
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "../";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire31f3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire31f3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fEubg", function(module, exports) {

var $5V43l = parcelRequire("5V43l");
"use strict";
function $b65200b57adbac66$var$sanitizeText(text) {
    // Marked parses any markdown content and solves the blank-space removal issue adding paragraphs.
    return (0, $5V43l.marked)($b65200b57adbac66$var$clearIndentation(text));
}
// Markdown parser recognize indentation as a pre-formatted text which breaks the email template
//  when using lists.
function $b65200b57adbac66$var$clearIndentation(text) {
    return text.replaceAll(/\t/g, "");
}
// CKEditor encode links. This breaks emails using dynamic link through Liquid variables.
// We decode braces so backend can read liquid syntax.
function $b65200b57adbac66$var$decodeLiquid(text) {
    return text.replaceAll(new RegExp("%7B%7B", "g"), "{{").replace(new RegExp("%7D%7D", "g"), "}}").replaceAll("&quot;", '"');
}
function $b65200b57adbac66$var$labelize(str) {
    return str.replaceAll("{{", "").replaceAll("}}", "").replaceAll("[", "").replaceAll("]", "").replaceAll(".", " ").replaceAll("_", " ").replaceAll("Payable Owner", "Payer's").split(" ").map((str)=>str[0].toUpperCase() + str.substring(1)).join(" ");
}
// ################################ //
const $b65200b57adbac66$var$CK_STYLESHEET_ID = "ck-editor-stylesheet";
const $b65200b57adbac66$var$CK_SCRIPT_ID = "ck-editor-script";
function $b65200b57adbac66$var$insertScript(src, onSuccess, onError, id) {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    if (id) script.id = id;
    script.onload = onSuccess;
    script.onerror = ()=>{
        script.remove();
        onError(src);
    };
    document.body.appendChild(script);
}
function $b65200b57adbac66$var$lazyLoadScripts() {
    const promise = document.getElementById($b65200b57adbac66$var$CK_SCRIPT_ID) ? Promise.resolve() : new Promise((resolve, reject)=>{
        if (!document.getElementById($b65200b57adbac66$var$CK_STYLESHEET_ID)) {
            const link = document.createElement("link");
            link.id = $b65200b57adbac66$var$CK_STYLESHEET_ID;
            link.rel = "stylesheet";
            link.href = "https://cdn.ckeditor.com/ckeditor5/44.3.0/ckeditor5.css";
            document.body.appendChild(link);
        }
        $b65200b57adbac66$var$insertScript("https://cdn.ckeditor.com/ckeditor5/44.3.0/ckeditor5.umd.js", ()=>{
            $b65200b57adbac66$var$insertScript("https://cdn.ckeditor.com/ckeditor5-premium-features/44.3.0/ckeditor5-premium-features.umd.js", resolve, (src)=>{
                reject(new Error(`Failed to load script: ${src}`));
            });
        }, (src)=>{
            reject(new Error(`Failed to load script: ${src}`));
        }, $b65200b57adbac66$var$CK_SCRIPT_ID);
    });
    return promise;
}
function $b65200b57adbac66$var$replace(app, licenseKey, hintEnv, elementId, value, autocompleteOptions, onChange) {
    const element = document.getElementById(elementId);
    const { ClassicEditor: ClassicEditor, Bold: Bold, Italic: Italic, Underline: Underline, Strikethrough: Strikethrough, RemoveFormat: RemoveFormat, Font: Font, Paragraph: Paragraph, Link: Link, List: List, Indent: Indent, Alignment: Alignment, Heading: Heading, BlockQuote: BlockQuote, GeneralHtmlSupport: GeneralHtmlSupport, FontSize: FontSize, Mention: Mention } = window.CKEDITOR;
    const { FormatPainter: FormatPainter } = window.CKEDITOR_PREMIUM_FEATURES;
    const hasPremiumFeatures = ()=>[
            "development",
            "production"
        ].includes(hintEnv);
    const plugins = [
        Bold,
        Italic,
        Font,
        Paragraph,
        Underline,
        Strikethrough,
        RemoveFormat,
        Link,
        List,
        Indent,
        Alignment,
        BlockQuote,
        Heading,
        FontSize,
        GeneralHtmlSupport,
        Mention,
        ...hasPremiumFeatures() ? [
            FormatPainter
        ] : []
    ];
    ClassicEditor.create(element, {
        licenseKey: licenseKey,
        plugins: plugins,
        mention: {
            feeds: [
                {
                    marker: "{{",
                    feed: (query)=>autocompleteOptions.map((option)=>({
                                id: option,
                                text: option,
                                name: $b65200b57adbac66$var$labelize(option)
                            })).filter((option)=>option.name.toLowerCase().includes(query.toLowerCase())),
                    itemRenderer: (option)=>{
                        const itemElement = document.createElement("span");
                        itemElement.textContent = option.name;
                        return itemElement;
                    },
                    minimumCharacters: 1
                }
            ]
        },
        toolbar: {
            items: [
                "bold",
                "italic",
                "underline",
                "strikethrough",
                "-",
                ...hasPremiumFeatures() ? [
                    "formatPainter"
                ] : [],
                "removeFormat",
                "|",
                "link",
                "|",
                "numberedList",
                "bulletedList",
                "|",
                "outdent",
                "indent",
                "|",
                "blockQuote",
                "|",
                "alignment",
                "-",
                "heading",
                "|",
                "fontSize",
                "fontFamily",
                "fontColor",
                "fontBackgroundColor"
            ],
            shouldNotGroupWhenFull: true
        },
        initialData: $b65200b57adbac66$var$sanitizeText(value)
    }).then((editor)=>{
        editor.model.document.on("change:data", ()=>{
            onChange($b65200b57adbac66$var$decodeLiquid(editor.getData()));
        });
        app.ports.ckEditorSetDataPort.subscribe(function(args) {
            const elementId = args[0];
            const value = args[1];
            if (editor.sourceElement.id != elementId) return;
            // Cross browser support
            const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
            requestAnimationFrame(function() {
                editor.setData($b65200b57adbac66$var$sanitizeText(value));
            });
        });
    });
}
const $b65200b57adbac66$var$CKEditorPort = {
    add: function(app, licenseKey, hintEnv) {
        app.ports.ckEditorReplacePort.subscribe((args)=>{
            const elementId = args[0];
            const value = args[1];
            const autocompleteOptions = args[2];
            // Cross browser support
            const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
            requestAnimationFrame(function() {
                $b65200b57adbac66$var$lazyLoadScripts().then(()=>{
                    $b65200b57adbac66$var$replace(app, licenseKey, hintEnv, elementId, value, autocompleteOptions, function(value) {
                        app.ports.ckEditorOnChangePort.send([
                            elementId,
                            value
                        ]);
                    });
                });
            });
        });
    }
};
module.exports = $b65200b57adbac66$var$CKEditorPort;

});
parcelRegister("5V43l", function(module, exports) {
/**
 * marked v17.0.5 - a markdown parser
 * Copyright (c) 2018-2026, MarkedJS. (MIT License)
 * Copyright (c) 2011-2018, Christopher Jeffrey. (MIT License)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(g, f) {
    module.exports = f();
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : module.exports, function() {
    var exports = {};
    var __exports = exports;
    var module1 = {
        exports: exports
    };
    "use strict";
    var G = Object.defineProperty;
    var Re = Object.getOwnPropertyDescriptor;
    var Te = Object.getOwnPropertyNames;
    var Oe = Object.prototype.hasOwnProperty;
    var we = (l, e)=>{
        for(var t in e)G(l, t, {
            get: e[t],
            enumerable: !0
        });
    }, ye = (l, e, t, n)=>{
        if (e && typeof e == "object" || typeof e == "function") for (let r of Te(e))!Oe.call(l, r) && r !== t && G(l, r, {
            get: ()=>e[r],
            enumerable: !(n = Re(e, r)) || n.enumerable
        });
        return l;
    };
    var Pe = (l)=>ye(G({}, "__esModule", {
            value: !0
        }), l);
    var xt = {};
    we(xt, {
        Hooks: ()=>P,
        Lexer: ()=>x,
        Marked: ()=>A,
        Parser: ()=>b,
        Renderer: ()=>y,
        TextRenderer: ()=>S,
        Tokenizer: ()=>w,
        defaults: ()=>R,
        getDefaults: ()=>_,
        lexer: ()=>mt,
        marked: ()=>g,
        options: ()=>pt,
        parse: ()=>gt,
        parseInline: ()=>dt,
        parser: ()=>ft,
        setOptions: ()=>ct,
        use: ()=>ht,
        walkTokens: ()=>kt
    });
    module1.exports = Pe(xt);
    function _() {
        return {
            async: !1,
            breaks: !1,
            extensions: null,
            gfm: !0,
            hooks: null,
            pedantic: !1,
            renderer: null,
            silent: !1,
            tokenizer: null,
            walkTokens: null
        };
    }
    var R = _();
    function N(l) {
        R = l;
    }
    var L = {
        exec: ()=>null
    };
    function k(l, e = "") {
        let t = typeof l == "string" ? l : l.source, n = {
            replace: (r, i)=>{
                let s = typeof i == "string" ? i : i.source;
                return s = s.replace(m.caret, "$1"), t = t.replace(r, s), n;
            },
            getRegex: ()=>new RegExp(t, e)
        };
        return n;
    }
    var Se = (()=>{
        try {
            return new RegExp("(?<=1)(?<!1)"), true;
        } catch  {
            return !1;
        }
    })(), m = {
        codeRemoveIndent: /^(?: {1,4}| {0,3}\t)/gm,
        outputLinkReplace: /\\([\[\]])/g,
        indentCodeCompensation: /^(\s+)(?:```)/,
        beginningSpace: /^\s+/,
        endingHash: /#$/,
        startingSpaceChar: /^ /,
        endingSpaceChar: / $/,
        nonSpaceChar: /[^ ]/,
        newLineCharGlobal: /\n/g,
        tabCharGlobal: /\t/g,
        multipleSpaceGlobal: /\s+/g,
        blankLine: /^[ \t]*$/,
        doubleBlankLine: /\n[ \t]*\n[ \t]*$/,
        blockquoteStart: /^ {0,3}>/,
        blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g,
        blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm,
        listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g,
        listIsTask: /^\[[ xX]\] +\S/,
        listReplaceTask: /^\[[ xX]\] +/,
        listTaskCheckbox: /\[[ xX]\]/,
        anyLine: /\n.*\n/,
        hrefBrackets: /^<(.*)>$/,
        tableDelimiter: /[:|]/,
        tableAlignChars: /^\||\| *$/g,
        tableRowBlankLine: /\n[ \t]*$/,
        tableAlignRight: /^ *-+: *$/,
        tableAlignCenter: /^ *:-+: *$/,
        tableAlignLeft: /^ *:-+ *$/,
        startATag: /^<a /i,
        endATag: /^<\/a>/i,
        startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i,
        endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i,
        startAngleBracket: /^</,
        endAngleBracket: />$/,
        pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/,
        unicodeAlphaNumeric: /[\p{L}\p{N}]/u,
        escapeTest: /[&<>"']/,
        escapeReplace: /[&<>"']/g,
        escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/,
        escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g,
        caret: /(^|[^\[])\^/g,
        percentDecode: /%25/g,
        findPipe: /\|/g,
        splitPipe: / \|/,
        slashPipe: /\\\|/g,
        carriageReturn: /\r\n|\r/g,
        spaceLine: /^ +$/gm,
        notSpaceStart: /^\S*/,
        endingNewline: /\n$/,
        listItemRegex: (l)=>new RegExp(`^( {0,3}${l})((?:[	 ][^\\n]*)?(?:\\n|$))`),
        nextBulletRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`),
        hrRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`),
        fencesBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}(?:\`\`\`|~~~)`),
        headingBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}#`),
        htmlBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}<(?:[a-z].*>|!--)`, "i"),
        blockquoteBeginRegex: (l)=>new RegExp(`^ {0,${Math.min(3, l - 1)}}>`)
    }, $e = /^(?:[ \t]*(?:\n|$))+/, _e = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, Le = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, B = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Me = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, j = / {0,3}(?:[*+-]|\d{1,9}[.)])/, ie = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, oe = k(ie).replace(/bull/g, j).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), ze = k(ie).replace(/bull/g, j).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), F = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Ee = /^[^\n]+/, U = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, Ie = k(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", U).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Ae = k(/^(bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, j).getRegex(), v = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", K = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Ce = k("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", K).replace("tag", v).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), ae = k(F).replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex(), Be = k(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", ae).getRegex(), W = {
        blockquote: Be,
        code: _e,
        def: Ie,
        fences: Le,
        heading: Me,
        hr: B,
        html: Ce,
        lheading: oe,
        list: Ae,
        newline: $e,
        paragraph: ae,
        table: L,
        text: Ee
    }, re = k("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex(), De = {
        ...W,
        lheading: ze,
        table: re,
        paragraph: k(F).replace("hr", B).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", re).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", v).getRegex()
    }, qe = {
        ...W,
        html: k(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", K).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: L,
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: k(F).replace("hr", B).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", oe).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
    }, ve = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, He = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, le = /^( {2,}|\\)\n(?!\s*$)/, Ze = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, z = /[\p{P}\p{S}]/u, H = /[\s\p{P}\p{S}]/u, X = /[^\s\p{P}\p{S}]/u, Ge = k(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, H).getRegex(), ue = /(?!~)[\p{P}\p{S}]/u, Ne = /(?!~)[\s\p{P}\p{S}]/u, Qe = /(?:[^\s\p{P}\p{S}]|~)/u, je = k(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", Se ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), pe = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, Fe = k(pe, "u").replace(/punct/g, z).getRegex(), Ue = k(pe, "u").replace(/punct/g, ue).getRegex(), ce = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", Ke = k(ce, "gu").replace(/notPunctSpace/g, X).replace(/punctSpace/g, H).replace(/punct/g, z).getRegex(), We = k(ce, "gu").replace(/notPunctSpace/g, Qe).replace(/punctSpace/g, Ne).replace(/punct/g, ue).getRegex(), Xe = k("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, X).replace(/punctSpace/g, H).replace(/punct/g, z).getRegex(), Je = k(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, z).getRegex(), Ve = "^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", Ye = k(Ve, "gu").replace(/notPunctSpace/g, X).replace(/punctSpace/g, H).replace(/punct/g, z).getRegex(), et = k(/\\(punct)/, "gu").replace(/punct/g, z).getRegex(), tt = k(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), nt = k(K).replace("(?:-->|$)", "-->").getRegex(), rt = k("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", nt).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), q = /(?:\[(?:\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/, st = k(/^!?\[(label)\]\(\s*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?\s*\)/).replace("label", q).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), he = k(/^!?\[(label)\]\[(ref)\]/).replace("label", q).replace("ref", U).getRegex(), ke = k(/^!?\[(ref)\](?:\[\])?/).replace("ref", U).getRegex(), it = k("reflink|nolink(?!\\()", "g").replace("reflink", he).replace("nolink", ke).getRegex(), se = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, J = {
        _backpedal: L,
        anyPunctuation: et,
        autolink: tt,
        blockSkip: je,
        br: le,
        code: He,
        del: L,
        delLDelim: L,
        delRDelim: L,
        emStrongLDelim: Fe,
        emStrongRDelimAst: Ke,
        emStrongRDelimUnd: Xe,
        escape: ve,
        link: st,
        nolink: ke,
        punctuation: Ge,
        reflink: he,
        reflinkSearch: it,
        tag: rt,
        text: Ze,
        url: L
    }, ot = {
        ...J,
        link: k(/^!?\[(label)\]\((.*?)\)/).replace("label", q).getRegex(),
        reflink: k(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", q).getRegex()
    }, Q = {
        ...J,
        emStrongRDelimAst: We,
        emStrongLDelim: Ue,
        delLDelim: Je,
        delRDelim: Ye,
        url: k(/^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("protocol", se).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/,
        text: k(/^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/).replace("protocol", se).getRegex()
    }, at = {
        ...Q,
        br: k(le).replace("{2,}", "*").getRegex(),
        text: k(Q.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
    }, D = {
        normal: W,
        gfm: De,
        pedantic: qe
    }, E = {
        normal: J,
        gfm: Q,
        breaks: at,
        pedantic: ot
    };
    var lt = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    }, de = (l)=>lt[l];
    function O(l, e) {
        if (e) {
            if (m.escapeTest.test(l)) return l.replace(m.escapeReplace, de);
        } else if (m.escapeTestNoEncode.test(l)) return l.replace(m.escapeReplaceNoEncode, de);
        return l;
    }
    function V(l) {
        try {
            l = encodeURI(l).replace(m.percentDecode, "%");
        } catch  {
            return null;
        }
        return l;
    }
    function Y(l, e) {
        let t = l.replace(m.findPipe, (i, s, a)=>{
            let o = !1, u = s;
            for(; --u >= 0 && a[u] === "\\";)o = !o;
            return o ? "|" : " |";
        }), n = t.split(m.splitPipe), r = 0;
        if (n[0].trim() || n.shift(), n.length > 0 && !n.at(-1)?.trim() && n.pop(), e) {
            if (n.length > e) n.splice(e);
            else for(; n.length < e;)n.push("");
        }
        for(; r < n.length; r++)n[r] = n[r].trim().replace(m.slashPipe, "|");
        return n;
    }
    function I(l, e, t) {
        let n = l.length;
        if (n === 0) return "";
        let r = 0;
        for(; r < n;){
            let i = l.charAt(n - r - 1);
            if (i === e && !t) r++;
            else if (i !== e && t) r++;
            else break;
        }
        return l.slice(0, n - r);
    }
    function ge(l, e) {
        if (l.indexOf(e[1]) === -1) return -1;
        let t = 0;
        for(let n = 0; n < l.length; n++)if (l[n] === "\\") n++;
        else if (l[n] === e[0]) t++;
        else if (l[n] === e[1] && (t--, t < 0)) return n;
        return t > 0 ? -2 : -1;
    }
    function fe(l, e = 0) {
        let t = e, n = "";
        for (let r of l)if (r === "	") {
            let i = 4 - t % 4;
            n += " ".repeat(i), t += i;
        } else n += r, t++;
        return n;
    }
    function me(l, e, t, n, r) {
        let i = e.href, s = e.title || null, a = l[1].replace(r.other.outputLinkReplace, "$1");
        n.state.inLink = !0;
        let o = {
            type: l[0].charAt(0) === "!" ? "image" : "link",
            raw: t,
            href: i,
            title: s,
            text: a,
            tokens: n.inlineTokens(a)
        };
        return n.state.inLink = !1, o;
    }
    function ut(l, e, t) {
        let n = l.match(t.other.indentCodeCompensation);
        if (n === null) return e;
        let r = n[1];
        return e.split(`
`).map((i)=>{
            let s = i.match(t.other.beginningSpace);
            if (s === null) return i;
            let [a] = s;
            return a.length >= r.length ? i.slice(r.length) : i;
        }).join(`
`);
    }
    var w = class {
        options;
        rules;
        lexer;
        constructor(e){
            this.options = e || R;
        }
        space(e) {
            let t = this.rules.block.newline.exec(e);
            if (t && t[0].length > 0) return {
                type: "space",
                raw: t[0]
            };
        }
        code(e) {
            let t = this.rules.block.code.exec(e);
            if (t) {
                let n = t[0].replace(this.rules.other.codeRemoveIndent, "");
                return {
                    type: "code",
                    raw: t[0],
                    codeBlockStyle: "indented",
                    text: this.options.pedantic ? n : I(n, `
`)
                };
            }
        }
        fences(e) {
            let t = this.rules.block.fences.exec(e);
            if (t) {
                let n = t[0], r = ut(n, t[3] || "", this.rules);
                return {
                    type: "code",
                    raw: n,
                    lang: t[2] ? t[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : t[2],
                    text: r
                };
            }
        }
        heading(e) {
            let t = this.rules.block.heading.exec(e);
            if (t) {
                let n = t[2].trim();
                if (this.rules.other.endingHash.test(n)) {
                    let r = I(n, "#");
                    (this.options.pedantic || !r || this.rules.other.endingSpaceChar.test(r)) && (n = r.trim());
                }
                return {
                    type: "heading",
                    raw: t[0],
                    depth: t[1].length,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        hr(e) {
            let t = this.rules.block.hr.exec(e);
            if (t) return {
                type: "hr",
                raw: I(t[0], `
`)
            };
        }
        blockquote(e) {
            let t = this.rules.block.blockquote.exec(e);
            if (t) {
                let n = I(t[0], `
`).split(`
`), r = "", i = "", s = [];
                for(; n.length > 0;){
                    let a = !1, o = [], u;
                    for(u = 0; u < n.length; u++)if (this.rules.other.blockquoteStart.test(n[u])) o.push(n[u]), a = !0;
                    else if (!a) o.push(n[u]);
                    else break;
                    n = n.slice(u);
                    let p = o.join(`
`), c = p.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
                    r = r ? `${r}
${p}` : p, i = i ? `${i}
${c}` : c;
                    let d = this.lexer.state.top;
                    if (this.lexer.state.top = !0, this.lexer.blockTokens(c, s, !0), this.lexer.state.top = d, n.length === 0) break;
                    let h = s.at(-1);
                    if (h?.type === "code") break;
                    if (h?.type === "blockquote") {
                        let T = h, f = T.raw + `
` + n.join(`
`), $ = this.blockquote(f);
                        s[s.length - 1] = $, r = r.substring(0, r.length - T.raw.length) + $.raw, i = i.substring(0, i.length - T.text.length) + $.text;
                        break;
                    } else if (h?.type === "list") {
                        let T = h, f = T.raw + `
` + n.join(`
`), $ = this.list(f);
                        s[s.length - 1] = $, r = r.substring(0, r.length - h.raw.length) + $.raw, i = i.substring(0, i.length - T.raw.length) + $.raw, n = f.substring(s.at(-1).raw.length).split(`
`);
                        continue;
                    }
                }
                return {
                    type: "blockquote",
                    raw: r,
                    tokens: s,
                    text: i
                };
            }
        }
        list(e) {
            let t = this.rules.block.list.exec(e);
            if (t) {
                let n = t[1].trim(), r = n.length > 1, i = {
                    type: "list",
                    raw: "",
                    ordered: r,
                    start: r ? +n.slice(0, -1) : "",
                    loose: !1,
                    items: []
                };
                n = r ? `\\d{1,9}\\${n.slice(-1)}` : `\\${n}`, this.options.pedantic && (n = r ? n : "[*+-]");
                let s = this.rules.other.listItemRegex(n), a = !1;
                for(; e;){
                    let u = !1, p = "", c = "";
                    if (!(t = s.exec(e)) || this.rules.block.hr.test(e)) break;
                    p = t[0], e = e.substring(p.length);
                    let d = fe(t[2].split(`
`, 1)[0], t[1].length), h = e.split(`
`, 1)[0], T = !d.trim(), f = 0;
                    if (this.options.pedantic ? (f = 2, c = d.trimStart()) : T ? f = t[1].length + 1 : (f = d.search(this.rules.other.nonSpaceChar), f = f > 4 ? 1 : f, c = d.slice(f), f += t[1].length), T && this.rules.other.blankLine.test(h) && (p += h + `
`, e = e.substring(h.length + 1), u = !0), !u) {
                        let $ = this.rules.other.nextBulletRegex(f), ee = this.rules.other.hrRegex(f), te = this.rules.other.fencesBeginRegex(f), ne = this.rules.other.headingBeginRegex(f), xe = this.rules.other.htmlBeginRegex(f), be = this.rules.other.blockquoteBeginRegex(f);
                        for(; e;){
                            let Z = e.split(`
`, 1)[0], C;
                            if (h = Z, this.options.pedantic ? (h = h.replace(this.rules.other.listReplaceNesting, "  "), C = h) : C = h.replace(this.rules.other.tabCharGlobal, "    "), te.test(h) || ne.test(h) || xe.test(h) || be.test(h) || $.test(h) || ee.test(h)) break;
                            if (C.search(this.rules.other.nonSpaceChar) >= f || !h.trim()) c += `
` + C.slice(f);
                            else {
                                if (T || d.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || te.test(d) || ne.test(d) || ee.test(d)) break;
                                c += `
` + h;
                            }
                            T = !h.trim(), p += Z + `
`, e = e.substring(Z.length + 1), d = C.slice(f);
                        }
                    }
                    i.loose || (a ? i.loose = !0 : this.rules.other.doubleBlankLine.test(p) && (a = !0)), i.items.push({
                        type: "list_item",
                        raw: p,
                        task: !!this.options.gfm && this.rules.other.listIsTask.test(c),
                        loose: !1,
                        text: c,
                        tokens: []
                    }), i.raw += p;
                }
                let o = i.items.at(-1);
                if (o) o.raw = o.raw.trimEnd(), o.text = o.text.trimEnd();
                else return;
                i.raw = i.raw.trimEnd();
                for (let u of i.items){
                    if (this.lexer.state.top = !1, u.tokens = this.lexer.blockTokens(u.text, []), u.task) {
                        if (u.text = u.text.replace(this.rules.other.listReplaceTask, ""), u.tokens[0]?.type === "text" || u.tokens[0]?.type === "paragraph") {
                            u.tokens[0].raw = u.tokens[0].raw.replace(this.rules.other.listReplaceTask, ""), u.tokens[0].text = u.tokens[0].text.replace(this.rules.other.listReplaceTask, "");
                            for(let c = this.lexer.inlineQueue.length - 1; c >= 0; c--)if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[c].src)) {
                                this.lexer.inlineQueue[c].src = this.lexer.inlineQueue[c].src.replace(this.rules.other.listReplaceTask, "");
                                break;
                            }
                        }
                        let p = this.rules.other.listTaskCheckbox.exec(u.raw);
                        if (p) {
                            let c = {
                                type: "checkbox",
                                raw: p[0] + " ",
                                checked: p[0] !== "[ ]"
                            };
                            u.checked = c.checked, i.loose ? u.tokens[0] && [
                                "paragraph",
                                "text"
                            ].includes(u.tokens[0].type) && "tokens" in u.tokens[0] && u.tokens[0].tokens ? (u.tokens[0].raw = c.raw + u.tokens[0].raw, u.tokens[0].text = c.raw + u.tokens[0].text, u.tokens[0].tokens.unshift(c)) : u.tokens.unshift({
                                type: "paragraph",
                                raw: c.raw,
                                text: c.raw,
                                tokens: [
                                    c
                                ]
                            }) : u.tokens.unshift(c);
                        }
                    }
                    if (!i.loose) {
                        let p = u.tokens.filter((d)=>d.type === "space"), c = p.length > 0 && p.some((d)=>this.rules.other.anyLine.test(d.raw));
                        i.loose = c;
                    }
                }
                if (i.loose) for (let u of i.items){
                    u.loose = !0;
                    for (let p of u.tokens)p.type === "text" && (p.type = "paragraph");
                }
                return i;
            }
        }
        html(e) {
            let t = this.rules.block.html.exec(e);
            if (t) return {
                type: "html",
                block: !0,
                raw: t[0],
                pre: t[1] === "pre" || t[1] === "script" || t[1] === "style",
                text: t[0]
            };
        }
        def(e) {
            let t = this.rules.block.def.exec(e);
            if (t) {
                let n = t[1].toLowerCase().replace(this.rules.other.multipleSpaceGlobal, " "), r = t[2] ? t[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = t[3] ? t[3].substring(1, t[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : t[3];
                return {
                    type: "def",
                    tag: n,
                    raw: t[0],
                    href: r,
                    title: i
                };
            }
        }
        table(e) {
            let t = this.rules.block.table.exec(e);
            if (!t || !this.rules.other.tableDelimiter.test(t[2])) return;
            let n = Y(t[1]), r = t[2].replace(this.rules.other.tableAlignChars, "").split("|"), i = t[3]?.trim() ? t[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], s = {
                type: "table",
                raw: t[0],
                header: [],
                align: [],
                rows: []
            };
            if (n.length === r.length) {
                for (let a of r)this.rules.other.tableAlignRight.test(a) ? s.align.push("right") : this.rules.other.tableAlignCenter.test(a) ? s.align.push("center") : this.rules.other.tableAlignLeft.test(a) ? s.align.push("left") : s.align.push(null);
                for(let a = 0; a < n.length; a++)s.header.push({
                    text: n[a],
                    tokens: this.lexer.inline(n[a]),
                    header: !0,
                    align: s.align[a]
                });
                for (let a of i)s.rows.push(Y(a, s.header.length).map((o, u)=>({
                        text: o,
                        tokens: this.lexer.inline(o),
                        header: !1,
                        align: s.align[u]
                    })));
                return s;
            }
        }
        lheading(e) {
            let t = this.rules.block.lheading.exec(e);
            if (t) {
                let n = t[1].trim();
                return {
                    type: "heading",
                    raw: t[0],
                    depth: t[2].charAt(0) === "=" ? 1 : 2,
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        paragraph(e) {
            let t = this.rules.block.paragraph.exec(e);
            if (t) {
                let n = t[1].charAt(t[1].length - 1) === `
` ? t[1].slice(0, -1) : t[1];
                return {
                    type: "paragraph",
                    raw: t[0],
                    text: n,
                    tokens: this.lexer.inline(n)
                };
            }
        }
        text(e) {
            let t = this.rules.block.text.exec(e);
            if (t) return {
                type: "text",
                raw: t[0],
                text: t[0],
                tokens: this.lexer.inline(t[0])
            };
        }
        escape(e) {
            let t = this.rules.inline.escape.exec(e);
            if (t) return {
                type: "escape",
                raw: t[0],
                text: t[1]
            };
        }
        tag(e) {
            let t = this.rules.inline.tag.exec(e);
            if (t) return !this.lexer.state.inLink && this.rules.other.startATag.test(t[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(t[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(t[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(t[0]) && (this.lexer.state.inRawBlock = !1), {
                type: "html",
                raw: t[0],
                inLink: this.lexer.state.inLink,
                inRawBlock: this.lexer.state.inRawBlock,
                block: !1,
                text: t[0]
            };
        }
        link(e) {
            let t = this.rules.inline.link.exec(e);
            if (t) {
                let n = t[2].trim();
                if (!this.options.pedantic && this.rules.other.startAngleBracket.test(n)) {
                    if (!this.rules.other.endAngleBracket.test(n)) return;
                    let s = I(n.slice(0, -1), "\\");
                    if ((n.length - s.length) % 2 === 0) return;
                } else {
                    let s = ge(t[2], "()");
                    if (s === -2) return;
                    if (s > -1) {
                        let o = (t[0].indexOf("!") === 0 ? 5 : 4) + t[1].length + s;
                        t[2] = t[2].substring(0, s), t[0] = t[0].substring(0, o).trim(), t[3] = "";
                    }
                }
                let r = t[2], i = "";
                if (this.options.pedantic) {
                    let s = this.rules.other.pedanticHrefTitle.exec(r);
                    s && (r = s[1], i = s[3]);
                } else i = t[3] ? t[3].slice(1, -1) : "";
                return r = r.trim(), this.rules.other.startAngleBracket.test(r) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(n) ? r = r.slice(1) : r = r.slice(1, -1)), me(t, {
                    href: r && r.replace(this.rules.inline.anyPunctuation, "$1"),
                    title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
                }, t[0], this.lexer, this.rules);
            }
        }
        reflink(e, t) {
            let n;
            if ((n = this.rules.inline.reflink.exec(e)) || (n = this.rules.inline.nolink.exec(e))) {
                let r = (n[2] || n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = t[r.toLowerCase()];
                if (!i) {
                    let s = n[0].charAt(0);
                    return {
                        type: "text",
                        raw: s,
                        text: s
                    };
                }
                return me(n, i, n[0], this.lexer, this.rules);
            }
        }
        emStrong(e, t, n = "") {
            let r = this.rules.inline.emStrongLDelim.exec(e);
            if (!r || !r[1] && !r[2] && !r[3] && !r[4] || r[4] && n.match(this.rules.other.unicodeAlphaNumeric)) return;
            if (!(r[1] || r[3] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let s = [
                    ...r[0]
                ].length - 1, a, o, u = s, p = 0, c = r[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
                for(c.lastIndex = 0, t = t.slice(-1 * e.length + s); (r = c.exec(t)) != null;){
                    if (a = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !a) continue;
                    if (o = [
                        ...a
                    ].length, r[3] || r[4]) {
                        u += o;
                        continue;
                    } else if ((r[5] || r[6]) && s % 3 && !((s + o) % 3)) {
                        p += o;
                        continue;
                    }
                    if (u -= o, u > 0) continue;
                    o = Math.min(o, o + u + p);
                    let d = [
                        ...r[0]
                    ][0].length, h = e.slice(0, s + r.index + d + o);
                    if (Math.min(s, o) % 2) {
                        let f = h.slice(1, -1);
                        return {
                            type: "em",
                            raw: h,
                            text: f,
                            tokens: this.lexer.inlineTokens(f)
                        };
                    }
                    let T = h.slice(2, -2);
                    return {
                        type: "strong",
                        raw: h,
                        text: T,
                        tokens: this.lexer.inlineTokens(T)
                    };
                }
            }
        }
        codespan(e) {
            let t = this.rules.inline.code.exec(e);
            if (t) {
                let n = t[2].replace(this.rules.other.newLineCharGlobal, " "), r = this.rules.other.nonSpaceChar.test(n), i = this.rules.other.startingSpaceChar.test(n) && this.rules.other.endingSpaceChar.test(n);
                return r && i && (n = n.substring(1, n.length - 1)), {
                    type: "codespan",
                    raw: t[0],
                    text: n
                };
            }
        }
        br(e) {
            let t = this.rules.inline.br.exec(e);
            if (t) return {
                type: "br",
                raw: t[0]
            };
        }
        del(e, t, n = "") {
            let r = this.rules.inline.delLDelim.exec(e);
            if (!r) return;
            if (!(r[1] || "") || !n || this.rules.inline.punctuation.exec(n)) {
                let s = [
                    ...r[0]
                ].length - 1, a, o, u = s, p = this.rules.inline.delRDelim;
                for(p.lastIndex = 0, t = t.slice(-1 * e.length + s); (r = p.exec(t)) != null;){
                    if (a = r[1] || r[2] || r[3] || r[4] || r[5] || r[6], !a || (o = [
                        ...a
                    ].length, o !== s)) continue;
                    if (r[3] || r[4]) {
                        u += o;
                        continue;
                    }
                    if (u -= o, u > 0) continue;
                    o = Math.min(o, o + u);
                    let c = [
                        ...r[0]
                    ][0].length, d = e.slice(0, s + r.index + c + o), h = d.slice(s, -s);
                    return {
                        type: "del",
                        raw: d,
                        text: h,
                        tokens: this.lexer.inlineTokens(h)
                    };
                }
            }
        }
        autolink(e) {
            let t = this.rules.inline.autolink.exec(e);
            if (t) {
                let n, r;
                return t[2] === "@" ? (n = t[1], r = "mailto:" + n) : (n = t[1], r = n), {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: r,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        url(e) {
            let t;
            if (t = this.rules.inline.url.exec(e)) {
                let n, r;
                if (t[2] === "@") n = t[0], r = "mailto:" + n;
                else {
                    let i;
                    do i = t[0], t[0] = this.rules.inline._backpedal.exec(t[0])?.[0] ?? "";
                    while (i !== t[0]);
                    n = t[0], t[1] === "www." ? r = "http://" + t[0] : r = t[0];
                }
                return {
                    type: "link",
                    raw: t[0],
                    text: n,
                    href: r,
                    tokens: [
                        {
                            type: "text",
                            raw: n,
                            text: n
                        }
                    ]
                };
            }
        }
        inlineText(e) {
            let t = this.rules.inline.text.exec(e);
            if (t) {
                let n = this.lexer.state.inRawBlock;
                return {
                    type: "text",
                    raw: t[0],
                    text: t[0],
                    escaped: n
                };
            }
        }
    };
    var x = class l {
        tokens;
        options;
        state;
        inlineQueue;
        tokenizer;
        constructor(e){
            this.tokens = [], this.tokens.links = Object.create(null), this.options = e || R, this.options.tokenizer = this.options.tokenizer || new w, this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
                inLink: !1,
                inRawBlock: !1,
                top: !0
            };
            let t = {
                other: m,
                block: D.normal,
                inline: E.normal
            };
            this.options.pedantic ? (t.block = D.pedantic, t.inline = E.pedantic) : this.options.gfm && (t.block = D.gfm, this.options.breaks ? t.inline = E.breaks : t.inline = E.gfm), this.tokenizer.rules = t;
        }
        static get rules() {
            return {
                block: D,
                inline: E
            };
        }
        static lex(e, t) {
            return new l(t).lex(e);
        }
        static lexInline(e, t) {
            return new l(t).inlineTokens(e);
        }
        lex(e) {
            e = e.replace(m.carriageReturn, `
`), this.blockTokens(e, this.tokens);
            for(let t = 0; t < this.inlineQueue.length; t++){
                let n = this.inlineQueue[t];
                this.inlineTokens(n.src, n.tokens);
            }
            return this.inlineQueue = [], this.tokens;
        }
        blockTokens(e, t = [], n = !1) {
            for(this.tokenizer.lexer = this, this.options.pedantic && (e = e.replace(m.tabCharGlobal, "    ").replace(m.spaceLine, "")); e;){
                let r;
                if (this.options.extensions?.block?.some((s)=>(r = s.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(r.raw.length), t.push(r), !0) : !1)) continue;
                if (r = this.tokenizer.space(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    r.raw.length === 1 && s !== void 0 ? s.raw += `
` : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.code(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.at(-1).src = s.text) : t.push(r);
                    continue;
                }
                if (r = this.tokenizer.fences(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.heading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.hr(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.blockquote(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.list(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.html(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.def(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "paragraph" || s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.raw, this.inlineQueue.at(-1).src = s.text) : this.tokens.links[r.tag] || (this.tokens.links[r.tag] = {
                        href: r.href,
                        title: r.title
                    }, t.push(r));
                    continue;
                }
                if (r = this.tokenizer.table(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                if (r = this.tokenizer.lheading(e)) {
                    e = e.substring(r.raw.length), t.push(r);
                    continue;
                }
                let i = e;
                if (this.options.extensions?.startBlock) {
                    let s = 1 / 0, a = e.slice(1), o;
                    this.options.extensions.startBlock.forEach((u)=>{
                        o = u.call({
                            lexer: this
                        }, a), typeof o == "number" && o >= 0 && (s = Math.min(s, o));
                    }), s < 1 / 0 && s >= 0 && (i = e.substring(0, s + 1));
                }
                if (this.state.top && (r = this.tokenizer.paragraph(i))) {
                    let s = t.at(-1);
                    n && s?.type === "paragraph" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r), n = i.length !== e.length, e = e.substring(r.raw.length);
                    continue;
                }
                if (r = this.tokenizer.text(e)) {
                    e = e.substring(r.raw.length);
                    let s = t.at(-1);
                    s?.type === "text" ? (s.raw += (s.raw.endsWith(`
`) ? "" : `
`) + r.raw, s.text += `
` + r.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = s.text) : t.push(r);
                    continue;
                }
                if (e) {
                    let s = "Infinite loop on byte: " + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(s);
                        break;
                    } else throw new Error(s);
                }
            }
            return this.state.top = !0, t;
        }
        inline(e, t = []) {
            return this.inlineQueue.push({
                src: e,
                tokens: t
            }), t;
        }
        inlineTokens(e, t = []) {
            this.tokenizer.lexer = this;
            let n = e, r = null;
            if (this.tokens.links) {
                let o = Object.keys(this.tokens.links);
                if (o.length > 0) for(; (r = this.tokenizer.rules.inline.reflinkSearch.exec(n)) != null;)o.includes(r[0].slice(r[0].lastIndexOf("[") + 1, -1)) && (n = n.slice(0, r.index) + "[" + "a".repeat(r[0].length - 2) + "]" + n.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
            }
            for(; (r = this.tokenizer.rules.inline.anyPunctuation.exec(n)) != null;)n = n.slice(0, r.index) + "++" + n.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
            let i;
            for(; (r = this.tokenizer.rules.inline.blockSkip.exec(n)) != null;)i = r[2] ? r[2].length : 0, n = n.slice(0, r.index + i) + "[" + "a".repeat(r[0].length - i - 2) + "]" + n.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            n = this.options.hooks?.emStrongMask?.call({
                lexer: this
            }, n) ?? n;
            let s = !1, a = "";
            for(; e;){
                s || (a = ""), s = !1;
                let o;
                if (this.options.extensions?.inline?.some((p)=>(o = p.call({
                        lexer: this
                    }, e, t)) ? (e = e.substring(o.raw.length), t.push(o), !0) : !1)) continue;
                if (o = this.tokenizer.escape(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.tag(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.link(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.reflink(e, this.tokens.links)) {
                    e = e.substring(o.raw.length);
                    let p = t.at(-1);
                    o.type === "text" && p?.type === "text" ? (p.raw += o.raw, p.text += o.text) : t.push(o);
                    continue;
                }
                if (o = this.tokenizer.emStrong(e, n, a)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.codespan(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.br(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.del(e, n, a)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (o = this.tokenizer.autolink(e)) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                if (!this.state.inLink && (o = this.tokenizer.url(e))) {
                    e = e.substring(o.raw.length), t.push(o);
                    continue;
                }
                let u = e;
                if (this.options.extensions?.startInline) {
                    let p = 1 / 0, c = e.slice(1), d;
                    this.options.extensions.startInline.forEach((h)=>{
                        d = h.call({
                            lexer: this
                        }, c), typeof d == "number" && d >= 0 && (p = Math.min(p, d));
                    }), p < 1 / 0 && p >= 0 && (u = e.substring(0, p + 1));
                }
                if (o = this.tokenizer.inlineText(u)) {
                    e = e.substring(o.raw.length), o.raw.slice(-1) !== "_" && (a = o.raw.slice(-1)), s = !0;
                    let p = t.at(-1);
                    p?.type === "text" ? (p.raw += o.raw, p.text += o.text) : t.push(o);
                    continue;
                }
                if (e) {
                    let p = "Infinite loop on byte: " + e.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(p);
                        break;
                    } else throw new Error(p);
                }
            }
            return t;
        }
    };
    var y = class {
        options;
        parser;
        constructor(e){
            this.options = e || R;
        }
        space(e) {
            return "";
        }
        code({ text: e, lang: t, escaped: n }) {
            let r = (t || "").match(m.notSpaceStart)?.[0], i = e.replace(m.endingNewline, "") + `
`;
            return r ? '<pre><code class="language-' + O(r) + '">' + (n ? i : O(i, !0)) + `</code></pre>
` : "<pre><code>" + (n ? i : O(i, !0)) + `</code></pre>
`;
        }
        blockquote({ tokens: e }) {
            return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
        }
        html({ text: e }) {
            return e;
        }
        def(e) {
            return "";
        }
        heading({ tokens: e, depth: t }) {
            return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
        }
        hr(e) {
            return `<hr>
`;
        }
        list(e) {
            let t = e.ordered, n = e.start, r = "";
            for(let a = 0; a < e.items.length; a++){
                let o = e.items[a];
                r += this.listitem(o);
            }
            let i = t ? "ol" : "ul", s = t && n !== 1 ? ' start="' + n + '"' : "";
            return "<" + i + s + `>
` + r + "</" + i + `>
`;
        }
        listitem(e) {
            return `<li>${this.parser.parse(e.tokens)}</li>
`;
        }
        checkbox({ checked: e }) {
            return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"> ';
        }
        paragraph({ tokens: e }) {
            return `<p>${this.parser.parseInline(e)}</p>
`;
        }
        table(e) {
            let t = "", n = "";
            for(let i = 0; i < e.header.length; i++)n += this.tablecell(e.header[i]);
            t += this.tablerow({
                text: n
            });
            let r = "";
            for(let i = 0; i < e.rows.length; i++){
                let s = e.rows[i];
                n = "";
                for(let a = 0; a < s.length; a++)n += this.tablecell(s[a]);
                r += this.tablerow({
                    text: n
                });
            }
            return r && (r = `<tbody>${r}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + r + `</table>
`;
        }
        tablerow({ text: e }) {
            return `<tr>
${e}</tr>
`;
        }
        tablecell(e) {
            let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
            return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
        }
        strong({ tokens: e }) {
            return `<strong>${this.parser.parseInline(e)}</strong>`;
        }
        em({ tokens: e }) {
            return `<em>${this.parser.parseInline(e)}</em>`;
        }
        codespan({ text: e }) {
            return `<code>${O(e, !0)}</code>`;
        }
        br(e) {
            return "<br>";
        }
        del({ tokens: e }) {
            return `<del>${this.parser.parseInline(e)}</del>`;
        }
        link({ href: e, title: t, tokens: n }) {
            let r = this.parser.parseInline(n), i = V(e);
            if (i === null) return r;
            e = i;
            let s = '<a href="' + e + '"';
            return t && (s += ' title="' + O(t) + '"'), s += ">" + r + "</a>", s;
        }
        image({ href: e, title: t, text: n, tokens: r }) {
            r && (n = this.parser.parseInline(r, this.parser.textRenderer));
            let i = V(e);
            if (i === null) return O(n);
            e = i;
            let s = `<img src="${e}" alt="${O(n)}"`;
            return t && (s += ` title="${O(t)}"`), s += ">", s;
        }
        text(e) {
            return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : O(e.text);
        }
    };
    var S = class {
        strong({ text: e }) {
            return e;
        }
        em({ text: e }) {
            return e;
        }
        codespan({ text: e }) {
            return e;
        }
        del({ text: e }) {
            return e;
        }
        html({ text: e }) {
            return e;
        }
        text({ text: e }) {
            return e;
        }
        link({ text: e }) {
            return "" + e;
        }
        image({ text: e }) {
            return "" + e;
        }
        br() {
            return "";
        }
        checkbox({ raw: e }) {
            return e;
        }
    };
    var b = class l {
        options;
        renderer;
        textRenderer;
        constructor(e){
            this.options = e || R, this.options.renderer = this.options.renderer || new y, this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new S;
        }
        static parse(e, t) {
            return new l(t).parse(e);
        }
        static parseInline(e, t) {
            return new l(t).parseInline(e);
        }
        parse(e) {
            this.renderer.parser = this;
            let t = "";
            for(let n = 0; n < e.length; n++){
                let r = e[n];
                if (this.options.extensions?.renderers?.[r.type]) {
                    let s = r, a = this.options.extensions.renderers[s.type].call({
                        parser: this
                    }, s);
                    if (a !== !1 || ![
                        "space",
                        "hr",
                        "heading",
                        "code",
                        "table",
                        "blockquote",
                        "list",
                        "html",
                        "def",
                        "paragraph",
                        "text"
                    ].includes(s.type)) {
                        t += a || "";
                        continue;
                    }
                }
                let i = r;
                switch(i.type){
                    case "space":
                        t += this.renderer.space(i);
                        break;
                    case "hr":
                        t += this.renderer.hr(i);
                        break;
                    case "heading":
                        t += this.renderer.heading(i);
                        break;
                    case "code":
                        t += this.renderer.code(i);
                        break;
                    case "table":
                        t += this.renderer.table(i);
                        break;
                    case "blockquote":
                        t += this.renderer.blockquote(i);
                        break;
                    case "list":
                        t += this.renderer.list(i);
                        break;
                    case "checkbox":
                        t += this.renderer.checkbox(i);
                        break;
                    case "html":
                        t += this.renderer.html(i);
                        break;
                    case "def":
                        t += this.renderer.def(i);
                        break;
                    case "paragraph":
                        t += this.renderer.paragraph(i);
                        break;
                    case "text":
                        t += this.renderer.text(i);
                        break;
                    default:
                        {
                            let s = 'Token with "' + i.type + '" type was not found.';
                            if (this.options.silent) return console.error(s), "";
                            throw new Error(s);
                        }
                }
            }
            return t;
        }
        parseInline(e, t = this.renderer) {
            this.renderer.parser = this;
            let n = "";
            for(let r = 0; r < e.length; r++){
                let i = e[r];
                if (this.options.extensions?.renderers?.[i.type]) {
                    let a = this.options.extensions.renderers[i.type].call({
                        parser: this
                    }, i);
                    if (a !== !1 || ![
                        "escape",
                        "html",
                        "link",
                        "image",
                        "strong",
                        "em",
                        "codespan",
                        "br",
                        "del",
                        "text"
                    ].includes(i.type)) {
                        n += a || "";
                        continue;
                    }
                }
                let s = i;
                switch(s.type){
                    case "escape":
                        n += t.text(s);
                        break;
                    case "html":
                        n += t.html(s);
                        break;
                    case "link":
                        n += t.link(s);
                        break;
                    case "image":
                        n += t.image(s);
                        break;
                    case "checkbox":
                        n += t.checkbox(s);
                        break;
                    case "strong":
                        n += t.strong(s);
                        break;
                    case "em":
                        n += t.em(s);
                        break;
                    case "codespan":
                        n += t.codespan(s);
                        break;
                    case "br":
                        n += t.br(s);
                        break;
                    case "del":
                        n += t.del(s);
                        break;
                    case "text":
                        n += t.text(s);
                        break;
                    default:
                        {
                            let a = 'Token with "' + s.type + '" type was not found.';
                            if (this.options.silent) return console.error(a), "";
                            throw new Error(a);
                        }
                }
            }
            return n;
        }
    };
    var P = class {
        options;
        block;
        constructor(e){
            this.options = e || R;
        }
        static passThroughHooks = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens",
            "emStrongMask"
        ]);
        static passThroughHooksRespectAsync = new Set([
            "preprocess",
            "postprocess",
            "processAllTokens"
        ]);
        preprocess(e) {
            return e;
        }
        postprocess(e) {
            return e;
        }
        processAllTokens(e) {
            return e;
        }
        emStrongMask(e) {
            return e;
        }
        provideLexer() {
            return this.block ? x.lex : x.lexInline;
        }
        provideParser() {
            return this.block ? b.parse : b.parseInline;
        }
    };
    var A = class {
        defaults = _();
        options = this.setOptions;
        parse = this.parseMarkdown(!0);
        parseInline = this.parseMarkdown(!1);
        Parser = b;
        Renderer = y;
        TextRenderer = S;
        Lexer = x;
        Tokenizer = w;
        Hooks = P;
        constructor(...e){
            this.use(...e);
        }
        walkTokens(e, t) {
            let n = [];
            for (let r of e)switch(n = n.concat(t.call(this, r)), r.type){
                case "table":
                    {
                        let i = r;
                        for (let s of i.header)n = n.concat(this.walkTokens(s.tokens, t));
                        for (let s of i.rows)for (let a of s)n = n.concat(this.walkTokens(a.tokens, t));
                        break;
                    }
                case "list":
                    {
                        let i = r;
                        n = n.concat(this.walkTokens(i.items, t));
                        break;
                    }
                default:
                    {
                        let i = r;
                        this.defaults.extensions?.childTokens?.[i.type] ? this.defaults.extensions.childTokens[i.type].forEach((s)=>{
                            let a = i[s].flat(1 / 0);
                            n = n.concat(this.walkTokens(a, t));
                        }) : i.tokens && (n = n.concat(this.walkTokens(i.tokens, t)));
                    }
            }
            return n;
        }
        use(...e) {
            let t = this.defaults.extensions || {
                renderers: {},
                childTokens: {}
            };
            return e.forEach((n)=>{
                let r = {
                    ...n
                };
                if (r.async = this.defaults.async || r.async || !1, n.extensions && (n.extensions.forEach((i)=>{
                    if (!i.name) throw new Error("extension name required");
                    if ("renderer" in i) {
                        let s = t.renderers[i.name];
                        s ? t.renderers[i.name] = function(...a) {
                            let o = i.renderer.apply(this, a);
                            return o === !1 && (o = s.apply(this, a)), o;
                        } : t.renderers[i.name] = i.renderer;
                    }
                    if ("tokenizer" in i) {
                        if (!i.level || i.level !== "block" && i.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
                        let s = t[i.level];
                        s ? s.unshift(i.tokenizer) : t[i.level] = [
                            i.tokenizer
                        ], i.start && (i.level === "block" ? t.startBlock ? t.startBlock.push(i.start) : t.startBlock = [
                            i.start
                        ] : i.level === "inline" && (t.startInline ? t.startInline.push(i.start) : t.startInline = [
                            i.start
                        ]));
                    }
                    "childTokens" in i && i.childTokens && (t.childTokens[i.name] = i.childTokens);
                }), r.extensions = t), n.renderer) {
                    let i = this.defaults.renderer || new y(this.defaults);
                    for(let s in n.renderer){
                        if (!(s in i)) throw new Error(`renderer '${s}' does not exist`);
                        if ([
                            "options",
                            "parser"
                        ].includes(s)) continue;
                        let a = s, o = n.renderer[a], u = i[a];
                        i[a] = (...p)=>{
                            let c = o.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c || "";
                        };
                    }
                    r.renderer = i;
                }
                if (n.tokenizer) {
                    let i = this.defaults.tokenizer || new w(this.defaults);
                    for(let s in n.tokenizer){
                        if (!(s in i)) throw new Error(`tokenizer '${s}' does not exist`);
                        if ([
                            "options",
                            "rules",
                            "lexer"
                        ].includes(s)) continue;
                        let a = s, o = n.tokenizer[a], u = i[a];
                        i[a] = (...p)=>{
                            let c = o.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c;
                        };
                    }
                    r.tokenizer = i;
                }
                if (n.hooks) {
                    let i = this.defaults.hooks || new P;
                    for(let s in n.hooks){
                        if (!(s in i)) throw new Error(`hook '${s}' does not exist`);
                        if ([
                            "options",
                            "block"
                        ].includes(s)) continue;
                        let a = s, o = n.hooks[a], u = i[a];
                        P.passThroughHooks.has(s) ? i[a] = (p)=>{
                            if (this.defaults.async && P.passThroughHooksRespectAsync.has(s)) return (async ()=>{
                                let d = await o.call(i, p);
                                return u.call(i, d);
                            })();
                            let c = o.call(i, p);
                            return u.call(i, c);
                        } : i[a] = (...p)=>{
                            if (this.defaults.async) return (async ()=>{
                                let d = await o.apply(i, p);
                                return d === !1 && (d = await u.apply(i, p)), d;
                            })();
                            let c = o.apply(i, p);
                            return c === !1 && (c = u.apply(i, p)), c;
                        };
                    }
                    r.hooks = i;
                }
                if (n.walkTokens) {
                    let i = this.defaults.walkTokens, s = n.walkTokens;
                    r.walkTokens = function(a) {
                        let o = [];
                        return o.push(s.call(this, a)), i && (o = o.concat(i.call(this, a))), o;
                    };
                }
                this.defaults = {
                    ...this.defaults,
                    ...r
                };
            }), this;
        }
        setOptions(e) {
            return this.defaults = {
                ...this.defaults,
                ...e
            }, this;
        }
        lexer(e, t) {
            return x.lex(e, t ?? this.defaults);
        }
        parser(e, t) {
            return b.parse(e, t ?? this.defaults);
        }
        parseMarkdown(e) {
            return (n, r)=>{
                let i = {
                    ...r
                }, s = {
                    ...this.defaults,
                    ...i
                }, a = this.onError(!!s.silent, !!s.async);
                if (this.defaults.async === !0 && i.async === !1) return a(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
                if (typeof n > "u" || n === null) return a(new Error("marked(): input parameter is undefined or null"));
                if (typeof n != "string") return a(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
                if (s.hooks && (s.hooks.options = s, s.hooks.block = e), s.async) return (async ()=>{
                    let o = s.hooks ? await s.hooks.preprocess(n) : n, p = await (s.hooks ? await s.hooks.provideLexer() : e ? x.lex : x.lexInline)(o, s), c = s.hooks ? await s.hooks.processAllTokens(p) : p;
                    s.walkTokens && await Promise.all(this.walkTokens(c, s.walkTokens));
                    let h = await (s.hooks ? await s.hooks.provideParser() : e ? b.parse : b.parseInline)(c, s);
                    return s.hooks ? await s.hooks.postprocess(h) : h;
                })().catch(a);
                try {
                    s.hooks && (n = s.hooks.preprocess(n));
                    let u = (s.hooks ? s.hooks.provideLexer() : e ? x.lex : x.lexInline)(n, s);
                    s.hooks && (u = s.hooks.processAllTokens(u)), s.walkTokens && this.walkTokens(u, s.walkTokens);
                    let c = (s.hooks ? s.hooks.provideParser() : e ? b.parse : b.parseInline)(u, s);
                    return s.hooks && (c = s.hooks.postprocess(c)), c;
                } catch (o) {
                    return a(o);
                }
            };
        }
        onError(e, t) {
            return (n)=>{
                if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
                    let r = "<p>An error occurred:</p><pre>" + O(n.message + "", !0) + "</pre>";
                    return t ? Promise.resolve(r) : r;
                }
                if (t) return Promise.reject(n);
                throw n;
            };
        }
    };
    var M = new A;
    function g(l, e) {
        return M.parse(l, e);
    }
    g.options = g.setOptions = function(l) {
        return M.setOptions(l), g.defaults = M.defaults, N(g.defaults), g;
    };
    g.getDefaults = _;
    g.defaults = R;
    g.use = function(...l) {
        return M.use(...l), g.defaults = M.defaults, N(g.defaults), g;
    };
    g.walkTokens = function(l, e) {
        return M.walkTokens(l, e);
    };
    g.parseInline = M.parseInline;
    g.Parser = b;
    g.parser = b.parse;
    g.Renderer = y;
    g.TextRenderer = S;
    g.Lexer = x;
    g.lexer = x.lex;
    g.Tokenizer = w;
    g.Hooks = P;
    g.parse = g;
    var pt = g.options, ct = g.setOptions, ht = g.use, kt = g.walkTokens, dt = g.parseInline, gt = g, ft = b.parse, mt = x.lex;
    if (__exports != exports) module1.exports = exports;
    return module1.exports;
});

});


parcelRegister("le31q", function(module, exports) {
"use strict";
const $f73d3fdff580da31$var$ClinicalPort = {
    add: function(app) {
        // Track if core-ready has been dispatched
        if (typeof window.__coreReadyDispatched === "undefined") window.__coreReadyDispatched = false;
        if (app.ports.dispatchLoadClinicalPort) app.ports.dispatchLoadClinicalPort.subscribe(async ()=>{
            // Prevent dispatching core-ready multiple times
            if (window.__coreReadyDispatched) return;
            window.__coreReadyDispatched = true;
            try {
                // Load EMR assets and wait for completion
                if (window.loadEMRAssets && typeof window.loadEMRAssets === "function") await window.loadEMRAssets();
                window.dispatchEvent(new CustomEvent("core-ready"));
            } catch (error) {
                // Reset flag on error to allow retry
                window.__coreReadyDispatched = false;
                throw error;
            }
        });
    }
};
module.exports = $f73d3fdff580da31$var$ClinicalPort;

});

parcelRegister("jCHdb", function(module, exports) {
"use strict";

var $9No4X = parcelRequire("9No4X");
var $e49315dfffe880aa$require$Chart = $9No4X.Chart;
var $e49315dfffe880aa$require$BarController = $9No4X.BarController;
var $e49315dfffe880aa$require$BarElement = $9No4X.BarElement;
var $e49315dfffe880aa$require$CategoryScale = $9No4X.CategoryScale;
var $e49315dfffe880aa$require$LineController = $9No4X.LineController;
var $e49315dfffe880aa$require$LineElement = $9No4X.LineElement;
var $e49315dfffe880aa$require$PointElement = $9No4X.PointElement;
var $e49315dfffe880aa$require$LinearScale = $9No4X.LinearScale;
var $e49315dfffe880aa$require$Filler = $9No4X.Filler;
var $e49315dfffe880aa$require$Tooltip = $9No4X.Tooltip;

var $bYaDZ = parcelRequire("bYaDZ");
var $e49315dfffe880aa$require$ColorHash = $bYaDZ.default;

var $eIMS8 = parcelRequire("eIMS8");
var $e49315dfffe880aa$require$loadChartjsPluginEmptyOverlay = $eIMS8.loadChartjsPluginEmptyOverlay;
$e49315dfffe880aa$require$Chart.register($e49315dfffe880aa$require$BarController, $e49315dfffe880aa$require$BarElement, $e49315dfffe880aa$require$CategoryScale, $e49315dfffe880aa$require$LineController, $e49315dfffe880aa$require$LineElement, $e49315dfffe880aa$require$PointElement, $e49315dfffe880aa$require$LinearScale, $e49315dfffe880aa$require$Filler, $e49315dfffe880aa$require$Tooltip);
const $e49315dfffe880aa$var$DashboardChartPort = {
    add: function(app) {
        $e49315dfffe880aa$require$loadChartjsPluginEmptyOverlay($e49315dfffe880aa$require$Chart);
        app.ports.mountDashboardChart.subscribe(({ options: options, labels: labels, datasets: datasets })=>{
            // Cross browser support
            const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
            requestAnimationFrame(function() {
                const parent = document.getElementById("dashboard-chart");
                if (!parent) return;
                parent.innerHTML = "";
                const ctx = document.createElement("canvas");
                parent.appendChild(ctx);
                new $e49315dfffe880aa$require$Chart(ctx, {
                    type: "bar",
                    options: $e49315dfffe880aa$var$formatOptions(options, datasets),
                    data: {
                        labels: labels,
                        datasets: $e49315dfffe880aa$var$formatDatasets(datasets)
                    }
                });
            });
        });
    }
};
const $e49315dfffe880aa$var$formatOptions = (options, datasets)=>{
    if (options.scales) $e49315dfffe880aa$var$formatScales(options.scales);
    options.plugins = options.plugins || {};
    options.plugins.tooltip = $e49315dfffe880aa$var$formatTooltip(options, datasets);
    options.maintainAspectRatio = false;
    return options;
};
const $e49315dfffe880aa$var$formatTooltip = (options, datasets)=>{
    const tooltip = options.plugins && options.plugins.tooltip || {};
    tooltip.callbacks = {};
    tooltip.callbacks.label = (item)=>{
        const dataset = datasets[item.datasetIndex];
        const defaultLabel = ` ${dataset.label} - ${item.formattedValue}`;
        if (dataset.suffix) return defaultLabel + dataset.suffix;
        return defaultLabel;
    };
    return tooltip;
};
const $e49315dfffe880aa$var$formatScales = (scales)=>{
    Object.values(scales).forEach((scale)=>{
        if (scale.axis == "y" && scale.ticks && scale.ticks.suffix) {
            const suffix = scale.ticks.suffix;
            delete scale.ticks.suffix;
            scale.ticks.callback = (value)=>value + suffix;
        }
    });
};
const $e49315dfffe880aa$var$formatDatasets = (datasets)=>{
    return datasets.map((dataset)=>{
        if (dataset.backgroundColor) return dataset;
        const color = $e49315dfffe880aa$var$colorByLabel(dataset.label);
        dataset.backgroundColor = color;
        dataset.borderColor = color;
        return dataset;
    });
};
const $e49315dfffe880aa$var$colorByLabel = (label)=>{
    switch(label){
        case "employer":
            return "rgba(115, 153, 245, 0.45)";
        case "retail":
            return "rgba(58, 68, 158, 0.45)";
        default:
            return `rgba(${new $e49315dfffe880aa$require$ColorHash({
                hash: "bkdr",
                saturation: [
                    0.65,
                    0.35,
                    0.5
                ],
                lightness: [
                    0.65,
                    0.35,
                    0.5
                ]
            }).rgb(label).join(",")}, 0.45)`;
    }
};
module.exports = $e49315dfffe880aa$var$DashboardChartPort;

});
parcelRegister("9No4X", function(module, exports) {

$parcel$export(module.exports, "BarController", function () { return $721b5e3efef367aa$export$e97d5dc64e999004; });
$parcel$export(module.exports, "LineController", function () { return $721b5e3efef367aa$export$3c9b5d28c11cbfd0; });
$parcel$export(module.exports, "Chart", function () { return $721b5e3efef367aa$export$acaa6426d77a227e; });
$parcel$export(module.exports, "LineElement", function () { return $721b5e3efef367aa$export$55e463fa7bcd3469; });
$parcel$export(module.exports, "PointElement", function () { return $721b5e3efef367aa$export$bd159b522b230b7a; });
$parcel$export(module.exports, "BarElement", function () { return $721b5e3efef367aa$export$a16ed71bf4b07672; });
$parcel$export(module.exports, "Filler", function () { return $721b5e3efef367aa$export$d19ba4d812bed757; });
$parcel$export(module.exports, "Tooltip", function () { return $721b5e3efef367aa$export$28c660c63b792dea; });
$parcel$export(module.exports, "CategoryScale", function () { return $721b5e3efef367aa$export$29e663ba4d09fe7; });
$parcel$export(module.exports, "LinearScale", function () { return $721b5e3efef367aa$export$e7f4e5e8656f0b93; });
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $3XW2M = parcelRequire("3XW2M");

class $721b5e3efef367aa$var$Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
    _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart: chart,
                initial: anims.initial,
                numSteps: numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
    _refresh() {
        if (this._request) return;
        this._running = true;
        this._request = (0, $3XW2M.r).call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) this._refresh();
        });
    }
    _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) return;
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) anims.duration = item._total;
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) this._running = false;
    }
    _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
    listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
    add(chart, items) {
        if (!items || !items.length) return;
        this._getAnims(chart).items.push(...items);
    }
    has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
    start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) return;
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) return false;
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) return false;
        return true;
    }
    stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) return;
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i)items[i].cancel();
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
    remove(chart) {
        return this._charts.delete(chart);
    }
}
var $721b5e3efef367aa$export$a424a0aa8f687495 = /* #__PURE__ */ new $721b5e3efef367aa$var$Animator();
const $721b5e3efef367aa$var$transparent = 'transparent';
const $721b5e3efef367aa$var$interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
    color (from, to, factor) {
        const c0 = (0, $3XW2M.c)(from || $721b5e3efef367aa$var$transparent);
        const c1 = c0.valid && (0, $3XW2M.c)(to || $721b5e3efef367aa$var$transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class $721b5e3efef367aa$export$c35d437ae5945fcd {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = (0, $3XW2M.a)([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = (0, $3XW2M.a)([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || $721b5e3efef367aa$var$interpolators[cfg.type || typeof from];
        this._easing = (0, $3XW2M.e)[cfg.easing] || (0, $3XW2M.e).linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = (0, $3XW2M.a)([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = (0, $3XW2M.a)([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res: res,
                rej: rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++)promises[i][method]();
    }
}
class $721b5e3efef367aa$export$8ab227dac26677d {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!(0, $3XW2M.i)(config)) return;
        const animationOptions = Object.keys((0, $3XW2M.d).animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!(0, $3XW2M.i)(cfg)) return;
            const resolved = {};
            for (const option of animationOptions)resolved[option] = cfg[option];
            ((0, $3XW2M.b)(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) animatedProps.set(prop, resolved);
            });
        });
    }
    _animateOptions(target, values) {
        const newOptions = values.options;
        const options = $721b5e3efef367aa$var$resolveTargetOptions(target, newOptions);
        if (!options) return [];
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) $721b5e3efef367aa$var$awaitAll(target.options.$animations, newOptions).then(()=>{
            target.options = newOptions;
        }, ()=>{});
        return animations;
    }
    _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') continue;
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else animation.cancel();
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new $721b5e3efef367aa$export$c35d437ae5945fcd(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
    update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            $721b5e3efef367aa$export$a424a0aa8f687495.add(this._chart, animations);
            return true;
        }
    }
}
function $721b5e3efef367aa$var$awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) running.push(anim.wait());
    }
    return Promise.all(running);
}
function $721b5e3efef367aa$var$resolveTargetOptions(target, newOptions) {
    if (!newOptions) return;
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) target.options = options = Object.assign({}, options, {
        $shared: false,
        $animations: {}
    });
    return options;
}
function $721b5e3efef367aa$var$scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function $721b5e3efef367aa$var$defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) return false;
    const x = $721b5e3efef367aa$var$scaleClip(xScale, allowedOverflow);
    const y = $721b5e3efef367aa$var$scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function $721b5e3efef367aa$var$toClip(value) {
    let t, r, b, l;
    if ((0, $3XW2M.i)(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else t = r = b = l = value;
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function $721b5e3efef367aa$var$getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i)keys.push(metasets[i].index);
    return keys;
}
function $721b5e3efef367aa$var$applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) return;
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) continue;
            break;
        }
        otherValue = stack.values[datasetIndex];
        if ((0, $3XW2M.g)(otherValue) && (singleMode || value === 0 || (0, $3XW2M.s)(value) === (0, $3XW2M.s)(otherValue))) value += otherValue;
    }
    if (!found && !options.all) return 0;
    return value;
}
function $721b5e3efef367aa$var$convertObjectDataToArray(data, meta) {
    const { iScale: iScale, vScale: vScale } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function $721b5e3efef367aa$var$isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function $721b5e3efef367aa$var$getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function $721b5e3efef367aa$var$getUserBounds(scale) {
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function $721b5e3efef367aa$var$getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function $721b5e3efef367aa$var$getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) return meta.index;
    }
    return null;
}
function $721b5e3efef367aa$var$updateStacks(controller, parsed) {
    const { chart: chart, _cachedMeta: meta } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale: iScale, vScale: vScale, index: datasetIndex } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = $721b5e3efef367aa$var$getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index, [vAxis]: value } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = $721b5e3efef367aa$var$getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = $721b5e3efef367aa$var$getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = $721b5e3efef367aa$var$getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function $721b5e3efef367aa$var$getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function $721b5e3efef367aa$var$createDatasetContext(parent, index) {
    return (0, $3XW2M.j)(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index: index,
        mode: 'default',
        type: 'dataset'
    });
}
function $721b5e3efef367aa$var$createDataContext(parent, index, element) {
    return (0, $3XW2M.j)(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element: element,
        index: index,
        mode: 'default',
        type: 'data'
    });
}
function $721b5e3efef367aa$var$clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) return;
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) return;
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) delete stacks[axis]._visualValues[datasetIndex];
    }
}
const $721b5e3efef367aa$var$isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const $721b5e3efef367aa$var$cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const $721b5e3efef367aa$var$createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: $721b5e3efef367aa$var$getSortedDatasetIndices(chart, true),
        values: null
    };
class $721b5e3efef367aa$export$75572ec5c55b4048 {
    static defaults = {};
    static datasetElementType = null;
    static dataElementType = null;
    constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
        this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = $721b5e3efef367aa$var$isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) $721b5e3efef367aa$var$clearStacks(this._cachedMeta);
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = (0, $3XW2M.v)(dataset.xAxisID, $721b5e3efef367aa$var$getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = (0, $3XW2M.v)(dataset.yAxisID, $721b5e3efef367aa$var$getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = (0, $3XW2M.v)(dataset.rAxisID, $721b5e3efef367aa$var$getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
    getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
    _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
    _destroy() {
        const meta = this._cachedMeta;
        if (this._data) (0, $3XW2M.u)(this._data, this);
        if (meta._stacked) $721b5e3efef367aa$var$clearStacks(meta);
    }
    _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if ((0, $3XW2M.i)(data)) {
            const meta = this._cachedMeta;
            this._data = $721b5e3efef367aa$var$convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                (0, $3XW2M.u)(_data, this);
                const meta = this._cachedMeta;
                $721b5e3efef367aa$var$clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) (0, $3XW2M.l)(data, this);
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) meta.dataset = new this.datasetElementType();
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = $721b5e3efef367aa$var$isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            $721b5e3efef367aa$var$clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            $721b5e3efef367aa$var$updateStacks(this, meta._parsed);
            meta._stacked = $721b5e3efef367aa$var$isStacked(meta.vScale, meta);
        }
    }
    configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
    parse(start, count) {
        const { _cachedMeta: meta, _data: data } = this;
        const { iScale: iScale, _stacked: _stacked } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if ((0, $3XW2M.b)(data[start])) parsed = this.parseArrayData(meta, data, start, count);
            else if ((0, $3XW2M.i)(data[start])) parsed = this.parseObjectData(meta, data, start, count);
            else parsed = this.parsePrimitiveData(meta, data, start, count);
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) sorted = false;
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) $721b5e3efef367aa$var$updateStacks(this, parsed);
    }
    parsePrimitiveData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const { xScale: xScale, yScale: yScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse((0, $3XW2M.f)(item, xAxisKey), index),
                y: yScale.parse((0, $3XW2M.f)(item, yAxisKey), index)
            };
        }
        return parsed;
    }
    getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
    getDataElement(index) {
        return this._cachedMeta.data[index];
    }
    applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: $721b5e3efef367aa$var$getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return $721b5e3efef367aa$var$applyStack(stack, value, meta.index, {
            mode: mode
        });
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = $721b5e3efef367aa$var$applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
    getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = $721b5e3efef367aa$var$createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin, max: otherMax } = $721b5e3efef367aa$var$getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !(0, $3XW2M.g)(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) break;
        }
        if (sorted) for(i = ilen - 1; i >= 0; --i){
            if (_skip()) continue;
            this.updateRangeFromParsed(range, scale, parsed, stack);
            break;
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if ((0, $3XW2M.g)(value)) values.push(value);
        }
        return values;
    }
    getMaxOverflow() {
        return false;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
    _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = $721b5e3efef367aa$var$toClip((0, $3XW2M.v)(this.options.clip, $721b5e3efef367aa$var$defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
    update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) meta.dataset.draw(ctx, area, start, count);
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) continue;
            if (element.active && drawActiveElementsOnTop) active.push(element);
            else element.draw(ctx, area);
        }
        for(i = 0; i < active.length; ++i)active[i].draw(ctx, area);
    }
    getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
    getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = $721b5e3efef367aa$var$createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = $721b5e3efef367aa$var$createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
    resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
    resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
    _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && (0, $3XW2M.h)(index);
        if (cached) return $721b5e3efef367aa$var$cloneIfNotShared(cached, sharing);
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys((0, $3XW2M.d).elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze($721b5e3efef367aa$var$cloneIfNotShared(values, sharing));
        }
        return values;
    }
    _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) return cached;
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new $721b5e3efef367aa$export$8ab227dac26677d(chart, options && options.animations);
        if (options && options._cacheable) cache[cacheKey] = Object.freeze(animations);
        return animations;
    }
    getSharedOptions(options) {
        if (!options.$shared) return;
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
    includeOptions(mode, sharedOptions) {
        return !sharedOptions || $721b5e3efef367aa$var$isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
    _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions: sharedOptions,
            includeOptions: includeOptions
        };
    }
    updateElement(element, index, properties, mode) {
        if ($721b5e3efef367aa$var$isDirectUpdateMode(mode)) Object.assign(element, properties);
        else this._resolveAnimations(index, mode).update(element, properties);
    }
    updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !$721b5e3efef367aa$var$isDirectUpdateMode(mode)) this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
    }
    _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
    _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', false);
    }
    _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) this._setStyle(element, undefined, 'active', true);
    }
    _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList)this[method](arg1, arg2);
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) this.parse(0, count);
        if (numData > numMeta) this._insertElements(numMeta, numData - numMeta, resetNewElements);
        else if (numData < numMeta) this._removeElements(numData, numMeta - numData);
    }
    _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--)arr[i] = arr[i - count];
        };
        move(data);
        for(i = start; i < end; ++i)data[i] = new this.dataElementType();
        if (this._parsing) move(meta._parsed);
        this.parse(start, count);
        if (resetNewElements) this.updateElements(data, start, count, 'reset');
    }
    updateElements(element, start, count, mode) {}
    _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) $721b5e3efef367aa$var$clearStacks(meta, removed);
        }
        meta.data.splice(start, count);
    }
    _sync(args) {
        if (this._parsing) this._syncList.push(args);
        else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) this._sync([
            '_removeElements',
            start,
            count
        ]);
        const newCount = arguments.length - 2;
        if (newCount) this._sync([
            '_insertElements',
            start,
            newCount
        ]);
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}
function $721b5e3efef367aa$var$getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++)values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        scale._cache.$bar = (0, $3XW2M._)(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
function $721b5e3efef367aa$var$computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = $721b5e3efef367aa$var$getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) return;
        if ((0, $3XW2M.h)(prev)) min = Math.min(min, Math.abs(curr - prev) || min);
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
function $721b5e3efef367aa$var$computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if ((0, $3XW2M.k)(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio: ratio,
        start: ruler.pixels[index] - size / 2
    };
}
function $721b5e3efef367aa$var$computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    if (next === null) next = curr + curr - prev;
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start: start
    };
}
function $721b5e3efef367aa$var$parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart: barStart,
        barEnd: barEnd,
        start: startValue,
        end: endValue,
        min: min,
        max: max
    };
}
function $721b5e3efef367aa$var$parseValue(entry, item, vScale, i) {
    if ((0, $3XW2M.b)(entry)) $721b5e3efef367aa$var$parseFloatBar(entry, item, vScale, i);
    else item[vScale.axis] = vScale.parse(entry, i);
    return item;
}
function $721b5e3efef367aa$var$parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push($721b5e3efef367aa$var$parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function $721b5e3efef367aa$var$isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function $721b5e3efef367aa$var$barSign(size, vScale, actualBase) {
    if (size !== 0) return (0, $3XW2M.s)(size);
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function $721b5e3efef367aa$var$borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start: start,
        end: end,
        reverse: reverse,
        top: top,
        bottom: bottom
    };
}
function $721b5e3efef367aa$var$setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start: start, end: end, reverse: reverse, top: top, bottom: bottom } = $721b5e3efef367aa$var$borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) edge = top;
        else if ((stack._bottom || 0) === index) edge = bottom;
        else {
            res[$721b5e3efef367aa$var$parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[$721b5e3efef367aa$var$parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function $721b5e3efef367aa$var$parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = $721b5e3efef367aa$var$swap(edge, a, b);
        edge = $721b5e3efef367aa$var$startEnd(edge, b, a);
    } else edge = $721b5e3efef367aa$var$startEnd(edge, a, b);
    return edge;
}
function $721b5e3efef367aa$var$swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function $721b5e3efef367aa$var$startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function $721b5e3efef367aa$var$setInflateAmount(properties, { inflateAmount: inflateAmount }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class $721b5e3efef367aa$export$e97d5dc64e999004 extends $721b5e3efef367aa$export$75572ec5c55b4048 {
    static id = 'bar';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
    parsePrimitiveData(meta, data, start, count) {
        return $721b5e3efef367aa$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseArrayData(meta, data, start, count) {
        return $721b5e3efef367aa$var$parseArrayOrPrimitive(meta, data, start, count);
    }
    parseObjectData(meta, data, start, count) {
        const { iScale: iScale, vScale: vScale } = meta;
        const { xAxisKey: xAxisKey = 'x', yAxisKey: yAxisKey = 'y' } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse((0, $3XW2M.f)(obj, iAxisKey), i);
            parsed.push($721b5e3efef367aa$var$parseValue((0, $3XW2M.f)(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
    updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
    getMaxOverflow() {
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale: iScale, vScale: vScale } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = $721b5e3efef367aa$var$isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value: value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index: index, _cachedMeta: { vScale: vScale } } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || (0, $3XW2M.k)(parsed[vScale.axis]) ? {
                base: base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal: horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || $721b5e3efef367aa$var$isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            const options = properties.options || bars[i].options;
            $721b5e3efef367aa$var$setBorderSkipped(properties, options, stack, index);
            $721b5e3efef367aa$var$setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
    _getStacks(last, dataIndex) {
        const { iScale: iScale } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if ((0, $3XW2M.k)(val) || isNaN(val)) return true;
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) continue;
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) stacks.push(meta.stack);
            if (meta.index === last) break;
        }
        if (!stacks.length) stacks.push(undefined);
        return stacks;
    }
    _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets)axis[(0, $3XW2M.v)(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        return Object.keys(axis);
    }
    _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
    _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i)pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        const barThickness = opts.barThickness;
        const min = barThickness || $721b5e3efef367aa$var$computeMinSampleSize(meta);
        return {
            min: min,
            pixels: pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
    _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale: vScale, _stacked: _stacked, index: datasetIndex }, options: { base: baseValue, minBarLength: minBarLength } } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = $721b5e3efef367aa$var$isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && (0, $3XW2M.s)(value) !== (0, $3XW2M.s)(custom.barEnd)) start = 0;
            start += value;
        }
        const startValue = !(0, $3XW2M.k)(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) head = vScale.getPixelForValue(start + length);
        else head = base;
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = $721b5e3efef367aa$var$barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) base -= size / 2;
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = (0, $3XW2M.s)(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size: size,
            base: base,
            head: head,
            center: head + size / 2
        };
    }
    _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = (0, $3XW2M.v)(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? $721b5e3efef367aa$var$computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : $721b5e3efef367aa$var$computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf((0, $3XW2M.v)(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center: center,
            size: size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i)if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) rects[i].draw(this._ctx);
    }
}
class $721b5e3efef367aa$export$19b5c4773f17abe extends $721b5e3efef367aa$export$75572ec5c55b4048 {
    static id = 'bubble';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'borderWidth',
                    'radius'
                ]
            }
        }
    };
    static overrides = {
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
    }
    parsePrimitiveData(meta, data, start, count) {
        const parsed = super.parsePrimitiveData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++)parsed[i]._custom = this.resolveDataElementOptions(i + start).radius;
        return parsed;
    }
    parseArrayData(meta, data, start, count) {
        const parsed = super.parseArrayData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $3XW2M.v)(item[2], this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    parseObjectData(meta, data, start, count) {
        const parsed = super.parseObjectData(meta, data, start, count);
        for(let i = 0; i < parsed.length; i++){
            const item = data[start + i];
            parsed[i]._custom = (0, $3XW2M.v)(item && item.r && +item.r, this.resolveDataElementOptions(i + start).radius);
        }
        return parsed;
    }
    getMaxOverflow() {
        const data = this._cachedMeta.data;
        let max = 0;
        for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
        return max > 0 && max;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        const r = parsed._custom;
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + (r ? ', ' + r : '') + ')'
        };
    }
    update(mode) {
        const points = this._cachedMeta.data;
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const parsed = !reset && this.getParsed(i);
            const properties = {};
            const iPixel = properties[iAxis] = reset ? iScale.getPixelForDecimal(0.5) : iScale.getPixelForValue(parsed[iAxis]);
            const vPixel = properties[vAxis] = reset ? vScale.getBasePixel() : vScale.getPixelForValue(parsed[vAxis]);
            properties.skip = isNaN(iPixel) || isNaN(vPixel);
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
                if (reset) properties.options.radius = 0;
            }
            this.updateElement(point, i, properties, mode);
        }
    }
    resolveDataElementOptions(index, mode) {
        const parsed = this.getParsed(index);
        let values = super.resolveDataElementOptions(index, mode);
        if (values.$shared) values = Object.assign({}, values, {
            $shared: false
        });
        const radius = values.radius;
        if (mode !== 'active') values.radius = 0;
        values.radius += (0, $3XW2M.v)(parsed && parsed._custom, radius);
        return values;
    }
}
function $721b5e3efef367aa$var$getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < (0, $3XW2M.T)) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>(0, $3XW2M.p)(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>(0, $3XW2M.p)(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax((0, $3XW2M.H), startY, endY);
        const minX = calcMin((0, $3XW2M.P), startX, endX);
        const minY = calcMin((0, $3XW2M.P) + (0, $3XW2M.H), startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX: ratioX,
        ratioY: ratioY,
        offsetX: offsetX,
        offsetY: offsetY
    };
}
class $721b5e3efef367aa$export$e04603e7d8b77172 extends $721b5e3efef367aa$export$75572ec5c55b4048 {
    static id = 'doughnut';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        const { labels: { pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                        if (data.labels.length && data.datasets.length) return data.labels.map((label, i)=>{
                            const meta = chart.getDatasetMeta(0);
                            const style = meta.controller.getStyle(i);
                            return {
                                text: label,
                                fillStyle: style.backgroundColor,
                                fontColor: color,
                                hidden: !chart.getDataVisibility(i),
                                lineDash: style.borderDash,
                                lineDashOffset: style.borderDashOffset,
                                lineJoin: style.borderJoinStyle,
                                lineWidth: style.borderWidth,
                                strokeStyle: style.borderColor,
                                textAlign: textAlign,
                                pointStyle: pointStyle,
                                borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                                index: i
                            };
                        });
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
    parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) meta._parsed = data;
        else {
            let getter = (i)=>+data[i];
            if ((0, $3XW2M.i)(data[start])) {
                const { key: key = 'value' } = this._parsing;
                getter = (i)=>+(0, $3XW2M.f)(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i)meta._parsed[i] = getter(i);
        }
    }
    _getRotation() {
        return (0, $3XW2M.t)(this.options.rotation - 90);
    }
    _getCircumference() {
        return (0, $3XW2M.t)(this.options.circumference);
    }
    _getRotationExtents() {
        let min = (0, $3XW2M.T);
        let max = -(0, $3XW2M.T);
        for(let i = 0; i < this.chart.data.datasets.length; ++i)if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
            const controller = this.chart.getDatasetMeta(i).controller;
            const rotation = controller._getRotation();
            const circumference = controller._getCircumference();
            min = Math.min(min, rotation);
            max = Math.max(max, rotation + circumference);
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
    update(mode) {
        const chart = this.chart;
        const { chartArea: chartArea } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min((0, $3XW2M.m)(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference: circumference, rotation: rotation } = this._getRotationExtents();
        const { ratioX: ratioX, ratioY: ratioY, offsetX: offsetX, offsetY: offsetY } = $721b5e3efef367aa$var$getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = (0, $3XW2M.n)(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) return 0;
        return this.calculateCircumference(meta._parsed[i] * circumference / (0, $3XW2M.T));
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i)startAngle += this._circumference(i, reset);
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle: startAngle,
                endAngle: startAngle + circumference,
                circumference: circumference,
                outerRadius: outerRadius,
                innerRadius: innerRadius
            };
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) total += Math.abs(value);
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) return (0, $3XW2M.T) * (Math.abs(value) / total);
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $3XW2M.o)(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i)if (chart.isDatasetVisible(i)) {
                meta = chart.getDatasetMeta(i);
                arcs = meta.data;
                controller = meta.controller;
                break;
            }
        }
        if (!arcs) return 0;
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
    _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i)if (this.chart.isDatasetVisible(i)) ringWeightOffset += this._getRingWeight(i);
        return ringWeightOffset;
    }
    _getRingWeight(datasetIndex) {
        return Math.max((0, $3XW2M.v)(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
    _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}
class $721b5e3efef367aa$export$3c9b5d28c11cbfd0 extends $721b5e3efef367aa$export$75572ec5c55b4048 {
    static id = 'line';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
    static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line, data: points = [], _dataset: _dataset } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $3XW2M.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $3XW2M.w)(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) options.borderWidth = 0;
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options: options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const { sharedOptions: sharedOptions, includeOptions: includeOptions } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $3XW2M.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = (0, $3XW2M.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}
class $721b5e3efef367aa$export$2a270b3a0d973c85 extends $721b5e3efef367aa$export$75572ec5c55b4048 {
    static id = 'polarArea';
    static defaults = {
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: true
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'startAngle',
                    'endAngle',
                    'innerRadius',
                    'outerRadius'
                ]
            }
        },
        indexAxis: 'r',
        startAngle: 0
    };
    static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        if (data.labels.length && data.datasets.length) {
                            const { labels: { pointStyle: pointStyle, color: color } } = chart.legend.options;
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    fontColor: color,
                                    lineWidth: style.borderWidth,
                                    pointStyle: pointStyle,
                                    hidden: !chart.getDataVisibility(i),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        },
        scales: {
            r: {
                type: 'radialLinear',
                angleLines: {
                    display: false
                },
                beginAtZero: true,
                grid: {
                    circular: true
                },
                pointLabels: {
                    display: false
                },
                startAngle: 0
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.innerRadius = undefined;
        this.outerRadius = undefined;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = (0, $3XW2M.o)(meta._parsed[index].r, chart.options.locale);
        return {
            label: labels[index] || '',
            value: value
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $3XW2M.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const arcs = this._cachedMeta.data;
        this._updateRadius();
        this.updateElements(arcs, 0, arcs.length, mode);
    }
    getMinMax() {
        const meta = this._cachedMeta;
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        meta.data.forEach((element, index)=>{
            const parsed = this.getParsed(index).r;
            if (!isNaN(parsed) && this.chart.getDataVisibility(index)) {
                if (parsed < range.min) range.min = parsed;
                if (parsed > range.max) range.max = parsed;
            }
        });
        return range;
    }
    _updateRadius() {
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
        const outerRadius = Math.max(minSize / 2, 0);
        const innerRadius = Math.max(opts.cutoutPercentage ? outerRadius / 100 * opts.cutoutPercentage : 1, 0);
        const radiusLength = (outerRadius - innerRadius) / chart.getVisibleDatasetCount();
        this.outerRadius = outerRadius - radiusLength * this.index;
        this.innerRadius = this.outerRadius - radiusLength;
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const scale = this._cachedMeta.rScale;
        const centerX = scale.xCenter;
        const centerY = scale.yCenter;
        const datasetStartAngle = scale.getIndexAngle(0) - 0.5 * (0, $3XW2M.P);
        let angle = datasetStartAngle;
        let i;
        const defaultAngle = 360 / this.countVisibleElements();
        for(i = 0; i < start; ++i)angle += this._computeAngle(i, mode, defaultAngle);
        for(i = start; i < start + count; i++){
            const arc = arcs[i];
            let startAngle = angle;
            let endAngle = angle + this._computeAngle(i, mode, defaultAngle);
            let outerRadius = chart.getDataVisibility(i) ? scale.getDistanceFromCenterForValue(this.getParsed(i).r) : 0;
            angle = endAngle;
            if (reset) {
                if (animationOpts.animateScale) outerRadius = 0;
                if (animationOpts.animateRotate) startAngle = endAngle = datasetStartAngle;
            }
            const properties = {
                x: centerX,
                y: centerY,
                innerRadius: 0,
                outerRadius: outerRadius,
                startAngle: startAngle,
                endAngle: endAngle,
                options: this.resolveDataElementOptions(i, arc.active ? 'active' : mode)
            };
            this.updateElement(arc, i, properties, mode);
        }
    }
    countVisibleElements() {
        const meta = this._cachedMeta;
        let count = 0;
        meta.data.forEach((element, index)=>{
            if (!isNaN(this.getParsed(index).r) && this.chart.getDataVisibility(index)) count++;
        });
        return count;
    }
    _computeAngle(index, mode, defaultAngle) {
        return this.chart.getDataVisibility(index) ? (0, $3XW2M.t)(this.resolveDataElementOptions(index, mode).angle || defaultAngle) : 0;
    }
}
class $721b5e3efef367aa$export$b21a3f1286706191 extends $721b5e3efef367aa$export$e04603e7d8b77172 {
    static id = 'pie';
    static defaults = {
        cutout: 0,
        rotation: 0,
        circumference: 360,
        radius: '100%'
    };
}
class $721b5e3efef367aa$export$48dbc6ac651bf8be extends $721b5e3efef367aa$export$75572ec5c55b4048 {
    static id = 'radar';
    static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        indexAxis: 'r',
        showLine: true,
        elements: {
            line: {
                fill: 'start'
            }
        }
    };
    static overrides = {
        aspectRatio: 1,
        scales: {
            r: {
                type: 'radialLinear'
            }
        }
    };
    getLabelAndValue(index) {
        const vScale = this._cachedMeta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: vScale.getLabels()[index],
            value: '' + vScale.getLabelForValue(parsed[vScale.axis])
        };
    }
    parseObjectData(meta, data, start, count) {
        return (0, $3XW2M.y).bind(this)(meta, data, start, count);
    }
    update(mode) {
        const meta = this._cachedMeta;
        const line = meta.dataset;
        const points = meta.data || [];
        const labels = meta.iScale.getLabels();
        line.points = points;
        if (mode !== 'resize') {
            const options = this.resolveDatasetElementOptions(mode);
            if (!this.options.showLine) options.borderWidth = 0;
            const properties = {
                _loop: true,
                _fullLoop: labels.length === points.length,
                options: options
            };
            this.updateElement(line, undefined, properties, mode);
        }
        this.updateElements(points, 0, points.length, mode);
    }
    updateElements(points, start, count, mode) {
        const scale = this._cachedMeta.rScale;
        const reset = mode === 'reset';
        for(let i = start; i < start + count; i++){
            const point = points[i];
            const options = this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            const pointPosition = scale.getPointPositionForValue(i, this.getParsed(i).r);
            const x = reset ? scale.xCenter : pointPosition.x;
            const y = reset ? scale.yCenter : pointPosition.y;
            const properties = {
                x: x,
                y: y,
                angle: pointPosition.angle,
                skip: isNaN(x) || isNaN(y),
                options: options
            };
            this.updateElement(point, i, properties, mode);
        }
    }
}
class $721b5e3efef367aa$export$b2f2bae6713db87 extends $721b5e3efef367aa$export$75572ec5c55b4048 {
    static id = 'scatter';
    static defaults = {
        datasetElementType: false,
        dataElementType: 'point',
        showLine: false,
        fill: false
    };
    static overrides = {
        interaction: {
            mode: 'point'
        },
        scales: {
            x: {
                type: 'linear'
            },
            y: {
                type: 'linear'
            }
        }
    };
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const labels = this.chart.data.labels || [];
        const { xScale: xScale, yScale: yScale } = meta;
        const parsed = this.getParsed(index);
        const x = xScale.getLabelForValue(parsed.x);
        const y = yScale.getLabelForValue(parsed.y);
        return {
            label: labels[index] || '',
            value: '(' + x + ', ' + y + ')'
        };
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { data: points = [] } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start: start, count: count } = (0, $3XW2M.q)(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if ((0, $3XW2M.w)(meta)) {
            start = 0;
            count = points.length;
        }
        if (this.options.showLine) {
            if (!this.datasetElementType) this.addElements();
            const { dataset: line, _dataset: _dataset } = meta;
            line._chart = this.chart;
            line._datasetIndex = this.index;
            line._decimated = !!_dataset._decimated;
            line.points = points;
            const options = this.resolveDatasetElementOptions(mode);
            options.segment = this.options.segment;
            this.updateElement(line, undefined, {
                animated: !animationsDisabled,
                options: options
            }, mode);
        } else if (this.datasetElementType) {
            delete meta.dataset;
            this.datasetElementType = false;
        }
        this.updateElements(points, start, count, mode);
    }
    addElements() {
        const { showLine: showLine } = this.options;
        if (!this.datasetElementType && showLine) this.datasetElementType = this.chart.registry.getElement('line');
        super.addElements();
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale: iScale, vScale: vScale, _stacked: _stacked, _dataset: _dataset } = this._cachedMeta;
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps: spanGaps, segment: segment } = this.options;
        const maxGapLength = (0, $3XW2M.x)(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = start; i < start + count; ++i){
            const point = points[i];
            const parsed = this.getParsed(i);
            const properties = directUpdate ? point : {};
            const nullData = (0, $3XW2M.k)(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            if (!directUpdate) this.updateElement(point, i, properties, mode);
            prevParsed = parsed;
        }
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
    }
    getMaxOverflow() {
        const meta = this._cachedMeta;
        const data = meta.data || [];
        if (!this.options.showLine) {
            let max = 0;
            for(let i = data.length - 1; i >= 0; --i)max = Math.max(max, data[i].size(this.resolveDataElementOptions(i)) / 2);
            return max > 0 && max;
        }
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        if (!data.length) return border;
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
}
var $721b5e3efef367aa$export$a6506504f799c5d5 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BarController: $721b5e3efef367aa$export$e97d5dc64e999004,
    BubbleController: $721b5e3efef367aa$export$19b5c4773f17abe,
    DoughnutController: $721b5e3efef367aa$export$e04603e7d8b77172,
    LineController: $721b5e3efef367aa$export$3c9b5d28c11cbfd0,
    PieController: $721b5e3efef367aa$export$b21a3f1286706191,
    PolarAreaController: $721b5e3efef367aa$export$2a270b3a0d973c85,
    RadarController: $721b5e3efef367aa$export$48dbc6ac651bf8be,
    ScatterController: $721b5e3efef367aa$export$b2f2bae6713db87
});
/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function $721b5e3efef367aa$var$abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class $721b5e3efef367aa$var$DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign($721b5e3efef367aa$var$DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return $721b5e3efef367aa$var$abstract();
    }
    parse() {
        return $721b5e3efef367aa$var$abstract();
    }
    format() {
        return $721b5e3efef367aa$var$abstract();
    }
    add() {
        return $721b5e3efef367aa$var$abstract();
    }
    diff() {
        return $721b5e3efef367aa$var$abstract();
    }
    startOf() {
        return $721b5e3efef367aa$var$abstract();
    }
    endOf() {
        return $721b5e3efef367aa$var$abstract();
    }
}
var $721b5e3efef367aa$export$f32766ea09ec8bc4 = {
    _date: $721b5e3efef367aa$var$DateAdapterBase
};
function $721b5e3efef367aa$var$binarySearch(metaset, axis, value, intersect) {
    const { controller: controller, data: data, _sorted: _sorted } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? (0, $3XW2M.A) : (0, $3XW2M.B);
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale: vScale } = controller._cachedMeta;
                const { _parsed: _parsed } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!(0, $3XW2M.k)(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!(0, $3XW2M.k)(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
function $721b5e3efef367aa$var$evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index: index, data: data } = metasets[i];
        const { lo: lo, hi: hi } = $721b5e3efef367aa$var$binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) handler(element, index, j);
        }
    }
}
function $721b5e3efef367aa$var$getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
function $721b5e3efef367aa$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) return items;
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !(0, $3XW2M.C)(element, chart.chartArea, 0)) return;
        if (element.inRange(position.x, position.y, useFinalPosition)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    };
    $721b5e3efef367aa$var$evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
function $721b5e3efef367aa$var$getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle: startAngle, endAngle: endAngle } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle: angle } = (0, $3XW2M.D)(element, {
            x: position.x,
            y: position.y
        });
        if ((0, $3XW2M.p)(angle, startAngle, endAngle)) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $721b5e3efef367aa$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $721b5e3efef367aa$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = $721b5e3efef367aa$var$getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) return;
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) return;
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element: element,
                    datasetIndex: datasetIndex,
                    index: index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) items.push({
            element: element,
            datasetIndex: datasetIndex,
            index: index
        });
    }
    $721b5e3efef367aa$var$evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
function $721b5e3efef367aa$var$getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) return [];
    return axis === 'r' && !intersect ? $721b5e3efef367aa$var$getNearestRadialItems(chart, position, axis, useFinalPosition) : $721b5e3efef367aa$var$getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function $721b5e3efef367aa$var$getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    $721b5e3efef367aa$var$evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element: element,
                datasetIndex: datasetIndex,
                index: index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) return [];
    return items;
}
var $721b5e3efef367aa$export$a13296960cae0384 = {
    evaluateInteractionItems: $721b5e3efef367aa$var$evaluateInteractionItems,
    modes: {
        index (chart, e, options, useFinalPosition) {
            const position = (0, $3XW2M.z)(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? $721b5e3efef367aa$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $721b5e3efef367aa$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) return [];
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) elements.push({
                    element: element,
                    datasetIndex: meta.index,
                    index: index
                });
            });
            return elements;
        },
        dataset (chart, e, options, useFinalPosition) {
            const position = (0, $3XW2M.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? $721b5e3efef367aa$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : $721b5e3efef367aa$var$getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i)items.push({
                    element: data[i],
                    datasetIndex: datasetIndex,
                    index: i
                });
            }
            return items;
        },
        point (chart, e, options, useFinalPosition) {
            const position = (0, $3XW2M.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $721b5e3efef367aa$var$getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
        nearest (chart, e, options, useFinalPosition) {
            const position = (0, $3XW2M.z)(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return $721b5e3efef367aa$var$getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
        x (chart, e, options, useFinalPosition) {
            const position = (0, $3XW2M.z)(e, chart);
            return $721b5e3efef367aa$var$getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
        y (chart, e, options, useFinalPosition) {
            const position = (0, $3XW2M.z)(e, chart);
            return $721b5e3efef367aa$var$getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};
const $721b5e3efef367aa$var$STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function $721b5e3efef367aa$var$filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function $721b5e3efef367aa$var$filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>$721b5e3efef367aa$var$STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function $721b5e3efef367aa$var$sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function $721b5e3efef367aa$var$wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos, options: { stack: stack, stackWeight: stackWeight = 1 } } = box);
        layoutBoxes.push({
            index: i,
            box: box,
            pos: pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight: stackWeight
        });
    }
    return layoutBoxes;
}
function $721b5e3efef367aa$var$buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack: stack, pos: pos, stackWeight: stackWeight } = wrap;
        if (!stack || !$721b5e3efef367aa$var$STATIC_POSITIONS.includes(pos)) continue;
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
function $721b5e3efef367aa$var$setLayoutDims(layouts, params) {
    const stacks = $721b5e3efef367aa$var$buildStacks(layouts);
    const { vBoxMaxWidth: vBoxMaxWidth, hBoxMaxHeight: hBoxMaxHeight } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize: fullSize } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function $721b5e3efef367aa$var$buildLayoutBoxes(boxes) {
    const layoutBoxes = $721b5e3efef367aa$var$wrapBoxes(boxes);
    const fullSize = $721b5e3efef367aa$var$sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = $721b5e3efef367aa$var$sortByWeight($721b5e3efef367aa$var$filterByPosition(layoutBoxes, 'left'), true);
    const right = $721b5e3efef367aa$var$sortByWeight($721b5e3efef367aa$var$filterByPosition(layoutBoxes, 'right'));
    const top = $721b5e3efef367aa$var$sortByWeight($721b5e3efef367aa$var$filterByPosition(layoutBoxes, 'top'), true);
    const bottom = $721b5e3efef367aa$var$sortByWeight($721b5e3efef367aa$var$filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = $721b5e3efef367aa$var$filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = $721b5e3efef367aa$var$filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize: fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: $721b5e3efef367aa$var$filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function $721b5e3efef367aa$var$getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function $721b5e3efef367aa$var$updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function $721b5e3efef367aa$var$updateDims(chartArea, params, layout, stacks) {
    const { pos: pos, box: box } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!(0, $3XW2M.i)(pos)) {
        if (layout.size) chartArea[pos] -= layout.size;
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) $721b5e3efef367aa$var$updateMaxPadding(maxPadding, box.getPadding());
    const newWidth = Math.max(0, params.outerWidth - $721b5e3efef367aa$var$getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - $721b5e3efef367aa$var$getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function $721b5e3efef367aa$var$handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function $721b5e3efef367aa$var$getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function $721b5e3efef367aa$var$fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, $721b5e3efef367aa$var$getMargins(layout.horizontal, chartArea));
        const { same: same, other: other } = $721b5e3efef367aa$var$updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) refitBoxes.push(layout);
    }
    return refit && $721b5e3efef367aa$var$fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function $721b5e3efef367aa$var$setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function $721b5e3efef367aa$var$placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x: x, y: y } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if ((0, $3XW2M.h)(stack.start)) y = stack.start;
            if (box.fullSize) $721b5e3efef367aa$var$setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            else $721b5e3efef367aa$var$setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if ((0, $3XW2M.h)(stack.start)) x = stack.start;
            if (box.fullSize) $721b5e3efef367aa$var$setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            else $721b5e3efef367aa$var$setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var $721b5e3efef367aa$export$1ecca0613f5e56d2 = {
    addBox (chart, item) {
        if (!chart.boxes) chart.boxes = [];
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
    removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) chart.boxes.splice(index, 1);
    },
    configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
    update (chart, width, height, minPadding) {
        if (!chart) return;
        const padding = (0, $3XW2M.E)(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = $721b5e3efef367aa$var$buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        (0, $3XW2M.F)(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') box.beforeLayout();
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding: padding,
            availableWidth: availableWidth,
            availableHeight: availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        $721b5e3efef367aa$var$updateMaxPadding(maxPadding, (0, $3XW2M.E)(minPadding));
        const chartArea = Object.assign({
            maxPadding: maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = $721b5e3efef367aa$var$setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        $721b5e3efef367aa$var$fitBoxes(boxes.fullSize, chartArea, params, stacks);
        $721b5e3efef367aa$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        if ($721b5e3efef367aa$var$fitBoxes(horizontalBoxes, chartArea, params, stacks)) $721b5e3efef367aa$var$fitBoxes(verticalBoxes, chartArea, params, stacks);
        $721b5e3efef367aa$var$handleMaxPadding(chartArea);
        $721b5e3efef367aa$var$placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        $721b5e3efef367aa$var$placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        (0, $3XW2M.F)(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};
class $721b5e3efef367aa$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {}
    releaseContext(context) {
        return false;
    }
    addEventListener(chart, type, listener) {}
    removeEventListener(chart, type, listener) {}
    getDevicePixelRatio() {
        return 1;
    }
    getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width: width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
    isAttached(canvas) {
        return true;
    }
    updateConfig(config) {}
}
class $721b5e3efef367aa$export$a40a96b24b46cf35 extends $721b5e3efef367aa$export$7b1aeb87f31f7da8 {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}
const $721b5e3efef367aa$var$EXPANDO_KEY = '$chartjs';
const $721b5e3efef367aa$var$EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const $721b5e3efef367aa$var$isNullOrEmpty = (value)=>value === null || value === '';
function $721b5e3efef367aa$var$initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[$721b5e3efef367aa$var$EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if ($721b5e3efef367aa$var$isNullOrEmpty(renderWidth)) {
        const displayWidth = (0, $3XW2M.J)(canvas, 'width');
        if (displayWidth !== undefined) canvas.width = displayWidth;
    }
    if ($721b5e3efef367aa$var$isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') canvas.height = canvas.width / (aspectRatio || 2);
        else {
            const displayHeight = (0, $3XW2M.J)(canvas, 'height');
            if (displayHeight !== undefined) canvas.height = displayHeight;
        }
    }
    return canvas;
}
const $721b5e3efef367aa$var$eventListenerOptions = (0, $3XW2M.K) ? {
    passive: true
} : false;
function $721b5e3efef367aa$var$addListener(node, type, listener) {
    if (node) node.addEventListener(type, listener, $721b5e3efef367aa$var$eventListenerOptions);
}
function $721b5e3efef367aa$var$removeListener(chart, type, listener) {
    if (chart && chart.canvas) chart.canvas.removeEventListener(type, listener, $721b5e3efef367aa$var$eventListenerOptions);
}
function $721b5e3efef367aa$var$fromNativeEvent(event, chart) {
    const type = $721b5e3efef367aa$var$EVENT_TYPES[event.type] || event.type;
    const { x: x, y: y } = (0, $3XW2M.z)(event, chart);
    return {
        type: type,
        chart: chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function $721b5e3efef367aa$var$nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) return true;
    }
}
function $721b5e3efef367aa$var$createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $721b5e3efef367aa$var$nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !$721b5e3efef367aa$var$nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $721b5e3efef367aa$var$createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || $721b5e3efef367aa$var$nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !$721b5e3efef367aa$var$nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) listener();
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const $721b5e3efef367aa$var$drpListeningCharts = new Map();
let $721b5e3efef367aa$var$oldDevicePixelRatio = 0;
function $721b5e3efef367aa$var$onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === $721b5e3efef367aa$var$oldDevicePixelRatio) return;
    $721b5e3efef367aa$var$oldDevicePixelRatio = dpr;
    $721b5e3efef367aa$var$drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) resize();
    });
}
function $721b5e3efef367aa$var$listenDevicePixelRatioChanges(chart, resize) {
    if (!$721b5e3efef367aa$var$drpListeningCharts.size) window.addEventListener('resize', $721b5e3efef367aa$var$onWindowResize);
    $721b5e3efef367aa$var$drpListeningCharts.set(chart, resize);
}
function $721b5e3efef367aa$var$unlistenDevicePixelRatioChanges(chart) {
    $721b5e3efef367aa$var$drpListeningCharts.delete(chart);
    if (!$721b5e3efef367aa$var$drpListeningCharts.size) window.removeEventListener('resize', $721b5e3efef367aa$var$onWindowResize);
}
function $721b5e3efef367aa$var$createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && (0, $3XW2M.I)(canvas);
    if (!container) return;
    const resize = (0, $3XW2M.L)((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) listener();
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) return;
        resize(width, height);
    });
    observer.observe(container);
    $721b5e3efef367aa$var$listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function $721b5e3efef367aa$var$releaseObserver(chart, type, observer) {
    if (observer) observer.disconnect();
    if (type === 'resize') $721b5e3efef367aa$var$unlistenDevicePixelRatioChanges(chart);
}
function $721b5e3efef367aa$var$createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = (0, $3XW2M.L)((event)=>{
        if (chart.ctx !== null) listener($721b5e3efef367aa$var$fromNativeEvent(event, chart));
    }, chart);
    $721b5e3efef367aa$var$addListener(canvas, type, proxy);
    return proxy;
}
class $721b5e3efef367aa$export$f02da7f882cf6b2e extends $721b5e3efef367aa$export$7b1aeb87f31f7da8 {
    acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            $721b5e3efef367aa$var$initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
    releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[$721b5e3efef367aa$var$EXPANDO_KEY]) return false;
        const initial = canvas[$721b5e3efef367aa$var$EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if ((0, $3XW2M.k)(value)) canvas.removeAttribute(prop);
            else canvas.setAttribute(prop, value);
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[$721b5e3efef367aa$var$EXPANDO_KEY];
        return true;
    }
    addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: $721b5e3efef367aa$var$createAttachObserver,
            detach: $721b5e3efef367aa$var$createDetachObserver,
            resize: $721b5e3efef367aa$var$createResizeObserver
        };
        const handler = handlers[type] || $721b5e3efef367aa$var$createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
    removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) return;
        const handlers = {
            attach: $721b5e3efef367aa$var$releaseObserver,
            detach: $721b5e3efef367aa$var$releaseObserver,
            resize: $721b5e3efef367aa$var$releaseObserver
        };
        const handler = handlers[type] || $721b5e3efef367aa$var$removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
    getMaximumSize(canvas, width, height, aspectRatio) {
        return (0, $3XW2M.G)(canvas, width, height, aspectRatio);
    }
    isAttached(canvas) {
        const container = canvas && (0, $3XW2M.I)(canvas);
        return !!(container && container.isConnected);
    }
}
function $721b5e3efef367aa$export$72cd9e67b1b784f9(canvas) {
    if (!(0, $3XW2M.M)() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return $721b5e3efef367aa$export$a40a96b24b46cf35;
    return $721b5e3efef367aa$export$f02da7f882cf6b2e;
}
class $721b5e3efef367aa$export$db77ccec0bb4ccac {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    hasValue() {
        return (0, $3XW2M.x)(this.x) && (0, $3XW2M.x)(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) // let's not create an object, if not needed
        return this;
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}
function $721b5e3efef367aa$var$autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = $721b5e3efef367aa$var$determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? $721b5e3efef367aa$var$getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        $721b5e3efef367aa$var$skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = $721b5e3efef367aa$var$calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        $721b5e3efef367aa$var$skip(ticks, newTicks, spacing, (0, $3XW2M.k)(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++)$721b5e3efef367aa$var$skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        $721b5e3efef367aa$var$skip(ticks, newTicks, spacing, last, (0, $3XW2M.k)(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    $721b5e3efef367aa$var$skip(ticks, newTicks, spacing);
    return newTicks;
}
function $721b5e3efef367aa$var$determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
function $721b5e3efef367aa$var$calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = $721b5e3efef367aa$var$getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) return Math.max(spacing, 1);
    const factors = (0, $3XW2M.N)(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) return factor;
    }
    return Math.max(spacing, 1);
}
function $721b5e3efef367aa$var$getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++)if (ticks[i].major) result.push(i);
    return result;
}
function $721b5e3efef367aa$var$skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = majorIndices[count * spacing];
    }
}
function $721b5e3efef367aa$var$skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = (0, $3XW2M.v)(majorStart, 0);
    const end = Math.min((0, $3XW2M.v)(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++)if (i === next) {
        newTicks.push(ticks[i]);
        count++;
        next = Math.round(start + count * spacing);
    }
}
function $721b5e3efef367aa$var$getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) return false;
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) return false;
    }
    return diff;
}
const $721b5e3efef367aa$var$reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const $721b5e3efef367aa$var$offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const $721b5e3efef367aa$var$getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
function $721b5e3efef367aa$var$sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment)result.push(arr[Math.floor(i)]);
    return result;
}
function $721b5e3efef367aa$var$getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) offset = Math.max(lineValue - start, end - lineValue);
        else if (index === 0) offset = (scale.getPixelForTick(1) - lineValue) / 2;
        else offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) return;
    }
    return lineValue;
}
function $721b5e3efef367aa$var$garbageCollect(caches, length) {
    (0, $3XW2M.F)(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i)delete cache.data[gc[i]];
            gc.splice(0, gcLen);
        }
    });
}
function $721b5e3efef367aa$var$getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
function $721b5e3efef367aa$var$getTitleHeight(options, fallback) {
    if (!options.display) return 0;
    const font = (0, $3XW2M.a0)(options.font, fallback);
    const padding = (0, $3XW2M.E)(options.padding);
    const lines = (0, $3XW2M.b)(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function $721b5e3efef367aa$var$createScaleContext(parent, scale) {
    return (0, $3XW2M.j)(parent, {
        scale: scale,
        type: 'scale'
    });
}
function $721b5e3efef367aa$var$createTickContext(parent, index, tick) {
    return (0, $3XW2M.j)(parent, {
        tick: tick,
        index: index,
        type: 'tick'
    });
}
function $721b5e3efef367aa$var$titleAlign(align, position, reverse) {
    let ret = (0, $3XW2M.a1)(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') ret = $721b5e3efef367aa$var$reverseAlign(ret);
    return ret;
}
function $721b5e3efef367aa$var$titleArgs(scale, offset, position, align) {
    const { top: top, left: left, bottom: bottom, right: right, chart: chart } = scale;
    const { chartArea: chartArea, scales: scales } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = (0, $3XW2M.a2)(align, left, right);
        if ((0, $3XW2M.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        else titleY = $721b5e3efef367aa$var$offsetFromEdge(scale, position, offset);
        maxWidth = right - left;
    } else {
        if ((0, $3XW2M.i)(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        else titleX = $721b5e3efef367aa$var$offsetFromEdge(scale, position, offset);
        titleY = (0, $3XW2M.a2)(align, bottom, top);
        rotation = position === 'left' ? -(0, $3XW2M.H) : (0, $3XW2M.H);
    }
    return {
        titleX: titleX,
        titleY: titleY,
        maxWidth: maxWidth,
        rotation: rotation
    };
}
class $721b5e3efef367aa$export$d60cfc58d3c358b6 extends $721b5e3efef367aa$export$db77ccec0bb4ccac {
    constructor(cfg){
        super();
        this.id = cfg.id;
        this.type = cfg.type;
        this.options = undefined;
        this.ctx = cfg.ctx;
        this.chart = cfg.chart;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.paddingTop = undefined;
        this.paddingBottom = undefined;
        this.paddingLeft = undefined;
        this.paddingRight = undefined;
        this.axis = undefined;
        this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
        this.ticks = [];
        this._gridLineItems = null;
        this._labelItems = null;
        this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
        this._startPixel = undefined;
        this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
    init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
    parse(raw, index) {
        return raw;
    }
    getUserBounds() {
        let { _userMin: _userMin, _userMax: _userMax, _suggestedMin: _suggestedMin, _suggestedMax: _suggestedMax } = this;
        _userMin = (0, $3XW2M.O)(_userMin, Number.POSITIVE_INFINITY);
        _userMax = (0, $3XW2M.O)(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = (0, $3XW2M.O)(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = (0, $3XW2M.O)(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: (0, $3XW2M.O)(_userMin, _suggestedMin),
            max: (0, $3XW2M.O)(_userMax, _suggestedMax),
            minDefined: (0, $3XW2M.g)(_userMin),
            maxDefined: (0, $3XW2M.g)(_userMax)
        };
    }
    getMinMax(canStack) {
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) return {
            min: min,
            max: max
        };
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) min = Math.min(min, range.min);
            if (!maxDefined) max = Math.max(max, range.max);
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: (0, $3XW2M.O)(min, (0, $3XW2M.O)(max, min)),
            max: (0, $3XW2M.O)(max, (0, $3XW2M.O)(min, max))
        };
    }
    getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
    getTicks() {
        return this.ticks;
    }
    getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
    getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        (0, $3XW2M.Q)(this.options.beforeUpdate, [
            this
        ]);
    }
    update(maxWidth, maxHeight, margins) {
        const { beginAtZero: beginAtZero, grace: grace, ticks: tickOpts } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = (0, $3XW2M.R)(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? $721b5e3efef367aa$var$sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = $721b5e3efef367aa$var$autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) this._convertTicksToLabels(this.ticks);
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
    configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        (0, $3XW2M.Q)(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        (0, $3XW2M.Q)(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        (0, $3XW2M.Q)(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        (0, $3XW2M.Q)(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
    buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        (0, $3XW2M.Q)(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
    generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = (0, $3XW2M.Q)(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        (0, $3XW2M.Q)(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        (0, $3XW2M.Q)(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = $721b5e3efef367aa$var$getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = (0, $3XW2M.S)(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - $721b5e3efef367aa$var$getTickMarkLength(options.grid) - tickOpts.padding - $721b5e3efef367aa$var$getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = (0, $3XW2M.U)(Math.min(Math.asin((0, $3XW2M.S)((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin((0, $3XW2M.S)(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin((0, $3XW2M.S)(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        (0, $3XW2M.Q)(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        (0, $3XW2M.Q)(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart: chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = $721b5e3efef367aa$var$getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = $721b5e3efef367aa$var$getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = $721b5e3efef367aa$var$getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first: first, last: last, widest: widest, highest: highest } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = (0, $3XW2M.t)(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align: align, padding: padding }, position: position } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') paddingRight = last.width;
            else if (align === 'end') paddingLeft = first.width;
            else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
    _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        (0, $3XW2M.Q)(this.options.afterFit, [
            this
        ]);
    }
    isHorizontal() {
        const { axis: axis, position: position } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
    isFullSize() {
        return this.options.fullSize;
    }
    _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++)if ((0, $3XW2M.k)(ticks[i].label)) {
            ticks.splice(i, 1);
            ilen--;
            i--;
        }
        this.afterTickToLabelConversion();
    }
    _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) ticks = $721b5e3efef367aa$var$sample(ticks, sampleSize);
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
    _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx: ctx, _longestTextCache: caches } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / $721b5e3efef367aa$var$getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!(0, $3XW2M.k)(label) && !(0, $3XW2M.b)(label)) {
                width = (0, $3XW2M.V)(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if ((0, $3XW2M.b)(label)) for(j = 0, jlen = label.length; j < jlen; ++j){
                nestedLabel = label[j];
                if (!(0, $3XW2M.k)(nestedLabel) && !(0, $3XW2M.b)(nestedLabel)) {
                    width = (0, $3XW2M.V)(ctx, cache.data, cache.gc, width, nestedLabel);
                    height += lineHeight;
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        $721b5e3efef367aa$var$garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths: widths,
            heights: heights
        };
    }
    getLabelForValue(value) {
        return value;
    }
    getPixelForValue(value, index) {
        return NaN;
    }
    getValueForPixel(pixel) {}
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getPixelForDecimal(decimal) {
        if (this._reversePixels) decimal = 1 - decimal;
        const pixel = this._startPixel + decimal * this._length;
        return (0, $3XW2M.W)(this._alignToPixels ? (0, $3XW2M.X)(this.chart, pixel, 0) : pixel);
    }
    getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
    getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
    getBaseValue() {
        const { min: min, max: max } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
    getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = $721b5e3efef367aa$var$createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = $721b5e3efef367aa$var$createScaleContext(this.chart.getContext(), this));
    }
    _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = (0, $3XW2M.t)(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
    _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') return !!display;
        return this.getMatchingVisibleMetas().length > 0;
    }
    _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid: grid, position: position, border: border } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = $721b5e3efef367aa$var$getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return (0, $3XW2M.X)(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            else if ((0, $3XW2M.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            else if ((0, $3XW2M.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = (0, $3XW2M.v)(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = $721b5e3efef367aa$var$getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) continue;
            alignedLineValue = (0, $3XW2M.X)(chart, lineValue, lineWidth);
            if (isHorizontal) tx1 = tx2 = x1 = x2 = alignedLineValue;
            else ty1 = ty2 = y1 = y2 = alignedLineValue;
            items.push({
                tx1: tx1,
                ty1: ty1,
                tx2: tx2,
                ty2: ty2,
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                width: lineWidth,
                color: lineColor,
                borderDash: borderDash,
                borderDashOffset: borderDashOffset,
                tickWidth: tickWidth,
                tickColor: tickColor,
                tickBorderDash: tickBorderDash,
                tickBorderDashOffset: tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
    _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position: position, ticks: optionTicks } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align: align, crossAlign: crossAlign, padding: padding, mirror: mirror } = optionTicks;
        const tl = $721b5e3efef367aa$var$getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -(0, $3XW2M.t)(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            else if ((0, $3XW2M.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            else if ((0, $3XW2M.i)(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') textBaseline = 'top';
            else if (align === 'end') textBaseline = 'bottom';
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = (0, $3XW2M.b)(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    else if (i === 0) tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    else tickTextAlign = 'center';
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = -lineCount * lineHeight + lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    else textOffset = -labelSizes.highest.height + lineHeight / 2;
                } else {
                    if (crossAlign === 'near' || rotation !== 0) textOffset = lineHeight / 2;
                    else if (crossAlign === 'center') textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    else textOffset = labelSizes.highest.height - lineCount * lineHeight;
                }
                if (mirror) textOffset *= -1;
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) x += lineHeight / 2 * Math.sin(rotation);
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = (0, $3XW2M.E)(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) left -= width;
                        else if (i > 0) left -= width / 2;
                        break;
                }
                backdrop = {
                    left: left,
                    top: top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label: label,
                font: font,
                textOffset: textOffset,
                options: {
                    rotation: rotation,
                    color: color,
                    strokeColor: strokeColor,
                    strokeWidth: strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline: textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop: backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position: position, ticks: ticks } = this.options;
        const rotation = -(0, $3XW2M.t)(this.labelRotation);
        if (rotation) return position === 'top' ? 'left' : 'right';
        let align = 'center';
        if (ticks.align === 'start') align = 'left';
        else if (ticks.align === 'end') align = 'right';
        else if (ticks.align === 'inner') align = 'inner';
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position: position, ticks: { crossAlign: crossAlign, mirror: mirror, padding: padding } } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') textAlign = 'right';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') textAlign = 'left';
                else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else textAlign = 'right';
        return {
            textAlign: textAlign,
            x: x
        };
    }
    _computeLabelArea() {
        if (this.options.ticks.mirror) return;
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') return {
            top: 0,
            left: this.left,
            bottom: chart.height,
            right: this.right
        };
        if (position === 'top' || position === 'bottom') return {
            top: this.top,
            left: 0,
            bottom: this.bottom,
            right: chart.width
        };
    }
    drawBackground() {
        const { ctx: ctx, options: { backgroundColor: backgroundColor }, left: left, top: top, width: width, height: height } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) return 0;
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
    drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) return;
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) for(i = 0, ilen = items.length; i < ilen; ++i){
            const item = items[i];
            if (grid.drawOnChartArea) drawLine({
                x: item.x1,
                y: item.y1
            }, {
                x: item.x2,
                y: item.y2
            }, item);
            if (grid.drawTicks) drawLine({
                x: item.tx1,
                y: item.ty1
            }, {
                x: item.tx2,
                y: item.ty2
            }, {
                color: item.tickColor,
                width: item.tickWidth,
                borderDash: item.tickBorderDash,
                borderDashOffset: item.tickBorderDashOffset
            });
        }
    }
    drawBorder() {
        const { chart: chart, ctx: ctx, options: { border: border, grid: grid } } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) return;
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = (0, $3XW2M.X)(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = (0, $3XW2M.X)(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = (0, $3XW2M.X)(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = (0, $3XW2M.X)(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
    drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) return;
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) (0, $3XW2M.Y)(ctx, area);
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            (0, $3XW2M.Z)(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) (0, $3XW2M.$)(ctx);
    }
    drawTitle() {
        const { ctx: ctx, options: { position: position, title: title, reverse: reverse } } = this;
        if (!title.display) return;
        const font = (0, $3XW2M.a0)(title.font);
        const padding = (0, $3XW2M.E)(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || (0, $3XW2M.i)(position)) {
            offset += padding.bottom;
            if ((0, $3XW2M.b)(title.text)) offset += font.lineHeight * (title.text.length - 1);
        } else offset += padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = $721b5e3efef367aa$var$titleArgs(this, offset, position, align);
        (0, $3XW2M.Z)(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: $721b5e3efef367aa$var$titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) return;
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
    _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = (0, $3XW2M.v)(opts.grid && opts.grid.z, -1);
        const bz = (0, $3XW2M.v)(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== $721b5e3efef367aa$export$d60cfc58d3c358b6.prototype.draw) return [
            {
                z: tz,
                draw: (chartArea)=>{
                    this.draw(chartArea);
                }
            }
        ];
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
    getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) result.push(meta);
        }
        return result;
    }
    _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return (0, $3XW2M.a0)(opts.font);
    }
    _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}
class $721b5e3efef367aa$var$TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
    register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if ($721b5e3efef367aa$var$isIChartComponent(proto)) parentScope = this.register(proto);
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) throw new Error('class does not have id: ' + item);
        if (id in items) return scope;
        items[id] = item;
        $721b5e3efef367aa$var$registerDefaults(item, scope, parentScope);
        if (this.override) (0, $3XW2M.d).override(item.id, item.overrides);
        return scope;
    }
    get(id) {
        return this.items[id];
    }
    unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) delete items[id];
        if (scope && id in (0, $3XW2M.d)[scope]) {
            delete (0, $3XW2M.d)[scope][id];
            if (this.override) delete (0, $3XW2M.a3)[id];
        }
    }
}
function $721b5e3efef367aa$var$registerDefaults(item, scope, parentScope) {
    const itemDefaults = (0, $3XW2M.a4)(Object.create(null), [
        parentScope ? (0, $3XW2M.d).get(parentScope) : {},
        (0, $3XW2M.d).get(scope),
        item.defaults
    ]);
    (0, $3XW2M.d).set(scope, itemDefaults);
    if (item.defaultRoutes) $721b5e3efef367aa$var$routeDefaults(scope, item.defaultRoutes);
    if (item.descriptors) (0, $3XW2M.d).describe(scope, item.descriptors);
}
function $721b5e3efef367aa$var$routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        (0, $3XW2M.d).route(sourceScope, sourceName, targetScope, targetName);
    });
}
function $721b5e3efef367aa$var$isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}
class $721b5e3efef367aa$var$Registry {
    constructor(){
        this.controllers = new $721b5e3efef367aa$var$TypedRegistry($721b5e3efef367aa$export$75572ec5c55b4048, 'datasets', true);
        this.elements = new $721b5e3efef367aa$var$TypedRegistry($721b5e3efef367aa$export$db77ccec0bb4ccac, 'elements');
        this.plugins = new $721b5e3efef367aa$var$TypedRegistry(Object, 'plugins');
        this.scales = new $721b5e3efef367aa$var$TypedRegistry($721b5e3efef367aa$export$d60cfc58d3c358b6, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
    add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
    addControllers(...args) {
        this._each('register', args, this.controllers);
    }
    addElements(...args) {
        this._each('register', args, this.elements);
    }
    addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
    addScales(...args) {
        this._each('register', args, this.scales);
    }
    getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
    getElement(id) {
        return this._get(id, this.elements, 'element');
    }
    getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
    getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
    removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
    removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
    removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
    removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
    _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) this._exec(method, reg, arg);
            else (0, $3XW2M.F)(arg, (item)=>{
                const itemReg = typedRegistry || this._getRegistryForType(item);
                this._exec(method, itemReg, item);
            });
        });
    }
    _exec(method, registry, component) {
        const camelMethod = (0, $3XW2M.a5)(method);
        (0, $3XW2M.Q)(component['before' + camelMethod], [], component);
        registry[method](component);
        (0, $3XW2M.Q)(component['after' + camelMethod], [], component);
    }
    _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) return reg;
        }
        return this.plugins;
    }
    _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) throw new Error('"' + id + '" is not a registered ' + type + '.');
        return item;
    }
}
var $721b5e3efef367aa$export$4bb7493d241fd8a5 = /* #__PURE__ */ new $721b5e3efef367aa$var$Registry();
class $721b5e3efef367aa$var$PluginService {
    constructor(){
        this._init = undefined;
    }
    notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) return;
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
    _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if ((0, $3XW2M.Q)(method, params, plugin) === false && args.cancelable) return false;
        }
        return true;
    }
    invalidate() {
        if (!(0, $3XW2M.k)(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
    _descriptors(chart) {
        if (this._cache) return this._cache;
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = (0, $3XW2M.v)(config.options && config.options.plugins, {});
        const plugins = $721b5e3efef367aa$var$allPlugins(config);
        return options === false && !all ? [] : $721b5e3efef367aa$var$createDescriptors(chart, plugins, options, all);
    }
    _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
function $721b5e3efef367aa$var$allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys($721b5e3efef367aa$export$4bb7493d241fd8a5.plugins.items);
    for(let i = 0; i < keys.length; i++)plugins.push($721b5e3efef367aa$export$4bb7493d241fd8a5.getPlugin(keys[i]));
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins: plugins,
        localIds: localIds
    };
}
function $721b5e3efef367aa$var$getOpts(options, all) {
    if (!all && options === false) return null;
    if (options === true) return {};
    return options;
}
function $721b5e3efef367aa$var$createDescriptors(chart, { plugins: plugins, localIds: localIds }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = $721b5e3efef367aa$var$getOpts(options[id], all);
        if (opts === null) continue;
        result.push({
            plugin: plugin,
            options: $721b5e3efef367aa$var$pluginOpts(chart.config, {
                plugin: plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function $721b5e3efef367aa$var$pluginOpts(config, { plugin: plugin, local: local }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) scopes.push(plugin.defaults);
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}
function $721b5e3efef367aa$var$getIndexAxis(type, options) {
    const datasetDefaults = (0, $3XW2M.d).datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function $721b5e3efef367aa$var$getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') axis = indexAxis;
    else if (id === '_value_') axis = indexAxis === 'x' ? 'y' : 'x';
    return axis;
}
function $721b5e3efef367aa$var$getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function $721b5e3efef367aa$var$idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') return id;
}
function $721b5e3efef367aa$var$axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') return 'x';
    if (position === 'left' || position === 'right') return 'y';
}
function $721b5e3efef367aa$var$determineAxis(id, ...scaleOptions) {
    if ($721b5e3efef367aa$var$idMatchesAxis(id)) return id;
    for (const opts of scaleOptions){
        const axis = opts.axis || $721b5e3efef367aa$var$axisFromPosition(opts.position) || id.length > 1 && $721b5e3efef367aa$var$idMatchesAxis(id[0].toLowerCase());
        if (axis) return axis;
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function $721b5e3efef367aa$var$getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) return {
        axis: axis
    };
}
function $721b5e3efef367aa$var$retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) return $721b5e3efef367aa$var$getAxisFromDataset(id, 'x', boundDs[0]) || $721b5e3efef367aa$var$getAxisFromDataset(id, 'y', boundDs[0]);
    }
    return {};
}
function $721b5e3efef367aa$var$mergeScaleConfig(config, options) {
    const chartDefaults = (0, $3XW2M.a3)[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = $721b5e3efef367aa$var$getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!(0, $3XW2M.i)(scaleConf)) return console.error(`Invalid scale configuration for scale: ${id}`);
        if (scaleConf._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        const axis = $721b5e3efef367aa$var$determineAxis(id, scaleConf, $721b5e3efef367aa$var$retrieveAxisFromDatasets(id, config), (0, $3XW2M.d).scales[scaleConf.type]);
        const defaultId = $721b5e3efef367aa$var$getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = (0, $3XW2M.ab)(Object.create(null), [
            {
                axis: axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || $721b5e3efef367aa$var$getIndexAxis(type, options);
        const datasetDefaults = (0, $3XW2M.a3)[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = $721b5e3efef367aa$var$getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            (0, $3XW2M.ab)(scales[id], [
                {
                    axis: axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        (0, $3XW2M.ab)(scale, [
            (0, $3XW2M.d).scales[scale.type],
            (0, $3XW2M.d).scale
        ]);
    });
    return scales;
}
function $721b5e3efef367aa$var$initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = (0, $3XW2M.v)(options.plugins, {});
    options.scales = $721b5e3efef367aa$var$mergeScaleConfig(config, options);
}
function $721b5e3efef367aa$var$initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function $721b5e3efef367aa$var$initConfig(config) {
    config = config || {};
    config.data = $721b5e3efef367aa$var$initData(config.data);
    $721b5e3efef367aa$var$initOptions(config);
    return config;
}
const $721b5e3efef367aa$var$keyCache = new Map();
const $721b5e3efef367aa$var$keysCached = new Set();
function $721b5e3efef367aa$var$cachedKeys(cacheKey, generate) {
    let keys = $721b5e3efef367aa$var$keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        $721b5e3efef367aa$var$keyCache.set(cacheKey, keys);
        $721b5e3efef367aa$var$keysCached.add(keys);
    }
    return keys;
}
const $721b5e3efef367aa$var$addIfFound = (set, obj, key)=>{
    const opts = (0, $3XW2M.f)(obj, key);
    if (opts !== undefined) set.add(opts);
};
class $721b5e3efef367aa$var$Config {
    constructor(config){
        this._config = $721b5e3efef367aa$var$initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = $721b5e3efef367aa$var$initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        $721b5e3efef367aa$var$initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
    datasetScopeKeys(datasetType) {
        return $721b5e3efef367aa$var$cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetAnimationScopeKeys(datasetType, transition) {
        return $721b5e3efef367aa$var$cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
    datasetElementScopeKeys(datasetType, elementType) {
        return $721b5e3efef367aa$var$cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
    pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return $721b5e3efef367aa$var$cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
    _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
    getOptionScopes(mainScope, keyLists, resetCache) {
        const { options: options, type: type } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) return cached;
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>$721b5e3efef367aa$var$addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>$721b5e3efef367aa$var$addIfFound(scopes, options, key));
            keys.forEach((key)=>$721b5e3efef367aa$var$addIfFound(scopes, (0, $3XW2M.a3)[type] || {}, key));
            keys.forEach((key)=>$721b5e3efef367aa$var$addIfFound(scopes, (0, $3XW2M.d), key));
            keys.forEach((key)=>$721b5e3efef367aa$var$addIfFound(scopes, (0, $3XW2M.a6), key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) array.push(Object.create(null));
        if ($721b5e3efef367aa$var$keysCached.has(keyLists)) cache.set(keyLists, array);
        return array;
    }
    chartOptionScopes() {
        const { options: options, type: type } = this;
        return [
            options,
            (0, $3XW2M.a3)[type] || {},
            (0, $3XW2M.d).datasets[type] || {},
            {
                type: type
            },
            (0, $3XW2M.d),
            (0, $3XW2M.a6)
        ];
    }
    resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver: resolver, subPrefixes: subPrefixes } = $721b5e3efef367aa$var$getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if ($721b5e3efef367aa$var$needContext(resolver, names)) {
            result.$shared = false;
            context = (0, $3XW2M.a7)(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = (0, $3XW2M.a8)(resolver, context, subResolver);
        }
        for (const prop of names)result[prop] = options[prop];
        return result;
    }
    createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver: resolver } = $721b5e3efef367aa$var$getResolver(this._resolverCache, scopes, prefixes);
        return (0, $3XW2M.i)(context) ? (0, $3XW2M.a8)(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function $721b5e3efef367aa$var$getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = (0, $3XW2M.a9)(scopes, prefixes);
        cached = {
            resolver: resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const $721b5e3efef367aa$var$hasFunction = (value)=>(0, $3XW2M.i)(value) && Object.getOwnPropertyNames(value).some((key)=>(0, $3XW2M.a7)(value[key]));
function $721b5e3efef367aa$var$needContext(proxy, names) {
    const { isScriptable: isScriptable, isIndexable: isIndexable } = (0, $3XW2M.aa)(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && ((0, $3XW2M.a7)(value) || $721b5e3efef367aa$var$hasFunction(value)) || indexable && (0, $3XW2M.b)(value)) return true;
    }
    return false;
}
var $721b5e3efef367aa$var$version = "4.5.1";
const $721b5e3efef367aa$var$KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function $721b5e3efef367aa$var$positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || $721b5e3efef367aa$var$KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function $721b5e3efef367aa$var$compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function $721b5e3efef367aa$var$onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    (0, $3XW2M.Q)(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function $721b5e3efef367aa$var$onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    (0, $3XW2M.Q)(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
function $721b5e3efef367aa$var$getCanvas(item) {
    if ((0, $3XW2M.M)() && typeof item === 'string') item = document.getElementById(item);
    else if (item && item.length) item = item[0];
    if (item && item.canvas) item = item.canvas;
    return item;
}
const $721b5e3efef367aa$var$instances = {};
const $721b5e3efef367aa$var$getChart = (key)=>{
    const canvas = $721b5e3efef367aa$var$getCanvas(key);
    return Object.values($721b5e3efef367aa$var$instances).filter((c)=>c.canvas === canvas).pop();
};
function $721b5e3efef367aa$var$moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) obj[intKey + move] = value;
        }
    }
}
function $721b5e3efef367aa$var$determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') return null;
    if (isClick) return lastEvent;
    return e;
}
class $721b5e3efef367aa$export$acaa6426d77a227e {
    static defaults = (0, $3XW2M.d);
    static instances = $721b5e3efef367aa$var$instances;
    static overrides = (0, $3XW2M.a3);
    static registry = $721b5e3efef367aa$export$4bb7493d241fd8a5;
    static version = $721b5e3efef367aa$var$version;
    static getChart = $721b5e3efef367aa$var$getChart;
    static register(...items) {
        $721b5e3efef367aa$export$4bb7493d241fd8a5.add(...items);
        $721b5e3efef367aa$var$invalidatePlugins();
    }
    static unregister(...items) {
        $721b5e3efef367aa$export$4bb7493d241fd8a5.remove(...items);
        $721b5e3efef367aa$var$invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new $721b5e3efef367aa$var$Config(userConfig);
        const initialCanvas = $721b5e3efef367aa$var$getCanvas(item);
        const existingChart = $721b5e3efef367aa$var$getChart(initialCanvas);
        if (existingChart) throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || $721b5e3efef367aa$export$72cd9e67b1b784f9(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = (0, $3XW2M.ac)();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
        this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new $721b5e3efef367aa$var$PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = (0, $3XW2M.ad)((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        $721b5e3efef367aa$var$instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        $721b5e3efef367aa$export$a424a0aa8f687495.listen(this, 'complete', $721b5e3efef367aa$var$onAnimationsComplete);
        $721b5e3efef367aa$export$a424a0aa8f687495.listen(this, 'progress', $721b5e3efef367aa$var$onAnimationProgress);
        this._initialize();
        if (this.attached) this.update();
    }
    get aspectRatio() {
        const { options: { aspectRatio: aspectRatio, maintainAspectRatio: maintainAspectRatio }, width: width, height: height, _aspectRatio: _aspectRatio } = this;
        if (!(0, $3XW2M.k)(aspectRatio)) return aspectRatio;
        if (maintainAspectRatio && _aspectRatio) return _aspectRatio;
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return $721b5e3efef367aa$export$4bb7493d241fd8a5;
    }
    _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) this.resize();
        else (0, $3XW2M.ae)(this, this.options.devicePixelRatio);
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        (0, $3XW2M.af)(this.canvas, this.ctx);
        return this;
    }
    stop() {
        $721b5e3efef367aa$export$a424a0aa8f687495.stop(this);
        return this;
    }
    resize(width, height) {
        if (!$721b5e3efef367aa$export$a424a0aa8f687495.running(this)) this._resize(width, height);
        else this._resizeBeforeDraw = {
            width: width,
            height: height
        };
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!(0, $3XW2M.ae)(this, newRatio, true)) return;
        this.notifyPlugins('resize', {
            size: newSize
        });
        (0, $3XW2M.Q)(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) this.render();
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        (0, $3XW2M.F)(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
    buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) items = items.concat(Object.keys(scaleOpts).map((id)=>{
            const scaleOptions = scaleOpts[id];
            const axis = $721b5e3efef367aa$var$determineAxis(id, scaleOptions);
            const isRadial = axis === 'r';
            const isHorizontal = axis === 'x';
            return {
                options: scaleOptions,
                dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
            };
        }));
        (0, $3XW2M.F)(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = $721b5e3efef367aa$var$determineAxis(id, scaleOptions);
            const scaleType = (0, $3XW2M.v)(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || $721b5e3efef367aa$var$positionIsHorizontal(scaleOptions.position, axis) !== $721b5e3efef367aa$var$positionIsHorizontal(item.dposition)) scaleOptions.position = item.dposition;
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) scale = scales[id];
            else {
                const scaleClass = $721b5e3efef367aa$export$4bb7493d241fd8a5.getScale(scaleType);
                scale = new scaleClass({
                    id: id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        (0, $3XW2M.F)(updated, (hasUpdated, id)=>{
            if (!hasUpdated) delete scales[id];
        });
        (0, $3XW2M.F)(scales, (scale)=>{
            $721b5e3efef367aa$export$1ecca0613f5e56d2.configure(this, scale, scale.options);
            $721b5e3efef367aa$export$1ecca0613f5e56d2.addBox(this, scale);
        });
    }
    _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i)this._destroyDatasetMeta(i);
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort($721b5e3efef367aa$var$compare2Level('order', 'index'));
    }
    _removeUnreferencedMetasets() {
        const { _metasets: metasets, data: { datasets: datasets } } = this;
        if (metasets.length > datasets.length) delete this._stacks;
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) this._destroyDatasetMeta(index);
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || $721b5e3efef367aa$var$getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = $721b5e3efef367aa$export$4bb7493d241fd8a5.getController(type);
                const { datasetElementType: datasetElementType, dataElementType: dataElementType } = (0, $3XW2M.d).datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: $721b5e3efef367aa$export$4bb7493d241fd8a5.getElement(dataElementType),
                    datasetElementType: datasetElementType && $721b5e3efef367aa$export$4bb7493d241fd8a5.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
    _resetElements() {
        (0, $3XW2M.F)(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
    reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller: controller } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) (0, $3XW2M.F)(newControllers, (controller)=>{
            controller.reset();
        });
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode: mode
        });
        this._layers.sort($721b5e3efef367aa$var$compare2Level('z', '_idx'));
        const { _active: _active, _lastEvent: _lastEvent } = this;
        if (_lastEvent) this._eventHandler(_lastEvent, true);
        else if (_active.length) this._updateHoverStyles(_active, _active, true);
        this.render();
    }
    _updateScales() {
        (0, $3XW2M.F)(this.scales, (scale)=>{
            $721b5e3efef367aa$export$1ecca0613f5e56d2.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
    _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!(0, $3XW2M.ag)(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
    _updateHiddenIndices() {
        const { _hiddenIndices: _hiddenIndices } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method: method, start: start, count: count } of changes){
            const move = method === '_removeElements' ? -count : count;
            $721b5e3efef367aa$var$moveNumericKeys(_hiddenIndices, start, move);
        }
    }
    _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) return;
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!(0, $3XW2M.ag)(changeSet, makeSet(i))) return;
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
    _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) return;
        $721b5e3efef367aa$export$1ecca0613f5e56d2.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        (0, $3XW2M.F)(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') return;
            if (box.configure) box.configure();
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
    _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode: mode,
            cancelable: true
        }) === false) return;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this.getDatasetMeta(i).controller.configure();
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._updateDataset(i, (0, $3XW2M.a7)(mode) ? mode({
            datasetIndex: i
        }) : mode);
        this.notifyPlugins('afterDatasetsUpdate', {
            mode: mode
        });
    }
    _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta: meta,
            index: index,
            mode: mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) return;
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) return;
        if ($721b5e3efef367aa$export$a424a0aa8f687495.has(this)) {
            if (this.attached && !$721b5e3efef367aa$export$a424a0aa8f687495.running(this)) $721b5e3efef367aa$export$a424a0aa8f687495.start(this);
        } else {
            this.draw();
            $721b5e3efef367aa$var$onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width: width, height: height } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) return;
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) return;
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i)layers[i].draw(this.chartArea);
        this._drawDatasets();
        for(; i < layers.length; ++i)layers[i].draw(this.chartArea);
        this.notifyPlugins('afterDraw');
    }
    _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) result.push(meta);
        }
        return result;
    }
    getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
    _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) return;
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i)this._drawDataset(metasets[i]);
        this.notifyPlugins('afterDatasetsDraw');
    }
    _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta: meta,
            index: meta.index,
            cancelable: true
        };
        const clip = (0, $3XW2M.ah)(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) return;
        if (clip) (0, $3XW2M.Y)(ctx, clip);
        meta.controller.draw();
        if (clip) (0, $3XW2M.$)(ctx);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
    isPointInArea(point) {
        return (0, $3XW2M.C)(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = $721b5e3efef367aa$export$a13296960cae0384.modes[mode];
        if (typeof method === 'function') return method(this, e, options, useFinalPosition);
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = (0, $3XW2M.j)(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) return false;
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
    _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if ((0, $3XW2M.h)(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible: visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
    _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) meta.controller._destroy();
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        $721b5e3efef367aa$export$a424a0aa8f687495.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i)this._destroyDatasetMeta(i);
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas: canvas, ctx: ctx } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            (0, $3XW2M.af)(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete $721b5e3efef367aa$var$instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
    bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) this.bindResponsiveEvents();
        else this.attached = true;
    }
    bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        (0, $3XW2M.F)(this.options.events, (type)=>_add(type, listener));
    }
    bindResponsiveEvents() {
        if (!this._responsiveListeners) this._responsiveListeners = {};
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) this.resize(width, height);
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) attached();
        else detached();
    }
    unbindEvents() {
        (0, $3XW2M.F)(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        (0, $3XW2M.F)(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('No dataset found at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $3XW2M.ai)(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
    notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
    isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
    _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        if (activated.length && hoverOptions.mode) this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
    _eventHandler(e, replay) {
        const args = {
            event: e,
            replay: replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) return;
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) this.render();
        return this;
    }
    _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [], options: options } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = (0, $3XW2M.aj)(e);
        const lastEvent = $721b5e3efef367aa$var$determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            (0, $3XW2M.Q)(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) (0, $3XW2M.Q)(options.onClick, [
                e,
                active,
                this
            ], this);
        }
        const changed = !(0, $3XW2M.ai)(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
    _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive;
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function $721b5e3efef367aa$var$invalidatePlugins() {
    return (0, $3XW2M.F)($721b5e3efef367aa$export$acaa6426d77a227e.instances, (chart)=>chart._plugins.invalidate());
}
function $721b5e3efef367aa$var$clipSelf(ctx, element, endAngle) {
    const { startAngle: startAngle, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, (0, $3XW2M.al)(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, (0, $3XW2M.al)(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * (0, $3XW2M.al)(startAngle - endAngle));
        if (borderJoinStyle === 'round') ctx.arc(x, y, clipWidth, endAngle - (0, $3XW2M.P) / 2, startAngle + (0, $3XW2M.P) / 2, true);
        else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + (0, $3XW2M.P) / 2) + x;
            const endY = -r * Math.sin(endAngle + (0, $3XW2M.P) / 2) + y;
            const startX = r * Math.cos(startAngle + (0, $3XW2M.P) / 2) + x;
            const startY = r * Math.sin(startAngle + (0, $3XW2M.P) / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function $721b5e3efef367aa$var$clipArc(ctx, element, endAngle) {
    const { startAngle: startAngle, pixelMargin: pixelMargin, x: x, y: y, outerRadius: outerRadius, innerRadius: innerRadius } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else ctx.arc(x, y, pixelMargin, endAngle + (0, $3XW2M.H), startAngle - (0, $3XW2M.H));
    ctx.closePath();
    ctx.clip();
}
function $721b5e3efef367aa$var$toRadiusCorners(value) {
    return (0, $3XW2M.am)(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function $721b5e3efef367aa$var$parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = $721b5e3efef367aa$var$toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return (0, $3XW2M.S)(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: (0, $3XW2M.S)(o.innerStart, 0, innerLimit),
        innerEnd: (0, $3XW2M.S)(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function $721b5e3efef367aa$var$rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function $721b5e3efef367aa$var$pathArc(ctx, element, offset, spacing, end, circular) {
    const { x: x, y: y, startAngle: start, pixelMargin: pixelMargin, innerRadius: innerR } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / (0, $3XW2M.P)) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart: outerStart, outerEnd: outerEnd, innerStart: innerStart, innerEnd: innerEnd } = $721b5e3efef367aa$var$parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = $721b5e3efef367aa$var$rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + (0, $3XW2M.H));
        }
        // The line from point 3 to point 4
        const p4 = $721b5e3efef367aa$var$rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = $721b5e3efef367aa$var$rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + (0, $3XW2M.H), innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = $721b5e3efef367aa$var$rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - (0, $3XW2M.H));
        }
        // The line from point 7 to point 8
        const p8 = $721b5e3efef367aa$var$rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = $721b5e3efef367aa$var$rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - (0, $3XW2M.H), outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function $721b5e3efef367aa$var$drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        $721b5e3efef367aa$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.fill();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $3XW2M.T) || (0, $3XW2M.T));
    }
    $721b5e3efef367aa$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function $721b5e3efef367aa$var$drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles: fullCircles, startAngle: startAngle, circumference: circumference, options: options } = element;
    const { borderWidth: borderWidth, borderJoinStyle: borderJoinStyle, borderDash: borderDash, borderDashOffset: borderDashOffset, borderRadius: borderRadius } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) return;
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        $721b5e3efef367aa$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i)ctx.stroke();
        if (!isNaN(circumference)) endAngle = startAngle + (circumference % (0, $3XW2M.T) || (0, $3XW2M.T));
    }
    if (inner) $721b5e3efef367aa$var$clipArc(ctx, element, endAngle);
    if (options.selfJoin && endAngle - startAngle >= (0, $3XW2M.P) && borderRadius === 0 && borderJoinStyle !== 'miter') $721b5e3efef367aa$var$clipSelf(ctx, element, endAngle);
    if (!fullCircles) {
        $721b5e3efef367aa$var$pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class $721b5e3efef367aa$export$d48203c759d6a1fc extends $721b5e3efef367aa$export$db77ccec0bb4ccac {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle: angle, distance: distance } = (0, $3XW2M.D)(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius, circumference: circumference } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = (0, $3XW2M.v)(circumference, endAngle - startAngle);
        const nonZeroBetween = (0, $3XW2M.p)(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= (0, $3XW2M.T) || nonZeroBetween;
        const withinRadius = (0, $3XW2M.ak)(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset: offset, spacing: spacing } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options: options, circumference: circumference } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > (0, $3XW2M.T) ? Math.floor(circumference / (0, $3XW2M.T)) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) return;
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min((0, $3XW2M.P), circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        $721b5e3efef367aa$var$drawArc(ctx, this, radiusOffset, spacing, circular);
        $721b5e3efef367aa$var$drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}
function $721b5e3efef367aa$var$setStyle(ctx, options, style = options) {
    ctx.lineCap = (0, $3XW2M.v)(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash((0, $3XW2M.v)(style.borderDash, options.borderDash));
    ctx.lineDashOffset = (0, $3XW2M.v)(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = (0, $3XW2M.v)(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = (0, $3XW2M.v)(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = (0, $3XW2M.v)(style.borderColor, options.borderColor);
}
function $721b5e3efef367aa$var$lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
function $721b5e3efef367aa$var$getLineMethod(options) {
    if (options.stepped) return 0, $3XW2M.at;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $3XW2M.au;
    return $721b5e3efef367aa$var$lineTo;
}
function $721b5e3efef367aa$var$pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
    const { start: segmentStart, end: segmentEnd } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count: count,
        start: start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
function $721b5e3efef367aa$var$pathSegment(ctx, line, segment, params) {
    const { points: points, options: options } = line;
    const { count: count, start: start, loop: loop, ilen: ilen } = $721b5e3efef367aa$var$pathVars(points, segment, params);
    const lineMethod = $721b5e3efef367aa$var$getLineMethod(options);
    let { move: move = true, reverse: reverse } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) continue;
        else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else lineMethod(ctx, prev, point, reverse, options.stepped);
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
function $721b5e3efef367aa$var$fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count: count, start: start, ilen: ilen } = $721b5e3efef367aa$var$pathVars(points, segment, params);
    const { move: move = true, reverse: reverse } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) continue;
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) minY = y;
            else if (y > maxY) maxY = y;
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
function $721b5e3efef367aa$var$_getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? $721b5e3efef367aa$var$fastPathSegment : $721b5e3efef367aa$var$pathSegment;
}
function $721b5e3efef367aa$var$_getInterpolationMethod(options) {
    if (options.stepped) return 0, $3XW2M.aq;
    if (options.tension || options.cubicInterpolationMode === 'monotone') return 0, $3XW2M.ar;
    return 0, $3XW2M.as;
}
function $721b5e3efef367aa$var$strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) path.closePath();
    }
    $721b5e3efef367aa$var$setStyle(ctx, line.options);
    ctx.stroke(path);
}
function $721b5e3efef367aa$var$strokePathDirect(ctx, line, start, count) {
    const { segments: segments, options: options } = line;
    const segmentMethod = $721b5e3efef367aa$var$_getSegmentMethod(line);
    for (const segment of segments){
        $721b5e3efef367aa$var$setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start: start,
            end: start + count - 1
        })) ctx.closePath();
        ctx.stroke();
    }
}
const $721b5e3efef367aa$var$usePath2D = typeof Path2D === 'function';
function $721b5e3efef367aa$var$draw(ctx, line, start, count) {
    if ($721b5e3efef367aa$var$usePath2D && !line.options.segment) $721b5e3efef367aa$var$strokePathWithCache(ctx, line, start, count);
    else $721b5e3efef367aa$var$strokePathDirect(ctx, line, start, count);
}
class $721b5e3efef367aa$export$55e463fa7bcd3469 extends $721b5e3efef367aa$export$db77ccec0bb4ccac {
    static id = 'line';
    static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            (0, $3XW2M.an)(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = (0, $3XW2M.ao)(this, this.options.segment));
    }
    first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
    last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
    interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = (0, $3XW2M.ap)(this, {
            property: property,
            start: value,
            end: value
        });
        if (!segments.length) return;
        const result = [];
        const _interpolate = $721b5e3efef367aa$var$_getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start: start, end: end } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
    pathSegment(ctx, segment, params) {
        const segmentMethod = $721b5e3efef367aa$var$_getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
    path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = $721b5e3efef367aa$var$_getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments)loop &= segmentMethod(ctx, this, segment, {
            start: start,
            end: start + count - 1
        });
        return !!loop;
    }
    draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            $721b5e3efef367aa$var$draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}
function $721b5e3efef367aa$var$inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class $721b5e3efef367aa$export$bd159b522b230b7a extends $721b5e3efef367aa$export$db77ccec0bb4ccac {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return $721b5e3efef367aa$var$inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $721b5e3efef367aa$var$inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x: x,
            y: y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !(0, $3XW2M.C)(this, area, this.size(options) / 2)) return;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        (0, $3XW2M.av)(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}
function $721b5e3efef367aa$var$getBarBounds(bar, useFinalPosition) {
    const { x: x, y: y, base: base, width: width, height: height } = bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left: left,
        top: top,
        right: right,
        bottom: bottom
    };
}
function $721b5e3efef367aa$var$skipOrLimit(skip, value, min, max) {
    return skip ? 0 : (0, $3XW2M.S)(value, min, max);
}
function $721b5e3efef367aa$var$parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = (0, $3XW2M.ax)(value);
    return {
        t: $721b5e3efef367aa$var$skipOrLimit(skip.top, o.top, 0, maxH),
        r: $721b5e3efef367aa$var$skipOrLimit(skip.right, o.right, 0, maxW),
        b: $721b5e3efef367aa$var$skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: $721b5e3efef367aa$var$skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function $721b5e3efef367aa$var$parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius: enableBorderRadius } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = (0, $3XW2M.ay)(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || (0, $3XW2M.i)(value);
    return {
        topLeft: $721b5e3efef367aa$var$skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: $721b5e3efef367aa$var$skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: $721b5e3efef367aa$var$skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: $721b5e3efef367aa$var$skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function $721b5e3efef367aa$var$boundingRects(bar) {
    const bounds = $721b5e3efef367aa$var$getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = $721b5e3efef367aa$var$parseBorderWidth(bar, width / 2, height / 2);
    const radius = $721b5e3efef367aa$var$parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius: radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function $721b5e3efef367aa$var$inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && $721b5e3efef367aa$var$getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || (0, $3XW2M.ak)(x, bounds.left, bounds.right)) && (skipY || (0, $3XW2M.ak)(y, bounds.top, bounds.bottom));
}
function $721b5e3efef367aa$var$hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
function $721b5e3efef367aa$var$addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function $721b5e3efef367aa$var$inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class $721b5e3efef367aa$export$a16ed71bf4b07672 extends $721b5e3efef367aa$export$db77ccec0bb4ccac {
    static id = 'bar';
    static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) Object.assign(this, cfg);
    }
    draw(ctx) {
        const { inflateAmount: inflateAmount, options: { borderColor: borderColor, backgroundColor: backgroundColor } } = this;
        const { inner: inner, outer: outer } = $721b5e3efef367aa$var$boundingRects(this);
        const addRectPath = $721b5e3efef367aa$var$hasRadius(outer.radius) ? (0, $3XW2M.aw) : $721b5e3efef367aa$var$addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, $721b5e3efef367aa$var$inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, $721b5e3efef367aa$var$inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, $721b5e3efef367aa$var$inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return $721b5e3efef367aa$var$inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return $721b5e3efef367aa$var$inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return $721b5e3efef367aa$var$inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x: x, y: y, base: base, horizontal: horizontal } = this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}
var $721b5e3efef367aa$export$7a5d735b2ab6389d = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcElement: $721b5e3efef367aa$export$d48203c759d6a1fc,
    BarElement: $721b5e3efef367aa$export$a16ed71bf4b07672,
    LineElement: $721b5e3efef367aa$export$55e463fa7bcd3469,
    PointElement: $721b5e3efef367aa$export$bd159b522b230b7a
});
const $721b5e3efef367aa$var$BORDER_COLORS = [
    'rgb(54, 162, 235)',
    'rgb(255, 99, 132)',
    'rgb(255, 159, 64)',
    'rgb(255, 205, 86)',
    'rgb(75, 192, 192)',
    'rgb(153, 102, 255)',
    'rgb(201, 203, 207)' // grey
];
// Border colors with 50% transparency
const $721b5e3efef367aa$var$BACKGROUND_COLORS = /* #__PURE__ */ $721b5e3efef367aa$var$BORDER_COLORS.map((color)=>color.replace('rgb(', 'rgba(').replace(')', ', 0.5)'));
function $721b5e3efef367aa$var$getBorderColor(i) {
    return $721b5e3efef367aa$var$BORDER_COLORS[i % $721b5e3efef367aa$var$BORDER_COLORS.length];
}
function $721b5e3efef367aa$var$getBackgroundColor(i) {
    return $721b5e3efef367aa$var$BACKGROUND_COLORS[i % $721b5e3efef367aa$var$BACKGROUND_COLORS.length];
}
function $721b5e3efef367aa$var$colorizeDefaultDataset(dataset, i) {
    dataset.borderColor = $721b5e3efef367aa$var$getBorderColor(i);
    dataset.backgroundColor = $721b5e3efef367aa$var$getBackgroundColor(i);
    return ++i;
}
function $721b5e3efef367aa$var$colorizeDoughnutDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$721b5e3efef367aa$var$getBorderColor(i++));
    return i;
}
function $721b5e3efef367aa$var$colorizePolarAreaDataset(dataset, i) {
    dataset.backgroundColor = dataset.data.map(()=>$721b5e3efef367aa$var$getBackgroundColor(i++));
    return i;
}
function $721b5e3efef367aa$var$getColorizer(chart) {
    let i = 0;
    return (dataset, datasetIndex)=>{
        const controller = chart.getDatasetMeta(datasetIndex).controller;
        if (controller instanceof $721b5e3efef367aa$export$e04603e7d8b77172) i = $721b5e3efef367aa$var$colorizeDoughnutDataset(dataset, i);
        else if (controller instanceof $721b5e3efef367aa$export$2a270b3a0d973c85) i = $721b5e3efef367aa$var$colorizePolarAreaDataset(dataset, i);
        else if (controller) i = $721b5e3efef367aa$var$colorizeDefaultDataset(dataset, i);
    };
}
function $721b5e3efef367aa$var$containsColorsDefinitions(descriptors) {
    let k;
    for(k in descriptors){
        if (descriptors[k].borderColor || descriptors[k].backgroundColor) return true;
    }
    return false;
}
function $721b5e3efef367aa$var$containsColorsDefinition(descriptor) {
    return descriptor && (descriptor.borderColor || descriptor.backgroundColor);
}
function $721b5e3efef367aa$var$containsDefaultColorsDefenitions() {
    return (0, $3XW2M.d).borderColor !== 'rgba(0,0,0,0.1)' || (0, $3XW2M.d).backgroundColor !== 'rgba(0,0,0,0.1)';
}
var $721b5e3efef367aa$export$c537fa0d021d010b = {
    id: 'colors',
    defaults: {
        enabled: true,
        forceOverride: false
    },
    beforeLayout (chart, _args, options) {
        if (!options.enabled) return;
        const { data: { datasets: datasets }, options: chartOptions } = chart.config;
        const { elements: elements } = chartOptions;
        const containsColorDefenition = $721b5e3efef367aa$var$containsColorsDefinitions(datasets) || $721b5e3efef367aa$var$containsColorsDefinition(chartOptions) || elements && $721b5e3efef367aa$var$containsColorsDefinitions(elements) || $721b5e3efef367aa$var$containsDefaultColorsDefenitions();
        if (!options.forceOverride && containsColorDefenition) return;
        const colorizer = $721b5e3efef367aa$var$getColorizer(chart);
        datasets.forEach(colorizer);
    }
};
function $721b5e3efef367aa$var$lttbDecimation(data, start, count, availableWidth, options) {
    const samples = options.samples || availableWidth;
    if (samples >= count) return data.slice(start, start + count);
    const decimated = [];
    const bucketWidth = (count - 2) / (samples - 2);
    let sampledIndex = 0;
    const endIndex = start + count - 1;
    let a = start;
    let i, maxAreaPoint, maxArea, area, nextA;
    decimated[sampledIndex++] = data[a];
    for(i = 0; i < samples - 2; i++){
        let avgX = 0;
        let avgY = 0;
        let j;
        const avgRangeStart = Math.floor((i + 1) * bucketWidth) + 1 + start;
        const avgRangeEnd = Math.min(Math.floor((i + 2) * bucketWidth) + 1, count) + start;
        const avgRangeLength = avgRangeEnd - avgRangeStart;
        for(j = avgRangeStart; j < avgRangeEnd; j++){
            avgX += data[j].x;
            avgY += data[j].y;
        }
        avgX /= avgRangeLength;
        avgY /= avgRangeLength;
        const rangeOffs = Math.floor(i * bucketWidth) + 1 + start;
        const rangeTo = Math.min(Math.floor((i + 1) * bucketWidth) + 1, count) + start;
        const { x: pointAx, y: pointAy } = data[a];
        maxArea = area = -1;
        for(j = rangeOffs; j < rangeTo; j++){
            area = 0.5 * Math.abs((pointAx - avgX) * (data[j].y - pointAy) - (pointAx - data[j].x) * (avgY - pointAy));
            if (area > maxArea) {
                maxArea = area;
                maxAreaPoint = data[j];
                nextA = j;
            }
        }
        decimated[sampledIndex++] = maxAreaPoint;
        a = nextA;
    }
    decimated[sampledIndex++] = data[endIndex];
    return decimated;
}
function $721b5e3efef367aa$var$minMaxDecimation(data, start, count, availableWidth) {
    let avgX = 0;
    let countX = 0;
    let i, point, x, y, prevX, minIndex, maxIndex, startIndex, minY, maxY;
    const decimated = [];
    const endIndex = start + count - 1;
    const xMin = data[start].x;
    const xMax = data[endIndex].x;
    const dx = xMax - xMin;
    for(i = start; i < start + count; ++i){
        point = data[i];
        x = (point.x - xMin) / dx * availableWidth;
        y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
                minIndex = i;
            } else if (y > maxY) {
                maxY = y;
                maxIndex = i;
            }
            avgX = (countX * avgX + point.x) / ++countX;
        } else {
            const lastIndex = i - 1;
            if (!(0, $3XW2M.k)(minIndex) && !(0, $3XW2M.k)(maxIndex)) {
                const intermediateIndex1 = Math.min(minIndex, maxIndex);
                const intermediateIndex2 = Math.max(minIndex, maxIndex);
                if (intermediateIndex1 !== startIndex && intermediateIndex1 !== lastIndex) decimated.push({
                    ...data[intermediateIndex1],
                    x: avgX
                });
                if (intermediateIndex2 !== startIndex && intermediateIndex2 !== lastIndex) decimated.push({
                    ...data[intermediateIndex2],
                    x: avgX
                });
            }
            if (i > 0 && lastIndex !== startIndex) decimated.push(data[lastIndex]);
            decimated.push(point);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
            minIndex = maxIndex = startIndex = i;
        }
    }
    return decimated;
}
function $721b5e3efef367aa$var$cleanDecimatedDataset(dataset) {
    if (dataset._decimated) {
        const data = dataset._data;
        delete dataset._decimated;
        delete dataset._data;
        Object.defineProperty(dataset, 'data', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: data
        });
    }
}
function $721b5e3efef367aa$var$cleanDecimatedData(chart) {
    chart.data.datasets.forEach((dataset)=>{
        $721b5e3efef367aa$var$cleanDecimatedDataset(dataset);
    });
}
function $721b5e3efef367aa$var$getStartAndCountOfVisiblePointsSimplified(meta, points) {
    const pointCount = points.length;
    let start = 0;
    let count;
    const { iScale: iScale } = meta;
    const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
    if (minDefined) start = (0, $3XW2M.S)((0, $3XW2M.B)(points, iScale.axis, min).lo, 0, pointCount - 1);
    if (maxDefined) count = (0, $3XW2M.S)((0, $3XW2M.B)(points, iScale.axis, max).hi + 1, start, pointCount) - start;
    else count = pointCount - start;
    return {
        start: start,
        count: count
    };
}
var $721b5e3efef367aa$export$be17f937e9aa7533 = {
    id: 'decimation',
    defaults: {
        algorithm: 'min-max',
        enabled: false
    },
    beforeElementsUpdate: (chart, args, options)=>{
        if (!options.enabled) {
            $721b5e3efef367aa$var$cleanDecimatedData(chart);
            return;
        }
        const availableWidth = chart.width;
        chart.data.datasets.forEach((dataset, datasetIndex)=>{
            const { _data: _data, indexAxis: indexAxis } = dataset;
            const meta = chart.getDatasetMeta(datasetIndex);
            const data = _data || dataset.data;
            if ((0, $3XW2M.a)([
                indexAxis,
                chart.options.indexAxis
            ]) === 'y') return;
            if (!meta.controller.supportsDecimation) return;
            const xAxis = chart.scales[meta.xAxisID];
            if (xAxis.type !== 'linear' && xAxis.type !== 'time') return;
            if (chart.options.parsing) return;
            let { start: start, count: count } = $721b5e3efef367aa$var$getStartAndCountOfVisiblePointsSimplified(meta, data);
            const threshold = options.threshold || 4 * availableWidth;
            if (count <= threshold) {
                $721b5e3efef367aa$var$cleanDecimatedDataset(dataset);
                return;
            }
            if ((0, $3XW2M.k)(_data)) {
                dataset._data = data;
                delete dataset.data;
                Object.defineProperty(dataset, 'data', {
                    configurable: true,
                    enumerable: true,
                    get: function() {
                        return this._decimated;
                    },
                    set: function(d) {
                        this._data = d;
                    }
                });
            }
            let decimated;
            switch(options.algorithm){
                case 'lttb':
                    decimated = $721b5e3efef367aa$var$lttbDecimation(data, start, count, availableWidth, options);
                    break;
                case 'min-max':
                    decimated = $721b5e3efef367aa$var$minMaxDecimation(data, start, count, availableWidth);
                    break;
                default:
                    throw new Error(`Unsupported decimation algorithm '${options.algorithm}'`);
            }
            dataset._decimated = decimated;
        });
    },
    destroy (chart) {
        $721b5e3efef367aa$var$cleanDecimatedData(chart);
    }
};
function $721b5e3efef367aa$var$_segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start: start, end: end } = segment;
        end = $721b5e3efef367aa$var$_findSegmentEnd(start, end, points);
        const bounds = $721b5e3efef367aa$var$_getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = (0, $3XW2M.ap)(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = $721b5e3efef367aa$var$_getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = (0, $3XW2M.az)(segment, points, subBounds);
            for (const fillSource of fillSources)parts.push({
                source: fillSource,
                target: tgt,
                start: {
                    [property]: $721b5e3efef367aa$var$_getEdge(bounds, subBounds, 'start', Math.max)
                },
                end: {
                    [property]: $721b5e3efef367aa$var$_getEdge(bounds, subBounds, 'end', Math.min)
                }
            });
        }
    }
    return parts;
}
function $721b5e3efef367aa$var$_getBounds(property, first, last, loop) {
    if (loop) return;
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = (0, $3XW2M.al)(start);
        end = (0, $3XW2M.al)(end);
    }
    return {
        property: property,
        start: start,
        end: end
    };
}
function $721b5e3efef367aa$var$_pointsFromSegments(boundary, line) {
    const { x: x = null, y: y = null } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start: start, end: end })=>{
        end = $721b5e3efef367aa$var$_findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y: y
            });
            points.push({
                x: last.x,
                y: y
            });
        } else if (x !== null) {
            points.push({
                x: x,
                y: first.y
            });
            points.push({
                x: x,
                y: last.y
            });
        }
    });
    return points;
}
function $721b5e3efef367aa$var$_findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) break;
    }
    return end;
}
function $721b5e3efef367aa$var$_getEdge(a, b, prop, fn) {
    if (a && b) return fn(a[prop], b[prop]);
    return a ? a[prop] : b ? b[prop] : 0;
}
function $721b5e3efef367aa$var$_createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if ((0, $3XW2M.b)(boundary)) {
        _loop = true;
        points = boundary;
    } else points = $721b5e3efef367aa$var$_pointsFromSegments(boundary, line);
    return points.length ? new $721b5e3efef367aa$export$55e463fa7bcd3469({
        points: points,
        options: {
            tension: 0
        },
        _loop: _loop,
        _fullLoop: _loop
    }) : null;
}
function $721b5e3efef367aa$var$_shouldApplyFill(source) {
    return source && source.fill !== false;
}
function $721b5e3efef367aa$var$_resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) return fill;
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!(0, $3XW2M.g)(fill)) return fill;
        target = sources[fill];
        if (!target) return false;
        if (target.visible) return fill;
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
function $721b5e3efef367aa$var$_decodeFill(line, index, count) {
    const fill = $721b5e3efef367aa$var$parseFillOption(line);
    if ((0, $3XW2M.i)(fill)) return isNaN(fill.value) ? false : fill;
    let target = parseFloat(fill);
    if ((0, $3XW2M.g)(target) && Math.floor(target) === target) return $721b5e3efef367aa$var$decodeTargetIndex(fill[0], index, target, count);
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function $721b5e3efef367aa$var$decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') target = index + target;
    if (target === index || target < 0 || target >= count) return false;
    return target;
}
function $721b5e3efef367aa$var$_getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') pixel = scale.bottom;
    else if (fill === 'end') pixel = scale.top;
    else if ((0, $3XW2M.i)(fill)) pixel = scale.getPixelForValue(fill.value);
    else if (scale.getBasePixel) pixel = scale.getBasePixel();
    return pixel;
}
function $721b5e3efef367aa$var$_getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') value = startValue;
    else if (fill === 'end') value = scale.options.reverse ? scale.min : scale.max;
    else if ((0, $3XW2M.i)(fill)) value = fill.value;
    else value = scale.getBaseValue();
    return value;
}
function $721b5e3efef367aa$var$parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = (0, $3XW2M.v)(fillOption && fillOption.target, fillOption);
    if (fill === undefined) fill = !!options.backgroundColor;
    if (fill === false || fill === null) return false;
    if (fill === true) return 'origin';
    return fill;
}
function $721b5e3efef367aa$var$_buildStackLine(source) {
    const { scale: scale, index: index, line: line } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = $721b5e3efef367aa$var$getLinesBelow(scale, index);
    linesBelow.push($721b5e3efef367aa$var$_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++)$721b5e3efef367aa$var$addPointsBelow(points, sourcePoints[j], linesBelow);
    }
    return new $721b5e3efef367aa$export$55e463fa7bcd3469({
        points: points,
        options: {}
    });
}
function $721b5e3efef367aa$var$getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) break;
        if (!meta.hidden) below.unshift(meta.dataset);
    }
    return below;
}
function $721b5e3efef367aa$var$addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first: first, last: last, point: point } = $721b5e3efef367aa$var$findPoint(line, sourcePoint, 'x');
        if (!point || first && last) continue;
        if (first) postponed.unshift(point);
        else {
            points.push(point);
            if (!last) break;
        }
    }
    points.push(...postponed);
}
function $721b5e3efef367aa$var$findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) return {};
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if ((0, $3XW2M.ak)(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first: first,
        last: last,
        point: point
    };
}
class $721b5e3efef367aa$var$simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x: x, y: y, radius: radius } = this;
        bounds = bounds || {
            start: 0,
            end: (0, $3XW2M.T)
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x: x, y: y, radius: radius } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle: angle
        };
    }
}
function $721b5e3efef367aa$var$_getTarget(source) {
    const { chart: chart, fill: fill, line: line } = source;
    if ((0, $3XW2M.g)(fill)) return $721b5e3efef367aa$var$getLineByIndex(chart, fill);
    if (fill === 'stack') return $721b5e3efef367aa$var$_buildStackLine(source);
    if (fill === 'shape') return true;
    const boundary = $721b5e3efef367aa$var$computeBoundary(source);
    if (boundary instanceof $721b5e3efef367aa$var$simpleArc) return boundary;
    return $721b5e3efef367aa$var$_createBoundaryLine(boundary, line);
}
function $721b5e3efef367aa$var$getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function $721b5e3efef367aa$var$computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) return $721b5e3efef367aa$var$computeCircularBoundary(source);
    return $721b5e3efef367aa$var$computeLinearBoundary(source);
}
function $721b5e3efef367aa$var$computeLinearBoundary(source) {
    const { scale: scale = {}, fill: fill } = source;
    const pixel = $721b5e3efef367aa$var$_getTargetPixel(fill, scale);
    if ((0, $3XW2M.g)(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function $721b5e3efef367aa$var$computeCircularBoundary(source) {
    const { scale: scale, fill: fill } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = $721b5e3efef367aa$var$_getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new $721b5e3efef367aa$var$simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i)target.push(scale.getPointPositionForValue(i, value));
    return target;
}
function $721b5e3efef367aa$var$_drawfill(ctx, source, area) {
    const target = $721b5e3efef367aa$var$_getTarget(source);
    const { chart: chart, index: index, line: line, scale: scale, axis: axis } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above: above = color, below: below = color } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = (0, $3XW2M.ah)(chart, meta);
    if (target && line.points.length) {
        (0, $3XW2M.Y)(ctx, area);
        $721b5e3efef367aa$var$doFill(ctx, {
            line: line,
            target: target,
            above: above,
            below: below,
            area: area,
            scale: scale,
            axis: axis,
            clip: clip
        });
        (0, $3XW2M.$)(ctx);
    }
}
function $721b5e3efef367aa$var$doFill(ctx, cfg) {
    const { line: line, target: target, above: above, below: below, area: area, scale: scale, clip: clip } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            $721b5e3efef367aa$var$clipVertical(ctx, target, area.top);
            $721b5e3efef367aa$var$fill(ctx, {
                line: line,
                target: target,
                color: above,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $721b5e3efef367aa$var$clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            $721b5e3efef367aa$var$clipHorizontal(ctx, target, area.left);
            $721b5e3efef367aa$var$fill(ctx, {
                line: line,
                target: target,
                color: below,
                scale: scale,
                property: property,
                clip: clip
            });
            ctx.restore();
            ctx.save();
            $721b5e3efef367aa$var$clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    $721b5e3efef367aa$var$fill(ctx, {
        line: line,
        target: target,
        color: fillColor,
        scale: scale,
        property: property,
        clip: clip
    });
    ctx.restore();
}
function $721b5e3efef367aa$var$clipVertical(ctx, target, clipY) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$721b5e3efef367aa$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(lastPoint.x, clipY);
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function $721b5e3efef367aa$var$clipHorizontal(ctx, target, clipX) {
    const { segments: segments, points: points } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start: start, end: end } = segment;
        const firstPoint = points[start];
        const lastPoint = points[$721b5e3efef367aa$var$_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) ctx.closePath();
        else ctx.lineTo(clipX, lastPoint.y);
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function $721b5e3efef367aa$var$fill(ctx, cfg) {
    const { line: line, target: target, property: property, color: color, scale: scale, clip: clip } = cfg;
    const segments = $721b5e3efef367aa$var$_segments(line, target, property);
    for (const { source: src, target: tgt, start: start, end: end } of segments){
        const { style: { backgroundColor: backgroundColor = color } = {} } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        $721b5e3efef367aa$var$clipBounds(ctx, scale, clip, notShape && $721b5e3efef367aa$var$_getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) ctx.closePath();
            else $721b5e3efef367aa$var$interpolatedLineTo(ctx, target, end, property);
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) $721b5e3efef367aa$var$interpolatedLineTo(ctx, target, start, property);
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function $721b5e3efef367aa$var$clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property: property, start: start, end: end } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function $721b5e3efef367aa$var$interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
}
var $721b5e3efef367aa$export$d19ba4d812bed757 = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof $721b5e3efef367aa$export$55e463fa7bcd3469) source = {
                visible: chart.isDatasetVisible(i),
                index: i,
                fill: $721b5e3efef367aa$var$_decodeFill(line, i, count),
                chart: chart,
                axis: meta.controller.options.indexAxis,
                scale: meta.vScale,
                line: line
            };
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) continue;
            source.fill = $721b5e3efef367aa$var$_resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) continue;
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) $721b5e3efef367aa$var$_drawfill(chart.ctx, source, area);
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') return;
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if ($721b5e3efef367aa$var$_shouldApplyFill(source)) $721b5e3efef367aa$var$_drawfill(chart.ctx, source, chart.chartArea);
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!$721b5e3efef367aa$var$_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') return;
        $721b5e3efef367aa$var$_drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};
const $721b5e3efef367aa$var$getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight: boxHeight = fontSize, boxWidth: boxWidth = fontSize } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth: boxWidth,
        boxHeight: boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const $721b5e3efef367aa$var$itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class $721b5e3efef367aa$var$Legend extends $721b5e3efef367aa$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
        this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = (0, $3XW2M.Q)(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        if (labelOpts.sort) legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        if (this.options.reverse) legendItems.reverse();
        this.legendItems = legendItems;
    }
    fit() {
        const { options: options, ctx: ctx } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = (0, $3XW2M.a0)(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth: boxWidth, itemHeight: itemHeight } = $721b5e3efef367aa$var$getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
    _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx: ctx, maxWidth: maxWidth, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top: top,
                row: row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx: ctx, maxHeight: maxHeight, options: { labels: { padding: padding } } } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth: itemWidth, itemHeight: itemHeight } = $721b5e3efef367aa$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left: left,
                top: currentColHeight,
                col: col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) return;
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes, options: { align: align, labels: { padding: padding }, rtl: rtl } } = this;
        const rtlHelper = (0, $3XW2M.aA)(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = (0, $3XW2M.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = (0, $3XW2M.a2)(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = (0, $3XW2M.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = (0, $3XW2M.a2)(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            (0, $3XW2M.Y)(ctx, this);
            this._draw();
            (0, $3XW2M.$)(ctx);
        }
    }
    _draw() {
        const { options: opts, columnSizes: columnSizes, lineWidths: lineWidths, ctx: ctx } = this;
        const { align: align, labels: labelOpts } = opts;
        const defaultColor = (0, $3XW2M.d).color;
        const rtlHelper = (0, $3XW2M.aA)(opts.rtl, this.left, this.width);
        const labelFont = (0, $3XW2M.a0)(labelOpts.font);
        const { padding: padding } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth: boxWidth, boxHeight: boxHeight, itemHeight: itemHeight } = $721b5e3efef367aa$var$getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) return;
            ctx.save();
            const lineWidth = (0, $3XW2M.v)(legendItem.lineWidth, 1);
            ctx.fillStyle = (0, $3XW2M.v)(legendItem.fillStyle, defaultColor);
            ctx.lineCap = (0, $3XW2M.v)(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = (0, $3XW2M.v)(legendItem.lineDashOffset, 0);
            ctx.lineJoin = (0, $3XW2M.v)(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = (0, $3XW2M.v)(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash((0, $3XW2M.v)(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                (0, $3XW2M.aE)(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = (0, $3XW2M.ay)(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) (0, $3XW2M.aw)(ctx, {
                    x: xBoxLeft,
                    y: yBoxTop,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                else ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                ctx.fill();
                if (lineWidth !== 0) ctx.stroke();
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            (0, $3XW2M.Z)(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) cursor = {
            x: (0, $3XW2M.a2)(align, this.left + padding, this.right - lineWidths[0]),
            y: this.top + padding + titleHeight,
            line: 0
        };
        else cursor = {
            x: this.left + padding,
            y: (0, $3XW2M.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
            line: 0
        };
        (0, $3XW2M.aB)(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = (0, $3XW2M.a2)(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = (0, $3XW2M.a2)(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = (0, $3XW2M.aC)(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) cursor.x += width + padding;
            else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += $721b5e3efef367aa$var$calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else cursor.y += lineHeight;
        });
        (0, $3XW2M.aD)(this.ctx, opts.textDirection);
    }
    drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = (0, $3XW2M.a0)(titleOpts.font);
        const titlePadding = (0, $3XW2M.E)(titleOpts.padding);
        if (!titleOpts.display) return;
        const rtlHelper = (0, $3XW2M.aA)(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = (0, $3XW2M.a2)(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + (0, $3XW2M.a2)(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = (0, $3XW2M.a2)(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign((0, $3XW2M.a1)(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        (0, $3XW2M.Z)(ctx, titleOpts.text, x, y, titleFont);
    }
    _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = (0, $3XW2M.a0)(titleOpts.font);
        const titlePadding = (0, $3XW2M.E)(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
    _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if ((0, $3XW2M.ak)(x, this.left, this.right) && (0, $3XW2M.ak)(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if ((0, $3XW2M.ak)(x, hitBox.left, hitBox.left + hitBox.width) && (0, $3XW2M.ak)(y, hitBox.top, hitBox.top + hitBox.height)) return this.legendItems[i];
            }
        }
        return null;
    }
    handleEvent(e) {
        const opts = this.options;
        if (!$721b5e3efef367aa$var$isListened(e.type, opts)) return;
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = $721b5e3efef367aa$var$itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) (0, $3XW2M.Q)(opts.onLeave, [
                e,
                previous,
                this
            ], this);
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) (0, $3XW2M.Q)(opts.onHover, [
                e,
                hoveredItem,
                this
            ], this);
        } else if (hoveredItem) (0, $3XW2M.Q)(opts.onClick, [
            e,
            hoveredItem,
            this
        ], this);
    }
}
function $721b5e3efef367aa$var$calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = $721b5e3efef367aa$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = $721b5e3efef367aa$var$calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth: itemWidth,
        itemHeight: itemHeight
    };
}
function $721b5e3efef367aa$var$calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function $721b5e3efef367aa$var$calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') itemHeight = $721b5e3efef367aa$var$calculateLegendItemHeight(legendItem, fontLineHeight);
    return itemHeight;
}
function $721b5e3efef367aa$var$calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function $721b5e3efef367aa$var$isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) return true;
    if (opts.onClick && (type === 'click' || type === 'mouseup')) return true;
    return false;
}
var $721b5e3efef367aa$export$ed247974535929c7 = {
    id: 'legend',
    _element: $721b5e3efef367aa$var$Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new $721b5e3efef367aa$var$Legend({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $721b5e3efef367aa$export$1ecca0613f5e56d2.configure(chart, legend, options);
        $721b5e3efef367aa$export$1ecca0613f5e56d2.addBox(chart, legend);
    },
    stop (chart) {
        $721b5e3efef367aa$export$1ecca0613f5e56d2.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        $721b5e3efef367aa$export$1ecca0613f5e56d2.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) chart.legend.handleEvent(args.event);
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle: usePointStyle, pointStyle: pointStyle, textAlign: textAlign, color: color, useBorderRadius: useBorderRadius, borderRadius: borderRadius } } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = (0, $3XW2M.E)(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};
class $721b5e3efef367aa$var$Title extends $721b5e3efef367aa$export$db77ccec0bb4ccac {
    constructor(config){
        super();
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this._padding = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.width = undefined;
        this.height = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight) {
        const opts = this.options;
        this.left = 0;
        this.top = 0;
        if (!opts.display) {
            this.width = this.height = this.right = this.bottom = 0;
            return;
        }
        this.width = this.right = maxWidth;
        this.height = this.bottom = maxHeight;
        const lineCount = (0, $3XW2M.b)(opts.text) ? opts.text.length : 1;
        this._padding = (0, $3XW2M.E)(opts.padding);
        const textSize = lineCount * (0, $3XW2M.a0)(opts.font).lineHeight + this._padding.height;
        if (this.isHorizontal()) this.height = textSize;
        else this.width = textSize;
    }
    isHorizontal() {
        const pos = this.options.position;
        return pos === 'top' || pos === 'bottom';
    }
    _drawArgs(offset) {
        const { top: top, left: left, bottom: bottom, right: right, options: options } = this;
        const align = options.align;
        let rotation = 0;
        let maxWidth, titleX, titleY;
        if (this.isHorizontal()) {
            titleX = (0, $3XW2M.a2)(align, left, right);
            titleY = top + offset;
            maxWidth = right - left;
        } else {
            if (options.position === 'left') {
                titleX = left + offset;
                titleY = (0, $3XW2M.a2)(align, bottom, top);
                rotation = (0, $3XW2M.P) * -0.5;
            } else {
                titleX = right - offset;
                titleY = (0, $3XW2M.a2)(align, top, bottom);
                rotation = (0, $3XW2M.P) * 0.5;
            }
            maxWidth = bottom - top;
        }
        return {
            titleX: titleX,
            titleY: titleY,
            maxWidth: maxWidth,
            rotation: rotation
        };
    }
    draw() {
        const ctx = this.ctx;
        const opts = this.options;
        if (!opts.display) return;
        const fontOpts = (0, $3XW2M.a0)(opts.font);
        const lineHeight = fontOpts.lineHeight;
        const offset = lineHeight / 2 + this._padding.top;
        const { titleX: titleX, titleY: titleY, maxWidth: maxWidth, rotation: rotation } = this._drawArgs(offset);
        (0, $3XW2M.Z)(ctx, opts.text, 0, 0, fontOpts, {
            color: opts.color,
            maxWidth: maxWidth,
            rotation: rotation,
            textAlign: (0, $3XW2M.a1)(opts.align),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
}
function $721b5e3efef367aa$var$createTitle(chart, titleOpts) {
    const title = new $721b5e3efef367aa$var$Title({
        ctx: chart.ctx,
        options: titleOpts,
        chart: chart
    });
    $721b5e3efef367aa$export$1ecca0613f5e56d2.configure(chart, title, titleOpts);
    $721b5e3efef367aa$export$1ecca0613f5e56d2.addBox(chart, title);
    chart.titleBlock = title;
}
var $721b5e3efef367aa$export$f99233281efd08a0 = {
    id: 'title',
    _element: $721b5e3efef367aa$var$Title,
    start (chart, _args, options) {
        $721b5e3efef367aa$var$createTitle(chart, options);
    },
    stop (chart) {
        const titleBlock = chart.titleBlock;
        $721b5e3efef367aa$export$1ecca0613f5e56d2.removeBox(chart, titleBlock);
        delete chart.titleBlock;
    },
    beforeUpdate (chart, _args, options) {
        const title = chart.titleBlock;
        $721b5e3efef367aa$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'bold'
        },
        fullSize: true,
        padding: 10,
        position: 'top',
        text: '',
        weight: 2000
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $721b5e3efef367aa$var$map = new WeakMap();
var $721b5e3efef367aa$export$d5c56664638992a4 = {
    id: 'subtitle',
    start (chart, _args, options) {
        const title = new $721b5e3efef367aa$var$Title({
            ctx: chart.ctx,
            options: options,
            chart: chart
        });
        $721b5e3efef367aa$export$1ecca0613f5e56d2.configure(chart, title, options);
        $721b5e3efef367aa$export$1ecca0613f5e56d2.addBox(chart, title);
        $721b5e3efef367aa$var$map.set(chart, title);
    },
    stop (chart) {
        $721b5e3efef367aa$export$1ecca0613f5e56d2.removeBox(chart, $721b5e3efef367aa$var$map.get(chart));
        $721b5e3efef367aa$var$map.delete(chart);
    },
    beforeUpdate (chart, _args, options) {
        const title = $721b5e3efef367aa$var$map.get(chart);
        $721b5e3efef367aa$export$1ecca0613f5e56d2.configure(chart, title, options);
        title.options = options;
    },
    defaults: {
        align: 'center',
        display: false,
        font: {
            weight: 'normal'
        },
        fullSize: true,
        padding: 0,
        position: 'top',
        text: '',
        weight: 1500
    },
    defaultRoutes: {
        color: 'color'
    },
    descriptors: {
        _scriptable: true,
        _indexable: false
    }
};
const $721b5e3efef367aa$var$positioners = {
    average (items) {
        if (!items.length) return false;
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) return false;
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
    nearest (items, eventPosition) {
        if (!items.length) return false;
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = (0, $3XW2M.aF)(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x: x,
            y: y
        };
    }
};
function $721b5e3efef367aa$var$pushOrConcat(base, toPush) {
    if (toPush) {
        if ((0, $3XW2M.b)(toPush)) Array.prototype.push.apply(base, toPush);
        else base.push(toPush);
    }
    return base;
}
function $721b5e3efef367aa$var$splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) return str.split('\n');
    return str;
}
function $721b5e3efef367aa$var$createTooltipItem(chart, item) {
    const { element: element, datasetIndex: datasetIndex, index: index } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label: label, value: value } = controller.getLabelAndValue(index);
    return {
        chart: chart,
        label: label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex: datasetIndex,
        element: element
    };
}
function $721b5e3efef367aa$var$getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body: body, footer: footer, title: title } = tooltip;
    const { boxWidth: boxWidth, boxHeight: boxHeight } = options;
    const bodyFont = (0, $3XW2M.a0)(options.bodyFont);
    const titleFont = (0, $3XW2M.a0)(options.titleFont);
    const footerFont = (0, $3XW2M.a0)(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = (0, $3XW2M.E)(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    (0, $3XW2M.F)(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    (0, $3XW2M.F)(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    (0, $3XW2M.F)(body, (bodyItem)=>{
        (0, $3XW2M.F)(bodyItem.before, maxLineWidth);
        (0, $3XW2M.F)(bodyItem.lines, maxLineWidth);
        (0, $3XW2M.F)(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    (0, $3XW2M.F)(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width: width,
        height: height
    };
}
function $721b5e3efef367aa$var$determineYAlign(chart, size) {
    const { y: y, height: height } = size;
    if (y < height / 2) return 'top';
    else if (y > chart.height - height / 2) return 'bottom';
    return 'center';
}
function $721b5e3efef367aa$var$doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x: x, width: width } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) return true;
    if (xAlign === 'right' && x - width - caret < 0) return true;
}
function $721b5e3efef367aa$var$determineXAlign(chart, options, size, yAlign) {
    const { x: x, width: width } = size;
    const { width: chartWidth, chartArea: { left: left, right: right } } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    else if (x <= width / 2) xAlign = 'left';
    else if (x >= chartWidth - width / 2) xAlign = 'right';
    if ($721b5e3efef367aa$var$doesNotFitWithAlign(xAlign, chart, options, size)) xAlign = 'center';
    return xAlign;
}
function $721b5e3efef367aa$var$determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || $721b5e3efef367aa$var$determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || $721b5e3efef367aa$var$determineXAlign(chart, options, size, yAlign),
        yAlign: yAlign
    };
}
function $721b5e3efef367aa$var$alignX(size, xAlign) {
    let { x: x, width: width } = size;
    if (xAlign === 'right') x -= width;
    else if (xAlign === 'center') x -= width / 2;
    return x;
}
function $721b5e3efef367aa$var$alignY(size, yAlign, paddingAndSize) {
    let { y: y, height: height } = size;
    if (yAlign === 'top') y += paddingAndSize;
    else if (yAlign === 'bottom') y -= height + paddingAndSize;
    else y -= height / 2;
    return y;
}
function $721b5e3efef367aa$var$getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize: caretSize, caretPadding: caretPadding, cornerRadius: cornerRadius } = options;
    const { xAlign: xAlign, yAlign: yAlign } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $3XW2M.ay)(cornerRadius);
    let x = $721b5e3efef367aa$var$alignX(size, xAlign);
    const y = $721b5e3efef367aa$var$alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') x += paddingAndSize;
        else if (xAlign === 'right') x -= paddingAndSize;
    } else if (xAlign === 'left') x -= Math.max(topLeft, bottomLeft) + caretSize;
    else if (xAlign === 'right') x += Math.max(topRight, bottomRight) + caretSize;
    return {
        x: (0, $3XW2M.S)(x, 0, chart.width - size.width),
        y: (0, $3XW2M.S)(y, 0, chart.height - size.height)
    };
}
function $721b5e3efef367aa$var$getAlignedX(tooltip, align, options) {
    const padding = (0, $3XW2M.E)(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function $721b5e3efef367aa$var$getBeforeAfterBodyLines(callback) {
    return $721b5e3efef367aa$var$pushOrConcat([], $721b5e3efef367aa$var$splitNewlines(callback));
}
function $721b5e3efef367aa$var$createTooltipContext(parent, tooltip, tooltipItems) {
    return (0, $3XW2M.j)(parent, {
        tooltip: tooltip,
        tooltipItems: tooltipItems,
        type: 'tooltip'
    });
}
function $721b5e3efef367aa$var$overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const $721b5e3efef367aa$var$defaultCallbacks = {
    beforeTitle: (0, $3XW2M.aG),
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') return item.dataset.label || '';
            else if (item.label) return item.label;
            else if (labelCount > 0 && item.dataIndex < labelCount) return labels[item.dataIndex];
        }
        return '';
    },
    afterTitle: (0, $3XW2M.aG),
    beforeBody: (0, $3XW2M.aG),
    beforeLabel: (0, $3XW2M.aG),
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        let label = tooltipItem.dataset.label || '';
        if (label) label += ': ';
        const value = tooltipItem.formattedValue;
        if (!(0, $3XW2M.k)(value)) label += value;
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: (0, $3XW2M.aG),
    afterBody: (0, $3XW2M.aG),
    beforeFooter: (0, $3XW2M.aG),
    footer: (0, $3XW2M.aG),
    afterFooter: (0, $3XW2M.aG)
};
function $721b5e3efef367aa$var$invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') return $721b5e3efef367aa$var$defaultCallbacks[name].call(ctx, arg);
    return result;
}
class $721b5e3efef367aa$var$Tooltip extends $721b5e3efef367aa$export$db77ccec0bb4ccac {
    static positioners = $721b5e3efef367aa$var$positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
    _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) return cached;
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new $721b5e3efef367aa$export$8ab227dac26677d(this.chart, opts);
        if (opts._cacheable) this._cachedAnimations = Object.freeze(animations);
        return animations;
    }
    getContext() {
        return this.$context || (this.$context = $721b5e3efef367aa$var$createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks: callbacks } = options;
        const beforeTitle = $721b5e3efef367aa$var$invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = $721b5e3efef367aa$var$invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = $721b5e3efef367aa$var$invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = $721b5e3efef367aa$var$pushOrConcat(lines, $721b5e3efef367aa$var$splitNewlines(beforeTitle));
        lines = $721b5e3efef367aa$var$pushOrConcat(lines, $721b5e3efef367aa$var$splitNewlines(title));
        lines = $721b5e3efef367aa$var$pushOrConcat(lines, $721b5e3efef367aa$var$splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return $721b5e3efef367aa$var$getBeforeAfterBodyLines($721b5e3efef367aa$var$invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const bodyItems = [];
        (0, $3XW2M.F)(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = $721b5e3efef367aa$var$overrideCallbacks(callbacks, context);
            $721b5e3efef367aa$var$pushOrConcat(bodyItem.before, $721b5e3efef367aa$var$splitNewlines($721b5e3efef367aa$var$invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            $721b5e3efef367aa$var$pushOrConcat(bodyItem.lines, $721b5e3efef367aa$var$invokeCallbackWithFallback(scoped, 'label', this, context));
            $721b5e3efef367aa$var$pushOrConcat(bodyItem.after, $721b5e3efef367aa$var$splitNewlines($721b5e3efef367aa$var$invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return $721b5e3efef367aa$var$getBeforeAfterBodyLines($721b5e3efef367aa$var$invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks: callbacks } = options;
        const beforeFooter = $721b5e3efef367aa$var$invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = $721b5e3efef367aa$var$invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = $721b5e3efef367aa$var$invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = $721b5e3efef367aa$var$pushOrConcat(lines, $721b5e3efef367aa$var$splitNewlines(beforeFooter));
        lines = $721b5e3efef367aa$var$pushOrConcat(lines, $721b5e3efef367aa$var$splitNewlines(footer));
        lines = $721b5e3efef367aa$var$pushOrConcat(lines, $721b5e3efef367aa$var$splitNewlines(afterFooter));
        return lines;
    }
    _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i)tooltipItems.push($721b5e3efef367aa$var$createTooltipItem(this.chart, active[i]));
        if (options.filter) tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        if (options.itemSort) tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        (0, $3XW2M.F)(tooltipItems, (context)=>{
            const scoped = $721b5e3efef367aa$var$overrideCallbacks(options.callbacks, context);
            labelColors.push($721b5e3efef367aa$var$invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push($721b5e3efef367aa$var$invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push($721b5e3efef367aa$var$invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) properties = {
                opacity: 0
            };
        } else {
            const position = $721b5e3efef367aa$var$positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = $721b5e3efef367aa$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = $721b5e3efef367aa$var$determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = $721b5e3efef367aa$var$getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) this._resolveAnimations().update(this, properties);
        if (changed && options.external) options.external.call(this, {
            chart: this.chart,
            tooltip: this,
            replay: replay
        });
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { caretSize: caretSize, cornerRadius: cornerRadius } = options;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $3XW2M.ay)(cornerRadius);
        const { x: ptX, y: ptY } = tooltipPoint;
        const { width: width, height: height } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            else if (xAlign === 'right') x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            else x2 = this.caretX;
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1: x1,
            x2: x2,
            x3: x3,
            y1: y1,
            y2: y2,
            y3: y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = (0, $3XW2M.aA)(options.rtl, this.x, this.width);
            pt.x = $721b5e3efef367aa$var$getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = (0, $3XW2M.a0)(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) pt.y += options.titleMarginBottom - titleSpacing;
            }
        }
    }
    _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight: boxHeight, boxWidth: boxWidth } = options;
        const bodyFont = (0, $3XW2M.a0)(options.bodyFont);
        const colorX = $721b5e3efef367aa$var$getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            (0, $3XW2M.av)(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            (0, $3XW2M.av)(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = (0, $3XW2M.i)(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = (0, $3XW2M.ay)(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                (0, $3XW2M.aw)(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                (0, $3XW2M.aw)(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body: body } = this;
        const { bodySpacing: bodySpacing, bodyAlign: bodyAlign, displayColors: displayColors, boxHeight: boxHeight, boxWidth: boxWidth, boxPadding: boxPadding } = options;
        const bodyFont = (0, $3XW2M.a0)(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = (0, $3XW2M.aA)(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = $721b5e3efef367aa$var$getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        (0, $3XW2M.F)(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            (0, $3XW2M.F)(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            (0, $3XW2M.F)(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        (0, $3XW2M.F)(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = (0, $3XW2M.aA)(options.rtl, this.x, this.width);
            pt.x = $721b5e3efef367aa$var$getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = (0, $3XW2M.a0)(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign: xAlign, yAlign: yAlign } = this;
        const { x: x, y: y } = pt;
        const { width: width, height: height } = tooltipSize;
        const { topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = (0, $3XW2M.ay)(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') this.drawCaret(pt, ctx, tooltipSize, options);
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) ctx.stroke();
    }
    _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = $721b5e3efef367aa$var$positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) return;
            const size = this._size = $721b5e3efef367aa$var$getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = $721b5e3efef367aa$var$determineAlignment(chart, options, positionAndSize);
            const point = $721b5e3efef367aa$var$getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
    _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) return;
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = (0, $3XW2M.E)(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            (0, $3XW2M.aB)(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            (0, $3XW2M.aD)(ctx, options.textDirection);
            ctx.restore();
        }
    }
    getActiveElements() {
        return this._active || [];
    }
    setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex: datasetIndex, index: index })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) throw new Error('Cannot find a dataset at index ' + datasetIndex);
            return {
                datasetIndex: datasetIndex,
                element: meta.data[index],
                index: index
            };
        });
        const changed = !(0, $3XW2M.ai)(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
    handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) return false;
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !(0, $3XW2M.ai)(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
    _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') return [];
        if (!inChartArea) return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) active.reverse();
        return active;
    }
    _positionChanged(active, e) {
        const { caretX: caretX, caretY: caretY, options: options } = this;
        const position = $721b5e3efef367aa$var$positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var $721b5e3efef367aa$export$28c660c63b792dea = {
    id: 'tooltip',
    _element: $721b5e3efef367aa$var$Tooltip,
    positioners: $721b5e3efef367aa$var$positioners,
    afterInit (chart, _args, options) {
        if (options) chart.tooltip = new $721b5e3efef367aa$var$Tooltip({
            chart: chart,
            options: options
        });
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    reset (chart, _args, options) {
        if (chart.tooltip) chart.tooltip.initialize(options);
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip: tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) return;
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) args.changed = true;
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: $721b5e3efef367aa$var$defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};
var $721b5e3efef367aa$export$8b3ca321c77fdea6 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Colors: $721b5e3efef367aa$export$c537fa0d021d010b,
    Decimation: $721b5e3efef367aa$export$be17f937e9aa7533,
    Filler: $721b5e3efef367aa$export$d19ba4d812bed757,
    Legend: $721b5e3efef367aa$export$ed247974535929c7,
    SubTitle: $721b5e3efef367aa$export$d5c56664638992a4,
    Title: $721b5e3efef367aa$export$f99233281efd08a0,
    Tooltip: $721b5e3efef367aa$export$28c660c63b792dea
});
const $721b5e3efef367aa$var$addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index: index,
            label: raw
        });
    } else if (isNaN(raw)) index = null;
    return index;
};
function $721b5e3efef367aa$var$findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) return $721b5e3efef367aa$var$addIfString(labels, raw, index, addedLabels);
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const $721b5e3efef367aa$var$validIndex = (index, max)=>index === null ? null : (0, $3XW2M.S)(Math.round(index), 0, max);
function $721b5e3efef367aa$var$_getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) return labels[value];
    return value;
}
class $721b5e3efef367aa$export$29e663ba4d09fe7 extends $721b5e3efef367aa$export$d60cfc58d3c358b6 {
    static id = 'category';
    static defaults = {
        ticks: {
            callback: $721b5e3efef367aa$var$_getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
        this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index: index, label: label } of added)if (labels[index] === label) labels.splice(index, 1);
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if ((0, $3XW2M.k)(raw)) return null;
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : $721b5e3efef367aa$var$findOrAddLabel(labels, raw, (0, $3XW2M.v)(index, raw), this._addedLabels);
        return $721b5e3efef367aa$var$validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) min = 0;
            if (!maxDefined) max = this.getLabels().length - 1;
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++)ticks.push({
            value: value
        });
        return ticks;
    }
    getLabelForValue(value) {
        return $721b5e3efef367aa$var$_getLabelForValue.call(this, value);
    }
    configure() {
        super.configure();
        if (!this.isHorizontal()) this._reversePixels = !this._reversePixels;
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') value = this.parse(value);
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) return null;
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}
function $721b5e3efef367aa$var$generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds: bounds, step: step, min: min, max: max, precision: precision, count: count, maxTicks: maxTicks, maxDigits: maxDigits, includeBounds: includeBounds } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin, max: rmax } = dataRange;
    const minDefined = !(0, $3XW2M.k)(min);
    const maxDefined = !(0, $3XW2M.k)(max);
    const countDefined = !(0, $3XW2M.k)(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = (0, $3XW2M.aI)((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) return [
        {
            value: rmin
        },
        {
            value: rmax
        }
    ];
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) spacing = (0, $3XW2M.aI)(numSpaces * spacing / maxSpaces / unit) * unit;
    if (!(0, $3XW2M.k)(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && (0, $3XW2M.aJ)((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if ((0, $3XW2M.aK)(numSpaces, Math.round(numSpaces), spacing / 1000)) numSpaces = Math.round(numSpaces);
        else numSpaces = Math.ceil(numSpaces);
    }
    const decimalPlaces = Math.max((0, $3XW2M.aL)(spacing), (0, $3XW2M.aL)(niceMin));
    factor = Math.pow(10, (0, $3XW2M.k)(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) j++;
            if ((0, $3XW2M.aK)(Math.round((niceMin + j * spacing) * factor) / factor, min, $721b5e3efef367aa$var$relativeLabelSize(min, minSpacing, generationOptions))) j++;
        } else if (niceMin < min) j++;
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) break;
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && (0, $3XW2M.aK)(ticks[ticks.length - 1].value, max, $721b5e3efef367aa$var$relativeLabelSize(max, minSpacing, generationOptions))) ticks[ticks.length - 1].value = max;
        else ticks.push({
            value: max
        });
    } else if (!maxDefined || niceMax === max) ticks.push({
        value: niceMax
    });
    return ticks;
}
function $721b5e3efef367aa$var$relativeLabelSize(value, minSpacing, { horizontal: horizontal, minRotation: minRotation }) {
    const rad = (0, $3XW2M.t)(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class $721b5e3efef367aa$var$LinearScaleBase extends $721b5e3efef367aa$export$d60cfc58d3c358b6 {
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if ((0, $3XW2M.k)(raw)) return null;
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) return null;
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero: beginAtZero } = this.options;
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let { min: min, max: max } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = (0, $3XW2M.s)(min);
            const maxSign = (0, $3XW2M.s)(max);
            if (minSign < 0 && maxSign < 0) setMax(0);
            else if (minSign > 0 && maxSign > 0) setMin(0);
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) setMin(min - offset);
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit: maxTicksLimit, stepSize: stepSize } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) maxTicks = Math.min(maxTicksLimit, maxTicks);
        return maxTicks;
    }
    computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks: maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = $721b5e3efef367aa$var$generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') (0, $3XW2M.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return (0, $3XW2M.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
}
class $721b5e3efef367aa$export$e7f4e5e8656f0b93 extends $721b5e3efef367aa$var$LinearScaleBase {
    static id = 'linear';
    static defaults = {
        ticks: {
            callback: (0, $3XW2M.aM).formatters.numeric
        }
    };
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $3XW2M.g)(min) ? min : 0;
        this.max = (0, $3XW2M.g)(max) ? max : 1;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = (0, $3XW2M.t)(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}
const $721b5e3efef367aa$var$log10Floor = (v)=>Math.floor((0, $3XW2M.aN)(v));
const $721b5e3efef367aa$var$changeExponent = (v, m)=>Math.pow(10, $721b5e3efef367aa$var$log10Floor(v) + m);
function $721b5e3efef367aa$var$isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, $721b5e3efef367aa$var$log10Floor(tickVal));
    return remain === 1;
}
function $721b5e3efef367aa$var$steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function $721b5e3efef367aa$var$startExp(min, max) {
    const range = max - min;
    let rangeExp = $721b5e3efef367aa$var$log10Floor(range);
    while($721b5e3efef367aa$var$steps(min, max, rangeExp) > 10)rangeExp++;
    while($721b5e3efef367aa$var$steps(min, max, rangeExp) < 10)rangeExp--;
    return Math.min(rangeExp, $721b5e3efef367aa$var$log10Floor(min));
}
function $721b5e3efef367aa$var$generateTicks(generationOptions, { min: min, max: max }) {
    min = (0, $3XW2M.O)(generationOptions.min, min);
    const ticks = [];
    const minExp = $721b5e3efef367aa$var$log10Floor(min);
    let exp = $721b5e3efef367aa$var$startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = (0, $3XW2M.O)(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value: value,
            major: $721b5e3efef367aa$var$isMajor(value),
            significand: significand
        });
        if (significand >= 10) significand = significand < 15 ? 15 : 20;
        else significand++;
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = (0, $3XW2M.O)(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: $721b5e3efef367aa$var$isMajor(lastTick),
        significand: significand
    });
    return ticks;
}
class $721b5e3efef367aa$export$85295eaf7cb3ac3e extends $721b5e3efef367aa$export$d60cfc58d3c358b6 {
    static id = 'logarithmic';
    static defaults = {
        ticks: {
            callback: (0, $3XW2M.aM).formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
        this.start = undefined;
        this.end = undefined;
        this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = $721b5e3efef367aa$var$LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return (0, $3XW2M.g)(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(true);
        this.min = (0, $3XW2M.g)(min) ? Math.max(0, min) : null;
        this.max = (0, $3XW2M.g)(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) this._zero = true;
        if (this._zero && this.min !== this._suggestedMin && !(0, $3XW2M.g)(this._userMin)) this.min = min === $721b5e3efef367aa$var$changeExponent(this.min, 0) ? $721b5e3efef367aa$var$changeExponent(this.min, -1) : $721b5e3efef367aa$var$changeExponent(this.min, 0);
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin($721b5e3efef367aa$var$changeExponent(min, -1));
                setMax($721b5e3efef367aa$var$changeExponent(max, 1));
            }
        }
        if (min <= 0) setMin($721b5e3efef367aa$var$changeExponent(max, -1));
        if (max <= 0) setMax($721b5e3efef367aa$var$changeExponent(min, 1));
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = $721b5e3efef367aa$var$generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') (0, $3XW2M.aH)(ticks, this, 'value');
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
    getLabelForValue(value) {
        return value === undefined ? '0' : (0, $3XW2M.o)(value, this.chart.options.locale, this.options.ticks.format);
    }
    configure() {
        const start = this.min;
        super.configure();
        this._startValue = (0, $3XW2M.aN)(start);
        this._valueRange = (0, $3XW2M.aN)(this.max) - (0, $3XW2M.aN)(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) value = this.min;
        if (value === null || isNaN(value)) return NaN;
        return this.getPixelForDecimal(value === this.min ? 0 : ((0, $3XW2M.aN)(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}
function $721b5e3efef367aa$var$getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = (0, $3XW2M.E)(tickOpts.backdropPadding);
        return (0, $3XW2M.v)(tickOpts.font && tickOpts.font.size, (0, $3XW2M.d).font.size) + padding.height;
    }
    return 0;
}
function $721b5e3efef367aa$var$measureLabelSize(ctx, font, label) {
    label = (0, $3XW2M.b)(label) ? label : [
        label
    ];
    return {
        w: (0, $3XW2M.aO)(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function $721b5e3efef367aa$var$determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) return {
        start: pos - size / 2,
        end: pos + size / 2
    };
    else if (angle < min || angle > max) return {
        start: pos - size,
        end: pos
    };
    return {
        start: pos,
        end: pos + size
    };
}
function $721b5e3efef367aa$var$fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? (0, $3XW2M.P) / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = (0, $3XW2M.a0)(opts.font);
        const textSize = $721b5e3efef367aa$var$measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = (0, $3XW2M.al)(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round((0, $3XW2M.U)(angleRadians));
        const hLimits = $721b5e3efef367aa$var$determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = $721b5e3efef367aa$var$determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        $721b5e3efef367aa$var$updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = $721b5e3efef367aa$var$buildPointLabelItems(scale, labelSizes, padding);
}
function $721b5e3efef367aa$var$updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function $721b5e3efef367aa$var$createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra: extra, additionalAngle: additionalAngle, padding: padding, size: size } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round((0, $3XW2M.U)((0, $3XW2M.al)(pointLabelPosition.angle + (0, $3XW2M.H))));
    const y = $721b5e3efef367aa$var$yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = $721b5e3efef367aa$var$getTextAlignForAngle(angle);
    const left = $721b5e3efef367aa$var$leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y: y,
        textAlign: textAlign,
        left: left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function $721b5e3efef367aa$var$isNotOverlapped(item, area) {
    if (!area) return true;
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const apexesInArea = (0, $3XW2M.C)({
        x: left,
        y: top
    }, area) || (0, $3XW2M.C)({
        x: left,
        y: bottom
    }, area) || (0, $3XW2M.C)({
        x: right,
        y: top
    }, area) || (0, $3XW2M.C)({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function $721b5e3efef367aa$var$buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels: centerPointLabels, display: display } = opts.pointLabels;
    const itemOpts = {
        extra: $721b5e3efef367aa$var$getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? (0, $3XW2M.P) / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = $721b5e3efef367aa$var$createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = $721b5e3efef367aa$var$isNotOverlapped(item, area);
            if (item.visible) area = item;
        }
    }
    return items;
}
function $721b5e3efef367aa$var$getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) return 'center';
    else if (angle < 180) return 'left';
    return 'right';
}
function $721b5e3efef367aa$var$leftForTextAlign(x, w, align) {
    if (align === 'right') x -= w;
    else if (align === 'center') x -= w / 2;
    return x;
}
function $721b5e3efef367aa$var$yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) y -= h / 2;
    else if (angle > 270 || angle < 90) y -= h;
    return y;
}
function $721b5e3efef367aa$var$drawPointLabelBox(ctx, opts, item) {
    const { left: left, top: top, right: right, bottom: bottom } = item;
    const { backdropColor: backdropColor } = opts;
    if (!(0, $3XW2M.k)(backdropColor)) {
        const borderRadius = (0, $3XW2M.ay)(opts.borderRadius);
        const padding = (0, $3XW2M.E)(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            (0, $3XW2M.aw)(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
}
function $721b5e3efef367aa$var$drawPointLabels(scale, labelCount) {
    const { ctx: ctx, options: { pointLabels: pointLabels } } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) continue;
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        $721b5e3efef367aa$var$drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = (0, $3XW2M.a0)(optsAtIndex.font);
        const { x: x, y: y, textAlign: textAlign } = item;
        (0, $3XW2M.Z)(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function $721b5e3efef367aa$var$pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx: ctx } = scale;
    if (circular) ctx.arc(scale.xCenter, scale.yCenter, radius, 0, (0, $3XW2M.T));
    else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function $721b5e3efef367aa$var$drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color: color, lineWidth: lineWidth } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) return;
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    $721b5e3efef367aa$var$pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function $721b5e3efef367aa$var$createPointLabelContext(parent, index, label) {
    return (0, $3XW2M.j)(parent, {
        label: label,
        index: index,
        type: 'pointLabel'
    });
}
class $721b5e3efef367aa$export$cfafc36d95386d38 extends $721b5e3efef367aa$var$LinearScaleBase {
    static id = 'radialLinear';
    static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: (0, $3XW2M.aM).formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
        this.xCenter = undefined;
        this.yCenter = undefined;
        this.drawingArea = undefined;
        this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = (0, $3XW2M.E)($721b5e3efef367aa$var$getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min: min, max: max } = this.getMinMax(false);
        this.min = (0, $3XW2M.g)(min) && !isNaN(min) ? min : 0;
        this.max = (0, $3XW2M.g)(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
    computeTickLimit() {
        return Math.ceil(this.drawingArea / $721b5e3efef367aa$var$getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        $721b5e3efef367aa$var$LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = (0, $3XW2M.Q)(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) $721b5e3efef367aa$var$fitWithPointLabels(this);
        else this.setCenterPoint(0, 0, 0, 0);
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = (0, $3XW2M.T) / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return (0, $3XW2M.al)(index * angleMultiplier + (0, $3XW2M.t)(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if ((0, $3XW2M.k)(value)) return NaN;
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) return (this.max - value) * scalingFactor;
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if ((0, $3XW2M.k)(distance)) return NaN;
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return $721b5e3efef367aa$var$createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - (0, $3XW2M.H) + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle: angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left: left, top: top, right: right, bottom: bottom } = this._pointLabelItems[index];
        return {
            left: left,
            top: top,
            right: right,
            bottom: bottom
        };
    }
    drawBackground() {
        const { backgroundColor: backgroundColor, grid: { circular: circular } } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            $721b5e3efef367aa$var$pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
    drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines: angleLines, grid: grid, border: border } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) $721b5e3efef367aa$var$drawPointLabels(this, labelCount);
        if (grid.display) this.ticks.forEach((tick, index)=>{
            if (index !== 0 || index === 0 && this.min < 0) {
                offset = this.getDistanceFromCenterForValue(tick.value);
                const context = this.getContext(index);
                const optsAtIndex = grid.setContext(context);
                const optsAtIndexBorder = border.setContext(context);
                $721b5e3efef367aa$var$drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
            }
        });
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color: color, lineWidth: lineWidth } = optsAtIndex;
                if (!lineWidth || !color) continue;
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
    drawBorder() {}
    drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) return;
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) return;
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = (0, $3XW2M.a0)(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = (0, $3XW2M.E)(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            (0, $3XW2M.Z)(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
    drawTitle() {}
}
const $721b5e3efef367aa$var$INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
const $721b5e3efef367aa$var$UNITS = /* #__PURE__ */ Object.keys($721b5e3efef367aa$var$INTERVALS);
function $721b5e3efef367aa$var$sorter(a, b) {
    return a - b;
}
function $721b5e3efef367aa$var$parse(scale, input) {
    if ((0, $3XW2M.k)(input)) return null;
    const adapter = scale._adapter;
    const { parser: parser, round: round, isoWeekday: isoWeekday } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') value = parser(value);
    if (!(0, $3XW2M.g)(value)) value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    if (value === null) return null;
    if (round) value = round === 'week' && ((0, $3XW2M.x)(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    return +value;
}
function $721b5e3efef367aa$var$determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = $721b5e3efef367aa$var$UNITS.length;
    for(let i = $721b5e3efef367aa$var$UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = $721b5e3efef367aa$var$INTERVALS[$721b5e3efef367aa$var$UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) return $721b5e3efef367aa$var$UNITS[i];
    }
    return $721b5e3efef367aa$var$UNITS[ilen - 1];
}
function $721b5e3efef367aa$var$determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = $721b5e3efef367aa$var$UNITS.length - 1; i >= $721b5e3efef367aa$var$UNITS.indexOf(minUnit); i--){
        const unit = $721b5e3efef367aa$var$UNITS[i];
        if ($721b5e3efef367aa$var$INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) return unit;
    }
    return $721b5e3efef367aa$var$UNITS[minUnit ? $721b5e3efef367aa$var$UNITS.indexOf(minUnit) : 0];
}
function $721b5e3efef367aa$var$determineMajorUnit(unit) {
    for(let i = $721b5e3efef367aa$var$UNITS.indexOf(unit) + 1, ilen = $721b5e3efef367aa$var$UNITS.length; i < ilen; ++i){
        if ($721b5e3efef367aa$var$INTERVALS[$721b5e3efef367aa$var$UNITS[i]].common) return $721b5e3efef367aa$var$UNITS[i];
    }
}
function $721b5e3efef367aa$var$addTick(ticks, time, timestamps) {
    if (!timestamps) ticks[time] = true;
    else if (timestamps.length) {
        const { lo: lo, hi: hi } = (0, $3XW2M.aQ)(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
function $721b5e3efef367aa$var$setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) ticks[index].major = true;
    }
    return ticks;
}
function $721b5e3efef367aa$var$ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
    const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value: value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : $721b5e3efef367aa$var$setMajorTicks(scale, ticks, map, majorUnit);
}
class $721b5e3efef367aa$export$a894c72689ff3ec extends $721b5e3efef367aa$export$d60cfc58d3c358b6 {
    static id = 'time';
    static defaults = {
        bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
            source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
    constructor(props){
        super(props);
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
        this._unit = 'day';
        this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
        const adapter = this._adapter = new $721b5e3efef367aa$export$f32766ea09ec8bc4._date(scaleOpts.adapters.date);
        adapter.init(opts);
        (0, $3XW2M.ab)(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
    parse(raw, index) {
        if (raw === undefined) return null;
        return $721b5e3efef367aa$var$parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = this.getUserBounds();
        function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) min = Math.min(min, bounds.min);
            if (!maxDefined && !isNaN(bounds.max)) max = Math.max(max, bounds.max);
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') _applyBounds(this.getMinMax(false));
        }
        min = (0, $3XW2M.g)(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = (0, $3XW2M.g)(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
    _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min: min,
            max: max
        };
    }
    buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = (0, $3XW2M.aP)(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? $721b5e3efef367aa$var$determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : $721b5e3efef367aa$var$determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : $721b5e3efef367aa$var$determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) ticks.reverse();
        return $721b5e3efef367aa$var$ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) this.initOffsets(this.ticks.map((tick)=>+tick.value));
    }
    initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) start = 1 - first;
            else start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) end = last;
            else end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = (0, $3XW2M.S)(start, 0, limit);
        end = (0, $3XW2M.S)(end, 0, limit);
        this._offsets = {
            start: start,
            end: end,
            factor: 1 / (start + 1 + end)
        };
    }
    _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || $721b5e3efef367aa$var$determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = (0, $3XW2M.v)(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = (0, $3XW2M.x)(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) first = +adapter.startOf(first, 'isoWeek', weekday);
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++)$721b5e3efef367aa$var$addTick(ticks, time, timestamps);
        if (time === max || options.bounds === 'ticks' || count === 1) $721b5e3efef367aa$var$addTick(ticks, time, timestamps);
        return Object.keys(ticks).sort($721b5e3efef367aa$var$sorter).map((x)=>+x);
    }
    getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) return adapter.format(value, timeOpts.tooltipFormat);
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
    format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
    _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) return (0, $3XW2M.Q)(formatter, [
            time,
            index,
            ticks
        ], this);
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
    generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
    getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
    getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
    _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = (0, $3XW2M.t)(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
    _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, $721b5e3efef367aa$var$ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
    getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) return this._cache.data = metas[0].controller.getAllParsedValues(this);
        for(i = 0, ilen = metas.length; i < ilen; ++i)timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        return this._cache.data = this.normalize(timestamps);
    }
    getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) return timestamps;
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i)timestamps.push($721b5e3efef367aa$var$parse(this, labels[i]));
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
    normalize(values) {
        return (0, $3XW2M._)(values.sort($721b5e3efef367aa$var$sorter));
    }
}
function $721b5e3efef367aa$var$interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) ({ lo: lo, hi: hi } = (0, $3XW2M.B)(table, 'pos', val));
        ({ pos: prevSource, time: prevTarget } = table[lo]);
        ({ pos: nextSource, time: nextTarget } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) ({ lo: lo, hi: hi } = (0, $3XW2M.B)(table, 'time', val));
        ({ time: prevSource, pos: prevTarget } = table[lo]);
        ({ time: nextSource, pos: nextTarget } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class $721b5e3efef367aa$export$85df64a8eb6dc986 extends $721b5e3efef367aa$export$a894c72689ff3ec {
    static id = 'timeseries';
    static defaults = $721b5e3efef367aa$export$a894c72689ff3ec.defaults;
    constructor(props){
        super(props);
        this._table = [];
        this._minPos = undefined;
        this._tableRange = undefined;
    }
    initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = $721b5e3efef367aa$var$interpolate(table, this.min);
        this._tableRange = $721b5e3efef367aa$var$interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
    buildLookupTable(timestamps) {
        const { min: min, max: max } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) items.push(curr);
        }
        if (items.length < 2) return [
            {
                time: min,
                pos: 0
            },
            {
                time: max,
                pos: 1
            }
        ];
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) table.push({
                time: curr,
                pos: i / (ilen - 1)
            });
        }
        return table;
    }
    _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) timestamps.splice(0, 0, min);
        if (!timestamps.includes(max) || timestamps.length === 1) timestamps.push(max);
        return timestamps.sort((a, b)=>a - b);
    }
    _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) return timestamps;
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) timestamps = this.normalize(data.concat(label));
        else timestamps = data.length ? data : label;
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
    getDecimalForValue(value) {
        return ($721b5e3efef367aa$var$interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
    getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return $721b5e3efef367aa$var$interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}
var $721b5e3efef367aa$export$bcac1c16f1530ec2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CategoryScale: $721b5e3efef367aa$export$29e663ba4d09fe7,
    LinearScale: $721b5e3efef367aa$export$e7f4e5e8656f0b93,
    LogarithmicScale: $721b5e3efef367aa$export$85295eaf7cb3ac3e,
    RadialLinearScale: $721b5e3efef367aa$export$cfafc36d95386d38,
    TimeScale: $721b5e3efef367aa$export$a894c72689ff3ec,
    TimeSeriesScale: $721b5e3efef367aa$export$85df64a8eb6dc986
});
const $721b5e3efef367aa$export$e8959e79e3af550f = [
    $721b5e3efef367aa$export$a6506504f799c5d5,
    $721b5e3efef367aa$export$7a5d735b2ab6389d,
    $721b5e3efef367aa$export$8b3ca321c77fdea6,
    $721b5e3efef367aa$export$bcac1c16f1530ec2
];

});
parcelRegister("3XW2M", function(module, exports) {

$parcel$export(module.exports, "aG", function () { return $2e33e814c7a8effd$export$53a70dd1ebbae346; });
$parcel$export(module.exports, "ac", function () { return $2e33e814c7a8effd$export$2219238a014317b0; });
$parcel$export(module.exports, "k", function () { return $2e33e814c7a8effd$export$342063e11d6c3cad; });
$parcel$export(module.exports, "b", function () { return $2e33e814c7a8effd$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "i", function () { return $2e33e814c7a8effd$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "g", function () { return $2e33e814c7a8effd$export$39b482c5e57630a8; });
$parcel$export(module.exports, "O", function () { return $2e33e814c7a8effd$export$c4ce752e73470fba; });
$parcel$export(module.exports, "v", function () { return $2e33e814c7a8effd$export$90a7f3efeed30595; });
$parcel$export(module.exports, "m", function () { return $2e33e814c7a8effd$export$953cecd6e717a553; });
$parcel$export(module.exports, "n", function () { return $2e33e814c7a8effd$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "Q", function () { return $2e33e814c7a8effd$export$3722cfe417b6ed86; });
$parcel$export(module.exports, "F", function () { return $2e33e814c7a8effd$export$d66501df72047452; });
$parcel$export(module.exports, "ai", function () { return $2e33e814c7a8effd$export$f38c853ae54ed474; });
$parcel$export(module.exports, "a4", function () { return $2e33e814c7a8effd$export$efca4cbe5dd06740; });
$parcel$export(module.exports, "ab", function () { return $2e33e814c7a8effd$export$555508cbc6add439; });
$parcel$export(module.exports, "f", function () { return $2e33e814c7a8effd$export$2d1720544b23b823; });
$parcel$export(module.exports, "a5", function () { return $2e33e814c7a8effd$export$a8550f7dbe79f93a; });
$parcel$export(module.exports, "h", function () { return $2e33e814c7a8effd$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "a7", function () { return $2e33e814c7a8effd$export$a93c5207d687da10; });
$parcel$export(module.exports, "ag", function () { return $2e33e814c7a8effd$export$ee7c8ad385a60b7b; });
$parcel$export(module.exports, "aj", function () { return $2e33e814c7a8effd$export$3b513254972cfc9c; });
$parcel$export(module.exports, "P", function () { return $2e33e814c7a8effd$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "T", function () { return $2e33e814c7a8effd$export$971d5caa766a69d7; });
$parcel$export(module.exports, "H", function () { return $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd; });
$parcel$export(module.exports, "aN", function () { return $2e33e814c7a8effd$export$faec65b429be379; });
$parcel$export(module.exports, "s", function () { return $2e33e814c7a8effd$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "aK", function () { return $2e33e814c7a8effd$export$23ebac1979863676; });
$parcel$export(module.exports, "aI", function () { return $2e33e814c7a8effd$export$b9a6b53f9be3734; });
$parcel$export(module.exports, "N", function () { return $2e33e814c7a8effd$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "x", function () { return $2e33e814c7a8effd$export$d141bba7fdc215a3; });
$parcel$export(module.exports, "aJ", function () { return $2e33e814c7a8effd$export$a05254e7c3aeba6e; });
$parcel$export(module.exports, "aH", function () { return $2e33e814c7a8effd$export$a33b77bbdbb8366c; });
$parcel$export(module.exports, "t", function () { return $2e33e814c7a8effd$export$625550452a3fa3ec; });
$parcel$export(module.exports, "U", function () { return $2e33e814c7a8effd$export$3a6d5c9ae78a2c08; });
$parcel$export(module.exports, "aL", function () { return $2e33e814c7a8effd$export$91477dc880baac21; });
$parcel$export(module.exports, "D", function () { return $2e33e814c7a8effd$export$96f57966bedc81b4; });
$parcel$export(module.exports, "aF", function () { return $2e33e814c7a8effd$export$cf2f7c5792f80b46; });
$parcel$export(module.exports, "al", function () { return $2e33e814c7a8effd$export$ab83b03e4111b1d0; });
$parcel$export(module.exports, "p", function () { return $2e33e814c7a8effd$export$ffb5f4729a158638; });
$parcel$export(module.exports, "S", function () { return $2e33e814c7a8effd$export$25ce5a424b770e84; });
$parcel$export(module.exports, "W", function () { return $2e33e814c7a8effd$export$71cec2538cb2c617; });
$parcel$export(module.exports, "ak", function () { return $2e33e814c7a8effd$export$21579262ef46735b; });
$parcel$export(module.exports, "aQ", function () { return $2e33e814c7a8effd$export$f96d196f7728bb5; });
$parcel$export(module.exports, "B", function () { return $2e33e814c7a8effd$export$ef35774e6d314e91; });
$parcel$export(module.exports, "A", function () { return $2e33e814c7a8effd$export$ebd11618f299a286; });
$parcel$export(module.exports, "aP", function () { return $2e33e814c7a8effd$export$2ed0fc6709e59212; });
$parcel$export(module.exports, "l", function () { return $2e33e814c7a8effd$export$882b5998b3b9117c; });
$parcel$export(module.exports, "u", function () { return $2e33e814c7a8effd$export$3b14a55fb2447963; });
$parcel$export(module.exports, "_", function () { return $2e33e814c7a8effd$export$71511d61b312f219; });
$parcel$export(module.exports, "r", function () { return $2e33e814c7a8effd$export$43caf9889c228507; });
$parcel$export(module.exports, "L", function () { return $2e33e814c7a8effd$export$61196ced6d74a310; });
$parcel$export(module.exports, "ad", function () { return $2e33e814c7a8effd$export$4c3d22f3d993c33f; });
$parcel$export(module.exports, "a1", function () { return $2e33e814c7a8effd$export$3c2fa207a37baaea; });
$parcel$export(module.exports, "a2", function () { return $2e33e814c7a8effd$export$ce26c07117d59d6a; });
$parcel$export(module.exports, "aC", function () { return $2e33e814c7a8effd$export$890c4ad488842ce7; });
$parcel$export(module.exports, "q", function () { return $2e33e814c7a8effd$export$9e5f44173e64f162; });
$parcel$export(module.exports, "w", function () { return $2e33e814c7a8effd$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "e", function () { return $2e33e814c7a8effd$export$f1e1789686576879; });
$parcel$export(module.exports, "c", function () { return $2e33e814c7a8effd$export$db3b6bfb95261072; });
$parcel$export(module.exports, "o", function () { return $2e33e814c7a8effd$export$ae1af26003f05816; });
$parcel$export(module.exports, "aM", function () { return $2e33e814c7a8effd$export$9f4f30ee63539e24; });
$parcel$export(module.exports, "a3", function () { return $2e33e814c7a8effd$export$6559d589eb85fbb6; });
$parcel$export(module.exports, "a6", function () { return $2e33e814c7a8effd$export$2e2af4578d910ddf; });
$parcel$export(module.exports, "d", function () { return $2e33e814c7a8effd$export$4368d992c4eafac0; });
$parcel$export(module.exports, "V", function () { return $2e33e814c7a8effd$export$e7c866399fa523f5; });
$parcel$export(module.exports, "aO", function () { return $2e33e814c7a8effd$export$c03999cb2f36933f; });
$parcel$export(module.exports, "X", function () { return $2e33e814c7a8effd$export$78acf4525d8a74c4; });
$parcel$export(module.exports, "af", function () { return $2e33e814c7a8effd$export$c9170ad7d4cd7e57; });
$parcel$export(module.exports, "av", function () { return $2e33e814c7a8effd$export$d66dc83d8cfc8dd; });
$parcel$export(module.exports, "aE", function () { return $2e33e814c7a8effd$export$158acd800e1ef08b; });
$parcel$export(module.exports, "C", function () { return $2e33e814c7a8effd$export$e7094788287c5e9b; });
$parcel$export(module.exports, "Y", function () { return $2e33e814c7a8effd$export$8743009a87fcb00f; });
$parcel$export(module.exports, "$", function () { return $2e33e814c7a8effd$export$3d8c2f653ac9d0b9; });
$parcel$export(module.exports, "at", function () { return $2e33e814c7a8effd$export$493d36ec626b6698; });
$parcel$export(module.exports, "au", function () { return $2e33e814c7a8effd$export$1fbe638ecf81657e; });
$parcel$export(module.exports, "Z", function () { return $2e33e814c7a8effd$export$dc98b0b04f4c7758; });
$parcel$export(module.exports, "aw", function () { return $2e33e814c7a8effd$export$92108d983e8ee699; });
$parcel$export(module.exports, "am", function () { return $2e33e814c7a8effd$export$1a82df3d29112e01; });
$parcel$export(module.exports, "ax", function () { return $2e33e814c7a8effd$export$9fa96a7d116ea3ce; });
$parcel$export(module.exports, "ay", function () { return $2e33e814c7a8effd$export$28f7fcd39efa255; });
$parcel$export(module.exports, "E", function () { return $2e33e814c7a8effd$export$a9c23c6ac3fc3eca; });
$parcel$export(module.exports, "a0", function () { return $2e33e814c7a8effd$export$34aec0b863436764; });
$parcel$export(module.exports, "a", function () { return $2e33e814c7a8effd$export$407448d2b89b1813; });
$parcel$export(module.exports, "R", function () { return $2e33e814c7a8effd$export$db202ddc8be9136; });
$parcel$export(module.exports, "j", function () { return $2e33e814c7a8effd$export$35e795649ee09318; });
$parcel$export(module.exports, "a9", function () { return $2e33e814c7a8effd$export$a9c996f45e5784d0; });
$parcel$export(module.exports, "a8", function () { return $2e33e814c7a8effd$export$c3950d9923825c02; });
$parcel$export(module.exports, "aa", function () { return $2e33e814c7a8effd$export$7910e0436ed8d1de; });
$parcel$export(module.exports, "y", function () { return $2e33e814c7a8effd$export$4a5767248b18ef41; });
$parcel$export(module.exports, "an", function () { return $2e33e814c7a8effd$export$306ddfe3a8403e2; });
$parcel$export(module.exports, "M", function () { return $2e33e814c7a8effd$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "I", function () { return $2e33e814c7a8effd$export$9bb611d729802a56; });
$parcel$export(module.exports, "z", function () { return $2e33e814c7a8effd$export$df995fae86a55f06; });
$parcel$export(module.exports, "G", function () { return $2e33e814c7a8effd$export$2329c99376c9d0a4; });
$parcel$export(module.exports, "ae", function () { return $2e33e814c7a8effd$export$f787f51d84a910ad; });
$parcel$export(module.exports, "K", function () { return $2e33e814c7a8effd$export$3466f893ebf79586; });
$parcel$export(module.exports, "J", function () { return $2e33e814c7a8effd$export$b4171a6734a65d42; });
$parcel$export(module.exports, "as", function () { return $2e33e814c7a8effd$export$6554612db691658e; });
$parcel$export(module.exports, "aq", function () { return $2e33e814c7a8effd$export$8a5498727ef6be21; });
$parcel$export(module.exports, "ar", function () { return $2e33e814c7a8effd$export$d24c54395ce0c509; });
$parcel$export(module.exports, "aA", function () { return $2e33e814c7a8effd$export$91c6e00c14e7e6fd; });
$parcel$export(module.exports, "aB", function () { return $2e33e814c7a8effd$export$9d398bebfec1c039; });
$parcel$export(module.exports, "aD", function () { return $2e33e814c7a8effd$export$24baa2b76016ce0e; });
$parcel$export(module.exports, "az", function () { return $2e33e814c7a8effd$export$3d12bd131bb975d1; });
$parcel$export(module.exports, "ap", function () { return $2e33e814c7a8effd$export$2f6ca3d3b1f80bf5; });
$parcel$export(module.exports, "ao", function () { return $2e33e814c7a8effd$export$7a38258bbe170828; });
$parcel$export(module.exports, "ah", function () { return $2e33e814c7a8effd$export$995eb9fca571757; });
/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */ 
var $eWgaQ = parcelRequire("eWgaQ");
/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function $2e33e814c7a8effd$export$53a70dd1ebbae346() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const $2e33e814c7a8effd$export$2219238a014317b0 = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $2e33e814c7a8effd$export$342063e11d6c3cad(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function $2e33e814c7a8effd$export$8b22cf2602fb60ce(value) {
    if (Array.isArray && Array.isArray(value)) return true;
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') return true;
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function $2e33e814c7a8effd$export$23f2a1d2818174ef(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function $2e33e814c7a8effd$export$39b482c5e57630a8(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function $2e33e814c7a8effd$export$c4ce752e73470fba(value, defaultValue) {
    return $2e33e814c7a8effd$export$39b482c5e57630a8(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function $2e33e814c7a8effd$export$90a7f3efeed30595(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const $2e33e814c7a8effd$export$953cecd6e717a553 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const $2e33e814c7a8effd$export$7ccc53e8f1e7dfc5 = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function $2e33e814c7a8effd$export$3722cfe417b6ed86(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') return fn.apply(thisArg, args);
}
function $2e33e814c7a8effd$export$d66501df72047452(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if ($2e33e814c7a8effd$export$8b22cf2602fb60ce(loopable)) {
        len = loopable.length;
        if (reverse) for(i = len - 1; i >= 0; i--)fn.call(thisArg, loopable[i], i);
        else for(i = 0; i < len; i++)fn.call(thisArg, loopable[i], i);
    } else if ($2e33e814c7a8effd$export$23f2a1d2818174ef(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++)fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function $2e33e814c7a8effd$export$f38c853ae54ed474(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) return false;
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) return false;
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function $2e33e814c7a8effd$export$667d3bf0c5f83305(source) {
    if ($2e33e814c7a8effd$export$8b22cf2602fb60ce(source)) return source.map($2e33e814c7a8effd$export$667d3bf0c5f83305);
    if ($2e33e814c7a8effd$export$23f2a1d2818174ef(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k)target[keys[k]] = $2e33e814c7a8effd$export$667d3bf0c5f83305(source[keys[k]]);
        return target;
    }
    return source;
}
function $2e33e814c7a8effd$var$isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function $2e33e814c7a8effd$export$317a3d46287192d8(key, target, source, options) {
    if (!$2e33e814c7a8effd$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($2e33e814c7a8effd$export$23f2a1d2818174ef(tval) && $2e33e814c7a8effd$export$23f2a1d2818174ef(sval)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $2e33e814c7a8effd$export$efca4cbe5dd06740(tval, sval, options);
    else target[key] = $2e33e814c7a8effd$export$667d3bf0c5f83305(sval);
}
function $2e33e814c7a8effd$export$efca4cbe5dd06740(target, source, options) {
    const sources = $2e33e814c7a8effd$export$8b22cf2602fb60ce(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!$2e33e814c7a8effd$export$23f2a1d2818174ef(target)) return target;
    options = options || {};
    const merger = options.merger || $2e33e814c7a8effd$export$317a3d46287192d8;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!$2e33e814c7a8effd$export$23f2a1d2818174ef(current)) continue;
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k)merger(keys[k], target, current, options);
    }
    return target;
}
function $2e33e814c7a8effd$export$555508cbc6add439(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $2e33e814c7a8effd$export$efca4cbe5dd06740(target, source, {
        merger: $2e33e814c7a8effd$export$1ee57be6f6687d2c
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function $2e33e814c7a8effd$export$1ee57be6f6687d2c(key, target, source) {
    if (!$2e33e814c7a8effd$var$isValidKey(key)) return;
    const tval = target[key];
    const sval = source[key];
    if ($2e33e814c7a8effd$export$23f2a1d2818174ef(tval) && $2e33e814c7a8effd$export$23f2a1d2818174ef(sval)) $2e33e814c7a8effd$export$555508cbc6add439(tval, sval);
    else if (!Object.prototype.hasOwnProperty.call(target, key)) target[key] = $2e33e814c7a8effd$export$667d3bf0c5f83305(sval);
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$9d0e2d13d04f7070(scope, value, previous, current) {
    if (value !== undefined) console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
}
// resolveObjectKey resolver cache
const $2e33e814c7a8effd$var$keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function $2e33e814c7a8effd$export$1a8f5705751d8277(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) tmp = tmp.slice(0, -1) + '.';
        else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function $2e33e814c7a8effd$var$_getKeyResolver(key) {
    const keys = $2e33e814c7a8effd$export$1a8f5705751d8277(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') break;
            obj = obj && obj[k];
        }
        return obj;
    };
}
function $2e33e814c7a8effd$export$2d1720544b23b823(obj, key) {
    const resolver = $2e33e814c7a8effd$var$keyResolvers[key] || ($2e33e814c7a8effd$var$keyResolvers[key] = $2e33e814c7a8effd$var$_getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$a8550f7dbe79f93a(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const $2e33e814c7a8effd$export$dda1d9f60106f0e9 = (value)=>typeof value !== 'undefined';
const $2e33e814c7a8effd$export$a93c5207d687da10 = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const $2e33e814c7a8effd$export$ee7c8ad385a60b7b = (a, b)=>{
    if (a.size !== b.size) return false;
    for (const item of a){
        if (!b.has(item)) return false;
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function $2e33e814c7a8effd$export$3b513254972cfc9c(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}
/**
 * @alias Chart.helpers.math
 * @namespace
 */ const $2e33e814c7a8effd$export$56c0d5a1e737357d = Math.PI;
const $2e33e814c7a8effd$export$971d5caa766a69d7 = 2 * $2e33e814c7a8effd$export$56c0d5a1e737357d;
const $2e33e814c7a8effd$export$2ec5befb9e6c97d4 = $2e33e814c7a8effd$export$971d5caa766a69d7 + $2e33e814c7a8effd$export$56c0d5a1e737357d;
const $2e33e814c7a8effd$export$53c86fa97d611818 = Number.POSITIVE_INFINITY;
const $2e33e814c7a8effd$export$39c1cc7c062529d4 = $2e33e814c7a8effd$export$56c0d5a1e737357d / 180;
const $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd = $2e33e814c7a8effd$export$56c0d5a1e737357d / 2;
const $2e33e814c7a8effd$export$7a0bdf7d4a91ea88 = $2e33e814c7a8effd$export$56c0d5a1e737357d / 4;
const $2e33e814c7a8effd$export$c18d01048907ea92 = $2e33e814c7a8effd$export$56c0d5a1e737357d * 2 / 3;
const $2e33e814c7a8effd$export$faec65b429be379 = Math.log10;
const $2e33e814c7a8effd$export$2408f22a0fab9ae5 = Math.sign;
function $2e33e814c7a8effd$export$23ebac1979863676(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function $2e33e814c7a8effd$export$b9a6b53f9be3734(range) {
    const roundedRange = Math.round(range);
    range = $2e33e814c7a8effd$export$23ebac1979863676(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor($2e33e814c7a8effd$export$faec65b429be379(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function $2e33e814c7a8effd$export$a07804094c3ecf2d(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++)if (value % i === 0) {
        result.push(i);
        result.push(value / i);
    }
    if (sqrt === (sqrt | 0)) result.push(sqrt);
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function $2e33e814c7a8effd$var$isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function $2e33e814c7a8effd$export$d141bba7fdc215a3(n) {
    return !$2e33e814c7a8effd$var$isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function $2e33e814c7a8effd$export$a05254e7c3aeba6e(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$a33b77bbdbb8366c(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function $2e33e814c7a8effd$export$625550452a3fa3ec(degrees) {
    return degrees * ($2e33e814c7a8effd$export$56c0d5a1e737357d / 180);
}
function $2e33e814c7a8effd$export$3a6d5c9ae78a2c08(radians) {
    return radians * (180 / $2e33e814c7a8effd$export$56c0d5a1e737357d);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function $2e33e814c7a8effd$export$91477dc880baac21(x) {
    if (!$2e33e814c7a8effd$export$39b482c5e57630a8(x)) return;
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function $2e33e814c7a8effd$export$96f57966bedc81b4(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * $2e33e814c7a8effd$export$56c0d5a1e737357d) angle += $2e33e814c7a8effd$export$971d5caa766a69d7; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    return {
        angle: angle,
        distance: radialDistanceFromCenter
    };
}
function $2e33e814c7a8effd$export$cf2f7c5792f80b46(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function $2e33e814c7a8effd$export$f074adc9fbd50943(a, b) {
    return (a - b + $2e33e814c7a8effd$export$2ec5befb9e6c97d4) % $2e33e814c7a8effd$export$971d5caa766a69d7 - $2e33e814c7a8effd$export$56c0d5a1e737357d;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function $2e33e814c7a8effd$export$ab83b03e4111b1d0(a) {
    return (a % $2e33e814c7a8effd$export$971d5caa766a69d7 + $2e33e814c7a8effd$export$971d5caa766a69d7) % $2e33e814c7a8effd$export$971d5caa766a69d7;
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$ffb5f4729a158638(angle, start, end, sameAngleIsFullCircle) {
    const a = $2e33e814c7a8effd$export$ab83b03e4111b1d0(angle);
    const s = $2e33e814c7a8effd$export$ab83b03e4111b1d0(start);
    const e = $2e33e814c7a8effd$export$ab83b03e4111b1d0(end);
    const angleToStart = $2e33e814c7a8effd$export$ab83b03e4111b1d0(s - a);
    const angleToEnd = $2e33e814c7a8effd$export$ab83b03e4111b1d0(e - a);
    const startToAngle = $2e33e814c7a8effd$export$ab83b03e4111b1d0(a - s);
    const endToAngle = $2e33e814c7a8effd$export$ab83b03e4111b1d0(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function $2e33e814c7a8effd$export$25ce5a424b770e84(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function $2e33e814c7a8effd$export$71cec2538cb2c617(value) {
    return $2e33e814c7a8effd$export$25ce5a424b770e84(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function $2e33e814c7a8effd$export$21579262ef46735b(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function $2e33e814c7a8effd$export$f96d196f7728bb5(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) lo = mid;
        else hi = mid;
    }
    return {
        lo: lo,
        hi: hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const $2e33e814c7a8effd$export$ef35774e6d314e91 = (table, key, value, last)=>$2e33e814c7a8effd$export$f96d196f7728bb5(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const $2e33e814c7a8effd$export$ebd11618f299a286 = (table, key, value)=>$2e33e814c7a8effd$export$f96d196f7728bb5(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function $2e33e814c7a8effd$export$2ed0fc6709e59212(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min)start++;
    while(end > start && values[end - 1] > max)end--;
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const $2e33e814c7a8effd$var$arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function $2e33e814c7a8effd$export$882b5998b3b9117c(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    $2e33e814c7a8effd$var$arrayEvents.forEach((key)=>{
        const method = '_onData' + $2e33e814c7a8effd$export$a8550f7dbe79f93a(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') object[method](...args);
                });
                return res;
            }
        });
    });
}
function $2e33e814c7a8effd$export$3b14a55fb2447963(array, listener) {
    const stub = array._chartjs;
    if (!stub) return;
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) listeners.splice(index, 1);
    if (listeners.length > 0) return;
    $2e33e814c7a8effd$var$arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function $2e33e814c7a8effd$export$71511d61b312f219(items) {
    const set = new Set(items);
    if (set.size === items.length) return items;
    return Array.from(set);
}
function $2e33e814c7a8effd$export$8c78c7c36408ea29(pixelSize, fontStyle, fontFamily) {
    return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
}
/**
* Request animation polyfill
*/ const $2e33e814c7a8effd$export$43caf9889c228507 = function() {
    if (typeof window === 'undefined') return function(callback) {
        return callback();
    };
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function $2e33e814c7a8effd$export$61196ced6d74a310(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            $2e33e814c7a8effd$export$43caf9889c228507.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function $2e33e814c7a8effd$export$4c3d22f3d993c33f(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else fn.apply(this, args);
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const $2e33e814c7a8effd$export$3c2fa207a37baaea = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const $2e33e814c7a8effd$export$ce26c07117d59d6a = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const $2e33e814c7a8effd$export$890c4ad488842ce7 = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function $2e33e814c7a8effd$export$9e5f44173e64f162(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale: iScale, vScale: vScale, _parsed: _parsed } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min: min, max: max, minDefined: minDefined, maxDefined: maxDefined } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min($2e33e814c7a8effd$export$ef35774e6d314e91(_parsed, axis, min).lo, animationsDisabled ? pointCount : $2e33e814c7a8effd$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!$2e33e814c7a8effd$export$342063e11d6c3cad(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = $2e33e814c7a8effd$export$25ce5a424b770e84(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max($2e33e814c7a8effd$export$ef35774e6d314e91(_parsed, iScale.axis, max, true).hi + 1, animationsDisabled ? 0 : $2e33e814c7a8effd$export$ef35774e6d314e91(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!$2e33e814c7a8effd$export$342063e11d6c3cad(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = $2e33e814c7a8effd$export$25ce5a424b770e84(end, start, pointCount) - start;
        } else count = pointCount - start;
    }
    return {
        start: start,
        count: count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function $2e33e814c7a8effd$export$efccba1c4a2ef57b(meta) {
    const { xScale: xScale, yScale: yScale, _scaleRanges: _scaleRanges } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}
const $2e33e814c7a8effd$var$atEdge = (t)=>t === 0 || t === 1;
const $2e33e814c7a8effd$var$elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * $2e33e814c7a8effd$export$971d5caa766a69d7 / p));
const $2e33e814c7a8effd$var$elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * $2e33e814c7a8effd$export$971d5caa766a69d7 / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const $2e33e814c7a8effd$export$f1e1789686576879 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd) + 1,
    easeOutSine: (t)=>Math.sin(t * $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd),
    easeInOutSine: (t)=>-0.5 * (Math.cos($2e33e814c7a8effd$export$56c0d5a1e737357d * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>$2e33e814c7a8effd$var$atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>$2e33e814c7a8effd$var$atEdge(t) ? t : $2e33e814c7a8effd$var$elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>$2e33e814c7a8effd$var$atEdge(t) ? t : $2e33e814c7a8effd$var$elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return $2e33e814c7a8effd$var$atEdge(t) ? t : t < 0.5 ? 0.5 * $2e33e814c7a8effd$var$elasticIn(t * 2, s, p) : 0.5 + 0.5 * $2e33e814c7a8effd$var$elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - $2e33e814c7a8effd$export$f1e1789686576879.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) return m * t * t;
        if (t < 2 / d) return m * (t -= 1.5 / d) * t + 0.75;
        if (t < 2.5 / d) return m * (t -= 2.25 / d) * t + 0.9375;
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? $2e33e814c7a8effd$export$f1e1789686576879.easeInBounce(t * 2) * 0.5 : $2e33e814c7a8effd$export$f1e1789686576879.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function $2e33e814c7a8effd$export$738ab4df8bf92ae9(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function $2e33e814c7a8effd$export$db3b6bfb95261072(value) {
    return $2e33e814c7a8effd$export$738ab4df8bf92ae9(value) ? value : new (0, $eWgaQ.Color)(value);
}
function $2e33e814c7a8effd$export$d377dcb2b61d6c4e(value) {
    return $2e33e814c7a8effd$export$738ab4df8bf92ae9(value) ? value : new (0, $eWgaQ.Color)(value).saturate(0.5).darken(0.1).hexString();
}
const $2e33e814c7a8effd$var$numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const $2e33e814c7a8effd$var$colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function $2e33e814c7a8effd$var$applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: $2e33e814c7a8effd$var$colors
        },
        numbers: {
            type: 'number',
            properties: $2e33e814c7a8effd$var$numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}
function $2e33e814c7a8effd$var$applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}
const $2e33e814c7a8effd$var$intlCache = new Map();
function $2e33e814c7a8effd$var$getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = $2e33e814c7a8effd$var$intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        $2e33e814c7a8effd$var$intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function $2e33e814c7a8effd$export$ae1af26003f05816(num, locale, options) {
    return $2e33e814c7a8effd$var$getNumberFormat(locale, options).format(num);
}
const $2e33e814c7a8effd$var$formatters = {
    values (value) {
        return $2e33e814c7a8effd$export$8b22cf2602fb60ce(value) ? value : '' + value;
    },
    numeric (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) notation = 'scientific';
            delta = $2e33e814c7a8effd$var$calculateDelta(tickValue, ticks);
        }
        const logDelta = $2e33e814c7a8effd$export$faec65b429be379(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation: notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return $2e33e814c7a8effd$export$ae1af26003f05816(tickValue, locale, options);
    },
    logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) return '0';
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor($2e33e814c7a8effd$export$faec65b429be379(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) return $2e33e814c7a8effd$var$formatters.numeric.call(this, tickValue, index, ticks);
        return '';
    }
};
function $2e33e814c7a8effd$var$calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) delta = tickValue - Math.floor(tickValue);
    return delta;
}
var $2e33e814c7a8effd$export$9f4f30ee63539e24 = {
    formatters: $2e33e814c7a8effd$var$formatters
};
function $2e33e814c7a8effd$var$applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
        bounds: 'ticks',
        clip: true,
        grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: $2e33e814c7a8effd$export$9f4f30ee63539e24.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}
const $2e33e814c7a8effd$export$6559d589eb85fbb6 = Object.create(null);
const $2e33e814c7a8effd$export$2e2af4578d910ddf = Object.create(null);
function $2e33e814c7a8effd$var$getScope$1(node, key) {
    if (!key) return node;
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function $2e33e814c7a8effd$var$set(root, scope, values) {
    if (typeof scope === 'string') return $2e33e814c7a8effd$export$efca4cbe5dd06740($2e33e814c7a8effd$var$getScope$1(root, scope), values);
    return $2e33e814c7a8effd$export$efca4cbe5dd06740($2e33e814c7a8effd$var$getScope$1(root, ''), scope);
}
class $2e33e814c7a8effd$var$Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>$2e33e814c7a8effd$export$d377dcb2b61d6c4e(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>$2e33e814c7a8effd$export$d377dcb2b61d6c4e(options.borderColor);
        this.hoverColor = (ctx, options)=>$2e33e814c7a8effd$export$d377dcb2b61d6c4e(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
    set(scope, values) {
        return $2e33e814c7a8effd$var$set(this, scope, values);
    }
    get(scope) {
        return $2e33e814c7a8effd$var$getScope$1(this, scope);
    }
    describe(scope, values) {
        return $2e33e814c7a8effd$var$set($2e33e814c7a8effd$export$2e2af4578d910ddf, scope, values);
    }
    override(scope, values) {
        return $2e33e814c7a8effd$var$set($2e33e814c7a8effd$export$6559d589eb85fbb6, scope, values);
    }
    route(scope, name, targetScope, targetName) {
        const scopeObject = $2e33e814c7a8effd$var$getScope$1(this, scope);
        const targetScopeObject = $2e33e814c7a8effd$var$getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if ($2e33e814c7a8effd$export$23f2a1d2818174ef(local)) return Object.assign({}, target, local);
                    return $2e33e814c7a8effd$export$90a7f3efeed30595(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var $2e33e814c7a8effd$export$4368d992c4eafac0 = /* #__PURE__ */ new $2e33e814c7a8effd$var$Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    $2e33e814c7a8effd$var$applyAnimationsDefaults,
    $2e33e814c7a8effd$var$applyLayoutsDefaults,
    $2e33e814c7a8effd$var$applyScaleDefaults
]);
/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function $2e33e814c7a8effd$export$e171bab687b50e0(font) {
    if (!font || $2e33e814c7a8effd$export$342063e11d6c3cad(font.size) || $2e33e814c7a8effd$export$342063e11d6c3cad(font.family)) return null;
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$e7c866399fa523f5(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) longest = textWidth;
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function $2e33e814c7a8effd$export$c03999cb2f36933f(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !$2e33e814c7a8effd$export$8b22cf2602fb60ce(thing)) longest = $2e33e814c7a8effd$export$e7c866399fa523f5(ctx, data, gc, longest, thing);
        else if ($2e33e814c7a8effd$export$8b22cf2602fb60ce(thing)) // if it is an array lets measure each element
        // to do maybe simplify this function a bit so we can do this more recursively?
        for(j = 0, jlen = thing.length; j < jlen; j++){
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !$2e33e814c7a8effd$export$8b22cf2602fb60ce(nestedThing)) longest = $2e33e814c7a8effd$export$e7c866399fa523f5(ctx, data, gc, longest, nestedThing);
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++)delete data[gc[i]];
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function $2e33e814c7a8effd$export$78acf4525d8a74c4(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function $2e33e814c7a8effd$export$c9170ad7d4cd7e57(canvas, ctx) {
    if (!ctx && !canvas) return;
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function $2e33e814c7a8effd$export$d66dc83d8cfc8dd(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $2e33e814c7a8effd$export$158acd800e1ef08b(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function $2e33e814c7a8effd$export$158acd800e1ef08b(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * $2e33e814c7a8effd$export$39c1cc7c062529d4;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) return;
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) ctx.ellipse(x, y, w / 2, radius, 0, 0, $2e33e814c7a8effd$export$971d5caa766a69d7);
            else ctx.arc(x, y, radius, 0, $2e33e814c7a8effd$export$971d5caa766a69d7);
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $2e33e814c7a8effd$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += $2e33e814c7a8effd$export$c18d01048907ea92;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + $2e33e814c7a8effd$export$7a0bdf7d4a91ea88) * size;
            xOffsetW = Math.cos(rad + $2e33e814c7a8effd$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + $2e33e814c7a8effd$export$7a0bdf7d4a91ea88) * size;
            yOffsetW = Math.sin(rad + $2e33e814c7a8effd$export$7a0bdf7d4a91ea88) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - $2e33e814c7a8effd$export$56c0d5a1e737357d, rad - $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd, rad + $2e33e814c7a8effd$export$56c0d5a1e737357d);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += $2e33e814c7a8effd$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += $2e33e814c7a8effd$export$7a0bdf7d4a91ea88;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += $2e33e814c7a8effd$export$7a0bdf7d4a91ea88;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) ctx.stroke();
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function $2e33e814c7a8effd$export$e7094788287c5e9b(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function $2e33e814c7a8effd$export$8743009a87fcb00f(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function $2e33e814c7a8effd$export$3d8c2f653ac9d0b9(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$493d36ec626b6698(ctx, previous, target, flip, mode) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) ctx.lineTo(previous.x, target.y);
    else ctx.lineTo(target.x, previous.y);
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$1fbe638ecf81657e(ctx, previous, target, flip) {
    if (!previous) return ctx.lineTo(target.x, target.y);
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function $2e33e814c7a8effd$var$setRenderOpts(ctx, opts) {
    if (opts.translation) ctx.translate(opts.translation[0], opts.translation[1]);
    if (!$2e33e814c7a8effd$export$342063e11d6c3cad(opts.rotation)) ctx.rotate(opts.rotation);
    if (opts.color) ctx.fillStyle = opts.color;
    if (opts.textAlign) ctx.textAlign = opts.textAlign;
    if (opts.textBaseline) ctx.textBaseline = opts.textBaseline;
}
function $2e33e814c7a8effd$var$decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function $2e33e814c7a8effd$var$drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function $2e33e814c7a8effd$export$dc98b0b04f4c7758(ctx, text, x, y, font, opts = {}) {
    const lines = $2e33e814c7a8effd$export$8b22cf2602fb60ce(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    $2e33e814c7a8effd$var$setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) $2e33e814c7a8effd$var$drawBackdrop(ctx, opts.backdrop);
        if (stroke) {
            if (opts.strokeColor) ctx.strokeStyle = opts.strokeColor;
            if (!$2e33e814c7a8effd$export$342063e11d6c3cad(opts.strokeWidth)) ctx.lineWidth = opts.strokeWidth;
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        $2e33e814c7a8effd$var$decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function $2e33e814c7a8effd$export$92108d983e8ee699(ctx, rect) {
    const { x: x, y: y, w: w, h: h, radius: radius } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * $2e33e814c7a8effd$export$56c0d5a1e737357d, $2e33e814c7a8effd$export$56c0d5a1e737357d, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, $2e33e814c7a8effd$export$56c0d5a1e737357d, $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, $2e33e814c7a8effd$export$7f8ddf7c7c20b3cd, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -$2e33e814c7a8effd$export$7f8ddf7c7c20b3cd, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}
const $2e33e814c7a8effd$var$LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const $2e33e814c7a8effd$var$FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function $2e33e814c7a8effd$export$d29e374196577086(value, size) {
    const matches = ('' + value).match($2e33e814c7a8effd$var$LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') return size * 1.2;
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const $2e33e814c7a8effd$var$numberOrZero = (v)=>+v || 0;
function $2e33e814c7a8effd$export$1a82df3d29112e01(value, props) {
    const ret = {};
    const objProps = $2e33e814c7a8effd$export$23f2a1d2818174ef(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = $2e33e814c7a8effd$export$23f2a1d2818174ef(value) ? objProps ? (prop)=>$2e33e814c7a8effd$export$90a7f3efeed30595(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys)ret[prop] = $2e33e814c7a8effd$var$numberOrZero(read(prop));
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function $2e33e814c7a8effd$export$9fa96a7d116ea3ce(value) {
    return $2e33e814c7a8effd$export$1a82df3d29112e01(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function $2e33e814c7a8effd$export$28f7fcd39efa255(value) {
    return $2e33e814c7a8effd$export$1a82df3d29112e01(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function $2e33e814c7a8effd$export$a9c23c6ac3fc3eca(value) {
    const obj = $2e33e814c7a8effd$export$9fa96a7d116ea3ce(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function $2e33e814c7a8effd$export$34aec0b863436764(options, fallback) {
    options = options || {};
    fallback = fallback || $2e33e814c7a8effd$export$4368d992c4eafac0.font;
    let size = $2e33e814c7a8effd$export$90a7f3efeed30595(options.size, fallback.size);
    if (typeof size === 'string') size = parseInt(size, 10);
    let style = $2e33e814c7a8effd$export$90a7f3efeed30595(options.style, fallback.style);
    if (style && !('' + style).match($2e33e814c7a8effd$var$FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: $2e33e814c7a8effd$export$90a7f3efeed30595(options.family, fallback.family),
        lineHeight: $2e33e814c7a8effd$export$d29e374196577086($2e33e814c7a8effd$export$90a7f3efeed30595(options.lineHeight, fallback.lineHeight), size),
        size: size,
        style: style,
        weight: $2e33e814c7a8effd$export$90a7f3efeed30595(options.weight, fallback.weight),
        string: ''
    };
    font.string = $2e33e814c7a8effd$export$e171bab687b50e0(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function $2e33e814c7a8effd$export$407448d2b89b1813(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) continue;
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && $2e33e814c7a8effd$export$8b22cf2602fb60ce(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) info.cacheable = false;
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function $2e33e814c7a8effd$export$db202ddc8be9136(minmax, grace, beginAtZero) {
    const { min: min, max: max } = minmax;
    const change = $2e33e814c7a8effd$export$7ccc53e8f1e7dfc5(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function $2e33e814c7a8effd$export$35e795649ee09318(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}
/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function $2e33e814c7a8effd$export$a9c996f45e5784d0(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') fallback = $2e33e814c7a8effd$var$_resolve('_fallback', scopes);
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>$2e33e814c7a8effd$export$a9c996f45e5784d0([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return $2e33e814c7a8effd$var$_cached(target, prop, ()=>$2e33e814c7a8effd$var$_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return $2e33e814c7a8effd$var$getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return $2e33e814c7a8effd$var$getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function $2e33e814c7a8effd$export$c3950d9923825c02(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: $2e33e814c7a8effd$export$7910e0436ed8d1de(proxy, descriptorDefaults),
        setContext: (ctx)=>$2e33e814c7a8effd$export$c3950d9923825c02(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>$2e33e814c7a8effd$export$c3950d9923825c02(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return $2e33e814c7a8effd$var$_cached(target, prop, ()=>$2e33e814c7a8effd$var$_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$7910e0436ed8d1de(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable: _scriptable = defaults.scriptable, _indexable: _indexable = defaults.indexable, _allKeys: _allKeys = defaults.allKeys } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: $2e33e814c7a8effd$export$a93c5207d687da10(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: $2e33e814c7a8effd$export$a93c5207d687da10(_indexable) ? _indexable : ()=>_indexable
    };
}
const $2e33e814c7a8effd$var$readKey = (prefix, name)=>prefix ? prefix + $2e33e814c7a8effd$export$a8550f7dbe79f93a(name) : name;
const $2e33e814c7a8effd$var$needsSubResolver = (prop, value)=>$2e33e814c7a8effd$export$23f2a1d2818174ef(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function $2e33e814c7a8effd$var$_cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') return target[prop];
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function $2e33e814c7a8effd$var$_resolveWithContext(target, prop, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if ($2e33e814c7a8effd$export$a93c5207d687da10(value) && descriptors.isScriptable(prop)) value = $2e33e814c7a8effd$var$_resolveScriptable(prop, value, target, receiver);
    if ($2e33e814c7a8effd$export$8b22cf2602fb60ce(value) && value.length) value = $2e33e814c7a8effd$var$_resolveArray(prop, value, target, descriptors.isIndexable);
    if ($2e33e814c7a8effd$var$needsSubResolver(prop, value)) // if the resolved value is an object, create a sub resolver for it
    value = $2e33e814c7a8effd$export$c3950d9923825c02(value, _context, _subProxy && _subProxy[prop], descriptors);
    return value;
}
function $2e33e814c7a8effd$var$_resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _stack: _stack } = target;
    if (_stack.has(prop)) throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if ($2e33e814c7a8effd$var$needsSubResolver(prop, value)) // When scriptable option returns an object, create a resolver on that.
    value = $2e33e814c7a8effd$var$createSubResolver(_proxy._scopes, _proxy, prop, value);
    return value;
}
function $2e33e814c7a8effd$var$_resolveArray(prop, value, target, isIndexable) {
    const { _proxy: _proxy, _context: _context, _subProxy: _subProxy, _descriptors: descriptors } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) return value[_context.index % value.length];
    else if ($2e33e814c7a8effd$export$23f2a1d2818174ef(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = $2e33e814c7a8effd$var$createSubResolver(scopes, _proxy, prop, item);
            value.push($2e33e814c7a8effd$export$c3950d9923825c02(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function $2e33e814c7a8effd$var$resolveFallback(fallback, prop, value) {
    return $2e33e814c7a8effd$export$a93c5207d687da10(fallback) ? fallback(prop, value) : fallback;
}
const $2e33e814c7a8effd$var$getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? $2e33e814c7a8effd$export$2d1720544b23b823(parent, key) : undefined;
function $2e33e814c7a8effd$var$addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = $2e33e814c7a8effd$var$getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = $2e33e814c7a8effd$var$resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) // When we reach the descriptor that defines a new _fallback, return that.
            // The fallback will resume to that new scope.
            return fallback;
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) // Fallback to `false` results to `false`, when falling back to different key.
        // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
        return null;
    }
    return false;
}
function $2e33e814c7a8effd$var$createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = $2e33e814c7a8effd$var$resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = $2e33e814c7a8effd$var$addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) return false;
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = $2e33e814c7a8effd$var$addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) return false;
    }
    return $2e33e814c7a8effd$export$a9c996f45e5784d0(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>$2e33e814c7a8effd$var$subGetTarget(resolver, prop, value));
}
function $2e33e814c7a8effd$var$addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key)key = $2e33e814c7a8effd$var$addScopes(set, allScopes, key, fallback, item);
    return key;
}
function $2e33e814c7a8effd$var$subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) parent[prop] = {};
    const target = parent[prop];
    if ($2e33e814c7a8effd$export$8b22cf2602fb60ce(target) && $2e33e814c7a8effd$export$23f2a1d2818174ef(value)) // For array of objects, the object is used to store updated values
    return value;
    return target || {};
}
function $2e33e814c7a8effd$var$_resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = $2e33e814c7a8effd$var$_resolve($2e33e814c7a8effd$var$readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') return $2e33e814c7a8effd$var$needsSubResolver(prop, value) ? $2e33e814c7a8effd$var$createSubResolver(scopes, proxy, prop, value) : value;
    }
}
function $2e33e814c7a8effd$var$_resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) continue;
        const value = scope[key];
        if (typeof value !== 'undefined') return value;
    }
}
function $2e33e814c7a8effd$var$getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) keys = target._keys = $2e33e814c7a8effd$var$resolveKeysFromAllScopes(target._scopes);
    return keys;
}
function $2e33e814c7a8effd$var$resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes)for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_')))set.add(key);
    return Array.from(set);
}
function $2e33e814c7a8effd$export$4a5767248b18ef41(meta, data, start, count) {
    const { iScale: iScale } = meta;
    const { key: key = 'r' } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index, item;
    for(i = 0, ilen = count; i < ilen; ++i){
        index = i + start;
        item = data[index];
        parsed[i] = {
            r: iScale.parse($2e33e814c7a8effd$export$2d1720544b23b823(item, key), index)
        };
    }
    return parsed;
}
const $2e33e814c7a8effd$var$EPSILON = Number.EPSILON || 1e-14;
const $2e33e814c7a8effd$var$getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const $2e33e814c7a8effd$var$getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function $2e33e814c7a8effd$export$527e9aa3390079e9(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = $2e33e814c7a8effd$export$cf2f7c5792f80b46(current, previous);
    const d12 = $2e33e814c7a8effd$export$cf2f7c5792f80b46(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function $2e33e814c7a8effd$var$monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = $2e33e814c7a8effd$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = $2e33e814c7a8effd$var$getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) continue;
        if ($2e33e814c7a8effd$export$23ebac1979863676(deltaK[i], 0, $2e33e814c7a8effd$var$EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) continue;
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function $2e33e814c7a8effd$var$monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = $2e33e814c7a8effd$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = $2e33e814c7a8effd$var$getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $2e33e814c7a8effd$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function $2e33e814c7a8effd$export$a17c37559e1db147(points, indexAxis = 'x') {
    const valueAxis = $2e33e814c7a8effd$var$getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = $2e33e814c7a8effd$var$getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = $2e33e814c7a8effd$var$getPoint(points, i + 1);
        if (!pointCurrent) continue;
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : $2e33e814c7a8effd$export$2408f22a0fab9ae5(deltaK[i - 1]) !== $2e33e814c7a8effd$export$2408f22a0fab9ae5(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    $2e33e814c7a8effd$var$monotoneAdjust(points, deltaK, mK);
    $2e33e814c7a8effd$var$monotoneCompute(points, mK, indexAxis);
}
function $2e33e814c7a8effd$var$capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function $2e33e814c7a8effd$var$capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = $2e33e814c7a8effd$export$e7094788287c5e9b(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && $2e33e814c7a8effd$export$e7094788287c5e9b(points[i + 1], area);
        if (!inArea) continue;
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = $2e33e814c7a8effd$var$capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = $2e33e814c7a8effd$var$capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = $2e33e814c7a8effd$var$capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = $2e33e814c7a8effd$var$capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$306ddfe3a8403e2(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) points = points.filter((pt)=>!pt.skip);
    if (options.cubicInterpolationMode === 'monotone') $2e33e814c7a8effd$export$a17c37559e1db147(points, indexAxis);
    else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = $2e33e814c7a8effd$export$527e9aa3390079e9(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) $2e33e814c7a8effd$var$capBezierPoints(points, area);
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$3a1a48c8f6ef640e() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$9bb611d729802a56(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') parent = parent.host;
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function $2e33e814c7a8effd$var$parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) // percentage * size in dimension
        valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    } else valueInPixels = styleValue;
    return valueInPixels;
}
const $2e33e814c7a8effd$var$getComputedStyle = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function $2e33e814c7a8effd$export$fef3dfd9bad05307(el, property) {
    return $2e33e814c7a8effd$var$getComputedStyle(el).getPropertyValue(property);
}
const $2e33e814c7a8effd$var$positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function $2e33e814c7a8effd$var$getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = $2e33e814c7a8effd$var$positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const $2e33e814c7a8effd$var$useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function $2e33e814c7a8effd$var$getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX: offsetX, offsetY: offsetY } = source;
    let box = false;
    let x, y;
    if ($2e33e814c7a8effd$var$useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x: x,
        y: y,
        box: box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function $2e33e814c7a8effd$export$df995fae86a55f06(event, chart) {
    if ('native' in event) return event;
    const { canvas: canvas, currentDevicePixelRatio: currentDevicePixelRatio } = chart;
    const style = $2e33e814c7a8effd$var$getComputedStyle(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = $2e33e814c7a8effd$var$getPositionedStyle(style, 'padding');
    const borders = $2e33e814c7a8effd$var$getPositionedStyle(style, 'border', 'width');
    const { x: x, y: y, box: box } = $2e33e814c7a8effd$var$getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width: width, height: height } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function $2e33e814c7a8effd$var$getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && $2e33e814c7a8effd$export$9bb611d729802a56(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = $2e33e814c7a8effd$var$getComputedStyle(container);
            const containerBorder = $2e33e814c7a8effd$var$getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = $2e33e814c7a8effd$var$getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = $2e33e814c7a8effd$var$parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = $2e33e814c7a8effd$var$parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width: width,
        height: height,
        maxWidth: maxWidth || $2e33e814c7a8effd$export$53c86fa97d611818,
        maxHeight: maxHeight || $2e33e814c7a8effd$export$53c86fa97d611818
    };
}
const $2e33e814c7a8effd$var$round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function $2e33e814c7a8effd$export$2329c99376c9d0a4(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = $2e33e814c7a8effd$var$getComputedStyle(canvas);
    const margins = $2e33e814c7a8effd$var$getPositionedStyle(style, 'margin');
    const maxWidth = $2e33e814c7a8effd$var$parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || $2e33e814c7a8effd$export$53c86fa97d611818;
    const maxHeight = $2e33e814c7a8effd$var$parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || $2e33e814c7a8effd$export$53c86fa97d611818;
    const containerSize = $2e33e814c7a8effd$var$getContainerSize(canvas, bbWidth, bbHeight);
    let { width: width, height: height } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = $2e33e814c7a8effd$var$getPositionedStyle(style, 'border', 'width');
        const paddings = $2e33e814c7a8effd$var$getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = $2e33e814c7a8effd$var$round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = $2e33e814c7a8effd$var$round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) // https://github.com/chartjs/Chart.js/issues/4659
    // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
    height = $2e33e814c7a8effd$var$round1(width / 2);
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = $2e33e814c7a8effd$var$round1(Math.floor(height * aspectRatio));
    }
    return {
        width: width,
        height: height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function $2e33e814c7a8effd$export$f787f51d84a910ad(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = $2e33e814c7a8effd$var$round1(chart.height * pixelRatio);
    const deviceWidth = $2e33e814c7a8effd$var$round1(chart.width * pixelRatio);
    chart.height = $2e33e814c7a8effd$var$round1(chart.height);
    chart.width = $2e33e814c7a8effd$var$round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const $2e33e814c7a8effd$export$3466f893ebf79586 = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if ($2e33e814c7a8effd$export$3a1a48c8f6ef640e()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function $2e33e814c7a8effd$export$b4171a6734a65d42(element, property) {
    const value = $2e33e814c7a8effd$export$fef3dfd9bad05307(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$6554612db691658e(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$8a5498727ef6be21(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function $2e33e814c7a8effd$export$d24c54395ce0c509(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = $2e33e814c7a8effd$export$6554612db691658e(p1, cp1, t);
    const b = $2e33e814c7a8effd$export$6554612db691658e(cp1, cp2, t);
    const c = $2e33e814c7a8effd$export$6554612db691658e(cp2, p2, t);
    const d = $2e33e814c7a8effd$export$6554612db691658e(a, b, t);
    const e = $2e33e814c7a8effd$export$6554612db691658e(b, c, t);
    return $2e33e814c7a8effd$export$6554612db691658e(d, e, t);
}
const $2e33e814c7a8effd$var$getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') return align;
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const $2e33e814c7a8effd$var$getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function $2e33e814c7a8effd$export$91c6e00c14e7e6fd(rtl, rectX, width) {
    return rtl ? $2e33e814c7a8effd$var$getRightToLeftAdapter(rectX, width) : $2e33e814c7a8effd$var$getLeftToRightAdapter();
}
function $2e33e814c7a8effd$export$9d398bebfec1c039(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function $2e33e814c7a8effd$export$24baa2b76016ce0e(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}
function $2e33e814c7a8effd$var$propertyFn(property) {
    if (property === 'angle') return {
        between: $2e33e814c7a8effd$export$ffb5f4729a158638,
        compare: $2e33e814c7a8effd$export$f074adc9fbd50943,
        normalize: $2e33e814c7a8effd$export$ab83b03e4111b1d0
    };
    return {
        between: $2e33e814c7a8effd$export$21579262ef46735b,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function $2e33e814c7a8effd$var$normalizeSegment({ start: start, end: end, count: count, loop: loop, style: style }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style: style
    };
}
function $2e33e814c7a8effd$var$getSegment(segment, points, bounds) {
    const { property: property, start: startBound, end: endBound } = bounds;
    const { between: between, normalize: normalize } = $2e33e814c7a8effd$var$propertyFn(property);
    const count = points.length;
    let { start: start, end: end, loop: loop } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) break;
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) end += count;
    return {
        start: start,
        end: end,
        loop: loop,
        style: segment.style
    };
}
function $2e33e814c7a8effd$export$3d12bd131bb975d1(segment, points, bounds) {
    if (!bounds) return [
        segment
    ];
    const { property: property, start: startBound, end: endBound } = bounds;
    const count = points.length;
    const { compare: compare, between: between, normalize: normalize } = $2e33e814c7a8effd$var$propertyFn(property);
    const { start: start, end: end, loop: loop, style: style } = $2e33e814c7a8effd$var$getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) continue;
        value = normalize(point[property]);
        if (value === prevValue) continue;
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) subStart = compare(value, startBound) === 0 ? i : prev;
        if (subStart !== null && shouldStop()) {
            result.push($2e33e814c7a8effd$var$normalizeSegment({
                start: subStart,
                end: i,
                loop: loop,
                count: count,
                style: style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) result.push($2e33e814c7a8effd$var$normalizeSegment({
        start: subStart,
        end: end,
        loop: loop,
        count: count,
        style: style
    }));
    return result;
}
function $2e33e814c7a8effd$export$2f6ca3d3b1f80bf5(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = $2e33e814c7a8effd$export$3d12bd131bb975d1(segments[i], line.points, bounds);
        if (sub.length) result.push(...sub);
    }
    return result;
}
function $2e33e814c7a8effd$var$findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) while(start < count && !points[start].skip)start++;
    while(start < count && points[start].skip)start++;
    start %= count;
    if (loop) end += start;
    while(end > start && points[end % count].skip)end--;
    end %= count;
    return {
        start: start,
        end: end
    };
}
function $2e33e814c7a8effd$var$solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop: loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) start = end;
        }
        prev = cur;
    }
    if (last !== null) result.push({
        start: start % count,
        end: last % count,
        loop: loop
    });
    return result;
}
function $2e33e814c7a8effd$export$7a38258bbe170828(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) return [];
    const loop = !!line._loop;
    const { start: start, end: end } = $2e33e814c7a8effd$var$findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) return $2e33e814c7a8effd$var$splitByStyles(line, [
        {
            start: start,
            end: end,
            loop: loop
        }
    ], points, segmentOptions);
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return $2e33e814c7a8effd$var$splitByStyles(line, $2e33e814c7a8effd$var$solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function $2e33e814c7a8effd$var$splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) return segments;
    return $2e33e814c7a8effd$var$doSplitByStyles(line, segments, points, segmentOptions);
}
function $2e33e814c7a8effd$var$doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = $2e33e814c7a8effd$var$readStyle(line.options);
    const { _datasetIndex: datasetIndex, options: { spanGaps: spanGaps } } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) return;
        s += count;
        while(points[s % count].skip)s -= dir;
        while(points[e % count].skip)e += dir;
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = $2e33e814c7a8effd$var$readStyle(segmentOptions.setContext($2e33e814c7a8effd$export$35e795649ee09318(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex: datasetIndex
            })));
            if ($2e33e814c7a8effd$var$styleChanged(style, prevStyle)) addStyle(start, i - 1, segment.loop, prevStyle);
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) addStyle(start, i - 1, segment.loop, prevStyle);
    }
    return result;
}
function $2e33e814c7a8effd$var$readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function $2e33e814c7a8effd$var$styleChanged(style, prevStyle) {
    if (!prevStyle) return false;
    const cache = [];
    const replacer = function(key, value) {
        if (!$2e33e814c7a8effd$export$738ab4df8bf92ae9(value)) return value;
        if (!cache.includes(value)) cache.push(value);
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}
function $2e33e814c7a8effd$var$getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function $2e33e814c7a8effd$var$getDatasetArea(meta, chartArea) {
    const { xScale: xScale, yScale: yScale } = meta;
    if (xScale && yScale) return {
        left: $2e33e814c7a8effd$var$getSizeForArea(xScale, chartArea, 'left'),
        right: $2e33e814c7a8effd$var$getSizeForArea(xScale, chartArea, 'right'),
        top: $2e33e814c7a8effd$var$getSizeForArea(yScale, chartArea, 'top'),
        bottom: $2e33e814c7a8effd$var$getSizeForArea(yScale, chartArea, 'bottom')
    };
    return chartArea;
}
function $2e33e814c7a8effd$export$995eb9fca571757(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) return false;
    const area = $2e33e814c7a8effd$var$getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}

});
parcelRegister("eWgaQ", function(module, exports) {

$parcel$export(module.exports, "Color", function () { return $ae03074569f2ca11$export$892596cec99bc70e; });
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */ function $ae03074569f2ca11$export$2077e0241d6afd3c(v) {
    return v + 0.5 | 0;
}
const $ae03074569f2ca11$export$837ba5c449269406 = (v, l, h)=>Math.max(Math.min(v, h), l);
function $ae03074569f2ca11$export$bcc6e673dfa14d36(v) {
    return $ae03074569f2ca11$export$837ba5c449269406($ae03074569f2ca11$export$2077e0241d6afd3c(v * 2.55), 0, 255);
}
function $ae03074569f2ca11$export$869b26d4e1bbdb63(v) {
    return $ae03074569f2ca11$export$837ba5c449269406($ae03074569f2ca11$export$2077e0241d6afd3c(v / 2.55), 0, 100);
}
function $ae03074569f2ca11$export$ed9bd8dcaeba14f6(v) {
    return $ae03074569f2ca11$export$837ba5c449269406($ae03074569f2ca11$export$2077e0241d6afd3c(v * 255), 0, 255);
}
function $ae03074569f2ca11$export$dbf961a8d278dbef(v) {
    return $ae03074569f2ca11$export$837ba5c449269406($ae03074569f2ca11$export$2077e0241d6afd3c(v / 2.55) / 100, 0, 1);
}
function $ae03074569f2ca11$export$aa35ef1f24408ab9(v) {
    return $ae03074569f2ca11$export$837ba5c449269406($ae03074569f2ca11$export$2077e0241d6afd3c(v * 100), 0, 100);
}
const $ae03074569f2ca11$var$map$1 = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 10,
    B: 11,
    C: 12,
    D: 13,
    E: 14,
    F: 15,
    a: 10,
    b: 11,
    c: 12,
    d: 13,
    e: 14,
    f: 15
};
const $ae03074569f2ca11$var$hex = [
    ...'0123456789ABCDEF'
];
const $ae03074569f2ca11$var$h1 = (b)=>$ae03074569f2ca11$var$hex[b & 0xF];
const $ae03074569f2ca11$var$h2 = (b)=>$ae03074569f2ca11$var$hex[(b & 0xF0) >> 4] + $ae03074569f2ca11$var$hex[b & 0xF];
const $ae03074569f2ca11$var$eq = (b)=>(b & 0xF0) >> 4 === (b & 0xF);
const $ae03074569f2ca11$var$isShort = (v)=>$ae03074569f2ca11$var$eq(v.r) && $ae03074569f2ca11$var$eq(v.g) && $ae03074569f2ca11$var$eq(v.b) && $ae03074569f2ca11$var$eq(v.a);
function $ae03074569f2ca11$export$625a38b961e8b5e9(str) {
    var len = str.length;
    var ret;
    if (str[0] === '#') {
        if (len === 4 || len === 5) ret = {
            r: 255 & $ae03074569f2ca11$var$map$1[str[1]] * 17,
            g: 255 & $ae03074569f2ca11$var$map$1[str[2]] * 17,
            b: 255 & $ae03074569f2ca11$var$map$1[str[3]] * 17,
            a: len === 5 ? $ae03074569f2ca11$var$map$1[str[4]] * 17 : 255
        };
        else if (len === 7 || len === 9) ret = {
            r: $ae03074569f2ca11$var$map$1[str[1]] << 4 | $ae03074569f2ca11$var$map$1[str[2]],
            g: $ae03074569f2ca11$var$map$1[str[3]] << 4 | $ae03074569f2ca11$var$map$1[str[4]],
            b: $ae03074569f2ca11$var$map$1[str[5]] << 4 | $ae03074569f2ca11$var$map$1[str[6]],
            a: len === 9 ? $ae03074569f2ca11$var$map$1[str[7]] << 4 | $ae03074569f2ca11$var$map$1[str[8]] : 255
        };
    }
    return ret;
}
const $ae03074569f2ca11$var$alpha = (a, f)=>a < 255 ? f(a) : '';
function $ae03074569f2ca11$export$1b06654353ef9f67(v) {
    var f = $ae03074569f2ca11$var$isShort(v) ? $ae03074569f2ca11$var$h1 : $ae03074569f2ca11$var$h2;
    return v ? '#' + f(v.r) + f(v.g) + f(v.b) + $ae03074569f2ca11$var$alpha(v.a, f) : undefined;
}
const $ae03074569f2ca11$var$HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function $ae03074569f2ca11$var$hsl2rgbn(h, s, l) {
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return [
        f(0),
        f(8),
        f(4)
    ];
}
function $ae03074569f2ca11$var$hsv2rgbn(h, s, v) {
    const f = (n, k = (n + h / 60) % 6)=>v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    return [
        f(5),
        f(3),
        f(1)
    ];
}
function $ae03074569f2ca11$var$hwb2rgbn(h, w, b) {
    const rgb = $ae03074569f2ca11$var$hsl2rgbn(h, 1, 0.5);
    let i;
    if (w + b > 1) {
        i = 1 / (w + b);
        w *= i;
        b *= i;
    }
    for(i = 0; i < 3; i++){
        rgb[i] *= 1 - w - b;
        rgb[i] += w;
    }
    return rgb;
}
function $ae03074569f2ca11$var$hueValue(r, g, b, d, max) {
    if (r === max) return (g - b) / d + (g < b ? 6 : 0);
    if (g === max) return (b - r) / d + 2;
    return (r - g) / d + 4;
}
function $ae03074569f2ca11$export$b5ba70b240f8f7f(v) {
    const range = 255;
    const r = v.r / range;
    const g = v.g / range;
    const b = v.b / range;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const l = (max + min) / 2;
    let h, s, d;
    if (max !== min) {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = $ae03074569f2ca11$var$hueValue(r, g, b, d, max);
        h = h * 60 + 0.5;
    }
    return [
        h | 0,
        s || 0,
        l
    ];
}
function $ae03074569f2ca11$var$calln(f, a, b, c) {
    return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map($ae03074569f2ca11$export$ed9bd8dcaeba14f6);
}
function $ae03074569f2ca11$export$4c15bd42559b811d(h, s, l) {
    return $ae03074569f2ca11$var$calln($ae03074569f2ca11$var$hsl2rgbn, h, s, l);
}
function $ae03074569f2ca11$export$e2710022c70fc9ee(h, w, b) {
    return $ae03074569f2ca11$var$calln($ae03074569f2ca11$var$hwb2rgbn, h, w, b);
}
function $ae03074569f2ca11$export$b785a357c84e4a04(h, s, v) {
    return $ae03074569f2ca11$var$calln($ae03074569f2ca11$var$hsv2rgbn, h, s, v);
}
function $ae03074569f2ca11$var$hue(h) {
    return (h % 360 + 360) % 360;
}
function $ae03074569f2ca11$export$5e91288c399be4f9(str) {
    const m = $ae03074569f2ca11$var$HUE_RE.exec(str);
    let a = 255;
    let v;
    if (!m) return;
    if (m[5] !== v) a = m[6] ? $ae03074569f2ca11$export$bcc6e673dfa14d36(+m[5]) : $ae03074569f2ca11$export$ed9bd8dcaeba14f6(+m[5]);
    const h = $ae03074569f2ca11$var$hue(+m[2]);
    const p1 = +m[3] / 100;
    const p2 = +m[4] / 100;
    if (m[1] === 'hwb') v = $ae03074569f2ca11$export$e2710022c70fc9ee(h, p1, p2);
    else if (m[1] === 'hsv') v = $ae03074569f2ca11$export$b785a357c84e4a04(h, p1, p2);
    else v = $ae03074569f2ca11$export$4c15bd42559b811d(h, p1, p2);
    return {
        r: v[0],
        g: v[1],
        b: v[2],
        a: a
    };
}
function $ae03074569f2ca11$export$bb628a54ab399bc9(v, deg) {
    var h = $ae03074569f2ca11$export$b5ba70b240f8f7f(v);
    h[0] = $ae03074569f2ca11$var$hue(h[0] + deg);
    h = $ae03074569f2ca11$export$4c15bd42559b811d(h);
    v.r = h[0];
    v.g = h[1];
    v.b = h[2];
}
function $ae03074569f2ca11$export$a197af1c58e6260c(v) {
    if (!v) return;
    const a = $ae03074569f2ca11$export$b5ba70b240f8f7f(v);
    const h = a[0];
    const s = $ae03074569f2ca11$export$aa35ef1f24408ab9(a[1]);
    const l = $ae03074569f2ca11$export$aa35ef1f24408ab9(a[2]);
    return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${$ae03074569f2ca11$export$dbf961a8d278dbef(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
const $ae03074569f2ca11$var$map = {
    x: 'dark',
    Z: 'light',
    Y: 're',
    X: 'blu',
    W: 'gr',
    V: 'medium',
    U: 'slate',
    A: 'ee',
    T: 'ol',
    S: 'or',
    B: 'ra',
    C: 'lateg',
    D: 'ights',
    R: 'in',
    Q: 'turquois',
    E: 'hi',
    P: 'ro',
    O: 'al',
    N: 'le',
    M: 'de',
    L: 'yello',
    F: 'en',
    K: 'ch',
    G: 'arks',
    H: 'ea',
    I: 'ightg',
    J: 'wh'
};
const $ae03074569f2ca11$var$names$1 = {
    OiceXe: 'f0f8ff',
    antiquewEte: 'faebd7',
    aqua: 'ffff',
    aquamarRe: '7fffd4',
    azuY: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '0',
    blanKedOmond: 'ffebcd',
    Xe: 'ff',
    XeviTet: '8a2be2',
    bPwn: 'a52a2a',
    burlywood: 'deb887',
    caMtXe: '5f9ea0',
    KartYuse: '7fff00',
    KocTate: 'd2691e',
    cSO: 'ff7f50',
    cSnflowerXe: '6495ed',
    cSnsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: 'ffff',
    xXe: '8b',
    xcyan: '8b8b',
    xgTMnPd: 'b8860b',
    xWay: 'a9a9a9',
    xgYF: '6400',
    xgYy: 'a9a9a9',
    xkhaki: 'bdb76b',
    xmagFta: '8b008b',
    xTivegYF: '556b2f',
    xSange: 'ff8c00',
    xScEd: '9932cc',
    xYd: '8b0000',
    xsOmon: 'e9967a',
    xsHgYF: '8fbc8f',
    xUXe: '483d8b',
    xUWay: '2f4f4f',
    xUgYy: '2f4f4f',
    xQe: 'ced1',
    xviTet: '9400d3',
    dAppRk: 'ff1493',
    dApskyXe: 'bfff',
    dimWay: '696969',
    dimgYy: '696969',
    dodgerXe: '1e90ff',
    fiYbrick: 'b22222',
    flSOwEte: 'fffaf0',
    foYstWAn: '228b22',
    fuKsia: 'ff00ff',
    gaRsbSo: 'dcdcdc',
    ghostwEte: 'f8f8ff',
    gTd: 'ffd700',
    gTMnPd: 'daa520',
    Way: '808080',
    gYF: '8000',
    gYFLw: 'adff2f',
    gYy: '808080',
    honeyMw: 'f0fff0',
    hotpRk: 'ff69b4',
    RdianYd: 'cd5c5c',
    Rdigo: '4b0082',
    ivSy: 'fffff0',
    khaki: 'f0e68c',
    lavFMr: 'e6e6fa',
    lavFMrXsh: 'fff0f5',
    lawngYF: '7cfc00',
    NmoncEffon: 'fffacd',
    ZXe: 'add8e6',
    ZcSO: 'f08080',
    Zcyan: 'e0ffff',
    ZgTMnPdLw: 'fafad2',
    ZWay: 'd3d3d3',
    ZgYF: '90ee90',
    ZgYy: 'd3d3d3',
    ZpRk: 'ffb6c1',
    ZsOmon: 'ffa07a',
    ZsHgYF: '20b2aa',
    ZskyXe: '87cefa',
    ZUWay: '778899',
    ZUgYy: '778899',
    ZstAlXe: 'b0c4de',
    ZLw: 'ffffe0',
    lime: 'ff00',
    limegYF: '32cd32',
    lRF: 'faf0e6',
    magFta: 'ff00ff',
    maPon: '800000',
    VaquamarRe: '66cdaa',
    VXe: 'cd',
    VScEd: 'ba55d3',
    VpurpN: '9370db',
    VsHgYF: '3cb371',
    VUXe: '7b68ee',
    VsprRggYF: 'fa9a',
    VQe: '48d1cc',
    VviTetYd: 'c71585',
    midnightXe: '191970',
    mRtcYam: 'f5fffa',
    mistyPse: 'ffe4e1',
    moccasR: 'ffe4b5',
    navajowEte: 'ffdead',
    navy: '80',
    Tdlace: 'fdf5e6',
    Tive: '808000',
    TivedBb: '6b8e23',
    Sange: 'ffa500',
    SangeYd: 'ff4500',
    ScEd: 'da70d6',
    pOegTMnPd: 'eee8aa',
    pOegYF: '98fb98',
    pOeQe: 'afeeee',
    pOeviTetYd: 'db7093',
    papayawEp: 'ffefd5',
    pHKpuff: 'ffdab9',
    peru: 'cd853f',
    pRk: 'ffc0cb',
    plum: 'dda0dd',
    powMrXe: 'b0e0e6',
    purpN: '800080',
    YbeccapurpN: '663399',
    Yd: 'ff0000',
    Psybrown: 'bc8f8f',
    PyOXe: '4169e1',
    saddNbPwn: '8b4513',
    sOmon: 'fa8072',
    sandybPwn: 'f4a460',
    sHgYF: '2e8b57',
    sHshell: 'fff5ee',
    siFna: 'a0522d',
    silver: 'c0c0c0',
    skyXe: '87ceeb',
    UXe: '6a5acd',
    UWay: '708090',
    UgYy: '708090',
    snow: 'fffafa',
    sprRggYF: 'ff7f',
    stAlXe: '4682b4',
    tan: 'd2b48c',
    teO: '8080',
    tEstN: 'd8bfd8',
    tomato: 'ff6347',
    Qe: '40e0d0',
    viTet: 'ee82ee',
    JHt: 'f5deb3',
    wEte: 'ffffff',
    wEtesmoke: 'f5f5f5',
    Lw: 'ffff00',
    LwgYF: '9acd32'
};
function $ae03074569f2ca11$var$unpack() {
    const unpacked = {};
    const keys = Object.keys($ae03074569f2ca11$var$names$1);
    const tkeys = Object.keys($ae03074569f2ca11$var$map);
    let i, j, k, ok, nk;
    for(i = 0; i < keys.length; i++){
        ok = nk = keys[i];
        for(j = 0; j < tkeys.length; j++){
            k = tkeys[j];
            nk = nk.replace(k, $ae03074569f2ca11$var$map[k]);
        }
        k = parseInt($ae03074569f2ca11$var$names$1[ok], 16);
        unpacked[nk] = [
            k >> 16 & 0xFF,
            k >> 8 & 0xFF,
            k & 0xFF
        ];
    }
    return unpacked;
}
let $ae03074569f2ca11$var$names;
function $ae03074569f2ca11$export$b2f06b640faad956(str) {
    if (!$ae03074569f2ca11$var$names) {
        $ae03074569f2ca11$var$names = $ae03074569f2ca11$var$unpack();
        $ae03074569f2ca11$var$names.transparent = [
            0,
            0,
            0,
            0
        ];
    }
    const a = $ae03074569f2ca11$var$names[str.toLowerCase()];
    return a && {
        r: a[0],
        g: a[1],
        b: a[2],
        a: a.length === 4 ? a[3] : 255
    };
}
const $ae03074569f2ca11$var$RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function $ae03074569f2ca11$export$91aedb20f296e541(str) {
    const m = $ae03074569f2ca11$var$RGB_RE.exec(str);
    let a = 255;
    let r, g, b;
    if (!m) return;
    if (m[7] !== r) {
        const v = +m[7];
        a = m[8] ? $ae03074569f2ca11$export$bcc6e673dfa14d36(v) : $ae03074569f2ca11$export$837ba5c449269406(v * 255, 0, 255);
    }
    r = +m[1];
    g = +m[3];
    b = +m[5];
    r = 255 & (m[2] ? $ae03074569f2ca11$export$bcc6e673dfa14d36(r) : $ae03074569f2ca11$export$837ba5c449269406(r, 0, 255));
    g = 255 & (m[4] ? $ae03074569f2ca11$export$bcc6e673dfa14d36(g) : $ae03074569f2ca11$export$837ba5c449269406(g, 0, 255));
    b = 255 & (m[6] ? $ae03074569f2ca11$export$bcc6e673dfa14d36(b) : $ae03074569f2ca11$export$837ba5c449269406(b, 0, 255));
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $ae03074569f2ca11$export$9595423f22cf925a(v) {
    return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${$ae03074569f2ca11$export$dbf961a8d278dbef(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
const $ae03074569f2ca11$var$to = (v)=>v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const $ae03074569f2ca11$var$from = (v)=>v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function $ae03074569f2ca11$var$interpolate(rgb1, rgb2, t) {
    const r = $ae03074569f2ca11$var$from($ae03074569f2ca11$export$dbf961a8d278dbef(rgb1.r));
    const g = $ae03074569f2ca11$var$from($ae03074569f2ca11$export$dbf961a8d278dbef(rgb1.g));
    const b = $ae03074569f2ca11$var$from($ae03074569f2ca11$export$dbf961a8d278dbef(rgb1.b));
    return {
        r: $ae03074569f2ca11$export$ed9bd8dcaeba14f6($ae03074569f2ca11$var$to(r + t * ($ae03074569f2ca11$var$from($ae03074569f2ca11$export$dbf961a8d278dbef(rgb2.r)) - r))),
        g: $ae03074569f2ca11$export$ed9bd8dcaeba14f6($ae03074569f2ca11$var$to(g + t * ($ae03074569f2ca11$var$from($ae03074569f2ca11$export$dbf961a8d278dbef(rgb2.g)) - g))),
        b: $ae03074569f2ca11$export$ed9bd8dcaeba14f6($ae03074569f2ca11$var$to(b + t * ($ae03074569f2ca11$var$from($ae03074569f2ca11$export$dbf961a8d278dbef(rgb2.b)) - b))),
        a: rgb1.a + t * (rgb2.a - rgb1.a)
    };
}
function $ae03074569f2ca11$var$modHSL(v, i, ratio) {
    if (v) {
        let tmp = $ae03074569f2ca11$export$b5ba70b240f8f7f(v);
        tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
        tmp = $ae03074569f2ca11$export$4c15bd42559b811d(tmp);
        v.r = tmp[0];
        v.g = tmp[1];
        v.b = tmp[2];
    }
}
function $ae03074569f2ca11$var$clone(v, proto) {
    return v ? Object.assign(proto || {}, v) : v;
}
function $ae03074569f2ca11$var$fromObject(input) {
    var v = {
        r: 0,
        g: 0,
        b: 0,
        a: 255
    };
    if (Array.isArray(input)) {
        if (input.length >= 3) {
            v = {
                r: input[0],
                g: input[1],
                b: input[2],
                a: 255
            };
            if (input.length > 3) v.a = $ae03074569f2ca11$export$ed9bd8dcaeba14f6(input[3]);
        }
    } else {
        v = $ae03074569f2ca11$var$clone(input, {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        });
        v.a = $ae03074569f2ca11$export$ed9bd8dcaeba14f6(v.a);
    }
    return v;
}
function $ae03074569f2ca11$var$functionParse(str) {
    if (str.charAt(0) === 'r') return $ae03074569f2ca11$export$91aedb20f296e541(str);
    return $ae03074569f2ca11$export$5e91288c399be4f9(str);
}
class $ae03074569f2ca11$export$892596cec99bc70e {
    constructor(input){
        if (input instanceof $ae03074569f2ca11$export$892596cec99bc70e) return input;
        const type = typeof input;
        let v;
        if (type === 'object') v = $ae03074569f2ca11$var$fromObject(input);
        else if (type === 'string') v = $ae03074569f2ca11$export$625a38b961e8b5e9(input) || $ae03074569f2ca11$export$b2f06b640faad956(input) || $ae03074569f2ca11$var$functionParse(input);
        this._rgb = v;
        this._valid = !!v;
    }
    get valid() {
        return this._valid;
    }
    get rgb() {
        var v = $ae03074569f2ca11$var$clone(this._rgb);
        if (v) v.a = $ae03074569f2ca11$export$dbf961a8d278dbef(v.a);
        return v;
    }
    set rgb(obj) {
        this._rgb = $ae03074569f2ca11$var$fromObject(obj);
    }
    rgbString() {
        return this._valid ? $ae03074569f2ca11$export$9595423f22cf925a(this._rgb) : undefined;
    }
    hexString() {
        return this._valid ? $ae03074569f2ca11$export$1b06654353ef9f67(this._rgb) : undefined;
    }
    hslString() {
        return this._valid ? $ae03074569f2ca11$export$a197af1c58e6260c(this._rgb) : undefined;
    }
    mix(color, weight) {
        if (color) {
            const c1 = this.rgb;
            const c2 = color.rgb;
            let w2;
            const p = weight === w2 ? 0.5 : weight;
            const w = 2 * p - 1;
            const a = c1.a - c2.a;
            const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
            w2 = 1 - w1;
            c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
            c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
            c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
            c1.a = p * c1.a + (1 - p) * c2.a;
            this.rgb = c1;
        }
        return this;
    }
    interpolate(color, t) {
        if (color) this._rgb = $ae03074569f2ca11$var$interpolate(this._rgb, color._rgb, t);
        return this;
    }
    clone() {
        return new $ae03074569f2ca11$export$892596cec99bc70e(this.rgb);
    }
    alpha(a) {
        this._rgb.a = $ae03074569f2ca11$export$ed9bd8dcaeba14f6(a);
        return this;
    }
    clearer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 - ratio;
        return this;
    }
    greyscale() {
        const rgb = this._rgb;
        const val = $ae03074569f2ca11$export$2077e0241d6afd3c(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
        rgb.r = rgb.g = rgb.b = val;
        return this;
    }
    opaquer(ratio) {
        const rgb = this._rgb;
        rgb.a *= 1 + ratio;
        return this;
    }
    negate() {
        const v = this._rgb;
        v.r = 255 - v.r;
        v.g = 255 - v.g;
        v.b = 255 - v.b;
        return this;
    }
    lighten(ratio) {
        $ae03074569f2ca11$var$modHSL(this._rgb, 2, ratio);
        return this;
    }
    darken(ratio) {
        $ae03074569f2ca11$var$modHSL(this._rgb, 2, -ratio);
        return this;
    }
    saturate(ratio) {
        $ae03074569f2ca11$var$modHSL(this._rgb, 1, ratio);
        return this;
    }
    desaturate(ratio) {
        $ae03074569f2ca11$var$modHSL(this._rgb, 1, -ratio);
        return this;
    }
    rotate(deg) {
        $ae03074569f2ca11$export$bb628a54ab399bc9(this._rgb, deg);
        return this;
    }
}
function $ae03074569f2ca11$export$2e2bcd8739ae039(input) {
    return new $ae03074569f2ca11$export$892596cec99bc70e(input);
}

});



parcelRegister("bYaDZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b6d8df5dd026b13$export$2e2bcd8739ae039; });
// deno-fmt-ignore-file
// deno-lint-ignore-file
// This code was bundled using `deno bundle` and it's not recommended to edit it manually
var $8b6d8df5dd026b13$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
};
var $8b6d8df5dd026b13$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
};
var $8b6d8df5dd026b13$var$_block, $8b6d8df5dd026b13$var$_blocks, $8b6d8df5dd026b13$var$_bytes, $8b6d8df5dd026b13$var$_finalized, $8b6d8df5dd026b13$var$_first, $8b6d8df5dd026b13$var$_h0, $8b6d8df5dd026b13$var$_h1, $8b6d8df5dd026b13$var$_h2, $8b6d8df5dd026b13$var$_h3, $8b6d8df5dd026b13$var$_h4, $8b6d8df5dd026b13$var$_h5, $8b6d8df5dd026b13$var$_h6, $8b6d8df5dd026b13$var$_h7, $8b6d8df5dd026b13$var$_hashed, $8b6d8df5dd026b13$var$_hBytes, $8b6d8df5dd026b13$var$_is224, $8b6d8df5dd026b13$var$_lastByteIndex, $8b6d8df5dd026b13$var$_start;
const $8b6d8df5dd026b13$var$BKDRHash = function(str) {
    var seed = 131;
    var seed2 = 137;
    var hash = 0;
    str += 'x';
    var MAX_SAFE_INTEGER = Math.floor(9007199254740991 / seed2);
    for(let i = 0; i < str.length; i++){
        if (hash > MAX_SAFE_INTEGER) hash = Math.floor(hash / seed2);
        hash = hash * seed + str.charCodeAt(i);
    }
    return hash;
};
const $8b6d8df5dd026b13$var$HEX_CHARS = "0123456789abcdef".split("");
const $8b6d8df5dd026b13$var$EXTRA = [
    -2147483648,
    8388608,
    32768,
    128
];
const $8b6d8df5dd026b13$var$SHIFT = [
    24,
    16,
    8,
    0
];
const $8b6d8df5dd026b13$var$K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
const $8b6d8df5dd026b13$var$blocks = [];
class $8b6d8df5dd026b13$var$Sha256 {
    constructor(is224 = false, sharedMemory = false){
        $8b6d8df5dd026b13$var$_block.set(this, void 0);
        $8b6d8df5dd026b13$var$_blocks.set(this, void 0);
        $8b6d8df5dd026b13$var$_bytes.set(this, void 0);
        $8b6d8df5dd026b13$var$_finalized.set(this, void 0);
        $8b6d8df5dd026b13$var$_first.set(this, void 0);
        $8b6d8df5dd026b13$var$_h0.set(this, void 0);
        $8b6d8df5dd026b13$var$_h1.set(this, void 0);
        $8b6d8df5dd026b13$var$_h2.set(this, void 0);
        $8b6d8df5dd026b13$var$_h3.set(this, void 0);
        $8b6d8df5dd026b13$var$_h4.set(this, void 0);
        $8b6d8df5dd026b13$var$_h5.set(this, void 0);
        $8b6d8df5dd026b13$var$_h6.set(this, void 0);
        $8b6d8df5dd026b13$var$_h7.set(this, void 0);
        $8b6d8df5dd026b13$var$_hashed.set(this, void 0);
        $8b6d8df5dd026b13$var$_hBytes.set(this, void 0);
        $8b6d8df5dd026b13$var$_is224.set(this, void 0);
        $8b6d8df5dd026b13$var$_lastByteIndex.set(this, 0);
        $8b6d8df5dd026b13$var$_start.set(this, void 0);
        this.init(is224, sharedMemory);
    }
    init(is224, sharedMemory) {
        if (sharedMemory) {
            $8b6d8df5dd026b13$var$blocks[0] = $8b6d8df5dd026b13$var$blocks[16] = $8b6d8df5dd026b13$var$blocks[1] = $8b6d8df5dd026b13$var$blocks[2] = $8b6d8df5dd026b13$var$blocks[3] = $8b6d8df5dd026b13$var$blocks[4] = $8b6d8df5dd026b13$var$blocks[5] = $8b6d8df5dd026b13$var$blocks[6] = $8b6d8df5dd026b13$var$blocks[7] = $8b6d8df5dd026b13$var$blocks[8] = $8b6d8df5dd026b13$var$blocks[9] = $8b6d8df5dd026b13$var$blocks[10] = $8b6d8df5dd026b13$var$blocks[11] = $8b6d8df5dd026b13$var$blocks[12] = $8b6d8df5dd026b13$var$blocks[13] = $8b6d8df5dd026b13$var$blocks[14] = $8b6d8df5dd026b13$var$blocks[15] = 0;
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_blocks, $8b6d8df5dd026b13$var$blocks);
        } else $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_blocks, [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]);
        if (is224) {
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h0, 0xc1059ed8);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h1, 0x367cd507);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h2, 0x3070dd17);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h3, 0xf70e5939);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h4, 0xffc00b31);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h5, 0x68581511);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h6, 0x64f98fa7);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h7, 0xbefa4fa4);
        } else {
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h0, 0x6a09e667);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h1, 0xbb67ae85);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h2, 0x3c6ef372);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h3, 0xa54ff53a);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h4, 0x510e527f);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h5, 0x9b05688c);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h6, 0x1f83d9ab);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h7, 0x5be0cd19);
        }
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_block, $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_start, $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_bytes, $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_hBytes, 0))));
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_finalized, $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_hashed, false));
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_first, true);
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_is224, is224);
    }
    update(message) {
        if ($8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_finalized)) return this;
        let msg;
        if (message instanceof ArrayBuffer) msg = new Uint8Array(message);
        else msg = message;
        let index = 0;
        const length = msg.length;
        const blocks = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_blocks);
        while(index < length){
            let i;
            if ($8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_hashed)) {
                $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_hashed, false);
                blocks[0] = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_block);
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (typeof msg !== "string") for(i = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_start); index < length && i < 64; ++index)blocks[i >> 2] |= msg[index] << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
            else for(i = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_start); index < length && i < 64; ++index){
                let code = msg.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | msg.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << $8b6d8df5dd026b13$var$SHIFT[i++ & 3];
                }
            }
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_lastByteIndex, i);
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_bytes, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_bytes) + (i - $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_start)));
            if (i >= 64) {
                $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_block, blocks[16]);
                $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_start, i - 64);
                this.hash();
                $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_hashed, true);
            } else $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_start, i);
        }
        if ($8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_bytes) > 4294967295) {
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_hBytes, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_hBytes) + ($8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_bytes) / 4294967296 << 0));
            $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_bytes, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_bytes) % 4294967296);
        }
        return this;
    }
    finalize() {
        if ($8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_finalized)) return;
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_finalized, true);
        const blocks = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_blocks);
        const i = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_lastByteIndex);
        blocks[16] = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_block);
        blocks[i >> 2] |= $8b6d8df5dd026b13$var$EXTRA[i & 3];
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_block, blocks[16]);
        if (i >= 56) {
            if (!$8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_hashed)) this.hash();
            blocks[0] = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_block);
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_hBytes) << 3 | $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_bytes) >>> 29;
        blocks[15] = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_bytes) << 3;
        this.hash();
    }
    hash() {
        let a = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h0);
        let b = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h1);
        let c = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h2);
        let d = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h3);
        let e = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h4);
        let f = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h5);
        let g = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h6);
        let h = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h7);
        const blocks = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_blocks);
        let s0;
        let s1;
        let maj;
        let t1;
        let t2;
        let ch;
        let ab;
        let da;
        let cd;
        let bc;
        for(let j = 16; j < 64; ++j){
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(let j1 = 0; j1 < 64; j1 += 4){
            if ($8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_first)) {
                if ($8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_is224)) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_first, false);
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + $8b6d8df5dd026b13$var$K[j1] + blocks[j1];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + $8b6d8df5dd026b13$var$K[j1 + 1] + blocks[j1 + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + $8b6d8df5dd026b13$var$K[j1 + 2] + blocks[j1 + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + $8b6d8df5dd026b13$var$K[j1 + 3] + blocks[j1 + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
        }
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h0, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h0) + a << 0);
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h1, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h1) + b << 0);
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h2, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h2) + c << 0);
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h3, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h3) + d << 0);
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h4, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h4) + e << 0);
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h5, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h5) + f << 0);
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h6, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h6) + g << 0);
        $8b6d8df5dd026b13$var$__classPrivateFieldSet(this, $8b6d8df5dd026b13$var$_h7, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h7) + h << 0);
    }
    hex() {
        this.finalize();
        const h0 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h0);
        const h1 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h1);
        const h2 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h2);
        const h3 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h3);
        const h4 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h4);
        const h5 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h5);
        const h6 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h6);
        const h7 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h7);
        let hex = $8b6d8df5dd026b13$var$HEX_CHARS[h0 >> 28 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h0 >> 24 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h0 >> 20 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h0 >> 16 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h0 >> 12 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h0 >> 8 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h0 >> 4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h0 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h1 >> 28 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h1 >> 24 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h1 >> 20 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h1 >> 16 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h1 >> 12 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h1 >> 8 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h1 >> 4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h1 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h2 >> 28 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h2 >> 24 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h2 >> 20 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h2 >> 16 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h2 >> 12 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h2 >> 8 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h2 >> 4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h2 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h3 >> 28 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h3 >> 24 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h3 >> 20 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h3 >> 16 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h3 >> 12 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h3 >> 8 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h3 >> 4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h3 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h4 >> 28 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h4 >> 24 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h4 >> 20 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h4 >> 16 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h4 >> 12 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h4 >> 8 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h4 >> 4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h5 >> 28 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h5 >> 24 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h5 >> 20 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h5 >> 16 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h5 >> 12 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h5 >> 8 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h5 >> 4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h5 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h6 >> 28 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h6 >> 24 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h6 >> 20 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h6 >> 16 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h6 >> 12 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h6 >> 8 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h6 >> 4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h6 & 0x0f];
        if (!$8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_is224)) hex += $8b6d8df5dd026b13$var$HEX_CHARS[h7 >> 28 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h7 >> 24 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h7 >> 20 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h7 >> 16 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h7 >> 12 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h7 >> 8 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h7 >> 4 & 0x0f] + $8b6d8df5dd026b13$var$HEX_CHARS[h7 & 0x0f];
        return hex;
    }
    toString() {
        return this.hex();
    }
    digest() {
        this.finalize();
        const h0 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h0);
        const h1 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h1);
        const h2 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h2);
        const h3 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h3);
        const h4 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h4);
        const h5 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h5);
        const h6 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h6);
        const h7 = $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h7);
        const arr = [
            h0 >> 24 & 0xff,
            h0 >> 16 & 0xff,
            h0 >> 8 & 0xff,
            h0 & 0xff,
            h1 >> 24 & 0xff,
            h1 >> 16 & 0xff,
            h1 >> 8 & 0xff,
            h1 & 0xff,
            h2 >> 24 & 0xff,
            h2 >> 16 & 0xff,
            h2 >> 8 & 0xff,
            h2 & 0xff,
            h3 >> 24 & 0xff,
            h3 >> 16 & 0xff,
            h3 >> 8 & 0xff,
            h3 & 0xff,
            h4 >> 24 & 0xff,
            h4 >> 16 & 0xff,
            h4 >> 8 & 0xff,
            h4 & 0xff,
            h5 >> 24 & 0xff,
            h5 >> 16 & 0xff,
            h5 >> 8 & 0xff,
            h5 & 0xff,
            h6 >> 24 & 0xff,
            h6 >> 16 & 0xff,
            h6 >> 8 & 0xff,
            h6 & 0xff
        ];
        if (!$8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_is224)) arr.push(h7 >> 24 & 0xff, h7 >> 16 & 0xff, h7 >> 8 & 0xff, h7 & 0xff);
        return arr;
    }
    array() {
        return this.digest();
    }
    arrayBuffer() {
        this.finalize();
        const buffer = new ArrayBuffer($8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_is224) ? 28 : 32);
        const dataView = new DataView(buffer);
        dataView.setUint32(0, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h0));
        dataView.setUint32(4, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h1));
        dataView.setUint32(8, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h2));
        dataView.setUint32(12, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h3));
        dataView.setUint32(16, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h4));
        dataView.setUint32(20, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h5));
        dataView.setUint32(24, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h6));
        if (!$8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_is224)) dataView.setUint32(28, $8b6d8df5dd026b13$var$__classPrivateFieldGet(this, $8b6d8df5dd026b13$var$_h7));
        return buffer;
    }
}
$8b6d8df5dd026b13$var$_block = new WeakMap(), $8b6d8df5dd026b13$var$_blocks = new WeakMap(), $8b6d8df5dd026b13$var$_bytes = new WeakMap(), $8b6d8df5dd026b13$var$_finalized = new WeakMap(), $8b6d8df5dd026b13$var$_first = new WeakMap(), $8b6d8df5dd026b13$var$_h0 = new WeakMap(), $8b6d8df5dd026b13$var$_h1 = new WeakMap(), $8b6d8df5dd026b13$var$_h2 = new WeakMap(), $8b6d8df5dd026b13$var$_h3 = new WeakMap(), $8b6d8df5dd026b13$var$_h4 = new WeakMap(), $8b6d8df5dd026b13$var$_h5 = new WeakMap(), $8b6d8df5dd026b13$var$_h6 = new WeakMap(), $8b6d8df5dd026b13$var$_h7 = new WeakMap(), $8b6d8df5dd026b13$var$_hashed = new WeakMap(), $8b6d8df5dd026b13$var$_hBytes = new WeakMap(), $8b6d8df5dd026b13$var$_is224 = new WeakMap(), $8b6d8df5dd026b13$var$_lastByteIndex = new WeakMap(), $8b6d8df5dd026b13$var$_start = new WeakMap();
function $8b6d8df5dd026b13$var$Sha256ToInt(s) {
    const sha256 = new $8b6d8df5dd026b13$var$Sha256();
    sha256.update(s);
    return parseInt(sha256.hex().substring(0, 8), 16);
}
const $8b6d8df5dd026b13$var$RGB2HEX = function(RGBArray) {
    var hex = '#';
    RGBArray.forEach(function(value) {
        if (value < 16) hex += 0;
        hex += value.toString(16);
    });
    return hex;
};
const $8b6d8df5dd026b13$var$HSL2RGB = function(H, S, L) {
    H /= 360;
    var q = L < 0.5 ? L * (1 + S) : L + S - L * S;
    var p = 2 * L - q;
    return [
        H + 1 / 3,
        H,
        H - 1 / 3
    ].map(function(color) {
        if (color < 0) color++;
        if (color > 1) color--;
        if (color < 1 / 6) color = p + (q - p) * 6 * color;
        else if (color < 0.5) color = q;
        else if (color < 2 / 3) color = p + (q - p) * 6 * (2 / 3 - color);
        else color = p;
        return Math.round(color * 255);
    });
};
class $8b6d8df5dd026b13$export$2e2bcd8739ae039 {
    constructor(options = {}){
        const [L, S] = [
            options.lightness,
            options.saturation
        ].map(function(param) {
            param = param !== undefined ? param : [
                0.35,
                0.5,
                0.65
            ];
            return Array.isArray(param) ? param.concat() : [
                param
            ];
        });
        this.L = L;
        this.S = S;
        if (typeof options.hue === 'number') options.hue = {
            min: options.hue,
            max: options.hue
        };
        if (typeof options.hue === 'object' && !Array.isArray(options.hue)) options.hue = [
            options.hue
        ];
        if (typeof options.hue === 'undefined') options.hue = [];
        this.hueRanges = options.hue.map(function(range) {
            return {
                min: typeof range.min === 'undefined' ? 0 : range.min,
                max: typeof range.max === 'undefined' ? 360 : range.max
            };
        });
        this.hash = $8b6d8df5dd026b13$var$Sha256ToInt;
        if (typeof options.hash === 'function') this.hash = options.hash;
        if (options.hash === 'bkdr') this.hash = $8b6d8df5dd026b13$var$BKDRHash;
    }
    hsl(str) {
        var H, S, L;
        var hash = this.hash(str);
        var hueResolution = 727;
        if (this.hueRanges.length) {
            const range = this.hueRanges[hash % this.hueRanges.length];
            H = hash / this.hueRanges.length % hueResolution * (range.max - range.min) / hueResolution + range.min;
        } else H = hash % 359;
        hash = Math.ceil(hash / 360);
        S = this.S[hash % this.S.length];
        hash = Math.ceil(hash / this.S.length);
        L = this.L[hash % this.L.length];
        return [
            H,
            S,
            L
        ];
    }
    rgb(str) {
        var hsl = this.hsl(str);
        return $8b6d8df5dd026b13$var$HSL2RGB.apply(this, hsl);
    }
    hex(str) {
        var rgb = this.rgb(str);
        return $8b6d8df5dd026b13$var$RGB2HEX(rgb);
    }
}

});

parcelRegister("eIMS8", function(module, exports) {
parcelRequire("aJlEQ");
var $3XW2M = parcelRequire("3XW2M");
'use strict';
module.exports = {
    loadChartjsPluginEmptyOverlay: function(Chart) {
        Chart.defaults.plugins.emptyOverlay = {
            message: 'No data available'
        };
        /**
         * Checks if the chart is currently empty
         * @param chart
         * @returns {boolean}
         */ function isChartEmpty(chart) {
            if (chart.config.type == "doughnut") {
                var values = chart.data.datasets[0].data;
                if (values.length == 0) return true;
                for(i = 0; i < values.length; i++){
                    if (values[i] != 0) return false;
                }
                return true;
            }
            return chart.data.datasets[0] == null || chart.data.datasets[0].data.length === 0;
        }
        Chart.register({
            id: 'empty-overlay',
            afterDraw: (chart, _args, _opts)=>{
                if (!isChartEmpty(chart)) return;
                const globalDefault = Chart.defaults.plugins.emptyOverlay;
                const emptyOpts = chart.options.plugins.emptyOverlay;
                const message = (0, $3XW2M.v)(emptyOpts.message, globalDefault.message);
                var ctx = chart.ctx;
                ctx.save();
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.font = "22px Arial";
                ctx.fillStyle = "gray";
                ctx.fillText(message, chart.width / 2, chart.height / 2);
                ctx.fillStyle = "rgba(0, 0, 0, 0.05)";
                ctx.fillRect(0, 0, chart.width, chart.height);
                ctx.restore();
            }
        });
    }
};

});
parcelRegister("aJlEQ", function(module, exports) {

$parcel$export(module.exports, "valueOrDefault", function () { return (parcelRequire("3XW2M")).v; });

var $3XW2M = parcelRequire("3XW2M");

});



parcelRegister("8ppvg", function(module, exports) {
"use strict";
const $61f470f3fc7a8abd$var$ClipboardPort = {
    add: function(app) {
        app.ports.clipboardCopyPort.subscribe(async function(text) {
            try {
                if (navigator.clipboard && window.isSecureContext) await navigator.clipboard.writeText(text);
                else {
                    // Fallback to the legacy method for local
                    const textareaToCopyFrom = document.createElement("textarea");
                    textareaToCopyFrom.value = text;
                    textareaToCopyFrom.style.position = "fixed";
                    textareaToCopyFrom.style.left = "-999999px";
                    textareaToCopyFrom.style.top = "-999999px";
                    window.document.body.appendChild(textareaToCopyFrom);
                    textareaToCopyFrom.focus();
                    textareaToCopyFrom.select();
                    window.document.execCommand("copy");
                    window.document.body.removeChild(textareaToCopyFrom);
                }
            } catch (err) {
                console.error("Failed to copy text to clipboard:", err);
            }
        });
    }
};
module.exports = $61f470f3fc7a8abd$var$ClipboardPort;

});

parcelRegister("7Yv4M", function(module, exports) {
"use strict";
const $5ce63e0a9d3792d6$var$GlobalSearchPort = {
    add: (app)=>{
        window.addEventListener("outsideGlobalSearchTriggered", function() {
            app.ports.globalSearchTriggeredPort.send(null);
        });
        if (app.ports.enableGlobalSearchShortcutPort) app.ports.enableGlobalSearchShortcutPort.subscribe(()=>{
            document.addEventListener("keydown", function keydownHandler(e) {
                if ((e.metaKey || e.ctrlKey) && e.key === "k") {
                    app.ports.globalSearchTriggeredPort.send(null);
                    e.preventDefault();
                }
            });
        });
        // Wire the clinical search port to call React function
        if (app.ports.openClinicalSearchPort) app.ports.openClinicalSearchPort.subscribe(()=>{
            if (window.openClinicalSearchBar) window.openClinicalSearchBar();
        });
    }
};
module.exports = $5ce63e0a9d3792d6$var$GlobalSearchPort;

});

parcelRegister("89GRY", function(module, exports) {

var $c8kW4 = parcelRequire("c8kW4");
const $5f006afb862fc623$var$GooglePlacesPort = {
    add: function(app, googleMapsKey) {
        if (!googleMapsKey) throw new Error("Google Maps Key is not configured.");
        let places;
        (0, $c8kW4.setOptions)({
            key: googleMapsKey
        });
        const fetchAutocompleteSuggestions = (id, request, callback)=>{
            places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request).then(({ suggestions: suggestions })=>{
                const formattedSuggestions = suggestions.map((s)=>{
                    const p = s.placePrediction;
                    return {
                        description: p.text.text,
                        place_id: p.placeId,
                        types: p.types
                    };
                });
                callback({
                    suggestions: formattedSuggestions,
                    id: id
                });
            }).catch((error)=>{
                console.log(error);
            });
        };
        (0, $c8kW4.importLibrary)("places").then((imported)=>{
            places = imported;
            app.ports.googlePlacesGetAutocompleteSuggestions.subscribe(function({ address: address, id: id }) {
                if (!address) return;
                let sessionToken = new places.AutocompleteSessionToken();
                let request = {
                    input: address,
                    sessionToken: sessionToken
                };
                navigator.geolocation.getCurrentPosition(({ coords: { latitude: latitude, longitude: longitude } })=>{
                    fetchAutocompleteSuggestions(id, {
                        ...request,
                        locationBias: {
                            radius: 5000,
                            center: {
                                lat: latitude,
                                lng: longitude
                            }
                        }
                    }, app.ports.googlePlacesAutocompleteSuggestionsResponse.send);
                }, ()=>{
                    fetchAutocompleteSuggestions(id, request, app.ports.googlePlacesAutocompleteSuggestionsResponse.send);
                });
            });
            app.ports.googlePlacesGetPlaceDetails.subscribe(function({ placeId: placeId, id: id }) {
                const place = new places.Place({
                    id: placeId
                });
                place.fetchFields({
                    fields: [
                        "addressComponents",
                        "formattedAddress",
                        "displayName",
                        "id",
                        "types"
                    ]
                }).then((response)=>{
                    const transformedPlace = {
                        address_components: (response.place.addressComponents || []).map((component)=>({
                                long_name: component.longText,
                                short_name: component.shortText,
                                types: component.types
                            })),
                        formatted_address: response.place.formattedAddress,
                        name: response.place.displayName,
                        place_id: response.place.id,
                        types: response.place.types
                    };
                    const address = JSON.stringify(transformedPlace);
                    app.ports.googlePlacesPlaceDetailsResponse.send({
                        address: address,
                        id: id
                    });
                }).catch((error)=>{
                    console.log("Error fetching place details:", error);
                    app.ports.googlePlacesPlaceDetailsResponse.send({
                        address: null,
                        id: id
                    });
                });
            });
        }).catch((error)=>console.log(error));
    }
};
module.exports = $5f006afb862fc623$var$GooglePlacesPort;

});
parcelRegister("c8kW4", function(module, exports) {
!function(o, e) {
    e(module.exports);
}(module.exports, function(o) {
    "use strict";
    const e = (o)=>{
        var e, n, r, t = "The Google Maps JavaScript API", a = "google", i = "importLibrary", s = "__ib__", p = document, c = window, l = c[a] || (c[a] = {}), d = l.maps || (l.maps = {}), m = new Set, g = new URLSearchParams;
        d[i] ? console.warn(t + " only loads once. Ignoring:", o) : d[i] = (c, ...l)=>m.add(c) && (e || (e = new Promise(async (i, c)=>{
                for(r in await (n = p.createElement("script")), g.set("libraries", [
                    ...m
                ] + ""), o)g.set(r.replace(/[A-Z]/g, (o)=>"_" + o[0].toLowerCase()), o[r]);
                g.set("callback", a + ".maps." + s), function(o, e) {
                    o.src = e;
                }(n, "https://maps.googleapis.com/maps/api/js?" + g), d[s] = i, n.onerror = ()=>e = c(Error(t + " could not load.")), n.nonce = p.querySelector("script[nonce]")?.nonce || "", p.head.append(n);
            }))).then(()=>d[i](c, ...l));
    };
    "production";
    "production";
    let n = !1;
    o.Loader = class {
        constructor(...o){
            throw new Error("[@googlemaps/js-api-loader]: The Loader class is no longer available in this version.\nPlease use the new functional API: setOptions() and importLibrary().\nFor more information, see the updated documentation at: https://github.com/googlemaps/js-api-loader/blob/main/README.md");
        }
    }, o.importLibrary = async function(o) {
        if (!window?.google?.maps?.importLibrary) throw new Error("google.maps.importLibrary is not installed.");
        return await google.maps.importLibrary(o);
    }, o.setOptions = function(o) {
        n ? ((o)=>{
            JSON.stringify(o);
        })(o) : (!function(o) {
            const n = Boolean(window.google?.maps?.importLibrary);
            n && ((o)=>{
                JSON.stringify(o);
            })(o);
            n || e(o);
        }(o), n = !0);
    };
}); //# sourceMappingURL=index.cjs.map

});


parcelRegister("vtHhd", function(module, exports) {
/* global grecaptcha */ "use strict";
const $05e9ee929b7489f9$var$setup = function(googleRecaptchaSiteKey) {
    function loadRecaptchaAPI() {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = "https://www.google.com/recaptcha/api.js?render=" + googleRecaptchaSiteKey;
        document.body.appendChild(script);
    }
    if (googleRecaptchaSiteKey) window.addEventListener("load", loadRecaptchaAPI, false);
};
const $05e9ee929b7489f9$var$GoogleRecaptchaPort = {
    add: function(app, googleRecaptchaSiteKey) {
        $05e9ee929b7489f9$var$setup(googleRecaptchaSiteKey);
        app.ports.getRecaptchaTokenPort.subscribe(function(action) {
            if (typeof grecaptcha !== "undefined") grecaptcha.ready(function() {
                grecaptcha.execute(googleRecaptchaSiteKey, {
                    action: action
                }).then(function(token) {
                    app.ports.gotRecaptchaTokenPort.send({
                        token: token,
                        result: "ok"
                    });
                }).catch(()=>app.ports.gotRecaptchaTokenPort.send({
                        token: "",
                        result: "remote-error"
                    }));
            });
            else app.ports.gotRecaptchaTokenPort.send({
                token: "",
                result: "recaptcha-not-defined"
            });
        });
    }
};
module.exports = $05e9ee929b7489f9$var$GoogleRecaptchaPort;

});

parcelRegister("iiYY3", function(module, exports) {
"use strict";

var $gOoIB = parcelRequire("gOoIB");
const $d5393359b6702f13$var$read = function() {
    return $gOoIB.getItem("hint.hinter-view-off") === "true";
};
const $d5393359b6702f13$var$write = function(hinterViewOff) {
    return $gOoIB.setItem("hint.hinter-view-off", hinterViewOff);
};
const $d5393359b6702f13$var$HinterViewPort = {
    read: $d5393359b6702f13$var$read,
    add: function(app) {
        if (app.ports.hinterViewStorePort) app.ports.hinterViewStorePort.subscribe((hinterViewOff)=>{
            $d5393359b6702f13$var$write(hinterViewOff);
            // The navbar listents for this event to update its internal value.
            // Remove this when the navbar is integrated with the main app.
            const event = new CustomEvent("outsideHinterViewUpdated", {
                detail: {
                    hinterViewOff: hinterViewOff
                }
            });
            window.dispatchEvent(event);
        });
    }
};
module.exports = $d5393359b6702f13$var$HinterViewPort;

});
parcelRegister("gOoIB", function(module, exports) {

var $5kRrD = parcelRequire("5kRrD");
"use strict";
const $c3d47d66edb313d7$var$storage = (0, $5kRrD.storageFactory)(()=>localStorage);
const $c3d47d66edb313d7$var$LocalStoragePort = {
    getItem: $c3d47d66edb313d7$var$storage.getItem,
    setItem: $c3d47d66edb313d7$var$storage.setItem,
    removeItem: $c3d47d66edb313d7$var$storage.removeItem,
    add: function(app) {
        app.ports.localStorageSetItemPort.subscribe(function(keyAndValue) {
            $c3d47d66edb313d7$var$storage.setItem(keyAndValue[0], keyAndValue[1]);
        });
        app.ports.localStorageGetItemPort.subscribe(function(key) {
            const value = $c3d47d66edb313d7$var$storage.getItem(key);
            app.ports.localStorageGotItemPort.send([
                key,
                value
            ]);
        });
    }
};
module.exports = $c3d47d66edb313d7$var$LocalStoragePort;

});
parcelRegister("5kRrD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.storageFactory = void 0;
function $3e284700822e4b4b$var$storageFactory(getStorage) {
    var inMemoryStorage = {};
    function isSupported() {
        try {
            var testKey = "__some_random_key_you_are_not_going_to_use__";
            getStorage().setItem(testKey, testKey);
            getStorage().removeItem(testKey);
            return true;
        } catch (e) {
            return false;
        }
    }
    function clear() {
        if (isSupported()) getStorage().clear();
        else inMemoryStorage = {};
    }
    function getItem(name) {
        if (isSupported()) return getStorage().getItem(name);
        if (inMemoryStorage.hasOwnProperty(name)) return inMemoryStorage[name];
        return null;
    }
    function key(index) {
        if (isSupported()) return getStorage().key(index);
        else return Object.keys(inMemoryStorage)[index] || null;
    }
    function removeItem(name) {
        if (isSupported()) getStorage().removeItem(name);
        else delete inMemoryStorage[name];
    }
    function setItem(name, value) {
        if (isSupported()) getStorage().setItem(name, value);
        else inMemoryStorage[name] = String(value);
    }
    function length() {
        if (isSupported()) return getStorage().length;
        else return Object.keys(inMemoryStorage).length;
    }
    return {
        getItem: getItem,
        setItem: setItem,
        removeItem: removeItem,
        clear: clear,
        key: key,
        get length () {
            return length();
        }
    };
}
module.exports.storageFactory = $3e284700822e4b4b$var$storageFactory;

});



parcelRegister("amH7X", function(module, exports) {
"use strict";
const $78bd69a877018107$var$IntercomPort = {
    add: function(app, appId) {
        if (appId && window.parent === window) window.setupIntercom(appId);
        app.ports.intercomPortOpen.subscribe(()=>{
            if (!window.Intercom) return;
            window.Intercom("showNewMessage");
        });
        app.ports.intercomPortBoot.subscribe((payload)=>{
            if (!window.Intercom) return;
            window.Intercom("boot", payload);
        });
        app.ports.intercomPortShutdown.subscribe(()=>{
            if (!window.Intercom) return;
            window.Intercom("shutdown");
        });
        app.ports.intercomPortShow.subscribe(()=>{
            if (!window.Intercom) return;
            window.Intercom("show");
        });
        app.ports.intercomPortUpdate.subscribe(()=>{
            if (!window.Intercom) return;
            window.Intercom("update", {});
        });
        app.ports.intercomPortLogEvent.subscribe(function(event) {
            if (!window.Intercom) return;
            // Copied from Amplitude.js
            const options = Object.assign(event.payload, {
                url_path: event.urlPath || location.pathname
            });
            window.Intercom("trackEvent", event.type, options);
        });
    }
};
module.exports = $78bd69a877018107$var$IntercomPort;

});

parcelRegister("9gaDw", function(module, exports) {
"use strict";
const $6bdddbd5cf1cf399$var$LayerPort = {
    add: function(app) {
        const insertScriptTag = ()=>{
            const layerScript = document.createElement("script");
            const layerStyles = document.createElement("link");
            layerScript.src = "/layer-web-components/dist/layer-web-components.js";
            layerScript.type = "module";
            layerStyles.href = "/layer-web-components/dist/layer-web-components.css";
            layerStyles.rel = "stylesheet";
            document.head.appendChild(layerScript);
            document.head.appendChild(layerStyles);
        };
        app.ports.layerPortLoad.subscribe(()=>{
            if (window.layerLoaded) return;
            insertScriptTag();
            window.layerLoaded = true;
        });
    }
};
module.exports = $6bdddbd5cf1cf399$var$LayerPort;

});

parcelRegister("ipoUY", function(module, exports) {
"use strict";
const $d66de3f7ba921516$var$NavbarPort = {
    add: (app)=>{
        const tt = document.createElement("span");
        tt.className = "sidenav-fixed-tooltip";
        document.body.appendChild(tt);
        let scrolling = false, scrollTimer;
        document.addEventListener("pointerenter", ({ target: target, pointerType: pointerType })=>{
            if (pointerType !== "mouse") return;
            if (document.querySelector("#sidenav.sidenav--expanded")) return;
            const w = target.closest?.(".sidenav__main--desktop .tooltip-wrapper");
            const t = w?.querySelector(".tooltip[data-text]");
            if (!t || scrolling) return;
            const r = w.getBoundingClientRect();
            Object.assign(tt, {
                textContent: t.dataset.text
            });
            Object.assign(tt.style, {
                display: "block",
                top: `${r.top + (r.height - tt.offsetHeight) / 2}px`,
                left: `${r.right + 10}px`
            });
        }, true);
        document.addEventListener("pointerleave", ({ target: target, pointerType: pointerType })=>{
            if (pointerType !== "mouse") return;
            if (target.closest?.(".sidenav__main--desktop .tooltip-wrapper")) tt.style.display = "none";
        }, true);
        document.addEventListener("scroll", ({ target: target })=>{
            if (!target.closest?.(".sidenav__main--desktop")) return;
            scrolling = true;
            tt.style.display = "none";
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(()=>{
                scrolling = false;
            }, 100);
        }, true);
        app.ports.sidenavLinkClickedPort.subscribe(()=>{
            app.ports.onSidenavLinkClickedPort.send(null);
        });
        const overlay = document.createElement("div");
        overlay.className = "sidenav-overlay";
        document.body.appendChild(overlay);
        new MutationObserver(()=>{
            const isOpen = !!document.querySelector(".sidenav--slide-in");
            overlay.classList.toggle("sidenav-overlay--visible", isOpen);
            if (isOpen) requestAnimationFrame(()=>{
                const mobileNav = document.querySelector(".sidenav__main--mobile");
                const activeItem = mobileNav?.querySelector(".sidenav__active");
                if (mobileNav && activeItem) activeItem.scrollIntoView({
                    block: "nearest",
                    behavior: "smooth"
                });
            });
        }).observe(document.body, {
            attributeFilter: [
                "class"
            ],
            subtree: true
        });
        overlay.addEventListener("click", ()=>{
            document.querySelector(".sidenav-close button")?.click();
        });
        window.addEventListener("outsideHinterViewUpdated", function(customEvent) {
            app.ports.sidenavHinterViewUpdatedPort.send(customEvent.detail["hinterViewOff"]);
        });
        app.ports.topnavHeaderHeightChangedPort.subscribe((headerHeight)=>{
            const root = document.documentElement;
            root.style.setProperty("--total-header-height", headerHeight + "px");
            // On mobile, the sidebar slides in from the top, covering the topnav.
            // Those 55px need to be accounted for when adjusting the wrapper's margin.
            const mobileNavHeight = window.innerWidth <= 768 ? getTopnavHeight() : 0;
            root.style.setProperty("--mobile-nav-height", mobileNavHeight + "px");
        });
        if (app.ports.globalSearchButtonClickedPort) app.ports.globalSearchButtonClickedPort.subscribe(()=>{
            const event = new Event("outsideGlobalSearchTriggered");
            window.dispatchEvent(event);
        });
        const getTopnavHeight = ()=>{
            const style = getComputedStyle(document.documentElement).getPropertyValue("--topnav-height");
            return parseInt(style.replace("px", "").trim());
        };
    }
};
module.exports = $d66de3f7ba921516$var$NavbarPort;

});

parcelRegister("616Ei", function(module, exports) {

var $cQ6Rb = parcelRequire("cQ6Rb");
"use strict";
const $4617fe64463cf7d0$var$isLocalHref = (link)=>link.host == location.host;
const $4617fe64463cf7d0$var$urlChanged = (callback)=>{
    setTimeout(()=>{
        callback(location.href);
    }, 0);
};
const $4617fe64463cf7d0$var$NavigationPort = {
    add: function(app) {
        // Inform app of browser navigation (the BACK and FORWARD buttons)
        window.addEventListener("popstate", function() {
            $4617fe64463cf7d0$var$urlChanged(app.ports.onUrlChange.send);
        });
        if (app.ports.pushUrl) app.ports.pushUrl.subscribe((url)=>{
            history.pushState({}, "", (0, (/*@__PURE__*/$parcel$interopDefault($cQ6Rb))).get(url));
            window.dispatchEvent(new PopStateEvent("popstate"));
            $4617fe64463cf7d0$var$urlChanged(app.ports.onUrlChange.send);
        });
        if (app.ports.navigationLoad) app.ports.navigationLoad.subscribe((url)=>{
            window.location = url;
        });
        window.addEventListener("clinical:navigate", ()=>{
            $4617fe64463cf7d0$var$urlChanged(app.ports.onUrlChange.send);
        });
        // Intercept link clicks to add custom elm logic
        document.addEventListener("click", (event)=>{
            const target = event.composedPath().find((el)=>el instanceof HTMLAnchorElement);
            if (!target) return;
            if (target.href && app.ports.navigationPortOnUrlRequest) {
                const shouldOpenInNewWindow = target.target == "_blank" || event.metaKey || event.ctrlKey || event.shiftKey;
                if (shouldOpenInNewWindow) return;
                event.preventDefault();
                app.ports.navigationPortOnUrlRequest.send([
                    target.href,
                    $4617fe64463cf7d0$var$isLocalHref(target),
                    shouldOpenInNewWindow
                ]);
            }
        });
        if (app.ports.navigationPortRequestUrl) app.ports.navigationPortRequestUrl.subscribe((args)=>{
            app.ports.navigationPortOnUrlRequest.send(args);
        });
        if (app.ports.navigationPortOpenInNewWindow) app.ports.navigationPortOpenInNewWindow.subscribe((url)=>{
            const newPage = window.open("http://hint.com", "_blank");
            newPage.location = url;
        });
        if (app.ports.navigationPortReload) app.ports.navigationPortReload.subscribe(()=>{
            window.location.reload();
        });
        if (app.ports.backPort) app.ports.backPort.subscribe(()=>{
            history.back();
        });
        if (app.ports.replaceUrl) app.ports.replaceUrl.subscribe((url)=>{
            history.replaceState({}, "", (0, (/*@__PURE__*/$parcel$interopDefault($cQ6Rb))).get(url));
        });
    }
};
module.exports = $4617fe64463cf7d0$var$NavigationPort;

});
parcelRegister("cQ6Rb", function(module, exports) {
"use strict";

var $gOoIB = parcelRequire("gOoIB");
const $958fa8fcf680a155$var$customOrgKey = "hint.custom-organization";
const $958fa8fcf680a155$var$queryParam = "organization";
function $958fa8fcf680a155$var$appendQueryParam(url, paramName, paramValue) {
    if (url.indexOf("?") === -1) return url + "?" + paramName + "=" + paramValue;
    else return url + "&" + paramName + "=" + paramValue;
}
module.exports = {
    get: function(url) {
        const org = $gOoIB.getItem($958fa8fcf680a155$var$customOrgKey);
        if (org !== null) return $958fa8fcf680a155$var$appendQueryParam(url, $958fa8fcf680a155$var$queryParam, org);
        return url;
    },
    setAndRetrieve: function() {
        const urlQueryParams = new URLSearchParams(window.location.search);
        let organization = urlQueryParams.get($958fa8fcf680a155$var$queryParam);
        if (organization) $gOoIB.setItem($958fa8fcf680a155$var$customOrgKey, organization);
        else organization = $gOoIB.getItem($958fa8fcf680a155$var$customOrgKey);
        return organization;
    }
};

});


parcelRegister("2OWT6", function(module, exports) {
"use strict";
const $20ddee2ed7becf4a$var$NewTab = {
    add: (app)=>{
        app.ports.open.subscribe((url)=>window.open(url, "_blank"));
    }
};
module.exports = $20ddee2ed7becf4a$var$NewTab;

});

parcelRegister("imN2D", function(module, exports) {
"use strict";
const $d5f052b56133b01e$var$ToastPort = {
    add: function(app, emrHost) {
        if (app.ports.sendToastMessagePort) app.ports.sendToastMessagePort.subscribe(function(levelAndMessage) {
            window.parent.postMessage({
                message: levelAndMessage[1],
                type: `alert.${levelAndMessage[0]}`
            }, emrHost);
        });
    }
};
module.exports = $d5f052b56133b01e$var$ToastPort;

});

parcelRegister("6ljOM", function(module, exports) {
"use strict";

var $6AGnV = parcelRequire("6AGnV");
const $49e413b2ef2faa75$var$PasswordStrengthPort = {
    add: function(app) {
        app.ports.checkPasswordStrength.subscribe((password)=>{
            const { score: score, feedback: feedback } = $6AGnV(password);
            app.ports.passwordStrengthChecked.send({
                strength: score,
                suggestions: feedback?.suggestions
            });
        });
    }
};
module.exports = $49e413b2ef2faa75$var$PasswordStrengthPort;

});
parcelRegister("6AGnV", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $013d040f147a2382$var$feedback, $013d040f147a2382$var$matching, $013d040f147a2382$var$scoring, $013d040f147a2382$var$time, $013d040f147a2382$var$time_estimates, $013d040f147a2382$var$zxcvbn;

$013d040f147a2382$var$matching = (parcelRequire("aCzIJ"));

$013d040f147a2382$var$scoring = (parcelRequire("1dnRX"));

$013d040f147a2382$var$time_estimates = (parcelRequire("aJyxA"));

$013d040f147a2382$var$feedback = (parcelRequire("74Z83"));
$013d040f147a2382$var$time = function() {
    return new Date().getTime();
};
$013d040f147a2382$var$zxcvbn = function(password, user_inputs) {
    var arg, attack_times, i, len, matches, prop, ref, result, sanitized_inputs, start, val;
    if (user_inputs == null) user_inputs = [];
    start = $013d040f147a2382$var$time();
    sanitized_inputs = [];
    for(i = 0, len = user_inputs.length; i < len; i++){
        arg = user_inputs[i];
        if ((ref = typeof arg) === "string" || ref === "number" || ref === "boolean") sanitized_inputs.push(arg.toString().toLowerCase());
    }
    $013d040f147a2382$var$matching.set_user_input_dictionary(sanitized_inputs);
    matches = $013d040f147a2382$var$matching.omnimatch(password);
    result = $013d040f147a2382$var$scoring.most_guessable_match_sequence(password, matches);
    result.calc_time = $013d040f147a2382$var$time() - start;
    attack_times = $013d040f147a2382$var$time_estimates.estimate_attack_times(result.guesses);
    for(prop in attack_times){
        val = attack_times[prop];
        result[prop] = val;
    }
    result.feedback = $013d040f147a2382$var$feedback.get_feedback(result.score, result.sequence);
    return result;
};
module.exports = $013d040f147a2382$var$zxcvbn;

});
parcelRegister("aCzIJ", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $7bb929518d6859cf$var$DATE_MAX_YEAR, $7bb929518d6859cf$var$DATE_MIN_YEAR, $7bb929518d6859cf$var$DATE_SPLITS, $7bb929518d6859cf$var$GRAPHS, $7bb929518d6859cf$var$L33T_TABLE, $7bb929518d6859cf$var$RANKED_DICTIONARIES, $7bb929518d6859cf$var$REGEXEN, $7bb929518d6859cf$var$adjacency_graphs, $7bb929518d6859cf$var$build_ranked_dict, $7bb929518d6859cf$var$frequency_lists, $7bb929518d6859cf$var$lst, $7bb929518d6859cf$var$matching, $7bb929518d6859cf$var$name, $7bb929518d6859cf$var$scoring;

$7bb929518d6859cf$var$frequency_lists = (parcelRequire("8By0C"));

$7bb929518d6859cf$var$adjacency_graphs = (parcelRequire("17UkK"));

$7bb929518d6859cf$var$scoring = (parcelRequire("1dnRX"));
$7bb929518d6859cf$var$build_ranked_dict = function(ordered_list) {
    var i, len1, o, result, word;
    result = {};
    i = 1;
    for(o = 0, len1 = ordered_list.length; o < len1; o++){
        word = ordered_list[o];
        result[word] = i;
        i += 1;
    }
    return result;
};
$7bb929518d6859cf$var$RANKED_DICTIONARIES = {};
for($7bb929518d6859cf$var$name in $7bb929518d6859cf$var$frequency_lists){
    $7bb929518d6859cf$var$lst = $7bb929518d6859cf$var$frequency_lists[$7bb929518d6859cf$var$name];
    $7bb929518d6859cf$var$RANKED_DICTIONARIES[$7bb929518d6859cf$var$name] = $7bb929518d6859cf$var$build_ranked_dict($7bb929518d6859cf$var$lst);
}
$7bb929518d6859cf$var$GRAPHS = {
    qwerty: $7bb929518d6859cf$var$adjacency_graphs.qwerty,
    dvorak: $7bb929518d6859cf$var$adjacency_graphs.dvorak,
    keypad: $7bb929518d6859cf$var$adjacency_graphs.keypad,
    mac_keypad: $7bb929518d6859cf$var$adjacency_graphs.mac_keypad
};
$7bb929518d6859cf$var$L33T_TABLE = {
    a: [
        '4',
        '@'
    ],
    b: [
        '8'
    ],
    c: [
        '(',
        '{',
        '[',
        '<'
    ],
    e: [
        '3'
    ],
    g: [
        '6',
        '9'
    ],
    i: [
        '1',
        '!',
        '|'
    ],
    l: [
        '1',
        '|',
        '7'
    ],
    o: [
        '0'
    ],
    s: [
        '$',
        '5'
    ],
    t: [
        '+',
        '7'
    ],
    x: [
        '%'
    ],
    z: [
        '2'
    ]
};
$7bb929518d6859cf$var$REGEXEN = {
    recent_year: /19\d\d|200\d|201\d/g
};
$7bb929518d6859cf$var$DATE_MAX_YEAR = 2050;
$7bb929518d6859cf$var$DATE_MIN_YEAR = 1000;
$7bb929518d6859cf$var$DATE_SPLITS = {
    4: [
        [
            1,
            2
        ],
        [
            2,
            3
        ]
    ],
    5: [
        [
            1,
            3
        ],
        [
            2,
            3
        ]
    ],
    6: [
        [
            1,
            2
        ],
        [
            2,
            4
        ],
        [
            4,
            5
        ]
    ],
    7: [
        [
            1,
            3
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            4,
            6
        ]
    ],
    8: [
        [
            2,
            4
        ],
        [
            4,
            6
        ]
    ]
};
$7bb929518d6859cf$var$matching = {
    empty: function(obj) {
        var k;
        return function() {
            var results;
            results = [];
            for(k in obj)results.push(k);
            return results;
        }().length === 0;
    },
    extend: function(lst, lst2) {
        return lst.push.apply(lst, lst2);
    },
    translate: function(string, chr_map) {
        var chr;
        return (function() {
            var len1, o, ref, results;
            ref = string.split('');
            results = [];
            for(o = 0, len1 = ref.length; o < len1; o++){
                chr = ref[o];
                results.push(chr_map[chr] || chr);
            }
            return results;
        })().join('');
    },
    mod: function(n, m) {
        return (n % m + m) % m;
    },
    sorted: function(matches) {
        return matches.sort(function(m1, m2) {
            return m1.i - m2.i || m1.j - m2.j;
        });
    },
    omnimatch: function(password) {
        var len1, matcher, matchers, matches, o;
        matches = [];
        matchers = [
            this.dictionary_match,
            this.reverse_dictionary_match,
            this.l33t_match,
            this.spatial_match,
            this.repeat_match,
            this.sequence_match,
            this.regex_match,
            this.date_match
        ];
        for(o = 0, len1 = matchers.length; o < len1; o++){
            matcher = matchers[o];
            this.extend(matches, matcher.call(this, password));
        }
        return this.sorted(matches);
    },
    dictionary_match: function(password, _ranked_dictionaries) {
        var dictionary_name, i, j, len, matches, o, p, password_lower, rank, ranked_dict, ref, ref1, ref2, word;
        if (_ranked_dictionaries == null) _ranked_dictionaries = $7bb929518d6859cf$var$RANKED_DICTIONARIES;
        matches = [];
        len = password.length;
        password_lower = password.toLowerCase();
        for(dictionary_name in _ranked_dictionaries){
            ranked_dict = _ranked_dictionaries[dictionary_name];
            for(i = o = 0, ref = len; 0 <= ref ? o < ref : o > ref; i = 0 <= ref ? ++o : --o){
                for(j = p = ref1 = i, ref2 = len; ref1 <= ref2 ? p < ref2 : p > ref2; j = ref1 <= ref2 ? ++p : --p)if (password_lower.slice(i, +j + 1 || 9e9) in ranked_dict) {
                    word = password_lower.slice(i, +j + 1 || 9e9);
                    rank = ranked_dict[word];
                    matches.push({
                        pattern: 'dictionary',
                        i: i,
                        j: j,
                        token: password.slice(i, +j + 1 || 9e9),
                        matched_word: word,
                        rank: rank,
                        dictionary_name: dictionary_name,
                        reversed: false,
                        l33t: false
                    });
                }
            }
        }
        return this.sorted(matches);
    },
    reverse_dictionary_match: function(password, _ranked_dictionaries) {
        var len1, match, matches, o, ref, reversed_password;
        if (_ranked_dictionaries == null) _ranked_dictionaries = $7bb929518d6859cf$var$RANKED_DICTIONARIES;
        reversed_password = password.split('').reverse().join('');
        matches = this.dictionary_match(reversed_password, _ranked_dictionaries);
        for(o = 0, len1 = matches.length; o < len1; o++){
            match = matches[o];
            match.token = match.token.split('').reverse().join('');
            match.reversed = true;
            ref = [
                password.length - 1 - match.j,
                password.length - 1 - match.i
            ], match.i = ref[0], match.j = ref[1];
        }
        return this.sorted(matches);
    },
    set_user_input_dictionary: function(ordered_list) {
        return $7bb929518d6859cf$var$RANKED_DICTIONARIES['user_inputs'] = $7bb929518d6859cf$var$build_ranked_dict(ordered_list.slice());
    },
    relevant_l33t_subtable: function(password, table) {
        var chr, len1, letter, o, password_chars, ref, relevant_subs, sub, subs, subtable;
        password_chars = {};
        ref = password.split('');
        for(o = 0, len1 = ref.length; o < len1; o++){
            chr = ref[o];
            password_chars[chr] = true;
        }
        subtable = {};
        for(letter in table){
            subs = table[letter];
            relevant_subs = function() {
                var len2, p, results;
                results = [];
                for(p = 0, len2 = subs.length; p < len2; p++){
                    sub = subs[p];
                    if (sub in password_chars) results.push(sub);
                }
                return results;
            }();
            if (relevant_subs.length > 0) subtable[letter] = relevant_subs;
        }
        return subtable;
    },
    enumerate_l33t_subs: function(table) {
        var chr, dedup, helper, k, keys, l33t_chr, len1, len2, o, p, ref, sub, sub_dict, sub_dicts, subs;
        keys = function() {
            var results;
            results = [];
            for(k in table)results.push(k);
            return results;
        }();
        subs = [
            []
        ];
        dedup = function(subs) {
            var assoc, deduped, label, len1, members, o, sub, v;
            deduped = [];
            members = {};
            for(o = 0, len1 = subs.length; o < len1; o++){
                sub = subs[o];
                assoc = function() {
                    var len2, p, results;
                    results = [];
                    for(v = p = 0, len2 = sub.length; p < len2; v = ++p){
                        k = sub[v];
                        results.push([
                            k,
                            v
                        ]);
                    }
                    return results;
                }();
                assoc.sort();
                label = (function() {
                    var len2, p, results;
                    results = [];
                    for(v = p = 0, len2 = assoc.length; p < len2; v = ++p){
                        k = assoc[v];
                        results.push(k + ',' + v);
                    }
                    return results;
                })().join('-');
                if (!(label in members)) {
                    members[label] = true;
                    deduped.push(sub);
                }
            }
            return deduped;
        };
        helper = function(keys) {
            var dup_l33t_index, first_key, i, l33t_chr, len1, len2, next_subs, o, p, q, ref, ref1, rest_keys, sub, sub_alternative, sub_extension;
            if (!keys.length) return;
            first_key = keys[0];
            rest_keys = keys.slice(1);
            next_subs = [];
            ref = table[first_key];
            for(o = 0, len1 = ref.length; o < len1; o++){
                l33t_chr = ref[o];
                for(p = 0, len2 = subs.length; p < len2; p++){
                    sub = subs[p];
                    dup_l33t_index = -1;
                    for(i = q = 0, ref1 = sub.length; 0 <= ref1 ? q < ref1 : q > ref1; i = 0 <= ref1 ? ++q : --q)if (sub[i][0] === l33t_chr) {
                        dup_l33t_index = i;
                        break;
                    }
                    if (dup_l33t_index === -1) {
                        sub_extension = sub.concat([
                            [
                                l33t_chr,
                                first_key
                            ]
                        ]);
                        next_subs.push(sub_extension);
                    } else {
                        sub_alternative = sub.slice(0);
                        sub_alternative.splice(dup_l33t_index, 1);
                        sub_alternative.push([
                            l33t_chr,
                            first_key
                        ]);
                        next_subs.push(sub);
                        next_subs.push(sub_alternative);
                    }
                }
            }
            subs = dedup(next_subs);
            return helper(rest_keys);
        };
        helper(keys);
        sub_dicts = [];
        for(o = 0, len1 = subs.length; o < len1; o++){
            sub = subs[o];
            sub_dict = {};
            for(p = 0, len2 = sub.length; p < len2; p++){
                ref = sub[p], l33t_chr = ref[0], chr = ref[1];
                sub_dict[l33t_chr] = chr;
            }
            sub_dicts.push(sub_dict);
        }
        return sub_dicts;
    },
    l33t_match: function(password, _ranked_dictionaries, _l33t_table) {
        var chr, k, len1, len2, match, match_sub, matches, o, p, ref, ref1, sub, subbed_chr, subbed_password, token, v;
        if (_ranked_dictionaries == null) _ranked_dictionaries = $7bb929518d6859cf$var$RANKED_DICTIONARIES;
        if (_l33t_table == null) _l33t_table = $7bb929518d6859cf$var$L33T_TABLE;
        matches = [];
        ref = this.enumerate_l33t_subs(this.relevant_l33t_subtable(password, _l33t_table));
        for(o = 0, len1 = ref.length; o < len1; o++){
            sub = ref[o];
            if (this.empty(sub)) break;
            subbed_password = this.translate(password, sub);
            ref1 = this.dictionary_match(subbed_password, _ranked_dictionaries);
            for(p = 0, len2 = ref1.length; p < len2; p++){
                match = ref1[p];
                token = password.slice(match.i, +match.j + 1 || 9e9);
                if (token.toLowerCase() === match.matched_word) continue;
                match_sub = {};
                for(subbed_chr in sub){
                    chr = sub[subbed_chr];
                    if (token.indexOf(subbed_chr) !== -1) match_sub[subbed_chr] = chr;
                }
                match.l33t = true;
                match.token = token;
                match.sub = match_sub;
                match.sub_display = (function() {
                    var results;
                    results = [];
                    for(k in match_sub){
                        v = match_sub[k];
                        results.push(k + " -> " + v);
                    }
                    return results;
                })().join(', ');
                matches.push(match);
            }
        }
        return this.sorted(matches.filter(function(match) {
            return match.token.length > 1;
        }));
    },
    spatial_match: function(password, _graphs) {
        var graph, graph_name, matches;
        if (_graphs == null) _graphs = $7bb929518d6859cf$var$GRAPHS;
        matches = [];
        for(graph_name in _graphs){
            graph = _graphs[graph_name];
            this.extend(matches, this.spatial_match_helper(password, graph, graph_name));
        }
        return this.sorted(matches);
    },
    SHIFTED_RX: /[~!@#$%^&*()_+QWERTYUIOP{}|ASDFGHJKL:"ZXCVBNM<>?]/,
    spatial_match_helper: function(password, graph, graph_name) {
        var adj, adjacents, cur_char, cur_direction, found, found_direction, i, j, last_direction, len1, matches, o, prev_char, shifted_count, turns;
        matches = [];
        i = 0;
        while(i < password.length - 1){
            j = i + 1;
            last_direction = null;
            turns = 0;
            if ((graph_name === 'qwerty' || graph_name === 'dvorak') && this.SHIFTED_RX.exec(password.charAt(i))) shifted_count = 1;
            else shifted_count = 0;
            while(true){
                prev_char = password.charAt(j - 1);
                found = false;
                found_direction = -1;
                cur_direction = -1;
                adjacents = graph[prev_char] || [];
                if (j < password.length) {
                    cur_char = password.charAt(j);
                    for(o = 0, len1 = adjacents.length; o < len1; o++){
                        adj = adjacents[o];
                        cur_direction += 1;
                        if (adj && adj.indexOf(cur_char) !== -1) {
                            found = true;
                            found_direction = cur_direction;
                            if (adj.indexOf(cur_char) === 1) shifted_count += 1;
                            if (last_direction !== found_direction) {
                                turns += 1;
                                last_direction = found_direction;
                            }
                            break;
                        }
                    }
                }
                if (found) j += 1;
                else {
                    if (j - i > 2) matches.push({
                        pattern: 'spatial',
                        i: i,
                        j: j - 1,
                        token: password.slice(i, j),
                        graph: graph_name,
                        turns: turns,
                        shifted_count: shifted_count
                    });
                    i = j;
                    break;
                }
            }
        }
        return matches;
    },
    repeat_match: function(password) {
        var base_analysis, base_guesses, base_matches, base_token, greedy, greedy_match, i, j, lastIndex, lazy, lazy_anchored, lazy_match, match, matches, ref;
        matches = [];
        greedy = /(.+)\1+/g;
        lazy = /(.+?)\1+/g;
        lazy_anchored = /^(.+?)\1+$/;
        lastIndex = 0;
        while(lastIndex < password.length){
            greedy.lastIndex = lazy.lastIndex = lastIndex;
            greedy_match = greedy.exec(password);
            lazy_match = lazy.exec(password);
            if (greedy_match == null) break;
            if (greedy_match[0].length > lazy_match[0].length) {
                match = greedy_match;
                base_token = lazy_anchored.exec(match[0])[1];
            } else {
                match = lazy_match;
                base_token = match[1];
            }
            ref = [
                match.index,
                match.index + match[0].length - 1
            ], i = ref[0], j = ref[1];
            base_analysis = $7bb929518d6859cf$var$scoring.most_guessable_match_sequence(base_token, this.omnimatch(base_token));
            base_matches = base_analysis.sequence;
            base_guesses = base_analysis.guesses;
            matches.push({
                pattern: 'repeat',
                i: i,
                j: j,
                token: match[0],
                base_token: base_token,
                base_guesses: base_guesses,
                base_matches: base_matches,
                repeat_count: match[0].length / base_token.length
            });
            lastIndex = j + 1;
        }
        return matches;
    },
    MAX_DELTA: 5,
    sequence_match: function(password) {
        var delta, i, j, k, last_delta, o, ref, result, update;
        if (password.length === 1) return [];
        update = function(_this) {
            return function(i, j, delta) {
                var ref, sequence_name, sequence_space, token;
                if (j - i > 1 || Math.abs(delta) === 1) {
                    if (0 < (ref = Math.abs(delta)) && ref <= _this.MAX_DELTA) {
                        token = password.slice(i, +j + 1 || 9e9);
                        if (/^[a-z]+$/.test(token)) {
                            sequence_name = 'lower';
                            sequence_space = 26;
                        } else if (/^[A-Z]+$/.test(token)) {
                            sequence_name = 'upper';
                            sequence_space = 26;
                        } else if (/^\d+$/.test(token)) {
                            sequence_name = 'digits';
                            sequence_space = 10;
                        } else {
                            sequence_name = 'unicode';
                            sequence_space = 26;
                        }
                        return result.push({
                            pattern: 'sequence',
                            i: i,
                            j: j,
                            token: password.slice(i, +j + 1 || 9e9),
                            sequence_name: sequence_name,
                            sequence_space: sequence_space,
                            ascending: delta > 0
                        });
                    }
                }
            };
        }(this);
        result = [];
        i = 0;
        last_delta = null;
        for(k = o = 1, ref = password.length; 1 <= ref ? o < ref : o > ref; k = 1 <= ref ? ++o : --o){
            delta = password.charCodeAt(k) - password.charCodeAt(k - 1);
            if (last_delta == null) last_delta = delta;
            if (delta === last_delta) continue;
            j = k - 1;
            update(i, j, last_delta);
            i = j;
            last_delta = delta;
        }
        update(i, password.length - 1, last_delta);
        return result;
    },
    regex_match: function(password, _regexen) {
        var matches, regex, rx_match, token;
        if (_regexen == null) _regexen = $7bb929518d6859cf$var$REGEXEN;
        matches = [];
        for($7bb929518d6859cf$var$name in _regexen){
            regex = _regexen[$7bb929518d6859cf$var$name];
            regex.lastIndex = 0;
            while(rx_match = regex.exec(password)){
                token = rx_match[0];
                matches.push({
                    pattern: 'regex',
                    token: token,
                    i: rx_match.index,
                    j: rx_match.index + rx_match[0].length - 1,
                    regex_name: $7bb929518d6859cf$var$name,
                    regex_match: rx_match
                });
            }
        }
        return this.sorted(matches);
    },
    date_match: function(password) {
        var best_candidate, candidate, candidates, distance, dmy, i, j, k, l, len1, len2, matches, maybe_date_no_separator, maybe_date_with_separator, metric, min_distance, o, p, q, r, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, rx_match, s, t, token;
        matches = [];
        maybe_date_no_separator = /^\d{4,8}$/;
        maybe_date_with_separator = /^(\d{1,4})([\s\/\\_.-])(\d{1,2})\2(\d{1,4})$/;
        for(i = o = 0, ref = password.length - 4; 0 <= ref ? o <= ref : o >= ref; i = 0 <= ref ? ++o : --o)for(j = p = ref1 = i + 3, ref2 = i + 7; ref1 <= ref2 ? p <= ref2 : p >= ref2; j = ref1 <= ref2 ? ++p : --p){
            if (j >= password.length) break;
            token = password.slice(i, +j + 1 || 9e9);
            if (!maybe_date_no_separator.exec(token)) continue;
            candidates = [];
            ref3 = $7bb929518d6859cf$var$DATE_SPLITS[token.length];
            for(q = 0, len1 = ref3.length; q < len1; q++){
                ref4 = ref3[q], k = ref4[0], l = ref4[1];
                dmy = this.map_ints_to_dmy([
                    parseInt(token.slice(0, k)),
                    parseInt(token.slice(k, l)),
                    parseInt(token.slice(l))
                ]);
                if (dmy != null) candidates.push(dmy);
            }
            if (!(candidates.length > 0)) continue;
            best_candidate = candidates[0];
            metric = function(candidate) {
                return Math.abs(candidate.year - $7bb929518d6859cf$var$scoring.REFERENCE_YEAR);
            };
            min_distance = metric(candidates[0]);
            ref5 = candidates.slice(1);
            for(r = 0, len2 = ref5.length; r < len2; r++){
                candidate = ref5[r];
                distance = metric(candidate);
                if (distance < min_distance) ref6 = [
                    candidate,
                    distance
                ], best_candidate = ref6[0], min_distance = ref6[1];
            }
            matches.push({
                pattern: 'date',
                token: token,
                i: i,
                j: j,
                separator: '',
                year: best_candidate.year,
                month: best_candidate.month,
                day: best_candidate.day
            });
        }
        for(i = s = 0, ref7 = password.length - 6; 0 <= ref7 ? s <= ref7 : s >= ref7; i = 0 <= ref7 ? ++s : --s)for(j = t = ref8 = i + 5, ref9 = i + 9; ref8 <= ref9 ? t <= ref9 : t >= ref9; j = ref8 <= ref9 ? ++t : --t){
            if (j >= password.length) break;
            token = password.slice(i, +j + 1 || 9e9);
            rx_match = maybe_date_with_separator.exec(token);
            if (rx_match == null) continue;
            dmy = this.map_ints_to_dmy([
                parseInt(rx_match[1]),
                parseInt(rx_match[3]),
                parseInt(rx_match[4])
            ]);
            if (dmy == null) continue;
            matches.push({
                pattern: 'date',
                token: token,
                i: i,
                j: j,
                separator: rx_match[2],
                year: dmy.year,
                month: dmy.month,
                day: dmy.day
            });
        }
        return this.sorted(matches.filter(function(match) {
            var is_submatch, len3, other_match, u;
            is_submatch = false;
            for(u = 0, len3 = matches.length; u < len3; u++){
                other_match = matches[u];
                if (match === other_match) continue;
                if (other_match.i <= match.i && other_match.j >= match.j) {
                    is_submatch = true;
                    break;
                }
            }
            return !is_submatch;
        }));
    },
    map_ints_to_dmy: function(ints) {
        var dm, int, len1, len2, len3, o, over_12, over_31, p, possible_year_splits, q, ref, ref1, rest, under_1, y;
        if (ints[1] > 31 || ints[1] <= 0) return;
        over_12 = 0;
        over_31 = 0;
        under_1 = 0;
        for(o = 0, len1 = ints.length; o < len1; o++){
            int = ints[o];
            if (99 < int && int < $7bb929518d6859cf$var$DATE_MIN_YEAR || int > $7bb929518d6859cf$var$DATE_MAX_YEAR) return;
            if (int > 31) over_31 += 1;
            if (int > 12) over_12 += 1;
            if (int <= 0) under_1 += 1;
        }
        if (over_31 >= 2 || over_12 === 3 || under_1 >= 2) return;
        possible_year_splits = [
            [
                ints[2],
                ints.slice(0, 2)
            ],
            [
                ints[0],
                ints.slice(1, 3)
            ]
        ];
        for(p = 0, len2 = possible_year_splits.length; p < len2; p++){
            ref = possible_year_splits[p], y = ref[0], rest = ref[1];
            if ($7bb929518d6859cf$var$DATE_MIN_YEAR <= y && y <= $7bb929518d6859cf$var$DATE_MAX_YEAR) {
                dm = this.map_ints_to_dm(rest);
                if (dm != null) return {
                    year: y,
                    month: dm.month,
                    day: dm.day
                };
                else return;
            }
        }
        for(q = 0, len3 = possible_year_splits.length; q < len3; q++){
            ref1 = possible_year_splits[q], y = ref1[0], rest = ref1[1];
            dm = this.map_ints_to_dm(rest);
            if (dm != null) {
                y = this.two_to_four_digit_year(y);
                return {
                    year: y,
                    month: dm.month,
                    day: dm.day
                };
            }
        }
    },
    map_ints_to_dm: function(ints) {
        var d, len1, m, o, ref, ref1;
        ref = [
            ints,
            ints.slice().reverse()
        ];
        for(o = 0, len1 = ref.length; o < len1; o++){
            ref1 = ref[o], d = ref1[0], m = ref1[1];
            if (1 <= d && d <= 31 && 1 <= m && m <= 12) return {
                day: d,
                month: m
            };
        }
    },
    two_to_four_digit_year: function(year) {
        if (year > 99) return year;
        else if (year > 50) return year + 1900;
        else return year + 2000;
    }
};
module.exports = $7bb929518d6859cf$var$matching;

});
parcelRegister("8By0C", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $643c28ec85b1ecb7$var$frequency_lists;
$643c28ec85b1ecb7$var$frequency_lists = {
    passwords: "123456,password,12345678,qwerty,123456789,12345,1234,111111,1234567,dragon,123123,baseball,abc123,football,monkey,letmein,shadow,master,696969,mustang,666666,qwertyuiop,123321,1234567890,pussy,superman,654321,1qaz2wsx,7777777,fuckyou,qazwsx,jordan,123qwe,000000,killer,trustno1,hunter,harley,zxcvbnm,asdfgh,buster,batman,soccer,tigger,charlie,sunshine,iloveyou,fuckme,ranger,hockey,computer,starwars,asshole,pepper,klaster,112233,zxcvbn,freedom,princess,maggie,pass,ginger,11111111,131313,fuck,love,cheese,159753,summer,chelsea,dallas,biteme,matrix,yankees,6969,corvette,austin,access,thunder,merlin,secret,diamond,hello,hammer,fucker,1234qwer,silver,gfhjkm,internet,samantha,golfer,scooter,test,orange,cookie,q1w2e3r4t5,maverick,sparky,phoenix,mickey,bigdog,snoopy,guitar,whatever,chicken,camaro,mercedes,peanut,ferrari,falcon,cowboy,welcome,sexy,samsung,steelers,smokey,dakota,arsenal,boomer,eagles,tigers,marina,nascar,booboo,gateway,yellow,porsche,monster,spider,diablo,hannah,bulldog,junior,london,purple,compaq,lakers,iceman,qwer1234,hardcore,cowboys,money,banana,ncc1701,boston,tennis,q1w2e3r4,coffee,scooby,123654,nikita,yamaha,mother,barney,brandy,chester,fuckoff,oliver,player,forever,rangers,midnight,chicago,bigdaddy,redsox,angel,badboy,fender,jasper,slayer,rabbit,natasha,marine,bigdick,wizard,marlboro,raiders,prince,casper,fishing,flower,jasmine,iwantu,panties,adidas,winter,winner,gandalf,password1,enter,ghbdtn,1q2w3e4r,golden,cocacola,jordan23,winston,madison,angels,panther,blowme,sexsex,bigtits,spanky,bitch,sophie,asdfasdf,horny,thx1138,toyota,tiger,dick,canada,12344321,blowjob,8675309,muffin,liverpoo,apples,qwerty123,passw0rd,abcd1234,pokemon,123abc,slipknot,qazxsw,123456a,scorpion,qwaszx,butter,startrek,rainbow,asdfghjkl,razz,newyork,redskins,gemini,cameron,qazwsxedc,florida,liverpool,turtle,sierra,viking,booger,butthead,doctor,rocket,159357,dolphins,captain,bandit,jaguar,packers,pookie,peaches,789456,asdf,dolphin,helpme,blue,theman,maxwell,qwertyui,shithead,lovers,maddog,giants,nirvana,metallic,hotdog,rosebud,mountain,warrior,stupid,elephant,suckit,success,bond007,jackass,alexis,porn,lucky,scorpio,samson,q1w2e3,azerty,rush2112,driver,freddy,1q2w3e4r5t,sydney,gators,dexter,red123,123456q,12345a,bubba,creative,voodoo,golf,trouble,america,nissan,gunner,garfield,bullshit,asdfghjk,5150,fucking,apollo,1qazxsw2,2112,eminem,legend,airborne,bear,beavis,apple,brooklyn,godzilla,skippy,4815162342,buddy,qwert,kitten,magic,shelby,beaver,phantom,asdasd,xavier,braves,darkness,blink182,copper,platinum,qweqwe,tomcat,01012011,girls,bigboy,102030,animal,police,online,11223344,voyager,lifehack,12qwaszx,fish,sniper,315475,trinity,blazer,heaven,lover,snowball,playboy,loveme,bubbles,hooters,cricket,willow,donkey,topgun,nintendo,saturn,destiny,pakistan,pumpkin,digital,sergey,redwings,explorer,tits,private,runner,therock,guinness,lasvegas,beatles,789456123,fire,cassie,christin,qwerty1,celtic,asdf1234,andrey,broncos,007007,babygirl,eclipse,fluffy,cartman,michigan,carolina,testing,alexande,birdie,pantera,cherry,vampire,mexico,dickhead,buffalo,genius,montana,beer,minecraft,maximus,flyers,lovely,stalker,metallica,doggie,snickers,speedy,bronco,lol123,paradise,yankee,horses,magnum,dreams,147258369,lacrosse,ou812,goober,enigma,qwertyu,scotty,pimpin,bollocks,surfer,cock,poohbear,genesis,star,asd123,qweasdzxc,racing,hello1,hawaii,eagle1,viper,poopoo,einstein,boobies,12345q,bitches,drowssap,simple,badger,alaska,action,jester,drummer,111222,spitfire,forest,maryjane,champion,diesel,svetlana,friday,hotrod,147258,chevy,lucky1,westside,security,google,badass,tester,shorty,thumper,hitman,mozart,zaq12wsx,boobs,reddog,010203,lizard,a123456,123456789a,ruslan,eagle,1232323q,scarface,qwerty12,147852,a12345,buddha,porno,420420,spirit,money1,stargate,qwe123,naruto,mercury,liberty,12345qwert,semperfi,suzuki,popcorn,spooky,marley,scotland,kitty,cherokee,vikings,simpsons,rascal,qweasd,hummer,loveyou,michael1,patches,russia,jupiter,penguin,passion,cumshot,vfhbyf,honda,vladimir,sandman,passport,raider,bastard,123789,infinity,assman,bulldogs,fantasy,sucker,1234554321,horney,domino,budlight,disney,ironman,usuckballz1,softball,brutus,redrum,bigred,mnbvcxz,fktrcfylh,karina,marines,digger,kawasaki,cougar,fireman,oksana,monday,cunt,justice,nigger,super,wildcats,tinker,logitech,dancer,swordfis,avalon,everton,alexandr,motorola,patriots,hentai,madonna,pussy1,ducati,colorado,connor,juventus,galore,smooth,freeuser,warcraft,boogie,titanic,wolverin,elizabet,arizona,valentin,saints,asdfg,accord,test123,password123,christ,yfnfif,stinky,slut,spiderma,naughty,chopper,hello123,ncc1701d,extreme,skyline,poop,zombie,pearljam,123qweasd,froggy,awesome,vision,pirate,fylhtq,dreamer,bullet,predator,empire,123123a,kirill,charlie1,panthers,penis,skipper,nemesis,rasdzv3,peekaboo,rolltide,cardinal,psycho,danger,mookie,happy1,wanker,chevelle,manutd,goblue,9379992,hobbes,vegeta,fyfcnfcbz,852456,picard,159951,windows,loverboy,victory,vfrcbv,bambam,serega,123654789,turkey,tweety,galina,hiphop,rooster,changeme,berlin,taurus,suckme,polina,electric,avatar,134679,maksim,raptor,alpha1,hendrix,newport,bigcock,brazil,spring,a1b2c3,madmax,alpha,britney,sublime,darkside,bigman,wolfpack,classic,hercules,ronaldo,letmein1,1q2w3e,741852963,spiderman,blizzard,123456789q,cheyenne,cjkysirj,tiger1,wombat,bubba1,pandora,zxc123,holiday,wildcat,devils,horse,alabama,147852369,caesar,12312,buddy1,bondage,pussycat,pickle,shaggy,catch22,leather,chronic,a1b2c3d4,admin,qqq111,qaz123,airplane,kodiak,freepass,billybob,sunset,katana,phpbb,chocolat,snowman,angel1,stingray,firebird,wolves,zeppelin,detroit,pontiac,gundam,panzer,vagina,outlaw,redhead,tarheels,greenday,nastya,01011980,hardon,engineer,dragon1,hellfire,serenity,cobra,fireball,lickme,darkstar,1029384756,01011,mustang1,flash,124578,strike,beauty,pavilion,01012000,bobafett,dbrnjhbz,bigmac,bowling,chris1,ytrewq,natali,pyramid,rulez,welcome1,dodgers,apache,swimming,whynot,teens,trooper,fuckit,defender,precious,135790,packard,weasel,popeye,lucifer,cancer,icecream,142536,raven,swordfish,presario,viktor,rockstar,blonde,james1,wutang,spike,pimp,atlanta,airforce,thailand,casino,lennon,mouse,741852,hacker,bluebird,hawkeye,456123,theone,catfish,sailor,goldfish,nfnmzyf,tattoo,pervert,barbie,maxima,nipples,machine,trucks,wrangler,rocks,tornado,lights,cadillac,bubble,pegasus,madman,longhorn,browns,target,666999,eatme,qazwsx123,microsoft,dilbert,christia,baller,lesbian,shooter,xfiles,seattle,qazqaz,cthutq,amateur,prelude,corona,freaky,malibu,123qweasdzxc,assassin,246810,atlantis,integra,pussies,iloveu,lonewolf,dragons,monkey1,unicorn,software,bobcat,stealth,peewee,openup,753951,srinivas,zaqwsx,valentina,shotgun,trigger,veronika,bruins,coyote,babydoll,joker,dollar,lestat,rocky1,hottie,random,butterfly,wordpass,smiley,sweety,snake,chipper,woody,samurai,devildog,gizmo,maddie,soso123aljg,mistress,freedom1,flipper,express,hjvfirf,moose,cessna,piglet,polaris,teacher,montreal,cookies,wolfgang,scully,fatboy,wicked,balls,tickle,bunny,dfvgbh,foobar,transam,pepsi,fetish,oicu812,basketba,toshiba,hotstuff,sunday,booty,gambit,31415926,impala,stephani,jessica1,hooker,lancer,knicks,shamrock,fuckyou2,stinger,314159,redneck,deftones,squirt,siemens,blaster,trucker,subaru,renegade,ibanez,manson,swinger,reaper,blondie,mylove,galaxy,blahblah,enterpri,travel,1234abcd,babylon5,indiana,skeeter,master1,sugar,ficken,smoke,bigone,sweetpea,fucked,trfnthbyf,marino,escort,smitty,bigfoot,babes,larisa,trumpet,spartan,valera,babylon,asdfghj,yankees1,bigboobs,stormy,mister,hamlet,aardvark,butterfl,marathon,paladin,cavalier,manchester,skater,indigo,hornet,buckeyes,01011990,indians,karate,hesoyam,toronto,diamonds,chiefs,buckeye,1qaz2wsx3edc,highland,hotsex,charger,redman,passwor,maiden,drpepper,storm,pornstar,garden,12345678910,pencil,sherlock,timber,thuglife,insane,pizza,jungle,jesus1,aragorn,1a2b3c,hamster,david1,triumph,techno,lollol,pioneer,catdog,321654,fktrctq,morpheus,141627,pascal,shadow1,hobbit,wetpussy,erotic,consumer,blabla,justme,stones,chrissy,spartak,goforit,burger,pitbull,adgjmptw,italia,barcelona,hunting,colors,kissme,virgin,overlord,pebbles,sundance,emerald,doggy,racecar,irina,element,1478963,zipper,alpine,basket,goddess,poison,nipple,sakura,chichi,huskers,13579,pussys,q12345,ultimate,ncc1701e,blackie,nicola,rommel,matthew1,caserta,omega,geronimo,sammy1,trojan,123qwe123,philips,nugget,tarzan,chicks,aleksandr,bassman,trixie,portugal,anakin,dodger,bomber,superfly,madness,q1w2e3r4t5y6,loser,123asd,fatcat,ybrbnf,soldier,warlock,wrinkle1,desire,sexual,babe,seminole,alejandr,951753,11235813,westham,andrei,concrete,access14,weed,letmein2,ladybug,naked,christop,trombone,tintin,bluesky,rhbcnbyf,qazxswedc,onelove,cdtnkfyf,whore,vfvjxrf,titans,stallion,truck,hansolo,blue22,smiles,beagle,panama,kingkong,flatron,inferno,mongoose,connect,poiuyt,snatch,qawsed,juice,blessed,rocker,snakes,turbo,bluemoon,sex4me,finger,jamaica,a1234567,mulder,beetle,fuckyou1,passat,immortal,plastic,123454321,anthony1,whiskey,dietcoke,suck,spunky,magic1,monitor,cactus,exigen,planet,ripper,teen,spyder,apple1,nolimit,hollywoo,sluts,sticky,trunks,1234321,14789632,pickles,sailing,bonehead,ghbdtnbr,delta,charlott,rubber,911911,112358,molly1,yomama,hongkong,jumper,william1,ilovesex,faster,unreal,cumming,memphis,1123581321,nylons,legion,sebastia,shalom,pentium,geheim,werewolf,funtime,ferret,orion,curious,555666,niners,cantona,sprite,philly,pirates,abgrtyu,lollipop,eternity,boeing,super123,sweets,cooldude,tottenha,green1,jackoff,stocking,7895123,moomoo,martini,biscuit,drizzt,colt45,fossil,makaveli,snapper,satan666,maniac,salmon,patriot,verbatim,nasty,shasta,asdzxc,shaved,blackcat,raistlin,qwerty12345,punkrock,cjkywt,01012010,4128,waterloo,crimson,twister,oxford,musicman,seinfeld,biggie,condor,ravens,megadeth,wolfman,cosmos,sharks,banshee,keeper,foxtrot,gn56gn56,skywalke,velvet,black1,sesame,dogs,squirrel,privet,sunrise,wolverine,sucks,legolas,grendel,ghost,cats,carrot,frosty,lvbnhbq,blades,stardust,frog,qazwsxed,121314,coolio,brownie,groovy,twilight,daytona,vanhalen,pikachu,peanuts,licker,hershey,jericho,intrepid,ninja,1234567a,zaq123,lobster,goblin,punisher,strider,shogun,kansas,amadeus,seven7,jason1,neptune,showtime,muscle,oldman,ekaterina,rfrfirf,getsome,showme,111222333,obiwan,skittles,danni,tanker,maestro,tarheel,anubis,hannibal,anal,newlife,gothic,shark,fighter,blue123,blues,123456z,princes,slick,chaos,thunder1,sabine,1q2w3e4r5t6y,python,test1,mirage,devil,clover,tequila,chelsea1,surfing,delete,potato,chubby,panasonic,sandiego,portland,baggins,fusion,sooners,blackdog,buttons,californ,moscow,playtime,mature,1a2b3c4d,dagger,dima,stimpy,asdf123,gangster,warriors,iverson,chargers,byteme,swallow,liquid,lucky7,dingdong,nymets,cracker,mushroom,456852,crusader,bigguy,miami,dkflbvbh,bugger,nimrod,tazman,stranger,newpass,doodle,powder,gotcha,guardian,dublin,slapshot,septembe,147896325,pepsi1,milano,grizzly,woody1,knights,photos,2468,nookie,charly,rammstein,brasil,123321123,scruffy,munchkin,poopie,123098,kittycat,latino,walnut,1701,thegame,viper1,1passwor,kolobok,picasso,robert1,barcelon,bananas,trance,auburn,coltrane,eatshit,goodluck,starcraft,wheels,parrot,postal,blade,wisdom,pink,gorilla,katerina,pass123,andrew1,shaney14,dumbass,osiris,fuck_inside,oakland,discover,ranger1,spanking,lonestar,bingo,meridian,ping,heather1,dookie,stonecol,megaman,192837465,rjntyjr,ledzep,lowrider,25802580,richard1,firefly,griffey,racerx,paradox,ghjcnj,gangsta,zaq1xsw2,tacobell,weezer,sirius,halflife,buffett,shiloh,123698745,vertigo,sergei,aliens,sobaka,keyboard,kangaroo,sinner,soccer1,0.0.000,bonjour,socrates,chucky,hotboy,sprint,0007,sarah1,scarlet,celica,shazam,formula1,sommer,trebor,qwerasdf,jeep,mailcreated5240,bollox,asshole1,fuckface,honda1,rebels,vacation,lexmark,penguins,12369874,ragnarok,formula,258456,tempest,vfhecz,tacoma,qwertz,colombia,flames,rockon,duck,prodigy,wookie,dodgeram,mustangs,123qaz,sithlord,smoker,server,bang,incubus,scoobydo,oblivion,molson,kitkat,titleist,rescue,zxcv1234,carpet,1122,bigballs,tardis,jimbob,xanadu,blueeyes,shaman,mersedes,pooper,pussy69,golfing,hearts,mallard,12312312,kenwood,patrick1,dogg,cowboys1,oracle,123zxc,nuttertools,102938,topper,1122334455,shemale,sleepy,gremlin,yourmom,123987,gateway1,printer,monkeys,peterpan,mikey,kingston,cooler,analsex,jimbo,pa55word,asterix,freckles,birdman,frank1,defiant,aussie,stud,blondes,tatyana,445566,aspirine,mariners,jackal,deadhead,katrin,anime,rootbeer,frogger,polo,scooter1,hallo,noodles,thomas1,parola,shaolin,celine,11112222,plymouth,creampie,justdoit,ohyeah,fatass,assfuck,amazon,1234567q,kisses,magnus,camel,nopass,bosco,987456,6751520,harley1,putter,champs,massive,spidey,lightnin,camelot,letsgo,gizmodo,aezakmi,bones,caliente,12121,goodtime,thankyou,raiders1,brucelee,redalert,aquarius,456654,catherin,smokin,pooh,mypass,astros,roller,porkchop,sapphire,qwert123,kevin1,a1s2d3f4,beckham,atomic,rusty1,vanilla,qazwsxedcrfv,hunter1,kaktus,cxfcnmt,blacky,753159,elvis1,aggies,blackjac,bangkok,scream,123321q,iforgot,power1,kasper,abc12,buster1,slappy,shitty,veritas,chevrole,amber1,01012001,vader,amsterdam,jammer,primus,spectrum,eduard,granny,horny1,sasha1,clancy,usa123,satan,diamond1,hitler,avenger,1221,spankme,123456qwerty,simba,smudge,scrappy,labrador,john316,syracuse,front242,falcons,husker,candyman,commando,gator,pacman,delta1,pancho,krishna,fatman,clitoris,pineappl,lesbians,8j4ye3uz,barkley,vulcan,punkin,boner,celtics,monopoly,flyboy,romashka,hamburg,123456aa,lick,gangbang,223344,area51,spartans,aaa111,tricky,snuggles,drago,homerun,vectra,homer1,hermes,topcat,cuddles,infiniti,1234567890q,cosworth,goose,phoenix1,killer1,ivanov,bossman,qawsedrf,peugeot,exigent,doberman,durango,brandon1,plumber,telefon,horndog,laguna,rbhbkk,dawg,webmaster,breeze,beast,porsche9,beefcake,leopard,redbull,oscar1,topdog,godsmack,theking,pics,omega1,speaker,viktoria,fuckers,bowler,starbuck,gjkbyf,valhalla,anarchy,blacks,herbie,kingpin,starfish,nokia,loveit,achilles,906090,labtec,ncc1701a,fitness,jordan1,brando,arsenal1,bull,kicker,napass,desert,sailboat,bohica,tractor,hidden,muppet,jackson1,jimmy1,terminator,phillies,pa55w0rd,terror,farside,swingers,legacy,frontier,butthole,doughboy,jrcfyf,tuesday,sabbath,daniel1,nebraska,homers,qwertyuio,azamat,fallen,agent007,striker,camels,iguana,looker,pinkfloy,moloko,qwerty123456,dannyboy,luckydog,789654,pistol,whocares,charmed,skiing,select,franky,puppy,daniil,vladik,vette,vfrcbvrf,ihateyou,nevada,moneys,vkontakte,mandingo,puppies,666777,mystic,zidane,kotenok,dilligaf,budman,bunghole,zvezda,123457,triton,golfball,technics,trojans,panda,laptop,rookie,01011991,15426378,aberdeen,gustav,jethro,enterprise,igor,stripper,filter,hurrican,rfnthbyf,lespaul,gizmo1,butch,132435,dthjybrf,1366613,excalibu,963852,nofear,momoney,possum,cutter,oilers,moocow,cupcake,gbpltw,batman1,splash,svetik,super1,soleil,bogdan,melissa1,vipers,babyboy,tdutybq,lancelot,ccbill,keystone,passwort,flamingo,firefox,dogman,vortex,rebel,noodle,raven1,zaphod,killme,pokemon1,coolman,danila,designer,skinny,kamikaze,deadman,gopher,doobie,warhammer,deeznuts,freaks,engage,chevy1,steve1,apollo13,poncho,hammers,azsxdc,dracula,000007,sassy,bitch1,boots,deskjet,12332,macdaddy,mighty,rangers1,manchest,sterlin,casey1,meatball,mailman,sinatra,cthulhu,summer1,bubbas,cartoon,bicycle,eatpussy,truelove,sentinel,tolkien,breast,capone,lickit,summit,123456k,peter1,daisy1,kitty1,123456789z,crazy1,jamesbon,texas1,sexygirl,362436,sonic,billyboy,redhot,microsof,microlab,daddy1,rockets,iloveyo,fernand,gordon24,danie,cutlass,polska,star69,titties,pantyhos,01011985,thekid,aikido,gofish,mayday,1234qwe,coke,anfield,sony,lansing,smut,scotch,sexx,catman,73501505,hustler,saun,dfkthbz,passwor1,jenny1,azsxdcfv,cheers,irish1,gabrie,tinman,orioles,1225,charlton,fortuna,01011970,airbus,rustam,xtreme,bigmoney,zxcasd,retard,grumpy,huskies,boxing,4runner,kelly1,ultima,warlord,fordf150,oranges,rotten,asdfjkl,superstar,denali,sultan,bikini,saratoga,thor,figaro,sixers,wildfire,vladislav,128500,sparta,mayhem,greenbay,chewie,music1,number1,cancun,fabie,mellon,poiuytrewq,cloud9,crunch,bigtime,chicken1,piccolo,bigbird,321654987,billy1,mojo,01011981,maradona,sandro,chester1,bizkit,rjirfrgbde,789123,rightnow,jasmine1,hyperion,treasure,meatloaf,armani,rovers,jarhead,01011986,cruise,coconut,dragoon,utopia,davids,cosmo,rfhbyf,reebok,1066,charli,giorgi,sticks,sayang,pass1234,exodus,anaconda,zaqxsw,illini,woofwoof,emily1,sandy1,packer,poontang,govols,jedi,tomato,beaner,cooter,creamy,lionking,happy123,albatros,poodle,kenworth,dinosaur,greens,goku,happyday,eeyore,tsunami,cabbage,holyshit,turkey50,memorex,chaser,bogart,orgasm,tommy1,volley,whisper,knopka,ericsson,walleye,321123,pepper1,katie1,chickens,tyler1,corrado,twisted,100000,zorro,clemson,zxcasdqwe,tootsie,milana,zenith,fktrcfylhf,shania,frisco,polniypizdec0211,crazybab,junebug,fugazi,rereirf,vfvekz,1001,sausage,vfczyz,koshka,clapton,justin1,anhyeuem,condom,fubar,hardrock,skywalker,tundra,cocks,gringo,150781,canon,vitalik,aspire,stocks,samsung1,applepie,abc12345,arjay,gandalf1,boob,pillow,sparkle,gmoney,rockhard,lucky13,samiam,everest,hellyeah,bigsexy,skorpion,rfrnec,hedgehog,australi,candle,slacker,dicks,voyeur,jazzman,america1,bobby1,br0d3r,wolfie,vfksirf,1qa2ws3ed,13243546,fright,yosemite,temp,karolina,fart,barsik,surf,cheetah,baddog,deniska,starship,bootie,milena,hithere,kume,greatone,dildo,50cent,0.0.0.000,albion,amanda1,midget,lion,maxell,football1,cyclone,freeporn,nikola,bonsai,kenshin,slider,balloon,roadkill,killbill,222333,jerkoff,78945612,dinamo,tekken,rambler,goliath,cinnamon,malaka,backdoor,fiesta,packers1,rastaman,fletch,sojdlg123aljg,stefano,artemis,calico,nyjets,damnit,robotech,duchess,rctybz,hooter,keywest,18436572,hal9000,mechanic,pingpong,operator,presto,sword,rasputin,spank,bristol,faggot,shado,963852741,amsterda,321456,wibble,carrera,alibaba,majestic,ramses,duster,route66,trident,clipper,steeler,wrestlin,divine,kipper,gotohell,kingfish,snake1,passwords,buttman,pompey,viagra,zxcvbnm1,spurs,332211,slutty,lineage2,oleg,macross,pooter,brian1,qwert1,charles1,slave,jokers,yzerman,swimmer,ne1469,nwo4life,solnce,seamus,lolipop,pupsik,moose1,ivanova,secret1,matador,love69,420247,ktyjxrf,subway,cinder,vermont,pussie,chico,florian,magick,guiness,allsop,ghetto,flash1,a123456789,typhoon,dfkthf,depeche,skydive,dammit,seeker,fuckthis,crysis,kcj9wx5n,umbrella,r2d2c3po,123123q,snoopdog,critter,theboss,ding,162534,splinter,kinky,cyclops,jayhawk,456321,caramel,qwer123,underdog,caveman,onlyme,grapes,feather,hotshot,fuckher,renault,george1,sex123,pippen,000001,789987,floppy,cunts,megapass,1000,pornos,usmc,kickass,great1,quattro,135246,wassup,helloo,p0015123,nicole1,chivas,shannon1,bullseye,java,fishes,blackhaw,jamesbond,tunafish,juggalo,dkflbckfd,123789456,dallas1,translator,122333,beanie,alucard,gfhjkm123,supersta,magicman,ashley1,cohiba,xbox360,caligula,12131415,facial,7753191,dfktynbyf,cobra1,cigars,fang,klingon,bob123,safari,looser,10203,deepthroat,malina,200000,tazmania,gonzo,goalie,jacob1,monaco,cruiser,misfit,vh5150,tommyboy,marino13,yousuck,sharky,vfhufhbnf,horizon,absolut,brighton,123456r,death1,kungfu,maxx,forfun,mamapapa,enter1,budweise,banker,getmoney,kostya,qazwsx12,bigbear,vector,fallout,nudist,gunners,royals,chainsaw,scania,trader,blueboy,walrus,eastside,kahuna,qwerty1234,love123,steph,01011989,cypress,champ,undertaker,ybrjkfq,europa,snowboar,sabres,moneyman,chrisbln,minime,nipper,groucho,whitey,viewsonic,penthous,wolf359,fabric,flounder,coolguy,whitesox,passme,smegma,skidoo,thanatos,fucku2,snapple,dalejr,mondeo,thesims,mybaby,panasoni,sinbad,thecat,topher,frodo,sneakers,q123456,z1x2c3,alfa,chicago1,taylor1,ghjcnjnfr,cat123,olivier,cyber,titanium,0420,madison1,jabroni,dang,hambone,intruder,holly1,gargoyle,sadie1,static,poseidon,studly,newcastl,sexxxx,poppy,johannes,danzig,beastie,musica,buckshot,sunnyday,adonis,bluedog,bonkers,2128506,chrono,compute,spawn,01011988,turbo1,smelly,wapbbs,goldstar,ferrari1,778899,quantum,pisces,boomboom,gunnar,1024,test1234,florida1,nike,superman1,multiplelo,custom,motherlode,1qwerty,westwood,usnavy,apple123,daewoo,korn,stereo,sasuke,sunflowe,watcher,dharma,555777,mouse1,assholes,babyblue,123qwerty,marius,walmart,snoop,starfire,tigger1,paintbal,knickers,aaliyah,lokomotiv,theend,winston1,sapper,rover,erotica,scanner,racer,zeus,sexy69,doogie,bayern,joshua1,newbie,scott1,losers,droopy,outkast,martin1,dodge1,wasser,ufkbyf,rjycnfynby,thirteen,12345z,112211,hotred,deejay,hotpussy,192837,jessic,philippe,scout,panther1,cubbies,havefun,magpie,fghtkm,avalanch,newyork1,pudding,leonid,harry1,cbr600,audia4,bimmer,fucku,01011984,idontknow,vfvfgfgf,1357,aleksey,builder,01011987,zerocool,godfather,mylife,donuts,allmine,redfish,777888,sascha,nitram,bounce,333666,smokes,1x2zkg8w,rodman,stunner,zxasqw12,hoosier,hairy,beretta,insert,123456s,rtyuehe,francesc,tights,cheese1,micron,quartz,hockey1,gegcbr,searay,jewels,bogey,paintball,celeron,padres,bing,syncmaster,ziggy,simon1,beaches,prissy,diehard,orange1,mittens,aleksandra,queens,02071986,biggles,thongs,southpark,artur,twinkle,gretzky,rabota,cambiami,monalisa,gollum,chuckles,spike1,gladiator,whisky,spongebob,sexy1,03082006,mazafaka,meathead,4121,ou8122,barefoot,12345678q,cfitymrf,bigass,a1s2d3,kosmos,blessing,titty,clevelan,terrapin,ginger1,johnboy,maggot,clarinet,deeznutz,336699,stumpy,stoney,footbal,traveler,volvo,bucket,snapon,pianoman,hawkeyes,futbol,casanova,tango,goodboy,scuba,honey1,sexyman,warthog,mustard,abc1234,nickel,10203040,meowmeow,1012,boricua,prophet,sauron,12qwas,reefer,andromeda,crystal1,joker1,90210,goofy,loco,lovesex,triangle,whatsup,mellow,bengals,monster1,maste,01011910,lover1,love1,123aaa,sunshin,smeghead,hokies,sting,welder,rambo,cerberus,bunny1,rockford,monke,1q2w3e4r5,goldwing,gabriell,buzzard,crjhgbjy,james007,rainman,groove,tiberius,purdue,nokia6300,hayabusa,shou,jagger,diver,zigzag,poochie,usarmy,phish,redwood,redwing,12345679,salamander,silver1,abcd123,sputnik,boobie,ripple,eternal,12qw34er,thegreat,allstar,slinky,gesperrt,mishka,whiskers,pinhead,overkill,sweet1,rhfcjnrf,montgom240,sersolution,jamie1,starman,proxy,swords,nikolay,bacardi,rasta,badgirl,rebecca1,wildman,penny1,spaceman,1007,10101,logan1,hacked,bulldog1,helmet,windsor,buffy1,runescape,trapper,123451,banane,dbrnjh,ripken,12345qwe,frisky,shun,fester,oasis,lightning,ib6ub9,cicero,kool,pony,thedog,784512,01011992,megatron,illusion,edward1,napster,11223,squash,roadking,woohoo,19411945,hoosiers,01091989,tracker,bagira,midway,leavemealone,br549,14725836,235689,menace,rachel1,feng,laser,stoned,realmadrid,787898,balloons,tinkerbell,5551212,maria1,pobeda,heineken,sonics,moonlight,optimus,comet,orchid,02071982,jaybird,kashmir,12345678a,chuang,chunky,peach,mortgage,rulezzz,saleen,chuckie,zippy,fishing1,gsxr750,doghouse,maxim,reader,shai,buddah,benfica,chou,salomon,meister,eraser,blackbir,bigmike,starter,pissing,angus,deluxe,eagles1,hardcock,135792468,mian,seahawks,godfathe,bookworm,gregor,intel,talisman,blackjack,babyface,hawaiian,dogfood,zhong,01011975,sancho,ludmila,medusa,mortimer,123456654321,roadrunn,just4me,stalin,01011993,handyman,alphabet,pizzas,calgary,clouds,password2,cgfhnfr,f**k,cubswin,gong,lexus,max123,xxx123,digital1,gfhjkm1,7779311,missy1,michae,beautifu,gator1,1005,pacers,buddie,chinook,heckfy,dutchess,sally1,breasts,beowulf,darkman,jenn,tiffany1,zhei,quan,qazwsx1,satana,shang,idontkno,smiths,puddin,nasty1,teddybea,valkyrie,passwd,chao,boxster,killers,yoda,cheater,inuyasha,beast1,wareagle,foryou,dragonball,mermaid,bhbirf,teddy1,dolphin1,misty1,delphi,gromit,sponge,qazzaq,fytxrf,gameover,diao,sergi,beamer,beemer,kittykat,rancid,manowar,adam12,diggler,assword,austin1,wishbone,gonavy,sparky1,fisting,thedude,sinister,1213,venera,novell,salsero,jayden,fuckoff1,linda1,vedder,02021987,1pussy,redline,lust,jktymrf,02011985,dfcbkbq,dragon12,chrome,gamecube,titten,cong,bella1,leng,02081988,eureka,bitchass,147369,banner,lakota,123321a,mustafa,preacher,hotbox,02041986,z1x2c3v4,playstation,01011977,claymore,electra,checkers,zheng,qing,armagedon,02051986,wrestle,svoboda,bulls,nimbus,alenka,madina,newpass6,onetime,aa123456,bartman,02091987,silverad,electron,12345t,devil666,oliver1,skylar,rhtdtlrj,gobucks,johann,12011987,milkman,02101985,camper,thunderb,bigbutt,jammin,davide,cheeks,goaway,lighter,claudi,thumbs,pissoff,ghostrider,cocaine,teng,squall,lotus,hootie,blackout,doitnow,subzero,02031986,marine1,02021988,pothead,123456qw,skate,1369,peng,antoni,neng,miao,bcfields,1492,marika,794613,musashi,tulips,nong,piao,chai,ruan,southpar,02061985,nude,mandarin,654123,ninjas,cannabis,jetski,xerxes,zhuang,kleopatra,dickie,bilbo,pinky,morgan1,1020,1017,dieter,baseball1,tottenham,quest,yfnfkmz,dirtbike,1234567890a,mango,jackson5,ipswich,iamgod,02011987,tdutybz,modena,qiao,slippery,qweasd123,bluefish,samtron,toon,111333,iscool,02091986,petrov,fuzzy,zhou,1357924680,mollydog,deng,02021986,1236987,pheonix,zhun,ghblehjr,othello,starcraf,000111,sanfran,a11111,cameltoe,badman,vasilisa,jiang,1qaz2ws,luan,sveta,12qw12,akira,chuai,369963,cheech,beatle,pickup,paloma,01011983,caravan,elizaveta,gawker,banzai,pussey,mullet,seng,bingo1,bearcat,flexible,farscape,borussia,zhuai,templar,guitar1,toolman,yfcntymrf,chloe1,xiang,slave1,guai,nuggets,02081984,mantis,slim,scorpio1,fyutkbyf,thedoors,02081987,02061986,123qq123,zappa,fergie,7ugd5hip2j,huai,asdfzxcv,sunflower,pussyman,deadpool,bigtit,01011982,love12,lassie,skyler,gatorade,carpedie,jockey,mancity,spectre,02021984,cameron1,artemka,reng,02031984,iomega,jing,moritz,spice,rhino,spinner,heater,zhai,hover,talon,grease,qiong,corleone,ltybcrf,tian,cowboy1,hippie,chimera,ting,alex123,02021985,mickey1,corsair,sonoma,aaron1,xxxpass,bacchus,webmaste,chuo,xyz123,chrysler,spurs1,artem,shei,cosmic,01020304,deutsch,gabriel1,123455,oceans,987456321,binladen,latinas,a12345678,speedo,buttercu,02081989,21031988,merlot,millwall,ceng,kotaku,jiong,dragonba,2580,stonecold,snuffy,01011999,02011986,hellos,blaze,maggie1,slapper,istanbul,bonjovi,babylove,mazda,bullfrog,phoeni,meng,porsche1,nomore,02061989,bobdylan,capslock,orion1,zaraza,teddybear,ntktajy,myname,rong,wraith,mets,niao,02041984,smokie,chevrolet,dialog,gfhjkmgfhjkm,dotcom,vadim,monarch,athlon,mikey1,hamish,pian,liang,coolness,chui,thoma,ramones,ciccio,chippy,eddie1,house1,ning,marker,cougars,jackpot,barbados,reds,pdtplf,knockers,cobalt,amateurs,dipshit,napoli,kilroy,pulsar,jayhawks,daemon,alexey,weng,shuang,9293709b13,shiner,eldorado,soulmate,mclaren,golfer1,andromed,duan,50spanks,sexyboy,dogshit,02021983,shuo,kakashka,syzygy,111111a,yeahbaby,qiang,netscape,fulham,120676,gooner,zhui,rainbow6,laurent,dog123,halifax,freeway,carlitos,147963,eastwood,microphone,monkey12,1123,persik,coldbeer,geng,nuan,danny1,fgtkmcby,entropy,gadget,just4fun,sophi,baggio,carlito,1234567891,02021989,02041983,specialk,piramida,suan,bigblue,salasana,hopeful,mephisto,bailey1,hack,annie1,generic,violetta,spencer1,arcadia,02051983,hondas,9562876,trainer,jones1,smashing,liao,159632,iceberg,rebel1,snooker,temp123,zang,matteo,fastball,q2w3e4r5,bamboo,fuckyo,shutup,astro,buddyboy,nikitos,redbird,maxxxx,shitface,02031987,kuai,kissmyass,sahara,radiohea,1234asdf,wildcard,maxwell1,patric,plasma,heynow,bruno1,shao,bigfish,misfits,sassy1,sheng,02011988,02081986,testpass,nanook,cygnus,licking,slavik,pringles,xing,1022,ninja1,submit,dundee,tiburon,pinkfloyd,yummy,shuai,guang,chopin,obelix,insomnia,stroker,1a2s3d4f,1223,playboy1,lazarus,jorda,spider1,homerj,sleeper,02041982,darklord,cang,02041988,02041987,tripod,magician,jelly,telephon,15975,vsjasnel12,pasword,iverson3,pavlov,homeboy,gamecock,amigo,brodie,budapest,yjdsqgfhjkm,reckless,02011980,pang,tiger123,2469,mason1,orient,01011979,zong,cdtnbr,maksimka,1011,bushido,taxman,giorgio,sphinx,kazantip,02101984,concorde,verizon,lovebug,georg,sam123,seadoo,qazwsxedc123,jiao,jezebel,pharmacy,abnormal,jellybea,maxime,puffy,islander,bunnies,jiggaman,drakon,010180,pluto,zhjckfd,12365,classics,crusher,mordor,hooligan,strawberry,02081985,scrabble,hawaii50,1224,wg8e3wjf,cthtuf,premium,arrow,123456qwe,mazda626,ramrod,tootie,rhjrjlbk,ghost1,1211,bounty,niang,02071984,goat,killer12,sweetnes,porno1,masamune,426hemi,corolla,mariposa,hjccbz,doomsday,bummer,blue12,zhao,bird33,excalibur,samsun,kirsty,buttfuck,kfhbcf,zhuo,marcello,ozzy,02021982,dynamite,655321,master12,123465,lollypop,stepan,1qa2ws,spiker,goirish,callum,michael2,moonbeam,attila,henry1,lindros,andrea1,sporty,lantern,12365478,nextel,violin,volcom,998877,water1,imation,inspiron,dynamo,citadel,placebo,clowns,tiao,02061988,tripper,dabears,haggis,merlin1,02031985,anthrax,amerika,iloveme,vsegda,burrito,bombers,snowboard,forsaken,katarina,a1a2a3,woofer,tigger2,fullmoon,tiger2,spock,hannah1,snoopy1,sexxxy,sausages,stanislav,cobain,robotics,exotic,green123,mobydick,senators,pumpkins,fergus,asddsa,147741,258852,windsurf,reddevil,vfitymrf,nevermind,nang,woodland,4417,mick,shui,q1q2q3,wingman,69696,superb,zuan,ganesh,pecker,zephyr,anastasiya,icu812,larry1,02081982,broker,zalupa,mihail,vfibyf,dogger,7007,paddle,varvara,schalke,1z2x3c,presiden,yankees2,tuning,poopy,02051982,concord,vanguard,stiffy,rjhjktdf,felix1,wrench,firewall,boxer,bubba69,popper,02011984,temppass,gobears,cuan,tipper,fuckme1,kamila,thong,puss,bigcat,drummer1,02031982,sowhat,digimon,tigers1,rang,jingle,bian,uranus,soprano,mandy1,dusty1,fandango,aloha,pumpkin1,postman,02061980,dogcat,bombay,pussy123,onetwo,highheel,pippo,julie1,laura1,pepito,beng,smokey1,stylus,stratus,reload,duckie,karen1,jimbo1,225588,369258,krusty,snappy,asdf12,electro,111qqq,kuang,fishin,clit,abstr,christma,qqqqq1,1234560,carnage,guyver,boxers,kittens,zeng,1000000,qwerty11,toaster,cramps,yugioh,02061987,icehouse,zxcvbnm123,pineapple,namaste,harrypotter,mygirl,falcon1,earnhard,fender1,spikes,nutmeg,01081989,dogboy,02091983,369852,softail,mypassword,prowler,bigboss,1112,harvest,heng,jubilee,killjoy,basset,keng,zaqxswcde,redsox1,biao,titan,misfit99,robot,wifey,kidrock,02101987,gameboy,enrico,1z2x3c4v,broncos1,arrows,havana,banger,cookie1,chriss,123qw,platypus,cindy1,lumber,pinball,foxy,london1,1023,05051987,02041985,password12,superma,longbow,radiohead,nigga,12051988,spongebo,qwert12345,abrakadabra,dodgers1,02101989,chillin,niceguy,pistons,hookup,santafe,bigben,jets,1013,vikings1,mankind,viktoriya,beardog,hammer1,02071980,reddwarf,magelan,longjohn,jennife,gilles,carmex2,02071987,stasik,bumper,doofus,slamdunk,pixies,garion,steffi,alessandro,beerman,niceass,warrior1,honolulu,134679852,visa,johndeer,mother1,windmill,boozer,oatmeal,aptiva,busty,delight,tasty,slick1,bergkamp,badgers,guitars,puffin,02091981,nikki1,irishman,miller1,zildjian,123000,airwolf,magnet,anai,install,02041981,02061983,astra,romans,megan1,mudvayne,freebird,muscles,dogbert,02091980,02091984,snowflak,01011900,mang,joseph1,nygiants,playstat,junior1,vjcrdf,qwer12,webhompas,giraffe,pelican,jefferso,comanche,bruiser,monkeybo,kjkszpj,123456l,micro,albany,02051987,angel123,epsilon,aladin,death666,hounddog,josephin,altima,chilly,02071988,78945,ultra,02041979,gasman,thisisit,pavel,idunno,kimmie,05051985,paulie,ballin,medion,moondog,manolo,pallmall,climber,fishbone,genesis1,153624,toffee,tbone,clippers,krypton,jerry1,picturs,compass,111111q,02051988,1121,02081977,sairam,getout,333777,cobras,22041987,bigblock,severin,booster,norwich,whiteout,ctrhtn,123456m,02061984,hewlett,shocker,fuckinside,02031981,chase1,white1,versace,123456789s,basebal,iloveyou2,bluebell,08031986,anthon,stubby,foreve,undertak,werder,saiyan,mama123,medic,chipmunk,mike123,mazdarx7,qwe123qwe,bowwow,kjrjvjnbd,celeb,choochoo,demo,lovelife,02051984,colnago,lithium,02051989,15051981,zzzxxx,welcom,anastasi,fidelio,franc,26061987,roadster,stone55,drifter,hookem,hellboy,1234qw,cbr900rr,sinned,good123654,storm1,gypsy,zebra,zachary1,toejam,buceta,02021979,testing1,redfox,lineage,mike1,highbury,koroleva,nathan1,washingt,02061982,02091985,vintage,redbaron,dalshe,mykids,11051987,macbeth,julien,james123,krasotka,111000,10011986,987123,pipeline,tatarin,sensei,codered,komodo,frogman,7894561230,nascar24,juicy,01031988,redrose,mydick,pigeon,tkbpfdtnf,smirnoff,1215,spam,winner1,flyfish,moskva,81fukkc,21031987,olesya,starligh,summer99,13041988,fishhead,freesex,super12,06061986,azazel,scoobydoo,02021981,cabron,yogibear,sheba1,konstantin,tranny,chilli,terminat,ghbywtccf,slowhand,soccer12,cricket1,fuckhead,1002,seagull,achtung,blam,bigbob,bdsm,nostromo,survivor,cnfybckfd,lemonade,boomer1,rainbow1,rober,irinka,cocksuck,peaches1,itsme,sugar1,zodiac,upyours,dinara,135791,sunny1,chiara,johnson1,02041989,solitude,habibi,sushi,markiz,smoke1,rockies,catwoman,johnny1,qwerty7,bearcats,username,01011978,wanderer,ohshit,02101986,sigma,stephen1,paradigm,02011989,flanker,sanity,jsbach,spotty,bologna,fantasia,chevys,borabora,cocker,74108520,123ewq,12021988,01061990,gtnhjdbx,02071981,01011960,sundevil,3000gt,mustang6,gagging,maggi,armstron,yfnfkb,13041987,revolver,02021976,trouble1,madcat,jeremy1,jackass1,volkswag,30051985,corndog,pool6123,marines1,03041991,pizza1,piggy,sissy,02031979,sunfire,angelus,undead,24061986,14061991,wildbill,shinobi,45m2do5bs,123qwer,21011989,cleopatr,lasvega,hornets,amorcit,11081989,coventry,nirvana1,destin,sidekick,20061988,02081983,gbhfvblf,sneaky,bmw325,22021989,nfytxrf,sekret,kalina,zanzibar,hotone,qazws,wasabi,heidi1,highlander,blues1,hitachi,paolo,23041987,slayer1,simba1,02011981,tinkerbe,kieran,01121986,172839,boiler,1125,bluesman,waffle,asdfgh01,threesom,conan,1102,reflex,18011987,nautilus,everlast,fatty,vader1,01071986,cyborg,ghbdtn123,birddog,rubble,02071983,suckers,02021973,skyhawk,12qw12qw,dakota1,joebob,nokia6233,woodie,longdong,lamer,troll,ghjcnjgfhjkm,420000,boating,nitro,armada,messiah,1031,penguin1,02091989,americ,02071989,redeye,asdqwe123,07071987,monty1,goten,spikey,sonata,635241,tokiohotel,sonyericsson,citroen,compaq1,1812,umpire,belmont,jonny,pantera1,nudes,palmtree,14111986,fenway,bighead,razor,gryphon,andyod22,aaaaa1,taco,10031988,enterme,malachi,dogface,reptile,01041985,dindom,handball,marseille,candy1,19101987,torino,tigge,matthias,viewsoni,13031987,stinker,evangelion,24011985,123456123,rampage,sandrine,02081980,thecrow,astral,28041987,sprinter,private1,seabee,shibby,02101988,25081988,fearless,junkie,01091987,aramis,antelope,draven,fuck1,mazda6,eggman,02021990,barselona,buddy123,19061987,fyfnjkbq,nancy1,12121990,10071987,sluggo,kille,hotties,irishka,zxcasdqwe123,shamus,fairlane,honeybee,soccer10,13061986,fantomas,17051988,10051987,20111986,gladiato,karachi,gambler,gordo,01011995,biatch,matthe,25800852,papito,excite,buffalo1,bobdole,cheshire,player1,28021992,thewho,10101986,pinky1,mentor,tomahawk,brown1,03041986,bismillah,bigpoppa,ijrjkfl,01121988,runaway,08121986,skibum,studman,helper,squeak,holycow,manfred,harlem,glock,gideon,987321,14021985,yellow1,wizard1,margarit,success1,medved,sf49ers,lambda,pasadena,johngalt,quasar,1776,02031980,coldplay,amand,playa,bigpimp,04041991,capricorn,elefant,sweetness,bruce1,luca,dominik,10011990,biker,09051945,datsun,elcamino,trinitro,malice,audi,voyager1,02101983,joe123,carpente,spartan1,mario1,glamour,diaper,12121985,22011988,winter1,asimov,callisto,nikolai,pebble,02101981,vendetta,david123,boytoy,11061985,02031989,iloveyou1,stupid1,cayman,casper1,zippo,yamahar1,wildwood,foxylady,calibra,02041980,27061988,dungeon,leedsutd,30041986,11051990,bestbuy,antares,dominion,24680,01061986,skillet,enforcer,derparol,01041988,196969,29071983,f00tball,purple1,mingus,25031987,21031990,remingto,giggles,klaste,3x7pxr,01011994,coolcat,29051989,megane,20031987,02051980,04041988,synergy,0000007,macman,iforget,adgjmp,vjqgfhjkm,28011987,rfvfcenhf,16051989,25121987,16051987,rogue,mamamia,08051990,20091991,1210,carnival,bolitas,paris1,dmitriy,dimas,05051989,papillon,knuckles,29011985,hola,tophat,28021990,100500,cutiepie,devo,415263,ducks,ghjuhfvvf,asdqwe,22021986,freefall,parol,02011983,zarina,buste,vitamin,warez,bigones,17061988,baritone,jamess,twiggy,mischief,bitchy,hetfield,1003,dontknow,grinch,sasha_007,18061990,12031985,12031987,calimero,224466,letmei,15011987,acmilan,alexandre,02031977,08081988,whiteboy,21051991,barney1,02071978,money123,18091985,bigdawg,02031988,cygnusx1,zoloto,31011987,firefigh,blowfish,screamer,lfybbk,20051988,chelse,11121986,01031989,harddick,sexylady,30031988,02041974,auditt,pizdec,kojak,kfgjxrf,20091988,123456ru,wp2003wp,1204,15051990,slugger,kordell1,03031986,swinging,01011974,02071979,rockie,dimples,1234123,1dragon,trucking,rusty2,roger1,marijuana,kerouac,02051978,08031985,paco,thecure,keepout,kernel,noname123,13121985,francisc,bozo,02011982,22071986,02101979,obsidian,12345qw,spud,tabasco,02051985,jaguars,dfktynby,kokomo,popova,notused,sevens,4200,magneto,02051976,roswell,15101986,21101986,lakeside,bigbang,aspen,little1,14021986,loki,suckmydick,strawber,carlos1,nokian73,dirty1,joshu,25091987,16121987,02041975,advent,17011987,slimshady,whistler,10101990,stryker,22031984,15021985,01031985,blueball,26031988,ksusha,bahamut,robocop,w_pass,chris123,impreza,prozac,bookie,bricks,13021990,alice1,cassandr,11111q,john123,4ever,korova,02051973,142857,25041988,paramedi,eclipse1,salope,07091990,1124,darkangel,23021986,999666,nomad,02051981,smackdow,01021990,yoyoma,argentin,moonligh,57chevy,bootys,hardone,capricor,galant,spanker,dkflbr,24111989,magpies,krolik,21051988,cevthrb,cheddar,22041988,bigbooty,scuba1,qwedsa,duffman,bukkake,acura,johncena,sexxy,p@ssw0rd,258369,cherries,12345s,asgard,leopold,fuck123,mopar,lalakers,dogpound,matrix1,crusty,spanner,kestrel,fenris,universa,peachy,assasin,lemmein,eggplant,hejsan,canucks,wendy1,doggy1,aikman,tupac,turnip,godlike,fussball,golden1,19283746,april1,django,petrova,captain1,vincent1,ratman,taekwondo,chocha,serpent,perfect1,capetown,vampir,amore,gymnast,timeout,nbvjatq,blue32,ksenia,k.lvbkf,nazgul,budweiser,clutch,mariya,sylveste,02051972,beaker,cartman1,q11111,sexxx,forever1,loser1,marseill,magellan,vehpbr,sexgod,jktxrf,hallo123,132456,liverpool1,southpaw,seneca,camden,357159,camero,tenchi,johndoe,145236,roofer,741963,vlad,02041978,fktyrf,zxcv123,wingnut,wolfpac,notebook,pufunga7782,brandy1,biteme1,goodgirl,redhat,02031978,challeng,millenium,hoops,maveric,noname,angus1,gaell,onion,olympus,sabrina1,ricard,sixpack,gratis,gagged,camaross,hotgirls,flasher,02051977,bubba123,goldfing,moonshin,gerrard,volkov,sonyfuck,mandrake,258963,tracer,lakers1,asians,susan1,money12,helmut,boater,diablo2,1234zxcv,dogwood,bubbles1,happy2,randy1,aries,beach1,marcius2,navigator,goodie,hellokitty,fkbyjxrf,earthlink,lookout,jumbo,opendoor,stanley1,marie1,12345m,07071977,ashle,wormix,murzik,02081976,lakewood,bluejays,loveya,commande,gateway2,peppe,01011976,7896321,goth,oreo,slammer,rasmus,faith1,knight1,stone1,redskin,ironmaiden,gotmilk,destiny1,dejavu,1master,midnite,timosha,espresso,delfin,toriamos,oberon,ceasar,markie,1a2s3d,ghhh47hj7649,vjkjrj,daddyo,dougie,disco,auggie,lekker,therock1,ou8123,start1,noway,p4ssw0rd,shadow12,333444,saigon,2fast4u,capecod,23skidoo,qazxcv,beater,bremen,aaasss,roadrunner,peace1,12345qwer,02071975,platon,bordeaux,vbkfirf,135798642,test12,supernov,beatles1,qwert40,optimist,vanessa1,prince1,ilovegod,nightwish,natasha1,alchemy,bimbo,blue99,patches1,gsxr1000,richar,hattrick,hott,solaris,proton,nevets,enternow,beavis1,amigos,159357a,ambers,lenochka,147896,suckdick,shag,intercourse,blue1234,spiral,02061977,tosser,ilove,02031975,cowgirl,canuck,q2w3e4,munch,spoons,waterboy,123567,evgeniy,savior,zasada,redcar,mamacita,terefon,globus,doggies,htubcnhfwbz,1008,cuervo,suslik,azertyui,limewire,houston1,stratfor,steaua,coors,tennis1,12345qwerty,stigmata,derf,klondike,patrici,marijuan,hardball,odyssey,nineinch,boston1,pass1,beezer,sandr,charon,power123,a1234,vauxhall,875421,awesome1,reggae,boulder,funstuff,iriska,krokodil,rfntymrf,sterva,champ1,bball,peeper,m123456,toolbox,cabernet,sheepdog,magic32,pigpen,02041977,holein1,lhfrjy,banan,dabomb,natalie1,jennaj,montana1,joecool,funky,steven1,ringo,junio,sammy123,qqqwww,baltimor,footjob,geezer,357951,mash4077,cashmone,pancake,monic,grandam,bongo,yessir,gocubs,nastia,vancouve,barley,dragon69,watford,ilikepie,02071976,laddie,123456789m,hairball,toonarmy,pimpdadd,cvthnm,hunte,davinci,lback,sophie1,firenze,q1234567,admin1,bonanza,elway7,daman,strap,azert,wxcvbn,afrika,theforce,123456t,idefix,wolfen,houdini,scheisse,default,beech,maserati,02061976,sigmachi,dylan1,bigdicks,eskimo,mizzou,02101976,riccardo,egghead,111777,kronos,ghbrjk,chaos1,jomama,rfhnjirf,rodeo,dolemite,cafc91,nittany,pathfind,mikael,password9,vqsablpzla,purpl,gabber,modelsne,myxworld,hellsing,punker,rocknrol,fishon,fuck69,02041976,lolol,twinkie,tripleh,cirrus,redbone,killer123,biggun,allegro,gthcbr,smith1,wanking,bootsy,barry1,mohawk,koolaid,5329,futurama,samoht,klizma,996633,lobo,honeys,peanut1,556677,zxasqw,joemama,javelin,samm,223322,sandra1,flicks,montag,nataly,3006,tasha1,1235789,dogbone,poker1,p0o9i8u7,goodday,smoothie,toocool,max333,metroid,archange,vagabond,billabon,22061941,tyson1,02031973,darkange,skateboard,evolutio,morrowind,wizards,frodo1,rockin,cumslut,plastics,zaqwsxcde,5201314,doit,outback,bumble,dominiqu,persona,nevermore,alinka,02021971,forgetit,sexo,all4one,c2h5oh,petunia,sheeba,kenny1,elisabet,aolsucks,woodstoc,pumper,02011975,fabio,granada,scrapper,123459,minimoni,q123456789,breaker,1004,02091976,ncc74656,slimshad,friendster,austin31,wiseguy,donner,dilbert1,132465,blackbird,buffet,jellybean,barfly,behappy,01011971,carebear,fireblad,02051975,boxcar,cheeky,kiteboy,hello12,panda1,elvisp,opennow,doktor,alex12,02101977,pornking,flamengo,02091975,snowbird,lonesome,robin1,11111a,weed420,baracuda,bleach,12345abc,nokia1,metall,singapor,mariner,herewego,dingo,tycoon,cubs,blunts,proview,123456789d,kamasutra,lagnaf,vipergts,navyseal,starwar,masterbate,wildone,peterbil,cucumber,butkus,123qwert,climax,deniro,gotribe,cement,scooby1,summer69,harrier,shodan,newyear,02091977,starwars1,romeo1,sedona,harald,doubled,sasha123,bigguns,salami,awnyce,kiwi,homemade,pimping,azzer,bradley1,warhamme,linkin,dudeman,qwe321,pinnacle,maxdog,flipflop,lfitymrf,fucker1,acidburn,esquire,sperma,fellatio,jeepster,thedon,sexybitch,pookey,spliff,widget,vfntvfnbrf,trinity1,mutant,samuel1,meliss,gohome,1q2q3q,mercede,comein,grin,cartoons,paragon,henrik,rainyday,pacino,senna,bigdog1,alleycat,12345qaz,narnia,mustang2,tanya1,gianni,apollo11,wetter,clovis,escalade,rainbows,freddy1,smart1,daisydog,s123456,cocksucker,pushkin,lefty,sambo,fyutkjxtr,hiziad,boyz,whiplash,orchard,newark,adrenalin,1598753,bootsie,chelle,trustme,chewy,golfgti,tuscl,ambrosia,5wr2i7h8,penetration,shonuf,jughead,payday,stickman,gotham,kolokol,johnny5,kolbasa,stang,puppydog,charisma,gators1,mone,jakarta,draco,nightmar,01011973,inlove,laetitia,02091973,tarpon,nautica,meadow,0192837465,luckyone,14881488,chessie,goldeney,tarakan,69camaro,bungle,wordup,interne,fuckme2,515000,dragonfl,sprout,02081974,gerbil,bandit1,02071971,melanie1,phialpha,camber,kathy1,adriano,gonzo1,10293847,bigjohn,bismarck,7777777a,scamper,12348765,rabbits,222777,bynthytn,dima123,alexander1,mallorca,dragster,favorite6,beethove,burner,cooper1,fosters,hello2,normandy,777999,sebring,1michael,lauren1,blake1,killa,02091971,nounours,trumpet1,thumper1,playball,xantia,rugby1,rocknroll,guillaum,angela1,strelok,prosper,buttercup,masterp,dbnfkbr,cambridg,venom,treefrog,lumina,1234566,supra,sexybabe,freee,shen,frogs,driller,pavement,grace1,dicky,checker,smackdown,pandas,cannibal,asdffdsa,blue42,zyjxrf,nthvbyfnjh,melrose,neon,jabber,gamma,369258147,aprilia,atticus,benessere,catcher,skipper1,azertyuiop,sixty9,thierry,treetop,jello,melons,123456789qwe,tantra,buzzer,catnip,bouncer,computer1,sexyone,ananas,young1,olenka,sexman,mooses,kittys,sephiroth,contra,hallowee,skylark,sparkles,777333,1qazxsw23edc,lucas1,q1w2e3r,gofast,hannes,amethyst,ploppy,flower2,hotass,amatory,volleyba,dixie1,bettyboo,ticklish,02061974,frenchy,phish1,murphy1,trustno,02061972,leinad,mynameis,spooge,jupiter1,hyundai,frosch,junkmail,abacab,marbles,32167,casio,sunshine1,wayne1,longhair,caster,snicker,02101973,gannibal,skinhead,hansol,gatsby,segblue2,montecar,plato,gumby,kaboom,matty,bosco1,888999,jazzy,panter,jesus123,charlie2,giulia,candyass,sex69,travis1,farmboy,special1,02041973,letsdoit,password01,allison1,abcdefg1,notredam,ilikeit,789654123,liberty1,rugger,uptown,alcatraz,123456w,airman,007bond,navajo,kenobi,terrier,stayout,grisha,frankie1,fluff,1qazzaq1,1234561,virginie,1234568,tango1,werdna,octopus,fitter,dfcbkbcf,blacklab,115599,montrose,allen1,supernova,frederik,ilovepussy,justice1,radeon,playboy2,blubber,sliver,swoosh,motocros,lockdown,pearls,thebear,istheman,pinetree,biit,1234rewq,rustydog,tampabay,titts,babycake,jehovah,vampire1,streaming,collie,camil,fidelity,calvin1,stitch,gatit,restart,puppy1,budgie,grunt,capitals,hiking,dreamcas,zorro1,321678,riffraff,makaka,playmate,napalm,rollin,amstel,zxcvb123,samanth,rumble,fuckme69,jimmys,951357,pizzaman,1234567899,tralala,delpiero,alexi,yamato,itisme,1million,vfndtq,kahlua,londo,wonderboy,carrots,tazz,ratboy,rfgecnf,02081973,nico,fujitsu,tujhrf,sergbest,blobby,02051970,sonic1,1357911,smirnov,video1,panhead,bucky,02031974,44332211,duffer,cashmoney,left4dead,bagpuss,salman,01011972,titfuck,66613666,england1,malish,dresden,lemans,darina,zapper,123456as,123456qqq,met2002,02041972,redstar,blue23,1234509876,pajero,booyah,please1,tetsuo,semper,finder,hanuman,sunlight,123456n,02061971,treble,cupoi,password99,dimitri,3ip76k2,popcorn1,lol12345,stellar,nympho,shark1,keith1,saskia,bigtruck,revoluti,rambo1,asd222,feelgood,phat,gogators,bismark,cola,puck,furball,burnout,slonik,bowtie,mommy1,icecube,fabienn,mouser,papamama,rolex,giants1,blue11,trooper1,momdad,iklo,morten,rhubarb,gareth,123456d,blitz,canada1,r2d2,brest,tigercat,usmarine,lilbit,benny1,azrael,lebowski,12345r,madagaskar,begemot,loverman,dragonballz,italiano,mazda3,naughty1,onions,diver1,cyrano,capcom,asdfg123,forlife,fisherman,weare138,requiem,mufasa,alpha123,piercing,hellas,abracadabra,duckman,caracas,macintos,02011971,jordan2,crescent,fduecn,hogtied,eatmenow,ramjet,18121812,kicksass,whatthe,discus,rfhfvtkmrf,rufus1,sqdwfe,mantle,vegitto,trek,dan123,paladin1,rudeboy,liliya,lunchbox,riversid,acapulco,libero,dnsadm,maison,toomuch,boobear,hemlock,sextoy,pugsley,misiek,athome,migue,altoids,marcin,123450,rhfcfdbwf,jeter2,rhinos,rjhjkm,mercury1,ronaldinho,shampoo,makayla,kamilla,masterbating,tennesse,holger,john1,matchbox,hores,poptart,parlament,goodyear,asdfgh1,02081970,hardwood,alain,erection,hfytnrb,highlife,implants,benjami,dipper,jeeper,bendover,supersonic,babybear,laserjet,gotenks,bama,natedogg,aol123,pokemo,rabbit1,raduga,sopranos,cashflow,menthol,pharao,hacking,334455,ghjcnbnenrf,lizzy,muffin1,pooky,penis1,flyer,gramma,dipset,becca,ireland1,diana1,donjuan,pong,ziggy1,alterego,simple1,cbr900,logger,111555,claudia1,cantona7,matisse,ljxtymrf,victori,harle,mamas,encore,mangos,iceman1,diamon,alexxx,tiamat,5000,desktop,mafia,smurf,princesa,shojou,blueberr,welkom,maximka,123890,123q123,tammy1,bobmarley,clips,demon666,ismail,termite,laser1,missie,altair,donna1,bauhaus,trinitron,mogwai,flyers88,juniper,nokia5800,boroda,jingles,qwerasdfzxcv,shakur,777666,legos,mallrats,1qazxsw,goldeneye,tamerlan,julia1,backbone,spleen,49ers,shady,darkone,medic1,justi,giggle,cloudy,aisan,douche,parkour,bluejay,huskers1,redwine,1qw23er4,satchmo,1231234,nineball,stewart1,ballsack,probes,kappa,amiga,flipper1,dortmund,963258,trigun,1237895,homepage,blinky,screwy,gizzmo,belkin,chemist,coolhand,chachi,braves1,thebest,greedisgood,pro100,banana1,101091m,123456g,wonderfu,barefeet,8inches,1111qqqq,kcchiefs,qweasdzxc123,metal1,jennifer1,xian,asdasd123,pollux,cheerleaers,fruity,mustang5,turbos,shopper,photon,espana,hillbill,oyster,macaroni,gigabyte,jesper,motown,tuxedo,buster12,triplex,cyclones,estrell,mortis,holla,456987,fiddle,sapphic,jurassic,thebeast,ghjcnjq,baura,spock1,metallica1,karaoke,nemrac58,love1234,02031970,flvbybcnhfnjh,frisbee,diva,ajax,feathers,flower1,soccer11,allday,mierda,pearl1,amature,marauder,333555,redheads,womans,egorka,godbless,159263,nimitz,aaaa1111,sashka,madcow,socce,greywolf,baboon,pimpdaddy,123456789r,reloaded,lancia,rfhfylfi,dicker,placid,grimace,22446688,olemiss,whores,culinary,wannabe,maxi,1234567aa,amelie,riley1,trample,phantom1,baberuth,bramble,asdfqwer,vides,4you,abc123456,taichi,aztnm,smother,outsider,hakr,blackhawk,bigblack,girlie,spook,valeriya,gianluca,freedo,1q2q3q4q,handbag,lavalamp,cumm,pertinant,whatup,nokia123,redlight,patrik,111aaa,poppy1,dfytxrf,aviator,sweeps,kristin1,cypher,elway,yinyang,access1,poophead,tucson,noles1,monterey,waterfal,dank,dougal,918273,suede,minnesot,legman,bukowski,ganja,mammoth,riverrat,asswipe,daredevi,lian,arizona1,kamikadze,alex1234,smile1,angel2,55bgates,bellagio,0001,wanrltw,stiletto,lipton,arsena,biohazard,bbking,chappy,tetris,as123456,darthvad,lilwayne,nopassword,7412369,123456789987654321,natchez,glitter,14785236,mytime,rubicon,moto,pyon,wazzup,tbird,shane1,nightowl,getoff,beckham7,trueblue,hotgirl,nevermin,deathnote,13131,taffy,bigal,copenhag,apricot,gallaries,dtkjcbgtl,totoro,onlyone,civicsi,jesse1,baby123,sierra1,festus,abacus,sickboy,fishtank,fungus,charle,golfpro,teensex,mario66,seaside,aleksei,rosewood,blackberry,1020304050,bedlam,schumi,deerhunt,contour,darkelf,surveyor,deltas,pitchers,741258963,dipstick,funny1,lizzard,112233445566,jupiter2,softtail,titman,greenman,z1x2c3v4b5,smartass,12345677,notnow,myworld,nascar1,chewbacc,nosferatu,downhill,dallas22,kuan,blazers,whales,soldat,craving,powerman,yfcntyf,hotrats,cfvceyu,qweasdzx,princess1,feline,qqwwee,chitown,1234qaz,mastermind,114477,dingbat,care1839,standby,kismet,atreides,dogmeat,icarus,monkeyboy,alex1,mouses,nicetits,sealteam,chopper1,crispy,winter99,rrpass1,myporn,myspace1,corazo,topolino,ass123,lawman,muffy,orgy,1love,passord,hooyah,ekmzyf,pretzel,amonra,nestle,01011950,jimbeam,happyman,z12345,stonewal,helios,manunited,harcore,dick1,gaymen,2hot4u,light1,qwerty13,kakashi,pjkjnj,alcatel,taylo,allah,buddydog,ltkmaby,mongo,blonds,start123,audia6,123456v,civilwar,bellaco,turtles,mustan,deadspin,aaa123,fynjirf,lucky123,tortoise,amor,summe,waterski,zulu,drag0n,dtxyjcnm,gizmos,strife,interacial,pusyy,goose1,bear1,equinox,matri,jaguar1,tobydog,sammys,nachos,traktor,bryan1,morgoth,444555,dasani,miami1,mashka,xxxxxx1,ownage,nightwin,hotlips,passmast,cool123,skolko,eldiablo,manu,1357908642,screwyou,badabing,foreplay,hydro,kubrick,seductive,demon1,comeon,galileo,aladdin,metoo,happines,902100,mizuno,caddy,bizzare,girls1,redone,ohmygod,sable,bonovox,girlies,hamper,opus,gizmodo1,aaabbb,pizzahut,999888,rocky2,anton1,kikimora,peavey,ocelot,a1a2a3a4,2wsx3edc,jackie1,solace,sprocket,galary,chuck1,volvo1,shurik,poop123,locutus,virago,wdtnjxtr,tequier,bisexual,doodles,makeitso,fishy,789632145,nothing1,fishcake,sentry,libertad,oaktree,fivestar,adidas1,vegitta,mississi,spiffy,carme,neutron,vantage,agassi,boners,123456789v,hilltop,taipan,barrage,kenneth1,fister,martian,willem,lfybkf,bluestar,moonman,ntktdbpjh,paperino,bikers,daffy,benji,quake,dragonfly,suckcock,danilka,lapochka,belinea,calypso,asshol,camero1,abraxas,mike1234,womam,q1q2q3q4q5,youknow,maxpower,pic\'s,audi80,sonora,raymond1,tickler,tadpole,belair,crazyman,finalfantasy,999000,jonatha,paisley,kissmyas,morgana,monste,mantra,spunk,magic123,jonesy,mark1,alessand,741258,baddest,ghbdtnrfrltkf,zxccxz,tictac,augustin,racers,7grout,foxfire,99762000,openit,nathanie,1z2x3c4v5b,seadog,gangbanged,lovehate,hondacbr,harpoon,mamochka,fisherma,bismilla,locust,wally1,spiderman1,saffron,utjhubq,123456987,20spanks,safeway,pisser,bdfyjd,kristen1,bigdick1,magenta,vfhujif,anfisa,friday13,qaz123wsx,0987654321q,tyrant,guan,meggie,kontol,nurlan,ayanami,rocket1,yaroslav,websol76,mutley,hugoboss,websolutions,elpaso,gagarin,badboys,sephirot,918273645,newuser,qian,edcrfv,booger1,852258,lockout,timoxa94,mazda323,firedog,sokolova,skydiver,jesus777,1234567890z,soulfly,canary,malinka,guillerm,hookers,dogfart,surfer1,osprey,india123,rhjkbr,stoppedby,nokia5530,123456789o,blue1,werter,divers,3000,123456f,alpina,cali,whoknows,godspeed,986532,foreskin,fuzzy1,heyyou,didier,slapnuts,fresno,rosebud1,sandman1,bears1,blade1,honeybun,queen1,baronn,pakista,philipp,9111961,topsecret,sniper1,214365,slipper,letsfuck,pippen33,godawgs,mousey,qw123456,scrotum,loveis,lighthou,bp2002,nancy123,jeffrey1,susieq,buddy2,ralphie,trout1,willi,antonov,sluttey,rehbwf,marty1,darian,losangeles,letme1n,12345d,pusssy,godiva,ender,golfnut,leonidas,a1b2c3d4e5,puffer,general1,wizzard,lehjxrf,racer1,bigbucks,cool12,buddys,zinger,esprit,vbienrf,josep,tickling,froggie,987654321a,895623,daddys,crumbs,gucci,mikkel,opiate,tracy1,christophe,came11,777555,petrovich,humbug,dirtydog,allstate,horatio,wachtwoord,creepers,squirts,rotary,bigd,georgia1,fujifilm,2sweet,dasha,yorkie,slimjim,wiccan,kenzie,system1,skunk,b12345,getit,pommes,daredevil,sugars,bucker,piston,lionheart,1bitch,515051,catfight,recon,icecold,fantom,vodafone,kontakt,boris1,vfcnth,canine,01011961,valleywa,faraon,chickenwing101,qq123456,livewire,livelife,roosters,jeepers,ilya1234,coochie,pavlik,dewalt,dfhdfhf,architec,blackops,1qaz2wsx3edc4rfv,rhfcjnf,wsxedc,teaser,sebora,25252,rhino1,ankara,swifty,decimal,redleg,shanno,nermal,candies,smirnova,dragon01,photo1,ranetki,a1s2d3f4g5,axio,wertzu,maurizio,6uldv8,zxcvasdf,punkass,flowe,graywolf,peddler,3rjs1la7qe,mpegs,seawolf,ladyboy,pianos,piggies,vixen,alexus,orpheus,gdtrfb,z123456,macgyver,hugetits,ralph1,flathead,maurici,mailru,goofball,nissan1,nikon,stopit,odin,big1,smooch,reboot,famil,bullit,anthony7,gerhard,methos,124038,morena,eagle2,jessica2,zebras,getlost,gfynthf,123581321,sarajevo,indon,comets,tatjana,rfgbnjirf,joystick,batman12,123456c,sabre,beerme,victory1,kitties,1475369,badboy1,booboo1,comcast,slava,squid,saxophon,lionhear,qaywsx,bustle,nastena,roadway,loader,hillside,starlight,24681012,niggers,access99,bazooka,molly123,blackice,bandi,cocacol,nfhfrfy,timur,muschi,horse1,quant4307s,squerting,oscars,mygirls,flashman,tangerin,goofy1,p0o9i8,housewifes,newness,monkey69,escorpio,password11,hippo,warcraft3,qazxsw123,qpalzm,ribbit,ghbdtndctv,bogota,star123,258000,lincoln1,bigjim,lacoste,firestorm,legenda,indain,ludacris,milamber,1009,evangeli,letmesee,a111111,hooters1,bigred1,shaker,husky,a4tech,cnfkrth,argyle,rjhjdf,nataha,0o9i8u7y,gibson1,sooners1,glendale,archery,hoochie,stooge,aaaaaa1,scorpions,school1,vegas1,rapier,mike23,bassoon,groupd2013,macaco,baker1,labia,freewill,santiag,silverado,butch1,vflfufcrfh,monica1,rugrat,cornhole,aerosmit,bionicle,gfgfvfvf,daniel12,virgo,fmale,favorite2,detroit1,pokey,shredder,baggies,wednesda,cosmo1,mimosa,sparhawk,firehawk,romario,911turbo,funtimes,fhntvrf,nexus6,159753456,timothy1,bajingan,terry1,frenchie,raiden,1mustang,babemagnet,74123698,nadejda,truffles,rapture,douglas1,lamborghini,motocross,rjcvjc,748596,skeeter1,dante1,angel666,telecom,carsten,pietro,bmw318,astro1,carpediem,samir,orang,helium,scirocco,fuzzball,rushmore,rebelz,hotspur,lacrimosa,chevys10,madonna1,domenico,yfnfirf,jachin,shelby1,bloke,dawgs,dunhill,atlanta1,service1,mikado,devilman,angelit,reznor,euphoria,lesbain,checkmat,browndog,phreak,blaze1,crash1,farida,mutter,luckyme,horsemen,vgirl,jediknig,asdas,cesare,allnight,rockey,starlite,truck1,passfan,close-up,samue,cazzo,wrinkles,homely,eatme1,sexpot,snapshot,dima1995,asthma,thetruth,ducky,blender,priyanka,gaucho,dutchman,sizzle,kakarot,651550,passcode,justinbieber,666333,elodie,sanjay,110442,alex01,lotus1,2300mj,lakshmi,zoomer,quake3,12349876,teapot,12345687,ramada,pennywis,striper,pilot1,chingon,optima,nudity,ethan1,euclid,beeline,loyola,biguns,zaq12345,bravo1,disney1,buffa,assmunch,vivid,6661313,wellingt,aqwzsx,madala11,9874123,sigmar,pictere,tiptop,bettyboop,dinero,tahiti,gregory1,bionic,speed1,fubar1,lexus1,denis1,hawthorn,saxman,suntzu,bernhard,dominika,camaro1,hunter12,balboa,bmw2002,seville,diablo1,vfhbyjxrf,1234abc,carling,lockerroom,punani,darth,baron1,vaness,1password,libido,picher,232425,karamba,futyn007,daydream,11001001,dragon123,friends1,bopper,rocky123,chooch,asslover,shimmer,riddler,openme,tugboat,sexy123,midori,gulnara,christo,swatch,laker,offroad,puddles,hackers,mannheim,manager1,horseman,roman1,dancer1,komputer,pictuers,nokia5130,ejaculation,lioness,123456y,evilone,nastenka,pushok,javie,lilman,3141592,mjolnir,toulouse,pussy2,bigworm,smoke420,fullback,extensa,dreamcast,belize,delboy,willie1,casablanca,csyjxtr,ricky1,bonghit,salvator,basher,pussylover,rosie1,963258741,vivitron,cobra427,meonly,armageddon,myfriend,zardoz,qwedsazxc,kraken,fzappa,starfox,333999,illmatic,capoeira,weenie,ramzes,freedom2,toasty,pupkin,shinigami,fhvfutljy,nocturne,churchil,thumbnils,tailgate,neworder,sexymama,goarmy,cerebus,michelle1,vbifyz,surfsup,earthlin,dabulls,basketbal,aligator,mojojojo,saibaba,welcome2,wifes,wdtnjr,12345w,slasher,papabear,terran,footman,hocke,153759,texans,tom123,sfgiants,billabong,aassdd,monolith,xxx777,l3tm31n,ticktock,newone,hellno,japanees,contortionist,admin123,scout1,alabama1,divx1,rochard,privat,radar1,bigdad,fhctybq,tortuga,citrus,avanti,fantasy1,woodstock,s12345,fireman1,embalmer,woodwork,bonzai,konyor,newstart,jigga,panorama,goats,smithy,rugrats,hotmama,daedalus,nonstop,fruitbat,lisenok,quaker,violator,12345123,my3sons,cajun,fraggle,gayboy,oldfart,vulva,knickerless,orgasms,undertow,binky,litle,kfcnjxrf,masturbation,bunnie,alexis1,planner,transexual,sparty,leeloo,monies,fozzie,stinger1,landrove,anakonda,scoobie,yamaha1,henti,star12,rfhlbyfk,beyonce,catfood,cjytxrf,zealots,strat,fordtruc,archangel,silvi,sativa,boogers,miles1,bigjoe,tulip,petite,greentea,shitter,jonboy,voltron,morticia,evanescence,3edc4rfv,longshot,windows1,serge,aabbcc,starbucks,sinful,drywall,prelude1,www123,camel1,homebrew,marlins,123412,letmeinn,domini,swampy,plokij,fordf350,webcam,michele1,bolivi,27731828,wingzero,qawsedrftg,shinji,sverige,jasper1,piper1,cummer,iiyama,gocats,amour,alfarome,jumanji,mike69,fantasti,1monkey,w00t88,shawn1,lorien,1a2s3d4f5g,koleso,murph,natascha,sunkist,kennwort,emine,grinder,m12345,q1q2q3q4,cheeba,money2,qazwsxedc1,diamante,prosto,pdiddy,stinky1,gabby1,luckys,franci,pornographic,moochie,gfhjdjp,samdog,empire1,comicbookdb,emili,motdepasse,iphone,braveheart,reeses,nebula,sanjose,bubba2,kickflip,arcangel,superbow,porsche911,xyzzy,nigger1,dagobert,devil1,alatam,monkey2,barbara1,12345v,vfpfafrf,alessio,babemagn,aceman,arrakis,kavkaz,987789,jasons,berserk,sublime1,rogue1,myspace,buckwhea,csyekz,pussy4me,vette1,boots1,boingo,arnaud,budlite,redstorm,paramore,becky1,imtheman,chango,marley1,milkyway,666555,giveme,mahalo,lux2000,lucian,paddy,praxis,shimano,bigpenis,creeper,newproject2004,rammstei,j3qq4h7h2v,hfljcnm,lambchop,anthony2,bugman,gfhjkm12,dreamer1,stooges,cybersex,diamant,cowboyup,maximus1,sentra,615243,goethe,manhatta,fastcar,selmer,1213141516,yfnfitymrf,denni,chewey,yankee1,elektra,123456789p,trousers,fishface,topspin,orwell,vorona,sodapop,motherfu,ibilltes,forall,kookie,ronald1,balrog,maximilian,mypasswo,sonny1,zzxxcc,tkfkdg,magoo,mdogg,heeled,gitara,lesbos,marajade,tippy,morozova,enter123,lesbean,pounded,asd456,fialka,scarab,sharpie,spanky1,gstring,sachin,12345asd,princeto,hellohel,ursitesux,billows,1234kekc,kombat,cashew,duracell,kseniya,sevenof9,kostik,arthur1,corvet07,rdfhnbhf,songoku,tiberian,needforspeed,1qwert,dropkick,kevin123,panache,libra,a123456a,kjiflm,vfhnsirf,cntgfy,iamcool,narut,buffer,sk8ordie,urlaub,fireblade,blanked,marishka,gemini1,altec,gorillaz,chief1,revival47,ironman1,space1,ramstein,doorknob,devilmaycry,nemesis1,sosiska,pennstat,monday1,pioner,shevchenko,detectiv,evildead,blessed1,aggie,coffees,tical,scotts,bullwink,marsel,krypto,adrock,rjitxrf,asmodeus,rapunzel,theboys,hotdogs,deepthro,maxpayne,veronic,fyyeirf,otter,cheste,abbey1,thanos,bedrock,bartok,google1,xxxzzz,rodent,montecarlo,hernande,mikayla,123456789l,bravehea,12locked,ltymub,pegasus1,ameteur,saltydog,faisal,milfnew,momsuck,everques,ytngfhjkz,m0nkey,businessbabe,cooki,custard,123456ab,lbvjxrf,outlaws,753357,qwerty78,udacha,insider,chees,fuckmehard,shotokan,katya,seahorse,vtldtlm,turtle1,mike12,beebop,heathe,everton1,darknes,barnie,rbcekz,alisher,toohot,theduke,555222,reddog1,breezy,bulldawg,monkeyman,baylee,losangel,mastermi,apollo1,aurelie,zxcvb12345,cayenne,bastet,wsxzaq,geibcnbr,yello,fucmy69,redwall,ladybird,bitchs,cccccc1,rktjgfnhf,ghjdthrf,quest1,oedipus,linus,impalass,fartman,12345k,fokker,159753a,optiplex,bbbbbb1,realtor,slipkno,santacru,rowdy,jelena,smeller,3984240,ddddd1,sexyme,janet1,3698741,eatme69,cazzone,today1,poobear,ignatius,master123,newpass1,heather2,snoopdogg,blondinka,pass12,honeydew,fuckthat,890098890,lovem,goldrush,gecko,biker1,llama,pendejo,avalanche,fremont,snowman1,gandolf,chowder,1a2b3c4d5e,flyguy,magadan,1fuck,pingvin,nokia5230,ab1234,lothar,lasers,bignuts,renee1,royboy,skynet,12340987,1122334,dragrace,lovely1,22334455,booter,12345612,corvett,123456qq,capital1,videoes,funtik,wyvern,flange,sammydog,hulkster,13245768,not4you,vorlon,omegared,l58jkdjp!,filippo,123mudar,samadams,petrus,chris12,charlie123,123456789123,icetea,sunderla,adrian1,123qweas,kazanova,aslan,monkey123,fktyeirf,goodsex,123ab,lbtest,banaan,bluenose,837519,asd12345,waffenss,whateve,1a2a3a4a,trailers,vfhbirf,bhbcrf,klaatu,turk182,monsoon,beachbum,sunbeam,succes,clyde1,viking1,rawhide,bubblegum,princ,mackenzi,hershey1,222555,dima55,niggaz,manatee,aquila,anechka,pamel,bugsbunn,lovel,sestra,newport1,althor,hornyman,wakeup,zzz111,phishy,cerber,torrent,thething,solnishko,babel,buckeye1,peanu,ethernet,uncencored,baraka,665544,chris2,rb26dett,willy1,choppers,texaco,biggirl,123456b,anna2614,sukebe,caralho,callofduty,rt6ytere,jesus7,angel12,1money,timelord,allblack,pavlova,romanov,tequiero,yitbos,lookup,bulls23,snowflake,dickweed,barks,lever,irisha,firestar,fred1234,ghjnjnbg,danman,gatito,betty1,milhouse,kbctyjr,masterbaiting,delsol,papit,doggys,123698741,bdfyjdf,invictus,bloods,kayla1,yourmama,apple2,angelok,bigboy1,pontiac1,verygood,yeshua,twins2,porn4me,141516,rasta69,james2,bosshog,candys,adventur,stripe,djkjlz,dokken,austin316,skins,hogwarts,vbhevbh,navigato,desperado,xxx666,cneltyn,vasiliy,hazmat,daytek,eightbal,fred1,four20,74227422,fabia,aerosmith,manue,wingchun,boohoo,hombre,sanity72,goatboy,fuckm,partizan,avrora,utahjazz,submarin,pussyeat,heinlein,control1,costaric,smarty,chuan,triplets,snowy,snafu,teacher1,vangogh,vandal,evergree,cochise,qwerty99,pyramid1,saab900,sniffer,qaz741,lebron23,mark123,wolvie,blackbelt,yoshi,feeder,janeway,nutella,fuking,asscock,deepak,poppie,bigshow,housewife,grils,tonto,cynthia1,temptress,irakli,belle1,russell1,manders,frank123,seabass,gforce,songbird,zippy1,naught,brenda1,chewy1,hotshit,topaz,43046721,girfriend,marinka,jakester,thatsme,planeta,falstaff,patrizia,reborn,riptide,cherry1,shuan,nogard,chino,oasis1,qwaszx12,goodlife,davis1,1911a1,harrys,shitfuck,12345678900,russian7,007700,bulls1,porshe,danil,dolphi,river1,sabaka,gobigred,deborah1,volkswagen,miamo,alkaline,muffdive,1letmein,fkbyrf,goodguy,hallo1,nirvan,ozzie,cannonda,cvbhyjdf,marmite,germany1,joeblow,radio1,love11,raindrop,159852,jacko,newday,fathead,elvis123,caspe,citibank,sports1,deuce,boxter,fakepass,golfman,snowdog,birthday4,nonmembe,niklas,parsifal,krasota,theshit,1235813,maganda,nikita1,omicron,cassie1,columbo,buick,sigma1,thistle,bassin,rickster,apteka,sienna,skulls,miamor,coolgirl,gravis,1qazxc,virgini,hunter2,akasha,batma,motorcyc,bambino,tenerife,fordf250,zhuan,iloveporn,markiza,hotbabes,becool,fynjybyf,wapapapa,forme,mamont,pizda,dragonz,sharon1,scrooge,mrbill,pfloyd,leeroy,natedog,ishmael,777111,tecumseh,carajo,nfy.irf,0000000000o,blackcock,fedorov,antigone,feanor,novikova,bobert,peregrin,spartan117,pumkin,rayman,manuals,tooltime,555333,bonethug,marina1,bonnie1,tonyhawk,laracroft,mahalkita,18273645,terriers,gamer,hoser,littlema,molotok,glennwei,lemon1,caboose,tater,12345654321,brians,fritz1,mistral,jigsaw,fuckshit,hornyguy,southside,edthom,antonio1,bobmarle,pitures,ilikesex,crafty,nexus,boarder,fulcrum,astonvil,yanks1,yngwie,account1,zooropa,hotlegs,sammi,gumbo,rover1,perkele,maurolarastefy,lampard,357753,barracud,dmband,abcxyz,pathfinder,335577,yuliya,micky,jayman,asdfg12345,1596321,halcyon,rerfhtre,feniks,zaxscd,gotyoass,jaycee,samson1,jamesb,vibrate,grandpri,camino,colossus,davidb,mamo4ka,nicky1,homer123,pinguin,watermelon,shadow01,lasttime,glider,823762,helen1,pyramids,tulane,osama,rostov,john12,scoote,bhbyrf,gohan,galeries,joyful,bigpussy,tonka,mowgli,astalavista,zzz123,leafs,dalejr8,unicorn1,777000,primal,bigmama,okmijn,killzone,qaz12345,snookie,zxcvvcxz,davidc,epson,rockman,ceaser,beanbag,katten,3151020,duckhunt,segreto,matros,ragnar,699669,sexsexse,123123z,fuckyeah,bigbutts,gbcmrf,element1,marketin,saratov,elbereth,blaster1,yamahar6,grime,masha,juneau,1230123,pappy,lindsay1,mooner,seattle1,katzen,lucent,polly1,lagwagon,pixie,misiaczek,666666a,smokedog,lakers24,eyeball,ironhors,ametuer,volkodav,vepsrf,kimmy,gumby1,poi098,ovation,1q2w3,drinker,penetrating,summertime,1dallas,prima,modles,takamine,hardwork,macintosh,tahoe,passthie,chiks,sundown,flowers1,boromir,music123,phaedrus,albert1,joung,malakas,gulliver,parker1,balder,sonne,jessie1,domainlock2005,express1,vfkbyf,youandme,raketa,koala,dhjnvytyjub,nhfrnjh,testibil,ybrbnjc,987654321q,axeman,pintail,pokemon123,dogggg,shandy,thesaint,11122233,x72jhhu3z,theclash,raptors,zappa1,djdjxrf,hell666,friday1,vivaldi,pluto1,lance1,guesswho,jeadmi,corgan,skillz,skippy1,mango1,gymnastic,satori,362514,theedge,cxfcnkbdfz,sparkey,deicide,bagels,lololol,lemmings,r4e3w2q1,silve,staind,schnuffi,dazzle,basebal1,leroy1,bilbo1,luckie,qwerty2,goodfell,hermione,peaceout,davidoff,yesterda,killah,flippy,chrisb,zelda1,headless,muttley,fuckof,tittys,catdaddy,photog,beeker,reaver,ram1500,yorktown,bolero,tryagain,arman,chicco,learjet,alexei,jenna1,go2hell,12s3t4p55,momsanaladventure,mustang9,protoss,rooter,ginola,dingo1,mojave,erica1,1qazse4,marvin1,redwolf,sunbird,dangerou,maciek,girsl,hawks1,packard1,excellen,dashka,soleda,toonces,acetate,nacked,jbond007,alligator,debbie1,wellhung,monkeyma,supers,rigger,larsson,vaseline,rjnzhf,maripos,123456asd,cbr600rr,doggydog,cronic,jason123,trekker,flipmode,druid,sonyvaio,dodges,mayfair,mystuff,fun4me,samanta,sofiya,magics,1ranger,arcane,sixtynin,222444,omerta,luscious,gbyudby,bobcats,envision,chance1,seaweed,holdem,tomate,mensch,slicer,acura1,goochi,qweewq,punter,repoman,tomboy,never1,cortina,gomets,147896321,369852147,dogma,bhjxrf,loglatin,eragon,strato,gazelle,growler,885522,klaudia,payton34,fuckem,butchie,scorpi,lugano,123456789k,nichola,chipper1,spide,uhbujhbq,rsalinas,vfylfhby,longhorns,bugatti,everquest,!qaz2wsx,blackass,999111,snakeman,p455w0rd,fanatic,family1,pfqxbr,777vlad,mysecret,marat,phoenix2,october1,genghis,panties1,cooker,citron,ace123,1234569,gramps,blackcoc,kodiak1,hickory,ivanhoe,blackboy,escher,sincity,beaks,meandyou,spaniel,canon1,timmy1,lancaste,polaroid,edinburg,fuckedup,hotman,cueball,golfclub,gopack,bookcase,worldcup,dkflbvbhjdbx,twostep,17171717aa,letsplay,zolushka,stella1,pfkegf,kingtut,67camaro,barracuda,wiggles,gjhjkm,prancer,patata,kjifhf,theman1,romanova,sexyass,copper1,dobber,sokolov,pomidor,algernon,cadman,amoremio,william2,silly1,bobbys,hercule,hd764nw5d7e1vb1,defcon,deutschland,robinhood,alfalfa,machoman,lesbens,pandora1,easypay,tomservo,nadezhda,goonies,saab9000,jordyn,f15eagle,dbrecz,12qwerty,greatsex,thrawn,blunted,baywatch,doggystyle,loloxx,chevy2,january1,kodak,bushel,78963214,ub6ib9,zz8807zpl,briefs,hawker,224488,first1,bonzo,brent1,erasure,69213124,sidewind,soccer13,622521,mentos,kolibri,onepiece,united1,ponyboy,keksa12,wayer,mypussy,andrej,mischa,mille,bruno123,garter,bigpun,talgat,familia,jazzy1,mustang8,newjob,747400,bobber,blackbel,hatteras,ginge,asdfjkl;,camelot1,blue44,rebbyt34,ebony1,vegas123,myboys,aleksander,ijrjkflrf,lopata,pilsner,lotus123,m0nk3y,andreev,freiheit,balls1,drjynfrnt,mazda1,waterpolo,shibumi,852963,123bbb,cezer121,blondie1,volkova,rattler,kleenex,ben123,sanane,happydog,satellit,qazplm,qazwsxedcrfvtgb,meowmix,badguy,facefuck,spice1,blondy,major1,25000,anna123,654321a,sober1,deathrow,patterso,china1,naruto1,hawkeye1,waldo1,butchy,crayon,5tgb6yhn,klopik,crocodil,mothra,imhorny,pookie1,splatter,slippy,lizard1,router,buratino,yahweh,123698,dragon11,123qwe456,peepers,trucker1,ganjaman,1hxboqg2,cheyanne,storys,sebastie,zztop,maddison,4rfv3edc,darthvader,jeffro,iloveit,victor1,hotty,delphin,lifeisgood,gooseman,shifty,insertions,dude123,abrupt,123masha,boogaloo,chronos,stamford,pimpster,kthjxrf,getmein,amidala,flubber,fettish,grapeape,dantes,oralsex,jack1,foxcg33,winchest,francis1,getin,archon,cliffy,blueman,1basebal,sport1,emmitt22,porn123,bignasty,morga,123hfjdk147,ferrar,juanito,fabiol,caseydog,steveo,peternorth,paroll,kimchi,bootleg,gaijin,secre,acacia,eatme2,amarillo,monkey11,rfhfgep,tylers,a1a2a3a4a5,sweetass,blower,rodina,babushka,camilo,cimbom,tiffan,vfnbkmlf,ohbaby,gotigers,lindsey1,dragon13,romulus,qazxsw12,zxcvbn1,dropdead,hitman47,snuggle,eleven11,bloopers,357mag,avangard,bmw320,ginscoot,dshade,masterkey,voodoo1,rootedit,caramba,leahcim,hannover,8phrowz622,tim123,cassius,000000a,angelito,zzzzz1,badkarma,star1,malaga,glenwood,footlove,golf1,summer12,helpme1,fastcars,titan1,police1,polinka,k.jdm,marusya,augusto,shiraz,pantyhose,donald1,blaise,arabella,brigada,c3por2d2,peter01,marco1,hellow,dillweed,uzumymw,geraldin,loveyou2,toyota1,088011,gophers,indy500,slainte,5hsu75kpot,teejay,renat,racoon,sabrin,angie1,shiznit,harpua,sexyred,latex,tucker1,alexandru,wahoo,teamwork,deepblue,goodison,rundmc,r2d2c3p0,puppys,samba,ayrton,boobed,999777,topsecre,blowme1,123321z,loudog,random1,pantie,drevil,mandolin,121212q,hottub,brother1,failsafe,spade1,matvey,open1234,carmen1,priscill,schatzi,kajak,gooddog,trojans1,gordon1,kayak,calamity,argent,ufhvjybz,seviyi,penfold,assface,dildos,hawkwind,crowbar,yanks,ruffles,rastus,luv2epus,open123,aquafina,dawns,jared1,teufel,12345c,vwgolf,pepsi123,amores,passwerd,01478520,boliva,smutty,headshot,password3,davidd,zydfhm,gbgbcmrf,pornpass,insertion,ceckbr,test2,car123,checkit,dbnfkbq,niggas,nyyankee,muskrat,nbuhtyjr,gunner1,ocean1,fabienne,chrissy1,wendys,loveme89,batgirl,cerveza,igorek,steel1,ragman,boris123,novifarm,sexy12,qwerty777,mike01,giveitup,123456abc,fuckall,crevice,hackerz,gspot,eight8,assassins,texass,swallows,123458,baldur,moonshine,labatt,modem,sydney1,voland,dbnfkz,hotchick,jacker,princessa,dawgs1,holiday1,booper,reliant,miranda1,jamaica1,andre1,badnaamhere,barnaby,tiger7,david12,margaux,corsica,085tzzqi,universi,thewall,nevermor,martin6,qwerty77,cipher,apples1,0102030405,seraphim,black123,imzadi,gandon,ducati99,1shadow,dkflbvbhjdyf,44magnum,bigbad,feedme,samantha1,ultraman,redneck1,jackdog,usmc0311,fresh1,monique1,tigre,alphaman,cool1,greyhoun,indycar,crunchy,55chevy,carefree,willow1,063dyjuy,xrated,assclown,federica,hilfiger,trivia,bronco1,mamita,100200300,simcity,lexingky,akatsuki,retsam,johndeere,abudfv,raster,elgato,businka,satanas,mattingl,redwing1,shamil,patate,mannn,moonstar,evil666,b123456,bowl300,tanechka,34523452,carthage,babygir,santino,bondarenko,jesuss,chico1,numlock,shyguy,sound1,kirby1,needit,mostwanted,427900,funky1,steve123,passions,anduril,kermit1,prospero,lusty,barakuda,dream1,broodwar,porky,christy1,mahal,yyyyyy1,allan1,1sexy,flintsto,capri,cumeater,heretic,robert2,hippos,blindax,marykay,collecti,kasumi,1qaz!qaz,112233q,123258,chemistr,coolboy,0o9i8u,kabuki,righton,tigress,nessie,sergej,andrew12,yfafyz,ytrhjvfyn,angel7,victo,mobbdeep,lemming,transfor,1725782,myhouse,aeynbr,muskie,leno4ka,westham1,cvbhyjd,daffodil,pussylicker,pamela1,stuffer,warehous,tinker1,2w3e4r,pluton,louise1,polarbea,253634,prime1,anatoliy,januar,wysiwyg,cobraya,ralphy,whaler,xterra,cableguy,112233a,porn69,jamesd,aqualung,jimmy123,lumpy,luckyman,kingsize,golfing1,alpha7,leeds1,marigold,lol1234,teabag,alex11,10sne1,saopaulo,shanny,roland1,basser,3216732167,carol1,year2005,morozov,saturn1,joseluis,bushed,redrock,memnoch,lalaland,indiana1,lovegod,gulnaz,buffalos,loveyou1,anteater,pattaya,jaydee,redshift,bartek,summerti,coffee1,ricochet,incest,schastie,rakkaus,h2opolo,suikoden,perro,dance1,loveme1,whoopass,vladvlad,boober,flyers1,alessia,gfcgjhn,pipers,papaya,gunsling,coolone,blackie1,gonads,gfhjkzytn,foxhound,qwert12,gangrel,ghjvtntq,bluedevi,mywife,summer01,hangman,licorice,patter,vfr750,thorsten,515253,ninguna,dakine,strange1,mexic,vergeten,12345432,8phrowz624,stampede,floyd1,sailfish,raziel,ananda,giacomo,freeme,crfprf,74185296,allstars,master01,solrac,gfnhbjn,bayliner,bmw525,3465xxx,catter,single1,michael3,pentium4,nitrox,mapet123456,halibut,killroy,xxxxx1,phillip1,poopsie,arsenalfc,buffys,kosova,all4me,32165498,arslan,opensesame,brutis,charles2,pochta,nadegda,backspac,mustang0,invis,gogeta,654321q,adam25,niceday,truckin,gfdkbr,biceps,sceptre,bigdave,lauras,user345,sandys,shabba,ratdog,cristiano,natha,march13,gumball,getsdown,wasdwasd,redhead1,dddddd1,longlegs,13572468,starsky,ducksoup,bunnys,omsairam,whoami,fred123,danmark,flapper,swanky,lakings,yfhenj,asterios,rainier,searcher,dapper,ltdjxrf,horsey,seahawk,shroom,tkfkdgo,aquaman,tashkent,number9,messi10,1asshole,milenium,illumina,vegita,jodeci,buster01,bareback,goldfinger,fire1,33rjhjds,sabian,thinkpad,smooth1,sully,bonghits,sushi1,magnavox,colombi,voiture,limpone,oldone,aruba,rooster1,zhenya,nomar5,touchdow,limpbizkit,rhfcfdxbr,baphomet,afrodita,bball1,madiso,ladles,lovefeet,matthew2,theworld,thunderbird,dolly1,123rrr,forklift,alfons,berkut,speedy1,saphire,oilman,creatine,pussylov,bastard1,456258,wicked1,filimon,skyline1,fucing,yfnfkbz,hot123,abdulla,nippon,nolimits,billiard,booty1,buttplug,westlife,coolbean,aloha1,lopas,asasin,1212121,october2,whodat,good4u,d12345,kostas,ilya1992,regal,pioneer1,volodya,focus1,bastos,nbvjif,fenix,anita1,vadimka,nickle,jesusc,123321456,teste,christ1,essendon,evgenii,celticfc,adam1,forumwp,lovesme,26exkp,chillout,burly,thelast1,marcus1,metalgear,test11,ronaldo7,socrate,world1,franki,mommie,vicecity,postov1000,charlie3,oldschool,333221,legoland,antoshka,counterstrike,buggy,mustang3,123454,qwertzui,toons,chesty,bigtoe,tigger12,limpopo,rerehepf,diddle,nokia3250,solidsnake,conan1,rockroll,963369,titanic1,qwezxc,cloggy,prashant,katharin,maxfli,takashi,cumonme,michael9,mymother,pennstate,khalid,48151623,fightclub,showboat,mateusz,elrond,teenie,arrow1,mammamia,dustydog,dominator,erasmus,zxcvb1,1a2a3a,bones1,dennis1,galaxie,pleaseme,whatever1,junkyard,galadriel,charlies,2wsxzaq1,crimson1,behemoth,teres,master11,fairway,shady1,pass99,1batman,joshua12,baraban,apelsin,mousepad,melon,twodogs,123321qwe,metalica,ryjgrf,pipiska,rerfhfxf,lugnut,cretin,iloveu2,powerade,aaaaaaa1,omanko,kovalenko,isabe,chobits,151nxjmt,shadow11,zcxfcnkbdf,gy3yt2rgls,vfhbyrf,159753123,bladerunner,goodone,wonton,doodie,333666999,fuckyou123,kitty123,chisox,orlando1,skateboa,red12345,destroye,snoogans,satan1,juancarlo,goheels,jetson,scottt,fuckup,aleksa,gfhfljrc,passfind,oscar123,derrick1,hateme,viper123,pieman,audi100,tuffy,andover,shooter1,10000,makarov,grant1,nighthaw,13576479,browneye,batigol,nfvfhf,chocolate1,7hrdnw23,petter,bantam,morlii,jediknight,brenden,argonaut,goodstuf,wisconsi,315920,abigail1,dirtbag,splurge,k123456,lucky777,valdepen,gsxr600,322223,ghjnjrjk,zaq1xsw2cde3,schwanz,walter1,letmein22,nomads,124356,codeblue,nokian70,fucke,footbal1,agyvorc,aztecs,passw0r,smuggles,femmes,ballgag,krasnodar,tamuna,schule,sixtynine,empires,erfolg,dvader,ladygaga,elite1,venezuel,nitrous,kochamcie,olivia1,trustn01,arioch,sting1,131415,tristar,555000,maroon,135799,marsik,555556,fomoco,natalka,cwoui,tartan,davecole,nosferat,hotsauce,dmitry,horus,dimasik,skazka,boss302,bluebear,vesper,ultras,tarantul,asd123asd,azteca,theflash,8ball,1footbal,titlover,lucas123,number6,sampson1,789852,party1,dragon99,adonai,carwash,metropol,psychnau,vthctltc,hounds,firework,blink18,145632,wildcat1,satchel,rice80,ghtktcnm,sailor1,cubano,anderso,rocks1,mike11,famili,dfghjc,besiktas,roygbiv,nikko,bethan,minotaur,rakesh,orange12,hfleuf,jackel,myangel,favorite7,1478520,asssss,agnieszka,haley1,raisin,htubyf,1buster,cfiekz,derevo,1a2a3a4a5a,baltika,raffles,scruffy1,clitlick,louis1,buddha1,fy.nrf,walker1,makoto,shadow2,redbeard,vfvfvskfhfve,mycock,sandydog,lineman,network1,favorite8,longdick,mustangg,mavericks,indica,1killer,cisco1,angelofwar,blue69,brianna1,bubbaa,slayer666,level42,baldrick,brutus1,lowdown,haribo,lovesexy,500000,thissuck,picker,stephy,1fuckme,characte,telecast,1bigdog,repytwjdf,thematrix,hammerhe,chucha,ganesha,gunsmoke,georgi,sheltie,1harley,knulla,sallas,westie,dragon7,conker,crappie,margosha,lisboa,3e2w1q,shrike,grifter,ghjcnjghjcnj,asdfg1,mnbvcxz1,myszka,posture,boggie,rocketman,flhtyfkby,twiztid,vostok,pi314159,force1,televizor,gtkmvtym,samhain,imcool,jadzia,dreamers,strannik,k2trix,steelhea,nikitin,commodor,brian123,chocobo,whopper,ibilljpf,megafon,ararat,thomas12,ghbrjkbcn,q1234567890,hibernia,kings1,jim123,redfive,68camaro,iawgk2,xavier1,1234567u,d123456,ndirish,airborn,halfmoon,fluffy1,ranchero,sneaker,soccer2,passion1,cowman,birthday1,johnn,razzle,glock17,wsxqaz,nubian,lucky2,jelly1,henderso,eric1,123123e,boscoe01,fuck0ff,simpson1,sassie,rjyjgkz,nascar3,watashi,loredana,janus,wilso,conman,david2,mothe,iloveher,snikers,davidj,fkmnthyfnbdf,mettss,ratfink,123456h,lostsoul,sweet16,brabus,wobble,petra1,fuckfest,otters,sable1,svetka,spartacu,bigstick,milashka,1lover,pasport,champagn,papichul,hrvatska,hondacivic,kevins,tacit,moneybag,gohogs,rasta1,246813579,ytyfdbcnm,gubber,darkmoon,vitaliy,233223,playboys,tristan1,joyce1,oriflame,mugwump,access2,autocad,thematri,qweqwe123,lolwut,ibill01,multisyn,1233211,pelikan,rob123,chacal,1234432,griffon,pooch,dagestan,geisha,satriani,anjali,rocketma,gixxer,pendrago,vincen,hellokit,killyou,ruger,doodah,bumblebe,badlands,galactic,emachines,foghorn,jackso,jerem,avgust,frontera,123369,daisymae,hornyboy,welcome123,tigger01,diabl,angel13,interex,iwantsex,rockydog,kukolka,sawdust,online1,3234412,bigpapa,jewboy,3263827,dave123,riches,333222,tony1,toggle,farter,124816,tities,balle,brasilia,southsid,micke,ghbdtn12,patit,ctdfcnjgjkm,olds442,zzzzzz1,nelso,gremlins,gypsy1,carter1,slut69,farcry,7415963,michael8,birdie1,charl,123456789abc,100001,aztec,sinjin,bigpimpi,closeup,atlas1,nvidia,doggone,classic1,manana,malcolm1,rfkbyf,hotbabe,rajesh,dimebag,ganjubas,rodion,jagr68,seren,syrinx,funnyman,karapuz,123456789n,bloomin,admin18533362,biggdogg,ocarina,poopy1,hellome,internet1,booties,blowjobs,matt1,donkey1,swede,1jennife,evgeniya,lfhbyf,coach1,444777,green12,patryk,pinewood,justin12,271828,89600506779,notredame,tuborg,lemond,sk8ter,million1,wowser,pablo1,st0n3,jeeves,funhouse,hiroshi,gobucs,angeleye,bereza,winter12,catalin,qazedc,andros,ramazan,vampyre,sweethea,imperium,murat,jamest,flossy,sandeep,morgen,salamandra,bigdogg,stroller,njdevils,nutsack,vittorio,%%passwo,playful,rjyatnrf,tookie,ubnfhf,michi,777444,shadow13,devils1,radiance,toshiba1,beluga,amormi,dandfa,trust1,killemall,smallville,polgara,billyb,landscap,steves,exploite,zamboni,damage11,dzxtckfd,trader12,pokey1,kobe08,damager,egorov,dragon88,ckfdbr,lisa69,blade2,audis4,nelson1,nibbles,23176djivanfros,mutabor,artofwar,matvei,metal666,hrfzlz,schwinn,poohbea,seven77,thinker,123456789qwerty,sobriety,jakers,karamelka,vbkfyf,volodin,iddqd,dale03,roberto1,lizaveta,qqqqqq1,cathy1,08154711,davidm,quixote,bluenote,tazdevil,katrina1,bigfoot1,bublik,marma,olechka,fatpussy,marduk,arina,nonrev67,qqqq1111,camill,wtpfhm,truffle,fairview,mashina,voltaire,qazxswedcvfr,dickface,grassy,lapdance,bosstone,crazy8,yackwin,mobil,danielit,mounta1n,player69,bluegill,mewtwo,reverb,cnthdf,pablito,a123321,elena1,warcraft1,orland,ilovemyself,rfntyjr,joyride,schoo,dthjxrf,thetachi,goodtimes,blacksun,humpty,chewbacca,guyute,123xyz,lexicon,blue45,qwe789,galatasaray,centrino,hendrix1,deimos,saturn5,craig1,vlad1996,sarah123,tupelo,ljrnjh,hotwife,bingos,1231231,nicholas1,flamer,pusher,1233210,heart1,hun999,jiggy,giddyup,oktober,123456zxc,budda,galahad,glamur,samwise,oneton,bugsbunny,dominic1,scooby2,freetime,internat,159753852,sc00ter,wantit,mazinger,inflames,laracrof,greedo,014789,godofwar,repytwjd,water123,fishnet,venus1,wallace1,tenpin,paula1,1475963,mania,novikov,qwertyasdfgh,goldmine,homies,777888999,8balls,holeinon,paper1,samael,013579,mansur,nikit,ak1234,blueline,polska1,hotcock,laredo,windstar,vbkbwbz,raider1,newworld,lfybkrf,catfish1,shorty1,piranha,treacle,royale,2234562,smurfs,minion,cadence,flapjack,123456p,sydne,135531,robinhoo,nasdaq,decatur,cyberonline,newage,gemstone,jabba,touchme,hooch,pigdog,indahous,fonzie,zebra1,juggle,patrick2,nihongo,hitomi,oldnavy,qwerfdsa,ukraina,shakti,allure,kingrich,diane1,canad,piramide,hottie1,clarion,college1,5641110,connect1,therion,clubber,velcro,dave1,astra1,13579-,astroboy,skittle,isgreat,photoes,cvzefh1gkc,001100,2cool4u,7555545,ginger12,2wsxcde3,camaro69,invader,domenow,asd1234,colgate,qwertasdfg,jack123,pass01,maxman,bronte,whkzyc,peter123,bogie,yecgaa,abc321,1qay2wsx,enfield,camaroz2,trashman,bonefish,system32,azsxdcfvgb,peterose,iwantyou,dick69,temp1234,blastoff,capa200,connie1,blazin,12233445,sexybaby,123456j,brentfor,pheasant,hommer,jerryg,thunders,august1,lager,kapusta,boobs1,nokia5300,rocco1,xytfu7,stars1,tugger,123sas,blingbling,1bubba,0wnsyo0,1george,baile,richard2,habana,1diamond,sensatio,1golfer,maverick1,1chris,clinton1,michael7,dragons1,sunrise1,pissant,fatim,mopar1,levani,rostik,pizzapie,987412365,oceans11,748159263,cum4me,palmetto,4r3e2w1q,paige1,muncher,arsehole,kratos,gaffer,banderas,billys,prakash,crabby,bungie,silver12,caddis,spawn1,xboxlive,sylvania,littlebi,524645,futura,valdemar,isacs155,prettygirl,big123,555444,slimer,chicke,newstyle,skypilot,sailormoon,fatluvr69,jetaime,sitruc,jesuschrist,sameer,bear12,hellion,yendor,country1,etnies,conejo,jedimast,darkknight,toobad,yxcvbn,snooks,porn4life,calvary,alfaromeo,ghostman,yannick,fnkfynblf,vatoloco,homebase,5550666,barret,1111111111zz,odysseus,edwardss,favre4,jerrys,crybaby,xsw21qaz,firestor,spanks,indians1,squish,kingair,babycakes,haters,sarahs,212223,teddyb,xfactor,cumload,rhapsody,death123,three3,raccoon,thomas2,slayer66,1q2q3q4q5q,thebes,mysterio,thirdeye,orkiox.,nodoubt,bugsy,schweiz,dima1996,angels1,darkwing,jeronimo,moonpie,ronaldo9,peaches2,mack10,manish,denise1,fellowes,carioca,taylor12,epaulson,makemoney,oc247ngucz,kochanie,3edcvfr4,vulture,1qw23e,1234567z,munchie,picard1,xthtgfirf,sportste,psycho1,tahoe1,creativ,perils,slurred,hermit,scoob,diesel1,cards1,wipeout,weeble,integra1,out3xf,powerpc,chrism,kalle,ariadne,kailua,phatty,dexter1,fordman,bungalow,paul123,compa,train1,thejoker,jys6wz,pussyeater,eatmee,sludge,dominus,denisa,tagheuer,yxcvbnm,bill1,ghfdlf,300zx,nikita123,carcass,semaj,ramone,muenchen,animal1,greeny,annemari,dbrf134,jeepcj7,mollys,garten,sashok,ironmaid,coyotes,astoria,george12,westcoast,primetim,123456o,panchito,rafae,japan1,framer,auralo,tooshort,egorova,qwerty22,callme,medicina,warhawk,w1w2w3w4,cristia,merli,alex22,kawaii,chatte,wargames,utvols,muaddib,trinket,andreas1,jjjjj1,cleric,scooters,cuntlick,gggggg1,slipknot1,235711,handcuff,stussy,guess1,leiceste,ppppp1,passe,lovegun,chevyman,hugecock,driver1,buttsex,psychnaut1,cyber1,black2,alpha12,melbourn,man123,metalman,yjdsqujl,blondi,bungee,freak1,stomper,caitlin1,nikitina,flyaway,prikol,begood,desperad,aurelius,john1234,whosyourdaddy,slimed123,bretagne,den123,hotwheel,king123,roodypoo,izzicam,save13tx,warpten,nokia3310,samolet,ready1,coopers,scott123,bonito,1aaaaa,yomomma,dawg1,rache,itworks,asecret,fencer,451236,polka,olivetti,sysadmin,zepplin,sanjuan,479373,lickem,hondacrx,pulamea,future1,naked1,sexyguy,w4g8at,lollol1,declan,runner1,rumple,daddy123,4snz9g,grandprix,calcio,whatthefuck,nagrom,asslick,pennst,negrit,squiggy,1223334444,police22,giovann,toronto1,tweet,yardbird,seagate,truckers,554455,scimitar,pescator,slydog,gaysex,dogfish,fuck777,12332112,qazxswed,morkovka,daniela1,imback,horny69,789123456,123456789w,jimmy2,bagger,ilove69,nikolaus,atdhfkm,rebirth,1111aaaa,pervasive,gjgeufq,dte4uw,gfhnbpfy,skeletor,whitney1,walkman,delorean,disco1,555888,as1234,ishikawa,fuck12,reaper1,dmitrii,bigshot,morrisse,purgen,qwer4321,itachi,willys,123123qwe,kisska,roma123,trafford,sk84life,326159487,pedros,idiom,plover,bebop,159875321,jailbird,arrowhea,qwaszx123,zaxscdvf,catlover,bakers,13579246,bones69,vermont1,helloyou,simeon,chevyz71,funguy,stargaze,parolparol,steph1,bubby,apathy,poppet,laxman,kelly123,goodnews,741236,boner1,gaetano,astonvilla,virtua,luckyboy,rocheste,hello2u,elohim,trigger1,cstrike,pepsicola,miroslav,96385274,fistfuck,cheval,magyar,svetlanka,lbfyjxrf,mamedov,123123123q,ronaldo1,scotty1,1nicole,pittbull,fredd,bbbbb1,dagwood,gfhkfvtyn,ghblehrb,logan5,1jordan,sexbomb,omega2,montauk,258741,dtythf,gibbon,winamp,thebomb,millerli,852654,gemin,baldy,halflife2,dragon22,mulberry,morrigan,hotel6,zorglub,surfin,951159,excell,arhangel,emachine,moses1,968574,reklama,bulldog2,cuties,barca,twingo,saber,elite11,redtruck,casablan,ashish,moneyy,pepper12,cnhtktw,rjcnbr,arschloch,phenix,cachorro,sunita,madoka,joselui,adams1,mymoney,hemicuda,fyutkjr,jake12,chicas,eeeee1,sonnyboy,smarties,birdy,kitten1,cnfcbr,island1,kurosaki,taekwond,konfetka,bennett1,omega3,jackson2,fresca,minako,octavian,kban667,feyenoord,muaythai,jakedog,fktrcfylhjdyf,1357911q,phuket,sexslave,fktrcfylhjdbx,asdfjk,89015173454,qwerty00,kindbud,eltoro,sex6969,nyknicks,12344321q,caballo,evenflow,hoddle,love22,metro1,mahalko,lawdog,tightass,manitou,buckie,whiskey1,anton123,335533,password4,primo,ramair,timbo,brayden,stewie,pedro1,yorkshir,ganster,hellothe,tippy1,direwolf,genesi,rodrig,enkeli,vaz21099,sorcerer,winky,oneshot,boggle,serebro,badger1,japanes,comicbook,kamehame,alcat,denis123,echo45,sexboy,gr8ful,hondo,voetbal,blue33,2112rush,geneviev,danni1,moosey,polkmn,matthew7,ironhead,hot2trot,ashley12,sweeper,imogen,blue21,retep,stealth1,guitarra,bernard1,tatian,frankfur,vfnhbwf,slacking,haha123,963741,asdasdas,katenok,airforce1,123456789qaz,shotgun1,12qwasz,reggie1,sharo,976431,pacifica,dhip6a,neptun,kardon,spooky1,beaut,555555a,toosweet,tiedup,11121314,startac,lover69,rediska,pirata,vfhrbp,1234qwerty,energize,hansolo1,playbo,larry123,oemdlg,cnjvfnjkju,a123123,alexan,gohawks,antonius,fcbayern,mambo,yummy1,kremlin,ellen1,tremere,vfiekz,bellevue,charlie9,izabella,malishka,fermat,rotterda,dawggy,becket,chasey,kramer1,21125150,lolit,cabrio,schlong,arisha,verity,3some,favorit,maricon,travelle,hotpants,red1234,garrett1,home123,knarf,seven777,figment,asdewq,canseco,good2go,warhol,thomas01,pionee,al9agd,panacea,chevy454,brazzers,oriole,azerty123,finalfan,patricio,northsta,rebelde,bulldo,stallone,boogie1,7uftyx,cfhfnjd,compusa,cornholi,config,deere,hoopster,sepultura,grasshop,babygurl,lesbo,diceman,proverbs,reddragon,nurbek,tigerwoo,superdup,buzzsaw,kakaroto,golgo13,edwar,123qaz123,butter1,sssss1,texas2,respekt,ou812ic,123456qaz,55555a,doctor1,mcgwire,maria123,aol999,cinders,aa1234,joness,ghbrjkmyj,makemone,sammyboy,567765,380zliki,theraven,testme,mylene,elvira26,indiglo,tiramisu,shannara,baby1,123666,gfhreh,papercut,johnmish,orange8,bogey1,mustang7,bagpipes,dimarik,vsijyjr,4637324,ravage,cogito,seven11,natashka,warzone,hr3ytm,4free,bigdee,000006,243462536,bigboi,123333,trouts,sandy123,szevasz,monica2,guderian,newlife1,ratchet,r12345,razorbac,12345i,piazza31,oddjob,beauty1,fffff1,anklet,nodrog,pepit,olivi,puravida,robert12,transam1,portman,bubbadog,steelers1,wilson1,eightball,mexico1,superboy,4rfv5tgb,mzepab,samurai1,fuckslut,colleen1,girdle,vfrcbvec,q1w2e3r4t,soldier1,19844891,alyssa1,a12345a,fidelis,skelter,nolove,mickeymouse,frehley,password69,watermel,aliska,soccer15,12345e,ladybug1,abulafia,adagio,tigerlil,takehana,hecate,bootneck,junfan,arigato,wonkette,bobby123,trustnoone,phantasm,132465798,brianjo,w12345,t34vfrc1991,deadeye,1robert,1daddy,adida,check1,grimlock,muffi,airwalk,prizrak,onclick,longbeac,ernie1,eadgbe,moore1,geniu,shadow123,bugaga,jonathan1,cjrjkjdf,orlova,buldog,talon1,westport,aenima,541233432442,barsuk,chicago2,kellys,hellbent,toughguy,iskander,skoal,whatisit,jake123,scooter2,fgjrfkbgcbc,ghandi,love13,adelphia,vjhrjdrf,adrenali,niunia,jemoeder,rainbo,all4u8,anime1,freedom7,seraph,789321,tommys,antman,firetruc,neogeo,natas,bmwm3,froggy1,paul1,mamit,bayview,gateways,kusanagi,ihateu,frederi,rock1,centurion,grizli,biggin,fish1,stalker1,3girls,ilovepor,klootzak,lollo,redsox04,kirill123,jake1,pampers,vasya,hammers1,teacup,towing,celtic1,ishtar,yingyang,4904s677075,dahc1,patriot1,patrick9,redbirds,doremi,rebecc,yoohoo,makarova,epiphone,rfgbnfy,milesd,blister,chelseafc,katana1,blackrose,1james,primrose,shock5,hard1,scooby12,c6h12o6,dustoff,boing,chisel,kamil,1william,defiant1,tyvugq,mp8o6d,aaa340,nafets,sonnet,flyhigh,242526,crewcom,love23,strike1,stairway,katusha,salamand,cupcake1,password0,007james,sunnie,multisync,harley01,tequila1,fred12,driver8,q8zo8wzq,hunter01,mozzer,temporar,eatmeraw,mrbrownxx,kailey,sycamore,flogger,tincup,rahasia,ganymede,bandera,slinger,1111122222,vander,woodys,1cowboy,khaled,jamies,london12,babyboo,tzpvaw,diogenes,budice,mavrick,135797531,cheeta,macros,squonk,blackber,topfuel,apache1,falcon16,darkjedi,cheeze,vfhvtkfl,sparco,change1,gfhfif,freestyl,kukuruza,loveme2,12345f,kozlov,sherpa,marbella,44445555,bocephus,1winner,alvar,hollydog,gonefish,iwantin,barman,godislove,amanda18,rfpfynbg,eugen,abcdef1,redhawk,thelema,spoonman,baller1,harry123,475869,tigerman,cdtnjxrf,marillio,scribble,elnino,carguy,hardhead,l2g7k3,troopers,selen,dragon76,antigua,ewtosi,ulysse,astana,paroli,cristo,carmex,marjan,bassfish,letitbe,kasparov,jay123,19933991,blue13,eyecandy,scribe,mylord,ukflbjkec,ellie1,beaver1,destro,neuken,halfpint,ameli,lilly1,satanic,xngwoj,12345trewq,asdf1,bulldogg,asakura,jesucrist,flipside,packers4,biggy,kadett,biteme69,bobdog,silverfo,saint1,bobbo,packman,knowledg,foolio,fussbal,12345g,kozerog,westcoas,minidisc,nbvcxw,martini1,alastair,rasengan,superbee,memento,porker,lena123,florenc,kakadu,bmw123,getalife,bigsky,monkee,people1,schlampe,red321,memyself,0147896325,12345678900987654321,soccer14,realdeal,gfgjxrf,bella123,juggs,doritos,celtics1,peterbilt,ghbdtnbrb,gnusmas,xcountry,ghbdtn1,batman99,deusex,gtnhjdf,blablabl,juster,marimba,love2,rerjkrf,alhambra,micros,siemens1,assmaste,moonie,dashadasha,atybrc,eeeeee1,wildrose,blue55,davidl,xrp23q,skyblue,leo123,ggggg1,bestfriend,franny,1234rmvb,fun123,rules1,sebastien,chester2,hakeem,winston2,fartripper,atlant,07831505,iluvsex,q1a2z3,larrys,009900,ghjkju,capitan,rider1,qazxsw21,belochka,andy123,hellya,chicca,maximal,juergen,password1234,howard1,quetzal,daniel123,qpwoeiruty,123555,bharat,ferrari3,numbnuts,savant,ladydog,phipsi,lovepussy,etoile,power2,mitten,britneys,chilidog,08522580,2fchbg,kinky1,bluerose,loulo,ricardo1,doqvq3,kswbdu,013cpfza,timoha,ghbdtnghbdtn,3stooges,gearhead,browns1,g00ber,super7,greenbud,kitty2,pootie,toolshed,gamers,coffe,ibill123,freelove,anasazi,sister1,jigger,natash,stacy1,weronika,luzern,soccer7,hoopla,dmoney,valerie1,canes,razdvatri,washere,greenwoo,rfhjkbyf,anselm,pkxe62,maribe,daniel2,maxim1,faceoff,carbine,xtkjdtr,buddy12,stratos,jumpman,buttocks,aqswdefr,pepsis,sonechka,steeler1,lanman,nietzsch,ballz,biscuit1,wrxsti,goodfood,juventu,federic,mattman,vika123,strelec,jledfyxbr,sideshow,4life,fredderf,bigwilly,12347890,12345671,sharik,bmw325i,fylhtqrf,dannon4,marky,mrhappy,drdoom,maddog1,pompier,cerbera,goobers,howler,jenny69,evely,letitrid,cthuttdyf,felip,shizzle,golf12,t123456,yamah,bluearmy,squishy,roxan,10inches,dollface,babygirl1,blacksta,kaneda,lexingto,canadien,222888,kukushka,sistema,224422,shadow69,ppspankp,mellons,barbie1,free4all,alfa156,lostone,2w3e4r5t,painkiller,robbie1,binger,8dihc6,jaspe,rellik,quark,sogood,hoopstar,number2,snowy1,dad2ownu,cresta,qwe123asd,hjvfyjdf,gibsonsg,qbg26i,dockers,grunge,duckling,lfiekz,cuntsoup,kasia1,1tigger,woaini,reksio,tmoney,firefighter,neuron,audia3,woogie,powerboo,powermac,fatcock,12345666,upnfmc,lustful,porn1,gotlove,amylee,kbytqrf,11924704,25251325,sarasota,sexme,ozzie1,berliner,nigga1,guatemal,seagulls,iloveyou!,chicken2,qwerty21,010203040506,1pillow,libby1,vodoley,backlash,piglets,teiubesc,019283,vonnegut,perico,thunde,buckey,gtxtymrf,manunite,iiiii1,lost4815162342,madonn,270873_,britney1,kevlar,piano1,boondock,colt1911,salamat,doma77ns,anuradha,cnhjqrf,rottweil,newmoon,topgun1,mauser,fightclu,birthday21,reviewpa,herons,aassddff,lakers32,melissa2,vredina,jiujitsu,mgoblue,shakey,moss84,12345zxcvb,funsex,benji1,garci,113322,chipie,windex,nokia5310,pwxd5x,bluemax,cosita,chalupa,trotsky,new123,g3ujwg,newguy,canabis,gnaget,happydays,felixx,1patrick,cumface,sparkie,kozlova,123234,newports,broncos7,golf18,recycle,hahah,harrypot,cachondo,open4me,miria,guessit,pepsione,knocker,usmc1775,countach,playe,wiking,landrover,cracksevi,drumline,a7777777,smile123,manzana,panty,liberta,pimp69,dolfan,quality1,schnee,superson,elaine22,webhompass,mrbrownx,deepsea,4wheel,mamasita,rockport,rollie,myhome,jordan12,kfvgjxrf,hockey12,seagrave,ford1,chelsea2,samsara,marissa1,lamesa,mobil1,piotrek,tommygun,yyyyy1,wesley1,billy123,homersim,julies,amanda12,shaka,maldini,suzenet,springst,iiiiii1,yakuza,111111aa,westwind,helpdesk,annamari,bringit,hopefull,hhhhhhh1,saywhat,mazdarx8,bulova,jennife1,baikal,gfhjkmxbr,victoria1,gizmo123,alex99,defjam,2girls,sandrock,positivo,shingo,syncmast,opensesa,silicone,fuckina,senna1,karlos,duffbeer,montagne,gehrig,thetick,pepino,hamburge,paramedic,scamp,smokeweed,fabregas,phantoms,venom121293,2583458,badone,porno69,manwhore,vfvf123,notagain,vbktyf,rfnthbyrf,wildblue,kelly001,dragon66,camell,curtis1,frolova,1212123,dothedew,tyler123,reddrago,planetx,promethe,gigolo,1001001,thisone,eugeni,blackshe,cruzazul,incognito,puller,joonas,quick1,spirit1,gazza,zealot,gordito,hotrod1,mitch1,pollito,hellcat,mythos,duluth,383pdjvl,easy123,hermos,binkie,its420,lovecraf,darien,romina,doraemon,19877891,syclone,hadoken,transpor,ichiro,intell,gargamel,dragon2,wavpzt,557744,rjw7x4,jennys,kickit,rjynfrn,likeit,555111,corvus,nec3520,133113,mookie1,bochum,samsung2,locoman0,154ugeiu,vfvfbgfgf,135792,[start],tenni,20001,vestax,hufmqw,neveragain,wizkid,kjgfnf,nokia6303,tristen,saltanat,louie1,gandalf2,sinfonia,alpha3,tolstoy,ford150,f00bar,1hello,alici,lol12,riker1,hellou,333888,1hunter,qw1234,vibrator,mets86,43211234,gonzale,cookies1,sissy1,john11,bubber,blue01,cup2006,gtkmvtyb,nazareth,heybaby,suresh,teddie,mozilla,rodeo1,madhouse,gamera,123123321,naresh,dominos,foxtrot1,taras,powerup,kipling,jasonb,fidget,galena,meatman,alpacino,bookmark,farting,humper,titsnass,gorgon,castaway,dianka,anutka,gecko1,fucklove,connery,wings1,erika1,peoria,moneymaker,ichabod,heaven1,paperboy,phaser,breakers,nurse1,westbrom,alex13,brendan1,123asd123,almera,grubber,clarkie,thisisme,welkom01,51051051051,crypto,freenet,pflybwf,black12,testme2,changeit,autobahn,attica,chaoss,denver1,tercel,gnasher23,master2,vasilii,sherman1,gomer,bigbuck,derek1,qwerzxcv,jumble,dragon23,art131313,numark,beasty,cxfcnmttcnm,updown,starion,glist,sxhq65,ranger99,monkey7,shifter,wolves1,4r5t6y,phone1,favorite5,skytommy,abracada,1martin,102030405060,gatech,giulio,blacktop,cheer1,africa1,grizzly1,inkjet,shemales,durango1,booner,11223344q,supergirl,vanyarespekt,dickless,srilanka,weaponx,6string,nashvill,spicey,boxer1,fabien,2sexy2ho,bowhunt,jerrylee,acrobat,tawnee,ulisse,nolimit8,l8g3bkde,pershing,gordo1,allover,gobrowns,123432,123444,321456987,spoon1,hhhhh1,sailing1,gardenia,teache,sexmachine,tratata,pirate1,niceone,jimbos,314159265,qsdfgh,bobbyy,ccccc1,carla1,vjkjltw,savana,biotech,frigid,123456789g,dragon10,yesiam,alpha06,oakwood,tooter,winsto,radioman,vavilon,asnaeb,google123,nariman,kellyb,dthyjcnm,password6,parol1,golf72,skate1,lthtdj,1234567890s,kennet,rossia,lindas,nataliya,perfecto,eminem1,kitana,aragorn1,rexona,arsenalf,planot,coope,testing123,timex,blackbox,bullhead,barbarian,dreamon,polaris1,cfvjktn,frdfhbev,gametime,slipknot666,nomad1,hfgcjlbz,happy69,fiddler,brazil1,joeboy,indianali,113355,obelisk,telemark,ghostrid,preston1,anonim,wellcome,verizon1,sayangku,censor,timeport,dummies,adult1,nbnfybr,donger,thales,iamgay,sexy1234,deadlift,pidaras,doroga,123qwe321,portuga,asdfgh12,happys,cadr14nu,pi3141,maksik,dribble,cortland,darken,stepanova,bommel,tropic,sochi2014,bluegras,shahid,merhaba,nacho,2580456,orange44,kongen,3cudjz,78girl,my3kids,marcopol,deadmeat,gabbie,saruman,jeepman,freddie1,katie123,master99,ronal,ballbag,centauri,killer7,xqgann,pinecone,jdeere,geirby,aceshigh,55832811,pepsimax,rayden,razor1,tallyho,ewelina,coldfire,florid,glotest,999333,sevenup,bluefin,limaperu,apostol,bobbins,charmed1,michelin,sundin,centaur,alphaone,christof,trial1,lions1,45645,just4you,starflee,vicki1,cougar1,green2,jellyfis,batman69,games1,hihje863,crazyzil,w0rm1,oklick,dogbite,yssup,sunstar,paprika,postov10,124578963,x24ik3,kanada,buckster,iloveamy,bear123,smiler,nx74205,ohiostat,spacey,bigbill,doudo,nikolaeva,hcleeb,sex666,mindy1,buster11,deacons,boness,njkcnsq,candy2,cracker1,turkey1,qwertyu1,gogreen,tazzzz,edgewise,ranger01,qwerty6,blazer1,arian,letmeinnow,cigar1,jjjjjj1,grigio,frien,tenchu,f9lmwd,imissyou,filipp,heathers,coolie,salem1,woodduck,scubadiv,123kat,raffaele,nikolaev,dapzu455,skooter,9inches,lthgfhjkm,gr8one,ffffff1,zujlrf,amanda69,gldmeo,m5wkqf,rfrltkf,televisi,bonjou,paleale,stuff1,cumalot,fuckmenow,climb7,mark1234,t26gn4,oneeye,george2,utyyflbq,hunting1,tracy71,ready2go,hotguy,accessno,charger1,rudedog,kmfdm,goober1,sweetie1,wtpmjgda,dimensio,ollie1,pickles1,hellraiser,mustdie,123zzz,99887766,stepanov,verdun,tokenbad,anatol,bartende,cidkid86,onkelz,timmie,mooseman,patch1,12345678c,marta1,dummy1,bethany1,myfamily,history1,178500,lsutiger,phydeaux,moren,dbrnjhjdbx,gnbxrf,uniden,drummers,abpbrf,godboy,daisy123,hogan1,ratpack,irland,tangerine,greddy,flore,sqrunch,billyjoe,q55555,clemson1,98745632,marios,ishot,angelin,access12,naruto12,lolly,scxakv,austin12,sallad,cool99,rockit,mongo1,mark22,ghbynth,ariadna,senha,docto,tyler2,mobius,hammarby,192168,anna12,claire1,pxx3eftp,secreto,greeneye,stjabn,baguvix,satana666,rhbcnbyjxrf,dallastx,garfiel,michaelj,1summer,montan,1234ab,filbert,squids,fastback,lyudmila,chucho,eagleone,kimberle,ar3yuk3,jake01,nokids,soccer22,1066ad,ballon,cheeto,review69,madeira,taylor2,sunny123,chubbs,lakeland,striker1,porche,qwertyu8,digiview,go1234,ferari,lovetits,aditya,minnow,green3,matman,cellphon,fortytwo,minni,pucara,69a20a,roman123,fuente,12e3e456,paul12,jacky,demian,littleman,jadakiss,vlad1997,franca,282860,midian,nunzio,xaccess2,colibri,jessica0,revilo,654456,harvey1,wolf1,macarena,corey1,husky1,arsen,milleniu,852147,crowes,redcat,combat123654,hugger,psalms,quixtar,ilovemom,toyot,ballss,ilovekim,serdar,james23,avenger1,serendip,malamute,nalgas,teflon,shagger,letmein6,vyjujnjxbt,assa1234,student1,dixiedog,gznybwf13,fuckass,aq1sw2de3,robroy,hosehead,sosa21,123345,ias100,teddy123,poppin,dgl70460,zanoza,farhan,quicksilver,1701d,tajmahal,depechemode,paulchen,angler,tommy2,recoil,megamanx,scarecro,nicole2,152535,rfvtgb,skunky,fatty1,saturno,wormwood,milwauke,udbwsk,sexlover,stefa,7bgiqk,gfnhbr,omar10,bratan,lbyfvj,slyfox,forest1,jambo,william3,tempus,solitari,lucydog,murzilka,qweasdzxc1,vehpbkrf,12312345,fixit,woobie,andre123,123456789x,lifter,zinaida,soccer17,andone,foxbat,torsten,apple12,teleport,123456i,leglover,bigcocks,vologda,dodger1,martyn,d6o8pm,naciona,eagleeye,maria6,rimshot,bentley1,octagon,barbos,masaki,gremio,siemen,s1107d,mujeres,bigtits1,cherr,saints1,mrpink,simran,ghzybr,ferrari2,secret12,tornado1,kocham,picolo,deneme,onelove1,rolan,fenster,1fuckyou,cabbie,pegaso,nastyboy,password5,aidana,mine2306,mike13,wetone,tigger69,ytreza,bondage1,myass,golova,tolik,happyboy,poilkj,nimda2k,rammer,rubies,hardcore1,jetset,hoops1,jlaudio,misskitt,1charlie,google12,theone1,phred,porsch,aalborg,luft4,charlie5,password7,gnosis,djgabbab,1daniel,vinny,borris,cumulus,member1,trogdor,darthmau,andrew2,ktjybl,relisys,kriste,rasta220,chgobndg,weener,qwerty66,fritter,followme,freeman1,ballen,blood1,peache,mariso,trevor1,biotch,gtfullam,chamonix,friendste,alligato,misha1,1soccer,18821221,venkat,superd,molotov,bongos,mpower,acun3t1x,dfcmrf,h4x3d,rfhfufylf,tigran,booyaa,plastic1,monstr,rfnhby,lookatme,anabolic,tiesto,simon123,soulman,canes1,skyking,tomcat1,madona,bassline,dasha123,tarheel1,dutch1,xsw23edc,qwerty123456789,imperator,slaveboy,bateau,paypal,house123,pentax,wolf666,drgonzo,perros,digger1,juninho,hellomoto,bladerun,zzzzzzz1,keebler,take8422,fffffff1,ginuwine,israe,caesar1,crack1,precious1,garand,magda1,zigazaga,321ewq,johnpaul,mama1234,iceman69,sanjeev,treeman,elric,rebell,1thunder,cochon,deamon,zoltan,straycat,uhbyuj,luvfur,mugsy,primer,wonder1,teetime,candycan,pfchfytw,fromage,gitler,salvatio,piggy1,23049307,zafira,chicky,sergeev,katze,bangers,andriy,jailbait,vaz2107,ghbhjlf,dbjktnnf,aqswde,zaratustra,asroma,1pepper,alyss,kkkkk1,ryan1,radish,cozumel,waterpol,pentium1,rosebowl,farmall,steinway,dbrekz,baranov,jkmuf,another1,chinacat,qqqqqqq1,hadrian,devilmaycry4,ratbag,teddy2,love21,pullings,packrat,robyn1,boobo,qw12er34,tribe1,rosey,celestia,nikkie,fortune12,olga123,danthema,gameon,vfrfhjys,dilshod,henry14,jenova,redblue,chimaera,pennywise,sokrates,danimal,qqaazz,fuaqz4,killer2,198200,tbone1,kolyan,wabbit,lewis1,maxtor,egoist,asdfas,spyglass,omegas,jack12,nikitka,esperanz,doozer,matematika,wwwww1,ssssss1,poiu0987,suchka,courtney1,gungho,alpha2,fktyjxrf,summer06,bud420,devildriver,heavyd,saracen,foucault,choclate,rjdfktyrj,goblue1,monaro,jmoney,dcpugh,efbcapa201,qqh92r,pepsicol,bbb747,ch5nmk,honeyb,beszoptad,tweeter,intheass,iseedeadpeople,123dan,89231243658s,farside1,findme,smiley1,55556666,sartre,ytcnjh,kacper,costarica,134679258,mikeys,nolimit9,vova123,withyou,5rxypn,love143,freebie,rescue1,203040,michael6,12monkey,redgreen,steff,itstime,naveen,good12345,acidrain,1dawg,miramar,playas,daddio,orion2,852741,studmuff,kobe24,senha123,stephe,mehmet,allalone,scarface1,helloworld,smith123,blueyes,vitali,memphis1,mybitch,colin1,159874,1dick,podaria,d6wnro,brahms,f3gh65,dfcbkmtd,xxxman,corran,ugejvp,qcfmtz,marusia,totem,arachnid,matrix2,antonell,fgntrf,zemfira,christos,surfing1,naruto123,plato1,56qhxs,madzia,vanille,043aaa,asq321,mutton,ohiostate,golde,cdznjckfd,rhfcysq,green5,elephan,superdog,jacqueli,bollock,lolitas,nick12,1orange,maplelea,july23,argento,waldorf,wolfer,pokemon12,zxcvbnmm,flicka,drexel,outlawz,harrie,atrain,juice2,falcons1,charlie6,19391945,tower1,dragon21,hotdamn,dirtyboy,love4ever,1ginger,thunder2,virgo1,alien1,bubblegu,4wwvte,123456789qqq,realtime,studio54,passss,vasilek,awsome,giorgia,bigbass,2002tii,sunghile,mosdef,simbas,count0,uwrl7c,summer05,lhepmz,ranger21,sugarbea,principe,5550123,tatanka,9638v,cheerios,majere,nomercy,jamesbond007,bh90210,7550055,jobber,karaganda,pongo,trickle,defamer,6chid8,1q2a3z,tuscan,nick123,.adgjm,loveyo,hobbes1,note1234,shootme,171819,loveporn,9788960,monty123,fabrice,macduff,monkey13,shadowfa,tweeker,hanna1,madball,telnet,loveu2,qwedcxzas,thatsit,vfhcbr,ptfe3xxp,gblfhfcs,ddddddd1,hakkinen,liverune,deathsta,misty123,suka123,recon1,inferno1,232629,polecat,sanibel,grouch,hitech,hamradio,rkfdbfnehf,vandam,nadin,fastlane,shlong,iddqdidkfa,ledzeppelin,sexyfeet,098123,stacey1,negras,roofing,lucifer1,ikarus,tgbyhn,melnik,barbaria,montego,twisted1,bigal1,jiggle,darkwolf,acerview,silvio,treetops,bishop1,iwanna,pornsite,happyme,gfccdjhl,114411,veritech,batterse,casey123,yhntgb,mailto,milli,guster,q12345678,coronet,sleuth,fuckmeha,armadill,kroshka,geordie,lastochka,pynchon,killall,tommy123,sasha1996,godslove,hikaru,clticic,cornbrea,vfkmdbyf,passmaster,123123123a,souris,nailer,diabolo,skipjack,martin12,hinata,mof6681,brookie,dogfight,johnso,karpov,326598,rfvbrflpt,travesti,caballer,galaxy1,wotan,antoha,art123,xakep1234,ricflair,pervert1,p00kie,ambulanc,santosh,berserker,larry33,bitch123,a987654321,dogstar,angel22,cjcbcrf,redhouse,toodles,gold123,hotspot,kennedy1,glock21,chosen1,schneide,mainman,taffy1,3ki42x,4zqauf,ranger2,4meonly,year2000,121212a,kfylsi,netzwerk,diese,picasso1,rerecz,225522,dastan,swimmer1,brooke1,blackbea,oneway,ruslana,dont4get,phidelt,chrisp,gjyxbr,xwing,kickme,shimmy,kimmy1,4815162342lost,qwerty5,fcporto,jazzbo,mierd,252627,basses,sr20det,00133,florin,howdy1,kryten,goshen,koufax,cichlid,imhotep,andyman,wrest666,saveme,dutchy,anonymou,semprini,siempre,mocha1,forest11,wildroid,aspen1,sesam,kfgekz,cbhbec,a55555,sigmanu,slash1,giggs11,vatech,marias,candy123,jericho1,kingme,123a123,drakula,cdjkjxm,mercur,oneman,hoseman,plumper,ilovehim,lancers,sergey1,takeshi,goodtogo,cranberr,ghjcnj123,harvick,qazxs,1972chev,horsesho,freedom3,letmein7,saitek,anguss,vfvfgfgfz,300000,elektro,toonporn,999111999q,mamuka,q9umoz,edelweis,subwoofer,bayside,disturbe,volition,lucky3,12345678z,3mpz4r,march1,atlantida,strekoza,seagrams,090909t,yy5rbfsc,jack1234,sammy12,sampras,mark12,eintrach,chaucer,lllll1,nochance,whitepower,197000,lbvekz,passer,torana,12345as,pallas,koolio,12qw34,nokia8800,findout,1thomas,mmmmm1,654987,mihaela,chinaman,superduper,donnas,ringo1,jeroen,gfdkjdf,professo,cdtnrf,tranmere,tanstaaf,himera,ukflbfnjh,667788,alex32,joschi,w123456,okidoki,flatline,papercli,super8,doris1,2good4u,4z34l0ts,pedigree,freeride,gsxr1100,wulfgar,benjie,ferdinan,king1,charlie7,djdxbr,fhntvbq,ripcurl,2wsx1qaz,kingsx,desade,sn00py,loveboat,rottie,evgesha,4money,dolittle,adgjmpt,buzzers,brett1,makita,123123qweqwe,rusalka,sluts1,123456e,jameson1,bigbaby,1z2z3z,ckjybr,love4u,fucker69,erhfbyf,jeanluc,farhad,fishfood,merkin,giant1,golf69,rfnfcnhjaf,camera1,stromb,smoothy,774411,nylon,juice1,rfn.irf,newyor,123456789t,marmot,star11,jennyff,jester1,hisashi,kumquat,alex777,helicopt,merkur,dehpye,cummin,zsmj2v,kristjan,april12,englan,honeypot,badgirls,uzumaki,keines,p12345,guita,quake1,duncan1,juicer,milkbone,hurtme,123456789b,qq123456789,schwein,p3wqaw,54132442,qwertyytrewq,andreeva,ruffryde,punkie,abfkrf,kristinka,anna1987,ooooo1,335533aa,umberto,amber123,456123789,456789123,beelch,manta,peeker,1112131415,3141592654,gipper,wrinkle5,katies,asd123456,james11,78n3s5af,michael0,daboss,jimmyb,hotdog1,david69,852123,blazed,sickan,eljefe,2n6wvq,gobills,rfhfcm,squeaker,cabowabo,luebri,karups,test01,melkor,angel777,smallvil,modano,olorin,4rkpkt,leslie1,koffie,shadows1,littleon,amiga1,topeka,summer20,asterix1,pitstop,aloysius,k12345,magazin,joker69,panocha,pass1word,1233214,ironpony,368ejhih,88keys,pizza123,sonali,57np39,quake2,1234567890qw,1020304,sword1,fynjif,abcde123,dfktyjr,rockys,grendel1,harley12,kokakola,super2,azathoth,lisa123,shelley1,girlss,ibragim,seven1,jeff24,1bigdick,dragan,autobot,t4nvp7,omega123,900000,hecnfv,889988,nitro1,doggie1,fatjoe,811pahc,tommyt,savage1,pallino,smitty1,jg3h4hfn,jamielee,1qazwsx,zx123456,machine1,asdfgh123,guinnes,789520,sharkman,jochen,legend1,sonic2,extreme1,dima12,photoman,123459876,nokian95,775533,vaz2109,april10,becks,repmvf,pooker,qwer12345,themaster,nabeel,monkey10,gogetit,hockey99,bbbbbbb1,zinedine,dolphin2,anelka,1superma,winter01,muggsy,horny2,669966,kuleshov,jesusis,calavera,bullet1,87t5hdf,sleepers,winkie,vespa,lightsab,carine,magister,1spider,shitbird,salavat,becca1,wc18c2,shirak,galactus,zaskar,barkley1,reshma,dogbreat,fullsail,asasa,boeder,12345ta,zxcvbnm12,lepton,elfquest,tony123,vkaxcs,savatage,sevilia1,badkitty,munkey,pebbles1,diciembr,qapmoc,gabriel2,1qa2ws3e,cbcmrb,welldone,nfyufh,kaizen,jack11,manisha,grommit,g12345,maverik,chessman,heythere,mixail,jjjjjjj1,sylvia1,fairmont,harve,skully,global1,youwish,pikachu1,badcat,zombie1,49527843,ultra1,redrider,offsprin,lovebird,153426,stymie,aq1sw2,sorrento,0000001,r3ady41t,webster1,95175,adam123,coonass,159487,slut1,gerasim,monkey99,slutwife,159963,1pass1page,hobiecat,bigtymer,all4you,maggie2,olamide,comcast1,infinit,bailee,vasileva,.ktxrf,asdfghjkl1,12345678912,setter,fuckyou7,nnagqx,lifesuck,draken,austi,feb2000,cable1,1234qwerasdf,hax0red,zxcv12,vlad7788,nosaj,lenovo,underpar,huskies1,lovegirl,feynman,suerte,babaloo,alskdjfhg,oldsmobi,bomber1,redrover,pupuce,methodman,phenom,cutegirl,countyli,gretsch,godisgood,bysunsu,hardhat,mironova,123qwe456rty,rusty123,salut,187211,555666777,11111z,mahesh,rjntyjxtr,br00klyn,dunce1,timebomb,bovine,makelove,littlee,shaven,rizwan,patrick7,42042042,bobbijo,rustem,buttmunc,dongle,tiger69,bluecat,blackhol,shirin,peaces,cherub,cubase,longwood,lotus7,gwju3g,bruin,pzaiu8,green11,uyxnyd,seventee,dragon5,tinkerbel,bluess,bomba,fedorova,joshua2,bodyshop,peluche,gbpacker,shelly1,d1i2m3a4,ghtpbltyn,talons,sergeevna,misato,chrisc,sexmeup,brend,olddog,davros,hazelnut,bridget1,hzze929b,readme,brethart,wild1,ghbdtnbr1,nortel,kinger,royal1,bucky1,allah1,drakkar,emyeuanh,gallaghe,hardtime,jocker,tanman,flavio,abcdef123,leviatha,squid1,skeet,sexse,123456x,mom4u4mm,lilred,djljktq,ocean11,cadaver,baxter1,808state,fighton,primavera,1andrew,moogle,limabean,goddess1,vitalya,blue56,258025,bullride,cicci,1234567d,connor1,gsxr11,oliveoil,leonard1,legsex,gavrik,rjnjgtc,mexicano,2bad4u,goodfellas,ornw6d,mancheste,hawkmoon,zlzfrh,schorsch,g9zns4,bashful,rossi46,stephie,rfhfntkm,sellout,123fuck,stewar1,solnze,00007,thor5200,compaq12,didit,bigdeal,hjlbyf,zebulon,wpf8eu,kamran,emanuele,197500,carvin,ozlq6qwm,3syqo15hil,pennys,epvjb6,asdfghjkl123,198000,nfbcbz,jazzer,asfnhg66,zoloft,albundy,aeiou,getlaid,planet1,gjkbyjxrf,alex2000,brianb,moveon,maggie11,eieio,vcradq,shaggy1,novartis,cocoloco,dunamis,554uzpad,sundrop,1qwertyu,alfie,feliks,briand,123www,red456,addams,fhntv1998,goodhead,theway,javaman,angel01,stratoca,lonsdale,15987532,bigpimpin,skater1,issue43,muffie,yasmina,slowride,crm114,sanity729,himmel,carolcox,bustanut,parabola,masterlo,computador,crackhea,dynastar,rockbott,doggysty,wantsome,bigten,gaelle,juicy1,alaska1,etower,sixnine,suntan,froggies,nokia7610,hunter11,njnets,alicante,buttons1,diosesamo,elizabeth1,chiron,trustnoo,amatuers,tinytim,mechta,sammy2,cthulu,trs8f7,poonam,m6cjy69u35,cookie12,blue25,jordans,santa1,kalinka,mikey123,lebedeva,12345689,kissss,queenbee,vjybnjh,ghostdog,cuckold,bearshare,rjcntyrj,alinochka,ghjcnjrdfibyj,aggie1,teens1,3qvqod,dauren,tonino,hpk2qc,iqzzt580,bears85,nascar88,theboy,njqcw4,masyanya,pn5jvw,intranet,lollone,shadow99,00096462,techie,cvtifhbrb,redeemed,gocanes,62717315,topman,intj3a,cobrajet,antivirus,whyme,berserke,ikilz083,airedale,brandon2,hopkig,johanna1,danil8098,gojira,arthu,vision1,pendragon,milen,chrissie,vampiro,mudder,chris22,blowme69,omega7,surfers,goterps,italy1,baseba11,diego1,gnatsum,birdies,semenov,joker123,zenit2011,wojtek,cab4ma99,watchmen,damia,forgotte,fdm7ed,strummer,freelanc,cingular,orange77,mcdonalds,vjhjpjdf,kariya,tombston,starlet,hawaii1,dantheman,megabyte,nbvjirf,anjing,ybrjkftdbx,hotmom,kazbek,pacific1,sashimi,asd12,coorslig,yvtte545,kitte,elysium,klimenko,cobblers,kamehameha,only4me,redriver,triforce,sidorov,vittoria,fredi,dank420,m1234567,fallout2,989244342a,crazy123,crapola,servus,volvos,1scooter,griffin1,autopass,ownzyou,deviant,george01,2kgwai,boeing74,simhrq,hermosa,hardcor,griffy,rolex1,hackme,cuddles1,master3,bujhtr,aaron123,popolo,blader,1sexyred,gerry1,cronos,ffvdj474,yeehaw,bob1234,carlos2,mike77,buckwheat,ramesh,acls2h,monster2,montess,11qq22ww,lazer,zx123456789,chimpy,masterch,sargon,lochness,archana,1234qwert,hbxfhl,sarahb,altoid,zxcvbn12,dakot,caterham,dolomite,chazz,r29hqq,longone,pericles,grand1,sherbert,eagle3,pudge,irontree,synapse,boome,nogood,summer2,pooki,gangsta1,mahalkit,elenka,lbhtrnjh,dukedog,19922991,hopkins1,evgenia,domino1,x123456,manny1,tabbycat,drake1,jerico,drahcir,kelly2,708090a,facesit,11c645df,mac123,boodog,kalani,hiphop1,critters,hellothere,tbirds,valerka,551scasi,love777,paloalto,mrbrown,duke3d,killa1,arcturus,spider12,dizzy1,smudger,goddog,75395,spammy,1357997531,78678,datalife,zxcvbn123,1122112211,london22,23dp4x,rxmtkp,biggirls,ownsu,lzbs2twz,sharps,geryfe,237081a,golakers,nemesi,sasha1995,pretty1,mittens1,d1lakiss,speedrac,gfhjkmm,sabbat,hellrais,159753258,qwertyuiop123,playgirl,crippler,salma,strat1,celest,hello5,omega5,cheese12,ndeyl5,edward12,soccer3,cheerio,davido,vfrcbr,gjhjctyjr,boscoe,inessa,shithole,ibill,qwepoi,201jedlz,asdlkj,davidk,spawn2,ariel1,michael4,jamie123,romantik,micro1,pittsbur,canibus,katja,muhtar,thomas123,studboy,masahiro,rebrov,patrick8,hotboys,sarge1,1hammer,nnnnn1,eistee,datalore,jackdani,sasha2010,mwq6qlzo,cmfnpu,klausi,cnhjbntkm,andrzej,ilovejen,lindaa,hunter123,vvvvv1,novembe,hamster1,x35v8l,lacey1,1silver,iluvporn,valter,herson,alexsandr,cojones,backhoe,womens,777angel,beatit,klingon1,ta8g4w,luisito,benedikt,maxwel,inspecto,zaq12ws,wladimir,bobbyd,peterj,asdfg12,hellspawn,bitch69,nick1234,golfer23,sony123,jello1,killie,chubby1,kodaira52,yanochka,buckfast,morris1,roaddogg,snakeeye,sex1234,mike22,mmouse,fucker11,dantist,brittan,vfrfhjdf,doc123,plokijuh,emerald1,batman01,serafim,elementa,soccer9,footlong,cthuttdbx,hapkido,eagle123,getsmart,getiton,batman2,masons,mastiff,098890,cfvfhf,james7,azalea,sherif,saun24865709,123red,cnhtrjpf,martina1,pupper,michael5,alan12,shakir,devin1,ha8fyp,palom,mamulya,trippy,deerhunter,happyone,monkey77,3mta3,123456789f,crownvic,teodor,natusik,0137485,vovchik,strutter,triumph1,cvetok,moremone,sonnen,screwbal,akira1,sexnow,pernille,independ,poopies,samapi,kbcbxrf,master22,swetlana,urchin,viper2,magica,slurpee,postit,gilgames,kissarmy,clubpenguin,limpbizk,timber1,celin,lilkim,fuckhard,lonely1,mom123,goodwood,extasy,sdsadee23,foxglove,malibog,clark1,casey2,shell1,odense,balefire,dcunited,cubbie,pierr,solei,161718,bowling1,areyukesc,batboy,r123456,1pionee,marmelad,maynard1,cn42qj,cfvehfq,heathrow,qazxcvbn,connecti,secret123,newfie,xzsawq21,tubitzen,nikusha,enigma1,yfcnz123,1austin,michaelc,splunge,wanger,phantom2,jason2,pain4me,primetime21,babes1,liberte,sugarray,undergro,zonker,labatts,djhjyf,watch1,eagle5,madison2,cntgfirf,sasha2,masterca,fiction7,slick50,bruins1,sagitari,12481632,peniss,insuranc,2b8riedt,12346789,mrclean,ssptx452,tissot,q1w2e3r4t5y6u7,avatar1,comet1,spacer,vbrjkf,pass11,wanker1,14vbqk9p,noshit,money4me,sayana,fish1234,seaways,pipper,romeo123,karens,wardog,ab123456,gorilla1,andrey123,lifesucks,jamesr,4wcqjn,bearman,glock22,matt11,dflbvrf,barbi,maine1,dima1997,sunnyboy,6bjvpe,bangkok1,666666q,rafiki,letmein0,0raziel0,dalla,london99,wildthin,patrycja,skydog,qcactw,tmjxn151,yqlgr667,jimmyd,stripclub,deadwood,863abgsg,horses1,qn632o,scatman,sonia1,subrosa,woland,kolya,charlie4,moleman,j12345,summer11,angel11,blasen,sandal,mynewpas,retlaw,cambria,mustang4,nohack04,kimber45,fatdog,maiden1,bigload,necron,dupont24,ghost123,turbo2,.ktymrf,radagast,balzac,vsevolod,pankaj,argentum,2bigtits,mamabear,bumblebee,mercury7,maddie1,chomper,jq24nc,snooky,pussylic,1lovers,taltos,warchild,diablo66,jojo12,sumerki,aventura,gagger,annelies,drumset,cumshots,azimut,123580,clambake,bmw540,birthday54,psswrd,paganini,wildwest,filibert,teaseme,1test,scampi,thunder5,antosha,purple12,supersex,hhhhhh1,brujah,111222333a,13579a,bvgthfnjh,4506802a,killians,choco,qqqwwweee,raygun,1grand,koetsu13,sharp1,mimi92139,fastfood,idontcare,bluered,chochoz,4z3al0ts,target1,sheffiel,labrat,stalingrad,147123,cubfan,corvett1,holden1,snapper1,4071505,amadeo,pollo,desperados,lovestory,marcopolo,mumbles,familyguy,kimchee,marcio,support1,tekila,shygirl1,trekkie,submissi,ilaria,salam,loveu,wildstar,master69,sales1,netware,homer2,arseniy,gerrity1,raspberr,atreyu,stick1,aldric,tennis12,matahari,alohomora,dicanio,michae1,michaeld,666111,luvbug,boyscout,esmerald,mjordan,admiral1,steamboa,616913,ybhdfyf,557711,555999,sunray,apokalipsis,theroc,bmw330,buzzy,chicos,lenusik,shadowma,eagles05,444222,peartree,qqq123,sandmann,spring1,430799,phatass,andi03,binky1,arsch,bamba,kenny123,fabolous,loser123,poop12,maman,phobos,tecate,myxworld4,metros,cocorico,nokia6120,johnny69,hater,spanked,313233,markos,love2011,mozart1,viktoriy,reccos,331234,hornyone,vitesse,1um83z,55555q,proline,v12345,skaven,alizee,bimini,fenerbahce,543216,zaqqaz,poi123,stabilo,brownie1,1qwerty1,dinesh,baggins1,1234567t,davidkin,friend1,lietuva,octopuss,spooks,12345qq,myshit,buttface,paradoxx,pop123,golfin,sweet69,rfghbp,sambuca,kayak1,bogus1,girlz,dallas12,millers,123456zx,operatio,pravda,eternal1,chase123,moroni,proust,blueduck,harris1,redbarch,996699,1010101,mouche,millenni,1123456,score1,1234565,1234576,eae21157,dave12,pussyy,gfif1991,1598741,hoppy,darrian,snoogins,fartface,ichbins,vfkbyrf,rusrap,2741001,fyfrjylf,aprils,favre,thisis,bannana,serval,wiggum,satsuma,matt123,ivan123,gulmira,123zxc123,oscar2,acces,annie2,dragon0,emiliano,allthat,pajaro,amandine,rawiswar,sinead,tassie,karma1,piggys,nokias,orions,origami,type40,mondo,ferrets,monker,biteme2,gauntlet,arkham,ascona,ingram01,klem1,quicksil,bingo123,blue66,plazma,onfire,shortie,spjfet,123963,thered,fire777,lobito,vball,1chicken,moosehea,elefante,babe23,jesus12,parallax,elfstone,number5,shrooms,freya,hacker1,roxette,snoops,number7,fellini,dtlmvf,chigger,mission1,mitsubis,kannan,whitedog,james01,ghjgecr,rfnfgekmnf,everythi,getnaked,prettybo,sylvan,chiller,carrera4,cowbo,biochem,azbuka,qwertyuiop1,midnight1,informat,audio1,alfred1,0range,sucker1,scott2,russland,1eagle,torben,djkrjlfd,rocky6,maddy1,bonobo,portos,chrissi,xjznq5,dexte,vdlxuc,teardrop,pktmxr,iamtheone,danijela,eyphed,suzuki1,etvww4,redtail,ranger11,mowerman,asshole2,coolkid,adriana1,bootcamp,longcut,evets,npyxr5,bighurt,bassman1,stryder,giblet,nastja,blackadd,topflite,wizar,cumnow,technolo,bassboat,bullitt,kugm7b,maksimus,wankers,mine12,sunfish,pimpin1,shearer9,user1,vjzgjxnf,tycobb,80070633pc,stanly,vitaly,shirley1,cinzia,carolyn1,angeliqu,teamo,qdarcv,aa123321,ragdoll,bonit,ladyluck,wiggly,vitara,jetbalance,12345600,ozzman,dima12345,mybuddy,shilo,satan66,erebus,warrio,090808qwe,stupi,bigdan,paul1234,chiapet,brooks1,philly1,dually,gowest,farmer1,1qa2ws3ed4rf,alberto1,beachboy,barne,aa12345,aliyah,radman,benson1,dfkthbq,highball,bonou2,i81u812,workit,darter,redhook,csfbr5yy,buttlove,episode1,ewyuza,porthos,lalal,abcd12,papero,toosexy,keeper1,silver7,jujitsu,corset,pilot123,simonsay,pinggolf,katerinka,kender,drunk1,fylhjvtlf,rashmi,nighthawk,maggy,juggernaut,larryb,cabibble,fyabcf,247365,gangstar,jaybee,verycool,123456789qw,forbidde,prufrock,12345zxc,malaika,blackbur,docker,filipe,koshechka,gemma1,djamaal,dfcbkmtdf,gangst,9988aa,ducks1,pthrfkj,puertorico,muppets,griffins,whippet,sauber,timofey,larinso,123456789zxc,quicken,qsefth,liteon,headcase,bigdadd,zxc321,maniak,jamesc,bassmast,bigdogs,1girls,123xxx,trajan,lerochka,noggin,mtndew,04975756,domin,wer123,fumanchu,lambada,thankgod,june22,kayaking,patchy,summer10,timepass,poiu1234,kondor,kakka,lament,zidane10,686xqxfg,l8v53x,caveman1,nfvthkfy,holymoly,pepita,alex1996,mifune,fighter1,asslicker,jack22,abc123abc,zaxxon,midnigh,winni,psalm23,punky,monkey22,password13,mymusic,justyna,annushka,lucky5,briann,495rus19,withlove,almaz,supergir,miata,bingbong,bradpitt,kamasutr,yfgjktjy,vanman,pegleg,amsterdam1,123a321,letmein9,shivan,korona,bmw520,annette1,scotsman,gandal,welcome12,sc00by,qpwoei,fred69,m1sf1t,hamburg1,1access,dfkmrbhbz,excalibe,boobies1,fuckhole,karamel,starfuck,star99,breakfas,georgiy,ywvxpz,smasher,fatcat1,allanon,12345n,coondog,whacko,avalon1,scythe,saab93,timon,khorne,atlast,nemisis,brady12,blenheim,52678677,mick7278,9skw5g,fleetwoo,ruger1,kissass,pussy7,scruff,12345l,bigfun,vpmfsz,yxkck878,evgeny,55667788,lickher,foothill,alesis,poppies,77777778,californi,mannie,bartjek,qhxbij,thehulk,xirt2k,angelo4ek,rfkmrekznjh,tinhorse,1david,sparky12,night1,luojianhua,bobble,nederland,rosemari,travi,minou,ciscokid,beehive,565hlgqo,alpine1,samsung123,trainman,xpress,logistic,vw198m2n,hanter,zaqwsx123,qwasz,mariachi,paska,kmg365,kaulitz,sasha12,north1,polarbear,mighty1,makeksa11,123456781,one4all,gladston,notoriou,polniypizdec110211,gosia,grandad,xholes,timofei,invalidp,speaker1,zaharov,maggiema,loislane,gonoles,br5499,discgolf,kaskad,snooper,newman1,belial,demigod,vicky1,pridurok,alex1990,tardis1,cruzer,hornie,sacramen,babycat,burunduk,mark69,oakland1,me1234,gmctruck,extacy,sexdog,putang,poppen,billyd,1qaz2w,loveable,gimlet,azwebitalia,ragtop,198500,qweas,mirela,rock123,11bravo,sprewell,tigrenok,jaredleto,vfhbif,blue2,rimjob,catwalk,sigsauer,loqse,doromich,jack01,lasombra,jonny5,newpassword,profesor,garcia1,123as123,croucher,demeter,4_life,rfhfvtkm,superman2,rogues,assword1,russia1,jeff1,mydream,z123456789,rascal1,darre,kimberl,pickle1,ztmfcq,ponchik,lovesporn,hikari,gsgba368,pornoman,chbjun,choppy,diggity,nightwolf,viktori,camar,vfhecmrf,alisa1,minstrel,wishmaster,mulder1,aleks,gogirl,gracelan,8womys,highwind,solstice,dbrnjhjdyf,nightman,pimmel,beertje,ms6nud,wwfwcw,fx3tuo,poopface,asshat,dirtyd,jiminy,luv2fuck,ptybnxtvgbjy,dragnet,pornogra,10inch,scarlet1,guido1,raintree,v123456,1aaaaaaa,maxim1935,hotwater,gadzooks,playaz,harri,brando1,defcon1,ivanna,123654a,arsenal2,candela,nt5d27,jaime1,duke1,burton1,allstar1,dragos,newpoint,albacore,1236987z,verygoodbot,1wildcat,fishy1,ptktysq,chris11,puschel,itdxtyrj,7kbe9d,serpico,jazzie,1zzzzz,kindbuds,wenef45313,1compute,tatung,sardor,gfyfcjybr,test99,toucan,meteora,lysander,asscrack,jowgnx,hevnm4,suckthis,masha123,karinka,marit,oqglh565,dragon00,vvvbbb,cheburashka,vfrfrf,downlow,unforgiven,p3e85tr,kim123,sillyboy,gold1,golfvr6,quicksan,irochka,froglegs,shortsto,caleb1,tishka,bigtitts,smurfy,bosto,dropzone,nocode,jazzbass,digdug,green7,saltlake,therat,dmitriev,lunita,deaddog,summer0,1212qq,bobbyg,mty3rh,isaac1,gusher,helloman,sugarbear,corvair,extrem,teatime,tujazopi,titanik,efyreg,jo9k2jw2,counchac,tivoli,utjvtnhbz,bebit,jacob6,clayton1,incubus1,flash123,squirter,dima2010,cock1,rawks,komatsu,forty2,98741236,cajun1,madelein,mudhoney,magomed,q111111,qaswed,consense,12345b,bakayaro,silencer,zoinks,bigdic,werwolf,pinkpuss,96321478,alfie1,ali123,sarit,minette,musics,chato,iaapptfcor,cobaka,strumpf,datnigga,sonic123,yfnecbr,vjzctvmz,pasta1,tribbles,crasher,htlbcrf,1tiger,shock123,bearshar,syphon,a654321,cubbies1,jlhanes,eyespy,fucktheworld,carrie1,bmw325is,suzuk,mander,dorina,mithril,hondo1,vfhnbyb,sachem,newton1,12345x,7777755102q,230857z,xxxsex,scubapro,hayastan,spankit,delasoul,searock6,fallout3,nilrem,24681357,pashka,voluntee,pharoh,willo,india1,badboy69,roflmao,gunslinger,lovergir,mama12,melange,640xwfkv,chaton,darkknig,bigman1,aabbccdd,harleyd,birdhouse,giggsy,hiawatha,tiberium,joker7,hello1234,sloopy,tm371855,greendog,solar1,bignose,djohn11,espanol,oswego,iridium,kavitha,pavell,mirjam,cyjdsvujljv,alpha5,deluge,hamme,luntik,turismo,stasya,kjkbnf,caeser,schnecke,tweety1,tralfaz,lambrett,prodigy1,trstno1,pimpshit,werty1,karman,bigboob,pastel,blackmen,matthew8,moomin,q1w2e,gilly,primaver,jimmyg,house2,elviss,15975321,1jessica,monaliza,salt55,vfylfhbyrf,harley11,tickleme,murder1,nurgle,kickass1,theresa1,fordtruck,pargolf,managua,inkognito,sherry1,gotit,friedric,metro2033,slk230,freeport,cigarett,492529,vfhctkm,thebeach,twocats,bakugan,yzerman1,charlieb,motoko,skiman,1234567w,pussy3,love77,asenna,buffie,260zntpc,kinkos,access20,mallard1,fuckyou69,monami,rrrrr1,bigdog69,mikola,1boomer,godzila,ginger2,dima2000,skorpion39,dima1234,hawkdog79,warrior2,ltleirf,supra1,jerusale,monkey01,333z333,666888,kelsey1,w8gkz2x1,fdfnfh,msnxbi,qwe123rty,mach1,monkey3,123456789qq,c123456,nezabudka,barclays,nisse,dasha1,12345678987654321,dima1993,oldspice,frank2,rabbitt,prettyboy,ov3ajy,iamthema,kawasak,banjo1,gtivr6,collants,gondor,hibees,cowboys2,codfish,buster2,purzel,rubyred,kayaker,bikerboy,qguvyt,masher,sseexx,kenshiro,moonglow,semenova,rosari,eduard1,deltaforce,grouper,bongo1,tempgod,1taylor,goldsink,qazxsw1,1jesus,m69fg2w,maximili,marysia,husker1,kokanee,sideout,googl,south1,plumber1,trillian,00001,1357900,farkle,1xxxxx,pascha,emanuela,bagheera,hound1,mylov,newjersey,swampfox,sakic19,torey,geforce,wu4etd,conrail,pigman,martin2,ber02,nascar2,angel69,barty,kitsune,cornet,yes90125,goomba,daking,anthea,sivart,weather1,ndaswf,scoubidou,masterchief,rectum,3364068,oranges1,copter,1samanth,eddies,mimoza,ahfywbz,celtic88,86mets,applemac,amanda11,taliesin,1angel,imhere,london11,bandit12,killer666,beer1,06225930,psylocke,james69,schumach,24pnz6kc,endymion,wookie1,poiu123,birdland,smoochie,lastone,rclaki,olive1,pirat,thunder7,chris69,rocko,151617,djg4bb4b,lapper,ajcuivd289,colole57,shadow7,dallas21,ajtdmw,executiv,dickies,omegaman,jason12,newhaven,aaaaaas,pmdmscts,s456123789,beatri,applesauce,levelone,strapon,benladen,creaven,ttttt1,saab95,f123456,pitbul,54321a,sex12345,robert3,atilla,mevefalkcakk,1johnny,veedub,lilleke,nitsuj,5t6y7u8i,teddys,bluefox,nascar20,vwjetta,buffy123,playstation3,loverr,qweasd12,lover2,telekom,benjamin1,alemania,neutrino,rockz,valjean,testicle,trinity3,realty,firestarter,794613852,ardvark,guadalup,philmont,arnold1,holas,zw6syj,birthday299,dover1,sexxy1,gojets,741236985,cance,blue77,xzibit,qwerty88,komarova,qweszxc,footer,rainger,silverst,ghjcnb,catmando,tatooine,31217221027711,amalgam,69dude,qwerty321,roscoe1,74185,cubby,alfa147,perry1,darock,katmandu,darknight,knicks1,freestuff,45454,kidman,4tlved,axlrose,cutie1,quantum1,joseph10,ichigo,pentium3,rfhectkm,rowdy1,woodsink,justforfun,sveta123,pornografia,mrbean,bigpig,tujheirf,delta9,portsmou,hotbod,kartal,10111213,fkbyf001,pavel1,pistons1,necromancer,verga,c7lrwu,doober,thegame1,hatesyou,sexisfun,1melissa,tuczno18,bowhunte,gobama,scorch,campeon,bruce2,fudge1,herpderp,bacon1,redsky,blackeye,19966991,19992000,ripken8,masturba,34524815,primax,paulina1,vp6y38,427cobra,4dwvjj,dracon,fkg7h4f3v6,longview,arakis,panama1,honda2,lkjhgfdsaz,razors,steels,fqkw5m,dionysus,mariajos,soroka,enriqu,nissa,barolo,king1234,hshfd4n279,holland1,flyer1,tbones,343104ky,modems,tk421,ybrbnrf,pikapp,sureshot,wooddoor,florida2,mrbungle,vecmrf,catsdogs,axolotl,nowayout,francoi,chris21,toenail,hartland,asdjkl,nikkii,onlyyou,buckskin,fnord,flutie,holen1,rincewind,lefty1,ducky1,199000,fvthbrf,redskin1,ryno23,lostlove,19mtpgam19,abercrom,benhur,jordan11,roflcopter,ranma,phillesh,avondale,igromania,p4ssword,jenny123,tttttt1,spycams,cardigan,2112yyz,sleepy1,paris123,mopars,lakers34,hustler1,james99,matrix3,popimp,12pack,eggbert,medvedev,testit,performa,logitec,marija,sexybeast,supermanboy,iwantit,rjktcj,jeffer,svarog,halo123,whdbtp,nokia3230,heyjoe,marilyn1,speeder,ibxnsm,prostock,bennyboy,charmin,codydog,parol999,ford9402,jimmer,crayola,159357258,alex77,joey1,cayuga,phish420,poligon,specops,tarasova,caramelo,draconis,dimon,cyzkhw,june29,getbent,1guitar,jimjam,dictiona,shammy,flotsam,0okm9ijn,crapper,technic,fwsadn,rhfdxtyrj,zaq11qaz,anfield1,159753q,curious1,hip-hop,1iiiii,gfhjkm2,cocteau,liveevil,friskie,crackhead,b1afra,elektrik,lancer1,b0ll0cks,jasond,z1234567,tempest1,alakazam,asdfasd,duffy1,oneday,dinkle,qazedctgb,kasimir,happy7,salama,hondaciv,nadezda,andretti,cannondale,sparticu,znbvjd,blueice,money01,finster,eldar,moosie,pappa,delta123,neruda,bmw330ci,jeanpaul,malibu1,alevtina,sobeit,travolta,fullmetal,enamorad,mausi,boston12,greggy,smurf1,ratrace,ichiban,ilovepus,davidg,wolf69,villa1,cocopuff,football12,starfury,zxc12345,forfree,fairfiel,dreams1,tayson,mike2,dogday,hej123,oldtimer,sanpedro,clicker,mollycat,roadstar,golfe,lvbnhbq1,topdevice,a1b2c,sevastopol,calli,milosc,fire911,pink123,team3x,nolimit5,snickers1,annies,09877890,jewel1,steve69,justin11,autechre,killerbe,browncow,slava1,christer,fantomen,redcloud,elenberg,beautiful1,passw0rd1,nazira,advantag,cockring,chaka,rjpzdrf,99941,az123456,biohazar,energie,bubble1,bmw323,tellme,printer1,glavine,1starwar,coolbeans,april17,carly1,quagmire,admin2,djkujuhfl,pontoon,texmex,carlos12,thermo,vaz2106,nougat,bob666,1hockey,1john,cricke,qwerty10,twinz,totalwar,underwoo,tijger,lildevil,123q321,germania,freddd,1scott,beefy,5t4r3e2w1q,fishbait,nobby,hogger,dnstuff,jimmyc,redknapp,flame1,tinfloor,balla,nfnfhby,yukon1,vixens,batata,danny123,1zxcvbnm,gaetan,homewood,greats,tester1,green99,1fucker,sc0tland,starss,glori,arnhem,goatman,1234asd,supertra,bill123,elguapo,sexylegs,jackryan,usmc69,innow,roaddog,alukard,winter11,crawler,gogiants,rvd420,alessandr,homegrow,gobbler,esteba,valeriy,happy12,1joshua,hawking,sicnarf,waynes,iamhappy,bayadera,august2,sashas,gotti,dragonfire,pencil1,halogen,borisov,bassingw,15975346,zachar,sweetp,soccer99,sky123,flipyou,spots3,xakepy,cyclops1,dragon77,rattolo58,motorhea,piligrim,helloween,dmb2010,supermen,shad0w,eatcum,sandokan,pinga,ufkfrnbrf,roksana,amista,pusser,sony1234,azerty1,1qasw2,ghbdt,q1w2e3r4t5y6u7i8,ktutylf,brehznev,zaebali,shitass,creosote,gjrtvjy,14938685,naughtyboy,pedro123,21crack,maurice1,joesakic,nicolas1,matthew9,lbyfhf,elocin,hfcgbplzq,pepper123,tiktak,mycroft,ryan11,firefly1,arriva,cyecvevhbr,loreal,peedee,jessica8,lisa01,anamari,pionex,ipanema,airbag,frfltvbz,123456789aa,epwr49,casper12,sweethear,sanandreas,wuschel,cocodog,france1,119911,redroses,erevan,xtvgbjy,bigfella,geneve,volvo850,evermore,amy123,moxie,celebs,geeman,underwor,haslo1,joy123,hallow,chelsea0,12435687,abarth,12332145,tazman1,roshan,yummie,genius1,chrisd,ilovelife,seventy7,qaz1wsx2,rocket88,gaurav,bobbyboy,tauchen,roberts1,locksmit,masterof,www111,d9ungl,volvos40,asdasd1,golfers,jillian1,7xm5rq,arwpls4u,gbhcf2,elloco,football2,muerte,bob101,sabbath1,strider1,killer66,notyou,lawnboy,de7mdf,johnnyb,voodoo2,sashaa,homedepo,bravos,nihao123,braindea,weedhead,rajeev,artem1,camille1,rockss,bobbyb,aniston,frnhbcf,oakridge,biscayne,cxfcnm,dressage,jesus3,kellyann,king69,juillet,holliste,h00ters,ripoff,123645,1999ar,eric12,123777,tommi,dick12,bilder,chris99,rulezz,getpaid,chicubs,ender1,byajhvfnbrf,milkshak,sk8board,freakshow,antonella,monolit,shelb,hannah01,masters1,pitbull1,1matthew,luvpussy,agbdlcid,panther2,alphas,euskadi,8318131,ronnie1,7558795,sweetgirl,cookie59,sequoia,5552555,ktyxbr,4500455,money7,severus,shinobu,dbityrf,phisig,rogue2,fractal,redfred,sebastian1,nelli,b00mer,cyberman,zqjphsyf6ctifgu,oldsmobile,redeemer,pimpi,lovehurts,1slayer,black13,rtynfdh,airmax,g00gle,1panther,artemon,nopasswo,fuck1234,luke1,trinit,666000,ziadma,oscardog,davex,hazel1,isgood,demond,james5,construc,555551,january2,m1911a1,flameboy,merda,nathan12,nicklaus,dukester,hello99,scorpio7,leviathan,dfcbktr,pourquoi,vfrcbv123,shlomo,rfcgth,rocky3,ignatz,ajhneyf,roger123,squeek,4815162342a,biskit,mossimo,soccer21,gridlock,lunker,popstar,ghhh47hj764,chutney,nitehawk,vortec,gamma1,codeman,dragula,kappasig,rainbow2,milehigh,blueballs,ou8124me,rulesyou,collingw,mystere,aster,astrovan,firetruck,fische,crawfish,hornydog,morebeer,tigerpaw,radost,144000,1chance,1234567890qwe,gracie1,myopia,oxnard,seminoles,evgeni,edvard,partytim,domani,tuffy1,jaimatadi,blackmag,kzueirf,peternor,mathew1,maggie12,henrys,k1234567,fasted,pozitiv,cfdtkbq,jessica7,goleafs,bandito,girl78,sharingan,skyhigh,bigrob,zorros,poopers,oldschoo,pentium2,gripper,norcal,kimba,artiller,moneymak,00197400,272829,shadow1212,thebull,handbags,all4u2c,bigman2,civics,godisgoo,section8,bandaid,suzanne1,zorba,159123,racecars,i62gbq,rambo123,ironroad,johnson2,knobby,twinboys,sausage1,kelly69,enter2,rhjirf,yessss,james12,anguilla,boutit,iggypop,vovochka,06060,budwiser,romuald,meditate,good1,sandrin,herkules,lakers8,honeybea,11111111a,miche,rangers9,lobster1,seiko,belova,midcon,mackdadd,bigdaddy1,daddie,sepultur,freddy12,damon1,stormy1,hockey2,bailey12,hedimaptfcor,dcowboys,sadiedog,thuggin,horny123,josie1,nikki2,beaver69,peewee1,mateus,viktorija,barrys,cubswin1,matt1234,timoxa,rileydog,sicilia,luckycat,candybar,julian1,abc456,pussylip,phase1,acadia,catty,246800,evertonf,bojangle,qzwxec,nikolaj,fabrizi,kagome,noncapa0,marle,popol,hahaha1,cossie,carla10,diggers,spankey,sangeeta,cucciolo,breezer,starwar1,cornholio,rastafari,spring99,yyyyyyy1,webstar,72d5tn,sasha1234,inhouse,gobuffs,civic1,redstone,234523,minnie1,rivaldo,angel5,sti2000,xenocide,11qq11,1phoenix,herman1,holly123,tallguy,sharks1,madri,superbad,ronin,jalal123,hardbody,1234567r,assman1,vivahate,buddylee,38972091,bonds25,40028922,qrhmis,wp2005,ceejay,pepper01,51842543,redrum1,renton,varadero,tvxtjk7r,vetteman,djhvbrc,curly1,fruitcak,jessicas,maduro,popmart,acuari,dirkpitt,buick1,bergerac,golfcart,pdtpljxrf,hooch1,dudelove,d9ebk7,123452000,afdjhbn,greener,123455432,parachut,mookie12,123456780,jeepcj5,potatoe,sanya,qwerty2010,waqw3p,gotika,freaky1,chihuahu,buccanee,ecstacy,crazyboy,slickric,blue88,fktdnbyf,2004rj,delta4,333222111,calient,ptbdhw,1bailey,blitz1,sheila1,master23,hoagie,pyf8ah,orbita,daveyboy,prono1,delta2,heman,1horny,tyrik123,ostrov,md2020,herve,rockfish,el546218,rfhbyjxrf,chessmaster,redmoon,lenny1,215487,tomat,guppy,amekpass,amoeba,my3girls,nottingh,kavita,natalia1,puccini,fabiana,8letters,romeos,netgear,casper2,taters,gowings,iforgot1,pokesmot,pollit,lawrun,petey1,rosebuds,007jr,gthtcnhjqrf,k9dls02a,neener,azertyu,duke11,manyak,tiger01,petros,supermar,mangas,twisty,spotter,takagi,dlanod,qcmfd454,tusymo,zz123456,chach,navyblue,gilbert1,2kash6zq,avemaria,1hxboqg2s,viviane,lhbjkjubz2957704,nowwowtg,1a2b3c4,m0rn3,kqigb7,superpuper,juehtw,gethigh,theclown,makeme,pradeep,sergik,deion21,nurik,devo2706,nbvibt,roman222,kalima,nevaeh,martin7,anathema,florian1,tamwsn3sja,dinmamma,133159,123654q,slicks,pnp0c08,yojimbo,skipp,kiran,pussyfuck,teengirl,apples12,myballs,angeli,1234a,125678,opelastra,blind1,armagedd,fish123,pitufo,chelseaf,thedevil,nugget1,cunt69,beetle1,carter15,apolon,collant,password00,fishboy,djkrjdf,deftone,celti,three11,cyrus1,lefthand,skoal1,ferndale,aries1,fred01,roberta1,chucks,cornbread,lloyd1,icecrea,cisco123,newjerse,vfhrbpf,passio,volcom1,rikimaru,yeah11,djembe,facile,a1l2e3x4,batman7,nurbol,lorenzo1,monica69,blowjob1,998899,spank1,233391,n123456,1bear,bellsout,999998,celtic67,sabre1,putas,y9enkj,alfabeta,heatwave,honey123,hard4u,insane1,xthysq,magnum1,lightsaber,123qweqwe,fisher1,pixie1,precios,benfic,thegirls,bootsman,4321rewq,nabokov,hightime,djghjc,1chelsea,junglist,august16,t3fkvkmj,1232123,lsdlsd12,chuckie1,pescado,granit,toogood,cathouse,natedawg,bmw530,123kid,hajime,198400,engine1,wessonnn,kingdom1,novembre,1rocks,kingfisher,qwerty89,jordan22,zasranec,megat,sucess,installutil,fetish01,yanshi1982,1313666,1314520,clemence,wargod,time1,newzealand,snaker,13324124,cfrehf,hepcat,mazahaka,bigjay,denisov,eastwest,1yellow,mistydog,cheetos,1596357,ginger11,mavrik,bubby1,bhbyf,pyramide,giusepp,luthien,honda250,andrewjackie,kentavr,lampoon,zaq123wsx,sonicx,davidh,1ccccc,gorodok,windsong,programm,blunt420,vlad1995,zxcvfdsa,tarasov,mrskin,sachas,mercedes1,koteczek,rawdog,honeybear,stuart1,kaktys,richard7,55555n,azalia,hockey10,scouter,francy,1xxxxxx,julie456,tequilla,penis123,schmoe,tigerwoods,1ferrari,popov,snowdrop,matthieu,smolensk,cornflak,jordan01,love2000,23wesdxc,kswiss,anna2000,geniusnet,baby2000,33ds5x,waverly,onlyone4,networkingpe,raven123,blesse,gocards,wow123,pjflkork,juicey,poorboy,freeee,billybo,shaheen,zxcvbnm.,berlit,truth1,gepard,ludovic,gunther1,bobby2,bob12345,sunmoon,septembr,bigmac1,bcnjhbz,seaking,all4u,12qw34er56ty,bassie,nokia5228,7355608,sylwia,charvel,billgate,davion,chablis,catsmeow,kjiflrf,amylynn,rfvbkkf,mizredhe,handjob,jasper12,erbol,solara,bagpipe,biffer,notime,erlan,8543852,sugaree,oshkosh,fedora,bangbus,5lyedn,longball,teresa1,bootyman,aleksand,qazwsxedc12,nujbhc,tifosi,zpxvwy,lights1,slowpoke,tiger12,kstate,password10,alex69,collins1,9632147,doglover,baseball2,security1,grunts,orange2,godloves,213qwe879,julieb,1qazxsw23edcvfr4,noidea,8uiazp,betsy1,junior2,parol123,123456zz,piehonkii,kanker,bunky,hingis,reese1,qaz123456,sidewinder,tonedup,footsie,blackpoo,jalapeno,mummy1,always1,josh1,rockyboy,plucky,chicag,nadroj,blarney,blood123,wheaties,packer1,ravens1,mrjones,gfhjkm007,anna2010,awatar,guitar12,hashish,scale1,tomwaits,amrita,fantasma,rfpfym,pass2,tigris,bigair,slicker,sylvi,shilpa,cindylou,archie1,bitches1,poppys,ontime,horney1,camaroz28,alladin,bujhm,cq2kph,alina1,wvj5np,1211123a,tetons,scorelan,concordi,morgan2,awacs,shanty,tomcat14,andrew123,bear69,vitae,fred99,chingy,octane,belgario,fatdaddy,rhodan,password23,sexxes,boomtown,joshua01,war3demo,my2kids,buck1,hot4you,monamour,12345aa,yumiko,parool,carlton1,neverland,rose12,right1,sociald,grouse,brandon0,cat222,alex00,civicex,bintang,malkav,arschloc,dodgeviper,qwerty666,goduke,dante123,boss1,ontheroc,corpsman,love14,uiegu451,hardtail,irondoor,ghjrehfnehf,36460341,konijn,h2slca,kondom25,123456ss,cfytxrf,btnjey,nando,freemail,comander,natas666,siouxsie,hummer1,biomed,dimsum,yankees0,diablo666,lesbian1,pot420,jasonm,glock23,jennyb,itsmine,lena2010,whattheh,beandip,abaddon,kishore,signup,apogee,biteme12,suzieq,vgfun4,iseeyou,rifleman,qwerta,4pussy,hawkman,guest1,june17,dicksuck,bootay,cash12,bassale,ktybyuhfl,leetch,nescafe,7ovtgimc,clapton1,auror,boonie,tracker1,john69,bellas,cabinboy,yonkers,silky1,ladyffesta,drache,kamil1,davidp,bad123,snoopy12,sanche,werthvfy,achille,nefertiti,gerald1,slage33,warszawa,macsan26,mason123,kotopes,welcome8,nascar99,kiril,77778888,hairy1,monito,comicsans,81726354,killabee,arclight,yuo67,feelme,86753099,nnssnn,monday12,88351132,88889999,websters,subito,asdf12345,vaz2108,zvbxrpl,159753456852,rezeda,multimed,noaccess,henrique,tascam,captiva,zadrot,hateyou,sophie12,123123456,snoop1,charlie8,birmingh,hardline,libert,azsxdcf,89172735872,rjpthju,bondar,philips1,olegnaruto,myword,yakman,stardog,banana12,1234567890w,farout,annick,duke01,rfj422,billard,glock19,shaolin1,master10,cinderel,deltaone,manning1,biggreen,sidney1,patty1,goforit1,766rglqy,sevendus,aristotl,armagedo,blumen,gfhfyjz,kazakov,lekbyxxx,accord1,idiota,soccer16,texas123,victoire,ololo,chris01,bobbbb,299792458,eeeeeee1,confiden,07070,clarks,techno1,kayley,stang1,wwwwww1,uuuuu1,neverdie,jasonr,cavscout,481516234,mylove1,shaitan,1qazxcvb,barbaros,123456782000,123wer,thissucks,7seven,227722,faerie,hayduke,dbacks,snorkel,zmxncbv,tiger99,unknown1,melmac,polo1234,sssssss1,1fire,369147,bandung,bluejean,nivram,stanle,ctcnhf,soccer20,blingbli,dirtball,alex2112,183461,skylin,boobman,geronto,brittany1,yyz2112,gizmo69,ktrcec,dakota12,chiken,sexy11,vg08k714,bernadet,1bulldog,beachs,hollyb,maryjoy,margo1,danielle1,chakra,alexand,hullcity,matrix12,sarenna,pablos,antler,supercar,chomsky,german1,airjordan,545ettvy,camaron,flight1,netvideo,tootall,valheru,481516,1234as,skimmer,redcross,inuyash,uthvfy,1012nw,edoardo,bjhgfi,golf11,9379992a,lagarto,socball,boopie,krazy,.adgjmptw,gaydar,kovalev,geddylee,firstone,turbodog,loveee,135711,badbo,trapdoor,opopop11,danny2,max2000,526452,kerry1,leapfrog,daisy2,134kzbip,1andrea,playa1,peekab00,heskey,pirrello,gsewfmck,dimon4ik,puppie,chelios,554433,hypnodanny,fantik,yhwnqc,ghbdtngjrf,anchorag,buffett1,fanta,sappho,024680,vialli,chiva,lucylu,hashem,exbntkm,thema,23jordan,jake11,wildside,smartie,emerica,2wj2k9oj,ventrue,timoth,lamers,baerchen,suspende,boobis,denman85,1adam12,otello,king12,dzakuni,qsawbbs,isgay,porno123,jam123,daytona1,tazzie,bunny123,amaterasu,jeffre,crocus,mastercard,bitchedup,chicago7,aynrand,intel1,tamila,alianza,mulch,merlin12,rose123,alcapone,mircea,loveher,joseph12,chelsea6,dorothy1,wolfgar,unlimite,arturik,qwerty3,paddy1,piramid,linda123,cooool,millie1,warlock1,forgotit,tort02,ilikeyou,avensis,loveislife,dumbass1,clint1,2110se,drlove,olesia,kalinina,sergey123,123423,alicia1,markova,tri5a3,media1,willia1,xxxxxxx1,beercan,smk7366,jesusislord,motherfuck,smacker,birthday5,jbaby,harley2,hyper1,a9387670a,honey2,corvet,gjmptw,rjhjkmbien,apollon,madhuri,3a5irt,cessna17,saluki,digweed,tamia1,yja3vo,cfvlehfr,1111111q,martyna,stimpy1,anjana,yankeemp,jupiler,idkfa,1blue,fromv,afric,3xbobobo,liverp00l,nikon1,amadeus1,acer123,napoleo,david7,vbhjckfdf,mojo69,percy1,pirates1,grunt1,alenushka,finbar,zsxdcf,mandy123,1fred,timewarp,747bbb,druids,julia123,123321qq,spacebar,dreads,fcbarcelona,angela12,anima,christopher1,stargazer,123123s,hockey11,brewski,marlbor,blinker,motorhead,damngood,werthrf,letmein3,moremoney,killer99,anneke,eatit,pilatus,andrew01,fiona1,maitai,blucher,zxgdqn,e5pftu,nagual,panic1,andron,openwide,alphabeta,alison1,chelsea8,fende,mmm666,1shot2,a19l1980,123456@,1black,m1chael,vagner,realgood,maxxx,vekmnbr,stifler,2509mmh,tarkan,sherzod,1234567b,gunners1,artem2010,shooby,sammie1,p123456,piggie,abcde12345,nokia6230,moldir,piter,1qaz3edc,frequenc,acuransx,1star,nikeair,alex21,dapimp,ranjan,ilovegirls,anastasiy,berbatov,manso,21436587,leafs1,106666,angelochek,ingodwetrust,123456aaa,deano,korsar,pipetka,thunder9,minka,himura,installdevic,1qqqqq,digitalprodu,suckmeoff,plonker,headers,vlasov,ktr1996,windsor1,mishanya,garfield1,korvin,littlebit,azaz09,vandamme,scripto,s4114d,passward,britt1,r1chard,ferrari5,running1,7xswzaq,falcon2,pepper76,trademan,ea53g5,graham1,volvos80,reanimator,micasa,1234554321q,kairat,escorpion,sanek94,karolina1,kolovrat,karen2,1qaz@wsx,racing1,splooge,sarah2,deadman1,creed1,nooner,minicoop,oceane,room112,charme,12345ab,summer00,wetcunt,drewman,nastyman,redfire,appels,merlin69,dolfin,bornfree,diskette,ohwell,12345678qwe,jasont,madcap,cobra2,dolemit1,whatthehell,juanit,voldemar,rocke,bianc,elendil,vtufgjkbc,hotwheels,spanis,sukram,pokerface,k1ller,freakout,dontae,realmadri,drumss,gorams,258789,snakey,jasonn,whitewolf,befree,johnny99,pooka,theghost,kennys,vfvektxrf,toby1,jumpman23,deadlock,barbwire,stellina,alexa1,dalamar,mustanggt,northwes,tesoro,chameleo,sigtau,satoshi,george11,hotcum,cornell1,golfer12,geek01d,trololo,kellym,megapolis,pepsi2,hea666,monkfish,blue52,sarajane,bowler1,skeets,ddgirls,hfccbz,bailey01,isabella1,dreday,moose123,baobab,crushme,000009,veryhot,roadie,meanone,mike18,henriett,dohcvtec,moulin,gulnur,adastra,angel9,western1,natura,sweetpe,dtnfkm,marsbar,daisys,frogger1,virus1,redwood1,streetball,fridolin,d78unhxq,midas,michelob,cantik,sk2000,kikker,macanudo,rambone,fizzle,20000,peanuts1,cowpie,stone32,astaroth,dakota01,redso,mustard1,sexylove,giantess,teaparty,bobbin,beerbong,monet1,charles3,anniedog,anna1988,cameleon,longbeach,tamere,qpful542,mesquite,waldemar,12345zx,iamhere,lowboy,canard,granp,daisymay,love33,moosejaw,nivek,ninjaman,shrike01,aaa777,88002000600,vodolei,bambush,falcor,harley69,alphaomega,severine,grappler,bosox,twogirls,gatorman,vettes,buttmunch,chyna,excelsio,crayfish,birillo,megumi,lsia9dnb9y,littlebo,stevek,hiroyuki,firehous,master5,briley2,gangste,chrisk,camaleon,bulle,troyboy,froinlaven,mybutt,sandhya,rapala,jagged,crazycat,lucky12,jetman,wavmanuk,1heather,beegee,negril,mario123,funtime1,conehead,abigai,mhorgan,patagoni,travel1,backspace,frenchfr,mudcat,dashenka,baseball3,rustys,741852kk,dickme,baller23,griffey1,suckmycock,fuhrfzgc,jenny2,spuds,berlin1,justfun,icewind,bumerang,pavlusha,minecraft123,shasta1,ranger12,123400,twisters,buthead,miked,finance1,dignity7,hello9,lvjdp383,jgthfnjh,dalmatio,paparoach,miller31,2bornot2b,fathe,monterre,theblues,satans,schaap,jasmine2,sibelius,manon,heslo,jcnhjd,shane123,natasha2,pierrot,bluecar,iloveass,harriso,red12,london20,job314,beholder,reddawg,fuckyou!,pussylick,bologna1,austintx,ole4ka,blotto,onering,jearly,balbes,lightbul,bighorn,crossfir,lee123,prapor,1ashley,gfhjkm22,wwe123,09090,sexsite,marina123,jagua,witch1,schmoo,parkview,dragon3,chilango,ultimo,abramova,nautique,2bornot2,duende,1arthur,nightwing,surfboar,quant4307,15s9pu03,karina1,shitball,walleye1,wildman1,whytesha,1morgan,my2girls,polic,baranova,berezuckiy,kkkkkk1,forzima,fornow,qwerty02,gokart,suckit69,davidlee,whatnow,edgard,tits1,bayshore,36987412,ghbphfr,daddyy,explore1,zoidberg,5qnzjx,morgane,danilov,blacksex,mickey12,balsam,83y6pv,sarahc,slaye,all4u2,slayer69,nadia1,rlzwp503,4cranker,kaylie,numberon,teremok,wolf12,deeppurple,goodbeer,aaa555,66669999,whatif,harmony1,ue8fpw,3tmnej,254xtpss,dusty197,wcksdypk,zerkalo,dfnheirf,motorol,digita,whoareyou,darksoul,manics,rounders,killer11,d2000lb,cegthgfhjkm,catdog1,beograd,pepsico,julius1,123654987,softbal,killer23,weasel1,lifeson,q123456q,444555666,bunches,andy1,darby1,service01,bear11,jordan123,amega,duncan21,yensid,lerxst,rassvet,bronco2,fortis,pornlove,paiste,198900,asdflkjh,1236547890,futur,eugene1,winnipeg261,fk8bhydb,seanjohn,brimston,matthe1,bitchedu,crisco,302731,roxydog,woodlawn,volgograd,ace1210,boy4u2ownnyc,laura123,pronger,parker12,z123456z,andrew13,longlife,sarang,drogba,gobruins,soccer4,holida,espace,almira,murmansk,green22,safina,wm00022,1chevy,schlumpf,doroth,ulises,golf99,hellyes,detlef,mydog,erkina,bastardo,mashenka,sucram,wehttam,generic1,195000,spaceboy,lopas123,scammer,skynyrd,daddy2,titani,ficker,cr250r,kbnthfnehf,takedown,sticky1,davidruiz,desant,nremtp,painter1,bogies,agamemno,kansas1,smallfry,archi,2b4dnvsx,1player,saddie,peapod,6458zn7a,qvw6n2,gfxqx686,twice2,sh4d0w3d,mayfly,375125,phitau,yqmbevgk,89211375759,kumar1,pfhfpf,toyboy,way2go,7pvn4t,pass69,chipster,spoony,buddycat,diamond3,rincewin,hobie,david01,billbo,hxp4life,matild,pokemon2,dimochka,clown1,148888,jenmt3,cuxldv,cqnwhy,cde34rfv,simone1,verynice,toobig,pasha123,mike00,maria2,lolpop,firewire,dragon9,martesana,a1234567890,birthday3,providen,kiska,pitbulls,556655,misawa,damned69,martin11,goldorak,gunship,glory1,winxclub,sixgun,splodge,agent1,splitter,dome69,ifghjb,eliza1,snaiper,wutang36,phoenix7,666425,arshavin,paulaner,namron,m69fg1w,qwert1234,terrys,zesyrmvu,joeman,scoots,dwml9f,625vrobg,sally123,gostoso,symow8,pelota,c43qpul5rz,majinbuu,lithium1,bigstuff,horndog1,kipelov,kringle,1beavis,loshara,octobe,jmzacf,12342000,qw12qw,runescape1,chargers1,krokus,piknik,jessy,778811,gjvbljh,474jdvff,pleaser,misskitty,breaker1,7f4df451,dayan,twinky,yakumo,chippers,matia,tanith,len2ski1,manni,nichol1,f00b4r,nokia3110,standart,123456789i,shami,steffie,larrywn,chucker,john99,chamois,jjjkkk,penmouse,ktnj2010,gooners,hemmelig,rodney1,merlin01,bearcat1,1yyyyy,159753z,1fffff,1ddddd,thomas11,gjkbyrf,ivanka,f1f2f3,petrovna,phunky,conair,brian2,creative1,klipsch,vbitymrf,freek,breitlin,cecili,westwing,gohabsgo,tippmann,1steve,quattro6,fatbob,sp00ky,rastas,1123581,redsea,rfnmrf,jerky1,1aaaaaa,spk666,simba123,qwert54321,123abcd,beavis69,fyfyfc,starr1,1236547,peanutbutter,sintra,12345abcde,1357246,abcde1,climbon,755dfx,mermaids,monte1,serkan,geilesau,777win,jasonc,parkside,imagine1,rockhead,producti,playhard,principa,spammer,gagher,escada,tsv1860,dbyjuhfl,cruiser1,kennyg,montgome,2481632,pompano,cum123,angel6,sooty,bear01,april6,bodyhamm,pugsly,getrich,mikes,pelusa,fosgate,jasonp,rostislav,kimberly1,128mo,dallas11,gooner1,manuel1,cocacola1,imesh,5782790,password8,daboys,1jones,intheend,e3w2q1,whisper1,madone,pjcgujrat,1p2o3i,jamesp,felicida,nemrac,phikap,firecat,jrcfyjxrf,matt12,bigfan,doedel,005500,jasonx,1234567k,badfish,goosey,utjuhfabz,wilco,artem123,igor123,spike123,jor23dan,dga9la,v2jmsz,morgan12,avery1,dogstyle,natasa,221195ws,twopac,oktober7,karthik,poop1,mightymo,davidr,zermatt,jehova,aezakmi1,dimwit,monkey5,serega123,qwerty111,blabl,casey22,boy123,1clutch,asdfjkl1,hariom,bruce10,jeep95,1smith,sm9934,karishma,bazzzz,aristo,669e53e1,nesterov,kill666,fihdfv,1abc2,anna1,silver11,mojoman,telefono,goeagles,sd3lpgdr,rfhfynby,melinda1,llcoolj,idteul,bigchief,rocky13,timberwo,ballers,gatekeep,kashif,hardass,anastasija,max777,vfuyjkbz,riesling,agent99,kappas,dalglish,tincan,orange3,turtoise,abkbvjy,mike24,hugedick,alabala,geolog,aziza,devilboy,habanero,waheguru,funboy,freedom5,natwest,seashore,impaler,qwaszx1,pastas,bmw535,tecktonik,mika00,jobsearc,pinche,puntang,aw96b6,1corvett,skorpio,foundati,zzr1100,gembird,vfnhjcrby,soccer18,vaz2110,peterp,archer1,cross1,samedi,dima1992,hunter99,lipper,hotbody,zhjckfdf,ducati1,trailer1,04325956,cheryl1,benetton,kononenko,sloneczko,rfgtkmrf,nashua,balalaika,ampere,eliston,dorsai,digge,flyrod,oxymoron,minolta,ironmike,majortom,karimov,fortun,putaria,an83546921an13,blade123,franchis,mxaigtg5,dynxyu,devlt4,brasi,terces,wqmfuh,nqdgxz,dale88,minchia,seeyou,housepen,1apple,1buddy,mariusz,bighouse,tango2,flimflam,nicola1,qwertyasd,tomek1,shumaher,kartoshka,bassss,canaries,redman1,123456789as,preciosa,allblacks,navidad,tommaso,beaudog,forrest1,green23,ryjgjxrf,go4it,ironman2,badnews,butterba,1grizzly,isaeva,rembrand,toront,1richard,bigjon,yfltymrf,1kitty,4ng62t,littlejo,wolfdog,ctvtyjd,spain1,megryan,tatertot,raven69,4809594q,tapout,stuntman,a131313,lagers,hotstuf,lfdbl11,stanley2,advokat,boloto,7894561,dooker,adxel187,cleodog,4play,0p9o8i,masterb,bimota,charlee,toystory,6820055,6666667,crevette,6031769,corsa,bingoo,dima1990,tennis11,samuri,avocado,melissa6,unicor,habari,metart,needsex,cockman,hernan,3891576,3334444,amigo1,gobuffs2,mike21,allianz,2835493,179355,midgard,joey123,oneluv,ellis1,towncar,shonuff,scouse,tool69,thomas19,chorizo,jblaze,lisa1,dima1999,sophia1,anna1989,vfvekbxrf,krasavica,redlegs,jason25,tbontb,katrine,eumesmo,vfhufhbnrf,1654321,asdfghj1,motdepas,booga,doogle,1453145,byron1,158272,kardinal,tanne,fallen1,abcd12345,ufyljy,n12345,kucing,burberry,bodger,1234578,februar,1234512,nekkid,prober,harrison1,idlewild,rfnz90,foiegras,pussy21,bigstud,denzel,tiffany2,bigwill,1234567890zzz,hello69,compute1,viper9,hellspaw,trythis,gococks,dogballs,delfi,lupine,millenia,newdelhi,charlest,basspro,1mike,joeblack,975310,1rosebud,batman11,misterio,fucknut,charlie0,august11,juancho,ilonka,jigei743ks,adam1234,889900,goonie,alicat,ggggggg1,1zzzzzzz,sexywife,northstar,chris23,888111,containe,trojan1,jason5,graikos,1ggggg,1eeeee,tigers01,indigo1,hotmale,jacob123,mishima,richard3,cjxb2014,coco123,meagain,thaman,wallst,edgewood,bundas,1power,matilda1,maradon,hookedup,jemima,r3vi3wpass,2004-10-,mudman,taz123,xswzaq,emerson1,anna21,warlord1,toering,pelle,tgwdvu,masterb8,wallstre,moppel,priora,ghjcnjrdfif,yoland,12332100,1j9e7f6f,jazzzz,yesman,brianm,42qwerty42,12345698,darkmanx,nirmal,john31,bb123456,neuspeed,billgates,moguls,fj1200,hbhlair,shaun1,ghbdfn,305pwzlr,nbu3cd,susanb,pimpdad,mangust6403,joedog,dawidek,gigante,708090,703751,700007,ikalcr,tbivbn,697769,marvi,iyaayas,karen123,jimmyboy,dozer1,e6z8jh,bigtime1,getdown,kevin12,brookly,zjduc3,nolan1,cobber,yr8wdxcq,liebe,m1garand,blah123,616879,action1,600000,sumitomo,albcaz,asian1,557799,dave69,556699,sasa123,streaker,michel1,karate1,buddy7,daulet,koks888,roadtrip,wapiti,oldguy,illini1,1234qq,mrspock,kwiatek,buterfly,august31,jibxhq,jackin,taxicab,tristram,talisker,446655,444666,chrisa,freespace,vfhbfyyf,chevell,444333,notyours,442244,christian1,seemore,sniper12,marlin1,joker666,multik,devilish,crf450,cdfoli,eastern1,asshead,duhast,voyager2,cyberia,1wizard,cybernet,iloveme1,veterok,karandash,392781,looksee,diddy,diabolic,foofight,missey,herbert1,bmw318i,premier1,zsfmpv,eric1234,dun6sm,fuck11,345543,spudman,lurker,bitem,lizzy1,ironsink,minami,339311,s7fhs127,sterne,332233,plankton,galax,azuywe,changepa,august25,mouse123,sikici,killer69,xswqaz,quovadis,gnomik,033028pw,777777a,barrakuda,spawn666,goodgod,slurp,morbius,yelnats,cujo31,norman1,fastone,earwig,aureli,wordlife,bnfkbz,yasmi,austin123,timberla,missy2,legalize,netcom,liljon,takeit,georgin,987654321z,warbird,vitalina,all4u3,mmmmmm1,bichon,ellobo,wahoos,fcazmj,aksarben,lodoss,satnam,vasili,197800,maarten,sam138989,0u812,ankita,walte,prince12,anvils,bestia,hoschi,198300,univer,jack10,ktyecbr,gr00vy,hokie,wolfman1,fuckwit,geyser,emmanue,ybrjkftd,qwerty33,karat,dblock,avocat,bobbym,womersle,1please,nostra,dayana,billyray,alternat,iloveu1,qwerty69,rammstein1,mystikal,winne,drawde,executor,craxxxs,ghjcnjnf,999888777,welshman,access123,963214785,951753852,babe69,fvcnthlfv,****me,666999666,testing2,199200,nintendo64,oscarr,guido8,zhanna,gumshoe,jbird,159357456,pasca,123452345,satan6,mithrand,fhbirf,aa1111aa,viggen,ficktjuv,radial9,davids1,rainbow7,futuro,hipho,platin,poppy123,rhenjq,fulle,rosit,chicano,scrumpy,lumpy1,seifer,uvmrysez,autumn1,xenon,susie1,7u8i9o0p,gamer1,sirene,muffy1,monkeys1,kalinin,olcrackmaster,hotmove,uconn,gshock,merson,lthtdyz,pizzaboy,peggy1,pistache,pinto1,fishka,ladydi,pandor,baileys,hungwell,redboy,rookie1,amanda01,passwrd,clean1,matty1,tarkus,jabba1,bobster,beer30,solomon1,moneymon,sesamo,fred11,sunnysid,jasmine5,thebears,putamadre,workhard,flashbac,counter1,liefde,magnat,corky1,green6,abramov,lordik,univers,shortys,david3,vip123,gnarly,1234567s,billy2,honkey,deathstar,grimmy,govinda,direktor,12345678s,linus1,shoppin,rekbrjdf,santeria,prett,berty75,mohican,daftpunk,uekmyfhf,chupa,strats,ironbird,giants56,salisbur,koldun,summer04,pondscum,jimmyj,miata1,george3,redshoes,weezie,bartman1,0p9o8i7u,s1lver,dorkus,125478,omega9,sexisgood,mancow,patric1,jetta1,074401,ghjuhtcc,gfhjk,bibble,terry2,123213,medicin,rebel2,hen3ry,4freedom,aldrin,lovesyou,browny,renwod,winnie1,belladon,1house,tyghbn,blessme,rfhfrfnbwf,haylee,deepdive,booya,phantasy,gansta,cock69,4mnveh,gazza1,redapple,structur,anakin1,manolito,steve01,poolman,chloe123,vlad1998,qazwsxe,pushit,random123,ontherocks,o236nq,brain1,dimedrol,agape,rovnogod,1balls,knigh,alliso,love01,wolf01,flintstone,beernuts,tuffguy,isengard,highfive,alex23,casper99,rubina,getreal,chinita,italian1,airsoft,qwerty23,muffdiver,willi1,grace123,orioles1,redbull1,chino1,ziggy123,breadman,estefan,ljcneg,gotoit,logan123,wideglid,mancity1,treess,qwe123456,kazumi,qweasdqwe,oddworld,naveed,protos,towson,a801016,godislov,at_asp,bambam1,soccer5,dark123,67vette,carlos123,hoser1,scouser,wesdxc,pelus,dragon25,pflhjn,abdula,1freedom,policema,tarkin,eduardo1,mackdad,gfhjkm11,lfplhfgthvf,adilet,zzzzxxxx,childre,samarkand,cegthgegth,shama,fresher,silvestr,greaser,allout,plmokn,sexdrive,nintendo1,fantasy7,oleander,fe126fd,crumpet,pingzing,dionis,hipster,yfcnz,requin,calliope,jerome1,housecat,abc123456789,doghot,snake123,augus,brillig,chronic1,gfhjkbot,expediti,noisette,master7,caliban,whitetai,favorite3,lisamari,educatio,ghjhjr,saber1,zcegth,1958proman,vtkrbq,milkdud,imajica,thehip,bailey10,hockey19,dkflbdjcnjr,j123456,bernar,aeiouy,gamlet,deltachi,endzone,conni,bcgfybz,brandi1,auckland2010,7653ajl1,mardigra,testuser,bunko18,camaro67,36936,greenie,454dfmcq,6xe8j2z4,mrgreen,ranger5,headhunt,banshee1,moonunit,zyltrc,hello3,pussyboy,stoopid,tigger11,yellow12,drums1,blue02,kils123,junkman,banyan,jimmyjam,tbbucs,sportster,badass1,joshie,braves10,lajolla,1amanda,antani,78787,antero,19216801,chich,rhett32,sarahm,beloit,sucker69,corkey,nicosnn,rccola,caracol,daffyduc,bunny2,mantas,monkies,hedonist,cacapipi,ashton1,sid123,19899891,patche,greekgod,cbr1000,leader1,19977991,ettore,chongo,113311,picass,cfif123,rhtfnbd,frances1,andy12,minnette,bigboy12,green69,alices,babcia,partyboy,javabean,freehand,qawsed123,xxx111,harold1,passwo,jonny1,kappa1,w2dlww3v5p,1merlin,222999,tomjones,jakeman,franken,markhegarty,john01,carole1,daveman,caseys,apeman,mookey,moon123,claret,titans1,residentevil,campari,curitiba,dovetail,aerostar,jackdaniels,basenji,zaq12w,glencoe,biglove,goober12,ncc170,far7766,monkey21,eclipse9,1234567v,vanechka,aristote,grumble,belgorod,abhishek,neworleans,pazzword,dummie,sashadog,diablo11,mst3000,koala1,maureen1,jake99,isaiah1,funkster,gillian1,ekaterina20,chibears,astra123,4me2no,winte,skippe,necro,windows9,vinograd,demolay,vika2010,quiksilver,19371ayj,dollar1,shecky,qzwxecrv,butterfly1,merrill1,scoreland,1crazy,megastar,mandragora,track1,dedhed,jacob2,newhope,qawsedrftgyh,shack1,samvel,gatita,shyster,clara1,telstar,office1,crickett,truls,nirmala,joselito,chrisl,lesnik,aaaabbbb,austin01,leto2010,bubbie,aaa12345,widder,234432,salinger,mrsmith,qazsedcft,newshoes,skunks,yt1300,bmw316,arbeit,smoove,123321qweewq,123qazwsx,22221111,seesaw,0987654321a,peach1,1029384756q,sereda,gerrard8,shit123,batcave,energy1,peterb,mytruck,peter12,alesya,tomato1,spirou,laputaxx,magoo1,omgkremidia,knight12,norton1,vladislava,shaddy,austin11,jlbyjxrf,kbdthgekm,punheta,fetish69,exploiter,roger2,manstein,gtnhjd,32615948worms,dogbreath,ujkjdjkjvrf,vodka1,ripcord,fatrat,kotek1,tiziana,larrybir,thunder3,nbvfnb,9kyq6fge,remembe,likemike,gavin1,shinigam,yfcnfcmz,13245678,jabbar,vampyr,ane4ka,lollipo,ashwin,scuderia,limpdick,deagle,3247562,vishenka,fdhjhf,alex02,volvov70,mandys,bioshock,caraca,tombraider,matrix69,jeff123,13579135,parazit,black3,noway1,diablos,hitmen,garden1,aminor,decembe,august12,b00ger,006900,452073t,schach,hitman1,mariner1,vbnmrf,paint1,742617000027,bitchboy,pfqxjyjr,5681392,marryher,sinnet,malik1,muffin12,aninha,piolin,lady12,traffic1,cbvjyf,6345789,june21,ivan2010,ryan123,honda99,gunny,coorslight,asd321,hunter69,7224763,sonofgod,dolphins1,1dolphin,pavlenko,woodwind,lovelov,pinkpant,gblfhfcbyf,hotel1,justinbiebe,vinter,jeff1234,mydogs,1pizza,boats1,parrothe,shawshan,brooklyn1,cbrown,1rocky,hemi426,dragon64,redwings1,porsches,ghostly,hubbahub,buttnut,b929ezzh,sorokina,flashg,fritos,b7mguk,metatron,treehous,vorpal,8902792,marcu,free123,labamba,chiefs1,zxc123zxc,keli_14,hotti,1steeler,money4,rakker,foxwoods,free1,ahjkjd,sidorova,snowwhit,neptune1,mrlover,trader1,nudelamb,baloo,power7,deltasig,bills1,trevo,7gorwell,nokia6630,nokia5320,madhatte,1cowboys,manga1,namtab,sanjar,fanny1,birdman1,adv12775,carlo1,dude1998,babyhuey,nicole11,madmike,ubvyfpbz,qawsedr,lifetec,skyhook,stalker123,toolong,robertso,ripazha,zippy123,1111111a,manol,dirtyman,analslut,jason3,dutches,minhasenha,cerise,fenrir,jayjay1,flatbush,franka,bhbyjxrf,26429vadim,lawntrax,198700,fritzy,nikhil,ripper1,harami,truckman,nemvxyheqdd5oqxyxyzi,gkfytnf,bugaboo,cableman,hairpie,xplorer,movado,hotsex69,mordred,ohyeah1,patrick3,frolov,katieh,4311111q,mochaj,presari,bigdo,753951852,freedom4,kapitan,tomas1,135795,sweet123,pokers,shagme,tane4ka,sentinal,ufgyndmv,jonnyb,skate123,123456798,123456788,very1,gerrit,damocles,dollarbi,caroline1,lloyds,pizdets,flatland,92702689,dave13,meoff,ajnjuhfabz,achmed,madison9,744744z,amonte,avrillavigne,elaine1,norma1,asseater,everlong,buddy23,cmgang1,trash1,mitsu,flyman,ulugbek,june27,magistr,fittan,sebora64,dingos,sleipnir,caterpil,cindys,212121qaz,partys,dialer,gjytltkmybr,qweqaz,janvier,rocawear,lostboy,aileron,sweety1,everest1,pornman,boombox,potter1,blackdic,44448888,eric123,112233aa,2502557i,novass,nanotech,yourname,x12345,indian1,15975300,1234567l,carla51,chicago0,coleta,cxzdsaewq,qqwweerr,marwan,deltic,hollys,qwerasd,pon32029,rainmake,nathan0,matveeva,legioner,kevink,riven,tombraid,blitzen,a54321,jackyl,chinese1,shalimar,oleg1995,beaches1,tommylee,eknock,berli,monkey23,badbob,pugwash,likewhoa,jesus2,yujyd360,belmar,shadow22,utfp5e,angelo1,minimax,pooder,cocoa1,moresex,tortue,lesbia,panthe,snoopy2,drumnbass,alway,gmcz71,6jhwmqku,leppard,dinsdale,blair1,boriqua,money111,virtuagirl,267605,rattlesn,1sunshin,monica12,veritas1,newmexic,millertime,turandot,rfvxfnrf,jaydog,kakawka,bowhunter,booboo12,deerpark,erreway,taylorma,rfkbybyf,wooglin,weegee,rexdog,iamhorny,cazzo1,vhou812,bacardi1,dctktyyfz,godpasi,peanut12,bertha1,fuckyoubitch,ghosty,altavista,jertoot,smokeit,ghjcnbvtyz,fhnehxbr,rolsen,qazxcdews,maddmaxx,redrocke,qazokm,spencer2,thekiller,asdf11,123sex,tupac1,p1234567,dbrown,1biteme,tgo4466,316769,sunghi,shakespe,frosty1,gucci1,arcana,bandit01,lyubov,poochy,dartmout,magpies1,sunnyd,mouseman,summer07,chester7,shalini,danbury,pigboy,dave99,deniss,harryb,ashley11,pppppp1,01081988m,balloon1,tkachenko,bucks1,master77,pussyca,tricky1,zzxxccvv,zoulou,doomer,mukesh,iluv69,supermax,todays,thefox,don123,dontask,diplom,piglett,shiney,fahbrf,qaz12wsx,temitope,reggin,project1,buffy2,inside1,lbpfqyth,vanilla1,lovecock,u4slpwra,fylh.irf,123211,7ertu3ds,necroman,chalky,artist1,simpso,4x7wjr,chaos666,lazyacres,harley99,ch33s3,marusa,eagle7,dilligas,computadora,lucky69,denwer,nissan350z,unforgiv,oddball,schalke0,aztec1,borisova,branden1,parkave,marie123,germa,lafayett,878kckxy,405060,cheeseca,bigwave,fred22,andreea,poulet,mercutio,psycholo,andrew88,o4izdmxu,sanctuar,newhome,milion,suckmydi,rjvgm.nth,warior,goodgame,1qwertyuiop,6339cndh,scorpio2,macker,southbay,crabcake,toadie,paperclip,fatkid,maddo,cliff1,rastafar,maries,twins1,geujdrf,anjela,wc4fun,dolina,mpetroff,rollout,zydeco,shadow3,pumpki,steeda,volvo240,terras,blowjo,blue2000,incognit,badmojo,gambit1,zhukov,station1,aaronb,graci,duke123,clipper1,qazxsw2,ledzeppe,kukareku,sexkitte,cinco,007008,lakers12,a1234b,acmilan1,afhfjy,starrr,slutty3,phoneman,kostyan,bonzo1,sintesi07,ersatz,cloud1,nephilim,nascar03,rey619,kairos,123456789e,hardon1,boeing1,juliya,hfccdtn,vgfun8,polizei,456838,keithb,minouche,ariston,savag,213141,clarkken,microwav,london2,santacla,campeo,qr5mx7,464811,mynuts,bombo,1mickey,lucky8,danger1,ironside,carter12,wyatt1,borntorun,iloveyou123,jose1,pancake1,tadmichaels,monsta,jugger,hunnie,triste,heat7777,ilovejesus,queeny,luckycharm,lieben,gordolee85,jtkirk,forever21,jetlag,skylane,taucher,neworlea,holera,000005,anhnhoem,melissa7,mumdad,massimiliano,dima1994,nigel1,madison3,slicky,shokolad,serenit,jmh1978,soccer123,chris3,drwho,rfpzdrf,1qasw23ed,free4me,wonka,sasquatc,sanan,maytag,verochka,bankone,molly12,monopoli,xfqybr,lamborgini,gondolin,candycane,needsome,jb007,scottie1,brigit,0147258369,kalamazo,lololyo123,bill1234,ilovejes,lol123123,popkorn,april13,567rntvm,downunde,charle1,angelbab,guildwars,homeworld,qazxcvbnm,superma1,dupa123,kryptoni,happyy,artyom,stormie,cool11,calvin69,saphir,konovalov,jansport,october8,liebling,druuna,susans,megans,tujhjdf,wmegrfux,jumbo1,ljb4dt7n,012345678910,kolesnik,speculum,at4gftlw,kurgan,93pn75,cahek0980,dallas01,godswill,fhifdby,chelsea4,jump23,barsoom,catinhat,urlacher,angel99,vidadi1,678910,lickme69,topaz1,westend,loveone,c12345,gold12,alex1959,mamon,barney12,1maggie,alex12345,lp2568cskt,s1234567,gjikbdctyf,anthony0,browns99,chips1,sunking,widespre,lalala1,tdutif,fucklife,master00,alino4ka,stakan,blonde1,phoebus,tenore,bvgthbz,brunos,suzjv8,uvdwgt,revenant,1banana,veroniqu,sexfun,sp1der,4g3izhox,isakov,shiva1,scooba,bluefire,wizard12,dimitris,funbags,perseus,hoodoo,keving,malboro,157953,a32tv8ls,latics,animate,mossad,yejntb,karting,qmpq39zr,busdrive,jtuac3my,jkne9y,sr20dett,4gxrzemq,keylargo,741147,rfktylfhm,toast1,skins1,xcalibur,gattone,seether,kameron,glock9mm,julio1,delenn,gameday,tommyd,str8edge,bulls123,66699,carlsberg,woodbird,adnama,45auto,codyman,truck2,1w2w3w4w,pvjegu,method1,luetdi,41d8cd98f00b,bankai,5432112345,94rwpe,reneee,chrisx,melvins,775577,sam2000,scrappy1,rachid,grizzley,margare,morgan01,winstons,gevorg,gonzal,crawdad,gfhfdjp,babilon,noneya,pussy11,barbell,easyride,c00li0,777771,311music,karla1,golions,19866891,peejay,leadfoot,hfvbkm,kr9z40sy,cobra123,isotwe,grizz,sallys,****you,aaa123a,dembel,foxs14,hillcres,webman,mudshark,alfredo1,weeded,lester1,hovepark,ratface,000777fffa,huskie,wildthing,elbarto,waikiki,masami,call911,goose2,regin,dovajb,agricola,cjytxrj,andy11,penny123,family01,a121212,1braves,upupa68,happy100,824655,cjlove,firsttim,kalel,redhair,dfhtymt,sliders,bananna,loverbo,fifa2008,crouton,chevy350,panties2,kolya1,alyona,hagrid,spagetti,q2w3e4r,867530,narkoman,nhfdvfnjkju123,1ccccccc,napolean,0072563,allay,w8sted,wigwam,jamesk,state1,parovoz,beach69,kevinb,rossella,logitech1,celula,gnocca,canucks1,loginova,marlboro1,aaaa1,kalleanka,mester,mishutka,milenko,alibek,jersey1,peterc,1mouse,nedved,blackone,ghfplybr,682regkh,beejay,newburgh,ruffian,clarets,noreaga,xenophon,hummerh2,tenshi,smeagol,soloyo,vfhnby,ereiamjh,ewq321,goomie,sportin,cellphone,sonnie,jetblack,saudan,gblfhfc,matheus,uhfvjnf,alicja,jayman1,devon1,hexagon,bailey2,vtufajy,yankees7,salty1,908070,killemal,gammas,eurocard,sydney12,tuesday1,antietam,wayfarer,beast666,19952009sa,aq12ws,eveli,hockey21,haloreach,dontcare,xxxx1,andrea11,karlmarx,jelszo,tylerb,protools,timberwolf,ruffneck,pololo,1bbbbb,waleed,sasami,twinss,fairlady,illuminati,alex007,sucks1,homerjay,scooter7,tarbaby,barmaley,amistad,vanes,randers,tigers12,dreamer2,goleafsg,googie,bernie1,as12345,godeep,james3,phanto,gwbush,cumlover,2196dc,studioworks,995511,golf56,titova,kaleka,itali,socks1,kurwamac,daisuke,hevonen,woody123,daisie,wouter,henry123,gostosa,guppie,porpoise,iamsexy,276115,paula123,1020315,38gjgeuftd,rjrfrjkf,knotty,idiot1,sasha12345,matrix13,securit,radical1,ag764ks,jsmith,coolguy1,secretar,juanas,sasha1988,itout,00000001,tiger11,1butthea,putain,cavalo,basia1,kobebryant,1232323,12345asdfg,sunsh1ne,cyfqgth,tomkat,dorota,dashit,pelmen,5t6y7u,whipit,smokeone,helloall,bonjour1,snowshoe,nilknarf,x1x2x3,lammas,1234599,lol123456,atombomb,ironchef,noclue,alekseev,gwbush1,silver2,12345678m,yesican,fahjlbnf,chapstic,alex95,open1,tiger200,lisichka,pogiako,cbr929,searchin,tanya123,alex1973,phil413,alex1991,dominati,geckos,freddi,silenthill,egroeg,vorobey,antoxa,dark666,shkola,apple22,rebellio,shamanking,7f8srt,cumsucker,partagas,bill99,22223333,arnster55,fucknuts,proxima,silversi,goblues,parcells,vfrcbvjdf,piloto,avocet,emily2,1597530,miniskir,himitsu,pepper2,juiceman,venom1,bogdana,jujube,quatro,botafogo,mama2010,junior12,derrickh,asdfrewq,miller2,chitarra,silverfox,napol,prestigio,devil123,mm111qm,ara123,max33484,sex2000,primo1,sephan,anyuta,alena2010,viborg,verysexy,hibiscus,terps,josefin,oxcart,spooker,speciali,raffaello,partyon,vfhvtkflrf,strela,a123456z,worksuck,glasss,lomonosov,dusty123,dukeblue,1winter,sergeeva,lala123,john22,cmc09,sobolev,bettylou,dannyb,gjkrjdybr,hagakure,iecnhbr,awsedr,pmdmsctsk,costco,alekseeva,fktrcttd,bazuka,flyingv,garuda,buffy16,gutierre,beer12,stomatolog,ernies,palmeiras,golf123,love269,n.kmgfy,gjkysqgbpltw,youare,joeboo,baksik,lifeguar,111a111,nascar8,mindgame,dude1,neopets,frdfkfyu,june24,phoenix8,penelopa,merlin99,mercenar,badluck,mishel,bookert,deadsexy,power9,chinchil,1234567m,alex10,skunk1,rfhkcjy,sammycat,wright1,randy2,marakesh,temppassword,elmer251,mooki,patrick0,bonoedge,1tits,chiar,kylie1,graffix,milkman1,cornel,mrkitty,nicole12,ticketmaster,beatles4,number20,ffff1,terps1,superfre,yfdbufnjh,jake1234,flblfc,1111qq,zanuda,jmol01,wpoolejr,polopol,nicolett,omega13,cannonba,123456789.,sandy69,ribeye,bo243ns,marilena,bogdan123,milla,redskins1,19733791,alias1,movie1,ducat,marzena,shadowru,56565,coolman1,pornlover,teepee,spiff,nafanya,gateway3,fuckyou0,hasher,34778,booboo69,staticx,hang10,qq12345,garnier,bosco123,1234567qw,carson1,samso,1xrg4kcq,cbr929rr,allan123,motorbik,andrew22,pussy101,miroslava,cytujdbr,camp0017,cobweb,snusmumrik,salmon1,cindy2,aliya,serendipity,co437at,tincouch,timmy123,hunter22,st1100,vvvvvv1,blanka,krondor,sweeti,nenit,kuzmich,gustavo1,bmw320i,alex2010,trees1,kyliem,essayons,april26,kumari,sprin,fajita,appletre,fghbjhb,1green,katieb,steven2,corrado1,satelite,1michell,123456789c,cfkfvfylhf,acurarsx,slut543,inhere,bob2000,pouncer,k123456789,fishie,aliso,audia8,bluetick,soccer69,jordan99,fromhell,mammoth1,fighting54,mike25,pepper11,extra1,worldwid,chaise,vfr800,sordfish,almat,nofate,listopad,hellgate,dctvghbdf,jeremia,qantas,lokiju,honker,sprint1,maral,triniti,compaq3,sixsix6,married1,loveman,juggalo1,repvtyrj,zxcasdqw,123445,whore1,123678,monkey6,west123,warcraf,pwnage,mystery1,creamyou,ant123,rehjgfnrf,corona1,coleman1,steve121,alderaan,barnaul,celeste1,junebug1,bombshel,gretzky9,tankist,targa,cachou,vaz2101,playgolf,boneyard,strateg,romawka,iforgotit,pullup,garbage1,irock,archmage,shaft1,oceano,sadies,alvin1,135135ab,psalm69,lmfao,ranger02,zaharova,33334444,perkman,realman,salguod,cmoney,astonmartin,glock1,greyfox,viper99,helpm,blackdick,46775575,family5,shazbot,dewey1,qwertyas,shivani,black22,mailman1,greenday1,57392632,red007,stanky,sanchez1,tysons,daruma,altosax,krayzie,85852008,1forever,98798798,irock.,123456654,142536789,ford22,brick1,michela,preciou,crazy4u,01telemike01,nolife,concac,safety1,annie123,brunswic,destini,123456qwer,madison0,snowball1,137946,1133557799,jarule,scout2,songohan,thedead,00009999,murphy01,spycam,hirsute,aurinko,associat,1miller,baklan,hermes1,2183rm,martie,kangoo,shweta,yvonne1,westsid,jackpot1,rotciv,maratik,fabrika,claude1,nursultan,noentry,ytnhjufnm,electra1,ghjcnjnfr1,puneet,smokey01,integrit,bugeye,trouble2,14071789,paul01,omgwtf,dmh415,ekilpool,yourmom1,moimeme,sparky11,boludo,ruslan123,kissme1,demetrio,appelsin,asshole3,raiders2,bunns,fynjybj,billygoa,p030710p$e4o,macdonal,248ujnfk,acorns,schmidt1,sparrow1,vinbylrj,weasle,jerom,ycwvrxxh,skywalk,gerlinde,solidus,postal1,poochie1,1charles,rhianna,terorist,rehnrf,omgwtfbbq,assfucke,deadend,zidan,jimboy,vengence,maroon5,7452tr,dalejr88,sombra,anatole,elodi,amazonas,147789,q12345q,gawker1,juanma,kassidy,greek1,bruces,bilbob,mike44,0o9i8u7y6t,kaligula,agentx,familie,anders1,pimpjuice,0128um,birthday10,lawncare,hownow,grandorgue,juggerna,scarfac,kensai,swatteam,123four,motorbike,repytxbr,other1,celicagt,pleomax,gen0303,godisgreat,icepick,lucifer666,heavy1,tea4two,forsure,02020,shortdog,webhead,chris13,palenque,3techsrl,knights1,orenburg,prong,nomarg,wutang1,80637852730,laika,iamfree,12345670,pillow1,12343412,bigears,peterg,stunna,rocky5,12123434,damir,feuerwehr,7418529630,danone,yanina,valenci,andy69,111222q,silvia1,1jjjjj,loveforever,passwo1,stratocaster,8928190a,motorolla,lateralu,ujujkm,chubba,ujkjdf,signon,123456789zx,serdce,stevo,wifey200,ololo123,popeye1,1pass,central1,melena,luxor,nemezida,poker123,ilovemusic,qaz1234,noodles1,lakeshow,amarill,ginseng,billiam,trento,321cba,fatback,soccer33,master13,marie2,newcar,bigtop,dark1,camron,nosgoth,155555,biglou,redbud,jordan7,159789,diversio,actros,dazed,drizzit,hjcnjd,wiktoria,justic,gooses,luzifer,darren1,chynna,tanuki,11335577,icculus,boobss,biggi,firstson,ceisi123,gatewa,hrothgar,jarhead1,happyjoy,felipe1,bebop1,medman,athena1,boneman,keiths,djljgfl,dicklick,russ120,mylady,zxcdsa,rock12,bluesea,kayaks,provista,luckies,smile4me,bootycal,enduro,123123f,heartbre,ern3sto,apple13,bigpappa,fy.njxrf,bigtom,cool69,perrito,quiet1,puszek,cious,cruella,temp1,david26,alemap,aa123123,teddies,tricolor,smokey12,kikiriki,mickey01,robert01,super5,ranman,stevenso,deliciou,money777,degauss,mozar,susanne1,asdasd12,shitbag,mommy123,wrestle1,imfree,fuckyou12,barbaris,florent,ujhijr,f8yruxoj,tefjps,anemone,toltec,2gether,left4dead2,ximen,gfkmvf,dunca,emilys,diana123,16473a,mark01,bigbro,annarbor,nikita2000,11aa11,tigres,llllll1,loser2,fbi11213,jupite,qwaszxqw,macabre,123ert,rev2000,mooooo,klapaucius,bagel1,chiquit,iyaoyas,bear101,irocz28,vfktymrfz,smokey2,love99,rfhnbyf,dracul,keith123,slicko,peacock1,orgasmic,thesnake,solder,wetass,doofer,david5,rhfcyjlfh,swanny,tammys,turkiye,tubaman,estefani,firehose,funnyguy,servo,grace17,pippa1,arbiter,jimmy69,nfymrf,asdf67nm,rjcnzy,demon123,thicknes,sexysex,kristall,michail,encarta,banderos,minty,marchenko,de1987ma,mo5kva,aircav,naomi1,bonni,tatoo,cronaldo,49ers1,mama1963,1truck,telecaster,punksnotdead,erotik,1eagles,1fender,luv269,acdeehan,tanner1,freema,1q3e5t7u,linksys,tiger6,megaman1,neophyte,australia1,mydaddy,1jeffrey,fgdfgdfg,gfgekz,1986irachka,keyman,m0b1l3,dfcz123,mikeyg,playstation2,abc125,slacker1,110491g,lordsoth,bhavani,ssecca,dctvghbdtn,niblick,hondacar,baby01,worldcom,4034407,51094didi,3657549,3630000,3578951,sweetpussy,majick,supercoo,robert11,abacabb,panda123,gfhjkm13,ford4x4,zippo1,lapin,1726354,lovesong,dude11,moebius,paravoz,1357642,matkhau,solnyshko,daniel4,multiplelog,starik,martusia,iamtheman,greentre,jetblue,motorrad,vfrcbvev,redoak,dogma1,gnorman,komlos,tonka1,1010220,666satan,losenord,lateralus,absinthe,command1,jigga1,iiiiiii1,pants1,jungfrau,926337,ufhhbgjnnth,yamakasi,888555,sunny7,gemini69,alone1,zxcvbnmz,cabezon,skyblues,zxc1234,456123a,zero00,caseih,azzurra,legolas1,menudo,murcielago,785612,779977,benidorm,viperman,dima1985,piglet1,hemligt,hotfeet,7elephants,hardup,gamess,a000000,267ksyjf,kaitlynn,sharkie,sisyphus,yellow22,667766,redvette,666420,mets69,ac2zxdty,hxxrvwcy,cdavis,alan1,noddy,579300,druss,eatshit1,555123,appleseed,simpleplan,kazak,526282,fynfyfyfhbde,birthday6,dragon6,1pookie,bluedevils,omg123,hj8z6e,x5dxwp,455445,batman23,termin,chrisbrown,animals1,lucky9,443322,kzktxrf,takayuki,fermer,assembler,zomu9q,sissyboy,sergant,felina,nokia6230i,eminem12,croco,hunt4red,festina,darknigh,cptnz062,ndshnx4s,twizzler,wnmaz7sd,aamaax,gfhfcjkmrf,alabama123,barrynov,happy5,punt0it,durandal,8xuuobe4,cmu9ggzh,bruno12,316497,crazyfrog,vfvfktyf,apple3,kasey1,mackdaddy,anthon1,sunnys,angel3,cribbage,moon1,donal,bryce1,pandabear,mwss474,whitesta,freaker,197100,bitche,p2ssw0rd,turnb,tiktonik,moonlite,ferret1,jackas,ferrum,bearclaw,liberty2,1diablo,caribe,snakeeyes,janbam,azonic,rainmaker,vetalik,bigeasy,baby1234,sureno13,blink1,kluivert,calbears,lavanda,198600,dhtlbyf,medvedeva,fox123,whirling,bonscott,freedom9,october3,manoman,segredo,cerulean,robinso,bsmith,flatus,dannon,password21,rrrrrr1,callista,romai,rainman1,trantor,mickeymo,bulldog7,g123456,pavlin,pass22,snowie,hookah,7ofnine,bubba22,cabible,nicerack,moomoo1,summer98,yoyo123,milan1,lieve27,mustang69,jackster,exocet,nadege,qaz12,bahama,watson1,libras,eclipse2,bahram,bapezm,up9x8rww,ghjcnjz,themaste,deflep27,ghost16,gattaca,fotograf,junior123,gilber,gbjyth,8vjzus,rosco1,begonia,aldebara,flower12,novastar,buzzman,manchild,lopez1,mama11,william7,yfcnz1,blackstar,spurs123,moom4242,1amber,iownyou,tightend,07931505,paquito,1johnson,smokepot,pi31415,snowmass,ayacdc,jessicam,giuliana,5tgbnhy6,harlee,giuli,bigwig,tentacle,scoubidou2,benelli,vasilina,nimda,284655,jaihind,lero4ka,1tommy,reggi,ididit,jlbyjxtcndj,mike26,qbert,wweraw,lukasz,loosee123,palantir,flint1,mapper,baldie,saturne,virgin1,meeeee,elkcit,iloveme2,blue15,themoon,radmir,number3,shyanne,missle,hannelor,jasmina,karin1,lewie622,ghjcnjqgfhjkm,blasters,oiseau,sheela,grinders,panget,rapido,positiv,twink,fltkbyf,kzsfj874,daniel01,enjoyit,nofags,doodad,rustler,squealer,fortunat,peace123,khushi,devils2,7inches,candlebo,topdawg,armen,soundman,zxcqweasd,april7,gazeta,netman,hoppers,bear99,ghbjhbntn,mantle7,bigbo,harpo,jgordon,bullshi,vinny1,krishn,star22,thunderc,galinka,phish123,tintable,nightcrawler,tigerboy,rbhgbx,messi,basilisk,masha1998,nina123,yomamma,kayla123,geemoney,0000000000d,motoman,a3jtni,ser123,owen10,italien,vintelok,12345rewq,nightime,jeepin,ch1tt1ck,mxyzptlk,bandido,ohboy,doctorj,hussar,superted,parfilev,grundle,1jack,livestrong,chrisj,matthew3,access22,moikka,fatone,miguelit,trivium,glenn1,smooches,heiko,dezember,spaghett,stason,molokai,bossdog,guitarma,waderh,boriska,photosho,path13,hfrtnf,audre,junior24,monkey24,silke,vaz21093,bigblue1,trident1,candide,arcanum,klinker,orange99,bengals1,rosebu,mjujuj,nallepuh,mtwapa1a,ranger69,level1,bissjop,leica,1tiffany,rutabega,elvis77,kellie1,sameas,barada,karabas,frank12,queenb,toutoune,surfcity,samanth1,monitor1,littledo,kazakova,fodase,mistral1,april22,carlit,shakal,batman123,fuckoff2,alpha01,5544332211,buddy3,towtruck,kenwood1,vfiekmrf,jkl123,pypsik,ranger75,sitges,toyman,bartek1,ladygirl,booman,boeing77,installsqlst,222666,gosling,bigmack,223311,bogos,kevin2,gomez1,xohzi3g4,kfnju842,klubnika,cubalibr,123456789101,kenpo,0147852369,raptor1,tallulah,boobys,jjones,1q2s3c,moogie,vid2600,almas,wombat1,extra300,xfiles1,green77,sexsex1,heyjude,sammyy,missy123,maiyeuem,nccpl25282,thicluv,sissie,raven3,fldjrfn,buster22,broncos2,laurab,letmein4,harrydog,solovey,fishlips,asdf4321,ford123,superjet,norwegen,movieman,psw333333,intoit,postbank,deepwate,ola123,geolog323,murphys,eshort,a3eilm2s2y,kimota,belous,saurus,123321qaz,i81b4u,aaa12,monkey20,buckwild,byabybnb,mapleleafs,yfcnzyfcnz,baby69,summer03,twista,246890,246824,ltcnhjth,z1z2z3,monika1,sad123,uto29321,bathory,villan,funkey,poptarts,spam967888,705499fh,sebast,porn1234,earn381,1porsche,whatthef,123456789y,polo12,brillo,soreilly,waters1,eudora,allochka,is_a_bot,winter00,bassplay,531879fiz,onemore,bjarne,red911,kot123,artur1,qazxdr,c0rvette,diamond7,matematica,klesko,beaver12,2enter,seashell,panam,chaching,edward2,browni,xenogear,cornfed,aniram,chicco22,darwin1,ancella2,sophie2,vika1998,anneli,shawn41,babie,resolute,pandora2,william8,twoone,coors1,jesusis1,teh012,cheerlea,renfield,tessa1,anna1986,madness1,bkmlfh,19719870,liebherr,ck6znp42,gary123,123654z,alsscan,eyedoc,matrix7,metalgea,chinito,4iter,falcon11,7jokx7b9du,bigfeet,tassadar,retnuh,muscle1,klimova,darion,batistuta,bigsur,1herbier,noonie,ghjrehjh,karimova,faustus,snowwhite,1manager,dasboot,michael12,analfuck,inbed,dwdrums,jaysoncj,maranell,bsheep75,164379,rolodex,166666,rrrrrrr1,almaz666,167943,russel1,negrito,alianz,goodpussy,veronik,1w2q3r4e,efremov,emb377,sdpass,william6,alanfahy,nastya1995,panther5,automag,123qwe12,vfvf2011,fishe,1peanut,speedie,qazwsx1234,pass999,171204j,ketamine,sheena1,energizer,usethis1,123abc123,buster21,thechamp,flvbhfk,frank69,chane,hopeful1,claybird,pander,anusha,bigmaxxx,faktor,housebed,dimidrol,bigball,shashi,derby1,fredy,dervish,bootycall,80988218126,killerb,cheese2,pariss,mymail,dell123,catbert,christa1,chevytru,gjgjdf,00998877,overdriv,ratten,golf01,nyyanks,dinamite,bloembol,gismo,magnus1,march2,twinkles,ryan22,duckey,118a105b,kitcat,brielle,poussin,lanzarot,youngone,ssvegeta,hero63,battle1,kiler,fktrcfylh1,newera,vika1996,dynomite,oooppp,beer4me,foodie,ljhjuf,sonshine,godess,doug1,constanc,thinkbig,steve2,damnyou,autogod,www333,kyle1,ranger7,roller1,harry2,dustin1,hopalong,tkachuk,b00bies,bill2,deep111,stuffit,fire69,redfish1,andrei123,graphix,1fishing,kimbo1,mlesp31,ifufkbyf,gurkan,44556,emily123,busman,and123,8546404,paladine,1world,bulgakov,4294967296,bball23,1wwwww,mycats,elain,delta6,36363,emilyb,color1,6060842,cdtnkfyrf,hedonism,gfgfrfhkj,5551298,scubad,gostate,sillyme,hdbiker,beardown,fishers,sektor,00000007,newbaby,rapid1,braves95,gator2,nigge,anthony3,sammmy,oou812,heffer,phishin,roxanne1,yourass,hornet1,albator,2521659,underwat,tanusha,dianas,3f3fpht7op,dragon20,bilbobag,cheroke,radiatio,dwarf1,majik,33st33,dochka,garibald,robinh,sham69,temp01,wakeboar,violet1,1w2w3w,registr,tonite,maranello,1593570,parolamea,galatasara,loranthos,1472583,asmodean,1362840,scylla,doneit,jokerr,porkypig,kungen,mercator,koolhaas,come2me,debbie69,calbear,liverpoolfc,yankees4,12344321a,kennyb,madma,85200258,dustin23,thomas13,tooling,mikasa,mistic,crfnbyf,112233445,sofia1,heinz57,colts1,price1,snowey,joakim,mark11,963147,cnhfcnm,kzinti,1bbbbbbb,rubberdu,donthate,rupert1,sasha1992,regis1,nbuhbwf,fanboy,sundial,sooner1,wayout,vjnjhjkf,deskpro,arkangel,willie12,mikeyb,celtic1888,luis1,buddy01,duane1,grandma1,aolcom,weeman,172839456,basshead,hornball,magnu,pagedown,molly2,131517,rfvtgbyhn,astonmar,mistery,madalina,cash1,1happy,shenlong,matrix01,nazarova,369874125,800500,webguy,rse2540,ashley2,briank,789551,786110,chunli,j0nathan,greshnik,courtne,suckmyco,mjollnir,789632147,asdfg1234,754321,odelay,ranma12,zebedee,artem777,bmw318is,butt1,rambler1,yankees9,alabam,5w76rnqp,rosies,mafioso,studio1,babyruth,tranzit,magical123,gfhjkm135,12345$,soboleva,709394,ubique,drizzt1,elmers,teamster,pokemons,1472583690,1597532486,shockers,merckx,melanie2,ttocs,clarisse,earth1,dennys,slobber,flagman,farfalla,troika,4fa82hyx,hakan,x4ww5qdr,cumsuck,leather1,forum1,july20,barbel,zodiak,samuel12,ford01,rushfan,bugsy1,invest1,tumadre,screwme,a666666,money5,henry8,tiddles,sailaway,starburs,100years,killer01,comando,hiromi,ranetka,thordog,blackhole,palmeira,verboten,solidsna,q1w1e1,humme,kevinc,gbrfxe,gevaudan,hannah11,peter2,vangar,sharky7,talktome,jesse123,chuchi,pammy,!qazxsw2,siesta,twenty1,wetwilly,477041,natural1,sun123,daniel3,intersta,shithead1,hellyea,bonethugs,solitair,bubbles2,father1,nick01,444000,adidas12,dripik,cameron2,442200,a7nz8546,respublika,fkojn6gb,428054,snoppy,rulez1,haslo,rachael1,purple01,zldej102,ab12cd34,cytuehjxrf,madhu,astroman,preteen,handsoff,mrblonde,biggio,testin,vfdhif,twolves,unclesam,asmara,kpydskcw,lg2wmgvr,grolsch,biarritz,feather1,williamm,s62i93,bone1,penske,337733,336633,taurus1,334433,billet,diamondd,333000,nukem,fishhook,godogs,thehun,lena1982,blue00,smelly1,unb4g9ty,65pjv22,applegat,mikehunt,giancarlo,krillin,felix123,december1,soapy,46doris,nicole23,bigsexy1,justin10,pingu,bambou,falcon12,dgthtl,1surfer,qwerty01,estrellit,nfqcjy,easygo,konica,qazqwe,1234567890m,stingers,nonrev,3e4r5t,champio,bbbbbb99,196400,allen123,seppel,simba2,rockme,zebra3,tekken3,endgame,sandy2,197300,fitte,monkey00,eldritch,littleone,rfyfgkz,1member,66chevy,oohrah,cormac,hpmrbm41,197600,grayfox,elvis69,celebrit,maxwell7,rodders,krist,1camaro,broken1,kendall1,silkcut,katenka,angrick,maruni,17071994a,tktyf,kruemel,snuffles,iro4ka,baby12,alexis01,marryme,vlad1994,forward1,culero,badaboom,malvin,hardtoon,hatelove,molley,knopo4ka,duchess1,mensuck,cba321,kickbutt,zastava,wayner,fuckyou6,eddie123,cjkysir,john33,dragonfi,cody1,jabell,cjhjrf,badseed,sweden1,marihuana,brownlov,elland,nike1234,kwiettie,jonnyboy,togepi,billyk,robert123,bb334,florenci,ssgoku,198910,bristol1,bob007,allister,yjdujhjl,gauloise,198920,bellaboo,9lives,aguilas,wltfg4ta,foxyroxy,rocket69,fifty50,babalu,master21,malinois,kaluga,gogosox,obsessio,yeahrigh,panthers1,capstan,liza2000,leigh1,paintball1,blueskie,cbr600f3,bagdad,jose98,mandreki,shark01,wonderbo,muledeer,xsvnd4b2,hangten,200001,grenden,anaell,apa195,model1,245lufpq,zip100,ghjcgtrn,wert1234,misty2,charro,juanjose,fkbcrf,frostbit,badminto,buddyy,1doctor,vanya,archibal,parviz,spunky1,footboy,dm6tzsgp,legola,samadhi,poopee,ytdxz2ca,hallowboy,dposton,gautie,theworm,guilherme,dopehead,iluvtits,bobbob1,ranger6,worldwar,lowkey,chewbaca,oooooo99,ducttape,dedalus,celular,8i9o0p,borisenko,taylor01,111111z,arlingto,p3nnywiz,rdgpl3ds,boobless,kcmfwesg,blacksab,mother2,markus1,leachim,secret2,s123456789,1derful,espero,russell2,tazzer,marykate,freakme,mollyb,lindros8,james00,gofaster,stokrotka,kilbosik,aquamann,pawel1,shedevil,mousie,slot2009,october6,146969,mm259up,brewcrew,choucho,uliana,sexfiend,fktirf,pantss,vladimi,starz,sheeps,12341234q,bigun,tiggers,crjhjcnm,libtech,pudge1,home12,zircon,klaus1,jerry2,pink1,lingus,monkey66,dumass,polopolo09,feuerweh,rjyatnf,chessy,beefer,shamen,poohbear1,4jjcho,bennevis,fatgirls,ujnbrf,cdexswzaq,9noize9,rich123,nomoney,racecar1,hacke,clahay,acuario,getsum,hondacrv,william0,cheyenn,techdeck,atljhjdf,wtcacq,suger,fallenangel,bammer,tranquil,carla123,relayer,lespaul1,portvale,idontno,bycnbnen,trooper2,gennadiy,pompon,billbob,amazonka,akitas,chinatow,atkbrc,busters,fitness1,cateye,selfok2013,1murphy,fullhous,mucker,bajskorv,nectarin,littlebitch,love24,feyenoor,bigal37,lambo1,pussybitch,icecube1,biged,kyocera,ltybcjdf,boodle,theking1,gotrice,sunset1,abm1224,fromme,sexsells,inheat,kenya1,swinger1,aphrodit,kurtcobain,rhind101,poidog,poiulkjh,kuzmina,beantown,tony88,stuttgar,drumer,joaqui,messenge,motorman,amber2,nicegirl,rachel69,andreia,faith123,studmuffin,jaiden,red111,vtkmybr,gamecocks,gumper,bosshogg,4me2know,tokyo1,kleaner,roadhog,fuckmeno,phoenix3,seeme,buttnutt,boner69,andreyka,myheart,katerin,rugburn,jvtuepip,dc3ubn,chile1,ashley69,happy99,swissair,balls2,fylhttdf,jimboo,55555d,mickey11,voronin,m7hsqstm,stufff,merete,weihnachte,dowjones,baloo1,freeones,bears34,auburn1,beverl,timberland,1elvis,guinness1,bombadil,flatron1,logging7,telefoon,merl1n,masha1,andrei1,cowabung,yousuck1,1matrix,peopl,asd123qwe,sweett,mirror1,torrente,joker12,diamond6,jackaroo,00000a,millerlite,ironhorse,2twins,stryke,gggg1,zzzxxxccc,roosevel,8363eddy,angel21,depeche1,d0ct0r,blue14,areyou,veloce,grendal,frederiksberg,cbcntvf,cb207sl,sasha2000,was.here,fritzz,rosedale,spinoza,cokeisit,gandalf3,skidmark,ashley01,12345j,1234567890qaz,sexxxxxx,beagles,lennart,12345789,pass10,politic,max007,gcheckou,12345611,tiffy,lightman,mushin,velosiped,brucewayne,gauthie,elena123,greenegg,h2oski,clocker,nitemare,123321s,megiddo,cassidy1,david13,boywonde,flori,peggy12,pgszt6md,batterie,redlands,scooter6,bckhere,trueno,bailey11,maxwell2,bandana,timoth1,startnow,ducati74,tiern,maxine1,blackmetal,suzyq,balla007,phatfarm,kirsten1,titmouse,benhogan,culito,forbin,chess1,warren1,panman,mickey7,24lover,dascha,speed2,redlion,andrew10,johnwayn,nike23,chacha1,bendog,bullyboy,goldtree,spookie,tigger99,1cookie,poutine,cyclone1,woodpony,camaleun,bluesky1,dfadan,eagles20,lovergirl,peepshow,mine1,dima1989,rjdfkmxer,11111aaaaa,machina,august17,1hhhhh,0773417k,1monster,freaksho,jazzmin,davidw,kurupt,chumly,huggies,sashenka,ccccccc1,bridge1,giggalo,cincinna,pistol1,hello22,david77,lightfoo,lucky6,jimmy12,261397,lisa12,tabaluga,mysite,belo4ka,greenn,eagle99,punkrawk,salvado,slick123,wichsen,knight99,dummys,fefolico,contrera,kalle1,anna1984,delray,robert99,garena,pretende,racefan,alons,serenada,ludmilla,cnhtkjr,l0swf9gx,hankster,dfktynbyrf,sheep1,john23,cv141ab,kalyani,944turbo,crystal2,blackfly,zrjdktdf,eus1sue1,mario5,riverplate,harddriv,melissa3,elliott1,sexybitc,cnhfyybr,jimdavis,bollix,beta1,amberlee,skywalk1,natala,1blood,brattax,shitty1,gb15kv99,ronjon,rothmans,thedoc,joey21,hotboi,firedawg,bimbo38,jibber,aftermat,nomar,01478963,phishing,domodo,anna13,materia,martha1,budman1,gunblade,exclusiv,sasha1997,anastas,rebecca2,fackyou,kallisti,fuckmyass,norseman,ipswich1,151500,1edward,intelinside,darcy1,bcrich,yjdjcnbf,failte,buzzzz,cream1,tatiana1,7eleven,green8,153351,1a2s3d4f5g6h,154263,milano1,bambi1,bruins77,rugby2,jamal1,bolita,sundaypunch,bubba12,realmadr,vfyxtcnth,iwojima,notlob,black666,valkiria,nexus1,millerti,birthday100,swiss1,appollo,gefest,greeneyes,celebrat,tigerr,slava123,izumrud,bubbabub,legoman,joesmith,katya123,sweetdream,john44,wwwwwww1,oooooo1,socal,lovespor,s5r8ed67s,258147,heidis,cowboy22,wachovia,michaelb,qwe1234567,i12345,255225,goldie1,alfa155,45colt,safeu851,antonova,longtong,1sparky,gfvznm,busen,hjlbjy,whateva,rocky4,cokeman,joshua3,kekskek1,sirocco,jagman,123456qwert,phinupi,thomas10,loller,sakur,vika2011,fullred,mariska,azucar,ncstate,glenn74,halima,aleshka,ilovemylife,verlaat,baggie,scoubidou6,phatboy,jbruton,scoop1,barney11,blindman,def456,maximus2,master55,nestea,11223355,diego123,sexpistols,sniffy,philip1,f12345,prisonbreak,nokia2700,ajnjuhfa,yankees3,colfax,ak470000,mtnman,bdfyeirf,fotball,ichbin,trebla,ilusha,riobravo,beaner1,thoradin,polkaudi,kurosawa,honda123,ladybu,valerik,poltava,saviola,fuckyouguys,754740g0,anallove,microlab1,juris01,ncc1864,garfild,shania1,qagsud,makarenko,cindy69,lebedev,andrew11,johnnybo,groovy1,booster1,sanders1,tommyb,johnson4,kd189nlcih,hondaman,vlasova,chick1,sokada,sevisgur,bear2327,chacho,sexmania,roma1993,hjcnbckfd,valley1,howdie,tuppence,jimandanne,strike3,y4kuz4,nhfnfnf,tsubasa,19955991,scabby,quincunx,dima1998,uuuuuu1,logica,skinner1,pinguino,lisa1234,xpressmusic,getfucked,qqqq1,bbbb1,matulino,ulyana,upsman,johnsmith,123579,co2000,spanner1,todiefor,mangoes,isabel1,123852,negra,snowdon,nikki123,bronx1,booom,ram2500,chuck123,fireboy,creek1,batman13,princesse,az12345,maksat,1knight,28infern,241455,r7112s,muselman,mets1986,katydid,vlad777,playme,kmfdm1,asssex,1prince,iop890,bigbroth,mollymoo,waitron,lizottes,125412,juggler,quinta,0sister0,zanardi,nata123,heckfyxbr,22q04w90e,engine2,nikita95,zamira,hammer22,lutscher,carolina1,zz6319,sanman,vfuflfy,buster99,rossco,kourniko,aggarwal,tattoo1,janice1,finger1,125521,19911992,shdwlnds,rudenko,vfvfgfgf123,galatea,monkeybu,juhani,premiumcash,classact,devilmay,helpme2,knuddel,hardpack,ramil,perrit,basil1,zombie13,stockcar,tos8217,honeypie,nowayman,alphadog,melon1,talula,125689,tiribon12,tornike,haribol,telefone,tiger22,sucka,lfytxrf,chicken123,muggins,a23456,b1234567,lytdybr,otter1,pippa,vasilisk,cooking1,helter,78978,bestboy,viper7,ahmed1,whitewol,mommys,apple5,shazam1,chelsea7,kumiko,masterma,rallye,bushmast,jkz123,entrar,andrew6,nathan01,alaric,tavasz,heimdall,gravy1,jimmy99,cthlwt,powerr,gthtrhtcnjr,canesfan,sasha11,ybrbnf_25,august9,brucie,artichok,arnie1,superdude,tarelka,mickey22,dooper,luners,holeshot,good123,gettysbu,bicho,hammer99,divine5,1zxcvbn,stronzo,q22222,disne,bmw750il,godhead,hallodu,aerith,nastik,differen,cestmoi,amber69,5string,pornosta,dirtygirl,ginger123,formel1,scott12,honda200,hotspurs,johnatha,firstone123,lexmark1,msconfig,karlmasc,l123456,123qweasdzx,baldman,sungod,furka,retsub,9811020,ryder1,tcglyued,astron,lbvfcbr,minddoc,dirt49,baseball12,tbear,simpl,schuey,artimus,bikman,plat1num,quantex,gotyou,hailey1,justin01,ellada,8481068,000002,manimal,dthjybxrf,buck123,dick123,6969696,nospam,strong1,kodeord,bama12,123321w,superman123,gladiolus,nintend,5792076,dreamgirl,spankme1,gautam,arianna1,titti,tetas,cool1234,belladog,importan,4206969,87e5nclizry,teufelo7,doller,yfl.irf,quaresma,3440172,melis,bradle,nnmaster,fast1,iverso,blargh,lucas12,chrisg,iamsam,123321az,tomjerry,kawika,2597174,standrew,billyg,muskan,gizmodo2,rz93qpmq,870621345,sathya,qmezrxg4,januari,marthe,moom4261,cum2me,hkger286,lou1988,suckit1,croaker,klaudia1,753951456,aidan1,fsunoles,romanenko,abbydog,isthebes,akshay,corgi,fuck666,walkman555,ranger98,scorpian,hardwareid,bluedragon,fastman,2305822q,iddqdiddqd,1597532,gopokes,zvfrfcb,w1234567,sputnik1,tr1993,pa$$w0rd,2i5fdruv,havvoc,1357913,1313131,bnm123,cowd00d,flexscan,thesims2,boogiema,bigsexxy,powerstr,ngc4565,joshman,babyboy1,123jlb,funfunfu,qwe456,honor1,puttana,bobbyj,daniel21,pussy12,shmuck,1232580,123578951,maxthedo,hithere1,bond0007,gehenna,nomames,blueone,r1234567,bwana,gatinho,1011111,torrents,cinta,123451234,tiger25,money69,edibey,pointman,mmcm19,wales1,caffreys,phaedra,bloodlus,321ret32,rufuss,tarbit,joanna1,102030405,stickboy,lotrfotr34,jamshid,mclarenf1,ataman,99ford,yarrak,logan2,ironlung,pushistik,dragoon1,unclebob,tigereye,pinokio,tylerj,mermaid1,stevie1,jaylen,888777,ramana,roman777,brandon7,17711771s,thiago,luigi1,edgar1,brucey,videogam,classi,birder,faramir,twiddle,cubalibre,grizzy,fucky,jjvwd4,august15,idinahui,ranita,nikita1998,123342,w1w2w3,78621323,4cancel,789963,(null,vassago,jaydog472,123452,timt42,canada99,123589,rebenok,htyfnf,785001,osipov,maks123,neverwinter,love2010,777222,67390436,eleanor1,bykemo,aquemini,frogg,roboto,thorny,shipmate,logcabin,66005918,nokian,gonzos,louisian,1abcdefg,triathlo,ilovemar,couger,letmeino,supera,runvs,fibonacci,muttly,58565254,5thgbqi,vfnehsv,electr,jose12,artemis1,newlove,thd1shr,hawkey,grigoryan,saisha,tosca,redder,lifesux,temple1,bunnyman,thekids,sabbeth,tarzan1,182838,158uefas,dell50,1super,666222,47ds8x,jackhamm,mineonly,rfnfhbyf,048ro,665259,kristina1,bombero,52545856,secure1,bigloser,peterk,alex2,51525354,anarchy1,superx,teenslut,money23,sigmapi,sanfrancisco,acme34,private5,eclips,qwerttrewq,axelle,kokain,hardguy,peter69,jesuschr,dyanna,dude69,sarah69,toyota91,amberr,45645645,bugmenot,bigted,44556677,556644,wwr8x9pu,alphaome,harley13,kolia123,wejrpfpu,revelati,nairda,sodoff,cityboy,pinkpussy,dkalis,miami305,wow12345,triplet,tannenbau,asdfasdf1,darkhors,527952,retired1,soxfan,nfyz123,37583867,goddes,515069,gxlmxbewym,1warrior,36925814,dmb2011,topten,karpova,89876065093rax,naturals,gateway9,cepseoun,turbot,493949,cock22,italia1,sasafras,gopnik,stalke,1qazxdr5,wm2006,ace1062,alieva,blue28,aracel,sandia,motoguzz,terri1,emmajane,conej,recoba,alex1995,jerkyboy,cowboy12,arenrone,precisio,31415927,scsa316,panzer1,studly1,powerhou,bensam,mashoutq,billee,eeyore1,reape,thebeatl,rul3z,montesa,doodle1,cvzefh1gk,424365,a159753,zimmerma,gumdrop,ashaman,grimreap,icandoit,borodina,branca,dima2009,keywest1,vaders,bubluk,diavolo,assss,goleta,eatass,napster1,382436,369741,5411pimo,lenchik,pikach,gilgamesh,kalimera,singer1,gordon2,rjycnbnewbz,maulwurf,joker13,2much4u,bond00,alice123,robotec,fuckgirl,zgjybz,redhorse,margaret1,brady1,pumpkin2,chinky,fourplay,1booger,roisin,1brandon,sandan,blackheart,cheez,blackfin,cntgfyjdf,mymoney1,09080706,goodboss,sebring1,rose1,kensingt,bigboner,marcus12,ym3cautj,struppi,thestone,lovebugs,stater,silver99,forest99,qazwsx12345,vasile,longboar,mkonji,huligan,rhfcbdfz,airmail,porn11,1ooooo,sofun,snake2,msouthwa,dougla,1iceman,shahrukh,sharona,dragon666,france98,196800,196820,ps253535,zjses9evpa,sniper01,design1,konfeta,jack99,drum66,good4you,station2,brucew,regedit,school12,mvtnr765,pub113,fantas,tiburon1,king99,ghjcnjgbpltw,checkito,308win,1ladybug,corneliu,svetasveta,197430,icicle,imaccess,ou81269,jjjdsl,brandon6,bimbo1,smokee,piccolo1,3611jcmg,children2,cookie2,conor1,darth1,margera,aoi856,paully,ou812345,sklave,eklhigcz,30624700,amazing1,wahooo,seau55,1beer,apples2,chulo,dolphin9,heather6,198206,198207,hergood,miracle1,njhyflj,4real,milka,silverfi,fabfive,spring12,ermine,mammy,jumpjet,adilbek,toscana,caustic,hotlove,sammy69,lolita1,byoung,whipme,barney01,mistys,tree1,buster3,kaylin,gfccgjhn,132333,aishiteru,pangaea,fathead1,smurph,198701,ryslan,gasto,xexeylhf,anisimov,chevyss,saskatoo,brandy12,tweaker,irish123,music2,denny1,palpatin,outlaw1,lovesuck,woman1,mrpibb,diadora,hfnfneq,poulette,harlock,mclaren1,cooper12,newpass3,bobby12,rfgecnfcerf,alskdjfh,mini14,dukers,raffael,199103,cleo123,1234567qwertyu,mossberg,scoopy,dctulf,starline,hjvjxrf,misfits1,rangers2,bilbos,blackhea,pappnase,atwork,purple2,daywalker,summoner,1jjjjjjj,swansong,chris10,laluna,12345qqq,charly1,lionsden,money99,silver33,hoghead,bdaddy,199430,saisg002,nosaints,tirpitz,1gggggg,jason13,kingss,ernest1,0cdh0v99ue,pkunzip,arowana,spiri,deskjet1,armine,lances,magic2,thetaxi,14159265,cacique,14142135,orange10,richard0,backdraf,255ooo,humtum,kohsamui,c43dae874d,wrestling1,cbhtym,sorento,megha,pepsiman,qweqwe12,bliss7,mario64,korolev,balls123,schlange,gordit,optiquest,fatdick,fish99,richy,nottoday,dianne1,armyof1,1234qwerasdfzxcv,bbonds,aekara,lidiya,baddog1,yellow5,funkie,ryan01,greentree,gcheckout,marshal1,liliput,000000z,rfhbyrf,gtogto43,rumpole,tarado,marcelit,aqwzsxedc,kenshin1,sassydog,system12,belly1,zilla,kissfan,tools1,desember,donsdad,nick11,scorpio6,poopoo1,toto99,steph123,dogfuck,rocket21,thx113,dude12,sanek,sommar,smacky,pimpsta,letmego,k1200rs,lytghjgtnhjdcr,abigale,buddog,deles,baseball9,roofus,carlsbad,hamzah,hereiam,genial,schoolgirlie,yfz450,breads,piesek,washear,chimay,apocalyp,nicole18,gfgf1234,gobulls,dnevnik,wonderwall,beer1234,1moose,beer69,maryann1,adpass,mike34,birdcage,hottuna,gigant,penquin,praveen,donna123,123lol123,thesame,fregat,adidas11,selrahc,pandoras,test3,chasmo,111222333000,pecos,daniel11,ingersol,shana1,mama12345,cessna15,myhero,1simpson,nazarenko,cognit,seattle2,irina1,azfpc310,rfycthdf,hardy1,jazmyn,sl1200,hotlanta,jason22,kumar123,sujatha,fsd9shtyu,highjump,changer,entertai,kolding,mrbig,sayuri,eagle21,qwertzu,jorge1,0101dd,bigdong,ou812a,sinatra1,htcnjhfy,oleg123,videoman,pbyfblf,tv612se,bigbird1,kenaidog,gunite,silverma,ardmore,123123qq,hotbot,cascada,cbr600f4,harakiri,chico123,boscos,aaron12,glasgow1,kmn5hc,lanfear,1light,liveoak,fizika,ybrjkftdyf,surfside,intermilan,multipas,redcard,72chevy,balata,coolio1,schroede,kanat,testerer,camion,kierra,hejmeddig,antonio2,tornados,isidor,pinkey,n8skfswa,ginny1,houndog,1bill,chris25,hastur,1marine,greatdan,french1,hatman,123qqq,z1z2z3z4,kicker1,katiedog,usopen,smith22,mrmagoo,1234512i,assa123,7seven7,monster7,june12,bpvtyf,149521,guenter,alex1985,voronina,mbkugegs,zaqwsxcderfv,rusty5,mystic1,master0,abcdef12,jndfkb,r4zpm3,cheesey,skripka,blackwhite,sharon69,dro8smwq,lektor,techman,boognish,deidara,heckfyf,quietkey,authcode,monkey4,jayboy,pinkerto,merengue,chulita,bushwick,turambar,kittykit,joseph2,dad123,kristo,pepote,scheiss,hambone1,bigballa,restaura,tequil,111luzer,euro2000,motox,denhaag,chelsi,flaco1,preeti,lillo,1001sin,passw,august24,beatoff,555555d,willis1,kissthis,qwertyz,rvgmw2gl,iloveboobies,timati,kimbo,msinfo,dewdrop,sdbaker,fcc5nky2,messiah1,catboy,small1,chode,beastie1,star77,hvidovre,short1,xavie,dagobah,alex1987,papageno,dakota2,toonami,fuerte,jesus33,lawina,souppp,dirtybir,chrish,naturist,channel1,peyote,flibble,gutentag,lactate,killem,zucchero,robinho,ditka,grumpy1,avr7000,boxxer,topcop,berry1,mypass1,beverly1,deuce1,9638527410,cthuttdf,kzkmrf,lovethem,band1t,cantona1,purple11,apples123,wonderwo,123a456,fuzzie,lucky99,dancer2,hoddling,rockcity,winner12,spooty,mansfiel,aimee1,287hf71h,rudiger,culebra,god123,agent86,daniel0,bunky1,notmine,9ball,goofus,puffy1,xyh28af4,kulikov,bankshot,vurdf5i2,kevinm,ercole,sexygirls,razvan,october7,goater,lollie,raissa,thefrog,mdmaiwa3,mascha,jesussaves,union1,anthony9,crossroa,brother2,areyuke,rodman91,toonsex,dopeman,gericom,vaz2115,cockgobbler,12356789,12345699,signatur,alexandra1,coolwhip,erwin1,awdrgyjilp,pens66,ghjrjgtyrj,linkinpark,emergenc,psych0,blood666,bootmort,wetworks,piroca,johnd,iamthe1,supermario,homer69,flameon,image1,bebert,fylhtq1,annapoli,apple11,hockey22,10048,indahouse,mykiss,1penguin,markp,misha123,foghat,march11,hank1,santorin,defcon4,tampico,vbnhjafy,robert22,bunkie,athlon64,sex777,nextdoor,koskesh,lolnoob,seemnemaailm,black23,march15,yeehaa,chiqui,teagan,siegheil,monday2,cornhusk,mamusia,chilis,sthgrtst,feldspar,scottm,pugdog,rfghjy,micmac,gtnhjdyf,terminato,1jackson,kakosja,bogomol,123321aa,rkbvtyrj,tresor,tigertig,fuckitall,vbkkbjy,caramon,zxc12,balin,dildo1,soccer09,avata,abby123,cheetah1,marquise,jennyc,hondavfr,tinti,anna1985,dennis2,jorel,mayflowe,icema,hal2000,nikkis,bigmouth,greenery,nurjan,leonov,liberty7,fafnir,larionov,sat321321,byteme1,nausicaa,hjvfynbrf,everto,zebra123,sergio1,titone,wisdom1,kahala,104328q,marcin1,salima,pcitra,1nnnnn,nalini,galvesto,neeraj,rick1,squeeky,agnes1,jitterbu,agshar,maria12,0112358,traxxas,stivone,prophet1,bananza,sommer1,canoneos,hotfun,redsox11,1bigmac,dctdjkjl,legion1,everclea,valenok,black9,danny001,roxie1,1theman,mudslide,july16,lechef,chula,glamis,emilka,canbeef,ioanna,cactus1,rockshox,im2cool,ninja9,thvfrjdf,june28,milo17,missyou,micky1,nbibyf,nokiaa,goldi,mattias,fuckthem,asdzxc123,ironfist,junior01,nesta,crazzy,killswit,hygge,zantac,kazama,melvin1,allston,maandag,hiccup,prototyp,specboot,dwl610,hello6,159456,baldhead,redwhite,calpoly,whitetail,agile1,cousteau,matt01,aust1n,malcolmx,gjlfhjr,semperf1,ferarri,a1b2c3d,vangelis,mkvdari,bettis36,andzia,comand,tazzman,morgaine,pepluv,anna1990,inandout,anetka,anna1997,wallpape,moonrake,huntress,hogtie,cameron7,sammy7,singe11,clownboy,newzeala,wilmar,safrane,rebeld,poopi,granat,hammertime,nermin,11251422,xyzzy1,bogeys,jkmxbr,fktrcfyl,11223311,nfyrbcn,11223300,powerpla,zoedog,ybrbnbyf,zaphod42,tarawa,jxfhjdfirf,dude1234,g5wks9,goobe,czekolada,blackros,amaranth,medical1,thereds,julija,nhecsyfujkjdt,promopas,buddy4,marmalad,weihnachten,tronic,letici,passthief,67mustan,ds7zamnw,morri,w8woord,cheops,pinarell,sonofsam,av473dv,sf161pn,5c92v5h6,purple13,tango123,plant1,1baby,xufrgemw,fitta,1rangers,spawns,kenned,taratata,19944991,11111118,coronas,4ebouux8,roadrash,corvette1,dfyjdf846,marley12,qwaszxerdfcv,68stang,67stang,racin,ellehcim,sofiko,nicetry,seabass1,jazzman1,zaqwsx1,laz2937,uuuuuuu1,vlad123,rafale,j1234567,223366,nnnnnn1,226622,junkfood,asilas,cer980,daddymac,persepho,neelam,00700,shithappens,255555,qwertyy,xbox36,19755791,qweasd1,bearcub,jerryb,a1b1c1,polkaudio,basketball1,456rty,1loveyou,marcus2,mama1961,palace1,transcend,shuriken,sudhakar,teenlove,anabelle,matrix99,pogoda,notme,bartend,jordana,nihaoma,ataris,littlegi,ferraris,redarmy,giallo,fastdraw,accountbloc,peludo,pornostar,pinoyako,cindee,glassjaw,dameon,johnnyd,finnland,saudade,losbravo,slonko,toplay,smalltit,nicksfun,stockhol,penpal,caraj,divedeep,cannibus,poppydog,pass88,viktory,walhalla,arisia,lucozade,goldenbo,tigers11,caball,ownage123,tonna,handy1,johny,capital5,faith2,stillher,brandan,pooky1,antananarivu,hotdick,1justin,lacrimos,goathead,bobrik,cgtwbfkbcn,maywood,kamilek,gbplf123,gulnar,beanhead,vfvjyn,shash,viper69,ttttttt1,hondacr,kanako,muffer,dukies,justin123,agapov58,mushka,bad11bad,muleman,jojo123,andreika,makeit,vanill,boomers,bigals,merlin11,quacker,aurelien,spartak1922,ligeti,diana2,lawnmowe,fortune1,awesom,rockyy,anna1994,oinker,love88,eastbay,ab55484,poker0,ozzy666,papasmurf,antihero,photogra,ktm250,painkill,jegr2d2,p3orion,canman,dextur,qwest123,samboy,yomismo,sierra01,herber,vfrcbvvfrcbv,gloria1,llama1,pie123,bobbyjoe,buzzkill,skidrow,grabber,phili,javier1,9379992q,geroin,oleg1994,sovereig,rollover,zaq12qaz,battery1,killer13,alina123,groucho1,mario12,peter22,butterbean,elise1,lucycat,neo123,ferdi,golfer01,randie,gfhfyjbr,ventura1,chelsea3,pinoy,mtgox,yrrim7,shoeman,mirko,ffggyyo,65mustan,ufdibyjd,john55,suckfuck,greatgoo,fvfnjhb,mmmnnn,love20,1bullshi,sucesso,easy1234,robin123,rockets1,diamondb,wolfee,nothing0,joker777,glasnost,richar1,guille,sayan,koresh,goshawk,alexx,batman21,a123456b,hball,243122,rockandr,coolfool,isaia,mary1,yjdbrjdf,lolopc,cleocat,cimbo,lovehina,8vfhnf,passking,bonapart,diamond2,bigboys,kreator,ctvtyjdf,sassy123,shellac,table54781,nedkelly,philbert,sux2bu,nomis,sparky99,python1,littlebear,numpty,silmaril,sweeet,jamesw,cbufhtnf,peggysue,wodahs,luvsex,wizardry,venom123,love4you,bama1,samat,reviewpass,ned467,cjkjdtq,mamula,gijoe,amersham,devochka,redhill,gisel,preggo,polock,cando,rewster,greenlantern,panasonik,dave1234,mikeee,1carlos,miledi,darkness1,p0o9i8u7y6,kathryn1,happyguy,dcp500,assmaster,sambuka,sailormo,antonio3,logans,18254288,nokiax2,qwertzuiop,zavilov,totti,xenon1,edward11,targa1,something1,tony_t,q1w2e3r4t5y6u7i8o9p0,02551670,vladimir1,monkeybutt,greenda,neel21,craiger,saveliy,dei008,honda450,fylhtq95,spike2,fjnq8915,passwordstandard,vova12345,talonesi,richi,gigemags,pierre1,westin,trevoga,dorothee,bastogne,25563o,brandon3,truegrit,krimml,iamgreat,servis,a112233,paulinka,azimuth,corperfmonsy,358hkyp,homerun1,dogbert1,eatmyass,cottage1,savina,baseball7,bigtex,gimmesum,asdcxz,lennon1,a159357,1bastard,413276191q,pngfilt,pchealth,netsnip,bodiroga,1matt,webtvs,ravers,adapters,siddis,mashamasha,coffee2,myhoney,anna1982,marcia1,fairchil,maniek,iloveluc,batmonh,wildon,bowie1,netnwlnk,fancy1,tom204,olga1976,vfif123,queens1,ajax01,lovess,mockba,icam4usb,triada,odinthor,rstlne,exciter,sundog,anchorat,girls69,nfnmzyrf,soloma,gti16v,shadowman,ottom,rataros,tonchin,vishal,chicken0,pornlo,christiaan,volante,likesit,mariupol,runfast,gbpltw123,missys,villevalo,kbpjxrf,ghibli,calla,cessna172,kinglear,dell11,swift1,walera,1cricket,pussy5,turbo911,tucke,maprchem56458,rosehill,thekiwi1,ygfxbkgt,mandarinka,98xa29,magnit,cjfrf,paswoord,grandam1,shenmue,leedsuni,hatrick,zagadka,angeldog,michaell,dance123,koichi,bballs,29palms,xanth,228822,ppppppp1,1kkkkk,1lllll,mynewbots,spurss,madmax1,224455,city1,mmmmmmm1,nnnnnnn1,biedronka,thebeatles,elessar,f14tomcat,jordan18,bobo123,ayi000,tedbear,86chevyx,user123,bobolink,maktub,elmer1,flyfishi,franco1,gandalf0,traxdata,david21,enlighte,dmitrij,beckys,1giants,flippe,12345678w,jossie,rugbyman,snowcat,rapeme,peanut11,gemeni,udders,techn9ne,armani1,chappie,war123,vakantie,maddawg,sewanee,jake5253,tautt1,anthony5,letterma,jimbo2,kmdtyjr,hextall,jessica6,amiga500,hotcunt,phoenix9,veronda,saqartvelo,scubas,sixer3,williamj,nightfal,shihan,melnikova,kosssss,handily,killer77,jhrl0821,march17,rushman,6gcf636i,metoyou,irina123,mine11,primus1,formatters,matthew5,infotech,gangster1,jordan45,moose69,kompas,motoxxx,greatwhi,cobra12,kirpich,weezer1,hello23,montse,tracy123,connecte,cjymrf,hemingwa,azreal,gundam00,mobila,boxman,slayers1,ravshan,june26,fktrcfylhjd,bermuda1,tylerd,maersk,qazwsx11,eybdthcbntn,ash123,camelo,kat123,backd00r,cheyenne1,1king,jerkin,tnt123,trabant,warhammer40k,rambos,punto,home77,pedrito,1frank,brille,guitarman,george13,rakas,tgbxtcrbq,flute1,bananas1,lovezp1314,thespot,postie,buster69,sexytime,twistys,zacharia,sportage,toccata,denver7,terry123,bogdanova,devil69,higgins1,whatluck,pele10,kkk666,jeffery1,1qayxsw2,riptide1,chevy11,munchy,lazer1,hooker1,ghfgjh,vergesse,playgrou,4077mash,gusev,humpin,oneputt,hydepark,monster9,tiger8,tangsoo,guy123,hesoyam1,uhtqneyu,thanku,lomond,ortezza,kronik,geetha,rabbit66,killas,qazxswe,alabaste,1234567890qwerty,capone1,andrea12,geral,beatbox,slutfuck,booyaka,jasmine7,ostsee,maestro1,beatme,tracey1,buster123,donaldduck,ironfish,happy6,konnichi,gintonic,momoney1,dugan1,today2,enkidu,destiny2,trim7gun,katuha,fractals,morganstanley,polkadot,gotime,prince11,204060,fifa2010,bobbyt,seemee,amanda10,airbrush,bigtitty,heidie,layla1,cotton1,5speed,fyfnjkmtdyf,flynavy,joxury8f,meeko,akuma,dudley1,flyboy1,moondog1,trotters,mariami,signin,chinna,legs11,pussy4,1s1h1e1f1,felici,optimus1,iluvu,marlins1,gavaec,balance1,glock40,london01,kokot,southwes,comfort1,sammy11,rockbottom,brianc,litebeer,homero,chopsuey,greenlan,charit,freecell,hampster,smalldog,viper12,blofeld,1234567890987654321,realsex,romann,cartman2,cjdthitycndj,nelly1,bmw528,zwezda,masterba,jeep99,turtl,america2,sunburst,sanyco,auntjudy,125wm,blue10,qwsazx,cartma,toby12,robbob,red222,ilovecock,losfix16,1explore,helge,vaz2114,whynotme,baba123,mugen,1qazwsxedc,albertjr,0101198,sextime,supras,nicolas2,wantsex,pussy6,checkm8,winam,24gordon,misterme,curlew,gbljhfcs,medtech,franzi,butthea,voivod,blackhat,egoiste,pjkeirf,maddog69,pakalolo,hockey4,igor1234,rouges,snowhite,homefree,sexfreak,acer12,dsmith,blessyou,199410,vfrcbvjd,falco02,belinda1,yaglasph,april21,groundho,jasmin1,nevergiveup,elvir,gborv526,c00kie,emma01,awesome2,larina,mike12345,maximu,anupam,bltynbabrfwbz,tanushka,sukkel,raptor22,josh12,schalke04,cosmodog,fuckyou8,busybee,198800,bijoux,frame1,blackmor,giveit,issmall,bear13,123-123,bladez,littlegirl,ultra123,fletch1,flashnet,loploprock,rkelly,12step,lukas1,littlewhore,cuntfinger,stinkyfinger,laurenc,198020,n7td4bjl,jackie69,camel123,ben1234,1gateway,adelheid,fatmike,thuglove,zzaaqq,chivas1,4815162342q,mamadou,nadano,james22,benwin,andrea99,rjirf,michou,abkbgg,d50gnn,aaazzz,a123654,blankman,booboo11,medicus,bigbone,197200,justine1,bendix,morphius,njhvjp,44mag,zsecyus56,goodbye1,nokiadermo,a333444,waratsea,4rzp8ab7,fevral,brillian,kirbys,minim,erathia,grazia,zxcvb1234,dukey,snaggle,poppi,hymen,1video,dune2000,jpthjdf,cvbn123,zcxfcnkbdfz,astonv,ginnie,316271,engine3,pr1ncess,64chevy,glass1,laotzu,hollyy,comicbooks,assasins,nuaddn9561,scottsda,hfcnfvfy,accobra,7777777z,werty123,metalhead,romanson,redsand,365214,shalo,arsenii,1989cc,sissi,duramax,382563,petera,414243,mamapap,jollymon,field1,fatgirl,janets,trompete,matchbox20,rambo2,nepenthe,441232,qwertyuiop10,bozo123,phezc419hv,romantika,lifestyl,pengui,decembre,demon6,panther6,444888,scanman,ghjcnjabkz,pachanga,buzzword,indianer,spiderman3,tony12,startre,frog1,fyutk,483422,tupacshakur,albert12,1drummer,bmw328i,green17,aerdna,invisibl,summer13,calimer,mustaine,lgnu9d,morefun,hesoyam123,escort1,scrapland,stargat,barabbas,dead13,545645,mexicali,sierr,gfhfpbn,gonchar,moonstafa,searock,counte,foster1,jayhawk1,floren,maremma,nastya2010,softball1,adaptec,halloo,barrabas,zxcasd123,hunny,mariana1,kafedra,freedom0,green420,vlad1234,method7,665566,tooting,hallo12,davinchi,conducto,medias,666444,invernes,madhatter,456asd,12345678i,687887,le33px,spring00,help123,bellybut,billy5,vitalik1,river123,gorila,bendis,power666,747200,footslav,acehigh,qazxswedc123,q1a1z1,richard9,peterburg,tabletop,gavrilov,123qwe1,kolosov,fredrau,run4fun,789056,jkbvgbflf,chitra,87654321q,steve22,wideopen,access88,surfe,tdfyutkbjy,impossib,kevin69,880888,cantina,887766,wxcvb,dontforg,qwer1209,asslicke,mamma123,indig,arkasha,scrapp,morelia,vehxbr,jones2,scratch1,cody11,cassie12,gerbera,dontgotm,underhil,maks2010,hollywood1,hanibal,elena2010,jason11,1010321,stewar,elaman,fireplug,goodby,sacrific,babyphat,bobcat12,bruce123,1233215,tony45,tiburo,love15,bmw750,wallstreet,2h0t4me,1346795,lamerz,munkee,134679q,granvill,1512198,armastus,aiden1,pipeutvj,g1234567,angeleyes,usmc1,102030q,putangina,brandnew,shadowfax,eagles12,1falcon,brianw,lokomoti,2022958,scooper,pegas,jabroni1,2121212,buffal,siffredi,wewiz,twotone,rosebudd,nightwis,carpet1,mickey2,2525252,sleddog,red333,jamesm,2797349,jeff12,onizuka,felixxxx,rf6666,fine1,ohlala,forplay,chicago5,muncho,scooby11,ptichka,johnnn,19851985p,dogphil3650,totenkopf,monitor2,macross7,3816778,dudder,semaj1,bounder,racerx1,5556633,7085506,ofclr278,brody1,7506751,nantucke,hedj2n4q,drew1,aessedai,trekbike,pussykat,samatron,imani,9124852,wiley1,dukenukem,iampurehaha2,9556035,obvious1,mccool24,apache64,kravchenko,justforf,basura,jamese,s0ccer,safado,darksta,surfer69,damian1,gjpbnbd,gunny1,wolley,sananton,zxcvbn123456,odt4p6sv8,sergei1,modem1,mansikka,zzzz1,rifraf,dima777,mary69,looking4,donttell,red100,ninjutsu,uaeuaeman,bigbri,brasco,queenas8151,demetri,angel007,bubbl,kolort,conny,antonia1,avtoritet,kaka22,kailayu,sassy2,wrongway,chevy3,1nascar,patriots1,chrisrey,mike99,sexy22,chkdsk,sd3utre7,padawan,a6pihd,doming,mesohorny,tamada,donatello,emma22,eather,susan69,pinky123,stud69,fatbitch,pilsbury,thc420,lovepuss,1creativ,golf1234,hurryup,1honda,huskerdu,marino1,gowron,girl1,fucktoy,gtnhjpfdjlcr,dkjfghdk,pinkfl,loreli,7777777s,donkeykong,rockytop,staples1,sone4ka,xxxjay,flywheel,toppdogg,bigbubba,aaa123456,2letmein,shavkat,paule,dlanor,adamas,0147852,aassaa,dixon1,bmw328,mother12,ilikepussy,holly2,tsmith,excaliber,fhutynbyf,nicole3,tulipan,emanue,flyvholm,currahee,godsgift,antonioj,torito,dinky1,sanna,yfcnzvjz,june14,anime123,123321456654,hanswurst,bandman,hello101,xxxyyy,chevy69,technica,tagada,arnol,v00d00,lilone,filles,drumandbass,dinamit,a1234a,eatmeat,elway07,inout,james6,dawid1,thewolf,diapason,yodaddy,qscwdv,fuckit1,liljoe,sloeber,simbacat,sascha1,qwe1234,1badger,prisca,angel17,gravedig,jakeyboy,longboard,truskawka,golfer11,pyramid7,highspee,pistola,theriver,hammer69,1packers,dannyd,alfonse,qwertgfdsa,11119999,basket1,ghjtrn,saralee,12inches,paolo1,zse4xdr5,taproot,sophieh6,grizzlie,hockey69,danang,biggums,hotbitch,5alive,beloved1,bluewave,dimon95,koketka,multiscan,littleb,leghorn,poker2,delite,skyfir,bigjake,persona1,amberdog,hannah12,derren,ziffle,1sarah,1assword,sparky01,seymur,tomtom1,123321qw,goskins,soccer19,luvbekki,bumhole,2balls,1muffin,borodin,monkey9,yfeiybrb,1alex,betmen,freder,nigger123,azizbek,gjkzrjdf,lilmike,1bigdadd,1rock,taganrog,snappy1,andrey1,kolonka,bunyan,gomango,vivia,clarkkent,satur,gaudeamus,mantaray,1month,whitehea,fargus,andrew99,ray123,redhawks,liza2009,qw12345,den12345,vfhnsyjdf,147258369a,mazepa,newyorke,1arsenal,hondas2000,demona,fordgt,steve12,birthday2,12457896,dickster,edcwsxqaz,sahalin,pantyman,skinny1,hubertus,cumshot1,chiro,kappaman,mark3434,canada12,lichking,bonkers1,ivan1985,sybase,valmet,doors1,deedlit,kyjelly,bdfysx,ford11,throatfuck,backwood,fylhsq,lalit,boss429,kotova,bricky,steveh,joshua19,kissa,imladris,star1234,lubimka,partyman,crazyd,tobias1,ilike69,imhome,whome,fourstar,scanner1,ujhjl312,anatoli,85bears,jimbo69,5678ytr,potapova,nokia7070,sunday1,kalleank,1996gta,refinnej,july1,molodec,nothanks,enigm,12play,sugardog,nhfkbdfkb,larousse,cannon1,144444,qazxcdew,stimorol,jhereg,spawn7,143000,fearme,hambur,merlin21,dobie,is3yeusc,partner1,dekal,varsha,478jfszk,flavi,hippo1,9hmlpyjd,july21,7imjfstw,lexxus,truelov,nokia5200,carlos6,anais,mudbone,anahit,taylorc,tashas,larkspur,animal2000,nibiru,jan123,miyvarxar,deflep,dolore,communit,ifoptfcor,laura2,anadrol,mamaliga,mitzi1,blue92,april15,matveev,kajlas,wowlook1,1flowers,shadow14,alucard1,1golf,bantha,scotlan,singapur,mark13,manchester1,telus01,superdav,jackoff1,madnes,bullnuts,world123,clitty,palmer1,david10,spider10,sargsyan,rattlers,david4,windows2,sony12,visigoth,qqqaaa,penfloor,cabledog,camilla1,natasha123,eagleman,softcore,bobrov,dietmar,divad,sss123,d1234567,tlbyjhju,1q1q1q1,paraiso,dav123,lfiekmrf,drachen,lzhan16889,tplate,gfghbrf,casio1,123boots1,123test,sys64738,heavymetal,andiamo,meduza,soarer,coco12,negrita,amigas,heavymet,bespin,1asdfghj,wharfrat,wetsex,tight1,janus1,sword123,ladeda,dragon98,austin2,atep1,jungle1,12345abcd,lexus300,pheonix1,alex1974,123qw123,137955,bigtim,shadow88,igor1994,goodjob,arzen,champ123,121ebay,changeme1,brooksie,frogman1,buldozer,morrowin,achim,trish1,lasse,festiva,bubbaman,scottb,kramit,august22,tyson123,passsword,oompah,al123456,fucking1,green45,noodle1,looking1,ashlynn,al1716,stang50,coco11,greese,bob111,brennan1,jasonj,1cherry,1q2345,1xxxxxxx,fifa2011,brondby,zachar1,satyam,easy1,magic7,1rainbow,cheezit,1eeeeeee,ashley123,assass1,amanda123,jerbear,1bbbbbb,azerty12,15975391,654321z,twinturb,onlyone1,denis1988,6846kg3r,jumbos,pennydog,dandelion,haileris,epervier,snoopy69,afrodite,oldpussy,green55,poopypan,verymuch,katyusha,recon7,mine69,tangos,contro,blowme2,jade1,skydive1,fiveiron,dimo4ka,bokser,stargirl,fordfocus,tigers2,platina,baseball11,raque,pimper,jawbreak,buster88,walter34,chucko,penchair,horizon1,thecure1,scc1975,adrianna1,kareta,duke12,krille,dumbfuck,cunt1,aldebaran,laverda,harumi,knopfler,pongo1,pfhbyf,dogman1,rossigno,1hardon,scarlets,nuggets1,ibelieve,akinfeev,xfhkbr,athene,falcon69,happie,billly,nitsua,fiocco,qwerty09,gizmo2,slava2,125690,doggy123,craigs,vader123,silkeborg,124365,peterm,123978,krakatoa,123699,123592,kgvebmqy,pensacol,d1d2d3,snowstor,goldenboy,gfg65h7,ev700,church1,orange11,g0dz1ll4,chester3,acheron,cynthi,hotshot1,jesuschris,motdepass,zymurgy,one2one,fietsbel,harryp,wisper,pookster,nn527hp,dolla,milkmaid,rustyboy,terrell1,epsilon1,lillian1,dale3,crhbgrf,maxsim,selecta,mamada,fatman1,ufkjxrf,shinchan,fuckuall,women1,000008,bossss,greta1,rbhjxrf,mamasboy,purple69,felicidade,sexy21,cathay,hunglow,splatt,kahless,shopping1,1gandalf,themis,delta7,moon69,blue24,parliame,mamma1,miyuki,2500hd,jackmeof,razer,rocker1,juvis123,noremac,boing747,9z5ve9rrcz,icewater,titania,alley1,moparman,christo1,oliver2,vinicius,tigerfan,chevyy,joshua99,doda99,matrixx,ekbnrf,jackfrost,viper01,kasia,cnfhsq,triton1,ssbt8ae2,rugby8,ramman,1lucky,barabash,ghtlfntkm,junaid,apeshit,enfant,kenpo1,shit12,007000,marge1,shadow10,qwerty789,richard8,vbitkm,lostboys,jesus4me,richard4,hifive,kolawole,damilola,prisma,paranoya,prince2,lisaann,happyness,cardss,methodma,supercop,a8kd47v5,gamgee,polly123,irene1,number8,hoyasaxa,1digital,matthew0,dclxvi,lisica,roy123,2468013579,sparda,queball,vaffanculo,pass1wor,repmvbx,999666333,freedom8,botanik,777555333,marcos1,lubimaya,flash2,einstei,08080,123456789j,159951159,159357123,carrot1,alina1995,sanjos,dilara,mustang67,wisteria,jhnjgtl12,98766789,darksun,arxangel,87062134,creativ1,malyshka,fuckthemall,barsic,rocksta,2big4u,5nizza,genesis2,romance1,ofcourse,1horse,latenite,cubana,sactown,789456123a,milliona,61808861,57699434,imperia,bubba11,yellow3,change12,55495746,flappy,jimbo123,19372846,19380018,cutlass1,craig123,klepto,beagle1,solus,51502112,pasha1,19822891,46466452,19855891,petshop,nikolaevna,119966,nokia6131,evenpar,hoosier1,contrasena,jawa350,gonzo123,mouse2,115511,eetfuk,gfhfvgfvgfv,1crystal,sofaking,coyote1,kwiatuszek,fhrflbq,valeria1,anthro,0123654789,alltheway,zoltar,maasikas,wildchil,fredonia,earlgrey,gtnhjczy,matrix123,solid1,slavko,12monkeys,fjdksl,inter1,nokia6500,59382113kevinp,spuddy,cachero,coorslit,password!,kiba1z,karizma,vova1994,chicony,english1,bondra12,1rocket,hunden,jimbob1,zpflhjn1,th0mas,deuce22,meatwad,fatfree,congas,sambora,cooper2,janne,clancy1,stonie,busta,kamaz,speedy2,jasmine3,fahayek,arsenal0,beerss,trixie1,boobs69,luansantana,toadman,control2,ewing33,maxcat,mama1964,diamond4,tabaco,joshua0,piper2,music101,guybrush,reynald,pincher,katiebug,starrs,pimphard,frontosa,alex97,cootie,clockwor,belluno,skyeseth,booty69,chaparra,boochie,green4,bobcat1,havok,saraann,pipeman,aekdb,jumpshot,wintermu,chaika,1chester,rjnjatq,emokid,reset1,regal1,j0shua,134679a,asmodey,sarahh,zapidoo,ciccione,sosexy,beckham23,hornets1,alex1971,delerium,manageme,connor11,1rabbit,sane4ek,caseyboy,cbljhjdf,redsox20,tttttt99,haustool,ander,pantera6,passwd1,journey1,9988776655,blue135,writerspace,xiaoyua123,justice2,niagra,cassis,scorpius,bpgjldsgjldthnf,gamemaster,bloody1,retrac,stabbin,toybox,fight1,ytpyf.,glasha,va2001,taylor11,shameles,ladylove,10078,karmann,rodeos,eintritt,lanesra,tobasco,jnrhjqcz,navyman,pablit,leshka,jessica3,123vika,alena1,platinu,ilford,storm7,undernet,sasha777,1legend,anna2002,kanmax1994,porkpie,thunder0,gundog,pallina,easypass,duck1,supermom,roach1,twincam,14028,tiziano,qwerty32,123654789a,evropa,shampoo1,yfxfkmybr,cubby1,tsunami1,fktrcttdf,yasacrac,17098,happyhap,bullrun,rodder,oaktown,holde,isbest,taylor9,reeper,hammer11,julias,rolltide1,compaq123,fourx4,subzero1,hockey9,7mary3,busines,ybrbnjcbr,wagoneer,danniash,portishead,digitex,alex1981,david11,infidel,1snoopy,free30,jaden,tonto1,redcar27,footie,moskwa,thomas21,hammer12,burzum,cosmo123,50000,burltree,54343,54354,vwpassat,jack5225,cougars1,burlpony,blackhorse,alegna,petert,katemoss,ram123,nels0n,ferrina,angel77,cstock,1christi,dave55,abc123a,alex1975,av626ss,flipoff,folgore,max1998,science1,si711ne,yams7,wifey1,sveiks,cabin1,volodia,ox3ford,cartagen,platini,picture1,sparkle1,tiedomi,service321,wooody,christi1,gnasher,brunob,hammie,iraffert,bot2010,dtcyeirf,1234567890p,cooper11,alcoholi,savchenko,adam01,chelsea5,niewiem,icebear,lllooottt,ilovedick,sweetpus,money8,cookie13,rfnthbyf1988,booboo2,angus123,blockbus,david9,chica1,nazaret,samsung9,smile4u,daystar,skinnass,john10,thegirl,sexybeas,wasdwasd1,sigge1,1qa2ws3ed4rf5tg,czarny,ripley1,chris5,ashley19,anitha,pokerman,prevert,trfnthby,tony69,georgia2,stoppedb,qwertyuiop12345,miniclip,franky1,durdom,cabbages,1234567890o,delta5,liudmila,nhfycajhvths,court1,josiew,abcd1,doghead,diman,masiania,songline,boogle,triston,deepika,sexy4me,grapple,spacebal,ebonee,winter0,smokewee,nargiza,dragonla,sassys,andy2000,menards,yoshio,massive1,suckmy1k,passat99,sexybo,nastya1996,isdead,stratcat,hokuto,infix,pidoras,daffyduck,cumhard,baldeagl,kerberos,yardman,shibainu,guitare,cqub6553,tommyy,bk.irf,bigfoo,hecto,july27,james4,biggus,esbjerg,isgod,1irish,phenmarr,jamaic,roma1990,diamond0,yjdbrjd,girls4me,tampa1,kabuto,vaduz,hanse,spieng,dianochka,csm101,lorna1,ogoshi,plhy6hql,2wsx4rfv,cameron0,adebayo,oleg1996,sharipov,bouboule,hollister1,frogss,yeababy,kablam,adelante,memem,howies,thering,cecilia1,onetwo12,ojp123456,jordan9,msorcloledbr,neveraga,evh5150,redwin,1august,canno,1mercede,moody1,mudbug,chessmas,tiikeri,stickdaddy77,alex15,kvartira,7654321a,lollol123,qwaszxedc,algore,solana,vfhbyfvfhbyf,blue72,misha1111,smoke20,junior13,mogli,threee,shannon2,fuckmylife,kevinh,saransk,karenw,isolde,sekirarr,orion123,thomas0,debra1,laketaho,alondra,curiva,jazz1234,1tigers,jambos,lickme2,suomi,gandalf7,028526,zygote,brett123,br1ttany,supafly,159000,kingrat,luton1,cool-ca,bocman,thomasd,skiller,katter,mama777,chanc,tomass,1rachel,oldno7,rfpfyjdf,bigkev,yelrah,primas,osito,kipper1,msvcr71,bigboy11,thesun,noskcaj,chicc,sonja1,lozinka,mobile1,1vader,ummagumma,waves1,punter12,tubgtn,server1,irina1991,magic69,dak001,pandemonium,dead1,berlingo,cherrypi,1montana,lohotron,chicklet,asdfgh123456,stepside,ikmvw103,icebaby,trillium,1sucks,ukrnet,glock9,ab12345,thepower,robert8,thugstools,hockey13,buffon,livefree,sexpics,dessar,ja0000,rosenrot,james10,1fish,svoloch,mykitty,muffin11,evbukb,shwing,artem1992,andrey1992,sheldon1,passpage,nikita99,fubar123,vannasx,eight888,marial,max2010,express2,violentj,2ykn5ccf,spartan11,brenda69,jackiech,abagail,robin2,grass1,andy76,bell1,taison,superme,vika1995,xtr451,fred20,89032073168,denis1984,2000jeep,weetabix,199020,daxter,tevion,panther8,h9iymxmc,bigrig,kalambur,tsalagi,12213443,racecar02,jeffrey4,nataxa,bigsam,purgator,acuracl,troutbum,potsmoke,jimmyz,manutd1,nytimes,pureevil,bearss,cool22,dragonage,nodnarb,dbrbyu,4seasons,freude,elric1,werule,hockey14,12758698,corkie,yeahright,blademan,tafkap,clave,liziko,hofner,jeffhardy,nurich,runne,stanisla,lucy1,monk3y,forzaroma,eric99,bonaire,blackwoo,fengshui,1qaz0okm,newmoney,pimpin69,07078,anonymer,laptop1,cherry12,ace111,salsa1,wilbur1,doom12,diablo23,jgtxzbhr,under1,honda01,breadfan,megan2,juancarlos,stratus1,ackbar,love5683,happytim,lambert1,cbljhtyrj,komarov,spam69,nfhtkrf,brownn,sarmat,ifiksr,spike69,hoangen,angelz,economia,tanzen,avogadro,1vampire,spanners,mazdarx,queequeg,oriana,hershil,sulaco,joseph11,8seconds,aquariu,cumberla,heather9,anthony8,burton12,crystal0,maria3,qazwsxc,snow123,notgood,198520,raindog,heehaw,consulta,dasein,miller01,cthulhu1,dukenuke,iubire,baytown,hatebree,198505,sistem,lena12,welcome01,maraca,middleto,sindhu,mitsou,phoenix5,vovan,donaldo,dylandog,domovoy,lauren12,byrjuybnj,123llll,stillers,sanchin,tulpan,smallvill,1mmmmm,patti1,folgers,mike31,colts18,123456rrr,njkmrjz,phoenix0,biene,ironcity,kasperok,password22,fitnes,matthew6,spotligh,bujhm123,tommycat,hazel5,guitar11,145678,vfcmrf,compass1,willee,1barney,jack2000,littleminge,shemp,derrek,xxx12345,littlefuck,spuds1,karolinka,camneely,qwertyu123,142500,brandon00,munson15,falcon3,passssap,z3cn2erv,goahead,baggio10,141592,denali1,37kazoo,copernic,123456789asd,orange88,bravada,rush211,197700,pablo123,uptheass,samsam1,demoman,mattylad10,heydude,mister2,werken,13467985,marantz,a22222,f1f2f3f4,fm12mn12,gerasimova,burrito1,sony1,glenny,baldeagle,rmfidd,fenomen,verbati,forgetme,5element,wer138,chanel1,ooicu812,10293847qp,minicooper,chispa,myturn,deisel,vthrehbq,boredboi4u,filatova,anabe,poiuyt1,barmalei,yyyy1,fourkids,naumenko,bangbros,pornclub,okaykk,euclid90,warrior3,kornet,palevo,patatina,gocart,antanta,jed1054,clock1,111111w,dewars,mankind1,peugeot406,liten,tahira,howlin,naumov,rmracing,corone,cunthole,passit,rock69,jaguarxj,bumsen,197101,sweet2,197010,whitecat,sawadee,money100,yfhrjnbrb,andyboy,9085603566,trace1,fagget,robot1,angel20,6yhn7ujm,specialinsta,kareena,newblood,chingada,boobies2,bugger1,squad51,133andre,call06,ashes1,ilovelucy,success2,kotton,cavalla,philou,deebee,theband,nine09,artefact,196100,kkkkkkk1,nikolay9,onelov,basia,emilyann,sadman,fkrjujkbr,teamomuch,david777,padrino,money21,firdaus,orion3,chevy01,albatro,erdfcv,2legit,sarah7,torock,kevinn,holio,soloy,enron714,starfleet,qwer11,neverman,doctorwh,lucy11,dino12,trinity7,seatleon,o123456,pimpman,1asdfgh,snakebit,chancho,prorok,bleacher,ramire,darkseed,warhorse,michael123,1spanky,1hotdog,34erdfcv,n0th1ng,dimanche,repmvbyf,michaeljackson,login1,icequeen,toshiro,sperme,racer2,veget,birthday26,daniel9,lbvekmrf,charlus,bryan123,wspanic,schreibe,1andonly,dgoins,kewell,apollo12,egypt1,fernie,tiger21,aa123456789,blowj,spandau,bisquit,12345678d,deadmau5,fredie,311420,happyface,samant,gruppa,filmstar,andrew17,bakesale,sexy01,justlook,cbarkley,paul11,bloodred,rideme,birdbath,nfkbcvfy,jaxson,sirius1,kristof,virgos,nimrod1,hardc0re,killerbee,1abcdef,pitcher1,justonce,vlada,dakota99,vespucci,wpass,outside1,puertori,rfvbkf,teamlosi,vgfun2,porol777,empire11,20091989q,jasong,webuivalidat,escrima,lakers08,trigger2,addpass,342500,mongini,dfhtybr,horndogg,palermo1,136900,babyblu,alla98,dasha2010,jkelly,kernow,yfnecz,rockhopper,toeman,tlaloc,silver77,dave01,kevinr,1234567887654321,135642,me2you,8096468644q,remmus,spider7,jamesa,jilly,samba1,drongo,770129ji,supercat,juntas,tema1234,esthe,1234567892000,drew11,qazqaz123,beegees,blome,rattrace,howhigh,tallboy,rufus2,sunny2,sou812,miller12,indiana7,irnbru,patch123,letmeon,welcome5,nabisco,9hotpoin,hpvteb,lovinit,stormin,assmonke,trill,atlanti,money1234,cubsfan,mello1,stars2,ueptkm,agate,dannym88,lover123,wordz,worldnet,julemand,chaser1,s12345678,pissword,cinemax,woodchuc,point1,hotchkis,packers2,bananana,kalender,420666,penguin8,awo8rx3wa8t,hoppie,metlife,ilovemyfamily,weihnachtsbau,pudding1,luckystr,scully1,fatboy1,amizade,dedham,jahbless,blaat,surrende,****er,1panties,bigasses,ghjuhfvbcn,asshole123,dfktyrb,likeme,nickers,plastik,hektor,deeman,muchacha,cerebro,santana5,testdrive,dracula1,canalc,l1750sq,savannah1,murena,1inside,pokemon00,1iiiiiii,jordan20,sexual1,mailliw,calipso,014702580369,1zzzzzz,1jjjjjj,break1,15253545,yomama1,katinka,kevin11,1ffffff,martijn,sslazio,daniel5,porno2,nosmas,leolion,jscript,15975312,pundai,kelli1,kkkddd,obafgkm,marmaris,lilmama,london123,rfhfnt,elgordo,talk87,daniel7,thesims3,444111,bishkek,afrika2002,toby22,1speedy,daishi,2children,afroman,qqqqwwww,oldskool,hawai,v55555,syndicat,pukimak,fanatik,tiger5,parker01,bri5kev6,timexx,wartburg,love55,ecosse,yelena03,madinina,highway1,uhfdbwfgf,karuna,buhjvfybz,wallie,46and2,khalif,europ,qaz123wsx456,bobbybob,wolfone,falloutboy,manning18,scuba10,schnuff,ihateyou1,lindam,sara123,popcor,fallengun,divine1,montblanc,qwerty8,rooney10,roadrage,bertie1,latinus,lexusis,rhfvfnjhcr,opelgt,hitme,agatka,1yamaha,dmfxhkju,imaloser,michell1,sb211st,silver22,lockedup,andrew9,monica01,sassycat,dsobwick,tinroof,ctrhtnyj,bultaco,rhfcyjzhcr,aaaassss,14ss88,joanne1,momanddad,ahjkjdf,yelhsa,zipdrive,telescop,500600,1sexsex,facial1,motaro,511647,stoner1,temujin,elephant1,greatman,honey69,kociak,ukqmwhj6,altezza,cumquat,zippos,kontiki,123max,altec1,bibigon,tontos,qazsew,nopasaran,militar,supratt,oglala,kobayash,agathe,yawetag,dogs1,cfiekmrf,megan123,jamesdea,porosenok,tiger23,berger1,hello11,seemann,stunner1,walker2,imissu,jabari,minfd,lollol12,hjvfy,1-oct,stjohns,2278124q,123456789qwer,alex1983,glowworm,chicho,mallards,bluedevil,explorer1,543211,casita,1time,lachesis,alex1982,airborn1,dubesor,changa,lizzie1,captaink,socool,bidule,march23,1861brr,k.ljxrf,watchout,fotze,1brian,keksa2,aaaa1122,matrim,providian,privado,dreame,merry1,aregdone,davidt,nounour,twenty2,play2win,artcast2,zontik,552255,shit1,sluggy,552861,dr8350,brooze,alpha69,thunder6,kamelia2011,caleb123,mmxxmm,jamesh,lfybkjd,125267,125000,124536,bliss1,dddsss,indonesi,bob69,123888,tgkbxfgy,gerar,themack,hijodeputa,good4now,ddd123,clk430,kalash,tolkien1,132forever,blackb,whatis,s1s2s3s4,lolkin09,yamahar,48n25rcc,djtiesto,111222333444555,bigbull,blade55,coolbree,kelse,ichwill,yamaha12,sakic,bebeto,katoom,donke,sahar,wahine,645202,god666,berni,starwood,june15,sonoio,time123,llbean,deadsoul,lazarev,cdtnf,ksyusha,madarchod,technik,jamesy,4speed,tenorsax,legshow,yoshi1,chrisbl,44e3ebda,trafalga,heather7,serafima,favorite4,havefun1,wolve,55555r,james13,nosredna,bodean,jlettier,borracho,mickael,marinus,brutu,sweet666,kiborg,rollrock,jackson6,macross1,ousooner,9085084232,takeme,123qwaszx,firedept,vfrfhjd,jackfros,123456789000,briane,cookie11,baby22,bobby18,gromova,systemofadown,martin01,silver01,pimaou,darthmaul,hijinx,commo,chech,skyman,sunse,2vrd6,vladimirovna,uthvfybz,nicole01,kreker,bobo1,v123456789,erxtgb,meetoo,drakcap,vfvf12,misiek1,butane,network2,flyers99,riogrand,jennyk,e12345,spinne,avalon11,lovejone,studen,maint,porsche2,qwerty100,chamberl,bluedog1,sungam,just4u,andrew23,summer22,ludic,musiclover,aguil,beardog1,libertin,pippo1,joselit,patito,bigberth,digler,sydnee,jockstra,poopo,jas4an,nastya123,profil,fuesse,default1,titan2,mendoz,kpcofgs,anamika,brillo021,bomberman,guitar69,latching,69pussy,blues2,phelge,ninja123,m7n56xo,qwertasd,alex1976,cunningh,estrela,gladbach,marillion,mike2000,258046,bypop,muffinman,kd5396b,zeratul,djkxbwf,john77,sigma2,1linda,selur,reppep,quartz1,teen1,freeclus,spook1,kudos4ever,clitring,sexiness,blumpkin,macbook,tileman,centra,escaflowne,pentable,shant,grappa,zverev,1albert,lommerse,coffee11,777123,polkilo,muppet1,alex74,lkjhgfdsazx,olesica,april14,ba25547,souths,jasmi,arashi,smile2,2401pedro,mybabe,alex111,quintain,pimp1,tdeir8b2,makenna,122333444455555,%e2%82%ac,tootsie1,pass111,zaqxsw123,gkfdfybt,cnfnbcnbrf,usermane,iloveyou12,hard69,osasuna,firegod,arvind,babochka,kiss123,cookie123,julie123,kamakazi,dylan2,223355,tanguy,nbhtqa,tigger13,tubby1,makavel,asdflkj,sambo1,mononoke,mickeys,gayguy,win123,green33,wcrfxtvgbjy,bigsmall,1newlife,clove,babyfac,bigwaves,mama1970,shockwav,1friday,bassey,yarddog,codered1,victory7,bigrick,kracker,gulfstre,chris200,sunbanna,bertuzzi,begemotik,kuolema,pondus,destinee,123456789zz,abiodun,flopsy,amadeusptfcor,geronim,yggdrasi,contex,daniel6,suck1,adonis1,moorea,el345612,f22raptor,moviebuf,raunchy,6043dkf,zxcvbnm123456789,eric11,deadmoin,ratiug,nosliw,fannies,danno,888889,blank1,mikey2,gullit,thor99,mamiya,ollieb,thoth,dagger1,websolutionssu,bonker,prive,1346798520,03038,q1234q,mommy2,contax,zhipo,gwendoli,gothic1,1234562000,lovedick,gibso,digital2,space199,b26354,987654123,golive,serious1,pivkoo,better1,824358553,794613258,nata1980,logout,fishpond,buttss,squidly,good4me,redsox19,jhonny,zse45rdx,matrixxx,honey12,ramina,213546879,motzart,fall99,newspape,killit,gimpy,photowiz,olesja,thebus,marco123,147852963,bedbug,147369258,hellbound,gjgjxrf,123987456,lovehurt,five55,hammer01,1234554321a,alina2011,peppino,ang238,questor,112358132,alina1994,alina1998,money77,bobjones,aigerim,cressida,madalena,420smoke,tinchair,raven13,mooser,mauric,lovebu,adidas69,krypton1,1111112,loveline,divin,voshod,michaelm,cocotte,gbkbuhbv,76689295,kellyj,rhonda1,sweetu70,steamforums,geeque,nothere,124c41,quixotic,steam181,1169900,rfcgthcrbq,rfvbkm,sexstuff,1231230,djctvm,rockstar1,fulhamfc,bhecbr,rfntyf,quiksilv,56836803,jedimaster,pangit,gfhjkm777,tocool,1237654,stella12,55378008,19216811,potte,fender12,mortalkombat,ball1,nudegirl,palace22,rattrap,debeers,lickpussy,jimmy6,not4u2c,wert12,bigjuggs,sadomaso,1357924,312mas,laser123,arminia,branford,coastie,mrmojo,19801982,scott11,banaan123,ingres,300zxtt,hooters6,sweeties,19821983,19831985,19833891,sinnfein,welcome4,winner69,killerman,tachyon,tigre1,nymets1,kangol,martinet,sooty1,19921993,789qwe,harsingh,1597535,thecount,phantom3,36985214,lukas123,117711,pakistan1,madmax11,willow01,19932916,fucker12,flhrci,opelagila,theword,ashley24,tigger3,crazyj,rapide,deadfish,allana,31359092,sasha1993,sanders2,discman,zaq!2wsx,boilerma,mickey69,jamesg,babybo,jackson9,orion7,alina2010,indien,breeze1,atease,warspite,bazongaz,1celtic,asguard,mygal,fitzgera,1secret,duke33,cyklone,dipascuc,potapov,1escobar2,c0l0rad0,kki177hk,1little,macondo,victoriya,peter7,red666,winston6,kl?benhavn,muneca,jackme,jennan,happylife,am4h39d8nh,bodybuil,201980,dutchie,biggame,lapo4ka,rauchen,black10,flaquit,water12,31021364,command2,lainth88,mazdamx5,typhon,colin123,rcfhlfc,qwaszx11,g0away,ramir,diesirae,hacked1,cessna1,woodfish,enigma2,pqnr67w5,odgez8j3,grisou,hiheels,5gtgiaxm,2580258,ohotnik,transits,quackers,serjik,makenzie,mdmgatew,bryana,superman12,melly,lokit,thegod,slickone,fun4all,netpass,penhorse,1cooper,nsync,asdasd22,otherside,honeydog,herbie1,chiphi,proghouse,l0nd0n,shagg,select1,frost1996,casper123,countr,magichat,greatzyo,jyothi,3bears,thefly,nikkita,fgjcnjk,nitros,hornys,san123,lightspe,maslova,kimber1,newyork2,spammm,mikejone,pumpk1n,bruiser1,bacons,prelude9,boodie,dragon4,kenneth2,love98,power5,yodude,pumba,thinline,blue30,sexxybj,2dumb2live,matt21,forsale,1carolin,innova,ilikeporn,rbgtkjd,a1s2d3f,wu9942,ruffus,blackboo,qwerty999,draco1,marcelin,hideki,gendalf,trevon,saraha,cartmen,yjhbkmcr,time2go,fanclub,ladder1,chinni,6942987,united99,lindac,quadra,paolit,mainstre,beano002,lincoln7,bellend,anomie,8520456,bangalor,goodstuff,chernov,stepashka,gulla,mike007,frasse,harley03,omnislash,8538622,maryjan,sasha2011,gineok,8807031,hornier,gopinath,princesit,bdr529,godown,bosslady,hakaone,1qwe2,madman1,joshua11,lovegame,bayamon,jedi01,stupid12,sport123,aaa666,tony44,collect1,charliem,chimaira,cx18ka,trrim777,chuckd,thedream,redsox99,goodmorning,delta88,iloveyou11,newlife2,figvam,chicago3,jasonk,12qwer,9875321,lestat1,satcom,conditio,capri50,sayaka,9933162,trunks1,chinga,snooch,alexand1,findus,poekie,cfdbyf,kevind,mike1969,fire13,leftie,bigtuna,chinnu,silence1,celos1,blackdra,alex24,gfgfif,2boobs,happy8,enolagay,sataniv1993,turner1,dylans,peugeo,sasha1994,hoppel,conno,moonshot,santa234,meister1,008800,hanako,tree123,qweras,gfitymrf,reggie31,august29,supert,joshua10,akademia,gbljhfc,zorro123,nathalia,redsox12,hfpdjl,mishmash,nokiae51,nyyankees,tu190022,strongbo,none1,not4u2no,katie2,popart,harlequi,santan,michal1,1therock,screwu,csyekmrf,olemiss1,tyrese,hoople,sunshin1,cucina,starbase,topshelf,fostex,california1,castle1,symantec,pippolo,babare,turntabl,1angela,moo123,ipvteb,gogolf,alex88,cycle1,maxie1,phase2,selhurst,furnitur,samfox,fromvermine,shaq34,gators96,captain2,delonge,tomatoe,bisous,zxcvbnma,glacius,pineapple1,cannelle,ganibal,mko09ijn,paraklast1974,hobbes12,petty43,artema,junior8,mylover,1234567890d,fatal1ty,prostreet,peruan,10020,nadya,caution1,marocas,chanel5,summer08,metal123,111lox,scrapy,thatguy,eddie666,washingto,yannis,minnesota_hp,lucky4,playboy6,naumova,azzurro,patat,dale33,pa55wd,speedster,zemanova,saraht,newto,tony22,qscesz,arkady,1oliver,death6,vkfwx046,antiflag,stangs,jzf7qf2e,brianp,fozzy,cody123,startrek1,yoda123,murciela,trabajo,lvbnhbtdf,canario,fliper,adroit,henry5,goducks,papirus,alskdj,soccer6,88mike,gogetter,tanelorn,donking,marky1,leedsu,badmofo,al1916,wetdog,akmaral,pallet,april24,killer00,nesterova,rugby123,coffee12,browseui,ralliart,paigow,calgary1,armyman,vtldtltd,frodo2,frxtgb,iambigal,benno,jaytee,2hot4you,askar,bigtee,brentwoo,palladin,eddie2,al1916w,horosho,entrada,ilovetits,venture1,dragon19,jayde,chuvak,jamesl,fzr600,brandon8,vjqvbh,snowbal,snatch1,bg6njokf,pudder,karolin,candoo,pfuflrf,satchel1,manteca,khongbiet,critter1,partridg,skyclad,bigdon,ginger69,brave1,anthony4,spinnake,chinadol,passout,cochino,nipples1,15058,lopesk,sixflags,lloo999,parkhead,breakdance,cia123,fidodido,yuitre12,fooey,artem1995,gayathri,medin,nondriversig,l12345,bravo7,happy13,kazuya,camster,alex1998,luckyy,zipcode,dizzle,boating1,opusone,newpassw,movies23,kamikazi,zapato,bart316,cowboys0,corsair1,kingshit,hotdog12,rolyat,h200svrm,qwerty4,boofer,rhtyltkm,chris999,vaz21074,simferopol,pitboss,love3,britania,tanyshka,brause,123qwerty123,abeille,moscow1,ilkaev,manut,process1,inetcfg,dragon05,fortknox,castill,rynner,mrmike,koalas,jeebus,stockpor,longman,juanpabl,caiman,roleplay,jeremi,26058,prodojo,002200,magical1,black5,bvlgari,doogie1,cbhtqa,mahina,a1s2d3f4g5h6,jblpro,usmc01,bismilah,guitar01,april9,santana1,1234aa,monkey14,sorokin,evan1,doohan,animalsex,pfqxtyjr,dimitry,catchme,chello,silverch,glock45,dogleg,litespee,nirvana9,peyton18,alydar,warhamer,iluvme,sig229,minotavr,lobzik,jack23,bushwack,onlin,football123,joshua5,federov,winter2,bigmax,fufnfrhbcnb,hfpldfnhb,1dakota,f56307,chipmonk,4nick8,praline,vbhjh123,king11,22tango,gemini12,street1,77879,doodlebu,homyak,165432,chuluthu,trixi,karlito,salom,reisen,cdtnkzxjr,pookie11,tremendo,shazaam,welcome0,00000ty,peewee51,pizzle,gilead,bydand,sarvar,upskirt,legends1,freeway1,teenfuck,ranger9,darkfire,dfymrf,hunt0802,justme1,buffy1ma,1harry,671fsa75yt,burrfoot,budster,pa437tu,jimmyp,alina2006,malacon,charlize,elway1,free12,summer02,gadina,manara,gomer1,1cassie,sanja,kisulya,money3,pujols,ford50,midiland,turga,orange6,demetriu,freakboy,orosie1,radio123,open12,vfufpby,mustek,chris33,animes,meiling,nthtvjr,jasmine9,gfdkjd,oligarh,marimar,chicago9,.kzirf,bugssgub,samuraix,jackie01,pimpjuic,macdad,cagiva,vernost,willyboy,fynjyjdf,tabby1,privet123,torres9,retype,blueroom,raven11,q12we3,alex1989,bringiton,ridered,kareltje,ow8jtcs8t,ciccia,goniners,countryb,24688642,covingto,24861793,beyblade,vikin,badboyz,wlafiga,walstib,mirand,needajob,chloes,balaton,kbpfdtnf,freyja,bond9007,gabriel12,stormbri,hollage,love4eve,fenomeno,darknite,dragstar,kyle123,milfhunter,ma123123123,samia,ghislain,enrique1,ferien12,xjy6721,natalie2,reglisse,wilson2,wesker,rosebud7,amazon1,robertr,roykeane,xtcnth,mamatata,crazyc,mikie,savanah,blowjob69,jackie2,forty1,1coffee,fhbyjxrf,bubbah,goteam,hackedit,risky1,logoff,h397pnvr,buck13,robert23,bronc,st123st,godflesh,pornog,iamking,cisco69,septiembr,dale38,zhongguo,tibbar,panther9,buffa1,bigjohn1,mypuppy,vehvfycr,april16,shippo,fire1234,green15,q123123,gungadin,steveg,olivier1,chinaski,magnoli,faithy,storm12,toadfrog,paul99,78791,august20,automati,squirtle,cheezy,positano,burbon,nunya,llebpmac,kimmi,turtle2,alan123,prokuror,violin1,durex,pussygal,visionar,trick1,chicken6,29024,plowboy,rfybreks,imbue,sasha13,wagner1,vitalogy,cfymrf,thepro,26028,gorbunov,dvdcom,letmein5,duder,fastfun,pronin,libra1,conner1,harley20,stinker1,20068,20038,amitech,syoung,dugway,18068,welcome7,jimmypag,anastaci,kafka1,pfhfnecnhf,catsss,campus100,shamal,nacho1,fire12,vikings2,brasil1,rangerover,mohamma,peresvet,14058,cocomo,aliona,14038,qwaser,vikes,cbkmdf,skyblue1,ou81234,goodlove,dfkmltvfh,108888,roamer,pinky2,static1,zxcv4321,barmen,rock22,shelby2,morgans,1junior,pasword1,logjam,fifty5,nhfrnjhbcn,chaddy,philli,nemesis2,ingenier,djkrjd,ranger3,aikman8,knothead,daddy69,love007,vsythb,ford350,tiger00,renrut,owen11,energy12,march14,alena123,robert19,carisma,orange22,murphy11,podarok,prozak,kfgeirf,wolf13,lydia1,shazza,parasha,akimov,tobbie,pilote,heather4,baster,leones,gznfxjr,megama,987654321g,bullgod,boxster1,minkey,wombats,vergil,colegiata,lincol,smoothe,pride1,carwash1,latrell,bowling3,fylhtq123,pickwick,eider,bubblebox,bunnies1,loquit,slipper1,nutsac,purina,xtutdfhf,plokiju,1qazxs,uhjpysq,zxcvbasdfg,enjoy1,1pumpkin,phantom7,mama22,swordsma,wonderbr,dogdays,milker,u23456,silvan,dfkthbr,slagelse,yeahman,twothree,boston11,wolf100,dannyg,troll1,fynjy123,ghbcnfd,bftest,ballsdeep,bobbyorr,alphasig,cccdemo,fire123,norwest,claire2,august10,lth1108,problemas,sapito,alex06,1rusty,maccom,goirish1,ohyes,bxdumb,nabila,boobear1,rabbit69,princip,alexsander,travail,chantal1,dogggy,greenpea,diablo69,alex2009,bergen09,petticoa,classe,ceilidh,vlad2011,kamakiri,lucidity,qaz321,chileno,cexfhf,99ranger,mcitra,estoppel,volvos60,carter80,webpass,temp12,touareg,fcgbhby,bubba8,sunitha,200190ru,bitch2,shadow23,iluvit,nicole0,ruben1,nikki69,butttt,shocker1,souschef,lopotok01,kantot,corsano,cfnfyf,riverat,makalu,swapna,all4u9,cdtnkfy,ntktgepbr,ronaldo99,thomasj,bmw540i,chrisw,boomba,open321,z1x2c3v4b5n6m7,gaviota,iceman44,frosya,chris100,chris24,cosette,clearwat,micael,boogyman,pussy9,camus1,chumpy,heccrbq,konoplya,chester8,scooter5,ghjgfufylf,giotto,koolkat,zero000,bonita1,ckflrbq,j1964,mandog,18n28n24a,renob,head1,shergar,ringo123,tanita,sex4free,johnny12,halberd,reddevils,biolog,dillinge,fatb0y,c00per,hyperlit,wallace2,spears1,vitamine,buheirf,sloboda,alkash,mooman,marion1,arsenal7,sunder,nokia5610,edifier,pippone,fyfnjkmtdbx,fujimo,pepsi12,kulikova,bolat,duetto,daimon,maddog01,timoshka,ezmoney,desdemon,chesters,aiden,hugues,patrick5,aikman08,robert4,roenick,nyranger,writer1,36169544,foxmulder,118801,kutter,shashank,jamjar,118811,119955,aspirina,dinkus,1sailor,nalgene,19891959,snarf,allie1,cracky,resipsa,45678912,kemerovo,19841989,netware1,alhimik,19801984,nicole123,19761977,51501984,malaka1,montella,peachfuz,jethro1,cypress1,henkie,holdon,esmith,55443322,1friend,quique,bandicoot,statistika,great123,death13,ucht36,master4,67899876,bobsmith,nikko1,jr1234,hillary1,78978978,rsturbo,lzlzdfcz,bloodlust,shadow00,skagen,bambina,yummies,88887777,91328378,matthew4,itdoes,98256518,102938475,alina2002,123123789,fubared,dannys,123456321,nikifor,suck69,newmexico,scubaman,rhbcnb,fifnfy,puffdadd,159357852,dtheyxbr,theman22,212009164,prohor,shirle,nji90okm,newmedia,goose5,roma1995,letssee,iceman11,aksana,wirenut,pimpdady,1212312121,tamplier,pelican1,domodedovo,1928374655,fiction6,duckpond,ybrecz,thwack,onetwo34,gunsmith,murphydo,fallout1,spectre1,jabberwo,jgjesq,turbo6,bobo12,redryder,blackpus,elena1971,danilova,antoin,bobo1234,bobob,bobbobbo,dean1,222222a,jesusgod,matt23,musical1,darkmage,loppol,werrew,josepha,rebel12,toshka,gadfly,hawkwood,alina12,dnomyar,sexaddict,dangit,cool23,yocrack,archimed,farouk,nhfkzkz,lindalou,111zzzzz,ghjatccjh,wethepeople,m123456789,wowsers,kbkbxrf,bulldog5,m_roesel,sissinit,yamoon6,123ewqasd,dangel,miruvor79,kaytee,falcon7,bandit11,dotnet,dannii,arsenal9,miatamx5,1trouble,strip4me,dogpile,sexyred1,rjdfktdf,google10,shortman,crystal7,awesome123,cowdog,haruka,birthday28,jitter,diabolik,boomer12,dknight,bluewate,hockey123,crm0624,blueboys,willy123,jumpup,google2,cobra777,llabesab,vicelord,hopper1,gerryber,remmah,j10e5d4,qqqqqqw,agusti,fre_ak8yj,nahlik,redrobin,scott3,epson1,dumpy,bundao,aniolek,hola123,jergens,itsasecret,maxsam,bluelight,mountai1,bongwater,1london,pepper14,freeuse,dereks,qweqw,fordgt40,rfhfdfy,raider12,hunnybun,compac,splicer,megamon,tuffgong,gymnast1,butter11,modaddy,wapbbs_1,dandelio,soccer77,ghjnbdjcnjzybt,123xyi2,fishead,x002tp00,whodaman,555aaa,oussama,brunodog,technici,pmtgjnbl,qcxdw8ry,schweden,redsox3,throbber,collecto,japan10,dbm123dm,hellhoun,tech1,deadzone,kahlan,wolf123,dethklok,xzsawq,bigguy1,cybrthc,chandle,buck01,qq123123,secreta,williams1,c32649135,delta12,flash33,123joker,spacejam,polopo,holycrap,daman1,tummybed,financia,nusrat,euroline,magicone,jimkirk,ameritec,daniel26,sevenn,topazz,kingpins,dima1991,macdog,spencer5,oi812,geoffre,music11,baffle,123569,usagi,cassiope,polla,lilcrowe,thecakeisalie,vbhjndjhtw,vthokies,oldmans,sophie01,ghoster,penny2,129834,locutus1,meesha,magik,jerry69,daddysgirl,irondesk,andrey12,jasmine123,vepsrfyn,likesdick,1accord,jetboat,grafix,tomuch,showit,protozoa,mosias98,taburetka,blaze420,esenin,anal69,zhv84kv,puissant,charles0,aishwarya,babylon6,bitter1,lenina,raleigh1,lechat,access01,kamilka,fynjy,sparkplu,daisy3112,choppe,zootsuit,1234567j,rubyrose,gorilla9,nightshade,alternativa,cghfdjxybr,snuggles1,10121v,vova1992,leonardo1,dave2,matthewd,vfhfnbr,1986mets,nobull,bacall,mexican1,juanjo,mafia1,boomer22,soylent,edwards1,jordan10,blackwid,alex86,gemini13,lunar2,dctvcjcfnm,malaki,plugger,eagles11,snafu2,1shelly,cintaku,hannah22,tbird1,maks5843,irish88,homer22,amarok,fktrcfylhjdf,lincoln2,acess,gre69kik,need4speed,hightech,core2duo,blunt1,ublhjgjybrf,dragon33,1autopas,autopas1,wwww1,15935746,daniel20,2500aa,massim,1ggggggg,96ford,hardcor1,cobra5,blackdragon,vovan_lt,orochimaru,hjlbntkb,qwertyuiop12,tallen,paradoks,frozenfish,ghjuhfvvbcn,gerri1,nuggett,camilit,doright,trans1,serena1,catch2,bkmyeh,fireston,afhvfwtdn,purple3,figure8,fuckya,scamp1,laranja,ontheoutside,louis123,yellow7,moonwalk,mercury2,tolkein,raide,amenra,a13579,dranreb,5150vh,harish,tracksta,sexking,ozzmosis,katiee,alomar,matrix19,headroom,jahlove,ringding,apollo8,132546,132613,12345672000,saretta,135798,136666,thomas7,136913,onetwothree,hockey33,calida,nefertit,bitwise,tailhook,boop4,kfgecbr,bujhmbujhm,metal69,thedark,meteoro,felicia1,house12,tinuviel,istina,vaz2105,pimp13,toolfan,nina1,tuesday2,maxmotives,lgkp500,locksley,treech,darling1,kurama,aminka,ramin,redhed,dazzler,jager1,stpiliot,cardman,rfvtym,cheeser,14314314,paramoun,samcat,plumpy,stiffie,vsajyjr,panatha,qqq777,car12345,098poi,asdzx,keegan1,furelise,kalifornia,vbhjckfd,beast123,zcfvfzkexifz,harry5,1birdie,96328i,escola,extra330,henry12,gfhfyjqz,14u2nv,max1234,templar1,1dave,02588520,catrin,pangolin,marhaba,latin1,amorcito,dave22,escape1,advance1,yasuhiro,grepw,meetme,orange01,ernes,erdna,zsergn,nautica1,justinb,soundwav,miasma,greg78,nadine1,sexmad,lovebaby,promo1,excel1,babys,dragonma,camry1,sonnenschein,farooq,wazzkaprivet,magal,katinas,elvis99,redsox24,rooney1,chiefy,peggys,aliev,pilsung,mudhen,dontdoit,dennis12,supercal,energia,ballsout,funone,claudiu,brown2,amoco,dabl1125,philos,gjdtkbntkm,servette,13571113,whizzer,nollie,13467982,upiter,12string,bluejay1,silkie,william4,kosta1,143333,connor12,sustanon,06068,corporat,ssnake,laurita,king10,tahoes,arsenal123,sapato,charless,jeanmarc,levent,algerie,marine21,jettas,winsome,dctvgbplf,1701ab,xxxp455w0rd5,lllllll1,ooooooo1,monalis,koufax32,anastasya,debugger,sarita2,jason69,ufkxjyjr,gjlcnfdf,1jerry,daniel10,balinor,sexkitten,death2,qwertasdfgzxcvb,s9te949f,vegeta1,sysman,maxxam,dimabilan,mooose,ilovetit,june23,illest,doesit,mamou,abby12,longjump,transalp,moderato,littleguy,magritte,dilnoza,hawaiiguy,winbig,nemiroff,kokaine,admira,myemail,dream2,browneyes,destiny7,dragonss,suckme1,asa123,andranik,suckem,fleshbot,dandie,timmys,scitra,timdog,hasbeen,guesss,smellyfe,arachne,deutschl,harley88,birthday27,nobody1,papasmur,home1,jonass,bunia3,epatb1,embalm,vfvekmrf,apacer,12345656,estreet,weihnachtsbaum,mrwhite,admin12,kristie1,kelebek,yoda69,socken,tima123,bayern1,fktrcfylth,tamiya,99strenght,andy01,denis2011,19delta,stokecit,aotearoa,stalker2,nicnac,conrad1,popey,agusta,bowl36,1bigfish,mossyoak,1stunner,getinnow,jessejames,gkfnjy,drako,1nissan,egor123,hotness,1hawaii,zxc123456,cantstop,1peaches,madlen,west1234,jeter1,markis,judit,attack1,artemi,silver69,153246,crazy2,green9,yoshimi,1vette,chief123,jasper2,1sierra,twentyon,drstrang,aspirant,yannic,jenna123,bongtoke,slurpy,1sugar,civic97,rusty21,shineon,james19,anna12345,wonderwoman,1kevin,karol1,kanabis,wert21,fktif6115,evil1,kakaha,54gv768,826248s,tyrone1,1winston,sugar2,falcon01,adelya,mopar440,zasxcd,leecher,kinkysex,mercede1,travka,11234567,rebon,geekboy".split(","),
    english_wikipedia: "the,of,and,in,was,is,for,as,on,with,by,he,at,from,his,an,were,are,which,doc,https,also,or,has,had,first,one,their,its,after,new,who,they,two,her,she,been,other,when,time,during,there,into,school,more,may,years,over,only,year,most,would,world,city,some,where,between,later,three,state,such,then,national,used,made,known,under,many,university,united,while,part,season,team,these,american,than,film,second,born,south,became,states,war,through,being,including,both,before,north,high,however,people,family,early,history,album,area,them,series,against,until,since,district,county,name,work,life,group,music,following,number,company,several,four,called,played,released,career,league,game,government,house,each,based,day,same,won,use,station,club,international,town,located,population,general,college,east,found,age,march,end,september,began,home,public,church,line,june,river,member,system,place,century,band,july,york,january,october,song,august,best,former,british,party,named,held,village,show,local,november,took,service,december,built,another,major,within,along,members,five,single,due,although,small,old,left,final,large,include,building,served,president,received,games,death,february,main,third,set,children,own,order,species,park,law,air,published,road,died,book,men,women,army,often,according,education,central,country,division,english,top,included,development,french,community,among,water,play,side,list,times,near,late,form,original,different,center,power,led,students,german,moved,court,six,land,council,island,u.s.,record,million,research,art,established,award,street,military,television,given,region,support,western,production,non,political,point,cup,period,business,title,started,various,election,using,england,role,produced,become,program,works,field,total,office,class,written,association,radio,union,level,championship,director,few,force,created,department,founded,services,married,though,per,n't,site,open,act,short,society,version,royal,present,northern,worked,professional,full,returned,joined,story,france,european,currently,language,social,california,india,days,design,st.,further,round,australia,wrote,san,project,control,southern,railway,board,popular,continued,free,battle,considered,video,common,position,living,half,playing,recorded,red,post,described,average,records,special,modern,appeared,announced,areas,rock,release,elected,others,example,term,opened,similar,formed,route,census,current,schools,originally,lake,developed,race,himself,forces,addition,information,upon,province,match,event,songs,result,events,win,eastern,track,lead,teams,science,human,construction,minister,germany,awards,available,throughout,training,style,body,museum,australian,health,seven,signed,chief,eventually,appointed,sea,centre,debut,tour,points,media,light,range,character,across,features,families,largest,indian,network,less,performance,players,refer,europe,sold,festival,usually,taken,despite,designed,committee,process,return,official,episode,institute,stage,followed,performed,japanese,personal,thus,arts,space,low,months,includes,china,study,middle,magazine,leading,japan,groups,aircraft,featured,federal,civil,rights,model,coach,canadian,books,remained,eight,type,independent,completed,capital,academy,instead,kingdom,organization,countries,studies,competition,sports,size,above,section,finished,gold,involved,reported,management,systems,industry,directed,market,fourth,movement,technology,bank,ground,campaign,base,lower,sent,rather,added,provided,coast,grand,historic,valley,conference,bridge,winning,approximately,films,chinese,awarded,degree,russian,shows,native,female,replaced,municipality,square,studio,medical,data,african,successful,mid,bay,attack,previous,operations,spanish,theatre,student,republic,beginning,provide,ship,primary,owned,writing,tournament,culture,introduced,texas,related,natural,parts,governor,reached,ireland,units,senior,decided,italian,whose,higher,africa,standard,income,professor,placed,regional,los,buildings,championships,active,novel,energy,generally,interest,via,economic,previously,stated,itself,channel,below,operation,leader,traditional,trade,structure,limited,runs,prior,regular,famous,saint,navy,foreign,listed,artist,catholic,airport,results,parliament,collection,unit,officer,goal,attended,command,staff,commission,lived,location,plays,commercial,places,foundation,significant,older,medal,self,scored,companies,highway,activities,programs,wide,musical,notable,library,numerous,paris,towards,individual,allowed,plant,property,annual,contract,whom,highest,initially,required,earlier,assembly,artists,rural,seat,practice,defeated,ended,soviet,length,spent,manager,press,associated,author,issues,additional,characters,lord,zealand,policy,engine,township,noted,historical,complete,financial,religious,mission,contains,nine,recent,represented,pennsylvania,administration,opening,secretary,lines,report,executive,youth,closed,theory,writer,italy,angeles,appearance,feature,queen,launched,legal,terms,entered,issue,edition,singer,greek,majority,background,source,anti,cultural,complex,changes,recording,stadium,islands,operated,particularly,basketball,month,uses,port,castle,mostly,names,fort,selected,increased,status,earth,subsequently,pacific,cover,variety,certain,goals,remains,upper,congress,becoming,studied,irish,nature,particular,loss,caused,chart,dr.,forced,create,era,retired,material,review,rate,singles,referred,larger,individuals,shown,provides,products,speed,democratic,poland,parish,olympics,cities,themselves,temple,wing,genus,households,serving,cost,wales,stations,passed,supported,view,cases,forms,actor,male,matches,males,stars,tracks,females,administrative,median,effect,biography,train,engineering,camp,offered,chairman,houses,mainly,19th,surface,therefore,nearly,score,ancient,subject,prime,seasons,claimed,experience,specific,jewish,failed,overall,believed,plot,troops,greater,spain,consists,broadcast,heavy,increase,raised,separate,campus,1980s,appears,presented,lies,composed,recently,influence,fifth,nations,creek,references,elections,britain,double,cast,meaning,earned,carried,producer,latter,housing,brothers,attempt,article,response,border,remaining,nearby,direct,ships,value,workers,politician,academic,label,1970s,commander,rule,fellow,residents,authority,editor,transport,dutch,projects,responsible,covered,territory,flight,races,defense,tower,emperor,albums,facilities,daily,stories,assistant,managed,primarily,quality,function,proposed,distribution,conditions,prize,journal,code,vice,newspaper,corps,highly,constructed,mayor,critical,secondary,corporation,rugby,regiment,ohio,appearances,serve,allow,nation,multiple,discovered,directly,scene,levels,growth,elements,acquired,1990s,officers,physical,20th,latin,host,jersey,graduated,arrived,issued,literature,metal,estate,vote,immediately,quickly,asian,competed,extended,produce,urban,1960s,promoted,contemporary,global,formerly,appear,industrial,types,opera,ministry,soldiers,commonly,mass,formation,smaller,typically,drama,shortly,density,senate,effects,iran,polish,prominent,naval,settlement,divided,basis,republican,languages,distance,treatment,continue,product,mile,sources,footballer,format,clubs,leadership,initial,offers,operating,avenue,officially,columbia,grade,squadron,fleet,percent,farm,leaders,agreement,likely,equipment,website,mount,grew,method,transferred,intended,renamed,iron,asia,reserve,capacity,politics,widely,activity,advanced,relations,scottish,dedicated,crew,founder,episodes,lack,amount,build,efforts,concept,follows,ordered,leaves,positive,economy,entertainment,affairs,memorial,ability,illinois,communities,color,text,railroad,scientific,focus,comedy,serves,exchange,environment,cars,direction,organized,firm,description,agency,analysis,purpose,destroyed,reception,planned,revealed,infantry,architecture,growing,featuring,household,candidate,removed,situated,models,knowledge,solo,technical,organizations,assigned,conducted,participated,largely,purchased,register,gained,combined,headquarters,adopted,potential,protection,scale,approach,spread,independence,mountains,titled,geography,applied,safety,mixed,accepted,continues,captured,rail,defeat,principal,recognized,lieutenant,mentioned,semi,owner,joint,liberal,actress,traffic,creation,basic,notes,unique,supreme,declared,simply,plants,sales,massachusetts,designated,parties,jazz,compared,becomes,resources,titles,concert,learning,remain,teaching,versions,content,alongside,revolution,sons,block,premier,impact,champions,districts,generation,estimated,volume,image,sites,account,roles,sport,quarter,providing,zone,yard,scoring,classes,presence,performances,representatives,hosted,split,taught,origin,olympic,claims,critics,facility,occurred,suffered,municipal,damage,defined,resulted,respectively,expanded,platform,draft,opposition,expected,educational,ontario,climate,reports,atlantic,surrounding,performing,reduced,ranked,allows,birth,nominated,younger,newly,kong,positions,theater,philadelphia,heritage,finals,disease,sixth,laws,reviews,constitution,tradition,swedish,theme,fiction,rome,medicine,trains,resulting,existing,deputy,environmental,labour,classical,develop,fans,granted,receive,alternative,begins,nuclear,fame,buried,connected,identified,palace,falls,letters,combat,sciences,effort,villages,inspired,regions,towns,conservative,chosen,animals,labor,attacks,materials,yards,steel,representative,orchestra,peak,entitled,officials,returning,reference,northwest,imperial,convention,examples,ocean,publication,painting,subsequent,frequently,religion,brigade,fully,sides,acts,cemetery,relatively,oldest,suggested,succeeded,achieved,application,programme,cells,votes,promotion,graduate,armed,supply,flying,communist,figures,literary,netherlands,korea,worldwide,citizens,1950s,faculty,draw,stock,seats,occupied,methods,unknown,articles,claim,holds,authorities,audience,sweden,interview,obtained,covers,settled,transfer,marked,allowing,funding,challenge,southeast,unlike,crown,rise,portion,transportation,sector,phase,properties,edge,tropical,standards,institutions,philosophy,legislative,hills,brand,fund,conflict,unable,founding,refused,attempts,metres,permanent,starring,applications,creating,effective,aired,extensive,employed,enemy,expansion,billboard,rank,battalion,multi,vehicle,fought,alliance,category,perform,federation,poetry,bronze,bands,entry,vehicles,bureau,maximum,billion,trees,intelligence,greatest,screen,refers,commissioned,gallery,injury,confirmed,setting,treaty,adult,americans,broadcasting,supporting,pilot,mobile,writers,programming,existence,squad,minnesota,copies,korean,provincial,sets,defence,offices,agricultural,internal,core,northeast,retirement,factory,actions,prevent,communications,ending,weekly,containing,functions,attempted,interior,weight,bowl,recognition,incorporated,increasing,ultimately,documentary,derived,attacked,lyrics,mexican,external,churches,centuries,metropolitan,selling,opposed,personnel,mill,visited,presidential,roads,pieces,norwegian,controlled,18th,rear,influenced,wrestling,weapons,launch,composer,locations,developing,circuit,specifically,studios,shared,canal,wisconsin,publishing,approved,domestic,consisted,determined,comic,establishment,exhibition,southwest,fuel,electronic,cape,converted,educated,melbourne,hits,wins,producing,norway,slightly,occur,surname,identity,represent,constituency,funds,proved,links,structures,athletic,birds,contest,users,poet,institution,display,receiving,rare,contained,guns,motion,piano,temperature,publications,passenger,contributed,toward,cathedral,inhabitants,architect,exist,athletics,muslim,courses,abandoned,signal,successfully,disambiguation,tennessee,dynasty,heavily,maryland,jews,representing,budget,weather,missouri,introduction,faced,pair,chapel,reform,height,vietnam,occurs,motor,cambridge,lands,focused,sought,patients,shape,invasion,chemical,importance,communication,selection,regarding,homes,voivodeship,maintained,borough,failure,aged,passing,agriculture,oregon,teachers,flow,philippines,trail,seventh,portuguese,resistance,reaching,negative,fashion,scheduled,downtown,universities,trained,skills,scenes,views,notably,typical,incident,candidates,engines,decades,composition,commune,chain,inc.,austria,sale,values,employees,chamber,regarded,winners,registered,task,investment,colonial,swiss,user,entirely,flag,stores,closely,entrance,laid,journalist,coal,equal,causes,turkish,quebec,techniques,promote,junction,easily,dates,kentucky,singapore,residence,violence,advance,survey,humans,expressed,passes,streets,distinguished,qualified,folk,establish,egypt,artillery,visual,improved,actual,finishing,medium,protein,switzerland,productions,operate,poverty,neighborhood,organisation,consisting,consecutive,sections,partnership,extension,reaction,factor,costs,bodies,device,ethnic,racial,flat,objects,chapter,improve,musicians,courts,controversy,membership,merged,wars,expedition,interests,arab,comics,gain,describes,mining,bachelor,crisis,joining,decade,1930s,distributed,habitat,routes,arena,cycle,divisions,briefly,vocals,directors,degrees,object,recordings,installed,adjacent,demand,voted,causing,businesses,ruled,grounds,starred,drawn,opposite,stands,formal,operates,persons,counties,compete,wave,israeli,ncaa,resigned,brief,greece,combination,demographics,historian,contain,commonwealth,musician,collected,argued,louisiana,session,cabinet,parliamentary,electoral,loan,profit,regularly,conservation,islamic,purchase,17th,charts,residential,earliest,designs,paintings,survived,moth,items,goods,grey,anniversary,criticism,images,discovery,observed,underground,progress,additionally,participate,thousands,reduce,elementary,owners,stating,iraq,resolution,capture,tank,rooms,hollywood,finance,queensland,reign,maintain,iowa,landing,broad,outstanding,circle,path,manufacturing,assistance,sequence,gmina,crossing,leads,universal,shaped,kings,attached,medieval,ages,metro,colony,affected,scholars,oklahoma,coastal,soundtrack,painted,attend,definition,meanwhile,purposes,trophy,require,marketing,popularity,cable,mathematics,mississippi,represents,scheme,appeal,distinct,factors,acid,subjects,roughly,terminal,economics,senator,diocese,prix,contrast,argentina,czech,wings,relief,stages,duties,16th,novels,accused,whilst,equivalent,charged,measure,documents,couples,request,danish,defensive,guide,devices,statistics,credited,tries,passengers,allied,frame,puerto,peninsula,concluded,instruments,wounded,differences,associate,forests,afterwards,replace,requirements,aviation,solution,offensive,ownership,inner,legislation,hungarian,contributions,actors,translated,denmark,steam,depending,aspects,assumed,injured,severe,admitted,determine,shore,technique,arrival,measures,translation,debuted,delivered,returns,rejected,separated,visitors,damaged,storage,accompanied,markets,industries,losses,gulf,charter,strategy,corporate,socialist,somewhat,significantly,physics,mounted,satellite,experienced,constant,relative,pattern,restored,belgium,connecticut,partners,harvard,retained,networks,protected,mode,artistic,parallel,collaboration,debate,involving,journey,linked,salt,authors,components,context,occupation,requires,occasionally,policies,tamil,ottoman,revolutionary,hungary,poem,versus,gardens,amongst,audio,makeup,frequency,meters,orthodox,continuing,suggests,legislature,coalition,guitarist,eighth,classification,practices,soil,tokyo,instance,limit,coverage,considerable,ranking,colleges,cavalry,centers,daughters,twin,equipped,broadway,narrow,hosts,rates,domain,boundary,arranged,12th,whereas,brazilian,forming,rating,strategic,competitions,trading,covering,baltimore,commissioner,infrastructure,origins,replacement,praised,disc,collections,expression,ukraine,driven,edited,austrian,solar,ensure,premiered,successor,wooden,operational,hispanic,concerns,rapid,prisoners,childhood,meets,influential,tunnel,employment,tribe,qualifying,adapted,temporary,celebrated,appearing,increasingly,depression,adults,cinema,entering,laboratory,script,flows,romania,accounts,fictional,pittsburgh,achieve,monastery,franchise,formally,tools,newspapers,revival,sponsored,processes,vienna,springs,missions,classified,13th,annually,branches,lakes,gender,manner,advertising,normally,maintenance,adding,characteristics,integrated,decline,modified,strongly,critic,victims,malaysia,arkansas,nazi,restoration,powered,monument,hundreds,depth,15th,controversial,admiral,criticized,brick,honorary,initiative,output,visiting,birmingham,progressive,existed,carbon,1920s,credits,colour,rising,hence,defeating,superior,filmed,listing,column,surrounded,orleans,principles,territories,struck,participation,indonesia,movements,index,commerce,conduct,constitutional,spiritual,ambassador,vocal,completion,edinburgh,residing,tourism,finland,bears,medals,resident,themes,visible,indigenous,involvement,basin,electrical,ukrainian,concerts,boats,styles,processing,rival,drawing,vessels,experimental,declined,touring,supporters,compilation,coaching,cited,dated,roots,string,explained,transit,traditionally,poems,minimum,representation,14th,releases,effectively,architectural,triple,indicated,greatly,elevation,clinical,printed,10th,proposal,peaked,producers,romanized,rapidly,stream,innings,meetings,counter,householder,honour,lasted,agencies,document,exists,surviving,experiences,honors,landscape,hurricane,harbor,panel,competing,profile,vessel,farmers,lists,revenue,exception,customers,11th,participants,wildlife,utah,bible,gradually,preserved,replacing,symphony,begun,longest,siege,provinces,mechanical,genre,transmission,agents,executed,videos,benefits,funded,rated,instrumental,ninth,similarly,dominated,destruction,passage,technologies,thereafter,outer,facing,affiliated,opportunities,instrument,governments,scholar,evolution,channels,shares,sessions,widespread,occasions,engineers,scientists,signing,battery,competitive,alleged,eliminated,supplies,judges,hampshire,regime,portrayed,penalty,taiwan,denied,submarine,scholarship,substantial,transition,victorian,http,nevertheless,filed,supports,continental,tribes,ratio,doubles,useful,honours,blocks,principle,retail,departure,ranks,patrol,yorkshire,vancouver,inter,extent,afghanistan,strip,railways,component,organ,symbol,categories,encouraged,abroad,civilian,periods,traveled,writes,struggle,immediate,recommended,adaptation,egyptian,graduating,assault,drums,nomination,historically,voting,allies,detailed,achievement,percentage,arabic,assist,frequent,toured,apply,and/or,intersection,maine,touchdown,throne,produces,contribution,emerged,obtain,archbishop,seek,researchers,remainder,populations,clan,finnish,overseas,fifa,licensed,chemistry,festivals,mediterranean,injuries,animated,seeking,publisher,volumes,limits,venue,jerusalem,generated,trials,islam,youngest,ruling,glasgow,germans,songwriter,persian,municipalities,donated,viewed,belgian,cooperation,posted,tech,dual,volunteer,settlers,commanded,claiming,approval,delhi,usage,terminus,partly,electricity,locally,editions,premiere,absence,belief,traditions,statue,indicate,manor,stable,attributed,possession,managing,viewers,chile,overview,seed,regulations,essential,minority,cargo,segment,endemic,forum,deaths,monthly,playoffs,erected,practical,machines,suburb,relation,mrs.,descent,indoor,continuous,characterized,solutions,caribbean,rebuilt,serbian,summary,contested,psychology,pitch,attending,muhammad,tenure,drivers,diameter,assets,venture,punk,airlines,concentration,athletes,volunteers,pages,mines,influences,sculpture,protest,ferry,behalf,drafted,apparent,furthermore,ranging,romanian,democracy,lanka,significance,linear,d.c.,certified,voters,recovered,tours,demolished,boundaries,assisted,identify,grades,elsewhere,mechanism,1940s,reportedly,aimed,conversion,suspended,photography,departments,beijing,locomotives,publicly,dispute,magazines,resort,conventional,platforms,internationally,capita,settlements,dramatic,derby,establishing,involves,statistical,implementation,immigrants,exposed,diverse,layer,vast,ceased,connections,belonged,interstate,uefa,organised,abuse,deployed,cattle,partially,filming,mainstream,reduction,automatic,rarely,subsidiary,decides,merger,comprehensive,displayed,amendment,guinea,exclusively,manhattan,concerning,commons,radical,serbia,baptist,buses,initiated,portrait,harbour,choir,citizen,sole,unsuccessful,manufactured,enforcement,connecting,increases,patterns,sacred,muslims,clothing,hindu,unincorporated,sentenced,advisory,tanks,campaigns,fled,repeated,remote,rebellion,implemented,texts,fitted,tribute,writings,sufficient,ministers,21st,devoted,jurisdiction,coaches,interpretation,pole,businessman,peru,sporting,prices,cuba,relocated,opponent,arrangement,elite,manufacturer,responded,suitable,distinction,calendar,dominant,tourist,earning,prefecture,ties,preparation,anglo,pursue,worship,archaeological,chancellor,bangladesh,scores,traded,lowest,horror,outdoor,biology,commented,specialized,loop,arriving,farming,housed,historians,'the,patent,pupils,christianity,opponents,athens,northwestern,maps,promoting,reveals,flights,exclusive,lions,norfolk,hebrew,extensively,eldest,shops,acquisition,virtual,renowned,margin,ongoing,essentially,iranian,alternate,sailed,reporting,conclusion,originated,temperatures,exposure,secured,landed,rifle,framework,identical,martial,focuses,topics,ballet,fighters,belonging,wealthy,negotiations,evolved,bases,oriented,acres,democrat,heights,restricted,vary,graduation,aftermath,chess,illness,participating,vertical,collective,immigration,demonstrated,leaf,completing,organic,missile,leeds,eligible,grammar,confederate,improvement,congressional,wealth,cincinnati,spaces,indicates,corresponding,reaches,repair,isolated,taxes,congregation,ratings,leagues,diplomatic,submitted,winds,awareness,photographs,maritime,nigeria,accessible,animation,restaurants,philippine,inaugural,dismissed,armenian,illustrated,reservoir,speakers,programmes,resource,genetic,interviews,camps,regulation,computers,preferred,travelled,comparison,distinctive,recreation,requested,southeastern,dependent,brisbane,breeding,playoff,expand,bonus,gauge,departed,qualification,inspiration,shipping,slaves,variations,shield,theories,munich,recognised,emphasis,favour,variable,seeds,undergraduate,territorial,intellectual,qualify,mini,banned,pointed,democrats,assessment,judicial,examination,attempting,objective,partial,characteristic,hardware,pradesh,execution,ottawa,metre,drum,exhibitions,withdrew,attendance,phrase,journalism,logo,measured,error,christians,trio,protestant,theology,respective,atmosphere,buddhist,substitute,curriculum,fundamental,outbreak,rabbi,intermediate,designation,globe,liberation,simultaneously,diseases,experiments,locomotive,difficulties,mainland,nepal,relegated,contributing,database,developments,veteran,carries,ranges,instruction,lodge,protests,obama,newcastle,experiment,physician,describing,challenges,corruption,delaware,adventures,ensemble,succession,renaissance,tenth,altitude,receives,approached,crosses,syria,croatia,warsaw,professionals,improvements,worn,airline,compound,permitted,preservation,reducing,printing,scientist,activist,comprises,sized,societies,enters,ruler,gospel,earthquake,extend,autonomous,croatian,serial,decorated,relevant,ideal,grows,grass,tier,towers,wider,welfare,columns,alumni,descendants,interface,reserves,banking,colonies,manufacturers,magnetic,closure,pitched,vocalist,preserve,enrolled,cancelled,equation,2000s,nickname,bulgaria,heroes,exile,mathematical,demands,input,structural,tube,stem,approaches,argentine,axis,manuscript,inherited,depicted,targets,visits,veterans,regard,removal,efficiency,organisations,concepts,lebanon,manga,petersburg,rally,supplied,amounts,yale,tournaments,broadcasts,signals,pilots,azerbaijan,architects,enzyme,literacy,declaration,placing,batting,incumbent,bulgarian,consistent,poll,defended,landmark,southwestern,raid,resignation,travels,casualties,prestigious,namely,aims,recipient,warfare,readers,collapse,coached,controls,volleyball,coup,lesser,verse,pairs,exhibited,proteins,molecular,abilities,integration,consist,aspect,advocate,administered,governing,hospitals,commenced,coins,lords,variation,resumed,canton,artificial,elevated,palm,difficulty,civic,efficient,northeastern,inducted,radiation,affiliate,boards,stakes,byzantine,consumption,freight,interaction,oblast,numbered,seminary,contracts,extinct,predecessor,bearing,cultures,functional,neighboring,revised,cylinder,grants,narrative,reforms,athlete,tales,reflect,presidency,compositions,specialist,cricketer,founders,sequel,widow,disbanded,associations,backed,thereby,pitcher,commanding,boulevard,singers,crops,militia,reviewed,centres,waves,consequently,fortress,tributary,portions,bombing,excellence,nest,payment,mars,plaza,unity,victories,scotia,farms,nominations,variant,attacking,suspension,installation,graphics,estates,comments,acoustic,destination,venues,surrender,retreat,libraries,quarterback,customs,berkeley,collaborated,gathered,syndrome,dialogue,recruited,shanghai,neighbouring,psychological,saudi,moderate,exhibit,innovation,depot,binding,brunswick,situations,certificate,actively,shakespeare,editorial,presentation,ports,relay,nationalist,methodist,archives,experts,maintains,collegiate,bishops,maintaining,temporarily,embassy,essex,wellington,connects,reformed,bengal,recalled,inches,doctrine,deemed,legendary,reconstruction,statements,palestinian,meter,achievements,riders,interchange,spots,auto,accurate,chorus,dissolved,missionary,thai,operators,e.g.,generations,failing,delayed,cork,nashville,perceived,venezuela,cult,emerging,tomb,abolished,documented,gaining,canyon,episcopal,stored,assists,compiled,kerala,kilometers,mosque,grammy,theorem,unions,segments,glacier,arrives,theatrical,circulation,conferences,chapters,displays,circular,authored,conductor,fewer,dimensional,nationwide,liga,yugoslavia,peer,vietnamese,fellowship,armies,regardless,relating,dynamic,politicians,mixture,serie,somerset,imprisoned,posts,beliefs,beta,layout,independently,electronics,provisions,fastest,logic,headquartered,creates,challenged,beaten,appeals,plains,protocol,graphic,accommodate,iraqi,midfielder,span,commentary,freestyle,reflected,palestine,lighting,burial,virtually,backing,prague,tribal,heir,identification,prototype,criteria,dame,arch,tissue,footage,extending,procedures,predominantly,updated,rhythm,preliminary,cafe,disorder,prevented,suburbs,discontinued,retiring,oral,followers,extends,massacre,journalists,conquest,larvae,pronounced,behaviour,diversity,sustained,addressed,geographic,restrictions,voiced,milwaukee,dialect,quoted,grid,nationally,nearest,roster,twentieth,separation,indies,manages,citing,intervention,guidance,severely,migration,artwork,focusing,rivals,trustees,varied,enabled,committees,centered,skating,slavery,cardinals,forcing,tasks,auckland,youtube,argues,colored,advisor,mumbai,requiring,theological,registration,refugees,nineteenth,survivors,runners,colleagues,priests,contribute,variants,workshop,concentrated,creator,lectures,temples,exploration,requirement,interactive,navigation,companion,perth,allegedly,releasing,citizenship,observation,stationed,ph.d.,sheep,breed,discovers,encourage,kilometres,journals,performers,isle,saskatchewan,hybrid,hotels,lancashire,dubbed,airfield,anchor,suburban,theoretical,sussex,anglican,stockholm,permanently,upcoming,privately,receiver,optical,highways,congo,colours,aggregate,authorized,repeatedly,varies,fluid,innovative,transformed,praise,convoy,demanded,discography,attraction,export,audiences,ordained,enlisted,occasional,westminster,syrian,heavyweight,bosnia,consultant,eventual,improving,aires,wickets,epic,reactions,scandal,i.e.,discrimination,buenos,patron,investors,conjunction,testament,construct,encountered,celebrity,expanding,georgian,brands,retain,underwent,algorithm,foods,provision,orbit,transformation,associates,tactical,compact,varieties,stability,refuge,gathering,moreover,manila,configuration,gameplay,discipline,entity,comprising,composers,skill,monitoring,ruins,museums,sustainable,aerial,altered,codes,voyage,friedrich,conflicts,storyline,travelling,conducting,merit,indicating,referendum,currency,encounter,particles,automobile,workshops,acclaimed,inhabited,doctorate,cuban,phenomenon,dome,enrollment,tobacco,governance,trend,equally,manufacture,hydrogen,grande,compensation,download,pianist,grain,shifted,neutral,evaluation,define,cycling,seized,array,relatives,motors,firms,varying,automatically,restore,nicknamed,findings,governed,investigate,manitoba,administrator,vital,integral,indonesian,confusion,publishers,enable,geographical,inland,naming,civilians,reconnaissance,indianapolis,lecturer,deer,tourists,exterior,rhode,bassist,symbols,scope,ammunition,yuan,poets,punjab,nursing,cent,developers,estimates,presbyterian,nasa,holdings,generate,renewed,computing,cyprus,arabia,duration,compounds,gastropod,permit,valid,touchdowns,facade,interactions,mineral,practiced,allegations,consequence,goalkeeper,baronet,copyright,uprising,carved,targeted,competitors,mentions,sanctuary,fees,pursued,tampa,chronicle,capabilities,specified,specimens,toll,accounting,limestone,staged,upgraded,philosophical,streams,guild,revolt,rainfall,supporter,princeton,terrain,hometown,probability,assembled,paulo,surrey,voltage,developer,destroyer,floors,lineup,curve,prevention,potentially,onwards,trips,imposed,hosting,striking,strict,admission,apartments,solely,utility,proceeded,observations,euro,incidents,vinyl,profession,haven,distant,expelled,rivalry,runway,torpedo,zones,shrine,dimensions,investigations,lithuania,idaho,pursuit,copenhagen,considerably,locality,wireless,decrease,genes,thermal,deposits,hindi,habitats,withdrawn,biblical,monuments,casting,plateau,thesis,managers,flooding,assassination,acknowledged,interim,inscription,guided,pastor,finale,insects,transported,activists,marshal,intensity,airing,cardiff,proposals,lifestyle,prey,herald,capitol,aboriginal,measuring,lasting,interpreted,occurring,desired,drawings,healthcare,panels,elimination,oslo,ghana,blog,sabha,intent,superintendent,governors,bankruptcy,p.m.,equity,disk,layers,slovenia,prussia,quartet,mechanics,graduates,politically,monks,screenplay,nato,absorbed,topped,petition,bold,morocco,exhibits,canterbury,publish,rankings,crater,dominican,enhanced,planes,lutheran,governmental,joins,collecting,brussels,unified,streak,strategies,flagship,surfaces,oval,archive,etymology,imprisonment,instructor,noting,remix,opposing,servant,rotation,width,trans,maker,synthesis,excess,tactics,snail,ltd.,lighthouse,sequences,cornwall,plantation,mythology,performs,foundations,populated,horizontal,speedway,activated,performer,diving,conceived,edmonton,subtropical,environments,prompted,semifinals,caps,bulk,treasury,recreational,telegraph,continent,portraits,relegation,catholics,graph,velocity,rulers,endangered,secular,observer,learns,inquiry,idol,dictionary,certification,estimate,cluster,armenia,observatory,revived,nadu,consumers,hypothesis,manuscripts,contents,arguments,editing,trails,arctic,essays,belfast,acquire,promotional,undertaken,corridor,proceedings,antarctic,millennium,labels,delegates,vegetation,acclaim,directing,substance,outcome,diploma,philosopher,malta,albanian,vicinity,degc,legends,regiments,consent,terrorist,scattered,presidents,gravity,orientation,deployment,duchy,refuses,estonia,crowned,separately,renovation,rises,wilderness,objectives,agreements,empress,slopes,inclusion,equality,decree,ballot,criticised,rochester,recurring,struggled,disabled,henri,poles,prussian,convert,bacteria,poorly,sudan,geological,wyoming,consistently,minimal,withdrawal,interviewed,proximity,repairs,initiatives,pakistani,republicans,propaganda,viii,abstract,commercially,availability,mechanisms,naples,discussions,underlying,lens,proclaimed,advised,spelling,auxiliary,attract,lithuanian,editors,o'brien,accordance,measurement,novelist,ussr,formats,councils,contestants,indie,facebook,parishes,barrier,battalions,sponsor,consulting,terrorism,implement,uganda,crucial,unclear,notion,distinguish,collector,attractions,filipino,ecology,investments,capability,renovated,iceland,albania,accredited,scouts,armor,sculptor,cognitive,errors,gaming,condemned,successive,consolidated,baroque,entries,regulatory,reserved,treasurer,variables,arose,technological,rounded,provider,rhine,agrees,accuracy,genera,decreased,frankfurt,ecuador,edges,particle,rendered,calculated,careers,faction,rifles,americas,gaelic,portsmouth,resides,merchants,fiscal,premises,coin,draws,presenter,acceptance,ceremonies,pollution,consensus,membrane,brigadier,nonetheless,genres,supervision,predicted,magnitude,finite,differ,ancestry,vale,delegation,removing,proceeds,placement,emigrated,siblings,molecules,payments,considers,demonstration,proportion,newer,valve,achieving,confederation,continuously,luxury,notre,introducing,coordinates,charitable,squadrons,disorders,geometry,winnipeg,ulster,loans,longtime,receptor,preceding,belgrade,mandate,wrestler,neighbourhood,factories,buddhism,imported,sectors,protagonist,steep,elaborate,prohibited,artifacts,prizes,pupil,cooperative,sovereign,subspecies,carriers,allmusic,nationals,settings,autobiography,neighborhoods,analog,facilitate,voluntary,jointly,newfoundland,organizing,raids,exercises,nobel,machinery,baltic,crop,granite,dense,websites,mandatory,seeks,surrendered,anthology,comedian,bombs,slot,synopsis,critically,arcade,marking,equations,halls,indo,inaugurated,embarked,speeds,clause,invention,premiership,likewise,presenting,demonstrate,designers,organize,examined,km/h,bavaria,troop,referee,detection,zurich,prairie,rapper,wingspan,eurovision,luxembourg,slovakia,inception,disputed,mammals,entrepreneur,makers,evangelical,yield,clergy,trademark,defunct,allocated,depicting,volcanic,batted,conquered,sculptures,providers,reflects,armoured,locals,walt,herzegovina,contracted,entities,sponsorship,prominence,flowing,ethiopia,marketed,corporations,withdraw,carnegie,induced,investigated,portfolio,flowering,opinions,viewing,classroom,donations,bounded,perception,leicester,fruits,charleston,academics,statute,complaints,smallest,deceased,petroleum,resolved,commanders,algebra,southampton,modes,cultivation,transmitter,spelled,obtaining,sizes,acre,pageant,bats,abbreviated,correspondence,barracks,feast,tackles,raja,derives,geology,disputes,translations,counted,constantinople,seating,macedonia,preventing,accommodation,homeland,explored,invaded,provisional,transform,sphere,unsuccessfully,missionaries,conservatives,highlights,traces,organisms,openly,dancers,fossils,absent,monarchy,combining,lanes,stint,dynamics,chains,missiles,screening,module,tribune,generating,miners,nottingham,seoul,unofficial,owing,linking,rehabilitation,citation,louisville,mollusk,depicts,differential,zimbabwe,kosovo,recommendations,responses,pottery,scorer,aided,exceptions,dialects,telecommunications,defines,elderly,lunar,coupled,flown,25th,espn,formula_1,bordered,fragments,guidelines,gymnasium,valued,complexity,papal,presumably,maternal,challenging,reunited,advancing,comprised,uncertain,favorable,twelfth,correspondent,nobility,livestock,expressway,chilean,tide,researcher,emissions,profits,lengths,accompanying,witnessed,itunes,drainage,slope,reinforced,feminist,sanskrit,develops,physicians,outlets,isbn,coordinator,averaged,termed,occupy,diagnosed,yearly,humanitarian,prospect,spacecraft,stems,enacted,linux,ancestors,karnataka,constitute,immigrant,thriller,ecclesiastical,generals,celebrations,enhance,heating,advocated,evident,advances,bombardment,watershed,shuttle,wicket,twitter,adds,branded,teaches,schemes,pension,advocacy,conservatory,cairo,varsity,freshwater,providence,seemingly,shells,cuisine,specially,peaks,intensive,publishes,trilogy,skilled,nacional,unemployment,destinations,parameters,verses,trafficking,determination,infinite,savings,alignment,linguistic,countryside,dissolution,measurements,advantages,licence,subfamily,highlands,modest,regent,algeria,crest,teachings,knockout,brewery,combine,conventions,descended,chassis,primitive,fiji,explicitly,cumberland,uruguay,laboratories,bypass,elect,informal,preceded,holocaust,tackle,minneapolis,quantity,securities,console,doctoral,religions,commissioners,expertise,unveiled,precise,diplomat,standings,infant,disciplines,sicily,endorsed,systematic,charted,armored,mild,lateral,townships,hurling,prolific,invested,wartime,compatible,galleries,moist,battlefield,decoration,convent,tubes,terrestrial,nominee,requests,delegate,leased,dubai,polar,applying,addresses,munster,sings,commercials,teamed,dances,eleventh,midland,cedar,flee,sandstone,snails,inspection,divide,asset,themed,comparable,paramount,dairy,archaeology,intact,institutes,rectangular,instances,phases,reflecting,substantially,applies,vacant,lacked,copa,coloured,encounters,sponsors,encoded,possess,revenues,ucla,chaired,a.m.,enabling,playwright,stoke,sociology,tibetan,frames,motto,financing,illustrations,gibraltar,chateau,bolivia,transmitted,enclosed,persuaded,urged,folded,suffolk,regulated,bros.,submarines,myth,oriental,malaysian,effectiveness,narrowly,acute,sunk,replied,utilized,tasmania,consortium,quantities,gains,parkway,enlarged,sided,employers,adequate,accordingly,assumption,ballad,mascot,distances,peaking,saxony,projected,affiliation,limitations,metals,guatemala,scots,theaters,kindergarten,verb,employer,differs,discharge,controller,seasonal,marching,guru,campuses,avoided,vatican,maori,excessive,chartered,modifications,caves,monetary,sacramento,mixing,institutional,celebrities,irrigation,shapes,broadcaster,anthem,attributes,demolition,offshore,specification,surveys,yugoslav,contributor,auditorium,lebanese,capturing,airports,classrooms,chennai,paths,tendency,determining,lacking,upgrade,sailors,detected,kingdoms,sovereignty,freely,decorative,momentum,scholarly,georges,gandhi,speculation,transactions,undertook,interact,similarities,cove,teammate,constituted,painters,tends,madagascar,partnerships,afghan,personalities,attained,rebounds,masses,synagogue,reopened,asylum,embedded,imaging,catalogue,defenders,taxonomy,fiber,afterward,appealed,communists,lisbon,rica,judaism,adviser,batsman,ecological,commands,lgbt,cooling,accessed,wards,shiva,employs,thirds,scenic,worcester,tallest,contestant,humanities,economist,textile,constituencies,motorway,tram,percussion,cloth,leisure,1880s,baden,flags,resemble,riots,coined,sitcom,composite,implies,daytime,tanzania,penalties,optional,competitor,excluded,steering,reversed,autonomy,reviewer,breakthrough,professionally,damages,pomeranian,deputies,valleys,ventures,highlighted,electorate,mapping,shortened,executives,tertiary,specimen,launching,bibliography,sank,pursuing,binary,descendant,marched,natives,ideology,turks,adolf,archdiocese,tribunal,exceptional,nigerian,preference,fails,loading,comeback,vacuum,favored,alter,remnants,consecrated,spectators,trends,patriarch,feedback,paved,sentences,councillor,astronomy,advocates,broader,commentator,commissions,identifying,revealing,theatres,incomplete,enables,constituent,reformation,tract,haiti,atmospheric,screened,explosive,czechoslovakia,acids,symbolic,subdivision,liberals,incorporate,challenger,erie,filmmaker,laps,kazakhstan,organizational,evolutionary,chemicals,dedication,riverside,fauna,moths,maharashtra,annexed,gen.,resembles,underwater,garnered,timeline,remake,suited,educator,hectares,automotive,feared,latvia,finalist,narrator,portable,airways,plaque,designing,villagers,licensing,flank,statues,struggles,deutsche,migrated,cellular,jacksonville,wimbledon,defining,highlight,preparatory,planets,cologne,employ,frequencies,detachment,readily,libya,resign,halt,helicopters,reef,landmarks,collaborative,irregular,retaining,helsinki,folklore,weakened,viscount,interred,professors,memorable,mega,repertoire,rowing,dorsal,albeit,progressed,operative,coronation,liner,telugu,domains,philharmonic,detect,bengali,synthetic,tensions,atlas,dramatically,paralympics,xbox,shire,kiev,lengthy,sued,notorious,seas,screenwriter,transfers,aquatic,pioneers,unesco,radius,abundant,tunnels,syndicated,inventor,accreditation,janeiro,exeter,ceremonial,omaha,cadet,predators,resided,prose,slavic,precision,abbot,deity,engaging,cambodia,estonian,compliance,demonstrations,protesters,reactor,commodore,successes,chronicles,mare,extant,listings,minerals,tonnes,parody,cultivated,traders,pioneering,supplement,slovak,preparations,collision,partnered,vocational,atoms,malayalam,welcomed,documentation,curved,functioning,presently,formations,incorporates,nazis,botanical,nucleus,ethical,greeks,metric,automated,whereby,stance,europeans,duet,disability,purchasing,email,telescope,displaced,sodium,comparative,processor,inning,precipitation,aesthetic,import,coordination,feud,alternatively,mobility,tibet,regained,succeeding,hierarchy,apostolic,catalog,reproduction,inscriptions,vicar,clusters,posthumously,rican,loosely,additions,photographic,nowadays,selective,derivative,keyboards,guides,collectively,affecting,combines,operas,networking,decisive,terminated,continuity,finishes,ancestor,consul,heated,simulation,leipzig,incorporating,georgetown,formula_2,circa,forestry,portrayal,councillors,advancement,complained,forewings,confined,transaction,definitions,reduces,televised,1890s,rapids,phenomena,belarus,alps,landscapes,quarterly,specifications,commemorate,continuation,isolation,antenna,downstream,patents,ensuing,tended,saga,lifelong,columnist,labeled,gymnastics,papua,anticipated,demise,encompasses,madras,antarctica,interval,icon,rams,midlands,ingredients,priory,strengthen,rouge,explicit,gaza,aging,securing,anthropology,listeners,adaptations,underway,vista,malay,fortified,lightweight,violations,concerto,financed,jesuit,observers,trustee,descriptions,nordic,resistant,opted,accepts,prohibition,andhra,inflation,negro,wholly,imagery,spur,instructed,gloucester,cycles,middlesex,destroyers,statewide,evacuated,hyderabad,peasants,mice,shipyard,coordinate,pitching,colombian,exploring,numbering,compression,countess,hiatus,exceed,raced,archipelago,traits,soils,o'connor,vowel,android,facto,angola,amino,holders,logistics,circuits,emergence,kuwait,partition,emeritus,outcomes,submission,promotes,barack,negotiated,loaned,stripped,50th,excavations,treatments,fierce,participant,exports,decommissioned,cameo,remarked,residences,fuselage,mound,undergo,quarry,node,midwest,specializing,occupies,etc.,showcase,molecule,offs,modules,salon,exposition,revision,peers,positioned,hunters,competes,algorithms,reside,zagreb,calcium,uranium,silicon,airs,counterpart,outlet,collectors,sufficiently,canberra,inmates,anatomy,ensuring,curves,aviv,firearms,basque,volcano,thrust,sheikh,extensions,installations,aluminum,darker,sacked,emphasized,aligned,asserted,pseudonym,spanning,decorations,eighteenth,orbital,spatial,subdivided,notation,decay,macedonian,amended,declining,cyclist,feat,unusually,commuter,birthplace,latitude,activation,overhead,30th,finalists,whites,encyclopedia,tenor,qatar,survives,complement,concentrations,uncommon,astronomical,bangalore,pius,genome,memoir,recruit,prosecutor,modification,paired,container,basilica,arlington,displacement,germanic,mongolia,proportional,debates,matched,calcutta,rows,tehran,aerospace,prevalent,arise,lowland,24th,spokesman,supervised,advertisements,clash,tunes,revelation,wanderers,quarterfinals,fisheries,steadily,memoirs,pastoral,renewable,confluence,acquiring,strips,slogan,upstream,scouting,analyst,practitioners,turbine,strengthened,heavier,prehistoric,plural,excluding,isles,persecution,turin,rotating,villain,hemisphere,unaware,arabs,corpus,relied,singular,unanimous,schooling,passive,angles,dominance,instituted,aria,outskirts,balanced,beginnings,financially,structured,parachute,viewer,attitudes,subjected,escapes,derbyshire,erosion,addressing,styled,declaring,originating,colts,adjusted,stained,occurrence,fortifications,baghdad,nitrogen,localities,yemen,galway,debris,lodz,victorious,pharmaceutical,substances,unnamed,dwelling,atop,developmental,activism,voter,refugee,forested,relates,overlooking,genocide,kannada,insufficient,oversaw,partisan,dioxide,recipients,factions,mortality,capped,expeditions,receptors,reorganized,prominently,atom,flooded,flute,orchestral,scripts,mathematician,airplay,detached,rebuilding,dwarf,brotherhood,salvation,expressions,arabian,cameroon,poetic,recruiting,bundesliga,inserted,scrapped,disabilities,evacuation,pasha,undefeated,crafts,rituals,aluminium,norm,pools,submerged,occupying,pathway,exams,prosperity,wrestlers,promotions,basal,permits,nationalism,trim,merge,gazette,tributaries,transcription,caste,porto,emerge,modeled,adjoining,counterparts,paraguay,redevelopment,renewal,unreleased,equilibrium,similarity,minorities,soviets,comprise,nodes,tasked,unrelated,expired,johan,precursor,examinations,electrons,socialism,exiled,admiralty,floods,wigan,nonprofit,lacks,brigades,screens,repaired,hanover,fascist,labs,osaka,delays,judged,statutory,colt,col.,offspring,solving,bred,assisting,retains,somalia,grouped,corresponds,tunisia,chaplain,eminent,chord,22nd,spans,viral,innovations,possessions,mikhail,kolkata,icelandic,implications,introduces,racism,workforce,alto,compulsory,admits,censorship,onset,reluctant,inferior,iconic,progression,liability,turnout,satellites,behavioral,coordinated,exploitation,posterior,averaging,fringe,krakow,mountainous,greenwich,para,plantations,reinforcements,offerings,famed,intervals,constraints,individually,nutrition,1870s,taxation,threshold,tomatoes,fungi,contractor,ethiopian,apprentice,diabetes,wool,gujarat,honduras,norse,bucharest,23rd,arguably,accompany,prone,teammates,perennial,vacancy,polytechnic,deficit,okinawa,functionality,reminiscent,tolerance,transferring,myanmar,concludes,neighbours,hydraulic,economically,slower,plots,charities,synod,investor,catholicism,identifies,bronx,interpretations,adverse,judiciary,hereditary,nominal,sensor,symmetry,cubic,triangular,tenants,divisional,outreach,representations,passages,undergoing,cartridge,testified,exceeded,impacts,limiting,railroads,defeats,regain,rendering,humid,retreated,reliability,governorate,antwerp,infamous,implied,packaging,lahore,trades,billed,extinction,ecole,rejoined,recognizes,projection,qualifications,stripes,forts,socially,lexington,accurately,sexuality,westward,wikipedia,pilgrimage,abolition,choral,stuttgart,nests,expressing,strikeouts,assessed,monasteries,reconstructed,humorous,marxist,fertile,consort,urdu,patronage,peruvian,devised,lyric,baba,nassau,communism,extraction,popularly,markings,inability,litigation,accounted,processed,emirates,tempo,cadets,eponymous,contests,broadly,oxide,courtyard,frigate,directory,apex,outline,regency,chiefly,patrols,secretariat,cliffs,residency,privy,armament,australians,dorset,geometric,genetics,scholarships,fundraising,flats,demographic,multimedia,captained,documentaries,updates,canvas,blockade,guerrilla,songwriting,administrators,intake,drought,implementing,fraction,cannes,refusal,inscribed,meditation,announcing,exported,ballots,formula_3,curator,basel,arches,flour,subordinate,confrontation,gravel,simplified,berkshire,patriotic,tuition,employing,servers,castile,posting,combinations,discharged,miniature,mutations,constellation,incarnation,ideals,necessity,granting,ancestral,crowds,pioneered,mormon,methodology,rama,indirect,complexes,bavarian,patrons,uttar,skeleton,bollywood,flemish,viable,bloc,breeds,triggered,sustainability,tailed,referenced,comply,takeover,latvian,homestead,platoon,communal,nationality,excavated,targeting,sundays,posed,physicist,turret,endowment,marginal,dispatched,commentators,renovations,attachment,collaborations,ridges,barriers,obligations,shareholders,prof.,defenses,presided,rite,backgrounds,arbitrary,affordable,gloucestershire,thirteenth,inlet,miniseries,possesses,detained,pressures,subscription,realism,solidarity,proto,postgraduate,noun,burmese,abundance,homage,reasoning,anterior,robust,fencing,shifting,vowels,garde,profitable,loch,anchored,coastline,samoa,terminology,prostitution,magistrate,venezuelan,speculated,regulate,fixture,colonists,digit,induction,manned,expeditionary,computational,centennial,principally,vein,preserving,engineered,numerical,cancellation,conferred,continually,borne,seeded,advertisement,unanimously,treaties,infections,ions,sensors,lowered,amphibious,lava,fourteenth,bahrain,niagara,nicaragua,squares,congregations,26th,periodic,proprietary,1860s,contributors,seller,overs,emission,procession,presumed,illustrator,zinc,gases,tens,applicable,stretches,reproductive,sixteenth,apparatus,accomplishments,canoe,guam,oppose,recruitment,accumulated,limerick,namibia,staging,remixes,ordnance,uncertainty,pedestrian,temperate,treason,deposited,registry,cerambycidae,attracting,lankan,reprinted,shipbuilding,homosexuality,neurons,eliminating,1900s,resume,ministries,beneficial,blackpool,surplus,northampton,licenses,constructing,announcer,standardized,alternatives,taipei,inadequate,failures,yields,medalist,titular,obsolete,torah,burlington,predecessors,lublin,retailers,castles,depiction,issuing,gubernatorial,propulsion,tiles,damascus,discs,alternating,pomerania,peasant,tavern,redesignated,27th,illustration,focal,mans,codex,specialists,productivity,antiquity,controversies,promoter,pits,companions,behaviors,lyrical,prestige,creativity,swansea,dramas,approximate,feudal,tissues,crude,campaigned,unprecedented,chancel,amendments,surroundings,allegiance,exchanges,align,firmly,optimal,commenting,reigning,landings,obscure,1850s,contemporaries,paternal,devi,endurance,communes,incorporation,denominations,exchanged,routing,resorts,amnesty,slender,explores,suppression,heats,pronunciation,centred,coupe,stirling,freelance,treatise,linguistics,laos,informs,discovering,pillars,encourages,halted,robots,definitive,maturity,tuberculosis,venetian,silesian,unchanged,originates,mali,lincolnshire,quotes,seniors,premise,contingent,distribute,danube,gorge,logging,dams,curling,seventeenth,specializes,wetlands,deities,assess,thickness,rigid,culminated,utilities,substrate,insignia,nile,assam,shri,currents,suffrage,canadians,mortar,asteroid,bosnian,discoveries,enzymes,sanctioned,replica,hymn,investigators,tidal,dominate,derivatives,converting,leinster,verbs,honoured,criticisms,dismissal,discrete,masculine,reorganization,unlimited,wurttemberg,sacks,allocation,bahn,jurisdictions,participates,lagoon,famine,communion,culminating,surveyed,shortage,cables,intersects,cassette,foremost,adopting,solicitor,outright,bihar,reissued,farmland,dissertation,turnpike,baton,photographed,christchurch,kyoto,finances,rails,histories,linebacker,kilkenny,accelerated,dispersed,handicap,absorption,rancho,ceramic,captivity,cites,font,weighed,mater,utilize,bravery,extract,validity,slovenian,seminars,discourse,ranged,duel,ironically,warships,sega,temporal,surpassed,prolonged,recruits,northumberland,greenland,contributes,patented,eligibility,unification,discusses,reply,translates,beirut,relies,torque,northward,reviewers,monastic,accession,neural,tramway,heirs,sikh,subscribers,amenities,taliban,audit,rotterdam,wagons,kurdish,favoured,combustion,meanings,persia,browser,diagnostic,niger,formula_4,denomination,dividing,parameter,branding,badminton,leningrad,sparked,hurricanes,beetles,propeller,mozambique,refined,diagram,exhaust,vacated,readings,markers,reconciliation,determines,concurrent,imprint,primera,organism,demonstrating,filmmakers,vanderbilt,affiliates,traction,evaluated,defendants,megachile,investigative,zambia,assassinated,rewarded,probable,staffordshire,foreigners,directorate,nominees,consolidation,commandant,reddish,differing,unrest,drilling,bohemia,resembling,instrumentation,considerations,haute,promptly,variously,dwellings,clans,tablet,enforced,cockpit,semifinal,hussein,prisons,ceylon,emblem,monumental,phrases,correspond,crossover,outlined,characterised,acceleration,caucus,crusade,protested,composing,rajasthan,habsburg,rhythmic,interception,inherent,cooled,ponds,spokesperson,gradual,consultation,kuala,globally,suppressed,builders,avengers,suffix,integer,enforce,fibers,unionist,proclamation,uncovered,infrared,adapt,eisenhower,utilizing,captains,stretched,observing,assumes,prevents,analyses,saxophone,caucasus,notices,villains,dartmouth,mongol,hostilities,stretching,veterinary,lenses,texture,prompting,overthrow,excavation,islanders,masovian,battleship,biographer,replay,degradation,departing,luftwaffe,fleeing,oversight,immigrated,serbs,fishermen,strengthening,respiratory,italians,denotes,radial,escorted,motif,wiltshire,expresses,accessories,reverted,establishments,inequality,protocols,charting,famously,satirical,entirety,trench,friction,atletico,sampling,subset,weekday,upheld,sharply,correlation,incorrect,mughal,travelers,hasan,earnings,offset,evaluate,specialised,recognizing,flexibility,nagar,postseason,algebraic,capitalism,crystals,melodies,polynomial,racecourse,defences,austro,wembley,attracts,anarchist,resurrection,reviewing,decreasing,prefix,ratified,mutation,displaying,separating,restoring,assemblies,ordinance,priesthood,cruisers,appoint,moldova,imports,directive,epidemic,militant,senegal,signaling,restriction,critique,retrospective,nationalists,undertake,sioux,canals,algerian,redesigned,philanthropist,depict,conceptual,turbines,intellectuals,eastward,applicants,contractors,vendors,undergone,namesake,ensured,tones,substituted,hindwings,arrests,tombs,transitional,principality,reelection,taiwanese,cavity,manifesto,broadcasters,spawned,thoroughbred,identities,generators,proposes,hydroelectric,johannesburg,cortex,scandinavian,killings,aggression,boycott,catalyst,physiology,fifteenth,waterfront,chromosome,organist,costly,calculation,cemeteries,flourished,recognise,juniors,merging,disciples,ashore,workplace,enlightenment,diminished,debated,hailed,podium,educate,mandated,distributor,litre,electromagnetic,flotilla,estuary,peterborough,staircase,selections,melodic,confronts,wholesale,integrate,intercepted,catalonia,unite,immense,palatinate,switches,earthquakes,occupational,successors,praising,concluding,faculties,firstly,overhaul,empirical,metacritic,inauguration,evergreen,laden,winged,philosophers,amalgamated,geoff,centimeters,napoleonic,upright,planting,brewing,fined,sensory,migrants,wherein,inactive,headmaster,warwickshire,siberia,terminals,denounced,academia,divinity,bilateral,clive,omitted,peerage,relics,apartheid,syndicate,fearing,fixtures,desirable,dismantled,ethnicity,valves,biodiversity,aquarium,ideological,visibility,creators,analyzed,tenant,balkan,postwar,supplier,smithsonian,risen,morphology,digits,bohemian,wilmington,vishnu,demonstrates,aforementioned,biographical,mapped,khorasan,phosphate,presentations,ecosystem,processors,calculations,mosaic,clashes,penned,recalls,coding,angular,lattice,macau,accountability,extracted,pollen,therapeutic,overlap,violinist,deposed,candidacy,infants,covenant,bacterial,restructuring,dungeons,ordination,conducts,builds,invasive,customary,concurrently,relocation,cello,statutes,borneo,entrepreneurs,sanctions,packet,rockefeller,piedmont,comparisons,waterfall,receptions,glacial,surge,signatures,alterations,advertised,enduring,somali,botanist,100th,canonical,motifs,longitude,circulated,alloy,indirectly,margins,preserves,internally,besieged,shale,peripheral,drained,baseman,reassigned,tobago,soloist,socio,grazing,contexts,roofs,portraying,ottomans,shrewsbury,noteworthy,lamps,supplying,beams,qualifier,portray,greenhouse,stronghold,hitter,rites,cretaceous,urging,derive,nautical,aiming,fortunes,verde,donors,reliance,exceeding,exclusion,exercised,simultaneous,continents,guiding,pillar,gradient,poznan,eruption,clinics,moroccan,indicator,trams,piers,parallels,fragment,teatro,potassium,satire,compressed,businessmen,influx,seine,perspectives,shelters,decreases,mounting,formula_5,confederacy,equestrian,expulsion,mayors,liberia,resisted,affinity,shrub,unexpectedly,stimulus,amtrak,deported,perpendicular,statesman,wharf,storylines,romanesque,weights,surfaced,interceptions,dhaka,crambidae,orchestras,rwanda,conclude,constitutes,subsidiaries,admissions,prospective,shear,bilingual,campaigning,presiding,domination,commemorative,trailing,confiscated,petrol,acquisitions,polymer,onlyinclude,chloride,elevations,resolutions,hurdles,pledged,likelihood,objected,erect,encoding,databases,aristotle,hindus,marshes,bowled,ministerial,grange,acronym,annexation,squads,ambient,pilgrims,botany,sofla,astronomer,planetary,descending,bestowed,ceramics,diplomacy,metabolism,colonization,potomac,africans,engraved,recycling,commitments,resonance,disciplinary,jamaican,narrated,spectral,tipperary,waterford,stationary,arbitration,transparency,threatens,crossroads,slalom,oversee,centenary,incidence,economies,livery,moisture,newsletter,autobiographical,bhutan,propelled,dependence,moderately,adobe,barrels,subdivisions,outlook,labelled,stratford,arising,diaspora,barony,automobiles,ornamental,slated,norms,primetime,generalized,analysts,vectors,libyan,yielded,certificates,rooted,vernacular,belarusian,marketplace,prediction,fairfax,malawi,viruses,wooded,demos,mauritius,prosperous,coincided,liberties,huddersfield,ascent,warnings,hinduism,glucose,pulitzer,unused,filters,illegitimate,acquitted,protestants,canopy,staple,psychedelic,winding,abbas,pathways,cheltenham,lagos,niche,invaders,proponents,barred,conversely,doncaster,recession,embraced,rematch,concession,emigration,upgrades,bowls,tablets,remixed,loops,kensington,shootout,monarchs,organizers,harmful,punjabi,broadband,exempt,neolithic,profiles,portrays,parma,cyrillic,quasi,attested,regimental,revive,torpedoes,heidelberg,rhythms,spherical,denote,hymns,icons,theologian,qaeda,exceptionally,reinstated,comune,playhouse,lobbying,grossing,viceroy,delivers,visually,armistice,utrecht,syllable,vertices,analogous,annex,refurbished,entrants,knighted,disciple,rhetoric,detailing,inactivated,ballads,algae,intensified,favourable,sanitation,receivers,pornography,commemorated,cannons,entrusted,manifold,photographers,pueblo,textiles,steamer,myths,marquess,onward,liturgical,romney,uzbekistan,consistency,denoted,hertfordshire,convex,hearings,sulfur,universidad,podcast,selecting,emperors,arises,justices,1840s,mongolian,exploited,termination,digitally,infectious,sedan,symmetric,penal,illustrate,formulation,attribute,problematic,modular,inverse,berth,searches,rutgers,leicestershire,enthusiasts,lockheed,upwards,transverse,accolades,backward,archaeologists,crusaders,nuremberg,defects,ferries,vogue,containers,openings,transporting,separates,lumpur,purchases,attain,wichita,topology,woodlands,deleted,periodically,syntax,overturned,musicals,corp.,strasbourg,instability,nationale,prevailing,cache,marathi,versailles,unmarried,grains,straits,antagonist,segregation,assistants,d'etat,contention,dictatorship,unpopular,motorcycles,criterion,analytical,salzburg,militants,hanged,worcestershire,emphasize,paralympic,erupted,convinces,offences,oxidation,nouns,populace,atari,spanned,hazardous,educators,playable,births,baha'i,preseason,generates,invites,meteorological,handbook,foothills,enclosure,diffusion,mirza,convergence,geelong,coefficient,connector,formula_6,cylindrical,disasters,pleaded,knoxville,contamination,compose,libertarian,arrondissement,franciscan,intercontinental,susceptible,initiation,malaria,unbeaten,consonants,waived,saloon,popularized,estadio,pseudo,interdisciplinary,transports,transformers,carriages,bombings,revolves,ceded,collaborator,celestial,exemption,colchester,maltese,oceanic,ligue,crete,shareholder,routed,depictions,ridden,advisors,calculate,lending,guangzhou,simplicity,newscast,scheduling,snout,eliot,undertaking,armenians,nottinghamshire,whitish,consulted,deficiency,salle,cinemas,superseded,rigorous,kerman,convened,landowners,modernization,evenings,pitches,conditional,scandinavia,differed,formulated,cyclists,swami,guyana,dunes,electrified,appalachian,abdomen,scenarios,prototypes,sindh,consonant,adaptive,boroughs,wolverhampton,modelling,cylinders,amounted,minimize,ambassadors,lenin,settler,coincide,approximation,grouping,murals,bullying,registers,rumours,engagements,energetic,vertex,annals,bordering,geologic,yellowish,runoff,converts,allegheny,facilitated,saturdays,colliery,monitored,rainforest,interfaces,geographically,impaired,prevalence,joachim,paperback,slowed,shankar,distinguishing,seminal,categorized,authorised,auspices,bandwidth,asserts,rebranded,balkans,supplemented,seldom,weaving,capsule,apostles,populous,monmouth,payload,symphonic,densely,shoreline,managerial,masonry,antioch,averages,textbooks,royalist,coliseum,tandem,brewers,diocesan,posthumous,walled,incorrectly,distributions,ensued,reasonably,graffiti,propagation,automation,harmonic,augmented,middleweight,limbs,elongated,landfall,comparatively,literal,grossed,koppen,wavelength,1830s,cerebral,boasts,congestion,physiological,practitioner,coasts,cartoonist,undisclosed,frontal,launches,burgundy,qualifiers,imposing,stade,flanked,assyrian,raided,multiplayer,montane,chesapeake,pathology,drains,vineyards,intercollegiate,semiconductor,grassland,convey,citations,predominant,rejects,benefited,yahoo,graphs,busiest,encompassing,hamlets,explorers,suppress,minors,graphical,calculus,sediment,intends,diverted,mainline,unopposed,cottages,initiate,alumnus,towed,autism,forums,darlington,modernist,oxfordshire,lectured,capitalist,suppliers,panchayat,actresses,foundry,southbound,commodity,wesleyan,divides,palestinians,luton,caretaker,nobleman,mutiny,organizer,preferences,nomenclature,splits,unwilling,offenders,timor,relying,halftime,semitic,arithmetic,milestone,jesuits,arctiidae,retrieved,consuming,contender,edged,plagued,inclusive,transforming,khmer,federally,insurgents,distributing,amherst,rendition,prosecutors,viaduct,disqualified,kabul,liturgy,prevailed,reelected,instructors,swimmers,aperture,churchyard,interventions,totals,darts,metropolis,fuels,fluent,northbound,correctional,inflicted,barrister,realms,culturally,aristocratic,collaborating,emphasizes,choreographer,inputs,ensembles,humboldt,practised,endowed,strains,infringement,archaeologist,congregational,magna,relativity,efficiently,proliferation,mixtape,abruptly,regeneration,commissioning,yukon,archaic,reluctantly,retailer,northamptonshire,universally,crossings,boilers,nickelodeon,revue,abbreviation,retaliation,scripture,routinely,medicinal,benedictine,kenyan,retention,deteriorated,glaciers,apprenticeship,coupling,researched,topography,entrances,anaheim,pivotal,compensate,arched,modify,reinforce,dusseldorf,journeys,motorsport,conceded,sumatra,spaniards,quantitative,loire,cinematography,discarded,botswana,morale,engined,zionist,philanthropy,sainte,fatalities,cypriot,motorsports,indicators,pricing,institut,bethlehem,implicated,gravitational,differentiation,rotor,thriving,precedent,ambiguous,concessions,forecast,conserved,fremantle,asphalt,landslide,middlesbrough,formula_7,humidity,overseeing,chronological,diaries,multinational,crimean,turnover,improvised,youths,declares,tasmanian,canadiens,fumble,refinery,weekdays,unconstitutional,upward,guardians,brownish,imminent,hamas,endorsement,naturalist,martyrs,caledonia,chords,yeshiva,reptiles,severity,mitsubishi,fairs,installment,substitution,repertory,keyboardist,interpreter,silesia,noticeable,rhineland,transmit,inconsistent,booklet,academies,epithet,pertaining,progressively,aquatics,scrutiny,prefect,toxicity,rugged,consume,o'donnell,evolve,uniquely,cabaret,mediated,landowner,transgender,palazzo,compilations,albuquerque,induce,sinai,remastered,efficacy,underside,analogue,specify,possessing,advocating,compatibility,liberated,greenville,mecklenburg,header,memorials,sewage,rhodesia,1800s,salaries,atoll,coordinating,partisans,repealed,amidst,subjective,optimization,nectar,evolving,exploits,madhya,styling,accumulation,raion,postage,responds,buccaneers,frontman,brunei,choreography,coated,kinetic,sampled,inflammatory,complementary,eclectic,norte,vijay,a.k.a,mainz,casualty,connectivity,laureate,franchises,yiddish,reputed,unpublished,economical,periodicals,vertically,bicycles,brethren,capacities,unitary,archeological,tehsil,domesday,wehrmacht,justification,angered,mysore,fielded,abuses,nutrients,ambitions,taluk,battleships,symbolism,superiority,neglect,attendees,commentaries,collaborators,predictions,yorker,breeders,investing,libretto,informally,coefficients,memorandum,pounder,collingwood,tightly,envisioned,arbor,mistakenly,captures,nesting,conflicting,enhancing,streetcar,manufactures,buckinghamshire,rewards,commemorating,stony,expenditure,tornadoes,semantic,relocate,weimar,iberian,sighted,intending,ensign,beverages,expectation,differentiate,centro,utilizes,saxophonist,catchment,transylvania,ecosystems,shortest,sediments,socialists,ineffective,kapoor,formidable,heroine,guantanamo,prepares,scattering,pamphlet,verified,elector,barons,totaling,shrubs,pyrenees,amalgamation,mutually,longitudinal,comte,negatively,masonic,envoy,sexes,akbar,mythical,tonga,bishopric,assessments,malaya,warns,interiors,reefs,reflections,neutrality,musically,nomadic,waterways,provence,collaborate,scaled,adulthood,emerges,euros,optics,incentives,overland,periodical,liege,awarding,realization,slang,affirmed,schooner,hokkaido,czechoslovak,protectorate,undrafted,disagreed,commencement,electors,spruce,swindon,fueled,equatorial,inventions,suites,slovene,backdrop,adjunct,energies,remnant,inhabit,alliances,simulcast,reactors,mosques,travellers,outfielder,plumage,migratory,benin,experimented,fibre,projecting,drafting,laude,evidenced,northernmost,indicted,directional,replication,croydon,comedies,jailed,organizes,devotees,reservoirs,turrets,originate,economists,songwriters,junta,trenches,mounds,proportions,comedic,apostle,azerbaijani,farmhouse,resembled,disrupted,playback,mixes,diagonal,relevance,govern,programmer,gdansk,maize,soundtracks,tendencies,mastered,impacted,believers,kilometre,intervene,chairperson,aerodrome,sails,subsidies,ensures,aesthetics,congresses,ratios,sardinia,southernmost,functioned,controllers,downward,randomly,distortion,regents,palatine,disruption,spirituality,vidhan,tracts,compiler,ventilation,anchorage,symposium,assert,pistols,excelled,avenues,convoys,moniker,constructions,proponent,phased,spines,organising,schleswig,policing,campeonato,mined,hourly,croix,lucrative,authenticity,haitian,stimulation,burkina,espionage,midfield,manually,staffed,awakening,metabolic,biographies,entrepreneurship,conspicuous,guangdong,preface,subgroup,mythological,adjutant,feminism,vilnius,oversees,honourable,tripoli,stylized,kinase,societe,notoriety,altitudes,configurations,outward,transmissions,announces,auditor,ethanol,clube,nanjing,mecca,haifa,blogs,postmaster,paramilitary,depart,positioning,potent,recognizable,spire,brackets,remembrance,overlapping,turkic,articulated,scientology,operatic,deploy,readiness,biotechnology,restrict,cinematographer,inverted,synonymous,administratively,westphalia,commodities,replaces,downloads,centralized,munitions,preached,sichuan,fashionable,implementations,matrices,hiv/aids,loyalist,luzon,celebrates,hazards,heiress,mercenaries,synonym,creole,ljubljana,technician,auditioned,technicians,viewpoint,wetland,mongols,princely,sharif,coating,dynasties,southward,doubling,formula_8,mayoral,harvesting,conjecture,goaltender,oceania,spokane,welterweight,bracket,gatherings,weighted,newscasts,mussolini,affiliations,disadvantage,vibrant,spheres,sultanate,distributors,disliked,establishes,marches,drastically,yielding,jewellery,yokohama,vascular,airlift,canons,subcommittee,repression,strengths,graded,outspoken,fused,pembroke,filmography,redundant,fatigue,repeal,threads,reissue,pennant,edible,vapor,corrections,stimuli,commemoration,dictator,anand,secession,amassed,orchards,pontifical,experimentation,greeted,bangor,forwards,decomposition,quran,trolley,chesterfield,traverse,sermons,burials,skier,climbs,consultants,petitioned,reproduce,parted,illuminated,kurdistan,reigned,occupants,packaged,geometridae,woven,regulating,protagonists,crafted,affluent,clergyman,consoles,migrant,supremacy,attackers,caliph,defect,convection,rallies,huron,resin,segunda,quota,warship,overseen,criticizing,shrines,glamorgan,lowering,beaux,hampered,invasions,conductors,collects,bluegrass,surrounds,substrates,perpetual,chronology,pulmonary,executions,crimea,compiling,noctuidae,battled,tumors,minsk,novgorod,serviced,yeast,computation,swamps,theodor,baronetcy,salford,uruguayan,shortages,odisha,siberian,novelty,cinematic,invitational,decks,dowager,oppression,bandits,appellate,state-of-the-art,clade,palaces,signalling,galaxies,industrialist,tensor,learnt,incurred,magistrates,binds,orbits,ciudad,willingness,peninsular,basins,biomedical,shafts,marlborough,bournemouth,withstand,fitzroy,dunedin,variance,steamship,integrating,muscular,fines,akron,bulbophyllum,malmo,disclosed,cornerstone,runways,medicines,twenty20,gettysburg,progresses,frigates,bodied,transformations,transforms,helens,modelled,versatile,regulator,pursuits,legitimacy,amplifier,scriptures,voyages,examines,presenters,octagonal,poultry,formula_9,anatolia,computed,migrate,directorial,hybrids,localized,preferring,guggenheim,persisted,grassroots,inflammation,fishery,otago,vigorous,professions,instructional,inexpensive,insurgency,legislators,sequels,surnames,agrarian,stainless,nairobi,minas,forerunner,aristocracy,transitions,sicilian,showcased,doses,hiroshima,summarized,gearbox,emancipation,limitation,nuclei,seismic,abandonment,dominating,appropriations,occupations,electrification,hilly,contracting,exaggerated,entertainer,kazan,oricon,cartridges,characterization,parcel,maharaja,exceeds,aspiring,obituary,flattened,contrasted,narration,replies,oblique,outpost,fronts,arranger,talmud,keynes,doctrines,endured,confesses,fortification,supervisors,kilometer,academie,jammu,bathurst,piracy,prostitutes,navarre,cumulative,cruises,lifeboat,twinned,radicals,interacting,expenditures,wexford,libre,futsal,curated,clockwise,colloquially,procurement,immaculate,lyricist,enhancement,porcelain,alzheimer,highlighting,judah,disagreements,storytelling,sheltered,wroclaw,vaudeville,contrasts,neoclassical,compares,contrasting,deciduous,francaise,descriptive,cyclic,reactive,antiquities,meiji,repeats,creditors,forcibly,newmarket,picturesque,impending,uneven,bison,raceway,solvent,ecumenical,optic,professorship,harvested,waterway,banjo,pharaoh,geologist,scanning,dissent,recycled,unmanned,retreating,gospels,aqueduct,branched,tallinn,groundbreaking,syllables,hangar,designations,procedural,craters,cabins,encryption,anthropologist,montevideo,outgoing,inverness,chattanooga,fascism,calais,chapels,groundwater,downfall,misleading,robotic,tortricidae,pixel,handel,prohibit,crewe,renaming,reprised,kickoff,leftist,spaced,integers,causeway,pines,authorship,organise,ptolemy,accessibility,virtues,lesions,iroquois,qur'an,atheist,synthesized,biennial,confederates,dietary,skaters,stresses,tariff,koreans,intercity,republics,quintet,baroness,naive,amplitude,insistence,tbilisi,residues,grammatical,diversified,egyptians,accompaniment,vibration,repository,mandal,topological,distinctions,coherent,invariant,batters,nuevo,internationals,implements,follower,bahia,widened,independents,cantonese,totaled,guadalajara,wolverines,befriended,muzzle,surveying,hungarians,medici,deportation,rayon,approx,recounts,attends,clerical,hellenic,furnished,alleging,soluble,systemic,gallantry,bolshevik,intervened,hostel,gunpowder,specialising,stimulate,leiden,removes,thematic,floral,bafta,printers,conglomerate,eroded,analytic,successively,lehigh,thessaloniki,kilda,clauses,ascended,nehru,scripted,tokugawa,competence,diplomats,exclude,consecration,freedoms,assaults,revisions,blacksmith,textual,sparse,concacaf,slain,uploaded,enraged,whaling,guise,stadiums,debuting,dormitory,cardiovascular,yunnan,dioceses,consultancy,notions,lordship,archdeacon,collided,medial,airfields,garment,wrestled,adriatic,reversal,refueling,verification,jakob,horseshoe,intricate,veracruz,sarawak,syndication,synthesizer,anthologies,stature,feasibility,guillaume,narratives,publicized,antrim,intermittent,constituents,grimsby,filmmaking,doping,unlawful,nominally,transmitting,documenting,seater,internationale,ejected,steamboat,alsace,boise,ineligible,geared,vassal,mustered,ville,inline,pairing,eurasian,kyrgyzstan,barnsley,reprise,stereotypes,rushes,conform,firefighters,deportivo,revolutionaries,rabbis,concurrency,charters,sustaining,aspirations,algiers,chichester,falkland,morphological,systematically,volcanoes,designate,artworks,reclaimed,jurist,anglia,resurrected,chaotic,feasible,circulating,simulated,environmentally,confinement,adventist,harrisburg,laborers,ostensibly,universiade,pensions,influenza,bratislava,octave,refurbishment,gothenburg,putin,barangay,annapolis,breaststroke,illustrates,distorted,choreographed,promo,emphasizing,stakeholders,descends,exhibiting,intrinsic,invertebrates,evenly,roundabout,salts,formula_10,strata,inhibition,branching,stylistic,rumored,realises,mitochondrial,commuted,adherents,logos,bloomberg,telenovela,guineas,charcoal,engages,winery,reflective,siena,cambridgeshire,ventral,flashback,installing,engraving,grasses,traveller,rotated,proprietor,nationalities,precedence,sourced,trainers,cambodian,reductions,depleted,saharan,classifications,biochemistry,plaintiffs,arboretum,humanist,fictitious,aleppo,climates,bazaar,his/her,homogeneous,multiplication,moines,indexed,linguist,skeletal,foliage,societal,differentiated,informing,mammal,infancy,archival,cafes,malls,graeme,musee,schizophrenia,fargo,pronouns,derivation,descend,ascending,terminating,deviation,recaptured,confessions,weakening,tajikistan,bahadur,pasture,b/hip,donegal,supervising,sikhs,thinkers,euclidean,reinforcement,friars,portage,fuscous,lucknow,synchronized,assertion,choirs,privatization,corrosion,multitude,skyscraper,royalties,ligament,usable,spores,directs,clashed,stockport,fronted,dependency,contiguous,biologist,backstroke,powerhouse,frescoes,phylogenetic,welding,kildare,gabon,conveyed,augsburg,severn,continuum,sahib,lille,injuring,passeriformesfamily,succeeds,translating,unitarian,startup,turbulent,outlying,philanthropic,stanislaw,idols,claremont,conical,haryana,armagh,blended,implicit,conditioned,modulation,rochdale,labourers,coinage,shortstop,potsdam,gears,obesity,bestseller,advisers,bouts,comedians,jozef,lausanne,taxonomic,correlated,columbian,marne,indications,psychologists,libel,edict,beaufort,disadvantages,renal,finalized,racehorse,unconventional,disturbances,falsely,zoology,adorned,redesign,executing,narrower,commended,appliances,stalls,resurgence,saskatoon,miscellaneous,permitting,epoch,formula_11,cumbria,forefront,vedic,eastenders,disposed,supermarkets,rower,inhibitor,magnesium,colourful,yusuf,harrow,formulas,centrally,balancing,ionic,nocturnal,consolidate,ornate,raiding,charismatic,accelerate,nominate,residual,dhabi,commemorates,attribution,uninhabited,mindanao,atrocities,genealogical,romani,applicant,enactment,abstraction,trough,pulpit,minuscule,misconduct,grenades,timely,supplements,messaging,curvature,ceasefire,telangana,susquehanna,braking,redistribution,shreveport,neighbourhoods,gregorian,widowed,khuzestan,empowerment,scholastic,evangelist,peptide,topical,theorist,historia,thence,sudanese,museo,jurisprudence,masurian,frankish,headlined,recounted,netball,petitions,tolerant,hectare,truncated,southend,methane,captives,reigns,massif,subunit,acidic,weightlifting,footballers,sabah,britannia,tunisian,segregated,sawmill,withdrawing,unpaid,weaponry,somme,perceptions,unicode,alcoholism,durban,wrought,waterfalls,jihad,auschwitz,upland,eastbound,adjective,anhalt,evaluating,regimes,guildford,reproduced,pamphlets,hierarchical,maneuvers,hanoi,fabricated,repetition,enriched,arterial,replacements,tides,globalization,adequately,westbound,satisfactory,fleets,phosphorus,lastly,neuroscience,anchors,xinjiang,membranes,improvisation,shipments,orthodoxy,submissions,bolivian,mahmud,ramps,leyte,pastures,outlines,flees,transmitters,fares,sequential,stimulated,novice,alternately,symmetrical,breakaway,layered,baronets,lizards,blackish,edouard,horsepower,penang,principals,mercantile,maldives,overwhelmingly,hawke,rallied,prostate,conscription,juveniles,maccabi,carvings,strikers,sudbury,spurred,improves,lombardy,macquarie,parisian,elastic,distillery,shetland,humane,brentford,wrexham,warehouses,routines,encompassed,introductory,isfahan,instituto,palais,revolutions,sporadic,impoverished,portico,fellowships,speculative,enroll,dormant,adhere,fundamentally,sculpted,meritorious,template,upgrading,reformer,rectory,uncredited,indicative,creeks,galveston,radically,hezbollah,firearm,educating,prohibits,trondheim,locus,refit,headwaters,screenings,lowlands,wasps,coarse,attaining,sedimentary,perished,pitchfork,interned,cerro,stagecoach,aeronautical,liter,transitioned,haydn,inaccurate,legislatures,bromwich,knesset,spectroscopy,butte,asiatic,degraded,concordia,catastrophic,lobes,wellness,pensacola,periphery,hapoel,theta,horizontally,freiburg,liberalism,pleas,durable,warmian,offenses,mesopotamia,shandong,unsuitable,hospitalized,appropriately,phonetic,encompass,conversions,observes,illnesses,breakout,assigns,crowns,inhibitors,nightly,manifestation,fountains,maximize,alphabetical,sloop,expands,newtown,widening,gaddafi,commencing,camouflage,footprint,tyrol,barangays,universite,highlanders,budgets,query,lobbied,westchester,equator,stipulated,pointe,distinguishes,allotted,embankment,advises,storing,loyalists,fourier,rehearsals,starvation,gland,rihanna,tubular,expressive,baccalaureate,intersections,revered,carbonate,eritrea,craftsmen,cosmopolitan,sequencing,corridors,shortlisted,bangladeshi,persians,mimic,parades,repetitive,recommends,flanks,promoters,incompatible,teaming,ammonia,greyhound,solos,improper,legislator,newsweek,recurrent,vitro,cavendish,eireann,crises,prophets,mandir,strategically,guerrillas,formula_12,ghent,contenders,equivalence,drone,sociological,hamid,castes,statehood,aland,clinched,relaunched,tariffs,simulations,williamsburg,rotate,mediation,smallpox,harmonica,lodges,lavish,restrictive,o'sullivan,detainees,polynomials,echoes,intersecting,learners,elects,charlemagne,defiance,epsom,liszt,facilitating,absorbing,revelations,padua,pieter,pious,penultimate,mammalian,montenegrin,supplementary,widows,aromatic,croats,roanoke,trieste,legions,subdistrict,babylonian,grasslands,volga,violently,sparsely,oldies,telecommunication,respondents,quarries,downloadable,commandos,taxpayer,catalytic,malabar,afforded,copying,declines,nawab,junctions,assessing,filtering,classed,disused,compliant,christoph,gottingen,civilizations,hermitage,caledonian,whereupon,ethnically,springsteen,mobilization,terraces,indus,excel,zoological,enrichment,simulate,guitarists,registrar,cappella,invoked,reused,manchu,configured,uppsala,genealogy,mergers,casts,curricular,rebelled,subcontinent,horticultural,parramatta,orchestrated,dockyard,claudius,decca,prohibiting,turkmenistan,brahmin,clandestine,obligatory,elaborated,parasitic,helix,constraint,spearheaded,rotherham,eviction,adapting,albans,rescues,sociologist,guiana,convicts,occurrences,kamen,antennas,asturias,wheeled,sanitary,deterioration,trier,theorists,baseline,announcements,valea,planners,factual,serialized,serials,bilbao,demoted,fission,jamestown,cholera,alleviate,alteration,indefinite,sulfate,paced,climatic,valuation,artisans,proficiency,aegean,regulators,fledgling,sealing,influencing,servicemen,frequented,cancers,tambon,narayan,bankers,clarified,embodied,engraver,reorganisation,dissatisfied,dictated,supplemental,temperance,ratification,puget,nutrient,pretoria,papyrus,uniting,ascribed,cores,coptic,schoolhouse,barrio,1910s,armory,defected,transatlantic,regulates,ported,artefacts,specifies,boasted,scorers,mollusks,emitted,navigable,quakers,projective,dialogues,reunification,exponential,vastly,banners,unsigned,dissipated,halves,coincidentally,leasing,purported,escorting,estimation,foxes,lifespan,inflorescence,assimilation,showdown,staunch,prologue,ligand,superliga,telescopes,northwards,keynote,heaviest,taunton,redeveloped,vocalists,podlaskie,soyuz,rodents,azores,moravian,outset,parentheses,apparel,domestically,authoritative,polymers,monterrey,inhibit,launcher,jordanian,folds,taxis,mandates,singled,liechtenstein,subsistence,marxism,ousted,governorship,servicing,offseason,modernism,prism,devout,translators,islamist,chromosomes,pitted,bedfordshire,fabrication,authoritarian,javanese,leaflets,transient,substantive,predatory,sigismund,assassinate,diagrams,arrays,rediscovered,reclamation,spawning,fjord,peacekeeping,strands,fabrics,highs,regulars,tirana,ultraviolet,athenian,filly,barnet,naacp,nueva,favourites,terminates,showcases,clones,inherently,interpreting,bjorn,finely,lauded,unspecified,chola,pleistocene,insulation,antilles,donetsk,funnel,nutritional,biennale,reactivated,southport,primate,cavaliers,austrians,interspersed,restarted,suriname,amplifiers,wladyslaw,blockbuster,sportsman,minogue,brightness,benches,bridgeport,initiating,israelis,orbiting,newcomers,externally,scaling,transcribed,impairment,luxurious,longevity,impetus,temperament,ceilings,tchaikovsky,spreads,pantheon,bureaucracy,1820s,heraldic,villas,formula_13,galician,meath,avoidance,corresponded,headlining,connacht,seekers,rappers,solids,monograph,scoreless,opole,isotopes,himalayas,parodies,garments,microscopic,republished,havilland,orkney,demonstrators,pathogen,saturated,hellenistic,facilitates,aerodynamic,relocating,indochina,laval,astronomers,bequeathed,administrations,extracts,nagoya,torquay,demography,medicare,ambiguity,renumbered,pursuant,concave,syriac,electrode,dispersal,henan,bialystok,walsall,crystalline,puebla,janata,illumination,tianjin,enslaved,coloration,championed,defamation,grille,johor,rejoin,caspian,fatally,planck,workings,appointing,institutionalized,wessex,modernized,exemplified,regatta,jacobite,parochial,programmers,blending,eruptions,insurrection,regression,indices,sited,dentistry,mobilized,furnishings,levant,primaries,ardent,nagasaki,conqueror,dorchester,opined,heartland,amman,mortally,wellesley,bowlers,outputs,coveted,orthography,immersion,disrepair,disadvantaged,curate,childless,condensed,codice_1,remodeled,resultant,bolsheviks,superfamily,saxons,2010s,contractual,rivalries,malacca,oaxaca,magnate,vertebrae,quezon,olympiad,yucatan,tyres,macro,specialization,commendation,caliphate,gunnery,exiles,excerpts,fraudulent,adjustable,aramaic,interceptor,drumming,standardization,reciprocal,adolescents,federalist,aeronautics,favorably,enforcing,reintroduced,zhejiang,refining,biplane,banknotes,accordion,intersect,illustrating,summits,classmate,militias,biomass,massacres,epidemiology,reworked,wrestlemania,nantes,auditory,taxon,elliptical,chemotherapy,asserting,avoids,proficient,airmen,yellowstone,multicultural,alloys,utilization,seniority,kuyavian,huntsville,orthogonal,bloomington,cultivars,casimir,internment,repulsed,impedance,revolving,fermentation,parana,shutout,partnering,empowered,islamabad,polled,classify,amphibians,greyish,obedience,4x100,projectile,khyber,halfback,relational,d'ivoire,synonyms,endeavour,padma,customized,mastery,defenceman,berber,purge,interestingly,covent,promulgated,restricting,condemnation,hillsborough,walkers,privateer,intra,captaincy,naturalized,huffington,detecting,hinted,migrating,bayou,counterattack,anatomical,foraging,unsafe,swiftly,outdated,paraguayan,attire,masjid,endeavors,jerseys,triassic,quechua,growers,axial,accumulate,wastewater,cognition,fungal,animator,pagoda,kochi,uniformly,antibody,yerevan,hypotheses,combatants,italianate,draining,fragmentation,snowfall,formative,inversion,kitchener,identifier,additive,lucha,selects,ashland,cambrian,racetrack,trapping,congenital,primates,wavelengths,expansions,yeomanry,harcourt,wealthiest,awaited,punta,intervening,aggressively,vichy,piloted,midtown,tailored,heyday,metadata,guadalcanal,inorganic,hadith,pulses,francais,tangent,scandals,erroneously,tractors,pigment,constabulary,jiangsu,landfill,merton,basalt,astor,forbade,debuts,collisions,exchequer,stadion,roofed,flavour,sculptors,conservancy,dissemination,electrically,undeveloped,existent,surpassing,pentecostal,manifested,amend,formula_14,superhuman,barges,tunis,analytics,argyll,liquids,mechanized,domes,mansions,himalayan,indexing,reuters,nonlinear,purification,exiting,timbers,triangles,decommissioning,departmental,causal,fonts,americana,sept.,seasonally,incomes,razavi,sheds,memorabilia,rotational,terre,sutra,protege,yarmouth,grandmaster,annum,looted,imperialism,variability,liquidation,baptised,isotope,showcasing,milling,rationale,hammersmith,austen,streamlined,acknowledging,contentious,qaleh,breadth,turing,referees,feral,toulon,unofficially,identifiable,standout,labeling,dissatisfaction,jurgen,angrily,featherweight,cantons,constrained,dominates,standalone,relinquished,theologians,markedly,italics,downed,nitrate,likened,gules,craftsman,singaporean,pixels,mandela,moray,parity,departement,antigen,academically,burgh,brahma,arranges,wounding,triathlon,nouveau,vanuatu,banded,acknowledges,unearthed,stemming,authentication,byzantines,converge,nepali,commonplace,deteriorating,recalling,palette,mathematicians,greenish,pictorial,ahmedabad,rouen,validation,u.s.a.,'best,malvern,archers,converter,undergoes,fluorescent,logistical,notification,transvaal,illicit,symphonies,stabilization,worsened,fukuoka,decrees,enthusiast,seychelles,blogger,louvre,dignitaries,burundi,wreckage,signage,pinyin,bursts,federer,polarization,urbana,lazio,schism,nietzsche,venerable,administers,seton,kilograms,invariably,kathmandu,farmed,disqualification,earldom,appropriated,fluctuations,kermanshah,deployments,deformation,wheelbase,maratha,psalm,bytes,methyl,engravings,skirmish,fayette,vaccines,ideally,astrology,breweries,botanic,opposes,harmonies,irregularities,contended,gaulle,prowess,constants,aground,filipinos,fresco,ochreous,jaipur,willamette,quercus,eastwards,mortars,champaign,braille,reforming,horned,hunan,spacious,agitation,draught,specialties,flourishing,greensboro,necessitated,swedes,elemental,whorls,hugely,structurally,plurality,synthesizers,embassies,assad,contradictory,inference,discontent,recreated,inspectors,unicef,commuters,embryo,modifying,stints,numerals,communicated,boosted,trumpeter,brightly,adherence,remade,leases,restrained,eucalyptus,dwellers,planar,grooves,gainesville,daimler,anzac,szczecin,cornerback,prized,peking,mauritania,khalifa,motorized,lodging,instrumentalist,fortresses,cervical,formula_15,passerine,sectarian,researches,apprenticed,reliefs,disclose,gliding,repairing,queue,kyushu,literate,canoeing,sacrament,separatist,calabria,parkland,flowed,investigates,statistically,visionary,commits,dragoons,scrolls,premieres,revisited,subdued,censored,patterned,elective,outlawed,orphaned,leyland,richly,fujian,miniatures,heresy,plaques,countered,nonfiction,exponent,moravia,dispersion,marylebone,midwestern,enclave,ithaca,federated,electronically,handheld,microscopy,tolls,arrivals,climbers,continual,cossacks,moselle,deserts,ubiquitous,gables,forecasts,deforestation,vertebrates,flanking,drilled,superstructure,inspected,consultative,bypassed,ballast,subsidy,socioeconomic,relic,grenada,journalistic,administering,accommodated,collapses,appropriation,reclassified,foreword,porte,assimilated,observance,fragmented,arundel,thuringia,gonzaga,shenzhen,shipyards,sectional,ayrshire,sloping,dependencies,promenade,ecuadorian,mangrove,constructs,goalscorer,heroism,iteration,transistor,omnibus,hampstead,cochin,overshadowed,chieftain,scalar,finishers,ghanaian,abnormalities,monoplane,encyclopaedia,characterize,travancore,baronetage,bearers,biking,distributes,paving,christened,inspections,banco,humber,corinth,quadratic,albanians,lineages,majored,roadside,inaccessible,inclination,darmstadt,fianna,epilepsy,propellers,papacy,montagu,bhutto,sugarcane,optimized,pilasters,contend,batsmen,brabant,housemates,sligo,ascot,aquinas,supervisory,accorded,gerais,echoed,nunavut,conservatoire,carniola,quartermaster,gminas,impeachment,aquitaine,reformers,quarterfinal,karlsruhe,accelerator,coeducational,archduke,gelechiidae,seaplane,dissident,frenchman,palau,depots,hardcover,aachen,darreh,denominational,groningen,parcels,reluctance,drafts,elliptic,counters,decreed,airship,devotional,contradiction,formula_16,undergraduates,qualitative,guatemalan,slavs,southland,blackhawks,detrimental,abolish,chechen,manifestations,arthritis,perch,fated,hebei,peshawar,palin,immensely,havre,totalling,rampant,ferns,concourse,triples,elites,olympian,larva,herds,lipid,karabakh,distal,monotypic,vojvodina,batavia,multiplied,spacing,spellings,pedestrians,parchment,glossy,industrialization,dehydrogenase,patriotism,abolitionist,mentoring,elizabethan,figurative,dysfunction,abyss,constantin,middletown,stigma,mondays,gambia,gaius,israelites,renounced,nepalese,overcoming,buren,sulphur,divergence,predation,looting,iberia,futuristic,shelved,anthropological,innsbruck,escalated,clermont,entrepreneurial,benchmark,mechanically,detachments,populist,apocalyptic,exited,embryonic,stanza,readership,chiba,landlords,expansive,boniface,therapies,perpetrators,whitehall,kassel,masts,carriageway,clinch,pathogens,mazandaran,undesirable,teutonic,miocene,nagpur,juris,cantata,compile,diffuse,dynastic,reopening,comptroller,o'neal,flourish,electing,scientifically,departs,welded,modal,cosmology,fukushima,libertadores,chang'an,asean,generalization,localization,afrikaans,cricketers,accompanies,emigrants,esoteric,southwards,shutdown,prequel,fittings,innate,wrongly,equitable,dictionaries,senatorial,bipolar,flashbacks,semitism,walkway,lyrically,legality,sorbonne,vigorously,durga,samoan,karel,interchanges,patna,decider,registering,electrodes,anarchists,excursion,overthrown,gilan,recited,michelangelo,advertiser,kinship,taboo,cessation,formula_17,premiers,traversed,madurai,poorest,torneo,exerted,replicate,spelt,sporadically,horde,landscaping,razed,hindered,esperanto,manchuria,propellant,jalan,baha'is,sikkim,linguists,pandit,racially,ligands,dowry,francophone,escarpment,behest,magdeburg,mainstay,villiers,yangtze,grupo,conspirators,martyrdom,noticeably,lexical,kazakh,unrestricted,utilised,sired,inhabits,proofs,joseon,pliny,minted,buddhists,cultivate,interconnected,reuse,viability,australasian,derelict,resolving,overlooks,menon,stewardship,playwrights,thwarted,filmfare,disarmament,protections,bundles,sidelined,hypothesized,singer/songwriter,forage,netted,chancery,townshend,restructured,quotation,hyperbolic,succumbed,parliaments,shenandoah,apical,kibbutz,storeys,pastors,lettering,ukrainians,hardships,chihuahua,avail,aisles,taluka,antisemitism,assent,ventured,banksia,seamen,hospice,faroe,fearful,woreda,outfield,chlorine,transformer,tatar,panoramic,pendulum,haarlem,styria,cornice,importing,catalyzes,subunits,enamel,bakersfield,realignment,sorties,subordinates,deanery,townland,gunmen,tutelage,evaluations,allahabad,thrace,veneto,mennonite,sharia,subgenus,satisfies,puritan,unequal,gastrointestinal,ordinances,bacterium,horticulture,argonauts,adjectives,arable,duets,visualization,woolwich,revamped,euroleague,thorax,completes,originality,vasco,freighter,sardar,oratory,sects,extremes,signatories,exporting,arisen,exacerbated,departures,saipan,furlongs,d'italia,goring,dakar,conquests,docked,offshoot,okrug,referencing,disperse,netting,summed,rewritten,articulation,humanoid,spindle,competitiveness,preventive,facades,westinghouse,wycombe,synthase,emulate,fostering,abdel,hexagonal,myriad,caters,arjun,dismay,axiom,psychotherapy,colloquial,complemented,martinique,fractures,culmination,erstwhile,atrium,electronica,anarchism,nadal,montpellier,algebras,submitting,adopts,stemmed,overcame,internacional,asymmetric,gallipoli,gliders,flushing,extermination,hartlepool,tesla,interwar,patriarchal,hitherto,ganges,combatant,marred,philology,glastonbury,reversible,isthmus,undermined,southwark,gateshead,andalusia,remedies,hastily,optimum,smartphone,evade,patrolled,beheaded,dopamine,waivers,ugandan,gujarati,densities,predicting,intestinal,tentative,interstellar,kolonia,soloists,penetrated,rebellions,qeshlaq,prospered,colegio,deficits,konigsberg,deficient,accessing,relays,kurds,politburo,codified,incarnations,occupancy,cossack,metaphysical,deprivation,chopra,piccadilly,formula_18,makeshift,protestantism,alaskan,frontiers,faiths,tendon,dunkirk,durability,autobots,bonuses,coinciding,emails,gunboat,stucco,magma,neutrons,vizier,subscriptions,visuals,envisaged,carpets,smoky,schema,parliamentarian,immersed,domesticated,parishioners,flinders,diminutive,mahabharata,ballarat,falmouth,vacancies,gilded,twigs,mastering,clerics,dalmatia,islington,slogans,compressor,iconography,congolese,sanction,blends,bulgarians,moderator,outflow,textures,safeguard,trafalgar,tramways,skopje,colonialism,chimneys,jazeera,organisers,denoting,motivations,ganga,longstanding,deficiencies,gwynedd,palladium,holistic,fascia,preachers,embargo,sidings,busan,ignited,artificially,clearwater,cemented,northerly,salim,equivalents,crustaceans,oberliga,quadrangle,historiography,romanians,vaults,fiercely,incidental,peacetime,tonal,bhopal,oskar,radha,pesticides,timeslot,westerly,cathedrals,roadways,aldershot,connectors,brahmins,paler,aqueous,gustave,chromatic,linkage,lothian,specialises,aggregation,tributes,insurgent,enact,hampden,ghulam,federations,instigated,lyceum,fredrik,chairmanship,floated,consequent,antagonists,intimidation,patriarchate,warbler,heraldry,entrenched,expectancy,habitation,partitions,widest,launchers,nascent,ethos,wurzburg,lycee,chittagong,mahatma,merseyside,asteroids,yokosuka,cooperatives,quorum,redistricting,bureaucratic,yachts,deploying,rustic,phonology,chorale,cellist,stochastic,crucifixion,surmounted,confucian,portfolios,geothermal,crested,calibre,tropics,deferred,nasir,iqbal,persistence,essayist,chengdu,aborigines,fayetteville,bastion,interchangeable,burlesque,kilmarnock,specificity,tankers,colonels,fijian,quotations,enquiry,quito,palmerston,delle,multidisciplinary,polynesian,iodine,antennae,emphasised,manganese,baptists,galilee,jutland,latent,excursions,skepticism,tectonic,precursors,negligible,musique,misuse,vitoria,expressly,veneration,sulawesi,footed,mubarak,chongqing,chemically,midday,ravaged,facets,varma,yeovil,ethnographic,discounted,physicists,attache,disbanding,essen,shogunate,cooperated,waikato,realising,motherwell,pharmacology,sulfide,inward,expatriate,devoid,cultivar,monde,andean,groupings,goran,unaffected,moldovan,postdoctoral,coleophora,delegated,pronoun,conductivity,coleridge,disapproval,reappeared,microbial,campground,olsztyn,fostered,vaccination,rabbinical,champlain,milestones,viewership,caterpillar,effected,eupithecia,financier,inferred,uzbek,bundled,bandar,balochistan,mysticism,biosphere,holotype,symbolizes,lovecraft,photons,abkhazia,swaziland,subgroups,measurable,falkirk,valparaiso,ashok,discriminatory,rarity,tabernacle,flyweight,jalisco,westernmost,antiquarian,extracellular,margrave,colspan=9,midsummer,digestive,reversing,burgeoning,substitutes,medallist,khrushchev,guerre,folio,detonated,partido,plentiful,aggregator,medallion,infiltration,shaded,santander,fared,auctioned,permian,ramakrishna,andorra,mentors,diffraction,bukit,potentials,translucent,feminists,tiers,protracted,coburg,wreath,guelph,adventurer,he/she,vertebrate,pipelines,celsius,outbreaks,australasia,deccan,garibaldi,unionists,buildup,biochemical,reconstruct,boulders,stringent,barbed,wording,furnaces,pests,befriends,organises,popes,rizal,tentacles,cadre,tallahassee,punishments,occidental,formatted,mitigation,rulings,rubens,cascades,inducing,choctaw,volta,synagogues,movable,altarpiece,mitigate,practise,intermittently,encountering,memberships,earns,signify,retractable,amounting,pragmatic,wilfrid,dissenting,divergent,kanji,reconstituted,devonian,constitutions,levied,hendrik,starch,costal,honduran,ditches,polygon,eindhoven,superstars,salient,argus,punitive,purana,alluvial,flaps,inefficient,retracted,advantageous,quang,andersson,danville,binghamton,symbolize,conclave,shaanxi,silica,interpersonal,adept,frans,pavilions,lubbock,equip,sunken,limburg,activates,prosecutions,corinthian,venerated,shootings,retreats,parapet,orissa,riviere,animations,parodied,offline,metaphysics,bluffs,plume,piety,fruition,subsidized,steeplechase,shanxi,eurasia,angled,forecasting,suffragan,ashram,larval,labyrinth,chronicler,summaries,trailed,merges,thunderstorms,filtered,formula_19,advertisers,alpes,informatics,parti,constituting,undisputed,certifications,javascript,molten,sclerosis,rumoured,boulogne,hmong,lewes,breslau,notts,bantu,ducal,messengers,radars,nightclubs,bantamweight,carnatic,kaunas,fraternal,triggering,controversially,londonderry,visas,scarcity,offaly,uprisings,repelled,corinthians,pretext,kuomintang,kielce,empties,matriculated,pneumatic,expos,agile,treatises,midpoint,prehistory,oncology,subsets,hydra,hypertension,axioms,wabash,reiterated,swapped,achieves,premio,ageing,overture,curricula,challengers,subic,selangor,liners,frontline,shutter,validated,normalized,entertainers,molluscs,maharaj,allegation,youngstown,synth,thoroughfare,regionally,pillai,transcontinental,pedagogical,riemann,colonia,easternmost,tentatively,profiled,herefordshire,nativity,meuse,nucleotide,inhibits,huntingdon,throughput,recorders,conceding,domed,homeowners,centric,gabled,canoes,fringes,breeder,subtitled,fluoride,haplogroup,zionism,izmir,phylogeny,kharkiv,romanticism,adhesion,usaaf,delegations,lorestan,whalers,biathlon,vaulted,mathematically,pesos,skirmishes,heisman,kalamazoo,gesellschaft,launceston,interacts,quadruple,kowloon,psychoanalysis,toothed,ideologies,navigational,valence,induces,lesotho,frieze,rigging,undercarriage,explorations,spoof,eucharist,profitability,virtuoso,recitals,subterranean,sizeable,herodotus,subscriber,huxley,pivot,forewing,warring,boleslaw,bharatiya,suffixes,trois,percussionist,downturn,garrisons,philosophies,chants,mersin,mentored,dramatist,guilds,frameworks,thermodynamic,venomous,mehmed,assembling,rabbinic,hegemony,replicas,enlargement,claimant,retitled,utica,dumfries,metis,deter,assortment,tubing,afflicted,weavers,rupture,ornamentation,transept,salvaged,upkeep,callsign,rajput,stevenage,trimmed,intracellular,synchronization,consular,unfavorable,royalists,goldwyn,fasting,hussars,doppler,obscurity,currencies,amiens,acorn,tagore,townsville,gaussian,migrations,porta,anjou,graphite,seaport,monographs,gladiators,metrics,calligraphy,sculptural,swietokrzyskie,tolombeh,eredivisie,shoals,queries,carts,exempted,fiberglass,mirrored,bazar,progeny,formalized,mukherjee,professed,amazon.com,cathode,moreton,removable,mountaineers,nagano,transplantation,augustinian,steeply,epilogue,adapter,decisively,accelerating,mediaeval,substituting,tasman,devonshire,litres,enhancements,himmler,nephews,bypassing,imperfect,argentinian,reims,integrates,sochi,ascii,licences,niches,surgeries,fables,versatility,indra,footpath,afonso,crore,evaporation,encodes,shelling,conformity,simplify,updating,quotient,overt,firmware,umpires,architectures,eocene,conservatism,secretion,embroidery,f.c..,tuvalu,mosaics,shipwreck,prefectural,cohort,grievances,garnering,centerpiece,apoptosis,djibouti,bethesda,formula_20,shonen,richland,justinian,dormitories,meteorite,reliably,obtains,pedagogy,hardness,cupola,manifolds,amplification,steamers,familial,dumbarton,jerzy,genital,maidstone,salinity,grumman,signifies,presbytery,meteorology,procured,aegis,streamed,deletion,nuestra,mountaineering,accords,neuronal,khanate,grenoble,axles,dispatches,tokens,turku,auctions,propositions,planters,proclaiming,recommissioned,stravinsky,obverse,bombarded,waged,saviour,massacred,reformist,purportedly,resettlement,ravenna,embroiled,minden,revitalization,hikers,bridging,torpedoed,depletion,nizam,affectionately,latitudes,lubeck,spore,polymerase,aarhus,nazism,101st,buyout,galerie,diets,overflow,motivational,renown,brevet,deriving,melee,goddesses,demolish,amplified,tamworth,retake,brokerage,beneficiaries,henceforth,reorganised,silhouette,browsers,pollutants,peron,lichfield,encircled,defends,bulge,dubbing,flamenco,coimbatore,refinement,enshrined,grizzlies,capacitor,usefulness,evansville,interscholastic,rhodesian,bulletins,diamondbacks,rockers,platted,medalists,formosa,transporter,slabs,guadeloupe,disparate,concertos,violins,regaining,mandible,untitled,agnostic,issuance,hamiltonian,brampton,srpska,homology,downgraded,florentine,epitaph,kanye,rallying,analysed,grandstand,infinitely,antitrust,plundered,modernity,colspan=3|total,amphitheatre,doric,motorists,yemeni,carnivorous,probabilities,prelate,struts,scrapping,bydgoszcz,pancreatic,signings,predicts,compendium,ombudsman,apertura,appoints,rebbe,stereotypical,valladolid,clustered,touted,plywood,inertial,kettering,curving,d'honneur,housewives,grenadier,vandals,barbarossa,necked,waltham,reputedly,jharkhand,cistercian,pursues,viscosity,organiser,cloister,islet,stardom,moorish,himachal,strives,scripps,staggered,blasts,westwards,millimeters,angolan,hubei,agility,admirals,mordellistena,coincides,platte,vehicular,cordillera,riffs,schoolteacher,canaan,acoustics,tinged,reinforcing,concentrates,daleks,monza,selectively,musik,polynesia,exporter,reviving,macclesfield,bunkers,ballets,manors,caudal,microbiology,primes,unbroken,outcry,flocks,pakhtunkhwa,abelian,toowoomba,luminous,mould,appraisal,leuven,experimentally,interoperability,hideout,perak,specifying,knighthood,vasily,excerpt,computerized,niels,networked,byzantium,reaffirmed,geographer,obscured,fraternities,mixtures,allusion,accra,lengthened,inquest,panhandle,pigments,revolts,bluetooth,conjugate,overtaken,foray,coils,breech,streaks,impressionist,mendelssohn,intermediary,panned,suggestive,nevis,upazila,rotunda,mersey,linnaeus,anecdotes,gorbachev,viennese,exhaustive,moldavia,arcades,irrespective,orator,diminishing,predictive,cohesion,polarized,montage,avian,alienation,conus,jaffna,urbanization,seawater,extremity,editorials,scrolling,dreyfus,traverses,topographic,gunboats,extratropical,normans,correspondents,recognises,millennia,filtration,ammonium,voicing,complied,prefixes,diplomas,figurines,weakly,gated,oscillator,lucerne,embroidered,outpatient,airframe,fractional,disobedience,quarterbacks,formula_21,shinto,chiapas,epistle,leakage,pacifist,avignon,penrith,renders,mantua,screenplays,gustaf,tesco,alphabetically,rations,discharges,headland,tapestry,manipur,boolean,mediator,ebenezer,subchannel,fable,bestselling,ateneo,trademarks,recurrence,dwarfs,britannica,signifying,vikram,mediate,condensation,censuses,verbandsgemeinde,cartesian,sprang,surat,britons,chelmsford,courtenay,statistic,retina,abortions,liabilities,closures,mississauga,skyscrapers,saginaw,compounded,aristocrat,msnbc,stavanger,septa,interpretive,hinder,visibly,seeding,shutouts,irregularly,quebecois,footbridge,hydroxide,implicitly,lieutenants,simplex,persuades,midshipman,heterogeneous,officiated,crackdown,lends,tartu,altars,fractions,dissidents,tapered,modernisation,scripting,blazon,aquaculture,thermodynamics,sistan,hasidic,bellator,pavia,propagated,theorized,bedouin,transnational,mekong,chronicled,declarations,kickstarter,quotas,runtime,duquesne,broadened,clarendon,brownsville,saturation,tatars,electorates,malayan,replicated,observable,amphitheater,endorsements,referral,allentown,mormons,pantomime,eliminates,typeface,allegorical,varna,conduction,evoke,interviewer,subordinated,uyghur,landscaped,conventionally,ascend,edifice,postulated,hanja,whitewater,embarking,musicologist,tagalog,frontage,paratroopers,hydrocarbons,transliterated,nicolae,viewpoints,surrealist,asheville,falklands,hacienda,glide,opting,zimbabwean,discal,mortgages,nicaraguan,yadav,ghosh,abstracted,castilian,compositional,cartilage,intergovernmental,forfeited,importation,rapping,artes,republika,narayana,condominium,frisian,bradman,duality,marche,extremist,phosphorylation,genomes,allusions,valencian,habeas,ironworks,multiplex,harpsichord,emigrate,alternated,breda,waffen,smartphones,familiarity,regionalliga,herbaceous,piping,dilapidated,carboniferous,xviii,critiques,carcinoma,sagar,chippewa,postmodern,neapolitan,excludes,notoriously,distillation,tungsten,richness,installments,monoxide,chand,privatisation,molded,maths,projectiles,luoyang,epirus,lemma,concentric,incline,erroneous,sideline,gazetted,leopards,fibres,renovate,corrugated,unilateral,repatriation,orchestration,saeed,rockingham,loughborough,formula_22,bandleader,appellation,openness,nanotechnology,massively,tonnage,dunfermline,exposes,moored,ridership,motte,eurobasket,majoring,feats,silla,laterally,playlist,downwards,methodologies,eastbourne,daimyo,cellulose,leyton,norwalk,oblong,hibernian,opaque,insular,allegory,camogie,inactivation,favoring,masterpieces,rinpoche,serotonin,portrayals,waverley,airliner,longford,minimalist,outsourcing,excise,meyrick,qasim,organisational,synaptic,farmington,gorges,scunthorpe,zoned,tohoku,librarians,davao,decor,theatrically,brentwood,pomona,acquires,planter,capacitors,synchronous,skateboarding,coatings,turbocharged,ephraim,capitulation,scoreboard,hebrides,ensues,cereals,ailing,counterpoint,duplication,antisemitic,clique,aichi,oppressive,transcendental,incursions,rename,renumbering,powys,vestry,bitterly,neurology,supplanted,affine,susceptibility,orbiter,activating,overlaps,ecoregion,raman,canoer,darfur,microorganisms,precipitated,protruding,torun,anthropologists,rennes,kangaroos,parliamentarians,edits,littoral,archived,begum,rensselaer,microphones,ypres,empower,etruscan,wisden,montfort,calibration,isomorphic,rioting,kingship,verbally,smyrna,cohesive,canyons,fredericksburg,rahul,relativistic,micropolitan,maroons,industrialized,henchmen,uplift,earthworks,mahdi,disparity,cultured,transliteration,spiny,fragmentary,extinguished,atypical,inventors,biosynthesis,heralded,curacao,anomalies,aeroplane,surya,mangalore,maastricht,ashkenazi,fusiliers,hangzhou,emitting,monmouthshire,schwarzenegger,ramayana,peptides,thiruvananthapuram,alkali,coimbra,budding,reasoned,epithelial,harbors,rudimentary,classically,parque,ealing,crusades,rotations,riparian,pygmy,inertia,revolted,microprocessor,calendars,solvents,kriegsmarine,accademia,cheshmeh,yoruba,ardabil,mitra,genomic,notables,propagate,narrates,univision,outposts,polio,birkenhead,urinary,crocodiles,pectoral,barrymore,deadliest,rupees,chaim,protons,comical,astrophysics,unifying,formula_23,vassals,cortical,audubon,pedals,tenders,resorted,geophysical,lenders,recognising,tackling,lanarkshire,doctrinal,annan,combating,guangxi,estimating,selectors,tribunals,chambered,inhabiting,exemptions,curtailed,abbasid,kandahar,boron,bissau,150th,codenamed,wearer,whorl,adhered,subversive,famer,smelting,inserting,mogadishu,zoologist,mosul,stumps,almanac,olympiacos,stamens,participatory,cults,honeycomb,geologists,dividend,recursive,skiers,reprint,pandemic,liber,percentages,adversely,stoppage,chieftains,tubingen,southerly,overcrowding,unorganized,hangars,fulfil,hails,cantilever,woodbridge,pinus,wiesbaden,fertilization,fluorescence,enhances,plenary,troublesome,episodic,thrissur,kickboxing,allele,staffing,garda,televisions,philatelic,spacetime,bullpen,oxides,leninist,enrolling,inventive,truro,compatriot,ruskin,normative,assay,gotha,murad,illawarra,gendarmerie,strasse,mazraeh,rebounded,fanfare,liaoning,rembrandt,iranians,emirate,governs,latency,waterfowl,chairmen,katowice,aristocrats,eclipsed,sentient,sonatas,interplay,sacking,decepticons,dynamical,arbitrarily,resonant,petar,velocities,alludes,wastes,prefectures,belleville,sensibility,salvadoran,consolidating,medicaid,trainees,vivekananda,molar,porous,upload,youngster,infused,doctorates,wuhan,annihilation,enthusiastically,gamespot,kanpur,accumulating,monorail,operetta,tiling,sapporo,finns,calvinist,hydrocarbon,sparrows,orienteering,cornelis,minster,vuelta,plebiscite,embraces,panchayats,focussed,remediation,brahman,olfactory,reestablished,uniqueness,northumbria,rwandan,predominately,abode,ghats,balances,californian,uptake,bruges,inert,westerns,reprints,cairn,yarra,resurfaced,audible,rossini,regensburg,italiana,fleshy,irrigated,alerts,yahya,varanasi,marginalized,expatriates,cantonment,normandie,sahitya,directives,rounder,hulls,fictionalized,constables,inserts,hipped,potosi,navies,biologists,canteen,husbandry,augment,fortnight,assamese,kampala,o'keefe,paleolithic,bluish,promontory,consecutively,striving,niall,reuniting,dipole,friendlies,disapproved,thrived,netflix,liberian,dielectric,medway,strategist,sankt,pickups,hitters,encode,rerouted,claimants,anglesey,partitioned,cavan,flutes,reared,repainted,armaments,bowed,thoracic,balliol,piero,chaplains,dehestan,sender,junkers,sindhi,sickle,dividends,metallurgy,honorific,berths,namco,springboard,resettled,gansu,copyrighted,criticizes,utopian,bendigo,ovarian,binomial,spaceflight,oratorio,proprietors,supergroup,duplicated,foreground,strongholds,revolved,optimize,layouts,westland,hurler,anthropomorphic,excelsior,merchandising,reeds,vetoed,cryptography,hollyoaks,monash,flooring,ionian,resilience,johnstown,resolves,lawmakers,alegre,wildcards,intolerance,subculture,selector,slums,formulate,bayonet,istvan,restitution,interchangeably,awakens,rostock,serpentine,oscillation,reichstag,phenotype,recessed,piotr,annotated,preparedness,consultations,clausura,preferential,euthanasia,genoese,outcrops,freemasonry,geometrical,genesee,islets,prometheus,panamanian,thunderbolt,terraced,stara,shipwrecks,futebol,faroese,sharqi,aldermen,zeitung,unify,formula_24,humanism,syntactic,earthen,blyth,taxed,rescinded,suleiman,cymru,dwindled,vitality,superieure,resupply,adolphe,ardennes,rajiv,profiling,olympique,gestation,interfaith,milosevic,tagline,funerary,druze,silvery,plough,shrubland,relaunch,disband,nunatak,minimizing,excessively,waned,attaching,luminosity,bugle,encampment,electrostatic,minesweeper,dubrovnik,rufous,greenock,hochschule,assyrians,extracting,malnutrition,priya,attainment,anhui,connotations,predicate,seabirds,deduced,pseudonyms,gopal,plovdiv,refineries,imitated,kwazulu,terracotta,tenets,discourses,brandeis,whigs,dominions,pulmonate,landslides,tutors,determinant,richelieu,farmstead,tubercles,technicolor,hegel,redundancy,greenpeace,shortening,mules,distilled,xxiii,fundamentalist,acrylic,outbuildings,lighted,corals,signaled,transistors,cavite,austerity,76ers,exposures,dionysius,outlining,commutative,permissible,knowledgeable,howrah,assemblage,inhibited,crewmen,mbit/s,pyramidal,aberdeenshire,bering,rotates,atheism,howitzer,saone,lancet,fermented,contradicted,materiel,ofsted,numeric,uniformity,josephus,nazarene,kuwaiti,noblemen,pediment,emergent,campaigner,akademi,murcia,perugia,gallen,allsvenskan,finned,cavities,matriculation,rosters,twickenham,signatory,propel,readable,contends,artisan,flamboyant,reggio,italo,fumbles,widescreen,rectangle,centimetres,collaborates,envoys,rijeka,phonological,thinly,refractive,civilisation,reductase,cognate,dalhousie,monticello,lighthouses,jitsu,luneburg,socialite,fermi,collectible,optioned,marquee,jokingly,architecturally,kabir,concubine,nationalisation,watercolor,wicklow,acharya,pooja,leibniz,rajendra,nationalized,stalemate,bloggers,glutamate,uplands,shivaji,carolingian,bucuresti,dasht,reappears,muscat,functionally,formulations,hinged,hainan,catechism,autosomal,incremental,asahi,coeur,diversification,multilateral,fewest,recombination,finisher,harrogate,hangul,feasts,photovoltaic,paget,liquidity,alluded,incubation,applauded,choruses,malagasy,hispanics,bequest,underparts,cassava,kazimierz,gastric,eradication,mowtowr,tyrosine,archbishopric,e9e9e9,unproductive,uxbridge,hydrolysis,harbours,officio,deterministic,devonport,kanagawa,breaches,freetown,rhinoceros,chandigarh,janos,sanatorium,liberator,inequalities,agonist,hydrophobic,constructors,nagorno,snowboarding,welcomes,subscribed,iloilo,resuming,catalysts,stallions,jawaharlal,harriers,definitively,roughriders,hertford,inhibiting,elgar,randomized,incumbents,episcopate,rainforests,yangon,improperly,kemal,interpreters,diverged,uttarakhand,umayyad,phnom,panathinaikos,shabbat,diode,jiangxi,forbidding,nozzle,artistry,licensee,processions,staffs,decimated,expressionism,shingle,palsy,ontology,mahayana,maribor,sunil,hostels,edwardian,jetty,freehold,overthrew,eukaryotic,schuylkill,rawalpindi,sheath,recessive,ferenc,mandibles,berlusconi,confessor,convergent,ababa,slugging,rentals,sephardic,equivalently,collagen,markov,dynamically,hailing,depressions,sprawling,fairgrounds,indistinguishable,plutarch,pressurized,banff,coldest,braunschweig,mackintosh,sociedad,wittgenstein,tromso,airbase,lecturers,subtitle,attaches,purified,contemplated,dreamworks,telephony,prophetic,rockland,aylesbury,biscay,coherence,aleksandar,judoka,pageants,theses,homelessness,luthor,sitcoms,hinterland,fifths,derwent,privateers,enigmatic,nationalistic,instructs,superimposed,conformation,tricycle,dusan,attributable,unbeknownst,laptops,etching,archbishops,ayatollah,cranial,gharbi,interprets,lackawanna,abingdon,saltwater,tories,lender,minaj,ancillary,ranching,pembrokeshire,topographical,plagiarism,murong,marque,chameleon,assertions,infiltrated,guildhall,reverence,schenectady,formula_25,kollam,notary,mexicana,initiates,abdication,basra,theorems,ionization,dismantling,eared,censors,budgetary,numeral,verlag,excommunicated,distinguishable,quarried,cagliari,hindustan,symbolizing,watertown,descartes,relayed,enclosures,militarily,sault,devolved,dalian,djokovic,filaments,staunton,tumour,curia,villainous,decentralized,galapagos,moncton,quartets,onscreen,necropolis,brasileiro,multipurpose,alamos,comarca,jorgen,concise,mercia,saitama,billiards,entomologist,montserrat,lindbergh,commuting,lethbridge,phoenician,deviations,anaerobic,denouncing,redoubt,fachhochschule,principalities,negros,announcers,seconded,parrots,konami,revivals,approving,devotee,riyadh,overtook,morecambe,lichen,expressionist,waterline,silverstone,geffen,sternites,aspiration,behavioural,grenville,tripura,mediums,genders,pyotr,charlottesville,sacraments,programmable,ps100,shackleton,garonne,sumerian,surpass,authorizing,interlocking,lagoons,voiceless,advert,steeple,boycotted,alouettes,yosef,oxidative,sassanid,benefiting,sayyid,nauru,predetermined,idealism,maxillary,polymerization,semesters,munchen,conor,outfitted,clapham,progenitor,gheorghe,observational,recognitions,numerically,colonized,hazrat,indore,contaminants,fatality,eradicate,assyria,convocation,cameos,skillful,skoda,corfu,confucius,overtly,ramadan,wollongong,placements,d.c..,permutation,contemporaneous,voltages,elegans,universitat,samar,plunder,dwindling,neuter,antonin,sinhala,campania,solidified,stanzas,fibrous,marburg,modernize,sorcery,deutscher,florets,thakur,disruptive,infielder,disintegration,internazionale,vicariate,effigy,tripartite,corrective,klamath,environs,leavenworth,sandhurst,workmen,compagnie,hoseynabad,strabo,palisades,ordovician,sigurd,grandsons,defection,viacom,sinhalese,innovator,uncontrolled,slavonic,indexes,refrigeration,aircrew,superbike,resumption,neustadt,confrontations,arras,hindenburg,ripon,embedding,isomorphism,dwarves,matchup,unison,lofty,argos,louth,constitutionally,transitive,newington,facelift,degeneration,perceptual,aviators,enclosing,igneous,symbolically,academician,constitutionality,iso/iec,sacrificial,maturation,apprentices,enzymology,naturalistic,hajji,arthropods,abbess,vistula,scuttled,gradients,pentathlon,etudes,freedmen,melaleuca,thrice,conductive,sackville,franciscans,stricter,golds,kites,worshiped,monsignor,trios,orally,tiered,primacy,bodywork,castleford,epidemics,alveolar,chapelle,chemists,hillsboro,soulful,warlords,ngati,huguenot,diurnal,remarking,luger,motorways,gauss,jahan,cutoff,proximal,bandai,catchphrase,jonubi,ossetia,codename,codice_2,throated,itinerant,chechnya,riverfront,leela,evoked,entailed,zamboanga,rejoining,circuitry,haymarket,khartoum,feuds,braced,miyazaki,mirren,lubusz,caricature,buttresses,attrition,characterizes,widnes,evanston,materialism,contradictions,marist,midrash,gainsborough,ulithi,turkmen,vidya,escuela,patrician,inspirations,reagent,premierships,humanistic,euphrates,transitioning,belfry,zedong,adaption,kaliningrad,lobos,epics,waiver,coniferous,polydor,inductee,refitted,moraine,unsatisfactory,worsening,polygamy,rajya,nested,subgenre,broadside,stampeders,lingua,incheon,pretender,peloton,persuading,excitation,multan,predates,tonne,brackish,autoimmune,insulated,podcasts,iraqis,bodybuilding,condominiums,midlothian,delft,debtor,asymmetrical,lycaenidae,forcefully,pathogenic,tamaulipas,andaman,intravenous,advancements,senegalese,chronologically,realigned,inquirer,eusebius,dekalb,additives,shortlist,goldwater,hindustani,auditing,caterpillars,pesticide,nakhon,ingestion,lansdowne,traditionalist,northland,thunderbirds,josip,nominating,locale,ventricular,animators,verandah,epistles,surveyors,anthems,dredd,upheaval,passaic,anatolian,svalbard,associative,floodplain,taranaki,estuaries,irreducible,beginners,hammerstein,allocate,coursework,secreted,counteract,handwritten,foundational,passover,discoverer,decoding,wares,bourgeoisie,playgrounds,nazionale,abbreviations,seanad,golan,mishra,godavari,rebranding,attendances,backstory,interrupts,lettered,hasbro,ultralight,hormozgan,armee,moderne,subdue,disuse,improvisational,enrolment,persists,moderated,carinthia,hatchback,inhibitory,capitalized,anatoly,abstracts,albemarle,bergamo,insolvency,sentai,cellars,walloon,joked,kashmiri,dirac,materialized,renomination,homologous,gusts,eighteens,centrifugal,storied,baluchestan,formula_26,poincare,vettel,infuriated,gauges,streetcars,vedanta,stately,liquidated,goguryeo,swifts,accountancy,levee,acadian,hydropower,eustace,comintern,allotment,designating,torsion,molding,irritation,aerobic,halen,concerted,plantings,garrisoned,gramophone,cytoplasm,onslaught,requisitioned,relieving,genitive,centrist,jeong,espanola,dissolving,chatterjee,sparking,connaught,varese,arjuna,carpathian,empowering,meteorologist,decathlon,opioid,hohenzollern,fenced,ibiza,avionics,footscray,scrum,discounts,filament,directories,a.f.c,stiffness,quaternary,adventurers,transmits,harmonious,taizong,radiating,germantown,ejection,projectors,gaseous,nahuatl,vidyalaya,nightlife,redefined,refuted,destitute,arista,potters,disseminated,distanced,jamboree,kaohsiung,tilted,lakeshore,grained,inflicting,kreis,novelists,descendents,mezzanine,recast,fatah,deregulation,ac/dc,australis,kohgiluyeh,boreal,goths,authoring,intoxicated,nonpartisan,theodosius,pyongyang,shree,boyhood,sanfl,plenipotentiary,photosynthesis,presidium,sinaloa,honshu,texan,avenida,transmembrane,malays,acropolis,catalunya,vases,inconsistencies,methodists,quell,suisse,banat,simcoe,cercle,zealanders,discredited,equine,sages,parthian,fascists,interpolation,classifying,spinoff,yehuda,cruised,gypsum,foaled,wallachia,saraswati,imperialist,seabed,footnotes,nakajima,locales,schoolmaster,drosophila,bridgehead,immanuel,courtier,bookseller,niccolo,stylistically,portmanteau,superleague,konkani,millimetres,arboreal,thanjavur,emulation,sounders,decompression,commoners,infusion,methodological,osage,rococo,anchoring,bayreuth,formula_27,abstracting,symbolized,bayonne,electrolyte,rowed,corvettes,traversing,editorship,sampler,presidio,curzon,adirondack,swahili,rearing,bladed,lemur,pashtun,behaviours,bottling,zaire,recognisable,systematics,leeward,formulae,subdistricts,smithfield,vijaya,buoyancy,boosting,cantonal,rishi,airflow,kamakura,adana,emblems,aquifer,clustering,husayn,woolly,wineries,montessori,turntable,exponentially,caverns,espoused,pianists,vorpommern,vicenza,latterly,o'rourke,williamstown,generale,kosice,duisburg,poirot,marshy,mismanagement,mandalay,dagenham,universes,chiral,radiated,stewards,vegan,crankshaft,kyrgyz,amphibian,cymbals,infrequently,offenbach,environmentalist,repatriated,permutations,midshipmen,loudoun,refereed,bamberg,ornamented,nitric,selim,translational,dorsum,annunciation,gippsland,reflector,informational,regia,reactionary,ahmet,weathering,erlewine,legalized,berne,occupant,divas,manifests,analyzes,disproportionate,mitochondria,totalitarian,paulista,interscope,anarcho,correlate,brookfield,elongate,brunel,ordinal,precincts,volatility,equaliser,hittite,somaliland,ticketing,monochrome,ubuntu,chhattisgarh,titleholder,ranches,referendums,blooms,accommodates,merthyr,religiously,ryukyu,tumultuous,checkpoints,anode,mi'kmaq,cannonball,punctuation,remodelled,assassinations,criminology,alternates,yonge,pixar,namibian,piraeus,trondelag,hautes,lifeboats,shoal,atelier,vehemently,sadat,postcode,jainism,lycoming,undisturbed,lutherans,genomics,popmatters,tabriz,isthmian,notched,autistic,horsham,mites,conseil,bloomsbury,seung,cybertron,idris,overhauled,disbandment,idealized,goldfields,worshippers,lobbyist,ailments,paganism,herbarium,athenians,messerschmitt,faraday,entangled,'olya,untreated,criticising,howitzers,parvati,lobed,debussy,atonement,tadeusz,permeability,mueang,sepals,degli,optionally,fuelled,follies,asterisk,pristina,lewiston,congested,overpass,affixed,pleads,telecasts,stanislaus,cryptographic,friesland,hamstring,selkirk,antisubmarine,inundated,overlay,aggregates,fleur,trolleybus,sagan,ibsen,inductees,beltway,tiled,ladders,cadbury,laplace,ascetic,micronesia,conveying,bellingham,cleft,batches,usaid,conjugation,macedon,assisi,reappointed,brine,jinnah,prairies,screenwriting,oxidized,despatches,linearly,fertilizers,brazilians,absorbs,wagga,modernised,scorsese,ashraf,charlestown,esque,habitable,nizhny,lettres,tuscaloosa,esplanade,coalitions,carbohydrates,legate,vermilion,standardised,galleria,psychoanalytic,rearrangement,substation,competency,nationalised,reshuffle,reconstructions,mehdi,bougainville,receivership,contraception,enlistment,conducive,aberystwyth,solicitors,dismisses,fibrosis,montclair,homeowner,surrealism,s.h.i.e.l.d,peregrine,compilers,1790s,parentage,palmas,rzeszow,worldview,eased,svenska,housemate,bundestag,originator,enlisting,outwards,reciprocity,formula_28,carbohydrate,democratically,firefighting,romagna,acknowledgement,khomeini,carbide,quests,vedas,characteristically,guwahati,brixton,unintended,brothels,parietal,namur,sherbrooke,moldavian,baruch,milieu,undulating,laurier,entre,dijon,ethylene,abilene,heracles,paralleling,ceres,dundalk,falun,auspicious,chisinau,polarity,foreclosure,templates,ojibwe,punic,eriksson,biden,bachchan,glaciation,spitfires,norsk,nonviolent,heidegger,algonquin,capacitance,cassettes,balconies,alleles,airdate,conveys,replays,classifies,infrequent,amine,cuttings,rarer,woking,olomouc,amritsar,rockabilly,illyrian,maoist,poignant,tempore,stalinist,segmented,bandmate,mollusc,muhammed,totalled,byrds,tendered,endogenous,kottayam,aisne,oxidase,overhears,illustrators,verve,commercialization,purplish,directv,moulded,lyttelton,baptismal,captors,saracens,georgios,shorten,polity,grids,fitzwilliam,sculls,impurities,confederations,akhtar,intangible,oscillations,parabolic,harlequin,maulana,ovate,tanzanian,singularity,confiscation,qazvin,speyer,phonemes,overgrown,vicarage,gurion,undocumented,niigata,thrones,preamble,stave,interment,liiga,ataturk,aphrodite,groupe,indentured,habsburgs,caption,utilitarian,ozark,slovenes,reproductions,plasticity,serbo,dulwich,castel,barbuda,salons,feuding,lenape,wikileaks,swamy,breuning,shedding,afield,superficially,operationally,lamented,okanagan,hamadan,accolade,furthering,adolphus,fyodor,abridged,cartoonists,pinkish,suharto,cytochrome,methylation,debit,colspan=9|,refine,taoist,signalled,herding,leaved,bayan,fatherland,rampart,sequenced,negation,storyteller,occupiers,barnabas,pelicans,nadir,conscripted,railcars,prerequisite,furthered,columba,carolinas,markup,gwalior,franche,chaco,eglinton,ramparts,rangoon,metabolites,pollination,croat,televisa,holyoke,testimonial,setlist,safavid,sendai,georgians,shakespearean,galleys,regenerative,krzysztof,overtones,estado,barbary,cherbourg,obispo,sayings,composites,sainsbury,deliberation,cosmological,mahalleh,embellished,ascap,biala,pancras,calumet,grands,canvases,antigens,marianas,defenseman,approximated,seedlings,soren,stele,nuncio,immunology,testimonies,glossary,recollections,suitability,tampere,venous,cohomology,methanol,echoing,ivanovich,warmly,sterilization,imran,multiplying,whitechapel,undersea,xuanzong,tacitus,bayesian,roundhouse,correlations,rioters,molds,fiorentina,bandmates,mezzo,thani,guerilla,200th,premiums,tamils,deepwater,chimpanzees,tribesmen,selwyn,globo,turnovers,punctuated,erode,nouvelle,banbury,exponents,abolishing,helical,maimonides,endothelial,goteborg,infield,encroachment,cottonwood,mazowiecki,parable,saarbrucken,reliever,epistemology,artistes,enrich,rationing,formula_29,palmyra,subfamilies,kauai,zoran,fieldwork,arousal,creditor,friuli,celts,comoros,equated,escalation,negev,tallied,inductive,anion,netanyahu,mesoamerican,lepidoptera,aspirated,remit,westmorland,italic,crosse,vaclav,fuego,owain,balmain,venetians,ethnicities,deflected,ticino,apulia,austere,flycatcher,reprising,repressive,hauptbahnhof,subtype,ophthalmology,summarizes,eniwetok,colonisation,subspace,nymphalidae,earmarked,tempe,burnet,crests,abbots,norwegians,enlarge,ashoka,frankfort,livorno,malware,renters,singly,iliad,moresby,rookies,gustavus,affirming,alleges,legume,chekhov,studded,abdicated,suzhou,isidore,townsite,repayment,quintus,yankovic,amorphous,constructor,narrowing,industrialists,tanganyika,capitalization,connective,mughals,rarities,aerodynamics,worthing,antalya,diagnostics,shaftesbury,thracian,obstetrics,benghazi,multiplier,orbitals,livonia,roscommon,intensify,ravel,oaths,overseer,locomotion,necessities,chickasaw,strathclyde,treviso,erfurt,aortic,contemplation,accrington,markazi,predeceased,hippocampus,whitecaps,assemblyman,incursion,ethnography,extraliga,reproducing,directorship,benzene,byway,stupa,taxable,scottsdale,onondaga,favourably,countermeasures,lithuanians,thatched,deflection,tarsus,consuls,annuity,paralleled,contextual,anglian,klang,hoisted,multilingual,enacting,samaj,taoiseach,carthaginian,apologised,hydrology,entrant,seamless,inflorescences,mugabe,westerners,seminaries,wintering,penzance,mitre,sergeants,unoccupied,delimitation,discriminate,upriver,abortive,nihon,bessarabia,calcareous,buffaloes,patil,daegu,streamline,berks,chaparral,laity,conceptions,typified,kiribati,threaded,mattel,eccentricity,signified,patagonia,slavonia,certifying,adnan,astley,sedition,minimally,enumerated,nikos,goalless,walid,narendra,causa,missoula,coolant,dalek,outcrop,hybridization,schoolchildren,peasantry,afghans,confucianism,shahr,gallic,tajik,kierkegaard,sauvignon,commissar,patriarchs,tuskegee,prussians,laois,ricans,talmudic,officiating,aesthetically,baloch,antiochus,separatists,suzerainty,arafat,shading,u.s.c,chancellors,inc..,toolkit,nepenthes,erebidae,solicited,pratap,kabbalah,alchemist,caltech,darjeeling,biopic,spillway,kaiserslautern,nijmegen,bolstered,neath,pahlavi,eugenics,bureaus,retook,northfield,instantaneous,deerfield,humankind,selectivity,putative,boarders,cornhuskers,marathas,raikkonen,aliabad,mangroves,garages,gulch,karzai,poitiers,chernobyl,thane,alexios,belgrano,scion,solubility,urbanized,executable,guizhou,nucleic,tripled,equalled,harare,houseguests,potency,ghazi,repeater,overarching,regrouped,broward,ragtime,d'art,nandi,regalia,campsites,mamluk,plating,wirral,presumption,zenit,archivist,emmerdale,decepticon,carabidae,kagoshima,franconia,guarani,formalism,diagonally,submarginal,denys,walkways,punts,metrolink,hydrographic,droplets,upperside,martyred,hummingbird,antebellum,curiously,mufti,friary,chabad,czechs,shaykh,reactivity,berklee,turbonilla,tongan,sultans,woodville,unlicensed,enmity,dominicans,operculum,quarrying,watercolour,catalyzed,gatwick,'what,mesozoic,auditors,shizuoka,footballing,haldane,telemundo,appended,deducted,disseminate,o'shea,pskov,abrasive,entente,gauteng,calicut,lemurs,elasticity,suffused,scopula,staining,upholding,excesses,shostakovich,loanwords,naidu,championnat,chromatography,boasting,goaltenders,engulfed,salah,kilogram,morristown,shingles,shi'a,labourer,renditions,frantisek,jekyll,zonal,nanda,sheriffs,eigenvalues,divisione,endorsing,ushered,auvergne,cadres,repentance,freemasons,utilising,laureates,diocletian,semiconductors,o'grady,vladivostok,sarkozy,trackage,masculinity,hydroxyl,mervyn,muskets,speculations,gridiron,opportunistic,mascots,aleutian,fillies,sewerage,excommunication,borrowers,capillary,trending,sydenham,synthpop,rajah,cagayan,deportes,kedah,faure,extremism,michoacan,levski,culminates,occitan,bioinformatics,unknowingly,inciting,emulated,footpaths,piacenza,dreadnought,viceroyalty,oceanographic,scouted,combinatorial,ornithologist,cannibalism,mujahideen,independiente,cilicia,hindwing,minimized,odeon,gyorgy,rubles,purchaser,collieries,kickers,interurban,coiled,lynchburg,respondent,plzen,detractors,etchings,centering,intensification,tomography,ranjit,warblers,retelling,reinstatement,cauchy,modulus,redirected,evaluates,beginner,kalateh,perforated,manoeuvre,scrimmage,internships,megawatts,mottled,haakon,tunbridge,kalyan,summarised,sukarno,quetta,canonized,henryk,agglomeration,coahuila,diluted,chiropractic,yogyakarta,talladega,sheik,cation,halting,reprisals,sulfuric,musharraf,sympathizers,publicised,arles,lectionary,fracturing,startups,sangha,latrobe,rideau,ligaments,blockading,cremona,lichens,fabaceae,modulated,evocative,embodies,battersea,indistinct,altai,subsystem,acidity,somatic,formula_30,tariq,rationality,sortie,ashlar,pokal,cytoplasmic,valour,bangla,displacing,hijacking,spectrometry,westmeath,weill,charing,goias,revolvers,individualized,tenured,nawaz,piquet,chanted,discard,bernd,phalanx,reworking,unilaterally,subclass,yitzhak,piloting,circumvent,disregarded,semicircular,viscous,tibetans,endeavours,retaliated,cretan,vienne,workhouse,sufficiency,aurangzeb,legalization,lipids,expanse,eintracht,sanjak,megas,125th,bahraini,yakima,eukaryotes,thwart,affirmation,peloponnese,retailing,carbonyl,chairwoman,macedonians,dentate,rockaway,correctness,wealthier,metamorphic,aragonese,fermanagh,pituitary,schrodinger,evokes,spoiler,chariots,akita,genitalia,combe,confectionery,desegregation,experiential,commodores,persepolis,viejo,restorations,virtualization,hispania,printmaking,stipend,yisrael,theravada,expended,radium,tweeted,polygonal,lippe,charente,leveraged,cutaneous,fallacy,fragrant,bypasses,elaborately,rigidity,majid,majorca,kongo,plasmodium,skits,audiovisual,eerste,staircases,prompts,coulthard,northwestward,riverdale,beatrix,copyrights,prudential,communicates,mated,obscenity,asynchronous,analyse,hansa,searchlight,farnborough,patras,asquith,qarah,contours,fumbled,pasteur,redistributed,almeria,sanctuaries,jewry,israelite,clinicians,koblenz,bookshop,affective,goulburn,panelist,sikorsky,cobham,mimics,ringed,portraiture,probabilistic,girolamo,intelligible,andalusian,jalal,athenaeum,eritrean,auxiliaries,pittsburg,devolution,sangam,isolating,anglers,cronulla,annihilated,kidderminster,synthesize,popularised,theophilus,bandstand,innumerable,chagrin,retroactively,weser,multiples,birdlife,goryeo,pawnee,grosser,grappling,tactile,ahmadinejad,turboprop,erdogan,matchday,proletarian,adhering,complements,austronesian,adverts,luminaries,archeology,impressionism,conifer,sodomy,interracial,platoons,lessen,postings,pejorative,registrations,cookery,persecutions,microbes,audits,idiosyncratic,subsp,suspensions,restricts,colouring,ratify,instrumentals,nucleotides,sulla,posits,bibliotheque,diameters,oceanography,instigation,subsumed,submachine,acceptor,legation,borrows,sedge,discriminated,loaves,insurers,highgate,detectable,abandons,kilns,sportscaster,harwich,iterations,preakness,arduous,tensile,prabhu,shortwave,philologist,shareholding,vegetative,complexities,councilors,distinctively,revitalize,automaton,amassing,montreux,khanh,surabaya,nurnberg,pernambuco,cuisines,charterhouse,firsts,tercera,inhabitant,homophobia,naturalism,einar,powerplant,coruna,entertainments,whedon,rajputs,raton,democracies,arunachal,oeuvre,wallonia,jeddah,trolleybuses,evangelism,vosges,kiowa,minimise,encirclement,undertakes,emigrant,beacons,deepened,grammars,publius,preeminent,seyyed,repechage,crafting,headingley,osteopathic,lithography,hotly,bligh,inshore,betrothed,olympians,formula_31,dissociation,trivandrum,arran,petrovic,stettin,disembarked,simplification,bronzes,philo,acrobatic,jonsson,conjectured,supercharged,kanto,detects,cheeses,correlates,harmonics,lifecycle,sudamericana,reservists,decayed,elitserien,parametric,113th,dusky,hogarth,modulo,symbiotic,monopolies,discontinuation,converges,southerners,tucuman,eclipses,enclaves,emits,famicom,caricatures,artistically,levelled,mussels,erecting,mouthparts,cunard,octaves,crucible,guardia,unusable,lagrangian,droughts,ephemeral,pashto,canis,tapering,sasebo,silurian,metallurgical,outscored,evolves,reissues,sedentary,homotopy,greyhawk,reagents,inheriting,onshore,tilting,rebuffed,reusable,naturalists,basingstoke,insofar,offensives,dravidian,curators,planks,rajan,isoforms,flagstaff,preside,globular,egalitarian,linkages,biographers,goalscorers,molybdenum,centralised,nordland,jurists,ellesmere,rosberg,hideyoshi,restructure,biases,borrower,scathing,redress,tunnelling,workflow,magnates,mahendra,dissenters,plethora,transcriptions,handicrafts,keyword,xi'an,petrograd,unser,prokofiev,90deg,madan,bataan,maronite,kearny,carmarthen,termini,consulates,disallowed,rockville,bowery,fanzine,docklands,bests,prohibitions,yeltsin,selassie,naturalization,realisation,dispensary,tribeca,abdulaziz,pocahontas,stagnation,pamplona,cuneiform,propagating,subsurface,christgau,epithelium,schwerin,lynching,routledge,hanseatic,upanishad,glebe,yugoslavian,complicity,endowments,girona,mynetworktv,entomology,plinth,ba'ath,supercup,torus,akkadian,salted,englewood,commandery,belgaum,prefixed,colorless,dartford,enthroned,caesarea,nominative,sandown,safeguards,hulled,formula_32,leamington,dieppe,spearhead,generalizations,demarcation,llanelli,masque,brickwork,recounting,sufism,strikingly,petrochemical,onslow,monologues,emigrating,anderlecht,sturt,hossein,sakhalin,subduction,novices,deptford,zanjan,airstrikes,coalfield,reintroduction,timbaland,hornby,messianic,stinging,universalist,situational,radiocarbon,strongman,rowling,saloons,traffickers,overran,fribourg,cambrai,gravesend,discretionary,finitely,archetype,assessor,pilipinas,exhumed,invocation,interacted,digitized,timisoara,smelter,teton,sexism,precepts,srinagar,pilsudski,carmelite,hanau,scoreline,hernando,trekking,blogging,fanbase,wielded,vesicles,nationalization,banja,rafts,motoring,luang,takeda,girder,stimulates,histone,sunda,nanoparticles,attains,jumpers,catalogued,alluding,pontus,ancients,examiners,shinkansen,ribbentrop,reimbursement,pharmacological,ramat,stringed,imposes,cheaply,transplanted,taiping,mizoram,looms,wallabies,sideman,kootenay,encased,sportsnet,revolutionized,tangier,benthic,runic,pakistanis,heatseekers,shyam,mishnah,presbyterians,stadt,sutras,straddles,zoroastrian,infer,fueling,gymnasts,ofcom,gunfight,journeyman,tracklist,oshawa,ps500,pa'in,mackinac,xiongnu,mississippian,breckinridge,freemason,bight,autoroute,liberalization,distantly,thrillers,solomons,presumptive,romanization,anecdotal,bohemians,unpaved,milder,concurred,spinners,alphabets,strenuous,rivieres,kerrang,mistreatment,dismounted,intensively,carlist,dancehall,shunting,pluralism,trafficked,brokered,bonaventure,bromide,neckar,designates,malian,reverses,sotheby,sorghum,serine,environmentalists,languedoc,consulship,metering,bankstown,handlers,militiamen,conforming,regularity,pondicherry,armin,capsized,consejo,capitalists,drogheda,granular,purged,acadians,endocrine,intramural,elicit,terns,orientations,miklos,omitting,apocryphal,slapstick,brecon,pliocene,affords,typography,emigre,tsarist,tomasz,beset,nishi,necessitating,encyclical,roleplaying,journeyed,inflow,sprints,progressives,novosibirsk,cameroonian,ephesus,speckled,kinshasa,freiherr,burnaby,dalmatian,torrential,rigor,renegades,bhakti,nurburgring,cosimo,convincingly,reverting,visayas,lewisham,charlottetown,charadriiformesfamily,transferable,jodhpur,converters,deepening,camshaft,underdeveloped,protease,polonia,uterine,quantify,tobruk,dealerships,narasimha,fortran,inactivity,1780s,victors,categorised,naxos,workstation,skink,sardinian,chalice,precede,dammed,sondheim,phineas,tutored,sourcing,uncompromising,placer,tyneside,courtiers,proclaims,pharmacies,hyogo,booksellers,sengoku,kursk,spectrometer,countywide,wielkopolski,bobsleigh,shetty,llywelyn,consistory,heretics,guinean,cliches,individualism,monolithic,imams,usability,bursa,deliberations,railings,torchwood,inconsistency,balearic,stabilizer,demonstrator,facet,radioactivity,outboard,educates,d'oyly,heretical,handover,jurisdictional,shockwave,hispaniola,conceptually,routers,unaffiliated,trentino,formula_33,cypriots,intervenes,neuchatel,formulating,maggiore,delisted,alcohols,thessaly,potable,estimator,suborder,fluency,mimicry,clergymen,infrastructures,rivals.com,baroda,subplot,majlis,plano,clinching,connotation,carinae,savile,intercultural,transcriptional,sandstones,ailerons,annotations,impresario,heinkel,scriptural,intermodal,astrological,ribbed,northeastward,posited,boers,utilise,kalmar,phylum,breakwater,skype,textured,guideline,azeri,rimini,massed,subsidence,anomalous,wolfsburg,polyphonic,accrediting,vodacom,kirov,captaining,kelantan,logie,fervent,eamon,taper,bundeswehr,disproportionately,divination,slobodan,pundits,hispano,kinetics,reunites,makati,ceasing,statistician,amending,chiltern,eparchy,riverine,melanoma,narragansett,pagans,raged,toppled,breaching,zadar,holby,dacian,ochre,velodrome,disparities,amphoe,sedans,webpage,williamsport,lachlan,groton,baring,swastika,heliport,unwillingness,razorbacks,exhibitors,foodstuffs,impacting,tithe,appendages,dermot,subtypes,nurseries,balinese,simulating,stary,remakes,mundi,chautauqua,geologically,stockade,hakka,dilute,kalimantan,pahang,overlapped,fredericton,baha'u'llah,jahangir,damping,benefactors,shomali,triumphal,cieszyn,paradigms,shielded,reggaeton,maharishi,zambian,shearing,golestan,mirroring,partitioning,flyover,songbook,incandescent,merrimack,huguenots,sangeet,vulnerabilities,trademarked,drydock,tantric,honoris,queenstown,labelling,iterative,enlists,statesmen,anglicans,herge,qinghai,burgundian,islami,delineated,zhuge,aggregated,banknote,qatari,suitably,tapestries,asymptotic,charleroi,majorities,pyramidellidae,leanings,climactic,tahir,ramsar,suppressor,revisionist,trawler,ernakulam,penicillium,categorization,slits,entitlement,collegium,earths,benefice,pinochet,puritans,loudspeaker,stockhausen,eurocup,roskilde,alois,jaroslav,rhondda,boutiques,vigor,neurotransmitter,ansar,malden,ferdinando,sported,relented,intercession,camberwell,wettest,thunderbolts,positional,oriel,cloverleaf,penalized,shoshone,rajkumar,completeness,sharjah,chromosomal,belgians,woolen,ultrasonic,sequentially,boleyn,mordella,microsystems,initiator,elachista,mineralogy,rhododendron,integrals,compostela,hamza,sawmills,stadio,berlioz,maidens,stonework,yachting,tappeh,myocardial,laborer,workstations,costumed,nicaea,lanark,roundtable,mashhad,nablus,algonquian,stuyvesant,sarkar,heroines,diwan,laments,intonation,intrigues,almaty,feuded,grandes,algarve,rehabilitate,macrophages,cruciate,dismayed,heuristic,eliezer,kozhikode,covalent,finalised,dimorphism,yaroslavl,overtaking,leverkusen,middlebury,feeders,brookings,speculates,insoluble,lodgings,jozsef,cysteine,shenyang,habilitation,spurious,brainchild,mtdna,comique,albedo,recife,partick,broadening,shahi,orientated,himalaya,swabia,palme,mennonites,spokeswoman,conscripts,sepulchre,chartres,eurozone,scaffold,invertebrate,parishad,bagan,heian,watercolors,basse,supercomputer,commences,tarragona,plainfield,arthurian,functor,identically,murex,chronicling,pressings,burrowing,histoire,guayaquil,goalkeeping,differentiable,warburg,machining,aeneas,kanawha,holocene,ramesses,reprisal,qingdao,avatars,turkestan,cantatas,besieging,repudiated,teamsters,equipping,hydride,ahmadiyya,euston,bottleneck,computations,terengganu,kalinga,stela,rediscovery,'this,azhar,stylised,karelia,polyethylene,kansai,motorised,lounges,normalization,calculators,1700s,goalkeepers,unfolded,commissary,cubism,vignettes,multiverse,heaters,briton,sparingly,childcare,thorium,plock,riksdag,eunuchs,catalysis,limassol,perce,uncensored,whitlam,ulmus,unites,mesopotamian,refraction,biodiesel,forza,fulda,unseated,mountbatten,shahrak,selenium,osijek,mimicking,antimicrobial,axons,simulcasting,donizetti,swabian,sportsmen,hafiz,neared,heraclius,locates,evaded,subcarpathian,bhubaneswar,negeri,jagannath,thaksin,aydin,oromo,lateran,goldsmiths,multiculturalism,cilia,mihai,evangelists,lorient,qajar,polygons,vinod,mechanised,anglophone,prefabricated,mosses,supervillain,airliners,biofuels,iodide,innovators,valais,wilberforce,logarithm,intelligentsia,dissipation,sanctioning,duchies,aymara,porches,simulators,mostar,telepathic,coaxial,caithness,burghs,fourths,stratification,joaquim,scribes,meteorites,monarchist,germination,vries,desiring,replenishment,istria,winemaking,tammany,troupes,hetman,lanceolate,pelagic,triptych,primeira,scant,outbound,hyphae,denser,bentham,basie,normale,executes,ladislaus,kontinental,herat,cruiserweight,activision,customization,manoeuvres,inglewood,northwood,waveform,investiture,inpatient,alignments,kiryat,rabat,archimedes,ustad,monsanto,archetypal,kirkby,sikhism,correspondingly,catskill,overlaid,petrels,widowers,unicameral,federalists,metalcore,gamerankings,mussel,formula_34,lymphocytes,cystic,southgate,vestiges,immortals,kalam,strove,amazons,pocono,sociologists,sopwith,adheres,laurens,caregivers,inspecting,transylvanian,rebroadcast,rhenish,miserables,pyrams,blois,newtonian,carapace,redshirt,gotland,nazir,unilever,distortions,linebackers,federalism,mombasa,lumen,bernoulli,favouring,aligarh,denounce,steamboats,dnieper,stratigraphic,synths,bernese,umass,icebreaker,guanajuato,heisenberg,boldly,diodes,ladakh,dogmatic,scriptwriter,maritimes,battlestar,symposia,adaptable,toluca,bhavan,nanking,ieyasu,picardy,soybean,adalbert,brompton,deutsches,brezhnev,glandular,laotian,hispanicized,ibadan,personification,dalit,yamuna,regio,dispensed,yamagata,zweibrucken,revising,fandom,stances,participle,flavours,khitan,vertebral,crores,mayaguez,dispensation,guntur,undefined,harpercollins,unionism,meena,leveling,philippa,refractory,telstra,judea,attenuation,pylons,elaboration,elegy,edging,gracillariidae,residencies,absentia,reflexive,deportations,dichotomy,stoves,sanremo,shimon,menachem,corneal,conifers,mordellidae,facsimile,diagnoses,cowper,citta,viticulture,divisive,riverview,foals,mystics,polyhedron,plazas,airspeed,redgrave,motherland,impede,multiplicity,barrichello,airships,pharmacists,harvester,clays,payloads,differentiating,popularize,caesars,tunneling,stagnant,circadian,indemnity,sensibilities,musicology,prefects,serfs,metra,lillehammer,carmarthenshire,kiosks,welland,barbican,alkyl,tillandsia,gatherers,asociacion,showings,bharati,brandywine,subversion,scalable,pfizer,dawla,barium,dardanelles,nsdap,konig,ayutthaya,hodgkin,sedimentation,completions,purchasers,sponsorships,maximizing,banked,taoism,minot,enrolls,fructose,aspired,capuchin,outages,artois,carrollton,totality,osceola,pawtucket,fontainebleau,converged,queretaro,competencies,botha,allotments,sheaf,shastri,obliquely,banding,catharines,outwardly,monchengladbach,driest,contemplative,cassini,ranga,pundit,kenilworth,tiananmen,disulfide,formula_35,townlands,codice_3,looping,caravans,rachmaninoff,segmentation,fluorine,anglicised,gnostic,dessau,discern,reconfigured,altrincham,rebounding,battlecruiser,ramblers,1770s,convective,triomphe,miyagi,mourners,instagram,aloft,breastfeeding,courtyards,folkestone,changsha,kumamoto,saarland,grayish,provisionally,appomattox,uncial,classicism,mahindra,elapsed,supremes,monophyletic,cautioned,formula_36,noblewoman,kernels,sucre,swaps,bengaluru,grenfell,epicenter,rockhampton,worshipful,licentiate,metaphorical,malankara,amputated,wattle,palawan,tankobon,nobunaga,polyhedra,transduction,jilin,syrians,affinities,fluently,emanating,anglicized,sportscar,botanists,altona,dravida,chorley,allocations,kunming,luanda,premiering,outlived,mesoamerica,lingual,dissipating,impairments,attenborough,balustrade,emulator,bakhsh,cladding,increments,ascents,workington,qal'eh,winless,categorical,petrel,emphasise,dormer,toros,hijackers,telescopic,solidly,jankovic,cession,gurus,madoff,newry,subsystems,northside,talib,englishmen,farnese,holographic,electives,argonne,scrivener,predated,brugge,nauvoo,catalyses,soared,siddeley,graphically,powerlifting,funicular,sungai,coercive,fusing,uncertainties,locos,acetic,diverge,wedgwood,dressings,tiebreaker,didactic,vyacheslav,acreage,interplanetary,battlecruisers,sunbury,alkaloids,hairpin,automata,wielkie,interdiction,plugins,monkees,nudibranch,esporte,approximations,disabling,powering,characterisation,ecologically,martinsville,termen,perpetuated,lufthansa,ascendancy,motherboard,bolshoi,athanasius,prunus,dilution,invests,nonzero,mendocino,charan,banque,shaheed,counterculture,unita,voivode,hospitalization,vapour,supermarine,resistor,steppes,osnabruck,intermediates,benzodiazepines,sunnyside,privatized,geopolitical,ponta,beersheba,kievan,embody,theoretic,sangh,cartographer,blige,rotors,thruway,battlefields,discernible,demobilized,broodmare,colouration,sagas,policymakers,serialization,augmentation,hoare,frankfurter,transnistria,kinases,detachable,generational,converging,antiaircraft,khaki,bimonthly,coadjutor,arkhangelsk,kannur,buffers,livonian,northwich,enveloped,cysts,yokozuna,herne,beeching,enron,virginian,woollen,excepting,competitively,outtakes,recombinant,hillcrest,clearances,pathe,cumbersome,brasov,u.s.a,likud,christiania,cruciform,hierarchies,wandsworth,lupin,resins,voiceover,sitar,electrochemical,mediacorp,typhus,grenadiers,hepatic,pompeii,weightlifter,bosniak,oxidoreductase,undersecretary,rescuers,ranji,seleucid,analysing,exegesis,tenancy,toure,kristiansand,110th,carillon,minesweepers,poitou,acceded,palladian,redevelop,naismith,rifled,proletariat,shojo,hackensack,harvests,endpoint,kuban,rosenborg,stonehenge,authorisation,jacobean,revocation,compatriots,colliding,undetermined,okayama,acknowledgment,angelou,fresnel,chahar,ethereal,mg/kg,emmet,mobilised,unfavourable,cultura,characterizing,parsonage,skeptics,expressways,rabaul,medea,guardsmen,visakhapatnam,caddo,homophobic,elmwood,encircling,coexistence,contending,seljuk,mycologist,infertility,moliere,insolvent,covenants,underpass,holme,landesliga,workplaces,delinquency,methamphetamine,contrived,tableau,tithes,overlying,usurped,contingents,spares,oligocene,molde,beatification,mordechai,balloting,pampanga,navigators,flowered,debutant,codec,orogeny,newsletters,solon,ambivalent,ubisoft,archdeaconry,harpers,kirkus,jabal,castings,kazhagam,sylhet,yuwen,barnstaple,amidships,causative,isuzu,watchtower,granules,canaveral,remuneration,insurer,payout,horizonte,integrative,attributing,kiwis,skanderbeg,asymmetry,gannett,urbanism,disassembled,unaltered,precluded,melodifestivalen,ascends,plugin,gurkha,bisons,stakeholder,industrialisation,abbotsford,sextet,bustling,uptempo,slavia,choreographers,midwives,haram,javed,gazetteer,subsection,natively,weighting,lysine,meera,redbridge,muchmusic,abruzzo,adjoins,unsustainable,foresters,kbit/s,cosmopterigidae,secularism,poetics,causality,phonograph,estudiantes,ceausescu,universitario,adjoint,applicability,gastropods,nagaland,kentish,mechelen,atalanta,woodpeckers,lombards,gatineau,romansh,avraham,acetylcholine,perturbation,galois,wenceslaus,fuzhou,meandering,dendritic,sacristy,accented,katha,therapeutics,perceives,unskilled,greenhouses,analogues,chaldean,timbre,sloped,volodymyr,sadiq,maghreb,monogram,rearguard,caucuses,mures,metabolite,uyezd,determinism,theosophical,corbet,gaels,disruptions,bicameral,ribosomal,wolseley,clarksville,watersheds,tarsi,radon,milanese,discontinuous,aristotelian,whistleblower,representational,hashim,modestly,localised,atrial,hazara,ravana,troyes,appointees,rubus,morningside,amity,aberdare,ganglia,wests,zbigniew,aerobatic,depopulated,corsican,introspective,twinning,hardtop,shallower,cataract,mesolithic,emblematic,graced,lubrication,republicanism,voronezh,bastions,meissen,irkutsk,oboes,hokkien,sprites,tenet,individualist,capitulated,oakville,dysentery,orientalist,hillsides,keywords,elicited,incised,lagging,apoel,lengthening,attractiveness,marauders,sportswriter,decentralization,boltzmann,contradicts,draftsman,precipitate,solihull,norske,consorts,hauptmann,riflemen,adventists,syndromes,demolishing,customize,continuo,peripherals,seamlessly,linguistically,bhushan,orphanages,paraul,lessened,devanagari,quarto,responders,patronymic,riemannian,altoona,canonization,honouring,geodetic,exemplifies,republica,enzymatic,porters,fairmount,pampa,sufferers,kamchatka,conjugated,coachella,uthman,repositories,copious,headteacher,awami,phoneme,homomorphism,franconian,moorland,davos,quantified,kamloops,quarks,mayoralty,weald,peacekeepers,valerian,particulate,insiders,perthshire,caches,guimaraes,piped,grenadines,kosciuszko,trombonist,artemisia,covariance,intertidal,soybeans,beatified,ellipse,fruiting,deafness,dnipropetrovsk,accrued,zealous,mandala,causation,junius,kilowatt,bakeries,montpelier,airdrie,rectified,bungalows,toleration,debian,pylon,trotskyist,posteriorly,two-and-a-half,herbivorous,islamists,poetical,donne,wodehouse,frome,allium,assimilate,phonemic,minaret,unprofitable,darpa,untenable,leaflet,bitcoin,zahir,thresholds,argentino,jacopo,bespoke,stratified,wellbeing,shiite,basaltic,timberwolves,secrete,taunts,marathons,isomers,carre,consecrators,penobscot,pitcairn,sakha,crosstown,inclusions,impassable,fenders,indre,uscgc,jordi,retinue,logarithmic,pilgrimages,railcar,cashel,blackrock,macroscopic,aligning,tabla,trestle,certify,ronson,palps,dissolves,thickened,silicate,taman,walsingham,hausa,lowestoft,rondo,oleksandr,cuyahoga,retardation,countering,cricketing,holborn,identifiers,hells,geophysics,infighting,sculpting,balaji,webbed,irradiation,runestone,trusses,oriya,sojourn,forfeiture,colonize,exclaimed,eucharistic,lackluster,glazing,northridge,gutenberg,stipulates,macroeconomic,priori,outermost,annular,udinese,insulating,headliner,godel,polytope,megalithic,salix,sharapova,derided,muskegon,braintree,plateaus,confers,autocratic,isomer,interstitial,stamping,omits,kirtland,hatchery,evidences,intifada,111th,podgorica,capua,motivating,nuneaton,jakub,korsakov,amitabh,mundial,monrovia,gluten,predictor,marshalling,d'orleans,levers,touchscreen,brantford,fricative,banishment,descendent,antagonism,ludovico,loudspeakers,formula_37,livelihoods,manassas,steamships,dewsbury,uppermost,humayun,lures,pinnacles,dependents,lecce,clumps,observatories,paleozoic,dedicating,samiti,draughtsman,gauls,incite,infringing,nepean,pythagorean,convents,triumvirate,seigneur,gaiman,vagrant,fossa,byproduct,serrated,renfrewshire,sheltering,achaemenid,dukedom,catchers,sampdoria,platelet,bielefeld,fluctuating,phenomenology,strikeout,ethnology,prospectors,woodworking,tatra,wildfires,meditations,agrippa,fortescue,qureshi,wojciech,methyltransferase,accusative,saatchi,amerindian,volcanism,zeeland,toyama,vladimirovich,allege,polygram,redox,budgeted,advisories,nematode,chipset,starscream,tonbridge,hardening,shales,accompanist,paraded,phonographic,whitefish,sportive,audiobook,kalisz,hibernation,latif,duels,ps200,coxeter,nayak,safeguarding,cantabria,minesweeping,zeiss,dunams,catholicos,sawtooth,ontological,nicobar,bridgend,unclassified,intrinsically,hanoverian,rabbitohs,kenseth,alcalde,northumbrian,raritan,septuagint,presse,sevres,origen,dandenong,peachtree,intersected,impeded,usages,hippodrome,novara,trajectories,customarily,yardage,inflected,yanow,kalan,taverns,liguria,librettist,intermarriage,1760s,courant,gambier,infanta,ptolemaic,ukulele,haganah,sceptical,manchukuo,plexus,implantation,hilal,intersex,efficiencies,arbroath,hagerstown,adelphi,diario,marais,matti,lifes,coining,modalities,divya,bletchley,conserving,ivorian,mithridates,generative,strikeforce,laymen,toponymy,pogrom,satya,meticulously,agios,dufferin,yaakov,fortnightly,cargoes,deterrence,prefrontal,przemysl,mitterrand,commemorations,chatsworth,gurdwara,abuja,chakraborty,badajoz,geometries,artiste,diatonic,ganglion,presides,marymount,nanak,cytokines,feudalism,storks,rowers,widens,politico,evangelicals,assailants,pittsfield,allowable,bijapur,telenovelas,dichomeris,glenelg,herbivores,keita,inked,radom,fundraisers,constantius,boheme,portability,komnenos,crystallography,derrida,moderates,tavistock,fateh,spacex,disjoint,bristles,commercialized,interwoven,empirically,regius,bulacan,newsday,showa,radicalism,yarrow,pleura,sayed,structuring,cotes,reminiscences,acetyl,edicts,escalators,aomori,encapsulated,legacies,bunbury,placings,fearsome,postscript,powerfully,keighley,hildesheim,amicus,crevices,deserters,benelux,aurangabad,freeware,ioannis,carpathians,chirac,seceded,prepaid,landlocked,naturalised,yanukovych,soundscan,blotch,phenotypic,determinants,twente,dictatorial,giessen,composes,recherche,pathophysiology,inventories,ayurveda,elevating,gravestone,degeneres,vilayet,popularizing,spartanburg,bloemfontein,previewed,renunciation,genotype,ogilvy,tracery,blacklisted,emissaries,diploid,disclosures,tupolev,shinjuku,antecedents,pennine,braganza,bhattacharya,countable,spectroscopic,ingolstadt,theseus,corroborated,compounding,thrombosis,extremadura,medallions,hasanabad,lambton,perpetuity,glycol,besancon,palaiologos,pandey,caicos,antecedent,stratum,laserdisc,novitiate,crowdfunding,palatal,sorceress,dassault,toughness,celle,cezanne,vientiane,tioga,hander,crossbar,gisborne,cursor,inspectorate,serif,praia,sphingidae,nameplate,psalter,ivanovic,sitka,equalised,mutineers,sergius,outgrowth,creationism,haredi,rhizomes,predominate,undertakings,vulgate,hydrothermal,abbeville,geodesic,kampung,physiotherapy,unauthorised,asteraceae,conservationist,minoan,supersport,mohammadabad,cranbrook,mentorship,legitimately,marshland,datuk,louvain,potawatomi,carnivores,levies,lyell,hymnal,regionals,tinto,shikoku,conformal,wanganui,beira,lleida,standstill,deloitte,formula_40,corbusier,chancellery,mixtapes,airtime,muhlenberg,formula_39,bracts,thrashers,prodigious,gironde,chickamauga,uyghurs,substitutions,pescara,batangas,gregarious,gijon,paleo,mathura,pumas,proportionally,hawkesbury,yucca,kristiania,funimation,fluted,eloquence,mohun,aftermarket,chroniclers,futurist,nonconformist,branko,mannerisms,lesnar,opengl,altos,retainers,ashfield,shelbourne,sulaiman,divisie,gwent,locarno,lieder,minkowski,bivalve,redeployed,cartography,seaway,bookings,decays,ostend,antiquaries,pathogenesis,formula_38,chrysalis,esperance,valli,motogp,homelands,bridged,bloor,ghazal,vulgaris,baekje,prospector,calculates,debtors,hesperiidae,titian,returner,landgrave,frontenac,kelowna,pregame,castelo,caius,canoeist,watercolours,winterthur,superintendents,dissonance,dubstep,adorn,matic,salih,hillel,swordsman,flavoured,emitter,assays,monongahela,deeded,brazzaville,sufferings,babylonia,fecal,umbria,astrologer,gentrification,frescos,phasing,zielona,ecozone,candido,manoj,quadrilateral,gyula,falsetto,prewar,puntland,infinitive,contraceptive,bakhtiari,ohrid,socialization,tailplane,evoking,havelock,macapagal,plundering,104th,keynesian,templars,phrasing,morphologically,czestochowa,humorously,catawba,burgas,chiswick,ellipsoid,kodansha,inwards,gautama,katanga,orthopaedic,heilongjiang,sieges,outsourced,subterminal,vijayawada,hares,oration,leitrim,ravines,manawatu,cryogenic,tracklisting,about.com,ambedkar,degenerated,hastened,venturing,lobbyists,shekhar,typefaces,northcote,rugen,'good,ornithology,asexual,hemispheres,unsupported,glyphs,spoleto,epigenetic,musicianship,donington,diogo,kangxi,bisected,polymorphism,megawatt,salta,embossed,cheetahs,cruzeiro,unhcr,aristide,rayleigh,maturing,indonesians,noire,llano,ffffff,camus,purges,annales,convair,apostasy,algol,phage,apaches,marketers,aldehyde,pompidou,kharkov,forgeries,praetorian,divested,retrospectively,gornji,scutellum,bitumen,pausanias,magnification,imitations,nyasaland,geographers,floodlights,athlone,hippolyte,expositions,clarinetist,razak,neutrinos,rotax,sheykh,plush,interconnect,andalus,cladogram,rudyard,resonator,granby,blackfriars,placido,windscreen,sahel,minamoto,haida,cations,emden,blackheath,thematically,blacklist,pawel,disseminating,academical,undamaged,raytheon,harsher,powhatan,ramachandran,saddles,paderborn,capping,zahra,prospecting,glycine,chromatin,profane,banska,helmand,okinawan,dislocation,oscillators,insectivorous,foyle,gilgit,autonomic,tuareg,sluice,pollinated,multiplexed,granary,narcissus,ranchi,staines,nitra,goalscoring,midwifery,pensioners,algorithmic,meetinghouse,biblioteca,besar,narva,angkor,predate,lohan,cyclical,detainee,occipital,eventing,faisalabad,dartmoor,kublai,courtly,resigns,radii,megachilidae,cartels,shortfall,xhosa,unregistered,benchmarks,dystopian,bulkhead,ponsonby,jovanovic,accumulates,papuan,bhutanese,intuitively,gotaland,headliners,recursion,dejan,novellas,diphthongs,imbued,withstood,analgesic,amplify,powertrain,programing,maidan,alstom,affirms,eradicated,summerslam,videogame,molla,severing,foundered,gallium,atmospheres,desalination,shmuel,howmeh,catolica,bossier,reconstructing,isolates,lyase,tweets,unconnected,tidewater,divisible,cohorts,orebro,presov,furnishing,folklorist,simplifying,centrale,notations,factorization,monarchies,deepen,macomb,facilitation,hennepin,declassified,redrawn,microprocessors,preliminaries,enlarging,timeframe,deutschen,shipbuilders,patiala,ferrous,aquariums,genealogies,vieux,unrecognized,bridgwater,tetrahedral,thule,resignations,gondwana,registries,agder,dataset,felled,parva,analyzer,worsen,coleraine,columella,blockaded,polytechnique,reassembled,reentry,narvik,greys,nigra,knockouts,bofors,gniezno,slotted,hamasaki,ferrers,conferring,thirdly,domestication,photojournalist,universality,preclude,ponting,halved,thereupon,photosynthetic,ostrava,mismatch,pangasinan,intermediaries,abolitionists,transited,headings,ustase,radiological,interconnection,dabrowa,invariants,honorius,preferentially,chantilly,marysville,dialectical,antioquia,abstained,gogol,dirichlet,muricidae,symmetries,reproduces,brazos,fatwa,bacillus,ketone,paribas,chowk,multiplicative,dermatitis,mamluks,devotes,adenosine,newbery,meditative,minefields,inflection,oxfam,conwy,bystrica,imprints,pandavas,infinitesimal,conurbation,amphetamine,reestablish,furth,edessa,injustices,frankston,serjeant,4x200,khazar,sihanouk,longchamp,stags,pogroms,coups,upperparts,endpoints,infringed,nuanced,summing,humorist,pacification,ciaran,jamaat,anteriorly,roddick,springboks,faceted,hypoxia,rigorously,cleves,fatimid,ayurvedic,tabled,ratna,senhora,maricopa,seibu,gauguin,holomorphic,campgrounds,amboy,coordinators,ponderosa,casemates,ouachita,nanaimo,mindoro,zealander,rimsky,cluny,tomaszow,meghalaya,caetano,tilak,roussillon,landtag,gravitation,dystrophy,cephalopods,trombones,glens,killarney,denominated,anthropogenic,pssas,roubaix,carcasses,montmorency,neotropical,communicative,rabindranath,ordinated,separable,overriding,surged,sagebrush,conciliation,codice_4,durrani,phosphatase,qadir,votive,revitalized,taiyuan,tyrannosaurus,graze,slovaks,nematodes,environmentalism,blockhouse,illiteracy,schengen,ecotourism,alternation,conic,wields,hounslow,blackfoot,kwame,ambulatory,volhynia,hordaland,croton,piedras,rohit,drava,conceptualized,birla,illustrative,gurgaon,barisal,tutsi,dezong,nasional,polje,chanson,clarinets,krasnoyarsk,aleksandrovich,cosmonaut,d'este,palliative,midseason,silencing,wardens,durer,girders,salamanders,torrington,supersonics,lauda,farid,circumnavigation,embankments,funnels,bajnoksag,lorries,cappadocia,jains,warringah,retirees,burgesses,equalization,cusco,ganesan,algal,amazonian,lineups,allocating,conquerors,usurper,mnemonic,predating,brahmaputra,ahmadabad,maidenhead,numismatic,subregion,encamped,reciprocating,freebsd,irgun,tortoises,governorates,zionists,airfoil,collated,ajmer,fiennes,etymological,polemic,chadian,clerestory,nordiques,fluctuated,calvados,oxidizing,trailhead,massena,quarrels,dordogne,tirunelveli,pyruvate,pulsed,athabasca,sylar,appointee,serer,japonica,andronikos,conferencing,nicolaus,chemin,ascertained,incited,woodbine,helices,hospitalised,emplacements,to/from,orchestre,tyrannical,pannonia,methodism,pop/rock,shibuya,berbers,despot,seaward,westpac,separator,perpignan,alamein,judeo,publicize,quantization,ethniki,gracilis,menlo,offside,oscillating,unregulated,succumbing,finnmark,metrical,suleyman,raith,sovereigns,bundesstrasse,kartli,fiduciary,darshan,foramen,curler,concubines,calvinism,larouche,bukhara,sophomores,mohanlal,lutheranism,monomer,eamonn,'black,uncontested,immersive,tutorials,beachhead,bindings,permeable,postulates,comite,transformative,indiscriminate,hofstra,associacao,amarna,dermatology,lapland,aosta,babur,unambiguous,formatting,schoolboys,gwangju,superconducting,replayed,adherent,aureus,compressors,forcible,spitsbergen,boulevards,budgeting,nossa,annandale,perumal,interregnum,sassoon,kwajalein,greenbrier,caldas,triangulation,flavius,increment,shakhtar,nullified,pinfall,nomen,microfinance,depreciation,cubist,steeper,splendour,gruppe,everyman,chasers,campaigners,bridle,modality,percussive,darkly,capes,velar,picton,triennial,factional,padang,toponym,betterment,norepinephrine,112th,estuarine,diemen,warehousing,morphism,ideologically,pairings,immunization,crassus,exporters,sefer,flocked,bulbous,deseret,booms,calcite,bohol,elven,groot,pulau,citigroup,wyeth,modernizing,layering,pastiche,complies,printmaker,condenser,theropod,cassino,oxyrhynchus,akademie,trainings,lowercase,coxae,parte,chetniks,pentagonal,keselowski,monocoque,morsi,reticulum,meiosis,clapboard,recoveries,tinge,an/fps,revista,sidon,livre,epidermis,conglomerates,kampong,congruent,harlequins,tergum,simplifies,epidemiological,underwriting,tcp/ip,exclusivity,multidimensional,mysql,columbine,ecologist,hayat,sicilies,levees,handset,aesop,usenet,pacquiao,archiving,alexandrian,compensatory,broadsheet,annotation,bahamian,d'affaires,interludes,phraya,shamans,marmara,customizable,immortalized,ambushes,chlorophyll,diesels,emulsion,rheumatoid,voluminous,screenwriters,tailoring,sedis,runcorn,democratization,bushehr,anacostia,constanta,antiquary,sixtus,radiate,advaita,antimony,acumen,barristers,reichsbahn,ronstadt,symbolist,pasig,cursive,secessionist,afrikaner,munnetra,inversely,adsorption,syllabic,moltke,idioms,midline,olimpico,diphosphate,cautions,radziwill,mobilisation,copelatus,trawlers,unicron,bhaskar,financiers,minimalism,derailment,marxists,oireachtas,abdicate,eigenvalue,zafar,vytautas,ganguly,chelyabinsk,telluride,subordination,ferried,dived,vendee,pictish,dimitrov,expiry,carnation,cayley,magnitudes,lismore,gretna,sandwiched,unmasked,sandomierz,swarthmore,tetra,nanyang,pevsner,dehradun,mormonism,rashi,complying,seaplanes,ningbo,cooperates,strathcona,mornington,mestizo,yulia,edgbaston,palisade,ethno,polytopes,espirito,tymoshenko,pronunciations,paradoxical,taichung,chipmunks,erhard,maximise,accretion,kanda,`abdu'l,narrowest,umpiring,mycenaean,divisor,geneticist,ceredigion,barque,hobbyists,equates,auxerre,spinose,cheil,sweetwater,guano,carboxylic,archiv,tannery,cormorant,agonists,fundacion,anbar,tunku,hindrance,meerut,concordat,secunderabad,kachin,achievable,murfreesboro,comprehensively,forges,broadest,synchronised,speciation,scapa,aliyev,conmebol,tirelessly,subjugated,pillaged,udaipur,defensively,lakhs,stateless,haasan,headlamps,patterning,podiums,polyphony,mcmurdo,mujer,vocally,storeyed,mucosa,multivariate,scopus,minimizes,formalised,certiorari,bourges,populate,overhanging,gaiety,unreserved,borromeo,woolworths,isotopic,bashar,purify,vertebra,medan,juxtaposition,earthwork,elongation,chaudhary,schematic,piast,steeped,nanotubes,fouls,achaea,legionnaires,abdur,qmjhl,embraer,hardback,centerville,ilocos,slovan,whitehorse,mauritian,moulding,mapuche,donned,provisioning,gazprom,jonesboro,audley,lightest,calyx,coldwater,trigonometric,petroglyphs,psychoanalyst,congregate,zambezi,fissure,supervises,bexley,etobicoke,wairarapa,tectonics,emphasises,formula_41,debugging,linfield,spatially,ionizing,ungulates,orinoco,clades,erlangen,news/talk,vols.,ceara,yakovlev,finsbury,entanglement,fieldhouse,graphene,intensifying,grigory,keyong,zacatecas,ninian,allgemeine,keswick,societa,snorri,femininity,najib,monoclonal,guyanese,postulate,huntly,abbeys,machinist,yunus,emphasising,ishaq,urmia,bremerton,pretenders,lumiere,thoroughfares,chikara,dramatized,metathorax,taiko,transcendence,wycliffe,retrieves,umpired,steuben,racehorses,taylors,kuznetsov,montezuma,precambrian,canopies,gaozong,propodeum,disestablished,retroactive,shoreham,rhizome,doubleheader,clinician,diwali,quartzite,shabaab,agassiz,despatched,stormwater,luxemburg,callao,universidade,courland,skane,glyph,dormers,witwatersrand,curacy,qualcomm,nansen,entablature,lauper,hausdorff,lusaka,ruthenian,360deg,cityscape,douai,vaishnava,spars,vaulting,rationalist,gygax,sequestration,typology,pollinates,accelerators,leben,colonials,cenotaph,imparted,carthaginians,equaled,rostrum,gobind,bodhisattva,oberst,bicycling,arabi,sangre,biophysics,hainaut,vernal,lunenburg,apportioned,finches,lajos,nenad,repackaged,zayed,nikephoros,r.e.m,swaminarayan,gestalt,unplaced,crags,grohl,sialkot,unsaturated,gwinnett,linemen,forays,palakkad,writs,instrumentalists,aircrews,badged,terrapins,180deg,oneness,commissariat,changi,pupation,circumscribed,contador,isotropic,administrated,fiefs,nimes,intrusions,minoru,geschichte,nadph,tainan,changchun,carbondale,frisia,swapo,evesham,hawai'i,encyclopedic,transporters,dysplasia,formula_42,onsite,jindal,guetta,judgements,narbonne,permissions,paleogene,rationalism,vilna,isometric,subtracted,chattahoochee,lamina,missa,greville,pervez,lattices,persistently,crystallization,timbered,hawaiians,fouling,interrelated,masood,ripening,stasi,gamal,visigothic,warlike,cybernetics,tanjung,forfar,cybernetic,karelian,brooklands,belfort,greifswald,campeche,inexplicably,refereeing,understory,uninterested,prius,collegiately,sefid,sarsfield,categorize,biannual,elsevier,eisteddfod,declension,autonoma,procuring,misrepresentation,novelization,bibliographic,shamanism,vestments,potash,eastleigh,ionized,turan,lavishly,scilly,balanchine,importers,parlance,'that,kanyakumari,synods,mieszko,crossovers,serfdom,conformational,legislated,exclave,heathland,sadar,differentiates,propositional,konstantinos,photoshop,manche,vellore,appalachia,orestes,taiga,exchanger,grozny,invalidated,baffin,spezia,staunchly,eisenach,robustness,virtuosity,ciphers,inlets,bolagh,understandings,bosniaks,parser,typhoons,sinan,luzerne,webcomic,subtraction,jhelum,businessweek,ceske,refrained,firebox,mitigated,helmholtz,dilip,eslamabad,metalwork,lucan,apportionment,provident,gdynia,schooners,casement,danse,hajjiabad,benazir,buttress,anthracite,newsreel,wollaston,dispatching,cadastral,riverboat,provincetown,nantwich,missal,irreverent,juxtaposed,darya,ennobled,electropop,stereoscopic,maneuverability,laban,luhansk,udine,collectibles,haulage,holyrood,materially,supercharger,gorizia,shkoder,townhouses,pilate,layoffs,folkloric,dialectic,exuberant,matures,malla,ceuta,citizenry,crewed,couplet,stopover,transposition,tradesmen,antioxidant,amines,utterance,grahame,landless,isere,diction,appellant,satirist,urbino,intertoto,subiaco,antonescu,nehemiah,ubiquitin,emcee,stourbridge,fencers,103rd,wranglers,monteverdi,watertight,expounded,xiamen,manmohan,pirie,threefold,antidepressant,sheboygan,grieg,cancerous,diverging,bernini,polychrome,fundamentalism,bihari,critiqued,cholas,villers,tendulkar,dafydd,vastra,fringed,evangelization,episcopalian,maliki,sana'a,ashburton,trianon,allegany,heptathlon,insufficiently,panelists,pharrell,hexham,amharic,fertilized,plumes,cistern,stratigraphy,akershus,catalans,karoo,rupee,minuteman,quantification,wigmore,leutnant,metanotum,weeknights,iridescent,extrasolar,brechin,deuterium,kuching,lyricism,astrakhan,brookhaven,euphorbia,hradec,bhagat,vardar,aylmer,positron,amygdala,speculators,unaccompanied,debrecen,slurry,windhoek,disaffected,rapporteur,mellitus,blockers,fronds,yatra,sportsperson,precession,physiologist,weeknight,pidgin,pharma,condemns,standardize,zetian,tibor,glycoprotein,emporia,cormorants,amalie,accesses,leonhard,denbighshire,roald,116th,will.i.am,symbiosis,privatised,meanders,chemnitz,jabalpur,shing,secede,ludvig,krajina,homegrown,snippets,sasanian,euripides,peder,cimarron,streaked,graubunden,kilimanjaro,mbeki,middleware,flensburg,bukovina,lindwall,marsalis,profited,abkhaz,polis,camouflaged,amyloid,morgantown,ovoid,bodleian,morte,quashed,gamelan,juventud,natchitoches,storyboard,freeview,enumeration,cielo,preludes,bulawayo,1600s,olympiads,multicast,faunal,asura,reinforces,puranas,ziegfeld,handicraft,seamount,kheil,noche,hallmarks,dermal,colorectal,encircle,hessen,umbilicus,sunnis,leste,unwin,disclosing,superfund,montmartre,refuelling,subprime,kolhapur,etiology,bismuth,laissez,vibrational,mazar,alcoa,rumsfeld,recurve,ticonderoga,lionsgate,onlookers,homesteads,filesystem,barometric,kingswood,biofuel,belleza,moshav,occidentalis,asymptomatic,northeasterly,leveson,huygens,numan,kingsway,primogeniture,toyotomi,yazoo,limpets,greenbelt,booed,concurrence,dihedral,ventrites,raipur,sibiu,plotters,kitab,109th,trackbed,skilful,berthed,effendi,fairing,sephardi,mikhailovich,lockyer,wadham,invertible,paperbacks,alphabetic,deuteronomy,constitutive,leathery,greyhounds,estoril,beechcraft,poblacion,cossidae,excreted,flamingos,singha,olmec,neurotransmitters,ascoli,nkrumah,forerunners,dualism,disenchanted,benefitted,centrum,undesignated,noida,o'donoghue,collages,egrets,egmont,wuppertal,cleave,montgomerie,pseudomonas,srinivasa,lymphatic,stadia,resold,minima,evacuees,consumerism,ronde,biochemist,automorphism,hollows,smuts,improvisations,vespasian,bream,pimlico,eglin,colne,melancholic,berhad,ousting,saale,notaulices,ouest,hunslet,tiberias,abdomina,ramsgate,stanislas,donbass,pontefract,sucrose,halts,drammen,chelm,l'arc,taming,trolleys,konin,incertae,licensees,scythian,giorgos,dative,tanglewood,farmlands,o'keeffe,caesium,romsdal,amstrad,corte,oglethorpe,huntingdonshire,magnetization,adapts,zamosc,shooto,cuttack,centrepiece,storehouse,winehouse,morbidity,woodcuts,ryazan,buddleja,buoyant,bodmin,estero,austral,verifiable,periyar,christendom,curtail,shura,kaifeng,cotswold,invariance,seafaring,gorica,androgen,usman,seabird,forecourt,pekka,juridical,audacious,yasser,cacti,qianlong,polemical,d'amore,espanyol,distrito,cartographers,pacifism,serpents,backa,nucleophilic,overturning,duplicates,marksman,oriente,vuitton,oberleutnant,gielgud,gesta,swinburne,transfiguration,1750s,retaken,celje,fredrikstad,asuka,cropping,mansard,donates,blacksmiths,vijayanagara,anuradhapura,germinate,betis,foreshore,jalandhar,bayonets,devaluation,frazione,ablaze,abidjan,approvals,homeostasis,corollary,auden,superfast,redcliffe,luxembourgish,datum,geraldton,printings,ludhiana,honoree,synchrotron,invercargill,hurriedly,108th,three-and-a-half,colonist,bexar,limousin,bessemer,ossetian,nunataks,buddhas,rebuked,thais,tilburg,verdicts,interleukin,unproven,dordrecht,solent,acclamation,muammar,dahomey,operettas,4x400,arrears,negotiators,whitehaven,apparitions,armoury,psychoactive,worshipers,sculptured,elphinstone,airshow,kjell,o'callaghan,shrank,professorships,predominance,subhash,coulomb,sekolah,retrofitted,samos,overthrowing,vibrato,resistors,palearctic,datasets,doordarshan,subcutaneous,compiles,immorality,patchwork,trinidadian,glycogen,pronged,zohar,visigoths,freres,akram,justo,agora,intakes,craiova,playwriting,bukhari,militarism,iwate,petitioners,harun,wisla,inefficiency,vendome,ledges,schopenhauer,kashi,entombed,assesses,tenn.,noumea,baguio,carex,o'donovan,filings,hillsdale,conjectures,blotches,annuals,lindisfarne,negated,vivek,angouleme,trincomalee,cofactor,verkhovna,backfield,twofold,automaker,rudra,freighters,darul,gharana,busway,formula_43,plattsburgh,portuguesa,showrunner,roadmap,valenciennes,erdos,biafra,spiritualism,transactional,modifies,carne,107th,cocos,gcses,tiverton,radiotherapy,meadowlands,gunma,srebrenica,foxtel,authenticated,enslavement,classicist,klaipeda,minstrels,searchable,infantrymen,incitement,shiga,nadp+,urals,guilders,banquets,exteriors,counterattacks,visualized,diacritics,patrimony,svensson,transepts,prizren,telegraphy,najaf,emblazoned,coupes,effluent,ragam,omani,greensburg,taino,flintshire,cd/dvd,lobbies,narrating,cacao,seafarers,bicolor,collaboratively,suraj,floodlit,sacral,puppetry,tlingit,malwa,login,motionless,thien,overseers,vihar,golem,specializations,bathhouse,priming,overdubs,winningest,archetypes,uniao,acland,creamery,slovakian,lithographs,maryborough,confidently,excavating,stillborn,ramallah,audiencia,alava,ternary,hermits,rostam,bauxite,gawain,lothair,captions,gulfstream,timelines,receded,mediating,petain,bastia,rudbar,bidders,disclaimer,shrews,tailings,trilobites,yuriy,jamil,demotion,gynecology,rajinikanth,madrigals,ghazni,flycatchers,vitebsk,bizet,computationally,kashgar,refinements,frankford,heralds,europe/africa,levante,disordered,sandringham,queues,ransacked,trebizond,verdes,comedie,primitives,figurine,organists,culminate,gosport,coagulation,ferrying,hoyas,polyurethane,prohibitive,midfielders,ligase,progesterone,defectors,sweetened,backcountry,diodorus,waterside,nieuport,khwaja,jurong,decried,gorkha,ismaili,300th,octahedral,kindergartens,paseo,codification,notifications,disregarding,risque,reconquista,shortland,atolls,texarkana,perceval,d'etudes,kanal,herbicides,tikva,nuova,gatherer,dissented,soweto,dexterity,enver,bacharach,placekicker,carnivals,automate,maynooth,symplectic,chetnik,militaire,upanishads,distributive,strafing,championing,moiety,miliband,blackadder,enforceable,maung,dimer,stadtbahn,diverges,obstructions,coleophoridae,disposals,shamrocks,aural,banca,bahru,coxed,grierson,vanadium,watermill,radiative,ecoregions,berets,hariri,bicarbonate,evacuations,mallee,nairn,rushden,loggia,slupsk,satisfactorily,milliseconds,cariboo,reine,cyclo,pigmentation,postmodernism,aqueducts,vasari,bourgogne,dilemmas,liquefied,fluminense,alloa,ibaraki,tenements,kumasi,humerus,raghu,labours,putsch,soundcloud,bodybuilder,rakyat,domitian,pesaro,translocation,sembilan,homeric,enforcers,tombstones,lectureship,rotorua,salamis,nikolaos,inferences,superfortress,lithgow,surmised,undercard,tarnow,barisan,stingrays,federacion,coldstream,haverford,ornithological,heerenveen,eleazar,jyoti,murali,bamako,riverbed,subsidised,theban,conspicuously,vistas,conservatorium,madrasa,kingfishers,arnulf,credential,syndicalist,sheathed,discontinuity,prisms,tsushima,coastlines,escapees,vitis,optimizing,megapixel,overground,embattled,halide,sprinters,buoys,mpumalanga,peculiarities,106th,roamed,menezes,macao,prelates,papyri,freemen,dissertations,irishmen,pooled,sverre,reconquest,conveyance,subjectivity,asturian,circassian,formula_45,comdr,thickets,unstressed,monro,passively,harmonium,moveable,dinar,carlsson,elysees,chairing,b'nai,confusingly,kaoru,convolution,godolphin,facilitator,saxophones,eelam,jebel,copulation,anions,livres,licensure,pontypridd,arakan,controllable,alessandria,propelling,stellenbosch,tiber,wolka,liberators,yarns,d'azur,tsinghua,semnan,amhara,ablation,melies,tonality,historique,beeston,kahne,intricately,sonoran,robespierre,gyrus,boycotts,defaulted,infill,maranhao,emigres,framingham,paraiba,wilhelmshaven,tritium,skyway,labial,supplementation,possessor,underserved,motets,maldivian,marrakech,quays,wikimedia,turbojet,demobilization,petrarch,encroaching,sloops,masted,karbala,corvallis,agribusiness,seaford,stenosis,hieronymus,irani,superdraft,baronies,cortisol,notability,veena,pontic,cyclin,archeologists,newham,culled,concurring,aeolian,manorial,shouldered,fords,philanthropists,105th,siddharth,gotthard,halim,rajshahi,jurchen,detritus,practicable,earthenware,discarding,travelogue,neuromuscular,elkhart,raeder,zygmunt,metastasis,internees,102nd,vigour,upmarket,summarizing,subjunctive,offsets,elizabethtown,udupi,pardubice,repeaters,instituting,archaea,substandard,technische,linga,anatomist,flourishes,velika,tenochtitlan,evangelistic,fitchburg,springbok,cascading,hydrostatic,avars,occasioned,filipina,perceiving,shimbun,africanus,consternation,tsing,optically,beitar,45deg,abutments,roseville,monomers,huelva,lotteries,hypothalamus,internationalist,electromechanical,hummingbirds,fibreglass,salaried,dramatists,uncovers,invokes,earners,excretion,gelding,ancien,aeronautica,haverhill,stour,ittihad,abramoff,yakov,ayodhya,accelerates,industrially,aeroplanes,deleterious,dwelt,belvoir,harpalus,atpase,maluku,alasdair,proportionality,taran,epistemological,interferometer,polypeptide,adjudged,villager,metastatic,marshalls,madhavan,archduchess,weizmann,kalgoorlie,balan,predefined,sessile,sagaing,brevity,insecticide,psychosocial,africana,steelworks,aether,aquifers,belem,mineiro,almagro,radiators,cenozoic,solute,turbocharger,invicta,guested,buccaneer,idolatry,unmatched,paducah,sinestro,dispossessed,conforms,responsiveness,cyanobacteria,flautist,procurator,complementing,semifinalist,rechargeable,permafrost,cytokine,refuges,boomed,gelderland,franchised,jinan,burnie,doubtless,randomness,colspan=12,angra,ginebra,famers,nuestro,declarative,roughness,lauenburg,motile,rekha,issuer,piney,interceptors,napoca,gipsy,formulaic,formula_44,viswanathan,ebrahim,thessalonica,galeria,muskogee,unsold,html5,taito,mobutu,icann,carnarvon,fairtrade,morphisms,upsilon,nozzles,fabius,meander,murugan,strontium,episcopacy,sandinista,parasol,attenuated,bhima,primeval,panay,ordinator,negara,osteoporosis,glossop,ebook,paradoxically,grevillea,modoc,equating,phonetically,legumes,covariant,dorje,quatre,bruxelles,pyroclastic,shipbuilder,zhaozong,obscuring,sveriges,tremolo,extensible,barrack,multnomah,hakon,chaharmahal,parsing,volumetric,astrophysical,glottal,combinatorics,freestanding,encoder,paralysed,cavalrymen,taboos,heilbronn,orientalis,lockport,marvels,ozawa,dispositions,waders,incurring,saltire,modulate,papilio,phenol,intermedia,rappahannock,plasmid,fortify,phenotypes,transiting,correspondences,leaguer,larnaca,incompatibility,mcenroe,deeming,endeavoured,aboriginals,helmed,salar,arginine,werke,ferrand,expropriated,delimited,couplets,phoenicians,petioles,ouster,anschluss,protectionist,plessis,urchins,orquesta,castleton,juniata,bittorrent,fulani,donji,mykola,rosemont,chandos,scepticism,signer,chalukya,wicketkeeper,coquitlam,programmatic,o'brian,carteret,urology,steelhead,paleocene,konkan,bettered,venkatesh,surfacing,longitudinally,centurions,popularization,yazid,douro,widths,premios,leonards,gristmill,fallujah,arezzo,leftists,ecliptic,glycerol,inaction,disenfranchised,acrimonious,depositing,parashah,cockatoo,marechal,bolzano,chios,cablevision,impartiality,pouches,thickly,equities,bentinck,emotive,boson,ashdown,conquistadors,parsi,conservationists,reductive,newlands,centerline,ornithologists,waveguide,nicene,philological,hemel,setanta,masala,aphids,convening,casco,matrilineal,chalcedon,orthographic,hythe,replete,damming,bolivarian,admixture,embarks,borderlands,conformed,nagarjuna,blenny,chaitanya,suwon,shigeru,tatarstan,lingayen,rejoins,grodno,merovingian,hardwicke,puducherry,prototyping,laxmi,upheavals,headquarter,pollinators,bromine,transom,plantagenet,arbuthnot,chidambaram,woburn,osamu,panelling,coauthored,zhongshu,hyaline,omissions,aspergillus,offensively,electrolytic,woodcut,sodom,intensities,clydebank,piotrkow,supplementing,quipped,focke,harbinger,positivism,parklands,wolfenbuttel,cauca,tryptophan,taunus,curragh,tsonga,remand,obscura,ashikaga,eltham,forelimbs,analogs,trnava,observances,kailash,antithesis,ayumi,abyssinia,dorsally,tralee,pursuers,misadventures,padova,perot,mahadev,tarim,granth,licenced,compania,patuxent,baronial,korda,cochabamba,codices,karna,memorialized,semaphore,playlists,mandibular,halal,sivaji,scherzinger,stralsund,foundries,ribosome,mindfulness,nikolayevich,paraphyletic,newsreader,catalyze,ioannina,thalamus,gbit/s,paymaster,sarab,500th,replenished,gamepro,cracow,formula_46,gascony,reburied,lessing,easement,transposed,meurthe,satires,proviso,balthasar,unbound,cuckoos,durbar,louisbourg,cowes,wholesalers,manet,narita,xiaoping,mohamad,illusory,cathal,reuptake,alkaloid,tahrir,mmorpg,underlies,anglicanism,repton,aharon,exogenous,buchenwald,indigent,odostomia,milled,santorum,toungoo,nevsky,steyr,urbanisation,darkseid,subsonic,canaanite,akiva,eglise,dentition,mediators,cirencester,peloponnesian,malmesbury,durres,oerlikon,tabulated,saens,canaria,ischemic,esterhazy,ringling,centralization,walthamstow,nalanda,lignite,takht,leninism,expiring,circe,phytoplankton,promulgation,integrable,breeches,aalto,menominee,borgo,scythians,skrull,galleon,reinvestment,raglan,reachable,liberec,airframes,electrolysis,geospatial,rubiaceae,interdependence,symmetrically,simulcasts,keenly,mauna,adipose,zaidi,fairport,vestibular,actuators,monochromatic,literatures,congestive,sacramental,atholl,skytrain,tycho,tunings,jamia,catharina,modifier,methuen,tapings,infiltrating,colima,grafting,tauranga,halides,pontificate,phonetics,koper,hafez,grooved,kintetsu,extrajudicial,linkoping,cyberpunk,repetitions,laurentian,parnu,bretton,darko,sverdlovsk,foreshadowed,akhenaten,rehnquist,gosford,coverts,pragmatism,broadleaf,ethiopians,instated,mediates,sodra,opulent,descriptor,enugu,shimla,leesburg,officership,giffard,refectory,lusitania,cybermen,fiume,corus,tydfil,lawrenceville,ocala,leviticus,burghers,ataxia,richthofen,amicably,acoustical,watling,inquired,tiempo,multiracial,parallelism,trenchard,tokyopop,germanium,usisl,philharmonia,shapur,jacobites,latinized,sophocles,remittances,o'farrell,adder,dimitrios,peshwa,dimitar,orlov,outstretched,musume,satish,dimensionless,serialised,baptisms,pagasa,antiviral,1740s,quine,arapaho,bombardments,stratosphere,ophthalmic,injunctions,carbonated,nonviolence,asante,creoles,sybra,boilermakers,abington,bipartite,permissive,cardinality,anheuser,carcinogenic,hohenlohe,surinam,szeged,infanticide,generically,floorball,'white,automakers,cerebellar,homozygous,remoteness,effortlessly,allude,'great,headmasters,minting,manchurian,kinabalu,wemyss,seditious,widgets,marbled,almshouses,bards,subgenres,tetsuya,faulting,kickboxer,gaulish,hoseyn,malton,fluvial,questionnaires,mondale,downplayed,traditionalists,vercelli,sumatran,landfills,gamesradar,exerts,franciszek,unlawfully,huesca,diderot,libertarians,professorial,laane,piecemeal,conidae,taiji,curatorial,perturbations,abstractions,szlachta,watercraft,mullah,zoroastrianism,segmental,khabarovsk,rectors,affordability,scuola,diffused,stena,cyclonic,workpiece,romford,'little,jhansi,stalag,zhongshan,skipton,maracaibo,bernadotte,thanet,groening,waterville,encloses,sahrawi,nuffield,moorings,chantry,annenberg,islay,marchers,tenses,wahid,siegen,furstenberg,basques,resuscitation,seminarians,tympanum,gentiles,vegetarianism,tufted,venkata,fantastical,pterophoridae,machined,superposition,glabrous,kaveri,chicane,executors,phyllonorycter,bidirectional,jasta,undertones,touristic,majapahit,navratilova,unpopularity,barbadian,tinian,webcast,hurdler,rigidly,jarrah,staphylococcus,igniting,irrawaddy,stabilised,airstrike,ragas,wakayama,energetically,ekstraklasa,minibus,largemouth,cultivators,leveraging,waitangi,carnaval,weaves,turntables,heydrich,sextus,excavate,govind,ignaz,pedagogue,uriah,borrowings,gemstones,infractions,mycobacterium,batavian,massing,praetor,subalpine,massoud,passers,geostationary,jalil,trainsets,barbus,impair,budejovice,denbigh,pertain,historicity,fortaleza,nederlandse,lamenting,masterchef,doubs,gemara,conductance,ploiesti,cetaceans,courthouses,bhagavad,mihailovic,occlusion,bremerhaven,bulwark,morava,kaine,drapery,maputo,conquistador,kaduna,famagusta,first-past-the-post,erudite,galton,undated,tangential,filho,dismembered,dashes,criterium,darwen,metabolized,blurring,everard,randwick,mohave,impurity,acuity,ansbach,chievo,surcharge,plantain,algoma,porosity,zirconium,selva,sevenoaks,venizelos,gwynne,golgi,imparting,separatism,courtesan,idiopathic,gravestones,hydroelectricity,babar,orford,purposeful,acutely,shard,ridgewood,viterbo,manohar,expropriation,placenames,brevis,cosine,unranked,richfield,newnham,recoverable,flightless,dispersing,clearfield,abu'l,stranraer,kempe,streamlining,goswami,epidermal,pieta,conciliatory,distilleries,electrophoresis,bonne,tiago,curiosities,candidature,picnicking,perihelion,lintel,povoa,gullies,configure,excision,facies,signers,1730s,insufficiency,semiotics,streatham,deactivation,entomological,skippers,albacete,parodying,escherichia,honorees,singaporeans,counterterrorism,tiruchirappalli,omnivorous,metropole,globalisation,athol,unbounded,codice_5,landforms,classifier,farmhouses,reaffirming,reparation,yomiuri,technologists,mitte,medica,viewable,steampunk,konya,kshatriya,repelling,edgewater,lamiinae,devas,potteries,llandaff,engendered,submits,virulence,uplifted,educationist,metropolitans,frontrunner,dunstable,forecastle,frets,methodius,exmouth,linnean,bouchet,repulsion,computable,equalling,liceo,tephritidae,agave,hydrological,azarenka,fairground,l'homme,enforces,xinhua,cinematographers,cooperstown,sa'id,paiute,christianization,tempos,chippenham,insulator,kotor,stereotyped,dello,cours,hisham,d'souza,eliminations,supercars,passau,rebrand,natures,coote,persephone,rededicated,cleaved,plenum,blistering,indiscriminately,cleese,safed,recursively,compacted,revues,hydration,shillong,echelons,garhwal,pedimented,grower,zwolle,wildflower,annexing,methionine,petah,valens,famitsu,petiole,specialities,nestorian,shahin,tokaido,shearwater,barberini,kinsmen,experimenter,alumnae,cloisters,alumina,pritzker,hardiness,soundgarden,julich,ps300,watercourse,cementing,wordplay,olivet,demesne,chasseurs,amide,zapotec,gaozu,porphyry,absorbers,indium,analogies,devotions,engravers,limestones,catapulted,surry,brickworks,gotra,rodham,landline,paleontologists,shankara,islip,raucous,trollope,arpad,embarkation,morphemes,recites,picardie,nakhchivan,tolerances,formula_47,khorramabad,nichiren,adrianople,kirkuk,assemblages,collider,bikaner,bushfires,roofline,coverings,reredos,bibliotheca,mantras,accentuated,commedia,rashtriya,fluctuation,serhiy,referential,fittipaldi,vesicle,geeta,iraklis,immediacy,chulalongkorn,hunsruck,bingen,dreadnoughts,stonemason,meenakshi,lebesgue,undergrowth,baltistan,paradoxes,parlement,articled,tiflis,dixieland,meriden,tejano,underdogs,barnstable,exemplify,venter,tropes,wielka,kankakee,iskandar,zilina,pharyngeal,spotify,materialised,picts,atlantique,theodoric,prepositions,paramilitaries,pinellas,attlee,actuated,piedmontese,grayling,thucydides,multifaceted,unedited,autonomously,universelle,utricularia,mooted,preto,incubated,underlie,brasenose,nootka,bushland,sensu,benzodiazepine,esteghlal,seagoing,amenhotep,azusa,sappers,culpeper,smokeless,thoroughbreds,dargah,gorda,alumna,mankato,zdroj,deleting,culvert,formula_49,punting,wushu,hindering,immunoglobulin,standardisation,birger,oilfield,quadrangular,ulama,recruiters,netanya,1630s,communaute,istituto,maciej,pathan,meher,vikas,characterizations,playmaker,interagency,intercepts,assembles,horthy,introspection,narada,matra,testes,radnicki,estonians,csiro,instar,mitford,adrenergic,crewmembers,haaretz,wasatch,lisburn,rangefinder,ordre,condensate,reforestation,corregidor,spvgg,modulator,mannerist,faulted,aspires,maktoum,squarepants,aethelred,piezoelectric,mulatto,dacre,progressions,jagiellonian,norge,samaria,sukhoi,effingham,coxless,hermetic,humanists,centrality,litters,stirlingshire,beaconsfield,sundanese,geometrically,caretakers,habitually,bandra,pashtuns,bradenton,arequipa,laminar,brickyard,hitchin,sustains,shipboard,ploughing,trechus,wheelers,bracketed,ilyushin,subotica,d'hondt,reappearance,bridgestone,intermarried,fulfilment,aphasia,birkbeck,transformational,strathmore,hornbill,millstone,lacan,voids,solothurn,gymnasiums,laconia,viaducts,peduncle,teachta,edgware,shinty,supernovae,wilfried,exclaim,parthia,mithun,flashpoint,moksha,cumbia,metternich,avalanches,militancy,motorist,rivadavia,chancellorsville,federals,gendered,bounding,footy,gauri,caliphs,lingam,watchmaker,unrecorded,riverina,unmodified,seafloor,droit,pfalz,chrysostom,gigabit,overlordship,besiege,espn2,oswestry,anachronistic,ballymena,reactivation,duchovny,ghani,abacetus,duller,legio,watercourses,nord-pas-de-calais,leiber,optometry,swarms,installer,sancti,adverbs,iheartmedia,meiningen,zeljko,kakheti,notional,circuses,patrilineal,acrobatics,infrastructural,sheva,oregonian,adjudication,aamir,wloclawek,overfishing,obstructive,subtracting,aurobindo,archeologist,newgate,'cause,secularization,tehsils,abscess,fingal,janacek,elkhorn,trims,kraftwerk,mandating,irregulars,faintly,congregationalist,sveti,kasai,mishaps,kennebec,provincially,durkheim,scotties,aicte,rapperswil,imphal,surrenders,morphs,nineveh,hoxha,cotabato,thuringian,metalworking,retold,shogakukan,anthers,proteasome,tippeligaen,disengagement,mockumentary,palatial,erupts,flume,corrientes,masthead,jaroslaw,rereleased,bharti,labors,distilling,tusks,varzim,refounded,enniskillen,melkite,semifinalists,vadodara,bermudian,capstone,grasse,origination,populus,alesi,arrondissements,semigroup,verein,opossum,messrs.,portadown,bulbul,tirupati,mulhouse,tetrahedron,roethlisberger,nonverbal,connexion,warangal,deprecated,gneiss,octet,vukovar,hesketh,chambre,despatch,claes,kargil,hideo,gravelly,tyndale,aquileia,tuners,defensible,tutte,theotokos,constructivist,ouvrage,dukla,polisario,monasticism,proscribed,commutation,testers,nipissing,codon,mesto,olivine,concomitant,exoskeleton,purports,coromandel,eyalet,dissension,hippocrates,purebred,yaounde,composting,oecophoridae,procopius,o'day,angiogenesis,sheerness,intelligencer,articular,felixstowe,aegon,endocrinology,trabzon,licinius,pagodas,zooplankton,hooghly,satie,drifters,sarthe,mercian,neuilly,tumours,canal+,scheldt,inclinations,counteroffensive,roadrunners,tuzla,shoreditch,surigao,predicates,carnot,algeciras,militaries,generalize,bulkheads,gawler,pollutant,celta,rundgren,microrna,gewog,olimpija,placental,lubelski,roxburgh,discerned,verano,kikuchi,musicale,l'enfant,ferocity,dimorphic,antigonus,erzurum,prebendary,recitative,discworld,cyrenaica,stigmella,totnes,sutta,pachuca,ulsan,downton,landshut,castellan,pleural,siedlce,siecle,catamaran,cottbus,utilises,trophic,freeholders,holyhead,u.s.s,chansons,responder,waziristan,suzuka,birding,shogi,asker,acetone,beautification,cytotoxic,dixit,hunterdon,cobblestone,formula_48,kossuth,devizes,sokoto,interlaced,shuttered,kilowatts,assiniboine,isaak,salto,alderney,sugarloaf,franchising,aggressiveness,toponyms,plaintext,antimatter,henin,equidistant,salivary,bilingualism,mountings,obligate,extirpated,irenaeus,misused,pastoralists,aftab,immigrating,warping,tyrolean,seaforth,teesside,soundwave,oligarchy,stelae,pairwise,iupac,tezuka,posht,orchestrations,landmass,ironstone,gallia,hjalmar,carmelites,strafford,elmhurst,palladio,fragility,teleplay,gruffudd,karoly,yerba,potok,espoo,inductance,macaque,nonprofits,pareto,rock'n'roll,spiritualist,shadowed,skateboarder,utterances,generality,congruence,prostrate,deterred,yellowknife,albarn,maldon,battlements,mohsen,insecticides,khulna,avellino,menstruation,glutathione,springdale,parlophone,confraternity,korps,countrywide,bosphorus,preexisting,damodar,astride,alexandrovich,sprinting,crystallized,botev,leaching,interstates,veers,angevin,undaunted,yevgeni,nishapur,northerners,alkmaar,bethnal,grocers,sepia,tornus,exemplar,trobe,charcot,gyeonggi,larne,tournai,lorain,voided,genji,enactments,maxilla,adiabatic,eifel,nazim,transducer,thelonious,pyrite,deportiva,dialectal,bengt,rosettes,labem,sergeyevich,synoptic,conservator,statuette,biweekly,adhesives,bifurcation,rajapaksa,mammootty,republique,yusef,waseda,marshfield,yekaterinburg,minnelli,fundy,fenian,matchups,dungannon,supremacist,panelled,drenthe,iyengar,fibula,narmada,homeport,oceanside,precept,antibacterial,altarpieces,swath,ospreys,lillooet,legnica,lossless,formula_50,galvatron,iorga,stormont,rsfsr,loggers,kutno,phenomenological,medallists,cuatro,soissons,homeopathy,bituminous,injures,syndicates,typesetting,displacements,dethroned,makassar,lucchese,abergavenny,targu,alborz,akb48,boldface,gastronomy,sacra,amenity,accumulator,myrtaceae,cornices,mourinho,denunciation,oxbow,diddley,aargau,arbitrage,bedchamber,gruffydd,zamindar,klagenfurt,caernarfon,slowdown,stansted,abrasion,tamaki,suetonius,dukakis,individualistic,ventrally,hotham,perestroika,ketones,fertilisation,sobriquet,couplings,renderings,misidentified,rundfunk,sarcastically,braniff,concours,dismissals,elegantly,modifiers,crediting,combos,crucially,seafront,lieut,ischemia,manchus,derivations,proteases,aristophanes,adenauer,porting,hezekiah,sante,trulli,hornblower,foreshadowing,ypsilanti,dharwad,khani,hohenstaufen,distillers,cosmodrome,intracranial,turki,salesian,gorzow,jihlava,yushchenko,leichhardt,venables,cassia,eurogamer,airtel,curative,bestsellers,timeform,sortied,grandview,massillon,ceding,pilbara,chillicothe,heredity,elblag,rogaland,ronne,millennial,batley,overuse,bharata,fille,campbelltown,abeyance,counterclockwise,250cc,neurodegenerative,consigned,electromagnetism,sunnah,saheb,exons,coxswain,gleaned,bassoons,worksop,prismatic,immigrate,pickets,takeo,bobsledder,stosur,fujimori,merchantmen,stiftung,forli,endorses,taskforce,thermally,atman,gurps,floodplains,enthalpy,extrinsic,setubal,kennesaw,grandis,scalability,durations,showrooms,prithvi,outro,overruns,andalucia,amanita,abitur,hipper,mozambican,sustainment,arsene,chesham,palaeolithic,reportage,criminality,knowsley,haploid,atacama,shueisha,ridgefield,astern,getafe,lineal,timorese,restyled,hollies,agincourt,unter,justly,tannins,mataram,industrialised,tarnovo,mumtaz,mustapha,stretton,synthetase,condita,allround,putra,stjepan,troughs,aechmea,specialisation,wearable,kadokawa,uralic,aeros,messiaen,existentialism,jeweller,effigies,gametes,fjordane,cochlear,interdependent,demonstrative,unstructured,emplacement,famines,spindles,amplitudes,actuator,tantalum,psilocybe,apnea,monogatari,expulsions,seleucus,tsuen,hospitaller,kronstadt,eclipsing,olympiakos,clann,canadensis,inverter,helio,egyptologist,squamous,resonate,munir,histology,torbay,khans,jcpenney,veterinarians,aintree,microscopes,colonised,reflectors,phosphorylated,pristimantis,tulare,corvinus,multiplexing,midweek,demosthenes,transjordan,ecija,tengku,vlachs,anamorphic,counterweight,radnor,trinitarian,armidale,maugham,njsiaa,futurism,stairways,avicenna,montebello,bridgetown,wenatchee,lyonnais,amass,surinamese,streptococcus,m*a*s*h,hydrogenation,frazioni,proscenium,kalat,pennsylvanian,huracan,tallying,kralove,nucleolar,phrygian,seaports,hyacinthe,ignace,donning,instalment,regnal,fonds,prawn,carell,folktales,goaltending,bracknell,vmware,patriarchy,mitsui,kragujevac,pythagoras,soult,thapa,disproved,suwalki,secures,somoza,l'ecole,divizia,chroma,herders,technologist,deduces,maasai,rampur,paraphrase,raimi,imaged,magsaysay,ivano,turmeric,formula_51,subcommittees,axillary,ionosphere,organically,indented,refurbishing,pequot,violinists,bearn,colle,contralto,silverton,mechanization,etruscans,wittelsbach,pasir,redshirted,marrakesh,scarp,plein,wafers,qareh,teotihuacan,frobenius,sinensis,rehoboth,bundaberg,newbridge,hydrodynamic,traore,abubakar,adjusts,storytellers,dynamos,verbandsliga,concertmaster,exxonmobil,appreciable,sieradz,marchioness,chaplaincy,rechristened,cunxu,overpopulation,apolitical,sequencer,beaked,nemanja,binaries,intendant,absorber,filamentous,indebtedness,nusra,nashik,reprises,psychedelia,abwehr,ligurian,isoform,resistive,pillaging,mahathir,reformatory,lusatia,allerton,ajaccio,tepals,maturin,njcaa,abyssinian,objector,fissures,sinuous,ecclesiastic,dalits,caching,deckers,phosphates,wurlitzer,navigated,trofeo,berea,purefoods,solway,unlockable,grammys,kostroma,vocalizations,basilan,rebuke,abbasi,douala,helsingborg,ambon,bakar,runestones,cenel,tomislav,pigmented,northgate,excised,seconda,kirke,determinations,dedicates,vilas,pueblos,reversion,unexploded,overprinted,ekiti,deauville,masato,anaesthesia,endoplasmic,transponders,aguascalientes,hindley,celluloid,affording,bayeux,piaget,rickshaws,eishockey,camarines,zamalek,undersides,hardwoods,hermitian,mutinied,monotone,blackmails,affixes,jpmorgan,habermas,mitrovica,paleontological,polystyrene,thana,manas,conformist,turbofan,decomposes,logano,castration,metamorphoses,patroness,herbicide,mikolaj,rapprochement,macroeconomics,barranquilla,matsudaira,lintels,femina,hijab,spotsylvania,morpheme,bitola,baluchistan,kurukshetra,otway,extrusion,waukesha,menswear,helder,trung,bingley,protester,boars,overhang,differentials,exarchate,hejaz,kumara,unjustified,timings,sharpness,nuovo,taisho,sundar,etc..,jehan,unquestionably,muscovy,daltrey,canute,paneled,amedeo,metroplex,elaborates,telus,tetrapods,dragonflies,epithets,saffir,parthenon,lucrezia,refitting,pentateuch,hanshin,montparnasse,lumberjacks,sanhedrin,erectile,odors,greenstone,resurgent,leszek,amory,substituents,prototypical,viewfinder,monck,universiteit,joffre,revives,chatillon,seedling,scherzo,manukau,ashdod,gympie,homolog,stalwarts,ruinous,weibo,tochigi,wallenberg,gayatri,munda,satyagraha,storefronts,heterogeneity,tollway,sportswriters,binocular,gendarmes,ladysmith,tikal,ortsgemeinde,ja'far,osmotic,linlithgow,bramley,telecoms,pugin,repose,rupaul,sieur,meniscus,garmisch,reintroduce,400th,shoten,poniatowski,drome,kazakhstani,changeover,astronautics,husserl,herzl,hypertext,katakana,polybius,antananarivo,seong,breguet,reliquary,utada,aggregating,liangshan,sivan,tonawanda,audiobooks,shankill,coulee,phenolic,brockton,bookmakers,handsets,boaters,wylde,commonality,mappings,silhouettes,pennines,maurya,pratchett,singularities,eschewed,pretensions,vitreous,ibero,totalitarianism,poulenc,lingered,directx,seasoning,deputation,interdict,illyria,feedstock,counterbalance,muzik,buganda,parachuted,violist,homogeneity,comix,fjords,corsairs,punted,verandahs,equilateral,laoghaire,magyars,117th,alesund,televoting,mayotte,eateries,refurbish,nswrl,yukio,caragiale,zetas,dispel,codecs,inoperable,outperformed,rejuvenation,elstree,modernise,contributory,pictou,tewkesbury,chechens,ashina,psionic,refutation,medico,overdubbed,nebulae,sandefjord,personages,eccellenza,businessperson,placename,abenaki,perryville,threshing,reshaped,arecibo,burslem,colspan=3|turnout,rebadged,lumia,erinsborough,interactivity,bitmap,indefatigable,theosophy,excitatory,gleizes,edsel,bermondsey,korce,saarinen,wazir,diyarbakir,cofounder,liberalisation,onsen,nighthawks,siting,retirements,semyon,d'histoire,114th,redditch,venetia,praha,'round,valdosta,hieroglyphic,postmedial,edirne,miscellany,savona,cockpits,minimization,coupler,jacksonian,appeasement,argentines,saurashtra,arkwright,hesiod,folios,fitzalan,publica,rivaled,civitas,beermen,constructivism,ribeira,zeitschrift,solanum,todos,deformities,chilliwack,verdean,meagre,bishoprics,gujrat,yangzhou,reentered,inboard,mythologies,virtus,unsurprisingly,rusticated,museu,symbolise,proportionate,thesaban,symbian,aeneid,mitotic,veliki,compressive,cisterns,abies,winemaker,massenet,bertolt,ahmednagar,triplemania,armorial,administracion,tenures,smokehouse,hashtag,fuerza,regattas,gennady,kanazawa,mahmudabad,crustal,asaph,valentinian,ilaiyaraaja,honeyeater,trapezoidal,cooperatively,unambiguously,mastodon,inhospitable,harnesses,riverton,renewables,djurgardens,haitians,airings,humanoids,boatswain,shijiazhuang,faints,veera,punjabis,steepest,narain,karlovy,serre,sulcus,collectives,1500m,arion,subarctic,liberally,apollonius,ostia,droplet,headstones,norra,robusta,maquis,veronese,imola,primers,luminance,escadrille,mizuki,irreconcilable,stalybridge,temur,paraffin,stuccoed,parthians,counsels,fundamentalists,vivendi,polymath,sugababes,mikko,yonne,fermions,vestfold,pastoralist,kigali,unseeded,glarus,cusps,amasya,northwesterly,minorca,astragalus,verney,trevelyan,antipathy,wollstonecraft,bivalves,boulez,royle,divisao,quranic,bareilly,coronal,deviates,lulea,erectus,petronas,chandan,proxies,aeroflot,postsynaptic,memoriam,moyne,gounod,kuznetsova,pallava,ordinating,reigate,'first,lewisburg,exploitative,danby,academica,bailiwick,brahe,injective,stipulations,aeschylus,computes,gulden,hydroxylase,liveries,somalis,underpinnings,muscovite,kongsberg,domus,overlain,shareware,variegated,jalalabad,agence,ciphertext,insectivores,dengeki,menuhin,cladistic,baerum,betrothal,tokushima,wavelet,expansionist,pottsville,siyuan,prerequisites,carpi,nemzeti,nazar,trialled,eliminator,irrorated,homeward,redwoods,undeterred,strayed,lutyens,multicellular,aurelian,notated,lordships,alsatian,idents,foggia,garros,chalukyas,lillestrom,podlaski,pessimism,hsien,demilitarized,whitewashed,willesden,kirkcaldy,sanctorum,lamia,relaying,escondido,paediatric,contemplates,demarcated,bluestone,betula,penarol,capitalise,kreuznach,kenora,115th,hold'em,reichswehr,vaucluse,m.i.a,windings,boys/girls,cajon,hisar,predictably,flemington,ysgol,mimicked,clivina,grahamstown,ionia,glyndebourne,patrese,aquaria,sleaford,dayal,sportscenter,malappuram,m.b.a.,manoa,carbines,solvable,designator,ramanujan,linearity,academicians,sayid,lancastrian,factorial,strindberg,vashem,delos,comyn,condensing,superdome,merited,kabaddi,intransitive,bideford,neuroimaging,duopoly,scorecards,ziggler,heriot,boyars,virology,marblehead,microtubules,westphalian,anticipates,hingham,searchers,harpist,rapides,morricone,convalescent,mises,nitride,metrorail,matterhorn,bicol,drivetrain,marketer,snippet,winemakers,muban,scavengers,halberstadt,herkimer,peten,laborious,stora,montgomeryshire,booklist,shamir,herault,eurostar,anhydrous,spacewalk,ecclesia,calliostoma,highschool,d'oro,suffusion,imparts,overlords,tagus,rectifier,counterinsurgency,ministered,eilean,milecastle,contre,micromollusk,okhotsk,bartoli,matroid,hasidim,thirunal,terme,tarlac,lashkar,presque,thameslink,flyby,troopship,renouncing,fatih,messrs,vexillum,bagration,magnetite,bornholm,androgynous,vehement,tourette,philosophic,gianfranco,tuileries,codice_6,radially,flexion,hants,reprocessing,setae,burne,palaeographically,infantryman,shorebirds,tamarind,moderna,threading,militaristic,crohn,norrkoping,125cc,stadtholder,troms,klezmer,alphanumeric,brome,emmanuelle,tiwari,alchemical,formula_52,onassis,bleriot,bipedal,colourless,hermeneutics,hosni,precipitating,turnstiles,hallucinogenic,panhellenic,wyandotte,elucidated,chita,ehime,generalised,hydrophilic,biota,niobium,rnzaf,gandhara,longueuil,logics,sheeting,bielsko,cuvier,kagyu,trefoil,docent,pancrase,stalinism,postures,encephalopathy,monckton,imbalances,epochs,leaguers,anzio,diminishes,pataki,nitrite,amuro,nabil,maybach,l'aquila,babbler,bacolod,thutmose,evora,gaudi,breakage,recur,preservative,60deg,mendip,functionaries,columnar,maccabiah,chert,verden,bromsgrove,clijsters,dengue,pastorate,phuoc,principia,viareggio,kharagpur,scharnhorst,anyang,bosons,l'art,criticises,ennio,semarang,brownian,mirabilis,asperger,calibers,typographical,cartooning,minos,disembark,supranational,undescribed,etymologically,alappuzha,vilhelm,lanao,pakenham,bhagavata,rakoczi,clearings,astrologers,manitowoc,bunuel,acetylene,scheduler,defamatory,trabzonspor,leaded,scioto,pentathlete,abrahamic,minigames,aldehydes,peerages,legionary,1640s,masterworks,loudness,bryansk,likeable,genocidal,vegetated,towpath,declination,pyrrhus,divinely,vocations,rosebery,associazione,loaders,biswas,oeste,tilings,xianzong,bhojpuri,annuities,relatedness,idolator,psers,constriction,chuvash,choristers,hanafi,fielders,grammarian,orpheum,asylums,millbrook,gyatso,geldof,stabilise,tableaux,diarist,kalahari,panini,cowdenbeath,melanin,4x100m,resonances,pinar,atherosclerosis,sheringham,castlereagh,aoyama,larks,pantograph,protrude,natak,gustafsson,moribund,cerevisiae,cleanly,polymeric,holkar,cosmonauts,underpinning,lithosphere,firuzabad,languished,mingled,citrate,spadina,lavas,daejeon,fibrillation,porgy,pineville,ps1000,cobbled,emamzadeh,mukhtar,dampers,indelible,salonika,nanoscale,treblinka,eilat,purporting,fluctuate,mesic,hagiography,cutscenes,fondation,barrens,comically,accrue,ibrox,makerere,defections,'there,hollandia,skene,grosseto,reddit,objectors,inoculation,rowdies,playfair,calligrapher,namor,sibenik,abbottabad,propellants,hydraulically,chloroplasts,tablelands,tecnico,schist,klasse,shirvan,bashkortostan,bullfighting,north/south,polski,hanns,woodblock,kilmore,ejecta,ignacy,nanchang,danubian,commendations,snohomish,samaritans,argumentation,vasconcelos,hedgehogs,vajrayana,barents,kulkarni,kumbakonam,identifications,hillingdon,weirs,nayanar,beauvoir,messe,divisors,atlantiques,broods,affluence,tegucigalpa,unsuited,autodesk,akash,princeps,culprits,kingstown,unassuming,goole,visayan,asceticism,blagojevich,irises,paphos,unsound,maurier,pontchartrain,desertification,sinfonietta,latins,especial,limpet,valerenga,glial,brainstem,mitral,parables,sauropod,judean,iskcon,sarcoma,venlo,justifications,zhuhai,blavatsky,alleviated,usafe,steppenwolf,inversions,janko,chagall,secretory,basildon,saguenay,pergamon,hemispherical,harmonized,reloading,franjo,domaine,extravagance,relativism,metamorphosed,labuan,baloncesto,gmail,byproducts,calvinists,counterattacked,vitus,bubonic,120th,strachey,ritually,brookwood,selectable,savinja,incontinence,meltwater,jinja,1720s,brahmi,morgenthau,sheaves,sleeved,stratovolcano,wielki,utilisation,avoca,fluxus,panzergrenadier,philately,deflation,podlaska,prerogatives,kuroda,theophile,zhongzong,gascoyne,magus,takao,arundell,fylde,merdeka,prithviraj,venkateswara,liepaja,daigo,dreamland,reflux,sunnyvale,coalfields,seacrest,soldering,flexor,structuralism,alnwick,outweighed,unaired,mangeshkar,batons,glaad,banshees,irradiated,organelles,biathlete,cabling,chairlift,lollapalooza,newsnight,capacitive,succumbs,flatly,miramichi,burwood,comedienne,charteris,biotic,workspace,aficionados,sokolka,chatelet,o'shaughnessy,prosthesis,neoliberal,refloated,oppland,hatchlings,econometrics,loess,thieu,androids,appalachians,jenin,pterostichinae,downsized,foils,chipsets,stencil,danza,narrate,maginot,yemenite,bisects,crustacean,prescriptive,melodious,alleviation,empowers,hansson,autodromo,obasanjo,osmosis,daugava,rheumatism,moraes,leucine,etymologies,chepstow,delaunay,bramall,bajaj,flavoring,approximates,marsupials,incisive,microcomputer,tactically,waals,wilno,fisichella,ursus,hindmarsh,mazarin,lomza,xenophobia,lawlessness,annecy,wingers,gornja,gnaeus,superieur,tlaxcala,clasps,symbolises,slats,rightist,effector,blighted,permanence,divan,progenitors,kunsthalle,anointing,excelling,coenzyme,indoctrination,dnipro,landholdings,adriaan,liturgies,cartan,ethmia,attributions,sanctus,trichy,chronicon,tancred,affinis,kampuchea,gantry,pontypool,membered,distrusted,fissile,dairies,hyposmocoma,craigie,adarsh,martinsburg,taxiway,30deg,geraint,vellum,bencher,khatami,formula_53,zemun,teruel,endeavored,palmares,pavements,u.s..,internationalization,satirized,carers,attainable,wraparound,muang,parkersburg,extinctions,birkenfeld,wildstorm,payers,cohabitation,unitas,culloden,capitalizing,clwyd,daoist,campinas,emmylou,orchidaceae,halakha,orientales,fealty,domnall,chiefdom,nigerians,ladislav,dniester,avowed,ergonomics,newsmagazine,kitsch,cantilevered,benchmarking,remarriage,alekhine,coldfield,taupo,almirante,substations,apprenticeships,seljuq,levelling,eponym,symbolising,salyut,opioids,underscore,ethnologue,mohegan,marikina,libro,bassano,parse,semantically,disjointed,dugdale,padraig,tulsi,modulating,xfinity,headlands,mstislav,earthworms,bourchier,lgbtq,embellishments,pennants,rowntree,betel,motet,mulla,catenary,washoe,mordaunt,dorking,colmar,girardeau,glentoran,grammatically,samad,recreations,technion,staccato,mikoyan,spoilers,lyndhurst,victimization,chertsey,belafonte,tondo,tonsberg,narrators,subcultures,malformations,edina,augmenting,attests,euphemia,cabriolet,disguising,1650s,navarrese,demoralized,cardiomyopathy,welwyn,wallachian,smoothness,planktonic,voles,issuers,sardasht,survivability,cuauhtemoc,thetis,extruded,signet,raghavan,lombok,eliyahu,crankcase,dissonant,stolberg,trencin,desktops,bursary,collectivization,charlottenburg,triathlete,curvilinear,involuntarily,mired,wausau,invades,sundaram,deletions,bootstrap,abellio,axiomatic,noguchi,setups,malawian,visalia,materialist,kartuzy,wenzong,plotline,yeshivas,parganas,tunica,citric,conspecific,idlib,superlative,reoccupied,blagoevgrad,masterton,immunological,hatta,courbet,vortices,swallowtail,delves,haridwar,diptera,boneh,bahawalpur,angering,mardin,equipments,deployable,guanine,normality,rimmed,artisanal,boxset,chandrasekhar,jools,chenar,tanakh,carcassonne,belatedly,millville,anorthosis,reintegration,velde,surfactant,kanaan,busoni,glyphipterix,personas,fullness,rheims,tisza,stabilizers,bharathi,joost,spinola,mouldings,perching,esztergom,afzal,apostate,lustre,s.league,motorboat,monotheistic,armature,barat,asistencia,bloomsburg,hippocampal,fictionalised,defaults,broch,hexadecimal,lusignan,ryanair,boccaccio,breisgau,southbank,bskyb,adjoined,neurobiology,aforesaid,sadhu,langue,headship,wozniacki,hangings,regulus,prioritized,dynamism,allier,hannity,shimin,antoninus,gymnopilus,caledon,preponderance,melayu,electrodynamics,syncopated,ibises,krosno,mechanistic,morpeth,harbored,albini,monotheism,'real,hyperactivity,haveli,writer/director,minato,nimoy,caerphilly,chitral,amirabad,fanshawe,l'oreal,lorde,mukti,authoritarianism,valuing,spyware,hanbury,restarting,stato,embed,suiza,empiricism,stabilisation,stari,castlemaine,orbis,manufactory,mauritanian,shoji,taoyuan,prokaryotes,oromia,ambiguities,embodying,slims,frente,innovate,ojibwa,powdery,gaeltacht,argentinos,quatermass,detergents,fijians,adaptor,tokai,chileans,bulgars,oxidoreductases,bezirksliga,conceicao,myosin,nellore,500cc,supercomputers,approximating,glyndwr,polypropylene,haugesund,cockerell,tudman,ashbourne,hindemith,bloodlines,rigveda,etruria,romanos,steyn,oradea,deceleration,manhunter,laryngeal,fraudulently,janez,wendover,haplotype,janaki,naoki,belizean,mellencamp,cartographic,sadhana,tricolour,pseudoscience,satara,bytow,s.p.a.,jagdgeschwader,arcot,omagh,sverdrup,masterplan,surtees,apocrypha,ahvaz,d'amato,socratic,leumit,unnumbered,nandini,witold,marsupial,coalesced,interpolated,gimnasia,karadzic,keratin,mamoru,aldeburgh,speculator,escapement,irfan,kashyap,satyajit,haddington,solver,rothko,ashkelon,kickapoo,yeomen,superbly,bloodiest,greenlandic,lithic,autofocus,yardbirds,poona,keble,javan,sufis,expandable,tumblr,ursuline,swimwear,winwood,counsellors,aberrations,marginalised,befriending,workouts,predestination,varietal,siddhartha,dunkeld,judaic,esquimalt,shabab,ajith,telefonica,stargard,hoysala,radhakrishnan,sinusoidal,strada,hiragana,cebuano,monoid,independencia,floodwaters,mildura,mudflats,ottokar,translit,radix,wigner,philosophically,tephritid,synthesizing,castletown,installs,stirner,resettle,bushfire,choirmaster,kabbalistic,shirazi,lightship,rebus,colonizers,centrifuge,leonean,kristofferson,thymus,clackamas,ratnam,rothesay,municipally,centralia,thurrock,gulfport,bilinear,desirability,merite,psoriasis,macaw,erigeron,consignment,mudstone,distorting,karlheinz,ramen,tailwheel,vitor,reinsurance,edifices,superannuation,dormancy,contagion,cobden,rendezvoused,prokaryotic,deliberative,patricians,feigned,degrades,starlings,sopot,viticultural,beaverton,overflowed,convener,garlands,michiel,ternopil,naturelle,biplanes,bagot,gamespy,ventspils,disembodied,flattening,profesional,londoners,arusha,scapular,forestall,pyridine,ulema,eurodance,aruna,callus,periodontal,coetzee,immobilized,o'meara,maharani,katipunan,reactants,zainab,microgravity,saintes,britpop,carrefour,constrain,adversarial,firebirds,brahmo,kashima,simca,surety,surpluses,superconductivity,gipuzkoa,cumans,tocantins,obtainable,humberside,roosting,'king,formula_54,minelayer,bessel,sulayman,cycled,biomarkers,annealing,shusha,barda,cassation,djing,polemics,tuple,directorates,indomitable,obsolescence,wilhelmine,pembina,bojan,tambo,dioecious,pensioner,magnificat,1660s,estrellas,southeasterly,immunodeficiency,railhead,surreptitiously,codeine,encores,religiosity,tempera,camberley,efendi,boardings,malleable,hagia,input/output,lucasfilm,ujjain,polymorphisms,creationist,berners,mickiewicz,irvington,linkedin,endures,kinect,munition,apologetics,fairlie,predicated,reprinting,ethnographer,variances,levantine,mariinsky,jadid,jarrow,asia/oceania,trinamool,waveforms,bisexuality,preselection,pupae,buckethead,hieroglyph,lyricists,marionette,dunbartonshire,restorer,monarchical,pazar,kickoffs,cabildo,savannas,gliese,dench,spoonbills,novelette,diliman,hypersensitivity,authorising,montefiore,mladen,qu'appelle,theistic,maruti,laterite,conestoga,saare,californica,proboscis,carrickfergus,imprecise,hadassah,baghdadi,jolgeh,deshmukh,amusements,heliopolis,berle,adaptability,partenkirchen,separations,baikonur,cardamom,southeastward,southfield,muzaffar,adequacy,metropolitana,rajkot,kiyoshi,metrobus,evictions,reconciles,librarianship,upsurge,knightley,badakhshan,proliferated,spirituals,burghley,electroacoustic,professing,featurette,reformists,skylab,descriptors,oddity,greyfriars,injects,salmond,lanzhou,dauntless,subgenera,underpowered,transpose,mahinda,gatos,aerobatics,seaworld,blocs,waratahs,joris,giggs,perfusion,koszalin,mieczyslaw,ayyubid,ecologists,modernists,sant'angelo,quicktime,him/her,staves,sanyo,melaka,acrocercops,qigong,iterated,generalizes,recuperation,vihara,circassians,psychical,chavo,memoires,infiltrates,notaries,pelecaniformesfamily,strident,chivalric,pierrepont,alleviating,broadsides,centipede,b.tech,reinterpreted,sudetenland,hussite,covenanters,radhika,ironclads,gainsbourg,testis,penarth,plantar,azadegan,beano,espn.com,leominster,autobiographies,nbcuniversal,eliade,khamenei,montferrat,undistinguished,ethnological,wenlock,fricatives,polymorphic,biome,joule,sheaths,astrophysicist,salve,neoclassicism,lovat,downwind,belisarius,forma,usurpation,freie,depopulation,backbench,ascenso,'high,aagpbl,gdanski,zalman,mouvement,encapsulation,bolshevism,statny,voyageurs,hywel,vizcaya,mazra'eh,narthex,azerbaijanis,cerebrospinal,mauretania,fantail,clearinghouse,bolingbroke,pequeno,ansett,remixing,microtubule,wrens,jawahar,palembang,gambian,hillsong,fingerboard,repurposed,sundry,incipient,veolia,theologically,ulaanbaatar,atsushi,foundling,resistivity,myeloma,factbook,mazowiecka,diacritic,urumqi,clontarf,provokes,intelsat,professes,materialise,portobello,benedictines,panionios,introverted,reacquired,bridport,mammary,kripke,oratorios,vlore,stoning,woredas,unreported,antti,togolese,fanzines,heuristics,conservatories,carburetors,clitheroe,cofounded,formula_57,erupting,quinnipiac,bootle,ghostface,sittings,aspinall,sealift,transferase,boldklub,siskiyou,predominated,francophonie,ferruginous,castrum,neogene,sakya,madama,precipitous,'love,posix,bithynia,uttara,avestan,thrushes,seiji,memorably,septimius,libri,cibernetico,hyperinflation,dissuaded,cuddalore,peculiarity,vaslui,grojec,albumin,thurles,casks,fasteners,fluidity,buble,casals,terek,gnosticism,cognates,ulnar,radwanska,babylonians,majuro,oxidizer,excavators,rhythmically,liffey,gorakhpur,eurydice,underscored,arborea,lumumba,tuber,catholique,grama,galilei,scrope,centreville,jacobin,bequests,ardeche,polygamous,montauban,terai,weatherboard,readability,attainder,acraea,transversely,rivets,winterbottom,reassures,bacteriology,vriesea,chera,andesite,dedications,homogenous,reconquered,bandon,forrestal,ukiyo,gurdjieff,tethys,sparc,muscogee,grebes,belchatow,mansa,blantyre,palliser,sokolow,fibroblasts,exmoor,misaki,soundscapes,housatonic,middelburg,convenor,leyla,antipope,histidine,okeechobee,alkenes,sombre,alkene,rubik,macaques,calabar,trophee,pinchot,'free,frusciante,chemins,falaise,vasteras,gripped,schwarzenberg,cumann,kanchipuram,acoustically,silverbacks,fangio,inset,plympton,kuril,vaccinations,recep,theropods,axils,stavropol,encroached,apoptotic,papandreou,wailers,moonstone,assizes,micrometers,hornchurch,truncation,annapurna,egyptologists,rheumatic,promiscuity,satiric,fleche,caloptilia,anisotropy,quaternions,gruppo,viscounts,awardees,aftershocks,sigint,concordance,oblasts,gaumont,stent,commissars,kesteven,hydroxy,vijayanagar,belorussian,fabricius,watermark,tearfully,mamet,leukaemia,sorkh,milepost,tattooing,vosta,abbasids,uncompleted,hedong,woodwinds,extinguishing,malus,multiplexes,francoist,pathet,responsa,bassists,'most,postsecondary,ossory,grampian,saakashvili,alito,strasberg,impressionistic,volador,gelatinous,vignette,underwing,campanian,abbasabad,albertville,hopefuls,nieuwe,taxiways,reconvened,recumbent,pathologists,unionized,faversham,asymptotically,romulo,culling,donja,constricted,annesley,duomo,enschede,lovech,sharpshooter,lansky,dhamma,papillae,alanine,mowat,delius,wrest,mcluhan,podkarpackie,imitators,bilaspur,stunting,pommel,casemate,handicaps,nagas,testaments,hemings,necessitate,rearward,locative,cilla,klitschko,lindau,merion,consequential,antic,soong,copula,berthing,chevrons,rostral,sympathizer,budokan,ranulf,beria,stilt,replying,conflated,alcibiades,painstaking,yamanashi,calif.,arvid,ctesiphon,xizong,rajas,caxton,downbeat,resurfacing,rudders,miscegenation,deathmatch,foregoing,arthropod,attestation,karts,reapportionment,harnessing,eastlake,schola,dosing,postcolonial,imtiaz,formula_55,insulators,gunung,accumulations,pampas,llewelyn,bahnhof,cytosol,grosjean,teaneck,briarcliff,arsenio,canara,elaborating,passchendaele,searchlights,holywell,mohandas,preventable,gehry,mestizos,ustinov,cliched,'national,heidfeld,tertullian,jihadist,tourer,miletus,semicircle,outclassed,bouillon,cardinalate,clarifies,dakshina,bilayer,pandyan,unrwa,chandragupta,formula_56,portola,sukumaran,lactation,islamia,heikki,couplers,misappropriation,catshark,montt,ploughs,carib,stator,leaderboard,kenrick,dendrites,scape,tillamook,molesworth,mussorgsky,melanesia,restated,troon,glycoside,truckee,headwater,mashup,sectoral,gangwon,docudrama,skirting,psychopathology,dramatised,ostroleka,infestations,thabo,depolarization,wideroe,eisenbahn,thomond,kumaon,upendra,foreland,acronyms,yaqui,retaking,raphaelite,specie,dupage,villars,lucasarts,chloroplast,werribee,balsa,ascribe,havant,flava,khawaja,tyumen,subtract,interrogators,reshaping,buzzcocks,eesti,campanile,potemkin,apertures,snowboarder,registrars,handbooks,boyar,contaminant,depositors,proximate,jeunesse,zagora,pronouncements,mists,nihilism,deified,margraviate,pietersen,moderators,amalfi,adjectival,copepods,magnetosphere,pallets,clemenceau,castra,perforation,granitic,troilus,grzegorz,luthier,dockyards,antofagasta,ffestiniog,subroutine,afterword,waterwheel,druce,nitin,undifferentiated,emacs,readmitted,barneveld,tapers,hittites,infomercials,infirm,braathens,heligoland,carpark,geomagnetic,musculoskeletal,nigerien,machinima,harmonize,repealing,indecency,muskoka,verite,steubenville,suffixed,cytoskeleton,surpasses,harmonia,imereti,ventricles,heterozygous,envisions,otsego,ecoles,warrnambool,burgenland,seria,rawat,capistrano,welby,kirin,enrollments,caricom,dragonlance,schaffhausen,expanses,photojournalism,brienne,etude,referent,jamtland,schemas,xianbei,cleburne,bicester,maritima,shorelines,diagonals,bjelke,nonpublic,aliasing,m.f.a,ovals,maitreya,skirmishing,grothendieck,sukhothai,angiotensin,bridlington,durgapur,contras,gakuen,skagit,rabbinate,tsunamis,haphazard,tyldesley,microcontroller,discourages,hialeah,compressing,septimus,larvik,condoleezza,psilocybin,protectionism,songbirds,clandestinely,selectmen,wargame,cinemascope,khazars,agronomy,melzer,latifah,cherokees,recesses,assemblymen,basescu,banaras,bioavailability,subchannels,adenine,o'kelly,prabhakar,leonese,dimethyl,testimonials,geoffroy,oxidant,universiti,gheorghiu,bohdan,reversals,zamorin,herbivore,jarre,sebastiao,infanterie,dolmen,teddington,radomsko,spaceships,cuzco,recapitulation,mahoning,bainimarama,myelin,aykroyd,decals,tokelau,nalgonda,rajasthani,121st,quelled,tambov,illyrians,homilies,illuminations,hypertrophy,grodzisk,inundation,incapacity,equilibria,combats,elihu,steinitz,berengar,gowda,canwest,khosrau,maculata,houten,kandinsky,onside,leatherhead,heritable,belvidere,federative,chukchi,serling,eruptive,patan,entitlements,suffragette,evolutions,migrates,demobilisation,athleticism,trope,sarpsborg,kensal,translink,squamish,concertgebouw,energon,timestamp,competences,zalgiris,serviceman,codice_7,spoofing,assange,mahadevan,skien,suceava,augustan,revisionism,unconvincing,hollande,drina,gottlob,lippi,broglie,darkening,tilapia,eagerness,nacht,kolmogorov,photometric,leeuwarden,jrotc,haemorrhage,almanack,cavalli,repudiation,galactose,zwickau,cetinje,houbraken,heavyweights,gabonese,ordinals,noticias,museveni,steric,charaxes,amjad,resection,joinville,leczyca,anastasius,purbeck,subtribe,dalles,leadoff,monoamine,jettisoned,kaori,anthologized,alfreton,indic,bayezid,tottori,colonizing,assassinating,unchanging,eusebian,d'estaing,tsingtao,toshio,transferases,peronist,metrology,equus,mirpur,libertarianism,kovil,indole,'green,abstention,quantitatively,icebreakers,tribals,mainstays,dryandra,eyewear,nilgiri,chrysanthemum,inositol,frenetic,merchantman,hesar,physiotherapist,transceiver,dancefloor,rankine,neisse,marginalization,lengthen,unaided,rework,pageantry,savio,striated,funen,witton,illuminates,frass,hydrolases,akali,bistrita,copywriter,firings,handballer,tachinidae,dmytro,coalesce,neretva,menem,moraines,coatbridge,crossrail,spoofed,drosera,ripen,protour,kikuyu,boleslav,edwardes,troubadours,haplogroups,wrasse,educationalist,sroda,khaneh,dagbladet,apennines,neuroscientist,deplored,terje,maccabees,daventry,spaceport,lessening,ducats,singer/guitarist,chambersburg,yeong,configurable,ceremonially,unrelenting,caffe,graaf,denizens,kingsport,ingush,panhard,synthesised,tumulus,homeschooled,bozorg,idiomatic,thanhouser,queensway,radek,hippolytus,inking,banovina,peacocks,piaui,handsworth,pantomimes,abalone,thera,kurzweil,bandura,augustinians,bocelli,ferrol,jiroft,quadrature,contravention,saussure,rectification,agrippina,angelis,matanzas,nidaros,palestrina,latium,coriolis,clostridium,ordain,uttering,lanchester,proteolytic,ayacucho,merseburg,holbein,sambalpur,algebraically,inchon,ostfold,savoia,calatrava,lahiri,judgeship,ammonite,masaryk,meyerbeer,hemorrhagic,superspeedway,ningxia,panicles,encircles,khmelnytsky,profusion,esher,babol,inflationary,anhydride,gaspe,mossy,periodicity,nacion,meteorologists,mahjong,interventional,sarin,moult,enderby,modell,palgrave,warners,montcalm,siddha,functionalism,rilke,politicized,broadmoor,kunste,orden,brasileira,araneta,eroticism,colquhoun,mamba,blacktown,tubercle,seagrass,manoel,camphor,neoregelia,llandudno,annexe,enplanements,kamien,plovers,statisticians,iturbide,madrasah,nontrivial,publican,landholders,manama,uninhabitable,revivalist,trunkline,friendliness,gurudwara,rocketry,unido,tripos,besant,braque,evolutionarily,abkhazian,staffel,ratzinger,brockville,bohemond,intercut,djurgarden,utilitarianism,deploys,sastri,absolutism,subhas,asghar,fictions,sepinwall,proportionately,titleholders,thereon,foursquare,machinegun,knightsbridge,siauliai,aqaba,gearboxes,castaways,weakens,phallic,strzelce,buoyed,ruthenia,pharynx,intractable,neptunes,koine,leakey,netherlandish,preempted,vinay,terracing,instigating,alluvium,prosthetics,vorarlberg,politiques,joinery,reduplication,nebuchadnezzar,lenticular,banka,seaborne,pattinson,helpline,aleph,beckenham,californians,namgyal,franziska,aphid,branagh,transcribe,appropriateness,surakarta,takings,propagates,juraj,b0d3fb,brera,arrayed,tailback,falsehood,hazleton,prosody,egyptology,pinnate,tableware,ratan,camperdown,ethnologist,tabari,classifiers,biogas,126th,kabila,arbitron,apuestas,membranous,kincardine,oceana,glories,natick,populism,synonymy,ghalib,mobiles,motherboards,stationers,germinal,patronised,formula_58,gaborone,torts,jeezy,interleague,novaya,batticaloa,offshoots,wilbraham,filename,nswrfl,'well,trilobite,pythons,optimally,scientologists,rhesus,pilsen,backdrops,batang,unionville,hermanos,shrikes,fareham,outlawing,discontinuing,boisterous,shamokin,scanty,southwestward,exchangers,unexpired,mewar,h.m.s,saldanha,pawan,condorcet,turbidity,donau,indulgences,coincident,cliques,weeklies,bardhaman,violators,kenai,caspase,xperia,kunal,fistula,epistemic,cammell,nephi,disestablishment,rotator,germaniawerft,pyaar,chequered,jigme,perlis,anisotropic,popstars,kapil,appendices,berat,defecting,shacks,wrangel,panchayath,gorna,suckling,aerosols,sponheim,talal,borehole,encodings,enlai,subduing,agong,nadar,kitsap,syrmia,majumdar,pichilemu,charleville,embryology,booting,literati,abutting,basalts,jussi,repubblica,hertogenbosch,digitization,relents,hillfort,wiesenthal,kirche,bhagwan,bactrian,oases,phyla,neutralizing,helsing,ebooks,spearheading,margarine,'golden,phosphor,picea,stimulants,outliers,timescale,gynaecology,integrator,skyrocketed,bridgnorth,senecio,ramachandra,suffragist,arrowheads,aswan,inadvertent,microelectronics,118th,sofer,kubica,melanesian,tuanku,balkh,vyborg,crystallographic,initiators,metamorphism,ginzburg,looters,unimproved,finistere,newburyport,norges,immunities,franchisees,asterism,kortrijk,camorra,komsomol,fleurs,draughts,patagonian,voracious,artin,collaborationist,revolucion,revitalizing,xaver,purifying,antipsychotic,disjunct,pompeius,dreamwave,juvenal,beinn,adiyaman,antitank,allama,boletus,melanogaster,dumitru,caproni,aligns,athabaskan,stobart,phallus,veikkausliiga,hornsey,buffering,bourbons,dobruja,marga,borax,electrics,gangnam,motorcyclist,whidbey,draconian,lodger,galilean,sanctification,imitates,boldness,underboss,wheatland,cantabrian,terceira,maumee,redefining,uppercase,ostroda,characterise,universalism,equalized,syndicalism,haringey,masovia,deleuze,funkadelic,conceals,thuan,minsky,pluralistic,ludendorff,beekeeping,bonfires,endoscopic,abuts,prebend,jonkoping,amami,tribunes,yup'ik,awadh,gasification,pforzheim,reforma,antiwar,vaishnavism,maryville,inextricably,margrethe,empresa,neutrophils,sanctified,ponca,elachistidae,curiae,quartier,mannar,hyperplasia,wimax,busing,neologism,florins,underrepresented,digitised,nieuw,cooch,howards,frege,hughie,plied,swale,kapellmeister,vajpayee,quadrupled,aeronautique,dushanbe,custos,saltillo,kisan,tigray,manaus,epigrams,shamanic,peppered,frosts,promotion/relegation,concedes,zwingli,charentes,whangarei,hyung,spring/summer,sobre,eretz,initialization,sawai,ephemera,grandfathered,arnaldo,customised,permeated,parapets,growths,visegrad,estudios,altamont,provincia,apologises,stoppard,carburettor,rifts,kinematic,zhengzhou,eschatology,prakrit,folate,yvelines,scapula,stupas,rishon,reconfiguration,flutist,1680s,apostolate,proudhon,lakshman,articulating,stortford,faithfull,bitterns,upwelling,qur'anic,lidar,interferometry,waterlogged,koirala,ditton,wavefunction,fazal,babbage,antioxidants,lemberg,deadlocked,tolled,ramapo,mathematica,leiria,topologies,khali,photonic,balti,1080p,corrects,recommenced,polyglot,friezes,tiebreak,copacabana,cholmondeley,armband,abolishment,sheamus,buttes,glycolysis,cataloged,warrenton,sassari,kishan,foodservice,cryptanalysis,holmenkollen,cosplay,machi,yousuf,mangal,allying,fertiliser,otomi,charlevoix,metallurg,parisians,bottlenose,oakleigh,debug,cidade,accede,ligation,madhava,pillboxes,gatefold,aveyron,sorin,thirsk,immemorial,menelik,mehra,domingos,underpinned,fleshed,harshness,diphthong,crestwood,miskolc,dupri,pyrausta,muskingum,tuoba,prodi,incidences,waynesboro,marquesas,heydar,artesian,calinescu,nucleation,funders,covalently,compaction,derbies,seaters,sodor,tabular,amadou,peckinpah,o'halloran,zechariah,libyans,kartik,daihatsu,chandran,erzhu,heresies,superheated,yarder,dorde,tanjore,abusers,xuanwu,juniperus,moesia,trusteeship,birdwatching,beatz,moorcock,harbhajan,sanga,choreographic,photonics,boylston,amalgamate,prawns,electrifying,sarath,inaccurately,exclaims,powerpoint,chaining,cpusa,adulterous,saccharomyces,glogow,vfl/afl,syncretic,simla,persisting,functors,allosteric,euphorbiaceae,juryo,mlada,moana,gabala,thornycroft,kumanovo,ostrovsky,sitio,tutankhamun,sauropods,kardzhali,reinterpretation,sulpice,rosyth,originators,halesowen,delineation,asesoria,abatement,gardai,elytra,taillights,overlays,monsoons,sandpipers,ingmar,henrico,inaccuracy,irwell,arenabowl,elche,pressburg,signalman,interviewees,sinkhole,pendle,ecommerce,cellos,nebria,organometallic,surrealistic,propagandist,interlaken,canandaigua,aerials,coutinho,pascagoula,tonopah,letterkenny,gropius,carbons,hammocks,childe,polities,hosiery,donitz,suppresses,diaghilev,stroudsburg,bagram,pistoia,regenerating,unitarians,takeaway,offstage,vidin,glorification,bakunin,yavapai,lutzow,sabercats,witney,abrogated,gorlitz,validating,dodecahedron,stubbornly,telenor,glaxosmithkline,solapur,undesired,jellicoe,dramatization,four-and-a-half,seawall,waterpark,artaxerxes,vocalization,typographic,byung,sachsenhausen,shepparton,kissimmee,konnan,belsen,dhawan,khurd,mutagenesis,vejle,perrot,estradiol,formula_60,saros,chiloe,misiones,lamprey,terrains,speke,miasto,eigenvectors,haydock,reservist,corticosteroids,savitri,shinawatra,developmentally,yehudi,berates,janissaries,recapturing,rancheria,subplots,gresley,nikkatsu,oryol,cosmas,boavista,formula_59,playfully,subsections,commentated,kathakali,dorid,vilaine,seepage,hylidae,keiji,kazakhs,triphosphate,1620s,supersede,monarchists,falla,miyako,notching,bhumibol,polarizing,secularized,shingled,bronislaw,lockerbie,soleyman,bundesbahn,latakia,redoubts,boult,inwardly,invents,ondrej,minangkabau,newquay,permanente,alhaji,madhav,malini,ellice,bookmaker,mankiewicz,etihad,o'dea,interrogative,mikawa,wallsend,canisius,bluesy,vitruvius,noord,ratifying,mixtec,gujranwala,subprefecture,keelung,goiania,nyssa,shi'ite,semitone,ch'uan,computerised,pertuan,catapults,nepomuk,shruti,millstones,buskerud,acolytes,tredegar,sarum,armia,dell'arte,devises,custodians,upturned,gallaudet,disembarking,thrashed,sagrada,myeon,undeclared,qumran,gaiden,tepco,janesville,showground,condense,chalon,unstaffed,pasay,undemocratic,hauts,viridis,uninjured,escutcheon,gymkhana,petaling,hammam,dislocations,tallaght,rerum,shias,indios,guaranty,simplicial,benares,benediction,tajiri,prolifically,huawei,onerous,grantee,ferencvaros,otranto,carbonates,conceit,digipak,qadri,masterclasses,swamiji,cradock,plunket,helmsman,119th,salutes,tippecanoe,murshidabad,intelligibility,mittal,diversifying,bidar,asansol,crowdsourcing,rovere,karakoram,grindcore,skylights,tulagi,furrows,ligne,stuka,sumer,subgraph,amata,regionalist,bulkeley,teletext,glorify,readied,lexicographer,sabadell,predictability,quilmes,phenylalanine,bandaranaike,pyrmont,marksmen,quisling,viscountess,sociopolitical,afoul,pediments,swazi,martyrology,nullify,panagiotis,superconductors,veldenz,jujuy,l'isle,hematopoietic,shafi,subsea,hattiesburg,jyvaskyla,kebir,myeloid,landmine,derecho,amerindians,birkenau,scriabin,milhaud,mucosal,nikaya,freikorps,theoretician,proconsul,o'hanlon,clerked,bactria,houma,macular,topologically,shrubby,aryeh,ghazali,afferent,magalhaes,moduli,ashtabula,vidarbha,securitate,ludwigsburg,adoor,varun,shuja,khatun,chengde,bushels,lascelles,professionnelle,elfman,rangpur,unpowered,citytv,chojnice,quaternion,stokowski,aschaffenburg,commutes,subramaniam,methylene,satrap,gharb,namesakes,rathore,helier,gestational,heraklion,colliers,giannis,pastureland,evocation,krefeld,mahadeva,churchmen,egret,yilmaz,galeazzo,pudukkottai,artigas,generalitat,mudslides,frescoed,enfeoffed,aphorisms,melilla,montaigne,gauliga,parkdale,mauboy,linings,prema,sapir,xylophone,kushan,rockne,sequoyah,vasyl,rectilinear,vidyasagar,microcosm,san'a,carcinogen,thicknesses,aleut,farcical,moderating,detested,hegemonic,instalments,vauban,verwaltungsgemeinschaft,picayune,razorback,magellanic,moluccas,pankhurst,exportation,waldegrave,sufferer,bayswater,1up.com,rearmament,orangutans,varazdin,b.o.b,elucidate,harlingen,erudition,brankovic,lapis,slipway,urraca,shinde,unwell,elwes,euboea,colwyn,srivijaya,grandstands,hortons,generalleutnant,fluxes,peterhead,gandhian,reals,alauddin,maximized,fairhaven,endow,ciechanow,perforations,darters,panellist,manmade,litigants,exhibitor,tirol,caracalla,conformance,hotelier,stabaek,hearths,borac,frisians,ident,veliko,emulators,schoharie,uzbeks,samarra,prestwick,wadia,universita,tanah,bucculatrix,predominates,genotypes,denounces,roadsides,ganassi,keokuk,philatelist,tomic,ingots,conduits,samplers,abdus,johar,allegories,timaru,wolfpacks,secunda,smeaton,sportivo,inverting,contraindications,whisperer,moradabad,calamities,bakufu,soundscape,smallholders,nadeem,crossroad,xenophobic,zakir,nationalliga,glazes,retroflex,schwyz,moroder,rubra,quraysh,theodoros,endemol,infidels,km/hr,repositioned,portraitist,lluis,answerable,arges,mindedness,coarser,eyewall,teleported,scolds,uppland,vibraphone,ricoh,isenburg,bricklayer,cuttlefish,abstentions,communicable,cephalopod,stockyards,balto,kinston,armbar,bandini,elphaba,maxims,bedouins,sachsen,friedkin,tractate,pamir,ivanovo,mohini,kovalainen,nambiar,melvyn,orthonormal,matsuyama,cuernavaca,veloso,overstated,streamer,dravid,informers,analyte,sympathized,streetscape,gosta,thomasville,grigore,futuna,depleting,whelks,kiedis,armadale,earner,wynyard,dothan,animating,tridentine,sabri,immovable,rivoli,ariege,parley,clinker,circulates,junagadh,fraunhofer,congregants,180th,buducnost,formula_62,olmert,dedekind,karnak,bayernliga,mazes,sandpiper,ecclestone,yuvan,smallmouth,decolonization,lemmy,adjudicated,retiro,legia,benue,posit,acidification,wahab,taconic,floatplane,perchlorate,atria,wisbech,divestment,dallara,phrygia,palustris,cybersecurity,rebates,facie,mineralogical,substituent,proteges,fowey,mayenne,smoothbore,cherwell,schwarzschild,junin,murrumbidgee,smalltalk,d'orsay,emirati,calaveras,titusville,theremin,vikramaditya,wampanoag,burra,plaines,onegin,emboldened,whampoa,langa,soderbergh,arnaz,sowerby,arendal,godunov,pathanamthitta,damselfly,bestowing,eurosport,iconoclasm,outfitters,acquiesced,badawi,hypotension,ebbsfleet,annulus,sohrab,thenceforth,chagatai,necessitates,aulus,oddities,toynbee,uniontown,innervation,populaire,indivisible,rossellini,minuet,cyrene,gyeongju,chania,cichlids,harrods,1690s,plunges,abdullahi,gurkhas,homebuilt,sortable,bangui,rediff,incrementally,demetrios,medaille,sportif,svend,guttenberg,tubules,carthusian,pleiades,torii,hoppus,phenyl,hanno,conyngham,teschen,cronenberg,wordless,melatonin,distinctiveness,autos,freising,xuanzang,dunwich,satanism,sweyn,predrag,contractually,pavlovic,malaysians,micrometres,expertly,pannonian,abstaining,capensis,southwesterly,catchphrases,commercialize,frankivsk,normanton,hibernate,verso,deportees,dubliners,codice_8,condors,zagros,glosses,leadville,conscript,morrisons,usury,ossian,oulton,vaccinium,civet,ayman,codrington,hadron,nanometers,geochemistry,extractor,grigori,tyrrhenian,neocollyris,drooping,falsification,werft,courtauld,brigantine,orhan,chapultepec,supercopa,federalized,praga,havering,encampments,infallibility,sardis,pawar,undirected,reconstructionist,ardrossan,varuna,pastimes,archdiocesan,fledging,shenhua,molise,secondarily,stagnated,replicates,ciencias,duryodhana,marauding,ruislip,ilyich,intermixed,ravenswood,shimazu,mycorrhizal,icosahedral,consents,dunblane,follicular,pekin,suffield,muromachi,kinsale,gauche,businesspeople,thereto,watauga,exaltation,chelmno,gorse,proliferate,drainages,burdwan,kangra,transducers,inductor,duvalier,maguindanao,moslem,uncaf,givenchy,plantarum,liturgics,telegraphs,lukashenko,chenango,andante,novae,ironwood,faubourg,torme,chinensis,ambala,pietermaritzburg,virginians,landform,bottlenecks,o'driscoll,darbhanga,baptistery,ameer,needlework,naperville,auditoriums,mullingar,starrer,animatronic,topsoil,madura,cannock,vernet,santurce,catocala,ozeki,pontevedra,multichannel,sundsvall,strategists,medio,135th,halil,afridi,trelawny,caloric,ghraib,allendale,hameed,ludwigshafen,spurned,pavlo,palmar,strafed,catamarca,aveiro,harmonization,surah,predictors,solvay,mande,omnipresent,parenthesis,echolocation,equaling,experimenters,acyclic,lithographic,sepoys,katarzyna,sridevi,impoundment,khosrow,caesarean,nacogdoches,rockdale,lawmaker,caucasians,bahman,miyan,rubric,exuberance,bombastic,ductile,snowdonia,inlays,pinyon,anemones,hurries,hospitallers,tayyip,pulleys,treme,photovoltaics,testbed,polonium,ryszard,osgoode,profiting,ironwork,unsurpassed,nepticulidae,makai,lumbini,preclassic,clarksburg,egremont,videography,rehabilitating,ponty,sardonic,geotechnical,khurasan,solzhenitsyn,henna,phoenicia,rhyolite,chateaux,retorted,tomar,deflections,repressions,harborough,renan,brumbies,vandross,storia,vodou,clerkenwell,decking,universo,salon.com,imprisoning,sudwest,ghaziabad,subscribing,pisgah,sukhumi,econometric,clearest,pindar,yildirim,iulia,atlases,cements,remaster,dugouts,collapsible,resurrecting,batik,unreliability,thiers,conjunctions,colophon,marcher,placeholder,flagella,wolds,kibaki,viviparous,twelver,screenshots,aroostook,khadr,iconographic,itasca,jaume,basti,propounded,varro,be'er,jeevan,exacted,shrublands,creditable,brocade,boras,bittern,oneonta,attentional,herzliya,comprehensible,lakeville,discards,caxias,frankland,camerata,satoru,matlab,commutator,interprovincial,yorkville,benefices,nizami,edwardsville,amigaos,cannabinoid,indianola,amateurliga,pernicious,ubiquity,anarchic,novelties,precondition,zardari,symington,sargodha,headphone,thermopylae,mashonaland,zindagi,thalberg,loewe,surfactants,dobro,crocodilians,samhita,diatoms,haileybury,berwickshire,supercritical,sofie,snorna,slatina,intramolecular,agung,osteoarthritis,obstetric,teochew,vakhtang,connemara,deformations,diadem,ferruccio,mainichi,qualitatively,refrigerant,rerecorded,methylated,karmapa,krasinski,restatement,rouvas,cubitt,seacoast,schwarzkopf,homonymous,shipowner,thiamine,approachable,xiahou,160th,ecumenism,polistes,internazionali,fouad,berar,biogeography,texting,inadequately,'when,4kids,hymenoptera,emplaced,cognomen,bellefonte,supplant,michaelmas,uriel,tafsir,morazan,schweinfurt,chorister,ps400,nscaa,petipa,resolutely,ouagadougou,mascarene,supercell,konstanz,bagrat,harmonix,bergson,shrimps,resonators,veneta,camas,mynydd,rumford,generalmajor,khayyam,web.com,pappus,halfdan,tanana,suomen,yutaka,bibliographical,traian,silat,noailles,contrapuntal,agaricus,'special,minibuses,1670s,obadiah,deepa,rorschach,malolos,lymington,valuations,imperials,caballeros,ambroise,judicature,elegiac,sedaka,shewa,checksum,gosforth,legionaries,corneille,microregion,friedrichshafen,antonis,surnamed,mycelium,cantus,educations,topmost,outfitting,ivica,nankai,gouda,anthemic,iosif,supercontinent,antifungal,belarusians,mudaliar,mohawks,caversham,glaciated,basemen,stevan,clonmel,loughton,deventer,positivist,manipuri,tensors,panipat,changeup,impermeable,dubbo,elfsborg,maritimo,regimens,bikram,bromeliad,substratum,norodom,gaultier,queanbeyan,pompeo,redacted,eurocopter,mothballed,centaurs,borno,copra,bemidji,'home,sopron,neuquen,passo,cineplex,alexandrov,wysokie,mammoths,yossi,sarcophagi,congreve,petkovic,extraneous,waterbirds,slurs,indias,phaeton,discontented,prefaced,abhay,prescot,interoperable,nordisk,bicyclists,validly,sejong,litovsk,zanesville,kapitanleutnant,kerch,changeable,mcclatchy,celebi,attesting,maccoll,sepahan,wayans,veined,gaudens,markt,dansk,soane,quantized,petersham,forebears,nayarit,frenzied,queuing,bygone,viggo,ludwik,tanka,hanssen,brythonic,cornhill,primorsky,stockpiles,conceptualization,lampeter,hinsdale,mesoderm,bielsk,rosenheim,ultron,joffrey,stanwyck,khagan,tiraspol,pavelic,ascendant,empoli,metatarsal,descentralizado,masada,ligier,huseyin,ramadi,waratah,tampines,ruthenium,statoil,mladost,liger,grecian,multiparty,digraph,maglev,reconsideration,radiography,cartilaginous,taizu,wintered,anabaptist,peterhouse,shoghi,assessors,numerator,paulet,painstakingly,halakhic,rocroi,motorcycling,gimel,kryptonian,emmeline,cheeked,drawdown,lelouch,dacians,brahmana,reminiscence,disinfection,optimizations,golders,extensor,tsugaru,tolling,liman,gulzar,unconvinced,crataegus,oppositional,dvina,pyrolysis,mandan,alexius,prion,stressors,loomed,moated,dhivehi,recyclable,relict,nestlings,sarandon,kosovar,solvers,czeslaw,kenta,maneuverable,middens,berkhamsted,comilla,folkways,loxton,beziers,batumi,petrochemicals,optimised,sirjan,rabindra,musicality,rationalisation,drillers,subspaces,'live,bbwaa,outfielders,tsung,danske,vandalised,norristown,striae,kanata,gastroenterology,steadfastly,equalising,bootlegging,mannerheim,notodontidae,lagoa,commentating,peninsulas,chishti,seismology,modigliani,preceptor,canonically,awardee,boyaca,hsinchu,stiffened,nacelle,bogor,dryness,unobstructed,yaqub,scindia,peeters,irritant,ammonites,ferromagnetic,speechwriter,oxygenated,walesa,millais,canarian,faience,calvinistic,discriminant,rasht,inker,annexes,howth,allocates,conditionally,roused,regionalism,regionalbahn,functionary,nitrates,bicentenary,recreates,saboteurs,koshi,plasmids,thinned,124th,plainview,kardashian,neuville,victorians,radiates,127th,vieques,schoolmates,petru,tokusatsu,keying,sunaina,flamethrower,'bout,demersal,hosokawa,corelli,omniscient,o'doherty,niksic,reflectivity,transdev,cavour,metronome,temporally,gabba,nsaids,geert,mayport,hematite,boeotia,vaudreuil,torshavn,sailplane,mineralogist,eskisehir,practises,gallifrey,takumi,unease,slipstream,hedmark,paulinus,ailsa,wielkopolska,filmworks,adamantly,vinaya,facelifted,franchisee,augustana,toppling,velvety,crispa,stonington,histological,genealogist,tactician,tebow,betjeman,nyingma,overwinter,oberoi,rampal,overwinters,petaluma,lactarius,stanmore,balikpapan,vasant,inclines,laminate,munshi,sociedade,rabbah,septal,boyband,ingrained,faltering,inhumans,nhtsa,affix,l'ordre,kazuki,rossendale,mysims,latvians,slaveholders,basilicata,neuburg,assize,manzanillo,scrobipalpa,formula_61,belgique,pterosaurs,privateering,vaasa,veria,northport,pressurised,hobbyist,austerlitz,sahih,bhadra,siliguri,bistrica,bursaries,wynton,corot,lepidus,lully,libor,libera,olusegun,choline,mannerism,lymphocyte,chagos,duxbury,parasitism,ecowas,morotai,cancion,coniston,aggrieved,sputnikmusic,parle,ammonian,civilisations,malformation,cattaraugus,skyhawks,d'arc,demerara,bronfman,midwinter,piscataway,jogaila,threonine,matins,kohlberg,hubli,pentatonic,camillus,nigam,potro,unchained,chauvel,orangeville,cistercians,redeployment,xanthi,manju,carabinieri,pakeha,nikolaevich,kantakouzenos,sesquicentennial,gunships,symbolised,teramo,ballo,crusading,l'oeil,bharatpur,lazier,gabrovo,hysteresis,rothbard,chaumont,roundel,ma'mun,sudhir,queried,newts,shimane,presynaptic,playfield,taxonomists,sensitivities,freleng,burkinabe,orfeo,autovia,proselytizing,bhangra,pasok,jujutsu,heung,pivoting,hominid,commending,formula_64,epworth,christianized,oresund,hantuchova,rajputana,hilversum,masoretic,dayak,bakri,assen,magog,macromolecules,waheed,qaida,spassky,rumped,protrudes,preminger,misogyny,glencairn,salafi,lacunae,grilles,racemes,areva,alighieri,inari,epitomized,photoshoot,one-of-a-kind,tring,muralist,tincture,backwaters,weaned,yeasts,analytically,smaland,caltrans,vysocina,jamuna,mauthausen,175th,nouvelles,censoring,reggina,christology,gilad,amplifying,mehmood,johnsons,redirects,eastgate,sacrum,meteoric,riverbanks,guidebooks,ascribes,scoparia,iconoclastic,telegraphic,chine,merah,mistico,lectern,sheung,aethelstan,capablanca,anant,uspto,albatrosses,mymensingh,antiretroviral,clonal,coorg,vaillant,liquidator,gigas,yokai,eradicating,motorcyclists,waitakere,tandon,nears,montenegrins,250th,tatsuya,yassin,atheistic,syncretism,nahum,berisha,transcended,owensboro,lakshmana,abteilung,unadorned,nyack,overflows,harrisonburg,complainant,uematsu,frictional,worsens,sangguniang,abutment,bulwer,sarma,apollinaire,shippers,lycia,alentejo,porpoises,optus,trawling,augustow,blackwall,workbench,westmount,leaped,sikandar,conveniences,stornoway,culverts,zoroastrians,hristo,ansgar,assistive,reassert,fanned,compasses,delgada,maisons,arima,plonsk,verlaine,starstruck,rakhine,befell,spirally,wyclef,expend,colloquium,formula_63,albertus,bellarmine,handedness,holon,introns,movimiento,profitably,lohengrin,discoverers,awash,erste,pharisees,dwarka,oghuz,hashing,heterodox,uloom,vladikavkaz,linesman,rehired,nucleophile,germanicus,gulshan,songz,bayerische,paralympian,crumlin,enjoined,khanum,prahran,penitent,amersfoort,saranac,semisimple,vagrants,compositing,tualatin,oxalate,lavra,ironi,ilkeston,umpqua,calum,stretford,zakat,guelders,hydrazine,birkin,spurring,modularity,aspartate,sodermanland,hopital,bellary,legazpi,clasico,cadfael,hypersonic,volleys,pharmacokinetics,carotene,orientale,pausini,bataille,lunga,retailed,m.phil,mazowieckie,vijayan,rawal,sublimation,promissory,estimators,ploughed,conflagration,penda,segregationist,otley,amputee,coauthor,sopra,pellew,wreckers,tollywood,circumscription,permittivity,strabane,landward,articulates,beaverbrook,rutherglen,coterminous,whistleblowers,colloidal,surbiton,atlante,oswiecim,bhasa,lampooned,chanter,saarc,landkreis,tribulation,tolerates,daiichi,hatun,cowries,dyschirius,abercromby,attock,aldwych,inflows,absolutist,l'histoire,committeeman,vanbrugh,headstock,westbourne,appenzell,hoxton,oculus,westfalen,roundabouts,nickelback,trovatore,quenching,summarises,conservators,transmutation,talleyrand,barzani,unwillingly,axonal,'blue,opining,enveloping,fidesz,rafah,colborne,flickr,lozenge,dulcimer,ndebele,swaraj,oxidize,gonville,resonated,gilani,superiore,endeared,janakpur,shepperton,solidifying,memoranda,sochaux,kurnool,rewari,emirs,kooning,bruford,unavailability,kayseri,judicious,negating,pterosaur,cytosolic,chernihiv,variational,sabretooth,seawolves,devalued,nanded,adverb,volunteerism,sealers,nemours,smederevo,kashubian,bartin,animax,vicomte,polotsk,polder,archiepiscopal,acceptability,quidditch,tussock,seminaire,immolation,belge,coves,wellingborough,khaganate,mckellen,nayaka,brega,kabhi,pontoons,bascule,newsreels,injectors,cobol,weblog,diplo,biggar,wheatbelt,erythrocytes,pedra,showgrounds,bogdanovich,eclecticism,toluene,elegies,formalize,andromedae,airworthiness,springville,mainframes,overexpression,magadha,bijelo,emlyn,glutamine,accenture,uhuru,metairie,arabidopsis,patanjali,peruvians,berezovsky,accion,astrolabe,jayanti,earnestly,sausalito,recurved,1500s,ramla,incineration,galleons,laplacian,shiki,smethwick,isomerase,dordevic,janow,jeffersonville,internationalism,penciled,styrene,ashur,nucleoside,peristome,horsemanship,sedges,bachata,medes,kristallnacht,schneerson,reflectance,invalided,strutt,draupadi,destino,partridges,tejas,quadrennial,aurel,halych,ethnomusicology,autonomist,radyo,rifting,shi'ar,crvena,telefilm,zawahiri,plana,sultanates,theodorus,subcontractors,pavle,seneschal,teleports,chernivtsi,buccal,brattleboro,stankovic,safar,dunhuang,electrocution,chastised,ergonomic,midsomer,130th,zomba,nongovernmental,escapist,localize,xuzhou,kyrie,carinthian,karlovac,nisan,kramnik,pilipino,digitisation,khasi,andronicus,highwayman,maior,misspelling,sebastopol,socon,rhaetian,archimandrite,partway,positivity,otaku,dingoes,tarski,geopolitics,disciplinarian,zulfikar,kenzo,globose,electrophilic,modele,storekeeper,pohang,wheldon,washers,interconnecting,digraphs,intrastate,campy,helvetic,frontispiece,ferrocarril,anambra,petraeus,midrib,endometrial,dwarfism,mauryan,endocytosis,brigs,percussionists,furtherance,synergistic,apocynaceae,krona,berthier,circumvented,casal,siltstone,precast,ethnikos,realists,geodesy,zarzuela,greenback,tripathi,persevered,interments,neutralization,olbermann,departements,supercomputing,demobilised,cassavetes,dunder,ministering,veszprem,barbarism,'world,pieve,apologist,frentzen,sulfides,firewalls,pronotum,staatsoper,hachette,makhachkala,oberland,phonon,yoshihiro,instars,purnima,winslet,mutsu,ergative,sajid,nizamuddin,paraphrased,ardeidae,kodagu,monooxygenase,skirmishers,sportiva,o'byrne,mykolaiv,ophir,prieta,gyllenhaal,kantian,leche,copan,herero,ps250,gelsenkirchen,shalit,sammarinese,chetwynd,wftda,travertine,warta,sigmaringen,concerti,namespace,ostergotland,biomarker,universals,collegio,embarcadero,wimborne,fiddlers,likening,ransomed,stifled,unabated,kalakaua,khanty,gongs,goodrem,countermeasure,publicizing,geomorphology,swedenborg,undefended,catastrophes,diverts,storyboards,amesbury,contactless,placentia,festivity,authorise,terrane,thallium,stradivarius,antonine,consortia,estimations,consecrate,supergiant,belichick,pendants,butyl,groza,univac,afire,kavala,studi,teletoon,paucity,gonbad,koninklijke,128th,stoichiometric,multimodal,facundo,anatomic,melamine,creuse,altan,brigands,mcguinty,blomfield,tsvangirai,protrusion,lurgan,warminster,tenzin,russellville,discursive,definable,scotrail,lignin,reincorporated,o'dell,outperform,redland,multicolored,evaporates,dimitrie,limbic,patapsco,interlingua,surrogacy,cutty,potrero,masud,cahiers,jintao,ardashir,centaurus,plagiarized,minehead,musings,statuettes,logarithms,seaview,prohibitively,downforce,rivington,tomorrowland,microbiologist,ferric,morag,capsid,kucinich,clairvaux,demotic,seamanship,cicada,painterly,cromarty,carbonic,tupou,oconee,tehuantepec,typecast,anstruther,internalized,underwriters,tetrahedra,flagrant,quakes,pathologies,ulrik,nahal,tarquini,dongguan,parnassus,ryoko,senussi,seleucia,airasia,einer,sashes,d'amico,matriculating,arabesque,honved,biophysical,hardinge,kherson,mommsen,diels,icbms,reshape,brasiliensis,palmach,netaji,oblate,functionalities,grigor,blacksburg,recoilless,melanchthon,reales,astrodome,handcrafted,memes,theorizes,isma'il,aarti,pirin,maatschappij,stabilizes,honiara,ashbury,copts,rootes,defensed,queiroz,mantegna,galesburg,coraciiformesfamily,cabrillo,tokio,antipsychotics,kanon,173rd,apollonia,finial,lydian,hadamard,rangi,dowlatabad,monolingual,platformer,subclasses,chiranjeevi,mirabeau,newsgroup,idmanyurdu,kambojas,walkover,zamoyski,generalist,khedive,flanges,knowle,bande,157th,alleyn,reaffirm,pininfarina,zuckerberg,hakodate,131st,aditi,bellinzona,vaulter,planking,boscombe,colombians,lysis,toppers,metered,nahyan,queensryche,minho,nagercoil,firebrand,foundress,bycatch,mendota,freeform,antena,capitalisation,martinus,overijssel,purists,interventionist,zgierz,burgundians,hippolyta,trompe,umatilla,moroccans,dictionnaire,hydrography,changers,chota,rimouski,aniline,bylaw,grandnephew,neamt,lemnos,connoisseurs,tractive,rearrangements,fetishism,finnic,apalachicola,landowning,calligraphic,circumpolar,mansfeld,legible,orientalism,tannhauser,blamey,maximization,noinclude,blackbirds,angara,ostersund,pancreatitis,glabra,acleris,juried,jungian,triumphantly,singlet,plasmas,synesthesia,yellowhead,unleashes,choiseul,quanzhong,brookville,kaskaskia,igcse,skatepark,jatin,jewellers,scaritinae,techcrunch,tellurium,lachaise,azuma,codeshare,dimensionality,unidirectional,scolaire,macdill,camshafts,unassisted,verband,kahlo,eliya,prelature,chiefdoms,saddleback,sockers,iommi,coloratura,llangollen,biosciences,harshest,maithili,k'iche,plical,multifunctional,andreu,tuskers,confounding,sambre,quarterdeck,ascetics,berdych,transversal,tuolumne,sagami,petrobras,brecker,menxia,instilling,stipulating,korra,oscillate,deadpan,v/line,pyrotechnic,stoneware,prelims,intracoastal,retraining,ilija,berwyn,encrypt,achievers,zulfiqar,glycoproteins,khatib,farmsteads,occultist,saman,fionn,derulo,khilji,obrenovic,argosy,toowong,dementieva,sociocultural,iconostasis,craigslist,festschrift,taifa,intercalated,tanjong,penticton,sharad,marxian,extrapolation,guises,wettin,prabang,exclaiming,kosta,famas,conakry,wanderings,'aliabad,macleay,exoplanet,bancorp,besiegers,surmounting,checkerboard,rajab,vliet,tarek,operable,wargaming,haldimand,fukuyama,uesugi,aggregations,erbil,brachiopods,tokyu,anglais,unfavorably,ujpest,escorial,armagnac,nagara,funafuti,ridgeline,cocking,o'gorman,compactness,retardant,krajowa,barua,coking,bestows,thampi,chicagoland,variably,o'loughlin,minnows,schwa,shaukat,polycarbonate,chlorinated,godalming,gramercy,delved,banqueting,enlil,sarada,prasanna,domhnall,decadal,regressive,lipoprotein,collectable,surendra,zaporizhia,cycliste,suchet,offsetting,formula_65,pudong,d'arte,blyton,quonset,osmania,tientsin,manorama,proteomics,bille,jalpaiguri,pertwee,barnegat,inventiveness,gollancz,euthanized,henricus,shortfalls,wuxia,chlorides,cerrado,polyvinyl,folktale,straddled,bioengineering,eschewing,greendale,recharged,olave,ceylonese,autocephalous,peacebuilding,wrights,guyed,rosamund,abitibi,bannockburn,gerontology,scutari,souness,seagram,codice_9,'open,xhtml,taguig,purposed,darbar,orthopedics,unpopulated,kisumu,tarrytown,feodor,polyhedral,monadnock,gottorp,priam,redesigning,gasworks,elfin,urquiza,homologation,filipovic,bohun,manningham,gornik,soundness,shorea,lanus,gelder,darke,sandgate,criticality,paranaense,153rd,vieja,lithograph,trapezoid,tiebreakers,convalescence,yan'an,actuaries,balad,altimeter,thermoelectric,trailblazer,previn,tenryu,ancaster,endoscopy,nicolet,discloses,fracking,plaine,salado,americanism,placards,absurdist,propylene,breccia,jirga,documenta,ismailis,161st,brentano,dallas/fort,embellishment,calipers,subscribes,mahavidyalaya,wednesbury,barnstormers,miwok,schembechler,minigame,unterberger,dopaminergic,inacio,nizamabad,overridden,monotype,cavernous,stichting,sassafras,sotho,argentinean,myrrh,rapidity,flatts,gowrie,dejected,kasaragod,cyprinidae,interlinked,arcseconds,degeneracy,infamously,incubate,substructure,trigeminal,sectarianism,marshlands,hooliganism,hurlers,isolationist,urania,burrard,switchover,lecco,wilts,interrogator,strived,ballooning,volterra,raciborz,relegating,gilding,cybele,dolomites,parachutist,lochaber,orators,raeburn,backend,benaud,rallycross,facings,banga,nuclides,defencemen,futurity,emitters,yadkin,eudonia,zambales,manasseh,sirte,meshes,peculiarly,mcminnville,roundly,boban,decrypt,icelanders,sanam,chelan,jovian,grudgingly,penalised,subscript,gambrinus,poaceae,infringements,maleficent,runciman,148th,supersymmetry,granites,liskeard,eliciting,involution,hallstatt,kitzbuhel,shankly,sandhills,inefficiencies,yishuv,psychotropic,nightjars,wavell,sangamon,vaikundar,choshu,retrospectives,pitesti,gigantea,hashemi,bosna,gakuin,siochana,arrangers,baronetcies,narayani,temecula,creston,koscierzyna,autochthonous,wyandot,anniston,igreja,mobilise,buzau,dunster,musselburgh,wenzhou,khattak,detoxification,decarboxylase,manlius,campbells,coleoptera,copyist,sympathisers,suisun,eminescu,defensor,transshipment,thurgau,somerton,fluctuates,ambika,weierstrass,lukow,giambattista,volcanics,romanticized,innovated,matabeleland,scotiabank,garwolin,purine,d'auvergne,borderland,maozhen,pricewaterhousecoopers,testator,pallium,scout.com,mv/pi,nazca,curacies,upjohn,sarasvati,monegasque,ketrzyn,malory,spikelets,biomechanics,haciendas,rapped,dwarfed,stews,nijinsky,subjection,matsu,perceptible,schwarzburg,midsection,entertains,circuitous,epiphytic,wonsan,alpini,bluefield,sloths,transportable,braunfels,dictum,szczecinek,jukka,wielun,wejherowo,hucknall,grameen,duodenum,ribose,deshpande,shahar,nexstar,injurious,dereham,lithographer,dhoni,structuralist,progreso,deschutes,christus,pulteney,quoins,yitzchak,gyeongsang,breviary,makkah,chiyoda,jutting,vineland,angiosperms,necrotic,novelisation,redistribute,tirumala,140th,featureless,mafic,rivaling,toyline,2/1st,martius,saalfeld,monthan,texian,kathak,melodramas,mithila,regierungsbezirk,509th,fermenting,schoolmate,virtuosic,briain,kokoda,heliocentric,handpicked,kilwinning,sonically,dinars,kasim,parkways,bogdanov,luxembourgian,halland,avesta,bardic,daugavpils,excavator,qwest,frustrate,physiographic,majoris,'ndrangheta,unrestrained,firmness,montalban,abundances,preservationists,adare,executioners,guardsman,bonnaroo,neglects,nazrul,pro12,hoorn,abercorn,refuting,kabud,cationic,parapsychology,troposphere,venezuelans,malignancy,khoja,unhindered,accordionist,medak,visby,ejercito,laparoscopic,dinas,umayyads,valmiki,o'dowd,saplings,stranding,incisions,illusionist,avocets,buccleuch,amazonia,fourfold,turboprops,roosts,priscus,turnstile,areal,certifies,pocklington,spoofs,viseu,commonalities,dabrowka,annam,homesteaders,daredevils,mondrian,negotiates,fiestas,perennials,maximizes,lubavitch,ravindra,scrapers,finials,kintyre,violas,snoqualmie,wilders,openbsd,mlawa,peritoneal,devarajan,congke,leszno,mercurial,fakir,joannes,bognor,overloading,unbuilt,gurung,scuttle,temperaments,bautzen,jardim,tradesman,visitations,barbet,sagamore,graaff,forecasters,wilsons,assis,l'air,shariah,sochaczew,russa,dirge,biliary,neuve,heartbreakers,strathearn,jacobian,overgrazing,edrich,anticline,parathyroid,petula,lepanto,decius,channelled,parvathi,puppeteers,communicators,francorchamps,kahane,longus,panjang,intron,traite,xxvii,matsuri,amrit,katyn,disheartened,cacak,omonia,alexandrine,partaking,wrangling,adjuvant,haskovo,tendrils,greensand,lammermoor,otherworld,volusia,stabling,one-and-a-half,bresson,zapatista,eotvos,ps150,webisodes,stepchildren,microarray,braganca,quanta,dolne,superoxide,bellona,delineate,ratha,lindenwood,bruhl,cingulate,tallies,bickerton,helgi,bevin,takoma,tsukuba,statuses,changeling,alister,bytom,dibrugarh,magnesia,duplicating,outlier,abated,goncalo,strelitz,shikai,mardan,musculature,ascomycota,springhill,tumuli,gabaa,odenwald,reformatted,autocracy,theresienstadt,suplex,chattopadhyay,mencken,congratulatory,weatherfield,systema,solemnity,projekt,quanzhou,kreuzberg,postbellum,nobuo,mediaworks,finisterre,matchplay,bangladeshis,kothen,oocyte,hovered,aromas,afshar,browed,teases,chorlton,arshad,cesaro,backbencher,iquique,vulcans,padmini,unabridged,cyclase,despotic,kirilenko,achaean,queensberry,debre,octahedron,iphigenia,curbing,karimnagar,sagarmatha,smelters,surrealists,sanada,shrestha,turridae,leasehold,jiedushi,eurythmics,appropriating,correze,thimphu,amery,musicomh,cyborgs,sandwell,pushcart,retorts,ameliorate,deteriorates,stojanovic,spline,entrenchments,bourse,chancellorship,pasolini,lendl,personage,reformulated,pubescens,loiret,metalurh,reinvention,nonhuman,eilema,tarsal,complutense,magne,broadview,metrodome,outtake,stouffville,seinen,bataillon,phosphoric,ostensible,opatow,aristides,beefheart,glorifying,banten,romsey,seamounts,fushimi,prophylaxis,sibylla,ranjith,goslar,balustrades,georgiev,caird,lafitte,peano,canso,bankura,halfpenny,segregate,caisson,bizerte,jamshedpur,euromaidan,philosophie,ridged,cheerfully,reclassification,aemilius,visionaries,samoans,wokingham,chemung,wolof,unbranched,cinerea,bhosle,ourense,immortalised,cornerstones,sourcebook,khufu,archimedean,universitatea,intermolecular,fiscally,suffices,metacomet,adjudicator,stablemate,specks,glace,inowroclaw,patristic,muharram,agitating,ashot,neurologic,didcot,gamla,ilves,putouts,siraj,laski,coaling,diarmuid,ratnagiri,rotulorum,liquefaction,morbihan,harel,aftershock,gruiformesfamily,bonnier,falconiformesfamily,adorns,wikis,maastrichtian,stauffenberg,bishopsgate,fakhr,sevenfold,ponders,quantifying,castiel,opacity,depredations,lenten,gravitated,o'mahony,modulates,inuktitut,paston,kayfabe,vagus,legalised,balked,arianism,tendering,sivas,birthdate,awlaki,khvajeh,shahab,samtgemeinde,bridgeton,amalgamations,biogenesis,recharging,tsukasa,mythbusters,chamfered,enthronement,freelancers,maharana,constantia,sutil,messines,monkton,okanogan,reinvigorated,apoplexy,tanahashi,neues,valiants,harappan,russes,carding,volkoff,funchal,statehouse,imitative,intrepidity,mellotron,samaras,turkana,besting,longitudes,exarch,diarrhoea,transcending,zvonareva,darna,ramblin,disconnection,137th,refocused,diarmait,agricole,ba'athist,turenne,contrabass,communis,daviess,fatimids,frosinone,fittingly,polyphyletic,qanat,theocratic,preclinical,abacha,toorak,marketplaces,conidia,seiya,contraindicated,retford,bundesautobahn,rebuilds,climatology,seaworthy,starfighter,qamar,categoria,malai,hellinsia,newstead,airworthy,catenin,avonmouth,arrhythmias,ayyavazhi,downgrade,ashburnham,ejector,kinematics,petworth,rspca,filmation,accipitridae,chhatrapati,g/mol,bacau,agama,ringtone,yudhoyono,orchestrator,arbitrators,138th,powerplants,cumbernauld,alderley,misamis,hawai`i,cuando,meistriliiga,jermyn,alans,pedigrees,ottavio,approbation,omnium,purulia,prioress,rheinland,lymphoid,lutsk,oscilloscope,ballina,iliac,motorbikes,modernising,uffizi,phylloxera,kalevala,bengalis,amravati,syntheses,interviewers,inflectional,outflank,maryhill,unhurt,profiler,nacelles,heseltine,personalised,guarda,herpetologist,airpark,pigot,margaretha,dinos,peleliu,breakbeat,kastamonu,shaivism,delamere,kingsville,epigram,khlong,phospholipids,journeying,lietuvos,congregated,deviance,celebes,subsoil,stroma,kvitova,lubricating,layoff,alagoas,olafur,doron,interuniversity,raycom,agonopterix,uzice,nanna,springvale,raimundo,wrested,pupal,talat,skinheads,vestige,unpainted,handan,odawara,ammar,attendee,lapped,myotis,gusty,ciconiiformesfamily,traversal,subfield,vitaphone,prensa,hasidism,inwood,carstairs,kropotkin,turgenev,dobra,remittance,purim,tannin,adige,tabulation,lethality,pacha,micronesian,dhruva,defensemen,tibeto,siculus,radioisotope,sodertalje,phitsanulok,euphonium,oxytocin,overhangs,skinks,fabrica,reinterred,emulates,bioscience,paragliding,raekwon,perigee,plausibility,frolunda,erroll,aznar,vyasa,albinus,trevally,confederacion,terse,sixtieth,1530s,kendriya,skateboarders,frontieres,muawiyah,easements,shehu,conservatively,keystones,kasem,brutalist,peekskill,cowry,orcas,syllabary,paltz,elisabetta,denticles,hampering,dolni,eidos,aarau,lermontov,yankton,shahbaz,barrages,kongsvinger,reestablishment,acetyltransferase,zulia,mrnas,slingsby,eucalypt,efficacious,weybridge,gradation,cinematheque,malthus,bampton,coexisted,cisse,hamdi,cupertino,saumarez,chionodes,libertine,formers,sakharov,pseudonymous,vol.1,mcduck,gopalakrishnan,amberley,jorhat,grandmasters,rudiments,dwindle,param,bukidnon,menander,americanus,multipliers,pulawy,homoerotic,pillbox,cd+dvd,epigraph,aleksandrow,extrapolated,horseshoes,contemporain,angiography,hasselt,shawinigan,memorization,legitimized,cyclades,outsold,rodolphe,kelis,powerball,dijkstra,analyzers,incompressible,sambar,orangeburg,osten,reauthorization,adamawa,sphagnum,hypermarket,millipedes,zoroaster,madea,ossuary,murrayfield,pronominal,gautham,resellers,ethers,quarrelled,dolna,stragglers,asami,tangut,passos,educacion,sharaf,texel,berio,bethpage,bezalel,marfa,noronha,36ers,genteel,avram,shilton,compensates,sweetener,reinstalled,disables,noether,1590s,balakrishnan,kotaro,northallerton,cataclysm,gholam,cancellara,schiphol,commends,longinus,albinism,gemayel,hamamatsu,volos,islamism,sidereal,pecuniary,diggings,townsquare,neosho,lushan,chittoor,akhil,disputation,desiccation,cambodians,thwarting,deliberated,ellipsis,bahini,susumu,separators,kohneh,plebeians,kultur,ogaden,pissarro,trypeta,latur,liaodong,vetting,datong,sohail,alchemists,lengthwise,unevenly,masterly,microcontrollers,occupier,deviating,farringdon,baccalaureat,theocracy,chebyshev,archivists,jayaram,ineffectiveness,scandinavians,jacobins,encomienda,nambu,g/cm3,catesby,paavo,heeded,rhodium,idealised,10deg,infective,mecyclothorax,halevy,sheared,minbari,audax,lusatian,rebuffs,hitfix,fastener,subjugate,tarun,binet,compuserve,synthesiser,keisuke,amalric,ligatures,tadashi,ignazio,abramovich,groundnut,otomo,maeve,mortlake,ostrogoths,antillean,todor,recto,millimetre,espousing,inaugurate,paracetamol,galvanic,harpalinae,jedrzejow,reassessment,langlands,civita,mikan,stikine,bijar,imamate,istana,kaiserliche,erastus,federale,cytosine,expansionism,hommes,norrland,smriti,snapdragon,gulab,taleb,lossy,khattab,urbanised,sesto,rekord,diffuser,desam,morganatic,silting,pacts,extender,beauharnais,purley,bouches,halfpipe,discontinuities,houthi,farmville,animism,horni,saadi,interpretative,blockades,symeon,biogeographic,transcaucasian,jetties,landrieu,astrocytes,conjunto,stumpings,weevils,geysers,redux,arching,romanus,tazeh,marcellinus,casein,opava,misrata,anare,sattar,declarer,dreux,oporto,venta,vallis,icosahedron,cortona,lachine,mohammedan,sandnes,zynga,clarin,diomedes,tsuyoshi,pribram,gulbarga,chartist,superettan,boscawen,altus,subang,gating,epistolary,vizianagaram,ogdensburg,panna,thyssen,tarkovsky,dzogchen,biograph,seremban,unscientific,nightjar,legco,deism,n.w.a,sudha,siskel,sassou,flintlock,jovial,montbeliard,pallida,formula_66,tranquillity,nisei,adornment,'people,yamhill,hockeyallsvenskan,adopters,appian,lowicz,haplotypes,succinctly,starogard,presidencies,kheyrabad,sobibor,kinesiology,cowichan,militum,cromwellian,leiningen,ps1.5,concourses,dalarna,goldfield,brzeg,faeces,aquarii,matchless,harvesters,181st,numismatics,korfball,sectioned,transpires,facultative,brandishing,kieron,forages,menai,glutinous,debarge,heathfield,1580s,malang,photoelectric,froome,semiotic,alwar,grammophon,chiaroscuro,mentalist,maramures,flacco,liquors,aleutians,marvell,sutlej,patnaik,qassam,flintoff,bayfield,haeckel,sueno,avicii,exoplanets,hoshi,annibale,vojislav,honeycombs,celebrant,rendsburg,veblen,quails,141st,carronades,savar,narrations,jeeva,ontologies,hedonistic,marinette,godot,munna,bessarabian,outrigger,thame,gravels,hoshino,falsifying,stereochemistry,nacionalista,medially,radula,ejecting,conservatorio,odile,ceiba,jaina,essonne,isometry,allophones,recidivism,iveco,ganda,grammarians,jagan,signposted,uncompressed,facilitators,constancy,ditko,propulsive,impaling,interbank,botolph,amlaib,intergroup,sorbus,cheka,debye,praca,adorning,presbyteries,dormition,strategos,qarase,pentecostals,beehives,hashemite,goldust,euronext,egress,arpanet,soames,jurchens,slovenska,copse,kazim,appraisals,marischal,mineola,sharada,caricaturist,sturluson,galba,faizabad,overwintering,grete,uyezds,didsbury,libreville,ablett,microstructure,anadolu,belenenses,elocution,cloaks,timeslots,halden,rashidun,displaces,sympatric,germanus,tuples,ceska,equalize,disassembly,krautrock,babangida,memel,deild,gopala,hematology,underclass,sangli,wawrinka,assur,toshack,refrains,nicotinic,bhagalpur,badami,racetracks,pocatello,walgreens,nazarbayev,occultation,spinnaker,geneon,josias,hydrolyzed,dzong,corregimiento,waistcoat,thermoplastic,soldered,anticancer,lactobacillus,shafi'i,carabus,adjournment,schlumberger,triceratops,despotate,mendicant,krishnamurti,bahasa,earthworm,lavoisier,noetherian,kalki,fervently,bhawan,saanich,coquille,gannet,motagua,kennels,mineralization,fitzherbert,svein,bifurcated,hairdressing,felis,abounded,dimers,fervour,hebdo,bluffton,aetna,corydon,clevedon,carneiro,subjectively,deutz,gastropoda,overshot,concatenation,varman,carolla,maharshi,mujib,inelastic,riverhead,initialized,safavids,rohini,caguas,bulges,fotbollforbund,hefei,spithead,westville,maronites,lytham,americo,gediminas,stephanus,chalcolithic,hijra,gnu/linux,predilection,rulership,sterility,haidar,scarlatti,saprissa,sviatoslav,pointedly,sunroof,guarantor,thevar,airstrips,pultusk,sture,129th,divinities,daizong,dolichoderus,cobourg,maoists,swordsmanship,uprated,bohme,tashi,largs,chandi,bluebeard,householders,richardsonian,drepanidae,antigonish,elbasan,occultism,marca,hypergeometric,oirat,stiglitz,ignites,dzungar,miquelon,pritam,d'automne,ulidiid,niamey,vallecano,fondo,billiton,incumbencies,raceme,chambery,cadell,barenaked,kagame,summerside,haussmann,hatshepsut,apothecaries,criollo,feint,nasals,timurid,feltham,plotinus,oxygenation,marginata,officinalis,salat,participations,ising,downe,izumo,unguided,pretence,coursed,haruna,viscountcy,mainstage,justicia,powiat,takara,capitoline,implacable,farben,stopford,cosmopterix,tuberous,kronecker,galatians,kweli,dogmas,exhorted,trebinje,skanda,newlyn,ablative,basidia,bhiwani,encroachments,stranglers,regrouping,tubal,shoestring,wawel,anionic,mesenchymal,creationists,pyrophosphate,moshi,despotism,powerbook,fatehpur,rupiah,segre,ternate,jessore,b.i.g,shevardnadze,abounds,gliwice,densest,memoria,suborbital,vietcong,ratepayers,karunanidhi,toolbar,descents,rhymney,exhortation,zahedan,carcinomas,hyperbaric,botvinnik,billets,neuropsychological,tigranes,hoards,chater,biennially,thistles,scotus,wataru,flotillas,hungama,monopolistic,payouts,vetch,generalissimo,caries,naumburg,piran,blizzards,escalates,reactant,shinya,theorize,rizzoli,transitway,ecclesiae,streptomyces,cantal,nisibis,superconductor,unworkable,thallus,roehampton,scheckter,viceroys,makuuchi,ilkley,superseding,takuya,klodzko,borbon,raspberries,operand,w.a.k.o,sarabande,factionalism,egalitarianism,temasek,torbat,unscripted,jorma,westerner,perfective,vrije,underlain,goldfrapp,blaenau,jomon,barthes,drivetime,bassa,bannock,umaga,fengxiang,zulus,sreenivasan,farces,codice_10,freeholder,poddebice,imperialists,deregulated,wingtip,o'hagan,pillared,overtone,hofstadter,149th,kitano,saybrook,standardizing,aldgate,staveley,o'flaherty,hundredths,steerable,soltan,empted,cruyff,intramuros,taluks,cotonou,marae,karur,figueres,barwon,lucullus,niobe,zemlya,lathes,homeported,chaux,amyotrophic,opines,exemplars,bhamo,homomorphisms,gauleiter,ladin,mafiosi,airdrieonians,b/soul,decal,transcaucasia,solti,defecation,deaconess,numidia,sampradaya,normalised,wingless,schwaben,alnus,cinerama,yakutsk,ketchikan,orvieto,unearned,monferrato,rotem,aacsb,loong,decoders,skerries,cardiothoracic,repositioning,pimpernel,yohannan,tenebrionoidea,nargis,nouvel,costliest,interdenominational,noize,redirecting,zither,morcha,radiometric,frequenting,irtysh,gbagbo,chakri,litvinenko,infotainment,ravensbruck,harith,corbels,maegashira,jousting,natan,novus,falcao,minis,railed,decile,rauma,ramaswamy,cavitation,paranaque,berchtesgaden,reanimated,schomberg,polysaccharides,exclusionary,cleon,anurag,ravaging,dhanush,mitchells,granule,contemptuous,keisei,rolleston,atlantean,yorkist,daraa,wapping,micrometer,keeneland,comparably,baranja,oranje,schlafli,yogic,dinajpur,unimpressive,masashi,recreativo,alemannic,petersfield,naoko,vasudeva,autosport,rajat,marella,busko,wethersfield,ssris,soulcalibur,kobani,wildland,rookery,hoffenheim,kauri,aliphatic,balaclava,ferrite,publicise,victorias,theism,quimper,chapbook,functionalist,roadbed,ulyanovsk,cupen,purpurea,calthorpe,teofilo,mousavi,cochlea,linotype,detmold,ellerslie,gakkai,telkom,southsea,subcontractor,inguinal,philatelists,zeebrugge,piave,trochidae,dempo,spoilt,saharanpur,mihrab,parasympathetic,barbarous,chartering,antiqua,katsina,bugis,categorizes,altstadt,kandyan,pambansa,overpasses,miters,assimilating,finlandia,uneconomic,am/fm,harpsichordist,dresdner,luminescence,authentically,overpowers,magmatic,cliftonville,oilfields,skirted,berthe,cuman,oakham,frelimo,glockenspiel,confection,saxophonists,piaseczno,multilevel,antipater,levying,maltreatment,velho,opoczno,harburg,pedophilia,unfunded,palettes,plasterwork,breve,dharmendra,auchinleck,nonesuch,blackmun,libretti,rabbani,145th,hasselbeck,kinnock,malate,vanden,cloverdale,ashgabat,nares,radians,steelworkers,sabor,possums,catterick,hemispheric,ostra,outpaced,dungeness,almshouse,penryn,texians,1000m,franchitti,incumbency,texcoco,newar,tramcars,toroidal,meitetsu,spellbound,agronomist,vinifera,riata,bunko,pinas,ba'al,github,vasilyevich,obsolescent,geodesics,ancestries,tujue,capitalised,unassigned,throng,unpaired,psychometric,skegness,exothermic,buffered,kristiansund,tongued,berenger,basho,alitalia,prolongation,archaeologically,fractionation,cyprinid,echinoderms,agriculturally,justiciar,sonam,ilium,baits,danceable,grazer,ardahan,grassed,preemption,glassworks,hasina,ugric,umbra,wahhabi,vannes,tinnitus,capitaine,tikrit,lisieux,scree,hormuz,despenser,jagiellon,maisonneuve,gandaki,santarem,basilicas,lancing,landskrona,weilburg,fireside,elysian,isleworth,krishnamurthy,filton,cynon,tecmo,subcostal,scalars,triglycerides,hyperplane,farmingdale,unione,meydan,pilings,mercosur,reactivate,akiba,fecundity,jatra,natsume,zarqawi,preta,masao,presbyter,oakenfold,rhodri,ferran,ruizong,cloyne,nelvana,epiphanius,borde,scutes,strictures,troughton,whitestone,sholom,toyah,shingon,kutuzov,abelard,passant,lipno,cafeterias,residuals,anabaptists,paratransit,criollos,pleven,radiata,destabilizing,hadiths,bazaars,mannose,taiyo,crookes,welbeck,baoding,archelaus,nguesso,alberni,wingtips,herts,viasat,lankans,evreux,wigram,fassbinder,ryuichi,storting,reducible,olesnica,znojmo,hyannis,theophanes,flatiron,mustering,rajahmundry,kadir,wayang,prome,lethargy,zubin,illegality,conall,dramedy,beerbohm,hipparchus,ziarat,ryuji,shugo,glenorchy,microarchitecture,morne,lewinsky,cauvery,battenberg,hyksos,wayanad,hamilcar,buhari,brazo,bratianu,solms,aksaray,elamite,chilcotin,bloodstock,sagara,dolny,reunified,umlaut,proteaceae,camborne,calabrian,dhanbad,vaxjo,cookware,potez,rediffusion,semitones,lamentations,allgau,guernica,suntory,pleated,stationing,urgell,gannets,bertelsmann,entryway,raphitomidae,acetaldehyde,nephrology,categorizing,beiyang,permeate,tourney,geosciences,khana,masayuki,crucis,universitaria,slaskie,khaimah,finno,advani,astonishingly,tubulin,vampiric,jeolla,sociale,cleethorpes,badri,muridae,suzong,debater,decimation,kenyans,mutualism,pontifex,middlemen,insee,halevi,lamentation,psychopathy,brassey,wenders,kavya,parabellum,prolactin,inescapable,apses,malignancies,rinzai,stigmatized,menahem,comox,ateliers,welshpool,setif,centimetre,truthfulness,downfield,drusus,woden,glycosylation,emanated,agulhas,dalkeith,jazira,nucky,unifil,jobim,operon,oryzomys,heroically,seances,supernumerary,backhouse,hashanah,tatler,imago,invert,hayato,clockmaker,kingsmill,swiecie,analogously,golconda,poste,tacitly,decentralised,ge'ez,diplomatically,fossiliferous,linseed,mahavira,pedestals,archpriest,byelection,domiciled,jeffersonian,bombus,winegrowing,waukegan,uncultivated,haverfordwest,saumur,communally,disbursed,cleeve,zeljeznicar,speciosa,vacationers,sigur,vaishali,zlatko,iftikhar,cropland,transkei,incompleteness,bohra,subantarctic,slieve,physiologic,similis,klerk,replanted,'right,chafee,reproducible,bayburt,regicide,muzaffarpur,plurals,hanyu,orthologs,diouf,assailed,kamui,tarik,dodecanese,gorne,on/off,179th,shimoga,granaries,carlists,valar,tripolitania,sherds,simmern,dissociated,isambard,polytechnical,yuvraj,brabazon,antisense,pubmed,glans,minutely,masaaki,raghavendra,savoury,podcasting,tachi,bienville,gongsun,ridgely,deform,yuichi,binders,canna,carcetti,llobregat,implored,berri,njegos,intermingled,offload,athenry,motherhouse,corpora,kakinada,dannebrog,imperio,prefaces,musicologists,aerospatiale,shirai,nagapattinam,servius,cristoforo,pomfret,reviled,entebbe,stane,east/west,thermometers,matriarchal,siglo,bodil,legionnaire,ze'ev,theorizing,sangeetha,horticulturist,uncountable,lookalike,anoxic,ionospheric,genealogists,chicopee,imprinting,popish,crematoria,diamondback,cyathea,hanzhong,cameramen,halogaland,naklo,waclaw,storehouses,flexed,comuni,frits,glauca,nilgiris,compresses,nainital,continuations,albay,hypoxic,samajwadi,dunkerque,nanticoke,sarwar,interchanged,jubal,corba,jalgaon,derleth,deathstroke,magny,vinnytsia,hyphenated,rimfire,sawan,boehner,disrepute,normalize,aromanian,dualistic,approximant,chama,karimabad,barnacles,sanok,stipends,dyfed,rijksmuseum,reverberation,suncorp,fungicides,reverie,spectrograph,stereophonic,niazi,ordos,alcan,karaite,lautrec,tableland,lamellar,rieti,langmuir,russula,webern,tweaks,hawick,southerner,morphy,naturalisation,enantiomer,michinoku,barbettes,relieves,carburettors,redruth,oblates,vocabularies,mogilev,bagmati,galium,reasserted,extolled,symon,eurosceptic,inflections,tirtha,recompense,oruro,roping,gouverneur,pared,yayoi,watermills,retooled,leukocytes,jubilant,mazhar,nicolau,manheim,touraine,bedser,hambledon,kohat,powerhouses,tlemcen,reuven,sympathetically,afrikaners,interes,handcrafts,etcher,baddeley,wodonga,amaury,155th,vulgarity,pompadour,automorphisms,1540s,oppositions,prekmurje,deryni,fortifying,arcuate,mahila,bocage,uther,nozze,slashes,atlantica,hadid,rhizomatous,azeris,'with,osmena,lewisville,innervated,bandmaster,outcropping,parallelogram,dominicana,twang,ingushetia,extensional,ladino,sastry,zinoviev,relatable,nobilis,cbeebies,hitless,eulima,sporangia,synge,longlisted,criminalized,penitential,weyden,tubule,volyn,priestesses,glenbrook,kibbutzim,windshaft,canadair,falange,zsolt,bonheur,meine,archangels,safeguarded,jamaicans,malarial,teasers,badging,merseyrail,operands,pulsars,gauchos,biotin,bambara,necaxa,egmond,tillage,coppi,anxiolytic,preah,mausoleums,plautus,feroz,debunked,187th,belediyespor,mujibur,wantage,carboxyl,chettiar,murnau,vagueness,racemic,backstretch,courtland,municipio,palpatine,dezful,hyperbola,sreekumar,chalons,altay,arapahoe,tudors,sapieha,quilon,burdensome,kanya,xxviii,recension,generis,siphuncle,repressor,bitrate,mandals,midhurst,dioxin,democratique,upholds,rodez,cinematographic,epoque,jinping,rabelais,zhytomyr,glenview,rebooted,khalidi,reticulata,122nd,monnaie,passersby,ghazals,europaea,lippmann,earthbound,tadic,andorran,artvin,angelicum,banksy,epicentre,resemblances,shuttled,rathaus,bernt,stonemasons,balochi,siang,tynemouth,cygni,biosynthetic,precipitates,sharecroppers,d'annunzio,softbank,shiji,apeldoorn,polycyclic,wenceslas,wuchang,samnites,tamarack,silmarillion,madinah,palaeontology,kirchberg,sculpin,rohtak,aquabats,oviparous,thynne,caney,blimps,minimalistic,whatcom,palatalization,bardstown,direct3d,paramagnetic,kamboja,khash,globemaster,lengua,matej,chernigov,swanage,arsenals,cascadia,cundinamarca,tusculum,leavers,organics,warplanes,'three,exertions,arminius,gandharva,inquires,comercio,kuopio,chabahar,plotlines,mersenne,anquetil,paralytic,buckminster,ambit,acrolophus,quantifiers,clacton,ciliary,ansaldo,fergana,egoism,thracians,chicoutimi,northbrook,analgesia,brotherhoods,hunza,adriaen,fluoridation,snowfalls,soundboard,fangoria,cannibalistic,orthogonius,chukotka,dindigul,manzoni,chainz,macromedia,beltline,muruga,schistura,provable,litex,initio,pneumoniae,infosys,cerium,boonton,cannonballs,d'une,solvency,mandurah,houthis,dolmens,apologists,radioisotopes,blaxploitation,poroshenko,stawell,coosa,maximilien,tempelhof,espouse,declaratory,hambro,xalapa,outmoded,mihiel,benefitting,desirous,archeparchy,repopulated,telescoping,captor,mackaye,disparaged,ramanathan,crowne,tumbled,technetium,silted,chedi,nievre,hyeon,cartoonish,interlock,infocom,rediff.com,dioramas,timekeeping,concertina,kutaisi,cesky,lubomirski,unapologetic,epigraphic,stalactites,sneha,biofilm,falconry,miraflores,catena,'outstanding,prospekt,apotheosis,o'odham,pacemakers,arabica,gandhinagar,reminisces,iroquoian,ornette,tilling,neoliberalism,chameleons,pandava,prefontaine,haiyan,gneisenau,utama,bando,reconstitution,azaria,canola,paratroops,ayckbourn,manistee,stourton,manifestos,lympne,denouement,tractatus,rakim,bellflower,nanometer,sassanids,turlough,presbyterianism,varmland,20deg,phool,nyerere,almohad,manipal,vlaanderen,quickness,removals,makow,circumflex,eatery,morane,fondazione,alkylation,unenforceable,galliano,silkworm,junior/senior,abducts,phlox,konskie,lofoten,buuren,glyphosate,faired,naturae,cobbles,taher,skrulls,dostoevsky,walkout,wagnerian,orbited,methodically,denzil,sarat,extraterritorial,kohima,d'armor,brinsley,rostropovich,fengtian,comitatus,aravind,moche,wrangell,giscard,vantaa,viljandi,hakoah,seabees,muscatine,ballade,camanachd,sothern,mullioned,durad,margraves,maven,arete,chandni,garifuna,142nd,reading/literature,thickest,intensifies,trygve,khaldun,perinatal,asana,powerline,acetylation,nureyev,omiya,montesquieu,riverwalk,marly,correlating,intermountain,bulgar,hammerheads,underscores,wiretapping,quatrain,ruisseau,newsagent,tuticorin,polygyny,hemsworth,partisanship,banna,istrian,evaporator".split(","),
    female_names: "mary,patricia,linda,barbara,elizabeth,jennifer,maria,susan,margaret,dorothy,lisa,nancy,karen,betty,helen,sandra,donna,carol,ruth,sharon,michelle,laura,sarah,kimberly,deborah,jessica,shirley,cynthia,angela,melissa,brenda,amy,anna,rebecca,virginia,kathleen,pamela,martha,debra,amanda,stephanie,carolyn,christine,marie,janet,catherine,frances,ann,joyce,diane,alice,julie,heather,teresa,doris,gloria,evelyn,jean,cheryl,mildred,katherine,joan,ashley,judith,rose,janice,kelly,nicole,judy,christina,kathy,theresa,beverly,denise,tammy,irene,jane,lori,rachel,marilyn,andrea,kathryn,louise,sara,anne,jacqueline,wanda,bonnie,julia,ruby,lois,tina,phyllis,norma,paula,diana,annie,lillian,emily,robin,peggy,crystal,gladys,rita,dawn,connie,florence,tracy,edna,tiffany,carmen,rosa,cindy,grace,wendy,victoria,edith,kim,sherry,sylvia,josephine,thelma,shannon,sheila,ethel,ellen,elaine,marjorie,carrie,charlotte,monica,esther,pauline,emma,juanita,anita,rhonda,hazel,amber,eva,debbie,april,leslie,clara,lucille,jamie,joanne,eleanor,valerie,danielle,megan,alicia,suzanne,michele,gail,bertha,darlene,veronica,jill,erin,geraldine,lauren,cathy,joann,lorraine,lynn,sally,regina,erica,beatrice,dolores,bernice,audrey,yvonne,annette,marion,dana,stacy,ana,renee,ida,vivian,roberta,holly,brittany,melanie,loretta,yolanda,jeanette,laurie,katie,kristen,vanessa,alma,sue,elsie,beth,jeanne,vicki,carla,tara,rosemary,eileen,terri,gertrude,lucy,tonya,ella,stacey,wilma,gina,kristin,jessie,natalie,agnes,vera,charlene,bessie,delores,melinda,pearl,arlene,maureen,colleen,allison,tamara,joy,georgia,constance,lillie,claudia,jackie,marcia,tanya,nellie,minnie,marlene,heidi,glenda,lydia,viola,courtney,marian,stella,caroline,dora,vickie,mattie,maxine,irma,mabel,marsha,myrtle,lena,christy,deanna,patsy,hilda,gwendolyn,jennie,nora,margie,nina,cassandra,leah,penny,kay,priscilla,naomi,carole,olga,billie,dianne,tracey,leona,jenny,felicia,sonia,miriam,velma,becky,bobbie,violet,kristina,toni,misty,mae,shelly,daisy,ramona,sherri,erika,katrina,claire,lindsey,lindsay,geneva,guadalupe,belinda,margarita,sheryl,cora,faye,ada,sabrina,isabel,marguerite,hattie,harriet,molly,cecilia,kristi,brandi,blanche,sandy,rosie,joanna,iris,eunice,angie,inez,lynda,madeline,amelia,alberta,genevieve,monique,jodi,janie,kayla,sonya,jan,kristine,candace,fannie,maryann,opal,alison,yvette,melody,luz,susie,olivia,flora,shelley,kristy,mamie,lula,lola,verna,beulah,antoinette,candice,juana,jeannette,pam,kelli,whitney,bridget,karla,celia,latoya,patty,shelia,gayle,della,vicky,lynne,sheri,marianne,kara,jacquelyn,erma,blanca,myra,leticia,pat,krista,roxanne,angelica,robyn,adrienne,rosalie,alexandra,brooke,bethany,sadie,bernadette,traci,jody,kendra,nichole,rachael,mable,ernestine,muriel,marcella,elena,krystal,angelina,nadine,kari,estelle,dianna,paulette,lora,mona,doreen,rosemarie,desiree,antonia,janis,betsy,christie,freda,meredith,lynette,teri,cristina,eula,leigh,meghan,sophia,eloise,rochelle,gretchen,cecelia,raquel,henrietta,alyssa,jana,gwen,jenna,tricia,laverne,olive,tasha,silvia,elvira,delia,kate,patti,lorena,kellie,sonja,lila,lana,darla,mindy,essie,mandy,lorene,elsa,josefina,jeannie,miranda,dixie,lucia,marta,faith,lela,johanna,shari,camille,tami,shawna,elisa,ebony,melba,ora,nettie,tabitha,ollie,winifred,kristie,alisha,aimee,rena,myrna,marla,tammie,latasha,bonita,patrice,ronda,sherrie,addie,francine,deloris,stacie,adriana,cheri,abigail,celeste,jewel,cara,adele,rebekah,lucinda,dorthy,effie,trina,reba,sallie,aurora,lenora,etta,lottie,kerri,trisha,nikki,estella,francisca,josie,tracie,marissa,karin,brittney,janelle,lourdes,laurel,helene,fern,elva,corinne,kelsey,ina,bettie,elisabeth,aida,caitlin,ingrid,iva,eugenia,christa,goldie,maude,jenifer,therese,dena,lorna,janette,latonya,candy,consuelo,tamika,rosetta,debora,cherie,polly,dina,jewell,fay,jillian,dorothea,nell,trudy,esperanza,patrica,kimberley,shanna,helena,cleo,stefanie,rosario,ola,janine,mollie,lupe,alisa,lou,maribel,susanne,bette,susana,elise,cecile,isabelle,lesley,jocelyn,paige,joni,rachelle,leola,daphne,alta,ester,petra,graciela,imogene,jolene,keisha,lacey,glenna,gabriela,keri,ursula,lizzie,kirsten,shana,adeline,mayra,jayne,jaclyn,gracie,sondra,carmela,marisa,rosalind,charity,tonia,beatriz,marisol,clarice,jeanine,sheena,angeline,frieda,lily,shauna,millie,claudette,cathleen,angelia,gabrielle,autumn,katharine,jodie,staci,lea,christi,justine,elma,luella,margret,dominique,socorro,martina,margo,mavis,callie,bobbi,maritza,lucile,leanne,jeannine,deana,aileen,lorie,ladonna,willa,manuela,gale,selma,dolly,sybil,abby,ivy,dee,winnie,marcy,luisa,jeri,magdalena,ofelia,meagan,audra,matilda,leila,cornelia,bianca,simone,bettye,randi,virgie,latisha,barbra,georgina,eliza,leann,bridgette,rhoda,haley,adela,nola,bernadine,flossie,ila,greta,ruthie,nelda,minerva,lilly,terrie,letha,hilary,estela,valarie,brianna,rosalyn,earline,catalina,ava,mia,clarissa,lidia,corrine,alexandria,concepcion,tia,sharron,rae,dona,ericka,jami,elnora,chandra,lenore,neva,marylou,melisa,tabatha,serena,avis,allie,sofia,jeanie,odessa,nannie,harriett,loraine,penelope,milagros,emilia,benita,allyson,ashlee,tania,esmeralda,eve,pearlie,zelma,malinda,noreen,tameka,saundra,hillary,amie,althea,rosalinda,lilia,alana,clare,alejandra,elinor,lorrie,jerri,darcy,earnestine,carmella,noemi,marcie,liza,annabelle,louisa,earlene,mallory,carlene,nita,selena,tanisha,katy,julianne,lakisha,edwina,maricela,margery,kenya,dollie,roxie,roslyn,kathrine,nanette,charmaine,lavonne,ilene,tammi,suzette,corine,kaye,chrystal,lina,deanne,lilian,juliana,aline,luann,kasey,maryanne,evangeline,colette,melva,lawanda,yesenia,nadia,madge,kathie,ophelia,valeria,nona,mitzi,mari,georgette,claudine,fran,alissa,roseann,lakeisha,susanna,reva,deidre,chasity,sheree,elvia,alyce,deirdre,gena,briana,araceli,katelyn,rosanne,wendi,tessa,berta,marva,imelda,marietta,marci,leonor,arline,sasha,madelyn,janna,juliette,deena,aurelia,josefa,augusta,liliana,lessie,amalia,savannah,anastasia,vilma,natalia,rosella,lynnette,corina,alfreda,leanna,amparo,coleen,tamra,aisha,wilda,karyn,maura,mai,evangelina,rosanna,hallie,erna,enid,mariana,lacy,juliet,jacklyn,freida,madeleine,mara,cathryn,lelia,casandra,bridgett,angelita,jannie,dionne,annmarie,katina,beryl,millicent,katheryn,diann,carissa,maryellen,liz,lauri,helga,gilda,rhea,marquita,hollie,tisha,tamera,angelique,francesca,kaitlin,lolita,florine,rowena,reyna,twila,fanny,janell,ines,concetta,bertie,alba,brigitte,alyson,vonda,pansy,elba,noelle,letitia,deann,brandie,louella,leta,felecia,sharlene,lesa,beverley,isabella,herminia,terra,celina,tori,octavia,jade,denice,germaine,michell,cortney,nelly,doretha,deidra,monika,lashonda,judi,chelsey,antionette,margot,adelaide,leeann,elisha,dessie,libby,kathi,gayla,latanya,mina,mellisa,kimberlee,jasmin,renae,zelda,elda,justina,gussie,emilie,camilla,abbie,rocio,kaitlyn,edythe,ashleigh,selina,lakesha,geri,allene,pamala,michaela,dayna,caryn,rosalia,jacquline,rebeca,marybeth,krystle,iola,dottie,belle,griselda,ernestina,elida,adrianne,demetria,delma,jaqueline,arleen,virgina,retha,fatima,tillie,eleanore,cari,treva,wilhelmina,rosalee,maurine,latrice,jena,taryn,elia,debby,maudie,jeanna,delilah,catrina,shonda,hortencia,theodora,teresita,robbin,danette,delphine,brianne,nilda,danna,cindi,bess,iona,winona,vida,rosita,marianna,racheal,guillermina,eloisa,celestine,caren,malissa,lona,chantel,shellie,marisela,leora,agatha,soledad,migdalia,ivette,christen,athena,janel,veda,pattie,tessie,tera,marilynn,lucretia,karrie,dinah,daniela,alecia,adelina,vernice,shiela,portia,merry,lashawn,dara,tawana,verda,alene,zella,sandi,rafaela,maya,kira,candida,alvina,suzan,shayla,lettie,samatha,oralia,matilde,larissa,vesta,renita,delois,shanda,phillis,lorri,erlinda,cathrine,barb,isabell,ione,gisela,roxanna,mayme,kisha,ellie,mellissa,dorris,dalia,bella,annetta,zoila,reta,reina,lauretta,kylie,christal,pilar,charla,elissa,tiffani,tana,paulina,leota,breanna,jayme,carmel,vernell,tomasa,mandi,dominga,santa,melodie,lura,alexa,tamela,mirna,kerrie,venus,felicita,cristy,carmelita,berniece,annemarie,tiara,roseanne,missy,cori,roxana,pricilla,kristal,jung,elyse,haydee,aletha,bettina,marge,gillian,filomena,zenaida,harriette,caridad,vada,aretha,pearline,marjory,marcela,flor,evette,elouise,alina,damaris,catharine,belva,nakia,marlena,luanne,lorine,karon,dorene,danita,brenna,tatiana,louann,julianna,andria,philomena,lucila,leonora,dovie,romona,mimi,jacquelin,gaye,tonja,misti,chastity,stacia,roxann,micaela,velda,marlys,johnna,aura,ivonne,hayley,nicki,majorie,herlinda,yadira,perla,gregoria,antonette,shelli,mozelle,mariah,joelle,cordelia,josette,chiquita,trista,laquita,georgiana,candi,shanon,hildegard,stephany,magda,karol,gabriella,tiana,roma,richelle,oleta,jacque,idella,alaina,suzanna,jovita,tosha,nereida,marlyn,kyla,delfina,tena,stephenie,sabina,nathalie,marcelle,gertie,darleen,thea,sharonda,shantel,belen,venessa,rosalina,genoveva,clementine,rosalba,renate,renata,georgianna,floy,dorcas,ariana,tyra,theda,mariam,juli,jesica,vikki,verla,roselyn,melvina,jannette,ginny,debrah,corrie,violeta,myrtis,latricia,collette,charleen,anissa,viviana,twyla,nedra,latonia,hellen,fabiola,annamarie,adell,sharyn,chantal,niki,maud,lizette,lindy,kesha,jeana,danelle,charline,chanel,valorie,dortha,cristal,sunny,leone,leilani,gerri,debi,andra,keshia,eulalia,easter,dulce,natividad,linnie,kami,georgie,catina,brook,alda,winnifred,sharla,ruthann,meaghan,magdalene,lissette,adelaida,venita,trena,shirlene,shameka,elizebeth,dian,shanta,latosha,carlotta,windy,rosina,mariann,leisa,jonnie,dawna,cathie,astrid,laureen,janeen,holli,fawn,vickey,teressa,shante,rubye,marcelina,chanda,terese,scarlett,marnie,lulu,lisette,jeniffer,elenor,dorinda,donita,carman,bernita,altagracia,aleta,adrianna,zoraida,lyndsey,janina,starla,phylis,phuong,kyra,charisse,blanch,sanjuanita,rona,nanci,marilee,maranda,brigette,sanjuana,marita,kassandra,joycelyn,felipa,chelsie,bonny,mireya,lorenza,kyong,ileana,candelaria,sherie,lucie,leatrice,lakeshia,gerda,edie,bambi,marylin,lavon,hortense,garnet,evie,tressa,shayna,lavina,kyung,jeanetta,sherrill,shara,phyliss,mittie,anabel,alesia,thuy,tawanda,joanie,tiffanie,lashanda,karissa,enriqueta,daria,daniella,corinna,alanna,abbey,roxane,roseanna,magnolia,lida,joellen,coral,carleen,tresa,peggie,novella,nila,maybelle,jenelle,carina,nova,melina,marquerite,margarette,josephina,evonne,cinthia,albina,toya,tawnya,sherita,myriam,lizabeth,lise,keely,jenni,giselle,cheryle,ardith,ardis,alesha,adriane,shaina,linnea,karolyn,felisha,dori,darci,artie,armida,zola,xiomara,vergie,shamika,nena,nannette,maxie,lovie,jeane,jaimie,inge,farrah,elaina,caitlyn,felicitas,cherly,caryl,yolonda,yasmin,teena,prudence,pennie,nydia,mackenzie,orpha,marvel,lizbeth,laurette,jerrie,hermelinda,carolee,tierra,mirian,meta,melony,kori,jennette,jamila,yoshiko,susannah,salina,rhiannon,joleen,cristine,ashton,aracely,tomeka,shalonda,marti,lacie,kala,jada,ilse,hailey,brittani,zona,syble,sherryl,nidia,marlo,kandice,kandi,alycia,ronna,norene,mercy,ingeborg,giovanna,gemma,christel,audry,zora,vita,trish,stephaine,shirlee,shanika,melonie,mazie,jazmin,inga,hettie,geralyn,fonda,estrella,adella,sarita,rina,milissa,maribeth,golda,evon,ethelyn,enedina,cherise,chana,velva,tawanna,sade,mirta,karie,jacinta,elna,davina,cierra,ashlie,albertha,tanesha,nelle,mindi,lorinda,larue,florene,demetra,dedra,ciara,chantelle,ashly,suzy,rosalva,noelia,lyda,leatha,krystyna,kristan,karri,darline,darcie,cinda,cherrie,awilda,almeda,rolanda,lanette,jerilyn,gisele,evalyn,cyndi,cleta,carin,zina,zena,velia,tanika,charissa,talia,margarete,lavonda,kaylee,kathlene,jonna,irena,ilona,idalia,candis,candance,brandee,anitra,alida,sigrid,nicolette,maryjo,linette,hedwig,christiana,alexia,tressie,modesta,lupita,lita,gladis,evelia,davida,cherri,cecily,ashely,annabel,agustina,wanita,shirly,rosaura,hulda,yetta,verona,thomasina,sibyl,shannan,mechelle,leandra,lani,kylee,kandy,jolynn,ferne,eboni,corene,alysia,zula,nada,moira,lyndsay,lorretta,jammie,hortensia,gaynell,adria,vina,vicenta,tangela,stephine,norine,nella,liana,leslee,kimberely,iliana,glory,felica,emogene,elfriede,eden,eartha,carma,ocie,lennie,kiara,jacalyn,carlota,arielle,otilia,kirstin,kacey,johnetta,joetta,jeraldine,jaunita,elana,dorthea,cami,amada,adelia,vernita,tamar,siobhan,renea,rashida,ouida,nilsa,meryl,kristyn,julieta,danica,breanne,aurea,anglea,sherron,odette,malia,lorelei,leesa,kenna,kathlyn,fiona,charlette,suzie,shantell,sabra,racquel,myong,mira,martine,lucienne,lavada,juliann,elvera,delphia,christiane,charolette,carri,asha,angella,paola,ninfa,leda,stefani,shanell,palma,machelle,lissa,kecia,kathryne,karlene,julissa,jettie,jenniffer,corrina,carolann,alena,rosaria,myrtice,marylee,liane,kenyatta,judie,janey,elmira,eldora,denna,cristi,cathi,zaida,vonnie,viva,vernie,rosaline,mariela,luciana,lesli,karan,felice,deneen,adina,wynona,tarsha,sheron,shanita,shani,shandra,randa,pinkie,nelida,marilou,lyla,laurene,laci,janene,dorotha,daniele,dani,carolynn,carlyn,berenice,ayesha,anneliese,alethea,thersa,tamiko,rufina,oliva,mozell,marylyn,kristian,kathyrn,kasandra,kandace,janae,domenica,debbra,dannielle,chun,arcelia,zenobia,sharen,sharee,lavinia,kacie,jackeline,huong,felisa,emelia,eleanora,cythia,cristin,claribel,anastacia,zulma,zandra,yoko,tenisha,susann,sherilyn,shay,shawanda,romana,mathilda,linsey,keiko,joana,isela,gretta,georgetta,eugenie,desirae,delora,corazon,antonina,anika,willene,tracee,tamatha,nichelle,mickie,maegan,luana,lanita,kelsie,edelmira,bree,afton,teodora,tamie,shena,linh,keli,kaci,danyelle,arlette,albertine,adelle,tiffiny,simona,nicolasa,nichol,nakisha,maira,loreen,kizzy,fallon,christene,bobbye,ying,vincenza,tanja,rubie,roni,queenie,margarett,kimberli,irmgard,idell,hilma,evelina,esta,emilee,dennise,dania,carie,risa,rikki,particia,masako,luvenia,loree,loni,lien,gigi,florencia,denita,billye,tomika,sharita,rana,nikole,neoma,margarite,madalyn,lucina,laila,kali,jenette,gabriele,evelyne,elenora,clementina,alejandrina,zulema,violette,vannessa,thresa,retta,patience,noella,nickie,jonell,chaya,camelia,bethel,anya,suzann,mila,lilla,laverna,keesha,kattie,georgene,eveline,estell,elizbeth,vivienne,vallie,trudie,stephane,magaly,madie,kenyetta,karren,janetta,hermine,drucilla,debbi,celestina,candie,britni,beckie,amina,zita,yolande,vivien,vernetta,trudi,pearle,patrina,ossie,nicolle,loyce,letty,katharina,joselyn,jonelle,jenell,iesha,heide,florinda,florentina,elodia,dorine,brunilda,brigid,ashli,ardella,twana,tarah,shavon,serina,rayna,ramonita,margurite,lucrecia,kourtney,kati,jesenia,crista,ayana,alica,alia,vinnie,suellen,romelia,rachell,olympia,michiko,kathaleen,jolie,jessi,janessa,hana,elease,carletta,britany,shona,salome,rosamond,regena,raina,ngoc,nelia,louvenia,lesia,latrina,laticia,larhonda,jina,jacki,emmy,deeann,coretta,arnetta,thalia,shanice,neta,mikki,micki,lonna,leana,lashunda,kiley,joye,jacqulyn,ignacia,hyun,hiroko,henriette,elayne,delinda,dahlia,coreen,consuela,conchita,babette,ayanna,anette,albertina,shawnee,shaneka,quiana,pamelia,merri,merlene,margit,kiesha,kiera,kaylene,jodee,jenise,erlene,emmie,dalila,daisey,casie,belia,babara,versie,vanesa,shelba,shawnda,nikia,naoma,marna,margeret,madaline,lawana,kindra,jutta,jazmine,janett,hannelore,glendora,gertrud,garnett,freeda,frederica,florance,flavia,carline,beverlee,anjanette,valda,tamala,shonna,sarina,oneida,merilyn,marleen,lurline,lenna,katherin,jeni,gracia,glady,farah,enola,dominque,devona,delana,cecila,caprice,alysha,alethia,vena,theresia,tawny,shakira,samara,sachiko,rachele,pamella,marni,mariel,maren,malisa,ligia,lera,latoria,larae,kimber,kathern,karey,jennefer,janeth,halina,fredia,delisa,debroah,ciera,angelika,andree,altha,vivan,terresa,tanna,sudie,signe,salena,ronni,rebbecca,myrtie,malika,maida,leonarda,kayleigh,ethyl,ellyn,dayle,cammie,brittni,birgit,avelina,asuncion,arianna,akiko,venice,tyesha,tonie,tiesha,takisha,steffanie,sindy,meghann,manda,macie,kellye,kellee,joslyn,inger,indira,glinda,glennis,fernanda,faustina,eneida,elicia,digna,dell,arletta,willia,tammara,tabetha,sherrell,sari,rebbeca,pauletta,natosha,nakita,mammie,kenisha,kazuko,kassie,earlean,daphine,corliss,clotilde,carolyne,bernetta,augustina,audrea,annis,annabell,tennille,tamica,selene,rosana,regenia,qiana,markita,macy,leeanne,laurine,jessenia,janita,georgine,genie,emiko,elvie,deandra,dagmar,corie,collen,cherish,romaine,porsha,pearlene,micheline,merna,margorie,margaretta,lore,jenine,hermina,fredericka,elke,drusilla,dorathy,dione,celena,brigida,allegra,tamekia,synthia,sook,slyvia,rosann,reatha,raye,marquetta,margart,ling,layla,kymberly,kiana,kayleen,katlyn,karmen,joella,emelda,eleni,detra,clemmie,cheryll,chantell,cathey,arnita,arla,angle,angelic,alyse,zofia,thomasine,tennie,sherly,sherley,sharyl,remedios,petrina,nickole,myung,myrle,mozella,louanne,lisha,latia,krysta,julienne,jeanene,jacqualine,isaura,gwenda,earleen,cleopatra,carlie,audie,antonietta,alise,verdell,tomoko,thao,talisha,shemika,savanna,santina,rosia,raeann,odilia,nana,minna,magan,lynelle,karma,joeann,ivana,inell,ilana,gudrun,dreama,crissy,chante,carmelina,arvilla,annamae,alvera,aleida,yanira,vanda,tianna,stefania,shira,nicol,nancie,monserrate,melynda,melany,lovella,laure,kacy,jacquelynn,hyon,gertha,eliana,christena,christeen,charise,caterina,carley,candyce,arlena,ammie,willette,vanita,tuyet,syreeta,penney,nyla,maryam,marya,magen,ludie,loma,livia,lanell,kimberlie,julee,donetta,diedra,denisha,deane,dawne,clarine,cherryl,bronwyn,alla,valery,tonda,sueann,soraya,shoshana,shela,sharleen,shanelle,nerissa,meridith,mellie,maye,maple,magaret,lili,leonila,leonie,leeanna,lavonia,lavera,kristel,kathey,kathe,jann,ilda,hildred,hildegarde,genia,fumiko,evelin,ermelinda,elly,dung,doloris,dionna,danae,berneice,annice,alix,verena,verdie,shawnna,shawana,shaunna,rozella,randee,ranae,milagro,lynell,luise,loida,lisbeth,karleen,junita,jona,isis,hyacinth,hedy,gwenn,ethelene,erline,donya,domonique,delicia,dannette,cicely,branda,blythe,bethann,ashlyn,annalee,alline,yuko,vella,trang,towanda,tesha,sherlyn,narcisa,miguelina,meri,maybell,marlana,marguerita,madlyn,lory,loriann,leonore,leighann,laurice,latesha,laronda,katrice,kasie,kaley,jadwiga,glennie,gearldine,francina,epifania,dyan,dorie,diedre,denese,demetrice,delena,cristie,cleora,catarina,carisa,barbera,almeta,trula,tereasa,solange,sheilah,shavonne,sanora,rochell,mathilde,margareta,maia,lynsey,lawanna,launa,kena,keena,katia,glynda,gaylene,elvina,elanor,danuta,danika,cristen,cordie,coletta,clarita,carmon,brynn,azucena,aundrea,angele,verlie,verlene,tamesha,silvana,sebrina,samira,reda,raylene,penni,norah,noma,mireille,melissia,maryalice,laraine,kimbery,karyl,karine,jolanda,johana,jesusa,jaleesa,jacquelyne,iluminada,hilaria,hanh,gennie,francie,floretta,exie,edda,drema,delpha,barbar,assunta,ardell,annalisa,alisia,yukiko,yolando,wonda,waltraud,veta,temeka,tameika,shirleen,shenita,piedad,ozella,mirtha,marilu,kimiko,juliane,jenice,janay,jacquiline,hilde,elois,echo,devorah,chau,brinda,betsey,arminda,aracelis,apryl,annett,alishia,veola,usha,toshiko,theola,tashia,talitha,shery,renetta,reiko,rasheeda,obdulia,mika,melaine,meggan,marlen,marget,marceline,mana,magdalen,librada,lezlie,latashia,lasandra,kelle,isidra,inocencia,gwyn,francoise,erminia,erinn,dimple,devora,criselda,armanda,arie,ariane,angelena,aliza,adriene,adaline,xochitl,twanna,tomiko,tamisha,taisha,susy,rutha,rhona,noriko,natashia,merrie,marinda,mariko,margert,loris,lizzette,leisha,kaila,joannie,jerrica,jene,jannet,janee,jacinda,herta,elenore,doretta,delaine,daniell,claudie,britta,apolonia,amberly,alease,yuri,waneta,tomi,sharri,sandie,roselle,reynalda,raguel,phylicia,patria,olimpia,odelia,mitzie,minda,mignon,mica,mendy,marivel,maile,lynetta,lavette,lauryn,latrisha,lakiesha,kiersten,kary,josphine,jolyn,jetta,janise,jacquie,ivelisse,glynis,gianna,gaynelle,danyell,danille,dacia,coralee,cher,ceola,arianne,aleshia,yung,williemae,trinh,thora,sherika,shemeka,shaunda,roseline,ricki,melda,mallie,lavonna,latina,laquanda,lala,lachelle,klara,kandis,johna,jeanmarie,jaye,grayce,gertude,emerita,ebonie,clorinda,ching,chery,carola,breann,blossom,bernardine,becki,arletha,argelia,alita,yulanda,yessenia,tobi,tasia,sylvie,shirl,shirely,shella,shantelle,sacha,rebecka,providencia,paulene,misha,miki,marline,marica,lorita,latoyia,lasonya,kerstin,kenda,keitha,kathrin,jaymie,gricelda,ginette,eryn,elina,elfrieda,danyel,cheree,chanelle,barrie,aurore,annamaria,alleen,ailene,aide,yasmine,vashti,treasa,tiffaney,sheryll,sharie,shanae,raisa,neda,mitsuko,mirella,milda,maryanna,maragret,mabelle,luetta,lorina,letisha,latarsha,lanelle,lajuana,krissy,karly,karena,jessika,jerica,jeanelle,jalisa,jacelyn,izola,euna,etha,domitila,dominica,daina,creola,carli,camie,brittny,ashanti,anisha,aleen,adah,yasuko,valrie,tona,tinisha,terisa,taneka,simonne,shalanda,serita,ressie,refugia,olene,margherita,mandie,maire,lyndia,luci,lorriane,loreta,leonia,lavona,lashawnda,lakia,kyoko,krystina,krysten,kenia,kelsi,jeanice,isobel,georgiann,genny,felicidad,eilene,deloise,deedee,conception,clora,cherilyn,calandra,armandina,anisa,tiera,theressa,stephania,sima,shyla,shonta,shera,shaquita,shala,rossana,nohemi,nery,moriah,melita,melida,melani,marylynn,marisha,mariette,malorie,madelene,ludivina,loria,lorette,loralee,lianne,lavenia,laurinda,lashon,kimi,keila,katelynn,jone,joane,jayna,janella,hertha,francene,elinore,despina,delsie,deedra,clemencia,carolin,bulah,brittanie,blondell,bibi,beaulah,beata,annita,agripina,virgen,valene,twanda,tommye,tarra,tari,tammera,shakia,sadye,ruthanne,rochel,rivka,pura,nenita,natisha,ming,merrilee,melodee,marvis,lucilla,leena,laveta,larita,lanie,keren,ileen,georgeann,genna,frida,eufemia,emely,edyth,deonna,deadra,darlena,chanell,cathern,cassondra,cassaundra,bernarda,berna,arlinda,anamaria,vertie,valeri,torri,stasia,sherise,sherill,sanda,ruthe,rosy,robbi,ranee,quyen,pearly,palmira,onita,nisha,niesha,nida,merlyn,mayola,marylouise,marth,margene,madelaine,londa,leontine,leoma,leia,lauralee,lanora,lakita,kiyoko,keturah,katelin,kareen,jonie,johnette,jenee,jeanett,izetta,hiedi,heike,hassie,giuseppina,georgann,fidela,fernande,elwanda,ellamae,eliz,dusti,dotty,cyndy,coralie,celesta,alverta,xenia,wava,vanetta,torrie,tashina,tandy,tambra,tama,stepanie,shila,shaunta,sharan,shaniqua,shae,setsuko,serafina,sandee,rosamaria,priscila,olinda,nadene,muoi,michelina,mercedez,maryrose,marcene,magali,mafalda,lannie,kayce,karoline,kamilah,kamala,justa,joline,jennine,jacquetta,iraida,georgeanna,franchesca,emeline,elane,ehtel,earlie,dulcie,dalene,classie,chere,charis,caroyln,carmina,carita,bethanie,ayako,arica,alysa,alessandra,akilah,adrien,zetta,youlanda,yelena,yahaira,xuan,wendolyn,tijuana,terina,teresia,suzi,sherell,shavonda,shaunte,sharda,shakita,sena,ryann,rubi,riva,reginia,rachal,parthenia,pamula,monnie,monet,michaele,melia,malka,maisha,lisandra,lekisha,lean,lakendra,krystin,kortney,kizzie,kittie,kera,kendal,kemberly,kanisha,julene,jule,johanne,jamee,halley,gidget,fredricka,fleta,fatimah,eusebia,elza,eleonore,dorthey,doria,donella,dinorah,delorse,claretha,christinia,charlyn,bong,belkis,azzie,andera,aiko,adena,yajaira,vania,ulrike,toshia,tifany,stefany,shizue,shenika,shawanna,sharolyn,sharilyn,shaquana,shantay,rozanne,roselee,remona,reanna,raelene,phung,petronila,natacha,nancey,myrl,miyoko,miesha,merideth,marvella,marquitta,marhta,marchelle,lizeth,libbie,lahoma,ladawn,kina,katheleen,katharyn,karisa,kaleigh,junie,julieann,johnsie,janean,jaimee,jackqueline,hisako,herma,helaine,gwyneth,gita,eustolia,emelina,elin,edris,donnette,donnetta,dierdre,denae,darcel,clarisa,cinderella,chia,charlesetta,charita,celsa,cassy,cassi,carlee,bruna,brittaney,brande,billi,antonetta,angla,angelyn,analisa,alane,wenona,wendie,veronique,vannesa,tobie,tempie,sumiko,sulema,somer,sheba,sharice,shanel,shalon,rosio,roselia,renay,rema,reena,ozie,oretha,oralee,ngan,nakesha,milly,marybelle,margrett,maragaret,manie,lurlene,lillia,lieselotte,lavelle,lashaunda,lakeesha,kaycee,kalyn,joya,joette,jenae,janiece,illa,grisel,glayds,genevie,gala,fredda,eleonor,debera,deandrea,corrinne,cordia,contessa,colene,cleotilde,chantay,cecille,beatris,azalee,arlean,ardath,anjelica,anja,alfredia,aleisha,zada,yuonne,xiao,willodean,vennie,vanna,tyisha,tova,torie,tonisha,tilda,tien,sirena,sherril,shanti,shan,senaida,samella,robbyn,renda,reita,phebe,paulita,nobuko,nguyet,neomi,mikaela,melania,maximina,marg,maisie,lynna,lilli,lashaun,lakenya,lael,kirstie,kathline,kasha,karlyn,karima,jovan,josefine,jennell,jacqui,jackelyn,hien,grazyna,florrie,floria,eleonora,dwana,dorla,delmy,deja,dede,dann,crysta,clelia,claris,chieko,cherlyn,cherelle,charmain,chara,cammy,arnette,ardelle,annika,amiee,amee,allena,yvone,yuki,yoshie,yevette,yael,willetta,voncile,venetta,tula,tonette,timika,temika,telma,teisha,taren,stacee,shawnta,saturnina,ricarda,pasty,onie,nubia,marielle,mariella,marianela,mardell,luanna,loise,lisabeth,lindsy,lilliana,lilliam,lelah,leigha,leanora,kristeen,khalilah,keeley,kandra,junko,joaquina,jerlene,jani,jamika,hsiu,hermila,genevive,evia,eugena,emmaline,elfreda,elene,donette,delcie,deeanna,darcey,clarinda,cira,chae,celinda,catheryn,casimira,carmelia,camellia,breana,bobette,bernardina,bebe,basilia,arlyne,amal,alayna,zonia,zenia,yuriko,yaeko,wynell,willena,vernia,tora,terrilyn,terica,tenesha,tawna,tajuana,taina,stephnie,sona,sina,shondra,shizuko,sherlene,sherice,sharika,rossie,rosena,rima,rheba,renna,natalya,nancee,melodi,meda,matha,marketta,maricruz,marcelene,malvina,luba,louetta,leida,lecia,lauran,lashawna,laine,khadijah,katerine,kasi,kallie,julietta,jesusita,jestine,jessia,jeffie,janyce,isadora,georgianne,fidelia,evita,eura,eulah,estefana,elsy,eladia,dodie,denisse,deloras,delila,daysi,crystle,concha,claretta,charlsie,charlena,carylon,bettyann,asley,ashlea,amira,agueda,agnus,yuette,vinita,victorina,tynisha,treena,toccara,tish,thomasena,tegan,soila,shenna,sharmaine,shantae,shandi,saran,sarai,sana,rosette,rolande,regine,otelia,olevia,nicholle,necole,naida,myrta,myesha,mitsue,minta,mertie,margy,mahalia,madalene,loura,lorean,lesha,leonida,lenita,lavone,lashell,lashandra,lamonica,kimbra,katherina,karry,kanesha,jong,jeneva,jaquelyn,gilma,ghislaine,gertrudis,fransisca,fermina,ettie,etsuko,ellan,elidia,edra,dorethea,doreatha,denyse,deetta,daine,cyrstal,corrin,cayla,carlita,camila,burma,bula,buena,barabara,avril,alaine,zana,wilhemina,wanetta,verline,vasiliki,tonita,tisa,teofila,tayna,taunya,tandra,takako,sunni,suanne,sixta,sharell,seema,rosenda,robena,raymonde,pamila,ozell,neida,mistie,micha,merissa,maurita,maryln,maryetta,marcell,malena,makeda,lovetta,lourie,lorrine,lorilee,laurena,lashay,larraine,laree,lacresha,kristle,keva,keira,karole,joie,jinny,jeannetta,jama,heidy,gilberte,gema,faviola,evelynn,enda,elli,ellena,divina,dagny,collene,codi,cindie,chassidy,chasidy,catrice,catherina,cassey,caroll,carlena,candra,calista,bryanna,britteny,beula,bari,audrie,audria,ardelia,annelle,angila,alona,allyn".split(","),
    surnames: "smith,johnson,williams,jones,brown,davis,miller,wilson,moore,taylor,anderson,jackson,white,harris,martin,thompson,garcia,martinez,robinson,clark,rodriguez,lewis,lee,walker,hall,allen,young,hernandez,king,wright,lopez,hill,green,adams,baker,gonzalez,nelson,carter,mitchell,perez,roberts,turner,phillips,campbell,parker,evans,edwards,collins,stewart,sanchez,morris,rogers,reed,cook,morgan,bell,murphy,bailey,rivera,cooper,richardson,cox,howard,ward,torres,peterson,gray,ramirez,watson,brooks,sanders,price,bennett,wood,barnes,ross,henderson,coleman,jenkins,perry,powell,long,patterson,hughes,flores,washington,butler,simmons,foster,gonzales,bryant,alexander,griffin,diaz,hayes,myers,ford,hamilton,graham,sullivan,wallace,woods,cole,west,owens,reynolds,fisher,ellis,harrison,gibson,mcdonald,cruz,marshall,ortiz,gomez,murray,freeman,wells,webb,simpson,stevens,tucker,porter,hicks,crawford,boyd,mason,morales,kennedy,warren,dixon,ramos,reyes,burns,gordon,shaw,holmes,rice,robertson,hunt,black,daniels,palmer,mills,nichols,grant,knight,ferguson,stone,hawkins,dunn,perkins,hudson,spencer,gardner,stephens,payne,pierce,berry,matthews,arnold,wagner,willis,watkins,olson,carroll,duncan,snyder,hart,cunningham,lane,andrews,ruiz,harper,fox,riley,armstrong,carpenter,weaver,greene,elliott,chavez,sims,peters,kelley,franklin,lawson,fields,gutierrez,schmidt,carr,vasquez,castillo,wheeler,chapman,montgomery,richards,williamson,johnston,banks,meyer,bishop,mccoy,howell,alvarez,morrison,hansen,fernandez,garza,harvey,burton,nguyen,jacobs,reid,fuller,lynch,garrett,romero,welch,larson,frazier,burke,hanson,mendoza,moreno,bowman,medina,fowler,brewer,hoffman,carlson,silva,pearson,holland,fleming,jensen,vargas,byrd,davidson,hopkins,herrera,wade,soto,walters,neal,caldwell,lowe,jennings,barnett,graves,jimenez,horton,shelton,barrett,obrien,castro,sutton,mckinney,lucas,miles,rodriquez,chambers,holt,lambert,fletcher,watts,bates,hale,rhodes,pena,beck,newman,haynes,mcdaniel,mendez,bush,vaughn,parks,dawson,santiago,norris,hardy,steele,curry,powers,schultz,barker,guzman,page,munoz,ball,keller,chandler,weber,walsh,lyons,ramsey,wolfe,schneider,mullins,benson,sharp,bowen,barber,cummings,hines,baldwin,griffith,valdez,hubbard,salazar,reeves,warner,stevenson,burgess,santos,tate,cross,garner,mann,mack,moss,thornton,mcgee,farmer,delgado,aguilar,vega,glover,manning,cohen,harmon,rodgers,robbins,newton,blair,higgins,ingram,reese,cannon,strickland,townsend,potter,goodwin,walton,rowe,hampton,ortega,patton,swanson,goodman,maldonado,yates,becker,erickson,hodges,rios,conner,adkins,webster,malone,hammond,flowers,cobb,moody,quinn,pope,osborne,mccarthy,guerrero,estrada,sandoval,gibbs,gross,fitzgerald,stokes,doyle,saunders,wise,colon,gill,alvarado,greer,padilla,waters,nunez,ballard,schwartz,mcbride,houston,christensen,klein,pratt,briggs,parsons,mclaughlin,zimmerman,buchanan,moran,copeland,pittman,brady,mccormick,holloway,brock,poole,logan,bass,marsh,drake,wong,jefferson,morton,abbott,sparks,norton,huff,massey,figueroa,carson,bowers,roberson,barton,tran,lamb,harrington,boone,cortez,clarke,mathis,singleton,wilkins,cain,underwood,hogan,mckenzie,collier,luna,phelps,mcguire,bridges,wilkerson,nash,summers,atkins,wilcox,pitts,conley,marquez,burnett,cochran,chase,davenport,hood,gates,ayala,sawyer,vazquez,dickerson,hodge,acosta,flynn,espinoza,nicholson,monroe,wolf,morrow,whitaker,oconnor,skinner,ware,molina,kirby,huffman,gilmore,dominguez,oneal,lang,combs,kramer,hancock,gallagher,gaines,shaffer,wiggins,mathews,mcclain,fischer,wall,melton,hensley,bond,dyer,grimes,contreras,wyatt,baxter,snow,mosley,shepherd,larsen,hoover,beasley,petersen,whitehead,meyers,garrison,shields,horn,savage,olsen,schroeder,hartman,woodard,mueller,kemp,deleon,booth,patel,calhoun,wiley,eaton,cline,navarro,harrell,humphrey,parrish,duran,hutchinson,hess,dorsey,bullock,robles,beard,dalton,avila,rich,blackwell,johns,blankenship,trevino,salinas,campos,pruitt,callahan,montoya,hardin,guerra,mcdowell,stafford,gallegos,henson,wilkinson,booker,merritt,atkinson,orr,decker,hobbs,tanner,knox,pacheco,stephenson,glass,rojas,serrano,marks,hickman,sweeney,strong,mcclure,conway,roth,maynard,farrell,lowery,hurst,nixon,weiss,trujillo,ellison,sloan,juarez,winters,mclean,boyer,villarreal,mccall,gentry,carrillo,ayers,lara,sexton,pace,hull,leblanc,browning,velasquez,leach,chang,sellers,herring,noble,foley,bartlett,mercado,landry,durham,walls,barr,mckee,bauer,rivers,bradshaw,pugh,velez,rush,estes,dodson,morse,sheppard,weeks,camacho,bean,barron,livingston,middleton,spears,branch,blevins,chen,kerr,mcconnell,hatfield,harding,solis,frost,giles,blackburn,pennington,woodward,finley,mcintosh,koch,mccullough,blanchard,rivas,brennan,mejia,kane,benton,buckley,valentine,maddox,russo,mcknight,buck,moon,mcmillan,crosby,berg,dotson,mays,roach,chan,richmond,meadows,faulkner,oneill,knapp,kline,ochoa,jacobson,gay,hendricks,horne,shepard,hebert,cardenas,mcintyre,waller,holman,donaldson,cantu,morin,gillespie,fuentes,tillman,bentley,peck,key,salas,rollins,gamble,dickson,santana,cabrera,cervantes,howe,hinton,hurley,spence,zamora,yang,mcneil,suarez,petty,gould,mcfarland,sampson,carver,bray,macdonald,stout,hester,melendez,dillon,farley,hopper,galloway,potts,joyner,stein,aguirre,osborn,mercer,bender,franco,rowland,sykes,pickett,sears,mayo,dunlap,hayden,wilder,mckay,coffey,mccarty,ewing,cooley,vaughan,bonner,cotton,holder,stark,ferrell,cantrell,fulton,lott,calderon,pollard,hooper,burch,mullen,fry,riddle,levy,duke,odonnell,britt,daugherty,berger,dillard,alston,frye,riggs,chaney,odom,duffy,fitzpatrick,valenzuela,mayer,alford,mcpherson,acevedo,barrera,cote,reilly,compton,mooney,mcgowan,craft,clemons,wynn,nielsen,baird,stanton,snider,rosales,bright,witt,hays,holden,rutledge,kinney,clements,castaneda,slater,hahn,burks,delaney,pate,lancaster,sharpe,whitfield,talley,macias,burris,ratliff,mccray,madden,kaufman,beach,goff,cash,bolton,mcfadden,levine,byers,kirkland,kidd,workman,carney,mcleod,holcomb,finch,sosa,haney,franks,sargent,nieves,downs,rasmussen,bird,hewitt,foreman,valencia,oneil,delacruz,vinson,dejesus,hyde,forbes,gilliam,guthrie,wooten,huber,barlow,boyle,mcmahon,buckner,rocha,puckett,langley,knowles,cooke,velazquez,whitley,vang,shea,rouse,hartley,mayfield,elder,rankin,hanna,cowan,lucero,arroyo,slaughter,haas,oconnell,minor,boucher,archer,boggs,dougherty,andersen,newell,crowe,wang,friedman,bland,swain,holley,pearce,childs,yarbrough,galvan,proctor,meeks,lozano,mora,rangel,bacon,villanueva,schaefer,rosado,helms,boyce,goss,stinson,ibarra,hutchins,covington,crowley,hatcher,mackey,bunch,womack,polk,dodd,childress,childers,villa,springer,mahoney,dailey,belcher,lockhart,griggs,costa,brandt,walden,moser,tatum,mccann,akers,lutz,pryor,orozco,mcallister,lugo,davies,shoemaker,rutherford,newsome,magee,chamberlain,blanton,simms,godfrey,flanagan,crum,cordova,escobar,downing,sinclair,donahue,krueger,mcginnis,gore,farris,webber,corbett,andrade,starr,lyon,yoder,hastings,mcgrath,spivey,krause,harden,crabtree,kirkpatrick,arrington,ritter,mcghee,bolden,maloney,gagnon,dunbar,ponce,pike,mayes,beatty,mobley,kimball,butts,montes,eldridge,braun,hamm,gibbons,moyer,manley,herron,plummer,elmore,cramer,rucker,pierson,fontenot,rubio,goldstein,elkins,wills,novak,hickey,worley,gorman,katz,dickinson,broussard,woodruff,crow,britton,nance,lehman,bingham,zuniga,whaley,shafer,coffman,steward,delarosa,neely,mata,davila,mccabe,kessler,hinkle,welsh,pagan,goldberg,goins,crouch,cuevas,quinones,mcdermott,hendrickson,samuels,denton,bergeron,ivey,locke,haines,snell,hoskins,byrne,arias,corbin,beltran,chappell,downey,dooley,tuttle,couch,payton,mcelroy,crockett,groves,cartwright,dickey,mcgill,dubois,muniz,tolbert,dempsey,cisneros,sewell,latham,vigil,tapia,rainey,norwood,stroud,meade,tipton,kuhn,hilliard,bonilla,teague,gunn,greenwood,correa,reece,pineda,phipps,frey,kaiser,ames,gunter,schmitt,milligan,espinosa,bowden,vickers,lowry,pritchard,costello,piper,mcclellan,lovell,sheehan,hatch,dobson,singh,jeffries,hollingsworth,sorensen,meza,fink,donnelly,burrell,tomlinson,colbert,billings,ritchie,helton,sutherland,peoples,mcqueen,thomason,givens,crocker,vogel,robison,dunham,coker,swartz,keys,ladner,richter,hargrove,edmonds,brantley,albright,murdock,boswell,muller,quintero,padgett,kenney,daly,connolly,inman,quintana,lund,barnard,villegas,simons,huggins,tidwell,sanderson,bullard,mcclendon,duarte,draper,marrero,dwyer,abrams,stover,goode,fraser,crews,bernal,godwin,conklin,mcneal,baca,esparza,crowder,bower,brewster,mcneill,rodrigues,leal,coates,raines,mccain,mccord,miner,holbrook,swift,dukes,carlisle,aldridge,ackerman,starks,ricks,holliday,ferris,hairston,sheffield,lange,fountain,doss,betts,kaplan,carmichael,bloom,ruffin,penn,kern,bowles,sizemore,larkin,dupree,seals,metcalf,hutchison,henley,farr,mccauley,hankins,gustafson,curran,waddell,ramey,cates,pollock,cummins,messer,heller,funk,cornett,palacios,galindo,cano,hathaway,pham,enriquez,salgado,pelletier,painter,wiseman,blount,feliciano,houser,doherty,mead,mcgraw,swan,capps,blanco,blackmon,thomson,mcmanus,burkett,gleason,dickens,cormier,voss,rushing,rosenberg,hurd,dumas,benitez,arellano,marin,caudill,bragg,jaramillo,huerta,gipson,colvin,biggs,vela,platt,cassidy,tompkins,mccollum,dolan,daley,crump,sneed,kilgore,grove,grimm,davison,brunson,prater,marcum,devine,dodge,stratton,rosas,choi,tripp,ledbetter,hightower,feldman,epps,yeager,posey,scruggs,cope,stubbs,richey,overton,trotter,sprague,cordero,butcher,stiles,burgos,woodson,horner,bassett,purcell,haskins,akins,ziegler,spaulding,hadley,grubbs,sumner,murillo,zavala,shook,lockwood,driscoll,dahl,thorpe,redmond,putnam,mcwilliams,mcrae,romano,joiner,sadler,hedrick,hager,hagen,fitch,coulter,thacker,mansfield,langston,guidry,ferreira,corley,conn,rossi,lackey,baez,saenz,mcnamara,mcmullen,mckenna,mcdonough,link,engel,browne,roper,peacock,eubanks,drummond,stringer,pritchett,parham,mims,landers,grayson,schafer,egan,timmons,ohara,keen,hamlin,finn,cortes,mcnair,nadeau,moseley,michaud,rosen,oakes,kurtz,jeffers,calloway,beal,bautista,winn,suggs,stern,stapleton,lyles,laird,montano,dawkins,hagan,goldman,bryson,barajas,lovett,segura,metz,lockett,langford,hinson,eastman,hooks,smallwood,shapiro,crowell,whalen,triplett,chatman,aldrich,cahill,youngblood,ybarra,stallings,sheets,reeder,connelly,bateman,abernathy,winkler,wilkes,masters,hackett,granger,gillis,schmitz,sapp,napier,souza,lanier,gomes,weir,otero,ledford,burroughs,babcock,ventura,siegel,dugan,bledsoe,atwood,wray,varner,spangler,anaya,staley,kraft,fournier,belanger,wolff,thorne,bynum,burnette,boykin,swenson,purvis,pina,khan,duvall,darby,xiong,kauffman,healy,engle,benoit,valle,steiner,spicer,shaver,randle,lundy,chin,calvert,staton,neff,kearney,darden,oakley,medeiros,mccracken,crenshaw,perdue,dill,whittaker,tobin,washburn,hogue,goodrich,easley,bravo,dennison,shipley,kerns,jorgensen,crain,villalobos,maurer,longoria,keene,coon,witherspoon,staples,pettit,kincaid,eason,madrid,echols,lusk,stahl,currie,thayer,shultz,mcnally,seay,maher,gagne,barrow,nava,moreland,honeycutt,hearn,diggs,caron,whitten,westbrook,stovall,ragland,munson,meier,looney,kimble,jolly,hobson,goddard,culver,burr,presley,negron,connell,tovar,huddleston,ashby,salter,root,pendleton,oleary,nickerson,myrick,judd,jacobsen,bain,adair,starnes,matos,busby,herndon,hanley,bellamy,doty,bartley,yazzie,rowell,parson,gifford,cullen,christiansen,benavides,barnhart,talbot,mock,crandall,connors,bonds,whitt,gage,bergman,arredondo,addison,lujan,dowdy,jernigan,huynh,bouchard,dutton,rhoades,ouellette,kiser,herrington,hare,blackman,babb,allred,rudd,paulson,ogden,koenig,geiger,begay,parra,lassiter,hawk,esposito,waldron,ransom,prather,chacon,vick,sands,roark,parr,mayberry,greenberg,coley,bruner,whitman,skaggs,shipman,leary,hutton,romo,medrano,ladd,kruse,askew,schulz,alfaro,tabor,mohr,gallo,bermudez,pereira,bliss,reaves,flint,comer,woodall,naquin,guevara,delong,carrier,pickens,tilley,schaffer,knutson,fenton,doran,vogt,vann,prescott,mclain,landis,corcoran,zapata,hyatt,hemphill,faulk,dove,boudreaux,aragon,whitlock,trejo,tackett,shearer,saldana,hanks,mckinnon,koehler,bourgeois,keyes,goodson,foote,lunsford,goldsmith,flood,winslow,sams,reagan,mccloud,hough,esquivel,naylor,loomis,coronado,ludwig,braswell,bearden,huang,fagan,ezell,edmondson,cronin,nunn,lemon,guillory,grier,dubose,traylor,ryder,dobbins,coyle,aponte,whitmore,smalls,rowan,malloy,cardona,braxton,borden,humphries,carrasco,ruff,metzger,huntley,hinojosa,finney,madsen,ernst,dozier,burkhart,bowser,peralta,daigle,whittington,sorenson,saucedo,roche,redding,fugate,avalos,waite,lind,huston,hawthorne,hamby,boyles,boles,regan,faust,crook,beam,barger,hinds,gallardo,willoughby,willingham,eckert,busch,zepeda,worthington,tinsley,hoff,hawley,carmona,varela,rector,newcomb,kinsey,dube,whatley,ragsdale,bernstein,becerra,yost,mattson,felder,cheek,handy,grossman,gauthier,escobedo,braden,beckman,mott,hillman,flaherty,dykes,stockton,stearns,lofton,coats,cavazos,beavers,barrios,tang,mosher,cardwell,coles,burnham,weller,lemons,beebe,aguilera,parnell,harman,couture,alley,schumacher,redd,dobbs,blum,blalock,merchant,ennis,denson,cottrell,brannon,bagley,aviles,watt,sousa,rosenthal,rooney,dietz,blank,paquette,mcclelland,duff,velasco,lentz,grubb,burrows,barbour,ulrich,shockley,rader,beyer,mixon,layton,altman,weathers,stoner,squires,shipp,priest,lipscomb,cutler,caballero,zimmer,willett,thurston,storey,medley,epperson,shah,mcmillian,baggett,torrez,hirsch,dent,poirier,peachey,farrar,creech,barth,trimble,dupre,albrecht,sample,lawler,crisp,conroy,wetzel,nesbitt,murry,jameson,wilhelm,patten,minton,matson,kimbrough,guinn,croft,toth,pulliam,nugent,newby,littlejohn,dias,canales,bernier,baron,singletary,renteria,pruett,mchugh,mabry,landrum,brower,stoddard,cagle,stjohn,scales,kohler,kellogg,hopson,gant,tharp,gann,zeigler,pringle,hammons,fairchild,deaton,chavis,carnes,rowley,matlock,kearns,irizarry,carrington,starkey,lopes,jarrell,craven,baum,littlefield,linn,humphreys,etheridge,cuellar,chastain,bundy,speer,skelton,quiroz,pyle,portillo,ponder,moulton,machado,killian,hutson,hitchcock,dowling,cloud,burdick,spann,pedersen,levin,leggett,hayward,dietrich,beaulieu,barksdale,wakefield,snowden,briscoe,bowie,berman,ogle,mcgregor,laughlin,helm,burden,wheatley,schreiber,pressley,parris,alaniz,agee,swann,snodgrass,schuster,radford,monk,mattingly,harp,girard,cheney,yancey,wagoner,ridley,lombardo,hudgins,gaskins,duckworth,coburn,willey,prado,newberry,magana,hammonds,elam,whipple,slade,serna,ojeda,liles,dorman,diehl,upton,reardon,michaels,goetz,eller,bauman,baer,layne,hummel,brenner,amaya,adamson,ornelas,dowell,cloutier,castellanos,wellman,saylor,orourke,moya,montalvo,kilpatrick,durbin,shell,oldham,kang,garvin,foss,branham,bartholomew,templeton,maguire,holton,rider,monahan,mccormack,beaty,anders,streeter,nieto,nielson,moffett,lankford,keating,heck,gatlin,delatorre,callaway,adcock,worrell,unger,robinette,nowak,jeter,brunner,steen,parrott,overstreet,nobles,montanez,clevenger,brinkley,trahan,quarles,pickering,pederson,jansen,grantham,gilchrist,crespo,aiken,schell,schaeffer,lorenz,leyva,harms,dyson,wallis,pease,leavitt,cheng,cavanaugh,batts,warden,seaman,rockwell,quezada,paxton,linder,houck,fontaine,durant,caruso,adler,pimentel,mize,lytle,cleary,cason,acker,switzer,isaacs,higginbotham,waterman,vandyke,stamper,sisk,shuler,riddick,mcmahan,levesque,hatton,bronson,bollinger,arnett,okeefe,gerber,gannon,farnsworth,baughman,silverman,satterfield,mccrary,kowalski,grigsby,greco,cabral,trout,rinehart,mahon,linton,gooden,curley,baugh,wyman,weiner,schwab,schuler,morrissey,mahan,bunn,thrasher,spear,waggoner,qualls,purdy,mcwhorter,mauldin,gilman,perryman,newsom,menard,martino,graf,billingsley,artis,simpkins,salisbury,quintanilla,gilliland,fraley,foust,crouse,scarborough,grissom,fultz,marlow,markham,madrigal,lawton,barfield,whiting,varney,schwarz,gooch,arce,wheat,truong,poulin,hurtado,selby,gaither,fortner,culpepper,coughlin,brinson,boudreau,bales,stepp,holm,schilling,morrell,kahn,heaton,gamez,causey,turpin,shanks,schrader,meek,isom,hardison,carranza,yanez,scroggins,schofield,runyon,ratcliff,murrell,moeller,irby,currier,butterfield,ralston,pullen,pinson,estep,carbone,hawks,ellington,casillas,spurlock,sikes,motley,mccartney,kruger,isbell,houle,burk,tomlin,quigley,neumann,lovelace,fennell,cheatham,bustamante,skidmore,hidalgo,forman,culp,bowens,betancourt,aquino,robb,milner,martel,gresham,wiles,ricketts,dowd,collazo,bostic,blakely,sherrod,kenyon,gandy,ebert,deloach,allard,sauer,robins,olivares,gillette,chestnut,bourque,paine,hite,hauser,devore,crawley,chapa,talbert,poindexter,meador,mcduffie,mattox,kraus,harkins,choate,wren,sledge,sanborn,kinder,geary,cornwell,barclay,abney,seward,rhoads,howland,fortier,benner,vines,tubbs,troutman,rapp,mccurdy,deluca,westmoreland,havens,guajardo,clary,seal,meehan,herzog,guillen,ashcraft,waugh,renner,milam,elrod,churchill,breaux,bolin,asher,windham,tirado,pemberton,nolen,noland,knott,emmons,cornish,christenson,brownlee,barbee,waldrop,pitt,olvera,lombardi,gruber,gaffney,eggleston,banda,archuleta,slone,prewitt,pfeiffer,nettles,mena,mcadams,henning,gardiner,cromwell,chisholm,burleson,vest,oglesby,mccarter,lumpkin,wofford,vanhorn,thorn,teel,swafford,stclair,stanfield,ocampo,herrmann,hannon,arsenault,roush,mcalister,hiatt,gunderson,forsythe,duggan,delvalle,cintron,wilks,weinstein,uribe,rizzo,noyes,mclendon,gurley,bethea,winstead,maples,guyton,giordano,alderman,valdes,polanco,pappas,lively,grogan,griffiths,bobo,arevalo,whitson,sowell,rendon,fernandes,farrow,benavidez,ayres,alicea,stump,smalley,seitz,schulte,gilley,gallant,canfield,wolford,omalley,mcnutt,mcnulty,mcgovern,hardman,harbin,cowart,chavarria,brink,beckett,bagwell,armstead,anglin,abreu,reynoso,krebs,jett,hoffmann,greenfield,forte,burney,broome,sisson,trammell,partridge,mace,lomax,lemieux,gossett,frantz,fogle,cooney,broughton,pence,paulsen,muncy,mcarthur,hollins,beauchamp,withers,osorio,mulligan,hoyle,dockery,cockrell,begley,amador,roby,rains,lindquist,gentile,everhart,bohannon,wylie,sommers,purnell,fortin,dunning,breeden,vail,phelan,phan,marx,cosby,colburn,boling,biddle,ledesma,gaddis,denney,chow,bueno,berrios,wicker,tolliver,thibodeaux,nagle,lavoie,fisk,crist,barbosa,reedy,locklear,kolb,himes,behrens,beckwith,weems,wahl,shorter,shackelford,rees,muse,cerda,valadez,thibodeau,saavedra,ridgeway,reiter,mchenry,majors,lachance,keaton,ferrara,clemens,blocker,applegate,needham,mojica,kuykendall,hamel,escamilla,doughty,burchett,ainsworth,vidal,upchurch,thigpen,strauss,spruill,sowers,riggins,ricker,mccombs,harlow,buffington,sotelo,olivas,negrete,morey,macon,logsdon,lapointe,bigelow,bello,westfall,stubblefield,lindley,hein,hawes,farrington,breen,birch,wilde,steed,sepulveda,reinhardt,proffitt,minter,messina,mcnabb,maier,keeler,gamboa,donohue,basham,shinn,crooks,cota,borders,bills,bachman,tisdale,tavares,schmid,pickard,gulley,fonseca,delossantos,condon,batista,wicks,wadsworth,martell,littleton,ison,haag,folsom,brumfield,broyles,brito,mireles,mcdonnell,leclair,hamblin,gough,fanning,binder,winfield,whitworth,soriano,palumbo,newkirk,mangum,hutcherson,comstock,carlin,beall,bair,wendt,watters,walling,putman,otoole,morley,mares,lemus,keener,hundley,dial,damico,billups,strother,mcfarlane,lamm,eaves,crutcher,caraballo,canty,atwell,taft,siler,rust,rawls,rawlings,prieto,mcneely,mcafee,hulsey,hackney,galvez,escalante,delagarza,crider,bandy,wilbanks,stowe,steinberg,renfro,masterson,massie,lanham,haskell,hamrick,dehart,burdette,branson,bourne,babin,aleman,worthy,tibbs,smoot,slack,paradis,mull,luce,houghton,gantt,furman,danner,christianson,burge,ashford,arndt,almeida,stallworth,shade,searcy,sager,noonan,mclemore,mcintire,maxey,lavigne,jobe,ferrer,falk,coffin,byrnes,aranda,apodaca,stamps,rounds,peek,olmstead,lewandowski,kaminski,dunaway,bruns,brackett,amato,reich,mcclung,lacroix,koontz,herrick,hardesty,flanders,cousins,cato,cade,vickery,shank,nagel,dupuis,croteau,cotter,stuckey,stine,porterfield,pauley,moffitt,knudsen,hardwick,goforth,dupont,blunt,barrows,barnhill,shull,rash,loftis,lemay,kitchens,horvath,grenier,fuchs,fairbanks,culbertson,calkins,burnside,beattie,ashworth,albertson,wertz,vaught,vallejo,turk,tuck,tijerina,sage,peterman,marroquin,marr,lantz,hoang,demarco,cone,berube,barnette,wharton,stinnett,slocum,scanlon,sander,pinto,mancuso,lima,headley,epstein,counts,clarkson,carnahan,boren,arteaga,adame,zook,whittle,whitehurst,wenzel,saxton,reddick,puente,handley,haggerty,earley,devlin,chaffin,cady,acuna,solano,sigler,pollack,pendergrass,ostrander,janes,francois,crutchfield,chamberlin,brubaker,baptiste,willson,reis,neeley,mullin,mercier,lira,layman,keeling,higdon,espinal,chapin,warfield,toledo,pulido,peebles,nagy,montague,mello,lear,jaeger,hogg,graff,furr,soliz,poore,mendenhall,mclaurin,maestas,gable,barraza,tillery,snead,pond,neill,mcculloch,mccorkle,lightfoot,hutchings,holloman,harness,dorn,bock,zielinski,turley,treadwell,stpierre,starling,somers,oswald,merrick,easterling,bivens,truitt,poston,parry,ontiveros,olivarez,moreau,medlin,lenz,knowlton,fairley,cobbs,chisolm,bannister,woodworth,toler,ocasio,noriega,neuman,moye,milburn,mcclanahan,lilley,hanes,flannery,dellinger,danielson,conti,blodgett,beers,weatherford,strain,karr,hitt,denham,custer,coble,clough,casteel,bolduc,batchelor,ammons,whitlow,tierney,staten,sibley,seifert,schubert,salcedo,mattison,laney,haggard,grooms,dees,cromer,cooks,colson,caswell,zarate,swisher,shin,ragan,pridgen,mcvey,matheny,lafleur,franz,ferraro,dugger,whiteside,rigsby,mcmurray,lehmann,jacoby,hildebrand,hendrick,headrick,goad,fincher,drury,borges,archibald,albers,woodcock,trapp,soares,seaton,monson,luckett,lindberg,kopp,keeton,healey,garvey,gaddy,fain,burchfield,wentworth,strand,stack,spooner,saucier,ricci,plunkett,pannell,ness,leger,freitas,fong,elizondo,duval,beaudoin,urbina,rickard,partin,mcgrew,mcclintock,ledoux,forsyth,faison,devries,bertrand,wasson,tilton,scarbrough,leung,irvine,garber,denning,corral,colley,castleberry,bowlin,bogan,beale,baines,trice,rayburn,parkinson,nunes,mcmillen,leahy,kimmel,higgs,fulmer,carden,bedford,taggart,spearman,prichard,morrill,koonce,heinz,hedges,guenther,grice,findley,dover,creighton,boothe,bayer,arreola,vitale,valles,raney,osgood,hanlon,burley,bounds,worden,weatherly,vetter,tanaka,stiltner,nevarez,mosby,montero,melancon,harter,hamer,goble,gladden,gist,ginn,akin,zaragoza,tarver,sammons,royster,oreilly,muir,morehead,luster,kingsley,kelso,grisham,glynn,baumann,alves,yount,tamayo,paterson,oates,menendez,longo,hargis,gillen,desantis,conover,breedlove,sumpter,scherer,rupp,reichert,heredia,creel,cohn,clemmons,casas,bickford,belton,bach,williford,whitcomb,tennant,sutter,stull,mccallum,langlois,keel,keegan,dangelo,dancy,damron,clapp,clanton,bankston,oliveira,mintz,mcinnis,martens,mabe,laster,jolley,hildreth,hefner,glaser,duckett,demers,brockman,blais,alcorn,agnew,toliver,tice,seeley,najera,musser,mcfall,laplante,galvin,fajardo,doan,coyne,copley,clawson,cheung,barone,wynne,woodley,tremblay,stoll,sparrow,sparkman,schweitzer,sasser,samples,roney,legg,heim,farias,colwell,christman,bratcher,winchester,upshaw,southerland,sorrell,sells,mccloskey,martindale,luttrell,loveless,lovejoy,linares,latimer,embry,coombs,bratton,bostick,venable,tuggle,toro,staggs,sandlin,jefferies,heckman,griffis,crayton,clem,browder,thorton,sturgill,sprouse,royer,rousseau,ridenour,pogue,perales,peeples,metzler,mesa,mccutcheon,mcbee,hornsby,heffner,corrigan,armijo,plante,peyton,paredes,macklin,hussey,hodgson,granados,frias,becnel,batten,almanza,turney,teal,sturgeon,meeker,mcdaniels,limon,keeney,hutto,holguin,gorham,fishman,fierro,blanchette,rodrigue,reddy,osburn,oden,lerma,kirkwood,keefer,haugen,hammett,chalmers,brinkman,baumgartner,zhang,valerio,tellez,steffen,shumate,sauls,ripley,kemper,guffey,evers,craddock,carvalho,blaylock,banuelos,balderas,wheaton,turnbull,shuman,pointer,mosier,mccue,ligon,kozlowski,johansen,ingle,herr,briones,snipes,rickman,pipkin,pantoja,orosco,moniz,lawless,kunkel,hibbard,galarza,enos,bussey,schott,salcido,perreault,mcdougal,mccool,haight,garris,easton,conyers,atherton,wimberly,utley,spellman,smithson,slagle,ritchey,rand,petit,osullivan,oaks,nutt,mcvay,mccreary,mayhew,knoll,jewett,harwood,cardoza,ashe,arriaga,zeller,wirth,whitmire,stauffer,rountree,redden,mccaffrey,martz,larose,langdon,humes,gaskin,faber,devito,cass,almond,wingfield,wingate,villareal,tyner,smothers,severson,reno,pennell,maupin,leighton,janssen,hassell,hallman,halcomb,folse,fitzsimmons,fahey,cranford,bolen,battles,battaglia,wooldridge,trask,rosser,regalado,mcewen,keefe,fuqua,echevarria,caro,boynton,andrus,viera,vanmeter,taber,spradlin,seibert,provost,prentice,oliphant,laporte,hwang,hatchett,hass,greiner,freedman,covert,chilton,byars,wiese,venegas,swank,shrader,roberge,mullis,mortensen,mccune,marlowe,kirchner,keck,isaacson,hostetler,halverson,gunther,griswold,fenner,durden,blackwood,ahrens,sawyers,savoy,nabors,mcswain,mackay,lavender,lash,labbe,jessup,fullerton,cruse,crittenden,correia,centeno,caudle,canady,callender,alarcon,ahern,winfrey,tribble,salley,roden,musgrove,minnick,fortenberry,carrion,bunting,batiste,whited,underhill,stillwell,rauch,pippin,perrin,messenger,mancini,lister,kinard,hartmann,fleck,wilt,treadway,thornhill,spalding,rafferty,pitre,patino,ordonez,linkous,kelleher,homan,galbraith,feeney,curtin,coward,camarillo,buss,bunnell,bolt,beeler,autry,alcala,witte,wentz,stidham,shively,nunley,meacham,martins,lemke,lefebvre,hynes,horowitz,hoppe,holcombe,dunne,derr,cochrane,brittain,bedard,beauregard,torrence,strunk,soria,simonson,shumaker,scoggins,oconner,moriarty,kuntz,ives,hutcheson,horan,hales,garmon,fitts,bohn,atchison,wisniewski,vanwinkle,sturm,sallee,prosser,moen,lundberg,kunz,kohl,keane,jorgenson,jaynes,funderburk,freed,durr,creamer,cosgrove,batson,vanhoose,thomsen,teeter,smyth,redmon,orellana,maness,heflin,goulet,frick,forney,bunker,asbury,aguiar,talbott,southard,mowery,mears,lemmon,krieger,hickson,elston,duong,delgadillo,dayton,dasilva,conaway,catron,bruton,bradbury,bordelon,bivins,bittner,bergstrom,beals,abell,whelan,tejada,pulley,pino,norfleet,nealy,maes,loper,gatewood,frierson,freund,finnegan,cupp,covey,catalano,boehm,bader,yoon,walston,tenney,sipes,rawlins,medlock,mccaskill,mccallister,marcotte,maclean,hughey,henke,harwell,gladney,gilson,chism,caskey,brandenburg,baylor,villasenor,veal,thatcher,stegall,petrie,nowlin,navarrete,lombard,loftin,lemaster,kroll,kovach,kimbrell,kidwell,hershberger,fulcher,cantwell,bustos,boland,bobbitt,binkley,wester,weis,verdin,tong,tiller,sisco,sharkey,seymore,rosenbaum,rohr,quinonez,pinkston,malley,logue,lessard,lerner,lebron,krauss,klinger,halstead,haller,getz,burrow,alger,shores,pfeifer,perron,nelms,munn,mcmaster,mckenney,manns,knudson,hutchens,huskey,goebel,flagg,cushman,click,castellano,carder,bumgarner,wampler,spinks,robson,neel,mcreynolds,mathias,maas,loera,jenson,florez,coons,buckingham,brogan,berryman,wilmoth,wilhite,thrash,shephard,seidel,schulze,roldan,pettis,obryan,maki,mackie,hatley,frazer,fiore,chesser,bottoms,bisson,benefield,allman,wilke,trudeau,timm,shifflett,mundy,milliken,mayers,leake,kohn,huntington,horsley,hermann,guerin,fryer,frizzell,foret,flemming,fife,criswell,carbajal,bozeman,boisvert,angulo,wallen,tapp,silvers,ramsay,oshea,orta,moll,mckeever,mcgehee,linville,kiefer,ketchum,howerton,groce,gass,fusco,corbitt,betz,bartels,amaral,aiello,weddle,sperry,seiler,runyan,raley,overby,osteen,olds,mckeown,matney,lauer,lattimore,hindman,hartwell,fredrickson,fredericks,espino,clegg,carswell,cambell,burkholder,woodbury,welker,totten,thornburg,theriault,stitt,stamm,stackhouse,scholl,saxon,rife,razo,quinlan,pinkerton,olivo,nesmith,nall,mattos,lafferty,justus,giron,geer,fielder,drayton,dortch,conners,conger,boatwright,billiot,barden,armenta,tibbetts,steadman,slattery,rinaldi,raynor,pinckney,pettigrew,milne,matteson,halsey,gonsalves,fellows,durand,desimone,cowley,cowles,brill,barham,barela,barba,ashmore,withrow,valenti,tejeda,spriggs,sayre,salerno,peltier,peel,merriman,matheson,lowman,lindstrom,hyland,giroux,earls,dugas,dabney,collado,briseno,baxley,whyte,wenger,vanover,vanburen,thiel,schindler,schiller,rigby,pomeroy,passmore,marble,manzo,mahaffey,lindgren,laflamme,greathouse,fite,calabrese,bayne,yamamoto,wick,townes,thames,reinhart,peeler,naranjo,montez,mcdade,mast,markley,marchand,leeper,kellum,hudgens,hennessey,hadden,gainey,coppola,borrego,bolling,beane,ault,slaton,pape,null,mulkey,lightner,langer,hillard,ethridge,enright,derosa,baskin,weinberg,turman,somerville,pardo,noll,lashley,ingraham,hiller,hendon,glaze,cothran,cooksey,conte,carrico,abner,wooley,swope,summerlin,sturgis,sturdivant,stott,spurgeon,spillman,speight,roussel,popp,nutter,mckeon,mazza,magnuson,lanning,kozak,jankowski,heyward,forster,corwin,callaghan,bays,wortham,usher,theriot,sayers,sabo,poling,loya,lieberman,laroche,labelle,howes,harr,garay,fogarty,everson,durkin,dominquez,chaves,chambliss,witcher,vieira,vandiver,terrill,stoker,schreiner,moorman,liddell,lawhorn,krug,irons,hylton,hollenbeck,herrin,hembree,goolsby,goodin,gilmer,foltz,dinkins,daughtry,caban,brim,briley,bilodeau,wyant,vergara,tallent,swearingen,stroup,scribner,quillen,pitman,mccants,maxfield,martinson,holtz,flournoy,brookins,brody,baumgardner,straub,sills,roybal,roundtree,oswalt,mcgriff,mcdougall,mccleary,maggard,gragg,gooding,godinez,doolittle,donato,cowell,cassell,bracken,appel,zambrano,reuter,perea,nakamura,monaghan,mickens,mcclinton,mcclary,marler,kish,judkins,gilbreath,freese,flanigan,felts,erdmann,dodds,chew,brownell,boatright,barreto,slayton,sandberg,saldivar,pettway,odum,narvaez,moultrie,montemayor,merrell,lees,keyser,hoke,hardaway,hannan,gilbertson,fogg,dumont,deberry,coggins,buxton,bucher,broadnax,beeson,araujo,appleton,amundson,aguayo,ackley,yocum,worsham,shivers,sanches,sacco,robey,rhoden,pender,ochs,mccurry,madera,luong,knotts,jackman,heinrich,hargrave,gault,comeaux,chitwood,caraway,boettcher,bernhardt,barrientos,zink,wickham,whiteman,thorp,stillman,settles,schoonover,roque,riddell,pilcher,phifer,novotny,macleod,hardee,haase,grider,doucette,clausen,bevins,beamon,badillo,tolley,tindall,soule,snook,seale,pinkney,pellegrino,nowell,nemeth,mondragon,mclane,lundgren,ingalls,hudspeth,hixson,gearhart,furlong,downes,dibble,deyoung,cornejo,camara,brookshire,boyette,wolcott,surratt,sellars,segal,salyer,reeve,rausch,labonte,haro,gower,freeland,fawcett,eads,driggers,donley,collett,bromley,boatman,ballinger,baldridge,volz,trombley,stonge,shanahan,rivard,rhyne,pedroza,matias,jamieson,hedgepeth,hartnett,estevez,eskridge,denman,chiu,chinn,catlett,carmack,buie,bechtel,beardsley,bard,ballou,ulmer,skeen,robledo,rincon,reitz,piazza,munger,moten,mcmichael,loftus,ledet,kersey,groff,fowlkes,crumpton,clouse,bettis,villagomez,timmerman,strom,santoro,roddy,penrod,musselman,macpherson,leboeuf,harless,haddad,guido,golding,fulkerson,fannin,dulaney,dowdell,cottle,ceja,cate,bosley,benge,albritton,voigt,trowbridge,soileau,seely,rohde,pearsall,paulk,orth,nason,mota,mcmullin,marquardt,madigan,hoag,gillum,gabbard,fenwick,danforth,cushing,cress,creed,cazares,bettencourt,barringer,baber,stansberry,schramm,rutter,rivero,oquendo,necaise,mouton,montenegro,miley,mcgough,marra,macmillan,lamontagne,jasso,horst,hetrick,heilman,gaytan,gall,fortney,dingle,desjardins,dabbs,burbank,brigham,breland,beaman,arriola,yarborough,wallin,toscano,stowers,reiss,pichardo,orton,michels,mcnamee,mccrory,leatherman,kell,keister,horning,hargett,guay,ferro,deboer,dagostino,carper,blanks,beaudry,towle,tafoya,stricklin,strader,soper,sonnier,sigmon,schenk,saddler,pedigo,mendes,lunn,lohr,lahr,kingsbury,jarman,hume,holliman,hofmann,haworth,harrelson,hambrick,flick,edmunds,dacosta,crossman,colston,chaplin,carrell,budd,weiler,waits,valentino,trantham,tarr,solorio,roebuck,powe,plank,pettus,pagano,mink,luker,leathers,joslin,hartzell,gambrell,cepeda,carty,caputo,brewington,bedell,ballew,applewhite,warnock,walz,urena,tudor,reel,pigg,parton,mickelson,meagher,mclellan,mcculley,mandel,leech,lavallee,kraemer,kling,kipp,kehoe,hochstetler,harriman,gregoire,grabowski,gosselin,gammon,fancher,edens,desai,brannan,armendariz,woolsey,whitehouse,whetstone,ussery,towne,testa,tallman,studer,strait,steinmetz,sorrells,sauceda,rolfe,paddock,mitchem,mcginn,mccrea,lovato,hazen,gilpin,gaynor,fike,devoe,delrio,curiel,burkhardt,bode,backus,zinn,watanabe,wachter,vanpelt,turnage,shaner,schroder,sato,riordan,quimby,portis,natale,mckoy,mccown,kilmer,hotchkiss,hesse,halbert,gwinn,godsey,delisle,chrisman,canter,arbogast,angell,acree,yancy,woolley,wesson,weatherspoon,trainor,stockman,spiller,sipe,rooks,reavis,propst,porras,neilson,mullens,loucks,llewellyn,kumar,koester,klingensmith,kirsch,kester,honaker,hodson,hennessy,helmick,garrity,garibay,drain,casarez,callis,botello,aycock,avant,wingard,wayman,tully,theisen,szymanski,stansbury,segovia,rainwater,preece,pirtle,padron,mincey,mckelvey,mathes,larrabee,kornegay,klug,ingersoll,hecht,germain,eggers,dykstra,deering,decoteau,deason,dearing,cofield,carrigan,bonham,bahr,aucoin,appleby,almonte,yager,womble,wimmer,weimer,vanderpool,stancil,sprinkle,romine,remington,pfaff,peckham,olivera,meraz,maze,lathrop,koehn,hazelton,halvorson,hallock,haddock,ducharme,dehaven,caruthers,brehm,bosworth,bost,bias,beeman,basile,bane,aikens,wold,walther,tabb,suber,strawn,stocker,shirey,schlosser,riedel,rembert,reimer,pyles,peele,merriweather,letourneau,latta,kidder,hixon,hillis,hight,herbst,henriquez,haygood,hamill,gabel,fritts,eubank,dawes,correll,bushey,buchholz,brotherton,botts,barnwell,auger,atchley,westphal,veilleux,ulloa,stutzman,shriver,ryals,pilkington,moyers,marrs,mangrum,maddux,lockard,laing,kuhl,harney,hammock,hamlett,felker,doerr,depriest,carrasquillo,carothers,bogle,bischoff,bergen,albanese,wyckoff,vermillion,vansickle,thibault,tetreault,stickney,shoemake,ruggiero,rawson,racine,philpot,paschal,mcelhaney,mathison,legrand,lapierre,kwan,kremer,jiles,hilbert,geyer,faircloth,ehlers,egbert,desrosiers,dalrymple,cotten,cashman,cadena,boardman,alcaraz,wyrick,therrien,tankersley,strickler,puryear,plourde,pattison,pardue,mcginty,mcevoy,landreth,kuhns,koon,hewett,giddens,emerick,eades,deangelis,cosme,ceballos,birdsong,benham,bemis,armour,anguiano,welborn,tsosie,storms,shoup,sessoms,samaniego,rood,rojo,rhinehart,raby,northcutt,myer,munguia,morehouse,mcdevitt,mallett,lozada,lemoine,kuehn,hallett,grim,gillard,gaylor,garman,gallaher,feaster,faris,darrow,dardar,coney,carreon,braithwaite,boylan,boyett,bixler,bigham,benford,barragan,barnum,zuber,wyche,westcott,vining,stoltzfus,simonds,shupe,sabin,ruble,rittenhouse,richman,perrone,mulholland,millan,lomeli,kite,jemison,hulett,holler,hickerson,herold,hazelwood,griffen,gause,forde,eisenberg,dilworth,charron,chaisson,bristow,breunig,brace,boutwell,bentz,belk,bayless,batchelder,baran,baeza,zimmermann,weathersby,volk,toole,theis,tedesco,searle,schenck,satterwhite,ruelas,rankins,partida,nesbit,morel,menchaca,levasseur,kaylor,johnstone,hulse,hollar,hersey,harrigan,harbison,guyer,gish,giese,gerlach,geller,geisler,falcone,elwell,doucet,deese,darr,corder,chafin,byler,bussell,burdett,brasher,bowe,bellinger,bastian,barner,alleyne,wilborn,weil,wegner,tatro,spitzer,smithers,schoen,resendez,parisi,overman,obrian,mudd,mahler,maggio,lindner,lalonde,lacasse,laboy,killion,kahl,jessen,jamerson,houk,henshaw,gustin,graber,durst,duenas,davey,cundiff,conlon,colunga,coakley,chiles,capers,buell,bricker,bissonnette,bartz,bagby,zayas,volpe,treece,toombs,thom,terrazas,swinney,skiles,silveira,shouse,senn,ramage,moua,langham,kyles,holston,hoagland,herd,feller,denison,carraway,burford,bickel,ambriz,abercrombie,yamada,weidner,waddle,verduzco,thurmond,swindle,schrock,sanabria,rosenberger,probst,peabody,olinger,nazario,mccafferty,mcbroom,mcabee,mazur,matherne,mapes,leverett,killingsworth,heisler,griego,gosnell,frankel,franke,ferrante,fenn,ehrlich,christopherso,chasse,caton,brunelle,bloomfield,babbitt,azevedo,abramson,ables,abeyta,youmans,wozniak,wainwright,stowell,smitherman,samuelson,runge,rothman,rosenfeld,peake,owings,olmos,munro,moreira,leatherwood,larkins,krantz,kovacs,kizer,kindred,karnes,jaffe,hubbell,hosey,hauck,goodell,erdman,dvorak,doane,cureton,cofer,buehler,bierman,berndt,banta,abdullah,warwick,waltz,turcotte,torrey,stith,seger,sachs,quesada,pinder,peppers,pascual,paschall,parkhurst,ozuna,oster,nicholls,lheureux,lavalley,kimura,jablonski,haun,gourley,gilligan,croy,cotto,cargill,burwell,burgett,buckman,booher,adorno,wrenn,whittemore,urias,szabo,sayles,saiz,rutland,rael,pharr,pelkey,ogrady,nickell,musick,moats,mather,massa,kirschner,kieffer,kellar,hendershot,gott,godoy,gadson,furtado,fiedler,erskine,dutcher,dever,daggett,chevalier,brake,ballesteros,amerson,wingo,waldon,trott,silvey,showers,schlegel,ritz,pepin,pelayo,parsley,palermo,moorehead,mchale,lett,kocher,kilburn,iglesias,humble,hulbert,huckaby,hartford,hardiman,gurney,grigg,grasso,goings,fillmore,farber,depew,dandrea,cowen,covarrubias,burrus,bracy,ardoin,thompkins,standley,radcliffe,pohl,persaud,parenteau,pabon,newson,newhouse,napolitano,mulcahy,malave,keim,hooten,hernandes,heffernan,hearne,greenleaf,glick,fuhrman,fetter,faria,dishman,dickenson,crites,criss,clapper,chenault,castor,casto,bugg,bove,bonney,anderton,allgood,alderson,woodman,warrick,toomey,tooley,tarrant,summerville,stebbins,sokol,searles,schutz,schumann,scheer,remillard,raper,proulx,palmore,monroy,messier,melo,melanson,mashburn,manzano,lussier,jenks,huneycutt,hartwig,grimsley,fulk,fielding,fidler,engstrom,eldred,dantzler,crandell,calder,brumley,breton,brann,bramlett,boykins,bianco,bancroft,almaraz,alcantar,whitmer,whitener,welton,vineyard,rahn,paquin,mizell,mcmillin,mckean,marston,maciel,lundquist,liggins,lampkin,kranz,koski,kirkham,jiminez,hazzard,harrod,graziano,grammer,gendron,garrido,fordham,englert,dryden,demoss,deluna,crabb,comeau,brummett,blume,benally,wessel,vanbuskirk,thorson,stumpf,stockwell,reams,radtke,rackley,pelton,niemi,newland,nelsen,morrissette,miramontes,mcginley,mccluskey,marchant,luevano,lampe,lail,jeffcoat,infante,hinman,gaona,eady,desmarais,decosta,dansby,cisco,choe,breckenridge,bostwick,borg,bianchi,alberts,wilkie,whorton,vargo,tait,soucy,schuman,ousley,mumford,lippert,leath,lavergne,laliberte,kirksey,kenner,johnsen,izzo,hiles,gullett,greenwell,gaspar,galbreath,gaitan,ericson,delapaz,croom,cottingham,clift,bushnell,bice,beason,arrowood,waring,voorhees,truax,shreve,shockey,schatz,sandifer,rubino,rozier,roseberry,pieper,peden,nester,nave,murphey,malinowski,macgregor,lafrance,kunkle,kirkman,hipp,hasty,haddix,gervais,gerdes,gamache,fouts,fitzwater,dillingham,deming,deanda,cedeno,cannady,burson,bouldin,arceneaux,woodhouse,whitford,wescott,welty,weigel,torgerson,toms,surber,sunderland,sterner,setzer,riojas,pumphrey,puga,metts,mcgarry,mccandless,magill,lupo,loveland,llamas,leclerc,koons,kahler,huss,holbert,heintz,haupt,grimmett,gaskill,ellingson,dorr,dingess,deweese,desilva,crossley,cordeiro,converse,conde,caldera,cairns,burmeister,burkhalter,brawner,bott,youngs,vierra,valladares,shrum,shropshire,sevilla,rusk,rodarte,pedraza,nino,merino,mcminn,markle,mapp,lajoie,koerner,kittrell,kato,hyder,hollifield,heiser,hazlett,greenwald,fant,eldredge,dreher,delafuente,cravens,claypool,beecher,aronson,alanis,worthen,wojcik,winger,whitacre,valverde,valdivia,troupe,thrower,swindell,suttles,stroman,spires,slate,shealy,sarver,sartin,sadowski,rondeau,rolon,rascon,priddy,paulino,nolte,munroe,molloy,mciver,lykins,loggins,lenoir,klotz,kempf,hupp,hollowell,hollander,haynie,harkness,harker,gottlieb,frith,eddins,driskell,doggett,densmore,charette,cassady,byrum,burcham,buggs,benn,whitted,warrington,vandusen,vaillancourt,steger,siebert,scofield,quirk,purser,plumb,orcutt,nordstrom,mosely,michalski,mcphail,mcdavid,mccraw,marchese,mannino,lefevre,largent,lanza,kress,isham,hunsaker,hoch,hildebrandt,guarino,grijalva,graybill,fick,ewell,ewald,cusick,crumley,coston,cathcart,carruthers,bullington,bowes,blain,blackford,barboza,yingling,wert,weiland,varga,silverstein,sievers,shuster,shumway,runnels,rumsey,renfroe,provencher,polley,mohler,middlebrooks,kutz,koster,groth,glidden,fazio,deen,chipman,chenoweth,champlin,cedillo,carrero,carmody,buckles,brien,boutin,bosch,berkowitz,altamirano,wilfong,wiegand,waites,truesdale,toussaint,tobey,tedder,steelman,sirois,schnell,robichaud,richburg,plumley,pizarro,piercy,ortego,oberg,neace,mertz,mcnew,matta,lapp,lair,kibler,howlett,hollister,hofer,hatten,hagler,falgoust,engelhardt,eberle,dombrowski,dinsmore,daye,casares,braud,balch,autrey,wendel,tyndall,strobel,stoltz,spinelli,serrato,reber,rathbone,palomino,nickels,mayle,mathers,mach,loeffler,littrell,levinson,leong,lemire,lejeune,lazo,lasley,koller,kennard,hoelscher,hintz,hagerman,greaves,fore,eudy,engler,corrales,cordes,brunet,bidwell,bennet,tyrrell,tharpe,swinton,stribling,southworth,sisneros,savoie,samons,ruvalcaba,ries,ramer,omara,mosqueda,millar,mcpeak,macomber,luckey,litton,lehr,lavin,hubbs,hoard,hibbs,hagans,futrell,exum,evenson,culler,carbaugh,callen,brashear,bloomer,blakeney,bigler,addington,woodford,unruh,tolentino,sumrall,stgermain,smock,sherer,rayner,pooler,oquinn,nero,mcglothlin,linden,kowal,kerrigan,ibrahim,harvell,hanrahan,goodall,geist,fussell,fung,ferebee,eley,eggert,dorsett,dingman,destefano,colucci,clemmer,burnell,brumbaugh,boddie,berryhill,avelar,alcantara,winder,winchell,vandenberg,trotman,thurber,thibeault,stlouis,stilwell,sperling,shattuck,sarmiento,ruppert,rumph,renaud,randazzo,rademacher,quiles,pearman,palomo,mercurio,lowrey,lindeman,lawlor,larosa,lander,labrecque,hovis,holifield,henninger,hawkes,hartfield,hann,hague,genovese,garrick,fudge,frink,eddings,dinh,cribbs,calvillo,bunton,brodeur,bolding,blanding,agosto,zahn,wiener,trussell,tello,teixeira,speck,sharma,shanklin,sealy,scanlan,santamaria,roundy,robichaux,ringer,rigney,prevost,polson,nord,moxley,medford,mccaslin,mcardle,macarthur,lewin,lasher,ketcham,keiser,heine,hackworth,grose,grizzle,gillman,gartner,frazee,fleury,edson,edmonson,derry,cronk,conant,burress,burgin,broom,brockington,bolick,boger,birchfield,billington,baily,bahena,armbruster,anson,yoho,wilcher,tinney,timberlake,thielen,sutphin,stultz,sikora,serra,schulman,scheffler,santillan,rego,preciado,pinkham,mickle,lomas,lizotte,lent,kellerman,keil,johanson,hernadez,hartsfield,haber,gorski,farkas,eberhardt,duquette,delano,cropper,cozart,cockerham,chamblee,cartagena,cahoon,buzzell,brister,brewton,blackshear,benfield,aston,ashburn,arruda,wetmore,weise,vaccaro,tucci,sudduth,stromberg,stoops,showalter,shears,runion,rowden,rosenblum,riffle,renfrow,peres,obryant,leftwich,lark,landeros,kistler,killough,kerley,kastner,hoggard,hartung,guertin,govan,gatling,gailey,fullmer,fulford,flatt,esquibel,endicott,edmiston,edelstein,dufresne,dressler,dickman,chee,busse,bonnett,berard,yoshida,velarde,veach,vanhouten,vachon,tolson,tolman,tennyson,stites,soler,shutt,ruggles,rhone,pegues,neese,muro,moncrief,mefford,mcphee,mcmorris,mceachern,mcclurg,mansour,mader,leija,lecompte,lafountain,labrie,jaquez,heald,hash,hartle,gainer,frisby,farina,eidson,edgerton,dyke,durrett,duhon,cuomo,cobos,cervantez,bybee,brockway,borowski,binion,beery,arguello,amaro,acton,yuen,winton,wigfall,weekley,vidrine,vannoy,tardiff,shoop,shilling,schick,safford,prendergast,pilgrim,pellerin,osuna,nissen,nalley,moller,messner,messick,merrifield,mcguinness,matherly,marcano,mahone,lemos,lebrun,jara,hoffer,herren,hecker,haws,haug,gwin,gober,gilliard,fredette,favela,echeverria,downer,donofrio,desrochers,crozier,corson,bechtold,argueta,aparicio,zamudio,westover,westerman,utter,troyer,thies,tapley,slavin,shirk,sandler,roop,rimmer,raymer,radcliff,otten,moorer,millet,mckibben,mccutchen,mcavoy,mcadoo,mayorga,mastin,martineau,marek,madore,leflore,kroeger,kennon,jimerson,hostetter,hornback,hendley,hance,guardado,granado,gowen,goodale,flinn,fleetwood,fitz,durkee,duprey,dipietro,dilley,clyburn,brawley,beckley,arana,weatherby,vollmer,vestal,tunnell,trigg,tingle,takahashi,sweatt,storer,snapp,shiver,rooker,rathbun,poisson,perrine,perri,parmer,parke,pare,papa,palmieri,midkiff,mecham,mccomas,mcalpine,lovelady,lillard,lally,knopp,kile,kiger,haile,gupta,goldsberry,gilreath,fulks,friesen,franzen,flack,findlay,ferland,dreyer,dore,dennard,deckard,debose,crim,coulombe,chancey,cantor,branton,bissell,barns,woolard,witham,wasserman,spiegel,shoffner,scholz,ruch,rossman,petry,palacio,paez,neary,mortenson,millsap,miele,menke,mckim,mcanally,martines,lemley,larochelle,klaus,klatt,kaufmann,kapp,helmer,hedge,halloran,glisson,frechette,fontana,eagan,distefano,danley,creekmore,chartier,chaffee,carillo,burg,bolinger,berkley,benz,basso,bash,zelaya,woodring,witkowski,wilmot,wilkens,wieland,verdugo,urquhart,tsai,timms,swiger,swaim,sussman,pires,molnar,mcatee,lowder,loos,linker,landes,kingery,hufford,higa,hendren,hammack,hamann,gillam,gerhardt,edelman,delk,deans,curl,constantine,cleaver,claar,casiano,carruth,carlyle,brophy,bolanos,bibbs,bessette,beggs,baugher,bartel,averill,andresen,amin,adames,valente,turnbow,swink,sublett,stroh,stringfellow,ridgway,pugliese,poteat,ohare,neubauer,murchison,mingo,lemmons,kwon,kellam,kean,jarmon,hyden,hudak,hollinger,henkel,hemingway,hasson,hansel,halter,haire,ginsberg,gillispie,fogel,flory,etter,elledge,eckman,deas,currin,crafton,coomer,colter,claxton,bulter,braddock,bowyer,binns,bellows,baskerville,barros,ansley,woolf,wight,waldman,wadley,tull,trull,tesch,stouffer,stadler,slay,shubert,sedillo,santacruz,reinke,poynter,neri,neale,mowry,moralez,monger,mitchum,merryman,manion,macdougall,litchfield,levitt,lepage,lasalle,khoury,kavanagh,karns,ivie,huebner,hodgkins,halpin,garica,eversole,dutra,dunagan,duffey,dillman,dillion,deville,dearborn,damato,courson,coulson,burdine,bousquet,bonin,bish,atencio,westbrooks,wages,vaca,toner,tillis,swett,struble,stanfill,solorzano,slusher,sipple,silvas,shults,schexnayder,saez,rodas,rager,pulver,penton,paniagua,meneses,mcfarlin,mcauley,matz,maloy,magruder,lohman,landa,lacombe,jaimes,holzer,holst,heil,hackler,grundy,gilkey,farnham,durfee,dunton,dunston,duda,dews,craver,corriveau,conwell,colella,chambless,bremer,boutte,bourassa,blaisdell,backman,babineaux,audette,alleman,towner,taveras,tarango,sullins,suiter,stallard,solberg,schlueter,poulos,pimental,owsley,okelley,moffatt,metcalfe,meekins,medellin,mcglynn,mccowan,marriott,marable,lennox,lamoureux,koss,kerby,karp,isenberg,howze,hockenberry,highsmith,hallmark,gusman,greeley,giddings,gaudet,gallup,fleenor,eicher,edington,dimaggio,dement,demello,decastro,bushman,brundage,brooker,bourg,blackstock,bergmann,beaton,banister,argo,appling,wortman,watterson,villalpando,tillotson,tighe,sundberg,sternberg,stamey,shipe,seeger,scarberry,sattler,sain,rothstein,poteet,plowman,pettiford,penland,partain,pankey,oyler,ogletree,ogburn,moton,merkel,lucier,lakey,kratz,kinser,kershaw,josephson,imhoff,hendry,hammon,frisbie,frawley,fraga,forester,eskew,emmert,drennan,doyon,dandridge,cawley,carvajal,bracey,belisle,batey,ahner,wysocki,weiser,veliz,tincher,sansone,sankey,sandstrom,rohrer,risner,pridemore,pfeffer,persinger,peery,oubre,nowicki,musgrave,murdoch,mullinax,mccary,mathieu,livengood,kyser,klink,kimes,kellner,kavanaugh,kasten,imes,hoey,hinshaw,hake,gurule,grube,grillo,geter,gatto,garver,garretson,farwell,eiland,dunford,decarlo,corso,colman,collard,cleghorn,chasteen,cavender,carlile,calvo,byerly,brogdon,broadwater,breault,bono,bergin,behr,ballenger,amick,tamez,stiffler,steinke,simmon,shankle,schaller,salmons,sackett,saad,rideout,ratcliffe,ranson,plascencia,petterson,olszewski,olney,olguin,nilsson,nevels,morelli,montiel,monge,michaelson,mertens,mcchesney,mcalpin,mathewson,loudermilk,lineberry,liggett,kinlaw,kight,jost,hereford,hardeman,halpern,halliday,hafer,gaul,friel,freitag,forsberg,evangelista,doering,dicarlo,dendy,delp,deguzman,dameron,curtiss,cosper,cauthen,bradberry,bouton,bonnell,bixby,bieber,beveridge,bedwell,barhorst,bannon,baltazar,baier,ayotte,attaway,arenas,abrego,turgeon,tunstall,thaxton,tenorio,stotts,sthilaire,shedd,seabolt,scalf,salyers,ruhl,rowlett,robinett,pfister,perlman,pepe,parkman,nunnally,norvell,napper,modlin,mckellar,mcclean,mascarenas,leibowitz,ledezma,kuhlman,kobayashi,hunley,holmquist,hinkley,hazard,hartsell,gribble,gravely,fifield,eliason,doak,crossland,carleton,bridgeman,bojorquez,boggess,auten,woosley,whiteley,wexler,twomey,tullis,townley,standridge,santoyo,rueda,riendeau,revell,pless,ottinger,nigro,nickles,mulvey,menefee,mcshane,mcloughlin,mckinzie,markey,lockridge,lipsey,knisley,knepper,kitts,kiel,jinks,hathcock,godin,gallego,fikes,fecteau,estabrook,ellinger,dunlop,dudek,countryman,chauvin,chatham,bullins,brownfield,boughton,bloodworth,bibb,baucom,barbieri,aubin,armitage,alessi,absher,abbate,zito,woolery,wiggs,wacker,tynes,tolle,telles,tarter,swarey,strode,stockdale,stalnaker,spina,schiff,saari,risley,rameriz,rakes,pettaway,penner,paulus,palladino,omeara,montelongo,melnick,mehta,mcgary,mccourt,mccollough,marchetti,manzanares,lowther,leiva,lauderdale,lafontaine,kowalczyk,knighton,joubert,jaworski,huth,hurdle,housley,hackman,gulick,gordy,gilstrap,gehrke,gebhart,gaudette,foxworth,endres,dunkle,cimino,caddell,brauer,braley,bodine,blackmore,belden,backer,ayer,andress,wisner,vuong,valliere,twigg,tavarez,strahan,steib,staub,sowder,seiber,schutt,scharf,schade,rodriques,risinger,renshaw,rahman,presnell,piatt,nieman,nevins,mcilwain,mcgaha,mccully,mccomb,massengale,macedo,lesher,kearse,jauregui,husted,hudnall,holmberg,hertel,hardie,glidewell,frausto,fassett,dalessandro,dahlgren,corum,constantino,conlin,colquitt,colombo,claycomb,cardin,buller,boney,bocanegra,biggers,benedetto,araiza,andino,albin,zorn,werth,weisman,walley,vanegas,ulibarri,towe,tedford,teasley,suttle,steffens,stcyr,squire,singley,sifuentes,shuck,schram,sass,rieger,ridenhour,rickert,richerson,rayborn,rabe,raab,pendley,pastore,ordway,moynihan,mellott,mckissick,mcgann,mccready,mauney,marrufo,lenhart,lazar,lafave,keele,kautz,jardine,jahnke,jacobo,hord,hardcastle,hageman,giglio,gehring,fortson,duque,duplessis,dicken,derosier,deitz,dalessio,cram,castleman,candelario,callison,caceres,bozarth,biles,bejarano,bashaw,avina,armentrout,alverez,acord,waterhouse,vereen,vanlandingham,strawser,shotwell,severance,seltzer,schoonmaker,schock,schaub,schaffner,roeder,rodrigez,riffe,rasberry,rancourt,railey,quade,pursley,prouty,perdomo,oxley,osterman,nickens,murphree,mounts,merida,maus,mattern,masse,martinelli,mangan,lutes,ludwick,loney,laureano,lasater,knighten,kissinger,kimsey,kessinger,honea,hollingshead,hockett,heyer,heron,gurrola,gove,glasscock,gillett,galan,featherstone,eckhardt,duron,dunson,dasher,culbreth,cowden,cowans,claypoole,churchwell,chabot,caviness,cater,caston,callan,byington,burkey,boden,beckford,atwater,archambault,alvey,alsup,whisenant,weese,voyles,verret,tsang,tessier,sweitzer,sherwin,shaughnessy,revis,remy,prine,philpott,peavy,paynter,parmenter,ovalle,offutt,nightingale,newlin,nakano,myatt,muth,mohan,mcmillon,mccarley,mccaleb,maxson,marinelli,maley,liston,letendre,kain,huntsman,hirst,hagerty,gulledge,greenway,grajeda,gorton,goines,gittens,frederickson,fanelli,embree,eichelberger,dunkin,dixson,dillow,defelice,chumley,burleigh,borkowski,binette,biggerstaff,berglund,beller,audet,arbuckle,allain,alfano,youngman,wittman,weintraub,vanzant,vaden,twitty,stollings,standifer,sines,shope,scalise,saville,posada,pisano,otte,nolasco,mier,merkle,mendiola,melcher,mejias,mcmurry,mccalla,markowitz,manis,mallette,macfarlane,lough,looper,landin,kittle,kinsella,kinnard,hobart,helman,hellman,hartsock,halford,hage,gordan,glasser,gayton,gattis,gastelum,gaspard,frisch,fitzhugh,eckstein,eberly,dowden,despain,crumpler,crotty,cornelison,chouinard,chamness,catlin,cann,bumgardner,budde,branum,bradfield,braddy,borst,birdwell,bazan,banas,bade,arango,ahearn,addis,zumwalt,wurth,wilk,widener,wagstaff,urrutia,terwilliger,tart,steinman,staats,sloat,rives,riggle,revels,reichard,prickett,poff,pitzer,petro,pell,northrup,nicks,moline,mielke,maynor,mallon,magness,lingle,lindell,lieb,lesko,lebeau,lammers,lafond,kiernan,ketron,jurado,holmgren,hilburn,hayashi,hashimoto,harbaugh,guillot,gard,froehlich,feinberg,falco,dufour,drees,doney,diep,delao,daves,dail,crowson,coss,congdon,carner,camarena,butterworth,burlingame,bouffard,bloch,bilyeu,barta,bakke,baillargeon,avent,aquilar,zeringue,yarber,wolfson,vogler,voelker,truss,troxell,thrift,strouse,spielman,sistrunk,sevigny,schuller,schaaf,ruffner,routh,roseman,ricciardi,peraza,pegram,overturf,olander,odaniel,millner,melchor,maroney,machuca,macaluso,livesay,layfield,laskowski,kwiatkowski,kilby,hovey,heywood,hayman,havard,harville,haigh,hagood,grieco,glassman,gebhardt,fleischer,fann,elson,eccles,cunha,crumb,blakley,bardwell,abshire,woodham,wines,welter,wargo,varnado,tutt,traynor,swaney,stricker,stoffel,stambaugh,sickler,shackleford,selman,seaver,sansom,sanmiguel,royston,rourke,rockett,rioux,puleo,pitchford,nardi,mulvaney,middaugh,malek,leos,lathan,kujawa,kimbro,killebrew,houlihan,hinckley,herod,hepler,hamner,hammel,hallowell,gonsalez,gingerich,gambill,funkhouser,fricke,fewell,falkner,endsley,dulin,drennen,deaver,dambrosio,chadwell,castanon,burkes,brune,brisco,brinker,bowker,boldt,berner,beaumont,beaird,bazemore,barrick,albano,younts,wunderlich,weidman,vanness,toland,theobald,stickler,steiger,stanger,spies,spector,sollars,smedley,seibel,scoville,saito,rummel,rowles,rouleau,roos,rogan,roemer,ream,raya,purkey,priester,perreira,penick,paulin,parkins,overcash,oleson,neves,muldrow,minard,midgett,michalak,melgar,mcentire,mcauliffe,marte,lydon,lindholm,leyba,langevin,lagasse,lafayette,kesler,kelton,kaminsky,jaggers,humbert,huck,howarth,hinrichs,higley,gupton,guimond,gravois,giguere,fretwell,fontes,feeley,faucher,eichhorn,ecker,earp,dole,dinger,derryberry,demars,deel,copenhaver,collinsworth,colangelo,cloyd,claiborne,caulfield,carlsen,calzada,caffey,broadus,brenneman,bouie,bodnar,blaney,blanc,beltz,behling,barahona,yockey,winkle,windom,wimer,villatoro,trexler,teran,taliaferro,sydnor,swinson,snelling,smtih,simonton,simoneaux,simoneau,sherrer,seavey,scheel,rushton,rupe,ruano,rippy,reiner,reiff,rabinowitz,quach,penley,odle,nock,minnich,mckown,mccarver,mcandrew,longley,laux,lamothe,lafreniere,kropp,krick,kates,jepson,huie,howse,howie,henriques,haydon,haught,hatter,hartzog,harkey,grimaldo,goshorn,gormley,gluck,gilroy,gillenwater,giffin,fluker,feder,eyre,eshelman,eakins,detwiler,delrosario,davisson,catalan,canning,calton,brammer,botelho,blakney,bartell,averett,askins,aker,witmer,winkelman,widmer,whittier,weitzel,wardell,wagers,ullman,tupper,tingley,tilghman,talton,simard,seda,scheller,sala,rundell,rost,ribeiro,rabideau,primm,pinon,peart,ostrom,ober,nystrom,nussbaum,naughton,murr,moorhead,monti,monteiro,melson,meissner,mclin,mcgruder,marotta,makowski,majewski,madewell,lunt,lukens,leininger,lebel,lakin,kepler,jaques,hunnicutt,hungerford,hoopes,hertz,heins,halliburton,grosso,gravitt,glasper,gallman,gallaway,funke,fulbright,falgout,eakin,dostie,dorado,dewberry,derose,cutshall,crampton,costanzo,colletti,cloninger,claytor,chiang,campagna,burd,brokaw,broaddus,bretz,brainard,binford,bilbrey,alpert,aitken,ahlers,zajac,woolfolk,witten,windle,wayland,tramel,tittle,talavera,suter,straley,specht,sommerville,soloman,skeens,sigman,sibert,shavers,schuck,schmit,sartain,sabol,rosenblatt,rollo,rashid,rabb,polston,nyberg,northrop,navarra,muldoon,mikesell,mcdougald,mcburney,mariscal,lozier,lingerfelt,legere,latour,lagunas,lacour,kurth,killen,kiely,kayser,kahle,isley,huertas,hower,hinz,haugh,gumm,galicia,fortunato,flake,dunleavy,duggins,doby,digiovanni,devaney,deltoro,cribb,corpuz,coronel,coen,charbonneau,caine,burchette,blakey,blakemore,bergquist,beene,beaudette,bayles,ballance,bakker,bailes,asberry,arwood,zucker,willman,whitesell,wald,walcott,vancleave,trump,strasser,simas,shick,schleicher,schaal,saleh,rotz,resnick,rainer,partee,ollis,oller,oday,noles,munday,mong,millican,merwin,mazzola,mansell,magallanes,llanes,lewellen,lepore,kisner,keesee,jeanlouis,ingham,hornbeck,hawn,hartz,harber,haffner,gutshall,guth,grays,gowan,finlay,finkelstein,eyler,enloe,dungan,diez,dearman,cull,crosson,chronister,cassity,campion,callihan,butz,breazeale,blumenthal,berkey,batty,batton,arvizu,alderete,aldana,albaugh,abernethy,wolter,wille,tweed,tollefson,thomasson,teter,testerman,sproul,spates,southwick,soukup,skelly,senter,sealey,sawicki,sargeant,rossiter,rosemond,repp,pifer,ormsby,nickelson,naumann,morabito,monzon,millsaps,millen,mcelrath,marcoux,mantooth,madson,macneil,mackinnon,louque,leister,lampley,kushner,krouse,kirwan,jessee,janson,jahn,jacquez,islas,hutt,holladay,hillyer,hepburn,hensel,harrold,gingrich,geis,gales,fults,finnell,ferri,featherston,epley,ebersole,eames,dunigan,drye,dismuke,devaughn,delorenzo,damiano,confer,collum,clower,clow,claussen,clack,caylor,cawthon,casias,carreno,bluhm,bingaman,bewley,belew,beckner,auld,amey,wolfenbarger,wilkey,wicklund,waltman,villalba,valero,valdovinos,ullrich,tyus,twyman,trost,tardif,tanguay,stripling,steinbach,shumpert,sasaki,sappington,sandusky,reinhold,reinert,quijano,placencia,pinkard,phinney,perrotta,pernell,parrett,oxendine,owensby,orman,nuno,mori,mcroberts,mcneese,mckamey,mccullum,markel,mardis,maines,lueck,lubin,lefler,leffler,larios,labarbera,kershner,josey,jeanbaptiste,izaguirre,hermosillo,haviland,hartshorn,hafner,ginter,getty,franck,fiske,dufrene,doody,davie,dangerfield,dahlberg,cuthbertson,crone,coffelt,chidester,chesson,cauley,caudell,cantara,campo,caines,bullis,bucci,brochu,bogard,bickerstaff,benning,arzola,antonelli,adkinson,zellers,wulf,worsley,woolridge,whitton,westerfield,walczak,vassar,truett,trueblood,trawick,townsley,topping,tobar,telford,steverson,stagg,sitton,sill,sergent,schoenfeld,sarabia,rutkowski,rubenstein,rigdon,prentiss,pomerleau,plumlee,philbrick,patnode,oloughlin,obregon,nuss,morell,mikell,mele,mcinerney,mcguigan,mcbrayer,lollar,kuehl,kinzer,kamp,joplin,jacobi,howells,holstein,hedden,hassler,harty,halle,greig,gouge,goodrum,gerhart,geier,geddes,gast,forehand,ferree,fendley,feltner,esqueda,encarnacion,eichler,egger,edmundson,eatmon,doud,donohoe,donelson,dilorenzo,digiacomo,diggins,delozier,dejong,danford,crippen,coppage,cogswell,clardy,cioffi,cabe,brunette,bresnahan,blomquist,blackstone,biller,bevis,bevan,bethune,benbow,baty,basinger,balcom,andes,aman,aguero,adkisson,yandell,wilds,whisenhunt,weigand,weeden,voight,villar,trottier,tillett,suazo,setser,scurry,schuh,schreck,schauer,samora,roane,rinker,reimers,ratchford,popovich,parkin,natal,melville,mcbryde,magdaleno,loehr,lockman,lingo,leduc,larocca,lamere,laclair,krall,korte,koger,jalbert,hughs,higbee,henton,heaney,haith,gump,greeson,goodloe,gholston,gasper,gagliardi,fregoso,farthing,fabrizio,ensor,elswick,elgin,eklund,eaddy,drouin,dorton,dizon,derouen,deherrera,davy,dampier,cullum,culley,cowgill,cardoso,cardinale,brodsky,broadbent,brimmer,briceno,branscum,bolyard,boley,bennington,beadle,baur,ballentine,azure,aultman,arciniega,aguila,aceves,yepez,woodrum,wethington,weissman,veloz,trusty,troup,trammel,tarpley,stivers,steck,sprayberry,spraggins,spitler,spiers,sohn,seagraves,schiffman,rudnick,rizo,riccio,rennie,quackenbush,puma,plott,pearcy,parada,paiz,munford,moskowitz,mease,mcnary,mccusker,lozoya,longmire,loesch,lasky,kuhlmann,krieg,koziol,kowalewski,konrad,kindle,jowers,jolin,jaco,horgan,hine,hileman,hepner,heise,heady,hawkinson,hannigan,haberman,guilford,grimaldi,garton,gagliano,fruge,follett,fiscus,ferretti,ebner,easterday,eanes,dirks,dimarco,depalma,deforest,cruce,craighead,christner,candler,cadwell,burchell,buettner,brinton,brazier,brannen,brame,bova,bomar,blakeslee,belknap,bangs,balzer,athey,armes,alvis,alverson,alvardo,yeung,wheelock,westlund,wessels,volkman,threadgill,thelen,tague,symons,swinford,sturtevant,straka,stier,stagner,segarra,seawright,rutan,roux,ringler,riker,ramsdell,quattlebaum,purifoy,poulson,permenter,peloquin,pasley,pagel,osman,obannon,nygaard,newcomer,munos,motta,meadors,mcquiston,mcniel,mcmann,mccrae,mayne,matte,legault,lechner,kucera,krohn,kratzer,koopman,jeske,horrocks,hock,hibbler,hesson,hersh,harvin,halvorsen,griner,grindle,gladstone,garofalo,frampton,forbis,eddington,diorio,dingus,dewar,desalvo,curcio,creasy,cortese,cordoba,connally,cluff,cascio,capuano,canaday,calabro,bussard,brayton,borja,bigley,arnone,arguelles,acuff,zamarripa,wooton,widner,wideman,threatt,thiele,templin,teeters,synder,swint,swick,sturges,stogner,stedman,spratt,siegfried,shetler,scull,savino,sather,rothwell,rook,rone,rhee,quevedo,privett,pouliot,poche,pickel,petrillo,pellegrini,peaslee,partlow,otey,nunnery,morelock,morello,meunier,messinger,mckie,mccubbin,mccarron,lerch,lavine,laverty,lariviere,lamkin,kugler,krol,kissel,keeter,hubble,hickox,hetzel,hayner,hagy,hadlock,groh,gottschalk,goodsell,gassaway,garrard,galligan,firth,fenderson,feinstein,etienne,engleman,emrick,ellender,drews,doiron,degraw,deegan,dart,crissman,corr,cookson,coil,cleaves,charest,chapple,chaparro,castano,carpio,byer,bufford,bridgewater,bridgers,brandes,borrero,bonanno,aube,ancheta,abarca,abad,wooster,wimbush,willhite,willams,wigley,weisberg,wardlaw,vigue,vanhook,unknow,torre,tasker,tarbox,strachan,slover,shamblin,semple,schuyler,schrimsher,sayer,salzman,rubalcava,riles,reneau,reichel,rayfield,rabon,pyatt,prindle,poss,polito,plemmons,pesce,perrault,pereyra,ostrowski,nilsen,niemeyer,munsey,mundell,moncada,miceli,meader,mcmasters,mckeehan,matsumoto,marron,marden,lizarraga,lingenfelter,lewallen,langan,lamanna,kovac,kinsler,kephart,keown,kass,kammerer,jeffreys,hysell,hosmer,hardnett,hanner,guyette,greening,glazer,ginder,fromm,fluellen,finkle,fessler,essary,eisele,duren,dittmer,crochet,cosentino,cogan,coelho,cavin,carrizales,campuzano,brough,bopp,bookman,bobb,blouin,beesley,battista,bascom,bakken,badgett,arneson,anselmo,albino,ahumada,woodyard,wolters,wireman,willison,warman,waldrup,vowell,vantassel,twombly,toomer,tennison,teets,tedeschi,swanner,stutz,stelly,sheehy,schermerhorn,scala,sandidge,salters,salo,saechao,roseboro,rolle,ressler,renz,renn,redford,raposa,rainbolt,pelfrey,orndorff,oney,nolin,nimmons,nardone,myhre,morman,menjivar,mcglone,mccammon,maxon,marciano,manus,lowrance,lorenzen,lonergan,lollis,littles,lindahl,lamas,lach,kuster,krawczyk,knuth,knecht,kirkendall,keitt,keever,kantor,jarboe,hoye,houchens,holter,holsinger,hickok,helwig,helgeson,hassett,harner,hamman,hames,hadfield,goree,goldfarb,gaughan,gaudreau,gantz,gallion,frady,foti,flesher,ferrin,faught,engram,donegan,desouza,degroot,cutright,crowl,criner,coan,clinkscales,chewning,chavira,catchings,carlock,bulger,buenrostro,bramblett,brack,boulware,bookout,bitner,birt,baranowski,baisden,allmon,acklin,yoakum,wilbourn,whisler,weinberger,washer,vasques,vanzandt,vanatta,troxler,tomes,tindle,tims,throckmorton,thach,stpeter,stlaurent,stenson,spry,spitz,songer,snavely,shroyer,shortridge,shenk,sevier,seabrook,scrivner,saltzman,rosenberry,rockwood,robeson,roan,reiser,ramires,raber,posner,popham,piotrowski,pinard,peterkin,pelham,peiffer,peay,nadler,musso,millett,mestas,mcgowen,marques,marasco,manriquez,manos,mair,lipps,leiker,krumm,knorr,kinslow,kessel,kendricks,kelm,irick,ickes,hurlburt,horta,hoekstra,heuer,helmuth,heatherly,hampson,hagar,haga,greenlaw,grau,godbey,gingras,gillies,gibb,gayden,gauvin,garrow,fontanez,florio,finke,fasano,ezzell,ewers,eveland,eckenrode,duclos,drumm,dimmick,delancey,defazio,dashiell,cusack,crowther,crigger,cray,coolidge,coldiron,cleland,chalfant,cassel,camire,cabrales,broomfield,brittingham,brisson,brickey,braziel,brazell,bragdon,boulanger,boman,bohannan,beem,barre,azar,ashbaugh,armistead,almazan,adamski,zendejas,winburn,willaims,wilhoit,westberry,wentzel,wendling,visser,vanscoy,vankirk,vallee,tweedy,thornberry,sweeny,spradling,spano,smelser,shim,sechrist,schall,scaife,rugg,rothrock,roesler,riehl,ridings,render,ransdell,radke,pinero,petree,pendergast,peluso,pecoraro,pascoe,panek,oshiro,navarrette,murguia,moores,moberg,michaelis,mcwhirter,mcsweeney,mcquade,mccay,mauk,mariani,marceau,mandeville,maeda,lunde,ludlow,loeb,lindo,linderman,leveille,leith,larock,lambrecht,kulp,kinsley,kimberlin,kesterson,hoyos,helfrich,hanke,grisby,goyette,gouveia,glazier,gile,gerena,gelinas,gasaway,funches,fujimoto,flynt,fenske,fellers,fehr,eslinger,escalera,enciso,duley,dittman,dineen,diller,devault,collings,clymer,clowers,chavers,charland,castorena,castello,camargo,bunce,bullen,boyes,borchers,borchardt,birnbaum,birdsall,billman,benites,bankhead,ange,ammerman,adkison,winegar,wickman,warr,warnke,villeneuve,veasey,vassallo,vannatta,vadnais,twilley,towery,tomblin,tippett,theiss,talkington,talamantes,swart,swanger,streit,stines,stabler,spurling,sobel,sine,simmers,shippy,shiflett,shearin,sauter,sanderlin,rusch,runkle,ruckman,rorie,roesch,richert,rehm,randel,ragin,quesenberry,puentes,plyler,plotkin,paugh,oshaughnessy,ohalloran,norsworthy,niemann,nader,moorefield,mooneyham,modica,miyamoto,mickel,mebane,mckinnie,mazurek,mancilla,lukas,lovins,loughlin,lotz,lindsley,liddle,levan,lederman,leclaire,lasseter,lapoint,lamoreaux,lafollette,kubiak,kirtley,keffer,kaczmarek,housman,hiers,hibbert,herrod,hegarty,hathorn,greenhaw,grafton,govea,futch,furst,franko,forcier,foran,flickinger,fairfield,eure,emrich,embrey,edgington,ecklund,eckard,durante,deyo,delvecchio,dade,currey,creswell,cottrill,casavant,cartier,cargile,capel,cammack,calfee,burse,burruss,brust,brousseau,bridwell,braaten,borkholder,bloomquist,bjork,bartelt,amburgey,yeary,whitefield,vinyard,vanvalkenburg,twitchell,timmins,tapper,stringham,starcher,spotts,slaugh,simonsen,sheffer,sequeira,rosati,rhymes,quint,pollak,peirce,patillo,parkerson,paiva,nilson,nevin,narcisse,mitton,merriam,merced,meiners,mckain,mcelveen,mcbeth,marsden,marez,manke,mahurin,mabrey,luper,krull,hunsicker,hornbuckle,holtzclaw,hinnant,heston,hering,hemenway,hegwood,hearns,halterman,guiterrez,grote,granillo,grainger,glasco,gilder,garren,garlock,garey,fryar,fredricks,fraizer,foshee,ferrel,felty,everitt,evens,esser,elkin,eberhart,durso,duguay,driskill,doster,dewall,deveau,demps,demaio,delreal,deleo,darrah,cumberbatch,culberson,cranmer,cordle,colgan,chesley,cavallo,castellon,castelli,carreras,carnell,carlucci,bontrager,blumberg,blasingame,becton,artrip,andujar,alkire,alder,zukowski,zuckerman,wroblewski,wrigley,woodside,wigginton,westman,westgate,werts,washam,wardlow,walser,waiters,tadlock,stringfield,stimpson,stickley,standish,spurlin,spindler,speller,spaeth,sotomayor,sluder,shryock,shepardson,shatley,scannell,santistevan,rosner,resto,reinhard,rathburn,prisco,poulsen,pinney,phares,pennock,pastrana,oviedo,ostler,nauman,mulford,moise,moberly,mirabal,metoyer,metheny,mentzer,meldrum,mcinturff,mcelyea,mcdougle,massaro,lumpkins,loveday,lofgren,lirette,lesperance,lefkowitz,ledger,lauzon,lachapelle,klassen,keough,kempton,kaelin,jeffords,hsieh,hoyer,horwitz,hoeft,hennig,haskin,gourdine,golightly,girouard,fulgham,fritsch,freer,frasher,foulk,firestone,fiorentino,fedor,ensley,englehart,eells,dunphy,donahoe,dileo,dibenedetto,dabrowski,crick,coonrod,conder,coddington,chunn,chaput,cerna,carreiro,calahan,braggs,bourdon,bollman,bittle,bauder,barreras,aubuchon,anzalone,adamo,zerbe,willcox,westberg,weikel,waymire,vroman,vinci,vallejos,truesdell,troutt,trotta,tollison,toles,tichenor,symonds,surles,strayer,stgeorge,sroka,sorrentino,solares,snelson,silvestri,sikorski,shawver,schumaker,schorr,schooley,scates,satterlee,satchell,rymer,roselli,robitaille,riegel,regis,reames,provenzano,priestley,plaisance,pettey,palomares,nowakowski,monette,minyard,mclamb,mchone,mccarroll,masson,magoon,maddy,lundin,licata,leonhardt,landwehr,kircher,kinch,karpinski,johannsen,hussain,houghtaling,hoskinson,hollaway,holeman,hobgood,hiebert,goggin,geissler,gadbois,gabaldon,fleshman,flannigan,fairman,eilers,dycus,dunmire,duffield,dowler,deloatch,dehaan,deemer,clayborn,christofferso,chilson,chesney,chatfield,carron,canale,brigman,branstetter,bosse,borton,bonar,biron,barroso,arispe,zacharias,zabel,yaeger,woolford,whetzel,weakley,veatch,vandeusen,tufts,troxel,troche,traver,townsel,talarico,swilley,sterrett,stenger,speakman,sowards,sours,souders,souder,soles,sobers,snoddy,smither,shute,shoaf,shahan,schuetz,scaggs,santini,rosson,rolen,robidoux,rentas,recio,pixley,pawlowski,pawlak,paull,overbey,orear,oliveri,oldenburg,nutting,naugle,mossman,misner,milazzo,michelson,mcentee,mccullar,mccree,mcaleer,mazzone,mandell,manahan,malott,maisonet,mailloux,lumley,lowrie,louviere,lipinski,lindemann,leppert,leasure,labarge,kubik,knisely,knepp,kenworthy,kennelly,kelch,kanter,houchin,hosley,hosler,hollon,holleman,heitman,haggins,gwaltney,goulding,gorden,geraci,gathers,frison,feagin,falconer,espada,erving,erikson,eisenhauer,ebeling,durgin,dowdle,dinwiddie,delcastillo,dedrick,crimmins,covell,cournoyer,coria,cohan,cataldo,carpentier,canas,campa,brode,brashears,blaser,bicknell,bednar,barwick,ascencio,althoff,almodovar,alamo,zirkle,zabala,wolverton,winebrenner,wetherell,westlake,wegener,weddington,tuten,trosclair,tressler,theroux,teske,swinehart,swensen,sundquist,southall,socha,sizer,silverberg,shortt,shimizu,sherrard,shaeffer,scheid,scheetz,saravia,sanner,rubinstein,rozell,romer,rheaume,reisinger,randles,pullum,petrella,payan,nordin,norcross,nicoletti,nicholes,newbold,nakagawa,monteith,milstead,milliner,mellen,mccardle,liptak,leitch,latimore,larrison,landau,laborde,koval,izquierdo,hymel,hoskin,holte,hoefer,hayworth,hausman,harrill,harrel,hardt,gully,groover,grinnell,greenspan,graver,grandberry,gorrell,goldenberg,goguen,gilleland,fuson,feldmann,everly,dyess,dunnigan,downie,dolby,deatherage,cosey,cheever,celaya,caver,cashion,caplinger,cansler,byrge,bruder,breuer,breslin,brazelton,botkin,bonneau,bondurant,bohanan,bogue,bodner,boatner,blatt,bickley,belliveau,beiler,beier,beckstead,bachmann,atkin,altizer,alloway,allaire,albro,abron,zellmer,yetter,yelverton,wiens,whidden,viramontes,vanwormer,tarantino,tanksley,sumlin,strauch,strang,stice,spahn,sosebee,sigala,shrout,seamon,schrum,schneck,schantz,ruddy,romig,roehl,renninger,reding,polak,pohlman,pasillas,oldfield,oldaker,ohanlon,ogilvie,norberg,nolette,neufeld,nellis,mummert,mulvihill,mullaney,monteleone,mendonca,meisner,mcmullan,mccluney,mattis,massengill,manfredi,luedtke,lounsbury,liberatore,lamphere,laforge,jourdan,iorio,iniguez,ikeda,hubler,hodgdon,hocking,heacock,haslam,haralson,hanshaw,hannum,hallam,haden,garnes,garces,gammage,gambino,finkel,faucett,ehrhardt,eggen,dusek,durrant,dubay,dones,depasquale,delucia,degraff,decamp,davalos,cullins,conard,clouser,clontz,cifuentes,chappel,chaffins,celis,carwile,byram,bruggeman,bressler,brathwaite,brasfield,bradburn,boose,bodie,blosser,bertsch,bernardi,bernabe,bengtson,barrette,astorga,alday,albee,abrahamson,yarnell,wiltse,wiebe,waguespack,vasser,upham,turek,traxler,torain,tomaszewski,tinnin,tiner,tindell,styron,stahlman,staab,skiba,sheperd,seidl,secor,schutte,sanfilippo,ruder,rondon,rearick,procter,prochaska,pettengill,pauly,neilsen,nally,mullenax,morano,meads,mcnaughton,mcmurtry,mcmath,mckinsey,matthes,massenburg,marlar,margolis,malin,magallon,mackin,lovette,loughran,loring,longstreet,loiselle,lenihan,kunze,koepke,kerwin,kalinowski,kagan,innis,innes,holtzman,heinemann,harshman,haider,haack,grondin,grissett,greenawalt,goudy,goodlett,goldston,gokey,gardea,galaviz,gafford,gabrielson,furlow,fritch,fordyce,folger,elizalde,ehlert,eckhoff,eccleston,ealey,dubin,diemer,deschamps,delapena,decicco,debolt,cullinan,crittendon,crase,cossey,coppock,coots,colyer,cluck,chamberland,burkhead,bumpus,buchan,borman,birkholz,berardi,benda,behnke,barter,amezquita,wotring,wirtz,wingert,wiesner,whitesides,weyant,wainscott,venezia,varnell,tussey,thurlow,tabares,stiver,stell,starke,stanhope,stanek,sisler,sinnott,siciliano,shehan,selph,seager,scurlock,scranton,santucci,santangelo,saltsman,rogge,rettig,renwick,reidy,reider,redfield,premo,parente,paolucci,palmquist,ohler,netherton,mutchler,morita,mistretta,minnis,middendorf,menzel,mendosa,mendelson,meaux,mcspadden,mcquaid,mcnatt,manigault,maney,mager,lukes,lopresti,liriano,letson,lechuga,lazenby,lauria,larimore,krupp,krupa,kopec,kinchen,kifer,kerney,kerner,kennison,kegley,karcher,justis,johson,jellison,janke,huskins,holzman,hinojos,hefley,hatmaker,harte,halloway,hallenbeck,goodwyn,glaspie,geise,fullwood,fryman,frakes,fraire,farrer,enlow,engen,ellzey,eckles,earles,dunkley,drinkard,dreiling,draeger,dinardo,dills,desroches,desantiago,curlee,crumbley,critchlow,coury,courtright,coffield,cleek,charpentier,cardone,caples,cantin,buntin,bugbee,brinkerhoff,brackin,bourland,blassingame,beacham,banning,auguste,andreasen,amann,almon,alejo,adelman,abston,yerger,wymer,woodberry,windley,whiteaker,westfield,weibel,wanner,waldrep,villani,vanarsdale,utterback,updike,triggs,topete,tolar,tigner,thoms,tauber,tarvin,tally,swiney,sweatman,studebaker,stennett,starrett,stannard,stalvey,sonnenberg,smithey,sieber,sickles,shinault,segars,sanger,salmeron,rothe,rizzi,restrepo,ralls,ragusa,quiroga,papenfuss,oropeza,okane,mudge,mozingo,molinaro,mcvicker,mcgarvey,mcfalls,mccraney,matus,magers,llanos,livermore,linehan,leitner,laymon,lawing,lacourse,kwong,kollar,kneeland,kennett,kellett,kangas,janzen,hutter,huling,hofmeister,hewes,harjo,habib,guice,grullon,greggs,grayer,granier,grable,gowdy,giannini,getchell,gartman,garnica,ganey,gallimore,fetters,fergerson,farlow,fagundes,exley,esteves,enders,edenfield,easterwood,drakeford,dipasquale,desousa,deshields,deeter,dedmon,debord,daughtery,cutts,courtemanche,coursey,copple,coomes,collis,cogburn,clopton,choquette,chaidez,castrejon,calhoon,burbach,bulloch,buchman,bruhn,bohon,blough,baynes,barstow,zeman,zackery,yardley,yamashita,wulff,wilken,wiliams,wickersham,wible,whipkey,wedgeworth,walmsley,walkup,vreeland,verrill,umana,traub,swingle,summey,stroupe,stockstill,steffey,stefanski,statler,stapp,speights,solari,soderberg,shunk,shorey,shewmaker,sheilds,schiffer,schank,schaff,sagers,rochon,riser,rickett,reale,raglin,polen,plata,pitcock,percival,palen,orona,oberle,nocera,navas,nault,mullings,montejano,monreal,minick,middlebrook,meece,mcmillion,mccullen,mauck,marshburn,maillet,mahaney,magner,maclin,lucey,litteral,lippincott,leite,leaks,lamarre,jurgens,jerkins,jager,hurwitz,hughley,hotaling,horstman,hohman,hocker,hively,hipps,hessler,hermanson,hepworth,helland,hedlund,harkless,haigler,gutierez,grindstaff,glantz,giardina,gerken,gadsden,finnerty,farnum,encinas,drakes,dennie,cutlip,curtsinger,couto,cortinas,corby,chiasson,carle,carballo,brindle,borum,bober,blagg,berthiaume,beahm,batres,basnight,backes,axtell,atterberry,alvares,alegria,woodell,wojciechowski,winfree,winbush,wiest,wesner,wamsley,wakeman,verner,truex,trafton,toman,thorsen,theus,tellier,tallant,szeto,strope,stills,simkins,shuey,shaul,servin,serio,serafin,salguero,ryerson,rudder,ruark,rother,rohrbaugh,rohrbach,rohan,rogerson,risher,reeser,pryce,prokop,prins,priebe,prejean,pinheiro,petrone,petri,penson,pearlman,parikh,natoli,murakami,mullikin,mullane,motes,morningstar,mcveigh,mcgrady,mcgaughey,mccurley,marchan,manske,lusby,linde,likens,licon,leroux,lemaire,legette,laskey,laprade,laplant,kolar,kittredge,kinley,kerber,kanagy,jetton,janik,ippolito,inouye,hunsinger,howley,howery,horrell,holthaus,hiner,hilson,hilderbrand,hartzler,harnish,harada,hansford,halligan,hagedorn,gwynn,gudino,greenstein,greear,gracey,goudeau,goodner,ginsburg,gerth,gerner,fujii,frier,frenette,folmar,fleisher,fleischmann,fetzer,eisenman,earhart,dupuy,dunkelberger,drexler,dillinger,dilbeck,dewald,demby,deford,craine,chesnut,casady,carstens,carrick,carino,carignan,canchola,bushong,burman,buono,brownlow,broach,britten,brickhouse,boyden,boulton,borland,bohrer,blubaugh,bever,berggren,benevides,arocho,arends,amezcua,almendarez,zalewski,witzel,winkfield,wilhoite,vangundy,vanfleet,vanetten,vandergriff,urbanski,troiano,thibodaux,straus,stoneking,stjean,stillings,stange,speicher,speegle,smeltzer,slawson,simmonds,shuttleworth,serpa,senger,seidman,schweiger,schloss,schimmel,schechter,sayler,sabatini,ronan,rodiguez,riggleman,richins,reamer,prunty,porath,plunk,piland,philbrook,pettitt,perna,peralez,pascale,padula,oboyle,nivens,nickols,mundt,munden,montijo,mcmanis,mcgrane,mccrimmon,manzi,mangold,malick,mahar,maddock,losey,litten,leedy,leavell,ladue,krahn,kluge,junker,iversen,imler,hurtt,huizar,hubbert,howington,hollomon,holdren,hoisington,heiden,hauge,hartigan,gutirrez,griffie,greenhill,gratton,granata,gottfried,gertz,gautreaux,furry,furey,funderburg,flippen,fitzgibbon,drucker,donoghue,dildy,devers,detweiler,despres,denby,degeorge,cueto,cranston,courville,clukey,cirillo,chivers,caudillo,butera,bulluck,buckmaster,braunstein,bracamonte,bourdeau,bonnette".split(","),
    us_tv_and_film: "you,i,to,that,it,me,what,this,know,i'm,no,have,my,don't,just,not,do,be,your,we,it's,so,but,all,well,oh,about,right,you're,get,here,out,going,like,yeah,if,can,up,want,think,that's,now,go,him,how,got,did,why,see,come,good,really,look,will,okay,back,can't,mean,tell,i'll,hey,he's,could,didn't,yes,something,because,say,take,way,little,make,need,gonna,never,we're,too,she's,i've,sure,our,sorry,what's,let,thing,maybe,down,man,very,there's,should,anything,said,much,any,even,off,please,doing,thank,give,thought,help,talk,god,still,wait,find,nothing,again,things,let's,doesn't,call,told,great,better,ever,night,away,believe,feel,everything,you've,fine,last,keep,does,put,around,stop,they're,i'd,guy,isn't,always,listen,wanted,guys,huh,those,big,lot,happened,thanks,won't,trying,kind,wrong,talking,guess,care,bad,mom,remember,getting,we'll,together,dad,leave,understand,wouldn't,actually,hear,baby,nice,father,else,stay,done,wasn't,course,might,mind,every,enough,try,hell,came,someone,you'll,whole,yourself,idea,ask,must,coming,looking,woman,room,knew,tonight,real,son,hope,went,hmm,happy,pretty,saw,girl,sir,friend,already,saying,next,job,problem,minute,thinking,haven't,heard,honey,matter,myself,couldn't,exactly,having,probably,happen,we've,hurt,boy,dead,gotta,alone,excuse,start,kill,hard,you'd,today,car,ready,without,wants,hold,wanna,yet,seen,deal,once,gone,morning,supposed,friends,head,stuff,worry,live,truth,face,forget,true,cause,soon,knows,telling,wife,who's,chance,run,move,anyone,person,bye,somebody,heart,miss,making,meet,anyway,phone,reason,damn,lost,looks,bring,case,turn,wish,tomorrow,kids,trust,check,change,anymore,least,aren't,working,makes,taking,means,brother,hate,ago,says,beautiful,gave,fact,crazy,sit,afraid,important,rest,fun,kid,word,watch,glad,everyone,sister,minutes,everybody,bit,couple,whoa,either,mrs,feeling,daughter,wow,gets,asked,break,promise,door,close,hand,easy,question,tried,far,walk,needs,mine,killed,hospital,anybody,alright,wedding,shut,able,die,perfect,stand,comes,hit,waiting,dinner,funny,husband,almost,pay,answer,cool,eyes,news,child,shouldn't,yours,moment,sleep,read,where's,sounds,sonny,pick,sometimes,bed,date,plan,hours,lose,hands,serious,shit,behind,inside,ahead,week,wonderful,fight,past,cut,quite,he'll,sick,it'll,eat,nobody,goes,save,seems,finally,lives,worried,upset,carly,met,brought,seem,sort,safe,weren't,leaving,front,shot,loved,asking,running,clear,figure,hot,felt,parents,drink,absolutely,how's,daddy,sweet,alive,sense,meant,happens,bet,blood,ain't,kidding,lie,meeting,dear,seeing,sound,fault,ten,buy,hour,speak,lady,jen,thinks,christmas,outside,hang,possible,worse,mistake,ooh,handle,spend,totally,giving,here's,marriage,realize,unless,sex,send,needed,scared,picture,talked,ass,hundred,changed,completely,explain,certainly,sign,boys,relationship,loves,hair,lying,choice,anywhere,future,weird,luck,she'll,turned,touch,kiss,crane,questions,obviously,wonder,pain,calling,somewhere,throw,straight,cold,fast,words,food,none,drive,feelings,they'll,marry,drop,cannot,dream,protect,twenty,surprise,sweetheart,poor,looked,mad,except,gun,y'know,dance,takes,appreciate,especially,situation,besides,pull,hasn't,worth,sheridan,amazing,expect,swear,piece,busy,happening,movie,we'd,catch,perhaps,step,fall,watching,kept,darling,dog,honor,moving,till,admit,problems,murder,he'd,evil,definitely,feels,honest,eye,broke,missed,longer,dollars,tired,evening,starting,entire,trip,niles,suppose,calm,imagine,fair,caught,blame,sitting,favor,apartment,terrible,clean,learn,frasier,relax,accident,wake,prove,smart,message,missing,forgot,interested,table,nbsp,mouth,pregnant,ring,careful,shall,dude,ride,figured,wear,shoot,stick,follow,angry,write,stopped,ran,standing,forgive,jail,wearing,ladies,kinda,lunch,cristian,greenlee,gotten,hoping,phoebe,thousand,ridge,paper,tough,tape,count,boyfriend,proud,agree,birthday,they've,share,offer,hurry,feet,wondering,decision,ones,finish,voice,herself,would've,mess,deserve,evidence,cute,dress,interesting,hotel,enjoy,quiet,concerned,staying,beat,sweetie,mention,clothes,fell,neither,mmm,fix,respect,prison,attention,holding,calls,surprised,bar,keeping,gift,hadn't,putting,dark,owe,ice,helping,normal,aunt,lawyer,apart,plans,jax,girlfriend,floor,whether,everything's,box,judge,upstairs,sake,mommy,possibly,worst,acting,accept,blow,strange,saved,conversation,plane,mama,yesterday,lied,quick,lately,stuck,difference,store,she'd,bought,doubt,listening,walking,cops,deep,dangerous,buffy,sleeping,chloe,rafe,join,card,crime,gentlemen,willing,window,walked,guilty,likes,fighting,difficult,soul,joke,favorite,uncle,promised,bother,seriously,cell,knowing,broken,advice,somehow,paid,losing,push,helped,killing,boss,liked,innocent,rules,learned,thirty,risk,letting,speaking,ridiculous,afternoon,apologize,nervous,charge,patient,boat,how'd,hide,detective,planning,huge,breakfast,horrible,awful,pleasure,driving,hanging,picked,sell,quit,apparently,dying,notice,congratulations,visit,could've,c'mon,letter,decide,forward,fool,showed,smell,seemed,spell,memory,pictures,slow,seconds,hungry,hearing,kitchen,ma'am,should've,realized,kick,grab,discuss,fifty,reading,idiot,suddenly,agent,destroy,bucks,shoes,peace,arms,demon,livvie,consider,papers,incredible,witch,drunk,attorney,tells,knock,ways,gives,nose,skye,turns,keeps,jealous,drug,sooner,cares,plenty,extra,outta,weekend,matters,gosh,opportunity,impossible,waste,pretend,jump,eating,proof,slept,arrest,breathe,perfectly,warm,pulled,twice,easier,goin,dating,suit,romantic,drugs,comfortable,finds,checked,divorce,begin,ourselves,closer,ruin,smile,laugh,treat,fear,what'd,otherwise,excited,mail,hiding,stole,pacey,noticed,fired,excellent,bringing,bottom,note,sudden,bathroom,honestly,sing,foot,remind,charges,witness,finding,tree,dare,hardly,that'll,steal,silly,contact,teach,shop,plus,colonel,fresh,trial,invited,roll,reach,dirty,choose,emergency,dropped,butt,credit,obvious,locked,loving,nuts,agreed,prue,goodbye,condition,guard,fuckin,grow,cake,mood,crap,crying,belong,partner,trick,pressure,dressed,taste,neck,nurse,raise,lots,carry,whoever,drinking,they'd,breaking,file,lock,wine,spot,paying,assume,asleep,turning,viki,bedroom,shower,nikolas,camera,fill,reasons,forty,bigger,nope,breath,doctors,pants,freak,movies,folks,cream,wild,truly,desk,convince,client,threw,hurts,spending,answers,shirt,chair,rough,doin,sees,ought,empty,wind,aware,dealing,pack,tight,hurting,guest,arrested,salem,confused,surgery,expecting,deacon,unfortunately,goddamn,bottle,beyond,whenever,pool,opinion,starts,jerk,secrets,falling,necessary,barely,dancing,tests,copy,cousin,ahem,twelve,tess,skin,fifteen,speech,orders,complicated,nowhere,escape,biggest,restaurant,grateful,usual,burn,address,someplace,screw,everywhere,regret,goodness,mistakes,details,responsibility,suspect,corner,hero,dumb,terrific,whoo,hole,memories,o'clock,teeth,ruined,bite,stenbeck,liar,showing,cards,desperate,search,pathetic,spoke,scare,marah,afford,settle,stayed,checking,hired,heads,concern,blew,alcazar,champagne,connection,tickets,happiness,saving,kissing,hated,personally,suggest,prepared,onto,downstairs,ticket,it'd,loose,holy,duty,convinced,throwing,kissed,legs,loud,saturday,babies,where'd,warning,miracle,carrying,blind,ugly,shopping,hates,sight,bride,coat,clearly,celebrate,brilliant,wanting,forrester,lips,custody,screwed,buying,toast,thoughts,reality,lexie,attitude,advantage,grandfather,sami,grandma,someday,roof,marrying,powerful,grown,grandmother,fake,must've,ideas,exciting,familiar,bomb,bout,harmony,schedule,capable,practically,correct,clue,forgotten,appointment,deserves,threat,bloody,lonely,shame,jacket,hook,scary,investigation,invite,shooting,lesson,criminal,victim,funeral,considering,burning,strength,harder,sisters,pushed,shock,pushing,heat,chocolate,miserable,corinthos,nightmare,brings,zander,crash,chances,sending,recognize,healthy,boring,feed,engaged,headed,treated,knife,drag,badly,hire,paint,pardon,behavior,closet,warn,gorgeous,milk,survive,ends,dump,rent,remembered,thanksgiving,rain,revenge,prefer,spare,pray,disappeared,aside,statement,sometime,meat,fantastic,breathing,laughing,stood,affair,ours,depends,protecting,jury,brave,fingers,murdered,explanation,picking,blah,stronger,handsome,unbelievable,anytime,shake,oakdale,wherever,pulling,facts,waited,lousy,circumstances,disappointed,weak,trusted,license,nothin,trash,understanding,slip,sounded,awake,friendship,stomach,weapon,threatened,mystery,vegas,understood,basically,switch,frankly,cheap,lifetime,deny,clock,garbage,why'd,tear,ears,indeed,changing,singing,tiny,decent,avoid,messed,filled,touched,disappear,exact,pills,kicked,harm,fortune,pretending,insurance,fancy,drove,cared,belongs,nights,lorelai,lift,timing,guarantee,chest,woke,burned,watched,heading,selfish,drinks,doll,committed,elevator,freeze,noise,wasting,ceremony,uncomfortable,staring,files,bike,stress,permission,thrown,possibility,borrow,fabulous,doors,screaming,bone,xander,what're,meal,apology,anger,honeymoon,bail,parking,fixed,wash,stolen,sensitive,stealing,photo,chose,lets,comfort,worrying,pocket,mateo,bleeding,shoulder,ignore,talent,tied,garage,dies,demons,dumped,witches,rude,crack,bothering,radar,soft,meantime,gimme,kinds,fate,concentrate,throat,prom,messages,intend,ashamed,somethin,manage,guilt,interrupt,guts,tongue,shoe,basement,sentence,purse,glasses,cabin,universe,repeat,mirror,wound,travers,tall,engagement,therapy,emotional,jeez,decisions,soup,thrilled,stake,chef,moves,extremely,moments,expensive,counting,shots,kidnapped,cleaning,shift,plate,impressed,smells,trapped,aidan,knocked,charming,attractive,argue,puts,whip,embarrassed,package,hitting,bust,stairs,alarm,pure,nail,nerve,incredibly,walks,dirt,stamp,terribly,friendly,damned,jobs,suffering,disgusting,stopping,deliver,riding,helps,disaster,bars,crossed,trap,talks,eggs,chick,threatening,spoken,introduce,confession,embarrassing,bags,impression,gate,reputation,presents,chat,suffer,argument,talkin,crowd,homework,coincidence,cancel,pride,solve,hopefully,pounds,pine,mate,illegal,generous,outfit,maid,bath,punch,freaked,begging,recall,enjoying,prepare,wheel,defend,signs,painful,yourselves,maris,that'd,suspicious,cooking,button,warned,sixty,pity,yelling,awhile,confidence,offering,pleased,panic,hers,gettin,refuse,grandpa,testify,choices,cruel,mental,gentleman,coma,cutting,proteus,guests,expert,benefit,faces,jumped,toilet,sneak,halloween,privacy,smoking,reminds,twins,swing,solid,options,commitment,crush,ambulance,wallet,gang,eleven,option,laundry,assure,stays,skip,fail,discussion,clinic,betrayed,sticking,bored,mansion,soda,sheriff,suite,handled,busted,load,happier,studying,romance,procedure,commit,assignment,suicide,minds,swim,yell,llanview,chasing,proper,believes,humor,hopes,lawyers,giant,latest,escaped,parent,tricks,insist,dropping,cheer,medication,flesh,routine,sandwich,handed,false,beating,warrant,awfully,odds,treating,thin,suggesting,fever,sweat,silent,clever,sweater,mall,sharing,assuming,judgment,goodnight,divorced,surely,steps,confess,math,listened,comin,answered,vulnerable,bless,dreaming,chip,zero,pissed,nate,kills,tears,knees,chill,brains,unusual,packed,dreamed,cure,lookin,grave,cheating,breaks,locker,gifts,awkward,thursday,joking,reasonable,dozen,curse,quartermaine,millions,dessert,rolling,detail,alien,delicious,closing,vampires,wore,tail,secure,salad,murderer,spit,offense,dust,conscience,bread,answering,lame,invitation,grief,smiling,pregnancy,prisoner,delivery,guards,virus,shrink,freezing,wreck,massimo,wire,technically,blown,anxious,cave,holidays,cleared,wishes,caring,candles,bound,charm,pulse,jumping,jokes,boom,occasion,silence,nonsense,frightened,slipped,dimera,blowing,relationships,kidnapping,spin,tool,roxy,packing,blaming,wrap,obsessed,fruit,torture,personality,there'll,fairy,necessarily,seventy,print,motel,underwear,grams,exhausted,believing,freaking,carefully,trace,touching,messing,recovery,intention,consequences,belt,sacrifice,courage,enjoyed,attracted,remove,testimony,intense,heal,defending,unfair,relieved,loyal,slowly,buzz,alcohol,surprises,psychiatrist,plain,attic,who'd,uniform,terrified,cleaned,zach,threaten,fella,enemies,satisfied,imagination,hooked,headache,forgetting,counselor,andie,acted,badge,naturally,frozen,sakes,appropriate,trunk,dunno,costume,sixteen,impressive,kicking,junk,grabbed,understands,describe,clients,owns,affect,witnesses,starving,instincts,happily,discussing,deserved,strangers,surveillance,admire,questioning,dragged,barn,deeply,wrapped,wasted,tense,hoped,fellas,roommate,mortal,fascinating,stops,arrangements,agenda,literally,propose,honesty,underneath,sauce,promises,lecture,eighty,torn,shocked,backup,differently,ninety,deck,biological,pheebs,ease,creep,waitress,telephone,ripped,raising,scratch,rings,prints,thee,arguing,ephram,asks,oops,diner,annoying,taggert,sergeant,blast,towel,clown,habit,creature,bermuda,snap,react,paranoid,handling,eaten,therapist,comment,sink,reporter,nurses,beats,priority,interrupting,warehouse,loyalty,inspector,pleasant,excuses,threats,guessing,tend,praying,motive,unconscious,mysterious,unhappy,tone,switched,rappaport,sookie,neighbor,loaded,swore,piss,balance,toss,misery,thief,squeeze,lobby,goa'uld,geez,exercise,forth,booked,sandburg,poker,eighteen,d'you,bury,everyday,digging,creepy,wondered,liver,hmmm,magical,fits,discussed,moral,helpful,searching,flew,depressed,aisle,cris,amen,vows,neighbors,darn,cents,arrange,annulment,useless,adventure,resist,fourteen,celebrating,inch,debt,violent,sand,teal'c,celebration,reminded,phones,paperwork,emotions,stubborn,pound,tension,stroke,steady,overnight,chips,beef,suits,boxes,cassadine,collect,tragedy,spoil,realm,wipe,surgeon,stretch,stepped,nephew,neat,limo,confident,perspective,climb,punishment,finest,springfield,hint,furniture,blanket,twist,proceed,fries,worries,niece,gloves,soap,signature,disappoint,crawl,convicted,flip,counsel,doubts,crimes,accusing,shaking,remembering,hallway,halfway,bothered,madam,gather,cameras,blackmail,symptoms,rope,ordinary,imagined,cigarette,supportive,explosion,trauma,ouch,furious,cheat,avoiding,whew,thick,oooh,boarding,approve,urgent,shhh,misunderstanding,drawer,phony,interfere,catching,bargain,tragic,respond,punish,penthouse,thou,rach,ohhh,insult,bugs,beside,begged,absolute,strictly,socks,senses,sneaking,reward,polite,checks,tale,physically,instructions,fooled,blows,tabby,bitter,adorable,y'all,tested,suggestion,jewelry,alike,jacks,distracted,shelter,lessons,constable,circus,audition,tune,shoulders,mask,helpless,feeding,explains,sucked,robbery,objection,behave,valuable,shadows,courtroom,confusing,talented,smarter,mistaken,customer,bizarre,scaring,motherfucker,alert,vecchio,reverend,foolish,compliment,bastards,worker,wheelchair,protective,gentle,reverse,picnic,knee,cage,wives,wednesday,voices,toes,stink,scares,pour,cheated,slide,ruining,filling,exit,cottage,upside,proves,parked,diary,complaining,confessed,pipe,merely,massage,chop,spill,prayer,betray,waiter,scam,rats,fraud,brush,tables,sympathy,pill,filthy,seventeen,employee,bracelet,pays,fairly,deeper,arrive,tracking,spite,shed,recommend,oughta,nanny,menu,diet,corn,roses,patch,dime,devastated,subtle,bullets,beans,pile,confirm,strings,parade,borrowed,toys,straighten,steak,premonition,planted,honored,exam,convenient,traveling,laying,insisted,dish,aitoro,kindly,grandson,donor,temper,teenager,proven,mothers,denial,backwards,tent,swell,noon,happiest,drives,thinkin,spirits,potion,holes,fence,whatsoever,rehearsal,overheard,lemme,hostage,bench,tryin,taxi,shove,moron,impress,needle,intelligent,instant,disagree,stinks,rianna,recover,groom,gesture,constantly,bartender,suspects,sealed,legally,hears,dresses,sheet,psychic,teenage,knocking,judging,accidentally,waking,rumor,manners,homeless,hollow,desperately,tapes,referring,item,genoa,gear,majesty,cried,tons,spells,instinct,quote,motorcycle,convincing,fashioned,aids,accomplished,grip,bump,upsetting,needing,invisible,forgiveness,feds,compare,bothers,tooth,inviting,earn,compromise,cocktail,tramp,jabot,intimate,dignity,dealt,souls,informed,gods,dressing,cigarettes,alistair,leak,fond,corky,seduce,liquor,fingerprints,enchantment,butters,stuffed,stavros,emotionally,transplant,tips,oxygen,nicely,lunatic,drill,complain,announcement,unfortunate,slap,prayers,plug,opens,oath,o'neill,mutual,yacht,remembers,fried,extraordinary,bait,warton,sworn,stare,safely,reunion,burst,might've,dive,aboard,expose,buddies,trusting,booze,sweep,sore,scudder,properly,parole,ditch,canceled,speaks,glow,wears,thirsty,skull,ringing,dorm,dining,bend,unexpected,pancakes,harsh,flattered,ahhh,troubles,fights,favourite,eats,rage,undercover,spoiled,sloane,shine,destroying,deliberately,conspiracy,thoughtful,sandwiches,plates,nails,miracles,fridge,drank,contrary,beloved,allergic,washed,stalking,solved,sack,misses,forgiven,bent,maciver,involve,dragging,cooked,pointing,foul,dull,beneath,heels,faking,deaf,stunt,jealousy,hopeless,fears,cuts,scenario,necklace,crashed,accuse,restraining,homicide,helicopter,firing,safer,auction,videotape,tore,reservations,pops,appetite,wounds,vanquish,ironic,fathers,excitement,anyhow,tearing,sends,rape,laughed,belly,dealer,cooperate,accomplish,wakes,spotted,sorts,reservation,ashes,tastes,supposedly,loft,intentions,integrity,wished,towels,suspected,investigating,inappropriate,lipstick,lawn,compassion,cafeteria,scarf,precisely,obsession,loses,lighten,infection,granddaughter,explode,balcony,this'll,spying,publicity,depend,cracked,conscious,ally,absurd,vicious,invented,forbid,directions,defendant,bare,announce,screwing,salesman,robbed,leap,lakeview,insanity,reveal,possibilities,kidnap,gown,chairs,wishing,setup,punished,criminals,regrets,raped,quarters,lamp,dentist,anyways,anonymous,semester,risks,owes,lungs,explaining,delicate,tricked,eager,doomed,adoption,stab,sickness,scum,floating,envelope,vault,sorel,pretended,potatoes,plea,photograph,payback,misunderstood,kiddo,healing,cascade,capeside,stabbed,remarkable,brat,privilege,passionate,nerves,lawsuit,kidney,disturbed,cozy,tire,shirts,oven,ordering,delay,risky,monsters,honorable,grounded,closest,breakdown,bald,abandon,scar,collar,worthless,sucking,enormous,disturbing,disturb,distract,deals,conclusions,vodka,dishes,crawling,briefcase,wiped,whistle,sits,roast,rented,pigs,flirting,deposit,bottles,topic,riot,overreacting,logical,hostile,embarrass,casual,beacon,amusing,altar,claus,survival,skirt,shave,porch,ghosts,favors,drops,dizzy,chili,advise,strikes,rehab,photographer,peaceful,leery,heavens,fortunately,fooling,expectations,cigar,weakness,ranch,practicing,examine,cranes,bribe,sail,prescription,hush,fragile,forensics,expense,drugged,cows,bells,visitor,suitcase,sorta,scan,manticore,insecure,imagining,hardest,clerk,wrist,what'll,starters,silk,pump,pale,nicer,haul,flies,boot,thumb,there'd,how're,elders,quietly,pulls,idiots,erase,denying,ankle,amnesia,accepting,heartbeat,devane,confront,minus,legitimate,fixing,arrogant,tuna,supper,slightest,sins,sayin,recipe,pier,paternity,humiliating,genuine,snack,rational,minded,guessed,weddings,tumor,humiliated,aspirin,spray,picks,eyed,drowning,contacts,ritual,perfume,hiring,hating,docks,creatures,visions,thanking,thankful,sock,nineteen,fork,throws,teenagers,stressed,slice,rolls,plead,ladder,kicks,detectives,assured,tellin,shallow,responsibilities,repay,howdy,girlfriends,deadly,comforting,ceiling,verdict,insensitive,spilled,respected,messy,interrupted,halliwell,blond,bleed,wardrobe,takin,murders,backs,underestimate,justify,harmless,frustrated,fold,enzo,communicate,bugging,arson,whack,salary,rumors,obligation,liking,dearest,congratulate,vengeance,rack,puzzle,fires,courtesy,caller,blamed,tops,quiz,prep,curiosity,circles,barbecue,sunnydale,spinning,psychotic,cough,accusations,resent,laughs,freshman,envy,drown,bartlet,asses,sofa,poster,highness,dock,apologies,theirs,stat,stall,realizes,psych,mmmm,fools,understandable,treats,succeed,stir,relaxed,makin,gratitude,faithful,accent,witter,wandering,locate,inevitable,gretel,deed,crushed,controlling,smelled,robe,gossip,gambling,cosmetics,accidents,surprising,stiff,sincere,rushed,refrigerator,preparing,nightmares,mijo,ignoring,hunch,fireworks,drowned,brass,whispering,sophisticated,luggage,hike,explore,emotion,crashing,contacted,complications,shining,rolled,righteous,reconsider,goody,geek,frightening,ethics,creeps,courthouse,camping,affection,smythe,haircut,essay,baked,apologized,vibe,respects,receipt,mami,hats,destructive,adore,adopt,tracked,shorts,reminding,dough,creations,cabot,barrel,snuck,slight,reporters,pressing,magnificent,madame,lazy,glorious,fiancee,bits,visitation,sane,kindness,shoulda,rescued,mattress,lounge,lifted,importantly,glove,enterprises,disappointment,condo,beings,admitting,yelled,waving,spoon,screech,satisfaction,reads,nailed,worm,tick,resting,marvelous,fuss,cortlandt,chased,pockets,luckily,lilith,filing,conversations,consideration,consciousness,worlds,innocence,forehead,aggressive,trailer,slam,quitting,inform,delighted,daylight,danced,confidential,aunts,washing,tossed,spectra,marrow,lined,implying,hatred,grill,corpse,clues,sober,offended,morgue,infected,humanity,distraction,cart,wired,violation,promising,harassment,glue,d'angelo,cursed,brutal,warlocks,wagon,unpleasant,proving,priorities,mustn't,lease,flame,disappearance,depressing,thrill,sitter,ribs,flush,earrings,deadline,corporal,collapsed,update,snapped,smack,melt,figuring,delusional,coulda,burnt,tender,sperm,realise,pork,popped,interrogation,esteem,choosing,undo,pres,prayed,plague,manipulate,insulting,detention,delightful,coffeehouse,betrayal,apologizing,adjust,wrecked,wont,whipped,rides,reminder,monsieur,faint,bake,distress,correctly,complaint,blocked,tortured,risking,pointless,handing,dumping,cups,alibi,struggling,shiny,risked,mummy,mint,hose,hobby,fortunate,fleischman,fitting,curtain,counseling,rode,puppet,modeling,memo,irresponsible,humiliation,hiya,freakin,felony,choke,blackmailing,appreciated,tabloid,suspicion,recovering,pledge,panicked,nursery,louder,jeans,investigator,homecoming,frustrating,buys,busting,buff,sleeve,irony,dope,declare,autopsy,workin,torch,prick,limb,hysterical,goddamnit,fetch,dimension,crowded,clip,climbing,bonding,woah,trusts,negotiate,lethal,iced,fantasies,deeds,bore,babysitter,questioned,outrageous,kiriakis,insulted,grudge,driveway,deserted,definite,beep,wires,suggestions,searched,owed,lend,drunken,demanding,costanza,conviction,bumped,weigh,touches,tempted,shout,resolve,relate,poisoned,meals,invitations,haunted,bogus,autograph,affects,tolerate,stepping,spontaneous,sleeps,probation,manny,fist,spectacular,hostages,heroin,havin,habits,encouraging,consult,burgers,boyfriends,bailed,baggage,watches,troubled,torturing,teasing,sweetest,qualities,postpone,overwhelmed,malkovich,impulse,classy,charging,amazed,policeman,hypocrite,humiliate,hideous,d'ya,costumes,bluffing,betting,bein,bedtime,alcoholic,vegetable,tray,suspicions,spreading,splendid,shrimp,shouting,pressed,nooo,grieving,gladly,fling,eliminate,cereal,aaah,sonofabitch,paralyzed,lotta,locks,guaranteed,dummy,despise,dental,briefing,bluff,batteries,whatta,sounding,servants,presume,handwriting,fainted,dried,allright,acknowledge,whacked,toxic,reliable,quicker,overwhelming,lining,harassing,fatal,endless,dolls,convict,whatcha,unlikely,shutting,positively,overcome,goddam,essence,dose,diagnosis,cured,bully,ahold,yearbook,tempting,shelf,prosecution,pouring,possessed,greedy,wonders,thorough,spine,rath,psychiatric,meaningless,latte,jammed,ignored,fiance,evidently,contempt,compromised,cans,weekends,urge,theft,suing,shipment,scissors,responding,proposition,noises,matching,hormones,hail,grandchildren,gently,smashed,sexually,sentimental,nicest,manipulated,intern,handcuffs,framed,errands,entertaining,crib,carriage,barge,spends,slipping,seated,rubbing,rely,reject,recommendation,reckon,headaches,float,embrace,corners,whining,sweating,skipped,mountie,motives,listens,cristobel,cleaner,cheerleader,balsom,unnecessary,stunning,scent,quartermaines,pose,montega,loosen,info,hottest,haunt,gracious,forgiving,errand,cakes,blames,abortion,sketch,shifts,plotting,perimeter,pals,mere,mattered,lonigan,interference,eyewitness,enthusiasm,diapers,strongest,shaken,punched,portal,catches,backyard,terrorists,sabotage,organs,needy,cuff,civilization,woof,who'll,prank,obnoxious,mates,hereby,gabby,faked,cellar,whitelighter,void,strangle,sour,muffins,interfering,demonic,clearing,boutique,barrington,terrace,smoked,righty,quack,petey,pact,knot,ketchup,disappearing,cordy,uptight,ticking,terrifying,tease,swamp,secretly,rejection,reflection,realizing,rays,mentally,marone,doubted,deception,congressman,cheesy,toto,stalling,scoop,ribbon,immune,expects,destined,bets,bathing,appreciation,accomplice,wander,shoved,sewer,scroll,retire,lasts,fugitive,freezer,discount,cranky,crank,clearance,bodyguard,anxiety,accountant,whoops,volunteered,talents,stinking,remotely,garlic,decency,cord,beds,altogether,uniforms,tremendous,popping,outa,observe,lung,hangs,feelin,dudes,donation,disguise,curb,bites,antique,toothbrush,realistic,predict,landlord,hourglass,hesitate,consolation,babbling,tipped,stranded,smartest,repeating,puke,psst,paycheck,overreacted,macho,juvenile,grocery,freshen,disposal,cuffs,caffeine,vanished,unfinished,ripping,pinch,flattering,expenses,dinners,colleague,ciao,belthazor,attorneys,woulda,whereabouts,waitin,truce,tripped,tasted,steer,poisoning,manipulative,immature,husbands,heel,granddad,delivering,condoms,addict,trashed,raining,pasta,needles,leaning,detector,coolest,batch,appointments,almighty,vegetables,spark,perfection,pains,momma,mole,meow,hairs,getaway,cracking,compliments,behold,verge,tougher,timer,tapped,taped,specialty,snooping,shoots,rendezvous,pentagon,leverage,jeopardize,janitor,grandparents,forbidden,clueless,bidding,ungrateful,unacceptable,tutor,serum,scuse,pajamas,mouths,lure,irrational,doom,cries,beautifully,arresting,approaching,traitor,sympathetic,smug,smash,rental,prostitute,premonitions,jumps,inventory,darlin,committing,banging,asap,worms,violated,vent,traumatic,traced,sweaty,shaft,overboard,insight,healed,grasp,experiencing,crappy,crab,chunk,awww,stain,shack,reacted,pronounce,poured,moms,marriages,jabez,handful,flipped,fireplace,embarrassment,disappears,concussion,bruises,brakes,twisting,swept,summon,splitting,sloppy,settling,reschedule,notch,hooray,grabbing,exquisite,disrespect,thornhart,straw,slapped,shipped,shattered,ruthless,refill,payroll,numb,mourning,manly,hunk,entertain,drift,dreadful,doorstep,confirmation,chops,appreciates,vague,tires,stressful,stashed,stash,sensed,preoccupied,predictable,noticing,madly,gunshot,dozens,dork,confuse,cleaners,charade,chalk,cappuccino,bouquet,amulet,addiction,who've,warming,unlock,satisfy,sacrificed,relaxing,lone,blocking,blend,blankets,addicted,yuck,hunger,hamburger,greeting,greet,gravy,gram,dreamt,dice,caution,backpack,agreeing,whale,taller,supervisor,sacrifices,phew,ounce,irrelevant,gran,felon,favorites,farther,fade,erased,easiest,convenience,compassionate,cane,backstage,agony,adores,veins,tweek,thieves,surgical,strangely,stetson,recital,proposing,productive,meaningful,immunity,hassle,goddamned,frighten,dearly,cease,ambition,wage,unstable,salvage,richer,refusing,raging,pumping,pressuring,mortals,lowlife,intimidated,intentionally,inspire,forgave,devotion,despicable,deciding,dash,comfy,breach,bark,aaaah,switching,swallowed,stove,screamed,scars,russians,pounding,poof,pipes,pawn,legit,invest,farewell,curtains,civilized,caviar,boost,token,superstition,supernatural,sadness,recorder,psyched,motivated,microwave,hallelujah,fraternity,dryer,cocoa,chewing,acceptable,unbelievably,smiled,smelling,simpler,respectable,remarks,khasinau,indication,gutter,grabs,fulfill,flashlight,ellenor,blooded,blink,blessings,beware,uhhh,turf,swings,slips,shovel,shocking,puff,mirrors,locking,heartless,fras,childish,cardiac,utterly,tuscany,ticked,stunned,statesville,sadly,purely,kiddin,jerks,hitch,flirt,fare,equals,dismiss,christening,casket,c'mere,breakup,biting,antibiotics,accusation,abducted,witchcraft,thread,runnin,punching,paramedics,newest,murdering,masks,lawndale,initials,grampa,choking,charms,careless,bushes,buns,bummed,shred,saves,saddle,rethink,regards,precinct,persuade,meds,manipulating,llanfair,leash,hearted,guarantees,fucks,disgrace,deposition,bookstore,boil,vitals,veil,trespassing,sidewalk,sensible,punishing,overtime,optimistic,obsessing,notify,mornin,jeopardy,jaffa,injection,hilarious,desires,confide,cautious,yada,where're,vindictive,vial,teeny,stroll,sittin,scrub,rebuild,posters,ordeal,nuns,intimacy,inheritance,exploded,donate,distracting,despair,crackers,wildwind,virtue,thoroughly,tails,spicy,sketches,sights,sheer,shaving,seize,scarecrow,refreshing,prosecute,platter,napkin,misplaced,merchandise,loony,jinx,heroic,frankenstein,ambitious,syrup,solitary,resemblance,reacting,premature,lavery,flashes,cheque,awright,acquainted,wrapping,untie,salute,realised,priceless,partying,lightly,lifting,kasnoff,insisting,glowing,generator,explosives,cutie,confronted,buts,blouse,ballistic,antidote,analyze,allowance,adjourned,unto,understatement,tucked,touchy,subconscious,screws,sarge,roommates,rambaldi,offend,nerd,knives,irresistible,incapable,hostility,goddammit,fuse,frat,curfew,blackmailed,walkin,starve,sleigh,sarcastic,recess,rebound,pinned,parlor,outfits,livin,heartache,haired,fundraiser,doorman,discreet,dilucca,cracks,considerate,climbed,catering,apophis,zoey,urine,strung,stitches,sordid,sark,protector,phoned,pets,hostess,flaw,flavor,deveraux,consumed,confidentiality,bourbon,straightened,specials,spaghetti,prettier,powerless,playin,playground,paranoia,instantly,havoc,exaggerating,eavesdropping,doughnuts,diversion,deepest,cutest,comb,bela,behaving,anyplace,accessory,workout,translate,stuffing,speeding,slime,royalty,polls,marital,lurking,lottery,imaginary,greetings,fairwinds,elegant,elbow,credibility,credentials,claws,chopped,bridal,bedside,babysitting,witty,unforgivable,underworld,tempt,tabs,sophomore,selfless,secrecy,restless,okey,movin,metaphor,messes,meltdown,lecter,incoming,gasoline,diefenbaker,buckle,admired,adjustment,warmth,throats,seduced,queer,parenting,noses,luckiest,graveyard,gifted,footsteps,dimeras,cynical,wedded,verbal,unpredictable,tuned,stoop,slides,sinking,rigged,plumbing,lingerie,hankey,greed,everwood,elope,dresser,chauffeur,bulletin,bugged,bouncing,temptation,strangest,slammed,sarcasm,pending,packages,orderly,obsessive,murderers,meteor,inconvenience,glimpse,froze,execute,courageous,consulate,closes,bosses,bees,amends,wuss,wolfram,wacky,unemployed,testifying,syringe,stew,startled,sorrow,sleazy,shaky,screams,rsquo,remark,poke,nutty,mentioning,mend,inspiring,impulsive,housekeeper,foam,fingernails,conditioning,baking,whine,thug,starved,sniffing,sedative,programmed,picket,paged,hound,homosexual,homo,hips,forgets,flipping,flea,flatter,dwell,dumpster,choo,assignments,ants,vile,unreasonable,tossing,thanked,steals,souvenir,scratched,psychopath,outs,obstruction,obey,lump,insists,harass,gloat,filth,edgy,didn,coroner,confessing,bruise,betraying,bailing,appealing,adebisi,wrath,wandered,waist,vain,traps,stepfather,poking,obligated,heavenly,dilemma,crazed,contagious,coaster,cheering,bundle,vomit,thingy,speeches,robbing,raft,pumped,pillows,peep,packs,neglected,m'kay,loneliness,intrude,helluva,gardener,forresters,drooling,betcha,vase,supermarket,squat,spitting,rhyme,relieve,receipts,racket,pictured,pause,overdue,motivation,morgendorffer,kidnapper,insect,horns,feminine,eyeballs,dumps,disappointing,crock,convertible,claw,clamp,canned,cambias,bathtub,avanya,artery,weep,warmer,suspense,summoned,spiders,reiber,raving,pushy,postponed,ohhhh,noooo,mold,laughter,incompetent,hugging,groceries,drip,communicating,auntie,adios,wraps,wiser,willingly,weirdest,timmih,thinner,swelling,swat,steroids,sensitivity,scrape,rehearse,prophecy,ledge,justified,insults,hateful,handles,doorway,chatting,buyer,buckaroo,bedrooms,askin,ammo,tutoring,subpoena,scratching,privileges,pager,mart,intriguing,idiotic,grape,enlighten,corrupt,brunch,bridesmaid,barking,applause,acquaintance,wretched,superficial,soak,smoothly,sensing,restraint,posing,pleading,payoff,oprah,nemo,morals,loaf,jumpy,ignorant,herbal,hangin,germs,generosity,flashing,doughnut,clumsy,chocolates,captive,behaved,apologise,vanity,stumbled,preview,poisonous,perjury,parental,onboard,mugged,minding,linen,knots,interviewing,humour,grind,greasy,goons,drastic,coop,comparing,cocky,clearer,bruised,brag,bind,worthwhile,whoop,vanquishing,tabloids,sprung,spotlight,sentencing,racist,provoke,pining,overly,locket,imply,impatient,hovering,hotter,fest,endure,dots,doren,debts,crawled,chained,brit,breaths,weirdo,warmed,wand,troubling,tok'ra,strapped,soaked,skipping,scrambled,rattle,profound,musta,mocking,misunderstand,limousine,kacl,hustle,forensic,enthusiastic,duct,drawers,devastating,conquer,clarify,chores,cheerleaders,cheaper,callin,blushing,barging,abused,yoga,wrecking,wits,waffles,virginity,vibes,uninvited,unfaithful,teller,strangled,scheming,ropes,rescuing,rave,postcard,o'reily,morphine,lotion,lads,kidneys,judgement,itch,indefinitely,grenade,glamorous,genetically,freud,discretion,delusions,crate,competent,bakery,argh,ahhhh,wedge,wager,unfit,tripping,torment,superhero,stirring,spinal,sorority,seminar,scenery,rabble,pneumonia,perks,override,ooooh,mija,manslaughter,mailed,lime,lettuce,intimidate,guarded,grieve,grad,frustration,doorbell,chinatown,authentic,arraignment,annulled,allergies,wanta,verify,vegetarian,tighter,telegram,stalk,spared,shoo,satisfying,saddam,requesting,pens,overprotective,obstacles,notified,nasedo,grandchild,genuinely,flushed,fluids,floss,escaping,ditched,cramp,corny,bunk,bitten,billions,bankrupt,yikes,wrists,ultrasound,ultimatum,thirst,sniff,shakes,salsa,retrieve,reassuring,pumps,neurotic,negotiating,needn't,monitors,millionaire,lydecker,limp,incriminating,hatchet,gracias,gordie,fills,feeds,doubting,decaf,biopsy,whiz,voluntarily,ventilator,unpack,unload,toad,spooked,snitch,schillinger,reassure,persuasive,mystical,mysteries,matrimony,mails,jock,headline,explanations,dispatch,curly,cupid,condolences,comrade,cassadines,bulb,bragging,awaits,assaulted,ambush,adolescent,abort,yank,whit,vaguely,undermine,tying,swamped,stabbing,slippers,slash,sincerely,sigh,setback,secondly,rotting,precaution,pcpd,melting,liaison,hots,hooking,headlines,haha,ganz,fury,felicity,fangs,encouragement,earring,dreidel,dory,donut,dictate,decorating,cocktails,bumps,blueberry,believable,backfired,backfire,apron,adjusting,vous,vouch,vitamins,ummm,tattoos,slimy,sibling,shhhh,renting,peculiar,parasite,paddington,marries,mailbox,magically,lovebirds,knocks,informant,exits,drazen,distractions,disconnected,dinosaurs,dashwood,crooked,conveniently,wink,warped,underestimated,tacky,shoving,seizure,reset,pushes,opener,mornings,mash,invent,indulge,horribly,hallucinating,festive,eyebrows,enjoys,desperation,dealers,darkest,daph,boragora,belts,bagel,authorization,auditions,agitated,wishful,wimp,vanish,unbearable,tonic,suffice,suction,slaying,safest,rocking,relive,puttin,prettiest,noisy,newlyweds,nauseous,misguided,mildly,midst,liable,judgmental,indy,hunted,givin,fascinated,elephants,dislike,deluded,decorate,crummy,contractions,carve,bottled,bonded,bahamas,unavailable,twenties,trustworthy,surgeons,stupidity,skies,remorse,preferably,pies,nausea,napkins,mule,mourn,melted,mashed,inherit,greatness,golly,excused,dumbo,drifting,delirious,damaging,cubicle,compelled,comm,chooses,checkup,boredom,bandages,alarms,windshield,who're,whaddya,transparent,surprisingly,sunglasses,slit,roar,reade,prognosis,probe,pitiful,persistent,peas,nosy,nagging,morons,masterpiece,martinis,limbo,liars,irritating,inclined,hump,hoynes,fiasco,eatin,cubans,concentrating,colorful,clam,cider,brochure,barto,bargaining,wiggle,welcoming,weighing,vanquished,stains,sooo,snacks,smear,sire,resentment,psychologist,pint,overhear,morality,landingham,kisser,hoot,holling,handshake,grilled,formality,elevators,depths,confirms,boathouse,accidental,westbridge,wacko,ulterior,thugs,thighs,tangled,stirred,snag,sling,sleaze,rumour,ripe,remarried,puddle,pins,perceptive,miraculous,longing,lockup,librarian,impressions,immoral,hypothetically,guarding,gourmet,gabe,faxed,extortion,downright,digest,cranberry,bygones,buzzing,burying,bikes,weary,taping,takeout,sweeping,stepmother,stale,senor,seaborn,pros,pepperoni,newborn,ludicrous,injected,geeks,forged,faults,drue,dire,dief,desi,deceiving,caterer,calmed,budge,ankles,vending,typing,tribbiani,there're,squared,snowing,shades,sexist,rewrite,regretted,raises,picky,orphan,mural,misjudged,miscarriage,memorize,leaking,jitters,invade,interruption,illegally,handicapped,glitch,gittes,finer,distraught,dispose,dishonest,digs,dads,cruelty,circling,canceling,butterflies,belongings,barbrady,amusement,alias,zombies,where've,unborn,swearing,stables,squeezed,sensational,resisting,radioactive,questionable,privileged,portofino,owning,overlook,orson,oddly,interrogate,imperative,impeccable,hurtful,hors,heap,graders,glance,disgust,devious,destruct,crazier,countdown,chump,cheeseburger,burglar,berries,ballroom,assumptions,annoyed,allergy,admirer,admirable,activate,underpants,twit,tack,strokes,stool,sham,scrap,retarded,resourceful,remarkably,refresh,pressured,precautions,pointy,nightclub,mustache,maui,lace,hunh,hubby,flare,dont,dokey,dangerously,crushing,clinging,choked,chem,cheerleading,checkbook,cashmere,calmly,blush,believer,amazingly,alas,what've,toilets,tacos,stairwell,spirited,sewing,rubbed,punches,protects,nuisance,motherfuckers,mingle,kynaston,knack,kinkle,impose,gullible,godmother,funniest,friggin,folding,fashions,eater,dysfunctional,drool,dripping,ditto,cruising,criticize,conceive,clone,cedars,caliber,brighter,blinded,birthdays,banquet,anticipate,annoy,whim,whichever,volatile,veto,vested,shroud,rests,reindeer,quarantine,pleases,painless,orphans,orphanage,offence,obliged,negotiation,narcotics,mistletoe,meddling,manifest,lookit,lilah,intrigued,injustice,homicidal,gigantic,exposing,elves,disturbance,disastrous,depended,demented,correction,cooped,cheerful,buyers,brownies,beverage,basics,arvin,weighs,upsets,unethical,swollen,sweaters,stupidest,sensation,scalpel,props,prescribed,pompous,objections,mushrooms,mulwray,manipulation,lured,internship,insignificant,inmate,incentive,fulfilled,disagreement,crypt,cornered,copied,brightest,beethoven,attendant,amaze,yogurt,wyndemere,vocabulary,tulsa,tactic,stuffy,respirator,pretends,polygraph,pennies,ordinarily,olives,necks,morally,martyr,leftovers,joints,hopping,homey,hints,heartbroken,forge,florist,firsthand,fiend,dandy,crippled,corrected,conniving,conditioner,clears,chemo,bubbly,bladder,beeper,baptism,wiring,wench,weaknesses,volunteering,violating,unlocked,tummy,surrogate,subid,stray,startle,specifics,slowing,scoot,robbers,rightful,richest,qfxmjrie,puffs,pierced,pencils,paralysis,makeover,luncheon,linksynergy,jerky,jacuzzi,hitched,hangover,fracture,flock,firemen,disgusted,darned,clams,borrowing,banged,wildest,weirder,unauthorized,stunts,sleeves,sixties,shush,shalt,retro,quits,pegged,painfully,paging,omelet,memorized,lawfully,jackets,intercept,ingredient,grownup,glued,fulfilling,enchanted,delusion,daring,compelling,carton,bridesmaids,bribed,boiling,bathrooms,bandage,awaiting,assign,arrogance,antiques,ainsley,turkeys,trashing,stockings,stalked,stabilized,skates,sedated,robes,respecting,psyche,presumptuous,prejudice,paragraph,mocha,mints,mating,mantan,lorne,loads,listener,itinerary,hepatitis,heave,guesses,fading,examining,dumbest,dishwasher,deceive,cunning,cripple,convictions,confided,compulsive,compromising,burglary,bumpy,brainwashed,benes,arnie,affirmative,adrenaline,adamant,watchin,waitresses,transgenic,toughest,tainted,surround,stormed,spree,spilling,spectacle,soaking,shreds,sewers,severed,scarce,scamming,scalp,rewind,rehearsing,pretentious,potions,overrated,obstacle,nerds,meems,mcmurphy,maternity,maneuver,loathe,fertility,eloping,ecstatic,ecstasy,divorcing,dignan,costing,clubhouse,clocks,candid,bursting,breather,braces,bending,arsonist,adored,absorb,valiant,uphold,unarmed,topolsky,thrilling,thigh,terminate,sustain,spaceship,snore,sneeze,smuggling,salty,quaint,patronize,patio,morbid,mamma,kettle,joyous,invincible,interpret,insecurities,impulses,illusions,holed,exploit,drivin,defenseless,dedicate,cradle,coupon,countless,conjure,cardboard,booking,backseat,accomplishment,wordsworth,wisely,valet,vaccine,urges,unnatural,unlucky,truths,traumatized,tasting,swears,strawberries,steaks,stats,skank,seducing,secretive,scumbag,screwdriver,schedules,rooting,rightfully,rattled,qualifies,puppets,prospects,pronto,posse,polling,pedestal,palms,muddy,morty,microscope,merci,lecturing,inject,incriminate,hygiene,grapefruit,gazebo,funnier,cuter,bossy,booby,aides,zende,winthrop,warrants,valentines,undressed,underage,truthfully,tampered,suffers,speechless,sparkling,sidelines,shrek,railing,puberty,pesky,outrage,outdoors,motions,moods,lunches,litter,kidnappers,itching,intuition,imitation,humility,hassling,gallons,drugstore,dosage,disrupt,dipping,deranged,debating,cuckoo,cremated,craziness,cooperating,circumstantial,chimney,blinking,biscuits,admiring,weeping,triad,trashy,soothing,slumber,slayers,skirts,siren,shindig,sentiment,rosco,riddance,quaid,purity,proceeding,pretzels,panicking,mckechnie,lovin,leaked,intruding,impersonating,ignorance,hamburgers,footprints,fluke,fleas,festivities,fences,feisty,evacuate,emergencies,deceived,creeping,craziest,corpses,conned,coincidences,bounced,bodyguards,blasted,bitterness,baloney,ashtray,apocalypse,zillion,watergate,wallpaper,telesave,sympathize,sweeter,startin,spades,sodas,snowed,sleepover,signor,seein,retainer,restroom,rested,repercussions,reliving,reconcile,prevail,preaching,overreact,o'neil,noose,moustache,manicure,maids,landlady,hypothetical,hopped,homesick,hives,hesitation,herbs,hectic,heartbreak,haunting,gangs,frown,fingerprint,exhausting,everytime,disregard,cling,chevron,chaperone,blinding,bitty,beads,battling,badgering,anticipation,upstanding,unprofessional,unhealthy,turmoil,truthful,toothpaste,tippin,thoughtless,tagataya,shooters,senseless,rewarding,propane,preposterous,pigeons,pastry,overhearing,obscene,negotiable,loner,jogging,itchy,insinuating,insides,hospitality,hormone,hearst,forthcoming,fists,fifties,etiquette,endings,destroys,despises,deprived,cuddy,crust,cloak,circumstance,chewed,casserole,bidder,bearer,artoo,applaud,appalling,vowed,virgins,vigilante,undone,throttle,testosterone,tailor,symptom,swoop,suitcases,stomp,sticker,stakeout,spoiling,snatched,smoochy,smitten,shameless,restraints,researching,renew,refund,reclaim,raoul,puzzles,purposely,punks,prosecuted,plaid,picturing,pickin,parasites,mysteriously,multiply,mascara,jukebox,interruptions,gunfire,furnace,elbows,duplicate,drapes,deliberate,decoy,cryptic,coupla,condemn,complicate,colossal,clerks,clarity,brushed,banished,argon,alarmed,worships,versa,uncanny,technicality,sundae,stumble,stripping,shuts,schmuck,satin,saliva,robber,relentless,reconnect,recipes,rearrange,rainy,psychiatrists,policemen,plunge,plugged,patched,overload,o'malley,mindless,menus,lullaby,lotte,leavin,killin,karinsky,invalid,hides,grownups,griff,flaws,flashy,flaming,fettes,evicted,dread,degrassi,dealings,dangers,cushion,bowel,barged,abide,abandoning,wonderfully,wait'll,violate,suicidal,stayin,sorted,slamming,sketchy,shoplifting,raiser,quizmaster,prefers,needless,motherhood,momentarily,migraine,lifts,leukemia,leftover,keepin,hinks,hellhole,gowns,goodies,gallon,futures,entertained,eighties,conspiring,cheery,benign,apiece,adjustments,abusive,abduction,wiping,whipping,welles,unspeakable,unidentified,trivial,transcripts,textbook,supervise,superstitious,stricken,stimulating,spielberg,slices,shelves,scratches,sabotaged,retrieval,repressed,rejecting,quickie,ponies,peeking,outraged,o'connell,moping,moaning,mausoleum,licked,kovich,klutz,interrogating,interfered,insulin,infested,incompetence,hyper,horrified,handedly,gekko,fraid,fractured,examiner,eloped,disoriented,dashing,crashdown,courier,cockroach,chipped,brushing,bombed,bolts,baths,baptized,astronaut,assurance,anemia,abuela,abiding,withholding,weave,wearin,weaker,suffocating,straws,straightforward,stench,steamed,starboard,sideways,shrinks,shortcut,scram,roasted,roaming,riviera,respectfully,repulsive,psychiatry,provoked,penitentiary,painkillers,ninotchka,mitzvah,milligrams,midge,marshmallows,looky,lapse,kubelik,intellect,improvise,implant,goa'ulds,giddy,geniuses,fruitcake,footing,fightin,drinkin,doork,detour,cuddle,crashes,combo,colonnade,cheats,cetera,bailiff,auditioning,assed,amused,alienate,aiding,aching,unwanted,topless,tongues,tiniest,superiors,soften,sheldrake,rawley,raisins,presses,plaster,nessa,narrowed,minions,merciful,lawsuits,intimidating,infirmary,inconvenient,imposter,hugged,honoring,holdin,hades,godforsaken,fumes,forgery,foolproof,folder,flattery,fingertips,exterminator,explodes,eccentric,dodging,disguised,crave,constructive,concealed,compartment,chute,chinpokomon,bodily,astronauts,alimony,accustomed,abdominal,wrinkle,wallow,valium,untrue,uncover,trembling,treasures,torched,toenails,timed,termites,telly,taunting,taransky,talker,succubus,smarts,sliding,sighting,semen,seizures,scarred,savvy,sauna,saddest,sacrificing,rubbish,riled,ratted,rationally,provenance,phonse,perky,pedal,overdose,nasal,nanites,mushy,movers,missus,midterm,merits,melodramatic,manure,knitting,invading,interpol,incapacitated,hotline,hauling,gunpoint,grail,ganza,framing,flannel,faded,eavesdrop,desserts,calories,breathtaking,bleak,blacked,batter,aggravated,yanked,wigand,whoah,unwind,undoubtedly,unattractive,twitch,trimester,torrance,timetable,taxpayers,strained,stared,slapping,sincerity,siding,shenanigans,shacking,sappy,samaritan,poorer,politely,paste,oysters,overruled,nightcap,mosquito,millimeter,merrier,manhood,lucked,kilos,ignition,hauled,harmed,goodwill,freshmen,fenmore,fasten,farce,exploding,erratic,drunks,ditching,d'artagnan,cramped,contacting,closets,clientele,chimp,bargained,arranging,anesthesia,amuse,altering,afternoons,accountable,abetting,wolek,waved,uneasy,toddy,tattooed,spauldings,sliced,sirens,schibetta,scatter,rinse,remedy,redemption,pleasures,optimism,oblige,mmmmm,masked,malicious,mailing,kosher,kiddies,judas,isolate,insecurity,incidentally,heals,headlights,growl,grilling,glazed,flunk,floats,fiery,fairness,exercising,excellency,disclosure,cupboard,counterfeit,condescending,conclusive,clicked,cleans,cholesterol,cashed,broccoli,brats,blueprints,blindfold,billing,attach,appalled,alrighty,wynant,unsolved,unreliable,toots,tighten,sweatshirt,steinbrenner,steamy,spouse,sonogram,slots,sleepless,shines,retaliate,rephrase,redeem,rambling,quilt,quarrel,prying,proverbial,priced,prescribe,prepped,pranks,possessive,plaintiff,pediatrics,overlooked,outcast,nightgown,mumbo,mediocre,mademoiselle,lunchtime,lifesaver,leaned,lambs,interns,hounding,hellmouth,hahaha,goner,ghoul,gardening,frenzy,foyer,extras,exaggerate,everlasting,enlightened,dialed,devote,deceitful,d'oeuvres,cosmetic,contaminated,conspired,conning,cavern,carving,butting,boiled,blurry,babysit,ascension,aaaaah,wildly,whoopee,whiny,weiskopf,walkie,vultures,vacations,upfront,unresolved,tampering,stockholders,snaps,sleepwalking,shrunk,sermon,seduction,scams,revolve,phenomenal,patrolling,paranormal,ounces,omigod,nightfall,lashing,innocents,infierno,incision,humming,haunts,gloss,gloating,frannie,fetal,feeny,entrapment,discomfort,detonator,dependable,concede,complication,commotion,commence,chulak,caucasian,casually,brainer,bolie,ballpark,anwar,analyzing,accommodations,youse,wring,wallowing,transgenics,thrive,tedious,stylish,strippers,sterile,squeezing,squeaky,sprained,solemn,snoring,shattering,shabby,seams,scrawny,revoked,residue,reeks,recite,ranting,quoting,predicament,plugs,pinpoint,petrified,pathological,passports,oughtta,nighter,navigate,kippie,intrigue,intentional,insufferable,hunky,how've,horrifying,hearty,hamptons,grazie,funerals,forks,fetched,excruciating,enjoyable,endanger,dumber,drying,diabolical,crossword,corry,comprehend,clipped,classmates,candlelight,brutally,brutality,boarded,bathrobe,authorize,assemble,aerobics,wholesome,whiff,vermin,trophies,trait,tragically,toying,testy,tasteful,stocked,spinach,sipping,sidetracked,scrubbing,scraping,sanctity,robberies,ridin,retribution,refrain,realities,radiant,protesting,projector,plutonium,payin,parting,o'reilly,nooooo,motherfucking,measly,manic,lalita,juggling,jerking,intro,inevitably,hypnosis,huddle,horrendous,hobbies,heartfelt,harlin,hairdresser,gonorrhea,fussing,furtwangler,fleeting,flawless,flashed,fetus,eulogy,distinctly,disrespectful,denies,crossbow,cregg,crabs,cowardly,contraction,contingency,confirming,condone,coffins,cleansing,cheesecake,certainty,cages,c'est,briefed,bravest,bosom,boils,binoculars,bachelorette,appetizer,ambushed,alerted,woozy,withhold,vulgar,utmost,unleashed,unholy,unhappiness,unconditional,typewriter,typed,twists,supermodel,subpoenaed,stringing,skeptical,schoolgirl,romantically,rocked,revoir,reopen,puncture,preach,polished,planetarium,penicillin,peacefully,nurturing,more'n,mmhmm,midgets,marklar,lodged,lifeline,jellyfish,infiltrate,hutch,horseback,heist,gents,frickin,freezes,forfeit,flakes,flair,fathered,eternally,epiphany,disgruntled,discouraged,delinquent,decipher,danvers,cubes,credible,coping,chills,cherished,catastrophe,bombshell,birthright,billionaire,ample,affections,admiration,abbotts,whatnot,watering,vinegar,unthinkable,unseen,unprepared,unorthodox,underhanded,uncool,timeless,thump,thermometer,theoretically,tapping,tagged,swung,stares,spiked,solves,smuggle,scarier,saucer,quitter,prudent,powdered,poked,pointers,peril,penetrate,penance,opium,nudge,nostrils,neurological,mockery,mobster,medically,loudly,insights,implicate,hypocritical,humanly,holiness,healthier,hammered,haldeman,gunman,gloom,freshly,francs,flunked,flawed,emptiness,drugging,dozer,derevko,deprive,deodorant,cryin,crocodile,coloring,colder,cognac,clocked,clippings,charades,chanting,certifiable,caterers,brute,brochures,botched,blinders,bitchin,banter,woken,ulcer,tread,thankfully,swine,swimsuit,swans,stressing,steaming,stamped,stabilize,squirm,snooze,shuffle,shredded,seafood,scratchy,savor,sadistic,rhetorical,revlon,realist,prosecuting,prophecies,polyester,petals,persuasion,paddles,o'leary,nuthin,neighbour,negroes,muster,meningitis,matron,lockers,letterman,legged,indictment,hypnotized,housekeeping,hopelessly,hallucinations,grader,goldilocks,girly,flask,envelopes,downside,doves,dissolve,discourage,disapprove,diabetic,deliveries,decorator,crossfire,criminally,containment,comrades,complimentary,chatter,catchy,cashier,cartel,caribou,cardiologist,brawl,booted,barbershop,aryan,angst,administer,zellie,wreak,whistles,vandalism,vamps,uterus,upstate,unstoppable,understudy,tristin,transcript,tranquilizer,toxins,tonsils,stempel,spotting,spectator,spatula,softer,snotty,slinging,showered,sexiest,sensual,sadder,rimbaud,restrain,resilient,remission,reinstate,rehash,recollection,rabies,popsicle,plausible,pediatric,patronizing,ostrich,ortolani,oooooh,omelette,mistrial,marseilles,loophole,laughin,kevvy,irritated,infidelity,hypothermia,horrific,groupie,grinding,graceful,goodspeed,gestures,frantic,extradition,echelon,disks,dawnie,dared,damsel,curled,collateral,collage,chant,calculating,bumping,bribes,boardwalk,blinds,blindly,bleeds,bickering,beasts,backside,avenge,apprehended,anguish,abusing,youthful,yells,yanking,whomever,when'd,vomiting,vengeful,unpacking,unfamiliar,undying,tumble,trolls,treacherous,tipping,tantrum,tanked,summons,straps,stomped,stinkin,stings,staked,squirrels,sprinkles,speculate,sorting,skinned,sicko,sicker,shootin,shatter,seeya,schnapps,s'posed,ronee,respectful,regroup,regretting,reeling,reckoned,ramifications,puddy,projections,preschool,plissken,platonic,permalash,outdone,outburst,mutants,mugging,misfortune,miserably,miraculously,medications,margaritas,manpower,lovemaking,logically,leeches,latrine,kneel,inflict,impostor,hypocrisy,hippies,heterosexual,heightened,hecuba,healer,gunned,grooming,groin,gooey,gloomy,frying,friendships,fredo,firepower,fathom,exhaustion,evils,endeavor,eggnog,dreaded,d'arcy,crotch,coughing,coronary,cookin,consummate,congrats,companionship,caved,caspar,bulletproof,brilliance,breakin,brash,blasting,aloud,airtight,advising,advertise,adultery,aches,wronged,upbeat,trillion,thingies,tending,tarts,surreal,specs,specialize,spade,shrew,shaping,selves,schoolwork,roomie,recuperating,rabid,quart,provocative,proudly,pretenses,prenatal,pharmaceuticals,pacing,overworked,originals,nicotine,murderous,mileage,mayonnaise,massages,losin,interrogated,injunction,impartial,homing,heartbreaker,hacks,glands,giver,fraizh,flips,flaunt,englishman,electrocuted,dusting,ducking,drifted,donating,cylon,crutches,crates,cowards,comfortably,chummy,chitchat,childbirth,businesswoman,brood,blatant,bethy,barring,bagged,awakened,asbestos,airplanes,worshipped,winnings,why're,visualize,unprotected,unleash,trays,thicker,therapists,takeoff,streisand,storeroom,stethoscope,stacked,spiteful,sneaks,snapping,slaughtered,slashed,simplest,silverware,shits,secluded,scruples,scrubs,scraps,ruptured,roaring,receptionist,recap,raditch,radiator,pushover,plastered,pharmacist,perverse,perpetrator,ornament,ointment,nineties,napping,nannies,mousse,moors,momentary,misunderstandings,manipulator,malfunction,laced,kivar,kickin,infuriating,impressionable,holdup,hires,hesitated,headphones,hammering,groundwork,grotesque,graces,gauze,gangsters,frivolous,freeing,fours,forwarding,ferrars,faulty,fantasizing,extracurricular,empathy,divorces,detonate,depraved,demeaning,deadlines,dalai,cursing,cufflink,crows,coupons,comforted,claustrophobic,casinos,camped,busboy,bluth,bennetts,baskets,attacker,aplastic,angrier,affectionate,zapped,wormhole,weaken,unrealistic,unravel,unimportant,unforgettable,twain,suspend,superbowl,stutter,stewardess,stepson,standin,spandex,souvenirs,sociopath,skeletons,shivering,sexier,selfishness,scrapbook,ritalin,ribbons,reunite,remarry,relaxation,rattling,rapist,psychosis,prepping,poses,pleasing,pisses,piling,persecuted,padded,operatives,negotiator,natty,menopause,mennihan,martimmys,loyalties,laynie,lando,justifies,intimately,inexperienced,impotent,immortality,horrors,hooky,hinges,heartbreaking,handcuffed,gypsies,guacamole,grovel,graziella,goggles,gestapo,fussy,ferragamo,feeble,eyesight,explosions,experimenting,enchanting,doubtful,dizziness,dismantle,detectors,deserving,defective,dangling,dancin,crumble,creamed,cramping,conceal,clockwork,chrissakes,chrissake,chopping,cabinets,brooding,bonfire,blurt,bloated,blackmailer,beforehand,bathed,bathe,barcode,banish,badges,babble,await,attentive,aroused,antibodies,animosity,ya'll,wrinkled,wonderland,willed,whisk,waltzing,waitressing,vigilant,upbringing,unselfish,uncles,trendy,trajectory,striped,stamina,stalled,staking,stacks,spoils,snuff,snooty,snide,shrinking,senora,secretaries,scoundrel,saline,salads,rundown,riddles,relapse,recommending,raspberry,plight,pecan,pantry,overslept,ornaments,niner,negligent,negligence,nailing,mucho,mouthed,monstrous,malpractice,lowly,loitering,logged,lingering,lettin,lattes,kamal,juror,jillefsky,jacked,irritate,intrusion,insatiable,infect,impromptu,icing,hmmmm,hefty,gasket,frightens,flapping,firstborn,faucet,estranged,envious,dopey,doesn,disposition,disposable,disappointments,dipped,dignified,deceit,dealership,deadbeat,curses,coven,counselors,concierge,clutches,casbah,callous,cahoots,brotherly,britches,brides,bethie,beige,autographed,attendants,attaboy,astonishing,appreciative,antibiotic,aneurysm,afterlife,affidavit,zoning,whats,whaddaya,vasectomy,unsuspecting,toula,topanga,tonio,toasted,tiring,terrorized,tenderness,tailing,sweats,suffocated,sucky,subconsciously,starvin,sprouts,spineless,sorrows,snowstorm,smirk,slicery,sledding,slander,simmer,signora,sigmund,seventies,sedate,scented,sandals,rollers,retraction,resigning,recuperate,receptive,racketeering,queasy,provoking,priors,prerogative,premed,pinched,pendant,outsiders,orbing,opportunist,olanov,neurologist,nanobot,mommies,molested,misread,mannered,laundromat,intercom,inspect,insanely,infatuation,indulgent,indiscretion,inconsiderate,hurrah,howling,herpes,hasta,harassed,hanukkah,groveling,groosalug,gander,galactica,futile,fridays,flier,fixes,exploiting,exorcism,evasive,endorse,emptied,dreary,dreamy,downloaded,dodged,doctored,disobeyed,disneyland,disable,dehydrated,contemplating,coconuts,cockroaches,clogged,chilling,chaperon,cameraman,bulbs,bucklands,bribing,brava,bracelets,bowels,bluepoint,appetizers,appendix,antics,anointed,analogy,almonds,yammering,winch,weirdness,wangler,vibrations,vendor,unmarked,unannounced,twerp,trespass,travesty,transfusion,trainee,towelie,tiresome,straightening,staggering,sonar,socializing,sinus,sinners,shambles,serene,scraped,scones,scepter,sarris,saberhagen,ridiculously,ridicule,rents,reconciled,radios,publicist,pubes,prune,prude,precrime,postponing,pluck,perish,peppermint,peeled,overdo,nutshell,nostalgic,mulan,mouthing,mistook,meddle,maybourne,martimmy,lobotomy,livelihood,lippman,likeness,kindest,kaffee,jocks,jerked,jeopardizing,jazzed,insured,inquisition,inhale,ingenious,holier,helmets,heirloom,heinous,haste,harmsway,hardship,hanky,gutters,gruesome,groping,goofing,godson,glare,finesse,figuratively,ferrie,endangerment,dreading,dozed,dorky,dmitri,divert,discredit,dialing,cufflinks,crutch,craps,corrupted,cocoon,cleavage,cannery,bystander,brushes,bruising,bribery,brainstorm,bolted,binge,ballistics,astute,arroway,adventurous,adoptive,addicts,addictive,yadda,whitelighters,wematanye,weeds,wedlock,wallets,vulnerability,vroom,vents,upped,unsettling,unharmed,trippin,trifle,tracing,tormenting,thats,syphilis,subtext,stickin,spices,sores,smacked,slumming,sinks,signore,shitting,shameful,shacked,septic,seedy,righteousness,relish,rectify,ravishing,quickest,phoebs,perverted,peeing,pedicure,pastrami,passionately,ozone,outnumbered,oregano,offender,nukes,nosed,nighty,nifty,mounties,motivate,moons,misinterpreted,mercenary,mentality,marsellus,lupus,lumbar,lovesick,lobsters,leaky,laundering,latch,jafar,instinctively,inspires,indoors,incarcerated,hundredth,handkerchief,gynecologist,guittierez,groundhog,grinning,goodbyes,geese,fullest,eyelashes,eyelash,enquirer,endlessly,elusive,disarm,detest,deluding,dangle,cotillion,corsage,conjugal,confessional,cones,commandment,coded,coals,chuckle,christmastime,cheeseburgers,chardonnay,celery,campfire,calming,burritos,brundle,broflovski,brighten,borderline,blinked,bling,beauties,bauers,battered,articulate,alienated,ahhhhh,agamemnon,accountants,y'see,wrongful,wrapper,workaholic,winnebago,whispered,warts,vacate,unworthy,unanswered,tonane,tolerated,throwin,throbbing,thrills,thorns,thereof,there've,tarot,sunscreen,stretcher,stereotype,soggy,sobbing,sizable,sightings,shucks,shrapnel,sever,senile,seaboard,scorned,saver,rebellious,rained,putty,prenup,pores,pinching,pertinent,peeping,paints,ovulating,opposites,occult,nutcracker,nutcase,newsstand,newfound,mocked,midterms,marshmallow,marbury,maclaren,leans,krudski,knowingly,keycard,junkies,juilliard,jolinar,irritable,invaluable,inuit,intoxicating,instruct,insolent,inexcusable,incubator,illustrious,hunsecker,houseguest,homosexuals,homeroom,hernia,harming,handgun,hallways,hallucination,gunshots,groupies,groggy,goiter,gingerbread,giggling,frigging,fledged,fedex,fairies,exchanging,exaggeration,esteemed,enlist,drags,dispense,disloyal,disconnect,desks,dentists,delacroix,degenerate,daydreaming,cushions,cuddly,corroborate,complexion,compensated,cobbler,closeness,chilled,checkmate,channing,carousel,calms,bylaws,benefactor,ballgame,baiting,backstabbing,artifact,airspace,adversary,actin,accuses,accelerant,abundantly,abstinence,zissou,zandt,yapping,witchy,willows,whadaya,vilandra,veiled,undress,undivided,underestimating,ultimatums,twirl,truckload,tremble,toasting,tingling,tents,tempered,sulking,stunk,sponges,spills,softly,snipers,scourge,rooftop,riana,revolting,revisit,refreshments,redecorating,recapture,raysy,pretense,prejudiced,precogs,pouting,poofs,pimple,piles,pediatrician,padre,packets,paces,orvelle,oblivious,objectivity,nighttime,nervosa,mexicans,meurice,melts,matchmaker,maeby,lugosi,lipnik,leprechaun,kissy,kafka,introductions,intestines,inspirational,insightful,inseparable,injections,inadvertently,hussy,huckabees,hittin,hemorrhaging,headin,haystack,hallowed,grudges,granilith,grandkids,grading,gracefully,godsend,gobbles,fragrance,fliers,finchley,farts,eyewitnesses,expendable,existential,dorms,delaying,degrading,deduction,darlings,danes,cylons,counsellor,contraire,consciously,conjuring,congratulating,cokes,buffay,brooch,bitching,bistro,bijou,bewitched,benevolent,bends,bearings,barren,aptitude,amish,amazes,abomination,worldly,whispers,whadda,wayward,wailing,vanishing,upscale,untouchable,unspoken,uncontrollable,unavoidable,unattended,trite,transvestite,toupee,timid,timers,terrorizing,swana,stumped,strolling,storybook,storming,stomachs,stoked,stationery,springtime,spontaneity,spits,spins,soaps,sentiments,scramble,scone,rooftops,retract,reflexes,rawdon,ragged,quirky,quantico,psychologically,prodigal,pounce,potty,pleasantries,pints,petting,perceive,onstage,notwithstanding,nibble,newmans,neutralize,mutilated,millionaires,mayflower,masquerade,mangy,macreedy,lunatics,lovable,locating,limping,lasagna,kwang,keepers,juvie,jaded,ironing,intuitive,intensely,insure,incantation,hysteria,hypnotize,humping,happenin,griet,grasping,glorified,ganging,g'night,focker,flunking,flimsy,flaunting,fixated,fitzwallace,fainting,eyebrow,exonerated,ether,electrician,egotistical,earthly,dusted,dignify,detonation,debrief,dazzling,dan'l,damnedest,daisies,crushes,crucify,contraband,confronting,collapsing,cocked,clicks,cliche,circled,chandelier,carburetor,callers,broads,breathes,bloodshed,blindsided,blabbing,bialystock,bashing,ballerina,aviva,arteries,anomaly,airstrip,agonizing,adjourn,aaaaa,yearning,wrecker,witnessing,whence,warhead,unsure,unheard,unfreeze,unfold,unbalanced,ugliest,troublemaker,toddler,tiptoe,threesome,thirties,thermostat,swipe,surgically,subtlety,stung,stumbling,stubs,stride,strangling,sprayed,socket,smuggled,showering,shhhhh,sabotaging,rumson,rounding,risotto,repairman,rehearsed,ratty,ragging,radiology,racquetball,racking,quieter,quicksand,prowl,prompt,premeditated,prematurely,prancing,porcupine,plated,pinocchio,peeked,peddle,panting,overweight,overrun,outing,outgrown,obsess,nursed,nodding,negativity,negatives,musketeers,mugger,motorcade,merrily,matured,masquerading,marvellous,maniacs,lovey,louse,linger,lilies,lawful,kudos,knuckle,juices,judgments,itches,intolerable,intermission,inept,incarceration,implication,imaginative,huckleberry,holster,heartburn,gunna,groomed,graciously,fulfillment,fugitives,forsaking,forgives,foreseeable,flavors,flares,fixation,fickle,fantasize,famished,fades,expiration,exclamation,erasing,eiffel,eerie,earful,duped,dulles,dissing,dissect,dispenser,dilated,detergent,desdemona,debriefing,damper,curing,crispina,crackpot,courting,cordial,conflicted,comprehension,commie,cleanup,chiropractor,charmer,chariot,cauldron,catatonic,bullied,buckets,brilliantly,breathed,booths,boardroom,blowout,blindness,blazing,biologically,bibles,biased,beseech,barbaric,balraj,audacity,anticipating,alcoholics,airhead,agendas,admittedly,absolution,youre,yippee,wittlesey,withheld,willful,whammy,weakest,washes,virtuous,videotapes,vials,unplugged,unpacked,unfairly,turbulence,tumbling,tricking,tremendously,traitors,torches,tinga,thyroid,teased,tawdry,taker,sympathies,swiped,sundaes,suave,strut,stepdad,spewing,spasm,socialize,slither,simulator,shutters,shrewd,shocks,semantics,schizophrenic,scans,savages,rya'c,runny,ruckus,royally,roadblocks,rewriting,revoke,repent,redecorate,recovers,recourse,ratched,ramali,racquet,quince,quiche,puppeteer,puking,puffed,problemo,praises,pouch,postcards,pooped,poised,piled,phoney,phobia,patching,parenthood,pardner,oozing,ohhhhh,numbing,nostril,nosey,neatly,nappa,nameless,mortuary,moronic,modesty,midwife,mcclane,matuka,maitre,lumps,lucid,loosened,loins,lawnmower,lamotta,kroehner,jinxy,jessep,jamming,jailhouse,jacking,intruders,inhuman,infatuated,indigestion,implore,implanted,hormonal,hoboken,hillbilly,heartwarming,headway,hatched,hartmans,harping,grapevine,gnome,forties,flyin,flirted,fingernail,exhilarating,enjoyment,embark,dumper,dubious,drell,docking,disillusioned,dishonor,disbarred,dicey,custodial,counterproductive,corned,cords,contemplate,concur,conceivable,cobblepot,chickened,checkout,carpe,cap'n,campers,buyin,bullies,braid,boxed,bouncy,blueberries,blubbering,bloodstream,bigamy,beeped,bearable,autographs,alarming,wretch,wimps,widower,whirlwind,whirl,warms,vandelay,unveiling,undoing,unbecoming,turnaround,touche,togetherness,tickles,ticker,teensy,taunt,sweethearts,stitched,standpoint,staffers,spotless,soothe,smothered,sickening,shouted,shepherds,shawl,seriousness,schooled,schoolboy,s'mores,roped,reminders,raggedy,preemptive,plucked,pheromones,particulars,pardoned,overpriced,overbearing,outrun,ohmigod,nosing,nicked,neanderthal,mosquitoes,mortified,milky,messin,mecha,markinson,marivellas,mannequin,manderley,madder,macready,lookie,locusts,lifetimes,lanna,lakhi,kholi,impersonate,hyperdrive,horrid,hopin,hogging,hearsay,harpy,harboring,hairdo,hafta,grasshopper,gobble,gatehouse,foosball,floozy,fished,firewood,finalize,felons,euphemism,entourage,elitist,elegance,drokken,drier,dredge,dossier,diseased,diarrhea,diagnose,despised,defuse,d'amour,contesting,conserve,conscientious,conjured,collars,clogs,chenille,chatty,chamomile,casing,calculator,brittle,breached,blurted,birthing,bikinis,astounding,assaulting,aroma,appliance,antsy,amnio,alienating,aliases,adolescence,xerox,wrongs,workload,willona,whistling,werewolves,wallaby,unwelcome,unseemly,unplug,undermining,ugliness,tyranny,tuesdays,trumpets,transference,ticks,tangible,tagging,swallowing,superheroes,studs,strep,stowed,stomping,steffy,sprain,spouting,sponsoring,sneezing,smeared,slink,shakin,sewed,seatbelt,scariest,scammed,sanctimonious,roasting,rightly,retinal,rethinking,resented,reruns,remover,racks,purest,progressing,presidente,preeclampsia,postponement,portals,poppa,pliers,pinning,pelvic,pampered,padding,overjoyed,ooooo,one'll,octavius,nonono,nicknames,neurosurgeon,narrows,misled,mislead,mishap,milltown,milking,meticulous,mediocrity,meatballs,machete,lurch,layin,knockin,khruschev,jurors,jumpin,jugular,jeweler,intellectually,inquiries,indulging,indestructible,indebted,imitate,ignores,hyperventilating,hyenas,hurrying,hermano,hellish,heheh,harshly,handout,grunemann,glances,giveaway,getup,gerome,furthest,frosting,frail,forwarded,forceful,flavored,flammable,flaky,fingered,fatherly,ethic,embezzlement,duffel,dotted,distressed,disobey,disappearances,dinky,diminish,diaphragm,deuces,creme,courteous,comforts,coerced,clots,clarification,chunks,chickie,chases,chaperoning,cartons,caper,calves,caged,bustin,bulging,bringin,boomhauer,blowin,blindfolded,biscotti,ballplayer,bagging,auster,assurances,aschen,arraigned,anonymity,alters,albatross,agreeable,adoring,abduct,wolfi,weirded,watchers,washroom,warheads,vincennes,urgency,understandably,uncomplicated,uhhhh,twitching,treadmill,thermos,tenorman,tangle,talkative,swarm,surrendering,summoning,strive,stilts,stickers,squashed,spraying,sparring,soaring,snort,sneezed,slaps,skanky,singin,sidle,shreck,shortness,shorthand,sharper,shamed,sadist,rydell,rusik,roulette,resumes,respiration,recount,reacts,purgatory,princesses,presentable,ponytail,plotted,pinot,pigtails,phillippe,peddling,paroled,orbed,offends,o'hara,moonlit,minefield,metaphors,malignant,mainframe,magicks,maggots,maclaine,loathing,leper,leaps,leaping,lashed,larch,larceny,lapses,ladyship,juncture,jiffy,jakov,invoke,infantile,inadmissible,horoscope,hinting,hideaway,hesitating,heddy,heckles,hairline,gripe,gratifying,governess,goebbels,freddo,foresee,fascination,exemplary,executioner,etcetera,escorts,endearing,eaters,earplugs,draped,disrupting,disagrees,dimes,devastate,detain,depositions,delicacy,darklighter,cynicism,cyanide,cutters,cronus,continuance,conquering,confiding,compartments,combing,cofell,clingy,cleanse,christmases,cheered,cheekbones,buttle,burdened,bruenell,broomstick,brained,bozos,bontecou,bluntman,blazes,blameless,bizarro,bellboy,beaucoup,barkeep,awaken,astray,assailant,appease,aphrodisiac,alleys,yesss,wrecks,woodpecker,wondrous,wimpy,willpower,wheeling,weepy,waxing,waive,videotaped,veritable,untouched,unlisted,unfounded,unforeseen,twinge,triggers,traipsing,toxin,tombstone,thumping,therein,testicles,telephones,tarmac,talby,tackled,swirling,suicides,suckered,subtitles,sturdy,strangler,stockbroker,stitching,steered,standup,squeal,sprinkler,spontaneously,splendor,spiking,spender,snipe,snagged,skimming,siddown,showroom,shovels,shotguns,shoelaces,shitload,shellfish,sharpest,shadowy,seizing,scrounge,scapegoat,sayonara,saddled,rummaging,roomful,renounce,reconsidered,recharge,realistically,radioed,quirks,quadrant,punctual,practising,pours,poolhouse,poltergeist,pocketbook,plainly,picnics,pesto,pawing,passageway,partied,oneself,numero,nostalgia,nitwit,neuro,mixer,meanest,mcbeal,matinee,margate,marce,manipulations,manhunt,manger,magicians,loafers,litvack,lightheaded,lifeguard,lawns,laughingstock,ingested,indignation,inconceivable,imposition,impersonal,imbecile,huddled,housewarming,horizons,homicides,hiccups,hearse,hardened,gushing,gushie,greased,goddamit,freelancer,forging,fondue,flustered,flung,flinch,flicker,fixin,festivus,fertilizer,farted,faggots,exonerate,evict,enormously,encrypted,emdash,embracing,duress,dupres,dowser,doormat,disfigured,disciplined,dibbs,depository,deathbed,dazzled,cuttin,cures,crowding,crepe,crammed,copycat,contradict,confidant,condemning,conceited,commute,comatose,clapping,circumference,chuppah,chore,choksondik,chestnuts,briault,bottomless,bonnet,blokes,berluti,beret,beggars,bankroll,bania,athos,arsenic,apperantly,ahhhhhh,afloat,accents,zipped,zeros,zeroes,zamir,yuppie,youngsters,yorkers,wisest,wipes,wield,whyn't,weirdos,wednesdays,vicksburg,upchuck,untraceable,unsupervised,unpleasantness,unhook,unconscionable,uncalled,trappings,tragedies,townie,thurgood,things'll,thine,tetanus,terrorize,temptations,tanning,tampons,swarming,straitjacket,steroid,startling,starry,squander,speculating,sollozzo,sneaked,slugs,skedaddle,sinker,silky,shortcomings,sellin,seasoned,scrubbed,screwup,scrapes,scarves,sandbox,salesmen,rooming,romances,revere,reproach,reprieve,rearranging,ravine,rationalize,raffle,punchy,psychobabble,provocation,profoundly,prescriptions,preferable,polishing,poached,pledges,pirelli,perverts,oversized,overdressed,outdid,nuptials,nefarious,mouthpiece,motels,mopping,mongrel,missin,metaphorically,mertin,memos,melodrama,melancholy,measles,meaner,mantel,maneuvering,mailroom,luring,listenin,lifeless,licks,levon,legwork,kneecaps,kippur,kiddie,kaput,justifiable,insistent,insidious,innuendo,innit,indecent,imaginable,horseshit,hemorrhoid,hella,healthiest,haywire,hamsters,hairbrush,grouchy,grisly,gratuitous,glutton,glimmer,gibberish,ghastly,gentler,generously,geeky,fuhrer,fronting,foolin,faxes,faceless,extinguisher,expel,etched,endangering,ducked,dodgeball,dives,dislocated,discrepancy,devour,derail,dementia,daycare,cynic,crumbling,cowardice,covet,cornwallis,corkscrew,cookbook,commandments,coincidental,cobwebs,clouded,clogging,clicking,clasp,chopsticks,chefs,chaps,cashing,carat,calmer,brazen,brainwashing,bradys,bowing,boned,bloodsucking,bleachers,bleached,bedpan,bearded,barrenger,bachelors,awwww,assures,assigning,asparagus,apprehend,anecdote,amoral,aggravation,afoot,acquaintances,accommodating,yakking,worshipping,wladek,willya,willies,wigged,whoosh,whisked,watered,warpath,volts,violates,valuables,uphill,unwise,untimely,unsavory,unresponsive,unpunished,unexplained,tubby,trolling,toxicology,tormented,toothache,tingly,timmiihh,thursdays,thoreau,terrifies,temperamental,telegrams,talkie,takers,symbiote,swirl,suffocate,stupider,strapping,steckler,springing,someway,sleepyhead,sledgehammer,slant,slams,showgirl,shoveling,shmoopy,sharkbait,shan't,scrambling,schematics,sandeman,sabbatical,rummy,reykjavik,revert,responsive,rescheduled,requisition,relinquish,rejoice,reckoning,recant,rebadow,reassurance,rattlesnake,ramble,primed,pricey,prance,pothole,pocus,persist,perpetrated,pekar,peeling,pastime,parmesan,pacemaker,overdrive,ominous,observant,nothings,noooooo,nonexistent,nodded,nieces,neglecting,nauseating,mutated,musket,mumbling,mowing,mouthful,mooseport,monologue,mistrust,meetin,masseuse,mantini,mailer,madre,lowlifes,locksmith,livid,liven,limos,liberating,lhasa,leniency,leering,laughable,lashes,lasagne,laceration,korben,katan,kalen,jittery,jammies,irreplaceable,intubate,intolerant,inhaler,inhaled,indifferent,indifference,impound,impolite,humbly,heroics,heigh,guillotine,guesthouse,grounding,grips,gossiping,goatee,gnomes,gellar,frutt,frobisher,freudian,foolishness,flagged,femme,fatso,fatherhood,fantasized,fairest,faintest,eyelids,extravagant,extraterrestrial,extraordinarily,escalator,elevate,drivel,dissed,dismal,disarray,dinnertime,devastation,dermatologist,delicately,defrost,debutante,debacle,damone,dainty,cuvee,culpa,crucified,creeped,crayons,courtship,convene,congresswoman,concocted,compromises,comprende,comma,coleslaw,clothed,clinically,chickenshit,checkin,cesspool,caskets,calzone,brothel,boomerang,bodega,blasphemy,bitsy,bicentennial,berlini,beatin,beards,barbas,barbarians,backpacking,arrhythmia,arousing,arbitrator,antagonize,angling,anesthetic,altercation,aggressor,adversity,acathla,aaahhh,wreaking,workup,wonderin,wither,wielding,what'm,what'cha,waxed,vibrating,veterinarian,venting,vasey,valor,validate,upholstery,untied,unscathed,uninterrupted,unforgiving,undies,uncut,twinkies,tucking,treatable,treasured,tranquility,townspeople,torso,tomei,tipsy,tinsel,tidings,thirtieth,tantrums,tamper,talky,swayed,swapping,suitor,stylist,stirs,standoff,sprinklers,sparkly,snobby,snatcher,smoother,sleepin,shrug,shoebox,sheesh,shackles,setbacks,sedatives,screeching,scorched,scanned,satyr,roadblock,riverbank,ridiculed,resentful,repellent,recreate,reconvene,rebuttal,realmedia,quizzes,questionnaire,punctured,pucker,prolong,professionalism,pleasantly,pigsty,penniless,paychecks,patiently,parading,overactive,ovaries,orderlies,oracles,oiled,offending,nudie,neonatal,neighborly,moops,moonlighting,mobilize,mmmmmm,milkshake,menial,meats,mayan,maxed,mangled,magua,lunacy,luckier,liters,lansbury,kooky,knowin,jeopardized,inkling,inhalation,inflated,infecting,incense,inbound,impractical,impenetrable,idealistic,i'mma,hypocrites,hurtin,humbled,hologram,hokey,hocus,hitchhiking,hemorrhoids,headhunter,hassled,harts,hardworking,haircuts,hacksaw,genitals,gazillion,gammy,gamesphere,fugue,footwear,folly,flashlights,fives,filet,extenuating,estrogen,entails,embezzled,eloquent,egomaniac,ducts,drowsy,drones,doree,donovon,disguises,diggin,deserting,depriving,defying,deductible,decorum,decked,daylights,daybreak,dashboard,damnation,cuddling,crunching,crickets,crazies,councilman,coughed,conundrum,complimented,cohaagen,clutching,clued,clader,cheques,checkpoint,chats,channeling,ceases,carasco,capisce,cantaloupe,cancelling,campsite,burglars,breakfasts,bra'tac,blueprint,bleedin,blabbed,beneficiary,basing,avert,atone,arlyn,approves,apothecary,antiseptic,aleikuum,advisement,zadir,wobbly,withnail,whattaya,whacking,wedged,wanders,vaginal,unimaginable,undeniable,unconditionally,uncharted,unbridled,tweezers,tvmegasite,trumped,triumphant,trimming,treading,tranquilizers,toontown,thunk,suture,suppressing,strays,stonewall,stogie,stepdaughter,stace,squint,spouses,splashed,speakin,sounder,sorrier,sorrel,sombrero,solemnly,softened,snobs,snippy,snare,smoothing,slump,slimeball,slaving,silently,shiller,shakedown,sensations,scrying,scrumptious,screamin,saucy,santoses,roundup,roughed,rosary,robechaux,retrospect,rescind,reprehensible,repel,remodeling,reconsidering,reciprocate,railroaded,psychics,promos,prob'ly,pristine,printout,priestess,prenuptial,precedes,pouty,phoning,peppy,pariah,parched,panes,overloaded,overdoing,nymphs,nother,notebooks,nearing,nearer,monstrosity,milady,mieke,mephesto,medicated,marshals,manilow,mammogram,m'lady,lotsa,loopy,lesion,lenient,learner,laszlo,kross,kinks,jinxed,involuntary,insubordination,ingrate,inflatable,incarnate,inane,hypoglycemia,huntin,humongous,hoodlum,honking,hemorrhage,helpin,hathor,hatching,grotto,grandmama,gorillas,godless,girlish,ghouls,gershwin,frosted,flutter,flagpole,fetching,fatter,faithfully,exert,evasion,escalate,enticing,enchantress,elopement,drills,downtime,downloading,dorks,doorways,divulge,dissociative,disgraceful,disconcerting,deteriorate,destinies,depressive,dented,denim,decruz,decidedly,deactivate,daydreams,curls,culprit,cruelest,crippling,cranberries,corvis,copped,commend,coastguard,cloning,cirque,churning,chock,chivalry,catalogues,cartwheels,carols,canister,buttered,bundt,buljanoff,bubbling,brokers,broaden,brimstone,brainless,bores,badmouthing,autopilot,ascertain,aorta,ampata,allenby,accosted,absolve,aborted,aaagh,aaaaaah,yonder,yellin,wyndham,wrongdoing,woodsboro,wigging,wasteland,warranty,waltzed,walnuts,vividly,veggie,unnecessarily,unloaded,unicorns,understated,unclean,umbrellas,twirling,turpentine,tupperware,triage,treehouse,tidbit,tickled,threes,thousandth,thingie,terminally,teething,tassel,talkies,swoon,switchboard,swerved,suspiciously,subsequentlyne,subscribe,strudel,stroking,strictest,stensland,starin,stannart,squirming,squealing,sorely,softie,snookums,sniveling,smidge,sloth,skulking,simian,sightseeing,siamese,shudder,shoppers,sharpen,shannen,semtex,secondhand,seance,scowl,scorn,safekeeping,russe,rummage,roshman,roomies,roaches,rinds,retrace,retires,resuscitate,rerun,reputations,rekall,refreshment,reenactment,recluse,ravioli,raves,raking,purses,punishable,punchline,puked,prosky,previews,poughkeepsie,poppins,polluted,placenta,pissy,petulant,perseverance,pears,pawns,pastries,partake,panky,palate,overzealous,orchids,obstructing,objectively,obituaries,obedient,nothingness,musty,motherly,mooning,momentous,mistaking,minutemen,milos,microchip,meself,merciless,menelaus,mazel,masturbate,mahogany,lysistrata,lillienfield,likable,liberate,leveled,letdown,larynx,lardass,lainey,lagged,klorel,kidnappings,keyed,karmic,jeebies,irate,invulnerable,intrusive,insemination,inquire,injecting,informative,informants,impure,impasse,imbalance,illiterate,hurled,hunts,hematoma,headstrong,handmade,handiwork,growling,gorky,getcha,gesundheit,gazing,galley,foolishly,fondness,floris,ferocious,feathered,fateful,fancies,fakes,faker,expire,ever'body,essentials,eskimos,enlightening,enchilada,emissary,embolism,elsinore,ecklie,drenched,drazi,doped,dogging,doable,dislikes,dishonesty,disengage,discouraging,derailed,deformed,deflect,defer,deactivated,crips,constellations,congressmen,complimenting,clubbing,clawing,chromium,chimes,chews,cheatin,chaste,cellblock,caving,catered,catacombs,calamari,bucking,brulee,brits,brisk,breezes,bounces,boudoir,binks,better'n,bellied,behrani,behaves,bedding,balmy,badmouth,backers,avenging,aromatherapy,armpit,armoire,anythin,anonymously,anniversaries,aftershave,affliction,adrift,admissible,adieu,acquittal,yucky,yearn,whitter,whirlpool,wendigo,watchdog,wannabes,wakey,vomited,voicemail,valedictorian,uttered,unwed,unrequited,unnoticed,unnerving,unkind,unjust,uniformed,unconfirmed,unadulterated,unaccounted,uglier,turnoff,trampled,tramell,toads,timbuktu,throwback,thimble,tasteless,tarantula,tamale,takeovers,swish,supposing,streaking,stargher,stanzi,stabs,squeamish,splattered,spiritually,spilt,speciality,smacking,skywire,skips,skaara,simpatico,shredding,showin,shortcuts,shite,shielding,shamelessly,serafine,sentimentality,seasick,schemer,scandalous,sainted,riedenschneider,rhyming,revel,retractor,retards,resurrect,remiss,reminiscing,remanded,reiben,regains,refuel,refresher,redoing,redheaded,reassured,rearranged,rapport,qumar,prowling,prejudices,precarious,powwow,pondering,plunger,plunged,pleasantville,playpen,phlegm,perfected,pancreas,paley,ovary,outbursts,oppressed,ooohhh,omoroca,offed,o'toole,nurture,nursemaid,nosebleed,necktie,muttering,munchies,mucking,mogul,mitosis,misdemeanor,miscarried,millionth,migraines,midler,manicurist,mandelbaum,manageable,malfunctioned,magnanimous,loudmouth,longed,lifestyles,liddy,lickety,leprechauns,komako,klute,kennel,justifying,irreversible,inventing,intergalactic,insinuate,inquiring,ingenuity,inconclusive,incessant,improv,impersonation,hyena,humperdinck,hubba,housework,hoffa,hither,hissy,hippy,hijacked,heparin,hellooo,hearth,hassles,hairstyle,hahahaha,hadda,guys'll,gutted,gulls,gritty,grievous,graft,gossamer,gooder,gambled,gadgets,fundamentals,frustrations,frolicking,frock,frilly,foreseen,footloose,fondly,flirtation,flinched,flatten,farthest,exposer,evading,escrow,empathize,embryos,embodiment,ellsberg,ebola,dulcinea,dreamin,drawbacks,doting,doose,doofy,disturbs,disorderly,disgusts,detox,denominator,demeanor,deliriously,decode,debauchery,croissant,cravings,cranked,coworkers,councilor,confuses,confiscate,confines,conduit,compress,combed,clouding,clamps,cinch,chinnery,celebratory,catalogs,carpenters,carnal,canin,bundys,bulldozer,buggers,bueller,brainy,booming,bookstores,bloodbath,bittersweet,bellhop,beeping,beanstalk,beady,baudelaire,bartenders,bargains,averted,armadillo,appreciating,appraised,antlers,aloof,allowances,alleyway,affleck,abject,zilch,youore,xanax,wrenching,wouldn,witted,wicca,whorehouse,whooo,whips,vouchers,victimized,vicodin,untested,unsolicited,unfocused,unfettered,unfeeling,unexplainable,understaffed,underbelly,tutorial,tryst,trampoline,towering,tirade,thieving,thang,swimmin,swayzak,suspecting,superstitions,stubbornness,streamers,strattman,stonewalling,stiffs,stacking,spout,splice,sonrisa,smarmy,slows,slicing,sisterly,shrill,shined,seeming,sedley,seatbelts,scour,scold,schoolyard,scarring,salieri,rustling,roxbury,rewire,revved,retriever,reputable,remodel,reins,reincarnation,rance,rafters,rackets,quail,pumbaa,proclaim,probing,privates,pried,prewedding,premeditation,posturing,posterity,pleasurable,pizzeria,pimps,penmanship,penchant,pelvis,overturn,overstepped,overcoat,ovens,outsmart,outed,ooohh,oncologist,omission,offhand,odour,nyazian,notarized,nobody'll,nightie,navel,nabbed,mystique,mover,mortician,morose,moratorium,mockingbird,mobsters,mingling,methinks,messengered,merde,masochist,martouf,martians,marinara,manray,majorly,magnifying,mackerel,lurid,lugging,lonnegan,loathsome,llantano,liberace,leprosy,latinos,lanterns,lamest,laferette,kraut,intestine,innocencia,inhibitions,ineffectual,indisposed,incurable,inconvenienced,inanimate,improbable,implode,hydrant,hustling,hustled,huevos,how'm,hooey,hoods,honcho,hinge,hijack,heimlich,hamunaptra,haladki,haiku,haggle,gutsy,grunting,grueling,gribbs,greevy,grandstanding,godparents,glows,glistening,gimmick,gaping,fraiser,formalities,foreigner,folders,foggy,fitty,fiends,fe'nos,favours,eyeing,extort,expedite,escalating,epinephrine,entitles,entice,eminence,eights,earthlings,eagerly,dunville,dugout,doublemeat,doling,dispensing,dispatcher,discoloration,diners,diddly,dictates,diazepam,derogatory,delights,defies,decoder,dealio,danson,cutthroat,crumbles,croissants,crematorium,craftsmanship,could'a,cordless,cools,conked,confine,concealing,complicates,communique,cockamamie,coasters,clobbered,clipping,clipboard,clemenza,cleanser,circumcision,chanukah,certainaly,cellmate,cancels,cadmium,buzzed,bumstead,bucko,browsing,broth,braver,boggling,bobbing,blurred,birkhead,benet,belvedere,bellies,begrudge,beckworth,banky,baldness,baggy,babysitters,aversion,astonished,assorted,appetites,angina,amiss,ambulances,alibis,airway,admires,adhesive,yoyou,xxxxxx,wreaked,wracking,woooo,wooing,wised,wilshire,wedgie,waging,violets,vincey,uplifting,untrustworthy,unmitigated,uneventful,undressing,underprivileged,unburden,umbilical,tweaking,turquoise,treachery,tosses,torching,toothpick,toasts,thickens,tereza,tenacious,teldar,taint,swill,sweatin,subtly,subdural,streep,stopwatch,stockholder,stillwater,stalkers,squished,squeegee,splinters,spliced,splat,spied,spackle,sophistication,snapshots,smite,sluggish,slithered,skeeters,sidewalks,sickly,shrugs,shrubbery,shrieking,shitless,settin,sentinels,selfishly,scarcely,sangria,sanctum,sahjhan,rustle,roving,rousing,rosomorf,riddled,responsibly,renoir,remoray,remedial,refundable,redirect,recheck,ravenwood,rationalizing,ramus,ramelle,quivering,pyjamas,psychos,provocations,prouder,protestors,prodded,proctologist,primordial,pricks,prickly,precedents,pentangeli,pathetically,parka,parakeet,panicky,overthruster,outsmarted,orthopedic,oncoming,offing,nutritious,nuthouse,nourishment,nibbling,newlywed,narcissist,mutilation,mundane,mummies,mumble,mowed,morvern,mortem,mopes,molasses,misplace,miscommunication,miney,midlife,menacing,memorizing,massaging,masking,magnets,luxuries,lounging,lothario,liposuction,lidocaine,libbets,levitate,leeway,launcelot,larek,lackeys,kumbaya,kryptonite,knapsack,keyhole,katarangura,juiced,jakey,ironclad,invoice,intertwined,interlude,interferes,injure,infernal,indeedy,incur,incorrigible,incantations,impediment,igloo,hysterectomy,hounded,hollering,hindsight,heebie,havesham,hasenfuss,hankering,hangers,hakuna,gutless,gusto,grubbing,grrrr,grazed,gratification,grandeur,gorak,godammit,gnawing,glanced,frostbite,frees,frazzled,fraulein,fraternizing,fortuneteller,formaldehyde,followup,foggiest,flunky,flickering,firecrackers,figger,fetuses,fates,eyeliner,extremities,extradited,expires,exceedingly,evaporate,erupt,epileptic,entrails,emporium,egregious,eggshells,easing,duwayne,droll,dreyfuss,dovey,doubly,doozy,donkeys,donde,distrust,distressing,disintegrate,discreetly,decapitated,dealin,deader,dashed,darkroom,dares,daddies,dabble,cushy,cupcakes,cuffed,croupier,croak,crapped,coursing,coolers,contaminate,consummated,construed,condos,concoction,compulsion,commish,coercion,clemency,clairvoyant,circulate,chesterton,checkered,charlatan,chaperones,categorically,cataracts,carano,capsules,capitalize,burdon,bullshitting,brewed,breathless,breasted,brainstorming,bossing,borealis,bonsoir,bobka,boast,blimp,bleep,bleeder,blackouts,bisque,billboards,beatings,bayberry,bashed,bamboozled,balding,baklava,baffled,backfires,babak,awkwardness,attest,attachments,apologizes,anyhoo,antiquated,alcante,advisable,aahhh,aaahh,zatarc,yearbooks,wuddya,wringing,womanhood,witless,winging,whatsa,wetting,waterproof,wastin,vogelman,vocation,vindicated,vigilance,vicariously,venza,vacuuming,utensils,uplink,unveil,unloved,unloading,uninhibited,unattached,tweaked,turnips,trinkets,toughen,toting,topside,terrors,terrify,technologically,tarnish,tagliati,szpilman,surly,supple,summation,suckin,stepmom,squeaking,splashmore,souffle,solitaire,solicitation,solarium,smokers,slugged,slobbering,skylight,skimpy,sinuses,silenced,sideburns,shrinkage,shoddy,shhhhhh,shelled,shareef,shangri,seuss,serenade,scuffle,scoff,scanners,sauerkraut,sardines,sarcophagus,salvy,rusted,russells,rowboat,rolfsky,ringside,respectability,reparations,renegotiate,reminisce,reimburse,regimen,raincoat,quibble,puzzled,purposefully,pubic,proofing,prescribing,prelim,poisons,poaching,personalized,personable,peroxide,pentonville,payphone,payoffs,paleontology,overflowing,oompa,oddest,objecting,o'hare,o'daniel,notches,nobody'd,nightstand,neutralized,nervousness,nerdy,needlessly,naquadah,nappy,nantucket,nambla,mountaineer,motherfuckin,morrie,monopolizing,mohel,mistreated,misreading,misbehave,miramax,minivan,milligram,milkshakes,metamorphosis,medics,mattresses,mathesar,matchbook,matata,marys,malucci,magilla,lymphoma,lowers,lordy,linens,lindenmeyer,limelight,leapt,laxative,lather,lapel,lamppost,laguardia,kindling,kegger,kawalsky,juries,jokin,jesminder,interning,innermost,injun,infallible,industrious,indulgence,incinerator,impossibility,impart,illuminate,iguanas,hypnotic,hyped,hospitable,hoses,homemaker,hirschmuller,helpers,headset,guardianship,guapo,grubby,granola,granddaddy,goren,goblet,gluttony,globes,giorno,getter,geritol,gassed,gaggle,foxhole,fouled,foretold,floorboards,flippers,flaked,fireflies,feedings,fashionably,farragut,fallback,facials,exterminate,excites,everything'll,evenin,ethically,ensue,enema,empath,eluded,eloquently,eject,edema,dumpling,droppings,dolled,distasteful,disputing,displeasure,disdain,deterrent,dehydration,defied,decomposing,dawned,dailies,custodian,crusts,crucifix,crowning,crier,crept,craze,crawls,couldn,correcting,corkmaster,copperfield,cooties,contraption,consumes,conspire,consenting,consented,conquers,congeniality,complains,communicator,commendable,collide,coladas,colada,clout,clooney,classifieds,clammy,civility,cirrhosis,chink,catskills,carvers,carpool,carelessness,cardio,carbs,capades,butabi,busmalis,burping,burdens,bunks,buncha,bulldozers,browse,brockovich,breakthroughs,bravado,boogety,blossoms,blooming,bloodsucker,blight,betterton,betrayer,belittle,beeps,bawling,barts,bartending,bankbooks,babish,atropine,assertive,armbrust,anyanka,annoyance,anemic,anago,airwaves,aimlessly,aaargh,aaand,yoghurt,writhing,workable,winking,winded,widen,whooping,whiter,whatya,wazoo,voila,virile,vests,vestibule,versed,vanishes,urkel,uproot,unwarranted,unscheduled,unparalleled,undergrad,tweedle,turtleneck,turban,trickery,transponder,toyed,townhouse,thyself,thunderstorm,thinning,thawed,tether,technicalities,tau'ri,tarnished,taffeta,tacked,systolic,swerve,sweepstakes,swabs,suspenders,superwoman,sunsets,succulent,subpoenas,stumper,stosh,stomachache,stewed,steppin,stepatech,stateside,spicoli,sparing,soulless,sonnets,sockets,snatching,smothering,slush,sloman,slashing,sitters,simpleton,sighs,sidra,sickens,shunned,shrunken,showbiz,shopped,shimmering,shagging,semblance,segue,sedation,scuzzlebutt,scumbags,screwin,scoundrels,scarsdale,scabs,saucers,saintly,saddened,runaways,runaround,rheya,resenting,rehashing,rehabilitated,regrettable,refreshed,redial,reconnecting,ravenous,raping,rafting,quandary,pylea,putrid,puffing,psychopathic,prunes,probate,prayin,pomegranate,plummeting,planing,plagues,pinata,pithy,perversion,personals,perched,peeps,peckish,pavarotti,pajama,packin,pacifier,overstepping,okama,obstetrician,nutso,nuance,normalcy,nonnegotiable,nomak,ninny,nines,nicey,newsflash,neutered,nether,negligee,necrosis,navigating,narcissistic,mylie,muses,momento,moisturizer,moderation,misinformed,misconception,minnifield,mikkos,methodical,mebbe,meager,maybes,matchmaking,masry,markovic,malakai,luzhin,lusting,lumberjack,loopholes,loaning,lightening,leotard,launder,lamaze,kubla,kneeling,kibosh,jumpsuit,joliet,jogger,janover,jakovasaurs,irreparable,innocently,inigo,infomercial,inexplicable,indispensable,impregnated,impossibly,imitating,hunches,hummus,houmfort,hothead,hostiles,hooves,hooligans,homos,homie,hisself,heyyy,hesitant,hangout,handsomest,handouts,hairless,gwennie,guzzling,guinevere,grungy,goading,glaring,gavel,gardino,gangrene,fruitful,friendlier,freckle,freakish,forthright,forearm,footnote,flops,fixer,firecracker,finito,figgered,fezzik,fastened,farfetched,fanciful,familiarize,faire,fahrenheit,extravaganza,exploratory,explanatory,everglades,eunuch,estas,escapade,erasers,emptying,embarassing,dweeb,dutiful,dumplings,dries,drafty,dollhouse,dismissing,disgraced,discrepancies,disbelief,disagreeing,digestion,didnt,deviled,deviated,demerol,delectable,decaying,decadent,dears,dateless,d'algout,cultivating,cryto,crumpled,crumbled,cronies,crease,craves,cozying,corduroy,congratulated,confidante,compressions,complicating,compadre,coerce,classier,chums,chumash,chivalrous,chinpoko,charred,chafing,celibacy,carted,carryin,carpeting,carotid,cannibals,candor,butterscotch,busts,busier,bullcrap,buggin,brookside,brodski,brassiere,brainwash,brainiac,botrelle,bonbon,boatload,blimey,blaring,blackness,bipartisan,bimbos,bigamist,biebe,biding,betrayals,bestow,bellerophon,bedpans,bassinet,basking,barzini,barnyard,barfed,backups,audited,asinine,asalaam,arouse,applejack,annoys,anchovies,ampule,alameida,aggravate,adage,accomplices,yokel,y'ever,wringer,witwer,withdrawals,windward,willfully,whorfin,whimsical,whimpering,weddin,weathered,warmest,wanton,volant,visceral,vindication,veggies,urinate,uproar,unwritten,unwrap,unsung,unsubstantiated,unspeakably,unscrupulous,unraveling,unquote,unqualified,unfulfilled,undetectable,underlined,unattainable,unappreciated,ummmm,ulcers,tylenol,tweak,turnin,tuatha,tropez,trellis,toppings,tootin,toodle,tinkering,thrives,thespis,theatrics,thatherton,tempers,tavington,tartar,tampon,swelled,sutures,sustenance,sunflowers,sublet,stubbins,strutting,strewn,stowaway,stoic,sternin,stabilizing,spiraling,spinster,speedometer,speakeasy,soooo,soiled,sneakin,smithereens,smelt,smacks,slaughterhouse,slacks,skids,sketching,skateboards,sizzling,sixes,sirree,simplistic,shouts,shorted,shoelace,sheeit,shards,shackled,sequestered,selmak,seduces,seclusion,seamstress,seabeas,scoops,scooped,scavenger,satch,s'more,rudeness,romancing,rioja,rifkin,rieper,revise,reunions,repugnant,replicating,repaid,renewing,relaxes,rekindle,regrettably,regenerate,reels,reciting,reappear,readin,ratting,rapes,rancher,rammed,rainstorm,railroading,queers,punxsutawney,punishes,pssst,prudy,proudest,protectors,procrastinating,proactive,priss,postmortem,pompoms,poise,pickings,perfectionist,peretti,people'll,pecking,patrolman,paralegal,paragraphs,paparazzi,pankot,pampering,overstep,overpower,outweigh,omnipotent,odious,nuwanda,nurtured,newsroom,neeson,needlepoint,necklaces,neato,muggers,muffler,mousy,mourned,mosey,mopey,mongolians,moldy,misinterpret,minibar,microfilm,mendola,mended,melissande,masturbating,masbath,manipulates,maimed,mailboxes,magnetism,m'lord,m'honey,lymph,lunge,lovelier,lefferts,leezak,ledgers,larraby,laloosh,kundun,kozinski,knockoff,kissin,kiosk,kennedys,kellman,karlo,kaleidoscope,jeffy,jaywalking,instructing,infraction,informer,infarction,impulsively,impressing,impersonated,impeach,idiocy,hyperbole,hurray,humped,huhuh,hsing,hordes,hoodlums,honky,hitchhiker,hideously,heaving,heathcliff,headgear,headboard,hazing,harem,handprint,hairspray,gutiurrez,goosebumps,gondola,glitches,gasping,frolic,freeways,frayed,fortitude,forgetful,forefathers,fonder,foiled,foaming,flossing,flailing,fitzgeralds,firehouse,finders,fiftieth,fellah,fawning,farquaad,faraway,fancied,extremists,exorcist,exhale,ethros,entrust,ennui,energized,encephalitis,embezzling,elster,elixir,electrolytes,duplex,dryers,drexl,dredging,drawback,don'ts,dobisch,divorcee,disrespected,disprove,disobeying,disinfectant,dingy,digress,dieting,dictating,devoured,devise,detonators,desist,deserter,derriere,deron,deceptive,debilitating,deathwok,daffodils,curtsy,cursory,cuppa,cumin,cronkite,cremation,credence,cranking,coverup,courted,countin,counselling,cornball,contentment,consensual,compost,cluett,cleverly,cleansed,cleanliness,chopec,chomp,chins,chime,cheswick,chessler,cheapest,chatted,cauliflower,catharsis,catchin,caress,camcorder,calorie,cackling,bystanders,buttoned,buttering,butted,buries,burgel,buffoon,brogna,bragged,boutros,bogeyman,blurting,blurb,blowup,bloodhound,blissful,birthmark,bigot,bestest,belted,belligerent,beggin,befall,beeswax,beatnik,beaming,barricade,baggoli,badness,awoke,artsy,artful,aroun,armpits,arming,annihilate,anise,angiogram,anaesthetic,amorous,ambiance,alligators,adoration,admittance,adama,abydos,zonked,zhivago,yorkin,wrongfully,writin,wrappers,worrywart,woops,wonderfalls,womanly,wickedness,whoopie,wholeheartedly,whimper,which'll,wheelchairs,what'ya,warranted,wallop,wading,wacked,virginal,vermouth,vermeil,verger,ventriss,veneer,vampira,utero,ushers,urgently,untoward,unshakable,unsettled,unruly,unlocks,ungodly,undue,uncooperative,uncontrollably,unbeatable,twitchy,tumbler,truest,triumphs,triplicate,tribbey,tortures,tongaree,tightening,thorazine,theres,testifies,teenaged,tearful,taxing,taldor,syllabus,swoops,swingin,suspending,sunburn,stuttering,stupor,strides,strategize,strangulation,stooped,stipulation,stingy,stapled,squeaks,squawking,spoilsport,splicing,spiel,spencers,spasms,spaniard,softener,sodding,soapbox,smoldering,smithbauer,skittish,sifting,sickest,sicilians,shuffling,shrivel,segretti,seeping,securely,scurrying,scrunch,scrote,screwups,schenkman,sawing,savin,satine,sapiens,salvaging,salmonella,sacrilege,rumpus,ruffle,roughing,rotted,rondall,ridding,rickshaw,rialto,rhinestone,restrooms,reroute,requisite,repress,rednecks,redeeming,rayed,ravell,raked,raincheck,raffi,racked,pushin,profess,prodding,procure,presuming,preppy,prednisone,potted,posttraumatic,poorhouse,podiatrist,plowed,pledging,playroom,plait,placate,pinback,picketing,photographing,pharoah,petrak,petal,persecuting,perchance,pellets,peeved,peerless,payable,pauses,pathologist,pagliacci,overwrought,overreaction,overqualified,overheated,outcasts,otherworldly,opinionated,oodles,oftentimes,occured,obstinate,nutritionist,numbness,nubile,nooooooo,nobodies,nepotism,neanderthals,mushu,mucus,mothering,mothballs,monogrammed,molesting,misspoke,misspelled,misconstrued,miscalculated,minimums,mince,mildew,mighta,middleman,mementos,mellowed,mayol,mauled,massaged,marmalade,mardi,makings,lundegaard,lovingly,loudest,lotto,loosing,loompa,looming,longs,loathes,littlest,littering,lifelike,legalities,laundered,lapdog,lacerations,kopalski,knobs,knitted,kittridge,kidnaps,kerosene,karras,jungles,jockeys,iranoff,invoices,invigorating,insolence,insincere,insectopia,inhumane,inhaling,ingrates,infestation,individuality,indeterminate,incomprehensible,inadequacy,impropriety,importer,imaginations,illuminating,ignite,hysterics,hypodermic,hyperventilate,hyperactive,humoring,honeymooning,honed,hoist,hoarding,hitching,hiker,hightail,hemoglobin,hell'd,heinie,growin,grasped,grandparent,granddaughters,gouged,goblins,gleam,glades,gigantor,get'em,geriatric,gatekeeper,gargoyles,gardenias,garcon,garbo,gallows,gabbing,futon,fulla,frightful,freshener,fortuitous,forceps,fogged,fodder,foamy,flogging,flaun,flared,fireplaces,feverish,favell,fattest,fattening,fallow,extraordinaire,evacuating,errant,envied,enchant,enamored,egocentric,dussander,dunwitty,dullest,dropout,dredged,dorsia,doornail,donot,dongs,dogged,dodgy,ditty,dishonorable,discriminating,discontinue,dings,dilly,dictation,dialysis,delly,delightfully,daryll,dandruff,cruddy,croquet,cringe,crimp,credo,crackling,courtside,counteroffer,counterfeiting,corrupting,copping,conveyor,contusions,contusion,conspirator,consoling,connoisseur,confetti,composure,compel,colic,coddle,cocksuckers,coattails,cloned,claustrophobia,clamoring,churn,chugga,chirping,chasin,chapped,chalkboard,centimeter,caymans,catheter,casings,caprica,capelli,cannolis,cannoli,camogli,camembert,butchers,butchered,busboys,bureaucrats,buckled,bubbe,brownstone,bravely,brackley,bouquets,botox,boozing,boosters,bodhi,blunders,blunder,blockage,biocyte,betrays,bested,beryllium,beheading,beggar,begbie,beamed,bastille,barstool,barricades,barbecues,barbecued,bandwagon,backfiring,bacarra,avenged,autopsies,aunties,associating,artichoke,arrowhead,appendage,apostrophe,antacid,ansel,annul,amuses,amped,amicable,amberg,alluring,adversaries,admirers,adlai,acupuncture,abnormality,aaaahhhh,zooming,zippity,zipping,zeroed,yuletide,yoyodyne,yengeese,yeahhh,wrinkly,wracked,withered,winks,windmills,whopping,wendle,weigart,waterworks,waterbed,watchful,wantin,wagging,waaah,vying,ventricle,varnish,vacuumed,unreachable,unprovoked,unmistakable,unfriendly,unfolding,underpaid,uncuff,unappealing,unabomber,typhoid,tuxedos,tushie,turds,tumnus,troubadour,trinium,treaters,treads,transpired,transgression,tought,thready,thins,thinners,techs,teary,tattaglia,tassels,tarzana,tanking,tablecloths,synchronize,symptomatic,sycophant,swimmingly,sweatshop,surfboard,superpowers,sunroom,sunblock,sugarplum,stupidly,strumpet,strapless,stooping,stools,stealthy,stalks,stairmaster,staffer,sshhh,squatting,squatters,spectacularly,sorbet,socked,sociable,snubbed,snorting,sniffles,snazzy,snakebite,smuggler,smorgasbord,smooching,slurping,slouch,slingshot,slaved,skimmed,sisterhood,silliest,sidarthur,sheraton,shebang,sharpening,shanghaied,shakers,sendoff,scurvy,scoliosis,scaredy,scagnetti,sawchuk,saugus,sasquatch,sandbag,saltines,s'pose,roston,rostle,riveting,ristle,rifling,revulsion,reverently,retrograde,restful,resents,reptilian,reorganize,renovating,reiterate,reinvent,reinmar,reibers,reechard,recuse,reconciling,recognizance,reclaiming,recitation,recieved,rebate,reacquainted,rascals,railly,quintuplets,quahog,pygmies,puzzling,punctuality,prosthetic,proms,probie,preys,preserver,preppie,poachers,plummet,plumbers,plannin,pitying,pitfalls,piqued,pinecrest,pinches,pillage,pigheaded,physique,pessimistic,persecute,perjure,percentile,pentothal,pensky,penises,peini,pazzi,pastels,parlour,paperweight,pamper,pained,overwhelm,overalls,outrank,outpouring,outhouse,outage,ouija,obstructed,obsessions,obeying,obese,o'riley,o'higgins,nosebleeds,norad,noooooooo,nononono,nonchalant,nippy,neurosis,nekhorvich,necronomicon,naquada,n'est,mystik,mystified,mumps,muddle,mothership,moped,monumentally,monogamous,mondesi,misogynistic,misinterpreting,mindlock,mending,megaphone,meeny,medicating,meanie,masseur,markstrom,marklars,margueritas,manifesting,maharajah,lukewarm,loveliest,loran,lizardo,liquored,lipped,lingers,limey,lemkin,leisurely,lathe,latched,lapping,ladle,krevlorneswath,kosygin,khakis,kenaru,keats,kaitlan,julliard,jollies,jaundice,jargon,jackals,invisibility,insipid,inflamed,inferiority,inexperience,incinerated,incinerate,incendiary,incan,inbred,implicating,impersonator,hunks,horsing,hooded,hippopotamus,hiked,hetson,hetero,hessian,henslowe,hendler,hellstrom,headstone,hayloft,harbucks,handguns,hallucinate,haldol,haggling,gynaecologist,gulag,guilder,guaranteeing,groundskeeper,grindstone,grimoir,grievance,griddle,gribbit,greystone,graceland,gooders,goeth,gentlemanly,gelatin,gawking,ganged,fukes,fromby,frenchmen,foursome,forsley,forbids,footwork,foothold,floater,flinging,flicking,fittest,fistfight,fireballs,fillings,fiddling,fennyman,felonious,felonies,feces,favoritism,fatten,fanatics,faceman,excusing,excepted,entwined,entree,ensconced,eladio,ehrlichman,easterland,dueling,dribbling,drape,downtrodden,doused,dosed,dorleen,dokie,distort,displeased,disown,dismount,disinherited,disarmed,disapproves,diperna,dined,diligent,dicaprio,depress,decoded,debatable,dealey,darsh,damsels,damning,dad'll,d'oeuvre,curlers,curie,cubed,crikey,crepes,countrymen,cornfield,coppers,copilot,copier,cooing,conspiracies,consigliere,condoning,commoner,commies,combust,comas,colds,clawed,clamped,choosy,chomping,chimps,chigorin,chianti,cheep,checkups,cheaters,celibate,cautiously,cautionary,castell,carpentry,caroling,carjacking,caritas,caregiver,cardiology,candlesticks,canasta,cain't,burro,burnin,bunking,bumming,bullwinkle,brummel,brooms,brews,breathin,braslow,bracing,botulism,boorish,bloodless,blayne,blatantly,blankie,bedbugs,becuase,barmaid,bared,baracus,banal,bakes,backpacks,attentions,atrocious,ativan,athame,asunder,astound,assuring,aspirins,asphyxiation,ashtrays,aryans,arnon,apprehension,applauding,anvil,antiquing,antidepressants,annoyingly,amputate,altruistic,alotta,alerting,afterthought,affront,affirm,actuality,abysmal,absentee,yeller,yakushova,wuzzy,wriggle,worrier,woogyman,womanizer,windpipe,windbag,willin,whisking,whimsy,wendall,weeny,weensy,weasels,watery,watcha,wasteful,waski,washcloth,waaay,vouched,viznick,ventriloquist,vendettas,veils,vayhue,vamanos,vadimus,upstage,uppity,unsaid,unlocking,unintentionally,undetected,undecided,uncaring,unbearably,tween,tryout,trotting,trini,trimmings,trickier,treatin,treadstone,trashcan,transcendent,tramps,townsfolk,torturous,torrid,toothpicks,tolerable,tireless,tiptoeing,timmay,tillinghouse,tidying,tibia,thumbing,thrusters,thrashing,these'll,thatos,testicular,teriyaki,tenors,tenacity,tellers,telemetry,tarragon,switchblade,swicker,swells,sweatshirts,swatches,surging,supremely,sump'n,succumb,subsidize,stumbles,stuffs,stoppin,stipulate,stenographer,steamroll,stasis,stagger,squandered,splint,splendidly,splashy,splashing,specter,sorcerers,somewheres,somber,snuggled,snowmobile,sniffed,snags,smugglers,smudged,smirking,smearing,slings,sleet,sleepovers,sleek,slackers,siree,siphoning,singed,sincerest,sickened,shuffled,shriveled,shorthanded,shittin,shish,shipwrecked,shins,sheetrock,shawshank,shamu,sha're,servitude,sequins,seascape,scrapings,scoured,scorching,sandpaper,saluting,salud,ruffled,roughnecks,rougher,rosslyn,rosses,roost,roomy,romping,revolutionize,reprimanded,refute,refrigerated,reeled,redundancies,rectal,recklessly,receding,reassignment,reapers,readout,ration,raring,ramblings,raccoons,quarantined,purging,punters,psychically,premarital,pregnancies,predisposed,precautionary,pollute,podunk,plums,plaything,pixilated,pitting,piranhas,pieced,piddles,pickled,photogenic,phosphorous,pffft,pestilence,pessimist,perspiration,perps,penticoff,passageways,pardons,panics,pancamo,paleontologist,overwhelms,overstating,overpaid,overdid,outlive,orthodontist,orgies,oreos,ordover,ordinates,ooooooh,oooohhh,omelettes,officiate,obtuse,obits,nymph,novocaine,noooooooooo,nipping,nilly,nightstick,negate,neatness,natured,narcotic,narcissism,namun,nakatomi,murky,muchacho,mouthwash,motzah,morsel,morph,morlocks,mooch,moloch,molest,mohra,modus,modicum,mockolate,misdemeanors,miscalculation,middies,meringue,mercilessly,meditating,mayakovsky,maximillian,marlee,markovski,maniacal,maneuvered,magnificence,maddening,lutze,lunged,lovelies,lorry,loosening,lookee,littered,lilac,lightened,laces,kurzon,kurtzweil,kind've,kimono,kenji,kembu,keanu,kazuo,jonesing,jilted,jiggling,jewelers,jewbilee,jacqnoud,jacksons,ivories,insurmountable,innocuous,innkeeper,infantery,indulged,indescribable,incoherent,impervious,impertinent,imperfections,hunnert,huffy,horsies,horseradish,hollowed,hogwash,hockley,hissing,hiromitsu,hidin,hereafter,helpmann,hehehe,haughty,happenings,hankie,handsomely,halliwells,haklar,haise,gunsights,grossly,grope,grocer,grits,gripping,grabby,glorificus,gizzard,gilardi,gibarian,geminon,gasses,garnish,galloping,gairwyn,futterman,futility,fumigated,fruitless,friendless,freon,foregone,forego,floored,flighty,flapjacks,fizzled,ficus,festering,farbman,fabricate,eyghon,extricate,exalted,eventful,esophagus,enterprising,entail,endor,emphatically,embarrasses,electroshock,easel,duffle,drumsticks,dissection,dissected,disposing,disparaging,disorientation,disintegrated,disarming,devoting,dessaline,deprecating,deplorable,delve,degenerative,deduct,decomposed,deathly,dearie,daunting,dankova,cyclotron,cyberspace,cutbacks,culpable,cuddled,crumpets,cruelly,crouching,cranium,cramming,cowering,couric,cordesh,conversational,conclusively,clung,clotting,cleanest,chipping,chimpanzee,chests,cheapen,chainsaws,censure,catapult,caravaggio,carats,captivating,calrissian,butlers,busybody,bussing,bunion,bulimic,budging,brung,browbeat,brokenhearted,brecher,breakdowns,bracebridge,boning,blowhard,blisters,blackboard,bigotry,bialy,bhamra,bended,begat,battering,baste,basquiat,barricaded,barometer,balled,baited,badenweiler,backhand,ascenscion,argumentative,appendicitis,apparition,anxiously,antagonistic,angora,anacott,amniotic,ambience,alonna,aleck,akashic,ageless,abouts,aawwww,aaaaarrrrrrggghhh,aaaaaa,zendi,yuppies,yodel,y'hear,wrangle,wombosi,wittle,withstanding,wisecracks,wiggling,wierd,whittlesley,whipper,whattya,whatsamatter,whatchamacallit,whassup,whad'ya,weakling,warfarin,waponis,wampum,wadn't,vorash,vizzini,virtucon,viridiana,veracity,ventilated,varicose,varcon,vandalized,vamos,vamoose,vaccinated,vacationing,usted,urinal,uppers,unwittingly,unsealed,unplanned,unhinged,unhand,unfathomable,unequivocally,unbreakable,unadvisedly,udall,tynacorp,tuxes,tussle,turati,tunic,tsavo,trussed,troublemakers,trollop,tremors,transsexual,transfusions,toothbrushes,toned,toddlers,tinted,tightened,thundering,thorpey,this'd,thespian,thaddius,tenuous,tenths,tenement,telethon,teleprompter,teaspoon,taunted,tattle,tardiness,taraka,tappy,tapioca,tapeworm,talcum,tacks,swivel,swaying,superpower,summarize,sumbitch,sultry,suburbia,styrofoam,stylings,strolls,strobe,stockpile,stewardesses,sterilized,sterilize,stealin,stakeouts,squawk,squalor,squabble,sprinkled,sportsmanship,spokes,spiritus,sparklers,spareribs,sowing,sororities,sonovabitch,solicit,softy,softness,softening,snuggling,snatchers,snarling,snarky,snacking,smears,slumped,slowest,slithering,sleazebag,slayed,slaughtering,skidded,skated,sivapathasundaram,sissies,silliness,silences,sidecar,sicced,shylock,shtick,shrugged,shriek,shoves,should'a,shortcake,shockingly,shirking,shaves,shatner,sharpener,shapely,shafted,sexless,septum,selflessness,seabea,scuff,screwball,scoping,scooch,scolding,schnitzel,schemed,scalper,santy,sankara,sanest,salesperson,sakulos,safehouse,sabers,runes,rumblings,rumbling,ruijven,ringers,righto,rhinestones,retrieving,reneging,remodelling,relentlessly,regurgitate,refills,reeking,reclusive,recklessness,recanted,ranchers,rafer,quaking,quacks,prophesied,propensity,profusely,problema,prided,prays,postmark,popsicles,poodles,pollyanna,polaroids,pokes,poconos,pocketful,plunging,plugging,pleeease,platters,pitied,pinetti,piercings,phooey,phonies,pestering,periscope,pentagram,pelts,patronized,paramour,paralyze,parachutes,pales,paella,paducci,owatta,overdone,overcrowded,overcompensating,ostracized,ordinate,optometrist,operandi,omens,okayed,oedipal,nuttier,nuptial,nunheim,noxious,nourish,notepad,nitroglycerin,nibblet,neuroses,nanosecond,nabbit,mythic,munchkins,multimillion,mulroney,mucous,muchas,mountaintop,morlin,mongorians,moneybags,mom'll,molto,mixup,misgivings,mindset,michalchuk,mesmerized,merman,mensa,meaty,mbwun,materialize,materialistic,masterminded,marginally,mapuhe,malfunctioning,magnify,macnamara,macinerney,machinations,macadamia,lysol,lurks,lovelorn,lopsided,locator,litback,litany,linea,limousines,limes,lighters,liebkind,levity,levelheaded,letterhead,lesabre,leron,lepers,lefts,leftenant,laziness,layaway,laughlan,lascivious,laryngitis,lapsed,landok,laminated,kurten,kobol,knucklehead,knowed,knotted,kirkeby,kinsa,karnovsky,jolla,jimson,jettison,jeric,jawed,jankis,janitors,jango,jalopy,jailbreak,jackers,jackasses,invalidate,intercepting,intercede,insinuations,infertile,impetuous,impaled,immerse,immaterial,imbeciles,imagines,idyllic,idolized,icebox,i'd've,hypochondriac,hyphen,hurtling,hurried,hunchback,hullo,horsting,hoooo,homeboys,hollandaise,hoity,hijinks,hesitates,herrero,herndorff,helplessly,heeyy,heathen,hearin,headband,harrassment,harpies,halstrom,hahahahaha,hacer,grumbling,grimlocks,grift,greets,grandmothers,grander,grafts,gordievsky,gondorff,godorsky,glscripts,gaudy,gardeners,gainful,fuses,fukienese,frizzy,freshness,freshening,fraught,frantically,foxbooks,fortieth,forked,foibles,flunkies,fleece,flatbed,fisted,firefight,fingerpaint,filibuster,fhloston,fenceline,femur,fatigues,fanucci,fantastically,familiars,falafel,fabulously,eyesore,expedient,ewwww,eviscerated,erogenous,epidural,enchante,embarassed,embarass,embalming,elude,elspeth,electrocute,eigth,eggshell,echinacea,eases,earpiece,earlobe,dumpsters,dumbshit,dumbasses,duloc,duisberg,drummed,drinkers,dressy,dorma,doily,divvy,diverting,dissuade,disrespecting,displace,disorganized,disgustingly,discord,disapproving,diligence,didja,diced,devouring,detach,destructing,desolate,demerits,delude,delirium,degrade,deevak,deemesa,deductions,deduce,debriefed,deadbeats,dateline,darndest,damnable,dalliance,daiquiri,d'agosta,cussing,cryss,cripes,cretins,crackerjack,cower,coveting,couriers,countermission,cotswolds,convertibles,conversationalist,consorting,consoled,consarn,confides,confidentially,commited,commiserate,comme,comforter,comeuppance,combative,comanches,colosseum,colling,coexist,coaxing,cliffside,chutes,chucked,chokes,childlike,childhoods,chickening,chenowith,charmingly,changin,catsup,captioning,capsize,cappucino,capiche,candlewell,cakewalk,cagey,caddie,buxley,bumbling,bulky,buggered,brussel,brunettes,brumby,brotha,bronck,brisket,bridegroom,braided,bovary,bookkeeper,bluster,bloodline,blissfully,blase,billionaires,bicker,berrisford,bereft,berating,berate,bendy,belive,belated,beikoku,beens,bedspread,bawdy,barreling,baptize,banya,balthazar,balmoral,bakshi,bails,badgered,backstreet,awkwardly,auras,attuned,atheists,astaire,assuredly,arrivederci,appetit,appendectomy,apologetic,antihistamine,anesthesiologist,amulets,albie,alarmist,aiight,adstream,admirably,acquaint,abound,abominable,aaaaaaah,zekes,zatunica,wussy,worded,wooed,woodrell,wiretap,windowsill,windjammer,windfall,whisker,whims,whatiya,whadya,weirdly,weenies,waunt,washout,wanto,waning,victimless,verdad,veranda,vandaley,vancomycin,valise,vaguest,upshot,unzip,unwashed,untrained,unstuck,unprincipled,unmentionables,unjustly,unfolds,unemployable,uneducated,unduly,undercut,uncovering,unconsciousness,unconsciously,tyndareus,turncoat,turlock,tulle,tryouts,trouper,triplette,trepkos,tremor,treeger,trapeze,traipse,tradeoff,trach,torin,tommorow,tollan,toity,timpani,thumbprint,thankless,tell'em,telepathy,telemarketing,telekinesis,teevee,teeming,tarred,tambourine,talentless,swooped,switcheroo,swirly,sweatpants,sunstroke,suitors,sugarcoat,subways,subterfuge,subservient,subletting,stunningly,strongbox,striptease,stravanavitch,stradling,stoolie,stodgy,stocky,stifle,stealer,squeezes,squatter,squarely,sprouted,spool,spindly,speedos,soups,soundly,soulmates,somebody'll,soliciting,solenoid,sobering,snowflakes,snowballs,snores,slung,slimming,skulk,skivvies,skewered,skewer,sizing,sistine,sidebar,sickos,shushing,shunt,shugga,shone,shol'va,sharpened,shapeshifter,shadowing,shadoe,selectman,sefelt,seared,scrounging,scribbling,scooping,scintillating,schmoozing,scallops,sapphires,sanitarium,sanded,safes,rudely,roust,rosebush,rosasharn,rondell,roadhouse,riveted,rewrote,revamp,retaliatory,reprimand,replicators,replaceable,remedied,relinquishing,rejoicing,reincarnated,reimbursed,reevaluate,redid,redefine,recreating,reconnected,rebelling,reassign,rearview,rayne,ravings,ratso,rambunctious,radiologist,quiver,quiero,queef,qualms,pyrotechnics,pulsating,psychosomatic,proverb,promiscuous,profanity,prioritize,preying,predisposition,precocious,precludes,prattling,prankster,povich,potting,postpartum,porridge,polluting,plowing,pistachio,pissin,pickpocket,physicals,peruse,pertains,personified,personalize,perjured,perfecting,pepys,pepperdine,pembry,peering,peels,pedophile,patties,passkey,paratrooper,paraphernalia,paralyzing,pandering,paltry,palpable,pagers,pachyderm,overstay,overestimated,overbite,outwit,outgrow,outbid,ooops,oomph,oohhh,oldie,obliterate,objectionable,nygma,notting,noches,nitty,nighters,newsstands,newborns,neurosurgery,nauseated,nastiest,narcolepsy,mutilate,muscled,murmur,mulva,mulling,mukada,muffled,morgues,moonbeams,monogamy,molester,molestation,molars,moans,misprint,mismatched,mirth,mindful,mimosas,millander,mescaline,menstrual,menage,mellowing,medevac,meddlesome,matey,manicures,malevolent,madmen,macaroons,lydell,lycra,lunchroom,lunching,lozenges,looped,litigious,liquidate,linoleum,lingk,limitless,limber,lilacs,ligature,liftoff,lemmiwinks,leggo,learnin,lazarre,lawyered,lactose,knelt,kenosha,kemosabe,jussy,junky,jordy,jimmies,jeriko,jakovasaur,issacs,isabela,irresponsibility,ironed,intoxication,insinuated,inherits,ingest,ingenue,inflexible,inflame,inevitability,inedible,inducement,indignant,indictments,indefensible,incomparable,incommunicado,improvising,impounded,illogical,ignoramus,hydrochloric,hydrate,hungover,humorless,humiliations,hugest,hoverdrone,hovel,hmmph,hitchhike,hibernating,henchman,helloooo,heirlooms,heartsick,headdress,hatches,harebrained,hapless,hanen,handsomer,hallows,habitual,guten,gummy,guiltier,guidebook,gstaad,gruff,griss,grieved,grata,gorignak,goosed,goofed,glowed,glitz,glimpses,glancing,gilmores,gianelli,geraniums,garroway,gangbusters,gamblers,galls,fuddy,frumpy,frowning,frothy,fro'tak,frere,fragrances,forgettin,follicles,flowery,flophouse,floatin,flirts,flings,flatfoot,fingerprinting,fingerprinted,fingering,finald,fillet,fianc,femoral,federales,fawkes,fascinates,farfel,fambly,falsified,fabricating,exterminators,expectant,excusez,excrement,excercises,evian,etins,esophageal,equivalency,equate,equalizer,entrees,enquire,endearment,empathetic,emailed,eggroll,earmuffs,dyslexic,duper,duesouth,drunker,druggie,dreadfully,dramatics,dragline,downplay,downers,dominatrix,doers,docket,docile,diversify,distracts,disloyalty,disinterested,discharging,disagreeable,dirtier,dinghy,dimwitted,dimoxinil,dimmy,diatribe,devising,deviate,detriment,desertion,depressants,depravity,deniability,delinquents,defiled,deepcore,deductive,decimate,deadbolt,dauthuille,dastardly,daiquiris,daggers,dachau,curiouser,curdled,cucamonga,cruller,cruces,crosswalk,crinkle,crescendo,cremate,counseled,couches,cornea,corday,copernicus,contrition,contemptible,constipated,conjoined,confounded,condescend,concoct,conch,compensating,committment,commandeered,comely,coddled,cockfight,cluttered,clunky,clownfish,cloaked,clenched,cleanin,civilised,circumcised,cimmeria,cilantro,chutzpah,chucking,chiseled,chicka,chattering,cervix,carrey,carpal,carnations,cappuccinos,candied,calluses,calisthenics,bushy,burners,budington,buchanans,brimming,braids,boycotting,bouncers,botticelli,botherin,bookkeeping,bogyman,bogged,bloodthirsty,blintzes,blanky,binturong,billable,bigboote,bewildered,betas,bequeath,behoove,befriend,bedpost,bedded,baudelaires,barreled,barboni,barbeque,bangin,baltus,bailout,backstabber,baccarat,awning,augie,arguillo,archway,apricots,apologising,annyong,anchorman,amenable,amazement,allspice,alannis,airfare,airbags,ahhhhhhhhh,ahhhhhhhh,ahhhhhhh,agitator,adrenal,acidosis,achoo,accessorizing,accentuate,abrasions,abductor,aaaahhh,aaaaaaaa,aaaaaaa,zeroing,zelner,zeldy,yevgeny,yeska,yellows,yeesh,yeahh,yamuri,wouldn't've,workmanship,woodsman,winnin,winked,wildness,whoring,whitewash,whiney,when're,wheezer,wheelman,wheelbarrow,westerburg,weeding,watermelons,washboard,waltzes,wafting,voulez,voluptuous,vitone,vigilantes,videotaping,viciously,vices,veruca,vermeer,verifying,vasculitis,valets,upholstered,unwavering,untold,unsympathetic,unromantic,unrecognizable,unpredictability,unmask,unleashing,unintentional,unglued,unequivocal,underrated,underfoot,unchecked,unbutton,unbind,unbiased,unagi,uhhhhh,tugging,triads,trespasses,treehorn,traviata,trappers,transplants,trannie,tramping,tracheotomy,tourniquet,tooty,toothless,tomarrow,toasters,thruster,thoughtfulness,thornwood,tengo,tenfold,telltale,telephoto,telephoned,telemarketer,tearin,tastic,tastefully,tasking,taser,tamed,tallow,taketh,taillight,tadpoles,tachibana,syringes,sweated,swarthy,swagger,surges,supermodels,superhighway,sunup,sun'll,sulfa,sugarless,sufficed,subside,strolled,stringy,strengthens,straightest,straightens,storefront,stopper,stockpiling,stimulant,stiffed,steyne,sternum,stepladder,stepbrother,steers,steelheads,steakhouse,stathis,stankylecartmankennymr,standoffish,stalwart,squirted,spritz,sprig,sprawl,spousal,sphincter,spenders,spearmint,spatter,spangled,southey,soured,sonuvabitch,somethng,snuffed,sniffs,smokescreen,smilin,slobs,sleepwalker,sleds,slays,slayage,skydiving,sketched,skanks,sixed,siphoned,siphon,simpering,sigfried,sidearm,siddons,sickie,shuteye,shuffleboard,shrubberies,shrouded,showmanship,shouldn't've,shoplift,shiatsu,sentries,sentance,sensuality,seething,secretions,searing,scuttlebutt,sculpt,scowling,scouring,scorecard,schoolers,schmucks,scepters,scaly,scalps,scaffolding,sauces,sartorius,santen,salivating,sainthood,saget,saddens,rygalski,rusting,ruination,rueland,rudabaga,rottweiler,roofies,romantics,rollerblading,roldy,roadshow,rickets,rible,rheza,revisiting,retentive,resurface,restores,respite,resounding,resorting,resists,repulse,repressing,repaying,reneged,refunds,rediscover,redecorated,reconstructive,recommitted,recollect,receptacle,reassess,reanimation,realtors,razinin,rationalization,ratatouille,rashum,rasczak,rancheros,rampler,quizzing,quips,quartered,purring,pummeling,puede,proximo,prospectus,pronouncing,prolonging,procreation,proclamations,principled,prides,preoccupation,prego,precog,prattle,pounced,potshots,potpourri,porque,pomegranates,polenta,plying,pluie,plesac,playmates,plantains,pillowcase,piddle,pickers,photocopied,philistine,perpetuate,perpetually,perilous,pawned,pausing,pauper,parter,parlez,parlay,pally,ovulation,overtake,overstate,overpowering,overpowered,overconfident,overbooked,ovaltine,outweighs,outings,ottos,orrin,orifice,orangutan,oopsy,ooooooooh,oooooo,ooohhhh,ocular,obstruct,obscenely,o'dwyer,nutjob,nunur,notifying,nostrand,nonny,nonfat,noblest,nimble,nikes,nicht,newsworthy,nestled,nearsighted,ne'er,nastier,narco,nakedness,muted,mummified,mudda,mozzarella,moxica,motivator,motility,mothafucka,mortmain,mortgaged,mores,mongers,mobbed,mitigating,mistah,misrepresented,mishke,misfortunes,misdirection,mischievous,mineshaft,millaney,microwaves,metzenbaum,mccovey,masterful,masochistic,marliston,marijawana,manya,mantumbi,malarkey,magnifique,madrona,madox,machida,m'hidi,lullabies,loveliness,lotions,looka,lompoc,litterbug,litigator,lithe,liquorice,linds,limericks,lightbulb,lewises,letch,lemec,layover,lavatory,laurels,lateness,laparotomy,laboring,kuato,kroff,krispy,krauts,knuckleheads,kitschy,kippers,kimbrow,keypad,keepsake,kebab,karloff,junket,judgemental,jointed,jezzie,jetting,jeeze,jeeter,jeesus,jeebs,janeane,jails,jackhammer,ixnay,irritates,irritability,irrevocable,irrefutable,irked,invoking,intricacies,interferon,intents,insubordinate,instructive,instinctive,inquisitive,inlay,injuns,inebriated,indignity,indecisive,incisors,incacha,inalienable,impresses,impregnate,impregnable,implosion,idolizes,hypothyroidism,hypoglycemic,huseni,humvee,huddling,honing,hobnobbing,hobnob,histrionics,histamine,hirohito,hippocratic,hindquarters,hikita,hikes,hightailed,hieroglyphics,heretofore,herbalist,hehey,hedriks,heartstrings,headmistress,headlight,hardheaded,happend,handlebars,hagitha,habla,gyroscope,guys'd,guy'd,guttersnipe,grump,growed,grovelling,groan,greenbacks,gravedigger,grating,grasshoppers,grandiose,grandest,grafted,gooood,goood,gooks,godsakes,goaded,glamorama,giveth,gingham,ghostbusters,germane,georgy,gazzo,gazelles,gargle,garbled,galgenstein,gaffe,g'day,fyarl,furnish,furies,fulfills,frowns,frowned,frighteningly,freebies,freakishly,forewarned,foreclose,forearms,fordson,fonics,flushes,flitting,flemmer,flabby,fishbowl,fidgeting,fevers,feigning,faxing,fatigued,fathoms,fatherless,fancier,fanatical,factored,eyelid,eyeglasses,expresso,expletive,expectin,excruciatingly,evidentiary,ever'thing,eurotrash,eubie,estrangement,erlich,epitome,entrap,enclose,emphysema,embers,emasculating,eighths,eardrum,dyslexia,duplicitous,dumpty,dumbledore,dufus,duddy,duchamp,drunkenness,drumlin,drowns,droid,drinky,drifts,drawbridge,dramamine,douggie,douchebag,dostoyevsky,doodling,don'tcha,domineering,doings,dogcatcher,doctoring,ditzy,dissimilar,dissecting,disparage,disliking,disintegrating,dishwalla,dishonored,dishing,disengaged,disavowed,dippy,diorama,dimmed,dilate,digitalis,diggory,dicing,diagnosing,devola,desolation,dennings,denials,deliverance,deliciously,delicacies,degenerates,degas,deflector,defile,deference,decrepit,deciphered,dawdle,dauphine,daresay,dangles,dampen,damndest,cucumbers,cucaracha,cryogenically,croaks,croaked,criticise,crisper,creepiest,creams,crackle,crackin,covertly,counterintelligence,corrosive,cordially,cops'll,convulsions,convoluted,conversing,conga,confrontational,confab,condolence,condiments,complicit,compiegne,commodus,comings,cometh,collusion,collared,cockeyed,clobber,clemonds,clarithromycin,cienega,christmasy,christmassy,chloroform,chippie,chested,cheeco,checklist,chauvinist,chandlers,chambermaid,chakras,cellophane,caveat,cataloguing,cartmanland,carples,carny,carded,caramels,cappy,caped,canvassing,callback,calibrated,calamine,buttermilk,butterfingers,bunsen,bulimia,bukatari,buildin,budged,brobich,bringer,brendell,brawling,bratty,braised,boyish,boundless,botch,boosh,bookies,bonbons,bodes,bobunk,bluntly,blossoming,bloomers,bloodstains,bloodhounds,blech,biter,biometric,bioethics,bijan,bigoted,bicep,bereaved,bellowing,belching,beholden,beached,batmobile,barcodes,barch,barbecuing,bandanna,backwater,backtrack,backdraft,augustino,atrophy,atrocity,atley,atchoo,asthmatic,assoc,armchair,arachnids,aptly,appetizing,antisocial,antagonizing,anorexia,anini,andersons,anagram,amputation,alleluia,airlock,aimless,agonized,agitate,aggravating,aerosol,acing,accomplishing,accidently,abuser,abstain,abnormally,aberration,aaaaahh,zlotys,zesty,zerzura,zapruder,zantopia,yelburton,yeess,y'knowwhati'msayin,wwhat,wussies,wrenched,would'a,worryin,wormser,wooooo,wookiee,wolchek,wishin,wiseguys,windbreaker,wiggy,wieners,wiedersehen,whoopin,whittled,wherefore,wharvey,welts,wellstone,wedges,wavered,watchit,wastebasket,wango,waken,waitressed,wacquiem,vrykolaka,voula,vitally,visualizing,viciousness,vespers,vertes,verily,vegetarians,vater,vaporize,vannacutt,vallens,ussher,urinating,upping,unwitting,untangle,untamed,unsanitary,unraveled,unopened,unisex,uninvolved,uninteresting,unintelligible,unimaginative,undeserving,undermines,undergarments,unconcerned,tyrants,typist,tykes,tybalt,twosome,twits,tutti,turndown,tularemia,tuberculoma,tsimshian,truffaut,truer,truant,trove,triumphed,tripe,trigonometry,trifled,trifecta,tribulations,tremont,tremoille,transcends,trafficker,touchin,tomfoolery,tinkered,tinfoil,tightrope,thousan,thoracotomy,thesaurus,thawing,thatta,tessio,temps,taxidermist,tator,tachycardia,t'akaya,swelco,sweetbreads,swatting,supercollider,sunbathing,summarily,suffocation,sueleen,succinct,subsided,submissive,subjecting,subbing,subatomic,stupendous,stunted,stubble,stubbed,streetwalker,strategizing,straining,straightaway,stoli,stiffer,stickup,stens,steamroller,steadwell,steadfast,stateroom,stans,sshhhh,squishing,squinting,squealed,sprouting,sprimp,spreadsheets,sprawled,spotlights,spooning,spirals,speedboat,spectacles,speakerphone,southglen,souse,soundproof,soothsayer,sommes,somethings,solidify,soars,snorted,snorkeling,snitches,sniping,snifter,sniffin,snickering,sneer,snarl,smila,slinking,slanted,slanderous,slammin,skimp,skilosh,siteid,sirloin,singe,sighing,sidekicks,sicken,showstopper,shoplifter,shimokawa,sherborne,shavadai,sharpshooters,sharking,shagged,shaddup,senorita,sesterces,sensuous,seahaven,scullery,scorcher,schotzie,schnoz,schmooze,schlep,schizo,scents,scalping,scalped,scallop,scalding,sayeth,saybrooke,sawed,savoring,sardine,sandstorm,sandalwood,salutations,sagman,s'okay,rsvp'd,rousted,rootin,romper,romanovs,rollercoaster,rolfie,robinsons,ritzy,ritualistic,ringwald,rhymed,rheingold,rewrites,revoking,reverts,retrofit,retort,retinas,respirations,reprobate,replaying,repaint,renquist,renege,relapsing,rekindled,rejuvenating,rejuvenated,reinstating,recriminations,rechecked,reassemble,rears,reamed,reacquaint,rayanne,ravish,rathole,raspail,rarest,rapists,rants,racketeer,quittin,quitters,quintessential,queremos,quellek,quelle,quasimodo,pyromaniac,puttanesca,puritanical,purer,puree,pungent,pummel,puedo,psychotherapist,prosecutorial,prosciutto,propositioning,procrastination,probationary,primping,preventative,prevails,preservatives,preachy,praetorians,practicality,powders,potus,postop,positives,poser,portolano,portokalos,poolside,poltergeists,pocketed,poach,plummeted,plucking,plimpton,playthings,plastique,plainclothes,pinpointed,pinkus,pinks,pigskin,piffle,pictionary,piccata,photocopy,phobias,perignon,perfumes,pecks,pecked,patently,passable,parasailing,paramus,papier,paintbrush,pacer,paaiint,overtures,overthink,overstayed,overrule,overestimate,overcooked,outlandish,outgrew,outdoorsy,outdo,orchestrate,oppress,opposable,oooohh,oomupwah,okeydokey,okaaay,ohashi,of'em,obscenities,oakie,o'gar,nurection,nostradamus,norther,norcom,nooch,nonsensical,nipped,nimbala,nervously,neckline,nebbleman,narwhal,nametag,n'n't,mycenae,muzak,muumuu,mumbled,mulvehill,muggings,muffet,mouthy,motivates,motaba,moocher,mongi,moley,moisturize,mohair,mocky,mmkay,mistuh,missis,misdeeds,mincemeat,miggs,miffed,methadone,messieur,menopausal,menagerie,mcgillicuddy,mayflowers,matrimonial,matick,masai,marzipan,maplewood,manzelle,mannequins,manhole,manhandle,malfunctions,madwoman,machiavelli,lynley,lynched,lurconis,lujack,lubricant,looove,loons,loofah,lonelyhearts,lollipops,lineswoman,lifers,lexter,lepner,lemony,leggy,leafy,leadeth,lazerus,lazare,lawford,languishing,lagoda,ladman,kundera,krinkle,krendler,kreigel,kowolski,knockdown,knifed,kneed,kneecap,kids'll,kennie,kenmore,keeled,kazootie,katzenmoyer,kasdan,karak,kapowski,kakistos,julyan,jockstrap,jobless,jiggly,jaunt,jarring,jabbering,irrigate,irrevocably,irrationally,ironies,invitro,intimated,intently,intentioned,intelligently,instill,instigator,instep,inopportune,innuendoes,inflate,infects,infamy,indiscretions,indiscreet,indio,indignities,indict,indecision,inconspicuous,inappropriately,impunity,impudent,impotence,implicates,implausible,imperfection,impatience,immutable,immobilize,idealist,iambic,hysterically,hyperspace,hygienist,hydraulics,hydrated,huzzah,husks,hunched,huffed,hubris,hubbub,hovercraft,houngan,hosed,horoscopes,hopelessness,hoodwinked,honorably,honeysuckle,homegirl,holiest,hippity,hildie,hieroglyphs,hexton,herein,heckle,heaping,healthilizer,headfirst,hatsue,harlot,hardwired,halothane,hairstyles,haagen,haaaaa,gutting,gummi,groundless,groaning,gristle,grills,graynamore,grabbin,goodes,goggle,glittering,glint,gleaming,glassy,girth,gimbal,giblets,gellers,geezers,geeze,garshaw,gargantuan,garfunkel,gangway,gandarium,gamut,galoshes,gallivanting,gainfully,gachnar,fusionlips,fusilli,furiously,frugal,fricking,frederika,freckling,frauds,fountainhead,forthwith,forgo,forgettable,foresight,foresaw,fondling,fondled,fondle,folksy,fluttering,fluffing,floundering,flirtatious,flexing,flatterer,flaring,fixating,finchy,figurehead,fiendish,fertilize,ferment,fending,fellahs,feelers,fascinate,fantabulous,falsify,fallopian,faithless,fairer,fainter,failings,facetious,eyepatch,exxon,extraterrestrials,extradite,extracurriculars,extinguish,expunged,expelling,exorbitant,exhilarated,exertion,exerting,excercise,everbody,evaporated,escargot,escapee,erases,epizootics,epithelials,ephrum,entanglements,enslave,engrossed,emphatic,emeralds,ember,emancipated,elevates,ejaculate,effeminate,eccentricities,easygoing,earshot,dunks,dullness,dulli,dulled,drumstick,dropper,driftwood,dregs,dreck,dreamboat,draggin,downsizing,donowitz,dominoes,diversions,distended,dissipate,disraeli,disqualify,disowned,dishwashing,disciplining,discerning,disappoints,dinged,digested,dicking,detonating,despising,depressor,depose,deport,dents,defused,deflecting,decryption,decoys,decoupage,decompress,decibel,decadence,deafening,dawning,dater,darkened,dappy,dallying,dagon,czechoslovakians,cuticles,cuteness,cupboards,culottes,cruisin,crosshairs,cronyn,criminalistics,creatively,creaming,crapping,cranny,cowed,contradicting,constipation,confining,confidences,conceiving,conceivably,concealment,compulsively,complainin,complacent,compels,communing,commode,comming,commensurate,columnists,colonoscopy,colchicine,coddling,clump,clubbed,clowning,cliffhanger,clang,cissy,choosers,choker,chiffon,channeled,chalet,cellmates,cathartic,caseload,carjack,canvass,canisters,candlestick,candlelit,camry,calzones,calitri,caldy,byline,butterball,bustier,burlap,bureaucrat,buffoons,buenas,brookline,bronzed,broiled,broda,briss,brioche,briar,breathable,brays,brassieres,boysenberry,bowline,boooo,boonies,booklets,bookish,boogeyman,boogey,bogas,boardinghouse,bluuch,blundering,bluer,blowed,blotchy,blossomed,bloodwork,bloodied,blithering,blinks,blathering,blasphemous,blacking,birdson,bings,bfmid,bfast,bettin,berkshires,benjamins,benevolence,benched,benatar,bellybutton,belabor,behooves,beddy,beaujolais,beattle,baxworth,baseless,barfing,bannish,bankrolled,banek,ballsy,ballpoint,baffling,badder,badda,bactine,backgammon,baako,aztreonam,authoritah,auctioning,arachtoids,apropos,aprons,apprised,apprehensive,anythng,antivenin,antichrist,anorexic,anoint,anguished,angioplasty,angio,amply,ampicillin,amphetamines,alternator,alcove,alabaster,airlifted,agrabah,affidavits,admonished,admonish,addled,addendum,accuser,accompli,absurdity,absolved,abrusso,abreast,aboot,abductions,abducting,aback,ababwa,aaahhhh,zorin,zinthar,zinfandel,zillions,zephyrs,zatarcs,zacks,youuu,yokels,yardstick,yammer,y'understand,wynette,wrung,wreaths,wowed,wouldn'ta,worming,wormed,workday,woodsy,woodshed,woodchuck,wojadubakowski,withering,witching,wiseass,wiretaps,wining,willoby,wiccaning,whupped,whoopi,whoomp,wholesaler,whiteness,whiner,whatchya,wharves,wenus,weirdoes,weaning,watusi,waponi,waistband,wackos,vouching,votre,vivica,viveca,vivant,vivacious,visor,visitin,visage,vicrum,vetted,ventriloquism,venison,varnsen,vaporized,vapid,vanstock,uuuuh,ushering,urologist,urination,upstart,uprooted,unsubtitled,unspoiled,unseat,unseasonably,unseal,unsatisfying,unnerve,unlikable,unleaded,uninsured,uninspired,unicycle,unhooked,unfunny,unfreezing,unflattering,unfairness,unexpressed,unending,unencumbered,unearth,undiscovered,undisciplined,understan,undershirt,underlings,underline,undercurrent,uncivilized,uncharacteristic,umpteenth,uglies,tuney,trumps,truckasaurus,trubshaw,trouser,tringle,trifling,trickster,trespassers,trespasser,traumas,trattoria,trashes,transgressions,trampling,tp'ed,toxoplasmosis,tounge,tortillas,topsy,topple,topnotch,tonsil,tions,timmuh,timithious,tilney,tighty,tightness,tightens,tidbits,ticketed,thyme,threepio,thoughtfully,thorkel,thommo,thing'll,thefts,that've,thanksgivings,tetherball,testikov,terraforming,tepid,tendonitis,tenboom,telex,teenybopper,tattered,tattaglias,tanneke,tailspin,tablecloth,swooping,swizzle,swiping,swindled,swilling,swerving,sweatshops,swaddling,swackhammer,svetkoff,supossed,superdad,sumptuous,sugary,sugai,subvert,substantiate,submersible,sublimating,subjugation,stymied,strychnine,streetlights,strassmans,stranglehold,strangeness,straddling,straddle,stowaways,stotch,stockbrokers,stifling,stepford,steerage,steena,statuary,starlets,staggeringly,ssshhh,squaw,spurt,spungeon,spritzer,sprightly,sprays,sportswear,spoonful,splittin,splitsville,speedily,specialise,spastic,sparrin,souvlaki,southie,sourpuss,soupy,soundstage,soothes,somebody'd,softest,sociopathic,socialized,snyders,snowmobiles,snowballed,snatches,smugness,smoothest,smashes,sloshed,sleight,skyrocket,skied,skewed,sixpence,sipowicz,singling,simulates,shyness,shuvanis,showoff,shortsighted,shopkeeper,shoehorn,shithouse,shirtless,shipshape,shifu,shelve,shelbyville,sheepskin,sharpens,shaquille,shanshu,servings,sequined,seizes,seashells,scrambler,scopes,schnauzer,schmo,schizoid,scampered,savagely,saudis,santas,sandovals,sanding,saleswoman,sagging,s'cuse,rutting,ruthlessly,runneth,ruffians,rubes,rosalita,rollerblades,rohypnol,roasts,roadies,ritten,rippling,ripples,rigoletto,richardo,rethought,reshoot,reserving,reseda,rescuer,reread,requisitions,repute,reprogram,replenish,repetitious,reorganizing,reinventing,reinvented,reheat,refrigerators,reenter,recruiter,recliner,rawdy,rashes,rajeski,raison,raisers,rages,quinine,questscape,queller,pygmalion,pushers,pusan,purview,pumpin,pubescent,prudes,provolone,propriety,propped,procrastinate,processional,preyed,pretrial,portent,pooling,poofy,polloi,policia,poacher,pluses,pleasuring,platitudes,plateaued,plaguing,pittance,pinheads,pincushion,pimply,pimped,piggyback,piecing,phillipe,philipse,philby,pharaohs,petyr,petitioner,peshtigo,pesaram,persnickety,perpetrate,percolating,pepto,penne,penell,pemmican,peeks,pedaling,peacemaker,pawnshop,patting,pathologically,patchouli,pasts,pasties,passin,parlors,paltrow,palamon,padlock,paddling,oversleep,overheating,overdosed,overcharge,overblown,outrageously,ornery,opportune,oooooooooh,oohhhh,ohhhhhh,ogres,odorless,obliterated,nyong,nymphomaniac,ntozake,novocain,nough,nonnie,nonissue,nodules,nightmarish,nightline,niceties,newsman,needra,nedry,necking,navour,nauseam,nauls,narim,namath,nagged,naboo,n'sync,myslexia,mutator,mustafi,musketeer,murtaugh,murderess,munching,mumsy,muley,mouseville,mortifying,morgendorffers,moola,montel,mongoloid,molestered,moldings,mocarbies,mo'ss,mixers,misrell,misnomer,misheard,mishandled,miscreant,misconceptions,miniscule,millgate,mettle,metricconverter,meteors,menorah,mengele,melding,meanness,mcgruff,mcarnold,matzoh,matted,mastectomy,massager,marveling,marooned,marmaduke,marick,manhandled,manatees,man'll,maltin,maliciously,malfeasance,malahide,maketh,makeovers,maiming,machismo,lumpectomy,lumbering,lucci,lording,lorca,lookouts,loogie,loners,loathed,lissen,lighthearted,lifer,lickin,lewen,levitation,lestercorp,lessee,lentils,legislate,legalizing,lederhosen,lawmen,lasskopf,lardner,lambeau,lamagra,ladonn,lactic,lacquer,labatier,krabappel,kooks,knickknacks,klutzy,kleynach,klendathu,kinross,kinkaid,kind'a,ketch,kesher,karikos,karenina,kanamits,junshi,jumbled,joust,jotted,jobson,jingling,jigalong,jerries,jellies,jeeps,javna,irresistable,internist,intercranial,inseminated,inquisitor,infuriate,inflating,infidelities,incessantly,incensed,incase,incapacitate,inasmuch,inaccuracies,imploding,impeding,impediments,immaturity,illegible,iditarod,icicles,ibuprofen,i'i'm,hymie,hydrolase,hunker,humps,humons,humidor,humdinger,humbling,huggin,huffing,housecleaning,hothouse,hotcakes,hosty,hootenanny,hootchie,hoosegow,honks,honeymooners,homily,homeopathic,hitchhikers,hissed,hillnigger,hexavalent,hewwo,hershe,hermey,hergott,henny,hennigans,henhouse,hemolytic,helipad,heifer,hebrews,hebbing,heaved,headlock,harrowing,harnessed,hangovers,handi,handbasket,halfrek,hacene,gyges,guys're,gundersons,gumption,gruntmaster,grubs,grossie,groped,grins,greaseball,gravesite,gratuity,granma,grandfathers,grandbaby,gradski,gracing,gossips,gooble,goners,golitsyn,gofer,godsake,goddaughter,gnats,gluing,glares,givers,ginza,gimmie,gimmee,gennero,gemme,gazpacho,gazed,gassy,gargling,gandhiji,galvanized,gallbladder,gaaah,furtive,fumigation,fucka,fronkonsteen,frills,freezin,freewald,freeloader,frailty,forger,foolhardy,fondest,fomin,followin,follicle,flotation,flopping,floodgates,flogged,flicked,flenders,fleabag,fixings,fixable,fistful,firewater,firelight,fingerbang,finalizing,fillin,filipov,fiderer,felling,feldberg,feign,faunia,fatale,farkus,fallible,faithfulness,factoring,eyeful,extramarital,exterminated,exhume,exasperated,eviscerate,estoy,esmerelda,escapades,epoxy,enticed,enthused,entendre,engrossing,endorphins,emptive,emmys,eminently,embezzler,embarressed,embarrassingly,embalmed,eludes,eling,elated,eirie,egotitis,effecting,eerily,eecom,eczema,earthy,earlobes,eally,dyeing,dwells,duvet,duncans,dulcet,droves,droppin,drools,drey'auc,downriver,domesticity,dollop,doesnt,dobler,divulged,diversionary,distancing,dispensers,disorienting,disneyworld,dismissive,disingenuous,disheveled,disfiguring,dinning,dimming,diligently,dilettante,dilation,dickensian,diaphragms,devastatingly,destabilize,desecrate,deposing,deniece,demony,delving,delicates,deigned,defraud,deflower,defibrillator,defiantly,defenceless,defacing,deconstruction,decompose,deciphering,decibels,deceptively,deceptions,decapitation,debutantes,debonair,deadlier,dawdling,davic,darwinism,darnit,darks,danke,danieljackson,dangled,cytoxan,cutout,cutlery,curveball,curfews,cummerbund,crunches,crouched,crisps,cripples,crilly,cribs,crewman,creepin,creeds,credenza,creak,crawly,crawlin,crawlers,crated,crackheads,coworker,couldn't've,corwins,coriander,copiously,convenes,contraceptives,contingencies,contaminating,conniption,condiment,concocting,comprehending,complacency,commendatore,comebacks,com'on,collarbone,colitis,coldly,coiffure,coffers,coeds,codependent,cocksucking,cockney,cockles,clutched,closeted,cloistered,cleve,cleats,clarifying,clapped,cinnabar,chunnel,chumps,cholinesterase,choirboy,chocolatey,chlamydia,chigliak,cheesie,chauvinistic,chasm,chartreuse,charo,charnier,chapil,chalked,chadway,certifiably,cellulite,celled,cavalcade,cataloging,castrated,cassio,cashews,cartouche,carnivore,carcinogens,capulet,captivated,capt'n,cancellations,campin,callate,callar,caffeinated,cadavers,cacophony,cackle,buzzes,buttoning,busload,burglaries,burbs,buona,bunions,bullheaded,buffs,bucyk,buckling,bruschetta,browbeating,broomsticks,broody,bromly,brolin,briefings,brewskies,breathalyzer,breakups,bratwurst,brania,braiding,brags,braggin,bradywood,bottomed,bossa,bordello,bookshelf,boogida,bondsman,bolder,boggles,bludgeoned,blowtorch,blotter,blips,blemish,bleaching,blainetologists,blading,blabbermouth,birdseed,bimmel,biloxi,biggly,bianchinni,betadine,berenson,belus,belloq,begets,befitting,beepers,beelzebub,beefed,bedridden,bedevere,beckons,beaded,baubles,bauble,battleground,bathrobes,basketballs,basements,barroom,barnacle,barkin,barked,baretta,bangles,bangler,banality,bambang,baltar,ballplayers,bagman,baffles,backroom,babysat,baboons,averse,audiotape,auctioneer,atten,atcha,astonishment,arugula,arroz,antihistamines,annoyances,anesthesiology,anatomically,anachronism,amiable,amaretto,allahu,alight,aimin,ailment,afterglow,affronte,advil,adrenals,actualization,acrost,ached,accursed,accoutrements,absconded,aboveboard,abetted,aargh,aaaahh,zuwicky,zolda,ziploc,zakamatak,youve,yippie,yesterdays,yella,yearns,yearnings,yearned,yawning,yalta,yahtzee,y'mean,y'are,wuthering,wreaks,worrisome,workiiing,wooooooo,wonky,womanizing,wolodarsky,wiwith,withdraws,wishy,wisht,wipers,wiper,winos,windthorne,windsurfing,windermere,wiggled,wiggen,whwhat,whodunit,whoaaa,whittling,whitesnake,whereof,wheezing,wheeze,whatd'ya,whataya,whammo,whackin,wellll,weightless,weevil,wedgies,webbing,weasly,wayside,waxes,waturi,washy,washrooms,wandell,waitaminute,waddya,waaaah,vornac,vishnoor,virulent,vindictiveness,vinceres,villier,vigeous,vestigial,ventilate,vented,venereal,veering,veered,veddy,vaslova,valosky,vailsburg,vaginas,vagas,urethra,upstaged,uploading,unwrapping,unwieldy,untapped,unsatisfied,unquenchable,unnerved,unmentionable,unlovable,unknowns,uninformed,unimpressed,unhappily,unguarded,unexplored,undergarment,undeniably,unclench,unclaimed,uncharacteristically,unbuttoned,unblemished,ululd,uhhhm,tweeze,tutsami,tushy,tuscarora,turkle,turghan,turbinium,tubers,trucoat,troxa,tropicana,triquetra,trimmers,triceps,trespassed,traya,traumatizing,transvestites,trainors,tradin,trackers,townies,tourelles,toucha,tossin,tortious,topshop,topes,tonics,tongs,tomsk,tomorrows,toiling,toddle,tizzy,tippers,timmi,thwap,thusly,ththe,thrusts,throwers,throwed,throughway,thickening,thermonuclear,thelwall,thataway,terrifically,tendons,teleportation,telepathically,telekinetic,teetering,teaspoons,tarantulas,tapas,tanned,tangling,tamales,tailors,tahitian,tactful,tachy,tablespoon,syrah,synchronicity,synch,synapses,swooning,switchman,swimsuits,sweltering,sweetly,suvolte,suslov,surfed,supposition,suppertime,supervillains,superfluous,superego,sunspots,sunning,sunless,sundress,suckah,succotash,sublevel,subbasement,studious,striping,strenuously,straights,stonewalled,stillness,stilettos,stevesy,steno,steenwyck,stargates,stammering,staedert,squiggly,squiggle,squashing,squaring,spreadsheet,spramp,spotters,sporto,spooking,splendido,spittin,spirulina,spiky,spate,spartacus,spacerun,soonest,something'll,someth,somepin,someone'll,sofas,soberly,sobered,snowmen,snowbank,snowballing,snivelling,sniffling,snakeskin,snagging,smush,smooter,smidgen,smackers,slumlord,slossum,slimmer,slighted,sleepwalk,sleazeball,skokie,skeptic,sitarides,sistah,sipped,sindell,simpletons,simony,silkwood,silks,silken,sightless,sideboard,shuttles,shrugging,shrouds,showy,shoveled,shouldn'ta,shoplifters,shitstorm,sheeny,shapetype,shaming,shallows,shackle,shabbily,shabbas,seppuku,senility,semite,semiautomatic,selznick,secretarial,sebacio,scuzzy,scummy,scrutinized,scrunchie,scribbled,scotches,scolded,scissor,schlub,scavenging,scarin,scarfing,scallions,scald,savour,savored,saute,sarcoidosis,sandbar,saluted,salish,saith,sailboats,sagittarius,sacre,saccharine,sacamano,rushdie,rumpled,rumba,rulebook,rubbers,roughage,rotisserie,rootie,roofy,roofie,romanticize,rittle,ristorante,rippin,rinsing,ringin,rincess,rickety,reveling,retest,retaliating,restorative,reston,restaurateur,reshoots,resetting,resentments,reprogramming,repossess,repartee,renzo,remore,remitting,remeber,relaxants,rejuvenate,rejections,regenerated,refocus,referrals,reeno,recycles,recrimination,reclining,recanting,reattach,reassigning,razgul,raved,rattlesnakes,rattles,rashly,raquetball,ransack,raisinettes,raheem,radisson,radishes,raban,quoth,qumari,quints,quilts,quilting,quien,quarreled,purty,purblind,punchbowl,publically,psychotics,psychopaths,psychoanalyze,pruning,provasik,protectin,propping,proportioned,prophylactic,proofed,prompter,procreate,proclivities,prioritizing,prinze,pricked,press'll,presets,prescribes,preocupe,prejudicial,prefex,preconceived,precipice,pralines,pragmatist,powerbar,pottie,pottersville,potsie,potholes,posses,posies,portkey,porterhouse,pornographers,poring,poppycock,poppers,pomponi,pokin,poitier,podiatry,pleeze,pleadings,playbook,platelets,plane'arium,placebos,place'll,pistachios,pirated,pinochle,pineapples,pinafore,pimples,piggly,piddling,picon,pickpockets,picchu,physiologically,physic,phobic,philandering,phenomenally,pheasants,pewter,petticoat,petronis,petitioning,perturbed,perpetuating,permutat,perishable,perimeters,perfumed,percocet,per'sus,pepperjack,penalize,pelting,pellet,peignoir,pedicures,peckers,pecans,pawning,paulsson,pattycake,patrolmen,patois,pathos,pasted,parishioner,parcheesi,parachuting,papayas,pantaloons,palpitations,palantine,paintballing,overtired,overstress,oversensitive,overnights,overexcited,overanxious,overachiever,outwitted,outvoted,outnumber,outlast,outlander,out've,orphey,orchestrating,openers,ooooooo,okies,ohhhhhhhhh,ohhhhhhhh,ogling,offbeat,obsessively,obeyed,o'hana,o'bannon,o'bannion,numpce,nummy,nuked,nuances,nourishing,nosedive,norbu,nomlies,nomine,nixed,nihilist,nightshift,newmeat,neglectful,neediness,needin,naphthalene,nanocytes,nanite,naivete,n'yeah,mystifying,myhnegon,mutating,musing,mulled,muggy,muerto,muckraker,muchachos,mountainside,motherless,mosquitos,morphed,mopped,moodoo,moncho,mollem,moisturiser,mohicans,mocks,mistresses,misspent,misinterpretation,miscarry,minuses,mindee,mimes,millisecond,milked,mightn't,mightier,mierzwiak,microchips,meyerling,mesmerizing,mershaw,meecrob,medicate,meddled,mckinnons,mcgewan,mcdunnough,mcats,mbien,matzah,matriarch,masturbated,masselin,martialed,marlboros,marksmanship,marinate,marchin,manicured,malnourished,malign,majorek,magnon,magnificently,macking,machiavellian,macdougal,macchiato,macaws,macanaw,m'self,lydells,lusts,lucite,lubricants,lopper,lopped,loneliest,lonelier,lomez,lojack,loath,liquefy,lippy,limps,likin,lightness,liesl,liebchen,licious,libris,libation,lhamo,leotards,leanin,laxatives,lavished,latka,lanyard,lanky,landmines,lameness,laddies,lacerated,labored,l'amour,kreskin,kovitch,kournikova,kootchy,konoss,knknow,knickety,knackety,kmart,klicks,kiwanis,kissable,kindergartners,kilter,kidnet,kid'll,kicky,kickbacks,kickback,kholokov,kewpie,kendo,katra,kareoke,kafelnikov,kabob,junjun,jumba,julep,jordie,jondy,jolson,jenoff,jawbone,janitorial,janiro,ipecac,invigorated,intruded,intros,intravenously,interruptus,interrogations,interject,interfacing,interestin,insuring,instilled,insensitivity,inscrutable,inroads,innards,inlaid,injector,ingratitude,infuriates,infra,infliction,indelicate,incubators,incrimination,inconveniencing,inconsolable,incestuous,incas,incarcerate,inbreeding,impudence,impressionists,impeached,impassioned,imipenem,idling,idiosyncrasies,icebergs,hypotensive,hydrochloride,hushed,humus,humph,hummm,hulking,hubcaps,hubald,howya,howbout,how'll,housebroken,hotwire,hotspots,hotheaded,horrace,hopsfield,honto,honkin,honeymoons,homewrecker,hombres,hollers,hollerin,hoedown,hoboes,hobbling,hobble,hoarse,hinky,highlighters,hexes,heru'ur,hernias,heppleman,hell're,heighten,heheheheheh,heheheh,hedging,heckling,heckled,heavyset,heatshield,heathens,heartthrob,headpiece,hayseed,haveo,hauls,hasten,harridan,harpoons,hardens,harcesis,harbouring,hangouts,halkein,haleh,halberstam,hairnet,hairdressers,hacky,haaaa,h'yah,gusta,gushy,gurgling,guilted,gruel,grudging,grrrrrr,grosses,groomsmen,griping,gravest,gratified,grated,goulash,goopy,goona,goodly,godliness,godawful,godamn,glycerin,glutes,glowy,globetrotters,glimpsed,glenville,glaucoma,girlscout,giraffes,gilbey,gigglepuss,ghora,gestating,gelato,geishas,gearshift,gayness,gasped,gaslighting,garretts,garba,gablyczyck,g'head,fumigating,fumbling,fudged,fuckwad,fuck're,fuchsia,fretting,freshest,frenchies,freezers,fredrica,fraziers,fraidy,foxholes,fourty,fossilized,forsake,forfeits,foreclosed,foreal,footsies,florists,flopped,floorshow,floorboard,flinching,flecks,flaubert,flatware,flatulence,flatlined,flashdance,flail,flagging,fiver,fitzy,fishsticks,finetti,finelli,finagle,filko,fieldstone,fibber,ferrini,feedin,feasting,favore,fathering,farrouhk,farmin,fairytale,fairservice,factoid,facedown,fabled,eyeballin,extortionist,exquisitely,expedited,exorcise,existentialist,execs,exculpatory,exacerbate,everthing,eventuality,evander,euphoric,euphemisms,estamos,erred,entitle,enquiries,enormity,enfants,endive,encyclopedias,emulating,embittered,effortless,ectopic,ecirc,easely,earphones,earmarks,dweller,durslar,durned,dunois,dunking,dunked,dumdum,dullard,dudleys,druthers,druggist,drossos,drooled,driveways,drippy,dreamless,drawstring,drang,drainpipe,dozing,dotes,dorkface,doorknobs,doohickey,donnatella,doncha,domicile,dokos,dobermans,dizzying,divola,ditsy,distaste,disservice,dislodged,dislodge,disinherit,disinformation,discounting,dinka,dimly,digesting,diello,diddling,dictatorships,dictators,diagnostician,devours,devilishly,detract,detoxing,detours,detente,destructs,desecrated,derris,deplore,deplete,demure,demolitions,demean,delish,delbruck,delaford,degaulle,deftly,deformity,deflate,definatly,defector,decrypted,decontamination,decapitate,decanter,dardis,dampener,damme,daddy'll,dabbling,dabbled,d'etre,d'argent,d'alene,d'agnasti,czechoslovakian,cymbal,cyberdyne,cutoffs,cuticle,curvaceous,curiousity,crowing,crowed,croutons,cropped,criminy,crescentis,crashers,cranwell,coverin,courtrooms,countenance,cosmically,cosign,corroboration,coroners,cornflakes,copperpot,copperhead,copacetic,coordsize,convulsing,consults,conjures,congenial,concealer,compactor,commercialism,cokey,cognizant,clunkers,clumsily,clucking,cloves,cloven,cloths,clothe,clods,clocking,clings,clavicle,classless,clashing,clanking,clanging,clamping,civvies,citywide,circulatory,circuited,chronisters,chromic,choos,chloroformed,chillun,cheesed,chatterbox,chaperoned,channukah,cerebellum,centerpieces,centerfold,ceecee,ccedil,cavorting,cavemen,cauterized,cauldwell,catting,caterine,cassiopeia,carves,cartwheel,carpeted,carob,caressing,carelessly,careening,capricious,capitalistic,capillaries,candidly,camaraderie,callously,calfskin,caddies,buttholes,busywork,busses,burps,burgomeister,bunkhouse,bungchow,bugler,buffets,buffed,brutish,brusque,bronchitis,bromden,brolly,broached,brewskis,brewin,brean,breadwinner,brana,bountiful,bouncin,bosoms,borgnine,bopping,bootlegs,booing,bombosity,bolting,boilerplate,bluey,blowback,blouses,bloodsuckers,bloodstained,bloat,bleeth,blackface,blackest,blackened,blacken,blackballed,blabs,blabbering,birdbrain,bipartisanship,biodegradable,biltmore,bilked,big'uns,bidet,besotted,bernheim,benegas,bendiga,belushi,bellboys,belittling,behinds,begone,bedsheets,beckoning,beaute,beaudine,beastly,beachfront,bathes,batak,baser,baseballs,barbella,bankrolling,bandaged,baerly,backlog,backin,babying,azkaban,awwwww,aviary,authorizes,austero,aunty,attics,atreus,astounded,astonish,artemus,arses,arintero,appraiser,apathetic,anybody'd,anxieties,anticlimactic,antar,anglos,angleman,anesthetist,androscoggin,andolini,andale,amway,amuck,amniocentesis,amnesiac,americano,amara,alvah,altruism,alternapalooza,alphabetize,alpaca,allus,allergist,alexandros,alaikum,akimbo,agoraphobia,agides,aggrhh,aftertaste,adoptions,adjuster,addictions,adamantium,activator,accomplishes,aberrant,aaaaargh,aaaaaaaaaaaaa,a'ight,zzzzzzz,zucchini,zookeeper,zirconia,zippers,zequiel,zellary,zeitgeist,zanuck,zagat,you'n,ylang,yes'm,yenta,yecchh,yecch,yawns,yankin,yahdah,yaaah,y'got,xeroxed,wwooww,wristwatch,wrangled,wouldst,worthiness,worshiping,wormy,wormtail,wormholes,woosh,wollsten,wolfing,woefully,wobbling,wintry,wingding,windstorm,windowtext,wiluna,wilting,wilted,willick,willenholly,wildflowers,wildebeest,whyyy,whoppers,whoaa,whizzing,whizz,whitest,whistled,whist,whinny,wheelies,whazzup,whatwhatwhaaat,whato,whatdya,what'dya,whacks,wewell,wetsuit,welluh,weeps,waylander,wavin,wassail,wasnt,warneford,warbucks,waltons,wallbanger,waiving,waitwait,vowing,voucher,vornoff,vorhees,voldemort,vivre,vittles,vindaloo,videogames,vichyssoise,vicarious,vesuvius,verguenza,ven't,velveteen,velour,velociraptor,vastness,vasectomies,vapors,vanderhof,valmont,validates,valiantly,vacuums,usurp,usernum,us'll,urinals,unyielding,unvarnished,unturned,untouchables,untangled,unsecured,unscramble,unreturned,unremarkable,unpretentious,unnerstand,unmade,unimpeachable,unfashionable,underwrite,underlining,underling,underestimates,underappreciated,uncouth,uncork,uncommonly,unclog,uncircumcised,unchallenged,uncas,unbuttoning,unapproved,unamerican,unafraid,umpteen,umhmm,uhwhy,ughuh,typewriters,twitches,twitched,twirly,twinkling,twinges,twiddling,turners,turnabout,tumblin,tryed,trowel,trousseau,trivialize,trifles,tribianni,trenchcoat,trembled,traumatize,transitory,transients,transfuse,transcribing,tranq,trampy,traipsed,trainin,trachea,traceable,touristy,toughie,toscanini,tortola,tortilla,torreon,toreador,tommorrow,tollbooth,tollans,toidy,togas,tofurkey,toddling,toddies,toasties,toadstool,to've,tingles,timin,timey,timetables,tightest,thuggee,thrusting,thrombus,throes,thrifty,thornharts,thinnest,thicket,thetas,thesulac,tethered,testaburger,tersenadine,terrif,terdlington,tepui,temping,tector,taxidermy,tastebuds,tartlets,tartabull,tar'd,tantamount,tangy,tangles,tamer,tabula,tabletops,tabithia,szechwan,synthedyne,svenjolly,svengali,survivalists,surmise,surfboards,surefire,suprise,supremacists,suppositories,superstore,supercilious,suntac,sunburned,summercliff,sullied,sugared,suckle,subtleties,substantiated,subsides,subliminal,subhuman,strowman,stroked,stroganoff,streetlight,straying,strainer,straighter,straightener,stoplight,stirrups,stewing,stereotyping,stepmommy,stephano,stashing,starshine,stairwells,squatsie,squandering,squalid,squabbling,squab,sprinkling,spreader,spongy,spokesmen,splintered,spittle,spitter,spiced,spews,spendin,spect,spearchucker,spatulas,southtown,soused,soshi,sorter,sorrowful,sooth,some'in,soliloquy,soiree,sodomized,sobriki,soaping,snows,snowcone,snitching,snitched,sneering,snausages,snaking,smoothed,smoochies,smarten,smallish,slushy,slurring,sluman,slithers,slippin,sleuthing,sleeveless,skinless,skillfully,sketchbook,skagnetti,sista,sinning,singularly,sinewy,silverlake,siguto,signorina,sieve,sidearms,shying,shunning,shtud,shrieks,shorting,shortbread,shopkeepers,shmancy,shizzit,shitheads,shitfaced,shipmates,shiftless,shelving,shedlow,shavings,shatters,sharifa,shampoos,shallots,shafter,sha'nauc,sextant,serviceable,sepsis,senores,sendin,semis,semanski,selflessly,seinfelds,seers,seeps,seductress,secaucus,sealant,scuttling,scusa,scrunched,scissorhands,schreber,schmancy,scamps,scalloped,savoir,savagery,sarong,sarnia,santangel,samool,sallow,salino,safecracker,sadism,sacrilegious,sabrini,sabath,s'aright,ruttheimer,rudest,rubbery,rousting,rotarian,roslin,roomed,romari,romanica,rolltop,rolfski,rockettes,roared,ringleader,riffing,ribcage,rewired,retrial,reting,resuscitated,restock,resale,reprogrammed,replicant,repentant,repellant,repays,repainting,renegotiating,rendez,remem,relived,relinquishes,relearn,relaxant,rekindling,rehydrate,refueled,refreshingly,refilling,reexamine,reeseman,redness,redeemable,redcoats,rectangles,recoup,reciprocated,reassessing,realy,realer,reachin,re'kali,rawlston,ravages,rappaports,ramoray,ramming,raindrops,rahesh,radials,racists,rabartu,quiches,quench,quarreling,quaintly,quadrants,putumayo,put'em,purifier,pureed,punitis,pullout,pukin,pudgy,puddings,puckering,pterodactyl,psychodrama,psats,protestations,protectee,prosaic,propositioned,proclivity,probed,printouts,prevision,pressers,preset,preposition,preempt,preemie,preconceptions,prancan,powerpuff,potties,potpie,poseur,porthole,poops,pooping,pomade,polyps,polymerized,politeness,polisher,polack,pocketknife,poatia,plebeian,playgroup,platonically,platitude,plastering,plasmapheresis,plaids,placemats,pizzazz,pintauro,pinstripes,pinpoints,pinkner,pincer,pimento,pileup,pilates,pigmen,pieeee,phrased,photocopies,phoebes,philistines,philanderer,pheromone,phasers,pfeffernuesse,pervs,perspire,personify,perservere,perplexed,perpetrating,perkiness,perjurer,periodontist,perfunctory,perdido,percodan,pentameter,pentacle,pensive,pensione,pennybaker,pennbrooke,penhall,pengin,penetti,penetrates,pegnoir,peeve,peephole,pectorals,peckin,peaky,peaksville,paxcow,paused,patted,parkishoff,parkers,pardoning,paraplegic,paraphrasing,paperers,papered,pangs,paneling,palooza,palmed,palmdale,palatable,pacify,pacified,owwwww,oversexed,overrides,overpaying,overdrawn,overcompensate,overcomes,overcharged,outmaneuver,outfoxed,oughtn't,ostentatious,oshun,orthopedist,or'derves,ophthalmologist,operagirl,oozes,oooooooh,onesie,omnis,omelets,oktoberfest,okeydoke,ofthe,ofher,obstetrical,obeys,obeah,o'henry,nyquil,nyanyanyanyah,nuttin,nutsy,nutball,nurhachi,numbskull,nullifies,nullification,nucking,nubbin,nourished,nonspecific,noing,noinch,nohoho,nobler,nitwits,newsprint,newspaperman,newscaster,neuropathy,netherworld,neediest,navasky,narcissists,napped,nafta,mache,mykonos,mutilating,mutherfucker,mutha,mutates,mutate,musn't,murchy,multitasking,mujeeb,mudslinging,muckraking,mousetrap,mourns,mournful,motherf,mostro,morphing,morphate,moralistic,moochy,mooching,monotonous,monopolize,monocle,molehill,moland,mofet,mockup,mobilizing,mmmmmmm,mitzvahs,mistreating,misstep,misjudge,misinformation,misdirected,miscarriages,miniskirt,mindwarped,minced,milquetoast,miguelito,mightily,midstream,midriff,mideast,microbe,methuselah,mesdames,mescal,men'll,memma,megaton,megara,megalomaniac,meeee,medulla,medivac,meaninglessness,mcnuggets,mccarthyism,maypole,may've,mauve,mateys,marshack,markles,marketable,mansiere,manservant,manse,manhandling,mallomars,malcontent,malaise,majesties,mainsail,mailmen,mahandra,magnolias,magnified,magev,maelstrom,machu,macado,m'boy,m'appelle,lustrous,lureen,lunges,lumped,lumberyard,lulled,luego,lucks,lubricated,loveseat,loused,lounger,loski,lorre,loora,looong,loonies,loincloth,lofts,lodgers,lobbing,loaner,livered,liqueur,ligourin,lifesaving,lifeguards,lifeblood,liaisons,let'em,lesbianism,lence,lemonlyman,legitimize,leadin,lazars,lazarro,lawyering,laugher,laudanum,latrines,lations,laters,lapels,lakefront,lahit,lafortunata,lachrymose,l'italien,kwaini,kruczynski,kramerica,kowtow,kovinsky,korsekov,kopek,knowakowski,knievel,knacks,kiowas,killington,kickball,keyworth,keymaster,kevie,keveral,kenyons,keggers,keepsakes,kechner,keaty,kavorka,karajan,kamerev,kaggs,jujyfruit,jostled,jonestown,jokey,joists,jocko,jimmied,jiggled,jests,jenzen,jenko,jellyman,jedediah,jealitosis,jaunty,jarmel,jankle,jagoff,jagielski,jackrabbits,jabbing,jabberjaw,izzat,irresponsibly,irrepressible,irregularity,irredeemable,inuvik,intuitions,intubated,intimates,interminable,interloper,intercostal,instyle,instigate,instantaneously,ining,ingrown,ingesting,infusing,infringe,infinitum,infact,inequities,indubitably,indisputable,indescribably,indentation,indefinable,incontrovertible,inconsequential,incompletes,incoherently,inclement,incidentals,inarticulate,inadequacies,imprudent,improprieties,imprison,imprinted,impressively,impostors,importante,imperious,impale,immodest,immobile,imbedded,imbecilic,illegals,idn't,hysteric,hypotenuse,hygienic,hyeah,hushpuppies,hunhh,humpback,humored,hummed,humiliates,humidifier,huggy,huggers,huckster,hotbed,hosing,hosers,horsehair,homebody,homebake,holing,holies,hoisting,hogwallop,hocks,hobbits,hoaxes,hmmmmm,hisses,hippest,hillbillies,hilarity,heurh,herniated,hermaphrodite,hennifer,hemlines,hemline,hemery,helplessness,helmsley,hellhound,heheheheh,heeey,hedda,heartbeats,heaped,healers,headstart,headsets,headlong,hawkland,havta,haulin,harvey'll,hanta,hansom,hangnail,handstand,handrail,handoff,hallucinogen,hallor,halitosis,haberdashery,gypped,guy'll,gumbel,guerillas,guava,guardrail,grunther,grunick,groppi,groomer,grodin,gripes,grinds,grifters,gretch,greevey,greasing,graveyards,grandkid,grainy,gouging,gooney,googly,goldmuff,goldenrod,goingo,godly,gobbledygook,gobbledegook,glues,gloriously,glengarry,glassware,glamor,gimmicks,giggly,giambetti,ghoulish,ghettos,ghali,gether,geriatrics,gerbils,geosynchronous,georgio,gente,gendarme,gelbman,gazillionth,gayest,gauging,gastro,gaslight,gasbag,garters,garish,garas,gantu,gangy,gangly,gangland,galling,gadda,furrowed,funnies,funkytown,fugimotto,fudging,fuckeen,frustrates,froufrou,froot,fromberge,frizzies,fritters,frightfully,friendliest,freeloading,freelancing,freakazoid,fraternization,framers,fornication,fornicating,forethought,footstool,foisting,focussing,focking,flurries,fluffed,flintstones,fledermaus,flayed,flawlessly,flatters,flashbang,flapped,fishies,firmer,fireproof,firebug,fingerpainting,finessed,findin,financials,finality,fillets,fiercest,fiefdom,fibbing,fervor,fentanyl,fenelon,fedorchuk,feckless,feathering,faucets,farewells,fantasyland,fanaticism,faltered,faggy,faberge,extorting,extorted,exterminating,exhumation,exhilaration,exhausts,exfoliate,excels,exasperating,exacting,everybody'd,evasions,espressos,esmail,errrr,erratically,eroding,ernswiler,epcot,enthralled,ensenada,enriching,enrage,enhancer,endear,encrusted,encino,empathic,embezzle,emanates,electricians,eking,egomaniacal,egging,effacing,ectoplasm,eavesdropped,dummkopf,dugray,duchaisne,drunkard,drudge,droop,droids,drips,dripped,dribbles,drazens,downy,downsize,downpour,dosages,doppelganger,dopes,doohicky,dontcha,doneghy,divining,divest,diuretics,diuretic,distrustful,disrupts,dismemberment,dismember,disinfect,disillusionment,disheartening,discourteous,discotheque,discolored,dirtiest,diphtheria,dinks,dimpled,didya,dickwad,diatribes,diathesis,diabetics,deviants,detonates,detests,detestable,detaining,despondent,desecration,derision,derailing,deputized,depressors,dependant,dentures,denominators,demur,demonology,delts,dellarte,delacour,deflated,defib,defaced,decorators,deaqon,davola,datin,darwinian,darklighters,dandelions,dampened,damaskinos,dalrimple,d'peshu,d'hoffryn,d'astier,cynics,cutesy,cutaway,curmudgeon,curdle,culpability,cuisinart,cuffing,crypts,cryptid,crunched,crumblers,crudely,crosscheck,croon,crissake,crevasse,creswood,creepo,creases,creased,creaky,cranks,crabgrass,coveralls,couple'a,coughs,coslaw,corporeal,cornucopia,cornering,corks,cordoned,coolly,coolin,cookbooks,contrite,contented,constrictor,confound,confit,confiscating,condoned,conditioners,concussions,comprendo,comers,combustible,combusted,collingswood,coldness,coitus,codicil,coasting,clydesdale,cluttering,clunker,clunk,clumsiness,clotted,clothesline,clinches,clincher,cleverness,clench,clein,cleanses,claymores,clammed,chugging,chronically,christsakes,choque,chompers,chiseling,chirpy,chirp,chinks,chingachgook,chickenpox,chickadee,chewin,chessboard,chargin,chanteuse,chandeliers,chamdo,chagrined,chaff,certs,certainties,cerreno,cerebrum,censured,cemetary,caterwauling,cataclysmic,casitas,cased,carvel,carting,carrear,carolling,carolers,carnie,cardiogram,carbuncle,capulets,canines,candaules,canape,caldecott,calamitous,cadillacs,cachet,cabeza,cabdriver,buzzards,butai,businesswomen,bungled,bumpkins,bummers,bulldoze,buffybot,bubut,bubbies,brrrrr,brownout,brouhaha,bronzing,bronchial,broiler,briskly,briefcases,bricked,breezing,breeher,breakable,breadstick,bravenet,braved,brandies,brainwaves,brainiest,braggart,bradlee,boys're,boys'll,boys'd,boutonniere,bossed,bosomy,borans,boosts,bookshelves,bookends,boneless,bombarding,bollo,boinked,boink,bluest,bluebells,bloodshot,blockhead,blockbusters,blithely,blather,blankly,bladders,blackbeard,bitte,bippy,biogenetics,bilge,bigglesworth,bicuspids,beususe,betaseron,besmirch,bernece,bereavement,bentonville,benchley,benching,bembe,bellyaching,bellhops,belie,beleaguered,behrle,beginnin,begining,beenie,beefs,beechwood,becau,beaverhausen,beakers,bazillion,baudouin,barrytown,barringtons,barneys,barbs,barbers,barbatus,bankrupted,bailiffs,backslide,baby'd,baaad,b'fore,awwwk,aways,awakes,automatics,authenticate,aught,aubyn,attired,attagirl,atrophied,asystole,astroturf,assertiveness,artichokes,arquillians,aright,archenemy,appraise,appeased,antin,anspaugh,anesthetics,anaphylactic,amscray,ambivalence,amalio,alriiight,alphabetized,alpena,alouette,allora,alliteration,allenwood,allegiances,algerians,alcerro,alastor,ahaha,agitators,aforethought,advertises,admonition,adirondacks,adenoids,acupuncturist,acula,actuarial,activators,actionable,achingly,accusers,acclimated,acclimate,absurdly,absorbent,absolvo,absolutes,absences,abdomenizer,aaaaaaaaah,aaaaaaaaaa,a'right".split(","),
    male_names: "james,john,robert,michael,william,david,richard,charles,joseph,thomas,christopher,daniel,paul,mark,donald,george,kenneth,steven,edward,brian,ronald,anthony,kevin,jason,matthew,gary,timothy,jose,larry,jeffrey,frank,scott,eric,stephen,andrew,raymond,gregory,joshua,jerry,dennis,walter,patrick,peter,harold,douglas,henry,carl,arthur,ryan,roger,joe,juan,jack,albert,jonathan,justin,terry,gerald,keith,samuel,willie,ralph,lawrence,nicholas,roy,benjamin,bruce,brandon,adam,harry,fred,wayne,billy,steve,louis,jeremy,aaron,randy,eugene,carlos,russell,bobby,victor,ernest,phillip,todd,jesse,craig,alan,shawn,clarence,sean,philip,chris,johnny,earl,jimmy,antonio,danny,bryan,tony,luis,mike,stanley,leonard,nathan,dale,manuel,rodney,curtis,norman,marvin,vincent,glenn,jeffery,travis,jeff,chad,jacob,melvin,alfred,kyle,francis,bradley,jesus,herbert,frederick,ray,joel,edwin,don,eddie,ricky,troy,randall,barry,bernard,mario,leroy,francisco,marcus,micheal,theodore,clifford,miguel,oscar,jay,jim,tom,calvin,alex,jon,ronnie,bill,lloyd,tommy,leon,derek,darrell,jerome,floyd,leo,alvin,tim,wesley,dean,greg,jorge,dustin,pedro,derrick,dan,zachary,corey,herman,maurice,vernon,roberto,clyde,glen,hector,shane,ricardo,sam,rick,lester,brent,ramon,tyler,gilbert,gene,marc,reginald,ruben,brett,nathaniel,rafael,edgar,milton,raul,ben,cecil,duane,andre,elmer,brad,gabriel,ron,roland,jared,adrian,karl,cory,claude,erik,darryl,neil,christian,javier,fernando,clinton,ted,mathew,tyrone,darren,lonnie,lance,cody,julio,kurt,allan,clayton,hugh,max,dwayne,dwight,armando,felix,jimmie,everett,ian,ken,bob,jaime,casey,alfredo,alberto,dave,ivan,johnnie,sidney,byron,julian,isaac,clifton,willard,daryl,virgil,andy,salvador,kirk,sergio,seth,kent,terrance,rene,eduardo,terrence,enrique,freddie,stuart,fredrick,arturo,alejandro,joey,nick,luther,wendell,jeremiah,evan,julius,donnie,otis,trevor,luke,homer,gerard,doug,kenny,hubert,angelo,shaun,lyle,matt,alfonso,orlando,rex,carlton,ernesto,pablo,lorenzo,omar,wilbur,blake,horace,roderick,kerry,abraham,rickey,ira,andres,cesar,johnathan,malcolm,rudolph,damon,kelvin,rudy,preston,alton,archie,marco,pete,randolph,garry,geoffrey,jonathon,felipe,bennie,gerardo,dominic,loren,delbert,colin,guillermo,earnest,benny,noel,rodolfo,myron,edmund,salvatore,cedric,lowell,gregg,sherman,devin,sylvester,roosevelt,israel,jermaine,forrest,wilbert,leland,simon,irving,owen,rufus,woodrow,sammy,kristopher,levi,marcos,gustavo,jake,lionel,marty,gilberto,clint,nicolas,laurence,ismael,orville,drew,ervin,dewey,wilfred,josh,hugo,ignacio,caleb,tomas,sheldon,erick,frankie,darrel,rogelio,terence,alonzo,elias,bert,elbert,ramiro,conrad,noah,grady,phil,cornelius,lamar,rolando,clay,percy,bradford,merle,darin,amos,terrell,moses,irvin,saul,roman,darnell,randal,tommie,timmy,darrin,brendan,toby,van,abel,dominick,emilio,elijah,cary,domingo,aubrey,emmett,marlon,emanuel,jerald,edmond,emil,dewayne,otto,teddy,reynaldo,bret,jess,trent,humberto,emmanuel,stephan,louie,vicente,lamont,garland,micah,efrain,heath,rodger,demetrius,ethan,eldon,rocky,pierre,eli,bryce,antoine,robbie,kendall,royce,sterling,grover,elton,cleveland,dylan,chuck,damian,reuben,stan,leonardo,russel,erwin,benito,hans,monte,blaine,ernie,curt,quentin,agustin,jamal,devon,adolfo,tyson,wilfredo,bart,jarrod,vance,denis,damien,joaquin,harlan,desmond,elliot,darwin,gregorio,kermit,roscoe,esteban,anton,solomon,norbert,elvin,nolan,carey,rod,quinton,hal,brain,rob,elwood,kendrick,darius,moises,marlin,fidel,thaddeus,cliff,marcel,ali,raphael,bryon,armand,alvaro,jeffry,dane,joesph,thurman,ned,sammie,rusty,michel,monty,rory,fabian,reggie,kris,isaiah,gus,avery,loyd,diego,adolph,millard,rocco,gonzalo,derick,rodrigo,gerry,rigoberto,alphonso,rickie,noe,vern,elvis,bernardo,mauricio,hiram,donovan,basil,nickolas,scot,vince,quincy,eddy,sebastian,federico,ulysses,heriberto,donnell,denny,gavin,emery,romeo,jayson,dion,dante,clement,coy,odell,jarvis,bruno,issac,dudley,sanford,colby,carmelo,nestor,hollis,stefan,donny,linwood,beau,weldon,galen,isidro,truman,delmar,johnathon,silas,frederic,irwin,merrill,charley,marcelino,carlo,trenton,kurtis,aurelio,winfred,vito,collin,denver,leonel,emory,pasquale,mohammad,mariano,danial,landon,dirk,branden,adan,numbers,clair,buford,bernie,wilmer,emerson,zachery,jacques,errol,josue,edwardo,wilford,theron,raymundo,daren,tristan,robby,lincoln,jame,genaro,octavio,cornell,hung,arron,antony,herschel,alva,giovanni,garth,cyrus,cyril,ronny,stevie,lon,kennith,carmine,augustine,erich,chadwick,wilburn,russ,myles,jonas,mitchel,mervin,zane,jamel,lazaro,alphonse,randell,johnie,jarrett,ariel,abdul,dusty,luciano,seymour,scottie,eugenio,mohammed,arnulfo,lucien,ferdinand,thad,ezra,aldo,rubin,mitch,earle,abe,marquis,lanny,kareem,jamar,boris,isiah,emile,elmo,aron,leopoldo,everette,josef,eloy,dorian,rodrick,reinaldo,lucio,jerrod,weston,hershel,lemuel,lavern,burt,jules,gil,eliseo,ahmad,nigel,efren,antwan,alden,margarito,refugio,dino,osvaldo,les,deandre,normand,kieth,ivory,trey,norberto,napoleon,jerold,fritz,rosendo,milford,sang,deon,christoper,alfonzo,lyman,josiah,brant,wilton,rico,jamaal,dewitt,brenton,yong,olin,faustino,claudio,judson,gino,edgardo,alec,jarred,donn,trinidad,tad,porfirio,odis,lenard,chauncey,tod,mel,marcelo,kory,augustus,keven,hilario,bud,sal,orval,mauro,dannie,zachariah,olen,anibal,milo,jed,thanh,amado,lenny,tory,richie,horacio,brice,mohamed,delmer,dario,mac,jonah,jerrold,robt,hank,sung,rupert,rolland,kenton,damion,chi,antone,waldo,fredric,bradly,kip,burl,tyree,jefferey,ahmed,willy,stanford,oren,moshe,mikel,enoch,brendon,quintin,jamison,florencio,darrick,tobias,minh,hassan,giuseppe,demarcus,cletus,tyrell,lyndon,keenan,werner,theo,geraldo,columbus,chet,bertram,markus,huey,hilton,dwain,donte,tyron,omer,isaias,hipolito,fermin,chung,adalberto,jamey,teodoro,mckinley,maximo,raleigh,lawerence,abram,rashad,emmitt,daron,chong,samual,otha,miquel,eusebio,dong,domenic,darron,wilber,renato,hoyt,haywood,ezekiel,chas,florentino,elroy,clemente,arden,neville,edison,deshawn,carrol,shayne,nathanial,jordon,danilo,claud,sherwood,raymon,rayford,cristobal,ambrose,titus,hyman,felton,ezequiel,erasmo,lonny,milan,lino,jarod,herb,andreas,rhett,jude,douglass,cordell,oswaldo,ellsworth,virgilio,toney,nathanael,benedict,mose,hong,isreal,garret,fausto,arlen,zack,modesto,francesco,manual,gaylord,gaston,filiberto,deangelo,michale,granville,malik,zackary,tuan,nicky,cristopher,antione,malcom,korey,jospeh,colton,waylon,hosea,shad,santo,rudolf,rolf,renaldo,marcellus,lucius,kristofer,harland,arnoldo,rueben,leandro,kraig,jerrell,jeromy,hobert,cedrick,arlie,winford,wally,luigi,keneth,jacinto,graig,franklyn,edmundo,leif,jeramy,willian,vincenzo,shon,michal,lynwood,jere,elden,darell,broderick,alonso".split(",")
};
module.exports = $643c28ec85b1ecb7$var$frequency_lists;

});

parcelRegister("17UkK", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $0d2224905bd79a69$var$adjacency_graphs;
$0d2224905bd79a69$var$adjacency_graphs = {
    qwerty: {
        "!": [
            "`~",
            null,
            null,
            "2@",
            "qQ",
            null
        ],
        "\"": [
            ";:",
            "[{",
            "]}",
            null,
            null,
            "/?"
        ],
        "#": [
            "2@",
            null,
            null,
            "4$",
            "eE",
            "wW"
        ],
        "$": [
            "3#",
            null,
            null,
            "5%",
            "rR",
            "eE"
        ],
        "%": [
            "4$",
            null,
            null,
            "6^",
            "tT",
            "rR"
        ],
        "&": [
            "6^",
            null,
            null,
            "8*",
            "uU",
            "yY"
        ],
        "'": [
            ";:",
            "[{",
            "]}",
            null,
            null,
            "/?"
        ],
        "(": [
            "8*",
            null,
            null,
            "0)",
            "oO",
            "iI"
        ],
        ")": [
            "9(",
            null,
            null,
            "-_",
            "pP",
            "oO"
        ],
        "*": [
            "7&",
            null,
            null,
            "9(",
            "iI",
            "uU"
        ],
        "+": [
            "-_",
            null,
            null,
            null,
            "]}",
            "[{"
        ],
        ",": [
            "mM",
            "kK",
            "lL",
            ".>",
            null,
            null
        ],
        "-": [
            "0)",
            null,
            null,
            "=+",
            "[{",
            "pP"
        ],
        ".": [
            ",<",
            "lL",
            ";:",
            "/?",
            null,
            null
        ],
        "/": [
            ".>",
            ";:",
            "'\"",
            null,
            null,
            null
        ],
        "0": [
            "9(",
            null,
            null,
            "-_",
            "pP",
            "oO"
        ],
        "1": [
            "`~",
            null,
            null,
            "2@",
            "qQ",
            null
        ],
        "2": [
            "1!",
            null,
            null,
            "3#",
            "wW",
            "qQ"
        ],
        "3": [
            "2@",
            null,
            null,
            "4$",
            "eE",
            "wW"
        ],
        "4": [
            "3#",
            null,
            null,
            "5%",
            "rR",
            "eE"
        ],
        "5": [
            "4$",
            null,
            null,
            "6^",
            "tT",
            "rR"
        ],
        "6": [
            "5%",
            null,
            null,
            "7&",
            "yY",
            "tT"
        ],
        "7": [
            "6^",
            null,
            null,
            "8*",
            "uU",
            "yY"
        ],
        "8": [
            "7&",
            null,
            null,
            "9(",
            "iI",
            "uU"
        ],
        "9": [
            "8*",
            null,
            null,
            "0)",
            "oO",
            "iI"
        ],
        ":": [
            "lL",
            "pP",
            "[{",
            "'\"",
            "/?",
            ".>"
        ],
        ";": [
            "lL",
            "pP",
            "[{",
            "'\"",
            "/?",
            ".>"
        ],
        "<": [
            "mM",
            "kK",
            "lL",
            ".>",
            null,
            null
        ],
        "=": [
            "-_",
            null,
            null,
            null,
            "]}",
            "[{"
        ],
        ">": [
            ",<",
            "lL",
            ";:",
            "/?",
            null,
            null
        ],
        "?": [
            ".>",
            ";:",
            "'\"",
            null,
            null,
            null
        ],
        "@": [
            "1!",
            null,
            null,
            "3#",
            "wW",
            "qQ"
        ],
        "A": [
            null,
            "qQ",
            "wW",
            "sS",
            "zZ",
            null
        ],
        "B": [
            "vV",
            "gG",
            "hH",
            "nN",
            null,
            null
        ],
        "C": [
            "xX",
            "dD",
            "fF",
            "vV",
            null,
            null
        ],
        "D": [
            "sS",
            "eE",
            "rR",
            "fF",
            "cC",
            "xX"
        ],
        "E": [
            "wW",
            "3#",
            "4$",
            "rR",
            "dD",
            "sS"
        ],
        "F": [
            "dD",
            "rR",
            "tT",
            "gG",
            "vV",
            "cC"
        ],
        "G": [
            "fF",
            "tT",
            "yY",
            "hH",
            "bB",
            "vV"
        ],
        "H": [
            "gG",
            "yY",
            "uU",
            "jJ",
            "nN",
            "bB"
        ],
        "I": [
            "uU",
            "8*",
            "9(",
            "oO",
            "kK",
            "jJ"
        ],
        "J": [
            "hH",
            "uU",
            "iI",
            "kK",
            "mM",
            "nN"
        ],
        "K": [
            "jJ",
            "iI",
            "oO",
            "lL",
            ",<",
            "mM"
        ],
        "L": [
            "kK",
            "oO",
            "pP",
            ";:",
            ".>",
            ",<"
        ],
        "M": [
            "nN",
            "jJ",
            "kK",
            ",<",
            null,
            null
        ],
        "N": [
            "bB",
            "hH",
            "jJ",
            "mM",
            null,
            null
        ],
        "O": [
            "iI",
            "9(",
            "0)",
            "pP",
            "lL",
            "kK"
        ],
        "P": [
            "oO",
            "0)",
            "-_",
            "[{",
            ";:",
            "lL"
        ],
        "Q": [
            null,
            "1!",
            "2@",
            "wW",
            "aA",
            null
        ],
        "R": [
            "eE",
            "4$",
            "5%",
            "tT",
            "fF",
            "dD"
        ],
        "S": [
            "aA",
            "wW",
            "eE",
            "dD",
            "xX",
            "zZ"
        ],
        "T": [
            "rR",
            "5%",
            "6^",
            "yY",
            "gG",
            "fF"
        ],
        "U": [
            "yY",
            "7&",
            "8*",
            "iI",
            "jJ",
            "hH"
        ],
        "V": [
            "cC",
            "fF",
            "gG",
            "bB",
            null,
            null
        ],
        "W": [
            "qQ",
            "2@",
            "3#",
            "eE",
            "sS",
            "aA"
        ],
        "X": [
            "zZ",
            "sS",
            "dD",
            "cC",
            null,
            null
        ],
        "Y": [
            "tT",
            "6^",
            "7&",
            "uU",
            "hH",
            "gG"
        ],
        "Z": [
            null,
            "aA",
            "sS",
            "xX",
            null,
            null
        ],
        "[": [
            "pP",
            "-_",
            "=+",
            "]}",
            "'\"",
            ";:"
        ],
        "\\": [
            "]}",
            null,
            null,
            null,
            null,
            null
        ],
        "]": [
            "[{",
            "=+",
            null,
            "\\|",
            null,
            "'\""
        ],
        "^": [
            "5%",
            null,
            null,
            "7&",
            "yY",
            "tT"
        ],
        "_": [
            "0)",
            null,
            null,
            "=+",
            "[{",
            "pP"
        ],
        "`": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ],
        "a": [
            null,
            "qQ",
            "wW",
            "sS",
            "zZ",
            null
        ],
        "b": [
            "vV",
            "gG",
            "hH",
            "nN",
            null,
            null
        ],
        "c": [
            "xX",
            "dD",
            "fF",
            "vV",
            null,
            null
        ],
        "d": [
            "sS",
            "eE",
            "rR",
            "fF",
            "cC",
            "xX"
        ],
        "e": [
            "wW",
            "3#",
            "4$",
            "rR",
            "dD",
            "sS"
        ],
        "f": [
            "dD",
            "rR",
            "tT",
            "gG",
            "vV",
            "cC"
        ],
        "g": [
            "fF",
            "tT",
            "yY",
            "hH",
            "bB",
            "vV"
        ],
        "h": [
            "gG",
            "yY",
            "uU",
            "jJ",
            "nN",
            "bB"
        ],
        "i": [
            "uU",
            "8*",
            "9(",
            "oO",
            "kK",
            "jJ"
        ],
        "j": [
            "hH",
            "uU",
            "iI",
            "kK",
            "mM",
            "nN"
        ],
        "k": [
            "jJ",
            "iI",
            "oO",
            "lL",
            ",<",
            "mM"
        ],
        "l": [
            "kK",
            "oO",
            "pP",
            ";:",
            ".>",
            ",<"
        ],
        "m": [
            "nN",
            "jJ",
            "kK",
            ",<",
            null,
            null
        ],
        "n": [
            "bB",
            "hH",
            "jJ",
            "mM",
            null,
            null
        ],
        "o": [
            "iI",
            "9(",
            "0)",
            "pP",
            "lL",
            "kK"
        ],
        "p": [
            "oO",
            "0)",
            "-_",
            "[{",
            ";:",
            "lL"
        ],
        "q": [
            null,
            "1!",
            "2@",
            "wW",
            "aA",
            null
        ],
        "r": [
            "eE",
            "4$",
            "5%",
            "tT",
            "fF",
            "dD"
        ],
        "s": [
            "aA",
            "wW",
            "eE",
            "dD",
            "xX",
            "zZ"
        ],
        "t": [
            "rR",
            "5%",
            "6^",
            "yY",
            "gG",
            "fF"
        ],
        "u": [
            "yY",
            "7&",
            "8*",
            "iI",
            "jJ",
            "hH"
        ],
        "v": [
            "cC",
            "fF",
            "gG",
            "bB",
            null,
            null
        ],
        "w": [
            "qQ",
            "2@",
            "3#",
            "eE",
            "sS",
            "aA"
        ],
        "x": [
            "zZ",
            "sS",
            "dD",
            "cC",
            null,
            null
        ],
        "y": [
            "tT",
            "6^",
            "7&",
            "uU",
            "hH",
            "gG"
        ],
        "z": [
            null,
            "aA",
            "sS",
            "xX",
            null,
            null
        ],
        "{": [
            "pP",
            "-_",
            "=+",
            "]}",
            "'\"",
            ";:"
        ],
        "|": [
            "]}",
            null,
            null,
            null,
            null,
            null
        ],
        "}": [
            "[{",
            "=+",
            null,
            "\\|",
            null,
            "'\""
        ],
        "~": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ]
    },
    dvorak: {
        "!": [
            "`~",
            null,
            null,
            "2@",
            "'\"",
            null
        ],
        "\"": [
            null,
            "1!",
            "2@",
            ",<",
            "aA",
            null
        ],
        "#": [
            "2@",
            null,
            null,
            "4$",
            ".>",
            ",<"
        ],
        "$": [
            "3#",
            null,
            null,
            "5%",
            "pP",
            ".>"
        ],
        "%": [
            "4$",
            null,
            null,
            "6^",
            "yY",
            "pP"
        ],
        "&": [
            "6^",
            null,
            null,
            "8*",
            "gG",
            "fF"
        ],
        "'": [
            null,
            "1!",
            "2@",
            ",<",
            "aA",
            null
        ],
        "(": [
            "8*",
            null,
            null,
            "0)",
            "rR",
            "cC"
        ],
        ")": [
            "9(",
            null,
            null,
            "[{",
            "lL",
            "rR"
        ],
        "*": [
            "7&",
            null,
            null,
            "9(",
            "cC",
            "gG"
        ],
        "+": [
            "/?",
            "]}",
            null,
            "\\|",
            null,
            "-_"
        ],
        ",": [
            "'\"",
            "2@",
            "3#",
            ".>",
            "oO",
            "aA"
        ],
        "-": [
            "sS",
            "/?",
            "=+",
            null,
            null,
            "zZ"
        ],
        ".": [
            ",<",
            "3#",
            "4$",
            "pP",
            "eE",
            "oO"
        ],
        "/": [
            "lL",
            "[{",
            "]}",
            "=+",
            "-_",
            "sS"
        ],
        "0": [
            "9(",
            null,
            null,
            "[{",
            "lL",
            "rR"
        ],
        "1": [
            "`~",
            null,
            null,
            "2@",
            "'\"",
            null
        ],
        "2": [
            "1!",
            null,
            null,
            "3#",
            ",<",
            "'\""
        ],
        "3": [
            "2@",
            null,
            null,
            "4$",
            ".>",
            ",<"
        ],
        "4": [
            "3#",
            null,
            null,
            "5%",
            "pP",
            ".>"
        ],
        "5": [
            "4$",
            null,
            null,
            "6^",
            "yY",
            "pP"
        ],
        "6": [
            "5%",
            null,
            null,
            "7&",
            "fF",
            "yY"
        ],
        "7": [
            "6^",
            null,
            null,
            "8*",
            "gG",
            "fF"
        ],
        "8": [
            "7&",
            null,
            null,
            "9(",
            "cC",
            "gG"
        ],
        "9": [
            "8*",
            null,
            null,
            "0)",
            "rR",
            "cC"
        ],
        ":": [
            null,
            "aA",
            "oO",
            "qQ",
            null,
            null
        ],
        ";": [
            null,
            "aA",
            "oO",
            "qQ",
            null,
            null
        ],
        "<": [
            "'\"",
            "2@",
            "3#",
            ".>",
            "oO",
            "aA"
        ],
        "=": [
            "/?",
            "]}",
            null,
            "\\|",
            null,
            "-_"
        ],
        ">": [
            ",<",
            "3#",
            "4$",
            "pP",
            "eE",
            "oO"
        ],
        "?": [
            "lL",
            "[{",
            "]}",
            "=+",
            "-_",
            "sS"
        ],
        "@": [
            "1!",
            null,
            null,
            "3#",
            ",<",
            "'\""
        ],
        "A": [
            null,
            "'\"",
            ",<",
            "oO",
            ";:",
            null
        ],
        "B": [
            "xX",
            "dD",
            "hH",
            "mM",
            null,
            null
        ],
        "C": [
            "gG",
            "8*",
            "9(",
            "rR",
            "tT",
            "hH"
        ],
        "D": [
            "iI",
            "fF",
            "gG",
            "hH",
            "bB",
            "xX"
        ],
        "E": [
            "oO",
            ".>",
            "pP",
            "uU",
            "jJ",
            "qQ"
        ],
        "F": [
            "yY",
            "6^",
            "7&",
            "gG",
            "dD",
            "iI"
        ],
        "G": [
            "fF",
            "7&",
            "8*",
            "cC",
            "hH",
            "dD"
        ],
        "H": [
            "dD",
            "gG",
            "cC",
            "tT",
            "mM",
            "bB"
        ],
        "I": [
            "uU",
            "yY",
            "fF",
            "dD",
            "xX",
            "kK"
        ],
        "J": [
            "qQ",
            "eE",
            "uU",
            "kK",
            null,
            null
        ],
        "K": [
            "jJ",
            "uU",
            "iI",
            "xX",
            null,
            null
        ],
        "L": [
            "rR",
            "0)",
            "[{",
            "/?",
            "sS",
            "nN"
        ],
        "M": [
            "bB",
            "hH",
            "tT",
            "wW",
            null,
            null
        ],
        "N": [
            "tT",
            "rR",
            "lL",
            "sS",
            "vV",
            "wW"
        ],
        "O": [
            "aA",
            ",<",
            ".>",
            "eE",
            "qQ",
            ";:"
        ],
        "P": [
            ".>",
            "4$",
            "5%",
            "yY",
            "uU",
            "eE"
        ],
        "Q": [
            ";:",
            "oO",
            "eE",
            "jJ",
            null,
            null
        ],
        "R": [
            "cC",
            "9(",
            "0)",
            "lL",
            "nN",
            "tT"
        ],
        "S": [
            "nN",
            "lL",
            "/?",
            "-_",
            "zZ",
            "vV"
        ],
        "T": [
            "hH",
            "cC",
            "rR",
            "nN",
            "wW",
            "mM"
        ],
        "U": [
            "eE",
            "pP",
            "yY",
            "iI",
            "kK",
            "jJ"
        ],
        "V": [
            "wW",
            "nN",
            "sS",
            "zZ",
            null,
            null
        ],
        "W": [
            "mM",
            "tT",
            "nN",
            "vV",
            null,
            null
        ],
        "X": [
            "kK",
            "iI",
            "dD",
            "bB",
            null,
            null
        ],
        "Y": [
            "pP",
            "5%",
            "6^",
            "fF",
            "iI",
            "uU"
        ],
        "Z": [
            "vV",
            "sS",
            "-_",
            null,
            null,
            null
        ],
        "[": [
            "0)",
            null,
            null,
            "]}",
            "/?",
            "lL"
        ],
        "\\": [
            "=+",
            null,
            null,
            null,
            null,
            null
        ],
        "]": [
            "[{",
            null,
            null,
            null,
            "=+",
            "/?"
        ],
        "^": [
            "5%",
            null,
            null,
            "7&",
            "fF",
            "yY"
        ],
        "_": [
            "sS",
            "/?",
            "=+",
            null,
            null,
            "zZ"
        ],
        "`": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ],
        "a": [
            null,
            "'\"",
            ",<",
            "oO",
            ";:",
            null
        ],
        "b": [
            "xX",
            "dD",
            "hH",
            "mM",
            null,
            null
        ],
        "c": [
            "gG",
            "8*",
            "9(",
            "rR",
            "tT",
            "hH"
        ],
        "d": [
            "iI",
            "fF",
            "gG",
            "hH",
            "bB",
            "xX"
        ],
        "e": [
            "oO",
            ".>",
            "pP",
            "uU",
            "jJ",
            "qQ"
        ],
        "f": [
            "yY",
            "6^",
            "7&",
            "gG",
            "dD",
            "iI"
        ],
        "g": [
            "fF",
            "7&",
            "8*",
            "cC",
            "hH",
            "dD"
        ],
        "h": [
            "dD",
            "gG",
            "cC",
            "tT",
            "mM",
            "bB"
        ],
        "i": [
            "uU",
            "yY",
            "fF",
            "dD",
            "xX",
            "kK"
        ],
        "j": [
            "qQ",
            "eE",
            "uU",
            "kK",
            null,
            null
        ],
        "k": [
            "jJ",
            "uU",
            "iI",
            "xX",
            null,
            null
        ],
        "l": [
            "rR",
            "0)",
            "[{",
            "/?",
            "sS",
            "nN"
        ],
        "m": [
            "bB",
            "hH",
            "tT",
            "wW",
            null,
            null
        ],
        "n": [
            "tT",
            "rR",
            "lL",
            "sS",
            "vV",
            "wW"
        ],
        "o": [
            "aA",
            ",<",
            ".>",
            "eE",
            "qQ",
            ";:"
        ],
        "p": [
            ".>",
            "4$",
            "5%",
            "yY",
            "uU",
            "eE"
        ],
        "q": [
            ";:",
            "oO",
            "eE",
            "jJ",
            null,
            null
        ],
        "r": [
            "cC",
            "9(",
            "0)",
            "lL",
            "nN",
            "tT"
        ],
        "s": [
            "nN",
            "lL",
            "/?",
            "-_",
            "zZ",
            "vV"
        ],
        "t": [
            "hH",
            "cC",
            "rR",
            "nN",
            "wW",
            "mM"
        ],
        "u": [
            "eE",
            "pP",
            "yY",
            "iI",
            "kK",
            "jJ"
        ],
        "v": [
            "wW",
            "nN",
            "sS",
            "zZ",
            null,
            null
        ],
        "w": [
            "mM",
            "tT",
            "nN",
            "vV",
            null,
            null
        ],
        "x": [
            "kK",
            "iI",
            "dD",
            "bB",
            null,
            null
        ],
        "y": [
            "pP",
            "5%",
            "6^",
            "fF",
            "iI",
            "uU"
        ],
        "z": [
            "vV",
            "sS",
            "-_",
            null,
            null,
            null
        ],
        "{": [
            "0)",
            null,
            null,
            "]}",
            "/?",
            "lL"
        ],
        "|": [
            "=+",
            null,
            null,
            null,
            null,
            null
        ],
        "}": [
            "[{",
            null,
            null,
            null,
            "=+",
            "/?"
        ],
        "~": [
            null,
            null,
            null,
            "1!",
            null,
            null
        ]
    },
    keypad: {
        "*": [
            "/",
            null,
            null,
            null,
            "-",
            "+",
            "9",
            "8"
        ],
        "+": [
            "9",
            "*",
            "-",
            null,
            null,
            null,
            null,
            "6"
        ],
        "-": [
            "*",
            null,
            null,
            null,
            null,
            null,
            "+",
            "9"
        ],
        ".": [
            "0",
            "2",
            "3",
            null,
            null,
            null,
            null,
            null
        ],
        "/": [
            null,
            null,
            null,
            null,
            "*",
            "9",
            "8",
            "7"
        ],
        "0": [
            null,
            "1",
            "2",
            "3",
            ".",
            null,
            null,
            null
        ],
        "1": [
            null,
            null,
            "4",
            "5",
            "2",
            "0",
            null,
            null
        ],
        "2": [
            "1",
            "4",
            "5",
            "6",
            "3",
            ".",
            "0",
            null
        ],
        "3": [
            "2",
            "5",
            "6",
            null,
            null,
            null,
            ".",
            "0"
        ],
        "4": [
            null,
            null,
            "7",
            "8",
            "5",
            "2",
            "1",
            null
        ],
        "5": [
            "4",
            "7",
            "8",
            "9",
            "6",
            "3",
            "2",
            "1"
        ],
        "6": [
            "5",
            "8",
            "9",
            "+",
            null,
            null,
            "3",
            "2"
        ],
        "7": [
            null,
            null,
            null,
            "/",
            "8",
            "5",
            "4",
            null
        ],
        "8": [
            "7",
            null,
            "/",
            "*",
            "9",
            "6",
            "5",
            "4"
        ],
        "9": [
            "8",
            "/",
            "*",
            "-",
            "+",
            null,
            "6",
            "5"
        ]
    },
    mac_keypad: {
        "*": [
            "/",
            null,
            null,
            null,
            null,
            null,
            "-",
            "9"
        ],
        "+": [
            "6",
            "9",
            "-",
            null,
            null,
            null,
            null,
            "3"
        ],
        "-": [
            "9",
            "/",
            "*",
            null,
            null,
            null,
            "+",
            "6"
        ],
        ".": [
            "0",
            "2",
            "3",
            null,
            null,
            null,
            null,
            null
        ],
        "/": [
            "=",
            null,
            null,
            null,
            "*",
            "-",
            "9",
            "8"
        ],
        "0": [
            null,
            "1",
            "2",
            "3",
            ".",
            null,
            null,
            null
        ],
        "1": [
            null,
            null,
            "4",
            "5",
            "2",
            "0",
            null,
            null
        ],
        "2": [
            "1",
            "4",
            "5",
            "6",
            "3",
            ".",
            "0",
            null
        ],
        "3": [
            "2",
            "5",
            "6",
            "+",
            null,
            null,
            ".",
            "0"
        ],
        "4": [
            null,
            null,
            "7",
            "8",
            "5",
            "2",
            "1",
            null
        ],
        "5": [
            "4",
            "7",
            "8",
            "9",
            "6",
            "3",
            "2",
            "1"
        ],
        "6": [
            "5",
            "8",
            "9",
            "-",
            "+",
            null,
            "3",
            "2"
        ],
        "7": [
            null,
            null,
            null,
            "=",
            "8",
            "5",
            "4",
            null
        ],
        "8": [
            "7",
            null,
            "=",
            "/",
            "9",
            "6",
            "5",
            "4"
        ],
        "9": [
            "8",
            "=",
            "/",
            "*",
            "-",
            "+",
            "6",
            "5"
        ],
        "=": [
            null,
            null,
            null,
            null,
            "/",
            "9",
            "8",
            "7"
        ]
    }
};
module.exports = $0d2224905bd79a69$var$adjacency_graphs;

});

parcelRegister("1dnRX", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $0e29854ab93c05f4$var$BRUTEFORCE_CARDINALITY, $0e29854ab93c05f4$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE, $0e29854ab93c05f4$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR, $0e29854ab93c05f4$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR, $0e29854ab93c05f4$var$adjacency_graphs, $0e29854ab93c05f4$var$calc_average_degree, $0e29854ab93c05f4$var$k, $0e29854ab93c05f4$var$scoring, $0e29854ab93c05f4$var$v;

$0e29854ab93c05f4$var$adjacency_graphs = (parcelRequire("17UkK"));
$0e29854ab93c05f4$var$calc_average_degree = function(graph) {
    var average, k, key, n, neighbors, v;
    average = 0;
    for(key in graph){
        neighbors = graph[key];
        average += function() {
            var len, o, results;
            results = [];
            for(o = 0, len = neighbors.length; o < len; o++){
                n = neighbors[o];
                if (n) results.push(n);
            }
            return results;
        }().length;
    }
    average /= function() {
        var results;
        results = [];
        for(k in graph){
            v = graph[k];
            results.push(k);
        }
        return results;
    }().length;
    return average;
};
$0e29854ab93c05f4$var$BRUTEFORCE_CARDINALITY = 10;
$0e29854ab93c05f4$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE = 10000;
$0e29854ab93c05f4$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR = 10;
$0e29854ab93c05f4$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR = 50;
$0e29854ab93c05f4$var$scoring = {
    nCk: function(n, k) {
        var d, o, r, ref;
        if (k > n) return 0;
        if (k === 0) return 1;
        r = 1;
        for(d = o = 1, ref = k; 1 <= ref ? o <= ref : o >= ref; d = 1 <= ref ? ++o : --o){
            r *= n;
            r /= d;
            n -= 1;
        }
        return r;
    },
    log10: function(n) {
        return Math.log(n) / Math.log(10);
    },
    log2: function(n) {
        return Math.log(n) / Math.log(2);
    },
    factorial: function(n) {
        var f, i, o, ref;
        if (n < 2) return 1;
        f = 1;
        for(i = o = 2, ref = n; 2 <= ref ? o <= ref : o >= ref; i = 2 <= ref ? ++o : --o)f *= i;
        return f;
    },
    most_guessable_match_sequence: function(password, matches, _exclude_additive) {
        var _, bruteforce_update, guesses, k, l, len, len1, len2, lst, m, make_bruteforce_match, matches_by_j, n, o, optimal, optimal_l, optimal_match_sequence, q, ref, ref1, u, unwind, update, w;
        if (_exclude_additive == null) _exclude_additive = false;
        n = password.length;
        matches_by_j = function() {
            var o, ref, results;
            results = [];
            for(_ = o = 0, ref = n; 0 <= ref ? o < ref : o > ref; _ = 0 <= ref ? ++o : --o)results.push([]);
            return results;
        }();
        for(o = 0, len = matches.length; o < len; o++){
            m = matches[o];
            matches_by_j[m.j].push(m);
        }
        for(q = 0, len1 = matches_by_j.length; q < len1; q++){
            lst = matches_by_j[q];
            lst.sort(function(m1, m2) {
                return m1.i - m2.i;
            });
        }
        optimal = {
            m: function() {
                var ref, results, u;
                results = [];
                for(_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u)results.push({});
                return results;
            }(),
            pi: function() {
                var ref, results, u;
                results = [];
                for(_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u)results.push({});
                return results;
            }(),
            g: function() {
                var ref, results, u;
                results = [];
                for(_ = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; _ = 0 <= ref ? ++u : --u)results.push({});
                return results;
            }()
        };
        update = function(_this) {
            return function(m, l) {
                var competing_g, competing_l, g, k, pi, ref;
                k = m.j;
                pi = _this.estimate_guesses(m, password);
                if (l > 1) pi *= optimal.pi[m.i - 1][l - 1];
                g = _this.factorial(l) * pi;
                if (!_exclude_additive) g += Math.pow($0e29854ab93c05f4$var$MIN_GUESSES_BEFORE_GROWING_SEQUENCE, l - 1);
                ref = optimal.g[k];
                for(competing_l in ref){
                    competing_g = ref[competing_l];
                    if (competing_l > l) continue;
                    if (competing_g <= g) return;
                }
                optimal.g[k][l] = g;
                optimal.m[k][l] = m;
                return optimal.pi[k][l] = pi;
            };
        }(this);
        bruteforce_update = function(_this) {
            return function(k) {
                var i, l, last_m, ref, results, u;
                m = make_bruteforce_match(0, k);
                update(m, 1);
                results = [];
                for(i = u = 1, ref = k; 1 <= ref ? u <= ref : u >= ref; i = 1 <= ref ? ++u : --u){
                    m = make_bruteforce_match(i, k);
                    results.push(function() {
                        var ref1, results1;
                        ref1 = optimal.m[i - 1];
                        results1 = [];
                        for(l in ref1){
                            last_m = ref1[l];
                            l = parseInt(l);
                            if (last_m.pattern === 'bruteforce') continue;
                            results1.push(update(m, l + 1));
                        }
                        return results1;
                    }());
                }
                return results;
            };
        }(this);
        make_bruteforce_match = function(_this) {
            return function(i, j) {
                return {
                    pattern: 'bruteforce',
                    token: password.slice(i, +j + 1 || 9e9),
                    i: i,
                    j: j
                };
            };
        }(this);
        unwind = function(_this) {
            return function(n) {
                var candidate_g, candidate_l, g, k, l, optimal_match_sequence, ref;
                optimal_match_sequence = [];
                k = n - 1;
                l = void 0;
                g = Infinity;
                ref = optimal.g[k];
                for(candidate_l in ref){
                    candidate_g = ref[candidate_l];
                    if (candidate_g < g) {
                        l = candidate_l;
                        g = candidate_g;
                    }
                }
                while(k >= 0){
                    m = optimal.m[k][l];
                    optimal_match_sequence.unshift(m);
                    k = m.i - 1;
                    l--;
                }
                return optimal_match_sequence;
            };
        }(this);
        for(k = u = 0, ref = n; 0 <= ref ? u < ref : u > ref; k = 0 <= ref ? ++u : --u){
            ref1 = matches_by_j[k];
            for(w = 0, len2 = ref1.length; w < len2; w++){
                m = ref1[w];
                if (m.i > 0) for(l in optimal.m[m.i - 1]){
                    l = parseInt(l);
                    update(m, l + 1);
                }
                else update(m, 1);
            }
            bruteforce_update(k);
        }
        optimal_match_sequence = unwind(n);
        optimal_l = optimal_match_sequence.length;
        if (password.length === 0) guesses = 1;
        else guesses = optimal.g[n - 1][optimal_l];
        return {
            password: password,
            guesses: guesses,
            guesses_log10: this.log10(guesses),
            sequence: optimal_match_sequence
        };
    },
    estimate_guesses: function(match, password) {
        var estimation_functions, guesses, min_guesses;
        if (match.guesses != null) return match.guesses;
        min_guesses = 1;
        if (match.token.length < password.length) min_guesses = match.token.length === 1 ? $0e29854ab93c05f4$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR : $0e29854ab93c05f4$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR;
        estimation_functions = {
            bruteforce: this.bruteforce_guesses,
            dictionary: this.dictionary_guesses,
            spatial: this.spatial_guesses,
            repeat: this.repeat_guesses,
            sequence: this.sequence_guesses,
            regex: this.regex_guesses,
            date: this.date_guesses
        };
        guesses = estimation_functions[match.pattern].call(this, match);
        match.guesses = Math.max(guesses, min_guesses);
        match.guesses_log10 = this.log10(match.guesses);
        return match.guesses;
    },
    bruteforce_guesses: function(match) {
        var guesses, min_guesses;
        guesses = Math.pow($0e29854ab93c05f4$var$BRUTEFORCE_CARDINALITY, match.token.length);
        if (guesses === Number.POSITIVE_INFINITY) guesses = Number.MAX_VALUE;
        min_guesses = match.token.length === 1 ? $0e29854ab93c05f4$var$MIN_SUBMATCH_GUESSES_SINGLE_CHAR + 1 : $0e29854ab93c05f4$var$MIN_SUBMATCH_GUESSES_MULTI_CHAR + 1;
        return Math.max(guesses, min_guesses);
    },
    repeat_guesses: function(match) {
        return match.base_guesses * match.repeat_count;
    },
    sequence_guesses: function(match) {
        var base_guesses, first_chr;
        first_chr = match.token.charAt(0);
        if (first_chr === 'a' || first_chr === 'A' || first_chr === 'z' || first_chr === 'Z' || first_chr === '0' || first_chr === '1' || first_chr === '9') base_guesses = 4;
        else if (first_chr.match(/\d/)) base_guesses = 10;
        else base_guesses = 26;
        if (!match.ascending) base_guesses *= 2;
        return base_guesses * match.token.length;
    },
    MIN_YEAR_SPACE: 20,
    REFERENCE_YEAR: new Date().getFullYear(),
    regex_guesses: function(match) {
        var char_class_bases, year_space;
        char_class_bases = {
            alpha_lower: 26,
            alpha_upper: 26,
            alpha: 52,
            alphanumeric: 62,
            digits: 10,
            symbols: 33
        };
        if (match.regex_name in char_class_bases) return Math.pow(char_class_bases[match.regex_name], match.token.length);
        else switch(match.regex_name){
            case 'recent_year':
                year_space = Math.abs(parseInt(match.regex_match[0]) - this.REFERENCE_YEAR);
                year_space = Math.max(year_space, this.MIN_YEAR_SPACE);
                return year_space;
        }
    },
    date_guesses: function(match) {
        var guesses, year_space;
        year_space = Math.max(Math.abs(match.year - this.REFERENCE_YEAR), this.MIN_YEAR_SPACE);
        guesses = year_space * 365;
        if (match.separator) guesses *= 4;
        return guesses;
    },
    KEYBOARD_AVERAGE_DEGREE: $0e29854ab93c05f4$var$calc_average_degree($0e29854ab93c05f4$var$adjacency_graphs.qwerty),
    KEYPAD_AVERAGE_DEGREE: $0e29854ab93c05f4$var$calc_average_degree($0e29854ab93c05f4$var$adjacency_graphs.keypad),
    KEYBOARD_STARTING_POSITIONS: function() {
        var ref, results;
        ref = $0e29854ab93c05f4$var$adjacency_graphs.qwerty;
        results = [];
        for($0e29854ab93c05f4$var$k in ref){
            $0e29854ab93c05f4$var$v = ref[$0e29854ab93c05f4$var$k];
            results.push($0e29854ab93c05f4$var$k);
        }
        return results;
    }().length,
    KEYPAD_STARTING_POSITIONS: function() {
        var ref, results;
        ref = $0e29854ab93c05f4$var$adjacency_graphs.keypad;
        results = [];
        for($0e29854ab93c05f4$var$k in ref){
            $0e29854ab93c05f4$var$v = ref[$0e29854ab93c05f4$var$k];
            results.push($0e29854ab93c05f4$var$k);
        }
        return results;
    }().length,
    spatial_guesses: function(match) {
        var L, S, U, d, guesses, i, j, o, possible_turns, q, ref, ref1, ref2, ref3, s, shifted_variations, t, u;
        if ((ref = match.graph) === 'qwerty' || ref === 'dvorak') {
            s = this.KEYBOARD_STARTING_POSITIONS;
            d = this.KEYBOARD_AVERAGE_DEGREE;
        } else {
            s = this.KEYPAD_STARTING_POSITIONS;
            d = this.KEYPAD_AVERAGE_DEGREE;
        }
        guesses = 0;
        L = match.token.length;
        t = match.turns;
        for(i = o = 2, ref1 = L; 2 <= ref1 ? o <= ref1 : o >= ref1; i = 2 <= ref1 ? ++o : --o){
            possible_turns = Math.min(t, i - 1);
            for(j = q = 1, ref2 = possible_turns; 1 <= ref2 ? q <= ref2 : q >= ref2; j = 1 <= ref2 ? ++q : --q)guesses += this.nCk(i - 1, j - 1) * s * Math.pow(d, j);
        }
        if (match.shifted_count) {
            S = match.shifted_count;
            U = match.token.length - match.shifted_count;
            if (S === 0 || U === 0) guesses *= 2;
            else {
                shifted_variations = 0;
                for(i = u = 1, ref3 = Math.min(S, U); 1 <= ref3 ? u <= ref3 : u >= ref3; i = 1 <= ref3 ? ++u : --u)shifted_variations += this.nCk(S + U, i);
                guesses *= shifted_variations;
            }
        }
        return guesses;
    },
    dictionary_guesses: function(match) {
        var reversed_variations;
        match.base_guesses = match.rank;
        match.uppercase_variations = this.uppercase_variations(match);
        match.l33t_variations = this.l33t_variations(match);
        reversed_variations = match.reversed && 2 || 1;
        return match.base_guesses * match.uppercase_variations * match.l33t_variations * reversed_variations;
    },
    START_UPPER: /^[A-Z][^A-Z]+$/,
    END_UPPER: /^[^A-Z]+[A-Z]$/,
    ALL_UPPER: /^[^a-z]+$/,
    ALL_LOWER: /^[^A-Z]+$/,
    uppercase_variations: function(match) {
        var L, U, chr, i, len, o, q, ref, ref1, regex, variations, word;
        word = match.token;
        if (word.match(this.ALL_LOWER) || word.toLowerCase() === word) return 1;
        ref = [
            this.START_UPPER,
            this.END_UPPER,
            this.ALL_UPPER
        ];
        for(o = 0, len = ref.length; o < len; o++){
            regex = ref[o];
            if (word.match(regex)) return 2;
        }
        U = function() {
            var len1, q, ref1, results;
            ref1 = word.split('');
            results = [];
            for(q = 0, len1 = ref1.length; q < len1; q++){
                chr = ref1[q];
                if (chr.match(/[A-Z]/)) results.push(chr);
            }
            return results;
        }().length;
        L = function() {
            var len1, q, ref1, results;
            ref1 = word.split('');
            results = [];
            for(q = 0, len1 = ref1.length; q < len1; q++){
                chr = ref1[q];
                if (chr.match(/[a-z]/)) results.push(chr);
            }
            return results;
        }().length;
        variations = 0;
        for(i = q = 1, ref1 = Math.min(U, L); 1 <= ref1 ? q <= ref1 : q >= ref1; i = 1 <= ref1 ? ++q : --q)variations += this.nCk(U + L, i);
        return variations;
    },
    l33t_variations: function(match) {
        var S, U, chr, chrs, i, o, p, possibilities, ref, ref1, subbed, unsubbed, variations;
        if (!match.l33t) return 1;
        variations = 1;
        ref = match.sub;
        for(subbed in ref){
            unsubbed = ref[subbed];
            chrs = match.token.toLowerCase().split('');
            S = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = chrs.length; o < len; o++){
                    chr = chrs[o];
                    if (chr === subbed) results.push(chr);
                }
                return results;
            }().length;
            U = function() {
                var len, o, results;
                results = [];
                for(o = 0, len = chrs.length; o < len; o++){
                    chr = chrs[o];
                    if (chr === unsubbed) results.push(chr);
                }
                return results;
            }().length;
            if (S === 0 || U === 0) variations *= 2;
            else {
                p = Math.min(U, S);
                possibilities = 0;
                for(i = o = 1, ref1 = p; 1 <= ref1 ? o <= ref1 : o >= ref1; i = 1 <= ref1 ? ++o : --o)possibilities += this.nCk(U + S, i);
                variations *= possibilities;
            }
        }
        return variations;
    }
};
module.exports = $0e29854ab93c05f4$var$scoring;

});


parcelRegister("aJyxA", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $7d08e666561af2f7$var$time_estimates;
$7d08e666561af2f7$var$time_estimates = {
    estimate_attack_times: function(guesses) {
        var crack_times_display, crack_times_seconds, scenario, seconds;
        crack_times_seconds = {
            online_throttling_100_per_hour: guesses / (100 / 3600),
            online_no_throttling_10_per_second: guesses / 10,
            offline_slow_hashing_1e4_per_second: guesses / 1e4,
            offline_fast_hashing_1e10_per_second: guesses / 1e10
        };
        crack_times_display = {};
        for(scenario in crack_times_seconds){
            seconds = crack_times_seconds[scenario];
            crack_times_display[scenario] = this.display_time(seconds);
        }
        return {
            crack_times_seconds: crack_times_seconds,
            crack_times_display: crack_times_display,
            score: this.guesses_to_score(guesses)
        };
    },
    guesses_to_score: function(guesses) {
        var DELTA;
        DELTA = 5;
        if (guesses < 1e3 + DELTA) return 0;
        else if (guesses < 1e6 + DELTA) return 1;
        else if (guesses < 1e8 + DELTA) return 2;
        else if (guesses < 1e10 + DELTA) return 3;
        else return 4;
    },
    display_time: function(seconds) {
        var base, century, day, display_num, display_str, hour, minute, month, ref, year;
        minute = 60;
        hour = minute * 60;
        day = hour * 24;
        month = day * 31;
        year = month * 12;
        century = year * 100;
        ref = seconds < 1 ? [
            null,
            'less than a second'
        ] : seconds < minute ? (base = Math.round(seconds), [
            base,
            base + " second"
        ]) : seconds < hour ? (base = Math.round(seconds / minute), [
            base,
            base + " minute"
        ]) : seconds < day ? (base = Math.round(seconds / hour), [
            base,
            base + " hour"
        ]) : seconds < month ? (base = Math.round(seconds / day), [
            base,
            base + " day"
        ]) : seconds < year ? (base = Math.round(seconds / month), [
            base,
            base + " month"
        ]) : seconds < century ? (base = Math.round(seconds / year), [
            base,
            base + " year"
        ]) : [
            null,
            'centuries'
        ], display_num = ref[0], display_str = ref[1];
        if (display_num != null && display_num !== 1) display_str += 's';
        return display_str;
    }
};
module.exports = $7d08e666561af2f7$var$time_estimates;

});

parcelRegister("74Z83", function(module, exports) {
// Generated by CoffeeScript 1.10.0
var $015485780e62a9b7$var$feedback, $015485780e62a9b7$var$scoring;

$015485780e62a9b7$var$scoring = (parcelRequire("1dnRX"));
$015485780e62a9b7$var$feedback = {
    default_feedback: {
        warning: '',
        suggestions: [
            "Use a few words, avoid common phrases",
            "No need for symbols, digits, or uppercase letters"
        ]
    },
    get_feedback: function(score, sequence) {
        var extra_feedback, i, len, longest_match, match, ref;
        if (sequence.length === 0) return this.default_feedback;
        if (score > 2) return {
            warning: '',
            suggestions: []
        };
        longest_match = sequence[0];
        ref = sequence.slice(1);
        for(i = 0, len = ref.length; i < len; i++){
            match = ref[i];
            if (match.token.length > longest_match.token.length) longest_match = match;
        }
        $015485780e62a9b7$var$feedback = this.get_match_feedback(longest_match, sequence.length === 1);
        extra_feedback = 'Add another word or two. Uncommon words are better.';
        if ($015485780e62a9b7$var$feedback != null) {
            $015485780e62a9b7$var$feedback.suggestions.unshift(extra_feedback);
            if ($015485780e62a9b7$var$feedback.warning == null) $015485780e62a9b7$var$feedback.warning = '';
        } else $015485780e62a9b7$var$feedback = {
            warning: '',
            suggestions: [
                extra_feedback
            ]
        };
        return $015485780e62a9b7$var$feedback;
    },
    get_match_feedback: function(match, is_sole_match) {
        var layout, warning;
        switch(match.pattern){
            case 'dictionary':
                return this.get_dictionary_match_feedback(match, is_sole_match);
            case 'spatial':
                layout = match.graph.toUpperCase();
                warning = match.turns === 1 ? 'Straight rows of keys are easy to guess' : 'Short keyboard patterns are easy to guess';
                return {
                    warning: warning,
                    suggestions: [
                        'Use a longer keyboard pattern with more turns'
                    ]
                };
            case 'repeat':
                warning = match.base_token.length === 1 ? 'Repeats like "aaa" are easy to guess' : 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"';
                return {
                    warning: warning,
                    suggestions: [
                        'Avoid repeated words and characters'
                    ]
                };
            case 'sequence':
                return {
                    warning: "Sequences like abc or 6543 are easy to guess",
                    suggestions: [
                        'Avoid sequences'
                    ]
                };
            case 'regex':
                if (match.regex_name === 'recent_year') return {
                    warning: "Recent years are easy to guess",
                    suggestions: [
                        'Avoid recent years',
                        'Avoid years that are associated with you'
                    ]
                };
                break;
            case 'date':
                return {
                    warning: "Dates are often easy to guess",
                    suggestions: [
                        'Avoid dates and years that are associated with you'
                    ]
                };
        }
    },
    get_dictionary_match_feedback: function(match, is_sole_match) {
        var ref, result, suggestions, warning, word;
        warning = match.dictionary_name === 'passwords' ? is_sole_match && !match.l33t && !match.reversed ? match.rank <= 10 ? 'This is a top-10 common password' : match.rank <= 100 ? 'This is a top-100 common password' : 'This is a very common password' : match.guesses_log10 <= 4 ? 'This is similar to a commonly used password' : void 0 : match.dictionary_name === 'english_wikipedia' ? is_sole_match ? 'A word by itself is easy to guess' : void 0 : (ref = match.dictionary_name) === 'surnames' || ref === 'male_names' || ref === 'female_names' ? is_sole_match ? 'Names and surnames by themselves are easy to guess' : 'Common names and surnames are easy to guess' : '';
        suggestions = [];
        word = match.token;
        if (word.match($015485780e62a9b7$var$scoring.START_UPPER)) suggestions.push("Capitalization doesn't help very much");
        else if (word.match($015485780e62a9b7$var$scoring.ALL_UPPER) && word.toLowerCase() !== word) suggestions.push("All-uppercase is almost as easy to guess as all-lowercase");
        if (match.reversed && match.token.length >= 4) suggestions.push("Reversed words aren't much harder to guess");
        if (match.l33t) suggestions.push("Predictable substitutions like '@' instead of 'a' don't help very much");
        result = {
            warning: warning,
            suggestions: suggestions
        };
        return result;
    }
};
module.exports = $015485780e62a9b7$var$feedback;

});



parcelRegister("Lv0sg", function(module, exports) {

var $crM7S = parcelRequire("crM7S");

var $lHnfk = parcelRequire("lHnfk");
"use strict";
// workaround until we move away from our MFA, this will decode the QR and allows to send it back to the api so we can
// store it in case we want to rollback to the old MFA system
const $08ec711d15058bc6$var$qrDecoder = {
    add: function(app) {
        app.ports.decodePort.subscribe((base64)=>{
            const qrcode = new (0, $crM7S.Decoder)();
            qrcode.scan(base64).then(({ data: data })=>{
                app.ports.onDecodePort.send(data);
            }).catch((error)=>{
                $lHnfk.captureMessage(error);
            });
        });
    }
};
module.exports = $08ec711d15058bc6$var$qrDecoder;

});
parcelRegister("crM7S", function(module, exports) {

$parcel$export(module.exports, "Decoder", function () { return $90fd568047b89463$export$f9de6ca0bc043724; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ 
var $iuaqv = parcelRequire("iuaqv");

var $2zdnb = parcelRequire("2zdnb");

var $5xQFI = parcelRequire("5xQFI");

var $aSvPT = parcelRequire("aSvPT");
/**
 * @module QRCode
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ function $90fd568047b89463$var$scan(matrix) {
    const locations = (0, $iuaqv.locate)(matrix);
    if (locations === null) return null;
    for (const location of locations){
        const extracted = (0, $2zdnb.extract)(matrix, location);
        const decoded = (0, $5xQFI.decode)(extracted.matrix);
        if (decoded !== null) {
            const dimension = location.dimension;
            return Object.assign(Object.assign({}, decoded), {
                location: {
                    topLeft: extracted.mappingFunction(0, 0),
                    topRight: extracted.mappingFunction(dimension, 0),
                    bottomLeft: extracted.mappingFunction(0, dimension),
                    bottomRight: extracted.mappingFunction(dimension, dimension),
                    topLeftFinder: location.topLeft,
                    topRightFinder: location.topRight,
                    bottomLeftFinder: location.bottomLeft,
                    bottomRightAlignment: decoded.version > 1 ? location.alignmentPattern : null
                }
            });
        }
    }
    return null;
}
function $90fd568047b89463$var$disposeImageEvents(image) {
    image.onload = null;
    image.onerror = null;
}
class $90fd568047b89463$export$f9de6ca0bc043724 {
    constructor(options = {}){
        this.options = options;
    }
    /**
     * @public
     * @method setOptions
     * @param {object} options
     */ setOptions(options) {
        this.options = Object.assign(Object.assign({}, this.options), options);
        return this;
    }
    /**
     * @public
     * @method decode
     * @param {Uint8ClampedArray} data
     * @param {number} width
     * @param {number} height
     * @returns {DecoderResult}
     */ decode(data, width, height) {
        const { options: options } = this;
        const { canOverwriteImage: canOverwriteImage, greyScaleWeights: greyScaleWeights, inversionAttempts: inversionAttempts = 'attemptBoth' } = options;
        const tryInvertedFirst = inversionAttempts === 'onlyInvert' || inversionAttempts === 'invertFirst';
        const invert = tryInvertedFirst || inversionAttempts === 'attemptBoth';
        const { binarized: binarized, inverted: inverted } = (0, $aSvPT.binarize)(data, width, height, invert, greyScaleWeights, canOverwriteImage);
        let result = $90fd568047b89463$var$scan(tryInvertedFirst ? inverted : binarized);
        if (result !== null && (options.inversionAttempts === 'attemptBoth' || options.inversionAttempts === 'invertFirst')) result = $90fd568047b89463$var$scan(tryInvertedFirst ? binarized : inverted);
        return result;
    }
    /**
     * @public
     * @method scan
     * @param {string} src
     * @returns {Promise}
     */ scan(src) {
        return new Promise((resolve, reject)=>{
            const image = new Image();
            // Image cross origin
            image.crossOrigin = 'anonymous';
            image.onload = ()=>{
                $90fd568047b89463$var$disposeImageEvents(image);
                const width = image.width;
                const height = image.height;
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                if (context === null) return reject(new Error(`browser does not support canvas.getContext('2d')`));
                canvas.width = width;
                canvas.height = height;
                context.drawImage(image, 0, 0);
                const { data: data } = context.getImageData(0, 0, width, height);
                const result = this.decode(data, width, height);
                if (result !== null) return resolve(result);
                return reject(new Error('failed to decode image'));
            };
            image.onerror = ()=>{
                $90fd568047b89463$var$disposeImageEvents(image);
                reject(new Error(`failed to load image: ${src}`));
            };
            image.src = src;
        });
    }
}

});
parcelRegister("iuaqv", function(module, exports) {

$parcel$export(module.exports, "locate", function () { return $d7531dd5a2e54969$export$5200e0c7549d7bff; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ /**
 * @module locator
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ const $d7531dd5a2e54969$var$MIN_QUAD_RATIO = 0.5;
const $d7531dd5a2e54969$var$MAX_QUAD_RATIO = 1.5;
const $d7531dd5a2e54969$var$MAX_FINDERPATTERNS_TO_SEARCH = 4;
function $d7531dd5a2e54969$var$distance(a, b) {
    return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
}
function $d7531dd5a2e54969$var$sum(values) {
    return values.reduce((a, b)=>a + b);
}
// Takes three finder patterns and organizes them into topLeft, topRight, etc
function $d7531dd5a2e54969$var$reorderFinderPatterns(pattern1, pattern2, pattern3) {
    // Find distances between pattern centers
    const oneTwoDistance = $d7531dd5a2e54969$var$distance(pattern1, pattern2);
    const twoThreeDistance = $d7531dd5a2e54969$var$distance(pattern2, pattern3);
    const oneThreeDistance = $d7531dd5a2e54969$var$distance(pattern1, pattern3);
    let topLeft;
    let topRight;
    let bottomLeft;
    // Assume one closest to other two is B; A and C will just be guesses at first
    if (twoThreeDistance >= oneTwoDistance && twoThreeDistance >= oneThreeDistance) [bottomLeft, topLeft, topRight] = [
        pattern2,
        pattern1,
        pattern3
    ];
    else if (oneThreeDistance >= twoThreeDistance && oneThreeDistance >= oneTwoDistance) [bottomLeft, topLeft, topRight] = [
        pattern1,
        pattern2,
        pattern3
    ];
    else [bottomLeft, topLeft, topRight] = [
        pattern1,
        pattern3,
        pattern2
    ];
    // Use cross product to figure out whether bottomLeft (A) and topRight (C) are correct or flipped in relation to topLeft (B)
    // This asks whether BC x BA has a positive z component, which is the arrangement we want. If it's negative, then
    // we've got it flipped around and should swap topRight and bottomLeft.
    if ((topRight.x - topLeft.x) * (bottomLeft.y - topLeft.y) - (topRight.y - topLeft.y) * (bottomLeft.x - topLeft.x) < 0) [bottomLeft, topRight] = [
        topRight,
        bottomLeft
    ];
    return {
        bottomLeft: bottomLeft,
        topLeft: topLeft,
        topRight: topRight
    };
}
// Computes the dimension (number of modules on a side) of the QR Code based on the position of the finder patterns
function $d7531dd5a2e54969$var$computeDimension(topLeft, topRight, bottomLeft, matrix) {
    // Divide by 7 since the ratio is 1:1:3:1:1
    const moduleSize = ($d7531dd5a2e54969$var$sum($d7531dd5a2e54969$var$countBlackWhiteRun(topLeft, bottomLeft, matrix, 5)) / 7 + $d7531dd5a2e54969$var$sum($d7531dd5a2e54969$var$countBlackWhiteRun(topLeft, topRight, matrix, 5)) / 7 + $d7531dd5a2e54969$var$sum($d7531dd5a2e54969$var$countBlackWhiteRun(bottomLeft, topLeft, matrix, 5)) / 7 + $d7531dd5a2e54969$var$sum($d7531dd5a2e54969$var$countBlackWhiteRun(topRight, topLeft, matrix, 5)) / 7) / 4;
    if (moduleSize < 1) throw new Error('invalid module size');
    const topDimension = Math.round($d7531dd5a2e54969$var$distance(topLeft, topRight) / moduleSize);
    const sideDimension = Math.round($d7531dd5a2e54969$var$distance(topLeft, bottomLeft) / moduleSize);
    let dimension = Math.floor((topDimension + sideDimension) / 2) + 7;
    switch(dimension % 4){
        case 0:
            dimension++;
            break;
        case 2:
            dimension--;
            break;
    }
    return {
        dimension: dimension,
        moduleSize: moduleSize
    };
}
// Takes an origin point and an end point and counts the sizes of the black white run from the origin towards the end point.
// Returns an array of elements, representing the pixel size of the black white run.
// Uses a variant of http://en.wikipedia.org/wiki/Bresenham's_line_algorithm
function $d7531dd5a2e54969$var$countBlackWhiteRunTowardsPoint(origin, end, matrix, length) {
    const switchPoints = [
        {
            x: Math.floor(origin.x),
            y: Math.floor(origin.y)
        }
    ];
    const steep = Math.abs(end.y - origin.y) > Math.abs(end.x - origin.x);
    let fromX;
    let fromY;
    let toX;
    let toY;
    if (steep) {
        fromX = Math.floor(origin.y);
        fromY = Math.floor(origin.x);
        toX = Math.floor(end.y);
        toY = Math.floor(end.x);
    } else {
        fromX = Math.floor(origin.x);
        fromY = Math.floor(origin.y);
        toX = Math.floor(end.x);
        toY = Math.floor(end.y);
    }
    const dx = Math.abs(toX - fromX);
    const dy = Math.abs(toY - fromY);
    const xStep = fromX < toX ? 1 : -1;
    const yStep = fromY < toY ? 1 : -1;
    let currentPixel = true;
    let error = Math.floor(-dx / 2);
    // Loop up until x == toX, but not beyond
    for(let x = fromX, y = fromY; x !== toX + xStep; x += xStep){
        // Does current pixel mean we have moved white to black or vice versa?
        // Scanning black in state 0,2 and white in state 1, so if we find the wrong
        // color, advance to next state or end if we are in state 2 already
        const realX = steep ? y : x;
        const realY = steep ? x : y;
        if (matrix.get(realX, realY) !== currentPixel) {
            currentPixel = !currentPixel;
            switchPoints.push({
                x: realX,
                y: realY
            });
            if (switchPoints.length === length + 1) break;
        }
        error += dy;
        if (error > 0) {
            if (y === toY) break;
            y += yStep;
            error -= dx;
        }
    }
    const distances = [];
    for(let i = 0; i < length; i++)if (switchPoints[i] && switchPoints[i + 1]) distances.push($d7531dd5a2e54969$var$distance(switchPoints[i], switchPoints[i + 1]));
    else distances.push(0);
    return distances;
}
// Takes an origin point and an end point and counts the sizes of the black white run in the origin point
// along the line that intersects with the end point. Returns an array of elements, representing the pixel sizes
// of the black white run. Takes a length which represents the number of switches from black to white to look for.
function $d7531dd5a2e54969$var$countBlackWhiteRun(origin, end, matrix, length) {
    const rise = end.y - origin.y;
    const run = end.x - origin.x;
    const towardsEnd = $d7531dd5a2e54969$var$countBlackWhiteRunTowardsPoint(origin, end, matrix, Math.ceil(length / 2));
    const awayFromEnd = $d7531dd5a2e54969$var$countBlackWhiteRunTowardsPoint(origin, {
        x: origin.x - run,
        y: origin.y - rise
    }, matrix, Math.ceil(length / 2));
    const middleValue = towardsEnd.shift() + awayFromEnd.shift() - 1; // Substract one so we don't double count a pixel
    return awayFromEnd.concat(middleValue).concat(...towardsEnd);
}
// Takes in a black white run and an array of expected ratios. Returns the average size of the run as well as the "error" -
// that is the amount the run diverges from the expected ratio
function $d7531dd5a2e54969$var$scoreBlackWhiteRun(sequence, ratios) {
    const averageSize = $d7531dd5a2e54969$var$sum(sequence) / $d7531dd5a2e54969$var$sum(ratios);
    let error = 0;
    ratios.forEach((ratio, i)=>{
        error += Math.pow(sequence[i] - ratio * averageSize, 2);
    });
    return {
        averageSize: averageSize,
        error: error
    };
}
// Takes an X,Y point and an array of sizes and scores the point against those ratios.
// For example for a finder pattern takes the ratio list of 1:1:3:1:1 and checks horizontal, vertical and diagonal ratios
// against that.
function $d7531dd5a2e54969$var$scorePattern(point, ratios, matrix) {
    try {
        const horizontalRun = $d7531dd5a2e54969$var$countBlackWhiteRun(point, {
            x: -1,
            y: point.y
        }, matrix, ratios.length);
        const verticalRun = $d7531dd5a2e54969$var$countBlackWhiteRun(point, {
            x: point.x,
            y: -1
        }, matrix, ratios.length);
        const topLeftPoint = {
            x: Math.max(0, point.x - point.y) - 1,
            y: Math.max(0, point.y - point.x) - 1
        };
        const topLeftBottomRightRun = $d7531dd5a2e54969$var$countBlackWhiteRun(point, topLeftPoint, matrix, ratios.length);
        const bottomLeftPoint = {
            x: Math.min(matrix.width, point.x + point.y) + 1,
            y: Math.min(matrix.height, point.y + point.x) + 1
        };
        const bottomLeftTopRightRun = $d7531dd5a2e54969$var$countBlackWhiteRun(point, bottomLeftPoint, matrix, ratios.length);
        const horzError = $d7531dd5a2e54969$var$scoreBlackWhiteRun(horizontalRun, ratios);
        const vertError = $d7531dd5a2e54969$var$scoreBlackWhiteRun(verticalRun, ratios);
        const diagDownError = $d7531dd5a2e54969$var$scoreBlackWhiteRun(topLeftBottomRightRun, ratios);
        const diagUpError = $d7531dd5a2e54969$var$scoreBlackWhiteRun(bottomLeftTopRightRun, ratios);
        const ratioError = Math.sqrt(horzError.error * horzError.error + vertError.error * vertError.error + diagDownError.error * diagDownError.error + diagUpError.error * diagUpError.error);
        const avgSize = (horzError.averageSize + vertError.averageSize + diagDownError.averageSize + diagUpError.averageSize) / 4;
        const sizeError = (Math.pow(horzError.averageSize - avgSize, 2) + Math.pow(vertError.averageSize - avgSize, 2) + Math.pow(diagDownError.averageSize - avgSize, 2) + Math.pow(diagUpError.averageSize - avgSize, 2)) / avgSize;
        return ratioError + sizeError;
    } catch (_a) {
        return Infinity;
    }
}
function $d7531dd5a2e54969$var$recenterLocation(matrix, point) {
    let leftX = Math.round(point.x);
    while(matrix.get(leftX, Math.round(point.y)))leftX--;
    let rightX = Math.round(point.x);
    while(matrix.get(rightX, Math.round(point.y)))rightX++;
    const x = (leftX + rightX) / 2;
    let topY = Math.round(point.y);
    while(matrix.get(Math.round(x), topY))topY--;
    let bottomY = Math.round(point.y);
    while(matrix.get(Math.round(x), bottomY))bottomY++;
    const y = (topY + bottomY) / 2;
    return {
        x: x,
        y: y
    };
}
function $d7531dd5a2e54969$var$findAlignmentPattern(matrix, alignmentPatternQuads, topRight, topLeft, bottomLeft) {
    // Now that we've found the three finder patterns we can determine the blockSize and the size of the QR code.
    // We'll use these to help find the alignment pattern but also later when we do the extraction.
    let dimension;
    let moduleSize;
    try {
        ({ dimension: dimension, moduleSize: moduleSize } = $d7531dd5a2e54969$var$computeDimension(topLeft, topRight, bottomLeft, matrix));
    } catch (_a) {
        return null;
    }
    // Now find the alignment pattern
    const bottomRightFinderPattern = {
        // Best guess at where a bottomRight finder pattern would be
        x: topRight.x - topLeft.x + bottomLeft.x,
        y: topRight.y - topLeft.y + bottomLeft.y
    };
    const modulesBetweenFinderPatterns = ($d7531dd5a2e54969$var$distance(topLeft, bottomLeft) + $d7531dd5a2e54969$var$distance(topLeft, topRight)) / 2 / moduleSize;
    const correctionToTopLeft = 1 - 3 / modulesBetweenFinderPatterns;
    const expectedAlignmentPattern = {
        x: topLeft.x + correctionToTopLeft * (bottomRightFinderPattern.x - topLeft.x),
        y: topLeft.y + correctionToTopLeft * (bottomRightFinderPattern.y - topLeft.y)
    };
    const alignmentPatterns = alignmentPatternQuads.reduce((quads, { top: top, bottom: bottom })=>{
        const x = (top.startX + top.endX + bottom.startX + bottom.endX) / 4;
        const y = (top.y + bottom.y + 1) / 2;
        const intX = Math.floor(x);
        const intY = Math.floor(y);
        if (matrix.get(intX, intY)) {
            const sizeScore = $d7531dd5a2e54969$var$scorePattern({
                x: intX,
                y: intY
            }, [
                1,
                1,
                1
            ], matrix);
            const score = sizeScore + $d7531dd5a2e54969$var$distance({
                x: x,
                y: y
            }, expectedAlignmentPattern);
            quads.push({
                x: x,
                y: y,
                score: score
            });
        }
        return quads;
    }, []).sort((a, b)=>a.score - b.score);
    // If there are less than 15 modules between finder patterns it's a version 1 QR code and as such has no alignmemnt pattern
    // so we can only use our best guess.
    const alignmentPattern = modulesBetweenFinderPatterns >= 15 && alignmentPatterns.length ? alignmentPatterns[0] : expectedAlignmentPattern;
    return {
        alignmentPattern: alignmentPattern,
        dimension: dimension
    };
}
function $d7531dd5a2e54969$export$5200e0c7549d7bff(matrix) {
    const finderPatternQuads = [];
    const alignmentPatternQuads = [];
    let activeFinderPatternQuads = [];
    let activeAlignmentPatternQuads = [];
    for(let y = 0; y <= matrix.height; y++){
        let length = 0;
        let lastBit = false;
        let scans = [
            0,
            0,
            0,
            0,
            0
        ];
        for(let x = -1; x <= matrix.width; x++){
            const v = matrix.get(x, y);
            if (v === lastBit) length++;
            else {
                scans = [
                    scans[1],
                    scans[2],
                    scans[3],
                    scans[4],
                    length
                ];
                length = 1;
                lastBit = v;
                // Do the last 5 color changes ~ match the expected ratio for a finder pattern? 1:1:3:1:1 of b:w:b:w:b
                const averageFinderPatternBlocksize = $d7531dd5a2e54969$var$sum(scans) / 7;
                const validFinderPattern = Math.abs(scans[0] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[1] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[2] - 3 * averageFinderPatternBlocksize) < 3 * averageFinderPatternBlocksize && Math.abs(scans[3] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && Math.abs(scans[4] - averageFinderPatternBlocksize) < averageFinderPatternBlocksize && !v; // And make sure the current pixel is white since finder patterns are bordered in white
                // Do the last 3 color changes ~ match the expected ratio for an alignment pattern? 1:1:1 of w:b:w
                const averageAlignmentPatternBlocksize = $d7531dd5a2e54969$var$sum(scans.slice(-3)) / 3;
                const validAlignmentPattern = Math.abs(scans[2] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && Math.abs(scans[3] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && Math.abs(scans[4] - averageAlignmentPatternBlocksize) < averageAlignmentPatternBlocksize && v; // Is the current pixel black since alignment patterns are bordered in black
                if (validFinderPattern) {
                    // Compute the start and end x values of the large center black square
                    const endX = x - scans[3] - scans[4];
                    const startX = endX - scans[2];
                    const line = {
                        startX: startX,
                        endX: endX,
                        y: y
                    };
                    // Is there a quad directly above the current spot? If so, extend it with the new line. Otherwise, create a new quad with
                    // that line as the starting point.
                    const matchingQuads = activeFinderPatternQuads.filter((q)=>startX >= q.bottom.startX && startX <= q.bottom.endX || endX >= q.bottom.startX && startX <= q.bottom.endX || startX <= q.bottom.startX && endX >= q.bottom.endX && scans[2] / (q.bottom.endX - q.bottom.startX) < $d7531dd5a2e54969$var$MAX_QUAD_RATIO && scans[2] / (q.bottom.endX - q.bottom.startX) > $d7531dd5a2e54969$var$MIN_QUAD_RATIO);
                    if (matchingQuads.length > 0) matchingQuads[0].bottom = line;
                    else activeFinderPatternQuads.push({
                        top: line,
                        bottom: line
                    });
                }
                if (validAlignmentPattern) {
                    // Compute the start and end x values of the center black square
                    const endX = x - scans[4];
                    const startX = endX - scans[3];
                    const line = {
                        startX: startX,
                        y: y,
                        endX: endX
                    };
                    // Is there a quad directly above the current spot? If so, extend it with the new line. Otherwise, create a new quad with
                    // that line as the starting point.
                    const matchingQuads = activeAlignmentPatternQuads.filter((q)=>startX >= q.bottom.startX && startX <= q.bottom.endX || endX >= q.bottom.startX && startX <= q.bottom.endX || startX <= q.bottom.startX && endX >= q.bottom.endX && scans[2] / (q.bottom.endX - q.bottom.startX) < $d7531dd5a2e54969$var$MAX_QUAD_RATIO && scans[2] / (q.bottom.endX - q.bottom.startX) > $d7531dd5a2e54969$var$MIN_QUAD_RATIO);
                    if (matchingQuads.length > 0) matchingQuads[0].bottom = line;
                    else activeAlignmentPatternQuads.push({
                        top: line,
                        bottom: line
                    });
                }
            }
        }
        finderPatternQuads.push(...activeFinderPatternQuads.filter((q)=>q.bottom.y !== y && q.bottom.y - q.top.y >= 2));
        activeFinderPatternQuads = activeFinderPatternQuads.filter((q)=>q.bottom.y === y);
        alignmentPatternQuads.push(...activeAlignmentPatternQuads.filter((q)=>q.bottom.y !== y));
        activeAlignmentPatternQuads = activeAlignmentPatternQuads.filter((q)=>q.bottom.y === y);
    }
    finderPatternQuads.push(...activeFinderPatternQuads.filter((q)=>q.bottom.y - q.top.y >= 2));
    alignmentPatternQuads.push(...activeAlignmentPatternQuads);
    const finderPatterns = finderPatternQuads.reduce((quads, { top: top, bottom: bottom })=>{
        // All quads must be at least 2px tall since the center square is larger than a block
        if (bottom.y - top.y >= 2) {
            // Initial scoring of finder pattern quads by looking at their ratios, not taking into account position
            const x = (top.startX + top.endX + bottom.startX + bottom.endX) / 4;
            const y = (top.y + bottom.y + 1) / 2;
            const intX = Math.round(x);
            const intY = Math.round(y);
            if (matrix.get(intX, intY)) {
                const lengths = [
                    top.endX - top.startX,
                    bottom.endX - bottom.startX,
                    bottom.y - top.y + 1
                ];
                const size = $d7531dd5a2e54969$var$sum(lengths) / lengths.length;
                const score = $d7531dd5a2e54969$var$scorePattern({
                    x: intX,
                    y: intY
                }, [
                    1,
                    1,
                    3,
                    1,
                    1
                ], matrix);
                quads.push({
                    x: x,
                    y: y,
                    size: size,
                    score: score
                });
            }
        }
        return quads;
    }, []).sort((a, b)=>a.score - b.score);
    const finderPatternGroups = finderPatterns.reduce((points, point, index, finderPatterns)=>{
        if (index <= $d7531dd5a2e54969$var$MAX_FINDERPATTERNS_TO_SEARCH) {
            const otherPoints = finderPatterns.reduce((points, { x: x, y: y, size: size, score: score }, oIndex)=>{
                if (index !== oIndex) points.push({
                    x: x,
                    y: y,
                    size: size,
                    score: score + Math.pow(size - point.size, 2) / point.size
                });
                return points;
            }, []);
            if (otherPoints.length >= 2) {
                const score = point.score + otherPoints[0].score + otherPoints[1].score;
                points.push({
                    points: [
                        point
                    ].concat(otherPoints.sort((a, b)=>a.score - b.score).slice(0, 2)),
                    score: score
                });
            }
        }
        return points;
    }, []).sort((a, b)=>a.score - b.score);
    if (finderPatternGroups.length === 0) return null;
    const { topRight: topRight, topLeft: topLeft, bottomLeft: bottomLeft } = $d7531dd5a2e54969$var$reorderFinderPatterns(finderPatternGroups[0].points[0], finderPatternGroups[0].points[1], finderPatternGroups[0].points[2]);
    const result = [];
    const alignment = $d7531dd5a2e54969$var$findAlignmentPattern(matrix, alignmentPatternQuads, topRight, topLeft, bottomLeft);
    if (alignment !== null) result.push({
        alignmentPattern: {
            x: alignment.alignmentPattern.x,
            y: alignment.alignmentPattern.y
        },
        bottomLeft: {
            x: bottomLeft.x,
            y: bottomLeft.y
        },
        dimension: alignment.dimension,
        topLeft: {
            x: topLeft.x,
            y: topLeft.y
        },
        topRight: {
            x: topRight.x,
            y: topRight.y
        }
    });
    // We normally use the center of the quads as the location of the tracking points, which is optimal for most cases and will account
    // for a skew in the image. However, In some cases, a slight skew might not be real and instead be caused by image compression
    // errors and/or low resolution. For those cases, we'd be better off centering the point exactly in the middle of the black area. We
    // compute and return the location data for the naively centered points as it is little additional work and allows for multiple
    // attempts at decoding harder images.
    const midTopRight = $d7531dd5a2e54969$var$recenterLocation(matrix, topRight);
    const midTopLeft = $d7531dd5a2e54969$var$recenterLocation(matrix, topLeft);
    const midBottomLeft = $d7531dd5a2e54969$var$recenterLocation(matrix, bottomLeft);
    const centeredAlignment = $d7531dd5a2e54969$var$findAlignmentPattern(matrix, alignmentPatternQuads, midTopRight, midTopLeft, midBottomLeft);
    if (centeredAlignment !== null) result.push({
        alignmentPattern: {
            x: centeredAlignment.alignmentPattern.x,
            y: centeredAlignment.alignmentPattern.y
        },
        bottomLeft: {
            x: midBottomLeft.x,
            y: midBottomLeft.y
        },
        topLeft: {
            x: midTopLeft.x,
            y: midTopLeft.y
        },
        topRight: {
            x: midTopRight.x,
            y: midTopRight.y
        },
        dimension: centeredAlignment.dimension
    });
    if (result.length === 0) return null;
    return result;
}

});

parcelRegister("2zdnb", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $1de93939cfbb7d80$export$f9380c9a627682d3; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ 
var $466Xy = parcelRequire("466Xy");
/**
 * @module extractor
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ function $1de93939cfbb7d80$var$squareToQuadrilateral(p1, p2, p3, p4) {
    const dx3 = p1.x - p2.x + p3.x - p4.x;
    const dy3 = p1.y - p2.y + p3.y - p4.y;
    if (dx3 === 0 && dy3 === 0) // Affine
    return {
        a11: p2.x - p1.x,
        a12: p2.y - p1.y,
        a13: 0,
        a21: p3.x - p2.x,
        a22: p3.y - p2.y,
        a23: 0,
        a31: p1.x,
        a32: p1.y,
        a33: 1
    };
    else {
        const dx1 = p2.x - p3.x;
        const dx2 = p4.x - p3.x;
        const dy1 = p2.y - p3.y;
        const dy2 = p4.y - p3.y;
        const denominator = dx1 * dy2 - dx2 * dy1;
        const a13 = (dx3 * dy2 - dx2 * dy3) / denominator;
        const a23 = (dx1 * dy3 - dx3 * dy1) / denominator;
        return {
            a11: p2.x - p1.x + a13 * p2.x,
            a12: p2.y - p1.y + a13 * p2.y,
            a13: a13,
            a21: p4.x - p1.x + a23 * p4.x,
            a22: p4.y - p1.y + a23 * p4.y,
            a23: a23,
            a31: p1.x,
            a32: p1.y,
            a33: 1
        };
    }
}
function $1de93939cfbb7d80$var$quadrilateralToSquare(p1, p2, p3, p4) {
    // Here, the adjoint serves as the inverse:
    const sToQ = $1de93939cfbb7d80$var$squareToQuadrilateral(p1, p2, p3, p4);
    return {
        a11: sToQ.a22 * sToQ.a33 - sToQ.a23 * sToQ.a32,
        a12: sToQ.a13 * sToQ.a32 - sToQ.a12 * sToQ.a33,
        a13: sToQ.a12 * sToQ.a23 - sToQ.a13 * sToQ.a22,
        a21: sToQ.a23 * sToQ.a31 - sToQ.a21 * sToQ.a33,
        a22: sToQ.a11 * sToQ.a33 - sToQ.a13 * sToQ.a31,
        a23: sToQ.a13 * sToQ.a21 - sToQ.a11 * sToQ.a23,
        a31: sToQ.a21 * sToQ.a32 - sToQ.a22 * sToQ.a31,
        a32: sToQ.a12 * sToQ.a31 - sToQ.a11 * sToQ.a32,
        a33: sToQ.a11 * sToQ.a22 - sToQ.a12 * sToQ.a21
    };
}
function $1de93939cfbb7d80$var$times(a, b) {
    return {
        a11: a.a11 * b.a11 + a.a21 * b.a12 + a.a31 * b.a13,
        a12: a.a12 * b.a11 + a.a22 * b.a12 + a.a32 * b.a13,
        a13: a.a13 * b.a11 + a.a23 * b.a12 + a.a33 * b.a13,
        a21: a.a11 * b.a21 + a.a21 * b.a22 + a.a31 * b.a23,
        a22: a.a12 * b.a21 + a.a22 * b.a22 + a.a32 * b.a23,
        a23: a.a13 * b.a21 + a.a23 * b.a22 + a.a33 * b.a23,
        a31: a.a11 * b.a31 + a.a21 * b.a32 + a.a31 * b.a33,
        a32: a.a12 * b.a31 + a.a22 * b.a32 + a.a32 * b.a33,
        a33: a.a13 * b.a31 + a.a23 * b.a32 + a.a33 * b.a33
    };
}
function $1de93939cfbb7d80$export$f9380c9a627682d3(image, location) {
    const qToS = $1de93939cfbb7d80$var$quadrilateralToSquare({
        x: 3.5,
        y: 3.5
    }, {
        x: location.dimension - 3.5,
        y: 3.5
    }, {
        x: location.dimension - 6.5,
        y: location.dimension - 6.5
    }, {
        x: 3.5,
        y: location.dimension - 3.5
    });
    const sToQ = $1de93939cfbb7d80$var$squareToQuadrilateral(location.topLeft, location.topRight, location.alignmentPattern, location.bottomLeft);
    const transform = $1de93939cfbb7d80$var$times(sToQ, qToS);
    const matrix = (0, $466Xy.BitMatrix).createEmpty(location.dimension, location.dimension);
    const mappingFunction = (x, y)=>{
        const denominator = transform.a13 * x + transform.a23 * y + transform.a33;
        return {
            x: Math.max(0, (transform.a11 * x + transform.a21 * y + transform.a31) / denominator),
            y: Math.max(0, (transform.a12 * x + transform.a22 * y + transform.a32) / denominator)
        };
    };
    for(let y = 0; y < location.dimension; y++)for(let x = 0; x < location.dimension; x++){
        const xValue = x + 0.5;
        const yValue = y + 0.5;
        const sourcePixel = mappingFunction(xValue, yValue);
        matrix.set(x, y, image.get(Math.floor(sourcePixel.x), Math.floor(sourcePixel.y)));
    }
    return {
        matrix: matrix,
        mappingFunction: mappingFunction
    };
}

});
parcelRegister("466Xy", function(module, exports) {

$parcel$export(module.exports, "BitMatrix", function () { return $2fbd1eff077290a3$export$b47b92038ba9a4d4; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ /**
 * @module BitMatrix
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ class $2fbd1eff077290a3$export$b47b92038ba9a4d4 {
    constructor(data, width){
        this.data = data;
        this.width = width;
        this.height = data.length / width;
    }
    static createEmpty(width, height) {
        return new $2fbd1eff077290a3$export$b47b92038ba9a4d4(new Uint8ClampedArray(width * height), width);
    }
    get(x, y) {
        if (x < 0 || x >= this.width || y < 0 || y >= this.height) return false;
        return !!this.data[y * this.width + x];
    }
    set(x, y, v) {
        this.data[y * this.width + x] = v ? 1 : 0;
    }
    setRegion(left, top, width, height, v) {
        for(let y = top; y < top + height; y++)for(let x = left; x < left + width; x++)this.set(x, y, !!v);
    }
}

});


parcelRegister("5xQFI", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $4098e45c00271f2a$export$2f872c0f2117be69; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ 
var $6IeB1 = parcelRequire("6IeB1");

var $28Mk0 = parcelRequire("28Mk0");

var $5lnLs = parcelRequire("5lnLs");

var $466Xy = parcelRequire("466Xy");

var $3EAUI = parcelRequire("3EAUI");
/**
 * @module index
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ function $4098e45c00271f2a$var$numBitsDiffering(x, y) {
    let z = x ^ y;
    let bitCount = 0;
    while(z){
        bitCount++;
        z &= z - 1;
    }
    return bitCount;
}
function $4098e45c00271f2a$var$pushBit(bit, byte) {
    return byte << 1 | +bit;
}
const $4098e45c00271f2a$var$FORMAT_INFO_TABLE = [
    {
        bits: 0x5412,
        formatInfo: {
            errorCorrectionLevel: 0,
            dataMask: 0
        }
    },
    {
        bits: 0x5125,
        formatInfo: {
            errorCorrectionLevel: 0,
            dataMask: 1
        }
    },
    {
        bits: 0x5e7c,
        formatInfo: {
            errorCorrectionLevel: 0,
            dataMask: 2
        }
    },
    {
        bits: 0x5b4b,
        formatInfo: {
            errorCorrectionLevel: 0,
            dataMask: 3
        }
    },
    {
        bits: 0x45f9,
        formatInfo: {
            errorCorrectionLevel: 0,
            dataMask: 4
        }
    },
    {
        bits: 0x40ce,
        formatInfo: {
            errorCorrectionLevel: 0,
            dataMask: 5
        }
    },
    {
        bits: 0x4f97,
        formatInfo: {
            errorCorrectionLevel: 0,
            dataMask: 6
        }
    },
    {
        bits: 0x4aa0,
        formatInfo: {
            errorCorrectionLevel: 0,
            dataMask: 7
        }
    },
    {
        bits: 0x77c4,
        formatInfo: {
            errorCorrectionLevel: 1,
            dataMask: 0
        }
    },
    {
        bits: 0x72f3,
        formatInfo: {
            errorCorrectionLevel: 1,
            dataMask: 1
        }
    },
    {
        bits: 0x7daa,
        formatInfo: {
            errorCorrectionLevel: 1,
            dataMask: 2
        }
    },
    {
        bits: 0x789d,
        formatInfo: {
            errorCorrectionLevel: 1,
            dataMask: 3
        }
    },
    {
        bits: 0x662f,
        formatInfo: {
            errorCorrectionLevel: 1,
            dataMask: 4
        }
    },
    {
        bits: 0x6318,
        formatInfo: {
            errorCorrectionLevel: 1,
            dataMask: 5
        }
    },
    {
        bits: 0x6c41,
        formatInfo: {
            errorCorrectionLevel: 1,
            dataMask: 6
        }
    },
    {
        bits: 0x6976,
        formatInfo: {
            errorCorrectionLevel: 1,
            dataMask: 7
        }
    },
    {
        bits: 0x1689,
        formatInfo: {
            errorCorrectionLevel: 2,
            dataMask: 0
        }
    },
    {
        bits: 0x13be,
        formatInfo: {
            errorCorrectionLevel: 2,
            dataMask: 1
        }
    },
    {
        bits: 0x1ce7,
        formatInfo: {
            errorCorrectionLevel: 2,
            dataMask: 2
        }
    },
    {
        bits: 0x19d0,
        formatInfo: {
            errorCorrectionLevel: 2,
            dataMask: 3
        }
    },
    {
        bits: 0x0762,
        formatInfo: {
            errorCorrectionLevel: 2,
            dataMask: 4
        }
    },
    {
        bits: 0x0255,
        formatInfo: {
            errorCorrectionLevel: 2,
            dataMask: 5
        }
    },
    {
        bits: 0x0d0c,
        formatInfo: {
            errorCorrectionLevel: 2,
            dataMask: 6
        }
    },
    {
        bits: 0x083b,
        formatInfo: {
            errorCorrectionLevel: 2,
            dataMask: 7
        }
    },
    {
        bits: 0x355f,
        formatInfo: {
            errorCorrectionLevel: 3,
            dataMask: 0
        }
    },
    {
        bits: 0x3068,
        formatInfo: {
            errorCorrectionLevel: 3,
            dataMask: 1
        }
    },
    {
        bits: 0x3f31,
        formatInfo: {
            errorCorrectionLevel: 3,
            dataMask: 2
        }
    },
    {
        bits: 0x3a06,
        formatInfo: {
            errorCorrectionLevel: 3,
            dataMask: 3
        }
    },
    {
        bits: 0x24b4,
        formatInfo: {
            errorCorrectionLevel: 3,
            dataMask: 4
        }
    },
    {
        bits: 0x2183,
        formatInfo: {
            errorCorrectionLevel: 3,
            dataMask: 5
        }
    },
    {
        bits: 0x2eda,
        formatInfo: {
            errorCorrectionLevel: 3,
            dataMask: 6
        }
    },
    {
        bits: 0x2bed,
        formatInfo: {
            errorCorrectionLevel: 3,
            dataMask: 7
        }
    }
];
function $4098e45c00271f2a$var$buildFunctionPatternMask(version) {
    const dimension = 17 + 4 * version.versionNumber;
    const matrix = (0, $466Xy.BitMatrix).createEmpty(dimension, dimension);
    matrix.setRegion(0, 0, 9, 9, true); // Top left finder pattern + separator + format
    matrix.setRegion(dimension - 8, 0, 8, 9, true); // Top right finder pattern + separator + format
    matrix.setRegion(0, dimension - 8, 9, 8, true); // Bottom left finder pattern + separator + format
    // Alignment patterns
    for (const x of version.alignmentPatternCenters){
        for (const y of version.alignmentPatternCenters)if (!(x === 6 && y === 6 || x === 6 && y === dimension - 7 || x === dimension - 7 && y === 6)) matrix.setRegion(x - 2, y - 2, 5, 5, true);
    }
    matrix.setRegion(6, 9, 1, dimension - 17, true); // Vertical timing pattern
    matrix.setRegion(9, 6, dimension - 17, 1, true); // Horizontal timing pattern
    if (version.versionNumber > 6) {
        matrix.setRegion(dimension - 11, 0, 3, 6, true); // Version info, top right
        matrix.setRegion(0, dimension - 11, 6, 3, true); // Version info, bottom left
    }
    return matrix;
}
function $4098e45c00271f2a$var$readCodewords(matrix, version, formatInfo) {
    const dimension = matrix.height;
    const maskFunc = (0, $3EAUI.getMaskFunc)(formatInfo.dataMask);
    const functionPatternMask = $4098e45c00271f2a$var$buildFunctionPatternMask(version);
    let bitsRead = 0;
    let currentByte = 0;
    const codewords = [];
    // Read columns in pairs, from right to left
    let readingUp = true;
    for(let columnIndex = dimension - 1; columnIndex > 0; columnIndex -= 2){
        if (columnIndex === 6) // Skip whole column with vertical alignment pattern;
        columnIndex--;
        for(let i = 0; i < dimension; i++){
            const y = readingUp ? dimension - 1 - i : i;
            for(let columnOffset = 0; columnOffset < 2; columnOffset++){
                const x = columnIndex - columnOffset;
                if (!functionPatternMask.get(x, y)) {
                    bitsRead++;
                    let bit = matrix.get(x, y);
                    if (maskFunc(x, y)) bit = !bit;
                    currentByte = $4098e45c00271f2a$var$pushBit(bit, currentByte);
                    if (bitsRead === 8) {
                        // Whole bytes
                        codewords.push(currentByte);
                        bitsRead = 0;
                        currentByte = 0;
                    }
                }
            }
        }
        readingUp = !readingUp;
    }
    return codewords;
}
function $4098e45c00271f2a$var$readVersion(matrix) {
    const dimension = matrix.height;
    const provisionalVersion = Math.floor((dimension - 17) / 4);
    if (provisionalVersion < 1) return null;
    if (provisionalVersion <= 6) // 6 and under dont have version info in the QR code
    return (0, $28Mk0.VERSIONS)[provisionalVersion - 1];
    let topRightVersionBits = 0;
    for(let y = 5; y >= 0; y--)for(let x = dimension - 9; x >= dimension - 11; x--)topRightVersionBits = $4098e45c00271f2a$var$pushBit(matrix.get(x, y), topRightVersionBits);
    let bottomLeftVersionBits = 0;
    for(let x = 5; x >= 0; x--)for(let y = dimension - 9; y >= dimension - 11; y--)bottomLeftVersionBits = $4098e45c00271f2a$var$pushBit(matrix.get(x, y), bottomLeftVersionBits);
    let bestDifference = Infinity;
    let bestVersion = null;
    for (const version of (0, $28Mk0.VERSIONS)){
        if (version.infoBits === topRightVersionBits || version.infoBits === bottomLeftVersionBits) return version;
        let difference = $4098e45c00271f2a$var$numBitsDiffering(topRightVersionBits, version.infoBits);
        if (difference < bestDifference) {
            bestVersion = version;
            bestDifference = difference;
        }
        difference = $4098e45c00271f2a$var$numBitsDiffering(bottomLeftVersionBits, version.infoBits);
        if (difference < bestDifference) {
            bestVersion = version;
            bestDifference = difference;
        }
    }
    // We can tolerate up to 3 bits of error since no two version info codewords will
    // differ in less than 8 bits.
    if (bestDifference <= 3) return bestVersion;
    return null;
}
function $4098e45c00271f2a$var$readFormatInformation(matrix) {
    let topLeftFormatInfoBits = 0;
    for(let x = 0; x <= 8; x++)if (x !== 6) // Skip timing pattern bit
    topLeftFormatInfoBits = $4098e45c00271f2a$var$pushBit(matrix.get(x, 8), topLeftFormatInfoBits);
    for(let y = 7; y >= 0; y--)if (y !== 6) // Skip timing pattern bit
    topLeftFormatInfoBits = $4098e45c00271f2a$var$pushBit(matrix.get(8, y), topLeftFormatInfoBits);
    const dimension = matrix.height;
    let topRightBottomRightFormatInfoBits = 0;
    for(let y = dimension - 1; y >= dimension - 7; y--)// bottom left
    topRightBottomRightFormatInfoBits = $4098e45c00271f2a$var$pushBit(matrix.get(8, y), topRightBottomRightFormatInfoBits);
    for(let x = dimension - 8; x < dimension; x++)// top right
    topRightBottomRightFormatInfoBits = $4098e45c00271f2a$var$pushBit(matrix.get(x, 8), topRightBottomRightFormatInfoBits);
    let bestDifference = Infinity;
    let bestFormatInfo = null;
    for (const { bits: bits, formatInfo: formatInfo } of $4098e45c00271f2a$var$FORMAT_INFO_TABLE){
        if (bits === topLeftFormatInfoBits || bits === topRightBottomRightFormatInfoBits) return formatInfo;
        let difference = $4098e45c00271f2a$var$numBitsDiffering(topLeftFormatInfoBits, bits);
        if (difference < bestDifference) {
            bestFormatInfo = formatInfo;
            bestDifference = difference;
        }
        if (topLeftFormatInfoBits !== topRightBottomRightFormatInfoBits) {
            // also try the other option
            difference = $4098e45c00271f2a$var$numBitsDiffering(topRightBottomRightFormatInfoBits, bits);
            if (difference < bestDifference) {
                bestFormatInfo = formatInfo;
                bestDifference = difference;
            }
        }
    }
    // Hamming distance of the 32 masked codes is 7, by construction, so <= 3 bits differing means we found a match
    if (bestDifference <= 3) return bestFormatInfo;
    return null;
}
function $4098e45c00271f2a$var$getDataBlocks(codewords, version, errorCorrectionLevel) {
    const dataBlocks = [];
    const ecInfo = version.errorCorrectionLevels[errorCorrectionLevel];
    let totalCodewords = 0;
    ecInfo.ecBlocks.forEach((block)=>{
        for(let i = 0; i < block.numBlocks; i++){
            dataBlocks.push({
                numDataCodewords: block.dataCodewordsPerBlock,
                codewords: []
            });
            totalCodewords += block.dataCodewordsPerBlock + ecInfo.ecCodewordsPerBlock;
        }
    });
    // In some cases the QR code will be malformed enough that we pull off more or less than we should.
    // If we pull off less there's nothing we can do.
    // If we pull off more we can safely truncate
    if (codewords.length < totalCodewords) return null;
    codewords = codewords.slice(0, totalCodewords);
    const shortBlockSize = ecInfo.ecBlocks[0].dataCodewordsPerBlock;
    // Pull codewords to fill the blocks up to the minimum size
    for(let i = 0; i < shortBlockSize; i++)for (const dataBlock of dataBlocks)dataBlock.codewords.push(codewords.shift());
    // If there are any large blocks, pull codewords to fill the last element of those
    if (ecInfo.ecBlocks.length > 1) {
        const smallBlockCount = ecInfo.ecBlocks[0].numBlocks;
        const largeBlockCount = ecInfo.ecBlocks[1].numBlocks;
        for(let i = 0; i < largeBlockCount; i++)dataBlocks[smallBlockCount + i].codewords.push(codewords.shift());
    }
    // Add the rest of the codewords to the blocks. These are the error correction codewords.
    while(codewords.length > 0)for (const dataBlock of dataBlocks)dataBlock.codewords.push(codewords.shift());
    return dataBlocks;
}
function $4098e45c00271f2a$var$decodeMatrix(matrix) {
    const version = $4098e45c00271f2a$var$readVersion(matrix);
    if (version === null) return null;
    const formatInfo = $4098e45c00271f2a$var$readFormatInformation(matrix);
    if (formatInfo === null) return null;
    const codewords = $4098e45c00271f2a$var$readCodewords(matrix, version, formatInfo);
    const dataBlocks = $4098e45c00271f2a$var$getDataBlocks(codewords, version, formatInfo.errorCorrectionLevel);
    if (dataBlocks === null) return null;
    // Count total number of data bytes
    const totalBytes = dataBlocks.reduce((a, b)=>a + b.numDataCodewords, 0);
    const resultBytes = new Uint8ClampedArray(totalBytes);
    let resultIndex = 0;
    for (const dataBlock of dataBlocks){
        const correctedBytes = (0, $6IeB1.rsDecode)(dataBlock.codewords, dataBlock.codewords.length - dataBlock.numDataCodewords);
        if (correctedBytes === null) return null;
        for(let i = 0; i < dataBlock.numDataCodewords; i++)resultBytes[resultIndex++] = correctedBytes[i];
    }
    try {
        return (0, $5lnLs.bytesDecode)(resultBytes, version.versionNumber, formatInfo.errorCorrectionLevel);
    } catch (_a) {
        return null;
    }
}
function $4098e45c00271f2a$export$2f872c0f2117be69(matrix) {
    const result = $4098e45c00271f2a$var$decodeMatrix(matrix);
    if (result !== null) return result;
    // Decoding didn't work, try mirroring the QR across the topLeft -> bottomRight line.
    for(let x = 0; x < matrix.width; x++){
        for(let y = x + 1; y < matrix.height; y++)if (matrix.get(x, y) !== matrix.get(y, x)) {
            matrix.set(x, y, !matrix.get(x, y));
            matrix.set(y, x, !matrix.get(y, x));
        }
    }
    return $4098e45c00271f2a$var$decodeMatrix(matrix);
}

});
parcelRegister("6IeB1", function(module, exports) {

$parcel$export(module.exports, "rsDecode", function () { return $4e322ca4c140eb7c$export$49865c8edb0140ec; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ 
var $7xQZc = parcelRequire("7xQZc");

var $jICx1 = parcelRequire("jICx1");
/**
 * @module index
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ function $4e322ca4c140eb7c$var$runEuclideanAlgorithm(field, a, b, R) {
    // Assume a's degree is >= b's
    if (a.degree() < b.degree()) [a, b] = [
        b,
        a
    ];
    let rLast = a;
    let r = b;
    let tLast = field.zero;
    let t = field.one;
    // Run Euclidean algorithm until r's degree is less than R/2
    while(r.degree() >= R / 2){
        const rLastLast = rLast;
        const tLastLast = tLast;
        rLast = r;
        tLast = t;
        // Divide rLastLast by rLast, with quotient in q and remainder in r
        if (rLast.isZero()) // Euclidean algorithm already terminated?
        return null;
        r = rLastLast;
        let q = field.zero;
        const denominatorLeadingTerm = rLast.getCoefficient(rLast.degree());
        const dltInverse = field.inverse(denominatorLeadingTerm);
        while(r.degree() >= rLast.degree() && !r.isZero()){
            const degreeDiff = r.degree() - rLast.degree();
            const scale = field.multiply(r.getCoefficient(r.degree()), dltInverse);
            q = q.addOrSubtract(field.buildMonomial(degreeDiff, scale));
            r = r.addOrSubtract(rLast.multiplyByMonomial(degreeDiff, scale));
        }
        t = q.multiplyPoly(tLast).addOrSubtract(tLastLast);
        if (r.degree() >= rLast.degree()) return null;
    }
    const sigmaTildeAtZero = t.getCoefficient(0);
    if (sigmaTildeAtZero === 0) return null;
    const inverse = field.inverse(sigmaTildeAtZero);
    return [
        t.multiply(inverse),
        r.multiply(inverse)
    ];
}
function $4e322ca4c140eb7c$var$findErrorLocations(field, errorLocator) {
    // This is a direct application of Chien's search
    const numErrors = errorLocator.degree();
    if (numErrors === 1) return [
        errorLocator.getCoefficient(1)
    ];
    let errorCount = 0;
    const result = new Array(numErrors);
    for(let i = 1; i < field.size && errorCount < numErrors; i++)if (errorLocator.evaluateAt(i) === 0) {
        result[errorCount] = field.inverse(i);
        errorCount++;
    }
    if (errorCount !== numErrors) return null;
    return result;
}
function $4e322ca4c140eb7c$var$findErrorMagnitudes(field, errorEvaluator, errorLocations) {
    // This is directly applying Forney's Formula
    const s = errorLocations.length;
    const result = new Array(s);
    for(let i = 0; i < s; i++){
        let denominator = 1;
        const xiInverse = field.inverse(errorLocations[i]);
        for(let j = 0; j < s; j++)if (i !== j) denominator = field.multiply(denominator, (0, $jICx1.addOrSubtractGF)(1, field.multiply(errorLocations[j], xiInverse)));
        result[i] = field.multiply(errorEvaluator.evaluateAt(xiInverse), field.inverse(denominator));
        if (field.generatorBase !== 0) result[i] = field.multiply(result[i], xiInverse);
    }
    return result;
}
function $4e322ca4c140eb7c$export$49865c8edb0140ec(bytes, twoS) {
    const outputBytes = new Uint8ClampedArray(bytes.length);
    outputBytes.set(bytes);
    const field = new (0, $jICx1.GenericGF)(0x011d, 256, 0); // x^8 + x^4 + x^3 + x^2 + 1
    const poly = new (0, $7xQZc.GenericGFPoly)(field, outputBytes);
    const syndromeCoefficients = new Uint8ClampedArray(twoS);
    let error = false;
    for(let s = 0; s < twoS; s++){
        const evaluation = poly.evaluateAt(field.exp(s + field.generatorBase));
        syndromeCoefficients[syndromeCoefficients.length - 1 - s] = evaluation;
        if (evaluation !== 0) error = true;
    }
    if (!error) return outputBytes;
    const syndrome = new (0, $7xQZc.GenericGFPoly)(field, syndromeCoefficients);
    const sigmaOmega = $4e322ca4c140eb7c$var$runEuclideanAlgorithm(field, field.buildMonomial(twoS, 1), syndrome, twoS);
    if (sigmaOmega === null) return null;
    const errorLocations = $4e322ca4c140eb7c$var$findErrorLocations(field, sigmaOmega[0]);
    if (errorLocations == null) return null;
    const errorMagnitudes = $4e322ca4c140eb7c$var$findErrorMagnitudes(field, sigmaOmega[1], errorLocations);
    for(let i = 0; i < errorLocations.length; i++){
        const position = outputBytes.length - 1 - field.log(errorLocations[i]);
        if (position < 0) return null;
        outputBytes[position] = (0, $jICx1.addOrSubtractGF)(outputBytes[position], errorMagnitudes[i]);
    }
    return outputBytes;
}

});
parcelRegister("7xQZc", function(module, exports) {

$parcel$export(module.exports, "GenericGFPoly", function () { return $57e4b7691dfa20c7$export$a05b0b0cae0d3da7; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ 
var $jICx1 = parcelRequire("jICx1");
/**
 * @module GenericGFPoly
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ class $57e4b7691dfa20c7$export$a05b0b0cae0d3da7 {
    constructor(field, coefficients){
        if (coefficients.length === 0) throw new Error('no coefficients');
        this.field = field;
        const coefficientsLength = coefficients.length;
        if (coefficientsLength > 1 && coefficients[0] === 0) {
            // Leading term must be non-zero for anything except the constant polynomial "0"
            let firstNonZero = 1;
            while(firstNonZero < coefficientsLength && coefficients[firstNonZero] === 0)firstNonZero++;
            if (firstNonZero === coefficientsLength) this.coefficients = field.zero.coefficients;
            else {
                this.coefficients = new Uint8ClampedArray(coefficientsLength - firstNonZero);
                for(let i = 0; i < this.coefficients.length; i++)this.coefficients[i] = coefficients[firstNonZero + i];
            }
        } else this.coefficients = coefficients;
    }
    degree() {
        return this.coefficients.length - 1;
    }
    isZero() {
        return this.coefficients[0] === 0;
    }
    getCoefficient(degree) {
        return this.coefficients[this.coefficients.length - 1 - degree];
    }
    addOrSubtract(other) {
        if (this.isZero()) return other;
        if (other.isZero()) return this;
        let smallerCoefficients = this.coefficients;
        let largerCoefficients = other.coefficients;
        if (smallerCoefficients.length > largerCoefficients.length) [smallerCoefficients, largerCoefficients] = [
            largerCoefficients,
            smallerCoefficients
        ];
        const sumDiff = new Uint8ClampedArray(largerCoefficients.length);
        const lengthDiff = largerCoefficients.length - smallerCoefficients.length;
        for(let i = 0; i < lengthDiff; i++)sumDiff[i] = largerCoefficients[i];
        for(let i = lengthDiff; i < largerCoefficients.length; i++)sumDiff[i] = (0, $jICx1.addOrSubtractGF)(smallerCoefficients[i - lengthDiff], largerCoefficients[i]);
        return new $57e4b7691dfa20c7$export$a05b0b0cae0d3da7(this.field, sumDiff);
    }
    multiply(scalar) {
        if (scalar === 0) return this.field.zero;
        if (scalar === 1) return this;
        const size = this.coefficients.length;
        const product = new Uint8ClampedArray(size);
        for(let i = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], scalar);
        return new $57e4b7691dfa20c7$export$a05b0b0cae0d3da7(this.field, product);
    }
    multiplyPoly(other) {
        if (this.isZero() || other.isZero()) return this.field.zero;
        const aCoefficients = this.coefficients;
        const aLength = aCoefficients.length;
        const bCoefficients = other.coefficients;
        const bLength = bCoefficients.length;
        const product = new Uint8ClampedArray(aLength + bLength - 1);
        for(let i = 0; i < aLength; i++){
            const aCoeff = aCoefficients[i];
            for(let j = 0; j < bLength; j++)product[i + j] = (0, $jICx1.addOrSubtractGF)(product[i + j], this.field.multiply(aCoeff, bCoefficients[j]));
        }
        return new $57e4b7691dfa20c7$export$a05b0b0cae0d3da7(this.field, product);
    }
    multiplyByMonomial(degree, coefficient) {
        if (degree < 0) throw new Error('invalid degree less than 0');
        if (coefficient === 0) return this.field.zero;
        const size = this.coefficients.length;
        const product = new Uint8ClampedArray(size + degree);
        for(let i = 0; i < size; i++)product[i] = this.field.multiply(this.coefficients[i], coefficient);
        return new $57e4b7691dfa20c7$export$a05b0b0cae0d3da7(this.field, product);
    }
    evaluateAt(a) {
        let result = 0;
        if (a === 0) // Just return the x^0 coefficient
        return this.getCoefficient(0);
        const size = this.coefficients.length;
        if (a === 1) {
            // Just the sum of the coefficients
            this.coefficients.forEach((coefficient)=>{
                result = (0, $jICx1.addOrSubtractGF)(result, coefficient);
            });
            return result;
        }
        result = this.coefficients[0];
        for(let i = 1; i < size; i++)result = (0, $jICx1.addOrSubtractGF)(this.field.multiply(a, result), this.coefficients[i]);
        return result;
    }
}

});
parcelRegister("jICx1", function(module, exports) {

$parcel$export(module.exports, "addOrSubtractGF", function () { return $e5b003eeb3e304ca$export$f840c9d28dceb57c; });
$parcel$export(module.exports, "GenericGF", function () { return $e5b003eeb3e304ca$export$5c08679ac4a7b2d6; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ 
var $7xQZc = parcelRequire("7xQZc");
/**
 * @module GenericGF
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ function $e5b003eeb3e304ca$export$f840c9d28dceb57c(a, b) {
    return a ^ b;
}
class $e5b003eeb3e304ca$export$5c08679ac4a7b2d6 {
    constructor(primitive, size, generatorBase){
        this.primitive = primitive;
        this.size = size;
        this.generatorBase = generatorBase;
        this.expTable = [];
        this.logTable = [];
        let x = 1;
        for(let i = 0; i < this.size; i++){
            this.logTable[i] = 0;
            this.expTable[i] = x;
            x = x * 2;
            if (x >= this.size) x = (x ^ this.primitive) & this.size - 1;
        }
        for(let i = 0; i < this.size - 1; i++)this.logTable[this.expTable[i]] = i;
        this.zero = new (0, $7xQZc.GenericGFPoly)(this, Uint8ClampedArray.from([
            0
        ]));
        this.one = new (0, $7xQZc.GenericGFPoly)(this, Uint8ClampedArray.from([
            1
        ]));
    }
    multiply(a, b) {
        if (a === 0 || b === 0) return 0;
        return this.expTable[(this.logTable[a] + this.logTable[b]) % (this.size - 1)];
    }
    inverse(a) {
        if (a === 0) throw new Error("can't invert 0");
        return this.expTable[this.size - this.logTable[a] - 1];
    }
    buildMonomial(degree, coefficient) {
        if (degree < 0) throw new Error('invalid monomial degree less than 0');
        if (coefficient === 0) return this.zero;
        const coefficients = new Uint8ClampedArray(degree + 1);
        coefficients[0] = coefficient;
        return new (0, $7xQZc.GenericGFPoly)(this, coefficients);
    }
    log(a) {
        if (a === 0) throw new Error("can't take log(0)");
        return this.logTable[a];
    }
    exp(a) {
        return this.expTable[a];
    }
}

});



parcelRegister("28Mk0", function(module, exports) {

$parcel$export(module.exports, "VERSIONS", function () { return $18f1cfc8f14302a2$export$aa5307f1aca77413; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ /**
 * @module Version
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ const $18f1cfc8f14302a2$export$aa5307f1aca77413 = [
    {
        infoBits: 0x00000,
        versionNumber: 1,
        alignmentPatternCenters: [],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 10,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 7,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 19
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 17,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 9
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 13,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 13
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x00000,
        versionNumber: 2,
        alignmentPatternCenters: [
            6,
            18
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 16,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 28
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 10,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 34
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 22
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x00000,
        versionNumber: 3,
        alignmentPatternCenters: [
            6,
            22
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 44
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 15,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 55
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 13
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 18,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 17
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x00000,
        versionNumber: 4,
        alignmentPatternCenters: [
            6,
            26
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 18,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 32
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 20,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 80
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 16,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 9
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 24
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x00000,
        versionNumber: 5,
        alignmentPatternCenters: [
            6,
            30
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 43
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 108
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 11
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 12
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 18,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 16
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x00000,
        versionNumber: 6,
        alignmentPatternCenters: [
            6,
            34
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 16,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 27
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 18,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 68
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 15
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 19
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x07c94,
        versionNumber: 7,
        alignmentPatternCenters: [
            6,
            22,
            38
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 18,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 31
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 20,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 78
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 13
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 14
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 18,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 14
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 15
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x085bc,
        versionNumber: 8,
        alignmentPatternCenters: [
            6,
            24,
            42
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 38
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 39
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 97
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 14
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 15
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 18
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 19
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x09a99,
        versionNumber: 9,
        alignmentPatternCenters: [
            6,
            26,
            46
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 36
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 37
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 116
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 12
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 13
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 20,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 16
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 17
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x0a4d3,
        versionNumber: 10,
        alignmentPatternCenters: [
            6,
            28,
            50
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 43
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 44
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 18,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 68
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 69
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 19
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 20
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x0bbf6,
        versionNumber: 11,
        alignmentPatternCenters: [
            6,
            30,
            54
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 50
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 51
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 20,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 81
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 12
                    },
                    {
                        numBlocks: 8,
                        dataCodewordsPerBlock: 13
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 22
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 23
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x0c762,
        versionNumber: 12,
        alignmentPatternCenters: [
            6,
            32,
            58
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 36
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 37
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 92
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 93
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 14
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 15
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 20
                    },
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 21
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x0d847,
        versionNumber: 13,
        alignmentPatternCenters: [
            6,
            34,
            62
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 8,
                        dataCodewordsPerBlock: 37
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 38
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 107
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 12,
                        dataCodewordsPerBlock: 11
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 12
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 8,
                        dataCodewordsPerBlock: 20
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 21
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x0e60d,
        versionNumber: 14,
        alignmentPatternCenters: [
            6,
            26,
            46,
            66
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 40
                    },
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 41
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 115
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 116
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 11,
                        dataCodewordsPerBlock: 12
                    },
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 13
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 20,
                ecBlocks: [
                    {
                        numBlocks: 11,
                        dataCodewordsPerBlock: 16
                    },
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 17
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x0f928,
        versionNumber: 15,
        alignmentPatternCenters: [
            6,
            26,
            48,
            70
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 41
                    },
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 42
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 22,
                ecBlocks: [
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 87
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 88
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 11,
                        dataCodewordsPerBlock: 12
                    },
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 13
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x10b78,
        versionNumber: 16,
        alignmentPatternCenters: [
            6,
            26,
            50,
            74
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 45
                    },
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 46
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 98
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 99
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 13,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 15,
                        dataCodewordsPerBlock: 19
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 20
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x1145d,
        versionNumber: 17,
        alignmentPatternCenters: [
            6,
            30,
            54,
            78
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 46
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 47
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 107
                    },
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 108
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 14
                    },
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 15
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 22
                    },
                    {
                        numBlocks: 15,
                        dataCodewordsPerBlock: 23
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x12a17,
        versionNumber: 18,
        alignmentPatternCenters: [
            6,
            30,
            56,
            82
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 9,
                        dataCodewordsPerBlock: 43
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 44
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 120
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 121
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 14
                    },
                    {
                        numBlocks: 19,
                        dataCodewordsPerBlock: 15
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 22
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 23
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x13532,
        versionNumber: 19,
        alignmentPatternCenters: [
            6,
            30,
            58,
            86
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 44
                    },
                    {
                        numBlocks: 11,
                        dataCodewordsPerBlock: 45
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 113
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 114
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 9,
                        dataCodewordsPerBlock: 13
                    },
                    {
                        numBlocks: 16,
                        dataCodewordsPerBlock: 14
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 21
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 22
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x149a6,
        versionNumber: 20,
        alignmentPatternCenters: [
            6,
            34,
            62,
            90
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 41
                    },
                    {
                        numBlocks: 13,
                        dataCodewordsPerBlock: 42
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 107
                    },
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 108
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 15,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 15,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x15683,
        versionNumber: 21,
        alignmentPatternCenters: [
            6,
            28,
            50,
            72,
            94
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 42
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 116
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 117
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 19,
                        dataCodewordsPerBlock: 16
                    },
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 17
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 22
                    },
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 23
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x168c9,
        versionNumber: 22,
        alignmentPatternCenters: [
            6,
            26,
            50,
            74,
            98
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 46
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 111
                    },
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 112
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 24,
                ecBlocks: [
                    {
                        numBlocks: 34,
                        dataCodewordsPerBlock: 13
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 16,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x177ec,
        versionNumber: 23,
        alignmentPatternCenters: [
            6,
            30,
            54,
            74,
            102
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 47
                    },
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 48
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 121
                    },
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 122
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 16,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 11,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x18ec4,
        versionNumber: 24,
        alignmentPatternCenters: [
            6,
            28,
            54,
            80,
            106
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 45
                    },
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 46
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 117
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 118
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 30,
                        dataCodewordsPerBlock: 16
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 17
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 11,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 16,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x191e1,
        versionNumber: 25,
        alignmentPatternCenters: [
            6,
            32,
            58,
            84,
            110
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 8,
                        dataCodewordsPerBlock: 47
                    },
                    {
                        numBlocks: 13,
                        dataCodewordsPerBlock: 48
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 26,
                ecBlocks: [
                    {
                        numBlocks: 8,
                        dataCodewordsPerBlock: 106
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 107
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 22,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 13,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 22,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x1afab,
        versionNumber: 26,
        alignmentPatternCenters: [
            6,
            30,
            58,
            86,
            114
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 19,
                        dataCodewordsPerBlock: 46
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 47
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 114
                    },
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 115
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 33,
                        dataCodewordsPerBlock: 16
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 17
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 28,
                        dataCodewordsPerBlock: 22
                    },
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 23
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x1b08e,
        versionNumber: 27,
        alignmentPatternCenters: [
            6,
            34,
            62,
            90,
            118
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 22,
                        dataCodewordsPerBlock: 45
                    },
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 46
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 8,
                        dataCodewordsPerBlock: 122
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 123
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 12,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 28,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 8,
                        dataCodewordsPerBlock: 23
                    },
                    {
                        numBlocks: 26,
                        dataCodewordsPerBlock: 24
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x1cc1a,
        versionNumber: 28,
        alignmentPatternCenters: [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 45
                    },
                    {
                        numBlocks: 23,
                        dataCodewordsPerBlock: 46
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 117
                    },
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 118
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 11,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 31,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 31,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x1d33f,
        versionNumber: 29,
        alignmentPatternCenters: [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 21,
                        dataCodewordsPerBlock: 45
                    },
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 46
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 116
                    },
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 117
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 19,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 26,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 23
                    },
                    {
                        numBlocks: 37,
                        dataCodewordsPerBlock: 24
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x1ed75,
        versionNumber: 30,
        alignmentPatternCenters: [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 19,
                        dataCodewordsPerBlock: 47
                    },
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 48
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 5,
                        dataCodewordsPerBlock: 115
                    },
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 116
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 23,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 25,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 15,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 25,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x1f250,
        versionNumber: 31,
        alignmentPatternCenters: [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 46
                    },
                    {
                        numBlocks: 29,
                        dataCodewordsPerBlock: 47
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 13,
                        dataCodewordsPerBlock: 115
                    },
                    {
                        numBlocks: 3,
                        dataCodewordsPerBlock: 116
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 23,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 28,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 42,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x209d5,
        versionNumber: 32,
        alignmentPatternCenters: [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 46
                    },
                    {
                        numBlocks: 23,
                        dataCodewordsPerBlock: 47
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 115
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 19,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 35,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 35,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x216f0,
        versionNumber: 33,
        alignmentPatternCenters: [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 46
                    },
                    {
                        numBlocks: 21,
                        dataCodewordsPerBlock: 47
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 115
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 116
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 11,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 46,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 29,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 19,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x228ba,
        versionNumber: 34,
        alignmentPatternCenters: [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 46
                    },
                    {
                        numBlocks: 23,
                        dataCodewordsPerBlock: 47
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 13,
                        dataCodewordsPerBlock: 115
                    },
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 116
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 59,
                        dataCodewordsPerBlock: 16
                    },
                    {
                        numBlocks: 1,
                        dataCodewordsPerBlock: 17
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 44,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x2379f,
        versionNumber: 35,
        alignmentPatternCenters: [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 12,
                        dataCodewordsPerBlock: 47
                    },
                    {
                        numBlocks: 26,
                        dataCodewordsPerBlock: 48
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 12,
                        dataCodewordsPerBlock: 121
                    },
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 122
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 22,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 41,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 39,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x24b0b,
        versionNumber: 36,
        alignmentPatternCenters: [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 47
                    },
                    {
                        numBlocks: 34,
                        dataCodewordsPerBlock: 48
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 121
                    },
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 122
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 2,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 64,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 46,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x2542e,
        versionNumber: 37,
        alignmentPatternCenters: [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 29,
                        dataCodewordsPerBlock: 46
                    },
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 47
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 17,
                        dataCodewordsPerBlock: 122
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 123
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 24,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 46,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 49,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x26a64,
        versionNumber: 38,
        alignmentPatternCenters: [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 13,
                        dataCodewordsPerBlock: 46
                    },
                    {
                        numBlocks: 32,
                        dataCodewordsPerBlock: 47
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 122
                    },
                    {
                        numBlocks: 18,
                        dataCodewordsPerBlock: 123
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 42,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 32,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 48,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 14,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x27541,
        versionNumber: 39,
        alignmentPatternCenters: [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 40,
                        dataCodewordsPerBlock: 47
                    },
                    {
                        numBlocks: 7,
                        dataCodewordsPerBlock: 48
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 20,
                        dataCodewordsPerBlock: 117
                    },
                    {
                        numBlocks: 4,
                        dataCodewordsPerBlock: 118
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 10,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 67,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 43,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 22,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    },
    {
        infoBits: 0x28c69,
        versionNumber: 40,
        alignmentPatternCenters: [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ],
        errorCorrectionLevels: [
            {
                ecCodewordsPerBlock: 28,
                ecBlocks: [
                    {
                        numBlocks: 18,
                        dataCodewordsPerBlock: 47
                    },
                    {
                        numBlocks: 31,
                        dataCodewordsPerBlock: 48
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 19,
                        dataCodewordsPerBlock: 118
                    },
                    {
                        numBlocks: 6,
                        dataCodewordsPerBlock: 119
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 20,
                        dataCodewordsPerBlock: 15
                    },
                    {
                        numBlocks: 61,
                        dataCodewordsPerBlock: 16
                    }
                ]
            },
            {
                ecCodewordsPerBlock: 30,
                ecBlocks: [
                    {
                        numBlocks: 34,
                        dataCodewordsPerBlock: 24
                    },
                    {
                        numBlocks: 34,
                        dataCodewordsPerBlock: 25
                    }
                ]
            }
        ]
    }
];

});

parcelRegister("5lnLs", function(module, exports) {

$parcel$export(module.exports, "bytesDecode", function () { return $3e4159052fbbb5e0$export$177802ace1f576a3; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ 
var $37SDy = parcelRequire("37SDy");

var $6ctTz = parcelRequire("6ctTz");

var $20vNq = parcelRequire("20vNq");

var $fv8Nt = parcelRequire("fv8Nt");
/**
 * @module index
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ function $3e4159052fbbb5e0$var$decodeNumeric(stream, size) {
    let data = '';
    const bytes = [];
    const characterCountSize = [
        10,
        12,
        14
    ][size];
    let length = stream.readBits(characterCountSize);
    // Read digits in groups of 3
    while(length >= 3){
        const num = stream.readBits(10);
        if (num >= 1000) throw new Error('invalid numeric value above 999');
        const a = Math.floor(num / 100);
        const b = Math.floor(num / 10) % 10;
        const c = num % 10;
        bytes.push(48 + a, 48 + b, 48 + c);
        data += a.toString() + b.toString() + c.toString();
        length -= 3;
    }
    // If the number of digits aren't a multiple of 3, the remaining digits are special cased.
    if (length === 2) {
        const num = stream.readBits(7);
        if (num >= 100) throw new Error('invalid numeric value above 99');
        const a = Math.floor(num / 10);
        const b = num % 10;
        bytes.push(48 + a, 48 + b);
        data += a.toString() + b.toString();
    } else if (length === 1) {
        const num = stream.readBits(4);
        if (num >= 10) throw new Error('invalid numeric value above 9');
        bytes.push(48 + num);
        data += num.toString();
    }
    return {
        bytes: bytes,
        data: data
    };
}
// prettier-ignore
const $3e4159052fbbb5e0$var$AlphanumericCharacterCodes = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    ' ',
    '$',
    '%',
    '*',
    '+',
    '-',
    '.',
    '/',
    ':'
];
function $3e4159052fbbb5e0$var$decodeAlphanumeric(stream, size) {
    const bytes = [];
    const characterCountSize = [
        9,
        11,
        13
    ][size];
    let data = '';
    let length = stream.readBits(characterCountSize);
    while(length >= 2){
        const v = stream.readBits(11);
        const a = Math.floor(v / 45);
        const b = v % 45;
        bytes.push($3e4159052fbbb5e0$var$AlphanumericCharacterCodes[a].charCodeAt(0), $3e4159052fbbb5e0$var$AlphanumericCharacterCodes[b].charCodeAt(0));
        data += $3e4159052fbbb5e0$var$AlphanumericCharacterCodes[a] + $3e4159052fbbb5e0$var$AlphanumericCharacterCodes[b];
        length -= 2;
    }
    if (length === 1) {
        const a = stream.readBits(6);
        bytes.push($3e4159052fbbb5e0$var$AlphanumericCharacterCodes[a].charCodeAt(0));
        data += $3e4159052fbbb5e0$var$AlphanumericCharacterCodes[a];
    }
    return {
        bytes: bytes,
        data: data
    };
}
function $3e4159052fbbb5e0$var$decodeByte(stream, size, encoding) {
    const bytes = [];
    const characterCountSize = [
        8,
        16,
        16
    ][size];
    const length = stream.readBits(characterCountSize);
    for(let i = 0; i < length; i++)bytes.push(stream.readBits(8));
    return {
        bytes: bytes,
        data: encoding === 20 /* EncodingHint.SJIS */  ? (0, $fv8Nt.decode)(bytes) : (0, $20vNq.decode)(bytes)
    };
}
function $3e4159052fbbb5e0$var$decodeKanji(stream, size) {
    let data = '';
    const bytes = [];
    const { fromCharCode: fromCharCode } = String;
    const { SJIS_TO_UTF8: SJIS_TO_UTF8 } = (0, $fv8Nt.getTables)();
    const characterCountSize = [
        8,
        10,
        12
    ][size];
    const length = stream.readBits(characterCountSize);
    for(let i = 0; i < length; i++){
        const k = stream.readBits(13);
        let c = Math.floor(k / 0xc0) << 8 | k % 0xc0;
        if (c < 0x1f00) c += 0x8140;
        else c += 0xc140;
        bytes.push(c >> 8, c & 0xff);
        const b = SJIS_TO_UTF8[c];
        data += fromCharCode(b != null ? b : c);
    }
    return {
        bytes: bytes,
        data: data
    };
}
function $3e4159052fbbb5e0$export$177802ace1f576a3(data, version, errorCorrectionLevel) {
    let encoding = -1;
    const stream = new (0, $37SDy.BitStream)(data);
    // There are 3 'sizes' based on the version. 1-9 is small (0), 10-26 is medium (1) and 27-40 is large (2).
    const size = version <= 9 ? 0 : version <= 26 ? 1 : 2;
    const result = {
        data: '',
        bytes: [],
        chunks: [],
        version: version,
        errorCorrectionLevel: errorCorrectionLevel
    };
    while(stream.available() >= 4){
        const mode = stream.readBits(4);
        if (mode === (0, $6ctTz.Mode).Terminator) return result;
        else if (mode === (0, $6ctTz.Mode).ECI) {
            if (stream.readBits(1) === 0) encoding = stream.readBits(7);
            else if (stream.readBits(1) === 0) encoding = stream.readBits(14);
            else if (stream.readBits(1) === 0) encoding = stream.readBits(21);
            else // ECI data seems corrupted
            encoding = -1;
        } else if (mode === (0, $6ctTz.Mode).Numeric) {
            const numericResult = $3e4159052fbbb5e0$var$decodeNumeric(stream, size);
            result.data += numericResult.data;
            result.chunks.push({
                mode: (0, $6ctTz.Mode).Numeric,
                data: numericResult.data,
                bytes: numericResult.bytes
            });
            result.bytes.push(...numericResult.bytes);
        } else if (mode === (0, $6ctTz.Mode).Alphanumeric) {
            const alphanumericResult = $3e4159052fbbb5e0$var$decodeAlphanumeric(stream, size);
            result.data += alphanumericResult.data;
            result.chunks.push({
                mode: (0, $6ctTz.Mode).Alphanumeric,
                data: alphanumericResult.data,
                bytes: alphanumericResult.bytes
            });
            result.bytes.push(...alphanumericResult.bytes);
        } else if (mode === (0, $6ctTz.Mode).StructuredAppend) {
            // QR Standard section 9.2
            const structuredAppend = {
                // [current, total]
                symbols: [
                    stream.readBits(4),
                    stream.readBits(4)
                ],
                parity: stream.readBits(8)
            };
            result.chunks.push(Object.assign({
                mode: (0, $6ctTz.Mode).StructuredAppend
            }, structuredAppend));
        } else if (mode === (0, $6ctTz.Mode).Byte) {
            const byteResult = $3e4159052fbbb5e0$var$decodeByte(stream, size, encoding);
            result.data += byteResult.data;
            result.chunks.push({
                encoding: encoding,
                mode: (0, $6ctTz.Mode).Byte,
                data: byteResult.data,
                bytes: byteResult.bytes
            });
            result.bytes.push(...byteResult.bytes);
        } else if (mode === (0, $6ctTz.Mode).Kanji) {
            const kanjiResult = $3e4159052fbbb5e0$var$decodeKanji(stream, size);
            result.data += kanjiResult.data;
            result.chunks.push({
                mode: (0, $6ctTz.Mode).Kanji,
                data: kanjiResult.data,
                bytes: kanjiResult.bytes
            });
            result.bytes.push(...kanjiResult.bytes);
        }
    }
    // If there is no data left, or the remaining bits are all 0, then that counts as a termination marker
    if (stream.available() === 0 || stream.readBits(stream.available()) === 0) return result;
    return null;
}

});
parcelRegister("37SDy", function(module, exports) {

$parcel$export(module.exports, "BitStream", function () { return $246c684e790f4d10$export$1a2c3393dc1db03d; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ /**
 * @module BitStream
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ class $246c684e790f4d10$export$1a2c3393dc1db03d {
    constructor(bytes){
        this.byteOffset = 0;
        this.bitOffset = 0;
        this.bytes = bytes;
    }
    readBits(numBits) {
        if (numBits < 1 || numBits > 32 || numBits > this.available()) throw new Error(`can't read ${numBits} bits`);
        let result = 0;
        // First, read remainder from current byte
        if (this.bitOffset > 0) {
            const bitsLeft = 8 - this.bitOffset;
            const toRead = numBits < bitsLeft ? numBits : bitsLeft;
            const bitsToNotRead = bitsLeft - toRead;
            const mask = 0xff >> 8 - toRead << bitsToNotRead;
            result = (this.bytes[this.byteOffset] & mask) >> bitsToNotRead;
            numBits -= toRead;
            this.bitOffset += toRead;
            if (this.bitOffset === 8) {
                this.bitOffset = 0;
                this.byteOffset++;
            }
        }
        // Next read whole bytes
        if (numBits > 0) {
            while(numBits >= 8){
                result = result << 8 | this.bytes[this.byteOffset] & 0xff;
                this.byteOffset++;
                numBits -= 8;
            }
            // Finally read a partial byte
            if (numBits > 0) {
                const bitsToNotRead = 8 - numBits;
                const mask = 0xff >> bitsToNotRead << bitsToNotRead;
                result = result << numBits | (this.bytes[this.byteOffset] & mask) >> bitsToNotRead;
                this.bitOffset += numBits;
            }
        }
        return result;
    }
    available() {
        return 8 * (this.bytes.length - this.byteOffset) - this.bitOffset;
    }
}

});

parcelRegister("6ctTz", function(module, exports) {

$parcel$export(module.exports, "Mode", function () { return $483b0da78911e2d1$export$9484bbecc3c49a2e; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ /**
 * @module Mode
 * @author nuintun
 * @author Cosmo Wolfe
 * @author Kazuhiko Arase
 */ /**
 * @readonly
 */ var $483b0da78911e2d1$export$9484bbecc3c49a2e;
(function(Mode) {
    Mode[Mode["Terminator"] = 0] = "Terminator";
    Mode[Mode["Numeric"] = 1] = "Numeric";
    Mode[Mode["Alphanumeric"] = 2] = "Alphanumeric";
    Mode[Mode["StructuredAppend"] = 3] = "StructuredAppend";
    Mode[Mode["Byte"] = 4] = "Byte";
    Mode[Mode["Kanji"] = 8] = "Kanji";
    Mode[Mode["ECI"] = 7] = "ECI";
// FNC1FirstPosition = 0x05,
// FNC1SecondPosition = 0x09
})($483b0da78911e2d1$export$9484bbecc3c49a2e || ($483b0da78911e2d1$export$9484bbecc3c49a2e = {}));

});

parcelRegister("20vNq", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $17643ee9df518bc3$export$2f872c0f2117be69; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ /**
 * @module UTF8
 * @author nuintun
 */ /**
 * @function encode
 * @param {string} text
 * @returns {number[]}
 * @see https://github.com/google/closure-library/blob/master/closure/goog/crypt/crypt.js
 */ function $17643ee9df518bc3$export$c564cdbbe6da493(text) {
    let pos = 0;
    const { length: length } = text;
    const bytes = [];
    for(let i = 0; i < length; i++){
        let code = text.charCodeAt(i);
        if (code < 128) bytes[pos++] = code;
        else if (code < 2048) {
            bytes[pos++] = code >> 6 | 192;
            bytes[pos++] = code & 63 | 128;
        } else if ((code & 0xfc00) === 0xd800 && i + 1 < length && (text.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            code = 0x10000 + ((code & 0x03ff) << 10) + (text.charCodeAt(++i) & 0x03ff);
            bytes[pos++] = code >> 18 | 240;
            bytes[pos++] = code >> 12 & 63 | 128;
            bytes[pos++] = code >> 6 & 63 | 128;
            bytes[pos++] = code & 63 | 128;
        } else {
            bytes[pos++] = code >> 12 | 224;
            bytes[pos++] = code >> 6 & 63 | 128;
            bytes[pos++] = code & 63 | 128;
        }
    }
    return bytes;
}
/**
 * @function decode
 * @param {number[]} bytes
 * @returns {string}
 * @see https://github.com/google/closure-library/blob/master/closure/goog/crypt/crypt.js
 */ function $17643ee9df518bc3$export$2f872c0f2117be69(bytes) {
    let pos = 0;
    let output = '';
    const { length: length } = bytes;
    const { fromCharCode: fromCharCode } = String;
    while(pos < length){
        const c1 = bytes[pos++];
        if (c1 < 128) output += fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            output += fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            output += fromCharCode(0xd800 + (u >> 10));
            output += fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            output += fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return output;
}

});

parcelRegister("fv8Nt", function(module, exports) {

$parcel$export(module.exports, "getTables", function () { return $b490932a11a7490e$export$2306b495ac6ae3e9; });
$parcel$export(module.exports, "decode", function () { return $b490932a11a7490e$export$2f872c0f2117be69; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ /**
 * @module SJIS
 * @author nuintun
 * @author soldair
 * @author Kazuhiko Arase
 * @see https://github.com/soldair/node-qrcode/blob/master/helper/to-sjis.js
 */ // prettier-ignore
const $b490932a11a7490e$var$SJIS_UTF8_TABLE = [
    [
        0x8140,
        "\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008\u3009\u300A\u300B\u300C\u300D\u300E\u300F\u3010\u3011\uFF0B\uFF0D\xb1\xd7"
    ],
    [
        0x8180,
        "\xf7\uFF1D\u2260\uFF1C\uFF1E"
    ],
    [
        0x818f,
        "\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605"
    ],
    [
        0x81a6,
        "\u203B\u3012\u2192\u2190\u2191\u2193\u3013"
    ],
    [
        0x81ca,
        "\uFFE2"
    ],
    [
        0x824f,
        "\uFF10\uFF11\uFF12\uFF13\uFF14\uFF15\uFF16\uFF17\uFF18\uFF19"
    ],
    [
        0x8260,
        "\uFF21\uFF22\uFF23\uFF24\uFF25\uFF26\uFF27\uFF28\uFF29\uFF2A\uFF2B\uFF2C\uFF2D\uFF2E\uFF2F\uFF30\uFF31\uFF32\uFF33\uFF34\uFF35\uFF36\uFF37\uFF38\uFF39\uFF3A"
    ],
    [
        0x8281,
        "\uFF41\uFF42\uFF43\uFF44\uFF45\uFF46\uFF47\uFF48\uFF49\uFF4A\uFF4B\uFF4C\uFF4D\uFF4E\uFF4F\uFF50\uFF51\uFF52\uFF53\uFF54\uFF55\uFF56\uFF57\uFF58\uFF59\uFF5A"
    ],
    [
        0x829f,
        "\u3041\u3042\u3043\u3044\u3045\u3046\u3047\u3048\u3049\u304A\u304B\u304C\u304D\u304E\u304F\u3050\u3051\u3052\u3053\u3054\u3055\u3056\u3057\u3058\u3059\u305A\u305B\u305C\u305D\u305E\u305F\u3060\u3061\u3062\u3063\u3064\u3065\u3066\u3067\u3068\u3069\u306A\u306B\u306C\u306D\u306E\u306F\u3070\u3071\u3072\u3073\u3074\u3075\u3076\u3077\u3078\u3079\u307A\u307B\u307C\u307D\u307E\u307F\u3080\u3081\u3082\u3083\u3084\u3085\u3086\u3087\u3088\u3089\u308A\u308B\u308C\u308D\u308E\u308F\u3090\u3091\u3092\u3093"
    ],
    [
        0x8340,
        "\u30A1\u30A2\u30A3\u30A4\u30A5\u30A6\u30A7\u30A8\u30A9\u30AA\u30AB\u30AC\u30AD\u30AE\u30AF\u30B0\u30B1\u30B2\u30B3\u30B4\u30B5\u30B6\u30B7\u30B8\u30B9\u30BA\u30BB\u30BC\u30BD\u30BE\u30BF\u30C0\u30C1\u30C2\u30C3\u30C4\u30C5\u30C6\u30C7\u30C8\u30C9\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D0\u30D1\u30D2\u30D3\u30D4\u30D5\u30D6\u30D7\u30D8\u30D9\u30DA\u30DB\u30DC\u30DD\u30DE\u30DF"
    ],
    [
        0x8380,
        "\u30E0\u30E1\u30E2\u30E3\u30E4\u30E5\u30E6\u30E7\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EE\u30EF\u30F0\u30F1\u30F2\u30F3\u30F4\u30F5\u30F6"
    ],
    [
        0x839f,
        "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9"
    ],
    [
        0x83bf,
        "\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9"
    ],
    [
        0x8440,
        "\u0410\u0411\u0412\u0413\u0414\u0415\u0401\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F"
    ],
    [
        0x8470,
        "\u0430\u0431\u0432\u0433\u0434\u0435\u0451\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D"
    ],
    [
        0x8480,
        "\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    ],
    [
        0x8780,
        "\u301D\u301F"
    ],
    [
        0x8940,
        "\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"
    ],
    [
        0x8980,
        "\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"
    ],
    [
        0x8a40,
        "\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"
    ],
    [
        0x8a80,
        "\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"
    ],
    [
        0x8b40,
        "\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"
    ],
    [
        0x8b80,
        "\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"
    ],
    [
        0x8c40,
        "\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"
    ],
    [
        0x8c80,
        "\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"
    ],
    [
        0x8d40,
        "\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"
    ],
    [
        0x8d80,
        "\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"
    ],
    [
        0x8e40,
        "\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"
    ],
    [
        0x8e80,
        "\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"
    ],
    [
        0x8f40,
        "\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"
    ],
    [
        0x8f80,
        "\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"
    ],
    [
        0x9040,
        "\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"
    ],
    [
        0x9080,
        "\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"
    ],
    [
        0x9140,
        "\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"
    ],
    [
        0x9180,
        "\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"
    ],
    [
        0x9240,
        "\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"
    ],
    [
        0x9280,
        "\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"
    ],
    [
        0x9340,
        "\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"
    ],
    [
        0x9380,
        "\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"
    ],
    [
        0x9440,
        "\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"
    ],
    [
        0x9480,
        "\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"
    ],
    [
        0x9540,
        "\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"
    ],
    [
        0x9580,
        "\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"
    ],
    [
        0x9640,
        "\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"
    ],
    [
        0x9680,
        "\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"
    ],
    [
        0x9740,
        "\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"
    ],
    [
        0x9780,
        "\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"
    ],
    [
        0x9840,
        "\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"
    ],
    [
        0x989f,
        "\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"
    ],
    [
        0x9940,
        "\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"
    ],
    [
        0x9980,
        "\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"
    ],
    [
        0x9a40,
        "\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"
    ],
    [
        0x9a80,
        "\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"
    ],
    [
        0x9b40,
        "\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"
    ],
    [
        0x9b80,
        "\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"
    ],
    [
        0x9c40,
        "\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"
    ],
    [
        0x9c80,
        "\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"
    ],
    [
        0x9d40,
        "\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"
    ],
    [
        0x9d80,
        "\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"
    ],
    [
        0x9e40,
        "\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"
    ],
    [
        0x9e80,
        "\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"
    ],
    [
        0x9f40,
        "\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"
    ],
    [
        0x9f80,
        "\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"
    ],
    [
        0xe040,
        "\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"
    ],
    [
        0xe080,
        "\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"
    ],
    [
        0xe140,
        "\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"
    ],
    [
        0xe180,
        "\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"
    ],
    [
        0xe240,
        "\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"
    ],
    [
        0xe280,
        "\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"
    ],
    [
        0xe340,
        "\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"
    ],
    [
        0xe380,
        "\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"
    ],
    [
        0xe440,
        "\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"
    ],
    [
        0xe480,
        "\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"
    ],
    [
        0xe540,
        "\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"
    ],
    [
        0xe580,
        "\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"
    ],
    [
        0xe640,
        "\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"
    ],
    [
        0xe680,
        "\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"
    ],
    [
        0xe740,
        "\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"
    ],
    [
        0xe780,
        "\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"
    ],
    [
        0xe840,
        "\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"
    ],
    [
        0xe880,
        "\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"
    ],
    [
        0xe940,
        "\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"
    ],
    [
        0xe980,
        "\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"
    ],
    [
        0xea40,
        "\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"
    ],
    [
        0xea80,
        "\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"
    ]
];
let $b490932a11a7490e$var$tables;
/**
 * @function getTables
 * @returns {SJISTables}
 */ function $b490932a11a7490e$export$2306b495ac6ae3e9() {
    if (!$b490932a11a7490e$var$tables) {
        const UTF8_TO_SJIS = {};
        const SJIS_TO_UTF8 = {};
        const tLength = $b490932a11a7490e$var$SJIS_UTF8_TABLE.length;
        for(let i = 0; i < tLength; i++){
            const mapItem = $b490932a11a7490e$var$SJIS_UTF8_TABLE[i];
            const kanji = mapItem[1];
            const kLength = kanji.length;
            for(var j = 0; j < kLength; j++){
                const kCode = mapItem[0] + j;
                const uCode = kanji.charAt(j).charCodeAt(0);
                UTF8_TO_SJIS[uCode] = kCode;
                SJIS_TO_UTF8[kCode] = uCode;
            }
        }
        $b490932a11a7490e$var$tables = {
            UTF8_TO_SJIS: UTF8_TO_SJIS,
            SJIS_TO_UTF8: SJIS_TO_UTF8
        };
    }
    return $b490932a11a7490e$var$tables;
}
/**
 * @function encode
 * @param {string} text
 * @returns {number[]}
 */ function $b490932a11a7490e$export$c564cdbbe6da493(text) {
    const { length: length } = text;
    const bytes = [];
    const { fromCharCode: fromCharCode } = String;
    const { UTF8_TO_SJIS: UTF8_TO_SJIS } = $b490932a11a7490e$export$2306b495ac6ae3e9();
    for(let i = 0; i < length; i++){
        const code = text.charCodeAt(i);
        const byte = UTF8_TO_SJIS[code];
        if (byte != null) // 2 bytes
        bytes.push(byte >> 8, byte & 0xff);
        else throw new Error(`illegal char: ${fromCharCode(code)}`);
    }
    return bytes;
}
/**
 * @function decode
 * @param {number[]} bytes
 * @returns {string}
 * @see https://github.com/narirou/jconv/blob/master/jconv.js
 */ function $b490932a11a7490e$export$2f872c0f2117be69(bytes) {
    let pos = 0;
    let output = '';
    const { length: length } = bytes;
    const { fromCharCode: fromCharCode } = String;
    const { SJIS_TO_UTF8: SJIS_TO_UTF8 } = $b490932a11a7490e$export$2306b495ac6ae3e9();
    while(pos < length){
        const byte = bytes[pos++];
        if (byte < 0x80) // ASCII
        output += fromCharCode(byte);
        else if (0xa0 <= byte && byte <= 0xdf) // HALFWIDTH_KATAKANA
        output += fromCharCode(byte + 0xfec0);
        else {
            // KANJI
            const code = SJIS_TO_UTF8[(byte << 8) + bytes[pos++]];
            output += code != null ? fromCharCode(code) : '?';
        }
    }
    return output;
}

});


parcelRegister("3EAUI", function(module, exports) {

$parcel$export(module.exports, "getMaskFunc", function () { return $2a91bdd4fc53ba2a$export$b74b926dc9aa5328; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ /**
 * @module MaskPattern
 * @author nuintun
 * @author Cosmo Wolfe
 * @author Kazuhiko Arase
 */ function $2a91bdd4fc53ba2a$export$b74b926dc9aa5328(maskPattern) {
    switch(maskPattern){
        case 0 /* MaskPattern.PATTERN000 */ :
            return (x, y)=>(x + y & 0x1) === 0;
        case 1 /* MaskPattern.PATTERN001 */ :
            return (_x, y)=>(y & 0x1) === 0;
        case 2 /* MaskPattern.PATTERN010 */ :
            return (x, _y)=>x % 3 === 0;
        case 3 /* MaskPattern.PATTERN011 */ :
            return (x, y)=>(x + y) % 3 === 0;
        case 4 /* MaskPattern.PATTERN100 */ :
            return (x, y)=>((x / 3 >> 0) + (y / 2 >> 0) & 0x1) === 0;
        case 5 /* MaskPattern.PATTERN101 */ :
            return (x, y)=>(x * y & 0x1) + x * y % 3 === 0;
        case 6 /* MaskPattern.PATTERN110 */ :
            return (x, y)=>((x * y & 0x1) + x * y % 3 & 0x1) === 0;
        case 7 /* MaskPattern.PATTERN111 */ :
            return (x, y)=>(x * y % 3 + (x + y & 0x1) & 0x1) === 0;
        default:
            throw new Error(`illegal mask: ${maskPattern}`);
    }
}

});


parcelRegister("aSvPT", function(module, exports) {

$parcel$export(module.exports, "binarize", function () { return $7eb7a47b5c5fe1f6$export$bdd80e0551c7a45c; });
/**
 * @module QRCode
 * @package @nuintun/qrcode
 * @license MIT
 * @version 3.4.0
 * @author nuintun <nuintun@qq.com>
 * @description A pure JavaScript QRCode encode and decode library.
 * @see https://github.com/nuintun/qrcode#readme
 */ 
var $466Xy = parcelRequire("466Xy");
/**
 * @module binarizer
 * @author nuintun
 * @author Cosmo Wolfe
 * @license https://raw.githubusercontent.com/cozmo/jsQR/master/LICENSE
 */ const $7eb7a47b5c5fe1f6$var$REGION_SIZE = 8;
const $7eb7a47b5c5fe1f6$var$MIN_DYNAMIC_RANGE = 24;
function $7eb7a47b5c5fe1f6$var$numBetween(value, min, max) {
    return value < min ? min : value > max ? max : value;
}
// Like BitMatrix but accepts arbitry Uint8 values
class $7eb7a47b5c5fe1f6$var$Matrix {
    constructor(width, height, buffer){
        this.width = width;
        const bufferSize = width * height;
        if (buffer && buffer.length !== bufferSize) throw new Error('wrong buffer size');
        this.data = buffer || new Uint8ClampedArray(bufferSize);
    }
    get(x, y) {
        return this.data[y * this.width + x];
    }
    set(x, y, value) {
        this.data[y * this.width + x] = value;
    }
}
function $7eb7a47b5c5fe1f6$export$bdd80e0551c7a45c(data, width, height, returnInverted, greyscaleWeights = {
    red: 0.2126,
    green: 0.7152,
    blue: 0.0722,
    useIntegerApproximation: false
}, canOverwriteImage = true) {
    const pixelCount = width * height;
    if (data.length !== pixelCount * 4) throw new Error('malformed data passed to binarizer');
    // Assign the greyscale and binary image within the rgba buffer as the rgba image will not be needed after conversion
    let bufferOffset = 0;
    // Convert image to greyscale
    let greyscaleBuffer;
    if (canOverwriteImage) {
        greyscaleBuffer = new Uint8ClampedArray(data.buffer, bufferOffset, pixelCount);
        bufferOffset += pixelCount;
    }
    const greyscalePixels = new $7eb7a47b5c5fe1f6$var$Matrix(width, height, greyscaleBuffer);
    for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
        const position = (y * width + x) * 4;
        const r = data[position];
        const g = data[position + 1];
        const b = data[position + 2];
        const value = greyscaleWeights.red * r + greyscaleWeights.green * g + greyscaleWeights.blue * b;
        greyscalePixels.set(x, y, greyscaleWeights.useIntegerApproximation ? value + 128 >> 8 : value);
    }
    const horizontalRegionCount = Math.ceil(width / $7eb7a47b5c5fe1f6$var$REGION_SIZE);
    const verticalRegionCount = Math.ceil(height / $7eb7a47b5c5fe1f6$var$REGION_SIZE);
    const blackPointsCount = horizontalRegionCount * verticalRegionCount;
    let blackPointsBuffer;
    if (canOverwriteImage) {
        blackPointsBuffer = new Uint8ClampedArray(data.buffer, bufferOffset, blackPointsCount);
        bufferOffset += blackPointsCount;
    }
    const blackPoints = new $7eb7a47b5c5fe1f6$var$Matrix(horizontalRegionCount, verticalRegionCount, blackPointsBuffer);
    for(let verticalRegion = 0; verticalRegion < verticalRegionCount; verticalRegion++)for(let hortizontalRegion = 0; hortizontalRegion < horizontalRegionCount; hortizontalRegion++){
        let sum = 0;
        let min = Infinity;
        let max = 0;
        for(let y = 0; y < $7eb7a47b5c5fe1f6$var$REGION_SIZE; y++)for(let x = 0; x < $7eb7a47b5c5fe1f6$var$REGION_SIZE; x++){
            const pixelLumosity = greyscalePixels.get(hortizontalRegion * $7eb7a47b5c5fe1f6$var$REGION_SIZE + x, verticalRegion * $7eb7a47b5c5fe1f6$var$REGION_SIZE + y);
            sum += pixelLumosity;
            min = Math.min(min, pixelLumosity);
            max = Math.max(max, pixelLumosity);
        }
        let average = sum / Math.pow($7eb7a47b5c5fe1f6$var$REGION_SIZE, 2);
        if (max - min <= $7eb7a47b5c5fe1f6$var$MIN_DYNAMIC_RANGE) {
            // If variation within the block is low, assume this is a block with only light or only
            // dark pixels. In that case we do not want to use the average, as it would divide this
            // low contrast area into black and white pixels, essentially creating data out of noise.
            //
            // Default the blackpoint for these blocks to be half the min - effectively white them out
            average = min / 2;
            if (verticalRegion > 0 && hortizontalRegion > 0) {
                // Correct the "white background" assumption for blocks that have neighbors by comparing
                // the pixels in this block to the previously calculated black points. This is based on
                // the fact that dark barcode symbology is always surrounded by some amount of light
                // background for which reasonable black point estimates were made. The bp estimated at
                // the boundaries is used for the interior.
                // The (min < bp) is arbitrary but works better than other heuristics that were tried.
                const averageNeighborBlackPoint = (blackPoints.get(hortizontalRegion, verticalRegion - 1) + 2 * blackPoints.get(hortizontalRegion - 1, verticalRegion) + blackPoints.get(hortizontalRegion - 1, verticalRegion - 1)) / 4;
                if (min < averageNeighborBlackPoint) average = averageNeighborBlackPoint;
            }
        }
        blackPoints.set(hortizontalRegion, verticalRegion, average);
    }
    let binarized;
    if (canOverwriteImage) {
        const binarizedBuffer = new Uint8ClampedArray(data.buffer, bufferOffset, pixelCount);
        bufferOffset += pixelCount;
        binarized = new (0, $466Xy.BitMatrix)(binarizedBuffer, width);
    } else binarized = (0, $466Xy.BitMatrix).createEmpty(width, height);
    let inverted;
    if (returnInverted) {
        if (canOverwriteImage) {
            const invertedBuffer = new Uint8ClampedArray(data.buffer, bufferOffset, pixelCount);
            inverted = new (0, $466Xy.BitMatrix)(invertedBuffer, width);
        } else inverted = (0, $466Xy.BitMatrix).createEmpty(width, height);
    }
    for(let verticalRegion = 0; verticalRegion < verticalRegionCount; verticalRegion++)for(let hortizontalRegion = 0; hortizontalRegion < horizontalRegionCount; hortizontalRegion++){
        const left = $7eb7a47b5c5fe1f6$var$numBetween(hortizontalRegion, 2, horizontalRegionCount - 3);
        const top = $7eb7a47b5c5fe1f6$var$numBetween(verticalRegion, 2, verticalRegionCount - 3);
        let sum = 0;
        for(let xRegion = -2; xRegion <= 2; xRegion++)for(let yRegion = -2; yRegion <= 2; yRegion++)sum += blackPoints.get(left + xRegion, top + yRegion);
        const threshold = sum / 25;
        for(let xRegion = 0; xRegion < $7eb7a47b5c5fe1f6$var$REGION_SIZE; xRegion++)for(let yRegion = 0; yRegion < $7eb7a47b5c5fe1f6$var$REGION_SIZE; yRegion++){
            const x = hortizontalRegion * $7eb7a47b5c5fe1f6$var$REGION_SIZE + xRegion;
            const y = verticalRegion * $7eb7a47b5c5fe1f6$var$REGION_SIZE + yRegion;
            const lum = greyscalePixels.get(x, y);
            binarized.set(x, y, lum <= threshold);
            if (returnInverted) inverted.set(x, y, !(lum <= threshold));
        }
    }
    if (returnInverted) return {
        binarized: binarized,
        inverted: inverted
    };
    return {
        binarized: binarized
    };
}

});


parcelRegister("lHnfk", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $fcbfa55aa5316979$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $fcbfa55aa5316979$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $fcbfa55aa5316979$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "setContext", function () { return $fcbfa55aa5316979$export$2f04de43fe27971a; });
$parcel$export(module.exports, "setExtra", function () { return $fcbfa55aa5316979$export$8e8e7789d42ed61d; });
$parcel$export(module.exports, "setUser", function () { return $fcbfa55aa5316979$export$8b6bb3dd62a01be2; });
$parcel$export(module.exports, "startSession", function () { return $fcbfa55aa5316979$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $fcbfa55aa5316979$export$667e7b4d445d566b; });

var $2Pa11 = parcelRequire("2Pa11");

var $jMrh2 = parcelRequire("jMrh2");

var $iny8b = parcelRequire("iny8b");

var $1W5wI = parcelRequire("1W5wI");

var $1ATua = parcelRequire("1ATua");

var $gWidS = parcelRequire("gWidS");

var $5NWBT = parcelRequire("5NWBT");

var $gdNBn = parcelRequire("gdNBn");

var $7ZJbk = parcelRequire("7ZJbk");

var $dQx3S = parcelRequire("dQx3S");

var $gKrW9 = parcelRequire("gKrW9");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $fcbfa55aa5316979$export$f5282963edea4a68(exception, hint) {
    return (0, $2Pa11.getCurrentScope)().captureException(exception, (0, $gdNBn.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $fcbfa55aa5316979$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const hint = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $2Pa11.getCurrentScope)().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $fcbfa55aa5316979$export$1462b974fdcf6ba2(event, hint) {
    return (0, $2Pa11.getCurrentScope)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $fcbfa55aa5316979$export$2f04de43fe27971a(name, context) {
    (0, $2Pa11.getIsolationScope)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $fcbfa55aa5316979$export$bb4922da0dd51b92(extras) {
    (0, $2Pa11.getIsolationScope)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $fcbfa55aa5316979$export$8e8e7789d42ed61d(key, extra) {
    (0, $2Pa11.getIsolationScope)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $fcbfa55aa5316979$export$74a8fb34822092e6(tags) {
    (0, $2Pa11.getIsolationScope)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $fcbfa55aa5316979$export$a37d07ee78eb4569(key, value) {
    (0, $2Pa11.getIsolationScope)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $fcbfa55aa5316979$export$8b6bb3dd62a01be2(user) {
    (0, $2Pa11.getIsolationScope)().setUser(user);
}
/**
 * Sets the conversation ID for the current isolation scope.
 *
 * @param conversationId The conversation ID to set. Pass `null` or `undefined` to unset the conversation ID.
 */ function $fcbfa55aa5316979$export$58213391a19e392(conversationId) {
    (0, $2Pa11.getIsolationScope)().setConversationId(conversationId);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $fcbfa55aa5316979$export$5d4e9fd7fac8e617() {
    return (0, $2Pa11.getIsolationScope)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fcbfa55aa5316979$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $2Pa11.getCurrentScope)();
    const client = (0, $2Pa11.getClient)();
    if (!client) (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $5NWBT.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fcbfa55aa5316979$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $fcbfa55aa5316979$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: 'in_progress'
        }, upsertMonitorConfig);
        const now = (0, $dQx3S.timestampInSeconds)();
        function finishCheckIn(status) {
            $fcbfa55aa5316979$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $dQx3S.timestampInSeconds)() - now
            });
        }
        // Default behavior without isolateTrace
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $gWidS.isThenable)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    }
    return (0, $2Pa11.withIsolationScope)(()=>upsertMonitorConfig?.isolateTrace ? (0, $1W5wI.startNewTrace)(runCallback) : runCallback());
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fcbfa55aa5316979$export$4909b86c8034bf73(timeout) {
    const client = (0, $2Pa11.getClient)();
    if (client) return client.flush(timeout);
    (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fcbfa55aa5316979$export$8360e631d277ea4d(timeout) {
    const client = (0, $2Pa11.getClient)();
    if (client) return client.close(timeout);
    (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $fcbfa55aa5316979$export$3f95c6f800b78024() {
    return !!(0, $2Pa11.getClient)();
}
/** If the SDK is initialized & enabled. */ function $fcbfa55aa5316979$export$3b029eb57ac4d562() {
    const client = (0, $2Pa11.getClient)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $fcbfa55aa5316979$export$9aac0b9f77928fbf(callback) {
    (0, $2Pa11.getIsolationScope)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $fcbfa55aa5316979$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $2Pa11.getIsolationScope)();
    const { user: user } = (0, $7ZJbk.getCombinedScopeData)(isolationScope, (0, $2Pa11.getCurrentScope)());
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $gKrW9.GLOBAL_OBJ).navigator || {};
    const session = (0, $iny8b.makeSession)({
        user: user,
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $iny8b.updateSession)(currentSession, {
        status: 'exited'
    });
    $fcbfa55aa5316979$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $fcbfa55aa5316979$export$17a5be43989a0bc1() {
    const isolationScope = (0, $2Pa11.getIsolationScope)();
    const currentScope = (0, $2Pa11.getCurrentScope)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $iny8b.closeSession)(session);
    $fcbfa55aa5316979$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $fcbfa55aa5316979$var$_sendSessionUpdate() {
    const isolationScope = (0, $2Pa11.getIsolationScope)();
    const client = (0, $2Pa11.getClient)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $fcbfa55aa5316979$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $fcbfa55aa5316979$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $fcbfa55aa5316979$var$_sendSessionUpdate();
}

});
parcelRegister("2Pa11", function(module, exports) {

$parcel$export(module.exports, "getCurrentScope", function () { return $20e81d0975ede5a2$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getIsolationScope", function () { return $20e81d0975ede5a2$export$68f3af03034c9e90; });
$parcel$export(module.exports, "getGlobalScope", function () { return $20e81d0975ede5a2$export$aa55d5ab8e05984f; });
$parcel$export(module.exports, "withScope", function () { return $20e81d0975ede5a2$export$ec58d9285c204497; });
$parcel$export(module.exports, "withIsolationScope", function () { return $20e81d0975ede5a2$export$9a4fed82c350c2bd; });
$parcel$export(module.exports, "getClient", function () { return $20e81d0975ede5a2$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "getTraceContextFromScope", function () { return $20e81d0975ede5a2$export$1e83db7ee4876dc4; });

var $eoinP = parcelRequire("eoinP");

var $eKPY4 = parcelRequire("eKPY4");

var $fBZm5 = parcelRequire("fBZm5");

var $giuI3 = parcelRequire("giuI3");
let $20e81d0975ede5a2$var$_externalPropagationContextProvider;
/**
 * Register an external propagation context provider function.
 * When registered, trace context will be read from the external source (e.g. OpenTelemetry)
 * instead of from the Sentry scope's propagation context.
 */ function $20e81d0975ede5a2$export$b5defb3466e9689b(fn) {
    $20e81d0975ede5a2$var$_externalPropagationContextProvider = fn;
}
/**
 * Get the external propagation context, if a provider has been registered.
 */ function $20e81d0975ede5a2$export$92547f779c920a71() {
    return $20e81d0975ede5a2$var$_externalPropagationContextProvider?.();
}
/**
 * Check if an external propagation context provider has been registered.
 */ function $20e81d0975ede5a2$export$53f0ae651a1c4298() {
    return $20e81d0975ede5a2$var$_externalPropagationContextProvider !== undefined;
}
/**
 * Get the currently active scope.
 */ function $20e81d0975ede5a2$export$c7be4b0125a10cba() {
    const carrier = (0, $eKPY4.getMainCarrier)();
    const acs = (0, $eoinP.getAsyncContextStrategy)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $20e81d0975ede5a2$export$68f3af03034c9e90() {
    const carrier = (0, $eKPY4.getMainCarrier)();
    const acs = (0, $eoinP.getAsyncContextStrategy)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $20e81d0975ede5a2$export$aa55d5ab8e05984f() {
    return (0, $eKPY4.getGlobalSingleton)('globalScope', ()=>new (0, $fBZm5.Scope)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $20e81d0975ede5a2$export$ec58d9285c204497(...rest) {
    const carrier = (0, $eKPY4.getMainCarrier)();
    const acs = (0, $eoinP.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $20e81d0975ede5a2$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $eKPY4.getMainCarrier)();
    const acs = (0, $eoinP.getAsyncContextStrategy)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $20e81d0975ede5a2$export$6bb76d6eba7e258c() {
    return $20e81d0975ede5a2$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $20e81d0975ede5a2$export$1e83db7ee4876dc4(scope) {
    const externalContext = $20e81d0975ede5a2$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $giuI3.generateSpanId)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}

});
parcelRegister("eoinP", function(module, exports) {

$parcel$export(module.exports, "getAsyncContextStrategy", function () { return $a7a1911c7f974fbd$export$f639b0c2752203be; });

var $eKPY4 = parcelRequire("eKPY4");

var $a20LS = parcelRequire("a20LS");
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $a7a1911c7f974fbd$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $eKPY4.getMainCarrier)();
    const sentry = (0, $eKPY4.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $a7a1911c7f974fbd$export$f639b0c2752203be(carrier) {
    const sentry = (0, $eKPY4.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $a20LS.getStackAsyncContextStrategy)();
}

});
parcelRegister("eKPY4", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", function () { return $abddac503a055785$export$19eade501500c6c1; });
$parcel$export(module.exports, "getSentryCarrier", function () { return $abddac503a055785$export$c8bfa33e4e8ae492; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $abddac503a055785$export$7e223ec222791509; });

var $lLmxT = parcelRequire("lLmxT");

var $gKrW9 = parcelRequire("gKrW9");
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $abddac503a055785$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $abddac503a055785$export$c8bfa33e4e8ae492((0, $gKrW9.GLOBAL_OBJ));
    return 0, $gKrW9.GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $abddac503a055785$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $lLmxT.SDK_VERSION);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $lLmxT.SDK_VERSION] = __SENTRY__[0, $lLmxT.SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $abddac503a055785$export$7e223ec222791509(name, creator, obj = (0, $gKrW9.GLOBAL_OBJ)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $lLmxT.SDK_VERSION] = __SENTRY__[0, $lLmxT.SDK_VERSION] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}

});
parcelRegister("lLmxT", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $fd7f79dabd54b95f$export$31499a9cd224b78c; });
// This is a magic string replaced by rollup
const $fd7f79dabd54b95f$export$31499a9cd224b78c = "10.47.0";

});

parcelRegister("gKrW9", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $c3169ceb01766182$export$f1a6cdb1459e81d1; });
/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $c3169ceb01766182$export$f1a6cdb1459e81d1 = globalThis;

});


parcelRegister("a20LS", function(module, exports) {

$parcel$export(module.exports, "getStackAsyncContextStrategy", function () { return $74dab0685e3b7e2b$export$329d4d4d54e42710; });

var $2jphu = parcelRequire("2jphu");

var $fBZm5 = parcelRequire("fBZm5");

var $d1TTs = parcelRequire("d1TTs");

var $gWidS = parcelRequire("gWidS");

var $eKPY4 = parcelRequire("eKPY4");
/**
 * This is an object that holds a stack of scopes.
 */ class $74dab0685e3b7e2b$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $fBZm5.Scope)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $fBZm5.Scope)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $gWidS.isThenable)(maybePromiseResult)) return (0, $d1TTs.chainAndCopyPromiseLike)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $74dab0685e3b7e2b$var$getAsyncContextStack() {
    const registry = (0, $eKPY4.getMainCarrier)();
    const sentry = (0, $eKPY4.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $74dab0685e3b7e2b$export$d36ec451f120cfba((0, $2jphu.getDefaultCurrentScope)(), (0, $2jphu.getDefaultIsolationScope)());
}
function $74dab0685e3b7e2b$var$withScope(callback) {
    return $74dab0685e3b7e2b$var$getAsyncContextStack().withScope(callback);
}
function $74dab0685e3b7e2b$var$withSetScope(scope, callback) {
    const stack = $74dab0685e3b7e2b$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $74dab0685e3b7e2b$var$withIsolationScope(callback) {
    return $74dab0685e3b7e2b$var$getAsyncContextStack().withScope(()=>{
        return callback($74dab0685e3b7e2b$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $74dab0685e3b7e2b$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $74dab0685e3b7e2b$var$withIsolationScope,
        withScope: $74dab0685e3b7e2b$var$withScope,
        withSetScope: $74dab0685e3b7e2b$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $74dab0685e3b7e2b$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$74dab0685e3b7e2b$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$74dab0685e3b7e2b$var$getAsyncContextStack().getIsolationScope()
    };
}

});
parcelRegister("2jphu", function(module, exports) {

$parcel$export(module.exports, "getDefaultCurrentScope", function () { return $1af0f76dcc0e1221$export$6f1b9191db9c4d5; });
$parcel$export(module.exports, "getDefaultIsolationScope", function () { return $1af0f76dcc0e1221$export$de9862929b76bf57; });

var $eKPY4 = parcelRequire("eKPY4");

var $fBZm5 = parcelRequire("fBZm5");
/** Get the default current scope. */ function $1af0f76dcc0e1221$export$6f1b9191db9c4d5() {
    return (0, $eKPY4.getGlobalSingleton)('defaultCurrentScope', ()=>new (0, $fBZm5.Scope)());
}
/** Get the default isolation scope. */ function $1af0f76dcc0e1221$export$de9862929b76bf57() {
    return (0, $eKPY4.getGlobalSingleton)('defaultIsolationScope', ()=>new (0, $fBZm5.Scope)());
}

});
parcelRegister("fBZm5", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $b5d9e79002eaab6c$export$775b6bb06e53a214; });

var $jMrh2 = parcelRequire("jMrh2");

var $iny8b = parcelRequire("iny8b");

var $1ATua = parcelRequire("1ATua");

var $gWidS = parcelRequire("gWidS");

var $8IjjG = parcelRequire("8IjjG");

var $5NWBT = parcelRequire("5NWBT");

var $giuI3 = parcelRequire("giuI3");

var $8fF74 = parcelRequire("8fF74");

var $e4zyg = parcelRequire("e4zyg");

var $gqtzY = parcelRequire("gqtzY");

var $dQx3S = parcelRequire("dQx3S");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $b5d9e79002eaab6c$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $b5d9e79002eaab6c$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $giuI3.generateTraceId)(),
            sampleRand: (0, $8fF74.safeMathRandom)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $b5d9e79002eaab6c$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $e4zyg._setSpanForScope)(newScope, (0, $e4zyg._getSpanForScope)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $iny8b.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $b5d9e79002eaab6c$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $gWidS.isPlainObject)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        (0, $e4zyg._setSpanForScope)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $giuI3.generateTraceId)(),
            sampleRand: (0, $8fF74.safeMathRandom)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $b5d9e79002eaab6c$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $dQx3S.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $gqtzY.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $e4zyg._getSpanForScope)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $8IjjG.merge)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $5NWBT.uuid4)();
        if (!this._client) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $5NWBT.uuid4)();
        if (!this._client) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $5NWBT.uuid4)();
        if (!this._client) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}

});
parcelRegister("jMrh2", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $e667a80926bc4243$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e667a80926bc4243$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("iny8b", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $d614d9abd8b45019$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $d614d9abd8b45019$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $d614d9abd8b45019$export$56521d9ba90f62ee; });

var $5NWBT = parcelRequire("5NWBT");

var $dQx3S = parcelRequire("dQx3S");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $d614d9abd8b45019$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $dQx3S.timestampInSeconds)();
    const session = {
        sid: (0, $5NWBT.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$d614d9abd8b45019$var$sessionToJSON(session)
    };
    if (context) $d614d9abd8b45019$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $d614d9abd8b45019$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $dQx3S.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $5NWBT.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $d614d9abd8b45019$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $d614d9abd8b45019$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $d614d9abd8b45019$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}

});
parcelRegister("5NWBT", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $439efe19e11d7183$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $439efe19e11d7183$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $439efe19e11d7183$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $439efe19e11d7183$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $439efe19e11d7183$export$6de4ffac6a2f1098; });

var $fOolf = parcelRequire("fOolf");

var $8fF74 = parcelRequire("8fF74");

var $gqtzY = parcelRequire("gqtzY");

var $gKrW9 = parcelRequire("gKrW9");
function $439efe19e11d7183$var$getCrypto() {
    const gbl = (0, $gKrW9.GLOBAL_OBJ);
    return gbl.crypto || gbl.msCrypto;
}
let $439efe19e11d7183$var$emptyUuid;
function $439efe19e11d7183$var$getRandomByte() {
    return (0, $8fF74.safeMathRandom)() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $439efe19e11d7183$export$19f53698e68b2496(crypto = $439efe19e11d7183$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $8fF74.withRandomSafeContext)(()=>crypto.randomUUID()).replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$439efe19e11d7183$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $439efe19e11d7183$var$emptyUuid = "10000000100040008000100000000000";
    return $439efe19e11d7183$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($439efe19e11d7183$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $439efe19e11d7183$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $439efe19e11d7183$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $439efe19e11d7183$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $439efe19e11d7183$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $439efe19e11d7183$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $439efe19e11d7183$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $439efe19e11d7183$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $439efe19e11d7183$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $439efe19e11d7183$export$d364f2020ab30578(input) {
    const match = input.match($439efe19e11d7183$var$SEMVER_REGEXP) || [];
    const major = $439efe19e11d7183$var$_parseInt(match[1]);
    const minor = $439efe19e11d7183$var$_parseInt(match[2]);
    const patch = $439efe19e11d7183$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $439efe19e11d7183$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $gqtzY.snipLine)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $gqtzY.snipLine)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $gqtzY.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $439efe19e11d7183$export$6de4ffac6a2f1098(exception) {
    if ($439efe19e11d7183$export$4a38e013f66150b(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $fOolf.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether we've already captured the given exception (note: not an identical exception - the very object).
 * It is considered already captured if it has the `__sentry_captured__` property set to `true`.
 *
 * @internal Only considered for internal usage
 */ function $439efe19e11d7183$export$4a38e013f66150b(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}

});
parcelRegister("fOolf", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $b82e68494ad81338$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $b82e68494ad81338$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $b82e68494ad81338$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $b82e68494ad81338$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $b82e68494ad81338$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $b82e68494ad81338$export$b0244d5063c0b61b; });

var $jMrh2 = parcelRequire("jMrh2");

var $konzj = parcelRequire("konzj");

var $1ATua = parcelRequire("1ATua");

var $gWidS = parcelRequire("gWidS");
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $b82e68494ad81338$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $b82e68494ad81338$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $b82e68494ad81338$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            value: // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $b82e68494ad81338$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $b82e68494ad81338$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b82e68494ad81338$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $b82e68494ad81338$export$62ff257738bf57f5(value) {
    if ((0, $gWidS.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$b82e68494ad81338$var$getOwnProperties(value)
    };
    else if ((0, $gWidS.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $b82e68494ad81338$var$serializeEventTarget(value.target),
            currentTarget: $b82e68494ad81338$var$serializeEventTarget(value.currentTarget),
            ...$b82e68494ad81338$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $gWidS.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $b82e68494ad81338$var$serializeEventTarget(target) {
    try {
        return (0, $gWidS.isElement)(target) ? (0, $konzj.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $b82e68494ad81338$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) return Object.fromEntries(Object.entries(obj));
    return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $b82e68494ad81338$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($b82e68494ad81338$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $b82e68494ad81338$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $b82e68494ad81338$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $b82e68494ad81338$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($b82e68494ad81338$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($b82e68494ad81338$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $b82e68494ad81338$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $b82e68494ad81338$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $b82e68494ad81338$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $gWidS.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("konzj", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $ed8854c2acd5009e$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $ed8854c2acd5009e$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $ed8854c2acd5009e$export$26727cfcc4d7e0fc; });

var $gWidS = parcelRequire("gWidS");

var $gKrW9 = parcelRequire("gKrW9");
const $ed8854c2acd5009e$var$WINDOW = (0, $gKrW9.GLOBAL_OBJ);
const $ed8854c2acd5009e$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $ed8854c2acd5009e$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $ed8854c2acd5009e$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $ed8854c2acd5009e$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $ed8854c2acd5009e$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($ed8854c2acd5009e$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $gWidS.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $ed8854c2acd5009e$export$1cfafeee2987818b() {
    try {
        return $ed8854c2acd5009e$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $ed8854c2acd5009e$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$ed8854c2acd5009e$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}

});
parcelRegister("gWidS", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $c55032c6d3d395a5$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $c55032c6d3d395a5$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $c55032c6d3d395a5$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $c55032c6d3d395a5$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $c55032c6d3d395a5$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $c55032c6d3d395a5$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $c55032c6d3d395a5$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $c55032c6d3d395a5$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $c55032c6d3d395a5$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $c55032c6d3d395a5$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $c55032c6d3d395a5$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $c55032c6d3d395a5$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $c55032c6d3d395a5$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $c55032c6d3d395a5$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isVueViewModel", function () { return $c55032c6d3d395a5$export$7916fad0ebc23f48; });
$parcel$export(module.exports, "isRequest", function () { return $c55032c6d3d395a5$export$6d3d1f317d7cda57; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $c55032c6d3d395a5$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$e6127cc7fe7395c3(wat) {
    switch($c55032c6d3d395a5$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $c55032c6d3d395a5$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$var$isBuiltin(wat, className) {
    return $c55032c6d3d395a5$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$9f9636d330b71954(wat) {
    return $c55032c6d3d395a5$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$ef9e2056653f0c8e(wat) {
    return $c55032c6d3d395a5$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$12e869b2a583f783(wat) {
    return $c55032c6d3d395a5$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$844ec244b1367d54(wat) {
    return $c55032c6d3d395a5$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$c3825b437cbdea5c(wat) {
    return wat === null || $c55032c6d3d395a5$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$53b83ca8eaab0383(wat) {
    return $c55032c6d3d395a5$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c55032c6d3d395a5$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c55032c6d3d395a5$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$49841c62b9eff15(wat) {
    return $c55032c6d3d395a5$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $c55032c6d3d395a5$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$bc2894c7158efbac(wat) {
    return $c55032c6d3d395a5$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $c55032c6d3d395a5$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c55032c6d3d395a5$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $c55032c6d3d395a5$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $c55032c6d3d395a5$export$49034edbe6b62415(request, Request);
}

});


parcelRegister("1ATua", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $129431841cf4511d$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $129431841cf4511d$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $129431841cf4511d$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "debug", function () { return $129431841cf4511d$export$1c9f709888824e05; });

var $eKPY4 = parcelRequire("eKPY4");

var $jMrh2 = parcelRequire("jMrh2");

var $gKrW9 = parcelRequire("gKrW9");
const $129431841cf4511d$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $129431841cf4511d$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $129431841cf4511d$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $129431841cf4511d$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $gKrW9.GLOBAL_OBJ))) return callback();
    const console = (0, $gKrW9.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($129431841cf4511d$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $129431841cf4511d$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $129431841cf4511d$var$enable() {
    $129431841cf4511d$var$_getLoggerSettings().enabled = true;
}
function $129431841cf4511d$var$disable() {
    $129431841cf4511d$var$_getLoggerSettings().enabled = false;
}
function $129431841cf4511d$var$isEnabled() {
    return $129431841cf4511d$var$_getLoggerSettings().enabled;
}
function $129431841cf4511d$var$log(...args) {
    $129431841cf4511d$var$_maybeLog('log', ...args);
}
function $129431841cf4511d$var$warn(...args) {
    $129431841cf4511d$var$_maybeLog('warn', ...args);
}
function $129431841cf4511d$var$error(...args) {
    $129431841cf4511d$var$_maybeLog('error', ...args);
}
function $129431841cf4511d$var$_maybeLog(level, ...args) {
    if (!(0, $jMrh2.DEBUG_BUILD)) return;
    if ($129431841cf4511d$var$isEnabled()) $129431841cf4511d$export$cda52e2a8927a2ca(()=>{
        (0, $gKrW9.GLOBAL_OBJ).console[level](`${$129431841cf4511d$var$PREFIX}[${level}]:`, ...args);
    });
}
function $129431841cf4511d$var$_getLoggerSettings() {
    if (!(0, $jMrh2.DEBUG_BUILD)) return {
        enabled: false
    };
    return (0, $eKPY4.getGlobalSingleton)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $129431841cf4511d$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $129431841cf4511d$var$enable,
    disable: /** Disable logging. */ $129431841cf4511d$var$disable,
    isEnabled: /** Check if logging is enabled. */ $129431841cf4511d$var$isEnabled,
    log: /** Log a message. */ $129431841cf4511d$var$log,
    warn: /** Log a warning. */ $129431841cf4511d$var$warn,
    error: /** Log an error. */ $129431841cf4511d$var$error
};

});


parcelRegister("8fF74", function(module, exports) {

$parcel$export(module.exports, "withRandomSafeContext", function () { return $601f9da5750b0b0e$export$ff239213cb80e2da; });
$parcel$export(module.exports, "safeMathRandom", function () { return $601f9da5750b0b0e$export$9869d72de32a3917; });
$parcel$export(module.exports, "safeDateNow", function () { return $601f9da5750b0b0e$export$65b1bada40c91b34; });

var $gKrW9 = parcelRequire("gKrW9");
// undefined = not yet resolved, null = no runner found, function = runner found
let $601f9da5750b0b0e$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $601f9da5750b0b0e$export$ff239213cb80e2da(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($601f9da5750b0b0e$var$RESOLVED_RUNNER !== undefined) return $601f9da5750b0b0e$var$RESOLVED_RUNNER ? $601f9da5750b0b0e$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for('__SENTRY_SAFE_RANDOM_ID_WRAPPER__');
    const globalWithSymbol = (0, $gKrW9.GLOBAL_OBJ);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === 'function') {
        $601f9da5750b0b0e$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $601f9da5750b0b0e$var$RESOLVED_RUNNER(cb);
    }
    $601f9da5750b0b0e$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $601f9da5750b0b0e$export$9869d72de32a3917() {
    return $601f9da5750b0b0e$export$ff239213cb80e2da(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $601f9da5750b0b0e$export$65b1bada40c91b34() {
    return $601f9da5750b0b0e$export$ff239213cb80e2da(()=>Date.now());
}

});

parcelRegister("gqtzY", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $bf5604e10adaa5d2$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $bf5604e10adaa5d2$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $bf5604e10adaa5d2$export$465e9d514283d4fd; });
$parcel$export(module.exports, "isMatchingPattern", function () { return $bf5604e10adaa5d2$export$cdded5b28a5f8c6d; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $bf5604e10adaa5d2$export$a7a5ec66062ea5d; });

var $gWidS = parcelRequire("gWidS");

var $bE8ha = parcelRequire("bE8ha");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $bf5604e10adaa5d2$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $bf5604e10adaa5d2$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $bf5604e10adaa5d2$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line typescript/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $gWidS.isVueViewModel)(value)) output.push((0, $bE8ha.getVueInternalName)(value));
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $bf5604e10adaa5d2$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $gWidS.isString)(value)) return false;
    if ((0, $gWidS.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $gWidS.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $bf5604e10adaa5d2$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$bf5604e10adaa5d2$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});
parcelRegister("bE8ha", function(module, exports) {

$parcel$export(module.exports, "UNKNOWN_FUNCTION", function () { return $87a9d9912f8cb725$export$27c7e15d453fc0ac; });
$parcel$export(module.exports, "createStackParser", function () { return $87a9d9912f8cb725$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $87a9d9912f8cb725$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $87a9d9912f8cb725$export$aad197c7121a6651; });
$parcel$export(module.exports, "getFramesFromEvent", function () { return $87a9d9912f8cb725$export$91d8ca51bd9f6a47; });
$parcel$export(module.exports, "getVueInternalName", function () { return $87a9d9912f8cb725$export$b6d9c5eb2330759f; });
$parcel$export(module.exports, "normalizeStackTracePath", function () { return $87a9d9912f8cb725$export$60c0d6c8e038267a; });
const $87a9d9912f8cb725$var$STACKTRACE_FRAME_LIMIT = 50;
const $87a9d9912f8cb725$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $87a9d9912f8cb725$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $87a9d9912f8cb725$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $87a9d9912f8cb725$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $87a9d9912f8cb725$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($87a9d9912f8cb725$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $87a9d9912f8cb725$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $87a9d9912f8cb725$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $87a9d9912f8cb725$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $87a9d9912f8cb725$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $87a9d9912f8cb725$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($87a9d9912f8cb725$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($87a9d9912f8cb725$var$STRIP_FRAME_REGEXP.test($87a9d9912f8cb725$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($87a9d9912f8cb725$var$STRIP_FRAME_REGEXP.test($87a9d9912f8cb725$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $87a9d9912f8cb725$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $87a9d9912f8cb725$var$getLastStackFrame(localStack).filename,
            function: frame.function || $87a9d9912f8cb725$export$27c7e15d453fc0ac
        }));
}
function $87a9d9912f8cb725$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $87a9d9912f8cb725$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $87a9d9912f8cb725$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $87a9d9912f8cb725$var$defaultFunctionName;
        return fn.name || $87a9d9912f8cb725$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $87a9d9912f8cb725$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $87a9d9912f8cb725$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $87a9d9912f8cb725$export$b6d9c5eb2330759f(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $87a9d9912f8cb725$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith('file://') ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}

});



parcelRegister("dQx3S", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $a149c706e743fe17$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $a149c706e743fe17$export$ee52dced521e3e18; });

var $8fF74 = parcelRequire("8fF74");

var $gKrW9 = parcelRequire("gKrW9");
const $a149c706e743fe17$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $a149c706e743fe17$export$7740643b9eeaf0c4() {
    return (0, $8fF74.safeDateNow)() / $a149c706e743fe17$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $a149c706e743fe17$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $gKrW9.GLOBAL_OBJ);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $a149c706e743fe17$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + (0, $8fF74.withRandomSafeContext)(()=>performance.now())) / $a149c706e743fe17$var$ONE_SECOND_IN_MS;
    };
}
let $a149c706e743fe17$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $a149c706e743fe17$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $a149c706e743fe17$var$_cachedTimestampInSeconds ?? ($a149c706e743fe17$var$_cachedTimestampInSeconds = $a149c706e743fe17$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $a149c706e743fe17$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $a149c706e743fe17$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $gKrW9.GLOBAL_OBJ);
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = (0, $8fF74.withRandomSafeContext)(()=>performance.now());
    const dateNow = (0, $8fF74.safeDateNow)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === 'number') {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $a149c706e743fe17$export$baf075a948ffc0bf() {
    if ($a149c706e743fe17$var$cachedTimeOrigin === null) $a149c706e743fe17$var$cachedTimeOrigin = $a149c706e743fe17$var$getBrowserTimeOrigin();
    return $a149c706e743fe17$var$cachedTimeOrigin;
}

});


parcelRegister("8IjjG", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $65816aa144fa1f51$export$4950aa0f605343fb; });
/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $65816aa144fa1f51$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $65816aa144fa1f51$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}

});

parcelRegister("giuI3", function(module, exports) {

$parcel$export(module.exports, "generateTraceId", function () { return $bdd62612993044ab$export$dc6d7ea554bcce10; });
$parcel$export(module.exports, "generateSpanId", function () { return $bdd62612993044ab$export$295213bc4d0c54ad; });

var $5NWBT = parcelRequire("5NWBT");
/**
 * Generate a random, valid trace ID.
 */ function $bdd62612993044ab$export$dc6d7ea554bcce10() {
    return (0, $5NWBT.uuid4)();
}
/**
 * Generate a random, valid span ID.
 */ function $bdd62612993044ab$export$295213bc4d0c54ad() {
    return (0, $5NWBT.uuid4)().substring(16);
}

});

parcelRegister("e4zyg", function(module, exports) {

$parcel$export(module.exports, "_setSpanForScope", function () { return $a3ed0436d1e448c7$export$3f25fa50c18e20ca; });
$parcel$export(module.exports, "_getSpanForScope", function () { return $a3ed0436d1e448c7$export$91f063ebb8eff307; });

var $fOolf = parcelRequire("fOolf");
const $a3ed0436d1e448c7$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $a3ed0436d1e448c7$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $fOolf.addNonEnumerableProperty)(scope, $a3ed0436d1e448c7$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$a3ed0436d1e448c7$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $a3ed0436d1e448c7$export$91f063ebb8eff307(scope) {
    return scope[$a3ed0436d1e448c7$var$SCOPE_SPAN_FIELD];
}

});



parcelRegister("d1TTs", function(module, exports) {

$parcel$export(module.exports, "chainAndCopyPromiseLike", function () { return $97c6b99cc213722d$export$64da0f40b0f924ba; });
const $97c6b99cc213722d$var$isActualPromise = (p)=>p instanceof Promise && !p[$97c6b99cc213722d$var$kChainedCopy];
const $97c6b99cc213722d$var$kChainedCopy = Symbol('chained PromiseLike');
/**
 * Copy the properties from a decorated promiselike object onto its chained
 * actual promise.
 */ const $97c6b99cc213722d$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    // if we're just dealing with "normal" Promise objects, return the chain
    return $97c6b99cc213722d$var$isActualPromise(chained) && $97c6b99cc213722d$var$isActualPromise(original) ? chained : $97c6b99cc213722d$var$copyProps(original, chained);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $97c6b99cc213722d$var$copyProps = (original, chained)=>{
    let mutated = false;
    //oxlint-disable-next-line guard-for-in
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === 'function') Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$97c6b99cc213722d$var$kChainedCopy]: true
    });
    return chained;
};

});




parcelRegister("1W5wI", function(module, exports) {

$parcel$export(module.exports, "startNewTrace", function () { return $168f7eb35223c149$export$f90b03291402f553; });

var $eoinP = parcelRequire("eoinP");

var $eKPY4 = parcelRequire("eKPY4");

var $2Pa11 = parcelRequire("2Pa11");

var $jMrh2 = parcelRequire("jMrh2");

var $gTUNT = parcelRequire("gTUNT");

var $cJp9I = parcelRequire("cJp9I");

var $1ATua = parcelRequire("1ATua");

var $9IjTv = parcelRequire("9IjTv");

var $3hkEm = parcelRequire("3hkEm");

var $Cb5a4 = parcelRequire("Cb5a4");

var $giuI3 = parcelRequire("giuI3");

var $8fF74 = parcelRequire("8fF74");

var $e4zyg = parcelRequire("e4zyg");

var $8C36L = parcelRequire("8C36L");

var $zaF2v = parcelRequire("zaF2v");

var $3KL2m = parcelRequire("3KL2m");

var $jsbrm = parcelRequire("jsbrm");

var $10V7a = parcelRequire("10V7a");

var $OpvoG = parcelRequire("OpvoG");

var $2Vnv3 = parcelRequire("2Vnv3");

var $aqntL = parcelRequire("aqntL");

var $keV6Y = parcelRequire("keV6Y");
/* eslint-disable max-lines */ const $168f7eb35223c149$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $168f7eb35223c149$export$a1bd95187356f372(options, callback) {
    const acs = $168f7eb35223c149$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $168f7eb35223c149$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $2Pa11.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $168f7eb35223c149$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $2Pa11.getCurrentScope)();
            const parentSpan = $168f7eb35223c149$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $OpvoG.SentryNonRecordingSpan)() : $168f7eb35223c149$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $e4zyg._setSpanForScope)(scope, activeSpan);
            return (0, $9IjTv.handleCallbackErrors)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $8C36L.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $aqntL.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $168f7eb35223c149$export$c10292ad04b92aea(options, callback) {
    const acs = $168f7eb35223c149$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $168f7eb35223c149$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $2Pa11.withScope)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $168f7eb35223c149$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $2Pa11.getCurrentScope)();
            const parentSpan = $168f7eb35223c149$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $OpvoG.SentryNonRecordingSpan)() : $168f7eb35223c149$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $e4zyg._setSpanForScope)(scope, activeSpan);
            return (0, $9IjTv.handleCallbackErrors)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $8C36L.spanToJSON)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $aqntL.SPAN_STATUS_ERROR),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $168f7eb35223c149$export$63dbba021a6b4047(options) {
    const acs = $168f7eb35223c149$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $168f7eb35223c149$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $2Pa11.withScope)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$168f7eb35223c149$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $2Pa11.getCurrentScope)();
        const parentSpan = $168f7eb35223c149$var$getParentSpan(scope, customParentSpan);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $OpvoG.SentryNonRecordingSpan)();
        return $168f7eb35223c149$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $168f7eb35223c149$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $eKPY4.getMainCarrier)();
    const acs = (0, $eoinP.getAsyncContextStrategy)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $2Pa11.getClient)();
    const incomingDsc = (0, $cJp9I.baggageHeaderToDynamicSamplingContext)(baggage);
    if (client && !(0, $zaF2v.shouldContinueTrace)(client, incomingDsc?.org_id)) return $168f7eb35223c149$export$f90b03291402f553(callback);
    return (0, $2Pa11.withScope)((scope)=>{
        const propagationContext = (0, $zaF2v.propagationContextFromHeaders)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $e4zyg._setSpanForScope)(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $168f7eb35223c149$export$e57ac09b143d92a2(span, callback) {
    const acs = $168f7eb35223c149$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $2Pa11.withScope)((scope)=>{
        (0, $e4zyg._setSpanForScope)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $168f7eb35223c149$export$869298f9835abc68(callback) {
    const acs = $168f7eb35223c149$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $2Pa11.withScope)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$168f7eb35223c149$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$168f7eb35223c149$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $168f7eb35223c149$export$f90b03291402f553(callback) {
    const acs = $168f7eb35223c149$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $2Pa11.withScope)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $giuI3.generateTraceId)(),
            sampleRand: (0, $8fF74.safeMathRandom)()
        });
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $168f7eb35223c149$export$e57ac09b143d92a2(null, callback);
    });
}
function $168f7eb35223c149$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $3hkEm.hasSpansEnabled)()) {
        const span = new (0, $OpvoG.SentryNonRecordingSpan)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $3KL2m.getDynamicSamplingContextFromSpan)(span)
            };
            (0, $3KL2m.freezeDscOnSpan)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $2Pa11.getIsolationScope)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $168f7eb35223c149$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $8C36L.addChildSpanToSpan)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $3KL2m.getDynamicSamplingContextFromSpan)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $8C36L.spanIsSampled)(parentSpan);
        span = $168f7eb35223c149$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $3KL2m.freezeDscOnSpan)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $168f7eb35223c149$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $3KL2m.freezeDscOnSpan)(span, dsc);
    }
    (0, $jsbrm.logSpanStart)(span);
    (0, $keV6Y.setCapturedScopesOnSpan)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $168f7eb35223c149$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $8C36L.spanTimeInputToSeconds)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $168f7eb35223c149$var$getAcs() {
    const carrier = (0, $eKPY4.getMainCarrier)();
    return (0, $eoinP.getAsyncContextStrategy)(carrier);
}
function $168f7eb35223c149$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $2Pa11.getClient)();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$168f7eb35223c149$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $10V7a.sampleSpan)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $Cb5a4.parseSampleRate)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $2Vnv3.SentrySpan)({
        ...spanArguments,
        attributes: {
            [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
            [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $168f7eb35223c149$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$168f7eb35223c149$var$SUPPRESS_TRACING_KEY] ? false : (0, $8C36L.spanIsSampled)(parentSpan);
    const childSpan = sampled ? new (0, $2Vnv3.SentrySpan)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $OpvoG.SentryNonRecordingSpan)({
        traceId: traceId
    });
    (0, $8C36L.addChildSpanToSpan)(parentSpan, childSpan);
    const client = (0, $2Pa11.getClient)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $168f7eb35223c149$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, $e4zyg._getSpanForScope)(scope);
    if (!span) return undefined;
    const client = (0, $2Pa11.getClient)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $8C36L.getRootSpan)(span);
    return span;
}
function $168f7eb35223c149$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $168f7eb35223c149$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}

});
parcelRegister("gTUNT", function(module, exports) {

$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function () { return $c4ddd87168b71cca$export$d7a7d984b0791405; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function () { return $c4ddd87168b71cca$export$ccfe0a40627cc34b; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE", function () { return $c4ddd87168b71cca$export$889fb736668e1ecc; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function () { return $c4ddd87168b71cca$export$1a413bd9a88fdb09; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function () { return $c4ddd87168b71cca$export$cca8dd30f57f805e; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT", function () { return $c4ddd87168b71cca$export$f5f95cff026507b5; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE", function () { return $c4ddd87168b71cca$export$69cd5c610c7bb96a; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME", function () { return $c4ddd87168b71cca$export$165ce9a229f6f050; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function () { return $c4ddd87168b71cca$export$1efec95406bbe327; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME", function () { return $c4ddd87168b71cca$export$fea48ba9f4550879; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD", function () { return $c4ddd87168b71cca$export$be7a251980e7e946; });
$parcel$export(module.exports, "SEMANTIC_ATTRIBUTE_URL_FULL", function () { return $c4ddd87168b71cca$export$25dfd73e0e32c6e1; });
$parcel$export(module.exports, "GEN_AI_CONVERSATION_ID_ATTRIBUTE", function () { return $c4ddd87168b71cca$export$71a4a707257f2774; });
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $c4ddd87168b71cca$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $c4ddd87168b71cca$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $c4ddd87168b71cca$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $c4ddd87168b71cca$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $c4ddd87168b71cca$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $c4ddd87168b71cca$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $c4ddd87168b71cca$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $c4ddd87168b71cca$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $c4ddd87168b71cca$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $c4ddd87168b71cca$export$1efec95406bbe327 = 'sentry.profile_id';
const $c4ddd87168b71cca$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $c4ddd87168b71cca$export$b016f89ac1066ec = 'cache.hit';
const $c4ddd87168b71cca$export$3110e4c3f4386399 = 'cache.key';
const $c4ddd87168b71cca$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $c4ddd87168b71cca$export$be7a251980e7e946 = 'http.request.method';
const $c4ddd87168b71cca$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $c4ddd87168b71cca$export$ff77b5fd5b2d627b = 'sentry.link.type';
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $c4ddd87168b71cca$export$71a4a707257f2774 = 'gen_ai.conversation.id';

});

parcelRegister("cJp9I", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $944d3366f9afd05f$export$5b96ee2c8421f107; });
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", function () { return $944d3366f9afd05f$export$56766feef403f365; });

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $gWidS = parcelRequire("gWidS");
const $944d3366f9afd05f$export$6e69537d67fa20f = 'sentry-';
const $944d3366f9afd05f$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $944d3366f9afd05f$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $944d3366f9afd05f$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $944d3366f9afd05f$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($944d3366f9afd05f$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($944d3366f9afd05f$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $944d3366f9afd05f$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$944d3366f9afd05f$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $944d3366f9afd05f$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $944d3366f9afd05f$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $gWidS.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $944d3366f9afd05f$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $944d3366f9afd05f$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $944d3366f9afd05f$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $944d3366f9afd05f$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $944d3366f9afd05f$export$bdd844ddb2def819) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});

parcelRegister("9IjTv", function(module, exports) {

$parcel$export(module.exports, "handleCallbackErrors", function () { return $7127a7b4310e5b61$export$18ce21a8b7efd7e9; });

var $d1TTs = parcelRequire("d1TTs");

var $gWidS = parcelRequire("gWidS");
/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $7127a7b4310e5b61$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $7127a7b4310e5b61$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 *
 * For thenable objects with extra methods (like jQuery's jqXHR),
 * this function preserves those methods by wrapping the original thenable in a Proxy
 * that intercepts .then() calls to apply error handling while forwarding all other
 * properties to the original object.
 * This allows code like `startSpan(() => $.ajax(...)).abort()` to work correctly.
 */ function $7127a7b4310e5b61$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $gWidS.isThenable)(value)) return (0, $d1TTs.chainAndCopyPromiseLike)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    // Non-thenable value - call callbacks immediately and return as-is
    onFinally();
    onSuccess(value);
    return value;
}

});

parcelRegister("3hkEm", function(module, exports) {

$parcel$export(module.exports, "hasSpansEnabled", function () { return $2632fa46c3ca4974$export$1f70765132c3c225; });

var $2Pa11 = parcelRequire("2Pa11");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $2632fa46c3ca4974$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $2Pa11.getClient)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}

});

parcelRegister("Cb5a4", function(module, exports) {

$parcel$export(module.exports, "parseSampleRate", function () { return $072c256da9ed0b71$export$a5bd2d81656d9546; });
/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $072c256da9ed0b71$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}

});

parcelRegister("8C36L", function(module, exports) {

$parcel$export(module.exports, "TRACE_FLAG_NONE", function () { return $64544889f5590cf2$export$208d5b368507fb8b; });
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", function () { return $64544889f5590cf2$export$eb571cd9b5d98de8; });
$parcel$export(module.exports, "spanToTransactionTraceContext", function () { return $64544889f5590cf2$export$4c3967a8a2f6bbd6; });
$parcel$export(module.exports, "spanToJSON", function () { return $64544889f5590cf2$export$92d8c23565496537; });
$parcel$export(module.exports, "spanToTraceContext", function () { return $64544889f5590cf2$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanIsSampled", function () { return $64544889f5590cf2$export$5caecac1caaf3a71; });
$parcel$export(module.exports, "convertSpanLinksForEnvelope", function () { return $64544889f5590cf2$export$cb3e3a12e0eec16c; });
$parcel$export(module.exports, "spanTimeInputToSeconds", function () { return $64544889f5590cf2$export$3f7581298f56c6d7; });
$parcel$export(module.exports, "getStatusMessage", function () { return $64544889f5590cf2$export$e238a77ea3a8cd66; });
$parcel$export(module.exports, "addChildSpanToSpan", function () { return $64544889f5590cf2$export$81397d924722cc65; });
$parcel$export(module.exports, "getSpanDescendants", function () { return $64544889f5590cf2$export$340c5c8a13ffc680; });
$parcel$export(module.exports, "getRootSpan", function () { return $64544889f5590cf2$export$c4c6a79b1260ca1b; });
$parcel$export(module.exports, "getActiveSpan", function () { return $64544889f5590cf2$export$1be426a8e585c83e; });
$parcel$export(module.exports, "showSpanDropWarning", function () { return $64544889f5590cf2$export$d11691ff45a3e535; });

var $eoinP = parcelRequire("eoinP");

var $eKPY4 = parcelRequire("eKPY4");

var $2Pa11 = parcelRequire("2Pa11");

var $gTUNT = parcelRequire("gTUNT");

var $aqntL = parcelRequire("aqntL");

var $keV6Y = parcelRequire("keV6Y");

var $fOolf = parcelRequire("fOolf");

var $giuI3 = parcelRequire("giuI3");

var $dQx3S = parcelRequire("dQx3S");

var $zaF2v = parcelRequire("zaF2v");

var $1ATua = parcelRequire("1ATua");

var $e4zyg = parcelRequire("e4zyg");
// These are aligned with OpenTelemetry trace flags
const $64544889f5590cf2$export$208d5b368507fb8b = 0x0;
const $64544889f5590cf2$export$eb571cd9b5d98de8 = 0x1;
let $64544889f5590cf2$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $64544889f5590cf2$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $64544889f5590cf2$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $64544889f5590cf2$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $64544889f5590cf2$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $keV6Y.getCapturedScopesOnSpan)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $giuI3.generateSpanId)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $64544889f5590cf2$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $64544889f5590cf2$export$5caecac1caaf3a71(span);
    return (0, $zaF2v.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $64544889f5590cf2$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $64544889f5590cf2$export$5caecac1caaf3a71(span);
    return (0, $zaF2v.generateTraceparentHeader)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $64544889f5590cf2$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $64544889f5590cf2$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $64544889f5590cf2$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $64544889f5590cf2$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $64544889f5590cf2$var$ensureTimestampInSeconds(input.getTime());
    return (0, $dQx3S.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $64544889f5590cf2$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $64544889f5590cf2$export$92d8c23565496537(span) {
    if ($64544889f5590cf2$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($64544889f5590cf2$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $64544889f5590cf2$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $64544889f5590cf2$export$3f7581298f56c6d7(endTime) || undefined,
            status: $64544889f5590cf2$export$e238a77ea3a8cd66(status),
            op: attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            origin: attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            links: $64544889f5590cf2$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $64544889f5590cf2$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $64544889f5590cf2$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $64544889f5590cf2$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $64544889f5590cf2$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $64544889f5590cf2$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $aqntL.SPAN_STATUS_UNSET)) return undefined;
    if (status.code === (0, $aqntL.SPAN_STATUS_OK)) return 'ok';
    return status.message || 'internal_error';
}
const $64544889f5590cf2$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $64544889f5590cf2$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $64544889f5590cf2$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$64544889f5590cf2$var$ROOT_SPAN_FIELD] || span;
    (0, $fOolf.addNonEnumerableProperty)(childSpan, $64544889f5590cf2$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$64544889f5590cf2$var$CHILD_SPANS_FIELD]) span[$64544889f5590cf2$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $fOolf.addNonEnumerableProperty)(span, $64544889f5590cf2$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $64544889f5590cf2$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$64544889f5590cf2$var$CHILD_SPANS_FIELD]) span[$64544889f5590cf2$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $64544889f5590cf2$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($64544889f5590cf2$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$64544889f5590cf2$var$CHILD_SPANS_FIELD] ? Array.from(span[$64544889f5590cf2$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $64544889f5590cf2$export$c4c6a79b1260ca1b(span) {
    return span[$64544889f5590cf2$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $64544889f5590cf2$export$1be426a8e585c83e() {
    const carrier = (0, $eKPY4.getMainCarrier)();
    const acs = (0, $eoinP.getAsyncContextStrategy)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $e4zyg._getSpanForScope)((0, $2Pa11.getCurrentScope)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $64544889f5590cf2$export$d11691ff45a3e535() {
    if (!$64544889f5590cf2$var$hasShownSpanDropWarning) {
        (0, $1ATua.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        $64544889f5590cf2$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $64544889f5590cf2$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'custom',
        [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME)]: name
    });
}

});
parcelRegister("aqntL", function(module, exports) {

$parcel$export(module.exports, "SPAN_STATUS_UNSET", function () { return $796e8b8b7a908bc3$export$136e25984ba4a383; });
$parcel$export(module.exports, "SPAN_STATUS_OK", function () { return $796e8b8b7a908bc3$export$58f7963109c806fc; });
$parcel$export(module.exports, "SPAN_STATUS_ERROR", function () { return $796e8b8b7a908bc3$export$f966a0446ece71e; });
const $796e8b8b7a908bc3$export$136e25984ba4a383 = 0;
const $796e8b8b7a908bc3$export$58f7963109c806fc = 1;
const $796e8b8b7a908bc3$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $796e8b8b7a908bc3$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $796e8b8b7a908bc3$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $796e8b8b7a908bc3$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $796e8b8b7a908bc3$export$f966a0446ece71e,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $796e8b8b7a908bc3$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $796e8b8b7a908bc3$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}

});

parcelRegister("keV6Y", function(module, exports) {

$parcel$export(module.exports, "setCapturedScopesOnSpan", function () { return $ebc16a95b19cdfd9$export$cddb4027e3b0dd66; });
$parcel$export(module.exports, "getCapturedScopesOnSpan", function () { return $ebc16a95b19cdfd9$export$c08fbc656a245d03; });

var $fOolf = parcelRequire("fOolf");

var $gKrW9 = parcelRequire("gKrW9");
const $ebc16a95b19cdfd9$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $ebc16a95b19cdfd9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Wrap a scope with a WeakRef if available, falling back to a direct scope. */ function $ebc16a95b19cdfd9$var$wrapScopeWithWeakRef(scope) {
    try {
        // @ts-expect-error - WeakRef is not available in all environments
        const WeakRefClass = (0, $gKrW9.GLOBAL_OBJ).WeakRef;
        if (typeof WeakRefClass === 'function') return new WeakRefClass(scope);
    } catch  {
    // WeakRef not available or failed to create
    // We'll fall back to a direct scope
    }
    return scope;
}
/** Try to unwrap a scope from a potential WeakRef wrapper. */ function $ebc16a95b19cdfd9$var$unwrapScopeFromWeakRef(scopeRef) {
    if (!scopeRef) return undefined;
    if (typeof scopeRef === 'object' && 'deref' in scopeRef && typeof scopeRef.deref === 'function') try {
        return scopeRef.deref();
    } catch  {
        return undefined;
    }
    // Fallback to a direct scope
    return scopeRef;
}
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $ebc16a95b19cdfd9$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $fOolf.addNonEnumerableProperty)(span, $ebc16a95b19cdfd9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $ebc16a95b19cdfd9$var$wrapScopeWithWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, $fOolf.addNonEnumerableProperty)(span, $ebc16a95b19cdfd9$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $ebc16a95b19cdfd9$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$ebc16a95b19cdfd9$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $ebc16a95b19cdfd9$var$unwrapScopeFromWeakRef(spanWithScopes[$ebc16a95b19cdfd9$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}

});

parcelRegister("zaF2v", function(module, exports) {

$parcel$export(module.exports, "propagationContextFromHeaders", function () { return $069b8a098113cbbf$export$261f383d16a93e39; });
$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $069b8a098113cbbf$export$f35d907436da45cf; });
$parcel$export(module.exports, "generateTraceparentHeader", function () { return $069b8a098113cbbf$export$1aff3752542747dd; });
$parcel$export(module.exports, "shouldContinueTrace", function () { return $069b8a098113cbbf$export$18811bc99eefceaa; });

var $1ATua = parcelRequire("1ATua");

var $cJp9I = parcelRequire("cJp9I");

var $6Zvn8 = parcelRequire("6Zvn8");

var $Cb5a4 = parcelRequire("Cb5a4");

var $giuI3 = parcelRequire("giuI3");

var $8fF74 = parcelRequire("8fF74");
// oxlint-disable-next-line sdk/no-regexp-constructor -- RegExp is used for readability here
const $069b8a098113cbbf$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $069b8a098113cbbf$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($069b8a098113cbbf$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $069b8a098113cbbf$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $069b8a098113cbbf$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $cJp9I.baggageHeaderToDynamicSamplingContext)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $giuI3.generateTraceId)(),
        sampleRand: (0, $8fF74.safeMathRandom)()
    };
    const sampleRand = $069b8a098113cbbf$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $069b8a098113cbbf$export$f35d907436da45cf(traceId = (0, $giuI3.generateTraceId)(), spanId = (0, $giuI3.generateSpanId)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $069b8a098113cbbf$export$1aff3752542747dd(traceId = (0, $giuI3.generateTraceId)(), spanId = (0, $giuI3.generateSpanId)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? '01' : '00'}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $069b8a098113cbbf$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $Cb5a4.parseSampleRate)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $Cb5a4.parseSampleRate)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? (0, $8fF74.safeMathRandom)() * parsedSampleRate : parsedSampleRate + (0, $8fF74.safeMathRandom)() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return (0, $8fF74.safeMathRandom)();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $069b8a098113cbbf$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $6Zvn8.extractOrgIdFromClient)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $1ATua.debug).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $1ATua.debug).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}

});
parcelRegister("6Zvn8", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $5170c66e174b3cc1$export$44d472fbb931a776; });
$parcel$export(module.exports, "extractOrgIdFromClient", function () { return $5170c66e174b3cc1$export$b7ac9b8efa4bb595; });
$parcel$export(module.exports, "makeDsn", function () { return $5170c66e174b3cc1$export$128827c3562ec0cb; });

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");
/** Regular expression used to extract org ID from a DSN host. */ const $5170c66e174b3cc1$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $5170c66e174b3cc1$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $5170c66e174b3cc1$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $5170c66e174b3cc1$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $5170c66e174b3cc1$export$b892860177f70a30(str) {
    const match = $5170c66e174b3cc1$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $1ATua.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $5170c66e174b3cc1$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $5170c66e174b3cc1$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $5170c66e174b3cc1$var$validateDsn(dsn) {
    if (!(0, $jMrh2.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $1ATua.debug).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $1ATua.debug).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$5170c66e174b3cc1$var$isValidProtocol(protocol)) {
        (0, $1ATua.debug).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $1ATua.debug).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $5170c66e174b3cc1$export$5914f4e7748c29c9(host) {
    const match = host.match($5170c66e174b3cc1$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $5170c66e174b3cc1$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $5170c66e174b3cc1$export$5914f4e7748c29c9(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $5170c66e174b3cc1$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $5170c66e174b3cc1$export$b892860177f70a30(from) : $5170c66e174b3cc1$var$dsnFromComponents(from);
    if (!components || !$5170c66e174b3cc1$var$validateDsn(components)) return undefined;
    return components;
}

});



parcelRegister("3KL2m", function(module, exports) {

$parcel$export(module.exports, "freezeDscOnSpan", function () { return $2bba27958f5d133f$export$7398c93e763ca9fd; });
$parcel$export(module.exports, "getDynamicSamplingContextFromScope", function () { return $2bba27958f5d133f$export$89ef1736f08c6b2b; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $2bba27958f5d133f$export$a117f995597e25df; });

var $fsBIR = parcelRequire("fsBIR");

var $2Pa11 = parcelRequire("2Pa11");

var $gTUNT = parcelRequire("gTUNT");

var $cJp9I = parcelRequire("cJp9I");

var $6Zvn8 = parcelRequire("6Zvn8");

var $3hkEm = parcelRequire("3hkEm");

var $fOolf = parcelRequire("fOolf");

var $8C36L = parcelRequire("8C36L");

var $keV6Y = parcelRequire("keV6Y");
/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $2bba27958f5d133f$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $2bba27958f5d133f$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $fOolf.addNonEnumerableProperty)(spanWithMaybeDsc, $2bba27958f5d133f$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $2bba27958f5d133f$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $fsBIR.DEFAULT_ENVIRONMENT),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $6Zvn8.extractOrgIdFromClient)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $2bba27958f5d133f$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $2bba27958f5d133f$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $2bba27958f5d133f$export$a117f995597e25df(span) {
    const client = (0, $2Pa11.getClient)();
    if (!client) return {};
    const rootSpan = (0, $8C36L.getRootSpan)(span);
    const rootSpanJson = (0, $8C36L.spanToJSON)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? rootSpanAttributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$2bba27958f5d133f$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $cJp9I.baggageHeaderToDynamicSamplingContext)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $2bba27958f5d133f$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $3hkEm.hasSpansEnabled)()) {
        dsc.sampled = String((0, $8C36L.spanIsSampled)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $keV6Y.getCapturedScopesOnSpan)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $2bba27958f5d133f$export$95cf936fdacaff7b(span) {
    const dsc = $2bba27958f5d133f$export$a117f995597e25df(span);
    return (0, $cJp9I.dynamicSamplingContextToSentryBaggageHeader)(dsc);
}

});
parcelRegister("fsBIR", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $b416bb6f47690297$export$849dbeeeda01ae98; });
const $b416bb6f47690297$export$849dbeeeda01ae98 = 'production';
const $b416bb6f47690297$export$6829f580e78306fa = 'development';

});


parcelRegister("jsbrm", function(module, exports) {

$parcel$export(module.exports, "logSpanStart", function () { return $e29981a9c2566386$export$2f3d84e767c9592b; });
$parcel$export(module.exports, "logSpanEnd", function () { return $e29981a9c2566386$export$b77c830667a4d630; });

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $8C36L = parcelRequire("8C36L");
/**
 * Print a log message for a started span.
 */ function $e29981a9c2566386$export$2f3d84e767c9592b(span) {
    if (!(0, $jMrh2.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $8C36L.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $8C36L.spanIsSampled)(span);
    const rootSpan = (0, $8C36L.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $8C36L.spanToJSON)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $1ATua.debug).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $e29981a9c2566386$export$b77c830667a4d630(span) {
    if (!(0, $jMrh2.DEBUG_BUILD)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $8C36L.spanToJSON)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $8C36L.getRootSpan)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $1ATua.debug).log(msg);
}

});

parcelRegister("10V7a", function(module, exports) {

$parcel$export(module.exports, "sampleSpan", function () { return $0bd21851b34bc1d1$export$5f833db634b217bb; });

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $3hkEm = parcelRequire("3hkEm");

var $Cb5a4 = parcelRequire("Cb5a4");
/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $0bd21851b34bc1d1$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $3hkEm.hasSpansEnabled)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $Cb5a4.parseSampleRate)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}

});

parcelRegister("OpvoG", function(module, exports) {

$parcel$export(module.exports, "SentryNonRecordingSpan", function () { return $0978747802c9d368$export$d6636b700b76c516; });

var $giuI3 = parcelRequire("giuI3");

var $8C36L = parcelRequire("8C36L");
/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $0978747802c9d368$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $giuI3.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $giuI3.generateSpanId)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $8C36L.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}

});

parcelRegister("2Vnv3", function(module, exports) {

$parcel$export(module.exports, "SentrySpan", function () { return $22132237229d4f17$export$a92149b045260d9f; });

var $2Pa11 = parcelRequire("2Pa11");

var $jMrh2 = parcelRequire("jMrh2");

var $8R6vM = parcelRequire("8R6vM");

var $gTUNT = parcelRequire("gTUNT");

var $1ATua = parcelRequire("1ATua");

var $giuI3 = parcelRequire("giuI3");

var $8C36L = parcelRequire("8C36L");

var $dQx3S = parcelRequire("dQx3S");

var $3KL2m = parcelRequire("3KL2m");

var $jsbrm = parcelRequire("jsbrm");

var $42oag = parcelRequire("42oag");

var $keV6Y = parcelRequire("keV6Y");
const $22132237229d4f17$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $22132237229d4f17$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $giuI3.generateTraceId)();
        this._spanId = spanContext.spanId || (0, $giuI3.generateSpanId)();
        this._startTime = spanContext.startTimestamp || (0, $dQx3S.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: 'manual',
            [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $8C36L.TRACE_FLAG_SAMPLED) : (0, $8C36L.TRACE_FLAG_NONE)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $8C36L.spanTimeInputToSeconds)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $8C36L.spanTimeInputToSeconds)(endTimestamp);
        (0, $jsbrm.logSpanEnd)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_OP],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $8C36L.getStatusMessage)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
            profile_id: this._attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_PROFILE_ID],
            exclusive_time: this._attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
            measurements: (0, $42oag.timedEventsToMeasurements)(this._events),
            is_segment: this._isStandaloneSpan && (0, $8C36L.getRootSpan)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $8C36L.getRootSpan)(this).spanContext().spanId : undefined,
            links: (0, $8C36L.convertSpanLinksForEnvelope)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('[Tracing] Adding an event to span:', name);
        const time = $22132237229d4f17$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $dQx3S.timestampInSeconds)();
        const attributes = $22132237229d4f17$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $8C36L.spanTimeInputToSeconds)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $2Pa11.getClient)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $8C36L.getRootSpan)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $22132237229d4f17$var$sendSpanEnvelope((0, $8R6vM.createSpanEnvelope)([
                this
            ], client));
            else {
                (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $keV6Y.getCapturedScopesOnSpan)(this).scope || (0, $2Pa11.getCurrentScope)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$22132237229d4f17$var$isFullFinishedSpan((0, $8C36L.spanToJSON)(this))) return undefined;
        if (!this._name) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $keV6Y.getCapturedScopesOnSpan)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $8C36L.getSpanDescendants)(this).filter((span)=>span !== this && !$22132237229d4f17$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $8C36L.spanToJSON)(span)).filter($22132237229d4f17$var$isFullFinishedSpan);
        const source = this._attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        spans.forEach((span)=>{
            delete span.data[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $8C36L.spanToTransactionTraceContext)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $22132237229d4f17$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $22132237229d4f17$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $3KL2m.getDynamicSamplingContextFromSpan)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $42oag.timedEventsToMeasurements)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $22132237229d4f17$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $22132237229d4f17$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $22132237229d4f17$var$isStandaloneSpan(span) {
    return span instanceof $22132237229d4f17$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $22132237229d4f17$var$sendSpanEnvelope(envelope) {
    const client = (0, $2Pa11.getClient)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

});
parcelRegister("8R6vM", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $6728530b8b39bae4$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $6728530b8b39bae4$export$c31057337a18010f; });
$parcel$export(module.exports, "createSpanEnvelope", function () { return $6728530b8b39bae4$export$19a0081d4b39d77; });

var $3KL2m = parcelRequire("3KL2m");

var $6Zvn8 = parcelRequire("6Zvn8");

var $45Tty = parcelRequire("45Tty");

var $kIFK2 = parcelRequire("kIFK2");

var $8C36L = parcelRequire("8C36L");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $6728530b8b39bae4$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $6728530b8b39bae4$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $45Tty.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $6Zvn8.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $45Tty.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $6728530b8b39bae4$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $45Tty.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $6728530b8b39bae4$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $45Tty.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $45Tty.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $6728530b8b39bae4$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $3KL2m.getDynamicSamplingContextFromSpan)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $6Zvn8.dsnToString)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>!(0, $kIFK2.shouldIgnoreSpan)((0, $8C36L.spanToJSON)(span), ignoreSpans)) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $8C36L.spanToJSON)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $8C36L.showSpanDropWarning)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $8C36L.spanToJSON);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $45Tty.createSpanEnvelopeItem)(spanJson));
    }
    return (0, $45Tty.createEnvelope)(headers, items);
}

});
parcelRegister("45Tty", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $2fb2a961cacd6a8c$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $2fb2a961cacd6a8c$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $2fb2a961cacd6a8c$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "envelopeContainsItemType", function () { return $2fb2a961cacd6a8c$export$604a45d95a155e2b; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $2fb2a961cacd6a8c$export$32f9b428425aac85; });
$parcel$export(module.exports, "createSpanEnvelopeItem", function () { return $2fb2a961cacd6a8c$export$655cf139bc8b8afd; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $2fb2a961cacd6a8c$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $2fb2a961cacd6a8c$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $2fb2a961cacd6a8c$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $2fb2a961cacd6a8c$export$92b6093782fe661b; });

var $eKPY4 = parcelRequire("eKPY4");

var $6Zvn8 = parcelRequire("6Zvn8");

var $fxHHp = parcelRequire("fxHHp");

var $gKrW9 = parcelRequire("gKrW9");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2fb2a961cacd6a8c$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $2fb2a961cacd6a8c$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $2fb2a961cacd6a8c$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $2fb2a961cacd6a8c$export$604a45d95a155e2b(envelope, types) {
    return $2fb2a961cacd6a8c$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $2fb2a961cacd6a8c$var$encodeUTF8(input) {
    const carrier = (0, $eKPY4.getSentryCarrier)((0, $gKrW9.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $2fb2a961cacd6a8c$var$decodeUTF8(input) {
    const carrier = (0, $eKPY4.getSentryCarrier)((0, $gKrW9.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $2fb2a961cacd6a8c$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $2fb2a961cacd6a8c$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $2fb2a961cacd6a8c$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $fxHHp.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $2fb2a961cacd6a8c$var$concatBuffers(parts);
}
function $2fb2a961cacd6a8c$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $2fb2a961cacd6a8c$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $2fb2a961cacd6a8c$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($2fb2a961cacd6a8c$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $2fb2a961cacd6a8c$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $2fb2a961cacd6a8c$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $2fb2a961cacd6a8c$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
// Map of envelope item types to data categories where the category differs from the type.
// Types that map to themselves (session, attachment, transaction, profile, feedback, span, metric) fall through.
const $2fb2a961cacd6a8c$var$DATA_CATEGORY_OVERRIDES = {
    sessions: 'session',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    raw_security: 'security',
    log: 'log_item',
    trace_metric: 'metric'
};
function $2fb2a961cacd6a8c$var$_isOverriddenType(type) {
    return type in $2fb2a961cacd6a8c$var$DATA_CATEGORY_OVERRIDES;
}
/**
 * Maps the type of an envelope item to a data category.
 */ function $2fb2a961cacd6a8c$export$b11169581eeaf237(type) {
    return $2fb2a961cacd6a8c$var$_isOverriddenType(type) ? $2fb2a961cacd6a8c$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
/** Extracts the minimal SDK info from the metadata or an events */ function $2fb2a961cacd6a8c$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $2fb2a961cacd6a8c$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $6Zvn8.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}

});
parcelRegister("fxHHp", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $b50bd5d1904a2992$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $b50bd5d1904a2992$export$23fbbb20bed71033; });

var $gWidS = parcelRequire("gWidS");

var $fOolf = parcelRequire("fOolf");

var $bE8ha = parcelRequire("bE8ha");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b50bd5d1904a2992$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $b50bd5d1904a2992$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $b50bd5d1904a2992$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $b50bd5d1904a2992$export$a3295358bff77e(object, depth);
    if ($b50bd5d1904a2992$var$jsonSize(normalized) > maxSize) return $b50bd5d1904a2992$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $b50bd5d1904a2992$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $b50bd5d1904a2992$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $b50bd5d1904a2992$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $b50bd5d1904a2992$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $fOolf.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $b50bd5d1904a2992$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $b50bd5d1904a2992$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $gWidS.isVueViewModel)(value)) return (0, $bE8ha.getVueInternalName)(value);
        // React's SyntheticEvent thingy
        if ((0, $gWidS.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $bE8ha.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $b50bd5d1904a2992$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $b50bd5d1904a2992$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $b50bd5d1904a2992$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b50bd5d1904a2992$var$jsonSize(value) {
    return $b50bd5d1904a2992$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $b50bd5d1904a2992$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // oxlint-disable-next-line sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $b50bd5d1904a2992$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("kIFK2", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreSpan", function () { return $f1584bb3456a99a7$export$5d569ac97c389400; });
$parcel$export(module.exports, "reparentChildSpans", function () { return $f1584bb3456a99a7$export$ddf57376e818b444; });

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $gqtzY = parcelRequire("gqtzY");
function $f1584bb3456a99a7$var$logIgnoredSpan(droppedSpan) {
    (0, $1ATua.debug).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $f1584bb3456a99a7$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length || !span.description) return false;
    for (const pattern of ignoreSpans){
        if ($f1584bb3456a99a7$var$isStringOrRegExp(pattern)) {
            if ((0, $gqtzY.isMatchingPattern)(span.description, pattern)) {
                (0, $jMrh2.DEBUG_BUILD) && $f1584bb3456a99a7$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        if (!pattern.name && !pattern.op) continue;
        const nameMatches = pattern.name ? (0, $gqtzY.isMatchingPattern)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $gqtzY.isMatchingPattern)(span.op, pattern.op) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
        // not both op and name actually have to match. This is the most efficient way to check
        // for all combinations of name and op patterns.
        if (nameMatches && opMatches) {
            (0, $jMrh2.DEBUG_BUILD) && $f1584bb3456a99a7$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $f1584bb3456a99a7$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $f1584bb3456a99a7$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}

});


parcelRegister("42oag", function(module, exports) {

$parcel$export(module.exports, "timedEventsToMeasurements", function () { return $2f0a17e6e25faec9$export$487db6fcdf36893e; });

var $jMrh2 = parcelRequire("jMrh2");

var $gTUNT = parcelRequire("gTUNT");

var $1ATua = parcelRequire("1ATua");

var $8C36L = parcelRequire("8C36L");
/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $2f0a17e6e25faec9$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $8C36L.getActiveSpan)()) {
    const rootSpan = activeSpan && (0, $8C36L.getRootSpan)(activeSpan);
    if (rootSpan) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE)]: value,
            [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $2f0a17e6e25faec9$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
        const value = attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}

});



parcelRegister("gdNBn", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $bcf45625b22adeab$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $bcf45625b22adeab$export$76b5f966996d1653; });

var $fsBIR = parcelRequire("fsBIR");

var $eRbSI = parcelRequire("eRbSI");

var $fBZm5 = parcelRequire("fBZm5");

var $8lnYa = parcelRequire("8lnYa");

var $5NWBT = parcelRequire("5NWBT");

var $fxHHp = parcelRequire("fxHHp");

var $7ZJbk = parcelRequire("7ZJbk");

var $gqtzY = parcelRequire("gqtzY");

var $e07xZ = parcelRequire("e07xZ");

var $dQx3S = parcelRequire("dQx3S");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $bcf45625b22adeab$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $5NWBT.uuid4)(),
        timestamp: event.timestamp || (0, $dQx3S.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $bcf45625b22adeab$export$d7e04067a6fbc882(prepared, options);
    $bcf45625b22adeab$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $bcf45625b22adeab$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $bcf45625b22adeab$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $5NWBT.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $7ZJbk.getCombinedScopeData)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $7ZJbk.applyScopeDataToEvent)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    // Skip event processors for internal exceptions to prevent recursion
    // oxlint-disable-next-line typescript/prefer-optional-chain
    const isInternalException = hint.data && hint.data.__sentry__ === true;
    const result = isInternalException ? (0, $e07xZ.resolvedSyncPromise)(prepared) : (0, $eRbSI.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $bcf45625b22adeab$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $bcf45625b22adeab$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $bcf45625b22adeab$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $fsBIR.DEFAULT_ENVIRONMENT);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $gqtzY.truncate)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) // Truncates error messages
        exception.value = (0, $gqtzY.truncate)(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $bcf45625b22adeab$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $8lnYa.getFilenameToDebugIdMap)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $bcf45625b22adeab$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $bcf45625b22adeab$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $bcf45625b22adeab$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $fxHHp.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $fxHHp.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $fxHHp.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $fxHHp.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $fxHHp.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $fxHHp.normalize)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $fxHHp.normalize)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $bcf45625b22adeab$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $fBZm5.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $bcf45625b22adeab$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($bcf45625b22adeab$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($bcf45625b22adeab$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $bcf45625b22adeab$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $fBZm5.Scope) || typeof hint === 'function';
}
const $bcf45625b22adeab$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $bcf45625b22adeab$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$bcf45625b22adeab$var$captureContextKeys.includes(key));
}

});
parcelRegister("eRbSI", function(module, exports) {

$parcel$export(module.exports, "notifyEventProcessors", function () { return $ad0f3b5c19a197be$export$bf2a096c3e883e79; });

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $gWidS = parcelRequire("gWidS");

var $e07xZ = parcelRequire("e07xZ");
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $ad0f3b5c19a197be$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $ad0f3b5c19a197be$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $gWidS.isThenable)(result) ? result : (0, $e07xZ.resolvedSyncPromise)(result);
    } catch (error) {
        return (0, $e07xZ.rejectedSyncPromise)(error);
    }
}
function $ad0f3b5c19a197be$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $jMrh2.DEBUG_BUILD) && result === null && (0, $1ATua.debug).log(`Event processor "${processor.id || '?'}" dropped event`);
    if ((0, $gWidS.isThenable)(result)) return result.then((final)=>$ad0f3b5c19a197be$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $ad0f3b5c19a197be$var$_notifyEventProcessors(result, hint, processors, index + 1);
}

});
parcelRegister("e07xZ", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $a316eb803beb3ac2$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $a316eb803beb3ac2$export$78e43115b553f358; });

var $gWidS = parcelRequire("gWidS");
/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $a316eb803beb3ac2$var$STATE_PENDING = 0;
const $a316eb803beb3ac2$var$STATE_RESOLVED = 1;
const $a316eb803beb3ac2$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $a316eb803beb3ac2$export$1fda8aa4d135f8aa(value) {
    return new $a316eb803beb3ac2$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $a316eb803beb3ac2$export$78e43115b553f358(reason) {
    return new $a316eb803beb3ac2$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $a316eb803beb3ac2$export$6f292d4960313241 {
    constructor(executor){
        this._state = $a316eb803beb3ac2$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $a316eb803beb3ac2$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $a316eb803beb3ac2$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $a316eb803beb3ac2$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $a316eb803beb3ac2$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $a316eb803beb3ac2$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $a316eb803beb3ac2$var$STATE_PENDING) return;
            if ((0, $gWidS.isThenable)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($a316eb803beb3ac2$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($a316eb803beb3ac2$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}

});


parcelRegister("8lnYa", function(module, exports) {

$parcel$export(module.exports, "getFilenameToDebugIdMap", function () { return $6132e0b623739571$export$e069fee9c632ed00; });

var $bE8ha = parcelRequire("bE8ha");

var $gKrW9 = parcelRequire("gKrW9");
let $6132e0b623739571$var$parsedStackResults;
let $6132e0b623739571$var$lastSentryKeysCount;
let $6132e0b623739571$var$lastNativeKeysCount;
let $6132e0b623739571$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function $6132e0b623739571$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $gKrW9.GLOBAL_OBJ)._sentryDebugIds;
    const nativeDebugIdMap = (0, $gKrW9.GLOBAL_OBJ)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($6132e0b623739571$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $6132e0b623739571$var$lastSentryKeysCount && nativeDebugIdKeys.length === $6132e0b623739571$var$lastNativeKeysCount) return $6132e0b623739571$var$cachedFilenameDebugIds;
    $6132e0b623739571$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $6132e0b623739571$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    $6132e0b623739571$var$cachedFilenameDebugIds = {};
    if (!$6132e0b623739571$var$parsedStackResults) $6132e0b623739571$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $6132e0b623739571$var$parsedStackResults?.[key];
            if (result && $6132e0b623739571$var$cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                $6132e0b623739571$var$cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if ($6132e0b623739571$var$parsedStackResults) $6132e0b623739571$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $6132e0b623739571$var$cachedFilenameDebugIds && $6132e0b623739571$var$parsedStackResults) {
                        $6132e0b623739571$var$cachedFilenameDebugIds[filename] = debugId;
                        $6132e0b623739571$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $6132e0b623739571$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $6132e0b623739571$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $6132e0b623739571$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $bE8ha.normalizeStackTracePath)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: 'sourcemap',
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}

});

parcelRegister("7ZJbk", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $5d214709a04cfc33$export$43988bc651a80216; });
$parcel$export(module.exports, "getCombinedScopeData", function () { return $5d214709a04cfc33$export$cc422922fcbb91c6; });

var $2Pa11 = parcelRequire("2Pa11");

var $3KL2m = parcelRequire("3KL2m");

var $8IjjG = parcelRequire("8IjjG");

var $8C36L = parcelRequire("8C36L");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $5d214709a04cfc33$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $5d214709a04cfc33$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $5d214709a04cfc33$var$applySpanToEvent(event, span);
    $5d214709a04cfc33$var$applyFingerprintToEvent(event, fingerprint);
    $5d214709a04cfc33$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $5d214709a04cfc33$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $5d214709a04cfc33$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $5d214709a04cfc33$export$b1a120a2871faa46(data, 'extra', extra);
    $5d214709a04cfc33$export$b1a120a2871faa46(data, 'tags', tags);
    $5d214709a04cfc33$export$b1a120a2871faa46(data, 'attributes', attributes);
    $5d214709a04cfc33$export$b1a120a2871faa46(data, 'user', user);
    $5d214709a04cfc33$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $8IjjG.merge)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $5d214709a04cfc33$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $8IjjG.merge)(data[prop], mergeVal, 1);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $5d214709a04cfc33$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $2Pa11.getGlobalScope)().getScopeData();
    isolationScope && $5d214709a04cfc33$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $5d214709a04cfc33$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $5d214709a04cfc33$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $5d214709a04cfc33$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $5d214709a04cfc33$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $5d214709a04cfc33$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $8C36L.spanToTraceContext)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $3KL2m.getDynamicSamplingContextFromSpan)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $8C36L.getRootSpan)(span);
    const transactionName = (0, $8C36L.spanToJSON)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $5d214709a04cfc33$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}

});




parcelRegister("7BtPc", function(module, exports) {
/* global CONFIGURATION */ 
var $lHnfk = parcelRequire("lHnfk");
"use strict";
function $58931fb3937a3864$var$captureMessage(message, level) {
    if (![
        "feature",
        "staging",
        "production"
    ].includes(CONFIGURATION.hintEnv)) {
        if (level === "info") console.error(message);
        else if (level === "debug") console.log(message);
    }
    $lHnfk.captureMessage(message, level);
}
const $58931fb3937a3864$var$SentryPort = {
    add: function(app) {
        app.ports.captureErrorMessage.subscribe(function(message) {
            $58931fb3937a3864$var$captureMessage(message, "info");
        });
        app.ports.captureDebugMessage.subscribe(function(message) {
            $58931fb3937a3864$var$captureMessage(message, "debug");
        });
        app.ports.sentrySetContext.subscribe(function(context) {
            $lHnfk.setUser({
                id: context.user_id
            });
            $lHnfk.setContext("practice", {
                practice_id: context.practice_id
            });
        });
    },
    captureMessage: $58931fb3937a3864$var$captureMessage
};
module.exports = $58931fb3937a3864$var$SentryPort;

});

parcelRegister("2Cu2d", function(module, exports) {
/* global Frontegg, CONFIGURATION */ 
var $2Zr0e = parcelRequire("2Zr0e");

var $iewRq = parcelRequire("iewRq");

var $10uMS = parcelRequire("10uMS");

var $25aUb = parcelRequire("25aUb");

var $ejN0Z = parcelRequire("ejN0Z");

var $cQ6Rb = parcelRequire("cQ6Rb");
"use strict";
let $1e866da2b0f498da$var$loginUrl = CONFIGURATION.providerAuthUrl;
let $1e866da2b0f498da$var$fronteggApp;
let $1e866da2b0f498da$var$loginRequested = false;
let $1e866da2b0f498da$var$sessionCreated = false;
let $1e866da2b0f498da$var$appInstance = null;
if (CONFIGURATION.backupAuthEnabled) $1e866da2b0f498da$var$loginUrl = `${CONFIGURATION.redirectToUri}/login`;
(0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).useCookies();
const $1e866da2b0f498da$var$readToken = function() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).load() || null;
};
function $1e866da2b0f498da$var$initSessionSDK() {
    return new (0, $2Zr0e.default)({
        postLogoutRedirectURI: (0, (/*@__PURE__*/$parcel$interopDefault($cQ6Rb))).get("/login"),
        loginUrl: $1e866da2b0f498da$var$loginUrl,
        isDevelopment: CONFIGURATION.debugOrTest,
        logger: true,
        backupAuth: CONFIGURATION.backupAuthEnabled,
        apiUrl: `${CONFIGURATION.apiUrl}/api/`,
        onLogout: function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).remove();
            $1e866da2b0f498da$var$appInstance?.ports.onSessionLoggedOutPort?.send(null);
            (0, (/*@__PURE__*/$parcel$interopDefault($25aUb))).persistUrl();
        }
    });
}
const $1e866da2b0f498da$var$sessionSDK = $1e866da2b0f498da$var$initSessionSDK();
(0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).initialize($1e866da2b0f498da$var$sessionSDK.cookieManager);
const $1e866da2b0f498da$var$SessionPort = {
    read: $1e866da2b0f498da$var$readToken,
    add: function(app, clientId) {
        $1e866da2b0f498da$var$appInstance = app;
        $1e866da2b0f498da$var$fronteggApp = $1e866da2b0f498da$var$initFronteggApp(clientId, $1e866da2b0f498da$var$loginUrl);
        (0, (/*@__PURE__*/$parcel$interopDefault($iewRq))).forBrowserFreeze(()=>login({
                loginFrom: "browser freeze",
                redirect: true
            }));
        window.fronteggApp = $1e866da2b0f498da$var$fronteggApp;
        app.ports.sessionAuthorizePort.subscribe(function(options) {
            subscribeToAuth({
                redirect: options.redirect
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($10uMS))).log($1e866da2b0f498da$var$fronteggApp);
        });
        if (app.ports.sessionSwitchTenant) app.ports.sessionSwitchTenant.subscribe(function(organizationId) {
            if (CONFIGURATION.backupAuthEnabled) return;
            $1e866da2b0f498da$var$fronteggApp.ready(()=>{
                console.log("Switching tenant to", organizationId);
                $1e866da2b0f498da$var$fronteggApp.switchTenant({
                    tenantId: organizationId,
                    silentReload: true
                });
            });
        });
        if (app.ports.logoutPort) app.ports.logoutPort.subscribe(logout);
        if (app.ports.persistBackupAuthTokenPort) app.ports.persistBackupAuthTokenPort.subscribe(function(accessToken) {
            (0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).set(accessToken);
            dispatchSessionCreatedEvent(accessToken);
        });
        if (app.ports.refreshBackupAuthTokenPort) app.ports.refreshBackupAuthTokenPort.subscribe(function(accessToken) {
            (0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).set(accessToken);
            app.ports.onAccessTokenUpdatedPort.send(accessToken);
        });
        app.ports.sessionPersistRedirectPort.subscribe(function(url) {
            (0, (/*@__PURE__*/$parcel$interopDefault($25aUb))).persistUrl(url);
        });
        function subscribeToAuth({ redirect: redirect = true } = {}) {
            $1e866da2b0f498da$var$sessionSDK.run({
                app: $1e866da2b0f498da$var$fronteggApp,
                onExpirationWarning: function() {
                    app.ports.onLogoutWarningPort.send(null);
                },
                onUnAuthenticated: function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($25aUb))).persistUrl();
                    login({
                        loginFrom: "unauthenticated",
                        redirect: redirect
                    });
                },
                onAccessTokenChange: onAccessTokenChange
            });
        }
        function onAccessTokenChange(accessToken) {
            $1e866da2b0f498da$var$loginRequested = false;
            if (CONFIGURATION.backupAuthEnabled) return;
            const isNewToken = !$1e866da2b0f498da$var$readToken();
            (0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).set(accessToken);
            if (isNewToken || !$1e866da2b0f498da$var$sessionCreated) dispatchSessionCreatedEvent(accessToken);
            else app.ports.onAccessTokenUpdatedPort.send($1e866da2b0f498da$var$readToken());
        }
        function login({ loginFrom: loginFrom, redirect: redirect = true } = {}) {
            if ($1e866da2b0f498da$var$loginRequested || CONFIGURATION.backupAuthEnabled) return;
            if (!CONFIGURATION.skipSSOInit) $1e866da2b0f498da$var$fronteggApp.ready(()=>{
                if (!redirect) $1e866da2b0f498da$var$fronteggApp.loginWithRedirectV2({
                    shouldRedirectToLogin: false,
                    firstTime: false
                });
                else {
                    setTimeout(()=>{
                        $1e866da2b0f498da$var$loginRequested = false;
                    }, 5000);
                    console.log("Attempting to login from", loginFrom);
                    $1e866da2b0f498da$var$loginRequested = true;
                    const loginEmail = localStorage.getItem("login-email");
                    if (loginEmail) {
                        $1e866da2b0f498da$var$fronteggApp.loginWithRedirect({
                            login_hint: loginEmail
                        });
                        localStorage.removeItem("login-email");
                    } else $1e866da2b0f498da$var$fronteggApp.loginWithRedirect();
                }
            });
            else if ($1e866da2b0f498da$var$readToken()) app.ports.onAccessTokenUpdatedPort.send($1e866da2b0f498da$var$readToken());
        }
        function logout({ redirect: redirect = true } = {}) {
            if (redirect) $1e866da2b0f498da$var$sessionSDK.logout();
            else {
                let currentUrl = $1e866da2b0f498da$var$sessionSDK.postLogoutRedirectURI;
                $1e866da2b0f498da$var$sessionSDK.postLogoutRedirectURI = window.location.href.replace(window.location.origin, "");
                $1e866da2b0f498da$var$sessionSDK.logout();
                $1e866da2b0f498da$var$sessionSDK.postLogoutRedirectURI = currentUrl;
            }
        }
        function dispatchSessionCreatedEvent(accessToken) {
            const event = {
                detail: {
                    accessToken: accessToken,
                    redirectToURI: (0, (/*@__PURE__*/$parcel$interopDefault($25aUb))).retrieveUrl()
                }
            };
            app.ports.onAccessTokenCreatedPort.send({
                accessToken: event.detail.accessToken || $1e866da2b0f498da$var$readToken(),
                redirectToURI: event.detail.redirectToURI
            });
            $1e866da2b0f498da$var$sessionCreated = true;
            (0, (/*@__PURE__*/$parcel$interopDefault($25aUb))).resetUrl();
        }
    }
};
function $1e866da2b0f498da$var$initFronteggApp(clientId, authUrl) {
    return Frontegg.initialize({
        contextOptions: {
            baseUrl: authUrl,
            clientId: clientId,
            tenantResolver: ()=>{
                return {
                    tenant: $1e866da2b0f498da$var$readToken() ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($cQ6Rb))).setAndRetrieve()
                };
            }
        },
        customLoader: !!$1e866da2b0f498da$var$readToken(),
        authOptions: {
            keepSessionAlive: true
        },
        hostedLoginBox: true
    });
}
module.exports = $1e866da2b0f498da$var$SessionPort;

});
parcelRegister("2Zr0e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22d6397645334f2c$export$2e2bcd8739ae039; });

var $eTqIw = parcelRequire("eTqIw");
var $22d6397645334f2c$export$2e2bcd8739ae039 = (0, $eTqIw.default);

});
parcelRegister("eTqIw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad7aed351d24321e$export$2e2bcd8739ae039; });

var $eeI02 = parcelRequire("eeI02");

var $euYq5 = parcelRequire("euYq5");

var $6WyXY = parcelRequire("6WyXY");
class $ad7aed351d24321e$var$SessionManager {
    #defaultTimeout = 15;
    #warningMinsBeforeLogout = 2;
    constructor(options){
        this.postLogoutRedirectURI = options.postLogoutRedirectURI;
        this.onLogout = options.onLogout || function() {};
        this.onLogout = options.onLogout || function() {};
        this.logoutTimeout = null;
        this.logoutWarningTimeout = null;
        this.app = null;
        this.token = null;
        this.sessionTimeout = this.#defaultTimeout;
        this.domain = options.domain || this.resolveSharedDomain();
        this.cookieManager = new (0, $euYq5.CookieManager)({
            isDevelopment: options.isDevelopment,
            domain: this.domain
        });
        this.logger = options.logger || false;
        this.loginUrl = options.loginUrl;
        this.backupAuth = options.backupAuth || false;
        this.apiService = new (0, $eeI02.ApiService)(options.apiUrl);
    }
    run(options) {
        if (typeof options === "undefined") options = {};
        this.app = options.app;
        if (!this.app) {
            console.error("App not provided");
            return;
        }
        this.onAccessTokenChange = options.onAccessTokenChange || function() {};
        this.onExpirationWarning = options.onExpirationWarning || function() {};
        this.onRefreshExpiration = options.onRefreshExpiration || function() {};
        const onUnAuthenticated = options.onUnAuthenticated || function() {};
        const onAuthenticated = this.onAuthenticated.bind(this);
        const subscribeToAuth = (function() {
            const fronteggService = new (0, $6WyXY.FronteggService)({
                app: this.app
            });
            fronteggService.subscribeToAuth(onAuthenticated, onUnAuthenticated);
        }).bind(this);
        subscribeToAuth();
        if (this.backupAuth) this.setupSessionWatchers();
    }
    onAuthenticated(authData) {
        this.cookieManager.remove("session_logout");
        this.sharedTabsLogoutChecker();
        if (this.token != authData.user.accessToken) {
            this.token = authData.user.accessToken;
            if (this.logger) console.log("There is a new token");
            this.apiService.createSession(this.token, (response)=>{
                if (!response.ok) {
                    if (response.status === 401) this.logout();
                    else setTimeout(function() {
                        // retrying to create session
                        this.token = null;
                        this.onAuthenticated(authData);
                    }, 5000);
                } else this.onSessionCreated(response, this.token);
            });
            this.setSessionTimeout(this.app.store.getState().auth.tenantsState.activeTenant);
            this.checkForActiveSession();
        }
    }
    onSessionCreated(response) {
        this.onAccessTokenChange(this.token);
        if (response.status !== 201) // session already exists, so we need to check if it's expired
        this.checkSessionExpired();
    }
    setupSessionWatchers() {
        // we will check on session expiration if the user had activity and warn it 2mins before
        this.scheduleLogout(this.expiresIn());
        this.scheduleLogoutWarning(this.warnExpirationIn());
        this.updateExpiresAt();
    }
    logout() {
        this.onLogout();
        this.apiService.deleteSession(this.token);
        this.token = null;
        this.cookieManager.store("session_logout", true);
        this.cookieManager.remove("session_expires_at");
        let url;
        if (this.backupAuth) url = new URL(this.loginUrl);
        else url = (0, $6WyXY.FronteggService).buildLogoutUrl(this.loginUrl, this.postLogoutRedirectURI);
        window.location.href = url.toString();
    }
    scheduleLogout(expiresInSeconds) {
        clearTimeout(this.logoutTimeout);
        let checkSessionExpired = this.checkSessionExpired.bind(this);
        this.logoutTimeout = setTimeout(function() {
            checkSessionExpired();
        }, expiresInSeconds * 1000);
    }
    checkForActiveSession() {
        let active = this.setupSessionWatchers;
        const refreshFrequency = 60000;
        document.addEventListener("mousemove", this.throttle(active.bind(this), refreshFrequency));
    }
    scheduleLogoutWarning(expiresInSeconds) {
        clearTimeout(this.logoutWarningTimeout);
        let cookieManager = this.cookieManager;
        let onExpirationWarning = this.onExpirationWarning;
        let warningMinsBeforeLogout = this.#warningMinsBeforeLogout;
        this.logoutWarningTimeout = setTimeout(function() {
            const expiresAt = cookieManager.retrieve("session_expires_at");
            if (expiresAt && new Date(Date.parse(expiresAt) - 60000 * warningMinsBeforeLogout) < new Date()) onExpirationWarning();
        }, expiresInSeconds * 1000);
    }
    calculateExpiresAt(sessionTimeout) {
        return new Date(new Date().getTime() + sessionTimeout * 60000);
    }
    setSessionTimeout(organization) {
        try {
            const originalTimeout = this.sessionTimeout;
            if (!organization) {
                if (this.logger) console.error("Could not find organization");
                return;
            }
            this.sessionTimeout = JSON.parse(organization.metadata).sessionTimeoutInMinutes;
            if (this.sessionTimeout !== originalTimeout) {
                this.updateExpiresAt();
                if (this.logger) console.log("Session timeout is", this.sessionTimeout);
            }
        } catch (e) {
            if (this.logger) console.error("Could not set session timeout ", e);
        }
    }
    checkSessionExpired() {
        const expiresAt = this.cookieManager.retrieve("session_expires_at");
        if (expiresAt && new Date(Date.parse(expiresAt)) < new Date()) {
            if (this.logger) console.log("Session expired, logging out");
            this.logout();
        }
    }
    throttle(func, timeFrame) {
        var lastTime = 0;
        return function() {
            var now = Date.now();
            if (now - lastTime >= timeFrame) {
                func();
                lastTime = now;
            }
        };
    }
    expiresIn() {
        return this.sessionTimeout * 60;
    }
    warnExpirationIn() {
        return (this.sessionTimeout - this.#warningMinsBeforeLogout) * 60;
    }
    updateExpiresAt() {
        this.cookieManager.store("session_expires_at", this.calculateExpiresAt(this.sessionTimeout));
        this.onRefreshExpiration();
    }
    resolveSharedDomain() {
        const url = window.location.hostname;
        const rootDomainRegex = /(\.[^.]+){2,}$/;
        return url.match(rootDomainRegex) ? url.match(rootDomainRegex)[0] : url; // should output ".yourdomain.com"
    }
    sharedTabsLogoutChecker() {
        setInterval(()=>{
            if (this.token && this.cookieManager.retrieve("session_logout")) {
                if (this.logger) console.log("Another app logged out");
                this.logout();
            }
        }, 5000);
    }
}
var $ad7aed351d24321e$export$2e2bcd8739ae039 = $ad7aed351d24321e$var$SessionManager;

});
parcelRegister("eeI02", function(module, exports) {

$parcel$export(module.exports, "ApiService", function () { return $a5d480e4b252faf5$export$ae14c375fc93363; });
class $a5d480e4b252faf5$export$ae14c375fc93363 {
    constructor(url){
        this.url = url;
    }
    async deleteSession(token) {
        this.sessionRequest(token, ()=>{}, "DELETE");
    }
    async createSession(token, callback) {
        this.sessionRequest(token, callback, "POST");
    }
    async sessionRequest(token, callback, method) {
        const authorizationHeader = `Bearer ${token}`;
        const url = `${this.url}session`;
        try {
            const response = await fetch(url, {
                method: method,
                headers: {
                    Authorization: authorizationHeader
                }
            });
            if (!response.ok) {
                callback(response);
                throw new Error(`Response status: ${response.status}`);
            }
            callback(response);
        } catch (error) {
            console.error(error.message);
        }
    }
}

});

parcelRegister("euYq5", function(module, exports) {

$parcel$export(module.exports, "CookieManager", function () { return $a8e2bc1cf04d451e$export$c0f66b9778462a6f; });

var $aCZl5 = parcelRequire("aCZl5");
class $a8e2bc1cf04d451e$export$c0f66b9778462a6f {
    constructor(options){
        const isDevelopment = options.isDevelopment || false;
        const isSafari = window.safari !== undefined;
        const appPrefix = 'hint.';
        const daysToExpire = 1;
        this.customPolicy = {
            domain: options.domain,
            expires: daysToExpire
        };
        if (isDevelopment) this.customPolicy = Object.assign(this.customPolicy, {
            sameSite: 'none',
            secure: true
        });
        if (isSafari && isDevelopment) delete this.customPolicy['secure'];
        this.prefix = appPrefix + options.domain.replace(new RegExp("^\\."), "").replace('.com', '') + '.';
    }
    store(key, value) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aCZl5))).set(this.prefix + key, value, this.customPolicy);
    }
    retrieve(key) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aCZl5))).get(this.prefix + key);
    }
    remove(key) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($aCZl5))).remove(this.prefix + key, this.customPolicy);
    }
}

});

parcelRegister("6WyXY", function(module, exports) {

$parcel$export(module.exports, "FronteggService", function () { return $50e3487055c29c1d$export$5c36251d80a9d084; });
class $50e3487055c29c1d$export$5c36251d80a9d084 {
    constructor(options){
        this.app = options.app;
    }
    subscribeToAuth(onAuthenticated, onUnAuthenticated) {
        this.app.ready(()=>{
            this.app.store.subscribe(()=>{
                const state = this.app.store.getState();
                if (!state.auth.isLoading) {
                    if (!state.auth.isAuthenticated) onUnAuthenticated();
                    else onAuthenticated(state.auth);
                }
            });
        });
    }
    static buildLogoutUrl(loginUrl, postLogoutRedirectURI) {
        // this.app.logout(); // TODO: bug in Frontegg that doesn't allow to use it in Firefox, so instead we should use the next
        let url = new URL(`${loginUrl}/oauth/logout`);
        let options = {
            post_logout_redirect_uri: `${window.location.origin}${postLogoutRedirectURI}`
        };
        url.search = new URLSearchParams(options);
        return url;
    }
}

});



parcelRegister("iewRq", function(module, exports) {

var $ejN0Z = parcelRequire("ejN0Z");
"use strict";
function $d4630639c1e3b52a$var$throttle(func, timeFrame) {
    var lastTime = 0;
    return function() {
        var now = Date.now();
        if (now - lastTime >= timeFrame) {
            func();
            lastTime = now;
        }
    };
}
module.exports = {
    forBrowserFreeze: function(loginCallback) {
        document.addEventListener("mousemove", $d4630639c1e3b52a$var$throttle(function() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).load() && (0, (/*@__PURE__*/$parcel$interopDefault($ejN0Z))).isExpired()) {
                console.log("The session is expired, refreshing manually");
                loginCallback("session expired");
            }
        }, 2000));
    }
};

});
parcelRegister("ejN0Z", function(module, exports) {

var $lSbpN = parcelRequire("lSbpN");

var $bruGF = parcelRequire("bruGF");
"use strict";
let $a6c8dc66f8b03b7c$var$clockOffsetMs = 0;
let $a6c8dc66f8b03b7c$var$token = null;
let $a6c8dc66f8b03b7c$var$useCookies = true;
const $a6c8dc66f8b03b7c$var$MAX_COOKIE_SIZE = 4000;
module.exports = {
    initialize: function(cookieManager) {
        (0, (/*@__PURE__*/$parcel$interopDefault($bruGF))).initialize(cookieManager);
    },
    set: function(value) {
        $a6c8dc66f8b03b7c$var$clockOffsetMs = (0, $lSbpN.jwtDecode)(value).iat * 1000 - Date.now();
        if ($a6c8dc66f8b03b7c$var$useCookies) try {
            (0, (/*@__PURE__*/$parcel$interopDefault($bruGF))).set(value);
            // Verify cookie was actually stored by reading it back
            const storedValue = (0, (/*@__PURE__*/$parcel$interopDefault($bruGF))).load();
            if (storedValue !== value) throw new Error("Cookie storage verification failed");
        } catch (error) {
            const isCookieTooLarge = value.length > $a6c8dc66f8b03b7c$var$MAX_COOKIE_SIZE;
            if (!isCookieTooLarge) console.error("Failed to store token in cookie, falling back to in-memory storage:", error.message);
            $a6c8dc66f8b03b7c$var$useCookies = false;
            $a6c8dc66f8b03b7c$var$token = value;
        }
        else $a6c8dc66f8b03b7c$var$token = value;
    },
    load: function() {
        if ($a6c8dc66f8b03b7c$var$useCookies) return (0, (/*@__PURE__*/$parcel$interopDefault($bruGF))).load();
        return $a6c8dc66f8b03b7c$var$token;
    },
    remove: function() {
        // for existing cookies or when cookies are enabled, remove them
        if ($a6c8dc66f8b03b7c$var$useCookies || (0, (/*@__PURE__*/$parcel$interopDefault($bruGF))).load()) (0, (/*@__PURE__*/$parcel$interopDefault($bruGF))).remove();
        else $a6c8dc66f8b03b7c$var$token = null;
    },
    isExpired: function() {
        let currentToken = $a6c8dc66f8b03b7c$var$useCookies ? (0, (/*@__PURE__*/$parcel$interopDefault($bruGF))).load() : $a6c8dc66f8b03b7c$var$token;
        if (!currentToken || typeof currentToken !== "string") return true;
        let decoded = (0, $lSbpN.jwtDecode)(currentToken);
        const refreshInAdvanceMs = 5000;
        if (Date.now() + $a6c8dc66f8b03b7c$var$clockOffsetMs + refreshInAdvanceMs >= decoded.exp * 1000) return true;
        return false;
    },
    useCookies: function() {
        $a6c8dc66f8b03b7c$var$useCookies = true;
    }
};

});
parcelRegister("lSbpN", function(module, exports) {

$parcel$export(module.exports, "jwtDecode", function () { return $fec77ee6d8b57856$export$fa1e2fb699b7861e; });
class $fec77ee6d8b57856$export$b9721ef022f71a68 extends Error {
}
$fec77ee6d8b57856$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
function $fec77ee6d8b57856$var$b64DecodeUnicode(str) {
    return decodeURIComponent(atob(str).replace(/(.)/g, (m, p)=>{
        let code = p.charCodeAt(0).toString(16).toUpperCase();
        if (code.length < 2) code = "0" + code;
        return "%" + code;
    }));
}
function $fec77ee6d8b57856$var$base64UrlDecode(str) {
    let output = str.replace(/-/g, "+").replace(/_/g, "/");
    switch(output.length % 4){
        case 0:
            break;
        case 2:
            output += "==";
            break;
        case 3:
            output += "=";
            break;
        default:
            throw new Error("base64 string is not of the correct length");
    }
    try {
        return $fec77ee6d8b57856$var$b64DecodeUnicode(output);
    } catch (err) {
        return atob(output);
    }
}
function $fec77ee6d8b57856$export$fa1e2fb699b7861e(token, options) {
    if (typeof token !== "string") throw new $fec77ee6d8b57856$export$b9721ef022f71a68("Invalid token specified: must be a string");
    options || (options = {});
    const pos = options.header === true ? 0 : 1;
    const part = token.split(".")[pos];
    if (typeof part !== "string") throw new $fec77ee6d8b57856$export$b9721ef022f71a68(`Invalid token specified: missing part #${pos + 1}`);
    let decoded;
    try {
        decoded = $fec77ee6d8b57856$var$base64UrlDecode(part);
    } catch (e) {
        throw new $fec77ee6d8b57856$export$b9721ef022f71a68(`Invalid token specified: invalid base64 for part #${pos + 1} (${e.message})`);
    }
    try {
        return JSON.parse(decoded);
    } catch (e) {
        throw new $fec77ee6d8b57856$export$b9721ef022f71a68(`Invalid token specified: invalid json for part #${pos + 1} (${e.message})`);
    }
}

});

parcelRegister("bruGF", function(module, exports) {
/* global Cookies */ "use strict";
const $854a052e7c045fd9$var$keyName = "session-token.provider";
const $854a052e7c045fd9$var$oldKeyName = "hint.session-token.provider";
let $854a052e7c045fd9$var$cookieManager = null;
module.exports = {
    initialize: function(cm) {
        $854a052e7c045fd9$var$cookieManager = cm;
    },
    set: function(value) {
        // Clean up old cookie name without prefix (migration)
        Cookies.remove($854a052e7c045fd9$var$oldKeyName);
        Cookies.remove($854a052e7c045fd9$var$oldKeyName, {
            domain: $854a052e7c045fd9$var$cookieManager.customPolicy.domain
        });
        return $854a052e7c045fd9$var$cookieManager.store($854a052e7c045fd9$var$keyName, value);
    },
    load: function() {
        // Try new prefixed name first, fall back to old name for migration
        return $854a052e7c045fd9$var$cookieManager.retrieve($854a052e7c045fd9$var$keyName) || Cookies.get($854a052e7c045fd9$var$oldKeyName);
    },
    remove: function() {
        // Remove both old and new cookie names
        Cookies.remove($854a052e7c045fd9$var$oldKeyName);
        Cookies.remove($854a052e7c045fd9$var$oldKeyName, {
            domain: $854a052e7c045fd9$var$cookieManager.customPolicy.domain
        });
        return $854a052e7c045fd9$var$cookieManager.remove($854a052e7c045fd9$var$keyName);
    }
};

});



parcelRegister("10uMS", function(module, exports) {

var $2ktsf = parcelRequire("2ktsf");
"use strict";
module.exports = {
    log: function(fronteggApp) {
        // if the user enters to an already used callback, frontegg fails
        var _error = console.error;
        console.error = function() {
            if (typeof arguments[0] === "string" && arguments[0].includes("exchangeOAuthTokens")) setTimeout(()=>{
                if (!fronteggApp.store.getState().auth.isAuthenticated) (0, $2ktsf.FullStory)("trackEvent", {
                    name: "Failed to login"
                });
            }, 5000);
            return _error.apply(console, arguments);
        };
    }
};

});
parcelRegister("2ktsf", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $1b244c1fd5700652$export$2cd8252107eb640b; });
$parcel$export(module.exports, "FullStory", function () { return $1b244c1fd5700652$export$d55ddad8cc9093bd; });

var $3UjwO = parcelRequire("3UjwO");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $1b244c1fd5700652$var$__assign = function() {
    $1b244c1fd5700652$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1b244c1fd5700652$var$__assign.apply(this, arguments);
};
var $1b244c1fd5700652$var$getFullStory = function() {
    if (window._fs_namespace) return window[window._fs_namespace];
    return undefined;
};
var $1b244c1fd5700652$var$ensureSnippetLoaded = function() {
    var fs = $1b244c1fd5700652$var$getFullStory();
    if (!fs) throw Error('FullStory is not loaded, please ensure the init function is invoked before calling FullStory API functions');
    return fs;
};
var $1b244c1fd5700652$var$_init = function(inputOptions, readyCallback) {
    // Make a copy so we can modify `options` if desired.
    var options = $1b244c1fd5700652$var$__assign({}, inputOptions);
    if ($1b244c1fd5700652$var$getFullStory()) {
        console.warn('The FullStory snippet has already been defined elsewhere (likely in the <head> element)');
        return;
    }
    // see README for details on the recordCrossDomainIFrames option
    if (options.recordCrossDomainIFrames) window._fs_run_in_iframe = true;
    if (options.appHost) window._fs_app_host = options.appHost;
    if (options.assetMapId) window._fs_asset_map_id = options.assetMapId;
    if (options.startCaptureManually) window._fs_capture_on_startup = false;
    // record the contents of this iFrame when embedded in a parent site
    if (options.recordOnlyThisIFrame) window._fs_is_outer_script = true;
    // Set cookie domain if it was specified.
    if (options.cookieDomain) window._fs_cookie_domain = options.cookieDomain;
    if (options.debug === true) {
        if (!options.script) options.script = 'edge.fullstory.com/s/fs-debug.js';
        else console.warn('Ignoring `debug = true` because `script` is set');
    }
    (0, $3UjwO.initFS)(options);
    var fs = $1b244c1fd5700652$var$getFullStory();
    if (!fs) {
        console.warn('Failed to initialize FS snippet');
        return;
    }
    if (options.sessionUid) fs('init', {
        env: {
            sessionUid: options.sessionUid
        }
    });
    if (readyCallback) fs('observe', {
        type: 'start',
        callback: readyCallback
    });
    if (options.devMode === true) {
        var message = 'FullStory was initialized in devMode and will stop recording';
        fs('trackEvent', {
            name: 'FullStory Dev Mode',
            properties: {
                message: message
            }
        });
        fs('shutdown');
        window._fs_dev_mode = true;
        console.warn(message);
    }
};
var $1b244c1fd5700652$var$initOnce = function(message) {
    return function(inputOptions, readyCallback) {
        if (window._fs_initialized) {
            if (message) console.warn(message);
            return;
        }
        $1b244c1fd5700652$var$_init(inputOptions, readyCallback);
        window._fs_initialized = true;
    };
};
var $1b244c1fd5700652$export$2cd8252107eb640b = $1b244c1fd5700652$var$initOnce('FullStory init has already been called once, additional invocations are ignored');
// normalize undefined into boolean
var $1b244c1fd5700652$export$3f95c6f800b78024 = function() {
    return !!window._fs_initialized;
};
var $1b244c1fd5700652$var$hasFullStoryWithFunction = function() {
    var testNames = [];
    for(var _i = 0; _i < arguments.length; _i++)testNames[_i] = arguments[_i];
    var fs = $1b244c1fd5700652$var$ensureSnippetLoaded();
    return testNames.every(function(current) {
        return fs[current];
    });
};
var $1b244c1fd5700652$var$guard = function(name) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(name, " method not executed");
            console.warn(message);
            return message;
        }
        var fs = $1b244c1fd5700652$var$getFullStory();
        if ($1b244c1fd5700652$var$hasFullStoryWithFunction(name) && fs) return fs[name].apply(fs, args);
        console.warn("FS.".concat(name, " not ready"));
        return null;
    };
};
var $1b244c1fd5700652$var$buildFullStoryShim = function() {
    var FS = function(operation, options, source) {
        var fs = $1b244c1fd5700652$var$ensureSnippetLoaded();
        if (window._fs_dev_mode) {
            var message = "FullStory is in dev mode and is not capturing: ".concat(operation, " not executed");
            console.warn(message);
            return undefined;
        }
        return fs(operation, options, source);
    };
    FS.anonymize = $1b244c1fd5700652$var$guard('anonymize');
    FS.consent = $1b244c1fd5700652$var$guard('consent');
    FS.disableConsole = $1b244c1fd5700652$var$guard('disableConsole');
    FS.enableConsole = $1b244c1fd5700652$var$guard('enableConsole');
    FS.event = $1b244c1fd5700652$var$guard('event');
    FS.getCurrentSessionURL = $1b244c1fd5700652$var$guard('getCurrentSessionURL');
    FS.identify = $1b244c1fd5700652$var$guard('identify');
    FS.log = $1b244c1fd5700652$var$guard('log');
    FS.restart = $1b244c1fd5700652$var$guard('restart');
    FS.setUserVars = $1b244c1fd5700652$var$guard('setUserVars');
    FS.setVars = $1b244c1fd5700652$var$guard('setVars');
    FS.shutdown = $1b244c1fd5700652$var$guard('shutdown');
    return FS;
};
var $1b244c1fd5700652$export$d55ddad8cc9093bd = $1b244c1fd5700652$var$buildFullStoryShim();

});
parcelRegister("3UjwO", function(module, exports) {

$parcel$export(module.exports, "initFS", function () { return $2d85bff27cebf729$export$52a15e44b483bf1c; });
// @ts-nocheck
var $2d85bff27cebf729$var$SnippetSrcV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var h,d=[];function j(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function r(b){return function(d){h||(h=[b,d],j())}}return b(r(0),r(1)),{\nthen:function(b,h){return p((function(r,i){d.push([b,h,r,i]),j()}))}}}a&&(g=m[e]=function(){var b=function(b,d,j,r){function i(i,c){\nh(b,d,j,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):h(b,d,j,c,c,r)}\n;function h(h,d,j,r,i,c){return b._api?b._api(h,d,j,r,i,c):(b.q&&b.q.push([h,d,j,r,i,c]),null)}return b.q=[],b}(),y=function(b){function h(h){\n\"function\"==typeof h[4]&&h[4](new Error(b))}var d=g.q;if(d){for(var j=0;j<d.length;j++)h(d[j]);d.length=0,d.push=h}},function(){\n(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",o.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)}\n;var b=n.getElementsByTagName(t)[0];b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,j){h(\"setProperties\",{type:b,properties:d},j)}function j(b,h){d(\"user\",b,h)}function r(b,h,d){j({\nuid:b},d),h&&j(h,d)}g.identify=r,g.setUserVars=j,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,j){h(\"trackEvent\",{\nname:b,properties:d},j)},g.anonymize=function(){r(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var $2d85bff27cebf729$var$SnippetSrcV2Delayed = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(d){\nreturn!(d in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function p(b){var d,h=[];function k(){d&&(h.forEach((function(b){var h;try{h=b[d[0]]&&b[d[0]](d[1])}catch(d){return void(b[3]&&b[3](d))}\nh&&h.then?h.then(b[2],b[3]):b[2]&&b[2](h)})),h.length=0)}function r(b){return function(h){d||(d=[b,h],k())}}return b(r(0),r(1)),{\nthen:function(b,d){return p((function(r,i){h.push([b,d,r,i]),k()}))}}}function j(){(o=n.createElement(t)).async=!0,o.crossOrigin=\"anonymous\",\no.src=\"https://\"+l,o.onerror=function(){y(\"Error loading \"+l)};var b=n.getElementsByTagName(t)[0]\n;b&&b.parentNode?b.parentNode.insertBefore(o,b):n.head.appendChild(o)}a&&(g=m[e]=function(){var b=function(b,h,k,r){function i(i,c){\nd(b,h,k,i,c,r)}r=r||2;var c,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(i):p(i)):d(b,h,k,c,c,r)}\n;function d(d,h,k,r,i,c){return b._api?b._api(d,h,k,r,i,c):(b.q&&b.q.push([d,h,k,r,i,c]),null)}return b.q=[],b}(),y=function(b){function d(d){\n\"function\"==typeof d[4]&&d[4](new Error(b))}var h=g.q;if(h){for(var k=0;k<h.length;k++)d(h[k]);h.length=0,h.push=d}},function(){try{\nvar b=!1,d=\"paint\";if(void 0!==window.PerformanceObserver&&PerformanceObserver.supportedEntryTypes.indexOf(d)>-1){\nvar h=new PerformanceObserver((function(d){for(var k=d.getEntriesByName(\"first-contentful-paint\"),r=0;r<k.length;r++)k[r]&&(h.disconnect(),\nb||(b=!0,j()))}));h.observe({buffered:!0,type:d}),setTimeout((function(){b||(b=!0,j())}),1e3)}else j()}catch(b){}}(),function(){function b(){}\nfunction d(b,d,h){g(b,d,h,1)}function h(b,h,k){d(\"setProperties\",{type:b,properties:h},k)}function k(b,d){h(\"user\",b,d)}function r(b,d,h){k({\nuid:b},h),d&&k(d,h)}g.identify=r,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=h,g.event=function(b,h,k){d(\"trackEvent\",{\nname:b,properties:h},k)},g.anonymize=function(){r(!1)},g.shutdown=function(){d(\"shutdown\")},g.restart=function(){d(\"restart\")},\ng.log=function(b,h){d(\"log\",{level:b,msg:h})},g.consent=function(b){d(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0.delayed\")\n}(window,document,window._fs_namespace,\"script\",window._fs_script);";
var $2d85bff27cebf729$var$mockSnippetV1 = "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"1.3.0\";\n})(window,document,window['_fs_namespace'],'script','user');";
var $2d85bff27cebf729$var$mockSnippetV2 = "!function(m,n,e,t,l,o,g,y){var s,f,a=function(h){\nreturn!(h in m)||(m.console&&m.console.log&&m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].'),!1)}(e)\n;function j(b){var h,d=[];function k(){h&&(d.forEach((function(b){var d;try{d=b[h[0]]&&b[h[0]](h[1])}catch(h){return void(b[3]&&b[3](h))}\nd&&d.then?d.then(b[2],b[3]):b[2]&&b[2](d)})),d.length=0)}function i(b){return function(d){h||(h=[b,d],k())}}return b(i(0),i(1)),{\nthen:function(b,h){return j((function(i,c){d.push([b,h,i,c]),k()}))}}}a&&(g=m[e]=function(){var b=function(b,d,k,i){function c(c,r){\nh(b,d,k,c,r,i)}i=i||2;var r,u=/Async$/;return u.test(b)?(b=b.replace(u,\"\"),\"function\"==typeof Promise?new Promise(c):j(c)):h(b,d,k,r,r,i)}\n;function h(h,d,k,i,c,r){return b._api?b._api(h,d,k,i,c,r):(b.q&&b.q.push([h,d,k,i,c,r]),null)}return b.q=[],b}(),function(){function b(){}\nfunction h(b,h,d){g(b,h,d,1)}function d(b,d,k){h(\"setProperties\",{type:b,properties:d},k)}function k(b,h){d(\"user\",b,h)}function i(b,h,d){k({\nuid:b},d),h&&k(h,d)}g.identify=i,g.setUserVars=k,g.identifyAccount=b,g.clearUserCookie=b,g.setVars=d,g.event=function(b,d,k){h(\"trackEvent\",{\nname:b,properties:d},k)},g.anonymize=function(){i(!1)},g.shutdown=function(){h(\"shutdown\")},g.restart=function(){h(\"restart\")},\ng.log=function(b,d){h(\"log\",{level:b,msg:d})},g.consent=function(b){h(\"setIdentity\",{consent:!arguments.length||b})}}(),s=\"fetch\",\nf=\"XMLHttpRequest\",g._w={},g._w[f]=m[f],g._w[s]=m[s],m[s]&&(m[s]=function(){return g._w[s].apply(this,arguments)}),g._v=\"2.0.0\")\n}(window,document,window._fs_namespace,0,window._fs_script);";
var $2d85bff27cebf729$var$executeSnippet = function executeSnippet() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$wnd = _ref.wnd, wnd = _ref$wnd === void 0 ? window : _ref$wnd, _ref$injectedNamespac = _ref.injectedNamespace, injectedNamespace = _ref$injectedNamespac === void 0 ? wnd['_fs_namespace'] : _ref$injectedNamespac, _ref$injectedScript = _ref.injectedScript, injectedScript = _ref$injectedScript === void 0 ? wnd['_fs_script'] : _ref$injectedScript;
    (function(win, doc, fsNamespace, tagName, fsScript, script, api, rejector) {
        var valid = function checkNamespace(fsNamespace) {
            if (!(fsNamespace in win)) return true;
            if (win.console && win.console.log) win.console.log("FullStory namespace conflict. Please set window[\"_fs_namespace\"].");
            return false;
        }(fsNamespace);
        if (!valid) return;
        function makeThenable(callback) {
            var waiters = [];
            var resolution;
            function flush() {
                if (!resolution) return;
                waiters.forEach(function(waiter) {
                    var result;
                    try {
                        result = waiter[resolution[0]] && waiter[resolution[0]](resolution[1]);
                    } catch (error) {
                        waiter[3] && waiter[3](error);
                        return;
                    }
                    if (result && result.then) result.then(waiter[2], waiter[3]);
                    else waiter[2] && waiter[2](result);
                });
                waiters.length = 0;
            }
            function makeHandler(which) {
                return function(value) {
                    if (resolution) return;
                    resolution = [
                        which,
                        value
                    ];
                    flush();
                };
            }
            callback(makeHandler(0), makeHandler(1));
            function _then(onFulfilled, onRejected) {
                return makeThenable(function(nextResolve, nextReject) {
                    waiters.push([
                        onFulfilled,
                        onRejected,
                        nextResolve,
                        nextReject
                    ]);
                    flush();
                });
            }
            return {
                then: _then
            };
        }
        api = win[fsNamespace] = function createV2API() {
            var FS = function FS(action, options, source, apiVersion) {
                apiVersion = apiVersion || 2;
                function setResolve(resolve, reject) {
                    api(action, options, source, resolve, reject, apiVersion);
                }
                var re = /Async$/;
                if (re.test(action)) {
                    action = action.replace(re, '');
                    // @ts-ignore
                    if (typeof Promise === 'function') // @ts-ignore
                    return new Promise(setResolve);
                    return makeThenable(setResolve);
                }
                var _undefined;
                return api(action, options, source, _undefined, _undefined, apiVersion);
            };
            function api(op, args, source, resolve, reject, apiVersion) {
                // Once fs.js is bootstrapped, we have access to ._api which
                //   handles pushing deferred methods into the queue internally.
                if (FS._api) return FS._api(op, args, source, resolve, reject, apiVersion);
                if (FS.q) FS.q.push([
                    op,
                    args,
                    source,
                    resolve,
                    reject,
                    apiVersion
                ]);
                return null;
            }
            FS.q = [];
            return FS;
        }();
        rejector = function createRejector() {
            // Returns a function called on the error handler of the fs.js script tag.
            // Its purpose is to reject all pending and future asynchronous api calls.
            // The 4th argument to any api operation is always the reject function if it
            // has been called with the "Async" modifier.
            return function(reason) {
                function doReject(operation) {
                    if (typeof operation[4] === 'function') operation[4](new Error(reason));
                }
                var q = api.q;
                if (q) {
                    for(var i = 0; i < q.length; i++)doReject(q[i]);
                    q.length = 0;
                    q.push = doReject;
                }
            };
        }();
        (function insertScript() {
            script = doc.createElement(tagName);
            script.async = true;
            script.crossOrigin = 'anonymous';
            script.src = 'https://' + fsScript;
            script.onerror = function() {
                rejector('Error loading ' + fsScript);
            };
            var firstScript = doc.getElementsByTagName(tagName)[0];
            if (firstScript && firstScript.parentNode) firstScript.parentNode.insertBefore(script, firstScript);
            else doc.head.appendChild(script);
        })();
        (function translateV1API() {
            function noop() {}
            function callAPI(action, option, source) {
                api(action, option, source, 1);
            }
            function setProperties(scope, props, source) {
                callAPI('setProperties', {
                    type: scope,
                    properties: props
                }, source);
            }
            function setUserProperties(props, source) {
                setProperties('user', props, source);
            }
            function identify(uid, customVars, source) {
                setUserProperties({
                    uid: uid
                }, source);
                if (customVars) setUserProperties(customVars, source);
            }
            api.identify = identify;
            api.setUserVars = setUserProperties;
            api.identifyAccount = noop;
            api.clearUserCookie = noop;
            api.setVars = setProperties;
            api.event = function(eventName, eventProps, source) {
                callAPI('trackEvent', {
                    name: eventName,
                    properties: eventProps
                }, source);
            };
            api.anonymize = function() {
                identify(false);
            };
            api.shutdown = function() {
                callAPI('shutdown');
            };
            api.restart = function() {
                callAPI('restart');
            };
            api.log = function(level, msg) {
                callAPI('log', {
                    level: level,
                    msg: msg
                });
            };
            api.consent = function(userConsents) {
                callAPI('setIdentity', {
                    consent: !arguments.length || userConsents
                });
            };
        })();
        (function snapshotGlobals() {
            var f = 'fetch';
            var xhr = 'XMLHttpRequest';
            api._w = {};
            api._w[xhr] = win[xhr];
            api._w[f] = win[f];
            if (win[f]) win[f] = function() {
                return api._w[f].apply(this, arguments);
            };
        })();
        api._v = "2.0.0";
    })(wnd, wnd.document, injectedNamespace, 'script', injectedScript);
};
var $2d85bff27cebf729$var$executeSnippetV1 = function executeSnippetV1() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$wnd = _ref2.wnd, wnd = _ref2$wnd === void 0 ? window : _ref2$wnd, _ref2$injectedNamespa = _ref2.injectedNamespace, injectedNamespace = _ref2$injectedNamespa === void 0 ? wnd['_fs_namespace'] : _ref2$injectedNamespa;
    (function(m, n, e, t, l, o, g, y) {
        if (e in m) {
            if (m.console && m.console.log) m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
            return;
        }
        g = m[e] = function(a, b, s) {
            g.q ? g.q.push([
                a,
                b,
                s
            ]) : g._api(a, b, s);
        };
        g.q = [];
        o = n.createElement(t);
        o.async = 1;
        o.crossOrigin = 'anonymous';
        o.src = 'https://' + _fs_script;
        y = n.getElementsByTagName(t)[0];
        y.parentNode.insertBefore(o, y);
        g.identify = function(i, v, s) {
            g(l, {
                uid: i
            }, s);
            if (v) g(l, v, s);
        };
        g.setUserVars = function(v, s) {
            g(l, v, s);
        };
        g.event = function(i, v, s) {
            g('event', {
                n: i,
                p: v
            }, s);
        };
        g.anonymize = function() {
            g.identify(false);
        };
        g.shutdown = function() {
            g("rec", !1);
        };
        g.restart = function() {
            g("rec", !0);
        };
        g.log = function(a, b) {
            g("log", [
                a,
                b
            ]);
        };
        g.consent = function(a) {
            g("consent", !arguments.length || a);
        };
        g.identifyAccount = function(i, v) {
            o = 'account';
            v = v || {};
            v.acctId = i;
            g(o, v);
        };
        g.clearUserCookie = function() {};
        g.setVars = function(n, p) {
            g('setVars', [
                n,
                p
            ]);
        };
        g._w = {};
        y = 'XMLHttpRequest';
        g._w[y] = m[y];
        y = 'fetch';
        g._w[y] = m[y];
        if (m[y]) m[y] = function() {
            return g._w[y].apply(this, arguments);
        };
        g._v = "1.3.0";
    })(wnd, wnd.document, injectedNamespace, 'script', 'user');
};
var $2d85bff27cebf729$var$getDocumentVar = function getDocumentVar(globalVar) {
    return globalVar === 'window' ? 'document' : "".concat(globalVar, ".document");
};
var $2d85bff27cebf729$var$toV1String = function toV1String() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$shouldInsertScr = _ref3.shouldInsertScript, shouldInsertScript = _ref3$shouldInsertScr === void 0 ? true : _ref3$shouldInsertScr, _ref3$globalVar = _ref3.globalVar, globalVar = _ref3$globalVar === void 0 ? 'window' : _ref3$globalVar, _ref3$globalNamespace = _ref3.globalNamespace, globalNamespace = _ref3$globalNamespace === void 0 ? "".concat(globalVar, "['_fs_namespace']") : _ref3$globalNamespace, _ref3$apiVersion = _ref3.apiVersion, apiVersion = _ref3$apiVersion === void 0 ? '1.3.0' : _ref3$apiVersion;
    return "(function(m,n,e,t,l,o,g,y){\n    if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window[\"_fs_namespace\"].');} return;}\n    g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];".concat(shouldInsertScript ? "\n    o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;\n    y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);" : '', "\n    g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};\n    g.anonymize=function(){g.identify(!!0)};\n    g.shutdown=function(){g(\"rec\",!1)};g.restart=function(){g(\"rec\",!0)};\n    g.log = function(a,b){g(\"log\",[a,b])};\n    g.consent=function(a){g(\"consent\",!arguments.length||a)};\n    g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};\n    g.clearUserCookie=function(){};\n    g.setVars=function(n, p){g('setVars',[n,p]);};\n    g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];\n    if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};\n    g._v=\"").concat(apiVersion, "\";\n})(").concat(globalVar, ",").concat($2d85bff27cebf729$var$getDocumentVar(globalVar), ",").concat(globalNamespace, ",'script','user');");
};
var $2d85bff27cebf729$export$52a15e44b483bf1c = function initFS(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    window['_fs_host'] = host;
    window['_fs_script'] = script;
    window['_fs_org'] = orgId;
    window['_fs_namespace'] = namespace;
    $2d85bff27cebf729$var$executeSnippet();
};
var $2d85bff27cebf729$export$26bbcb54e60c59be = function initFSV1(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    window['_fs_host'] = host;
    window['_fs_script'] = script;
    window['_fs_org'] = orgId;
    window['_fs_namespace'] = namespace;
    $2d85bff27cebf729$var$executeSnippetV1();
};
var $2d85bff27cebf729$export$41ad23cd2470a6dd = $2d85bff27cebf729$var$SnippetSrcV2;
var $2d85bff27cebf729$export$56870719feaa6534 = $2d85bff27cebf729$var$SnippetSrcV2Delayed;
var $2d85bff27cebf729$export$7ab8f32ee68a385 = $2d85bff27cebf729$var$toV1String();
var $2d85bff27cebf729$export$e843673607dd064a = function generateSnippetText(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat($2d85bff27cebf729$export$41ad23cd2470a6dd, "\n");
};
var $2d85bff27cebf729$export$449f4f90c1f01cdf = function generateSnippetTextV1(_a) {
    var orgId = _a.orgId, _b = _a.namespace, namespace = _b === void 0 ? 'FS' : _b, _c = _a.host, host = _c === void 0 ? 'fullstory.com' : _c, _d = _a.script, script = _d === void 0 ? 'edge.fullstory.com/s/fs.js' : _d;
    if (!orgId) throw new Error('FullStory orgId is a required parameter');
    return "window['_fs_host'] = '".concat(host, "';\nwindow['_fs_script'] = '").concat(script, "';\nwindow['_fs_org'] = '").concat(orgId, "';\nwindow['_fs_namespace'] = '").concat(namespace, "';\n").concat($2d85bff27cebf729$export$7ab8f32ee68a385, "\n");
};
var $2d85bff27cebf729$export$a91c1a98ec2aac0d = $2d85bff27cebf729$var$mockSnippetV2;
var $2d85bff27cebf729$export$f721247e8e626cdb = $2d85bff27cebf729$var$mockSnippetV1;

});



parcelRegister("25aUb", function(module, exports) {
"use strict";

var $gOoIB = parcelRequire("gOoIB");
const $184481f5ad52dab2$var$returnUrlKey = "hint.redirect-after-login";
function $184481f5ad52dab2$var$fromCallback() {
    return window.location.href.includes("oauth/callback");
}
module.exports = {
    persistUrl: function(forcedUrl) {
        const defaultUrl = window.location.href;
        if (forcedUrl !== undefined || !$184481f5ad52dab2$var$fromCallback() && ![
            "login",
            "logout",
            "callback",
            "join"
        ].some((s)=>defaultUrl.includes(s))) {
            let url = forcedUrl || defaultUrl;
            $gOoIB.setItem($184481f5ad52dab2$var$returnUrlKey, url);
        }
    },
    retrieveUrl: function() {
        return $gOoIB.getItem($184481f5ad52dab2$var$returnUrlKey);
    },
    resetUrl: function() {
        $gOoIB.removeItem($184481f5ad52dab2$var$returnUrlKey);
    }
};

});


parcelRegister("f6fb3", function(module, exports) {
/* global StripeTerminal */ "use strict";
const $afe3306febb92101$var$StripeTerminalPort = {
    add: function(app) {
        if (!window.StripeTerminal) return;
        let stripeTerminals = {};
        app.ports.stripeTerminalPortCreate.subscribe(function(token) {
            stripeTerminals[token] = StripeTerminal.create({
                onFetchConnectionToken: function() {
                    return token;
                },
                onUnexpectedReaderDisconnect: function() {
                    app.ports.stripeTerminalPortOnUnexpectedReaderDisconnect.send("Disconnected from reader");
                }
            });
            app.ports.stripeTerminalPortOnCreated.send(token);
        });
        app.ports.stripeTerminalPortConnectReader.subscribe(function(args) {
            const token = args[0];
            const stripeObject = args[1];
            let discoverReaders;
            if (stripeObject.device_type == "simulated_wisepos_e") discoverReaders = new Promise(function(resolve, reject) {
                stripeTerminals[token].discoverReaders({
                    simulated: true
                }).then(function(discoverResult) {
                    if (discoverResult.error) reject(discoverResult.error);
                    else if (discoverResult.discoveredReaders.length === 0) reject("No available readers.");
                    else resolve(discoverResult.discoveredReaders[0]);
                });
            });
            else discoverReaders = new Promise(function(resolve) {
                resolve(stripeObject);
            });
            discoverReaders.then(function(selectedReader) {
                stripeTerminals[token].connectReader(selectedReader).then(function(result) {
                    const error = result.error || {};
                    app.ports.stripeTerminalPortOnReaderConnected.send([
                        token,
                        error.message || null
                    ]);
                });
            });
        });
        app.ports.stripeTerminalPortReadReusableCard.subscribe(function(token) {
            stripeTerminals[token].readReusableCard().then(function(result) {
                if (result.error) app.ports.stripeTerminalPortOnReusableCardRead.send([
                    token,
                    null,
                    result.error
                ]);
                else app.ports.stripeTerminalPortOnReusableCardRead.send([
                    token,
                    result.payment_method.id,
                    null
                ]);
            });
        });
        app.ports.stripeTerminalPortCancelReadReusableCard.subscribe(function(token) {
            stripeTerminals[token].cancelReadReusableCard().then(function(result) {
                app.ports.stripeTerminalPortOnReadReusableCardCancelled.send([
                    token,
                    result.error || null
                ]);
            });
        });
        app.ports.stripeTerminalPortDisconnectReader.subscribe(function(token) {
            stripeTerminals[token].disconnectReader();
        });
        app.ports.stripeTerminalPortClearCachedCredentials.subscribe(function(token) {
            stripeTerminals[token].clearCachedCredentials();
        });
    }
};
module.exports = $afe3306febb92101$var$StripeTerminalPort;

});

parcelRegister("3i8Jd", function(module, exports) {
/* global Stripe */ 
var $5TpGy = parcelRequire("5TpGy");
"use strict";
const $2659d2c5ac41ad2b$var$REQUEST_ANIMATION_FRAME = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
const $2659d2c5ac41ad2b$var$STRIPE_FONTS = [
    {
        cssSrc: "https://fonts.googleapis.com/css2?family=Wix+Madefor+Text:ital,wght@0,400..800;1,400..800&display=swap"
    }
];
function $2659d2c5ac41ad2b$var$getTextMutedColor() {
    return getComputedStyle(document.documentElement).getPropertyValue("--text-muted").trim() || "#43739e";
}
function $2659d2c5ac41ad2b$var$getStripeAppearance(textMutedColor) {
    return {
        theme: "flat",
        variables: {
            borderRadius: "3px",
            colorBackground: "#FFFFFF",
            colorPrimary: "#1890FF",
            colorText: "#1D2334",
            colorTextPlaceholder: "#497AA5",
            colorTextSecondary: "#497AA5",
            fontFamily: "Wix Madefor Text",
            fontSizeBase: "0.875rem",
            colorIconTabSelected: "#FFFFFF",
            spacingGridRow: "1rem",
            colorIconHover: "#006cd1",
            colorIconTabHover: "#006cd1"
        },
        rules: {
            ".Tab--selected": {
                backgroundColor: "#006cd1",
                border: "0px",
                color: "#FFFFFF"
            },
            ".Tab:hover, .PickerItem:hover": {
                color: "#006cd1"
            },
            ".DropdownItem--highlight": {
                backgroundColor: "#F1F6FC",
                border: "1px solid #81AFE4"
            },
            ".Tab, .Input, .PickerItem": {
                border: "1px solid #c4dcf8",
                boxShadow: "none"
            },
            ".Label": {
                color: textMutedColor,
                textTransform: "capitalize",
                lineHeight: "20px",
                marginBottom: "5px",
                fontSize: "1rem",
                fontWeight: "600"
            },
            ".PickerItem": {
                color: "#497aa4",
                textTransform: "uppercase",
                lineHeight: "25px"
            },
            ".PickerItem:hover": {
                backgroundColor: "#FFFFFF"
            },
            ".Tab:focus, .Tab--selected:focus": {
                outline: "none",
                boxShadow: "0px"
            }
        }
    };
}
function $2659d2c5ac41ad2b$var$buildAndMountElementWithSetupIntent(stripeClient, params, app, elementsRef) {
    const cardElement = document.querySelector(params.selector);
    const textMutedColor = $2659d2c5ac41ad2b$var$getTextMutedColor();
    const elements = stripeClient.elements({
        clientSecret: params.setupIntentSecret,
        fonts: $2659d2c5ac41ad2b$var$STRIPE_FONTS,
        appearance: $2659d2c5ac41ad2b$var$getStripeAppearance(textMutedColor)
    });
    elementsRef.current = elements;
    const disallowedBrands = params.acceptAmex ? [] : [
        "amex"
    ];
    const paymentElement = elements.create("payment", {
        terms: {
            card: "never",
            usBankAccount: "never"
        },
        defaultValues: {
            billingDetails: {
                name: params.name,
                address: {
                    postal_code: params.zip
                }
            }
        },
        disallowedCardBrands: disallowedBrands,
        wallets: {
            applePay: "never",
            googlePay: "never"
        }
    });
    paymentElement.mount(cardElement);
    paymentElement.on("change", function(element) {
        const type = element && element.value && element.value.type || "";
        app.ports.stripePortOnSetupIntentChange.send(type);
    });
    return {
        stripeClient: stripeClient,
        elements: elements,
        paymentElement: paymentElement,
        options: params.options
    };
}
function $2659d2c5ac41ad2b$var$createSetupIntentMountHandler(app, hintStripePublicKey, stripeElements, elementsRef) {
    const mountAttemptsMax = 20;
    let mountAttempts = 0;
    function tryBuildAndMount(params) {
        const stripeClient = Stripe(hintStripePublicKey, {
            betas: [
                "blocked_card_brands_beta_1"
            ],
            apiVersion: "2019-12-03"
        });
        const cardElement = document.querySelector(params.selector);
        if (cardElement) $2659d2c5ac41ad2b$var$REQUEST_ANIMATION_FRAME(function() {
            stripeElements[params.selector] = $2659d2c5ac41ad2b$var$buildAndMountElementWithSetupIntent(stripeClient, params, app, elementsRef);
        });
        else if (mountAttempts <= mountAttemptsMax) {
            mountAttempts += 1;
            setTimeout(function() {
                tryBuildAndMount(params);
            }, 100);
        }
    }
    return tryBuildAndMount;
}
function $2659d2c5ac41ad2b$var$createConfirmSetupIntentHandler(app, stripeElements, elementsRef) {
    return function(params) {
        const stripeElement = stripeElements[params.selector];
        const billingDetails = params.options && params.options.billingOptions ? {
            billing_details: {
                name: params.options.billingOptions.name
            }
        } : {};
        stripeElement.stripeClient.confirmSetup({
            elements: elementsRef.current,
            confirmParams: {
                return_url: window.location.href,
                payment_method_data: billingDetails
            },
            redirect: "if_required"
        }).then(({ error: error, setupIntent: setupIntent })=>{
            if (error) app.ports.stripePortOnSetupIntentConfirmed.send({
                selector: params.selector,
                setup_intent: null,
                error: error.message
            });
            else app.ports.stripePortOnSetupIntentConfirmed.send({
                selector: params.selector,
                setup_intent: setupIntent,
                error: null
            });
        });
    };
}
function $2659d2c5ac41ad2b$var$createMountPaymentDisputesHandler(hintStripePublicKey) {
    return function(params) {
        $2659d2c5ac41ad2b$var$REQUEST_ANIMATION_FRAME(function() {
            const stripeConnectInstance = (0, $5TpGy.loadConnectAndInitialize)({
                publishableKey: hintStripePublicKey,
                fetchClientSecret: ()=>Promise.resolve(params.stripeClientSecret)
            });
            const paymentDisputes = stripeConnectInstance.create("payment-disputes");
            paymentDisputes.setPayment(params.chargeId);
            document.querySelector(params.selector).appendChild(paymentDisputes);
        });
    };
}
function $2659d2c5ac41ad2b$var$createMountCapitalPromoTileHandler(app, hintStripePublicKey) {
    return function(params) {
        $2659d2c5ac41ad2b$var$REQUEST_ANIMATION_FRAME(function() {
            const container = document.querySelector(params.selector);
            if (!container) return;
            const stripeConnectInstance = (0, $5TpGy.loadConnectAndInitialize)({
                publishableKey: hintStripePublicKey,
                fetchClientSecret: ()=>Promise.resolve(params.stripeClientSecret)
            });
            try {
                const capitalPromoTile = stripeConnectInstance.create("capital-financing-promotion");
                capitalPromoTile.setLayout("banner");
                capitalPromoTile.setOnEligibleFinancingOfferLoaded(({ productType: productType })=>{
                    app.ports.stripePortOnCapitalOfferLoaded.send(productType);
                });
                container.appendChild(capitalPromoTile);
            } catch (error) {
                console.warn("Capital promotion tile not available:", error.message);
            }
        });
    };
}
const $2659d2c5ac41ad2b$var$StripePort = {
    add: function(app, hintStripePublicKey) {
        if (!window.Stripe) return;
        const stripeElements = {};
        const elementsRef = {
            current: null
        };
        app.ports.stripePortBuildAndMountElementWithSetupIntent.subscribe($2659d2c5ac41ad2b$var$createSetupIntentMountHandler(app, hintStripePublicKey, stripeElements, elementsRef));
        app.ports.stripePortConfirmSetupIntent.subscribe($2659d2c5ac41ad2b$var$createConfirmSetupIntentHandler(app, stripeElements, elementsRef));
        app.ports.stripePortMountPaymentDisputesComponent.subscribe($2659d2c5ac41ad2b$var$createMountPaymentDisputesHandler(hintStripePublicKey));
        app.ports.stripePortMountCapitalPromoTile.subscribe($2659d2c5ac41ad2b$var$createMountCapitalPromoTileHandler(app, hintStripePublicKey));
        app.ports.stripePortMountAccountOnboardingComponent.subscribe(function(params) {
            requestAnimationFrame(function() {
                const stripeConnectInstance = (0, $5TpGy.loadConnectAndInitialize)({
                    publishableKey: hintStripePublicKey,
                    fetchClientSecret: ()=>Promise.resolve(params.stripeClientSecret)
                });
                const accountOnboarding = stripeConnectInstance.create("account-onboarding");
                accountOnboarding.setOnExit(function() {
                    app.ports.stripePortOnboardingExited.send(null);
                });
                accountOnboarding.setOnStepChange(function() {
                    app.ports.stripePortOnboardingStepChanged.send(null);
                });
                document.querySelector(params.selector).appendChild(accountOnboarding);
            });
        });
    }
};
module.exports = $2659d2c5ac41ad2b$var$StripePort;

});
parcelRegister("5TpGy", function(module, exports) {

$parcel$export(module.exports, "loadConnectAndInitialize", function () { return $44a6036565c60c10$export$2d0a5237d5a92e8d; });
/* eslint-disable @typescript-eslint/no-empty-function */ /* eslint-disable @typescript-eslint/no-unused-vars */ const $44a6036565c60c10$var$ConnectElementCommonMethodConfig = {
    setOnLoadError: (_listener)=>{},
    setOnLoaderStart: (_listener)=>{}
};
const $44a6036565c60c10$var$ConnectElementCustomMethodConfig = {
    payments: {
        setDefaultFilters: (_filters)=>{}
    },
    "payment-details": {
        setPayment: (_payment)=>{},
        setOnClose: (_listener)=>{}
    },
    "payment-disputes": {
        setPayment: (_payment)=>{},
        setOnDisputesLoaded: (_listener)=>{}
    },
    "account-onboarding": {
        setFullTermsOfServiceUrl: (_termOfServiceUrl)=>{},
        setRecipientTermsOfServiceUrl: (_recipientTermsOfServiceUrl)=>{},
        setPrivacyPolicyUrl: (_privacyPolicyUrl)=>{},
        setSkipTermsOfServiceCollection: (_skipTermsOfServiceCollection)=>{},
        setCollectionOptions: (_collectionOptions)=>{},
        setOnExit: (_listener)=>{},
        setOnStepChange: (_listener)=>{}
    },
    "account-management": {
        setCollectionOptions: (_collectionOptions)=>{}
    },
    "notification-banner": {
        setCollectionOptions: (_collectionOptions)=>{},
        setOnNotificationsChange: (_listener)=>{}
    },
    "instant-payouts-promotion": {
        setOnInstantPayoutsPromotionLoaded: (_listener)=>{},
        setOnInstantPayoutCreated: (_listener)=>{}
    },
    "issuing-card": {
        setDefaultCard: (_defaultCard)=>{},
        setCardSwitching: (_cardSwitching)=>{},
        setFetchEphemeralKey: (_fetchEphemeralKey)=>{},
        setShowSpendControls: (_showSpendControls)=>{}
    },
    "issuing-cards-list": {
        setFetchEphemeralKey: (_fetchEphemeralKey)=>{},
        setShowSpendControls: (_showSpendControls)=>{},
        setIssuingProgram: (_issuingProgram)=>{}
    },
    "financial-account": {
        setFinancialAccount: (_financialAccount)=>{}
    },
    "financial-account-transactions": {
        setFinancialAccount: (_financialAccount)=>{}
    },
    recipients: {
        setDataSource: (_dataSource)=>{}
    },
    "app-install": {
        setApp: (_app)=>{},
        setOnAppInstallStateFetched: (_listener)=>{},
        setOnAppInstallStateChanged: (_listener)=>{}
    },
    "app-viewport": {
        setApp: (_app)=>{},
        setAppData: (_appData)=>{}
    },
    "payment-method-settings": {
        setPaymentMethodConfiguration: (_paymentMethodConfiguration)=>{}
    },
    "capital-financing": {
        setDefaultFinancingOffer: (_defaultFinancingOffer)=>{},
        setShowFinancingSelector: (_showFinancingSelector)=>{},
        setHowCapitalWorksUrl: (_howCapitalWorksUrl)=>{},
        setSupportUrl: (_supportUrl)=>{},
        setOnFinancingsLoaded: (_listener)=>{}
    },
    "capital-financing-application": {
        setOnApplicationSubmitted: (_listener)=>{},
        setPrivacyPolicyUrl: (_privacyPolicyUrl)=>{},
        setHowCapitalWorksUrl: (_howCapitalWorksUrl)=>{},
        setOnApplicationStepChange: (_listener)=>{}
    },
    "capital-financing-promotion": {
        setLayout: (_layout)=>{},
        setOnApplicationSubmitted: (_listener)=>{},
        setOnEligibleFinancingOfferLoaded: (_listener)=>{},
        setPrivacyPolicyUrl: (_privacyPolicyUrl)=>{},
        setHowCapitalWorksUrl: (_howCapitalWorksUrl)=>{},
        setEligibilityCriteriaUrl: (_eligibilityCriteriaUrl)=>{},
        setOnApplicationStepChange: (_listener)=>{}
    },
    "reporting-chart": {
        setReportName: (_reportName)=>{},
        setIntervalStart: (_intervalStart)=>{},
        setIntervalEnd: (_intervalEnd)=>{},
        setIntervalType: (_intervalType)=>{}
    },
    "tax-settings": {
        setHideProductTaxCodeSelector: (_hidden)=>{},
        setDisplayHeadOfficeCountries: (_countries)=>{},
        setOnTaxSettingsUpdated: (_listener)=>{}
    },
    "tax-registrations": {
        setOnAfterTaxRegistrationAdded: (_listener)=>{},
        setDisplayCountries: (_countries)=>{},
        setOnAfterTaxRegistrationExpired: (_listener)=>{}
    },
    "tax-threshold-monitoring": {
        setDisplayCountries: (_countries)=>{}
    },
    "product-tax-code-selector": {
        setOnTaxCodeSelect: (_listener)=>{},
        setHideDescription: (_hideDescription)=>{},
        setDisabled: (_disabled)=>{},
        setInitialTaxCode: (_initialTaxCode)=>{}
    },
    "export-tax-transactions": {},
    "payout-details": {
        setPayout: (_payout)=>{},
        setOnClose: (_listener)=>{}
    },
    "check-scanning": {
        setHandleCheckScanSubmitted: (_handleCheckScanSubmitted)=>{}
    },
    "agentic-commerce-settings": {
        setOnAgreementUpdated: (_listener)=>{}
    },
    "terminal-hardware-shop": {
        setOnCheckoutFinished: (_listener)=>{}
    }
};
const $44a6036565c60c10$var$componentNameMapping = {
    payments: "stripe-connect-payments",
    payouts: "stripe-connect-payouts",
    "payment-details": "stripe-connect-payment-details",
    "payment-disputes": "stripe-connect-payment-disputes",
    "disputes-list": "stripe-connect-disputes-list",
    "account-onboarding": "stripe-connect-account-onboarding",
    "payment-method-settings": "stripe-connect-payment-method-settings",
    "account-management": "stripe-connect-account-management",
    "notification-banner": "stripe-connect-notification-banner",
    "instant-payouts": "stripe-connect-instant-payouts",
    "instant-payouts-promotion": "stripe-connect-instant-payouts-promotion",
    "issuing-card": "stripe-connect-issuing-card",
    "issuing-cards-list": "stripe-connect-issuing-cards-list",
    "financial-account": "stripe-connect-financial-account",
    recipients: "stripe-connect-recipients",
    "financial-account-transactions": "stripe-connect-financial-account-transactions",
    "capital-financing": "stripe-connect-capital-financing",
    "capital-financing-application": "stripe-connect-capital-financing-application",
    "capital-financing-promotion": "stripe-connect-capital-financing-promotion",
    "capital-overview": "stripe-connect-capital-overview",
    documents: "stripe-connect-documents",
    "product-tax-code-selector": "stripe-connect-product-tax-code-selector",
    "export-tax-transactions": "stripe-connect-export-tax-transactions",
    "tax-registrations": "stripe-connect-tax-registrations",
    "tax-settings": "stripe-connect-tax-settings",
    "tax-threshold-monitoring": "stripe-connect-tax-threshold-monitoring",
    balances: "stripe-connect-balances",
    "payouts-list": "stripe-connect-payouts-list",
    "payout-details": "stripe-connect-payout-details",
    "app-install": "stripe-connect-app-install",
    "app-viewport": "stripe-connect-app-viewport",
    "reporting-chart": "stripe-connect-reporting-chart",
    "check-scanning": "stripe-connect-check-scanning",
    "agentic-commerce-settings": "stripe-connect-agentic-commerce-settings",
    "terminal-hardware-orders": "stripe-connect-terminal-hardware-orders",
    "terminal-hardware-shop": "stripe-connect-terminal-hardware-shop",
    "network-cost-passthrough-report": "stripe-connect-network-cost-passthrough-report"
};
const $44a6036565c60c10$var$EXISTING_SCRIPT_MESSAGE = "loadConnect was called but an existing Connect.js script already exists in the document; existing script parameters will be used";
const $44a6036565c60c10$var$V0_URL = "https://connect-js.stripe.com/v0.1/connect.js";
const $44a6036565c60c10$var$V1_URL = "https://connect-js.stripe.com/v1.0/connect.js";
const $44a6036565c60c10$var$findScript = ()=>{
    return document.querySelectorAll(`script[src="${$44a6036565c60c10$var$V0_URL}"]`)[0] || document.querySelectorAll(`script[src="${$44a6036565c60c10$var$V1_URL}"]`)[0] || null;
};
const $44a6036565c60c10$var$injectScript = ()=>{
    const script = document.createElement("script");
    script.src = $44a6036565c60c10$var$V1_URL;
    const head = document.head;
    if (!head) throw new Error("Expected document.head not to be null. Connect.js requires a <head> element.");
    document.head.appendChild(script);
    return script;
};
let $44a6036565c60c10$var$stripePromise = null;
const $44a6036565c60c10$var$isWindowStripeConnectDefined = (stripeConnect)=>{
    // We only consider `StripeConnect` defined if `init` is a function
    // Why? HTML markup like:
    // <a id="StripeConnect"><a id="StripeConnect" name="init" href="stripe"></a></a> in the <head> of the page
    // can end up "contaminating" the window.StripeConnect object and cause issues in connect.js initialization
    return !!(stripeConnect && typeof stripeConnect === "object" && "init" in stripeConnect && typeof stripeConnect.init === "function");
};
const $44a6036565c60c10$var$loadScript = ()=>{
    // Ensure that we only attempt to load Connect.js at most once
    if ($44a6036565c60c10$var$stripePromise !== null) return $44a6036565c60c10$var$stripePromise;
    $44a6036565c60c10$var$stripePromise = new Promise((resolve, reject)=>{
        if (typeof window === "undefined") {
            reject("ConnectJS won't load when rendering code in the server - it can only be loaded on a browser. This error is expected when loading ConnectJS in SSR environments, like NextJS. It will have no impact in the UI, however if you wish to avoid it, you can switch to the `pure` version of the connect.js loader: https://github.com/stripe/connect-js#importing-loadconnect-without-side-effects.");
            return;
        }
        if ($44a6036565c60c10$var$isWindowStripeConnectDefined(window.StripeConnect)) {
            console.warn($44a6036565c60c10$var$EXISTING_SCRIPT_MESSAGE);
            const wrapper = $44a6036565c60c10$var$createWrapper(window.StripeConnect);
            resolve(wrapper);
            return;
        }
        try {
            let script = $44a6036565c60c10$var$findScript();
            if (script) console.warn($44a6036565c60c10$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $44a6036565c60c10$var$injectScript();
            script.addEventListener("load", ()=>{
                if ($44a6036565c60c10$var$isWindowStripeConnectDefined(window.StripeConnect)) {
                    const wrapper = $44a6036565c60c10$var$createWrapper(window.StripeConnect);
                    resolve(wrapper);
                } else reject(new Error("Connect.js did not load the necessary objects"));
            });
            script.addEventListener("error", ()=>{
                reject(new Error("Failed to load Connect.js"));
            });
        } catch (error) {
            reject(error);
        }
    });
    return $44a6036565c60c10$var$stripePromise;
};
const $44a6036565c60c10$var$hasCustomMethod = (tagName)=>{
    return tagName in $44a6036565c60c10$var$ConnectElementCustomMethodConfig;
};
const $44a6036565c60c10$var$initStripeConnect = (stripePromise, initParams)=>{
    var _a;
    const eagerClientSecretPromise = (()=>{
        try {
            return initParams.fetchClientSecret();
        } catch (error) {
            return Promise.reject(error);
        }
    })();
    const metaOptions = (_a = initParams.metaOptions) !== null && _a !== void 0 ? _a : {};
    const stripeConnectInstance = stripePromise.then((wrapper)=>wrapper.initialize(Object.assign(Object.assign({}, initParams), {
            metaOptions: Object.assign(Object.assign({}, metaOptions), {
                eagerClientSecretPromise: eagerClientSecretPromise
            })
        })));
    return {
        create: (tagName)=>{
            let htmlName = $44a6036565c60c10$var$componentNameMapping[tagName];
            if (!htmlName) htmlName = tagName;
            const element = document.createElement(htmlName);
            const customMethods = $44a6036565c60c10$var$hasCustomMethod(tagName) ? $44a6036565c60c10$var$ConnectElementCustomMethodConfig[tagName] : {};
            const methods = Object.assign(Object.assign({}, customMethods), $44a6036565c60c10$var$ConnectElementCommonMethodConfig);
            for(const method in methods)element[method] = function(value) {
                stripeConnectInstance.then(()=>{
                    if (!this[`${method}InternalOnly`]) throw new Error(`Method ${method} is not available in the ${tagName} HTML element. Are you using a supported version of the "@stripe/connect-js" package? Using version: 3.3.50-preview-1`);
                    this[`${method}InternalOnly`](value);
                });
            };
            stripeConnectInstance.then((instance)=>{
                if (!element.isConnected && !element.setConnector) {
                    // If the element is not connected to the DOM and the `setConnector` method is not
                    // defined, this indicates the element was created before connect.js was loaded, and has
                    // not been transformed into a custom element yet
                    // To load the custom element code on it, we need to connect and disconnect it to the DOM
                    // This isn't a problem, as the element will be invisible, and we know the element is already
                    // not currently connected to the DOM
                    const oldDisplay = element.style.display;
                    element.style.display = "none";
                    document.body.appendChild(element);
                    document.body.removeChild(element);
                    element.style.display = oldDisplay;
                }
                if (!element || !element.setConnector) throw new Error(`Element ${tagName} was not transformed into a custom element. Are you using a documented component? See https://docs.stripe.com/connect/supported-embedded-components for a list of supported components`);
                element.setConnector(instance.connect);
            });
            return element;
        },
        update: (updateOptions)=>{
            stripeConnectInstance.then((instance)=>{
                instance.update(updateOptions);
            });
        },
        debugInstance: ()=>{
            return stripeConnectInstance;
        },
        logout: ()=>{
            return stripeConnectInstance.then((instance)=>{
                return instance.logout();
            });
        }
    };
};
const $44a6036565c60c10$var$createWrapper = (stripeConnect)=>{
    window.StripeConnect = window.StripeConnect || {};
    window.StripeConnect.optimizedLoading = true;
    const wrapper = {
        initialize: (params)=>{
            var _a;
            const metaOptions = (_a = params.metaOptions) !== null && _a !== void 0 ? _a : {};
            const stripeConnectInstance = stripeConnect.init(Object.assign(Object.assign({}, params), {
                metaOptions: Object.assign(Object.assign({}, metaOptions), {
                    sdk: true,
                    sdkOptions: {
                        // This will be replaced by the npm package version when bundling
                        sdkVersion: "3.3.50-preview-1"
                    }
                })
            }));
            return stripeConnectInstance;
        }
    };
    return wrapper;
};
// Execute our own script injection after a tick to give users time to do their
// own script injection.
const $44a6036565c60c10$var$stripePromise$1 = Promise.resolve().then(()=>$44a6036565c60c10$var$loadScript());
let $44a6036565c60c10$var$loadCalled = false;
$44a6036565c60c10$var$stripePromise$1.catch((err)=>{
    if (!$44a6036565c60c10$var$loadCalled) console.warn(err);
});
const $44a6036565c60c10$export$2d0a5237d5a92e8d = (initParams)=>{
    $44a6036565c60c10$var$loadCalled = true;
    return $44a6036565c60c10$var$initStripeConnect($44a6036565c60c10$var$stripePromise$1, initParams);
};

});


parcelRegister("eNjxw", function(module, exports) {
"use strict";
const $ac54cc7082a6642c$var$calculateUnderlinePosition = (navId, activeTab)=>{
    const nav = document.querySelector(`#${navId}`), activeItemRect = activeTab.getBoundingClientRect(), navRect = nav.getBoundingClientRect();
    return {
        navId: navId,
        width: activeItemRect.width,
        left: activeItemRect.x - navRect.x
    };
};
const $ac54cc7082a6642c$var$findActiveTab = (navId)=>{
    return document.querySelector(`#${navId} > .nav-tabs__item--active`);
};
const $ac54cc7082a6642c$var$sendUnderlinePositionThroughPort = (navId, portFun, retryCount)=>{
    // First render is extremely slow, thus the timeout and the many retries.
    const activeTab = $ac54cc7082a6642c$var$findActiveTab(navId);
    if (activeTab) portFun.send($ac54cc7082a6642c$var$calculateUnderlinePosition(navId, activeTab));
    else if (retryCount > 20) return false;
    else setTimeout(()=>{
        $ac54cc7082a6642c$var$sendUnderlinePositionThroughPort(navId, portFun, (retryCount || 0) + 1);
    }, 100);
};
const $ac54cc7082a6642c$var$NavTabsPort = {
    add: (app)=>{
        app.ports.navTabActiveChanged.subscribe((navId)=>{
            // This ports usually fires before the dom refreshes, so the activeTab
            // hasn't changed yet. Thus the timeout.
            setTimeout(()=>{
                $ac54cc7082a6642c$var$sendUnderlinePositionThroughPort(navId, app.ports.onNavTabActivePositionChange);
            }, 50);
        });
    }
};
module.exports = $ac54cc7082a6642c$var$NavTabsPort;

});

parcelRegister("7d4sX", function(module, exports) {
parcelRequire("67hUc");
var $dV0Ap = parcelRequire("dV0Ap");
var $e0AWW = parcelRequire("e0AWW");
var $dPO2k = parcelRequire("dPO2k");
var $8USNj = parcelRequire("8USNj");
"use strict";
const $53fd36298febc800$var$DOWNLOAD_ACTIONS = [
    (0, $dV0Ap.Action).DownloadAsPdf,
    (0, $dV0Ap.Action).DownloadAsCsv,
    (0, $dV0Ap.Action).Download
];
const $53fd36298febc800$var$ThoughtSpotPort = {
    add: function(app) {
        const render = (id)=>{
            const liveboardEmbed = new (0, $dPO2k.LiveboardEmbed)(document.getElementById("ts-embed"), {
                frameParams: {
                    width: "100%",
                    height: "100%"
                },
                hidedatasources: true,
                liveboardId: id,
                fullHeight: true,
                visibleActions: [
                    (0, $dV0Ap.Action).AxisMenuSort,
                    (0, $dV0Ap.Action).AxisMenuFilter,
                    ...$53fd36298febc800$var$DOWNLOAD_ACTIONS
                ],
                customizations: {
                    style: {
                        customCSS: {
                            variables: {
                                "--ts-var-root-background": "#f1f6fc"
                            }
                        }
                    }
                }
            });
            liveboardEmbed.render();
        };
        const authenticate = ()=>{
            const promise = new Promise((resolve)=>{
                const authenticationHandler = (token)=>{
                    app.ports.authenticateThoughtSpotPort.unsubscribe(authenticationHandler);
                    resolve(token);
                };
                app.ports.authenticateThoughtSpotPort.subscribe(authenticationHandler);
            });
            app.ports.onThoughtSpotTokenRequestPort.send(null);
            return promise;
        };
        const initialize = (email)=>{
            (0, $e0AWW.init)({
                thoughtSpotHost: "https://hinthealth.thoughtspot.cloud",
                // For some reason ThoughtSpot does not support Cookieless for builder embedding.
                // authType: AuthType.TrustedAuthToken,
                // However, testing with cookie tokens is quite tricky, as the token get's
                // retrieved from the cookies instead of refreshing on user change.
                authType: (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless,
                username: email,
                autoLogin: true,
                getAuthToken: authenticate,
                dateFormatLocale: "en-US"
            });
        };
        app.ports.embedThoughtSpotPort.subscribe(({ id: id, email: email, downloadsGated: downloadsGated, practiceIdents: practiceIdents })=>{
            initialize(email);
            render(id, downloadsGated, practiceIdents);
        });
        app.ports.embedSearchThoughtSpotPort.subscribe(({ email: email })=>{
            initialize(email);
            setTimeout(()=>{
                const searchEmbed = new (0, $8USNj.SearchEmbed)(document.getElementById("ts-search-embed"), {
                    frameParams: {
                        width: "100%",
                        height: "100%"
                    },
                    fullHeight: true
                });
                searchEmbed.render();
            }, 500);
        });
    }
};
module.exports = $53fd36298febc800$var$ThoughtSpotPort;

});
parcelRegister("67hUc", function(module, exports) {

$parcel$export(module.exports, "init", function () { return (parcelRequire("e0AWW")).init; });
$parcel$export(module.exports, "SearchEmbed", function () { return (parcelRequire("8USNj")).SearchEmbed; });
$parcel$export(module.exports, "LiveboardEmbed", function () { return (parcelRequire("dPO2k")).LiveboardEmbed; });
$parcel$export(module.exports, "AuthType", function () { return (parcelRequire("dV0Ap")).AuthType; });
$parcel$export(module.exports, "Action", function () { return (parcelRequire("dV0Ap")).Action; });

var $jKmZQ = parcelRequire("jKmZQ");

var $e0AWW = parcelRequire("e0AWW");

var $dPO2k = parcelRequire("dPO2k");

var $8USNj = parcelRequire("8USNj");

var $9doxk = parcelRequire("9doxk");

var $lPfbA = parcelRequire("lPfbA");

var $a9HVp = parcelRequire("a9HVp");

var $fv46J = parcelRequire("fv46J");

var $6JZt8 = parcelRequire("6JZt8");

var $dV0Ap = parcelRequire("dV0Ap");

var $3q1XH = parcelRequire("3q1XH");

var $a6640 = parcelRequire("a6640");

var $fxzLD = parcelRequire("fxzLD");

var $8NaiO = parcelRequire("8NaiO");

var $lMpvb = parcelRequire("lMpvb");

var $jVefY = parcelRequire("jVefY");

var $cMxso = parcelRequire("cMxso");

var $d4gBz = parcelRequire("d4gBz");

var $bINVD = parcelRequire("bINVD");
'use client';

});
parcelRegister("jKmZQ", function(module, exports) {
/**
 * Copyright (c) 2022
 *
 * Full application embedding
 * https://developers.thoughtspot.com/docs/?pageid=full-embed
 * @summary Full app embed
 * @module
 * @author Ayon Ghosh <ayon.ghosh@thoughtspot.com>
 */ 
var $kCAID = parcelRequire("kCAID");

var $7aJfj = parcelRequire("7aJfj");

var $dV0Ap = parcelRequire("dV0Ap");

var $2SBdZ = parcelRequire("2SBdZ");

var $b8Ldn = parcelRequire("b8Ldn");
var $e60426d4ba18eebc$export$6955bcca4cd3539f;
(function(Page) {
    /**
     * Home page
     */ Page["Home"] = "home";
    /**
     * Search page
     */ Page["Search"] = "search";
    /**
     * Saved answers listing page
     */ Page["Answers"] = "answers";
    /**
     * Liveboards listing page
     */ Page["Liveboards"] = "liveboards";
    /**
     * @hidden
     */ Page["Pinboards"] = "pinboards";
    /**
     * Data management page
     */ Page["Data"] = "data";
    /**
     * SpotIQ listing page
     */ Page["SpotIQ"] = "insights";
    /**
     *  Monitor Alerts Page
     */ Page["Monitor"] = "monitor";
})($e60426d4ba18eebc$export$6955bcca4cd3539f || ($e60426d4ba18eebc$export$6955bcca4cd3539f = {}));
var $e60426d4ba18eebc$export$aadbc8888d90c6a6;
(function(DataPanelCustomColumnGroupsAccordionState) {
    /**
     * Expand all the accordion initially in data panel v2.
     */ DataPanelCustomColumnGroupsAccordionState["EXPAND_ALL"] = "EXPAND_ALL";
    /**
     * Collapse all the accordions initially in data panel v2.
     */ DataPanelCustomColumnGroupsAccordionState["COLLAPSE_ALL"] = "COLLAPSE_ALL";
    /**
     * Expand the first accordion and collapse the rest.
     */ DataPanelCustomColumnGroupsAccordionState["EXPAND_FIRST"] = "EXPAND_FIRST";
})($e60426d4ba18eebc$export$aadbc8888d90c6a6 || ($e60426d4ba18eebc$export$aadbc8888d90c6a6 = {}));
var $e60426d4ba18eebc$export$5485039826c78500;
(function(HomePageSearchBarMode) {
    HomePageSearchBarMode["OBJECT_SEARCH"] = "objectSearch";
    HomePageSearchBarMode["AI_ANSWER"] = "aiAnswer";
    HomePageSearchBarMode["NONE"] = "none";
})($e60426d4ba18eebc$export$5485039826c78500 || ($e60426d4ba18eebc$export$5485039826c78500 = {}));
var $e60426d4ba18eebc$export$4a7dc30b37490b34;
(function(PrimaryNavbarVersion) {
    /**
     * Sliding (v3) introduces a new left-side navigation hub featuring a tab switcher,
     * along with updates to the top navigation bar.
     * It serves as the foundational version of the PrimaryNavBar.
     */ PrimaryNavbarVersion["Sliding"] = "v3";
})($e60426d4ba18eebc$export$4a7dc30b37490b34 || ($e60426d4ba18eebc$export$4a7dc30b37490b34 = {}));
var $e60426d4ba18eebc$export$36d69433c4f81145;
(function(HomePage) {
    /**
     * Modular (v2) introduces the updated Modular Home Experience.
     * It serves as the foundational version of the home page.
     */ HomePage["Modular"] = "v2";
    /**
     * ModularWithStylingChanges (v3) introduces Modular Home Experience
     * with styling changes.
     */ HomePage["ModularWithStylingChanges"] = "v3";
})($e60426d4ba18eebc$export$36d69433c4f81145 || ($e60426d4ba18eebc$export$36d69433c4f81145 = {}));
var $e60426d4ba18eebc$export$9b7824917a0c851e;
(function(ListPage) {
    /**
     * List (v2) is the traditional List Experience.
     * It serves as the foundational version of the list page.
     */ ListPage["List"] = "v2";
    /**
     * ListWithUXChanges (v3) introduces the new updated list page with UX changes.
     */ ListPage["ListWithUXChanges"] = "v3";
})($e60426d4ba18eebc$export$9b7824917a0c851e || ($e60426d4ba18eebc$export$9b7824917a0c851e = {}));
class $e60426d4ba18eebc$export$1c477ebd0b6db914 extends (0, $2SBdZ.V1Embed) {
    constructor(domSelector, viewConfig){
        viewConfig.embedComponentType = 'AppEmbed';
        super(domSelector, viewConfig);
        this.defaultHeight = 500;
        this.sendFullHeightLazyLoadData = ()=>{
            const data = (0, $7aJfj.calculateVisibleElementData)(this.iFrame);
            // this should be fired only if the lazyLoadingForFullHeight and fullHeight are true
            if (this.viewConfig.lazyLoadingForFullHeight && this.viewConfig.fullHeight) this.trigger((0, $dV0Ap.HostEvent).VisibleEmbedCoordinates, data);
        };
        /**
         * This is a handler for the RequestVisibleEmbedCoordinates event.
         * It is used to send the visible coordinates data to the host application.
         * @param data The event payload
         * @param responder The responder function
         */ this.requestVisibleEmbedCoordinatesHandler = (data, responder)=>{
            (0, $kCAID.logger).info('Sending RequestVisibleEmbedCoordinates', data);
            const visibleCoordinatesData = (0, $7aJfj.calculateVisibleElementData)(this.iFrame);
            responder({
                type: (0, $dV0Ap.EmbedEvent).RequestVisibleEmbedCoordinates,
                data: visibleCoordinatesData
            });
        };
        /**
         * Set the iframe height as per the computed height received
         * from the ThoughtSpot app.
         * @param data The event payload
         */ this.updateIFrameHeight = (data)=>{
            this.setIFrameHeight(Math.max(data.data, this.defaultHeight));
            this.sendFullHeightLazyLoadData();
        };
        this.embedIframeCenter = (data, responder)=>{
            const obj = this.getIframeCenter();
            responder({
                type: (0, $dV0Ap.EmbedEvent).EmbedIframeCenter,
                data: obj
            });
        };
        this.setIframeHeightForNonEmbedLiveboard = (data)=>{
            const { height: frameHeight } = this.viewConfig.frameParams || {};
            const liveboardRelatedRoutes = [
                '/pinboard/',
                '/insights/pinboard/',
                '/schedules/',
                '/embed/viz/',
                '/embed/insights/viz/',
                '/liveboard/',
                '/insights/liveboard/',
                '/tsl-editor/PINBOARD_ANSWER_BOOK/',
                '/import-tsl/PINBOARD_ANSWER_BOOK/'
            ];
            if (liveboardRelatedRoutes.some((path)=>data.data.currentPath.startsWith(path))) // Ignore the height reset of the frame, if the navigation is
            // only within the liveboard page.
            return;
            this.setIFrameHeight(frameHeight || this.defaultHeight);
        };
        if (this.viewConfig.fullHeight === true) {
            this.on((0, $dV0Ap.EmbedEvent).RouteChange, this.setIframeHeightForNonEmbedLiveboard);
            this.on((0, $dV0Ap.EmbedEvent).EmbedHeight, this.updateIFrameHeight);
            this.on((0, $dV0Ap.EmbedEvent).EmbedIframeCenter, this.embedIframeCenter);
            this.on((0, $dV0Ap.EmbedEvent).RequestVisibleEmbedCoordinates, this.requestVisibleEmbedCoordinatesHandler);
        }
    }
    /**
     * Extends the default APP_INIT payload with `embedParams.spotterSidebarConfig`
     * so the conv-assist app can read sidebar configuration on initialisation.
     *
     * Precedence for `enablePastConversationsSidebar`:
     * `spotterSidebarConfig.enablePastConversationsSidebar` wins over the
     * deprecated top-level `enablePastConversationsSidebar` flag; if the former
     * is absent the latter is used as a fallback.
     *
     * An invalid `spotterDocumentationUrl` triggers a validation error and is
     * excluded from the payload rather than forwarded to the app.
     */ async getAppInitData() {
        const defaultAppInitData = await super.getAppInitData();
        return (0, $b8Ldn.buildSpotterSidebarAppInitData)(defaultAppInitData, this.viewConfig, this.handleError.bind(this));
    }
    /**
     * Constructs a map of parameters to be passed on to the
     * embedded Liveboard or visualization.
     */ getEmbedParams() {
        const { tag: tag, hideTagFilterChips: hideTagFilterChips, hideObjects: hideObjects, liveboardV2: liveboardV2, showPrimaryNavbar: showPrimaryNavbar, disableProfileAndHelp: disableProfileAndHelp, hideHamburger: hideHamburger, hideObjectSearch: hideObjectSearch, hideNotification: hideNotification, hideApplicationSwitcher: hideApplicationSwitcher, hideOrgSwitcher: hideOrgSwitcher, enableSearchAssist: enableSearchAssist, fullHeight: fullHeight, dataPanelV2: dataPanelV2 = true, hideLiveboardHeader: hideLiveboardHeader = false, showLiveboardTitle: showLiveboardTitle = true, showLiveboardDescription: showLiveboardDescription = true, showMaskedFilterChip: showMaskedFilterChip = false, isLiveboardMasterpiecesEnabled: isLiveboardMasterpiecesEnabled = false, hideHomepageLeftNav: hideHomepageLeftNav = false, modularHomeExperience: modularHomeExperience = false, isLiveboardHeaderSticky: isLiveboardHeaderSticky = true, enableAskSage: enableAskSage, collapseSearchBarInitially: collapseSearchBarInitially = false, enable2ColumnLayout: enable2ColumnLayout, enableCustomColumnGroups: enableCustomColumnGroups = false, dataPanelCustomGroupsAccordionInitialState: dataPanelCustomGroupsAccordionInitialState = $e60426d4ba18eebc$export$aadbc8888d90c6a6.EXPAND_ALL, collapseSearchBar: collapseSearchBar = true, isLiveboardCompactHeaderEnabled: isLiveboardCompactHeaderEnabled = false, showLiveboardVerifiedBadge: showLiveboardVerifiedBadge = true, showLiveboardReverifyBanner: showLiveboardReverifyBanner = true, hideIrrelevantChipsInLiveboardTabs: hideIrrelevantChipsInLiveboardTabs = false, isEnhancedFilterInteractivityEnabled: isEnhancedFilterInteractivityEnabled = false, homePageSearchBarMode: homePageSearchBarMode, isUnifiedSearchExperienceEnabled: isUnifiedSearchExperienceEnabled = true, enablePendoHelp: enablePendoHelp = true, discoveryExperience: discoveryExperience, coverAndFilterOptionInPDF: coverAndFilterOptionInPDF = false, isLiveboardStylingAndGroupingEnabled: isLiveboardStylingAndGroupingEnabled, isPNGInScheduledEmailsEnabled: isPNGInScheduledEmailsEnabled = false, isLiveboardXLSXCSVDownloadEnabled: isLiveboardXLSXCSVDownloadEnabled = false, isGranularXLSXCSVSchedulesEnabled: isGranularXLSXCSVSchedulesEnabled = false, isCentralizedLiveboardFilterUXEnabled: isCentralizedLiveboardFilterUXEnabled = false, isLinkParametersEnabled: isLinkParametersEnabled, updatedSpotterChatPrompt: updatedSpotterChatPrompt, enableStopAnswerGenerationEmbed: enableStopAnswerGenerationEmbed, spotterChatConfig: spotterChatConfig, minimumHeight: minimumHeight, isThisPeriodInDateFiltersEnabled: isThisPeriodInDateFiltersEnabled, enableHomepageAnnouncement: enableHomepageAnnouncement = false, isContinuousLiveboardPDFEnabled: isContinuousLiveboardPDFEnabled } = this.viewConfig;
        let params = {};
        params[(0, $dV0Ap.Param).PrimaryNavHidden] = !showPrimaryNavbar;
        params[(0, $dV0Ap.Param).HideProfleAndHelp] = !!disableProfileAndHelp;
        params[(0, $dV0Ap.Param).HideApplicationSwitcher] = !!hideApplicationSwitcher;
        params[(0, $dV0Ap.Param).HideOrgSwitcher] = !!hideOrgSwitcher;
        params[(0, $dV0Ap.Param).HideLiveboardHeader] = hideLiveboardHeader;
        params[(0, $dV0Ap.Param).ShowLiveboardTitle] = showLiveboardTitle;
        params[(0, $dV0Ap.Param).ShowLiveboardDescription] = !!showLiveboardDescription;
        params[(0, $dV0Ap.Param).ShowMaskedFilterChip] = showMaskedFilterChip;
        params[(0, $dV0Ap.Param).IsLiveboardMasterpiecesEnabled] = isLiveboardMasterpiecesEnabled;
        params[(0, $dV0Ap.Param).LiveboardHeaderSticky] = isLiveboardHeaderSticky;
        params[(0, $dV0Ap.Param).IsFullAppEmbed] = true;
        params[(0, $dV0Ap.Param).LiveboardHeaderV2] = isLiveboardCompactHeaderEnabled;
        params[(0, $dV0Ap.Param).IsEnhancedFilterInteractivityEnabled] = isEnhancedFilterInteractivityEnabled;
        params[(0, $dV0Ap.Param).ShowLiveboardVerifiedBadge] = showLiveboardVerifiedBadge;
        params[(0, $dV0Ap.Param).ShowLiveboardReverifyBanner] = showLiveboardReverifyBanner;
        params[(0, $dV0Ap.Param).HideIrrelevantFiltersInTab] = hideIrrelevantChipsInLiveboardTabs;
        if (isUnifiedSearchExperienceEnabled !== undefined) params[(0, $dV0Ap.Param).IsUnifiedSearchExperienceEnabled] = isUnifiedSearchExperienceEnabled;
        params[(0, $dV0Ap.Param).CoverAndFilterOptionInPDF] = !!coverAndFilterOptionInPDF;
        params = this.getBaseQueryParams(params);
        if (!(0, $7aJfj.isUndefined)(updatedSpotterChatPrompt)) params[(0, $dV0Ap.Param).UpdatedSpotterChatPrompt] = !!updatedSpotterChatPrompt;
        if (!(0, $7aJfj.isUndefined)(enableStopAnswerGenerationEmbed)) params[(0, $dV0Ap.Param).EnableStopAnswerGenerationEmbed] = !!enableStopAnswerGenerationEmbed;
        // Handle spotterChatConfig params
        if (spotterChatConfig) {
            const { hideToolResponseCardBranding: hideToolResponseCardBranding, toolResponseCardBrandingLabel: toolResponseCardBrandingLabel } = spotterChatConfig;
            (0, $7aJfj.setParamIfDefined)(params, (0, $dV0Ap.Param).HideToolResponseCardBranding, hideToolResponseCardBranding, true);
            (0, $7aJfj.setParamIfDefined)(params, (0, $dV0Ap.Param).ToolResponseCardBrandingLabel, toolResponseCardBrandingLabel);
        }
        if (hideObjectSearch) params[(0, $dV0Ap.Param).HideObjectSearch] = !!hideObjectSearch;
        if (hideHamburger) params[(0, $dV0Ap.Param).HideHamburger] = !!hideHamburger;
        if (hideNotification) params[(0, $dV0Ap.Param).HideNotification] = !!hideNotification;
        if (fullHeight === true) {
            params[(0, $dV0Ap.Param).fullHeight] = true;
            if (this.viewConfig.lazyLoadingForFullHeight) {
                params[(0, $dV0Ap.Param).IsLazyLoadingForEmbedEnabled] = true;
                if ((0, $7aJfj.isValidCssMargin)(this.viewConfig.lazyLoadingMargin)) params[(0, $dV0Ap.Param).RootMarginForLazyLoad] = this.viewConfig.lazyLoadingMargin;
            }
        }
        if (tag) params[(0, $dV0Ap.Param).Tag] = tag;
        if (hideObjects && hideObjects.length) params[(0, $dV0Ap.Param).HideObjects] = JSON.stringify(hideObjects);
        if (liveboardV2 !== undefined) params[(0, $dV0Ap.Param).LiveboardV2Enabled] = liveboardV2;
        if (enableSearchAssist !== undefined) params[(0, $dV0Ap.Param).EnableSearchAssist] = enableSearchAssist;
        if (enable2ColumnLayout !== undefined) params[(0, $dV0Ap.Param).Enable2ColumnLayout] = enable2ColumnLayout;
        if (enableAskSage) params[(0, $dV0Ap.Param).enableAskSage] = enableAskSage;
        if (homePageSearchBarMode) params[(0, $dV0Ap.Param).HomePageSearchBarMode] = homePageSearchBarMode;
        if (enablePendoHelp !== undefined) params[(0, $dV0Ap.Param).EnablePendoHelp] = enablePendoHelp;
        if (isLiveboardStylingAndGroupingEnabled !== undefined) params[(0, $dV0Ap.Param).IsLiveboardStylingAndGroupingEnabled] = isLiveboardStylingAndGroupingEnabled;
        if (isPNGInScheduledEmailsEnabled !== undefined) params[(0, $dV0Ap.Param).isPNGInScheduledEmailsEnabled] = isPNGInScheduledEmailsEnabled;
        if (isLiveboardXLSXCSVDownloadEnabled !== undefined) params[(0, $dV0Ap.Param).isLiveboardXLSXCSVDownloadEnabled] = isLiveboardXLSXCSVDownloadEnabled;
        if (isGranularXLSXCSVSchedulesEnabled !== undefined) params[(0, $dV0Ap.Param).isGranularXLSXCSVSchedulesEnabled] = isGranularXLSXCSVSchedulesEnabled;
        if (hideTagFilterChips !== undefined) params[(0, $dV0Ap.Param).HideTagFilterChips] = hideTagFilterChips;
        if (isLinkParametersEnabled !== undefined) params[(0, $dV0Ap.Param).isLinkParametersEnabled] = isLinkParametersEnabled;
        if (isCentralizedLiveboardFilterUXEnabled != undefined) params[(0, $dV0Ap.Param).isCentralizedLiveboardFilterUXEnabled] = isCentralizedLiveboardFilterUXEnabled;
        if (isThisPeriodInDateFiltersEnabled !== undefined) params[(0, $dV0Ap.Param).IsThisPeriodInDateFiltersEnabled] = isThisPeriodInDateFiltersEnabled;
        if (enableHomepageAnnouncement !== undefined) params[(0, $dV0Ap.Param).EnableHomepageAnnouncement] = enableHomepageAnnouncement;
        if (isContinuousLiveboardPDFEnabled !== undefined) params[(0, $dV0Ap.Param).IsWYSIWYGLiveboardPDFEnabled] = isContinuousLiveboardPDFEnabled;
        this.defaultHeight = minimumHeight || this.defaultHeight;
        params[(0, $dV0Ap.Param).DataPanelV2Enabled] = dataPanelV2;
        params[(0, $dV0Ap.Param).HideHomepageLeftNav] = hideHomepageLeftNav;
        params[(0, $dV0Ap.Param).ModularHomeExperienceEnabled] = modularHomeExperience;
        params[(0, $dV0Ap.Param).CollapseSearchBarInitially] = collapseSearchBarInitially || collapseSearchBar;
        params[(0, $dV0Ap.Param).EnableCustomColumnGroups] = enableCustomColumnGroups;
        if (dataPanelCustomGroupsAccordionInitialState === $e60426d4ba18eebc$export$aadbc8888d90c6a6.COLLAPSE_ALL || dataPanelCustomGroupsAccordionInitialState === $e60426d4ba18eebc$export$aadbc8888d90c6a6.EXPAND_FIRST) params[(0, $dV0Ap.Param).DataPanelCustomGroupsAccordionInitialState] = dataPanelCustomGroupsAccordionInitialState;
        else params[(0, $dV0Ap.Param).DataPanelCustomGroupsAccordionInitialState] = $e60426d4ba18eebc$export$aadbc8888d90c6a6.EXPAND_ALL;
        if (modularHomeExperience !== undefined) params[(0, $dV0Ap.Param).ModularHomeExperienceEnabled] = modularHomeExperience;
        // Set navigation to v2 by default to avoid problems like the app
        // switcher (9-dot menu) not showing when v3 navigation is turned on
        // at the cluster level.
        // To use v3 navigation, we must manually set the discoveryExperience
        // settings.
        params[(0, $dV0Ap.Param).NavigationVersion] = 'v2';
        // Set homePageVersion to v2 by default to reset the LD flag value
        // for the homepageVersion.
        params[(0, $dV0Ap.Param).HomepageVersion] = 'v2';
        if (discoveryExperience) {
            // primaryNavbarVersion v3 will enabled the new left navigation
            if (discoveryExperience.primaryNavbarVersion === $e60426d4ba18eebc$export$4a7dc30b37490b34.Sliding) {
                params[(0, $dV0Ap.Param).NavigationVersion] = discoveryExperience.primaryNavbarVersion;
                // Enable the modularHomeExperience when Sliding is enabled.
                params[(0, $dV0Ap.Param).ModularHomeExperienceEnabled] = true;
            }
            // homePage v2 will enable the modular home page
            // and it will override the modularHomeExperience value
            if (discoveryExperience.homePage === $e60426d4ba18eebc$export$36d69433c4f81145.Modular) params[(0, $dV0Ap.Param).ModularHomeExperienceEnabled] = true;
            // ModularWithStylingChanges (v3) introduces the styling changes
            // to the Modular Homepage.
            // v3 will be the base version of homePageVersion.
            if (discoveryExperience.homePage === $e60426d4ba18eebc$export$36d69433c4f81145.ModularWithStylingChanges) params[(0, $dV0Ap.Param).HomepageVersion] = $e60426d4ba18eebc$export$36d69433c4f81145.ModularWithStylingChanges;
            // listPageVersion can be changed to v2 or v3
            if (discoveryExperience.listPageVersion !== undefined) params[(0, $dV0Ap.Param).ListPageVersion] = discoveryExperience.listPageVersion;
        }
        const queryParams = (0, $7aJfj.getQueryParamString)(params, true);
        return queryParams;
    }
    /**
     * Constructs the URL of the ThoughtSpot app page to be rendered.
     * @param pageId The ID of the page to be embedded.
     */ getIFrameSrc() {
        const { pageId: pageId, path: path, modularHomeExperience: modularHomeExperience } = this.viewConfig;
        const pageRoute = this.formatPath(path) || this.getPageRoute(pageId, modularHomeExperience);
        let url = `${this.getRootIframeSrc()}/${pageRoute}`;
        const tsPostHashParams = this.getThoughtSpotPostUrlParams();
        url = `${url}${tsPostHashParams}`;
        return url;
    }
    /**
     * Gets the ThoughtSpot route of the page for a particular page ID.
     * @param pageId The identifier for a page in the ThoughtSpot app.
     * @param modularHomeExperience
     */ getPageRoute(pageId, modularHomeExperience = false) {
        switch(pageId){
            case $e60426d4ba18eebc$export$6955bcca4cd3539f.Search:
                return 'answer';
            case $e60426d4ba18eebc$export$6955bcca4cd3539f.Answers:
                return modularHomeExperience ? 'home/answers' : 'answers';
            case $e60426d4ba18eebc$export$6955bcca4cd3539f.Liveboards:
                return modularHomeExperience ? 'home/liveboards' : 'pinboards';
            case $e60426d4ba18eebc$export$6955bcca4cd3539f.Pinboards:
                return modularHomeExperience ? 'home/liveboards' : 'pinboards';
            case $e60426d4ba18eebc$export$6955bcca4cd3539f.Data:
                return 'data/tables';
            case $e60426d4ba18eebc$export$6955bcca4cd3539f.SpotIQ:
                return modularHomeExperience ? 'home/spotiq-analysis' : 'insights/results';
            case $e60426d4ba18eebc$export$6955bcca4cd3539f.Monitor:
                return modularHomeExperience ? 'home/monitor-alerts' : 'insights/monitor-alerts';
            case $e60426d4ba18eebc$export$6955bcca4cd3539f.Home:
            default:
                return 'home';
        }
    }
    /**
     * Formats the path provided by the user.
     * @param path The URL path.
     * @returns The URL path that the embedded app understands.
     */ formatPath(path) {
        if (!path) return null;
        // remove leading slash
        if (path.indexOf('/') === 0) return path.substring(1);
        return path;
    }
    /**
     * Navigate to particular page for app embed. eg:answers/pinboards/home
     * This is used for embedding answers, pinboards, visualizations and full application
     * only.
     * @param path string | number The string, set to iframe src and navigate to new page
     * eg: appEmbed.navigateToPage('pinboards')
     * When used with `noReload` (default: true) this can also be a number
     * like 1/-1 to go forward/back.
     * @param noReload boolean Trigger the navigation without reloading the page
     * @version SDK: 1.12.0 | ThoughtSpot: 8.4.0.cl, 8.4.1-sw
     */ navigateToPage(path, noReload = false) {
        if (!this.iFrame) {
            (0, $kCAID.logger).log('Please call render before invoking this method');
            return;
        }
        if (noReload) this.trigger((0, $dV0Ap.HostEvent).Navigate, path);
        else {
            if (typeof path !== 'string') {
                (0, $kCAID.logger).warn('Path can only by a string when triggered without noReload');
                return;
            }
            const iframeSrc = this.iFrame.src;
            const embedPath = '#/embed';
            const currentPath = iframeSrc.includes(embedPath) ? embedPath : '#';
            this.iFrame.src = `${iframeSrc.split(currentPath)[0]}${currentPath}/${path.replace(/^\/?#?\//, '')}`;
        }
    }
    /**
     * Destroys the ThoughtSpot embed, and remove any nodes from the DOM.
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     */ destroy() {
        super.destroy();
        this.unregisterLazyLoadEvents();
    }
    postRender() {
        this.registerLazyLoadEvents();
    }
    registerLazyLoadEvents() {
        if (this.viewConfig.fullHeight && this.viewConfig.lazyLoadingForFullHeight) {
            // TODO: Use passive: true, install modernizr to check for passive
            window.addEventListener('resize', this.sendFullHeightLazyLoadData);
            window.addEventListener('scroll', this.sendFullHeightLazyLoadData, true);
        }
    }
    unregisterLazyLoadEvents() {
        if (this.viewConfig.fullHeight && this.viewConfig.lazyLoadingForFullHeight) {
            window.removeEventListener('resize', this.sendFullHeightLazyLoadData);
            window.removeEventListener('scroll', this.sendFullHeightLazyLoadData);
        }
    }
    /**
     * Renders the embedded application pages in the ThoughtSpot app.
     * @param renderOptions An object containing the page ID
     * to be embedded.
     */ async render() {
        await super.render();
        const src = this.getIFrameSrc();
        await this.renderV1Embed(src);
        this.postRender();
        return this;
    }
}

});
parcelRegister("kCAID", function(module, exports) {

$parcel$export(module.exports, "setGlobalLogLevelOverride", function () { return $f033d6e1f985a09a$export$5eeed73c162713da; });
$parcel$export(module.exports, "logger", function () { return $f033d6e1f985a09a$export$af88d00dbe7f521; });

var $dV0Ap = parcelRequire("dV0Ap");
const $f033d6e1f985a09a$var$logFunctions = {
    [(0, $dV0Ap.LogLevel).SILENT]: ()=>undefined,
    [(0, $dV0Ap.LogLevel).ERROR]: console.error,
    [(0, $dV0Ap.LogLevel).WARN]: console.warn,
    [(0, $dV0Ap.LogLevel).INFO]: console.info,
    [(0, $dV0Ap.LogLevel).DEBUG]: console.debug,
    [(0, $dV0Ap.LogLevel).TRACE]: console.trace
};
let $f033d6e1f985a09a$var$globalLogLevelOverride = (0, $dV0Ap.LogLevel).TRACE;
const $f033d6e1f985a09a$export$5eeed73c162713da = (logLevel)=>{
    $f033d6e1f985a09a$var$globalLogLevelOverride = logLevel;
};
const $f033d6e1f985a09a$var$logLevelToNumber = {
    [(0, $dV0Ap.LogLevel).SILENT]: 0,
    [(0, $dV0Ap.LogLevel).ERROR]: 1,
    [(0, $dV0Ap.LogLevel).WARN]: 2,
    [(0, $dV0Ap.LogLevel).INFO]: 3,
    [(0, $dV0Ap.LogLevel).DEBUG]: 4,
    [(0, $dV0Ap.LogLevel).TRACE]: 5
};
const $f033d6e1f985a09a$var$compareLogLevels = (logLevel1, logLevel2)=>{
    const logLevel1Index = $f033d6e1f985a09a$var$logLevelToNumber[logLevel1];
    const logLevel2Index = $f033d6e1f985a09a$var$logLevelToNumber[logLevel2];
    return logLevel1Index - logLevel2Index;
};
class $f033d6e1f985a09a$var$Logger {
    constructor(){
        this.logLevel = (0, $dV0Ap.LogLevel).ERROR;
        this.setLogLevel = (newLogLevel)=>{
            this.logLevel = newLogLevel;
        };
        this.getLogLevel = ()=>this.logLevel;
    }
    canLog(logLevel) {
        if (logLevel === (0, $dV0Ap.LogLevel).SILENT) return false;
        if ($f033d6e1f985a09a$var$globalLogLevelOverride !== undefined) return $f033d6e1f985a09a$var$compareLogLevels($f033d6e1f985a09a$var$globalLogLevelOverride, logLevel) >= 0;
        return $f033d6e1f985a09a$var$compareLogLevels(this.logLevel, logLevel) >= 0;
    }
    logMessages(args, logLevel) {
        if (this.canLog(logLevel)) {
            const logFn = $f033d6e1f985a09a$var$logFunctions[logLevel];
            if (logFn) logFn(...args);
        }
    }
    log(...args) {
        this.info(args);
    }
    info(...args) {
        this.logMessages(args, (0, $dV0Ap.LogLevel).INFO);
    }
    debug(...args) {
        this.logMessages(args, (0, $dV0Ap.LogLevel).DEBUG);
    }
    trace(...args) {
        this.logMessages(args, (0, $dV0Ap.LogLevel).TRACE);
    }
    error(...args) {
        this.logMessages(args, (0, $dV0Ap.LogLevel).ERROR);
    }
    warn(...args) {
        this.logMessages(args, (0, $dV0Ap.LogLevel).WARN);
    }
}
const $f033d6e1f985a09a$export$af88d00dbe7f521 = new $f033d6e1f985a09a$var$Logger();

});
parcelRegister("dV0Ap", function(module, exports) {

$parcel$export(module.exports, "AuthType", function () { return $a2210daac95811c7$export$e04cb10fd7e39267; });
$parcel$export(module.exports, "EmbedEvent", function () { return $a2210daac95811c7$export$9db453de2db4822; });
$parcel$export(module.exports, "HostEvent", function () { return $a2210daac95811c7$export$2cab83a5627bcd4c; });
$parcel$export(module.exports, "DataSourceVisualMode", function () { return $a2210daac95811c7$export$7a1114f3cd20ec44; });
$parcel$export(module.exports, "Param", function () { return $a2210daac95811c7$export$1ca45c9a47aec42c; });
$parcel$export(module.exports, "Action", function () { return $a2210daac95811c7$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "PrefetchFeatures", function () { return $a2210daac95811c7$export$1892d4005e417d41; });
$parcel$export(module.exports, "ContextMenuTriggerOptions", function () { return $a2210daac95811c7$export$41300f43dfe6060b; });
$parcel$export(module.exports, "CustomActionsPosition", function () { return $a2210daac95811c7$export$ec71f89a7e8d2b23; });
$parcel$export(module.exports, "CustomActionTarget", function () { return $a2210daac95811c7$export$b6339065dcd25647; });
$parcel$export(module.exports, "LogLevel", function () { return $a2210daac95811c7$export$243e62d78d3b544d; });
$parcel$export(module.exports, "ErrorDetailsTypes", function () { return $a2210daac95811c7$export$3afa882655b95cc6; });
$parcel$export(module.exports, "EmbedErrorCodes", function () { return $a2210daac95811c7$export$af552b21ba6cd753; });
$parcel$export(module.exports, "InterceptedApiType", function () { return $a2210daac95811c7$export$b3057738eedd0dc9; });
/**
 * Copyright (c) 2023
 *
 * TypeScript type definitions for ThoughtSpot Visual Embed SDK
 * @summary Type definitions for Embed SDK
 * @author Ayon Ghosh <ayon.ghosh@thoughtspot.com>
 */ /**
 * The authentication mechanism for allowing access to
 * the embedded app
 * @group Authentication / Init
 */ var $a2210daac95811c7$export$e04cb10fd7e39267;
(function(AuthType) {
    /**
     * No authentication on the SDK. Pass-through to the embedded App. Alias for
     * `Passthrough`.
     * @example
     * ```js
     * init({
     *   // ...
     *   authType: AuthType.None,
     *  });
     * ```
     */ AuthType["None"] = "None";
    /**
     * Passthrough SSO to the embedded application within the iframe. Requires least
     * configuration, but may not be supported by all IDPs. This will behave like `None`
     * if SSO is not configured on ThoughtSpot.
     *
     * To use this:
     * Your SAML or OpenID provider must allow iframe redirects.
     * For example, if you are using Okta as IdP, you can enable iframe embedding.
     * @version SDK: 1.15.0 | ThoughtSpot: 8.8.0.cl
     * @example
     * ```js
     * init({
     *   // ...
     *   authType: AuthType.EmbeddedSSO,
     *  });
     * ```
     */ AuthType["EmbeddedSSO"] = "EmbeddedSSO";
    /**
     * SSO using SAML, Use {@link SAMLRedirect} instead
     * @deprecated This option is deprecated.
     * @hidden
     */ AuthType["SSO"] = "SSO_SAML";
    /**
     * SSO using SAML, Use {@link SAMLRedirect} instead
     * @deprecated This option is deprecated.
     * @hidden
     */ // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    AuthType["SAML"] = "SSO_SAML";
    /**
     * SSO using SAML
     * Makes the host application redirect to the SAML IdP. Use this
     * if your IdP does not allow itself to be embedded.
     *
     * This redirects the host application to the SAML IdP. The host application
     * will be redirected back to the ThoughtSpot app after authentication.
     * @example
     * ```js
     * init({
     *   // ...
     *   authType: AuthType.SAMLRedirect,
     *  });
     * ```
     *
     * This opens the SAML IdP in a popup window. The popup is triggered
     * when the user clicks the trigger button. The popup window will be
     * closed automatically after authentication.
     * @example
     * ```js
     * init({
     *   // ...
     *   authType: AuthType.SAMLRedirect,
     *   authTriggerText: 'Login with SAML',
     *   authTriggerContainer: '#tsEmbed',
     *   inPopup: true,
     * });
     * ```
     *
     * Can also use the event to trigger the popup flow. Works the same
     * as the above example.
     * @example
     * ```js
     * const authEE = init({
     *  // ...
     *  authType: AuthType.SAMLRedirect,
     *  inPopup: true,
     * });
     *
     * someButtonOnYourPage.addEventListener('click', () => {
     *  authEE.emit(AuthEvent.TRIGGER_SSO_POPUP);
     * });
     * ```
     */ // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    AuthType["SAMLRedirect"] = "SSO_SAML";
    /**
     * SSO using OIDC
     * SSO using OIDC, Use {@link OIDCRedirect} instead
     * @deprecated This option is deprecated.
     * @hidden
     */ AuthType["OIDC"] = "SSO_OIDC";
    /**
     * SSO using OIDC
     * Will make the host application redirect to the OIDC IdP.
     * See code samples in {@link SAMLRedirect}.
     */ // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    AuthType["OIDCRedirect"] = "SSO_OIDC";
    /**
     * Trusted authentication server
     * Use {@link TrustedAuth} instead
     * @deprecated This option is deprecated.
     * @hidden
     */ AuthType["AuthServer"] = "AuthServer";
    /**
     * Trusted authentication server. Use your own authentication server
     * which returns a bearer token, generated using the `secret_key` obtained
     * from ThoughtSpot.
     * @example
     * ```js
     * init({
     *  // ...
     *  authType: AuthType.TrustedAuthToken,
     *  getAuthToken: () => {
     *    return fetch('https://my-backend.app/ts-token')
     *      .then((response) => response.json())
     *      .then((data) => data.token);
     *  }
     * });
     * ```
     */ // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    AuthType["TrustedAuthToken"] = "AuthServer";
    /**
     * Trusted authentication server Cookieless, Use your own authentication
     * server which returns a bearer token, generated using the `secret_key`
     * obtained from ThoughtSpot. This uses a cookieless authentication
     * approach, recommended to bypass the third-party cookie-blocking restriction
     * implemented by some browsers.
     * @version SDK: 1.22.0 | ThoughtSpot: 9.3.0.cl, 9.5.1.sw
     * @example
     * ```js
     * init({
     *  // ...
     *  authType: AuthType.TrustedAuthTokenCookieless,
     *  getAuthToken: () => {
     *    return fetch('https://my-backend.app/ts-token')
     *      .then((response) => response.json())
     *      .then((data) => data.token);
     *  }
     * });
     * ```
     */ AuthType["TrustedAuthTokenCookieless"] = "AuthServerCookieless";
    /**
     * Use the ThoughtSpot login API to authenticate to the cluster directly.
     *
     * Warning: This feature is primarily intended for developer testing. It is
     * strongly advised not to use this authentication method in production.
     */ AuthType["Basic"] = "Basic";
})($a2210daac95811c7$export$e04cb10fd7e39267 || ($a2210daac95811c7$export$e04cb10fd7e39267 = {}));
var $a2210daac95811c7$export$db7fdfc82561d938;
(function(HomeLeftNavItem) {
    /**
     * The *Search data* option in
     * the *Insights* left navigation panel.
     * @version SDK: 1.28.0 | ThoughtSpot: 9.12.5.cl
     */ HomeLeftNavItem["SearchData"] = "search-data";
    /**
     * The *Home* menu option in
     * the *Insights* left navigation panel.
     * @version SDK: 1.28.0 | ThoughtSpot: 9.12.5.cl
     */ HomeLeftNavItem["Home"] = "insights-home";
    /**
     * The *Liveboards* menu option in
     * the *Insights* left navigation panel.
     * @version SDK: 1.28.0 | ThoughtSpot: 9.12.5.cl
     */ HomeLeftNavItem["Liveboards"] = "liveboards";
    /**
     * The *Answers* menu option in
     * the *Insights* left navigation panel.
     * @version SDK: 1.28.0 | ThoughtSpot: 9.12.5.cl
     */ HomeLeftNavItem["Answers"] = "answers";
    /**
     * The *Monitor subscriptions* menu option in
     * the *Insights* left navigation panel.
     * @version SDK: 1.28.0 | ThoughtSpot: 9.12.5.cl
     */ HomeLeftNavItem["MonitorSubscription"] = "monitor-alerts";
    /**
     * The *SpotIQ analysis* menu option in
     * the *Insights* left navigation panel.
     * @version SDK: 1.28.0 | ThoughtSpot: 9.12.5.cl
     */ HomeLeftNavItem["SpotIQAnalysis"] = "spotiq-analysis";
    /**
     * The *Liveboard schedules* menu option in
     * the *Insights* left navigation panel.
     * @version SDK: 1.34.0 | ThoughtSpot: 10.3.0.cl
     */ HomeLeftNavItem["LiveboardSchedules"] = "liveboard-schedules";
    /**
     * The create option in the *Insights*
     * left navigation panel.
     * Available in the V3 navigation experience.
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HomeLeftNavItem["Create"] = "create";
    /**
     * The *Spotter* menu option in the *Insights*
     * left navigation panel.
     * Available in the V3 navigation experience.
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HomeLeftNavItem["Spotter"] = "spotter";
    /**
     * The *Favorites* section in the *Insights*
     * left navigation panel.
     * Available in the V3 navigation experience.
     * @version SDK: 1.41.0 | ThoughtSpot: 10.12.0.cl
     */ HomeLeftNavItem["Favorites"] = "favorites";
})($a2210daac95811c7$export$db7fdfc82561d938 || ($a2210daac95811c7$export$db7fdfc82561d938 = {}));
var $a2210daac95811c7$export$ffde8c71143a52d0;
(function(RuntimeFilterOp) {
    /**
     * Equals
     */ RuntimeFilterOp["EQ"] = "EQ";
    /**
     * Does not equal
     */ RuntimeFilterOp["NE"] = "NE";
    /**
     * Less than
     */ RuntimeFilterOp["LT"] = "LT";
    /**
     * Less than or equal to
     */ RuntimeFilterOp["LE"] = "LE";
    /**
     * Greater than
     */ RuntimeFilterOp["GT"] = "GT";
    /**
     * Greater than or equal to
     */ RuntimeFilterOp["GE"] = "GE";
    /**
     * Contains
     */ RuntimeFilterOp["CONTAINS"] = "CONTAINS";
    /**
     * Begins with
     */ RuntimeFilterOp["BEGINS_WITH"] = "BEGINS_WITH";
    /**
     * Ends with
     */ RuntimeFilterOp["ENDS_WITH"] = "ENDS_WITH";
    /**
     * Between, inclusive of higher value
     */ RuntimeFilterOp["BW_INC_MAX"] = "BW_INC_MAX";
    /**
     * Between, inclusive of lower value
     */ RuntimeFilterOp["BW_INC_MIN"] = "BW_INC_MIN";
    /**
     * Between, inclusive of both higher and lower value
     */ RuntimeFilterOp["BW_INC"] = "BW_INC";
    /**
     * Between, non-inclusive
     */ RuntimeFilterOp["BW"] = "BW";
    /**
     * Is included in this list of values
     */ RuntimeFilterOp["IN"] = "IN";
    /**
     * Is not included in this list of values
     */ RuntimeFilterOp["NOT_IN"] = "NOT_IN";
})($a2210daac95811c7$export$ffde8c71143a52d0 || ($a2210daac95811c7$export$ffde8c71143a52d0 = {}));
var $a2210daac95811c7$export$4e1fb1b01c4acc16;
(function(HomepageModule) {
    /**
     * Search bar
     */ HomepageModule["Search"] = "SEARCH";
    /**
     * KPI watchlist module
     */ HomepageModule["Watchlist"] = "WATCHLIST";
    /**
     * Favorite module
     */ HomepageModule["Favorite"] = "FAVORITE";
    /**
     * List of answers and Liveboards
     */ HomepageModule["MyLibrary"] = "MY_LIBRARY";
    /**
     * Trending list
     */ HomepageModule["Trending"] = "TRENDING";
    /**
     * Learning videos
     */ HomepageModule["Learning"] = "LEARNING";
})($a2210daac95811c7$export$4e1fb1b01c4acc16 || ($a2210daac95811c7$export$4e1fb1b01c4acc16 = {}));
var $a2210daac95811c7$export$1563cf044d23de27;
(function(ListPageColumns) {
    /**
     * Favorites
     */ ListPageColumns["Favorites"] = "FAVOURITE";
    /**
     * Favourite Use {@link ListPageColumns.Favorites} instead.
     * @deprecated This option is deprecated.
     */ ListPageColumns["Favourite"] = "FAVOURITE";
    /**
     * Tags
     */ ListPageColumns["Tags"] = "TAGS";
    /**
     * Author
     */ ListPageColumns["Author"] = "AUTHOR";
    /**
     * Last viewed/Last modified
     */ ListPageColumns["DateSort"] = "DATE_SORT";
    /**
     * Share
     */ ListPageColumns["Share"] = "SHARE";
    /**
     * Verified badge/column
     */ ListPageColumns["Verified"] = "VERIFIED";
})($a2210daac95811c7$export$1563cf044d23de27 || ($a2210daac95811c7$export$1563cf044d23de27 = {}));
var $a2210daac95811c7$export$9db453de2db4822;
(function(EmbedEvent) {
    /**
     * Rendering has initialized.
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Init, showLoader)
     *  //show a loader
     * function showLoader() {
     * document.getElementById("loader");
     * }
     * ```
     * @returns timestamp - The timestamp when the event was generated.
     */ EmbedEvent["Init"] = "init";
    /**
     * Authentication has either succeeded or failed.
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.AuthInit, payload => {
     *    console.log('AuthInit', payload);
     * })
     * ```
     * @returns isLoggedIn - A Boolean specifying whether authentication was successful.
     */ EmbedEvent["AuthInit"] = "authInit";
    /**
     * The embed object container has loaded.
     * @returns timestamp - The timestamp when the event was generated.
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 8.4.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Load, hideLoader)
     *    //hide loader
     * function hideLoader() {
     *   document.getElementById("loader");
     * }
     * ```
     */ EmbedEvent["Load"] = "load";
    /**
     * Data pertaining to an Answer, Liveboard or Spotter visualization is received.
     * The event payload includes the raw data of the object.
     * @return data -  Answer of Liveboard data
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 8.4.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Data, payload => {
     *    console.log('data', payload);
     * })
     * ```
     * @important
     */ EmbedEvent["Data"] = "data";
    /**
     * Search query has been updated by the user.
     * @version SDK: 1.4.0 | ThoughtSpot: ts7.sep.cl, 8.4.1.sw
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.QueryChanged, payload => console.log('data', payload))
     * ```
     */ EmbedEvent["QueryChanged"] = "queryChanged";
    /**
     * A drill-down operation has been performed.
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 8.4.1.sw
     * @returns additionalFilters - Any additional filters applied
     * @returns drillDownColumns - The columns on which drill down was performed
     * @returns nonFilteredColumns - The columns that were not filtered
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.DrillDown, {
     *    points: {
     *        clickedPoint,
     *        selectedPoints: selectedPoint
     *    },
     *    autoDrillDown: true,
     * })
     * ```
     * In this example, `VizPointDoubleClick` event is used for
     * triggering the `DrillDown` event when an area or specific
     * data point on a table or chart is double-clicked.
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.VizPointDoubleClick, (payload) => {
     *   console.log(payload);
     *   const clickedPoint = payload.data.clickedPoint;
     *   const selectedPoint = payload.data.selectedPoints;
     *   console.log('>>> called', clickedPoint);
     *   embed.trigger(HostEvent.DrillDown, {
     *      points: {
     *      clickedPoint,
     *          selectedPoints: selectedPoint
     *     },
     *   autoDrillDown: true,
     *     })
     * })
     * ```
     */ EmbedEvent["Drilldown"] = "drillDown";
    /**
     * One or more data sources have been selected.
     * @returns dataSourceIds - the list of data sources
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 8.4.1.sw
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.DataSourceSelected, payload => {
     *    console.log('DataSourceSelected', payload);
     * })
     * ```
     */ EmbedEvent["DataSourceSelected"] = "dataSourceSelected";
    /**
     * One or more data columns have been selected.
     * @returns columnIds - the list of columns
     * @version SDK: 1.10.0 | ThoughtSpot: 8.2.0.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.AddRemoveColumns, payload => {
     *   console.log('AddRemoveColumns', payload);
     * })
     * ```
     */ EmbedEvent["AddRemoveColumns"] = "addRemoveColumns";
    /**
     * A custom action has been triggered.
     * @returns actionId - ID of the custom action
     * @returns payload {@link CustomActionPayload} - Response payload with the
     * Answer or Liveboard data
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.customAction, payload => {
     *     const data = payload.data;
     *     if (data.id === 'insert Custom Action ID here') {
     *         console.log('Custom Action event:', data.embedAnswerData);
     *     }
     * })
     * ```
     */ EmbedEvent["CustomAction"] = "customAction";
    /**
     * Listen to double click actions on a visualization.
     * @return ContextMenuInputPoints - Data point that is double-clicked
     * @version SDK: 1.5.0 | ThoughtSpot: ts7.oct.cl, 7.2.1
     * @example
     * ```js
     * LiveboardEmbed.on(EmbedEvent.VizPointDoubleClick, payload => {
     *      console.log('VizPointDoubleClick', payload);
     * })
     * ```
     */ EmbedEvent["VizPointDoubleClick"] = "vizPointDoubleClick";
    /**
     * Listen to clicks on a visualization in a Liveboard or Search result.
     * @return viz, clickedPoint - metadata about the point that is clicked
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @important
     * @example
     * ```js
     * embed.on(EmbedEvent.VizPointClick, ({data}) => {
     *   console.log(
     *    data.vizId, // viz id
     *    data.clickedPoint.selectedAttributes[0].value,
     *    data.clickedPoint.selectedAttributes[0].column.name,
     *    data.clickedPoint.selectedMeasures[0].value,
     *    data.clickedPoint.selectedMeasures[0].column.name,
     *   )
     * });
     * ```
     */ EmbedEvent["VizPointClick"] = "vizPointClick";
    /**
     * An error has occurred. This event is fired for the following error types:
     *
     * `API` - API call failure.
     * `FULLSCREEN` - Error when presenting a Liveboard or visualization in full screen
     * mode. `SINGLE_VALUE_FILTER` - Error due to multiple values in the single value
     * filter. `NON_EXIST_FILTER` - Error due to a non-existent filter.
     * `INVALID_DATE_VALUE` - Invalid date value error.
     * `INVALID_OPERATOR` - Use of invalid operator during filter application.
     *
     * For more information, see https://developers.thoughtspot.com/docs/events-app-integration#errorType
     * @returns error - An error object or message
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 8.4.1.sw
     * @example
     * ```js
     * // API error
     * SearchEmbed.on(EmbedEvent.Error, (error) => {
     *   console.log(error);
     *  // { type: "Error", data: { errorType: "API", error: { message: '...', error: '...' } } }
     *  // { errorType: "API", message: '...', code: '...' } new format
     * });
     * ```
     * @example
     * ```js
     * // Fullscreen error (Errors during presenting of a liveboard)
     * LiveboardEmbed.on(EmbedEvent.Error, (error) => {
     *   console.log(error);
     *   // { type: "Error", data: { errorType: "FULLSCREEN", error: {
     *   //   message: "Fullscreen API is not enabled",
     *   //   stack: "..."
     *   // } }}
     *   // { errorType: "FULLSCREEN", message: "Fullscreen API is not enabled", code: '...' } new format
     * })
     * ```
     */ EmbedEvent["Error"] = "Error";
    /**
     * The embedded object has sent an alert.
     * @returns alert - An alert object
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 8.4.1.sw
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.Alert)
     * ```
     */ EmbedEvent["Alert"] = "alert";
    /**
     * The ThoughtSpot authentication session has expired.
     * @version SDK: 1.4.0 | ThoughtSpot: ts7.sep.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.AuthExpire, showAuthExpired)
     * //show auth expired banner
     * function showAuthExpired() {
     *    document.getElementById("authExpiredBanner");
     * }
     * ```
     */ EmbedEvent["AuthExpire"] = "ThoughtspotAuthExpired";
    /**
     * ThoughtSpot failed to validate the auth session.
     * @hidden
     */ EmbedEvent["AuthFailure"] = "ThoughtspotAuthFailure";
    /**
     * ThoughtSpot failed to re validate the auth session.
     * @hidden
     */ EmbedEvent["IdleSessionTimeout"] = "IdleSessionTimeout";
    /**
     * ThoughtSpot failed to validate the auth session.
     * @hidden
     */ EmbedEvent["AuthLogout"] = "ThoughtspotAuthLogout";
    /**
     * The height of the embedded Liveboard or visualization has been computed.
     * @returns data - The height of the embedded Liveboard or visualization
     * @hidden
     */ EmbedEvent["EmbedHeight"] = "EMBED_HEIGHT";
    /**
     * The center of visible iframe viewport is calculated.
     * @returns data - The center of the visible Iframe viewport.
     * @hidden
     */ EmbedEvent["EmbedIframeCenter"] = "EmbedIframeCenter";
    /**
     * Emitted when the **Get Data** action is initiated.
     * Applicable to `SearchBarEmbed` only.
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     * @example
     * ```js
     * searchbarEmbed.on(EmbedEvent.GetDataClick)
     *  .then(data => {
     *  console.log('Answer Data:', data);
     * })
     * ```
     */ EmbedEvent["GetDataClick"] = "getDataClick";
    /**
     * Detects the route change.
     * @version SDK: 1.7.0 | ThoughtSpot: 8.0.0.cl, 8.4.1.sw
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.RouteChange, payload =>
     *    console.log('data', payload))
     * ```
     */ EmbedEvent["RouteChange"] = "ROUTE_CHANGE";
    /**
     * The v1 event type for Data
     * @hidden
     */ EmbedEvent["V1Data"] = "exportVizDataToParent";
    /**
     * Emitted when the embed does not have cookie access. This happens
     * when third-party cookies are blocked by Safari or other
     * web browsers. `NoCookieAccess` can trigger.
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.NoCookieAccess)
     * ```
     * @version SDK: 1.1.0 | ThoughtSpot: ts7.may.cl, 7.2.1.sw
     */ EmbedEvent["NoCookieAccess"] = "noCookieAccess";
    /**
     * Emitted when SAML is complete
     * @private
     * @hidden
     */ EmbedEvent["SAMLComplete"] = "samlComplete";
    /**
     * Emitted when any modal is opened in the app
     * @version SDK: 1.6.0 | ThoughtSpot: ts8.nov.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.DialogOpen, payload => {
     *    console.log('dialog open', payload);
     *  })
     * ```
     */ EmbedEvent["DialogOpen"] = "dialog-open";
    /**
     * Emitted when any modal is closed in the app
     * @version SDK: 1.6.0 | ThoughtSpot: ts8.nov.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.DialogClose, payload => {
     *     console.log('dialog close', payload);
     * })
     * ```
     */ EmbedEvent["DialogClose"] = "dialog-close";
    /**
     * Emitted when the Liveboard shell loads.
     * You can use this event as a hook to trigger
     * other events on the rendered Liveboard.
     * @version SDK: 1.9.1 | ThoughtSpot: 8.1.0.cl, 8.4.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.LiveboardRendered, payload => {
           console.log('Liveboard is rendered', payload);
       })
     * ```
     * The following example shows how to trigger
     * `SetVisibleVizs` event using LiveboardRendered embed event:
     * @example
     * ```js
     * const embedRef = useEmbedRef();
     * const onLiveboardRendered = () => {
     * embed.trigger(HostEvent.SetVisibleVizs, ['viz1', 'viz2']);
     * };
     * ```
     */ EmbedEvent["LiveboardRendered"] = "PinboardRendered";
    /**
     * Emits all events.
     * @version SDK: 1.10.0 | ThoughtSpot: 8.2.0.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.ALL, payload => {
     *  console.log('Embed Events', payload)
     * })
     * ```
     */ EmbedEvent["ALL"] = "*";
    /**
     * Emitted when an Answer is saved in the app.
     * Use start:true to subscribe to when save is initiated, or end:true to subscribe to when save is completed. Default is end:true.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //Emit when action starts
     *  searchEmbed.on(EmbedEvent.Save, payload => {
     *    console.log('Save', payload)
     *  }, {
     *    start: true
     * })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.Save, payload => {
     *    console.log('Save', payload)
     * })
     * ```
     */ EmbedEvent["Save"] = "save";
    /**
     * Emitted when the download action is triggered on an Answer.
     *
     * **Note**: This event is deprecated in v1.21.0.
     * To fire an event when a download action is initiated on a chart or table,
     * use `EmbedEvent.DownloadAsPng`, `EmbedEvent.DownloadAsPDF`,
     * `EmbedEvent.DownloadAsCSV`, or `EmbedEvent.DownloadAsXLSX`
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Download, {
     * vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * })
     * ```
     */ EmbedEvent["Download"] = "download";
    /**
     * Emitted when the download action is triggered on an Answer.
     *  Use start:true to subscribe to when download is initiated, or end:true to
     *  subscribe to when download is completed. Default is end:true.
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.4.0.sw
     * @example
     * ```js
     * //emit when action starts
     * searchEmbed.on(EmbedEvent.DownloadAsPng, payload => {
     *   console.log('download PNG', payload)}, {start: true })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.DownloadAsPng, payload => {
     *   console.log('download PNG', payload)})
     * ```
     */ EmbedEvent["DownloadAsPng"] = "downloadAsPng";
    /**
     * Emitted when the Download as PDF action is triggered on an Answer
     *  Use start:true to subscribe to when download as PDF is initiated, or end:true to
     *  subscribe to when download as PDF is completed. Default is end:true.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * searchEmbed.on(EmbedEvent.DownloadAsPdf, payload => {
     *   console.log('download PDF', payload)}, {start: true })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.DownloadAsPdf, payload => {
     *   console.log('download PDF', payload)})
     * ```
     */ EmbedEvent["DownloadAsPdf"] = "downloadAsPdf";
    /**
     * Emitted when the Download as CSV action is triggered on an Answer.
     *  Use start:true to subscribe to when download as CSV is initiated, or end:true to
     *  subscribe to when download as CSV is completed. Default is end:true.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * searchEmbed.on(EmbedEvent.DownloadAsCSV, payload => {
     *   console.log('download CSV', payload)}, {start: true })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.DownloadAsCSV, payload => {
     *    console.log('download CSV', payload)})
     * ```
     */ EmbedEvent["DownloadAsCsv"] = "downloadAsCsv";
    /**
     * Emitted when the Download as XLSX action is triggered on an Answer.
     *  Use start:true to subscribe to when download as XLSX is initiated, or end:true to
     *  subscribe to when download as XLSX is completed. Default is end:true.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * searchEmbed.on(EmbedEvent.DownloadAsXlsx, payload => {
     *   console.log('download Xlsx', payload)}, { start: true })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.DownloadAsXlsx, payload => {
     *   console.log('download Xlsx', payload)})
     * ```
     */ EmbedEvent["DownloadAsXlsx"] = "downloadAsXlsx";
    /**
     * Emitted when the Download Liveboard as Continuous PDF action is triggered
     * on a Liveboard.
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.DownloadLiveboardAsContinuousPDF, payload => {
     *   console.log('download liveboard as continuous PDF', payload)})
     * ```
     */ EmbedEvent["DownloadLiveboardAsContinuousPDF"] = "downloadLiveboardAsContinuousPDF";
    /**
     * Emitted when an Answer is deleted in the app
     *  Use start:true to subscribe to when delete is initiated, or end:true to subscribe
     *  to when delete is completed. Default is end:true.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * appEmbed.on(EmbedEvent.AnswerDelete, payload => {
     *    console.log('delete answer', payload)}, {start: true })
     * //trigger when action is completed
     * appEmbed.on(EmbedEvent.AnswerDelete, payload => {
     *    console.log('delete answer', payload)})
     * ```
     */ EmbedEvent["AnswerDelete"] = "answerDelete";
    /**
     * Emitted when the AI Highlights action is triggered on a Liveboard
     * @version SDK: 1.44.0 | ThoughtSpot: 10.15.0.cl
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.AIHighlights, (payload) => {
     *   console.log('AI Highlights', payload);
     * })
     * ```
     */ EmbedEvent["AIHighlights"] = "AIHighlights";
    /**
     * Emitted when a user initiates the Pin action to
     *  add an Answer to a Liveboard.
     *  Use start:true to subscribe to when pin is initiated, or end:true to subscribe to
     *  when pin is completed. Default is end:true.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * searchEmbed.on(EmbedEvent.Pin, payload => {
     *    console.log('pin', payload)
     * }, {
     * start: true
     * })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.Pin, payload => {
     *    console.log('pin', payload)
     * })
     * ```
     */ EmbedEvent["Pin"] = "pin";
    /**
     * Emitted when SpotIQ analysis is triggered
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * searchEmbed.on(EmbedEvent.SpotIQAnalyze, payload => {
     *   console.log('SpotIQAnalyze', payload)
     * }, {
     * start: true
     * })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.SpotIQAnalyze, payload => {
     *   console.log('SpotIQ analyze', payload)
     * })
     * ```
     */ EmbedEvent["SpotIQAnalyze"] = "spotIQAnalyze";
    /**
     * Emitted when a user shares an object with another user or group
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * searchEmbed.on(EmbedEvent.Share, payload => {
     *    console.log('Share', payload)
     * }, {
     * start: true
     * })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.Share, payload => {
     *   console.log('Share', payload)
     * })
     * ```
     */ EmbedEvent["Share"] = "share";
    /**
     * Emitted when a user clicks the **Include** action to include a specific value or
     * data on a chart or table.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.DrillInclude, payload => {
     *    console.log('Drill include', payload);
     * })
     * ```
     */ EmbedEvent["DrillInclude"] = "context-menu-item-include";
    /**
     * Emitted when a user clicks the **Exclude** action to exclude a specific value or
     * data on a chart or table
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.DrillExclude, payload => {
     *     console.log('Drill exclude', payload);
     * })
     * ```
     */ EmbedEvent["DrillExclude"] = "context-menu-item-exclude";
    /**
     * Emitted when a column value is copied in the embedded app.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.CopyToClipboard, payload => {
     *    console.log('copy to clipboard', payload);
     * })
     * ```
     */ EmbedEvent["CopyToClipboard"] = "context-menu-item-copy-to-clipboard";
    /**
     * Emitted when a user clicks the **Update TML** action on
     * embedded Liveboard.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.UpdateTML)
     * })
     * ```
     */ EmbedEvent["UpdateTML"] = "updateTSL";
    /**
     * Emitted when a user clicks the **Edit TML** action
     * on an embedded Liveboard.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.EditTML, payload => {
     *    console.log('Edit TML', payload);
     * })
     * ```
     */ EmbedEvent["EditTML"] = "editTSL";
    /**
     * Emitted when the **Export TML** action is triggered on an
     * an embedded object in the app
     *  Use start:true to subscribe to when export is initiated, or end:true to subscribe
     *  to when export is completed. Default is end:true.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * searchEmbed.on(EmbedEvent.ExportTML, payload => {
     *     console.log('Export TML', payload)}, { start: true })
     * //emit when action ends
     * searchEmbed.on(EmbedEvent.ExportTML, payload => {
     *     console.log('Export TML', payload)})
     * ```
     */ EmbedEvent["ExportTML"] = "exportTSL";
    /**
     * Emitted when an Answer is saved as a View.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.SaveAsView, payload => {
     *    console.log('View', payload);
     * })
     * ```
     */ EmbedEvent["SaveAsView"] = "saveAsView";
    /**
     * Emitted when the user creates a copy of an Answer.
     *  Use start:true to subscribe to when copy and edit is initiated, or end:true to
     *  subscribe to when copy and edit is completed. Default is end:true.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * //emit when action starts
     * appEmbed.on(EmbedEvent.CopyAEdit, payload => {
     *    console.log('Copy and edit', payload)}, {start: true })
     * //emit when action ends
     * appEmbed.on(EmbedEvent.CopyAEdit, payload => {
     *    console.log('Copy and edit', payload)})
     * ```
     */ EmbedEvent["CopyAEdit"] = "copyAEdit";
    /**
     * Emitted when a user clicks *Show underlying data* on an Answer.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.ShowUnderlyingData, payload => {
     *    console.log('show data', payload);
     * })
     * ```
     */ EmbedEvent["ShowUnderlyingData"] = "showUnderlyingData";
    /**
     * Emitted when an Answer is switched to a chart or table view.
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.AnswerChartSwitcher, payload => {
     *    console.log('switch view', payload);
     * })
     * ```
     */ EmbedEvent["AnswerChartSwitcher"] = "answerChartSwitcher";
    /**
     * Internal event to communicate the initial settings back to the ThoughtSpot app
     * @hidden
     */ EmbedEvent["APP_INIT"] = "appInit";
    /**
     * Internal event to clear the cached info
     * @hidden
     */ EmbedEvent["CLEAR_INFO_CACHE"] = "clearInfoCache";
    /**
     * Emitted when a user clicks **Show Liveboard details** on a Liveboard
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.LiveboardInfo, payload => {
     *    console.log('Liveboard details', payload);
     * })
     * ```
     */ EmbedEvent["LiveboardInfo"] = "pinboardInfo";
    /**
     * Emitted when a user clicks on the Favorite icon on a Liveboard
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.AddToFavorites, payload => {
     *    console.log('favorites', payload);
     * })
     * ```
     */ EmbedEvent["AddToFavorites"] = "addToFavorites";
    /**
     * Emitted when a user clicks **Schedule** on a Liveboard
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Schedule, payload => {
     *    console.log('Liveboard schedule', payload);
     * })
     * ```
     */ EmbedEvent["Schedule"] = "subscription";
    /**
     * Emitted when a user clicks **Edit** on a Liveboard or visualization
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Edit, payload => {
     *    console.log('Liveboard edit', payload);
     * })
     * ```
     */ EmbedEvent["Edit"] = "edit";
    /**
     * Emitted when a user clicks *Make a copy* on a Liveboard
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.MakeACopy, payload => {
     *    console.log('Copy', payload);
     * })
     * ```
     */ EmbedEvent["MakeACopy"] = "makeACopy";
    /**
     * Emitted when a user clicks **Present** on a Liveboard or visualization
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Present)
     * ```
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Present, {
     *   vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * })
     * ```
     */ EmbedEvent["Present"] = "present";
    /**
     * Emitted when a user clicks **Delete** on a visualization
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Delete,
     *   {vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     */ EmbedEvent["Delete"] = "delete";
    /**
     * Emitted when a user clicks Manage schedules on a Liveboard
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.SchedulesList)
     * ```
     */ EmbedEvent["SchedulesList"] = "schedule-list";
    /**
     * Emitted when a user clicks **Cancel** in edit mode on a Liveboard
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Cancel)
     * ```
     */ EmbedEvent["Cancel"] = "cancel";
    /**
     * Emitted when a user clicks **Explore** on a visualization
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.Explore,  {
     *   vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     */ EmbedEvent["Explore"] = "explore";
    /**
     * Emitted when a user clicks **Copy link** action on a visualization.
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.CopyLink, {
     *   vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     */ EmbedEvent["CopyLink"] = "embedDocument";
    /**
     * Emitted when a user interacts with cross filters on a
     * visualization or Liveboard.
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.0.sw
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.CrossFilterChanged, {
     *    vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     */ EmbedEvent["CrossFilterChanged"] = "cross-filter-changed";
    /**
     * Emitted when a user right clicks on a visualization (chart or table)
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.0.sw
     * @example
     * ```js
     * LiveboardEmbed.on(EmbedEvent.VizPointRightClick, payload => {
     *    console.log('VizPointClick', payload)
     * })
     * ```
     */ EmbedEvent["VizPointRightClick"] = "vizPointRightClick";
    /**
     * Emitted when a user clicks **Insert to slide** on a visualization
     * @hidden
     */ EmbedEvent["InsertIntoSlide"] = "insertInToSlide";
    /**
     * Emitted when a user changes any filter on a Liveboard.
     * Returns filter type and name, column name and ID, and runtime
     * filter details.
     * @example
     *
     * ```js
     * LiveboardEmbed.on(EmbedEvent.FilterChanged, (payload) => {
     *    console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.23.0 | ThoughtSpot: 9.4.0.cl, 9.5.0.sw
     */ EmbedEvent["FilterChanged"] = "filterChanged";
    /**
     * Emitted when a user updates a connection on the **Data** page
     * @version SDK: 1.27.0 | ThoughtSpot: 9.8.0.cl, 9.8.0.sw
     */ EmbedEvent["UpdateConnection"] = "updateConnection";
    /**
     * Emitted when a user updates a connection on the **Data** page
     * @version SDK: 1.27.0 | ThoughtSpot: 9.8.0.cl, 9.8.0.sw
     */ EmbedEvent["CreateConnection"] = "createConnection";
    /**
     * Emitted when name, status (private or public) or filter values of a
     * Personalised view is updated.
     * This event is deprecated. Use {@link EmbedEvent.UpdatePersonalizedView} instead.
     * @returns viewName: string
     * @returns viewId: string
     * @returns liveboardId: string
     * @returns isPublic: boolean
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 9.8.0.sw
     * @deprecated SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ EmbedEvent["UpdatePersonalisedView"] = "updatePersonalisedView";
    /**
     * Emitted when name, status (private or public) or filter values of a
     * Personalized view is updated.
     * @returns viewName: string
     * @returns viewId: string
     * @returns liveboardId: string
     * @returns isPublic: boolean
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ EmbedEvent["UpdatePersonalizedView"] = "updatePersonalisedView";
    /**
     * Emitted when a Personalised view is saved.
     * This event is deprecated. Use {@link EmbedEvent.SavePersonalizedView} instead.
     * @returns viewName: string
     * @returns viewId: string
     * @returns liveboardId: string
     * @returns isPublic: boolean
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 9.8.0.sw
     * @deprecated SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ EmbedEvent["SavePersonalisedView"] = "savePersonalisedView";
    /**
     * Emitted when a Personalized view is saved.
     * @returns viewName: string
     * @returns viewId: string
     * @returns liveboardId: string
     * @returns isPublic: boolean
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ EmbedEvent["SavePersonalizedView"] = "savePersonalisedView";
    /**
     * Emitted when a Liveboard is reset.
     * @returns viewName: string
     * @returns viewId: string
     * @returns liveboardId: string
     * @returns isPublic: boolean
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 9.8.0.sw
     */ EmbedEvent["ResetLiveboard"] = "resetLiveboard";
    /**
     * Emitted when a PersonalisedView is deleted.
     * This event is deprecated. Use {@link EmbedEvent.DeletePersonalizedView} instead.
     * @returns views: string[]
     * @returns liveboardId: string
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 9.8.0.sw
     * @deprecated SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ EmbedEvent["DeletePersonalisedView"] = "deletePersonalisedView";
    /**
     * Emitted when a PersonalizedView is deleted.
     * @returns views: string[]
     * @returns liveboardId: string
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ EmbedEvent["DeletePersonalizedView"] = "deletePersonalisedView";
    /**
     * Emitted when a user selects a different Personalized View or
     * resets to the original/default view on a Liveboard.
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.ChangePersonalizedView, (data) => {
     *   console.log(data.viewName);    // 'Q4 Revenue' or 'Original View'
     *   console.log(data.viewId);      // '2a021a12-...' or null (default)
     *   console.log(data.liveboardId); // 'abc123...'
     *   console.log(data.isPublic);    // true | false
     * })
     * ```
     * @returns viewName: string - Name of the selected view,
     *   or 'Original View' when reset to default.
     * @returns viewId: string | null - GUID of the selected view,
     *   or null when reset to default.
     * @returns liveboardId: string
     * @returns isPublic: boolean
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ EmbedEvent["ChangePersonalizedView"] = "changePersonalisedView";
    /**
     * Emitted when a user creates a Worksheet.
     * @version SDK: 1.27.0 | ThoughtSpot: 9.8.0.cl, 9.8.0.sw
     */ EmbedEvent["CreateWorksheet"] = "createWorksheet";
    /**
     * Emitted when the *Ask Sage* is initialized.
     * @returns viewName: string
     * @returns viewId: string
     * @returns liveboardId: string
     * @returns isPublic: boolean
     * @version SDK: 1.29.0 | ThoughtSpot Cloud: 9.12.0.cl
     */ EmbedEvent["AskSageInit"] = "AskSageInit";
    /**
     * Emitted when a Liveboard or visualization is renamed.
     * @version SDK: 1.28.0 | ThoughtSpot: 9.10.5.cl, 10.1.0.sw
     */ EmbedEvent["Rename"] = "rename";
    /**
     *
     * This event allows developers to intercept search execution
     * and implement logic that decides whether Search Data should return
     * data or block the search operation.
     *
     * **Prerequisite**: Set`isOnBeforeGetVizDataInterceptEnabled` to `true`
     * to ensure that `EmbedEvent.OnBeforeGetVizDataIntercept` is emitted
     * when the embedding application user tries to run a search query.
     *
     * This framework applies only to `AppEmbed` and `SearchEmbed`.
     * @param - Includes the following parameters:
     * - `payload`: The payload received from the embed related to the Data API call.
     * - `responder`: Contains elements that let developers define whether ThoughtSpot
     *   will run or block the search operation, and if blocked, which error message to
     *   provide.
     * - `execute` - When `execute` returns `true`, the search is run.
     * When `execute` returns `false`, the search is not executed.
     * - `error` - Developers can customize the user-facing error message when `execute`
     * is `false` by using the `error` parameters in `responder`.
     * - `errorText` - The error message text shown to the user.
     * @version SDK: 1.29.0 | ThoughtSpot: 10.3.0.cl
     * @example
     *
     * This example blocks search operation and returns a custom error message:
     * ```js
     * embed.on(EmbedEvent.OnBeforeGetVizDataIntercept, (payload, responder) => {
     *   responder({
     *     data: {
     *       execute: false,
     *       error: {
     *         // Provide a custom error message to explain why the search did not run.
     *         errorText: 'This search query cannot be run. Please contact your administrator for more details.',
     *       },
     *     },
     *   });
     * })
     * ```
     * @example
     *
     * This example allows the search operation to run
     * unless the query contains both `sales` and `county`,
     * and returns a custom error message if the query is rejected:
     * ```js
     * embed.on(EmbedEvent.OnBeforeGetVizDataIntercept, (payload, responder) => {
     *   // Record the search query submitted by the end user.
     *   const query = payload.data.data.answer.search_query;
     *
     *   responder({
     *     data: {
     *       // Returns true as long as the query does not include both `sales` and `county`.
     *       execute: !(query.includes('sales') && query.includes('county')),
     *       error: {
     *         // Provide a custom error message when the query is blocked by your logic.
     *         errorText:
     *           "You can't use this query: "
     *           + query
     *           + ". The 'sales' measure can never be used at the 'county' level. "
     *           + "Please try another measure or remove 'county' from your search.",
     *       },
     *     },
     *   });
     * })
     * ```
     */ EmbedEvent["OnBeforeGetVizDataIntercept"] = "onBeforeGetVizDataIntercept";
    /**
     * Emitted when parameter changes in an Answer
     * or Liveboard.
     * ```js
     * liveboardEmbed.on(EmbedEvent.ParameterChanged, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.29.0 | ThoughtSpot: 10.3.0.cl
     */ EmbedEvent["ParameterChanged"] = "parameterChanged";
    /**
     * Emits when a table visualization is rendered in
     * the ThoughtSpot embedded app.
     *
     * You can also use this event as a hook to trigger host events
     * such as `HostEvent.TransformTableVizData` on the table visualization.
     * The event payload contains the data used in the rendered table.
     * You can extract the relevant data from the payload
     * stored in `payload.data.data.columnDataLite`.
     *
     * `columnDataLite` is a multidimensional array that contains
     * data values for each column, which was used in the query to
     * generate the table visualization. To find and modify specific cell data,
     * you can either loop through the array or directly access a cell if
     * you know its position and data index.
     *
     * In the following code sample, the first cell in the first column
     * (`columnDataLite[0].dataValue[0]`) is set to `new fob`.
     * Note that any changes made to the data in the payload will only update the
     * visual presentation and do not affect the underlying data.
     * To persist data value modifications after a reload or during chart
     * interactions such as drill down, ensure that the modified
     * payload in the `columnDataLite` is passed on to
     * `HostEvent.TransformTableVizData` and trigger an update to
     * the table visualization.
     *
     * If the Row-Level Security (RLS) rules are applied on the
     * Model, exercise caution when changing column
     * or table cell values to maintain data security.
     *
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.TableVizRendered, (payload) => {
     *      console.log(payload);
     *      const columnDataLite = payload.data.data.columnDataLite;
     *      columnDataLite[0].dataValue[0]="new fob";
     *      console.log('>>> new Data', columnDataLite);
     *      searchEmbed.trigger(HostEvent.TransformTableVizData, columnDataLite);
     * })
     * ```
     * @version SDK: 1.37.0 | ThoughtSpot: 10.8.0.cl
     */ EmbedEvent["TableVizRendered"] = "TableVizRendered";
    /**
     * Emitted when the liveboard is created from pin modal or Liveboard list page.
     * You can use this event as a hook to trigger
     * other events on liveboard creation.
     *
     * ```js
     * liveboardEmbed.on(EmbedEvent.CreateLiveboard, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.37.0 | ThoughtSpot: 10.8.0.cl
     */ EmbedEvent["CreateLiveboard"] = "createLiveboard";
    /**
     * Emitted when a user creates a Model.
     * @version SDK: 1.37.0 | ThoughtSpot: 10.8.0.cl
     */ EmbedEvent["CreateModel"] = "createModel";
    /**
     * @hidden
     * Emitted when a user exits present mode.
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ EmbedEvent["ExitPresentMode"] = "exitPresentMode";
    /**
     * Emitted when a user requests the full height lazy load data.
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     * @hidden
     */ EmbedEvent["RequestVisibleEmbedCoordinates"] = "requestVisibleEmbedCoordinates";
    /**
     * Emitted when Spotter response is text data
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.SpotterData, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     */ EmbedEvent["SpotterData"] = "SpotterData";
    /**
     * Emitted when user opens up the data source preview modal in Spotter embed.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.PreviewSpotterData, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     */ EmbedEvent["PreviewSpotterData"] = "PreviewSpotterData";
    /**
     * Emitted when user opens up the Add to Coaching modal on any visualization in Spotter Embed.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.AddToCoaching, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot: 26.2.0.cl
     */ EmbedEvent["AddToCoaching"] = "addToCoaching";
    /**
     * Emitted when user opens up the data model instructions modal in Spotter embed.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.DataModelInstructions, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot: 26.3.0.cl
     */ EmbedEvent["DataModelInstructions"] = "DataModelInstructions";
    /**
     * Emitted when the Spotter query is triggered in Spotter embed.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.SpotterQueryTriggered, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     */ EmbedEvent["SpotterQueryTriggered"] = "SpotterQueryTriggered";
    /**
     * Emitted when the last Spotter query is edited in Spotter embed.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.LastPromptEdited, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     */ EmbedEvent["LastPromptEdited"] = "LastPromptEdited";
    /**
     * Emitted when the last Spotter query is deleted in Spotter embed.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.LastPromptDeleted, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     */ EmbedEvent["LastPromptDeleted"] = "LastPromptDeleted";
    /**
     * Emitted when the conversation is reset in Spotter embed.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.ResetSpotterConversation, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     */ EmbedEvent["ResetSpotterConversation"] = "ResetSpotterConversation";
    /**
     * Emitted when the *Spotter* is initialized.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.SpotterInit, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.41.0 | ThoughtSpot: 10.12.0.cl
     */ EmbedEvent["SpotterInit"] = "spotterInit";
    /**
     * Emitted when a *Spotter* conversation has been successfully created.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.SpotterLoadComplete, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.44.0 | ThoughtSpot: 26.2.0.cl
     */ EmbedEvent["SpotterLoadComplete"] = "spotterLoadComplete";
    /**
     * @hidden
     * Triggers when the embed listener is ready to receive events.
     * This is used to trigger events after the embed container is loaded.
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.EmbedListenerReady, () => {
     *     console.log('EmbedListenerReady');
     * })
     * ```
     */ EmbedEvent["EmbedListenerReady"] = "EmbedListenerReady";
    /**
     * Emitted when the organization is switched.
     * @example
     * ```js
     * appEmbed.on(EmbedEvent.OrgSwitched, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.41.0 | ThoughtSpot: 10.12.0.cl
     */ EmbedEvent["OrgSwitched"] = "orgSwitched";
    /**
     * Emitted when the user intercepts a URL.
     *
     * Supported on all embed types.
     *
     * @example
     *
     * ```js
     * embed.on(EmbedEvent.ApiIntercept, (payload, responder) => {
     *     console.log('payload', payload);
     *     responder({
     *         data: {
     *             execute: false,
     *             error: {
     *                 errorText: 'Error Occurred',
     *             }
     *         }
     *     })
     * })
     * ```
     *
     * ```js
     * // We can also send a response for the intercepted api
     * embed.on(EmbedEvent.ApiIntercept, (payload, responder) => {
     *     console.log('payload', payload);
     *     responder({
     *         data: {
     *             execute: false,
     *             response: {
     *                body: {
     *                    data: {
     *                       // Some api response
     *                    },
     *                }
     *             }
     *         }
     *     })
     * })
     *
     * // here embed will use the response from the responder as the response for the api
     * ```
     *
     * ```js
     * // We can also send error in response for the intercepted api
     * embed.on(EmbedEvent.ApiIntercept, (payload, responder) => {
     *     console.log('payload', payload);
     *     responder({
     *         data: {
     *             execute: false,
     *             response: {
     *                body: {
     *                    errors: [{
     *                      title: 'Error Occurred',
     *                      description: 'Error Description',
     *                      isUserError: true,
     *                    }],
     *                    data: {},
     *                },
     *             }
     *         }
     *     })
     * })
     * ```
     * @version SDK: 1.43.0 | ThoughtSpot: 10.15.0.cl
     */ EmbedEvent["ApiIntercept"] = "ApiIntercept";
    /**
     * Emitted when a Spotter conversation is renamed.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.SpotterConversationRenamed, (payload) => {
     *     console.log('Conversation renamed', payload);
     *     // payload: { convId: string, oldTitle: string, newTitle: string }
     * })
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot: 26.3.0.cl
     */ EmbedEvent["SpotterConversationRenamed"] = "spotterConversationRenamed";
    /**
     * Emitted when a Spotter conversation is deleted.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.SpotterConversationDeleted, (payload) => {
     *     console.log('Conversation deleted', payload);
     *     // payload: { convId: string, title: string }
     * })
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot: 26.3.0.cl
     */ EmbedEvent["SpotterConversationDeleted"] = "spotterConversationDeleted";
    /**
     * Emitted when a Spotter conversation is selected/clicked.
     * @example
     * ```js
     * spotterEmbed.on(EmbedEvent.SpotterConversationSelected, (payload) => {
     *     console.log('Conversation selected', payload);
     *     // payload: { convId: string, title: string, worksheetId: string }
     * })
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot: 26.3.0.cl
     */ EmbedEvent["SpotterConversationSelected"] = "spotterConversationSelected";
    /**
     * @hidden
     * Emitted when the auth token is about to get expired and needs to be refreshed.
     * @example
     * ```js
     * embed.on(EmbedEvent.RefreshAuthToken, (payload) => {
     *     console.log('payload', payload);
     * })
     * ```
     * @version SDK: 1.45.2 | ThoughtSpot: 26.3.0.cl
     */ EmbedEvent["RefreshAuthToken"] = "RefreshAuthToken";
})($a2210daac95811c7$export$9db453de2db4822 || ($a2210daac95811c7$export$9db453de2db4822 = {}));
var $a2210daac95811c7$export$2cab83a5627bcd4c;
(function(HostEvent) {
    /**
     * Triggers a search operation with the search tokens specified in
     * the search query string.
     * Supported in `AppEmbed` and `SearchEmbed` deployments.
     * Includes the following properties:
     * @param - Includes the following keys:
     * - `searchQuery`: Query string with search tokens.
     * - `dataSources`: Data source GUID to search on.
     *   Although an array, only a single source is supported.
     * - `execute`: Executes search and updates the existing query.
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.Search, {
         searchQuery: "[sales] by [item type]",
         dataSources: ["cd252e5c-b552-49a8-821d-3eadaa049cca"],
         execute: true
       });
     * ```
     * @example
     * ```js
     * // Trigger search from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Search, {
     *     searchQuery: "[revenue] by [region]",
     *     dataSources: ["cd252e5c-b552-49a8-821d-3eadaa049cca"],
     *     execute: true
     * }, ContextType.Search);
     * ```
     */ HostEvent["Search"] = "search";
    /**
     * Triggers a drill on certain points of the specified column
     * Includes the following properties:
     * @param - Includes the following keys:
     * - `points`: An object containing `selectedPoints` and/or `clickedPoint`
     *   to drill to. For example, `{ selectedPoints: [] }`.
     * - `columnGuid`: Optional. GUID of the column to drill by. If not provided,
     *   it will auto drill by the configured column.
     * - `autoDrillDown`: Optional. If `true`, the drill down will be done automatically
     *   on the most popular column.
     * - `vizId` (TS >= 9.8.0): Optional. The GUID of the visualization to drill in case
     *   of a Liveboard. In Spotter embed, `vizId` refers to the Answer ID and is
     *   **required**.
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.VizPointDoubleClick, (payload) => {
     *       console.log(payload);
     *       const clickedPoint = payload.data.clickedPoint;
     *       const selectedPoint = payload.data.selectedPoints;
     *       console.log('>>> called', clickedPoint);
     *       searchEmbed.trigger(HostEvent.DrillDown, {
     *             points: {
     *                  clickedPoint,
     *                  selectedPoints: selectedPoint
     *             },
     *             autoDrillDown: true,
     *       });
     * })
     * ```
     * @example
     * ```js
     *  // Works with TS 9.8.0 and above
     *
     *  liveboardEmbed.on(EmbedEvent.VizPointDoubleClick, (payload) => {
     *    console.log(payload);
     *    const clickedPoint = payload.data.clickedPoint;
     *    const selectedPoint = payload.data.selectedPoints;
     *    console.log('>>> called', clickedPoint);
     *    liveboardEmbed.trigger(HostEvent.DrillDown, {
     *      points: {
     *        clickedPoint,
     *        selectedPoints: selectedPoint
     *      },
     *      columnGuid: "<guid of the column to drill>",
     *      vizId: payload.data.vizId
     *    });
     *  })
     * ```
     * @example
     * ```js
     * // Drill down from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.DrillDown, {
     *     points: { clickedPoint, selectedPoints },
     *     autoDrillDown: true
     * }, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Drill down from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * searchEmbed.trigger(HostEvent.DrillDown, {
     *     points: { clickedPoint, selectedPoints },
     *     columnGuid: "column-guid"
     * }, ContextType.Search);
     * ```
     * @version SDK: 1.5.0 | ThoughtSpot: ts7.oct.cl, 7.2.1
     */ HostEvent["DrillDown"] = "triggerDrillDown";
    /**
     * Apply filters
     * @hidden
     */ HostEvent["Filter"] = "filter";
    /**
     * Reload the Answer or visualization
     * @hidden
     */ HostEvent["Reload"] = "reload";
    /**
     * Get iframe URL for the current embed view.
     * @example
     * ```js
     * const url = embed.trigger(HostEvent.GetIframeUrl);
     * console.log("iFrameURL",url);
     * ```
     * @example
     * ```js
     * // Get iframe URL from specific context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * const url = await appEmbed.trigger(HostEvent.GetIframeUrl, {}, ContextType.Answer);
     * console.log("iFrameURL", url);
     * ```
     * @version SDK: 1.35.0 | ThoughtSpot: 10.4.0.cl
     */ HostEvent["GetIframeUrl"] = "GetIframeUrl";
    /**
     * Display specific visualizations on a Liveboard.
     * @param - An array of GUIDs of the visualization to show. The visualization IDs not passed
     *  in this parameter will be hidden.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.SetVisibleVizs, [
     *  '730496d6-6903-4601-937e-2c691821af3c',
     *  'd547ec54-2a37-4516-a222-2b06719af726'])
     * ```
     * @example
     * ```js
     * // Set visible vizs from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.SetVisibleVizs, [
     *     '730496d6-6903-4601-937e-2c691821af3c',
     *     'd547ec54-2a37-4516-a222-2b06719af726'
     * ], ContextType.Liveboard);
     * ```
     * @version SDK: 1.6.0 | ThoughtSpot: ts8.nov.cl, 8.4.1.sw
     */ HostEvent["SetVisibleVizs"] = "SetPinboardVisibleVizs";
    /**
     * Set a Liveboard tab as an active tab.
     * @param - tabId - string of id of Tab to show
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.SetActiveTab,{
     *  tabId:'730496d6-6903-4601-937e-2c691821af3c'
     * })
     * ```
     * @example
     * ```js
     * // Set active tab from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.SetActiveTab, {
     *     tabId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.24.0 | ThoughtSpot: 9.5.0.cl, 9.5.1-sw
     */ HostEvent["SetActiveTab"] = "SetActiveTab";
    /**
     * Updates the runtime filters applied on a Liveboard. The filter
     * attributes passed with this event are appended to the existing runtime
     * filters applied on a Liveboard.
     *
     * **Note**: `HostEvent.UpdateRuntimeFilters` is supported in `LiveboardEmbed`
     * and `AppEmbed` only. In full application embedding, this event updates
     * the runtime filters applied on the Liveboard and saved Answer objects.
     *
     * @param - Array of {@link RuntimeFilter} objects. Each item includes:
     * - `columnName`: Name of the column to filter on.
     * - `operator`: {@link RuntimeFilterOp} to apply. For more information, see
     *   link:https://developers.thoughtspot.com/docs/runtime-filters#rtOperator[Developer Documentation].
     * - `values`: List of operands. Some operators such as EQ and LE allow a single
     *   value, whereas BW and IN accept multiple values.
     *
     * **Note**: Updating runtime filters resets the ThoughtSpot
     * object to its original state and applies new filter conditions.
     * Any user changes (like drilling into a visualization)
     * will be cleared, restoring the original visualization
     * with the updated filters.
     *

     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdateRuntimeFilters, [
     *   {columnName: "state",operator: RuntimeFilterOp.EQ,values: ["michigan"]},
     *   {columnName: "item type",operator: RuntimeFilterOp.EQ,values: ["Jackets"]}
     * ])
     * ```
     * @example
     * ```js
     * // Update runtime filters from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.UpdateRuntimeFilters, [
     *     {columnName: "region", operator: RuntimeFilterOp.EQ, values: ["west"]},
     *     {columnName: "product", operator: RuntimeFilterOp.IN, values: ["shoes", "boots"]}
     * ], ContextType.Liveboard);
     * ```
     * @version SDK: 1.9.0 | ThoughtSpot: 8.1.0.cl, 8.4.1.sw
     * @important
     */ HostEvent["UpdateRuntimeFilters"] = "UpdateRuntimeFilters";
    /**
     * Navigate to a specific page in the embedded ThoughtSpot application.
     * This is the same as calling `appEmbed.navigateToPage(path, true)`.
     * @param - `path` - the path to navigate to go forward or back. The path value can
     * be a number; for example, `1`, `-1`.
     * @example
     * ```js
     * appEmbed.navigateToPage(-1)
     * ```
     * @version SDK: 1.12.0 | ThoughtSpot: 8.4.0.cl, 8.4.1.sw
     */ HostEvent["Navigate"] = "Navigate";
    /**
     * Open the filter panel for a particular column.
     * Works with Search and Liveboard embed.
     * @param - { columnId: string,
     *  name: string,
     *  type: ATTRIBUTE/MEASURE,
     *  dataType: INT64/CHAR/DATE }
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.OpenFilter,
     *  {column: { columnId: '<column-GUID>', name: 'column name', type: 'ATTRIBUTE', dataType: 'INT64'}})
     * ```
     * @example
     * ```js
     * LiveboardEmbed.trigger(HostEvent.OpenFilter,
     *   { column: {columnId: '<column-GUID>'}})
     * ```
     * @example
     * ```js
     * // Open filter from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * searchEmbed.trigger(HostEvent.OpenFilter, {
     *     column: { columnId: '<column-GUID>', name: 'region', type: 'ATTRIBUTE', dataType: 'CHAR'}
     * }, ContextType.Search);
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl
     */ HostEvent["OpenFilter"] = "openFilter";
    /**
     * Add columns to the current search query.
     * @param - { columnIds: string[] }
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.AddColumns, { columnIds: ['<column-GUID>','<column-GUID>'] })
     * ```
     * @example
     * ```js
     * // Add columns from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * searchEmbed.trigger(HostEvent.AddColumns, {
     *     columnIds: ['col-guid-1', 'col-guid-2']
     * }, ContextType.Search);
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl
     */ HostEvent["AddColumns"] = "addColumns";
    /**
     * Remove a column from the current search query.
     * @param - { columnId: string }
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.RemoveColumn, { columnId: '<column-Guid>' })
     * ```
     * @example
     * ```js
     * // Remove column from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * searchEmbed.trigger(HostEvent.RemoveColumn, {
     *     columnId: 'column-guid'
     * }, ContextType.Search);
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl
     */ HostEvent["RemoveColumn"] = "removeColumn";
    /**
     * Get the transient state of a Liveboard as encoded content.
     * This includes unsaved and ad hoc changes such as
     * Liveboard filters, runtime filters applied on visualizations on a
     * Liveboard, and Liveboard layout, changes to visualizations such as
     * sorting, toggling of legends, and data drill down.
     * For more information, see
     * link:https://developers.thoughtspot.com/docs/fetch-data-and-report-apis#transient-lb-content[Liveboard data with unsaved changes].
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.getExportRequestForCurrentPinboard).then(
     * data=>console.log(data))
     * ```
     * @version SDK: 1.13.0 | ThoughtSpot: 8.5.0.cl, 8.8.1.sw
     */ HostEvent["getExportRequestForCurrentPinboard"] = "getExportRequestForCurrentPinboard";
    /**
     * Trigger **Pin** action on an embedded object.
     * If no parameters are defined, the pin action is triggered
     * for the Answer that the user is currently on
     * and a modal opens for Liveboard selection.
     * To add an Answer or visualization to a Liveboard programmatically without
     * requiring additional user input via the *Pin to Liveboard* modal, define
     * the following parameters:
     *
     * @param - Includes the following keys:
     * - `vizId`: GUID of the saved Answer or Spotter visualization ID to pin to a
     * Liveboard.
     *   Optional when pinning a new chart or table generated from a Search query.
     *   **Required** in Spotter Embed.
     * - `liveboardId`: GUID of the Liveboard to pin an Answer. If there is no Liveboard,
     *   specify the `newLiveboardName` parameter to create a new Liveboard.
     * - `tabId`: GUID of the Liveboard tab. Adds the Answer to the Liveboard tab
     *   specified in the code.
     * - `newVizName`: Name string for the Answer or visualization. If defined,
     *   this parameter adds a new visualization object or creates a copy of the
     *   Answer or visualization specified in `vizId`.
     *   Required.
     * - `newLiveboardName`: Name string for the Liveboard.
     *   Creates a new Liveboard object with the specified name.
     * - `newTabName`: Name of the tab. Adds a new tab Liveboard specified
     *   in the code.
     *
     * @example
     * ```js
     * const pinResponse = await appEmbed.trigger(HostEvent.Pin, {
     *     vizId: "123",
     *     newVizName: "Sales by region",
     *     liveboardId: "123",
     *     tabId: "123"
     *  });
     * ```
     * @example
     * ```js
     * const pinResponse = await appEmbed.trigger(HostEvent.Pin, {
     *     newVizName: "Total sales of Jackets",
     *     liveboardId: "123"
     *  });
     * ```
     *
     * @example
     * ```js
     * const pinResponse = await searchEmbed.trigger(HostEvent.Pin, {
     *     newVizName: "Sales by state",
     *     newLiveboardName: "Sales",
     *     newTabName: "Products"
     *  });
     * ```
     * @example
     * ```js
     * appEmbed.trigger(HostEvent.Pin)
     * ```
     * @example
     * ```js

    * // You can use the Data event dispatched on each answer creation to get the vizId and use in Pin host event.
    * let latestSpotterVizId = '';
    * spotterEmbed.on(EmbedEvent.Data, (payload) => {
    *   latestSpotterVizId = payload.data.id;
    * });
    *
    * spotterEmbed.trigger(HostEvent.Pin, { vizId: latestSpotterVizId });
    * ```
     * @example
     * ```js
     * // Using context parameter to specify the context type (SDK: 1.45.2+)
     * // Pin from a search answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Pin, {
     *     vizId: "123",
     *     newVizName: "Sales by region",
     *     liveboardId: "456"
     *  }, ContextType.Search);
     * ```
     * @example
     * ```js
     * // Pin from an answer context (explore modal/page) (SDK: 1.45.2+)
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Pin, {
     *     vizId: "789",
     *     newVizName: "Revenue trends",
     *     liveboardId: "456"
     *  }, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Pin from a spotter context (SDK: 1.45.2+)
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Pin, {
     *     vizId: latestSpotterVizId,
     *     newVizName: "AI-generated insights",
     *     liveboardId: "456"
     *  }, ContextType.Spotter);
     * ```
     *
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["Pin"] = "pin";
    /**
     * Trigger the **Show Liveboard details** action
     * on an embedded Liveboard.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.LiveboardInfo)
     *```
     * @example
     * ```js
     * // Show liveboard info from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.LiveboardInfo, {}, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["LiveboardInfo"] = "pinboardInfo";
    /**
     * Trigger the **Schedule** action on an embedded Liveboard.
     * @example
     * ```js
     *  liveboardEmbed.trigger(HostEvent.Schedule)
     * ```
     * @example
     * ```js
     * // Schedule from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Schedule, {}, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["Schedule"] = "subscription";
    /**
     * Trigger the **Manage schedule** action on an embedded Liveboard
     * @example
     * ```js
     *  liveboardEmbed.trigger(HostEvent.ScheduleList)
     * ```
     * @example
     * ```js
     * // Manage schedules from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.ScheduleList, {}, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["SchedulesList"] = "schedule-list";
    /**
     * Trigger the **Export TML** action on an embedded Liveboard or
     * Answer.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.ExportTML)
     * ```
     * @example
     * ```js
     * // Export TML from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.ExportTML, {}, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Export TML from search-answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.ExportTML, {}, ContextType.Search);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["ExportTML"] = "exportTSL";
    /**
     * Trigger the **Edit TML** action on an embedded Liveboard or
     * saved Answers in the full application embedding.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.EditTML)
     * ```
     * @example
     * ```js
     * // Edit TML from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.EditTML, {}, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Edit TML from search-answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.EditTML, {}, ContextType.Search);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["EditTML"] = "editTSL";
    /**
     * Trigger the **Update TML** action on an embedded Liveboard.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdateTML)
     * ```
     * @example
     * ```js
     * // Update TML from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.UpdateTML, {}, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["UpdateTML"] = "updateTSL";
    /**
     * Trigger the **Download PDF** action on an embedded Liveboard,
     * visualization or Answer.
     *
     * @param - `vizId` refers to the Answer ID in Spotter embed and is required in Spotter embed.
     *
     * **NOTE**: The **Download** > **PDF** action is available on
     * visualizations and Answers if the data is in tabular format.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.DownloadAsPdf)
     * ```
     * @example
     * ```js

    * // You can use the Data event dispatched on each answer creation to get the vizId and use in DownloadAsPdf host event.
    * let latestSpotterVizId = '';
    * spotterEmbed.on(EmbedEvent.Data, (payload) => {
    *   latestSpotterVizId = payload.data.id;
    * });
    *
    * spotterEmbed.trigger(HostEvent.DownloadAsPdf, { vizId: latestSpotterVizId });
    * ```
     * @example
     * ```js
     * // Download as PDF from search-answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.DownloadAsPdf, {}, ContextType.Search);
     * ```
     * @example
     * ```js
     * // Download as PDF from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.DownloadAsPdf, {}, ContextType.Liveboard);
     * ```
     *
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["DownloadAsPdf"] = "downloadAsPdf";
    /**
     * Trigger the **Download Liveboard as Continuous PDF** action on an
     * embedded Liveboard.
     *
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.DownloadLiveboardAsContinuousPDF)
     * ```
     *
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ HostEvent["DownloadLiveboardAsContinuousPDF"] = "downloadLiveboardAsContinuousPDF";
    /**
     * Trigger the **AI Highlights** action on an embedded Liveboard
     *
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.AIHighlights)
     * ```
     * @version SDK: 1.44.0 | ThoughtSpot: 10.15.0.cl
     */ HostEvent["AIHighlights"] = "AIHighlights";
    /**
     * Trigger the **Make a copy** action on a Liveboard,
     * visualization, or Answer page.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.MakeACopy)
     * ```
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.MakeACopy, {
     * vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * @example
     * ```js
     * vizEmbed.trigger(HostEvent.MakeACopy)
     * ```
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.MakeACopy)
     * ```
     * @example
     * ```js
     * // You can use the Data event dispatched on each answer creation to get the vizId and use in MakeACopy host event.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.MakeACopy, { vizId: latestSpotterVizId });
     * ```
     * @example
     * ```js
     * // Make a copy from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.MakeACopy, {}, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Make a copy from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.MakeACopy, {}, ContextType.Search);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["MakeACopy"] = "makeACopy";
    /**
     * Trigger the **Delete** action for a Liveboard.
     * @example
     * ```js
     * appEmbed.trigger(HostEvent.Remove)
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.Remove)
     * ```
     * @version SDK: 1.37.0 | ThoughtSpot: 10.8.0.cl, 10.10.0.sw
     */ HostEvent["Remove"] = "delete";
    /**
     * Trigger the **Explore** action on a visualization.
     * @param - an object with `vizId` as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.Explore, {vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * @example
     * ```js
     * // Explore from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Explore, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["Explore"] = "explore";
    /**
     * Trigger the **Create alert** action on a KPI chart
     * in a Liveboard or saved Answer.
     * @param - an object with `vizId` as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.CreateMonitor, {
     *  vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * })
     * ```
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.CreateMonitor)
     * ```
     * @example
     * ```js
     * // Create monitor from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.CreateMonitor, {}, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Create monitor from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.CreateMonitor, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["CreateMonitor"] = "createMonitor";
    /**
     * Trigger the **Manage alerts** action on a KPI chart
     * in a visualization or saved Answer.
     * @param - an object with `vizId` as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.ManageMonitor, {
     *  vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * })
     * ```
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.ManageMonitor)
     * ```
     * @example
     * ```js
     * vizEmbed.trigger(HostEvent.ManageMonitor)
     * ```
     * @example
     * ```js
     * // Manage monitor from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.ManageMonitor, {}, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Manage monitor from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.ManageMonitor, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["ManageMonitor"] = "manageMonitor";
    /**
     * Trigger the **Edit** action on a Liveboard or a visualization
     * on a Liveboard.
     *
     * This event is not supported in visualization embed and search embed.
     * @param - Object parameter. Includes the following keys:
     * - `vizId`: To trigger the action for a specific visualization in Liveboard embed,
     *   pass in `vizId` as a key. In Spotter embed, `vizId` refers to the Answer ID and
     *   is **required**.
     *
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.Edit)
     * ```
     * ```js
     * liveboardEmbed.trigger(HostEvent.Edit, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.Edit);
     * ```
     * @example
     * ```js
     * // Using context parameter to edit liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Edit, {}, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Edit from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Edit, {}, ContextType.Search);
     * ```
     * * @example
     * ```js
     * // Edit from spotter context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Edit, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Spotter);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["Edit"] = "edit";
    /**
     * Trigger the **Copy link** action on a Liveboard or visualization
     * @param - object - to trigger the action for a
     * specific visualization in Liveboard embed, pass in `vizId` as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.CopyLink)
     * ```
     * ```js
     * liveboardEmbed.trigger(HostEvent.CopyLink, {vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.CopyLink)
     * ```
     * @example
     * ```js
     * // Copy link from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.CopyLink, {}, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Copy link from liveboard visualization context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.CopyLink, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Copy link from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.CopyLink, {}, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Copy link from liveboard visualization context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.CopyLink, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["CopyLink"] = "embedDocument";
    /**
     * Trigger the **Present** action on a Liveboard or visualization
     * @param - object - to trigger the action for a specific visualization
     *  in Liveboard embed, pass in `vizId` as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.Present)
     * ```
     * ```js
     * liveboardEmbed.trigger(HostEvent.Present, {vizId: '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.Present)
     * ```
     * @example
     * ```js
     * // Present from liveboard visualization context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Present, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Present from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Present, {}, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Present from liveboard visualization context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Present, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Present from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Present, {}, ContextType.Liveboard);
     * ```
     * @version SDK: 1.15.0 | ThoughtSpot: 8.7.0.cl, 8.8.1.sw
     */ HostEvent["Present"] = "present";
    /**
     * Get TML for the current search.
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.GetTML).then((tml) => {
     *   console.log(
     *      tml.answer.search_query // TML representation of the search query
     *   );
     * })
     * ```
     * @example
     * ```js
     * // You can use the Data event dispatched on each answer creation to get the vizId and use in GetTML host event.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.GetTML, {
     *   vizId: latestSpotterVizId
     * }).then((tml) => {
     *   console.log(
     *      tml.answer.search_query // TML representation of the search query
     *   );
     * })
     * ```
     * @example
     * ```js
     * // Get TML from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.GetTML, {}, ContextType.Search).then((tml) => {
     *   console.log(tml.answer.search_query);
     * });
     * ```
     * @example
     * ```js
     * // Get TML from search-answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.GetTML, {}, ContextType.Search).then((tml) => {
     *   console.log(tml.answer);
     * });
     * ```
     * @version SDK: 1.18.0 | ThoughtSpot: 8.10.0.cl, 9.0.1.sw
     * @important
     */ HostEvent["GetTML"] = "getTML";
    /**
     * Trigger the **Show underlying data** action on a
     * chart or table.
     *
     * @param - an object with vizId as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.ShowUnderlyingData, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.ShowUnderlyingData)
     * ```
     * ```js
     * searchEmbed.trigger(HostEvent.ShowUnderlyingData)
     * ```
     * @example
     * ```js
     * // Show underlying data from liveboard visualization context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.ShowUnderlyingData, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Show underlying data from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.ShowUnderlyingData, {}, ContextType.Search);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["ShowUnderlyingData"] = "showUnderlyingData";
    /**
     * Trigger the **Delete** action for a visualization
     * in an embedded Liveboard, or a chart or table
     * generated from Search.
     * @param - Liveboard embed takes an object with `vizId` as a key.
     * Can be left empty if embedding Search or visualization.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.Delete, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * searchEmbed.trigger(HostEvent.Delete)
     * ```
     * @example
     * ```js
     * // Delete from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Delete, {}, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Delete from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Delete, {}, ContextType.Search);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["Delete"] = "onDeleteAnswer";
    /**
     * Trigger the **SpotIQ analyze** action on a
     * chart or table.
     * @param - Liveboard embed takes `vizId` as a
     * key. Can be left undefined when embedding Search or
     * visualization.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.SpotIQAnalyze, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.SpotIQAnalyze)
     * ```
     * ```js
     * searchEmbed.trigger(HostEvent.SpotIQAnalyze)
     * ```
     * @example
     * ```js
     * // SpotIQ analyze from search-answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.SpotIQAnalyze, { vizId: '730496d6-6903-4601-937e-2c691821af3c' }, ContextType.Search);
     * ```
     * @example
     * ```js
     * // SpotIQ analyze from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.SpotIQAnalyze, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["SpotIQAnalyze"] = "spotIQAnalyze";
    /**
     * Trigger the **Download** action on charts in
     * the embedded view.
     * Use {@link HostEvent.DownloadAsPng} instead.
     *
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     *
     * @deprecated from SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl ,9.4.1.sw
     * @param - `vizId` refers to the Visualization ID in Spotter embed and is required in Spotter embed.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.Download, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * embed.trigger(HostEvent.Download)
     * ```
     * ```js
     * // You can use the Data event dispatched on each answer creation to get the vizId and use in Download host event.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.Download, { vizId: latestSpotterVizId });
     * ```
     */ HostEvent["Download"] = "downloadAsPng";
    /**
     * Trigger the **Download** > **PNG** action on
     * charts in the embedded view.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.DownloadAsPng,
     * {vizId:'730496d6-6903-4601-937e-2c691821af3c'})
     *
     * vizEmbed.trigger(HostEvent.DownloadAsPng)
     *
     * searchEmbed.trigger(HostEvent.DownloadAsPng)
     *
     * // You can use the Data event dispatched on each answer creation to get the vizId and use in DownloadAsPng host event.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.DownloadAsPng, { vizId: latestSpotterVizId });
     * ```
     * @example
     * ```js
     * // Download as PNG from search-answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.DownloadAsPng, {}, ContextType.Search);
     * ```
     *
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.4.1.sw
     */ // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    HostEvent["DownloadAsPng"] = "downloadAsPng";
    /**
     * Trigger the **Download** > **CSV**  action on tables in
     * the embedded view.
     * @param - `vizId` refers to the Visualization ID in Spotter embed and is required in Spotter embed.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.DownloadAsCsv, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.DownloadAsCsv)
     * ```
     * ```js
     * searchEmbed.trigger(HostEvent.DownloadAsCsv)
     * ```
     * ```js
     * // You can use the Data event dispatched on each answer creation to get the vizId and use in DownloadAsCsv host event.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.DownloadAsCsv, { vizId: latestSpotterVizId });
     * ```
     * @example
     * ```js
     * // Download as CSV from search-answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.DownloadAsCsv, {}, ContextType.Search);
     * ```
     * @example
     * ```js
     * // Download as CSV from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * searchEmbed.trigger(HostEvent.DownloadAsCsv, {}, ContextType.Search);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["DownloadAsCsv"] = "downloadAsCSV";
    /**
     * Trigger the **Download** > **XLSX**  action on tables
     * in the embedded view.
     * @param - `vizId` refers to the Visualization ID in Spotter embed and is required in Spotter embed.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.DownloadAsXlsx, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.DownloadAsXlsx)
     * ```
     * ```js
     * searchEmbed.trigger(HostEvent.DownloadAsXlsx)
     * ```
     * ```js
     * // You can use the Data event dispatched on each answer creation to get the vizId and use in DownloadAsXlsx host event.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.DownloadAsXlsx, { vizId: latestSpotterVizId });
     * ```
     * @example
     * ```js
     * // Download as XLSX from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.DownloadAsXlsx, {}, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Download as XLSX from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * searchEmbed.trigger(HostEvent.DownloadAsXlsx, {}, ContextType.Search);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["DownloadAsXlsx"] = "downloadAsXLSX";
    /**
     * Trigger the **Share** action on an embedded
     * Liveboard or Answer.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.Share)
     * ```
     * ```js
     * searchEmbed.trigger(HostEvent.Share)
     * ```
     * @example
     * ```js
     * // Share from Liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.Share, {}, ContextType.Liveboard);
     * ```
     * @example
     * ```js
     * // Share from search-answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Share, {}, ContextType.Search);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["Share"] = "share";
    /**
     * Trigger the **Save** action on a Liveboard, Answer, or Spotter.
     * Saves the changes.
     *
     * @param - `vizId` refers to the Spotter Visualization Id used in Spotter embed.
     * It is required and can be retrieved from the data embed event.
     *
     * @example
     * ```js
     * // Save changes in a Liveboard
     * liveboardEmbed.trigger(HostEvent.Save)
     * ```
     *
     * ```js
     * // Save the current Answer in Search embed
     * searchEmbed.trigger(HostEvent.Save)
     * ```
     *
     * ```js
     * // Save a Visualization in Spotter (requires vizId)
     * spotterEmbed.trigger(HostEvent.Save, {
     *   vizId: "730496d6-6903-4601-937e-2c691821af3c"
     * })
     * ```
     *
     * ```js
     * // How to get the vizId in Spotter?
     *
     * // You can use the Data event dispatched on each answer creation to get the vizId.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.Save, { vizId: latestSpotterVizId });
     * ```
     * @example
     * ```js
     * // Save from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.Save, {}, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Save from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * searchEmbed.trigger(HostEvent.Save, {}, ContextType.Search);
     * ```
     *
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["Save"] = "save";
    /**
     * Trigger the **Sync to Sheets** action on an embedded visualization or Answer
     * Sends data from an Answer or Liveboard visualization to a Google sheet.
     * @param - an object with `vizId` as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.SyncToSheets, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.SyncToSheets)
     * ```
     * @example
     * ```js
     * // Sync to sheets from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.SyncToSheets, {}, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Sync to sheets from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.SyncToSheets, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["SyncToSheets"] = "sync-to-sheets";
    /**
     * Trigger the **Sync to Other Apps** action on an embedded visualization or Answer
     * Sends data from an Answer or Liveboard visualization to third-party apps such
     * as Slack, Salesforce, Microsoft Teams, ServiceNow and so on.
     * @param - an object with vizId as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.SyncToOtherApps, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.SyncToOtherApps)
     * ```
     * @example
     * ```js
     * // Sync to other apps from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.SyncToOtherApps, {}, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Sync to other apps from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.SyncToOtherApps, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["SyncToOtherApps"] = "sync-to-other-apps";
    /**
     * Trigger the **Manage pipelines** action on an embedded
     * visualization or Answer.
     * Allows users to manage ThoughtSpot Sync pipelines.
     * @param - an object with `vizId` as a key
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.ManagePipelines, {vizId:
     * '730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * ```js
     * vizEmbed.trigger(HostEvent.ManagePipelines)
     * ```
     * @example
     * ```js
     * // Manage pipelines from answer context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * appEmbed.trigger(HostEvent.ManagePipelines, {}, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Manage pipelines from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.ManagePipelines, {
     *     vizId: '730496d6-6903-4601-937e-2c691821af3c'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.19.0 | ThoughtSpot: 9.0.0.cl, 9.0.1.sw
     */ HostEvent["ManagePipelines"] = "manage-pipeline";
    /**
     * Reset search operation on the Search or Answer page.
     * @example
     * ```js
     * searchEmbed.trigger(HostEvent.ResetSearch)
     * ```
     * ```js
     * appEmbed.trigger(HostEvent.ResetSearch)
     * ```
     * @example
     * ```js
     * // Reset search from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * searchEmbed.trigger(HostEvent.ResetSearch, {}, ContextType.Search);
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.0.1.sw
     */ HostEvent["ResetSearch"] = "resetSearch";
    /**
     * Get details of filters applied on the Liveboard.
     * Returns arrays containing Liveboard filter and runtime filter elements.
     * @example
     * ```js
     * const data = await liveboardEmbed.trigger(HostEvent.GetFilters);
     *     console.log('data', data);
     * ```
     * @example
     * ```js
     * // Get filters from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * const data = await liveboardEmbed.trigger(HostEvent.GetFilters, {}, ContextType.Liveboard);
     * console.log('filters', data);
     * ```
     * @version SDK: 1.23.0 | ThoughtSpot: 9.4.0.cl
     */ HostEvent["GetFilters"] = "getFilters";
    /**
     * Update one or several filters applied on a Liveboard.
     * @param - Includes the following keys:
     * - `filter`: A single filter object containing column name, filter operator, and
     * values.
     * - `filters`: Multiple filter objects with column name, filter operator,
     * and values for each.
     *
     * Each filter object must include the following attributes:
     *
     * `column` - Name of the column to filter on.
     *
     * `oper`  - Filter operator, for example, EQ, IN, CONTAINS.
     *  For information about the supported filter operators,
     *  see link:https://developers.thoughtspot.com/docs/runtime-filters#rtOperator[Developer Documentation].
     *
     * `values` - An array of one or several values. The value definition on the
     *  data type you choose to filter on. For a complete list of supported data types,
     *  see
     *  link:https://developers.thoughtspot.com/docs/runtime-filters#_supported_data_types[Supported
     *  data types].
     *
     * `type`  - To update filters for date time, specify the date format type.
     * For more information and examples, see link:https://developers.thoughtspot.com/docs/embed-liveboard#_date_filters[Date filters].
     * @example
     * ```js
     *
     * liveboardEmbed.trigger(HostEvent.UpdateFilters, {
     *     filter: {
     *         column: "item type",
     *         oper: "IN",
     *         values: ["bags","shirts"]
     *        }
     *    });
     * ```
     * @example
     * ```js
     *
     * liveboardEmbed.trigger(HostEvent.UpdateFilters, {
     *     filter: {
     *         column: "date",
     *         oper: "EQ",
     *         values: ["JULY","2023"],
     *         type: "MONTH_YEAR"
     *        }
     *    });
     * ```
     * @example
     *
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdateFilters, {
     *  filters: [{
     *      column: "Item Type",
     *      oper: 'IN',
     *      values: ["bags","shirts"]
     *  },
     *    {
     *      column: "Region",
     *      oper: 'IN',
     *      values: ["West","Midwest"]
     *  },
     *    {
     *      column: "Date",
     *      oper: 'EQ',
     *      values: ["2023-07-31"],
     *      type: "EXACT_DATE"
     *    }]
     * });
     * ```
     * If there are multiple columns with the same name, consider
     * using `WORKSHEET_NAME::COLUMN_NAME` format.
     *
     * @example
     *
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdateFilters, {
     *  filters: [{
     *      column: "(Sample) Retail - Apparel::city",
     *      oper: 'IN',
     *      values: ["atlanta"]
     *  },
     *  {
     *      column: "(Sample) Retail - Apparel::Region",
     *      oper: 'IN',
     *      values: ["West","Midwest"]
     *  }]
     * });
     * ```
     * @example
     * ```js
     * // Update filters from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.UpdateFilters, {
     *     filter: {
     *         column: "item type",
     *         oper: "IN",
     *         values: ["shoes", "boots"]
     *     }
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.23.0 | ThoughtSpot: 9.4.0.cl
     */ HostEvent["UpdateFilters"] = "updateFilters";
    /**
     * Get tab details for the current Liveboard.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.GetTabs).then((tabDetails) => {
     *   console.log(
     *      tabDetails // TabDetails of current Liveboard
     *   );
     * })
     * ```
     * @example
     * ```js
     * // Get tabs from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.GetTabs, {}, ContextType.Liveboard).then((tabDetails) => {
     *     console.log('tabs', tabDetails);
     * });
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl
     */ HostEvent["GetTabs"] = "getTabs";
    /**
     * Set the visible tabs on a Liveboard.
     * @param - an array of ids of tabs to show, the IDs not passed
     *          will be hidden.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.SetVisibleTabs, [
     *  '430496d6-6903-4601-937e-2c691821af3c',
     *  'f547ec54-2a37-4516-a222-2b06719af726'])
     * ```
     * @example
     * ```js
     * // Set visible tabs from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.SetVisibleTabs, [
     *     '430496d6-6903-4601-937e-2c691821af3c',
     *     'f547ec54-2a37-4516-a222-2b06719af726'
     * ], ContextType.Liveboard);
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 9.8.0.sw
     */ HostEvent["SetVisibleTabs"] = "SetPinboardVisibleTabs";
    /**
     * Set the hidden tabs on a Liveboard.
     * @param - an array of the IDs of the tabs to hide.
     * The IDs not passed will be shown.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.SetHiddenTabs, [
     *  '630496d6-6903-4601-937e-2c691821af3c',
     *  'i547ec54-2a37-4516-a222-2b06719af726'])
     * ```
     * @example
     * ```js
     * // Set hidden tabs from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.SetHiddenTabs, [
     *     '630496d6-6903-4601-937e-2c691821af3c',
     *     'i547ec54-2a37-4516-a222-2b06719af726'
     * ], ContextType.Liveboard);
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 9.8.0.sw
     */ HostEvent["SetHiddenTabs"] = "SetPinboardHiddenTabs";
    /**
     * Get the Answer session for a Search or
     * Liveboard visualization.
     *
     * Note: This event is not typically used directly. Instead, use the
     * `getAnswerService()` method on the embed instance to get an AnswerService
     * object that provides a more convenient interface for working with answers.
     *
     * @example
     * ```js
     * // Preferred way to get an AnswerService
     * const service = await embed.getAnswerService();
     *
     * // Alternative direct usage (not recommended)
     * const {session} = await embed.trigger(
     *  HostEvent.GetAnswerSession, {
     *      vizId: '123', // For Liveboard Visualization.
     *  })
     * ```
     * @example
     * ```js
     * // Preferred way to get an AnswerService
     * const service = await embed.getAnswerService();
     *
     * // Alternative direct usage (not recommended)
     * const {session} = await embed.trigger( HostEvent.GetAnswerSession )
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot: 9.10.0.cl, 10.1.0.sw
     */ HostEvent["GetAnswerSession"] = "getAnswerSession";
    /**
     * Trigger the *Ask Sage* action for visualizations
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.AskSage,
     * {vizId:'730496d6-6903-4601-937e-2c691821af3c'})
     * ```
     * @version SDK: 1.29.0 | ThoughtSpot Cloud: 9.12.0.cl
     */ HostEvent["AskSage"] = "AskSage";
    /**
     * Trigger cross filter update action on a Liveboard.
     *
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdateCrossFilter, {
     *      vizId: 'b535c760-8bbe-4e6f-bb26-af56b4129a1e',
     *      conditions: [
     *      { columnName: 'Category', values: ['mfgr#12','mfgr#14'] },
     *      { columnName: 'color', values: ['mint','hot'] },
     *    ],
     * });
     * ```
     * @version SDK: 1.29.0 | ThoughtSpot Cloud: 10.0.0.cl, 10.1.0.sw
     */ HostEvent["UpdateCrossFilter"] = "UpdateCrossFilter";
    /**
     * Trigger reset action for a personalized Liveboard view.
     * This event is deprecated. Use {@link HostEvent.ResetLiveboardPersonalizedView} instead.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.ResetLiveboardPersonalisedView);
     * ```
     * @version SDK: 1.29.0 | ThoughtSpot Cloud: 10.1.0.cl, 10.1.0.sw
     * @deprecated SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ HostEvent["ResetLiveboardPersonalisedView"] = "ResetLiveboardPersonalisedView";
    /**
     * Trigger reset action for a personalized Liveboard view.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.ResetLiveboardPersonalizedView);
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ HostEvent["ResetLiveboardPersonalizedView"] = "ResetLiveboardPersonalisedView";
    /**
     * Triggers an action to update Parameter values on embedded
     * Answers, Liveboard, and Spotter answer in Edit mode.
     * @param - Includes the following keys for each item:
     * - `name`: Name of the parameter.
     * - `value`: The value to set for the parameter.
     * - `isVisibleToUser`: Optional. To control the visibility of the parameter chip.
     *
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdateParameters, [{
     *   name: "Integer Range Param",
     *   value: 10,
     *   isVisibleToUser: false
     * }])
     * ```
     * @example
     * ```js
     * // Update parameters from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.UpdateParameters, [{
     *     name: "Region Param",
     *     value: "West",
     *     isVisibleToUser: true
     * }], ContextType.Liveboard);
     * ```
     * @version SDK: 1.29.0 | ThoughtSpot: 10.1.0.cl, 10.1.0.sw
     */ HostEvent["UpdateParameters"] = "UpdateParameters";
    /**
     * Triggers GetParameters to fetch the runtime Parameters.
     * @param - `vizId` refers to the Answer ID in Spotter embed and is required in Spotter embed.
     * ```js
     * liveboardEmbed.trigger(HostEvent.GetParameters).then((parameter) => {
     *  console.log('parameters', parameter);
     * });
     * ```
     * ```js
     * // You can use the Data event dispatched on each answer creation to get the vizId and use in GetParameters host event.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.GetParameters, { vizId: latestSpotterVizId });
     *```
     * @example
     * ```js
     * // Get parameters from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.GetParameters, {}, ContextType.Liveboard).then((parameters) => {
     *     console.log('parameters', parameters);
     * });
     * ```
     * @version SDK: 1.29.0 | ThoughtSpot: 10.1.0.cl, 10.1.0.sw
     */ HostEvent["GetParameters"] = "GetParameters";
    /**
     * Triggers an event to update a personalized view of a Liveboard.
     * This event is deprecated. Use {@link HostEvent.UpdatePersonalizedView} instead.
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdatePersonalisedView, {viewId: '1234'})
     * ```
     * @example
     * ```js
     * // Update personalized view from liveboard context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * liveboardEmbed.trigger(HostEvent.UpdatePersonalisedView, {
     *     viewId: '1234'
     * }, ContextType.Liveboard);
     * ```
     * @version SDK: 1.36.0 | ThoughtSpot: 10.6.0.cl
     * @deprecated SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ HostEvent["UpdatePersonalisedView"] = "UpdatePersonalisedView";
    /**
     * Triggers an event to update a personalized view of a Liveboard.
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdatePersonalisedView, {viewId: '1234'})
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ HostEvent["UpdatePersonalizedView"] = "UpdatePersonalisedView";
    /**
     * Triggers selection of a specific Personalized View on a
     * Liveboard without reloading the embed. Pass either a
     * `viewId` (GUID) or `viewName`. If both are provided, `viewId` takes precedence.
     * If neither is provided, the Liveboard resets to the original/default view.
     * When a `viewName` is provided and multiple views share
     * the same name, the first match is selected.
     * @example
     * ```js
     * liveboardEmbed.trigger(
     *   HostEvent.SelectPersonalizedView,
     *   { viewId: '2a021a12-1aed-425d-984b-141ee916ce72' },
     * )
     * ```
     * @example
     * ```js
     * // Select by name
     * liveboardEmbed.trigger(
     *   HostEvent.SelectPersonalizedView,
     *   { viewName: 'Dr Smith Cardiology' },
     * )
     * ```
     * @example
     * ```js
     * // Reset to default view
     * liveboardEmbed.trigger(
     *   HostEvent.SelectPersonalizedView,
     *   {},
     * )
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ HostEvent["SelectPersonalizedView"] = "SelectPersonalisedView";
    /**
     * @hidden
     * Notify when info call is completed successfully
     * ```js
     * liveboardEmbed.trigger(HostEvent.InfoSuccess, data);
     * ```
     * @version SDK: 1.36.0 | ThoughtSpot: 10.6.0.cl
     */ HostEvent["InfoSuccess"] = "InfoSuccess";
    /**
     * Trigger the save action for an Answer.
     * To programmatically save an answer without opening the
     * *Describe your Answer* modal, define the `name` and `description`
     * properties.
     * If no parameters are specified, the save action is
     * triggered with a modal to prompt users to
     * add a name and description for the Answer.
     * @param - Includes the following keys:
     * - `vizId`: Refers to the Answer ID in Spotter embed and is **required** in Spotter
     * embed.
     * - `name`: Optional. Name string for the Answer.
     * - `description`: Optional. Description text for the Answer.
     * @example
     * ```js
     * const saveAnswerResponse = await searchEmbed.trigger(HostEvent.SaveAnswer, {
     *      name: "Sales by states",
     *      description: "Total sales by states in MidWest"
     *   });
     * ```
     * @example
     * ```js
     * // You can use the Data event dispatched on each answer creation to get the vizId and use in SaveAnswer host event.
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.SaveAnswer, { vizId: latestSpotterVizId });
     * ```
     * @example
     * ```js
     * // Using context parameter to save answer from search context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * const saveAnswerResponse = await appEmbed.trigger(HostEvent.SaveAnswer, {
     *      name: "Regional sales analysis",
     *      description: "Sales breakdown by region"
     *   }, ContextType.Search);
     * ```
     * @example
     * ```js
     * // Save answer from answer context (explore modal)
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * const saveAnswerResponse = await appEmbed.trigger(HostEvent.SaveAnswer, {
     *      name: "Modified analysis",
     *      description: "Updated from explore view"
     *   }, ContextType.Answer);
     * ```
     * @example
     * ```js
     * // Save answer from spotter context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * const saveAnswerResponse = await appEmbed.trigger(HostEvent.SaveAnswer, {
     *      vizId: latestSpotterVizId,
     *      name: "AI insights",
     *      description: "Generated from Spotter"
     *   }, ContextType.Spotter);
     * ```
     * @version SDK: 1.36.0 | ThoughtSpot: 10.6.0.cl
     */ HostEvent["SaveAnswer"] = "saveAnswer";
    /**
     * EmbedApi
     * @hidden
     */ HostEvent["UIPassthrough"] = "UiPassthrough";
    /**
     * Triggers the table visualization re-render with the updated data.
     * Includes the following properties:
     * @param - `columnDataLite` - an array of object containing the
     * data value modifications retrieved from the `EmbedEvent.TableVizRendered`
     * payload.For example, { columnDataLite: []}`.
     *
     * @example
     * ```js
     * searchEmbed.on(EmbedEvent.TableVizRendered, (payload) => {
     *      console.log(payload);
     *      const columnDataLite = payload.data.data.columnDataLite;
     *      columnDataLite[0].dataValue[0]="new fob";
     *      console.log('>>> new Data', columnDataLite);
     *      searchEmbed.trigger(HostEvent.TransformTableVizData, columnDataLite);
     * })
     * ```
     * @version SDK: 1.37.0 | ThoughtSpot: 10.8.0.cl
     */ HostEvent["TransformTableVizData"] = "TransformTableVizData";
    /**
     * Triggers a search operation with the search tokens specified in
     * the search query string in spotter embed.
     * @param - Includes the following keys:
     * - `query`: Text string in Natural Language format.
     * - `executeSearch`: Boolean to execute search and update search query.
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.SpotterSearch, {
     *  query: 'revenue per year',
     *  executeSearch: true,
     * })
     * ```
     * @example
     * ```js
     * // Spotter search from spotter context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * spotterEmbed.trigger(HostEvent.SpotterSearch, {
     *     query: 'sales by region',
     *     executeSearch: true
     * }, ContextType.Spotter);
     * ```
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HostEvent["SpotterSearch"] = "SpotterSearch";
    /**
     * Edits the last prompt in spotter embed.
     * @param - `query`: Text string
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.EditLastPrompt, "revenue per year");
     * ```
     * @example
     * ```js
     * // Edit last prompt from spotter context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * spotterEmbed.trigger(HostEvent.EditLastPrompt, "sales by region", ContextType.Spotter);
     * ```
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HostEvent["EditLastPrompt"] = "EditLastPrompt";
    /**
     * Opens the data source preview modal in Spotter Embed.
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.PreviewSpotterData);
     * ```
     * @example
     * ```js
     * // Preview spotter data from spotter context
     * import { ContextType } from '@thoughtspot/visual-embed-sdk';
     * spotterEmbed.trigger(HostEvent.PreviewSpotterData, {}, ContextType.Spotter);
     * ```
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HostEvent["PreviewSpotterData"] = "PreviewSpotterData";
    /**
     * Opens the Add to Coaching modal from a visualization in Spotter Embed.
     * @param - `vizId ` refers to the Visualization ID in Spotter embed and is required.
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.AddToCoaching, { vizId: '730496d6-6903-4601-937e-2c691821af3c' });
     *
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot: 26.2.0.cl
     */ HostEvent["AddToCoaching"] = "addToCoaching";
    /**
     * Opens the data model instructions modal in Spotter Embed.
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.DataModelInstructions);
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot: 26.3.0.cl
     */ HostEvent["DataModelInstructions"] = "DataModelInstructions";
    /**
     * Resets the Spotter Embed Conversation.
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.ResetSpotterConversation);
     * ```
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HostEvent["ResetSpotterConversation"] = "ResetSpotterConversation";
    /**
     * Deletes the last prompt in spotter embed.
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.DeleteLastPrompt);
     * ```
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HostEvent["DeleteLastPrompt"] = "DeleteLastPrompt";
    /**
     * Toggle the visualization to chart or table view.
     * @param - `vizId ` refers to the Visualization ID in Spotter embed and is required.
     * @example
     * ```js
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.AnswerChartSwitcher, { vizId: latestSpotterVizId });
     * ```
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HostEvent["AnswerChartSwitcher"] = "answerChartSwitcher";
    /**
     * @hidden
     * Trigger exit from presentation mode when user exits fullscreen.
     * This is automatically triggered by the SDK when fullscreen mode is exited.
     * ```js
     * liveboardEmbed.trigger(HostEvent.ExitPresentMode);
     * ```
     * @version SDK: 1.40.0 | ThoughtSpot: 10.11.0.cl
     */ HostEvent["ExitPresentMode"] = "exitPresentMode";
    /**
     * Triggers the full height lazy load data.
     * @example
     * ```js
     * liveboardEmbed.on(EmbedEvent.RequestVisibleEmbedCoordinates, (payload) => {
     *      console.log(payload);
     * });
     * ```
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     *
     * @hidden
     */ HostEvent["VisibleEmbedCoordinates"] = "visibleEmbedCoordinates";
    /**
     * Trigger the *Spotter* action for visualizations present on the liveboard's vizzes.
     * @param - `vizId` refers to the Visualization ID in Spotter embed and is required.
     * @example
     * ```js
     * let latestSpotterVizId = '';
     * spotterEmbed.on(EmbedEvent.Data, (payload) => {
     *   latestSpotterVizId = payload.data.id;
     * });
     *
     * spotterEmbed.trigger(HostEvent.AskSpotter, { vizId: latestSpotterVizId });
     * ```
     * @version SDK: 1.41.0 | ThoughtSpot: 10.12.0.cl
     */ HostEvent["AskSpotter"] = "AskSpotter";
    /**
     * @hidden
     * Triggers the update of the embed params.
     *
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.UpdateEmbedParams, viewConfig);
     * ```
     */ HostEvent["UpdateEmbedParams"] = "updateEmbedParams";
    /**
     * Triggered when the embed needs to be destroyed. This is used to clean up any embed-related resources internally.
     * @example
     * ```js
     * liveboardEmbed.trigger(HostEvent.DestroyEmbed);
     * ```
     * @version SDK: 1.41.0 | ThoughtSpot: 10.12.0.cl
     */ HostEvent["DestroyEmbed"] = "EmbedDestroyed";
    /**
     * Triggers a new conversation in Spotter embed.
     *
     * This feature is available only when chat history is enabled on your ThoughtSpot
     * instance. Contact your admin or ThoughtSpot Support to enable chat history on your
     * instance.
     *
     * @example
     * ```js
     * spotterEmbed.trigger(HostEvent.StartNewSpotterConversation);
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot: 26.2.0.cl
     */ HostEvent["StartNewSpotterConversation"] = "StartNewSpotterConversation";
    /**
     * @hidden
     * Get the current context of the embedded page.
     *
     * @example
     * ```js
     * const context = await liveboardEmbed.trigger(HostEvent.GetPageContext);
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot: 26.2.0.cl
     */ HostEvent["GetPageContext"] = "GetPageContext";
})($a2210daac95811c7$export$2cab83a5627bcd4c || ($a2210daac95811c7$export$2cab83a5627bcd4c = {}));
var $a2210daac95811c7$export$7a1114f3cd20ec44;
(function(DataSourceVisualMode) {
    /**
     * The data source panel is hidden.
     */ DataSourceVisualMode["Hidden"] = "hide";
    /**
     * The data source panel is collapsed, but the user can manually expand it.
     */ DataSourceVisualMode["Collapsed"] = "collapse";
    /**
     * The data source panel is expanded, but the user can manually collapse it.
     */ DataSourceVisualMode["Expanded"] = "expand";
})($a2210daac95811c7$export$7a1114f3cd20ec44 || ($a2210daac95811c7$export$7a1114f3cd20ec44 = {}));
var $a2210daac95811c7$export$1ca45c9a47aec42c;
(function(Param) {
    Param["Tsmcp"] = "tsmcp";
    Param["EmbedApp"] = "embedApp";
    Param["DataSources"] = "dataSources";
    Param["DataSourceMode"] = "dataSourceMode";
    Param["DisableActions"] = "disableAction";
    Param["DisableActionReason"] = "disableHint";
    Param["ForceTable"] = "forceTable";
    Param["preventLiveboardFilterRemoval"] = "preventPinboardFilterRemoval";
    Param["SearchQuery"] = "searchQuery";
    Param["HideActions"] = "hideAction";
    Param["HideObjects"] = "hideObjects";
    Param["HostAppUrl"] = "hostAppUrl";
    Param["EnableVizTransformations"] = "enableVizTransform";
    Param["EnableSearchAssist"] = "enableSearchAssist";
    Param["EnablePendoHelp"] = "enablePendoHelp";
    Param["HideResult"] = "hideResult";
    Param["UseLastSelectedDataSource"] = "useLastSelectedSources";
    Param["Tag"] = "tag";
    Param["HideTagFilterChips"] = "hideTagFilterChips";
    Param["AutoLogin"] = "autoLogin";
    Param["searchTokenString"] = "searchTokenString";
    Param["executeSearch"] = "executeSearch";
    Param["fullHeight"] = "isFullHeightPinboard";
    Param["livedBoardEmbed"] = "isLiveboardEmbed";
    Param["searchEmbed"] = "isSearchEmbed";
    Param["vizEmbed"] = "isVizEmbed";
    Param["StringIDsUrl"] = "overrideStringIDsUrl";
    Param["Version"] = "sdkVersion";
    Param["ViewPortHeight"] = "viewPortHeight";
    Param["ViewPortWidth"] = "viewPortWidth";
    Param["VisibleActions"] = "visibleAction";
    Param["DisableLoginRedirect"] = "disableLoginRedirect";
    Param["visibleVizs"] = "pinboardVisibleVizs";
    Param["LiveboardV2Enabled"] = "isPinboardV2Enabled";
    Param["DataPanelV2Enabled"] = "enableDataPanelV2";
    Param["ShowAlerts"] = "showAlerts";
    Param["Locale"] = "locale";
    Param["CustomStyle"] = "customStyle";
    Param["ForceSAMLAutoRedirect"] = "forceSAMLAutoRedirect";
    // eslint-disable-next-line @typescript-eslint/no-shadow
    Param["AuthType"] = "authType";
    Param["IconSpriteUrl"] = "iconSprite";
    Param["cookieless"] = "cookieless";
    // Deprecated: `isContextMenuEnabledOnLeftClick`
    // Introduced: `contextMenuEnabledOnWhichClick` with values: 'left',
    // 'right', or 'both'. This update only affects ThoughtSpot URL parameters
    // and does not impact existing workflows or use cases. Added support for
    // 'both' clicks in `contextMenuTrigger` configuration.
    Param["ContextMenuTrigger"] = "contextMenuEnabledOnWhichClick";
    Param["LinkOverride"] = "linkOverride";
    Param["EnableLinkOverridesV2"] = "enableLinkOverridesV2";
    Param["blockNonEmbedFullAppAccess"] = "blockNonEmbedFullAppAccess";
    Param["ShowInsertToSlide"] = "insertInToSlide";
    Param["PrimaryNavHidden"] = "primaryNavHidden";
    Param["HideProfleAndHelp"] = "profileAndHelpInNavBarHidden";
    Param["NavigationVersion"] = "navigationVersion";
    Param["HideHamburger"] = "hideHamburger";
    Param["HideObjectSearch"] = "hideObjectSearch";
    Param["HideNotification"] = "hideNotification";
    Param["HideApplicationSwitcher"] = "applicationSwitcherHidden";
    Param["HideOrgSwitcher"] = "orgSwitcherHidden";
    Param["HideWorksheetSelector"] = "hideWorksheetSelector";
    Param["DisableWorksheetChange"] = "disableWorksheetChange";
    Param["HideSourceSelection"] = "hideSourceSelection";
    Param["DisableSourceSelection"] = "disableSourceSelection";
    Param["HideEurekaResults"] = "hideEurekaResults";
    Param["HideEurekaSuggestions"] = "hideEurekaSuggestions";
    Param["HideAutocompleteSuggestions"] = "hideAutocompleteSuggestions";
    Param["HideLiveboardHeader"] = "hideLiveboardHeader";
    Param["ShowLiveboardDescription"] = "showLiveboardDescription";
    Param["ShowLiveboardTitle"] = "showLiveboardTitle";
    Param["ShowMaskedFilterChip"] = "showMaskedFilterChip";
    Param["IsLiveboardMasterpiecesEnabled"] = "isLiveboardMasterpiecesEnabled";
    Param["HiddenTabs"] = "hideTabs";
    Param["VisibleTabs"] = "visibleTabs";
    Param["HideTabPanel"] = "hideTabPanel";
    Param["HideSampleQuestions"] = "hideSampleQuestions";
    Param["WorksheetId"] = "worksheet";
    Param["Query"] = "query";
    Param["HideHomepageLeftNav"] = "hideHomepageLeftNav";
    Param["ModularHomeExperienceEnabled"] = "modularHomeExperience";
    Param["HomepageVersion"] = "homepageVersion";
    Param["ListPageVersion"] = "listpageVersion";
    Param["PendoTrackingKey"] = "additionalPendoKey";
    Param["LiveboardHeaderSticky"] = "isLiveboardHeaderSticky";
    Param["IsProductTour"] = "isProductTour";
    Param["HideSearchBarTitle"] = "hideSearchBarTitle";
    Param["HideSageAnswerHeader"] = "hideSageAnswerHeader";
    Param["HideSearchBar"] = "hideSearchBar";
    Param["ClientLogLevel"] = "clientLogLevel";
    Param["ExposeTranslationIDs"] = "exposeTranslationIDs";
    Param["OverrideNativeConsole"] = "overrideConsoleLogs";
    Param["enableAskSage"] = "enableAskSage";
    Param["CollapseSearchBarInitially"] = "collapseSearchBarInitially";
    Param["DataPanelCustomGroupsAccordionInitialState"] = "dataPanelCustomGroupsAccordionInitialState";
    Param["EnableCustomColumnGroups"] = "enableCustomColumnGroups";
    Param["DateFormatLocale"] = "dateFormatLocale";
    Param["NumberFormatLocale"] = "numberFormatLocale";
    Param["CurrencyFormat"] = "currencyFormat";
    Param["Enable2ColumnLayout"] = "enable2ColumnLayout";
    Param["IsFullAppEmbed"] = "isFullAppEmbed";
    Param["IsOnBeforeGetVizDataInterceptEnabled"] = "isOnBeforeGetVizDataInterceptEnabled";
    Param["FocusSearchBarOnRender"] = "focusSearchBarOnRender";
    Param["DisableRedirectionLinksInNewTab"] = "disableRedirectionLinksInNewTab";
    Param["HomePageSearchBarMode"] = "homePageSearchBarMode";
    Param["ShowLiveboardVerifiedBadge"] = "showLiveboardVerifiedBadge";
    Param["ShowLiveboardReverifyBanner"] = "showLiveboardReverifyBanner";
    Param["LiveboardHeaderV2"] = "isLiveboardHeaderV2Enabled";
    Param["HideIrrelevantFiltersInTab"] = "hideIrrelevantFiltersAtTabLevel";
    Param["IsEnhancedFilterInteractivityEnabled"] = "isLiveboardPermissionV2Enabled";
    Param["SpotterEnabled"] = "isSpotterExperienceEnabled";
    Param["IsUnifiedSearchExperienceEnabled"] = "isUnifiedSearchExperienceEnabled";
    Param["OverrideOrgId"] = "orgId";
    Param["OauthPollingInterval"] = "oAuthPollingInterval";
    Param["IsForceRedirect"] = "isForceRedirect";
    Param["DataSourceId"] = "dataSourceId";
    Param["preAuthCache"] = "preAuthCache";
    Param["ShowSpotterLimitations"] = "showSpotterLimitations";
    Param["CoverAndFilterOptionInPDF"] = "arePdfCoverFilterPageCheckboxesEnabled";
    Param["PrimaryAction"] = "primaryAction";
    Param["isSpotterAgentEmbed"] = "isSpotterAgentEmbed";
    Param["IsLiveboardStylingAndGroupingEnabled"] = "isLiveboardStylingAndGroupingEnabled";
    Param["IsLazyLoadingForEmbedEnabled"] = "isLazyLoadingForEmbedEnabled";
    Param["RootMarginForLazyLoad"] = "rootMarginForLazyLoad";
    Param["isPNGInScheduledEmailsEnabled"] = "isPNGInScheduledEmailsEnabled";
    Param["IsWYSIWYGLiveboardPDFEnabled"] = "isWYSIWYGLiveboardPDFEnabled";
    Param["isLiveboardXLSXCSVDownloadEnabled"] = "isLiveboardXLSXCSVDownloadEnabled";
    Param["isGranularXLSXCSVSchedulesEnabled"] = "isGranularXLSXCSVSchedulesEnabled";
    Param["isCentralizedLiveboardFilterUXEnabled"] = "isCentralizedLiveboardFilterUXEnabled";
    Param["isLinkParametersEnabled"] = "isLinkParametersEnabled";
    Param["EnablePastConversationsSidebar"] = "enablePastConversationsSidebar";
    Param["UpdatedSpotterChatPrompt"] = "updatedSpotterChatPrompt";
    Param["EnableStopAnswerGenerationEmbed"] = "enableStopAnswerGenerationEmbed";
    Param["SpotterSidebarTitle"] = "spotterSidebarTitle";
    Param["SpotterSidebarDefaultExpanded"] = "spotterSidebarDefaultExpanded";
    Param["SpotterChatRenameLabel"] = "spotterChatRenameLabel";
    Param["SpotterChatDeleteLabel"] = "spotterChatDeleteLabel";
    Param["SpotterDeleteConversationModalTitle"] = "spotterDeleteConversationModalTitle";
    Param["SpotterPastConversationAlertMessage"] = "spotterPastConversationAlertMessage";
    Param["SpotterDocumentationUrl"] = "spotterDocumentationUrl";
    Param["SpotterBestPracticesLabel"] = "spotterBestPracticesLabel";
    Param["SpotterConversationsBatchSize"] = "spotterConversationsBatchSize";
    Param["SpotterNewChatButtonTitle"] = "spotterNewChatButtonTitle";
    Param["IsThisPeriodInDateFiltersEnabled"] = "isThisPeriodInDateFiltersEnabled";
    Param["HideToolResponseCardBranding"] = "hideToolResponseCardBranding";
    Param["ToolResponseCardBrandingLabel"] = "toolResponseCardBrandingLabel";
    Param["EnableHomepageAnnouncement"] = "enableHomepageAnnouncement";
})($a2210daac95811c7$export$1ca45c9a47aec42c || ($a2210daac95811c7$export$1ca45c9a47aec42c = {}));
var $a2210daac95811c7$export$e19cd5f9376f8cee;
(function(Action) {
    /**
     * The **Save** action on an Answer or Liveboard.
     * Allows users to save the changes.
     * @example
     * ```js
     * disabledActions: [Action.Save]
     * ```
     */ Action["Save"] = "save";
    /**
     * @hidden
     */ Action["Update"] = "update";
    /**
     * @hidden
     */ Action["SaveUntitled"] = "saveUntitled";
    /**
     * The **Save as View** action on the Answer
     * page. Saves an Answer as a View object in the full
     * application embedding mode.
     * @example
     * ```js
     * disabledActions: [Action.SaveAsView]
     * ```
     */ Action["SaveAsView"] = "saveAsView";
    /**
     * The **Make a copy** action on a Liveboard or Answer
     * page. Creates a copy of the Liveboard.
     * In LiveboardEmbed, the **Make a copy** action is not available for
     * visualizations in the embedded Liveboard view.
     * In AppEmbed, the **Make a copy** action is available on both
     * Liveboards and visualizations.
     * @example
     * ```js
     * disabledActions: [Action.MakeACopy]
     * ```
     */ Action["MakeACopy"] = "makeACopy";
    /**
     * The **Copy and Edit** action on a Liveboard.
     * This action is now replaced with `Action.MakeACopy`.
     * @example
     * ```js
     * disabledActions: [Action.EditACopy]
     * ```
     */ Action["EditACopy"] = "editACopy";
    /**
     * The **Copy link** menu action on a Liveboard visualization.
     * Copies the visualization URL
     * @example
     * ```js
     * disabledActions: [Action.CopyLink]
     * ```
     */ Action["CopyLink"] = "embedDocument";
    /**
     * @hidden
     */ Action["ResetLayout"] = "resetLayout";
    /**
     * The **Schedule** menu action on a Liveboard.
     * Allows scheduling a Liveboard job, for example,
     * sending periodic notifications.
     * @example
     * ```js
     * disabledActions: [Action.Schedule]
     * ```
     */ Action["Schedule"] = "subscription";
    /**
     * The **Manage schedules** menu action on a Liveboard.
     * Allows users to manage scheduled Liveboard jobs.
     * @example
     * ```js
     * disabledActions: [Action.SchedulesList]
     * ```
     */ Action["SchedulesList"] = "schedule-list";
    /**
     * The **Share** action on a Liveboard, Answer, or Model.
     * Allows users to share an object with other users and groups.
     * @example
     * ```js
     * disabledActions: [Action.Share]
     * ```
     */ Action["Share"] = "share";
    /**
     * The **Add filter** action on a Liveboard page.
     * Allows adding filters to visualizations on a Liveboard.
     * @example
     * ```js
     * disabledActions: [Action.AddFilter]
     * ```
     */ Action["AddFilter"] = "addFilter";
    /**
     * The **Add Data Panel Objects** action on the data panel v2.
     * Allows to show action menu to add different objects (such as
     * formulas, Parameters) in data panel new experience.
     * @example
     * ```js
     * disabledActions: [Action.AddDataPanelObjects]
     * ```
     * @version SDK: 1.32.0 | ThoughtSpot: 10.0.0.cl, 10.1.0.sw
     */ Action["AddDataPanelObjects"] = "addDataPanelObjects";
    /**
     * The filter configuration options for a Liveboard.
     * The configuration options are available when adding
     * filters on a Liveboard.
     *
     * @example
     * ```js
     * disabledActions: [Action.ConfigureFilter]
     * ```
     */ Action["ConfigureFilter"] = "configureFilter";
    /**
     * The **Collapse data sources** icon on the Search page.
     * Collapses the panel showing data sources.
     *
     * @example
     * ```js
     * disabledActions: [Action.CollapseDataPanel]
     * ```
     * @version SDK: 1.1.0 | ThoughtSpot Cloud: ts7.may.cl, 8.4.1.sw
     */ Action["CollapseDataSources"] = "collapseDataSources";
    /**
     * The **Collapse data panel** icon on the Search page.
     * Collapses the data panel view.
     *
     * @version SDK: 1.34.0 | ThoughtSpot Cloud: 10.3.0.cl
     *
     * @example
     * ```js
     * disabledActions: [Action.CollapseDataPanel]
     * ```
     */ Action["CollapseDataPanel"] = "collapseDataPanel";
    /**
     * The **Choose sources** button on Search page.
     * Allows selecting data sources for search queries.
     * @example
     * ```js
     * disabledActions: [Action.ChooseDataSources]
     * ```
     */ Action["ChooseDataSources"] = "chooseDataSources";
    /**
     * The **Create formula** action on a Search or Answer page.
     * Allows adding formulas to an Answer.
     * @example
     * ```js
     * disabledActions: [Action.AddFormula]
     * ```
     */ Action["AddFormula"] = "addFormula";
    /**
     * The **Add parameter** action on a Liveboard or Answer.
     * Allows adding Parameters to a Liveboard or Answer.
     * @example
     * ```js
     * disabledActions: [Action.AddParameter]
     * ```
     */ Action["AddParameter"] = "addParameter";
    /**
     * The **Add Column Set** action on a Answer.
     * Allows adding column sets to a Answer.
     * @example
     * ```js
     * disabledActions: [Action.AddColumnSet]
     * ```
     * @version SDK: 1.32.0 | ThoughtSpot: 10.0.0.cl, 10.1.0.sw
     */ Action["AddColumnSet"] = "addSimpleCohort";
    /**
     * The **Add Query Set** action on a Answer.
     * Allows adding query sets to a Answer.
     * @example
     * ```js
     * disabledActions: [Action.AddQuerySet]
     * ```
     * @version SDK: 1.32.0 | ThoughtSpot: 10.0.0.cl, 10.1.0.sw
     */ Action["AddQuerySet"] = "addAdvancedCohort";
    /**
     * @hidden
     */ Action["SearchOnTop"] = "searchOnTop";
    /**
     * The **SpotIQ analyze** menu action on a visualization or
     * Answer page.
     * @example
     * ```js
     * disabledActions: [Action.SpotIQAnalyze]
     * ```
     */ Action["SpotIQAnalyze"] = "spotIQAnalyze";
    /**
     * @hidden
     */ Action["ExplainInsight"] = "explainInsight";
    /**
     * @hidden
     */ Action["SpotIQFollow"] = "spotIQFollow";
    /**
     * The Share action for a Liveboard visualization.
     */ Action["ShareViz"] = "shareViz";
    /**
     * @hidden
     */ Action["ReplaySearch"] = "replaySearch";
    /**
     * The **Show underlying data** menu action on a
     * visualization or Answer page.
     * Displays detailed information and raw data
     * for a given visualization.
     * @example
     * ```js
     * disabledActions: [Action.ShowUnderlyingData]
     * ```
     */ Action["ShowUnderlyingData"] = "showUnderlyingData";
    /**
     * The **Download** menu action on Liveboard
     * visualizations and Answers.
     * Allows downloading a visualization or Answer.
     * @example
     * ```js
     * disabledActions: [Action.DownloadAsPng]
     * ```
     */ Action["Download"] = "download";
    /**
     * The **Download** > **PNG** menu action for charts on a Liveboard
     * or Answer page.
     * Downloads a visualization or Answer as a PNG file.
     * @example
     * ```js
     * disabledActions: [Action.DownloadAsPng]
     * ```
     */ Action["DownloadAsPng"] = "downloadAsPng";
    /**
     *
     *The **Download PDF** action that downloads a Liveboard,
     * visualization, or Answer as a PDF file.
     *
     * **NOTE**: The **Download** > **PDF** option is available for
     * tables in visualizations and Answers.
     * @example
     * ```js
     * disabledActions: [Action.DownloadAsPdf]
     * ```
     */ Action["DownloadAsPdf"] = "downloadAsPdf";
    /**
     * The **Download** > **CSV** menu action for tables on a Liveboard
     * or Answer page.
     * Downloads a visualization or Answer in the XLSX format.
     * @example
     * ```js
     * disabledActions: [Action.DownloadAsCsv]
     * ```
     */ Action["DownloadAsCsv"] = "downloadAsCSV";
    /**
     * The **Download** > **XLSX** menu action for tables on a Liveboard
     * or Answer page.
     * Downloads a visualization or Answer in the XLSX format.
     * @example
     * ```js
     * disabledActions: [Action.DownloadAsXlsx]
     * ```
     */ Action["DownloadAsXlsx"] = "downloadAsXLSX";
    /**
     * The **Download Liveboard** menu action on a Liveboard.
     * Allows downloading the entire Liveboard.
     * @example
     * ```js
     * disabledActions: [Action.DownloadLiveboard]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot: 26.3.0.cl
     */ Action["DownloadLiveboard"] = "downloadLiveboard";
    /**
     * The **Download Liveboard as Continuous PDF** menu action on a Liveboard.
     * Allows downloading the entire Liveboard as a continuous PDF.
     * @example
     * ```js
     * disabledActions: [Action.DownloadLiveboardAsContinuousPDF]
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ Action["DownloadLiveboardAsContinuousPDF"] = "downloadLiveboardAsContinuousPDF";
    /**
     * @hidden
     */ Action["DownloadTrace"] = "downloadTrace";
    /**
     * The **Export TML** menu action on a Liveboard, Answer, and
     * the Data Workspace pages for data objects and connections.
     *
     * Allows exporting an object as a TML file.
     *
     * @example
     * ```js
     * disabledActions: [Action.ExportTML]
     * ```
     */ Action["ExportTML"] = "exportTSL";
    /**
     * The **Import TML** menu action on the
     * *Data Workspace* > *Utilities* page.
     * Imports TML representation of ThoughtSpot objects.
     * @example
     * ```js
     * disabledActions: [Action.ImportTML]
     * ```
     */ Action["ImportTML"] = "importTSL";
    /**
     * The **Update TML** menu action for Liveboards and Answers.
     * Updates TML representation of ThoughtSpot objects.
     * @example
     * ```js
     * disabledActions: [Action.UpdateTML]
     * ```
     */ Action["UpdateTML"] = "updateTSL";
    /**
     * The **Edit TML** menu action for Liveboards and Answers.
     * Opens the TML editor.
     * @example
     * ```js
     * disabledActions: [Action.EditTML]
     * ```
     */ Action["EditTML"] = "editTSL";
    /**
     * The **Present** menu action for Liveboards and Answers.
     * Allows presenting a Liveboard or visualization in
     * slideshow mode.
     * @example
     * ```js
     * disabledActions: [Action.Present]
     * ```
     */ Action["Present"] = "present";
    /**
     * The visualization tile resize option.
     * Also available via More `...` options menu on a visualization.
     * Allows resizing visualization tiles and switching
     * between different preset layout option.
     *
     * @example
     * ```js
     * disabledActions: [Action.ToggleSize]
     * ```
     */ Action["ToggleSize"] = "toggleSize";
    /**
     * The *Edit* action on the Liveboard page and in the
     * visualization menu.
     * Opens a Liveboard or visualization in edit mode.
     * @example
     * ```js
     * disabledActions: [Action.Edit]
     * ```
     */ Action["Edit"] = "edit";
    /**
     * The text edit option for Liveboard and visualization titles.
     * @example
     * ```js
     * disabledActions: [Action.EditTitle]
     * ```
     */ Action["EditTitle"] = "editTitle";
    /**
     * The **Delete** action on a Liveboard, *Liveboards* and
     * *Answers* list pages in full application embedding.
     *
     * @example
     * ```js
     * disabledActions: [Action.Remove]
     * ```
     */ Action["Remove"] = "delete";
    /**
     * @hidden
     */ Action["Ungroup"] = "ungroup";
    /**
     * @hidden
     */ Action["Describe"] = "describe";
    /**
     * @hidden
     */ Action["Relate"] = "relate";
    /**
     * @hidden
     */ Action["CustomizeHeadlines"] = "customizeHeadlines";
    /**
     * @hidden
     */ Action["PinboardInfo"] = "pinboardInfo";
    /**
     * The **Show Liveboard details** menu action on a Liveboard.
     * Displays details such as the name, description, and
     * author of the Liveboard, and timestamp of Liveboard creation
     * and update.
     * @example
     * ```js
     * disabledActions: [Action.LiveboardInfo]
     * ```
     */ // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Action["LiveboardInfo"] = "pinboardInfo";
    /**
     * @hidden
     */ Action["SendAnswerFeedback"] = "sendFeedback";
    /**
     * @hidden
     */ Action["DownloadEmbraceQueries"] = "downloadEmbraceQueries";
    /**
     * The **Pin** menu action on an Answer or
     * Search results page.
     * @example
     * ```js
     * disabledActions: [Action.Pin]
     * ```
     */ Action["Pin"] = "pin";
    /**
     * @hidden
     */ Action["AnalysisInfo"] = "analysisInfo";
    /**
     * The **Schedule** menu action on a Liveboard.
     * Allows scheduling a Liveboard job.
     * @example
     * ```js
     * disabledActions: [Action.Subscription]
     * ```
     */ // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    Action["Subscription"] = "subscription";
    /**
     * The **Explore** action on Liveboard visualizations
     * @example
     * ```js
     * disabledActions: [Action.Explore]
     * ```
     */ Action["Explore"] = "explore";
    /**
     * The contextual menu action to include a specific data point
     * when drilling down a table or chart on an Answer.
     *
     * @example
     * ```js
     * disabledActions: [Action.DrillInclude]
     * ```
     */ Action["DrillInclude"] = "context-menu-item-include";
    /**
     * The contextual menu action to exclude a specific data point
     * when drilling down a table or chart on an Answer.
     * @example
     * ```js
     * disabledActions: [Action.DrillInclude]
     * ```
     */ Action["DrillExclude"] = "context-menu-item-exclude";
    /**
     * The **Copy to clipboard** menu action on tables in an Answer
     * or Liveboard.
     * Copies the selected data point.
     * @example
     * ```js
     * disabledActions: [Action.CopyToClipboard]
     * ```
     */ Action["CopyToClipboard"] = "context-menu-item-copy-to-clipboard";
    Action["CopyAndEdit"] = "context-menu-item-copy-and-edit";
    /**
     * @hidden
     */ Action["DrillEdit"] = "context-menu-item-edit";
    Action["EditMeasure"] = "context-menu-item-edit-measure";
    Action["Separator"] = "context-menu-item-separator";
    /**
     * The **Drill down** menu action on Answers and Liveboard
     * visualizations.
     * Allows drilling down to a specific data point on a chart or table.
     * @example
     * ```js
     * disabledActions: [Action.DrillDown]
     * ```
     */ Action["DrillDown"] = "DRILL";
    /**
     * The request access action on Liveboards.
     * Allows users with view permissions to request edit access to a Liveboard.
     * @example
     * ```js
     * disabledActions: [Action.RequestAccess]
     * ```
     */ Action["RequestAccess"] = "requestAccess";
    /**
     * Controls the display and availability of the **Query visualizer** and
     * **Query SQL** buttons in the Query details panel on the Answer page.
     *
     * **Query visualizer** - Displays the tables and filters used in the search query.
     * **Query SQL** - Displays the SQL statements used to retrieve data for the query.
     *
     * Note: This action ID only affects the visibility of the buttons within the
     * Query details panel. It does not control the visibility
     * of the query details icon on the Answer page.
     * @example
     * ```js
     * disabledActions: [Action.QueryDetailsButtons]
     * ```
     */ Action["QueryDetailsButtons"] = "queryDetailsButtons";
    /**
     * The **Delete** action for Answers in the full application
     * embedding mode.
     * @example
     * ```js
     * disabledActions: [Action.AnswerDelete]
     * ```
     * @version SDK: 1.9.0 | ThoughtSpot: 8.1.0.cl, 8.4.1.sw
     */ Action["AnswerDelete"] = "onDeleteAnswer";
    /**
     * The chart switcher icon on Answer page and
     * visualizations in edit mode.
     * Allows switching to the table or chart mode
     * when editing a visualization.
     * @example
     * ```js
     * disabledActions: [Action.AnswerChartSwitcher]
     * ```
     * @version SDK: 1.9.0 | ThoughtSpot: 8.1.0.cl, 8.4.1.sw
     */ Action["AnswerChartSwitcher"] = "answerChartSwitcher";
    /**
     * The Favorites icon (*) for Answers,
     * Liveboard, and data objects like Model,
     * Tables and Views.
     * Allows adding an object to the user's favorites list.
     * @example
     * ```js
     * disabledActions: [Action.AddToFavorites]
     * ```
     * @version SDK: 1.9.0 | ThoughtSpot: 8.1.0.cl, 8.4.1.sw
     */ Action["AddToFavorites"] = "addToFavorites";
    /**
     * The edit icon on Liveboards (Classic experience).
     * @example
     * ```js
     * disabledActions: [Action.EditDetails]
     * ```
     * @version SDK: 1.9.0 | ThoughtSpot: 8.1.0.cl, 8.4.1.sw
     */ Action["EditDetails"] = "editDetails";
    /**
     * The *Create alert* action for KPI charts.
     * Allows users to schedule threshold-based alerts
     * for KPI charts.
     * @example
     * ```js
     * disabledActions: [Action.CreateMonitor]
     * ```
     * @version SDK: 1.11.0 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     */ Action["CreateMonitor"] = "createMonitor";
    /**
     * @version SDK: 1.11.1 | ThoughtSpot: 8.3.0.cl, 8.4.1.sw
     * @deprecated This action is deprecated. It was used for reporting errors.
     * @example
     * ```js
     * disabledActions: [Action.ReportError]
     * ```
     */ Action["ReportError"] = "reportError";
    /**
     * The **Sync to sheets** action on Answers and Liveboard visualizations.
     * Allows sending data to a Google Sheet.
     * @example
     * ```js
     * disabledActions: [Action.SyncToSheets]
     * ```
     * @version SDK: 1.18.0 | ThoughtSpot: 8.10.0.cl, 9.0.1.sw
     */ Action["SyncToSheets"] = "sync-to-sheets";
    /**
     * The **Sync to other apps** action on Answers and Liveboard visualizations.
     * Allows sending data to third-party apps like Slack, Salesforce,
     * Microsoft Teams, and so on.
     * @example
     * ```js
     * disabledActions: [Action.SyncToOtherApps]
     * ```
     * @version SDK: 1.18.0 | ThoughtSpot: 8.10.0.cl, 9.0.1.sw
     */ Action["SyncToOtherApps"] = "sync-to-other-apps";
    /**
     * The **Manage pipelines** action on Answers and Liveboard visualizations.
     * Allows users to manage data sync pipelines to third-party apps.
     * @example
     * ```js
     * disabledActions: [Action.ManagePipelines]
     * ```
     * @version SDK: 1.18.0 | ThoughtSpot: 8.10.0.cl, 9.0.1.sw
     */ Action["ManagePipelines"] = "manage-pipeline";
    /**
     * The **Filter** action on Liveboard visualizations.
     * Allows users to apply cross-filters on a Liveboard.
     * @example
     * ```js
     * disabledActions: [Action.CrossFilter]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.8.0.sw
     */ Action["CrossFilter"] = "context-menu-item-cross-filter";
    /**
     * The **Sync to Slack** action on Liveboard visualizations.
     * Allows sending data to third-party apps like Slack.
     * @example
     * ```js
     * disabledActions: [Action.SyncToSlack]
     * ```
     * @version SDK: 1.32.0 | ThoughtSpot Cloud: 10.1.0.cl
     */ Action["SyncToSlack"] = "syncToSlack";
    /**
     * The **Sync to Teams** action on Liveboard visualizations.
     * Allows sending data to third-party apps like Microsoft Teams.
     * @example
     * ```js
     * disabledActions: [Action.SyncToTeams]
     * ```
     * @version SDK: 1.32.0 | ThoughtSpot Cloud: 10.1.0.cl
     */ Action["SyncToTeams"] = "syncToTeams";
    /**
     * The **Remove** action that appears when cross filters are applied
     * on a Liveboard.
     * Removes filters applied to a visualization.
     * @example
     * ```js
     * disabledActions: [Action.RemoveCrossFilter]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["RemoveCrossFilter"] = "context-menu-item-remove-cross-filter";
    /**
     * The **Aggregate** option in the chart axis or the
     * table column customization menu.
     * Provides aggregation options to analyze the data on a chart or table.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuAggregate]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuAggregate"] = "axisMenuAggregate";
    /**
     * The **Time bucket** option in the chart axis or table column
     * customization menu.
     * Allows defining time metric for date comparison.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuTimeBucket]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuTimeBucket"] = "axisMenuTimeBucket";
    /**
     * The **Filter** action in the chart axis or table column
     * customization menu.
     * Allows adding, editing, or removing filters.
     *
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuFilter]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuFilter"] = "axisMenuFilter";
    /**
     * The **Conditional formatting** action on chart or table.
     * Allows adding rules for conditional formatting of data
     * points on a chart or table.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuConditionalFormat]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuConditionalFormat"] = "axisMenuConditionalFormat";
    /**
     * The **Sort** menu action on a table or chart axis
     * Sorts data in ascending or descending order.
     * Allows adding, editing, or removing filters.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuConditionalFormat]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuSort"] = "axisMenuSort";
    /**
     * The **Group** option in the chart axis or table column
     * customization menu.
     * Allows grouping data points if the axes use the same
     * unit of measurement and a similar scale.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuGroup]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuGroup"] = "axisMenuGroup";
    /**
     * The **Position** option in the axis customization menu.
     * Allows changing the position of the axis to the
     * left or right side of the chart.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuPosition]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuPosition"] = "axisMenuPosition";
    /**
     * The **Rename** option in the chart axis or table column customization menu.
     * Renames the axis label on a chart or the column header on a table.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuRename]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuRename"] = "axisMenuRename";
    /**
     * The **Edit** action in the axis customization menu.
     * Allows editing the axis name, position, minimum and maximum values,
     * and format of a column.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuEdit]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuEdit"] = "axisMenuEdit";
    /**
     * The **Number format** action to customize the format of
     * the data labels on a chart or table.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuNumberFormat]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuNumberFormat"] = "axisMenuNumberFormat";
    /**
     * The **Text wrapping** action on a table.
     * Wraps or clips column text on a table.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuTextWrapping]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuTextWrapping"] = "axisMenuTextWrapping";
    /**
     * The **Remove** action in the chart axis or table column
     * customization menu.
     * Removes the data labels from a chart or the column of a
     * table visualization.
     * @example
     * ```js
     * disabledActions: [Action.AxisMenuRemove]
     * ```
     * @version SDK: 1.21.0 | ThoughtSpot: 9.2.0.cl, 9.5.1.sw
     */ Action["AxisMenuRemove"] = "axisMenuRemove";
    /**
     * @hidden
     */ Action["InsertInToSlide"] = "insertInToSlide";
    /**
     * The **Rename** menu action on Liveboards and visualizations.
     * Allows renaming a Liveboard or visualization.
     * @example
     * ```js
     * disabledActions: [Action.RenameModalTitleDescription]
     * ```
     * @version SDK: 1.23.0 | ThoughtSpot: 9.4.0.cl, 9.8.0.sw
     */ Action["RenameModalTitleDescription"] = "renameModalTitleDescription";
    /**
     * The *Request verification* action on a Liveboard.
     * Initiates a request for Liveboard verification.
     * @example
     * ```js
     * disabledActions: [Action.RequestVerification]
     * ```
     * @version SDK: 1.25.0 | ThoughtSpot: 9.6.0.cl, 10.1.0.sw
     */ Action["RequestVerification"] = "requestVerification";
    /**
     *
     * Allows users to mark a Liveboard as verified.
     * @example
     * ```js
     * disabledActions: [Action.MarkAsVerified]
     * ```
     * @version SDK: 1.25.0 | ThoughtSpot: 9.6.0.cl, 10.1.0.sw
     */ Action["MarkAsVerified"] = "markAsVerified";
    /**
     * The **Add Tab** action on a Liveboard.
     * Allows adding a new tab to a Liveboard view.
     * @example
     * ```js
     * disabledActions: [Action.AddTab]
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 9.8.0.sw
     */ Action["AddTab"] = "addTab";
    /**
     *
     * Initiates contextual change analysis on KPI charts.
     * @example
     * ```js
     * disabledActions: [Action.EnableContextualChangeAnalysis]
     * ```
     * @version SDK: 1.25.0 | ThoughtSpot Cloud: 9.6.0.cl
     */ Action["EnableContextualChangeAnalysis"] = "enableContextualChangeAnalysis";
    /**
     * Action ID to hide or disable Iterative Change Analysis option
     * in the contextual change analysis Insight charts context menu.
     *
     * @example
     * ```js
     * disabledActions: [Action.EnableIterativeChangeAnalysis]
     * ```
     * @version SDK: 1.41.0 | ThoughtSpot Cloud: 9.12.0.cl
     */ Action["EnableIterativeChangeAnalysis"] = "enableIterativeChangeAnalysis";
    /**
     * Action ID to hide or disable Natural Language Search query.
     *
     * @example
     * ```js
     * disabledActions: [Action.ShowSageQuery]
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot Cloud: 9.7.0.cl
     */ Action["ShowSageQuery"] = "showSageQuery";
    /**
     *
     * Action ID to hide or disable the edit option for the
     * results generated from the
     * Natural Language Search query.
     *
     * @example
     * ```js
     * disabledActions: [Action.EditSageAnswer]
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot Cloud: 9.7.0.cl
     */ Action["EditSageAnswer"] = "editSageAnswer";
    /**
     * The feedback widget for AI-generated Answers.
     * Allows users to send feedback on the Answers generated
     * from a Natural Language Search query.
     *
     * @example
     * ```js
     * disabledActions: [Action.SageAnswerFeedback]
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl
     */ Action["SageAnswerFeedback"] = "sageAnswerFeedback";
    /**
     *
     * @example
     * ```js
     * disabledActions: [Action.ModifySageAnswer]
     * ```
     * @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl
     */ Action["ModifySageAnswer"] = "modifySageAnswer";
    /**
     * The **Move to Tab** menu action on visualizations in Liveboard edit mode.
     * Allows moving a visualization to a different tab.
     * @example
     * ```js
     * disabledActions: [Action.MoveToTab]
     * ```
     */ Action["MoveToTab"] = "onContainerMove";
    /**
     * The **Manage Alerts** menu action on KPI visualizations.
     * Allows creating, viewing, and editing monitor
     * alerts for a KPI chart.
     *
     * @example
     * ```js
     * disabledActions: [Action.ManageMonitor]
     * ```
     */ Action["ManageMonitor"] = "manageMonitor";
    /**
     * The Liveboard Personalised Views dropdown.
     * Allows navigating to a personalized Liveboard View.
     * This action is deprecated. Use {@link Action.PersonalizedViewsDropdown} instead.
     *  @example
     * ```js
     * disabledActions: [Action.PersonalisedViewsDropdown]
     * ```
     *  @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 10.1.0.sw
     * @deprecated SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ Action["PersonalisedViewsDropdown"] = "personalisedViewsDropdown";
    /**
     * The Liveboard Personalized Views dropdown.
     * Allows navigating to a personalized Liveboard View.
     *  @example
     * ```js
     * disabledActions: [Action.PersonalizedViewsDropdown]
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ Action["PersonalizedViewsDropdown"] = "personalisedViewsDropdown";
    /**
     * Action ID for show or hide the user details on a
     * Liveboard (Recently visited / social proof)
     *  @example
     * ```js
     * disabledActions: [Action.LiveboardUsers]
     * ```
     *  @version SDK: 1.26.0 | ThoughtSpot: 9.7.0.cl, 10.1.0.sw
     */ Action["LiveboardUsers"] = "liveboardUsers";
    /**
     * Action ID for the Parent TML action
     * The parent action **TML** must be included to access TML-related options
     * within the cascading menu (specific to the Answer page)
     * @example
     * ```js
     * // to include specific TML actions
     * visibleActions: [Action.TML, Action.ExportTML, Action.EditTML]
     *
     * ```
     * @example
     * ```js
     * hiddenAction: [Action.TML] // hide all TML actions
     * disabledActions: [Action.TML] // to disable all TML actions
     * ```
     * @version SDK: 1.28.3 | ThoughtSpot: 9.12.0.cl, 10.1.0.sw
     */ Action["TML"] = "tml";
    /**
     * The **Create Liveboard* action on
     * the Liveboards page and the Pin modal.
     * Allows users to create a Liveboard.
     *
     * @example
     * ```js
     * hiddenAction: [Action.CreateLiveboard]
     * disabledActions: [Action.CreateLiveboard]
     * ```
     * @version SDK: 1.32.0 | ThoughtSpot: 10.1.0.cl, 10.1.0.sw
     */ Action["CreateLiveboard"] = "createLiveboard";
    /**
     * Action ID for to hide or disable the
     * Verified Liveboard banner.
     *  @example
     * ```js
     * hiddenAction: [Action.VerifiedLiveboard]
     * ```
     *  @version SDK: 1.29.0 | ThoughtSpot: 9.10.0.cl, 10.1.0.sw
     */ Action["VerifiedLiveboard"] = "verifiedLiveboard";
    /**
     * Action ID for the *Ask Sage* In Natural Language Search embed,
     * *Spotter* in Liveboard, full app, and Spotter embed.
     *
     * Allows initiating a conversation with ThoughtSpot AI analyst.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.AskAi]
     * ```
     *  @version SDK: 1.29.0 | ThoughtSpot Cloud: 9.12.0.cl
     */ Action["AskAi"] = "AskAi";
    /**
     * The **Add KPI to Watchlist** action on Home page watchlist.
     * Adds a KPI chart to the watchlist on the Home page.
     * @example
     * ```js
     * disabledActions: [Action.AddToWatchlist]
     * ```
     * @version SDK: 1.27.9 | ThoughtSpot Cloud: 9.12.5.cl
     */ Action["AddToWatchlist"] = "addToWatchlist";
    /**
     * The **Remove from watchlist** menu action on KPI watchlist.
     * Removes a KPI chart from the watchlist on the Home page.
     * @example
     * ```js
     * disabledActions: [Action.RemoveFromWatchlist]
     * ```
     * @version SDK: 1.27.9 | ThoughtSpot: 9.12.5.cl
     */ Action["RemoveFromWatchlist"] = "removeFromWatchlist";
    /**
     * The **Organize Favourites** action on Homepage
     * *Favorites* module.
     * This action is deprecated. Use {@link Action.OrganizeFavorites} instead.
     *
     * @example
     * ```js
     * disabledActions: [Action.OrganiseFavourites]
     * ```
     * @version SDK: 1.32.0 | ThoughtSpot: 10.0.0.cl
     * @deprecated SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ Action["OrganiseFavourites"] = "organiseFavourites";
    /**
     * The **Organize Favorites** action on Homepage
     * *Favorites* module.
     *
     * @example
     * ```js
     * disabledActions: [Action.OrganizeFavorites]
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot: 26.5.0.cl
     */ Action["OrganizeFavorites"] = "organiseFavourites";
    /**
     * The **AI Highlights** action on a Liveboard.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.AIHighlights]
     * ```
     *  @version SDK: 1.27.10 | ThoughtSpot Cloud: 9.12.5.cl
     */ Action["AIHighlights"] = "AIHighlights";
    /**
     * The *Edit* action on the *Liveboard Schedules* page
     * (new Homepage experience).
     * Allows editing Liveboard schedules.
     *
     * @example
     * ```js
     * disabledActions: [Action.EditScheduleHomepage]
     * ```
     *  @version SDK: 1.34.0 | ThoughtSpot Cloud: 10.3.0.cl
     */ Action["EditScheduleHomepage"] = "editScheduleHomepage";
    /**
     * The *Pause* action on the *Liveboard Schedules* page
     * Pauses a scheduled Liveboard job.
     * @example
     * ```js
     * disabledActions: [Action.PauseScheduleHomepage]
     * ```
     *  @version SDK: 1.34.0 | ThoughtSpot Cloud: 10.3.0.cl
     */ Action["PauseScheduleHomepage"] = "pauseScheduleHomepage";
    /**
     * The **View run history** action **Liveboard Schedules** page.
     * Allows viewing schedule run history.
     * @example
     * ```js
     * disabledActions: [Action.ViewScheduleRunHomepage]
     * ```
     *  @version SDK: 1.34.0 | ThoughtSpot: 10.3.0.cl
     */ Action["ViewScheduleRunHomepage"] = "viewScheduleRunHomepage";
    /**
     * Action ID to hide or disable the
     * unsubscribe option for Liveboard schedules.
     * @example
     * ```js
     * disabledActions: [Action.UnsubscribeScheduleHomepage]
     * ```
     *  @version SDK: 1.34.0 | ThoughtSpot: 10.3.0.cl
     */ Action["UnsubscribeScheduleHomepage"] = "unsubscribeScheduleHomepage";
    /**
     * The **Manage Tags** action on Homepage Favourite Module.
     * @example
     * ```js
     * disabledActions: [Action.ManageTags]
     * ```
     * @version SDK: 1.34.0 | ThoughtSpot Cloud: 10.3.0.cl
     */ Action["ManageTags"] = "manageTags";
    /**
     * The **Delete** action on the **Liveboard Schedules* page.
     * Deletes a Liveboard schedule.
     * @example
     * ```js
     * disabledActions: [Action.DeleteScheduleHomepage]
     * ```
     *  @version SDK: 1.34.0 | ThoughtSpot: 10.3.0.cl
     */ Action["DeleteScheduleHomepage"] = "deleteScheduleHomepage";
    /**
     * The **Analyze CTA** action on KPI chart.
     * @example
     * ```js
     * disabledActions: [Action.KPIAnalysisCTA]
     * ```
     *  @version SDK: 1.34.0 | ThoughtSpot Cloud: 10.3.0.cl
     */ Action["KPIAnalysisCTA"] = "kpiAnalysisCTA";
    /**
     * Action ID for disabling chip reorder in Answer and Liveboard
     * @example
     * ```js
     * const disabledActions = [Action.DisableChipReorder]
     * ```
     * @version SDK: 1.36.0 | ThoughtSpot Cloud: 10.6.0.cl
     */ Action["DisableChipReorder"] = "disableChipReorder";
    /**
     * Action ID to show, hide, or disable filters
     * in a Liveboard tab.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.ChangeFilterVisibilityInTab]
     * ```
     *  @version SDK: 1.36.0 | ThoughtSpot Cloud: 10.6.0.cl
     */ Action["ChangeFilterVisibilityInTab"] = "changeFilterVisibilityInTab";
    /**
     * The **Data model instructions** button on the Spotter interface.
     * Allows opening the data model instructions modal.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.DataModelInstructions]
     * ```
     *  @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["DataModelInstructions"] = "DataModelInstructions";
    /**
     * The **Preview data** button on the Spotter interface.
     * Allows previewing the data used for Spotter queries.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.PreviewDataSpotter]
     * ```
     *  @version SDK: 1.36.0 | ThoughtSpot Cloud: 10.6.0.cl
     */ Action["PreviewDataSpotter"] = "previewDataSpotter";
    /**
     * The **Reset** link on the Spotter interface.
     * Resets the conversation with Spotter.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.ResetSpotterChat]
     * ```
     *  @version SDK: 1.36.0 | ThoughtSpot Cloud: 10.6.0.cl
     */ Action["ResetSpotterChat"] = "resetSpotterChat";
    /**
     * Action ID for hide or disable the
     * Spotter feedback widget.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.SpotterFeedback]
     * ```
     *  @version SDK: 1.36.0 | ThoughtSpot Cloud: 10.6.0.cl
     */ Action["SpotterFeedback"] = "spotterFeedback";
    /**
     * Action ID for hide or disable
     * the previous prompt edit option in Spotter.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.EditPreviousPrompt]
     * ```
     *  @version SDK: 1.36.0 | ThoughtSpot Cloud: 10.6.0.cl
     */ Action["EditPreviousPrompt"] = "editPreviousPrompt";
    /**
     * Action ID for hide or disable
     * the previous prompt deletion option in Spotter.
     *
     *  @example
     * ```js
     * hiddenAction: [Action.DeletePreviousPrompt]
     * ```
     *  @version SDK: 1.36.0 | ThoughtSpot Cloud: 10.6.0.cl
     */ Action["DeletePreviousPrompt"] = "deletePreviousPrompt";
    /**
     * Action ID for hide or disable editing tokens generated from
     * Spotter results.
     *  @example
     * ```js
     * hiddenAction: [Action.EditTokens]
     * ```
     *  @version SDK: 1.36.0 | ThoughtSpot Cloud: 10.6.0.cl
     */ Action["EditTokens"] = "editTokens";
    /**
     * Action ID for hiding rename option for Column rename
     *  @example
     * ```js
     * hiddenAction: [Action.ColumnRename]
     * ```
     *  @version SDK: 1.37.0 | ThoughtSpot Cloud: 10.8.0.cl
     */ Action["ColumnRename"] = "columnRename";
    /**
     * Action ID for hide checkboxes for include or exclude
     * cover and filter pages in the Liveboard PDF
     *  @example
     * ```js
     * hiddenAction: [Action.CoverAndFilterOptionInPDF]
     * ```
     *  @version SDK: 1.37.0 | ThoughtSpot Cloud: 10.8.0.cl
     */ Action["CoverAndFilterOptionInPDF"] = "coverAndFilterOptionInPDF";
    /**
     * Action ID to hide or disable the Coaching workflow in Spotter conversations.
     * When disabled, users cannot access **Add to Coaching** workflow in conversation.
     * The **Add to Coaching** feature allows adding reference questions and
     * business terms to improve Spotter’s responses. This feature is generally available
     * (GA) from version 26.2.0.cl and enabled by default on embed deployments.
     *  @example
     * ```js
     * hiddenAction: [Action.InConversationTraining]
     * disabledActions: [Action.InConversationTraining]
     *
     * ```
     *  @version SDK: 1.39.0 | ThoughtSpot Cloud: 10.10.0.cl
     */ Action["InConversationTraining"] = "InConversationTraining";
    /**
     * Action ID to hide the warnings banner in
     * Spotter results. It's an EA feature and
     * handled by LD.
     *  @example
     * ```js
     * hiddenAction: [Action.SpotterWarningsBanner]
     * ```
     *  @version SDK: 1.41.0 | ThoughtSpot Cloud: 10.13.0.cl
     */ Action["SpotterWarningsBanner"] = "SpotterWarningsBanner";
    /**
     * Action ID to hide the warnings border on the knowledge
     * card in Spotter results. It's an EA feature and
     * handled by LD.
     *  @example
     * ```js
     * hiddenAction: [Action.SpotterWarningsOnTokens]
     * ```
     *  @version SDK: 1.41.0 | ThoughtSpot Cloud: 10.13.0.cl
     */ Action["SpotterWarningsOnTokens"] = "SpotterWarningsOnTokens";
    /**
     * Action ID to disable the click event handler on knowledge
     * card in Spotter results. It's an EA feature and
     * handled by LD.
     *  @example
     * ```js
     * hiddenAction: [Action.SpotterTokenQuickEdit]
     * ```
     *  @version SDK: 1.41.0 | ThoughtSpot Cloud: 10.13.0.cl
     */ Action["SpotterTokenQuickEdit"] = "SpotterTokenQuickEdit";
    /**
     * The **PNG screenshot in email** option in the schedule email dialog.
     * Includes a PNG screenshot in the notification email body.
     * @example
     * ```js
     * disabledActions: [Action.PngScreenshotInEmail]
     * ```
     * ```
     *  @version SDK: 1.42.0 | ThoughtSpot Cloud: 10.14.0.cl
     */ Action["PngScreenshotInEmail"] = "pngScreenshotInEmail";
    /**
     * The **Remove attachment** action in the schedule email dialog.
     * Removes an attachment from the email configuration.
     * @example
     * ```js
     * disabledActions: [Action.RemoveAttachment]
     * ```
     * ```
     * ```
     *  @version SDK: 1.42.0 | ThoughtSpot Cloud: 10.14.0.cl
     */ Action["RemoveAttachment"] = "removeAttachment";
    /**
     * The **Style panel** on a Liveboard.
     * Controls the visibility of the Liveboard style panel.
     * @example
     * ```js
     * hiddenActions: [Action.LiveboardStylePanel]
     * ```
     * @version SDK: 1.43.0 | ThoughtSpot Cloud: 10.15.0.cl
     */ Action["LiveboardStylePanel"] = "liveboardStylePanel";
    /**
     * The **Publish** action for Liveboards, Answers and Models.
     * Opens the publishing modal. It's a parent action for the
     * **Manage Publishing** and **Unpublish** actions if the object
     * is already published, otherwise appears standalone.
     * @example
     * ```js
     * hiddenActions: [Action.Publish]
     * disabledActions: [Action.Publish]
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot Cloud: 26.2.0.cl
     */ Action["Publish"] = "publish";
    /**
     * The **Manage Publishing** action for Liveboards, Answers and Models.
     * Opens the same publishing modal as the **Publish** action.
     * Appears as a child action to the **Publish** action if the
     * object is already published.
     * @example
     * ```js
     * hiddenActions: [Action.ManagePublishing]
     * disabledActions: [Action.ManagePublishing]
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot Cloud: 26.2.0.cl
     */ Action["ManagePublishing"] = "managePublishing";
    /**
     * The **Unpublish** action for Liveboards, Answers and Models.
     * Opens the unpublishing modal. Appears as a child action to
     * the **Publish** action if the object is already published.
     * @example
     * ```js
     * hiddenActions: [Action.Unpublish]
     * disabledActions: [Action.Unpublish]
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot Cloud: 26.2.0.cl
     */ Action["Unpublish"] = "unpublish";
    /**
     * The **Parameterize** action for Tables and Connections.
     * Opens the parameterization modal.
     * @example
     * ```js
     * hiddenActions: [Action.Parameterize]
     * disabledActions: [Action.Parameterize]
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot Cloud: 26.2.0.cl
     */ Action["Parameterize"] = "parameterise";
    /**
     * The **Move to Group** menu action on a Liveboard.
     * Allows moving a visualization to a different group.
     * @example
     * ```js
     * disabledActions: [Action.MoveToGroup]
     * ```
     * @version SDK: 1.44.0 | ThoughtSpot Cloud: 26.2.0.cl
     */ Action["MoveToGroup"] = "moveToGroup";
    /**
     * The **Move out of Group** menu action on a Liveboard.
     * Allows moving a visualization out of a group.
     * @example
     * ```js
     * disabledActions: [Action.MoveOutOfGroup]
     * ```
     * @version SDK: 1.44.0 | ThoughtSpot Cloud: 26.2.0.cl
     */ Action["MoveOutOfGroup"] = "moveOutOfGroup";
    /**
     * The **Create Group** menu action on a Liveboard.
     * Allows creating a new group.
     * @example
     * ```js
     * disabledActions: [Action.CreateGroup]
     * ```
     * @version SDK: 1.44.0 | ThoughtSpot Cloud: 26.2.0.cl
     */ Action["CreateGroup"] = "createGroup";
    /**
     * The **Ungroup Liveboard Group** menu action on a Liveboard.
     * Allows ungrouping a liveboard group.
     * @example
     * ```js
     * disabledActions: [Action.UngroupLiveboardGroup]
     * ```
     * @version SDK: 1.44.0 | ThoughtSpot Cloud: 26.2.0.cl
     */ Action["UngroupLiveboardGroup"] = "ungroupLiveboardGroup";
    /**
     * Controls visibility of the sidebar header (title and toggle button)
     * in the Spotter past conversations sidebar.
     * @example
     * ```js
     * hiddenActions: [Action.SpotterSidebarHeader]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterSidebarHeader"] = "spotterSidebarHeader";
    /**
     * Controls visibility of the sidebar footer (documentation link)
     * in the Spotter past conversations sidebar.
     * @example
     * ```js
     * hiddenActions: [Action.SpotterSidebarFooter]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterSidebarFooter"] = "spotterSidebarFooter";
    /**
     * Controls visibility and disable state of the sidebar toggle/expand button
     * in the Spotter past conversations sidebar.
     * @example
     * ```js
     * disabledActions: [Action.SpotterSidebarToggle]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterSidebarToggle"] = "spotterSidebarToggle";
    /**
     * Controls visibility and disable state of the "New Chat" button
     * in the Spotter past conversations sidebar.
     * @example
     * ```js
     * disabledActions: [Action.SpotterNewChat]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterNewChat"] = "spotterNewChat";
    /**
     * Controls visibility of the past conversation banner alert
     * in the Spotter interface.
     * @example
     * ```js
     * hiddenActions: [Action.SpotterPastChatBanner]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterPastChatBanner"] = "spotterPastChatBanner";
    /**
     * Controls visibility and disable state of the conversation edit menu
     * (three-dot menu) in the Spotter past conversations sidebar.
     * @example
     * ```js
     * disabledActions: [Action.SpotterChatMenu]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterChatMenu"] = "spotterChatMenu";
    /**
     * Controls visibility and disable state of the rename action
     * in the Spotter conversation edit menu.
     * @example
     * ```js
     * disabledActions: [Action.SpotterChatRename]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterChatRename"] = "spotterChatRename";
    /**
     * Controls visibility and disable state of the delete action
     * in the Spotter conversation edit menu.
     * @example
     * ```js
     * disabledActions: [Action.SpotterChatDelete]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterChatDelete"] = "spotterChatDelete";
    /**
     * Controls visibility and disable state of the documentation/best practices
     * link in the Spotter sidebar footer.
     * @example
     * ```js
     * disabledActions: [Action.SpotterDocs]
     * ```
     * @version SDK: 1.46.0 | ThoughtSpot Cloud: 26.3.0.cl
     */ Action["SpotterDocs"] = "spotterDocs";
    /**
     * Controls visibility and disable state of the connector resources
     * section in the Spotter chat interface.
     * @example
     * ```js
     * hiddenActions: [Action.SpotterChatConnectorResources]
     * disabledActions: [Action.SpotterChatConnectorResources]
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot Cloud: 26.5.0.cl
     */ Action["SpotterChatConnectorResources"] = "spotterChatConnectorResources";
    /**
     * Controls visibility and disable state of the connectors
     * in the Spotter chat interface.
     * @example
     * ```js
     * hiddenActions: [Action.SpotterChatConnectors]
     * disabledActions: [Action.SpotterChatConnectors]
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot Cloud: 26.5.0.cl
     */ Action["SpotterChatConnectors"] = "spotterChatConnectors";
    /**
     * Controls visibility and disable state of the mode switcher
     * in the Spotter chat interface.
     * @example
     * ```js
     * hiddenActions: [Action.SpotterChatModeSwitcher]
     * disabledActions: [Action.SpotterChatModeSwitcher]
     * ```
     * @version SDK: 1.48.0 | ThoughtSpot Cloud: 26.5.0.cl
     */ Action["SpotterChatModeSwitcher"] = "spotterChatModeSwitcher";
    /**
     * The **Include current period** checkbox for date filters.
     * Controls the visibility and availability of the option to include
     * the current time period in filter results.
     * @example
     * ```js
     * hiddenActions: [Action.IncludeCurrentPeriod]
     * disabledActions: [Action.IncludeCurrentPeriod]
     * ```
     * @version SDK: 1.45.0 | ThoughtSpot: 26.4.0.cl
     */ Action["IncludeCurrentPeriod"] = "includeCurrentPeriod";
})($a2210daac95811c7$export$e19cd5f9376f8cee || ($a2210daac95811c7$export$e19cd5f9376f8cee = {}));
var $a2210daac95811c7$export$1892d4005e417d41;
(function(PrefetchFeatures) {
    PrefetchFeatures["FullApp"] = "FullApp";
    PrefetchFeatures["SearchEmbed"] = "SearchEmbed";
    PrefetchFeatures["LiveboardEmbed"] = "LiveboardEmbed";
    PrefetchFeatures["VizEmbed"] = "VizEmbed";
})($a2210daac95811c7$export$1892d4005e417d41 || ($a2210daac95811c7$export$1892d4005e417d41 = {}));
var $a2210daac95811c7$export$41300f43dfe6060b;
(function(ContextMenuTriggerOptions) {
    ContextMenuTriggerOptions["LEFT_CLICK"] = "left-click";
    ContextMenuTriggerOptions["RIGHT_CLICK"] = "right-click";
    ContextMenuTriggerOptions["BOTH_CLICKS"] = "both-clicks";
})($a2210daac95811c7$export$41300f43dfe6060b || ($a2210daac95811c7$export$41300f43dfe6060b = {}));
var $a2210daac95811c7$export$ec71f89a7e8d2b23;
(function(CustomActionsPosition) {
    /**
     * Shows the action as a primary button
     * in the toolbar area of the embed.
     */ CustomActionsPosition["PRIMARY"] = "PRIMARY";
    /**
     * Shows the action inside the "More" menu
     * (three-dot overflow menu).
     */ CustomActionsPosition["MENU"] = "MENU";
    /**
     * Shows the action in the right-click
     * context menu. Only supported for
     * {@link CustomActionTarget.VIZ},
     * {@link CustomActionTarget.ANSWER}, and
     * {@link CustomActionTarget.SPOTTER} targets.
     */ CustomActionsPosition["CONTEXTMENU"] = "CONTEXTMENU";
})($a2210daac95811c7$export$ec71f89a7e8d2b23 || ($a2210daac95811c7$export$ec71f89a7e8d2b23 = {}));
var $a2210daac95811c7$export$b6339065dcd25647;
(function(CustomActionTarget) {
    /**
     * Action applies at the Liveboard level.
     * Supported positions:
     * {@link CustomActionsPosition.PRIMARY},
     * {@link CustomActionsPosition.MENU}.
     * Can be scoped with
     * `metadataIds.liveboardIds`,
     * `orgIds`, and `groupIds`.
     */ CustomActionTarget["LIVEBOARD"] = "LIVEBOARD";
    /**
     * Action applies to individual
     * visualizations (charts/tables).
     * Supported positions:
     * {@link CustomActionsPosition.PRIMARY},
     * {@link CustomActionsPosition.MENU},
     * {@link CustomActionsPosition.CONTEXTMENU}.
     * Can be scoped with `metadataIds`
     * (answerIds, liveboardIds, vizIds),
     * `dataModelIds` (modelIds,
     * modelColumnNames), `orgIds`,
     * and `groupIds`.
     */ CustomActionTarget["VIZ"] = "VIZ";
    /**
     * Action applies to saved or unsaved
     * Answers. Supported positions:
     * {@link CustomActionsPosition.PRIMARY},
     * {@link CustomActionsPosition.MENU},
     * {@link CustomActionsPosition.CONTEXTMENU}.
     * Can be scoped with
     * `metadataIds.answerIds`,
     * `dataModelIds` (modelIds,
     * modelColumnNames), `orgIds`,
     * and `groupIds`.
     */ CustomActionTarget["ANSWER"] = "ANSWER";
    /**
     * Action applies to Spotter
     * (AI-powered search).
     * Supported positions:
     * {@link CustomActionsPosition.MENU},
     * {@link CustomActionsPosition.CONTEXTMENU}.
     * Can be scoped with
     * `dataModelIds.modelIds`,
     * `orgIds`, and `groupIds`.
     */ CustomActionTarget["SPOTTER"] = "SPOTTER";
})($a2210daac95811c7$export$b6339065dcd25647 || ($a2210daac95811c7$export$b6339065dcd25647 = {}));
var $a2210daac95811c7$export$243e62d78d3b544d;
(function(LogLevel) {
    /**
     * No application or SDK-related logs will be logged
     * in the console output.
     * @example
     * ```js
     * init({
     *   ... //other embed view config,
     *  logLevel: LogLevel.SILENT,
     * })
     * ```
     * @version SDK: 1.26.7 | ThoughtSpot Cloud: 9.10.0.cl
     */ LogLevel["SILENT"] = "SILENT";
    /**
     * Log only errors in the console output.
     * @example
     * ```js
     * init({
     *   ... //other embed view config,
     *  logLevel: LogLevel.ERROR,
     * })
     * ```
     * @version SDK: 1.26.7 | ThoughtSpot Cloud: 9.10.0.cl
     */ LogLevel["ERROR"] = "ERROR";
    /**
     * Log only warnings and errors in the console output.
     * @example
     * ```js
     * init({
     *   ... //other embed view config,
     *  logLevel: LogLevel.WARN,
     * })
     * ```
     * @version SDK: 1.26.7 | ThoughtSpot Cloud: 9.10.0.cl
     */ LogLevel["WARN"] = "WARN";
    /**
     * Log only the information alerts, warnings, and errors
     * in the console output.
     * @example
     * ```js
     * init({
     *   ... //other embed view config,
     *  logLevel: LogLevel.INFO,
     * })
     * ```
     * @version SDK: 1.26.7 | ThoughtSpot Cloud: 9.10.0.cl
     */ LogLevel["INFO"] = "INFO";
    /**
     * Log debug messages, warnings, information alerts,
     * and errors in the console output.
     * @example
     * ```js
     * init({
     *   ... //other embed view config,
     *  logLevel: LogLevel.DEBUG,
     * })
     * ```
     * @version SDK: 1.26.7 | ThoughtSpot Cloud: 9.10.0.cl
     */ LogLevel["DEBUG"] = "DEBUG";
    /**
     * All logs will be logged in the browser console.
     * @example
     * ```js
     * init({
     *   ... //other embed view config,
     *  logLevel: LogLevel.TRACE,
     * })
     * ```
     * @version SDK: 1.26.7 | ThoughtSpot Cloud: 9.10.0.cl
     */ LogLevel["TRACE"] = "TRACE";
})($a2210daac95811c7$export$243e62d78d3b544d || ($a2210daac95811c7$export$243e62d78d3b544d = {}));
var $a2210daac95811c7$export$3afa882655b95cc6;
(function(ErrorDetailsTypes) {
    /** API call failure */ ErrorDetailsTypes["API"] = "API";
    /** General validation error */ ErrorDetailsTypes["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    /** Network connectivity or request error */ ErrorDetailsTypes["NETWORK"] = "NETWORK";
})($a2210daac95811c7$export$3afa882655b95cc6 || ($a2210daac95811c7$export$3afa882655b95cc6 = {}));
var $a2210daac95811c7$export$af552b21ba6cd753;
(function(EmbedErrorCodes) {
    /** Worksheet ID not found or does not exist */ EmbedErrorCodes["WORKSHEET_ID_NOT_FOUND"] = "WORKSHEET_ID_NOT_FOUND";
    /** Required Liveboard ID is missing from configuration */ EmbedErrorCodes["LIVEBOARD_ID_MISSING"] = "LIVEBOARD_ID_MISSING";
    /** Conflicting action configuration detected */ EmbedErrorCodes["CONFLICTING_ACTIONS_CONFIG"] = "CONFLICTING_ACTIONS_CONFIG";
    /** Conflicting tab configuration detected  */ EmbedErrorCodes["CONFLICTING_TABS_CONFIG"] = "CONFLICTING_TABS_CONFIG";
    /** Error during component initialization */ EmbedErrorCodes["INIT_ERROR"] = "INIT_ERROR";
    /** Network connectivity or request error */ EmbedErrorCodes["NETWORK_ERROR"] = "NETWORK_ERROR";
    /** Custom action validation failed */ EmbedErrorCodes["CUSTOM_ACTION_VALIDATION"] = "CUSTOM_ACTION_VALIDATION";
    /** Authentication/login failed */ EmbedErrorCodes["LOGIN_FAILED"] = "LOGIN_FAILED";
    /** Render method was not called before attempting to use the component */ EmbedErrorCodes["RENDER_NOT_CALLED"] = "RENDER_NOT_CALLED";
    /** Host event type is undefined or invalid */ EmbedErrorCodes["HOST_EVENT_TYPE_UNDEFINED"] = "HOST_EVENT_TYPE_UNDEFINED";
    /** Error parsing api intercept body */ EmbedErrorCodes["PARSING_API_INTERCEPT_BODY_ERROR"] = "PARSING_API_INTERCEPT_BODY_ERROR";
    /** Failed to update embed parameters during pre-render */ EmbedErrorCodes["UPDATE_PARAMS_FAILED"] = "UPDATE_PARAMS_FAILED";
    /** Invalid URL provided in configuration */ EmbedErrorCodes["INVALID_URL"] = "INVALID_URL";
    /** Host event payload validation failed */ EmbedErrorCodes["HOST_EVENT_VALIDATION"] = "HOST_EVENT_VALIDATION";
    /** UpdateFilters payload is invalid - missing or malformed filter/filters */ EmbedErrorCodes["UPDATEFILTERS_INVALID_PAYLOAD"] = "UPDATEFILTERS_INVALID_PAYLOAD";
    /** DrillDown payload is invalid - missing or malformed points */ EmbedErrorCodes["DRILLDOWN_INVALID_PAYLOAD"] = "DRILLDOWN_INVALID_PAYLOAD";
})($a2210daac95811c7$export$af552b21ba6cd753 || ($a2210daac95811c7$export$af552b21ba6cd753 = {}));
var $a2210daac95811c7$export$f4f876851689635a;
(function(ContextType) {
    /**
     * Search answer context for search page or edit viz dialog on liveboard page.
     */ ContextType["Search"] = "search-answer";
    /**
     * Liveboard context for liveboard page.
     */ ContextType["Liveboard"] = "liveboard";
    /**
     * Answer context for explore modal/page on liveboard page.
     */ ContextType["Answer"] = "answer";
    /**
     * Spotter context for spotter modal/page.
     */ ContextType["Spotter"] = "spotter";
    /**
     * Other context for any other generic page.
     */ ContextType["Other"] = "other";
})($a2210daac95811c7$export$f4f876851689635a || ($a2210daac95811c7$export$f4f876851689635a = {}));
var $a2210daac95811c7$export$b3057738eedd0dc9;
(function(InterceptedApiType) {
    /**
     * The apis that are use to get the data for the embed
     */ InterceptedApiType["AnswerData"] = "AnswerData";
    /**
     * This will intercept all the apis
     */ InterceptedApiType["ALL"] = "ALL";
    /**
     * The apis that are use to get the data for the liveboard
     */ InterceptedApiType["LiveboardData"] = "LiveboardData";
})($a2210daac95811c7$export$b3057738eedd0dc9 || ($a2210daac95811c7$export$b3057738eedd0dc9 = {}));

});


parcelRegister("7aJfj", function(module, exports) {

$parcel$export(module.exports, "getFilterQuery", function () { return $538c9078cbe2fec7$export$af27e998c5db692c; });
$parcel$export(module.exports, "getRuntimeParameters", function () { return $538c9078cbe2fec7$export$c26d6c847ea80866; });
$parcel$export(module.exports, "getQueryParamString", function () { return $538c9078cbe2fec7$export$14997d9c23f3e101; });
$parcel$export(module.exports, "getCssDimension", function () { return $538c9078cbe2fec7$export$48bff18f0e202506; });
$parcel$export(module.exports, "isValidCssMargin", function () { return $538c9078cbe2fec7$export$b982c7e4cf0ea9f0; });
$parcel$export(module.exports, "isUndefined", function () { return $538c9078cbe2fec7$export$fce6876652108ab; });
$parcel$export(module.exports, "getSSOMarker", function () { return $538c9078cbe2fec7$export$63bf154232bc8399; });
$parcel$export(module.exports, "getRedirectUrl", function () { return $538c9078cbe2fec7$export$93832c3affb240d3; });
$parcel$export(module.exports, "getEncodedQueryParamsString", function () { return $538c9078cbe2fec7$export$3f6e88b2fe3b72a6; });
$parcel$export(module.exports, "getOffsetTop", function () { return $538c9078cbe2fec7$export$6fcff0dc60346367; });
$parcel$export(module.exports, "embedEventStatus", function () { return $538c9078cbe2fec7$export$13f32d437dda3cd6; });
$parcel$export(module.exports, "setAttributes", function () { return $538c9078cbe2fec7$export$74da2cba014bdc09; });
$parcel$export(module.exports, "checkReleaseVersionInBeta", function () { return $538c9078cbe2fec7$export$9289957b21c4361a; });
$parcel$export(module.exports, "getCustomisations", function () { return $538c9078cbe2fec7$export$f704cb06e87acf32; });
$parcel$export(module.exports, "getRuntimeFilters", function () { return $538c9078cbe2fec7$export$d537c9051de638f8; });
$parcel$export(module.exports, "getDOMNode", function () { return $538c9078cbe2fec7$export$f39f755673ece9e2; });
$parcel$export(module.exports, "deepMerge", function () { return $538c9078cbe2fec7$export$6969335ea1e4e77c; });
$parcel$export(module.exports, "getOperationNameFromQuery", function () { return $538c9078cbe2fec7$export$2ff5a3a2313a0d80; });
$parcel$export(module.exports, "removeTypename", function () { return $538c9078cbe2fec7$export$7a6c04d143cff875; });
$parcel$export(module.exports, "setStyleProperties", function () { return $538c9078cbe2fec7$export$4b03d14c8d278a0c; });
$parcel$export(module.exports, "removeStyleProperties", function () { return $538c9078cbe2fec7$export$64e24104117bf06c; });
$parcel$export(module.exports, "getTypeFromValue", function () { return $538c9078cbe2fec7$export$682c97444e627d2b; });
$parcel$export(module.exports, "storeValueInWindow", function () { return $538c9078cbe2fec7$export$fca1c662a1185b42; });
$parcel$export(module.exports, "isWindowUndefined", function () { return $538c9078cbe2fec7$export$cadb5a0966590981; });
$parcel$export(module.exports, "getValueFromWindow", function () { return $538c9078cbe2fec7$export$3925f938de064225; });
$parcel$export(module.exports, "arrayIncludesString", function () { return $538c9078cbe2fec7$export$2b94c5a443575d95; });
$parcel$export(module.exports, "handlePresentEvent", function () { return $538c9078cbe2fec7$export$6c452bd8b67330ed; });
$parcel$export(module.exports, "handleExitPresentMode", function () { return $538c9078cbe2fec7$export$a26391e12f77042a; });
$parcel$export(module.exports, "calculateVisibleElementData", function () { return $538c9078cbe2fec7$export$dac2332d9d9404cc; });
$parcel$export(module.exports, "formatTemplate", function () { return $538c9078cbe2fec7$export$1d4f254d8032f638; });
$parcel$export(module.exports, "getHostEventsConfig", function () { return $538c9078cbe2fec7$export$ea0ba61f27f15dd7; });
$parcel$export(module.exports, "validateHttpUrl", function () { return $538c9078cbe2fec7$export$7f551e8a5ef91fc0; });
$parcel$export(module.exports, "setParamIfDefined", function () { return $538c9078cbe2fec7$export$b3ce47f2ef28a28; });
/**
 * Copyright (c) 2023
 *
 * Common utility functions for ThoughtSpot Visual Embed SDK
 * @summary Utils
 * @author Ayon Ghosh <ayon.ghosh@thoughtspot.com>
 */ 
var $jZ5lG = parcelRequire("jZ5lG");

var $kCAID = parcelRequire("kCAID");

var $h7cYZ = parcelRequire("h7cYZ");
const $538c9078cbe2fec7$export$af27e998c5db692c = (runtimeFilters)=>{
    if (runtimeFilters && runtimeFilters.length) {
        const filters = runtimeFilters.map((filter, valueIndex)=>{
            const index = valueIndex + 1;
            const filterExpr = [];
            filterExpr.push(`col${index}=${encodeURIComponent(filter.columnName)}`);
            filterExpr.push(`op${index}=${filter.operator}`);
            filterExpr.push(filter.values.map((value)=>{
                const encodedValue = typeof value === 'bigint' ? value.toString() : value;
                return `val${index}=${encodeURIComponent(String(encodedValue))}`;
            }).join('&'));
            return filterExpr.join('&');
        });
        return `${filters.join('&')}`;
    }
    return null;
};
const $538c9078cbe2fec7$export$c26d6c847ea80866 = (runtimeParameters)=>{
    if (runtimeParameters && runtimeParameters.length) {
        const params = runtimeParameters.map((param, valueIndex)=>{
            const index = valueIndex + 1;
            const filterExpr = [];
            filterExpr.push(`param${index}=${encodeURIComponent(param.name)}`);
            filterExpr.push(`paramVal${index}=${encodeURIComponent(param.value)}`);
            return filterExpr.join('&');
        });
        return `${params.join('&')}`;
    }
    return null;
};
/**
 * Convert a value to a string representation to be sent as a query
 * parameter to the ThoughtSpot app.
 * @param value Any parameter value
 */ const $538c9078cbe2fec7$var$serializeParam = (value)=>{
    // do not serialize primitive types
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return value;
    return JSON.stringify(value);
};
/**
 * Convert a value to a string:
 * in case of an array, we convert it to CSV.
 * in case of any other type, we directly return the value.
 * @param value
 */ const $538c9078cbe2fec7$var$paramToString = (value)=>Array.isArray(value) ? value.join(',') : value;
const $538c9078cbe2fec7$export$14997d9c23f3e101 = (queryParams, shouldSerializeParamValues = false)=>{
    const qp = [];
    const params = Object.keys(queryParams);
    params.forEach((key)=>{
        const val = queryParams[key];
        if (val !== undefined) {
            const serializedValue = shouldSerializeParamValues ? $538c9078cbe2fec7$var$serializeParam(val) : $538c9078cbe2fec7$var$paramToString(val);
            qp.push(`${key}=${serializedValue}`);
        }
    });
    if (qp.length) return qp.join('&');
    return null;
};
const $538c9078cbe2fec7$export$48bff18f0e202506 = (value)=>{
    if (typeof value === 'number') return `${value}px`;
    return value;
};
const $538c9078cbe2fec7$export$b982c7e4cf0ea9f0 = (value)=>{
    if ($538c9078cbe2fec7$export$fce6876652108ab(value)) return false;
    if (typeof value !== 'string') {
        (0, $kCAID.logger).error('Please provide a valid lazyLoadingMargin value (e.g., "10px")');
        return false;
    }
    // This pattern allows for an optional negative sign, and numbers
    // that can be integers or decimals (including leading dot).
    const cssUnitPattern = /^-?(\d+(\.\d*)?|\.\d+)(px|em|rem|%|vh|vw)$/i;
    const parts = value.trim().split(/\s+/);
    if (parts.length > 4) {
        (0, $kCAID.logger).error('Please provide a valid lazyLoadingMargin value (e.g., "10px")');
        return false;
    }
    const isValid = parts.every((part)=>{
        const trimmedPart = part.trim();
        return trimmedPart.toLowerCase() === 'auto' || trimmedPart === '0' || cssUnitPattern.test(trimmedPart);
    });
    if (!isValid) {
        (0, $kCAID.logger).error('Please provide a valid lazyLoadingMargin value (e.g., "10px")');
        return false;
    }
    return true;
};
const $538c9078cbe2fec7$export$63bf154232bc8399 = (markerId)=>{
    const encStringToAppend = encodeURIComponent(markerId);
    return `tsSSOMarker=${encStringToAppend}`;
};
const $538c9078cbe2fec7$export$468d8a0038bd4a40 = (url, stringToAppend)=>{
    let outputUrl = url;
    const encStringToAppend = encodeURIComponent(stringToAppend);
    const marker = `tsSSOMarker=${encStringToAppend}`;
    let splitAdder = '';
    if (url.indexOf('#') >= 0) // If second half of hash contains a '?' already add a '&' instead of
    // '?' which appends to query params.
    splitAdder = url.split('#')[1].indexOf('?') >= 0 ? '&' : '?';
    else splitAdder = '#?';
    outputUrl = `${outputUrl}${splitAdder}${marker}`;
    return outputUrl;
};
function $538c9078cbe2fec7$export$93832c3affb240d3(url, stringToAppend, path = '') {
    const targetUrl = path ? new URL(path, window.location.origin).href : url;
    return $538c9078cbe2fec7$export$468d8a0038bd4a40(targetUrl, stringToAppend);
}
const $538c9078cbe2fec7$export$3f6e88b2fe3b72a6 = (queryString)=>{
    if (!queryString) return queryString;
    return btoa(queryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};
const $538c9078cbe2fec7$export$6fcff0dc60346367 = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top + window.scrollY;
};
const $538c9078cbe2fec7$export$13f32d437dda3cd6 = {
    START: 'start',
    END: 'end'
};
const $538c9078cbe2fec7$export$74da2cba014bdc09 = (element, attributes)=>{
    Object.keys(attributes).forEach((key)=>{
        element.setAttribute(key, attributes[key].toString());
    });
};
const $538c9078cbe2fec7$var$isCloudRelease = (version)=>version.endsWith('.cl');
const $538c9078cbe2fec7$export$9289957b21c4361a = (releaseVersion, suppressBetaWarning)=>{
    if (releaseVersion !== '' && !$538c9078cbe2fec7$var$isCloudRelease(releaseVersion)) {
        const splittedReleaseVersion = releaseVersion.split('.');
        const majorVersion = Number(splittedReleaseVersion[0]);
        const isBetaVersion = majorVersion < 8;
        return !suppressBetaWarning && isBetaVersion;
    }
    return false;
};
const $538c9078cbe2fec7$export$f704cb06e87acf32 = (embedConfig, viewConfig)=>{
    var _a, _b, _c, _d;
    const customizationsFromViewConfig = viewConfig.customizations;
    const customizationsFromEmbedConfig = embedConfig.customizations || embedConfig.customisations;
    const customizations = {
        style: {
            ...customizationsFromEmbedConfig === null || customizationsFromEmbedConfig === void 0 ? void 0 : customizationsFromEmbedConfig.style,
            ...customizationsFromViewConfig === null || customizationsFromViewConfig === void 0 ? void 0 : customizationsFromViewConfig.style,
            customCSS: {
                ...(_a = customizationsFromEmbedConfig === null || customizationsFromEmbedConfig === void 0 ? void 0 : customizationsFromEmbedConfig.style) === null || _a === void 0 ? void 0 : _a.customCSS,
                ...(_b = customizationsFromViewConfig === null || customizationsFromViewConfig === void 0 ? void 0 : customizationsFromViewConfig.style) === null || _b === void 0 ? void 0 : _b.customCSS
            },
            customCSSUrl: ((_c = customizationsFromViewConfig === null || customizationsFromViewConfig === void 0 ? void 0 : customizationsFromViewConfig.style) === null || _c === void 0 ? void 0 : _c.customCSSUrl) || ((_d = customizationsFromEmbedConfig === null || customizationsFromEmbedConfig === void 0 ? void 0 : customizationsFromEmbedConfig.style) === null || _d === void 0 ? void 0 : _d.customCSSUrl)
        },
        content: {
            ...customizationsFromEmbedConfig === null || customizationsFromEmbedConfig === void 0 ? void 0 : customizationsFromEmbedConfig.content,
            ...customizationsFromViewConfig === null || customizationsFromViewConfig === void 0 ? void 0 : customizationsFromViewConfig.content
        }
    };
    return customizations;
};
const $538c9078cbe2fec7$export$d537c9051de638f8 = (runtimefilters)=>$538c9078cbe2fec7$export$af27e998c5db692c(runtimefilters || []);
function $538c9078cbe2fec7$export$f39f755673ece9e2(domSelector) {
    return typeof domSelector === 'string' ? document.querySelector(domSelector) : domSelector;
}
const $538c9078cbe2fec7$export$6969335ea1e4e77c = (target, source)=>(0, $jZ5lG.default)(target, source);
const $538c9078cbe2fec7$export$2ff5a3a2313a0d80 = (query)=>{
    const regex = /(?:query|mutation)\s+(\w+)/;
    const matches = query.match(regex);
    return matches === null || matches === void 0 ? void 0 : matches[1];
};
function $538c9078cbe2fec7$export$7a6c04d143cff875(obj) {
    if (!obj || typeof obj !== 'object') return obj;
    for(const key in obj){
        if (key === '__typename') delete obj[key];
        else if (typeof obj[key] === 'object') $538c9078cbe2fec7$export$7a6c04d143cff875(obj[key]);
    }
    return obj;
}
const $538c9078cbe2fec7$export$4b03d14c8d278a0c = (element, styleProperties)=>{
    if (!(element === null || element === void 0 ? void 0 : element.style)) return;
    Object.keys(styleProperties).forEach((styleProperty)=>{
        const styleKey = styleProperty;
        const value = styleProperties[styleKey];
        if (value !== undefined) element.style[styleKey] = value.toString();
    });
};
const $538c9078cbe2fec7$export$64e24104117bf06c = (element, styleProperties)=>{
    if (!(element === null || element === void 0 ? void 0 : element.style)) return;
    styleProperties.forEach((styleProperty)=>{
        element.style.removeProperty(styleProperty);
    });
};
const $538c9078cbe2fec7$export$fce6876652108ab = (value)=>value === undefined;
const $538c9078cbe2fec7$export$682c97444e627d2b = (value)=>{
    if (typeof value === 'string') return [
        'char',
        'string'
    ];
    if (typeof value === 'number') return [
        'double',
        'double'
    ];
    if (typeof value === 'boolean') return [
        'boolean',
        'boolean'
    ];
    return [
        '',
        ''
    ];
};
const $538c9078cbe2fec7$var$sdkWindowKey = '_tsEmbedSDK';
function $538c9078cbe2fec7$export$fca1c662a1185b42(key, value, options = {}) {
    if ($538c9078cbe2fec7$export$cadb5a0966590981()) return value;
    if (!window[$538c9078cbe2fec7$var$sdkWindowKey]) window[$538c9078cbe2fec7$var$sdkWindowKey] = {};
    if (options.ignoreIfAlreadyExists && key in window[$538c9078cbe2fec7$var$sdkWindowKey]) return window[$538c9078cbe2fec7$var$sdkWindowKey][key];
    window[$538c9078cbe2fec7$var$sdkWindowKey][key] = value;
    return value;
}
const $538c9078cbe2fec7$export$3925f938de064225 = (key)=>{
    var _a;
    if ($538c9078cbe2fec7$export$cadb5a0966590981()) return undefined;
    return (_a = window === null || window === void 0 ? void 0 : window[$538c9078cbe2fec7$var$sdkWindowKey]) === null || _a === void 0 ? void 0 : _a[key];
};
const $538c9078cbe2fec7$export$2b94c5a443575d95 = (arr, key)=>{
    return arr.some((item)=>typeof item === 'string' && item === key);
};
function $538c9078cbe2fec7$export$c170b43e3d94ba44(key) {
    if ($538c9078cbe2fec7$export$cadb5a0966590981()) return false;
    if (key in window[$538c9078cbe2fec7$var$sdkWindowKey]) {
        delete window[$538c9078cbe2fec7$var$sdkWindowKey][key];
        return true;
    }
    return false;
}
/**
 * Check if the document is currently in fullscreen mode
 */ const $538c9078cbe2fec7$var$isInFullscreen = ()=>{
    return !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);
};
const $538c9078cbe2fec7$export$6c452bd8b67330ed = async (iframe)=>{
    if ($538c9078cbe2fec7$var$isInFullscreen()) return; // Already in fullscreen
    // Browser-specific methods to enter fullscreen mode
    const fullscreenMethods = [
        'requestFullscreen',
        'webkitRequestFullscreen',
        'mozRequestFullScreen',
        'msRequestFullscreen' // IE/Edge
    ];
    for (const method of fullscreenMethods){
        if (typeof iframe[method] === 'function') try {
            const result = iframe[method]();
            await Promise.resolve(result);
            return;
        } catch (error) {
            (0, $kCAID.logger).warn(`Failed to enter fullscreen using ${method}:`, error);
        }
    }
    (0, $kCAID.logger).error('Fullscreen API is not supported by this browser.');
};
const $538c9078cbe2fec7$export$a26391e12f77042a = async ()=>{
    if (!$538c9078cbe2fec7$var$isInFullscreen()) return; // Not in fullscreen
    const exitFullscreenMethods = [
        'exitFullscreen',
        'webkitExitFullscreen',
        'mozCancelFullScreen',
        'msExitFullscreen' // IE/Edge
    ];
    // Try each method until one works
    for (const method of exitFullscreenMethods){
        if (typeof document[method] === 'function') try {
            const result = document[method]();
            await Promise.resolve(result);
            return;
        } catch (error) {
            (0, $kCAID.logger).warn(`Failed to exit fullscreen using ${method}:`, error);
        }
    }
    (0, $kCAID.logger).warn('Exit fullscreen API is not supported by this browser.');
};
const $538c9078cbe2fec7$export$dac2332d9d9404cc = (element)=>{
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const windowWidth = window.innerWidth;
    const frameRelativeTop = Math.max(rect.top, 0);
    const frameRelativeLeft = Math.max(rect.left, 0);
    const frameRelativeBottom = Math.min(windowHeight, rect.bottom);
    const frameRelativeRight = Math.min(windowWidth, rect.right);
    const data = {
        top: Math.max(0, rect.top * -1),
        height: Math.max(0, frameRelativeBottom - frameRelativeTop),
        left: Math.max(0, rect.left * -1),
        width: Math.max(0, frameRelativeRight - frameRelativeLeft)
    };
    return data;
};
const $538c9078cbe2fec7$export$1d4f254d8032f638 = (template, values)=>{
    // This regex /\{(\w+)\}/g finds all placeholders in the format {word} 
    // and captures the word inside the braces for replacement.
    return template.replace(/\{(\w+)\}/g, (match, key)=>{
        return values[key] !== undefined ? String(values[key]) : match;
    });
};
const $538c9078cbe2fec7$export$ea0ba61f27f15dd7 = (viewConfig)=>{
    return {
        shouldBypassPayloadValidation: viewConfig.shouldBypassPayloadValidation,
        useHostEventsV2: viewConfig.useHostEventsV2
    };
};
const $538c9078cbe2fec7$export$cadb5a0966590981 = ()=>{
    if (typeof window === 'undefined') {
        (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).SSR_ENVIRONMENT_ERROR);
        return true;
    }
    return false;
};
const $538c9078cbe2fec7$export$7f551e8a5ef91fc0 = (url)=>{
    try {
        const parsedUrl = new URL(url);
        if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') return [
            false,
            new Error(`Invalid protocol: ${parsedUrl.protocol}. Only http: and https: are allowed.`)
        ];
        return [
            true,
            null
        ];
    } catch (error) {
        return [
            false,
            error instanceof Error ? error : new Error(String(error))
        ];
    }
};
const $538c9078cbe2fec7$export$b3ce47f2ef28a28 = (queryParams, param, value, asBoolean = false)=>{
    if (value !== undefined) queryParams[param] = asBoolean ? !!value : value;
};

});
parcelRegister("jZ5lG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e8c7dcf4fe2e2651$export$2e2bcd8739ae039; });
// istanbul ignore next
const $e8c7dcf4fe2e2651$var$isObject = (obj)=>{
    if (typeof obj === "object" && obj !== null) {
        if (typeof Object.getPrototypeOf === "function") {
            const prototype = Object.getPrototypeOf(obj);
            return prototype === Object.prototype || prototype === null;
        }
        return Object.prototype.toString.call(obj) === "[object Object]";
    }
    return false;
};
const $e8c7dcf4fe2e2651$var$merge = (...objects)=>objects.reduce((result, current)=>{
        if (Array.isArray(current)) throw new TypeError("Arguments provided to ts-deepmerge must be objects, not arrays.");
        Object.keys(current).forEach((key)=>{
            if ([
                "__proto__",
                "constructor",
                "prototype"
            ].includes(key)) return;
            if (Array.isArray(result[key]) && Array.isArray(current[key])) result[key] = $e8c7dcf4fe2e2651$var$merge.options.mergeArrays ? $e8c7dcf4fe2e2651$var$merge.options.uniqueArrayItems ? Array.from(new Set(result[key].concat(current[key]))) : [
                ...result[key],
                ...current[key]
            ] : current[key];
            else if ($e8c7dcf4fe2e2651$var$isObject(result[key]) && $e8c7dcf4fe2e2651$var$isObject(current[key])) result[key] = $e8c7dcf4fe2e2651$var$merge(result[key], current[key]);
            else result[key] = current[key] === undefined ? $e8c7dcf4fe2e2651$var$merge.options.allowUndefinedOverrides ? current[key] : result[key] : current[key];
        });
        return result;
    }, {});
const $e8c7dcf4fe2e2651$var$defaultOptions = {
    allowUndefinedOverrides: true,
    mergeArrays: true,
    uniqueArrayItems: true
};
$e8c7dcf4fe2e2651$var$merge.options = $e8c7dcf4fe2e2651$var$defaultOptions;
$e8c7dcf4fe2e2651$var$merge.withOptions = (options, ...objects)=>{
    $e8c7dcf4fe2e2651$var$merge.options = Object.assign(Object.assign({}, $e8c7dcf4fe2e2651$var$defaultOptions), options);
    const result = $e8c7dcf4fe2e2651$var$merge(...objects);
    $e8c7dcf4fe2e2651$var$merge.options = $e8c7dcf4fe2e2651$var$defaultOptions;
    return result;
};
var $e8c7dcf4fe2e2651$export$2e2bcd8739ae039 = $e8c7dcf4fe2e2651$var$merge;

});

parcelRegister("h7cYZ", function(module, exports) {

$parcel$export(module.exports, "ERROR_MESSAGE", function () { return $c75d2939eb93131e$export$3f27bc10068ef877; });
$parcel$export(module.exports, "CUSTOM_ACTIONS_ERROR_MESSAGE", function () { return $c75d2939eb93131e$export$3b45ea5b8f9adcbe; });
const $c75d2939eb93131e$export$3f27bc10068ef877 = {
    INVALID_THOUGHTSPOT_HOST: 'Error parsing ThoughtSpot host. Please provide a valid URL.',
    SPOTTER_EMBED_WORKSHEED_ID_NOT_FOUND: 'Please select a Model to get started',
    LIVEBOARD_VIZ_ID_VALIDATION: 'Please select a Liveboard to embed.',
    TRIGGER_TIMED_OUT: 'Trigger timed-out in getting a response',
    SEARCHEMBED_BETA_WRANING_MESSAGE: 'SearchEmbed is in Beta in this release.',
    THIRD_PARTY_COOKIE_BLOCKED_ALERT: 'Third-party cookie access is blocked on this browser. Please allow third-party cookies for this to work properly. \nYou can use `suppressNoCookieAccessAlert` to suppress this message.',
    DUPLICATE_TOKEN_ERR: 'Duplicate token. Please issue a new token every time getAuthToken callback is called. See https://developers.thoughtspot.com/docs/?pageid=embed-auth#trusted-auth-embed for more details.',
    SDK_NOT_INITIALIZED: 'SDK not initialized',
    SESSION_INFO_FAILED: 'Failed to get session information',
    INVALID_TOKEN_ERROR: 'Received invalid token from getAuthToken callback or authToken endpoint.',
    INVALID_TOKEN_TYPE_ERROR: 'Expected getAuthToken to return a string, but received a {invalidType}.',
    MIXPANEL_TOKEN_NOT_FOUND: 'Mixpanel token not found in session info',
    PRERENDER_ID_MISSING: 'PreRender ID is required for preRender',
    SYNC_STYLE_CALLED_BEFORE_RENDER: 'PreRender should be called before using syncPreRenderStyle',
    CSP_VIOLATION_ALERT: 'CSP violation detected. Please check the console errors for more details.',
    CSP_FRAME_HOST_VIOLATION_LOG_MESSAGE: 'Please set up CSP correctly for the application to start working. For more information, see https://developers.thoughtspot.com/docs/security-settings#csp-viz-embed-hosts. \n If the issue persists, refer to https://developers.thoughtspot.com/docs/security-settings#csp-viz-embed-hosts',
    MISSING_REPORTING_OBSERVER: 'ReportingObserver not supported',
    RENDER_CALLED_BEFORE_INIT: 'Looks like render was called before calling init, the render won\'t start until init is called.\nFor more info check\n1. https://developers.thoughtspot.com/docs/Function_init#_init\n2.https://developers.thoughtspot.com/docs/getting-started#initSdk',
    SPOTTER_AGENT_NOT_INITIALIZED: 'SpotterAgent not initialized',
    OFFLINE_WARNING: 'Network not Detected. Embed is offline. Please reconnect and refresh',
    INIT_SDK_REQUIRED: 'You need to init the ThoughtSpot SDK module first',
    CONFLICTING_ACTIONS_CONFIG: 'You cannot have both hidden actions and visible actions',
    CONFLICTING_TABS_CONFIG: 'You cannot have both hidden Tabs and visible Tabs',
    RENDER_BEFORE_EVENTS_REQUIRED: 'Please call render before triggering events',
    HOST_EVENT_TYPE_UNDEFINED: 'Host event type is undefined',
    LOGIN_FAILED: 'Login failed',
    ERROR_PARSING_API_INTERCEPT_BODY: 'Error parsing api intercept body',
    SSR_ENVIRONMENT_ERROR: 'SSR environment detected. This function cannot be called in SSR environment.',
    UPDATE_PARAMS_FAILED: 'Failed to update embed parameters',
    INVALID_SPOTTER_DOCUMENTATION_URL: 'Invalid spotterDocumentationUrl. Please provide a valid http or https URL.',
    UPDATEFILTERS_INVALID_PAYLOAD: 'UpdateFilters requires a valid filter or filters array. Expected: { filter: { column, oper, values } } or { filters: [{ column, oper, values }, ...] }',
    DRILLDOWN_INVALID_PAYLOAD: 'DrillDown requires a valid points object. Expected: { points: { clickedPoint?, selectedPoints? }, autoDrillDown?, vizId? }'
};
const $c75d2939eb93131e$export$3b45ea5b8f9adcbe = {
    INVALID_ACTION_OBJECT: 'Custom Action Validation Error: Invalid action object provided',
    MISSING_REQUIRED_FIELDS: (id, missingFields)=>`Custom Action Validation Error for '${id}': Missing required fields: ${missingFields.join(', ')}`,
    UNSUPPORTED_TARGET: (id, targetType)=>`Custom Action Validation Error for '${id}': Target type '${targetType}' is not supported`,
    INVALID_POSITION: (position, targetType, supportedPositions)=>`Position '${position}' is not supported for ${targetType.toLowerCase()}-level custom actions. Supported positions: ${supportedPositions}`,
    INVALID_METADATA_IDS: (targetType, invalidIds, supportedIds)=>`Invalid metadata IDs for ${targetType.toLowerCase()}-level custom actions: ${invalidIds.join(', ')}. Supported metadata IDs: ${supportedIds}`,
    INVALID_DATA_MODEL_IDS: (targetType, invalidIds, supportedIds)=>`Invalid data model IDs for ${targetType.toLowerCase()}-level custom actions: ${invalidIds.join(', ')}. Supported data model IDs: ${supportedIds}`,
    INVALID_FIELDS: (targetType, invalidFields, supportedFields)=>`Invalid fields for ${targetType.toLowerCase()}-level custom actions: ${invalidFields.join(', ')}. Supported fields: ${supportedFields}`,
    DUPLICATE_IDS: (id, duplicateNames, keptName)=>`Duplicate custom action ID '${id}' found. Actions with names '${duplicateNames.join("', '")}' will be ignored. Keeping '${keptName}'.`
};

});


parcelRegister("2SBdZ", function(module, exports) {

$parcel$export(module.exports, "TsEmbed", function () { return $218d7ff0debb34ef$export$6d92ba91718653d8; });
$parcel$export(module.exports, "V1Embed", function () { return $218d7ff0debb34ef$export$9184aa0f8b851822; });
/**
 * Copyright (c) 2022
 *
 * Base classes
 * @summary Base classes
 * @author Ayon Ghosh <ayon.ghosh@thoughtspot.com>
 */ 
var $6bh8U = parcelRequire("6bh8U");

var $kh1ul = parcelRequire("kh1ul");

var $hZEPb = parcelRequire("hZEPb");

var $cMxso = parcelRequire("cMxso");

var $kCAID = parcelRequire("kCAID");

var $d4gBz = parcelRequire("d4gBz");

var $3q1XH = parcelRequire("3q1XH");

var $7aJfj = parcelRequire("7aJfj");

var $iPROI = parcelRequire("iPROI");

var $10hiU = parcelRequire("10hiU");

var $dV0Ap = parcelRequire("dV0Ap");

var $fxzLD = parcelRequire("fxzLD");

var $4iokK = parcelRequire("4iokK");

var $jZ130 = parcelRequire("jZ130");

var $e0AWW = parcelRequire("e0AWW");
var $fv46J = parcelRequire("fv46J");

var $fv46J = parcelRequire("fv46J");

var $a6640 = parcelRequire("a6640");

var $h7cYZ = parcelRequire("h7cYZ");

var $6JZt8 = parcelRequire("6JZt8");

var $gnR3r = parcelRequire("gnR3r");

var $1G6ZM = parcelRequire("1G6ZM");
const { version: $218d7ff0debb34ef$var$version } = (0, (/*@__PURE__*/$parcel$interopDefault($jZ130)));
const $218d7ff0debb34ef$export$fbd947bd5ee90e = 'ts-';
const $218d7ff0debb34ef$var$TS_EMBED_ID = '_thoughtspot-embed';
/**
 * The event id map from v2 event names to v1 event id
 * v1 events are the classic embed events implemented in Blink v1
 * We cannot rename v1 event types to maintain backward compatibility
 * @internal
 */ const $218d7ff0debb34ef$var$V1EventMap = {};
class $218d7ff0debb34ef$export$6d92ba91718653d8 {
    /**
     * Setter for the iframe element
     * @param {HTMLIFrameElement} iFrame HTMLIFrameElement
     */ setIframeElement(iFrame) {
        this.iFrame = iFrame;
        this.hostEventClient.setIframeElement(iFrame);
    }
    constructor(domSelector, viewConfig){
        /**
         * The key to store the embed instance in the DOM node
         */ this.embedNodeKey = '__tsEmbed';
        this.isAppInitialized = false;
        /**
         * Should we encode URL Query Params using base64 encoding which ThoughtSpot
         * will generate for embedding. This provides additional security to
         * ThoughtSpot clusters against Cross site scripting attacks.
         * @default false
         */ this.shouldEncodeUrlQueryParams = false;
        this.defaultHiddenActions = [
            (0, $dV0Ap.Action).ReportError
        ];
        /**
         * Handler for fullscreen change events
         */ this.fullscreenChangeHandler = null;
        this.subscribedListeners = {};
        this.messageEventListener = (event)=>{
            const eventType = this.getEventType(event);
            const eventPort = this.getEventPort(event);
            const eventData = this.formatEventData(event, eventType);
            if (event.source === this.iFrame.contentWindow) {
                const processedEventData = (0, $4iokK.processEventData)(eventType, eventData, this.thoughtSpotHost, this.isPreRendered ? this.preRenderWrapper : this.el);
                if (eventType === (0, $dV0Ap.EmbedEvent).ApiIntercept) {
                    this.handleApiInterceptEvent({
                        eventData: eventData,
                        eventPort: eventPort
                    });
                    return;
                }
                this.executeCallbacks(eventType, processedEventData, eventPort);
            }
        };
        /**
         * Send Custom style as part of payload of APP_INIT
         * @param _
         * @param responder
         */ this.appInitCb = async (_, responder)=>{
            try {
                const appInitData = await this.getAppInitData();
                this.isAppInitialized = true;
                responder({
                    type: (0, $dV0Ap.EmbedEvent).APP_INIT,
                    data: appInitData
                });
            } catch (e) {
                (0, $kCAID.logger).error(`AppInit failed, Error : ${e === null || e === void 0 ? void 0 : e.message}`);
            }
        };
        this.handleAuthFailure = (error)=>{
            (0, $kCAID.logger).error(`${(0, $h7cYZ.ERROR_MESSAGE).INVALID_TOKEN_ERROR} Error : ${error === null || error === void 0 ? void 0 : error.message}`);
            (0, $4iokK.processAuthFailure)(error, this.isPreRendered ? this.preRenderWrapper : this.el);
        };
        /**
         * Refresh the auth token if the autoLogin is true and the authType is TrustedAuthTokenCookieless
         * @param _
         * @param responder
         */ this.tokenRefresh = async (_, responder)=>{
            try {
                await this.refreshAuthTokenForCookieless(responder, (0, $dV0Ap.EmbedEvent).RefreshAuthToken, true);
            } catch (e) {
                this.handleAuthFailure(e);
            }
        };
        /**
         * Sends updated auth token to the iFrame to avoid user logout
         * @param _
         * @param responder
         */ this.updateAuthToken = async (_, responder)=>{
            const { authType: authType, autoLogin: autoLoginConfig } = this.embedConfig;
            // Default autoLogin: true for cookieless if undefined/null, otherwise
            // false
            const autoLogin = autoLoginConfig !== null && autoLoginConfig !== void 0 ? autoLoginConfig : authType === (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless;
            try {
                await this.refreshAuthTokenForCookieless(responder, (0, $dV0Ap.EmbedEvent).AuthExpire, false);
            } catch (e) {
                this.handleAuthFailure(e);
            }
            if (autoLogin && authType !== (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless) (0, $e0AWW.handleAuth)();
            (0, $fv46J.notifyAuthFailure)((0, $fv46J.AuthFailureType).EXPIRY);
        };
        /**
         * Auto Login and send updated authToken to the iFrame to avoid user session logout
         * @param _
         * @param responder
         */ this.idleSessionTimeout = (_, responder)=>{
            (0, $e0AWW.handleAuth)().then(async ()=>{
                let authToken = '';
                try {
                    authToken = await (0, $d4gBz.getAuthenticationToken)(this.embedConfig);
                    responder({
                        type: (0, $dV0Ap.EmbedEvent).IdleSessionTimeout,
                        data: {
                            authToken: authToken
                        }
                    });
                } catch (e) {
                    this.handleAuthFailure(e);
                }
            }).catch((e)=>{
                (0, $kCAID.logger).error(`Auto Login failed, Error : ${e === null || e === void 0 ? void 0 : e.message}`);
            });
            (0, $fv46J.notifyAuthFailure)((0, $fv46J.AuthFailureType).IDLE_SESSION_TIMEOUT);
        };
        /**
         * Register APP_INIT event and sendback init payload
         */ this.registerAppInit = ()=>{
            this.on((0, $dV0Ap.EmbedEvent).APP_INIT, this.appInitCb, {
                start: false
            }, true);
            this.on((0, $dV0Ap.EmbedEvent).AuthExpire, this.updateAuthToken, {
                start: false
            }, true);
            this.on((0, $dV0Ap.EmbedEvent).IdleSessionTimeout, this.idleSessionTimeout, {
                start: false
            }, true);
            const embedListenerReadyHandler = this.createEmbedContainerHandler((0, $dV0Ap.EmbedEvent).EmbedListenerReady);
            this.on((0, $dV0Ap.EmbedEvent).EmbedListenerReady, embedListenerReadyHandler, {
                start: false
            }, true);
            const authInitHandler = this.createEmbedContainerHandler((0, $dV0Ap.EmbedEvent).AuthInit);
            this.on((0, $dV0Ap.EmbedEvent).AuthInit, authInitHandler, {
                start: false
            }, true);
            this.on((0, $dV0Ap.EmbedEvent).RefreshAuthToken, this.tokenRefresh, {
                start: false
            }, true);
        };
        this.showPreRenderByDefault = false;
        /**
         * We can process the customer given payload before sending it to the embed port
         * Embed event handler -> responder -> createEmbedEventResponder -> send response
         * @param eventPort The event port for a specific MessageChannel
         * @param eventType The event type
         * @returns
         */ this.createEmbedEventResponder = (eventPort, eventType)=>{
            const getPayloadToSend = (payload)=>{
                if (eventType === (0, $dV0Ap.EmbedEvent).OnBeforeGetVizDataIntercept) return (0, $1G6ZM.processLegacyInterceptResponse)(payload);
                if (eventType === (0, $dV0Ap.EmbedEvent).ApiIntercept) return (0, $1G6ZM.processApiInterceptResponse)(payload);
                return payload;
            };
            return (payload)=>{
                const payloadToSend = getPayloadToSend(payload);
                this.triggerEventOnPort(eventPort, payloadToSend);
            };
        };
        /**
        * @hidden
        * Internal state to track if the embed container is loaded.
        * This is used to trigger events after the embed container is loaded.
        */ this.isEmbedContainerLoaded = false;
        /**
         * @hidden
         * Internal state to track the callbacks to be executed after the embed container
         * is loaded.
         * This is used to trigger events after the embed container is loaded.
         */ this.embedContainerReadyCallbacks = [];
        this.createEmbedContainerHandler = (source)=>()=>{
                const processEmbedContainerReady = ()=>{
                    (0, $kCAID.logger).debug('processEmbedContainerReady');
                    this.isEmbedContainerLoaded = true;
                    this.executeEmbedContainerReadyCallbacks();
                };
                if (source === (0, $dV0Ap.EmbedEvent).AuthInit) {
                    const AUTH_INIT_FALLBACK_DELAY = 1000;
                    // Wait for 1 second to ensure the embed container is loaded
                    // This is a workaround to ensure the embed container is loaded
                    // this is needed until all clusters have EmbedListenerReady event
                    setTimeout(processEmbedContainerReady, AUTH_INIT_FALLBACK_DELAY);
                } else if (source === (0, $dV0Ap.EmbedEvent).EmbedListenerReady) processEmbedContainerReady();
            };
        this.validatePreRenderViewConfig = (viewConfig)=>{
            var _a;
            const preRenderAllowedKeys = [
                'preRenderId',
                'vizId',
                'liveboardId'
            ];
            const preRenderedObject = (_a = this.insertedDomEl) === null || _a === void 0 ? void 0 : _a[this.embedNodeKey];
            if (!preRenderedObject) return;
            if (viewConfig.preRenderId) {
                const allOtherKeys = Object.keys(viewConfig).filter((key)=>!preRenderAllowedKeys.includes(key) && !key.startsWith('on'));
                allOtherKeys.forEach((key)=>{
                    if (!(0, $7aJfj.isUndefined)(viewConfig[key]) && !(0, (/*@__PURE__*/$parcel$interopDefault($6bh8U)))(viewConfig[key], preRenderedObject.viewConfig[key])) (0, $kCAID.logger).warn(`${viewConfig.embedComponentType || 'Component'} was pre-rendered with ` + `"${key}" as "${JSON.stringify(preRenderedObject.viewConfig[key])}" ` + `but a different value "${JSON.stringify(viewConfig[key])}" ` + 'was passed to the Embed component. ' + 'The new value provided is ignored, the value provided during ' + 'preRender is used.');
                });
            }
        };
        this.el = (0, $7aJfj.getDOMNode)(domSelector);
        this.eventHandlerMap = new Map();
        this.isError = false;
        this.viewConfig = {
            excludeRuntimeFiltersfromURL: true,
            excludeRuntimeParametersfromURL: true,
            ...viewConfig
        };
        this.registerAppInit();
        (0, $fxzLD.uploadMixpanelEvent)((0, $fxzLD.MIXPANEL_EVENT).VISUAL_SDK_EMBED_CREATE, {
            ...viewConfig
        });
        const embedConfig = (0, $a6640.getEmbedConfig)();
        this.embedConfig = embedConfig;
        this.hostEventClient = new (0, $gnR3r.HostEventClient)(this.iFrame);
        this.isReadyForRenderPromise = (0, $e0AWW.getInitPromise)().then(async ()=>{
            if (!embedConfig.authTriggerContainer && !embedConfig.useEventForSAMLPopup) this.embedConfig.authTriggerContainer = domSelector;
            this.thoughtSpotHost = (0, $10hiU.getThoughtSpotHost)(embedConfig);
            this.thoughtSpotV2Base = (0, $10hiU.getV2BasePath)(embedConfig);
            this.shouldEncodeUrlQueryParams = embedConfig.shouldEncodeUrlQueryParams;
        });
    }
    /**
     * Throws error encountered during initialization.
     */ throwInitError() {
        this.handleError({
            errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
            message: (0, $h7cYZ.ERROR_MESSAGE).INIT_SDK_REQUIRED,
            code: (0, $dV0Ap.EmbedErrorCodes).INIT_ERROR,
            error: (0, $h7cYZ.ERROR_MESSAGE).INIT_SDK_REQUIRED
        });
    }
    /**
     * Handles errors within the SDK
     * @param error The error message or object
     * @param errorDetails The error details
     */ handleError(errorDetails) {
        this.isError = true;
        this.executeCallbacks((0, $dV0Ap.EmbedEvent).Error, errorDetails);
        // Log error
        (0, $kCAID.logger).error(errorDetails);
    }
    /**
     * Extracts the type field from the event payload
     * @param event The window message event
     */ getEventType(event) {
        var _a, _b;
        return ((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) || ((_b = event.data) === null || _b === void 0 ? void 0 : _b.__type);
    }
    /**
     * Extracts the port field from the event payload
     * @param event  The window message event
     * @returns
     */ getEventPort(event) {
        if (event.ports.length && event.ports[0]) return event.ports[0];
        return null;
    }
    /**
     * Checks if preauth cache is enabled
     * from the view config and embed config
     * @returns boolean
     */ isPreAuthCacheEnabled() {
        // Disable preauth cache when:
        // 1. overrideOrgId is present since:
        //    - cached auth info would be for wrong org
        //    - info call response changes for each different overrideOrgId
        // 2. disablePreauthCache is explicitly set to true
        // 3. FullAppEmbed has primary navbar visible since:
        //    - primary navbar requires fresh auth state for navigation
        //    - cached auth may not reflect current user permissions
        const isDisabled = this.viewConfig.overrideOrgId !== undefined || this.embedConfig.disablePreauthCache === true || this.isFullAppEmbedWithVisiblePrimaryNavbar();
        return !isDisabled;
    }
    /**
     * Checks if current embed is FullAppEmbed with visible primary navbar
     * @returns boolean
     */ isFullAppEmbedWithVisiblePrimaryNavbar() {
        const appViewConfig = this.viewConfig;
        // Check if this is a FullAppEmbed (AppEmbed)
        // showPrimaryNavbar defaults to true if not explicitly set to false
        return appViewConfig.embedComponentType === 'AppEmbed' && appViewConfig.showPrimaryNavbar === true;
    }
    /**
     * fix for ts7.sep.cl
     * will be removed for ts7.oct.cl
     * @param event
     * @param eventType
     * @hidden
     */ formatEventData(event, eventType) {
        const eventData = {
            ...event.data,
            type: eventType
        };
        if (!eventData.data) eventData.data = event.data.payload;
        return eventData;
    }
    /**
     * Subscribe to network events (online/offline) that should
     * work regardless of auth status
     */ subscribeToNetworkEvents() {
        this.unsubscribeToNetworkEvents();
        const onlineEventListener = (e)=>{
            this.trigger((0, $dV0Ap.HostEvent).Reload);
        };
        window.addEventListener('online', onlineEventListener);
        const offlineEventListener = (e)=>{
            const errorDetails = {
                errorType: (0, $dV0Ap.ErrorDetailsTypes).NETWORK,
                message: (0, $h7cYZ.ERROR_MESSAGE).OFFLINE_WARNING,
                code: (0, $dV0Ap.EmbedErrorCodes).NETWORK_ERROR,
                offlineWarning: (0, $h7cYZ.ERROR_MESSAGE).OFFLINE_WARNING
            };
            this.executeCallbacks((0, $dV0Ap.EmbedEvent).Error, errorDetails);
            (0, $kCAID.logger).warn(errorDetails);
        };
        window.addEventListener('offline', offlineEventListener);
        this.subscribedListeners.online = onlineEventListener;
        this.subscribedListeners.offline = offlineEventListener;
    }
    handleApiInterceptEvent({ eventData: eventData, eventPort: eventPort }) {
        const executeEvent = (_eventType, data)=>{
            this.executeCallbacks(_eventType, data, eventPort);
        };
        const getUnsavedAnswerTml = async (props)=>{
            var _a, _b;
            const response = await this.triggerUIPassThrough((0, $cMxso.UIPassthroughEvent).GetUnsavedAnswerTML, props);
            return (_b = (_a = response.filter((item)=>item.value)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value;
        };
        (0, $1G6ZM.handleInterceptEvent)({
            eventData: eventData,
            executeEvent: executeEvent,
            viewConfig: this.viewConfig,
            getUnsavedAnswerTml: getUnsavedAnswerTml
        });
    }
    /**
     * Subscribe to message events that depend on successful iframe setup
     */ subscribeToMessageEvents() {
        this.unsubscribeToMessageEvents();
        window.addEventListener('message', this.messageEventListener);
        this.subscribedListeners.message = this.messageEventListener;
    }
    /**
     * Adds event listeners for both network and message events.
     * This maintains backward compatibility with the existing method.
     * Adds a global event listener to window for "message" events.
     * ThoughtSpot detects if a particular event is targeted to this
     * embed instance through an identifier contained in the payload,
     * and executes the registered callbacks accordingly.
     */ subscribeToEvents() {
        this.subscribeToNetworkEvents();
        this.subscribeToMessageEvents();
    }
    unsubscribeToNetworkEvents() {
        if (this.subscribedListeners.online) {
            window.removeEventListener('online', this.subscribedListeners.online);
            delete this.subscribedListeners.online;
        }
        if (this.subscribedListeners.offline) {
            window.removeEventListener('offline', this.subscribedListeners.offline);
            delete this.subscribedListeners.offline;
        }
    }
    unsubscribeToMessageEvents() {
        if (this.subscribedListeners.message) {
            window.removeEventListener('message', this.subscribedListeners.message);
            delete this.subscribedListeners.message;
        }
    }
    unsubscribeToEvents() {
        Object.keys(this.subscribedListeners).forEach((key)=>{
            window.removeEventListener(key, this.subscribedListeners[key]);
        });
    }
    async getAuthTokenForCookielessInit() {
        let authToken = '';
        if (this.embedConfig.authType !== (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless) return authToken;
        try {
            authToken = await (0, $d4gBz.getAuthenticationToken)(this.embedConfig);
        } catch (e) {
            (0, $4iokK.processAuthFailure)(e, this.isPreRendered ? this.preRenderWrapper : this.el);
            throw e;
        }
        return authToken;
    }
    async getDefaultAppInitData() {
        var _a, _b;
        const authToken = await this.getAuthTokenForCookielessInit();
        const customActionsResult = (0, $iPROI.getCustomActions)([
            ...this.viewConfig.customActions || [],
            ...this.embedConfig.customActions || []
        ]);
        if (customActionsResult.errors.length > 0) this.handleError({
            errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
            message: customActionsResult.errors,
            code: (0, $dV0Ap.EmbedErrorCodes).CUSTOM_ACTION_VALIDATION,
            error: {
                type: (0, $dV0Ap.EmbedErrorCodes).CUSTOM_ACTION_VALIDATION,
                message: customActionsResult.errors
            }
        });
        const baseInitData = {
            customisations: (0, $7aJfj.getCustomisations)(this.embedConfig, this.viewConfig),
            authToken: authToken,
            runtimeFilterParams: this.viewConfig.excludeRuntimeFiltersfromURL ? (0, $7aJfj.getRuntimeFilters)(this.viewConfig.runtimeFilters) : null,
            runtimeParameterParams: this.viewConfig.excludeRuntimeParametersfromURL ? (0, $7aJfj.getRuntimeParameters)(this.viewConfig.runtimeParameters || []) : null,
            hiddenHomepageModules: this.viewConfig.hiddenHomepageModules || [],
            reorderedHomepageModules: this.viewConfig.reorderedHomepageModules || [],
            hostConfig: this.embedConfig.hostConfig,
            hiddenHomeLeftNavItems: ((_a = this.viewConfig) === null || _a === void 0 ? void 0 : _a.hiddenHomeLeftNavItems) ? (_b = this.viewConfig) === null || _b === void 0 ? void 0 : _b.hiddenHomeLeftNavItems : [],
            customVariablesForThirdPartyTools: this.embedConfig.customVariablesForThirdPartyTools || {},
            hiddenListColumns: this.viewConfig.hiddenListColumns || [],
            customActions: customActionsResult.actions,
            embedExpiryInAuthToken: this.viewConfig.refreshAuthTokenOnNearExpiry,
            ...(0, $1G6ZM.getInterceptInitData)(this.viewConfig),
            ...(0, $7aJfj.getHostEventsConfig)(this.viewConfig)
        };
        return baseInitData;
    }
    async getAppInitData() {
        return this.getDefaultAppInitData();
    }
    /**
     * Helper method to refresh/update auth token for TrustedAuthTokenCookieless auth type
     * @param responder - Function to send response back
     * @param eventType - The embed event type to send
     * @param forceRefresh - Whether to force refresh the token
     * @returns Promise that resolves if token was refreshed, rejects otherwise
     */ async refreshAuthTokenForCookieless(responder, eventType, forceRefresh = false) {
        const { authType: authType, autoLogin: autoLogin } = this.embedConfig;
        const isAutoLoginTrue = autoLogin !== null && autoLogin !== void 0 ? autoLogin : authType === (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless;
        if (isAutoLoginTrue && authType === (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless) {
            const authToken = await (0, $d4gBz.getAuthenticationToken)(this.embedConfig, forceRefresh);
            responder({
                type: eventType,
                data: {
                    authToken: authToken
                }
            });
        }
    }
    /**
     * Constructs the base URL string to load the ThoughtSpot app.
     * @param query
     */ getEmbedBasePath(query) {
        let queryString = query.startsWith('?') ? query : `?${query}`;
        if (this.shouldEncodeUrlQueryParams) queryString = `?base64UrlEncodedFlags=${(0, $7aJfj.getEncodedQueryParamsString)(queryString.substr(1))}`;
        const basePath = [
            this.thoughtSpotHost,
            this.thoughtSpotV2Base,
            queryString
        ].filter((x)=>x.length > 0).join('/');
        return `${basePath}#`;
    }
    async getUpdateEmbedParamsObject() {
        let queryParams = this.getEmbedParamsObject();
        const appInitData = await this.getAppInitData();
        queryParams = {
            ...this.viewConfig,
            ...queryParams,
            ...appInitData
        };
        return queryParams;
    }
    /**
     * Common query params set for all the embed modes.
     * @param queryParams
     * @returns queryParams
     */ getBaseQueryParams(queryParams = {}) {
        var _a, _b, _c, _d;
        let hostAppUrl = ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host) || '';
        // The below check is needed because TS Cloud firewall, blocks
        // localhost/127.0.0.1 in any url param.
        if (hostAppUrl.includes('localhost') || hostAppUrl.includes('127.0.0.1')) hostAppUrl = 'local-host';
        const blockNonEmbedFullAppAccess = (_b = this.embedConfig.blockNonEmbedFullAppAccess) !== null && _b !== void 0 ? _b : true;
        queryParams[(0, $dV0Ap.Param).EmbedApp] = true;
        queryParams[(0, $dV0Ap.Param).HostAppUrl] = encodeURIComponent(hostAppUrl);
        queryParams[(0, $dV0Ap.Param).ViewPortHeight] = window.innerHeight;
        queryParams[(0, $dV0Ap.Param).ViewPortWidth] = window.innerWidth;
        queryParams[(0, $dV0Ap.Param).Version] = $218d7ff0debb34ef$var$version;
        queryParams[(0, $dV0Ap.Param).AuthType] = this.embedConfig.authType;
        queryParams[(0, $dV0Ap.Param).blockNonEmbedFullAppAccess] = blockNonEmbedFullAppAccess;
        queryParams[(0, $dV0Ap.Param).AutoLogin] = this.embedConfig.autoLogin;
        if (this.embedConfig.disableLoginRedirect === true || this.embedConfig.autoLogin === true) queryParams[(0, $dV0Ap.Param).DisableLoginRedirect] = true;
        if (this.embedConfig.authType === (0, $dV0Ap.AuthType).EmbeddedSSO) queryParams[(0, $dV0Ap.Param).ForceSAMLAutoRedirect] = true;
        if (this.embedConfig.authType === (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless) queryParams[(0, $dV0Ap.Param).cookieless] = true;
        if (this.embedConfig.pendoTrackingKey) queryParams[(0, $dV0Ap.Param).PendoTrackingKey] = this.embedConfig.pendoTrackingKey;
        if (this.embedConfig.numberFormatLocale) queryParams[(0, $dV0Ap.Param).NumberFormatLocale] = this.embedConfig.numberFormatLocale;
        if (this.embedConfig.dateFormatLocale) queryParams[(0, $dV0Ap.Param).DateFormatLocale] = this.embedConfig.dateFormatLocale;
        if (this.embedConfig.currencyFormat) queryParams[(0, $dV0Ap.Param).CurrencyFormat] = this.embedConfig.currencyFormat;
        const { disabledActions: disabledActions, disabledActionReason: disabledActionReason, hiddenActions: hiddenActions, visibleActions: visibleActions, hiddenTabs: hiddenTabs, visibleTabs: visibleTabs, showAlerts: showAlerts, additionalFlags: additionalFlagsFromView, locale: locale, customizations: customizations, contextMenuTrigger: contextMenuTrigger, linkOverride: linkOverride, enableLinkOverridesV2: enableLinkOverridesV2, insertInToSlide: insertInToSlide, disableRedirectionLinksInNewTab: disableRedirectionLinksInNewTab, overrideOrgId: overrideOrgId, exposeTranslationIDs: exposeTranslationIDs, primaryAction: primaryAction } = this.viewConfig;
        const { additionalFlags: additionalFlagsFromInit } = this.embedConfig;
        const additionalFlags = {
            ...additionalFlagsFromInit,
            ...additionalFlagsFromView
        };
        if (Array.isArray(visibleActions) && Array.isArray(hiddenActions)) {
            this.handleError({
                errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
                message: (0, $h7cYZ.ERROR_MESSAGE).CONFLICTING_ACTIONS_CONFIG,
                code: (0, $dV0Ap.EmbedErrorCodes).CONFLICTING_ACTIONS_CONFIG,
                error: (0, $h7cYZ.ERROR_MESSAGE).CONFLICTING_ACTIONS_CONFIG
            });
            return queryParams;
        }
        if (Array.isArray(visibleTabs) && Array.isArray(hiddenTabs)) {
            this.handleError({
                errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
                message: (0, $h7cYZ.ERROR_MESSAGE).CONFLICTING_TABS_CONFIG,
                code: (0, $dV0Ap.EmbedErrorCodes).CONFLICTING_TABS_CONFIG,
                error: (0, $h7cYZ.ERROR_MESSAGE).CONFLICTING_TABS_CONFIG
            });
            return queryParams;
        }
        if (primaryAction) queryParams[(0, $dV0Ap.Param).PrimaryAction] = primaryAction;
        if (disabledActions === null || disabledActions === void 0 ? void 0 : disabledActions.length) queryParams[(0, $dV0Ap.Param).DisableActions] = disabledActions;
        if (disabledActionReason) queryParams[(0, $dV0Ap.Param).DisableActionReason] = disabledActionReason;
        if (exposeTranslationIDs) queryParams[(0, $dV0Ap.Param).ExposeTranslationIDs] = exposeTranslationIDs;
        queryParams[(0, $dV0Ap.Param).HideActions] = [
            ...this.defaultHiddenActions,
            ...hiddenActions !== null && hiddenActions !== void 0 ? hiddenActions : []
        ];
        if (Array.isArray(visibleActions)) queryParams[(0, $dV0Ap.Param).VisibleActions] = visibleActions;
        if (Array.isArray(hiddenTabs)) queryParams[(0, $dV0Ap.Param).HiddenTabs] = hiddenTabs;
        if (Array.isArray(visibleTabs)) queryParams[(0, $dV0Ap.Param).VisibleTabs] = visibleTabs;
        /**
         * Default behavior for context menu will be left-click
         *  from version 9.2.0.cl the user have an option to override context
         *  menu click
         */ if (contextMenuTrigger === (0, $dV0Ap.ContextMenuTriggerOptions).LEFT_CLICK) queryParams[(0, $dV0Ap.Param).ContextMenuTrigger] = 'left';
        else if (contextMenuTrigger === (0, $dV0Ap.ContextMenuTriggerOptions).RIGHT_CLICK) queryParams[(0, $dV0Ap.Param).ContextMenuTrigger] = 'right';
        else if (contextMenuTrigger === (0, $dV0Ap.ContextMenuTriggerOptions).BOTH_CLICKS) queryParams[(0, $dV0Ap.Param).ContextMenuTrigger] = 'both';
        const embedCustomizations = this.embedConfig.customizations;
        const spriteUrl = (customizations === null || customizations === void 0 ? void 0 : customizations.iconSpriteUrl) || (embedCustomizations === null || embedCustomizations === void 0 ? void 0 : embedCustomizations.iconSpriteUrl);
        if (spriteUrl) queryParams[(0, $dV0Ap.Param).IconSpriteUrl] = spriteUrl.replace('https://', '');
        const stringIDsUrl = ((_c = customizations === null || customizations === void 0 ? void 0 : customizations.content) === null || _c === void 0 ? void 0 : _c.stringIDsUrl) || ((_d = embedCustomizations === null || embedCustomizations === void 0 ? void 0 : embedCustomizations.content) === null || _d === void 0 ? void 0 : _d.stringIDsUrl);
        if (stringIDsUrl) queryParams[(0, $dV0Ap.Param).StringIDsUrl] = stringIDsUrl;
        if (showAlerts !== undefined) queryParams[(0, $dV0Ap.Param).ShowAlerts] = showAlerts;
        if (locale !== undefined) queryParams[(0, $dV0Ap.Param).Locale] = locale;
        // TODO: Once V2 is stable, send both flags when
        // linkOverride is true (remove the else-if).
        if (enableLinkOverridesV2) {
            queryParams[(0, $dV0Ap.Param).EnableLinkOverridesV2] = true;
            queryParams[(0, $dV0Ap.Param).LinkOverride] = true;
        } else if (linkOverride) queryParams[(0, $dV0Ap.Param).LinkOverride] = linkOverride;
        if (insertInToSlide) queryParams[(0, $dV0Ap.Param).ShowInsertToSlide] = insertInToSlide;
        if (disableRedirectionLinksInNewTab) queryParams[(0, $dV0Ap.Param).DisableRedirectionLinksInNewTab] = disableRedirectionLinksInNewTab;
        if (overrideOrgId !== undefined) queryParams[(0, $dV0Ap.Param).OverrideOrgId] = overrideOrgId;
        if (this.isPreAuthCacheEnabled()) queryParams[(0, $dV0Ap.Param).preAuthCache] = true;
        queryParams[(0, $dV0Ap.Param).OverrideNativeConsole] = true;
        queryParams[(0, $dV0Ap.Param).ClientLogLevel] = this.embedConfig.logLevel;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hZEPb)))(additionalFlags) && !(0, (/*@__PURE__*/$parcel$interopDefault($kh1ul)))(additionalFlags)) Object.assign(queryParams, additionalFlags);
        // Do not add any flags below this, as we want additional flags to
        // override other flags
        return queryParams;
    }
    /**
     * Constructs the base URL string to load v1 of the ThoughtSpot app.
     * This is used for embedding Liveboards, visualizations, and full application.
     * @param queryString The query string to append to the URL.
     * @param isAppEmbed A Boolean parameter to specify if you are embedding
     * the full application.
     */ getV1EmbedBasePath(queryString) {
        const queryParams = this.shouldEncodeUrlQueryParams ? `?base64UrlEncodedFlags=${(0, $7aJfj.getEncodedQueryParamsString)(queryString)}` : `?${queryString}`;
        const host = this.thoughtSpotHost;
        const path = `${host}/${queryParams}#`;
        return path;
    }
    getEmbedParams() {
        const queryParams = this.getEmbedParamsObject();
        return (0, $7aJfj.getQueryParamString)(queryParams);
    }
    getEmbedParamsObject() {
        const params = this.getBaseQueryParams();
        return params;
    }
    getRootIframeSrc() {
        const query = this.getEmbedParams();
        return this.getEmbedBasePath(query);
    }
    createIframeEl(frameSrc) {
        const iFrame = document.createElement('iframe');
        iFrame.src = frameSrc;
        iFrame.id = $218d7ff0debb34ef$var$TS_EMBED_ID;
        iFrame.setAttribute('data-ts-iframe', 'true');
        // according to screenfull.js documentation
        // allowFullscreen, webkitallowfullscreen and mozallowfullscreen must be
        // true
        iFrame.allowFullscreen = true;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        iFrame.webkitallowfullscreen = true;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        iFrame.mozallowfullscreen = true;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        iFrame.allow = 'clipboard-read; clipboard-write; fullscreen; local-network-access;';
        const frameParams = this.viewConfig.frameParams;
        const { height: frameHeight, width: frameWidth, ...restParams } = frameParams || {};
        const width = (0, $7aJfj.getCssDimension)(frameWidth || (0, $10hiU.DEFAULT_EMBED_WIDTH));
        const height = (0, $7aJfj.getCssDimension)(frameHeight || (0, $10hiU.DEFAULT_EMBED_HEIGHT));
        (0, $7aJfj.setAttributes)(iFrame, restParams);
        iFrame.style.width = `${width}`;
        iFrame.style.height = `${height}`;
        // Set minimum height to the frame so that,
        // scaling down on the fullheight doesn't make it too small.
        iFrame.style.minHeight = `${height}`;
        iFrame.style.border = '0';
        iFrame.name = 'ThoughtSpot Embedded Analytics';
        return iFrame;
    }
    handleInsertionIntoDOM(child) {
        if (this.isPreRendered) this.insertIntoDOMForPreRender(child);
        else this.insertIntoDOM(child);
        if (this.insertedDomEl instanceof Node) this.insertedDomEl[this.embedNodeKey] = this;
    }
    /**
     * Renders the embedded ThoughtSpot app in an iframe and sets up
     * event listeners.
     * @param url - The URL of the embedded ThoughtSpot app.
     */ async renderIFrame(url) {
        if (this.isError) return null;
        if (!this.thoughtSpotHost) this.throwInitError();
        url.length;
        return (0, $e0AWW.renderInQueue)((nextInQueue)=>{
            var _a;
            const initTimestamp = Date.now();
            this.executeCallbacks((0, $dV0Ap.EmbedEvent).Init, {
                data: {
                    timestamp: initTimestamp
                },
                type: (0, $dV0Ap.EmbedEvent).Init
            });
            (0, $fxzLD.uploadMixpanelEvent)((0, $fxzLD.MIXPANEL_EVENT).VISUAL_SDK_RENDER_START);
            // Always subscribe to network events, regardless of auth status
            this.subscribeToNetworkEvents();
            return (_a = (0, $e0AWW.getAuthPromise)()) === null || _a === void 0 ? void 0 : _a.then((isLoggedIn)=>{
                if (!isLoggedIn) {
                    this.handleInsertionIntoDOM(this.embedConfig.loginFailedMessage);
                    return;
                }
                this.setIframeElement(this.iFrame || this.createIframeEl(url));
                this.iFrame.addEventListener('load', ()=>{
                    nextInQueue();
                    const loadTimestamp = Date.now();
                    this.executeCallbacks((0, $dV0Ap.EmbedEvent).Load, {
                        data: {
                            timestamp: loadTimestamp
                        },
                        type: (0, $dV0Ap.EmbedEvent).Load
                    });
                    (0, $fxzLD.uploadMixpanelEvent)((0, $fxzLD.MIXPANEL_EVENT).VISUAL_SDK_RENDER_COMPLETE, {
                        elWidth: this.iFrame.clientWidth,
                        elHeight: this.iFrame.clientHeight,
                        timeTookToLoad: loadTimestamp - initTimestamp
                    });
                    // Send info event  if preauth cache is enabled
                    if (this.isPreAuthCacheEnabled()) (0, $6JZt8.getPreauthInfo)().then((data)=>{
                        if (data === null || data === void 0 ? void 0 : data.info) this.trigger((0, $dV0Ap.HostEvent).InfoSuccess, data);
                    });
                    // Setup fullscreen change handler after iframe is
                    // loaded and ready
                    this.setupFullscreenChangeHandler();
                });
                this.iFrame.addEventListener('error', ()=>{
                    nextInQueue();
                });
                this.handleInsertionIntoDOM(this.iFrame);
                const prefetchIframe = document.querySelectorAll('.prefetchIframe');
                if (prefetchIframe.length) prefetchIframe.forEach((el)=>{
                    el.remove();
                });
                // Subscribe to message events only after successful
                // auth and iframe setup
                this.subscribeToMessageEvents();
            }).catch((error)=>{
                nextInQueue();
                (0, $fxzLD.uploadMixpanelEvent)((0, $fxzLD.MIXPANEL_EVENT).VISUAL_SDK_RENDER_FAILED, {
                    error: JSON.stringify(error)
                });
                this.handleInsertionIntoDOM(this.embedConfig.loginFailedMessage);
                this.handleError({
                    errorType: (0, $dV0Ap.ErrorDetailsTypes).API,
                    message: error.message || (0, $h7cYZ.ERROR_MESSAGE).LOGIN_FAILED,
                    code: (0, $dV0Ap.EmbedErrorCodes).LOGIN_FAILED,
                    error: error
                });
            });
        });
    }
    createPreRenderWrapper() {
        var _a;
        const preRenderIds = this.getPreRenderIds();
        (_a = document.getElementById(preRenderIds.wrapper)) === null || _a === void 0 || _a.remove();
        const preRenderWrapper = document.createElement('div');
        preRenderWrapper.id = preRenderIds.wrapper;
        const initialPreRenderWrapperStyle = {
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100vw',
            height: '100vh'
        };
        (0, $7aJfj.setStyleProperties)(preRenderWrapper, initialPreRenderWrapperStyle);
        return preRenderWrapper;
    }
    connectPreRendered() {
        const preRenderIds = this.getPreRenderIds();
        const preRenderWrapperElement = document.getElementById(preRenderIds.wrapper);
        this.preRenderWrapper = this.preRenderWrapper || preRenderWrapperElement;
        this.preRenderChild = this.preRenderChild || document.getElementById(preRenderIds.child);
        if (this.preRenderWrapper && this.preRenderChild) {
            this.isPreRendered = true;
            if (this.preRenderChild instanceof HTMLIFrameElement) this.setIframeElement(this.preRenderChild);
            this.insertedDomEl = this.preRenderWrapper;
            this.isRendered = true;
        }
        return this.isPreRenderAvailable();
    }
    isPreRenderAvailable() {
        return this.isRendered && this.isPreRendered && Boolean(this.preRenderWrapper && this.preRenderChild);
    }
    createPreRenderChild(child) {
        var _a;
        const preRenderIds = this.getPreRenderIds();
        (_a = document.getElementById(preRenderIds.child)) === null || _a === void 0 || _a.remove();
        if (child instanceof HTMLElement) {
            child.id = preRenderIds.child;
            return child;
        }
        const divChildNode = document.createElement('div');
        (0, $7aJfj.setStyleProperties)(divChildNode, {
            width: '100%',
            height: '100%'
        });
        divChildNode.id = preRenderIds.child;
        if (typeof child === 'string') divChildNode.innerHTML = child;
        else divChildNode.appendChild(child);
        return divChildNode;
    }
    insertIntoDOMForPreRender(child) {
        const preRenderChild = this.createPreRenderChild(child);
        const preRenderWrapper = this.createPreRenderWrapper();
        preRenderWrapper.appendChild(preRenderChild);
        this.preRenderChild = preRenderChild;
        this.preRenderWrapper = preRenderWrapper;
        if (preRenderChild instanceof HTMLIFrameElement) this.setIframeElement(preRenderChild);
        this.insertedDomEl = preRenderWrapper;
        if (this.showPreRenderByDefault) this.showPreRender();
        else this.hidePreRender();
        document.body.appendChild(preRenderWrapper);
    }
    insertIntoDOM(child) {
        var _a;
        if (this.viewConfig.insertAsSibling) {
            if (typeof child === 'string') {
                const div = document.createElement('div');
                div.innerHTML = child;
                div.id = $218d7ff0debb34ef$var$TS_EMBED_ID;
                child = div;
            }
            if (((_a = this.el.nextElementSibling) === null || _a === void 0 ? void 0 : _a.id) === $218d7ff0debb34ef$var$TS_EMBED_ID) this.el.nextElementSibling.remove();
            this.el.parentElement.insertBefore(child, this.el.nextSibling);
            this.insertedDomEl = child;
        } else if (typeof child === 'string') {
            this.el.innerHTML = child;
            this.insertedDomEl = this.el.children[0];
        } else {
            this.el.innerHTML = '';
            this.el.appendChild(child);
            this.insertedDomEl = child;
        }
    }
    /**
     * Sets the height of the iframe
     * @param height The height in pixels
     */ setIFrameHeight(height) {
        this.iFrame.style.height = (0, $7aJfj.getCssDimension)(height);
    }
    /**
     * Executes all registered event handlers for a particular event type
     * @param eventType The event type
     * @param data The payload invoked with the event handler
     * @param eventPort The event Port for a specific MessageChannel
     */ executeCallbacks(eventType, data, eventPort) {
        const eventHandlers = this.eventHandlerMap.get(eventType) || [];
        const allHandlers = this.eventHandlerMap.get((0, $dV0Ap.EmbedEvent).ALL) || [];
        const callbacks = [
            ...eventHandlers,
            ...allHandlers
        ];
        const dataStatus = (data === null || data === void 0 ? void 0 : data.status) || (0, $7aJfj.embedEventStatus).END;
        callbacks.forEach((callbackObj)=>{
            if (// When start status is true it trigger only start releated
            // payload
            callbackObj.options.start && dataStatus === (0, $7aJfj.embedEventStatus).START || !callbackObj.options.start && dataStatus === (0, $7aJfj.embedEventStatus).END) {
                const responder = this.createEmbedEventResponder(eventPort, eventType);
                callbackObj.callback(data, responder);
            }
        });
    }
    /**
     * Returns the ThoughtSpot hostname or IP address.
     */ getThoughtSpotHost() {
        return this.thoughtSpotHost;
    }
    /**
     * Gets the v1 event type (if applicable) for the EmbedEvent type
     * @param eventType The v2 event type
     * @returns The corresponding v1 event type if one exists
     * or else the v2 event type itself
     */ getCompatibleEventType(eventType) {
        return $218d7ff0debb34ef$var$V1EventMap[eventType] || eventType;
    }
    /**
     * Calculates the iframe center for the current visible viewPort
     * of iframe using Scroll position of Host App, offsetTop for iframe
     * in Host app. ViewPort height of the tab.
     * @returns iframe Center in visible viewport,
     *  Iframe height,
     *  View port height.
     */ getIframeCenter() {
        const offsetTopClient = (0, $7aJfj.getOffsetTop)(this.iFrame);
        const scrollTopClient = window.scrollY;
        const viewPortHeight = window.innerHeight;
        const iframeHeight = this.iFrame.offsetHeight;
        const iframeScrolled = scrollTopClient - offsetTopClient;
        let iframeVisibleViewPort;
        let iframeOffset;
        if (iframeScrolled < 0) {
            iframeVisibleViewPort = viewPortHeight - (offsetTopClient - scrollTopClient);
            iframeVisibleViewPort = Math.min(iframeHeight, iframeVisibleViewPort);
            iframeOffset = 0;
        } else {
            iframeVisibleViewPort = Math.min(iframeHeight - iframeScrolled, viewPortHeight);
            iframeOffset = iframeScrolled;
        }
        const iframeCenter = iframeOffset + iframeVisibleViewPort / 2;
        return {
            iframeCenter: iframeCenter,
            iframeScrolled: iframeScrolled,
            iframeHeight: iframeHeight,
            viewPortHeight: viewPortHeight,
            iframeVisibleViewPort: iframeVisibleViewPort
        };
    }
    /**
     * Registers an event listener to trigger an alert when the ThoughtSpot app
     * sends an event of a particular message type to the host application.
     * @param messageType The message type
     * @param callback A callback as a function
     * @param options The message options
     * @param isSelf
     * @param isRegisteredBySDK
     * @example
     * ```js
     * tsEmbed.on(EmbedEvent.Error, (data) => {
     *   console.error(data);
     * });
     * ```
     * @example
     * ```js
     * tsEmbed.on(EmbedEvent.Save, (data) => {
     *   console.log("Answer save clicked", data);
     * }, {
     *   start: true // This will trigger the callback on start of save
     * });
     * ```
     */ on(messageType, callback, options = {
        start: false
    }, isRegisteredBySDK = false) {
        (0, $fxzLD.uploadMixpanelEvent)(`${(0, $fxzLD.MIXPANEL_EVENT).VISUAL_SDK_ON}-${messageType}`, {
            isRegisteredBySDK: isRegisteredBySDK
        });
        if (this.isRendered) (0, $kCAID.logger).warn('Please register event handlers before calling render');
        const callbacks = this.eventHandlerMap.get(messageType) || [];
        callbacks.push({
            options: options,
            callback: callback
        });
        this.eventHandlerMap.set(messageType, callbacks);
        return this;
    }
    /**
     * Removes an event listener for a particular event type.
     * @param messageType The message type
     * @param callback The callback to remove
     * @example
     * ```js
     * const errorHandler = (data) => { console.error(data); };
     * tsEmbed.on(EmbedEvent.Error, errorHandler);
     * tsEmbed.off(EmbedEvent.Error, errorHandler);
     * ```
     */ off(messageType, callback) {
        const callbacks = this.eventHandlerMap.get(messageType) || [];
        const index = callbacks.findIndex((cb)=>cb.callback === callback);
        if (index > -1) callbacks.splice(index, 1);
        return this;
    }
    /**
     * Triggers an event on specific Port registered against
     * for the EmbedEvent
     * @param eventType The message type
     * @param data The payload to send
     * @param eventPort
     * @param payload
     */ triggerEventOnPort(eventPort, payload) {
        if (eventPort) try {
            eventPort.postMessage({
                type: payload.type,
                data: payload.data
            });
        } catch (e) {
            eventPort.postMessage({
                error: e
            });
            (0, $kCAID.logger).log(e);
        }
        else (0, $kCAID.logger).log('Event Port is not defined');
    }
    getPreRenderObj() {
        var _a;
        const embedObj = (_a = this.insertedDomEl) === null || _a === void 0 ? void 0 : _a[this.embedNodeKey];
        if (embedObj === this) (0, $kCAID.logger).info('embedObj is same as this');
        return embedObj;
    }
    checkEmbedContainerLoaded() {
        if (this.isEmbedContainerLoaded) return true;
        const preRenderObj = this.getPreRenderObj();
        if (preRenderObj && preRenderObj.isEmbedContainerLoaded) this.isEmbedContainerLoaded = true;
        return this.isEmbedContainerLoaded;
    }
    executeEmbedContainerReadyCallbacks() {
        (0, $kCAID.logger).debug('executePendingEvents', this.embedContainerReadyCallbacks);
        this.embedContainerReadyCallbacks.forEach((callback)=>{
            callback === null || callback === void 0 || callback();
        });
        this.embedContainerReadyCallbacks = [];
    }
    /**
     * Executes a callback after the embed container is loaded.
     * @param callback The callback to execute
     */ executeAfterEmbedContainerLoaded(callback) {
        if (this.checkEmbedContainerLoaded()) callback === null || callback === void 0 || callback();
        else {
            (0, $kCAID.logger).debug('pushing callback to embedContainerReadyCallbacks', callback);
            this.embedContainerReadyCallbacks.push(callback);
        }
    }
    /**
     * Triggers an event to the embedded app
     * @param {HostEvent} messageType The event type
     * @param {any} data The payload to send with the message
     * @param {ContextType} context Optional context type to specify the context from which the event is triggered.
     * Use ContextType.Search for search answer context, ContextType.Answer for answer/explore context,
     * ContextType.Liveboard for liveboard context, or ContextType.Spotter for spotter context.
     * Available from SDK version 1.45.2 | ThoughtSpot: 26.3.0.cl
     * @returns A promise that resolves with the response from the embedded app
     * @example
     * ```js
     * // Trigger Pin event with context (SDK: 1.45.2+)
     * import { HostEvent, ContextType } from '@thoughtspot/visual-embed-sdk';
     * embed.trigger(HostEvent.Pin, {
     *   vizId: "123",
     *   liveboardId: "456"
     * }, ContextType.Search);
     * ```
     * @version SDK: 1.45.2 | ThoughtSpot: 26.3.0.cl (for context parameter)
     */ async trigger(messageType, data = {}, context) {
        (0, $fxzLD.uploadMixpanelEvent)(`${(0, $fxzLD.MIXPANEL_EVENT).VISUAL_SDK_TRIGGER}-${messageType}`);
        if (!this.isRendered) {
            this.handleError({
                errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
                message: (0, $h7cYZ.ERROR_MESSAGE).RENDER_BEFORE_EVENTS_REQUIRED,
                code: (0, $dV0Ap.EmbedErrorCodes).RENDER_NOT_CALLED,
                error: (0, $h7cYZ.ERROR_MESSAGE).RENDER_BEFORE_EVENTS_REQUIRED
            });
            return null;
        }
        if (!messageType) {
            this.handleError({
                errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
                message: (0, $h7cYZ.ERROR_MESSAGE).HOST_EVENT_TYPE_UNDEFINED,
                code: (0, $dV0Ap.EmbedErrorCodes).HOST_EVENT_TYPE_UNDEFINED,
                error: (0, $h7cYZ.ERROR_MESSAGE).HOST_EVENT_TYPE_UNDEFINED
            });
            return null;
        }
        // Check if iframe exists before triggering - 
        // this prevents the error when auth fails
        if (!this.iFrame) {
            (0, $kCAID.logger).debug(`Cannot trigger ${messageType} - iframe not available (likely due to auth failure)`);
            return null;
        }
        // send an empty object, this is needed for liveboard default handlers
        return this.hostEventClient.triggerHostEvent(messageType, data, context).catch((err)=>{
            var _a;
            if (err === null || err === void 0 ? void 0 : err.isValidationError) {
                const errorDetails = (_a = err.embedErrorDetails) !== null && _a !== void 0 ? _a : {
                    errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
                    message: err.message || (0, $h7cYZ.ERROR_MESSAGE).UPDATEFILTERS_INVALID_PAYLOAD,
                    code: (0, $dV0Ap.EmbedErrorCodes).UPDATEFILTERS_INVALID_PAYLOAD,
                    error: err.message
                };
                this.handleError(errorDetails);
            }
            throw err;
        });
    }
    /**
     * Triggers an event to the embedded app, skipping the UI flow.
     * @param {UIPassthroughEvent} apiName - The name of the API to be triggered.
     * @param {UIPassthroughRequest} parameters - The parameters to be passed to the API.
     * @returns {Promise<UIPassthroughRequest>} - A promise that resolves with the response
     * from the embedded app.
     */ async triggerUIPassThrough(apiName, parameters) {
        const response = this.hostEventClient.triggerUIPassthroughApi(apiName, parameters);
        return response;
    }
    /**
     * Marks the ThoughtSpot object to have been rendered
     * Needs to be overridden by subclasses to do the actual
     * rendering of the iframe.
     * @param args
     */ async render() {
        if (!(0, $e0AWW.getIsInitCalled)()) (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).RENDER_CALLED_BEFORE_INIT);
        await this.isReadyForRenderPromise;
        this.isRendered = true;
        return this;
    }
    getIframeSrc() {
        return '';
    }
    handleRenderForPrerender() {
        return this.render();
    }
    /**
    * Context object for the embedded component.
    * @returns {ContextObject} The current context object containing the page type and object ids.
    * @example
    * ```js
    * const context = await embed.getCurrentContext();
    * console.log(context);
    *
    * // Example output
    * {
    *   stack: [
    *     {
    *       name: 'Liveboard',
    *       type: ContextType.Liveboard,
    *       objectIds: {
    *         liveboardId: '123',
    *       },
    *     },
    *   ],
    *   currentContext: {
    *     name: 'Liveboard',
    *     type: ContextType.Liveboard,
    *     objectIds: {
    *       liveboardId: '123',
    *     },
    *   },
    * }
    * ```
     * @version SDK: 1.45.2 | ThoughtSpot: 26.3.0.cl
     */ async getCurrentContext() {
        return new Promise((resolve)=>{
            this.executeAfterEmbedContainerLoaded(async ()=>{
                const context = await this.trigger((0, $dV0Ap.HostEvent).GetPageContext, {});
                resolve(context);
            });
        });
    }
    /**
     * Creates the preRender shell
     * @param showPreRenderByDefault - Show the preRender after render, hidden by default
     */ async preRender(showPreRenderByDefault = false, replaceExistingPreRender = false) {
        if (!this.viewConfig.preRenderId) {
            (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).PRERENDER_ID_MISSING);
            return this;
        }
        this.isPreRendered = true;
        this.showPreRenderByDefault = showPreRenderByDefault;
        const isAlreadyRendered = this.connectPreRendered();
        if (isAlreadyRendered && !replaceExistingPreRender) return this;
        return this.handleRenderForPrerender();
    }
    /**
     * Get the Post Url Params for THOUGHTSPOT from the current
     * host app URL.
     * THOUGHTSPOT URL params starts with a prefix "ts-"
     * @version SDK: 1.14.0 | ThoughtSpot: 8.4.0.cl, 8.4.1-sw
     */ getThoughtSpotPostUrlParams(additionalParams = {}) {
        const urlHash = window.location.hash;
        const queryParams = window.location.search;
        const postHashParams = urlHash.split('?');
        const postURLParams = postHashParams[postHashParams.length - 1];
        const queryParamsObj = new URLSearchParams(queryParams);
        const postURLParamsObj = new URLSearchParams(postURLParams);
        const params = new URLSearchParams();
        const addKeyValuePairCb = (value, key)=>{
            if (key.startsWith($218d7ff0debb34ef$export$fbd947bd5ee90e)) params.append(key, value);
        };
        queryParamsObj.forEach(addKeyValuePairCb);
        postURLParamsObj.forEach(addKeyValuePairCb);
        Object.entries(additionalParams).forEach(([k, v])=>params.append(k, v));
        let tsParams = params.toString();
        tsParams = tsParams ? `?${tsParams}` : '';
        return tsParams;
    }
    /**
     * Destroys the ThoughtSpot embed, and remove any nodes from the DOM.
     * @version SDK: 1.19.1 | ThoughtSpot: *
     */ destroy() {
        var _a, _b;
        try {
            this.removeFullscreenChangeHandler();
            this.unsubscribeToEvents();
            if (!this.isRendered) return;
            if (!(0, $a6640.getEmbedConfig)().waitForCleanupOnDestroy) {
                this.trigger((0, $dV0Ap.HostEvent).DestroyEmbed);
                (_b = (_a = this.insertedDomEl) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 || _b.removeChild(this.insertedDomEl);
            } else {
                const cleanupTimeout = (0, $a6640.getEmbedConfig)().cleanupTimeout;
                Promise.race([
                    this.trigger((0, $dV0Ap.HostEvent).DestroyEmbed),
                    new Promise((resolve)=>setTimeout(resolve, cleanupTimeout))
                ]).catch((e)=>{
                    (0, $kCAID.logger).log('Error destroying TS Embed', e);
                }).finally(()=>{
                    var _a, _b;
                    try {
                        (_b = (_a = this.insertedDomEl) === null || _a === void 0 ? void 0 : _a.parentNode) === null || _b === void 0 || _b.removeChild(this.insertedDomEl);
                    } catch (e) {
                        (0, $kCAID.logger).log('Error removing DOM element on destroy', e);
                    }
                });
            }
        } catch (e) {
            (0, $kCAID.logger).log('Error destroying TS Embed', e);
        }
    }
    getUnderlyingFrameElement() {
        return this.iFrame;
    }
    /**
     * Prerenders a generic instance of the TS component.
     * This means without the path but with the flags already applied.
     * This is useful for prerendering the component in the background.
     * @version SDK: 1.22.0
     * @returns
     */ async prerenderGeneric() {
        if (!(0, $e0AWW.getIsInitCalled)()) (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).RENDER_CALLED_BEFORE_INIT);
        await this.isReadyForRenderPromise;
        const prerenderFrameSrc = this.getRootIframeSrc();
        this.isRendered = true;
        return this.renderIFrame(prerenderFrameSrc);
    }
    beforePrerenderVisible() {
    // Override in subclass
    }
    /**
     * Displays the PreRender component.
     * If the component is not preRendered, it attempts to create and render it.
     * Also, synchronizes the style of the PreRender component with the embedding
     * element.
     */ async showPreRender() {
        if (!this.viewConfig.preRenderId) {
            (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).PRERENDER_ID_MISSING);
            return this;
        }
        if (!this.isPreRenderAvailable()) {
            const isAvailable = this.connectPreRendered();
            if (!isAvailable) // if the Embed component is not preRendered , Render it now and
            return this.preRender(true);
            this.validatePreRenderViewConfig(this.viewConfig);
            (0, $kCAID.logger).debug('triggering UpdateEmbedParams', this.viewConfig);
            this.executeAfterEmbedContainerLoaded(async ()=>{
                try {
                    const params = await this.getUpdateEmbedParamsObject();
                    this.trigger((0, $dV0Ap.HostEvent).UpdateEmbedParams, params);
                } catch (error) {
                    (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).UPDATE_PARAMS_FAILED, error);
                    this.handleError({
                        errorType: (0, $dV0Ap.ErrorDetailsTypes).API,
                        message: (error === null || error === void 0 ? void 0 : error.message) || (0, $h7cYZ.ERROR_MESSAGE).UPDATE_PARAMS_FAILED,
                        code: (0, $dV0Ap.EmbedErrorCodes).UPDATE_PARAMS_FAILED,
                        error: (error === null || error === void 0 ? void 0 : error.message) || error
                    });
                }
            });
        }
        this.beforePrerenderVisible();
        if (this.el) {
            this.syncPreRenderStyle();
            if (!this.viewConfig.doNotTrackPreRenderSize) {
                this.resizeObserver = new ResizeObserver((entries)=>{
                    entries.forEach((entry)=>{
                        if (entry.contentRect && entry.target === this.el) (0, $7aJfj.setStyleProperties)(this.preRenderWrapper, {
                            width: `${entry.contentRect.width}px`,
                            height: `${entry.contentRect.height}px`
                        });
                    });
                });
                this.resizeObserver.observe(this.el);
            }
        }
        (0, $7aJfj.removeStyleProperties)(this.preRenderWrapper, [
            'z-index',
            'opacity',
            'pointer-events',
            'overflow'
        ]);
        this.subscribeToEvents();
        // Setup fullscreen change handler for prerendered components
        if (this.iFrame) this.setupFullscreenChangeHandler();
        return this;
    }
    /**
     * Synchronizes the style properties of the PreRender component with the embedding
     * element. This function adjusts the position, width, and height of the PreRender
     * component
     * to match the dimensions and position of the embedding element.
     * @throws {Error} Throws an error if the embedding element (passed as domSelector)
     * is not defined or not found.
     */ syncPreRenderStyle() {
        if (!this.isPreRenderAvailable() || !this.el) {
            (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).SYNC_STYLE_CALLED_BEFORE_RENDER);
            return;
        }
        const elBoundingClient = this.el.getBoundingClientRect();
        (0, $7aJfj.setStyleProperties)(this.preRenderWrapper, {
            top: `${elBoundingClient.y + window.scrollY}px`,
            left: `${elBoundingClient.x + window.scrollX}px`,
            width: `${elBoundingClient.width}px`,
            height: `${elBoundingClient.height}px`
        });
    }
    /**
     * Hides the PreRender component if it is available.
     * If the component is not preRendered, it issues a warning.
     */ hidePreRender() {
        if (!this.isPreRenderAvailable()) {
            // if the embed component is not preRendered , nothing to hide
            (0, $kCAID.logger).warn('PreRender should be called before hiding it using hidePreRender.');
            return;
        }
        const preRenderHideStyles = {
            opacity: '0',
            pointerEvents: 'none',
            zIndex: '-1000',
            position: 'absolute',
            top: '0',
            left: '0',
            overflow: 'hidden'
        };
        (0, $7aJfj.setStyleProperties)(this.preRenderWrapper, preRenderHideStyles);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        this.unsubscribeToEvents();
    }
    /**
     * Retrieves unique HTML element IDs for PreRender-related elements.
     * These IDs are constructed based on the provided 'preRenderId' from 'viewConfig'.
     * @returns {object} An object containing the IDs for the PreRender elements.
     * @property {string} wrapper - The HTML element ID for the PreRender wrapper.
     * @property {string} child - The HTML element ID for the PreRender child.
     */ getPreRenderIds() {
        return {
            wrapper: `tsEmbed-pre-render-wrapper-${this.viewConfig.preRenderId}`,
            child: `tsEmbed-pre-render-child-${this.viewConfig.preRenderId}`
        };
    }
    /**
     * Returns the answerService which can be used to make arbitrary graphql calls on top
     * session.
     * @param vizId [Optional] to get for a specific viz in case of a Liveboard.
     * @version SDK: 1.25.0 | ThoughtSpot: 9.10.0
     */ async getAnswerService(vizId) {
        const { session: session } = await this.trigger((0, $dV0Ap.HostEvent).GetAnswerSession, vizId ? {
            vizId: vizId
        } : {});
        return new (0, $3q1XH.AnswerService)(session, null, this.embedConfig.thoughtSpotHost);
    }
    /**
     * Set up fullscreen change detection to automatically trigger ExitPresentMode
     * when user exits fullscreen mode
     */ setupFullscreenChangeHandler() {
        var _a;
        const embedConfig = (0, $a6640.getEmbedConfig)();
        const disableFullscreenPresentation = (_a = embedConfig === null || embedConfig === void 0 ? void 0 : embedConfig.disableFullscreenPresentation) !== null && _a !== void 0 ? _a : true;
        if (disableFullscreenPresentation) return;
        if (this.fullscreenChangeHandler) document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler);
        this.fullscreenChangeHandler = ()=>{
            const isFullscreen = !!document.fullscreenElement;
            if (!isFullscreen) {
                (0, $kCAID.logger).info('Exited fullscreen mode - triggering ExitPresentMode');
                // Only trigger if iframe is available and contentWindow is
                // accessible
                if (this.iFrame && this.iFrame.contentWindow) this.trigger((0, $dV0Ap.HostEvent).ExitPresentMode);
                else (0, $kCAID.logger).debug('Skipping ExitPresentMode - iframe contentWindow not available');
            }
        };
        document.addEventListener('fullscreenchange', this.fullscreenChangeHandler);
    }
    /**
     * Remove fullscreen change handler
     */ removeFullscreenChangeHandler() {
        if (this.fullscreenChangeHandler) {
            document.removeEventListener('fullscreenchange', this.fullscreenChangeHandler);
            this.fullscreenChangeHandler = null;
        }
    }
}
class $218d7ff0debb34ef$export$9184aa0f8b851822 extends $218d7ff0debb34ef$export$6d92ba91718653d8 {
    constructor(domSelector, viewConfig){
        super(domSelector, viewConfig);
        /**
         * Only for testing purposes.
         * @hidden
         */ this.test__executeCallbacks = this.executeCallbacks;
        this.viewConfig = {
            excludeRuntimeFiltersfromURL: true,
            excludeRuntimeParametersfromURL: true,
            ...viewConfig
        };
    }
    /**
     * Render the app in an iframe and set up event handlers
     * @param iframeSrc
     */ renderV1Embed(iframeSrc) {
        return this.renderIFrame(iframeSrc);
    }
    getRootIframeSrc() {
        const queryParams = this.getEmbedParams();
        let queryString = queryParams;
        if (!this.viewConfig.excludeRuntimeParametersfromURL) {
            const runtimeParameters = this.viewConfig.runtimeParameters;
            const parameterQuery = (0, $7aJfj.getRuntimeParameters)(runtimeParameters || []);
            queryString = [
                parameterQuery,
                queryParams
            ].filter(Boolean).join('&');
        }
        if (!this.viewConfig.excludeRuntimeFiltersfromURL) {
            const runtimeFilters = this.viewConfig.runtimeFilters;
            const filterQuery = (0, $7aJfj.getFilterQuery)(runtimeFilters || []);
            queryString = [
                filterQuery,
                queryString
            ].filter(Boolean).join('&');
        }
        return this.viewConfig.enableV2Shell_experimental ? this.getEmbedBasePath(queryString) : this.getV1EmbedBasePath(queryString);
    }
    /**
     * @inheritdoc
     * @example
     * ```js
     * tsEmbed.on(EmbedEvent.Error, (data) => {
     *   console.error(data);
     * });
     * ```
     * @example
     * ```js
     * tsEmbed.on(EmbedEvent.Save, (data) => {
     *   console.log("Answer save clicked", data);
     * }, {
     *   start: true // This will trigger the callback on start of save
     * });
     * ```
     */ on(messageType, callback, options = {
        start: false
    }) {
        const eventType = this.getCompatibleEventType(messageType);
        return super.on(eventType, callback, options);
    }
}

});
parcelRegister("6bh8U", function(module, exports) {

var $hI53D = parcelRequire("hI53D");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $480111597f858d06$var$isEqual(value, other) {
    return $hI53D(value, other);
}
module.exports = $480111597f858d06$var$isEqual;

});
parcelRegister("hI53D", function(module, exports) {

var $h5pHd = parcelRequire("h5pHd");

var $4Du0J = parcelRequire("4Du0J");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $ce4a780ea1549a48$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$4Du0J(value) && !$4Du0J(other)) return value !== value && other !== other;
    return $h5pHd(value, other, bitmask, customizer, $ce4a780ea1549a48$var$baseIsEqual, stack);
}
module.exports = $ce4a780ea1549a48$var$baseIsEqual;

});
parcelRegister("h5pHd", function(module, exports) {

var $2GSgF = parcelRequire("2GSgF");

var $aw1v6 = parcelRequire("aw1v6");

var $1Ic31 = parcelRequire("1Ic31");

var $4QwsC = parcelRequire("4QwsC");

var $6p9FM = parcelRequire("6p9FM");

var $8JAfJ = parcelRequire("8JAfJ");

var $5x5qJ = parcelRequire("5x5qJ");

var $35pob = parcelRequire("35pob");
/** Used to compose bitmasks for value comparisons. */ var $c706d5f9212c853a$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c706d5f9212c853a$var$argsTag = '[object Arguments]', $c706d5f9212c853a$var$arrayTag = '[object Array]', $c706d5f9212c853a$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $c706d5f9212c853a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c706d5f9212c853a$var$hasOwnProperty = $c706d5f9212c853a$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c706d5f9212c853a$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $8JAfJ(object), othIsArr = $8JAfJ(other), objTag = objIsArr ? $c706d5f9212c853a$var$arrayTag : $6p9FM(object), othTag = othIsArr ? $c706d5f9212c853a$var$arrayTag : $6p9FM(other);
    objTag = objTag == $c706d5f9212c853a$var$argsTag ? $c706d5f9212c853a$var$objectTag : objTag;
    othTag = othTag == $c706d5f9212c853a$var$argsTag ? $c706d5f9212c853a$var$objectTag : othTag;
    var objIsObj = objTag == $c706d5f9212c853a$var$objectTag, othIsObj = othTag == $c706d5f9212c853a$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $5x5qJ(object)) {
        if (!$5x5qJ(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $2GSgF);
        return objIsArr || $35pob(object) ? $aw1v6(object, other, bitmask, customizer, equalFunc, stack) : $1Ic31(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c706d5f9212c853a$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c706d5f9212c853a$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $c706d5f9212c853a$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $2GSgF);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $2GSgF);
    return $4QwsC(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $c706d5f9212c853a$var$baseIsEqualDeep;

});
parcelRegister("2GSgF", function(module, exports) {

var $3kOYa = parcelRequire("3kOYa");

var $iGBmD = parcelRequire("iGBmD");

var $j9pFi = parcelRequire("j9pFi");

var $6B3St = parcelRequire("6B3St");

var $h6oOR = parcelRequire("h6oOR");

var $MPaHQ = parcelRequire("MPaHQ");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $1f599974288ddc95$var$Stack(entries) {
    var data = this.__data__ = new $3kOYa(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$1f599974288ddc95$var$Stack.prototype.clear = $iGBmD;
$1f599974288ddc95$var$Stack.prototype['delete'] = $j9pFi;
$1f599974288ddc95$var$Stack.prototype.get = $6B3St;
$1f599974288ddc95$var$Stack.prototype.has = $h6oOR;
$1f599974288ddc95$var$Stack.prototype.set = $MPaHQ;
module.exports = $1f599974288ddc95$var$Stack;

});
parcelRegister("3kOYa", function(module, exports) {

var $lhXrZ = parcelRequire("lhXrZ");

var $lL2bl = parcelRequire("lL2bl");

var $fanUD = parcelRequire("fanUD");

var $42r2X = parcelRequire("42r2X");

var $eNiY2 = parcelRequire("eNiY2");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $26dac6d4baa6548b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$26dac6d4baa6548b$var$ListCache.prototype.clear = $lhXrZ;
$26dac6d4baa6548b$var$ListCache.prototype['delete'] = $lL2bl;
$26dac6d4baa6548b$var$ListCache.prototype.get = $fanUD;
$26dac6d4baa6548b$var$ListCache.prototype.has = $42r2X;
$26dac6d4baa6548b$var$ListCache.prototype.set = $eNiY2;
module.exports = $26dac6d4baa6548b$var$ListCache;

});
parcelRegister("lhXrZ", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $f7f94d267ff43952$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $f7f94d267ff43952$var$listCacheClear;

});

parcelRegister("lL2bl", function(module, exports) {

var $dretn = parcelRequire("dretn");
/** Used for built-in method references. */ var $fd6fae08271f92f9$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $fd6fae08271f92f9$var$splice = $fd6fae08271f92f9$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fd6fae08271f92f9$var$listCacheDelete(key) {
    var data = this.__data__, index = $dretn(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $fd6fae08271f92f9$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $fd6fae08271f92f9$var$listCacheDelete;

});
parcelRegister("dretn", function(module, exports) {

var $9StTY = parcelRequire("9StTY");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $9c8905f7bc395e02$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($9StTY(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $9c8905f7bc395e02$var$assocIndexOf;

});
parcelRegister("9StTY", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $73105a0d3f14fdb2$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $73105a0d3f14fdb2$var$eq;

});



parcelRegister("fanUD", function(module, exports) {

var $dretn = parcelRequire("dretn");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b0aa56b3d160f5f6$var$listCacheGet(key) {
    var data = this.__data__, index = $dretn(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b0aa56b3d160f5f6$var$listCacheGet;

});

parcelRegister("42r2X", function(module, exports) {

var $dretn = parcelRequire("dretn");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2f0c5440f0ee18d8$var$listCacheHas(key) {
    return $dretn(this.__data__, key) > -1;
}
module.exports = $2f0c5440f0ee18d8$var$listCacheHas;

});

parcelRegister("eNiY2", function(module, exports) {

var $dretn = parcelRequire("dretn");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ac545ad3f3d2fc6c$var$listCacheSet(key, value) {
    var data = this.__data__, index = $dretn(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ac545ad3f3d2fc6c$var$listCacheSet;

});


parcelRegister("iGBmD", function(module, exports) {

var $3kOYa = parcelRequire("3kOYa");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $d9a921f477074947$var$stackClear() {
    this.__data__ = new $3kOYa;
    this.size = 0;
}
module.exports = $d9a921f477074947$var$stackClear;

});

parcelRegister("j9pFi", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $df12c41dbc92e36c$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $df12c41dbc92e36c$var$stackDelete;

});

parcelRegister("6B3St", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4cd934ce3f365f6e$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $4cd934ce3f365f6e$var$stackGet;

});

parcelRegister("h6oOR", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c7363fd41a8f4731$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $c7363fd41a8f4731$var$stackHas;

});

parcelRegister("MPaHQ", function(module, exports) {

var $3kOYa = parcelRequire("3kOYa");

var $5JlQS = parcelRequire("5JlQS");

var $gbn6K = parcelRequire("gbn6K");
/** Used as the size to enable large array optimizations. */ var $092c2d707d34237b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $092c2d707d34237b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $3kOYa) {
        var pairs = data.__data__;
        if (!$5JlQS || pairs.length < $092c2d707d34237b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $gbn6K(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $092c2d707d34237b$var$stackSet;

});
parcelRegister("5JlQS", function(module, exports) {

var $dCkw7 = parcelRequire("dCkw7");

var $959cr = parcelRequire("959cr");
/* Built-in method references that are verified to be native. */ var $42c21b0c48b01d7c$var$Map = $dCkw7($959cr, 'Map');
module.exports = $42c21b0c48b01d7c$var$Map;

});
parcelRegister("dCkw7", function(module, exports) {

var $9jZtK = parcelRequire("9jZtK");

var $9h2aD = parcelRequire("9h2aD");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $9e9ebd3ef44a2f2b$var$getNative(object, key) {
    var value = $9h2aD(object, key);
    return $9jZtK(value) ? value : undefined;
}
module.exports = $9e9ebd3ef44a2f2b$var$getNative;

});
parcelRegister("9jZtK", function(module, exports) {

var $jln1g = parcelRequire("jln1g");

var $fKs4q = parcelRequire("fKs4q");

var $hZEPb = parcelRequire("hZEPb");

var $9wI4x = parcelRequire("9wI4x");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $01c0591819899026$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $01c0591819899026$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $01c0591819899026$var$funcProto = Function.prototype, $01c0591819899026$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $01c0591819899026$var$funcToString = $01c0591819899026$var$funcProto.toString;
/** Used to check objects for own properties. */ var $01c0591819899026$var$hasOwnProperty = $01c0591819899026$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $01c0591819899026$var$reIsNative = RegExp('^' + $01c0591819899026$var$funcToString.call($01c0591819899026$var$hasOwnProperty).replace($01c0591819899026$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $01c0591819899026$var$baseIsNative(value) {
    if (!$hZEPb(value) || $fKs4q(value)) return false;
    var pattern = $jln1g(value) ? $01c0591819899026$var$reIsNative : $01c0591819899026$var$reIsHostCtor;
    return pattern.test($9wI4x(value));
}
module.exports = $01c0591819899026$var$baseIsNative;

});
parcelRegister("jln1g", function(module, exports) {

var $lqs1Q = parcelRequire("lqs1Q");

var $hZEPb = parcelRequire("hZEPb");
/** `Object#toString` result references. */ var $e151d5a2e896931a$var$asyncTag = '[object AsyncFunction]', $e151d5a2e896931a$var$funcTag = '[object Function]', $e151d5a2e896931a$var$genTag = '[object GeneratorFunction]', $e151d5a2e896931a$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $e151d5a2e896931a$var$isFunction(value) {
    if (!$hZEPb(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $lqs1Q(value);
    return tag == $e151d5a2e896931a$var$funcTag || tag == $e151d5a2e896931a$var$genTag || tag == $e151d5a2e896931a$var$asyncTag || tag == $e151d5a2e896931a$var$proxyTag;
}
module.exports = $e151d5a2e896931a$var$isFunction;

});
parcelRegister("lqs1Q", function(module, exports) {

var $1its0 = parcelRequire("1its0");

var $aFvfT = parcelRequire("aFvfT");

var $iMJYY = parcelRequire("iMJYY");
/** `Object#toString` result references. */ var $f991c4953ebb1101$var$nullTag = '[object Null]', $f991c4953ebb1101$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $f991c4953ebb1101$var$symToStringTag = $1its0 ? $1its0.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $f991c4953ebb1101$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $f991c4953ebb1101$var$undefinedTag : $f991c4953ebb1101$var$nullTag;
    return $f991c4953ebb1101$var$symToStringTag && $f991c4953ebb1101$var$symToStringTag in Object(value) ? $aFvfT(value) : $iMJYY(value);
}
module.exports = $f991c4953ebb1101$var$baseGetTag;

});
parcelRegister("1its0", function(module, exports) {

var $959cr = parcelRequire("959cr");
/** Built-in value references. */ var $0f1e513298ff9f91$var$Symbol = $959cr.Symbol;
module.exports = $0f1e513298ff9f91$var$Symbol;

});
parcelRegister("959cr", function(module, exports) {

var $gYXEb = parcelRequire("gYXEb");
/** Detect free variable `self`. */ var $69cbb788ce93ecc8$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $69cbb788ce93ecc8$var$root = $gYXEb || $69cbb788ce93ecc8$var$freeSelf || Function('return this')();
module.exports = $69cbb788ce93ecc8$var$root;

});
parcelRegister("gYXEb", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $c5d084997df12bee$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $c5d084997df12bee$var$freeGlobal;

});



parcelRegister("aFvfT", function(module, exports) {

var $1its0 = parcelRequire("1its0");
/** Used for built-in method references. */ var $7c45fa5ed33a0cb9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7c45fa5ed33a0cb9$var$hasOwnProperty = $7c45fa5ed33a0cb9$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7c45fa5ed33a0cb9$var$nativeObjectToString = $7c45fa5ed33a0cb9$var$objectProto.toString;
/** Built-in value references. */ var $7c45fa5ed33a0cb9$var$symToStringTag = $1its0 ? $1its0.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $7c45fa5ed33a0cb9$var$getRawTag(value) {
    var isOwn = $7c45fa5ed33a0cb9$var$hasOwnProperty.call(value, $7c45fa5ed33a0cb9$var$symToStringTag), tag = value[$7c45fa5ed33a0cb9$var$symToStringTag];
    try {
        value[$7c45fa5ed33a0cb9$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $7c45fa5ed33a0cb9$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$7c45fa5ed33a0cb9$var$symToStringTag] = tag;
        else delete value[$7c45fa5ed33a0cb9$var$symToStringTag];
    }
    return result;
}
module.exports = $7c45fa5ed33a0cb9$var$getRawTag;

});

parcelRegister("iMJYY", function(module, exports) {
/** Used for built-in method references. */ var $dad060dccf828d40$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dad060dccf828d40$var$nativeObjectToString = $dad060dccf828d40$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $dad060dccf828d40$var$objectToString(value) {
    return $dad060dccf828d40$var$nativeObjectToString.call(value);
}
module.exports = $dad060dccf828d40$var$objectToString;

});


parcelRegister("hZEPb", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $d197cd18280f2324$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $d197cd18280f2324$var$isObject;

});


parcelRegister("fKs4q", function(module, exports) {

var $6JlKZ = parcelRequire("6JlKZ");
/** Used to detect methods masquerading as native. */ var $b770ed1872546ff5$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($6JlKZ && $6JlKZ.keys && $6JlKZ.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b770ed1872546ff5$var$isMasked(func) {
    return !!$b770ed1872546ff5$var$maskSrcKey && $b770ed1872546ff5$var$maskSrcKey in func;
}
module.exports = $b770ed1872546ff5$var$isMasked;

});
parcelRegister("6JlKZ", function(module, exports) {

var $959cr = parcelRequire("959cr");
/** Used to detect overreaching core-js shims. */ var $4e67d2806232c3a0$var$coreJsData = $959cr["__core-js_shared__"];
module.exports = $4e67d2806232c3a0$var$coreJsData;

});


parcelRegister("9wI4x", function(module, exports) {
/** Used for built-in method references. */ var $6ef94a099674b452$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $6ef94a099674b452$var$funcToString = $6ef94a099674b452$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $6ef94a099674b452$var$toSource(func) {
    if (func != null) {
        try {
            return $6ef94a099674b452$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $6ef94a099674b452$var$toSource;

});


parcelRegister("9h2aD", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $6c076295e2c250cc$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $6c076295e2c250cc$var$getValue;

});



parcelRegister("gbn6K", function(module, exports) {

var $hdpfc = parcelRequire("hdpfc");

var $dWbkK = parcelRequire("dWbkK");

var $7SLkb = parcelRequire("7SLkb");

var $lvhBm = parcelRequire("lvhBm");

var $9x0Ny = parcelRequire("9x0Ny");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bc7f99297d07463a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$bc7f99297d07463a$var$MapCache.prototype.clear = $hdpfc;
$bc7f99297d07463a$var$MapCache.prototype['delete'] = $dWbkK;
$bc7f99297d07463a$var$MapCache.prototype.get = $7SLkb;
$bc7f99297d07463a$var$MapCache.prototype.has = $lvhBm;
$bc7f99297d07463a$var$MapCache.prototype.set = $9x0Ny;
module.exports = $bc7f99297d07463a$var$MapCache;

});
parcelRegister("hdpfc", function(module, exports) {

var $liZgF = parcelRequire("liZgF");

var $3kOYa = parcelRequire("3kOYa");

var $5JlQS = parcelRequire("5JlQS");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $c8873b82b6b13e88$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $liZgF,
        'map': new ($5JlQS || $3kOYa),
        'string': new $liZgF
    };
}
module.exports = $c8873b82b6b13e88$var$mapCacheClear;

});
parcelRegister("liZgF", function(module, exports) {

var $fhWWG = parcelRequire("fhWWG");

var $gBtrh = parcelRequire("gBtrh");

var $ee14B = parcelRequire("ee14B");

var $2QMoR = parcelRequire("2QMoR");

var $epEhp = parcelRequire("epEhp");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f82acde88cb5eacc$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$f82acde88cb5eacc$var$Hash.prototype.clear = $fhWWG;
$f82acde88cb5eacc$var$Hash.prototype['delete'] = $gBtrh;
$f82acde88cb5eacc$var$Hash.prototype.get = $ee14B;
$f82acde88cb5eacc$var$Hash.prototype.has = $2QMoR;
$f82acde88cb5eacc$var$Hash.prototype.set = $epEhp;
module.exports = $f82acde88cb5eacc$var$Hash;

});
parcelRegister("fhWWG", function(module, exports) {

var $hCu6J = parcelRequire("hCu6J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $b2162aec011f6c25$var$hashClear() {
    this.__data__ = $hCu6J ? $hCu6J(null) : {};
    this.size = 0;
}
module.exports = $b2162aec011f6c25$var$hashClear;

});
parcelRegister("hCu6J", function(module, exports) {

var $dCkw7 = parcelRequire("dCkw7");
/* Built-in method references that are verified to be native. */ var $cd3d56fee1711203$var$nativeCreate = $dCkw7(Object, 'create');
module.exports = $cd3d56fee1711203$var$nativeCreate;

});


parcelRegister("gBtrh", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c166f009ff824f50$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $c166f009ff824f50$var$hashDelete;

});

parcelRegister("ee14B", function(module, exports) {

var $hCu6J = parcelRequire("hCu6J");
/** Used to stand-in for `undefined` hash values. */ var $a5b334a4755d6c1e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $a5b334a4755d6c1e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a5b334a4755d6c1e$var$hasOwnProperty = $a5b334a4755d6c1e$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a5b334a4755d6c1e$var$hashGet(key) {
    var data = this.__data__;
    if ($hCu6J) {
        var result = data[key];
        return result === $a5b334a4755d6c1e$var$HASH_UNDEFINED ? undefined : result;
    }
    return $a5b334a4755d6c1e$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $a5b334a4755d6c1e$var$hashGet;

});

parcelRegister("2QMoR", function(module, exports) {

var $hCu6J = parcelRequire("hCu6J");
/** Used for built-in method references. */ var $2135fb54759126a5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2135fb54759126a5$var$hasOwnProperty = $2135fb54759126a5$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $2135fb54759126a5$var$hashHas(key) {
    var data = this.__data__;
    return $hCu6J ? data[key] !== undefined : $2135fb54759126a5$var$hasOwnProperty.call(data, key);
}
module.exports = $2135fb54759126a5$var$hashHas;

});

parcelRegister("epEhp", function(module, exports) {

var $hCu6J = parcelRequire("hCu6J");
/** Used to stand-in for `undefined` hash values. */ var $a7e2a53cc5ad9505$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $a7e2a53cc5ad9505$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $hCu6J && value === undefined ? $a7e2a53cc5ad9505$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $a7e2a53cc5ad9505$var$hashSet;

});



parcelRegister("dWbkK", function(module, exports) {

var $7nfxV = parcelRequire("7nfxV");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $a2597bc590610955$var$mapCacheDelete(key) {
    var result = $7nfxV(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $a2597bc590610955$var$mapCacheDelete;

});
parcelRegister("7nfxV", function(module, exports) {

var $3FiYm = parcelRequire("3FiYm");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $55e6bd8a1f6fc6ed$var$getMapData(map, key) {
    var data = map.__data__;
    return $3FiYm(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $55e6bd8a1f6fc6ed$var$getMapData;

});
parcelRegister("3FiYm", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $2ab3eafdbde94fa9$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $2ab3eafdbde94fa9$var$isKeyable;

});



parcelRegister("7SLkb", function(module, exports) {

var $7nfxV = parcelRequire("7nfxV");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5bd249315c38d75e$var$mapCacheGet(key) {
    return $7nfxV(this, key).get(key);
}
module.exports = $5bd249315c38d75e$var$mapCacheGet;

});

parcelRegister("lvhBm", function(module, exports) {

var $7nfxV = parcelRequire("7nfxV");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fa7a258dd09db8db$var$mapCacheHas(key) {
    return $7nfxV(this, key).has(key);
}
module.exports = $fa7a258dd09db8db$var$mapCacheHas;

});

parcelRegister("9x0Ny", function(module, exports) {

var $7nfxV = parcelRequire("7nfxV");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $6f07d0a9f7b93c65$var$mapCacheSet(key, value) {
    var data = $7nfxV(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $6f07d0a9f7b93c65$var$mapCacheSet;

});




parcelRegister("aw1v6", function(module, exports) {

var $6e4Tx = parcelRequire("6e4Tx");

var $46EI3 = parcelRequire("46EI3");

var $doLbr = parcelRequire("doLbr");
/** Used to compose bitmasks for value comparisons. */ var $7a7e0e8a938bc809$var$COMPARE_PARTIAL_FLAG = 1, $7a7e0e8a938bc809$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $7a7e0e8a938bc809$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $7a7e0e8a938bc809$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $7a7e0e8a938bc809$var$COMPARE_UNORDERED_FLAG ? new $6e4Tx : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$46EI3(other, function(othValue, othIndex) {
                if (!$doLbr(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $7a7e0e8a938bc809$var$equalArrays;

});
parcelRegister("6e4Tx", function(module, exports) {

var $gbn6K = parcelRequire("gbn6K");

var $cDKYG = parcelRequire("cDKYG");

var $8Rzfy = parcelRequire("8Rzfy");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $4887d8e270b59e15$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $gbn6K;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$4887d8e270b59e15$var$SetCache.prototype.add = $4887d8e270b59e15$var$SetCache.prototype.push = $cDKYG;
$4887d8e270b59e15$var$SetCache.prototype.has = $8Rzfy;
module.exports = $4887d8e270b59e15$var$SetCache;

});
parcelRegister("cDKYG", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $933d9159ef432589$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $933d9159ef432589$var$setCacheAdd(value) {
    this.__data__.set(value, $933d9159ef432589$var$HASH_UNDEFINED);
    return this;
}
module.exports = $933d9159ef432589$var$setCacheAdd;

});

parcelRegister("8Rzfy", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $673e9ddfac74de40$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $673e9ddfac74de40$var$setCacheHas;

});


parcelRegister("46EI3", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $2fd74d09dfe434db$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $2fd74d09dfe434db$var$arraySome;

});

parcelRegister("doLbr", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9c121dee101a8f13$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $9c121dee101a8f13$var$cacheHas;

});


parcelRegister("1Ic31", function(module, exports) {

var $1its0 = parcelRequire("1its0");

var $ljtrK = parcelRequire("ljtrK");

var $9StTY = parcelRequire("9StTY");

var $aw1v6 = parcelRequire("aw1v6");

var $7kZ7h = parcelRequire("7kZ7h");

var $8BkPt = parcelRequire("8BkPt");
/** Used to compose bitmasks for value comparisons. */ var $13f33eec4bff9752$var$COMPARE_PARTIAL_FLAG = 1, $13f33eec4bff9752$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $13f33eec4bff9752$var$boolTag = '[object Boolean]', $13f33eec4bff9752$var$dateTag = '[object Date]', $13f33eec4bff9752$var$errorTag = '[object Error]', $13f33eec4bff9752$var$mapTag = '[object Map]', $13f33eec4bff9752$var$numberTag = '[object Number]', $13f33eec4bff9752$var$regexpTag = '[object RegExp]', $13f33eec4bff9752$var$setTag = '[object Set]', $13f33eec4bff9752$var$stringTag = '[object String]', $13f33eec4bff9752$var$symbolTag = '[object Symbol]';
var $13f33eec4bff9752$var$arrayBufferTag = '[object ArrayBuffer]', $13f33eec4bff9752$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $13f33eec4bff9752$var$symbolProto = $1its0 ? $1its0.prototype : undefined, $13f33eec4bff9752$var$symbolValueOf = $13f33eec4bff9752$var$symbolProto ? $13f33eec4bff9752$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $13f33eec4bff9752$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $13f33eec4bff9752$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $13f33eec4bff9752$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $ljtrK(object), new $ljtrK(other))) return false;
            return true;
        case $13f33eec4bff9752$var$boolTag:
        case $13f33eec4bff9752$var$dateTag:
        case $13f33eec4bff9752$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $9StTY(+object, +other);
        case $13f33eec4bff9752$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $13f33eec4bff9752$var$regexpTag:
        case $13f33eec4bff9752$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $13f33eec4bff9752$var$mapTag:
            var convert = $7kZ7h;
        case $13f33eec4bff9752$var$setTag:
            var isPartial = bitmask & $13f33eec4bff9752$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $8BkPt);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $13f33eec4bff9752$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $aw1v6(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $13f33eec4bff9752$var$symbolTag:
            if ($13f33eec4bff9752$var$symbolValueOf) return $13f33eec4bff9752$var$symbolValueOf.call(object) == $13f33eec4bff9752$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $13f33eec4bff9752$var$equalByTag;

});
parcelRegister("ljtrK", function(module, exports) {

var $959cr = parcelRequire("959cr");
/** Built-in value references. */ var $f84236c77cb8bae8$var$Uint8Array = $959cr.Uint8Array;
module.exports = $f84236c77cb8bae8$var$Uint8Array;

});

parcelRegister("7kZ7h", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $5579cf18d88ec8ff$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $5579cf18d88ec8ff$var$mapToArray;

});

parcelRegister("8BkPt", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $6431efac1d49d5c4$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $6431efac1d49d5c4$var$setToArray;

});


parcelRegister("4QwsC", function(module, exports) {

var $eY9kY = parcelRequire("eY9kY");
/** Used to compose bitmasks for value comparisons. */ var $387532c45a90e6ad$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $387532c45a90e6ad$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $387532c45a90e6ad$var$hasOwnProperty = $387532c45a90e6ad$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $387532c45a90e6ad$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $387532c45a90e6ad$var$COMPARE_PARTIAL_FLAG, objProps = $eY9kY(object), objLength = objProps.length, othProps = $eY9kY(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $387532c45a90e6ad$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $387532c45a90e6ad$var$equalObjects;

});
parcelRegister("eY9kY", function(module, exports) {

var $6PHTc = parcelRequire("6PHTc");

var $fxvpG = parcelRequire("fxvpG");

var $gAbtd = parcelRequire("gAbtd");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $ae5de97ee4320e86$var$getAllKeys(object) {
    return $6PHTc(object, $gAbtd, $fxvpG);
}
module.exports = $ae5de97ee4320e86$var$getAllKeys;

});
parcelRegister("6PHTc", function(module, exports) {

var $b9jxk = parcelRequire("b9jxk");

var $8JAfJ = parcelRequire("8JAfJ");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $4f998d03382eea80$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $8JAfJ(object) ? result : $b9jxk(result, symbolsFunc(object));
}
module.exports = $4f998d03382eea80$var$baseGetAllKeys;

});
parcelRegister("b9jxk", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $81dfb08a65bfdca4$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $81dfb08a65bfdca4$var$arrayPush;

});

parcelRegister("8JAfJ", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $65bea5c1f117c4e5$var$isArray = Array.isArray;
module.exports = $65bea5c1f117c4e5$var$isArray;

});


parcelRegister("fxvpG", function(module, exports) {

var $9feae = parcelRequire("9feae");

var $lIi8P = parcelRequire("lIi8P");
/** Used for built-in method references. */ var $b5024e186283bb1c$var$objectProto = Object.prototype;
/** Built-in value references. */ var $b5024e186283bb1c$var$propertyIsEnumerable = $b5024e186283bb1c$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b5024e186283bb1c$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $b5024e186283bb1c$var$getSymbols = !$b5024e186283bb1c$var$nativeGetSymbols ? $lIi8P : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $9feae($b5024e186283bb1c$var$nativeGetSymbols(object), function(symbol) {
        return $b5024e186283bb1c$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $b5024e186283bb1c$var$getSymbols;

});
parcelRegister("9feae", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6bb080755c436aa0$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6bb080755c436aa0$var$arrayFilter;

});

parcelRegister("lIi8P", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $fcebc78f1ef1bbbc$var$stubArray() {
    return [];
}
module.exports = $fcebc78f1ef1bbbc$var$stubArray;

});


parcelRegister("gAbtd", function(module, exports) {

var $2wgOY = parcelRequire("2wgOY");

var $edK4x = parcelRequire("edK4x");

var $lAT3M = parcelRequire("lAT3M");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $c128e7e7acefe641$var$keys(object) {
    return $lAT3M(object) ? $2wgOY(object) : $edK4x(object);
}
module.exports = $c128e7e7acefe641$var$keys;

});
parcelRegister("2wgOY", function(module, exports) {

var $elnWC = parcelRequire("elnWC");

var $7cx1v = parcelRequire("7cx1v");

var $8JAfJ = parcelRequire("8JAfJ");

var $5x5qJ = parcelRequire("5x5qJ");

var $zsAV5 = parcelRequire("zsAV5");

var $35pob = parcelRequire("35pob");
/** Used for built-in method references. */ var $1d5b9e4634f595e9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1d5b9e4634f595e9$var$hasOwnProperty = $1d5b9e4634f595e9$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1d5b9e4634f595e9$var$arrayLikeKeys(value, inherited) {
    var isArr = $8JAfJ(value), isArg = !isArr && $7cx1v(value), isBuff = !isArr && !isArg && $5x5qJ(value), isType = !isArr && !isArg && !isBuff && $35pob(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $elnWC(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1d5b9e4634f595e9$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $zsAV5(key, length)))) result.push(key);
    return result;
}
module.exports = $1d5b9e4634f595e9$var$arrayLikeKeys;

});
parcelRegister("elnWC", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $a71599bf76e581c9$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $a71599bf76e581c9$var$baseTimes;

});

parcelRegister("7cx1v", function(module, exports) {

var $8uXVq = parcelRequire("8uXVq");

var $4Du0J = parcelRequire("4Du0J");
/** Used for built-in method references. */ var $53e34520237c2d00$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $53e34520237c2d00$var$hasOwnProperty = $53e34520237c2d00$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $53e34520237c2d00$var$propertyIsEnumerable = $53e34520237c2d00$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $53e34520237c2d00$var$isArguments = $8uXVq(function() {
    return arguments;
}()) ? $8uXVq : function(value) {
    return $4Du0J(value) && $53e34520237c2d00$var$hasOwnProperty.call(value, 'callee') && !$53e34520237c2d00$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $53e34520237c2d00$var$isArguments;

});
parcelRegister("8uXVq", function(module, exports) {

var $lqs1Q = parcelRequire("lqs1Q");

var $4Du0J = parcelRequire("4Du0J");
/** `Object#toString` result references. */ var $62ff9bfe9ad1893e$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $62ff9bfe9ad1893e$var$baseIsArguments(value) {
    return $4Du0J(value) && $lqs1Q(value) == $62ff9bfe9ad1893e$var$argsTag;
}
module.exports = $62ff9bfe9ad1893e$var$baseIsArguments;

});
parcelRegister("4Du0J", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $3602157961d0d88b$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $3602157961d0d88b$var$isObjectLike;

});



parcelRegister("5x5qJ", function(module, exports) {

var $959cr = parcelRequire("959cr");

var $k9AXe = parcelRequire("k9AXe");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $959cr.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $k9AXe;
module.exports = isBuffer;

});
parcelRegister("k9AXe", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eac15048d2725a56$var$stubFalse() {
    return false;
}
module.exports = $eac15048d2725a56$var$stubFalse;

});


parcelRegister("zsAV5", function(module, exports) {
/** Used as references for various `Number` constants. */ var $06a97344487e2e98$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $06a97344487e2e98$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $06a97344487e2e98$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $06a97344487e2e98$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $06a97344487e2e98$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $06a97344487e2e98$var$isIndex;

});

parcelRegister("35pob", function(module, exports) {

var $cu61i = parcelRequire("cu61i");

var $lGuK9 = parcelRequire("lGuK9");

var $jOztm = parcelRequire("jOztm");
/* Node.js helper references. */ var $23f588781384a879$var$nodeIsTypedArray = $jOztm && $jOztm.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $23f588781384a879$var$isTypedArray = $23f588781384a879$var$nodeIsTypedArray ? $lGuK9($23f588781384a879$var$nodeIsTypedArray) : $cu61i;
module.exports = $23f588781384a879$var$isTypedArray;

});
parcelRegister("cu61i", function(module, exports) {

var $lqs1Q = parcelRequire("lqs1Q");

var $1gDO9 = parcelRequire("1gDO9");

var $4Du0J = parcelRequire("4Du0J");
/** `Object#toString` result references. */ var $916cf4d2ed8f0463$var$argsTag = '[object Arguments]', $916cf4d2ed8f0463$var$arrayTag = '[object Array]', $916cf4d2ed8f0463$var$boolTag = '[object Boolean]', $916cf4d2ed8f0463$var$dateTag = '[object Date]', $916cf4d2ed8f0463$var$errorTag = '[object Error]', $916cf4d2ed8f0463$var$funcTag = '[object Function]', $916cf4d2ed8f0463$var$mapTag = '[object Map]', $916cf4d2ed8f0463$var$numberTag = '[object Number]', $916cf4d2ed8f0463$var$objectTag = '[object Object]', $916cf4d2ed8f0463$var$regexpTag = '[object RegExp]', $916cf4d2ed8f0463$var$setTag = '[object Set]', $916cf4d2ed8f0463$var$stringTag = '[object String]', $916cf4d2ed8f0463$var$weakMapTag = '[object WeakMap]';
var $916cf4d2ed8f0463$var$arrayBufferTag = '[object ArrayBuffer]', $916cf4d2ed8f0463$var$dataViewTag = '[object DataView]', $916cf4d2ed8f0463$var$float32Tag = '[object Float32Array]', $916cf4d2ed8f0463$var$float64Tag = '[object Float64Array]', $916cf4d2ed8f0463$var$int8Tag = '[object Int8Array]', $916cf4d2ed8f0463$var$int16Tag = '[object Int16Array]', $916cf4d2ed8f0463$var$int32Tag = '[object Int32Array]', $916cf4d2ed8f0463$var$uint8Tag = '[object Uint8Array]', $916cf4d2ed8f0463$var$uint8ClampedTag = '[object Uint8ClampedArray]', $916cf4d2ed8f0463$var$uint16Tag = '[object Uint16Array]', $916cf4d2ed8f0463$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $916cf4d2ed8f0463$var$typedArrayTags = {};
$916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$float32Tag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$float64Tag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$int8Tag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$int16Tag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$int32Tag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$uint8Tag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$uint8ClampedTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$uint16Tag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$uint32Tag] = true;
$916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$argsTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$arrayTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$arrayBufferTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$boolTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$dataViewTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$dateTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$errorTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$funcTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$mapTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$numberTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$objectTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$regexpTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$setTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$stringTag] = $916cf4d2ed8f0463$var$typedArrayTags[$916cf4d2ed8f0463$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $916cf4d2ed8f0463$var$baseIsTypedArray(value) {
    return $4Du0J(value) && $1gDO9(value.length) && !!$916cf4d2ed8f0463$var$typedArrayTags[$lqs1Q(value)];
}
module.exports = $916cf4d2ed8f0463$var$baseIsTypedArray;

});
parcelRegister("1gDO9", function(module, exports) {
/** Used as references for various `Number` constants. */ var $0ec62a15da5c224c$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $0ec62a15da5c224c$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $0ec62a15da5c224c$var$MAX_SAFE_INTEGER;
}
module.exports = $0ec62a15da5c224c$var$isLength;

});


parcelRegister("lGuK9", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $fc955e3bb118b577$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $fc955e3bb118b577$var$baseUnary;

});

parcelRegister("jOztm", function(module, exports) {

var $gYXEb = parcelRequire("gYXEb");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $gYXEb.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("edK4x", function(module, exports) {

var $53WIH = parcelRequire("53WIH");

var $kYf4L = parcelRequire("kYf4L");
/** Used for built-in method references. */ var $a5a604961169e15b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a5a604961169e15b$var$hasOwnProperty = $a5a604961169e15b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $a5a604961169e15b$var$baseKeys(object) {
    if (!$53WIH(object)) return $kYf4L(object);
    var result = [];
    for(var key in Object(object))if ($a5a604961169e15b$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $a5a604961169e15b$var$baseKeys;

});
parcelRegister("53WIH", function(module, exports) {
/** Used for built-in method references. */ var $3afac824cdf7e1e5$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $3afac824cdf7e1e5$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $3afac824cdf7e1e5$var$objectProto;
    return value === proto;
}
module.exports = $3afac824cdf7e1e5$var$isPrototype;

});

parcelRegister("kYf4L", function(module, exports) {

var $8YKRe = parcelRequire("8YKRe");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f4451afe31209217$var$nativeKeys = $8YKRe(Object.keys, Object);
module.exports = $f4451afe31209217$var$nativeKeys;

});
parcelRegister("8YKRe", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $68984646044ca3dd$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $68984646044ca3dd$var$overArg;

});



parcelRegister("lAT3M", function(module, exports) {

var $jln1g = parcelRequire("jln1g");

var $1gDO9 = parcelRequire("1gDO9");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $040e9348798f0ccd$var$isArrayLike(value) {
    return value != null && $1gDO9(value.length) && !$jln1g(value);
}
module.exports = $040e9348798f0ccd$var$isArrayLike;

});




parcelRegister("6p9FM", function(module, exports) {

var $et9SP = parcelRequire("et9SP");

var $5JlQS = parcelRequire("5JlQS");

var $dtdmD = parcelRequire("dtdmD");

var $g4JNb = parcelRequire("g4JNb");

var $5yw8F = parcelRequire("5yw8F");

var $lqs1Q = parcelRequire("lqs1Q");

var $9wI4x = parcelRequire("9wI4x");
/** `Object#toString` result references. */ var $4a9c94b6a8c3a17f$var$mapTag = '[object Map]', $4a9c94b6a8c3a17f$var$objectTag = '[object Object]', $4a9c94b6a8c3a17f$var$promiseTag = '[object Promise]', $4a9c94b6a8c3a17f$var$setTag = '[object Set]', $4a9c94b6a8c3a17f$var$weakMapTag = '[object WeakMap]';
var $4a9c94b6a8c3a17f$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $4a9c94b6a8c3a17f$var$dataViewCtorString = $9wI4x($et9SP), $4a9c94b6a8c3a17f$var$mapCtorString = $9wI4x($5JlQS), $4a9c94b6a8c3a17f$var$promiseCtorString = $9wI4x($dtdmD), $4a9c94b6a8c3a17f$var$setCtorString = $9wI4x($g4JNb), $4a9c94b6a8c3a17f$var$weakMapCtorString = $9wI4x($5yw8F);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $4a9c94b6a8c3a17f$var$getTag = $lqs1Q;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($et9SP && $4a9c94b6a8c3a17f$var$getTag(new $et9SP(new ArrayBuffer(1))) != $4a9c94b6a8c3a17f$var$dataViewTag || $5JlQS && $4a9c94b6a8c3a17f$var$getTag(new $5JlQS) != $4a9c94b6a8c3a17f$var$mapTag || $dtdmD && $4a9c94b6a8c3a17f$var$getTag($dtdmD.resolve()) != $4a9c94b6a8c3a17f$var$promiseTag || $g4JNb && $4a9c94b6a8c3a17f$var$getTag(new $g4JNb) != $4a9c94b6a8c3a17f$var$setTag || $5yw8F && $4a9c94b6a8c3a17f$var$getTag(new $5yw8F) != $4a9c94b6a8c3a17f$var$weakMapTag) $4a9c94b6a8c3a17f$var$getTag = function(value) {
    var result = $lqs1Q(value), Ctor = result == $4a9c94b6a8c3a17f$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $9wI4x(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $4a9c94b6a8c3a17f$var$dataViewCtorString:
            return $4a9c94b6a8c3a17f$var$dataViewTag;
        case $4a9c94b6a8c3a17f$var$mapCtorString:
            return $4a9c94b6a8c3a17f$var$mapTag;
        case $4a9c94b6a8c3a17f$var$promiseCtorString:
            return $4a9c94b6a8c3a17f$var$promiseTag;
        case $4a9c94b6a8c3a17f$var$setCtorString:
            return $4a9c94b6a8c3a17f$var$setTag;
        case $4a9c94b6a8c3a17f$var$weakMapCtorString:
            return $4a9c94b6a8c3a17f$var$weakMapTag;
    }
    return result;
};
module.exports = $4a9c94b6a8c3a17f$var$getTag;

});
parcelRegister("et9SP", function(module, exports) {

var $dCkw7 = parcelRequire("dCkw7");

var $959cr = parcelRequire("959cr");
/* Built-in method references that are verified to be native. */ var $a88b70be79a23921$var$DataView = $dCkw7($959cr, 'DataView');
module.exports = $a88b70be79a23921$var$DataView;

});

parcelRegister("dtdmD", function(module, exports) {

var $dCkw7 = parcelRequire("dCkw7");

var $959cr = parcelRequire("959cr");
/* Built-in method references that are verified to be native. */ var $9ce859a057814d2d$var$Promise = $dCkw7($959cr, 'Promise');
module.exports = $9ce859a057814d2d$var$Promise;

});

parcelRegister("g4JNb", function(module, exports) {

var $dCkw7 = parcelRequire("dCkw7");

var $959cr = parcelRequire("959cr");
/* Built-in method references that are verified to be native. */ var $bb408a79d143b360$var$Set = $dCkw7($959cr, 'Set');
module.exports = $bb408a79d143b360$var$Set;

});

parcelRegister("5yw8F", function(module, exports) {

var $dCkw7 = parcelRequire("dCkw7");

var $959cr = parcelRequire("959cr");
/* Built-in method references that are verified to be native. */ var $40b90ecf2cd3b7bb$var$WeakMap = $dCkw7($959cr, 'WeakMap');
module.exports = $40b90ecf2cd3b7bb$var$WeakMap;

});





parcelRegister("kh1ul", function(module, exports) {

var $edK4x = parcelRequire("edK4x");

var $6p9FM = parcelRequire("6p9FM");

var $7cx1v = parcelRequire("7cx1v");

var $8JAfJ = parcelRequire("8JAfJ");

var $lAT3M = parcelRequire("lAT3M");

var $5x5qJ = parcelRequire("5x5qJ");

var $53WIH = parcelRequire("53WIH");

var $35pob = parcelRequire("35pob");
/** `Object#toString` result references. */ var $ec268cbbff36533e$var$mapTag = '[object Map]', $ec268cbbff36533e$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $ec268cbbff36533e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ec268cbbff36533e$var$hasOwnProperty = $ec268cbbff36533e$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $ec268cbbff36533e$var$isEmpty(value) {
    if (value == null) return true;
    if ($lAT3M(value) && ($8JAfJ(value) || typeof value == 'string' || typeof value.splice == 'function' || $5x5qJ(value) || $35pob(value) || $7cx1v(value))) return !value.length;
    var tag = $6p9FM(value);
    if (tag == $ec268cbbff36533e$var$mapTag || tag == $ec268cbbff36533e$var$setTag) return !value.size;
    if ($53WIH(value)) return !$edK4x(value).length;
    for(var key in value){
        if ($ec268cbbff36533e$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $ec268cbbff36533e$var$isEmpty;

});

parcelRegister("cMxso", function(module, exports) {

$parcel$export(module.exports, "UIPassthroughEvent", function () { return $94e3eb96cdaa82c9$export$4e9a272093dce90f; });
parcelRequire("dV0Ap");
var $94e3eb96cdaa82c9$export$4e9a272093dce90f;
(function(UIPassthroughEvent) {
    UIPassthroughEvent["PinAnswerToLiveboard"] = "addVizToPinboard";
    UIPassthroughEvent["SaveAnswer"] = "saveAnswer";
    UIPassthroughEvent["GetDiscoverabilityStatus"] = "getDiscoverabilityStatus";
    UIPassthroughEvent["GetAvailableUIPassthroughs"] = "getAvailableUiPassthroughs";
    UIPassthroughEvent["GetAnswerConfig"] = "getAnswerPageConfig";
    UIPassthroughEvent["GetLiveboardConfig"] = "getPinboardPageConfig";
    UIPassthroughEvent["GetUnsavedAnswerTML"] = "getUnsavedAnswerTML";
    UIPassthroughEvent["UpdateFilters"] = "updateFilters";
    UIPassthroughEvent["Drilldown"] = "drillDown";
    UIPassthroughEvent["GetAnswerSession"] = "getAnswerSession";
    UIPassthroughEvent["GetFilters"] = "getFilters";
    UIPassthroughEvent["GetIframeUrl"] = "getIframeUrl";
    UIPassthroughEvent["GetParameters"] = "getParameters";
    UIPassthroughEvent["GetTML"] = "getTML";
    UIPassthroughEvent["GetTabs"] = "getTabs";
    UIPassthroughEvent["GetExportRequestForCurrentPinboard"] = "getExportRequestForCurrentPinboard";
})($94e3eb96cdaa82c9$export$4e9a272093dce90f || ($94e3eb96cdaa82c9$export$4e9a272093dce90f = {}));

});

parcelRegister("d4gBz", function(module, exports) {

$parcel$export(module.exports, "getAuthenticationToken", function () { return $9838877f9ddec8ba$export$9e6d13f84f356d3; });
$parcel$export(module.exports, "resetCachedAuthToken", function () { return $9838877f9ddec8ba$export$51be2ddd1bde4897; });

var $h7cYZ = parcelRequire("h7cYZ");

var $7aJfj = parcelRequire("7aJfj");

var $bdEoU = parcelRequire("bdEoU");

var $kCAID = parcelRequire("kCAID");
const $9838877f9ddec8ba$var$cacheAuthTokenKey = 'cachedAuthToken';
const $9838877f9ddec8ba$var$getCacheAuthToken = ()=>(0, $7aJfj.getValueFromWindow)($9838877f9ddec8ba$var$cacheAuthTokenKey);
const $9838877f9ddec8ba$var$storeAuthTokenInCache = (token)=>{
    (0, $7aJfj.storeValueInWindow)($9838877f9ddec8ba$var$cacheAuthTokenKey, token);
};
async function $9838877f9ddec8ba$export$9e6d13f84f356d3(embedConfig, skipvalidation = false) {
    const cachedAuthToken = $9838877f9ddec8ba$var$getCacheAuthToken();
    // Since we don't have token validation enabled , we cannot tell if the
    // cached token is valid or not. So we will always fetch a new token.
    if (cachedAuthToken && !embedConfig.disableTokenVerification && !skipvalidation) {
        let isCachedTokenStillValid;
        try {
            isCachedTokenStillValid = await $9838877f9ddec8ba$export$c10be818bb4caf75(embedConfig, cachedAuthToken, true);
        } catch  {
            isCachedTokenStillValid = false;
        }
        if (isCachedTokenStillValid) return cachedAuthToken;
    }
    const { authEndpoint: authEndpoint, getAuthToken: getAuthToken } = embedConfig;
    let authToken = null;
    if (getAuthToken) authToken = await getAuthToken();
    else {
        const response = await (0, $bdEoU.fetchAuthTokenService)(authEndpoint);
        authToken = await response.text();
    }
    try {
        // this will throw error if the token is not valid
        await $9838877f9ddec8ba$export$c10be818bb4caf75(embedConfig, authToken);
    } catch (e) {
        (0, $kCAID.logger).error(`${(0, $h7cYZ.ERROR_MESSAGE).INVALID_TOKEN_ERROR} Error : ${e.message}`);
        throw e;
    }
    $9838877f9ddec8ba$var$storeAuthTokenInCache(authToken);
    return authToken;
}
const $9838877f9ddec8ba$export$c10be818bb4caf75 = async (embedConfig, authToken, suppressAlert)=>{
    // even if token verification is disabled, we will still validate
    // that the token is a string before proceeding.
    if (typeof authToken !== 'string') {
        const errorMessage = (0, $7aJfj.formatTemplate)((0, $h7cYZ.ERROR_MESSAGE).INVALID_TOKEN_TYPE_ERROR, {
            invalidType: typeof authToken
        });
        (0, $kCAID.logger).error(errorMessage);
        throw new Error(errorMessage);
    }
    const cachedAuthToken = $9838877f9ddec8ba$var$getCacheAuthToken();
    if (embedConfig.disableTokenVerification) {
        (0, $kCAID.logger).info('Token verification is disabled. Assuming token is valid.');
        return true;
    }
    try {
        const isTokenValid = await (0, $bdEoU.verifyTokenService)(embedConfig.thoughtSpotHost, authToken);
        if (isTokenValid) return true;
    } catch  {
        return false;
    }
    if (cachedAuthToken && cachedAuthToken === authToken) {
        if (!embedConfig.suppressErrorAlerts && !suppressAlert) alert((0, $h7cYZ.ERROR_MESSAGE).DUPLICATE_TOKEN_ERR);
        throw new Error((0, $h7cYZ.ERROR_MESSAGE).DUPLICATE_TOKEN_ERR);
    } else throw new Error((0, $h7cYZ.ERROR_MESSAGE).INVALID_TOKEN_ERROR);
};
const $9838877f9ddec8ba$export$51be2ddd1bde4897 = ()=>{
    $9838877f9ddec8ba$var$storeAuthTokenInCache(null);
};

});
parcelRegister("bdEoU", function(module, exports) {

$parcel$export(module.exports, "EndPoints", function () { return $82b03f5d3f4c8bf5$export$ce30d4c1fa70e50a; });
$parcel$export(module.exports, "verifyTokenService", function () { return $82b03f5d3f4c8bf5$export$27714147fecef7a3; });
$parcel$export(module.exports, "fetchAuthTokenService", function () { return $82b03f5d3f4c8bf5$export$ea2adcdf99bf76bc; });
$parcel$export(module.exports, "fetchAuthService", function () { return $82b03f5d3f4c8bf5$export$eaf5f4038a7f1d34; });
$parcel$export(module.exports, "fetchAuthPostService", function () { return $82b03f5d3f4c8bf5$export$e4c1cc1219a73402; });
$parcel$export(module.exports, "fetchBasicAuthService", function () { return $82b03f5d3f4c8bf5$export$e7c28d8383ef628; });

var $kCAID = parcelRequire("kCAID");
const $82b03f5d3f4c8bf5$export$ce30d4c1fa70e50a = {
    AUTH_VERIFICATION: '/callosum/v1/session/info',
    SESSION_INFO: '/callosum/v1/session/info',
    PREAUTH_INFO: '/prism/preauth/info',
    SAML_LOGIN_TEMPLATE: (targetUrl)=>`/callosum/v1/saml/login?targetURLPath=${targetUrl}`,
    OIDC_LOGIN_TEMPLATE: (targetUrl)=>`/callosum/v1/oidc/login?targetURLPath=${targetUrl}`,
    TOKEN_LOGIN: '/callosum/v1/session/login/token',
    BASIC_LOGIN: '/callosum/v1/session/login',
    LOGOUT: '/callosum/v1/session/logout',
    EXECUTE_TML: '/api/rest/2.0/metadata/tml/import',
    EXPORT_TML: '/api/rest/2.0/metadata/tml/export',
    IS_ACTIVE: '/callosum/v1/session/isactive'
};
/**
 *
 * @param url
 * @param options
 */ function $82b03f5d3f4c8bf5$var$failureLoggedFetch(url, options = {}) {
    return fetch(url, options).then(async (r)=>{
        var _a;
        if (!r.ok && r.type !== 'opaqueredirect' && r.type !== 'opaque') (0, $kCAID.logger).error('Failure', await ((_a = r.text) === null || _a === void 0 ? void 0 : _a.call(r)));
        return r;
    });
}
async function $82b03f5d3f4c8bf5$export$27714147fecef7a3(thoughtSpotHost, authToken) {
    const authVerificationUrl = `${thoughtSpotHost}${$82b03f5d3f4c8bf5$export$ce30d4c1fa70e50a.IS_ACTIVE}`;
    try {
        const res = await fetch(authVerificationUrl, {
            headers: {
                Authorization: `Bearer ${authToken}`,
                'x-requested-by': 'ThoughtSpot'
            },
            credentials: 'omit'
        });
        return res.ok;
    } catch (e) {
        (0, $kCAID.logger).warn(`Token Verification Service failed : ${e.message}`);
    }
    return false;
}
async function $82b03f5d3f4c8bf5$export$ea2adcdf99bf76bc(authEndpoint) {
    return fetch(authEndpoint);
}
async function $82b03f5d3f4c8bf5$export$eaf5f4038a7f1d34(thoughtSpotHost, username, authToken) {
    const fetchUrlParams = username ? `username=${username}&auth_token=${authToken}` : `auth_token=${authToken}`;
    return $82b03f5d3f4c8bf5$var$failureLoggedFetch(`${thoughtSpotHost}${$82b03f5d3f4c8bf5$export$ce30d4c1fa70e50a.TOKEN_LOGIN}?${fetchUrlParams}`, {
        credentials: 'include',
        // We do not want to follow the redirect, as it starts giving a CORS
        // error
        redirect: 'manual'
    });
}
async function $82b03f5d3f4c8bf5$export$e4c1cc1219a73402(thoughtSpotHost, username, authToken) {
    const bodyPrams = username ? `username=${encodeURIComponent(username)}&auth_token=${encodeURIComponent(authToken)}` : `auth_token=${encodeURIComponent(authToken)}`;
    return $82b03f5d3f4c8bf5$var$failureLoggedFetch(`${thoughtSpotHost}${$82b03f5d3f4c8bf5$export$ce30d4c1fa70e50a.TOKEN_LOGIN}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'x-requested-by': 'ThoughtSpot'
        },
        body: bodyPrams,
        credentials: 'include',
        // We do not want to follow the redirect, as it starts giving a CORS
        // error
        redirect: 'manual'
    });
}
async function $82b03f5d3f4c8bf5$export$e7c28d8383ef628(thoughtSpotHost, username, password) {
    return $82b03f5d3f4c8bf5$var$failureLoggedFetch(`${thoughtSpotHost}${$82b03f5d3f4c8bf5$export$ce30d4c1fa70e50a.BASIC_LOGIN}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
            'x-requested-by': 'ThoughtSpot'
        },
        body: `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`,
        credentials: 'include'
    });
}

});


parcelRegister("3q1XH", function(module, exports) {

$parcel$export(module.exports, "AnswerService", function () { return $27d55264d5ee9c14$export$2ccd2bbec058b8ee; });
// import YAML from 'yaml';

var $8NaiO = parcelRequire("8NaiO");

var $7aJfj = parcelRequire("7aJfj");

var $509aq = parcelRequire("509aq");

var $fDYte = parcelRequire("fDYte");

var $1xhX8 = parcelRequire("1xhX8");
var $27d55264d5ee9c14$export$485547b05523629;
(function(OperationType) {
    OperationType["GetChartWithData"] = "GetChartWithData";
    OperationType["GetTableWithHeadlineData"] = "GetTableWithHeadlineData";
})($27d55264d5ee9c14$export$485547b05523629 || ($27d55264d5ee9c14$export$485547b05523629 = {}));
const $27d55264d5ee9c14$export$68317eef4cf08696 = [
    'DATE',
    'DATE_TIME',
    'TIME'
];

class $27d55264d5ee9c14$export$2ccd2bbec058b8ee {
    /**
     * Should not need to be called directly.
     * @param session
     * @param answer
     * @param thoughtSpotHost
     * @param selectedPoints
     */ constructor(session, answer, thoughtSpotHost, selectedPoints){
        this.session = session;
        this.thoughtSpotHost = thoughtSpotHost;
        this.selectedPoints = selectedPoints;
        this.tmlOverride = {};
        this.session = (0, $7aJfj.removeTypename)(session);
        this.answer = answer;
    }
    /**
     * Get the details about the source used in the answer.
     * This can be used to get the list of all columns in the data source for example.
     */ async getSourceDetail() {
        const sourceId = (await this.getAnswer()).sources[0].header.guid;
        return (0, $fDYte.getSourceDetail)(this.thoughtSpotHost, sourceId);
    }
    /**
     * Remove columnIds and return updated answer session.
     * @param columnIds
     * @returns
     */ async removeColumns(columnIds) {
        return this.executeQuery($1xhX8.removeColumns, {
            logicalColumnIds: columnIds
        });
    }
    /**
     * Add columnIds and return updated answer session.
     * @param columnIds
     * @returns
     */ async addColumns(columnIds) {
        return this.executeQuery($1xhX8.addColumns, {
            columns: columnIds.map((colId)=>({
                    logicalColumnId: colId
                }))
        });
    }
    /**
     * Add columns by names and return updated answer session.
     * @param columnNames
     * @returns
     * @example
     * ```js
     * embed.on(EmbedEvent.Data, async (e) => {
     *    const service = await embed.getAnswerService();
     *    await service.addColumnsByName([
     *      "col name 1",
     *      "col name 2"
     *    ]);
     *    console.log(await service.fetchData());
     * });
     * ```
     */ async addColumnsByName(columnNames) {
        const sourceDetail = await this.getSourceDetail();
        const columnGuids = $27d55264d5ee9c14$var$getGuidsFromColumnNames(sourceDetail, columnNames);
        return this.addColumns([
            ...columnGuids
        ]);
    }
    /**
     * Add a filter to the answer.
     * @param columnName
     * @param operator
     * @param values
     * @returns
     */ async addFilter(columnName, operator, values) {
        const sourceDetail = await this.getSourceDetail();
        const columnGuids = $27d55264d5ee9c14$var$getGuidsFromColumnNames(sourceDetail, [
            columnName
        ]);
        return this.executeQuery($1xhX8.addFilter, {
            params: {
                filterContent: [
                    {
                        filterType: operator,
                        value: values.map((v)=>{
                            const [type, prefix] = (0, $7aJfj.getTypeFromValue)(v);
                            return {
                                type: type.toUpperCase(),
                                [`${prefix}Value`]: v
                            };
                        })
                    }
                ],
                filterGroupId: {
                    logicalColumnId: columnGuids.values().next().value
                }
            }
        });
    }
    async updateDisplayMode(displayMode = "TABLE_MODE") {
        return this.executeQuery($1xhX8.updateDisplayMode, {
            displayMode: displayMode
        });
    }
    async getSQLQuery(fetchSQLWithAllColumns = false) {
        if (fetchSQLWithAllColumns) await this.updateDisplayMode("TABLE_MODE");
        const { sql: sql } = await this.executeQuery($1xhX8.getSQLQuery, {});
        return sql;
    }
    /**
     * Fetch data from the answer.
     * @param offset
     * @param size
     * @returns
     */ async fetchData(offset = 0, size = 1000) {
        const { answer: answer } = await this.executeQuery($1xhX8.getAnswerData, {
            deadline: 0,
            dataPaginationParams: {
                isClientPaginated: true,
                offset: offset,
                size: size
            }
        });
        const { columns: columns, data: data } = answer.visualizations.find((viz)=>!!viz.data) || {};
        return {
            columns: columns,
            data: data
        };
    }
    /**
     * Fetch the data for the answer as a CSV blob. This might be
     * quicker for larger data.
     * @param userLocale
     * @param includeInfo Include the CSV header in the output
     * @returns Response
     */ async fetchCSVBlob(userLocale = 'en-us', includeInfo = false) {
        const fetchUrl = this.getFetchCSVBlobUrl(userLocale, includeInfo);
        return (0, $8NaiO.tokenizedFetch)(fetchUrl, {
            credentials: 'include'
        });
    }
    /**
     * Fetch the data for the answer as a PNG blob. This might be
     * quicker for larger data.
     * @param userLocale
     * @param includeInfo
     * @param omitBackground Omit the background in the PNG
     * @param deviceScaleFactor The scale factor for the PNG
     * @return Response
     */ async fetchPNGBlob(userLocale = 'en-us', omitBackground = false, deviceScaleFactor = 2) {
        const fetchUrl = this.getFetchPNGBlobUrl(userLocale, omitBackground, deviceScaleFactor);
        return (0, $8NaiO.tokenizedFetch)(fetchUrl, {
            credentials: 'include'
        });
    }
    /**
     * Just get the internal URL for this answer's data
     * as a CSV blob.
     * @param userLocale
     * @param includeInfo
     * @returns
     */ getFetchCSVBlobUrl(userLocale = 'en-us', includeInfo = false) {
        return `${this.thoughtSpotHost}/prism/download/answer/csv?sessionId=${this.session.sessionId}&genNo=${this.session.genNo}&userLocale=${userLocale}&exportFileName=data&hideCsvHeader=${!includeInfo}`;
    }
    /**
     * Just get the internal URL for this answer's data
     * as a PNG blob.
     * @param userLocale
     * @param omitBackground
     * @param deviceScaleFactor
     */ getFetchPNGBlobUrl(userLocale = 'en-us', omitBackground = false, deviceScaleFactor = 2) {
        return `${this.thoughtSpotHost}/prism/download/answer/png?sessionId=${this.session.sessionId}&deviceScaleFactor=${deviceScaleFactor}&omitBackground=${omitBackground}&genNo=${this.session.genNo}&userLocale=${userLocale}&exportFileName=data`;
    }
    /**
     * Get underlying data given a point and the output column names.
     * In case of a context menu action, the selectedPoints are
     * automatically passed.
     * @param outputColumnNames
     * @param selectedPoints
     * @example
     * ```js
     *  embed.on(EmbedEvent.CustomAction, e => {
     *     const underlying = await e.answerService.getUnderlyingDataForPoint([
     *       'col name 1' // The column should exist in the data source.
     *     ]);
     *     const data = await underlying.fetchData(0, 100);
     *  })
     * ```
     * @version SDK: 1.25.0 | ThoughtSpot: 9.10.0.cl
     */ async getUnderlyingDataForPoint(outputColumnNames, selectedPoints) {
        if (!selectedPoints && !this.selectedPoints) throw new Error('Needs to be triggered in context of a point');
        if (!selectedPoints) selectedPoints = $27d55264d5ee9c14$var$getSelectedPointsForUnderlyingDataQuery(this.selectedPoints);
        const sourceDetail = await this.getSourceDetail();
        const ouputColumnGuids = $27d55264d5ee9c14$var$getGuidsFromColumnNames(sourceDetail, outputColumnNames);
        const unAggAnswer = await (0, $509aq.graphqlQuery)({
            query: $1xhX8.getUnaggregatedAnswerSession,
            variables: {
                session: this.session,
                columns: selectedPoints
            },
            thoughtSpotHost: this.thoughtSpotHost
        });
        const unaggAnswerSession = new $27d55264d5ee9c14$export$2ccd2bbec058b8ee(unAggAnswer.id, unAggAnswer.answer, this.thoughtSpotHost);
        const currentColumns = new Set(unAggAnswer.answer.visualizations[0].columns.map((c)=>c.column.referencedColumns[0].guid));
        const columnsToAdd = [
            ...ouputColumnGuids
        ].filter((col)=>!currentColumns.has(col));
        if (columnsToAdd.length) await unaggAnswerSession.addColumns(columnsToAdd);
        const columnsToRemove = [
            ...currentColumns
        ].filter((col)=>!ouputColumnGuids.has(col));
        if (columnsToRemove.length) await unaggAnswerSession.removeColumns(columnsToRemove);
        return unaggAnswerSession;
    }
    /**
     * Execute a custom graphql query in the context of the answer.
     * @param query graphql query
     * @param variables graphql variables
     * @returns
     */ async executeQuery(query, variables) {
        const data = await (0, $509aq.graphqlQuery)({
            query: query,
            variables: {
                session: this.session,
                ...variables
            },
            thoughtSpotHost: this.thoughtSpotHost,
            isCompositeQuery: false
        });
        this.session = (0, $7aJfj.deepMerge)(this.session, (data === null || data === void 0 ? void 0 : data.id) || {});
        return data;
    }
    /**
     * Get the internal session details for the answer.
     * @returns
     */ getSession() {
        return this.session;
    }
    async getAnswer() {
        if (this.answer) return this.answer;
        this.answer = this.executeQuery($1xhX8.getAnswer, {}).then((data)=>data === null || data === void 0 ? void 0 : data.answer);
        return this.answer;
    }
    async getTML() {
        const { object: object } = await this.executeQuery($1xhX8.getAnswerTML, {});
        const edoc = object[0].edoc;
        const YAML = await (parcelRequire("e1Opj"));
        const parsedDoc = YAML.parse(edoc);
        return {
            answer: {
                ...parsedDoc.answer,
                ...this.tmlOverride
            }
        };
    }
    async addDisplayedVizToLiveboard(liveboardId) {
        const { displayMode: displayMode, visualizations: visualizations } = await this.getAnswer();
        const viz = $27d55264d5ee9c14$var$getDisplayedViz(visualizations, displayMode);
        return this.executeQuery($1xhX8.addVizToLiveboard, {
            liveboardId: liveboardId,
            vizId: viz.id
        });
    }
    setTMLOverride(override) {
        this.tmlOverride = override;
    }
}
/**
 *
 * @param sourceDetail
 * @param colNames
 */ function $27d55264d5ee9c14$var$getGuidsFromColumnNames(sourceDetail, colNames) {
    const cols = sourceDetail.columns.reduce((colSet, col)=>{
        colSet[col.name.toLowerCase()] = col;
        return colSet;
    }, {});
    return new Set(colNames.map((colName)=>{
        const col = cols[colName.toLowerCase()];
        return col.id;
    }));
}
/**
 *
 * @param selectedPoints
 */ function $27d55264d5ee9c14$var$getSelectedPointsForUnderlyingDataQuery(selectedPoints) {
    const underlyingDataPoint = [];
    /**
     *
     * @param colVal
     */ function addPointFromColVal(colVal) {
        var _a;
        const dataType = colVal.column.dataType;
        const id = colVal.column.id;
        let dataValue;
        if ($27d55264d5ee9c14$export$68317eef4cf08696.includes(dataType)) {
            if (Number.isFinite(colVal.value)) dataValue = [
                {
                    epochRange: {
                        startEpoch: colVal.value
                    }
                }
            ];
            else if ((_a = colVal.value) === null || _a === void 0 ? void 0 : _a.v) dataValue = [
                {
                    epochRange: {
                        startEpoch: colVal.value.v.s,
                        endEpoch: colVal.value.v.e
                    }
                }
            ];
        } else dataValue = [
            {
                value: colVal.value
            }
        ];
        underlyingDataPoint.push({
            columnId: colVal.column.id,
            dataValue: dataValue
        });
    }
    selectedPoints.forEach((p)=>{
        p.selectedAttributes.forEach(addPointFromColVal);
    });
    return underlyingDataPoint;
}
/**
 *
 * @param visualizations
 * @param displayMode
 */ function $27d55264d5ee9c14$var$getDisplayedViz(visualizations, displayMode) {
    if (displayMode === 'CHART_MODE') return visualizations.find((viz)=>viz.__typename === 'ChartViz');
    return visualizations.find((viz)=>viz.__typename === 'TableViz');
}

});
parcelRegister("8NaiO", function(module, exports) {

$parcel$export(module.exports, "tokenizedFetch", function () { return $666ae43417e2ed1f$export$50a1b9455bb50efd; });

var $d4gBz = parcelRequire("d4gBz");

var $a6640 = parcelRequire("a6640");

var $dV0Ap = parcelRequire("dV0Ap");
const $666ae43417e2ed1f$export$50a1b9455bb50efd = async (input, init)=>{
    const embedConfig = (0, $a6640.getEmbedConfig)();
    if (embedConfig.authType !== (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless) return fetch(input, {
        // ensure cookies are included for the non cookie-less api calls.
        credentials: 'include',
        ...init
    });
    const req = new Request(input, init);
    const authToken = await (0, $d4gBz.getAuthenticationToken)(embedConfig);
    if (authToken) req.headers.append('Authorization', `Bearer ${authToken}`);
    return fetch(req);
};

});
parcelRegister("a6640", function(module, exports) {

$parcel$export(module.exports, "getEmbedConfig", function () { return $01e5a9fbe56124bc$export$e4c8bb4ac3697689; });
$parcel$export(module.exports, "setEmbedConfig", function () { return $01e5a9fbe56124bc$export$acaa1bbebb0868bd; });

var $7aJfj = parcelRequire("7aJfj");
const $01e5a9fbe56124bc$var$configKey = 'embedConfig';
const $01e5a9fbe56124bc$export$e4c8bb4ac3697689 = ()=>(0, $7aJfj.getValueFromWindow)($01e5a9fbe56124bc$var$configKey) || {};
const $01e5a9fbe56124bc$export$acaa1bbebb0868bd = (newConfig)=>{
    (0, $7aJfj.storeValueInWindow)($01e5a9fbe56124bc$var$configKey, newConfig);
    return (0, $7aJfj.getValueFromWindow)($01e5a9fbe56124bc$var$configKey);
};

});


parcelRegister("509aq", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", function () { return $3a44103f32e16f86$export$74eb8d79ae3e02b5; });

var $8NaiO = parcelRequire("8NaiO");

var $7aJfj = parcelRequire("7aJfj");
async function $3a44103f32e16f86$export$74eb8d79ae3e02b5({ query: query, variables: variables, thoughtSpotHost: thoughtSpotHost, isCompositeQuery: isCompositeQuery = false }) {
    const operationName = (0, $7aJfj.getOperationNameFromQuery)(query);
    try {
        const response = await (0, $8NaiO.tokenizedFetch)(`${thoughtSpotHost}/prism/?op=${operationName}`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json;charset=UTF-8',
                'x-requested-by': 'ThoughtSpot',
                accept: '*/*',
                'accept-language': 'en-us'
            },
            body: JSON.stringify({
                operationName: operationName,
                query: query,
                variables: variables
            }),
            credentials: 'include'
        });
        const result = await response.json();
        const dataValues = Object.values(result.data);
        return isCompositeQuery ? result.data : dataValues[0];
    } catch (error) {
        return error;
    }
}

});

parcelRegister("fDYte", function(module, exports) {

$parcel$export(module.exports, "getSourceDetail", function () { return $b63967b7f1a148da$export$8680ad650bb27822; });

var $509aq = parcelRequire("509aq");
const $b63967b7f1a148da$export$b01679a26532c2f7 = `
    query GetSourceDetail($ids: [GUID!]!) {
        getSourceDetailById(ids: $ids, type: LOGICAL_TABLE) {
        id
        name
        description
        authorName
        authorDisplayName
        isExternal
        type
        created
        modified
        columns {
            id
            name
            author
            authorDisplayName
            description
            dataType
            type
            modified
            ownerName
            owner
            dataRecency
            sources {
            tableId
            tableName
            columnId
            columnName
            __typename
            }
            synonyms
            cohortAnswerId
            __typename
        }
        relationships
        destinationRelationships
        dataSourceId
        __typename
        }
    }  
`;
const $b63967b7f1a148da$var$sourceDetailCache = new Map();
async function $b63967b7f1a148da$export$8680ad650bb27822(thoughtSpotHost, sourceId) {
    if ($b63967b7f1a148da$var$sourceDetailCache.get(sourceId)) return $b63967b7f1a148da$var$sourceDetailCache.get(sourceId);
    const details = await (0, $509aq.graphqlQuery)({
        query: $b63967b7f1a148da$export$b01679a26532c2f7,
        variables: {
            ids: [
                sourceId
            ]
        },
        thoughtSpotHost: thoughtSpotHost
    });
    const souceDetails = details[0];
    if (souceDetails) $b63967b7f1a148da$var$sourceDetailCache.set(sourceId, souceDetails);
    return souceDetails;
}

});

parcelRegister("1xhX8", function(module, exports) {

$parcel$export(module.exports, "getUnaggregatedAnswerSession", function () { return $11e6cc8ada99f4ec$export$fc9678a56136df5b; });
$parcel$export(module.exports, "removeColumns", function () { return $11e6cc8ada99f4ec$export$40fea0e3b9aba2e5; });
$parcel$export(module.exports, "addColumns", function () { return $11e6cc8ada99f4ec$export$bdd30748c1336166; });
$parcel$export(module.exports, "addFilter", function () { return $11e6cc8ada99f4ec$export$ae939118842f3d6d; });
$parcel$export(module.exports, "getAnswer", function () { return $11e6cc8ada99f4ec$export$8f29ccfa759f3dbf; });
$parcel$export(module.exports, "getAnswerData", function () { return $11e6cc8ada99f4ec$export$e9d187d8c1ef2519; });
$parcel$export(module.exports, "addVizToLiveboard", function () { return $11e6cc8ada99f4ec$export$592e58e6ec9b43b; });
$parcel$export(module.exports, "getSQLQuery", function () { return $11e6cc8ada99f4ec$export$3b9b5fd0a4aa737c; });
$parcel$export(module.exports, "updateDisplayMode", function () { return $11e6cc8ada99f4ec$export$21030d247278ac02; });
$parcel$export(module.exports, "getAnswerTML", function () { return $11e6cc8ada99f4ec$export$2f97fcf0f7c67247; });
const $11e6cc8ada99f4ec$var$bachSessionId = `
id {
    sessionId
    genNo
    acSession {
        sessionId
        genNo
    }
}
`;
const $11e6cc8ada99f4ec$export$fc9678a56136df5b = `
mutation GetUnAggregatedAnswerSession($session: BachSessionIdInput!, $columns: [UserPointSelectionInput!]!) {
    Answer__getUnaggregatedAnswer(session: $session, columns: $columns) {
        ${$11e6cc8ada99f4ec$var$bachSessionId}
        answer {
            visualizations {
                ... on TableViz {
                    columns {
                        column {
                            id
                            name
                            referencedColumns {
                                guid
                                displayName
                            }
                        }
                    }
                }
            }
        }
    }
}  
`;
const $11e6cc8ada99f4ec$export$40fea0e3b9aba2e5 = `
mutation RemoveColumns($session: BachSessionIdInput!, $logicalColumnIds: [GUID!], $columnIds: [GUID!]) {
    Answer__removeColumns(
        session: $session
        logicalColumnIds: $logicalColumnIds
        columnIds: $columnIds
        ) {
            ${$11e6cc8ada99f4ec$var$bachSessionId}
    }
}
    `;
const $11e6cc8ada99f4ec$export$bdd30748c1336166 = `
    mutation AddColumns($session: BachSessionIdInput!, $columns: [AnswerColumnInfo!]!) {
        Answer__addColumn(session: $session, columns: $columns) {
            ${$11e6cc8ada99f4ec$var$bachSessionId}
        }
    }
    `;
const $11e6cc8ada99f4ec$export$ae939118842f3d6d = `
    mutation AddUpdateFilter($session: BachSessionIdInput!, $params: AddUpdateFilterInput!) {
        Answer__addUpdateFilter(session: $session, params: $params) {
            ${$11e6cc8ada99f4ec$var$bachSessionId}
        }
    }
`;
const $11e6cc8ada99f4ec$export$8f29ccfa759f3dbf = `
    query GetAnswer($session: BachSessionIdInput!) {
        getAnswer(session: $session) {
            ${$11e6cc8ada99f4ec$var$bachSessionId}
            answer {
                id
                name
                description
                displayMode
                sources {
                    header {
                        guid
                        displayName
                    }
                }
                filterGroups {
                    columnInfo {
                        name
                        referencedColumns {
                            guid
                            displayName
                        }
                    }
                    filters {
                        filterContent {
                            filterType
                            negate
                            value {
                                key
                            }
                        }
                    }
                }
                metadata {
                    author
                    authorId
                    createdAt
                    isDiscoverable
                    isHidden
                    modifiedAt
                }
                visualizations {
                    ... on TableViz {
                        id
                        columns {
                            column {
                                id
                                name
                                referencedColumns {
                                    guid
                                    displayName
                                }
                            }
                        }
                    }
                    ... on ChartViz {
                        id
                    }
                }
            }
        }
    }

`;
const $11e6cc8ada99f4ec$export$e9d187d8c1ef2519 = `
    query GetTableWithHeadlineData($session: BachSessionIdInput!, $deadline: Int!, $dataPaginationParams: DataPaginationParamsInput!) {
        getAnswer(session: $session) {
            ${$11e6cc8ada99f4ec$var$bachSessionId}
            answer {
                id
                visualizations {
                    id
                    ... on TableViz {
                        columns {
                            column {
                                id
                                name
                                type
                                aggregationType
                                dataType
                            }
                        }
                        data(deadline: $deadline, pagination: $dataPaginationParams)
                    }          
                }
            }
        }
    }
`;
const $11e6cc8ada99f4ec$export$592e58e6ec9b43b = `
    mutation AddVizToLiveboard(liveboardId: GUID!, session: BachSessionIdInput!, tabId: GUID, vizId: GUID!) {
        Answer__addVizToPinboard(
            pinboardId: liveboardId

            session: $session

            tabId: $tabId

            vizId: $vizId
        ) {
            ${$11e6cc8ada99f4ec$var$bachSessionId}
        }
    }
`;
const $11e6cc8ada99f4ec$export$3b9b5fd0a4aa737c = `
    mutation GetSQLQuery($session: BachSessionIdInput!) {
        Answer__getQuery(session: $session) {
            sql
        }
    }
`;
const $11e6cc8ada99f4ec$export$21030d247278ac02 = `
   mutation UpdateDisplayMode(
    $session: BachSessionIdInput!
    $displayMode: DisplayMode
) {
    Answer__updateProperties(session: $session, displayMode: $displayMode) {
        id {
            sessionId
            genNo
            acSession {
                sessionId
                genNo
            }
        }
        answer {
            id
            displayMode
            suggestedDisplayMode
        }
    }
}
`;
const $11e6cc8ada99f4ec$export$2f97fcf0f7c67247 = `
mutation GetUnsavedAnswerTML($session: BachSessionIdInput!, $exportDependencies: Boolean, $formatType:  EDocFormatType, $exportPermissions: Boolean, $exportFqn: Boolean) {
  UnsavedAnswer_getTML(
    session: $session
    exportDependencies: $exportDependencies
    formatType: $formatType
    exportPermissions: $exportPermissions
    exportFqn: $exportFqn
  ) {
    zipFile
    object {
      edoc
      name
      type
      __typename
    }
    __typename
  }
}`;

});

parcelRegister("e1Opj", function(module, exports) {
module.exports = $parcel$import("50t6p").then(()=>parcelRequire('aOyad'));

});


parcelRegister("iPROI", function(module, exports) {

$parcel$export(module.exports, "getCustomActions", function () { return $db66bc5c8a863686$export$d1002d3e50ecda60; });

var $dV0Ap = parcelRequire("dV0Ap");

var $7aJfj = parcelRequire("7aJfj");

var $4F1oH = parcelRequire("4F1oH");

var $h7cYZ = parcelRequire("h7cYZ");

var $kCAID = parcelRequire("kCAID");
/**
 * Configuration for custom action validation rules.
 * Defines allowed positions, metadata IDs, data model IDs, and fields for each target
 * type.
 *
 */ const $db66bc5c8a863686$var$customActionValidationConfig = {
    [(0, $dV0Ap.CustomActionTarget).LIVEBOARD]: {
        positions: [
            (0, $dV0Ap.CustomActionsPosition).PRIMARY,
            (0, $dV0Ap.CustomActionsPosition).MENU
        ],
        allowedMetadataIds: [
            'liveboardIds'
        ],
        allowedDataModelIds: [],
        allowedFields: [
            'name',
            'id',
            'position',
            'target',
            'metadataIds',
            'orgIds',
            'groupIds'
        ]
    },
    [(0, $dV0Ap.CustomActionTarget).VIZ]: {
        positions: [
            (0, $dV0Ap.CustomActionsPosition).MENU,
            (0, $dV0Ap.CustomActionsPosition).PRIMARY,
            (0, $dV0Ap.CustomActionsPosition).CONTEXTMENU
        ],
        allowedMetadataIds: [
            'liveboardIds',
            'vizIds',
            'answerIds'
        ],
        allowedDataModelIds: [
            'modelIds',
            'modelColumnNames'
        ],
        allowedFields: [
            'name',
            'id',
            'position',
            'target',
            'metadataIds',
            'orgIds',
            'groupIds',
            'dataModelIds'
        ]
    },
    [(0, $dV0Ap.CustomActionTarget).ANSWER]: {
        positions: [
            (0, $dV0Ap.CustomActionsPosition).MENU,
            (0, $dV0Ap.CustomActionsPosition).PRIMARY,
            (0, $dV0Ap.CustomActionsPosition).CONTEXTMENU
        ],
        allowedMetadataIds: [
            'answerIds'
        ],
        allowedDataModelIds: [
            'modelIds',
            'modelColumnNames'
        ],
        allowedFields: [
            'name',
            'id',
            'position',
            'target',
            'metadataIds',
            'orgIds',
            'groupIds',
            'dataModelIds'
        ]
    },
    [(0, $dV0Ap.CustomActionTarget).SPOTTER]: {
        positions: [
            (0, $dV0Ap.CustomActionsPosition).MENU,
            (0, $dV0Ap.CustomActionsPosition).CONTEXTMENU
        ],
        allowedMetadataIds: [],
        allowedDataModelIds: [
            'modelIds'
        ],
        allowedFields: [
            'name',
            'id',
            'position',
            'target',
            'orgIds',
            'groupIds',
            'dataModelIds'
        ]
    }
};
/**
 * Validates a single custom action based on its target type
 * @param action - The custom action to validate
 * @param primaryActionsPerTarget - Map to track primary actions per target
 * @returns CustomActionValidation with isValid flag and reason string
 *
 * @hidden
 */ const $db66bc5c8a863686$var$validateCustomAction = (action, primaryActionsPerTarget)=>{
    const { id: actionId, target: targetType, position: position, metadataIds: metadataIds, dataModelIds: dataModelIds } = action;
    // Check if target type is supported
    if (!$db66bc5c8a863686$var$customActionValidationConfig[targetType]) {
        const errorMessage = (0, $h7cYZ.CUSTOM_ACTIONS_ERROR_MESSAGE).UNSUPPORTED_TARGET(actionId, targetType);
        return {
            isValid: false,
            errors: [
                errorMessage
            ]
        };
    }
    const config = $db66bc5c8a863686$var$customActionValidationConfig[targetType];
    const errors = [];
    // Validate position
    if (!(0, $7aJfj.arrayIncludesString)(config.positions, position)) {
        const supportedPositions = config.positions.join(', ');
        errors.push((0, $h7cYZ.CUSTOM_ACTIONS_ERROR_MESSAGE).INVALID_POSITION(position, targetType, supportedPositions));
    }
    // Validate metadata IDs
    if (metadataIds) {
        const invalidMetadataIds = Object.keys(metadataIds).filter((key)=>!(0, $7aJfj.arrayIncludesString)(config.allowedMetadataIds, key));
        if (invalidMetadataIds.length > 0) {
            const supportedMetadataIds = config.allowedMetadataIds.length > 0 ? config.allowedMetadataIds.join(', ') : 'none';
            errors.push((0, $h7cYZ.CUSTOM_ACTIONS_ERROR_MESSAGE).INVALID_METADATA_IDS(targetType, invalidMetadataIds, supportedMetadataIds));
        }
    }
    // Validate data model IDs
    if (dataModelIds) {
        const invalidDataModelIds = Object.keys(dataModelIds).filter((key)=>!(0, $7aJfj.arrayIncludesString)(config.allowedDataModelIds, key));
        if (invalidDataModelIds.length > 0) {
            const supportedDataModelIds = config.allowedDataModelIds.length > 0 ? config.allowedDataModelIds.join(', ') : 'none';
            errors.push((0, $h7cYZ.CUSTOM_ACTIONS_ERROR_MESSAGE).INVALID_DATA_MODEL_IDS(targetType, invalidDataModelIds, supportedDataModelIds));
        }
    }
    // Validate allowed fields
    const actionKeys = Object.keys(action);
    const invalidFields = actionKeys.filter((key)=>!(0, $7aJfj.arrayIncludesString)(config.allowedFields, key));
    if (invalidFields.length > 0) {
        const supportedFields = config.allowedFields.join(', ');
        errors.push((0, $h7cYZ.CUSTOM_ACTIONS_ERROR_MESSAGE).INVALID_FIELDS(targetType, invalidFields, supportedFields));
    }
    return {
        isValid: errors.length === 0,
        errors: errors
    };
};
/**
 * Validates basic action structure and required fields
 * @param action - The action to validate
 * @returns Object containing validation result and missing fields
 *
 * @hidden
 */ const $db66bc5c8a863686$var$validateActionStructure = (action)=>{
    if (!action || typeof action !== 'object') return {
        isValid: false,
        missingFields: []
    };
    // Check for all missing required fields
    const missingFields = [
        'id',
        'name',
        'target',
        'position'
    ].filter((field)=>!action[field]);
    return {
        isValid: missingFields.length === 0,
        missingFields: missingFields
    };
};
/**
 * Checks for duplicate IDs among actions
 * @param actions - Array of actions to check
 * @returns Object containing filtered actions and duplicate errors
 *
 * @hidden
 */ const $db66bc5c8a863686$var$filterDuplicateIds = (actions)=>{
    const idMap = actions.reduce((map, action)=>{
        const list = map.get(action.id) || [];
        list.push(action);
        map.set(action.id, list);
        return map;
    }, new Map());
    const { actions: actionsWithUniqueIds, errors: errors } = Array.from(idMap.entries()).reduce((acc, [id, actionsWithSameId])=>{
        if (actionsWithSameId.length === 1) acc.actions.push(actionsWithSameId[0]);
        else {
            // Keep the first action and add error for duplicates
            acc.actions.push(actionsWithSameId[0]);
            const duplicateNames = actionsWithSameId.slice(1).map((action)=>action.name);
            acc.errors.push((0, $h7cYZ.CUSTOM_ACTIONS_ERROR_MESSAGE).DUPLICATE_IDS(id, duplicateNames, actionsWithSameId[0].name));
        }
        return acc;
    }, {
        actions: [],
        errors: []
    });
    return {
        actions: actionsWithUniqueIds,
        errors: errors
    };
};
const $db66bc5c8a863686$export$d1002d3e50ecda60 = (customActions)=>{
    const errors = [];
    const primaryActionsPerTarget = new Map();
    if (!customActions || !Array.isArray(customActions)) return {
        actions: [],
        errors: []
    };
    // Step 1: Handle invalid actions first (null, undefined, missing required
    // fields)
    const validActions = customActions.filter((action)=>{
        const validation = $db66bc5c8a863686$var$validateActionStructure(action);
        if (!validation.isValid) {
            if (!action || typeof action !== 'object') errors.push((0, $h7cYZ.CUSTOM_ACTIONS_ERROR_MESSAGE).INVALID_ACTION_OBJECT);
            else errors.push((0, $h7cYZ.CUSTOM_ACTIONS_ERROR_MESSAGE).MISSING_REQUIRED_FIELDS(action.id, validation.missingFields));
            return false;
        }
        return true;
    });
    // Step 2: Check for duplicate IDs among valid actions
    const { actions: actionsWithUniqueIds, errors: duplicateErrors } = $db66bc5c8a863686$var$filterDuplicateIds(validActions);
    // Add duplicate errors to the errors array
    duplicateErrors.forEach((error)=>errors.push(error));
    // Step 3: Validate actions with unique IDs
    const finalValidActions = [];
    actionsWithUniqueIds.forEach((action)=>{
        const { isValid: isValid, errors: validationErrors } = $db66bc5c8a863686$var$validateCustomAction(action, primaryActionsPerTarget);
        validationErrors.forEach((error)=>errors.push(error));
        if (isValid) finalValidActions.push(action);
    });
    // Step 4: Collect warnings for long custom action names
    const MAX_ACTION_NAME_LENGTH = 30;
    const warnings = finalValidActions.filter((action)=>action.name.length > MAX_ACTION_NAME_LENGTH).map((action)=>`Custom action name '${action.name}' exceeds ${MAX_ACTION_NAME_LENGTH} characters. This may cause display or truncation issues in the UI.`);
    if (warnings.length > 0) (0, $kCAID.logger).warn(warnings);
    const sortedActions = (0, (/*@__PURE__*/$parcel$interopDefault($4F1oH)))(finalValidActions, (a)=>a.name.toLocaleLowerCase());
    return {
        actions: sortedActions,
        errors: errors
    };
};

});
parcelRegister("4F1oH", function(module, exports) {

var $8lLJ6 = parcelRequire("8lLJ6");

var $5OHSY = parcelRequire("5OHSY");

var $2bPJl = parcelRequire("2bPJl");

var $9xkz9 = parcelRequire("9xkz9");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $364c134291df3211$var$sortBy = $2bPJl(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $9xkz9(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $9xkz9(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $5OHSY(collection, $8lLJ6(iteratees, 1), []);
});
module.exports = $364c134291df3211$var$sortBy;

});
parcelRegister("8lLJ6", function(module, exports) {

var $b9jxk = parcelRequire("b9jxk");

var $7t4B7 = parcelRequire("7t4B7");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $61454e66e65b2d2e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $7t4B7);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $61454e66e65b2d2e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $b9jxk(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $61454e66e65b2d2e$var$baseFlatten;

});
parcelRegister("7t4B7", function(module, exports) {

var $1its0 = parcelRequire("1its0");

var $7cx1v = parcelRequire("7cx1v");

var $8JAfJ = parcelRequire("8JAfJ");
/** Built-in value references. */ var $56feceddcf305379$var$spreadableSymbol = $1its0 ? $1its0.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $56feceddcf305379$var$isFlattenable(value) {
    return $8JAfJ(value) || $7cx1v(value) || !!($56feceddcf305379$var$spreadableSymbol && value && value[$56feceddcf305379$var$spreadableSymbol]);
}
module.exports = $56feceddcf305379$var$isFlattenable;

});


parcelRegister("5OHSY", function(module, exports) {

var $2BXj9 = parcelRequire("2BXj9");

var $kBlwZ = parcelRequire("kBlwZ");

var $bDfda = parcelRequire("bDfda");

var $gHgts = parcelRequire("gHgts");

var $di7Iq = parcelRequire("di7Iq");

var $lGuK9 = parcelRequire("lGuK9");

var $g6XIN = parcelRequire("g6XIN");

var $CC47w = parcelRequire("CC47w");

var $8JAfJ = parcelRequire("8JAfJ");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $43c3aa0c0fa6ff90$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $2BXj9(iteratees, function(iteratee) {
        if ($8JAfJ(iteratee)) return function(value) {
            return $kBlwZ(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $CC47w
    ];
    var index = -1;
    iteratees = $2BXj9(iteratees, $lGuK9($bDfda));
    var result = $gHgts(collection, function(value, key, collection) {
        var criteria = $2BXj9(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $di7Iq(result, function(object, other) {
        return $g6XIN(object, other, orders);
    });
}
module.exports = $43c3aa0c0fa6ff90$var$baseOrderBy;

});
parcelRegister("2BXj9", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $1e6d0acd561cc660$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $1e6d0acd561cc660$var$arrayMap;

});

parcelRegister("kBlwZ", function(module, exports) {

var $aGETn = parcelRequire("aGETn");

var $jIgX6 = parcelRequire("jIgX6");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $eff7f6fa6fb32628$var$baseGet(object, path) {
    path = $aGETn(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$jIgX6(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $eff7f6fa6fb32628$var$baseGet;

});
parcelRegister("aGETn", function(module, exports) {

var $8JAfJ = parcelRequire("8JAfJ");

var $iFOqZ = parcelRequire("iFOqZ");

var $k0Uia = parcelRequire("k0Uia");

var $2UXku = parcelRequire("2UXku");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $7c7d8bf40895aa2d$var$castPath(value, object) {
    if ($8JAfJ(value)) return value;
    return $iFOqZ(value, object) ? [
        value
    ] : $k0Uia($2UXku(value));
}
module.exports = $7c7d8bf40895aa2d$var$castPath;

});
parcelRegister("iFOqZ", function(module, exports) {

var $8JAfJ = parcelRequire("8JAfJ");

var $4fYAE = parcelRequire("4fYAE");
/** Used to match property names within property paths. */ var $d9832d8b4010f439$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $d9832d8b4010f439$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $d9832d8b4010f439$var$isKey(value, object) {
    if ($8JAfJ(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $4fYAE(value)) return true;
    return $d9832d8b4010f439$var$reIsPlainProp.test(value) || !$d9832d8b4010f439$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $d9832d8b4010f439$var$isKey;

});
parcelRegister("4fYAE", function(module, exports) {

var $lqs1Q = parcelRequire("lqs1Q");

var $4Du0J = parcelRequire("4Du0J");
/** `Object#toString` result references. */ var $319790198220133d$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $319790198220133d$var$isSymbol(value) {
    return typeof value == 'symbol' || $4Du0J(value) && $lqs1Q(value) == $319790198220133d$var$symbolTag;
}
module.exports = $319790198220133d$var$isSymbol;

});


parcelRegister("k0Uia", function(module, exports) {

var $cjHJk = parcelRequire("cjHJk");
/** Used to match property names within property paths. */ var $e91f792933b52950$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $e91f792933b52950$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $e91f792933b52950$var$stringToPath = $cjHJk(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($e91f792933b52950$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($e91f792933b52950$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $e91f792933b52950$var$stringToPath;

});
parcelRegister("cjHJk", function(module, exports) {

var $1v9zh = parcelRequire("1v9zh");
/** Used as the maximum memoize cache size. */ var $8f792e4326162d56$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $8f792e4326162d56$var$memoizeCapped(func) {
    var result = $1v9zh(func, function(key) {
        if (cache.size === $8f792e4326162d56$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $8f792e4326162d56$var$memoizeCapped;

});
parcelRegister("1v9zh", function(module, exports) {

var $gbn6K = parcelRequire("gbn6K");
/** Error message constants. */ var $11801bb9e90fe62b$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $11801bb9e90fe62b$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($11801bb9e90fe62b$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($11801bb9e90fe62b$var$memoize.Cache || $gbn6K);
    return memoized;
}
// Expose `MapCache`.
$11801bb9e90fe62b$var$memoize.Cache = $gbn6K;
module.exports = $11801bb9e90fe62b$var$memoize;

});



parcelRegister("2UXku", function(module, exports) {

var $3XL4j = parcelRequire("3XL4j");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $21fed556ba97673c$var$toString(value) {
    return value == null ? '' : $3XL4j(value);
}
module.exports = $21fed556ba97673c$var$toString;

});
parcelRegister("3XL4j", function(module, exports) {

var $1its0 = parcelRequire("1its0");

var $2BXj9 = parcelRequire("2BXj9");

var $8JAfJ = parcelRequire("8JAfJ");

var $4fYAE = parcelRequire("4fYAE");
/** Used as references for various `Number` constants. */ var $2e2b649992c4a680$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2e2b649992c4a680$var$symbolProto = $1its0 ? $1its0.prototype : undefined, $2e2b649992c4a680$var$symbolToString = $2e2b649992c4a680$var$symbolProto ? $2e2b649992c4a680$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2e2b649992c4a680$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($8JAfJ(value)) // Recursively convert values (susceptible to call stack limits).
    return $2BXj9(value, $2e2b649992c4a680$var$baseToString) + '';
    if ($4fYAE(value)) return $2e2b649992c4a680$var$symbolToString ? $2e2b649992c4a680$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$2e2b649992c4a680$var$INFINITY ? '-0' : result;
}
module.exports = $2e2b649992c4a680$var$baseToString;

});



parcelRegister("jIgX6", function(module, exports) {

var $4fYAE = parcelRequire("4fYAE");
/** Used as references for various `Number` constants. */ var $e59f46bef0713e05$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $e59f46bef0713e05$var$toKey(value) {
    if (typeof value == 'string' || $4fYAE(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$e59f46bef0713e05$var$INFINITY ? '-0' : result;
}
module.exports = $e59f46bef0713e05$var$toKey;

});


parcelRegister("bDfda", function(module, exports) {

var $dyhPU = parcelRequire("dyhPU");

var $cr2eA = parcelRequire("cr2eA");

var $CC47w = parcelRequire("CC47w");

var $8JAfJ = parcelRequire("8JAfJ");

var $2s8u3 = parcelRequire("2s8u3");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $877f22e7e445941b$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $CC47w;
    if (typeof value == 'object') return $8JAfJ(value) ? $cr2eA(value[0], value[1]) : $dyhPU(value);
    return $2s8u3(value);
}
module.exports = $877f22e7e445941b$var$baseIteratee;

});
parcelRegister("dyhPU", function(module, exports) {

var $19qmJ = parcelRequire("19qmJ");

var $lmJ7u = parcelRequire("lmJ7u");

var $11Tp2 = parcelRequire("11Tp2");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $9ddc493b8d427125$var$baseMatches(source) {
    var matchData = $lmJ7u(source);
    if (matchData.length == 1 && matchData[0][2]) return $11Tp2(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $19qmJ(object, source, matchData);
    };
}
module.exports = $9ddc493b8d427125$var$baseMatches;

});
parcelRegister("19qmJ", function(module, exports) {

var $2GSgF = parcelRequire("2GSgF");

var $hI53D = parcelRequire("hI53D");
/** Used to compose bitmasks for value comparisons. */ var $0d6b155bccfde6de$var$COMPARE_PARTIAL_FLAG = 1, $0d6b155bccfde6de$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $0d6b155bccfde6de$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $2GSgF;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $hI53D(srcValue, objValue, $0d6b155bccfde6de$var$COMPARE_PARTIAL_FLAG | $0d6b155bccfde6de$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $0d6b155bccfde6de$var$baseIsMatch;

});

parcelRegister("lmJ7u", function(module, exports) {

var $eJrUV = parcelRequire("eJrUV");

var $gAbtd = parcelRequire("gAbtd");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $f8dea6e4a39e41d8$var$getMatchData(object) {
    var result = $gAbtd(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $eJrUV(value)
        ];
    }
    return result;
}
module.exports = $f8dea6e4a39e41d8$var$getMatchData;

});
parcelRegister("eJrUV", function(module, exports) {

var $hZEPb = parcelRequire("hZEPb");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $ab9aec729542eaf5$var$isStrictComparable(value) {
    return value === value && !$hZEPb(value);
}
module.exports = $ab9aec729542eaf5$var$isStrictComparable;

});


parcelRegister("11Tp2", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $0c00dc46ed8840cf$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $0c00dc46ed8840cf$var$matchesStrictComparable;

});


parcelRegister("cr2eA", function(module, exports) {

var $hI53D = parcelRequire("hI53D");

var $i3wgO = parcelRequire("i3wgO");

var $24RES = parcelRequire("24RES");

var $iFOqZ = parcelRequire("iFOqZ");

var $eJrUV = parcelRequire("eJrUV");

var $11Tp2 = parcelRequire("11Tp2");

var $jIgX6 = parcelRequire("jIgX6");
/** Used to compose bitmasks for value comparisons. */ var $90d9bd507ecabab3$var$COMPARE_PARTIAL_FLAG = 1, $90d9bd507ecabab3$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $90d9bd507ecabab3$var$baseMatchesProperty(path, srcValue) {
    if ($iFOqZ(path) && $eJrUV(srcValue)) return $11Tp2($jIgX6(path), srcValue);
    return function(object) {
        var objValue = $i3wgO(object, path);
        return objValue === undefined && objValue === srcValue ? $24RES(object, path) : $hI53D(srcValue, objValue, $90d9bd507ecabab3$var$COMPARE_PARTIAL_FLAG | $90d9bd507ecabab3$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $90d9bd507ecabab3$var$baseMatchesProperty;

});
parcelRegister("i3wgO", function(module, exports) {

var $kBlwZ = parcelRequire("kBlwZ");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d25189ffb21f6fd2$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $kBlwZ(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d25189ffb21f6fd2$var$get;

});

parcelRegister("24RES", function(module, exports) {

var $NVy7G = parcelRequire("NVy7G");

var $2wXNo = parcelRequire("2wXNo");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $183593eb6dcc7114$var$hasIn(object, path) {
    return object != null && $2wXNo(object, path, $NVy7G);
}
module.exports = $183593eb6dcc7114$var$hasIn;

});
parcelRegister("NVy7G", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $096137d2ff85d29a$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $096137d2ff85d29a$var$baseHasIn;

});

parcelRegister("2wXNo", function(module, exports) {

var $aGETn = parcelRequire("aGETn");

var $7cx1v = parcelRequire("7cx1v");

var $8JAfJ = parcelRequire("8JAfJ");

var $zsAV5 = parcelRequire("zsAV5");

var $1gDO9 = parcelRequire("1gDO9");

var $jIgX6 = parcelRequire("jIgX6");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $1d7cf41e269153aa$var$hasPath(object, path, hasFunc) {
    path = $aGETn(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $jIgX6(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1gDO9(length) && $zsAV5(key, length) && ($8JAfJ(object) || $7cx1v(object));
}
module.exports = $1d7cf41e269153aa$var$hasPath;

});



parcelRegister("CC47w", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $074113bb38d45979$var$identity(value) {
    return value;
}
module.exports = $074113bb38d45979$var$identity;

});

parcelRegister("2s8u3", function(module, exports) {

var $aOoCE = parcelRequire("aOoCE");

var $23JTE = parcelRequire("23JTE");

var $iFOqZ = parcelRequire("iFOqZ");

var $jIgX6 = parcelRequire("jIgX6");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $1c94c6fd81dc6951$var$property(path) {
    return $iFOqZ(path) ? $aOoCE($jIgX6(path)) : $23JTE(path);
}
module.exports = $1c94c6fd81dc6951$var$property;

});
parcelRegister("aOoCE", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7df1ac5e8bfbe14e$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $7df1ac5e8bfbe14e$var$baseProperty;

});

parcelRegister("23JTE", function(module, exports) {

var $kBlwZ = parcelRequire("kBlwZ");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $17ff76b41f44f8b2$var$basePropertyDeep(path) {
    return function(object) {
        return $kBlwZ(object, path);
    };
}
module.exports = $17ff76b41f44f8b2$var$basePropertyDeep;

});



parcelRegister("gHgts", function(module, exports) {

var $9sblP = parcelRequire("9sblP");

var $lAT3M = parcelRequire("lAT3M");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $c27d70ed2e8269a5$var$baseMap(collection, iteratee) {
    var index = -1, result = $lAT3M(collection) ? Array(collection.length) : [];
    $9sblP(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $c27d70ed2e8269a5$var$baseMap;

});
parcelRegister("9sblP", function(module, exports) {

var $6bNP9 = parcelRequire("6bNP9");

var $2FrKl = parcelRequire("2FrKl");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $6e1f88ac9845e679$var$baseEach = $2FrKl($6bNP9);
module.exports = $6e1f88ac9845e679$var$baseEach;

});
parcelRegister("6bNP9", function(module, exports) {

var $cHkRp = parcelRequire("cHkRp");

var $gAbtd = parcelRequire("gAbtd");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $481a6b30b8cdf967$var$baseForOwn(object, iteratee) {
    return object && $cHkRp(object, iteratee, $gAbtd);
}
module.exports = $481a6b30b8cdf967$var$baseForOwn;

});
parcelRegister("cHkRp", function(module, exports) {

var $dpdUZ = parcelRequire("dpdUZ");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $93e9aea24fb408d2$var$baseFor = $dpdUZ();
module.exports = $93e9aea24fb408d2$var$baseFor;

});
parcelRegister("dpdUZ", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $9c286802845801ac$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $9c286802845801ac$var$createBaseFor;

});



parcelRegister("2FrKl", function(module, exports) {

var $lAT3M = parcelRequire("lAT3M");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $1f14eef529b947d8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$lAT3M(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $1f14eef529b947d8$var$createBaseEach;

});



parcelRegister("di7Iq", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $9ad2f0f6f2595d26$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $9ad2f0f6f2595d26$var$baseSortBy;

});

parcelRegister("g6XIN", function(module, exports) {

var $l5meh = parcelRequire("l5meh");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $bbab88550bedbc88$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $l5meh(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $bbab88550bedbc88$var$compareMultiple;

});
parcelRegister("l5meh", function(module, exports) {

var $4fYAE = parcelRequire("4fYAE");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $f59b4ee600a190b3$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $4fYAE(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $4fYAE(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $f59b4ee600a190b3$var$compareAscending;

});



parcelRegister("2bPJl", function(module, exports) {

var $CC47w = parcelRequire("CC47w");

var $jftUY = parcelRequire("jftUY");

var $87KYa = parcelRequire("87KYa");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $1984bc68ec028c8b$var$baseRest(func, start) {
    return $87KYa($jftUY(func, start, $CC47w), func + '');
}
module.exports = $1984bc68ec028c8b$var$baseRest;

});
parcelRegister("jftUY", function(module, exports) {

var $kE9GA = parcelRequire("kE9GA");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e036a01b7ea62bb6$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $e036a01b7ea62bb6$var$overRest(func, start, transform) {
    start = $e036a01b7ea62bb6$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $e036a01b7ea62bb6$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $kE9GA(func, this, otherArgs);
    };
}
module.exports = $e036a01b7ea62bb6$var$overRest;

});
parcelRegister("kE9GA", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $f07f0e8291097dfe$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $f07f0e8291097dfe$var$apply;

});


parcelRegister("87KYa", function(module, exports) {

var $fzxC9 = parcelRequire("fzxC9");

var $c1wsI = parcelRequire("c1wsI");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $5ea3694f81544aae$var$setToString = $c1wsI($fzxC9);
module.exports = $5ea3694f81544aae$var$setToString;

});
parcelRegister("fzxC9", function(module, exports) {

var $7OOyQ = parcelRequire("7OOyQ");

var $k24Vz = parcelRequire("k24Vz");

var $CC47w = parcelRequire("CC47w");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b56432fb9d1232ee$var$baseSetToString = !$k24Vz ? $CC47w : function(func, string) {
    return $k24Vz(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $7OOyQ(string),
        'writable': true
    });
};
module.exports = $b56432fb9d1232ee$var$baseSetToString;

});
parcelRegister("7OOyQ", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $5b146c49a8122828$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $5b146c49a8122828$var$constant;

});

parcelRegister("k24Vz", function(module, exports) {

var $dCkw7 = parcelRequire("dCkw7");
var $e957d1135fa893c6$var$defineProperty = function() {
    try {
        var func = $dCkw7(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $e957d1135fa893c6$var$defineProperty;

});


parcelRegister("c1wsI", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $8c0ec25bb4a338b8$var$HOT_COUNT = 800, $8c0ec25bb4a338b8$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8c0ec25bb4a338b8$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $8c0ec25bb4a338b8$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $8c0ec25bb4a338b8$var$nativeNow(), remaining = $8c0ec25bb4a338b8$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $8c0ec25bb4a338b8$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $8c0ec25bb4a338b8$var$shortOut;

});



parcelRegister("9xkz9", function(module, exports) {

var $9StTY = parcelRequire("9StTY");

var $lAT3M = parcelRequire("lAT3M");

var $zsAV5 = parcelRequire("zsAV5");

var $hZEPb = parcelRequire("hZEPb");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $6f17261a727510ec$var$isIterateeCall(value, index, object) {
    if (!$hZEPb(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $lAT3M(object) && $zsAV5(index, object.length) : type == 'string' && index in object) return $9StTY(object[index], value);
    return false;
}
module.exports = $6f17261a727510ec$var$isIterateeCall;

});



parcelRegister("10hiU", function(module, exports) {

$parcel$export(module.exports, "getThoughtSpotHost", function () { return $0bb336c4bf385d7f$export$eb4363b7f4ccb184; });
$parcel$export(module.exports, "getV2BasePath", function () { return $0bb336c4bf385d7f$export$36f9e52c8949ff18; });
$parcel$export(module.exports, "DEFAULT_EMBED_WIDTH", function () { return $0bb336c4bf385d7f$export$307a57fbb422cb52; });
$parcel$export(module.exports, "DEFAULT_EMBED_HEIGHT", function () { return $0bb336c4bf385d7f$export$da051d1a0621b6dd; });

var $h7cYZ = parcelRequire("h7cYZ");
/**
 * Copyright (c) 2023
 *
 * Utilities related to reading configuration objects
 * @summary Config-related utils
 * @author Ayon Ghosh <ayon.ghosh@thoughtspot.com>
 */ const $0bb336c4bf385d7f$var$urlRegex = new RegExp([
    '(^(https?:)//)?',
    '(([^:/?#]*)(?::([0-9]+))?)',
    '(/{0,1}[^?#]*)',
    '(\\?[^#]*|)',
    '(#.*|)$'
].join(''));
const $0bb336c4bf385d7f$export$eb4363b7f4ccb184 = (config)=>{
    if (!config.thoughtSpotHost) throw new Error((0, $h7cYZ.ERROR_MESSAGE).INVALID_THOUGHTSPOT_HOST);
    const urlParts = config.thoughtSpotHost.match($0bb336c4bf385d7f$var$urlRegex);
    if (!urlParts) throw new Error((0, $h7cYZ.ERROR_MESSAGE).INVALID_THOUGHTSPOT_HOST);
    const protocol = urlParts[2] || window.location.protocol;
    const host = urlParts[3];
    let path = urlParts[6];
    // Lose the trailing / if any
    if (path.charAt(path.length - 1) === '/') path = path.substring(0, path.length - 1);
    // const urlParams = urlParts[7];
    // const hash = urlParts[8];
    return `${protocol}//${host}${path}`;
};
const $0bb336c4bf385d7f$export$36f9e52c8949ff18 = (config)=>{
    if (config.basepath) return config.basepath;
    const tsHost = $0bb336c4bf385d7f$export$eb4363b7f4ccb184(config);
    // This is to handle when e2e's. Search is run on pods for
    // comp-blink-test-pipeline with baseUrl=https://localhost:8443.
    // This is to handle when the developer is developing in their local
    // environment.
    if (tsHost.includes('://localhost') && !tsHost.includes(':8443')) return '';
    return 'v2';
};
const $0bb336c4bf385d7f$export$7419f05d61bcd67f = 2000;
const $0bb336c4bf385d7f$export$307a57fbb422cb52 = '100%';
const $0bb336c4bf385d7f$export$da051d1a0621b6dd = '100%';

});

parcelRegister("fxzLD", function(module, exports) {

$parcel$export(module.exports, "MIXPANEL_EVENT", function () { return $b505aeb72350d706$export$a978c6c170f584a1; });
$parcel$export(module.exports, "uploadMixpanelEvent", function () { return $b505aeb72350d706$export$5b65d73e37561152; });
$parcel$export(module.exports, "initMixpanel", function () { return $b505aeb72350d706$export$e614f62ab9abde9d; });

var $9TvCu = parcelRequire("9TvCu");

var $kCAID = parcelRequire("kCAID");

var $h7cYZ = parcelRequire("h7cYZ");
const $b505aeb72350d706$export$ce30d4c1fa70e50a = {
    CONFIG: '/callosum/v1/system/config'
};
// Needed to avoid error in CJS builds on some bundlers.
const $b505aeb72350d706$var$mixpanelLib = $9TvCu.default || $9TvCu;
let $b505aeb72350d706$var$mixpanelInstance;
const $b505aeb72350d706$export$a978c6c170f584a1 = {
    VISUAL_SDK_RENDER_START: 'visual-sdk-render-start',
    VISUAL_SDK_CALLED_INIT: 'visual-sdk-called-init',
    VISUAL_SDK_RENDER_COMPLETE: 'visual-sdk-render-complete',
    VISUAL_SDK_RENDER_FAILED: 'visual-sdk-render-failed',
    VISUAL_SDK_TRIGGER: 'visual-sdk-trigger',
    VISUAL_SDK_ON: 'visual-sdk-on',
    VISUAL_SDK_IFRAME_LOAD_PERFORMANCE: 'visual-sdk-iframe-load-performance',
    VISUAL_SDK_EMBED_CREATE: 'visual-sdk-embed-create',
    VERCEL_INTEGRATION_COMPLETED: 'vercel-integration-completed'
};
let $b505aeb72350d706$var$isMixpanelInitialized = false;
let $b505aeb72350d706$var$eventQueue = [];
function $b505aeb72350d706$export$5b65d73e37561152(eventId, eventProps = {}) {
    if (!$b505aeb72350d706$var$isMixpanelInitialized) {
        $b505aeb72350d706$var$eventQueue.push({
            eventId: eventId,
            eventProps: eventProps
        });
        return;
    }
    $b505aeb72350d706$var$mixpanelInstance.track(eventId, eventProps);
}
/**
 *
 */ function $b505aeb72350d706$var$emptyQueue() {
    if (!$b505aeb72350d706$var$isMixpanelInitialized) return;
    $b505aeb72350d706$var$eventQueue.forEach((event)=>{
        $b505aeb72350d706$export$5b65d73e37561152(event.eventId, event.eventProps);
    });
    $b505aeb72350d706$var$eventQueue = [];
}
function $b505aeb72350d706$export$e614f62ab9abde9d(sessionInfo) {
    var _a;
    if (!sessionInfo || !sessionInfo.mixpanelToken) {
        (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).MIXPANEL_TOKEN_NOT_FOUND);
        return;
    }
    // On a public cluster the user is anonymous, so don't set the identify to
    // userGUID
    const isPublicCluster = !!sessionInfo.isPublicUser;
    const token = sessionInfo.mixpanelToken;
    try {
        if (token) {
            $b505aeb72350d706$var$mixpanelInstance = $b505aeb72350d706$var$mixpanelLib.init(token, undefined, 'tsEmbed');
            if (!isPublicCluster) $b505aeb72350d706$var$mixpanelInstance.identify(sessionInfo.userGUID);
            $b505aeb72350d706$var$mixpanelInstance.register_once({
                clusterId: sessionInfo.clusterId,
                clusterName: sessionInfo.clusterName,
                releaseVersion: sessionInfo.releaseVersion,
                hostAppUrl: ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.host) || ''
            });
            $b505aeb72350d706$var$isMixpanelInitialized = true;
            $b505aeb72350d706$var$emptyQueue();
        }
    } catch (e) {
        (0, $kCAID.logger).error('Error initializing mixpanel', e);
    }
}
function $b505aeb72350d706$export$c1715fa5dffe8e47() {
    $b505aeb72350d706$var$isMixpanelInitialized = false;
    $b505aeb72350d706$var$eventQueue = [];
}

});
parcelRegister("9TvCu", function(module, exports) {
'use strict';
var $7341c7289667bcd6$var$Config = {
    DEBUG: false,
    LIB_VERSION: '2.47.0'
};
// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var $7341c7289667bcd6$var$window$1;
if (typeof window === 'undefined') {
    var $7341c7289667bcd6$var$loc = {
        hostname: ''
    };
    $7341c7289667bcd6$var$window$1 = {
        navigator: {
            userAgent: ''
        },
        document: {
            location: $7341c7289667bcd6$var$loc,
            referrer: ''
        },
        screen: {
            width: 0,
            height: 0
        },
        location: $7341c7289667bcd6$var$loc
    };
} else $7341c7289667bcd6$var$window$1 = window;
/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */ var $7341c7289667bcd6$var$ArrayProto = Array.prototype;
var $7341c7289667bcd6$var$FuncProto = Function.prototype;
var $7341c7289667bcd6$var$ObjProto = Object.prototype;
var $7341c7289667bcd6$var$slice = $7341c7289667bcd6$var$ArrayProto.slice;
var $7341c7289667bcd6$var$toString = $7341c7289667bcd6$var$ObjProto.toString;
var $7341c7289667bcd6$var$hasOwnProperty = $7341c7289667bcd6$var$ObjProto.hasOwnProperty;
var $7341c7289667bcd6$var$windowConsole = $7341c7289667bcd6$var$window$1.console;
var $7341c7289667bcd6$var$navigator = $7341c7289667bcd6$var$window$1.navigator;
var $7341c7289667bcd6$var$document$1 = $7341c7289667bcd6$var$window$1.document;
var $7341c7289667bcd6$var$windowOpera = $7341c7289667bcd6$var$window$1.opera;
var $7341c7289667bcd6$var$screen = $7341c7289667bcd6$var$window$1.screen;
var $7341c7289667bcd6$var$userAgent = $7341c7289667bcd6$var$navigator.userAgent;
var $7341c7289667bcd6$var$nativeBind = $7341c7289667bcd6$var$FuncProto.bind;
var $7341c7289667bcd6$var$nativeForEach = $7341c7289667bcd6$var$ArrayProto.forEach;
var $7341c7289667bcd6$var$nativeIndexOf = $7341c7289667bcd6$var$ArrayProto.indexOf;
var $7341c7289667bcd6$var$nativeMap = $7341c7289667bcd6$var$ArrayProto.map;
var $7341c7289667bcd6$var$nativeIsArray = Array.isArray;
var $7341c7289667bcd6$var$breaker = {};
var $7341c7289667bcd6$var$_ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};
// Console override
var $7341c7289667bcd6$var$console = {
    /** @type {function(...*)} */ log: function() {
        if ($7341c7289667bcd6$var$Config.DEBUG && !$7341c7289667bcd6$var$_.isUndefined($7341c7289667bcd6$var$windowConsole) && $7341c7289667bcd6$var$windowConsole) try {
            $7341c7289667bcd6$var$windowConsole.log.apply($7341c7289667bcd6$var$windowConsole, arguments);
        } catch (err) {
            $7341c7289667bcd6$var$_.each(arguments, function(arg) {
                $7341c7289667bcd6$var$windowConsole.log(arg);
            });
        }
    },
    /** @type {function(...*)} */ warn: function() {
        if ($7341c7289667bcd6$var$Config.DEBUG && !$7341c7289667bcd6$var$_.isUndefined($7341c7289667bcd6$var$windowConsole) && $7341c7289667bcd6$var$windowConsole) {
            var args = [
                'Mixpanel warning:'
            ].concat($7341c7289667bcd6$var$_.toArray(arguments));
            try {
                $7341c7289667bcd6$var$windowConsole.warn.apply($7341c7289667bcd6$var$windowConsole, args);
            } catch (err) {
                $7341c7289667bcd6$var$_.each(args, function(arg) {
                    $7341c7289667bcd6$var$windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ error: function() {
        if ($7341c7289667bcd6$var$Config.DEBUG && !$7341c7289667bcd6$var$_.isUndefined($7341c7289667bcd6$var$windowConsole) && $7341c7289667bcd6$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($7341c7289667bcd6$var$_.toArray(arguments));
            try {
                $7341c7289667bcd6$var$windowConsole.error.apply($7341c7289667bcd6$var$windowConsole, args);
            } catch (err) {
                $7341c7289667bcd6$var$_.each(args, function(arg) {
                    $7341c7289667bcd6$var$windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */ critical: function() {
        if (!$7341c7289667bcd6$var$_.isUndefined($7341c7289667bcd6$var$windowConsole) && $7341c7289667bcd6$var$windowConsole) {
            var args = [
                'Mixpanel error:'
            ].concat($7341c7289667bcd6$var$_.toArray(arguments));
            try {
                $7341c7289667bcd6$var$windowConsole.error.apply($7341c7289667bcd6$var$windowConsole, args);
            } catch (err) {
                $7341c7289667bcd6$var$_.each(args, function(arg) {
                    $7341c7289667bcd6$var$windowConsole.error(arg);
                });
            }
        }
    }
};
var $7341c7289667bcd6$var$log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply($7341c7289667bcd6$var$console, arguments);
    };
};
var $7341c7289667bcd6$var$console_with_prefix = function(prefix) {
    return {
        log: $7341c7289667bcd6$var$log_func_with_prefix($7341c7289667bcd6$var$console.log, prefix),
        error: $7341c7289667bcd6$var$log_func_with_prefix($7341c7289667bcd6$var$console.error, prefix),
        critical: $7341c7289667bcd6$var$log_func_with_prefix($7341c7289667bcd6$var$console.critical, prefix)
    };
};
// UNDERSCORE
// Embed part of the Underscore Library
$7341c7289667bcd6$var$_.bind = function(func, context) {
    var args, bound;
    if ($7341c7289667bcd6$var$nativeBind && func.bind === $7341c7289667bcd6$var$nativeBind) return $7341c7289667bcd6$var$nativeBind.apply(func, $7341c7289667bcd6$var$slice.call(arguments, 1));
    if (!$7341c7289667bcd6$var$_.isFunction(func)) throw new TypeError();
    args = $7341c7289667bcd6$var$slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) return func.apply(context, args.concat($7341c7289667bcd6$var$slice.call(arguments)));
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat($7341c7289667bcd6$var$slice.call(arguments)));
        if (Object(result) === result) return result;
        return self;
    };
    return bound;
};
/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */ $7341c7289667bcd6$var$_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) return;
    if ($7341c7289667bcd6$var$nativeForEach && obj.forEach === $7341c7289667bcd6$var$nativeForEach) obj.forEach(iterator, context);
    else if (obj.length === +obj.length) for(var i = 0, l = obj.length; i < l; i++){
        if (i in obj && iterator.call(context, obj[i], i, obj) === $7341c7289667bcd6$var$breaker) return;
    }
    else {
        for(var key in obj)if ($7341c7289667bcd6$var$hasOwnProperty.call(obj, key)) {
            if (iterator.call(context, obj[key], key, obj) === $7341c7289667bcd6$var$breaker) return;
        }
    }
};
$7341c7289667bcd6$var$_.extend = function(obj) {
    $7341c7289667bcd6$var$_.each($7341c7289667bcd6$var$slice.call(arguments, 1), function(source) {
        for(var prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
    });
    return obj;
};
$7341c7289667bcd6$var$_.isArray = $7341c7289667bcd6$var$nativeIsArray || function(obj) {
    return $7341c7289667bcd6$var$toString.call(obj) === '[object Array]';
};
// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
$7341c7289667bcd6$var$_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};
$7341c7289667bcd6$var$_.isArguments = function(obj) {
    return !!(obj && $7341c7289667bcd6$var$hasOwnProperty.call(obj, 'callee'));
};
$7341c7289667bcd6$var$_.toArray = function(iterable) {
    if (!iterable) return [];
    if (iterable.toArray) return iterable.toArray();
    if ($7341c7289667bcd6$var$_.isArray(iterable)) return $7341c7289667bcd6$var$slice.call(iterable);
    if ($7341c7289667bcd6$var$_.isArguments(iterable)) return $7341c7289667bcd6$var$slice.call(iterable);
    return $7341c7289667bcd6$var$_.values(iterable);
};
$7341c7289667bcd6$var$_.map = function(arr, callback, context) {
    if ($7341c7289667bcd6$var$nativeMap && arr.map === $7341c7289667bcd6$var$nativeMap) return arr.map(callback, context);
    else {
        var results = [];
        $7341c7289667bcd6$var$_.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};
$7341c7289667bcd6$var$_.keys = function(obj) {
    var results = [];
    if (obj === null) return results;
    $7341c7289667bcd6$var$_.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};
$7341c7289667bcd6$var$_.values = function(obj) {
    var results = [];
    if (obj === null) return results;
    $7341c7289667bcd6$var$_.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};
$7341c7289667bcd6$var$_.include = function(obj, target) {
    var found = false;
    if (obj === null) return found;
    if ($7341c7289667bcd6$var$nativeIndexOf && obj.indexOf === $7341c7289667bcd6$var$nativeIndexOf) return obj.indexOf(target) != -1;
    $7341c7289667bcd6$var$_.each(obj, function(value) {
        if (found || (found = value === target)) return $7341c7289667bcd6$var$breaker;
    });
    return found;
};
$7341c7289667bcd6$var$_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};
// Underscore Addons
$7341c7289667bcd6$var$_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};
$7341c7289667bcd6$var$_.isObject = function(obj) {
    return obj === Object(obj) && !$7341c7289667bcd6$var$_.isArray(obj);
};
$7341c7289667bcd6$var$_.isEmptyObject = function(obj) {
    if ($7341c7289667bcd6$var$_.isObject(obj)) {
        for(var key in obj){
            if ($7341c7289667bcd6$var$hasOwnProperty.call(obj, key)) return false;
        }
        return true;
    }
    return false;
};
$7341c7289667bcd6$var$_.isUndefined = function(obj) {
    return obj === void 0;
};
$7341c7289667bcd6$var$_.isString = function(obj) {
    return $7341c7289667bcd6$var$toString.call(obj) == '[object String]';
};
$7341c7289667bcd6$var$_.isDate = function(obj) {
    return $7341c7289667bcd6$var$toString.call(obj) == '[object Date]';
};
$7341c7289667bcd6$var$_.isNumber = function(obj) {
    return $7341c7289667bcd6$var$toString.call(obj) == '[object Number]';
};
$7341c7289667bcd6$var$_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};
$7341c7289667bcd6$var$_.encodeDates = function(obj) {
    $7341c7289667bcd6$var$_.each(obj, function(v, k) {
        if ($7341c7289667bcd6$var$_.isDate(v)) obj[k] = $7341c7289667bcd6$var$_.formatDate(v);
        else if ($7341c7289667bcd6$var$_.isObject(v)) obj[k] = $7341c7289667bcd6$var$_.encodeDates(v); // recurse
    });
    return obj;
};
$7341c7289667bcd6$var$_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};
$7341c7289667bcd6$var$_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds());
};
$7341c7289667bcd6$var$_.strip_empty_properties = function(p) {
    var ret = {};
    $7341c7289667bcd6$var$_.each(p, function(v, k) {
        if ($7341c7289667bcd6$var$_.isString(v) && v.length > 0) ret[k] = v;
    });
    return ret;
};
/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */ $7341c7289667bcd6$var$_.truncate = function(obj, length) {
    var ret;
    if (typeof obj === 'string') ret = obj.slice(0, length);
    else if ($7341c7289667bcd6$var$_.isArray(obj)) {
        ret = [];
        $7341c7289667bcd6$var$_.each(obj, function(val) {
            ret.push($7341c7289667bcd6$var$_.truncate(val, length));
        });
    } else if ($7341c7289667bcd6$var$_.isObject(obj)) {
        ret = {};
        $7341c7289667bcd6$var$_.each(obj, function(val, key) {
            ret[key] = $7341c7289667bcd6$var$_.truncate(val, length);
        });
    } else ret = obj;
    return ret;
};
$7341c7289667bcd6$var$_.JSONEncode = function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = {
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };
            escapable.lastIndex = 0;
            return escapable.test(string) ? '"' + string.replace(escapable, function(a) {
                var c = meta[a];
                return typeof c === 'string' ? c : '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
            }) + '"' : '"' + string + '"';
        };
        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];
            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' && typeof value.toJSON === 'function') value = value.toJSON(key);
            // What happens next depends on the value's type.
            switch(typeof value){
                case 'string':
                    return quote(value);
                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';
                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.
                    return String(value);
                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) return 'null';
                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];
                    // Is the value an array?
                    if ($7341c7289667bcd6$var$toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.
                        length = value.length;
                        for(i = 0; i < length; i += 1)partial[i] = str(i, value) || 'null';
                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' : gap ? '[\n' + gap + partial.join(',\n' + gap) + '\n' + mind + ']' : '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }
                    // Iterate through all of the keys in the object.
                    for(k in value)if ($7341c7289667bcd6$var$hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) partial.push(quote(k) + (gap ? ': ' : ':') + v);
                    }
                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' : gap ? '{' + partial.join(',') + '' + mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };
        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
}();
/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */ $7341c7289667bcd6$var$_.JSONDecode = function() {
    var at, ch, escapee = {
        '"': '"',
        '\\': '\\',
        '/': '/',
        'b': '\b',
        'f': '\f',
        'n': '\n',
        'r': '\r',
        't': '\t'
    }, text, error = function(m) {
        var e = new SyntaxError(m);
        e.at = at;
        e.text = text;
        throw e;
    }, next = function(c) {
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== ch) error('Expected \'' + c + '\' instead of \'' + ch + '\'');
        // Get the next character. When there are no more characters,
        // return the empty string.
        ch = text.charAt(at);
        at += 1;
        return ch;
    }, number = function() {
        // Parse a number value.
        var number, string = '';
        if (ch === '-') {
            string = '-';
            next('-');
        }
        while(ch >= '0' && ch <= '9'){
            string += ch;
            next();
        }
        if (ch === '.') {
            string += '.';
            while(next() && ch >= '0' && ch <= '9')string += ch;
        }
        if (ch === 'e' || ch === 'E') {
            string += ch;
            next();
            if (ch === '-' || ch === '+') {
                string += ch;
                next();
            }
            while(ch >= '0' && ch <= '9'){
                string += ch;
                next();
            }
        }
        number = +string;
        if (!isFinite(number)) error('Bad number');
        else return number;
    }, string = function() {
        // Parse a string value.
        var hex, i, string = '', uffff;
        // When parsing for string values, we must look for " and \ characters.
        if (ch === '"') while(next()){
            if (ch === '"') {
                next();
                return string;
            }
            if (ch === '\\') {
                next();
                if (ch === 'u') {
                    uffff = 0;
                    for(i = 0; i < 4; i += 1){
                        hex = parseInt(next(), 16);
                        if (!isFinite(hex)) break;
                        uffff = uffff * 16 + hex;
                    }
                    string += String.fromCharCode(uffff);
                } else if (typeof escapee[ch] === 'string') string += escapee[ch];
                else break;
            } else string += ch;
        }
        error('Bad string');
    }, white = function() {
        // Skip whitespace.
        while(ch && ch <= ' ')next();
    }, word = function() {
        // true, false, or null.
        switch(ch){
            case 't':
                next('t');
                next('r');
                next('u');
                next('e');
                return true;
            case 'f':
                next('f');
                next('a');
                next('l');
                next('s');
                next('e');
                return false;
            case 'n':
                next('n');
                next('u');
                next('l');
                next('l');
                return null;
        }
        error('Unexpected "' + ch + '"');
    }, value, array = function() {
        // Parse an array value.
        var array = [];
        if (ch === '[') {
            next('[');
            white();
            if (ch === ']') {
                next(']');
                return array; // empty array
            }
            while(ch){
                array.push(value());
                white();
                if (ch === ']') {
                    next(']');
                    return array;
                }
                next(',');
                white();
            }
        }
        error('Bad array');
    }, object = function() {
        // Parse an object value.
        var key, object = {};
        if (ch === '{') {
            next('{');
            white();
            if (ch === '}') {
                next('}');
                return object; // empty object
            }
            while(ch){
                key = string();
                white();
                next(':');
                if (Object.hasOwnProperty.call(object, key)) error('Duplicate key "' + key + '"');
                object[key] = value();
                white();
                if (ch === '}') {
                    next('}');
                    return object;
                }
                next(',');
                white();
            }
        }
        error('Bad object');
    };
    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch(ch){
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };
    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;
        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) error('Syntax error');
        return result;
    };
}();
$7341c7289667bcd6$var$_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];
    if (!data) return data;
    data = $7341c7289667bcd6$var$_.utf8Encode(data);
    do {
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);
        bits = o1 << 16 | o2 << 8 | o3;
        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;
        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    }while (i < data.length);
    enc = tmp_arr.join('');
    switch(data.length % 3){
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }
    return enc;
};
$7341c7289667bcd6$var$_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    var utftext = '', start, end;
    var stringl = 0, n;
    start = end = 0;
    stringl = string.length;
    for(n = 0; n < stringl; n++){
        var c1 = string.charCodeAt(n);
        var enc = null;
        if (c1 < 128) end++;
        else if (c1 > 127 && c1 < 2048) enc = String.fromCharCode(c1 >> 6 | 192, c1 & 63 | 128);
        else enc = String.fromCharCode(c1 >> 12 | 224, c1 >> 6 & 63 | 128, c1 & 63 | 128);
        if (enc !== null) {
            if (end > start) utftext += string.substring(start, end);
            utftext += enc;
            start = end = n + 1;
        }
    }
    if (end > start) utftext += string.substring(start, string.length);
    return utftext;
};
$7341c7289667bcd6$var$_.UUID = function() {
    // Time-based entropy
    var T = function() {
        var time = 1 * new Date(); // cross-browser version of Date.now()
        var ticks;
        if ($7341c7289667bcd6$var$window$1.performance && $7341c7289667bcd6$var$window$1.performance.now) ticks = $7341c7289667bcd6$var$window$1.performance.now();
        else {
            // fall back to busy loop
            ticks = 0;
            // this while loop figures how many browser ticks go by
            // before 1*new Date() returns a new number, ie the amount
            // of ticks that go by per millisecond
            while(time == 1 * new Date())ticks++;
        }
        return time.toString(16) + Math.floor(ticks).toString(16);
    };
    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace('.', '');
    };
    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = $7341c7289667bcd6$var$userAgent, i, ch, buffer = [], ret = 0;
        function xor(result, byte_array) {
            var j, tmp = 0;
            for(j = 0; j < byte_array.length; j++)tmp |= buffer[j] << j * 8;
            return result ^ tmp;
        }
        for(i = 0; i < ua.length; i++){
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }
        if (buffer.length > 0) ret = xor(ret, buffer);
        return ret.toString(16);
    };
    return function() {
        var se = ($7341c7289667bcd6$var$screen.height * $7341c7289667bcd6$var$screen.width).toString(16);
        return T() + '-' + R() + '-' + UA() + '-' + se + '-' + T();
    };
}();
// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var $7341c7289667bcd6$var$BLOCKED_UA_STRS = [
    'ahrefsbot',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandexbot',
    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
$7341c7289667bcd6$var$_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for(i = 0; i < $7341c7289667bcd6$var$BLOCKED_UA_STRS.length; i++){
        if (ua.indexOf($7341c7289667bcd6$var$BLOCKED_UA_STRS[i]) !== -1) return true;
    }
    return false;
};
/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */ $7341c7289667bcd6$var$_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];
    if ($7341c7289667bcd6$var$_.isUndefined(arg_separator)) arg_separator = '&';
    $7341c7289667bcd6$var$_.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });
    return tmp_arr.join(arg_separator);
};
$7341c7289667bcd6$var$_.getQueryParam = function(url, param) {
    // Expects a raw URL
    param = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)', regex = new RegExp(regexS), results = regex.exec(url);
    if (results === null || results && typeof results[1] !== 'string' && results[1].length) return '';
    else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch (err) {
            $7341c7289667bcd6$var$console.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};
// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
$7341c7289667bcd6$var$_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = $7341c7289667bcd6$var$document$1.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) == ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    },
    parse: function(name) {
        var cookie;
        try {
            cookie = $7341c7289667bcd6$var$_.JSONDecode($7341c7289667bcd6$var$_.cookie.get(name)) || {};
        } catch (err) {
        // noop
        }
        return cookie;
    },
    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $7341c7289667bcd6$var$extract_domain($7341c7289667bcd6$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + seconds * 1000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        $7341c7289667bcd6$var$document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },
    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';
        if (domain_override) cdomain = '; domain=' + domain_override;
        else if (is_cross_subdomain) {
            var domain = $7341c7289667bcd6$var$extract_domain($7341c7289667bcd6$var$document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 86400000);
            expires = '; expires=' + date.toGMTString();
        }
        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) secure += '; secure';
        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        $7341c7289667bcd6$var$document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },
    remove: function(name, is_cross_subdomain, domain_override) {
        $7341c7289667bcd6$var$_.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};
var $7341c7289667bcd6$var$_localStorageSupported = null;
var $7341c7289667bcd6$var$localStorageSupported = function(storage, forceCheck) {
    if ($7341c7289667bcd6$var$_localStorageSupported !== null && !forceCheck) return $7341c7289667bcd6$var$_localStorageSupported;
    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = '__mplss_' + $7341c7289667bcd6$var$cheap_guid(8), val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) supported = false;
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }
    $7341c7289667bcd6$var$_localStorageSupported = supported;
    return supported;
};
// _.localStorage
$7341c7289667bcd6$var$_.localStorage = {
    is_supported: function(force_check) {
        var supported = $7341c7289667bcd6$var$localStorageSupported(null, force_check);
        if (!supported) $7341c7289667bcd6$var$console.error('localStorage unsupported; falling back to cookie store');
        return supported;
    },
    error: function(msg) {
        $7341c7289667bcd6$var$console.error('localStorage error: ' + msg);
    },
    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            $7341c7289667bcd6$var$_.localStorage.error(err);
        }
        return null;
    },
    parse: function(name) {
        try {
            return $7341c7289667bcd6$var$_.JSONDecode($7341c7289667bcd6$var$_.localStorage.get(name)) || {};
        } catch (err) {
        // noop
        }
        return null;
    },
    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            $7341c7289667bcd6$var$_.localStorage.error(err);
        }
    },
    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            $7341c7289667bcd6$var$_.localStorage.error(err);
        }
    }
};
$7341c7289667bcd6$var$_.register_event = function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440
    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */ var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            $7341c7289667bcd6$var$console.error('No valid element provided to register_event');
            return;
        }
        if (element.addEventListener && !oldSchool) element.addEventListener(type, handler, !!useCapture);
        else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };
    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);
            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) return undefined;
            var ret = true;
            var old_result, new_result;
            if ($7341c7289667bcd6$var$_.isFunction(old_handlers)) old_result = old_handlers(event);
            new_result = new_handler.call(element, event);
            if (false === old_result || false === new_result) ret = false;
            return ret;
        };
        return handler;
    }
    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };
    return register_event;
}();
var $7341c7289667bcd6$var$TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');
$7341c7289667bcd6$var$_.dom_query = function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */ function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }
    var bad_whitespace = /[\t\r\n]/g;
    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return (' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0;
    }
    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!$7341c7289667bcd6$var$document$1.getElementsByTagName) return [];
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [
            $7341c7289667bcd6$var$document$1
        ];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = $7341c7289667bcd6$var$document$1.getElementById(id);
                if (!element || tagName && element.nodeName.toLowerCase() != tagName) // element not found or tag with that ID not found, return false
                return [];
                // Set currentContext to contain just this element
                currentContext = [
                    element
                ];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) tagName = '*';
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (found[j].className && $7341c7289667bcd6$var$_.isString(found[j].className) && // some SVG elements have classNames which are not strings
                hasClass(found[j], className)) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match($7341c7289667bcd6$var$TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) tagName = '*';
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for(j = 0; j < currentContext.length; j++){
                    if (tagName == '*') elements = getAllChildren(currentContext[j]);
                    else elements = currentContext[j].getElementsByTagName(tagName);
                    for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch(attrOperator){
                    case '=':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName) == attrValue;
                        };
                        break;
                    case '~':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b'));
                        };
                        break;
                    case '|':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?'));
                        };
                        break;
                    case '^':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) === 0;
                        };
                        break;
                    case '$':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length;
                        };
                        break;
                    case '*':
                        checkFunction = function(e) {
                            return e.getAttribute(attrName).indexOf(attrValue) > -1;
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for(j = 0; j < found.length; j++)if (checkFunction(found[j])) currentContext[currentContextIndex++] = found[j];
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for(j = 0; j < currentContext.length; j++){
                elements = currentContext[j].getElementsByTagName(tagName);
                for(k = 0; k < elements.length; k++)found[foundCount++] = elements[k];
            }
            currentContext = found;
        }
        return currentContext;
    }
    return function(query) {
        if ($7341c7289667bcd6$var$_.isElement(query)) return [
            query
        ];
        else if ($7341c7289667bcd6$var$_.isObject(query) && !$7341c7289667bcd6$var$_.isUndefined(query.length)) return query;
        else return getElementsBySelector.call(this, query);
    };
}();
var $7341c7289667bcd6$var$CAMPAIGN_KEYWORDS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
];
var $7341c7289667bcd6$var$CLICK_IDS = [
    'dclid',
    'fbclid',
    'gclid',
    'ko_click_id',
    'li_fat_id',
    'msclkid',
    'ttclid',
    'twclid',
    'wbraid'
];
$7341c7289667bcd6$var$_.info = {
    campaignParams: function(default_value) {
        var kw = '', params = {};
        $7341c7289667bcd6$var$_.each($7341c7289667bcd6$var$CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = $7341c7289667bcd6$var$_.getQueryParam($7341c7289667bcd6$var$document$1.URL, kwkey);
            if (kw.length) params[kwkey] = kw;
            else if (default_value !== undefined) params[kwkey] = default_value;
        });
        return params;
    },
    clickParams: function() {
        var id = '', params = {};
        $7341c7289667bcd6$var$_.each($7341c7289667bcd6$var$CLICK_IDS, function(idkey) {
            id = $7341c7289667bcd6$var$_.getQueryParam($7341c7289667bcd6$var$document$1.URL, idkey);
            if (id.length) params[idkey] = id;
        });
        return params;
    },
    marketingParams: function() {
        return $7341c7289667bcd6$var$_.extend($7341c7289667bcd6$var$_.info.campaignParams(), $7341c7289667bcd6$var$_.info.clickParams());
    },
    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) return 'google';
        else if (referrer.search('https?://(.*)bing.com') === 0) return 'bing';
        else if (referrer.search('https?://(.*)yahoo.com') === 0) return 'yahoo';
        else if (referrer.search('https?://(.*)duckduckgo.com') === 0) return 'duckduckgo';
        else return null;
    },
    searchInfo: function(referrer) {
        var search = $7341c7289667bcd6$var$_.info.searchEngine(referrer), param = search != 'yahoo' ? 'q' : 'p', ret = {};
        if (search !== null) {
            ret['$search_engine'] = search;
            var keyword = $7341c7289667bcd6$var$_.getQueryParam(referrer, param);
            if (keyword.length) ret['mp_keyword'] = keyword;
        }
        return ret;
    },
    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */ browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || $7341c7289667bcd6$var$_.includes(user_agent, ' OPR/')) {
            if ($7341c7289667bcd6$var$_.includes(user_agent, 'Mini')) return 'Opera Mini';
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'IEMobile') || $7341c7289667bcd6$var$_.includes(user_agent, 'WPDesktop')) return 'Internet Explorer Mobile';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'SamsungBrowser/')) // https://developer.samsung.com/internet/user-agent-string-format
        return 'Samsung Internet';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'Edge') || $7341c7289667bcd6$var$_.includes(user_agent, 'Edg/')) return 'Microsoft Edge';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'FBIOS')) return 'Facebook Mobile';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'Chrome')) return 'Chrome';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'CriOS')) return 'Chrome iOS';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'UCWEB') || $7341c7289667bcd6$var$_.includes(user_agent, 'UCBrowser')) return 'UC Browser';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'FxiOS')) return 'Firefox iOS';
        else if ($7341c7289667bcd6$var$_.includes(vendor, 'Apple')) {
            if ($7341c7289667bcd6$var$_.includes(user_agent, 'Mobile')) return 'Mobile Safari';
            return 'Safari';
        } else if ($7341c7289667bcd6$var$_.includes(user_agent, 'Android')) return 'Android Mobile';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'Konqueror')) return 'Konqueror';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'Firefox')) return 'Firefox';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'MSIE') || $7341c7289667bcd6$var$_.includes(user_agent, 'Trident/')) return 'Internet Explorer';
        else if ($7341c7289667bcd6$var$_.includes(user_agent, 'Gecko')) return 'Mozilla';
        else return '';
    },
    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */ browserVersion: function(userAgent, vendor, opera) {
        var browser = $7341c7289667bcd6$var$_.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser': /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) return null;
        var matches = userAgent.match(regex);
        if (!matches) return null;
        return parseFloat(matches[matches.length - 2]);
    },
    os: function() {
        var a = $7341c7289667bcd6$var$userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) return 'Windows Phone';
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) return 'iOS';
        else if (/Android/.test(a)) return 'Android';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) return 'BlackBerry';
        else if (/Mac/i.test(a)) return 'Mac OS X';
        else if (/Linux/.test(a)) return 'Linux';
        else if (/CrOS/.test(a)) return 'Chrome OS';
        else return '';
    },
    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) return 'Windows Phone';
        else if (/iPad/.test(user_agent)) return 'iPad';
        else if (/iPod/.test(user_agent)) return 'iPod Touch';
        else if (/iPhone/.test(user_agent)) return 'iPhone';
        else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) return 'BlackBerry';
        else if (/Android/.test(user_agent)) return 'Android';
        else return '';
    },
    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) return split[2];
        return '';
    },
    properties: function() {
        return $7341c7289667bcd6$var$_.extend($7341c7289667bcd6$var$_.strip_empty_properties({
            '$os': $7341c7289667bcd6$var$_.info.os(),
            '$browser': $7341c7289667bcd6$var$_.info.browser($7341c7289667bcd6$var$userAgent, $7341c7289667bcd6$var$navigator.vendor, $7341c7289667bcd6$var$windowOpera),
            '$referrer': $7341c7289667bcd6$var$document$1.referrer,
            '$referring_domain': $7341c7289667bcd6$var$_.info.referringDomain($7341c7289667bcd6$var$document$1.referrer),
            '$device': $7341c7289667bcd6$var$_.info.device($7341c7289667bcd6$var$userAgent)
        }), {
            '$current_url': $7341c7289667bcd6$var$window$1.location.href,
            '$browser_version': $7341c7289667bcd6$var$_.info.browserVersion($7341c7289667bcd6$var$userAgent, $7341c7289667bcd6$var$navigator.vendor, $7341c7289667bcd6$var$windowOpera),
            '$screen_height': $7341c7289667bcd6$var$screen.height,
            '$screen_width': $7341c7289667bcd6$var$screen.width,
            'mp_lib': 'web',
            '$lib_version': $7341c7289667bcd6$var$Config.LIB_VERSION,
            '$insert_id': $7341c7289667bcd6$var$cheap_guid(),
            'time': $7341c7289667bcd6$var$_.timestamp() / 1000 // epoch time in seconds
        });
    },
    people_properties: function() {
        return $7341c7289667bcd6$var$_.extend($7341c7289667bcd6$var$_.strip_empty_properties({
            '$os': $7341c7289667bcd6$var$_.info.os(),
            '$browser': $7341c7289667bcd6$var$_.info.browser($7341c7289667bcd6$var$userAgent, $7341c7289667bcd6$var$navigator.vendor, $7341c7289667bcd6$var$windowOpera)
        }), {
            '$browser_version': $7341c7289667bcd6$var$_.info.browserVersion($7341c7289667bcd6$var$userAgent, $7341c7289667bcd6$var$navigator.vendor, $7341c7289667bcd6$var$windowOpera)
        });
    },
    mpPageViewProperties: function() {
        return $7341c7289667bcd6$var$_.strip_empty_properties({
            'current_page_title': $7341c7289667bcd6$var$document$1.title,
            'current_domain': $7341c7289667bcd6$var$window$1.location.hostname,
            'current_url_path': $7341c7289667bcd6$var$window$1.location.pathname,
            'current_url_protocol': $7341c7289667bcd6$var$window$1.location.protocol,
            'current_url_search': $7341c7289667bcd6$var$window$1.location.search
        });
    }
};
var $7341c7289667bcd6$var$cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};
// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var $7341c7289667bcd6$var$SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var $7341c7289667bcd6$var$DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */ var $7341c7289667bcd6$var$extract_domain = function(hostname) {
    var domain_regex = $7341c7289667bcd6$var$DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') domain_regex = $7341c7289667bcd6$var$SIMPLE_DOMAIN_MATCH_REGEX;
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};
var $7341c7289667bcd6$var$JSONStringify = null;
var $7341c7289667bcd6$var$JSONParse = null;
if (typeof JSON !== 'undefined') {
    $7341c7289667bcd6$var$JSONStringify = JSON.stringify;
    $7341c7289667bcd6$var$JSONParse = JSON.parse;
}
$7341c7289667bcd6$var$JSONStringify = $7341c7289667bcd6$var$JSONStringify || $7341c7289667bcd6$var$_.JSONEncode;
$7341c7289667bcd6$var$JSONParse = $7341c7289667bcd6$var$JSONParse || $7341c7289667bcd6$var$_.JSONDecode;
// EXPORTS (for closure compiler)
$7341c7289667bcd6$var$_['toArray'] = $7341c7289667bcd6$var$_.toArray;
$7341c7289667bcd6$var$_['isObject'] = $7341c7289667bcd6$var$_.isObject;
$7341c7289667bcd6$var$_['JSONEncode'] = $7341c7289667bcd6$var$_.JSONEncode;
$7341c7289667bcd6$var$_['JSONDecode'] = $7341c7289667bcd6$var$_.JSONDecode;
$7341c7289667bcd6$var$_['isBlockedUA'] = $7341c7289667bcd6$var$_.isBlockedUA;
$7341c7289667bcd6$var$_['isEmptyObject'] = $7341c7289667bcd6$var$_.isEmptyObject;
$7341c7289667bcd6$var$_['info'] = $7341c7289667bcd6$var$_.info;
$7341c7289667bcd6$var$_['info']['device'] = $7341c7289667bcd6$var$_.info.device;
$7341c7289667bcd6$var$_['info']['browser'] = $7341c7289667bcd6$var$_.info.browser;
$7341c7289667bcd6$var$_['info']['browserVersion'] = $7341c7289667bcd6$var$_.info.browserVersion;
$7341c7289667bcd6$var$_['info']['properties'] = $7341c7289667bcd6$var$_.info.properties;
/**
 * DomTracker Object
 * @constructor
 */ var $7341c7289667bcd6$var$DomTracker = function() {};
// interface
$7341c7289667bcd6$var$DomTracker.prototype.create_properties = function() {};
$7341c7289667bcd6$var$DomTracker.prototype.event_handler = function() {};
$7341c7289667bcd6$var$DomTracker.prototype.after_track_handler = function() {};
$7341c7289667bcd6$var$DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};
/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */ $7341c7289667bcd6$var$DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = $7341c7289667bcd6$var$_.dom_query(query);
    if (elements.length === 0) {
        $7341c7289667bcd6$var$console.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }
    $7341c7289667bcd6$var$_.each(elements, function(element) {
        $7341c7289667bcd6$var$_.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');
            that.event_handler(e, this, options);
            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);
            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);
    return true;
};
/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */ $7341c7289667bcd6$var$DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;
    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) return;
        options.callback_fired = true;
        if (user_callback && user_callback(timeout_occured, props) === false) // user can prevent the default functionality by
        // returning false from their callback
        return;
        that.after_track_handler(props, options, timeout_occured);
    };
};
$7341c7289667bcd6$var$DomTracker.prototype.create_properties = function(properties, element) {
    var props;
    if (typeof properties === 'function') props = properties(element);
    else props = $7341c7289667bcd6$var$_.extend({}, properties);
    return props;
};
/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */ var $7341c7289667bcd6$var$LinkTracker = function() {
    this.override_event = 'click';
};
$7341c7289667bcd6$var$_.inherit($7341c7289667bcd6$var$LinkTracker, $7341c7289667bcd6$var$DomTracker);
$7341c7289667bcd6$var$LinkTracker.prototype.create_properties = function(properties, element) {
    var props = $7341c7289667bcd6$var$LinkTracker.superclass.create_properties.apply(this, arguments);
    if (element.href) props['url'] = element.href;
    return props;
};
$7341c7289667bcd6$var$LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = evt.which === 2 || evt.metaKey || evt.ctrlKey || element.target === '_blank';
    options.href = element.href;
    if (!options.new_tab) evt.preventDefault();
};
$7341c7289667bcd6$var$LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) return;
    setTimeout(function() {
        window.location = options.href;
    }, 0);
};
/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */ var $7341c7289667bcd6$var$FormTracker = function() {
    this.override_event = 'submit';
};
$7341c7289667bcd6$var$_.inherit($7341c7289667bcd6$var$FormTracker, $7341c7289667bcd6$var$DomTracker);
$7341c7289667bcd6$var$FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};
$7341c7289667bcd6$var$FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};
// eslint-disable-line camelcase
var $7341c7289667bcd6$var$logger$2 = $7341c7289667bcd6$var$console_with_prefix('lock');
/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */ var $7341c7289667bcd6$var$SharedLock = function(key, options) {
    options = options || {};
    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};
// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
$7341c7289667bcd6$var$SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== 'function') {
        pid = errorCB;
        errorCB = null;
    }
    var i = pid || new Date().getTime() + '|' + Math.random();
    var startTime = new Date().getTime();
    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;
    var keyX = key + ':X';
    var keyY = key + ':Y';
    var keyZ = key + ':Z';
    var reportError = function(err) {
        errorCB && errorCB(err);
    };
    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            $7341c7289667bcd6$var$logger$2.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch (err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };
    var waitFor = function(predicate, cb) {
        if (predicate()) cb();
        else delay(function() {
            waitFor(predicate, cb);
        });
    };
    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) return false;
        else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) return true;
            else {
                if (!$7341c7289667bcd6$var$localStorageSupported(storage, true)) throw new Error('localStorage support dropped while acquiring lock');
                return false;
            }
        }
    };
    var loop = function() {
        storage.setItem(keyX, i);
        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }
            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };
    var criticalSection = function() {
        storage.setItem(keyZ, '1');
        try {
            lockedCB();
        } finally{
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) storage.removeItem(keyY);
            if (storage.getItem(keyX) === i) storage.removeItem(keyX);
        }
    };
    try {
        if ($7341c7289667bcd6$var$localStorageSupported(storage, true)) loop();
        else throw new Error('localStorage support check failed');
    } catch (err) {
        reportError(err);
    }
};
// eslint-disable-line camelcase
var $7341c7289667bcd6$var$logger$1 = $7341c7289667bcd6$var$console_with_prefix('batch');
/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */ var $7341c7289667bcd6$var$RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || $7341c7289667bcd6$var$_.bind($7341c7289667bcd6$var$logger$1.error, $7341c7289667bcd6$var$logger$1);
    this.lock = new $7341c7289667bcd6$var$SharedLock(storageKey, {
        storage: this.storage
    });
    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios
    this.memQueue = [];
};
/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */ $7341c7289667bcd6$var$RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        'id': $7341c7289667bcd6$var$cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };
    this.lock.withLock($7341c7289667bcd6$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) // only add to in-memory queue when storage succeeds
            this.memQueue.push(queueEntry);
        } catch (err) {
            this.reportError('Error enqueueing item', item);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $7341c7289667bcd6$var$_.bind(function lockFailure(err) {
        this.reportError('Error acquiring storage lock', err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */ $7341c7289667bcd6$var$RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            $7341c7289667bcd6$var$_.each(batch, function(item) {
                idsInBatch[item['id']] = true;
            });
            for(var i = 0; i < storedQueue.length; i++){
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) break;
                }
            }
        }
    }
    return batch;
};
/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */ var $7341c7289667bcd6$var$filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    $7341c7289667bcd6$var$_.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) filteredItems.push(item);
    });
    return filteredItems;
};
/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */ $7341c7289667bcd6$var$RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    $7341c7289667bcd6$var$_.each(ids, function(id) {
        idSet[id] = true;
    });
    this.memQueue = $7341c7289667bcd6$var$filterOutIDsAndInvalid(this.memQueue, idSet);
    var removeFromStorage = $7341c7289667bcd6$var$_.bind(function() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $7341c7289667bcd6$var$filterOutIDsAndInvalid(storedQueue, idSet);
            succeeded = this.saveToStorage(storedQueue);
            // an extra check: did storage report success but somehow
            // the items are still there?
            if (succeeded) {
                storedQueue = this.readFromStorage();
                for(var i = 0; i < storedQueue.length; i++){
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) {
                        this.reportError('Item not removed from storage');
                        return false;
                    }
                }
            }
        } catch (err) {
            this.reportError('Error removing items', ids);
            succeeded = false;
        }
        return succeeded;
    }, this);
    this.lock.withLock(function lockAcquired() {
        var succeeded = removeFromStorage();
        if (cb) cb(succeeded);
    }, $7341c7289667bcd6$var$_.bind(function lockFailure(err) {
        var succeeded = false;
        this.reportError('Error acquiring storage lock', err);
        if (!$7341c7289667bcd6$var$localStorageSupported(this.storage, true)) {
            // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            succeeded = removeFromStorage();
            if (!succeeded) // OK, we couldn't even write out the smaller queue. Try clearing it
            // entirely.
            try {
                this.storage.removeItem(this.storageKey);
            } catch (err) {
                this.reportError('Error clearing queue', err);
            }
        }
        if (cb) cb(succeeded);
    }, this), this.pid);
};
// internal helper for RequestQueue.updatePayloads
var $7341c7289667bcd6$var$updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    $7341c7289667bcd6$var$_.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else // no update
        newItems.push(item);
    });
    return newItems;
};
/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */ $7341c7289667bcd6$var$RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = $7341c7289667bcd6$var$updatePayloads(this.memQueue, itemsToUpdate);
    this.lock.withLock($7341c7289667bcd6$var$_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = $7341c7289667bcd6$var$updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch (err) {
            this.reportError('Error updating items', itemsToUpdate);
            succeeded = false;
        }
        if (cb) cb(succeeded);
    }, this), $7341c7289667bcd6$var$_.bind(function lockFailure(err) {
        this.reportError('Error acquiring storage lock', err);
        if (cb) cb(false);
    }, this), this.pid);
};
/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */ $7341c7289667bcd6$var$RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = $7341c7289667bcd6$var$JSONParse(storageEntry);
            if (!$7341c7289667bcd6$var$_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError('Error retrieving queue', err);
        storageEntry = null;
    }
    return storageEntry || [];
};
/**
 * Serialize the given items array to localStorage.
 */ $7341c7289667bcd6$var$RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, $7341c7289667bcd6$var$JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError('Error saving queue', err);
        return false;
    }
};
/**
 * Clear out queues (memory and localStorage).
 */ $7341c7289667bcd6$var$RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    this.storage.removeItem(this.storageKey);
};
// eslint-disable-line camelcase
// maximum interval between request retries after exponential backoff
var $7341c7289667bcd6$var$MAX_RETRY_INTERVAL_MS = 600000; // 10 minutes
var $7341c7289667bcd6$var$logger = $7341c7289667bcd6$var$console_with_prefix('batch');
/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */ var $7341c7289667bcd6$var$RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new $7341c7289667bcd6$var$RequestQueue(storageKey, {
        errorReporter: $7341c7289667bcd6$var$_.bind(this.reportError, this),
        storage: options.storage
    });
    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;
    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];
    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;
    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
};
/**
 * Add one item to queue.
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};
/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};
/**
 * Stop flushing batches. Can be restarted by calling start().
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};
/**
 * Clear out queue.
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};
/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};
/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};
/**
 * Schedule the next flush in the given number of milliseconds.
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) this.timeoutID = setTimeout($7341c7289667bcd6$var$_.bind(this.flush, this), this.flushInterval);
};
/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.flush = function(options) {
    try {
        if (this.requestInProgress) {
            $7341c7289667bcd6$var$logger.log('Flush: Request already in progress');
            return;
        }
        options = options || {};
        var timeoutMS = this.libConfig['batch_request_timeout_ms'];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        var dataForRequest = [];
        var transformedItems = {};
        $7341c7289667bcd6$var$_.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) payload = this.beforeSendHook(payload);
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) payload['properties'] = $7341c7289667bcd6$var$_.extend({}, payload['properties'], {
                    'mp_sent_by_lib_version': $7341c7289667bcd6$var$Config.LIB_VERSION
                });
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else this.reportError('[dupe] found item with no ID', {
                    item: item
                });
                if (addPayload) dataForRequest.push(payload);
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }
        this.requestInProgress = true;
        var batchSendCallback = $7341c7289667bcd6$var$_.bind(function(res) {
            this.requestInProgress = false;
            try {
                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong
                var removeItemsFromQueue = false;
                if (options.unloading) // update persisted data to include hook transformations
                this.queue.updatePayloads(transformedItems);
                else if ($7341c7289667bcd6$var$_.isObject(res) && res.error === 'timeout' && new Date().getTime() - startTime >= timeoutMS) {
                    this.reportError('Network timeout; retrying');
                    this.flush();
                } else if ($7341c7289667bcd6$var$_.isObject(res) && res.xhr_req && (res.xhr_req['status'] >= 500 || res.xhr_req['status'] === 429 || res.error === 'timeout')) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    var headers = res.xhr_req['responseHeaders'];
                    if (headers) {
                        var retryAfter = headers['Retry-After'];
                        if (retryAfter) retryMS = parseInt(retryAfter, 10) * 1000 || retryMS;
                    }
                    retryMS = Math.min($7341c7289667bcd6$var$MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                } else if ($7341c7289667bcd6$var$_.isObject(res) && res.xhr_req && res.xhr_req['status'] === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else // successful network request+response; remove each item in batch from queue
                // (even if it was e.g. a 400, in which case retrying won't help)
                removeItemsFromQueue = true;
                if (removeItemsFromQueue) {
                    this.queue.removeItemsByID($7341c7289667bcd6$var$_.map(batch, function(item) {
                        return item['id'];
                    }), $7341c7289667bcd6$var$_.bind(function(succeeded) {
                        if (succeeded) {
                            this.consecutiveRemovalFailures = 0;
                            this.flush(); // handle next batch if the queue isn't empty
                        } else {
                            this.reportError('Failed to remove items from queue');
                            if (++this.consecutiveRemovalFailures > 5) {
                                this.reportError('Too many queue failures; disabling batching system.');
                                this.stopAllBatching();
                            } else this.resetFlush();
                        }
                    }, this));
                    // client-side dedupe
                    $7341c7289667bcd6$var$_.each(batch, $7341c7289667bcd6$var$_.bind(function(item) {
                        var itemId = item['id'];
                        if (itemId) {
                            this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                            this.itemIdsSentSuccessfully[itemId]++;
                            if (this.itemIdsSentSuccessfully[itemId] > 5) this.reportError('[dupe] item ID sent too many times', {
                                item: item,
                                batchSize: batch.length,
                                timesSent: this.itemIdsSentSuccessfully[itemId]
                            });
                        } else this.reportError('[dupe] found item with no ID while removing', {
                            item: item
                        });
                    }, this));
                }
            } catch (err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true,
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) requestOptions.transport = 'sendBeacon';
        $7341c7289667bcd6$var$logger.log('MIXPANEL REQUEST:', dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);
    } catch (err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }
};
/**
 * Log error to global logger and optional user-defined logger.
 */ $7341c7289667bcd6$var$RequestBatcher.prototype.reportError = function(msg, err) {
    $7341c7289667bcd6$var$logger.error.apply($7341c7289667bcd6$var$logger.error, arguments);
    if (this.errorReporter) try {
        if (!(err instanceof Error)) err = new Error(msg);
        this.errorReporter(msg, err);
    } catch (err) {
        $7341c7289667bcd6$var$logger.error(err);
    }
};
/**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */ /** Public **/ var $7341c7289667bcd6$var$GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';
/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $7341c7289667bcd6$var$optIn(token, options) {
    $7341c7289667bcd6$var$_optInOut(true, token, options);
}
/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */ function $7341c7289667bcd6$var$optOut(token, options) {
    $7341c7289667bcd6$var$_optInOut(false, token, options);
}
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */ function $7341c7289667bcd6$var$hasOptedIn(token, options) {
    return $7341c7289667bcd6$var$_getStorageValue(token, options) === '1';
}
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */ function $7341c7289667bcd6$var$hasOptedOut(token, options) {
    if ($7341c7289667bcd6$var$_hasDoNotTrackFlagOn(options)) {
        $7341c7289667bcd6$var$console.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = $7341c7289667bcd6$var$_getStorageValue(token, options) === '0';
    if (optedOut) $7341c7289667bcd6$var$console.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    return optedOut;
}
/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $7341c7289667bcd6$var$addOptOutCheckMixpanelLib(method) {
    return $7341c7289667bcd6$var$_addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}
/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(method) {
    return $7341c7289667bcd6$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $7341c7289667bcd6$var$addOptOutCheckMixpanelGroup(method) {
    return $7341c7289667bcd6$var$_addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $7341c7289667bcd6$var$clearOptInOut(token, options) {
    options = options || {};
    $7341c7289667bcd6$var$_getStorage(options).remove($7341c7289667bcd6$var$_getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain);
}
/** Private **/ /**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */ function $7341c7289667bcd6$var$_getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? $7341c7289667bcd6$var$_.localStorage : $7341c7289667bcd6$var$_.cookie;
}
/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */ function $7341c7289667bcd6$var$_getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || $7341c7289667bcd6$var$GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}
/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */ function $7341c7289667bcd6$var$_getStorageValue(token, options) {
    return $7341c7289667bcd6$var$_getStorage(options).get($7341c7289667bcd6$var$_getStorageKey(token, options));
}
/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */ function $7341c7289667bcd6$var$_hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) return false;
    var win = options && options.window || $7341c7289667bcd6$var$window$1;
    var nav = win['navigator'] || {};
    var hasDntOn = false;
    $7341c7289667bcd6$var$_.each([
        nav['doNotTrack'],
        nav['msDoNotTrack'],
        win['doNotTrack']
    ], function(dntValue) {
        if ($7341c7289667bcd6$var$_.includes([
            true,
            1,
            '1',
            'yes'
        ], dntValue)) hasDntOn = true;
    });
    return hasDntOn;
}
/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */ function $7341c7289667bcd6$var$_optInOut(optValue, token, options) {
    if (!$7341c7289667bcd6$var$_.isString(token) || !token.length) {
        $7341c7289667bcd6$var$console.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }
    options = options || {};
    $7341c7289667bcd6$var$_getStorage(options).set($7341c7289667bcd6$var$_getStorageKey(token, options), optValue ? 1 : 0, $7341c7289667bcd6$var$_.isNumber(options.cookieExpiration) ? options.cookieExpiration : null, !!options.crossSubdomainCookie, !!options.secureCookie, !!options.crossSiteCookie, options.cookieDomain);
    if (options.track && optValue) options.track(options.trackEventName || '$opt_in', options.trackProperties, {
        'send_immediately': true
    });
}
/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */ function $7341c7289667bcd6$var$_addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;
        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests
            if (token) optedOut = $7341c7289667bcd6$var$hasOptedOut(token, {
                ignoreDnt: ignoreDnt,
                persistenceType: persistenceType,
                persistencePrefix: persistencePrefix,
                window: win
            });
        } catch (err) {
            $7341c7289667bcd6$var$console.error('Unexpected error when checking tracking opt-out status: ' + err);
        }
        if (!optedOut) return method.apply(this, arguments);
        var callback = arguments[arguments.length - 1];
        if (typeof callback === 'function') callback(0);
        return;
    };
}
/** @const */ var $7341c7289667bcd6$var$SET_ACTION = '$set';
/** @const */ var $7341c7289667bcd6$var$SET_ONCE_ACTION = '$set_once';
/** @const */ var $7341c7289667bcd6$var$UNSET_ACTION = '$unset';
/** @const */ var $7341c7289667bcd6$var$ADD_ACTION = '$add';
/** @const */ var $7341c7289667bcd6$var$APPEND_ACTION = '$append';
/** @const */ var $7341c7289667bcd6$var$UNION_ACTION = '$union';
/** @const */ var $7341c7289667bcd6$var$REMOVE_ACTION = '$remove';
/** @const */ var $7341c7289667bcd6$var$DELETE_ACTION = '$delete';
// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var $7341c7289667bcd6$var$apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if ($7341c7289667bcd6$var$_.isObject(prop)) $7341c7289667bcd6$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set[k] = v;
        }, this);
        else $set[prop] = to;
        data[$7341c7289667bcd6$var$SET_ACTION] = $set;
        return data;
    },
    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!$7341c7289667bcd6$var$_.isArray(prop)) prop = [
            prop
        ];
        $7341c7289667bcd6$var$_.each(prop, function(k) {
            if (!this._is_reserved_property(k)) $unset.push(k);
        }, this);
        data[$7341c7289667bcd6$var$UNSET_ACTION] = $unset;
        return data;
    },
    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if ($7341c7289667bcd6$var$_.isObject(prop)) $7341c7289667bcd6$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) $set_once[k] = v;
        }, this);
        else $set_once[prop] = to;
        data[$7341c7289667bcd6$var$SET_ONCE_ACTION] = $set_once;
        return data;
    },
    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if ($7341c7289667bcd6$var$_.isObject(list_name)) $7341c7289667bcd6$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $union[k] = $7341c7289667bcd6$var$_.isArray(v) ? v : [
                v
            ];
        }, this);
        else $union[list_name] = $7341c7289667bcd6$var$_.isArray(values) ? values : [
            values
        ];
        data[$7341c7289667bcd6$var$UNION_ACTION] = $union;
        return data;
    },
    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if ($7341c7289667bcd6$var$_.isObject(list_name)) $7341c7289667bcd6$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $append[k] = v;
        }, this);
        else $append[list_name] = value;
        data[$7341c7289667bcd6$var$APPEND_ACTION] = $append;
        return data;
    },
    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if ($7341c7289667bcd6$var$_.isObject(list_name)) $7341c7289667bcd6$var$_.each(list_name, function(v, k) {
            if (!this._is_reserved_property(k)) $remove[k] = v;
        }, this);
        else $remove[list_name] = value;
        data[$7341c7289667bcd6$var$REMOVE_ACTION] = $remove;
        return data;
    },
    delete_action: function() {
        var data = {};
        data[$7341c7289667bcd6$var$DELETE_ACTION] = '';
        return data;
    }
};
/**
 * Mixpanel Group Object
 * @constructor
 */ var $7341c7289667bcd6$var$MixpanelGroup = function() {};
$7341c7289667bcd6$var$_.extend($7341c7289667bcd6$var$MixpanelGroup.prototype, $7341c7289667bcd6$var$apiActions);
$7341c7289667bcd6$var$MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};
/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $7341c7289667bcd6$var$MixpanelGroup.prototype.set = $7341c7289667bcd6$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($7341c7289667bcd6$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $7341c7289667bcd6$var$MixpanelGroup.prototype.set_once = $7341c7289667bcd6$var$addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($7341c7289667bcd6$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $7341c7289667bcd6$var$MixpanelGroup.prototype.unset = $7341c7289667bcd6$var$addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $7341c7289667bcd6$var$MixpanelGroup.prototype.union = $7341c7289667bcd6$var$addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if ($7341c7289667bcd6$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $7341c7289667bcd6$var$MixpanelGroup.prototype['delete'] = $7341c7289667bcd6$var$addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});
/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */ $7341c7289667bcd6$var$MixpanelGroup.prototype.remove = $7341c7289667bcd6$var$addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
$7341c7289667bcd6$var$MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');
    var date_encoded_data = $7341c7289667bcd6$var$_.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/groups/',
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};
$7341c7289667bcd6$var$MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};
$7341c7289667bcd6$var$MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};
$7341c7289667bcd6$var$MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};
// MixpanelGroup Exports
$7341c7289667bcd6$var$MixpanelGroup.prototype['remove'] = $7341c7289667bcd6$var$MixpanelGroup.prototype.remove;
$7341c7289667bcd6$var$MixpanelGroup.prototype['set'] = $7341c7289667bcd6$var$MixpanelGroup.prototype.set;
$7341c7289667bcd6$var$MixpanelGroup.prototype['set_once'] = $7341c7289667bcd6$var$MixpanelGroup.prototype.set_once;
$7341c7289667bcd6$var$MixpanelGroup.prototype['union'] = $7341c7289667bcd6$var$MixpanelGroup.prototype.union;
$7341c7289667bcd6$var$MixpanelGroup.prototype['unset'] = $7341c7289667bcd6$var$MixpanelGroup.prototype.unset;
$7341c7289667bcd6$var$MixpanelGroup.prototype['toString'] = $7341c7289667bcd6$var$MixpanelGroup.prototype.toString;
/**
 * Mixpanel People Object
 * @constructor
 */ var $7341c7289667bcd6$var$MixpanelPeople = function() {};
$7341c7289667bcd6$var$_.extend($7341c7289667bcd6$var$MixpanelPeople.prototype, $7341c7289667bcd6$var$apiActions);
$7341c7289667bcd6$var$MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};
/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $7341c7289667bcd6$var$MixpanelPeople.prototype.set = $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if ($7341c7289667bcd6$var$_.isObject(prop)) callback = to;
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) this._mixpanel['persistence'].update_referrer_info(document.referrer);
    // update $set object with default people properties
    data[$7341c7289667bcd6$var$SET_ACTION] = $7341c7289667bcd6$var$_.extend({}, $7341c7289667bcd6$var$_.info.people_properties(), this._mixpanel['persistence'].get_referrer_info(), data[$7341c7289667bcd6$var$SET_ACTION]);
    return this._send_request(data, callback);
});
/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $7341c7289667bcd6$var$MixpanelPeople.prototype.set_once = $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if ($7341c7289667bcd6$var$_.isObject(prop)) callback = to;
    return this._send_request(data, callback);
});
/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $7341c7289667bcd6$var$MixpanelPeople.prototype.unset = $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});
/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $7341c7289667bcd6$var$MixpanelPeople.prototype.increment = $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if ($7341c7289667bcd6$var$_.isObject(prop)) {
        $7341c7289667bcd6$var$_.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    $7341c7289667bcd6$var$console.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else $add[k] = v;
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if ($7341c7289667bcd6$var$_.isUndefined(by)) by = 1;
        $add[prop] = by;
    }
    data[$7341c7289667bcd6$var$ADD_ACTION] = $add;
    return this._send_request(data, callback);
});
/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $7341c7289667bcd6$var$MixpanelPeople.prototype.append = $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($7341c7289667bcd6$var$_.isObject(list_name)) callback = value;
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $7341c7289667bcd6$var$MixpanelPeople.prototype.remove = $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if ($7341c7289667bcd6$var$_.isObject(list_name)) callback = value;
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});
/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/ $7341c7289667bcd6$var$MixpanelPeople.prototype.union = $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if ($7341c7289667bcd6$var$_.isObject(list_name)) callback = values;
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});
/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */ $7341c7289667bcd6$var$MixpanelPeople.prototype.track_charge = $7341c7289667bcd6$var$addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!$7341c7289667bcd6$var$_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            $7341c7289667bcd6$var$console.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }
    return this.append('$transactions', $7341c7289667bcd6$var$_.extend({
        '$amount': amount
    }, properties), callback);
});
/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */ $7341c7289667bcd6$var$MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};
/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/ $7341c7289667bcd6$var$MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        $7341c7289667bcd6$var$console.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {
        '$delete': this._mixpanel.get_distinct_id()
    };
    return this._send_request(data);
};
$7341c7289667bcd6$var$MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};
$7341c7289667bcd6$var$MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) data['$device_id'] = device_id;
    if (user_id) data['$user_id'] = user_id;
    if (had_persisted_distinct_id) data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    var date_encoded_data = $7341c7289667bcd6$var$_.encodeDates(data);
    if (!this._identify_called()) {
        this._enqueue(data);
        if (!$7341c7289667bcd6$var$_.isUndefined(callback)) {
            if (this._get_config('verbose')) callback({
                status: -1,
                error: null
            });
            else callback(-1);
        }
        return $7341c7289667bcd6$var$_.truncate(date_encoded_data, 255);
    }
    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/engage/',
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};
$7341c7289667bcd6$var$MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};
$7341c7289667bcd6$var$MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};
// Queue up engage operations if identify hasn't been called yet.
$7341c7289667bcd6$var$MixpanelPeople.prototype._enqueue = function(data) {
    if ($7341c7289667bcd6$var$SET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$SET_ACTION, data);
    else if ($7341c7289667bcd6$var$SET_ONCE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$SET_ONCE_ACTION, data);
    else if ($7341c7289667bcd6$var$UNSET_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$UNSET_ACTION, data);
    else if ($7341c7289667bcd6$var$ADD_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$ADD_ACTION, data);
    else if ($7341c7289667bcd6$var$APPEND_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$APPEND_ACTION, data);
    else if ($7341c7289667bcd6$var$REMOVE_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$REMOVE_ACTION, data);
    else if ($7341c7289667bcd6$var$UNION_ACTION in data) this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$UNION_ACTION, data);
    else $7341c7289667bcd6$var$console.error('Invalid call to _enqueue():', data);
};
$7341c7289667bcd6$var$MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = $7341c7289667bcd6$var$_.extend({}, this._mixpanel['persistence']._get_queue(action));
    var action_params = queued_data;
    if (!$7341c7289667bcd6$var$_.isUndefined(queued_data) && $7341c7289667bcd6$var$_.isObject(queued_data) && !$7341c7289667bcd6$var$_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        if (queue_to_params_fn) action_params = queue_to_params_fn(queued_data);
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            if (!$7341c7289667bcd6$var$_.isUndefined(callback)) callback(response, data);
        });
    }
};
// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
$7341c7289667bcd6$var$MixpanelPeople.prototype._flush = function(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    var _this = this;
    var $append_queue = this._mixpanel['persistence']._get_queue($7341c7289667bcd6$var$APPEND_ACTION);
    var $remove_queue = this._mixpanel['persistence']._get_queue($7341c7289667bcd6$var$REMOVE_ACTION);
    this._flush_one_queue($7341c7289667bcd6$var$SET_ACTION, this.set, _set_callback);
    this._flush_one_queue($7341c7289667bcd6$var$SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue($7341c7289667bcd6$var$UNSET_ACTION, this.unset, _unset_callback, function(queue) {
        return $7341c7289667bcd6$var$_.keys(queue);
    });
    this._flush_one_queue($7341c7289667bcd6$var$ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue($7341c7289667bcd6$var$UNION_ACTION, this.union, _union_callback);
    // we have to fire off each $append individually since there is
    // no concat method server side
    if (!$7341c7289667bcd6$var$_.isUndefined($append_queue) && $7341c7289667bcd6$var$_.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$APPEND_ACTION, $append_item);
            if (!$7341c7289667bcd6$var$_.isUndefined(_append_callback)) _append_callback(response, data);
        };
        for(var i = $append_queue.length - 1; i >= 0; i--){
            $append_item = $append_queue.pop();
            if (!$7341c7289667bcd6$var$_.isEmptyObject($append_item)) _this.append($append_item, append_callback);
        }
        // Save the shortened append queue
        _this._mixpanel['persistence'].save();
    }
    // same for $remove
    if (!$7341c7289667bcd6$var$_.isUndefined($remove_queue) && $7341c7289667bcd6$var$_.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) _this._mixpanel['persistence']._add_to_people_queue($7341c7289667bcd6$var$REMOVE_ACTION, $remove_item);
            if (!$7341c7289667bcd6$var$_.isUndefined(_remove_callback)) _remove_callback(response, data);
        };
        for(var j = $remove_queue.length - 1; j >= 0; j--){
            $remove_item = $remove_queue.pop();
            if (!$7341c7289667bcd6$var$_.isEmptyObject($remove_item)) _this.remove($remove_item, remove_callback);
        }
        _this._mixpanel['persistence'].save();
    }
};
$7341c7289667bcd6$var$MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};
// MixpanelPeople Exports
$7341c7289667bcd6$var$MixpanelPeople.prototype['set'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.set;
$7341c7289667bcd6$var$MixpanelPeople.prototype['set_once'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.set_once;
$7341c7289667bcd6$var$MixpanelPeople.prototype['unset'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.unset;
$7341c7289667bcd6$var$MixpanelPeople.prototype['increment'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.increment;
$7341c7289667bcd6$var$MixpanelPeople.prototype['append'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.append;
$7341c7289667bcd6$var$MixpanelPeople.prototype['remove'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.remove;
$7341c7289667bcd6$var$MixpanelPeople.prototype['union'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.union;
$7341c7289667bcd6$var$MixpanelPeople.prototype['track_charge'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.track_charge;
$7341c7289667bcd6$var$MixpanelPeople.prototype['clear_charges'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.clear_charges;
$7341c7289667bcd6$var$MixpanelPeople.prototype['delete_user'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.delete_user;
$7341c7289667bcd6$var$MixpanelPeople.prototype['toString'] = $7341c7289667bcd6$var$MixpanelPeople.prototype.toString;
/*
 * Constants
 */ /** @const */ var $7341c7289667bcd6$var$SET_QUEUE_KEY = '__mps';
/** @const */ var $7341c7289667bcd6$var$SET_ONCE_QUEUE_KEY = '__mpso';
/** @const */ var $7341c7289667bcd6$var$UNSET_QUEUE_KEY = '__mpus';
/** @const */ var $7341c7289667bcd6$var$ADD_QUEUE_KEY = '__mpa';
/** @const */ var $7341c7289667bcd6$var$APPEND_QUEUE_KEY = '__mpap';
/** @const */ var $7341c7289667bcd6$var$REMOVE_QUEUE_KEY = '__mpr';
/** @const */ var $7341c7289667bcd6$var$UNION_QUEUE_KEY = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var $7341c7289667bcd6$var$PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var $7341c7289667bcd6$var$ALIAS_ID_KEY = '__alias';
/** @const */ var $7341c7289667bcd6$var$EVENT_TIMERS_KEY = '__timers';
/** @const */ var $7341c7289667bcd6$var$RESERVED_PROPERTIES = [
    $7341c7289667bcd6$var$SET_QUEUE_KEY,
    $7341c7289667bcd6$var$SET_ONCE_QUEUE_KEY,
    $7341c7289667bcd6$var$UNSET_QUEUE_KEY,
    $7341c7289667bcd6$var$ADD_QUEUE_KEY,
    $7341c7289667bcd6$var$APPEND_QUEUE_KEY,
    $7341c7289667bcd6$var$REMOVE_QUEUE_KEY,
    $7341c7289667bcd6$var$UNION_QUEUE_KEY,
    $7341c7289667bcd6$var$PEOPLE_DISTINCT_ID_KEY,
    $7341c7289667bcd6$var$ALIAS_ID_KEY,
    $7341c7289667bcd6$var$EVENT_TIMERS_KEY
];
/**
 * Mixpanel Persistence Object
 * @constructor
 */ var $7341c7289667bcd6$var$MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;
    if (config['persistence_name']) this.name = 'mp_' + config['persistence_name'];
    else this.name = 'mp_' + config['token'] + '_mixpanel';
    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        $7341c7289667bcd6$var$console.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }
    if (storage_type === 'localStorage' && $7341c7289667bcd6$var$_.localStorage.is_supported()) this.storage = $7341c7289667bcd6$var$_.localStorage;
    else this.storage = $7341c7289667bcd6$var$_.cookie;
    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.properties = function() {
    var p = {};
    // Filter out reserved properties
    $7341c7289667bcd6$var$_.each(this['props'], function(v, k) {
        if (!$7341c7289667bcd6$var$_.include($7341c7289667bcd6$var$RESERVED_PROPERTIES, k)) p[k] = v;
    });
    return p;
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.load = function() {
    if (this.disabled) return;
    var entry = this.storage.parse(this.name);
    if (entry) this['props'] = $7341c7289667bcd6$var$_.extend({}, entry);
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config['upgrade'], old_cookie_name, old_cookie;
    if (upgrade_from_old_lib) {
        old_cookie_name = 'mp_super_properties';
        // Case where they had a custom cookie name before.
        if (typeof upgrade_from_old_lib === 'string') old_cookie_name = upgrade_from_old_lib;
        old_cookie = this.storage.parse(old_cookie_name);
        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);
        if (old_cookie) this['props'] = $7341c7289667bcd6$var$_.extend(this['props'], old_cookie['all'], old_cookie['events']);
    }
    if (!config['cookie_name'] && config['name'] !== 'mixpanel') {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = 'mp_' + config['token'] + '_' + config['name'];
        old_cookie = this.storage.parse(old_cookie_name);
        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);
            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }
    if (this.storage === $7341c7289667bcd6$var$_.localStorage) {
        old_cookie = $7341c7289667bcd6$var$_.cookie.parse(this.name);
        $7341c7289667bcd6$var$_.cookie.remove(this.name);
        $7341c7289667bcd6$var$_.cookie.remove(this.name, true);
        if (old_cookie) this.register_once(old_cookie);
    }
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.save = function() {
    if (this.disabled) return;
    this.storage.set(this.name, $7341c7289667bcd6$var$_.JSONEncode(this['props']), this.expire_days, this.cross_subdomain, this.secure, this.cross_site, this.cookie_domain);
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};
// removes the storage entry and deletes all loaded data
// forced name for tests
$7341c7289667bcd6$var$MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};
/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/ $7341c7289667bcd6$var$MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if ($7341c7289667bcd6$var$_.isObject(props)) {
        if (typeof default_value === 'undefined') default_value = 'None';
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        $7341c7289667bcd6$var$_.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) this['props'][prop] = val;
        }, this);
        this.save();
        return true;
    }
    return false;
};
/**
* @param {Object} props
* @param {number=} days
*/ $7341c7289667bcd6$var$MixpanelPersistence.prototype.register = function(props, days) {
    if ($7341c7289667bcd6$var$_.isObject(props)) {
        this.expire_days = typeof days === 'undefined' ? this.default_expiry : days;
        $7341c7289667bcd6$var$_.extend(this['props'], props);
        this.save();
        return true;
    }
    return false;
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.unregister = function(prop) {
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register($7341c7289667bcd6$var$_.info.searchInfo(referrer));
};
// EXPORTED METHOD, we test this directly.
$7341c7289667bcd6$var$MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': $7341c7289667bcd6$var$_.info.referringDomain(referrer) || '$direct'
    }, '');
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.get_referrer_info = function() {
    return $7341c7289667bcd6$var$_.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};
// safely fills the passed in object with stored properties,
// does not override any properties defined in both
// returns the passed in object
$7341c7289667bcd6$var$MixpanelPersistence.prototype.safe_merge = function(props) {
    $7341c7289667bcd6$var$_.each(this['props'], function(val, prop) {
        if (!(prop in props)) props[prop] = val;
    });
    return props;
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) this.remove();
    else this.save();
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue), q_data = data[queue], set_q = this._get_or_create_queue($7341c7289667bcd6$var$SET_ACTION), set_once_q = this._get_or_create_queue($7341c7289667bcd6$var$SET_ONCE_ACTION), unset_q = this._get_or_create_queue($7341c7289667bcd6$var$UNSET_ACTION), add_q = this._get_or_create_queue($7341c7289667bcd6$var$ADD_ACTION), union_q = this._get_or_create_queue($7341c7289667bcd6$var$UNION_ACTION), remove_q = this._get_or_create_queue($7341c7289667bcd6$var$REMOVE_ACTION, []), append_q = this._get_or_create_queue($7341c7289667bcd6$var$APPEND_ACTION, []);
    if (q_key === $7341c7289667bcd6$var$SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        $7341c7289667bcd6$var$_.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue($7341c7289667bcd6$var$ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue($7341c7289667bcd6$var$UNION_ACTION, q_data);
        this._pop_from_people_queue($7341c7289667bcd6$var$UNSET_ACTION, q_data);
    } else if (q_key === $7341c7289667bcd6$var$SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        $7341c7289667bcd6$var$_.each(q_data, function(v, k) {
            if (!(k in set_once_q)) set_once_q[k] = v;
        });
        this._pop_from_people_queue($7341c7289667bcd6$var$UNSET_ACTION, q_data);
    } else if (q_key === $7341c7289667bcd6$var$UNSET_QUEUE_KEY) $7341c7289667bcd6$var$_.each(q_data, function(prop) {
        // undo previously-queued actions on this key
        $7341c7289667bcd6$var$_.each([
            set_q,
            set_once_q,
            add_q,
            union_q
        ], function(enqueued_obj) {
            if (prop in enqueued_obj) delete enqueued_obj[prop];
        });
        $7341c7289667bcd6$var$_.each(append_q, function(append_obj) {
            if (prop in append_obj) delete append_obj[prop];
        });
        unset_q[prop] = true;
    });
    else if (q_key === $7341c7289667bcd6$var$ADD_QUEUE_KEY) {
        $7341c7289667bcd6$var$_.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) set_q[k] += v;
            else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) add_q[k] = 0;
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue($7341c7289667bcd6$var$UNSET_ACTION, q_data);
    } else if (q_key === $7341c7289667bcd6$var$UNION_QUEUE_KEY) {
        $7341c7289667bcd6$var$_.each(q_data, function(v, k) {
            if ($7341c7289667bcd6$var$_.isArray(v)) {
                if (!(k in union_q)) union_q[k] = [];
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue($7341c7289667bcd6$var$UNSET_ACTION, q_data);
    } else if (q_key === $7341c7289667bcd6$var$REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue($7341c7289667bcd6$var$APPEND_ACTION, q_data);
    } else if (q_key === $7341c7289667bcd6$var$APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue($7341c7289667bcd6$var$UNSET_ACTION, q_data);
    }
    $7341c7289667bcd6$var$console.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    $7341c7289667bcd6$var$console.log(data);
    this.save();
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this._get_queue(queue);
    if (!$7341c7289667bcd6$var$_.isUndefined(q)) {
        $7341c7289667bcd6$var$_.each(data, function(v, k) {
            if (queue === $7341c7289667bcd6$var$APPEND_ACTION || queue === $7341c7289667bcd6$var$REMOVE_ACTION) // list actions: only remove if both k+v match
            // e.g. remove should not override append in a case like
            // append({foo: 'bar'}); remove({foo: 'qux'})
            $7341c7289667bcd6$var$_.each(q, function(queued_action) {
                if (queued_action[k] === v) delete queued_action[k];
            });
            else delete q[k];
        }, this);
        this.save();
    }
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === $7341c7289667bcd6$var$SET_ACTION) return $7341c7289667bcd6$var$SET_QUEUE_KEY;
    else if (queue === $7341c7289667bcd6$var$SET_ONCE_ACTION) return $7341c7289667bcd6$var$SET_ONCE_QUEUE_KEY;
    else if (queue === $7341c7289667bcd6$var$UNSET_ACTION) return $7341c7289667bcd6$var$UNSET_QUEUE_KEY;
    else if (queue === $7341c7289667bcd6$var$ADD_ACTION) return $7341c7289667bcd6$var$ADD_QUEUE_KEY;
    else if (queue === $7341c7289667bcd6$var$APPEND_ACTION) return $7341c7289667bcd6$var$APPEND_QUEUE_KEY;
    else if (queue === $7341c7289667bcd6$var$REMOVE_ACTION) return $7341c7289667bcd6$var$REMOVE_QUEUE_KEY;
    else if (queue === $7341c7289667bcd6$var$UNION_ACTION) return $7341c7289667bcd6$var$UNION_QUEUE_KEY;
    else $7341c7289667bcd6$var$console.error('Invalid queue:', queue);
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype._get_queue = function(queue) {
    return this['props'][this._get_queue_key(queue)];
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = $7341c7289667bcd6$var$_.isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this['props'][$7341c7289667bcd6$var$EVENT_TIMERS_KEY] || {};
    timers[event_name] = timestamp;
    this['props'][$7341c7289667bcd6$var$EVENT_TIMERS_KEY] = timers;
    this.save();
};
$7341c7289667bcd6$var$MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this['props'][$7341c7289667bcd6$var$EVENT_TIMERS_KEY] || {};
    var timestamp = timers[event_name];
    if (!$7341c7289667bcd6$var$_.isUndefined(timestamp)) {
        delete this['props'][$7341c7289667bcd6$var$EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};
/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */ // ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==
/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/ var $7341c7289667bcd6$var$init_type; // MODULE or SNIPPET loader
var $7341c7289667bcd6$var$mixpanel_master; // main mixpanel instance / object
var $7341c7289667bcd6$var$INIT_MODULE = 0;
var $7341c7289667bcd6$var$INIT_SNIPPET = 1;
var $7341c7289667bcd6$var$IDENTITY_FUNC = function(x) {
    return x;
};
var $7341c7289667bcd6$var$NOOP_FUNC = function() {};
/** @const */ var $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var $7341c7289667bcd6$var$PAYLOAD_TYPE_BASE64 = 'base64';
/** @const */ var $7341c7289667bcd6$var$PAYLOAD_TYPE_JSON = 'json';
/** @const */ var $7341c7289667bcd6$var$DEVICE_ID_PREFIX = '$device:';
/*
 * Dynamic... constants? Is that an oxymoron?
 */ // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var $7341c7289667bcd6$var$USE_XHR = $7341c7289667bcd6$var$window$1.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest();
// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var $7341c7289667bcd6$var$ENQUEUE_REQUESTS = !$7341c7289667bcd6$var$USE_XHR && $7341c7289667bcd6$var$userAgent.indexOf('MSIE') === -1 && $7341c7289667bcd6$var$userAgent.indexOf('Mozilla') === -1;
// save reference to navigator.sendBeacon so it can be minified
var $7341c7289667bcd6$var$sendBeacon = null;
if ($7341c7289667bcd6$var$navigator['sendBeacon']) $7341c7289667bcd6$var$sendBeacon = function() {
    // late reference to navigator.sendBeacon to allow patching/spying
    return $7341c7289667bcd6$var$navigator['sendBeacon'].apply($7341c7289667bcd6$var$navigator, arguments);
};
/*
 * Module-level globals
 */ var $7341c7289667bcd6$var$DEFAULT_CONFIG = {
    'api_host': 'https://api-js.mixpanel.com',
    'api_method': 'POST',
    'api_transport': 'XHR',
    'api_payload_format': $7341c7289667bcd6$var$PAYLOAD_TYPE_BASE64,
    'app_host': 'https://mixpanel.com',
    'cdn': 'https://cdn.mxpnl.com',
    'cross_site_cookie': false,
    'cross_subdomain_cookie': true,
    'error_reporter': $7341c7289667bcd6$var$NOOP_FUNC,
    'persistence': 'cookie',
    'persistence_name': '',
    'cookie_domain': '',
    'cookie_name': '',
    'loaded': $7341c7289667bcd6$var$NOOP_FUNC,
    'track_marketing': true,
    'track_pageview': false,
    'skip_first_touch_marketing': false,
    'store_google': true,
    'save_referrer': true,
    'test': false,
    'verbose': false,
    'img': false,
    'debug': false,
    'track_links_timeout': 300,
    'cookie_expiration': 365,
    'upgrade': false,
    'disable_persistence': false,
    'disable_cookie': false,
    'secure_cookie': false,
    'ip': true,
    'opt_out_tracking_by_default': false,
    'opt_out_persistence_by_default': false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix': null,
    'property_blacklist': [],
    'xhr_headers': {},
    'ignore_dnt': false,
    'batch_requests': true,
    'batch_size': 50,
    'batch_flush_interval_ms': 5000,
    'batch_request_timeout_ms': 90000,
    'batch_autostart': true,
    'hooks': {}
};
var $7341c7289667bcd6$var$DOM_LOADED = false;
/**
 * Mixpanel Library Object
 * @constructor
 */ var $7341c7289667bcd6$var$MixpanelLib = function() {};
/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */ var $7341c7289667bcd6$var$create_mplib = function(token, config, name) {
    var instance, target = name === $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME ? $7341c7289667bcd6$var$mixpanel_master : $7341c7289667bcd6$var$mixpanel_master[name];
    if (target && $7341c7289667bcd6$var$init_type === $7341c7289667bcd6$var$INIT_MODULE) instance = target;
    else {
        if (target && !$7341c7289667bcd6$var$_.isArray(target)) {
            $7341c7289667bcd6$var$console.error('You have already initialized ' + name);
            return;
        }
        instance = new $7341c7289667bcd6$var$MixpanelLib();
    }
    instance._cached_groups = {}; // cache groups in a pool
    instance._init(token, config, name);
    instance['people'] = new $7341c7289667bcd6$var$MixpanelPeople();
    instance['people']._init(instance);
    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = $7341c7289667bcd6$var$_.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        $7341c7289667bcd6$var$_.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) has_utm = true;
        });
        if (has_utm) instance['people'].set_once(initial_utm_params);
    }
    // if any instance on the page has debug = true, we set the
    // global debug to be true
    $7341c7289667bcd6$var$Config.DEBUG = $7341c7289667bcd6$var$Config.DEBUG || instance.get_config('debug');
    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!$7341c7289667bcd6$var$_.isUndefined(target) && $7341c7289667bcd6$var$_.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }
    return instance;
};
// Initialization methods
/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.init = function(token, config, name) {
    if ($7341c7289667bcd6$var$_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }
    var instance = $7341c7289667bcd6$var$create_mplib(token, config, name);
    $7341c7289667bcd6$var$mixpanel_master[name] = instance;
    instance._loaded();
    return instance;
};
// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
$7341c7289667bcd6$var$MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};
    this['__loaded'] = true;
    this['config'] = {};
    var variable_features = {};
    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || $7341c7289667bcd6$var$DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) variable_features['api_payload_format'] = $7341c7289667bcd6$var$PAYLOAD_TYPE_JSON;
    }
    this.set_config($7341c7289667bcd6$var$_.extend({}, $7341c7289667bcd6$var$DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': (name === $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME ? name : $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));
    this['_jsc'] = $7341c7289667bcd6$var$NOOP_FUNC;
    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };
    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!$7341c7289667bcd6$var$_.localStorage.is_supported(true) || !$7341c7289667bcd6$var$USE_XHR) {
            this._batch_requests = false;
            $7341c7289667bcd6$var$console.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
        } else {
            this.init_batchers();
            if ($7341c7289667bcd6$var$sendBeacon && $7341c7289667bcd6$var$window$1.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = $7341c7289667bcd6$var$_.bind(function() {
                    if (!this.request_batchers.events.stopped) this.request_batchers.events.flush({
                        unloading: true
                    });
                }, this);
                $7341c7289667bcd6$var$window$1.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) flush_on_unload();
                });
                $7341c7289667bcd6$var$window$1.addEventListener('visibilitychange', function() {
                    if ($7341c7289667bcd6$var$document$1['visibilityState'] === 'hidden') flush_on_unload();
                });
            }
        }
    }
    this['persistence'] = this['cookie'] = new $7341c7289667bcd6$var$MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();
    var uuid = $7341c7289667bcd6$var$_.UUID();
    if (!this.get_distinct_id()) // There is no need to set the distinct id
    // or the device id if something was already stored
    // in the persitence
    this.register_once({
        'distinct_id': $7341c7289667bcd6$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
    if (this.get_config('track_pageview')) this.track_pageview();
};
// Private methods
$7341c7289667bcd6$var$MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
};
// update persistence with info on referrer, UTM params, etc
$7341c7289667bcd6$var$MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword($7341c7289667bcd6$var$document$1.referrer);
    if (this.get_config('store_google')) this.register($7341c7289667bcd6$var$_.info.campaignParams(), {
        persistent: false
    });
    if (this.get_config('save_referrer')) this['persistence'].update_referrer_info($7341c7289667bcd6$var$document$1.referrer);
};
$7341c7289667bcd6$var$MixpanelLib.prototype._dom_loaded = function() {
    $7341c7289667bcd6$var$_.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);
    if (!this.has_opted_out_tracking()) $7341c7289667bcd6$var$_.each(this.__request_queue, function(item) {
        this._send_request.apply(this, item);
    }, this);
    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};
$7341c7289667bcd6$var$MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }
    if (!$7341c7289667bcd6$var$DOM_LOADED) {
        this.__dom_loaded_queue.push([
            DomClass,
            args
        ]);
        return false;
    }
    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};
/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if ($7341c7289667bcd6$var$_.isUndefined(callback)) return null;
    if ($7341c7289667bcd6$var$USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};
$7341c7289667bcd6$var$MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;
    if ($7341c7289667bcd6$var$ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }
    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;
    if (!callback && ($7341c7289667bcd6$var$_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = $7341c7289667bcd6$var$_.extend(DEFAULT_OPTIONS, options || {});
    if (!$7341c7289667bcd6$var$USE_XHR) options.method = 'GET';
    var use_post = options.method === 'POST';
    var use_sendBeacon = $7341c7289667bcd6$var$sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';
    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) verbose_mode = true;
    if (this.get_config('test')) data['test'] = 1;
    if (verbose_mode) data['verbose'] = 1;
    if (this.get_config('img')) data['img'] = 1;
    if (!$7341c7289667bcd6$var$USE_XHR) {
        if (callback) data['callback'] = callback;
        else if (verbose_mode || this.get_config('test')) // Verbose output (from verbose mode, or an error in test mode) is a json blob,
        // which by itself is not valid javascript. Without a callback, this verbose output will
        // cause an error when returned via jsonp, so we force a no-op callback param.
        // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
        data['callback'] = '(function(){})';
    }
    data['ip'] = this.get_config('ip') ? 1 : 0;
    data['_'] = new Date().getTime().toString();
    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }
    url += '?' + $7341c7289667bcd6$var$_.HTTPBuildQuery(data);
    var lib = this;
    if ('img' in data) {
        var img = $7341c7289667bcd6$var$document$1.createElement('img');
        img.src = url;
        $7341c7289667bcd6$var$document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = $7341c7289667bcd6$var$sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) callback(succeeded ? 1 : 0);
        } catch (e) {
            lib.report_error(e);
        }
    } else if ($7341c7289667bcd6$var$USE_XHR) try {
        var req = new XMLHttpRequest();
        req.open(options.method, url, true);
        var headers = this.get_config('xhr_headers');
        if (use_post) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        $7341c7289667bcd6$var$_.each(headers, function(headerValue, headerName) {
            req.setRequestHeader(headerName, headerValue);
        });
        if (options.timeout_ms && typeof req.timeout !== 'undefined') {
            req.timeout = options.timeout_ms;
            var start_time = new Date().getTime();
        }
        // send the mp_optout cookie
        // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.withCredentials = true;
        req.onreadystatechange = function() {
            if (req.readyState === 4) {
                if (req.status === 200) {
                    if (callback) {
                        if (verbose_mode) {
                            var response;
                            try {
                                response = $7341c7289667bcd6$var$_.JSONDecode(req.responseText);
                            } catch (e) {
                                lib.report_error(e);
                                if (options.ignore_json_errors) response = req.responseText;
                                else return;
                            }
                            callback(response);
                        } else callback(Number(req.responseText));
                    }
                } else {
                    var error;
                    if (req.timeout && !req.status && new Date().getTime() - start_time >= req.timeout) error = 'timeout';
                    else error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                    lib.report_error(error);
                    if (callback) {
                        if (verbose_mode) callback({
                            status: 0,
                            error: error,
                            xhr_req: req
                        });
                        else callback(0);
                    }
                }
            }
        };
        req.send(body_data);
    } catch (e) {
        lib.report_error(e);
        succeeded = false;
    }
    else {
        var script = $7341c7289667bcd6$var$document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = $7341c7289667bcd6$var$document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }
    return succeeded;
};
/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */ $7341c7289667bcd6$var$MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    $7341c7289667bcd6$var$_.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if ($7341c7289667bcd6$var$_.isArray(fn_name)) tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            else if (typeof item === 'function') item.call(this);
            else if ($7341c7289667bcd6$var$_.isArray(item) && fn_name === 'alias') alias_calls.push(item);
            else if ($7341c7289667bcd6$var$_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof this[fn_name] === 'function') tracking_calls.push(item);
            else other_calls.push(item);
        }
    }, this);
    var execute = function(calls, context) {
        $7341c7289667bcd6$var$_.each(calls, function(item) {
            if ($7341c7289667bcd6$var$_.isArray(item[0])) {
                // chained call
                var caller = context;
                $7341c7289667bcd6$var$_.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else this[item[0]].apply(this, item.slice(1));
        }, context);
    };
    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};
// request queueing utils
$7341c7289667bcd6$var$MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};
$7341c7289667bcd6$var$MixpanelLib.prototype.init_batchers = function() {
    var token = this.get_config('token');
    if (!this.are_batchers_initialized()) {
        var batcher_for = $7341c7289667bcd6$var$_.bind(function(attrs) {
            return new $7341c7289667bcd6$var$RequestBatcher('__mpq_' + token + attrs.queue_suffix, {
                libConfig: this['config'],
                sendRequestFunc: $7341c7289667bcd6$var$_.bind(function(data, options, cb) {
                    this._send_request(this.get_config('api_host') + attrs.endpoint, this._encode_data_for_request(data), options, this._prepare_callback(cb, data));
                }, this),
                beforeSendHook: $7341c7289667bcd6$var$_.bind(function(item) {
                    return this._run_hook('before_send_' + attrs.type, item);
                }, this),
                errorReporter: this.get_config('error_reporter'),
                stopAllBatchingFunc: $7341c7289667bcd6$var$_.bind(this.stop_batch_senders, this)
            });
        }, this);
        this.request_batchers = {
            events: batcher_for({
                type: 'events',
                endpoint: '/track/',
                queue_suffix: '_ev'
            }),
            people: batcher_for({
                type: 'people',
                endpoint: '/engage/',
                queue_suffix: '_pp'
            }),
            groups: batcher_for({
                type: 'groups',
                endpoint: '/groups/',
                queue_suffix: '_gr'
            })
        };
    }
    if (this.get_config('batch_autostart')) this.start_batch_senders();
};
$7341c7289667bcd6$var$MixpanelLib.prototype.start_batch_senders = function() {
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        $7341c7289667bcd6$var$_.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};
$7341c7289667bcd6$var$MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    $7341c7289667bcd6$var$_.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};
/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.push = function(item) {
    this._execute_array([
        item
    ]);
};
/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.disable = function(events) {
    if (typeof events === 'undefined') this._flags.disable_all_events = true;
    else this.__disabled_events = this.__disabled_events.concat(events);
};
$7341c7289667bcd6$var$MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = $7341c7289667bcd6$var$_.JSONEncode(data);
    if (this.get_config('api_payload_format') === $7341c7289667bcd6$var$PAYLOAD_TYPE_BASE64) encoded_data = $7341c7289667bcd6$var$_.base64Encode(encoded_data);
    return {
        'data': encoded_data
    };
};
// internal method for handling track vs batch-enqueue logic
$7341c7289667bcd6$var$MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = $7341c7289667bcd6$var$_.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || $7341c7289667bcd6$var$NOOP_FUNC;
    var request_enqueued_or_initiated = true;
    var send_request_immediately = $7341c7289667bcd6$var$_.bind(function() {
        if (!send_request_options.skip_hooks) truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        if (truncated_data) {
            $7341c7289667bcd6$var$console.log('MIXPANEL REQUEST:');
            $7341c7289667bcd6$var$console.log(truncated_data);
            return this._send_request(endpoint, this._encode_data_for_request(truncated_data), send_request_options, this._prepare_callback(callback, truncated_data));
        } else return null;
    }, this);
    if (this._batch_requests && !should_send_immediately) batcher.enqueue(truncated_data, function(succeeded) {
        if (succeeded) callback(1, truncated_data);
        else send_request_immediately();
    });
    else request_enqueued_or_initiated = send_request_immediately();
    return request_enqueued_or_initiated && truncated_data;
};
/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.track = $7341c7289667bcd6$var$addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) options.transport = transport; // 'transport' prop name can be minified internally
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') callback = $7341c7289667bcd6$var$NOOP_FUNC;
    if ($7341c7289667bcd6$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }
    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }
    // set defaults
    properties = properties || {};
    properties['token'] = this.get_config('token');
    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!$7341c7289667bcd6$var$_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }
    this._set_default_superprops();
    var marketing_properties = this.get_config('track_marketing') ? $7341c7289667bcd6$var$_.info.marketingParams() : {};
    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object
    // update properties with pageview info and super-properties
    properties = $7341c7289667bcd6$var$_.extend({}, $7341c7289667bcd6$var$_.info.properties(), marketing_properties, this['persistence'].properties(), this.unpersisted_superprops, properties);
    var property_blacklist = this.get_config('property_blacklist');
    if ($7341c7289667bcd6$var$_.isArray(property_blacklist)) $7341c7289667bcd6$var$_.each(property_blacklist, function(blacklisted_prop) {
        delete properties[blacklisted_prop];
    });
    else this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/track/',
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);
    return ret;
});
/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.set_group = $7341c7289667bcd6$var$addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!$7341c7289667bcd6$var$_.isArray(group_ids)) group_ids = [
        group_ids
    ];
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});
/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.add_group = $7341c7289667bcd6$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    if (old_values === undefined) {
        var prop = {};
        prop[group_key] = [
            group_id
        ];
        this.register(prop);
    } else if (old_values.indexOf(group_id) === -1) {
        old_values.push(group_id);
        this.register(prop);
    }
    return this['people'].union(group_key, group_id, callback);
});
/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.remove_group = $7341c7289667bcd6$var$addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({
                group_key: old_value
            });
        }
        if (old_value.length === 0) this.unregister(group_key);
    }
    return this['people'].remove(group_key, group_id, callback);
});
/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.track_with_groups = $7341c7289667bcd6$var$addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = $7341c7289667bcd6$var$_.extend({}, properties || {});
    $7341c7289667bcd6$var$_.each(groups, function(v, k) {
        if (v !== null && v !== undefined) tracking_props[k] = v;
    });
    return this.track(event_name, tracking_props, callback);
});
$7341c7289667bcd6$var$MixpanelLib.prototype._create_map_key = function(group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};
$7341c7289667bcd6$var$MixpanelLib.prototype._remove_group_from_cache = function(group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};
/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.get_group = function(group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new $7341c7289667bcd6$var$MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};
/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data. The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 * ### Usage
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.track_pageview = $7341c7289667bcd6$var$addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== 'object') properties = {};
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';
    var default_page_properties = $7341c7289667bcd6$var$_.extend($7341c7289667bcd6$var$_.info.mpPageViewProperties(), $7341c7289667bcd6$var$_.info.campaignParams(), $7341c7289667bcd6$var$_.info.clickParams());
    var event_properties = $7341c7289667bcd6$var$_.extend({}, default_page_properties, properties);
    return this.track(event_name, event_properties);
});
/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, $7341c7289667bcd6$var$LinkTracker, arguments);
};
/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, $7341c7289667bcd6$var$FormTracker, arguments);
};
/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.time_event = function(event_name) {
    if ($7341c7289667bcd6$var$_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }
    if (this._event_is_disabled(event_name)) return;
    this['persistence'].set_event_timer(event_name, new Date().getTime());
};
var $7341c7289667bcd6$var$REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */ var $7341c7289667bcd6$var$options_for_register = function(days_or_options) {
    var options;
    if ($7341c7289667bcd6$var$_.isObject(days_or_options)) options = days_or_options;
    else if (!$7341c7289667bcd6$var$_.isUndefined(days_or_options)) options = {
        'days': days_or_options
    };
    else options = {};
    return $7341c7289667bcd6$var$_.extend({}, $7341c7289667bcd6$var$REGISTER_DEFAULTS, options);
};
/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = $7341c7289667bcd6$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register(props, options['days']);
    else $7341c7289667bcd6$var$_.extend(this.unpersisted_superprops, props);
};
/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = $7341c7289667bcd6$var$options_for_register(days_or_options);
    if (options['persistent']) this['persistence'].register_once(props, default_value, options['days']);
    else {
        if (typeof default_value === 'undefined') default_value = 'None';
        $7341c7289667bcd6$var$_.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) this.unpersisted_superprops[prop] = val;
        }, this);
    }
};
/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.unregister = function(property, options) {
    options = $7341c7289667bcd6$var$options_for_register(options);
    if (options['persistent']) this['persistence'].unregister(property);
    else delete this.unpersisted_superprops[property];
};
$7341c7289667bcd6$var$MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};
/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.identify = function(new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed
    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf($7341c7289667bcd6$var$DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({
            '$user_id': new_distinct_id
        });
    }
    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }
    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property($7341c7289667bcd6$var$ALIAS_ID_KEY)) {
        this.unregister($7341c7289667bcd6$var$ALIAS_ID_KEY);
        this.register({
            'distinct_id': new_distinct_id
        });
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);
    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) this.track('$identify', {
        'distinct_id': new_distinct_id,
        '$anon_distinct_id': previous_distinct_id
    }, {
        skip_hooks: true
    });
};
/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = $7341c7289667bcd6$var$_.UUID();
    this.register_once({
        'distinct_id': $7341c7289667bcd6$var$DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
};
/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};
/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property($7341c7289667bcd6$var$PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }
    var _this = this;
    if ($7341c7289667bcd6$var$_.isUndefined(original)) original = this.get_distinct_id();
    if (alias !== original) {
        this._register_single($7341c7289667bcd6$var$ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};
/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};
/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.set_config = function(config) {
    if ($7341c7289667bcd6$var$_.isObject(config)) {
        $7341c7289667bcd6$var$_.extend(this['config'], config);
        var new_batch_size = config['batch_size'];
        if (new_batch_size) $7341c7289667bcd6$var$_.each(this.request_batchers, function(batcher) {
            batcher.resetBatchSize();
        });
        if (!this.get_config('persistence_name')) this['config']['persistence_name'] = this['config']['cookie_name'];
        if (!this.get_config('disable_persistence')) this['config']['disable_persistence'] = this['config']['disable_cookie'];
        if (this['persistence']) this['persistence'].update_config(this['config']);
        $7341c7289667bcd6$var$Config.DEBUG = $7341c7289667bcd6$var$Config.DEBUG || this.get_config('debug');
    }
};
/**
 * returns the current config object for the library.
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};
/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */ $7341c7289667bcd6$var$MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || $7341c7289667bcd6$var$IDENTITY_FUNC).apply(this, $7341c7289667bcd6$var$slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};
/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence']['props'][property_name];
};
$7341c7289667bcd6$var$MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME) name = $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME + '.' + name;
    return name;
};
$7341c7289667bcd6$var$MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return $7341c7289667bcd6$var$_.isBlockedUA($7341c7289667bcd6$var$userAgent) || this._flags.disable_all_events || $7341c7289667bcd6$var$_.include(this.__disabled_events, event_name);
};
// perform some housekeeping around GDPR opt-in/out state
$7341c7289667bcd6$var$MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';
    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && $7341c7289667bcd6$var$_.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({
            'persistence_type': 'cookie'
        })) this.opt_in_tracking({
            'enable_persistence': false
        });
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({
            'persistence_type': 'cookie'
        })) this.opt_out_tracking({
            'clear_persistence': false
        });
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }
    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) this._gdpr_update_persistence({
        'clear_persistence': true
    });
    else if (!this.has_opted_in_tracking() && (this.get_config('opt_out_tracking_by_default') || $7341c7289667bcd6$var$_.cookie.get('mp_optout'))) {
        $7341c7289667bcd6$var$_.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};
/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */ $7341c7289667bcd6$var$MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) disabled = true;
    else if (options && options['enable_persistence']) disabled = false;
    else return;
    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) this['persistence'].set_disabled(disabled);
    if (disabled) $7341c7289667bcd6$var$_.each(this.request_batchers, function(batcher) {
        batcher.clear();
    });
};
// call a base gdpr function after constructing the appropriate token and options args
$7341c7289667bcd6$var$MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = $7341c7289667bcd6$var$_.extend({
        'track': $7341c7289667bcd6$var$_.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);
    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!$7341c7289667bcd6$var$_.localStorage.is_supported()) options['persistence_type'] = 'cookie';
    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};
/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = $7341c7289667bcd6$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($7341c7289667bcd6$var$optIn, options);
    this._gdpr_update_persistence(options);
};
/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = $7341c7289667bcd6$var$_.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);
    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }
    this._gdpr_call_func($7341c7289667bcd6$var$optOut, options);
    this._gdpr_update_persistence(options);
};
/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func($7341c7289667bcd6$var$hasOptedIn, options);
};
/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func($7341c7289667bcd6$var$hasOptedOut, options);
};
/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */ $7341c7289667bcd6$var$MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = $7341c7289667bcd6$var$_.extend({
        'enable_persistence': true
    }, options);
    this._gdpr_call_func($7341c7289667bcd6$var$clearOptInOut, options);
    this._gdpr_update_persistence(options);
};
$7341c7289667bcd6$var$MixpanelLib.prototype.report_error = function(msg, err) {
    $7341c7289667bcd6$var$console.error.apply($7341c7289667bcd6$var$console.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) msg = new Error(msg);
        this.get_config('error_reporter')(msg, err);
    } catch (err) {
        $7341c7289667bcd6$var$console.error(err);
    }
};
// EXPORTS (for closure compiler)
// MixpanelLib Exports
$7341c7289667bcd6$var$MixpanelLib.prototype['init'] = $7341c7289667bcd6$var$MixpanelLib.prototype.init;
$7341c7289667bcd6$var$MixpanelLib.prototype['reset'] = $7341c7289667bcd6$var$MixpanelLib.prototype.reset;
$7341c7289667bcd6$var$MixpanelLib.prototype['disable'] = $7341c7289667bcd6$var$MixpanelLib.prototype.disable;
$7341c7289667bcd6$var$MixpanelLib.prototype['time_event'] = $7341c7289667bcd6$var$MixpanelLib.prototype.time_event;
$7341c7289667bcd6$var$MixpanelLib.prototype['track'] = $7341c7289667bcd6$var$MixpanelLib.prototype.track;
$7341c7289667bcd6$var$MixpanelLib.prototype['track_links'] = $7341c7289667bcd6$var$MixpanelLib.prototype.track_links;
$7341c7289667bcd6$var$MixpanelLib.prototype['track_forms'] = $7341c7289667bcd6$var$MixpanelLib.prototype.track_forms;
$7341c7289667bcd6$var$MixpanelLib.prototype['track_pageview'] = $7341c7289667bcd6$var$MixpanelLib.prototype.track_pageview;
$7341c7289667bcd6$var$MixpanelLib.prototype['register'] = $7341c7289667bcd6$var$MixpanelLib.prototype.register;
$7341c7289667bcd6$var$MixpanelLib.prototype['register_once'] = $7341c7289667bcd6$var$MixpanelLib.prototype.register_once;
$7341c7289667bcd6$var$MixpanelLib.prototype['unregister'] = $7341c7289667bcd6$var$MixpanelLib.prototype.unregister;
$7341c7289667bcd6$var$MixpanelLib.prototype['identify'] = $7341c7289667bcd6$var$MixpanelLib.prototype.identify;
$7341c7289667bcd6$var$MixpanelLib.prototype['alias'] = $7341c7289667bcd6$var$MixpanelLib.prototype.alias;
$7341c7289667bcd6$var$MixpanelLib.prototype['name_tag'] = $7341c7289667bcd6$var$MixpanelLib.prototype.name_tag;
$7341c7289667bcd6$var$MixpanelLib.prototype['set_config'] = $7341c7289667bcd6$var$MixpanelLib.prototype.set_config;
$7341c7289667bcd6$var$MixpanelLib.prototype['get_config'] = $7341c7289667bcd6$var$MixpanelLib.prototype.get_config;
$7341c7289667bcd6$var$MixpanelLib.prototype['get_property'] = $7341c7289667bcd6$var$MixpanelLib.prototype.get_property;
$7341c7289667bcd6$var$MixpanelLib.prototype['get_distinct_id'] = $7341c7289667bcd6$var$MixpanelLib.prototype.get_distinct_id;
$7341c7289667bcd6$var$MixpanelLib.prototype['toString'] = $7341c7289667bcd6$var$MixpanelLib.prototype.toString;
$7341c7289667bcd6$var$MixpanelLib.prototype['opt_out_tracking'] = $7341c7289667bcd6$var$MixpanelLib.prototype.opt_out_tracking;
$7341c7289667bcd6$var$MixpanelLib.prototype['opt_in_tracking'] = $7341c7289667bcd6$var$MixpanelLib.prototype.opt_in_tracking;
$7341c7289667bcd6$var$MixpanelLib.prototype['has_opted_out_tracking'] = $7341c7289667bcd6$var$MixpanelLib.prototype.has_opted_out_tracking;
$7341c7289667bcd6$var$MixpanelLib.prototype['has_opted_in_tracking'] = $7341c7289667bcd6$var$MixpanelLib.prototype.has_opted_in_tracking;
$7341c7289667bcd6$var$MixpanelLib.prototype['clear_opt_in_out_tracking'] = $7341c7289667bcd6$var$MixpanelLib.prototype.clear_opt_in_out_tracking;
$7341c7289667bcd6$var$MixpanelLib.prototype['get_group'] = $7341c7289667bcd6$var$MixpanelLib.prototype.get_group;
$7341c7289667bcd6$var$MixpanelLib.prototype['set_group'] = $7341c7289667bcd6$var$MixpanelLib.prototype.set_group;
$7341c7289667bcd6$var$MixpanelLib.prototype['add_group'] = $7341c7289667bcd6$var$MixpanelLib.prototype.add_group;
$7341c7289667bcd6$var$MixpanelLib.prototype['remove_group'] = $7341c7289667bcd6$var$MixpanelLib.prototype.remove_group;
$7341c7289667bcd6$var$MixpanelLib.prototype['track_with_groups'] = $7341c7289667bcd6$var$MixpanelLib.prototype.track_with_groups;
$7341c7289667bcd6$var$MixpanelLib.prototype['start_batch_senders'] = $7341c7289667bcd6$var$MixpanelLib.prototype.start_batch_senders;
$7341c7289667bcd6$var$MixpanelLib.prototype['stop_batch_senders'] = $7341c7289667bcd6$var$MixpanelLib.prototype.stop_batch_senders;
// MixpanelPersistence Exports
$7341c7289667bcd6$var$MixpanelPersistence.prototype['properties'] = $7341c7289667bcd6$var$MixpanelPersistence.prototype.properties;
$7341c7289667bcd6$var$MixpanelPersistence.prototype['update_search_keyword'] = $7341c7289667bcd6$var$MixpanelPersistence.prototype.update_search_keyword;
$7341c7289667bcd6$var$MixpanelPersistence.prototype['update_referrer_info'] = $7341c7289667bcd6$var$MixpanelPersistence.prototype.update_referrer_info;
$7341c7289667bcd6$var$MixpanelPersistence.prototype['get_cross_subdomain'] = $7341c7289667bcd6$var$MixpanelPersistence.prototype.get_cross_subdomain;
$7341c7289667bcd6$var$MixpanelPersistence.prototype['clear'] = $7341c7289667bcd6$var$MixpanelPersistence.prototype.clear;
var $7341c7289667bcd6$var$instances = {};
var $7341c7289667bcd6$var$extend_mp = function() {
    // add all the sub mixpanel instances
    $7341c7289667bcd6$var$_.each($7341c7289667bcd6$var$instances, function(instance, name) {
        if (name !== $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME) $7341c7289667bcd6$var$mixpanel_master[name] = instance;
    });
    // add private functions as _
    $7341c7289667bcd6$var$mixpanel_master['_'] = $7341c7289667bcd6$var$_;
};
var $7341c7289667bcd6$var$override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    $7341c7289667bcd6$var$mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!$7341c7289667bcd6$var$mixpanel_master[name]) {
                $7341c7289667bcd6$var$mixpanel_master[name] = $7341c7289667bcd6$var$instances[name] = $7341c7289667bcd6$var$create_mplib(token, config, name);
                $7341c7289667bcd6$var$mixpanel_master[name]._loaded();
            }
            return $7341c7289667bcd6$var$mixpanel_master[name];
        } else {
            var instance = $7341c7289667bcd6$var$mixpanel_master;
            if ($7341c7289667bcd6$var$instances[$7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME]) // main mixpanel lib already initialized
            instance = $7341c7289667bcd6$var$instances[$7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME];
            else if (token) {
                // intialize the main mixpanel lib
                instance = $7341c7289667bcd6$var$create_mplib(token, config, $7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME);
                instance._loaded();
                $7341c7289667bcd6$var$instances[$7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME] = instance;
            }
            $7341c7289667bcd6$var$mixpanel_master = instance;
            if ($7341c7289667bcd6$var$init_type === $7341c7289667bcd6$var$INIT_SNIPPET) $7341c7289667bcd6$var$window$1[$7341c7289667bcd6$var$PRIMARY_INSTANCE_NAME] = $7341c7289667bcd6$var$mixpanel_master;
            $7341c7289667bcd6$var$extend_mp();
        }
    };
};
var $7341c7289667bcd6$var$add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) return;
        dom_loaded_handler.done = true;
        $7341c7289667bcd6$var$DOM_LOADED = true;
        $7341c7289667bcd6$var$ENQUEUE_REQUESTS = false;
        $7341c7289667bcd6$var$_.each($7341c7289667bcd6$var$instances, function(inst) {
            inst._dom_loaded();
        });
    }
    function do_scroll_check() {
        try {
            $7341c7289667bcd6$var$document$1.documentElement.doScroll('left');
        } catch (e) {
            setTimeout(do_scroll_check, 1);
            return;
        }
        dom_loaded_handler();
    }
    if ($7341c7289667bcd6$var$document$1.addEventListener) {
        if ($7341c7289667bcd6$var$document$1.readyState === 'complete') // safari 4 can fire the DOMContentLoaded event before loading all
        // external JS (including this file). you will see some copypasta
        // on the internet that checks for 'complete' and 'loaded', but
        // 'loaded' is an IE thing
        dom_loaded_handler();
        else $7341c7289667bcd6$var$document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
    } else if ($7341c7289667bcd6$var$document$1.attachEvent) {
        // IE
        $7341c7289667bcd6$var$document$1.attachEvent('onreadystatechange', dom_loaded_handler);
        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = $7341c7289667bcd6$var$window$1.frameElement === null;
        } catch (e) {
        // noop
        }
        if ($7341c7289667bcd6$var$document$1.documentElement.doScroll && toplevel) do_scroll_check();
    }
    // fallback handler, always will work
    $7341c7289667bcd6$var$_.register_event($7341c7289667bcd6$var$window$1, 'load', dom_loaded_handler, true);
};
function $7341c7289667bcd6$var$init_as_module() {
    $7341c7289667bcd6$var$init_type = $7341c7289667bcd6$var$INIT_MODULE;
    $7341c7289667bcd6$var$mixpanel_master = new $7341c7289667bcd6$var$MixpanelLib();
    $7341c7289667bcd6$var$override_mp_init_func();
    $7341c7289667bcd6$var$mixpanel_master['init']();
    $7341c7289667bcd6$var$add_dom_loaded_handler();
    return $7341c7289667bcd6$var$mixpanel_master;
}
var $7341c7289667bcd6$var$mixpanel = $7341c7289667bcd6$var$init_as_module();
module.exports = $7341c7289667bcd6$var$mixpanel;

});


parcelRegister("4iokK", function(module, exports) {

$parcel$export(module.exports, "processAuthFailure", function () { return $320bb80a2b0c1471$export$476ec7e759d7d526; });
$parcel$export(module.exports, "processEventData", function () { return $320bb80a2b0c1471$export$5ad8778ef3296466; });

var $a6640 = parcelRequire("a6640");

var $e0AWW = parcelRequire("e0AWW");
var $fv46J = parcelRequire("fv46J");

var $fv46J = parcelRequire("fv46J");

var $dV0Ap = parcelRequire("dV0Ap");

var $3q1XH = parcelRequire("3q1XH");

var $d4gBz = parcelRequire("d4gBz");

var $h7cYZ = parcelRequire("h7cYZ");

var $7aJfj = parcelRequire("7aJfj");

var $6JZt8 = parcelRequire("6JZt8");
/**
 * Process the ExitPresentMode event and handle default fullscreen exit
 * @param e - The event data
 */ function $320bb80a2b0c1471$var$processExitPresentMode(e) {
    var _a;
    const embedConfig = (0, $a6640.getEmbedConfig)();
    const disableFullscreenPresentation = (_a = embedConfig === null || embedConfig === void 0 ? void 0 : embedConfig.disableFullscreenPresentation) !== null && _a !== void 0 ? _a : true;
    if (!disableFullscreenPresentation) (0, $7aJfj.handleExitPresentMode)();
}
/**
 * Clears the cached preauth and session info.
 */ function $320bb80a2b0c1471$var$processClearInfoCache() {
    (0, $6JZt8.resetCachedPreauthInfo)();
    (0, $6JZt8.resetCachedSessionInfo)();
}
function $320bb80a2b0c1471$export$3d23652bba2842eb(e, thoughtSpotHost) {
    const { session: session, embedAnswerData: embedAnswerData, contextMenuPoints: contextMenuPoints } = e.data;
    const answerService = new (0, $3q1XH.AnswerService)(session, embedAnswerData || {}, thoughtSpotHost, contextMenuPoints === null || contextMenuPoints === void 0 ? void 0 : contextMenuPoints.selectedPoints);
    return {
        ...e,
        answerService: answerService
    };
}
/**
 * Responds to AuthInit sent from host signifying successful authentication in host.
 * @param e
 * @returns {any}
 */ function $320bb80a2b0c1471$var$processAuthInit(e) {
    var _a, _b;
    (0, $fv46J.notifyAuthSuccess)();
    // Expose only allowed details (eg: userGUID) back to SDK users.
    return {
        ...e,
        data: {
            userGUID: ((_a = e.data) === null || _a === void 0 ? void 0 : _a.userGUID) || ((_b = e.payload) === null || _b === void 0 ? void 0 : _b.userGUID)
        }
    };
}
/**
 *
 * @param e
 * @param containerEl
 */ function $320bb80a2b0c1471$var$processNoCookieAccess(e, containerEl) {
    const { loginFailedMessage: loginFailedMessage, suppressNoCookieAccessAlert: suppressNoCookieAccessAlert, ignoreNoCookieAccess: ignoreNoCookieAccess, suppressErrorAlerts: suppressErrorAlerts } = (0, $a6640.getEmbedConfig)();
    if (!ignoreNoCookieAccess) {
        if (!suppressNoCookieAccessAlert && !suppressErrorAlerts) alert((0, $h7cYZ.ERROR_MESSAGE).THIRD_PARTY_COOKIE_BLOCKED_ALERT);
        containerEl.innerHTML = loginFailedMessage;
    }
    (0, $fv46J.notifyAuthFailure)((0, $fv46J.AuthFailureType).NO_COOKIE_ACCESS);
    return e;
}
function $320bb80a2b0c1471$export$476ec7e759d7d526(e, containerEl) {
    var _a;
    const { loginFailedMessage: loginFailedMessage, authType: authType, disableLoginFailurePage: disableLoginFailurePage, autoLogin: autoLogin } = (0, $a6640.getEmbedConfig)();
    const isEmbeddedSSO = authType === (0, $dV0Ap.AuthType).EmbeddedSSO;
    const isTrustedAuth = authType === (0, $dV0Ap.AuthType).TrustedAuthToken || authType === (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless;
    const isEmbeddedSSOInfoFailure = isEmbeddedSSO && ((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.type) === (0, $fv46J.AuthFailureType).UNAUTHENTICATED_FAILURE;
    if (autoLogin && isTrustedAuth) {
        containerEl.innerHTML = loginFailedMessage;
        (0, $fv46J.notifyAuthFailure)((0, $fv46J.AuthFailureType).IDLE_SESSION_TIMEOUT);
    } else if (authType !== (0, $dV0Ap.AuthType).None && !disableLoginFailurePage && !isEmbeddedSSOInfoFailure) {
        containerEl.innerHTML = loginFailedMessage;
        (0, $fv46J.notifyAuthFailure)((0, $fv46J.AuthFailureType).OTHER);
    }
    (0, $d4gBz.resetCachedAuthToken)();
    return e;
}
/**
 *
 * @param e
 * @param containerEl
 */ function $320bb80a2b0c1471$var$processAuthLogout(e, containerEl) {
    const { loginFailedMessage: loginFailedMessage } = (0, $a6640.getEmbedConfig)();
    containerEl.innerHTML = loginFailedMessage;
    (0, $d4gBz.resetCachedAuthToken)();
    (0, $e0AWW.disableAutoLogin)();
    (0, $fv46J.notifyLogout)();
    return e;
}
function $320bb80a2b0c1471$export$5ad8778ef3296466(type, eventData, thoughtSpotHost, containerEl) {
    switch(type){
        case (0, $dV0Ap.EmbedEvent).CustomAction:
            return $320bb80a2b0c1471$export$3d23652bba2842eb(eventData, thoughtSpotHost);
        case (0, $dV0Ap.EmbedEvent).AuthInit:
            return $320bb80a2b0c1471$var$processAuthInit(eventData);
        case (0, $dV0Ap.EmbedEvent).NoCookieAccess:
            return $320bb80a2b0c1471$var$processNoCookieAccess(eventData, containerEl);
        case (0, $dV0Ap.EmbedEvent).AuthFailure:
            return $320bb80a2b0c1471$export$476ec7e759d7d526(eventData, containerEl);
        case (0, $dV0Ap.EmbedEvent).AuthLogout:
            return $320bb80a2b0c1471$var$processAuthLogout(eventData, containerEl);
        case (0, $dV0Ap.EmbedEvent).ExitPresentMode:
            return $320bb80a2b0c1471$var$processExitPresentMode(eventData);
        case (0, $dV0Ap.EmbedEvent).CLEAR_INFO_CACHE:
            return $320bb80a2b0c1471$var$processClearInfoCache();
        default:
    }
    return eventData;
}

});
parcelRegister("e0AWW", function(module, exports) {

$parcel$export(module.exports, "getAuthPromise", function () { return $a32dba3bebbf74a7$export$760ec4c43d0b7dd; });
$parcel$export(module.exports, "handleAuth", function () { return $a32dba3bebbf74a7$export$fb1ac82b4cebb734; });
$parcel$export(module.exports, "getInitPromise", function () { return $a32dba3bebbf74a7$export$c3e38303a31ec018; });
$parcel$export(module.exports, "getIsInitCalled", function () { return $a32dba3bebbf74a7$export$e6716e501de8cc4e; });
$parcel$export(module.exports, "init", function () { return $a32dba3bebbf74a7$export$2cd8252107eb640b; });
$parcel$export(module.exports, "disableAutoLogin", function () { return $a32dba3bebbf74a7$export$41aa26d54b08975e; });
$parcel$export(module.exports, "renderInQueue", function () { return $a32dba3bebbf74a7$export$7b7b85c4a4934382; });
$parcel$export(module.exports, "executeTML", function () { return $a32dba3bebbf74a7$export$ae3ed590be111ba5; });
$parcel$export(module.exports, "notifyAuthFailure", function () { return (parcelRequire("fv46J")).notifyAuthFailure; });
$parcel$export(module.exports, "notifyAuthSuccess", function () { return (parcelRequire("fv46J")).notifyAuthSuccess; });
$parcel$export(module.exports, "notifyLogout", function () { return (parcelRequire("fv46J")).notifyLogout; });
/**
 * Copyright (c) 2022
 *
 * Base classes
 * @summary Base classes
 * @author Ayon Ghosh <ayon.ghosh@thoughtspot.com>
 */ 
var $8uY62 = parcelRequire("8uY62");

var $do0Z9 = parcelRequire("do0Z9");

var $kCAID = parcelRequire("kCAID");

var $8NaiO = parcelRequire("8NaiO");

var $bdEoU = parcelRequire("bdEoU");

var $10hiU = parcelRequire("10hiU");

var $dV0Ap = parcelRequire("dV0Ap");

var $fv46J = parcelRequire("fv46J");
parcelRequire("jeUxw");

var $fxzLD = parcelRequire("fxzLD");

var $a6640 = parcelRequire("a6640");

var $7aJfj = parcelRequire("7aJfj");

var $627dq = parcelRequire("627dq");

var $e2GRa = parcelRequire("e2GRa");
const $a32dba3bebbf74a7$var$CONFIG_DEFAULTS = {
    loginFailedMessage: 'Not logged in',
    authTriggerText: 'Authorize',
    authType: (0, $dV0Ap.AuthType).None,
    logLevel: (0, $dV0Ap.LogLevel).ERROR,
    waitForCleanupOnDestroy: false,
    cleanupTimeout: 5000
};
let $a32dba3bebbf74a7$export$fc031706d492056a;
const $a32dba3bebbf74a7$export$760ec4c43d0b7dd = ()=>$a32dba3bebbf74a7$export$fc031706d492056a;
const $a32dba3bebbf74a7$export$fb1ac82b4cebb734 = ()=>{
    $a32dba3bebbf74a7$export$fc031706d492056a = (0, $fv46J.authenticate)((0, $a6640.getEmbedConfig)());
    $a32dba3bebbf74a7$export$fc031706d492056a.then((isLoggedIn)=>{
        if (!isLoggedIn) (0, $fv46J.notifyAuthFailure)((0, $fv46J.AuthFailureType).SDK);
        else {
            // Post login service is called after successful login.
            (0, $fv46J.postLoginService)();
            (0, $fv46J.notifyAuthSDKSuccess)();
        }
    }, ()=>{
        (0, $fv46J.notifyAuthFailure)((0, $fv46J.AuthFailureType).SDK);
    });
    return $a32dba3bebbf74a7$export$fc031706d492056a;
};
const $a32dba3bebbf74a7$var$hostUrlToFeatureUrl = {
    [(0, $dV0Ap.PrefetchFeatures).SearchEmbed]: (url, flags)=>`${url}v2/?${flags}#/embed/answer`,
    [(0, $dV0Ap.PrefetchFeatures).LiveboardEmbed]: (url, flags)=>`${url}?${flags}`,
    [(0, $dV0Ap.PrefetchFeatures).FullApp]: (url, flags)=>`${url}?${flags}`,
    [(0, $dV0Ap.PrefetchFeatures).VizEmbed]: (url, flags)=>`${url}?${flags}`
};
const $a32dba3bebbf74a7$export$f003ab04b0b3c00e = (url, prefetchFeatures, additionalFlags)=>{
    var _a;
    if (url === '') (0, $kCAID.logger).warn('The prefetch method does not have a valid URL');
    else {
        const features = prefetchFeatures || [
            (0, $dV0Ap.PrefetchFeatures).FullApp
        ];
        let hostUrl = url || (0, $a6640.getEmbedConfig)().thoughtSpotHost;
        const prefetchFlags = {
            [(0, $dV0Ap.Param).EmbedApp]: true,
            ...(_a = (0, $a6640.getEmbedConfig)()) === null || _a === void 0 ? void 0 : _a.additionalFlags,
            ...additionalFlags
        };
        hostUrl = hostUrl[hostUrl.length - 1] === '/' ? hostUrl : `${hostUrl}/`;
        Array.from(new Set(features.map((feature)=>$a32dba3bebbf74a7$var$hostUrlToFeatureUrl[feature](hostUrl, (0, $7aJfj.getQueryParamString)(prefetchFlags))))).forEach((prefetchUrl, index)=>{
            const iFrame = document.createElement('iframe');
            iFrame.src = prefetchUrl;
            iFrame.style.width = '0';
            iFrame.style.height = '0';
            iFrame.style.border = '0';
            // Make it 'fixed' to keep it in a different stacking
            // context. This should solve the focus behaviours inside
            // the iframe from interfering with main body.
            iFrame.style.position = 'fixed';
            // Push it out of viewport.
            iFrame.style.top = '100vh';
            iFrame.style.left = '100vw';
            iFrame.classList.add('prefetchIframe');
            iFrame.classList.add(`prefetchIframeNum-${index}`);
            document.body.appendChild(iFrame);
        });
    }
};
/**
 *
 * @param embedConfig
 */ function $a32dba3bebbf74a7$var$sanity(embedConfig) {
    if (embedConfig.thoughtSpotHost === undefined) throw new Error('ThoughtSpot host not provided');
    if (embedConfig.authType === (0, $dV0Ap.AuthType).TrustedAuthToken) {
        if (!embedConfig.authEndpoint && typeof embedConfig.getAuthToken !== 'function') throw new Error('Trusted auth should provide either authEndpoint or getAuthToken');
    }
}
/**
 *
 * @param embedConfig
 */ function $a32dba3bebbf74a7$var$backwardCompat(embedConfig) {
    const newConfig = {
        ...embedConfig
    };
    if (embedConfig.noRedirect !== undefined && embedConfig.inPopup === undefined) newConfig.inPopup = embedConfig.noRedirect;
    return newConfig;
}
const $a32dba3bebbf74a7$var$initFlagKey = 'initFlagKey';
const $a32dba3bebbf74a7$export$77339d7500e203b0 = ()=>{
    if ((0, $7aJfj.isWindowUndefined)()) return;
    const { promise: initPromise, resolve: initPromiseResolve } = Promise.withResolvers();
    const initFlagStore = {
        initPromise: initPromise,
        isInitCalled: false,
        initPromiseResolve: initPromiseResolve
    };
    (0, $7aJfj.storeValueInWindow)($a32dba3bebbf74a7$var$initFlagKey, initFlagStore, {
        // In case of diff imports the promise might be already set
        ignoreIfAlreadyExists: true
    });
};
$a32dba3bebbf74a7$export$77339d7500e203b0();
const $a32dba3bebbf74a7$export$c3e38303a31ec018 = ()=>{
    var _a;
    return (_a = (0, $7aJfj.getValueFromWindow)($a32dba3bebbf74a7$var$initFlagKey)) === null || _a === void 0 ? void 0 : _a.initPromise;
};
const $a32dba3bebbf74a7$export$e6716e501de8cc4e = ()=>{
    var _a;
    return !!((_a = (0, $7aJfj.getValueFromWindow)($a32dba3bebbf74a7$var$initFlagKey)) === null || _a === void 0 ? void 0 : _a.isInitCalled);
};
const $a32dba3bebbf74a7$export$2cd8252107eb640b = (embedConfig)=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    if ((0, $7aJfj.isWindowUndefined)()) return null;
    $a32dba3bebbf74a7$var$sanity(embedConfig);
    (0, $627dq.resetAllCachedServices)();
    embedConfig = (0, $a6640.setEmbedConfig)($a32dba3bebbf74a7$var$backwardCompat({
        ...$a32dba3bebbf74a7$var$CONFIG_DEFAULTS,
        ...embedConfig,
        thoughtSpotHost: (0, $10hiU.getThoughtSpotHost)(embedConfig)
    }));
    (0, $kCAID.setGlobalLogLevelOverride)(embedConfig.logLevel);
    (0, $do0Z9.registerReportingObserver)();
    const authEE = new (0, (/*@__PURE__*/$parcel$interopDefault($8uY62)))();
    (0, $fv46J.setAuthEE)(authEE);
    $a32dba3bebbf74a7$export$fb1ac82b4cebb734();
    const { password: password, ...configToTrack } = (0, $a6640.getEmbedConfig)();
    (0, $fxzLD.uploadMixpanelEvent)((0, $fxzLD.MIXPANEL_EVENT).VISUAL_SDK_CALLED_INIT, {
        ...configToTrack,
        usedCustomizationSheet: ((_b = (_a = embedConfig.customizations) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.customCSSUrl) != null,
        usedCustomizationVariables: ((_e = (_d = (_c = embedConfig.customizations) === null || _c === void 0 ? void 0 : _c.style) === null || _d === void 0 ? void 0 : _d.customCSS) === null || _e === void 0 ? void 0 : _e.variables) != null,
        usedCustomizationRules: ((_h = (_g = (_f = embedConfig.customizations) === null || _f === void 0 ? void 0 : _f.style) === null || _g === void 0 ? void 0 : _g.customCSS) === null || _h === void 0 ? void 0 : _h.rules_UNSTABLE) != null,
        usedCustomizationStrings: !!((_k = (_j = embedConfig.customizations) === null || _j === void 0 ? void 0 : _j.content) === null || _k === void 0 ? void 0 : _k.strings),
        usedCustomizationIconSprite: !!((_l = embedConfig.customizations) === null || _l === void 0 ? void 0 : _l.iconSpriteUrl)
    });
    if ((0, $a6640.getEmbedConfig)().callPrefetch) $a32dba3bebbf74a7$export$f003ab04b0b3c00e((0, $a6640.getEmbedConfig)().thoughtSpotHost);
    // Resolves the promise created in the initPromiseKey
    (0, $7aJfj.getValueFromWindow)($a32dba3bebbf74a7$var$initFlagKey).initPromiseResolve(authEE);
    (0, $7aJfj.getValueFromWindow)($a32dba3bebbf74a7$var$initFlagKey).isInitCalled = true;
    return authEE;
};
function $a32dba3bebbf74a7$export$41aa26d54b08975e() {
    (0, $a6640.getEmbedConfig)().autoLogin = false;
}
const $a32dba3bebbf74a7$export$a0973bcfe11b05c9 = (doNotDisableAutoLogin = false)=>{
    if (!doNotDisableAutoLogin) $a32dba3bebbf74a7$export$41aa26d54b08975e();
    return (0, $fv46J.logout)((0, $a6640.getEmbedConfig)()).then((isLoggedIn)=>{
        (0, $fv46J.notifyLogout)();
        return isLoggedIn;
    });
};
let $a32dba3bebbf74a7$var$renderQueue = Promise.resolve();
const $a32dba3bebbf74a7$export$7b7b85c4a4934382 = (fn)=>{
    const { queueMultiRenders: queueMultiRenders = false } = (0, $a6640.getEmbedConfig)();
    if (queueMultiRenders) {
        $a32dba3bebbf74a7$var$renderQueue = $a32dba3bebbf74a7$var$renderQueue.then(()=>new Promise((res)=>fn(res)));
        return $a32dba3bebbf74a7$var$renderQueue;
    }
    // Sending an empty function to keep it consistent with the above usage.
    return fn(()=>{});
};
const $a32dba3bebbf74a7$export$ae3ed590be111ba5 = async (data)=>{
    try {
        $a32dba3bebbf74a7$var$sanity((0, $a6640.getEmbedConfig)());
    } catch (err) {
        return Promise.reject(err);
    }
    const { thoughtSpotHost: thoughtSpotHost, authType: authType } = (0, $a6640.getEmbedConfig)();
    const headers = {
        'Content-Type': 'application/json',
        'x-requested-by': 'ThoughtSpot'
    };
    const payload = {
        metadata_tmls: data.metadata_tmls,
        import_policy: data.import_policy || 'PARTIAL',
        create_new: data.create_new || false
    };
    return (0, $8NaiO.tokenizedFetch)(`${thoughtSpotHost}${(0, $bdEoU.EndPoints).EXECUTE_TML}`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
        credentials: 'include'
    }).then((response)=>{
        if (!response.ok) throw new Error(`Failed to import TML data: ${response.status} - ${response.statusText}`);
        return response.json();
    }).catch((error)=>{
        throw error;
    });
};
const $a32dba3bebbf74a7$export$e86d338033cd9db = async (data)=>{
    const { thoughtSpotHost: thoughtSpotHost, authType: authType } = (0, $a6640.getEmbedConfig)();
    try {
        $a32dba3bebbf74a7$var$sanity((0, $a6640.getEmbedConfig)());
    } catch (err) {
        return Promise.reject(err);
    }
    const payload = {
        metadata: data.metadata,
        export_associated: data.export_associated || false,
        export_fqn: data.export_fqn || false,
        edoc_format: data.edoc_format || 'YAML'
    };
    const headers = {
        'Content-Type': 'application/json',
        'x-requested-by': 'ThoughtSpot'
    };
    return (0, $8NaiO.tokenizedFetch)(`${thoughtSpotHost}${(0, $bdEoU.EndPoints).EXPORT_TML}`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(payload),
        credentials: 'include'
    }).then((response)=>{
        if (!response.ok) throw new Error(`Failed to export TML: ${response.status} - ${response.statusText}`);
        return response.json();
    }).catch((error)=>{
        throw error;
    });
};
function $a32dba3bebbf74a7$export$aad8462122ac592b() {
    (0, $a6640.setEmbedConfig)({});
    (0, $fv46J.setAuthEE)(null);
    $a32dba3bebbf74a7$export$fc031706d492056a = null;
}
const $a32dba3bebbf74a7$export$a4189964c472854f = (iFrame)=>{
    if (!iFrame) {
        (0, $kCAID.logger).warn('reloadIframe called with no iFrame element.');
        return;
    }
    (0, $e2GRa.reload)(iFrame);
};

});
parcelRegister("8uY62", function(module, exports) {
'use strict';
var $62ffbdfb537d047e$var$has = Object.prototype.hasOwnProperty, $62ffbdfb537d047e$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $62ffbdfb537d047e$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $62ffbdfb537d047e$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $62ffbdfb537d047e$var$Events().__proto__) $62ffbdfb537d047e$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $62ffbdfb537d047e$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $62ffbdfb537d047e$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $62ffbdfb537d047e$var$EE(fn, context || emitter, once), evt = $62ffbdfb537d047e$var$prefix ? $62ffbdfb537d047e$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $62ffbdfb537d047e$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $62ffbdfb537d047e$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $62ffbdfb537d047e$var$EventEmitter() {
    this._events = new $62ffbdfb537d047e$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $62ffbdfb537d047e$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($62ffbdfb537d047e$var$has.call(events, name)) names.push($62ffbdfb537d047e$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $62ffbdfb537d047e$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $62ffbdfb537d047e$var$prefix ? $62ffbdfb537d047e$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $62ffbdfb537d047e$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $62ffbdfb537d047e$var$prefix ? $62ffbdfb537d047e$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $62ffbdfb537d047e$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $62ffbdfb537d047e$var$prefix ? $62ffbdfb537d047e$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $62ffbdfb537d047e$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $62ffbdfb537d047e$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $62ffbdfb537d047e$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $62ffbdfb537d047e$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $62ffbdfb537d047e$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $62ffbdfb537d047e$var$prefix ? $62ffbdfb537d047e$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $62ffbdfb537d047e$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $62ffbdfb537d047e$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $62ffbdfb537d047e$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $62ffbdfb537d047e$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $62ffbdfb537d047e$var$prefix ? $62ffbdfb537d047e$var$prefix + event : event;
        if (this._events[evt]) $62ffbdfb537d047e$var$clearEvent(this, evt);
    } else {
        this._events = new $62ffbdfb537d047e$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$62ffbdfb537d047e$var$EventEmitter.prototype.off = $62ffbdfb537d047e$var$EventEmitter.prototype.removeListener;
$62ffbdfb537d047e$var$EventEmitter.prototype.addListener = $62ffbdfb537d047e$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$62ffbdfb537d047e$var$EventEmitter.prefixed = $62ffbdfb537d047e$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$62ffbdfb537d047e$var$EventEmitter.EventEmitter = $62ffbdfb537d047e$var$EventEmitter;
module.exports = $62ffbdfb537d047e$var$EventEmitter;

});

parcelRegister("do0Z9", function(module, exports) {

$parcel$export(module.exports, "registerReportingObserver", function () { return $9bee47e610891acf$export$970d7d136a7dfe72; });

var $a6640 = parcelRequire("a6640");

var $kCAID = parcelRequire("kCAID");

var $h7cYZ = parcelRequire("h7cYZ");
var $9bee47e610891acf$var$ReportType;
(function(ReportType) {
    ReportType["CSP_VIOLATION"] = "csp-violation";
    ReportType["DEPRECATION"] = "deprecation";
    ReportType["INTERVENTION"] = "intervention";
})($9bee47e610891acf$var$ReportType || ($9bee47e610891acf$var$ReportType = {}));
let $9bee47e610891acf$var$globalObserver = null;
function $9bee47e610891acf$export$970d7d136a7dfe72(overrideExisting = false) {
    if (!window.ReportingObserver) {
        (0, $kCAID.logger).warn((0, $h7cYZ.ERROR_MESSAGE).MISSING_REPORTING_OBSERVER);
        return null;
    }
    if (overrideExisting) $9bee47e610891acf$export$2b1c25ccca777114();
    if ($9bee47e610891acf$var$globalObserver) return $9bee47e610891acf$var$globalObserver;
    const embedConfig = (0, $a6640.getEmbedConfig)();
    $9bee47e610891acf$var$globalObserver = new ReportingObserver((reports)=>{
        reports.forEach((report)=>{
            const { type: type, url: url, body: body } = report;
            const reportBody = body;
            const isThoughtSpotHost = url && url.startsWith(embedConfig.thoughtSpotHost);
            const isFrameHostError = type === $9bee47e610891acf$var$ReportType.CSP_VIOLATION && reportBody.effectiveDirective === 'frame-ancestors';
            if (isThoughtSpotHost && isFrameHostError) {
                if (!embedConfig.suppressErrorAlerts) alert((0, $h7cYZ.ERROR_MESSAGE).CSP_VIOLATION_ALERT);
                (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).CSP_FRAME_HOST_VIOLATION_LOG_MESSAGE);
            }
        });
    }, {
        buffered: true
    });
    $9bee47e610891acf$var$globalObserver.observe();
    return $9bee47e610891acf$var$globalObserver;
}
function $9bee47e610891acf$export$ca10e1b5db306fae() {
    return $9bee47e610891acf$var$globalObserver;
}
function $9bee47e610891acf$export$2b1c25ccca777114() {
    if ($9bee47e610891acf$var$globalObserver) $9bee47e610891acf$var$globalObserver.disconnect();
    $9bee47e610891acf$var$globalObserver = null;
}

});

parcelRegister("fv46J", function(module, exports) {

$parcel$export(module.exports, "AuthFailureType", function () { return $b48ceff3663efe66$export$60ff61ea7504be0c; });
$parcel$export(module.exports, "setAuthEE", function () { return $b48ceff3663efe66$export$fe578c92ebb68d2f; });
$parcel$export(module.exports, "notifyAuthSDKSuccess", function () { return $b48ceff3663efe66$export$d3f156fdc6be78c9; });
$parcel$export(module.exports, "notifyAuthSuccess", function () { return $b48ceff3663efe66$export$c07aae205a8ff13; });
$parcel$export(module.exports, "notifyAuthFailure", function () { return $b48ceff3663efe66$export$e51b23ca74d197e0; });
$parcel$export(module.exports, "notifyLogout", function () { return $b48ceff3663efe66$export$b4d4e4504bc4325b; });
$parcel$export(module.exports, "postLoginService", function () { return $b48ceff3663efe66$export$d34beeb7783ee621; });
$parcel$export(module.exports, "getReleaseVersion", function () { return $b48ceff3663efe66$export$81c6f82fa2331919; });
$parcel$export(module.exports, "logout", function () { return $b48ceff3663efe66$export$a0973bcfe11b05c9; });
$parcel$export(module.exports, "authenticate", function () { return $b48ceff3663efe66$export$61bb00ddedae72e4; });

var $d4gBz = parcelRequire("d4gBz");

var $a6640 = parcelRequire("a6640");

var $fxzLD = parcelRequire("fxzLD");

var $dV0Ap = parcelRequire("dV0Ap");

var $7aJfj = parcelRequire("7aJfj");
parcelRequire("iDOqM");
var $bdEoU = parcelRequire("bdEoU");
var $826fy = parcelRequire("826fy");

var $826fy = parcelRequire("826fy");

var $kCAID = parcelRequire("kCAID");

var $6JZt8 = parcelRequire("6JZt8");

var $h7cYZ = parcelRequire("h7cYZ");

var $627dq = parcelRequire("627dq");
let $b48ceff3663efe66$export$eb09faaed66968ff = false;
let $b48ceff3663efe66$export$9386a3bdb3b23f9c = null;
let $b48ceff3663efe66$export$f2dac53f4e3dab25 = null;
let $b48ceff3663efe66$var$releaseVersion = '';
const $b48ceff3663efe66$export$f6412f92e99f78d2 = '5e16222e-ef02-43e9-9fbd-24226bf3ce5b';
var $b48ceff3663efe66$export$60ff61ea7504be0c;
(function(AuthFailureType) {
    /**
     * Authentication failed in the SDK authentication flow.
     *
     * Emitted when `init()` or auto-authentication cannot establish a logged-in session.
     * For example, this can happen because of an invalid token, an auth request failure,
     * or an auth promise rejection.
     */ AuthFailureType["SDK"] = "SDK";
    /**
     * Browser cookie access is blocked for the embedded app.
     *
     * Emitted when the iframe reports that required cookies
     * cannot be read or sent, commonly due to third-party cookie restrictions.
     */ AuthFailureType["NO_COOKIE_ACCESS"] = "NO_COOKIE_ACCESS";
    /**
     * The current authentication token or session has expired.
     *
     * Emitted when the embed receives an auth-expiry signal and starts auth refresh
     * handling.
     */ AuthFailureType["EXPIRY"] = "EXPIRY";
    /**
     * A generic authentication failure that does not match a more specific type.
     *
     * Emitted as a fallback for app-reported auth failures in standard auth flows.
     */ AuthFailureType["OTHER"] = "OTHER";
    /**
     * The user session timed out due to inactivity.
     *
     * Emitted when the app reports an idle-session timeout.
     */ AuthFailureType["IDLE_SESSION_TIMEOUT"] = "IDLE_SESSION_TIMEOUT";
    /**
     * The app reports that the user is unauthenticated.
     *
     * Used primarily to classify unauthenticated failures in Embedded SSO flows.
     */ AuthFailureType["UNAUTHENTICATED_FAILURE"] = "UNAUTHENTICATED_FAILURE";
})($b48ceff3663efe66$export$60ff61ea7504be0c || ($b48ceff3663efe66$export$60ff61ea7504be0c = {}));
var $b48ceff3663efe66$export$77c219755a7e3571;
(function(AuthStatus) {
    /**
     * Emits when the SDK fails to authenticate.
     */ AuthStatus["FAILURE"] = "FAILURE";
    /**
     * Emits when the SDK authentication step completes
     * successfully (e.g., token exchange, cookie set).
     * This fires before any iframe is rendered. Use
     * this to know that auth passed and it is safe to
     * proceed with rendering. The callback receives no
     * arguments.
     * @example
     * ```js
     * const authEE = init({ ... });
     * authEE.on(AuthStatus.SDK_SUCCESS, () => {
     *     // Auth done, iframe not loaded yet
     * });
     * ```
     */ AuthStatus["SDK_SUCCESS"] = "SDK_SUCCESS";
    /**
     * @hidden
     * Emits when iframe is loaded and session
     * information is available.
     */ AuthStatus["SESSION_INFO_SUCCESS"] = "SESSION_INFO_SUCCESS";
    /**
     * Emits when the ThoughtSpot app inside the
     * embedded iframe confirms its session is active.
     * This fires after the iframe loads and sends back an `AuthInit` event.
     * @param sessionInfo Information about the user session, with details like `userGUID`.
     * @see EmbedEvent.AuthInit
     * @example
     * ```js
     * const authEE = init({ ... });
     * authEE.on(AuthStatus.SUCCESS, (sessionInfo) => {
     *     // App is loaded and authenticated
     *     console.log(sessionInfo.userGUID);
     * });
     * ```
     */ AuthStatus["SUCCESS"] = "SUCCESS";
    /**
     * Emits when a user logs out
     */ AuthStatus["LOGOUT"] = "LOGOUT";
    /**
     * Emitted when inPopup is true in the SAMLRedirect flow and the
     * popup is waiting to be triggered either programmatically
     * or by the trigger button.
     * @version SDK: 1.19.0
     */ AuthStatus["WAITING_FOR_POPUP"] = "WAITING_FOR_POPUP";
    /**
     * Emitted when the SAML popup is closed without authentication
     */ AuthStatus["SAML_POPUP_CLOSED_NO_AUTH"] = "SAML_POPUP_CLOSED_NO_AUTH";
})($b48ceff3663efe66$export$77c219755a7e3571 || ($b48ceff3663efe66$export$77c219755a7e3571 = {}));
var $b48ceff3663efe66$export$22a75dd05a0ec9a0;
(function(AuthEvent) {
    /**
     * Manually trigger the SSO popup. This is useful when
     * authStatus is SAMLRedirect/OIDCRedirect and inPopup is set to true
     */ AuthEvent["TRIGGER_SSO_POPUP"] = "TRIGGER_SSO_POPUP";
})($b48ceff3663efe66$export$22a75dd05a0ec9a0 || ($b48ceff3663efe66$export$22a75dd05a0ec9a0 = {}));
let $b48ceff3663efe66$var$authEE;
function $b48ceff3663efe66$export$cd42d6421bc0dbec() {
    return $b48ceff3663efe66$var$authEE;
}
function $b48ceff3663efe66$export$fe578c92ebb68d2f(eventEmitter) {
    $b48ceff3663efe66$var$authEE = eventEmitter;
}
function $b48ceff3663efe66$export$d3f156fdc6be78c9() {
    if (!$b48ceff3663efe66$var$authEE) {
        (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).SDK_NOT_INITIALIZED);
        return;
    }
    $b48ceff3663efe66$var$authEE.emit($b48ceff3663efe66$export$77c219755a7e3571.SDK_SUCCESS);
}
async function $b48ceff3663efe66$export$c07aae205a8ff13() {
    if (!$b48ceff3663efe66$var$authEE) {
        (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).SDK_NOT_INITIALIZED);
        return;
    }
    try {
        (0, $6JZt8.getPreauthInfo)();
        const sessionInfo = await (0, $6JZt8.getSessionInfo)();
        $b48ceff3663efe66$var$authEE.emit($b48ceff3663efe66$export$77c219755a7e3571.SUCCESS, sessionInfo);
    } catch (e) {
        (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).SESSION_INFO_FAILED);
    }
}
function $b48ceff3663efe66$export$e51b23ca74d197e0(failureType) {
    if (!$b48ceff3663efe66$var$authEE) {
        (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).SDK_NOT_INITIALIZED);
        return;
    }
    $b48ceff3663efe66$var$authEE.emit($b48ceff3663efe66$export$77c219755a7e3571.FAILURE, failureType);
}
function $b48ceff3663efe66$export$b4d4e4504bc4325b() {
    if (!$b48ceff3663efe66$var$authEE) {
        (0, $kCAID.logger).error((0, $h7cYZ.ERROR_MESSAGE).SDK_NOT_INITIALIZED);
        return;
    }
    $b48ceff3663efe66$var$authEE.emit($b48ceff3663efe66$export$77c219755a7e3571.LOGOUT);
}
/**
 * Check if we are logged into the ThoughtSpot cluster
 * @param thoughtSpotHost The ThoughtSpot cluster hostname or IP
 */ async function $b48ceff3663efe66$var$isLoggedIn(thoughtSpotHost) {
    try {
        const response = await (0, $826fy.isActiveService)(thoughtSpotHost);
        return response;
    } catch (e) {
        return false;
    }
}
async function $b48ceff3663efe66$export$d34beeb7783ee621() {
    try {
        (0, $6JZt8.getPreauthInfo)();
        const sessionInfo = await (0, $6JZt8.getSessionInfo)();
        $b48ceff3663efe66$var$releaseVersion = sessionInfo.releaseVersion;
        const embedConfig = (0, $a6640.getEmbedConfig)();
        if (!embedConfig.disableSDKTracking) (0, $fxzLD.initMixpanel)(sessionInfo);
    } catch (e) {
        (0, $kCAID.logger).error('Post login services failed.', e.message, e);
    }
}
function $b48ceff3663efe66$export$81c6f82fa2331919() {
    return $b48ceff3663efe66$var$releaseVersion;
}
/**
 * Check if we are stuck at the SSO redirect URL
 */ function $b48ceff3663efe66$var$isAtSSORedirectUrl() {
    return window.location.href.indexOf((0, $7aJfj.getSSOMarker)($b48ceff3663efe66$export$f6412f92e99f78d2)) >= 0;
}
/**
 * Remove the SSO redirect URL marker
 */ function $b48ceff3663efe66$var$removeSSORedirectUrlMarker() {
    // Note (sunny): This will leave a # around even if it was not in the URL
    // to begin with. Trying to remove the hash by changing window.location will
    // reload the page which we don't want. We'll live with adding an
    // unnecessary hash to the parent page URL until we find any use case where
    // that creates an issue.
    // Replace any occurrences of ?ssoMarker=guid or &ssoMarker=guid.
    let updatedHash = window.location.hash.replace(`?${(0, $7aJfj.getSSOMarker)($b48ceff3663efe66$export$f6412f92e99f78d2)}`, '');
    updatedHash = updatedHash.replace(`&${(0, $7aJfj.getSSOMarker)($b48ceff3663efe66$export$f6412f92e99f78d2)}`, '');
    window.location.hash = updatedHash;
}
const $b48ceff3663efe66$export$ece9bb21552e108c = async (embedConfig)=>{
    const { thoughtSpotHost: thoughtSpotHost, username: username, authEndpoint: authEndpoint, getAuthToken: getAuthToken } = embedConfig;
    if (!authEndpoint && !getAuthToken) throw new Error('Either auth endpoint or getAuthToken function must be provided');
    $b48ceff3663efe66$export$eb09faaed66968ff = await $b48ceff3663efe66$var$isLoggedIn(thoughtSpotHost);
    if (!$b48ceff3663efe66$export$eb09faaed66968ff) {
        let authToken;
        try {
            authToken = await (0, $d4gBz.getAuthenticationToken)(embedConfig);
        } catch (e) {
            $b48ceff3663efe66$export$eb09faaed66968ff = false;
            throw e;
        }
        let resp;
        try {
            resp = await (0, $bdEoU.fetchAuthPostService)(thoughtSpotHost, username, authToken);
        } catch (e) {
            resp = await (0, $bdEoU.fetchAuthService)(thoughtSpotHost, username, authToken);
        }
        // token login issues a 302 when successful
        $b48ceff3663efe66$export$eb09faaed66968ff = resp.ok || resp.type === 'opaqueredirect';
        if ($b48ceff3663efe66$export$eb09faaed66968ff && embedConfig.detectCookieAccessSlow) // When 3rd party cookie access is blocked, this will fail because
        // cookies will not be sent with the call.
        $b48ceff3663efe66$export$eb09faaed66968ff = await $b48ceff3663efe66$var$isLoggedIn(thoughtSpotHost);
    }
    return $b48ceff3663efe66$export$eb09faaed66968ff;
};
const $b48ceff3663efe66$export$603bb7552fca6214 = async (embedConfig)=>{
    const { authEndpoint: authEndpoint, getAuthToken: getAuthToken } = embedConfig;
    if (!authEndpoint && !getAuthToken) throw new Error('Either auth endpoint or getAuthToken function must be provided');
    let authSuccess = false;
    try {
        const authToken = await (0, $d4gBz.getAuthenticationToken)(embedConfig);
        if (authToken) authSuccess = true;
    } catch  {
        authSuccess = false;
    }
    return authSuccess;
};
const $b48ceff3663efe66$export$6123b21b2c8d8f10 = async (embedConfig)=>{
    const { thoughtSpotHost: thoughtSpotHost, username: username, password: password } = embedConfig;
    const loggedIn = await $b48ceff3663efe66$var$isLoggedIn(thoughtSpotHost);
    if (!loggedIn) {
        const response = await (0, $bdEoU.fetchBasicAuthService)(thoughtSpotHost, username, password);
        $b48ceff3663efe66$export$eb09faaed66968ff = response.ok;
        if (embedConfig.detectCookieAccessSlow) $b48ceff3663efe66$export$eb09faaed66968ff = await $b48ceff3663efe66$var$isLoggedIn(thoughtSpotHost);
    } else $b48ceff3663efe66$export$eb09faaed66968ff = true;
    return $b48ceff3663efe66$export$eb09faaed66968ff;
};
/**
 *
 * @param ssoURL
 * @param triggerContainer
 * @param triggerText
 */ async function $b48ceff3663efe66$var$samlPopupFlow(ssoURL, triggerContainer, triggerText) {
    let popupClosedCheck;
    const openPopup = ()=>{
        if ($b48ceff3663efe66$export$9386a3bdb3b23f9c === null || $b48ceff3663efe66$export$9386a3bdb3b23f9c.closed) {
            $b48ceff3663efe66$export$9386a3bdb3b23f9c = window.open(ssoURL, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes');
            if ($b48ceff3663efe66$export$9386a3bdb3b23f9c) popupClosedCheck = setInterval(()=>{
                if ($b48ceff3663efe66$export$9386a3bdb3b23f9c.closed) {
                    clearInterval(popupClosedCheck);
                    if ($b48ceff3663efe66$export$f2dac53f4e3dab25 && !samlCompletionResolved) $b48ceff3663efe66$var$authEE === null || $b48ceff3663efe66$var$authEE === void 0 || $b48ceff3663efe66$var$authEE.emit($b48ceff3663efe66$export$77c219755a7e3571.SAML_POPUP_CLOSED_NO_AUTH);
                }
            }, 500);
        } else $b48ceff3663efe66$export$9386a3bdb3b23f9c.focus();
    };
    let samlCompletionResolved = false;
    $b48ceff3663efe66$var$authEE === null || $b48ceff3663efe66$var$authEE === void 0 || $b48ceff3663efe66$var$authEE.emit($b48ceff3663efe66$export$77c219755a7e3571.WAITING_FOR_POPUP);
    const containerEl = (0, $7aJfj.getDOMNode)(triggerContainer);
    if (containerEl) {
        containerEl.innerHTML = '<button id="ts-auth-btn" class="ts-auth-btn" style="margin: auto;"></button>';
        const authElem = document.getElementById('ts-auth-btn');
        authElem.textContent = triggerText;
        authElem.addEventListener('click', openPopup, {
            once: true
        });
    }
    $b48ceff3663efe66$export$f2dac53f4e3dab25 = $b48ceff3663efe66$export$f2dac53f4e3dab25 || new Promise((resolve, reject)=>{
        window.addEventListener('message', (e)=>{
            if (e.data.type === (0, $dV0Ap.EmbedEvent).SAMLComplete) {
                samlCompletionResolved = true;
                if (popupClosedCheck) clearInterval(popupClosedCheck);
                e.source.close();
                resolve();
            }
        });
    });
    $b48ceff3663efe66$var$authEE === null || $b48ceff3663efe66$var$authEE === void 0 || $b48ceff3663efe66$var$authEE.once($b48ceff3663efe66$export$22a75dd05a0ec9a0.TRIGGER_SSO_POPUP, openPopup);
    return $b48ceff3663efe66$export$f2dac53f4e3dab25;
}
/**
 * Perform SAML authentication
 * @param embedConfig The embed configuration
 * @param ssoEndPoint
 */ const $b48ceff3663efe66$var$doSSOAuth = async (embedConfig, ssoEndPoint)=>{
    const { thoughtSpotHost: thoughtSpotHost } = embedConfig;
    const loggedIn = await $b48ceff3663efe66$var$isLoggedIn(thoughtSpotHost);
    if (loggedIn) {
        if ($b48ceff3663efe66$var$isAtSSORedirectUrl()) $b48ceff3663efe66$var$removeSSORedirectUrlMarker();
        $b48ceff3663efe66$export$eb09faaed66968ff = true;
        return;
    }
    // we have already tried authentication and it did not succeed, restore
    // the current URL to the original one and invoke the callback.
    if ($b48ceff3663efe66$var$isAtSSORedirectUrl()) {
        $b48ceff3663efe66$var$removeSSORedirectUrlMarker();
        $b48ceff3663efe66$export$eb09faaed66968ff = false;
        return;
    }
    const ssoURL = `${thoughtSpotHost}${ssoEndPoint}`;
    if (embedConfig.inPopup) {
        await $b48ceff3663efe66$var$samlPopupFlow(ssoURL, embedConfig.authTriggerContainer, embedConfig.authTriggerText);
        $b48ceff3663efe66$export$eb09faaed66968ff = await $b48ceff3663efe66$var$isLoggedIn(thoughtSpotHost);
        return;
    }
    window.location.href = ssoURL;
};
const $b48ceff3663efe66$export$b78d66aa04b7f734 = async (embedConfig)=>{
    const { thoughtSpotHost: thoughtSpotHost } = embedConfig;
    // redirect for SSO, when the SSO authentication is done, this page will be
    // loaded again and the same JS will execute again.
    const ssoRedirectUrl = embedConfig.inPopup ? `${thoughtSpotHost}/v2/#/embed/saml-complete` : (0, $7aJfj.getRedirectUrl)(window.location.href, $b48ceff3663efe66$export$f6412f92e99f78d2, embedConfig.redirectPath);
    // bring back the page to the same URL
    const ssoEndPoint = `${(0, $bdEoU.EndPoints).SAML_LOGIN_TEMPLATE(encodeURIComponent(ssoRedirectUrl))}`;
    await $b48ceff3663efe66$var$doSSOAuth(embedConfig, ssoEndPoint);
    return $b48ceff3663efe66$export$eb09faaed66968ff;
};
const $b48ceff3663efe66$export$c7ca00e447e4ec42 = async (embedConfig)=>{
    const { thoughtSpotHost: thoughtSpotHost } = embedConfig;
    // redirect for SSO, when the SSO authentication is done, this page will be
    // loaded again and the same JS will execute again.
    const ssoRedirectUrl = embedConfig.noRedirect || embedConfig.inPopup ? `${thoughtSpotHost}/v2/#/embed/saml-complete` : (0, $7aJfj.getRedirectUrl)(window.location.href, $b48ceff3663efe66$export$f6412f92e99f78d2, embedConfig.redirectPath);
    // bring back the page to the same URL
    const baseEndpoint = `${(0, $bdEoU.EndPoints).OIDC_LOGIN_TEMPLATE(encodeURIComponent(ssoRedirectUrl))}`;
    const ssoEndPoint = `${baseEndpoint}${baseEndpoint.includes('?') ? '&' : '?'}forceSAMLAutoRedirect=true`;
    await $b48ceff3663efe66$var$doSSOAuth(embedConfig, ssoEndPoint);
    return $b48ceff3663efe66$export$eb09faaed66968ff;
};
const $b48ceff3663efe66$export$a0973bcfe11b05c9 = async (embedConfig)=>{
    const { thoughtSpotHost: thoughtSpotHost } = embedConfig;
    await (0, $826fy.fetchLogoutService)(thoughtSpotHost);
    (0, $627dq.resetAllCachedServices)();
    const thoughtspotIframes = document.querySelectorAll("[data-ts-iframe='true']");
    if (thoughtspotIframes === null || thoughtspotIframes === void 0 ? void 0 : thoughtspotIframes.length) thoughtspotIframes.forEach((el)=>{
        el.parentElement.innerHTML = embedConfig.loginFailedMessage;
    });
    $b48ceff3663efe66$export$eb09faaed66968ff = false;
    return $b48ceff3663efe66$export$eb09faaed66968ff;
};
const $b48ceff3663efe66$export$61bb00ddedae72e4 = async (embedConfig)=>{
    const { authType: authType } = embedConfig;
    switch(authType){
        case (0, $dV0Ap.AuthType).SSO:
        case (0, $dV0Ap.AuthType).SAMLRedirect:
        case (0, $dV0Ap.AuthType).SAML:
            return $b48ceff3663efe66$export$b78d66aa04b7f734(embedConfig);
        case (0, $dV0Ap.AuthType).OIDC:
        case (0, $dV0Ap.AuthType).OIDCRedirect:
            return $b48ceff3663efe66$export$c7ca00e447e4ec42(embedConfig);
        case (0, $dV0Ap.AuthType).AuthServer:
        case (0, $dV0Ap.AuthType).TrustedAuthToken:
            return $b48ceff3663efe66$export$ece9bb21552e108c(embedConfig);
        case (0, $dV0Ap.AuthType).TrustedAuthTokenCookieless:
            return $b48ceff3663efe66$export$603bb7552fca6214(embedConfig);
        case (0, $dV0Ap.AuthType).Basic:
            return $b48ceff3663efe66$export$6123b21b2c8d8f10(embedConfig);
        default:
            return Promise.resolve(true);
    }
};
const $b48ceff3663efe66$export$83d11f23a23d4a7c = ()=>$b48ceff3663efe66$export$eb09faaed66968ff;

});
parcelRegister("iDOqM", function(module, exports) {

$parcel$export(module.exports, "EndPoints", function () { return (parcelRequire("bdEoU")).EndPoints; });
$parcel$export(module.exports, "fetchAuthPostService", function () { return (parcelRequire("bdEoU")).fetchAuthPostService; });
$parcel$export(module.exports, "fetchAuthService", function () { return (parcelRequire("bdEoU")).fetchAuthService; });
$parcel$export(module.exports, "fetchBasicAuthService", function () { return (parcelRequire("bdEoU")).fetchBasicAuthService; });
$parcel$export(module.exports, "fetchLogoutService", function () { return (parcelRequire("826fy")).fetchLogoutService; });
$parcel$export(module.exports, "fetchSessionInfoService", function () { return (parcelRequire("826fy")).fetchSessionInfoService; });
$parcel$export(module.exports, "fetchPreauthInfoService", function () { return (parcelRequire("826fy")).fetchPreauthInfoService; });

var $bdEoU = parcelRequire("bdEoU");

var $826fy = parcelRequire("826fy");

});
parcelRegister("826fy", function(module, exports) {

$parcel$export(module.exports, "fetchPreauthInfoService", function () { return $5d935bb852aa54d7$export$b723f9246da3bb94; });
$parcel$export(module.exports, "fetchSessionInfoService", function () { return $5d935bb852aa54d7$export$f0ef1f17cc349c24; });
$parcel$export(module.exports, "fetchLogoutService", function () { return $5d935bb852aa54d7$export$4d3aa1e2204073d6; });
$parcel$export(module.exports, "isActiveService", function () { return $5d935bb852aa54d7$export$aa3b4ecb94acd0b7; });

var $8NaiO = parcelRequire("8NaiO");

var $kCAID = parcelRequire("kCAID");

var $bdEoU = parcelRequire("bdEoU");
/**
 *
 * @param url
 * @param options
 */ function $5d935bb852aa54d7$var$tokenizedFailureLoggedFetch(url, options = {}) {
    return (0, $8NaiO.tokenizedFetch)(url, options).then(async (r)=>{
        var _a;
        if (!r.ok && r.type !== 'opaqueredirect' && r.type !== 'opaque') (0, $kCAID.logger).error(`Failed to fetch ${url}`, await ((_a = r.text) === null || _a === void 0 ? void 0 : _a.call(r)));
        return r;
    });
}
async function $5d935bb852aa54d7$export$b723f9246da3bb94(thoughtspotHost) {
    const sessionInfoPath = `${thoughtspotHost}${(0, $bdEoU.EndPoints).PREAUTH_INFO}`;
    const handleError = (e)=>{
        const error = new Error(`Failed to fetch auth info: ${e.message || e.statusText}`);
        error.status = e.status; // Attach the status code to the error object
        throw error;
    };
    try {
        const response = await $5d935bb852aa54d7$var$tokenizedFailureLoggedFetch(sessionInfoPath);
        return response;
    } catch (e) {
        handleError(e);
        return null;
    }
}
async function $5d935bb852aa54d7$export$f0ef1f17cc349c24(thoughtspotHost) {
    const sessionInfoPath = `${thoughtspotHost}${(0, $bdEoU.EndPoints).SESSION_INFO}`;
    const response = await $5d935bb852aa54d7$var$tokenizedFailureLoggedFetch(sessionInfoPath);
    if (!response.ok) throw new Error(`Failed to fetch session info: ${response.statusText}`);
    const data = await response.json();
    return data;
}
async function $5d935bb852aa54d7$export$4d3aa1e2204073d6(thoughtSpotHost) {
    return $5d935bb852aa54d7$var$tokenizedFailureLoggedFetch(`${thoughtSpotHost}${(0, $bdEoU.EndPoints).LOGOUT}`, {
        credentials: 'include',
        method: 'POST',
        headers: {
            'x-requested-by': 'ThoughtSpot'
        }
    });
}
async function $5d935bb852aa54d7$export$aa3b4ecb94acd0b7(thoughtSpotHost) {
    const isActiveUrl = `${thoughtSpotHost}${(0, $bdEoU.EndPoints).IS_ACTIVE}`;
    try {
        const res = await (0, $8NaiO.tokenizedFetch)(isActiveUrl, {
            credentials: 'include'
        });
        return res.ok;
    } catch (e) {
        (0, $kCAID.logger).warn(`Is Logged In Service failed : ${e.message}`);
    }
    return false;
}

});


parcelRegister("6JZt8", function(module, exports) {

$parcel$export(module.exports, "getPreauthInfo", function () { return $4e86a082abf2920c$export$c08d288cb0f3271; });
$parcel$export(module.exports, "getSessionInfo", function () { return $4e86a082abf2920c$export$28055d25e3f96ec1; });
$parcel$export(module.exports, "resetCachedSessionInfo", function () { return $4e86a082abf2920c$export$28b1e363aa3e7d9; });
$parcel$export(module.exports, "resetCachedPreauthInfo", function () { return $4e86a082abf2920c$export$a4eb6c0a8bbe0816; });

var $a6640 = parcelRequire("a6640");
parcelRequire("iDOqM");
var $826fy = parcelRequire("826fy");
let $4e86a082abf2920c$var$sessionInfo = null;
let $4e86a082abf2920c$var$preauthInfo = null;
const $4e86a082abf2920c$export$a14063849d70f3a8 = async (preauthInfoResp)=>{
    var _a;
    try {
        // Convert Headers to a plain object
        const headers = {};
        (_a = preauthInfoResp === null || preauthInfoResp === void 0 ? void 0 : preauthInfoResp.headers) === null || _a === void 0 || _a.forEach((value, key)=>{
            headers[key] = value;
        });
        const data = await preauthInfoResp.json();
        return {
            ...data,
            status: 200,
            headers: headers
        };
    } catch (error) {
        return null;
    }
};
async function $4e86a082abf2920c$export$c08d288cb0f3271(allowCache = true) {
    if (!allowCache || !$4e86a082abf2920c$var$preauthInfo) try {
        const host = (0, $a6640.getEmbedConfig)().thoughtSpotHost;
        const sessionResponse = await (0, $826fy.fetchPreauthInfoService)(host);
        const processedPreauthInfo = await $4e86a082abf2920c$export$a14063849d70f3a8(sessionResponse);
        $4e86a082abf2920c$var$preauthInfo = processedPreauthInfo;
    } catch (error) {
        return null;
    }
    return $4e86a082abf2920c$var$preauthInfo;
}
async function $4e86a082abf2920c$export$28055d25e3f96ec1() {
    if (!$4e86a082abf2920c$var$sessionInfo) {
        const host = (0, $a6640.getEmbedConfig)().thoughtSpotHost;
        const sessionResponse = await (0, $826fy.fetchSessionInfoService)(host);
        const processedSessionInfo = $4e86a082abf2920c$export$dd7d6675aec7457c(sessionResponse);
        $4e86a082abf2920c$var$sessionInfo = processedSessionInfo;
    }
    return $4e86a082abf2920c$var$sessionInfo;
}
function $4e86a082abf2920c$export$19184c0e5189d069() {
    return $4e86a082abf2920c$var$sessionInfo;
}
const $4e86a082abf2920c$export$dd7d6675aec7457c = (sessionInfoResp)=>{
    const devMixpanelToken = sessionInfoResp.configInfo.mixpanelConfig.devSdkKey;
    const prodMixpanelToken = sessionInfoResp.configInfo.mixpanelConfig.prodSdkKey;
    const mixpanelToken = sessionInfoResp.configInfo.mixpanelConfig.production ? prodMixpanelToken : devMixpanelToken;
    return {
        userGUID: sessionInfoResp.userGUID,
        mixpanelToken: mixpanelToken,
        isPublicUser: sessionInfoResp.configInfo.isPublicUser,
        releaseVersion: sessionInfoResp.releaseVersion,
        clusterId: sessionInfoResp.configInfo.selfClusterId,
        clusterName: sessionInfoResp.configInfo.selfClusterName,
        ...sessionInfoResp
    };
};
function $4e86a082abf2920c$export$28b1e363aa3e7d9() {
    $4e86a082abf2920c$var$sessionInfo = null;
}
function $4e86a082abf2920c$export$a4eb6c0a8bbe0816() {
    $4e86a082abf2920c$var$preauthInfo = null;
}

});

parcelRegister("627dq", function(module, exports) {

$parcel$export(module.exports, "resetAllCachedServices", function () { return $464886d8f474eac7$export$521b6ed1fba0d188; });

var $d4gBz = parcelRequire("d4gBz");

var $6JZt8 = parcelRequire("6JZt8");
function $464886d8f474eac7$export$521b6ed1fba0d188() {
    (0, $d4gBz.resetCachedAuthToken)();
    (0, $6JZt8.resetCachedSessionInfo)();
    (0, $6JZt8.resetCachedPreauthInfo)();
}

});


parcelRegister("jeUxw", function(module, exports) {
if (typeof Promise.withResolvers === 'undefined') Promise.withResolvers = ()=>{
    let resolve;
    let reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};

});

parcelRegister("e2GRa", function(module, exports) {

$parcel$export(module.exports, "reload", function () { return $a3927efffe1ad9a2$export$32da5b5043dcd88c; });
$parcel$export(module.exports, "processTrigger", function () { return $a3927efffe1ad9a2$export$cc5aa198364f0826; });

var $h7cYZ = parcelRequire("h7cYZ");

var $dV0Ap = parcelRequire("dV0Ap");

var $kCAID = parcelRequire("kCAID");

var $7aJfj = parcelRequire("7aJfj");

var $a6640 = parcelRequire("a6640");
const $a3927efffe1ad9a2$export$32da5b5043dcd88c = (iFrame)=>{
    const src = iFrame.src;
    iFrame.src = '';
    setTimeout(()=>{
        iFrame.src = src;
    }, 100);
};
/**
 * Post iframe message.
 * @param iFrame
 * @param message
 * @param message.type
 * @param message.data
 * @param message.context
 * @param thoughtSpotHost
 * @param channel
 */ function $a3927efffe1ad9a2$var$postIframeMessage(iFrame, message, thoughtSpotHost, channel) {
    var _a;
    return (_a = iFrame.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(message, thoughtSpotHost, [
        channel === null || channel === void 0 ? void 0 : channel.port2
    ]);
}
const $a3927efffe1ad9a2$export$531a53549e80460b = 30000;
function $a3927efffe1ad9a2$export$cc5aa198364f0826(iFrame, messageType, thoughtSpotHost, data, context) {
    return new Promise((res, rej)=>{
        var _a;
        if (messageType === (0, $dV0Ap.HostEvent).Reload) {
            $a3927efffe1ad9a2$export$32da5b5043dcd88c(iFrame);
            return res(null);
        }
        if (messageType === (0, $dV0Ap.HostEvent).Present) {
            const embedConfig = (0, $a6640.getEmbedConfig)();
            const disableFullscreenPresentation = (_a = embedConfig === null || embedConfig === void 0 ? void 0 : embedConfig.disableFullscreenPresentation) !== null && _a !== void 0 ? _a : true;
            if (!disableFullscreenPresentation) (0, $7aJfj.handlePresentEvent)(iFrame);
            else (0, $kCAID.logger).warn('Fullscreen presentation mode is disabled. Set disableFullscreenPresentation: false to enable this feature.');
        }
        const channel = new MessageChannel();
        channel.port1.onmessage = ({ data: responseData })=>{
            var _a;
            channel.port1.close();
            const error = (responseData === null || responseData === void 0 ? void 0 : responseData.error) || ((_a = responseData === null || responseData === void 0 ? void 0 : responseData.data) === null || _a === void 0 ? void 0 : _a.error);
            if (error) rej(error);
            else res(responseData);
        };
        // Close the messageChannel and resolve the promise if timeout.
        setTimeout(()=>{
            channel.port1.close();
            res(new Error((0, $h7cYZ.ERROR_MESSAGE).TRIGGER_TIMED_OUT));
        }, $a3927efffe1ad9a2$export$531a53549e80460b);
        return $a3927efffe1ad9a2$var$postIframeMessage(iFrame, {
            type: messageType,
            data: data,
            context: context
        }, thoughtSpotHost, channel);
    });
}

});



parcelRegister("jZ130", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"@thoughtspot/visual-embed-sdk\",\"version\":\"1.47.1\",\"description\":\"ThoughtSpot Embed SDK\",\"module\":\"lib/src/index.js\",\"main\":\"dist/tsembed.js\",\"types\":\"lib/src/index.d.ts\",\"files\":[\"dist/**\",\"lib/**\",\"src/**\",\"cjs/**\"],\"exports\":{\".\":{\"import\":\"./lib/src/index.js\",\"require\":\"./cjs/src/index.js\",\"types\":\"./lib/src/index.d.ts\"},\"./react\":{\"import\":\"./lib/src/react/all-types-export.js\",\"require\":\"./cjs/src/react/all-types-export.js\",\"types\":\"./lib/src/react/all-types-export.d.ts\"},\"./lib/src/react\":{\"import\":\"./lib/src/react/all-types-export.js\",\"require\":\"./cjs/src/react/all-types-export.js\",\"types\":\"./lib/src/react/all-types-export.d.ts\"}},\"typesVersions\":{\"*\":{\"react\":[\"./lib/src/react/all-types-export.d.ts\"]}},\"size-limit\":[{\"path\":\"dist/tsembed.es.js\",\"limit\":\"34 kB\"}],\"scripts\":{\"lint\":\"eslint 'src/**'\",\"lint:fix\":\"eslint 'src/**/*.*' --fix\",\"tsc\":\"tsc -p tsconfig.build.json --incremental false; tsc -p tsconfig.build.json --incremental false --module commonjs --outDir cjs\",\"build-and-publish\":\"npm run build:gatsby && npm run publish\",\"bundle-dts-file\":\"dts-bundle-generator --config ./dts-config/dts-bundle-file.config.js && node dts-config/wrap-ambient-module.mjs\",\"bundle-dts\":\"dts-bundle-generator --config ./dts-config/dts-bundle.config.js\",\"bundle-dts-react\":\"dts-bundle-generator --config ./dts-config/dts-bundle-react.config.js\",\"bundle-dts-react-full\":\"dts-bundle-generator --config ./dts-config/dts-bundle-react-full.config.js\",\"build\":\"rollup -c\",\"watch\":\"rollup -cw\",\"docgen\":\"typedoc --tsconfig tsconfig.build.json --theme typedoc-theme --json static/typedoc/typedoc.json --disableOutputCheck\",\"test-sdk\":\"jest -c jest.config.sdk.js --runInBand\",\"test\":\"npm run test-sdk\",\"posttest\":\"cat ./coverage/sdk/lcov.info | npx coveralls-next || echo 'Warning: Coveralls upload failed but not breaking the build.'\",\"is-publish-allowed\":\"node scripts/is-publish-allowed.js\",\"prepublishOnly\":\"npm run is-publish-allowed && npm run test && npm run tsc && npm run bundle-dts-file && npm run bundle-dts && npm run bundle-dts-react && npm run bundle-dts-react-full && npm run build\",\"check-size\":\"npm run build && size-limit\",\"publish-dev\":\"npm publish --tag dev\",\"publish-prod\":\"npm publish --tag latest\",\"dev\":\"vite -c vite.local.config.ts\"},\"peerDependencies\":{\"react\":\"> 16.8.0\",\"react-dom\":\"> 16.8.0\"},\"dependencies\":{\"classnames\":\"^2.3.1\",\"eventemitter3\":\"^4.0.7\",\"lodash\":\"^4.17.23\",\"mixpanel-browser\":\"2.47.0\",\"ts-deepmerge\":\"^6.0.2\",\"tslib\":\"^2.5.3\",\"use-deep-compare-effect\":\"^1.8.1\",\"yaml\":\"^2.5.1\"},\"devDependencies\":{\"@mdx-js/mdx\":\"^1.6.22\",\"@mdx-js/react\":\"^1.6.22\",\"@react-icons/all-files\":\"^4.1.0\",\"@rollup/plugin-commonjs\":\"^18.0.0\",\"@rollup/plugin-json\":\"^4.1.0\",\"@rollup/plugin-node-resolve\":\"^11.2.1\",\"@rollup/plugin-replace\":\"^5.0.2\",\"@size-limit/preset-big-lib\":\"^11.2.0\",\"@testing-library/dom\":\"^7.31.0\",\"@testing-library/jest-dom\":\"^5.14.1\",\"@testing-library/react\":\"^11.2.7\",\"@testing-library/user-event\":\"^13.1.8\",\"@types/jest\":\"^30.0.0\",\"@types/lodash\":\"^4.17.0\",\"@types/mixpanel-browser\":\"^2.35.6\",\"@types/react-test-renderer\":\"^17.0.1\",\"@typescript-eslint/eslint-plugin\":\"^8.28.0\",\"@typescript-eslint/parser\":\"^8.28.0\",\"ajv\":\"^8.17.1\",\"asciidoctor\":\"^2.2.1\",\"babel-jest\":\"^30.2.0\",\"babel-preset-gatsby\":\"^1.10.0\",\"command-line-args\":\"^5.1.1\",\"coveralls-next\":\"^5.0.0\",\"crypto\":\"^1.0.1\",\"current-git-branch\":\"^1.1.0\",\"dts-bundle-generator\":\"^9.5.1\",\"eslint\":\"^9.23.0\",\"eslint-config-airbnb-base\":\"^15.0.0\",\"eslint-config-prettier\":\"^10.1.1\",\"eslint-import-resolver-typescript\":\"^4.2.5\",\"eslint-plugin-comment-length\":\"2.2.1\",\"eslint-plugin-import\":\"^2.31.0\",\"eslint-plugin-jsdoc\":\"^50.6.9\",\"eslint-plugin-prettier\":\"^5.2.5\",\"eslint-plugin-react\":\"^7.37.5\",\"eslint-plugin-react-hooks\":\"^5.2.0\",\"fs-extra\":\"^10.0.0\",\"gh-pages\":\"6.3.0\",\"globals\":\"^16.0.0\",\"highlight.js\":\"^10.6.0\",\"html-to-text\":\"^8.0.0\",\"identity-obj-proxy\":\"^3.0.0\",\"istanbul-merge\":\"^2.0.0\",\"jest\":\"^30.2.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"jest-fetch-mock\":\"^3.0.3\",\"jsdom\":\"^17.0.0\",\"prettier\":\"2.1.2\",\"react\":\"^16.14.0\",\"react-dom\":\"^16.14.0\",\"react-resizable\":\"^1.11.0\",\"react-resize-detector\":\"^6.6.0\",\"react-test-renderer\":\"^17.0.2\",\"react-use-flexsearch\":\"^0.1.1\",\"rollup\":\"4.59.0\",\"rollup-plugin-typescript2\":\"0.27.3\",\"ts-jest\":\"^29.4.6\",\"ts-loader\":\"8.0.4\",\"typedoc\":\"0.21.6\",\"typedoc-plugin-toc-group\":\"thoughtspot/typedoc-plugin-toc-group\",\"typescript\":\"^4.9.4\",\"typescript-eslint\":\"^8.29.1\",\"url-search-params-polyfill\":\"^8.1.0\",\"util\":\"^0.12.4\",\"vite\":\"^6.3.5\"},\"author\":\"ThoughtSpot\",\"email\":\"support@thoughtspot.com\",\"license\":\"ThoughtSpot Development Tools End User License Agreement\",\"directories\":{\"lib\":\"lib\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/thoughtspot/visual-embed-sdk.git\"},\"publishConfig\":{\"registry\":\"https://registry.npmjs.org\"},\"keywords\":[\"thoughtspot\",\"everywhere\",\"embedded\",\"embed\",\"sdk\",\"analytics\"],\"bugs\":{\"url\":\"https://github.com/thoughtspot/visual-embed-sdk/issues\"},\"homepage\":\"https://github.com/thoughtspot/visual-embed-sdk#readme\",\"globals\":{\"window\":{}}}");

});

parcelRegister("gnR3r", function(module, exports) {

$parcel$export(module.exports, "HostEventClient", function () { return $bed7f2db24c5045e$export$ebb560279205c352; });

var $dV0Ap = parcelRequire("dV0Ap");

var $e2GRa = parcelRequire("e2GRa");

var $a6640 = parcelRequire("a6640");

var $kklak = parcelRequire("kklak");

var $cMxso = parcelRequire("cMxso");
/**
 * Maps HostEvent to its corresponding UIPassthroughEvent.
 * Includes both custom-handler events (Pin, SaveAnswer, UpdateFilters, DrillDown)
 * and getter events (GetAnswerSession, GetFilters, etc.) that use getDataWithPassthroughFallback.
 */ const $bed7f2db24c5045e$var$PASSTHROUGH_MAP = {
    // Custom handlers (setters with special logic)
    [(0, $dV0Ap.HostEvent).Pin]: (0, $cMxso.UIPassthroughEvent).PinAnswerToLiveboard,
    [(0, $dV0Ap.HostEvent).SaveAnswer]: (0, $cMxso.UIPassthroughEvent).SaveAnswer,
    [(0, $dV0Ap.HostEvent).UpdateFilters]: (0, $cMxso.UIPassthroughEvent).UpdateFilters,
    [(0, $dV0Ap.HostEvent).DrillDown]: (0, $cMxso.UIPassthroughEvent).Drilldown,
    // Getters (use getDataWithPassthroughFallback)
    [(0, $dV0Ap.HostEvent).GetAnswerSession]: (0, $cMxso.UIPassthroughEvent).GetAnswerSession,
    [(0, $dV0Ap.HostEvent).GetFilters]: (0, $cMxso.UIPassthroughEvent).GetFilters,
    [(0, $dV0Ap.HostEvent).GetIframeUrl]: (0, $cMxso.UIPassthroughEvent).GetIframeUrl,
    [(0, $dV0Ap.HostEvent).GetParameters]: (0, $cMxso.UIPassthroughEvent).GetParameters,
    [(0, $dV0Ap.HostEvent).GetTML]: (0, $cMxso.UIPassthroughEvent).GetTML,
    [(0, $dV0Ap.HostEvent).GetTabs]: (0, $cMxso.UIPassthroughEvent).GetTabs,
    [(0, $dV0Ap.HostEvent).getExportRequestForCurrentPinboard]: (0, $cMxso.UIPassthroughEvent).GetExportRequestForCurrentPinboard
};
class $bed7f2db24c5045e$export$ebb560279205c352 {
    constructor(iFrame){
        /** Cached list of available UI passthrough keys from the embedded app */ this.availablePassthroughKeysCache = null;
        this.iFrame = iFrame;
        this.customHandlers = {
            [(0, $dV0Ap.HostEvent).Pin]: (p, c)=>this.handlePinEvent(p, c),
            [(0, $dV0Ap.HostEvent).SaveAnswer]: (p, c)=>this.handleSaveAnswerEvent(p, c),
            [(0, $dV0Ap.HostEvent).UpdateFilters]: (p, c)=>this.handleUpdateFiltersEvent(p, c),
            [(0, $dV0Ap.HostEvent).DrillDown]: (p, c)=>this.handleDrillDownEvent(p, c)
        };
    }
    /**
     * A wrapper over process trigger to
     * @param {HostEvent} message Host event to send
     * @param {any} data Data to send with the host event
     * @returns {Promise<any>} - the response from the process trigger
     */ async processTrigger(message, data, context) {
        if (!this.iFrame) throw new Error('Iframe element is not set');
        const thoughtspotHost = (0, $a6640.getEmbedConfig)().thoughtSpotHost;
        return (0, $e2GRa.processTrigger)(this.iFrame, message, thoughtspotHost, data, context);
    }
    async handleHostEventWithParam(apiName, parameters, context) {
        var _a, _b, _c, _d;
        const response = (_b = (_a = await this.triggerUIPassthroughApi(apiName, parameters, context)) === null || _a === void 0 ? void 0 : _a.find) === null || _b === void 0 ? void 0 : _b.call(_a, (r)=>r.error || r.value);
        if (!response) {
            const error = `No answer found${parameters.vizId ? ` for vizId: ${parameters.vizId}` : ''}.`;
            throw {
                error: error
            };
        }
        const errors = response.error || ((_c = response.value) === null || _c === void 0 ? void 0 : _c.errors) || ((_d = response.value) === null || _d === void 0 ? void 0 : _d.error);
        if (errors) {
            const message = typeof errors === 'string' ? errors : JSON.stringify(errors);
            throw {
                error: message
            };
        }
        return {
            ...response.value
        };
    }
    async hostEventFallback(hostEvent, data, context) {
        return this.processTrigger(hostEvent, data, context);
    }
    /**
     * For getter events that return data. Tries UI passthrough first;
     * if the app doesn't support it (no response data), falls back to
     * the legacy host event channel. Real errors are thrown as-is.
     */ async getDataWithPassthroughFallback(passthroughEvent, hostEvent, payload, context) {
        var _a, _b, _c;
        const response = await this.triggerUIPassthroughApi(passthroughEvent, payload || {}, context);
        const matched = (_a = response === null || response === void 0 ? void 0 : response.find) === null || _a === void 0 ? void 0 : _a.call(response, (r)=>r.error || r.value);
        if (!matched) return this.hostEventFallback(hostEvent, payload, context);
        const errors = matched.error || ((_b = matched.value) === null || _b === void 0 ? void 0 : _b.errors) || ((_c = matched.value) === null || _c === void 0 ? void 0 : _c.error);
        if (errors) {
            const message = typeof errors === 'string' ? errors : JSON.stringify(errors);
            throw new Error(message);
        }
        return {
            ...matched.value
        };
    }
    /**
     * Setter for the iframe element used for host events
     * @param {HTMLIFrameElement} iFrame - the iframe element to set
     */ setIframeElement(iFrame) {
        this.iFrame = iFrame;
    }
    /**
     * Fetches the list of available UI passthrough keys from the embedded app.
     * Result is cached for the session. Returns empty array on failure.
     */ async getAvailableUIPassthroughKeys(context) {
        var _a, _b;
        if (this.availablePassthroughKeysCache !== null) return this.availablePassthroughKeysCache;
        try {
            const response = await this.triggerUIPassthroughApi((0, $cMxso.UIPassthroughEvent).GetAvailableUIPassthroughs, {}, context);
            const matched = (_a = response === null || response === void 0 ? void 0 : response.find) === null || _a === void 0 ? void 0 : _a.call(response, (r)=>r.value && !r.error);
            const keys = (_b = matched === null || matched === void 0 ? void 0 : matched.value) === null || _b === void 0 ? void 0 : _b.keys;
            this.availablePassthroughKeysCache = Array.isArray(keys) ? keys : [];
            return this.availablePassthroughKeysCache;
        } catch  {
            return [];
        }
    }
    async triggerUIPassthroughApi(apiName, parameters, context) {
        const res = await this.processTrigger((0, $dV0Ap.HostEvent).UIPassthrough, {
            type: apiName,
            parameters: parameters
        }, context);
        return res;
    }
    async handlePinEvent(payload, context) {
        var _a, _b;
        if (!payload || !('newVizName' in payload)) return this.hostEventFallback((0, $dV0Ap.HostEvent).Pin, payload, context);
        const formattedPayload = {
            ...payload,
            pinboardId: (_a = payload.liveboardId) !== null && _a !== void 0 ? _a : payload.pinboardId,
            newPinboardName: (_b = payload.newLiveboardName) !== null && _b !== void 0 ? _b : payload.newPinboardName
        };
        const data = await this.handleHostEventWithParam((0, $cMxso.UIPassthroughEvent).PinAnswerToLiveboard, formattedPayload, context);
        return {
            ...data,
            liveboardId: data.pinboardId
        };
    }
    async handleSaveAnswerEvent(payload, context) {
        var _a, _b, _c, _d;
        if (!payload || !('name' in payload) || !('description' in payload)) // Save is the fallback for SaveAnswer
        return this.hostEventFallback((0, $dV0Ap.HostEvent).Save, payload, context);
        const data = await this.handleHostEventWithParam((0, $cMxso.UIPassthroughEvent).SaveAnswer, payload, context);
        return {
            ...data,
            answerId: (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.saveResponse) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.Answer__save) === null || _c === void 0 ? void 0 : _c.answer) === null || _d === void 0 ? void 0 : _d.id
        };
    }
    handleUpdateFiltersEvent(payload, context) {
        if (!(0, $kklak.isValidUpdateFiltersPayload)(payload)) (0, $kklak.throwUpdateFiltersValidationError)();
        return this.handleHostEventWithParam((0, $cMxso.UIPassthroughEvent).UpdateFilters, payload, context);
    }
    handleDrillDownEvent(payload, context) {
        if (!(0, $kklak.isValidDrillDownPayload)(payload)) (0, $kklak.throwDrillDownValidationError)();
        return this.handleHostEventWithParam((0, $cMxso.UIPassthroughEvent).Drilldown, payload, context);
    }
    /**
     * Dispatches a host event using the appropriate channel:
     * 1. If the embedded app supports UI passthrough for this event, use it (custom handler or getter).
     * 2. Otherwise fall back to the legacy host event channel.
     *
     * @param hostEvent - The host event to trigger
     * @param payload - Optional payload for the event
     * @param context - Optional context (e.g. vizId) for scoped operations
     */ async triggerHostEvent(hostEvent, payload, context) {
        const customHandler = this.customHandlers[hostEvent];
        const passthroughEvent = $bed7f2db24c5045e$var$PASSTHROUGH_MAP[hostEvent];
        // If embedded app supports passthrough but not this event, use legacy channel
        const keys = passthroughEvent ? await this.getAvailableUIPassthroughKeys(context) : [];
        if (passthroughEvent && keys.length > 0 && !keys.includes(passthroughEvent)) return this.hostEventFallback(hostEvent, payload, context);
        // Custom handler (setters) > getter passthrough > legacy fallback
        return customHandler ? customHandler(payload, context) : passthroughEvent ? this.getDataWithPassthroughFallback(passthroughEvent, hostEvent, payload, context) : this.hostEventFallback(hostEvent, payload, context);
    }
}

});
parcelRegister("kklak", function(module, exports) {

$parcel$export(module.exports, "isValidUpdateFiltersPayload", function () { return $ecc617ee216ff9d3$export$fc2b4919ab672c80; });
$parcel$export(module.exports, "isValidDrillDownPayload", function () { return $ecc617ee216ff9d3$export$4d734747d1bc5de0; });
$parcel$export(module.exports, "throwUpdateFiltersValidationError", function () { return $ecc617ee216ff9d3$export$fda581ab9febc135; });
$parcel$export(module.exports, "throwDrillDownValidationError", function () { return $ecc617ee216ff9d3$export$78b88b8bd59a942d; });

var $dV0Ap = parcelRequire("dV0Ap");

var $h7cYZ = parcelRequire("h7cYZ");

var $7aJfj = parcelRequire("7aJfj");
function $ecc617ee216ff9d3$export$fc2b4919ab672c80(payload) {
    if (!payload) return false;
    const isValidFilter = (f)=>{
        const hasColumn = typeof f.column === 'string' || typeof f.columnName === 'string';
        const hasOperator = typeof f.oper === 'string' || typeof f.operator === 'string';
        const hasValues = Array.isArray(f.values);
        const validType = !f.type || typeof f.type === 'string';
        return hasColumn && hasOperator && hasValues && validType;
    };
    const hasValidFilter = payload.filter && isValidFilter(payload.filter);
    const hasValidFilters = Array.isArray(payload.filters) && payload.filters.length > 0 && payload.filters.every(isValidFilter);
    return !!(hasValidFilter || hasValidFilters);
}
function $ecc617ee216ff9d3$export$4d734747d1bc5de0(payload) {
    if (!payload) return false;
    const points = payload.points;
    if (!points || typeof points !== 'object') return false;
    const hasClickedPoint = 'clickedPoint' in points && points.clickedPoint != null;
    const hasSelectedPoints = Array.isArray(points.selectedPoints) && points.selectedPoints.length > 0;
    return hasClickedPoint || hasSelectedPoints;
}
function $ecc617ee216ff9d3$export$917c51cf81aee5b7(message) {
    const err = new Error(message);
    err.isValidationError = true;
    err.embedErrorDetails = {
        type: (0, $dV0Ap.EmbedEvent).Error,
        data: {
            errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
            message: message,
            code: (0, $dV0Ap.EmbedErrorCodes).HOST_EVENT_VALIDATION,
            error: message
        },
        status: (0, $7aJfj.embedEventStatus).END
    };
    throw err;
}
function $ecc617ee216ff9d3$export$fda581ab9febc135() {
    $ecc617ee216ff9d3$export$917c51cf81aee5b7((0, $h7cYZ.ERROR_MESSAGE).UPDATEFILTERS_INVALID_PAYLOAD);
}
function $ecc617ee216ff9d3$export$78b88b8bd59a942d() {
    $ecc617ee216ff9d3$export$917c51cf81aee5b7((0, $h7cYZ.ERROR_MESSAGE).DRILLDOWN_INVALID_PAYLOAD);
}

});


parcelRegister("1G6ZM", function(module, exports) {

$parcel$export(module.exports, "getInterceptInitData", function () { return $138f23d6930946bf$export$e8ec047ed273f6cf; });
$parcel$export(module.exports, "handleInterceptEvent", function () { return $138f23d6930946bf$export$1d4fc87233d679c4; });
$parcel$export(module.exports, "processApiInterceptResponse", function () { return $138f23d6930946bf$export$adb9d6ea0caeb1da; });
$parcel$export(module.exports, "processLegacyInterceptResponse", function () { return $138f23d6930946bf$export$196533fbc29c739; });

var $10hiU = parcelRequire("10hiU");

var $a6640 = parcelRequire("a6640");

var $h7cYZ = parcelRequire("h7cYZ");

var $dV0Ap = parcelRequire("dV0Ap");

var $7aJfj = parcelRequire("7aJfj");

var $kCAID = parcelRequire("kCAID");
const $138f23d6930946bf$var$DefaultInterceptUrlsMap = {
    [(0, $dV0Ap.InterceptedApiType).AnswerData]: [
        '/prism/?op=GetChartWithData',
        '/prism/?op=GetTableWithHeadlineData',
        '/prism/?op=GetTableWithData'
    ],
    [(0, $dV0Ap.InterceptedApiType).LiveboardData]: [
        '/prism/?op=LoadContextBook'
    ]
};
const $138f23d6930946bf$var$formatInterceptUrl = (url)=>{
    const host = (0, $10hiU.getThoughtSpotHost)((0, $a6640.getEmbedConfig)());
    if (url.startsWith('/')) return `${host}${url}`;
    return url;
};
/**
 * Converts user passed url values to proper urls
 * [ANSER_DATA] => ['https://host/pris/op?=op']
 * @param interceptUrls
 * @returns
 */ const $138f23d6930946bf$var$processInterceptUrls = (interceptUrls)=>{
    let processedUrls = [
        ...interceptUrls
    ];
    Object.entries($138f23d6930946bf$var$DefaultInterceptUrlsMap).forEach(([apiType, apiTypeUrls])=>{
        if (!processedUrls.includes(apiType)) return;
        processedUrls = processedUrls.filter((url)=>url !== apiType);
        processedUrls = [
            ...processedUrls,
            ...apiTypeUrls
        ];
    });
    return processedUrls.map((url)=>$138f23d6930946bf$var$formatInterceptUrl(url));
};
const $138f23d6930946bf$export$e8ec047ed273f6cf = (viewConfig)=>{
    const combinedUrls = [
        ...viewConfig.interceptUrls || []
    ];
    if (viewConfig.isOnBeforeGetVizDataInterceptEnabled) combinedUrls.push((0, $dV0Ap.InterceptedApiType).AnswerData);
    const shouldInterceptAll = combinedUrls.includes((0, $dV0Ap.InterceptedApiType).ALL);
    const interceptUrls = shouldInterceptAll ? [
        (0, $dV0Ap.InterceptedApiType).ALL
    ] : $138f23d6930946bf$var$processInterceptUrls(combinedUrls);
    const interceptTimeout = viewConfig.interceptTimeout;
    return {
        interceptUrls: interceptUrls,
        interceptTimeout: interceptTimeout
    };
};
const $138f23d6930946bf$var$parseJson = (jsonString)=>{
    try {
        const json = JSON.parse(jsonString);
        return [
            json,
            null
        ];
    } catch (error) {
        return [
            null,
            error
        ];
    }
};
/**
 * Parse the api intercept data and return the parsed data and error if any
 * Embed returns the input and init from the fetch call
 */ const $138f23d6930946bf$var$parseInterceptData = (eventDataString)=>{
    try {
        const [parsedData, error] = $138f23d6930946bf$var$parseJson(eventDataString);
        if (error) return [
            null,
            error
        ];
        const { input: input, init: init } = parsedData;
        const [parsedBody, bodyParseError] = $138f23d6930946bf$var$parseJson(init.body);
        if (!bodyParseError) init.body = parsedBody;
        const parsedInit = {
            input: input,
            init: init
        };
        return [
            parsedInit,
            null
        ];
    } catch (error) {
        return [
            null,
            error
        ];
    }
};
const $138f23d6930946bf$var$getUrlType = (url)=>{
    for (const [apiType, apiTypeUrls] of Object.entries($138f23d6930946bf$var$DefaultInterceptUrlsMap)){
        if (apiTypeUrls.includes(url)) return apiType;
    }
    // TODO: have a unknown type maybe ??
    return (0, $dV0Ap.InterceptedApiType).ALL;
};
const $138f23d6930946bf$export$1d4fc87233d679c4 = async (params)=>{
    var _a, _b, _c, _d, _e;
    const { eventData: eventData, executeEvent: executeEvent, viewConfig: viewConfig, getUnsavedAnswerTml: getUnsavedAnswerTml } = params;
    const [interceptData, bodyParseError] = $138f23d6930946bf$var$parseInterceptData(eventData.data);
    if (bodyParseError) {
        const errorDetails = {
            errorType: (0, $dV0Ap.ErrorDetailsTypes).API,
            message: (0, $h7cYZ.ERROR_MESSAGE).ERROR_PARSING_API_INTERCEPT_BODY,
            code: (0, $dV0Ap.EmbedErrorCodes).PARSING_API_INTERCEPT_BODY_ERROR,
            error: (0, $h7cYZ.ERROR_MESSAGE).ERROR_PARSING_API_INTERCEPT_BODY
        };
        executeEvent((0, $dV0Ap.EmbedEvent).Error, errorDetails);
        (0, $kCAID.logger).error('Error parsing request body', bodyParseError);
        return;
    }
    const { input: requestUrl, init: init } = interceptData;
    const sessionId = (_c = (_b = (_a = init === null || init === void 0 ? void 0 : init.body) === null || _a === void 0 ? void 0 : _a.variables) === null || _b === void 0 ? void 0 : _b.session) === null || _c === void 0 ? void 0 : _c.sessionId;
    const vizId = (_e = (_d = init === null || init === void 0 ? void 0 : init.body) === null || _d === void 0 ? void 0 : _d.variables) === null || _e === void 0 ? void 0 : _e.contextBookId;
    const answerDataUrls = $138f23d6930946bf$var$DefaultInterceptUrlsMap[(0, $dV0Ap.InterceptedApiType).AnswerData];
    const legacyInterceptEnabled = viewConfig.isOnBeforeGetVizDataInterceptEnabled;
    const isAnswerDataUrl = answerDataUrls.includes(requestUrl);
    const sendLegacyIntercept = isAnswerDataUrl && legacyInterceptEnabled;
    if (sendLegacyIntercept) {
        const answerTml = await getUnsavedAnswerTml({
            sessionId: sessionId,
            vizId: vizId
        });
        // Build the legacy payload for backwards compatibility
        const legacyPayload = {
            data: {
                data: answerTml,
                status: (0, $7aJfj.embedEventStatus).END,
                type: (0, $dV0Ap.EmbedEvent).OnBeforeGetVizDataIntercept
            }
        };
        executeEvent((0, $dV0Ap.EmbedEvent).OnBeforeGetVizDataIntercept, legacyPayload);
    }
    const urlType = $138f23d6930946bf$var$getUrlType(requestUrl);
    executeEvent((0, $dV0Ap.EmbedEvent).ApiIntercept, {
        ...interceptData,
        urlType: urlType
    });
};
const $138f23d6930946bf$export$adb9d6ea0caeb1da = (payload)=>{
    var _a;
    const isLegacyFormat = (_a = payload === null || payload === void 0 ? void 0 : payload.data) === null || _a === void 0 ? void 0 : _a.error;
    if (isLegacyFormat) return $138f23d6930946bf$export$196533fbc29c739(payload);
    return payload;
};
const $138f23d6930946bf$export$196533fbc29c739 = (payload)=>{
    var _a, _b, _c, _d, _e;
    const errorText = (_b = (_a = payload === null || payload === void 0 ? void 0 : payload.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.errorText;
    const errorDescription = (_d = (_c = payload === null || payload === void 0 ? void 0 : payload.data) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.errorDescription;
    const payloadToSend = {
        execute: (_e = payload === null || payload === void 0 ? void 0 : payload.data) === null || _e === void 0 ? void 0 : _e.execute,
        response: {
            body: {
                errors: [
                    {
                        title: errorText,
                        description: errorDescription,
                        isUserError: true
                    }
                ],
                data: {}
            }
        }
    };
    return {
        data: payloadToSend
    };
};

});


parcelRegister("b8Ldn", function(module, exports) {

$parcel$export(module.exports, "buildSpotterSidebarAppInitData", function () { return $81c510f2e9cd124e$export$21610a4c6ecde4b4; });

var $dV0Ap = parcelRequire("dV0Ap");

var $7aJfj = parcelRequire("7aJfj");

var $h7cYZ = parcelRequire("h7cYZ");
const $81c510f2e9cd124e$export$ce6dc4a8ced17c7c = (params)=>params.spotterSidebarConfigValue !== undefined ? params.spotterSidebarConfigValue : params.standaloneValue;
function $81c510f2e9cd124e$export$21610a4c6ecde4b4(defaultAppInitData, viewConfig, handleError) {
    const { spotterSidebarConfig: spotterSidebarConfig, enablePastConversationsSidebar: enablePastConversationsSidebar } = viewConfig;
    const resolvedEnablePastConversations = $81c510f2e9cd124e$export$ce6dc4a8ced17c7c({
        spotterSidebarConfigValue: spotterSidebarConfig === null || spotterSidebarConfig === void 0 ? void 0 : spotterSidebarConfig.enablePastConversationsSidebar,
        standaloneValue: enablePastConversationsSidebar
    });
    const hasConfig = spotterSidebarConfig || resolvedEnablePastConversations !== undefined;
    if (!hasConfig) return defaultAppInitData;
    const resolvedSidebarConfig = {
        ...spotterSidebarConfig,
        ...resolvedEnablePastConversations !== undefined && {
            enablePastConversationsSidebar: resolvedEnablePastConversations
        }
    };
    if (resolvedSidebarConfig.spotterDocumentationUrl !== undefined) {
        const [isValid, validationError] = (0, $7aJfj.validateHttpUrl)(resolvedSidebarConfig.spotterDocumentationUrl);
        if (!isValid) {
            handleError({
                errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
                message: (0, $h7cYZ.ERROR_MESSAGE).INVALID_SPOTTER_DOCUMENTATION_URL,
                code: (0, $dV0Ap.EmbedErrorCodes).INVALID_URL,
                error: (validationError === null || validationError === void 0 ? void 0 : validationError.message) || (0, $h7cYZ.ERROR_MESSAGE).INVALID_SPOTTER_DOCUMENTATION_URL
            });
            delete resolvedSidebarConfig.spotterDocumentationUrl;
        }
    }
    return {
        ...defaultAppInitData,
        embedParams: {
            ...defaultAppInitData.embedParams || {},
            spotterSidebarConfig: resolvedSidebarConfig
        }
    };
}

});


parcelRegister("dPO2k", function(module, exports) {

$parcel$export(module.exports, "LiveboardEmbed", function () { return $a126da043e03bca1$export$3f48e59c930ef0ae; });
/**
 * Copyright (c) 2022
 *
 * Embed a ThoughtSpot Liveboard or visualization
 * https://developers.thoughtspot.com/docs/embed-liveboard
 * https://developers.thoughtspot.com/docs/embed-a-viz
 * @summary Liveboard & visualization embed
 * @author Ayon Ghosh <ayon.ghosh@thoughtspot.com>
 */ 
var $d45vL = parcelRequire("d45vL");

var $h7cYZ = parcelRequire("h7cYZ");

var $dV0Ap = parcelRequire("dV0Ap");

var $7aJfj = parcelRequire("7aJfj");

var $2SBdZ = parcelRequire("2SBdZ");

var $jhzgw = parcelRequire("jhzgw");

var $kCAID = parcelRequire("kCAID");
class $a126da043e03bca1$export$3f48e59c930ef0ae extends (0, $2SBdZ.V1Embed) {
    constructor(domSelector, viewConfig){
        viewConfig.embedComponentType = 'LiveboardEmbed';
        super(domSelector, viewConfig);
        this.defaultHeight = 500;
        this.sendFullHeightLazyLoadData = ()=>{
            const data = (0, $7aJfj.calculateVisibleElementData)(this.iFrame);
            // this should be fired only if the lazyLoadingForFullHeight and fullHeight are true
            if (this.viewConfig.lazyLoadingForFullHeight && this.viewConfig.fullHeight) this.trigger((0, $dV0Ap.HostEvent).VisibleEmbedCoordinates, data);
        };
        /**
         * This is a handler for the RequestVisibleEmbedCoordinates event.
         * It is used to send the visible coordinates data to the host application.
         * @param data The event payload
         * @param responder The responder function
         */ this.requestVisibleEmbedCoordinatesHandler = (data, responder)=>{
            (0, $kCAID.logger).info('Sending RequestVisibleEmbedCoordinates', data);
            const visibleCoordinatesData = (0, $7aJfj.calculateVisibleElementData)(this.iFrame);
            responder({
                type: (0, $dV0Ap.EmbedEvent).RequestVisibleEmbedCoordinates,
                data: visibleCoordinatesData
            });
        };
        /**
         * Set the iframe height as per the computed height received
         * from the ThoughtSpot app.
         * @param data The event payload
         */ this.updateIFrameHeight = (data)=>{
            this.setIFrameHeight(Math.max(data.data, this.defaultHeight));
            this.sendFullHeightLazyLoadData();
        };
        this.embedIframeCenter = (data, responder)=>{
            const obj = this.getIframeCenter();
            responder({
                type: (0, $dV0Ap.EmbedEvent).EmbedIframeCenter,
                data: obj
            });
        };
        this.setIframeHeightForNonEmbedLiveboard = (data)=>{
            const { height: frameHeight } = this.viewConfig.frameParams || {};
            const liveboardRelatedRoutes = [
                '/pinboard/',
                '/insights/pinboard/',
                '/schedules/',
                '/embed/viz/',
                '/embed/insights/viz/',
                '/liveboard/',
                '/insights/liveboard/',
                '/tsl-editor/PINBOARD_ANSWER_BOOK/',
                '/import-tsl/PINBOARD_ANSWER_BOOK/'
            ];
            if (liveboardRelatedRoutes.some((path)=>data.data.currentPath.startsWith(path))) // Ignore the height reset of the frame, if the navigation is
            // only within the liveboard page.
            return;
            this.setIFrameHeight(frameHeight || this.defaultHeight);
        };
        /**
         * @hidden
         * Internal state to track the current liveboard id.
         * This is used to navigate to the correct liveboard when the prerender is visible.
         */ this.currentLiveboardState = {
            liveboardId: this.viewConfig.liveboardId,
            vizId: this.viewConfig.vizId,
            activeTabId: this.viewConfig.activeTabId,
            personalizedViewId: this.viewConfig.personalizedViewId
        };
        if (this.viewConfig.fullHeight === true) {
            if (this.viewConfig.vizId) (0, $kCAID.logger).warn("Full height is currently only supported for Liveboard embeds.Using full height with vizId might lead to unexpected behavior.");
            this.on((0, $dV0Ap.EmbedEvent).RouteChange, this.setIframeHeightForNonEmbedLiveboard);
            this.on((0, $dV0Ap.EmbedEvent).EmbedHeight, this.updateIFrameHeight);
            this.on((0, $dV0Ap.EmbedEvent).EmbedIframeCenter, this.embedIframeCenter);
            this.on((0, $dV0Ap.EmbedEvent).RequestVisibleEmbedCoordinates, this.requestVisibleEmbedCoordinatesHandler);
        }
    }
    /**
     * Construct a map of params to be passed on to the
     * embedded Liveboard or visualization.
     */ getEmbedParams() {
        const params = this.getEmbedParamsObject();
        const queryParams = (0, $7aJfj.getQueryParamString)(params, true);
        return queryParams;
    }
    getEmbedParamsObject() {
        let params = {};
        params = this.getBaseQueryParams(params);
        const { enableVizTransformations: enableVizTransformations, fullHeight: fullHeight, defaultHeight: defaultHeight, minimumHeight: minimumHeight, visibleVizs: visibleVizs, liveboardV2: liveboardV2, vizId: vizId, hideTabPanel: hideTabPanel, activeTabId: activeTabId, hideLiveboardHeader: hideLiveboardHeader, showLiveboardDescription: showLiveboardDescription, showLiveboardTitle: showLiveboardTitle, isLiveboardHeaderSticky: isLiveboardHeaderSticky = true, isLiveboardCompactHeaderEnabled: isLiveboardCompactHeaderEnabled = false, showLiveboardVerifiedBadge: showLiveboardVerifiedBadge = true, showLiveboardReverifyBanner: showLiveboardReverifyBanner = true, hideIrrelevantChipsInLiveboardTabs: hideIrrelevantChipsInLiveboardTabs = false, showMaskedFilterChip: showMaskedFilterChip = false, isLiveboardMasterpiecesEnabled: isLiveboardMasterpiecesEnabled = false, isEnhancedFilterInteractivityEnabled: isEnhancedFilterInteractivityEnabled = false, enableAskSage: enableAskSage, enable2ColumnLayout: enable2ColumnLayout, dataPanelV2: dataPanelV2 = true, enableCustomColumnGroups: enableCustomColumnGroups = false, oAuthPollingInterval: oAuthPollingInterval, isForceRedirect: isForceRedirect, dataSourceId: dataSourceId, coverAndFilterOptionInPDF: coverAndFilterOptionInPDF = false, isLiveboardStylingAndGroupingEnabled: isLiveboardStylingAndGroupingEnabled, isPNGInScheduledEmailsEnabled: isPNGInScheduledEmailsEnabled = false, isLiveboardXLSXCSVDownloadEnabled: isLiveboardXLSXCSVDownloadEnabled = false, isGranularXLSXCSVSchedulesEnabled: isGranularXLSXCSVSchedulesEnabled = false, showSpotterLimitations: showSpotterLimitations, isCentralizedLiveboardFilterUXEnabled: isCentralizedLiveboardFilterUXEnabled = false, isLinkParametersEnabled: isLinkParametersEnabled, updatedSpotterChatPrompt: updatedSpotterChatPrompt, enableStopAnswerGenerationEmbed: enableStopAnswerGenerationEmbed, spotterChatConfig: spotterChatConfig, isThisPeriodInDateFiltersEnabled: isThisPeriodInDateFiltersEnabled, isContinuousLiveboardPDFEnabled: isContinuousLiveboardPDFEnabled } = this.viewConfig;
        const preventLiveboardFilterRemoval = this.viewConfig.preventLiveboardFilterRemoval || this.viewConfig.preventPinboardFilterRemoval;
        if (fullHeight === true) {
            params[(0, $dV0Ap.Param).fullHeight] = true;
            if (this.viewConfig.lazyLoadingForFullHeight) {
                params[(0, $dV0Ap.Param).IsLazyLoadingForEmbedEnabled] = true;
                if ((0, $7aJfj.isValidCssMargin)(this.viewConfig.lazyLoadingMargin)) params[(0, $dV0Ap.Param).RootMarginForLazyLoad] = this.viewConfig.lazyLoadingMargin;
            }
        }
        this.defaultHeight = minimumHeight || defaultHeight || this.defaultHeight;
        if (enableVizTransformations !== undefined) params[(0, $dV0Ap.Param).EnableVizTransformations] = enableVizTransformations.toString();
        if (preventLiveboardFilterRemoval) params[(0, $dV0Ap.Param).preventLiveboardFilterRemoval] = true;
        if (!(0, $7aJfj.isUndefined)(updatedSpotterChatPrompt)) params[(0, $dV0Ap.Param).UpdatedSpotterChatPrompt] = !!updatedSpotterChatPrompt;
        if (!(0, $7aJfj.isUndefined)(enableStopAnswerGenerationEmbed)) params[(0, $dV0Ap.Param).EnableStopAnswerGenerationEmbed] = !!enableStopAnswerGenerationEmbed;
        if (visibleVizs) params[(0, $dV0Ap.Param).visibleVizs] = visibleVizs;
        params[(0, $dV0Ap.Param).livedBoardEmbed] = true;
        if (vizId) params[(0, $dV0Ap.Param).vizEmbed] = true;
        if (liveboardV2 !== undefined) params[(0, $dV0Ap.Param).LiveboardV2Enabled] = liveboardV2;
        if (enable2ColumnLayout !== undefined) params[(0, $dV0Ap.Param).Enable2ColumnLayout] = enable2ColumnLayout;
        if (hideTabPanel) params[(0, $dV0Ap.Param).HideTabPanel] = hideTabPanel;
        if (hideLiveboardHeader) params[(0, $dV0Ap.Param).HideLiveboardHeader] = hideLiveboardHeader;
        if (showLiveboardDescription) params[(0, $dV0Ap.Param).ShowLiveboardDescription] = showLiveboardDescription;
        if (showLiveboardTitle) params[(0, $dV0Ap.Param).ShowLiveboardTitle] = showLiveboardTitle;
        if (enableAskSage) params[(0, $dV0Ap.Param).enableAskSage] = enableAskSage;
        if (oAuthPollingInterval !== undefined) params[(0, $dV0Ap.Param).OauthPollingInterval] = oAuthPollingInterval;
        if (isForceRedirect) params[(0, $dV0Ap.Param).IsForceRedirect] = isForceRedirect;
        if (dataSourceId !== undefined) params[(0, $dV0Ap.Param).DataSourceId] = dataSourceId;
        if (isLiveboardStylingAndGroupingEnabled !== undefined) params[(0, $dV0Ap.Param).IsLiveboardStylingAndGroupingEnabled] = isLiveboardStylingAndGroupingEnabled;
        if (isPNGInScheduledEmailsEnabled !== undefined) params[(0, $dV0Ap.Param).isPNGInScheduledEmailsEnabled] = isPNGInScheduledEmailsEnabled;
        if (isLiveboardXLSXCSVDownloadEnabled !== undefined) params[(0, $dV0Ap.Param).isLiveboardXLSXCSVDownloadEnabled] = isLiveboardXLSXCSVDownloadEnabled;
        if (isGranularXLSXCSVSchedulesEnabled !== undefined) params[(0, $dV0Ap.Param).isGranularXLSXCSVSchedulesEnabled] = isGranularXLSXCSVSchedulesEnabled;
        if (showSpotterLimitations !== undefined) params[(0, $dV0Ap.Param).ShowSpotterLimitations] = showSpotterLimitations;
        // Handle spotterChatConfig params
        if (spotterChatConfig) {
            const { hideToolResponseCardBranding: hideToolResponseCardBranding, toolResponseCardBrandingLabel: toolResponseCardBrandingLabel } = spotterChatConfig;
            (0, $7aJfj.setParamIfDefined)(params, (0, $dV0Ap.Param).HideToolResponseCardBranding, hideToolResponseCardBranding, true);
            (0, $7aJfj.setParamIfDefined)(params, (0, $dV0Ap.Param).ToolResponseCardBrandingLabel, toolResponseCardBrandingLabel);
        }
        if (isLinkParametersEnabled !== undefined) params[(0, $dV0Ap.Param).isLinkParametersEnabled] = isLinkParametersEnabled;
        if (isCentralizedLiveboardFilterUXEnabled !== undefined) params[(0, $dV0Ap.Param).isCentralizedLiveboardFilterUXEnabled] = isCentralizedLiveboardFilterUXEnabled;
        if (isThisPeriodInDateFiltersEnabled !== undefined) params[(0, $dV0Ap.Param).IsThisPeriodInDateFiltersEnabled] = isThisPeriodInDateFiltersEnabled;
        if (isContinuousLiveboardPDFEnabled !== undefined) params[(0, $dV0Ap.Param).IsWYSIWYGLiveboardPDFEnabled] = isContinuousLiveboardPDFEnabled;
        params[(0, $dV0Ap.Param).LiveboardHeaderSticky] = isLiveboardHeaderSticky;
        params[(0, $dV0Ap.Param).LiveboardHeaderV2] = isLiveboardCompactHeaderEnabled;
        params[(0, $dV0Ap.Param).ShowLiveboardVerifiedBadge] = showLiveboardVerifiedBadge;
        params[(0, $dV0Ap.Param).ShowLiveboardReverifyBanner] = showLiveboardReverifyBanner;
        params[(0, $dV0Ap.Param).HideIrrelevantFiltersInTab] = hideIrrelevantChipsInLiveboardTabs;
        params[(0, $dV0Ap.Param).ShowMaskedFilterChip] = showMaskedFilterChip;
        params[(0, $dV0Ap.Param).IsLiveboardMasterpiecesEnabled] = isLiveboardMasterpiecesEnabled;
        params[(0, $dV0Ap.Param).IsEnhancedFilterInteractivityEnabled] = isEnhancedFilterInteractivityEnabled;
        params[(0, $dV0Ap.Param).DataPanelV2Enabled] = dataPanelV2;
        params[(0, $dV0Ap.Param).EnableCustomColumnGroups] = enableCustomColumnGroups;
        params[(0, $dV0Ap.Param).CoverAndFilterOptionInPDF] = coverAndFilterOptionInPDF;
        const queryParams = (0, $7aJfj.getQueryParamString)(params, true);
        return params;
    }
    getIframeSuffixSrc(liveboardId, vizId, activeTabId, personalizedViewId) {
        // Extract view from liveboardId if passed along with it (legacy
        // approach)
        // View must be appended as query param at the end, not
        // embedded in path
        let liveboardGuid = liveboardId;
        let legacyViewId;
        if (liveboardId === null || liveboardId === void 0 ? void 0 : liveboardId.includes('?')) {
            const [id, query] = liveboardId.split('?');
            liveboardGuid = id;
            const params = new URLSearchParams(query);
            legacyViewId = params.get('view') || undefined;
        }
        // personalizedViewId takes precedence over legacyViewId (when passed
        // as part of liveboardId)
        const effectiveViewId = personalizedViewId || legacyViewId;
        let suffix = `/embed/viz/${liveboardGuid}`;
        if (activeTabId) suffix = `${suffix}/tab/${activeTabId}`;
        if (vizId) suffix = `${suffix}/${vizId}`;
        const additionalParams = {};
        if (effectiveViewId) additionalParams.view = effectiveViewId;
        const tsPostHashParams = this.getThoughtSpotPostUrlParams(additionalParams);
        suffix = `${suffix}${tsPostHashParams}`;
        return suffix;
    }
    /**
     * Construct the URL of the embedded ThoughtSpot Liveboard or visualization
     * to be loaded within the iFrame.
     */ getIFrameSrc() {
        var _a;
        const { vizId: vizId, activeTabId: activeTabId, personalizedViewId: personalizedViewId } = this.viewConfig;
        const liveboardId = (_a = this.viewConfig.liveboardId) !== null && _a !== void 0 ? _a : this.viewConfig.pinboardId;
        if (!liveboardId) this.handleError({
            errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
            message: (0, $h7cYZ.ERROR_MESSAGE).LIVEBOARD_VIZ_ID_VALIDATION,
            code: (0, $dV0Ap.EmbedErrorCodes).LIVEBOARD_ID_MISSING,
            error: (0, $h7cYZ.ERROR_MESSAGE).LIVEBOARD_VIZ_ID_VALIDATION
        });
        return `${this.getRootIframeSrc()}${this.getIframeSuffixSrc(liveboardId, vizId, activeTabId, personalizedViewId)}`;
    }
    setActiveTab(data) {
        if (!this.viewConfig.vizId) {
            const prefixPath = this.iFrame.src.split('#/')[1].split('/tab')[0];
            const path = `${prefixPath}/tab/${data.tabId}`;
            super.trigger((0, $dV0Ap.HostEvent).Navigate, path);
        }
    }
    async showPreviewLoader() {
        if (!this.viewConfig.showPreviewLoader || !this.viewConfig.vizId) return;
        try {
            const preview = await (0, $d45vL.getPreview)(this.thoughtSpotHost, this.viewConfig.vizId, this.viewConfig.liveboardId);
            if (!preview.vizContent) return;
            (0, $jhzgw.addPreviewStylesIfNotPresent)();
            const div = document.createElement('div');
            div.innerHTML = `
                <div class=ts-viz-preview-loader>
                    ${preview.vizContent}
                </div>
                `;
            const previewDiv = div.firstElementChild;
            this.el.appendChild(previewDiv);
            this.el.style.position = 'relative';
            this.on((0, $dV0Ap.EmbedEvent).Data, ()=>{
                previewDiv.remove();
            });
        } catch (error) {
            console.error('Error fetching preview', error);
        }
    }
    beforePrerenderVisible() {
        const embedObj = this.getPreRenderObj();
        this.executeAfterEmbedContainerLoaded(()=>{
            this.navigateToLiveboard(this.viewConfig.liveboardId, this.viewConfig.vizId, this.viewConfig.activeTabId, this.viewConfig.personalizedViewId);
            if (embedObj) embedObj.currentLiveboardState = {
                liveboardId: this.viewConfig.liveboardId,
                vizId: this.viewConfig.vizId,
                activeTabId: this.viewConfig.activeTabId,
                personalizedViewId: this.viewConfig.personalizedViewId
            };
        });
    }
    async handleRenderForPrerender() {
        if ((0, $7aJfj.isUndefined)(this.viewConfig.liveboardId)) return this.prerenderGeneric();
        return super.handleRenderForPrerender();
    }
    /**
     * Triggers an event to the embedded app
     * @param {HostEvent} messageType The event type
     * @param {any} data The payload to send with the message
     * @returns A promise that resolves with the response from the embedded app
     */ trigger(messageType, data = {}, context) {
        const dataWithVizId = data;
        if (messageType === (0, $dV0Ap.HostEvent).SetActiveTab) {
            this.setActiveTab(data);
            return Promise.resolve(null);
        }
        if (typeof dataWithVizId === 'object' && this.viewConfig.vizId) dataWithVizId.vizId = this.viewConfig.vizId;
        return super.trigger(messageType, dataWithVizId, context);
    }
    /**
     * Destroys the ThoughtSpot embed, and remove any nodes from the DOM.
     * @version SDK: 1.39.0 | ThoughtSpot: 10.10.0.cl
     */ destroy() {
        super.destroy();
        this.unregisterLazyLoadEvents();
    }
    postRender() {
        this.registerLazyLoadEvents();
    }
    registerLazyLoadEvents() {
        if (this.viewConfig.fullHeight && this.viewConfig.lazyLoadingForFullHeight) {
            // TODO: Use passive: true, install modernizr to check for passive
            window.addEventListener('resize', this.sendFullHeightLazyLoadData);
            window.addEventListener('scroll', this.sendFullHeightLazyLoadData, true);
        }
    }
    unregisterLazyLoadEvents() {
        if (this.viewConfig.fullHeight && this.viewConfig.lazyLoadingForFullHeight) {
            window.removeEventListener('resize', this.sendFullHeightLazyLoadData);
            window.removeEventListener('scroll', this.sendFullHeightLazyLoadData);
        }
    }
    /**
     * Render an embedded ThoughtSpot Liveboard or visualization
     * @param renderOptions An object specifying the Liveboard ID,
     * visualization ID and the runtime filters.
     */ async render() {
        await super.render();
        const src = this.getIFrameSrc();
        await this.renderV1Embed(src);
        this.showPreviewLoader();
        this.postRender();
        return this;
    }
    navigateToLiveboard(liveboardId, vizId, activeTabId, personalizedViewId) {
        const path = this.getIframeSuffixSrc(liveboardId, vizId, activeTabId, personalizedViewId);
        this.viewConfig.liveboardId = liveboardId;
        this.viewConfig.activeTabId = activeTabId;
        this.viewConfig.vizId = vizId;
        this.viewConfig.personalizedViewId = personalizedViewId;
        if (this.isRendered) this.trigger((0, $dV0Ap.HostEvent).Navigate, path.substring(1));
        else if (this.viewConfig.preRenderId) this.preRender(true);
        else this.render();
    }
    /**
     * Returns the full url of the Liveboard/visualization which can be used to open
     * this Liveboard inside the full ThoughtSpot application in a new tab.
     * @returns url string
     */ getLiveboardUrl() {
        let url = `${this.thoughtSpotHost}/#/pinboard/${this.viewConfig.liveboardId}`;
        if (this.viewConfig.activeTabId) url = `${url}/tab/${this.viewConfig.activeTabId}`;
        if (this.viewConfig.vizId) url = `${url}/${this.viewConfig.vizId}`;
        if (this.viewConfig.personalizedViewId) url = `${url}?view=${this.viewConfig.personalizedViewId}`;
        return url;
    }
}
class $a126da043e03bca1$export$71b172928731a65d extends $a126da043e03bca1$export$3f48e59c930ef0ae {
}

});
parcelRegister("d45vL", function(module, exports) {

$parcel$export(module.exports, "getPreview", function () { return $982fec893b9acf64$export$41b3415e6330f1b5; });

var $509aq = parcelRequire("509aq");
const $982fec893b9acf64$export$6effa981e2cec2f7 = `
query GetEurekaVizSnapshots(
    $vizId: String!, $liveboardId: String!) {
    getEurekaVizSnapshot(
      id: $vizId
      reportBookId: $liveboardId
      reportBookType: "PINBOARD_ANSWER_BOOK"
      version: 9999999
    ) {
      id
      vizContent
      snapshotType
      createdMs
    }
  } 
`;
async function $982fec893b9acf64$export$41b3415e6330f1b5(thoughtSpotHost, vizId, liveboardId) {
    return (0, $509aq.graphqlQuery)({
        query: $982fec893b9acf64$export$6effa981e2cec2f7,
        variables: {
            vizId: vizId,
            liveboardId: liveboardId
        },
        thoughtSpotHost: thoughtSpotHost
    });
}

});

parcelRegister("jhzgw", function(module, exports) {

$parcel$export(module.exports, "addPreviewStylesIfNotPresent", function () { return $e09af5d664e8191c$export$f31446debe70c255; });
const $e09af5d664e8191c$export$f31446debe70c255 = ()=>{
    const styleEl = document.getElementById('ts-preview-style');
    if (styleEl) return;
    const previewStyles = `
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/ag-grid-community@32.0.2/styles/ag-grid.min.css" integrity="sha384-PvEsKa6emq5KYa9mf+Q7eYF5C2OCacYzZ+hBngp21NA4o1A9iU9smnytEmqUFbEZ" crossorigin="anonymous">
        <style id="ts-preview-style">
           .ts-viz-preview-loader {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                display: flex;
                justify-content: center;
                align-items: center;
                background: linear-gradient(-45deg, #eee 40%, #fafafa 50%, #eee 60%);
                background-size: 300%;
                background-position-x: 100%;
                animation: shimmer 1s infinite linear;
                z-index: 999;
                filter: grayscale(0.2);
           }

           @keyframes shimmer {
                to {
                    background-position-x: 0%
                }
           }

           .ts-viz-preview-loader .table-module__fullContainer {
                width: 100%;
                height: 100%;
           }
        </style>
    `;
    document.head.insertAdjacentHTML('beforeend', previewStyles);
};

});


parcelRegister("8USNj", function(module, exports) {

$parcel$export(module.exports, "SearchEmbed", function () { return $67de0eb46eeedc5e$export$f2f4c7d59be1a1da; });
/**
 * Copyright (c) 2022
 *
 * Embed ThoughtSpot search or a saved answer.
 * https://developers.thoughtspot.com/docs/search-embed
 * @summary Search embed
 * @author Ayon Ghosh <ayon.ghosh@thoughtspot.com>
 */ 
var $dV0Ap = parcelRequire("dV0Ap");

var $7aJfj = parcelRequire("7aJfj");

var $2SBdZ = parcelRequire("2SBdZ");

var $h7cYZ = parcelRequire("h7cYZ");

var $e0AWW = parcelRequire("e0AWW");

var $fv46J = parcelRequire("fv46J");

var $a6640 = parcelRequire("a6640");
var $67de0eb46eeedc5e$export$aadbc8888d90c6a6;
(function(DataPanelCustomColumnGroupsAccordionState) {
    /**
     * Expand all the accordion initially in data panel v2.
     */ DataPanelCustomColumnGroupsAccordionState["EXPAND_ALL"] = "EXPAND_ALL";
    /**
     * Collapse all the accordions initially in data panel v2.
     */ DataPanelCustomColumnGroupsAccordionState["COLLAPSE_ALL"] = "COLLAPSE_ALL";
    /**
     * Expand the first accordion and collapse the rest.
     */ DataPanelCustomColumnGroupsAccordionState["EXPAND_FIRST"] = "EXPAND_FIRST";
})($67de0eb46eeedc5e$export$aadbc8888d90c6a6 || ($67de0eb46eeedc5e$export$aadbc8888d90c6a6 = {}));
const $67de0eb46eeedc5e$export$97f9d3d882e8d8e4 = [
    (0, $dV0Ap.Action).EditACopy,
    (0, $dV0Ap.Action).SaveAsView,
    (0, $dV0Ap.Action).UpdateTML,
    (0, $dV0Ap.Action).EditTML,
    (0, $dV0Ap.Action).AnswerDelete
];
class $67de0eb46eeedc5e$export$f2f4c7d59be1a1da extends (0, $2SBdZ.TsEmbed) {
    constructor(domSelector, viewConfig){
        viewConfig = {
            embedComponentType: 'SearchEmbed',
            excludeRuntimeFiltersfromURL: true,
            excludeRuntimeParametersfromURL: true,
            ...viewConfig
        };
        super(domSelector, viewConfig);
    }
    /**
     * Get the state of the data sources panel that the embedded
     * ThoughtSpot search will be initialized with.
     */ getDataSourceMode() {
        let dataSourceMode = (0, $dV0Ap.DataSourceVisualMode).Expanded;
        if (this.viewConfig.collapseDataSources === true || this.viewConfig.collapseDataPanel === true) dataSourceMode = (0, $dV0Ap.DataSourceVisualMode).Collapsed;
        if (this.viewConfig.hideDataSources === true) dataSourceMode = (0, $dV0Ap.DataSourceVisualMode).Hidden;
        return dataSourceMode;
    }
    getSearchInitData() {
        var _a;
        return {
            ...this.viewConfig.excludeSearchTokenStringFromURL ? {
                searchOptions: {
                    searchTokenString: (_a = this.viewConfig.searchOptions) === null || _a === void 0 ? void 0 : _a.searchTokenString
                }
            } : {}
        };
    }
    async getAppInitData() {
        const defaultAppInitData = await super.getAppInitData();
        return {
            ...defaultAppInitData,
            ...this.getSearchInitData()
        };
    }
    getEmbedParamsObject() {
        var _a;
        const { hideResults: hideResults, enableSearchAssist: enableSearchAssist, forceTable: forceTable, searchOptions: searchOptions, runtimeFilters: runtimeFilters, dataSource: dataSource, dataSources: dataSources, excludeRuntimeFiltersfromURL: excludeRuntimeFiltersfromURL, hideSearchBar: hideSearchBar, dataPanelV2: dataPanelV2 = true, useLastSelectedSources: useLastSelectedSources = false, runtimeParameters: runtimeParameters, collapseSearchBarInitially: collapseSearchBarInitially = false, enableCustomColumnGroups: enableCustomColumnGroups = false, dataPanelCustomGroupsAccordionInitialState: dataPanelCustomGroupsAccordionInitialState = $67de0eb46eeedc5e$export$aadbc8888d90c6a6.EXPAND_ALL, focusSearchBarOnRender: focusSearchBarOnRender = true, excludeRuntimeParametersfromURL: excludeRuntimeParametersfromURL, excludeSearchTokenStringFromURL: excludeSearchTokenStringFromURL, collapseSearchBar: collapseSearchBar = true, isThisPeriodInDateFiltersEnabled: isThisPeriodInDateFiltersEnabled } = this.viewConfig;
        const queryParams = this.getBaseQueryParams();
        queryParams[(0, $dV0Ap.Param).HideActions] = [
            ...(_a = queryParams[(0, $dV0Ap.Param).HideActions]) !== null && _a !== void 0 ? _a : [],
            ...$67de0eb46eeedc5e$export$97f9d3d882e8d8e4
        ];
        if (dataSources && dataSources.length) queryParams[(0, $dV0Ap.Param).DataSources] = JSON.stringify(dataSources);
        if (dataSource) queryParams[(0, $dV0Ap.Param).DataSources] = `["${dataSource}"]`;
        if (searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.searchTokenString) {
            if (!excludeSearchTokenStringFromURL) queryParams[(0, $dV0Ap.Param).searchTokenString] = encodeURIComponent(searchOptions.searchTokenString);
            if (searchOptions.executeSearch) queryParams[(0, $dV0Ap.Param).executeSearch] = true;
        }
        if (enableSearchAssist) queryParams[(0, $dV0Ap.Param).EnableSearchAssist] = true;
        if (hideResults) queryParams[(0, $dV0Ap.Param).HideResult] = true;
        if (forceTable) queryParams[(0, $dV0Ap.Param).ForceTable] = true;
        if (hideSearchBar) queryParams[(0, $dV0Ap.Param).HideSearchBar] = true;
        if (!focusSearchBarOnRender) queryParams[(0, $dV0Ap.Param).FocusSearchBarOnRender] = focusSearchBarOnRender;
        if (isThisPeriodInDateFiltersEnabled !== undefined) queryParams[(0, $dV0Ap.Param).IsThisPeriodInDateFiltersEnabled] = isThisPeriodInDateFiltersEnabled;
        queryParams[(0, $dV0Ap.Param).DataPanelV2Enabled] = dataPanelV2;
        queryParams[(0, $dV0Ap.Param).DataSourceMode] = this.getDataSourceMode();
        queryParams[(0, $dV0Ap.Param).UseLastSelectedDataSource] = useLastSelectedSources;
        if (dataSource || dataSources) queryParams[(0, $dV0Ap.Param).UseLastSelectedDataSource] = false;
        queryParams[(0, $dV0Ap.Param).searchEmbed] = true;
        queryParams[(0, $dV0Ap.Param).CollapseSearchBarInitially] = collapseSearchBarInitially || collapseSearchBar;
        queryParams[(0, $dV0Ap.Param).EnableCustomColumnGroups] = enableCustomColumnGroups;
        if (dataPanelCustomGroupsAccordionInitialState === $67de0eb46eeedc5e$export$aadbc8888d90c6a6.COLLAPSE_ALL || dataPanelCustomGroupsAccordionInitialState === $67de0eb46eeedc5e$export$aadbc8888d90c6a6.EXPAND_FIRST) queryParams[(0, $dV0Ap.Param).DataPanelCustomGroupsAccordionInitialState] = dataPanelCustomGroupsAccordionInitialState;
        else queryParams[(0, $dV0Ap.Param).DataPanelCustomGroupsAccordionInitialState] = $67de0eb46eeedc5e$export$aadbc8888d90c6a6.EXPAND_ALL;
        return queryParams;
    }
    getEmbedParams() {
        const { runtimeParameters: runtimeParameters, runtimeFilters: runtimeFilters, excludeRuntimeParametersfromURL: excludeRuntimeParametersfromURL, excludeRuntimeFiltersfromURL: excludeRuntimeFiltersfromURL } = this.viewConfig;
        const queryParams = this.getEmbedParamsObject();
        let query = '';
        const queryParamsString = (0, $7aJfj.getQueryParamString)(queryParams, true);
        if (queryParamsString) query = `?${queryParamsString}`;
        const parameterQuery = (0, $7aJfj.getRuntimeParameters)(runtimeParameters || []);
        if (parameterQuery && !excludeRuntimeParametersfromURL) query += `&${parameterQuery}`;
        const filterQuery = (0, $7aJfj.getFilterQuery)(runtimeFilters || []);
        if (filterQuery && !excludeRuntimeFiltersfromURL) query += `&${filterQuery}`;
        return query;
    }
    /**
     * Construct the URL of the embedded ThoughtSpot search to be
     * loaded in the iframe
     * @param answerId The GUID of a saved answer
     * @param dataSources A list of data source GUIDs
     */ getIFrameSrc() {
        const { answerId: answerId } = this.viewConfig;
        const answerPath = answerId ? `saved-answer/${answerId}` : 'answer';
        const tsPostHashParams = this.getThoughtSpotPostUrlParams();
        return `${this.getRootIframeSrc()}/embed/${answerPath}${tsPostHashParams}`;
    }
    /**
     * Render the embedded ThoughtSpot search
     */ async render() {
        await super.render();
        const { answerId: answerId } = this.viewConfig;
        const src = this.getIFrameSrc();
        await this.renderIFrame(src);
        (0, $e0AWW.getAuthPromise)().then(()=>{
            if ((0, $7aJfj.checkReleaseVersionInBeta)((0, $fv46J.getReleaseVersion)(), (0, $a6640.getEmbedConfig)().suppressSearchEmbedBetaWarning || (0, $a6640.getEmbedConfig)().suppressErrorAlerts)) alert((0, $h7cYZ.ERROR_MESSAGE).SEARCHEMBED_BETA_WRANING_MESSAGE);
        });
        return this;
    }
}

});

parcelRegister("9doxk", function(module, exports) {

var $dV0Ap = parcelRequire("dV0Ap");

var $7aJfj = parcelRequire("7aJfj");

var $2SBdZ = parcelRequire("2SBdZ");
class $6b585c6d092cf409$export$cc9b66e0c3a1c0d5 extends (0, $2SBdZ.TsEmbed) {
    constructor(domSelector, viewConfig){
        super(domSelector);
        this.embedComponentType = 'SearchBarEmbed';
        this.viewConfig = viewConfig;
    }
    getEmbedParamsObject() {
        var _a;
        const { searchOptions: searchOptions, dataSource: dataSource, dataSources: dataSources, useLastSelectedSources: useLastSelectedSources = false, excludeSearchTokenStringFromURL: excludeSearchTokenStringFromURL } = this.viewConfig;
        const queryParams = this.getBaseQueryParams();
        queryParams[(0, $dV0Ap.Param).HideActions] = [
            ...(_a = queryParams[(0, $dV0Ap.Param).HideActions]) !== null && _a !== void 0 ? _a : []
        ];
        if (dataSources && dataSources.length) queryParams[(0, $dV0Ap.Param).DataSources] = JSON.stringify(dataSources);
        if (dataSource) queryParams[(0, $dV0Ap.Param).DataSources] = `["${dataSource}"]`;
        if (searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.searchTokenString) {
            if (!excludeSearchTokenStringFromURL) queryParams[(0, $dV0Ap.Param).searchTokenString] = encodeURIComponent(searchOptions.searchTokenString);
            if (searchOptions.executeSearch) queryParams[(0, $dV0Ap.Param).executeSearch] = true;
        }
        queryParams[(0, $dV0Ap.Param).UseLastSelectedDataSource] = useLastSelectedSources;
        if (dataSource || dataSources) queryParams[(0, $dV0Ap.Param).UseLastSelectedDataSource] = false;
        queryParams[(0, $dV0Ap.Param).searchEmbed] = true;
        return queryParams;
    }
    /**
     * Construct the URL of the embedded ThoughtSpot search to be
     * loaded in the iframe
     * @param dataSources A list of data source GUIDs
     */ getIFrameSrc() {
        const queryParams = this.getEmbedParamsObject();
        const path = 'search-bar-embed';
        let query = '';
        const queryParamsString = (0, $7aJfj.getQueryParamString)(queryParams, true);
        if (queryParamsString) query = `?${queryParamsString}`;
        const tsPostHashParams = this.getThoughtSpotPostUrlParams();
        return `${this.getEmbedBasePath(query)}/embed/${path}${tsPostHashParams}`;
    }
    /**
     * Render the embedded ThoughtSpot search
     */ async render() {
        await super.render();
        const src = this.getIFrameSrc();
        await this.renderIFrame(src);
        return this;
    }
    getSearchInitData() {
        return {
            searchOptions: this.viewConfig.excludeSearchTokenStringFromURL ? this.viewConfig.searchOptions : null
        };
    }
    async getAppInitData() {
        const defaultAppInitData = await super.getAppInitData();
        return {
            ...defaultAppInitData,
            ...this.getSearchInitData()
        };
    }
}

});

parcelRegister("lPfbA", function(module, exports) {

var $dV0Ap = parcelRequire("dV0Ap");

var $2SBdZ = parcelRequire("2SBdZ");

var $mEvLI = parcelRequire("mEvLI");

var $a6640 = parcelRequire("a6640");

var $7aJfj = parcelRequire("7aJfj");
class $fe3a23ff4aa6b275$export$1f8096a2fc3acaec extends (0, $2SBdZ.TsEmbed) {
    constructor(container, viewConfig){
        viewConfig.embedComponentType = 'bodyless-conversation';
        super(container, viewConfig);
        this.viewConfig = viewConfig;
    }
    getEmbedParamsObject() {
        var _a;
        const queryParams = this.getBaseQueryParams();
        queryParams[(0, $dV0Ap.Param).HideActions] = [
            ...(_a = queryParams[(0, $dV0Ap.Param).HideActions]) !== null && _a !== void 0 ? _a : []
        ];
        queryParams[(0, $dV0Ap.Param).isSpotterAgentEmbed] = true;
        return queryParams;
    }
    getIframeSrc() {
        const { sessionId: sessionId, genNo: genNo, acSessionId: acSessionId, acGenNo: acGenNo, convId: convId, messageId: messageId } = this.viewConfig;
        const path = 'conv-assist-answer';
        const queryParams = this.getEmbedParamsObject();
        let query = '';
        const queryParamsString = (0, $7aJfj.getQueryParamString)(queryParams, true);
        if (queryParamsString) query = `?${queryParamsString}`;
        const tsPostHashParams = this.getThoughtSpotPostUrlParams({
            sessionId: sessionId,
            genNo: genNo,
            acSessionId: acSessionId,
            acGenNo: acGenNo,
            convId: convId,
            messageId: messageId
        });
        return `${this.getEmbedBasePath(query)}/embed/${path}${tsPostHashParams}`;
    }
    async render() {
        await super.render();
        const src = this.getIframeSrc();
        await this.renderIFrame(src);
        return this;
    }
}
class $fe3a23ff4aa6b275$export$c7af5d8b7ee3aa1b {
    constructor(viewConfig){
        this.viewConfig = viewConfig;
        const embedConfig = (0, $a6640.getEmbedConfig)();
        this.conversationService = new (0, $mEvLI.Conversation)(embedConfig.thoughtSpotHost, viewConfig.worksheetId);
    }
    async sendMessage(userMessage) {
        const { data: data, error: error } = await this.conversationService.sendMessage(userMessage);
        if (error) return {
            error: error
        };
        const container = document.createElement('div');
        const embed = new $fe3a23ff4aa6b275$export$1f8096a2fc3acaec(container, {
            ...this.viewConfig,
            convId: data.convId,
            messageId: data.messageId,
            sessionId: data.sessionId,
            genNo: data.genNo,
            acSessionId: data.stateKey.transactionId,
            acGenNo: data.stateKey.generationNumber
        });
        await embed.render();
        return {
            container: container,
            viz: embed
        };
    }
    /**
     * Send a message to the conversation service and return only the data.
     * @param userMessage - The message to send to the conversation service.
     * @returns The data from the conversation service.
     */ async sendMessageData(userMessage) {
        try {
            const { data: data, error: error } = await this.conversationService.sendMessage(userMessage);
            if (error) return {
                error: error
            };
            return {
                data: {
                    convId: data.convId,
                    messageId: data.messageId,
                    sessionId: data.sessionId,
                    genNo: data.genNo,
                    acSessionId: data.stateKey.transactionId,
                    acGenNo: data.stateKey.generationNumber
                }
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }
}
class $fe3a23ff4aa6b275$export$3ce80755d121c22 extends $fe3a23ff4aa6b275$export$c7af5d8b7ee3aa1b {
    constructor(viewConfig){
        super(viewConfig);
    }
}

});
parcelRegister("mEvLI", function(module, exports) {

$parcel$export(module.exports, "Conversation", function () { return $04417ae86c131fe4$export$8e86b22308382a1; });

var $509aq = parcelRequire("509aq");

var $dzJus = parcelRequire("dzJus");
class $04417ae86c131fe4$export$8e86b22308382a1 {
    constructor(thoughtSpotHost, worksheetId){
        this.thoughtSpotHost = thoughtSpotHost;
        this.worksheetId = worksheetId;
        this.inProgress = null;
        this.inProgress = this.init();
    }
    async init() {
        const { convId: convId } = await this.createConversation();
        this.conversationId = convId;
    }
    createConversation() {
        return this.executeQuery($dzJus.createConversation, {
            params: {
                initialCtx: {
                    tsWorksheetCtx: {
                        worksheet: {
                            worksheetId: this.worksheetId
                        }
                    },
                    type: 'TS_WORKSHEET'
                },
                userInfo: {
                    tenantUrl: `${this.thoughtSpotHost}/prism`
                }
            }
        });
    }
    async sendMessage(userMessage) {
        await this.inProgress;
        try {
            const { responses: responses } = await this.executeQuery($dzJus.sendMessage, {
                params: {
                    convId: this.conversationId,
                    headers: [],
                    msg: {
                        data: {
                            userCmdData: {
                                cmdText: userMessage,
                                nlsData: {
                                    worksheetId: this.worksheetId,
                                    questionType: 'ANSWER_SPEC_GENERATION'
                                }
                            }
                        },
                        msgId: crypto.randomUUID(),
                        type: 'USER_COMMAND'
                    }
                }
            });
            const data = responses[0].data;
            return {
                convId: this.conversationId,
                messageId: responses[0].msgId,
                data: {
                    ...data.asstRespData.nlsAnsData.sageQuerySuggestions[0],
                    convId: this.conversationId,
                    messageId: responses[0].msgId
                },
                error: null
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }
    async executeQuery(query, variables) {
        return (0, $509aq.graphqlQuery)({
            query: query,
            variables: variables,
            thoughtSpotHost: this.thoughtSpotHost,
            isCompositeQuery: false
        });
    }
}

});
parcelRegister("dzJus", function(module, exports) {

$parcel$export(module.exports, "createConversation", function () { return $9e21d4a3718f9aea$export$6b51043996b5bbb6; });
$parcel$export(module.exports, "sendMessage", function () { return $9e21d4a3718f9aea$export$465cb47180de50f0; });
const $9e21d4a3718f9aea$export$6b51043996b5bbb6 = `
mutation CreateConversation($params: Input_convassist_CreateConversationRequest) {
  ConvAssist__createConversation(request: $params) {
    convId
    initialCtx {
      type
      tsAnsCtx {
        sessionId
        genNo
        stateKey {
          transactionId
          generationNumber
        }
        worksheet {
          worksheetId
          worksheetName
        }
      }
    }
  }
}
`;
const $9e21d4a3718f9aea$export$465cb47180de50f0 = `
query SendMessage($params: Input_convassist_SendMessageRequest) {
  ConvAssist__sendMessage(request: $params) {
    responses {
      timestamp
      msgId
      data {
        asstRespData {
          tool
          asstRespText
          nlsAnsData {
            sageQuerySuggestions {
              sageQueryTokens {
                additions {
                  phrase {
                    isCompletePhrase
                    numTokens
                    phraseType
                    startIndex
                    __typename
                  }
                  tokens {
                    token
                    dataType
                    typeEnum
                    guid
                    tokenMetadata {
                      name
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                phrases {
                  isCompletePhrase
                  numTokens
                  phraseType
                  startIndex
                  __typename
                }
                removals {
                  phrase {
                    isCompletePhrase
                    numTokens
                    phraseType
                    startIndex
                    __typename
                  }
                  tokens {
                    token
                    dataType
                    typeEnum
                    guid
                    tokenMetadata {
                      name
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                tokens {
                  token
                  dataType
                  typeEnum
                  guid
                  tokenMetadata {
                    name
                    __typename
                  }
                  __typename
                }
                __typename
              }
              llmReasoning {
                assumptions
                clarifications
                interpretation
                __typename
              }
              tokens
              tmlTokens
              worksheetId
              tokens
              description
              title
              tmlTokens
              cached
              sqlQuery
              sessionId
              genNo
              formulaInfo {
                name
                expression
                __typename
              }
              tmlPhrases
              ambiguousPhrases {
                alternativePhrases {
                  phraseType
                  token {
                    token
                    dataType
                    typeEnum
                    guid
                    tokenMetadata {
                      name
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                ambiguityType
                token {
                  token
                  dataType
                  typeEnum
                  guid
                  tokenMetadata {
                    name
                    __typename
                  }
                  __typename
                }
                __typename
              }
              ambiguousTokens {
                alternativeTokens {
                  token
                  dataType
                  typeEnum
                  guid
                  tokenMetadata {
                    name
                    deprecatedTableGuid
                    deprecatedTableName
                    isFormula
                    rootTables {
                      created
                      description
                      guid
                      indexVersion
                      modified
                      name
                      __typename
                    }
                    schemaTableUserDefinedName
                    table {
                      created
                      description
                      guid
                      indexVersion
                      modified
                      name
                      __typename
                    }
                    __typename
                  }
                  __typename
                }
                ambiguityType
                token {
                  token
                  dataType
                  typeEnum
                  guid
                  tokenMetadata {
                    name
                    __typename
                  }
                  __typename
                }
                __typename
              }
              stateKey {
                transactionId
                generationNumber
                transactionId
                __typename
              }
              subQueries {
                tokens
                cohortConfig {
                  anchorColumnId
                  cohortAnswerGuid
                  cohortGroupingType
                  cohortGuid
                  cohortType
                  combineNonGroupValues
                  description
                  groupExcludedQueryValues
                  hideExcludedQueryValues
                  isEditable
                  name
                  nullOutputValue
                  returnColumnId
                  __typename
                }
                formulas {
                  name
                  expression
                  __typename
                }
                __typename
              }
              visualizationSuggestion {
                chartType
                displayMode
                axisConfigs {
                  category
                  color
                  hidden
                  size
                  sort
                  x
                  y
                  __typename
                }
                usersVizIntentApplied
                customChartConfigs {
                  dimensions {
                    columns
                    key
                    __typename
                  }
                  key
                  __typename
                }
                customChartGuid
                __typename
              }
              tableData {
                columnDataLite {
                  columnId
                  columnDataType
                  dataValue
                  columnName
                  __typename
                }
                __typename
              }
              warningType
              cached
              __typename
            }
            debugInfo {
              fewShotExamples {
                chartType
                id
                mappingId
                nlQuery
                nlQueryConcepts
                sageQuery
                scope
                sql
                tml
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        errorData {
          tool
          errCode
          errTxt
          toolErrCode
          __typename
        }
        __typename
      }
      type
      __typename
    }
    prevCtx {
      genNo
      sessionId
      __typename
    }
    __typename
  }
}
`;

});



parcelRegister("a9HVp", function(module, exports) {

var $h7cYZ = parcelRequire("h7cYZ");

var $dV0Ap = parcelRequire("dV0Ap");

var $2SBdZ = parcelRequire("2SBdZ");

var $b8Ldn = parcelRequire("b8Ldn");

var $7aJfj = parcelRequire("7aJfj");
class $764cd1347a58db98$export$f9e59c8fad243ee0 extends (0, $2SBdZ.TsEmbed) {
    constructor(container, viewConfig){
        viewConfig = {
            embedComponentType: 'conversation',
            excludeRuntimeFiltersfromURL: true,
            excludeRuntimeParametersfromURL: true,
            ...viewConfig
        };
        super(container, viewConfig);
        this.viewConfig = viewConfig;
    }
    /**
     * Extends the default APP_INIT payload with `embedParams.spotterSidebarConfig`
     * so the conv-assist app can read sidebar configuration on initialisation.
     *
     * Precedence for `enablePastConversationsSidebar`:
     * `spotterSidebarConfig.enablePastConversationsSidebar` wins over the
     * deprecated top-level `enablePastConversationsSidebar` flag; if the former
     * is absent the latter is used as a fallback.
     *
     * An invalid `spotterDocumentationUrl` triggers a validation error and is
     * excluded from the payload rather than forwarded to the app.
     */ async getAppInitData() {
        const defaultAppInitData = await super.getAppInitData();
        return (0, $b8Ldn.buildSpotterSidebarAppInitData)(defaultAppInitData, this.viewConfig, this.handleError.bind(this));
    }
    getEmbedParamsObject() {
        const { worksheetId: worksheetId, searchOptions: searchOptions, disableSourceSelection: disableSourceSelection, hideSourceSelection: hideSourceSelection, dataPanelV2: dataPanelV2, showSpotterLimitations: showSpotterLimitations, hideSampleQuestions: hideSampleQuestions, runtimeFilters: runtimeFilters, excludeRuntimeFiltersfromURL: excludeRuntimeFiltersfromURL, runtimeParameters: runtimeParameters, excludeRuntimeParametersfromURL: excludeRuntimeParametersfromURL, updatedSpotterChatPrompt: updatedSpotterChatPrompt, enableStopAnswerGenerationEmbed: enableStopAnswerGenerationEmbed, spotterChatConfig: spotterChatConfig } = this.viewConfig;
        if (!worksheetId) this.handleError({
            errorType: (0, $dV0Ap.ErrorDetailsTypes).VALIDATION_ERROR,
            message: (0, $h7cYZ.ERROR_MESSAGE).SPOTTER_EMBED_WORKSHEED_ID_NOT_FOUND,
            code: (0, $dV0Ap.EmbedErrorCodes).WORKSHEET_ID_NOT_FOUND,
            error: (0, $h7cYZ.ERROR_MESSAGE).SPOTTER_EMBED_WORKSHEED_ID_NOT_FOUND
        });
        const queryParams = this.getBaseQueryParams();
        queryParams[(0, $dV0Ap.Param).SpotterEnabled] = true;
        // Boolean params
        (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).DisableSourceSelection, disableSourceSelection, true);
        (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).HideSourceSelection, hideSourceSelection, true);
        (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).DataPanelV2Enabled, dataPanelV2, true);
        (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).ShowSpotterLimitations, showSpotterLimitations, true);
        (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).HideSampleQuestions, hideSampleQuestions, true);
        (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).UpdatedSpotterChatPrompt, updatedSpotterChatPrompt, true);
        (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).EnableStopAnswerGenerationEmbed, enableStopAnswerGenerationEmbed, true);
        // Handle spotterChatConfig params
        if (spotterChatConfig) {
            const { hideToolResponseCardBranding: hideToolResponseCardBranding, toolResponseCardBrandingLabel: toolResponseCardBrandingLabel } = spotterChatConfig;
            (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).HideToolResponseCardBranding, hideToolResponseCardBranding, true);
            (0, $7aJfj.setParamIfDefined)(queryParams, (0, $dV0Ap.Param).ToolResponseCardBrandingLabel, toolResponseCardBrandingLabel);
        }
        return queryParams;
    }
    getIframeSrc() {
        const { worksheetId: worksheetId, searchOptions: searchOptions, runtimeFilters: runtimeFilters, excludeRuntimeFiltersfromURL: excludeRuntimeFiltersfromURL, runtimeParameters: runtimeParameters, excludeRuntimeParametersfromURL: excludeRuntimeParametersfromURL } = this.viewConfig;
        const path = 'insights/conv-assist';
        const queryParams = this.getEmbedParamsObject();
        let query = '';
        const queryParamsString = (0, $7aJfj.getQueryParamString)(queryParams, true);
        if (queryParamsString) query = `?${queryParamsString}`;
        const filterQuery = (0, $7aJfj.getFilterQuery)(runtimeFilters || []);
        if (filterQuery && !excludeRuntimeFiltersfromURL) query += `&${filterQuery}`;
        const parameterQuery = (0, $7aJfj.getRuntimeParameters)(runtimeParameters || []);
        if (parameterQuery && !excludeRuntimeParametersfromURL) query += `&${parameterQuery}`;
        const tsPostHashParams = this.getThoughtSpotPostUrlParams({
            worksheet: worksheetId,
            query: (searchOptions === null || searchOptions === void 0 ? void 0 : searchOptions.searchQuery) || ''
        });
        return `${this.getEmbedBasePath(query)}/embed/${path}${tsPostHashParams}`;
    }
    async render() {
        await super.render();
        const src = this.getIframeSrc();
        await this.renderIFrame(src);
        return this;
    }
}
class $764cd1347a58db98$export$941f48fff7ca1487 extends $764cd1347a58db98$export$f9e59c8fad243ee0 {
    constructor(container, viewConfig){
        viewConfig = {
            embedComponentType: 'conversation',
            excludeRuntimeFiltersfromURL: true,
            excludeRuntimeParametersfromURL: true,
            ...viewConfig
        };
        super(container, viewConfig);
        this.viewConfig = viewConfig;
    }
}

});

parcelRegister("lMpvb", function(module, exports) {

var $a6640 = parcelRequire("a6640");

var $3q1XH = parcelRequire("3q1XH");

var $509aq = parcelRequire("509aq");

var $gBrqC = parcelRequire("gBrqC");
const $fdb1dcce39956e10$export$da691db9259f39c9 = async (query, worksheetId)=>{
    const embedConfig = (0, $a6640.getEmbedConfig)();
    const resp = await (0, $509aq.graphqlQuery)({
        query: $gBrqC.getAnswerSessionFromQuery,
        variables: {
            params: {
                facetSelections: [],
                filterSelections: [
                    {
                        facetType: 'WORKSHEETS',
                        facetValue: [
                            worksheetId
                        ]
                    }
                ],
                query: query,
                worksheetFacetPayload: {
                    worksheetId: worksheetId
                },
                searchOption: 'AI_ANSWER'
            }
        },
        thoughtSpotHost: embedConfig.thoughtSpotHost,
        isCompositeQuery: false
    });
    const suggestion = resp.sageQuerySuggestions[0];
    const answerSession = {
        sessionId: suggestion.sessionId,
        genNo: suggestion.genNo,
        acSession: {
            sessionId: suggestion.stateKey.transactionId,
            genNo: suggestion.stateKey.generationNumber
        }
    };
    return {
        answer: new (0, $3q1XH.AnswerService)(answerSession, null, embedConfig.thoughtSpotHost),
        suggestion: suggestion
    };
};

});
parcelRegister("gBrqC", function(module, exports) {

$parcel$export(module.exports, "getAnswerSessionFromQuery", function () { return $c16560b90e5fe27c$export$5151c34e1e136477; });
const $c16560b90e5fe27c$export$5151c34e1e136477 = `
query GetEurekaResults($params: Input_eureka_SearchRequest) {
        queryRequest(request: $params) {
            ...eurekaResults
            __typename
        }
    }

        fragment eurekaResults on eureka_SearchResponse {
        facets {
            facetType
            facetValue
            facetValues {
            id
            resultCount
            name
            __typename
            }
            __typename
        }
        requestIdentifiers {
            apiRequestId
            appActivityId
            __typename
        }
        sageQuerySuggestions {
            llmReasoning {
                assumptions
                clarifications
                interpretation
                __typename
            }
            tokens
            tmlTokens
            worksheetId
            description
            title
            tmlTokens
            formulaInfo {
            name
            expression
            __typename
            }
            tmlPhrases
            ambiguousPhrases {
            alternativePhrases {
                phraseType
                token {
                token
                dataType
                typeEnum
                guid
                tokenMetadata {
                    name
                    __typename
                }
                __typename
                }
                __typename
            }
            ambiguityType
            token {
                token
                dataType
                typeEnum
                guid
                tokenMetadata {
                name
                __typename
                }
                __typename
            }
            __typename
            }
            ambiguousTokens {
            alternativeTokens {
                token
                dataType
                typeEnum
                guid
                tokenMetadata {
                name
                deprecatedTableGuid
                deprecatedTableName
                isFormula
                rootTables {
                    created
                    description
                    guid
                    indexVersion
                    modified
                    name
                    __typename
                }
                schemaTableUserDefinedName
                table {
                    created
                    description
                    guid
                    indexVersion
                    modified
                    name
                    __typename
                }
                __typename
                }
                __typename
            }
            ambiguityType
            token {
                token
                dataType
                typeEnum
                guid
                tokenMetadata {
                name
                __typename
                }
                __typename
            }
            __typename
            }
            sessionId
            genNo
            stateKey {
                generationNumber
                transactionId
            __typename
            }
            subQueries {
            tokens
            cohortConfig {
                anchorColumnId
                cohortAnswerGuid
                cohortGroupingType
                cohortGuid
                cohortType
                combineNonGroupValues
                description
                groupExcludedQueryValues
                hideExcludedQueryValues
                isEditable
                name
                nullOutputValue
                returnColumnId
                __typename
            }
            formulas {
                name
                expression
                __typename
            }
            __typename
            }
            visualizationSuggestion {
            chartType
            displayMode
            axisConfigs {
                category
                color
                hidden
                size
                sort
                x
                y
                __typename
            }
            usersVizIntentApplied
            customChartConfigs {
                dimensions {
                columns
                key
                __typename
                }
                key
                __typename
            }
            customChartGuid
            __typename
            }
            tableData {
            columnDataLite {
                columnId
                columnDataType
                dataValue
                columnName
                __typename
            }
            __typename
            }
            warningType
            cached
            warningDetails {
            warningType
            __typename
            }
            __typename
        }
        results {
            objectSecurityInfo {
            objectType
            objectId
            objectIdForDeletionCheck
            objectTypeForDeletionCheck
            isD13ySourced
            offset
            __typename
            }
            searchAnswer {
            ...eurekaAnswer
            __typename
            }
            searchPinboardViz {
            answer {
                ...eurekaAnswer
                __typename
            }
            pinboardHeader {
                id
                title
                __typename
            }
            __typename
            }
            searchPinboard {
            header {
                ...header
                __typename
            }
            usageInfo {
                ...usageInfo
                __typename
            }
            answers {
                ...eurekaAnswer
                __typename
            }
            vizCount {
                charts
                metrics
                tables
                __typename
            }
            __typename
            }
            snippetInfo {
            titleSnippet {
                snippetString
                highlights {
                start
                end
                __typename
                }
                __typename
            }
            descriptionSnippet {
                snippetString
                highlights {
                start
                end
                __typename
                }
                __typename
            }
            sageQuerySnippet {
                phrase {
                isCompletePhrase
                numTokens
                phraseType
                startIndex
                __typename
                }
                token {
                token
                dataType
                typeEnum
                __typename
                }
                __typename
            }
            sageQuerySnippetWithHighlights {
                highlights {
                start
                end
                __typename
                }
                phraseType
                phraseValue
                __typename
            }
            __typename
            }
            score
            debugInfo
            resultType
            sageQuery
            __typename
        }
        version
        nextPageOffset
        batchSizeRequired
        isFinalPage
        totalResults
        totalFacetResultCount
        errorCode
        debugInfo {
            fewShotExamples {
            chartType
            formulas {
                name
                expression
                __typename
            }
            id
            mappingId
            nlQuery
            nlQueryConcepts
            sageQuery
            scope
            sql
            tml
            feedbackType
            __typename
            }
            __typename
        }
        __typename
        }

        fragment eurekaAnswer on eureka_AnswerResult {
        header {
            ...header
            __typename
        }
        usageInfo {
            ...usageInfo
            __typename
        }
        preferredViz {
            ...visualizationMetadata
            __typename
        }
        worksheetInfo {
            ...worksheetInfo
            __typename
        }
        formatted {
            phrase {
            isCompletePhrase
            numTokens
            phraseType
            startIndex
            __typename
            }
            token {
            token
            typeEnum
            __typename
            }
            __typename
        }
        __typename
        }

        fragment header on eureka_Header {
        id
        title
        description
        authorGuid
        authorName
        createdOn
        tagIds
        __typename
        }

        fragment usageInfo on eureka_UsageInfo {
        favouriteCount
        viewCount
        __typename
        }

        fragment visualizationMetadata on eureka_VisualizationMetadata {
        vizType
        chartType
        vizSnapshotRequestData {
            parentReportbookGuid
            parentType
            version
            vizGuid
            __typename
        }
        __typename
        }

        fragment worksheetInfo on eureka_WorksheetInfo {
        id
        name
        __typename
        }`;

});


parcelRegister("jVefY", function(module, exports) {

var $8NaiO = parcelRequire("8NaiO");

var $a6640 = parcelRequire("a6640");

var $e0AWW = parcelRequire("e0AWW");
const $e80e664513318bcd$export$808ecca0ebbd6db = async (answers, name)=>{
    var _a;
    const { thoughtSpotHost: thoughtSpotHost, authType: authType } = (0, $a6640.getEmbedConfig)();
    const resp = await (0, $8NaiO.tokenizedFetch)(`${thoughtSpotHost}/api/rest/2.0/metadata/search`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            metadata: [
                {
                    type: 'LIVEBOARD',
                    identifier: name
                }
            ]
        })
    });
    const lbList = await resp.json();
    const liveboardId = (_a = lbList[0]) === null || _a === void 0 ? void 0 : _a.metadata_id;
    const answerTMLs = (await Promise.all(answers.map((a)=>a.getTML()))).filter((tml)=>tml.answer.search_query);
    const lbTml = {
        guid: liveboardId,
        liveboard: {
            name: name,
            visualizations: answerTMLs.map((tml, idx)=>({
                    id: `Viz_${idx}`,
                    answer: tml.answer
                })),
            layout: {
                tiles: answerTMLs.map((tml, idx)=>({
                        visualization_id: `Viz_${idx}`,
                        size: 'MEDIUM_SMALL'
                    }))
            }
        }
    };
    const result = await (0, $e0AWW.executeTML)({
        metadata_tmls: [
            JSON.stringify(lbTml)
        ],
        import_policy: 'ALL_OR_NONE'
    });
    return result;
};

});

parcelRegister("bINVD", function(module, exports) {

var $dV0Ap = parcelRequire("dV0Ap");

var $2SBdZ = parcelRequire("2SBdZ");

var $7aJfj = parcelRequire("7aJfj");
function $888a888b154233d8$export$d95a8e1ee3c9311b(viewConfig = {}) {
    const replaceWithMCPIframe = (iframe)=>{
        const autoMCPFrameRenderer = new $888a888b154233d8$var$AutoFrameRenderer(viewConfig);
        autoMCPFrameRenderer.replaceIframe(iframe);
    };
    const observer = new MutationObserver((mutations)=>{
        for (const mutation of mutations)for (const node of Array.from(mutation.addedNodes)){
            if (node instanceof HTMLIFrameElement && $888a888b154233d8$var$isTSMCPIframe(node)) replaceWithMCPIframe(node);
            if (node instanceof HTMLElement) node.querySelectorAll('iframe').forEach((iframe)=>{
                if ($888a888b154233d8$var$isTSMCPIframe(iframe)) replaceWithMCPIframe(iframe);
            });
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    return observer;
}
function $888a888b154233d8$var$isTSMCPIframe(iframe) {
    try {
        const url = new URL(iframe.src);
        return url.searchParams.get((0, $dV0Ap.Param).Tsmcp) === 'true';
    } catch (e) {
        // The iframe src might not be a valid URL (e.g., 'about:blank').
        return false;
    }
}
/**
 * Embed component that automatically replaces a plain iframe with a
 * ThoughtSpot embed iframe. It merges the SDK's embed parameters with
 * the original iframe's query parameters (stripping the `tsmcp` marker)
 * and swaps the original iframe element in the DOM.
 *
 * This class is used internally by {@link startAutoMCPFrameRenderer} and
 * is not intended to be instantiated directly.
 */ class $888a888b154233d8$var$AutoFrameRenderer extends (0, $2SBdZ.TsEmbed) {
    constructor(viewConfig){
        viewConfig.embedComponentType = 'auto-frame-renderer';
        const container = document.createElement('div');
        super(container, viewConfig);
        this.viewConfig = viewConfig;
    }
    /**
     * Builds the final iframe `src` by merging the SDK embed parameters
     * with the query parameters already present on the source iframe URL.
     * The `tsmcp` marker param is removed so it does not propagate to the
     * ThoughtSpot application.
     *
     * @param sourceSrc - The original iframe's `src` URL string.
     * @returns The constructed URL to use for the ThoughtSpot embed iframe.
     */ getMCPIframeSrc(sourceSrc) {
        const queryParams = this.getEmbedParamsObject();
        const sourceURL = new URL(sourceSrc);
        const existingQueryParams = sourceURL.searchParams;
        const existingQueryParamsObject = Object.fromEntries(existingQueryParams);
        delete existingQueryParamsObject[(0, $dV0Ap.Param).Tsmcp];
        const mergedQueryParams = {
            ...queryParams,
            ...existingQueryParamsObject
        };
        const mergedQueryParamsString = (0, $7aJfj.getQueryParamString)(mergedQueryParams);
        const frameSrc = `${this.getEmbedBasePath(mergedQueryParamsString)}${sourceURL.hash.replace('#', '')}`;
        return frameSrc;
    }
    /**
     * Overrides the base insertion behavior so the new embed iframe
     * replaces the original iframe in-place rather than being appended
     * to a container element. Falls back to the default behavior when
     * no iframe has been set for replacement.
     */ handleInsertionIntoDOM(child) {
        if (this.frameToReplace) this.frameToReplace.replaceWith(child);
        else super.handleInsertionIntoDOM(child);
    }
    /**
     * Replaces the given iframe with a new ThoughtSpot embed iframe.
     *
     * The original iframe's `src` is used to derive the embed URL, and
     * once the new iframe is rendered it takes the original's place in
     * the DOM tree.
     *
     * @param iframe - The existing `<iframe>` element to replace.
     */ async replaceIframe(iframe) {
        this.frameToReplace = iframe;
        const src = this.getMCPIframeSrc(iframe.src);
        await this.renderIFrame(src);
    }
}

});



parcelRegister("iGeIU", function(module, exports) {

var $2ktsf = parcelRequire("2ktsf");
"use strict";
const $d99791ff06f302eb$var$FullStoryPort = {
    add: function(app, orgId) {
        if (orgId) {
            (0, $2ktsf.init)({
                orgId: orgId
            });
            window["_fs_run_in_iframe"] = true;
            app.ports.fullStoryPortBoot.subscribe(function(userIdAndUserAttrs) {
                const userId = userIdAndUserAttrs[0];
                const userAttrs = userIdAndUserAttrs[1];
                (0, $2ktsf.FullStory)("setIdentity", {
                    uid: userId,
                    properties: userAttrs
                });
            });
            app.ports.fullStoryPortStopCapturing.subscribe(function() {
                (0, $2ktsf.FullStory)("shutdown");
            });
            app.ports.fullStoryPortLogEvent.subscribe(function(event) {
                // Copied from Amplitude.js
                const options = Object.assign(event.payload, {
                    url_path: event.urlPath || location.pathname
                });
                (0, $2ktsf.FullStory)("trackEvent", {
                    name: event.type,
                    properties: options
                });
            });
        }
    }
};
module.exports = $d99791ff06f302eb$var$FullStoryPort;

});

parcelRegister("2NItH", function(module, exports) {
"use strict";
const $20a2a8cdd1ce1d56$var$FaviconPort = {
    add: function(app) {
        if (app.ports.setFaviconPort) app.ports.setFaviconPort.subscribe((favicons)=>{
            let icoLink = document.getElementById("faviconIco");
            let pngLink = document.getElementById("faviconPng");
            let appleLink = document.getElementById("faviconApple");
            icoLink.setAttribute("href", favicons.icoUrl);
            pngLink.setAttribute("href", favicons.pngUrl);
            appleLink.setAttribute("href", favicons.appleUrl);
        });
    }
};
module.exports = $20a2a8cdd1ce1d56$var$FaviconPort;

});

parcelRegister("f9qUo", function(module, exports) {
"use strict";
const $b07c91c48872c401$var$PageTitle = {
    add: (app)=>{
        app.ports.updateTabTitle.subscribe((title)=>{
            document.title = title;
        });
    }
};
module.exports = $b07c91c48872c401$var$PageTitle;

});

parcelRegister("jRaNl", function(module, exports) {
"use strict";
const $e74b572ff485efd6$var$DropdownPort = {
    add: (app)=>{
        document.addEventListener("focusout", (event)=>{
            const dropdown = event.target.closest(".new-dropdown");
            const blurredOutAll = (dropdown)=>{
                // Recursively go up the parent nodes to close
                // All open dropdowns.
                // This is mostly helpful for dropdowns inside dropdowns.
                while(dropdown){
                    app.ports.onDropdownBlur.send(dropdown.id);
                    dropdown = dropdown.parentElement.closest(".new-dropdown");
                }
            };
            if (dropdown) {
                if (!event.relatedTarget) // Close all dropdowns if no new target.
                blurredOutAll(dropdown);
                else {
                    const newFocusedDropdown = event.relatedTarget.closest(".new-dropdown");
                    if (!newFocusedDropdown) {
                        // Close all dropdowns if new target is not inside a dropdown.
                        blurredOutAll(dropdown);
                        return;
                    }
                    if (newFocusedDropdown.classList.contains("new-dropdown-menu__item--inner")) {
                        if (newFocusedDropdown.closest(`#${dropdown.id}`)) // If the new focused dropdown is an inner dropdown of
                        // The previously focused dropdown do nothing.
                        return;
                    }
                    if (newFocusedDropdown.id !== dropdown.id) // Close only the previous focused dropdown if the
                    // newly focused one is different.
                    app.ports.onDropdownBlur.send(dropdown.id);
                }
            }
        });
        app.ports.dropdownSimulateClick.subscribe(()=>{
            const focusedOption = document.activeElement;
            const actualOption = focusedOption.closest(".new-dropdown-menu__item");
            if (!actualOption) return;
            actualOption.dispatchEvent(new MouseEvent("mouseup"));
            actualOption.dispatchEvent(new MouseEvent("click"));
        });
        app.ports.focusFirstDropdownOptionPort.subscribe((dropdownId)=>{
            // This will be an issue if there are elements but all of them are non visible.
            const dropdown = document.getElementById(dropdownId);
            requestAnimationFrame(()=>{
                const firstItem = dropdown.querySelector(".new-dropdown-menu__item");
                if (firstItem) {
                    if ($e74b572ff485efd6$var$canFocus(firstItem)) {
                        setTimeout(()=>firstItem.focus(), 50);
                        return;
                    }
                    $e74b572ff485efd6$var$focusNextFocusableItem(firstItem);
                }
            });
        });
        app.ports.focusNextDropdownOptionPort.subscribe(()=>{
            const focusedOption = document.activeElement;
            const actualOption = focusedOption.closest(".new-dropdown-menu__item");
            if (!actualOption) return;
            $e74b572ff485efd6$var$focusNextFocusableItem(actualOption);
        });
        app.ports.focusPrevDropdownOptionPort.subscribe(()=>{
            const focusedOption = document.activeElement;
            const actualOption = focusedOption.closest(".new-dropdown-menu__item");
            if (!actualOption) return;
            $e74b572ff485efd6$var$focusPreviousFocusableItem(actualOption);
        });
        app.ports.submitFormDropdownPort.subscribe(()=>{
            const focusedSelect = document.activeElement;
            const form = focusedSelect.closest("form");
            if (form) form.requestSubmit();
        });
        app.ports.focusInnerDropdownOptionInputPort.subscribe(()=>{
            const focusedOption = document.activeElement;
            const actualOption = focusedOption.closest(".new-dropdown-menu__item");
            const input = actualOption.querySelector("input");
            if (input) input.focus();
        });
        app.ports.focusInnerDropdownOptionLinkPort.subscribe(()=>{
            const focusedOption = document.activeElement;
            const actualOption = focusedOption.closest(".new-dropdown-menu__item");
            const link = actualOption.querySelector("a");
            if (link) link.focus();
        });
        document.addEventListener("keydown", function(event) {
            const insideDropdown = document.activeElement?.closest(".new-dropdown--open");
            if (!insideDropdown) return;
            if (event.key === "Escape") {
                event.stopPropagation();
                app.ports.onDropdownEscapeKeyPressed.send("");
            }
        }, {
            capture: true
        });
    }
};
const $e74b572ff485efd6$var$focusPreviousFocusableItem = (element)=>{
    let previousElement = element.previousElementSibling;
    while(previousElement != element)if (previousElement) {
        if ($e74b572ff485efd6$var$canFocus(previousElement)) {
            previousElement.focus();
            return;
        }
        previousElement = previousElement.previousElementSibling;
    } else previousElement = element.parentElement.lastElementChild;
};
const $e74b572ff485efd6$var$canFocus = (item)=>{
    return item.classList.contains("new-dropdown-menu__item--focusable") && getComputedStyle(item).display != "none";
};
const $e74b572ff485efd6$var$focusNextFocusableItem = (element)=>{
    let nextElement = element.nextElementSibling;
    while(nextElement != element)if (nextElement) {
        if ($e74b572ff485efd6$var$canFocus(nextElement)) {
            nextElement.focus();
            return;
        }
        nextElement = nextElement.nextElementSibling;
    } else nextElement = element.parentElement.firstElementChild;
};
module.exports = $e74b572ff485efd6$var$DropdownPort;

});

parcelRegister("3WmqL", function(module, exports) {
"use strict";
const $2de830267383ef38$var$RainforestPort = {
    add: function(app) {
        const insertScriptTag = (rainforestEnv)=>{
            const paymentScript = document.createElement("script");
            const merchantScript = document.createElement("script");
            if (rainforestEnv === "production") {
                paymentScript.src = "https://static.rainforestpay.com/payment.js";
                merchantScript.src = "https://static.rainforestpay.com/merchant.js";
            } else {
                paymentScript.src = "https://static.rainforestpay.com/sandbox.payment.js";
                merchantScript.src = "https://static.rainforestpay.com/sandbox.merchant.js";
            }
            document.body.appendChild(paymentScript);
            document.body.appendChild(merchantScript);
        };
        // Cross browser support
        const requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
        app.ports.rainforestPortLoad.subscribe(function(rainforestEnv1) {
            requestAnimationFrame(function() {
                insertScriptTag(rainforestEnv1);
            });
        });
        app.ports.rainforestSubmitPaymentMethod.subscribe(function() {
            const component = document.getElementsByTagName("rainforest-payment")[0];
            if (!component) return;
            component.submit();
        });
    }
};
module.exports = $2de830267383ef38$var$RainforestPort;

});

parcelRegister("jdEJG", function(module, exports) {
"use strict";
/**
 * This port handles the relative paths of files
 * that are uploaded to the system, allowing to preserve
 * the original directory structure from the client.
 */ class $dfded482d6111a46$var$FileRegistry {
    constructor(){
        this.reset();
    }
    reset() {
        this.filePaths = new WeakMap();
        this.filesByNameAndSize = new Map();
    }
    _generateKey(file) {
        return `${file.name}:${file.size}`;
    }
    addFiles(files) {
        this.reset();
        for (const file of files){
            this.filePaths.set(file, file.webkitRelativePath || file.name);
            const key = this._generateKey(file);
            if (!this.filesByNameAndSize.has(key)) this.filesByNameAndSize.set(key, []);
            this.filesByNameAndSize.get(key).push({
                file: file,
                assigned: false
            });
        }
    }
    getFilePath(fileInfo) {
        const key = this._generateKey(fileInfo);
        const candidateFiles = this.filesByNameAndSize.get(key) || [];
        const nextAvailableFile = candidateFiles.find((item)=>!item.assigned);
        if (nextAvailableFile) {
            nextAvailableFile.assigned = true;
            const originalFilePath = this.filePaths.get(nextAvailableFile.file);
            return [
                fileInfo.name,
                originalFilePath,
                fileInfo.size
            ];
        } else return [
            fileInfo.name,
            "",
            fileInfo.size
        ];
    }
}
const $dfded482d6111a46$var$setup = (registry)=>{
    const handleFileChange = function(event) {
        if (event.target.type === "file") {
            const files = event.target.files || [];
            registry.addFiles(files);
        }
    };
    document.addEventListener("change", handleFileChange, true);
};
const $dfded482d6111a46$var$FilePathsPort = {
    add: function(app) {
        const registry = new $dfded482d6111a46$var$FileRegistry();
        $dfded482d6111a46$var$setup(registry);
        app.ports.getFilePath.subscribe(function(fileInfo) {
            app.ports.receiveFilePath.send(registry.getFilePath(fileInfo));
        });
    }
};
module.exports = $dfded482d6111a46$var$FilePathsPort;

});

parcelRegister("21gpv", function(module, exports) {
/* global CONFIGURATION, PartnerApp, Frontegg */ module.exports = {
    add: (app)=>{
        const script = document.createElement("script");
        script.src = CONFIGURATION.apiUrl + "/partner-app.js?ts=" + Date.now();
        script.async = true;
        document.body.appendChild(script);
        script.onload = ()=>{
            app.ports.partnerAppsMount.subscribe(({ id: id, appId: appId, type_: type_ })=>{
                const apiUrl = CONFIGURATION.apiUrl;
                const attemptMount = (retryCount = 0)=>{
                    const maxRetries = 50;
                    const retryDelay = 100;
                    const authState = Frontegg.AppHolder._apps.default.store.getState().auth;
                    const token = authState.user?.accessToken;
                    if (token) PartnerApp.mount(id, {
                        appId: appId,
                        type: type_,
                        token: token,
                        apiUrl: apiUrl
                    });
                    else if (retryCount < maxRetries) setTimeout(()=>attemptMount(retryCount + 1), retryDelay);
                    else console.error("Could not get access token from frontegg");
                };
                attemptMount();
            });
        };
    }
};

});

var $e053cca534b71031$exports = {};
$parcel$extendImportMap({
    "50t6p": "hint-release-tag/browser.e142ea8e.js"
});

/* global CONFIGURATION, setupNewRelic, setupStatusPage */ 
var $2Pa11 = parcelRequire("2Pa11");

var $2Pa11 = parcelRequire("2Pa11");

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");
const $a8fcea8fa590fcc8$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $a8fcea8fa590fcc8$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $a8fcea8fa590fcc8$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $a8fcea8fa590fcc8$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $a8fcea8fa590fcc8$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $a8fcea8fa590fcc8$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $a8fcea8fa590fcc8$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $a8fcea8fa590fcc8$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!$a8fcea8fa590fcc8$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $a8fcea8fa590fcc8$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $a8fcea8fa590fcc8$export$2d8f5188773bcddd(integration) {
    const client = (0, $2Pa11.getClient)();
    if (!client) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $a8fcea8fa590fcc8$export$2323046b9414659f(fn) {
    return fn;
}



var $gTUNT = parcelRequire("gTUNT");
const $16cfa9df699f9a64$var$INTEGRATION_NAME = 'ConversationId';
const $16cfa9df699f9a64$var$_conversationIdIntegration = ()=>{
    return {
        name: $16cfa9df699f9a64$var$INTEGRATION_NAME,
        setup (client) {
            client.on('spanStart', (span)=>{
                const scopeData = (0, $2Pa11.getCurrentScope)().getScopeData();
                const isolationScopeData = (0, $2Pa11.getIsolationScope)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) span.setAttribute((0, $gTUNT.GEN_AI_CONVERSATION_ID_ATTRIBUTE), conversationId);
            });
        }
    };
};
/**
 * Automatically applies conversation ID from scope to spans.
 *
 * This integration reads the conversation ID from the current or isolation scope
 * and applies it to spans when they start. This ensures the conversation ID is
 * available for all AI-related operations.
 */ const $16cfa9df699f9a64$export$97457a453081a5b3 = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)($16cfa9df699f9a64$var$_conversationIdIntegration);


var $jMrh2 = parcelRequire("jMrh2");


var $1ATua = parcelRequire("1ATua");

var $bE8ha = parcelRequire("bE8ha");
const $65e42714649a8e9c$var$INTEGRATION_NAME = 'Dedupe';
const $65e42714649a8e9c$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $65e42714649a8e9c$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($65e42714649a8e9c$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $65e42714649a8e9c$export$6d39aa44cd0c7567 = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)($65e42714649a8e9c$var$_dedupeIntegration);
/** only exported for tests. */ function $65e42714649a8e9c$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($65e42714649a8e9c$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($65e42714649a8e9c$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $65e42714649a8e9c$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$65e42714649a8e9c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$65e42714649a8e9c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $65e42714649a8e9c$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $65e42714649a8e9c$var$_getExceptionFromEvent(previousEvent);
    const currentException = $65e42714649a8e9c$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$65e42714649a8e9c$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$65e42714649a8e9c$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $65e42714649a8e9c$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $bE8ha.getFramesFromEvent)(currentEvent);
    let previousFrames = (0, $bE8ha.getFramesFromEvent)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $65e42714649a8e9c$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch  {
        return false;
    }
}
function $65e42714649a8e9c$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}


var $2Pa11 = parcelRequire("2Pa11");


var $fOolf = parcelRequire("fOolf");
let $35b7f33c5ff3b983$var$originalFunctionToString;
const $35b7f33c5ff3b983$var$INTEGRATION_NAME = 'FunctionToString';
const $35b7f33c5ff3b983$var$SETUP_CLIENTS = new WeakMap();
const $35b7f33c5ff3b983$var$_functionToStringIntegration = ()=>{
    return {
        name: $35b7f33c5ff3b983$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $35b7f33c5ff3b983$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $fOolf.getOriginalFunction)(this);
                    const context = $35b7f33c5ff3b983$var$SETUP_CLIENTS.has((0, $2Pa11.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $35b7f33c5ff3b983$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $35b7f33c5ff3b983$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $35b7f33c5ff3b983$export$7918117e9202e4fb = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)($35b7f33c5ff3b983$var$_functionToStringIntegration);


var $jMrh2 = parcelRequire("jMrh2");


var $1ATua = parcelRequire("1ATua");
/**
 * Get a list of possible event messages from a Sentry event.
 */ function $516172830308bf3f$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}



var $5NWBT = parcelRequire("5NWBT");

var $gqtzY = parcelRequire("gqtzY");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $7a12bd42514a67de$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    /can't redefine non-configurable property "solana"/,
    /vv\(\)\.getRestrictions is not a function/,
    /Can't find variable: _AutofillCallbackHandler/,
    /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $7a12bd42514a67de$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $7a12bd42514a67de$export$9a84f518c163c552 = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $7a12bd42514a67de$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $7a12bd42514a67de$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $7a12bd42514a67de$var$_mergeOptions(options, clientOptions);
            }
            return $7a12bd42514a67de$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $7a12bd42514a67de$export$cb3c5c2ceb9818ba = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)((options = {})=>{
    return {
        ...$7a12bd42514a67de$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $7a12bd42514a67de$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $7a12bd42514a67de$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $7a12bd42514a67de$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($7a12bd42514a67de$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $5NWBT.getEventDescription)(event)}`);
            return true;
        }
        if ($7a12bd42514a67de$var$_isUselessError(event)) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $5NWBT.getEventDescription)(event)}`);
            return true;
        }
        if ($7a12bd42514a67de$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $5NWBT.getEventDescription)(event)}.\nUrl: ${$7a12bd42514a67de$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$7a12bd42514a67de$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $5NWBT.getEventDescription)(event)}.\nUrl: ${$7a12bd42514a67de$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($7a12bd42514a67de$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $5NWBT.getEventDescription)(event)}`);
            return true;
        }
    }
    return false;
}
function $7a12bd42514a67de$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $516172830308bf3f$export$d55a97c329cacfcc)(event).some((message)=>(0, $gqtzY.stringMatchesSomePattern)(message, ignoreErrors));
}
function $7a12bd42514a67de$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $gqtzY.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $7a12bd42514a67de$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $7a12bd42514a67de$var$_getEventFilterUrl(event);
    return !url ? false : (0, $gqtzY.stringMatchesSomePattern)(url, denyUrls);
}
function $7a12bd42514a67de$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $7a12bd42514a67de$var$_getEventFilterUrl(event);
    return !url ? true : (0, $gqtzY.stringMatchesSomePattern)(url, allowUrls);
}
function $7a12bd42514a67de$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $7a12bd42514a67de$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $7a12bd42514a67de$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).error(`Cannot extract url for event ${(0, $5NWBT.getEventDescription)(event)}`);
        return null;
    }
}
function $7a12bd42514a67de$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}


var $2Pa11 = parcelRequire("2Pa11");

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $7a3d5d890048aa50$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $jMrh2.DEBUG_BUILD) (0, $1ATua.debug).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $1ATua.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $2Pa11.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $7a3d5d890048aa50$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $7a3d5d890048aa50$export$ecb76f41d43c0e43(client) {
    (0, $2Pa11.getCurrentScope)().setClient(client);
}


var $bE8ha = parcelRequire("bE8ha");
/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function $8ead3519ba5db9c0$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === 'object' && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes('value');
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function $8ead3519ba5db9c0$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $8ead3519ba5db9c0$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = $8ead3519ba5db9c0$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === 'string' ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === 'skip-undefined' && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = '';
    try {
        stringValue = JSON.stringify(value) ?? '';
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: 'string',
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function $8ead3519ba5db9c0$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $8ead3519ba5db9c0$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function $8ead3519ba5db9c0$var$getTypedAttributeValue(value) {
    const primitiveType = typeof value === 'string' ? 'string' : typeof value === 'boolean' ? 'boolean' : typeof value === 'number' && !Number.isNaN(value) ? Number.isInteger(value) ? 'integer' : 'double' : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value: value,
        type: primitiveType
    };
}



var $eKPY4 = parcelRequire("eKPY4");

var $2Pa11 = parcelRequire("2Pa11");

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $gWidS = parcelRequire("gWidS");

var $7ZJbk = parcelRequire("7ZJbk");

var $e4zyg = parcelRequire("e4zyg");

var $dQx3S = parcelRequire("dQx3S");
const $cee74bdb80b112e3$var$SEQUENCE_ATTR_KEY = 'sentry.timestamp.sequence';
let $cee74bdb80b112e3$var$_sequenceNumber = 0;
let $cee74bdb80b112e3$var$_previousTimestampMs;
/**
 * Returns the `sentry.timestamp.sequence` attribute entry for a serialized telemetry item.
 *
 * The sequence number starts at 0 and increments by 1 for each item captured.
 * It resets to 0 when the current item's integer millisecond timestamp differs
 * from the previous item's integer millisecond timestamp.
 *
 * @param timestampInSeconds - The timestamp of the telemetry item in seconds.
 */ function $cee74bdb80b112e3$export$63ada7b125d23ef9(timestampInSeconds) {
    const nowMs = Math.floor(timestampInSeconds * 1000);
    if ($cee74bdb80b112e3$var$_previousTimestampMs !== undefined && nowMs !== $cee74bdb80b112e3$var$_previousTimestampMs) $cee74bdb80b112e3$var$_sequenceNumber = 0;
    const value = $cee74bdb80b112e3$var$_sequenceNumber;
    $cee74bdb80b112e3$var$_sequenceNumber++;
    $cee74bdb80b112e3$var$_previousTimestampMs = nowMs;
    return {
        key: $cee74bdb80b112e3$var$SEQUENCE_ATTR_KEY,
        value: {
            value: value,
            type: 'integer'
        }
    };
}



var $2Pa11 = parcelRequire("2Pa11");

var $3KL2m = parcelRequire("3KL2m");

var $8C36L = parcelRequire("8C36L");
/** Extract trace information from scope */ function $72a60ccb53c645c9$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $2Pa11.withScope)(scope, ()=>{
        const span = (0, $8C36L.getActiveSpan)();
        const traceContext = span ? (0, $8C36L.spanToTraceContext)(span) : (0, $2Pa11.getTraceContextFromScope)(scope);
        const dynamicSamplingContext = span ? (0, $3KL2m.getDynamicSamplingContextFromSpan)(span) : (0, $3KL2m.getDynamicSamplingContextFromScope)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $049e67160fa55ad9$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};



var $6Zvn8 = parcelRequire("6Zvn8");

var $45Tty = parcelRequire("45Tty");
/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $1eb679f1b12678df$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $1eb679f1b12678df$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $6Zvn8.dsnToString)(dsn);
    return (0, $45Tty.createEnvelope)(headers, [
        $1eb679f1b12678df$export$efdf3b13edb1118e(logs)
    ]);
}


const $d119c9fe19f61302$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $d119c9fe19f61302$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $d119c9fe19f61302$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $d119c9fe19f61302$var$_getBufferMap();
    const logBuffer = $d119c9fe19f61302$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $d119c9fe19f61302$var$MAX_LOG_BUFFER_SIZE) {
        $d119c9fe19f61302$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $d119c9fe19f61302$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $2Pa11.getCurrentScope)(), captureSerializedLog = $d119c9fe19f61302$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $2Pa11.getClient)();
    if (!client) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $72a60ccb53c645c9$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = (0, $7ZJbk.getCombinedScopeData)((0, $2Pa11.getIsolationScope)(), currentScope);
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'sentry._internal.replay_is_buffering', true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $gWidS.isParameterizedString)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $e4zyg._getSpanForScope)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $d119c9fe19f61302$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $1ATua.consoleSandbox)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const timestamp = (0, $dQx3S.timestampInSeconds)();
    const sequenceAttr = (0, $cee74bdb80b112e3$export$63ada7b125d23ef9)(timestamp);
    const serializedLog = {
        timestamp: timestamp,
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $049e67160fa55ad9$export$4fb50c0840d636d1)[level],
        attributes: {
            ...(0, $8ead3519ba5db9c0$export$4954cae66e755861)(scopeAttributes),
            ...(0, $8ead3519ba5db9c0$export$4954cae66e755861)(logAttributes, true),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $d119c9fe19f61302$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $d119c9fe19f61302$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $1eb679f1b12678df$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $d119c9fe19f61302$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $d119c9fe19f61302$export$5365c9902fb9e770(client) {
    return $d119c9fe19f61302$var$_getBufferMap().get(client);
}
function $d119c9fe19f61302$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $eKPY4.getGlobalSingleton)('clientToLogBufferMap', ()=>new WeakMap());
}



var $eKPY4 = parcelRequire("eKPY4");

var $2Pa11 = parcelRequire("2Pa11");

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $7ZJbk = parcelRequire("7ZJbk");

var $e4zyg = parcelRequire("e4zyg");

var $dQx3S = parcelRequire("dQx3S");



var $6Zvn8 = parcelRequire("6Zvn8");

var $45Tty = parcelRequire("45Tty");
/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @returns The created metric container envelope item.
 */ function $d6316a6c40742061$export$58e45eb52ad1077d(items) {
    return [
        {
            type: 'trace_metric',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.trace-metric+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $d6316a6c40742061$export$f23eb96e33154901(metrics, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $6Zvn8.dsnToString)(dsn);
    return (0, $45Tty.createEnvelope)(headers, [
        $d6316a6c40742061$export$58e45eb52ad1077d(metrics)
    ]);
}


const $77c2c475e37ed0aa$var$MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $77c2c475e37ed0aa$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $77c2c475e37ed0aa$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $77c2c475e37ed0aa$var$_getBufferMap();
    const metricBuffer = $77c2c475e37ed0aa$export$49385134251b08ff(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $77c2c475e37ed0aa$var$MAX_METRIC_BUFFER_SIZE) {
        $77c2c475e37ed0aa$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function $77c2c475e37ed0aa$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    // Add user attributes
    $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'user.id', user.id, false);
    $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'user.email', user.email, false);
    $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'user.name', user.username, false);
    // Add Sentry metadata
    $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'sentry.release', release);
    $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'sentry.environment', environment);
    // Add SDK metadata
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.name', name);
    $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.version', version);
    // Add replay metadata
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') $77c2c475e37ed0aa$var$setMetricAttribute(processedMetricAttributes, 'sentry._internal.replay_is_buffering', true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function $77c2c475e37ed0aa$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    // Get trace context
    const [, traceContext] = (0, $72a60ccb53c645c9$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $e4zyg._getSpanForScope)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    const timestamp = (0, $dQx3S.timestampInSeconds)();
    const sequenceAttr = (0, $cee74bdb80b112e3$export$63ada7b125d23ef9)(timestamp);
    return {
        timestamp: timestamp,
        trace_id: traceId ?? '',
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $8ead3519ba5db9c0$export$4954cae66e755861)(scopeAttributes),
            ...(0, $8ead3519ba5db9c0$export$4954cae66e755861)(metric.attributes, 'skip-undefined'),
            [sequenceAttr.key]: sequenceAttr.value
        }
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $77c2c475e37ed0aa$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $2Pa11.getCurrentScope)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $77c2c475e37ed0aa$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $2Pa11.getClient)();
    if (!client) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('No client available to capture metric.');
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('metrics option not enabled, metric will not be captured.');
        return;
    }
    // Enrich metric with contextual attributes
    const { user: user, attributes: scopeAttributes } = (0, $7ZJbk.getCombinedScopeData)((0, $2Pa11.getIsolationScope)(), currentScope);
    const enrichedMetric = $77c2c475e37ed0aa$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit('processMetric', enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('`beforeSendMetric` returned `null`, will not send metric.');
        return;
    }
    const serializedMetric = $77c2c475e37ed0aa$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('[Metric]', serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit('afterCaptureMetric', processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $77c2c475e37ed0aa$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $77c2c475e37ed0aa$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $d6316a6c40742061$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the metric buffer after envelopes have been constructed.
    $77c2c475e37ed0aa$var$_getBufferMap().set(client, []);
    client.emit('flushMetrics');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function $77c2c475e37ed0aa$export$49385134251b08ff(client) {
    return $77c2c475e37ed0aa$var$_getBufferMap().get(client);
}
function $77c2c475e37ed0aa$var$_getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return (0, $eKPY4.getGlobalSingleton)('clientToMetricBufferMap', ()=>new WeakMap());
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ function $eb824d107e500a4e$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $eb824d107e500a4e$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


var $lLmxT = parcelRequire("lLmxT");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $a35f192848dcaa12$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
    if (!sdk.name) {
        sdk.name = `sentry.javascript.${name}`;
        sdk.packages = names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $lLmxT.SDK_VERSION)
            }));
        sdk.version = (0, $lLmxT.SDK_VERSION);
    }
}


var $6Zvn8 = parcelRequire("6Zvn8");
const $5243194a12c70fc4$export$9207631ea4ce5c48 = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $5243194a12c70fc4$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $5243194a12c70fc4$var$_getIngestEndpoint(dsn) {
    return `${$5243194a12c70fc4$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $5243194a12c70fc4$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $5243194a12c70fc4$export$9207631ea4ce5c48
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $5243194a12c70fc4$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$5243194a12c70fc4$var$_getIngestEndpoint(dsn)}?${$5243194a12c70fc4$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $5243194a12c70fc4$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $6Zvn8.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$5243194a12c70fc4$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $6Zvn8.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}



var $fsBIR = parcelRequire("fsBIR");

var $2Pa11 = parcelRequire("2Pa11");

var $jMrh2 = parcelRequire("jMrh2");

var $8R6vM = parcelRequire("8R6vM");




var $iny8b = parcelRequire("iny8b");

var $3KL2m = parcelRequire("3KL2m");

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $45Tty = parcelRequire("45Tty");

var $e07xZ = parcelRequire("e07xZ");
/**
 * Calls `unref` on a timer, if the method is available on @param timer.
 *
 * `unref()` is used to allow processes to exit immediately, even if the timer
 * is still running and hasn't resolved yet.
 *
 * Use this in places where code can run on browser or server, since browsers
 * do not support `unref`.
 */ function $f72b9383890004b6$export$630056cb83d87863(timer) {
    if (typeof timer === 'object' && typeof timer.unref === 'function') timer.unref();
    return timer;
}


const $704e8b3ce2124605$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $704e8b3ce2124605$export$85a4f67f852183e6(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $e07xZ.rejectedSyncPromise)($704e8b3ce2124605$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return (0, $e07xZ.resolvedSyncPromise)(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>(0, $f72b9383890004b6$export$630056cb83d87863)(setTimeout(()=>resolve(false), timeout)))
        ];
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



var $8fF74 = parcelRequire("8fF74");
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $408918dfcc7847e4$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $408918dfcc7847e4$export$615352e17ed7741(header, now = (0, $8fF74.safeDateNow)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $408918dfcc7847e4$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $408918dfcc7847e4$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $408918dfcc7847e4$export$6c91fec22056810a(limits, dataCategory, now = (0, $8fF74.safeDateNow)()) {
    return $408918dfcc7847e4$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $408918dfcc7847e4$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $8fF74.safeDateNow)()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $408918dfcc7847e4$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $eb8ebfd2c6d05621$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $eb8ebfd2c6d05621$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $704e8b3ce2124605$export$85a4f67f852183e6)(options.bufferSize || $eb8ebfd2c6d05621$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $45Tty.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $45Tty.envelopeItemTypeToDataCategory)(type);
            if ((0, $408918dfcc7847e4$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $45Tty.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            // Don't record outcomes for client reports - we don't want to create a feedback loop if client reports themselves fail to send
            if ((0, $45Tty.envelopeContainsItemType)(filteredEnvelope, [
                'client_report'
            ])) {
                (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $45Tty.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $45Tty.envelopeItemTypeToDataCategory)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $45Tty.serializeEnvelope)(filteredEnvelope)
            }).then((response)=>{
                // Handle 413 Content Too Large
                // Loss of envelope content is expected so we record a send_error client report
                // https://develop.sentry.dev/sdk/expected-features/#dealing-with-network-failures
                if (response.statusCode === 413) {
                    (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).error('Sentry responded with status code 413. Envelope was discarded due to exceeding size limits.');
                    recordEnvelopeLoss('send_error');
                    return response;
                }
                // We don't want to throw on NOK responses, but we want to at least log them
                if ((0, $jMrh2.DEBUG_BUILD) && response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $1ATua.debug).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $408918dfcc7847e4$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $704e8b3ce2124605$export$c8667f1887a128dc)) {
                (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}



var $45Tty = parcelRequire("45Tty");

var $dQx3S = parcelRequire("dQx3S");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $d00ee0a9bee88668$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $dQx3S.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $45Tty.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}



var $1ATua = parcelRequire("1ATua");

var $6Zvn8 = parcelRequire("6Zvn8");

var $45Tty = parcelRequire("45Tty");


var $gWidS = parcelRequire("gWidS");

var $8IjjG = parcelRequire("8IjjG");

var $5NWBT = parcelRequire("5NWBT");

var $Cb5a4 = parcelRequire("Cb5a4");

var $gdNBn = parcelRequire("gdNBn");


var $8fF74 = parcelRequire("8fF74");

var $kIFK2 = parcelRequire("kIFK2");

var $8C36L = parcelRequire("8C36L");

var $e07xZ = parcelRequire("e07xZ");


var $gTUNT = parcelRequire("gTUNT");
/**
 * Converts a transaction event to a span JSON object.
 */ function $e370e087ce72e343$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $gTUNT.SEMANTIC_ATTRIBUTE_PROFILE_ID],
        exclusive_time: data?.[0, $gTUNT.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $e370e087ce72e343$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $gTUNT.SEMANTIC_ATTRIBUTE_PROFILE_ID)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $gTUNT.SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}


/* eslint-disable max-lines */ const $af8b318b20a71384$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $af8b318b20a71384$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $af8b318b20a71384$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $af8b318b20a71384$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
// Default interval for flushing logs and metrics (5 seconds)
const $af8b318b20a71384$var$DEFAULT_FLUSH_INTERVAL = 5000;
function $af8b318b20a71384$var$_makeInternalError(message) {
    return {
        message: message,
        [$af8b318b20a71384$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $af8b318b20a71384$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$af8b318b20a71384$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $af8b318b20a71384$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $af8b318b20a71384$var$INTERNAL_ERROR_SYMBOL in error;
}
function $af8b318b20a71384$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $af8b318b20a71384$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function $af8b318b20a71384$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            // Use safeUnref so the timer doesn't prevent the process from exiting
            flushTimeout = (0, $f72b9383890004b6$export$630056cb83d87863)(setTimeout(()=>{
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, $af8b318b20a71384$var$DEFAULT_FLUSH_INTERVAL));
        }
    });
    client.on('flush', ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $af8b318b20a71384$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, $704e8b3ce2124605$export$85a4f67f852183e6)(options.transportOptions?.bufferSize ?? (0, $eb8ebfd2c6d05621$export$e515cf6dfd2f98b8));
        if (options.dsn) this._dsn = (0, $6Zvn8.makeDsn)(options.dsn);
        else (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $5243194a12c70fc4$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) $af8b318b20a71384$var$setupWeightBasedFlushing(this, 'afterCaptureLog', 'flushLogs', $af8b318b20a71384$var$estimateLogSizeInBytes, (0, $d119c9fe19f61302$export$f8ed83d3b6a0b504));
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) $af8b318b20a71384$var$setupWeightBasedFlushing(this, 'afterCaptureMetric', 'flushMetrics', $af8b318b20a71384$var$estimateMetricSizeInBytes, (0, $77c2c475e37ed0aa$export$91c9ef254b7d0f67));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $5NWBT.uuid4)();
        // ensure we haven't captured this very object before
        if ((0, $5NWBT.checkOrSetAlreadyCaught)(exception)) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log($af8b318b20a71384$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $5NWBT.uuid4)(),
            ...hint
        };
        const eventMessage = (0, $gWidS.isParameterizedString)(message) ? message : String(message);
        const isMessage = (0, $gWidS.isPrimitive)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? 'unknown' : 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $5NWBT.uuid4)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $5NWBT.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log($af8b318b20a71384$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $af8b318b20a71384$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $iny8b.updateSession)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        if (!transport) return true;
        this.emit('flush');
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        (0, $d119c9fe19f61302$export$f8ed83d3b6a0b504)(this);
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit('close');
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $a8fcea8fa590fcc8$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $a8fcea8fa590fcc8$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $8R6vM.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $45Tty.addItemToEnvelope)(env, (0, $45Tty.createAttachmentEnvelopeItem)(attachment));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $fsBIR.DEFAULT_ENVIRONMENT) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn($af8b318b20a71384$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn($af8b318b20a71384$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $8R6vM.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).error('Error while sending envelope:', reason);
            return {};
        }
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).error('Transport disabled');
        return {};
    }
    /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources.
   * After calling dispose(), the client should not be used anymore.
   */ dispose() {
    // Base class has no cleanup logic - subclasses implement their own
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $a8fcea8fa590fcc8$export$51abed9797baa598)(this, integrations);
        (0, $a8fcea8fa590fcc8$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        // initially, set `crashed` based on the event level and update from exceptions if there are any later on
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $iny8b.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $gdNBn.prepareEvent)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: {
                    ...evt.contexts?.trace,
                    ...(0, $2Pa11.getTraceContextFromScope)(currentScope)
                },
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $3KL2m.getDynamicSamplingContextFromScope)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $2Pa11.getCurrentScope)(), isolationScope = (0, $2Pa11.getIsolationScope)()) {
        if ((0, $jMrh2.DEBUG_BUILD) && $af8b318b20a71384$var$isErrorEvent(event)) (0, $1ATua.debug).log(`Captured error event \`${(0, $516172830308bf3f$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $jMrh2.DEBUG_BUILD) {
                if ($af8b318b20a71384$var$_isDoNotSendEventError(reason)) (0, $1ATua.debug).log(reason.message);
                else if ($af8b318b20a71384$var$_isInternalError(reason)) (0, $1ATua.debug).warn(reason.message);
                else (0, $1ATua.debug).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $af8b318b20a71384$var$isTransactionEvent(event);
        const isError = $af8b318b20a71384$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $Cb5a4.parseSampleRate)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && (0, $8fF74.safeMathRandom)() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $e07xZ.rejectedSyncPromise)($af8b318b20a71384$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $af8b318b20a71384$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $af8b318b20a71384$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data?.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $af8b318b20a71384$var$processBeforeSend(this, options, prepared, hint);
            return $af8b318b20a71384$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $af8b318b20a71384$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($af8b318b20a71384$var$_isDoNotSendEventError(reason) || $af8b318b20a71384$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: 'internal'
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $af8b318b20a71384$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $704e8b3ce2124605$export$c8667f1887a128dc)) this.recordDroppedEvent('queue_overflow', dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).log('Sending outcomes:', outcomes);
        const envelope = (0, $d00ee0a9bee88668$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $6Zvn8.dsnToString)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
function $af8b318b20a71384$var$getDataCategoryByType(type) {
    return type === 'replay_event' ? 'replay' : type || 'error';
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $af8b318b20a71384$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $gWidS.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $gWidS.isPlainObject)(event) && event !== null) throw $af8b318b20a71384$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $af8b318b20a71384$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $gWidS.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw $af8b318b20a71384$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $af8b318b20a71384$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = options;
    let processedEvent = event;
    if ($af8b318b20a71384$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($af8b318b20a71384$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = (0, $e370e087ce72e343$export$d9c6b2464b0a687e)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && (0, $kIFK2.shouldIgnoreSpan)(rootSpanJson, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $8C36L.showSpanDropWarning)();
                else // update event with processed root span values
                processedEvent = (0, $8IjjG.merge)(event, (0, $e370e087ce72e343$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && (0, $kIFK2.shouldIgnoreSpan)(span, ignoreSpans)) {
                        (0, $kIFK2.reparentChildSpans)(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $8C36L.showSpanDropWarning)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $af8b318b20a71384$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $af8b318b20a71384$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function $af8b318b20a71384$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + $af8b318b20a71384$var$estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function $af8b318b20a71384$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + $af8b318b20a71384$var$estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function $af8b318b20a71384$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $af8b318b20a71384$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $gWidS.isPrimitive)(value)) weight += $af8b318b20a71384$var$estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function $af8b318b20a71384$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'number') return 8;
    else if (typeof value === 'boolean') return 4;
    return 0;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $82d5e8e2d5d1dc3a$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $82d5e8e2d5d1dc3a$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}



var $gWidS = parcelRequire("gWidS");

var $5NWBT = parcelRequire("5NWBT");

var $fxHHp = parcelRequire("fxHHp");

var $fOolf = parcelRequire("fOolf");
/**
 * Extracts stack frames from the error.stack string
 */ function $91f12bd76f3fc3bf$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
function $91f12bd76f3fc3bf$var$hasSentryFetchUrlHost(error) {
    return (0, $gWidS.isError)(error) && '__sentry_fetch_url_host__' in error && typeof error.__sentry_fetch_url_host__ === 'string';
}
/**
 * Enhances the error message with the hostname for better Sentry error reporting.
 * This allows third-party packages to still match on the original error message,
 * while Sentry gets the enhanced version with context.
 *
 * Only used internally
 * @hidden
 */ function $91f12bd76f3fc3bf$export$35a730c8874c1024(error) {
    // If the error has a __sentry_fetch_url_host__ property (added by fetch instrumentation),
    // enhance the error message with the hostname.
    if ($91f12bd76f3fc3bf$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $91f12bd76f3fc3bf$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $91f12bd76f3fc3bf$export$35a730c8874c1024(error)
    };
    const frames = $91f12bd76f3fc3bf$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function $91f12bd76f3fc3bf$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
function $91f12bd76f3fc3bf$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    const keys = (0, $fOolf.extractExceptionKeysForMessage)(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $gWidS.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $91f12bd76f3fc3bf$var$getObjectClassName(exception);
    return `${className && className !== 'Object' ? `'${className}'` : 'Object'} captured as exception with keys: ${keys}`;
}
function $91f12bd76f3fc3bf$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
function $91f12bd76f3fc3bf$var$getException(client, mechanism, exception, hint) {
    if ((0, $gWidS.isError)(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ((0, $gWidS.isPlainObject)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ['__serialized__']: (0, $fxHHp.normalizeToSize)(exception, normalizeDepth)
        };
        const errorFromProp = $91f12bd76f3fc3bf$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $91f12bd76f3fc3bf$var$getMessageForObject(exception);
        const ex = hint?.syntheticException || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function $91f12bd76f3fc3bf$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    const [ex, extras] = $91f12bd76f3fc3bf$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $91f12bd76f3fc3bf$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $5NWBT.addExceptionTypeValue)(event, undefined, undefined);
    (0, $5NWBT.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $91f12bd76f3fc3bf$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $91f12bd76f3fc3bf$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $5NWBT.addExceptionMechanism)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $gWidS.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


var $5NWBT = parcelRequire("5NWBT");
var $fOolf = parcelRequire("fOolf");
var $2Pa11 = parcelRequire("2Pa11");
var $gWidS = parcelRequire("gWidS");
var $fxHHp = parcelRequire("fxHHp");
var $e07xZ = parcelRequire("e07xZ");
/**
 * This function creates an exception from a JavaScript Error
 */ function $071c3f82346abcc5$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $071c3f82346abcc5$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $071c3f82346abcc5$export$2e9ae379995d99e3(ex),
        value: $071c3f82346abcc5$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $071c3f82346abcc5$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $2Pa11.getClient)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $071c3f82346abcc5$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $fxHHp.normalizeToSize)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $071c3f82346abcc5$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $gWidS.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $071c3f82346abcc5$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $071c3f82346abcc5$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $071c3f82346abcc5$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $071c3f82346abcc5$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $071c3f82346abcc5$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $071c3f82346abcc5$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $071c3f82346abcc5$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $071c3f82346abcc5$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $071c3f82346abcc5$var$getSkipFirstStackStringLines(ex) {
    if (ex && $071c3f82346abcc5$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $071c3f82346abcc5$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $071c3f82346abcc5$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    // oxlint-disable-next-line typescript/prefer-optional-chain
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $071c3f82346abcc5$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $071c3f82346abcc5$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $071c3f82346abcc5$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($071c3f82346abcc5$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return (0, $91f12bd76f3fc3bf$export$35a730c8874c1024)(message.error);
    return (0, $91f12bd76f3fc3bf$export$35a730c8874c1024)(ex);
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $071c3f82346abcc5$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $071c3f82346abcc5$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $5NWBT.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $e07xZ.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $071c3f82346abcc5$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $071c3f82346abcc5$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $e07xZ.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $071c3f82346abcc5$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $gWidS.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $071c3f82346abcc5$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $gWidS.isDOMError)(exception) || (0, $gWidS.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $071c3f82346abcc5$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $gWidS.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $071c3f82346abcc5$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $5NWBT.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $gWidS.isError)(exception)) // we have a real Error object, do nothing
    return $071c3f82346abcc5$var$eventFromError(stackParser, exception);
    if ((0, $gWidS.isPlainObject)(exception) || (0, $gWidS.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $071c3f82346abcc5$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $5NWBT.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $071c3f82346abcc5$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $5NWBT.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $5NWBT.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $071c3f82346abcc5$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $071c3f82346abcc5$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $5NWBT.addExceptionMechanism)(event, {
            synthetic: true
        });
    }
    if ((0, $gWidS.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $071c3f82346abcc5$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $fOolf.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $gWidS.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $gWidS.isEvent)(exception)) {
        const className = $071c3f82346abcc5$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $071c3f82346abcc5$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $071c3f82346abcc5$var$getErrorPropertyFromObject(obj) {
    return Object.values(obj).find((v)=>v instanceof Error);
}



var $5NWBT = parcelRequire("5NWBT");
var $fOolf = parcelRequire("fOolf");
var $lHnfk = parcelRequire("lHnfk");
var $konzj = parcelRequire("konzj");
var $gKrW9 = parcelRequire("gKrW9");
var $2Pa11 = parcelRequire("2Pa11");
const $6dae9d95bf10974c$export$56d8a8a25bd48b81 = (0, $gKrW9.GLOBAL_OBJ);
let $6dae9d95bf10974c$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $6dae9d95bf10974c$export$b79738ab10c590b2() {
    return $6dae9d95bf10974c$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $6dae9d95bf10974c$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $6dae9d95bf10974c$var$ignoreOnError++;
    setTimeout(()=>{
        $6dae9d95bf10974c$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $6dae9d95bf10974c$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $fOolf.getOriginalFunction)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$6dae9d95bf10974c$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $6dae9d95bf10974c$export$1265a142ff5ba165();
            (0, $2Pa11.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $5NWBT.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $5NWBT.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $lHnfk.captureException)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $fOolf.markFunctionWrapped)(sentryWrapped, fn);
    (0, $fOolf.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $6dae9d95bf10974c$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $konzj.getLocationHref)();
    const { referrer: referrer } = $6dae9d95bf10974c$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $6dae9d95bf10974c$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $77776fecbac44e2f$export$1df9218a526d318d extends (0, $af8b318b20a71384$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $77776fecbac44e2f$export$4e107b20a7f977(options);
        const sdkSource = (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $82d5e8e2d5d1dc3a$export$8ad33f488b1ab046)();
        (0, $a35f192848dcaa12$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never',
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        // todo(v11): Remove the experimental flag
        if ((0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $d119c9fe19f61302$export$f8ed83d3b6a0b504)(this);
                if (enableMetrics) (0, $77c2c475e37ed0aa$export$91c9ef254b7d0f67)(this);
            }
        });
        if (sendDefaultPii) this.on('beforeSendSession', (0, $eb824d107e500a4e$export$e8e2d07ba63e2b6c));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $071c3f82346abcc5$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $071c3f82346abcc5$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $77776fecbac44e2f$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}



var $2Pa11 = parcelRequire("2Pa11");

var $1ATua = parcelRequire("1ATua");

var $dQx3S = parcelRequire("dQx3S");
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4a6b9ee34ae53a6e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $4a6b9ee34ae53a6e$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $2Pa11.getClient)();
    const isolationScope = (0, $2Pa11.getIsolationScope)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4a6b9ee34ae53a6e$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $dQx3S.dateTimestampInSeconds)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $1ATua.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}


var $1ATua = parcelRequire("1ATua");

var $fOolf = parcelRequire("fOolf");

var $gKrW9 = parcelRequire("gKrW9");

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $bE8ha = parcelRequire("bE8ha");
// We keep the handlers globally
const $0d026b2963ae70d7$var$handlers = {};
const $0d026b2963ae70d7$var$instrumented = {};
/** Add a handler function. */ function $0d026b2963ae70d7$export$a4e09611e30da72e(type, handler) {
    $0d026b2963ae70d7$var$handlers[type] = $0d026b2963ae70d7$var$handlers[type] || [];
    $0d026b2963ae70d7$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $0d026b2963ae70d7$export$b17eab759a1cb5fe() {
    Object.keys($0d026b2963ae70d7$var$handlers).forEach((key)=>{
        $0d026b2963ae70d7$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $0d026b2963ae70d7$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$0d026b2963ae70d7$var$instrumented[type]) {
        $0d026b2963ae70d7$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $0d026b2963ae70d7$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $0d026b2963ae70d7$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $bE8ha.getFunctionName)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5ccf44fc1a438be7$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $0d026b2963ae70d7$export$a4e09611e30da72e)(type, handler);
    (0, $0d026b2963ae70d7$export$e18d6c5462c01368)(type, $5ccf44fc1a438be7$var$instrumentConsole);
}
function $5ccf44fc1a438be7$var$instrumentConsole() {
    if (!('console' in (0, $gKrW9.GLOBAL_OBJ))) return;
    (0, $1ATua.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $gKrW9.GLOBAL_OBJ).console)) return;
        (0, $fOolf.fill)((0, $gKrW9.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $1ATua.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $0d026b2963ae70d7$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $1ATua.originalConsoleMethods)[level];
                log?.apply((0, $gKrW9.GLOBAL_OBJ).console, args);
            };
        });
    });
}


var $2Pa11 = parcelRequire("2Pa11");

var $gWidS = parcelRequire("gWidS");

var $fOolf = parcelRequire("fOolf");

var $jMrh2 = parcelRequire("jMrh2");

var $1ATua = parcelRequire("1ATua");

var $gKrW9 = parcelRequire("gKrW9");
const $e7db6037daffc460$var$WINDOW = (0, $gKrW9.GLOBAL_OBJ);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $e7db6037daffc460$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $e7db6037daffc460$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $e7db6037daffc460$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $e7db6037daffc460$export$67fc34576016d6ec() {
    return 'history' in $e7db6037daffc460$var$WINDOW && !!$e7db6037daffc460$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $e7db6037daffc460$export$edf3cb81fd7d2a3e = $e7db6037daffc460$var$_isFetchSupported;
function $e7db6037daffc460$var$_isFetchSupported() {
    if (!('fetch' in $e7db6037daffc460$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $e7db6037daffc460$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $e7db6037daffc460$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$e7db6037daffc460$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($e7db6037daffc460$export$d5f608b368e73f38($e7db6037daffc460$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $e7db6037daffc460$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $e7db6037daffc460$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $jMrh2.DEBUG_BUILD) && (0, $1ATua.debug).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $e7db6037daffc460$export$531055a6c684a70a() {
    return 'ReportingObserver' in $e7db6037daffc460$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $e7db6037daffc460$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$e7db6037daffc460$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}



var $dQx3S = parcelRequire("dQx3S");

var $gKrW9 = parcelRequire("gKrW9");

/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1f0ea0e14e45fe52$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $0d026b2963ae70d7$export$a4e09611e30da72e)(type, handler);
    (0, $0d026b2963ae70d7$export$e18d6c5462c01368)(type, ()=>$1f0ea0e14e45fe52$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $1f0ea0e14e45fe52$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $0d026b2963ae70d7$export$a4e09611e30da72e)(type, handler);
    (0, $0d026b2963ae70d7$export$e18d6c5462c01368)(type, ()=>$1f0ea0e14e45fe52$var$instrumentFetch($1f0ea0e14e45fe52$var$streamHandler));
}
function $1f0ea0e14e45fe52$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $e7db6037daffc460$export$c82d238e23c40b21)()) return;
    (0, $fOolf.fill)((0, $gKrW9.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $1f0ea0e14e45fe52$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $dQx3S.timestampInSeconds)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $1f0ea0e14e45fe52$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $0d026b2963ae70d7$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $gKrW9.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $0d026b2963ae70d7$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $dQx3S.timestampInSeconds)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $0d026b2963ae70d7$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $dQx3S.timestampInSeconds)() * 1000,
                    error: error
                });
                if ((0, $gWidS.isError)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $fOolf.addNonEnumerableProperty)(error, 'framesToPop', 1);
                }
                // We enhance fetch error messages with hostname information based on the configuration.
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                const client = (0, $2Pa11.getClient)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? 'always';
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    const hostname = url.host;
                    if (enhanceOption === 'always') // Modify the error message directly
                    error.message = `${error.message} (${hostname})`;
                    else // Store hostname as non-enumerable property for Sentry-only enhancement
                    // This preserves the original error message for third-party packages
                    (0, $fOolf.addNonEnumerableProperty)(error, '__sentry_fetch_url_host__', hostname);
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $1f0ea0e14e45fe52$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $1f0ea0e14e45fe52$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $1f0ea0e14e45fe52$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $0d026b2963ae70d7$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $dQx3S.timestampInSeconds)() * 1000,
            response: response
        });
    });
}
function $1f0ea0e14e45fe52$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $1f0ea0e14e45fe52$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($1f0ea0e14e45fe52$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $1f0ea0e14e45fe52$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $1f0ea0e14e45fe52$var$getUrlFromResource(resource),
            method: $1f0ea0e14e45fe52$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : (0, $gWidS.isRequest)(resource) && $1f0ea0e14e45fe52$var$hasProp(resource, 'method') ? String(resource.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $1f0ea0e14e45fe52$var$getUrlFromResource(arg),
        method: $1f0ea0e14e45fe52$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $1f0ea0e14e45fe52$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $gWidS.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}


var $1ATua = parcelRequire("1ATua");/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $90e001414024827e$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}


var $2Pa11 = parcelRequire("2Pa11");
var $konzj = parcelRequire("konzj");
var $5NWBT = parcelRequire("5NWBT");
var $gTUNT = parcelRequire("gTUNT");
// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $aa6227c531197232$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $aa6227c531197232$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $aa6227c531197232$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $aa6227c531197232$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $aa6227c531197232$export$5339fcdc8e2a427c(url) {
    if ($aa6227c531197232$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $aa6227c531197232$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $aa6227c531197232$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $aa6227c531197232$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: spanOrigin,
        [(0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
    }
    if (request?.method) attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = 'route';
        }
        if (!$aa6227c531197232$export$e258e13805402ba7(urlObject)) {
            attributes[0, $gTUNT.SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $aa6227c531197232$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $aa6227c531197232$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $aa6227c531197232$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $aa6227c531197232$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function $aa6227c531197232$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith('data:')) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : 'text/plain';
        const isBase64 = url.includes(';base64,');
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(',');
        let dataPrefix = '';
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ',base64' : ''}${dataPrefix ? `,${dataPrefix}` : ''}`;
    }
    return url;
}


var $gqtzY = parcelRequire("gqtzY");/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $518a505e2e17237c$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}



var $fOolf = parcelRequire("fOolf");
var $5NWBT = parcelRequire("5NWBT");

var $gKrW9 = parcelRequire("gKrW9");
const $af7355079bb90fc7$export$56d8a8a25bd48b81 = (0, $gKrW9.GLOBAL_OBJ);


const $9d3c87f0d3e4d589$var$DEBOUNCE_DURATION = 1000;
let $9d3c87f0d3e4d589$var$debounceTimerID;
let $9d3c87f0d3e4d589$var$lastCapturedEventType;
let $9d3c87f0d3e4d589$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9d3c87f0d3e4d589$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $0d026b2963ae70d7$export$a4e09611e30da72e)(type, handler);
    (0, $0d026b2963ae70d7$export$e18d6c5462c01368)(type, $9d3c87f0d3e4d589$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $9d3c87f0d3e4d589$export$3014bbf0af0e1d4a() {
    if (!(0, $af7355079bb90fc7$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $0d026b2963ae70d7$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $9d3c87f0d3e4d589$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $af7355079bb90fc7$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $af7355079bb90fc7$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $af7355079bb90fc7$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $fOolf.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $9d3c87f0d3e4d589$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $fOolf.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $9d3c87f0d3e4d589$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $9d3c87f0d3e4d589$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $9d3c87f0d3e4d589$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $9d3c87f0d3e4d589$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $9d3c87f0d3e4d589$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $9d3c87f0d3e4d589$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($9d3c87f0d3e4d589$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $fOolf.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $fOolf.addNonEnumerableProperty)(target, '_sentryId', (0, $5NWBT.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$9d3c87f0d3e4d589$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $9d3c87f0d3e4d589$var$lastCapturedEventType = event.type;
            $9d3c87f0d3e4d589$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($9d3c87f0d3e4d589$var$debounceTimerID);
        $9d3c87f0d3e4d589$var$debounceTimerID = (0, $af7355079bb90fc7$export$56d8a8a25bd48b81).setTimeout(()=>{
            $9d3c87f0d3e4d589$var$lastCapturedEventTargetId = undefined;
            $9d3c87f0d3e4d589$var$lastCapturedEventType = undefined;
        }, $9d3c87f0d3e4d589$var$DEBOUNCE_DURATION);
    };
}
function $9d3c87f0d3e4d589$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}


var $fOolf = parcelRequire("fOolf");

let $b7c237754c377b53$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b7c237754c377b53$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $0d026b2963ae70d7$export$a4e09611e30da72e)(type, handler);
    (0, $0d026b2963ae70d7$export$e18d6c5462c01368)(type, $b7c237754c377b53$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $b7c237754c377b53$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $af7355079bb90fc7$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $af7355079bb90fc7$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $b7c237754c377b53$var$lastHref;
        $b7c237754c377b53$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $0d026b2963ae70d7$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $e7db6037daffc460$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $b7c237754c377b53$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $b7c237754c377b53$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $b7c237754c377b53$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $0d026b2963ae70d7$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $fOolf.fill)((0, $af7355079bb90fc7$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $fOolf.fill)((0, $af7355079bb90fc7$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}
function $b7c237754c377b53$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $af7355079bb90fc7$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}


var $gWidS = parcelRequire("gWidS");
var $dQx3S = parcelRequire("dQx3S");

const $2a85f774ae9fd231$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2a85f774ae9fd231$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $0d026b2963ae70d7$export$a4e09611e30da72e)(type, handler);
    (0, $0d026b2963ae70d7$export$e18d6c5462c01368)(type, $2a85f774ae9fd231$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $2a85f774ae9fd231$export$c67d533bf77cbf54() {
    if (!(0, $af7355079bb90fc7$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $dQx3S.timestampInSeconds)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $gWidS.isString)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $2a85f774ae9fd231$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$2a85f774ae9fd231$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$2a85f774ae9fd231$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $dQx3S.timestampInSeconds)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $0d026b2963ae70d7$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$2a85f774ae9fd231$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $gWidS.isString)(header) && (0, $gWidS.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$2a85f774ae9fd231$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $dQx3S.timestampInSeconds)() * 1000,
                xhr: sendThisArg
            };
            (0, $0d026b2963ae70d7$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $2a85f774ae9fd231$var$parseXhrUrlArg(url) {
    if ((0, $gWidS.isString)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $82fc00877a9e6d47$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $0c92771e42004ee7$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $0c92771e42004ee7$var$INTEGRATION_NAME = 'Breadcrumbs';
const $0c92771e42004ee7$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $0c92771e42004ee7$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $5ccf44fc1a438be7$export$1d6e0d073f9e6723)($0c92771e42004ee7$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $9d3c87f0d3e4d589$export$5aeffd3db2cf9df7)($0c92771e42004ee7$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $2a85f774ae9fd231$export$26ace48dd54c9aea)($0c92771e42004ee7$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $1f0ea0e14e45fe52$export$f75d3c772c923df0)($0c92771e42004ee7$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $b7c237754c377b53$export$3f18c56c58114e75)($0c92771e42004ee7$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $0c92771e42004ee7$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $0c92771e42004ee7$export$c079d904b326663a = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)($0c92771e42004ee7$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $0c92771e42004ee7$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $2Pa11.getClient)() !== client) return;
        (0, $4a6b9ee34ae53a6e$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $5NWBT.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $0c92771e42004ee7$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $2Pa11.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $0c92771e42004ee7$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $82fc00877a9e6d47$export$16a28057038b10ef) && (0, $1ATua.debug).warn(`\`dom.maxStringLength\` cannot exceed ${$0c92771e42004ee7$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$0c92771e42004ee7$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $0c92771e42004ee7$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $0c92771e42004ee7$var$_isEvent(event) ? event.target : event;
            target = (0, $konzj.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $konzj.getComponentName)(element);
        } catch  {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $4a6b9ee34ae53a6e$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $0c92771e42004ee7$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $2Pa11.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $518a505e2e17237c$export$d771ef054122c30a)(handlerData.level),
            message: (0, $gqtzY.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $gqtzY.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $4a6b9ee34ae53a6e$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $0c92771e42004ee7$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $2Pa11.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $2a85f774ae9fd231$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $90e001414024827e$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $4a6b9ee34ae53a6e$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $0c92771e42004ee7$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $2Pa11.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: handlerData.fetchData,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $4a6b9ee34ae53a6e$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $90e001414024827e$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $4a6b9ee34ae53a6e$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $0c92771e42004ee7$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $2Pa11.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $aa6227c531197232$export$7a5253c0f62e0150)((0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $aa6227c531197232$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $aa6227c531197232$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $4a6b9ee34ae53a6e$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $0c92771e42004ee7$var$_isEvent(event) {
    return !!event && !!event.target;
}



var $fOolf = parcelRequire("fOolf");
var $bE8ha = parcelRequire("bE8ha");

// Using a comma-separated string and split for smaller bundle size vs an array literal
const $f3e0375b84877586$var$DEFAULT_EVENT_TARGET = 'EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload'.split(',');
const $f3e0375b84877586$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $f3e0375b84877586$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $f3e0375b84877586$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $fOolf.fill)((0, $6dae9d95bf10974c$export$56d8a8a25bd48b81), 'setTimeout', $f3e0375b84877586$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $fOolf.fill)((0, $6dae9d95bf10974c$export$56d8a8a25bd48b81), 'setInterval', $f3e0375b84877586$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $fOolf.fill)((0, $6dae9d95bf10974c$export$56d8a8a25bd48b81), 'requestAnimationFrame', $f3e0375b84877586$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81)) (0, $fOolf.fill)(XMLHttpRequest.prototype, 'send', $f3e0375b84877586$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $f3e0375b84877586$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$f3e0375b84877586$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $f3e0375b84877586$export$59bfe9f1c76150e = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)($f3e0375b84877586$var$_browserApiErrorsIntegration);
function $f3e0375b84877586$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $6dae9d95bf10974c$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $bE8ha.getFunctionName)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $f3e0375b84877586$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $6dae9d95bf10974c$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $bE8ha.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function $f3e0375b84877586$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $fOolf.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $bE8ha.getFunctionName)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $fOolf.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $bE8ha.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $6dae9d95bf10974c$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $f3e0375b84877586$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $fOolf.fill)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($f3e0375b84877586$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $6dae9d95bf10974c$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $bE8ha.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $f3e0375b84877586$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $6dae9d95bf10974c$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $bE8ha.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, $fOolf.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $f3e0375b84877586$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $f3e0375b84877586$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}



var $lHnfk = parcelRequire("lHnfk");
var $1ATua = parcelRequire("1ATua");
var $2Pa11 = parcelRequire("2Pa11");



/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $bee2b9bb0a3aad8c$export$1baa7880e357371c = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)((options = {})=>{
    const lifecycle = options.lifecycle ?? 'route';
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $82fc00877a9e6d47$export$16a28057038b10ef) && (0, $1ATua.debug).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $lHnfk.startSession)({
                ignoreDuration: true
            });
            (0, $lHnfk.captureSession)();
            // User data can be set at any time, for example async after Sentry.init has run and the initial session
            // envelope was already sent, but still on the initial page.
            // Therefore, we have to update the ongoing session with the new user data if it exists, to send the `did`.
            // In theory, sessions, as well as user data is always put onto the isolation scope. So we listen to the
            // isolation scope for changes and update the session with the new user data if it exists.
            // This will not catch users set onto other scopes, like the current scope. For now, we'll accept this limitation.
            // The alternative is to update and capture the session from within the scope. This could be too costly or would not
            // play well with session aggregates on the server side. Since this happens in the scope class, we'd need change
            // scope behaviour in the browser.
            const isolationScope = (0, $2Pa11.getIsolationScope)();
            let previousUser = isolationScope.getUser();
            isolationScope.addScopeListener((scope)=>{
                const maybeNewUser = scope.getUser();
                // sessions only care about user id and ip address, so we only need to capture the session if the user has changed
                if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
                    // the scope class already writes the user to its session, so we only need to capture the session here
                    (0, $lHnfk.captureSession)();
                    previousUser = maybeNewUser;
                }
            });
            if (lifecycle === 'route') // We want to create a session for every navigation as well
            (0, $b7c237754c377b53$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== to) {
                    (0, $lHnfk.startSession)({
                        ignoreDuration: true
                    });
                    (0, $lHnfk.captureSession)();
                }
            });
        }
    };
});




const $30560531ada7a547$var$INTEGRATION_NAME = 'CultureContext';
const $30560531ada7a547$var$_cultureContextIntegration = ()=>{
    return {
        name: $30560531ada7a547$var$INTEGRATION_NAME,
        preprocessEvent (event) {
            const culture = $30560531ada7a547$var$getCultureContext();
            if (culture) event.contexts = {
                ...event.contexts,
                culture: {
                    ...culture,
                    ...event.contexts?.culture
                }
            };
        }
    };
};
/**
 * Captures culture context from the browser.
 *
 * Enabled by default.
 *
 * @example
 * ```js
 * import * as Sentry from '@sentry/browser';
 *
 * Sentry.init({
 *   integrations: [Sentry.cultureContextIntegration()],
 * });
 * ```
 */ const $30560531ada7a547$export$ec5976aacdc85985 = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)($30560531ada7a547$var$_cultureContextIntegration);
/**
 * Returns the culture context from the browser's Intl API.
 */ function $30560531ada7a547$var$getCultureContext() {
    try {
        const intl = (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).Intl;
        if (!intl) return undefined;
        const options = intl.DateTimeFormat().resolvedOptions();
        return {
            locale: options.locale,
            timezone: options.timeZone,
            calendar: options.calendar
        };
    } catch  {
        // Ignore errors
        return undefined;
    }
}



var $gKrW9 = parcelRequire("gKrW9");

let $9d49d8b68b90dbbe$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $9d49d8b68b90dbbe$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $0d026b2963ae70d7$export$a4e09611e30da72e)(type, handler);
    (0, $0d026b2963ae70d7$export$e18d6c5462c01368)(type, $9d49d8b68b90dbbe$var$instrumentError);
}
function $9d49d8b68b90dbbe$var$instrumentError() {
    $9d49d8b68b90dbbe$var$_oldOnErrorHandler = (0, $gKrW9.GLOBAL_OBJ).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $gKrW9.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $0d026b2963ae70d7$export$b18c893e424d3127)('error', handlerData);
        if ($9d49d8b68b90dbbe$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $9d49d8b68b90dbbe$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $gKrW9.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}


var $gKrW9 = parcelRequire("gKrW9");

let $34e92caad24b01a8$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $34e92caad24b01a8$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $0d026b2963ae70d7$export$a4e09611e30da72e)(type, handler);
    (0, $0d026b2963ae70d7$export$e18d6c5462c01368)(type, $34e92caad24b01a8$var$instrumentUnhandledRejection);
}
function $34e92caad24b01a8$var$instrumentUnhandledRejection() {
    $34e92caad24b01a8$var$_oldOnUnhandledRejectionHandler = (0, $gKrW9.GLOBAL_OBJ).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $gKrW9.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $0d026b2963ae70d7$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($34e92caad24b01a8$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $34e92caad24b01a8$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $gKrW9.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


var $lHnfk = parcelRequire("lHnfk");
var $1ATua = parcelRequire("1ATua");
var $2Pa11 = parcelRequire("2Pa11");
var $konzj = parcelRequire("konzj");
var $gWidS = parcelRequire("gWidS");
var $bE8ha = parcelRequire("bE8ha");



const $9620e2fd37d2a2bf$var$INTEGRATION_NAME = 'GlobalHandlers';
const $9620e2fd37d2a2bf$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $9620e2fd37d2a2bf$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $9620e2fd37d2a2bf$var$_installGlobalOnErrorHandler(client);
                $9620e2fd37d2a2bf$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $9620e2fd37d2a2bf$var$_installGlobalOnUnhandledRejectionHandler(client);
                $9620e2fd37d2a2bf$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $9620e2fd37d2a2bf$export$66acc70e8cf2b71a = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)($9620e2fd37d2a2bf$var$_globalHandlersIntegration);
function $9620e2fd37d2a2bf$var$_installGlobalOnErrorHandler(client) {
    (0, $9d49d8b68b90dbbe$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9620e2fd37d2a2bf$var$getOptions();
        if ((0, $2Pa11.getClient)() !== client || (0, $6dae9d95bf10974c$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $9620e2fd37d2a2bf$var$_enhanceEventWithInitialFrame((0, $071c3f82346abcc5$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $lHnfk.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function $9620e2fd37d2a2bf$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $34e92caad24b01a8$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $9620e2fd37d2a2bf$var$getOptions();
        if ((0, $2Pa11.getClient)() !== client || (0, $6dae9d95bf10974c$export$b79738ab10c590b2)()) return;
        const error = $9620e2fd37d2a2bf$export$b2cc40fa8241780(e);
        const event = (0, $gWidS.isPrimitive)(error) ? $9620e2fd37d2a2bf$export$1353b5b36844a9ed(error) : (0, $071c3f82346abcc5$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $lHnfk.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
/**
 *
 */ function $9620e2fd37d2a2bf$export$b2cc40fa8241780(error) {
    if ((0, $gWidS.isPrimitive)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $9620e2fd37d2a2bf$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $9620e2fd37d2a2bf$var$_enhanceEventWithInitialFrame(event, url, lineno, colno) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        lineno: lineno,
        filename: $9620e2fd37d2a2bf$var$getFilenameFromUrl(url) ?? (0, $konzj.getLocationHref)(),
        function: (0, $bE8ha.UNKNOWN_FUNCTION),
        in_app: true
    });
    return event;
}
function $9620e2fd37d2a2bf$var$globalHandlerLog(type) {
    (0, $82fc00877a9e6d47$export$16a28057038b10ef) && (0, $1ATua.debug).log(`Global Handler attached: ${type}`);
}
function $9620e2fd37d2a2bf$var$getOptions() {
    const client = (0, $2Pa11.getClient)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $9620e2fd37d2a2bf$var$getFilenameFromUrl(url) {
    if (!(0, $gWidS.isString)(url) || url.length === 0) return undefined;
    // Strip data URL content to avoid long base64 strings in stack frames
    // (e.g. when initializing a Worker with a base64 encoded script)
    // Don't include data prefix for filenames as it's not useful for stack traces
    // Wrap with < > to indicate it's a placeholder
    if (url.startsWith('data:')) return `<${(0, $aa6227c531197232$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $3defe6f9a20111b0$export$1378794447170364 = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).navigator && !(0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).location && !(0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $6dae9d95bf10974c$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});



var $gWidS = parcelRequire("gWidS");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $e253b2225b1ae9e1$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $gWidS.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $e253b2225b1ae9e1$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $e253b2225b1ae9e1$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $gWidS.isInstanceOf)(error[key], Error)) {
        $e253b2225b1ae9e1$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $e253b2225b1ae9e1$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $e253b2225b1ae9e1$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if ($e253b2225b1ae9e1$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $gWidS.isInstanceOf)(childError, Error)) {
            $e253b2225b1ae9e1$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $e253b2225b1ae9e1$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $e253b2225b1ae9e1$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $e253b2225b1ae9e1$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $e253b2225b1ae9e1$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: 'auto.core.linked_errors',
        ...$e253b2225b1ae9e1$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $e253b2225b1ae9e1$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $0ab4815eddaf54b1$var$DEFAULT_KEY = 'cause';
const $0ab4815eddaf54b1$var$DEFAULT_LIMIT = 5;
const $0ab4815eddaf54b1$var$INTEGRATION_NAME = 'LinkedErrors';
const $0ab4815eddaf54b1$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $0ab4815eddaf54b1$var$DEFAULT_LIMIT;
    const key = options.key || $0ab4815eddaf54b1$var$DEFAULT_KEY;
    return {
        name: $0ab4815eddaf54b1$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $e253b2225b1ae9e1$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $071c3f82346abcc5$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $0ab4815eddaf54b1$export$ebabb00eb7f3a395 = (0, $a8fcea8fa590fcc8$export$2323046b9414659f)($0ab4815eddaf54b1$var$_linkedErrorsIntegration);




var $bE8ha = parcelRequire("bE8ha");
const $2d0109866f521c95$var$OPERA10_PRIORITY = 10;
const $2d0109866f521c95$var$OPERA11_PRIORITY = 20;
const $2d0109866f521c95$var$CHROME_PRIORITY = 30;
const $2d0109866f521c95$var$WINJS_PRIORITY = 40;
const $2d0109866f521c95$var$GECKO_PRIORITY = 50;
function $2d0109866f521c95$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $bE8ha.UNKNOWN_FUNCTION) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $2d0109866f521c95$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $2d0109866f521c95$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $2d0109866f521c95$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $2d0109866f521c95$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $2d0109866f521c95$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($2d0109866f521c95$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $2d0109866f521c95$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $2d0109866f521c95$var$createFrame(filename, (0, $bE8ha.UNKNOWN_FUNCTION), +line, +col);
    }
    const parts = $2d0109866f521c95$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2]?.indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $2d0109866f521c95$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $2d0109866f521c95$var$extractSafariExtensionDetails(parts[1] || (0, $bE8ha.UNKNOWN_FUNCTION), parts[2]);
        return $2d0109866f521c95$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $2d0109866f521c95$export$263a749fff749872 = [
    $2d0109866f521c95$var$CHROME_PRIORITY,
    $2d0109866f521c95$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $2d0109866f521c95$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $2d0109866f521c95$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $2d0109866f521c95$var$gecko = (line)=>{
    const parts = $2d0109866f521c95$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $2d0109866f521c95$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $bE8ha.UNKNOWN_FUNCTION);
        [func, filename] = $2d0109866f521c95$var$extractSafariExtensionDetails(func, filename);
        return $2d0109866f521c95$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $2d0109866f521c95$export$cdba47a5dd2804d = [
    $2d0109866f521c95$var$GECKO_PRIORITY,
    $2d0109866f521c95$var$gecko
];
const $2d0109866f521c95$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $2d0109866f521c95$var$winjs = (line)=>{
    const parts = $2d0109866f521c95$var$winjsRegex.exec(line);
    return parts ? $2d0109866f521c95$var$createFrame(parts[2], parts[1] || (0, $bE8ha.UNKNOWN_FUNCTION), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $2d0109866f521c95$export$179460296da408e8 = [
    $2d0109866f521c95$var$WINJS_PRIORITY,
    $2d0109866f521c95$var$winjs
];
const $2d0109866f521c95$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $2d0109866f521c95$var$opera10 = (line)=>{
    const parts = $2d0109866f521c95$var$opera10Regex.exec(line);
    return parts ? $2d0109866f521c95$var$createFrame(parts[2], parts[3] || (0, $bE8ha.UNKNOWN_FUNCTION), +parts[1]) : undefined;
};
const $2d0109866f521c95$export$f892b52c880ffc7a = [
    $2d0109866f521c95$var$OPERA10_PRIORITY,
    $2d0109866f521c95$var$opera10
];
const $2d0109866f521c95$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $2d0109866f521c95$var$opera11 = (line)=>{
    const parts = $2d0109866f521c95$var$opera11Regex.exec(line);
    return parts ? $2d0109866f521c95$var$createFrame(parts[5], parts[3] || parts[4] || (0, $bE8ha.UNKNOWN_FUNCTION), +parts[1], +parts[2]) : undefined;
};
const $2d0109866f521c95$export$af11af13f09fb0dc = [
    $2d0109866f521c95$var$OPERA11_PRIORITY,
    $2d0109866f521c95$var$opera11
];
const $2d0109866f521c95$export$7197c0fe6554c079 = [
    $2d0109866f521c95$export$263a749fff749872,
    $2d0109866f521c95$export$cdba47a5dd2804d
];
const $2d0109866f521c95$export$2b2b997d81bf3907 = (0, $bE8ha.createStackParser)(...$2d0109866f521c95$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $2d0109866f521c95$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $bE8ha.UNKNOWN_FUNCTION),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




var $1ATua = parcelRequire("1ATua");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $d9f524950a7ece40$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $120597bca0cf2ff3$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $120597bca0cf2ff3$export$e464f4a514ac28a8(name) {
    const cached = $120597bca0cf2ff3$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $af7355079bb90fc7$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $e7db6037daffc460$export$d5f608b368e73f38)(impl)) return $120597bca0cf2ff3$var$cachedImplementations[name] = impl.bind((0, $af7355079bb90fc7$export$56d8a8a25bd48b81));
    const document = (0, $af7355079bb90fc7$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $d9f524950a7ece40$export$16a28057038b10ef) && (0, $1ATua.debug).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $120597bca0cf2ff3$var$cachedImplementations[name] = impl.bind((0, $af7355079bb90fc7$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $120597bca0cf2ff3$export$8aa36702e8c8978(name) {
    $120597bca0cf2ff3$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $120597bca0cf2ff3$export$e7aa7bc5c1b3cfb3(...rest) {
    return $120597bca0cf2ff3$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $120597bca0cf2ff3$export$831dc9f2ab0a617b(...rest) {
    return $120597bca0cf2ff3$export$e464f4a514ac28a8('setTimeout')(...rest);
}


const $c7651d7a8cc0b48d$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $c7651d7a8cc0b48d$export$b2311068c46d7cc8(options, nativeFetch = (0, $120597bca0cf2ff3$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            // Note: We do not need to suppress tracing here, because we are using the native fetch, instead of our wrapped one.
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After')
                }
            };
        } catch (e) {
            (0, $120597bca0cf2ff3$export$8aa36702e8c8978)('fetch');
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $eb8ebfd2c6d05621$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $704e8b3ce2124605$export$85a4f67f852183e6)(options.bufferSize || $c7651d7a8cc0b48d$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}



var $1ATua = parcelRequire("1ATua");
var $konzj = parcelRequire("konzj");


/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $850d766fb0c929df$export$dc236a86065879fc() {
    if ($850d766fb0c929df$var$_isEmbeddedBrowserExtension()) {
        if (0, $82fc00877a9e6d47$export$16a28057038b10ef) (0, $1ATua.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $850d766fb0c929df$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $konzj.getLocationHref)();
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81) === (0, $6dae9d95bf10974c$export$56d8a8a25bd48b81).top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $d8088e4871d4eafb$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $7a12bd42514a67de$export$cb3c5c2ceb9818ba)(),
        (0, $35b7f33c5ff3b983$export$7918117e9202e4fb)(),
        (0, $16cfa9df699f9a64$export$97457a453081a5b3)(),
        (0, $f3e0375b84877586$export$59bfe9f1c76150e)(),
        (0, $0c92771e42004ee7$export$c079d904b326663a)(),
        (0, $9620e2fd37d2a2bf$export$66acc70e8cf2b71a)(),
        (0, $0ab4815eddaf54b1$export$ebabb00eb7f3a395)(),
        (0, $65e42714649a8e9c$export$6d39aa44cd0c7567)(),
        (0, $3defe6f9a20111b0$export$1378794447170364)(),
        (0, $30560531ada7a547$export$ec5976aacdc85985)(),
        (0, $bee2b9bb0a3aad8c$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $d8088e4871d4eafb$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $850d766fb0c929df$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $d8088e4871d4eafb$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $bE8ha.stackParserFromStackParserOptions)(options.stackParser || (0, $2d0109866f521c95$export$2b2b997d81bf3907)),
        integrations: (0, $a8fcea8fa590fcc8$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $c7651d7a8cc0b48d$export$b2311068c46d7cc8)
    };
    return (0, $7a3d5d890048aa50$export$5333c3f1c58d9bc1)((0, $77776fecbac44e2f$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $d8088e4871d4eafb$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $d8088e4871d4eafb$export$4e4d8b287d028b6b(callback) {
    callback();
}


var $lHnfk = parcelRequire("lHnfk");
// Production: Use pre-compiled Elm JS (built by npm run build:elm-precompile)
var $b601112f62ed8cc8$var$_s = {};
(function(scope) {
    'use strict';
    function F(arity, fun, wrapper) {
        wrapper.a = arity;
        wrapper.f = fun;
        return wrapper;
    }
    function F2(fun) {
        return F(2, fun, function(a) {
            return function(b) {
                return fun(a, b);
            };
        });
    }
    function F3(fun) {
        return F(3, fun, function(a) {
            return function(b) {
                return function(c) {
                    return fun(a, b, c);
                };
            };
        });
    }
    function F4(fun) {
        return F(4, fun, function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return fun(a, b, c, d);
                    };
                };
            };
        });
    }
    function F5(fun) {
        return F(5, fun, function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return fun(a, b, c, d, e);
                        };
                    };
                };
            };
        });
    }
    function F6(fun) {
        return F(6, fun, function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return function(f) {
                                return fun(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(fun) {
        return F(7, fun, function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return function(f) {
                                return function(g) {
                                    return fun(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F8(fun) {
        return F(8, fun, function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return function(f) {
                                return function(g) {
                                    return function(h) {
                                        return fun(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function F9(fun) {
        return F(9, fun, function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return function(f) {
                                return function(g) {
                                    return function(h) {
                                        return function(i) {
                                            return fun(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(fun, a, b) {
        return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
    }
    function A3(fun, a, b, c) {
        return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
    }
    function A4(fun, a, b, c, d) {
        return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
    }
    function A5(fun, a, b, c, d, e) {
        return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
    }
    function A6(fun, a, b, c, d, e, f) {
        return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
    }
    function A7(fun, a, b, c, d, e, f, g) {
        return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
    }
    function A8(fun, a, b, c, d, e, f, g, h) {
        return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
    }
    function A9(fun, a, b, c, d, e, f, g, h, i) {
        return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
    }
    var _JsArray_empty = [];
    function _JsArray_singleton(value) {
        return [
            value
        ];
    }
    function _JsArray_length(array) {
        return array.length;
    }
    var _JsArray_initialize = F3(function(size, offset, func) {
        var result = new Array(size);
        for(var i = 0; i < size; i++)result[i] = func(offset + i);
        return result;
    });
    var _JsArray_initializeFromList = F2(function(max, ls) {
        var result = new Array(max);
        for(var i = 0; i < max && ls.b; i++){
            result[i] = ls.a;
            ls = ls.b;
        }
        result.length = i;
        return _Utils_Tuple2(result, ls);
    });
    var _JsArray_unsafeGet = F2(function(index, array) {
        return array[index];
    });
    var _JsArray_unsafeSet = F3(function(index, value, array) {
        var length = array.length;
        var result = new Array(length);
        for(var i = 0; i < length; i++)result[i] = array[i];
        result[index] = value;
        return result;
    });
    var _JsArray_push = F2(function(value, array) {
        var length = array.length;
        var result = new Array(length + 1);
        for(var i = 0; i < length; i++)result[i] = array[i];
        result[length] = value;
        return result;
    });
    var _JsArray_foldl = F3(function(func, acc, array) {
        var length = array.length;
        for(var i = 0; i < length; i++)acc = A2(func, array[i], acc);
        return acc;
    });
    var _JsArray_foldr = F3(function(func, acc, array) {
        for(var i = array.length - 1; i >= 0; i--)acc = A2(func, array[i], acc);
        return acc;
    });
    var _JsArray_map = F2(function(func, array) {
        var length = array.length;
        var result = new Array(length);
        for(var i = 0; i < length; i++)result[i] = func(array[i]);
        return result;
    });
    var _JsArray_indexedMap = F3(function(func, offset, array) {
        var length = array.length;
        var result = new Array(length);
        for(var i = 0; i < length; i++)result[i] = A2(func, offset + i, array[i]);
        return result;
    });
    var _JsArray_slice = F3(function(from, to, array) {
        return array.slice(from, to);
    });
    var _JsArray_appendN = F3(function(n, dest, source) {
        var destLen = dest.length;
        var itemsToCopy = n - destLen;
        if (itemsToCopy > source.length) itemsToCopy = source.length;
        var size = destLen + itemsToCopy;
        var result = new Array(size);
        for(var i = 0; i < destLen; i++)result[i] = dest[i];
        for(var i = 0; i < itemsToCopy; i++)result[i + destLen] = source[i];
        return result;
    });
    // LOG
    var _Debug_log = F2(function(tag, value) {
        return value;
    });
    var _Debug_log_UNUSED = F2(function(tag, value) {
        console.log(tag + ': ' + _Debug_toString(value));
        return value;
    });
    // TODOS
    function _Debug_todo(moduleName, region) {
        return function(message) {
            _Debug_crash(8, moduleName, region, message);
        };
    }
    function _Debug_todoCase(moduleName, region, value) {
        return function(message) {
            _Debug_crash(9, moduleName, region, value, message);
        };
    }
    // TO STRING
    function _Debug_toString(value) {
        return '<internals>';
    }
    function _Debug_toString_UNUSED(value) {
        return _Debug_toAnsiString(false, value);
    }
    function _Debug_toAnsiString(ansi, value) {
        if (typeof value === 'function') return _Debug_internalColor(ansi, '<function>');
        if (typeof value === 'boolean') return _Debug_ctorColor(ansi, value ? 'True' : 'False');
        if (typeof value === 'number') return _Debug_numberColor(ansi, value + '');
        if (value instanceof String) return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
        if (typeof value === 'string') return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
        if (typeof value === 'object' && '$' in value) {
            var tag = value.$;
            if (typeof tag === 'number') return _Debug_internalColor(ansi, '<internals>');
            if (tag[0] === '#') {
                var output = [];
                for(var k in value){
                    if (k === '$') continue;
                    output.push(_Debug_toAnsiString(ansi, value[k]));
                }
                return '(' + output.join(',') + ')';
            }
            if (tag === 'Set_elm_builtin') return _Debug_ctorColor(ansi, 'Set') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
            if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin') return _Debug_ctorColor(ansi, 'Dict') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
            if (tag === 'Array_elm_builtin') return _Debug_ctorColor(ansi, 'Array') + _Debug_fadeColor(ansi, '.fromList') + ' ' + _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
            if (tag === '::' || tag === '[]') {
                var output = '[';
                value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b);
                for(; value.b; value = value.b)output += ',' + _Debug_toAnsiString(ansi, value.a);
                return output + ']';
            }
            var output = '';
            for(var i in value){
                if (i === '$') continue;
                var str = _Debug_toAnsiString(ansi, value[i]);
                var c0 = str[0];
                var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
                output += ' ' + (parenless ? str : '(' + str + ')');
            }
            return _Debug_ctorColor(ansi, tag) + output;
        }
        if (typeof DataView === 'function' && value instanceof DataView) return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
        if (typeof File !== 'undefined' && value instanceof File) return _Debug_internalColor(ansi, '<' + value.name + '>');
        if (typeof value === 'object') {
            var output = [];
            for(var key in value){
                var field = key[0] === '_' ? key.slice(1) : key;
                output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
            }
            if (output.length === 0) return '{}';
            return '{ ' + output.join(', ') + ' }';
        }
        return _Debug_internalColor(ansi, '<internals>');
    }
    function _Debug_addSlashes(str, isChar) {
        var s = str.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/\r/g, '\\r').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
        if (isChar) return s.replace(/\'/g, '\\\'');
        else return s.replace(/\"/g, '\\"');
    }
    function _Debug_ctorColor(ansi, string) {
        return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
    }
    function _Debug_numberColor(ansi, string) {
        return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
    }
    function _Debug_stringColor(ansi, string) {
        return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
    }
    function _Debug_charColor(ansi, string) {
        return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
    }
    function _Debug_fadeColor(ansi, string) {
        return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
    }
    function _Debug_internalColor(ansi, string) {
        return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
    }
    function _Debug_toHexDigit(n) {
        return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
    }
    // CRASH
    function _Debug_crash(identifier) {
        throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
    }
    function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4) {
        switch(identifier){
            case 0:
                throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');
            case 1:
                throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');
            case 2:
                var jsonErrorString = fact1;
                throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);
            case 3:
                var portName = fact1;
                throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');
            case 4:
                var portName = fact1;
                var problem = fact2;
                throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);
            case 5:
                throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');
            case 6:
                var moduleName = fact1;
                throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');
            case 8:
                var moduleName = fact1;
                var region = fact2;
                var message = fact3;
                throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);
            case 9:
                var moduleName = fact1;
                var region = fact2;
                var value = fact3;
                var message = fact4;
                throw new Error('TODO in module `' + moduleName + '` from the `case` expression ' + _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    ' + _Debug_toString(value).replace('\n', '\n    ') + '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    '));
            case 10:
                throw new Error('Bug in https://github.com/elm/virtual-dom/issues');
            case 11:
                throw new Error('Cannot perform mod 0. Division by zero error.');
        }
    }
    function _Debug_regionToString(region) {
        if (region.HB.rh === region.Fn.rh) return 'on line ' + region.HB.rh;
        return 'on lines ' + region.HB.rh + ' through ' + region.Fn.rh;
    }
    // EQUALITY
    function _Utils_eq(x, y) {
        for(var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack); isEqual && (pair = stack.pop()); isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack));
        return isEqual;
    }
    function _Utils_eqHelp(x, y, depth, stack) {
        if (x === y) return true;
        if (typeof x !== 'object' || x === null || y === null) {
            typeof x === 'function' && _Debug_crash(5);
            return false;
        }
        if (depth > 100) {
            stack.push(_Utils_Tuple2(x, y));
            return true;
        }
        /**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/ /**/ if (x.$ < 0) {
            x = $elm$core$Dict$toList(x);
            y = $elm$core$Dict$toList(y);
        }
        //*/
        for(var key in x){
            if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack)) return false;
        }
        return true;
    }
    var _Utils_equal = F2(_Utils_eq);
    var _Utils_notEqual = F2(function(a, b) {
        return !_Utils_eq(a, b);
    });
    // COMPARISONS
    // Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
    // the particular integer values assigned to LT, EQ, and GT.
    function _Utils_cmp(x, y, ord) {
        if (typeof x !== 'object') return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
        /**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/ /**/ if (typeof x.$ === 'undefined') return (ord = _Utils_cmp(x.a, y.a)) ? ord : (ord = _Utils_cmp(x.b, y.b)) ? ord : _Utils_cmp(x.c, y.c);
        // traverse conses until end of a list or a mismatch
        for(; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b); // WHILE_CONSES
        return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
    }
    var _Utils_lt = F2(function(a, b) {
        return _Utils_cmp(a, b) < 0;
    });
    var _Utils_le = F2(function(a, b) {
        return _Utils_cmp(a, b) < 1;
    });
    var _Utils_gt = F2(function(a, b) {
        return _Utils_cmp(a, b) > 0;
    });
    var _Utils_ge = F2(function(a, b) {
        return _Utils_cmp(a, b) >= 0;
    });
    var _Utils_compare = F2(function(x, y) {
        var n = _Utils_cmp(x, y);
        return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
    });
    // COMMON VALUES
    var _Utils_Tuple0 = 0;
    var _Utils_Tuple0_UNUSED = {
        $: '#0'
    };
    function _Utils_Tuple2(a, b) {
        return {
            a: a,
            b: b
        };
    }
    function _Utils_Tuple2_UNUSED(a, b) {
        return {
            $: '#2',
            a: a,
            b: b
        };
    }
    function _Utils_Tuple3(a, b, c) {
        return {
            a: a,
            b: b,
            c: c
        };
    }
    function _Utils_Tuple3_UNUSED(a, b, c) {
        return {
            $: '#3',
            a: a,
            b: b,
            c: c
        };
    }
    function _Utils_chr(c) {
        return c;
    }
    function _Utils_chr_UNUSED(c) {
        return new String(c);
    }
    // RECORDS
    function _Utils_update(oldRecord, updatedFields) {
        var newRecord = {};
        for(var key in oldRecord)newRecord[key] = oldRecord[key];
        for(var key in updatedFields)newRecord[key] = updatedFields[key];
        return newRecord;
    }
    // APPEND
    var _Utils_append = F2(_Utils_ap);
    function _Utils_ap(xs, ys) {
        // append Strings
        if (typeof xs === 'string') return xs + ys;
        // append Lists
        if (!xs.b) return ys;
        var root = _List_Cons(xs.a, ys);
        xs = xs.b;
        for(var curr = root; xs.b; xs = xs.b)curr = curr.b = _List_Cons(xs.a, ys);
        return root;
    }
    var _List_Nil = {
        $: 0
    };
    var _List_Nil_UNUSED = {
        $: '[]'
    };
    function _List_Cons(hd, tl) {
        return {
            $: 1,
            a: hd,
            b: tl
        };
    }
    function _List_Cons_UNUSED(hd, tl) {
        return {
            $: '::',
            a: hd,
            b: tl
        };
    }
    var _List_cons = F2(_List_Cons);
    function _List_fromArray(arr) {
        var out = _List_Nil;
        for(var i = arr.length; i--;)out = _List_Cons(arr[i], out);
        return out;
    }
    function _List_toArray(xs) {
        for(var out = []; xs.b; xs = xs.b)out.push(xs.a);
        return out;
    }
    var _List_map2 = F3(function(f, xs, ys) {
        for(var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b)arr.push(A2(f, xs.a, ys.a));
        return _List_fromArray(arr);
    });
    var _List_map3 = F4(function(f, xs, ys, zs) {
        for(var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b)arr.push(A3(f, xs.a, ys.a, zs.a));
        return _List_fromArray(arr);
    });
    var _List_map4 = F5(function(f, ws, xs, ys, zs) {
        for(var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b)arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
        return _List_fromArray(arr);
    });
    var _List_map5 = F6(function(f, vs, ws, xs, ys, zs) {
        for(var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b)arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
        return _List_fromArray(arr);
    });
    var _List_sortBy = F2(function(f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
            return _Utils_cmp(f(a), f(b));
        }));
    });
    var _List_sortWith = F2(function(f, xs) {
        return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
            var ord = A2(f, a, b);
            return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
        }));
    });
    // MATH
    var _Basics_add = F2(function(a, b) {
        return a + b;
    });
    var _Basics_sub = F2(function(a, b) {
        return a - b;
    });
    var _Basics_mul = F2(function(a, b) {
        return a * b;
    });
    var _Basics_fdiv = F2(function(a, b) {
        return a / b;
    });
    var _Basics_idiv = F2(function(a, b) {
        return a / b | 0;
    });
    var _Basics_pow = F2(Math.pow);
    var _Basics_remainderBy = F2(function(b, a) {
        return a % b;
    });
    // https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
    var _Basics_modBy = F2(function(modulus, x) {
        var answer = x % modulus;
        return modulus === 0 ? _Debug_crash(11) : answer > 0 && modulus < 0 || answer < 0 && modulus > 0 ? answer + modulus : answer;
    });
    // TRIGONOMETRY
    var _Basics_pi = Math.PI;
    var _Basics_e = Math.E;
    var _Basics_cos = Math.cos;
    var _Basics_sin = Math.sin;
    var _Basics_tan = Math.tan;
    var _Basics_acos = Math.acos;
    var _Basics_asin = Math.asin;
    var _Basics_atan = Math.atan;
    var _Basics_atan2 = F2(Math.atan2);
    // MORE MATH
    function _Basics_toFloat(x) {
        return x;
    }
    function _Basics_truncate(n) {
        return n | 0;
    }
    function _Basics_isInfinite(n) {
        return n === Infinity || n === -Infinity;
    }
    var _Basics_ceiling = Math.ceil;
    var _Basics_floor = Math.floor;
    var _Basics_round = Math.round;
    var _Basics_sqrt = Math.sqrt;
    var _Basics_log = Math.log;
    var _Basics_isNaN = isNaN;
    // BOOLEANS
    function _Basics_not(bool) {
        return !bool;
    }
    var _Basics_and = F2(function(a, b) {
        return a && b;
    });
    var _Basics_or = F2(function(a, b) {
        return a || b;
    });
    var _Basics_xor = F2(function(a, b) {
        return a !== b;
    });
    var _String_cons = F2(function(chr, str) {
        return chr + str;
    });
    function _String_uncons(string) {
        var word = string.charCodeAt(0);
        return !isNaN(word) ? $elm$core$Maybe$Just(0xD800 <= word && word <= 0xDBFF ? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2)) : _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))) : $elm$core$Maybe$Nothing;
    }
    var _String_append = F2(function(a, b) {
        return a + b;
    });
    function _String_length(str) {
        return str.length;
    }
    var _String_map = F2(function(func, string) {
        var len = string.length;
        var array = new Array(len);
        var i = 0;
        while(i < len){
            var word = string.charCodeAt(i);
            if (0xD800 <= word && word <= 0xDBFF) {
                array[i] = func(_Utils_chr(string[i] + string[i + 1]));
                i += 2;
                continue;
            }
            array[i] = func(_Utils_chr(string[i]));
            i++;
        }
        return array.join('');
    });
    var _String_filter = F2(function(isGood, str) {
        var arr = [];
        var len = str.length;
        var i = 0;
        while(i < len){
            var char = str[i];
            var word = str.charCodeAt(i);
            i++;
            if (0xD800 <= word && word <= 0xDBFF) {
                char += str[i];
                i++;
            }
            if (isGood(_Utils_chr(char))) arr.push(char);
        }
        return arr.join('');
    });
    function _String_reverse(str) {
        var len = str.length;
        var arr = new Array(len);
        var i = 0;
        while(i < len){
            var word = str.charCodeAt(i);
            if (0xD800 <= word && word <= 0xDBFF) {
                arr[len - i] = str[i + 1];
                i++;
                arr[len - i] = str[i - 1];
                i++;
            } else {
                arr[len - i] = str[i];
                i++;
            }
        }
        return arr.join('');
    }
    var _String_foldl = F3(function(func, state, string) {
        var len = string.length;
        var i = 0;
        while(i < len){
            var char = string[i];
            var word = string.charCodeAt(i);
            i++;
            if (0xD800 <= word && word <= 0xDBFF) {
                char += string[i];
                i++;
            }
            state = A2(func, _Utils_chr(char), state);
        }
        return state;
    });
    var _String_foldr = F3(function(func, state, string) {
        var i = string.length;
        while(i--){
            var char = string[i];
            var word = string.charCodeAt(i);
            if (0xDC00 <= word && word <= 0xDFFF) {
                i--;
                char = string[i] + char;
            }
            state = A2(func, _Utils_chr(char), state);
        }
        return state;
    });
    var _String_split = F2(function(sep, str) {
        return str.split(sep);
    });
    var _String_join = F2(function(sep, strs) {
        return strs.join(sep);
    });
    var _String_slice = F3(function(start, end, str) {
        return str.slice(start, end);
    });
    function _String_trim(str) {
        return str.trim();
    }
    function _String_trimLeft(str) {
        return str.replace(/^\s+/, '');
    }
    function _String_trimRight(str) {
        return str.replace(/\s+$/, '');
    }
    function _String_words(str) {
        return _List_fromArray(str.trim().split(/\s+/g));
    }
    function _String_lines(str) {
        return _List_fromArray(str.split(/\r\n|\r|\n/g));
    }
    function _String_toUpper(str) {
        return str.toUpperCase();
    }
    function _String_toLower(str) {
        return str.toLowerCase();
    }
    var _String_any = F2(function(isGood, string) {
        var i = string.length;
        while(i--){
            var char = string[i];
            var word = string.charCodeAt(i);
            if (0xDC00 <= word && word <= 0xDFFF) {
                i--;
                char = string[i] + char;
            }
            if (isGood(_Utils_chr(char))) return true;
        }
        return false;
    });
    var _String_all = F2(function(isGood, string) {
        var i = string.length;
        while(i--){
            var char = string[i];
            var word = string.charCodeAt(i);
            if (0xDC00 <= word && word <= 0xDFFF) {
                i--;
                char = string[i] + char;
            }
            if (!isGood(_Utils_chr(char))) return false;
        }
        return true;
    });
    var _String_contains = F2(function(sub, str) {
        return str.indexOf(sub) > -1;
    });
    var _String_startsWith = F2(function(sub, str) {
        return str.indexOf(sub) === 0;
    });
    var _String_endsWith = F2(function(sub, str) {
        return str.length >= sub.length && str.lastIndexOf(sub) === str.length - sub.length;
    });
    var _String_indexes = F2(function(sub, str) {
        var subLen = sub.length;
        if (subLen < 1) return _List_Nil;
        var i = 0;
        var is = [];
        while((i = str.indexOf(sub, i)) > -1){
            is.push(i);
            i = i + subLen;
        }
        return _List_fromArray(is);
    });
    // TO STRING
    function _String_fromNumber(number) {
        return number + '';
    }
    // INT CONVERSIONS
    function _String_toInt(str) {
        var total = 0;
        var code0 = str.charCodeAt(0);
        var start = code0 == 0x2B /* + */  || code0 == 0x2D /* - */  ? 1 : 0;
        for(var i = start; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x30 || 0x39 < code) return $elm$core$Maybe$Nothing;
            total = 10 * total + code - 0x30;
        }
        return i == start ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
    }
    // FLOAT CONVERSIONS
    function _String_toFloat(s) {
        // check if it is a hex, octal, or binary number
        if (s.length === 0 || /[\sxbo]/.test(s)) return $elm$core$Maybe$Nothing;
        var n = +s;
        // faster isNaN check
        return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
    }
    function _String_fromList(chars) {
        return _List_toArray(chars).join('');
    }
    function _Char_toCode(char) {
        var code = char.charCodeAt(0);
        if (0xD800 <= code && code <= 0xDBFF) return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000;
        return code;
    }
    function _Char_fromCode(code) {
        return _Utils_chr(code < 0 || 0x10FFFF < code ? '\uFFFD' : code <= 0xFFFF ? String.fromCharCode(code) : (code -= 0x10000, String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)));
    }
    function _Char_toUpper(char) {
        return _Utils_chr(char.toUpperCase());
    }
    function _Char_toLower(char) {
        return _Utils_chr(char.toLowerCase());
    }
    function _Char_toLocaleUpper(char) {
        return _Utils_chr(char.toLocaleUpperCase());
    }
    function _Char_toLocaleLower(char) {
        return _Utils_chr(char.toLocaleLowerCase());
    }
    /**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/ // CORE DECODERS
    function _Json_succeed(msg) {
        return {
            $: 0,
            a: msg
        };
    }
    function _Json_fail(msg) {
        return {
            $: 1,
            a: msg
        };
    }
    function _Json_decodePrim(decoder) {
        return {
            $: 2,
            b: decoder
        };
    }
    var _Json_decodeInt = _Json_decodePrim(function(value) {
        return typeof value !== 'number' ? _Json_expecting('an INT', value) : -2147483647 < value && value < 2147483647 && (value | 0) === value ? $elm$core$Result$Ok(value) : isFinite(value) && !(value % 1) ? $elm$core$Result$Ok(value) : _Json_expecting('an INT', value);
    });
    var _Json_decodeBool = _Json_decodePrim(function(value) {
        return typeof value === 'boolean' ? $elm$core$Result$Ok(value) : _Json_expecting('a BOOL', value);
    });
    var _Json_decodeFloat = _Json_decodePrim(function(value) {
        return typeof value === 'number' ? $elm$core$Result$Ok(value) : _Json_expecting('a FLOAT', value);
    });
    var _Json_decodeValue = _Json_decodePrim(function(value) {
        return $elm$core$Result$Ok(_Json_wrap(value));
    });
    var _Json_decodeString = _Json_decodePrim(function(value) {
        return typeof value === 'string' ? $elm$core$Result$Ok(value) : value instanceof String ? $elm$core$Result$Ok(value + '') : _Json_expecting('a STRING', value);
    });
    function _Json_decodeList(decoder) {
        return {
            $: 3,
            b: decoder
        };
    }
    function _Json_decodeArray(decoder) {
        return {
            $: 4,
            b: decoder
        };
    }
    function _Json_decodeNull(value) {
        return {
            $: 5,
            c: value
        };
    }
    var _Json_decodeField = F2(function(field, decoder) {
        return {
            $: 6,
            d: field,
            b: decoder
        };
    });
    var _Json_decodeIndex = F2(function(index, decoder) {
        return {
            $: 7,
            e: index,
            b: decoder
        };
    });
    function _Json_decodeKeyValuePairs(decoder) {
        return {
            $: 8,
            b: decoder
        };
    }
    function _Json_mapMany(f, decoders) {
        return {
            $: 9,
            f: f,
            g: decoders
        };
    }
    var _Json_andThen = F2(function(callback, decoder) {
        return {
            $: 10,
            b: decoder,
            h: callback
        };
    });
    function _Json_oneOf(decoders) {
        return {
            $: 11,
            g: decoders
        };
    }
    // DECODING OBJECTS
    var _Json_map1 = F2(function(f, d1) {
        return _Json_mapMany(f, [
            d1
        ]);
    });
    var _Json_map2 = F3(function(f, d1, d2) {
        return _Json_mapMany(f, [
            d1,
            d2
        ]);
    });
    var _Json_map3 = F4(function(f, d1, d2, d3) {
        return _Json_mapMany(f, [
            d1,
            d2,
            d3
        ]);
    });
    var _Json_map4 = F5(function(f, d1, d2, d3, d4) {
        return _Json_mapMany(f, [
            d1,
            d2,
            d3,
            d4
        ]);
    });
    var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5) {
        return _Json_mapMany(f, [
            d1,
            d2,
            d3,
            d4,
            d5
        ]);
    });
    var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6) {
        return _Json_mapMany(f, [
            d1,
            d2,
            d3,
            d4,
            d5,
            d6
        ]);
    });
    var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7) {
        return _Json_mapMany(f, [
            d1,
            d2,
            d3,
            d4,
            d5,
            d6,
            d7
        ]);
    });
    var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8) {
        return _Json_mapMany(f, [
            d1,
            d2,
            d3,
            d4,
            d5,
            d6,
            d7,
            d8
        ]);
    });
    // DECODE
    var _Json_runOnString = F2(function(decoder, string) {
        try {
            var value = JSON.parse(string);
            return _Json_runHelp(decoder, value);
        } catch (e) {
            return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
        }
    });
    var _Json_run = F2(function(decoder, value) {
        return _Json_runHelp(decoder, _Json_unwrap(value));
    });
    function _Json_runHelp(decoder, value) {
        switch(decoder.$){
            case 2:
                return decoder.b(value);
            case 5:
                return value === null ? $elm$core$Result$Ok(decoder.c) : _Json_expecting('null', value);
            case 3:
                if (!_Json_isArray(value)) return _Json_expecting('a LIST', value);
                return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);
            case 4:
                if (!_Json_isArray(value)) return _Json_expecting('an ARRAY', value);
                return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);
            case 6:
                var field = decoder.d;
                if (typeof value !== 'object' || value === null || !(field in value)) return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
                var result = _Json_runHelp(decoder.b, value[field]);
                return $elm$core$Result$isOk(result) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));
            case 7:
                var index = decoder.e;
                if (!_Json_isArray(value)) return _Json_expecting('an ARRAY', value);
                if (index >= value.length) return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
                var result = _Json_runHelp(decoder.b, value[index]);
                return $elm$core$Result$isOk(result) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));
            case 8:
                if (typeof value !== 'object' || value === null || _Json_isArray(value)) return _Json_expecting('an OBJECT', value);
                var keyValuePairs = _List_Nil;
                // TODO test perf of Object.keys and switch when support is good enough
                for(var key in value)if (value.hasOwnProperty(key)) {
                    var result = _Json_runHelp(decoder.b, value[key]);
                    if (!$elm$core$Result$isOk(result)) return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
                    keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
                }
                return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));
            case 9:
                var answer = decoder.f;
                var decoders = decoder.g;
                for(var i = 0; i < decoders.length; i++){
                    var result = _Json_runHelp(decoders[i], value);
                    if (!$elm$core$Result$isOk(result)) return result;
                    answer = answer(result.a);
                }
                return $elm$core$Result$Ok(answer);
            case 10:
                var result = _Json_runHelp(decoder.b, value);
                return !$elm$core$Result$isOk(result) ? result : _Json_runHelp(decoder.h(result.a), value);
            case 11:
                var errors = _List_Nil;
                for(var temp = decoder.g; temp.b; temp = temp.b){
                    var result = _Json_runHelp(temp.a, value);
                    if ($elm$core$Result$isOk(result)) return result;
                    errors = _List_Cons(result.a, errors);
                }
                return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));
            case 1:
                return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));
            case 0:
                return $elm$core$Result$Ok(decoder.a);
        }
    }
    function _Json_runArrayDecoder(decoder, value, toElmValue) {
        var len = value.length;
        var array = new Array(len);
        for(var i = 0; i < len; i++){
            var result = _Json_runHelp(decoder, value[i]);
            if (!$elm$core$Result$isOk(result)) return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
            array[i] = result.a;
        }
        return $elm$core$Result$Ok(toElmValue(array));
    }
    function _Json_isArray(value) {
        return Array.isArray(value) || typeof FileList !== 'undefined' && value instanceof FileList;
    }
    function _Json_toElmArray(array) {
        return A2($elm$core$Array$initialize, array.length, function(i) {
            return array[i];
        });
    }
    function _Json_expecting(type, value) {
        return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
    }
    // EQUALITY
    function _Json_equality(x, y) {
        if (x === y) return true;
        if (x.$ !== y.$) return false;
        switch(x.$){
            case 0:
            case 1:
                return x.a === y.a;
            case 2:
                return x.b === y.b;
            case 5:
                return x.c === y.c;
            case 3:
            case 4:
            case 8:
                return _Json_equality(x.b, y.b);
            case 6:
                return x.d === y.d && _Json_equality(x.b, y.b);
            case 7:
                return x.e === y.e && _Json_equality(x.b, y.b);
            case 9:
                return x.f === y.f && _Json_listEquality(x.g, y.g);
            case 10:
                return x.h === y.h && _Json_equality(x.b, y.b);
            case 11:
                return _Json_listEquality(x.g, y.g);
        }
    }
    function _Json_listEquality(aDecoders, bDecoders) {
        var len = aDecoders.length;
        if (len !== bDecoders.length) return false;
        for(var i = 0; i < len; i++){
            if (!_Json_equality(aDecoders[i], bDecoders[i])) return false;
        }
        return true;
    }
    // ENCODE
    var _Json_encode = F2(function(indentLevel, value) {
        return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
    });
    function _Json_wrap_UNUSED(value) {
        return {
            $: 0,
            a: value
        };
    }
    function _Json_unwrap_UNUSED(value) {
        return value.a;
    }
    function _Json_wrap(value) {
        return value;
    }
    function _Json_unwrap(value) {
        return value;
    }
    function _Json_emptyArray() {
        return [];
    }
    function _Json_emptyObject() {
        return {};
    }
    var _Json_addField = F3(function(key, value, object) {
        object[key] = _Json_unwrap(value);
        return object;
    });
    function _Json_addEntry(func) {
        return F2(function(entry, array) {
            array.push(_Json_unwrap(func(entry)));
            return array;
        });
    }
    var _Json_encodeNull = _Json_wrap(null);
    // TASKS
    function _Scheduler_succeed(value) {
        return {
            $: 0,
            a: value
        };
    }
    function _Scheduler_fail(error) {
        return {
            $: 1,
            a: error
        };
    }
    function _Scheduler_binding(callback) {
        return {
            $: 2,
            b: callback,
            c: null
        };
    }
    var _Scheduler_andThen = F2(function(callback, task) {
        return {
            $: 3,
            b: callback,
            d: task
        };
    });
    var _Scheduler_onError = F2(function(callback, task) {
        return {
            $: 4,
            b: callback,
            d: task
        };
    });
    function _Scheduler_receive(callback) {
        return {
            $: 5,
            b: callback
        };
    }
    // PROCESSES
    var _Scheduler_guid = 0;
    function _Scheduler_rawSpawn(task) {
        var proc = {
            $: 0,
            e: _Scheduler_guid++,
            f: task,
            g: null,
            h: []
        };
        _Scheduler_enqueue(proc);
        return proc;
    }
    function _Scheduler_spawn(task) {
        return _Scheduler_binding(function(callback) {
            callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
        });
    }
    function _Scheduler_rawSend(proc, msg) {
        proc.h.push(msg);
        _Scheduler_enqueue(proc);
    }
    var _Scheduler_send = F2(function(proc, msg) {
        return _Scheduler_binding(function(callback) {
            _Scheduler_rawSend(proc, msg);
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    });
    function _Scheduler_kill(proc) {
        return _Scheduler_binding(function(callback) {
            var task = proc.f;
            if (task.$ === 2 && task.c) task.c();
            proc.f = null;
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    }
    /* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/ var _Scheduler_working = false;
    var _Scheduler_queue = [];
    function _Scheduler_enqueue(proc) {
        _Scheduler_queue.push(proc);
        if (_Scheduler_working) return;
        _Scheduler_working = true;
        while(proc = _Scheduler_queue.shift())_Scheduler_step(proc);
        _Scheduler_working = false;
    }
    function _Scheduler_step(proc) {
        while(proc.f){
            var rootTag = proc.f.$;
            if (rootTag === 0 || rootTag === 1) {
                while(proc.g && proc.g.$ !== rootTag)proc.g = proc.g.i;
                if (!proc.g) return;
                proc.f = proc.g.b(proc.f.a);
                proc.g = proc.g.i;
            } else if (rootTag === 2) {
                proc.f.c = proc.f.b(function(newRoot) {
                    proc.f = newRoot;
                    _Scheduler_enqueue(proc);
                });
                return;
            } else if (rootTag === 5) {
                if (proc.h.length === 0) return;
                proc.f = proc.f.b(proc.h.shift());
            } else {
                proc.g = {
                    $: rootTag === 3 ? 0 : 1,
                    b: proc.f.b,
                    i: proc.g
                };
                proc.f = proc.f.d;
            }
        }
    }
    function _Process_sleep(time) {
        return _Scheduler_binding(function(callback) {
            var id = setTimeout(function() {
                callback(_Scheduler_succeed(_Utils_Tuple0));
            }, time);
            return function() {
                clearTimeout(id);
            };
        });
    }
    // PROGRAMS
    var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.aeq, impl.aaO, impl.ahE, function() {
            return function() {};
        });
    });
    // INITIALIZE A PROGRAM
    function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder) {
        var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
        $elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/ );
        var managers = {};
        var initPair = init(result.a);
        var model = initPair.a;
        var stepper = stepperBuilder(sendToApp, model);
        var ports = _Platform_setupEffects(managers, sendToApp);
        function sendToApp(msg, viewMetadata) {
            var pair = A2(update, msg, model);
            stepper(model = pair.a, viewMetadata);
            _Platform_enqueueEffects(managers, pair.b, subscriptions(model));
        }
        _Platform_enqueueEffects(managers, initPair.b, subscriptions(model));
        return ports ? {
            ports: ports
        } : {};
    }
    // TRACK PRELOADS
    //
    // This is used by code in elm/browser and elm/http
    // to register any HTTP requests that are triggered by init.
    //
    var _Platform_preload;
    function _Platform_registerPreload(url) {
        _Platform_preload.add(url);
    }
    // EFFECT MANAGERS
    var _Platform_effectManagers = {};
    function _Platform_setupEffects(managers, sendToApp) {
        var ports;
        // setup all necessary effect managers
        for(var key in _Platform_effectManagers){
            var manager = _Platform_effectManagers[key];
            if (manager.a) {
                ports = ports || {};
                ports[key] = manager.a(key, sendToApp);
            }
            managers[key] = _Platform_instantiateManager(manager, sendToApp);
        }
        return ports;
    }
    function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap) {
        return {
            b: init,
            c: onEffects,
            d: onSelfMsg,
            e: cmdMap,
            f: subMap
        };
    }
    function _Platform_instantiateManager(info, sendToApp) {
        var router = {
            g: sendToApp,
            h: undefined
        };
        var onEffects = info.c;
        var onSelfMsg = info.d;
        var cmdMap = info.e;
        var subMap = info.f;
        function loop(state) {
            return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg) {
                var value = msg.a;
                if (msg.$ === 0) return A3(onSelfMsg, router, value, state);
                return cmdMap && subMap ? A4(onEffects, router, value.i, value.j, state) : A3(onEffects, router, cmdMap ? value.i : value.j, state);
            }));
        }
        return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
    }
    // ROUTING
    var _Platform_sendToApp = F2(function(router, msg) {
        return _Scheduler_binding(function(callback) {
            router.g(msg);
            callback(_Scheduler_succeed(_Utils_Tuple0));
        });
    });
    var _Platform_sendToSelf = F2(function(router, msg) {
        return A2(_Scheduler_send, router.h, {
            $: 0,
            a: msg
        });
    });
    // BAGS
    function _Platform_leaf(home) {
        return function(value) {
            return {
                $: 1,
                k: home,
                l: value
            };
        };
    }
    function _Platform_batch(list) {
        return {
            $: 2,
            m: list
        };
    }
    var _Platform_map = F2(function(tagger, bag) {
        return {
            $: 3,
            n: tagger,
            o: bag
        };
    });
    // PIPE BAGS INTO EFFECT MANAGERS
    //
    // Effects must be queued!
    //
    // Say your init contains a synchronous command, like Time.now or Time.here
    //
    //   - This will produce a batch of effects (FX_1)
    //   - The synchronous task triggers the subsequent `update` call
    //   - This will produce a batch of effects (FX_2)
    //
    // If we just start dispatching FX_2, subscriptions from FX_2 can be processed
    // before subscriptions from FX_1. No good! Earlier versions of this code had
    // this problem, leading to these reports:
    //
    //   https://github.com/elm/core/issues/980
    //   https://github.com/elm/core/pull/981
    //   https://github.com/elm/compiler/issues/1776
    //
    // The queue is necessary to avoid ordering issues for synchronous commands.
    // Why use true/false here? Why not just check the length of the queue?
    // The goal is to detect "are we currently dispatching effects?" If we
    // are, we need to bail and let the ongoing while loop handle things.
    //
    // Now say the queue has 1 element. When we dequeue the final element,
    // the queue will be empty, but we are still actively dispatching effects.
    // So you could get queue jumping in a really tricky category of cases.
    //
    var _Platform_effectsQueue = [];
    var _Platform_effectsActive = false;
    function _Platform_enqueueEffects(managers, cmdBag, subBag) {
        _Platform_effectsQueue.push({
            p: managers,
            q: cmdBag,
            r: subBag
        });
        if (_Platform_effectsActive) return;
        _Platform_effectsActive = true;
        for(var fx; fx = _Platform_effectsQueue.shift();)_Platform_dispatchEffects(fx.p, fx.q, fx.r);
        _Platform_effectsActive = false;
    }
    function _Platform_dispatchEffects(managers, cmdBag, subBag) {
        var effectsDict = {};
        _Platform_gatherEffects(true, cmdBag, effectsDict, null);
        _Platform_gatherEffects(false, subBag, effectsDict, null);
        for(var home in managers)_Scheduler_rawSend(managers[home], {
            $: 'fx',
            a: effectsDict[home] || {
                i: _List_Nil,
                j: _List_Nil
            }
        });
    }
    function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers) {
        switch(bag.$){
            case 1:
                var home = bag.k;
                var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
                effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
                return;
            case 2:
                for(var list = bag.m; list.b; list = list.b)_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
                return;
            case 3:
                _Platform_gatherEffects(isCmd, bag.o, effectsDict, {
                    s: bag.n,
                    t: taggers
                });
                return;
        }
    }
    function _Platform_toEffect(isCmd, home, taggers, value) {
        function applyTaggers(x) {
            for(var temp = taggers; temp; temp = temp.t)x = temp.s(x);
            return x;
        }
        var map = isCmd ? _Platform_effectManagers[home].e : _Platform_effectManagers[home].f;
        return A2(map, applyTaggers, value);
    }
    function _Platform_insert(isCmd, newEffect, effects) {
        effects = effects || {
            i: _List_Nil,
            j: _List_Nil
        };
        isCmd ? effects.i = _List_Cons(newEffect, effects.i) : effects.j = _List_Cons(newEffect, effects.j);
        return effects;
    }
    // PORTS
    function _Platform_checkPortName(name) {
        if (_Platform_effectManagers[name]) _Debug_crash(3, name);
    }
    // OUTGOING PORTS
    function _Platform_outgoingPort(name, converter) {
        _Platform_checkPortName(name);
        _Platform_effectManagers[name] = {
            e: _Platform_outgoingPortMap,
            u: converter,
            a: _Platform_setupOutgoingPort
        };
        return _Platform_leaf(name);
    }
    var _Platform_outgoingPortMap = F2(function(tagger, value) {
        return value;
    });
    function _Platform_setupOutgoingPort(name) {
        var subs = [];
        var converter = _Platform_effectManagers[name].u;
        // CREATE MANAGER
        var init = _Process_sleep(0);
        _Platform_effectManagers[name].b = init;
        _Platform_effectManagers[name].c = F3(function(router, cmdList, state) {
            for(; cmdList.b; cmdList = cmdList.b){
                // grab a separate reference to subs in case unsubscribe is called
                var currentSubs = subs;
                var value = _Json_unwrap(converter(cmdList.a));
                for(var i = 0; i < currentSubs.length; i++)currentSubs[i](value);
            }
            return init;
        });
        // PUBLIC API
        function subscribe(callback) {
            subs.push(callback);
        }
        function unsubscribe(callback) {
            // copy subs into a new array in case unsubscribe is called within a
            // subscribed callback
            subs = subs.slice();
            var index = subs.indexOf(callback);
            if (index >= 0) subs.splice(index, 1);
        }
        return {
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }
    // INCOMING PORTS
    function _Platform_incomingPort(name, converter) {
        _Platform_checkPortName(name);
        _Platform_effectManagers[name] = {
            f: _Platform_incomingPortMap,
            u: converter,
            a: _Platform_setupIncomingPort
        };
        return _Platform_leaf(name);
    }
    var _Platform_incomingPortMap = F2(function(tagger, finalTagger) {
        return function(value) {
            return tagger(finalTagger(value));
        };
    });
    function _Platform_setupIncomingPort(name, sendToApp) {
        var subs = _List_Nil;
        var converter = _Platform_effectManagers[name].u;
        // CREATE MANAGER
        var init = _Scheduler_succeed(null);
        _Platform_effectManagers[name].b = init;
        _Platform_effectManagers[name].c = F3(function(router, subList, state) {
            subs = subList;
            return init;
        });
        // PUBLIC API
        function send(incomingValue) {
            var result = A2(_Json_run, converter, _Json_wrap(incomingValue));
            $elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);
            var value = result.a;
            for(var temp = subs; temp.b; temp = temp.b)sendToApp(temp.a(value));
        }
        return {
            send: send
        };
    }
    // EXPORT ELM MODULES
    //
    // Have DEBUG and PROD versions so that we can (1) give nicer errors in
    // debug mode and (2) not pay for the bits needed for that in prod mode.
    //
    function _Platform_export(exports) {
        scope['Elm'] ? _Platform_mergeExportsProd(scope['Elm'], exports) : scope['Elm'] = exports;
    }
    function _Platform_mergeExportsProd(obj, exports) {
        for(var name in exports)name in obj ? name == 'init' ? _Debug_crash(6) : _Platform_mergeExportsProd(obj[name], exports[name]) : obj[name] = exports[name];
    }
    function _Platform_export_UNUSED(exports) {
        scope['Elm'] ? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports) : scope['Elm'] = exports;
    }
    function _Platform_mergeExportsDebug(moduleName, obj, exports) {
        for(var name in exports)name in obj ? name == 'init' ? _Debug_crash(6, moduleName) : _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name]) : obj[name] = exports[name];
    }
    // HELPERS
    var _VirtualDom_divertHrefToApp;
    var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};
    function _VirtualDom_appendChild(parent, child) {
        parent.appendChild(child);
    }
    var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args) {
        // NOTE: this function needs _Platform_export available to work
        /**/ var node = args['node'];
        //*/
        /**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/ node.parentNode.replaceChild(_VirtualDom_render(virtualNode, function() {}), node);
        return {};
    });
    // TEXT
    function _VirtualDom_text(string) {
        return {
            $: 0,
            a: string
        };
    }
    // NODE
    var _VirtualDom_nodeNS = F2(function(namespace, tag) {
        return F2(function(factList, kidList) {
            for(var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b){
                var kid = kidList.a;
                descendantsCount += kid.b || 0;
                kids.push(kid);
            }
            descendantsCount += kids.length;
            return {
                $: 1,
                c: tag,
                d: _VirtualDom_organizeFacts(factList),
                e: kids,
                f: namespace,
                b: descendantsCount
            };
        });
    });
    var _VirtualDom_node = _VirtualDom_nodeNS(undefined);
    // KEYED NODE
    var _VirtualDom_keyedNodeNS = F2(function(namespace, tag) {
        return F2(function(factList, kidList) {
            for(var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b){
                var kid = kidList.a;
                descendantsCount += kid.b.b || 0;
                kids.push(kid);
            }
            descendantsCount += kids.length;
            return {
                $: 2,
                c: tag,
                d: _VirtualDom_organizeFacts(factList),
                e: kids,
                f: namespace,
                b: descendantsCount
            };
        });
    });
    var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);
    // CUSTOM
    function _VirtualDom_custom(factList, model, render, diff) {
        return {
            $: 3,
            d: _VirtualDom_organizeFacts(factList),
            g: model,
            h: render,
            i: diff
        };
    }
    // MAP
    var _VirtualDom_map = F2(function(tagger, node) {
        return {
            $: 4,
            j: tagger,
            k: node,
            b: 1 + (node.b || 0)
        };
    });
    // LAZY
    function _VirtualDom_thunk(refs, thunk) {
        return {
            $: 5,
            l: refs,
            m: thunk,
            k: undefined
        };
    }
    var _VirtualDom_lazy = F2(function(func, a) {
        return _VirtualDom_thunk([
            func,
            a
        ], function() {
            return func(a);
        });
    });
    var _VirtualDom_lazy2 = F3(function(func, a, b) {
        return _VirtualDom_thunk([
            func,
            a,
            b
        ], function() {
            return A2(func, a, b);
        });
    });
    var _VirtualDom_lazy3 = F4(function(func, a, b, c) {
        return _VirtualDom_thunk([
            func,
            a,
            b,
            c
        ], function() {
            return A3(func, a, b, c);
        });
    });
    var _VirtualDom_lazy4 = F5(function(func, a, b, c, d) {
        return _VirtualDom_thunk([
            func,
            a,
            b,
            c,
            d
        ], function() {
            return A4(func, a, b, c, d);
        });
    });
    var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e) {
        return _VirtualDom_thunk([
            func,
            a,
            b,
            c,
            d,
            e
        ], function() {
            return A5(func, a, b, c, d, e);
        });
    });
    var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f) {
        return _VirtualDom_thunk([
            func,
            a,
            b,
            c,
            d,
            e,
            f
        ], function() {
            return A6(func, a, b, c, d, e, f);
        });
    });
    var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g) {
        return _VirtualDom_thunk([
            func,
            a,
            b,
            c,
            d,
            e,
            f,
            g
        ], function() {
            return A7(func, a, b, c, d, e, f, g);
        });
    });
    var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h) {
        return _VirtualDom_thunk([
            func,
            a,
            b,
            c,
            d,
            e,
            f,
            g,
            h
        ], function() {
            return A8(func, a, b, c, d, e, f, g, h);
        });
    });
    // FACTS
    var _VirtualDom_on = F2(function(key, handler) {
        return {
            $: 'a0',
            n: key,
            o: handler
        };
    });
    var _VirtualDom_style = F2(function(key, value) {
        return {
            $: 'a1',
            n: key,
            o: value
        };
    });
    var _VirtualDom_property = F2(function(key, value) {
        return {
            $: 'a2',
            n: key,
            o: value
        };
    });
    var _VirtualDom_attribute = F2(function(key, value) {
        return {
            $: 'a3',
            n: key,
            o: value
        };
    });
    var _VirtualDom_attributeNS = F3(function(namespace, key, value) {
        return {
            $: 'a4',
            n: key,
            o: {
                f: namespace,
                o: value
            }
        };
    });
    // XSS ATTACK VECTOR CHECKS
    //
    // For some reason, tabs can appear in href protocols and it still works.
    // So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
    // in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
    // so freaky.
    //
    // Pulling the regular expressions out to the top level gives a slight speed
    // boost in small benchmarks (4-10%) but hoisting values to reduce allocation
    // can be unpredictable in large programs where JIT may have a harder time with
    // functions are not fully self-contained. The benefit is more that the js and
    // js_html ones are so weird that I prefer to see them near each other.
    var _VirtualDom_RE_script = /^script$/i;
    var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
    var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
    var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;
    function _VirtualDom_noScript(tag) {
        return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
    }
    function _VirtualDom_noOnOrFormAction(key) {
        return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
    }
    function _VirtualDom_noInnerHtmlOrFormAction(key) {
        return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
    }
    function _VirtualDom_noJavaScriptUri(value) {
        return _VirtualDom_RE_js.test(value) ? /**/ '' //*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
         : value;
    }
    function _VirtualDom_noJavaScriptOrHtmlUri(value) {
        return _VirtualDom_RE_js_html.test(value) ? /**/ '' //*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
         : value;
    }
    function _VirtualDom_noJavaScriptOrHtmlJson(value) {
        return typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)) ? _Json_wrap(/**/ '' //*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
        ) : value;
    }
    // MAP FACTS
    var _VirtualDom_mapAttribute = F2(function(func, attr) {
        return attr.$ === 'a0' ? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o)) : attr;
    });
    function _VirtualDom_mapHandler(func, handler) {
        var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);
        // 0 = Normal
        // 1 = MayStopPropagation
        // 2 = MayPreventDefault
        // 3 = Custom
        return {
            $: handler.$,
            a: !tag ? A2($elm$json$Json$Decode$map, func, handler.a) : A3($elm$json$Json$Decode$map2, tag < 3 ? _VirtualDom_mapEventTuple : _VirtualDom_mapEventRecord, $elm$json$Json$Decode$succeed(func), handler.a)
        };
    }
    var _VirtualDom_mapEventTuple = F2(function(func, tuple) {
        return _Utils_Tuple2(func(tuple.a), tuple.b);
    });
    var _VirtualDom_mapEventRecord = F2(function(func, record) {
        return {
            ae1: func(record.ae1),
            CJ: record.CJ,
            Bq: record.Bq
        };
    });
    // ORGANIZE FACTS
    function _VirtualDom_organizeFacts(factList) {
        for(var facts = {}; factList.b; factList = factList.b){
            var entry = factList.a;
            var tag = entry.$;
            var key = entry.n;
            var value = entry.o;
            if (tag === 'a2') {
                key === 'className' ? _VirtualDom_addClass(facts, key, _Json_unwrap(value)) : facts[key] = _Json_unwrap(value);
                continue;
            }
            var subFacts = facts[tag] || (facts[tag] = {});
            tag === 'a3' && key === 'class' ? _VirtualDom_addClass(subFacts, key, value) : subFacts[key] = value;
        }
        return facts;
    }
    function _VirtualDom_addClass(object, key, newClass) {
        var classes = object[key];
        object[key] = classes ? classes + ' ' + newClass : newClass;
    }
    // RENDER
    function _VirtualDom_render(vNode, eventNode) {
        var tag = vNode.$;
        if (tag === 5) return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
        if (tag === 0) return _VirtualDom_doc.createTextNode(vNode.a);
        if (tag === 4) {
            var subNode = vNode.k;
            var tagger = vNode.j;
            while(subNode.$ === 4){
                typeof tagger !== 'object' ? tagger = [
                    tagger,
                    subNode.j
                ] : tagger.push(subNode.j);
                subNode = subNode.k;
            }
            var subEventRoot = {
                j: tagger,
                p: eventNode
            };
            var domNode = _VirtualDom_render(subNode, subEventRoot);
            domNode.elm_event_node_ref = subEventRoot;
            return domNode;
        }
        if (tag === 3) {
            var domNode = vNode.h(vNode.g);
            _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
            return domNode;
        }
        // at this point `tag` must be 1 or 2
        var domNode = vNode.f ? _VirtualDom_doc.createElementNS(vNode.f, vNode.c) : _VirtualDom_doc.createElement(vNode.c);
        if (_VirtualDom_divertHrefToApp && vNode.c == 'a') domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
        _VirtualDom_applyFacts(domNode, eventNode, vNode.d);
        for(var kids = vNode.e, i = 0; i < kids.length; i++)_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
        return domNode;
    }
    // APPLY FACTS
    function _VirtualDom_applyFacts(domNode, eventNode, facts) {
        for(var key in facts){
            var value = facts[key];
            key === 'a1' ? _VirtualDom_applyStyles(domNode, value) : key === 'a0' ? _VirtualDom_applyEvents(domNode, eventNode, value) : key === 'a3' ? _VirtualDom_applyAttrs(domNode, value) : key === 'a4' ? _VirtualDom_applyAttrsNS(domNode, value) : (key !== 'value' && key !== 'checked' || domNode[key] !== value) && (domNode[key] = value);
        }
    }
    // APPLY STYLES
    function _VirtualDom_applyStyles(domNode, styles) {
        var domNodeStyle = domNode.style;
        for(var key in styles)domNodeStyle[key] = styles[key];
    }
    // APPLY ATTRS
    function _VirtualDom_applyAttrs(domNode, attrs) {
        for(var key in attrs){
            var value = attrs[key];
            typeof value !== 'undefined' ? domNode.setAttribute(key, value) : domNode.removeAttribute(key);
        }
    }
    // APPLY NAMESPACED ATTRS
    function _VirtualDom_applyAttrsNS(domNode, nsAttrs) {
        for(var key in nsAttrs){
            var pair = nsAttrs[key];
            var namespace = pair.f;
            var value = pair.o;
            typeof value !== 'undefined' ? domNode.setAttributeNS(namespace, key, value) : domNode.removeAttributeNS(namespace, key);
        }
    }
    // APPLY EVENTS
    function _VirtualDom_applyEvents(domNode, eventNode, events) {
        var allCallbacks = domNode.elmFs || (domNode.elmFs = {});
        for(var key in events){
            var newHandler = events[key];
            var oldCallback = allCallbacks[key];
            if (!newHandler) {
                domNode.removeEventListener(key, oldCallback);
                allCallbacks[key] = undefined;
                continue;
            }
            if (oldCallback) {
                var oldHandler = oldCallback.q;
                if (oldHandler.$ === newHandler.$) {
                    oldCallback.q = newHandler;
                    continue;
                }
                domNode.removeEventListener(key, oldCallback);
            }
            oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
            domNode.addEventListener(key, oldCallback, _VirtualDom_passiveSupported && {
                passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2
            });
            allCallbacks[key] = oldCallback;
        }
    }
    // PASSIVE EVENTS
    var _VirtualDom_passiveSupported;
    try {
        window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
            get: function() {
                _VirtualDom_passiveSupported = true;
            }
        }));
    } catch (e) {}
    // EVENT HANDLERS
    function _VirtualDom_makeCallback(eventNode, initialHandler) {
        function callback(event) {
            var handler = callback.q;
            var result = _Json_runHelp(handler.a, event);
            if (!$elm$core$Result$isOk(result)) return;
            var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);
            // 0 = Normal
            // 1 = MayStopPropagation
            // 2 = MayPreventDefault
            // 3 = Custom
            var value = result.a;
            var message = !tag ? value : tag < 3 ? value.a : value.ae1;
            var stopPropagation = tag == 1 ? value.b : tag == 3 && value.CJ;
            var currentEventNode = (stopPropagation && event.stopPropagation(), (tag == 2 ? value.b : tag == 3 && value.Bq) && event.preventDefault(), eventNode);
            var tagger;
            var i;
            while(tagger = currentEventNode.j){
                if (typeof tagger == 'function') message = tagger(message);
                else for(var i = tagger.length; i--;)message = tagger[i](message);
                currentEventNode = currentEventNode.p;
            }
            currentEventNode(message, stopPropagation); // stopPropagation implies isSync
        }
        callback.q = initialHandler;
        return callback;
    }
    function _VirtualDom_equalEvents(x, y) {
        return x.$ == y.$ && _Json_equality(x.a, y.a);
    }
    // DIFF
    // TODO: Should we do patches like in iOS?
    //
    // type Patch
    //   = At Int Patch
    //   | Batch (List Patch)
    //   | Change ...
    //
    // How could it not be better?
    //
    function _VirtualDom_diff(x, y) {
        var patches = [];
        _VirtualDom_diffHelp(x, y, patches, 0);
        return patches;
    }
    function _VirtualDom_pushPatch(patches, type, index, data) {
        var patch = {
            $: type,
            r: index,
            s: data,
            t: undefined,
            u: undefined
        };
        patches.push(patch);
        return patch;
    }
    function _VirtualDom_diffHelp(x, y, patches, index) {
        if (x === y) return;
        var xType = x.$;
        var yType = y.$;
        // Bail if you run into different types of nodes. Implies that the
        // structure has changed significantly and it's not worth a diff.
        if (xType !== yType) {
            if (xType === 1 && yType === 2) {
                y = _VirtualDom_dekey(y);
                yType = 1;
            } else {
                _VirtualDom_pushPatch(patches, 0, index, y);
                return;
            }
        }
        // Now we know that both nodes are the same $.
        switch(yType){
            case 5:
                var xRefs = x.l;
                var yRefs = y.l;
                var i = xRefs.length;
                var same = i === yRefs.length;
                while(same && i--)same = xRefs[i] === yRefs[i];
                if (same) {
                    y.k = x.k;
                    return;
                }
                y.k = y.m();
                var subPatches = [];
                _VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
                subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
                return;
            case 4:
                // gather nested taggers
                var xTaggers = x.j;
                var yTaggers = y.j;
                var nesting = false;
                var xSubNode = x.k;
                while(xSubNode.$ === 4){
                    nesting = true;
                    typeof xTaggers !== 'object' ? xTaggers = [
                        xTaggers,
                        xSubNode.j
                    ] : xTaggers.push(xSubNode.j);
                    xSubNode = xSubNode.k;
                }
                var ySubNode = y.k;
                while(ySubNode.$ === 4){
                    nesting = true;
                    typeof yTaggers !== 'object' ? yTaggers = [
                        yTaggers,
                        ySubNode.j
                    ] : yTaggers.push(ySubNode.j);
                    ySubNode = ySubNode.k;
                }
                // Just bail if different numbers of taggers. This implies the
                // structure of the virtual DOM has changed.
                if (nesting && xTaggers.length !== yTaggers.length) {
                    _VirtualDom_pushPatch(patches, 0, index, y);
                    return;
                }
                // check if taggers are "the same"
                if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers) _VirtualDom_pushPatch(patches, 2, index, yTaggers);
                // diff everything below the taggers
                _VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
                return;
            case 0:
                if (x.a !== y.a) _VirtualDom_pushPatch(patches, 3, index, y.a);
                return;
            case 1:
                _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
                return;
            case 2:
                _VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
                return;
            case 3:
                if (x.h !== y.h) {
                    _VirtualDom_pushPatch(patches, 0, index, y);
                    return;
                }
                var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
                factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
                var patch = y.i(x.g, y.g);
                patch && _VirtualDom_pushPatch(patches, 5, index, patch);
                return;
        }
    }
    // assumes the incoming arrays are the same length
    function _VirtualDom_pairwiseRefEqual(as, bs) {
        for(var i = 0; i < as.length; i++){
            if (as[i] !== bs[i]) return false;
        }
        return true;
    }
    function _VirtualDom_diffNodes(x, y, patches, index, diffKids) {
        // Bail if obvious indicators have changed. Implies more serious
        // structural changes such that it's not worth it to diff.
        if (x.c !== y.c || x.f !== y.f) {
            _VirtualDom_pushPatch(patches, 0, index, y);
            return;
        }
        var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
        factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);
        diffKids(x, y, patches, index);
    }
    // DIFF FACTS
    // TODO Instead of creating a new diff object, it's possible to just test if
    // there *is* a diff. During the actual patch, do the diff again and make the
    // modifications directly. This way, there's no new allocations. Worth it?
    function _VirtualDom_diffFacts(x, y, category) {
        var diff;
        // look for changes and removals
        for(var xKey in x){
            if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4') {
                var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
                if (subDiff) {
                    diff = diff || {};
                    diff[xKey] = subDiff;
                }
                continue;
            }
            // remove if not in the new facts
            if (!(xKey in y)) {
                diff = diff || {};
                diff[xKey] = !category ? typeof x[xKey] === 'string' ? '' : null : category === 'a1' ? '' : category === 'a0' || category === 'a3' ? undefined : {
                    f: x[xKey].f,
                    o: undefined
                };
                continue;
            }
            var xValue = x[xKey];
            var yValue = y[xKey];
            // reference equal, so don't worry about it
            if (xValue === yValue && xKey !== 'value' && xKey !== 'checked' || category === 'a0' && _VirtualDom_equalEvents(xValue, yValue)) continue;
            diff = diff || {};
            diff[xKey] = yValue;
        }
        // add new stuff
        for(var yKey in y)if (!(yKey in x)) {
            diff = diff || {};
            diff[yKey] = y[yKey];
        }
        return diff;
    }
    // DIFF KIDS
    function _VirtualDom_diffKids(xParent, yParent, patches, index) {
        var xKids = xParent.e;
        var yKids = yParent.e;
        var xLen = xKids.length;
        var yLen = yKids.length;
        // FIGURE OUT IF THERE ARE INSERTS OR REMOVALS
        if (xLen > yLen) _VirtualDom_pushPatch(patches, 6, index, {
            v: yLen,
            i: xLen - yLen
        });
        else if (xLen < yLen) _VirtualDom_pushPatch(patches, 7, index, {
            v: xLen,
            e: yKids
        });
        // PAIRWISE DIFF EVERYTHING ELSE
        for(var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++){
            var xKid = xKids[i];
            _VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
            index += xKid.b || 0;
        }
    }
    // KEYED DIFF
    function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex) {
        var localPatches = [];
        var changes = {}; // Dict String Entry
        var inserts = []; // Array { index : Int, entry : Entry }
        // type Entry = { tag : String, vnode : VNode, index : Int, data : _ }
        var xKids = xParent.e;
        var yKids = yParent.e;
        var xLen = xKids.length;
        var yLen = yKids.length;
        var xIndex = 0;
        var yIndex = 0;
        var index = rootIndex;
        while(xIndex < xLen && yIndex < yLen){
            var x = xKids[xIndex];
            var y = yKids[yIndex];
            var xKey = x.a;
            var yKey = y.a;
            var xNode = x.b;
            var yNode = y.b;
            var newMatch = undefined;
            var oldMatch = undefined;
            // check if keys match
            if (xKey === yKey) {
                index++;
                _VirtualDom_diffHelp(xNode, yNode, localPatches, index);
                index += xNode.b || 0;
                xIndex++;
                yIndex++;
                continue;
            }
            // look ahead 1 to detect insertions and removals.
            var xNext = xKids[xIndex + 1];
            var yNext = yKids[yIndex + 1];
            if (xNext) {
                var xNextKey = xNext.a;
                var xNextNode = xNext.b;
                oldMatch = yKey === xNextKey;
            }
            if (yNext) {
                var yNextKey = yNext.a;
                var yNextNode = yNext.b;
                newMatch = xKey === yNextKey;
            }
            // swap x and y
            if (newMatch && oldMatch) {
                index++;
                _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
                _VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
                index += xNode.b || 0;
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 2;
                continue;
            }
            // insert y
            if (newMatch) {
                index++;
                _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
                _VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
                index += xNode.b || 0;
                xIndex += 1;
                yIndex += 2;
                continue;
            }
            // remove x
            if (oldMatch) {
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
                index += xNode.b || 0;
                index++;
                _VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 1;
                continue;
            }
            // remove x, insert y
            if (xNext && xNextKey === yNextKey) {
                index++;
                _VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
                _VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
                index += xNode.b || 0;
                index++;
                _VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
                index += xNextNode.b || 0;
                xIndex += 2;
                yIndex += 2;
                continue;
            }
            break;
        }
        // eat up any remaining nodes with removeNode and insertNode
        while(xIndex < xLen){
            index++;
            var x = xKids[xIndex];
            var xNode = x.b;
            _VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
            index += xNode.b || 0;
            xIndex++;
        }
        while(yIndex < yLen){
            var endInserts = endInserts || [];
            var y = yKids[yIndex];
            _VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
            yIndex++;
        }
        if (localPatches.length > 0 || inserts.length > 0 || endInserts) _VirtualDom_pushPatch(patches, 8, rootIndex, {
            w: localPatches,
            x: inserts,
            y: endInserts
        });
    }
    // CHANGES FROM KEYED DIFF
    var _VirtualDom_POSTFIX = '_elmW6BL';
    function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts) {
        var entry = changes[key];
        // never seen this key before
        if (!entry) {
            entry = {
                c: 0,
                z: vnode,
                r: yIndex,
                s: undefined
            };
            inserts.push({
                r: yIndex,
                A: entry
            });
            changes[key] = entry;
            return;
        }
        // this key was removed earlier, a match!
        if (entry.c === 1) {
            inserts.push({
                r: yIndex,
                A: entry
            });
            entry.c = 2;
            var subPatches = [];
            _VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
            entry.r = yIndex;
            entry.s.s = {
                w: subPatches,
                A: entry
            };
            return;
        }
        // this key has already been inserted or moved, a duplicate!
        _VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
    }
    function _VirtualDom_removeNode(changes, localPatches, key, vnode, index) {
        var entry = changes[key];
        // never seen this key before
        if (!entry) {
            var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);
            changes[key] = {
                c: 1,
                z: vnode,
                r: index,
                s: patch
            };
            return;
        }
        // this key was inserted earlier, a match!
        if (entry.c === 0) {
            entry.c = 2;
            var subPatches = [];
            _VirtualDom_diffHelp(vnode, entry.z, subPatches, index);
            _VirtualDom_pushPatch(localPatches, 9, index, {
                w: subPatches,
                A: entry
            });
            return;
        }
        // this key has already been removed or moved, a duplicate!
        _VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
    }
    // ADD DOM NODES
    //
    // Each DOM node has an "index" assigned in order of traversal. It is important
    // to minimize our crawl over the actual DOM, so these indexes (along with the
    // descendantsCount of virtual nodes) let us skip touching entire subtrees of
    // the DOM if we know there are no patches there.
    function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode) {
        _VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
    }
    // assumes `patches` is non-empty and indexes increase monotonically.
    function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode) {
        var patch = patches[i];
        var index = patch.r;
        while(index === low){
            var patchType = patch.$;
            if (patchType === 1) _VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
            else if (patchType === 8) {
                patch.t = domNode;
                patch.u = eventNode;
                var subPatches = patch.s.w;
                if (subPatches.length > 0) _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
            } else if (patchType === 9) {
                patch.t = domNode;
                patch.u = eventNode;
                var data = patch.s;
                if (data) {
                    data.A.s = domNode;
                    var subPatches = data.w;
                    if (subPatches.length > 0) _VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
                }
            } else {
                patch.t = domNode;
                patch.u = eventNode;
            }
            i++;
            if (!(patch = patches[i]) || (index = patch.r) > high) return i;
        }
        var tag = vNode.$;
        if (tag === 4) {
            var subNode = vNode.k;
            while(subNode.$ === 4)subNode = subNode.k;
            return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
        }
        // tag must be 1 or 2 at this point
        var vKids = vNode.e;
        var childNodes = domNode.childNodes;
        for(var j = 0; j < vKids.length; j++){
            low++;
            var vKid = tag === 1 ? vKids[j] : vKids[j].b;
            var nextLow = low + (vKid.b || 0);
            if (low <= index && index <= nextLow) {
                i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
                if (!(patch = patches[i]) || (index = patch.r) > high) return i;
            }
            low = nextLow;
        }
        return i;
    }
    // APPLY PATCHES
    function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode) {
        if (patches.length === 0) return rootDomNode;
        _VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
        return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
    }
    function _VirtualDom_applyPatchesHelp(rootDomNode, patches) {
        for(var i = 0; i < patches.length; i++){
            var patch = patches[i];
            var localDomNode = patch.t;
            var newNode = _VirtualDom_applyPatch(localDomNode, patch);
            if (localDomNode === rootDomNode) rootDomNode = newNode;
        }
        return rootDomNode;
    }
    function _VirtualDom_applyPatch(domNode, patch) {
        switch(patch.$){
            case 0:
                return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);
            case 4:
                _VirtualDom_applyFacts(domNode, patch.u, patch.s);
                return domNode;
            case 3:
                domNode.replaceData(0, domNode.length, patch.s);
                return domNode;
            case 1:
                return _VirtualDom_applyPatchesHelp(domNode, patch.s);
            case 2:
                if (domNode.elm_event_node_ref) domNode.elm_event_node_ref.j = patch.s;
                else domNode.elm_event_node_ref = {
                    j: patch.s,
                    p: patch.u
                };
                return domNode;
            case 6:
                var data = patch.s;
                for(var i = 0; i < data.i; i++)domNode.removeChild(domNode.childNodes[data.v]);
                return domNode;
            case 7:
                var data = patch.s;
                var kids = data.e;
                var i = data.v;
                var theEnd = domNode.childNodes[i];
                for(; i < kids.length; i++)domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
                return domNode;
            case 9:
                var data = patch.s;
                if (!data) {
                    domNode.parentNode.removeChild(domNode);
                    return domNode;
                }
                var entry = data.A;
                if (typeof entry.r !== 'undefined') domNode.parentNode.removeChild(domNode);
                entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
                return domNode;
            case 8:
                return _VirtualDom_applyPatchReorder(domNode, patch);
            case 5:
                return patch.s(domNode);
            default:
                _Debug_crash(10); // 'Ran into an unknown patch!'
        }
    }
    function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode) {
        var parentNode = domNode.parentNode;
        var newNode = _VirtualDom_render(vNode, eventNode);
        if (!newNode.elm_event_node_ref) newNode.elm_event_node_ref = domNode.elm_event_node_ref;
        if (parentNode && newNode !== domNode) parentNode.replaceChild(newNode, domNode);
        return newNode;
    }
    function _VirtualDom_applyPatchReorder(domNode, patch) {
        var data = patch.s;
        // remove end inserts
        var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);
        // removals
        domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);
        // inserts
        var inserts = data.x;
        for(var i = 0; i < inserts.length; i++){
            var insert = inserts[i];
            var entry = insert.A;
            var node = entry.c === 2 ? entry.s : _VirtualDom_render(entry.z, patch.u);
            domNode.insertBefore(node, domNode.childNodes[insert.r]);
        }
        // add end inserts
        if (frag) _VirtualDom_appendChild(domNode, frag);
        return domNode;
    }
    function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch) {
        if (!endInserts) return;
        var frag = _VirtualDom_doc.createDocumentFragment();
        for(var i = 0; i < endInserts.length; i++){
            var insert = endInserts[i];
            var entry = insert.A;
            _VirtualDom_appendChild(frag, entry.c === 2 ? entry.s : _VirtualDom_render(entry.z, patch.u));
        }
        return frag;
    }
    function _VirtualDom_virtualize(node) {
        // TEXT NODES
        if (node.nodeType === 3) return _VirtualDom_text(node.textContent);
        // WEIRD NODES
        if (node.nodeType !== 1) return _VirtualDom_text('');
        // ELEMENT NODES
        var attrList = _List_Nil;
        var attrs = node.attributes;
        for(var i = attrs.length; i--;){
            var attr = attrs[i];
            var name = attr.name;
            var value = attr.value;
            attrList = _List_Cons(A2(_VirtualDom_attribute, name, value), attrList);
        }
        var tag = node.tagName.toLowerCase();
        var kidList = _List_Nil;
        var kids = node.childNodes;
        for(var i = kids.length; i--;)kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
        return A3(_VirtualDom_node, tag, attrList, kidList);
    }
    function _VirtualDom_dekey(keyedNode) {
        var keyedKids = keyedNode.e;
        var len = keyedKids.length;
        var kids = new Array(len);
        for(var i = 0; i < len; i++)kids[i] = keyedKids[i].b;
        return {
            $: 1,
            c: keyedNode.c,
            d: keyedNode.d,
            e: kids,
            f: keyedNode.f,
            b: keyedNode.b
        };
    }
    // ELEMENT
    var _Debugger_element;
    var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.aeq, impl.aaO, impl.ahE, function(sendToApp, initialModel) {
            var view = impl.aid;
            /**/ var domNode = args['node'];
            //*/
            /**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/ var currNode = _VirtualDom_virtualize(domNode);
            return _Browser_makeAnimator(initialModel, function(model) {
                var nextNode = view(model);
                var patches = _VirtualDom_diff(currNode, nextNode);
                domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
                currNode = nextNode;
            });
        });
    });
    // DOCUMENT
    var _Debugger_document;
    var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args) {
        return _Platform_initialize(flagDecoder, args, impl.aeq, impl.aaO, impl.ahE, function(sendToApp, initialModel) {
            var divertHrefToApp = impl.Z1 && impl.Z1(sendToApp);
            var view = impl.aid;
            var title = _VirtualDom_doc.title;
            var bodyNode = _VirtualDom_doc.body;
            var currNode = _VirtualDom_virtualize(bodyNode);
            return _Browser_makeAnimator(initialModel, function(model) {
                _VirtualDom_divertHrefToApp = divertHrefToApp;
                var doc = view(model);
                var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.fb);
                var patches = _VirtualDom_diff(currNode, nextNode);
                bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
                currNode = nextNode;
                _VirtualDom_divertHrefToApp = 0;
                title !== doc.$2 && (_VirtualDom_doc.title = title = doc.$2);
            });
        });
    });
    // ANIMATION
    var _Browser_cancelAnimationFrame = typeof cancelAnimationFrame !== 'undefined' ? cancelAnimationFrame : function(id) {
        clearTimeout(id);
    };
    var _Browser_requestAnimationFrame = typeof requestAnimationFrame !== 'undefined' ? requestAnimationFrame : function(callback) {
        return setTimeout(callback, 1000 / 60);
    };
    function _Browser_makeAnimator(model, draw) {
        draw(model);
        var state = 0;
        function updateIfNeeded() {
            state = state === 1 ? 0 : (_Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1);
        }
        return function(nextModel, isSync) {
            model = nextModel;
            isSync ? (draw(model), state === 2 && (state = 1)) : (state === 0 && _Browser_requestAnimationFrame(updateIfNeeded), state = 2);
        };
    }
    // APPLICATION
    function _Browser_application(impl) {
        var onUrlChange = impl.afP;
        var onUrlRequest = impl.afQ;
        var key = function() {
            key.a(onUrlChange(_Browser_getUrl()));
        };
        return _Browser_document({
            Z1: function(sendToApp) {
                key.a = sendToApp;
                _Browser_window.addEventListener('popstate', key);
                _Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);
                return F2(function(domNode, event) {
                    if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download')) {
                        event.preventDefault();
                        var href = domNode.href;
                        var curr = _Browser_getUrl();
                        var next = $elm$url$Url$fromString(href).a;
                        sendToApp(onUrlRequest(next && curr.XH === next.XH && curr.aec === next.aec && curr.WV.a === next.WV.a ? $elm$browser$Browser$Internal(next) : $elm$browser$Browser$External(href)));
                    }
                });
            },
            aeq: function(flags) {
                return A3(impl.aeq, flags, _Browser_getUrl(), key);
            },
            aid: impl.aid,
            aaO: impl.aaO,
            ahE: impl.ahE
        });
    }
    function _Browser_getUrl() {
        return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
    }
    var _Browser_go = F2(function(key, n) {
        return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
            n && history.go(n);
            key();
        }));
    });
    var _Browser_pushUrl = F2(function(key, url) {
        return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
            history.pushState({}, '', url);
            key();
        }));
    });
    var _Browser_replaceUrl = F2(function(key, url) {
        return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
            history.replaceState({}, '', url);
            key();
        }));
    });
    // GLOBAL EVENTS
    var _Browser_fakeNode = {
        addEventListener: function() {},
        removeEventListener: function() {}
    };
    var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
    var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;
    var _Browser_on = F3(function(node, eventName, sendToSelf) {
        return _Scheduler_spawn(_Scheduler_binding(function(callback) {
            function handler(event) {
                _Scheduler_rawSpawn(sendToSelf(event));
            }
            node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && {
                passive: true
            });
            return function() {
                node.removeEventListener(eventName, handler);
            };
        }));
    });
    var _Browser_decodeEvent = F2(function(decoder, event) {
        var result = _Json_runHelp(decoder, event);
        return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
    });
    // PAGE VISIBILITY
    function _Browser_visibilityInfo() {
        return typeof _VirtualDom_doc.hidden !== 'undefined' ? {
            ad6: 'hidden',
            acg: 'visibilitychange'
        } : typeof _VirtualDom_doc.mozHidden !== 'undefined' ? {
            ad6: 'mozHidden',
            acg: 'mozvisibilitychange'
        } : typeof _VirtualDom_doc.msHidden !== 'undefined' ? {
            ad6: 'msHidden',
            acg: 'msvisibilitychange'
        } : typeof _VirtualDom_doc.webkitHidden !== 'undefined' ? {
            ad6: 'webkitHidden',
            acg: 'webkitvisibilitychange'
        } : {
            ad6: 'hidden',
            acg: 'visibilitychange'
        };
    }
    // ANIMATION FRAMES
    function _Browser_rAF() {
        return _Scheduler_binding(function(callback) {
            var id = _Browser_requestAnimationFrame(function() {
                callback(_Scheduler_succeed(Date.now()));
            });
            return function() {
                _Browser_cancelAnimationFrame(id);
            };
        });
    }
    function _Browser_now() {
        return _Scheduler_binding(function(callback) {
            callback(_Scheduler_succeed(Date.now()));
        });
    }
    // DOM STUFF
    function _Browser_withNode(id, doStuff) {
        return _Scheduler_binding(function(callback) {
            _Browser_requestAnimationFrame(function() {
                var node = document.getElementById(id);
                callback(node ? _Scheduler_succeed(doStuff(node)) : _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id)));
            });
        });
    }
    function _Browser_withWindow(doStuff) {
        return _Scheduler_binding(function(callback) {
            _Browser_requestAnimationFrame(function() {
                callback(_Scheduler_succeed(doStuff()));
            });
        });
    }
    // FOCUS and BLUR
    var _Browser_call = F2(function(functionName, id) {
        return _Browser_withNode(id, function(node) {
            node[functionName]();
            return _Utils_Tuple0;
        });
    });
    // WINDOW VIEWPORT
    function _Browser_getViewport() {
        return {
            Zs: _Browser_getScene(),
            aie: {
                abu: _Browser_window.pageXOffset,
                abv: _Browser_window.pageYOffset,
                aih: _Browser_doc.documentElement.clientWidth,
                QE: _Browser_doc.documentElement.clientHeight
            }
        };
    }
    function _Browser_getScene() {
        var body = _Browser_doc.body;
        var elem = _Browser_doc.documentElement;
        return {
            aih: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
            QE: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
        };
    }
    var _Browser_setViewport = F2(function(x, y) {
        return _Browser_withWindow(function() {
            _Browser_window.scroll(x, y);
            return _Utils_Tuple0;
        });
    });
    // ELEMENT VIEWPORT
    function _Browser_getViewportOf(id) {
        return _Browser_withNode(id, function(node) {
            return {
                Zs: {
                    aih: node.scrollWidth,
                    QE: node.scrollHeight
                },
                aie: {
                    abu: node.scrollLeft,
                    abv: node.scrollTop,
                    aih: node.clientWidth,
                    QE: node.clientHeight
                }
            };
        });
    }
    var _Browser_setViewportOf = F3(function(id, x, y) {
        return _Browser_withNode(id, function(node) {
            node.scrollLeft = x;
            node.scrollTop = y;
            return _Utils_Tuple0;
        });
    });
    // ELEMENT
    function _Browser_getElement(id) {
        return _Browser_withNode(id, function(node) {
            var rect = node.getBoundingClientRect();
            var x = _Browser_window.pageXOffset;
            var y = _Browser_window.pageYOffset;
            return {
                Zs: _Browser_getScene(),
                aie: {
                    abu: x,
                    abv: y,
                    aih: _Browser_doc.documentElement.clientWidth,
                    QE: _Browser_doc.documentElement.clientHeight
                },
                adh: {
                    abu: x + rect.left,
                    abv: y + rect.top,
                    aih: rect.width,
                    QE: rect.height
                }
            };
        });
    }
    // LOAD and RELOAD
    function _Browser_reload(skipCache) {
        return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback) {
            _VirtualDom_doc.location.reload(skipCache);
        }));
    }
    function _Browser_load(url) {
        return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback) {
            try {
                _Browser_window.location = url;
            } catch (err) {
                // Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
                // Other browsers reload the page, so let's be consistent about that.
                _VirtualDom_doc.location.reload(false);
            }
        }));
    }
    function _Url_percentEncode(string) {
        return encodeURIComponent(string);
    }
    function _Url_percentDecode(string) {
        try {
            return $elm$core$Maybe$Just(decodeURIComponent(string));
        } catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    }
    function _Time_now(millisToPosix) {
        return _Scheduler_binding(function(callback) {
            callback(_Scheduler_succeed(millisToPosix(Date.now())));
        });
    }
    var _Time_setInterval = F2(function(interval, task) {
        return _Scheduler_binding(function(callback) {
            var id = setInterval(function() {
                _Scheduler_rawSpawn(task);
            }, interval);
            return function() {
                clearInterval(id);
            };
        });
    });
    function _Time_here() {
        return _Scheduler_binding(function(callback) {
            callback(_Scheduler_succeed(A2($elm$time$Time$customZone, -new Date().getTimezoneOffset(), _List_Nil)));
        });
    }
    function _Time_getZoneName() {
        return _Scheduler_binding(function(callback) {
            try {
                var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
            } catch (e) {
                var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
            }
            callback(_Scheduler_succeed(name));
        });
    }
    // SEND REQUEST
    var _Http_toTask = F3(function(router, toTask, request) {
        return _Scheduler_binding(function(callback) {
            function done(response) {
                callback(toTask(request.Pb.a(response)));
            }
            var xhr = new XMLHttpRequest();
            xhr.addEventListener('error', function() {
                done($elm$http$Http$NetworkError_);
            });
            xhr.addEventListener('timeout', function() {
                done($elm$http$Http$Timeout_);
            });
            xhr.addEventListener('load', function() {
                done(_Http_toResponse(request.Pb.b, xhr));
            });
            $elm$core$Maybe$isJust(request.tu) && _Http_track(router, xhr, request.tu.a);
            try {
                xhr.open(request.Gk, request.aaT, true);
            } catch (e) {
                return done($elm$http$Http$BadUrl_(request.aaT));
            }
            _Http_configureRequest(xhr, request);
            request.fb.a && xhr.setRequestHeader('Content-Type', request.fb.a);
            xhr.send(request.fb.b);
            return function() {
                xhr.c = true;
                xhr.abort();
            };
        });
    });
    // CONFIGURE
    function _Http_configureRequest(xhr, request) {
        for(var headers = request.iL; headers.b; headers = headers.b)xhr.setRequestHeader(headers.a.a, headers.a.b);
        xhr.timeout = request.HQ.a || 0;
        xhr.responseType = request.Pb.d;
        xhr.withCredentials = request.abF;
    }
    // RESPONSES
    function _Http_toResponse(toBody, xhr) {
        return A2(200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_, _Http_toMetadata(xhr), toBody(xhr.response));
    }
    // METADATA
    function _Http_toMetadata(xhr) {
        return {
            aaT: xhr.responseURL,
            _7: xhr.status,
            ahz: xhr.statusText,
            iL: _Http_parseHeaders(xhr.getAllResponseHeaders())
        };
    }
    // HEADERS
    function _Http_parseHeaders(rawHeaders) {
        if (!rawHeaders) return $elm$core$Dict$empty;
        var headers = $elm$core$Dict$empty;
        var headerPairs = rawHeaders.split('\r\n');
        for(var i = headerPairs.length; i--;){
            var headerPair = headerPairs[i];
            var index = headerPair.indexOf(': ');
            if (index > 0) {
                var key = headerPair.substring(0, index);
                var value = headerPair.substring(index + 2);
                headers = A3($elm$core$Dict$update, key, function(oldValue) {
                    return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue) ? value + ', ' + oldValue.a : value);
                }, headers);
            }
        }
        return headers;
    }
    // EXPECT
    var _Http_expect = F3(function(type, toBody, toValue) {
        return {
            $: 0,
            d: type,
            b: toBody,
            a: toValue
        };
    });
    var _Http_mapExpect = F2(function(func, expect) {
        return {
            $: 0,
            d: expect.d,
            b: expect.b,
            a: function(x) {
                return func(expect.a(x));
            }
        };
    });
    function _Http_toDataView(arrayBuffer) {
        return new DataView(arrayBuffer);
    }
    // BODY and PARTS
    var _Http_emptyBody = {
        $: 0
    };
    var _Http_pair = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    function _Http_toFormData(parts) {
        for(var formData = new FormData(); parts.b; parts = parts.b){
            var part = parts.a;
            formData.append(part.a, part.b);
        }
        return formData;
    }
    var _Http_bytesToBlob = F2(function(mime, bytes) {
        return new Blob([
            bytes
        ], {
            type: mime
        });
    });
    // PROGRESS
    function _Http_track(router, xhr, tracker) {
        // TODO check out lengthComputable on loadstart event
        xhr.upload.addEventListener('progress', function(event) {
            if (xhr.c) return;
            _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
                ahg: event.loaded,
                ahq: event.total
            }))));
        });
        xhr.addEventListener('progress', function(event) {
            if (xhr.c) return;
            _Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
                agx: event.loaded,
                ahq: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
            }))));
        });
    }
    var _Bitwise_and = F2(function(a, b) {
        return a & b;
    });
    var _Bitwise_or = F2(function(a, b) {
        return a | b;
    });
    var _Bitwise_xor = F2(function(a, b) {
        return a ^ b;
    });
    function _Bitwise_complement(a) {
        return ~a;
    }
    var _Bitwise_shiftLeftBy = F2(function(offset, a) {
        return a << offset;
    });
    var _Bitwise_shiftRightBy = F2(function(offset, a) {
        return a >> offset;
    });
    var _Bitwise_shiftRightZfBy = F2(function(offset, a) {
        return a >>> offset;
    });
    // CREATE
    var _Regex_never = /.^/;
    var _Regex_fromStringWith = F2(function(options, string) {
        var flags = 'g';
        if (options.ae8) flags += 'm';
        if (options.acf) flags += 'i';
        try {
            return $elm$core$Maybe$Just(new RegExp(string, flags));
        } catch (error) {
            return $elm$core$Maybe$Nothing;
        }
    });
    // USE
    var _Regex_contains = F2(function(re, string) {
        return string.match(re) !== null;
    });
    var _Regex_findAtMost = F3(function(n, re, str) {
        var out = [];
        var number = 0;
        var string = str;
        var lastIndex = re.lastIndex;
        var prevLastIndex = -1;
        var result;
        while(number++ < n && (result = re.exec(string))){
            if (prevLastIndex == re.lastIndex) break;
            var i = result.length - 1;
            var subs = new Array(i);
            while(i > 0){
                var submatch = result[i];
                subs[--i] = submatch ? $elm$core$Maybe$Just(submatch) : $elm$core$Maybe$Nothing;
            }
            out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
            prevLastIndex = re.lastIndex;
        }
        re.lastIndex = lastIndex;
        return _List_fromArray(out);
    });
    var _Regex_replaceAtMost = F4(function(n, re, replacer, string) {
        var count = 0;
        function jsReplacer(match) {
            if (count++ >= n) return match;
            var i = arguments.length - 3;
            var submatches = new Array(i);
            while(i > 0){
                var submatch = arguments[i];
                submatches[--i] = submatch ? $elm$core$Maybe$Just(submatch) : $elm$core$Maybe$Nothing;
            }
            return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
        }
        return string.replace(re, jsReplacer);
    });
    var _Regex_splitAtMost = F3(function(n, re, str) {
        var string = str;
        var out = [];
        var start = re.lastIndex;
        var restoreLastIndex = re.lastIndex;
        while(n--){
            var result = re.exec(string);
            if (!result) break;
            out.push(string.slice(start, result.index));
            start = re.lastIndex;
        }
        out.push(string.slice(start));
        re.lastIndex = restoreLastIndex;
        return _List_fromArray(out);
    });
    var _Regex_infinity = Infinity;
    // BYTES
    function _Bytes_width(bytes) {
        return bytes.byteLength;
    }
    var _Bytes_getHostEndianness = F2(function(le, be) {
        return _Scheduler_binding(function(callback) {
            callback(_Scheduler_succeed(new Uint8Array(new Uint32Array([
                1
            ]))[0] === 1 ? le : be));
        });
    });
    // ENCODERS
    function _Bytes_encode(encoder) {
        var mutableBytes = new DataView(new ArrayBuffer($elm$bytes$Bytes$Encode$getWidth(encoder)));
        $elm$bytes$Bytes$Encode$write(encoder)(mutableBytes)(0);
        return mutableBytes;
    }
    // SIGNED INTEGERS
    var _Bytes_write_i8 = F3(function(mb, i, n) {
        mb.setInt8(i, n);
        return i + 1;
    });
    var _Bytes_write_i16 = F4(function(mb, i, n, isLE) {
        mb.setInt16(i, n, isLE);
        return i + 2;
    });
    var _Bytes_write_i32 = F4(function(mb, i, n, isLE) {
        mb.setInt32(i, n, isLE);
        return i + 4;
    });
    // UNSIGNED INTEGERS
    var _Bytes_write_u8 = F3(function(mb, i, n) {
        mb.setUint8(i, n);
        return i + 1;
    });
    var _Bytes_write_u16 = F4(function(mb, i, n, isLE) {
        mb.setUint16(i, n, isLE);
        return i + 2;
    });
    var _Bytes_write_u32 = F4(function(mb, i, n, isLE) {
        mb.setUint32(i, n, isLE);
        return i + 4;
    });
    // FLOATS
    var _Bytes_write_f32 = F4(function(mb, i, n, isLE) {
        mb.setFloat32(i, n, isLE);
        return i + 4;
    });
    var _Bytes_write_f64 = F4(function(mb, i, n, isLE) {
        mb.setFloat64(i, n, isLE);
        return i + 8;
    });
    // BYTES
    var _Bytes_write_bytes = F3(function(mb, offset, bytes) {
        for(var i = 0, len = bytes.byteLength, limit = len - 4; i <= limit; i += 4)mb.setUint32(offset + i, bytes.getUint32(i));
        for(; i < len; i++)mb.setUint8(offset + i, bytes.getUint8(i));
        return offset + len;
    });
    // STRINGS
    function _Bytes_getStringWidth(string) {
        for(var width = 0, i = 0; i < string.length; i++){
            var code = string.charCodeAt(i);
            width += code < 0x80 ? 1 : code < 0x800 ? 2 : code < 0xD800 || 0xDBFF < code ? 3 : (i++, 4);
        }
        return width;
    }
    var _Bytes_write_string = F3(function(mb, offset, string) {
        for(var i = 0; i < string.length; i++){
            var code = string.charCodeAt(i);
            offset += code < 0x80 ? (mb.setUint8(offset, code), 1) : code < 0x800 ? (mb.setUint16(offset, 0xC080 /* 0b1100000010000000 */  | (code >>> 6 & 0x1F /* 0b00011111 */ ) << 8 | code & 0x3F /* 0b00111111 */ ), 2) : code < 0xD800 || 0xDBFF < code ? (mb.setUint16(offset, 0xE080 /* 0b1110000010000000 */  | (code >>> 12 & 0xF /* 0b00001111 */ ) << 8 | code >>> 6 & 0x3F /* 0b00111111 */ ), mb.setUint8(offset + 2, 0x80 /* 0b10000000 */  | code & 0x3F /* 0b00111111 */ ), 3) : (code = (code - 0xD800) * 0x400 + string.charCodeAt(++i) - 0xDC00 + 0x10000, mb.setUint32(offset, 0xF0808080 /* 0b11110000100000001000000010000000 */  | (code >>> 18 & 0x7 /* 0b00000111 */ ) << 24 | (code >>> 12 & 0x3F /* 0b00111111 */ ) << 16 | (code >>> 6 & 0x3F /* 0b00111111 */ ) << 8 | code & 0x3F /* 0b00111111 */ ), 4);
        }
        return offset;
    });
    // DECODER
    var _Bytes_decode = F2(function(decoder, bytes) {
        try {
            return $elm$core$Maybe$Just(A2(decoder, bytes, 0).b);
        } catch (e) {
            return $elm$core$Maybe$Nothing;
        }
    });
    var _Bytes_read_i8 = F2(function(bytes, offset) {
        return _Utils_Tuple2(offset + 1, bytes.getInt8(offset));
    });
    var _Bytes_read_i16 = F3(function(isLE, bytes, offset) {
        return _Utils_Tuple2(offset + 2, bytes.getInt16(offset, isLE));
    });
    var _Bytes_read_i32 = F3(function(isLE, bytes, offset) {
        return _Utils_Tuple2(offset + 4, bytes.getInt32(offset, isLE));
    });
    var _Bytes_read_u8 = F2(function(bytes, offset) {
        return _Utils_Tuple2(offset + 1, bytes.getUint8(offset));
    });
    var _Bytes_read_u16 = F3(function(isLE, bytes, offset) {
        return _Utils_Tuple2(offset + 2, bytes.getUint16(offset, isLE));
    });
    var _Bytes_read_u32 = F3(function(isLE, bytes, offset) {
        return _Utils_Tuple2(offset + 4, bytes.getUint32(offset, isLE));
    });
    var _Bytes_read_f32 = F3(function(isLE, bytes, offset) {
        return _Utils_Tuple2(offset + 4, bytes.getFloat32(offset, isLE));
    });
    var _Bytes_read_f64 = F3(function(isLE, bytes, offset) {
        return _Utils_Tuple2(offset + 8, bytes.getFloat64(offset, isLE));
    });
    var _Bytes_read_bytes = F3(function(len, bytes, offset) {
        return _Utils_Tuple2(offset + len, new DataView(bytes.buffer, bytes.byteOffset + offset, len));
    });
    var _Bytes_read_string = F3(function(len, bytes, offset) {
        var string = '';
        var end = offset + len;
        for(; offset < end;){
            var byte = bytes.getUint8(offset++);
            string += byte < 128 ? String.fromCharCode(byte) : (byte & 0xE0 /* 0b11100000 */ ) === 0xC0 /* 0b11000000 */  ? String.fromCharCode((byte & 0x1F /* 0b00011111 */ ) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */ ) : (byte & 0xF0 /* 0b11110000 */ ) === 0xE0 /* 0b11100000 */  ? String.fromCharCode((byte & 0xF /* 0b00001111 */ ) << 12 | (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */ ) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */ ) : (byte = ((byte & 0x7 /* 0b00000111 */ ) << 18 | (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */ ) << 12 | (bytes.getUint8(offset++) & 0x3F /* 0b00111111 */ ) << 6 | bytes.getUint8(offset++) & 0x3F /* 0b00111111 */ ) - 0x10000, String.fromCharCode(Math.floor(byte / 0x400) + 0xD800, byte % 0x400 + 0xDC00));
        }
        return _Utils_Tuple2(offset, string);
    });
    var _Bytes_decodeFailure = F2(function() {
        throw 0;
    });
    // STRINGS
    var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString) {
        var smallLength = smallString.length;
        var isGood = offset + smallLength <= bigString.length;
        for(var i = 0; isGood && i < smallLength;){
            var code = bigString.charCodeAt(offset);
            isGood = smallString[i++] === bigString[offset++] && (code === 0x000A /* \n */  ? (row++, col = 1) : (col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1));
        }
        return _Utils_Tuple3(isGood ? offset : -1, row, col);
    });
    // CHARS
    var _Parser_isSubChar = F3(function(predicate, offset, string) {
        return string.length <= offset ? -1 : (string.charCodeAt(offset) & 0xF800) === 0xD800 ? predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1 : predicate(_Utils_chr(string[offset])) ? string[offset] === '\n' ? -2 : offset + 1 : -1;
    });
    var _Parser_isAsciiCode = F3(function(code, offset, string) {
        return string.charCodeAt(offset) === code;
    });
    // NUMBERS
    var _Parser_chompBase10 = F2(function(offset, string) {
        for(; offset < string.length; offset++){
            var code = string.charCodeAt(offset);
            if (code < 0x30 || 0x39 < code) return offset;
        }
        return offset;
    });
    var _Parser_consumeBase = F3(function(base, offset, string) {
        for(var total = 0; offset < string.length; offset++){
            var digit = string.charCodeAt(offset) - 0x30;
            if (digit < 0 || base <= digit) break;
            total = base * total + digit;
        }
        return _Utils_Tuple2(offset, total);
    });
    var _Parser_consumeBase16 = F2(function(offset, string) {
        for(var total = 0; offset < string.length; offset++){
            var code = string.charCodeAt(offset);
            if (0x30 <= code && code <= 0x39) total = 16 * total + code - 0x30;
            else if (0x41 <= code && code <= 0x46) total = 16 * total + code - 55;
            else if (0x61 <= code && code <= 0x66) total = 16 * total + code - 87;
            else break;
        }
        return _Utils_Tuple2(offset, total);
    });
    // FIND STRING
    var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString) {
        var newOffset = bigString.indexOf(smallString, offset);
        var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;
        while(offset < target){
            var code = bigString.charCodeAt(offset++);
            code === 0x000A /* \n */  ? (col = 1, row++) : (col++, (code & 0xF800) === 0xD800 && offset++);
        }
        return _Utils_Tuple3(newOffset, row, col);
    });
    // DECODER
    var _File_decoder = _Json_decodePrim(function(value) {
        // NOTE: checks if `File` exists in case this is run on node
        return typeof File !== 'undefined' && value instanceof File ? $elm$core$Result$Ok(value) : _Json_expecting('a FILE', value);
    });
    // METADATA
    function _File_name(file) {
        return file.name;
    }
    function _File_mime(file) {
        return file.type;
    }
    function _File_size(file) {
        return file.size;
    }
    function _File_lastModified(file) {
        return $elm$time$Time$millisToPosix(file.lastModified);
    }
    // DOWNLOAD
    var _File_downloadNode;
    function _File_getDownloadNode() {
        return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
    }
    var _File_download = F3(function(name, mime, content) {
        return _Scheduler_binding(function(callback) {
            var blob = new Blob([
                content
            ], {
                type: mime
            });
            // for IE10+
            if (navigator.msSaveOrOpenBlob) {
                navigator.msSaveOrOpenBlob(blob, name);
                return;
            }
            // for HTML5
            var node = _File_getDownloadNode();
            var objectUrl = URL.createObjectURL(blob);
            node.href = objectUrl;
            node.download = name;
            _File_click(node);
            URL.revokeObjectURL(objectUrl);
        });
    });
    function _File_downloadUrl(href) {
        return _Scheduler_binding(function(callback) {
            var node = _File_getDownloadNode();
            node.href = href;
            node.download = '';
            node.origin === location.origin || (node.target = '_blank');
            _File_click(node);
        });
    }
    // IE COMPATIBILITY
    function _File_makeBytesSafeForInternetExplorer(bytes) {
        // only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
        // all other browsers can just run `new Blob([bytes])` directly with no problem
        //
        return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    }
    function _File_click(node) {
        // only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
        // all other browsers have MouseEvent and do not need this conditional stuff
        //
        if (typeof MouseEvent === 'function') node.dispatchEvent(new MouseEvent('click'));
        else {
            var event = document.createEvent('MouseEvents');
            event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            document.body.appendChild(node);
            node.dispatchEvent(event);
            document.body.removeChild(node);
        }
    }
    // UPLOAD
    var _File_node;
    function _File_uploadOne(mimes) {
        return _Scheduler_binding(function(callback) {
            _File_node = document.createElement('input');
            _File_node.type = 'file';
            _File_node.accept = A2($elm$core$String$join, ',', mimes);
            _File_node.addEventListener('change', function(event) {
                callback(_Scheduler_succeed(event.target.files[0]));
            });
            _File_click(_File_node);
        });
    }
    function _File_uploadOneOrMore(mimes) {
        return _Scheduler_binding(function(callback) {
            _File_node = document.createElement('input');
            _File_node.type = 'file';
            _File_node.multiple = true;
            _File_node.accept = A2($elm$core$String$join, ',', mimes);
            _File_node.addEventListener('change', function(event) {
                var elmFiles = _List_fromArray(event.target.files);
                callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
            });
            _File_click(_File_node);
        });
    }
    // CONTENT
    function _File_toString(blob) {
        return _Scheduler_binding(function(callback) {
            var reader = new FileReader();
            reader.addEventListener('loadend', function() {
                callback(_Scheduler_succeed(reader.result));
            });
            reader.readAsText(blob);
            return function() {
                reader.abort();
            };
        });
    }
    function _File_toBytes(blob) {
        return _Scheduler_binding(function(callback) {
            var reader = new FileReader();
            reader.addEventListener('loadend', function() {
                callback(_Scheduler_succeed(new DataView(reader.result)));
            });
            reader.readAsArrayBuffer(blob);
            return function() {
                reader.abort();
            };
        });
    }
    function _File_toUrl(blob) {
        return _Scheduler_binding(function(callback) {
            var reader = new FileReader();
            reader.addEventListener('loadend', function() {
                callback(_Scheduler_succeed(reader.result));
            });
            reader.readAsDataURL(blob);
            return function() {
                reader.abort();
            };
        });
    }
    var $elm$core$Maybe$Just = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$core$Maybe$Nothing = {
        $: 1
    };
    var $elm$core$List$cons = _List_cons;
    var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
    var $elm$core$Array$foldr = F3(function(func, baseCase, _v0) {
        var tree = _v0.c;
        var tail = _v0.d;
        var helper = F2(function(node, acc) {
            if (!node.$) {
                var subTree = node.a;
                return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
            } else {
                var values = node.a;
                return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
            }
        });
        return A3($elm$core$Elm$JsArray$foldr, helper, A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail), tree);
    });
    var $elm$core$Array$toList = function(array) {
        return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
    };
    var $elm$core$Dict$foldr = F3(function(func, acc, t) {
        foldr: while(true){
            if (t.$ === -2) return acc;
            else {
                var key = t.b;
                var value = t.c;
                var left = t.d;
                var right = t.e;
                var $temp$func = func, $temp$acc = A3(func, key, value, A3($elm$core$Dict$foldr, func, acc, right)), $temp$t = left;
                func = $temp$func;
                acc = $temp$acc;
                t = $temp$t;
                continue foldr;
            }
        }
    });
    var $elm$core$Dict$toList = function(dict) {
        return A3($elm$core$Dict$foldr, F3(function(key, value, list) {
            return A2($elm$core$List$cons, _Utils_Tuple2(key, value), list);
        }), _List_Nil, dict);
    };
    var $elm$core$Dict$keys = function(dict) {
        return A3($elm$core$Dict$foldr, F3(function(key, value, keyList) {
            return A2($elm$core$List$cons, key, keyList);
        }), _List_Nil, dict);
    };
    var $elm$core$Set$toList = function(_v0) {
        var dict = _v0;
        return $elm$core$Dict$keys(dict);
    };
    var $elm$core$Basics$EQ = 1;
    var $elm$core$Basics$GT = 2;
    var $elm$core$Basics$LT = 0;
    var $elm$core$Result$Err = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$json$Json$Decode$Failure = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $elm$json$Json$Decode$Field = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$json$Json$Decode$Index = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $elm$core$Result$Ok = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$json$Json$Decode$OneOf = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $elm$core$Basics$False = 1;
    var $elm$core$Basics$add = _Basics_add;
    var $elm$core$String$all = _String_all;
    var $elm$core$Basics$and = _Basics_and;
    var $elm$core$Basics$append = _Utils_append;
    var $elm$json$Json$Encode$encode = _Json_encode;
    var $elm$core$String$fromInt = _String_fromNumber;
    var $elm$core$String$join = F2(function(sep, chunks) {
        return A2(_String_join, sep, _List_toArray(chunks));
    });
    var $elm$core$String$split = F2(function(sep, string) {
        return _List_fromArray(A2(_String_split, sep, string));
    });
    var $elm$json$Json$Decode$indent = function(str) {
        return A2($elm$core$String$join, '\n    ', A2($elm$core$String$split, '\n', str));
    };
    var $elm$core$List$foldl = F3(function(func, acc, list) {
        foldl: while(true){
            if (!list.b) return acc;
            else {
                var x = list.a;
                var xs = list.b;
                var $temp$func = func, $temp$acc = A2(func, x, acc), $temp$list = xs;
                func = $temp$func;
                acc = $temp$acc;
                list = $temp$list;
                continue foldl;
            }
        }
    });
    var $elm$core$List$length = function(xs) {
        return A3($elm$core$List$foldl, F2(function(_v0, i) {
            return i + 1;
        }), 0, xs);
    };
    var $elm$core$List$map2 = _List_map2;
    var $elm$core$Basics$le = _Utils_le;
    var $elm$core$Basics$sub = _Basics_sub;
    var $elm$core$List$rangeHelp = F3(function(lo, hi, list) {
        rangeHelp: while(true){
            if (_Utils_cmp(lo, hi) < 1) {
                var $temp$lo = lo, $temp$hi = hi - 1, $temp$list = A2($elm$core$List$cons, hi, list);
                lo = $temp$lo;
                hi = $temp$hi;
                list = $temp$list;
                continue rangeHelp;
            } else return list;
        }
    });
    var $elm$core$List$range = F2(function(lo, hi) {
        return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
    });
    var $elm$core$List$indexedMap = F2(function(f, xs) {
        return A3($elm$core$List$map2, f, A2($elm$core$List$range, 0, $elm$core$List$length(xs) - 1), xs);
    });
    var $elm$core$Char$toCode = _Char_toCode;
    var $elm$core$Char$isLower = function(_char) {
        var code = $elm$core$Char$toCode(_char);
        return 97 <= code && code <= 122;
    };
    var $elm$core$Char$isUpper = function(_char) {
        var code = $elm$core$Char$toCode(_char);
        return code <= 90 && 65 <= code;
    };
    var $elm$core$Basics$or = _Basics_or;
    var $elm$core$Char$isAlpha = function(_char) {
        return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
    };
    var $elm$core$Char$isDigit = function(_char) {
        var code = $elm$core$Char$toCode(_char);
        return code <= 57 && 48 <= code;
    };
    var $elm$core$Char$isAlphaNum = function(_char) {
        return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char);
    };
    var $elm$core$List$reverse = function(list) {
        return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
    };
    var $elm$core$String$uncons = _String_uncons;
    var $elm$json$Json$Decode$errorOneOf = F2(function(i, error) {
        return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent($elm$json$Json$Decode$errorToString(error))));
    });
    var $elm$json$Json$Decode$errorToString = function(error) {
        return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
    };
    var $elm$json$Json$Decode$errorToStringHelp = F2(function(error, context) {
        errorToStringHelp: while(true)switch(error.$){
            case 0:
                var f = error.a;
                var err = error.b;
                var isSimple = function() {
                    var _v1 = $elm$core$String$uncons(f);
                    if (_v1.$ === 1) return false;
                    else {
                        var _v2 = _v1.a;
                        var _char = _v2.a;
                        var rest = _v2.b;
                        return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
                    }
                }();
                var fieldName = isSimple ? '.' + f : '[\'' + (f + '\']');
                var $temp$error = err, $temp$context = A2($elm$core$List$cons, fieldName, context);
                error = $temp$error;
                context = $temp$context;
                continue errorToStringHelp;
            case 1:
                var i = error.a;
                var err = error.b;
                var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
                var $temp$error = err, $temp$context = A2($elm$core$List$cons, indexName, context);
                error = $temp$error;
                context = $temp$context;
                continue errorToStringHelp;
            case 2:
                var errors = error.a;
                if (!errors.b) return 'Ran into a Json.Decode.oneOf with no possibilities' + function() {
                    if (!context.b) return '!';
                    else return ' at json' + A2($elm$core$String$join, '', $elm$core$List$reverse(context));
                }();
                else if (!errors.b.b) {
                    var err = errors.a;
                    var $temp$error = err, $temp$context = context;
                    error = $temp$error;
                    context = $temp$context;
                    continue errorToStringHelp;
                } else {
                    var starter = function() {
                        if (!context.b) return 'Json.Decode.oneOf';
                        else return 'The Json.Decode.oneOf at json' + A2($elm$core$String$join, '', $elm$core$List$reverse(context));
                    }();
                    var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt($elm$core$List$length(errors)) + ' ways:'));
                    return A2($elm$core$String$join, '\n\n', A2($elm$core$List$cons, introduction, A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
                }
            default:
                var msg = error.a;
                var json = error.b;
                var introduction = function() {
                    if (!context.b) return 'Problem with the given value:\n\n';
                    else return 'Problem with the value at json' + (A2($elm$core$String$join, '', $elm$core$List$reverse(context)) + ':\n\n    ');
                }();
                return introduction + ($elm$json$Json$Decode$indent(A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
        }
    });
    var $elm$core$Array$branchFactor = 32;
    var $elm$core$Array$Array_elm_builtin = F4(function(a, b, c, d) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $elm$core$Elm$JsArray$empty = _JsArray_empty;
    var $elm$core$Basics$ceiling = _Basics_ceiling;
    var $elm$core$Basics$fdiv = _Basics_fdiv;
    var $elm$core$Basics$logBase = F2(function(base, number) {
        return _Basics_log(number) / _Basics_log(base);
    });
    var $elm$core$Basics$toFloat = _Basics_toFloat;
    var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
    var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
    var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
    var $elm$core$Array$Leaf = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$core$Basics$apL = F2(function(f, x) {
        return f(x);
    });
    var $elm$core$Basics$apR = F2(function(x, f) {
        return f(x);
    });
    var $elm$core$Basics$eq = _Utils_equal;
    var $elm$core$Basics$floor = _Basics_floor;
    var $elm$core$Elm$JsArray$length = _JsArray_length;
    var $elm$core$Basics$gt = _Utils_gt;
    var $elm$core$Basics$max = F2(function(x, y) {
        return _Utils_cmp(x, y) > 0 ? x : y;
    });
    var $elm$core$Basics$mul = _Basics_mul;
    var $elm$core$Array$SubTree = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
    var $elm$core$Array$compressNodes = F2(function(nodes, acc) {
        compressNodes: while(true){
            var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
            var node = _v0.a;
            var remainingNodes = _v0.b;
            var newAcc = A2($elm$core$List$cons, $elm$core$Array$SubTree(node), acc);
            if (!remainingNodes.b) return $elm$core$List$reverse(newAcc);
            else {
                var $temp$nodes = remainingNodes, $temp$acc = newAcc;
                nodes = $temp$nodes;
                acc = $temp$acc;
                continue compressNodes;
            }
        }
    });
    var $elm$core$Tuple$first = function(_v0) {
        var x = _v0.a;
        return x;
    };
    var $elm$core$Array$treeFromBuilder = F2(function(nodeList, nodeListSize) {
        treeFromBuilder: while(true){
            var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
            if (newNodeSize === 1) return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
            else {
                var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil), $temp$nodeListSize = newNodeSize;
                nodeList = $temp$nodeList;
                nodeListSize = $temp$nodeListSize;
                continue treeFromBuilder;
            }
        }
    });
    var $elm$core$Array$builderToArray = F2(function(reverseNodeList, builder) {
        if (!builder.y) return A4($elm$core$Array$Array_elm_builtin, $elm$core$Elm$JsArray$length(builder.J), $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, builder.J);
        else {
            var treeLen = builder.y * $elm$core$Array$branchFactor;
            var depth = $elm$core$Basics$floor(A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
            var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.R) : builder.R;
            var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.y);
            return A4($elm$core$Array$Array_elm_builtin, $elm$core$Elm$JsArray$length(builder.J) + treeLen, A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep), tree, builder.J);
        }
    });
    var $elm$core$Basics$idiv = _Basics_idiv;
    var $elm$core$Basics$lt = _Utils_lt;
    var $elm$core$Array$initializeHelp = F5(function(fn, fromIndex, len, nodeList, tail) {
        initializeHelp: while(true){
            if (fromIndex < 0) return A2($elm$core$Array$builderToArray, false, {
                R: nodeList,
                y: len / $elm$core$Array$branchFactor | 0,
                J: tail
            });
            else {
                var leaf = $elm$core$Array$Leaf(A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
                var $temp$fn = fn, $temp$fromIndex = fromIndex - $elm$core$Array$branchFactor, $temp$len = len, $temp$nodeList = A2($elm$core$List$cons, leaf, nodeList), $temp$tail = tail;
                fn = $temp$fn;
                fromIndex = $temp$fromIndex;
                len = $temp$len;
                nodeList = $temp$nodeList;
                tail = $temp$tail;
                continue initializeHelp;
            }
        }
    });
    var $elm$core$Basics$remainderBy = _Basics_remainderBy;
    var $elm$core$Array$initialize = F2(function(len, fn) {
        if (len <= 0) return $elm$core$Array$empty;
        else {
            var tailLen = len % $elm$core$Array$branchFactor;
            var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
            var initialFromIndex = len - tailLen - $elm$core$Array$branchFactor;
            return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
        }
    });
    var $elm$core$Basics$True = 0;
    var $elm$core$Result$isOk = function(result) {
        if (!result.$) return true;
        else return false;
    };
    var $elm$json$Json$Decode$andThen = _Json_andThen;
    var $elm$json$Json$Decode$bool = _Json_decodeBool;
    var $elm$core$Basics$composeR = F3(function(f, g, x) {
        return g(f(x));
    });
    var $elm$json$Json$Decode$map = _Json_map1;
    var $elm$json$Json$Decode$map2 = _Json_map2;
    var $elm$json$Json$Decode$succeed = _Json_succeed;
    var $elm$virtual_dom$VirtualDom$toHandlerInt = function(handler) {
        switch(handler.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    };
    var $elm$browser$Browser$External = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$browser$Browser$Internal = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$core$Basics$identity = function(x) {
        return x;
    };
    var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
    var $elm$url$Url$Http = 0;
    var $elm$url$Url$Https = 1;
    var $elm$url$Url$Url = F6(function(protocol, host, port_, path, query, fragment) {
        return {
            adZ: fragment,
            aec: host,
            V6: path,
            WV: port_,
            XH: protocol,
            Bz: query
        };
    });
    var $elm$core$String$contains = _String_contains;
    var $elm$core$String$length = _String_length;
    var $elm$core$String$slice = _String_slice;
    var $elm$core$String$dropLeft = F2(function(n, string) {
        return n < 1 ? string : A3($elm$core$String$slice, n, $elm$core$String$length(string), string);
    });
    var $elm$core$String$indexes = _String_indexes;
    var $elm$core$String$isEmpty = function(string) {
        return string === '';
    };
    var $elm$core$String$left = F2(function(n, string) {
        return n < 1 ? '' : A3($elm$core$String$slice, 0, n, string);
    });
    var $elm$core$String$toInt = _String_toInt;
    var $elm$url$Url$chompBeforePath = F5(function(protocol, path, params, frag, str) {
        if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) return $elm$core$Maybe$Nothing;
        else {
            var _v0 = A2($elm$core$String$indexes, ':', str);
            if (!_v0.b) return $elm$core$Maybe$Just(A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
            else {
                if (!_v0.b.b) {
                    var i = _v0.a;
                    var _v1 = $elm$core$String$toInt(A2($elm$core$String$dropLeft, i + 1, str));
                    if (_v1.$ === 1) return $elm$core$Maybe$Nothing;
                    else {
                        var port_ = _v1;
                        return $elm$core$Maybe$Just(A6($elm$url$Url$Url, protocol, A2($elm$core$String$left, i, str), port_, path, params, frag));
                    }
                } else return $elm$core$Maybe$Nothing;
            }
        }
    });
    var $elm$url$Url$chompBeforeQuery = F4(function(protocol, params, frag, str) {
        if ($elm$core$String$isEmpty(str)) return $elm$core$Maybe$Nothing;
        else {
            var _v0 = A2($elm$core$String$indexes, '/', str);
            if (!_v0.b) return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
            else {
                var i = _v0.a;
                return A5($elm$url$Url$chompBeforePath, protocol, A2($elm$core$String$dropLeft, i, str), params, frag, A2($elm$core$String$left, i, str));
            }
        }
    });
    var $elm$url$Url$chompBeforeFragment = F3(function(protocol, frag, str) {
        if ($elm$core$String$isEmpty(str)) return $elm$core$Maybe$Nothing;
        else {
            var _v0 = A2($elm$core$String$indexes, '?', str);
            if (!_v0.b) return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
            else {
                var i = _v0.a;
                return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Just(A2($elm$core$String$dropLeft, i + 1, str)), frag, A2($elm$core$String$left, i, str));
            }
        }
    });
    var $elm$url$Url$chompAfterProtocol = F2(function(protocol, str) {
        if ($elm$core$String$isEmpty(str)) return $elm$core$Maybe$Nothing;
        else {
            var _v0 = A2($elm$core$String$indexes, '#', str);
            if (!_v0.b) return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
            else {
                var i = _v0.a;
                return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Just(A2($elm$core$String$dropLeft, i + 1, str)), A2($elm$core$String$left, i, str));
            }
        }
    });
    var $elm$core$String$startsWith = _String_startsWith;
    var $elm$url$Url$fromString = function(str) {
        return A2($elm$core$String$startsWith, 'http://', str) ? A2($elm$url$Url$chompAfterProtocol, 0, A2($elm$core$String$dropLeft, 7, str)) : A2($elm$core$String$startsWith, 'https://', str) ? A2($elm$url$Url$chompAfterProtocol, 1, A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing;
    };
    var $elm$core$Basics$never = function(_v0) {
        never: while(true){
            var nvr = _v0;
            var $temp$_v0 = nvr;
            _v0 = $temp$_v0;
            continue never;
        }
    };
    var $elm$core$Task$Perform = $elm$core$Basics$identity;
    var $elm$core$Task$succeed = _Scheduler_succeed;
    var $elm$core$Task$init = $elm$core$Task$succeed(0);
    var $elm$core$List$foldrHelper = F4(function(fn, acc, ctr, ls) {
        if (!ls.b) return acc;
        else {
            var a = ls.a;
            var r1 = ls.b;
            if (!r1.b) return A2(fn, a, acc);
            else {
                var b = r1.a;
                var r2 = r1.b;
                if (!r2.b) return A2(fn, a, A2(fn, b, acc));
                else {
                    var c = r2.a;
                    var r3 = r2.b;
                    if (!r3.b) return A2(fn, a, A2(fn, b, A2(fn, c, acc)));
                    else {
                        var d = r3.a;
                        var r4 = r3.b;
                        var res = ctr > 500 ? A3($elm$core$List$foldl, fn, acc, $elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
                        return A2(fn, a, A2(fn, b, A2(fn, c, A2(fn, d, res))));
                    }
                }
            }
        }
    });
    var $elm$core$List$foldr = F3(function(fn, acc, ls) {
        return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
    });
    var $elm$core$List$map = F2(function(f, xs) {
        return A3($elm$core$List$foldr, F2(function(x, acc) {
            return A2($elm$core$List$cons, f(x), acc);
        }), _List_Nil, xs);
    });
    var $elm$core$Task$andThen = _Scheduler_andThen;
    var $elm$core$Task$map = F2(function(func, taskA) {
        return A2($elm$core$Task$andThen, function(a) {
            return $elm$core$Task$succeed(func(a));
        }, taskA);
    });
    var $elm$core$Task$map2 = F3(function(func, taskA, taskB) {
        return A2($elm$core$Task$andThen, function(a) {
            return A2($elm$core$Task$andThen, function(b) {
                return $elm$core$Task$succeed(A2(func, a, b));
            }, taskB);
        }, taskA);
    });
    var $elm$core$Task$sequence = function(tasks) {
        return A3($elm$core$List$foldr, $elm$core$Task$map2($elm$core$List$cons), $elm$core$Task$succeed(_List_Nil), tasks);
    };
    var $elm$core$Platform$sendToApp = _Platform_sendToApp;
    var $elm$core$Task$spawnCmd = F2(function(router, _v0) {
        var task = _v0;
        return _Scheduler_spawn(A2($elm$core$Task$andThen, $elm$core$Platform$sendToApp(router), task));
    });
    var $elm$core$Task$onEffects = F3(function(router, commands, state) {
        return A2($elm$core$Task$map, function(_v0) {
            return 0;
        }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Task$spawnCmd(router), commands)));
    });
    var $elm$core$Task$onSelfMsg = F3(function(_v0, _v1, _v2) {
        return $elm$core$Task$succeed(0);
    });
    var $elm$core$Task$cmdMap = F2(function(tagger, _v0) {
        var task = _v0;
        return A2($elm$core$Task$map, tagger, task);
    });
    _Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
    var $elm$core$Task$command = _Platform_leaf('Task');
    var $elm$core$Task$perform = F2(function(toMessage, task) {
        return $elm$core$Task$command(A2($elm$core$Task$map, toMessage, task));
    });
    var $elm$browser$Browser$element = _Browser_element;
    var $elm$json$Json$Decode$field = _Json_decodeField;
    var $elm$json$Json$Decode$index = _Json_decodeIndex;
    var $author$project$Main$Layout = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Main$Model = F5(function(shared, route, page, layout, loadClinicalDebouncer) {
        return {
            ba: layout,
            rl: loadClinicalDebouncer,
            GM: page,
            d: route,
            Cu: shared
        };
    });
    var $author$project$Main$Pages = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Main$Shared = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $elm$core$Platform$Cmd$batch = _Platform_batch;
    var $author$project$Spa$Generated$Route$NotFound = {
        $: 9
    };
    var $elm$url$Url$Parser$State = F5(function(visited, unvisited, params, frag, value) {
        return {
            iK: frag,
            VU: params,
            hb: unvisited,
            aa9: value,
            kN: visited
        };
    });
    var $elm$url$Url$Parser$getFirstMatch = function(states) {
        getFirstMatch: while(true){
            if (!states.b) return $elm$core$Maybe$Nothing;
            else {
                var state = states.a;
                var rest = states.b;
                var _v1 = state.hb;
                if (!_v1.b) return $elm$core$Maybe$Just(state.aa9);
                else {
                    if (_v1.a === '' && !_v1.b.b) return $elm$core$Maybe$Just(state.aa9);
                    else {
                        var $temp$states = rest;
                        states = $temp$states;
                        continue getFirstMatch;
                    }
                }
            }
        }
    };
    var $elm$url$Url$Parser$removeFinalEmpty = function(segments) {
        if (!segments.b) return _List_Nil;
        else {
            if (segments.a === '' && !segments.b.b) return _List_Nil;
            else {
                var segment = segments.a;
                var rest = segments.b;
                return A2($elm$core$List$cons, segment, $elm$url$Url$Parser$removeFinalEmpty(rest));
            }
        }
    };
    var $elm$url$Url$Parser$preparePath = function(path) {
        var _v0 = A2($elm$core$String$split, '/', path);
        if (_v0.b && _v0.a === '') {
            var segments = _v0.b;
            return $elm$url$Url$Parser$removeFinalEmpty(segments);
        } else {
            var segments = _v0;
            return $elm$url$Url$Parser$removeFinalEmpty(segments);
        }
    };
    var $elm$url$Url$Parser$addToParametersHelp = F2(function(value, maybeList) {
        if (maybeList.$ === 1) return $elm$core$Maybe$Just(_List_fromArray([
            value
        ]));
        else {
            var list = maybeList.a;
            return $elm$core$Maybe$Just(A2($elm$core$List$cons, value, list));
        }
    });
    var $elm$url$Url$percentDecode = _Url_percentDecode;
    var $elm$core$Basics$compare = _Utils_compare;
    var $elm$core$Dict$get = F2(function(targetKey, dict) {
        get: while(true){
            if (dict.$ === -2) return $elm$core$Maybe$Nothing;
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var _v1 = A2($elm$core$Basics$compare, targetKey, key);
                switch(_v1){
                    case 0:
                        var $temp$targetKey = targetKey, $temp$dict = left;
                        targetKey = $temp$targetKey;
                        dict = $temp$dict;
                        continue get;
                    case 1:
                        return $elm$core$Maybe$Just(value);
                    default:
                        var $temp$targetKey = targetKey, $temp$dict = right;
                        targetKey = $temp$targetKey;
                        dict = $temp$dict;
                        continue get;
                }
            }
        }
    });
    var $elm$core$Dict$Black = 1;
    var $elm$core$Dict$RBNode_elm_builtin = F5(function(a, b, c, d, e) {
        return {
            $: -1,
            a: a,
            b: b,
            c: c,
            d: d,
            e: e
        };
    });
    var $elm$core$Dict$RBEmpty_elm_builtin = {
        $: -2
    };
    var $elm$core$Dict$Red = 0;
    var $elm$core$Dict$balance = F5(function(color, key, value, left, right) {
        if (right.$ === -1 && !right.a) {
            var _v1 = right.a;
            var rK = right.b;
            var rV = right.c;
            var rLeft = right.d;
            var rRight = right.e;
            if (left.$ === -1 && !left.a) {
                var _v3 = left.a;
                var lK = left.b;
                var lV = left.c;
                var lLeft = left.d;
                var lRight = left.e;
                return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
            } else return A5($elm$core$Dict$RBNode_elm_builtin, color, rK, rV, A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft), rRight);
        } else {
            if (left.$ === -1 && !left.a && left.d.$ === -1 && !left.d.a) {
                var _v5 = left.a;
                var lK = left.b;
                var lV = left.c;
                var _v6 = left.d;
                var _v7 = _v6.a;
                var llK = _v6.b;
                var llV = _v6.c;
                var llLeft = _v6.d;
                var llRight = _v6.e;
                var lRight = left.e;
                return A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
            } else return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
        }
    });
    var $elm$core$Dict$insertHelp = F3(function(key, value, dict) {
        if (dict.$ === -2) return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
        else {
            var nColor = dict.a;
            var nKey = dict.b;
            var nValue = dict.c;
            var nLeft = dict.d;
            var nRight = dict.e;
            var _v1 = A2($elm$core$Basics$compare, key, nKey);
            switch(_v1){
                case 0:
                    return A5($elm$core$Dict$balance, nColor, nKey, nValue, A3($elm$core$Dict$insertHelp, key, value, nLeft), nRight);
                case 1:
                    return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
                default:
                    return A5($elm$core$Dict$balance, nColor, nKey, nValue, nLeft, A3($elm$core$Dict$insertHelp, key, value, nRight));
            }
        }
    });
    var $elm$core$Dict$insert = F3(function(key, value, dict) {
        var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
        if (_v0.$ === -1 && !_v0.a) {
            var _v1 = _v0.a;
            var k = _v0.b;
            var v = _v0.c;
            var l = _v0.d;
            var r = _v0.e;
            return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
        } else {
            var x = _v0;
            return x;
        }
    });
    var $elm$core$Dict$getMin = function(dict) {
        getMin: while(true){
            if (dict.$ === -1 && dict.d.$ === -1) {
                var left = dict.d;
                var $temp$dict = left;
                dict = $temp$dict;
                continue getMin;
            } else return dict;
        }
    };
    var $elm$core$Dict$moveRedLeft = function(dict) {
        if (dict.$ === -1 && dict.d.$ === -1 && dict.e.$ === -1) {
            if (dict.e.d.$ === -1 && !dict.e.d.a) {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v1 = dict.d;
                var lClr = _v1.a;
                var lK = _v1.b;
                var lV = _v1.c;
                var lLeft = _v1.d;
                var lRight = _v1.e;
                var _v2 = dict.e;
                var rClr = _v2.a;
                var rK = _v2.b;
                var rV = _v2.c;
                var rLeft = _v2.d;
                var _v3 = rLeft.a;
                var rlK = rLeft.b;
                var rlV = rLeft.c;
                var rlL = rLeft.d;
                var rlR = rLeft.e;
                var rRight = _v2.e;
                return A5($elm$core$Dict$RBNode_elm_builtin, 0, rlK, rlV, A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), rlL), A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
            } else {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v4 = dict.d;
                var lClr = _v4.a;
                var lK = _v4.b;
                var lV = _v4.c;
                var lLeft = _v4.d;
                var lRight = _v4.e;
                var _v5 = dict.e;
                var rClr = _v5.a;
                var rK = _v5.b;
                var rV = _v5.c;
                var rLeft = _v5.d;
                var rRight = _v5.e;
                if (clr === 1) return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
                else return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
            }
        } else return dict;
    };
    var $elm$core$Dict$moveRedRight = function(dict) {
        if (dict.$ === -1 && dict.d.$ === -1 && dict.e.$ === -1) {
            if (dict.d.d.$ === -1 && !dict.d.d.a) {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v1 = dict.d;
                var lClr = _v1.a;
                var lK = _v1.b;
                var lV = _v1.c;
                var _v2 = _v1.d;
                var _v3 = _v2.a;
                var llK = _v2.b;
                var llV = _v2.c;
                var llLeft = _v2.d;
                var llRight = _v2.e;
                var lRight = _v1.e;
                var _v4 = dict.e;
                var rClr = _v4.a;
                var rK = _v4.b;
                var rV = _v4.c;
                var rLeft = _v4.d;
                var rRight = _v4.e;
                return A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight), A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, lRight, A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
            } else {
                var clr = dict.a;
                var k = dict.b;
                var v = dict.c;
                var _v5 = dict.d;
                var lClr = _v5.a;
                var lK = _v5.b;
                var lV = _v5.c;
                var lLeft = _v5.d;
                var lRight = _v5.e;
                var _v6 = dict.e;
                var rClr = _v6.a;
                var rK = _v6.b;
                var rV = _v6.c;
                var rLeft = _v6.d;
                var rRight = _v6.e;
                if (clr === 1) return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
                else return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight), A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
            }
        } else return dict;
    };
    var $elm$core$Dict$removeHelpPrepEQGT = F7(function(targetKey, dict, color, key, value, left, right) {
        if (left.$ === -1 && !left.a) {
            var _v1 = left.a;
            var lK = left.b;
            var lV = left.c;
            var lLeft = left.d;
            var lRight = left.e;
            return A5($elm$core$Dict$RBNode_elm_builtin, color, lK, lV, lLeft, A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
        } else {
            _v2$2: while(true){
                if (right.$ === -1 && right.a === 1) {
                    if (right.d.$ === -1) {
                        if (right.d.a === 1) {
                            var _v3 = right.a;
                            var _v4 = right.d;
                            var _v5 = _v4.a;
                            return $elm$core$Dict$moveRedRight(dict);
                        } else break _v2$2;
                    } else {
                        var _v6 = right.a;
                        var _v7 = right.d;
                        return $elm$core$Dict$moveRedRight(dict);
                    }
                } else break _v2$2;
            }
            return dict;
        }
    });
    var $elm$core$Dict$removeMin = function(dict) {
        if (dict.$ === -1 && dict.d.$ === -1) {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var lColor = left.a;
            var lLeft = left.d;
            var right = dict.e;
            if (lColor === 1) {
                if (lLeft.$ === -1 && !lLeft.a) {
                    var _v3 = lLeft.a;
                    return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, $elm$core$Dict$removeMin(left), right);
                } else {
                    var _v4 = $elm$core$Dict$moveRedLeft(dict);
                    if (_v4.$ === -1) {
                        var nColor = _v4.a;
                        var nKey = _v4.b;
                        var nValue = _v4.c;
                        var nLeft = _v4.d;
                        var nRight = _v4.e;
                        return A5($elm$core$Dict$balance, nColor, nKey, nValue, $elm$core$Dict$removeMin(nLeft), nRight);
                    } else return $elm$core$Dict$RBEmpty_elm_builtin;
                }
            } else return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, $elm$core$Dict$removeMin(left), right);
        } else return $elm$core$Dict$RBEmpty_elm_builtin;
    };
    var $elm$core$Dict$removeHelp = F2(function(targetKey, dict) {
        if (dict.$ === -2) return $elm$core$Dict$RBEmpty_elm_builtin;
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            if (_Utils_cmp(targetKey, key) < 0) {
                if (left.$ === -1 && left.a === 1) {
                    var _v4 = left.a;
                    var lLeft = left.d;
                    if (lLeft.$ === -1 && !lLeft.a) {
                        var _v6 = lLeft.a;
                        return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, A2($elm$core$Dict$removeHelp, targetKey, left), right);
                    } else {
                        var _v7 = $elm$core$Dict$moveRedLeft(dict);
                        if (_v7.$ === -1) {
                            var nColor = _v7.a;
                            var nKey = _v7.b;
                            var nValue = _v7.c;
                            var nLeft = _v7.d;
                            var nRight = _v7.e;
                            return A5($elm$core$Dict$balance, nColor, nKey, nValue, A2($elm$core$Dict$removeHelp, targetKey, nLeft), nRight);
                        } else return $elm$core$Dict$RBEmpty_elm_builtin;
                    }
                } else return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, A2($elm$core$Dict$removeHelp, targetKey, left), right);
            } else return A2($elm$core$Dict$removeHelpEQGT, targetKey, A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
        }
    });
    var $elm$core$Dict$removeHelpEQGT = F2(function(targetKey, dict) {
        if (dict.$ === -1) {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            if (_Utils_eq(targetKey, key)) {
                var _v1 = $elm$core$Dict$getMin(right);
                if (_v1.$ === -1) {
                    var minKey = _v1.b;
                    var minValue = _v1.c;
                    return A5($elm$core$Dict$balance, color, minKey, minValue, left, $elm$core$Dict$removeMin(right));
                } else return $elm$core$Dict$RBEmpty_elm_builtin;
            } else return A5($elm$core$Dict$balance, color, key, value, left, A2($elm$core$Dict$removeHelp, targetKey, right));
        } else return $elm$core$Dict$RBEmpty_elm_builtin;
    });
    var $elm$core$Dict$remove = F2(function(key, dict) {
        var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
        if (_v0.$ === -1 && !_v0.a) {
            var _v1 = _v0.a;
            var k = _v0.b;
            var v = _v0.c;
            var l = _v0.d;
            var r = _v0.e;
            return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
        } else {
            var x = _v0;
            return x;
        }
    });
    var $elm$core$Dict$update = F3(function(targetKey, alter, dictionary) {
        var _v0 = alter(A2($elm$core$Dict$get, targetKey, dictionary));
        if (!_v0.$) {
            var value = _v0.a;
            return A3($elm$core$Dict$insert, targetKey, value, dictionary);
        } else return A2($elm$core$Dict$remove, targetKey, dictionary);
    });
    var $elm$url$Url$Parser$addParam = F2(function(segment, dict) {
        var _v0 = A2($elm$core$String$split, '=', segment);
        if (_v0.b && _v0.b.b && !_v0.b.b.b) {
            var rawKey = _v0.a;
            var _v1 = _v0.b;
            var rawValue = _v1.a;
            var _v2 = $elm$url$Url$percentDecode(rawKey);
            if (_v2.$ === 1) return dict;
            else {
                var key = _v2.a;
                var _v3 = $elm$url$Url$percentDecode(rawValue);
                if (_v3.$ === 1) return dict;
                else {
                    var value = _v3.a;
                    return A3($elm$core$Dict$update, key, $elm$url$Url$Parser$addToParametersHelp(value), dict);
                }
            }
        } else return dict;
    });
    var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
    var $elm$url$Url$Parser$prepareQuery = function(maybeQuery) {
        if (maybeQuery.$ === 1) return $elm$core$Dict$empty;
        else {
            var qry = maybeQuery.a;
            return A3($elm$core$List$foldr, $elm$url$Url$Parser$addParam, $elm$core$Dict$empty, A2($elm$core$String$split, '&', qry));
        }
    };
    var $elm$url$Url$Parser$parse = F2(function(_v0, url) {
        var parser = _v0;
        return $elm$url$Url$Parser$getFirstMatch(parser(A5($elm$url$Url$Parser$State, _List_Nil, $elm$url$Url$Parser$preparePath(url.V6), $elm$url$Url$Parser$prepareQuery(url.Bz), url.adZ, $elm$core$Basics$identity)));
    });
    var $author$project$Spa$Generated$Route$Admin__AdvanceBilling = {
        $: 20
    };
    var $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields = {
        $: 198
    };
    var $author$project$Spa$Generated$Route$Admin__Athenahealth__Link = {
        $: 199
    };
    var $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations = {
        $: 200
    };
    var $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview = {
        $: 201
    };
    var $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers = {
        $: 202
    };
    var $author$project$Spa$Generated$Route$Admin__Athenahealth__Top = {
        $: 167
    };
    var $author$project$Spa$Generated$Route$Admin__Billing = {
        $: 21
    };
    var $author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String = function(a) {
        return {
            $: 316,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__CancellationReasons = {
        $: 22
    };
    var $author$project$Spa$Generated$Route$Admin__CardReaders = {
        $: 23
    };
    var $author$project$Spa$Generated$Route$Admin__Categories = {
        $: 24
    };
    var $author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String = function(a) {
        return {
            $: 274,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__ChargeItems__New = {
        $: 203
    };
    var $author$project$Spa$Generated$Route$Admin__ChargeItems__Top = {
        $: 168
    };
    var $author$project$Spa$Generated$Route$Admin__ChargeItems__Upload = {
        $: 204
    };
    var $author$project$Spa$Generated$Route$Admin__Commissions = {
        $: 25
    };
    var $author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String = function(a) {
        return {
            $: 275,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__CompanyPlans__New = {
        $: 205
    };
    var $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top = {
        $: 169
    };
    var $author$project$Spa$Generated$Route$Admin__Coupons = {
        $: 26
    };
    var $author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String = function(a) {
        return {
            $: 276,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__CoveragePlans__New = {
        $: 206
    };
    var $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top = {
        $: 170
    };
    var $author$project$Spa$Generated$Route$Admin__CreditCategories = {
        $: 27
    };
    var $author$project$Spa$Generated$Route$Admin__Credits__Upload = {
        $: 207
    };
    var $author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String = function(a) {
        return {
            $: 278,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__DataExportSettings__New = {
        $: 208
    };
    var $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top = {
        $: 172
    };
    var $author$project$Spa$Generated$Route$Admin__DataExport__Id_String = function(a) {
        return {
            $: 277,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__DataExport__Top = {
        $: 171
    };
    var $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys = {
        $: 209
    };
    var $author$project$Spa$Generated$Route$Admin__Developers__GetStarted = {
        $: 210
    };
    var $author$project$Spa$Generated$Route$Admin__Developers__Sandboxes = {
        $: 211
    };
    var $author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints = {
        $: 212
    };
    var $author$project$Spa$Generated$Route$Admin__Documents__Id_String = function(a) {
        return {
            $: 279,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__Documents__New = {
        $: 213
    };
    var $author$project$Spa$Generated$Route$Admin__Documents__Top = {
        $: 173
    };
    var $author$project$Spa$Generated$Route$Admin__ElationLegacy = {
        $: 28
    };
    var $author$project$Spa$Generated$Route$Admin__Elation__Link = {
        $: 214
    };
    var $author$project$Spa$Generated$Route$Admin__Elation__Overview = {
        $: 215
    };
    var $author$project$Spa$Generated$Route$Admin__Elation__Providers = {
        $: 216
    };
    var $author$project$Spa$Generated$Route$Admin__Elation__Top = {
        $: 174
    };
    var $author$project$Spa$Generated$Route$Admin__Features = {
        $: 29
    };
    var $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations = {
        $: 30
    };
    var $author$project$Spa$Generated$Route$Admin__Integrations__Slug_String = function(a) {
        return {
            $: 280,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__InternalSettings = {
        $: 31
    };
    var $author$project$Spa$Generated$Route$Admin__InvoiceSettings = {
        $: 32
    };
    var $author$project$Spa$Generated$Route$Admin__LeadSources = {
        $: 33
    };
    var $author$project$Spa$Generated$Route$Admin__Locations = {
        $: 34
    };
    var $author$project$Spa$Generated$Route$Admin__Mailgun = {
        $: 35
    };
    var $author$project$Spa$Generated$Route$Admin__Notes = {
        $: 36
    };
    var $author$project$Spa$Generated$Route$Admin__Notifications__Company = {
        $: 217
    };
    var $author$project$Spa$Generated$Route$Admin__Notifications__Employee = {
        $: 218
    };
    var $author$project$Spa$Generated$Route$Admin__Notifications__Membership = {
        $: 219
    };
    var $author$project$Spa$Generated$Route$Admin__Notifications__Patient = {
        $: 220
    };
    var $author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule = {
        $: 302
    };
    var $author$project$Spa$Generated$Route$Admin__Notifications__Practice = {
        $: 221
    };
    var $author$project$Spa$Generated$Route$Admin__Notifications__Settings = {
        $: 222
    };
    var $author$project$Spa$Generated$Route$Admin__Patients = {
        $: 37
    };
    var $author$project$Spa$Generated$Route$Admin__PaymentMethodImport = {
        $: 38
    };
    var $author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload = {
        $: 223
    };
    var $author$project$Spa$Generated$Route$Admin__PaymentProcessing = {
        $: 39
    };
    var $author$project$Spa$Generated$Route$Admin__PaymentSources = {
        $: 40
    };
    var $author$project$Spa$Generated$Route$Admin__Plans__Id_String = function(a) {
        return {
            $: 281,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New = function(a) {
        return {
            $: 328,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String = function(a) {
        return {
            $: 332,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__Plans__New = {
        $: 224
    };
    var $author$project$Spa$Generated$Route$Admin__Plans__Top = {
        $: 175
    };
    var $author$project$Spa$Generated$Route$Admin__Practice = {
        $: 41
    };
    var $author$project$Spa$Generated$Route$Admin__ProviderGroups = {
        $: 42
    };
    var $author$project$Spa$Generated$Route$Admin__Providers__Top = {
        $: 176
    };
    var $author$project$Spa$Generated$Route$Admin__Providers__Upload = {
        $: 225
    };
    var $author$project$Spa$Generated$Route$Admin__Quickbooks__Top = {
        $: 177
    };
    var $author$project$Spa$Generated$Route$Admin__ScheduledJobs = {
        $: 43
    };
    var $author$project$Spa$Generated$Route$Admin__SelfService = {
        $: 44
    };
    var $author$project$Spa$Generated$Route$Admin__Signup = {
        $: 45
    };
    var $author$project$Spa$Generated$Route$Admin__SignupPages__Id_String = function(a) {
        return {
            $: 282,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Admin__SignupPages__New = {
        $: 226
    };
    var $author$project$Spa$Generated$Route$Admin__SignupPages__Top = {
        $: 178
    };
    var $author$project$Spa$Generated$Route$Admin__Stripe = {
        $: 46
    };
    var $author$project$Spa$Generated$Route$Admin__Taxes = {
        $: 47
    };
    var $author$project$Spa$Generated$Route$Admin__Team = {
        $: 48
    };
    var $author$project$Spa$Generated$Route$Admin__Team__New = {
        $: 227
    };
    var $author$project$Spa$Generated$Route$AffiliateBills__Top = {
        $: 11
    };
    var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions = function(a) {
        return {
            $: 228,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String = function(a) {
        return {
            $: 317,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top = function(a) {
        return {
            $: 290,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders = function(a) {
        return {
            $: 229,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders = function(a) {
        return {
            $: 230,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients = function(a) {
        return {
            $: 231,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings = function(a) {
        return {
            $: 232,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users = function(a) {
        return {
            $: 233,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Affiliates__Create = {
        $: 49
    };
    var $author$project$Spa$Generated$Route$Affiliates__New = {
        $: 50
    };
    var $author$project$Spa$Generated$Route$Affiliates__Top = {
        $: 12
    };
    var $author$project$Spa$Generated$Route$Apps__Slug_String = function(a) {
        return {
            $: 163,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Blank = {
        $: 1
    };
    var $author$project$Spa$Generated$Route$Bookkeeping = {
        $: 2
    };
    var $author$project$Spa$Generated$Route$Calendar = {
        $: 3
    };
    var $author$project$Spa$Generated$Route$Charges__New = {
        $: 51
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top = function(a) {
        return {
            $: 334,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended = function(a) {
        return {
            $: 329,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New = function(a) {
        return {
            $: 330,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top = function(a) {
        return {
            $: 322,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals = function(a) {
        return {
            $: 303,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals = function(a) {
        return {
            $: 304,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String = function(a) {
        return {
            $: 333,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top = function(a) {
        return {
            $: 323,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top = function(a) {
        return {
            $: 291,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New = {
        $: 234
    };
    var $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top = {
        $: 179
    };
    var $author$project$Spa$Generated$Route$Commissions__StatementLines__Summary = {
        $: 235
    };
    var $author$project$Spa$Generated$Route$Commissions__StatementLines__Top = {
        $: 180
    };
    var $author$project$Spa$Generated$Route$Commissions__Statements = {
        $: 52
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing = function(a) {
        return {
            $: 236,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas = function(a) {
        return {
            $: 237,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create = function(a) {
        return {
            $: 305,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top = function(a) {
        return {
            $: 335,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top = function(a) {
        return {
            $: 292,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions = function(a) {
        return {
            $: 238,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings = function(a) {
        return {
            $: 239,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String = function(a) {
        return {
            $: 318,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top = function(a) {
        return {
            $: 293,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes = function(a) {
        return {
            $: 240,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications = function(a) {
        return {
            $: 241,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources = function(a) {
        return {
            $: 242,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup = function(a) {
        return {
            $: 243,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String = function(a) {
        return {
            $: 319,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New = function(a) {
        return {
            $: 306,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top = function(a) {
        return {
            $: 181,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top = function(a) {
        return {
            $: 294,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top = function(a) {
        return {
            $: 324,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults = function(a) {
        return {
            $: 331,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Companies__New = {
        $: 53
    };
    var $author$project$Spa$Generated$Route$Companies__Top = {
        $: 13
    };
    var $author$project$Spa$Generated$Route$Contacts__ContactId_String__Top = function(a) {
        return {
            $: 182,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Contacts__List = {
        $: 54
    };
    var $author$project$Spa$Generated$Route$Contacts__New = {
        $: 55
    };
    var $author$project$Spa$Generated$Route$Error__Status_String = function(a) {
        return {
            $: 164,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Files__Public = {
        $: 56
    };
    var $author$project$Spa$Generated$Route$Files__Top = {
        $: 14
    };
    var $author$project$Spa$Generated$Route$Forms = {
        $: 4
    };
    var $author$project$Spa$Generated$Route$GoogleCallback = {
        $: 5
    };
    var $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String = function(a) {
        return {
            $: 283,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top = {
        $: 183
    };
    var $author$project$Spa$Generated$Route$Hinter__ClonePractice = {
        $: 57
    };
    var $author$project$Spa$Generated$Route$Hinter__Disputes = {
        $: 58
    };
    var $author$project$Spa$Generated$Route$Hinter__FeatureFlags = {
        $: 59
    };
    var $author$project$Spa$Generated$Route$Hinter__NewGroup = {
        $: 60
    };
    var $author$project$Spa$Generated$Route$Hinter__NewPartner = {
        $: 61
    };
    var $author$project$Spa$Generated$Route$Hinter__NewPractice = {
        $: 62
    };
    var $author$project$Spa$Generated$Route$Home = {
        $: 6
    };
    var $author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top = function(a) {
        return {
            $: 184,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Inventory__List = {
        $: 63
    };
    var $author$project$Spa$Generated$Route$Inventory__New = {
        $: 64
    };
    var $author$project$Spa$Generated$Route$Inventory__Settings = {
        $: 65
    };
    var $author$project$Spa$Generated$Route$Join__Token_String = function(a) {
        return {
            $: 165,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Login = {
        $: 7
    };
    var $author$project$Spa$Generated$Route$Logout = {
        $: 8
    };
    var $author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings = {
        $: 307
    };
    var $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings = {
        $: 308
    };
    var $author$project$Spa$Generated$Route$Marketplace__Manage = {
        $: 66
    };
    var $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings = {
        $: 309
    };
    var $author$project$Spa$Generated$Route$Marketplace__Slug_String = function(a) {
        return {
            $: 166,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding = function(a) {
        return {
            $: 310,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings = function(a) {
        return {
            $: 311,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users = function(a) {
        return {
            $: 312,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Marketplace__Top = {
        $: 15
    };
    var $author$project$Spa$Generated$Route$Messages__Calls = {
        $: 67
    };
    var $author$project$Spa$Generated$Route$Messages__Chat = {
        $: 68
    };
    var $author$project$Spa$Generated$Route$Messages__Drafts = {
        $: 69
    };
    var $author$project$Spa$Generated$Route$Messages__Faxes__New = {
        $: 244
    };
    var $author$project$Spa$Generated$Route$Messages__Faxes__Top = {
        $: 185
    };
    var $author$project$Spa$Generated$Route$Messages__Forms = {
        $: 70
    };
    var $author$project$Spa$Generated$Route$Messages__Labs = {
        $: 71
    };
    var $author$project$Spa$Generated$Route$Messages__Scheduled__New = {
        $: 245
    };
    var $author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top = function(a) {
        return {
            $: 295,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Messages__Scheduled__Top = {
        $: 186
    };
    var $author$project$Spa$Generated$Route$Messages__Sms = {
        $: 72
    };
    var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String = function(a) {
        return {
            $: 284,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New = {
        $: 246
    };
    var $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top = {
        $: 187
    };
    var $author$project$Spa$Generated$Route$NewSettings__BlockedPhoneNumbers = {
        $: 73
    };
    var $author$project$Spa$Generated$Route$NewSettings__BookingOverview = {
        $: 74
    };
    var $author$project$Spa$Generated$Route$NewSettings__Erx = {
        $: 75
    };
    var $author$project$Spa$Generated$Route$NewSettings__Export = {
        $: 76
    };
    var $author$project$Spa$Generated$Route$NewSettings__HinterSettings = {
        $: 77
    };
    var $author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String = function(a) {
        return {
            $: 285,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$NewSettings__Locations__New__LocationId_String = function(a) {
        return {
            $: 320,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$NewSettings__Locations__Top = {
        $: 188
    };
    var $author$project$Spa$Generated$Route$NewSettings__PracticeInfo = {
        $: 78
    };
    var $author$project$Spa$Generated$Route$NewSettings__Team = {
        $: 79
    };
    var $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String = function(a) {
        return {
            $: 286,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo = function(a) {
        return {
            $: 313,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$NewSettings__Templates__New = {
        $: 247
    };
    var $author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String = function(a) {
        return {
            $: 287,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$NewSettings__Templates__Top = {
        $: 189
    };
    var $author$project$Spa$Generated$Route$Oauth__Callback = {
        $: 80
    };
    var $author$project$Spa$Generated$Route$Onboard__DealId_String__Top = function(a) {
        return {
            $: 190,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed = function(a) {
        return {
            $: 248,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing = function(a) {
        return {
            $: 249,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment = function(a) {
        return {
            $: 250,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Onboard__OnboardId_String__User = function(a) {
        return {
            $: 251,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Onboarding = {
        $: 10
    };
    var $author$project$Spa$Generated$Route$Partner__ApiKeys = {
        $: 81
    };
    var $author$project$Spa$Generated$Route$Partner__Billing = {
        $: 82
    };
    var $author$project$Spa$Generated$Route$Partner__Billing__Hinter = {
        $: 252
    };
    var $author$project$Spa$Generated$Route$Partner__Dashboard__Top = {
        $: 191
    };
    var $author$project$Spa$Generated$Route$Partner__Engagements = {
        $: 83
    };
    var $author$project$Spa$Generated$Route$Partner__Hinter = {
        $: 84
    };
    var $author$project$Spa$Generated$Route$Partner__Practices__Top = {
        $: 192
    };
    var $author$project$Spa$Generated$Route$Partner__Product = {
        $: 85
    };
    var $author$project$Spa$Generated$Route$Partner__Product__ActivationSettings = {
        $: 253
    };
    var $author$project$Spa$Generated$Route$Partner__Product__AppSettings = {
        $: 254
    };
    var $author$project$Spa$Generated$Route$Partner__Product__Hinter = {
        $: 255
    };
    var $author$project$Spa$Generated$Route$Partner__Product__New = {
        $: 256
    };
    var $author$project$Spa$Generated$Route$Partner__Sandboxes__Top = {
        $: 193
    };
    var $author$project$Spa$Generated$Route$Partner__Team = {
        $: 86
    };
    var $author$project$Spa$Generated$Route$Partner__Webhooks__Requests = {
        $: 257
    };
    var $author$project$Spa$Generated$Route$Partner__Webhooks__Settings = {
        $: 258
    };
    var $author$project$Spa$Generated$Route$Patients__Create = {
        $: 87
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top = function(a) {
        return {
            $: 296,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top = function(a) {
        return {
            $: 297,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top = function(a) {
        return {
            $: 325,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top = function(a) {
        return {
            $: 326,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top = function(a) {
        return {
            $: 298,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Chart = function(a) {
        return {
            $: 259,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Edit = function(a) {
        return {
            $: 260,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__GrowthChart = function(a) {
        return {
            $: 261,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__LabTrends = function(a) {
        return {
            $: 262,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits = function(a) {
        return {
            $: 263,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top = function(a) {
        return {
            $: 327,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New = function(a) {
        return {
            $: 314,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top = function(a) {
        return {
            $: 299,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Merge = function(a) {
        return {
            $: 264,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__NoteId_String = function(a) {
        return {
            $: 321,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top = function(a) {
        return {
            $: 300,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top = function(a) {
        return {
            $: 301,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__Top = function(a) {
        return {
            $: 194,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__PatientId_String__VitalsTrends = function(a) {
        return {
            $: 265,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Patients__Top = {
        $: 16
    };
    var $author$project$Spa$Generated$Route$Patients__Upload = {
        $: 88
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Account = {
        $: 89
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Communications = {
        $: 90
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Complete = {
        $: 91
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Documents = {
        $: 92
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Legal = {
        $: 93
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing = {
        $: 94
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Plans = {
        $: 95
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit = function(a) {
        return {
            $: 315,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Plans__New = {
        $: 266
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Team = {
        $: 96
    };
    var $author$project$Spa$Generated$Route$PracticeSetup__Top = {
        $: 17
    };
    var $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String = function(a) {
        return {
            $: 288,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top = {
        $: 195
    };
    var $author$project$Spa$Generated$Route$Reports__CompanyInvoices = {
        $: 97
    };
    var $author$project$Spa$Generated$Route$Reports__CreditOutstanding = {
        $: 98
    };
    var $author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary = {
        $: 267
    };
    var $author$project$Spa$Generated$Route$Reports__CreditTransactions = {
        $: 99
    };
    var $author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary = {
        $: 268
    };
    var $author$project$Spa$Generated$Route$Reports__Custom__Id_String = function(a) {
        return {
            $: 289,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Reports__Custom__New = {
        $: 269
    };
    var $author$project$Spa$Generated$Route$Reports__Dashboard = {
        $: 100
    };
    var $author$project$Spa$Generated$Route$Reports__DeferredRevenue = {
        $: 101
    };
    var $author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary = {
        $: 270
    };
    var $author$project$Spa$Generated$Route$Reports__Deposits = {
        $: 102
    };
    var $author$project$Spa$Generated$Route$Reports__Disputes = {
        $: 103
    };
    var $author$project$Spa$Generated$Route$Reports__Invoices = {
        $: 104
    };
    var $author$project$Spa$Generated$Route$Reports__Memberships = {
        $: 105
    };
    var $author$project$Spa$Generated$Route$Reports__Months = {
        $: 106
    };
    var $author$project$Spa$Generated$Route$Reports__PaymentApplications = {
        $: 107
    };
    var $author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary = {
        $: 271
    };
    var $author$project$Spa$Generated$Route$Reports__Revenue = {
        $: 108
    };
    var $author$project$Spa$Generated$Route$Reports__Revenue__Summary = {
        $: 272
    };
    var $author$project$Spa$Generated$Route$Reports__SalesTax = {
        $: 109
    };
    var $author$project$Spa$Generated$Route$Reports__SalesTax__Summary = {
        $: 273
    };
    var $author$project$Spa$Generated$Route$Reports__SignupAttempts = {
        $: 110
    };
    var $author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators = {
        $: 111
    };
    var $author$project$Spa$Generated$Route$StyleGuide__AddressInput = {
        $: 112
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Alert = {
        $: 113
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Badge = {
        $: 114
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Button = {
        $: 115
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Carousel = {
        $: 116
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Checkbox = {
        $: 117
    };
    var $author$project$Spa$Generated$Route$StyleGuide__CurrencyInput = {
        $: 118
    };
    var $author$project$Spa$Generated$Route$StyleGuide__DateInput = {
        $: 119
    };
    var $author$project$Spa$Generated$Route$StyleGuide__DateRangeInput = {
        $: 120
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Dropdown = {
        $: 121
    };
    var $author$project$Spa$Generated$Route$StyleGuide__ExportCsv = {
        $: 122
    };
    var $author$project$Spa$Generated$Route$StyleGuide__FileInput = {
        $: 123
    };
    var $author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu = {
        $: 124
    };
    var $author$project$Spa$Generated$Route$StyleGuide__FormExample = {
        $: 125
    };
    var $author$project$Spa$Generated$Route$StyleGuide__FormGroup = {
        $: 126
    };
    var $author$project$Spa$Generated$Route$StyleGuide__FormStatic = {
        $: 127
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Grid = {
        $: 128
    };
    var $author$project$Spa$Generated$Route$StyleGuide__HiConfirm = {
        $: 129
    };
    var $author$project$Spa$Generated$Route$StyleGuide__HorizontalRule = {
        $: 130
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Icon = {
        $: 131
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Input = {
        $: 132
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Link = {
        $: 133
    };
    var $author$project$Spa$Generated$Route$StyleGuide__ListGroup = {
        $: 134
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Modal = {
        $: 135
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Pagination = {
        $: 136
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Panel = {
        $: 137
    };
    var $author$project$Spa$Generated$Route$StyleGuide__PasswordInput = {
        $: 138
    };
    var $author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer = {
        $: 139
    };
    var $author$project$Spa$Generated$Route$StyleGuide__PhoneInput = {
        $: 140
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Popover = {
        $: 141
    };
    var $author$project$Spa$Generated$Route$StyleGuide__ProgressBar = {
        $: 142
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Radio = {
        $: 143
    };
    var $author$project$Spa$Generated$Route$StyleGuide__ResourceFilter = {
        $: 144
    };
    var $author$project$Spa$Generated$Route$StyleGuide__SearchInput = {
        $: 145
    };
    var $author$project$Spa$Generated$Route$StyleGuide__SearchableSelect = {
        $: 146
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Select = {
        $: 147
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Skeleton = {
        $: 148
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Table = {
        $: 149
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Toast = {
        $: 150
    };
    var $author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch = {
        $: 151
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Tooltip = {
        $: 152
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Top = {
        $: 18
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Typography = {
        $: 153
    };
    var $author$project$Spa$Generated$Route$StyleGuide__UploadForm = {
        $: 154
    };
    var $author$project$Spa$Generated$Route$StyleGuide__UploadResult = {
        $: 155
    };
    var $author$project$Spa$Generated$Route$StyleGuide__Well = {
        $: 156
    };
    var $author$project$Spa$Generated$Route$Support__CannySso = {
        $: 157
    };
    var $author$project$Spa$Generated$Route$Tasks__New = {
        $: 158
    };
    var $author$project$Spa$Generated$Route$Tasks__TasksId_String__Top = function(a) {
        return {
            $: 196,
            a: a
        };
    };
    var $author$project$Spa$Generated$Route$Tasks__Top = {
        $: 19
    };
    var $author$project$Spa$Generated$Route$Top = {
        $: 0
    };
    var $author$project$Spa$Generated$Route$User__AcceptTerms = {
        $: 159
    };
    var $author$project$Spa$Generated$Route$User__Mfa = {
        $: 160
    };
    var $author$project$Spa$Generated$Route$User__Organizations__Top = {
        $: 197
    };
    var $author$project$Spa$Generated$Route$User__Profile = {
        $: 161
    };
    var $author$project$Spa$Generated$Route$User__Security = {
        $: 162
    };
    var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
    var $elm$url$Url$Parser$mapState = F2(function(func, _v0) {
        var visited = _v0.kN;
        var unvisited = _v0.hb;
        var params = _v0.VU;
        var frag = _v0.iK;
        var value = _v0.aa9;
        return A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, func(value));
    });
    var $elm$url$Url$Parser$map = F2(function(subValue, _v0) {
        var parseArg = _v0;
        return function(_v1) {
            var visited = _v1.kN;
            var unvisited = _v1.hb;
            var params = _v1.VU;
            var frag = _v1.iK;
            var value = _v1.aa9;
            return A2($elm$core$List$map, $elm$url$Url$Parser$mapState(value), parseArg(A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
        };
    });
    var $elm$core$List$append = F2(function(xs, ys) {
        if (!ys.b) return xs;
        else return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
    });
    var $elm$core$List$concat = function(lists) {
        return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
    };
    var $elm$core$List$concatMap = F2(function(f, list) {
        return $elm$core$List$concat(A2($elm$core$List$map, f, list));
    });
    var $elm$url$Url$Parser$oneOf = function(parsers) {
        return function(state) {
            return A2($elm$core$List$concatMap, function(_v0) {
                var parser = _v0;
                return parser(state);
            }, parsers);
        };
    };
    var $elm$url$Url$Parser$s = function(str) {
        return function(_v0) {
            var visited = _v0.kN;
            var unvisited = _v0.hb;
            var params = _v0.VU;
            var frag = _v0.iK;
            var value = _v0.aa9;
            if (!unvisited.b) return _List_Nil;
            else {
                var next = unvisited.a;
                var rest = unvisited.b;
                return _Utils_eq(next, str) ? _List_fromArray([
                    A5($elm$url$Url$Parser$State, A2($elm$core$List$cons, next, visited), rest, params, frag, value)
                ]) : _List_Nil;
            }
        };
    };
    var $elm$url$Url$Parser$slash = F2(function(_v0, _v1) {
        var parseBefore = _v0;
        var parseAfter = _v1;
        return function(state) {
            return A2($elm$core$List$concatMap, parseAfter, parseBefore(state));
        };
    });
    var $elm$url$Url$Parser$custom = F2(function(tipe, stringToSomething) {
        return function(_v0) {
            var visited = _v0.kN;
            var unvisited = _v0.hb;
            var params = _v0.VU;
            var frag = _v0.iK;
            var value = _v0.aa9;
            if (!unvisited.b) return _List_Nil;
            else {
                var next = unvisited.a;
                var rest = unvisited.b;
                var _v2 = stringToSomething(next);
                if (!_v2.$) {
                    var nextValue = _v2.a;
                    return _List_fromArray([
                        A5($elm$url$Url$Parser$State, A2($elm$core$List$cons, next, visited), rest, params, frag, value(nextValue))
                    ]);
                } else return _List_Nil;
            }
        };
    });
    var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
    var $elm$url$Url$Parser$top = function(state) {
        return _List_fromArray([
            state
        ]);
    };
    var $author$project$Spa$Generated$Route$routes = $elm$url$Url$Parser$oneOf(_List_fromArray([
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Top, $elm$url$Url$Parser$top),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Blank, $elm$url$Url$Parser$s('blank')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Bookkeeping, $elm$url$Url$Parser$s('bookkeeping')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Calendar, $elm$url$Url$Parser$s('calendar')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Forms, $elm$url$Url$Parser$s('forms')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$GoogleCallback, $elm$url$Url$Parser$s('google_callback')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Home, $elm$url$Url$Parser$s('home')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Login, $elm$url$Url$Parser$s('login')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Logout, $elm$url$Url$Parser$s('logout')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NotFound, $elm$url$Url$Parser$s('not_found')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Onboarding, $elm$url$Url$Parser$s('onboarding')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$AffiliateBills__Top, $elm$url$Url$Parser$s('affiliate_bills')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__Top, $elm$url$Url$Parser$s('affiliates')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__Top, $elm$url$Url$Parser$s('companies')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Files__Top, $elm$url$Url$Parser$s('files')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Top, $elm$url$Url$Parser$s('marketplace')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__Top, $elm$url$Url$Parser$s('patients')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Top, $elm$url$Url$Parser$s('practice_setup')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Top, $elm$url$Url$Parser$s('style_guide')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Tasks__Top, $elm$url$Url$Parser$s('tasks')),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__AdvanceBilling, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('advance_billing'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Billing, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('billing'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CancellationReasons, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('cancellation_reasons'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CardReaders, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('card_readers'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Categories, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('categories'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Commissions, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('commissions'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Coupons, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('coupons'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CreditCategories, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('credit_categories'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__ElationLegacy, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('elation_legacy'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Features, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('features'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('hipaa_authorizations'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__InternalSettings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('internal_settings'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__InvoiceSettings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('invoice_settings'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__LeadSources, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('lead_sources'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Locations, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('locations'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Mailgun, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('mailgun'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Notes, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('notes'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Patients, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('patients'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__PaymentMethodImport, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('payment_method_import'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__PaymentProcessing, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('payment_processing'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__PaymentSources, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('payment_sources'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Practice, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('practice'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__ProviderGroups, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('provider_groups'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__ScheduledJobs, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('scheduled_jobs'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__SelfService, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('self_service'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Signup, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('signup'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Stripe, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('stripe'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Taxes, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('taxes'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Team, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('team'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__Create, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), $elm$url$Url$Parser$s('create'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), $elm$url$Url$Parser$s('new'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Charges__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('charges'), $elm$url$Url$Parser$s('new'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__Statements, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), $elm$url$Url$Parser$s('statements'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), $elm$url$Url$Parser$s('new'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Contacts__List, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('contacts'), $elm$url$Url$Parser$s('list'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Contacts__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('contacts'), $elm$url$Url$Parser$s('new'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Files__Public, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('files'), $elm$url$Url$Parser$s('public'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Hinter__ClonePractice, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('hinter'), $elm$url$Url$Parser$s('clone_practice'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Hinter__Disputes, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('hinter'), $elm$url$Url$Parser$s('disputes'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Hinter__FeatureFlags, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('hinter'), $elm$url$Url$Parser$s('feature_flags'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Hinter__NewGroup, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('hinter'), $elm$url$Url$Parser$s('new_group'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Hinter__NewPartner, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('hinter'), $elm$url$Url$Parser$s('new_partner'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Hinter__NewPractice, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('hinter'), $elm$url$Url$Parser$s('new_practice'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Inventory__List, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('inventory'), $elm$url$Url$Parser$s('list'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Inventory__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('inventory'), $elm$url$Url$Parser$s('new'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Inventory__Settings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('inventory'), $elm$url$Url$Parser$s('settings'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Manage, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('marketplace'), $elm$url$Url$Parser$s('manage'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Calls, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), $elm$url$Url$Parser$s('calls'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Chat, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), $elm$url$Url$Parser$s('chat'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Drafts, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), $elm$url$Url$Parser$s('drafts'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Forms, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), $elm$url$Url$Parser$s('forms'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Labs, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), $elm$url$Url$Parser$s('labs'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Sms, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), $elm$url$Url$Parser$s('sms'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__BlockedPhoneNumbers, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('blocked_phone_numbers'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__BookingOverview, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('booking_overview'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Erx, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('erx'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Export, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('export'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__HinterSettings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('hinter_settings'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__PracticeInfo, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('practice_info'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Team, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('team'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Oauth__Callback, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('oauth'), $elm$url$Url$Parser$s('callback'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__ApiKeys, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('api_keys'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Billing, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('billing'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Engagements, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('engagements'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Hinter, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('hinter'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Product, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('product'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Team, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('team'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__Create, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), $elm$url$Url$Parser$s('create'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__Upload, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), $elm$url$Url$Parser$s('upload'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Account, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), $elm$url$Url$Parser$s('account'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Communications, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), $elm$url$Url$Parser$s('communications'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Complete, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), $elm$url$Url$Parser$s('complete'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Documents, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), $elm$url$Url$Parser$s('documents'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Legal, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), $elm$url$Url$Parser$s('legal'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), $elm$url$Url$Parser$s('payment_processing'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Plans, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), $elm$url$Url$Parser$s('plans'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Team, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), $elm$url$Url$Parser$s('team'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__CompanyInvoices, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('company_invoices'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__CreditOutstanding, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('credit_outstanding'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__CreditTransactions, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('credit_transactions'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Dashboard, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('dashboard'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__DeferredRevenue, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('deferred_revenue'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Deposits, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('deposits'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Disputes, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('disputes'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Invoices, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('invoices'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Memberships, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('memberships'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Months, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('months'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__PaymentApplications, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('payment_applications'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Revenue, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('revenue'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__SalesTax, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('sales_tax'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__SignupAttempts, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('signup_attempts'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('activity_indicators'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__AddressInput, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('address_input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Alert, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('alert'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Badge, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('badge'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Button, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('button'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Carousel, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('carousel'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Checkbox, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('checkbox'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__CurrencyInput, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('currency_input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__DateInput, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('date_input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__DateRangeInput, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('date_range_input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Dropdown, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('dropdown'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__ExportCsv, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('export_csv'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__FileInput, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('file_input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('flyout_menu'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__FormExample, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('form_example'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__FormGroup, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('form_group'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__FormStatic, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('form_static'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Grid, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('grid'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__HiConfirm, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('hi_confirm'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__HorizontalRule, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('horizontal_rule'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Icon, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('icon'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Input, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Link, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('link'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__ListGroup, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('list_group'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Modal, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('modal'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Pagination, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('pagination'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Panel, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('panel'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__PasswordInput, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('password_input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('payment_source_displayer'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__PhoneInput, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('phone_input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Popover, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('popover'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__ProgressBar, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('progress_bar'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Radio, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('radio'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__ResourceFilter, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('resource_filter'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__SearchInput, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('search_input'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__SearchableSelect, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('searchable_select'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Select, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('select'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Skeleton, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('skeleton'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Table, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('table'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Toast, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('toast'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('toggle_switch'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Tooltip, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('tooltip'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Typography, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('typography'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__UploadForm, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('upload_form'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__UploadResult, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('upload_result'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$StyleGuide__Well, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('style_guide'), $elm$url$Url$Parser$s('well'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Support__CannySso, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('support'), $elm$url$Url$Parser$s('canny_sso'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Tasks__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('tasks'), $elm$url$Url$Parser$s('new'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$User__AcceptTerms, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('user'), $elm$url$Url$Parser$s('accept_terms'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$User__Mfa, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('user'), $elm$url$Url$Parser$s('mfa'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$User__Profile, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('user'), $elm$url$Url$Parser$s('profile'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$User__Security, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('user'), $elm$url$Url$Parser$s('security'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Apps__Slug_String, A2($elm$url$Url$Parser$map, function(slug) {
            return {
                _A: slug
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('apps'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Error__Status_String, A2($elm$url$Url$Parser$map, function(status) {
            return {
                ahy: status
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('error'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Join__Token_String, A2($elm$url$Url$Parser$map, function(token) {
            return {
                aaf: token
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('join'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Slug_String, A2($elm$url$Url$Parser$map, function(slug) {
            return {
                _A: slug
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('marketplace'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Athenahealth__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('athenahealth'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('charge_items'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('company_plans'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('coverage_plans'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__DataExport__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('data_export'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('data_export_settings'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Documents__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('documents'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Elation__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('elation'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Plans__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('plans'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Providers__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('providers'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Quickbooks__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('quickbooks'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__SignupPages__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), $elm$url$Url$Parser$s('signup_pages'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), $elm$url$Url$Parser$s('broker_accounts'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__StatementLines__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), $elm$url$Url$Parser$s('statement_lines'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Contacts__ContactId_String__Top, A2($elm$url$Url$Parser$map, function(contactId) {
            return {
                acA: contactId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('contacts'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('hinter'), $elm$url$Url$Parser$s('admin_users_groups'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top, A2($elm$url$Url$Parser$map, function(inventoryId) {
            return {
                aev: inventoryId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('inventory'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Faxes__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), $elm$url$Url$Parser$s('faxes'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Scheduled__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), $elm$url$Url$Parser$s('scheduled'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('appointment_types'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Locations__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('locations'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Templates__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), $elm$url$Url$Parser$s('templates'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Onboard__DealId_String__Top, A2($elm$url$Url$Parser$map, function(dealId) {
            return {
                acS: dealId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('onboard'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Dashboard__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('dashboard'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Practices__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('practices'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Sandboxes__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), $elm$url$Url$Parser$s('sandboxes'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), $elm$url$Url$Parser$s('ancillary_charges'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Tasks__TasksId_String__Top, A2($elm$url$Url$Parser$map, function(tasksId) {
            return {
                ahJ: tasksId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('tasks'), $elm$url$Url$Parser$string))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$User__Organizations__Top, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('user'), $elm$url$Url$Parser$s('organizations'))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('athenahealth'), $elm$url$Url$Parser$s('fields')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Athenahealth__Link, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('athenahealth'), $elm$url$Url$Parser$s('link')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('athenahealth'), $elm$url$Url$Parser$s('locations')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('athenahealth'), $elm$url$Url$Parser$s('overview')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('athenahealth'), $elm$url$Url$Parser$s('providers')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__ChargeItems__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('charge_items'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__ChargeItems__Upload, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('charge_items'), $elm$url$Url$Parser$s('upload')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CompanyPlans__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('company_plans'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CoveragePlans__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('coverage_plans'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Credits__Upload, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('credits'), $elm$url$Url$Parser$s('upload')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__DataExportSettings__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('data_export_settings'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('developers'), $elm$url$Url$Parser$s('api_keys')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('developers'), $elm$url$Url$Parser$s('get_started')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Developers__Sandboxes, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('developers'), $elm$url$Url$Parser$s('sandboxes')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('developers'), $elm$url$Url$Parser$s('webhook_endpoints')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Documents__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('documents'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Elation__Link, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('elation'), $elm$url$Url$Parser$s('link')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Elation__Overview, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('elation'), $elm$url$Url$Parser$s('overview')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Elation__Providers, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('elation'), $elm$url$Url$Parser$s('providers')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Notifications__Company, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('notifications'), $elm$url$Url$Parser$s('company')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Notifications__Employee, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('notifications'), $elm$url$Url$Parser$s('employee')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Notifications__Membership, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('notifications'), $elm$url$Url$Parser$s('membership')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Notifications__Patient, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('notifications'), $elm$url$Url$Parser$s('patient')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Notifications__Practice, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('notifications'), $elm$url$Url$Parser$s('practice')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Notifications__Settings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('notifications'), $elm$url$Url$Parser$s('settings')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('payment_method_import'), $elm$url$Url$Parser$s('upload')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Plans__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('plans'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Providers__Upload, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('providers'), $elm$url$Url$Parser$s('upload')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__SignupPages__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('signup_pages'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Team__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('team'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions, A2($elm$url$Url$Parser$map, function(affiliateId) {
            return {
                pr: affiliateId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('affiliate_actions'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders, A2($elm$url$Url$Parser$map, function(affiliateId) {
            return {
                pr: affiliateId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('link_providers'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders, A2($elm$url$Url$Parser$map, function(affiliateId) {
            return {
                pr: affiliateId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('linked_providers'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients, A2($elm$url$Url$Parser$map, function(affiliateId) {
            return {
                pr: affiliateId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('patients'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings, A2($elm$url$Url$Parser$map, function(affiliateId) {
            return {
                pr: affiliateId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('settings'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users, A2($elm$url$Url$Parser$map, function(affiliateId) {
            return {
                pr: affiliateId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('users'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__StatementLines__Summary, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('statement_lines'), $elm$url$Url$Parser$s('summary')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('affiliates_pricing'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('eas'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('ended_commissions'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('invoice_settings'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('notes'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('notifications'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('payment_sources'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('signup'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Faxes__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('faxes'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Scheduled__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('scheduled'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('appointment_types'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Templates__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('templates'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed, A2($elm$url$Url$Parser$map, function(onboardId) {
            return {
                afS: onboardId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('onboard'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('completed'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing, A2($elm$url$Url$Parser$map, function(onboardId) {
            return {
                afS: onboardId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('onboard'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('completing'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment, A2($elm$url$Url$Parser$map, function(onboardId) {
            return {
                afS: onboardId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('onboard'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('payment'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__User, A2($elm$url$Url$Parser$map, function(onboardId) {
            return {
                afS: onboardId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('onboard'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('user'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Billing__Hinter, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('billing'), $elm$url$Url$Parser$s('hinter')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Product__ActivationSettings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('product'), $elm$url$Url$Parser$s('activation_settings')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Product__AppSettings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('product'), $elm$url$Url$Parser$s('app_settings')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Product__Hinter, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('product'), $elm$url$Url$Parser$s('hinter')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Product__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('product'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Webhooks__Requests, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('webhooks'), $elm$url$Url$Parser$s('requests')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Partner__Webhooks__Settings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('partner'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('webhooks'), $elm$url$Url$Parser$s('settings')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Chart, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('chart'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Edit, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('edit'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__GrowthChart, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('growth_chart'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__LabTrends, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('lab_trends'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('manage_credits'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Merge, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('merge'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__VitalsTrends, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('vitals_trends'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Plans__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('plans'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('credit_outstanding'), $elm$url$Url$Parser$s('summary')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('credit_transactions'), $elm$url$Url$Parser$s('summary')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Custom__New, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('custom'), $elm$url$Url$Parser$s('new')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('deferred_revenue'), $elm$url$Url$Parser$s('summary')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('payment_applications'), $elm$url$Url$Parser$s('summary')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Revenue__Summary, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('revenue'), $elm$url$Url$Parser$s('summary')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__SalesTax__Summary, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('sales_tax'), $elm$url$Url$Parser$s('summary')))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('charge_items'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('company_plans'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('coverage_plans'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__DataExport__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('data_export'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('data_export_settings'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Documents__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('documents'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Integrations__Slug_String, A2($elm$url$Url$Parser$map, function(slug) {
            return {
                _A: slug
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('integrations'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Plans__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('plans'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__SignupPages__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('signup_pages'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('hinter'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin_users_groups'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String, A2($elm$url$Url$Parser$map, function(ident) {
            return {
                aeg: ident
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('appointment_types'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String, A2($elm$url$Url$Parser$map, function(bookingLocationId) {
            return {
                ab5: bookingLocationId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('locations'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String, A2($elm$url$Url$Parser$map, function(teamId) {
            return {
                ahL: teamId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('team'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String, A2($elm$url$Url$Parser$map, function(templateId) {
            return {
                ahM: templateId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('templates'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('ancillary_charges'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Reports__Custom__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('reports'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('custom'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top, A2($elm$url$Url$Parser$map, function(affiliateId) {
            return {
                pr: affiliateId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('bills'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top, A2($elm$url$Url$Parser$map, function(brokerAccountId) {
            return {
                bS: brokerAccountId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('employees'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('invoices'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('uploads'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top, A2($elm$url$Url$Parser$map, function(scheduledId) {
            return {
                ag6: scheduledId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('messages'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('scheduled'), $elm$url$Url$Parser$string)))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('accounts'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('affiliation'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('charges'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('memberships'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('notes'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('notifications'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('notifications'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patient'), $elm$url$Url$Parser$s('dunning_schedule'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals, A2($elm$url$Url$Parser$map, function(brokerAccountId) {
            return {
                bS: brokerAccountId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('deals')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals, A2($elm$url$Url$Parser$map, function(brokerAccountId) {
            return {
                bS: brokerAccountId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('ended_deals')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('employees'), $elm$url$Url$Parser$s('create')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New, A2($elm$url$Url$Parser$map, function(companyId) {
            return {
                fl: companyId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('signup_pages'), $elm$url$Url$Parser$s('new')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('marketplace'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('bookkeeping'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('manage'), $elm$url$Url$Parser$s('settings'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('marketplace'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('elation'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('manage'), $elm$url$Url$Parser$s('settings'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('marketplace'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('quickbooks'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('manage'), $elm$url$Url$Parser$s('settings'))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding, A2($elm$url$Url$Parser$map, function(slug) {
            return {
                _A: slug
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('marketplace'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('manage'), $elm$url$Url$Parser$s('onboarding')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings, A2($elm$url$Url$Parser$map, function(slug) {
            return {
                _A: slug
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('marketplace'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('manage'), $elm$url$Url$Parser$s('settings')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users, A2($elm$url$Url$Parser$map, function(slug) {
            return {
                _A: slug
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('marketplace'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('manage'), $elm$url$Url$Parser$s('users')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo, A2($elm$url$Url$Parser$map, function(teamId) {
            return {
                ahL: teamId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('team'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('basic_info')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New, A2($elm$url$Url$Parser$map, function(patientId) {
            return {
                V8: patientId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('memberships'), $elm$url$Url$Parser$s('new')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_setup'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('plans'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('edit')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('billing'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('practice_invoices'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String, A2($elm$url$Url$Parser$map, F2(function(affiliateId, id) {
            return {
                pr: affiliateId,
                aef: id
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('affiliates'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('bills'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String, A2($elm$url$Url$Parser$map, F2(function(companyId, id) {
            return {
                fl: companyId,
                aef: id
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('invoices'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String, A2($elm$url$Url$Parser$map, F2(function(companyId, id) {
            return {
                fl: companyId,
                aef: id
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('signup_pages'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$NewSettings__Locations__New__LocationId_String, A2($elm$url$Url$Parser$map, function(locationId) {
            return {
                Tp: locationId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new_settings'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('locations'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('new'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__NoteId_String, A2($elm$url$Url$Parser$map, F2(function(patientId, noteId) {
            return {
                afp: noteId,
                V8: patientId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('notes'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top, A2($elm$url$Url$Parser$map, function(brokerAccountId) {
            return {
                bS: brokerAccountId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('brokers')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top, A2($elm$url$Url$Parser$map, function(brokerAccountId) {
            return {
                bS: brokerAccountId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('statements')))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top, A2($elm$url$Url$Parser$map, F2(function(companyId, uploadId) {
            return {
                fl: companyId,
                H_: uploadId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('uploads'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top, A2($elm$url$Url$Parser$map, F2(function(patientId, agreementId) {
            return {
                I$: agreementId,
                V8: patientId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('agreements'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top, A2($elm$url$Url$Parser$map, F2(function(patientId, invoiceId) {
            return {
                RI: invoiceId,
                V8: patientId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('charges'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top, A2($elm$url$Url$Parser$map, F2(function(patientId, membershipId) {
            return {
                y0: membershipId,
                V8: patientId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('patients'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('memberships'), $elm$url$Url$Parser$string))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New, A2($elm$url$Url$Parser$map, function(id) {
            return {
                aef: id
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('plans'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('pricing_versions'), $elm$url$Url$Parser$s('new'))))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended, A2($elm$url$Url$Parser$map, function(brokerAccountId) {
            return {
                bS: brokerAccountId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('brokers'), $elm$url$Url$Parser$s('ended'))))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New, A2($elm$url$Url$Parser$map, function(brokerAccountId) {
            return {
                bS: brokerAccountId
            };
        }, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('brokers'), $elm$url$Url$Parser$s('new'))))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults, A2($elm$url$Url$Parser$map, F2(function(companyId, uploadId) {
            return {
                fl: companyId,
                H_: uploadId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('uploads'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$s('upload_results'))))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String, A2($elm$url$Url$Parser$map, F2(function(id, pricingVersionId) {
            return {
                aef: id,
                ago: pricingVersionId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('admin'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('plans'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('pricing_versions'), $elm$url$Url$Parser$string)))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String, A2($elm$url$Url$Parser$map, F2(function(brokerAccountId, statementId) {
            return {
                bS: brokerAccountId,
                ahx: statementId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('statements'), $elm$url$Url$Parser$string)))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top, A2($elm$url$Url$Parser$map, F2(function(brokerAccountId, brokerId) {
            return {
                bS: brokerAccountId,
                EC: brokerId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('commissions'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('broker_accounts'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('brokers'), $elm$url$Url$Parser$string)))))),
        A2($elm$url$Url$Parser$map, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top, A2($elm$url$Url$Parser$map, F3(function(companyId, employeeId, dependentId) {
            return {
                fl: companyId,
                ac2: dependentId,
                adk: employeeId
            };
        }), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('companies'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('employees'), A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$s('dependent'), $elm$url$Url$Parser$string)))))))
    ]));
    var $author$project$Spa$Generated$Route$fromUrl = $elm$url$Url$Parser$parse($author$project$Spa$Generated$Route$routes);
    var $elm$core$Maybe$withDefault = F2(function(_default, maybe) {
        if (!maybe.$) {
            var value = maybe.a;
            return value;
        } else return _default;
    });
    var $author$project$Utils$Route$fromUrl = A2($elm$core$Basics$composeR, $author$project$Spa$Generated$Route$fromUrl, $elm$core$Maybe$withDefault($author$project$Spa$Generated$Route$NotFound));
    var $jinjor$elm_debounce$Debounce$Debounce = $elm$core$Basics$identity;
    var $jinjor$elm_debounce$Debounce$init = {
        ea: _List_Nil,
        Ts: false
    };
    var $author$project$Shared$GlobalSearchMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Shared$GotTimeZone = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Data$Loading = {
        $: 1
    };
    var $author$project$Api$Data$NotAsked = {
        $: 0
    };
    var $author$project$Shared$ReleaseMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $elm$core$Maybe$andThen = F2(function(callback, maybeValue) {
        if (!maybeValue.$) {
            var value = maybeValue.a;
            return callback(value);
        } else return $elm$core$Maybe$Nothing;
    });
    var $elm$core$Basics$composeL = F3(function(g, f, x) {
        return g(f(x));
    });
    var $elm$core$Task$onError = _Scheduler_onError;
    var $elm$core$Task$attempt = F2(function(resultToMessage, task) {
        return $elm$core$Task$command(A2($elm$core$Task$onError, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Err), A2($elm$core$Task$andThen, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage), $elm$core$Result$Ok), task)));
    });
    var $author$project$Api$Data$Client = $elm$core$Basics$identity;
    var $author$project$Api$Data$clientInit = F4(function(prePath, providerAuthUrl, apiVersion, authToken) {
        return {
            Ek: apiVersion,
            e7: authToken,
            Bo: prePath,
            G8: providerAuthUrl,
            Cq: true
        };
    });
    var $author$project$Utils$Environment$Development = 2;
    var $author$project$Utils$Environment$Feature = 3;
    var $author$project$Utils$Environment$Production = 0;
    var $author$project$Utils$Environment$Staging = 1;
    var $author$project$Utils$Environment$decode = function(envName) {
        return A2($elm$core$Maybe$andThen, function(env) {
            switch(env){
                case 'production':
                    return $elm$core$Maybe$Just(0);
                case 'staging':
                    return $elm$core$Maybe$Just(1);
                case 'development':
                    return $elm$core$Maybe$Just(2);
                case 'feature':
                    return $elm$core$Maybe$Just(3);
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }, envName);
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$Rules = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$Zone = F2(function(history1, current) {
        return {
            MJ: current,
            ca: history1
        };
    });
    var $justinmimbs$timezone_data$TimeZone$Specification$ZoneState = F2(function(standardOffset, zoneRules) {
        return {
            HA: standardOffset,
            H7: zoneRules
        };
    });
    var $elm$time$Time$Zone = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$time$Time$customZone = $elm$time$Time$Zone;
    var $justinmimbs$timezone_data$TimeZone$maxYear = 2037;
    var $justinmimbs$timezone_data$TimeZone$minYear = 1970;
    var $justinmimbs$timezone_data$TimeZone$Specification$DateTime = F5(function(year, month, day, time, clock) {
        return {
            fk: clock,
            acP: day,
            ae6: month,
            ahT: time,
            ail: year
        };
    });
    var $elm$time$Time$Jan = 0;
    var $justinmimbs$timezone_data$TimeZone$Specification$Universal = 0;
    var $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch = function(_v0) {
        dropChangesBeforeEpoch: while(true){
            var initial = _v0.a;
            var changes = _v0.b;
            if (changes.b) {
                var change = changes.a;
                var rest = changes.b;
                if (change.HB <= 0) {
                    var $temp$_v0 = _Utils_Tuple2(change.f, rest);
                    _v0 = $temp$_v0;
                    continue dropChangesBeforeEpoch;
                } else return _Utils_Tuple2(initial, changes);
            } else return _Utils_Tuple2(initial, _List_Nil);
        }
    };
    var $elm$core$Tuple$second = function(_v0) {
        var y = _v0.b;
        return y;
    };
    var $elm$core$Basics$modBy = _Basics_modBy;
    var $justinmimbs$timezone_data$RataDie$weekdayNumber = function(rd) {
        var _v0 = A2($elm$core$Basics$modBy, 7, rd);
        if (!_v0) return 7;
        else {
            var n = _v0;
            return n;
        }
    };
    var $justinmimbs$timezone_data$RataDie$weekdayToNumber = function(wd) {
        switch(wd){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    };
    var $justinmimbs$timezone_data$RataDie$floorWeekday = F2(function(weekday, rd) {
        var daysSincePreviousWeekday = A2($elm$core$Basics$modBy, 7, $justinmimbs$timezone_data$RataDie$weekdayNumber(rd) + 7 - $justinmimbs$timezone_data$RataDie$weekdayToNumber(weekday));
        return rd - daysSincePreviousWeekday;
    });
    var $justinmimbs$timezone_data$RataDie$ceilingWeekday = F2(function(weekday, rd) {
        var floored = A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, rd);
        return _Utils_eq(rd, floored) ? rd : floored + 7;
    });
    var $elm$core$Basics$neq = _Utils_notEqual;
    var $justinmimbs$timezone_data$RataDie$isLeapYear = function(y) {
        return !A2($elm$core$Basics$modBy, 4, y) && !!A2($elm$core$Basics$modBy, 100, y) || !A2($elm$core$Basics$modBy, 400, y);
    };
    var $justinmimbs$timezone_data$RataDie$daysBeforeMonth = F2(function(y, m) {
        var leapDays = $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 1 : 0;
        switch(m){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + leapDays;
            case 3:
                return 90 + leapDays;
            case 4:
                return 120 + leapDays;
            case 5:
                return 151 + leapDays;
            case 6:
                return 181 + leapDays;
            case 7:
                return 212 + leapDays;
            case 8:
                return 243 + leapDays;
            case 9:
                return 273 + leapDays;
            case 10:
                return 304 + leapDays;
            default:
                return 334 + leapDays;
        }
    });
    var $justinmimbs$timezone_data$RataDie$daysBeforeYear = function(y1) {
        var y = y1 - 1;
        var leapYears = (y / 4 | 0) - (y / 100 | 0) + (y / 400 | 0);
        return 365 * y + leapYears;
    };
    var $justinmimbs$timezone_data$RataDie$dayOfMonth = F3(function(y, m, d) {
        return $justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m) + d;
    });
    var $elm$core$List$filter = F2(function(isGood, list) {
        return A3($elm$core$List$foldr, F2(function(x, xs) {
            return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
        }), _List_Nil, list);
    });
    var $justinmimbs$timezone_data$RataDie$daysInMonth = F2(function(y, m) {
        switch(m){
            case 0:
                return 31;
            case 1:
                return $justinmimbs$timezone_data$RataDie$isLeapYear(y) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    });
    var $justinmimbs$timezone_data$RataDie$lastOfMonth = F2(function(y, m) {
        return $justinmimbs$timezone_data$RataDie$daysBeforeYear(y) + A2($justinmimbs$timezone_data$RataDie$daysBeforeMonth, y, m) + A2($justinmimbs$timezone_data$RataDie$daysInMonth, y, m);
    });
    var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie = function(rd) {
        return (rd - 719163) * 1440;
    };
    var $elm$core$List$sortBy = _List_sortBy;
    var $justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment = F2(function(clock, _v0) {
        var standard = _v0.gY;
        var save = _v0.ag3;
        switch(clock){
            case 0:
                return 0;
            case 1:
                return 0 - standard;
            default:
                return 0 - (standard + save);
        }
    });
    var $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime = function(_v0) {
        var year = _v0.ail;
        var month = _v0.ae6;
        var day = _v0.acP;
        var time = _v0.ahT;
        return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, month, day)) + time;
    };
    var $justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime = F2(function(offset, datetime) {
        return $justinmimbs$timezone_data$TimeZone$Specification$minutesFromDateTime(datetime) + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, datetime.fk, offset);
    });
    var $justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges = F5(function(previousOffset, start, until, standardOffset, rules) {
        var transitions = A2($elm$core$List$concatMap, function(year) {
            return A2($elm$core$List$sortBy, function($) {
                return $.HB;
            }, A2($elm$core$List$map, function(rule) {
                return {
                    fk: rule.fk,
                    ag3: rule.ag3,
                    HB: $justinmimbs$timezone_data$TimeZone$Specification$minutesFromRataDie(function() {
                        var _v2 = rule.acP;
                        switch(_v2.$){
                            case 0:
                                var day = _v2.a;
                                return A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.ae6, day);
                            case 1:
                                var weekday = _v2.a;
                                var after = _v2.b;
                                return A2($justinmimbs$timezone_data$RataDie$ceilingWeekday, weekday, A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.ae6, after));
                            case 2:
                                var weekday = _v2.a;
                                var before = _v2.b;
                                return A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, A3($justinmimbs$timezone_data$RataDie$dayOfMonth, year, rule.ae6, before));
                            default:
                                var weekday = _v2.a;
                                return A2($justinmimbs$timezone_data$RataDie$floorWeekday, weekday, A2($justinmimbs$timezone_data$RataDie$lastOfMonth, year, rule.ae6));
                        }
                    }()) + rule.ahT
                };
            }, A2($elm$core$List$filter, function(rule) {
                return _Utils_cmp(rule.PZ, year) < 1 && _Utils_cmp(year, rule.$3) < 1;
            }, rules)));
        }, A2($elm$core$List$range, start.ail - 1, until.ail));
        var initialOffset = {
            ag3: 0,
            gY: standardOffset
        };
        var initialChange = {
            f: standardOffset,
            HB: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
        };
        var _v0 = A3($elm$core$List$foldl, F2(function(transition, _v1) {
            var currentOffset = _v1.a;
            var changes = _v1.b;
            var newOffset = {
                ag3: transition.ag3,
                gY: standardOffset
            };
            if (_Utils_cmp(transition.HB + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fk, previousOffset), initialChange.HB) < 1) {
                var updatedInitialChange = {
                    f: standardOffset + transition.ag3,
                    HB: initialChange.HB
                };
                return _Utils_Tuple2(newOffset, _List_fromArray([
                    updatedInitialChange
                ]));
            } else {
                if (_Utils_cmp(transition.HB + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fk, currentOffset), A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, currentOffset, until)) < 0) {
                    var change = {
                        f: standardOffset + transition.ag3,
                        HB: transition.HB + A2($justinmimbs$timezone_data$TimeZone$Specification$utcAdjustment, transition.fk, currentOffset)
                    };
                    return _Utils_Tuple2(newOffset, A2($elm$core$List$cons, change, changes));
                } else return _Utils_Tuple2(currentOffset, changes);
            }
        }), _Utils_Tuple2(initialOffset, _List_fromArray([
            initialChange
        ])), transitions);
        var nextOffset = _v0.a;
        var descendingChanges = _v0.b;
        return _Utils_Tuple2($elm$core$List$reverse(descendingChanges), nextOffset);
    });
    var $justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges = F4(function(previousOffset, start, until, _v0) {
        var standardOffset = _v0.HA;
        var zoneRules = _v0.H7;
        if (!zoneRules.$) {
            var save = zoneRules.a;
            return _Utils_Tuple2(_List_fromArray([
                {
                    f: standardOffset + save,
                    HB: A2($justinmimbs$timezone_data$TimeZone$Specification$utcMinutesFromDateTime, previousOffset, start)
                }
            ]), {
                ag3: save,
                gY: standardOffset
            });
        } else {
            var rules = zoneRules.a;
            return A5($justinmimbs$timezone_data$TimeZone$Specification$rulesToOffsetChanges, previousOffset, start, until, standardOffset, rules);
        }
    });
    var $justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp = F4(function(f, a, rev, list) {
        stripDuplicatesByHelp: while(true){
            if (!list.b) return $elm$core$List$reverse(rev);
            else {
                var x = list.a;
                var xs = list.b;
                var b = f(x);
                var rev_ = !_Utils_eq(a, b) ? A2($elm$core$List$cons, x, rev) : rev;
                var $temp$f = f, $temp$a = b, $temp$rev = rev_, $temp$list = xs;
                f = $temp$f;
                a = $temp$a;
                rev = $temp$rev;
                list = $temp$list;
                continue stripDuplicatesByHelp;
            }
        }
    });
    var $justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges = F3(function(zoneStart, zoneUntil, zone) {
        var _v0 = A3($elm$core$List$foldl, F2(function(_v1, _v2) {
            var state = _v1.a;
            var nextStart = _v1.b;
            var start = _v2.a;
            var ranges = _v2.b;
            return _Utils_Tuple2(nextStart, A2($elm$core$List$cons, _Utils_Tuple3(start, state, nextStart), ranges));
        }), _Utils_Tuple2(zoneStart, _List_Nil), zone.ca);
        var currentStart = _v0.a;
        var historyRanges = _v0.b;
        return $elm$core$List$reverse(A2($elm$core$List$cons, _Utils_Tuple3(currentStart, zone.MJ, zoneUntil), historyRanges));
    });
    var $justinmimbs$timezone_data$TimeZone$Specification$toOffsets = F3(function(minYear, maxYear, zone) {
        var initialState = function() {
            var _v5 = zone.ca;
            if (_v5.b) {
                var _v6 = _v5.a;
                var earliest = _v6.a;
                return earliest;
            } else return zone.MJ;
        }();
        var initialOffset = {
            ag3: function() {
                var _v4 = initialState.H7;
                if (!_v4.$) {
                    var save = _v4.a;
                    return save;
                } else return 0;
            }(),
            gY: initialState.HA
        };
        var ascendingChanges = A4($justinmimbs$timezone_data$TimeZone$Specification$stripDuplicatesByHelp, function($) {
            return $.f;
        }, initialOffset.gY + initialOffset.ag3, _List_Nil, A3($elm$core$List$foldl, F2(function(_v1, _v2) {
            var start = _v1.a;
            var state = _v1.b;
            var until = _v1.c;
            var prevOffset = _v2.a;
            var prevChanges = _v2.b;
            var _v3 = A4($justinmimbs$timezone_data$TimeZone$Specification$stateToOffsetChanges, prevOffset, start, until, state);
            var nextChanges = _v3.a;
            var nextOffset = _v3.b;
            return _Utils_Tuple2(nextOffset, _Utils_ap(prevChanges, nextChanges));
        }), _Utils_Tuple2(initialOffset, _List_Nil), A3($justinmimbs$timezone_data$TimeZone$Specification$zoneToRanges, A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, minYear, 0, 1, 0, 0), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, maxYear + 1, 0, 1, 0, 0), zone)).b);
        var _v0 = $justinmimbs$timezone_data$TimeZone$Specification$dropChangesBeforeEpoch(_Utils_Tuple2(initialOffset.gY + initialOffset.ag3, ascendingChanges));
        var initial = _v0.a;
        var ascending = _v0.b;
        return _Utils_Tuple2($elm$core$List$reverse(ascending), initial);
    });
    var $justinmimbs$timezone_data$TimeZone$fromSpecification = function(zone) {
        var _v0 = A3($justinmimbs$timezone_data$TimeZone$Specification$toOffsets, $justinmimbs$timezone_data$TimeZone$minYear, $justinmimbs$timezone_data$TimeZone$maxYear, zone);
        var descending = _v0.a;
        var bottom = _v0.b;
        return A2($elm$time$Time$customZone, bottom, descending);
    };
    var $elm$core$Basics$negate = function(n) {
        return -n;
    };
    var $elm$time$Time$Apr = 3;
    var $justinmimbs$timezone_data$TimeZone$Specification$Day = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$time$Time$Feb = 1;
    var $justinmimbs$timezone_data$TimeZone$Specification$Last = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $elm$time$Time$Mar = 2;
    var $justinmimbs$timezone_data$TimeZone$Specification$Next = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $elm$time$Time$Nov = 10;
    var $elm$time$Time$Oct = 9;
    var $justinmimbs$timezone_data$TimeZone$Specification$Rule = F7(function(from, to, month, day, time, clock, save) {
        return {
            fk: clock,
            acP: day,
            PZ: from,
            ae6: month,
            ag3: save,
            ahT: time,
            $3: to
        };
    });
    var $elm$time$Time$Sun = 6;
    var $justinmimbs$timezone_data$TimeZone$Specification$WallClock = 2;
    var $justinmimbs$timezone_data$TimeZone$rules_US = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1967, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1967, 1973, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, $justinmimbs$timezone_data$TimeZone$maxYear, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, $justinmimbs$timezone_data$TimeZone$maxYear, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__los_angeles = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $author$project$Shared$defaultTimeZone = $justinmimbs$timezone_data$TimeZone$america__los_angeles(0);
    var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
    var $justinmimbs$date$Date$fromRataDie = function(rd) {
        return rd;
    };
    var $author$project$Api$AuthToken$Valid = $elm$core$Basics$identity;
    var $author$project$Api$AuthToken$fromString = function(authToken) {
        return authToken;
    };
    var $justinmimbs$timezone_data$TimeZone$NoDataForZoneName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $justinmimbs$timezone_data$TimeZone$NoZoneName = {
        $: 0
    };
    var $elm$core$Task$fail = _Scheduler_fail;
    var $elm$time$Time$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$time$Time$Offset = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$time$Time$getZoneName = _Time_getZoneName(0);
    var $justinmimbs$timezone_data$TimeZone$Specification$Save = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $justinmimbs$timezone_data$TimeZone$africa__abidjan = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__accra = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__nairobi = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__addis_ababa = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $elm$time$Time$May = 4;
    var $elm$time$Time$Sep = 8;
    var $justinmimbs$timezone_data$TimeZone$Specification$Standard = 1;
    var $justinmimbs$timezone_data$TimeZone$rules_Algeria = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1971, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 1380, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1971, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 1380, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__algiers = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 21, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 26, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Algeria)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 4, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__asmara = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__bamako = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__lagos = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__bangui = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__banjul = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__bissau = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__maputo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__blantyre = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__brazzaville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__bujumbura = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $elm$time$Time$Aug = 7;
    var $elm$time$Time$Fri = 4;
    var $elm$time$Time$Jul = 6;
    var $elm$time$Time$Jun = 5;
    var $elm$time$Time$Thu = 3;
    var $justinmimbs$timezone_data$TimeZone$rules_Egypt = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1959, 1981, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1966, 1994, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1982, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1988, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1994, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 2010, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 2005, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 3, 1), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2014, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2014, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2014, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2014, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__cairo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Egypt))));
    };
    var $elm$time$Time$Dec = 11;
    var $justinmimbs$timezone_data$TimeZone$rules_Morocco = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2013, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2013, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2013, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2018, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2018, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2014, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2014, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2015, 2015, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2015, 2015, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2016, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2016, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2017, 2017, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2017, 2017, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2018, 2018, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2018, 2018, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2019, 2019, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2019, 2019, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2020, 2020, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2020, 2020, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2021, 2021, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2021, 2021, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2022, 2022, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2022, 2022, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2023, 2023, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2023, 2023, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2024, 2024, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2024, 2024, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2025, 2025, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2025, 2025, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2026, 2026, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2026, 2026, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2027, 2027, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2027, 2027, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2028, 2028, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2028, 2028, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2029, 2029, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2029, 2029, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2029, 2029, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2030, 2030, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2030, 2030, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2031, 2031, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2031, 2031, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2032, 2032, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2032, 2032, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2033, 2033, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2033, 2033, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2033, 2033, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2034, 2034, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2034, 2034, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2035, 2035, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2035, 2035, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2036, 2036, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2036, 2036, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2037, 2037, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 180, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2037, 2037, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__casablanca = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_EU = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1980, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 60, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_SpainAfrica = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__ceuta = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SpainAfrica)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 2, 16, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__conakry = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__dakar = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__djibouti = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__douala = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__el_aaiun = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 3, 14, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 180, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Morocco))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__freetown = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__gaborone = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__harare = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__johannesburg = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Sudan = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1970, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1971, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__juba = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2021, 1, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__kampala = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__khartoum = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Sudan)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 15, 720, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 10, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__kigali = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__kinshasa = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__libreville = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__lome = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__luanda = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__lubumbashi = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__lusaka = $justinmimbs$timezone_data$TimeZone$africa__maputo;
    var $justinmimbs$timezone_data$TimeZone$africa__malabo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__maseru = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
    var $justinmimbs$timezone_data$TimeZone$africa__mbabane = $justinmimbs$timezone_data$TimeZone$africa__johannesburg;
    var $justinmimbs$timezone_data$TimeZone$africa__mogadishu = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$africa__monrovia = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -45, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 7, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__ndjamena = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 14, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 2, 8, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$africa__niamey = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__nouakchott = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__ouagadougou = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$africa__porto_novo = $justinmimbs$timezone_data$TimeZone$africa__lagos;
    var $justinmimbs$timezone_data$TimeZone$africa__sao_tome = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 0, 1, 60, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 1, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Libya = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1989, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2013, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2013, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__tripoli = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 4, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 30, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 9, 4, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 10, 10, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Libya)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 9, 25, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Tunisia = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1990, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2008, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__tunis = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tunisia))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Namibia = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1994, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 2017, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 2017, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, -60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$africa__windhoek = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 21, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Namibia))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__adak = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__anchorage = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__port_of_spain = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__anguilla = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__antigua = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$rules_Brazil = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1995, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1995, 1, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 1998, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 1999, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2001, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2006, 1, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2002, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2003, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2017, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2011, 1, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 1, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2014, 1, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2015, 2015, 1, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2019, 1, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2018, 2018, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__araguaina = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 14, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 8, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Arg = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1968, 1969, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1993, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1992, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 1999, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2009, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 28, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 17, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 6, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 4, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 15, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 18, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 23, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 8, 26, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__salta = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 4, 7, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_SanLuis = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2009, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2008, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 2, 14, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 9, 15, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 5, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 31, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 6, 25, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 0, 21, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_SanLuis)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 11, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 13, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 2, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 4, 30, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 9, 18, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__curacao = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__aruba = $justinmimbs$timezone_data$TimeZone$america__curacao;
    var $justinmimbs$timezone_data$TimeZone$rules_Para = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1978, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1991, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1995, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1995, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 2001, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 2001, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2004, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2003, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2009, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2009, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, $justinmimbs$timezone_data$TimeZone$maxYear, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2012, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, $justinmimbs$timezone_data$TimeZone$maxYear, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__asuncion = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Para))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__atikokan = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__bahia = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 16, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 9, 21, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Mexico = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 2000, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 2000, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2001, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2001, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__bahia_banderas = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 3, 4, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Barb = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1978, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1980, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__barbados = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Barb))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__belem = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Belize = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1982, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__belize = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Belize))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Canada = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, $justinmimbs$timezone_data$TimeZone$maxYear, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, $justinmimbs$timezone_data$TimeZone$maxYear, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__blanc_sablon = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__boa_vista = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_CO = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__bogota = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CO))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__boise = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 1, 3, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_NT_YK = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__cambridge_bay = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 10, 5, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__campo_grande = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__cancun = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 23, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 7, 2, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 1, 1, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__caracas = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 11, 9, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -270, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 1, 150, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__cayenne = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__panama = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__cayman = $justinmimbs$timezone_data$TimeZone$america__panama;
    var $justinmimbs$timezone_data$TimeZone$america__chicago = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__chihuahua = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $elm$time$Time$Sat = 5;
    var $justinmimbs$timezone_data$TimeZone$rules_CR = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1980, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1980, 5, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1992, 0, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 15), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__costa_rica = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_CR))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__creston = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__cuiaba = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 8, 24, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__danmarkshavn = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__dawson = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 9, 28, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Vanc = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1946, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1962, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__dawson_creek = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 7, 30, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__denver = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__detroit = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 3, 27, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__dominica = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$rules_Edm = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__edmonton = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Edm)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__eirunepe = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Salv = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1988, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1988, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__el_salvador = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Salv))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__fort_nelson = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__fortaleza = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Halifax = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1962, 1973, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1962, 1973, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__glace_bay = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_StJohns = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1951, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1960, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 1, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 1, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 1, 2, 120),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 1, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2011, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 1, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2010, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 1, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__goose_bay = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__grand_turk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 2, 8, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 180, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__grenada = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__guadeloupe = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$rules_Guat = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__guatemala = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guat))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Ecuador = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__guayaquil = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__guyana = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -225, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 6, 31, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__halifax = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Halifax)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Cuba = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1977, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1971, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1974, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1990, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1980, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1985, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 5), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1989, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 14), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1997, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1995, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 1999, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2003, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2010, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2010, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, $justinmimbs$timezone_data$TimeZone$maxYear, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, $justinmimbs$timezone_data$TimeZone$maxYear, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 0, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__havana = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cuba))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__hermosillo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__knox = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 27, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__marengo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 9, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__vevay = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 10, 4, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__indiana__winamac = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 2, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__inuvik = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 3, 29, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__iqaluit = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__jamaica = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__juneau = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 27, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 9, 26, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 6, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__kralendijk = $justinmimbs$timezone_data$TimeZone$america__curacao;
    var $justinmimbs$timezone_data$TimeZone$america__la_paz = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Peru = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1987, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1994, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1994, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__lima = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Peru))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__lower_princes = $justinmimbs$timezone_data$TimeZone$america__curacao;
    var $justinmimbs$timezone_data$TimeZone$america__maceio = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 9, 13, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 8, 4, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 22, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $elm$time$Time$Mon = 0;
    var $justinmimbs$timezone_data$TimeZone$rules_Nic = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1980, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1980, 5, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 23), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 60, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__managua = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 4, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 1, 16, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 240, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 24, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Nic))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__manaus = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 8, 28, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 22, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__marigot = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__martinique = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__matamoros = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__mazatlan = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__menominee = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 3, 29, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__merida = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 11, 23, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 11, 2, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__metlakatla = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 1, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 10, 4, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 0, 20, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__mexico_city = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__miquelon = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 4, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Moncton = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1946, 1972, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1957, 1972, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 1, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 1, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__moncton = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moncton)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__monterrey = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Uruguay = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1970, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1970, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 0, 2, 90),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 30),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1979, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1991, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1992, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2015, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2014, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__montevideo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 2, 10, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 11, 22, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Uruguay))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__montserrat = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$rules_Bahamas = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1964, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1964, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__nassau = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bahamas)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__new_york = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__nipigon = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__nome = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__noronha = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 10, 7, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__north_dakota__center = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 9, 25, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 9, 26, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__nuuk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__ojinaga = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 5, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__pangnirtung = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 3, 2, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__paramaribo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -210, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 9, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__phoenix = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Haiti = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1987, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1997, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1997, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2015, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2015, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2017, $justinmimbs$timezone_data$TimeZone$maxYear, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2017, $justinmimbs$timezone_data$TimeZone$maxYear, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__port_au_prince = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Haiti))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__porto_velho = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__puerto_rico = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Chile = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1969, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1969, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1970, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1971, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1972, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1986, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1987, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1990, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1989, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1996, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1997, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 1998, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 1999, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 2010, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2007, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 7, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2014, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2014, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2018, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2018, 7, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 240, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2019, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2), 180, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2019, $justinmimbs$timezone_data$TimeZone$maxYear, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2), 240, 0, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__punta_arenas = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__rainy_river = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__rankin_inlet = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__recife = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 8, 17, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 8, 30, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 15, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 8, 13, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 9, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__regina = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__resolute = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 3, 1, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 9, 29, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 2, 11, 180, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__rio_branco = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2013, 10, 10, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__santarem = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 8, 12, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 5, 24, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__santiago = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_DR = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1973, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 30),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1970, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1971, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1974, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__santo_domingo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_DR)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 9, 29, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 3, 60, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__sao_paulo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Brazil))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_C_Eur = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1980, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__scoresbysund = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__sitka = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 9, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__st_barthelemy = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__st_johns = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -210, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_StJohns)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 10, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -210, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__st_kitts = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__st_lucia = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__st_thomas = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__st_vincent = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__swift_current = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 3, 30, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Hond = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1988, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1988, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 7, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 0, 1), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__tegucigalpa = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hond))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Thule = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1992, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, $justinmimbs$timezone_data$TimeZone$maxYear, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, $justinmimbs$timezone_data$TimeZone$maxYear, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__thule = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Thule))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Toronto = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1950, 1973, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1957, 1973, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__thunder_bay = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1970, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__tijuana = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 20, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mexico)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__toronto = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Toronto)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__tortola = $justinmimbs$timezone_data$TimeZone$america__port_of_spain;
    var $justinmimbs$timezone_data$TimeZone$america__vancouver = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanc)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__whitehorse = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 10, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Winn = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1966, 1986, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1966, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 2005, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$america__winnipeg = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Winn)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__yakutat = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 10, 30, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$america__yellowknife = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NT_YK)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__casey = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 5, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1020, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 9, 22, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 2, 11, 240, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 7, 240, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 2, 17, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 9, 4, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 2, 8, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 9, 4, 1, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__davis = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 10, 1200, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 9, 28, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 1, 21, 1200, 0))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AT = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1968, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1971, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1981, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1986, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1990, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1999, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, $justinmimbs$timezone_data$TimeZone$maxYear, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$antarctica__macquarie = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__mawson = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 9, 18, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_NZ = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1989, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 2006, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 2007, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, $justinmimbs$timezone_data$TimeZone$maxYear, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__auckland = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NZ))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo = $justinmimbs$timezone_data$TimeZone$pacific__auckland;
    var $justinmimbs$timezone_data$TimeZone$antarctica__palmer = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Arg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__rothera = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 11, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__syowa = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Troll = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 120),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$antarctica__troll = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 1, 12, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Troll))));
    };
    var $justinmimbs$timezone_data$TimeZone$antarctica__vostok = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__oslo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen = $justinmimbs$timezone_data$TimeZone$europe__oslo;
    var $justinmimbs$timezone_data$TimeZone$asia__riyadh = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__aden = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
    var $justinmimbs$timezone_data$TimeZone$rules_RussiaAsia = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 2010, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__almaty = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Jordan = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1988, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1990, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1993, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1998, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1994, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 1998, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 1999, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 2002, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2001, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2012, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2003, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2011, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2013, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__amman = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Russia = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 2010, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__anadyr = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 780, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__aqtau = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__aqtobe = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__ashgabat = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__atyrau = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 2, 28, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Iraq = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1982, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1984, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1990, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1990, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 2007, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 180, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 180, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__baghdad = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 4, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iraq))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__qatar = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1972, 5, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__bahrain = $justinmimbs$timezone_data$TimeZone$asia__qatar;
    var $justinmimbs$timezone_data$TimeZone$rules_Azer = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 2015, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 240, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 2015, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 300, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_EUAsia = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__baku = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Azer))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__bangkok = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__barnaul = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 4, 28, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Lebanon = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1987, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1992, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__beirut = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Lebanon))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Kyrgyz = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1996, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 7), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1996, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 150, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 2004, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 150, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__bishkek = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 7, 31, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Kyrgyz)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 7, 12, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__brunei = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__chita = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Mongol = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2001, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2006, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2006, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2015, 2016, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2015, 2016, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__choibalsan = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 2, 31, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__colombo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 4, 25, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 390, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 26, 30, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2006, 3, 15, 30, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Syria = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1966, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1967, 1978, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1984, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1992, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1996, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(0), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2011, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__damascus = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Syria))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Dhaka = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 1380, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1440, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__dhaka = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2009, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Dhaka))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__dili = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 4, 3, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 8, 17, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__dubai = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__dushanbe = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 9, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Cyprus = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1980, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1997, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__famagusta = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 8, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2017, 9, 29, 60, 0))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Palestine = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 2005, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 2003, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 15), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2007, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(4), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 1, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2014, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(3), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2013, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2014, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2015, 2015, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2015, 2015, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2018, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2018, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2019, 2019, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2019, 2019, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2020, $justinmimbs$timezone_data$TimeZone$maxYear, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2020, $justinmimbs$timezone_data$TimeZone$maxYear, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 24), 60, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$Specification$Prev = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $justinmimbs$timezone_data$TimeZone$rules_Zion = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 1440, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 1440, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1984, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 1440, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1984, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 1440, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1987, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1988, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1990, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1994, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1994, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 1995, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 1998, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 1998, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 1999, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 1999, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(14), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2001, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2001, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2002, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2002, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2003, 2003, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2003, 2003, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2012, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Prev, 4, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(9), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(23), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, $justinmimbs$timezone_data$TimeZone$maxYear, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 4, 23), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__gaza = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 7, 29, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2008, 8, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 27, 1, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 7, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2012, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__hebron = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Jordan)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Palestine))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 5, 13, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_HK = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1965, 1976, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 210, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1965, 1976, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 210, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 210, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 210, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 210, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__hong_kong = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_HK))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__hovd = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__irkutsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Turkey = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1976, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 31), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1978, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1978, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1994, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 2006, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 2006, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__istanbul = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 5, 29, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 10, 1, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Turkey)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2007, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 28, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 31, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 25, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 10, 8, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 8, 7, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__istanbul = $justinmimbs$timezone_data$TimeZone$europe__istanbul;
    var $justinmimbs$timezone_data$TimeZone$asia__jakarta = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__jayapura = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__jerusalem = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Zion))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kabul = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 270, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kamchatka = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Pakistan = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2002, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2002, 2002, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 2), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2009, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(15), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__karachi = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 2, 26, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Pakistan))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kathmandu = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 345, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__khandyga = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kolkata = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 450, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kuching = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__kuwait = $justinmimbs$timezone_data$TimeZone$asia__riyadh;
    var $justinmimbs$timezone_data$TimeZone$rules_Macau = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1965, 1973, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 210, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1967, 1976, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 210, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 210, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1976, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 210, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(13), 210, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 210, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__macau = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Macau))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__magadan = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 3, 24, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__makassar = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Phil = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__manila = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Phil))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__muscat = $justinmimbs$timezone_data$TimeZone$asia__dubai;
    var $justinmimbs$timezone_data$TimeZone$asia__nicosia = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cyprus)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EUAsia))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__novosibirsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 4, 23, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 6, 24, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__omsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__oral = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__phnom_penh = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
    var $justinmimbs$timezone_data$TimeZone$asia__pontianak = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__pyongyang = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 7, 15, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 510, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 4, 4, 1410, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__qostanay = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__qyzylorda = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 9, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 11, 21, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__sakhalin = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__samarkand = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_ROK = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1988, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1988, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 180, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__seoul = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_ROK))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_PRC = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1991, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1991, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 11), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__shanghai = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_PRC))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__singapore = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 450, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Taiwan = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 6, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__taipei = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Taiwan))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__tashkent = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_E_EurAsia = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__tbilisi = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 8, 25, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_EurAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2004, 5, 27, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2005, 2, 27, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Iran = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1995, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1999, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1999, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2003, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2003, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2004, 2004, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2005, 2005, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2011, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2011, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2012, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2015, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2013, 2015, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2016, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2016, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2017, 2019, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2017, 2019, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2020, 2020, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2020, 2020, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2021, 2023, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2021, 2023, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2024, 2024, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2024, 2024, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2025, 2027, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2025, 2027, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2028, 2029, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2028, 2029, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2030, 2031, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2030, 2031, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2032, 2033, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2032, 2033, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2034, 2035, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2034, 2035, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2036, 2037, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2036, 2037, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 1440, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__tehran = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 210, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 10, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 210, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Iran))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__thimphu = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 330, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1987, 9, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__tokyo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__tomsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 4, 1, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 4, 29, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mongol))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__urumqi = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__ust_nera = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 3, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 8, 13, 0, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__vientiane = $justinmimbs$timezone_data$TimeZone$asia__bangkok;
    var $justinmimbs$timezone_data$TimeZone$asia__vladivostok = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__yakutsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__yangon = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 390, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Armenia = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$asia__yerevan = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 8, 24, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_RussiaAsia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Armenia))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Port = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(25), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1979, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1982, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1982, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_W_Eur = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1980, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$atlantic__azores = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 60, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 2, 28, 60, 0))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__bermuda = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 3, 28, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Canada)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_US))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__canary = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 3, 6, 0, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 8, 28, 60, 0))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 10, 25, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__faroe = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__madeira = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$atlantic__st_helena = $justinmimbs$timezone_data$TimeZone$africa__abidjan;
    var $justinmimbs$timezone_data$TimeZone$rules_Falk = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1985, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1984, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 2000, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 9), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 2000, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2010, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2010, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$atlantic__stanley = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 4, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 8, 15, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Falk)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 8, 5, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AS = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1985, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1990, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1994, 1994, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__adelaide = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 570, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 570, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AQ = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1971, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1991, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1992, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__brisbane = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AN = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1981, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1982, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1985, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1989, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1995, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__broken_hill = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 570, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 570, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 570, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AS))));
    };
    var $justinmimbs$timezone_data$TimeZone$australia__darwin = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 570, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AW = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1984, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1991, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(17), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__eucla = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 525, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
    };
    var $justinmimbs$timezone_data$TimeZone$australia__hobart = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AT))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Holiday = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1993, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1993, 1994, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__lindeman = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AQ)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 6, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Holiday))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_LH = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1984, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1985, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1985, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 30),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1989, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1986, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 2, 30),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1987, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 30),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1995, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 30),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 30),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 30)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__lord_howe = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 630, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 6, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 630, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_LH))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_AV = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1985, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1985, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1990, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1986, 1987, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1988, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1994, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1995, 2005, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 7, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2007, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2006, 2006, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, 2007, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$australia__melbourne = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AV))));
    };
    var $justinmimbs$timezone_data$TimeZone$australia__perth = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 480, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AW))));
    };
    var $justinmimbs$timezone_data$TimeZone$australia__sydney = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__amsterdam = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__andorra = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1985, 2, 31, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__astrakhan = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Greece = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(11), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1978, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 240, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 540, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__athens = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Greece)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__belgrade = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 10, 27, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__berlin = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__prague = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__bratislava = $justinmimbs$timezone_data$TimeZone$europe__prague;
    var $justinmimbs$timezone_data$TimeZone$europe__brussels = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_E_Eur = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1980, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1995, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_Romania = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 1380, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1993, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1991, 1993, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__bucharest = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 2, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Romania)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Hungary = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1983, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__budapest = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Hungary)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__zurich = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__busingen = $justinmimbs$timezone_data$TimeZone$europe__zurich;
    var $justinmimbs$timezone_data$TimeZone$rules_Moldova = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__chisinau = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 4, 6, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Moldova))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__copenhagen = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Eire = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1971, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 0, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1980, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 120, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1980, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23), 120, 0, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, $justinmimbs$timezone_data$TimeZone$maxYear, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1989, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23), 60, 0, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1995, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 60, 0, -60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, $justinmimbs$timezone_data$TimeZone$maxYear, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, -60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__dublin = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Eire))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__gibraltar = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_GB_Eire = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1980, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 16), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1980, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1995, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1989, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 23), 60, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 1995, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 60, 0, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__london = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1971, 9, 31, 120, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_GB_Eire)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__guernsey = $justinmimbs$timezone_data$TimeZone$europe__london;
    var $justinmimbs$timezone_data$TimeZone$rules_Finland = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1982, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1982, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__helsinki = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Finland)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__isle_of_man = $justinmimbs$timezone_data$TimeZone$europe__london;
    var $justinmimbs$timezone_data$TimeZone$europe__jersey = $justinmimbs$timezone_data$TimeZone$europe__london;
    var $justinmimbs$timezone_data$TimeZone$europe__kaliningrad = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__kiev = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__kirov = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__lisbon = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1976, 8, 26, 60, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Port)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1983, 8, 25, 60, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 8, 27, 60, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 60, 0))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 0, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__ljubljana = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$europe__luxembourg = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Spain = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1975, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 12), 1380, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1975, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 1380, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 1380, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__madrid = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Spain)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Italy = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1967, 1969, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1969, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1970, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1970, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1972, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1971, 1971, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1972, 1972, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1977, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1979, 4, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 22), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$rules_Malta = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 0, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1979, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1980, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__malta = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1973, 2, 31, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Malta)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__mariehamn = $justinmimbs$timezone_data$TimeZone$europe__helsinki;
    var $justinmimbs$timezone_data$TimeZone$europe__minsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_France = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 60, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 60, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__monaco = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__moscow = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__nicosia = $justinmimbs$timezone_data$TimeZone$asia__nicosia;
    var $justinmimbs$timezone_data$TimeZone$europe__paris = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_France)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__podgorica = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$rules_Latvia = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1996, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1996, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__riga = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Latvia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 21, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 1, 29, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2001, 0, 2, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__rome = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Italy)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__samara = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 9, 20, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2010, 2, 28, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__san_marino = $justinmimbs$timezone_data$TimeZone$europe__rome;
    var $justinmimbs$timezone_data$TimeZone$europe__sarajevo = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$europe__saratov = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 11, 4, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__simferopol = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 4, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 2, 31, 0, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 9, 27, 180, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 2, 30, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 2, 30, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__skopje = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$rules_Bulg = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 1380, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1982, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1), 1380, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 60, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1981, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__sofia = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 2, 31, 1380, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Bulg)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 8, 26, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1997, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__stockholm = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1980, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__tallinn = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 8, 24, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 8, 22, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 240, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2002, 1, 21, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Albania = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(8), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(5), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1979, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(4), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1981, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1981, 1981, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1982, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1982, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(3), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(18), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1984, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 0, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__tirane = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Albania)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1984, 6, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 19, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2016, 2, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__uzhgorod = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1990, 6, 1, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 180, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__vaduz = $justinmimbs$timezone_data$TimeZone$europe__zurich;
    var $justinmimbs$timezone_data$TimeZone$europe__vatican = $justinmimbs$timezone_data$TimeZone$europe__rome;
    var $justinmimbs$timezone_data$TimeZone$rules_Austria = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1980, 1980, 8, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 0, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$europe__vienna = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Austria)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1981, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__vilnius = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1989, 2, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 8, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_C_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 2, 29, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 9, 31, 60, 0)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2003, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__volgograd = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1992, 2, 29, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 2, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 9, 26, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2018, 9, 28, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2020, 11, 27, 120, 1))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__warsaw = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1977, 0, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_W_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1988, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 60, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $justinmimbs$timezone_data$TimeZone$europe__zagreb = $justinmimbs$timezone_data$TimeZone$europe__belgrade;
    var $justinmimbs$timezone_data$TimeZone$europe__zaporozhye = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 180, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Russia)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1991, 2, 31, 120, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_E_Eur)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1995, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 120, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_EU))));
    };
    var $elm$core$Dict$fromList = function(assocs) {
        return A3($elm$core$List$foldl, F2(function(_v0, dict) {
            var key = _v0.a;
            var value = _v0.b;
            return A3($elm$core$Dict$insert, key, value, dict);
        }), $elm$core$Dict$empty, assocs);
    };
    var $justinmimbs$timezone_data$TimeZone$indian__antananarivo = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$indian__chagos = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1996, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 360, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__christmas = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 420, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__cocos = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 390, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__comoro = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$indian__kerguelen = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__mahe = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__maldives = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Mauritius = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1982, 1982, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(10), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1983, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(21), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, 2008, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$indian__mauritius = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Mauritius))));
    };
    var $justinmimbs$timezone_data$TimeZone$indian__mayotte = $justinmimbs$timezone_data$TimeZone$africa__nairobi;
    var $justinmimbs$timezone_data$TimeZone$indian__reunion = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 240, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_WS = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 1), 240, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(5), 180, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 240, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, $justinmimbs$timezone_data$TimeZone$maxYear, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__apia = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 29, 1440, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 780, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_WS))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__bougainville = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2014, 11, 28, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Chatham = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 165, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1975, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 165, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1975, 1988, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 165, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1989, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 165, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1989, 1989, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 165, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 2006, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 165, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1990, 2007, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 165, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2007, $justinmimbs$timezone_data$TimeZone$maxYear, 8, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 165, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2008, $justinmimbs$timezone_data$TimeZone$maxYear, 3, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 165, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__chatham = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 765, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chatham))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__chuuk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__easter = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -420, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1982, 2, 14, 180, 0))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Chile))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Vanuatu = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 720, 0, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(30), 720, 0, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1983, 1991, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22), 1440, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1984, 1991, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1993, 0, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22), 1440, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1992, 1992, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 5, 22), 1440, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__efate = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Vanuatu))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__enderbury = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 780, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__fakaofo = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2011, 11, 30, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 780, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Fiji = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1998, 1999, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 2000, 1, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2009, 2009, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(29), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2010, 2, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2010, 2013, 9, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 21), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2011, 2011, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2012, 2013, 0, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2014, 0, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 18), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2014, 2018, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2015, $justinmimbs$timezone_data$TimeZone$maxYear, 0, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 12), 180, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2019, 2019, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2020, 2020, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(20), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2021, $justinmimbs$timezone_data$TimeZone$maxYear, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 8), 120, 2, 60)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__fiji = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Fiji))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__funafuti = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__galapagos = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -300, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1986, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -360, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Ecuador))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__gambier = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Guam = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1969, 0, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 1, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1969, 5, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1969, 1969, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(31), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1971, 3, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1970, 1971, 8, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1973, 1973, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(16), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1974, 1974, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 4, $justinmimbs$timezone_data$TimeZone$Specification$Day(26), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1976, 1976, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(22), 121, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 3, $justinmimbs$timezone_data$TimeZone$Specification$Day(24), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1977, 7, $justinmimbs$timezone_data$TimeZone$Specification$Day(28), 120, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__guam = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Guam)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2000, 11, 23, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__honolulu = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__kiritimati = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -640, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 9, 1, 0, 2)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1994, 11, 31, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 840, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__kosrae = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__kwajalein = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1993, 7, 20, 1440, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__majuro = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__marquesas = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -570, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__pago_pago = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__midway = $justinmimbs$timezone_data$TimeZone$pacific__pago_pago;
    var $justinmimbs$timezone_data$TimeZone$pacific__nauru = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 690, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1979, 1, 10, 120, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__niue = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -690, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 9, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__norfolk = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 690, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1974, 9, 27, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 690, $justinmimbs$timezone_data$TimeZone$Specification$Save(60)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1975, 2, 2, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 690, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2015, 9, 4, 120, 1)),
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 2019, 6, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_AN))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_NC = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1977, 1978, 11, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1979, 1, $justinmimbs$timezone_data$TimeZone$Specification$Day(27), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1996, 1996, 11, $justinmimbs$timezone_data$TimeZone$Specification$Day(1), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1997, 1997, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(2), 120, 1, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__noumea = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_NC))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__palau = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 540, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__pitcairn = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -510, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1998, 3, 27, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -480, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__pohnpei = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 660, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__port_moresby = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Cook = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1978, 1978, 10, $justinmimbs$timezone_data$TimeZone$Specification$Day(12), 0, 2, 30),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1991, 2, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 0, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1979, 1990, 9, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 0, 2, 30)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__rarotonga = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -630, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1978, 10, 12, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -600, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Cook))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__saipan = $justinmimbs$timezone_data$TimeZone$pacific__guam;
    var $justinmimbs$timezone_data$TimeZone$pacific__tahiti = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, -600, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__tarawa = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$rules_Tonga = _List_fromArray([
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 1999, 1999, 9, $justinmimbs$timezone_data$TimeZone$Specification$Day(7), 120, 1, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2000, 2, $justinmimbs$timezone_data$TimeZone$Specification$Day(19), 120, 1, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2000, 2001, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2001, 2002, 0, $justinmimbs$timezone_data$TimeZone$Specification$Last(6), 120, 2, 0),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2016, 2016, 10, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 1), 120, 2, 60),
        A7($justinmimbs$timezone_data$TimeZone$Specification$Rule, 2017, 2017, 0, A2($justinmimbs$timezone_data$TimeZone$Specification$Next, 6, 15), 180, 2, 0)
    ]);
    var $justinmimbs$timezone_data$TimeZone$pacific__tongatapu = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_fromArray([
            _Utils_Tuple2(A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 780, $justinmimbs$timezone_data$TimeZone$Specification$Save(0)), A5($justinmimbs$timezone_data$TimeZone$Specification$DateTime, 1999, 0, 1, 0, 2))
        ]), A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 780, $justinmimbs$timezone_data$TimeZone$Specification$Rules($justinmimbs$timezone_data$TimeZone$rules_Tonga))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__wake = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$pacific__wallis = function(_v0) {
        return $justinmimbs$timezone_data$TimeZone$fromSpecification(A2($justinmimbs$timezone_data$TimeZone$Specification$Zone, _List_Nil, A2($justinmimbs$timezone_data$TimeZone$Specification$ZoneState, 720, $justinmimbs$timezone_data$TimeZone$Specification$Save(0))));
    };
    var $justinmimbs$timezone_data$TimeZone$zones = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2('Africa/Abidjan', $justinmimbs$timezone_data$TimeZone$africa__abidjan),
        _Utils_Tuple2('Africa/Accra', $justinmimbs$timezone_data$TimeZone$africa__accra),
        _Utils_Tuple2('Africa/Addis_Ababa', $justinmimbs$timezone_data$TimeZone$africa__addis_ababa),
        _Utils_Tuple2('Africa/Algiers', $justinmimbs$timezone_data$TimeZone$africa__algiers),
        _Utils_Tuple2('Africa/Asmara', $justinmimbs$timezone_data$TimeZone$africa__asmara),
        _Utils_Tuple2('Africa/Bamako', $justinmimbs$timezone_data$TimeZone$africa__bamako),
        _Utils_Tuple2('Africa/Bangui', $justinmimbs$timezone_data$TimeZone$africa__bangui),
        _Utils_Tuple2('Africa/Banjul', $justinmimbs$timezone_data$TimeZone$africa__banjul),
        _Utils_Tuple2('Africa/Bissau', $justinmimbs$timezone_data$TimeZone$africa__bissau),
        _Utils_Tuple2('Africa/Blantyre', $justinmimbs$timezone_data$TimeZone$africa__blantyre),
        _Utils_Tuple2('Africa/Brazzaville', $justinmimbs$timezone_data$TimeZone$africa__brazzaville),
        _Utils_Tuple2('Africa/Bujumbura', $justinmimbs$timezone_data$TimeZone$africa__bujumbura),
        _Utils_Tuple2('Africa/Cairo', $justinmimbs$timezone_data$TimeZone$africa__cairo),
        _Utils_Tuple2('Africa/Casablanca', $justinmimbs$timezone_data$TimeZone$africa__casablanca),
        _Utils_Tuple2('Africa/Ceuta', $justinmimbs$timezone_data$TimeZone$africa__ceuta),
        _Utils_Tuple2('Africa/Conakry', $justinmimbs$timezone_data$TimeZone$africa__conakry),
        _Utils_Tuple2('Africa/Dakar', $justinmimbs$timezone_data$TimeZone$africa__dakar),
        _Utils_Tuple2('Africa/Dar_es_Salaam', $justinmimbs$timezone_data$TimeZone$africa__dar_es_salaam),
        _Utils_Tuple2('Africa/Djibouti', $justinmimbs$timezone_data$TimeZone$africa__djibouti),
        _Utils_Tuple2('Africa/Douala', $justinmimbs$timezone_data$TimeZone$africa__douala),
        _Utils_Tuple2('Africa/El_Aaiun', $justinmimbs$timezone_data$TimeZone$africa__el_aaiun),
        _Utils_Tuple2('Africa/Freetown', $justinmimbs$timezone_data$TimeZone$africa__freetown),
        _Utils_Tuple2('Africa/Gaborone', $justinmimbs$timezone_data$TimeZone$africa__gaborone),
        _Utils_Tuple2('Africa/Harare', $justinmimbs$timezone_data$TimeZone$africa__harare),
        _Utils_Tuple2('Africa/Johannesburg', $justinmimbs$timezone_data$TimeZone$africa__johannesburg),
        _Utils_Tuple2('Africa/Juba', $justinmimbs$timezone_data$TimeZone$africa__juba),
        _Utils_Tuple2('Africa/Kampala', $justinmimbs$timezone_data$TimeZone$africa__kampala),
        _Utils_Tuple2('Africa/Khartoum', $justinmimbs$timezone_data$TimeZone$africa__khartoum),
        _Utils_Tuple2('Africa/Kigali', $justinmimbs$timezone_data$TimeZone$africa__kigali),
        _Utils_Tuple2('Africa/Kinshasa', $justinmimbs$timezone_data$TimeZone$africa__kinshasa),
        _Utils_Tuple2('Africa/Lagos', $justinmimbs$timezone_data$TimeZone$africa__lagos),
        _Utils_Tuple2('Africa/Libreville', $justinmimbs$timezone_data$TimeZone$africa__libreville),
        _Utils_Tuple2('Africa/Lome', $justinmimbs$timezone_data$TimeZone$africa__lome),
        _Utils_Tuple2('Africa/Luanda', $justinmimbs$timezone_data$TimeZone$africa__luanda),
        _Utils_Tuple2('Africa/Lubumbashi', $justinmimbs$timezone_data$TimeZone$africa__lubumbashi),
        _Utils_Tuple2('Africa/Lusaka', $justinmimbs$timezone_data$TimeZone$africa__lusaka),
        _Utils_Tuple2('Africa/Malabo', $justinmimbs$timezone_data$TimeZone$africa__malabo),
        _Utils_Tuple2('Africa/Maputo', $justinmimbs$timezone_data$TimeZone$africa__maputo),
        _Utils_Tuple2('Africa/Maseru', $justinmimbs$timezone_data$TimeZone$africa__maseru),
        _Utils_Tuple2('Africa/Mbabane', $justinmimbs$timezone_data$TimeZone$africa__mbabane),
        _Utils_Tuple2('Africa/Mogadishu', $justinmimbs$timezone_data$TimeZone$africa__mogadishu),
        _Utils_Tuple2('Africa/Monrovia', $justinmimbs$timezone_data$TimeZone$africa__monrovia),
        _Utils_Tuple2('Africa/Nairobi', $justinmimbs$timezone_data$TimeZone$africa__nairobi),
        _Utils_Tuple2('Africa/Ndjamena', $justinmimbs$timezone_data$TimeZone$africa__ndjamena),
        _Utils_Tuple2('Africa/Niamey', $justinmimbs$timezone_data$TimeZone$africa__niamey),
        _Utils_Tuple2('Africa/Nouakchott', $justinmimbs$timezone_data$TimeZone$africa__nouakchott),
        _Utils_Tuple2('Africa/Ouagadougou', $justinmimbs$timezone_data$TimeZone$africa__ouagadougou),
        _Utils_Tuple2('Africa/Porto-Novo', $justinmimbs$timezone_data$TimeZone$africa__porto_novo),
        _Utils_Tuple2('Africa/Sao_Tome', $justinmimbs$timezone_data$TimeZone$africa__sao_tome),
        _Utils_Tuple2('Africa/Tripoli', $justinmimbs$timezone_data$TimeZone$africa__tripoli),
        _Utils_Tuple2('Africa/Tunis', $justinmimbs$timezone_data$TimeZone$africa__tunis),
        _Utils_Tuple2('Africa/Windhoek', $justinmimbs$timezone_data$TimeZone$africa__windhoek),
        _Utils_Tuple2('America/Adak', $justinmimbs$timezone_data$TimeZone$america__adak),
        _Utils_Tuple2('America/Anchorage', $justinmimbs$timezone_data$TimeZone$america__anchorage),
        _Utils_Tuple2('America/Anguilla', $justinmimbs$timezone_data$TimeZone$america__anguilla),
        _Utils_Tuple2('America/Antigua', $justinmimbs$timezone_data$TimeZone$america__antigua),
        _Utils_Tuple2('America/Araguaina', $justinmimbs$timezone_data$TimeZone$america__araguaina),
        _Utils_Tuple2('America/Argentina/Buenos_Aires', $justinmimbs$timezone_data$TimeZone$america__argentina__buenos_aires),
        _Utils_Tuple2('America/Argentina/Catamarca', $justinmimbs$timezone_data$TimeZone$america__argentina__catamarca),
        _Utils_Tuple2('America/Argentina/Cordoba', $justinmimbs$timezone_data$TimeZone$america__argentina__cordoba),
        _Utils_Tuple2('America/Argentina/Jujuy', $justinmimbs$timezone_data$TimeZone$america__argentina__jujuy),
        _Utils_Tuple2('America/Argentina/La_Rioja', $justinmimbs$timezone_data$TimeZone$america__argentina__la_rioja),
        _Utils_Tuple2('America/Argentina/Mendoza', $justinmimbs$timezone_data$TimeZone$america__argentina__mendoza),
        _Utils_Tuple2('America/Argentina/Rio_Gallegos', $justinmimbs$timezone_data$TimeZone$america__argentina__rio_gallegos),
        _Utils_Tuple2('America/Argentina/Salta', $justinmimbs$timezone_data$TimeZone$america__argentina__salta),
        _Utils_Tuple2('America/Argentina/San_Juan', $justinmimbs$timezone_data$TimeZone$america__argentina__san_juan),
        _Utils_Tuple2('America/Argentina/San_Luis', $justinmimbs$timezone_data$TimeZone$america__argentina__san_luis),
        _Utils_Tuple2('America/Argentina/Tucuman', $justinmimbs$timezone_data$TimeZone$america__argentina__tucuman),
        _Utils_Tuple2('America/Argentina/Ushuaia', $justinmimbs$timezone_data$TimeZone$america__argentina__ushuaia),
        _Utils_Tuple2('America/Aruba', $justinmimbs$timezone_data$TimeZone$america__aruba),
        _Utils_Tuple2('America/Asuncion', $justinmimbs$timezone_data$TimeZone$america__asuncion),
        _Utils_Tuple2('America/Atikokan', $justinmimbs$timezone_data$TimeZone$america__atikokan),
        _Utils_Tuple2('America/Bahia', $justinmimbs$timezone_data$TimeZone$america__bahia),
        _Utils_Tuple2('America/Bahia_Banderas', $justinmimbs$timezone_data$TimeZone$america__bahia_banderas),
        _Utils_Tuple2('America/Barbados', $justinmimbs$timezone_data$TimeZone$america__barbados),
        _Utils_Tuple2('America/Belem', $justinmimbs$timezone_data$TimeZone$america__belem),
        _Utils_Tuple2('America/Belize', $justinmimbs$timezone_data$TimeZone$america__belize),
        _Utils_Tuple2('America/Blanc-Sablon', $justinmimbs$timezone_data$TimeZone$america__blanc_sablon),
        _Utils_Tuple2('America/Boa_Vista', $justinmimbs$timezone_data$TimeZone$america__boa_vista),
        _Utils_Tuple2('America/Bogota', $justinmimbs$timezone_data$TimeZone$america__bogota),
        _Utils_Tuple2('America/Boise', $justinmimbs$timezone_data$TimeZone$america__boise),
        _Utils_Tuple2('America/Cambridge_Bay', $justinmimbs$timezone_data$TimeZone$america__cambridge_bay),
        _Utils_Tuple2('America/Campo_Grande', $justinmimbs$timezone_data$TimeZone$america__campo_grande),
        _Utils_Tuple2('America/Cancun', $justinmimbs$timezone_data$TimeZone$america__cancun),
        _Utils_Tuple2('America/Caracas', $justinmimbs$timezone_data$TimeZone$america__caracas),
        _Utils_Tuple2('America/Cayenne', $justinmimbs$timezone_data$TimeZone$america__cayenne),
        _Utils_Tuple2('America/Cayman', $justinmimbs$timezone_data$TimeZone$america__cayman),
        _Utils_Tuple2('America/Chicago', $justinmimbs$timezone_data$TimeZone$america__chicago),
        _Utils_Tuple2('America/Chihuahua', $justinmimbs$timezone_data$TimeZone$america__chihuahua),
        _Utils_Tuple2('America/Costa_Rica', $justinmimbs$timezone_data$TimeZone$america__costa_rica),
        _Utils_Tuple2('America/Creston', $justinmimbs$timezone_data$TimeZone$america__creston),
        _Utils_Tuple2('America/Cuiaba', $justinmimbs$timezone_data$TimeZone$america__cuiaba),
        _Utils_Tuple2('America/Curacao', $justinmimbs$timezone_data$TimeZone$america__curacao),
        _Utils_Tuple2('America/Danmarkshavn', $justinmimbs$timezone_data$TimeZone$america__danmarkshavn),
        _Utils_Tuple2('America/Dawson', $justinmimbs$timezone_data$TimeZone$america__dawson),
        _Utils_Tuple2('America/Dawson_Creek', $justinmimbs$timezone_data$TimeZone$america__dawson_creek),
        _Utils_Tuple2('America/Denver', $justinmimbs$timezone_data$TimeZone$america__denver),
        _Utils_Tuple2('America/Detroit', $justinmimbs$timezone_data$TimeZone$america__detroit),
        _Utils_Tuple2('America/Dominica', $justinmimbs$timezone_data$TimeZone$america__dominica),
        _Utils_Tuple2('America/Edmonton', $justinmimbs$timezone_data$TimeZone$america__edmonton),
        _Utils_Tuple2('America/Eirunepe', $justinmimbs$timezone_data$TimeZone$america__eirunepe),
        _Utils_Tuple2('America/El_Salvador', $justinmimbs$timezone_data$TimeZone$america__el_salvador),
        _Utils_Tuple2('America/Fort_Nelson', $justinmimbs$timezone_data$TimeZone$america__fort_nelson),
        _Utils_Tuple2('America/Fortaleza', $justinmimbs$timezone_data$TimeZone$america__fortaleza),
        _Utils_Tuple2('America/Glace_Bay', $justinmimbs$timezone_data$TimeZone$america__glace_bay),
        _Utils_Tuple2('America/Goose_Bay', $justinmimbs$timezone_data$TimeZone$america__goose_bay),
        _Utils_Tuple2('America/Grand_Turk', $justinmimbs$timezone_data$TimeZone$america__grand_turk),
        _Utils_Tuple2('America/Grenada', $justinmimbs$timezone_data$TimeZone$america__grenada),
        _Utils_Tuple2('America/Guadeloupe', $justinmimbs$timezone_data$TimeZone$america__guadeloupe),
        _Utils_Tuple2('America/Guatemala', $justinmimbs$timezone_data$TimeZone$america__guatemala),
        _Utils_Tuple2('America/Guayaquil', $justinmimbs$timezone_data$TimeZone$america__guayaquil),
        _Utils_Tuple2('America/Guyana', $justinmimbs$timezone_data$TimeZone$america__guyana),
        _Utils_Tuple2('America/Halifax', $justinmimbs$timezone_data$TimeZone$america__halifax),
        _Utils_Tuple2('America/Havana', $justinmimbs$timezone_data$TimeZone$america__havana),
        _Utils_Tuple2('America/Hermosillo', $justinmimbs$timezone_data$TimeZone$america__hermosillo),
        _Utils_Tuple2('America/Indiana/Indianapolis', $justinmimbs$timezone_data$TimeZone$america__indiana__indianapolis),
        _Utils_Tuple2('America/Indiana/Knox', $justinmimbs$timezone_data$TimeZone$america__indiana__knox),
        _Utils_Tuple2('America/Indiana/Marengo', $justinmimbs$timezone_data$TimeZone$america__indiana__marengo),
        _Utils_Tuple2('America/Indiana/Petersburg', $justinmimbs$timezone_data$TimeZone$america__indiana__petersburg),
        _Utils_Tuple2('America/Indiana/Tell_City', $justinmimbs$timezone_data$TimeZone$america__indiana__tell_city),
        _Utils_Tuple2('America/Indiana/Vevay', $justinmimbs$timezone_data$TimeZone$america__indiana__vevay),
        _Utils_Tuple2('America/Indiana/Vincennes', $justinmimbs$timezone_data$TimeZone$america__indiana__vincennes),
        _Utils_Tuple2('America/Indiana/Winamac', $justinmimbs$timezone_data$TimeZone$america__indiana__winamac),
        _Utils_Tuple2('America/Inuvik', $justinmimbs$timezone_data$TimeZone$america__inuvik),
        _Utils_Tuple2('America/Iqaluit', $justinmimbs$timezone_data$TimeZone$america__iqaluit),
        _Utils_Tuple2('America/Jamaica', $justinmimbs$timezone_data$TimeZone$america__jamaica),
        _Utils_Tuple2('America/Juneau', $justinmimbs$timezone_data$TimeZone$america__juneau),
        _Utils_Tuple2('America/Kentucky/Louisville', $justinmimbs$timezone_data$TimeZone$america__kentucky__louisville),
        _Utils_Tuple2('America/Kentucky/Monticello', $justinmimbs$timezone_data$TimeZone$america__kentucky__monticello),
        _Utils_Tuple2('America/Kralendijk', $justinmimbs$timezone_data$TimeZone$america__kralendijk),
        _Utils_Tuple2('America/La_Paz', $justinmimbs$timezone_data$TimeZone$america__la_paz),
        _Utils_Tuple2('America/Lima', $justinmimbs$timezone_data$TimeZone$america__lima),
        _Utils_Tuple2('America/Los_Angeles', $justinmimbs$timezone_data$TimeZone$america__los_angeles),
        _Utils_Tuple2('America/Lower_Princes', $justinmimbs$timezone_data$TimeZone$america__lower_princes),
        _Utils_Tuple2('America/Maceio', $justinmimbs$timezone_data$TimeZone$america__maceio),
        _Utils_Tuple2('America/Managua', $justinmimbs$timezone_data$TimeZone$america__managua),
        _Utils_Tuple2('America/Manaus', $justinmimbs$timezone_data$TimeZone$america__manaus),
        _Utils_Tuple2('America/Marigot', $justinmimbs$timezone_data$TimeZone$america__marigot),
        _Utils_Tuple2('America/Martinique', $justinmimbs$timezone_data$TimeZone$america__martinique),
        _Utils_Tuple2('America/Matamoros', $justinmimbs$timezone_data$TimeZone$america__matamoros),
        _Utils_Tuple2('America/Mazatlan', $justinmimbs$timezone_data$TimeZone$america__mazatlan),
        _Utils_Tuple2('America/Menominee', $justinmimbs$timezone_data$TimeZone$america__menominee),
        _Utils_Tuple2('America/Merida', $justinmimbs$timezone_data$TimeZone$america__merida),
        _Utils_Tuple2('America/Metlakatla', $justinmimbs$timezone_data$TimeZone$america__metlakatla),
        _Utils_Tuple2('America/Mexico_City', $justinmimbs$timezone_data$TimeZone$america__mexico_city),
        _Utils_Tuple2('America/Miquelon', $justinmimbs$timezone_data$TimeZone$america__miquelon),
        _Utils_Tuple2('America/Moncton', $justinmimbs$timezone_data$TimeZone$america__moncton),
        _Utils_Tuple2('America/Monterrey', $justinmimbs$timezone_data$TimeZone$america__monterrey),
        _Utils_Tuple2('America/Montevideo', $justinmimbs$timezone_data$TimeZone$america__montevideo),
        _Utils_Tuple2('America/Montserrat', $justinmimbs$timezone_data$TimeZone$america__montserrat),
        _Utils_Tuple2('America/Nassau', $justinmimbs$timezone_data$TimeZone$america__nassau),
        _Utils_Tuple2('America/New_York', $justinmimbs$timezone_data$TimeZone$america__new_york),
        _Utils_Tuple2('America/Nipigon', $justinmimbs$timezone_data$TimeZone$america__nipigon),
        _Utils_Tuple2('America/Nome', $justinmimbs$timezone_data$TimeZone$america__nome),
        _Utils_Tuple2('America/Noronha', $justinmimbs$timezone_data$TimeZone$america__noronha),
        _Utils_Tuple2('America/North_Dakota/Beulah', $justinmimbs$timezone_data$TimeZone$america__north_dakota__beulah),
        _Utils_Tuple2('America/North_Dakota/Center', $justinmimbs$timezone_data$TimeZone$america__north_dakota__center),
        _Utils_Tuple2('America/North_Dakota/New_Salem', $justinmimbs$timezone_data$TimeZone$america__north_dakota__new_salem),
        _Utils_Tuple2('America/Nuuk', $justinmimbs$timezone_data$TimeZone$america__nuuk),
        _Utils_Tuple2('America/Ojinaga', $justinmimbs$timezone_data$TimeZone$america__ojinaga),
        _Utils_Tuple2('America/Panama', $justinmimbs$timezone_data$TimeZone$america__panama),
        _Utils_Tuple2('America/Pangnirtung', $justinmimbs$timezone_data$TimeZone$america__pangnirtung),
        _Utils_Tuple2('America/Paramaribo', $justinmimbs$timezone_data$TimeZone$america__paramaribo),
        _Utils_Tuple2('America/Phoenix', $justinmimbs$timezone_data$TimeZone$america__phoenix),
        _Utils_Tuple2('America/Port-au-Prince', $justinmimbs$timezone_data$TimeZone$america__port_au_prince),
        _Utils_Tuple2('America/Port_of_Spain', $justinmimbs$timezone_data$TimeZone$america__port_of_spain),
        _Utils_Tuple2('America/Porto_Velho', $justinmimbs$timezone_data$TimeZone$america__porto_velho),
        _Utils_Tuple2('America/Puerto_Rico', $justinmimbs$timezone_data$TimeZone$america__puerto_rico),
        _Utils_Tuple2('America/Punta_Arenas', $justinmimbs$timezone_data$TimeZone$america__punta_arenas),
        _Utils_Tuple2('America/Rainy_River', $justinmimbs$timezone_data$TimeZone$america__rainy_river),
        _Utils_Tuple2('America/Rankin_Inlet', $justinmimbs$timezone_data$TimeZone$america__rankin_inlet),
        _Utils_Tuple2('America/Recife', $justinmimbs$timezone_data$TimeZone$america__recife),
        _Utils_Tuple2('America/Regina', $justinmimbs$timezone_data$TimeZone$america__regina),
        _Utils_Tuple2('America/Resolute', $justinmimbs$timezone_data$TimeZone$america__resolute),
        _Utils_Tuple2('America/Rio_Branco', $justinmimbs$timezone_data$TimeZone$america__rio_branco),
        _Utils_Tuple2('America/Santarem', $justinmimbs$timezone_data$TimeZone$america__santarem),
        _Utils_Tuple2('America/Santiago', $justinmimbs$timezone_data$TimeZone$america__santiago),
        _Utils_Tuple2('America/Santo_Domingo', $justinmimbs$timezone_data$TimeZone$america__santo_domingo),
        _Utils_Tuple2('America/Sao_Paulo', $justinmimbs$timezone_data$TimeZone$america__sao_paulo),
        _Utils_Tuple2('America/Scoresbysund', $justinmimbs$timezone_data$TimeZone$america__scoresbysund),
        _Utils_Tuple2('America/Sitka', $justinmimbs$timezone_data$TimeZone$america__sitka),
        _Utils_Tuple2('America/St_Barthelemy', $justinmimbs$timezone_data$TimeZone$america__st_barthelemy),
        _Utils_Tuple2('America/St_Johns', $justinmimbs$timezone_data$TimeZone$america__st_johns),
        _Utils_Tuple2('America/St_Kitts', $justinmimbs$timezone_data$TimeZone$america__st_kitts),
        _Utils_Tuple2('America/St_Lucia', $justinmimbs$timezone_data$TimeZone$america__st_lucia),
        _Utils_Tuple2('America/St_Thomas', $justinmimbs$timezone_data$TimeZone$america__st_thomas),
        _Utils_Tuple2('America/St_Vincent', $justinmimbs$timezone_data$TimeZone$america__st_vincent),
        _Utils_Tuple2('America/Swift_Current', $justinmimbs$timezone_data$TimeZone$america__swift_current),
        _Utils_Tuple2('America/Tegucigalpa', $justinmimbs$timezone_data$TimeZone$america__tegucigalpa),
        _Utils_Tuple2('America/Thule', $justinmimbs$timezone_data$TimeZone$america__thule),
        _Utils_Tuple2('America/Thunder_Bay', $justinmimbs$timezone_data$TimeZone$america__thunder_bay),
        _Utils_Tuple2('America/Tijuana', $justinmimbs$timezone_data$TimeZone$america__tijuana),
        _Utils_Tuple2('America/Toronto', $justinmimbs$timezone_data$TimeZone$america__toronto),
        _Utils_Tuple2('America/Tortola', $justinmimbs$timezone_data$TimeZone$america__tortola),
        _Utils_Tuple2('America/Vancouver', $justinmimbs$timezone_data$TimeZone$america__vancouver),
        _Utils_Tuple2('America/Whitehorse', $justinmimbs$timezone_data$TimeZone$america__whitehorse),
        _Utils_Tuple2('America/Winnipeg', $justinmimbs$timezone_data$TimeZone$america__winnipeg),
        _Utils_Tuple2('America/Yakutat', $justinmimbs$timezone_data$TimeZone$america__yakutat),
        _Utils_Tuple2('America/Yellowknife', $justinmimbs$timezone_data$TimeZone$america__yellowknife),
        _Utils_Tuple2('Antarctica/Casey', $justinmimbs$timezone_data$TimeZone$antarctica__casey),
        _Utils_Tuple2('Antarctica/Davis', $justinmimbs$timezone_data$TimeZone$antarctica__davis),
        _Utils_Tuple2('Antarctica/DumontDUrville', $justinmimbs$timezone_data$TimeZone$antarctica__dumontdurville),
        _Utils_Tuple2('Antarctica/Macquarie', $justinmimbs$timezone_data$TimeZone$antarctica__macquarie),
        _Utils_Tuple2('Antarctica/Mawson', $justinmimbs$timezone_data$TimeZone$antarctica__mawson),
        _Utils_Tuple2('Antarctica/McMurdo', $justinmimbs$timezone_data$TimeZone$antarctica__mcmurdo),
        _Utils_Tuple2('Antarctica/Palmer', $justinmimbs$timezone_data$TimeZone$antarctica__palmer),
        _Utils_Tuple2('Antarctica/Rothera', $justinmimbs$timezone_data$TimeZone$antarctica__rothera),
        _Utils_Tuple2('Antarctica/Syowa', $justinmimbs$timezone_data$TimeZone$antarctica__syowa),
        _Utils_Tuple2('Antarctica/Troll', $justinmimbs$timezone_data$TimeZone$antarctica__troll),
        _Utils_Tuple2('Antarctica/Vostok', $justinmimbs$timezone_data$TimeZone$antarctica__vostok),
        _Utils_Tuple2('Arctic/Longyearbyen', $justinmimbs$timezone_data$TimeZone$arctic__longyearbyen),
        _Utils_Tuple2('Asia/Aden', $justinmimbs$timezone_data$TimeZone$asia__aden),
        _Utils_Tuple2('Asia/Almaty', $justinmimbs$timezone_data$TimeZone$asia__almaty),
        _Utils_Tuple2('Asia/Amman', $justinmimbs$timezone_data$TimeZone$asia__amman),
        _Utils_Tuple2('Asia/Anadyr', $justinmimbs$timezone_data$TimeZone$asia__anadyr),
        _Utils_Tuple2('Asia/Aqtau', $justinmimbs$timezone_data$TimeZone$asia__aqtau),
        _Utils_Tuple2('Asia/Aqtobe', $justinmimbs$timezone_data$TimeZone$asia__aqtobe),
        _Utils_Tuple2('Asia/Ashgabat', $justinmimbs$timezone_data$TimeZone$asia__ashgabat),
        _Utils_Tuple2('Asia/Atyrau', $justinmimbs$timezone_data$TimeZone$asia__atyrau),
        _Utils_Tuple2('Asia/Baghdad', $justinmimbs$timezone_data$TimeZone$asia__baghdad),
        _Utils_Tuple2('Asia/Bahrain', $justinmimbs$timezone_data$TimeZone$asia__bahrain),
        _Utils_Tuple2('Asia/Baku', $justinmimbs$timezone_data$TimeZone$asia__baku),
        _Utils_Tuple2('Asia/Bangkok', $justinmimbs$timezone_data$TimeZone$asia__bangkok),
        _Utils_Tuple2('Asia/Barnaul', $justinmimbs$timezone_data$TimeZone$asia__barnaul),
        _Utils_Tuple2('Asia/Beirut', $justinmimbs$timezone_data$TimeZone$asia__beirut),
        _Utils_Tuple2('Asia/Bishkek', $justinmimbs$timezone_data$TimeZone$asia__bishkek),
        _Utils_Tuple2('Asia/Brunei', $justinmimbs$timezone_data$TimeZone$asia__brunei),
        _Utils_Tuple2('Asia/Chita', $justinmimbs$timezone_data$TimeZone$asia__chita),
        _Utils_Tuple2('Asia/Choibalsan', $justinmimbs$timezone_data$TimeZone$asia__choibalsan),
        _Utils_Tuple2('Asia/Colombo', $justinmimbs$timezone_data$TimeZone$asia__colombo),
        _Utils_Tuple2('Asia/Damascus', $justinmimbs$timezone_data$TimeZone$asia__damascus),
        _Utils_Tuple2('Asia/Dhaka', $justinmimbs$timezone_data$TimeZone$asia__dhaka),
        _Utils_Tuple2('Asia/Dili', $justinmimbs$timezone_data$TimeZone$asia__dili),
        _Utils_Tuple2('Asia/Dubai', $justinmimbs$timezone_data$TimeZone$asia__dubai),
        _Utils_Tuple2('Asia/Dushanbe', $justinmimbs$timezone_data$TimeZone$asia__dushanbe),
        _Utils_Tuple2('Asia/Famagusta', $justinmimbs$timezone_data$TimeZone$asia__famagusta),
        _Utils_Tuple2('Asia/Gaza', $justinmimbs$timezone_data$TimeZone$asia__gaza),
        _Utils_Tuple2('Asia/Hebron', $justinmimbs$timezone_data$TimeZone$asia__hebron),
        _Utils_Tuple2('Asia/Ho_Chi_Minh', $justinmimbs$timezone_data$TimeZone$asia__ho_chi_minh),
        _Utils_Tuple2('Asia/Hong_Kong', $justinmimbs$timezone_data$TimeZone$asia__hong_kong),
        _Utils_Tuple2('Asia/Hovd', $justinmimbs$timezone_data$TimeZone$asia__hovd),
        _Utils_Tuple2('Asia/Irkutsk', $justinmimbs$timezone_data$TimeZone$asia__irkutsk),
        _Utils_Tuple2('Asia/Istanbul', $justinmimbs$timezone_data$TimeZone$asia__istanbul),
        _Utils_Tuple2('Asia/Jakarta', $justinmimbs$timezone_data$TimeZone$asia__jakarta),
        _Utils_Tuple2('Asia/Jayapura', $justinmimbs$timezone_data$TimeZone$asia__jayapura),
        _Utils_Tuple2('Asia/Jerusalem', $justinmimbs$timezone_data$TimeZone$asia__jerusalem),
        _Utils_Tuple2('Asia/Kabul', $justinmimbs$timezone_data$TimeZone$asia__kabul),
        _Utils_Tuple2('Asia/Kamchatka', $justinmimbs$timezone_data$TimeZone$asia__kamchatka),
        _Utils_Tuple2('Asia/Karachi', $justinmimbs$timezone_data$TimeZone$asia__karachi),
        _Utils_Tuple2('Asia/Kathmandu', $justinmimbs$timezone_data$TimeZone$asia__kathmandu),
        _Utils_Tuple2('Asia/Khandyga', $justinmimbs$timezone_data$TimeZone$asia__khandyga),
        _Utils_Tuple2('Asia/Kolkata', $justinmimbs$timezone_data$TimeZone$asia__kolkata),
        _Utils_Tuple2('Asia/Krasnoyarsk', $justinmimbs$timezone_data$TimeZone$asia__krasnoyarsk),
        _Utils_Tuple2('Asia/Kuala_Lumpur', $justinmimbs$timezone_data$TimeZone$asia__kuala_lumpur),
        _Utils_Tuple2('Asia/Kuching', $justinmimbs$timezone_data$TimeZone$asia__kuching),
        _Utils_Tuple2('Asia/Kuwait', $justinmimbs$timezone_data$TimeZone$asia__kuwait),
        _Utils_Tuple2('Asia/Macau', $justinmimbs$timezone_data$TimeZone$asia__macau),
        _Utils_Tuple2('Asia/Magadan', $justinmimbs$timezone_data$TimeZone$asia__magadan),
        _Utils_Tuple2('Asia/Makassar', $justinmimbs$timezone_data$TimeZone$asia__makassar),
        _Utils_Tuple2('Asia/Manila', $justinmimbs$timezone_data$TimeZone$asia__manila),
        _Utils_Tuple2('Asia/Muscat', $justinmimbs$timezone_data$TimeZone$asia__muscat),
        _Utils_Tuple2('Asia/Nicosia', $justinmimbs$timezone_data$TimeZone$asia__nicosia),
        _Utils_Tuple2('Asia/Novokuznetsk', $justinmimbs$timezone_data$TimeZone$asia__novokuznetsk),
        _Utils_Tuple2('Asia/Novosibirsk', $justinmimbs$timezone_data$TimeZone$asia__novosibirsk),
        _Utils_Tuple2('Asia/Omsk', $justinmimbs$timezone_data$TimeZone$asia__omsk),
        _Utils_Tuple2('Asia/Oral', $justinmimbs$timezone_data$TimeZone$asia__oral),
        _Utils_Tuple2('Asia/Phnom_Penh', $justinmimbs$timezone_data$TimeZone$asia__phnom_penh),
        _Utils_Tuple2('Asia/Pontianak', $justinmimbs$timezone_data$TimeZone$asia__pontianak),
        _Utils_Tuple2('Asia/Pyongyang', $justinmimbs$timezone_data$TimeZone$asia__pyongyang),
        _Utils_Tuple2('Asia/Qatar', $justinmimbs$timezone_data$TimeZone$asia__qatar),
        _Utils_Tuple2('Asia/Qostanay', $justinmimbs$timezone_data$TimeZone$asia__qostanay),
        _Utils_Tuple2('Asia/Qyzylorda', $justinmimbs$timezone_data$TimeZone$asia__qyzylorda),
        _Utils_Tuple2('Asia/Riyadh', $justinmimbs$timezone_data$TimeZone$asia__riyadh),
        _Utils_Tuple2('Asia/Sakhalin', $justinmimbs$timezone_data$TimeZone$asia__sakhalin),
        _Utils_Tuple2('Asia/Samarkand', $justinmimbs$timezone_data$TimeZone$asia__samarkand),
        _Utils_Tuple2('Asia/Seoul', $justinmimbs$timezone_data$TimeZone$asia__seoul),
        _Utils_Tuple2('Asia/Shanghai', $justinmimbs$timezone_data$TimeZone$asia__shanghai),
        _Utils_Tuple2('Asia/Singapore', $justinmimbs$timezone_data$TimeZone$asia__singapore),
        _Utils_Tuple2('Asia/Srednekolymsk', $justinmimbs$timezone_data$TimeZone$asia__srednekolymsk),
        _Utils_Tuple2('Asia/Taipei', $justinmimbs$timezone_data$TimeZone$asia__taipei),
        _Utils_Tuple2('Asia/Tashkent', $justinmimbs$timezone_data$TimeZone$asia__tashkent),
        _Utils_Tuple2('Asia/Tbilisi', $justinmimbs$timezone_data$TimeZone$asia__tbilisi),
        _Utils_Tuple2('Asia/Tehran', $justinmimbs$timezone_data$TimeZone$asia__tehran),
        _Utils_Tuple2('Asia/Thimphu', $justinmimbs$timezone_data$TimeZone$asia__thimphu),
        _Utils_Tuple2('Asia/Tokyo', $justinmimbs$timezone_data$TimeZone$asia__tokyo),
        _Utils_Tuple2('Asia/Tomsk', $justinmimbs$timezone_data$TimeZone$asia__tomsk),
        _Utils_Tuple2('Asia/Ulaanbaatar', $justinmimbs$timezone_data$TimeZone$asia__ulaanbaatar),
        _Utils_Tuple2('Asia/Urumqi', $justinmimbs$timezone_data$TimeZone$asia__urumqi),
        _Utils_Tuple2('Asia/Ust-Nera', $justinmimbs$timezone_data$TimeZone$asia__ust_nera),
        _Utils_Tuple2('Asia/Vientiane', $justinmimbs$timezone_data$TimeZone$asia__vientiane),
        _Utils_Tuple2('Asia/Vladivostok', $justinmimbs$timezone_data$TimeZone$asia__vladivostok),
        _Utils_Tuple2('Asia/Yakutsk', $justinmimbs$timezone_data$TimeZone$asia__yakutsk),
        _Utils_Tuple2('Asia/Yangon', $justinmimbs$timezone_data$TimeZone$asia__yangon),
        _Utils_Tuple2('Asia/Yekaterinburg', $justinmimbs$timezone_data$TimeZone$asia__yekaterinburg),
        _Utils_Tuple2('Asia/Yerevan', $justinmimbs$timezone_data$TimeZone$asia__yerevan),
        _Utils_Tuple2('Atlantic/Azores', $justinmimbs$timezone_data$TimeZone$atlantic__azores),
        _Utils_Tuple2('Atlantic/Bermuda', $justinmimbs$timezone_data$TimeZone$atlantic__bermuda),
        _Utils_Tuple2('Atlantic/Canary', $justinmimbs$timezone_data$TimeZone$atlantic__canary),
        _Utils_Tuple2('Atlantic/Cape_Verde', $justinmimbs$timezone_data$TimeZone$atlantic__cape_verde),
        _Utils_Tuple2('Atlantic/Faroe', $justinmimbs$timezone_data$TimeZone$atlantic__faroe),
        _Utils_Tuple2('Atlantic/Madeira', $justinmimbs$timezone_data$TimeZone$atlantic__madeira),
        _Utils_Tuple2('Atlantic/Reykjavik', $justinmimbs$timezone_data$TimeZone$atlantic__reykjavik),
        _Utils_Tuple2('Atlantic/South_Georgia', $justinmimbs$timezone_data$TimeZone$atlantic__south_georgia),
        _Utils_Tuple2('Atlantic/St_Helena', $justinmimbs$timezone_data$TimeZone$atlantic__st_helena),
        _Utils_Tuple2('Atlantic/Stanley', $justinmimbs$timezone_data$TimeZone$atlantic__stanley),
        _Utils_Tuple2('Australia/Adelaide', $justinmimbs$timezone_data$TimeZone$australia__adelaide),
        _Utils_Tuple2('Australia/Brisbane', $justinmimbs$timezone_data$TimeZone$australia__brisbane),
        _Utils_Tuple2('Australia/Broken_Hill', $justinmimbs$timezone_data$TimeZone$australia__broken_hill),
        _Utils_Tuple2('Australia/Darwin', $justinmimbs$timezone_data$TimeZone$australia__darwin),
        _Utils_Tuple2('Australia/Eucla', $justinmimbs$timezone_data$TimeZone$australia__eucla),
        _Utils_Tuple2('Australia/Hobart', $justinmimbs$timezone_data$TimeZone$australia__hobart),
        _Utils_Tuple2('Australia/Lindeman', $justinmimbs$timezone_data$TimeZone$australia__lindeman),
        _Utils_Tuple2('Australia/Lord_Howe', $justinmimbs$timezone_data$TimeZone$australia__lord_howe),
        _Utils_Tuple2('Australia/Melbourne', $justinmimbs$timezone_data$TimeZone$australia__melbourne),
        _Utils_Tuple2('Australia/Perth', $justinmimbs$timezone_data$TimeZone$australia__perth),
        _Utils_Tuple2('Australia/Sydney', $justinmimbs$timezone_data$TimeZone$australia__sydney),
        _Utils_Tuple2('Europe/Amsterdam', $justinmimbs$timezone_data$TimeZone$europe__amsterdam),
        _Utils_Tuple2('Europe/Andorra', $justinmimbs$timezone_data$TimeZone$europe__andorra),
        _Utils_Tuple2('Europe/Astrakhan', $justinmimbs$timezone_data$TimeZone$europe__astrakhan),
        _Utils_Tuple2('Europe/Athens', $justinmimbs$timezone_data$TimeZone$europe__athens),
        _Utils_Tuple2('Europe/Belgrade', $justinmimbs$timezone_data$TimeZone$europe__belgrade),
        _Utils_Tuple2('Europe/Berlin', $justinmimbs$timezone_data$TimeZone$europe__berlin),
        _Utils_Tuple2('Europe/Bratislava', $justinmimbs$timezone_data$TimeZone$europe__bratislava),
        _Utils_Tuple2('Europe/Brussels', $justinmimbs$timezone_data$TimeZone$europe__brussels),
        _Utils_Tuple2('Europe/Bucharest', $justinmimbs$timezone_data$TimeZone$europe__bucharest),
        _Utils_Tuple2('Europe/Budapest', $justinmimbs$timezone_data$TimeZone$europe__budapest),
        _Utils_Tuple2('Europe/Busingen', $justinmimbs$timezone_data$TimeZone$europe__busingen),
        _Utils_Tuple2('Europe/Chisinau', $justinmimbs$timezone_data$TimeZone$europe__chisinau),
        _Utils_Tuple2('Europe/Copenhagen', $justinmimbs$timezone_data$TimeZone$europe__copenhagen),
        _Utils_Tuple2('Europe/Dublin', $justinmimbs$timezone_data$TimeZone$europe__dublin),
        _Utils_Tuple2('Europe/Gibraltar', $justinmimbs$timezone_data$TimeZone$europe__gibraltar),
        _Utils_Tuple2('Europe/Guernsey', $justinmimbs$timezone_data$TimeZone$europe__guernsey),
        _Utils_Tuple2('Europe/Helsinki', $justinmimbs$timezone_data$TimeZone$europe__helsinki),
        _Utils_Tuple2('Europe/Isle_of_Man', $justinmimbs$timezone_data$TimeZone$europe__isle_of_man),
        _Utils_Tuple2('Europe/Istanbul', $justinmimbs$timezone_data$TimeZone$europe__istanbul),
        _Utils_Tuple2('Europe/Jersey', $justinmimbs$timezone_data$TimeZone$europe__jersey),
        _Utils_Tuple2('Europe/Kaliningrad', $justinmimbs$timezone_data$TimeZone$europe__kaliningrad),
        _Utils_Tuple2('Europe/Kiev', $justinmimbs$timezone_data$TimeZone$europe__kiev),
        _Utils_Tuple2('Europe/Kirov', $justinmimbs$timezone_data$TimeZone$europe__kirov),
        _Utils_Tuple2('Europe/Lisbon', $justinmimbs$timezone_data$TimeZone$europe__lisbon),
        _Utils_Tuple2('Europe/Ljubljana', $justinmimbs$timezone_data$TimeZone$europe__ljubljana),
        _Utils_Tuple2('Europe/London', $justinmimbs$timezone_data$TimeZone$europe__london),
        _Utils_Tuple2('Europe/Luxembourg', $justinmimbs$timezone_data$TimeZone$europe__luxembourg),
        _Utils_Tuple2('Europe/Madrid', $justinmimbs$timezone_data$TimeZone$europe__madrid),
        _Utils_Tuple2('Europe/Malta', $justinmimbs$timezone_data$TimeZone$europe__malta),
        _Utils_Tuple2('Europe/Mariehamn', $justinmimbs$timezone_data$TimeZone$europe__mariehamn),
        _Utils_Tuple2('Europe/Minsk', $justinmimbs$timezone_data$TimeZone$europe__minsk),
        _Utils_Tuple2('Europe/Monaco', $justinmimbs$timezone_data$TimeZone$europe__monaco),
        _Utils_Tuple2('Europe/Moscow', $justinmimbs$timezone_data$TimeZone$europe__moscow),
        _Utils_Tuple2('Europe/Nicosia', $justinmimbs$timezone_data$TimeZone$europe__nicosia),
        _Utils_Tuple2('Europe/Oslo', $justinmimbs$timezone_data$TimeZone$europe__oslo),
        _Utils_Tuple2('Europe/Paris', $justinmimbs$timezone_data$TimeZone$europe__paris),
        _Utils_Tuple2('Europe/Podgorica', $justinmimbs$timezone_data$TimeZone$europe__podgorica),
        _Utils_Tuple2('Europe/Prague', $justinmimbs$timezone_data$TimeZone$europe__prague),
        _Utils_Tuple2('Europe/Riga', $justinmimbs$timezone_data$TimeZone$europe__riga),
        _Utils_Tuple2('Europe/Rome', $justinmimbs$timezone_data$TimeZone$europe__rome),
        _Utils_Tuple2('Europe/Samara', $justinmimbs$timezone_data$TimeZone$europe__samara),
        _Utils_Tuple2('Europe/San_Marino', $justinmimbs$timezone_data$TimeZone$europe__san_marino),
        _Utils_Tuple2('Europe/Sarajevo', $justinmimbs$timezone_data$TimeZone$europe__sarajevo),
        _Utils_Tuple2('Europe/Saratov', $justinmimbs$timezone_data$TimeZone$europe__saratov),
        _Utils_Tuple2('Europe/Simferopol', $justinmimbs$timezone_data$TimeZone$europe__simferopol),
        _Utils_Tuple2('Europe/Skopje', $justinmimbs$timezone_data$TimeZone$europe__skopje),
        _Utils_Tuple2('Europe/Sofia', $justinmimbs$timezone_data$TimeZone$europe__sofia),
        _Utils_Tuple2('Europe/Stockholm', $justinmimbs$timezone_data$TimeZone$europe__stockholm),
        _Utils_Tuple2('Europe/Tallinn', $justinmimbs$timezone_data$TimeZone$europe__tallinn),
        _Utils_Tuple2('Europe/Tirane', $justinmimbs$timezone_data$TimeZone$europe__tirane),
        _Utils_Tuple2('Europe/Ulyanovsk', $justinmimbs$timezone_data$TimeZone$europe__ulyanovsk),
        _Utils_Tuple2('Europe/Uzhgorod', $justinmimbs$timezone_data$TimeZone$europe__uzhgorod),
        _Utils_Tuple2('Europe/Vaduz', $justinmimbs$timezone_data$TimeZone$europe__vaduz),
        _Utils_Tuple2('Europe/Vatican', $justinmimbs$timezone_data$TimeZone$europe__vatican),
        _Utils_Tuple2('Europe/Vienna', $justinmimbs$timezone_data$TimeZone$europe__vienna),
        _Utils_Tuple2('Europe/Vilnius', $justinmimbs$timezone_data$TimeZone$europe__vilnius),
        _Utils_Tuple2('Europe/Volgograd', $justinmimbs$timezone_data$TimeZone$europe__volgograd),
        _Utils_Tuple2('Europe/Warsaw', $justinmimbs$timezone_data$TimeZone$europe__warsaw),
        _Utils_Tuple2('Europe/Zagreb', $justinmimbs$timezone_data$TimeZone$europe__zagreb),
        _Utils_Tuple2('Europe/Zaporozhye', $justinmimbs$timezone_data$TimeZone$europe__zaporozhye),
        _Utils_Tuple2('Europe/Zurich', $justinmimbs$timezone_data$TimeZone$europe__zurich),
        _Utils_Tuple2('Indian/Antananarivo', $justinmimbs$timezone_data$TimeZone$indian__antananarivo),
        _Utils_Tuple2('Indian/Chagos', $justinmimbs$timezone_data$TimeZone$indian__chagos),
        _Utils_Tuple2('Indian/Christmas', $justinmimbs$timezone_data$TimeZone$indian__christmas),
        _Utils_Tuple2('Indian/Cocos', $justinmimbs$timezone_data$TimeZone$indian__cocos),
        _Utils_Tuple2('Indian/Comoro', $justinmimbs$timezone_data$TimeZone$indian__comoro),
        _Utils_Tuple2('Indian/Kerguelen', $justinmimbs$timezone_data$TimeZone$indian__kerguelen),
        _Utils_Tuple2('Indian/Mahe', $justinmimbs$timezone_data$TimeZone$indian__mahe),
        _Utils_Tuple2('Indian/Maldives', $justinmimbs$timezone_data$TimeZone$indian__maldives),
        _Utils_Tuple2('Indian/Mauritius', $justinmimbs$timezone_data$TimeZone$indian__mauritius),
        _Utils_Tuple2('Indian/Mayotte', $justinmimbs$timezone_data$TimeZone$indian__mayotte),
        _Utils_Tuple2('Indian/Reunion', $justinmimbs$timezone_data$TimeZone$indian__reunion),
        _Utils_Tuple2('Pacific/Apia', $justinmimbs$timezone_data$TimeZone$pacific__apia),
        _Utils_Tuple2('Pacific/Auckland', $justinmimbs$timezone_data$TimeZone$pacific__auckland),
        _Utils_Tuple2('Pacific/Bougainville', $justinmimbs$timezone_data$TimeZone$pacific__bougainville),
        _Utils_Tuple2('Pacific/Chatham', $justinmimbs$timezone_data$TimeZone$pacific__chatham),
        _Utils_Tuple2('Pacific/Chuuk', $justinmimbs$timezone_data$TimeZone$pacific__chuuk),
        _Utils_Tuple2('Pacific/Easter', $justinmimbs$timezone_data$TimeZone$pacific__easter),
        _Utils_Tuple2('Pacific/Efate', $justinmimbs$timezone_data$TimeZone$pacific__efate),
        _Utils_Tuple2('Pacific/Enderbury', $justinmimbs$timezone_data$TimeZone$pacific__enderbury),
        _Utils_Tuple2('Pacific/Fakaofo', $justinmimbs$timezone_data$TimeZone$pacific__fakaofo),
        _Utils_Tuple2('Pacific/Fiji', $justinmimbs$timezone_data$TimeZone$pacific__fiji),
        _Utils_Tuple2('Pacific/Funafuti', $justinmimbs$timezone_data$TimeZone$pacific__funafuti),
        _Utils_Tuple2('Pacific/Galapagos', $justinmimbs$timezone_data$TimeZone$pacific__galapagos),
        _Utils_Tuple2('Pacific/Gambier', $justinmimbs$timezone_data$TimeZone$pacific__gambier),
        _Utils_Tuple2('Pacific/Guadalcanal', $justinmimbs$timezone_data$TimeZone$pacific__guadalcanal),
        _Utils_Tuple2('Pacific/Guam', $justinmimbs$timezone_data$TimeZone$pacific__guam),
        _Utils_Tuple2('Pacific/Honolulu', $justinmimbs$timezone_data$TimeZone$pacific__honolulu),
        _Utils_Tuple2('Pacific/Kiritimati', $justinmimbs$timezone_data$TimeZone$pacific__kiritimati),
        _Utils_Tuple2('Pacific/Kosrae', $justinmimbs$timezone_data$TimeZone$pacific__kosrae),
        _Utils_Tuple2('Pacific/Kwajalein', $justinmimbs$timezone_data$TimeZone$pacific__kwajalein),
        _Utils_Tuple2('Pacific/Majuro', $justinmimbs$timezone_data$TimeZone$pacific__majuro),
        _Utils_Tuple2('Pacific/Marquesas', $justinmimbs$timezone_data$TimeZone$pacific__marquesas),
        _Utils_Tuple2('Pacific/Midway', $justinmimbs$timezone_data$TimeZone$pacific__midway),
        _Utils_Tuple2('Pacific/Nauru', $justinmimbs$timezone_data$TimeZone$pacific__nauru),
        _Utils_Tuple2('Pacific/Niue', $justinmimbs$timezone_data$TimeZone$pacific__niue),
        _Utils_Tuple2('Pacific/Norfolk', $justinmimbs$timezone_data$TimeZone$pacific__norfolk),
        _Utils_Tuple2('Pacific/Noumea', $justinmimbs$timezone_data$TimeZone$pacific__noumea),
        _Utils_Tuple2('Pacific/Pago_Pago', $justinmimbs$timezone_data$TimeZone$pacific__pago_pago),
        _Utils_Tuple2('Pacific/Palau', $justinmimbs$timezone_data$TimeZone$pacific__palau),
        _Utils_Tuple2('Pacific/Pitcairn', $justinmimbs$timezone_data$TimeZone$pacific__pitcairn),
        _Utils_Tuple2('Pacific/Pohnpei', $justinmimbs$timezone_data$TimeZone$pacific__pohnpei),
        _Utils_Tuple2('Pacific/Port_Moresby', $justinmimbs$timezone_data$TimeZone$pacific__port_moresby),
        _Utils_Tuple2('Pacific/Rarotonga', $justinmimbs$timezone_data$TimeZone$pacific__rarotonga),
        _Utils_Tuple2('Pacific/Saipan', $justinmimbs$timezone_data$TimeZone$pacific__saipan),
        _Utils_Tuple2('Pacific/Tahiti', $justinmimbs$timezone_data$TimeZone$pacific__tahiti),
        _Utils_Tuple2('Pacific/Tarawa', $justinmimbs$timezone_data$TimeZone$pacific__tarawa),
        _Utils_Tuple2('Pacific/Tongatapu', $justinmimbs$timezone_data$TimeZone$pacific__tongatapu),
        _Utils_Tuple2('Pacific/Wake', $justinmimbs$timezone_data$TimeZone$pacific__wake),
        _Utils_Tuple2('Pacific/Wallis', $justinmimbs$timezone_data$TimeZone$pacific__wallis)
    ]));
    var $justinmimbs$timezone_data$TimeZone$getZone = A2($elm$core$Task$andThen, function(nameOrOffset) {
        if (!nameOrOffset.$) {
            var zoneName = nameOrOffset.a;
            var _v1 = A2($elm$core$Dict$get, zoneName, $justinmimbs$timezone_data$TimeZone$zones);
            if (!_v1.$) {
                var zone = _v1.a;
                return $elm$core$Task$succeed(_Utils_Tuple2(zoneName, zone(0)));
            } else return $elm$core$Task$fail($justinmimbs$timezone_data$TimeZone$NoDataForZoneName(zoneName));
        } else return $elm$core$Task$fail($justinmimbs$timezone_data$TimeZone$NoZoneName);
    }, $elm$time$Time$getZoneName);
    var $author$project$Components$GlobalSearch$Closed = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$GlobalSearch$GotSearchPermissions = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Utils$Maybe$toBool = function(maybe) {
        if (!maybe.$) return true;
        else return false;
    };
    var $author$project$Api$Data$clientHasAuthToken = function(_v0) {
        var client = _v0;
        return $author$project$Utils$Maybe$toBool(client.e7);
    };
    var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
    var $author$project$Api$Provider$SearchPermissions$All$SearchPermissions = $elm$core$Basics$identity;
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
    var $author$project$Api$Provider$SearchPermissions$Shared$SearchPermissions = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SearchPermissions$Shared$Record = F4(function(id, attributes, searchable, name) {
        return {
            vD: attributes,
            aef: id,
            zr: name,
            ZA: searchable
        };
    });
    var $elm$json$Json$Decode$list = _Json_decodeList;
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(function(key, valDecoder, decoder) {
        return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$field, key, valDecoder), decoder);
    });
    var $elm$json$Json$Decode$string = _Json_decodeString;
    var $author$project$Api$Provider$SearchPermissions$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'searchable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'attributes', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SearchPermissions$Shared$Record)))));
    var $author$project$Api$Provider$SearchPermissions$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SearchPermissions$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SearchPermissions$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SearchPermissions$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $elm$http$Http$BadStatus_ = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $elm$http$Http$BadUrl_ = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$http$Http$GoodStatus_ = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $elm$http$Http$NetworkError_ = {
        $: 2
    };
    var $elm$http$Http$Receiving = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$http$Http$Sending = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$http$Http$Timeout_ = {
        $: 1
    };
    var $elm$core$Maybe$isJust = function(maybe) {
        if (!maybe.$) return true;
        else return false;
    };
    var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
    var $elm$http$Http$expectStringResponse = F2(function(toMsg, toResult) {
        return A3(_Http_expect, '', $elm$core$Basics$identity, A2($elm$core$Basics$composeR, toResult, toMsg));
    });
    var $author$project$Api$Data$Failure = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Data$Success = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Data$fromResult = function(result) {
        if (!result.$) {
            var _v1 = result.a;
            var value = _v1.a;
            var headers = _v1.b;
            return A2($author$project$Api$Data$Success, value, headers);
        } else {
            var reasons = result.a;
            return $author$project$Api$Data$Failure(reasons);
        }
    };
    var $author$project$Api$Data$BadStatus = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Data$BadUrl = {
        $: 1
    };
    var $author$project$Api$Data$Conflict = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Data$Decoder = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Data$Forbidden = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Data$GatewayError = {
        $: 4
    };
    var $author$project$Api$Data$Network = {
        $: 3
    };
    var $author$project$Api$Data$NotFound = {
        $: 5
    };
    var $author$project$Api$Data$Timeout = {
        $: 2
    };
    var $author$project$Api$Data$Unauthorized = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$json$Json$Decode$at = F2(function(fields, decoder) {
        return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
    });
    var $elm$core$String$replace = F3(function(before, after, string) {
        return A2($elm$core$String$join, after, A2($elm$core$String$split, before, string));
    });
    var $author$project$Api$Data$decodeErrorToString = function(decodeError) {
        switch(decodeError.$){
            case 0:
                return $elm$json$Json$Decode$errorToString(decodeError);
            case 1:
                var index = decodeError.a;
                var error = decodeError.b;
                return $elm$core$String$fromInt(index) + (' -> ' + $author$project$Api$Data$decodeErrorToString(error));
            case 2:
                var errors = decodeError.a;
                return A2($elm$core$String$join, '\n', A2($elm$core$List$map, $author$project$Api$Data$decodeErrorToString, errors));
            default:
                var message = decodeError.a;
                return message + ('\n' + A3($elm$core$String$replace, message, '', A3($elm$core$String$replace, '  ', '', A3($elm$core$String$replace, '\n', '', A3($elm$core$String$replace, 'Problem with the given value:', '', $elm$json$Json$Decode$errorToString(decodeError))))));
        }
    };
    var $elm$json$Json$Decode$decodeString = _Json_runOnString;
    var $author$project$Api$Data$InternalServerError = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $elm$core$Result$toMaybe = function(result) {
        if (!result.$) {
            var v = result.a;
            return $elm$core$Maybe$Just(v);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Data$handleServerError = function(body) {
        var decodedMessage = A2($elm$json$Json$Decode$decodeString, A2($elm$json$Json$Decode$at, _List_fromArray([
            'message'
        ]), $elm$json$Json$Decode$string), body);
        return $elm$core$Result$Err($author$project$Api$Data$InternalServerError($elm$core$Result$toMaybe(decodedMessage)));
    };
    var $author$project$Api$Data$handleJsonResponse = F2(function(decoder, response) {
        switch(response.$){
            case 0:
                return $elm$core$Result$Err($author$project$Api$Data$BadUrl);
            case 1:
                return $elm$core$Result$Err($author$project$Api$Data$Timeout);
            case 2:
                return $elm$core$Result$Err($author$project$Api$Data$Network);
            case 3:
                var metadata = response.a;
                var body = response.b;
                var _v1 = metadata._7;
                switch(_v1){
                    case 404:
                        return $elm$core$Result$Err($author$project$Api$Data$NotFound);
                    case 401:
                        var decodedMessage = A2($elm$json$Json$Decode$decodeString, A2($elm$json$Json$Decode$at, _List_fromArray([
                            'message'
                        ]), $elm$json$Json$Decode$string), body);
                        return $elm$core$Result$Err($author$project$Api$Data$Unauthorized($elm$core$Result$toMaybe(decodedMessage)));
                    case 403:
                        var decodedMessage = A2($elm$json$Json$Decode$decodeString, A2($elm$json$Json$Decode$at, _List_fromArray([
                            'message'
                        ]), $elm$json$Json$Decode$string), body);
                        return $elm$core$Result$Err($author$project$Api$Data$Forbidden($elm$core$Result$toMaybe(decodedMessage)));
                    case 409:
                        var decodedMessage = A2($elm$json$Json$Decode$decodeString, A2($elm$json$Json$Decode$at, _List_fromArray([
                            'message'
                        ]), $elm$json$Json$Decode$string), body);
                        return $elm$core$Result$Err($author$project$Api$Data$Conflict($elm$core$Result$toMaybe(decodedMessage)));
                    case 500:
                        return $author$project$Api$Data$handleServerError(body);
                    case 504:
                        return $author$project$Api$Data$handleServerError(body);
                    case 502:
                        return $elm$core$Result$Err($author$project$Api$Data$GatewayError);
                    default:
                        var decodedError = A2($elm$json$Json$Decode$decodeString, A2($elm$json$Json$Decode$at, _List_fromArray([
                            'message'
                        ]), $elm$json$Json$Decode$string), body);
                        if (!decodedError.$) {
                            var error = decodedError.a;
                            return $elm$core$Result$Err(A2($author$project$Api$Data$BadStatus, metadata._7, error));
                        } else {
                            var decoderError = decodedError.a;
                            return $elm$core$Result$Err($author$project$Api$Data$Decoder('[' + (metadata.aaT + ('] ' + $author$project$Api$Data$decodeErrorToString(decoderError)))));
                        }
                }
            default:
                var metadata = response.a;
                var body = response.b;
                var jsonBody = $elm$core$String$isEmpty(body) ? '{}' : body;
                var _v3 = A2($elm$json$Json$Decode$decodeString, decoder, jsonBody);
                if (!_v3.$) {
                    var decoded = _v3.a;
                    return $elm$core$Result$Ok(_Utils_Tuple2(decoded, metadata.iL));
                } else {
                    var error = _v3.a;
                    return $elm$core$Result$Err($author$project$Api$Data$Decoder('[' + (metadata.aaT + ('] ' + $author$project$Api$Data$decodeErrorToString(error)))));
                }
        }
    });
    var $author$project$Api$Data$expectJson = F2(function(toMsg, decoder) {
        return A2($elm$http$Http$expectStringResponse, A2($elm$core$Basics$composeR, $author$project$Api$Data$fromResult, toMsg), $author$project$Api$Data$handleJsonResponse(decoder));
    });
    var $elm$http$Http$Request = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$http$Http$State = F2(function(reqs, subs) {
        return {
            YD: reqs,
            $q: subs
        };
    });
    var $elm$http$Http$init = $elm$core$Task$succeed(A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
    var $elm$core$Process$kill = _Scheduler_kill;
    var $elm$core$Process$spawn = _Scheduler_spawn;
    var $elm$http$Http$updateReqs = F3(function(router, cmds, reqs) {
        updateReqs: while(true){
            if (!cmds.b) return $elm$core$Task$succeed(reqs);
            else {
                var cmd = cmds.a;
                var otherCmds = cmds.b;
                if (!cmd.$) {
                    var tracker = cmd.a;
                    var _v2 = A2($elm$core$Dict$get, tracker, reqs);
                    if (_v2.$ === 1) {
                        var $temp$router = router, $temp$cmds = otherCmds, $temp$reqs = reqs;
                        router = $temp$router;
                        cmds = $temp$cmds;
                        reqs = $temp$reqs;
                        continue updateReqs;
                    } else {
                        var pid = _v2.a;
                        return A2($elm$core$Task$andThen, function(_v3) {
                            return A3($elm$http$Http$updateReqs, router, otherCmds, A2($elm$core$Dict$remove, tracker, reqs));
                        }, $elm$core$Process$kill(pid));
                    }
                } else {
                    var req = cmd.a;
                    return A2($elm$core$Task$andThen, function(pid) {
                        var _v4 = req.tu;
                        if (_v4.$ === 1) return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
                        else {
                            var tracker = _v4.a;
                            return A3($elm$http$Http$updateReqs, router, otherCmds, A3($elm$core$Dict$insert, tracker, pid, reqs));
                        }
                    }, $elm$core$Process$spawn(A3(_Http_toTask, router, $elm$core$Platform$sendToApp(router), req)));
                }
            }
        }
    });
    var $elm$http$Http$onEffects = F4(function(router, cmds, subs, state) {
        return A2($elm$core$Task$andThen, function(reqs) {
            return $elm$core$Task$succeed(A2($elm$http$Http$State, reqs, subs));
        }, A3($elm$http$Http$updateReqs, router, cmds, state.YD));
    });
    var $elm$core$List$maybeCons = F3(function(f, mx, xs) {
        var _v0 = f(mx);
        if (!_v0.$) {
            var x = _v0.a;
            return A2($elm$core$List$cons, x, xs);
        } else return xs;
    });
    var $elm$core$List$filterMap = F2(function(f, xs) {
        return A3($elm$core$List$foldr, $elm$core$List$maybeCons(f), _List_Nil, xs);
    });
    var $elm$http$Http$maybeSend = F4(function(router, desiredTracker, progress, _v0) {
        var actualTracker = _v0.a;
        var toMsg = _v0.b;
        return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(A2($elm$core$Platform$sendToApp, router, toMsg(progress))) : $elm$core$Maybe$Nothing;
    });
    var $elm$http$Http$onSelfMsg = F3(function(router, _v0, state) {
        var tracker = _v0.a;
        var progress = _v0.b;
        return A2($elm$core$Task$andThen, function(_v1) {
            return $elm$core$Task$succeed(state);
        }, $elm$core$Task$sequence(A2($elm$core$List$filterMap, A3($elm$http$Http$maybeSend, router, tracker, progress), state.$q)));
    });
    var $elm$http$Http$Cancel = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$http$Http$cmdMap = F2(function(func, cmd) {
        if (!cmd.$) {
            var tracker = cmd.a;
            return $elm$http$Http$Cancel(tracker);
        } else {
            var r = cmd.a;
            return $elm$http$Http$Request({
                abF: r.abF,
                fb: r.fb,
                Pb: A2(_Http_mapExpect, func, r.Pb),
                iL: r.iL,
                Gk: r.Gk,
                HQ: r.HQ,
                tu: r.tu,
                aaT: r.aaT
            });
        }
    });
    var $elm$http$Http$MySub = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$http$Http$subMap = F2(function(func, _v0) {
        var tracker = _v0.a;
        var toMsg = _v0.b;
        return A2($elm$http$Http$MySub, tracker, A2($elm$core$Basics$composeR, toMsg, func));
    });
    _Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
    var $elm$http$Http$command = _Platform_leaf('Http');
    var $elm$http$Http$subscription = _Platform_leaf('Http');
    var $elm$http$Http$request = function(r) {
        return $elm$http$Http$command($elm$http$Http$Request({
            abF: false,
            fb: r.fb,
            Pb: r.Pb,
            iL: r.iL,
            Gk: r.Gk,
            HQ: r.HQ,
            tu: r.tu,
            aaT: r.aaT
        }));
    };
    var $elm$http$Http$emptyBody = _Http_emptyBody;
    var $elm$http$Http$filePart = _Http_pair;
    var $elm$http$Http$jsonBody = function(value) {
        return A2(_Http_pair, 'application/json', A2($elm$json$Json$Encode$encode, 0, value));
    };
    var $elm$core$Maybe$map = F2(function(f, maybe) {
        if (!maybe.$) {
            var value = maybe.a;
            return $elm$core$Maybe$Just(f(value));
        } else return $elm$core$Maybe$Nothing;
    });
    var $elm$http$Http$multipartBody = function(parts) {
        return A2(_Http_pair, '', _Http_toFormData(parts));
    };
    var $author$project$Api$Data$requestBody = function(_v0) {
        var request = _v0;
        return A2($elm$core$Maybe$withDefault, $elm$http$Http$emptyBody, A2($elm$core$Maybe$map, function(body) {
            switch(body.$){
                case 0:
                    var value = body.a;
                    return $elm$http$Http$jsonBody(value);
                case 1:
                    var name = body.a;
                    var files = body.b;
                    return $elm$http$Http$multipartBody(A2($elm$core$List$map, $elm$http$Http$filePart(name), files));
                default:
                    var parts = body.a;
                    return $elm$http$Http$multipartBody(parts);
            }
        }, request.fb));
    };
    var $author$project$Api$AuthToken$toString = function(authToken) {
        var token = authToken;
        return $elm$core$Maybe$Just(token);
    };
    var $author$project$Api$AuthToken$asHeader = function(authToken) {
        return A2($elm$core$Maybe$map, function(token) {
            return 'Bearer ' + token;
        }, $author$project$Api$AuthToken$toString(authToken));
    };
    var $elm$http$Http$Header = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$http$Http$header = $elm$http$Http$Header;
    var $author$project$Api$Data$authHeader = function(authToken) {
        return A2($elm$core$Maybe$map, function(tokenHeader) {
            return A2($elm$http$Http$header, 'Authorization', tokenHeader);
        }, $author$project$Api$AuthToken$asHeader(authToken));
    };
    var $author$project$Api$Data$clientApiVersionHeader = $elm$core$Maybe$map($elm$http$Http$header('Hint-Version'));
    var $author$project$Api$Data$clientHeaders = function(_v0) {
        var sendAuth = _v0.Cq;
        var authToken = _v0.e7;
        var apiVersion = _v0.Ek;
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            sendAuth ? A2($elm$core$Maybe$andThen, $author$project$Api$Data$authHeader, authToken) : $elm$core$Maybe$Nothing,
            $author$project$Api$Data$clientApiVersionHeader(apiVersion)
        ]));
    };
    var $author$project$Api$Data$requestHeaders = F2(function(client, _v0) {
        var request = _v0;
        return _Utils_ap(request.iL, $author$project$Api$Data$clientHeaders(client));
    });
    var $elm$url$Url$Builder$toQueryPair = function(_v0) {
        var key = _v0.a;
        var value = _v0.b;
        return key + ('=' + value);
    };
    var $elm$url$Url$Builder$toQuery = function(parameters) {
        if (!parameters.b) return '';
        else return '?' + A2($elm$core$String$join, '&', A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
    };
    var $elm$url$Url$Builder$crossOrigin = F3(function(prePath, pathSegments, parameters) {
        return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
    });
    var $author$project$Api$Data$formatToString = function(format) {
        return '.csv';
    };
    var $author$project$Api$Data$pathToPieces = F2(function(maybeFormat, _v0) {
        var pieces = _v0;
        if (!maybeFormat.$) {
            var format = maybeFormat.a;
            return A2($elm$core$List$indexedMap, F2(function(index, piece) {
                return _Utils_eq(index, $elm$core$List$length(pieces) - 1) ? _Utils_ap(piece, $author$project$Api$Data$formatToString(format)) : piece;
            }), pieces);
        } else return pieces;
    });
    var $author$project$Api$Data$requestToUrl = F2(function(_v0, _v1) {
        var client = _v0;
        var request = _v1;
        return A3($elm$url$Url$Builder$crossOrigin, client.Bo, A2($elm$core$List$cons, 'api', A2($author$project$Api$Data$pathToPieces, $elm$core$Maybe$Nothing, request.$3)), request.Bz);
    });
    var $elm$core$String$toUpper = _String_toUpper;
    var $author$project$Api$Data$makeRequest = F5(function(method, client, decoder, toMsg, request) {
        var tracker = request.tu;
        return $elm$http$Http$request({
            fb: $author$project$Api$Data$requestBody(request),
            Pb: A2($author$project$Api$Data$expectJson, toMsg, decoder),
            iL: A2($author$project$Api$Data$requestHeaders, client, request),
            Gk: $elm$core$String$toUpper(method),
            HQ: $elm$core$Maybe$Just(61000),
            tu: tracker,
            aaT: A2($author$project$Api$Data$requestToUrl, client, request)
        });
    });
    var $author$project$Api$Data$get = $author$project$Api$Data$makeRequest('get');
    var $author$project$Api$Data$Path = $elm$core$Basics$identity;
    var $author$project$Api$Data$pathAppend = F2(function(pieces, _v0) {
        var path = _v0;
        return _Utils_ap(path, pieces);
    });
    var $author$project$Api$Data$newPath = $elm$core$Basics$identity;
    var $author$project$Api$Data$providerPath = $author$project$Api$Data$newPath(_List_fromArray([
        'provider'
    ]));
    var $author$project$Api$Provider$Search$path = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'search'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Data$Request = $elm$core$Basics$identity;
    var $author$project$Api$Data$requestTo = function(path) {
        return {
            fb: $elm$core$Maybe$Nothing,
            iL: _List_fromArray([
                A2($elm$http$Http$header, 'Accept', 'application/json, text/plain, */*')
            ]),
            Bz: _List_Nil,
            $3: path,
            tu: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Api$Provider$Search$permissions = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$SearchPermissions$All$decoder), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'permissions'
        ]), $author$project$Api$Provider$Search$path)));
    });
    var $author$project$Components$GlobalSearch$init = F2(function(apiClient, url) {
        var searchPermissionsCmd = $author$project$Api$Data$clientHasAuthToken(apiClient) ? A2($author$project$Api$Provider$Search$permissions, apiClient, $author$project$Components$GlobalSearch$GotSearchPermissions) : $elm$core$Platform$Cmd$none;
        return _Utils_Tuple2($author$project$Components$GlobalSearch$Closed({
            aaT: url
        }), searchPermissionsCmd);
    });
    var $gingko$time_distance$Time$Distance$I18n$en = F3(function(_v0, tense, distanceId) {
        var withAffix = _v0.aij;
        var toStr = $elm$core$String$fromInt;
        var maybeAffix = function(str) {
            var _v2 = _Utils_Tuple2(withAffix, tense);
            if (_v2.a) {
                if (!_v2.b) {
                    var _v3 = _v2.b;
                    return str + ' ago';
                } else {
                    var _v4 = _v2.b;
                    return 'in ' + str;
                }
            } else return str;
        };
        return maybeAffix(function() {
            switch(distanceId.$){
                case 0:
                    var i = distanceId.a;
                    return i === 1 ? 'less than 1 second' : 'less than ' + (toStr(i) + ' seconds');
                case 1:
                    return 'half a minute';
                case 2:
                    var i = distanceId.a;
                    return i === 1 ? 'less than a minute' : 'less than ' + (toStr(i) + ' minutes');
                case 3:
                    var i = distanceId.a;
                    return i === 1 ? '1 minute' : toStr(i) + ' minutes';
                case 4:
                    var i = distanceId.a;
                    return i === 1 ? 'about 1 hour' : 'about ' + (toStr(i) + ' hours');
                case 5:
                    var i = distanceId.a;
                    return i === 1 ? '1 day' : toStr(i) + ' days';
                case 6:
                    var i = distanceId.a;
                    return i === 1 ? 'about 1 month' : 'about ' + (toStr(i) + ' months');
                case 7:
                    var i = distanceId.a;
                    return i === 1 ? '1 month' : toStr(i) + ' months';
                case 8:
                    var i = distanceId.a;
                    return i === 1 ? 'about 1 year' : 'about ' + (toStr(i) + ' years');
                case 9:
                    var i = distanceId.a;
                    return i === 1 ? 'over 1 year' : 'over ' + (toStr(i) + ' years');
                default:
                    var i = distanceId.a;
                    return i === 1 ? 'almost 1 year' : 'almost ' + (toStr(i) + ' years');
            }
        }());
    });
    var $gingko$time_distance$Time$Distance$Types$Future = 1;
    var $gingko$time_distance$Time$Distance$Types$Past = 0;
    var $gingko$time_distance$Time$Distance$Types$AboutXHours = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $gingko$time_distance$Time$Distance$Types$LessThanXMinutes = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $gingko$time_distance$Time$Distance$Types$XDays = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $gingko$time_distance$Time$Distance$Types$XMinutes = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $elm$core$Basics$abs = function(n) {
        return n < 0 ? -n : n;
    };
    var $gingko$time_distance$Time$Distance$minutes_in_almost_two_days = 2520;
    var $gingko$time_distance$Time$Distance$minutes_in_day = 1440;
    var $gingko$time_distance$Time$Distance$minutes_in_month = 43200;
    var $gingko$time_distance$Time$Distance$minutes_in_two_months = 86400;
    var $gingko$time_distance$Time$Distance$Types$AboutXYears = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $gingko$time_distance$Time$Distance$Types$AlmostXYears = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $gingko$time_distance$Time$Distance$Types$OverXYears = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $gingko$time_distance$Time$Distance$Types$XMonths = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $elm$core$Basics$round = _Basics_round;
    var $gingko$time_distance$Time$Distance$upToOneYear = function(minutes) {
        var nearestMonth = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_month);
        return $gingko$time_distance$Time$Distance$Types$XMonths(nearestMonth);
    };
    var $gingko$time_distance$Time$Distance$moreThanTwoMonths = function(minutes) {
        var months = minutes / $gingko$time_distance$Time$Distance$minutes_in_month | 0;
        if (months < 12) return $gingko$time_distance$Time$Distance$upToOneYear(minutes);
        else {
            var years = $elm$core$Basics$floor(months / 12);
            var monthsSinceStartOfYear = A2($elm$core$Basics$modBy, 12, months);
            return monthsSinceStartOfYear < 3 ? $gingko$time_distance$Time$Distance$Types$AboutXYears(years) : monthsSinceStartOfYear < 9 ? $gingko$time_distance$Time$Distance$Types$OverXYears(years) : $gingko$time_distance$Time$Distance$Types$AlmostXYears(years + 1);
        }
    };
    var $gingko$time_distance$Time$Distance$upToOneDay = function(minutes) {
        var hours = $elm$core$Basics$round(minutes / 60);
        return $gingko$time_distance$Time$Distance$Types$AboutXHours(hours);
    };
    var $gingko$time_distance$Time$Distance$Types$HalfAMinute = {
        $: 1
    };
    var $gingko$time_distance$Time$Distance$Types$LessThanXSeconds = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $gingko$time_distance$Time$Distance$upToOneMinute = function(seconds) {
        return seconds < 5 ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(5) : seconds < 10 ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(10) : seconds < 20 ? $gingko$time_distance$Time$Distance$Types$LessThanXSeconds(20) : seconds < 40 ? $gingko$time_distance$Time$Distance$Types$HalfAMinute : seconds < 60 ? $gingko$time_distance$Time$Distance$Types$LessThanXMinutes(1) : $gingko$time_distance$Time$Distance$Types$XMinutes(1);
    };
    var $gingko$time_distance$Time$Distance$upToOneMonth = function(minutes) {
        var days = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_day);
        return $gingko$time_distance$Time$Distance$Types$XDays(days);
    };
    var $gingko$time_distance$Time$Distance$Types$AboutXMonths = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $gingko$time_distance$Time$Distance$upToTwoMonths = function(minutes) {
        var months = $elm$core$Basics$round(minutes / $gingko$time_distance$Time$Distance$minutes_in_month);
        return $gingko$time_distance$Time$Distance$Types$AboutXMonths(months);
    };
    var $gingko$time_distance$Time$Distance$calculateDistance = F3(function(includeSeconds, s1, s2) {
        var seconds = $elm$core$Basics$abs(s2 - s1) / 1000 | 0;
        var minutes = $elm$core$Basics$round(seconds / 60);
        return includeSeconds && minutes < 2 ? $gingko$time_distance$Time$Distance$upToOneMinute(seconds) : !minutes ? $gingko$time_distance$Time$Distance$Types$LessThanXMinutes(1) : minutes < 2 ? $gingko$time_distance$Time$Distance$Types$XMinutes(minutes) : minutes < 45 ? $gingko$time_distance$Time$Distance$Types$XMinutes(minutes) : minutes < 90 ? $gingko$time_distance$Time$Distance$Types$AboutXHours(1) : _Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_day) < 0 ? $gingko$time_distance$Time$Distance$upToOneDay(minutes) : _Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_almost_two_days) < 0 ? $gingko$time_distance$Time$Distance$Types$XDays(1) : _Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_month) < 0 ? $gingko$time_distance$Time$Distance$upToOneMonth(minutes) : _Utils_cmp(minutes, $gingko$time_distance$Time$Distance$minutes_in_two_months) < 0 ? $gingko$time_distance$Time$Distance$upToTwoMonths(minutes) : $gingko$time_distance$Time$Distance$moreThanTwoMonths(minutes);
    });
    var $elm$time$Time$posixToMillis = function(_v0) {
        var millis = _v0;
        return millis;
    };
    var $gingko$time_distance$Time$Distance$inWordsWithConfig = F4(function(config, locale, otherTime, currentTime) {
        var otherSeconds = $elm$time$Time$posixToMillis(otherTime);
        var currentSeconds = $elm$time$Time$posixToMillis(currentTime);
        var distance = A3($gingko$time_distance$Time$Distance$calculateDistance, true, otherSeconds, currentSeconds);
        var tense = function() {
            var _v0 = A2($elm$core$Basics$compare, currentSeconds, otherSeconds);
            if (_v0 === 2) return 0;
            else return 1;
        }();
        return A3(locale, config, tense, distance);
    });
    var $gingko$time_distance$Time$Distance$inWords = F2(function(otherTime, currentTime) {
        return A4($gingko$time_distance$Time$Distance$inWordsWithConfig, {
            aij: true
        }, $gingko$time_distance$Time$Distance$I18n$en, otherTime, currentTime);
    });
    var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayName = function(day) {
        switch(day){
            case 0:
                return 'Monday';
            case 1:
                return 'Tuesday';
            case 2:
                return 'Wednesday';
            case 3:
                return 'Thursday';
            case 4:
                return 'Friday';
            case 5:
                return 'Saturday';
            default:
                return 'Sunday';
        }
    };
    var $elm$core$String$cons = _String_cons;
    var $elm$core$String$fromChar = function(_char) {
        return A2($elm$core$String$cons, _char, '');
    };
    var $elm$core$Bitwise$and = _Bitwise_and;
    var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
    var $elm$core$String$repeatHelp = F3(function(n, chunk, result) {
        return n <= 0 ? result : A3($elm$core$String$repeatHelp, n >> 1, _Utils_ap(chunk, chunk), !(n & 1) ? result : _Utils_ap(result, chunk));
    });
    var $elm$core$String$repeat = F2(function(n, chunk) {
        return A3($elm$core$String$repeatHelp, n, chunk, '');
    });
    var $elm$core$String$padLeft = F3(function(n, _char, string) {
        return _Utils_ap(A2($elm$core$String$repeat, n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)), string);
    });
    var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayOfMonthWithSuffix = F2(function(pad, day) {
        var value = function() {
            switch(day){
                case 1:
                    return '1st';
                case 21:
                    return '21st';
                case 2:
                    return '2nd';
                case 22:
                    return '22nd';
                case 3:
                    return '3rd';
                case 23:
                    return '23rd';
                case 31:
                    return '31st';
                default:
                    return $elm$core$String$fromInt(day) + 'th';
            }
        }();
        return pad ? A3($elm$core$String$padLeft, 4, ' ', value) : value;
    });
    var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayShort = function(day) {
        switch(day){
            case 0:
                return 'Mon';
            case 1:
                return 'Tue';
            case 2:
                return 'Wed';
            case 3:
                return 'Thu';
            case 4:
                return 'Fri';
            case 5:
                return 'Sat';
            default:
                return 'Sun';
        }
    };
    var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthName = function(month) {
        switch(month){
            case 0:
                return 'January';
            case 1:
                return 'February';
            case 2:
                return 'March';
            case 3:
                return 'April';
            case 4:
                return 'May';
            case 5:
                return 'June';
            case 6:
                return 'July';
            case 7:
                return 'August';
            case 8:
                return 'September';
            case 9:
                return 'October';
            case 10:
                return 'November';
            default:
                return 'December';
        }
    };
    var $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthShort = function(month) {
        switch(month){
            case 0:
                return 'Jan';
            case 1:
                return 'Feb';
            case 2:
                return 'Mar';
            case 3:
                return 'Apr';
            case 4:
                return 'May';
            case 5:
                return 'Jun';
            case 6:
                return 'Jul';
            case 7:
                return 'Aug';
            case 8:
                return 'Sep';
            case 9:
                return 'Oct';
            case 10:
                return 'Nov';
            default:
                return 'Dec';
        }
    };
    var $CoderDennis$elm_time_format$Time$Format$I18n$I_default$twelveHourPeriod = function(period) {
        if (!period) return 'AM';
        else return 'PM';
    };
    var $CoderDennis$elm_time_format$Time$Format$Config$Config_en_us$config = {
        PX: {
            M4: '%-m/%-d/%Y',
            acO: '%-m/%-d/%Y %-I:%M %p',
            adQ: 6,
            aeU: '%A, %B %d, %Y',
            aeV: '%-I:%M:%S %p',
            ahT: '%-I:%M %p'
        },
        bx: {
            M8: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayName,
            M9: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayOfMonthWithSuffix,
            Na: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$dayShort,
            Uz: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthName,
            UE: $CoderDennis$elm_time_format$Time$Format$I18n$I_en_us$monthShort,
            aaC: $CoderDennis$elm_time_format$Time$Format$I18n$I_default$twelveHourPeriod
        }
    };
    var $elm$regex$Regex$Match = F4(function(match, index, number, submatches) {
        return {
            yc: index,
            aeX: match,
            Gx: number,
            ahD: submatches
        };
    });
    var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
    var $elm$regex$Regex$fromString = function(string) {
        return A2($elm$regex$Regex$fromStringWith, {
            acf: false,
            ae8: false
        }, string);
    };
    var $elm$regex$Regex$never = _Regex_never;
    var $CoderDennis$elm_time_format$Time$Format$formatRegex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $elm$regex$Regex$fromString('%(y|Y|m|_m|-m|B|^B|b|^b|d|-d|-@d|e|@e|A|^A|a|^a|H|-H|k|I|-I|l|p|P|M|S|%|L)'));
    var $CoderDennis$elm_time_format$Time$Format$collapse = function(m) {
        return A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, m);
    };
    var $elm$core$List$head = function(list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(x);
        } else return $elm$core$Maybe$Nothing;
    };
    var $CoderDennis$elm_time_format$Time$Format$hourMod12 = function(h) {
        return !A2($elm$core$Basics$modBy, 12, h) ? 12 : A2($elm$core$Basics$modBy, 12, h);
    };
    var $CoderDennis$elm_time_format$Time$Format$Core$monthToInt = function(month) {
        switch(month){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    };
    var $CoderDennis$elm_time_format$Time$Format$padWith = function(c) {
        return A2($elm$core$Basics$composeL, A2($elm$core$String$padLeft, 2, c), $elm$core$String$fromInt);
    };
    var $CoderDennis$elm_time_format$Time$Format$padWithN = F2(function(n, c) {
        return A2($elm$core$Basics$composeL, A2($elm$core$String$padLeft, n, c), $elm$core$String$fromInt);
    });
    var $elm$core$String$right = F2(function(n, string) {
        return n < 1 ? '' : A3($elm$core$String$slice, -n, $elm$core$String$length(string), string);
    });
    var $elm$time$Time$flooredDiv = F2(function(numerator, denominator) {
        return $elm$core$Basics$floor(numerator / denominator);
    });
    var $elm$time$Time$toAdjustedMinutesHelp = F3(function(defaultOffset, posixMinutes, eras) {
        toAdjustedMinutesHelp: while(true){
            if (!eras.b) return posixMinutes + defaultOffset;
            else {
                var era = eras.a;
                var olderEras = eras.b;
                if (_Utils_cmp(era.HB, posixMinutes) < 0) return posixMinutes + era.f;
                else {
                    var $temp$defaultOffset = defaultOffset, $temp$posixMinutes = posixMinutes, $temp$eras = olderEras;
                    defaultOffset = $temp$defaultOffset;
                    posixMinutes = $temp$posixMinutes;
                    eras = $temp$eras;
                    continue toAdjustedMinutesHelp;
                }
            }
        }
    });
    var $elm$time$Time$toAdjustedMinutes = F2(function(_v0, time) {
        var defaultOffset = _v0.a;
        var eras = _v0.b;
        return A3($elm$time$Time$toAdjustedMinutesHelp, defaultOffset, A2($elm$time$Time$flooredDiv, $elm$time$Time$posixToMillis(time), 60000), eras);
    });
    var $elm$core$Basics$ge = _Utils_ge;
    var $elm$time$Time$toCivil = function(minutes) {
        var rawDay = A2($elm$time$Time$flooredDiv, minutes, 1440) + 719468;
        var era = (rawDay >= 0 ? rawDay : rawDay - 146096) / 146097 | 0;
        var dayOfEra = rawDay - era * 146097;
        var yearOfEra = (dayOfEra - (dayOfEra / 1460 | 0) + (dayOfEra / 36524 | 0) - (dayOfEra / 146096 | 0)) / 365 | 0;
        var dayOfYear = dayOfEra - (365 * yearOfEra + (yearOfEra / 4 | 0) - (yearOfEra / 100 | 0));
        var mp = (5 * dayOfYear + 2) / 153 | 0;
        var month = mp + (mp < 10 ? 3 : -9);
        var year = yearOfEra + era * 400;
        return {
            acP: dayOfYear - ((153 * mp + 2) / 5 | 0) + 1,
            ae6: month,
            ail: year + (month <= 2 ? 1 : 0)
        };
    };
    var $elm$time$Time$toDay = F2(function(zone, time) {
        return $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).acP;
    });
    var $elm$time$Time$toHour = F2(function(zone, time) {
        return A2($elm$core$Basics$modBy, 24, A2($elm$time$Time$flooredDiv, A2($elm$time$Time$toAdjustedMinutes, zone, time), 60));
    });
    var $elm$time$Time$toMillis = F2(function(_v0, time) {
        return A2($elm$core$Basics$modBy, 1000, $elm$time$Time$posixToMillis(time));
    });
    var $elm$time$Time$toMinute = F2(function(zone, time) {
        return A2($elm$core$Basics$modBy, 60, A2($elm$time$Time$toAdjustedMinutes, zone, time));
    });
    var $elm$time$Time$toMonth = F2(function(zone, time) {
        var _v0 = $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).ae6;
        switch(_v0){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    });
    var $elm$time$Time$toSecond = F2(function(_v0, time) {
        return A2($elm$core$Basics$modBy, 60, A2($elm$time$Time$flooredDiv, $elm$time$Time$posixToMillis(time), 1000));
    });
    var $elm$time$Time$Tue = 1;
    var $elm$time$Time$Wed = 2;
    var $elm$time$Time$toWeekday = F2(function(zone, time) {
        var _v0 = A2($elm$core$Basics$modBy, 7, A2($elm$time$Time$flooredDiv, A2($elm$time$Time$toAdjustedMinutes, zone, time), 1440));
        switch(_v0){
            case 0:
                return 3;
            case 1:
                return 4;
            case 2:
                return 5;
            case 3:
                return 6;
            case 4:
                return 0;
            case 5:
                return 1;
            default:
                return 2;
        }
    });
    var $elm$time$Time$toYear = F2(function(zone, time) {
        return $elm$time$Time$toCivil(A2($elm$time$Time$toAdjustedMinutes, zone, time)).ail;
    });
    var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$AM = 0;
    var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$PM = 1;
    var $CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod = F2(function(z, d) {
        return A2($elm$time$Time$toHour, z, d) < 12 ? 0 : 1;
    });
    var $CoderDennis$elm_time_format$Time$Format$formatToken = F4(function(config, zone, d, m) {
        var symbol = A2($elm$core$Maybe$withDefault, ' ', $CoderDennis$elm_time_format$Time$Format$collapse($elm$core$List$head(m.ahD)));
        switch(symbol){
            case 'Y':
                return A3($CoderDennis$elm_time_format$Time$Format$padWithN, 4, '0', A2($elm$time$Time$toYear, zone, d));
            case 'y':
                return A2($elm$core$String$right, 2, A3($CoderDennis$elm_time_format$Time$Format$padWithN, 2, '0', A2($elm$time$Time$toYear, zone, d)));
            case 'm':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, '0', $CoderDennis$elm_time_format$Time$Format$Core$monthToInt(A2($elm$time$Time$toMonth, zone, d)));
            case '_m':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, ' ', $CoderDennis$elm_time_format$Time$Format$Core$monthToInt(A2($elm$time$Time$toMonth, zone, d)));
            case '-m':
                return $elm$core$String$fromInt($CoderDennis$elm_time_format$Time$Format$Core$monthToInt(A2($elm$time$Time$toMonth, zone, d)));
            case 'B':
                return config.bx.Uz(A2($elm$time$Time$toMonth, zone, d));
            case '^B':
                return $elm$core$String$toUpper(config.bx.Uz(A2($elm$time$Time$toMonth, zone, d)));
            case 'b':
                return config.bx.UE(A2($elm$time$Time$toMonth, zone, d));
            case '^b':
                return $elm$core$String$toUpper(config.bx.UE(A2($elm$time$Time$toMonth, zone, d)));
            case 'd':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, '0', A2($elm$time$Time$toDay, zone, d));
            case '-d':
                return $elm$core$String$fromInt(A2($elm$time$Time$toDay, zone, d));
            case '-@d':
                return A2(config.bx.M9, false, A2($elm$time$Time$toDay, zone, d));
            case 'e':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, ' ', A2($elm$time$Time$toDay, zone, d));
            case '@e':
                return A2(config.bx.M9, true, A2($elm$time$Time$toDay, zone, d));
            case 'A':
                return config.bx.M8(A2($elm$time$Time$toWeekday, zone, d));
            case '^A':
                return $elm$core$String$toUpper(config.bx.M8(A2($elm$time$Time$toWeekday, zone, d)));
            case 'a':
                return config.bx.Na(A2($elm$time$Time$toWeekday, zone, d));
            case '^a':
                return $elm$core$String$toUpper(config.bx.Na(A2($elm$time$Time$toWeekday, zone, d)));
            case 'H':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, '0', A2($elm$time$Time$toHour, zone, d));
            case '-H':
                return $elm$core$String$fromInt(A2($elm$time$Time$toHour, zone, d));
            case 'k':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, ' ', A2($elm$time$Time$toHour, zone, d));
            case 'I':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, '0', $CoderDennis$elm_time_format$Time$Format$hourMod12(A2($elm$time$Time$toHour, zone, d)));
            case '-I':
                return $elm$core$String$fromInt($CoderDennis$elm_time_format$Time$Format$hourMod12(A2($elm$time$Time$toHour, zone, d)));
            case 'l':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, ' ', $CoderDennis$elm_time_format$Time$Format$hourMod12(A2($elm$time$Time$toHour, zone, d)));
            case 'p':
                return $elm$core$String$toUpper(config.bx.aaC(A2($CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod, zone, d)));
            case 'P':
                return config.bx.aaC(A2($CoderDennis$elm_time_format$Time$Format$TwelveHourClock$twelveHourPeriod, zone, d));
            case 'M':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, '0', A2($elm$time$Time$toMinute, zone, d));
            case 'S':
                return A2($CoderDennis$elm_time_format$Time$Format$padWith, '0', A2($elm$time$Time$toSecond, zone, d));
            case 'L':
                return A3($CoderDennis$elm_time_format$Time$Format$padWithN, 3, '0', A2($elm$time$Time$toMillis, zone, d));
            case '%':
                return symbol;
            default:
                return '';
        }
    });
    var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
    var $CoderDennis$elm_time_format$Time$Format$format = F4(function(config, formatStr, zone, time) {
        return A3($elm$regex$Regex$replace, $CoderDennis$elm_time_format$Time$Format$formatRegex, A3($CoderDennis$elm_time_format$Time$Format$formatToken, config, zone, time), formatStr);
    });
    var $author$project$Formatters$Time$toTimeStamp = F3(function(zone, expression, time) {
        return A4($CoderDennis$elm_time_format$Time$Format$format, $CoderDennis$elm_time_format$Time$Format$Config$Config_en_us$config, expression, zone, time);
    });
    var $author$project$Formatters$Time$toString = F4(function(zone, now, format, time) {
        switch(format){
            case 0:
                return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y at %l:%M %p', time);
            case 1:
                return A2($gingko$time_distance$Time$Distance$inWords, time, now);
            case 2:
                return A3($author$project$Formatters$Time$toTimeStamp, zone, '%B %d, %Y at %l:%M %p', time);
            case 3:
                return A3($author$project$Formatters$Time$toTimeStamp, zone, '%l:%M %p', time);
            case 4:
                return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y %l:%M %p', time);
            case 5:
                return A3($author$project$Formatters$Time$toTimeStamp, zone, '%m/%d/%Y', time);
            default:
                return A3($author$project$Formatters$Time$toTimeStamp, zone, '%B %d, %Y', time);
        }
    });
    var $author$project$Formatters$Time$init = F2(function(zone, now) {
        return A2($author$project$Formatters$Time$toString, zone, now);
    });
    var $author$project$Ui$Toast$Toastr = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Toast$init = A2($author$project$Ui$Toast$Toastr, 1, _List_Nil);
    var $author$project$Utils$Release$Model = $elm$core$Basics$identity;
    var $elm$core$Basics$always = F2(function(a, _v0) {
        return a;
    });
    var $author$project$Utils$Release$FetchLiveRelease = {
        $: 1
    };
    var $elm$core$Process$sleep = _Process_sleep;
    var $author$project$Utils$Release$scheduleNextReleaseCheck = A2($elm$core$Task$attempt, function(_v0) {
        return $author$project$Utils$Release$FetchLiveRelease;
    }, $elm$core$Process$sleep(10000));
    var $author$project$Utils$Release$init = function(release) {
        return _Utils_Tuple2({
            E0: A2($elm$core$Maybe$withDefault, '', release),
            zs: false
        }, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Utils$Release$scheduleNextReleaseCheck), release)));
    };
    var $author$project$Shared$GotSession = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Shared$GotUser = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $elm$json$Json$Encode$bool = _Json_wrap;
    var $elm$json$Json$Encode$object = function(pairs) {
        return _Json_wrap(A3($elm$core$List$foldl, F2(function(_v0, obj) {
            var k = _v0.a;
            var v = _v0.b;
            return A3(_Json_addField, k, v, obj);
        }), _Json_emptyObject(0), pairs));
    };
    var $author$project$Ports$Session$sessionAuthorizePort = _Platform_outgoingPort('sessionAuthorizePort', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('redirect', $elm$json$Json$Encode$bool($.agy))
        ]));
    });
    var $author$project$Ports$Session$authorize = function(options) {
        return $author$project$Ports$Session$sessionAuthorizePort(options);
    };
    var $author$project$Shared$BackupJwtRefreshWindowFinished = {
        $: 27
    };
    var $author$project$Api$Data$clientAuthToken = function(_v0) {
        var client = _v0;
        return client.e7;
    };
    var $simonh1000$elm_jwt$Jwt$TokenDecodeError = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$core$Result$andThen = F2(function(callback, result) {
        if (!result.$) {
            var value = result.a;
            return callback(value);
        } else {
            var msg = result.a;
            return $elm$core$Result$Err(msg);
        }
    });
    var $simonh1000$elm_jwt$Jwt$TokenHeaderError = {
        $: 2
    };
    var $simonh1000$elm_jwt$Jwt$TokenProcessingError = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$core$String$concat = function(strings) {
        return A2($elm$core$String$join, '', strings);
    };
    var $simonh1000$elm_jwt$Jwt$fixlength = function(s) {
        var _v0 = A2($elm$core$Basics$modBy, 4, $elm$core$String$length(s));
        switch(_v0){
            case 0:
                return $elm$core$Result$Ok(s);
            case 2:
                return $elm$core$Result$Ok($elm$core$String$concat(_List_fromArray([
                    s,
                    '=='
                ])));
            case 3:
                return $elm$core$Result$Ok($elm$core$String$concat(_List_fromArray([
                    s,
                    '='
                ])));
            default:
                return $elm$core$Result$Err($simonh1000$elm_jwt$Jwt$TokenProcessingError('Wrong length'));
        }
    };
    var $elm$core$Result$fromMaybe = F2(function(err, maybe) {
        if (!maybe.$) {
            var v = maybe.a;
            return $elm$core$Result$Ok(v);
        } else return $elm$core$Result$Err(err);
    });
    var $elm$core$Result$map = F2(function(func, ra) {
        if (!ra.$) {
            var a = ra.a;
            return $elm$core$Result$Ok(func(a));
        } else {
            var e = ra.a;
            return $elm$core$Result$Err(e);
        }
    });
    var $elm$core$Result$map2 = F3(function(func, ra, rb) {
        if (ra.$ === 1) {
            var x = ra.a;
            return $elm$core$Result$Err(x);
        } else {
            var a = ra.a;
            if (rb.$ === 1) {
                var x = rb.a;
                return $elm$core$Result$Err(x);
            } else {
                var b = rb.a;
                return $elm$core$Result$Ok(A2(func, a, b));
            }
        }
    });
    var $elm$core$Result$mapError = F2(function(f, result) {
        if (!result.$) {
            var v = result.a;
            return $elm$core$Result$Ok(v);
        } else {
            var e = result.a;
            return $elm$core$Result$Err(f(e));
        }
    });
    var $elm$bytes$Bytes$Encode$getWidth = function(builder) {
        switch(builder.$){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 4;
            case 3:
                return 1;
            case 4:
                return 2;
            case 5:
                return 4;
            case 6:
                return 4;
            case 7:
                return 8;
            case 8:
                var w = builder.a;
                return w;
            case 9:
                var w = builder.a;
                return w;
            default:
                var bs = builder.a;
                return _Bytes_width(bs);
        }
    };
    var $elm$bytes$Bytes$LE = 0;
    var $elm$bytes$Bytes$Encode$write = F3(function(builder, mb, offset) {
        switch(builder.$){
            case 0:
                var n = builder.a;
                return A3(_Bytes_write_i8, mb, offset, n);
            case 1:
                var e = builder.a;
                var n = builder.b;
                return A4(_Bytes_write_i16, mb, offset, n, !e);
            case 2:
                var e = builder.a;
                var n = builder.b;
                return A4(_Bytes_write_i32, mb, offset, n, !e);
            case 3:
                var n = builder.a;
                return A3(_Bytes_write_u8, mb, offset, n);
            case 4:
                var e = builder.a;
                var n = builder.b;
                return A4(_Bytes_write_u16, mb, offset, n, !e);
            case 5:
                var e = builder.a;
                var n = builder.b;
                return A4(_Bytes_write_u32, mb, offset, n, !e);
            case 6:
                var e = builder.a;
                var n = builder.b;
                return A4(_Bytes_write_f32, mb, offset, n, !e);
            case 7:
                var e = builder.a;
                var n = builder.b;
                return A4(_Bytes_write_f64, mb, offset, n, !e);
            case 8:
                var bs = builder.b;
                return A3($elm$bytes$Bytes$Encode$writeSequence, bs, mb, offset);
            case 9:
                var s = builder.b;
                return A3(_Bytes_write_string, mb, offset, s);
            default:
                var bs = builder.a;
                return A3(_Bytes_write_bytes, mb, offset, bs);
        }
    });
    var $elm$bytes$Bytes$Encode$writeSequence = F3(function(builders, mb, offset) {
        writeSequence: while(true){
            if (!builders.b) return offset;
            else {
                var b = builders.a;
                var bs = builders.b;
                var $temp$builders = bs, $temp$mb = mb, $temp$offset = A3($elm$bytes$Bytes$Encode$write, b, mb, offset);
                builders = $temp$builders;
                mb = $temp$mb;
                offset = $temp$offset;
                continue writeSequence;
            }
        }
    });
    var $elm$bytes$Bytes$Decode$decode = F2(function(_v0, bs) {
        var decoder = _v0;
        return A2(_Bytes_decode, decoder, bs);
    });
    var $elm$bytes$Bytes$Decode$Decoder = $elm$core$Basics$identity;
    var $elm$bytes$Bytes$Decode$string = function(n) {
        return _Bytes_read_string(n);
    };
    var $elm$bytes$Bytes$Encode$encode = _Bytes_encode;
    var $elm$bytes$Bytes$BE = 1;
    var $danfishgold$base64_bytes$Encode$isValidChar = function(c) {
        if ($elm$core$Char$isAlphaNum(c)) return true;
        else switch(c){
            case '+':
                return true;
            case '/':
                return true;
            default:
                return false;
        }
    };
    var $elm$core$Bitwise$or = _Bitwise_or;
    var $elm$bytes$Bytes$Encode$Seq = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $elm$bytes$Bytes$Encode$getWidths = F2(function(width, builders) {
        getWidths: while(true){
            if (!builders.b) return width;
            else {
                var b = builders.a;
                var bs = builders.b;
                var $temp$width = width + $elm$bytes$Bytes$Encode$getWidth(b), $temp$builders = bs;
                width = $temp$width;
                builders = $temp$builders;
                continue getWidths;
            }
        }
    });
    var $elm$bytes$Bytes$Encode$sequence = function(builders) {
        return A2($elm$bytes$Bytes$Encode$Seq, A2($elm$bytes$Bytes$Encode$getWidths, 0, builders), builders);
    };
    var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
    var $danfishgold$base64_bytes$Encode$unsafeConvertChar = function(_char) {
        var key = $elm$core$Char$toCode(_char);
        if (key >= 65 && key <= 90) return key - 65;
        else {
            if (key >= 97 && key <= 122) return key - 97 + 26;
            else {
                if (key >= 48 && key <= 57) return key - 48 + 26 + 26;
                else switch(_char){
                    case '+':
                        return 62;
                    case '/':
                        return 63;
                    default:
                        return -1;
                }
            }
        }
    };
    var $elm$bytes$Bytes$Encode$U16 = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $elm$bytes$Bytes$Encode$unsignedInt16 = $elm$bytes$Bytes$Encode$U16;
    var $elm$bytes$Bytes$Encode$U8 = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $elm$bytes$Bytes$Encode$unsignedInt8 = $elm$bytes$Bytes$Encode$U8;
    var $danfishgold$base64_bytes$Encode$encodeCharacters = F4(function(a, b, c, d) {
        if ($danfishgold$base64_bytes$Encode$isValidChar(a) && $danfishgold$base64_bytes$Encode$isValidChar(b)) {
            var n2 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(b);
            var n1 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(a);
            if ('=' === d) {
                if ('=' === c) {
                    var n = n1 << 18 | n2 << 12;
                    var b1 = n >> 16;
                    return $elm$core$Maybe$Just($elm$bytes$Bytes$Encode$unsignedInt8(b1));
                } else {
                    if ($danfishgold$base64_bytes$Encode$isValidChar(c)) {
                        var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
                        var n = n1 << 18 | n2 << 12 | n3 << 6;
                        var combined = n >> 8;
                        return $elm$core$Maybe$Just(A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined));
                    } else return $elm$core$Maybe$Nothing;
                }
            } else {
                if ($danfishgold$base64_bytes$Encode$isValidChar(c) && $danfishgold$base64_bytes$Encode$isValidChar(d)) {
                    var n4 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(d);
                    var n3 = $danfishgold$base64_bytes$Encode$unsafeConvertChar(c);
                    var n = n1 << 18 | n2 << 12 | (n3 << 6 | n4);
                    var combined = n >> 8;
                    var b3 = n;
                    return $elm$core$Maybe$Just($elm$bytes$Bytes$Encode$sequence(_List_fromArray([
                        A2($elm$bytes$Bytes$Encode$unsignedInt16, 1, combined),
                        $elm$bytes$Bytes$Encode$unsignedInt8(b3)
                    ])));
                } else return $elm$core$Maybe$Nothing;
            }
        } else return $elm$core$Maybe$Nothing;
    });
    var $elm$core$String$foldr = _String_foldr;
    var $elm$core$String$toList = function(string) {
        return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
    };
    var $danfishgold$base64_bytes$Encode$encodeChunks = F2(function(input, accum) {
        encodeChunks: while(true){
            var _v0 = $elm$core$String$toList(A2($elm$core$String$left, 4, input));
            _v0$4: while(true){
                if (!_v0.b) return $elm$core$Maybe$Just(accum);
                else {
                    if (_v0.b.b) {
                        if (_v0.b.b.b) {
                            if (_v0.b.b.b.b) {
                                if (!_v0.b.b.b.b.b) {
                                    var a = _v0.a;
                                    var _v1 = _v0.b;
                                    var b = _v1.a;
                                    var _v2 = _v1.b;
                                    var c = _v2.a;
                                    var _v3 = _v2.b;
                                    var d = _v3.a;
                                    var _v4 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, d);
                                    if (!_v4.$) {
                                        var enc = _v4.a;
                                        var $temp$input = A2($elm$core$String$dropLeft, 4, input), $temp$accum = A2($elm$core$List$cons, enc, accum);
                                        input = $temp$input;
                                        accum = $temp$accum;
                                        continue encodeChunks;
                                    } else return $elm$core$Maybe$Nothing;
                                } else break _v0$4;
                            } else {
                                var a = _v0.a;
                                var _v5 = _v0.b;
                                var b = _v5.a;
                                var _v6 = _v5.b;
                                var c = _v6.a;
                                var _v7 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, c, '=');
                                if (_v7.$ === 1) return $elm$core$Maybe$Nothing;
                                else {
                                    var enc = _v7.a;
                                    return $elm$core$Maybe$Just(A2($elm$core$List$cons, enc, accum));
                                }
                            }
                        } else {
                            var a = _v0.a;
                            var _v8 = _v0.b;
                            var b = _v8.a;
                            var _v9 = A4($danfishgold$base64_bytes$Encode$encodeCharacters, a, b, '=', '=');
                            if (_v9.$ === 1) return $elm$core$Maybe$Nothing;
                            else {
                                var enc = _v9.a;
                                return $elm$core$Maybe$Just(A2($elm$core$List$cons, enc, accum));
                            }
                        }
                    } else break _v0$4;
                }
            }
            return $elm$core$Maybe$Nothing;
        }
    });
    var $danfishgold$base64_bytes$Encode$encoder = function(string) {
        return A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$List$reverse, $elm$bytes$Bytes$Encode$sequence), A2($danfishgold$base64_bytes$Encode$encodeChunks, string, _List_Nil));
    };
    var $danfishgold$base64_bytes$Encode$toBytes = function(string) {
        return A2($elm$core$Maybe$map, $elm$bytes$Bytes$Encode$encode, $danfishgold$base64_bytes$Encode$encoder(string));
    };
    var $danfishgold$base64_bytes$Base64$toBytes = $danfishgold$base64_bytes$Encode$toBytes;
    var $elm$bytes$Bytes$width = _Bytes_width;
    var $danfishgold$base64_bytes$Base64$toString = function(b64String) {
        var _v0 = $danfishgold$base64_bytes$Base64$toBytes(b64String);
        if (_v0.$ === 1) return $elm$core$Maybe$Nothing;
        else {
            var b64Bytes = _v0.a;
            return A2($elm$bytes$Bytes$Decode$decode, $elm$bytes$Bytes$Decode$string($elm$bytes$Bytes$width(b64Bytes)), b64Bytes);
        }
    };
    var $elm$core$String$map = _String_map;
    var $simonh1000$elm_jwt$Jwt$unurl = function() {
        var fix = function(c) {
            switch(c){
                case '-':
                    return '+';
                case '_':
                    return '/';
                default:
                    return c;
            }
        };
        return $elm$core$String$map(fix);
    }();
    var $elm$json$Json$Decode$value = _Json_decodeValue;
    var $simonh1000$elm_jwt$Jwt$getTokenParts = function(token) {
        var verifyJson = F2(function(errorHandler, str) {
            return A2($elm$core$Result$mapError, errorHandler, A2($elm$core$Result$map, function(_v8) {
                return str;
            }, A2($elm$json$Json$Decode$decodeString, $elm$json$Json$Decode$value, str)));
        });
        var processor = A2($elm$core$Basics$composeR, $simonh1000$elm_jwt$Jwt$unurl, A2($elm$core$Basics$composeR, $elm$core$String$split('.'), $elm$core$List$map($simonh1000$elm_jwt$Jwt$fixlength)));
        var _v0 = processor(token);
        _v0$1: while(true){
            if (_v0.b && _v0.b.b && _v0.b.b.b && !_v0.b.b.b.b) {
                if (!_v0.a.$) {
                    if (!_v0.b.a.$) {
                        var header = _v0.a.a;
                        var _v1 = _v0.b;
                        var body = _v1.a.a;
                        var _v2 = _v1.b;
                        var header_ = A2($elm$core$Result$andThen, verifyJson(function(_v3) {
                            return $simonh1000$elm_jwt$Jwt$TokenHeaderError;
                        }), A2($elm$core$Result$fromMaybe, $simonh1000$elm_jwt$Jwt$TokenHeaderError, $danfishgold$base64_bytes$Base64$toString(header)));
                        var body_ = A2($elm$core$Result$andThen, verifyJson($simonh1000$elm_jwt$Jwt$TokenDecodeError), A2($elm$core$Result$fromMaybe, $simonh1000$elm_jwt$Jwt$TokenProcessingError('Invalid UTF-16'), $danfishgold$base64_bytes$Base64$toString(body)));
                        return A3($elm$core$Result$map2, F2(function(a, b) {
                            return _Utils_Tuple2(a, b);
                        }), header_, body_);
                    } else break _v0$1;
                } else {
                    if (_v0.b.a.$ === 1) break _v0$1;
                    else {
                        var err = _v0.a.a;
                        var _v6 = _v0.b;
                        var _v7 = _v6.b;
                        return $elm$core$Result$Err(err);
                    }
                }
            } else return $elm$core$Result$Err($simonh1000$elm_jwt$Jwt$TokenProcessingError('Token has invalid shape'));
        }
        var _v4 = _v0.b;
        var err = _v4.a.a;
        var _v5 = _v4.b;
        return $elm$core$Result$Err(err);
    };
    var $simonh1000$elm_jwt$Jwt$decodeToken = F2(function(dec, token) {
        return A2($elm$core$Result$andThen, A2($elm$core$Basics$composeR, $elm$json$Json$Decode$decodeString(dec), $elm$core$Result$mapError($simonh1000$elm_jwt$Jwt$TokenDecodeError)), A2($elm$core$Result$map, $elm$core$Tuple$second, $simonh1000$elm_jwt$Jwt$getTokenParts(token)));
    });
    var $elm$json$Json$Decode$float = _Json_decodeFloat;
    var $elm$json$Json$Decode$int = _Json_decodeInt;
    var $elm$json$Json$Decode$oneOf = _Json_oneOf;
    var $simonh1000$elm_jwt$Jwt$getTokenExpirationMillis = function(token) {
        var decodeExp = $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$int,
            A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)
        ]));
        return A2($elm$core$Result$map, function(exp) {
            return 1000 * exp;
        }, A2($simonh1000$elm_jwt$Jwt$decodeToken, A2($elm$json$Json$Decode$field, 'exp', decodeExp), token));
    };
    var $author$project$Api$AuthToken$expiresAt = function(authToken) {
        return A2($elm$core$Maybe$andThen, $elm$core$Result$toMaybe, A2($elm$core$Maybe$map, $simonh1000$elm_jwt$Jwt$getTokenExpirationMillis, A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
    };
    var $author$project$Api$AuthToken$issuedAt = function(authToken) {
        return A2($elm$core$Maybe$andThen, $elm$core$Result$toMaybe, A2($elm$core$Maybe$map, function(token) {
            var decodeExp = $elm$json$Json$Decode$oneOf(_List_fromArray([
                $elm$json$Json$Decode$int,
                A2($elm$json$Json$Decode$map, $elm$core$Basics$round, $elm$json$Json$Decode$float)
            ]));
            return A2($elm$core$Result$map, function(iat) {
                return 1000 * iat;
            }, A2($simonh1000$elm_jwt$Jwt$decodeToken, A2($elm$json$Json$Decode$field, 'iat', decodeExp), token));
        }, A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
    };
    var $author$project$Shared$GotNewBackupJwt = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Api$Data$platformPath = $author$project$Api$Data$newPath(_List_Nil);
    var $author$project$Api$Auth$authPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'auth'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$AuthToken$decode = function(authToken) {
        return $elm$json$Json$Decode$succeed(authToken);
    };
    var $author$project$Api$Auth$authTokenDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$AuthToken$decode, A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string));
    var $author$project$Api$Data$post = $author$project$Api$Data$makeRequest('post');
    var $author$project$Api$Auth$refreshToken = F2(function(client, toMsg) {
        return A4($author$project$Api$Data$post, client, $author$project$Api$Auth$authTokenDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'refresh'
        ]), $author$project$Api$Auth$authPath)));
    });
    var $author$project$Shared$refreshToken = function(apiClient) {
        return A2($author$project$Api$Auth$refreshToken, apiClient, $author$project$Shared$GotNewBackupJwt);
    };
    var $author$project$Shared$backupJwtRefreshTimeout = function(apiClient) {
        var refreshWindowStart = $author$project$Api$AuthToken$issuedAt($author$project$Api$Data$clientAuthToken(apiClient));
        var expiresAt = $author$project$Api$AuthToken$expiresAt($author$project$Api$Data$clientAuthToken(apiClient));
        var _v0 = _Utils_Tuple2(refreshWindowStart, expiresAt);
        if (!_v0.a.$ && !_v0.b.$) {
            var refreshStart = _v0.a.a;
            var expiresAt_ = _v0.b.a;
            var fiveMinMs = 300000;
            return _Utils_cmp(expiresAt_ - refreshStart, fiveMinMs) > 0 ? A2($elm$core$Task$perform, function(_v1) {
                return $author$project$Shared$BackupJwtRefreshWindowFinished;
            }, $elm$core$Process$sleep(expiresAt_ - refreshStart - fiveMinMs)) : $author$project$Shared$refreshToken(apiClient);
        } else return $elm$core$Platform$Cmd$none;
    };
    var $simonh1000$elm_jwt$Jwt$isExpired = F2(function(now, token) {
        return A2($elm$core$Result$map, function(millis) {
            return _Utils_cmp($elm$time$Time$posixToMillis(now), millis) > 0;
        }, $simonh1000$elm_jwt$Jwt$getTokenExpirationMillis(token));
    });
    var $author$project$Api$AuthToken$isExpired = F2(function(authToken, now) {
        return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$andThen, $elm$core$Result$toMaybe, A2($elm$core$Maybe$map, $simonh1000$elm_jwt$Jwt$isExpired(now), A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken))));
    });
    var $author$project$Api$Data$clientHasTokenExpired = F2(function(_v0, now) {
        var client = _v0;
        return A2($author$project$Api$AuthToken$isExpired, client.e7, now);
    });
    var $elm$core$Basics$not = _Basics_not;
    var $elm$json$Json$Encode$string = _Json_wrap;
    var $author$project$Ports$Navigation$pushUrl = _Platform_outgoingPort('pushUrl', $elm$json$Json$Encode$string);
    var $elm$core$String$append = _String_append;
    var $author$project$Spa$Generated$Route$toString = function(route) {
        var segments = function() {
            switch(route.$){
                case 0:
                    return _List_Nil;
                case 1:
                    return _List_fromArray([
                        'blank'
                    ]);
                case 2:
                    return _List_fromArray([
                        'bookkeeping'
                    ]);
                case 3:
                    return _List_fromArray([
                        'calendar'
                    ]);
                case 4:
                    return _List_fromArray([
                        'forms'
                    ]);
                case 5:
                    return _List_fromArray([
                        'google_callback'
                    ]);
                case 6:
                    return _List_fromArray([
                        'home'
                    ]);
                case 7:
                    return _List_fromArray([
                        'login'
                    ]);
                case 8:
                    return _List_fromArray([
                        'logout'
                    ]);
                case 9:
                    return _List_fromArray([
                        'not_found'
                    ]);
                case 10:
                    return _List_fromArray([
                        'onboarding'
                    ]);
                case 11:
                    return _List_fromArray([
                        'affiliate_bills'
                    ]);
                case 12:
                    return _List_fromArray([
                        'affiliates'
                    ]);
                case 13:
                    return _List_fromArray([
                        'companies'
                    ]);
                case 14:
                    return _List_fromArray([
                        'files'
                    ]);
                case 15:
                    return _List_fromArray([
                        'marketplace'
                    ]);
                case 16:
                    return _List_fromArray([
                        'patients'
                    ]);
                case 17:
                    return _List_fromArray([
                        'practice_setup'
                    ]);
                case 18:
                    return _List_fromArray([
                        'style_guide'
                    ]);
                case 19:
                    return _List_fromArray([
                        'tasks'
                    ]);
                case 20:
                    return _List_fromArray([
                        'admin',
                        'advance_billing'
                    ]);
                case 21:
                    return _List_fromArray([
                        'admin',
                        'billing'
                    ]);
                case 22:
                    return _List_fromArray([
                        'admin',
                        'cancellation_reasons'
                    ]);
                case 23:
                    return _List_fromArray([
                        'admin',
                        'card_readers'
                    ]);
                case 24:
                    return _List_fromArray([
                        'admin',
                        'categories'
                    ]);
                case 25:
                    return _List_fromArray([
                        'admin',
                        'commissions'
                    ]);
                case 26:
                    return _List_fromArray([
                        'admin',
                        'coupons'
                    ]);
                case 27:
                    return _List_fromArray([
                        'admin',
                        'credit_categories'
                    ]);
                case 28:
                    return _List_fromArray([
                        'admin',
                        'elation_legacy'
                    ]);
                case 29:
                    return _List_fromArray([
                        'admin',
                        'features'
                    ]);
                case 30:
                    return _List_fromArray([
                        'admin',
                        'hipaa_authorizations'
                    ]);
                case 31:
                    return _List_fromArray([
                        'admin',
                        'internal_settings'
                    ]);
                case 32:
                    return _List_fromArray([
                        'admin',
                        'invoice_settings'
                    ]);
                case 33:
                    return _List_fromArray([
                        'admin',
                        'lead_sources'
                    ]);
                case 34:
                    return _List_fromArray([
                        'admin',
                        'locations'
                    ]);
                case 35:
                    return _List_fromArray([
                        'admin',
                        'mailgun'
                    ]);
                case 36:
                    return _List_fromArray([
                        'admin',
                        'notes'
                    ]);
                case 37:
                    return _List_fromArray([
                        'admin',
                        'patients'
                    ]);
                case 38:
                    return _List_fromArray([
                        'admin',
                        'payment_method_import'
                    ]);
                case 39:
                    return _List_fromArray([
                        'admin',
                        'payment_processing'
                    ]);
                case 40:
                    return _List_fromArray([
                        'admin',
                        'payment_sources'
                    ]);
                case 41:
                    return _List_fromArray([
                        'admin',
                        'practice'
                    ]);
                case 42:
                    return _List_fromArray([
                        'admin',
                        'provider_groups'
                    ]);
                case 43:
                    return _List_fromArray([
                        'admin',
                        'scheduled_jobs'
                    ]);
                case 44:
                    return _List_fromArray([
                        'admin',
                        'self_service'
                    ]);
                case 45:
                    return _List_fromArray([
                        'admin',
                        'signup'
                    ]);
                case 46:
                    return _List_fromArray([
                        'admin',
                        'stripe'
                    ]);
                case 47:
                    return _List_fromArray([
                        'admin',
                        'taxes'
                    ]);
                case 48:
                    return _List_fromArray([
                        'admin',
                        'team'
                    ]);
                case 49:
                    return _List_fromArray([
                        'affiliates',
                        'create'
                    ]);
                case 50:
                    return _List_fromArray([
                        'affiliates',
                        'new'
                    ]);
                case 51:
                    return _List_fromArray([
                        'charges',
                        'new'
                    ]);
                case 52:
                    return _List_fromArray([
                        'commissions',
                        'statements'
                    ]);
                case 53:
                    return _List_fromArray([
                        'companies',
                        'new'
                    ]);
                case 54:
                    return _List_fromArray([
                        'contacts',
                        'list'
                    ]);
                case 55:
                    return _List_fromArray([
                        'contacts',
                        'new'
                    ]);
                case 56:
                    return _List_fromArray([
                        'files',
                        'public'
                    ]);
                case 57:
                    return _List_fromArray([
                        'hinter',
                        'clone_practice'
                    ]);
                case 58:
                    return _List_fromArray([
                        'hinter',
                        'disputes'
                    ]);
                case 59:
                    return _List_fromArray([
                        'hinter',
                        'feature_flags'
                    ]);
                case 60:
                    return _List_fromArray([
                        'hinter',
                        'new_group'
                    ]);
                case 61:
                    return _List_fromArray([
                        'hinter',
                        'new_partner'
                    ]);
                case 62:
                    return _List_fromArray([
                        'hinter',
                        'new_practice'
                    ]);
                case 63:
                    return _List_fromArray([
                        'inventory',
                        'list'
                    ]);
                case 64:
                    return _List_fromArray([
                        'inventory',
                        'new'
                    ]);
                case 65:
                    return _List_fromArray([
                        'inventory',
                        'settings'
                    ]);
                case 66:
                    return _List_fromArray([
                        'marketplace',
                        'manage'
                    ]);
                case 67:
                    return _List_fromArray([
                        'messages',
                        'calls'
                    ]);
                case 68:
                    return _List_fromArray([
                        'messages',
                        'chat'
                    ]);
                case 69:
                    return _List_fromArray([
                        'messages',
                        'drafts'
                    ]);
                case 70:
                    return _List_fromArray([
                        'messages',
                        'forms'
                    ]);
                case 71:
                    return _List_fromArray([
                        'messages',
                        'labs'
                    ]);
                case 72:
                    return _List_fromArray([
                        'messages',
                        'sms'
                    ]);
                case 73:
                    return _List_fromArray([
                        'new_settings',
                        'blocked_phone_numbers'
                    ]);
                case 74:
                    return _List_fromArray([
                        'new_settings',
                        'booking_overview'
                    ]);
                case 75:
                    return _List_fromArray([
                        'new_settings',
                        'erx'
                    ]);
                case 76:
                    return _List_fromArray([
                        'new_settings',
                        'export'
                    ]);
                case 77:
                    return _List_fromArray([
                        'new_settings',
                        'hinter_settings'
                    ]);
                case 78:
                    return _List_fromArray([
                        'new_settings',
                        'practice_info'
                    ]);
                case 79:
                    return _List_fromArray([
                        'new_settings',
                        'team'
                    ]);
                case 80:
                    return _List_fromArray([
                        'oauth',
                        'callback'
                    ]);
                case 81:
                    return _List_fromArray([
                        'partner',
                        'api_keys'
                    ]);
                case 82:
                    return _List_fromArray([
                        'partner',
                        'billing'
                    ]);
                case 83:
                    return _List_fromArray([
                        'partner',
                        'engagements'
                    ]);
                case 84:
                    return _List_fromArray([
                        'partner',
                        'hinter'
                    ]);
                case 85:
                    return _List_fromArray([
                        'partner',
                        'product'
                    ]);
                case 86:
                    return _List_fromArray([
                        'partner',
                        'team'
                    ]);
                case 87:
                    return _List_fromArray([
                        'patients',
                        'create'
                    ]);
                case 88:
                    return _List_fromArray([
                        'patients',
                        'upload'
                    ]);
                case 89:
                    return _List_fromArray([
                        'practice_setup',
                        'account'
                    ]);
                case 90:
                    return _List_fromArray([
                        'practice_setup',
                        'communications'
                    ]);
                case 91:
                    return _List_fromArray([
                        'practice_setup',
                        'complete'
                    ]);
                case 92:
                    return _List_fromArray([
                        'practice_setup',
                        'documents'
                    ]);
                case 93:
                    return _List_fromArray([
                        'practice_setup',
                        'legal'
                    ]);
                case 94:
                    return _List_fromArray([
                        'practice_setup',
                        'payment_processing'
                    ]);
                case 95:
                    return _List_fromArray([
                        'practice_setup',
                        'plans'
                    ]);
                case 96:
                    return _List_fromArray([
                        'practice_setup',
                        'team'
                    ]);
                case 97:
                    return _List_fromArray([
                        'reports',
                        'company_invoices'
                    ]);
                case 98:
                    return _List_fromArray([
                        'reports',
                        'credit_outstanding'
                    ]);
                case 99:
                    return _List_fromArray([
                        'reports',
                        'credit_transactions'
                    ]);
                case 100:
                    return _List_fromArray([
                        'reports',
                        'dashboard'
                    ]);
                case 101:
                    return _List_fromArray([
                        'reports',
                        'deferred_revenue'
                    ]);
                case 102:
                    return _List_fromArray([
                        'reports',
                        'deposits'
                    ]);
                case 103:
                    return _List_fromArray([
                        'reports',
                        'disputes'
                    ]);
                case 104:
                    return _List_fromArray([
                        'reports',
                        'invoices'
                    ]);
                case 105:
                    return _List_fromArray([
                        'reports',
                        'memberships'
                    ]);
                case 106:
                    return _List_fromArray([
                        'reports',
                        'months'
                    ]);
                case 107:
                    return _List_fromArray([
                        'reports',
                        'payment_applications'
                    ]);
                case 108:
                    return _List_fromArray([
                        'reports',
                        'revenue'
                    ]);
                case 109:
                    return _List_fromArray([
                        'reports',
                        'sales_tax'
                    ]);
                case 110:
                    return _List_fromArray([
                        'reports',
                        'signup_attempts'
                    ]);
                case 111:
                    return _List_fromArray([
                        'style_guide',
                        'activity_indicators'
                    ]);
                case 112:
                    return _List_fromArray([
                        'style_guide',
                        'address_input'
                    ]);
                case 113:
                    return _List_fromArray([
                        'style_guide',
                        'alert'
                    ]);
                case 114:
                    return _List_fromArray([
                        'style_guide',
                        'badge'
                    ]);
                case 115:
                    return _List_fromArray([
                        'style_guide',
                        'button'
                    ]);
                case 116:
                    return _List_fromArray([
                        'style_guide',
                        'carousel'
                    ]);
                case 117:
                    return _List_fromArray([
                        'style_guide',
                        'checkbox'
                    ]);
                case 118:
                    return _List_fromArray([
                        'style_guide',
                        'currency_input'
                    ]);
                case 119:
                    return _List_fromArray([
                        'style_guide',
                        'date_input'
                    ]);
                case 120:
                    return _List_fromArray([
                        'style_guide',
                        'date_range_input'
                    ]);
                case 121:
                    return _List_fromArray([
                        'style_guide',
                        'dropdown'
                    ]);
                case 122:
                    return _List_fromArray([
                        'style_guide',
                        'export_csv'
                    ]);
                case 123:
                    return _List_fromArray([
                        'style_guide',
                        'file_input'
                    ]);
                case 124:
                    return _List_fromArray([
                        'style_guide',
                        'flyout_menu'
                    ]);
                case 125:
                    return _List_fromArray([
                        'style_guide',
                        'form_example'
                    ]);
                case 126:
                    return _List_fromArray([
                        'style_guide',
                        'form_group'
                    ]);
                case 127:
                    return _List_fromArray([
                        'style_guide',
                        'form_static'
                    ]);
                case 128:
                    return _List_fromArray([
                        'style_guide',
                        'grid'
                    ]);
                case 129:
                    return _List_fromArray([
                        'style_guide',
                        'hi_confirm'
                    ]);
                case 130:
                    return _List_fromArray([
                        'style_guide',
                        'horizontal_rule'
                    ]);
                case 131:
                    return _List_fromArray([
                        'style_guide',
                        'icon'
                    ]);
                case 132:
                    return _List_fromArray([
                        'style_guide',
                        'input'
                    ]);
                case 133:
                    return _List_fromArray([
                        'style_guide',
                        'link'
                    ]);
                case 134:
                    return _List_fromArray([
                        'style_guide',
                        'list_group'
                    ]);
                case 135:
                    return _List_fromArray([
                        'style_guide',
                        'modal'
                    ]);
                case 136:
                    return _List_fromArray([
                        'style_guide',
                        'pagination'
                    ]);
                case 137:
                    return _List_fromArray([
                        'style_guide',
                        'panel'
                    ]);
                case 138:
                    return _List_fromArray([
                        'style_guide',
                        'password_input'
                    ]);
                case 139:
                    return _List_fromArray([
                        'style_guide',
                        'payment_source_displayer'
                    ]);
                case 140:
                    return _List_fromArray([
                        'style_guide',
                        'phone_input'
                    ]);
                case 141:
                    return _List_fromArray([
                        'style_guide',
                        'popover'
                    ]);
                case 142:
                    return _List_fromArray([
                        'style_guide',
                        'progress_bar'
                    ]);
                case 143:
                    return _List_fromArray([
                        'style_guide',
                        'radio'
                    ]);
                case 144:
                    return _List_fromArray([
                        'style_guide',
                        'resource_filter'
                    ]);
                case 145:
                    return _List_fromArray([
                        'style_guide',
                        'search_input'
                    ]);
                case 146:
                    return _List_fromArray([
                        'style_guide',
                        'searchable_select'
                    ]);
                case 147:
                    return _List_fromArray([
                        'style_guide',
                        'select'
                    ]);
                case 148:
                    return _List_fromArray([
                        'style_guide',
                        'skeleton'
                    ]);
                case 149:
                    return _List_fromArray([
                        'style_guide',
                        'table'
                    ]);
                case 150:
                    return _List_fromArray([
                        'style_guide',
                        'toast'
                    ]);
                case 151:
                    return _List_fromArray([
                        'style_guide',
                        'toggle_switch'
                    ]);
                case 152:
                    return _List_fromArray([
                        'style_guide',
                        'tooltip'
                    ]);
                case 153:
                    return _List_fromArray([
                        'style_guide',
                        'typography'
                    ]);
                case 154:
                    return _List_fromArray([
                        'style_guide',
                        'upload_form'
                    ]);
                case 155:
                    return _List_fromArray([
                        'style_guide',
                        'upload_result'
                    ]);
                case 156:
                    return _List_fromArray([
                        'style_guide',
                        'well'
                    ]);
                case 157:
                    return _List_fromArray([
                        'support',
                        'canny_sso'
                    ]);
                case 158:
                    return _List_fromArray([
                        'tasks',
                        'new'
                    ]);
                case 159:
                    return _List_fromArray([
                        'user',
                        'accept_terms'
                    ]);
                case 160:
                    return _List_fromArray([
                        'user',
                        'mfa'
                    ]);
                case 161:
                    return _List_fromArray([
                        'user',
                        'profile'
                    ]);
                case 162:
                    return _List_fromArray([
                        'user',
                        'security'
                    ]);
                case 163:
                    var slug = route.a._A;
                    return _List_fromArray([
                        'apps',
                        slug
                    ]);
                case 164:
                    var status = route.a.ahy;
                    return _List_fromArray([
                        'error',
                        status
                    ]);
                case 165:
                    var token = route.a.aaf;
                    return _List_fromArray([
                        'join',
                        token
                    ]);
                case 166:
                    var slug = route.a._A;
                    return _List_fromArray([
                        'marketplace',
                        slug
                    ]);
                case 167:
                    return _List_fromArray([
                        'admin',
                        'athenahealth'
                    ]);
                case 168:
                    return _List_fromArray([
                        'admin',
                        'charge_items'
                    ]);
                case 169:
                    return _List_fromArray([
                        'admin',
                        'company_plans'
                    ]);
                case 170:
                    return _List_fromArray([
                        'admin',
                        'coverage_plans'
                    ]);
                case 171:
                    return _List_fromArray([
                        'admin',
                        'data_export'
                    ]);
                case 172:
                    return _List_fromArray([
                        'admin',
                        'data_export_settings'
                    ]);
                case 173:
                    return _List_fromArray([
                        'admin',
                        'documents'
                    ]);
                case 174:
                    return _List_fromArray([
                        'admin',
                        'elation'
                    ]);
                case 175:
                    return _List_fromArray([
                        'admin',
                        'plans'
                    ]);
                case 176:
                    return _List_fromArray([
                        'admin',
                        'providers'
                    ]);
                case 177:
                    return _List_fromArray([
                        'admin',
                        'quickbooks'
                    ]);
                case 178:
                    return _List_fromArray([
                        'admin',
                        'signup_pages'
                    ]);
                case 179:
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts'
                    ]);
                case 180:
                    return _List_fromArray([
                        'commissions',
                        'statement_lines'
                    ]);
                case 181:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId
                    ]);
                case 182:
                    var contactId = route.a.acA;
                    return _List_fromArray([
                        'contacts',
                        contactId
                    ]);
                case 183:
                    return _List_fromArray([
                        'hinter',
                        'admin_users_groups'
                    ]);
                case 184:
                    var inventoryId = route.a.aev;
                    return _List_fromArray([
                        'inventory',
                        inventoryId
                    ]);
                case 185:
                    return _List_fromArray([
                        'messages',
                        'faxes'
                    ]);
                case 186:
                    return _List_fromArray([
                        'messages',
                        'scheduled'
                    ]);
                case 187:
                    return _List_fromArray([
                        'new_settings',
                        'appointment_types'
                    ]);
                case 188:
                    return _List_fromArray([
                        'new_settings',
                        'locations'
                    ]);
                case 189:
                    return _List_fromArray([
                        'new_settings',
                        'templates'
                    ]);
                case 190:
                    var dealId = route.a.acS;
                    return _List_fromArray([
                        'onboard',
                        dealId
                    ]);
                case 191:
                    return _List_fromArray([
                        'partner',
                        'dashboard'
                    ]);
                case 192:
                    return _List_fromArray([
                        'partner',
                        'practices'
                    ]);
                case 193:
                    return _List_fromArray([
                        'partner',
                        'sandboxes'
                    ]);
                case 194:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId
                    ]);
                case 195:
                    return _List_fromArray([
                        'reports',
                        'ancillary_charges'
                    ]);
                case 196:
                    var tasksId = route.a.ahJ;
                    return _List_fromArray([
                        'tasks',
                        tasksId
                    ]);
                case 197:
                    return _List_fromArray([
                        'user',
                        'organizations'
                    ]);
                case 198:
                    return _List_fromArray([
                        'admin',
                        'athenahealth',
                        'fields'
                    ]);
                case 199:
                    return _List_fromArray([
                        'admin',
                        'athenahealth',
                        'link'
                    ]);
                case 200:
                    return _List_fromArray([
                        'admin',
                        'athenahealth',
                        'locations'
                    ]);
                case 201:
                    return _List_fromArray([
                        'admin',
                        'athenahealth',
                        'overview'
                    ]);
                case 202:
                    return _List_fromArray([
                        'admin',
                        'athenahealth',
                        'providers'
                    ]);
                case 203:
                    return _List_fromArray([
                        'admin',
                        'charge_items',
                        'new'
                    ]);
                case 204:
                    return _List_fromArray([
                        'admin',
                        'charge_items',
                        'upload'
                    ]);
                case 205:
                    return _List_fromArray([
                        'admin',
                        'company_plans',
                        'new'
                    ]);
                case 206:
                    return _List_fromArray([
                        'admin',
                        'coverage_plans',
                        'new'
                    ]);
                case 207:
                    return _List_fromArray([
                        'admin',
                        'credits',
                        'upload'
                    ]);
                case 208:
                    return _List_fromArray([
                        'admin',
                        'data_export_settings',
                        'new'
                    ]);
                case 209:
                    return _List_fromArray([
                        'admin',
                        'developers',
                        'api_keys'
                    ]);
                case 210:
                    return _List_fromArray([
                        'admin',
                        'developers',
                        'get_started'
                    ]);
                case 211:
                    return _List_fromArray([
                        'admin',
                        'developers',
                        'sandboxes'
                    ]);
                case 212:
                    return _List_fromArray([
                        'admin',
                        'developers',
                        'webhook_endpoints'
                    ]);
                case 213:
                    return _List_fromArray([
                        'admin',
                        'documents',
                        'new'
                    ]);
                case 214:
                    return _List_fromArray([
                        'admin',
                        'elation',
                        'link'
                    ]);
                case 215:
                    return _List_fromArray([
                        'admin',
                        'elation',
                        'overview'
                    ]);
                case 216:
                    return _List_fromArray([
                        'admin',
                        'elation',
                        'providers'
                    ]);
                case 217:
                    return _List_fromArray([
                        'admin',
                        'notifications',
                        'company'
                    ]);
                case 218:
                    return _List_fromArray([
                        'admin',
                        'notifications',
                        'employee'
                    ]);
                case 219:
                    return _List_fromArray([
                        'admin',
                        'notifications',
                        'membership'
                    ]);
                case 220:
                    return _List_fromArray([
                        'admin',
                        'notifications',
                        'patient'
                    ]);
                case 221:
                    return _List_fromArray([
                        'admin',
                        'notifications',
                        'practice'
                    ]);
                case 222:
                    return _List_fromArray([
                        'admin',
                        'notifications',
                        'settings'
                    ]);
                case 223:
                    return _List_fromArray([
                        'admin',
                        'payment_method_import',
                        'upload'
                    ]);
                case 224:
                    return _List_fromArray([
                        'admin',
                        'plans',
                        'new'
                    ]);
                case 225:
                    return _List_fromArray([
                        'admin',
                        'providers',
                        'upload'
                    ]);
                case 226:
                    return _List_fromArray([
                        'admin',
                        'signup_pages',
                        'new'
                    ]);
                case 227:
                    return _List_fromArray([
                        'admin',
                        'team',
                        'new'
                    ]);
                case 228:
                    var affiliateId = route.a.pr;
                    return _List_fromArray([
                        'affiliates',
                        affiliateId,
                        'affiliate_actions'
                    ]);
                case 229:
                    var affiliateId = route.a.pr;
                    return _List_fromArray([
                        'affiliates',
                        affiliateId,
                        'link_providers'
                    ]);
                case 230:
                    var affiliateId = route.a.pr;
                    return _List_fromArray([
                        'affiliates',
                        affiliateId,
                        'linked_providers'
                    ]);
                case 231:
                    var affiliateId = route.a.pr;
                    return _List_fromArray([
                        'affiliates',
                        affiliateId,
                        'patients'
                    ]);
                case 232:
                    var affiliateId = route.a.pr;
                    return _List_fromArray([
                        'affiliates',
                        affiliateId,
                        'settings'
                    ]);
                case 233:
                    var affiliateId = route.a.pr;
                    return _List_fromArray([
                        'affiliates',
                        affiliateId,
                        'users'
                    ]);
                case 234:
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        'new'
                    ]);
                case 235:
                    return _List_fromArray([
                        'commissions',
                        'statement_lines',
                        'summary'
                    ]);
                case 236:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'affiliates_pricing'
                    ]);
                case 237:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'eas'
                    ]);
                case 238:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'ended_commissions'
                    ]);
                case 239:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'invoice_settings'
                    ]);
                case 240:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'notes'
                    ]);
                case 241:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'notifications'
                    ]);
                case 242:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'payment_sources'
                    ]);
                case 243:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'signup'
                    ]);
                case 244:
                    return _List_fromArray([
                        'messages',
                        'faxes',
                        'new'
                    ]);
                case 245:
                    return _List_fromArray([
                        'messages',
                        'scheduled',
                        'new'
                    ]);
                case 246:
                    return _List_fromArray([
                        'new_settings',
                        'appointment_types',
                        'new'
                    ]);
                case 247:
                    return _List_fromArray([
                        'new_settings',
                        'templates',
                        'new'
                    ]);
                case 248:
                    var onboardId = route.a.afS;
                    return _List_fromArray([
                        'onboard',
                        onboardId,
                        'completed'
                    ]);
                case 249:
                    var onboardId = route.a.afS;
                    return _List_fromArray([
                        'onboard',
                        onboardId,
                        'completing'
                    ]);
                case 250:
                    var onboardId = route.a.afS;
                    return _List_fromArray([
                        'onboard',
                        onboardId,
                        'payment'
                    ]);
                case 251:
                    var onboardId = route.a.afS;
                    return _List_fromArray([
                        'onboard',
                        onboardId,
                        'user'
                    ]);
                case 252:
                    return _List_fromArray([
                        'partner',
                        'billing',
                        'hinter'
                    ]);
                case 253:
                    return _List_fromArray([
                        'partner',
                        'product',
                        'activation_settings'
                    ]);
                case 254:
                    return _List_fromArray([
                        'partner',
                        'product',
                        'app_settings'
                    ]);
                case 255:
                    return _List_fromArray([
                        'partner',
                        'product',
                        'hinter'
                    ]);
                case 256:
                    return _List_fromArray([
                        'partner',
                        'product',
                        'new'
                    ]);
                case 257:
                    return _List_fromArray([
                        'partner',
                        'webhooks',
                        'requests'
                    ]);
                case 258:
                    return _List_fromArray([
                        'partner',
                        'webhooks',
                        'settings'
                    ]);
                case 259:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'chart'
                    ]);
                case 260:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'edit'
                    ]);
                case 261:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'growth_chart'
                    ]);
                case 262:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'lab_trends'
                    ]);
                case 263:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'manage_credits'
                    ]);
                case 264:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'merge'
                    ]);
                case 265:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'vitals_trends'
                    ]);
                case 266:
                    return _List_fromArray([
                        'practice_setup',
                        'plans',
                        'new'
                    ]);
                case 267:
                    return _List_fromArray([
                        'reports',
                        'credit_outstanding',
                        'summary'
                    ]);
                case 268:
                    return _List_fromArray([
                        'reports',
                        'credit_transactions',
                        'summary'
                    ]);
                case 269:
                    return _List_fromArray([
                        'reports',
                        'custom',
                        'new'
                    ]);
                case 270:
                    return _List_fromArray([
                        'reports',
                        'deferred_revenue',
                        'summary'
                    ]);
                case 271:
                    return _List_fromArray([
                        'reports',
                        'payment_applications',
                        'summary'
                    ]);
                case 272:
                    return _List_fromArray([
                        'reports',
                        'revenue',
                        'summary'
                    ]);
                case 273:
                    return _List_fromArray([
                        'reports',
                        'sales_tax',
                        'summary'
                    ]);
                case 274:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'charge_items',
                        id
                    ]);
                case 275:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'company_plans',
                        id
                    ]);
                case 276:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'coverage_plans',
                        id
                    ]);
                case 277:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'data_export',
                        id
                    ]);
                case 278:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'data_export_settings',
                        id
                    ]);
                case 279:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'documents',
                        id
                    ]);
                case 280:
                    var slug = route.a._A;
                    return _List_fromArray([
                        'admin',
                        'integrations',
                        slug
                    ]);
                case 281:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'plans',
                        id
                    ]);
                case 282:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'signup_pages',
                        id
                    ]);
                case 283:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'hinter',
                        'admin_users_groups',
                        id
                    ]);
                case 284:
                    var ident = route.a.aeg;
                    return _List_fromArray([
                        'new_settings',
                        'appointment_types',
                        ident
                    ]);
                case 285:
                    var bookingLocationId = route.a.ab5;
                    return _List_fromArray([
                        'new_settings',
                        'locations',
                        bookingLocationId
                    ]);
                case 286:
                    var teamId = route.a.ahL;
                    return _List_fromArray([
                        'new_settings',
                        'team',
                        teamId
                    ]);
                case 287:
                    var templateId = route.a.ahM;
                    return _List_fromArray([
                        'new_settings',
                        'templates',
                        templateId
                    ]);
                case 288:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'reports',
                        'ancillary_charges',
                        id
                    ]);
                case 289:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'reports',
                        'custom',
                        id
                    ]);
                case 290:
                    var affiliateId = route.a.pr;
                    return _List_fromArray([
                        'affiliates',
                        affiliateId,
                        'bills'
                    ]);
                case 291:
                    var brokerAccountId = route.a.bS;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId
                    ]);
                case 292:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'employees'
                    ]);
                case 293:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'invoices'
                    ]);
                case 294:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'uploads'
                    ]);
                case 295:
                    var scheduledId = route.a.ag6;
                    return _List_fromArray([
                        'messages',
                        'scheduled',
                        scheduledId
                    ]);
                case 296:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'accounts'
                    ]);
                case 297:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'affiliation'
                    ]);
                case 298:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'charges'
                    ]);
                case 299:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'memberships'
                    ]);
                case 300:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'notes'
                    ]);
                case 301:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'notifications'
                    ]);
                case 302:
                    return _List_fromArray([
                        'admin',
                        'notifications',
                        'patient',
                        'dunning_schedule'
                    ]);
                case 303:
                    var brokerAccountId = route.a.bS;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId,
                        'deals'
                    ]);
                case 304:
                    var brokerAccountId = route.a.bS;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId,
                        'ended_deals'
                    ]);
                case 305:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'employees',
                        'create'
                    ]);
                case 306:
                    var companyId = route.a.fl;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'signup_pages',
                        'new'
                    ]);
                case 307:
                    return _List_fromArray([
                        'marketplace',
                        'bookkeeping',
                        'manage',
                        'settings'
                    ]);
                case 308:
                    return _List_fromArray([
                        'marketplace',
                        'elation',
                        'manage',
                        'settings'
                    ]);
                case 309:
                    return _List_fromArray([
                        'marketplace',
                        'quickbooks',
                        'manage',
                        'settings'
                    ]);
                case 310:
                    var slug = route.a._A;
                    return _List_fromArray([
                        'marketplace',
                        slug,
                        'manage',
                        'onboarding'
                    ]);
                case 311:
                    var slug = route.a._A;
                    return _List_fromArray([
                        'marketplace',
                        slug,
                        'manage',
                        'settings'
                    ]);
                case 312:
                    var slug = route.a._A;
                    return _List_fromArray([
                        'marketplace',
                        slug,
                        'manage',
                        'users'
                    ]);
                case 313:
                    var teamId = route.a.ahL;
                    return _List_fromArray([
                        'new_settings',
                        'team',
                        teamId,
                        'basic_info'
                    ]);
                case 314:
                    var patientId = route.a.V8;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'memberships',
                        'new'
                    ]);
                case 315:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'practice_setup',
                        'plans',
                        id,
                        'edit'
                    ]);
                case 316:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'billing',
                        'practice_invoices',
                        id
                    ]);
                case 317:
                    var affiliateId = route.a.pr;
                    var id = route.a.aef;
                    return _List_fromArray([
                        'affiliates',
                        affiliateId,
                        'bills',
                        id
                    ]);
                case 318:
                    var companyId = route.a.fl;
                    var id = route.a.aef;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'invoices',
                        id
                    ]);
                case 319:
                    var companyId = route.a.fl;
                    var id = route.a.aef;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'signup_pages',
                        id
                    ]);
                case 320:
                    var locationId = route.a.Tp;
                    return _List_fromArray([
                        'new_settings',
                        'locations',
                        'new',
                        locationId
                    ]);
                case 321:
                    var patientId = route.a.V8;
                    var noteId = route.a.afp;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'notes',
                        noteId
                    ]);
                case 322:
                    var brokerAccountId = route.a.bS;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId,
                        'brokers'
                    ]);
                case 323:
                    var brokerAccountId = route.a.bS;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId,
                        'statements'
                    ]);
                case 324:
                    var companyId = route.a.fl;
                    var uploadId = route.a.H_;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'uploads',
                        uploadId
                    ]);
                case 325:
                    var patientId = route.a.V8;
                    var agreementId = route.a.I$;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'agreements',
                        agreementId
                    ]);
                case 326:
                    var patientId = route.a.V8;
                    var invoiceId = route.a.RI;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'charges',
                        invoiceId
                    ]);
                case 327:
                    var patientId = route.a.V8;
                    var membershipId = route.a.y0;
                    return _List_fromArray([
                        'patients',
                        patientId,
                        'memberships',
                        membershipId
                    ]);
                case 328:
                    var id = route.a.aef;
                    return _List_fromArray([
                        'admin',
                        'plans',
                        id,
                        'pricing_versions',
                        'new'
                    ]);
                case 329:
                    var brokerAccountId = route.a.bS;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId,
                        'brokers',
                        'ended'
                    ]);
                case 330:
                    var brokerAccountId = route.a.bS;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId,
                        'brokers',
                        'new'
                    ]);
                case 331:
                    var companyId = route.a.fl;
                    var uploadId = route.a.H_;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'uploads',
                        uploadId,
                        'upload_results'
                    ]);
                case 332:
                    var id = route.a.aef;
                    var pricingVersionId = route.a.ago;
                    return _List_fromArray([
                        'admin',
                        'plans',
                        id,
                        'pricing_versions',
                        pricingVersionId
                    ]);
                case 333:
                    var brokerAccountId = route.a.bS;
                    var statementId = route.a.ahx;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId,
                        'statements',
                        statementId
                    ]);
                case 334:
                    var brokerAccountId = route.a.bS;
                    var brokerId = route.a.EC;
                    return _List_fromArray([
                        'commissions',
                        'broker_accounts',
                        brokerAccountId,
                        'brokers',
                        brokerId
                    ]);
                default:
                    var companyId = route.a.fl;
                    var employeeId = route.a.adk;
                    var dependentId = route.a.ac2;
                    return _List_fromArray([
                        'companies',
                        companyId,
                        'employees',
                        employeeId,
                        'dependent',
                        dependentId
                    ]);
            }
        }();
        return A2($elm$core$String$append, '/', A2($elm$core$String$join, '/', segments));
    };
    var $author$project$Ports$Navigation$pushRoute = F2(function(queryParams, route) {
        return $author$project$Ports$Navigation$pushUrl(_Utils_ap($author$project$Spa$Generated$Route$toString(route), $elm$url$Url$Builder$toQuery(queryParams)));
    });
    var $author$project$Api$Platform$Session$One$Session = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Session$One$Record = function(id) {
        return function(createdAt) {
            return function(role) {
                return function(restrictedByGroups) {
                    return function(user) {
                        return function(showCollectionWarning) {
                            return function(requestDetail) {
                                return function(organization) {
                                    return function(permissionSets) {
                                        return function(locationGroups) {
                                            return function(sandbox) {
                                                return {
                                                    Mx: createdAt,
                                                    aef: id,
                                                    Tl: locationGroups,
                                                    VA: organization,
                                                    WD: permissionSets,
                                                    YE: requestDetail,
                                                    YW: restrictedByGroups,
                                                    ag_: role,
                                                    Zn: sandbox,
                                                    _f: showCollectionWarning,
                                                    aaX: user
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $elm$json$Json$Decode$fail = _Json_fail;
    var $elm$parser$Parser$Advanced$Bad = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $elm$parser$Parser$Advanced$Good = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
    var $elm$parser$Parser$Advanced$andThen = F2(function(callback, _v0) {
        var parseA = _v0;
        return function(s0) {
            var _v1 = parseA(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return A2($elm$parser$Parser$Advanced$Bad, p, x);
            } else {
                var p1 = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                var _v2 = callback(a);
                var parseB = _v2;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
                } else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
                }
            }
        };
    });
    var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
    var $elm$parser$Parser$ExpectingEnd = {
        $: 10
    };
    var $elm$parser$Parser$Advanced$AddRight = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $elm$parser$Parser$Advanced$DeadEnd = F4(function(row, col, problem, contextStack) {
        return {
            Ln: col,
            acB: contextStack,
            nK: problem,
            n4: row
        };
    });
    var $elm$parser$Parser$Advanced$Empty = {
        $: 0
    };
    var $elm$parser$Parser$Advanced$fromState = F2(function(s, x) {
        return A2($elm$parser$Parser$Advanced$AddRight, $elm$parser$Parser$Advanced$Empty, A4($elm$parser$Parser$Advanced$DeadEnd, s.n4, s.Ln, x, s.aC));
    });
    var $elm$parser$Parser$Advanced$end = function(x) {
        return function(s) {
            return _Utils_eq($elm$core$String$length(s.s2), s.f) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, x));
        };
    };
    var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
    var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
    var $elm$parser$Parser$Advanced$chompWhileHelp = F5(function(isGood, offset, row, col, s0) {
        chompWhileHelp: while(true){
            var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.s2);
            if (_Utils_eq(newOffset, -1)) return A3($elm$parser$Parser$Advanced$Good, _Utils_cmp(s0.f, offset) < 0, 0, {
                Ln: col,
                aC: s0.aC,
                aeo: s0.aeo,
                f: offset,
                n4: row,
                s2: s0.s2
            });
            else if (_Utils_eq(newOffset, -2)) {
                var $temp$isGood = isGood, $temp$offset = offset + 1, $temp$row = row + 1, $temp$col = 1, $temp$s0 = s0;
                isGood = $temp$isGood;
                offset = $temp$offset;
                row = $temp$row;
                col = $temp$col;
                s0 = $temp$s0;
                continue chompWhileHelp;
            } else {
                var $temp$isGood = isGood, $temp$offset = newOffset, $temp$row = row, $temp$col = col + 1, $temp$s0 = s0;
                isGood = $temp$isGood;
                offset = $temp$offset;
                row = $temp$row;
                col = $temp$col;
                s0 = $temp$s0;
                continue chompWhileHelp;
            }
        }
    });
    var $elm$parser$Parser$Advanced$chompWhile = function(isGood) {
        return function(s) {
            return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.f, s.n4, s.Ln, s);
        };
    };
    var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
    var $elm$parser$Parser$Advanced$mapChompedString = F2(function(func, _v0) {
        var parse = _v0;
        return function(s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var p = _v1.a;
                var x = _v1.b;
                return A2($elm$parser$Parser$Advanced$Bad, p, x);
            } else {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return A3($elm$parser$Parser$Advanced$Good, p, A2(func, A3($elm$core$String$slice, s0.f, s1.f, s0.s2), a), s1);
            }
        };
    });
    var $elm$parser$Parser$Advanced$getChompedString = function(parser) {
        return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
    };
    var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
    var $elm$parser$Parser$Problem = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $elm$parser$Parser$Advanced$problem = function(x) {
        return function(s) {
            return A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, x));
        };
    };
    var $elm$parser$Parser$problem = function(msg) {
        return $elm$parser$Parser$Advanced$problem($elm$parser$Parser$Problem(msg));
    };
    var $elm$parser$Parser$Advanced$succeed = function(a) {
        return function(s) {
            return A3($elm$parser$Parser$Advanced$Good, false, a, s);
        };
    };
    var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
    var $elm$core$String$toFloat = _String_toFloat;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2($elm$parser$Parser$andThen, function(str) {
        if ($elm$core$String$length(str) <= 9) {
            var _v0 = $elm$core$String$toFloat('0.' + str);
            if (!_v0.$) {
                var floatVal = _v0.a;
                return $elm$parser$Parser$succeed($elm$core$Basics$round(floatVal * 1000));
            } else return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
        } else return $elm$parser$Parser$problem('Expected at most 9 digits, but got ' + $elm$core$String$fromInt($elm$core$String$length(str)));
    }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
    var $elm$time$Time$Posix = $elm$core$Basics$identity;
    var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(function(monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
        return $elm$time$Time$millisToPosix(monthYearDayMs + hour * 3600000 + (minute - utcOffsetMinutes) * 60000 + second * 1000 + ms);
    });
    var $elm$parser$Parser$Advanced$map2 = F3(function(func, _v0, _v1) {
        var parseA = _v0;
        var parseB = _v1;
        return function(s0) {
            var _v2 = parseA(s0);
            if (_v2.$ === 1) {
                var p = _v2.a;
                var x = _v2.b;
                return A2($elm$parser$Parser$Advanced$Bad, p, x);
            } else {
                var p1 = _v2.a;
                var a = _v2.b;
                var s1 = _v2.c;
                var _v3 = parseB(s1);
                if (_v3.$ === 1) {
                    var p2 = _v3.a;
                    var x = _v3.b;
                    return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
                } else {
                    var p2 = _v3.a;
                    var b = _v3.b;
                    var s2 = _v3.c;
                    return A3($elm$parser$Parser$Advanced$Good, p1 || p2, A2(func, a, b), s2);
                }
            }
        };
    });
    var $elm$parser$Parser$Advanced$ignorer = F2(function(keepParser, ignoreParser) {
        return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
    });
    var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
    var $elm$parser$Parser$Advanced$keeper = F2(function(parseFunc, parseArg) {
        return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
    });
    var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
    var $elm$parser$Parser$Advanced$Append = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $elm$parser$Parser$Advanced$oneOfHelp = F3(function(s0, bag, parsers) {
        oneOfHelp: while(true){
            if (!parsers.b) return A2($elm$parser$Parser$Advanced$Bad, false, bag);
            else {
                var parse = parsers.a;
                var remainingParsers = parsers.b;
                var _v1 = parse(s0);
                if (!_v1.$) {
                    var step = _v1;
                    return step;
                } else {
                    var step = _v1;
                    var p = step.a;
                    var x = step.b;
                    if (p) return step;
                    else {
                        var $temp$s0 = s0, $temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x), $temp$parsers = remainingParsers;
                        s0 = $temp$s0;
                        bag = $temp$bag;
                        parsers = $temp$parsers;
                        continue oneOfHelp;
                    }
                }
            }
        }
    });
    var $elm$parser$Parser$Advanced$oneOf = function(parsers) {
        return function(s) {
            return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
        };
    };
    var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
    var $elm$parser$Parser$Done = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$parser$Parser$Loop = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$parser$Parser$UnexpectedChar = {
        $: 11
    };
    var $elm$parser$Parser$Advanced$chompIf = F2(function(isGood, expecting) {
        return function(s) {
            var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.f, s.s2);
            return _Utils_eq(newOffset, -1) ? A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : _Utils_eq(newOffset, -2) ? A3($elm$parser$Parser$Advanced$Good, true, 0, {
                Ln: 1,
                aC: s.aC,
                aeo: s.aeo,
                f: s.f + 1,
                n4: s.n4 + 1,
                s2: s.s2
            }) : A3($elm$parser$Parser$Advanced$Good, true, 0, {
                Ln: s.Ln + 1,
                aC: s.aC,
                aeo: s.aeo,
                f: newOffset,
                n4: s.n4,
                s2: s.s2
            });
        };
    });
    var $elm$parser$Parser$chompIf = function(isGood) {
        return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
    };
    var $elm$parser$Parser$Advanced$loopHelp = F4(function(p, state, callback, s0) {
        loopHelp: while(true){
            var _v0 = callback(state);
            var parse = _v0;
            var _v1 = parse(s0);
            if (!_v1.$) {
                var p1 = _v1.a;
                var step = _v1.b;
                var s1 = _v1.c;
                if (!step.$) {
                    var newState = step.a;
                    var $temp$p = p || p1, $temp$state = newState, $temp$callback = callback, $temp$s0 = s1;
                    p = $temp$p;
                    state = $temp$state;
                    callback = $temp$callback;
                    s0 = $temp$s0;
                    continue loopHelp;
                } else {
                    var result = step.a;
                    return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
                }
            } else {
                var p1 = _v1.a;
                var x = _v1.b;
                return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
            }
        }
    });
    var $elm$parser$Parser$Advanced$loop = F2(function(state, callback) {
        return function(s) {
            return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
        };
    });
    var $elm$parser$Parser$Advanced$map = F2(function(func, _v0) {
        var parse = _v0;
        return function(s0) {
            var _v1 = parse(s0);
            if (!_v1.$) {
                var p = _v1.a;
                var a = _v1.b;
                var s1 = _v1.c;
                return A3($elm$parser$Parser$Advanced$Good, p, func(a), s1);
            } else {
                var p = _v1.a;
                var x = _v1.b;
                return A2($elm$parser$Parser$Advanced$Bad, p, x);
            }
        };
    });
    var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
    var $elm$parser$Parser$Advanced$Done = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$parser$Parser$Advanced$Loop = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$parser$Parser$toAdvancedStep = function(step) {
        if (!step.$) {
            var s = step.a;
            return $elm$parser$Parser$Advanced$Loop(s);
        } else {
            var a = step.a;
            return $elm$parser$Parser$Advanced$Done(a);
        }
    };
    var $elm$parser$Parser$loop = F2(function(state, callback) {
        return A2($elm$parser$Parser$Advanced$loop, state, function(s) {
            return A2($elm$parser$Parser$map, $elm$parser$Parser$toAdvancedStep, callback(s));
        });
    });
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function(quantity) {
        var helper = function(str) {
            if (_Utils_eq($elm$core$String$length(str), quantity)) {
                var _v0 = $elm$core$String$toInt(str);
                if (!_v0.$) {
                    var intVal = _v0.a;
                    return A2($elm$parser$Parser$map, $elm$parser$Parser$Done, $elm$parser$Parser$succeed(intVal));
                } else return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
            } else return A2($elm$parser$Parser$map, function(nextChar) {
                return $elm$parser$Parser$Loop(A2($elm$core$String$append, str, nextChar));
            }, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
        };
        return A2($elm$parser$Parser$loop, '', helper);
    };
    var $elm$parser$Parser$ExpectingSymbol = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $elm$parser$Parser$Advanced$Token = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
    var $elm$parser$Parser$Advanced$token = function(_v0) {
        var str = _v0.a;
        var expecting = _v0.b;
        var progress = !$elm$core$String$isEmpty(str);
        return function(s) {
            var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.f, s.n4, s.Ln, s.s2);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return _Utils_eq(newOffset, -1) ? A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3($elm$parser$Parser$Advanced$Good, progress, 0, {
                Ln: newCol,
                aC: s.aC,
                aeo: s.aeo,
                f: newOffset,
                n4: newRow,
                s2: s.s2
            });
        };
    };
    var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
    var $elm$parser$Parser$symbol = function(str) {
        return $elm$parser$Parser$Advanced$symbol(A2($elm$parser$Parser$Advanced$Token, str, $elm$parser$Parser$ExpectingSymbol(str)));
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function(day) {
        return $elm$parser$Parser$problem('Invalid day: ' + $elm$core$String$fromInt(day));
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function(year) {
        return !A2($elm$core$Basics$modBy, 4, year) && (!!A2($elm$core$Basics$modBy, 100, year) || !A2($elm$core$Basics$modBy, 400, year));
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function(y1) {
        var y = y1 - 1;
        return (y / 4 | 0) - (y / 100 | 0) + (y / 400 | 0);
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function(_v0) {
        var year = _v0.a;
        var month = _v0.b;
        var dayInMonth = _v0.c;
        if (dayInMonth < 0) return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
        else {
            var succeedWith = function(extraMs) {
                var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
                var days = month < 3 || !$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year) ? dayInMonth - 1 : dayInMonth;
                var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
                return $elm$parser$Parser$succeed(extraMs + yearMs + dayMs);
            };
            switch(month){
                case 1:
                    return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
                case 2:
                    return dayInMonth > 29 || dayInMonth === 29 && !$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
                case 3:
                    return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
                case 4:
                    return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
                case 5:
                    return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
                case 6:
                    return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
                case 7:
                    return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
                case 8:
                    return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
                case 9:
                    return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
                case 10:
                    return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
                case 11:
                    return dayInMonth > 30 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
                case 12:
                    return dayInMonth > 31 ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
                default:
                    return $elm$parser$Parser$problem('Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
            }
        }
    };
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2($elm$parser$Parser$andThen, $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(F3(function(year, month, day) {
        return _Utils_Tuple3(year, month, day);
    })), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)), $elm$parser$Parser$oneOf(_List_fromArray([
        A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('-')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
        $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
    ]))), $elm$parser$Parser$oneOf(_List_fromArray([
        A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('-')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
        $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
    ]))));
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function() {
        var utcOffsetMinutesFromParts = F3(function(multiplier, hours, minutes) {
            return multiplier * (hours * 60) + minutes;
        });
        return A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$map, function(_v0) {
                return 0;
            }, $elm$parser$Parser$symbol('Z')),
            A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(utcOffsetMinutesFromParts), $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$map, function(_v1) {
                    return 1;
                }, $elm$parser$Parser$symbol('+')),
                A2($elm$parser$Parser$map, function(_v2) {
                    return -1;
                }, $elm$parser$Parser$symbol('-'))
            ]))), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
                $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
                $elm$parser$Parser$succeed(0)
            ]))),
            A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$end)
        ])));
    }();
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2($elm$parser$Parser$andThen, function(datePart) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)), $elm$parser$Parser$symbol('T')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)), $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
                $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
            ]))), $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol(':')), $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
                $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
                $elm$parser$Parser$succeed(0)
            ]))), $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$symbol('.')), $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
                $elm$parser$Parser$succeed(0)
            ]))), A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
            A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)), $elm$parser$Parser$end)
        ]));
    }, $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
    var $elm$parser$Parser$DeadEnd = F3(function(row, col, problem) {
        return {
            Ln: col,
            nK: problem,
            n4: row
        };
    });
    var $elm$parser$Parser$problemToDeadEnd = function(p) {
        return A3($elm$parser$Parser$DeadEnd, p.n4, p.Ln, p.nK);
    };
    var $elm$parser$Parser$Advanced$bagToList = F2(function(bag, list) {
        bagToList: while(true)switch(bag.$){
            case 0:
                return list;
            case 1:
                var bag1 = bag.a;
                var x = bag.b;
                var $temp$bag = bag1, $temp$list = A2($elm$core$List$cons, x, list);
                bag = $temp$bag;
                list = $temp$list;
                continue bagToList;
            default:
                var bag1 = bag.a;
                var bag2 = bag.b;
                var $temp$bag = bag1, $temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
                bag = $temp$bag;
                list = $temp$list;
                continue bagToList;
        }
    });
    var $elm$parser$Parser$Advanced$run = F2(function(_v0, src) {
        var parse = _v0;
        var _v1 = parse({
            Ln: 1,
            aC: _List_Nil,
            aeo: 1,
            f: 0,
            n4: 1,
            s2: src
        });
        if (!_v1.$) {
            var value = _v1.b;
            return $elm$core$Result$Ok(value);
        } else {
            var bag = _v1.b;
            return $elm$core$Result$Err(A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
        }
    });
    var $elm$parser$Parser$run = F2(function(parser, source) {
        var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
        if (!_v0.$) {
            var a = _v0.a;
            return $elm$core$Result$Ok(a);
        } else {
            var problems = _v0.a;
            return $elm$core$Result$Err(A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
        }
    });
    var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function(str) {
        return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
    };
    var $elm_community$json_extra$Json$Decode$Extra$datetime = A2($elm$json$Json$Decode$andThen, function(dateString) {
        var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateString);
        if (!_v0.$) {
            var v = _v0.a;
            return $elm$json$Json$Decode$succeed(v);
        } else return $elm$json$Json$Decode$fail('Expecting an ISO-8601 formatted date+time string');
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$LocationGroup$Shared$LocationGroup = $elm$core$Basics$identity;
    var $author$project$Api$Common$LocationGroup$Min$LocationGroup = $elm$core$Basics$identity;
    var $author$project$Api$Common$LocationGroup$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Common$LocationGroup$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$LocationGroup$Min$Record)));
    var $author$project$Api$Common$LocationGroup$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$LocationGroup$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$LocationGroup$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$LocationGroup$Min$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$PermissionSet$Shared$PermissionSet = $elm$core$Basics$identity;
    var $author$project$Api$Common$PermissionSet$Shared$Record = F2(function(name, enabled) {
        return {
            OM: enabled,
            zr: name
        };
    });
    var $author$project$Api$Common$PermissionSet$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$PermissionSet$Shared$Record)));
    var $author$project$Api$Common$PermissionSet$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$PermissionSet$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$RequestDetail$Shared$RequestDetail = $elm$core$Basics$identity;
    var $author$project$Api$Common$RequestDetail$Shared$Record = F9(function(ip, clientName, deviceType, osName, state, country, countryCode, deviceBrand, deviceName) {
        return {
            Lj: clientName,
            p0: country,
            Mf: countryCode,
            NW: deviceBrand,
            NX: deviceName,
            NY: deviceType,
            RN: ip,
            VG: osName,
            s4: state
        };
    });
    var $elm$json$Json$Decode$null = _Json_decodeNull;
    var $elm$json$Json$Decode$nullable = function(decoder) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
            A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
        ]));
    };
    var $author$project$Api$Common$RequestDetail$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'device_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'device_brand', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'country_code', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'country', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'state', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'os_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'device_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'client_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ip', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Common$RequestDetail$Shared$Record))))))))));
    var $author$project$Api$Common$RequestDetail$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$RequestDetail$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Organization$Shared$Organization = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$Organization$Min$Organization = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Organization$Min$Record = F3(function(type_, id, name) {
        return {
            aef: id,
            zr: name,
            ah5: type_
        };
    });
    var $author$project$Api$OrganizationType$Company = 1;
    var $author$project$Api$OrganizationType$Partner = 2;
    var $author$project$Api$OrganizationType$Practice = 0;
    var $author$project$Api$OrganizationType$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'company':
                return $elm$json$Json$Decode$succeed(1);
            case 'practice':
                return $elm$json$Json$Decode$succeed(0);
            case 'partner':
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail('Unsupported organization type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Platform$Organization$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$OrganizationType$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Min$Record))));
    var $author$project$Api$Platform$Organization$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Organization$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Organization$Shared$Record = F7(function(accountType, isNetwork, requiresMfa, onboarded, practiceIsOnboarding, onboardingClinical, sandboxOf) {
        return {
            In: accountType,
            Sd: isNetwork,
            Vs: onboarded,
            Vt: onboardingClinical,
            W4: practiceIsOnboarding,
            YL: requiresMfa,
            Zp: sandboxOf
        };
    });
    var $elm$json$Json$Decode$decodeValue = _Json_run;
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(function(pathDecoder, valDecoder, fallback) {
        var nullOr = function(decoder) {
            return $elm$json$Json$Decode$oneOf(_List_fromArray([
                decoder,
                $elm$json$Json$Decode$null(fallback)
            ]));
        };
        var handleResult = function(input) {
            var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
            if (!_v0.$) {
                var rawValue = _v0.a;
                var _v1 = A2($elm$json$Json$Decode$decodeValue, nullOr(valDecoder), rawValue);
                if (!_v1.$) {
                    var finalResult = _v1.a;
                    return $elm$json$Json$Decode$succeed(finalResult);
                } else {
                    var finalErr = _v1.a;
                    return $elm$json$Json$Decode$fail($elm$json$Json$Decode$errorToString(finalErr));
                }
            } else return $elm$json$Json$Decode$succeed(fallback);
        };
        return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
    });
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(function(key, valDecoder, fallback, decoder) {
        return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value), valDecoder, fallback), decoder);
    });
    var $author$project$Api$Platform$Organization$Shared$SandboxOfPartner = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Platform$Organization$Shared$SandboxOfPractice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Platform$Organization$SandboxOf$Organization = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Organization$SandboxOf$decoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Organization$Shared$sandboxOfDecoder = A2($elm$json$Json$Decode$andThen, function(sandboxOfType) {
        if (sandboxOfType.$ === 1) return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
        else switch(sandboxOfType.a){
            case 'Practice':
                return A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sandbox_of', $author$project$Api$Platform$Organization$SandboxOf$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$SandboxOfPractice)));
            case 'Partner':
                return A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sandbox_of', $author$project$Api$Platform$Organization$SandboxOf$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$SandboxOfPartner)));
            default:
                var somethingElse = sandboxOfType.a;
                return $elm$json$Json$Decode$fail('Unsupported sandbox of type ' + somethingElse);
        }
    }, A2($elm$json$Json$Decode$at, _List_fromArray([
        'sandbox_of_type'
    ]), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
    var $author$project$Api$Platform$Organization$Shared$recordDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Organization$Shared$sandboxOfDecoder, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'onboarding_clinical', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'practice_is_onboarding', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'onboarded', $elm$json$Json$Decode$bool, true, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_mfa', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'is_network', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'account_type', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$Record))))))));
    var $author$project$Api$Platform$Organization$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Organization$Shared$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Organization$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Organization$Shared$Organization)));
    var $author$project$Api$Platform$User$Shared$User = $elm$core$Basics$identity;
    var $author$project$Api$Platform$User$Shared$Record = function(id) {
        return function(name) {
            return function(firstName) {
                return function(lastName) {
                    return function(email) {
                        return function(canSwitchOrganizations) {
                            return function(isAdmin) {
                                return function(termsAccepted) {
                                    return function(mfaStatus) {
                                        return function(requiresMfa) {
                                            return function(isMfaActive) {
                                                return function(phones) {
                                                    return function(identityProviderId) {
                                                        return function(intercomUserHash) {
                                                            return {
                                                                KV: canSwitchOrganizations,
                                                                OH: email,
                                                                PN: firstName,
                                                                aef: id,
                                                                Q1: identityProviderId,
                                                                Rx: intercomUserHash,
                                                                RO: isAdmin,
                                                                Sb: isMfaActive,
                                                                SU: lastName,
                                                                Ug: mfaStatus,
                                                                zr: name,
                                                                WG: phones,
                                                                YL: requiresMfa,
                                                                HM: termsAccepted
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Platform$Mfa$Status$Active = 0;
    var $author$project$Api$Platform$Mfa$Status$Inactive = 1;
    var $author$project$Api$Platform$Mfa$Status$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'active':
                return $elm$json$Json$Decode$succeed(0);
            case 'inactive':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unsupported mfa status: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Phone$Shared$Phone = $elm$core$Basics$identity;
    var $author$project$Api$Common$Phone$Shared$Record = F3(function(number, type_, usFormattable) {
        return {
            Gx: number,
            ah5: type_,
            H0: usFormattable
        };
    });
    var $author$project$Api$Common$Phone$Shared$Home = {
        $: 1
    };
    var $author$project$Api$Common$Phone$Shared$Mobile = {
        $: 0
    };
    var $author$project$Api$Common$Phone$Shared$Office = {
        $: 2
    };
    var $author$project$Api$Common$Phone$Shared$Other = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Common$Phone$Shared$typeDecoder = A2($elm$json$Json$Decode$map, function(str) {
        switch(str){
            case 'mobile':
                return $author$project$Api$Common$Phone$Shared$Mobile;
            case 'home':
                return $author$project$Api$Common$Phone$Shared$Home;
            case 'office':
                return $author$project$Api$Common$Phone$Shared$Office;
            default:
                var somethingElse = str;
                return $author$project$Api$Common$Phone$Shared$Other(somethingElse);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Phone$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'us_formattable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Common$Phone$Shared$typeDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Common$Phone$Shared$Record))));
    var $author$project$Api$Common$Phone$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Phone$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$User$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'intercom_user_hash', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'identity_provider_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phones', $elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_mfa_active', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_mfa', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mfa_status', $author$project$Api$Platform$Mfa$Status$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'terms_accepted', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_admin', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_switch_organizations', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$User$Shared$Record)))))))))))))));
    var $author$project$Api$Platform$User$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$User$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Session$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sandbox', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location_groups', $elm$json$Json$Decode$list($author$project$Api$Common$LocationGroup$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'permission_sets', $elm$json$Json$Decode$list($author$project$Api$Common$PermissionSet$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization', $elm$json$Json$Decode$nullable($author$project$Api$Platform$Organization$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_detail', $elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'show_collection_warning', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'user', $author$project$Api$Platform$User$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'restricted_by_groups', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'role', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Session$One$Record))))))))))));
    var $author$project$Api$Platform$Session$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Session$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Session$sessionPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'session'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$Session$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Platform$Session$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$Session$sessionPath));
    });
    var $author$project$Api$Platform$User$One$User = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$User$One$Record = F4(function(practicesCount, companiesCount, partnersCount, defaultOrganization) {
        return {
            LH: companiesCount,
            Nv: defaultOrganization,
            V2: partnersCount,
            W8: practicesCount
        };
    });
    var $author$project$Api$Platform$User$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'default_organization', $elm$json$Json$Decode$nullable($author$project$Api$Platform$Organization$Shared$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partners_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'companies_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practices_count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Platform$User$One$Record)))));
    var $author$project$Api$Platform$User$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$User$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$User$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$User$One$User)));
    var $author$project$Api$Platform$User$userPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'user'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$User$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Platform$User$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath));
    });
    var $author$project$Api$AuthToken$jwtIssuer = function(authToken) {
        return A2($elm$core$Maybe$andThen, $elm$core$Result$toMaybe, A2($elm$core$Maybe$map, function(token) {
            return A2($simonh1000$elm_jwt$Jwt$decodeToken, A2($elm$json$Json$Decode$field, 'iss', $elm$json$Json$Decode$string), token);
        }, A2($elm$core$Maybe$andThen, $author$project$Api$AuthToken$toString, authToken)));
    };
    var $author$project$Api$AuthToken$isDefaultAuthJwt = F2(function(authToken, providerAuthUrl) {
        return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(issuer) {
            return _Utils_eq(issuer, providerAuthUrl);
        }, $author$project$Api$AuthToken$jwtIssuer(authToken)));
    });
    var $author$project$Api$Data$usingDefaultAuth = F2(function(_v0, backupAuthEnabled) {
        var client = _v0;
        var isDefaultAuthJwt = A2($author$project$Api$AuthToken$isDefaultAuthJwt, client.e7, client.G8);
        return !backupAuthEnabled && isDefaultAuthJwt;
    });
    var $author$project$Shared$initSession = F3(function(apiClient, currentTime, backupAuthEnabled) {
        var refreshTimeoutCmd = !A2($author$project$Api$Data$usingDefaultAuth, apiClient, backupAuthEnabled) ? $author$project$Shared$backupJwtRefreshTimeout(apiClient) : $elm$core$Platform$Cmd$none;
        var notExpired = !A2($author$project$Api$Data$clientHasTokenExpired, apiClient, currentTime);
        var canRetrieveSession = $author$project$Api$Data$clientHasAuthToken(apiClient) && notExpired;
        var retrieveApiSession = canRetrieveSession ? $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Platform$Session$retrieve, apiClient, $author$project$Shared$GotSession),
            A2($author$project$Api$Platform$User$retrieve, apiClient, $author$project$Shared$GotUser)
        ])) : $elm$core$Platform$Cmd$none;
        var session = canRetrieveSession ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked;
        var authenticate = function() {
            var _v0 = _Utils_Tuple2($author$project$Api$Data$clientHasAuthToken(apiClient), backupAuthEnabled);
            if (_v0.a) return $author$project$Ports$Session$authorize({
                agy: true
            });
            else {
                if (_v0.b) return A2($author$project$Ports$Navigation$pushRoute, _List_Nil, $author$project$Spa$Generated$Route$Login);
                else return $elm$core$Platform$Cmd$none;
            }
        }();
        return _Utils_Tuple2(session, _List_fromArray([
            authenticate,
            retrieveApiSession,
            refreshTimeoutCmd
        ]));
    });
    var $author$project$Ui$Image$Store = $elm$core$Basics$identity;
    var $author$project$Ui$Image$initStore = $elm$core$Basics$identity;
    var $elm$core$Platform$Cmd$map = _Platform_map;
    var $author$project$Shared$init = F2(function(flags, url) {
        var providerAuthUrl = flags.G8;
        var defaultTheme = 'v2';
        var currentTime = $elm$time$Time$millisToPosix(flags.acJ);
        var maybeAuthToken = A2($elm$core$Maybe$andThen, function(token) {
            return A2($author$project$Api$AuthToken$isExpired, $elm$core$Maybe$Just(token), currentTime) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(token);
        }, A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, flags.ahk));
        var backupAuthEnabled = flags.abT;
        var apiClient = A4($author$project$Api$Data$clientInit, flags.abM, providerAuthUrl, flags.Ek, maybeAuthToken);
        var _v0 = A3($author$project$Shared$initSession, apiClient, currentTime, backupAuthEnabled);
        var session = _v0.a;
        var sessionCmds = _v0.b;
        var _v1 = $author$project$Utils$Release$init(flags.agH);
        var release = _v1.a;
        var releaseCmd = _v1.b;
        var _v2 = A2($author$project$Components$GlobalSearch$init, apiClient, url);
        var globalSearch = _v2.a;
        var globalSearchCmd = _v2.b;
        var cmds = _Utils_ap(sessionCmds, _List_fromArray([
            A2($elm$core$Task$attempt, $author$project$Shared$GotTimeZone, $justinmimbs$timezone_data$TimeZone$getZone),
            A2($elm$core$Platform$Cmd$map, $author$project$Shared$GlobalSearchMsg, globalSearchCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Shared$ReleaseMsg, releaseCmd)
        ]));
        return _Utils_Tuple2({
            pl: maybeAuthToken,
            Ej: apiClient,
            acy: $author$project$Api$Data$NotAsked,
            LV: '',
            cP: $justinmimbs$date$Date$fromRataDie(flags.acI),
            MO: $author$project$Api$Data$NotAsked,
            lL: $elm$core$Maybe$Nothing,
            acJ: currentTime,
            adU: flags,
            fP: globalSearch,
            mu: false,
            aea: $author$project$Utils$Environment$decode(flags.aea),
            aeb: flags.aeb,
            qW: $author$project$Ui$Image$initStore(flags.Q5),
            qY: $elm$core$Maybe$Nothing,
            ae: $elm$core$Maybe$Nothing,
            aff: $author$project$Utils$Environment$decode(flags.aff),
            afW: false,
            gg: $elm$core$Maybe$Nothing,
            VW: $author$project$Api$Data$NotAsked,
            af4: $elm$core$Maybe$Nothing,
            af8: $elm$core$Maybe$Nothing,
            Wx: $elm$core$Maybe$Nothing,
            db: $elm$core$Maybe$Nothing,
            Wy: false,
            W1: $author$project$Api$Data$Loading,
            sp: $elm$core$Maybe$Nothing,
            agH: release,
            n1: $elm$core$Maybe$Nothing,
            Z$: session,
            sQ: false,
            sV: false,
            $Z: defaultTheme,
            HO: A2($author$project$Formatters$Time$init, $author$project$Shared$defaultTimeZone, currentTime),
            HP: $author$project$Shared$defaultTimeZone,
            ky: $author$project$Ui$Toast$init,
            aaT: url,
            aaX: $author$project$Api$Data$Loading,
            abq: $author$project$Api$Data$Loading
        }, $elm$core$Platform$Cmd$batch(cmds));
    });
    var $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Model = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Msg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Model = function(a) {
        return {
            $: 198,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Msg = function(a) {
        return {
            $: 198,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Model = function(a) {
        return {
            $: 199,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Msg = function(a) {
        return {
            $: 199,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Model = function(a) {
        return {
            $: 200,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Msg = function(a) {
        return {
            $: 200,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Model = function(a) {
        return {
            $: 201,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Msg = function(a) {
        return {
            $: 201,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Model = function(a) {
        return {
            $: 202,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Msg = function(a) {
        return {
            $: 202,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Model = function(a) {
        return {
            $: 167,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Msg = function(a) {
        return {
            $: 167,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Billing__Model = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Billing__Msg = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Model = function(a) {
        return {
            $: 316,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Msg = function(a) {
        return {
            $: 316,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Model = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Msg = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CardReaders__Model = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CardReaders__Msg = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Categories__Model = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Categories__Msg = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Model = function(a) {
        return {
            $: 274,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Msg = function(a) {
        return {
            $: 274,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Model = function(a) {
        return {
            $: 203,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Msg = function(a) {
        return {
            $: 203,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Model = function(a) {
        return {
            $: 168,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Msg = function(a) {
        return {
            $: 168,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Model = function(a) {
        return {
            $: 204,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Msg = function(a) {
        return {
            $: 204,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Commissions__Model = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Commissions__Msg = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Model = function(a) {
        return {
            $: 275,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Msg = function(a) {
        return {
            $: 275,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Model = function(a) {
        return {
            $: 205,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Msg = function(a) {
        return {
            $: 205,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Model = function(a) {
        return {
            $: 169,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Msg = function(a) {
        return {
            $: 169,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Coupons__Model = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Coupons__Msg = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Model = function(a) {
        return {
            $: 276,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Msg = function(a) {
        return {
            $: 276,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Model = function(a) {
        return {
            $: 206,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Msg = function(a) {
        return {
            $: 206,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Model = function(a) {
        return {
            $: 170,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Msg = function(a) {
        return {
            $: 170,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CreditCategories__Model = function(a) {
        return {
            $: 27,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__CreditCategories__Msg = function(a) {
        return {
            $: 27,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Model = function(a) {
        return {
            $: 207,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Msg = function(a) {
        return {
            $: 207,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Model = function(a) {
        return {
            $: 278,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Msg = function(a) {
        return {
            $: 278,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Model = function(a) {
        return {
            $: 208,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Msg = function(a) {
        return {
            $: 208,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Model = function(a) {
        return {
            $: 172,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Msg = function(a) {
        return {
            $: 172,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Model = function(a) {
        return {
            $: 277,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Msg = function(a) {
        return {
            $: 277,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Model = function(a) {
        return {
            $: 171,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Msg = function(a) {
        return {
            $: 171,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Model = function(a) {
        return {
            $: 209,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Msg = function(a) {
        return {
            $: 209,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Model = function(a) {
        return {
            $: 210,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Msg = function(a) {
        return {
            $: 210,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Model = function(a) {
        return {
            $: 211,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Msg = function(a) {
        return {
            $: 211,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Model = function(a) {
        return {
            $: 212,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Msg = function(a) {
        return {
            $: 212,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Model = function(a) {
        return {
            $: 279,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Msg = function(a) {
        return {
            $: 279,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Documents__New__Model = function(a) {
        return {
            $: 213,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Documents__New__Msg = function(a) {
        return {
            $: 213,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Documents__Top__Model = function(a) {
        return {
            $: 173,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Documents__Top__Msg = function(a) {
        return {
            $: 173,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Model = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Msg = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Elation__Link__Model = function(a) {
        return {
            $: 214,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Elation__Link__Msg = function(a) {
        return {
            $: 214,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Model = function(a) {
        return {
            $: 215,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Msg = function(a) {
        return {
            $: 215,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Model = function(a) {
        return {
            $: 216,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Msg = function(a) {
        return {
            $: 216,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Elation__Top__Model = function(a) {
        return {
            $: 174,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Elation__Top__Msg = function(a) {
        return {
            $: 174,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Features__Model = function(a) {
        return {
            $: 29,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Features__Msg = function(a) {
        return {
            $: 29,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Model = function(a) {
        return {
            $: 30,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Msg = function(a) {
        return {
            $: 30,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Model = function(a) {
        return {
            $: 280,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Msg = function(a) {
        return {
            $: 280,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__InternalSettings__Model = function(a) {
        return {
            $: 31,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__InternalSettings__Msg = function(a) {
        return {
            $: 31,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Model = function(a) {
        return {
            $: 32,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Msg = function(a) {
        return {
            $: 32,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__LeadSources__Model = function(a) {
        return {
            $: 33,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__LeadSources__Msg = function(a) {
        return {
            $: 33,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Locations__Model = function(a) {
        return {
            $: 34,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Locations__Msg = function(a) {
        return {
            $: 34,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Mailgun__Model = function(a) {
        return {
            $: 35,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Mailgun__Msg = function(a) {
        return {
            $: 35,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notes__Model = function(a) {
        return {
            $: 36,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notes__Msg = function(a) {
        return {
            $: 36,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Model = function(a) {
        return {
            $: 217,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Msg = function(a) {
        return {
            $: 217,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Model = function(a) {
        return {
            $: 218,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Msg = function(a) {
        return {
            $: 218,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Model = function(a) {
        return {
            $: 219,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Msg = function(a) {
        return {
            $: 219,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Model = function(a) {
        return {
            $: 302,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Msg = function(a) {
        return {
            $: 302,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Model = function(a) {
        return {
            $: 220,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Msg = function(a) {
        return {
            $: 220,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Model = function(a) {
        return {
            $: 221,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Msg = function(a) {
        return {
            $: 221,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Model = function(a) {
        return {
            $: 222,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Msg = function(a) {
        return {
            $: 222,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Patients__Model = function(a) {
        return {
            $: 37,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Patients__Msg = function(a) {
        return {
            $: 37,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Model = function(a) {
        return {
            $: 38,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Msg = function(a) {
        return {
            $: 38,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Model = function(a) {
        return {
            $: 223,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Msg = function(a) {
        return {
            $: 223,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Model = function(a) {
        return {
            $: 39,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Msg = function(a) {
        return {
            $: 39,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__PaymentSources__Model = function(a) {
        return {
            $: 40,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__PaymentSources__Msg = function(a) {
        return {
            $: 40,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Model = function(a) {
        return {
            $: 281,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Msg = function(a) {
        return {
            $: 281,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Model = function(a) {
        return {
            $: 328,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Msg = function(a) {
        return {
            $: 328,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Model = function(a) {
        return {
            $: 332,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Msg = function(a) {
        return {
            $: 332,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__New__Model = function(a) {
        return {
            $: 224,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__New__Msg = function(a) {
        return {
            $: 224,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__Top__Model = function(a) {
        return {
            $: 175,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Plans__Top__Msg = function(a) {
        return {
            $: 175,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Practice__Model = function(a) {
        return {
            $: 41,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Practice__Msg = function(a) {
        return {
            $: 41,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Model = function(a) {
        return {
            $: 42,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Msg = function(a) {
        return {
            $: 42,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Providers__Top__Model = function(a) {
        return {
            $: 176,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Providers__Top__Msg = function(a) {
        return {
            $: 176,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Model = function(a) {
        return {
            $: 225,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Msg = function(a) {
        return {
            $: 225,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Model = function(a) {
        return {
            $: 177,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Msg = function(a) {
        return {
            $: 177,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Model = function(a) {
        return {
            $: 43,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Msg = function(a) {
        return {
            $: 43,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__SelfService__Model = function(a) {
        return {
            $: 44,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__SelfService__Msg = function(a) {
        return {
            $: 44,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Model = function(a) {
        return {
            $: 282,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Msg = function(a) {
        return {
            $: 282,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Model = function(a) {
        return {
            $: 226,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Msg = function(a) {
        return {
            $: 226,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Model = function(a) {
        return {
            $: 178,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Msg = function(a) {
        return {
            $: 178,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Signup__Model = function(a) {
        return {
            $: 45,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Signup__Msg = function(a) {
        return {
            $: 45,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Stripe__Model = function(a) {
        return {
            $: 46,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Stripe__Msg = function(a) {
        return {
            $: 46,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Taxes__Model = function(a) {
        return {
            $: 47,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Taxes__Msg = function(a) {
        return {
            $: 47,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Team__Model = function(a) {
        return {
            $: 48,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Team__Msg = function(a) {
        return {
            $: 48,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Team__New__Model = function(a) {
        return {
            $: 227,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Admin__Team__New__Msg = function(a) {
        return {
            $: 227,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$AffiliateBills__Top__Model = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$AffiliateBills__Top__Msg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Model = function(a) {
        return {
            $: 228,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Msg = function(a) {
        return {
            $: 228,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Model = function(a) {
        return {
            $: 317,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Msg = function(a) {
        return {
            $: 317,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Model = function(a) {
        return {
            $: 290,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Msg = function(a) {
        return {
            $: 290,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Model = function(a) {
        return {
            $: 229,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Msg = function(a) {
        return {
            $: 229,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Model = function(a) {
        return {
            $: 230,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Msg = function(a) {
        return {
            $: 230,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Model = function(a) {
        return {
            $: 231,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Msg = function(a) {
        return {
            $: 231,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Model = function(a) {
        return {
            $: 232,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Msg = function(a) {
        return {
            $: 232,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Model = function(a) {
        return {
            $: 233,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Msg = function(a) {
        return {
            $: 233,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__Create__Model = function(a) {
        return {
            $: 49,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__Create__Msg = function(a) {
        return {
            $: 49,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__New__Model = function(a) {
        return {
            $: 50,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__New__Msg = function(a) {
        return {
            $: 50,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__Top__Model = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Affiliates__Top__Msg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Apps__Slug_String__Model = function(a) {
        return {
            $: 163,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Apps__Slug_String__Msg = function(a) {
        return {
            $: 163,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Blank__Model = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Blank__Msg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Bookkeeping__Model = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Bookkeeping__Msg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Calendar__Model = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Calendar__Msg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Charges__New__Model = function(a) {
        return {
            $: 51,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Charges__New__Msg = function(a) {
        return {
            $: 51,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Model = function(a) {
        return {
            $: 334,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Msg = function(a) {
        return {
            $: 334,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Model = function(a) {
        return {
            $: 329,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Msg = function(a) {
        return {
            $: 329,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Model = function(a) {
        return {
            $: 330,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Msg = function(a) {
        return {
            $: 330,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Model = function(a) {
        return {
            $: 322,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Msg = function(a) {
        return {
            $: 322,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Model = function(a) {
        return {
            $: 303,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Msg = function(a) {
        return {
            $: 303,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Model = function(a) {
        return {
            $: 304,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Msg = function(a) {
        return {
            $: 304,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Model = function(a) {
        return {
            $: 333,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Msg = function(a) {
        return {
            $: 333,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Model = function(a) {
        return {
            $: 323,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Msg = function(a) {
        return {
            $: 323,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Model = function(a) {
        return {
            $: 291,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Msg = function(a) {
        return {
            $: 291,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Model = function(a) {
        return {
            $: 234,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Msg = function(a) {
        return {
            $: 234,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Model = function(a) {
        return {
            $: 179,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Msg = function(a) {
        return {
            $: 179,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Model = function(a) {
        return {
            $: 235,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Msg = function(a) {
        return {
            $: 235,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Model = function(a) {
        return {
            $: 180,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Msg = function(a) {
        return {
            $: 180,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__Statements__Model = function(a) {
        return {
            $: 52,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Commissions__Statements__Msg = function(a) {
        return {
            $: 52,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Model = function(a) {
        return {
            $: 236,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Msg = function(a) {
        return {
            $: 236,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Model = function(a) {
        return {
            $: 237,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Msg = function(a) {
        return {
            $: 237,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Model = function(a) {
        return {
            $: 305,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Msg = function(a) {
        return {
            $: 305,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Model = function(a) {
        return {
            $: 335,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Msg = function(a) {
        return {
            $: 335,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Model = function(a) {
        return {
            $: 292,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Msg = function(a) {
        return {
            $: 292,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Model = function(a) {
        return {
            $: 238,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Msg = function(a) {
        return {
            $: 238,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Model = function(a) {
        return {
            $: 239,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Msg = function(a) {
        return {
            $: 239,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Model = function(a) {
        return {
            $: 318,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Msg = function(a) {
        return {
            $: 318,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Model = function(a) {
        return {
            $: 293,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Msg = function(a) {
        return {
            $: 293,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Model = function(a) {
        return {
            $: 240,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Msg = function(a) {
        return {
            $: 240,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Model = function(a) {
        return {
            $: 241,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Msg = function(a) {
        return {
            $: 241,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Model = function(a) {
        return {
            $: 242,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Msg = function(a) {
        return {
            $: 242,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Model = function(a) {
        return {
            $: 319,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Msg = function(a) {
        return {
            $: 319,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Model = function(a) {
        return {
            $: 306,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Msg = function(a) {
        return {
            $: 306,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Model = function(a) {
        return {
            $: 243,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Msg = function(a) {
        return {
            $: 243,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Model = function(a) {
        return {
            $: 181,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Msg = function(a) {
        return {
            $: 181,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Model = function(a) {
        return {
            $: 294,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Msg = function(a) {
        return {
            $: 294,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Model = function(a) {
        return {
            $: 324,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Msg = function(a) {
        return {
            $: 324,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Model = function(a) {
        return {
            $: 331,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Msg = function(a) {
        return {
            $: 331,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__New__Model = function(a) {
        return {
            $: 53,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__New__Msg = function(a) {
        return {
            $: 53,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__Top__Model = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Companies__Top__Msg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Model = function(a) {
        return {
            $: 182,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Msg = function(a) {
        return {
            $: 182,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Contacts__List__Model = function(a) {
        return {
            $: 54,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Contacts__List__Msg = function(a) {
        return {
            $: 54,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Contacts__New__Model = function(a) {
        return {
            $: 55,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Contacts__New__Msg = function(a) {
        return {
            $: 55,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Error__Status_String__Model = function(a) {
        return {
            $: 164,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Error__Status_String__Msg = function(a) {
        return {
            $: 164,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Files__Public__Model = function(a) {
        return {
            $: 56,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Files__Public__Msg = function(a) {
        return {
            $: 56,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Files__Top__Model = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Files__Top__Msg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Forms__Model = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Forms__Msg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$GoogleCallback__Model = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$GoogleCallback__Msg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Model = function(a) {
        return {
            $: 283,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Msg = function(a) {
        return {
            $: 283,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Model = function(a) {
        return {
            $: 183,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Msg = function(a) {
        return {
            $: 183,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Model = function(a) {
        return {
            $: 57,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Msg = function(a) {
        return {
            $: 57,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__Disputes__Model = function(a) {
        return {
            $: 58,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__Disputes__Msg = function(a) {
        return {
            $: 58,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Model = function(a) {
        return {
            $: 59,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Msg = function(a) {
        return {
            $: 59,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__NewGroup__Model = function(a) {
        return {
            $: 60,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__NewGroup__Msg = function(a) {
        return {
            $: 60,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__NewPartner__Model = function(a) {
        return {
            $: 61,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__NewPartner__Msg = function(a) {
        return {
            $: 61,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__NewPractice__Model = function(a) {
        return {
            $: 62,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Hinter__NewPractice__Msg = function(a) {
        return {
            $: 62,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Home__Model = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Home__Msg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Model = function(a) {
        return {
            $: 184,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Msg = function(a) {
        return {
            $: 184,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Inventory__List__Model = function(a) {
        return {
            $: 63,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Inventory__List__Msg = function(a) {
        return {
            $: 63,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Inventory__New__Model = function(a) {
        return {
            $: 64,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Inventory__New__Msg = function(a) {
        return {
            $: 64,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Inventory__Settings__Model = function(a) {
        return {
            $: 65,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Inventory__Settings__Msg = function(a) {
        return {
            $: 65,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Join__Token_String__Model = function(a) {
        return {
            $: 165,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Join__Token_String__Msg = function(a) {
        return {
            $: 165,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Login__Model = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Login__Msg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Logout__Model = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Logout__Msg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Bookkeeping__Manage__Settings__Model = function(a) {
        return {
            $: 307,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Bookkeeping__Manage__Settings__Msg = function(a) {
        return {
            $: 307,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Elation__Manage__Settings__Model = function(a) {
        return {
            $: 308,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Elation__Manage__Settings__Msg = function(a) {
        return {
            $: 308,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Manage__Model = function(a) {
        return {
            $: 66,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Manage__Msg = function(a) {
        return {
            $: 66,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Quickbooks__Manage__Settings__Model = function(a) {
        return {
            $: 309,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Quickbooks__Manage__Settings__Msg = function(a) {
        return {
            $: 309,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Model = function(a) {
        return {
            $: 310,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Msg = function(a) {
        return {
            $: 310,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Model = function(a) {
        return {
            $: 311,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Msg = function(a) {
        return {
            $: 311,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Model = function(a) {
        return {
            $: 312,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Msg = function(a) {
        return {
            $: 312,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Model = function(a) {
        return {
            $: 166,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Msg = function(a) {
        return {
            $: 166,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Top__Model = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Marketplace__Top__Msg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Calls__Model = function(a) {
        return {
            $: 67,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Calls__Msg = function(a) {
        return {
            $: 67,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Chat__Model = function(a) {
        return {
            $: 68,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Chat__Msg = function(a) {
        return {
            $: 68,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Drafts__Model = function(a) {
        return {
            $: 69,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Drafts__Msg = function(a) {
        return {
            $: 69,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Faxes__New__Model = function(a) {
        return {
            $: 244,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Faxes__New__Msg = function(a) {
        return {
            $: 244,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Model = function(a) {
        return {
            $: 185,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Msg = function(a) {
        return {
            $: 185,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Forms__Model = function(a) {
        return {
            $: 70,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Forms__Msg = function(a) {
        return {
            $: 70,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Labs__Model = function(a) {
        return {
            $: 71,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Labs__Msg = function(a) {
        return {
            $: 71,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Model = function(a) {
        return {
            $: 245,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Msg = function(a) {
        return {
            $: 245,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Model = function(a) {
        return {
            $: 295,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Msg = function(a) {
        return {
            $: 295,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Model = function(a) {
        return {
            $: 186,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Msg = function(a) {
        return {
            $: 186,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Sms__Model = function(a) {
        return {
            $: 72,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Messages__Sms__Msg = function(a) {
        return {
            $: 72,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Model = function(a) {
        return {
            $: 284,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Msg = function(a) {
        return {
            $: 284,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Model = function(a) {
        return {
            $: 246,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Msg = function(a) {
        return {
            $: 246,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Model = function(a) {
        return {
            $: 187,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Msg = function(a) {
        return {
            $: 187,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__BlockedPhoneNumbers__Model = function(a) {
        return {
            $: 73,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__BlockedPhoneNumbers__Msg = function(a) {
        return {
            $: 73,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__BookingOverview__Model = function(a) {
        return {
            $: 74,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__BookingOverview__Msg = function(a) {
        return {
            $: 74,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Erx__Model = function(a) {
        return {
            $: 75,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Erx__Msg = function(a) {
        return {
            $: 75,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Export__Model = function(a) {
        return {
            $: 76,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Export__Msg = function(a) {
        return {
            $: 76,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Model = function(a) {
        return {
            $: 77,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Msg = function(a) {
        return {
            $: 77,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Model = function(a) {
        return {
            $: 285,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Msg = function(a) {
        return {
            $: 285,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Locations__New__LocationId_String__Model = function(a) {
        return {
            $: 320,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Locations__New__LocationId_String__Msg = function(a) {
        return {
            $: 320,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Model = function(a) {
        return {
            $: 188,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Msg = function(a) {
        return {
            $: 188,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Model = function(a) {
        return {
            $: 78,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Msg = function(a) {
        return {
            $: 78,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Team__Model = function(a) {
        return {
            $: 79,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Team__Msg = function(a) {
        return {
            $: 79,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Model = function(a) {
        return {
            $: 313,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Msg = function(a) {
        return {
            $: 313,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Model = function(a) {
        return {
            $: 286,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Msg = function(a) {
        return {
            $: 286,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Model = function(a) {
        return {
            $: 247,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Msg = function(a) {
        return {
            $: 247,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Model = function(a) {
        return {
            $: 287,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Msg = function(a) {
        return {
            $: 287,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Model = function(a) {
        return {
            $: 189,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Msg = function(a) {
        return {
            $: 189,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NotFound__Model = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$NotFound__Msg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Oauth__Callback__Model = function(a) {
        return {
            $: 80,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Oauth__Callback__Msg = function(a) {
        return {
            $: 80,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Model = function(a) {
        return {
            $: 190,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Msg = function(a) {
        return {
            $: 190,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Model = function(a) {
        return {
            $: 248,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Msg = function(a) {
        return {
            $: 248,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Model = function(a) {
        return {
            $: 249,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Msg = function(a) {
        return {
            $: 249,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Model = function(a) {
        return {
            $: 250,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Msg = function(a) {
        return {
            $: 250,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Model = function(a) {
        return {
            $: 251,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Msg = function(a) {
        return {
            $: 251,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboarding__Model = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Onboarding__Msg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__ApiKeys__Model = function(a) {
        return {
            $: 81,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__ApiKeys__Msg = function(a) {
        return {
            $: 81,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Model = function(a) {
        return {
            $: 252,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Msg = function(a) {
        return {
            $: 252,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Billing__Model = function(a) {
        return {
            $: 82,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Billing__Msg = function(a) {
        return {
            $: 82,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Model = function(a) {
        return {
            $: 191,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Msg = function(a) {
        return {
            $: 191,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Engagements__Model = function(a) {
        return {
            $: 83,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Engagements__Msg = function(a) {
        return {
            $: 83,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Hinter__Model = function(a) {
        return {
            $: 84,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Hinter__Msg = function(a) {
        return {
            $: 84,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Practices__Top__Model = function(a) {
        return {
            $: 192,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Practices__Top__Msg = function(a) {
        return {
            $: 192,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__ActivationSettings__Model = function(a) {
        return {
            $: 253,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__ActivationSettings__Msg = function(a) {
        return {
            $: 253,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__AppSettings__Model = function(a) {
        return {
            $: 254,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__AppSettings__Msg = function(a) {
        return {
            $: 254,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__Hinter__Model = function(a) {
        return {
            $: 255,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__Hinter__Msg = function(a) {
        return {
            $: 255,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__Model = function(a) {
        return {
            $: 85,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__Msg = function(a) {
        return {
            $: 85,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__New__Model = function(a) {
        return {
            $: 256,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Product__New__Msg = function(a) {
        return {
            $: 256,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Model = function(a) {
        return {
            $: 193,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Msg = function(a) {
        return {
            $: 193,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Team__Model = function(a) {
        return {
            $: 86,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Team__Msg = function(a) {
        return {
            $: 86,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Webhooks__Requests__Model = function(a) {
        return {
            $: 257,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Webhooks__Requests__Msg = function(a) {
        return {
            $: 257,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Webhooks__Settings__Model = function(a) {
        return {
            $: 258,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Partner__Webhooks__Settings__Msg = function(a) {
        return {
            $: 258,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__Create__Model = function(a) {
        return {
            $: 87,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__Create__Msg = function(a) {
        return {
            $: 87,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Model = function(a) {
        return {
            $: 296,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Msg = function(a) {
        return {
            $: 296,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Model = function(a) {
        return {
            $: 297,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Msg = function(a) {
        return {
            $: 297,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Model = function(a) {
        return {
            $: 325,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Msg = function(a) {
        return {
            $: 325,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Model = function(a) {
        return {
            $: 326,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Msg = function(a) {
        return {
            $: 326,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Model = function(a) {
        return {
            $: 298,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Msg = function(a) {
        return {
            $: 298,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Model = function(a) {
        return {
            $: 259,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Msg = function(a) {
        return {
            $: 259,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Model = function(a) {
        return {
            $: 260,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Msg = function(a) {
        return {
            $: 260,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__GrowthChart__Model = function(a) {
        return {
            $: 261,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__GrowthChart__Msg = function(a) {
        return {
            $: 261,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__LabTrends__Model = function(a) {
        return {
            $: 262,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__LabTrends__Msg = function(a) {
        return {
            $: 262,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Model = function(a) {
        return {
            $: 263,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Msg = function(a) {
        return {
            $: 263,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Model = function(a) {
        return {
            $: 327,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Msg = function(a) {
        return {
            $: 327,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Model = function(a) {
        return {
            $: 314,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Msg = function(a) {
        return {
            $: 314,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Model = function(a) {
        return {
            $: 299,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Msg = function(a) {
        return {
            $: 299,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Model = function(a) {
        return {
            $: 264,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Msg = function(a) {
        return {
            $: 264,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__NoteId_String__Model = function(a) {
        return {
            $: 321,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__NoteId_String__Msg = function(a) {
        return {
            $: 321,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Model = function(a) {
        return {
            $: 300,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Msg = function(a) {
        return {
            $: 300,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Model = function(a) {
        return {
            $: 301,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Msg = function(a) {
        return {
            $: 301,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Model = function(a) {
        return {
            $: 194,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Msg = function(a) {
        return {
            $: 194,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__VitalsTrends__Model = function(a) {
        return {
            $: 265,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__PatientId_String__VitalsTrends__Msg = function(a) {
        return {
            $: 265,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__Top__Model = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__Top__Msg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__Upload__Model = function(a) {
        return {
            $: 88,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Patients__Upload__Msg = function(a) {
        return {
            $: 88,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Account__Model = function(a) {
        return {
            $: 89,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Account__Msg = function(a) {
        return {
            $: 89,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Model = function(a) {
        return {
            $: 90,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Msg = function(a) {
        return {
            $: 90,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Model = function(a) {
        return {
            $: 91,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Msg = function(a) {
        return {
            $: 91,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Model = function(a) {
        return {
            $: 92,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Msg = function(a) {
        return {
            $: 92,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Model = function(a) {
        return {
            $: 93,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Msg = function(a) {
        return {
            $: 93,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Model = function(a) {
        return {
            $: 94,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Msg = function(a) {
        return {
            $: 94,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Model = function(a) {
        return {
            $: 315,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Msg = function(a) {
        return {
            $: 315,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Model = function(a) {
        return {
            $: 95,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Msg = function(a) {
        return {
            $: 95,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Model = function(a) {
        return {
            $: 266,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Msg = function(a) {
        return {
            $: 266,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Team__Model = function(a) {
        return {
            $: 96,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Team__Msg = function(a) {
        return {
            $: 96,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Top__Model = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$PracticeSetup__Top__Msg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Model = function(a) {
        return {
            $: 288,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Msg = function(a) {
        return {
            $: 288,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Model = function(a) {
        return {
            $: 195,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Msg = function(a) {
        return {
            $: 195,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Model = function(a) {
        return {
            $: 97,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Msg = function(a) {
        return {
            $: 97,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Model = function(a) {
        return {
            $: 98,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Msg = function(a) {
        return {
            $: 98,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Model = function(a) {
        return {
            $: 267,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Msg = function(a) {
        return {
            $: 267,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Model = function(a) {
        return {
            $: 99,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Msg = function(a) {
        return {
            $: 99,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Model = function(a) {
        return {
            $: 268,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Msg = function(a) {
        return {
            $: 268,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Model = function(a) {
        return {
            $: 289,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Msg = function(a) {
        return {
            $: 289,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Custom__New__Model = function(a) {
        return {
            $: 269,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Custom__New__Msg = function(a) {
        return {
            $: 269,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Dashboard__Model = function(a) {
        return {
            $: 100,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Dashboard__Msg = function(a) {
        return {
            $: 100,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Model = function(a) {
        return {
            $: 101,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Msg = function(a) {
        return {
            $: 101,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Model = function(a) {
        return {
            $: 270,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Msg = function(a) {
        return {
            $: 270,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Deposits__Model = function(a) {
        return {
            $: 102,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Deposits__Msg = function(a) {
        return {
            $: 102,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Disputes__Model = function(a) {
        return {
            $: 103,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Disputes__Msg = function(a) {
        return {
            $: 103,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Invoices__Model = function(a) {
        return {
            $: 104,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Invoices__Msg = function(a) {
        return {
            $: 104,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Memberships__Model = function(a) {
        return {
            $: 105,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Memberships__Msg = function(a) {
        return {
            $: 105,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Months__Model = function(a) {
        return {
            $: 106,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Months__Msg = function(a) {
        return {
            $: 106,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Model = function(a) {
        return {
            $: 107,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Msg = function(a) {
        return {
            $: 107,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Model = function(a) {
        return {
            $: 271,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Msg = function(a) {
        return {
            $: 271,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Revenue__Model = function(a) {
        return {
            $: 108,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Revenue__Msg = function(a) {
        return {
            $: 108,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Model = function(a) {
        return {
            $: 272,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Msg = function(a) {
        return {
            $: 272,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__SalesTax__Model = function(a) {
        return {
            $: 109,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__SalesTax__Msg = function(a) {
        return {
            $: 109,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Model = function(a) {
        return {
            $: 273,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Msg = function(a) {
        return {
            $: 273,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Model = function(a) {
        return {
            $: 110,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Msg = function(a) {
        return {
            $: 110,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Model = function(a) {
        return {
            $: 111,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Msg = function(a) {
        return {
            $: 111,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Model = function(a) {
        return {
            $: 112,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Msg = function(a) {
        return {
            $: 112,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Alert__Model = function(a) {
        return {
            $: 113,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Alert__Msg = function(a) {
        return {
            $: 113,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Badge__Model = function(a) {
        return {
            $: 114,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Badge__Msg = function(a) {
        return {
            $: 114,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Button__Model = function(a) {
        return {
            $: 115,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Button__Msg = function(a) {
        return {
            $: 115,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Model = function(a) {
        return {
            $: 116,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Msg = function(a) {
        return {
            $: 116,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Model = function(a) {
        return {
            $: 117,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Msg = function(a) {
        return {
            $: 117,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Model = function(a) {
        return {
            $: 118,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Msg = function(a) {
        return {
            $: 118,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Model = function(a) {
        return {
            $: 119,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Msg = function(a) {
        return {
            $: 119,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Model = function(a) {
        return {
            $: 120,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Msg = function(a) {
        return {
            $: 120,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Model = function(a) {
        return {
            $: 121,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Msg = function(a) {
        return {
            $: 121,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Model = function(a) {
        return {
            $: 122,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Msg = function(a) {
        return {
            $: 122,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Model = function(a) {
        return {
            $: 123,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Msg = function(a) {
        return {
            $: 123,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Model = function(a) {
        return {
            $: 124,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Msg = function(a) {
        return {
            $: 124,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Model = function(a) {
        return {
            $: 125,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Msg = function(a) {
        return {
            $: 125,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Model = function(a) {
        return {
            $: 126,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Msg = function(a) {
        return {
            $: 126,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Model = function(a) {
        return {
            $: 127,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Msg = function(a) {
        return {
            $: 127,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Grid__Model = function(a) {
        return {
            $: 128,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Grid__Msg = function(a) {
        return {
            $: 128,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Model = function(a) {
        return {
            $: 129,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Msg = function(a) {
        return {
            $: 129,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Model = function(a) {
        return {
            $: 130,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Msg = function(a) {
        return {
            $: 130,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Icon__Model = function(a) {
        return {
            $: 131,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Icon__Msg = function(a) {
        return {
            $: 131,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Input__Model = function(a) {
        return {
            $: 132,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Input__Msg = function(a) {
        return {
            $: 132,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Link__Model = function(a) {
        return {
            $: 133,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Link__Msg = function(a) {
        return {
            $: 133,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Model = function(a) {
        return {
            $: 134,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Msg = function(a) {
        return {
            $: 134,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Modal__Model = function(a) {
        return {
            $: 135,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Modal__Msg = function(a) {
        return {
            $: 135,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Model = function(a) {
        return {
            $: 136,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Msg = function(a) {
        return {
            $: 136,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Panel__Model = function(a) {
        return {
            $: 137,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Panel__Msg = function(a) {
        return {
            $: 137,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Model = function(a) {
        return {
            $: 138,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Msg = function(a) {
        return {
            $: 138,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Model = function(a) {
        return {
            $: 139,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Msg = function(a) {
        return {
            $: 139,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Model = function(a) {
        return {
            $: 140,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Msg = function(a) {
        return {
            $: 140,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Popover__Model = function(a) {
        return {
            $: 141,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Popover__Msg = function(a) {
        return {
            $: 141,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Model = function(a) {
        return {
            $: 142,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Msg = function(a) {
        return {
            $: 142,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Radio__Model = function(a) {
        return {
            $: 143,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Radio__Msg = function(a) {
        return {
            $: 143,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Model = function(a) {
        return {
            $: 144,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Msg = function(a) {
        return {
            $: 144,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Model = function(a) {
        return {
            $: 145,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Msg = function(a) {
        return {
            $: 145,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__SearchableSelect__Model = function(a) {
        return {
            $: 146,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__SearchableSelect__Msg = function(a) {
        return {
            $: 146,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Select__Model = function(a) {
        return {
            $: 147,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Select__Msg = function(a) {
        return {
            $: 147,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Model = function(a) {
        return {
            $: 148,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Msg = function(a) {
        return {
            $: 148,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Table__Model = function(a) {
        return {
            $: 149,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Table__Msg = function(a) {
        return {
            $: 149,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Toast__Model = function(a) {
        return {
            $: 150,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Toast__Msg = function(a) {
        return {
            $: 150,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Model = function(a) {
        return {
            $: 151,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Msg = function(a) {
        return {
            $: 151,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Model = function(a) {
        return {
            $: 152,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Msg = function(a) {
        return {
            $: 152,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Top__Model = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Top__Msg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Typography__Model = function(a) {
        return {
            $: 153,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Typography__Msg = function(a) {
        return {
            $: 153,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Model = function(a) {
        return {
            $: 154,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Msg = function(a) {
        return {
            $: 154,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Model = function(a) {
        return {
            $: 155,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Msg = function(a) {
        return {
            $: 155,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Well__Model = function(a) {
        return {
            $: 156,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$StyleGuide__Well__Msg = function(a) {
        return {
            $: 156,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Support__CannySso__Model = function(a) {
        return {
            $: 157,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Support__CannySso__Msg = function(a) {
        return {
            $: 157,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Tasks__New__Model = function(a) {
        return {
            $: 158,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Tasks__New__Msg = function(a) {
        return {
            $: 158,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Model = function(a) {
        return {
            $: 196,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Msg = function(a) {
        return {
            $: 196,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Tasks__Top__Model = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Tasks__Top__Msg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Top__Model = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$Top__Msg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__AcceptTerms__Model = function(a) {
        return {
            $: 159,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__AcceptTerms__Msg = function(a) {
        return {
            $: 159,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__Mfa__Model = function(a) {
        return {
            $: 160,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__Mfa__Msg = function(a) {
        return {
            $: 160,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__Organizations__Top__Model = function(a) {
        return {
            $: 197,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__Organizations__Top__Msg = function(a) {
        return {
            $: 197,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__Profile__Model = function(a) {
        return {
            $: 161,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__Profile__Msg = function(a) {
        return {
            $: 161,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__Security__Model = function(a) {
        return {
            $: 162,
            a: a
        };
    };
    var $author$project$Spa$Generated$Pages$User__Security__Msg = function(a) {
        return {
            $: 162,
            a: a
        };
    };
    var $author$project$Spa$Page$SessionFailed = {
        $: 2
    };
    var $author$project$Spa$Page$SessionLoaded = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Spa$Page$SessionLoading = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Permission$User = 7;
    var $author$project$Permission$Company__Account = 18;
    var $author$project$Permission$Company__AffiliatesPricing = 23;
    var $author$project$Permission$Company__Employees = 19;
    var $author$project$Permission$Company__Invoice = 20;
    var $author$project$Permission$Company__Invoices = 21;
    var $author$project$Permission$Company__One = 22;
    var $author$project$Permission$Company__PaymentSources = 24;
    var $author$project$Permission$Company__Signup = 26;
    var $author$project$Permission$Company__Uploads = 25;
    var $elm$core$List$any = F2(function(isOkay, list) {
        any: while(true){
            if (!list.b) return false;
            else {
                var x = list.a;
                var xs = list.b;
                if (isOkay(x)) return true;
                else {
                    var $temp$isOkay = isOkay, $temp$list = xs;
                    isOkay = $temp$isOkay;
                    list = $temp$list;
                    continue any;
                }
            }
        }
    });
    var $elm$core$List$member = F2(function(x, xs) {
        return A2($elm$core$List$any, function(a) {
            return _Utils_eq(a, x);
        }, xs);
    });
    var $author$project$Permission$companySessionCanGoTo = function(state) {
        var allowedStates = _List_fromArray([
            18,
            19,
            20,
            21,
            22,
            23,
            24,
            25,
            26
        ]);
        return A2($elm$core$List$member, state, allowedStates);
    };
    var $author$project$Api$Platform$User$Shared$isAdmin = function(_v0) {
        var record = _v0;
        return record.RO;
    };
    var $author$project$Permission$Hinter__AdminAdminUsersGroup = 14;
    var $author$project$Permission$Hinter__AdminAdminUsersGroups = 13;
    var $author$project$Permission$Hinter__AdminClonePractice = 9;
    var $author$project$Permission$Hinter__AdminDisputes = 12;
    var $author$project$Permission$Hinter__AdminFeatureFlags = 15;
    var $author$project$Permission$Hinter__AdminNewGroup = 11;
    var $author$project$Permission$Hinter__AdminNewPartner = 10;
    var $author$project$Permission$Hinter__AdminNewPractice = 8;
    var $author$project$Permission$Marketplace__List = 56;
    var $author$project$Permission$Marketplace__Slug_String = 57;
    var $author$project$Permission$Partner__Billing__Hinter = 33;
    var $author$project$Permission$Partner__Hinter = 32;
    var $author$project$Permission$Partner__Product__Hinter = 36;
    var $author$project$Permission$onlyHintersStates = _List_fromArray([
        8,
        9,
        12,
        13,
        14,
        15,
        10,
        11,
        36,
        33,
        32,
        56,
        57
    ]);
    var $author$project$Api$Platform$Session$One$organization = function(_v0) {
        var record = _v0;
        return record.VA;
    };
    var $author$project$Permission$Partner__ApiKeys = 39;
    var $author$project$Permission$Partner__Billing = 34;
    var $author$project$Permission$Partner__Practices = 41;
    var $author$project$Permission$Partner__Product = 31;
    var $author$project$Permission$Partner__Product_AppSettings = 42;
    var $author$project$Permission$Partner__Product__ActivationSettings = 35;
    var $author$project$Permission$Partner__Product__New = 38;
    var $author$project$Permission$Partner__Products = 37;
    var $author$project$Permission$Partner__Sandboxes = 43;
    var $author$project$Permission$Partner__Team = 30;
    var $author$project$Permission$Partner__Webhooks = 40;
    var $author$project$Permission$partnerSessionCanGoTo = function(state) {
        var allowedStates = _List_fromArray([
            30,
            31,
            32,
            35,
            36,
            37,
            38,
            39,
            40,
            41,
            42,
            43,
            33,
            34,
            57
        ]);
        return A2($elm$core$List$member, state, allowedStates);
    };
    var $author$project$Permission$Admin__PaymentProcessing = 3;
    var $author$project$Permission$Admin__Stripe = 6;
    var $author$project$Permission$Onboarding = 51;
    var $author$project$Permission$PracticeIsOnboarding = 52;
    var $author$project$Api$Common$PermissionSet$Shared$enabled = function(_v0) {
        var record = _v0;
        return record.OM;
    };
    var $author$project$Api$Platform$Session$One$permissionSets = function(_v0) {
        var record = _v0;
        return record.WD;
    };
    var $author$project$Permission$enabledPermissionSetsFor = function(session) {
        return A2($elm$core$List$filter, $author$project$Api$Common$PermissionSet$Shared$enabled, $author$project$Api$Platform$Session$One$permissionSets(session));
    };
    var $elm$core$List$isEmpty = function(xs) {
        if (!xs.b) return true;
        else return false;
    };
    var $author$project$Api$Common$PermissionSet$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Platform$Organization$Shared$onboarded = function(_v0) {
        var record = _v0.b;
        return record.Vs;
    };
    var $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding = function(_v0) {
        var record = _v0.b;
        return record.W4;
    };
    var $author$project$Permission$patientsPermission = {
        zr: 'view_patients'
    };
    var $author$project$Permission$requiredPermissionSetFor = function(state) {
        switch(state){
            case 44:
                return $elm$core$Maybe$Just($author$project$Permission$patientsPermission);
            case 45:
                return $elm$core$Maybe$Just({
                    zr: 'view_reports'
                });
            case 16:
                return $elm$core$Maybe$Just({
                    zr: 'manage_employers'
                });
            case 0:
                return $elm$core$Maybe$Just({
                    zr: 'change_admin_settings'
                });
            case 46:
                return $elm$core$Maybe$Just({
                    zr: 'manage_commissions'
                });
            case 1:
                return $elm$core$Maybe$Just({
                    zr: 'practice_billing_only'
                });
            case 2:
                return $elm$core$Maybe$Just({
                    zr: 'practice_billing_only'
                });
            case 3:
                return $elm$core$Maybe$Just({
                    zr: 'practice_billing_only'
                });
            case 4:
                return $elm$core$Maybe$Just({
                    zr: 'practice_billing_only'
                });
            case 5:
                return $elm$core$Maybe$Just({
                    zr: 'practice_billing_only'
                });
            case 6:
                return $elm$core$Maybe$Just({
                    zr: 'change_admin_settings'
                });
            case 48:
                return $elm$core$Maybe$Just({
                    zr: 'revise_invoices'
                });
            case 50:
                return $elm$core$Maybe$Just({
                    zr: 'manage_networks'
                });
            case 49:
                return $elm$core$Maybe$Just({
                    zr: 'issue_refunds'
                });
            case 7:
                return $elm$core$Maybe$Nothing;
            case 8:
                return $elm$core$Maybe$Nothing;
            case 9:
                return $elm$core$Maybe$Nothing;
            case 10:
                return $elm$core$Maybe$Nothing;
            case 11:
                return $elm$core$Maybe$Nothing;
            case 12:
                return $elm$core$Maybe$Nothing;
            case 13:
                return $elm$core$Maybe$Nothing;
            case 14:
                return $elm$core$Maybe$Nothing;
            case 15:
                return $elm$core$Maybe$Nothing;
            case 17:
                return $elm$core$Maybe$Nothing;
            case 18:
                return $elm$core$Maybe$Nothing;
            case 19:
                return $elm$core$Maybe$Nothing;
            case 20:
                return $elm$core$Maybe$Nothing;
            case 21:
                return $elm$core$Maybe$Nothing;
            case 22:
                return $elm$core$Maybe$Nothing;
            case 23:
                return $elm$core$Maybe$Nothing;
            case 24:
                return $elm$core$Maybe$Nothing;
            case 25:
                return $elm$core$Maybe$Nothing;
            case 26:
                return $elm$core$Maybe$Nothing;
            case 27:
                return $elm$core$Maybe$Nothing;
            case 28:
                return $elm$core$Maybe$Nothing;
            case 29:
                return $elm$core$Maybe$Nothing;
            case 47:
                return $elm$core$Maybe$Nothing;
            case 51:
                return $elm$core$Maybe$Nothing;
            case 52:
                return $elm$core$Maybe$Nothing;
            case 53:
                return $elm$core$Maybe$Nothing;
            case 54:
                return $elm$core$Maybe$Nothing;
            case 30:
                return $elm$core$Maybe$Nothing;
            case 31:
                return $elm$core$Maybe$Nothing;
            case 32:
                return $elm$core$Maybe$Nothing;
            case 35:
                return $elm$core$Maybe$Nothing;
            case 36:
                return $elm$core$Maybe$Nothing;
            case 37:
                return $elm$core$Maybe$Nothing;
            case 38:
                return $elm$core$Maybe$Nothing;
            case 39:
                return $elm$core$Maybe$Nothing;
            case 40:
                return $elm$core$Maybe$Nothing;
            case 41:
                return $elm$core$Maybe$Nothing;
            case 42:
                return $elm$core$Maybe$Nothing;
            case 43:
                return $elm$core$Maybe$Nothing;
            case 33:
                return $elm$core$Maybe$Nothing;
            case 34:
                return $elm$core$Maybe$Nothing;
            case 55:
                return $elm$core$Maybe$Nothing;
            case 56:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Permission$Admin = 0;
    var $author$project$Permission$Bookkeeping = 53;
    var $author$project$Permission$BrokerAccounts = 47;
    var $author$project$Permission$ClinicalApp = 55;
    var $author$project$Permission$Commissions = 46;
    var $author$project$Permission$Companies = 16;
    var $author$project$Permission$Company = 17;
    var $author$project$Permission$IssueRefunds = 49;
    var $author$project$Permission$Network = 50;
    var $author$project$Permission$PartnerApp = 54;
    var $author$project$Permission$Patients = 44;
    var $author$project$Permission$Reports = 45;
    var $author$project$Permission$ReviseInvoices = 48;
    var $author$project$Permission$topLevelStateFor = function(state) {
        switch(state){
            case 44:
                return 44;
            case 45:
                return 45;
            case 0:
                return 0;
            case 46:
                return 46;
            case 47:
                return 47;
            case 1:
                return 0;
            case 2:
                return 0;
            case 3:
                return 0;
            case 4:
                return 0;
            case 5:
                return 0;
            case 6:
                return 0;
            case 48:
                return 48;
            case 50:
                return 50;
            case 49:
                return 49;
            case 7:
                return 7;
            case 8:
                return 7;
            case 9:
                return 7;
            case 10:
                return 7;
            case 11:
                return 7;
            case 12:
                return 7;
            case 13:
                return 7;
            case 14:
                return 7;
            case 15:
                return 7;
            case 16:
                return 16;
            case 17:
                return 17;
            case 18:
                return 17;
            case 19:
                return 17;
            case 20:
                return 17;
            case 21:
                return 17;
            case 22:
                return 17;
            case 23:
                return 17;
            case 24:
                return 17;
            case 25:
                return 17;
            case 26:
                return 17;
            case 27:
                return 17;
            case 28:
                return 17;
            case 29:
                return 17;
            case 51:
                return 51;
            case 52:
                return 52;
            case 53:
                return 53;
            case 54:
                return 54;
            case 30:
                return 41;
            case 31:
                return 41;
            case 32:
                return 32;
            case 35:
                return 31;
            case 36:
                return 31;
            case 37:
                return 41;
            case 38:
                return 31;
            case 39:
                return 41;
            case 40:
                return 41;
            case 41:
                return 41;
            case 42:
                return 42;
            case 43:
                return 43;
            case 33:
                return 34;
            case 34:
                return 34;
            case 55:
                return 55;
            case 56:
                return 56;
            default:
                return 56;
        }
    };
    var $author$project$Api$Platform$Session$One$user = function(_v0) {
        var record = _v0;
        return record.aaX;
    };
    var $author$project$Utils$User$viewingAsNonHinter = F2(function(session, hinterViewOff) {
        return !A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session) || hinterViewOff;
    });
    var $author$project$Permission$practiceSessionCanGoTo = F3(function(session, hinterViewOff, state) {
        if (!A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$onboarded, $author$project$Api$Platform$Session$One$organization(session))) && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff)) return state === 51;
        else {
            if (function() {
                var practiceIsOnboarding = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding, $author$project$Api$Platform$Session$One$organization(session)));
                return practiceIsOnboarding && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff);
            }()) return state === 52 || state === 6 || state === 3;
            else {
                var topLevelState = $author$project$Permission$topLevelStateFor(state);
                var enabledPermissionSets = $author$project$Permission$enabledPermissionSetsFor(session);
                var currentPermissionSet = function() {
                    var _v1 = _Utils_Tuple2($author$project$Permission$requiredPermissionSetFor(state), $author$project$Permission$requiredPermissionSetFor(topLevelState));
                    if (!_v1.a.$) {
                        var permissionSet = _v1.a.a;
                        return $elm$core$Maybe$Just(permissionSet);
                    } else if (!_v1.b.$) {
                        var _v2 = _v1.a;
                        var permissionSet = _v1.b.a;
                        return $elm$core$Maybe$Just(permissionSet);
                    } else {
                        var _v3 = _v1.a;
                        var _v4 = _v1.b;
                        return $elm$core$Maybe$Nothing;
                    }
                }();
                if (currentPermissionSet.$ === 1) return !$elm$core$List$isEmpty(enabledPermissionSets);
                else {
                    var currentPermissionSet_ = currentPermissionSet.a;
                    return A2($elm$core$List$any, function(permissionSet) {
                        return _Utils_eq($author$project$Api$Common$PermissionSet$Shared$name(permissionSet), currentPermissionSet_.zr);
                    }, enabledPermissionSets);
                }
            }
        }
    });
    var $author$project$Api$Platform$Organization$Min$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Platform$Organization$Shared$type_ = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Organization$Min$type_(min);
    };
    var $author$project$Permission$canGoTo = F3(function(session, hinterViewOff, state) {
        if (A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session) && A2($elm$core$List$member, state, $author$project$Permission$onlyHintersStates)) return true;
        else {
            if (state === 7) return true;
            else {
                var _v0 = $author$project$Api$Platform$Session$One$organization(session);
                if (_v0.$ === 1) return false;
                else {
                    var organization = _v0.a;
                    var _v1 = $author$project$Api$Platform$Organization$Shared$type_(organization);
                    switch(_v1){
                        case 1:
                            return $author$project$Permission$companySessionCanGoTo(state);
                        case 0:
                            return A3($author$project$Permission$practiceSessionCanGoTo, session, hinterViewOff, state);
                        default:
                            return $author$project$Permission$partnerSessionCanGoTo(state);
                    }
                }
            }
        }
    });
    var $author$project$Permission$Admin__Billing = 1;
    var $author$project$Permission$Admin__PaymentMethodImport = 4;
    var $author$project$Permission$Admin__PaymentMethodImport__Upload = 5;
    var $author$project$Permission$Admin__PaymentSources = 2;
    var $author$project$Permission$Company__EndedCommissions = 29;
    var $author$project$Permission$Company__Notes = 27;
    var $author$project$Permission$Company__Notifications = 28;
    var $author$project$Permission$forRoute = function(route) {
        switch(route.$){
            case 198:
                return $elm$core$Maybe$Just(0);
            case 199:
                return $elm$core$Maybe$Just(0);
            case 200:
                return $elm$core$Maybe$Just(0);
            case 201:
                return $elm$core$Maybe$Just(0);
            case 202:
                return $elm$core$Maybe$Just(0);
            case 167:
                return $elm$core$Maybe$Just(0);
            case 316:
                return $elm$core$Maybe$Just(1);
            case 274:
                return $elm$core$Maybe$Just(0);
            case 203:
                return $elm$core$Maybe$Just(0);
            case 168:
                return $elm$core$Maybe$Just(0);
            case 204:
                return $elm$core$Maybe$Just(0);
            case 275:
                return $elm$core$Maybe$Just(0);
            case 205:
                return $elm$core$Maybe$Just(0);
            case 169:
                return $elm$core$Maybe$Just(0);
            case 276:
                return $elm$core$Maybe$Just(0);
            case 206:
                return $elm$core$Maybe$Just(0);
            case 170:
                return $elm$core$Maybe$Just(0);
            case 207:
                return $elm$core$Maybe$Just(0);
            case 279:
                return $elm$core$Maybe$Just(0);
            case 213:
                return $elm$core$Maybe$Just(0);
            case 173:
                return $elm$core$Maybe$Just(0);
            case 214:
                return $elm$core$Maybe$Just(0);
            case 215:
                return $elm$core$Maybe$Just(0);
            case 216:
                return $elm$core$Maybe$Just(0);
            case 174:
                return $elm$core$Maybe$Just(0);
            case 280:
                return $elm$core$Maybe$Just(0);
            case 217:
                return $elm$core$Maybe$Just(0);
            case 218:
                return $elm$core$Maybe$Just(0);
            case 219:
                return $elm$core$Maybe$Just(0);
            case 220:
                return $elm$core$Maybe$Just(0);
            case 221:
                return $elm$core$Maybe$Just(0);
            case 222:
                return $elm$core$Maybe$Just(0);
            case 302:
                return $elm$core$Maybe$Just(0);
            case 281:
                return $elm$core$Maybe$Just(0);
            case 224:
                return $elm$core$Maybe$Just(0);
            case 175:
                return $elm$core$Maybe$Just(0);
            case 176:
                return $elm$core$Maybe$Just(0);
            case 225:
                return $elm$core$Maybe$Just(0);
            case 177:
                return $elm$core$Maybe$Just(0);
            case 282:
                return $elm$core$Maybe$Just(0);
            case 226:
                return $elm$core$Maybe$Just(0);
            case 178:
                return $elm$core$Maybe$Just(0);
            case 20:
                return $elm$core$Maybe$Just(0);
            case 21:
                return $elm$core$Maybe$Just(1);
            case 22:
                return $elm$core$Maybe$Just(0);
            case 23:
                return $elm$core$Maybe$Just(0);
            case 24:
                return $elm$core$Maybe$Just(0);
            case 25:
                return $elm$core$Maybe$Just(0);
            case 26:
                return $elm$core$Maybe$Just(0);
            case 27:
                return $elm$core$Maybe$Just(0);
            case 28:
                return $elm$core$Maybe$Just(0);
            case 29:
                return $elm$core$Maybe$Just(0);
            case 31:
                return $elm$core$Maybe$Just(0);
            case 30:
                return $elm$core$Maybe$Just(0);
            case 32:
                return $elm$core$Maybe$Just(0);
            case 33:
                return $elm$core$Maybe$Just(0);
            case 34:
                return $elm$core$Maybe$Just(0);
            case 35:
                return $elm$core$Maybe$Just(0);
            case 36:
                return $elm$core$Maybe$Just(0);
            case 37:
                return $elm$core$Maybe$Just(0);
            case 40:
                return $elm$core$Maybe$Just(2);
            case 39:
                return $elm$core$Maybe$Just(3);
            case 38:
                return $elm$core$Maybe$Just(4);
            case 223:
                return $elm$core$Maybe$Just(5);
            case 41:
                return $elm$core$Maybe$Just(0);
            case 42:
                return $elm$core$Maybe$Just(0);
            case 43:
                return $elm$core$Maybe$Just(0);
            case 44:
                return $elm$core$Maybe$Just(0);
            case 172:
                return $elm$core$Maybe$Just(0);
            case 208:
                return $elm$core$Maybe$Just(0);
            case 278:
                return $elm$core$Maybe$Just(0);
            case 171:
                return $elm$core$Maybe$Just(0);
            case 277:
                return $elm$core$Maybe$Just(0);
            case 209:
                return $elm$core$Maybe$Just(0);
            case 210:
                return $elm$core$Maybe$Just(0);
            case 212:
                return $elm$core$Maybe$Just(0);
            case 211:
                return $elm$core$Maybe$Just(0);
            case 45:
                return $elm$core$Maybe$Just(0);
            case 46:
                return $elm$core$Maybe$Just(6);
            case 47:
                return $elm$core$Maybe$Just(0);
            case 48:
                return $elm$core$Maybe$Just(0);
            case 227:
                return $elm$core$Maybe$Just(0);
            case 78:
                return $elm$core$Maybe$Just(55);
            case 79:
                return $elm$core$Maybe$Just(55);
            case 286:
                return $elm$core$Maybe$Just(55);
            case 313:
                return $elm$core$Maybe$Just(55);
            case 75:
                return $elm$core$Maybe$Just(55);
            case 74:
                return $elm$core$Maybe$Just(55);
            case 73:
                return $elm$core$Maybe$Just(55);
            case 76:
                return $elm$core$Maybe$Just(55);
            case 2:
                return $elm$core$Maybe$Just(0);
            case 62:
                return $elm$core$Maybe$Just(8);
            case 57:
                return $elm$core$Maybe$Just(9);
            case 61:
                return $elm$core$Maybe$Just(10);
            case 60:
                return $elm$core$Maybe$Just(11);
            case 58:
                return $elm$core$Maybe$Just(12);
            case 59:
                return $elm$core$Maybe$Just(15);
            case 183:
                return $elm$core$Maybe$Just(13);
            case 283:
                return $elm$core$Maybe$Just(14);
            case 161:
                return $elm$core$Maybe$Just(7);
            case 160:
                return $elm$core$Maybe$Just(7);
            case 162:
                return $elm$core$Maybe$Just(7);
            case 197:
                return $elm$core$Maybe$Just(7);
            case 159:
                return $elm$core$Maybe$Just(7);
            case 105:
                return $elm$core$Maybe$Just(45);
            case 110:
                return $elm$core$Maybe$Just(45);
            case 100:
                return $elm$core$Maybe$Just(45);
            case 106:
                return $elm$core$Maybe$Just(45);
            case 109:
                return $elm$core$Maybe$Just(45);
            case 273:
                return $elm$core$Maybe$Just(45);
            case 195:
                return $elm$core$Maybe$Just(45);
            case 288:
                return $elm$core$Maybe$Just(45);
            case 102:
                return $elm$core$Maybe$Just(45);
            case 97:
                return $elm$core$Maybe$Just(45);
            case 104:
                return $elm$core$Maybe$Just(45);
            case 98:
                return $elm$core$Maybe$Just(45);
            case 267:
                return $elm$core$Maybe$Just(45);
            case 99:
                return $elm$core$Maybe$Just(45);
            case 268:
                return $elm$core$Maybe$Just(45);
            case 107:
                return $elm$core$Maybe$Just(45);
            case 271:
                return $elm$core$Maybe$Just(45);
            case 108:
                return $elm$core$Maybe$Just(45);
            case 272:
                return $elm$core$Maybe$Just(45);
            case 101:
                return $elm$core$Maybe$Just(45);
            case 270:
                return $elm$core$Maybe$Just(45);
            case 289:
                return $elm$core$Maybe$Just(45);
            case 103:
                return $elm$core$Maybe$Just(45);
            case 53:
                return $elm$core$Maybe$Just(16);
            case 13:
                return $elm$core$Maybe$Just(16);
            case 181:
                return $elm$core$Maybe$Just(22);
            case 238:
                return $elm$core$Maybe$Just(29);
            case 236:
                return $elm$core$Maybe$Just(23);
            case 293:
                return $elm$core$Maybe$Just(21);
            case 318:
                return $elm$core$Maybe$Just(21);
            case 240:
                return $elm$core$Maybe$Just(27);
            case 241:
                return $elm$core$Maybe$Just(28);
            case 239:
                return $elm$core$Maybe$Just(0);
            case 292:
                return $elm$core$Maybe$Just(19);
            case 305:
                return $elm$core$Maybe$Just(19);
            case 335:
                return $elm$core$Maybe$Just(19);
            case 242:
                return $elm$core$Maybe$Just(24);
            case 294:
                return $elm$core$Maybe$Just(25);
            case 324:
                return $elm$core$Maybe$Just(25);
            case 237:
                return $elm$core$Maybe$Just(25);
            case 331:
                return $elm$core$Maybe$Just(25);
            case 243:
                return $elm$core$Maybe$Just(26);
            case 306:
                return $elm$core$Maybe$Just(26);
            case 319:
                return $elm$core$Maybe$Just(26);
            case 52:
                return $elm$core$Maybe$Just(46);
            case 180:
                return $elm$core$Maybe$Just(46);
            case 235:
                return $elm$core$Maybe$Just(46);
            case 179:
                return $elm$core$Maybe$Just(46);
            case 234:
                return $elm$core$Maybe$Just(46);
            case 291:
                return $elm$core$Maybe$Just(47);
            case 303:
                return $elm$core$Maybe$Just(47);
            case 304:
                return $elm$core$Maybe$Just(47);
            case 322:
                return $elm$core$Maybe$Just(47);
            case 330:
                return $elm$core$Maybe$Just(47);
            case 334:
                return $elm$core$Maybe$Just(47);
            case 329:
                return $elm$core$Maybe$Just(47);
            case 323:
                return $elm$core$Maybe$Just(47);
            case 333:
                return $elm$core$Maybe$Just(47);
            case 12:
                return $elm$core$Maybe$Just(50);
            case 50:
                return $elm$core$Maybe$Just(50);
            case 49:
                return $elm$core$Maybe$Just(50);
            case 228:
                return $elm$core$Maybe$Just(0);
            case 229:
                return $elm$core$Maybe$Just(50);
            case 290:
                return $elm$core$Maybe$Just(50);
            case 317:
                return $elm$core$Maybe$Just(50);
            case 230:
                return $elm$core$Maybe$Just(50);
            case 232:
                return $elm$core$Maybe$Just(50);
            case 231:
                return $elm$core$Maybe$Just(50);
            case 233:
                return $elm$core$Maybe$Just(50);
            case 11:
                return $elm$core$Maybe$Just(50);
            case 165:
                return $elm$core$Maybe$Nothing;
            case 8:
                return $elm$core$Maybe$Nothing;
            case 80:
                return $elm$core$Maybe$Nothing;
            case 157:
                return $elm$core$Maybe$Nothing;
            case 164:
                return $elm$core$Maybe$Nothing;
            case 7:
                return $elm$core$Maybe$Nothing;
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            case 9:
                return $elm$core$Maybe$Nothing;
            case 16:
                return $elm$core$Maybe$Just(44);
            case 87:
                return $elm$core$Maybe$Just(44);
            case 88:
                return $elm$core$Maybe$Just(44);
            case 194:
                return $elm$core$Maybe$Just(44);
            case 260:
                return $elm$core$Maybe$Just(44);
            case 264:
                return $elm$core$Maybe$Just(44);
            case 296:
                return $elm$core$Maybe$Just(44);
            case 263:
                return $elm$core$Maybe$Just(44);
            case 325:
                return $elm$core$Maybe$Just(44);
            case 259:
                return $elm$core$Maybe$Just(55);
            case 298:
                return $elm$core$Maybe$Just(44);
            case 326:
                return $elm$core$Maybe$Just(44);
            case 299:
                return $elm$core$Maybe$Just(44);
            case 314:
                return $elm$core$Maybe$Just(44);
            case 327:
                return $elm$core$Maybe$Just(44);
            case 300:
                return $elm$core$Maybe$Just(44);
            case 321:
                return $elm$core$Maybe$Just(55);
            case 261:
                return $elm$core$Maybe$Just(55);
            case 262:
                return $elm$core$Maybe$Just(55);
            case 265:
                return $elm$core$Maybe$Just(55);
            case 297:
                return $elm$core$Maybe$Just(44);
            case 301:
                return $elm$core$Maybe$Just(44);
            case 51:
                return $elm$core$Maybe$Nothing;
            case 10:
                return $elm$core$Maybe$Just(51);
            case 86:
                return $elm$core$Maybe$Just(30);
            case 85:
                return $elm$core$Maybe$Just(31);
            case 81:
                return $elm$core$Maybe$Just(39);
            case 258:
                return $elm$core$Maybe$Just(40);
            case 257:
                return $elm$core$Maybe$Just(40);
            case 192:
                return $elm$core$Maybe$Just(41);
            case 84:
                return $elm$core$Maybe$Just(32);
            case 252:
                return $elm$core$Maybe$Just(33);
            case 82:
                return $elm$core$Maybe$Just(34);
            case 253:
                return $elm$core$Maybe$Just(35);
            case 255:
                return $elm$core$Maybe$Just(36);
            case 191:
                return $elm$core$Maybe$Just(37);
            case 256:
                return $elm$core$Maybe$Just(38);
            case 254:
                return $elm$core$Maybe$Just(42);
            case 193:
                return $elm$core$Maybe$Just(43);
            case 83:
                return $elm$core$Maybe$Just(41);
            case 18:
                return $elm$core$Maybe$Nothing;
            case 143:
                return $elm$core$Maybe$Nothing;
            case 111:
                return $elm$core$Maybe$Nothing;
            case 115:
                return $elm$core$Maybe$Nothing;
            case 156:
                return $elm$core$Maybe$Nothing;
            case 130:
                return $elm$core$Maybe$Nothing;
            case 131:
                return $elm$core$Maybe$Nothing;
            case 133:
                return $elm$core$Maybe$Nothing;
            case 149:
                return $elm$core$Maybe$Nothing;
            case 137:
                return $elm$core$Maybe$Nothing;
            case 151:
                return $elm$core$Maybe$Nothing;
            case 153:
                return $elm$core$Maybe$Nothing;
            case 150:
                return $elm$core$Maybe$Nothing;
            case 113:
                return $elm$core$Maybe$Nothing;
            case 142:
                return $elm$core$Maybe$Nothing;
            case 117:
                return $elm$core$Maybe$Nothing;
            case 132:
                return $elm$core$Maybe$Nothing;
            case 136:
                return $elm$core$Maybe$Nothing;
            case 126:
                return $elm$core$Maybe$Nothing;
            case 125:
                return $elm$core$Maybe$Nothing;
            case 140:
                return $elm$core$Maybe$Nothing;
            case 135:
                return $elm$core$Maybe$Nothing;
            case 129:
                return $elm$core$Maybe$Nothing;
            case 114:
                return $elm$core$Maybe$Nothing;
            case 152:
                return $elm$core$Maybe$Nothing;
            case 124:
                return $elm$core$Maybe$Nothing;
            case 141:
                return $elm$core$Maybe$Nothing;
            case 122:
                return $elm$core$Maybe$Nothing;
            case 134:
                return $elm$core$Maybe$Nothing;
            case 138:
                return $elm$core$Maybe$Nothing;
            case 127:
                return $elm$core$Maybe$Nothing;
            case 120:
                return $elm$core$Maybe$Nothing;
            case 139:
                return $elm$core$Maybe$Nothing;
            case 155:
                return $elm$core$Maybe$Nothing;
            case 123:
                return $elm$core$Maybe$Nothing;
            case 154:
                return $elm$core$Maybe$Nothing;
            case 146:
                return $elm$core$Maybe$Nothing;
            case 144:
                return $elm$core$Maybe$Nothing;
            case 118:
                return $elm$core$Maybe$Nothing;
            case 147:
                return $elm$core$Maybe$Nothing;
            case 119:
                return $elm$core$Maybe$Nothing;
            case 145:
                return $elm$core$Maybe$Nothing;
            case 112:
                return $elm$core$Maybe$Nothing;
            case 128:
                return $elm$core$Maybe$Nothing;
            case 148:
                return $elm$core$Maybe$Nothing;
            case 190:
                return $elm$core$Maybe$Nothing;
            case 250:
                return $elm$core$Maybe$Nothing;
            case 251:
                return $elm$core$Maybe$Nothing;
            case 249:
                return $elm$core$Maybe$Nothing;
            case 248:
                return $elm$core$Maybe$Nothing;
            case 17:
                return $elm$core$Maybe$Just(52);
            case 89:
                return $elm$core$Maybe$Just(52);
            case 95:
                return $elm$core$Maybe$Just(52);
            case 266:
                return $elm$core$Maybe$Just(52);
            case 315:
                return $elm$core$Maybe$Just(52);
            case 92:
                return $elm$core$Maybe$Just(52);
            case 94:
                return $elm$core$Maybe$Just(52);
            case 91:
                return $elm$core$Maybe$Just(52);
            case 96:
                return $elm$core$Maybe$Just(52);
            case 90:
                return $elm$core$Maybe$Just(52);
            case 93:
                return $elm$core$Maybe$Just(52);
            case 269:
                return $elm$core$Maybe$Just(0);
            case 121:
                return $elm$core$Maybe$Nothing;
            case 116:
                return $elm$core$Maybe$Nothing;
            case 328:
                return $elm$core$Maybe$Just(0);
            case 332:
                return $elm$core$Maybe$Just(0);
            case 163:
                return $elm$core$Maybe$Just(54);
            case 15:
                return $elm$core$Maybe$Just(56);
            case 166:
                return $elm$core$Maybe$Just(57);
            case 310:
                return $elm$core$Maybe$Just(0);
            case 312:
                return $elm$core$Maybe$Just(0);
            case 311:
                return $elm$core$Maybe$Just(0);
            case 307:
                return $elm$core$Maybe$Just(0);
            case 309:
                return $elm$core$Maybe$Just(0);
            case 308:
                return $elm$core$Maybe$Just(0);
            case 66:
                return $elm$core$Maybe$Just(0);
            case 5:
                return $elm$core$Maybe$Just(55);
            case 3:
                return $elm$core$Maybe$Just(55);
            case 6:
                return $elm$core$Maybe$Just(55);
            case 54:
                return $elm$core$Maybe$Just(55);
            case 55:
                return $elm$core$Maybe$Just(55);
            case 182:
                return $elm$core$Maybe$Just(55);
            case 14:
                return $elm$core$Maybe$Just(55);
            case 56:
                return $elm$core$Maybe$Just(55);
            case 4:
                return $elm$core$Maybe$Just(55);
            case 63:
                return $elm$core$Maybe$Just(55);
            case 64:
                return $elm$core$Maybe$Just(55);
            case 184:
                return $elm$core$Maybe$Just(55);
            case 65:
                return $elm$core$Maybe$Just(55);
            case 72:
                return $elm$core$Maybe$Just(55);
            case 68:
                return $elm$core$Maybe$Just(55);
            case 67:
                return $elm$core$Maybe$Just(55);
            case 71:
                return $elm$core$Maybe$Just(55);
            case 185:
                return $elm$core$Maybe$Just(55);
            case 244:
                return $elm$core$Maybe$Just(55);
            case 70:
                return $elm$core$Maybe$Just(55);
            case 69:
                return $elm$core$Maybe$Just(55);
            case 186:
                return $elm$core$Maybe$Just(55);
            case 245:
                return $elm$core$Maybe$Just(55);
            case 295:
                return $elm$core$Maybe$Just(55);
            case 19:
                return $elm$core$Maybe$Just(55);
            case 158:
                return $elm$core$Maybe$Just(55);
            case 196:
                return $elm$core$Maybe$Just(55);
            case 188:
                return $elm$core$Maybe$Just(55);
            case 285:
                return $elm$core$Maybe$Just(55);
            case 320:
                return $elm$core$Maybe$Just(55);
            case 187:
                return $elm$core$Maybe$Just(55);
            case 246:
                return $elm$core$Maybe$Just(55);
            case 284:
                return $elm$core$Maybe$Just(55);
            case 189:
                return $elm$core$Maybe$Just(55);
            case 247:
                return $elm$core$Maybe$Just(55);
            case 287:
                return $elm$core$Maybe$Just(55);
            default:
                return $elm$core$Maybe$Just(55);
        }
    };
    var $author$project$Permission$homeStateMappingFor = function(role) {
        switch(role){
            case 'practice_admin':
                return $author$project$Spa$Generated$Route$Patients__Top;
            case 'practice_manager':
                return $author$project$Spa$Generated$Route$Patients__Top;
            case 'practice_staff':
                return $author$project$Spa$Generated$Route$Patients__Top;
            case 'practice_staff_limited':
                return $author$project$Spa$Generated$Route$Patients__Top;
            case 'practice_reports_only':
                return $author$project$Spa$Generated$Route$Reports__Dashboard;
            case 'practice_read_only':
                return $author$project$Spa$Generated$Route$Patients__Top;
            case 'practice_practice_billing_only':
                return $author$project$Spa$Generated$Route$Admin__Billing;
            default:
                return $author$project$Spa$Generated$Route$Patients__Top;
        }
    };
    var $author$project$Api$Platform$Organization$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Platform$Organization$Shared$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Organization$Min$id(min);
    };
    var $author$project$Api$Platform$User$Shared$requiresMfa = function(_v0) {
        var record = _v0;
        return record.YL;
    };
    var $author$project$Api$Platform$Session$One$role = function(_v0) {
        var record = _v0;
        return record.ag_;
    };
    var $author$project$Permission$homeStateFor = F2(function(session, hinterViewOff) {
        var _v0 = $author$project$Api$Platform$Session$One$organization(session);
        if (_v0.$ === 1) {
            var requiresMfa = $author$project$Api$Platform$User$Shared$requiresMfa($author$project$Api$Platform$Session$One$user(session));
            return requiresMfa ? $author$project$Spa$Generated$Route$User__Mfa : $author$project$Spa$Generated$Route$User__Profile;
        } else {
            var organization = _v0.a;
            var _v1 = $author$project$Api$Platform$Organization$Shared$type_(organization);
            switch(_v1){
                case 0:
                    return !$author$project$Api$Platform$Organization$Shared$type_(organization) && !$author$project$Api$Platform$Organization$Shared$onboarded(organization) && A2($author$project$Utils$User$viewingAsNonHinter, session, hinterViewOff) ? $author$project$Spa$Generated$Route$Onboarding : !$author$project$Api$Platform$Organization$Shared$type_(organization) && $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding(organization) ? $author$project$Spa$Generated$Route$Patients__Top : !$author$project$Api$Platform$Organization$Shared$type_(organization) ? $author$project$Permission$homeStateMappingFor($author$project$Api$Platform$Session$One$role(session)) : $author$project$Spa$Generated$Route$NotFound;
                case 1:
                    return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                        fl: $author$project$Api$Platform$Organization$Shared$id(organization)
                    });
                default:
                    return $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
            }
        }
    });
    var $author$project$Permission$authorizeRoute = F3(function(session, hinterViewOff, route) {
        var code = $author$project$Permission$forRoute(route);
        return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, A2($author$project$Permission$canGoTo, session, hinterViewOff), code)) || _Utils_eq(A2($author$project$Permission$homeStateFor, session, hinterViewOff), route);
    });
    var $author$project$Spa$Page$authorizeUrl = F3(function(session, hinterViewOff, url) {
        return A3($author$project$Permission$authorizeRoute, session, hinterViewOff, $author$project$Utils$Route$fromUrl(url));
    });
    var $author$project$Utils$Tuple3$fromTuple2 = F2(function(third_, _v0) {
        var first_ = _v0.a;
        var second_ = _v0.b;
        return _Utils_Tuple3(first_, second_, third_);
    });
    var $elm$core$Tuple$mapFirst = F2(function(func, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(func(x), y);
    });
    var $author$project$Utils$Tuple3$mapFirst = F2(function(mapFunc, _v0) {
        var first_ = _v0.a;
        var second_ = _v0.b;
        var third_ = _v0.c;
        return _Utils_Tuple3(mapFunc(first_), second_, third_);
    });
    var $elm$url$Url$Builder$QueryParameter = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$url$Url$percentEncode = _Url_percentEncode;
    var $elm$url$Url$Builder$string = F2(function(key, value) {
        return A2($elm$url$Url$Builder$QueryParameter, $elm$url$Url$percentEncode(key), $elm$url$Url$percentEncode(value));
    });
    var $author$project$Utils$Route$toString = F2(function(params, route) {
        var queryString = $elm$url$Url$Builder$toQuery(A2($elm$core$List$map, function(_v0) {
            var k = _v0.a;
            var v = _v0.b;
            return A2($elm$url$Url$Builder$string, k, v);
        }, $elm$core$Dict$toList(params)));
        return _Utils_ap($author$project$Spa$Generated$Route$toString(route), queryString);
    });
    var $author$project$Utils$Route$navigate = F2(function(params, route) {
        return $author$project$Ports$Navigation$pushUrl(A2($author$project$Utils$Route$toString, params, route));
    });
    var $elm$core$Platform$Sub$batch = _Platform_batch;
    var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
    var $author$project$Components$BlankPage$view = _List_Nil;
    var $author$project$Spa$Page$applicationPractice = function(page) {
        return {
            aeq: F2(function(shared, url) {
                var _v0 = _Utils_Tuple2(shared.Z$, shared.W1);
                _v0$3: while(true){
                    _v0$5: while(true)switch(_v0.a.$){
                        case 3:
                            switch(_v0.b.$){
                                case 3:
                                    if (!_v0.b.a.$) {
                                        var _v1 = _v0.a;
                                        var session = _v1.a;
                                        var _v2 = _v0.b;
                                        var practice = _v2.a.a;
                                        return !A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil) : A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4(page.aeq, session, practice, shared, url)));
                                    } else {
                                        var _v3 = _v0.a;
                                        var session = _v3.a;
                                        var _v4 = _v0.b;
                                        return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                    }
                                case 2:
                                    break _v0$3;
                                default:
                                    break _v0$5;
                            }
                        case 2:
                            return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 0:
                            if (_v0.b.$ === 2) break _v0$3;
                            else {
                                var _v5 = _v0.a;
                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $author$project$Ports$Session$authorize({
                                    agy: true
                                }), _List_Nil);
                            }
                        default:
                            if (_v0.b.$ === 2) break _v0$3;
                            else break _v0$5;
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aeR: F2(function(shared, model) {
                var _v6 = _Utils_Tuple3(shared.Z$, shared.W1, model);
                _v6$1: while(true){
                    _v6$3: while(true){
                        _v6$4: while(true)if (!_v6.c.$) switch(_v6.a.$){
                            case 3:
                                switch(_v6.b.$){
                                    case 3:
                                        if (!_v6.b.a.$) {
                                            var _v7 = _v6.a;
                                            var session = _v7.a;
                                            var _v8 = _v6.b;
                                            var practice = _v8.a.a;
                                            var url = _v6.c.a;
                                            if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT)) return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                            else {
                                                var _v9 = A4(page.aeq, session, practice, shared, url);
                                                var pageModel = _v9.a;
                                                var cmd = _v9.b;
                                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoaded(pageModel), cmd, _List_Nil);
                                            }
                                        } else break _v6$1;
                                    case 2:
                                        break _v6$3;
                                    default:
                                        break _v6$4;
                                }
                            case 2:
                                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                            default:
                                if (_v6.b.$ === 2) break _v6$3;
                                else break _v6$4;
                        }
                        else {
                            if (_v6.a.$ === 3 && _v6.b.$ === 3 && _v6.b.a.$ === 1) break _v6$1;
                            else break _v6$4;
                        }
                        if (model.$ === 1) {
                            var modelWithSession = model.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aeR, shared, _Utils_update(modelWithSession, {
                                Ej: shared.Ej
                            }))));
                        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                var _v10 = _v6.a;
                var session = _v10.a;
                var _v11 = _v6.b;
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
            }),
            ag3: F2(function(model, shared) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2(page.ag3, modelWithSession, shared);
                } else return shared;
            }),
            ahE: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.ahE(modelWithSession);
                } else return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(msg, model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aaO, msg, modelWithSession));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.aid(modelWithSession);
                } else return {
                    fb: $author$project$Components$BlankPage$view,
                    $2: 'Loading...'
                };
            }
        };
    };
    var $author$project$Pages$Admin$AdvanceBilling$GotNotificationSetting = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Utils$User$isViewingAsHinter = F2(function(session, hinterViewOff) {
        return A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$isAdmin)(session) && !hinterViewOff;
    });
    var $author$project$Shared$isHintAdmin = function(model) {
        var _v0 = model.Z$;
        if (_v0.$ === 3) {
            var session = _v0.a;
            return A2($author$project$Utils$User$isViewingAsHinter, session, model.aeb);
        } else return false;
    };
    var $author$project$Api$Provider$NotificationSetting$One$NotificationSetting = $elm$core$Basics$identity;
    var $author$project$Api$Provider$NotificationSetting$Shared$NotificationSetting = $elm$core$Basics$identity;
    var $author$project$Api$Provider$NotificationSetting$Shared$Record = function(id) {
        return function(shortDescriptionHtml) {
            return function(description) {
                return function(disableable) {
                    return function(enabled) {
                        return function(customEnabled) {
                            return function(subject) {
                                return function(body) {
                                    return function(subjectExample) {
                                        return function(bodyExample) {
                                            return function(availableLiquidVariables) {
                                                return function(meta) {
                                                    return function(isTranslatable) {
                                                        return {
                                                            J_: availableLiquidVariables,
                                                            fb: body,
                                                            Kk: bodyExample,
                                                            MT: customEnabled,
                                                            NQ: description,
                                                            N_: disableable,
                                                            OM: enabled,
                                                            aef: id,
                                                            Sw: isTranslatable,
                                                            Ue: meta,
                                                            Z8: shortDescriptionHtml,
                                                            HF: subject,
                                                            $o: subjectExample
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$HtmlTemplate$HtmlTemplate = $elm$core$Basics$identity;
    var $author$project$Api$HtmlTemplate$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$NotificationSetting$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$NotificationSetting$Meta$MetaRecord = function(body) {
        return {
            fb: body
        };
    };
    var $author$project$Api$Provider$NotificationSetting$Meta$EditableRecord = function(editable) {
        return {
            Ot: editable
        };
    };
    var $author$project$Api$Provider$NotificationSetting$Meta$editableRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Meta$EditableRecord));
    var $author$project$Api$Provider$NotificationSetting$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'body', $author$project$Api$Provider$NotificationSetting$Meta$editableRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Meta$MetaRecord));
    var $author$project$Api$Provider$NotificationSetting$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$NotificationSetting$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$NotificationSetting$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_translatable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$NotificationSetting$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'available_liquid_variables', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'body_example', $author$project$Api$HtmlTemplate$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subject_example', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'body', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subject', $elm$json$Json$Decode$string, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'custom_enabled', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enabled', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'disableable', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'short_description_html', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSetting$Shared$Record))))))))))))));
    var $author$project$Api$Provider$NotificationSetting$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$NotificationSetting$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$NotificationSetting$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$NotificationSetting$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$NotificationSetting$notificationSettingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'notification_settings'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$NotificationSetting$notificationSettingPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$NotificationSetting$notificationSettingsPath);
    };
    var $author$project$Api$Param$boolToString = function(bool_) {
        return A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$bool(bool_));
    };
    var $justinmimbs$date$Date$isLeapYear = function(y) {
        return !A2($elm$core$Basics$modBy, 4, y) && !!A2($elm$core$Basics$modBy, 100, y) || !A2($elm$core$Basics$modBy, 400, y);
    };
    var $justinmimbs$date$Date$daysInMonth = F2(function(y, m) {
        switch(m){
            case 0:
                return 31;
            case 1:
                return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    });
    var $justinmimbs$date$Date$monthToNumber = function(m) {
        switch(m){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            case 6:
                return 7;
            case 7:
                return 8;
            case 8:
                return 9;
            case 9:
                return 10;
            case 10:
                return 11;
            default:
                return 12;
        }
    };
    var $justinmimbs$date$Date$numberToMonth = function(mn) {
        var _v0 = A2($elm$core$Basics$max, 1, mn);
        switch(_v0){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            case 7:
                return 6;
            case 8:
                return 7;
            case 9:
                return 8;
            case 10:
                return 9;
            case 11:
                return 10;
            default:
                return 11;
        }
    };
    var $justinmimbs$date$Date$toCalendarDateHelp = F3(function(y, m, d) {
        toCalendarDateHelp: while(true){
            var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
            var mn = $justinmimbs$date$Date$monthToNumber(m);
            if (mn < 12 && _Utils_cmp(d, monthDays) > 0) {
                var $temp$y = y, $temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1), $temp$d = d - monthDays;
                y = $temp$y;
                m = $temp$m;
                d = $temp$d;
                continue toCalendarDateHelp;
            } else return {
                acP: d,
                ae6: m,
                ail: y
            };
        }
    });
    var $justinmimbs$date$Date$floorDiv = F2(function(a, b) {
        return $elm$core$Basics$floor(a / b);
    });
    var $justinmimbs$date$Date$daysBeforeYear = function(y1) {
        var y = y1 - 1;
        var leapYears = A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100) + A2($justinmimbs$date$Date$floorDiv, y, 400);
        return 365 * y + leapYears;
    };
    var $justinmimbs$date$Date$divWithRemainder = F2(function(a, b) {
        return _Utils_Tuple2(A2($justinmimbs$date$Date$floorDiv, a, b), A2($elm$core$Basics$modBy, b, a));
    });
    var $justinmimbs$date$Date$year = function(_v0) {
        var rd = _v0;
        var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
        var n400 = _v1.a;
        var r400 = _v1.b;
        var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
        var n100 = _v2.a;
        var r100 = _v2.b;
        var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
        var n4 = _v3.a;
        var r4 = _v3.b;
        var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
        var n1 = _v4.a;
        var r1 = _v4.b;
        var n = !r1 ? 0 : 1;
        return n400 * 400 + n100 * 100 + n4 * 4 + n1 + n;
    };
    var $justinmimbs$date$Date$toOrdinalDate = function(_v0) {
        var rd = _v0;
        var y = $justinmimbs$date$Date$year(rd);
        return {
            GH: rd - $justinmimbs$date$Date$daysBeforeYear(y),
            ail: y
        };
    };
    var $justinmimbs$date$Date$toCalendarDate = function(_v0) {
        var rd = _v0;
        var date = $justinmimbs$date$Date$toOrdinalDate(rd);
        return A3($justinmimbs$date$Date$toCalendarDateHelp, date.ail, 0, date.GH);
    };
    var $justinmimbs$date$Date$day = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toCalendarDate, function($) {
        return $.acP;
    });
    var $justinmimbs$date$Date$month = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toCalendarDate, function($) {
        return $.ae6;
    });
    var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
    var $justinmimbs$date$Date$ordinalDay = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toOrdinalDate, function($) {
        return $.GH;
    });
    var $justinmimbs$date$Date$padSignedInt = F2(function(length, _int) {
        return _Utils_ap(_int < 0 ? '-' : '', A3($elm$core$String$padLeft, length, '0', $elm$core$String$fromInt($elm$core$Basics$abs(_int))));
    });
    var $justinmimbs$date$Date$monthToQuarter = function(m) {
        return ($justinmimbs$date$Date$monthToNumber(m) + 2) / 3 | 0;
    };
    var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
    var $justinmimbs$date$Date$weekdayNumber = function(_v0) {
        var rd = _v0;
        var _v1 = A2($elm$core$Basics$modBy, 7, rd);
        if (!_v1) return 7;
        else {
            var n = _v1;
            return n;
        }
    };
    var $justinmimbs$date$Date$daysBeforeWeekYear = function(y) {
        var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
        return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
    };
    var $justinmimbs$date$Date$numberToWeekday = function(wdn) {
        var _v0 = A2($elm$core$Basics$max, 1, wdn);
        switch(_v0){
            case 1:
                return 0;
            case 2:
                return 1;
            case 3:
                return 2;
            case 4:
                return 3;
            case 5:
                return 4;
            case 6:
                return 5;
            default:
                return 6;
        }
    };
    var $justinmimbs$date$Date$toWeekDate = function(_v0) {
        var rd = _v0;
        var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
        var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
        var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
        return {
            abo: 1 + ((rd - week1Day1) / 7 | 0),
            abp: wy,
            aig: $justinmimbs$date$Date$numberToWeekday(wdn)
        };
    };
    var $justinmimbs$date$Date$weekNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toWeekDate, function($) {
        return $.abo;
    });
    var $justinmimbs$date$Date$weekYear = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$toWeekDate, function($) {
        return $.abp;
    });
    var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
    var $elm$core$Basics$min = F2(function(x, y) {
        return _Utils_cmp(x, y) < 0 ? x : y;
    });
    var $justinmimbs$date$Date$ordinalSuffix = function(n) {
        var nn = A2($elm$core$Basics$modBy, 100, n);
        var _v0 = A2($elm$core$Basics$min, nn < 20 ? nn : A2($elm$core$Basics$modBy, 10, nn), 4);
        switch(_v0){
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    };
    var $justinmimbs$date$Date$withOrdinalSuffix = function(n) {
        return _Utils_ap($elm$core$String$fromInt(n), $justinmimbs$date$Date$ordinalSuffix(n));
    };
    var $justinmimbs$date$Date$formatField = F4(function(language, _char, length, date) {
        switch(_char){
            case 'y':
                if (length === 2) return A2($elm$core$String$right, 2, A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$year(date))));
                else return A2($justinmimbs$date$Date$padSignedInt, length, $justinmimbs$date$Date$year(date));
            case 'Y':
                if (length === 2) return A2($elm$core$String$right, 2, A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$weekYear(date))));
                else return A2($justinmimbs$date$Date$padSignedInt, length, $justinmimbs$date$Date$weekYear(date));
            case 'Q':
                switch(length){
                    case 1:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$quarter(date));
                    case 2:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$quarter(date));
                    case 3:
                        return 'Q' + $elm$core$String$fromInt($justinmimbs$date$Date$quarter(date));
                    case 4:
                        return $justinmimbs$date$Date$withOrdinalSuffix($justinmimbs$date$Date$quarter(date));
                    case 5:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$quarter(date));
                    default:
                        return '';
                }
            case 'M':
                switch(length){
                    case 1:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$monthNumber(date));
                    case 2:
                        return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$monthNumber(date)));
                    case 3:
                        return language.zn($justinmimbs$date$Date$month(date));
                    case 4:
                        return language.Uz($justinmimbs$date$Date$month(date));
                    case 5:
                        return A2($elm$core$String$left, 1, language.zn($justinmimbs$date$Date$month(date)));
                    default:
                        return '';
                }
            case 'w':
                switch(length){
                    case 1:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$weekNumber(date));
                    case 2:
                        return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$weekNumber(date)));
                    default:
                        return '';
                }
            case 'd':
                switch(length){
                    case 1:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$day(date));
                    case 2:
                        return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$day(date)));
                    case 3:
                        return language.E9($justinmimbs$date$Date$day(date));
                    default:
                        return '';
                }
            case 'D':
                switch(length){
                    case 1:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$ordinalDay(date));
                    case 2:
                        return A3($elm$core$String$padLeft, 2, '0', $elm$core$String$fromInt($justinmimbs$date$Date$ordinalDay(date)));
                    case 3:
                        return A3($elm$core$String$padLeft, 3, '0', $elm$core$String$fromInt($justinmimbs$date$Date$ordinalDay(date)));
                    default:
                        return '';
                }
            case 'E':
                switch(length){
                    case 1:
                        return language.kO($justinmimbs$date$Date$weekday(date));
                    case 2:
                        return language.kO($justinmimbs$date$Date$weekday(date));
                    case 3:
                        return language.kO($justinmimbs$date$Date$weekday(date));
                    case 4:
                        return language.H6($justinmimbs$date$Date$weekday(date));
                    case 5:
                        return A2($elm$core$String$left, 1, language.kO($justinmimbs$date$Date$weekday(date)));
                    case 6:
                        return A2($elm$core$String$left, 2, language.kO($justinmimbs$date$Date$weekday(date)));
                    default:
                        return '';
                }
            case 'e':
                switch(length){
                    case 1:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$weekdayNumber(date));
                    case 2:
                        return $elm$core$String$fromInt($justinmimbs$date$Date$weekdayNumber(date));
                    default:
                        return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
                }
            default:
                return '';
        }
    });
    var $justinmimbs$date$Date$formatWithTokens = F3(function(language, tokens, date) {
        return A3($elm$core$List$foldl, F2(function(token, formatted) {
            if (!token.$) {
                var _char = token.a;
                var length = token.b;
                return _Utils_ap(A4($justinmimbs$date$Date$formatField, language, _char, length, date), formatted);
            } else {
                var str = token.a;
                return _Utils_ap(str, formatted);
            }
        }), '', tokens);
    });
    var $justinmimbs$date$Pattern$Literal = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$parser$Parser$Expecting = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$parser$Parser$toToken = function(str) {
        return A2($elm$parser$Parser$Advanced$Token, str, $elm$parser$Parser$Expecting(str));
    };
    var $elm$parser$Parser$token = function(str) {
        return $elm$parser$Parser$Advanced$token($elm$parser$Parser$toToken(str));
    };
    var $justinmimbs$date$Pattern$escapedQuote = A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal('\'')), $elm$parser$Parser$token('\'\''));
    var $justinmimbs$date$Pattern$Field = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$parser$Parser$Advanced$getOffset = function(s) {
        return A3($elm$parser$Parser$Advanced$Good, false, s.f, s);
    };
    var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
    var $justinmimbs$date$Pattern$fieldRepeats = function(str) {
        var _v0 = $elm$core$String$toList(str);
        if (_v0.b && !_v0.b.b) {
            var _char = _v0.a;
            return A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed(F2(function(x, y) {
                return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
            })), A2($elm$parser$Parser$ignorer, $elm$parser$Parser$getOffset, $elm$parser$Parser$chompWhile($elm$core$Basics$eq(_char)))), $elm$parser$Parser$getOffset);
        } else return $elm$parser$Parser$problem('expected exactly one char');
    };
    var $justinmimbs$date$Pattern$field = A2($elm$parser$Parser$andThen, $justinmimbs$date$Pattern$fieldRepeats, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
    var $justinmimbs$date$Pattern$finalize = A2($elm$core$List$foldl, F2(function(token, tokens) {
        var _v0 = _Utils_Tuple2(token, tokens);
        if (_v0.a.$ === 1 && _v0.b.b && _v0.b.a.$ === 1) {
            var x = _v0.a.a;
            var _v1 = _v0.b;
            var y = _v1.a.a;
            var rest = _v1.b;
            return A2($elm$core$List$cons, $justinmimbs$date$Pattern$Literal(_Utils_ap(x, y)), rest);
        } else return A2($elm$core$List$cons, token, tokens);
    }), _List_Nil);
    var $elm$parser$Parser$Advanced$lazy = function(thunk) {
        return function(s) {
            var _v0 = thunk(0);
            var parse = _v0;
            return parse(s);
        };
    };
    var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
    var $justinmimbs$date$Pattern$isLiteralChar = function(_char) {
        return _char !== '\'' && !$elm$core$Char$isAlpha(_char);
    };
    var $justinmimbs$date$Pattern$literal = A2($elm$parser$Parser$map, $justinmimbs$date$Pattern$Literal, $elm$parser$Parser$getChompedString(A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)), $elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
    var $justinmimbs$date$Pattern$quotedHelp = function(result) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$andThen, function(str) {
                return $justinmimbs$date$Pattern$quotedHelp(_Utils_ap(result, str));
            }, $elm$parser$Parser$getChompedString(A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($elm$core$Basics$neq('\''))), $elm$parser$Parser$chompWhile($elm$core$Basics$neq('\''))))),
            A2($elm$parser$Parser$andThen, function(_v0) {
                return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
            }, $elm$parser$Parser$token('\'\'')),
            $elm$parser$Parser$succeed(result)
        ]));
    };
    var $justinmimbs$date$Pattern$quoted = A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal), $elm$parser$Parser$chompIf($elm$core$Basics$eq('\''))), A2($elm$parser$Parser$ignorer, $justinmimbs$date$Pattern$quotedHelp(''), $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$chompIf($elm$core$Basics$eq('\'')),
        $elm$parser$Parser$end
    ]))));
    var $justinmimbs$date$Pattern$patternHelp = function(tokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$andThen, function(token) {
                return $justinmimbs$date$Pattern$patternHelp(A2($elm$core$List$cons, token, tokens));
            }, $elm$parser$Parser$oneOf(_List_fromArray([
                $justinmimbs$date$Pattern$field,
                $justinmimbs$date$Pattern$literal,
                $justinmimbs$date$Pattern$escapedQuote,
                $justinmimbs$date$Pattern$quoted
            ]))),
            $elm$parser$Parser$lazy(function(_v0) {
                return $elm$parser$Parser$succeed($justinmimbs$date$Pattern$finalize(tokens));
            })
        ]));
    };
    var $elm$core$Result$withDefault = F2(function(def, result) {
        if (!result.$) {
            var a = result.a;
            return a;
        } else return def;
    });
    var $justinmimbs$date$Pattern$fromString = function(str) {
        return A2($elm$core$Result$withDefault, _List_fromArray([
            $justinmimbs$date$Pattern$Literal(str)
        ]), A2($elm$parser$Parser$run, $justinmimbs$date$Pattern$patternHelp(_List_Nil), str));
    };
    var $justinmimbs$date$Date$formatWithLanguage = F2(function(language, pattern) {
        var tokens = $elm$core$List$reverse($justinmimbs$date$Pattern$fromString(pattern));
        return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
    });
    var $justinmimbs$date$Date$monthToName = function(m) {
        switch(m){
            case 0:
                return 'January';
            case 1:
                return 'February';
            case 2:
                return 'March';
            case 3:
                return 'April';
            case 4:
                return 'May';
            case 5:
                return 'June';
            case 6:
                return 'July';
            case 7:
                return 'August';
            case 8:
                return 'September';
            case 9:
                return 'October';
            case 10:
                return 'November';
            default:
                return 'December';
        }
    };
    var $justinmimbs$date$Date$weekdayToName = function(wd) {
        switch(wd){
            case 0:
                return 'Monday';
            case 1:
                return 'Tuesday';
            case 2:
                return 'Wednesday';
            case 3:
                return 'Thursday';
            case 4:
                return 'Friday';
            case 5:
                return 'Saturday';
            default:
                return 'Sunday';
        }
    };
    var $justinmimbs$date$Date$language_en = {
        E9: $justinmimbs$date$Date$withOrdinalSuffix,
        Uz: $justinmimbs$date$Date$monthToName,
        zn: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$monthToName, $elm$core$String$left(3)),
        H6: $justinmimbs$date$Date$weekdayToName,
        kO: A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayToName, $elm$core$String$left(3))
    };
    var $justinmimbs$date$Date$format = function(pattern) {
        return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
    };
    var $author$project$Utils$Date$toQuery = function(date) {
        return A2($justinmimbs$date$Date$format, 'yyyy-MM-dd', date);
    };
    var $author$project$Api$Param$toQuery = function(param) {
        switch(param.$){
            case 0:
                var key = param.a;
                var string_ = param.b;
                return _List_fromArray([
                    A2($elm$url$Url$Builder$string, key, string_)
                ]);
            case 1:
                var key = param.a;
                var bool_ = param.b;
                return _List_fromArray([
                    A2($elm$url$Url$Builder$string, key, $author$project$Api$Param$boolToString(bool_))
                ]);
            case 2:
                var key = param.a;
                var date_ = param.b;
                return _List_fromArray([
                    A2($elm$url$Url$Builder$string, key, $author$project$Utils$Date$toQuery(date_))
                ]);
            default:
                var key = param.a;
                var list_ = param.b;
                return $elm$core$List$length(list_) > 1 ? A2($elm$core$List$map, function(string_) {
                    return A2($elm$url$Url$Builder$string, key + '[]', string_);
                }, list_) : A2($elm$core$List$map, function(string_) {
                    return A2($elm$url$Url$Builder$string, key, string_);
                }, list_);
        }
    };
    var $author$project$Api$Data$requestWithQuery = F2(function(params, _v0) {
        var request = _v0;
        return _Utils_update(request, {
            Bz: _Utils_ap(request.Bz, A2($elm$core$List$concatMap, $author$project$Api$Param$toQuery, params))
        });
    });
    var $author$project$Api$Param$String = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Param$string = $author$project$Api$Param$String;
    var $author$project$Language$toValue = function(lang) {
        if (!lang) return 'en';
        else return 'es';
    };
    var $author$project$Api$Provider$NotificationSetting$retrieve = F4(function(apiClient, id_, maybeLanguage, toMsg) {
        var query = function() {
            if (!maybeLanguage.$) {
                var language = maybeLanguage.a;
                return _List_fromArray([
                    A2($author$project$Api$Param$string, 'language', $author$project$Language$toValue(language))
                ]);
            } else return _List_Nil;
        }();
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$NotificationSetting$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, query, $author$project$Api$Data$requestTo($author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
    });
    var $author$project$Pages$Admin$AdvanceBilling$init = F4(function(_v0, practice, shared, _v1) {
        var notificationSettingIds = _List_fromArray([
            'patient_upcoming_monthly_autopay_invoice_generated',
            'patient_upcoming_non_monthly_autopay_invoice_generated',
            'patient_upcoming_monthly_non_autopay_invoice_generated',
            'patient_upcoming_non_monthly_non_autopay_invoice_generated'
        ]);
        return _Utils_Tuple2({
            Ej: shared.Ej,
            w: $elm$core$Maybe$Nothing,
            F3: $author$project$Shared$isHintAdmin(shared),
            bd: $elm$core$Dict$empty,
            W1: practice
        }, $elm$core$Platform$Cmd$batch(A2($elm$core$List$map, function(id) {
            return A4($author$project$Api$Provider$NotificationSetting$retrieve, shared.Ej, id, $elm$core$Maybe$Nothing, $author$project$Pages$Admin$AdvanceBilling$GotNotificationSetting(id));
        }, notificationSettingIds)));
    });
    var $author$project$Pages$Admin$AdvanceBilling$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$AdvanceBilling$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$AdvanceBilling$CancelEdit = {
        $: 1
    };
    var $author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $elm$core$Platform$Sub$map = _Platform_map;
    var $author$project$Ui$Modal$decodePressedKey = function(closeMsg) {
        return A2($elm$json$Json$Decode$andThen, function(key) {
            return key === 'Escape' ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
        }, A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
    };
    var $elm$browser$Browser$Events$Document = 0;
    var $elm$browser$Browser$Events$MySub = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $elm$browser$Browser$Events$State = F2(function(subs, pids) {
        return {
            WJ: pids,
            $q: subs
        };
    });
    var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
    var $elm$browser$Browser$Events$nodeToKey = function(node) {
        if (!node) return 'd_';
        else return 'w_';
    };
    var $elm$browser$Browser$Events$addKey = function(sub) {
        var node = sub.a;
        var name = sub.b;
        return _Utils_Tuple2(_Utils_ap($elm$browser$Browser$Events$nodeToKey(node), name), sub);
    };
    var $elm$core$Dict$foldl = F3(function(func, acc, dict) {
        foldl: while(true){
            if (dict.$ === -2) return acc;
            else {
                var key = dict.b;
                var value = dict.c;
                var left = dict.d;
                var right = dict.e;
                var $temp$func = func, $temp$acc = A3(func, key, value, A3($elm$core$Dict$foldl, func, acc, left)), $temp$dict = right;
                func = $temp$func;
                acc = $temp$acc;
                dict = $temp$dict;
                continue foldl;
            }
        }
    });
    var $elm$core$Dict$merge = F6(function(leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
        var stepState = F3(function(rKey, rValue, _v0) {
            stepState: while(true){
                var list = _v0.a;
                var result = _v0.b;
                if (!list.b) return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
                else {
                    var _v2 = list.a;
                    var lKey = _v2.a;
                    var lValue = _v2.b;
                    var rest = list.b;
                    if (_Utils_cmp(lKey, rKey) < 0) {
                        var $temp$rKey = rKey, $temp$rValue = rValue, $temp$_v0 = _Utils_Tuple2(rest, A3(leftStep, lKey, lValue, result));
                        rKey = $temp$rKey;
                        rValue = $temp$rValue;
                        _v0 = $temp$_v0;
                        continue stepState;
                    } else {
                        if (_Utils_cmp(lKey, rKey) > 0) return _Utils_Tuple2(list, A3(rightStep, rKey, rValue, result));
                        else return _Utils_Tuple2(rest, A4(bothStep, lKey, lValue, rValue, result));
                    }
                }
            }
        });
        var _v3 = A3($elm$core$Dict$foldl, stepState, _Utils_Tuple2($elm$core$Dict$toList(leftDict), initialResult), rightDict);
        var leftovers = _v3.a;
        var intermediateResult = _v3.b;
        return A3($elm$core$List$foldl, F2(function(_v4, result) {
            var k = _v4.a;
            var v = _v4.b;
            return A3(leftStep, k, v, result);
        }), intermediateResult, leftovers);
    });
    var $elm$browser$Browser$Events$Event = F2(function(key, event) {
        return {
            adu: event,
            yy: key
        };
    });
    var $elm$browser$Browser$Events$spawn = F3(function(router, key, _v0) {
        var node = _v0.a;
        var name = _v0.b;
        var actualNode = function() {
            if (!node) return _Browser_doc;
            else return _Browser_window;
        }();
        return A2($elm$core$Task$map, function(value) {
            return _Utils_Tuple2(key, value);
        }, A3(_Browser_on, actualNode, name, function(event) {
            return A2($elm$core$Platform$sendToSelf, router, A2($elm$browser$Browser$Events$Event, key, event));
        }));
    });
    var $elm$core$Dict$union = F2(function(t1, t2) {
        return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
    });
    var $elm$browser$Browser$Events$onEffects = F3(function(router, subs, state) {
        var stepRight = F3(function(key, sub, _v6) {
            var deads = _v6.a;
            var lives = _v6.b;
            var news = _v6.c;
            return _Utils_Tuple3(deads, lives, A2($elm$core$List$cons, A3($elm$browser$Browser$Events$spawn, router, key, sub), news));
        });
        var stepLeft = F3(function(_v4, pid, _v5) {
            var deads = _v5.a;
            var lives = _v5.b;
            var news = _v5.c;
            return _Utils_Tuple3(A2($elm$core$List$cons, pid, deads), lives, news);
        });
        var stepBoth = F4(function(key, pid, _v2, _v3) {
            var deads = _v3.a;
            var lives = _v3.b;
            var news = _v3.c;
            return _Utils_Tuple3(deads, A3($elm$core$Dict$insert, key, pid, lives), news);
        });
        var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
        var _v0 = A6($elm$core$Dict$merge, stepLeft, stepBoth, stepRight, state.WJ, $elm$core$Dict$fromList(newSubs), _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
        var deadPids = _v0.a;
        var livePids = _v0.b;
        var makeNewPids = _v0.c;
        return A2($elm$core$Task$andThen, function(pids) {
            return $elm$core$Task$succeed(A2($elm$browser$Browser$Events$State, newSubs, A2($elm$core$Dict$union, livePids, $elm$core$Dict$fromList(pids))));
        }, A2($elm$core$Task$andThen, function(_v1) {
            return $elm$core$Task$sequence(makeNewPids);
        }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
    });
    var $elm$browser$Browser$Events$onSelfMsg = F3(function(router, _v0, state) {
        var key = _v0.yy;
        var event = _v0.adu;
        var toMessage = function(_v2) {
            var subKey = _v2.a;
            var _v3 = _v2.b;
            var node = _v3.a;
            var name = _v3.b;
            var decoder = _v3.c;
            return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
        };
        var messages = A2($elm$core$List$filterMap, toMessage, state.$q);
        return A2($elm$core$Task$andThen, function(_v1) {
            return $elm$core$Task$succeed(state);
        }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$core$Platform$sendToApp(router), messages)));
    });
    var $elm$browser$Browser$Events$subMap = F2(function(func, _v0) {
        var node = _v0.a;
        var name = _v0.b;
        var decoder = _v0.c;
        return A3($elm$browser$Browser$Events$MySub, node, name, A2($elm$json$Json$Decode$map, func, decoder));
    });
    _Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
    var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
    var $elm$browser$Browser$Events$on = F3(function(node, name, decoder) {
        return $elm$browser$Browser$Events$subscription(A3($elm$browser$Browser$Events$MySub, node, name, decoder));
    });
    var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
    var $author$project$Ui$Modal$subscribeToEscapeKeyPress = function(closeMsg) {
        return $elm$browser$Browser$Events$onKeyDown($author$project$Ui$Modal$decodePressedKey(closeMsg));
    };
    var $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
    var $author$project$Components$Admin$NotificationSetting$Customize$Body = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$Close = {
        $: 1
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$Ignore = {
        $: 14
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId = function(notificationSetting) {
        return 'notification-editor' + $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting);
    };
    var $author$project$Ports$CKEditor$ckEditorOnChangePort = _Platform_incomingPort('ckEditorOnChangePort', A2($elm$json$Json$Decode$andThen, function(_v0) {
        return A2($elm$json$Json$Decode$andThen, function(_v1) {
            return $elm$json$Json$Decode$succeed(_Utils_Tuple2(_v0, _v1));
        }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
    var $author$project$Ports$CKEditor$onChange = function(toMsg) {
        return $author$project$Ports$CKEditor$ckEditorOnChangePort(function(_v0) {
            var elementId = _v0.a;
            var value = _v0.b;
            return A2(toMsg, elementId, value);
        });
    };
    var $author$project$Ui$Dropdown$BlurredOut = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$EscapeKeyPressed = {
        $: 4
    };
    var $author$project$Ports$Dropdown$onDropdownBlur = _Platform_incomingPort('onDropdownBlur', $elm$json$Json$Decode$string);
    var $author$project$Ports$Dropdown$onBlur = $author$project$Ports$Dropdown$onDropdownBlur;
    var $author$project$Ports$Dropdown$onDropdownEscapeKeyPressed = _Platform_incomingPort('onDropdownEscapeKeyPressed', $elm$json$Json$Decode$string);
    var $author$project$Ports$Dropdown$onEscapeKeyPressed = function(msg) {
        return $author$project$Ports$Dropdown$onDropdownEscapeKeyPressed($elm$core$Basics$always(msg));
    };
    var $author$project$Ui$Dropdown$subscriptions = function(model) {
        return model.Vw ? $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, model.ahX, $author$project$Ports$Dropdown$onEscapeKeyPressed($author$project$Ui$Dropdown$EscapeKeyPressed)),
            A2($elm$core$Platform$Sub$map, model.ahX, $author$project$Ports$Dropdown$onBlur($author$project$Ui$Dropdown$BlurredOut))
        ])) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$subscriptions = function(model) {
        if (model.Vw) {
            var notificationBodyEditorId_ = $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.U7);
            return $elm$core$Platform$Sub$batch(_List_fromArray([
                $author$project$Ports$CKEditor$onChange(F2(function(elementId, value) {
                    return _Utils_eq(elementId, notificationBodyEditorId_) ? A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$Customize$Body)(value) : $author$project$Components$Admin$NotificationSetting$Customize$Ignore;
                })),
                function() {
                    var _v0 = A2($elm$core$Maybe$map, function($) {
                        return $.Vw;
                    }, model.fD);
                    if (!_v0.$ && _v0.a) return $elm$core$Platform$Sub$none;
                    else return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$Customize$Close);
                }(),
                A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Ui$Dropdown$subscriptions, model.fD))
            ]));
        } else return $elm$core$Platform$Sub$none;
    };
    var $elm$core$Dict$values = function(dict) {
        return A3($elm$core$Dict$foldr, F3(function(key, value, valueList) {
            return A2($elm$core$List$cons, value, valueList);
        }), _List_Nil, dict);
    };
    var $author$project$Pages$Admin$AdvanceBilling$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $elm$core$Platform$Sub$batch(A2($elm$core$List$map, function(_v0) {
                var setting = _v0.a;
                var customize = _v0.b;
                return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(setting), $author$project$Components$Admin$NotificationSetting$Customize$subscriptions(customize));
            }, $elm$core$Dict$values(model.bd))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$AdvanceBilling$CancelEdit)), model.w))
        ]));
    };
    var $author$project$Api$Provider$Notification$PracticeContext = {
        $: 0
    };
    var $author$project$OutMsg$PracticeUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$OutMsg$ShowToast = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Toast$Success = 3;
    var $author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg = F3(function(a, b, c) {
        return {
            $: 7,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Provider$Practice$One$one = function(_v0) {
        var record = _v0.b;
        return record;
    };
    var $author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.abZ;
    });
    var $author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ab_;
    });
    var $author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ab$;
    });
    var $author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ab0;
    });
    var $author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ag4;
    });
    var $author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ag5;
    });
    var $author$project$Pages$Admin$AdvanceBilling$formFieldsInit = F3(function(type_, frequency, practice) {
        return {
            abZ: $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays(practice)),
            ab_: $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays(practice)),
            ab$: $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays(practice)),
            ab0: $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays(practice)),
            qK: frequency,
            ag4: $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays(practice)),
            ag5: $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays(practice)),
            ah5: type_
        };
    });
    var $author$project$Pages$Admin$AdvanceBilling$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    abZ: $elm$core$String$toInt(string)
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    ab$: $elm$core$String$toInt(string)
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    ab_: $elm$core$String$toInt(string)
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    ab0: $elm$core$String$toInt(string)
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    ag4: $elm$core$String$toInt(string)
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    ag5: $elm$core$String$toInt(string)
                });
        }
    });
    var $rtfeldman$elm_validate$Validate$Validator = $elm$core$Basics$identity;
    var $rtfeldman$elm_validate$Validate$all = function(validators) {
        var newGetErrors = function(subject) {
            var accumulateErrors = F2(function(_v0, totalErrors) {
                var getErrors = _v0;
                return _Utils_ap(totalErrors, getErrors(subject));
            });
            return A3($elm$core$List$foldl, accumulateErrors, _List_Nil, validators);
        };
        return newGetErrors;
    };
    var $rtfeldman$elm_validate$Validate$fromErrors = function(toErrors) {
        return toErrors;
    };
    var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDaysValidation = 0;
    var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDaysValidation = 1;
    var $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDaysValidation = 2;
    var $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDaysValidation = 3;
    var $author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays = F2(function(days, vaildationGroup) {
        if (!days.$) {
            var _int = days.a;
            return _int < 0 ? _List_fromArray([
                _Utils_Tuple2(vaildationGroup, 'Please enter a number greater or equal to 0')
            ]) : _int > 90 ? _List_fromArray([
                _Utils_Tuple2(vaildationGroup, 'Please enter a number lower or equal to 90')
            ]) : _List_Nil;
        } else return _List_fromArray([
            _Utils_Tuple2(vaildationGroup, 'Please enter a number')
        ]);
    });
    var $author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance = F3(function(createDays, scheduleDays, validationGroup) {
        var _v0 = _Utils_Tuple2(createDays, scheduleDays);
        if (!_v0.a.$ && !_v0.b.$) {
            var createDays_ = _v0.a.a;
            var scheduleDays_ = _v0.b.a;
            return _Utils_cmp(createDays_, scheduleDays_) < 1 ? _List_fromArray([
                _Utils_Tuple2(validationGroup, 'The number of days in create & notify needs to be greater than schedule payment in advance.')
            ]) : _List_Nil;
        } else return _List_Nil;
    });
    var $author$project$Pages$Admin$AdvanceBilling$validateAutopay = function(fields) {
        var _v0 = fields.qK;
        if (!_v0) return $elm$core$List$concat(_List_fromArray([
            A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.abZ, 0),
            A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.ag4, 2),
            A3($author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance, fields.abZ, fields.ag4, 2)
        ]));
        else return $elm$core$List$concat(_List_fromArray([
            A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.ab$, 1),
            A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.ag5, 3),
            A3($author$project$Pages$Admin$AdvanceBilling$validateSchedulePaymentInAdvance, fields.ab$, fields.ag5, 3)
        ]));
    };
    var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDaysValidation = 4;
    var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDaysValidation = 5;
    var $author$project$Pages$Admin$AdvanceBilling$validateNonAutopay = function(fields) {
        var _v0 = fields.qK;
        if (!_v0) return A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.ab_, 4);
        else return A2($author$project$Pages$Admin$AdvanceBilling$validateNumberOfDays, fields.ab0, 5);
    };
    var $author$project$Pages$Admin$AdvanceBilling$validateAdvanceBilling = function(fields) {
        var _v0 = fields.ah5;
        if (!_v0) return $author$project$Pages$Admin$AdvanceBilling$validateAutopay(fields);
        else return $author$project$Pages$Admin$AdvanceBilling$validateNonAutopay(fields);
    };
    var $author$project$Pages$Admin$AdvanceBilling$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$AdvanceBilling$validateAdvanceBilling)
    ]));
    var $author$project$Ui$Toast$Error = 1;
    var $author$project$OutMsg$GatewayError = {
        $: 19
    };
    var $author$project$OutMsg$SessionExpired = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$OutMsg$DecodeFailed = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$OutMsg$reportDecodeError = function(response) {
        if (response.$ === 2 && response.a.$ === 7) {
            var error = response.a.a;
            return _List_fromArray([
                $author$project$OutMsg$DecodeFailed(error)
            ]);
        } else return _List_Nil;
    };
    var $author$project$Ui$Toast$defaultError = 'An error occurred, please try again.';
    var $author$project$Ui$Toast$serverError = function(errorResponse) {
        switch(errorResponse.$){
            case 8:
                var errorMessage = errorResponse.a;
                return A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, errorMessage);
            case 6:
                var code = errorResponse.a;
                var errorMessage = errorResponse.b;
                return code >= 500 ? $author$project$Ui$Toast$defaultError : errorMessage;
            case 0:
                var errorMessage = errorResponse.a;
                return A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, errorMessage);
            default:
                return $author$project$Ui$Toast$defaultError;
        }
    };
    var $author$project$OutMsg$handleErrorResponse = function(response) {
        return _Utils_ap($author$project$OutMsg$reportDecodeError(response), function() {
            if (response.$ === 2) {
                var error = response.a;
                switch(error.$){
                    case 0:
                        return _List_fromArray([
                            $author$project$OutMsg$SessionExpired(error)
                        ]);
                    case 4:
                        return _List_fromArray([
                            $author$project$OutMsg$GatewayError,
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]);
                    default:
                        return _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]);
                }
            } else return _List_Nil;
        }());
    };
    var $author$project$Api$Provider$NotificationSetting$One$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$id(shared);
    };
    var $author$project$Components$Admin$NotificationSetting$Toggle$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$NotificationSetting$Toggle$init = F2(function(getters, notificationSetting) {
        return {
            OM: getters.OM(notificationSetting),
            xR: getters,
            U7: notificationSetting,
            su: $author$project$Api$Data$NotAsked
        };
    });
    var $author$project$Utils$Form$Form = F4(function(a, b, c, d) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Utils$Form$init = function(fields_) {
        return A4($author$project$Utils$Form$Form, fields_, false, fields_, _List_Nil);
    };
    var $author$project$Language$EN = 0;
    var $author$project$Language$english = 0;
    var $author$project$Api$Provider$NotificationSetting$Shared$body = function(_v0) {
        var record = _v0;
        return record.fb;
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$subject = function(_v0) {
        var record = _v0;
        return record.HF;
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$initFormFields = function(notificationSetting) {
        return {
            fb: $author$project$Api$Provider$NotificationSetting$Shared$body(notificationSetting),
            HF: $author$project$Api$Provider$NotificationSetting$Shared$subject(notificationSetting)
        };
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$init = F2(function(notificationSetting, context) {
        return {
            aC: context,
            fD: $elm$core$Maybe$Nothing,
            PU: $author$project$Utils$Form$init($author$project$Components$Admin$NotificationSetting$Customize$initFormFields(notificationSetting)),
            yC: $author$project$Language$english,
            ru: false,
            U7: notificationSetting,
            Vw: false,
            agk: $author$project$Api$Data$NotAsked,
            n8: false,
            os: false,
            kv: $author$project$Api$Data$NotAsked,
            aay: $elm$core$Dict$empty,
            DT: false
        };
    });
    var $author$project$Api$Provider$NotificationSetting$One$toShared = function(_v0) {
        var shared = _v0;
        return shared;
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$initFromOne = function(notificationSettingOne) {
        return A2($author$project$Components$Admin$NotificationSetting$Customize$init, $author$project$Api$Provider$NotificationSetting$One$toShared(notificationSettingOne), $author$project$Api$Provider$Notification$PracticeContext);
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$disableable = function(_v0) {
        var record = _v0;
        return record.N_;
    };
    var $author$project$Api$Provider$NotificationSetting$One$disableable = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$disableable(shared);
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$enabled = function(_v0) {
        var record = _v0;
        return record.OM;
    };
    var $author$project$Api$Provider$NotificationSetting$One$enabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$enabled(shared);
    };
    var $author$project$Components$Admin$NotificationSetting$Toggle$oneGetters = {
        N_: $author$project$Api$Provider$NotificationSetting$One$disableable,
        OM: $author$project$Api$Provider$NotificationSetting$One$enabled,
        aef: $author$project$Api$Provider$NotificationSetting$One$id
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$GotNotificationSetting = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$LanguageDropdownMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$None = 0;
    var $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingUpdated = 1;
    var $author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables = function(_v0) {
        var record = _v0;
        return record.J_;
    };
    var $author$project$Ui$Dropdown$DownRight = 0;
    var $author$project$Ui$Dropdown$defaultConfig = function(_v0) {
        var id = _v0.aef;
        var toMsg = _v0.ahX;
        return {
            a1: 0,
            aef: id,
            ahX: toMsg
        };
    };
    var $author$project$Utils$Form$fields = function(_v0) {
        var fields_ = _v0.c;
        return fields_;
    };
    var $author$project$Ui$Dropdown$init = function(_v0) {
        var id = _v0.aef;
        var direction = _v0.a1;
        var toMsg = _v0.ahX;
        return {
            a1: direction,
            aef: id,
            Vw: false,
            ahX: toMsg
        };
    };
    var $elm$json$Json$Encode$list = F2(function(func, entries) {
        return _Json_wrap(A3($elm$core$List$foldl, _Json_addEntry(func), _Json_emptyArray(0), entries));
    });
    var $author$project$Ports$CKEditor$ckEditorSetDataPort = _Platform_outgoingPort('ckEditorSetDataPort', function($) {
        var a = $.a;
        var b = $.b;
        return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([
            $elm$json$Json$Encode$string(a),
            $elm$json$Json$Encode$string(b)
        ]));
    });
    var $author$project$Ports$CKEditor$setData = F2(function(elementId, value) {
        return $author$project$Ports$CKEditor$ckEditorSetDataPort(_Utils_Tuple2(elementId, value));
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$initForm = function(setting) {
        var body = $author$project$Api$Provider$NotificationSetting$Shared$body(setting);
        return _Utils_Tuple2($author$project$Utils$Form$init({
            fb: body,
            HF: $author$project$Api$Provider$NotificationSetting$Shared$subject(setting)
        }), A2($author$project$Ports$CKEditor$setData, $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(setting), body));
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable = function(_v0) {
        var record = _v0;
        return record.Sw;
    };
    var $author$project$Api$Data$map = F2(function(func, dataList) {
        switch(dataList.$){
            case 3:
                var value = dataList.a;
                var headers = dataList.b;
                return A2($author$project$Api$Data$Success, func(value), headers);
            case 0:
                return $author$project$Api$Data$NotAsked;
            case 1:
                return $author$project$Api$Data$Loading;
            default:
                var error = dataList.a;
                return $author$project$Api$Data$Failure(error);
        }
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                HF: string
            });
        } else {
            var string = field.a;
            return _Utils_update(fields, {
                fb: string
            });
        }
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
    var $author$project$Components$Admin$NotificationSetting$Customize$GotPreview = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $rtfeldman$elm_validate$Validate$fromValid = function(_v0) {
        var subject = _v0;
        return subject;
    };
    var $author$project$Api$Provider$NotificationSettingPreview$NotificationSettingPreview = $elm$core$Basics$identity;
    var $author$project$Api$Provider$NotificationSettingPreview$Record = F2(function(subject, body) {
        return {
            fb: body,
            HF: subject
        };
    });
    var $author$project$Api$Provider$NotificationSettingPreview$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'body', $author$project$Api$HtmlTemplate$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subject', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$NotificationSettingPreview$Record)));
    var $author$project$Api$Provider$NotificationSettingPreview$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$NotificationSettingPreview$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$companiesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'companies'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Company$companyPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            companyId
        ]), $author$project$Api$Provider$Company$companiesPath);
    };
    var $author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'notification_settings'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath = F2(function(companyId, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath(companyId));
    });
    var $author$project$Api$Data$Json = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Data$requestWithJson = F2(function(json, _v0) {
        var request = _v0;
        return _Utils_update(request, {
            fb: $elm$core$Maybe$Just($author$project$Api$Data$Json(json))
        });
    });
    var $author$project$Api$Provider$Company$NotificationSetting$preview = F5(function(apiClient, companyId, id_, fields, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification_setting', $elm$json$Json$Encode$object(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                A2($elm$core$Maybe$map, function(subject) {
                    return _Utils_Tuple2('subject', $elm$json$Json$Encode$string(subject));
                }, fields.HF),
                A2($elm$core$Maybe$map, function(body) {
                    return _Utils_Tuple2('body', $elm$json$Json$Encode$string(body));
                }, fields.fb)
            ])))),
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.yC)))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$NotificationSettingPreview$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'preview'
        ]), A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
    });
    var $author$project$Api$Provider$NotificationSetting$preview = F4(function(apiClient, id_, fields, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification_setting', $elm$json$Json$Encode$object(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                A2($elm$core$Maybe$map, function(subject) {
                    return _Utils_Tuple2('subject', $elm$json$Json$Encode$string(subject));
                }, fields.HF),
                A2($elm$core$Maybe$map, function(body) {
                    return _Utils_Tuple2('body', $elm$json$Json$Encode$string(body));
                }, fields.fb)
            ])))),
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.yC)))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$NotificationSettingPreview$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'preview'
        ]), $author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$previewNotificationSetting = F3(function(apiClient, formFields, _v0) {
        var context = _v0.aC;
        var language = _v0.yC;
        var notificationSetting = _v0.U7;
        var _v1 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var subject = _v1.HF;
        var body = _v1.fb;
        if (context.$ === 1) {
            var id = context.a;
            return A5($author$project$Api$Provider$Company$NotificationSetting$preview, apiClient, id, $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting), {
                fb: $elm$core$Maybe$Just(body),
                yC: language,
                HF: $elm$core$Maybe$Just(subject)
            }, $author$project$Components$Admin$NotificationSetting$Customize$GotPreview);
        } else return A4($author$project$Api$Provider$NotificationSetting$preview, apiClient, $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting), {
            fb: $elm$core$Maybe$Just(body),
            yC: language,
            HF: $elm$core$Maybe$Just(subject)
        }, $author$project$Components$Admin$NotificationSetting$Customize$GotPreview);
    });
    var $author$project$Ports$CKEditor$ckEditorReplacePort = _Platform_outgoingPort('ckEditorReplacePort', function($) {
        var a = $.a;
        var b = $.b;
        var c = $.c;
        return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([
            $elm$json$Json$Encode$string(a),
            $elm$json$Json$Encode$string(b),
            $elm$json$Json$Encode$list($elm$json$Json$Encode$string)(c)
        ]));
    });
    var $author$project$Ports$CKEditor$replace = F3(function(elementId, value, autocompleteOptions) {
        return $author$project$Ports$CKEditor$ckEditorReplacePort(_Utils_Tuple3(elementId, value, autocompleteOptions));
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$GotReset = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$NotificationSetting$reset = F5(function(apiClient, companyId, id_, _v0, toMsg) {
        var language = _v0.yC;
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(language)))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$NotificationSetting$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reset'
        ]), A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
    });
    var $author$project$Api$Provider$NotificationSetting$reset = F4(function(apiClient, id_, _v0, toMsg) {
        var language = _v0.yC;
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(language)))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$NotificationSetting$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reset'
        ]), $author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$resetNotificationSetting = F2(function(apiClient, _v0) {
        var context = _v0.aC;
        var language = _v0.yC;
        var notificationSetting = _v0.U7;
        if (context.$ === 1) {
            var id = context.a;
            return A5($author$project$Api$Provider$Company$NotificationSetting$reset, apiClient, id, $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting), {
                yC: language
            }, $author$project$Components$Admin$NotificationSetting$Customize$GotReset);
        } else return A4($author$project$Api$Provider$NotificationSetting$reset, apiClient, $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting), {
            yC: language
        }, $author$project$Components$Admin$NotificationSetting$Customize$GotReset);
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$GotTest = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Data$EmptyBody = 0;
    var $author$project$Api$Data$emptyBodyDecoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Company$NotificationSetting$test = F5(function(apiClient, companyId, id_, fields, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('subject', $elm$json$Json$Encode$string(fields.HF)),
                _Utils_Tuple2('body', $elm$json$Json$Encode$string(fields.fb))
            ]))),
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.yC)))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'test'
        ]), A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_)))));
    });
    var $author$project$Api$Provider$NotificationSetting$test = F4(function(apiClient, id_, fields, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('subject', $elm$json$Json$Encode$string(fields.HF)),
                _Utils_Tuple2('body', $elm$json$Json$Encode$string(fields.fb))
            ]))),
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.yC)))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'test'
        ]), $author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_)))));
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$testNotificationSetting = F3(function(apiClient, formFields, _v0) {
        var context = _v0.aC;
        var notificationSetting = _v0.U7;
        var language = _v0.yC;
        var _v1 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var subject = _v1.HF;
        var body = _v1.fb;
        if (context.$ === 1) {
            var id = context.a;
            return A5($author$project$Api$Provider$Company$NotificationSetting$test, apiClient, id, $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting), {
                fb: body,
                yC: language,
                HF: subject
            }, $author$project$Components$Admin$NotificationSetting$Customize$GotTest);
        } else return A4($author$project$Api$Provider$NotificationSetting$test, apiClient, $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting), {
            fb: body,
            yC: language,
            HF: subject
        }, $author$project$Components$Admin$NotificationSetting$Customize$GotTest);
    });
    var $author$project$Api$Data$toMaybe = function(data) {
        if (data.$ === 3) {
            var value = data.a;
            return $elm$core$Maybe$Just(value);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Ui$Dropdown$MenuClosedAfterFocus = {
        $: 9
    };
    var $author$project$Ui$Dropdown$NoOp = {
        $: 6
    };
    var $author$project$Ui$Dropdown$RightDown = 1;
    var $author$project$Ports$Dropdown$focusFirstDropdownOptionPort = _Platform_outgoingPort('focusFirstDropdownOptionPort', $elm$json$Json$Encode$string);
    var $author$project$Ports$Dropdown$focusFirstItem = $author$project$Ports$Dropdown$focusFirstDropdownOptionPort;
    var $elm$json$Json$Encode$null = _Json_encodeNull;
    var $author$project$Ports$Dropdown$focusInnerDropdownOptionInputPort = _Platform_outgoingPort('focusInnerDropdownOptionInputPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Dropdown$focusInnerInput = $author$project$Ports$Dropdown$focusInnerDropdownOptionInputPort(0);
    var $author$project$Ports$Dropdown$focusInnerDropdownOptionLinkPort = _Platform_outgoingPort('focusInnerDropdownOptionLinkPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Dropdown$focusInnerLink = $author$project$Ports$Dropdown$focusInnerDropdownOptionLinkPort(0);
    var $author$project$Ports$Dropdown$focusNextDropdownOptionPort = _Platform_outgoingPort('focusNextDropdownOptionPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Dropdown$focusNextItem = $author$project$Ports$Dropdown$focusNextDropdownOptionPort(0);
    var $author$project$Ports$Dropdown$focusPrevDropdownOptionPort = _Platform_outgoingPort('focusPrevDropdownOptionPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Dropdown$focusPrevItem = $author$project$Ports$Dropdown$focusPrevDropdownOptionPort(0);
    var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
    var $author$project$Ui$Dropdown$focusTrigger = F2(function(msg, id) {
        return A2($elm$core$Task$attempt, $elm$core$Basics$always(msg), $elm$browser$Browser$Dom$focus(id + '-trigger'));
    });
    var $author$project$Ports$Dropdown$dropdownSimulateClick = _Platform_outgoingPort('dropdownSimulateClick', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Dropdown$simulateClick = $author$project$Ports$Dropdown$dropdownSimulateClick(0);
    var $author$project$Ports$Dropdown$submitFormDropdownPort = _Platform_outgoingPort('submitFormDropdownPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Dropdown$submitForm = $author$project$Ports$Dropdown$submitFormDropdownPort(0);
    var $author$project$Ui$Dropdown$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: !model.Vw
                }), !model.Vw ? A2($elm$core$Platform$Cmd$map, model.ahX, $author$project$Ports$Dropdown$focusFirstItem(model.aef)) : $elm$core$Platform$Cmd$none);
            case 1:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: true
                }), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: true
                }), $elm$core$Platform$Cmd$none);
            case 3:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: !model.Vw
                }), !model.Vw ? A2($elm$core$Platform$Cmd$map, model.ahX, $author$project$Ports$Dropdown$focusFirstItem(model.aef)) : $elm$core$Platform$Cmd$none);
            case 4:
                return _Utils_Tuple2(model, A2($elm$core$Platform$Cmd$map, model.ahX, A2($author$project$Ui$Dropdown$focusTrigger, $author$project$Ui$Dropdown$MenuClosedAfterFocus, model.aef)));
            case 5:
                var arrowDirection = msg.a;
                var openAndFocusFirst = _Utils_Tuple2(_Utils_update(model, {
                    Vw: true
                }), $author$project$Ports$Dropdown$focusFirstItem(model.aef));
                var _v1 = model.a1;
                switch(_v1){
                    case 0:
                        if (arrowDirection === 1) return openAndFocusFirst;
                        else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    case 1:
                        if (arrowDirection === 2) return openAndFocusFirst;
                        else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    case 4:
                        if (arrowDirection === 1) return openAndFocusFirst;
                        else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    case 2:
                        if (arrowDirection === 1) return openAndFocusFirst;
                        else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    default:
                        if (arrowDirection === 1) return openAndFocusFirst;
                        else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            case 7:
                var direction = msg.a;
                switch(direction){
                    case 0:
                        return _Utils_Tuple2(model, $author$project$Ports$Dropdown$focusPrevItem);
                    case 1:
                        return _Utils_Tuple2(model, $author$project$Ports$Dropdown$focusNextItem);
                    case 2:
                        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    default:
                        return model.a1 === 1 ? _Utils_Tuple2(_Utils_update(model, {
                            Vw: false
                        }), A2($elm$core$Platform$Cmd$map, model.ahX, A2($author$project$Ui$Dropdown$focusTrigger, $author$project$Ui$Dropdown$NoOp, model.aef))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            case 6:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 8:
                return _Utils_Tuple2(model, A2($elm$core$Platform$Cmd$map, model.ahX, A2($author$project$Ui$Dropdown$focusTrigger, $author$project$Ui$Dropdown$MenuClosedAfterFocus, model.aef)));
            case 9:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: false
                }), $elm$core$Platform$Cmd$none);
            case 10:
                return _Utils_Tuple2(model, A2($elm$core$Platform$Cmd$map, model.ahX, $author$project$Ports$Dropdown$focusInnerInput));
            case 11:
                return _Utils_Tuple2(model, A2($elm$core$Platform$Cmd$map, model.ahX, $author$project$Ports$Dropdown$focusInnerLink));
            case 12:
                var id = msg.a;
                return _Utils_eq(model.aef, id) ? _Utils_Tuple2(_Utils_update(model, {
                    Vw: false
                }), $elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 13:
                return _Utils_Tuple2(model, $author$project$Ports$Dropdown$submitForm);
            default:
                return _Utils_Tuple2(model, A2($elm$core$Platform$Cmd$map, model.ahX, $author$project$Ports$Dropdown$simulateClick));
        }
    });
    var $author$project$Utils$Form$update = F3(function(updater, field_, _v0) {
        var originalFields = _v0.a;
        var validated_ = _v0.b;
        var fields_ = _v0.c;
        var errors_ = _v0.d;
        return A4($author$project$Utils$Form$Form, originalFields, validated_, A2(updater, field_, fields_), errors_);
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Data$patch = $author$project$Api$Data$makeRequest('patch');
    var $author$project$Api$Provider$Company$NotificationSetting$update = F5(function(apiClient, companyId, id_, fields, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('subject', $elm$json$Json$Encode$string(fields.HF)),
                _Utils_Tuple2('body', $elm$json$Json$Encode$string(fields.fb))
            ]))),
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.yC)))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$NotificationSetting$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_))));
    });
    var $author$project$Api$Provider$NotificationSetting$update = F4(function(apiClient, id_, fields, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('subject', $elm$json$Json$Encode$string(fields.HF)),
                _Utils_Tuple2('body', $elm$json$Json$Encode$string(fields.fb))
            ]))),
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.yC)))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$NotificationSetting$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo($author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$updateNotificationSetting = F2(function(apiClient, _v0) {
        var context = _v0.aC;
        var language = _v0.yC;
        var notificationSetting = _v0.U7;
        var form = _v0.PU;
        var _v1 = $author$project$Utils$Form$fields(form);
        var subject = _v1.HF;
        var body = _v1.fb;
        if (context.$ === 1) {
            var id = context.a;
            return A5($author$project$Api$Provider$Company$NotificationSetting$update, apiClient, id, $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting), {
                fb: body,
                yC: language,
                HF: subject
            }, $author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting);
        } else return A4($author$project$Api$Provider$NotificationSetting$update, apiClient, $author$project$Api$Provider$NotificationSetting$Shared$id(notificationSetting), {
            fb: body,
            yC: language,
            HF: subject
        }, $author$project$Components$Admin$NotificationSetting$Customize$SavedNotificationSetting);
    });
    var $rtfeldman$elm_validate$Validate$Valid = $elm$core$Basics$identity;
    var $rtfeldman$elm_validate$Validate$validate = F2(function(_v0, subject) {
        var getErrors = _v0;
        var _v1 = getErrors(subject);
        if (!_v1.b) return $elm$core$Result$Ok(subject);
        else {
            var errors = _v1;
            return $elm$core$Result$Err(errors);
        }
    });
    var $author$project$Utils$Form$validate = F2(function(formFieldsValidator, _v0) {
        var originalFields = _v0.a;
        var fields_ = _v0.c;
        var _v1 = A2($rtfeldman$elm_validate$Validate$validate, formFieldsValidator, fields_);
        if (!_v1.$) {
            var validForm = _v1.a;
            return $elm$core$Result$Ok(_Utils_Tuple2(A4($author$project$Utils$Form$Form, originalFields, true, fields_, _List_Nil), validForm));
        } else {
            var errors_ = _v1.a;
            return $elm$core$Result$Err(A4($author$project$Utils$Form$Form, originalFields, true, fields_, errors_));
        }
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 14:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 15:
                var dropdownMsg = msg.a;
                var _v1 = model.fD;
                if (!_v1.$) {
                    var dropdown = _v1.a;
                    var _v2 = A2($author$project$Ui$Dropdown$update, dropdownMsg, dropdown);
                    var newDropdown = _v2.a;
                    var dropdownCmd = _v2.b;
                    var newModel = _Utils_update(model, {
                        fD: $elm$core$Maybe$Just(newDropdown)
                    });
                    return {
                        EQ: dropdownCmd,
                        adu: 0,
                        zi: newModel,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var dropdown = model.ru && $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable(model.U7) ? $elm$core$Maybe$Just($author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                    aef: 'customize-language-dropdown',
                    ahX: $author$project$Components$Admin$NotificationSetting$Customize$LanguageDropdownMsg
                }))) : $elm$core$Maybe$Nothing;
                var _v3 = $author$project$Components$Admin$NotificationSetting$Customize$initForm(model.U7);
                var form = _v3.a;
                return {
                    EQ: A3($author$project$Ports$CKEditor$replace, $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.U7), $author$project$Api$Provider$NotificationSetting$Shared$body(model.U7), $author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.U7)),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fD: dropdown,
                        PU: form,
                        yC: $author$project$Language$english,
                        Vw: true
                    }),
                    at: _List_Nil
                };
            case 1:
                return function(closedModel) {
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: closedModel,
                        at: _List_Nil
                    };
                }(_Utils_update(model, {
                    Vw: false,
                    agk: $author$project$Api$Data$NotAsked
                }));
            case 2:
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, model.PU);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return function(okFormModel) {
                        return {
                            EQ: A3($author$project$Components$Admin$NotificationSetting$Customize$previewNotificationSetting, apiClient, validFormFields, okFormModel),
                            adu: 0,
                            zi: okFormModel,
                            at: _List_Nil
                        };
                    }(_Utils_update(model, {
                        PU: newForm,
                        agk: $author$project$Api$Data$Loading
                    }));
                } else {
                    var newForm = _v4.a;
                    return function(failedFormModel) {
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: failedFormModel,
                            at: _List_Nil
                        };
                    }(_Utils_update(model, {
                        PU: newForm,
                        agk: $author$project$Api$Data$NotAsked
                    }));
                }
            case 3:
                var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, model.PU);
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var newForm = _v7.a;
                    var validFormFields = _v7.b;
                    return function(okModel) {
                        return {
                            EQ: A3($author$project$Components$Admin$NotificationSetting$Customize$testNotificationSetting, apiClient, validFormFields, okModel),
                            adu: 0,
                            zi: okModel,
                            at: _List_Nil
                        };
                    }(_Utils_update(model, {
                        PU: newForm,
                        kv: $author$project$Api$Data$Loading
                    }));
                } else {
                    var newForm = _v6.a;
                    return function(errModel) {
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: errModel,
                            at: _List_Nil
                        };
                    }(_Utils_update(model, {
                        PU: newForm,
                        kv: $author$project$Api$Data$NotAsked
                    }));
                }
            case 4:
                return function(resettingModel) {
                    return {
                        EQ: A2($author$project$Components$Admin$NotificationSetting$Customize$resetNotificationSetting, apiClient, resettingModel),
                        adu: 0,
                        zi: resettingModel,
                        at: _List_Nil
                    };
                }(_Utils_update(model, {
                    agk: $author$project$Api$Data$Loading
                }));
            case 5:
                return function(editingModel) {
                    var _v8 = $author$project$Utils$Form$fields(model.PU);
                    var body = _v8.fb;
                    return {
                        EQ: A3($author$project$Ports$CKEditor$replace, $author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.U7), body, $author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.U7)),
                        adu: 0,
                        zi: editingModel,
                        at: _List_Nil
                    };
                }(_Utils_update(model, {
                    agk: $author$project$Api$Data$NotAsked
                }));
            case 6:
                return {
                    EQ: A2($author$project$Components$Admin$NotificationSetting$Customize$updateNotificationSetting, apiClient, model),
                    adu: 0,
                    zi: _Utils_update(model, {
                        n8: true
                    }),
                    at: _List_Nil
                };
            case 7:
                var response = msg.a;
                return function(modelWPreview) {
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: modelWPreview,
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                }(_Utils_update(model, {
                    agk: response
                }));
            case 10:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsUpdate, field, model.PU);
                var validatedForm = function() {
                    var _v9 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$Customize$notificationSettingFormFieldsValidator, newForm);
                    if (!_v9.$) {
                        var _v10 = _v9.a;
                        var form = _v10.a;
                        return form;
                    } else {
                        var form = _v9.a;
                        return form;
                    }
                }();
                var newModel = _Utils_update(model, {
                    PU: validatedForm,
                    n8: false
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: newModel,
                    at: _List_Nil
                };
            case 11:
                var response = msg.a;
                if (response.$ === 3) return function(okModel) {
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: okModel,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Notification successfully updated.')
                        ])
                    };
                }(_Utils_update(model, {
                    Vw: false
                }));
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 12:
                var language = msg.a;
                var response = msg.b;
                var _v12 = function() {
                    if (_Utils_eq(language, model.yC)) {
                        if (response.$ === 3) {
                            var setting = response.a;
                            return $author$project$Components$Admin$NotificationSetting$Customize$initForm($author$project$Api$Provider$NotificationSetting$One$toShared(setting));
                        } else return _Utils_Tuple2(model.PU, $elm$core$Platform$Cmd$none);
                    } else return _Utils_Tuple2(model.PU, $elm$core$Platform$Cmd$none);
                }();
                var form = _v12.a;
                var formCmd = _v12.b;
                return function(translations) {
                    return {
                        EQ: formCmd,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: form,
                            aay: translations
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                }(A3($elm$core$Dict$insert, $author$project$Language$toValue(language), A2($author$project$Api$Data$map, $author$project$Api$Provider$NotificationSetting$One$toShared, response), model.aay));
            case 8:
                var response = msg.a;
                if (response.$ === 3) {
                    var notificationSettingOne = response.a;
                    var notificationSetting = $author$project$Api$Provider$NotificationSetting$One$toShared(notificationSettingOne);
                    var _v15 = $author$project$Components$Admin$NotificationSetting$Customize$initForm(notificationSetting);
                    var form = _v15.a;
                    var formCmd = _v15.b;
                    var newModel = _Utils_update(model, {
                        PU: form,
                        U7: notificationSetting
                    });
                    return {
                        EQ: formCmd,
                        adu: 1,
                        zi: newModel,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Notification successfully reset.')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 9:
                var response = msg.a;
                return function(newModel) {
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: newModel,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'A sample of this email has been sent to you.')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: newModel,
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                }(_Utils_update(model, {
                    kv: response
                }));
            case 13:
                return function(newModel) {
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: newModel,
                        at: _List_Nil
                    };
                }(_Utils_update(model, {
                    os: !model.os
                }));
            default:
                var language = msg.a;
                var _v17 = _Utils_eq(language, $author$project$Language$english) ? $author$project$Components$Admin$NotificationSetting$Customize$initForm(model.U7) : A2($elm$core$Maybe$withDefault, _Utils_Tuple2(model.PU, A4($author$project$Api$Provider$NotificationSetting$retrieve, apiClient, $author$project$Api$Provider$NotificationSetting$Shared$id(model.U7), $elm$core$Maybe$Just(language), $author$project$Components$Admin$NotificationSetting$Customize$GotNotificationSetting(language))), A2($elm$core$Maybe$map, function(translatedSetting) {
                    return $author$project$Components$Admin$NotificationSetting$Customize$initForm(translatedSetting);
                }, A2($elm$core$Maybe$andThen, $author$project$Api$Data$toMaybe, A2($elm$core$Dict$get, $author$project$Language$toValue(language), model.aay))));
                var form = _v17.a;
                var formCmd = _v17.b;
                return {
                    EQ: formCmd,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: form,
                        yC: language
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$NotificationSetting$toggle = F5(function(apiClient, companyId, id_, enabled_, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('enabled', $elm$json$Json$Encode$bool(enabled_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$NotificationSetting$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$NotificationSetting$notificationSettingPath, companyId, id_))));
    });
    var $author$project$Api$Provider$NotificationSetting$toggle = F4(function(apiClient, id_, enabled_, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('enabled', $elm$json$Json$Encode$bool(enabled_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$NotificationSetting$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo($author$project$Api$Provider$NotificationSetting$notificationSettingPath(id_))));
    });
    var $author$project$Components$Admin$NotificationSetting$Toggle$update = F4(function(apiClient, context, msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var bool = msg.a;
            var toggleCmd = function() {
                if (context.$ === 1) {
                    var companyId = context.a;
                    return A5($author$project$Api$Provider$Company$NotificationSetting$toggle, apiClient, companyId, model.xR.aef(model.U7), bool, $author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled);
                } else return A4($author$project$Api$Provider$NotificationSetting$toggle, apiClient, model.xR.aef(model.U7), bool, $author$project$Components$Admin$NotificationSetting$Toggle$NotificationSettingToggled);
            }();
            return _Utils_Tuple3(_Utils_update(model, {
                su: $author$project$Api$Data$Loading
            }), toggleCmd, _List_Nil);
        } else {
            var response = msg.a;
            if (response.$ === 3) {
                var notificationSetting = response.a;
                var status = $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting) ? 'enabled' : 'disabled';
                return _Utils_Tuple3(_Utils_update(model, {
                    OM: $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting),
                    su: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'This notification has been ' + status)
                ]));
            } else return _Utils_Tuple3(_Utils_update(model, {
                su: $author$project$Api$Data$NotAsked
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$AdvanceBilling$Updated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$Practice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Practice$Shared$Practice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$Shared$Record = function(id) {
        return function(name) {
            return function(email) {
                return function(usesSponsors) {
                    return function(cancellationReasonOther) {
                        return function(deactivated) {
                            return function(deactivateOn) {
                                return function(subdomain) {
                                    return function(hasClinicalAccount) {
                                        return function(hasStripeAccount) {
                                            return function(hasPaymentProcessorAccount) {
                                                return function(url) {
                                                    return function(stripeClientId) {
                                                        return function(stripePublishableKey) {
                                                            return function(logoUrl) {
                                                                return function(usesCardReaders) {
                                                                    return function(isNetwork) {
                                                                        return function(isAffiliate) {
                                                                            return function(elationEnabled) {
                                                                                return function(acceptsCards) {
                                                                                    return function(acceptsAmex) {
                                                                                        return function(stripeLink) {
                                                                                            return function(encourageAch) {
                                                                                                return function(createdAt) {
                                                                                                    return function(paymentProcessor) {
                                                                                                        return function(hasBankTransfersCapability) {
                                                                                                            return {
                                                                                                                If: acceptsAmex,
                                                                                                                Ig: acceptsCards,
                                                                                                                aca: cancellationReasonOther,
                                                                                                                Mx: createdAt,
                                                                                                                Ng: deactivateOn,
                                                                                                                Nh: deactivated,
                                                                                                                Oz: elationEnabled,
                                                                                                                OH: email,
                                                                                                                ON: encourageAch,
                                                                                                                Qk: hasBankTransfersCapability,
                                                                                                                Ql: hasClinicalAccount,
                                                                                                                Qw: hasPaymentProcessorAccount,
                                                                                                                QB: hasStripeAccount,
                                                                                                                aef: id,
                                                                                                                RP: isAffiliate,
                                                                                                                Sd: isNetwork,
                                                                                                                Tu: logoUrl,
                                                                                                                zr: name,
                                                                                                                Wo: paymentProcessor,
                                                                                                                $d: stripeClientId,
                                                                                                                $j: stripeLink,
                                                                                                                $l: stripePublishableKey,
                                                                                                                $n: subdomain,
                                                                                                                aaT: url,
                                                                                                                aa$: usesCardReaders,
                                                                                                                aa3: usesSponsors
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $justinmimbs$date$Date$deadEndToString = function(_v0) {
        var problem = _v0.nK;
        if (problem.$ === 12) {
            var message = problem.a;
            return message;
        } else return 'Expected a date in ISO 8601 format';
    };
    var $justinmimbs$date$Date$MonthAndDay = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $justinmimbs$date$Date$OrdinalDay = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $justinmimbs$date$Date$WeekAndWeekday = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $elm$parser$Parser$Advanced$backtrackable = function(_v0) {
        var parse = _v0;
        return function(s0) {
            var _v1 = parse(s0);
            if (_v1.$ === 1) {
                var x = _v1.b;
                return A2($elm$parser$Parser$Advanced$Bad, false, x);
            } else {
                var a = _v1.b;
                var s1 = _v1.c;
                return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
            }
        };
    };
    var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
    var $elm$parser$Parser$Advanced$commit = function(a) {
        return function(s) {
            return A3($elm$parser$Parser$Advanced$Good, true, a, s);
        };
    };
    var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
    var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
    var $justinmimbs$date$Date$int1 = A2($elm$parser$Parser$mapChompedString, F2(function(str, _v0) {
        return A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(str));
    }), $elm$parser$Parser$chompIf($elm$core$Char$isDigit));
    var $justinmimbs$date$Date$int2 = A2($elm$parser$Parser$mapChompedString, F2(function(str, _v0) {
        return A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(str));
    }), A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
    var $justinmimbs$date$Date$int3 = A2($elm$parser$Parser$mapChompedString, F2(function(str, _v0) {
        return A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(str));
    }), A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
    var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(_List_fromArray([
        A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$token('-')), $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$backtrackable(A2($elm$parser$Parser$andThen, $elm$parser$Parser$commit, A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
            A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay), $justinmimbs$date$Date$int2), $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$token('-')), $justinmimbs$date$Date$int2),
                $elm$parser$Parser$succeed(1)
            ]))),
            A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday), $elm$parser$Parser$token('W')), $justinmimbs$date$Date$int2), $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$token('-')), $justinmimbs$date$Date$int1),
                $elm$parser$Parser$succeed(1)
            ])))
        ]))),
        $elm$parser$Parser$backtrackable(A2($elm$parser$Parser$andThen, $elm$parser$Parser$commit, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay), $justinmimbs$date$Date$int2), $elm$parser$Parser$oneOf(_List_fromArray([
            $justinmimbs$date$Date$int2,
            $elm$parser$Parser$succeed(1)
        ]))))),
        A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
        A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday), $elm$parser$Parser$token('W')), $justinmimbs$date$Date$int2), $elm$parser$Parser$oneOf(_List_fromArray([
            $justinmimbs$date$Date$int1,
            $elm$parser$Parser$succeed(1)
        ]))),
        $elm$parser$Parser$succeed($justinmimbs$date$Date$OrdinalDay(1))
    ]));
    var $justinmimbs$date$Date$daysBeforeMonth = F2(function(y, m) {
        var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
        switch(m){
            case 0:
                return 0;
            case 1:
                return 31;
            case 2:
                return 59 + leapDays;
            case 3:
                return 90 + leapDays;
            case 4:
                return 120 + leapDays;
            case 5:
                return 151 + leapDays;
            case 6:
                return 181 + leapDays;
            case 7:
                return 212 + leapDays;
            case 8:
                return 243 + leapDays;
            case 9:
                return 273 + leapDays;
            case 10:
                return 304 + leapDays;
            default:
                return 334 + leapDays;
        }
    });
    var $justinmimbs$date$Date$isBetweenInt = F3(function(a, b, x) {
        return _Utils_cmp(a, x) < 1 && _Utils_cmp(x, b) < 1;
    });
    var $justinmimbs$date$Date$fromCalendarParts = F3(function(y, mn, d) {
        return A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3($justinmimbs$date$Date$isBetweenInt, 1, A2($justinmimbs$date$Date$daysInMonth, y, $justinmimbs$date$Date$numberToMonth(mn)), d) ? $elm$core$Result$Ok($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, $justinmimbs$date$Date$numberToMonth(mn)) + d) : $elm$core$Result$Err('Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
    });
    var $justinmimbs$date$Date$fromOrdinalParts = F2(function(y, od) {
        return A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || od === 366 && $justinmimbs$date$Date$isLeapYear(y) ? $elm$core$Result$Ok($justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err('Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
    });
    var $justinmimbs$date$Date$firstOfYear = function(y) {
        return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
    };
    var $justinmimbs$date$Date$is53WeekYear = function(y) {
        var wdnJan1 = $justinmimbs$date$Date$weekdayNumber($justinmimbs$date$Date$firstOfYear(y));
        return wdnJan1 === 4 || wdnJan1 === 3 && $justinmimbs$date$Date$isLeapYear(y);
    };
    var $justinmimbs$date$Date$fromWeekParts = F3(function(wy, wn, wdn) {
        return A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || wn === 53 && $justinmimbs$date$Date$is53WeekYear(wy)) ? $elm$core$Result$Ok($justinmimbs$date$Date$daysBeforeWeekYear(wy) + (wn - 1) * 7 + wdn) : $elm$core$Result$Err('Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
    });
    var $justinmimbs$date$Date$fromYearAndDayOfYear = function(_v0) {
        var y = _v0.a;
        var doy = _v0.b;
        switch(doy.$){
            case 0:
                var mn = doy.a;
                var d = doy.b;
                return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
            case 1:
                var wn = doy.a;
                var wdn = doy.b;
                return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
            default:
                var od = doy.a;
                return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
        }
    };
    var $justinmimbs$date$Date$int4 = A2($elm$parser$Parser$mapChompedString, F2(function(str, _v0) {
        return A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(str));
    }), A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$chompIf(function(c) {
            return c === '-';
        }),
        $elm$parser$Parser$succeed(0)
    ]))), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)), $elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
    var $elm$core$Tuple$pair = F2(function(a, b) {
        return _Utils_Tuple2(a, b);
    });
    var $justinmimbs$date$Date$resultToParser = function(result) {
        if (!result.$) {
            var x = result.a;
            return $elm$parser$Parser$succeed(x);
        } else {
            var message = result.a;
            return $elm$parser$Parser$problem(message);
        }
    };
    var $justinmimbs$date$Date$parser = A2($elm$parser$Parser$andThen, A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser), A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($elm$core$Tuple$pair), $justinmimbs$date$Date$int4), $justinmimbs$date$Date$dayOfYear));
    var $justinmimbs$date$Date$fromIsoString = A2($elm$core$Basics$composeR, $elm$parser$Parser$run(A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($elm$core$Basics$identity), A2($elm$parser$Parser$ignorer, $justinmimbs$date$Date$parser, A2($elm$parser$Parser$andThen, $justinmimbs$date$Date$resultToParser, $elm$parser$Parser$oneOf(_List_fromArray([
        A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
        A2($elm$parser$Parser$map, $elm$core$Basics$always($elm$core$Result$Err('Expected a date only, not a date and time')), $elm$parser$Parser$chompIf($elm$core$Basics$eq('T'))),
        $elm$parser$Parser$succeed($elm$core$Result$Err('Expected a date only'))
    ])))))), $elm$core$Result$mapError(A2($elm$core$Basics$composeR, $elm$core$List$head, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($justinmimbs$date$Date$deadEndToString), $elm$core$Maybe$withDefault('')))));
    var $elm_community$json_extra$Json$Decode$Extra$fromResult = function(result) {
        if (!result.$) {
            var successValue = result.a;
            return $elm$json$Json$Decode$succeed(successValue);
        } else {
            var errorMessage = result.a;
            return $elm$json$Json$Decode$fail(errorMessage);
        }
    };
    var $author$project$Utils$Date$decode = A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult), $elm$json$Json$Decode$string);
    var $elm$json$Json$Decode$maybe = function(decoder) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
            $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
        ]));
    };
    var $author$project$Api$Provider$Practice$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'has_bank_transfers_capability', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'encourage_ach', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_account_link', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_amex', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_cards', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'elation_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_affiliate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_network', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_card_readers', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'logo_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_publishable_key', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_client_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_payment_processor_account', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_stripe_account', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_clinical_account', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subdomain', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deactivate_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deactivated', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancellation_reason_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_sponsors', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$Shared$Record)))))))))))))))))))))))))));
    var $author$project$Api$Provider$Practice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practice$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Practice$One$Record = function(requireGroupForLocations) {
        return function(requiresMfa) {
            return function(trackPatientsByLocation) {
                return function(chargePatientsCreditCardFees) {
                    return function(passthroughFeesCutoffEnabled) {
                        return function(passthroughFeesCutoffDate) {
                            return function(ssnEnabled) {
                                return function(requiresSSN) {
                                    return function(requiresPatientEmail) {
                                        return function(requiresPatientMobile) {
                                            return function(requiresPractitioner) {
                                                return function(requiresLocation) {
                                                    return function(requiresDefaultLocationForCompanies) {
                                                        return function(hasCompaniesWithoutDefaultLocation) {
                                                            return function(hasLocationsWithoutGroup) {
                                                                return function(onboarded) {
                                                                    return function(organizationId) {
                                                                        return function(canDeleteAllPatients) {
                                                                            return function(collectSSNOnSignup) {
                                                                                return function(collectPractitionerOnSignup) {
                                                                                    return function(collectLocationOnSignup) {
                                                                                        return function(selfServiceRequestAccessUrl) {
                                                                                            return function(notRetailPlansCount) {
                                                                                                return function(locationGroupsCount) {
                                                                                                    return function(feePlanType) {
                                                                                                        return function(sendZeroRevenueMembershipNotification) {
                                                                                                            return function(emailReplyAddress) {
                                                                                                                return function(salutation) {
                                                                                                                    return function(greetsFormally) {
                                                                                                                        return function(footer) {
                                                                                                                            return function(memberPortalSignupUrl) {
                                                                                                                                return function(meta) {
                                                                                                                                    return function(practiceOnboarding) {
                                                                                                                                        return function(features) {
                                                                                                                                            return function(daysWithOutstandingBalance) {
                                                                                                                                                return function(collectionWarningStatus) {
                                                                                                                                                    return function(accessRestricted) {
                                                                                                                                                        return function(daysUntilAccessRestricted) {
                                                                                                                                                            return function(billMonthlyAutopayInAdvanceInDays) {
                                                                                                                                                                return function(billNonMonthlyAutopayInAdvanceInDays) {
                                                                                                                                                                    return function(billMonthlyNonAutopayInAdvanceInDays) {
                                                                                                                                                                        return function(billNonMonthlyNonAutopayInAdvanceInDays) {
                                                                                                                                                                            return function(scheduleMonthlyPaymentInAdvanceInDays) {
                                                                                                                                                                                return function(scheduleNonMonthlyPaymentInAdvanceInDays) {
                                                                                                                                                                                    return function(commissionsEnabled) {
                                                                                                                                                                                        return function(commissionsTrackingFrom) {
                                                                                                                                                                                            return function(sessionTimeoutInMinutes) {
                                                                                                                                                                                                return function(ein) {
                                                                                                                                                                                                    return function(practicePulse) {
                                                                                                                                                                                                        return function(engagementThreshold) {
                                                                                                                                                                                                            return function(defaultToActivePatientsFilter) {
                                                                                                                                                                                                                return function(plansCount) {
                                                                                                                                                                                                                    return function(companiesCount) {
                                                                                                                                                                                                                        return function(owner) {
                                                                                                                                                                                                                            return function(businessLocation) {
                                                                                                                                                                                                                                return function(companyInvoiceSetting) {
                                                                                                                                                                                                                                    return function(paymentSourceSetting) {
                                                                                                                                                                                                                                        return function(address) {
                                                                                                                                                                                                                                            return function(phones) {
                                                                                                                                                                                                                                                return function(network) {
                                                                                                                                                                                                                                                    return function(featureGates) {
                                                                                                                                                                                                                                                        return function(labelBillingAsShipping) {
                                                                                                                                                                                                                                                            return function(accountType) {
                                                                                                                                                                                                                                                                return function(transInclusivity) {
                                                                                                                                                                                                                                                                    return function(hasActiveCompanies) {
                                                                                                                                                                                                                                                                        return function(customForms) {
                                                                                                                                                                                                                                                                            return function(acceptsAch) {
                                                                                                                                                                                                                                                                                return function(postSignupButtonLabel) {
                                                                                                                                                                                                                                                                                    return function(postSignupRedirectUrl) {
                                                                                                                                                                                                                                                                                        return function(showPostSignupFooterButton) {
                                                                                                                                                                                                                                                                                            return function(redirectsPostSignup) {
                                                                                                                                                                                                                                                                                                return function(postSignupMessage) {
                                                                                                                                                                                                                                                                                                    return function(collectPaymentSourceOnSignup) {
                                                                                                                                                                                                                                                                                                        return function(autoConfirmSignup) {
                                                                                                                                                                                                                                                                                                            return function(prepayFirstPaymentOnSignup) {
                                                                                                                                                                                                                                                                                                                return function(mergeDuplicatePatientsOnSignup) {
                                                                                                                                                                                                                                                                                                                    return function(collectAddressOnSignup) {
                                                                                                                                                                                                                                                                                                                        return function(collectBillingAddressOnSignup) {
                                                                                                                                                                                                                                                                                                                            return function(collectLeadSourceOnSignup) {
                                                                                                                                                                                                                                                                                                                                return function(collectBrokerOnSignup) {
                                                                                                                                                                                                                                                                                                                                    return function(startDateSelectableOnSignup) {
                                                                                                                                                                                                                                                                                                                                        return function(allowPayerOnBehalfOnSignup) {
                                                                                                                                                                                                                                                                                                                                            return function(collectInsuranceOnSignup) {
                                                                                                                                                                                                                                                                                                                                                return function(signupPageNotFoundRedirectUrl) {
                                                                                                                                                                                                                                                                                                                                                    return function(signupSettings) {
                                                                                                                                                                                                                                                                                                                                                        return function(defaultPlanId) {
                                                                                                                                                                                                                                                                                                                                                            return function(minEnrollAge) {
                                                                                                                                                                                                                                                                                                                                                                return function(restrictZipCodesOnSignup) {
                                                                                                                                                                                                                                                                                                                                                                    return function(allowedZipCodesOnSignup) {
                                                                                                                                                                                                                                                                                                                                                                        return function(defaultMembershipStartDate) {
                                                                                                                                                                                                                                                                                                                                                                            return function(anyRetailBrokers) {
                                                                                                                                                                                                                                                                                                                                                                                return function(mailgunStatus) {
                                                                                                                                                                                                                                                                                                                                                                                    return function(addons) {
                                                                                                                                                                                                                                                                                                                                                                                        return function(customLogoUrl) {
                                                                                                                                                                                                                                                                                                                                                                                            return function(emr) {
                                                                                                                                                                                                                                                                                                                                                                                                return function(emrOther) {
                                                                                                                                                                                                                                                                                                                                                                                                    return function(defaultPatientsPreferredLanguage) {
                                                                                                                                                                                                                                                                                                                                                                                                        return function(stripeCustomerLink) {
                                                                                                                                                                                                                                                                                                                                                                                                            return function(membershipCancellationEnabled) {
                                                                                                                                                                                                                                                                                                                                                                                                                return function(allowMultipleRetailMemberships) {
                                                                                                                                                                                                                                                                                                                                                                                                                    return function(hasManagedPartner) {
                                                                                                                                                                                                                                                                                                                                                                                                                        return {
                                                                                                                                                                                                                                                                                                                                                                                                                            Ie: acceptsAch,
                                                                                                                                                                                                                                                                                                                                                                                                                            Ii: accessRestricted,
                                                                                                                                                                                                                                                                                                                                                                                                                            In: accountType,
                                                                                                                                                                                                                                                                                                                                                                                                                            IH: addons,
                                                                                                                                                                                                                                                                                                                                                                                                                            II: address,
                                                                                                                                                                                                                                                                                                                                                                                                                            I9: allowMultipleRetailMemberships,
                                                                                                                                                                                                                                                                                                                                                                                                                            Jb: allowPayerOnBehalfOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Jf: allowedZipCodesOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Jv: anyRetailBrokers,
                                                                                                                                                                                                                                                                                                                                                                                                                            JT: autoConfirmSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            abZ: billMonthlyAutopayInAdvanceInDays,
                                                                                                                                                                                                                                                                                                                                                                                                                            ab_: billMonthlyNonAutopayInAdvanceInDays,
                                                                                                                                                                                                                                                                                                                                                                                                                            ab$: billNonMonthlyAutopayInAdvanceInDays,
                                                                                                                                                                                                                                                                                                                                                                                                                            ab0: billNonMonthlyNonAutopayInAdvanceInDays,
                                                                                                                                                                                                                                                                                                                                                                                                                            Kx: businessLocation,
                                                                                                                                                                                                                                                                                                                                                                                                                            KH: canDeleteAllPatients,
                                                                                                                                                                                                                                                                                                                                                                                                                            aco: chargePatientsCreditCardFees,
                                                                                                                                                                                                                                                                                                                                                                                                                            Lo: collectAddressOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Lp: collectBillingAddressOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Lq: collectBrokerOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Lt: collectInsuranceOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Lu: collectLeadSourceOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            acw: collectLocationOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Lw: collectPaymentSourceOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Lx: collectPractitionerOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Ly: collectSSNOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            LA: collectionWarningStatus,
                                                                                                                                                                                                                                                                                                                                                                                                                            LF: commissionsEnabled,
                                                                                                                                                                                                                                                                                                                                                                                                                            LG: commissionsTrackingFrom,
                                                                                                                                                                                                                                                                                                                                                                                                                            LH: companiesCount,
                                                                                                                                                                                                                                                                                                                                                                                                                            LL: companyInvoiceSetting,
                                                                                                                                                                                                                                                                                                                                                                                                                            MU: customForms,
                                                                                                                                                                                                                                                                                                                                                                                                                            MX: customLogoUrl,
                                                                                                                                                                                                                                                                                                                                                                                                                            Nd: daysUntilAccessRestricted,
                                                                                                                                                                                                                                                                                                                                                                                                                            Ne: daysWithOutstandingBalance,
                                                                                                                                                                                                                                                                                                                                                                                                                            Nu: defaultMembershipStartDate,
                                                                                                                                                                                                                                                                                                                                                                                                                            Nw: defaultPatientsPreferredLanguage,
                                                                                                                                                                                                                                                                                                                                                                                                                            NA: defaultPlanId,
                                                                                                                                                                                                                                                                                                                                                                                                                            ac0: defaultToActivePatientsFilter,
                                                                                                                                                                                                                                                                                                                                                                                                                            Oy: ein,
                                                                                                                                                                                                                                                                                                                                                                                                                            adi: emailReplyAddress,
                                                                                                                                                                                                                                                                                                                                                                                                                            adl: emr,
                                                                                                                                                                                                                                                                                                                                                                                                                            adn: emrOther,
                                                                                                                                                                                                                                                                                                                                                                                                                            ads: engagementThreshold,
                                                                                                                                                                                                                                                                                                                                                                                                                            Pv: featureGates,
                                                                                                                                                                                                                                                                                                                                                                                                                            Px: features,
                                                                                                                                                                                                                                                                                                                                                                                                                            PA: feePlanType,
                                                                                                                                                                                                                                                                                                                                                                                                                            adV: footer,
                                                                                                                                                                                                                                                                                                                                                                                                                            ad2: greetsFormally,
                                                                                                                                                                                                                                                                                                                                                                                                                            Qj: hasActiveCompanies,
                                                                                                                                                                                                                                                                                                                                                                                                                            Qm: hasCompaniesWithoutDefaultLocation,
                                                                                                                                                                                                                                                                                                                                                                                                                            Qs: hasLocationsWithoutGroup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Qt: hasManagedPartner,
                                                                                                                                                                                                                                                                                                                                                                                                                            SN: labelBillingAsShipping,
                                                                                                                                                                                                                                                                                                                                                                                                                            Tm: locationGroupsCount,
                                                                                                                                                                                                                                                                                                                                                                                                                            Ty: mailgunStatus,
                                                                                                                                                                                                                                                                                                                                                                                                                            TW: memberPortalSignupUrl,
                                                                                                                                                                                                                                                                                                                                                                                                                            ae$: membershipCancellationEnabled,
                                                                                                                                                                                                                                                                                                                                                                                                                            Uc: mergeDuplicatePatientsOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Ue: meta,
                                                                                                                                                                                                                                                                                                                                                                                                                            Uk: minEnrollAge,
                                                                                                                                                                                                                                                                                                                                                                                                                            UK: network,
                                                                                                                                                                                                                                                                                                                                                                                                                            U6: notRetailPlansCount,
                                                                                                                                                                                                                                                                                                                                                                                                                            Vs: onboarded,
                                                                                                                                                                                                                                                                                                                                                                                                                            afV: organizationId,
                                                                                                                                                                                                                                                                                                                                                                                                                            VM: owner,
                                                                                                                                                                                                                                                                                                                                                                                                                            af0: passthroughFeesCutoffDate,
                                                                                                                                                                                                                                                                                                                                                                                                                            af1: passthroughFeesCutoffEnabled,
                                                                                                                                                                                                                                                                                                                                                                                                                            Ws: paymentSourceSetting,
                                                                                                                                                                                                                                                                                                                                                                                                                            WG: phones,
                                                                                                                                                                                                                                                                                                                                                                                                                            WP: plansCount,
                                                                                                                                                                                                                                                                                                                                                                                                                            WZ: postSignupButtonLabel,
                                                                                                                                                                                                                                                                                                                                                                                                                            W_: postSignupMessage,
                                                                                                                                                                                                                                                                                                                                                                                                                            W$: postSignupRedirectUrl,
                                                                                                                                                                                                                                                                                                                                                                                                                            W5: practiceOnboarding,
                                                                                                                                                                                                                                                                                                                                                                                                                            W6: practicePulse,
                                                                                                                                                                                                                                                                                                                                                                                                                            Xj: prepayFirstPaymentOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            Yp: redirectsPostSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            agL: requireGroupForLocations,
                                                                                                                                                                                                                                                                                                                                                                                                                            agP: requiresDefaultLocationForCompanies,
                                                                                                                                                                                                                                                                                                                                                                                                                            YK: requiresLocation,
                                                                                                                                                                                                                                                                                                                                                                                                                            YL: requiresMfa,
                                                                                                                                                                                                                                                                                                                                                                                                                            YM: requiresPatientEmail,
                                                                                                                                                                                                                                                                                                                                                                                                                            YN: requiresPatientMobile,
                                                                                                                                                                                                                                                                                                                                                                                                                            YP: requiresPractitioner,
                                                                                                                                                                                                                                                                                                                                                                                                                            YQ: requiresSSN,
                                                                                                                                                                                                                                                                                                                                                                                                                            YV: restrictZipCodesOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            ag2: salutation,
                                                                                                                                                                                                                                                                                                                                                                                                                            ag4: scheduleMonthlyPaymentInAdvanceInDays,
                                                                                                                                                                                                                                                                                                                                                                                                                            ag5: scheduleNonMonthlyPaymentInAdvanceInDays,
                                                                                                                                                                                                                                                                                                                                                                                                                            ZG: selfServiceRequestAccessUrl,
                                                                                                                                                                                                                                                                                                                                                                                                                            ZS: sendZeroRevenueMembershipNotification,
                                                                                                                                                                                                                                                                                                                                                                                                                            ahj: sessionTimeoutInMinutes,
                                                                                                                                                                                                                                                                                                                                                                                                                            _j: showPostSignupFooterButton,
                                                                                                                                                                                                                                                                                                                                                                                                                            _r: signupPageNotFoundRedirectUrl,
                                                                                                                                                                                                                                                                                                                                                                                                                            _t: signupSettings,
                                                                                                                                                                                                                                                                                                                                                                                                                            _$: ssnEnabled,
                                                                                                                                                                                                                                                                                                                                                                                                                            _1: startDateSelectableOnSignup,
                                                                                                                                                                                                                                                                                                                                                                                                                            $g: stripeCustomerLink,
                                                                                                                                                                                                                                                                                                                                                                                                                            aaq: trackPatientsByLocation,
                                                                                                                                                                                                                                                                                                                                                                                                                            aas: transInclusivity
                                                                                                                                                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                                };
                                                                                                                                                                                                                                            };
                                                                                                                                                                                                                                        };
                                                                                                                                                                                                                                    };
                                                                                                                                                                                                                                };
                                                                                                                                                                                                                            };
                                                                                                                                                                                                                        };
                                                                                                                                                                                                                    };
                                                                                                                                                                                                                };
                                                                                                                                                                                                            };
                                                                                                                                                                                                        };
                                                                                                                                                                                                    };
                                                                                                                                                                                                };
                                                                                                                                                                                            };
                                                                                                                                                                                        };
                                                                                                                                                                                    };
                                                                                                                                                                                };
                                                                                                                                                                            };
                                                                                                                                                                        };
                                                                                                                                                                    };
                                                                                                                                                                };
                                                                                                                                                            };
                                                                                                                                                        };
                                                                                                                                                    };
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$AccountType$Affiliate = 1;
    var $author$project$Api$AccountType$Mce = 2;
    var $author$project$Api$AccountType$Standard = 0;
    var $author$project$Api$AccountType$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'standard':
                return $elm$json$Json$Decode$succeed(0);
            case 'affiliate':
                return $elm$json$Json$Decode$succeed(1);
            case 'mce':
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail('Unsupported practice account_type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$FeePlanType$Pmpm = 1;
    var $author$project$Api$FeePlanType$Transaction = 0;
    var $author$project$Api$FeePlanType$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'transaction':
                return $elm$json$Json$Decode$succeed(0);
            case 'pmpm':
                return $elm$json$Json$Decode$succeed(1);
            case 'pmpm_tiered':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unsupported practice fee_plan_type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Language$ES = 1;
    var $author$project$Language$decode = A2($elm$json$Json$Decode$andThen, function(str) {
        switch(str){
            case 'en':
                return $elm$json$Json$Decode$succeed(0);
            case 'es':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Invalid language');
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$CollectOnSignup$Default = 3;
    var $author$project$Api$CollectOnSignup$No = 0;
    var $author$project$Api$CollectOnSignup$Optional = 1;
    var $author$project$Api$CollectOnSignup$Require = 2;
    var $author$project$Api$CollectOnSignup$Yes = 4;
    var $author$project$Api$CollectOnSignup$decoder = A2($elm$json$Json$Decode$andThen, function(str) {
        switch(str){
            case 'no':
                return $elm$json$Json$Decode$succeed(0);
            case 'optional':
                return $elm$json$Json$Decode$succeed(1);
            case 'require':
                return $elm$json$Json$Decode$succeed(2);
            case 'default':
                return $elm$json$Json$Decode$succeed(3);
            case 'yes':
                return $elm$json$Json$Decode$succeed(4);
            default:
                var somethingElse = str;
                return $elm$json$Json$Decode$fail('Unknown collect on signup value: ' + somethingElse);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Address$Shared$Address = $elm$core$Basics$identity;
    var $author$project$Api$Common$Address$Shared$Record = F7(function(line1, line2, city, state, zip, country, stripeCountryCode) {
        return {
            pW: city,
            p0: country,
            ri: line1,
            yG: line2,
            s4: state,
            $f: stripeCountryCode,
            tK: zip
        };
    });
    var $author$project$Api$Common$Address$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_country_code', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'country', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'zip', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'state', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'city', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'line2', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'line1', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Common$Address$Shared$Record))))))));
    var $author$project$Api$Common$Address$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Address$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$FeatureGate$Shared$FeatureGate = $elm$core$Basics$identity;
    var $author$project$Api$Common$FeatureGate$Shared$Record = F2(function(code, startingTier) {
        return {
            Lk: code,
            ahw: startingTier
        };
    });
    var $author$project$Api$FeatureGate$CallUs = 3;
    var $author$project$Api$FeatureGate$Enterprise = 2;
    var $author$project$Api$FeatureGate$Growth = 1;
    var $author$project$Api$FeatureGate$OtherStartingTier = 4;
    var $author$project$Api$FeatureGate$Startup = 0;
    var $author$project$Api$FeatureGate$decodeStartingTier = function(startingTierStr) {
        switch(startingTierStr){
            case 'startup':
                return $elm$json$Json$Decode$succeed(0);
            case 'growth':
                return $elm$json$Json$Decode$succeed(1);
            case 'enterprise':
                return $elm$json$Json$Decode$succeed(2);
            case 'call_us':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$succeed(4);
        }
    };
    var $author$project$Api$Common$FeatureGate$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'starting_tier', A2($elm$json$Json$Decode$andThen, $author$project$Api$FeatureGate$decodeStartingTier, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'code', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$FeatureGate$Shared$Record)));
    var $author$project$Api$Common$FeatureGate$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$FeatureGate$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Addon$Min$Addon = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Addon$Min$Record = F4(function(id, name, url, sendsExternalEmail) {
        return {
            aef: id,
            zr: name,
            ZU: sendsExternalEmail,
            aaT: url
        };
    });
    var $author$project$Api$Provider$Addon$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sends_external_email', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Addon$Min$Record)))));
    var $author$project$Api$Provider$Addon$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Addon$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Form$Shared$Form = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Form$Shared$Record = F3(function(id, name, formItems) {
        return {
            PV: formItems,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$FormItem$Shared$FormItem = $elm$core$Basics$identity;
    var $author$project$Api$Provider$FormItem$Shared$Record = F3(function(id, title, itemType) {
        return {
            aef: id,
            rc: itemType,
            $2: title
        };
    });
    var $author$project$Api$Provider$FormItem$Shared$Boolean = 0;
    var $author$project$Api$Provider$FormItem$Shared$MultipleStrings = 1;
    var $author$project$Api$Provider$FormItem$Shared$String = 2;
    var $author$project$Api$Provider$FormItem$Shared$itemTypeDecoder = function(itemTypeString) {
        switch(itemTypeString){
            case 'string':
                return $elm$json$Json$Decode$succeed(2);
            case 'multiple_strings':
                return $elm$json$Json$Decode$succeed(1);
            case 'boolean':
                return $elm$json$Json$Decode$succeed(0);
            default:
                return $elm$json$Json$Decode$fail('Unsupported item type: ' + itemTypeString);
        }
    };
    var $author$project$Api$Provider$FormItem$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'item_type', A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$FormItem$Shared$itemTypeDecoder, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$FormItem$Shared$Record))));
    var $author$project$Api$Provider$FormItem$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$FormItem$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Form$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'form_items', $elm$json$Json$Decode$list($author$project$Api$Provider$FormItem$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Form$Shared$Record))));
    var $author$project$Api$Provider$Form$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Form$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Location$Min$Location = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Location$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Location$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Min$Record)));
    var $author$project$Api$Provider$Location$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Location$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Network$Shared$Network = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Network$Shared$Record = F2(function(syncByAffiliation, ratesFromAffiliate) {
        return {
            X9: ratesFromAffiliate,
            $D: syncByAffiliation
        };
    });
    var $author$project$Api$Provider$Network$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rates_from_affiliate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sync_by_affiliation', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Network$Shared$Record)));
    var $author$project$Api$Provider$Network$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Network$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $elm_community$list_extra$List$Extra$find = F2(function(predicate, list) {
        find: while(true){
            if (!list.b) return $elm$core$Maybe$Nothing;
            else {
                var first = list.a;
                var rest = list.b;
                if (predicate(first)) return $elm$core$Maybe$Just(first);
                else {
                    var $temp$predicate = predicate, $temp$list = rest;
                    predicate = $temp$predicate;
                    list = $temp$list;
                    continue find;
                }
            }
        }
    });
    var $author$project$Api$Provider$Practice$Emr$AkuteHealth = 3;
    var $author$project$Api$Provider$Practice$Emr$AthenaHealth = 4;
    var $author$project$Api$Provider$Practice$Emr$Canvas = 9;
    var $author$project$Api$Provider$Practice$Emr$Cerbo = 2;
    var $author$project$Api$Provider$Practice$Emr$CharmEMR = 6;
    var $author$project$Api$Provider$Practice$Emr$DrChrono = 8;
    var $author$project$Api$Provider$Practice$Emr$EClinicalWorks = 5;
    var $author$project$Api$Provider$Practice$Emr$ElationHealth = 1;
    var $author$project$Api$Provider$Practice$Emr$Emr = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$Emr$Healthie = 11;
    var $author$project$Api$Provider$Practice$Emr$HintClinical = 0;
    var $author$project$Api$Provider$Practice$Emr$Jane = 10;
    var $author$project$Api$Provider$Practice$Emr$Other = 13;
    var $author$project$Api$Provider$Practice$Emr$PracticeFusion = 7;
    var $author$project$Api$Provider$Practice$Emr$VibrantPractice = 12;
    var $author$project$Api$Provider$Practice$Emr$options = _List_fromArray([
        {
            aef: 'hint_clinical',
            zr: 'Hint Clinical',
            af: 0
        },
        {
            aef: 'akute_health',
            zr: 'Akute Health',
            af: 3
        },
        {
            aef: 'athena_health',
            zr: 'AthenaHealth',
            af: 4
        },
        {
            aef: 'canvas',
            zr: 'Canvas',
            af: 9
        },
        {
            aef: 'cerbo',
            zr: 'Cerbo',
            af: 2
        },
        {
            aef: 'charm_emr',
            zr: 'CharmEMR',
            af: 6
        },
        {
            aef: 'dr_chrono',
            zr: 'DrChrono',
            af: 8
        },
        {
            aef: 'e_clinical_works',
            zr: 'eClinicalWorks',
            af: 5
        },
        {
            aef: 'elation_health',
            zr: 'Elation Health',
            af: 1
        },
        {
            aef: 'healthie',
            zr: 'Healthie',
            af: 11
        },
        {
            aef: 'jane',
            zr: 'Jane',
            af: 10
        },
        {
            aef: 'practice_fusion',
            zr: 'PracticeFusion',
            af: 7
        },
        {
            aef: 'vibrant_practice',
            zr: 'Vibrant Practice',
            af: 12
        },
        {
            aef: 'other',
            zr: 'Other',
            af: 13
        }
    ]);
    var $author$project$Api$Provider$Practice$Emr$fromValue = function(string) {
        return A2($elm_community$list_extra$List$Extra$find, function(_v0) {
            var id = _v0.aef;
            return _Utils_eq(id, string);
        }, $author$project$Api$Provider$Practice$Emr$options);
    };
    var $author$project$Api$Provider$Practice$Emr$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        var _v0 = $author$project$Api$Provider$Practice$Emr$fromValue(string);
        if (!_v0.$) {
            var emr = _v0.a;
            return $elm$json$Json$Decode$succeed(emr);
        } else return $elm$json$Json$Decode$fail('Unsupported emr option: ' + string);
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$PracticeOnboarding$Shared$PracticeOnboarding = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeOnboarding$Shared$Record = F2(function(id, accountStep) {
        return {
            Im: accountStep,
            aef: id
        };
    });
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Communications = 5;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$ContactInfo = 1;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Legal = 6;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$MembershipPricing = 2;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$NotOnboarding = 8;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$NotStarted = 0;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$PatientAgreements = 3;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$Profile = 4;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$SetupCompleted = 7;
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$decode = A2($elm$json$Json$Decode$map, function(string) {
        switch(string){
            case 'not_started':
                return 0;
            case 'contact_info':
                return 1;
            case 'membership_pricing':
                return 2;
            case 'patient_agreements':
                return 3;
            case 'users_setup':
                return 4;
            case 'communications_setup':
                return 5;
            case 'legal_setup':
                return 6;
            case 'setup_completed':
                return 7;
            default:
                return 8;
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$PracticeOnboarding$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'account_step', $author$project$Api$Provider$PracticeOnboarding$AccountStep$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeOnboarding$Shared$Record)));
    var $author$project$Api$Provider$PracticeOnboarding$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeOnboarding$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SignupSettings$Min$SignupSettings = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SignupSettings$Min$Record = function(customJavascriptText) {
        return {
            MV: customJavascriptText
        };
    };
    var $author$project$Api$Provider$SignupSettings$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'custom_javascript_text', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupSettings$Min$Record));
    var $author$project$Api$Provider$SignupSettings$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SignupSettings$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$User$Min$User = $elm$core$Basics$identity;
    var $author$project$Api$Provider$User$Min$Record = function(name) {
        return {
            zr: name
        };
    };
    var $author$project$Api$Provider$User$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$User$Min$Record));
    var $author$project$Api$Provider$User$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$User$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Expandable$Expanded = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Expandable$NotExpanded = {
        $: 1
    };
    var $author$project$Api$Expandable$expandable = F2(function(key, decoder) {
        return A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, key, $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($author$project$Api$Expandable$NotExpanded),
            A2($elm$json$Json$Decode$map, $author$project$Api$Expandable$Expanded, decoder)
        ])), $author$project$Api$Expandable$NotExpanded);
    });
    var $author$project$Api$Provider$CustomForm$CustomForm = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CustomForm$FormQuestion = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Form$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$FormItem$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CustomForm$Boolean = 0;
    var $author$project$Api$Provider$CustomForm$MultipleStrings = 1;
    var $author$project$Api$Provider$CustomForm$String = 2;
    var $author$project$Api$Provider$CustomForm$itemTypeToQuestionType = function(type_) {
        switch(type_){
            case 0:
                return 0;
            case 1:
                return 1;
            default:
                return 2;
        }
    };
    var $author$project$Api$Provider$Form$Shared$items = function(_v0) {
        var record = _v0;
        return record.PV;
    };
    var $author$project$Api$Provider$Form$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$FormItem$Shared$title = function(_v0) {
        var record = _v0;
        return record.$2;
    };
    var $author$project$Api$Provider$FormItem$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.rc;
    };
    var $author$project$Api$Provider$CustomForm$initFromForm = function(form) {
        var formItems = $author$project$Api$Provider$Form$Shared$items(form);
        var emptyFormQuestion = function(item) {
            return {
                pz: _List_Nil,
                aef: $author$project$Api$Provider$FormItem$Shared$id(item),
                $2: $author$project$Api$Provider$FormItem$Shared$title(item),
                ah5: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType($author$project$Api$Provider$FormItem$Shared$type_(item))
            };
        };
        var questions_ = A2($elm$core$List$map, function(formItem) {
            return emptyFormQuestion(formItem);
        }, formItems);
        return {
            xP: '',
            aef: $author$project$Api$Provider$Form$Shared$id(form),
            zr: $author$project$Api$Provider$Form$Shared$name(form),
            BA: questions_
        };
    };
    var $author$project$Api$Provider$Practice$One$OneMeta = F4(function(hasPractitioners, hasLocations, collectLocationOnSignup, collectPractitionerOnSignup) {
        return {
            acw: collectLocationOnSignup,
            Lx: collectPractitionerOnSignup,
            Qr: hasLocations,
            Qx: hasPractitioners
        };
    });
    var $author$project$Api$Provider$Practice$One$OneMetaEditable = function(editable) {
        return {
            Ot: editable
        };
    };
    var $author$project$Api$Provider$Practice$One$metaEditableDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$OneMetaEditable));
    var $author$project$Api$Provider$Practice$One$metaDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_practitioner_on_signup', $author$project$Api$Provider$Practice$One$metaEditableDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_location_on_signup', $author$project$Api$Provider$Practice$One$metaEditableDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_locations', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_practitioners', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$OneMeta)))));
    var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$Shared = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$Shared$Record));
    var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$sharedDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyInvoiceSetting$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PaymentSourceSetting$Shared$Shared = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PaymentSourceSetting$Shared$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$PaymentSourceSetting$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$Shared$Record));
    var $author$project$Api$Provider$PaymentSourceSetting$Shared$sharedDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PaymentSourceSetting$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Practice$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'has_managed_partner', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'allow_multiple_retail_memberships', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_cancellation_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_customer_link', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_patients_preferred_language', $author$project$Language$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'emr_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'emr', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practice$Emr$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'custom_logo_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'addons', $elm$json$Json$Decode$list($author$project$Api$Provider$Addon$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mailgun_status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'any_retail_brokers', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_membership_start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allowed_zip_codes_on_signup', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'restrict_zip_codes_on_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min_enroll_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($author$project$Api$Expandable$expandable, 'default_plan_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($author$project$Api$Expandable$expandable, 'signup_settings', $author$project$Api$Provider$SignupSettings$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signup_page_not_found_redirect_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_insurance_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allows_payer_on_behalf_on_signup', $author$project$Api$CollectOnSignup$decoder, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'start_date_selectable_on_signup', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_broker_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_lead_source_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_billing_address_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_address_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'merge_duplicate_patients_on_online_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'prepay_first_payment_on_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_confirm_signups', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_payment_source_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redirects_post_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'show_post_signup_footer_button', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_redirect_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_button_label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_ach', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'forms', A2($elm$json$Json$Decode$map, $elm$core$List$map($author$project$Api$Provider$CustomForm$initFromForm), $elm$json$Json$Decode$list($author$project$Api$Provider$Form$Shared$decoder)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_active_companies', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'trans_inclusivity', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'account_type', $author$project$Api$AccountType$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label_billing_as_shipping', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'feature_gates', $elm$json$Json$Decode$list($author$project$Api$Common$FeatureGate$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'network', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Network$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phones', $elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_source_setting', $author$project$Api$Provider$PaymentSourceSetting$Shared$sharedDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_invoice_setting', $author$project$Api$Provider$CompanyInvoiceSetting$Shared$sharedDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'business_location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'companies_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plans_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_to_active_patients_filter', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'engagement_threshold', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_pulse', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ein', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'session_timeout_in_minutes', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'commissions_tracking_from', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'commissions_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'schedule_non_monthly_payment_in_advance_in_days', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'schedule_monthly_payment_in_advance_in_days', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_non_monthly_non_autopay_in_advance_in_days', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_monthly_non_autopay_in_advance_in_days', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_non_monthly_autopay_in_advance_in_days', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_monthly_autopay_in_advance_in_days', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'days_until_access_restricted', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'access_restricted', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collection_warning_status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'days_with_outstanding_balance', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'features', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_onboarding', $elm$json$Json$Decode$nullable($author$project$Api$Provider$PracticeOnboarding$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Practice$One$metaDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'member_portal_signup_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'footer', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'greets_formally', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'salutation', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email_reply_address', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'send_zero_revenue_membership_notification', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fee_plan_type', $author$project$Api$FeePlanType$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location_groups_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'not_retail_plans_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'self_service_request_access_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_location_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_practitioner_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_ssn_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_delete_all_patients', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'onboarded', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_locations_without_group', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_companies_without_default_location', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'require_default_location_for_companies', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'requires_location', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'requires_practitioner', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_patient_mobile', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_patient_email', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_ssn', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'ssn_enabled', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'passthrough_fees_cutoff_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'passthrough_fees_cutoff_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_patients_credit_card_fees', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'track_patients_by_location', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_mfa', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'require_group_for_locations', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$Record))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    var $author$project$Api$Provider$Practice$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practice$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practice$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$One$Practice)));
    var $elm$json$Json$Encode$int = _Json_wrap;
    var $author$project$Api$Provider$Practice$practicePath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Practice$updateAdvanceBilling = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('bill_monthly_autopay_in_advance_in_days', $elm$json$Json$Encode$int(fields.abZ)),
                _Utils_Tuple2('bill_monthly_non_autopay_in_advance_in_days', $elm$json$Json$Encode$int(fields.ab_)),
                _Utils_Tuple2('bill_non_monthly_autopay_in_advance_in_days', $elm$json$Json$Encode$int(fields.ab$)),
                _Utils_Tuple2('bill_non_monthly_non_autopay_in_advance_in_days', $elm$json$Json$Encode$int(fields.ab0)),
                _Utils_Tuple2('schedule_monthly_payment_in_advance_in_days', $elm$json$Json$Encode$int(fields.ag4)),
                _Utils_Tuple2('schedule_non_monthly_payment_in_advance_in_days', $elm$json$Json$Encode$int(fields.ag5))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Admin$AdvanceBilling$updateAdvanceBilling = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Practice$updateAdvanceBilling, apiClient, {
            abZ: A2($elm$core$Maybe$withDefault, 0, fields.abZ),
            ab_: A2($elm$core$Maybe$withDefault, 0, fields.ab_),
            ab$: A2($elm$core$Maybe$withDefault, 0, fields.ab$),
            ab0: A2($elm$core$Maybe$withDefault, 0, fields.ab0),
            ag4: A2($elm$core$Maybe$withDefault, 0, fields.ag4),
            ag5: A2($elm$core$Maybe$withDefault, 0, fields.ag5)
        }, $author$project$Pages$Admin$AdvanceBilling$Updated);
    });
    var $author$project$Pages$Admin$AdvanceBilling$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var type_ = msg.a;
                var frequency = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$Form$init(A3($author$project$Pages$Admin$AdvanceBilling$formFieldsInit, type_, frequency, model.W1)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var field = msg.a;
                var _v1 = model.w;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var form = _v2.a;
                    var updateRequest = _v2.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$AdvanceBilling$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        w: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, updateRequest))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v3 = model.w;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var form = _v4.a;
                    var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$AdvanceBilling$formFieldsValidator, form);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var newForm = _v6.a;
                        var validFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            w: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
                        }), A2($author$project$Pages$Admin$AdvanceBilling$updateAdvanceBilling, model.Ej, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v5.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            w: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                var _v7 = model.w;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var form = _v8.a;
                    if (response.$ === 3) {
                        var practice = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            w: $elm$core$Maybe$Nothing,
                            W1: practice
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Settings successfully updated.'),
                            $author$project$OutMsg$PracticeUpdated(response)
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        w: $elm$core$Maybe$Just(_Utils_Tuple2(form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var id = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var notificationSetting = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bd: A3($elm$core$Dict$insert, id, _Utils_Tuple3(notificationSetting, $author$project$Components$Admin$NotificationSetting$Customize$initFromOne(notificationSetting), A2($author$project$Components$Admin$NotificationSetting$Toggle$init, $author$project$Components$Admin$NotificationSetting$Toggle$oneGetters, notificationSetting)), model.bd)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var setting = msg.a;
                var subMsg = msg.b;
                return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, function(_v11) {
                    var customize = _v11.b;
                    var result = A3($author$project$Components$Admin$NotificationSetting$Customize$update, model.Ej, subMsg, customize);
                    return _Utils_Tuple3(_Utils_update(model, {
                        bd: A3($elm$core$Dict$update, $author$project$Api$Provider$NotificationSetting$One$id(setting), function(tuple) {
                            if (!tuple.$) {
                                var _v13 = tuple.a;
                                var s = _v13.a;
                                var t = _v13.c;
                                return $elm$core$Maybe$Just(_Utils_Tuple3(s, result.zi, t));
                            } else return $elm$core$Maybe$Nothing;
                        }, model.bd)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(setting), result.EQ), result.at);
                }, A2($elm$core$Dict$get, $author$project$Api$Provider$NotificationSetting$One$id(setting), model.bd)));
            default:
                var id = msg.a;
                var toggleNotification = msg.b;
                var subMsg = msg.c;
                var _v14 = A4($author$project$Components$Admin$NotificationSetting$Toggle$update, model.Ej, $author$project$Api$Provider$Notification$PracticeContext, subMsg, toggleNotification);
                var toggleNotification_ = _v14.a;
                var subCmd = _v14.b;
                var subOutMsg = _v14.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    bd: A3($elm$core$Dict$update, id, $elm$core$Maybe$map(function(_v15) {
                        var notificationSetting_ = _v15.a;
                        var customize = _v15.b;
                        return _Utils_Tuple3(notificationSetting_, customize, toggleNotification_);
                    }), model.bd)
                }), A2($elm$core$Platform$Cmd$map, A2($author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg, id, toggleNotification_), subCmd), subOutMsg);
        }
    });
    var $author$project$Ui$Panel$Body = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Panel$body = $author$project$Ui$Panel$Body;
    var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
    var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
    var $author$project$Utils$Html$empty = $elm$html$Html$text('');
    var $author$project$Ui$Panel$Heading = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Panel$heading = $author$project$Ui$Panel$Heading;
    var $elm$html$Html$Attributes$stringProperty = F2(function(key, string) {
        return A2(_VirtualDom_property, key, $elm$json$Json$Encode$string(string));
    });
    var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
    var $elm$html$Html$h4 = _VirtualDom_node('h4');
    var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
    var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
    var $author$project$Ui$Typography$headingSm = function(content) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$h4, _List_fromArray([
            $elm$html$Html$Attributes$class('text-heading-sm text-main')
        ]), content));
    };
    var $author$project$Ui$Element$Margin = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Element$mb2 = $author$project$Ui$Element$Margin('mb-2');
    var $author$project$Ui$Element$Muted = 0;
    var $author$project$Ui$Element$Text = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Element$textMuted = $author$project$Ui$Element$Text(0);
    var $author$project$Ui$Panel$title = function(contents) {
        return $author$project$Ui$Typography$headingSm(contents);
    };
    var $elm$virtual_dom$VirtualDom$node = function(tag) {
        return _VirtualDom_node(_VirtualDom_noScript(tag));
    };
    var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
    var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
    var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
    var $elm$virtual_dom$VirtualDom$attribute = F2(function(key, value) {
        return A2(_VirtualDom_attribute, _VirtualDom_noOnOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlUri(value));
    });
    var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
    var $author$project$Api$Phi$maskElement = $elm$html$Html$Attributes$class('fs-mask');
    var $author$project$Api$Phi$displayAttr = _List_fromArray([
        $author$project$Api$Phi$maskElement,
        A2($elm$html$Html$Attributes$attribute, 'data-recording-sensitive', '')
    ]);
    var $elm$core$List$singleton = function(value) {
        return _List_fromArray([
            value
        ]);
    };
    var $author$project$Utils$Html$Attributes$test = $elm$html$Html$Attributes$attribute('data-test');
    var $author$project$Ui$Alignment$toClassName = function(alignment) {
        switch(alignment.$){
            case 0:
                switch(alignment.a){
                    case 0:
                        var _v1 = alignment.a;
                        return 'text-left';
                    case 1:
                        var _v2 = alignment.a;
                        return 'text-center';
                    default:
                        var _v3 = alignment.a;
                        return 'text-right';
                }
            case 1:
                switch(alignment.a){
                    case 0:
                        var _v4 = alignment.a;
                        return 'flex items-start';
                    case 1:
                        var _v5 = alignment.a;
                        return 'flex items-center';
                    default:
                        var _v6 = alignment.a;
                        return 'flex items-end';
                }
            case 2:
                switch(alignment.a){
                    case 0:
                        var _v7 = alignment.a;
                        return 'flex justify-start';
                    case 1:
                        var _v8 = alignment.a;
                        return 'flex justify-center';
                    default:
                        var _v9 = alignment.a;
                        return 'flex justify-end';
                }
            case 3:
                switch(alignment.a){
                    case 1:
                        var _v10 = alignment.a;
                        return 'flex justify-around';
                    case 0:
                        var _v11 = alignment.a;
                        return 'flex justify-between';
                    default:
                        var _v12 = alignment.a;
                        return 'flex justify-evenly';
                }
            default:
                switch(alignment.a){
                    case 0:
                        var _v13 = alignment.a;
                        return 'flex self-start';
                    case 1:
                        var _v14 = alignment.a;
                        return 'flex self-center';
                    default:
                        var _v15 = alignment.a;
                        return 'flex self-end';
                }
        }
    };
    var $author$project$Ui$Alignment$toClass = function(alignment) {
        return $elm$html$Html$Attributes$class($author$project$Ui$Alignment$toClassName(alignment));
    };
    var $author$project$Ui$ScreenSize$toClassPrefix = function(screenSize) {
        switch(screenSize){
            case 0:
                return '';
            case 1:
                return 'sm:';
            case 2:
                return 'md:';
            case 3:
                return 'lg:';
            default:
                return 'xl:';
        }
    };
    var $author$project$Ui$Element$optionToAttribute = function(option) {
        switch(option.$){
            case 1:
                var alignment = option.a;
                return _List_fromArray([
                    $author$project$Ui$Alignment$toClass(alignment)
                ]);
            case 0:
                var screenSize = option.a;
                var display = option.b;
                return $elm$core$List$singleton(function() {
                    switch(display){
                        case 0:
                            return $elm$html$Html$Attributes$class($author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'block');
                        case 1:
                            return $elm$html$Html$Attributes$class($author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'inline-block');
                        default:
                            return $elm$html$Html$Attributes$class($author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex');
                    }
                }());
            case 2:
                var paddingClass = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$class(paddingClass)
                ]);
            case 3:
                var marginClass = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$class(marginClass)
                ]);
            case 5:
                var style = option.a;
                return $elm$core$List$singleton(function() {
                    switch(style){
                        case 0:
                            return $elm$html$Html$Attributes$class('text-muted');
                        case 1:
                            return $elm$html$Html$Attributes$class('text-body-sm');
                        case 2:
                            return $elm$html$Html$Attributes$class('text-body-md');
                        case 3:
                            return $elm$html$Html$Attributes$class('font-bold');
                        default:
                            return $elm$html$Html$Attributes$class('text-danger');
                    }
                }());
            case 6:
                var testString = option.a;
                return _List_fromArray([
                    $author$project$Utils$Html$Attributes$test(testString)
                ]);
            case 4:
                var _v3 = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('bg-primary-50')
                ]);
            case 7:
                var screenSize = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$class($author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden')
                ]);
            case 8:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('flex flex-wrap')
                ]);
            case 9:
                var val = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('flex gap-' + $elm$core$String$fromInt(val))
                ]);
            case 10:
                var val = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('space-x-' + $elm$core$String$fromInt(val))
                ]);
            case 11:
                var val = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('space-y-' + $elm$core$String$fromInt(val))
                ]);
            case 12:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('flex-auto')
                ]);
            case 13:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('items-stretch')
                ]);
            case 14:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('h-full')
                ]);
            case 15:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('w-full')
                ]);
            case 16:
                return $author$project$Api$Phi$displayAttr;
            default:
                var screenSize = option.a;
                var dir = option.b;
                return $elm$core$List$singleton(function() {
                    if (!dir) return $elm$html$Html$Attributes$class($author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex-row');
                    else return $elm$html$Html$Attributes$class($author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'flex-col');
                }());
        }
    };
    var $author$project$Ui$Element$optionsToAttributes = $elm$core$List$concatMap(A2($elm$core$Basics$composeR, $author$project$Ui$Element$optionToAttribute, $elm$core$List$map($elm$html$Html$Attributes$map($elm$core$Basics$never))));
    var $author$project$Ui$Element$customNode = F3(function(node, classes, options) {
        return A2($elm$html$Html$node, node, A2($elm$core$List$cons, $elm$html$Html$Attributes$class(classes), $author$project$Ui$Element$optionsToAttributes(options)));
    });
    var $author$project$Ui$Element$custom = F2(function(classes, options) {
        return A3($author$project$Ui$Element$customNode, 'div', classes, options);
    });
    var $author$project$Ui$Element$view = $author$project$Ui$Element$custom('');
    var $elm$html$Html$Attributes$classList = function(classes) {
        return $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', A2($elm$core$List$map, $elm$core$Tuple$first, A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
    };
    var $elm$html$Html$div = _VirtualDom_node('div');
    var $author$project$Ui$Panel$defaultOptions = {
        vE: _List_Nil,
        lA: $elm$core$Maybe$Nothing,
        s5: 'panel-default',
        Dx: false
    };
    var $author$project$Ui$Panel$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 4:
                    return _Utils_update(record, {
                        Dx: true
                    });
                case 0:
                    var style = option.a;
                    switch(style){
                        case 0:
                            return _Utils_update(record, {
                                s5: 'panel--primary'
                            });
                        case 1:
                            return _Utils_update(record, {
                                s5: 'panel--success'
                            });
                        case 2:
                            return _Utils_update(record, {
                                s5: 'panel--info'
                            });
                        case 3:
                            return _Utils_update(record, {
                                s5: 'panel--warning'
                            });
                        case 4:
                            return _Utils_update(record, {
                                s5: 'panel--danger'
                            });
                        default:
                            return _Utils_update(record, {
                                s5: 'light-grey-panel'
                            });
                    }
                case 1:
                    return _Utils_update(record, {
                        vE: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('h-full'), record.vE)
                    });
                case 2:
                    return _Utils_update(record, {
                        vE: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('p-6'), record.vE)
                    });
                case 3:
                    return _Utils_update(record, {
                        vE: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('border-left-panel'), record.vE)
                    });
                case 5:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vE: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('panel--active', bool)
                        ])), record.vE)
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        lA: $elm$core$Maybe$Just(bool)
                    });
            }
        }), $author$project$Ui$Panel$defaultOptions, options);
    };
    var $author$project$Ui$Icon$ChevronDown = 13;
    var $author$project$Ui$Icon$Class = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Icon$iconOptionToSvgOption = function(iconOption) {
        return $author$project$Ui$Icon$Class(function() {
            switch(iconOption.$){
                case 0:
                    switch(iconOption.a){
                        case 0:
                            var _v1 = iconOption.a;
                            return 'icon--xs';
                        case 1:
                            var _v2 = iconOption.a;
                            return 'icon--sm';
                        case 2:
                            var _v3 = iconOption.a;
                            return '';
                        case 3:
                            var _v4 = iconOption.a;
                            return 'icon--lg';
                        default:
                            var _v5 = iconOption.a;
                            return 'icon--xl';
                    }
                case 1:
                    switch(iconOption.a){
                        case 0:
                            var _v6 = iconOption.a;
                            return 'icon--danger';
                        case 1:
                            var _v7 = iconOption.a;
                            return 'icon--primary';
                        case 2:
                            var _v8 = iconOption.a;
                            return 'icon--info';
                        case 3:
                            var _v9 = iconOption.a;
                            return 'icon--success';
                        default:
                            var _v10 = iconOption.a;
                            return '';
                    }
                case 7:
                    return 'icon--circled';
                case 2:
                    var deg = iconOption.a;
                    return 'rotate-' + $elm$core$String$fromInt(deg);
                case 3:
                    return 'ml-1';
                case 4:
                    return 'mr-1';
                case 5:
                    var _int = iconOption.a;
                    return 'mb-' + $elm$core$String$fromInt(_int);
                default:
                    var deg = iconOption.a;
                    return 'rotate-' + $elm$core$String$fromInt(deg);
            }
        }());
    };
    var $author$project$Ui$Icon$iconOptionsToSvgOptions = function(iconOptions) {
        return A2($elm$core$List$cons, $author$project$Ui$Icon$Class('icon'), A2($elm$core$List$map, $author$project$Ui$Icon$iconOptionToSvgOption, iconOptions));
    };
    var $elm$virtual_dom$VirtualDom$nodeNS = F2(function(namespace, tag) {
        return A2(_VirtualDom_nodeNS, namespace, _VirtualDom_noScript(tag));
    });
    var $elm$svg$Svg$node = $elm$virtual_dom$VirtualDom$nodeNS('http://www.w3.org/2000/svg');
    var $author$project$Generated$Icons$account = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1.5 -1.5 19 19'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '0.6'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-linejoin', 'round'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.93596 12.3744C3.76355 11.8095 4.58128 11.3727 5.38916 11.064C6.19704 10.7553 7.06732 10.601 8 10.601C8.93268 10.601 9.80952 10.7553 10.6305 11.064C11.4516 11.3727 12.2693 11.8095 13.0837 12.3744C13.6617 11.665 14.069 10.9557 14.3054 10.2463C14.5419 9.53695 14.6601 8.78818 14.6601 8C14.6601 6.10837 14.023 4.52545 12.7488 3.25123C11.4745 1.97701 9.89163 1.3399 8 1.3399C6.10837 1.3399 4.52545 1.97701 3.25123 3.25123C1.97701 4.52545 1.3399 6.10837 1.3399 8C1.3399 8.78818 1.46141 9.53695 1.70443 10.2463C1.94745 10.9557 2.35796 11.665 2.93596 12.3744ZM8 8.63054C7.22496 8.63054 6.578 8.36782 6.05911 7.84236C5.54023 7.31691 5.28079 6.66667 5.28079 5.89163C5.28079 5.12972 5.54351 4.48604 6.06897 3.96059C6.59442 3.43514 7.2381 3.17241 8 3.17241C8.77504 3.17241 9.422 3.43514 9.94089 3.96059C10.4598 4.48604 10.7192 5.13629 10.7192 5.91133C10.7192 6.67324 10.4565 7.31691 9.93103 7.84236C9.40558 8.36782 8.7619 8.63054 8 8.63054ZM8 16C6.90969 16 5.87849 15.7898 4.9064 15.3695C3.93432 14.9491 3.08374 14.3744 2.35468 13.6453C1.62562 12.9163 1.0509 12.069 0.630542 11.1034C0.210181 10.1379 0 9.10345 0 8C0 6.89655 0.210181 5.86207 0.630542 4.89655C1.0509 3.93103 1.62562 3.08374 2.35468 2.35468C3.08374 1.62562 3.93103 1.0509 4.89655 0.630542C5.86207 0.210181 6.89655 0 8 0C9.10345 0 10.1379 0.210181 11.1034 0.630542C12.069 1.0509 12.9163 1.62562 13.6453 2.35468C14.3744 3.08374 14.9491 3.93103 15.3695 4.89655C15.7898 5.86207 16 6.89655 16 8C16 9.09031 15.7898 10.1215 15.3695 11.0936C14.9491 12.0657 14.3744 12.9163 13.6453 13.6453C12.9163 14.3744 12.069 14.9491 11.1034 15.3695C10.1379 15.7898 9.10345 16 8 16ZM8 14.6601C8.70936 14.6601 9.4023 14.5583 10.0788 14.3547C10.7553 14.1511 11.4286 13.7931 12.0985 13.2808C11.4286 12.8079 10.7553 12.4499 10.0788 12.2069C9.4023 11.9639 8.70936 11.8424 8 11.8424C7.29064 11.8424 6.60099 11.9639 5.93103 12.2069C5.26108 12.4499 4.58457 12.8079 3.90148 13.2808C4.57143 13.7931 5.24466 14.1511 5.92118 14.3547C6.5977 14.5583 7.29064 14.6601 8 14.6601ZM8 7.38916C8.4335 7.38916 8.79146 7.25123 9.07389 6.97537C9.35632 6.69951 9.49754 6.33826 9.49754 5.89163C9.49754 5.45813 9.35632 5.10345 9.07389 4.82759C8.79146 4.55172 8.4335 4.41379 8 4.41379C7.5665 4.41379 7.20854 4.55172 6.92611 4.82759C6.64368 5.10345 6.50246 5.45813 6.50246 5.89163C6.50246 6.33826 6.64368 6.69951 6.92611 6.97537C7.20854 7.25123 7.5665 7.38916 8 7.38916Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$accountPricing = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.1471 27L11.5294 23.2167C11.1961 23.0985 10.8333 22.9261 10.4412 22.6995C10.049 22.4729 9.70588 22.2414 9.41176 22.0049L5.91176 23.6305L3 18.4877L6.23529 16.1232C6.19608 15.9655 6.17157 15.7783 6.16176 15.5616C6.15196 15.3448 6.14706 15.1576 6.14706 15C6.14706 14.8424 6.15196 14.6552 6.16176 14.4384C6.17157 14.2217 6.19608 14.0345 6.23529 13.8768L3 11.5123L5.91176 6.36946L9.44118 7.99507C9.71569 7.75862 10.049 7.53202 10.4412 7.31527C10.8333 7.09852 11.1961 6.93103 11.5294 6.81281L12.1471 3H17.8529L18.4706 6.78325C18.8039 6.92118 19.1716 7.0936 19.5735 7.30049C19.9755 7.50739 20.3137 7.73892 20.5882 7.99507L24.1176 6.36946L27 11.5123L23.7647 13.8177C23.8039 13.9951 23.8284 14.1921 23.8382 14.4089C23.848 14.6256 23.8529 14.8227 23.8529 15C23.8529 15.1773 23.848 15.3695 23.8382 15.5764C23.8284 15.7833 23.8039 15.9754 23.7647 16.1527L27 18.4877L24.0882 23.6305L20.5588 22.0049C20.2843 22.2414 19.9559 22.4778 19.5735 22.7143C19.1912 22.9507 18.8235 23.1182 18.4706 23.2167L17.8529 27H12.1471ZM15 18.8424C16.0588 18.8424 16.9608 18.468 17.7059 17.7192C18.451 16.9704 18.8235 16.064 18.8235 15C18.8235 13.936 18.451 13.0296 17.7059 12.2808C16.9608 11.532 16.0588 11.1576 15 11.1576C13.9412 11.1576 13.0392 11.532 12.2941 12.2808C11.549 13.0296 11.1765 13.936 11.1765 15C11.1765 16.064 11.549 16.9704 12.2941 17.7192C13.0392 18.468 13.9412 18.8424 15 18.8424ZM15 17.069C14.4118 17.069 13.9216 16.867 13.5294 16.4631C13.1373 16.0591 12.9412 15.5714 12.9412 15C12.9412 14.4286 13.1373 13.9409 13.5294 13.5369C13.9216 13.133 14.4118 12.931 15 12.931C15.5686 12.931 16.0539 13.133 16.4559 13.5369C16.8578 13.9409 17.0588 14.4286 17.0588 15C17.0588 15.5714 16.8578 16.0591 16.4559 16.4631C16.0539 16.867 15.5686 17.069 15 17.069ZM13.7647 24.9901H16.2353L16.6471 21.6798C17.2941 21.5222 17.9118 21.2759 18.5 20.9409C19.0882 20.6059 19.6176 20.1921 20.0882 19.6995L23.2059 21.0591L24.3235 19.0197L21.5588 17.0099C21.6373 16.6749 21.7059 16.3399 21.7647 16.0049C21.8235 15.67 21.8529 15.335 21.8529 15C21.8529 14.665 21.8284 14.33 21.7794 13.9951C21.7304 13.6601 21.6569 13.3251 21.5588 12.9901L24.3235 10.9803L23.2059 8.94089L20.0882 10.3005C19.6373 9.76847 19.1225 9.32512 18.5441 8.97044C17.9657 8.61576 17.3333 8.39901 16.6471 8.3202L16.2353 5.00985H13.7647L13.3529 8.3202C12.6863 8.43842 12.0588 8.66995 11.4706 9.01478C10.8824 9.35961 10.3529 9.78818 9.88235 10.3005L6.79412 8.94089L5.67647 10.9803L8.41176 12.9901C8.33333 13.3251 8.26961 13.6601 8.22059 13.9951C8.17157 14.33 8.14706 14.665 8.14706 15C8.14706 15.335 8.17157 15.67 8.22059 16.0049C8.26961 16.3399 8.33333 16.6749 8.41176 17.0099L5.67647 19.0197L6.79412 21.0591L9.88235 19.6995C10.3725 20.1921 10.9118 20.6059 11.5 20.9409C12.0882 21.2759 12.7059 21.5222 13.3529 21.6798L13.7647 24.9901Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$add = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 13 13'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.72183 13V7.27817H0V5.72183H5.72183V0H7.27817V5.72183H13V7.27817H7.27817V13H5.72183Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$admin = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -0.5 21 21'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375V9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625V10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM9.05 18H11.025L11.375 15.35C11.8917 15.2167 12.3708 15.0208 12.8125 14.7625C13.2542 14.5042 13.6583 14.1917 14.025 13.825L16.5 14.85L17.475 13.15L15.325 11.525C15.4083 11.2917 15.4667 11.0458 15.5 10.7875C15.5333 10.5292 15.55 10.2667 15.55 10C15.55 9.73333 15.5333 9.47083 15.5 9.2125C15.4667 8.95417 15.4083 8.70833 15.325 8.475L17.475 6.85L16.5 5.15L14.025 6.2C13.6583 5.81667 13.2542 5.49583 12.8125 5.2375C12.3708 4.97917 11.8917 4.78333 11.375 4.65L11.05 2H9.075L8.725 4.65C8.20833 4.78333 7.72917 4.97917 7.2875 5.2375C6.84583 5.49583 6.44167 5.80833 6.075 6.175L3.6 5.15L2.625 6.85L4.775 8.45C4.69167 8.7 4.63333 8.95 4.6 9.2C4.56667 9.45 4.55 9.71667 4.55 10C4.55 10.2667 4.56667 10.525 4.6 10.775C4.63333 11.025 4.69167 11.275 4.775 11.525L2.625 13.15L3.6 14.85L6.075 13.8C6.44167 14.1833 6.84583 14.5042 7.2875 14.7625C7.72917 15.0208 8.20833 15.2167 8.725 15.35L9.05 18ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$alert = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12 0C5.37187 0 0 5.37188 0 12C0 18.6281 5.37187 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0ZM19.2914 19.2914C18.3445 20.2383 17.2406 20.9836 16.0125 21.5016C14.7422 22.0406 13.3922 22.3125 12 22.3125C10.6078 22.3125 9.25781 22.0406 7.9875 21.5039C6.75938 20.9836 5.65781 20.2406 4.70859 19.2937C3.76172 18.3469 3.01641 17.243 2.49844 16.0148C1.95938 14.7422 1.6875 13.3922 1.6875 12C1.6875 10.6078 1.95938 9.25781 2.49609 7.9875C3.01641 6.75937 3.75938 5.65781 4.70625 4.70859C5.65312 3.76172 6.75703 3.01641 7.98516 2.49844C9.25781 1.95938 10.6078 1.6875 12 1.6875C13.3922 1.6875 14.7422 1.95938 16.0125 2.49609C17.2406 3.01641 18.3422 3.75937 19.2914 4.70625C20.2383 5.65312 20.9836 6.75703 21.5016 7.98516C22.0406 9.25781 22.3125 10.6078 22.3125 12C22.3125 13.3922 22.0406 14.7422 21.5039 16.0125C20.9836 17.2406 20.2406 18.3445 19.2914 19.2914ZM14.7703 16.5375H12.7734V8.33203C12.7734 7.86563 12.3961 7.48828 11.9297 7.48828H11.0859H9.67969C9.21328 7.48828 8.83594 7.86563 8.83594 8.33203C8.83594 8.79844 9.21328 9.17578 9.67969 9.17578H11.0859V16.5375H9.08906C8.62266 16.5375 8.24531 16.9148 8.24531 17.3812C8.24531 17.8477 8.62266 18.225 9.08906 18.225H11.0859H12.7734H14.7703C15.2367 18.225 15.6141 17.8477 15.6141 17.3812C15.6141 16.9148 15.2367 16.5375 14.7703 16.5375ZM11.0859 5.16797C11.0859 4.70198 11.4637 4.32422 11.9297 4.32422C12.3957 4.32422 12.7734 4.70198 12.7734 5.16797C12.7734 5.63396 12.3957 6.01172 11.9297 6.01172C11.4637 6.01172 11.0859 5.63396 11.0859 5.16797Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$apiKey = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M280-400q-33 0-56.5-23.5T200-480q0-33 23.5-56.5T280-560q33 0 56.5 23.5T360-480q0 33-23.5 56.5T280-400Zm0 160q-100 0-170-70T40-480q0-100 70-170t170-70q67 0 121.5 33t86.5 87h352l120 120-180 180-80-60-80 60-85-60h-47q-32 54-86.5 87T280-240Zm0-80q56 0 98.5-34t56.5-86h125l58 41 82-61 71 55 75-75-40-40H435q-14-52-56.5-86T280-640q-66 0-113 47t-47 113q0 66 47 113t113 47Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$app = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M200-120q-33 0-56.5-23.5T120-200v-500q0-14 4.5-26.5T138-750l56-68q9-11 20.5-16.5T240-840h480q14 0 25.5 5.5T766-818l56 68q9 11 13.5 23.5T840-700v500q0 33-23.5 56.5T760-120H200Zm16-600h528l-34-40H250l-34 40Zm-16 520h560v-440H200v440Zm382-78 142-142-142-142-58 58 84 84-84 84 58 58Zm-202 0 58-58-84-84 84-84-58-58-142 142 142 142Zm-180 78v-440 440Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$arrowLeft = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 26'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.7065 25.5066L0 12.8283L12.7565 0.0999985L15.5848 2.8218L7.58705 10.8478H33.237V14.8087H7.58705L15.5348 22.7565L12.7065 25.5066Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$arrowRight = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 35 26'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M21.6215 25.4066L18.7932 22.6565L26.741 14.7087H0.886719V10.7478H26.741L18.7432 2.7218L21.5715 0L34.3281 12.7283L21.6215 25.4066Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$arrowRightBottom = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 8 8'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4.75184 8L3.81094 7.16387L5.45953 5.70371H0V0H1.32826V4.52335H5.45953L3.81094 3.05834L4.74639 2.22222L8 5.11353L4.75184 8Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$bolt = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$book = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -920 960 870'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M260-320q47 0 91.5 10.5T440-278v-394q-41-24-87-36t-93-12q-36 0-71.5 7T120-692v396q35-12 69.5-18t70.5-6Zm260 42q44-21 88.5-31.5T700-320q36 0 70.5 6t69.5 18v-396q-33-14-68.5-21t-71.5-7q-47 0-93 12t-87 36v394Zm-40 118q-48-38-104-59t-116-21q-42 0-82.5 11T100-198q-21 11-40.5-1T40-234v-482q0-11 5.5-21T62-752q46-24 96-36t102-12q58 0 113.5 15T480-740q51-30 106.5-45T700-800q52 0 102 12t96 36q11 5 16.5 15t5.5 21v482q0 23-19.5 35t-40.5 1q-37-20-77.5-31T700-240q-60 0-116 21t-104 59ZM280-494Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$burgerMenu = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '16'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 2V0H16V2H0ZM0 7H16V5H0V7ZM0 12H16V10H0V12Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$burgerMenuClose = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '16'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '16'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '8 8 14 14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.92918 9.3427L20.6571 22.0706L22.0713 20.6564L9.34339 7.92849L7.92918 9.3427Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M20.6571 7.92893L7.92913 20.6569L9.34334 22.0711L22.0713 9.34315L20.6571 7.92893Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$businessCenter = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M146.67-120q-27 0-46.84-19.83Q80-159.67 80-186.67v-466.66q0-27 19.83-46.84Q119.67-720 146.67-720H320v-93.33q0-27 19.83-46.84Q359.67-880 386.67-880h186.66q27 0 46.84 19.83Q640-840.33 640-813.33V-720h173.33q27 0 46.84 19.83Q880-680.33 880-653.33v466.66q0 27-19.83 46.84Q840.33-120 813.33-120H146.67Zm240-600h186.66v-93.33H386.67V-720Zm426.66 352.67H580.67v66.66h-200v-66.66h-234v180.66h666.66v-180.66Zm-366 0H514V-434h-66.67v66.67ZM146.67-434h234v-66.67h200V-434h232.66v-219.33H146.67V-434ZM480-400.67Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$calendar = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 20 22'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$call = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M795-120q-116 0-236.5-56T335-335Q232-438 176-558.5T120-795q0-19.29 12.86-32.14Q145.71-840 165-840h140q14 0 24 10t14 25l26.93 125.64Q372-665 369.5-653.5t-10.73 19.73L259-533q26 44 55 82t64 72q37 38 78 69.5t86 55.5l95-98q10-11 23.15-15 13.15-4 25.85-2l119 26q15 4 25 16.04 10 12.05 10 26.96v135q0 19.29-12.86 32.14Q814.29-120 795-120ZM229-588l81-82-23-110H180q2 42 13.5 88.5T229-588Zm369 363q41 19 89 31t93 14v-107l-103-21-79 83ZM229-588Zm369 363Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$cart = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M223.5-103.5Q200-127 200-160t23.5-56.5Q247-240 280-240t56.5 23.5Q360-193 360-160t-23.5 56.5Q313-80 280-80t-56.5-23.5Zm400 0Q600-127 600-160t23.5-56.5Q647-240 680-240t56.5 23.5Q760-193 760-160t-23.5 56.5Q713-80 680-80t-56.5-23.5ZM246-720l96 200h280l110-200H246Zm-38-80h590q23 0 35 20.5t1 41.5L692-482q-11 20-29.5 31T622-440H324l-44 80h480v80H280q-45 0-68-39.5t-2-78.5l54-98-144-304H40v-80h130l38 80Zm134 280h280-280Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$check = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 10 8'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M9.22494 0.671064C9.03255 0.497837 8.73617 0.51337 8.56294 0.705758L3.31035 6.53935L1.44406 4.46663C1.27083 4.27424 0.97444 4.25871 0.782052 4.43193C0.589664 4.60516 0.574131 4.90155 0.747358 5.09394L2.95557 7.54641C3.08001 7.68461 3.268 7.73155 3.43534 7.68281C3.52259 7.66093 3.6045 7.61374 3.66921 7.54186L9.25964 1.33307C9.43286 1.14068 9.41733 0.844291 9.22494 0.671064Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$chevron = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-2 0 13 13'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 2L7 6.5L2 11'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.5'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-linecap', 'square')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$chevronDown = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 8'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M11.9741 0.991346L6.07575 7.84129L0.177371 0.991345L1.06142 0.230102L6.07575 6.05338L11.0901 0.230103L11.9741 0.991346Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$circle = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'circle', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'cx', '12'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'cy', '12'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'r', '10')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$commissions = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-8 -8 64 64'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.5 21C7.6 21 5.125 19.975 3.075 17.925C1.025 15.875 0 13.4 0 10.5C0 7.6 1.025 5.125 3.075 3.075C5.125 1.025 7.6 0 10.5 0C13.4 0 15.875 1.025 17.925 3.075C19.975 5.125 21 7.6 21 10.5C21 13.4 19.975 15.875 17.925 17.925C15.875 19.975 13.4 21 10.5 21ZM10.5 15C11.75 15 12.8125 14.5625 13.6875 13.6875C14.5625 12.8125 15 11.75 15 10.5C15 9.25 14.5625 8.1875 13.6875 7.3125C12.8125 6.4375 11.75 6 10.5 6C9.25 6 8.1875 6.4375 7.3125 7.3125C6.4375 8.1875 6 9.25 6 10.5C6 11.75 6.4375 12.8125 7.3125 13.6875C8.1875 14.5625 9.25 15 10.5 15ZM37.5 48C34.6 48 32.125 46.975 30.075 44.925C28.025 42.875 27 40.4 27 37.5C27 34.6 28.025 32.125 30.075 30.075C32.125 28.025 34.6 27 37.5 27C40.4 27 42.875 28.025 44.925 30.075C46.975 32.125 48 34.6 48 37.5C48 40.4 46.975 42.875 44.925 44.925C42.875 46.975 40.4 48 37.5 48ZM37.5 42C38.75 42 39.8125 41.5625 40.6875 40.6875C41.5625 39.8125 42 38.75 42 37.5C42 36.25 41.5625 35.1875 40.6875 34.3125C39.8125 33.4375 38.75 33 37.5 33C36.25 33 35.1875 33.4375 34.3125 34.3125C33.4375 35.1875 33 36.25 33 37.5C33 38.75 33.4375 39.8125 34.3125 40.6875C35.1875 41.5625 36.25 42 37.5 42ZM4.2 48L0 43.8L43.8 0L48 4.2L4.2 48Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$contact = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 22 22'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 14.85C2.9 13.9667 3.94583 13.2708 5.1375 12.7625C6.32917 12.2542 7.61667 12 9 12C10.3833 12 11.6708 12.2542 12.8625 12.7625C14.0542 13.2708 15.1 13.9667 16 14.85V2H2V14.85ZM9 10C9.96667 10 10.7917 9.65833 11.475 8.975C12.1583 8.29167 12.5 7.46667 12.5 6.5C12.5 5.53333 12.1583 4.70833 11.475 4.025C10.7917 3.34167 9.96667 3 9 3C8.03333 3 7.20833 3.34167 6.525 4.025C5.84167 4.70833 5.5 5.53333 5.5 6.5C5.5 7.46667 5.84167 8.29167 6.525 8.975C7.20833 9.65833 8.03333 10 9 10ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM3.725 16H14.275C13.5417 15.35 12.7125 14.8542 11.7875 14.5125C10.8625 14.1708 9.93333 14 9 14C8.06667 14 7.12917 14.1708 6.1875 14.5125C5.24583 14.8542 4.425 15.35 3.725 16ZM9 8C8.58333 8 8.22917 7.85417 7.9375 7.5625C7.64583 7.27083 7.5 6.91667 7.5 6.5C7.5 6.08333 7.64583 5.72917 7.9375 5.4375C8.22917 5.14583 8.58333 5 9 5C9.41667 5 9.77083 5.14583 10.0625 5.4375C10.3542 5.72917 10.5 6.08333 10.5 6.5C10.5 6.91667 10.3542 7.27083 10.0625 7.5625C9.77083 7.85417 9.41667 8 9 8Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$copy = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.24141 9.90068V0H11.0769V9.90068H2.24141ZM3.60072 8.62754H9.70315V1.28668H3.60072V8.62754ZM0 12V2.66817H1.37377V10.7133H8.09801V12H0ZM3.60072 8.62754V1.28668V8.62754Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$cross = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 10 9'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.72526 4.20443L9.04297 0.889323C9.24349 0.688802 9.24349 0.364583 9.04297 0.165365C8.84245 -0.0351562 8.51823 -0.0351562 8.31901 0.165365L5 3.47917L1.68099 0.164062C1.48047 -0.0364583 1.15625 -0.0364583 0.957031 0.164062C0.75651 0.364583 0.75651 0.688802 0.957031 0.888021L4.27474 4.20312L0.957031 7.51953C0.75651 7.72005 0.75651 8.04427 0.957031 8.24349C1.05729 8.34375 1.1888 8.39323 1.31901 8.39323C1.45052 8.39323 1.58073 8.34375 1.68099 8.24349L5 4.92839L8.31901 8.24479C8.41927 8.34505 8.54948 8.39453 8.68099 8.39453C8.8125 8.39453 8.94271 8.34505 9.04297 8.24479C9.24349 8.04427 9.24349 7.72005 9.04297 7.52083L5.72526 4.20443Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$crossCircle = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M9.80534 4.18684C9.61257 3.99543 9.30085 3.99543 9.10944 4.18821L6.99987 6.30325L4.8903 4.18821C4.6989 3.99543 4.38718 3.99543 4.1944 4.18684C4.00163 4.37825 4.00163 4.68997 4.19304 4.88274L6.30534 7.00051L4.19304 9.11829C4.00163 9.31106 4.00163 9.62278 4.1944 9.81418C4.29011 9.90989 4.41589 9.95774 4.54167 9.95774C4.66745 9.95774 4.7946 9.90989 4.8903 9.81282L6.99987 7.69778L9.10944 9.81418C9.20515 9.91125 9.33229 9.95911 9.45808 9.95911C9.58386 9.95911 9.70964 9.91125 9.80534 9.81555C9.99811 9.62415 9.99811 9.31243 9.80671 9.11965L7.6944 7.00051L9.80534 4.88274C9.99811 4.68997 9.99811 4.37825 9.80534 4.18684ZM7 0C3.13359 0 0 3.13359 0 7C0 10.8664 3.13359 14 7 14C10.8664 14 14 10.8664 14 7C14 3.13359 10.8664 0 7 0ZM11.2533 11.2533C10.701 11.8057 10.057 12.2404 9.34062 12.5426C8.59961 12.857 7.81211 13.0156 7 13.0156C6.18789 13.0156 5.40039 12.857 4.65938 12.5439C3.94297 12.2404 3.30039 11.807 2.74668 11.2547C2.19434 10.7023 1.75957 10.0584 1.45742 9.34199C1.14297 8.59961 0.984375 7.81211 0.984375 7C0.984375 6.18789 1.14297 5.40039 1.45605 4.65938C1.75957 3.94297 2.19297 3.30039 2.74531 2.74668C3.29766 2.19434 3.9416 1.75957 4.65801 1.45742C5.40039 1.14297 6.18789 0.984375 7 0.984375C7.81211 0.984375 8.59961 1.14297 9.34062 1.45605C10.057 1.75957 10.6996 2.19297 11.2533 2.74531C11.8057 3.29766 12.2404 3.9416 12.5426 4.65801C12.857 5.40039 13.0156 6.18789 13.0156 7C13.0156 7.81211 12.857 8.59961 12.5439 9.34062C12.2404 10.057 11.807 10.701 11.2533 11.2533Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$dashboard = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 20 22'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 16H5V10H11V16H14V7L8 2.5L2 7V16ZM0 18V6L8 0L16 6V18H9V12H7V18H0Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$decrease = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M480-360 280-560h400L480-360Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$delete = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 38'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.67175 37.6098C4.72348 37.6098 3.91667 37.2783 3.2513 36.6153C2.58593 35.9523 2.25325 35.1483 2.25325 34.2033V5.90655H0V2.5H9.91415V0.784798H23.5087V2.5H33.4348V5.90655H31.1816V34.2033C31.1816 35.1233 30.8426 35.921 30.1648 36.5965C29.4869 37.272 28.6863 37.6098 27.7631 37.6098H5.67175ZM27.7631 5.90655H5.67175V34.2033H27.7631V5.90655ZM10.912 29.9989H14.1152V10.0489H10.912V29.9989ZM19.3196 29.9989H22.5348V10.0489H19.3196V29.9989Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$demography = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M762.5-257.5Q780-275 780-300t-17.5-42.5Q745-360 720-360t-42.5 17.5Q660-325 660-300t17.5 42.5Q695-240 720-240t42.5-17.5ZM779-136q27-16 43-42-23-12-48.5-19t-53.5-7q-28 0-53.5 7T618-178q16 26 43 42t59 16q32 0 59-16Zm-563-8q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v258q-17.1-5.76-35.1-9.92T744-502v-242H216v528h241q1.88 19.52 5.94 37.26Q467-161 473-144H216Zm0-96v24-528 242-2 264Zm72-48h172q4-19 10.19-36.97Q476.38-342.93 484-360H288v72Zm0-156h264q26-20 56-34.5t64-20.5v-17H288v72Zm0-156h384v-72H288v72ZM719.77-48Q640-48 584-104.23q-56-56.22-56-136Q528-320 584.23-376q56.22-56 136-56Q800-432 856-375.77q56 56.22 56 136Q912-160 855.77-104q-56.22 56-136 56Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$dev = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M224-358h98.67q20.1 0 34.38-14.28 14.28-14.29 14.28-34.39v-146.66q0-20.1-14.28-34.39Q342.77-602 322.67-602H224v244Zm48.67-48.67v-146.66h50v146.66h-50ZM433-358h100.67v-48.67h-82v-52h52v-44h-52v-50.66h82V-602H433.31q-13.31 0-21.81 8.5Q403-585 403-572v183.73q0 13.27 8.5 21.77T433-358Zm246.57-9.5q10.1-8.5 13.76-21.5L756-602h-50.67l-49.66 168L606-602h-50.67L618-389q3.67 13 13.76 21.5t23.91 8.5q13.81 0 23.9-8.5ZM186.67-120q-27 0-46.84-19.83Q120-159.67 120-186.67v-586.66q0-27 19.83-46.84Q159.67-840 186.67-840h586.66q27 0 46.84 19.83Q840-800.33 840-773.33v586.66q0 27-19.83 46.84Q800.33-120 773.33-120H186.67Zm0-66.67h586.66v-586.66H186.67v586.66Zm0-586.66v586.66-586.66Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$dollar = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2.89385 14V12.3609C2.1378 12.2323 1.51862 11.9463 1.03631 11.5028C0.554004 11.0592 0.208566 10.4968 0 9.81543L1.19274 9.35262C1.41434 9.98255 1.73371 10.4454 2.15084 10.741C2.56797 11.0367 3.0568 11.1846 3.61732 11.1846C4.24302 11.1846 4.7514 11.0335 5.14246 10.7314C5.53352 10.4293 5.72905 10.0211 5.72905 9.50689C5.72905 8.95409 5.54656 8.52341 5.18156 8.21488C4.81657 7.90633 4.14525 7.5978 3.1676 7.28926C2.22905 6.99357 1.5284 6.59825 1.06564 6.1033C0.602887 5.60836 0.371508 4.98806 0.371508 4.24242C0.371508 3.54821 0.596368 2.95684 1.04609 2.46832C1.49581 1.9798 2.11173 1.69697 2.89385 1.61983V0H4.1257V1.61983C4.71229 1.69697 5.22393 1.89624 5.66061 2.21763C6.0973 2.53903 6.42644 2.95041 6.64804 3.45179L5.45531 3.95317C5.27281 3.55464 5.0284 3.25895 4.72207 3.06612C4.41574 2.87328 4.02142 2.77686 3.53911 2.77686C2.95251 2.77686 2.48976 2.90542 2.15084 3.16253C1.81192 3.41965 1.64246 3.77319 1.64246 4.22314C1.64246 4.68595 1.82821 5.0652 2.19972 5.36088C2.57123 5.65657 3.29143 5.9651 4.36033 6.2865C5.25978 6.56933 5.92458 6.96786 6.35475 7.48209C6.78492 7.99633 7 8.64555 7 9.42975C7 10.2525 6.75559 10.9146 6.26676 11.416C5.77793 11.9174 5.06425 12.2388 4.1257 12.3802V14H2.89385Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$dots = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 3'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.7622 2.02143C1.55894 2.02143 1.3811 1.94521 1.22866 1.79277C1.07622 1.64033 1 1.45741 1 1.24399C1 1.03058 1.07622 0.84765 1.22866 0.695211C1.3811 0.542772 1.56402 0.466553 1.77744 0.466553C1.98069 0.466553 2.15854 0.542772 2.31098 0.695211C2.46341 0.84765 2.53963 1.03058 2.53963 1.24399C2.53963 1.45741 2.46341 1.64033 2.31098 1.79277C2.15854 1.94521 1.97561 2.02143 1.7622 2.02143ZM6 2.02143C5.78658 2.02143 5.60366 1.94521 5.45122 1.79277C5.29878 1.64033 5.22256 1.45741 5.22256 1.24399C5.22256 1.03058 5.29878 0.84765 5.45122 0.695211C5.60366 0.542772 5.78658 0.466553 6 0.466553C6.21341 0.466553 6.39634 0.542772 6.54878 0.695211C6.70122 0.84765 6.77744 1.03058 6.77744 1.24399C6.77744 1.45741 6.70122 1.64033 6.54878 1.79277C6.39634 1.94521 6.21341 2.02143 6 2.02143ZM10.2226 2.02143C10.0091 2.02143 9.82876 1.94521 9.6814 1.79277C9.53404 1.64033 9.46036 1.45741 9.46036 1.24399C9.46036 1.03058 9.53658 0.84765 9.68902 0.695211C9.84146 0.542772 10.0244 0.466553 10.2378 0.466553C10.4512 0.466553 10.6316 0.542772 10.779 0.695211C10.9263 0.84765 11 1.03058 11 1.24399C11 1.45741 10.9238 1.64033 10.7713 1.79277C10.6189 1.94521 10.436 2.02143 10.2226 2.02143Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '0.5')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$edit = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 9 9'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.99474 2.53088L6.46912 1.00526L7.46255 0L9 1.52562L7.99474 2.53088ZM0 9V7.47438L5.9724 1.50197L7.49803 3.02759L1.52562 9H0Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$employeeUploads = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M13.8079 23.1872H15.5813V17.2167L18.0049 19.6404L19.2463 18.399L14.6355 13.9064L10.0837 18.4581L11.3251 19.6995L13.8079 17.2167V23.1872ZM5 27V3H17.7094L24.2709 9.56158V27H5ZM16.6749 10.5074V5.00985H7.00985V24.9901H22.2611V10.5074H16.6749Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$employees = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 25.8526V22.5893C0 21.7844 0.206677 21.0555 0.620031 20.4029C1.03339 19.7502 1.60991 19.2607 2.34959 18.9344C3.93774 18.2382 5.37904 17.7378 6.67349 17.4333C7.96795 17.1287 9.28959 16.9764 10.6384 16.9764C12.0308 16.9764 13.3633 17.1287 14.636 17.4333C15.9087 17.7378 17.3391 18.2382 18.9273 18.9344C19.667 19.2607 20.2489 19.7502 20.6731 20.4029C21.0974 21.0555 21.3095 21.7844 21.3095 22.5893V25.8526H0ZM19.5473 16.9111C21.0049 17.0852 22.381 17.3408 23.6754 17.678C24.9699 18.0152 26.0304 18.3905 26.8571 18.8039C27.5751 19.2172 28.1516 19.7502 28.5867 20.4029C29.0218 21.0555 29.2394 21.7952 29.2394 22.6219V25.8526H23.3328V22.5893C23.3328 21.2187 22.9901 20.082 22.3048 19.1791C21.6195 18.2763 20.7003 17.5203 19.5473 16.9111ZM10.6711 14.9858C9.19169 14.9858 7.9897 14.518 7.06509 13.5825C6.14048 12.6471 5.67818 11.4505 5.67818 9.99288C5.67818 8.51351 6.14048 7.31152 7.06509 6.38691C7.9897 5.4623 9.18081 5 10.6384 5C12.1178 5 13.3252 5.4623 14.2607 6.38691C15.1962 7.31152 15.6639 8.51351 15.6639 9.99288C15.6639 11.4505 15.1962 12.6471 14.2607 13.5825C13.3252 14.518 12.1287 14.9858 10.6711 14.9858ZM22.6801 9.99288C22.6801 11.4505 22.2178 12.6471 21.2932 13.5825C20.3686 14.518 19.1666 14.9858 17.6872 14.9858C17.4479 14.9858 17.1814 14.9695 16.8877 14.9368C16.594 14.9042 16.3275 14.8335 16.0882 14.7247C16.6103 14.1808 17.0073 13.5064 17.2793 12.7014C17.5512 11.8965 17.6872 10.9936 17.6872 9.99288C17.6872 8.99213 17.5512 8.11103 17.2793 7.34959C17.0073 6.58815 16.6103 5.8811 16.0882 5.22843C16.3275 5.16317 16.594 5.10878 16.8877 5.06527C17.1814 5.02176 17.4479 5 17.6872 5C19.1666 5 20.3686 5.46774 21.2932 6.40323C22.2178 7.33871 22.6801 8.53527 22.6801 9.99288ZM2.25169 23.6336H19.0578V22.6219C19.0578 22.2739 18.9545 21.9366 18.7478 21.6103C18.5411 21.284 18.2855 21.0555 17.9809 20.925C16.4363 20.2506 15.1418 19.7937 14.0976 19.5544C13.0533 19.3151 11.9002 19.1955 10.6384 19.1955C9.42012 19.1955 8.27252 19.3151 7.19563 19.5544C6.11873 19.7937 4.81884 20.2506 3.29596 20.925C2.99138 21.0555 2.74119 21.284 2.54539 21.6103C2.34959 21.9366 2.25169 22.2739 2.25169 22.6219V23.6336ZM10.6384 12.832C11.4651 12.832 12.1504 12.5655 12.6943 12.0325C13.2382 11.4995 13.5102 10.8196 13.5102 9.99288C13.5102 9.16617 13.2437 8.48088 12.7106 7.93699C12.1776 7.3931 11.4978 7.12116 10.6711 7.12116C9.84436 7.12116 9.15906 7.3931 8.61517 7.93699C8.07128 8.48088 7.79934 9.16617 7.79934 9.99288C7.79934 10.8196 8.07128 11.4995 8.61517 12.0325C9.15906 12.5655 9.83348 12.832 10.6384 12.832Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$enter = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 13 12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.92857 1H11.5V7.86957H1.5M1.5 7.86957L4.5 4.73913M1.5 7.86957L4.5 11'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$eraser = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M702.91-242.87h144.5q19.16 0 32.33 13.17 13.17 13.18 13.17 32.33t-13.17 32.33q-13.17 13.17-32.33 13.17h-235.5l91-91Zm-502.84 91q-9.2 0-17.54-3.36-8.33-3.36-15.05-10.07l-72.05-72.05q-26.34-26.35-26.72-64.53-.38-38.19 25.96-65.53l437.85-450.98q26.35-27.35 64.27-27.23 37.93.12 64.28 26.47l193.97 193.98q26.35 26.34 26.35 64.65 0 38.3-26.35 64.65L531.28-165.54q-6.71 6.71-15.05 10.19-8.34 3.48-17.53 3.48H200.07Zm279.23-91 311.85-318.41L597.93-754.5 158.57-303.52l60.65 60.65H479.3ZM480-480Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$exit = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.5285 10.5191L9.59892 9.58197L11.5149 7.65027H4.95122V6.34973H11.477L9.56098 4.41803L10.4905 3.48087L14 7.01913L10.5285 10.5191ZM0 14V0H6.84824V1.30055H1.30894V12.6995H6.84824V14H0Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$export = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 15'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.51131 11.2051L2.94118 6.69162L4.04977 5.59132L6.74208 8.26347V0H8.28054V8.26347L10.9729 5.59132L12.0814 6.69162L7.51131 11.2051ZM1.53846 15C1.13122 15 0.773002 14.8503 0.463801 14.5509C0.1546 14.2515 0 13.8922 0 13.4731V10.015H1.53846V13.4731H13.4615V10.015H15V13.4731C15 13.8922 14.8492 14.2515 14.5475 14.5509C14.2459 14.8503 13.8839 15 13.4615 15H1.53846Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$favicon = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '800'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 1000'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'defs', _List_Nil, _List_fromArray([
                A3($elm$svg$Svg$node, 'linearGradient', _List_fromArray([
                    A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient1'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '681.6406'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1557.7874'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '681.6406'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '557.7873'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
                ]), _List_fromArray([
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
                    ]), _List_Nil),
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#00BFFF')
                    ]), _List_Nil)
                ])),
                A3($elm$svg$Svg$node, 'linearGradient', _List_fromArray([
                    A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient2'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '0'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1239.5522'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '1000'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '1239.5522'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
                ]), _List_fromArray([
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1D63F2')
                    ]), _List_Nil),
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
                    ]), _List_Nil)
                ]))
            ])),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M363.3 363.9C363.3 363.9 363.3 321.3 363.3 318.2C363.3 142.5 505.9 0 681.6 0C857.3 0 1000 142.5 1000 318.2V1000L590.6 727.5L363.3 363.9Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient1)')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M364.1 363.5C364.1 363.5 321.5 363.5 318.4 363.5C142.6 363.5 0 506.1 0 681.8C0 857.5 142.6 1000 318.4 1000H1000L364.1 363.5Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient2)')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$file = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '39'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 52 52'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 0H20.2759L24 3.75114H48V39H0V0ZM4.0197 4.1084V34.9511H43.9803V7.8H22.3448L18.6207 4.1084H4.0197ZM4.0197 34.9511V4.1084V34.9511Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$filter = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.18883 12V8.16667H6.3V9.53333H12V10.6445H6.3V12H5.18883ZM0 10.6445V9.53333H4.07783V10.6445H0ZM2.96667 7.91117V6.5555H0V5.4445H2.96667V4.06667H4.07783V7.91117H2.96667ZM5.18883 6.5555V5.4445H12V6.5555H5.18883ZM7.92217 3.83333V0H9.03333V1.3555H12V2.46667H9.03333V3.83333H7.92217ZM0 2.46667V1.3555H6.81117V2.46667H0Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$flag = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 18'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 18V0H9.2549L9.75164 2.23699H16V12.1734H9.01961L8.52288 9.96243H1.77778V18H0ZM10.5359 10.4046H14.2222V4.00578H8.2353L7.73856 1.76879H1.77778V8.19364H10.0392L10.5359 10.4046Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$form = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 18 22'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4 16H12V14H4V16ZM4 12H12V10H4V12ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$gift = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M160-80v-440H80v-240h208q-5-9-6.5-19t-1.5-21q0-50 35-85t85-35q23 0 43 8.5t37 23.5q17-16 37-24t43-8q50 0 85 35t35 85q0 11-2 20.5t-6 19.5h208v240h-80v440H160Zm371.5-748.5Q520-817 520-800t11.5 28.5Q543-760 560-760t28.5-11.5Q600-783 600-800t-11.5-28.5Q577-840 560-840t-28.5 11.5ZM360-800q0 17 11.5 28.5T400-760q17 0 28.5-11.5T440-800q0-17-11.5-28.5T400-840q-17 0-28.5 11.5T360-800ZM160-680v80h280v-80H160Zm280 520v-360H240v360h200Zm80 0h200v-360H520v360Zm280-440v-80H520v80h280Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$groups = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$help = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M513.5-254.5Q528-269 528-290t-14.5-35.5Q499-340 478-340t-35.5 14.5Q428-311 428-290t14.5 35.5Q457-240 478-240t35.5-14.5ZM442-394h74q0-33 7.5-52t42.5-52q26-26 41-49.5t15-56.5q0-56-41-86t-97-30q-57 0-92.5 30T342-618l66 26q5-18 22.5-39t53.5-21q32 0 48 17.5t16 38.5q0 20-12 37.5T506-526q-44 39-54 59t-10 73Zm38 314q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$hint404 = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '190'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '69'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 190 69'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M81.9569 68.9947H129.013L129.021 69V68.9947H129.026L129.021 68.9895V21.9569C129.021 9.83247 119.188 0 107.064 0C98.5922 0 91.2394 4.80054 87.5781 11.8292L91.5 24.5L96 18L101.5 39L105 33.5L122.5 64.5L106 47.5L100.5 54.5L92.5 36.5L88 44L78.1371 25.4122C67.8329 27.2205 60 36.2162 60 47.0378C60 59.1623 69.8325 68.9947 81.9569 68.9947Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#paint0_linear_24_321)')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M30.19 55.2733H0.320007V43.0933L28.2567 0.559998H44.11V43.0933H52.9067V55.2733H44.11V69H30.19V55.2733ZM30.19 19.5067H29.9967L14.82 43.0933H30.19V19.5067Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#1D66F3')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M167.19 55.2733H137.32V43.0933L165.257 0.559998H181.11V43.0933H189.907V55.2733H181.11V69H167.19V55.2733ZM167.19 19.5067H166.997L151.82 43.0933H167.19V19.5067Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#06B0FE')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'defs', _List_Nil, _List_fromArray([
                A3($elm$svg$Svg$node, 'linearGradient', _List_fromArray([
                    A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'paint0_linear_24_321'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '73'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '63'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '116.5'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '27'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
                ]), _List_fromArray([
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1D66F3')
                    ]), _List_Nil),
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0.371318'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1483F7')
                    ]), _List_Nil),
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0.655803'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#06ACFC')
                    ]), _List_Nil),
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#00BFFF')
                    ]), _List_Nil)
                ]))
            ]))
        ]));
    };
    var $author$project$Generated$Icons$hintHeart = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1000 1000'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'defs', _List_Nil, _List_fromArray([
                A3($elm$svg$Svg$node, 'linearGradient', _List_fromArray([
                    A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient1'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '681.6406'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1557.7874'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '681.6406'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '557.7873'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
                ]), _List_fromArray([
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
                    ]), _List_Nil),
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#00BFFF')
                    ]), _List_Nil)
                ])),
                A3($elm$svg$Svg$node, 'linearGradient', _List_fromArray([
                    A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'gradient2'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x1', '0'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y1', '1239.5522'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x2', '1000'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y2', '1239.5522'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'gradientUnits', 'userSpaceOnUse')
                ]), _List_fromArray([
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '0'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#1D63F2')
                    ]), _List_Nil),
                    A3($elm$svg$Svg$node, 'stop', _List_fromArray([
                        A2($elm$virtual_dom$VirtualDom$attribute, 'offset', '1'),
                        A2($elm$virtual_dom$VirtualDom$attribute, 'stop-color', '#0F91F9')
                    ]), _List_Nil)
                ]))
            ])),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M363.3 363.9C363.3 363.9 363.3 321.3 363.3 318.2C363.3 142.5 505.9 0 681.6 0C857.3 0 1000 142.5 1000 318.2V1000L590.6 727.5L363.3 363.9Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient1)')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M364.1 363.5C364.1 363.5 321.5 363.5 318.4 363.5C142.6 363.5 0 506.1 0 681.8C0 857.5 142.6 1000 318.4 1000H1000L364.1 363.5Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'url(#gradient2)')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$hintHeartFlat = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1000 1000'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M363.3 363.9C363.3 363.9 363.3 321.3 363.3 318.2C363.3 142.5 505.9 0 681.6 0C857.3 0 1000 142.5 1000 318.2V1000L590.6 727.5L363.3 363.9Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#0F91F9')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M364.1 363.5C364.1 363.5 321.5 363.5 318.4 363.5C142.6 363.5 0 506.1 0 681.8C0 857.5 142.6 1000 318.4 1000H1000L364.1 363.5Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#1D63F2')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$history = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 0h24v24H0V0z')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$inbox = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-1 -2 22 22'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V13H13C12.5 13.6333 11.9042 14.125 11.2125 14.475C10.5208 14.825 9.78333 15 9 15C8.21667 15 7.47917 14.825 6.7875 14.475C6.09583 14.125 5.5 13.6333 5 13H2V16ZM9 13C9.63333 13 10.2083 12.8167 10.725 12.45C11.2417 12.0833 11.6 11.6 11.8 11H16V2H2V11H6.2C6.4 11.6 6.75833 12.0833 7.275 12.45C7.79167 12.8167 8.36667 13 9 13Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$increase = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm280-400 200-200 200 200H280Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$inventory = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M21.2208 41.103L29.4267 32.8971L15.1029 18.5733L6.89699 26.7792C2.94159 30.7346 2.94159 37.1476 6.89699 41.103C10.8524 45.0584 17.2654 45.0584 21.2208 41.103ZM17.8821 15.7941L32.2059 30.1179L41.103 21.2208C45.0584 17.2654 45.0584 10.8524 41.103 6.89699C37.1476 2.94159 30.7346 2.94159 26.7792 6.89699L17.8821 15.7941ZM43.8823 4.11775C38.3919 -1.37259 29.4903 -1.37258 24 4.11775L4.11775 24C-1.37258 29.4903 -1.37258 38.3919 4.11775 43.8823C9.60808 49.3726 18.5097 49.3726 24 43.8822L43.8823 24C49.3726 18.5097 49.3726 9.60808 43.8823 4.11775ZM25.6991 18.364L31.7459 12.3171L28.9667 9.53789L22.9198 15.5847L25.6991 18.364Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$invoices = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.46624 28C6.5051 28 5.68711 27.6626 5.01227 26.9877C4.33742 26.3129 4 25.4949 4 24.5338V20.5154H7.95704V3.00012L9.85887 4.87128L11.73 3.00012L13.5705 4.87128L15.4723 3.00012L17.3128 4.87128L19.2147 3.00012L21.0858 4.87128L22.957 3.00012L24.8281 4.87128L26.6993 3.00012V24.5338C26.6993 25.4949 26.3619 26.3129 25.687 26.9877C25.0122 27.6626 24.1942 28 23.233 28H7.46624ZM23.233 25.9141C23.642 25.9141 23.9743 25.7863 24.23 25.5307C24.4856 25.2751 24.6134 24.9428 24.6134 24.5338V6.34366H10.0736V20.5154H21.8527V24.5338C21.8527 24.9428 21.9805 25.2751 22.2361 25.5307C22.4917 25.7863 22.824 25.9141 23.233 25.9141ZM11.6993 11.2209V9.38046H18.9079V11.2209H11.6993ZM11.6993 15.3314V13.4909H18.9079V15.3314H11.6993ZM21.7607 11.2209C21.5153 11.2209 21.3005 11.1289 21.1165 10.9449C20.9324 10.7608 20.8404 10.5461 20.8404 10.3007C20.8404 10.0553 20.9324 9.84058 21.1165 9.65653C21.3005 9.47248 21.5153 9.38046 21.7607 9.38046C22.0061 9.38046 22.2208 9.47248 22.4048 9.65653C22.5889 9.84058 22.6809 10.0553 22.6809 10.3007C22.6809 10.5461 22.5889 10.7608 22.4048 10.9449C22.2208 11.1289 22.0061 11.2209 21.7607 11.2209ZM21.7607 15.178C21.5153 15.178 21.3005 15.086 21.1165 14.9019C20.9324 14.7179 20.8404 14.5031 20.8404 14.2577C20.8404 14.0123 20.9324 13.7976 21.1165 13.6136C21.3005 13.4295 21.5153 13.3375 21.7607 13.3375C22.0061 13.3375 22.2208 13.4295 22.4048 13.6136C22.5889 13.7976 22.6809 14.0123 22.6809 14.2577C22.6809 14.5031 22.5889 14.7179 22.4048 14.9019C22.2208 15.086 22.0061 15.178 21.7607 15.178ZM7.43557 25.9141H19.7668V22.6013H6.08588V24.5338C6.08588 24.9428 6.21369 25.2751 6.46931 25.5307C6.72494 25.7863 7.04702 25.9141 7.43557 25.9141Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$kebabMenu = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 3 17'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.2439 16.9373C0.902439 16.9373 0.609756 16.8153 0.365854 16.5714C0.121951 16.3275 0 16.0348 0 15.6934C0 15.3681 0.121951 15.0836 0.365854 14.8397C0.609756 14.5958 0.902439 14.4738 1.2439 14.4738C1.58537 14.4738 1.87805 14.5958 2.12195 14.8397C2.36585 15.0836 2.4878 15.3763 2.4878 15.7177C2.4878 16.0429 2.36585 16.3275 2.12195 16.5714C1.87805 16.8153 1.58537 16.9373 1.2439 16.9373ZM1.2439 10.1812C0.902439 10.1812 0.609756 10.0592 0.365854 9.8153C0.121951 9.5714 0 9.27872 0 8.93725C0 8.59579 0.121951 8.30311 0.365854 8.05921C0.609756 7.8153 0.902439 7.69335 1.2439 7.69335C1.58537 7.69335 1.87805 7.8153 2.12195 8.05921C2.36585 8.30311 2.4878 8.59579 2.4878 8.93725C2.4878 9.27872 2.36585 9.5714 2.12195 9.8153C1.87805 10.0592 1.58537 10.1812 1.2439 10.1812ZM1.2439 3.40067C0.902439 3.40067 0.609756 3.27872 0.365854 3.03482C0.121951 2.79091 0 2.49823 0 2.15677C0 1.8153 0.121951 1.52669 0.365854 1.29091C0.609756 1.05514 0.902439 0.937256 1.2439 0.937256C1.58537 0.937256 1.87805 1.05921 2.12195 1.30311C2.36585 1.54701 2.4878 1.83969 2.4878 2.18116C2.4878 2.52262 2.36585 2.81124 2.12195 3.04701C1.87805 3.28278 1.58537 3.40067 1.2439 3.40067Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$launch = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$link = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M318-120q-82 0-140-58t-58-140q0-40 15-76t43-64l134-133 56 56-134 134q-17 17-25.5 38.5T200-318q0 49 34.5 83.5T318-200q23 0 45-8.5t39-25.5l133-134 57 57-134 133q-28 28-64 43t-76 15Zm79-220-57-57 223-223 57 57-223 223Zm251-28-56-57 134-133q17-17 25-38t8-44q0-50-34-85t-84-35q-23 0-44.5 8.5T558-726L425-592l-57-56 134-134q28-28 64-43t76-15q82 0 139.5 58T839-641q0 39-14.5 75T782-502L648-368Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$location = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 15'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6 13.2675C7.54074 11.9909 8.7037 10.7637 9.48889 9.58587C10.2741 8.40805 10.6667 7.31003 10.6667 6.29179C10.6667 5.39514 10.5074 4.63526 10.1889 4.01216C9.87037 3.38906 9.47778 2.87994 9.01111 2.4848C8.54444 2.08967 8.03704 1.80471 7.48889 1.62994C6.94074 1.45517 6.44444 1.36778 6 1.36778C5.55556 1.36778 5.05926 1.45517 4.51111 1.62994C3.96296 1.80471 3.45556 2.08967 2.98889 2.4848C2.52222 2.87994 2.12963 3.38906 1.81111 4.01216C1.49259 4.63526 1.33333 5.39514 1.33333 6.29179C1.33333 7.31003 1.72593 8.40805 2.51111 9.58587C3.2963 10.7637 4.45926 11.9909 6 13.2675ZM6 15C3.97037 13.4347 2.46296 11.9377 1.47778 10.5091C0.492592 9.08055 0 7.67477 0 6.29179C0 5.25836 0.181482 4.3503 0.544445 3.56763C0.907408 2.78495 1.37778 2.12766 1.95556 1.59574C2.53333 1.06383 3.17778 0.664894 3.88889 0.398936C4.6 0.132979 5.3037 0 6 0C6.6963 0 7.4 0.132979 8.11111 0.398936C8.82222 0.664894 9.46667 1.06383 10.0444 1.59574C10.6222 2.12766 11.0926 2.78495 11.4556 3.56763C11.8185 4.3503 12 5.25836 12 6.29179C12 7.67477 11.5074 9.08055 10.5222 10.5091C9.53704 11.9377 8.02963 13.4347 6 15ZM6 7.75076C6.42963 7.75076 6.7963 7.59498 7.1 7.28343C7.4037 6.97188 7.55556 6.59574 7.55556 6.15502C7.55556 5.71429 7.4037 5.33815 7.1 5.0266C6.7963 4.71505 6.42963 4.55927 6 4.55927C5.57037 4.55927 5.2037 4.71505 4.9 5.0266C4.5963 5.33815 4.44444 5.71429 4.44444 6.15502C4.44444 6.59574 4.5963 6.97188 4.9 7.28343C5.2037 7.59498 5.57037 7.75076 6 7.75076Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$lock = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240Zm0-80h480v-400H240v400Zm296.5-143.5Q560-327 560-360t-23.5-56.5Q513-440 480-440t-56.5 23.5Q400-393 400-360t23.5 56.5Q447-280 480-280t56.5-23.5ZM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80ZM240-160v-400 400Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$mail = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm340-302L140-685v465h680v-465L480-462Zm0-60 336-218H145l335 218ZM140-685v-55 520-465Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$marketplace = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '85 -840 805 720')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M841-518v318q0 33-23.5 56.5T761-120H201q-33 0-56.5-23.5T121-200v-318q-23-21-35.5-54t-.5-72l42-136q8-26 28.5-43t47.5-17h556q27 0 47 16.5t29 43.5l42 136q12 39-.5 71T841-518Zm-272-42q27 0 41-18.5t11-41.5l-22-140h-78v148q0 21 14 36.5t34 15.5Zm-180 0q23 0 37.5-15.5T441-612v-148h-78l-22 140q-4 24 10.5 42t37.5 18Zm-178 0q18 0 31.5-13t16.5-33l22-154h-78l-40 134q-6 20 6.5 43t41.5 23Zm540 0q29 0 42-23t6-43l-42-134h-76l22 154q3 20 16.5 33t31.5 13ZM201-200h560v-282q-5 2-6.5 2H751q-27 0-47.5-9T663-518q-18 18-41 28t-49 10q-27 0-50.5-10T481-518q-17 18-39.5 28T393-480q-29 0-52.5-10T299-518q-21 21-41.5 29.5T211-480h-4.5q-2.5 0-5.5-2v282Zm560 0H201h560Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$minus = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 24 24'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 10.56h24v2.88H0z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$onlineSignup = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M3 3V24.9376H11.7568L13.7667 22.9278H5.00986L5.00986 5.00986H22.52V14.1744L24.5334 12.1611V3H3Z')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M25.6432 19.0929L23.672 17.1461L25.0288 15.8061L27 17.7529L25.6432 19.0929ZM15.6827 27V25.0532L22.5712 18.2333L24.5424 20.1801L17.6539 27H15.6827ZM7.79999 19.233V17.4884H15.7616V19.233H7.79999ZM7.79999 14.9095V13.1902H20.0368V14.9095H7.79999ZM7.79999 10.586V8.86667H20.0368V10.586H7.79999Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$open = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.42857 1H11V7.86957H1M1 7.86957L4 4.73913M1 7.86957L4 11'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$package = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M440-183v-274L200-596v274l240 139Zm80 0 240-139v-274L520-457v274Zm-80 92L160-252q-19-11-29.5-29T120-321v-318q0-22 10.5-40t29.5-29l280-161q19-11 40-11t40 11l280 161q19 11 29.5 29t10.5 40v318q0 22-10.5 40T800-252L520-91q-19 11-40 11t-40-11Zm200-528 77-44-237-137-78 45 238 136Zm-160 93 78-45-237-137-78 45 237 137Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$patients = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-2 -4 28 24'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0ZM18 16V13C18 12.2667 17.7958 11.5625 17.3875 10.8875C16.9792 10.2125 16.4 9.63333 15.65 9.15C16.5 9.25 17.3 9.42083 18.05 9.6625C18.8 9.90417 19.5 10.2 20.15 10.55C20.75 10.8833 21.2083 11.2542 21.525 11.6625C21.8417 12.0708 22 12.5167 22 13V16H18ZM8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM18 4C18 5.1 17.6083 6.04167 16.825 6.825C16.0417 7.60833 15.1 8 14 8C13.8167 8 13.5833 7.97917 13.3 7.9375C13.0167 7.89583 12.7833 7.85 12.6 7.8C13.05 7.26667 13.3958 6.675 13.6375 6.025C13.8792 5.375 14 4.7 14 4C14 3.3 13.8792 2.625 13.6375 1.975C13.3958 1.325 13.05 0.733333 12.6 0.2C12.8333 0.116667 13.0667 0.0625 13.3 0.0375C13.5333 0.0125 13.7667 0 14 0C15.1 0 16.0417 0.391667 16.825 1.175C17.6083 1.95833 18 2.9 18 4ZM2 14H14V13.2C14 13.0167 13.9542 12.85 13.8625 12.7C13.7708 12.55 13.65 12.4333 13.5 12.35C12.6 11.9 11.6917 11.5625 10.775 11.3375C9.85833 11.1125 8.93333 11 8 11C7.06667 11 6.14167 11.1125 5.225 11.3375C4.30833 11.5625 3.4 11.9 2.5 12.35C2.35 12.4333 2.22917 12.55 2.1375 12.7C2.04583 12.85 2 13.0167 2 13.2V14ZM8 6C8.55 6 9.02083 5.80417 9.4125 5.4125C9.80417 5.02083 10 4.55 10 4C10 3.45 9.80417 2.97917 9.4125 2.5875C9.02083 2.19583 8.55 2 8 2C7.45 2 6.97917 2.19583 6.5875 2.5875C6.19583 2.97917 6 3.45 6 4C6 4.55 6.19583 5.02083 6.5875 5.4125C6.97917 5.80417 7.45 6 8 6Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$paymentMethods = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 30 30'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M2 25.8768V5H28V25.8768H2ZM4.17734 10.6034H25.8226V7.17734H4.17734V10.6034ZM4.17734 14.734V23.6995H25.8226V14.734H4.17734Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$practices = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M420-280h120v-100h100v-120H540v-100H420v100H320v120h100v100ZM160-120v-480l320-240 320 240v480H160Zm80-80h480v-360L480-740 240-560v360Zm240-270Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$progressActivity = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '20px'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '20px'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$quote = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 66 45')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M17.9667 0L4.4 20.52C1.83333 24.48 0 27.72 0 32.04C0 39.6 5.86667 45 12.4667 45C19.4333 45 24.9333 39.6 24.9333 32.04C24.9333 27 22.7333 22.68 17.9667 20.52L28.2333 0H17.9667ZM55.7333 20.52L66 0H55.7333L42.1667 20.52C39.6 24.48 37.7667 27.72 37.7667 32.04C37.7667 39.6 43.6333 45 50.2333 45C57.2 45 62.7 39.6 62.7 32.04C62.7 27 60.5 22.68 55.7333 20.52Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$repeat = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 34 33'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M16.6813 32.6098C12.1682 32.6098 8.32346 31.0216 5.14702 27.8451C1.97056 24.6687 0.382324 20.8249 0.382324 16.3138C0.382324 11.8028 1.97056 7.95605 5.14702 4.77365C8.32346 1.59121 12.1682 -3.8147e-06 16.6813 -3.8147e-06C19.5624 -3.8147e-06 22.0911 0.583865 24.2675 1.7516C26.4438 2.91933 28.3281 4.52533 29.9204 6.5696V-3.8147e-06H33.0639V13.1424H19.9095V10.0109H28.2617C26.987 8.0428 25.3823 6.45203 23.4476 5.2386C21.5128 4.0252 19.2573 3.4185 16.6813 3.4185C13.0778 3.4185 10.0282 4.66617 7.53247 7.1615C5.03674 9.65683 3.78887 12.7059 3.78887 16.3088C3.78887 19.9116 5.03677 22.9614 7.53257 25.4582C10.0284 27.9549 13.078 29.2033 16.6816 29.2033C19.4082 29.2033 21.9115 28.4216 24.1916 26.8582C26.4716 25.2948 28.0657 23.229 28.9736 20.6609H32.4921C31.5175 24.2406 29.5679 27.127 26.6434 29.3201C23.7189 31.5132 20.3982 32.6098 16.6813 32.6098Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$report = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '-8 -8 64 64'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M36 48V27H48V48H36ZM18 48V0H30V48H18ZM0 48V15H12V48H0Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$sandbox = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M40-120v-80h42l35-525q2-32 25-53.5t55-21.5h245q32 0 55 21.5t25 53.5l36 525h162v-246q-52-14-86-56t-34-98q0-34 13-63.5t36-51.5q-5-11-7-22t-2-23q0-50 35-85t85-35q50 0 85 35t35 85q0 12-2 23t-7 22q23 22 36 51.5t13 63.5q0 56-34 98t-86 56v246h120v80H40Zm123-80h314l-35-520h-32v360h30v80H200v-80h30v-360h-32l-35 520Zm127-160h60v-360h-60v360Zm470-160q33 0 56.5-23.5T840-600q0-28-13-43t-27-29v-88q0-17-11.5-28.5T760-800q-17 0-28.5 11.5T720-760v88q-14 14-27 29t-13 43q0 33 23.5 56.5T760-520Zm0-80Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$scissors = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M39.5833 43.7501L25 29.1667L20.1042 34.0626C20.382 34.5834 20.5729 35.139 20.6771 35.7293C20.7813 36.3195 20.8333 36.9098 20.8333 37.5001C20.8333 39.7918 20.0174 41.7536 18.3854 43.3855C16.7535 45.0174 14.7917 45.8334 12.5 45.8334C10.2083 45.8334 8.24653 45.0174 6.61459 43.3855C4.98264 41.7536 4.16667 39.7918 4.16667 37.5001C4.16667 35.2084 4.98264 33.2466 6.61459 31.6147C8.24653 29.9827 10.2083 29.1667 12.5 29.1667C13.0903 29.1667 13.6806 29.2188 14.2708 29.323C14.8611 29.4272 15.4167 29.6181 15.9375 29.8959L20.8333 25.0001L15.9375 20.1042C15.4167 20.382 14.8611 20.573 14.2708 20.6772C13.6806 20.7813 13.0903 20.8334 12.5 20.8334C10.2083 20.8334 8.24653 20.0174 6.61459 18.3855C4.98264 16.7536 4.16667 14.7917 4.16667 12.5001C4.16667 10.2084 4.98264 8.24661 6.61459 6.61467C8.24653 4.98272 10.2083 4.16675 12.5 4.16675C14.7917 4.16675 16.7535 4.98272 18.3854 6.61467C20.0174 8.24661 20.8333 10.2084 20.8333 12.5001C20.8333 13.0904 20.7813 13.6806 20.6771 14.2709C20.5729 14.8612 20.382 15.4167 20.1042 15.9376L45.8333 41.6668V43.7501H39.5833ZM31.25 22.9167L27.0833 18.7501L39.5833 6.25008H45.8333V8.33342L31.25 22.9167ZM12.5 16.6667C13.6458 16.6667 14.6267 16.2588 15.4427 15.4428C16.2587 14.6268 16.6667 13.6459 16.6667 12.5001C16.6667 11.3542 16.2587 10.3733 15.4427 9.55737C14.6267 8.7414 13.6458 8.33342 12.5 8.33342C11.3542 8.33342 10.3733 8.7414 9.5573 9.55737C8.74133 10.3733 8.33334 11.3542 8.33334 12.5001C8.33334 13.6459 8.74133 14.6268 9.5573 15.4428C10.3733 16.2588 11.3542 16.6667 12.5 16.6667ZM25 26.0417C25.2778 26.0417 25.5208 25.9376 25.7292 25.7293C25.9375 25.5209 26.0417 25.2779 26.0417 25.0001C26.0417 24.7223 25.9375 24.4793 25.7292 24.2709C25.5208 24.0626 25.2778 23.9584 25 23.9584C24.7222 23.9584 24.4792 24.0626 24.2708 24.2709C24.0625 24.4793 23.9583 24.7223 23.9583 25.0001C23.9583 25.2779 24.0625 25.5209 24.2708 25.7293C24.4792 25.9376 24.7222 26.0417 25 26.0417ZM12.5 41.6668C13.6458 41.6668 14.6267 41.2588 15.4427 40.4428C16.2587 39.6268 16.6667 38.6459 16.6667 37.5001C16.6667 36.3543 16.2587 35.3733 15.4427 34.5574C14.6267 33.7414 13.6458 33.3334 12.5 33.3334C11.3542 33.3334 10.3733 33.7414 9.5573 34.5574C8.74133 35.3733 8.33334 36.3543 8.33334 37.5001C8.33334 38.6459 8.74133 39.6268 9.5573 40.4428C10.3733 41.2588 11.3542 41.6668 12.5 41.6668Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$search = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 16 16'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M14.9071 16L9.11475 10.2216C8.69217 10.5864 8.18944 10.871 7.60656 11.0752C7.02368 11.2795 6.40437 11.3817 5.74863 11.3817C4.14572 11.3817 2.78689 10.8272 1.67213 9.71819C0.557377 8.60921 0 7.26676 0 5.69083C0 4.11491 0.557377 2.77246 1.67213 1.66347C2.78689 0.554492 4.13115 0 5.70492 0C7.27869 0 8.61931 0.554492 9.72678 1.66347C10.8342 2.77246 11.388 4.11491 11.388 5.69083C11.388 6.31829 11.286 6.92385 11.082 7.50752C10.878 8.0912 10.5792 8.6384 10.1858 9.14911L16 14.9056L14.9071 16ZM5.72678 9.8933C6.87796 9.8933 7.85792 9.48108 8.66667 8.65663C9.47541 7.83219 9.87978 6.84359 9.87978 5.69083C9.87978 4.53808 9.47541 3.54948 8.66667 2.72503C7.85792 1.90059 6.87796 1.48837 5.72678 1.48837C4.54645 1.48837 3.54827 1.90059 2.73224 2.72503C1.91621 3.54948 1.5082 4.53808 1.5082 5.69083C1.5082 6.84359 1.91621 7.83219 2.73224 8.65663C3.54827 9.48108 4.54645 9.8933 5.72678 9.8933Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$selectArrows = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4.13031 13L4.13031 1M4.13031 1L7.26074 4M4.13031 1L0.999873 4'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.1304 1V13M10.1304 13L7 10M10.1304 13L13.2609 10'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1.2')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$send = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 39 33'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0185714 33L39 16.5L0.0185714 0L0 12.8333L27.8571 16.5L0 20.1667L0.0185714 33Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$share = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '3 0 48 48'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'stroke', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'stroke-width', '1'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M36.35 44.3Q33.85 44.3 32.1 42.525Q30.35 40.75 30.35 38.3Q30.35 37.95 30.425 37.45Q30.5 36.95 30.65 36.55L15.95 28Q15.2 28.9 14.05 29.45Q12.9 30 11.7 30Q9.2 30 7.45 28.25Q5.7 26.5 5.7 24Q5.7 21.5 7.45 19.75Q9.2 18 11.7 18Q12.9 18 14 18.475Q15.1 18.95 15.95 19.85L30.65 11.4Q30.5 11.05 30.425 10.575Q30.35 10.1 30.35 9.7Q30.35 7.2 32.1 5.45Q33.85 3.7 36.35 3.7Q38.85 3.7 40.6 5.45Q42.35 7.2 42.35 9.7Q42.35 12.2 40.6 13.95Q38.85 15.7 36.35 15.7Q35.15 15.7 34.025 15.3Q32.9 14.9 32.15 14.05L17.45 22.15Q17.55 22.55 17.625 23.1Q17.7 23.65 17.7 24Q17.7 24.35 17.625 24.75Q17.55 25.15 17.45 25.6L32.15 33.9Q32.9 33.2 33.95 32.75Q35 32.3 36.35 32.3Q38.85 32.3 40.6 34.05Q42.35 35.8 42.35 38.3Q42.35 40.8 40.6 42.55Q38.85 44.3 36.35 44.3ZM36.35 12.4Q37.5 12.4 38.275 11.625Q39.05 10.85 39.05 9.7Q39.05 8.55 38.275 7.775Q37.5 7 36.35 7Q35.2 7 34.425 7.775Q33.65 8.55 33.65 9.7Q33.65 10.85 34.425 11.625Q35.2 12.4 36.35 12.4ZM11.7 26.7Q12.85 26.7 13.625 25.925Q14.4 25.15 14.4 24Q14.4 22.85 13.625 22.075Q12.85 21.3 11.7 21.3Q10.55 21.3 9.775 22.075Q9 22.85 9 24Q9 25.15 9.775 25.925Q10.55 26.7 11.7 26.7ZM36.35 41Q37.5 41 38.275 40.225Q39.05 39.45 39.05 38.3Q39.05 37.15 38.275 36.375Q37.5 35.6 36.35 35.6Q35.2 35.6 34.425 36.375Q33.65 37.15 33.65 38.3Q33.65 39.45 34.425 40.225Q35.2 41 36.35 41Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$sort = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$sortDown = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$sortUp = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 7 11'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 3.74379L3.09733 0.105446C3.22316 -0.0351486 3.44354 -0.0351486 3.56937 0.105446L6.57064 3.74379C6.75231 3.94762 6.60787 4.27046 6.33462 4.27046H0.316447C0.043943 4.27046 -0.101244 3.94762 0.0811703 3.74379Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil),
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M0.0811703 6.30308L3.09733 9.94143C3.22316 10.082 3.44354 10.082 3.56937 9.94143L6.57064 6.30308C6.75231 6.09926 6.60787 5.77641 6.33462 5.77641H0.316447C0.043943 5.77641 -0.101244 6.09926 0.0811703 6.30308Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#C4DCF8')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$sponsors = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '2 -2 48 48'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M4 42V9.5L14 2L24 9.5V14H44V42H4ZM8 38H12V34H8V38ZM8 30H12V26H8V30ZM8 22H12V18H8V22ZM8 14H12V10H8V14ZM16 14H20V10H16V14ZM16 38H40V18H16V38ZM28 26V22H36V26H28ZM28 34V30H36V34H28ZM20 26V22H24V26H20ZM20 34V30H24V34H20Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$star = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '50'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '50'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M44.375 38.9584L38.125 32.7084L41.0417 29.7917L47.2917 36.0417L44.375 38.9584ZM36.875 13.9584L33.9583 11.0417L40.2083 4.79175L43.125 7.70841L36.875 13.9584ZM13.125 13.9584L6.87501 7.70841L9.79168 4.79175L16.0417 11.0417L13.125 13.9584ZM5.62501 38.9584L2.70834 36.0417L8.95834 29.7917L11.875 32.7084L5.62501 38.9584ZM18.4375 35.0522L25 31.0938L31.5625 35.1042L29.8438 27.6042L35.625 22.6042L28.0208 21.9272L25 14.8438L21.9792 21.8751L14.375 22.5522L20.1563 27.6042L18.4375 35.0522ZM12.1354 43.7501L15.5208 29.1147L4.16668 19.2709L19.1667 17.9688L25 4.16675L30.8333 17.9688L45.8333 19.2709L34.4792 29.1147L37.8646 43.7501L25 35.9897L12.1354 43.7501Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$starNote = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '50'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 50 50'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'clip-rule', 'evenodd'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M26.2353 34.6797H16.3529V31.3984H26.2353V34.6797ZM32.978 25.3281H16.3529V22.0469H32.978V25.3281ZM32.978 15.9766H16.3529V12.6953H32.978V15.9766ZM4.92647 42.3906C5.54412 43.0469 6.26472 43.375 7.08824 43.375H28.7059V40.0938H7.08824V7.28125H37.9706V25H41.0588V7.28125C41.0588 6.4063 40.75 5.64062 40.1324 4.98438C39.5147 4.32812 38.794 4 37.9706 4H7.08824C6.26472 4 5.54412 4.32812 4.92647 4.98438C4.30882 5.64062 4 6.4063 4 7.28125V40.0938C4 40.9687 4.30882 41.7344 4.92647 42.3906ZM34.5592 39.7809L37.3529 46L40.1467 39.7809L46 36.8125L40.1467 33.8441L37.3529 27.625L34.5592 33.8441L28.7059 36.8125L34.5592 39.7809ZM12.0294 16.3375C13.0528 16.3375 13.8824 15.456 13.8824 14.3688C13.8824 13.2816 13.0528 12.4 12.0294 12.4C11.006 12.4 10.1765 13.2816 10.1765 14.3688C10.1765 15.456 11.006 16.3375 12.0294 16.3375ZM13.8824 23.6875C13.8824 24.7747 13.0528 25.6562 12.0294 25.6562C11.006 25.6562 10.1765 24.7747 10.1765 23.6875C10.1765 22.6003 11.006 21.7188 12.0294 21.7188C13.0528 21.7188 13.8824 22.6003 13.8824 23.6875ZM12.0294 34.975C13.0528 34.975 13.8824 34.0935 13.8824 33.0063C13.8824 31.919 13.0528 31.0375 12.0294 31.0375C11.006 31.0375 10.1765 31.919 10.1765 33.0063C10.1765 34.0935 11.006 34.975 12.0294 34.975Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#00BFFF')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$stop = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 14'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7 14C6.03448 14 5.12644 13.8161 4.27586 13.4483C3.42529 13.0805 2.68391 12.5805 2.05172 11.9483C1.41954 11.3161 0.91954 10.5747 0.551724 9.72414C0.183908 8.87356 0 7.96552 0 7C0 6.03448 0.183908 5.12356 0.551724 4.26724C0.91954 3.41092 1.41954 2.66954 2.05172 2.0431C2.68391 1.41667 3.42529 0.91954 4.27586 0.551724C5.12644 0.183908 6.03448 0 7 0C7.96552 0 8.87356 0.183908 9.72414 0.551724C10.5747 0.91954 11.3161 1.41667 11.9483 2.0431C12.5805 2.66954 13.0805 3.41092 13.4483 4.26724C13.8161 5.12356 14 6.03448 14 7C14 7.96552 13.8161 8.87356 13.4483 9.72414C13.0805 10.5747 12.5805 11.3161 11.9483 11.9483C11.3161 12.5805 10.5747 13.0805 9.72414 13.4483C8.87356 13.8161 7.96552 14 7 14ZM7 12.8276C8.62069 12.8276 9.99713 12.2615 11.1293 11.1293C12.2615 9.99713 12.8276 8.62069 12.8276 7C12.8276 6.32184 12.7126 5.66667 12.4828 5.03448C12.2529 4.4023 11.9253 3.82759 11.5 3.31034L3.31034 11.4828C3.81609 11.931 4.38793 12.2672 5.02586 12.4914C5.66379 12.7155 6.32184 12.8276 7 12.8276ZM2.51724 10.6897L10.6897 2.51724C10.1724 2.08046 9.5977 1.74713 8.96552 1.51724C8.33333 1.28736 7.67816 1.17241 7 1.17241C5.37931 1.17241 4.00287 1.73563 2.87069 2.86207C1.73851 3.98851 1.17241 5.36782 1.17241 7C1.17241 7.67816 1.2931 8.33333 1.53448 8.96552C1.77586 9.5977 2.10345 10.1724 2.51724 10.6897Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$syncedFrom = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 17'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'transform', 'rotate(180, 7.5, 8.5)'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.5 12.0161C11.8667 12.0161 11.3 12.2721 10.8667 12.6732L4.925 9.13153C4.96667 8.93524 5 8.73896 5 8.53414C5 8.32932 4.96667 8.13303 4.925 7.93675L10.8 4.42922C11.25 4.85592 11.8417 5.12048 12.5 5.12048C13.8833 5.12048 15 3.97691 15 2.56024C15 1.14357 13.8833 0 12.5 0C11.1167 0 10 1.14357 10 2.56024C10 2.76506 10.0333 2.96135 10.075 3.15763L4.2 6.66516C3.75 6.23845 3.15833 5.9739 2.5 5.9739C1.11667 5.9739 0 7.11747 0 8.53414C0 9.9508 1.11667 11.0944 2.5 11.0944C3.15833 11.0944 3.75 10.8298 4.2 10.4031L10.1333 13.9533C10.0917 14.1325 10.0667 14.3203 10.0667 14.508C10.0667 15.882 11.1583 17 12.5 17C13.8417 17 14.9333 15.882 14.9333 14.508C14.9333 13.134 13.8417 12.0161 12.5 12.0161ZM12.5 1.70683C12.9583 1.70683 13.3333 2.09086 13.3333 2.56024C13.3333 3.02962 12.9583 3.41365 12.5 3.41365C12.0417 3.41365 11.6667 3.02962 11.6667 2.56024C11.6667 2.09086 12.0417 1.70683 12.5 1.70683ZM2.5 9.38755C2.04167 9.38755 1.66667 9.00351 1.66667 8.53414C1.66667 8.06476 2.04167 7.68072 2.5 7.68072C2.95833 7.68072 3.33333 8.06476 3.33333 8.53414C3.33333 9.00351 2.95833 9.38755 2.5 9.38755ZM12.5 15.3785C12.0417 15.3785 11.6667 14.9945 11.6667 14.5251C11.6667 14.0557 12.0417 13.6717 12.5 13.6717C12.9583 13.6717 13.3333 14.0557 13.3333 14.5251C13.3333 14.9945 12.9583 15.3785 12.5 15.3785Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$syncedTo = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 17'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M12.5 12.0161C11.8667 12.0161 11.3 12.2721 10.8667 12.6732L4.925 9.13153C4.96667 8.93524 5 8.73896 5 8.53414C5 8.32932 4.96667 8.13303 4.925 7.93675L10.8 4.42922C11.25 4.85592 11.8417 5.12048 12.5 5.12048C13.8833 5.12048 15 3.97691 15 2.56024C15 1.14357 13.8833 0 12.5 0C11.1167 0 10 1.14357 10 2.56024C10 2.76506 10.0333 2.96135 10.075 3.15763L4.2 6.66516C3.75 6.23845 3.15833 5.9739 2.5 5.9739C1.11667 5.9739 0 7.11747 0 8.53414C0 9.9508 1.11667 11.0944 2.5 11.0944C3.15833 11.0944 3.75 10.8298 4.2 10.4031L10.1333 13.9533C10.0917 14.1325 10.0667 14.3203 10.0667 14.508C10.0667 15.882 11.1583 17 12.5 17C13.8417 17 14.9333 15.882 14.9333 14.508C14.9333 13.134 13.8417 12.0161 12.5 12.0161ZM12.5 1.70683C12.9583 1.70683 13.3333 2.09086 13.3333 2.56024C13.3333 3.02962 12.9583 3.41365 12.5 3.41365C12.0417 3.41365 11.6667 3.02962 11.6667 2.56024C11.6667 2.09086 12.0417 1.70683 12.5 1.70683ZM2.5 9.38755C2.04167 9.38755 1.66667 9.00351 1.66667 8.53414C1.66667 8.06476 2.04167 7.68072 2.5 7.68072C2.95833 7.68072 3.33333 8.06476 3.33333 8.53414C3.33333 9.00351 2.95833 9.38755 2.5 9.38755ZM12.5 15.3785C12.0417 15.3785 11.6667 14.9945 11.6667 14.5251C11.6667 14.0557 12.0417 13.6717 12.5 13.6717C12.9583 13.6717 13.3333 14.0557 13.3333 14.5251C13.3333 14.9945 12.9583 15.3785 12.5 15.3785Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$task = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -1 20 22'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M7.6 15.05L14.65 8L13.25 6.6L7.6 12.25L4.75 9.4L3.35 10.8L7.6 15.05ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H6.2C6.41667 1.4 6.77917 0.916667 7.2875 0.55C7.79583 0.183333 8.36667 0 9 0C9.63333 0 10.2042 0.183333 10.7125 0.55C11.2208 0.916667 11.5833 1.4 11.8 2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V4H2V18ZM9 3.25C9.21667 3.25 9.39583 3.17917 9.5375 3.0375C9.67917 2.89583 9.75 2.71667 9.75 2.5C9.75 2.28333 9.67917 2.10417 9.5375 1.9625C9.39583 1.82083 9.21667 1.75 9 1.75C8.78333 1.75 8.60417 1.82083 8.4625 1.9625C8.32083 2.10417 8.25 2.28333 8.25 2.5C8.25 2.71667 8.32083 2.89583 8.4625 3.0375C8.60417 3.17917 8.78333 3.25 9 3.25Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$testConnection = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'svg-icon'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'width: 1.80078125em; height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 1844 1024'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'version', '1.1'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M650.541129 1022.638311 108.423481 1022.638311C52.314305 1022.638311 6.776422 976.885119 6.776422 920.510651L6.776422 103.489375C6.776422 47.114907 52.314305 1.361715 108.423481 1.361715L650.541129 1.361715C706.650305 1.361715 752.188187 47.114907 752.188187 103.489375 752.188187 159.863843 706.650305 205.617034 650.541129 205.617034L210.07054 205.617034 210.07054 818.382991 650.541129 818.382991C706.650305 818.382991 752.188187 864.136183 752.188187 920.510651 752.188187 976.885119 706.650305 1022.638311 650.541129 1022.638311L650.541129 1022.638311ZM1734.776422 1022.638311 1192.65878 1022.638311C1136.549601 1022.638311 1091.011717 976.885119 1091.011717 920.510651 1091.011717 864.136183 1136.549601 818.382991 1192.65878 818.382991L1633.129359 818.382991 1633.129359 205.617034 1192.65878 205.617034C1136.549601 205.617034 1091.011717 159.863843 1091.011717 103.489375 1091.011717 47.114907 1136.549601 1.361715 1192.65878 1.361715L1734.776422 1.361715C1790.885601 1.361715 1836.423485 47.114907 1836.423485 103.489375L1836.423485 920.510651C1836.423485 976.885119 1790.885601 1022.638311 1734.776422 1022.638311L1734.776422 1022.638311ZM1328.188191 614.127672 515.011716 614.127672C458.90254 614.127672 413.364658 568.374481 413.364658 512.000013 413.364658 455.625545 458.90254 409.872353 515.011716 409.872353L1328.188191 409.872353C1384.297359 409.872353 1429.835244 455.625545 1429.835244 512.000013 1429.835244 568.374481 1384.297359 614.127672 1328.188191 614.127672L1328.188191 614.127672Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$transfer = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 42 33'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M10.3555 32.6098L0.418457 22.6728L10.3555 12.7359L12.7425 15.1228L6.90771 20.9696H22.2414V24.3881H6.90766L12.7424 30.2228L10.3555 32.6098ZM31.0794 19.8739L28.6924 17.487L34.5392 11.6522H19.2055V8.2337H34.5392L28.6924 2.387L31.0794 -3.8147e-06L41.0283 9.937L31.0794 19.8739Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$translate = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 12 12'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M5.99882 12C5.16604 12 4.38488 11.8428 3.65534 11.5283C2.92571 11.2138 2.29008 10.7854 1.74846 10.243C1.20675 9.70048 0.77993 9.06279 0.468017 8.32991C0.156006 7.59713 0 6.81435 0 5.98156C0 5.14622 0.156006 4.36565 0.468017 3.63985C0.77993 2.91396 1.20675 2.28059 1.74846 1.73976C2.29008 1.19893 2.92571 0.773784 3.65534 0.464329C4.38488 0.154776 5.16604 0 5.99882 0C6.83406 0 7.61586 0.154776 8.34422 0.464329C9.07257 0.773784 9.70756 1.19893 10.2492 1.73976C10.7909 2.28059 11.2181 2.91396 11.5308 3.63985C11.8436 4.36565 12 5.14622 12 5.98156C12 6.81435 11.8436 7.59713 11.5308 8.32991C11.2181 9.06279 10.7909 9.70048 10.2492 10.243C9.70756 10.7854 9.07257 11.2138 8.34422 11.5283C7.61586 11.8428 6.83406 12 5.99882 12ZM5.9941 10.896C6.3009 10.5451 6.56207 10.1543 6.77762 9.72363C6.99317 9.29293 7.17056 8.79645 7.3098 8.23418H4.6964C4.826 8.7702 4.99798 9.25847 5.21235 9.699C5.42672 10.1395 5.6873 10.5385 5.9941 10.896ZM4.65996 10.6993C4.4339 10.3467 4.2417 9.96799 4.08339 9.56315C3.92507 9.15841 3.79183 8.71542 3.68366 8.23418H1.64492C1.98358 8.86037 2.3867 9.3657 2.85427 9.75018C3.32194 10.1346 3.92384 10.451 4.65996 10.6993ZM7.3393 10.6895C7.99017 10.482 8.57441 10.1676 9.09204 9.74635C9.60957 9.32509 10.0286 8.82103 10.3492 8.23418H8.32268C8.20793 8.70884 8.07188 9.14858 7.91455 9.55342C7.75712 9.95816 7.56537 10.3368 7.3393 10.6895ZM1.28458 7.26142H3.49678C3.46728 7.01893 3.44845 6.79601 3.44029 6.59265C3.43203 6.3894 3.4279 6.1857 3.4279 5.98156C3.4279 5.74881 3.43365 5.53793 3.44515 5.34894C3.45666 5.15994 3.47716 4.95398 3.50666 4.73106H1.28458C1.22233 4.95319 1.17892 5.15733 1.15433 5.34348C1.12975 5.52952 1.11746 5.74222 1.11746 5.98156C1.11746 6.21845 1.12975 6.43547 1.15433 6.63263C1.17892 6.82979 1.22233 7.03938 1.28458 7.26142ZM4.49978 7.26142H7.50656C7.54098 6.99267 7.56315 6.76321 7.57309 6.57304C7.58302 6.38286 7.58798 6.1857 7.58798 5.98156C7.58798 5.78155 7.58302 5.59034 7.57309 5.40794C7.56315 5.22543 7.54098 4.9998 7.50656 4.73106H4.49978C4.46369 4.9998 4.43994 5.22543 4.42854 5.40794C4.41703 5.59034 4.41128 5.78155 4.41128 5.98156C4.41128 6.1857 4.41703 6.38286 4.42854 6.57304C4.43994 6.76321 4.46369 6.99267 4.49978 7.26142ZM8.4898 7.26142H10.7083C10.769 7.03938 10.812 6.82979 10.8374 6.63263C10.8628 6.43547 10.8755 6.21845 10.8755 5.98156C10.8755 5.74222 10.8628 5.52952 10.8374 5.34348C10.812 5.15733 10.769 4.95319 10.7083 4.73106H8.49968C8.52525 5.02763 8.54359 5.26678 8.5547 5.4485C8.56581 5.63012 8.57137 5.80781 8.57137 5.98156C8.57137 6.19219 8.56419 6.3926 8.54983 6.58277C8.53547 6.77305 8.51546 6.99926 8.4898 7.26142ZM8.3128 3.75476H10.3492C10.0417 3.14322 9.62919 2.62702 9.11166 2.20616C8.59413 1.78529 8.0001 1.48424 7.32956 1.30301C7.55553 1.65062 7.74724 2.02296 7.90467 2.42003C8.0621 2.8171 8.19814 3.26201 8.3128 3.75476ZM4.6964 3.75476H7.31968C7.21063 3.26781 7.03973 2.79856 6.80697 2.34702C6.57422 1.89547 6.30326 1.48852 5.9941 1.12616C5.70697 1.41801 5.46113 1.77088 5.2566 2.18477C5.05207 2.59865 4.86533 3.12198 4.6964 3.75476ZM1.64492 3.75476H3.6934C3.79507 3.28168 3.92178 2.84827 4.0735 2.45455C4.22533 2.06072 4.41752 1.68017 4.65008 1.3129C3.97797 1.49412 3.38886 1.79148 2.88274 2.20498C2.37652 2.61857 1.96391 3.13516 1.64492 3.75476Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$trendingDown = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '25'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '25'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 25 25'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'mask', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'id', 'mask0_107_13'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'mask-type:alpha'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'maskUnits', 'userSpaceOnUse'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'x', '0'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'y', '0'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'width', '25'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'height', '25')
            ]), _List_fromArray([
                A3($elm$svg$Svg$node, 'rect', _List_fromArray([
                    A2($elm$virtual_dom$VirtualDom$attribute, 'x', '0.90918'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'y', '0.0909119'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'width', '24'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'height', '24'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'fill', '#E1000C')
                ]), _List_Nil)
            ])),
            A3($elm$svg$Svg$node, 'g', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'mask', 'url(#mask0_107_13)')
            ]), _List_fromArray([
                A3($elm$svg$Svg$node, 'path', _List_fromArray([
                    A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M16.9092 18.0909V16.0909H19.5092L14.3092 10.9409L10.3092 14.9409L2.90918 7.49091L4.30918 6.09091L10.3092 12.0909L14.3092 8.09091L20.9092 14.6909V12.0909H22.9092V18.0909H16.9092Z'),
                    A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
                ]), _List_Nil)
            ]))
        ]));
    };
    var $author$project$Generated$Icons$trendingUp = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '1 -4 20 20'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.4 12L0 10.6L7.4 3.15L11.4 7.15L16.6 2H14V0H20V6H18V3.4L11.4 10L7.4 6L1.4 12Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$unpublishedRuleArrow = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'width', '21'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'height', '22'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 21 22'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1 19H0.5V19.5H1V19ZM20.5 19L15.5 16.1132V21.8868L20.5 19ZM0.5 0.5V19H1.5V0.5H0.5ZM1 19.5H16V18.5H1V19.5Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$upload = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 15 16'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'none'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M1.54097 15.119C1.12482 15.119 0.763951 14.9656 0.458371 14.6587C0.15279 14.3519 0 13.9895 0 13.5715V10.0949H1.54097V13.5726H13.459V10.0949H15V13.5701C15 13.9877 14.8463 14.3503 14.5388 14.6578C14.2313 14.9653 13.8714 15.119 13.459 15.119H1.54097ZM6.73223 11.2853V2.97522L4.05056 5.66232L2.94277 4.55994L7.5027 0L12.0626 4.55994L10.9548 5.66232L8.27318 2.97522V11.2853H6.73223Z'),
                A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$visibility = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M607.5-372.5Q660-425 660-500t-52.5-127.5Q555-680 480-680t-127.5 52.5Q300-575 300-500t52.5 127.5Q405-320 480-320t127.5-52.5Zm-204-51Q372-455 372-500t31.5-76.5Q435-608 480-608t76.5 31.5Q588-545 588-500t-31.5 76.5Q525-392 480-392t-76.5-31.5ZM214-281.5Q94-363 40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200q-146 0-266-81.5ZM480-500Zm207.5 160.5Q782-399 832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280q113 0 207.5-59.5Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$visibilityOff = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$void = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 0 14 11'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M6.40872 8.5L8.52589 6.36538L10.6621 8.5L11.5395 7.63461L9.3842 5.5L11.5014 3.36539L10.624 2.48077L8.52589 4.63462L6.40872 2.48077L5.53134 3.36539L7.66758 5.5L5.53134 7.63461L6.40872 8.5ZM3.87193 11L0 5.5L3.87193 0H14V11H3.87193ZM4.53951 9.69231H12.703V1.30769H4.53951L1.62125 5.5L4.53951 9.69231Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$warning = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'm40-120 440-760 440 760H40Zm138-80h604L480-720 178-200Zm330.5-51.5Q520-263 520-280t-11.5-28.5Q497-320 480-320t-28.5 11.5Q440-297 440-280t11.5 28.5Q463-240 480-240t28.5-11.5ZM440-360h80v-200h-80v200Zm40-100Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$webhook = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M280-120q-83 0-141.5-58.5T80-320q0-73 45.5-127.5T240-516v83q-35 12-57.5 43T160-320q0 50 35 85t85 35q50 0 85-35t35-85v-40h235q8-9 19.5-14.5T680-380q25 0 42.5 17.5T740-320q0 25-17.5 42.5T680-260q-14 0-25.5-5.5T635-280H476q-14 69-68.5 114.5T280-120Zm400 0q-56 0-101.5-27.5T507-220h107q14 10 31 15t35 5q50 0 85-35t35-85q0-50-35-85t-85-35q-20 0-37 5.5T611-418L489-621q-21-4-35-20t-14-39q0-25 17.5-42.5T500-740q25 0 42.5 17.5T560-680v8.5q0 3.5-2 8.5l87 146q8-2 17-2.5t18-.5q83 0 141.5 58.5T880-320q0 83-58.5 141.5T680-120ZM280-260q-25 0-42.5-17.5T220-320q0-22 14-38t34-21l94-156q-29-27-45.5-64.5T300-680q0-83 58.5-141.5T500-880q83 0 141.5 58.5T700-680h-80q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 43 26 75.5t66 41.5L337-338q2 5 2.5 9t.5 9q0 25-17.5 42.5T280-260Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Generated$Icons$wrench = function(attrs) {
        return A3($elm$svg$Svg$node, 'svg', _Utils_ap(_List_fromArray([
            A2($elm$virtual_dom$VirtualDom$attribute, 'xmlns', 'http://www.w3.org/2000/svg'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'viewBox', '0 -960 960 960'),
            A2($elm$virtual_dom$VirtualDom$attribute, 'fill', 'currentColor')
        ]), attrs), _List_fromArray([
            A3($elm$svg$Svg$node, 'path', _List_fromArray([
                A2($elm$virtual_dom$VirtualDom$attribute, 'd', 'M356.41-354.5q-102.87 0-175.14-72.27Q109-499.04 109-601.91q0-20 3.24-40T123-680.39q5.24-10.72 13.46-16.44 8.21-5.71 18.17-7.71t20.17.74q10.22 2.73 18.7 11.21L296.59-589.5l72-72L265.5-764.59q-8.48-8.48-11.22-18.81-2.74-10.34-.74-20.06 2-9.71 7.6-17.93 5.6-8.22 16.32-13.46 18.47-7.76 38.83-11t40.12-3.24q102.87 0 175.02 72.16 72.16 72.15 72.16 175.02 0 22.28-3.64 42.3-3.65 20.02-11.17 40.02l206.07 204.07Q826-284.37 826-239.5t-31.15 76.02q-31.15 31.15-76.14 31.15t-76.14-31.91L438.5-369.3q-19.28 7.28-38.95 11.04-19.66 3.76-43.14 3.76Z')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Ui$Icon$generatedFun = function(name) {
        switch(name){
            case 0:
                return $author$project$Generated$Icons$syncedTo;
            case 1:
                return $author$project$Generated$Icons$syncedFrom;
            case 2:
                return $author$project$Generated$Icons$unpublishedRuleArrow;
            case 3:
                return $author$project$Generated$Icons$account;
            case 4:
                return $author$project$Generated$Icons$admin;
            case 6:
                return $author$project$Generated$Icons$commissions;
            case 7:
                return $author$project$Generated$Icons$help;
            case 8:
                return $author$project$Generated$Icons$patients;
            case 9:
                return $author$project$Generated$Icons$report;
            case 10:
                return $author$project$Generated$Icons$share;
            case 11:
                return $author$project$Generated$Icons$sponsors;
            case 12:
                return $author$project$Generated$Icons$chevron;
            case 13:
                return $author$project$Generated$Icons$chevronDown;
            case 14:
                return $author$project$Generated$Icons$location;
            case 15:
                return $author$project$Generated$Icons$copy;
            case 16:
                return $author$project$Generated$Icons$enter;
            case 17:
                return $author$project$Generated$Icons$selectArrows;
            case 18:
                return $author$project$Generated$Icons$open;
            case 19:
                return $author$project$Generated$Icons$kebabMenu;
            case 20:
                return $author$project$Generated$Icons$launch;
            case 21:
                return $author$project$Generated$Icons$lock;
            case 22:
                return $author$project$Generated$Icons$exit;
            case 23:
                return $author$project$Generated$Icons$paymentMethods;
            case 24:
                return $author$project$Generated$Icons$employees;
            case 25:
                return $author$project$Generated$Icons$employeeUploads;
            case 26:
                return $author$project$Generated$Icons$invoices;
            case 27:
                return $author$project$Generated$Icons$onlineSignup;
            case 28:
                return $author$project$Generated$Icons$accountPricing;
            case 29:
                return $author$project$Generated$Icons$burgerMenu;
            case 30:
                return $author$project$Generated$Icons$burgerMenuClose;
            case 31:
                return $author$project$Generated$Icons$hint404;
            case 32:
                return $author$project$Generated$Icons$favicon;
            case 33:
                return $author$project$Generated$Icons$hintHeart;
            case 34:
                return $author$project$Generated$Icons$hintHeartFlat;
            case 35:
                return $author$project$Generated$Icons$sort;
            case 36:
                return $author$project$Generated$Icons$sortDown;
            case 37:
                return $author$project$Generated$Icons$sortUp;
            case 38:
                return $author$project$Generated$Icons$send;
            case 39:
                return $author$project$Generated$Icons$add;
            case 40:
                return $author$project$Generated$Icons$edit;
            case 41:
                return $author$project$Generated$Icons$search;
            case 42:
                return $author$project$Generated$Icons$delete;
            case 43:
                return $author$project$Generated$Icons$flag;
            case 44:
                return $author$project$Generated$Icons$repeat;
            case 45:
                return $author$project$Generated$Icons$check;
            case 46:
                return $author$project$Generated$Icons$circle;
            case 48:
                return $author$project$Generated$Icons$cross;
            case 49:
                return $author$project$Generated$Icons$transfer;
            case 55:
                return $author$project$Generated$Icons$history;
            case 47:
                return $author$project$Generated$Icons$bolt;
            case 50:
                return $author$project$Generated$Icons$upload;
            case 52:
                return $author$project$Generated$Icons$visibility;
            case 53:
                return $author$project$Generated$Icons$visibilityOff;
            case 51:
                return $author$project$Generated$Icons$export;
            case 54:
                return $author$project$Generated$Icons$dollar;
            case 56:
                return $author$project$Generated$Icons$void;
            case 57:
                return $author$project$Generated$Icons$calendar;
            case 58:
                return $author$project$Generated$Icons$cart;
            case 59:
                return $author$project$Generated$Icons$stop;
            case 60:
                return $author$project$Generated$Icons$dots;
            case 61:
                return $author$project$Generated$Icons$arrowRight;
            case 63:
                return $author$project$Generated$Icons$arrowRightBottom;
            case 62:
                return $author$project$Generated$Icons$arrowLeft;
            case 64:
                return $author$project$Generated$Icons$warning;
            case 5:
                return $author$project$Generated$Icons$alert;
            case 65:
                return $author$project$Generated$Icons$crossCircle;
            case 66:
                return $author$project$Generated$Icons$translate;
            case 67:
                return $author$project$Generated$Icons$filter;
            case 69:
                return $author$project$Generated$Icons$trendingDown;
            case 68:
                return $author$project$Generated$Icons$trendingUp;
            case 70:
                return $author$project$Generated$Icons$scissors;
            case 71:
                return $author$project$Generated$Icons$star;
            case 72:
                return $author$project$Generated$Icons$starNote;
            case 73:
                return $author$project$Generated$Icons$minus;
            case 74:
                return $author$project$Generated$Icons$testConnection;
            case 75:
                return $author$project$Generated$Icons$dashboard;
            case 77:
                return $author$project$Generated$Icons$inbox;
            case 78:
                return $author$project$Generated$Icons$contact;
            case 79:
                return $author$project$Generated$Icons$form;
            case 80:
                return $author$project$Generated$Icons$file;
            case 81:
                return $author$project$Generated$Icons$inventory;
            case 82:
                return $author$project$Generated$Icons$decrease;
            case 83:
                return $author$project$Generated$Icons$increase;
            case 84:
                return $author$project$Generated$Icons$task;
            case 85:
                return $author$project$Generated$Icons$apiKey;
            case 86:
                return $author$project$Generated$Icons$webhook;
            case 87:
                return $author$project$Generated$Icons$practices;
            case 89:
                return $author$project$Generated$Icons$app;
            case 90:
                return $author$project$Generated$Icons$gift;
            case 91:
                return $author$project$Generated$Icons$groups;
            case 92:
                return $author$project$Generated$Icons$sandbox;
            case 93:
                return $author$project$Generated$Icons$package;
            case 94:
                return $author$project$Generated$Icons$call;
            case 95:
                return $author$project$Generated$Icons$mail;
            case 88:
                return $author$project$Generated$Icons$progressActivity;
            case 96:
                return $author$project$Generated$Icons$marketplace;
            case 97:
                return $author$project$Generated$Icons$book;
            case 98:
                return $author$project$Generated$Icons$demography;
            case 99:
                return $author$project$Generated$Icons$businessCenter;
            case 100:
                return $author$project$Generated$Icons$dev;
            case 101:
                return $author$project$Generated$Icons$quote;
            case 76:
                return $author$project$Generated$Icons$wrench;
            case 102:
                return $author$project$Generated$Icons$link;
            default:
                return $author$project$Generated$Icons$eraser;
        }
    };
    var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
    var $elm$svg$Svg$Attributes$color = _VirtualDom_attribute('color');
    var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
    var $elm$core$String$fromFloat = _String_fromNumber;
    var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
    var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
    var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
    var $author$project$Ui$Icon$optionToAttr = function(option) {
        switch(option.$){
            case 0:
                var string = option.a;
                return _List_fromArray([
                    $elm$svg$Svg$Attributes$color(string)
                ]);
            case 1:
                var string = option.a;
                return _List_fromArray([
                    $elm$svg$Svg$Attributes$class(string)
                ]);
            case 2:
                var string = option.a;
                return _List_fromArray([
                    $elm$svg$Svg$Attributes$fill(string)
                ]);
            case 3:
                var string = option.a;
                return _List_fromArray([
                    $elm$svg$Svg$Attributes$width(string)
                ]);
            case 4:
                var string = option.a;
                return _List_fromArray([
                    $elm$svg$Svg$Attributes$height(string)
                ]);
            case 5:
                var degrees = option.a;
                return _List_fromArray([
                    $elm$svg$Svg$Attributes$transform('rotate(' + ($elm$core$String$fromFloat(degrees) + ')'))
                ]);
            default:
                var string = option.a;
                return _List_fromArray([
                    $elm$svg$Svg$Attributes$class(string)
                ]);
        }
    };
    var $author$project$Ui$Icon$view = F2(function(options, name) {
        var optionAttrs = A2($elm$core$List$concatMap, $author$project$Ui$Icon$optionToAttr, options);
        return A2($author$project$Ui$Icon$generatedFun, name, optionAttrs);
    });
    var $author$project$Ui$Icon$viewIcon = F2(function(name, iconOptions) {
        return A2($author$project$Ui$Icon$view, $author$project$Ui$Icon$iconOptionsToSvgOptions(iconOptions), name);
    });
    var $author$project$Ui$Icon$chevronDown = $author$project$Ui$Icon$viewIcon(13);
    var $elm$html$Html$input = _VirtualDom_node('input');
    var $elm$virtual_dom$VirtualDom$property = F2(function(key, value) {
        return A2(_VirtualDom_property, _VirtualDom_noInnerHtmlOrFormAction(key), _VirtualDom_noJavaScriptOrHtmlJson(value));
    });
    var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
    var $elm$html$Html$span = _VirtualDom_node('span');
    var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
    var $elm$html$Html$hr = _VirtualDom_node('hr');
    var $author$project$Ui$Margin$toClass = function(margin) {
        switch(margin){
            case 0:
                return $elm$html$Html$Attributes$class('mb-0');
            case 5:
                return $elm$html$Html$Attributes$class('mb-2');
            case 1:
                return $elm$html$Html$Attributes$class('mb-025');
            case 2:
                return $elm$html$Html$Attributes$class('mb-075');
            case 3:
                return $elm$html$Html$Attributes$class('mb-2em');
            case 4:
                return $elm$html$Html$Attributes$class('mb-10');
            case 19:
                return $elm$html$Html$Attributes$class('mt-0');
            case 6:
                return $elm$html$Html$Attributes$class('mt-05');
            case 7:
                return $elm$html$Html$Attributes$class('mt-075');
            case 8:
                return $elm$html$Html$Attributes$class('mt-2');
            case 9:
                return $elm$html$Html$Attributes$class('mt-4');
            case 20:
                return $elm$html$Html$Attributes$class('mt-05');
            case 10:
                return $elm$html$Html$Attributes$class('ml-05');
            case 11:
                return $elm$html$Html$Attributes$class('ml-1');
            case 12:
                return $elm$html$Html$Attributes$class('ml-2');
            case 13:
                return $elm$html$Html$Attributes$class('ml-30');
            case 21:
                return $elm$html$Html$Attributes$class('mt-1');
            case 18:
                return $elm$html$Html$Attributes$class('mt-3');
            case 22:
                return $elm$html$Html$Attributes$class('mt-8');
            case 14:
                return $elm$html$Html$Attributes$class('mr-05');
            case 15:
                return $elm$html$Html$Attributes$class('mr-1');
            case 16:
                return $elm$html$Html$Attributes$class('mr-2');
            case 17:
                return $elm$html$Html$Attributes$class('mr-4');
            case 23:
                return $elm$html$Html$Attributes$class('nmx-1');
            case 24:
                return $elm$html$Html$Attributes$class('mx-05');
            default:
                return $elm$html$Html$Attributes$class('m-0');
        }
    };
    var $author$project$Ui$HorizontalRule$optionToAttributes = function(option) {
        if (!option.$) {
            var style = option.a;
            switch(style){
                case 0:
                    return _List_fromArray([
                        $elm$html$Html$Attributes$class('double')
                    ]);
                case 1:
                    return _List_fromArray([
                        $elm$html$Html$Attributes$class('thin')
                    ]);
                case 2:
                    return _List_fromArray([
                        $elm$html$Html$Attributes$class('minimal')
                    ]);
                default:
                    return _List_fromArray([
                        $elm$html$Html$Attributes$class('separator')
                    ]);
            }
        } else {
            var margin_ = option.a;
            return _List_fromArray([
                $author$project$Ui$Margin$toClass(margin_)
            ]);
        }
    };
    var $author$project$Ui$HorizontalRule$optionsToAttributes = function(options) {
        return A2($elm$core$List$concatMap, $author$project$Ui$HorizontalRule$optionToAttributes, options);
    };
    var $author$project$Ui$HorizontalRule$view = function(options) {
        return A2($elm$html$Html$hr, $author$project$Ui$HorizontalRule$optionsToAttributes(options), _List_Nil);
    };
    var $author$project$Ui$Table$defaultOptions = {
        vD: _List_Nil,
        EP: _List_Nil,
        wS: _List_fromArray([
            'table-wrapper'
        ]),
        Tk: false,
        D4: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Table$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'table-striped', record.EP)
                    });
                case 1:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'table-bordered', record.EP)
                    });
                case 2:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'vertical-centered', record.EP)
                    });
                case 3:
                    var contents = option.a;
                    return _Utils_update(record, {
                        D4: $elm$core$Maybe$Just(contents)
                    });
                case 4:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Tk: bool
                    });
                case 6:
                    var classes = option.a;
                    return _Utils_update(record, {
                        wS: classes
                    });
                default:
                    var testString = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Utils$Html$Attributes$test(testString), record.vD)
                    });
            }
        }), $author$project$Ui$Table$defaultOptions, options);
    };
    var $elm$html$Html$table = _VirtualDom_node('table');
    var $elm$html$Html$tbody = _VirtualDom_node('tbody');
    var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
    var $elm$html$Html$thead = _VirtualDom_node('thead');
    var $elm$html$Html$tr = _VirtualDom_node('tr');
    var $author$project$Ui$Icon$Sort = 35;
    var $author$project$Ui$Icon$SortDown = 36;
    var $author$project$Ui$Icon$SortUp = 37;
    var $author$project$Ui$Icon$class = $author$project$Ui$Icon$Class;
    var $author$project$Ui$Icon$Height = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Icon$height = $author$project$Ui$Icon$Height;
    var $elm$virtual_dom$VirtualDom$Normal = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
    var $elm$html$Html$Events$on = F2(function(event, decoder) {
        return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$Normal(decoder));
    });
    var $elm$html$Html$Events$onClick = function(msg) {
        return A2($elm$html$Html$Events$on, 'click', $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Ui$Table$defaultCellOptions = {
        vD: _List_Nil,
        EP: _List_Nil,
        pX: 1,
        zU: $elm$core$Maybe$Nothing,
        sB: 1,
        kh: $elm$core$Maybe$Nothing,
        Hv: false
    };
    var $author$project$Ui$Table$sizeToScreenPrefix = function(screenSize) {
        switch(screenSize){
            case 0:
                return '';
            case 1:
                return 'sm:';
            case 2:
                return 'md:';
            case 3:
                return 'lg:';
            default:
                return 'xl:';
        }
    };
    var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
    var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
    var $author$project$Ui$Table$optionsToCellRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 3:
                    var _int = option.a;
                    return _Utils_update(record, {
                        pX: _int
                    });
                case 11:
                    var _int = option.a;
                    return _Utils_update(record, {
                        sB: _int
                    });
                case 9:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'nowrap', 'nowrap'), record.vD)
                    });
                case 8:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'style', 'padding-left: 20px !important'), record.vD)
                    });
                case 10:
                    var msg = option.a;
                    return _Utils_update(record, {
                        zU: $elm$core$Maybe$Just(msg)
                    });
                case 12:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Hv: bool
                    });
                case 13:
                    var direction = option.a;
                    return _Utils_update(record, {
                        kh: $elm$core$Maybe$Just(direction)
                    });
                case 7:
                    var width = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$style, 'min-width', width), record.vD)
                    });
                case 0:
                    var attr_ = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, attr_, record.vD)
                    });
                case 15:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle'), record.vD)
                    });
                case 14:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$style, 'vertical-align', 'bottom'), record.vD)
                    });
                case 2:
                    var alignment = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Alignment$toClass(alignment), record.vD)
                    });
                case 5:
                    var screen = option.a;
                    var span = option.b;
                    var widthClass = 'w-' + (span === 12 ? 'full' : $elm$core$String$fromInt(span) + '/12');
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class(_Utils_ap($author$project$Ui$Table$sizeToScreenPrefix(screen), widthClass)), A2($elm$core$List$cons, $elm$html$Html$Attributes$class($author$project$Ui$Table$sizeToScreenPrefix(screen) + 'table-cell'), record.vD))
                    });
                case 6:
                    var screenSize = option.a;
                    if (!screenSize) return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('flex-grid-hidden'), record.vD)
                    });
                    else return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class($author$project$Ui$Table$sizeToScreenPrefix(screenSize) + 'hidden'), record.vD)
                    });
                case 4:
                    var screenSize = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class($author$project$Ui$Table$sizeToScreenPrefix(screenSize) + 'table-cell'), record.vD)
                    });
                default:
                    var value = option.a;
                    return value ? _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'table-cell--active', record.EP)
                    }) : record;
            }
        }), $author$project$Ui$Table$defaultCellOptions, options);
    };
    var $author$project$Ui$Skeleton$Span = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$ScreenSize$Xs = 0;
    var $author$project$Ui$Skeleton$span = $author$project$Ui$Skeleton$Span(0);
    var $author$project$Ui$Skeleton$innerText = function(options) {
        return A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(A2($elm$core$List$filterMap, function(option) {
            if (option.$ === 2) {
                var someText = option.a;
                return $elm$core$Maybe$Just(someText);
            } else return $elm$core$Maybe$Nothing;
        }, options)));
    };
    var $author$project$Ui$Skeleton$optionToAttrs = function(option) {
        switch(option.$){
            case 0:
                var screenSize = option.a;
                var _int = option.b;
                var width = 'w-' + (_int === 12 ? 'full' : $elm$core$String$fromInt(_int) + '/12');
                return _List_fromArray([
                    $elm$html$Html$Attributes$class(_Utils_ap($author$project$Ui$ScreenSize$toClassPrefix(screenSize), width))
                ]);
            case 1:
                var _v1 = option.a;
                return $elm$core$List$singleton($elm$html$Html$Attributes$class('skeleton--block'));
            default:
                return $elm$core$List$singleton($elm$html$Html$Attributes$class('w-auto'));
        }
    };
    var $author$project$Ui$Skeleton$view = F2(function(modifier, options) {
        var attrs = A3($elm$core$List$foldl, F2(function(option, acc) {
            return _Utils_ap(acc, $author$project$Ui$Skeleton$optionToAttrs(option));
        }), _List_Nil, options);
        return A2($elm$html$Html$span, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('skeleton--' + modifier), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('skeleton'), attrs)), _List_fromArray([
            $elm$html$Html$text($author$project$Ui$Skeleton$innerText(options))
        ]));
    });
    var $author$project$Ui$Skeleton$text = $author$project$Ui$Skeleton$view('text');
    var $elm$html$Html$th = _VirtualDom_node('th');
    var $author$project$Ui$Table$viewHeader = F2(function(loading_, _v0) {
        var _v1 = _v0;
        var options = _v1.a;
        var contents = _v1.b;
        var optionsRecord = $author$project$Ui$Table$optionsToCellRecord(options);
        var attributes = $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', optionsRecord.EP)),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('clickable', optionsRecord.Hv)
                ])),
                $elm$html$Html$Attributes$class('table_cell table__cell--header')
            ]),
            A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), optionsRecord.vD),
            function() {
                var _v4 = optionsRecord.zU;
                if (!_v4.$) {
                    var toMsg = _v4.a;
                    return _List_fromArray([
                        $elm$html$Html$Events$onClick(toMsg),
                        $elm$html$Html$Attributes$class('clickable')
                    ]);
                } else return _List_Nil;
            }()
        ]));
        return A2($elm$html$Html$th, attributes, _Utils_ap(loading_ ? _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(10)
            ]))
        ]) : contents, function() {
            var _v2 = optionsRecord.kh;
            if (!_v2.$) {
                var direction = _v2.a;
                return $elm$core$List$singleton(A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$height('12px'),
                    $author$project$Ui$Icon$class('ml-2 -mb-0.5')
                ]), function() {
                    if (!direction) return 37;
                    else return 36;
                }()));
            } else return optionsRecord.Hv ? _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$height('12px'),
                    $author$project$Ui$Icon$class('ml-2 -mb-0.5')
                ]), 35)
            ]) : _List_Nil;
        }()));
    });
    var $author$project$Ui$Table$Cell = $elm$core$Basics$identity;
    var $author$project$Ui$Table$cell = F2(function(options, content) {
        return _Utils_Tuple2(options, content);
    });
    var $elm$core$List$repeatHelp = F3(function(result, n, value) {
        repeatHelp: while(true){
            if (n <= 0) return result;
            else {
                var $temp$result = A2($elm$core$List$cons, value, result), $temp$n = n - 1, $temp$value = value;
                result = $temp$result;
                n = $temp$n;
                value = $temp$value;
                continue repeatHelp;
            }
        }
    });
    var $elm$core$List$repeat = F2(function(n, value) {
        return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
    });
    var $elm$html$Html$Attributes$colspan = function(n) {
        return A2(_VirtualDom_attribute, 'colspan', $elm$core$String$fromInt(n));
    };
    var $elm$html$Html$Attributes$rowspan = function(n) {
        return A2(_VirtualDom_attribute, 'rowspan', $elm$core$String$fromInt(n));
    };
    var $elm$html$Html$td = _VirtualDom_node('td');
    var $author$project$Ui$Table$viewCell = function(_v0) {
        var _v1 = _v0;
        var options = _v1.a;
        var content = _v1.b;
        var optionsRecord = $author$project$Ui$Table$optionsToCellRecord(options);
        var attributes = $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $elm$html$Html$Attributes$class('table__cell')
            ]),
            A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), optionsRecord.vD),
            _List_fromArray([
                $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', optionsRecord.EP))
            ]),
            optionsRecord.pX !== 1 ? _List_fromArray([
                $elm$html$Html$Attributes$colspan(optionsRecord.pX)
            ]) : _List_Nil,
            optionsRecord.sB !== 1 ? _List_fromArray([
                $elm$html$Html$Attributes$rowspan(optionsRecord.sB)
            ]) : _List_Nil
        ]));
        return A2($elm$html$Html$td, attributes, content);
    };
    var $author$project$Ui$Table$viewLoading = function(colspan_) {
        return A2($elm$core$List$repeat, 10, A2($elm$html$Html$tr, _List_Nil, A2($elm$core$List$map, $author$project$Ui$Table$viewCell, A2($elm$core$List$repeat, colspan_, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(10)
            ]))
        ]))))));
    };
    var $author$project$Ui$Table$defaultRowOptions = {
        vD: _List_Nil,
        EP: _List_Nil
    };
    var $author$project$Ui$Table$optionsToRowRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            if (!option.$) {
                var color_ = option.a;
                switch(color_){
                    case 2:
                        return _Utils_update(record, {
                            EP: A2($elm$core$List$cons, 'table__row--info', record.EP)
                        });
                    case 1:
                        return _Utils_update(record, {
                            EP: A2($elm$core$List$cons, 'table__row--success', record.EP)
                        });
                    case 3:
                        return _Utils_update(record, {
                            EP: A2($elm$core$List$cons, 'table__row--warning', record.EP)
                        });
                    case 4:
                        return _Utils_update(record, {
                            EP: A2($elm$core$List$cons, 'table__row--danger', record.EP)
                        });
                    default:
                        return _Utils_update(record, {
                            EP: A2($elm$core$List$cons, 'active', record.EP)
                        });
                }
            } else return _Utils_update(record, {
                EP: A2($elm$core$List$cons, 'table__row--indented', record.EP)
            });
        }), $author$project$Ui$Table$defaultRowOptions, options);
    };
    var $author$project$Ui$Table$viewRow = function(row_) {
        if (row_.$ === 1) {
            var _v1 = row_.a;
            var options = _v1.a;
            var cells = _v1.b;
            var optionsRecord = $author$project$Ui$Table$optionsToRowRecord(options);
            var attributes = _List_fromArray([
                $elm$html$Html$Attributes$class('table__row'),
                $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', optionsRecord.EP))
            ]);
            return A2($elm$html$Html$tr, attributes, A2($elm$core$List$map, $author$project$Ui$Table$viewCell, cells));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Table$viewZeroState = F2(function(contents, colspan_) {
        return A2($elm$html$Html$tr, _List_fromArray([
            $elm$html$Html$Attributes$class('table__row')
        ]), _List_fromArray([
            A2($elm$html$Html$td, _List_fromArray([
                $elm$html$Html$Attributes$class('table__cell'),
                $elm$html$Html$Attributes$colspan(colspan_),
                $elm$html$Html$Attributes$class('text-center')
            ]), contents)
        ]));
    });
    var $author$project$Ui$Table$view = F4(function(options, headers, rows, footers) {
        var optionsRecord = $author$project$Ui$Table$optionsToRecord(options);
        var mainContainerClasses = A2($elm$core$String$join, ' ', optionsRecord.wS);
        var classes = A2($elm$core$List$cons, 'table', optionsRecord.EP);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(mainContainerClasses)
        ]), $elm$core$List$singleton(A2($elm$html$Html$table, A2($elm$core$List$cons, $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', classes)), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), optionsRecord.vD)), _List_fromArray([
            A2($elm$html$Html$thead, _List_Nil, _List_fromArray([
                A2($elm$html$Html$tr, _List_Nil, A2($elm$core$List$map, $author$project$Ui$Table$viewHeader(optionsRecord.Tk), headers))
            ])),
            A2($elm$html$Html$tbody, _List_Nil, function() {
                var _v0 = _Utils_Tuple3(optionsRecord.Tk, optionsRecord.D4, $elm$core$List$isEmpty(rows));
                if (_v0.a) return $author$project$Ui$Table$viewLoading($elm$core$List$length(headers));
                else {
                    if (!_v0.b.$ && _v0.c) {
                        var contents = _v0.b.a;
                        return _List_fromArray([
                            A2($author$project$Ui$Table$viewZeroState, contents, $elm$core$List$length(headers))
                        ]);
                    } else return A2($elm$core$List$map, $author$project$Ui$Table$viewRow, rows);
                }
            }()),
            $elm$core$List$isEmpty(footers) ? $author$project$Utils$Html$empty : A2($elm$html$Html$tfoot, _List_Nil, A2($elm$core$List$map, $author$project$Ui$Table$viewRow, footers))
        ]))));
    });
    var $author$project$Ui$Icon$Size = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Icon$Xs = 0;
    var $author$project$Ui$Icon$xs = $author$project$Ui$Icon$Size(0);
    var $author$project$Ui$Panel$sectionToContents = F2(function(optionsRecord, section) {
        switch(section.$){
            case 0:
                var attributes = section.a;
                var contents = section.b;
                var _v1 = optionsRecord.lA;
                if (!_v1.$) {
                    var isCollapsed = _v1.a;
                    var chevron = A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('panel-heading__chevron')
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$chevronDown(_List_fromArray([
                            $author$project$Ui$Icon$xs
                        ]))
                    ]));
                    var checkbox = A2($elm$html$Html$input, _List_fromArray([
                        $elm$html$Html$Attributes$type_('checkbox'),
                        $elm$html$Html$Attributes$class('panel__checkbox'),
                        A2($elm$html$Html$Attributes$property, 'defaultChecked', $elm$json$Json$Encode$bool(isCollapsed))
                    ]), _List_Nil);
                    return $elm$core$Maybe$Just(A4($author$project$Ui$Element$customNode, 'label', 'panel-heading', attributes, A2($elm$core$List$cons, checkbox, _Utils_ap(contents, _List_fromArray([
                        chevron
                    ])))));
                } else return $elm$core$Maybe$Just(A3($author$project$Ui$Element$custom, 'panel-heading', attributes, contents));
            case 1:
                var attributes = section.a;
                var contents = section.b;
                return $elm$core$Maybe$Just(A3($author$project$Ui$Element$custom, 'panel-body', attributes, contents));
            case 2:
                var attributes = section.a;
                var contents = section.b;
                return $elm$core$Maybe$Just(A3($author$project$Ui$Element$custom, 'panel-footer', attributes, contents));
            case 3:
                var options = section.a;
                var headers = section.b;
                var rows = section.c;
                var footers = section.d;
                return $elm$core$Maybe$Just(A4($author$project$Ui$Table$view, options, headers, rows, footers));
            case 4:
                return $elm$core$Maybe$Just($author$project$Ui$HorizontalRule$view(_List_Nil));
            default:
                return $elm$core$Maybe$Nothing;
        }
    });
    var $author$project$Ui$Panel$sectionsToContents = F2(function(optionsRecord, sections) {
        return A2($elm$core$List$filterMap, $author$project$Ui$Panel$sectionToContents(optionsRecord), sections);
    });
    var $author$project$Ui$Panel$view = F2(function(options, sections) {
        var optionsRecord = $author$project$Ui$Panel$optionsToRecord(options);
        var isCollapsible = !_Utils_eq(optionsRecord.lA, $elm$core$Maybe$Nothing);
        var isCollapsed = A2($elm$core$Maybe$withDefault, false, optionsRecord.lA);
        return A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('panel'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class(optionsRecord.s5), A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
            _Utils_Tuple2('panel--subtle', optionsRecord.Dx),
            _Utils_Tuple2('panel--collapsible', isCollapsible),
            _Utils_Tuple2('panel--collapsed', isCollapsed)
        ])), optionsRecord.vE))), A2($author$project$Ui$Panel$sectionsToContents, optionsRecord, sections));
    });
    var $author$project$Pages$Admin$AdvanceBilling$Autopay = 0;
    var $author$project$Pages$Admin$AdvanceBilling$Edit = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$AdvanceBilling$Monthly = 0;
    var $author$project$Pages$Admin$AdvanceBilling$NonMonthly = 1;
    var $author$project$Ui$Pull$Right = 1;
    var $author$project$Ui$Table$Grid = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Table$Xs = 0;
    var $author$project$Ui$Table$cellSpan = $author$project$Ui$Table$Grid(0);
    var $author$project$Ui$Icon$Edit = 40;
    var $author$project$Ui$Icon$edit = $author$project$Ui$Icon$viewIcon(40);
    var $author$project$Ui$Table$Header = $elm$core$Basics$identity;
    var $author$project$Ui$Table$header = F2(function(options, contents) {
        return _Utils_Tuple2(options, contents);
    });
    var $author$project$Ui$Button$Icon = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Ui$Button$icon = $author$project$Ui$Button$Icon;
    var $author$project$Ui$Button$Link = 7;
    var $author$project$Ui$Button$Styled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Button$styled = $author$project$Ui$Button$Styled;
    var $author$project$Ui$Button$link = $author$project$Ui$Button$styled(7);
    var $author$project$Ui$Button$OnClick = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Button$onClick = function(msg) {
        return $author$project$Ui$Button$OnClick(msg);
    };
    var $author$project$Ui$Button$Pull = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Button$pull = $author$project$Ui$Button$Pull;
    var $author$project$Ui$Table$Row = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Table$row = F2(function(options, cells) {
        return $author$project$Ui$Table$Row(_Utils_Tuple2(options, cells));
    });
    var $author$project$Ui$Button$Size = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Button$Sm = 0;
    var $author$project$Ui$Button$sm = $author$project$Ui$Button$Size(0);
    var $elm$core$String$dropRight = F2(function(n, string) {
        return n < 1 ? string : A3($elm$core$String$slice, 0, -n, string);
    });
    var $author$project$Formatters$String$vowels = _List_fromArray([
        'a',
        'e',
        'i',
        'o',
        'u'
    ]);
    var $author$project$Formatters$String$endsWithConsonantAndY = function(word) {
        var lastTwoChars = $elm$core$String$toList(A2($elm$core$String$right, 2, word));
        if (lastTwoChars.b && lastTwoChars.b.b && 'y' === lastTwoChars.b.a && !lastTwoChars.b.b.b) {
            var _char = lastTwoChars.a;
            var _v1 = lastTwoChars.b;
            return !A2($elm$core$List$member, _char, $author$project$Formatters$String$vowels);
        } else return false;
    };
    var $author$project$Formatters$String$endsWithS = function(word) {
        var lastChar = A2($elm$core$String$right, 1, word);
        return lastChar === 's';
    };
    var $author$project$Formatters$String$pluralOf = function(singular) {
        if (singular === 'child') return 'children';
        else return $author$project$Formatters$String$endsWithConsonantAndY(singular) ? A2($elm$core$String$dropRight, 1, singular) + 'ies' : $author$project$Formatters$String$endsWithS(singular) ? singular : singular + 's';
    };
    var $elm_community$string_extra$String$Extra$pluralize = F3(function(singular, plural, count) {
        return count === 1 ? '1 ' + singular : $elm$core$String$fromInt(count) + (' ' + plural);
    });
    var $author$project$Formatters$String$pluralize = F2(function(singular, count) {
        var plural = $author$project$Formatters$String$pluralOf(singular);
        return A3($elm_community$string_extra$String$Extra$pluralize, singular, plural, count);
    });
    var $author$project$Formatters$Int$toDays = $author$project$Formatters$String$pluralize('day');
    var $author$project$Ui$Button$AriaLabel = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $elm$html$Html$button = _VirtualDom_node('button');
    var $elm$html$Html$Attributes$boolProperty = F2(function(key, bool) {
        return A2(_VirtualDom_property, key, $elm$json$Json$Encode$bool(bool));
    });
    var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
    var $elm$json$Json$Decode$lazy = function(thunk) {
        return A2($elm$json$Json$Decode$andThen, thunk, $elm$json$Json$Decode$succeed(0));
    };
    var $author$project$Utils$Dom$isOutsideTarget = function(id) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            A2($elm$json$Json$Decode$andThen, function(elementId) {
                return _Utils_eq(id, elementId) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
            }, A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
            $elm$json$Json$Decode$lazy(function(_v0) {
                return A2($elm$json$Json$Decode$field, 'parentNode', $author$project$Utils$Dom$isOutsideTarget(id));
            }),
            $elm$json$Json$Decode$succeed(true)
        ]));
    };
    var $author$project$Utils$Dom$blurOutside = F2(function(msg, id) {
        return A2($elm$json$Json$Decode$andThen, function(isOutside) {
            return isOutside ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('blurred inside');
        }, A2($elm$json$Json$Decode$field, 'relatedTarget', $author$project$Utils$Dom$isOutsideTarget(id)));
    });
    var $author$project$Utils$Dom$onOutsideBlur = F2(function(msg, id) {
        return A2($elm$html$Html$Events$on, 'blur', A2($author$project$Utils$Dom$blurOutside, msg, id));
    });
    var $author$project$Ui$Button$Secondary = 2;
    var $author$project$Ui$Button$Default = 0;
    var $author$project$Ui$Button$Md = 1;
    var $author$project$Ui$Button$defaultOptions = {
        vD: _List_Nil,
        d$: false,
        Oj: false,
        FD: false,
        QZ: $elm$core$Maybe$Nothing,
        qS: _List_Nil,
        Tk: false,
        zU: $elm$core$Maybe$Nothing,
        zZ: $elm$core$Maybe$Nothing,
        ahq: 1,
        s5: 0,
        ti: 0,
        ah5: 'button'
    };
    var $author$project$Ui$Icon$Lg = 3;
    var $author$project$Ui$Icon$lg = $author$project$Ui$Icon$Size(3);
    var $author$project$Ui$Icon$Sm = 1;
    var $author$project$Ui$Icon$sm = $author$project$Ui$Icon$Size(1);
    var $author$project$Ui$Button$sizeToIconSize = function(size_) {
        switch(size_){
            case 0:
                return _List_fromArray([
                    $author$project$Ui$Icon$sm
                ]);
            case 1:
                return _List_Nil;
            default:
                return _List_fromArray([
                    $author$project$Ui$Icon$lg
                ]);
        }
    };
    var $author$project$Ui$Alignment$toAttrs = function(alignment) {
        return _List_fromArray([
            $elm$html$Html$Attributes$class($author$project$Ui$Alignment$toClassName(alignment))
        ]);
    };
    var $author$project$Ui$Padding$toClass = function(margin) {
        switch(margin){
            case 0:
                return $elm$html$Html$Attributes$class('p-0');
            case 1:
                return $elm$html$Html$Attributes$class('pl-0');
            case 2:
                return $elm$html$Html$Attributes$class('pl-05');
            case 3:
                return $elm$html$Html$Attributes$class('pl-2');
            case 4:
                return $elm$html$Html$Attributes$class('pr-2');
            case 5:
                return $elm$html$Html$Attributes$class('pt-0');
            case 7:
                return $elm$html$Html$Attributes$class('pt-05');
            case 6:
                return $elm$html$Html$Attributes$class('pt-1');
            case 8:
                return $elm$html$Html$Attributes$class('pb-1');
            case 9:
                return $elm$html$Html$Attributes$class('pb-3');
            case 10:
                return $elm$html$Html$Attributes$class('px-1');
            default:
                return $elm$html$Html$Attributes$class('px-2');
        }
    };
    var $author$project$Ui$Pull$toClass = function(direction) {
        if (!direction) return $elm$html$Html$Attributes$class('pull-left');
        else return $elm$html$Html$Attributes$class('pull-right');
    };
    var $author$project$Ui$Button$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var stylingType = option.a;
                    return _Utils_update(record, {
                        s5: stylingType
                    });
                case 8:
                    var size_ = option.a;
                    return _Utils_update(record, {
                        qS: _Utils_ap($author$project$Ui$Button$sizeToIconSize(size_), record.qS),
                        ahq: size_
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(record, {
                        d$: bool
                    });
                case 3:
                    return _Utils_update(record, {
                        ah5: 'submit'
                    });
                case 12:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('close'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'), record.vD)),
                        s5: 2
                    });
                case 6:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Tk: bool
                    });
                case 4:
                    var msg = option.a;
                    return _Utils_update(record, {
                        zU: $elm$core$Maybe$Just(msg)
                    });
                case 5:
                    var ids = option.a;
                    var msg = option.b;
                    return _Utils_update(record, {
                        zZ: $elm$core$Maybe$Just(_Utils_Tuple2(ids, msg))
                    });
                case 7:
                    var bool = option.a;
                    return _Utils_update(record, {
                        FD: bool
                    });
                case 2:
                    var list = option.a;
                    return _Utils_update(record, {
                        vD: _Utils_ap(record.vD, list)
                    });
                case 9:
                    var side = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Pull$toClass(side), record.vD)
                    });
                case 11:
                    var margin_ = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Margin$toClass(margin_), record.vD)
                    });
                case 10:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('button--primary', bool)
                        ])), record.vD)
                    });
                case 13:
                    var alignment = option.a;
                    return _Utils_update(record, {
                        vD: _Utils_ap($author$project$Ui$Alignment$toAttrs(alignment), record.vD)
                    });
                case 14:
                    var padding_ = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Padding$toClass(padding_), record.vD)
                    });
                case 15:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('dropdown-toggle'), record.vD)
                    });
                case 16:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Utils$Html$Attributes$test(string), record.vD)
                    });
                case 17:
                    var iconFunc = option.a;
                    return _Utils_update(record, {
                        QZ: $elm$core$Maybe$Just(iconFunc)
                    });
                case 18:
                    var label = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-label', label), record.vD)
                    });
                case 20:
                    var index = option.a;
                    return _Utils_update(record, {
                        ti: index
                    });
                default:
                    var display_ = option.a;
                    var screenSize = option.b;
                    return display_ ? _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class($author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'inline-flex'), record.vD)
                    }) : _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class($author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden'), record.vD)
                    });
            }
        }), $author$project$Ui$Button$defaultOptions, options);
    };
    var $author$project$Ui$Icon$ProgressActivity = 88;
    var $author$project$Ui$Icon$progressActivity = $author$project$Ui$Icon$viewIcon(88);
    var $author$project$Ui$Button$sizeClass = function(size_) {
        return $elm$html$Html$Attributes$class(function() {
            switch(size_){
                case 0:
                    return 'button--sm';
                case 1:
                    return '';
                default:
                    return 'button--lg';
            }
        }());
    };
    var $author$project$Ui$Button$styleClass = function(style) {
        return $elm$html$Html$Attributes$class(function() {
            switch(style){
                case 0:
                    return 'button--default';
                case 1:
                    return 'button--primary';
                case 2:
                    return 'button--secondary';
                case 3:
                    return 'button--success';
                case 4:
                    return 'button--warning';
                case 5:
                    return 'button--danger';
                case 7:
                    return 'button--link';
                case 6:
                    return 'button--outline';
                case 8:
                    return 'button--link button--link-gray';
                case 9:
                    return 'button--with-bg-image';
                default:
                    return 'button--badge';
            }
        }());
    };
    var $elm$html$Html$Attributes$tabindex = function(n) {
        return A2(_VirtualDom_attribute, 'tabIndex', $elm$core$String$fromInt(n));
    };
    var $author$project$Ui$Button$view = F3(function(_v0, options, content) {
        var ariaLabel = _v0.abP;
        var optionsRecord = $author$project$Ui$Button$optionsToRecord(A2($elm$core$List$cons, $author$project$Ui$Button$AriaLabel(ariaLabel), options));
        var attributes = $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $elm$html$Html$Attributes$class('button'),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('button--loading', optionsRecord.Tk),
                    _Utils_Tuple2('w-full justify-center', optionsRecord.FD)
                ])),
                $author$project$Ui$Button$styleClass(optionsRecord.s5),
                $author$project$Ui$Button$sizeClass(optionsRecord.ahq),
                $elm$html$Html$Attributes$disabled(optionsRecord.d$ || optionsRecord.Tk),
                !!optionsRecord.ti ? $elm$html$Html$Attributes$tabindex(optionsRecord.ti) : $elm$html$Html$Attributes$class('')
            ]),
            A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), optionsRecord.vD),
            function() {
                var _v1 = _Utils_Tuple2(optionsRecord.d$, optionsRecord.zU);
                if (!_v1.a && !_v1.b.$) {
                    var msg = _v1.b.a;
                    return _List_fromArray([
                        $elm$html$Html$Events$onClick(msg)
                    ]);
                } else return _List_Nil;
            }(),
            _List_fromArray([
                $elm$html$Html$Attributes$type_(optionsRecord.ah5)
            ]),
            function() {
                var _v2 = optionsRecord.zZ;
                if (_v2.$ === 1) return _List_Nil;
                else {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var msg = _v3.b;
                    return _List_fromArray([
                        A2($author$project$Utils$Dom$onOutsideBlur, msg, id)
                    ]);
                }
            }()
        ]));
        return A2($elm$html$Html$button, attributes, A2($elm$core$List$cons, A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function(icon_) {
            return icon_(optionsRecord.qS);
        }, optionsRecord.QZ)), _Utils_ap($elm$core$List$isEmpty(content) ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('button__content')
            ]), content)
        ]), optionsRecord.Tk ? _List_fromArray([
            $author$project$Ui$Icon$progressActivity(_List_Nil)
        ]) : _List_Nil)));
    });
    var $author$project$Ui$Typography$Aligned = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Typography$aligned = $author$project$Ui$Typography$Aligned;
    var $author$project$Components$Admin$NotificationSetting$Customize$OpenModal = {
        $: 0
    };
    var $author$project$Api$Provider$NotificationSetting$Meta$bodyEditable = function(_v0) {
        var meta = _v0;
        return meta.fb.Ot;
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Ui$Padding$None = 0;
    var $author$project$Ui$Padding$none = 0;
    var $author$project$Ui$Button$Padding = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Ui$Button$padding = $author$project$Ui$Button$Padding;
    var $author$project$Components$Admin$NotificationSetting$Customize$button = function(model) {
        return $author$project$Api$Provider$NotificationSetting$Meta$bodyEditable($author$project$Api$Provider$NotificationSetting$Shared$meta(model.U7)) ? A3($author$project$Ui$Button$view, {
            abP: 'Customize notification'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$OpenModal)
        ]), _List_fromArray([
            $elm$html$Html$text('Customize')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$OverflowWrap$toAttrs = function(overflowWrap) {
        var value = function() {
            switch(overflowWrap){
                case 3:
                    return 'wrap-word';
                case 0:
                    return 'break-word';
                case 2:
                    return 'anywhere';
                case 1:
                    return 'normal';
                default:
                    return 'break-all';
            }
        }();
        return _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'overflow-wrap', value)
        ]);
    };
    var $author$project$Ui$FontWeight$toClass = function(direction) {
        if (!direction) return $elm$html$Html$Attributes$class('font-weight-medium');
        else return $elm$html$Html$Attributes$class('font-weight-normal');
    };
    var $author$project$Ui$Typography$optionToAttributes = function(option) {
        switch(option.$){
            case 0:
                var list = option.a;
                return list;
            case 2:
                var alignment = option.a;
                return $author$project$Ui$Alignment$toAttrs(alignment);
            case 3:
                var overflowWrap_ = option.a;
                return $author$project$Ui$OverflowWrap$toAttrs(overflowWrap_);
            case 4:
                var decoration = option.a;
                switch(decoration){
                    case 2:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('italic')
                        ]);
                    case 0:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('underline')
                        ]);
                    case 1:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-strike')
                        ]);
                    case 3:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('font-bold')
                        ]);
                    default:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-capitalized')
                        ]);
                }
            case 1:
                var color = option.a;
                switch(color){
                    case 0:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-muted')
                        ]);
                    case 1:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-primary')
                        ]);
                    case 5:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-danger')
                        ]);
                    case 2:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-success')
                        ]);
                    case 4:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-warning')
                        ]);
                    case 3:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-info')
                        ]);
                    case 6:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-dark-gray')
                        ]);
                    case 7:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-gray')
                        ]);
                    default:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('text-main')
                        ]);
                }
            case 5:
                var direction = option.a;
                return _List_fromArray([
                    $author$project$Ui$Pull$toClass(direction)
                ]);
            case 6:
                var bool = option.a;
                return bool ? $author$project$Api$Phi$displayAttr : _List_Nil;
            case 7:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('text-xs')
                ]);
            case 8:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('text-body-sm text-muted')
                ]);
            case 9:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('help-text')
                ]);
            case 10:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('amount')
                ]);
            case 11:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('badge')
                ]);
            case 12:
                var margin_ = option.a;
                return _List_fromArray([
                    $author$project$Ui$Margin$toClass(margin_)
                ]);
            case 13:
                var padding_ = option.a;
                return _List_fromArray([
                    $author$project$Ui$Padding$toClass(padding_)
                ]);
            case 14:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('control-label')
                ]);
            case 15:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('pre-wrap')
                ]);
            case 16:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('ellipsis')
                ]);
            case 17:
                var fontWeight_ = option.a;
                return _List_fromArray([
                    $author$project$Ui$FontWeight$toClass(fontWeight_)
                ]);
            case 18:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('text-label-md text-muted')
                ]);
            case 19:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('numeric')
                ]);
            case 20:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('created-by')
                ]);
            case 21:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('authorization_code')
                ]);
            case 22:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('long-text')
                ]);
            case 23:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('subtotal')
                ]);
            case 24:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('membership-savings')
                ]);
            case 25:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('display-3')
                ]);
            case 26:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('display-4')
                ]);
            case 27:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('display-5')
                ]);
            case 28:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('age')
                ]);
            case 29:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('xs:hidden')
                ]);
            case 30:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('sm:hidden')
                ]);
            case 31:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('md:hidden')
                ]);
            case 32:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('title-separator')
                ]);
            case 33:
                var bool = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('content-disabled', bool)
                    ]))
                ]);
            case 34:
                var bool = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('inactive', bool)
                    ]))
                ]);
            case 35:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('sr-only')
                ]);
            case 36:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('highlighted')
                ]);
            default:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('w-full')
                ]);
        }
    };
    var $author$project$Ui$Typography$optionsToAttributes = function(options) {
        return A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), A2($elm$core$List$concatMap, $author$project$Ui$Typography$optionToAttributes, options));
    };
    var $author$project$Ui$Typography$div = F2(function(options, contents) {
        return A2($elm$html$Html$div, $author$project$Ui$Typography$optionsToAttributes(options), contents);
    });
    var $author$project$Ui$Modal$Body = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Modal$body = function(contents) {
        return $author$project$Ui$Modal$Body(contents);
    };
    var $author$project$Ui$Modal$Footer = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Modal$footer = function(contents) {
        return $author$project$Ui$Modal$Footer(contents);
    };
    var $author$project$Ui$Modal$Header = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Modal$header = function(contents) {
        return $author$project$Ui$Modal$Header(contents);
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml = function(_v0) {
        var record = _v0;
        return record.Z8;
    };
    var $author$project$Ui$Modal$title = function(string) {
        return A2($elm$html$Html$h4, _List_fromArray([
            $elm$html$Html$Attributes$class('modal-title')
        ]), _List_fromArray([
            $elm$html$Html$text(string)
        ]));
    };
    var $elm$html$Html$form = _VirtualDom_node('form');
    var $elm$html$Html$Events$alwaysPreventDefault = function(msg) {
        return _Utils_Tuple2(msg, true);
    };
    var $elm$virtual_dom$VirtualDom$MayPreventDefault = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $elm$html$Html$Events$preventDefaultOn = F2(function(event, decoder) {
        return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
    });
    var $elm$html$Html$Events$onSubmit = function(msg) {
        return A2($elm$html$Html$Events$preventDefaultOn, 'submit', A2($elm$json$Json$Decode$map, $elm$html$Html$Events$alwaysPreventDefault, $elm$json$Json$Decode$succeed(msg)));
    };
    var $author$project$Ui$Modal$Md = 1;
    var $author$project$Ui$Modal$defaultOptions = {
        qm: true,
        z2: $elm$core$Maybe$Nothing,
        ahq: 1
    };
    var $author$project$Ui$Modal$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var size_ = option.a;
                    return _Utils_update(record, {
                        ahq: size_
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(record, {
                        qm: bool
                    });
                default:
                    var msg = option.a;
                    return _Utils_update(record, {
                        z2: $elm$core$Maybe$Just(msg)
                    });
            }
        }), $author$project$Ui$Modal$defaultOptions, options);
    };
    var $author$project$Ui$Modal$sizeClass = function(size_) {
        switch(size_){
            case 0:
                return 'modal-sm';
            case 1:
                return '';
            case 2:
                return 'modal-lg';
            default:
                return 'x-large';
        }
    };
    var $author$project$Ui$Modal$viewBackdrop = function(onClose) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('modal__backdrop'),
            A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
            A2($elm$html$Html$Attributes$style, 'inset', '0px'),
            A2($elm$html$Html$Attributes$style, 'z-index', '1040'),
            $elm$html$Html$Events$onClick(onClose)
        ]), _List_Nil);
    };
    var $author$project$Utils$Html$multiplication = $elm$html$Html$text($elm$core$String$fromChar("\xd7"));
    var $author$project$Ui$Modal$closeButton = function(onClose) {
        return A2($elm$html$Html$button, _List_fromArray([
            $elm$html$Html$Attributes$type_('button'),
            $elm$html$Html$Attributes$class('button close'),
            A2($elm$html$Html$Attributes$attribute, 'aria-label', 'Close'),
            $elm$html$Html$Events$onClick(onClose)
        ]), _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
            ]), _List_fromArray([
                $author$project$Utils$Html$multiplication
            ]))
        ]));
    };
    var $author$project$Ui$Modal$viewSection = F3(function(dismisiable_, onCloseMsg, section) {
        switch(section.$){
            case 0:
                var contents = section.a;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('modal-header')
                ]), dismisiable_ ? A2($elm$core$List$cons, $author$project$Ui$Modal$closeButton(onCloseMsg), contents) : contents);
            case 1:
                var contents = section.a;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('modal-body')
                ]), contents);
            case 2:
                var contents = section.a;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('modal-faq')
                ]), contents);
            default:
                var contents = section.a;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('modal-footer')
                ]), contents);
        }
    });
    var $author$project$Ui$Modal$view = F3(function(onClose, options, sections) {
        var optionsRecord = $author$project$Ui$Modal$optionsToRecord(options);
        var wrapInsideForm = function(htmlSections) {
            var _v0 = optionsRecord.z2;
            if (!_v0.$) {
                var msg = _v0.a;
                return _List_fromArray([
                    A2($elm$html$Html$form, _List_fromArray([
                        $elm$html$Html$Events$onSubmit(msg)
                    ]), htmlSections)
                ]);
            } else return htmlSections;
        };
        return function(content) {
            return A3($elm$html$Html$node, 'elm-modal', _List_fromArray([
                $elm$html$Html$Attributes$class('elm-modal show'),
                $elm$html$Html$Attributes$tabindex(-1),
                A2($elm$html$Html$Attributes$attribute, 'role', 'dialog')
            ]), _List_fromArray([
                $author$project$Ui$Modal$viewBackdrop(onClose),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('modal-dialog'),
                    $elm$html$Html$Attributes$class($author$project$Ui$Modal$sizeClass(optionsRecord.ahq)),
                    A2($elm$html$Html$Attributes$attribute, 'role', 'document')
                ]), _List_fromArray([
                    content
                ]))
            ]));
        }(A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('modal-content')
        ]), wrapInsideForm(A2($elm$core$List$map, A2($author$project$Ui$Modal$viewSection, optionsRecord.qm, onClose), sections))));
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$Subject = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$NotificationSettingPreview$body = function(_v0) {
        var record = _v0;
        return record.fb;
    };
    var $elm$html$Html$br = _VirtualDom_node('br');
    var $author$project$Ui$Alert$Danger = 3;
    var $author$project$Ui$Icon$Cross = 48;
    var $author$project$Ui$Icon$cross = $author$project$Ui$Icon$viewIcon(48);
    var $author$project$Ui$Alert$dismissButton = function(msg) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Dismiss alert'
        }, _List_fromArray([
            $author$project$Ui$Button$onClick(msg)
        ]), _List_fromArray([
            $author$project$Ui$Icon$cross(_List_Nil)
        ]));
    };
    var $author$project$Ui$Alert$defaultOptions = {
        vD: _List_Nil,
        qm: $elm$core$Maybe$Nothing,
        tg: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Alert$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var msg = option.a;
                    return _Utils_update(record, {
                        qm: $elm$core$Maybe$Just(msg)
                    });
                case 1:
                    var margin_ = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Margin$toClass(margin_), record.vD)
                    });
                case 2:
                    var alignment_ = option.a;
                    return _Utils_update(record, {
                        vD: _Utils_ap($author$project$Ui$Alignment$toAttrs(alignment_), record.vD)
                    });
                case 3:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('hard-notification'), record.vD)
                    });
                case 4:
                    var svgIcon = option.a;
                    return _Utils_update(record, {
                        tg: $elm$core$Maybe$Just(svgIcon)
                    });
                default:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('h-full'), record.vD)
                    });
            }
        }), $author$project$Ui$Alert$defaultOptions, options);
    };
    var $author$project$Ui$Alert$styleClass = function(style) {
        switch(style){
            case 0:
                return 'alert--success';
            case 1:
                return 'alert--info';
            case 2:
                return 'alert--warning';
            case 3:
                return 'alert--danger';
            default:
                return 'alert--primary';
        }
    };
    var $author$project$Ui$Icon$Width = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Icon$width = $author$project$Ui$Icon$Width;
    var $author$project$Ui$Alert$view = F3(function(style, options, contents) {
        var optionsRecord = $author$project$Ui$Alert$optionsToRecord(options);
        var hasFullHeight = A2($elm$core$List$any, function(opt) {
            if (opt.$ === 5) return true;
            else return false;
        }, options);
        var attributes = $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $elm$html$Html$Attributes$class('alert'),
                $elm$html$Html$Attributes$class($author$project$Ui$Alert$styleClass(style)),
                A2($elm$html$Html$Attributes$attribute, 'role', 'alert')
            ]),
            A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), optionsRecord.vD),
            function() {
                var _v2 = optionsRecord.qm;
                if (!_v2.$) return _List_fromArray([
                    $elm$html$Html$Attributes$class('alert--dismissible')
                ]);
                else return _List_Nil;
            }(),
            function() {
                var _v3 = optionsRecord.tg;
                if (!_v3.$) return _List_fromArray([
                    $elm$html$Html$Attributes$class('alert--icon')
                ]);
                else return _List_Nil;
            }()
        ]));
        return A2($elm$html$Html$div, attributes, $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = optionsRecord.tg;
                if (!_v0.$) {
                    var msg = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$width('24px'),
                            $author$project$Ui$Icon$height('24px')
                        ]), msg)
                    ]);
                } else return _List_Nil;
            }(),
            _List_fromArray([
                A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('alert--contents'), hasFullHeight ? _List_fromArray([
                    $elm$html$Html$Attributes$class('h-full')
                ]) : _List_Nil), contents)
            ]),
            function() {
                var _v1 = optionsRecord.qm;
                if (!_v1.$) {
                    var msg = _v1.a;
                    return _List_fromArray([
                        $author$project$Ui$Alert$dismissButton(msg)
                    ]);
                } else return _List_Nil;
            }()
        ])));
    });
    var $author$project$Ui$Alert$danger = $author$project$Ui$Alert$view(3);
    var $author$project$Api$Data$errorToString = function(errorResponse) {
        switch(errorResponse.$){
            case 0:
                var errorMessage = errorResponse.a;
                return A2($elm$core$Maybe$withDefault, 'Unauthorized', errorMessage);
            case 1:
                return 'BadUrl';
            case 2:
                return 'Timeout';
            case 3:
                return 'Network';
            case 4:
                return 'Server Error';
            case 5:
                return 'Not Found';
            case 8:
                var errorMessage = errorResponse.a;
                return A2($elm$core$Maybe$withDefault, 'Internal Server Error', errorMessage);
            case 6:
                var errorMessage = errorResponse.b;
                return errorMessage;
            case 7:
                var string = errorResponse.a;
                return 'Decoder error! ' + string;
            case 9:
                var errorMessage = errorResponse.a;
                return A2($elm$core$Maybe$withDefault, 'Forbidden', errorMessage);
            default:
                var errorMessage = errorResponse.a;
                return A2($elm$core$Maybe$withDefault, 'Conflict', errorMessage);
        }
    };
    var $author$project$Ui$Form$Textarea$Id = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$id = $author$project$Ui$Form$Textarea$Id;
    var $elm$html$Html$li = _VirtualDom_node('li');
    var $author$project$Ui$Typography$Color = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Typography$Muted = 0;
    var $author$project$Ui$Typography$muted = $author$project$Ui$Typography$Color(0);
    var $author$project$Ui$Form$Input$OnInput = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$onInput = $author$project$Ui$Form$Input$OnInput;
    var $elm$html$Html$p = _VirtualDom_node('p');
    var $author$project$Ui$Typography$p = F2(function(options, content) {
        return A2($elm$html$Html$p, $author$project$Ui$Typography$optionsToAttributes(options), content);
    });
    var $author$project$Ui$Form$Input$Phi = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$phi = $author$project$Ui$Form$Input$Phi;
    var $author$project$Ui$Form$Textarea$Phi = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$phi = $author$project$Ui$Form$Textarea$Phi;
    var $author$project$Ui$Typography$Phi = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Typography$phi = $author$project$Ui$Typography$Phi;
    var $author$project$Ui$Link$Route = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$html$Html$a = _VirtualDom_node('a');
    var $elm$html$Html$Attributes$href = function(url) {
        return A2($elm$html$Html$Attributes$stringProperty, 'href', _VirtualDom_noJavaScriptUri(url));
    };
    var $author$project$Ui$Link$defaultOptions = {
        vD: _List_Nil,
        dz: false,
        mv: $elm$core$Maybe$Nothing,
        QZ: $elm$core$Maybe$Nothing,
        qS: _List_Nil,
        ya: $elm$core$Maybe$Nothing,
        qT: _List_Nil,
        d: $elm$core$Maybe$Nothing,
        sA: _List_Nil,
        ti: 0
    };
    var $author$project$Ui$Icon$Md = 2;
    var $author$project$Ui$Icon$base = $author$project$Ui$Icon$Size(2);
    var $author$project$Ui$Link$sizeToIconSize = function(size_) {
        switch(size_){
            case 1:
                return _List_fromArray([
                    $author$project$Ui$Icon$xs
                ]);
            case 0:
                return _List_fromArray([
                    $author$project$Ui$Icon$sm
                ]);
            case 2:
                return _List_fromArray([
                    $author$project$Ui$Icon$base
                ]);
            default:
                return _List_fromArray([
                    $author$project$Ui$Icon$lg
                ]);
        }
    };
    var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
    var $author$project$Ui$Link$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var route_ = option.a;
                    return _Utils_update(record, {
                        d: $elm$core$Maybe$Just(route_)
                    });
                case 1:
                    var list = option.a;
                    return _Utils_update(record, {
                        sA: _Utils_ap(list, record.sA)
                    });
                case 2:
                    var string = option.a;
                    return _Utils_update(record, {
                        mv: $elm$core$Maybe$Just(string)
                    });
                case 3:
                    var string = option.a;
                    return _Utils_update(record, {
                        mv: $elm$core$Maybe$Just('mailto:' + string)
                    });
                case 4:
                    var string = option.a;
                    return _Utils_update(record, {
                        mv: $elm$core$Maybe$Just('tel:' + string)
                    });
                case 5:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Utils$Html$Attributes$test(string), record.vD)
                    });
                case 8:
                    var msg = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Events$onClick(msg), record.vD)
                    });
                case 6:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$target('_blank'), record.vD)
                    });
                case 7:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('w-full block'), record.vD)
                    });
                case 9:
                    var side = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Pull$toClass(side), record.vD)
                    });
                case 10:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(bool), A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('disabled', bool)
                        ])), record.vD))
                    });
                case 11:
                    var margin_ = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Margin$toClass(margin_), record.vD)
                    });
                case 12:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('text-muted pointer'), record.vD)
                    });
                case 14:
                    var size = option.a;
                    var modifier = function() {
                        switch(size){
                            case 1:
                                return '--xs';
                            case 0:
                                return '--sm';
                            case 2:
                                return '--md';
                            default:
                                return '--lg';
                        }
                    }();
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('link' + modifier), A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('button' + modifier, record.dz)
                        ])), record.vD)),
                        qS: _Utils_ap($author$project$Ui$Link$sizeToIconSize(size), record.qS),
                        qT: _Utils_ap($author$project$Ui$Link$sizeToIconSize(size), record.qT)
                    });
                case 13:
                    var style_ = option.a;
                    switch(style_){
                        case 0:
                            return _Utils_update(record, {
                                vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('button button--primary'), record.vD),
                                dz: true
                            });
                        case 1:
                            return _Utils_update(record, {
                                vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('button button--success'), record.vD),
                                dz: true
                            });
                        case 2:
                            return _Utils_update(record, {
                                vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('button button--default'), record.vD),
                                dz: true
                            });
                        case 3:
                            return _Utils_update(record, {
                                vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('button button--secondary'), record.vD),
                                dz: true
                            });
                        case 4:
                            return _Utils_update(record, {
                                vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('button button--warning'), record.vD),
                                dz: true
                            });
                        default:
                            return _Utils_update(record, {
                                vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('underline'), record.vD)
                            });
                    }
                case 15:
                    var icon_ = option.a;
                    return _Utils_update(record, {
                        QZ: $elm$core$Maybe$Just(icon_)
                    });
                case 16:
                    var iconRight_ = option.a;
                    return _Utils_update(record, {
                        ya: $elm$core$Maybe$Just(iconRight_)
                    });
                case 17:
                    var label = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-label', label), record.vD)
                    });
                case 18:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('text-current'), record.vD)
                    });
                default:
                    var _int = option.a;
                    return _Utils_update(record, {
                        ti: _int
                    });
            }
        }), $author$project$Ui$Link$defaultOptions, options);
    };
    var $author$project$Ui$Link$view = F2(function(options, content) {
        var optionsRecord = $author$project$Ui$Link$optionsToRecord(options);
        return A2($elm$html$Html$a, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('link', !optionsRecord.dz)
                ]))
            ]),
            function() {
                var _v0 = _Utils_Tuple2(optionsRecord.d, optionsRecord.mv);
                if (!_v0.a.$) {
                    var route_ = _v0.a.a;
                    return _List_fromArray([
                        $elm$html$Html$Attributes$href(_Utils_ap($author$project$Spa$Generated$Route$toString(route_), $elm$url$Url$Builder$toQuery(optionsRecord.sA)))
                    ]);
                } else if (!_v0.b.$) {
                    var _v1 = _v0.a;
                    var string = _v0.b.a;
                    return _List_fromArray([
                        $elm$html$Html$Attributes$href(string)
                    ]);
                } else {
                    var _v2 = _v0.a;
                    var _v3 = _v0.b;
                    return _List_Nil;
                }
            }(),
            _List_fromArray([
                $elm$html$Html$Attributes$tabindex(optionsRecord.ti)
            ]),
            optionsRecord.vD
        ])), _List_fromArray([
            function() {
                var _v4 = optionsRecord.QZ;
                if (!_v4.$) {
                    var icon_ = _v4.a;
                    return icon_(optionsRecord.qS);
                } else return $elm$html$Html$text('');
            }(),
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('link__content')
            ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content)),
            function() {
                var _v5 = optionsRecord.ya;
                if (!_v5.$) {
                    var iconRight_ = _v5.a;
                    return A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('ml-2')
                    ]), _List_fromArray([
                        iconRight_(optionsRecord.qT)
                    ]));
                } else return $elm$html$Html$text('');
            }()
        ]));
    });
    var $author$project$Ui$Link$route = F3(function(route_, options, content) {
        return A2($author$project$Ui$Link$view, A2($elm$core$List$cons, $author$project$Ui$Link$Route(route_), options), content);
    });
    var $author$project$Ui$Form$Textarea$Rows = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$rows = $author$project$Ui$Form$Textarea$Rows;
    var $author$project$Ui$Typography$Small = {
        $: 7
    };
    var $author$project$Ui$Typography$small = $author$project$Ui$Typography$Small;
    var $elm$html$Html$strong = _VirtualDom_node('strong');
    var $author$project$Ui$Typography$strong = F2(function(options, content) {
        return A2($elm$html$Html$strong, $author$project$Ui$Typography$optionsToAttributes(options), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content));
    });
    var $author$project$Api$Provider$NotificationSettingPreview$subject = function(_v0) {
        var record = _v0;
        return record.HF;
    };
    var $elm$html$Html$ul = _VirtualDom_node('ul');
    var $author$project$Ui$Form$Input$Value = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$value = $author$project$Ui$Form$Input$Value;
    var $author$project$Api$HtmlTemplate$view = F2(function(attributes, _v0) {
        var html = _v0;
        return A3($elm$html$Html$node, 'html-template', A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'contents', html), attributes), _List_Nil);
    });
    var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
    var $author$project$Ui$Form$Group$defaultOptions = {
        vD: _List_Nil,
        QZ: $elm$core$Maybe$Nothing,
        mz: _List_Nil,
        aeI: $elm$core$Maybe$Nothing,
        yz: 'control-label',
        mQ: _List_Nil,
        yA: $elm$core$Maybe$Nothing,
        mR: false,
        agM: false
    };
    var $author$project$Ui$Clearfix$toClass = $elm$html$Html$Attributes$class('clearfix');
    var $author$project$Ui$Form$Group$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var lab = option.a;
                    return _Utils_update(record, {
                        aeI: $elm$core$Maybe$Just(lab)
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(record, {
                        agM: bool
                    });
                case 3:
                    var list = option.a;
                    return _Utils_update(record, {
                        mQ: _Utils_ap(record.mQ, list)
                    });
                case 4:
                    var list = option.a;
                    return _Utils_update(record, {
                        mz: _Utils_ap(record.mz, list)
                    });
                case 2:
                    var side = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Pull$toClass(side), record.vD)
                    });
                case 5:
                    var list = option.a;
                    return _Utils_update(record, {
                        yA: $elm$core$Maybe$Just(list)
                    });
                case 6:
                    var list = option.a;
                    return _Utils_update(record, {
                        yz: list
                    });
                case 7:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Clearfix$toClass, record.vD)
                    });
                case 8:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-inline'), record.vD)
                    });
                case 9:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('has-error', bool)
                        ])), record.vD)
                    });
                case 10:
                    var margin_ = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Margin$toClass(margin_), record.vD)
                    });
                case 11:
                    return _Utils_update(record, {
                        mR: true
                    });
                case 12:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Utils$Html$Attributes$test(string), record.vD)
                    });
                case 13:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-group--label-above'), record.vD)
                    });
                default:
                    var icon_ = option.a;
                    return _Utils_update(record, {
                        QZ: $elm$core$Maybe$Just(icon_)
                    });
            }
        }), $author$project$Ui$Form$Group$defaultOptions, options);
    };
    var $author$project$Ui$Typography$Attr = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Typography$attrs = function(attributes) {
        return $author$project$Ui$Typography$Attr(attributes);
    };
    var $elm$html$Html$label = _VirtualDom_node('label');
    var $author$project$Ui$Typography$label = F2(function(options, content) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$label, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('text-label-md'), $author$project$Ui$Typography$optionsToAttributes(options)), content));
    });
    var $author$project$Utils$String$noBreakSpace = $elm$core$String$fromChar('\u00A0');
    var $author$project$Utils$Html$noBreakSpace = $elm$html$Html$text($author$project$Utils$String$noBreakSpace);
    var $author$project$Api$Phi$phiSafe = function(content) {
        return A2($elm$html$Html$span, $author$project$Api$Phi$displayAttr, content);
    };
    var $author$project$Api$Phi$text = function(_v0) {
        var string = _v0;
        return $author$project$Api$Phi$phiSafe(_List_fromArray([
            $elm$html$Html$text(string)
        ]));
    };
    var $author$project$Ui$Form$Group$viewLabel = function(options) {
        var _v0 = options.aeI;
        if (!_v0.$) {
            var label_ = _v0.a;
            var labelHtml_ = function() {
                switch(label_.$){
                    case 0:
                        var html = label_.a;
                        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), html);
                    case 1:
                        var lab = label_.a;
                        return _List_fromArray([
                            $elm$html$Html$text(lab)
                        ]);
                    default:
                        var lab = label_.a;
                        return _List_fromArray([
                            $author$project$Api$Phi$text(lab)
                        ]);
                }
            }();
            var iconHtml = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(icon_) {
                return _List_fromArray([
                    icon_
                ]);
            }, options.QZ));
            return A2($author$project$Ui$Typography$label, _List_fromArray([
                $author$project$Ui$Typography$attrs(_List_fromArray([
                    $elm$html$Html$Attributes$class(options.yz),
                    $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', options.mQ)),
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('label-required', options.agM)
                    ]))
                ]))
            ]), _Utils_ap(iconHtml, _Utils_ap(labelHtml_, _List_fromArray([
                options.agM ? A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('form-group__required')
                ]), _List_fromArray([
                    $elm$html$Html$text('*')
                ])) : $elm$html$Html$text(''),
                A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm$html$Html$div(_List_fromArray([
                    $elm$html$Html$Attributes$class('form-group__help')
                ]))), options.yA)),
                options.mR ? $author$project$Utils$Html$noBreakSpace : $author$project$Utils$Html$empty
            ]))));
        } else return $elm$html$Html$text('');
    };
    var $elm$html$Html$legend = _VirtualDom_node('legend');
    var $author$project$Ui$Form$Group$viewLegend = function(options) {
        var _v0 = options.aeI;
        if (!_v0.$ && _v0.a.$ === 1) {
            var label_ = _v0.a.a;
            return A2($elm$html$Html$legend, _List_fromArray([
                $elm$html$Html$Attributes$class('sr-only')
            ]), _List_fromArray([
                $elm$html$Html$text(label_)
            ]));
        } else return $elm$html$Html$text('');
    };
    var $author$project$Ui$Form$Group$view = F2(function(options, content) {
        var optionsRecord = $author$project$Ui$Form$Group$optionsToRecord(options);
        return A2($elm$html$Html$fieldset, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-group'), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), optionsRecord.vD)), _List_fromArray([
            $author$project$Ui$Form$Group$viewLegend(optionsRecord),
            !optionsRecord.mR ? $author$project$Ui$Form$Group$viewLabel(optionsRecord) : $author$project$Utils$Html$empty,
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('form-group__content'),
                $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', optionsRecord.mz))
            ]), A2($elm$core$List$cons, optionsRecord.mR ? $author$project$Ui$Form$Group$viewLabel(optionsRecord) : $author$project$Utils$Html$empty, content))
        ]));
    });
    var $author$project$Ui$Form$Input$inputTypeToAttributes = function(type_) {
        switch(type_.$){
            case 0:
                return _List_fromArray([
                    $elm$html$Html$Attributes$type_('tel')
                ]);
            case 1:
                return _List_fromArray([
                    $elm$html$Html$Attributes$type_('text')
                ]);
            case 2:
                return _List_fromArray([
                    $elm$html$Html$Attributes$type_('text'),
                    A2($elm$html$Html$Attributes$attribute, 'inputmode', 'decimal')
                ]);
            case 3:
                return _List_fromArray([
                    $elm$html$Html$Attributes$type_('url')
                ]);
            case 4:
                return _List_fromArray([
                    $elm$html$Html$Attributes$type_('email')
                ]);
            case 5:
                return _List_fromArray([
                    $elm$html$Html$Attributes$type_('password')
                ]);
            default:
                var otherType = type_.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$type_(otherType)
                ]);
        }
    };
    var $elm$html$Html$Events$alwaysStop = function(x) {
        return _Utils_Tuple2(x, true);
    };
    var $elm$virtual_dom$VirtualDom$MayStopPropagation = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$html$Html$Events$stopPropagationOn = F2(function(event, decoder) {
        return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
    });
    var $elm$html$Html$Events$targetValue = A2($elm$json$Json$Decode$at, _List_fromArray([
        'target',
        'value'
    ]), $elm$json$Json$Decode$string);
    var $elm$html$Html$Events$onInput = function(tagger) {
        return A2($elm$html$Html$Events$stopPropagationOn, 'input', A2($elm$json$Json$Decode$map, $elm$html$Html$Events$alwaysStop, A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
    };
    var $author$project$Ui$Form$Input$onNumberInput = F2(function(prevValue, tagger) {
        return A2($elm$html$Html$Events$on, 'input', A2($elm$json$Json$Decode$map, function(val) {
            var _v0 = _Utils_Tuple2(val, $elm$core$String$toFloat(val));
            switch(_v0.a){
                case '':
                    return tagger(val);
                case '-':
                    return tagger(val);
                default:
                    if (!_v0.b.$) return tagger(val);
                    else return tagger(prevValue);
            }
        }, A2($elm$json$Json$Decode$at, _List_fromArray([
            'target',
            'value'
        ]), $elm$json$Json$Decode$string)));
    });
    var $author$project$Ui$Form$Input$optionsToInputHandler = function(optionsRecord) {
        var _v0 = _Utils_Tuple2(optionsRecord.afE, optionsRecord.ah5);
        if (_v0.a.$ === 1) {
            var _v1 = _v0.a;
            return _List_Nil;
        } else if (_v0.b.$ === 2) {
            var handler = _v0.a.a;
            var _v2 = _v0.b;
            return _List_fromArray([
                A2($author$project$Ui$Form$Input$onNumberInput, optionsRecord.aa9, handler)
            ]);
        } else {
            var handler = _v0.a.a;
            return _List_fromArray([
                $elm$html$Html$Events$onInput(handler)
            ]);
        }
    };
    var $elm$html$Html$Attributes$autocomplete = function(bool) {
        return A2($elm$html$Html$Attributes$stringProperty, 'autocomplete', bool ? 'on' : 'off');
    };
    var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
    var $author$project$Ui$Form$Input$Text = {
        $: 1
    };
    var $author$project$Ui$Form$Input$defaultOptions = {
        vD: _List_Nil,
        fK: _List_Nil,
        xU: false,
        xW: false,
        q2: false,
        afE: $elm$core$Maybe$Nothing,
        ah5: $author$project$Ui$Form$Input$Text,
        aa9: '',
        D3: _List_Nil,
        tI: _List_Nil
    };
    var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
    var $author$project$Api$Phi$inputAttr = _List_fromArray([
        $author$project$Api$Phi$maskElement,
        A2($elm$html$Html$Attributes$attribute, 'data-recording-ignore', 'mask')
    ]);
    var $agustinrhcp$elm_mask$Mask$maskRec = F2(function(input, pattern) {
        var _v0 = _Utils_Tuple2(input, pattern);
        if (!_v0.b.b) return '';
        else if (_v0.a.b) {
            var _v1 = _v0.a;
            var _char = _v1.a;
            var remainingChar = _v1.b;
            var _v2 = _v0.b;
            var token = _v2.a;
            var remainingTokens = _v2.b;
            switch(token.$){
                case 2:
                    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(_int) {
                        return _Utils_ap($elm$core$String$fromInt(_int), A2($agustinrhcp$elm_mask$Mask$maskRec, remainingChar, remainingTokens));
                    }, $elm$core$String$toInt($elm$core$String$fromChar(_char))));
                case 1:
                    return _Utils_ap($elm$core$String$fromChar(_char), A2($agustinrhcp$elm_mask$Mask$maskRec, remainingChar, remainingTokens));
                default:
                    var a = token.a;
                    return _Utils_ap($elm$core$String$fromChar(a), A2($agustinrhcp$elm_mask$Mask$maskRec, input, remainingTokens));
            }
        } else {
            var _v4 = _v0.b;
            var token = _v4.a;
            var remainingTokens = _v4.b;
            if (!token.$) {
                var symbol = token.a;
                return _Utils_ap($elm$core$String$fromChar(symbol), A2($agustinrhcp$elm_mask$Mask$maskRec, input, remainingTokens));
            } else return '';
        }
    });
    var $agustinrhcp$elm_mask$Mask$mask = F2(function(_v0, stringInput) {
        var pattern = _v0;
        return $elm$core$String$isEmpty(stringInput) ? '' : A2($agustinrhcp$elm_mask$Mask$maskRec, $elm$core$String$toList(stringInput), pattern);
    });
    var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
    var $agustinrhcp$elm_mask$Mask$maskedValue = F2(function(pattern, val) {
        return $elm$core$String$isEmpty(val) ? $elm$html$Html$Attributes$value('') : $elm$html$Html$Attributes$value(A2($agustinrhcp$elm_mask$Mask$mask, pattern, val));
    });
    var $elm$html$Html$Attributes$maxlength = function(n) {
        return A2(_VirtualDom_attribute, 'maxlength', $elm$core$String$fromInt(n));
    };
    var $elm$html$Html$Events$onBlur = function(msg) {
        return A2($elm$html$Html$Events$on, 'blur', $elm$json$Json$Decode$succeed(msg));
    };
    var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
    var $author$project$Utils$Dom$onKeyDown = function(msg) {
        return A2($elm$html$Html$Events$on, 'keydown', A2($elm$json$Json$Decode$map, msg, $elm$html$Html$Events$keyCode));
    };
    var $agustinrhcp$elm_mask$Mask$unMaskRec = F2(function(input, pattern) {
        unMaskRec: while(true){
            var _v0 = _Utils_Tuple2(input, pattern);
            _v0$1: while(true)if (_v0.a.b) {
                if (_v0.b.b) {
                    var _v1 = _v0.a;
                    var _char = _v1.a;
                    var remainingChar = _v1.b;
                    var _v2 = _v0.b;
                    var token = _v2.a;
                    var remainingTokens = _v2.b;
                    switch(token.$){
                        case 2:
                            return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(_int) {
                                return _Utils_ap($elm$core$String$fromInt(_int), A2($agustinrhcp$elm_mask$Mask$unMaskRec, remainingChar, remainingTokens));
                            }, $elm$core$String$toInt($elm$core$String$fromChar(_char))));
                        case 1:
                            return _Utils_ap($elm$core$String$fromChar(_char), A2($agustinrhcp$elm_mask$Mask$unMaskRec, remainingChar, remainingTokens));
                        default:
                            var symbol = token.a;
                            if (_Utils_eq(symbol, _char)) {
                                var $temp$input = remainingChar, $temp$pattern = remainingTokens;
                                input = $temp$input;
                                pattern = $temp$pattern;
                                continue unMaskRec;
                            } else return '';
                    }
                } else break _v0$1;
            } else {
                if (!_v0.b.b) break _v0$1;
                else return '';
            }
            return '';
        }
    });
    var $agustinrhcp$elm_mask$Mask$unMask = F2(function(_v0, string) {
        var pattern = _v0;
        return $elm$core$String$isEmpty(string) ? '' : A2($agustinrhcp$elm_mask$Mask$unMaskRec, $elm$core$String$toList(string), pattern);
    });
    var $agustinrhcp$elm_mask$Mask$isMasked = F2(function(pattern, text) {
        return _Utils_eq(text, A2($agustinrhcp$elm_mask$Mask$mask, pattern, A2($agustinrhcp$elm_mask$Mask$unMask, pattern, text)));
    });
    var $agustinrhcp$elm_mask$Mask$unMaskValue = F3(function(pattern, currentValue, maskedNewValue) {
        if ($elm$core$String$isEmpty(maskedNewValue)) return '';
        else {
            if ($elm$core$String$isEmpty(currentValue)) return A2($agustinrhcp$elm_mask$Mask$isMasked, pattern, maskedNewValue) ? A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue) : A2($agustinrhcp$elm_mask$Mask$unMask, pattern, A2($agustinrhcp$elm_mask$Mask$mask, pattern, maskedNewValue));
            else {
                if (_Utils_cmp(A2($agustinrhcp$elm_mask$Mask$mask, pattern, currentValue), maskedNewValue) > 0) {
                    var unmaskedNewValue = A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue);
                    return _Utils_cmp(currentValue, unmaskedNewValue) > 0 ? unmaskedNewValue : A2($elm$core$String$dropRight, 1, currentValue);
                } else return A2($agustinrhcp$elm_mask$Mask$unMask, pattern, maskedNewValue);
            }
        }
    });
    var $agustinrhcp$elm_mask$Mask$onMaskedInput = F3(function(pattern, currentValue, msg) {
        return $elm$html$Html$Events$onInput(A2($elm$core$Basics$composeR, A2($agustinrhcp$elm_mask$Mask$unMaskValue, pattern, currentValue), msg));
    });
    var $author$project$Ui$Form$Input$onOff = function(bool) {
        return bool ? 'on' : 'off';
    };
    var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
    var $author$project$Ui$Form$Input$trueFalse = function(bool) {
        return bool ? 'true' : 'false';
    };
    var $author$project$Ui$Form$Input$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$id(string), record.vD)
                    });
                case 1:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$placeholder(string), record.vD)
                    });
                case 2:
                    var handler = option.a;
                    return _Utils_update(record, {
                        afE: $elm$core$Maybe$Just(handler)
                    });
                case 3:
                    var string = option.a;
                    return _Utils_update(record, {
                        aa9: string
                    });
                case 4:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(bool), record.vD)
                    });
                case 5:
                    var string = option.a;
                    return _Utils_update(record, {
                        ah5: string
                    });
                case 7:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('feedback-errored', bool)
                        ])), record.vD),
                        q2: bool
                    });
                case 8:
                    var bool = option.a;
                    var phiAttrs = bool ? $author$project$Api$Phi$inputAttr : _List_Nil;
                    return _Utils_update(record, {
                        vD: _Utils_ap(phiAttrs, record.vD)
                    });
                case 9:
                    var pattern = option.a;
                    var string = option.b;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($agustinrhcp$elm_mask$Mask$maskedValue, pattern, string), record.vD)
                    });
                case 10:
                    var pattern = option.a;
                    var lastValue = option.b;
                    var handler = option.c;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A3($agustinrhcp$elm_mask$Mask$onMaskedInput, pattern, lastValue, handler), record.vD)
                    });
                case 11:
                    var handler = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Events$onBlur(handler), record.vD)
                    });
                case 12:
                    var handler = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Events$onClick(handler), record.vD)
                    });
                case 13:
                    var handler = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Utils$Dom$onKeyDown(handler), record.vD)
                    });
                case 14:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$autocomplete(bool), record.vD)
                    });
                case 15:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'autocorrect', $author$project$Ui$Form$Input$onOff(bool)), record.vD)
                    });
                case 16:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'autocapitalize', $author$project$Ui$Form$Input$onOff(bool)), record.vD)
                    });
                case 17:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'spellcheck', $author$project$Ui$Form$Input$trueFalse(bool)), record.vD)
                    });
                case 20:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$autofocus(bool), record.vD)
                    });
                case 18:
                    var bool = option.a;
                    return _Utils_update(record, {
                        xU: bool,
                        tI: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('has-feedback', bool)
                        ])), record.tI)
                    });
                case 19:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
                case 21:
                    var _int = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$maxlength(_int), record.vD)
                    });
                case 6:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Utils$Html$Attributes$test(string), record.vD)
                    });
                case 22:
                    var html = option.a;
                    return _Utils_update(record, {
                        D3: html
                    });
                case 23:
                    var attributes = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$append, record.vD, attributes)
                    });
                case 24:
                    var labelled = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-label', labelled), record.vD)
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        xW: bool
                    });
            }
        }), $author$project$Ui$Form$Input$defaultOptions, options);
    };
    var $author$project$Utils$FormErrors$viewError = function(error) {
        return A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('text-danger')
        ]), _List_fromArray([
            $elm$html$Html$text(error)
        ]));
    };
    var $author$project$Utils$FormErrors$view = function(errorList) {
        return $elm$core$List$isEmpty(errorList) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Utils$FormErrors$viewError, errorList));
    };
    var $author$project$Ui$Form$Input$viewErrors = function(option) {
        if (option.$ === 19) {
            var errors_ = option.a;
            return $author$project$Utils$FormErrors$view(errors_);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Icon$Check = 45;
    var $author$project$Ui$Icon$check = $author$project$Ui$Icon$viewIcon(45);
    var $author$project$Ui$Icon$Danger = 0;
    var $author$project$Ui$Icon$IconColor = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Icon$danger = $author$project$Ui$Icon$IconColor(0);
    var $author$project$Ui$Icon$Success = 3;
    var $author$project$Ui$Icon$success = $author$project$Ui$Icon$IconColor(3);
    var $author$project$Ui$Form$Input$viewFeedback = function(options) {
        var _v0 = _Utils_Tuple2(options.xU, options.q2);
        if (_v0.a) {
            if (_v0.b) return A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('has-error form-control__feedback')
            ]), _List_fromArray([
                $author$project$Ui$Icon$cross(_List_fromArray([
                    $author$project$Ui$Icon$danger
                ]))
            ]));
            else return A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('text-muted form-control__feedback')
            ]), _List_fromArray([
                $author$project$Ui$Icon$check(_List_fromArray([
                    $author$project$Ui$Icon$success
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Form$Input$view = function(options) {
        var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
        var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
        var errorDescription = $elm$core$List$isEmpty(optionsRecord.fK) ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-describedby', A2($elm$core$String$join, '. ', optionsRecord.fK))
        ]);
        return A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('input-wrapper'), optionsRecord.tI), $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Ui$Form$Input$viewFeedback(optionsRecord),
                A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-control'), A2($elm$core$List$cons, $elm$html$Html$Attributes$value(optionsRecord.aa9), _Utils_ap($author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.ah5), _Utils_ap(errorDescription, _Utils_ap(optionsRecord.vD, onInputHandler))))), _List_Nil)
            ]),
            optionsRecord.D3,
            optionsRecord.xW ? _List_Nil : A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
        ])));
    };
    var $author$project$Ui$Form$Textarea$disableGrammarly = _List_fromArray([
        A2($elm$html$Html$Attributes$attribute, 'data-gramm_editor', 'false'),
        A2($elm$html$Html$Attributes$attribute, 'data-gramm', 'false'),
        A2($elm$html$Html$Attributes$attribute, 'data-enable-grammarly', 'false')
    ]);
    var $author$project$Ui$Form$Textarea$defaultOptions = {
        vD: $author$project$Ui$Form$Textarea$disableGrammarly,
        fK: _List_Nil,
        xW: false,
        q2: false,
        tI: _List_Nil
    };
    var $elm$html$Html$Attributes$rows = function(n) {
        return A2(_VirtualDom_attribute, 'rows', $elm$core$String$fromInt(n));
    };
    var $author$project$Ui$Form$Textarea$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$id(string), record.vD)
                    });
                case 1:
                    var _int = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$rows(_int), record.vD)
                    });
                case 2:
                    var handler = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Events$onInput(handler), record.vD)
                    });
                case 3:
                    var handler = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Events$onBlur(handler), record.vD)
                    });
                case 4:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$value(string), record.vD)
                    });
                case 5:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('feedback-errored', bool)
                        ])), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-invalid', bool ? 'true' : 'false'), record.vD)),
                        q2: bool
                    });
                case 6:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
                case 7:
                    var bool = option.a;
                    var phiAttrs = bool ? $author$project$Api$Phi$inputAttr : _List_Nil;
                    return _Utils_update(record, {
                        vD: _Utils_ap(phiAttrs, record.vD)
                    });
                case 8:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$placeholder(string), record.vD)
                    });
                case 9:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(bool), A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('disabled', bool)
                        ])), record.vD))
                    });
                case 10:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Utils$Html$Attributes$test(string), record.vD)
                    });
                case 11:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$style, 'min-height', string), record.vD)
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        xW: bool
                    });
            }
        }), $author$project$Ui$Form$Textarea$defaultOptions, options);
    };
    var $elm$html$Html$textarea = _VirtualDom_node('textarea');
    var $author$project$Ui$Form$Textarea$viewErrors = function(option) {
        if (option.$ === 6) {
            var errors_ = option.a;
            return $author$project$Utils$FormErrors$view(errors_);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Form$Textarea$view = function(options) {
        var optionsRecord = $author$project$Ui$Form$Textarea$optionsToRecord(options);
        var errorDescription = $elm$core$List$isEmpty(optionsRecord.fK) ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-describedby', A2($elm$core$String$join, '. ', optionsRecord.fK))
        ]);
        return A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('input-wrapper'), optionsRecord.tI), $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($elm$html$Html$textarea, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-control'), _Utils_ap(errorDescription, optionsRecord.vD)), _List_Nil)
            ]),
            optionsRecord.xW ? _List_Nil : A2($elm$core$List$map, $author$project$Ui$Form$Textarea$viewErrors, options)
        ])));
    };
    var $author$project$Ui$Well$optionToAttrs = function(option) {
        switch(option.$){
            case 0:
                var size = option.a;
                switch(size){
                    case 0:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('well-xs')
                        ]);
                    case 1:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('well-sm'),
                            $elm$html$Html$Attributes$class('max-w-sm')
                        ]);
                    case 2:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('well')
                        ]);
                    default:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('well-lg')
                        ]);
                }
            case 1:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('signin')
                ]);
            case 2:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('clearfix')
                ]);
            case 3:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('border-0')
                ]);
            default:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('w-full')
                ]);
        }
    };
    var $author$project$Ui$Well$view = F2(function(options, content) {
        return A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('well'), A2($elm$core$List$concatMap, $author$project$Ui$Well$optionToAttrs, options)), content);
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$LanguageSelected = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Ui$Link$ExternalHref = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Link$externalHref = F3(function(externalHref_, options, content) {
        return A2($author$project$Ui$Link$view, A2($elm$core$List$cons, $author$project$Ui$Link$ExternalHref(externalHref_), options), content);
    });
    var $author$project$Ui$Alert$Info = 1;
    var $author$project$Ui$Alert$info = $author$project$Ui$Alert$view(1);
    var $author$project$Ui$Form$Group$InputGrid = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$spanToWidthClass = function(span) {
        return span === 12 ? 'w-full' : 'w-' + ($elm$core$String$fromInt(span) + '/12');
    };
    var $author$project$Ui$Form$Group$inputSpan = function(span) {
        return $author$project$Ui$Form$Group$InputGrid(_List_fromArray([
            $author$project$Ui$Form$Group$spanToWidthClass(span)
        ]));
    };
    var $author$project$Ui$Dropdown$Item = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Dropdown$item = $author$project$Ui$Dropdown$Item;
    var $author$project$Ui$Form$Group$Label = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$Plain = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$label = A2($elm$core$Basics$composeR, $author$project$Ui$Form$Group$Plain, $author$project$Ui$Form$Group$Label);
    var $author$project$Ui$Form$Group$LabelGrid = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$labelSpan = function(span) {
        return $author$project$Ui$Form$Group$LabelGrid(_List_fromArray([
            $author$project$Ui$Form$Group$spanToWidthClass(span)
        ]));
    };
    var $author$project$Ui$Element$mt2 = $author$project$Ui$Element$Margin('mt-2');
    var $author$project$Ui$Dropdown$Item$OnSelect = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$onSelect = $author$project$Ui$Dropdown$Item$OnSelect;
    var $author$project$Ui$Dropdown$Item$Selected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$selected = $author$project$Ui$Dropdown$Item$Selected;
    var $author$project$Language$spanish = 1;
    var $author$project$Ui$Link$TargetBlank = {
        $: 6
    };
    var $author$project$Ui$Link$targetBlank = $author$project$Ui$Link$TargetBlank;
    var $author$project$Language$toLabel = function(lang) {
        if (!lang) return 'English';
        else return 'Spanish';
    };
    var $author$project$Ui$Dropdown$DropdownButtonClicked = {
        $: 0
    };
    var $author$project$Ui$Icon$Info = 2;
    var $author$project$Ui$Icon$info = $author$project$Ui$Icon$IconColor(2);
    var $author$project$Ui$Dropdown$optionsToRecord = A2($elm$core$List$foldl, F2(function(option, record) {
        switch(option.$){
            case 0:
                switch(option.a){
                    case 0:
                        var _v1 = option.a;
                        return _Utils_update(record, {
                            lm: _List_fromArray([
                                'button button--secondary'
                            ])
                        });
                    case 2:
                        var _v2 = option.a;
                        return _Utils_update(record, {
                            lm: _List_fromArray([
                                'button button--warning'
                            ])
                        });
                    default:
                        var _v3 = option.a;
                        return _Utils_update(record, {
                            lm: _List_fromArray([
                                'button button--link'
                            ])
                        });
                }
            case 1:
                var _v4 = option.a;
                return _Utils_update(record, {
                    vS: _List_fromArray([
                        'button--sm'
                    ])
                });
            case 2:
                var isInvalid = option.a;
                return _Utils_update(record, {
                    q2: isInvalid
                });
            case 3:
                var isDisabled = option.a;
                return _Utils_update(record, {
                    d$: isDisabled
                });
            case 4:
                var isReadonly = option.a;
                return _Utils_update(record, {
                    sq: isReadonly
                });
            case 5:
                var errorList = option.a;
                return _Utils_update(record, {
                    fK: errorList
                });
            case 6:
                var label = option.a;
                return _Utils_update(record, {
                    abP: label
                });
            case 7:
                var placeholder_ = option.a;
                return _Utils_update(record, {
                    we: placeholder_
                });
            default:
                var isLoading = option.a;
                return _Utils_update(record, {
                    Tk: isLoading
                });
        }
    }), {
        abP: '',
        lm: _List_fromArray([
            'button button--default'
        ]),
        vS: _List_Nil,
        we: '',
        d$: false,
        fK: _List_Nil,
        q2: false,
        Tk: false,
        sq: false
    });
    var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
    var $author$project$Ui$Dropdown$ArrowPressed = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$Down = 1;
    var $author$project$Ui$Dropdown$EnterPressed = {
        $: 13
    };
    var $author$project$Ui$Dropdown$Right = 2;
    var $author$project$Ui$Dropdown$Up = 0;
    var $elm$virtual_dom$VirtualDom$Custom = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $elm$html$Html$Events$custom = F2(function(event, decoder) {
        return A2($elm$virtual_dom$VirtualDom$on, event, $elm$virtual_dom$VirtualDom$Custom(decoder));
    });
    var $author$project$Ui$Dropdown$triggerKeyHandlers = function(toMsg) {
        return A2($elm$html$Html$Events$custom, 'keydown', A2($elm$json$Json$Decode$map, function(msg_) {
            return {
                ae1: msg_,
                Bq: true,
                CJ: true
            };
        }, A2($elm$json$Json$Decode$andThen, function(key) {
            switch(key){
                case ' ':
                    return $elm$json$Json$Decode$succeed(toMsg($author$project$Ui$Dropdown$DropdownButtonClicked));
                case 'Enter':
                    return $elm$json$Json$Decode$succeed(toMsg($author$project$Ui$Dropdown$EnterPressed));
                case 'ArrowDown':
                    return $elm$json$Json$Decode$succeed(toMsg($author$project$Ui$Dropdown$ArrowPressed(1)));
                case 'ArrowUp':
                    return $elm$json$Json$Decode$succeed(toMsg($author$project$Ui$Dropdown$ArrowPressed(0)));
                case 'ArrowRight':
                    return $elm$json$Json$Decode$succeed(toMsg($author$project$Ui$Dropdown$ArrowPressed(2)));
                default:
                    return $elm$json$Json$Decode$fail('ignore');
            }
        }, A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
    };
    var $author$project$Ui$Dropdown$ArrowNavigation = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$Item$Checkbox = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Dropdown$FocusInput = {
        $: 10
    };
    var $author$project$Ui$Dropdown$FocusLink = {
        $: 11
    };
    var $author$project$Ui$Dropdown$Item$InnerDropdown = F4(function(a, b, c, d) {
        return {
            $: 5,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Ui$Dropdown$InnerDropdownButtonClicked = {
        $: 3
    };
    var $author$project$Ui$Dropdown$Item$Input = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$Item$Item = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Dropdown$Item$Link = F3(function(a, b, c) {
        return {
            $: 6,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Dropdown$Item$OnArrowRight = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$Item$Radio = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Dropdown$Item$Separator = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$ItemEnterPressed = {
        $: 14
    };
    var $author$project$Ui$Dropdown$ItemSelected = {
        $: 8
    };
    var $author$project$Ui$Dropdown$Left = 3;
    var $author$project$Ui$Dropdown$defaultItemOptions = function(toMsg) {
        return {
            vD: _List_Nil,
            hO: false,
            QZ: $elm$core$Maybe$Nothing,
            aer: $elm$core$Maybe$Nothing,
            Vk: _List_fromArray([
                _Utils_Tuple2('ArrowDown', toMsg($author$project$Ui$Dropdown$ArrowNavigation(1))),
                _Utils_Tuple2('ArrowUp', toMsg($author$project$Ui$Dropdown$ArrowNavigation(0))),
                _Utils_Tuple2('ArrowLeft', toMsg($author$project$Ui$Dropdown$ArrowNavigation(3))),
                _Utils_Tuple2('ArrowRight', toMsg($author$project$Ui$Dropdown$ArrowNavigation(2)))
            ]),
            afw: $elm$core$Basics$always(toMsg($author$project$Ui$Dropdown$NoOp)),
            zU: toMsg($author$project$Ui$Dropdown$NoOp),
            afB: toMsg($author$project$Ui$Dropdown$NoOp),
            afC: toMsg($author$project$Ui$Dropdown$ItemEnterPressed),
            afD: toMsg($author$project$Ui$Dropdown$NoOp),
            afE: $elm$core$Basics$always(toMsg($author$project$Ui$Dropdown$NoOp)),
            afJ: toMsg($author$project$Ui$Dropdown$ItemSelected),
            afN: false,
            ah: false,
            aa9: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Ui$Dropdown$Item$OnEnter = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$onEnter = $author$project$Ui$Dropdown$Item$OnEnter;
    var $author$project$Ui$Dropdown$Item$OnFocus = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$onFocus = $author$project$Ui$Dropdown$Item$OnFocus;
    var $author$project$Ui$Margin$Left_2 = 12;
    var $author$project$Ui$Dropdown$Item$optionsToRecord = F2(function(defaultOptions, options) {
        return A3($elm$core$List$foldl, F2(function(option_, record) {
            switch(option_.$){
                case 0:
                    var msg = option_.a;
                    return _Utils_update(record, {
                        zU: msg
                    });
                case 1:
                    var msg = option_.a;
                    return _Utils_update(record, {
                        afD: msg
                    });
                case 2:
                    var bool = option_.a;
                    return _Utils_update(record, {
                        ah: bool
                    });
                case 3:
                    var msg = option_.a;
                    return _Utils_update(record, {
                        afE: msg
                    });
                case 4:
                    var string = option_.a;
                    return _Utils_update(record, {
                        aa9: $elm$core$Maybe$Just(string)
                    });
                case 5:
                    var checked = option_.a;
                    return _Utils_update(record, {
                        hO: checked
                    });
                case 6:
                    var msg = option_.a;
                    return _Utils_update(record, {
                        afw: msg
                    });
                case 7:
                    var msg = option_.a;
                    return _Utils_update(record, {
                        afB: msg
                    });
                case 8:
                    var placeholder = option_.a;
                    return _Utils_update(record, {
                        aer: $elm$core$Maybe$Just(placeholder)
                    });
                case 9:
                    var msg = option_.a;
                    return _Utils_update(record, {
                        Vk: A2($elm$core$List$map, function(_v1) {
                            var key = _v1.a;
                            var handler = _v1.b;
                            if (key === 'ArrowRight') return _Utils_Tuple2('ArrowRight', msg);
                            else return _Utils_Tuple2(key, handler);
                        }, record.Vk)
                    });
                case 10:
                    return _Utils_update(record, {
                        afN: true
                    });
                case 11:
                    return _Utils_update(record, {
                        vD: _Utils_ap(record.vD, _List_fromArray([
                            $elm$html$Html$Attributes$class('lg:hidden')
                        ]))
                    });
                case 12:
                    var iconFunc = option_.a;
                    return _Utils_update(record, {
                        QZ: $elm$core$Maybe$Just(iconFunc)
                    });
                default:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $author$project$Ui$Margin$toClass(12), record.vD)
                    });
            }
        }), defaultOptions, options);
    });
    var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
    var $elm$html$Html$Events$targetChecked = A2($elm$json$Json$Decode$at, _List_fromArray([
        'target',
        'checked'
    ]), $elm$json$Json$Decode$bool);
    var $elm$html$Html$Events$onCheck = function(tagger) {
        return A2($elm$html$Html$Events$on, 'change', A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
    };
    var $elm$html$Html$Events$onFocus = function(msg) {
        return A2($elm$html$Html$Events$on, 'focus', $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Ui$Dropdown$Item$onKeyDown = function(handlers) {
        return A2($elm$html$Html$Events$custom, 'keydown', A2($elm$json$Json$Decode$map, function(msg) {
            return {
                ae1: msg,
                Bq: true,
                CJ: true
            };
        }, A2($elm$json$Json$Decode$andThen, function(key) {
            var _v0 = A2($elm$core$List$filter, function(_v1) {
                var k = _v1.a;
                return _Utils_eq(k, key);
            }, handlers);
            if (_v0.b && !_v0.b.b) {
                var _v2 = _v0.a;
                var msg = _v2.b;
                return $elm$json$Json$Decode$succeed(msg);
            } else return $elm$json$Json$Decode$fail('ignore');
        }, A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string))));
    };
    var $author$project$Ui$Dropdown$Item$onMouse = F2(function(event, msg) {
        return A2($elm$html$Html$Events$custom, event, $elm$json$Json$Decode$succeed({
            ae1: msg,
            Bq: true,
            CJ: true
        }));
    });
    var $author$project$Ui$Dropdown$Item$viewCheckbox = F2(function(options, content) {
        return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'option'), A2($elm$core$List$cons, $elm$html$Html$Events$onFocus(options.afD), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item--focusable'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item--checkbox'), A2($elm$core$List$cons, $elm$html$Html$Attributes$tabindex(-1), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), options.vD))))))), _List_fromArray([
            A2($elm$html$Html$label, _List_fromArray([
                A2($author$project$Ui$Dropdown$Item$onMouse, 'mousedown', options.afD)
            ]), _List_fromArray([
                A2($elm$html$Html$input, _List_fromArray([
                    $elm$html$Html$Attributes$type_('checkbox'),
                    $author$project$Ui$Dropdown$Item$onKeyDown(A2($elm$core$List$cons, _Utils_Tuple2('Enter', options.afw(!options.hO)), options.Vk)),
                    $elm$html$Html$Attributes$tabindex(-1),
                    $elm$html$Html$Events$onCheck(options.afw),
                    $elm$html$Html$Attributes$checked(options.hO)
                ]), _List_Nil),
                content
            ]))
        ]));
    });
    var $author$project$Ui$Dropdown$Item$viewInnerDropdown = F4(function(dropdownId, open, options, content) {
        return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item--focusable'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item--inner'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'option'), A2($elm$core$List$cons, $elm$html$Html$Attributes$tabindex(-1), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown'), A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
            _Utils_Tuple2('new-dropdown--open', open)
        ])), A2($elm$core$List$cons, $elm$html$Html$Attributes$id(dropdownId), A2($elm$core$List$cons, $author$project$Ui$Dropdown$Item$onKeyDown(A2($elm$core$List$cons, _Utils_Tuple2('Enter', options.afB), options.Vk)), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), options.vD)))))))))), content);
    });
    var $author$project$Ui$Dropdown$Item$decodePressedKey = F2(function(expectedKey, toMsg) {
        return A2($elm$json$Json$Decode$andThen, function(key) {
            return _Utils_eq(key, expectedKey) ? $elm$json$Json$Decode$succeed(toMsg) : $elm$json$Json$Decode$fail('ignore');
        }, A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
    });
    var $author$project$Ui$Dropdown$Item$onEnter = F2(function(event, msg) {
        return A2($elm$html$Html$Events$custom, event, A2($elm$json$Json$Decode$map, function(msg_) {
            return {
                ae1: msg_,
                Bq: true,
                CJ: true
            };
        }, A2($author$project$Ui$Dropdown$Item$decodePressedKey, 'Enter', msg)));
    });
    var $author$project$Ui$Dropdown$Item$viewInput = function(options) {
        return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item new-dropdown-menu__item--focusable'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item--input'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'option'), A2($elm$core$List$cons, $elm$html$Html$Events$onFocus(options.afD), A2($elm$core$List$cons, $elm$html$Html$Attributes$tabindex(-1), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), options.vD)))))), _List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function(icon_) {
                return icon_(_List_fromArray([
                    $author$project$Ui$Icon$info
                ]));
            }, options.QZ)),
            A2($elm$html$Html$input, _List_fromArray([
                $elm$html$Html$Attributes$type_('text'),
                $author$project$Ui$Dropdown$Item$onKeyDown(A2($elm$core$List$cons, _Utils_Tuple2('Enter', options.afB), options.Vk)),
                $elm$html$Html$Events$onInput(options.afE),
                function() {
                    var _v0 = options.aer;
                    if (!_v0.$) {
                        var placeholder = _v0.a;
                        return $elm$html$Html$Attributes$placeholder(placeholder);
                    } else return $elm$html$Html$Attributes$class('');
                }(),
                $elm$html$Html$Attributes$autocomplete(false),
                $elm$html$Html$Attributes$tabindex(-1),
                A2($elm$core$Maybe$withDefault, $elm$html$Html$Attributes$class(''), A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, options.aa9)),
                $elm$html$Html$Attributes$class('form-control'),
                options.afN ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$Dropdown$Item$onEnter, 'keyup', options.afC)
            ]), _List_Nil)
        ]));
    };
    var $author$project$Ui$Dropdown$Item$viewItem = F2(function(options, content) {
        return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
            _Utils_Tuple2('new-dropdown-menu__item', true),
            _Utils_Tuple2('new-dropdown-menu__item--active', options.ah),
            _Utils_Tuple2('new-dropdown-menu__item--focusable', true)
        ])), A2($elm$core$List$cons, $elm$html$Html$Events$onClick(options.zU), A2($elm$core$List$cons, options.afN ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$Dropdown$Item$onMouse, 'mouseup', options.afJ), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'option'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'designMode', 'true'), A2($elm$core$List$cons, options.afN ? $elm$html$Html$Attributes$class('') : A2($author$project$Ui$Dropdown$Item$onEnter, 'keyup', options.afC), A2($elm$core$List$cons, $author$project$Ui$Dropdown$Item$onKeyDown(options.Vk), A2($elm$core$List$cons, $elm$html$Html$Attributes$tabindex(-1), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), options.vD))))))))), _List_fromArray([
            content
        ]));
    });
    var $author$project$Ui$Dropdown$Item$viewLink = F3(function(href, options, content) {
        return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
            _Utils_Tuple2('new-dropdown-menu__item', true),
            _Utils_Tuple2('new-dropdown-menu__item--active', options.ah),
            _Utils_Tuple2('new-dropdown-menu__item--focusable', true),
            _Utils_Tuple2('new-dropdown-menu__item--link', true)
        ])), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'option'), A2($elm$core$List$cons, $elm$html$Html$Events$onFocus(options.afD), A2($elm$core$List$cons, $elm$html$Html$Attributes$tabindex(-1), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), options.vD))))), _List_fromArray([
            A2($elm$html$Html$a, _List_fromArray([
                $elm$html$Html$Attributes$tabindex(-1),
                $elm$html$Html$Attributes$href(href),
                $author$project$Ui$Dropdown$Item$onKeyDown(options.Vk)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$never, content)
            ]))
        ]));
    });
    var $author$project$Ui$Dropdown$Item$viewRadio = F2(function(options, content) {
        return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'option'), A2($elm$core$List$cons, $elm$html$Html$Events$onFocus(options.afD), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item--focusable'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item--radio'), A2($elm$core$List$cons, $elm$html$Html$Attributes$tabindex(-1), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), options.vD))))))), _List_fromArray([
            A2($elm$html$Html$label, _List_fromArray([
                A2($author$project$Ui$Dropdown$Item$onMouse, 'mousedown', options.afD)
            ]), _List_fromArray([
                A2($elm$html$Html$input, _List_fromArray([
                    $elm$html$Html$Attributes$type_('radio'),
                    $author$project$Ui$Dropdown$Item$onKeyDown(A2($elm$core$List$cons, _Utils_Tuple2('Enter', options.afw(!options.hO)), options.Vk)),
                    $elm$html$Html$Attributes$tabindex(-1),
                    $elm$html$Html$Events$onCheck(options.afw),
                    $elm$html$Html$Attributes$checked(options.hO)
                ]), _List_Nil),
                content
            ]))
        ]));
    });
    var $elm$html$Html$Events$onMouseDown = function(msg) {
        return A2($elm$html$Html$Events$on, 'mousedown', $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Ui$Dropdown$Item$viewSeparator = function(options) {
        return A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown-menu__item new-dropdown-menu__item--separator'), A2($elm$core$List$cons, $elm$html$Html$Events$onMouseDown(options.zU), A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), options.vD))), _List_Nil);
    };
    var $author$project$Ui$Dropdown$Item$view = F2(function(defaultOptions, item) {
        switch(item.$){
            case 0:
                var options = item.a;
                var content = item.b;
                return A2($author$project$Ui$Dropdown$Item$viewItem, A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options), content);
            case 1:
                var options = item.a;
                return $author$project$Ui$Dropdown$Item$viewInput(A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options));
            case 2:
                var options = item.a;
                return $author$project$Ui$Dropdown$Item$viewSeparator(A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options));
            case 3:
                var options = item.a;
                var content = item.b;
                return A2($author$project$Ui$Dropdown$Item$viewCheckbox, A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options), content);
            case 4:
                var options = item.a;
                var content = item.b;
                return A2($author$project$Ui$Dropdown$Item$viewRadio, A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options), content);
            case 5:
                var id = item.a;
                var isOpen = item.b;
                var options = item.c;
                var content = item.d;
                return A4($author$project$Ui$Dropdown$Item$viewInnerDropdown, id, isOpen, A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options), content);
            default:
                var href = item.a;
                var options = item.b;
                var content = item.c;
                return A3($author$project$Ui$Dropdown$Item$viewLink, href, A2($author$project$Ui$Dropdown$Item$optionsToRecord, defaultOptions, options), content);
        }
    });
    var $author$project$Ui$Dropdown$innerDropdownContent = F3(function(trigger, items, model) {
        return _List_fromArray([
            A2($elm$html$Html$button, _List_fromArray([
                $elm$html$Html$Attributes$class('new-dropdown__trigger'),
                $elm$html$Html$Attributes$tabindex(0),
                $elm$html$Html$Attributes$id(model.aef + '-trigger'),
                $elm$html$Html$Events$onClick(model.ahX($author$project$Ui$Dropdown$InnerDropdownButtonClicked))
            ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), trigger)),
            A3($author$project$Ui$Dropdown$viewMenu, model.ahX, model, items)
        ]);
    });
    var $author$project$Ui$Dropdown$viewMenu = F3(function(toMsg, _v0, items) {
        var direction = _v0.a1;
        var hasNestedDropdowns = A2($elm$core$List$any, function(item_) {
            if (item_.$ === 5) return true;
            else return false;
        }, items);
        var directionClass = function() {
            switch(direction){
                case 0:
                    return '';
                case 1:
                    return 'new-dropdown-menu--dir-rd';
                case 2:
                    return 'new-dropdown-menu--dir-dl';
                case 3:
                    return 'new-dropdown-menu--dir-tl';
                default:
                    return 'new-dropdown-menu--dir-tr';
            }
        }();
        return A2($elm$html$Html$ul, _List_fromArray([
            $elm$html$Html$Attributes$class('new-dropdown-menu'),
            A2($elm$html$Html$Attributes$attribute, 'role', 'listbox'),
            $elm$html$Html$Attributes$class(directionClass),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('new-dropdown-menu--overflow-scroll', !hasNestedDropdowns)
            ]))
        ]), A2($elm$core$List$map, function(item_) {
            switch(item_.$){
                case 0:
                    var options = item_.a;
                    return A2($author$project$Ui$Dropdown$Item$view, function(defaults) {
                        return _Utils_update(defaults, {
                            Vk: _List_fromArray([
                                _Utils_Tuple2('ArrowDown', toMsg($author$project$Ui$Dropdown$ArrowNavigation(1))),
                                _Utils_Tuple2('ArrowUp', toMsg($author$project$Ui$Dropdown$ArrowNavigation(0)))
                            ])
                        });
                    }($author$project$Ui$Dropdown$defaultItemOptions(toMsg)), $author$project$Ui$Dropdown$Item$Input(_Utils_ap(options, _List_fromArray([
                        $author$project$Ui$Dropdown$onFocus(toMsg($author$project$Ui$Dropdown$FocusInput))
                    ]))));
                case 1:
                    return A2($author$project$Ui$Dropdown$Item$view, $author$project$Ui$Dropdown$defaultItemOptions(toMsg), $author$project$Ui$Dropdown$Item$Separator(_List_Nil));
                case 2:
                    var options = item_.a;
                    var content = item_.b;
                    return A2($author$project$Ui$Dropdown$Item$view, $author$project$Ui$Dropdown$defaultItemOptions(toMsg), A2($author$project$Ui$Dropdown$Item$Checkbox, _Utils_ap(options, _List_fromArray([
                        $author$project$Ui$Dropdown$onFocus(toMsg($author$project$Ui$Dropdown$FocusInput))
                    ])), content));
                case 3:
                    var options = item_.a;
                    var content = item_.b;
                    return A2($author$project$Ui$Dropdown$Item$view, $author$project$Ui$Dropdown$defaultItemOptions(toMsg), A2($author$project$Ui$Dropdown$Item$Radio, _Utils_ap(options, _List_fromArray([
                        $author$project$Ui$Dropdown$onFocus(toMsg($author$project$Ui$Dropdown$FocusInput))
                    ])), content));
                case 4:
                    var options = item_.a;
                    var content = item_.b;
                    return A2($author$project$Ui$Dropdown$Item$view, $author$project$Ui$Dropdown$defaultItemOptions(toMsg), A2($author$project$Ui$Dropdown$Item$Item, options, content));
                case 6:
                    var href = item_.a;
                    var options = item_.b;
                    var content = item_.c;
                    return A2($author$project$Ui$Dropdown$Item$view, $author$project$Ui$Dropdown$defaultItemOptions(toMsg), A3($author$project$Ui$Dropdown$Item$Link, href, _Utils_ap(options, _List_fromArray([
                        $author$project$Ui$Dropdown$onFocus(toMsg($author$project$Ui$Dropdown$FocusLink))
                    ])), content));
                default:
                    var content = item_.a;
                    var items_ = item_.b;
                    var innerModel = item_.c;
                    return A2($author$project$Ui$Dropdown$Item$view, $author$project$Ui$Dropdown$defaultItemOptions(toMsg), A4($author$project$Ui$Dropdown$Item$InnerDropdown, innerModel.aef, innerModel.Vw, A2($elm$core$List$cons, $author$project$Ui$Dropdown$onEnter(innerModel.ahX($author$project$Ui$Dropdown$DropdownButtonClicked)), function() {
                        var _v2 = innerModel.a1;
                        if (_v2 === 1) return _List_fromArray([
                            $author$project$Ui$Dropdown$Item$OnArrowRight(innerModel.ahX($author$project$Ui$Dropdown$InnerDropdownButtonClicked))
                        ]);
                        else return _List_Nil;
                    }()), A3($author$project$Ui$Dropdown$innerDropdownContent, content, items_, innerModel)));
            }
        }, items));
    });
    var $author$project$Ui$Dropdown$viewSelect = F4(function(options, content, items, model) {
        var toMsg = model.ahX;
        var optionsRecord = $author$project$Ui$Dropdown$optionsToRecord(options);
        var errorDescription = $elm$core$List$isEmpty(optionsRecord.fK) ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-describedby', A2($elm$core$String$join, '. ', optionsRecord.fK))
        ]);
        var ariaInvalid = optionsRecord.q2 || !$elm$core$List$isEmpty(optionsRecord.fK) ? _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
        ]) : _List_Nil;
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('new-dropdown'),
            $elm$html$Html$Attributes$id(model.aef),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('new-dropdown--open', model.Vw && !optionsRecord.d$ && !optionsRecord.sq),
                _Utils_Tuple2('new-dropdown--invalid', optionsRecord.q2 || !$elm$core$List$isEmpty(optionsRecord.fK)),
                _Utils_Tuple2('new-dropdown--disabled', optionsRecord.d$),
                _Utils_Tuple2('new-dropdown--readonly', optionsRecord.sq)
            ]))
        ]), _List_fromArray([
            A2($elm$html$Html$span, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown__trigger new-dropdown__trigger--select'), A2($elm$core$List$cons, $elm$html$Html$Attributes$id(model.aef + '-trigger'), A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('combobox'), A2($elm$core$List$cons, $elm$html$Html$Attributes$tabindex(0), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'button'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-expanded', model.Vw ? 'true' : 'false'), A2($elm$core$List$cons, $elm$core$String$isEmpty(optionsRecord.abP) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.abP), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'options-list'), _Utils_ap(optionsRecord.d$ ? _List_fromArray([
                A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')
            ]) : optionsRecord.sq ? _List_fromArray([
                $elm$html$Html$Attributes$readonly(true)
            ]) : _List_fromArray([
                $author$project$Ui$Dropdown$triggerKeyHandlers(toMsg),
                $elm$html$Html$Events$onClick(toMsg($author$project$Ui$Dropdown$DropdownButtonClicked))
            ]), _Utils_ap(errorDescription, ariaInvalid))))))))))), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('flex justify-between items-center')
                ]), _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('truncate')
                    ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content)),
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('new-dropdown__trigger__chevron')
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$chevronDown(_List_fromArray([
                            $author$project$Ui$Icon$xs,
                            $author$project$Ui$Icon$info
                        ]))
                    ]))
                ]))
            ])),
            optionsRecord.d$ || optionsRecord.sq ? $elm$html$Html$text('') : A3($author$project$Ui$Dropdown$viewMenu, toMsg, model, items),
            $author$project$Utils$FormErrors$view(optionsRecord.fK)
        ]));
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$viewPreview = F4(function(notificationSetting, subject, body, model) {
        return _List_fromArray([
            A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Liquid syntax is used to build this email. '),
                A3($author$project$Ui$Link$externalHref, 'http://shopify.github.io/liquid/basics/introduction/', _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('Click here')
                ])),
                $elm$html$Html$text(' to learn more.')
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2,
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$NotificationSetting$Shared$description(notificationSetting))
            ])),
            function() {
                var _v0 = _Utils_Tuple2(model.agk, model.fD);
                if (_v0.a.$ === 3) {
                    var _v1 = _v0.a;
                    return $elm$html$Html$text('');
                } else {
                    if (!_v0.b.$) {
                        var dropdown = _v0.b.a;
                        var languageToItem = function(lang) {
                            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                $author$project$Ui$Dropdown$selected(_Utils_eq(lang, model.yC)),
                                $author$project$Ui$Dropdown$onSelect($author$project$Components$Admin$NotificationSetting$Customize$LanguageSelected(lang))
                            ]), $elm$html$Html$text($author$project$Language$toLabel(lang)));
                        };
                        var items = A2($elm$core$List$map, languageToItem, _List_fromArray([
                            $author$project$Language$english,
                            $author$project$Language$spanish
                        ]));
                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Now editing'),
                            $author$project$Ui$Form$Group$labelSpan(2),
                            $author$project$Ui$Form$Group$inputSpan(4)
                        ]), _List_fromArray([
                            A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Language$toLabel(model.yC))
                            ]), items, dropdown)
                        ]));
                    } else return $elm$html$Html$text('');
                }
            }(),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(2),
                $author$project$Ui$Form$Group$label('Subject')
            ]), _List_fromArray([
                subject
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(2),
                $author$project$Ui$Form$Group$label('Body')
            ]), _List_fromArray([
                body
            ]))
        ]);
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$ToogleVariables = {
        $: 13
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$viewToogleVariables = function(showVariables) {
        var action = showVariables ? 'hide' : 'show';
        return _List_fromArray([
            $elm$html$Html$text('Click '),
            A3($author$project$Ui$Button$view, {
                abP: action + 'variables'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$ToogleVariables)
            ]), _List_fromArray([
                $elm$html$Html$text('here')
            ])),
            $elm$html$Html$text(' to ' + (action + ' variables'))
        ]);
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$viewModalBody = function(model) {
        var _v0 = model.agk;
        if (_v0.$ === 3) {
            var preview = _v0.a;
            return _Utils_ap(A4($author$project$Components$Admin$NotificationSetting$Customize$viewPreview, model.U7, A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$NotificationSettingPreview$subject(preview))
                ]))
            ])), A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                A2($elm$html$Html$p, _List_fromArray([
                    $elm$html$Html$Attributes$class('notification-email-layout')
                ]), _List_fromArray([
                    A2($author$project$Api$HtmlTemplate$view, $author$project$Api$Phi$displayAttr, $author$project$Api$Provider$NotificationSettingPreview$body(preview))
                ]))
            ])), model), _List_fromArray([
                function() {
                    var _v1 = model.kv;
                    if (_v1.$ === 2) {
                        var error = _v1.a;
                        return A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Error sending email')
                            ])),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            $elm$html$Html$text($author$project$Api$Data$errorToString(error))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]));
        } else {
            var _v2 = $author$project$Utils$Form$fields(model.PU);
            var subject = _v2.HF;
            return A4($author$project$Components$Admin$NotificationSetting$Customize$viewPreview, model.U7, A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(subject),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$Customize$NotificationSettingFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$Customize$Subject)),
                    $author$project$Ui$Form$Input$phi(true)
                ]))
            ])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$Textarea$view(_List_fromArray([
                        $author$project$Ui$Form$Textarea$rows(15),
                        $author$project$Ui$Form$Textarea$id($author$project$Components$Admin$NotificationSetting$Customize$notificationBodyEditorId(model.U7)),
                        $author$project$Ui$Form$Textarea$phi(true)
                    ]))
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text('You can edit your footer '),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Notifications__Settings, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('here.')
                    ]))
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), model.DT ? $author$project$Components$Admin$NotificationSetting$Customize$viewToogleVariables(model.os) : _List_fromArray([
                    $author$project$Utils$Html$empty
                ])),
                model.os ? A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, function(liquidVariable) {
                        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(liquidVariable)
                        ]));
                    }, $author$project$Api$Provider$NotificationSetting$Shared$availableLiquidVariables(model.U7)))
                ])) : $author$project$Utils$Html$empty
            ])), model);
        }
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$Edit = {
        $: 5
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$Preview = {
        $: 2
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$Reset = {
        $: 4
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$Save = {
        $: 6
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$Test = {
        $: 3
    };
    var $author$project$Ui$Button$Danger = 5;
    var $author$project$Ui$Button$danger = $author$project$Ui$Button$Styled(5);
    var $author$project$Ui$Icon$Delete = 42;
    var $author$project$Ui$Icon$delete = $author$project$Ui$Icon$viewIcon(42);
    var $author$project$Ui$Button$Loading = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Button$loading = $author$project$Ui$Button$Loading;
    var $author$project$Ui$Button$Primary = 1;
    var $author$project$Ui$Button$primary = $author$project$Ui$Button$Styled(1);
    var $author$project$Ui$Icon$Rotate = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Icon$rotate270 = $author$project$Ui$Icon$Rotate(270);
    var $author$project$Ui$Icon$rotate90 = $author$project$Ui$Icon$Rotate(90);
    var $author$project$Ui$Icon$Send = 38;
    var $author$project$Ui$Icon$send = $author$project$Ui$Icon$viewIcon(38);
    var $author$project$Ui$Button$Submit = {
        $: 3
    };
    var $author$project$Ui$Button$submit = $author$project$Ui$Button$Submit;
    var $author$project$Components$Admin$NotificationSetting$Customize$viewModalFooter = function(model) {
        var _v0 = model.agk;
        if (_v0.$ === 3) {
            var loading = model.n8;
            return _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close the modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Edit)
                ]), _List_fromArray([
                    $author$project$Ui$Icon$chevronDown(_List_fromArray([
                        $author$project$Ui$Icon$rotate90
                    ])),
                    $elm$html$Html$text('Back')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save email'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Save),
                    $author$project$Ui$Button$loading(loading)
                ]), _List_fromArray([
                    $elm$html$Html$text('Save Email')
                ]))
            ]);
        } else {
            var testLoading = function() {
                var _v1 = model.kv;
                if (_v1.$ === 1) return true;
                else return false;
            }();
            var loading = model.n8;
            return _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Reset to default version'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Reset),
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                    $author$project$Ui$Button$sm
                ]), _List_fromArray([
                    $elm$html$Html$text('Reset to Default Version')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Send Me a Test Copy'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Test),
                    $author$project$Ui$Button$loading(testLoading),
                    $author$project$Ui$Button$sm
                ]), _List_fromArray([
                    $author$project$Ui$Icon$send(_List_Nil),
                    $elm$html$Html$text(' Send Me a Test Copy')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Preview and save'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Customize$Preview),
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$sm
                ]), _List_fromArray([
                    $author$project$Ui$Icon$chevronDown(_List_fromArray([
                        $author$project$Ui$Icon$rotate270
                    ])),
                    $elm$html$Html$text(' Preview & Save')
                ]))
            ]);
        }
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$viewModal = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$NotificationSetting$Customize$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title($author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml(model.U7))
            ])),
            $author$project$Ui$Modal$body($author$project$Components$Admin$NotificationSetting$Customize$viewModalBody(model)),
            $author$project$Ui$Modal$footer($author$project$Components$Admin$NotificationSetting$Customize$viewModalFooter(model))
        ]));
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$modal = function(model) {
        return model.Vw ? $author$project$Components$Admin$NotificationSetting$Customize$viewModal(model) : $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Alignment$Center = 1;
    var $author$project$Ui$Alignment$Text = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Alignment$textCenter = $author$project$Ui$Alignment$Text(1);
    var $author$project$Components$Admin$NotificationSetting$Toggle$ToggleNotificationSetting = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$ToggleSwitch$Disabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$ToggleSwitch$disabled = $author$project$Ui$ToggleSwitch$Disabled;
    var $author$project$Ui$ToggleSwitch$On = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$ToggleSwitch$on = $author$project$Ui$ToggleSwitch$On;
    var $author$project$Ui$ToggleSwitch$OnChange = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$ToggleSwitch$onChange = $author$project$Ui$ToggleSwitch$OnChange;
    var $author$project$Ui$ToggleSwitch$defaultOptions = {
        EP: _List_Nil,
        d$: false,
        rG: false,
        ahX: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$ToggleSwitch$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var bool = option.a;
                    return _Utils_update(record, {
                        rG: bool
                    });
                case 1:
                    var toMsg = option.a;
                    return _Utils_update(record, {
                        ahX: $elm$core$Maybe$Just(toMsg)
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        d$: bool
                    });
                default:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'toggle--sm', record.EP)
                    });
            }
        }), $author$project$Ui$ToggleSwitch$defaultOptions, options);
    };
    var $author$project$Utils$Bool$toString = function(bool) {
        return bool ? 'true' : 'false';
    };
    var $author$project$Ui$ToggleSwitch$view = function(options) {
        var optionsRecord = $author$project$Ui$ToggleSwitch$optionsToRecord(options);
        return A2($elm$html$Html$label, _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'role', 'switch'),
            A2($elm$html$Html$Attributes$attribute, 'aria-checked', $author$project$Utils$Bool$toString(optionsRecord.rG)),
            $elm$html$Html$Attributes$class('toggle'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('toggle--disabled', optionsRecord.d$)
            ])),
            $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', optionsRecord.EP))
        ]), _List_fromArray([
            A2($elm$html$Html$input, _List_fromArray([
                $elm$html$Html$Attributes$type_('checkbox'),
                $elm$html$Html$Attributes$checked(optionsRecord.rG),
                $elm$html$Html$Attributes$disabled(optionsRecord.d$),
                A2($elm$core$Maybe$withDefault, $elm$html$Html$Attributes$class(''), A2($elm$core$Maybe$map, $elm$html$Html$Events$onCheck, optionsRecord.ahX))
            ]), _List_Nil),
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('toggle__background')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('toggle__icon')
                ]), 45),
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('toggle__icon')
                ]), 48)
            ])),
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('toggle__knob')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$Admin$NotificationSetting$Toggle$view = function(_v0) {
        var model = _v0;
        return model.xR.N_(model.U7) ? $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(model.OM),
            $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$NotificationSetting$Toggle$ToggleNotificationSetting),
            $author$project$Ui$ToggleSwitch$disabled(_Utils_eq(model.su, $author$project$Api$Data$Loading))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Spinner$optionToAttrs = function(option) {
        switch(option.$){
            case 1:
                var attributes = option.a;
                return A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), attributes);
            case 0:
                var size = option.a;
                switch(size){
                    case 0:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('spinner-xs')
                        ]);
                    case 1:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('spinner-sm')
                        ]);
                    case 2:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('spinner')
                        ]);
                    default:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('spinner-lg')
                        ]);
                }
            default:
                var side = option.a;
                return _List_fromArray([
                    $author$project$Ui$Pull$toClass(side)
                ]);
        }
    };
    var $author$project$Ui$Spinner$view = function(options) {
        return A2($elm$html$Html$span, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('spinner'), A2($elm$core$List$concatMap, $author$project$Ui$Spinner$optionToAttrs, options)), _List_Nil);
    };
    var $author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting = F2(function(model, id) {
        var _v0 = A2($elm$core$Dict$get, id, model.bd);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var notificationSetting = _v1.a;
            var customizeNotification = _v1.b;
            var toggleNotification = _v1.c;
            return _List_fromArray([
                A2($elm$html$Html$map, A2($author$project$Pages$Admin$AdvanceBilling$ToggleNotificationMsg, id, toggleNotification), $author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification)),
                $author$project$Utils$Html$noBreakSpace,
                A2($elm$html$Html$map, $author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(notificationSetting), $author$project$Components$Admin$NotificationSetting$Customize$button(customizeNotification)),
                A2($elm$html$Html$map, $author$project$Pages$Admin$AdvanceBilling$CustomizeNotificationMsg(notificationSetting), $author$project$Components$Admin$NotificationSetting$Customize$modal(customizeNotification))
            ]);
        } else return _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
            ]), _List_fromArray([
                $author$project$Ui$Spinner$view(_List_Nil)
            ]))
        ]);
    });
    var $author$project$Pages$Admin$AdvanceBilling$viewAutopayTable = function(model) {
        return A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Billing Period')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Create & Notify')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Schedule Payment In Advance')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Email Notifications')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Monthly')
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Int$toDays($author$project$Api$Provider$Practice$One$billMonthlyAutopayInAdvanceInDays(model.W1)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Int$toDays($author$project$Api$Provider$Practice$One$scheduleMonthlyPaymentInAdvanceInDays(model.W1)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_monthly_autopay_invoice_generated')),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick(A2($author$project$Pages$Admin$AdvanceBilling$Edit, 0, 0)),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Quarterly, Semi-Annual, Annual')
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Int$toDays($author$project$Api$Provider$Practice$One$billNonMonthlyAutopayInAdvanceInDays(model.W1)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Int$toDays($author$project$Api$Provider$Practice$One$scheduleNonMonthlyPaymentInAdvanceInDays(model.W1)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_non_monthly_autopay_invoice_generated')),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick(A2($author$project$Pages$Admin$AdvanceBilling$Edit, 0, 1)),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]), _List_Nil);
    };
    var $author$project$Pages$Admin$AdvanceBilling$Save = {
        $: 3
    };
    var $author$project$Ui$Margin$Bottom_2 = 5;
    var $author$project$Ui$Alert$Margin = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Alert$mb2 = $author$project$Ui$Alert$Margin(5);
    var $author$project$Ui$Modal$OnSubmit = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Modal$onSubmit = $author$project$Ui$Modal$OnSubmit;
    var $author$project$Ui$Clearfix$view = A2($elm$html$Html$div, _List_fromArray([
        $author$project$Ui$Clearfix$toClass
    ]), _List_Nil);
    var $author$project$Ui$Alert$Warning = 2;
    var $author$project$Ui$Alert$warning = $author$project$Ui$Alert$view(2);
    var $author$project$Components$Admin$CreateEditModal$modal = F2(function(_v0, formGroups) {
        var label = _v0.aeI;
        var maybeId = _v0.TR;
        var onClose = _v0.Vl;
        var onSave = _v0.Vn;
        var loading = _v0.Tk;
        var maybeUpdateWarning = _v0.TS;
        var helpText = _v0.QG;
        var updating = function() {
            if (maybeId.$ === 1) return false;
            else return true;
        }();
        return A3($author$project$Ui$Modal$view, onClose, _List_fromArray([
            $author$project$Ui$Modal$onSubmit(onSave(maybeId))
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(updating ? 'Edit ' + label : 'New ' + label),
                function() {
                    if (!helpText.$) {
                        var helpText_ = helpText.a;
                        return A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text(helpText_)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    var _v2 = _Utils_Tuple2(maybeUpdateWarning, updating);
                    if (!_v2.a.$ && _v2.b) {
                        var updateWarning = _v2.a.a;
                        return A2($author$project$Ui$Alert$warning, _List_fromArray([
                            $author$project$Ui$Alert$mb2
                        ]), _List_fromArray([
                            $elm$html$Html$text(updateWarning)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('form-horizontal')
                ]), formGroups),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick(onClose)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save ' + label
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$submit
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDays = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDays = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$AdvanceBilling$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDays = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDays = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$addon = $elm$html$Html$span(_List_fromArray([
        $elm$html$Html$Attributes$class('input-group__addon')
    ]));
    var $author$project$Ui$Form$Input$group = function(content) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('input-group')
        ]), content);
    };
    var $author$project$Ui$Form$Input$Number = {
        $: 2
    };
    var $author$project$Ui$Form$Input$Type = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$number = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Number);
    var $author$project$Utils$Form$errorBelongsToGroup = F2(function(currentValidationGroup, _v0) {
        var validationGroup = _v0.a;
        var error = _v0.b;
        return _Utils_eq(currentValidationGroup, validationGroup) ? $elm$core$Maybe$Just(error) : $elm$core$Maybe$Nothing;
    });
    var $author$project$Utils$Form$validationErrors = F2(function(validationGroup, _v0) {
        var errors_ = _v0.d;
        return A2($elm$core$List$filterMap, $author$project$Utils$Form$errorBelongsToGroup(validationGroup), errors_);
    });
    var $author$project$Ui$Typography$Bold = 3;
    var $author$project$Ui$Typography$Decoration = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Typography$bold = $author$project$Ui$Typography$Decoration(3);
    var $author$project$Ui$Typography$Italic = 2;
    var $author$project$Ui$Typography$italic = $author$project$Ui$Typography$Decoration(2);
    var $author$project$Ui$Typography$span = F2(function(options, content) {
        return A2($elm$html$Html$span, $author$project$Ui$Typography$optionsToAttributes(options), content);
    });
    var $author$project$Pages$Admin$AdvanceBilling$viewPendingMessage = F2(function(frequency, days) {
        var label = function() {
            if (!frequency) return 'Monthly';
            else return 'Quarterly, Semi-Annual, Annual';
        }();
        return A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$small
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$strong, _List_fromArray([
                $author$project$Ui$Typography$italic
            ]), _List_fromArray([
                $elm$html$Html$text('Pending: ')
            ])),
            $elm$html$Html$text('Starting tonight, your '),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$bold
            ]), _List_fromArray([
                $elm$html$Html$text(label)
            ])),
            $elm$html$Html$text(' patients will have invoices generated '),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$bold
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Int$toDays, days)))
            ])),
            $elm$html$Html$text(' in advance')
        ]));
    });
    var $author$project$Pages$Admin$AdvanceBilling$viewAutopayFields = F2(function(frequency, form) {
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = function() {
            if (!frequency) return _Utils_Tuple3(fields.ag4, $author$project$Pages$Admin$AdvanceBilling$ScheduleMonthlyPaymentInAdvanceInDays, 2);
            else return _Utils_Tuple3(fields.ag5, $author$project$Pages$Admin$AdvanceBilling$ScheduleNonMonthlyPaymentInAdvanceInDays, 3);
        }();
        var scheduleValue = _v0.a;
        var scheduleField = _v0.b;
        var scheduleValidationGroup = _v0.c;
        var _v2 = function() {
            if (!frequency) return _Utils_Tuple3(fields.abZ, $author$project$Pages$Admin$AdvanceBilling$BillMonthlyAutopayInAdvanceInDays, 0);
            else return _Utils_Tuple3(fields.ab$, $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyAutopayInAdvanceInDays, 1);
        }();
        var createValue = _v2.a;
        var createField = _v2.b;
        var createValidationGroup = _v2.c;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(5),
                $author$project$Ui$Form$Group$inputSpan(7),
                $author$project$Ui$Form$Group$label('Create & Notify')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$number,
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, createValue))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, createField))
                    ])),
                    $author$project$Ui$Form$Input$addon(_List_fromArray([
                        $elm$html$Html$text('days')
                    ]))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, createValidationGroup, form)),
                A2($author$project$Pages$Admin$AdvanceBilling$viewPendingMessage, frequency, createValue)
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(5),
                $author$project$Ui$Form$Group$inputSpan(7),
                $author$project$Ui$Form$Group$label('Schedule Payment In Advance')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$number,
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, scheduleValue))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, scheduleField))
                    ])),
                    $author$project$Ui$Form$Input$addon(_List_fromArray([
                        $elm$html$Html$text('days')
                    ]))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, scheduleValidationGroup, form))
            ]))
        ]);
    });
    var $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDays = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDays = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$AdvanceBilling$viewNonAutopayFields = F2(function(frequency, form) {
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = function() {
            if (!frequency) return _Utils_Tuple3(fields.ab_, $author$project$Pages$Admin$AdvanceBilling$BillMonthlyNonAutopayInAdvanceInDays, 4);
            else return _Utils_Tuple3(fields.ab0, $author$project$Pages$Admin$AdvanceBilling$BillNonMonthlyNonAutopayInAdvanceInDays, 5);
        }();
        var value = _v0.a;
        var field = _v0.b;
        var validationGroup = _v0.c;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(5),
                $author$project$Ui$Form$Group$inputSpan(7),
                $author$project$Ui$Form$Group$label('Invoice & Notification Lead Time')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$number,
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$AdvanceBilling$FormUpdated, field))
                    ])),
                    $author$project$Ui$Form$Input$addon(_List_fromArray([
                        $elm$html$Html$text('days')
                    ]))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
                A2($author$project$Pages$Admin$AdvanceBilling$viewPendingMessage, frequency, value)
            ]))
        ]);
    });
    var $author$project$Pages$Admin$AdvanceBilling$viewEditModal = F2(function(form, saveRequest) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Invoicing Ahead of Time',
            Tk: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just(''),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$AdvanceBilling$CancelEdit,
            Vn: $elm$core$Basics$always($author$project$Pages$Admin$AdvanceBilling$Save)
        };
        var _v0 = $author$project$Utils$Form$fields(form);
        var type_ = _v0.ah5;
        var frequency = _v0.qK;
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, function() {
            if (!type_) return A2($author$project$Pages$Admin$AdvanceBilling$viewAutopayFields, frequency, form);
            else return A2($author$project$Pages$Admin$AdvanceBilling$viewNonAutopayFields, frequency, form);
        }());
    });
    var $author$project$Pages$Admin$AdvanceBilling$NonAutopay = 1;
    var $author$project$Pages$Admin$AdvanceBilling$viewNonAutopayTable = function(model) {
        return A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Billing Period')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Create & Notify')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_Nil),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Email Notifications')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Monthly')
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Int$toDays($author$project$Api$Provider$Practice$One$billMonthlyNonAutopayInAdvanceInDays(model.W1)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                A2($author$project$Ui$Table$cell, _List_Nil, A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_monthly_non_autopay_invoice_generated')),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick(A2($author$project$Pages$Admin$AdvanceBilling$Edit, 1, 0)),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Quarterly, Semi-Annual, Annual')
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Int$toDays($author$project$Api$Provider$Practice$One$billNonMonthlyNonAutopayInAdvanceInDays(model.W1)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                A2($author$project$Ui$Table$cell, _List_Nil, A2($author$project$Pages$Admin$AdvanceBilling$viewNotificationSetting, model, 'patient_upcoming_non_monthly_non_autopay_invoice_generated')),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick(A2($author$project$Pages$Admin$AdvanceBilling$Edit, 1, 1)),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]), _List_Nil);
    };
    var $author$project$Pages$Admin$AdvanceBilling$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.w;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var form = _v1.a;
                        var updateRequest = _v1.b;
                        return A2($author$project$Pages$Admin$AdvanceBilling$viewEditModal, form, updateRequest);
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Invoicing Ahead of Time')
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textMuted
                        ]), _List_fromArray([
                            $elm$html$Html$text('We will create invoices and notify your members before their bill date, unless they have already been billed. You can specify the lead time (in days) before invoicing below. Any changes you make will take effect tonight during our nightly billing run.')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mb2
                        ]), _List_fromArray([
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('For Autopay Members')
                            ]))
                        ])),
                        $author$project$Pages$Admin$AdvanceBilling$viewAutopayTable(model)
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mb2
                        ]), _List_fromArray([
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('For Autopay Disabled Members')
                            ]))
                        ])),
                        $author$project$Pages$Admin$AdvanceBilling$viewNonAutopayTable(model)
                    ]))
                ]))
            ]),
            $2: 'Admin | Advance Billing'
        };
    };
    var $author$project$Pages$Admin$AdvanceBilling$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$AdvanceBilling$init,
        aeR: $author$project$Pages$Admin$AdvanceBilling$load,
        ag3: $author$project$Pages$Admin$AdvanceBilling$save,
        ahE: $author$project$Pages$Admin$AdvanceBilling$subscriptions,
        aaO: $author$project$Pages$Admin$AdvanceBilling$update,
        aid: $author$project$Pages$Admin$AdvanceBilling$view
    });
    var $author$project$Components$Admin$Athena$StepHeader$Fields = 3;
    var $author$project$Pages$Admin$Athenahealth$Fields$GotAthena = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Athena$StepHeader$init = function(currentStep) {
        return {
            E1: currentStep,
            d0: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Api$Provider$Integration$Athena$athenaPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'athena_configuration'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$AthenaConfiguration$One$AthenaConfiguration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$AthenaConfiguration$Shared$AthenaConfiguration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$AthenaConfiguration$Shared$Record = F8(function(status, allowNewPatientCreation, athenaPracticeName, athenaPracticeId, athenaProviderGroupId, scopedByProviderGroup, setupSubstate, ignoredFields) {
        return {
            Ja: allowNewPatientCreation,
            JH: athenaPracticeId,
            JI: athenaPracticeName,
            JJ: athenaProviderGroupId,
            Q3: ignoredFields,
            Zz: scopedByProviderGroup,
            Z2: setupSubstate,
            ahy: status
        };
    });
    var $author$project$Api$Provider$AthenaConfiguration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ignored_fields', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'setup_substate', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'scoped_by_provider_group', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'athena_provider_group_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'athena_practice_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'athena_practice_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allow_new_patient_creation', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$AthenaConfiguration$Shared$Record)))))))));
    var $author$project$Api$Provider$AthenaConfiguration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$AthenaConfiguration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$AthenaConfiguration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$AthenaConfiguration$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$AthenaConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            k4: $author$project$Api$Data$Loading,
            k5: $author$project$Api$Data$NotAsked,
            cB: _List_Nil,
            j_: $author$project$Api$Data$NotAsked,
            kl: $author$project$Components$Admin$Athena$StepHeader$init(3)
        }, A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.Ej, $author$project$Pages$Admin$Athenahealth$Fields$GotAthena(true)));
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$Athena$StepHeader$HiConfirmClosed = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$subscribeToEscapeKeyPress = function(onClose) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose(false));
    };
    var $author$project$Components$Admin$Athena$StepHeader$subscriptions = function(model) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Admin$Athena$StepHeader$HiConfirmClosed)), model.d0));
    };
    var $author$project$Pages$Admin$Athenahealth$Fields$subscriptions = function(_v0) {
        var stepHeader = _v0.kl;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
    };
    var $author$project$Pages$Admin$Athenahealth$Fields$FieldMappingsUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaCustomFields = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$externalId = function(_v0) {
        var record = _v0;
        return record.adE;
    };
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$externalId(shared);
    };
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$humanName = function(_v0) {
        var record = _v0;
        return record.QW;
    };
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$humanName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$humanName(shared);
    };
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$id(shared);
    };
    var $author$project$Api$Provider$Integration$Athena$CustomField$customFieldsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'custom_fields'
    ]), $author$project$Api$Provider$Integration$Athena$athenaPath);
    var $author$project$Api$Provider$Integration$Athena$CustomField$All$CustomField = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$CustomField = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$Record = F2(function(externalId, name) {
        return {
            adE: externalId,
            zr: name
        };
    });
    var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external_id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$CustomField$Shared$Record)));
    var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$CustomField$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$CustomField$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$CustomField$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$CustomField$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$CustomField$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$CustomField$customFieldsPath));
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaFieldMappings = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$FieldMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$FieldMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$Record = F3(function(id, humanName, externalId) {
        return {
            adE: externalId,
            QW: humanName,
            aef: id
        };
    });
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$Record))));
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$FieldMapping$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'field_mappings'
    ]), $author$project$Api$Provider$Integration$Athena$athenaPath);
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath));
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$fetchCustomFieldsData = function(model) {
        return _Utils_Tuple2(_Utils_update(model, {
            k5: $author$project$Api$Data$Loading,
            cB: _List_Nil
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$Integration$Athena$CustomField$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaCustomFields),
            A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaFieldMappings)
        ])));
    };
    var $author$project$Components$Admin$Athena$StepHeader$Initial = 0;
    var $author$project$Components$Admin$Athena$StepHeader$Link = 1;
    var $author$project$Components$Admin$Athena$StepHeader$Locations = 2;
    var $author$project$Components$Admin$Athena$StepHeader$Overview = 5;
    var $author$project$Components$Admin$Athena$StepHeader$Providers = 4;
    var $author$project$Components$Admin$Athena$StepHeader$all = _List_fromArray([
        0,
        1,
        2,
        3,
        4,
        5
    ]);
    var $elm_community$list_extra$List$Extra$findIndexHelp = F3(function(index, predicate, list) {
        findIndexHelp: while(true){
            if (!list.b) return $elm$core$Maybe$Nothing;
            else {
                var x = list.a;
                var xs = list.b;
                if (predicate(x)) return $elm$core$Maybe$Just(index);
                else {
                    var $temp$index = index + 1, $temp$predicate = predicate, $temp$list = xs;
                    index = $temp$index;
                    predicate = $temp$predicate;
                    list = $temp$list;
                    continue findIndexHelp;
                }
            }
        }
    });
    var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
    var $author$project$Components$Admin$Athena$StepHeader$stepIndex = function(step_) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm_community$list_extra$List$Extra$findIndex, function(currentStep_) {
            return _Utils_eq(step_, currentStep_);
        }, $author$project$Components$Admin$Athena$StepHeader$all));
    };
    var $author$project$Components$Admin$Athena$StepHeader$canGoToStep = F2(function(step, setupSubstateStep) {
        return _Utils_cmp($author$project$Components$Admin$Athena$StepHeader$stepIndex(step), $author$project$Components$Admin$Athena$StepHeader$stepIndex(setupSubstateStep)) < 0;
    });
    var $author$project$Api$Provider$AthenaConfiguration$Shared$setupSubstate = function(_v0) {
        var record = _v0;
        return record.Z2;
    };
    var $author$project$Api$Provider$AthenaConfiguration$One$setupSubstate = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$AthenaConfiguration$Shared$setupSubstate(shared);
    };
    var $author$project$Api$Provider$AthenaConfiguration$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$AthenaConfiguration$One$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$AthenaConfiguration$Shared$status(shared);
    };
    var $author$project$Components$Admin$Athena$StepHeader$stepRoute = function(step) {
        switch(step){
            case 0:
                return $author$project$Spa$Generated$Route$Admin__Athenahealth__Top;
            case 1:
                return $author$project$Spa$Generated$Route$Admin__Athenahealth__Link;
            case 2:
                return $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations;
            case 3:
                return $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields;
            case 4:
                return $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers;
            default:
                return $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview;
        }
    };
    var $author$project$Components$Admin$Athena$StepHeader$goToStep = F2(function(athenaConfiguration, step) {
        _v0$2: while(true)switch(athenaConfiguration.$){
            case 3:
                var athenaConfiguration_ = athenaConfiguration.a;
                if ($author$project$Api$Provider$AthenaConfiguration$One$status(athenaConfiguration_) === 'inactive' && !!step) return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Top);
                else {
                    var setupSubstateStep = function() {
                        var _v1 = $author$project$Api$Provider$AthenaConfiguration$One$setupSubstate(athenaConfiguration_);
                        switch(_v1){
                            case 'link_practice':
                                return 1;
                            case 'locations_mapping':
                                return 2;
                            case 'fields_mapping':
                                return 3;
                            case 'providers_mapping':
                                return 4;
                            case 'completed':
                                return 5;
                            default:
                                return 5;
                        }
                    }();
                    return $author$project$Api$Provider$AthenaConfiguration$One$status(athenaConfiguration_) !== 'inactive' && !step && !_Utils_eq(step, setupSubstateStep) ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Components$Admin$Athena$StepHeader$stepRoute(setupSubstateStep)) : step === 1 && !_Utils_eq(step, setupSubstateStep) ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Components$Admin$Athena$StepHeader$stepRoute(setupSubstateStep)) : A2($author$project$Components$Admin$Athena$StepHeader$canGoToStep, step, setupSubstateStep) && !_Utils_eq(step, setupSubstateStep) ? $elm$core$Platform$Cmd$none : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Components$Admin$Athena$StepHeader$stepRoute(setupSubstateStep));
                }
            case 2:
                if (athenaConfiguration.a.$ === 5) {
                    var _v2 = athenaConfiguration.a;
                    return !!step ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Top) : $elm$core$Platform$Cmd$none;
                } else break _v0$2;
            default:
                break _v0$2;
        }
        return $elm$core$Platform$Cmd$none;
    });
    var $elm$core$Tuple$mapSecond = F2(function(func, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(x, func(y));
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$setIntegration = F3(function(athenaConfiguration, fetchCustomFields, model) {
        return A2($elm$core$Tuple$mapSecond, function(cmd) {
            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmd,
                A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 3)
            ]));
        }, (fetchCustomFields ? $author$project$Pages$Admin$Athenahealth$Fields$fetchCustomFieldsData : function(model_) {
            return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
        })(_Utils_update(model, {
            k4: athenaConfiguration
        })));
    });
    var $elm$core$String$trim = _String_trim;
    var $author$project$Utils$String$isBlank = function(string) {
        return $elm$core$String$isEmpty($elm$core$String$trim(string));
    };
    var $author$project$Utils$String$toMaybe = function(string) {
        return $author$project$Utils$String$isBlank(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
    };
    var $author$project$Utils$Encode$nullable = F2(function(encoder, value) {
        return A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, encoder, value));
    });
    var $author$project$Api$Data$put = $author$project$Api$Data$makeRequest('put');
    var $author$project$Api$Provider$Integration$Athena$FieldMapping$update = F3(function(apiClient, fieldMappings, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('field_mappings', A2($elm$json$Json$Encode$list, function(fieldMapping) {
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(fieldMapping.aef)),
                    _Utils_Tuple2('external_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMapping.adE))
                ]));
            }, fieldMappings))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$FieldMapping$All$decoder), toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$FieldMapping$fieldMappingsPath)));
    });
    var $author$project$Components$Admin$Athena$StepHeader$Disabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Data$delete = $author$project$Api$Data$makeRequest('delete');
    var $author$project$Api$Provider$Integration$Athena$delete = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
    });
    var $author$project$Components$Admin$Athena$StepHeader$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
                }), A2($author$project$Api$Provider$Integration$Athena$delete, apiClient, $author$project$Components$Admin$Athena$StepHeader$Disabled), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Nothing
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Top), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration has been disabled.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $elm_community$list_extra$List$Extra$updateIf = F3(function(predicate, update, list) {
        return A2($elm$core$List$map, function(item) {
            return predicate(item) ? update(item) : item;
        }, list);
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var fetchCustomFields = msg.a;
                var response = msg.b;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Pages$Admin$Athenahealth$Fields$setIntegration, response, fetchCustomFields, model));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Pages$Admin$Athenahealth$Fields$setIntegration, response, fetchCustomFields, model));
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    k4: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    k5: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var athenaFieldMappings = response.a;
                    var fieldMappings = A2($elm$core$List$map, function(athenaFieldMapping) {
                        return {
                            adE: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId(athenaFieldMapping),
                            aef: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$id(athenaFieldMapping),
                            zr: $author$project$Api$Provider$Integration$Athena$FieldMapping$All$humanName(athenaFieldMapping)
                        };
                    }, athenaFieldMappings);
                    return _Utils_Tuple3(_Utils_update(model, {
                        cB: fieldMappings
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cB: _List_Nil
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Integration$Athena$FieldMapping$update, model.Ej, A2($elm$core$List$map, function(athenaFieldMapping) {
                    return {
                        adE: athenaFieldMapping.adE,
                        aef: athenaFieldMapping.aef
                    };
                }, model.cB), $author$project$Pages$Admin$Athenahealth$Fields$FieldMappingsUpdated), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers), _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    k5: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Athena$CustomField$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Fields$GotAthenaCustomFields), _List_Nil);
            case 6:
                var athenaFieldMapping = msg.a;
                var athenaFieldId = msg.b;
                var athenaFieldMappings = A3($elm_community$list_extra$List$Extra$updateIf, function(fieldMapping) {
                    return _Utils_eq(fieldMapping.aef, athenaFieldMapping.aef);
                }, function(fieldMapping) {
                    return _Utils_update(fieldMapping, {
                        adE: $author$project$Utils$String$toMaybe(athenaFieldId)
                    });
                }, model.cB);
                return _Utils_Tuple3(_Utils_update(model, {
                    cB: athenaFieldMappings
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v5 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.Ej, subMsg, model.kl);
                var stepHeader = _v5.a;
                var subCmd = _v5.b;
                var subOutMsg = _v5.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    kl: stepHeader
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$CompleteFields = {
        $: 3
    };
    var $author$project$Ui$Form$Autocomplete = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$autocomplete = $author$project$Ui$Form$Autocomplete;
    var $author$project$Ui$Form$Horizontal = {
        $: 0
    };
    var $author$project$Ui$Form$horizontal = $author$project$Ui$Form$Horizontal;
    var $author$project$Components$HiConfirm$CustomMessage = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$customMessage = $author$project$Components$HiConfirm$CustomMessage;
    var $author$project$Components$HiConfirm$Loading = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$loading = $author$project$Components$HiConfirm$Loading;
    var $author$project$Components$HiConfirm$defaultOptions = {
        vT: $elm$core$Maybe$Nothing,
        v3: true,
        w5: $elm$core$Maybe$Nothing,
        w6: $elm$core$Maybe$Nothing,
        xh: $elm$core$Maybe$Nothing,
        Tk: false,
        zO: $elm$core$Maybe$Nothing,
        Cr: $elm$core$Maybe$Nothing,
        Cw: true,
        DH: true,
        aba: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$HiConfirm$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var string = option.a;
                    return _Utils_update(record, {
                        aba: $elm$core$Maybe$Just(string)
                    });
                case 1:
                    var string = option.a;
                    return _Utils_update(record, {
                        zO: $elm$core$Maybe$Just(string)
                    });
                case 2:
                    var string = option.a;
                    return _Utils_update(record, {
                        w5: $elm$core$Maybe$Just(string)
                    });
                case 3:
                    var bool = option.a;
                    return _Utils_update(record, {
                        DH: bool
                    });
                case 4:
                    var bool = option.a;
                    return _Utils_update(record, {
                        v3: bool
                    });
                case 5:
                    var string = option.a;
                    return _Utils_update(record, {
                        xh: $elm$core$Maybe$Just(string)
                    });
                case 6:
                    var string = option.a;
                    return _Utils_update(record, {
                        Cr: $elm$core$Maybe$Just(string)
                    });
                case 7:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Tk: bool
                    });
                case 8:
                    var string = option.a;
                    return _Utils_update(record, {
                        w6: $elm$core$Maybe$Just(string)
                    });
                case 9:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Cw: bool
                    });
                default:
                    var buttonStyle_ = option.a;
                    return _Utils_update(record, {
                        vT: $elm$core$Maybe$Just(buttonStyle_)
                    });
            }
        }), $author$project$Components$HiConfirm$defaultOptions, options);
    };
    var $elm_community$string_extra$String$Extra$regexFromString = A2($elm$core$Basics$composeR, $elm$regex$Regex$fromString, $elm$core$Maybe$withDefault($elm$regex$Regex$never));
    var $elm$core$String$toLower = _String_toLower;
    var $elm_community$string_extra$String$Extra$changeCase = F2(function(mutator, word) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(_v0) {
            var head = _v0.a;
            var tail = _v0.b;
            return A2($elm$core$String$cons, mutator(head), tail);
        }, $elm$core$String$uncons(word)));
    });
    var $elm$core$Char$toUpper = _Char_toUpper;
    var $elm_community$string_extra$String$Extra$toSentenceCase = function(word) {
        return A2($elm_community$string_extra$String$Extra$changeCase, $elm$core$Char$toUpper, word);
    };
    var $elm_community$string_extra$String$Extra$humanize = function(string) {
        return $elm_community$string_extra$String$Extra$toSentenceCase($elm$core$String$toLower($elm$core$String$trim(A3($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('_id$|[-_\\s]+'), $elm$core$Basics$always(' '), A3($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('[A-Z]+'), A2($elm$core$Basics$composeR, function($) {
            return $.aeX;
        }, $elm$core$String$append('-')), string)))));
    };
    var $elm_community$string_extra$String$Extra$toTitleCase = function(ws) {
        var uppercaseMatch = A2($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('\\w+'), A2($elm$core$Basics$composeR, function($) {
            return $.aeX;
        }, $elm_community$string_extra$String$Extra$toSentenceCase));
        return A3($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('^([a-z])|\\s+([a-z])'), A2($elm$core$Basics$composeR, function($) {
            return $.aeX;
        }, uppercaseMatch), ws);
    };
    var $author$project$Formatters$String$titleize = A2($elm$core$Basics$composeR, $elm_community$string_extra$String$Extra$humanize, $elm_community$string_extra$String$Extra$toTitleCase);
    var $author$project$Components$HiConfirm$viewMessage = F4(function(maybeVerb, maybeProcessedNoun, maybeDetail, maybeSentence) {
        var _v0 = _Utils_Tuple2(maybeVerb, maybeProcessedNoun);
        if (!_v0.a.$ && !_v0.b.$) {
            var verb_ = _v0.a.a;
            var processedNoun = _v0.b.a;
            var _v1 = _Utils_Tuple2(maybeDetail, maybeSentence);
            if (!_v1.a.$) {
                if (_v1.b.$ === 1) {
                    var detail_ = _v1.a.a;
                    var _v4 = _v1.b;
                    return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' ' + (processedNoun + ('  ' + (detail_ + '.'))))));
                } else return $elm$core$Maybe$Nothing;
            } else if (_v1.b.$ === 1) {
                var _v2 = _v1.a;
                var _v3 = _v1.b;
                return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' this ' + (processedNoun + '.'))));
            } else {
                var _v5 = _v1.a;
                var sentence_ = _v1.b.a;
                return $elm$core$Maybe$Just('You\'re about to ' + (verb_ + (' ' + (processedNoun + ('. ' + sentence_)))));
            }
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$HiConfirm$viewBody = F2(function(processedNoun, options) {
        var alignment = options.v3 ? _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]) : _List_Nil;
        return A2($elm$html$Html$div, $author$project$Api$Phi$displayAttr, _List_fromArray([
            A2($author$project$Ui$Typography$p, alignment, function() {
                var _v0 = options.w5;
                if (!_v0.$) {
                    var customMessage_ = _v0.a;
                    return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), customMessage_);
                } else return $elm$core$List$concat(_List_fromArray([
                    function() {
                        var _v1 = A4($author$project$Components$HiConfirm$viewMessage, options.aba, processedNoun, options.xh, options.Cr);
                        if (!_v1.$) {
                            var message = _v1.a;
                            return _List_fromArray([
                                $elm$html$Html$text(message),
                                $author$project$Utils$Html$noBreakSpace
                            ]);
                        } else return _List_Nil;
                    }(),
                    _List_fromArray([
                        $elm$html$Html$text('This action cannot be undone.')
                    ])
                ]));
            }())
        ]));
    });
    var $author$project$Ui$Button$Success = 3;
    var $author$project$Ui$Button$Warning = 4;
    var $author$project$Components$HiConfirm$calculatebuttonStyle = function(maybeVerb) {
        if (maybeVerb.$ === 1) return 1;
        else {
            var verb_ = maybeVerb.a;
            switch(verb_){
                case 'remove':
                    return 5;
                case 'deactivate':
                    return 5;
                case 'delete':
                    return 5;
                case 'disable':
                    return 5;
                case 'destroy':
                    return 5;
                case 'void':
                    return 5;
                case 'mark':
                    return 5;
                case 'unlock':
                    return 4;
                case 'unenroll':
                    return 5;
                case 'approve':
                    return 3;
                case 'merge':
                    return 5;
                case 'enroll':
                    return 4;
                case 'end':
                    return 5;
                case 'clear':
                    return 5;
                case 'archive':
                    return 5;
                case 'cancel':
                    return 5;
                default:
                    return 1;
            }
        }
    };
    var $author$project$Ui$Grid$Col = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Grid$column = $author$project$Ui$Grid$Col;
    var $author$project$Ui$Button$FullWidth = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Button$fullWidth = $author$project$Ui$Button$FullWidth;
    var $author$project$Ui$Grid$Empty = {
        $: 0
    };
    var $author$project$Ui$Grid$none = $author$project$Ui$Grid$Empty;
    var $author$project$Ui$Grid$Offset = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Grid$offset = $author$project$Ui$Grid$Offset(0);
    var $author$project$Ui$Grid$optionsToClasses = F2(function(toAttributesFunc, options) {
        return A2($elm$core$List$concatMap, toAttributesFunc, options);
    });
    var $author$project$Ui$Grid$rowElementOptions = function(options) {
        return A2($elm$core$List$filterMap, function(option) {
            if (!option.$) {
                var elemOption = option.a;
                return $elm$core$Maybe$Just(elemOption);
            } else return $elm$core$Maybe$Nothing;
        }, options);
    };
    var $author$project$Ui$Grid$rowOptionToClass = function(option) {
        if (option.$ === 1) switch(option.a){
            case 0:
                var _v1 = option.a;
                return _List_fromArray([
                    'gap-0'
                ]);
            case 1:
                var _v2 = option.a;
                return _List_fromArray([
                    'gap-2'
                ]);
            case 2:
                var _v3 = option.a;
                return _List_fromArray([
                    'gap-4'
                ]);
            default:
                var _v4 = option.a;
                return _List_fromArray([
                    'gap-6'
                ]);
        }
        else return _List_Nil;
    };
    var $author$project$Ui$Grid$elementOptions = function(options) {
        return A2($elm$core$List$concatMap, function(option) {
            if (option.$ === 5) {
                var elemOption = option.a;
                return _List_fromArray([
                    elemOption
                ]);
            } else return _List_Nil;
        }, options);
    };
    var $author$project$Ui$Grid$optionToClass = function(option) {
        optionToClass: while(true)switch(option.$){
            case 1:
                var screenSize = option.a;
                return _List_fromArray([
                    $author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'hidden'
                ]);
            case 3:
                var screenSize = option.a;
                return _List_fromArray([
                    $author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'grid'
                ]);
            case 0:
                var screenSize = option.a;
                var _int = option.b;
                return _List_fromArray([
                    $author$project$Ui$ScreenSize$toClassPrefix(screenSize) + ('col-span-' + $elm$core$String$fromInt(_int))
                ]);
            case 4:
                var screenSize = option.a;
                var _int = option.b;
                return _List_fromArray([
                    $author$project$Ui$ScreenSize$toClassPrefix(screenSize) + ('col-start-' + $elm$core$String$fromInt(_int + 1))
                ]);
            case 2:
                var _v1 = option.a;
                var bool = _v1.a;
                var opt = _v1.b;
                if (bool) {
                    var $temp$option = opt;
                    option = $temp$option;
                    continue optionToClass;
                } else return _List_Nil;
            case 5:
                return _List_Nil;
            case 6:
                var _int = option.a;
                return _List_fromArray([
                    'gap-' + $elm$core$String$fromInt(_int)
                ]);
            default:
                return _List_fromArray([
                    'h-full'
                ]);
        }
    };
    var $author$project$Ui$Grid$viewCol = function(col) {
        if (col.$ === 1) {
            var options = col.a;
            var content = col.b;
            return A3($author$project$Ui$Element$custom, A2($elm$core$String$join, ' ', A2($elm$core$List$cons, 'grid-col', A2($author$project$Ui$Grid$optionsToClasses, $author$project$Ui$Grid$optionToClass, options))), $author$project$Ui$Grid$elementOptions(options), content);
        } else return $elm$html$Html$text('');
    };
    var $author$project$Ui$Grid$row = F2(function(options, columns) {
        return A3($author$project$Ui$Element$custom, A2($elm$core$String$join, ' ', A2($elm$core$List$cons, 'grid-row', A2($author$project$Ui$Grid$optionsToClasses, $author$project$Ui$Grid$rowOptionToClass, options))), $author$project$Ui$Grid$rowElementOptions(options), A2($elm$core$List$map, $author$project$Ui$Grid$viewCol, columns));
    });
    var $author$project$Ui$Grid$Span = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Grid$span = $author$project$Ui$Grid$Span(0);
    var $author$project$Components$HiConfirm$viewFooter = F6(function(maybeVerb, processedNoun, loading_, showCancelButton, buttonStyle_, onClose) {
        var verb_ = A2($elm$core$Maybe$withDefault, 'confirm', maybeVerb);
        var confirmButtonColOptions = showCancelButton ? _List_fromArray([
            $author$project$Ui$Grid$span(6)
        ]) : _List_fromArray([
            $author$project$Ui$Grid$span(6),
            $author$project$Ui$Grid$offset(3)
        ]);
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            showCancelButton ? A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel action'
                }, _List_fromArray([
                    $author$project$Ui$Button$fullWidth(true),
                    $author$project$Ui$Button$onClick(onClose(false))
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ]))
            ])) : $author$project$Ui$Grid$none,
            A2($author$project$Ui$Grid$column, confirmButtonColOptions, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: $author$project$Formatters$String$titleize(verb_) + (' ' + A2($elm$core$Maybe$withDefault, '', processedNoun))
                }, _List_fromArray([
                    $author$project$Ui$Button$fullWidth(true),
                    $author$project$Ui$Button$styled(A2($elm$core$Maybe$withDefault, $author$project$Components$HiConfirm$calculatebuttonStyle(maybeVerb), buttonStyle_)),
                    $author$project$Ui$Button$loading(loading_),
                    $author$project$Ui$Button$onClick(onClose(true))
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$titleize(verb_) + (' ' + A2($elm$core$Maybe$withDefault, '', processedNoun)))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$HiConfirm$viewHeader = F3(function(maybeCustomTitle, mayberVerb, maybeProcessedNoun) {
        var header = function() {
            if (!maybeCustomTitle.$) {
                var title = maybeCustomTitle.a;
                return title;
            } else {
                var _v1 = _Utils_Tuple2(mayberVerb, maybeProcessedNoun);
                if (!_v1.a.$) {
                    if (_v1.b.$ === 1) {
                        var verb_ = _v1.a.a;
                        var _v2 = _v1.b;
                        return $author$project$Formatters$String$titleize(verb_);
                    } else {
                        var verb_ = _v1.a.a;
                        var processedNoun = _v1.b.a;
                        return $author$project$Formatters$String$titleize(verb_) + (' ' + processedNoun);
                    }
                } else return 'Please Confirm';
            }
        }();
        return $author$project$Ui$Typography$headingSm(_List_fromArray([
            $elm$html$Html$text(header)
        ]));
    });
    var $author$project$Components$HiConfirm$modal = F2(function(onClose, options) {
        var optionsRecord = $author$project$Components$HiConfirm$optionsToRecord(options);
        var processedNoun = function() {
            var _v0 = _Utils_Tuple2(optionsRecord.DH, optionsRecord.zO);
            _v0$2: while(true)if (_v0.a) {
                if (!_v0.b.$) {
                    var noun_ = _v0.b.a;
                    return $elm$core$Maybe$Just($author$project$Formatters$String$titleize(noun_));
                } else break _v0$2;
            } else {
                if (!_v0.b.$) {
                    var noun_ = _v0.b.a;
                    return $elm$core$Maybe$Just(noun_);
                } else break _v0$2;
            }
            return $elm$core$Maybe$Nothing;
        }();
        return A3($author$project$Ui$Modal$view, onClose(false), _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                A3($author$project$Components$HiConfirm$viewHeader, optionsRecord.w6, optionsRecord.aba, processedNoun)
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Components$HiConfirm$viewBody, processedNoun, optionsRecord)
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A6($author$project$Components$HiConfirm$viewFooter, optionsRecord.aba, processedNoun, optionsRecord.Tk, optionsRecord.Cw, optionsRecord.vT, onClose)
            ]))
        ]));
    });
    var $author$project$Components$Admin$Athena$StepHeader$modal = function(model) {
        var _v0 = model.d0;
        if (!_v0.$) {
            var disablingRequest = _v0.a;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Admin$Athena$StepHeader$HiConfirmClosed, _List_fromArray([
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    $elm$html$Html$text('Please confirm you would like to deactivate the athenahealth integration.')
                ])),
                $author$project$Components$HiConfirm$loading(_Utils_eq(disablingRequest, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Form$NoValidate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$noValidate = $author$project$Ui$Form$NoValidate;
    var $author$project$Ui$Form$OnSubmit = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$onSubmit = $author$project$Ui$Form$OnSubmit;
    var $author$project$Ui$Padding$Left_0 = 1;
    var $author$project$Ui$Margin$Top_1 = 21;
    var $author$project$Components$Admin$Athena$StepHeader$inBreadcrumbsAs = function(step) {
        switch(step){
            case 0:
                return '';
            case 1:
                return 'Connect Account';
            case 2:
                return 'Match Locations to Departments';
            case 3:
                return 'Match Custom Fields';
            case 4:
                return 'Match Providers';
            default:
                return 'Overview';
        }
    };
    var $author$project$Ui$Form$Group$inputSpanSm = function(span) {
        return $author$project$Ui$Form$Group$InputGrid(_List_fromArray([
            'sm:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
        ]));
    };
    var $author$project$Ui$HorizontalBreadcrumb$Item = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$HorizontalBreadcrumb$item = $author$project$Ui$HorizontalBreadcrumb$Item;
    var $author$project$Ui$Form$Group$LabelClass = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$labelClass = $author$project$Ui$Form$Group$LabelClass;
    var $author$project$Ui$Form$Group$Html = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Skeleton$TextSpan = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Skeleton$spanFromText = $author$project$Ui$Skeleton$TextSpan;
    var $author$project$Ui$Form$Group$labelSkeleton = function(text) {
        return $author$project$Ui$Form$Group$Label($author$project$Ui$Form$Group$Html(_List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText(text)
            ]))
        ])));
    };
    var $author$project$Ui$Form$Group$labelSpanSm = function(span) {
        return $author$project$Ui$Form$Group$LabelGrid(_List_fromArray([
            'sm:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
        ]));
    };
    var $author$project$Ui$HorizontalBreadcrumb$Margin = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$HorizontalBreadcrumb$margin = $author$project$Ui$HorizontalBreadcrumb$Margin;
    var $author$project$Ui$HorizontalBreadcrumb$Padding = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$HorizontalBreadcrumb$padding = $author$project$Ui$HorizontalBreadcrumb$Padding;
    var $author$project$Components$Admin$Athena$StepHeader$showOnBreadcrumbs = function(step_) {
        switch(step_){
            case 0:
                return false;
            case 1:
                return true;
            case 2:
                return true;
            case 3:
                return true;
            case 4:
                return true;
            default:
                return true;
        }
    };
    var $author$project$Ui$Form$Static$optionToAttributes = function(option) {
        switch(option.$){
            case 0:
                var bool = option.a;
                return bool ? $author$project$Api$Phi$displayAttr : _List_Nil;
            case 1:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('numeric')
                ]);
            case 2:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('text-muted')
                ]);
            default:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('no-value')
                ]);
        }
    };
    var $author$project$Ui$Form$Static$optionsToAttributes = function(options) {
        return A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), A2($elm$core$List$concatMap, $author$project$Ui$Form$Static$optionToAttributes, options));
    };
    var $author$project$Ui$Form$Static$view = F2(function(options, contents) {
        return A2($elm$html$Html$p, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-control-static'), $author$project$Ui$Form$Static$optionsToAttributes(options)), contents);
    });
    var $author$project$Ui$HorizontalBreadcrumb$optionToAttributes = function(option) {
        if (!option.$) {
            var margin_ = option.a;
            return _List_fromArray([
                $author$project$Ui$Margin$toClass(margin_)
            ]);
        } else {
            var padding_ = option.a;
            return _List_fromArray([
                $author$project$Ui$Padding$toClass(padding_)
            ]);
        }
    };
    var $author$project$Ui$HorizontalBreadcrumb$optionsToAttributes = function(options) {
        return A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), A2($elm$core$List$concatMap, $author$project$Ui$HorizontalBreadcrumb$optionToAttributes, options));
    };
    var $author$project$Ui$HorizontalBreadcrumb$itemOptionToAttributes = function(option) {
        if (!option.$) {
            var bool = option.a;
            return _List_fromArray([
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('current', bool)
                ]))
            ]);
        } else {
            var bool = option.a;
            return _List_fromArray([
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('disabled', bool)
                ]))
            ]);
        }
    };
    var $author$project$Ui$HorizontalBreadcrumb$itemOptionsToAttributes = function(options) {
        return A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), A2($elm$core$List$concatMap, $author$project$Ui$HorizontalBreadcrumb$itemOptionToAttributes, options));
    };
    var $author$project$Ui$HorizontalBreadcrumb$viewItem = function(_v0) {
        var options = _v0.a;
        var contents = _v0.b;
        return A2($elm$html$Html$li, $author$project$Ui$HorizontalBreadcrumb$itemOptionsToAttributes(options), contents);
    };
    var $author$project$Ui$HorizontalBreadcrumb$view = F2(function(options, items) {
        return A2($elm$html$Html$ul, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('horizontal-breadcrumb'), $author$project$Ui$HorizontalBreadcrumb$optionsToAttributes(options)), A2($elm$core$List$map, $author$project$Ui$HorizontalBreadcrumb$viewItem, items));
    });
    var $author$project$Components$Admin$Athena$StepHeader$skeleton = function() {
        var stepToBreadcrumbSkeleton = A2($elm$core$Basics$composeR, $author$project$Components$Admin$Athena$StepHeader$inBreadcrumbsAs, A2($elm$core$Basics$composeR, $author$project$Ui$Skeleton$spanFromText, A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $author$project$Ui$Skeleton$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$HorizontalBreadcrumb$item(_List_Nil))))));
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSkeleton('Status'),
                $author$project$Ui$Form$Group$labelClass('text-left'),
                $author$project$Ui$Form$Group$labelSpanSm(1),
                $author$project$Ui$Form$Group$inputSpanSm(11)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Inactive')
                    ]))
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$HorizontalBreadcrumb$view, _List_fromArray([
                $author$project$Ui$HorizontalBreadcrumb$margin(21),
                $author$project$Ui$HorizontalBreadcrumb$padding(1)
            ]), A2($elm$core$List$map, stepToBreadcrumbSkeleton, A2($elm$core$List$filter, $author$project$Components$Admin$Athena$StepHeader$showOnBreadcrumbs, $author$project$Components$Admin$Athena$StepHeader$all)))
        ]));
    }();
    var $author$project$Components$Admin$Athena$StepHeader$Disable = {
        $: 0
    };
    var $author$project$Components$Admin$Athena$StepHeader$stringToStep = function(string) {
        switch(string){
            case 'link_practice':
                return $elm$core$Maybe$Just(1);
            case 'locations_mapping':
                return $elm$core$Maybe$Just(2);
            case 'fields_mapping':
                return $elm$core$Maybe$Just(3);
            case 'providers_mapping':
                return $elm$core$Maybe$Just(4);
            case 'completed':
                return $elm$core$Maybe$Just(5);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Ui$Margin$Left_0_5 = 10;
    var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeId = function(_v0) {
        var record = _v0;
        return record.JH;
    };
    var $author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeId(shared);
    };
    var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeName = function(_v0) {
        var record = _v0;
        return record.JI;
    };
    var $author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaPracticeName(shared);
    };
    var $author$project$Api$Provider$AthenaConfiguration$Shared$athenaProviderGroupId = function(_v0) {
        var record = _v0;
        return record.JJ;
    };
    var $author$project$Api$Provider$AthenaConfiguration$One$athenaProviderGroupId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$AthenaConfiguration$Shared$athenaProviderGroupId(shared);
    };
    var $author$project$Ui$Typography$Margin = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Ui$Typography$margin = $author$project$Ui$Typography$Margin;
    var $author$project$Components$Admin$Athena$StepHeader$viewName = function(maybeConfig) {
        if (!maybeConfig.$) {
            var config = maybeConfig.a;
            var _v1 = _Utils_Tuple2($author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeName(config), $author$project$Api$Provider$AthenaConfiguration$One$athenaProviderGroupId(config));
            if (!_v1.a.$) {
                var name = _v1.a.a;
                var maybeProviderGroupId = _v1.b;
                var practiceId = 'Practice ID: ' + A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$AthenaConfiguration$One$athenaPracticeId(config));
                var groupId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(providerGroupId) {
                    return ', Provider Group ID: ' + providerGroupId;
                }, maybeProviderGroupId));
                return A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$margin(10)
                ]), _List_fromArray([
                    $elm$html$Html$text('at ' + (name + (' (' + (practiceId + (groupId + ')')))))
                ]));
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Badge$formatLabel = function(label) {
        switch(label){
            case 'needs_payment_info':
                return 'no payment info';
            case 'bank_not_verified':
                return 'bank not verified';
            case 'saving':
                return 'saving...';
            case 'refund_pending':
                return 'refund processing';
            case 'refund_cancelled':
                return 'refund cancelled';
            case 'refund_actually_pending':
                return 'refund pending';
            case 'refund_successful':
                return 'refunded';
            case 'refund_failed':
                return 'refund failed';
            case 'refund_unattempted':
                return 'refund unattempted';
            case 'new_payment_source':
                return 'new';
            case 'needs_trial_deposits':
                return 'unverified';
            case 'not_redeemable':
                return 'not redeemable';
            case 'bad_debt':
                return 'bad debt';
            case 'no_payment':
                return 'no payment';
            case 'accepted_and_outdated':
                return 'out of date';
            case 'not_accepted':
                return 'not accepted';
            case 'scheduled_without_source':
                return 'scheduled';
            case 'review_data_matches':
                return 'review data matches';
            case 'review_file_size':
                return 'review file size';
            case 'enqueued_for_preprocessing':
                return 'enqueued';
            case 'enqueued_for_processing':
                return 'enqueued';
            case 'preprocessing':
                return 'processing';
            case 'postprocessing':
                return 'processing';
            case 'ready_to_preprocess':
                return 'enqueued';
            case 'ready_to_process':
                return 'ready to process';
            case 'deal_ending':
                return 'ending';
            case 'unpublished_change':
                return 'unpublished change';
            case 'failed_payment':
                return 'failed payment';
            case 'in_development':
                return 'in development';
            default:
                return label;
        }
    };
    var $author$project$Ui$Badge$Color = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Badge$Danger = 3;
    var $author$project$Ui$Badge$danger = $author$project$Ui$Badge$Color(3);
    var $author$project$Ui$Badge$Info = 1;
    var $author$project$Ui$Badge$info = $author$project$Ui$Badge$Color(1);
    var $author$project$Ui$Badge$Primary = 4;
    var $author$project$Ui$Badge$primary = $author$project$Ui$Badge$Color(4);
    var $author$project$Ui$Badge$Success = 2;
    var $author$project$Ui$Badge$success = $author$project$Ui$Badge$Color(2);
    var $author$project$Ui$Badge$Warning = 0;
    var $author$project$Ui$Badge$warning = $author$project$Ui$Badge$Color(0);
    var $author$project$Ui$Badge$mapColor = function(status) {
        switch(status){
            case 'needs_payment_info':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'pending':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'downloading':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'bank_not_verified':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'successful':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'live':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'failed':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'refunded':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'retrying':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'cancelled':
                return _List_Nil;
            case 'default':
                return _List_fromArray([
                    $author$project$Ui$Badge$primary
                ]);
            case 'saving':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'refund_pending':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'refund_actually_pending':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'refund_successful':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'refund_failed':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'active':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'unconfirmed':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'confirmed':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'warning':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'new_payment_source':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'needs_trial_deposits':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'invalid':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'inactive':
                return _List_Nil;
            case 'expiring':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'connected':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'requested':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'unpaid':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'paid':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'clearing':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'processing':
                return _List_fromArray([
                    $author$project$Ui$Badge$primary
                ]);
            case 'redeemable':
                return _List_fromArray([
                    $author$project$Ui$Badge$primary
                ]);
            case 'not_redeemable':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'viewed':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'bad_debt':
                return _List_Nil;
            case 'disputed':
                return _List_Nil;
            case 'overdue':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'sent':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'issued':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'no_payment':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'missing':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'accepted':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'accepted_and_outdated':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'not_accepted':
                return _List_Nil;
            case 'none':
                return _List_Nil;
            case 'scheduled':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'scheduled_without_source':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'in transit':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'completed':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'enabled':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'synced':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'unsynced':
                return _List_Nil;
            case 'errored':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'opened':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'error':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'processed':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'review_data_matches':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'review_file_size':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'enqueued_for_preprocessing':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'enqueued_for_processing':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'preprocessing':
                return _List_fromArray([
                    $author$project$Ui$Badge$primary
                ]);
            case 'postprocessing':
                return _List_fromArray([
                    $author$project$Ui$Badge$primary
                ]);
            case 'ready_to_preprocess':
                return _List_fromArray([
                    $author$project$Ui$Badge$primary
                ]);
            case 'ready_to_process':
                return _List_fromArray([
                    $author$project$Ui$Badge$primary
                ]);
            case 'payable':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'deal_ending':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'published':
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 'unpublished':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'unpublished_change':
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 'upcoming':
                return _List_fromArray([
                    $author$project$Ui$Badge$info
                ]);
            case 'failed_payment':
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            case 'in_development':
                return _List_Nil;
            default:
                return _List_Nil;
        }
    };
    var $author$project$Ui$Badge$optionToAttr = function(option) {
        switch(option.$){
            case 0:
                return $elm$html$Html$Attributes$class('badge--inline');
            case 1:
                return $elm$html$Html$Attributes$class('badge--lg');
            case 2:
                return $elm$html$Html$Attributes$class('badge--sm');
            case 5:
                return $elm$html$Html$Attributes$class('mr-2');
            case 3:
                var testString = option.a;
                return $author$project$Utils$Html$Attributes$test(testString);
            default:
                var color = option.a;
                switch(color){
                    case 0:
                        return $elm$html$Html$Attributes$class('badge--warning');
                    case 1:
                        return $elm$html$Html$Attributes$class('badge--info');
                    case 2:
                        return $elm$html$Html$Attributes$class('badge--success');
                    case 3:
                        return $elm$html$Html$Attributes$class('badge--danger');
                    case 4:
                        return $elm$html$Html$Attributes$class('badge--primary');
                    case 5:
                        return $elm$html$Html$Attributes$class('badge--neutral');
                    case 6:
                        return $elm$html$Html$Attributes$class('badge--accent-primary');
                    default:
                        return $elm$html$Html$Attributes$class('badge--accent-secondary');
                }
        }
    };
    var $author$project$Ui$Badge$view = F2(function(options, content) {
        return function(attrs) {
            return A2($elm$html$Html$span, attrs, content);
        }(A2($elm$core$List$cons, $elm$html$Html$Attributes$class('badge'), A2($elm$core$List$map, $author$project$Ui$Badge$optionToAttr, options)));
    });
    var $author$project$Ui$Badge$fromString = F2(function(options, label) {
        return function(options_) {
            return A2($author$project$Ui$Badge$view, options_, _List_fromArray([
                $elm$html$Html$text($author$project$Ui$Badge$formatLabel(label))
            ]));
        }(_Utils_ap(options, $author$project$Ui$Badge$mapColor(label)));
    });
    var $author$project$Components$Admin$Athena$StepHeader$viewStatus = F2(function(status, content) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Status'),
            $author$project$Ui$Form$Group$labelClass('text-label-md text-muted'),
            $author$project$Ui$Form$Group$labelSpanSm(1),
            $author$project$Ui$Form$Group$inputSpanSm(11)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Badge$fromString, _List_Nil, status), content))
        ]));
    });
    var $author$project$Components$Admin$Athena$StepHeader$breadcrumbsDisabled = function(step) {
        switch(step){
            case 0:
                return false;
            case 1:
                return true;
            case 2:
                return false;
            case 3:
                return false;
            case 4:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Ui$HorizontalBreadcrumb$Current = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$HorizontalBreadcrumb$current = $author$project$Ui$HorizontalBreadcrumb$Current;
    var $author$project$Ui$HorizontalBreadcrumb$Disabled = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$HorizontalBreadcrumb$disabled = $author$project$Ui$HorizontalBreadcrumb$Disabled;
    var $author$project$Components$Admin$Athena$StepHeader$stepIsDisabled = F3(function(setupSubstateStep, currentStep, step) {
        var minStepIndex = _Utils_cmp($author$project$Components$Admin$Athena$StepHeader$stepIndex(currentStep), $author$project$Components$Admin$Athena$StepHeader$stepIndex(setupSubstateStep)) > 0 ? $author$project$Components$Admin$Athena$StepHeader$stepIndex(currentStep) : $author$project$Components$Admin$Athena$StepHeader$stepIndex(setupSubstateStep);
        return $author$project$Components$Admin$Athena$StepHeader$breadcrumbsDisabled(step) || _Utils_cmp(minStepIndex, $author$project$Components$Admin$Athena$StepHeader$stepIndex(step)) < 0;
    });
    var $author$project$Components$Admin$Athena$StepHeader$viewStepBreadcrumb = F3(function(setupSubstateStep, currentStep, step) {
        var isCurrent = _Utils_eq(step, currentStep);
        return A2($author$project$Ui$HorizontalBreadcrumb$item, _List_fromArray([
            $author$project$Ui$HorizontalBreadcrumb$current(isCurrent),
            $author$project$Ui$HorizontalBreadcrumb$disabled($author$project$Components$Admin$Athena$StepHeader$breadcrumbsDisabled(step))
        ]), _List_fromArray([
            isCurrent || A3($author$project$Components$Admin$Athena$StepHeader$stepIsDisabled, setupSubstateStep, currentStep, step) ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Admin$Athena$StepHeader$inBreadcrumbsAs(step))
            ])) : A3($author$project$Ui$Link$route, $author$project$Components$Admin$Athena$StepHeader$stepRoute(step), _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Admin$Athena$StepHeader$inBreadcrumbsAs(step))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Athena$StepHeader$view = F2(function(athenahealthConfiguration, model) {
        var athenahealthConfiguration_ = $author$project$Api$Data$toMaybe(athenahealthConfiguration);
        var practiceNameAndIds = $author$project$Components$Admin$Athena$StepHeader$viewName(athenahealthConfiguration_);
        var setupSubstateStep = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Components$Admin$Athena$StepHeader$stringToStep, A2($elm$core$Maybe$map, $author$project$Api$Provider$AthenaConfiguration$One$setupSubstate, athenahealthConfiguration_)));
        var status = A2($elm$core$Maybe$withDefault, 'pending', A2($elm$core$Maybe$map, $author$project$Api$Provider$AthenaConfiguration$One$status, athenahealthConfiguration_));
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Components$Admin$Athena$StepHeader$viewStatus, status, _List_fromArray([
                practiceNameAndIds,
                $author$project$Utils$Maybe$toBool(athenahealthConfiguration_) ? A3($author$project$Ui$Button$view, {
                    abP: 'Deativate integration'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Athena$StepHeader$Disable),
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$pull(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Deactivate the integration')
                ])) : $author$project$Utils$Html$empty
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$HorizontalBreadcrumb$view, _List_fromArray([
                $author$project$Ui$HorizontalBreadcrumb$margin(21),
                $author$project$Ui$HorizontalBreadcrumb$padding(1)
            ]), A2($elm$core$List$map, A2($author$project$Components$Admin$Athena$StepHeader$viewStepBreadcrumb, setupSubstateStep, model.E1), A2($elm$core$List$filter, $author$project$Components$Admin$Athena$StepHeader$showOnBreadcrumbs, $author$project$Components$Admin$Athena$StepHeader$all))),
            A2($elm$html$Html$br, _List_Nil, _List_Nil)
        ]));
    });
    var $elm$html$Html$Attributes$novalidate = $elm$html$Html$Attributes$boolProperty('noValidate');
    var $author$project$Ui$Form$defaultOptions = {
        vG: true,
        x8: false,
        yf: false,
        zN: false,
        z2: $elm$core$Maybe$Nothing,
        CD: false
    };
    var $author$project$Ui$Form$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    return _Utils_update(record, {
                        x8: true
                    });
                case 4:
                    return _Utils_update(record, {
                        yf: true
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(record, {
                        zN: bool
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vG: bool
                    });
                case 3:
                    var msg = option.a;
                    return _Utils_update(record, {
                        z2: $elm$core$Maybe$Just(msg)
                    });
                default:
                    return _Utils_update(record, {
                        CD: true
                    });
            }
        }), $author$project$Ui$Form$defaultOptions, options);
    };
    var $author$project$Ui$Form$view = F2(function(options, contents) {
        var optionsRecord = $author$project$Ui$Form$optionsToRecord(options);
        return A2($elm$html$Html$form, A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
            _Utils_Tuple2('form-horizontal', optionsRecord.x8),
            _Utils_Tuple2('form-inline', optionsRecord.yf),
            _Utils_Tuple2('form-signup', optionsRecord.CD)
        ])), A2($elm$core$List$cons, $elm$html$Html$Attributes$novalidate(optionsRecord.zN), A2($elm$core$List$cons, $elm$html$Html$Attributes$autocomplete(optionsRecord.vG), function() {
            var _v0 = optionsRecord.z2;
            if (!_v0.$) {
                var onSubmit_ = _v0.a;
                return _List_fromArray([
                    $elm$html$Html$Events$onSubmit(onSubmit_)
                ]);
            } else return _List_Nil;
        }()))), contents);
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$RefreshAthenaCustomFields = {
        $: 5
    };
    var $author$project$Ui$Grid$Element = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Element$Alignment = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Alignment$End = 2;
    var $author$project$Ui$Alignment$Items = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Alignment$itemsEnd = $author$project$Ui$Alignment$Items(2);
    var $author$project$Ui$Element$itemsEnd = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsEnd);
    var $author$project$Ui$Grid$justifyRight = $author$project$Ui$Grid$Element($author$project$Ui$Element$itemsEnd);
    var $author$project$Ui$Icon$Repeat = 44;
    var $author$project$Ui$Icon$repeat = $author$project$Ui$Icon$viewIcon(44);
    var $author$project$Ui$ScreenSize$Lg = 3;
    var $author$project$Ui$Grid$spanLg = $author$project$Ui$Grid$Span(3);
    var $author$project$Ui$ScreenSize$Md = 2;
    var $author$project$Ui$Grid$spanMd = $author$project$Ui$Grid$Span(2);
    var $author$project$Ui$ScreenSize$Sm = 1;
    var $author$project$Ui$Grid$spanSm = $author$project$Ui$Grid$Span(1);
    var $author$project$Pages$Admin$Athenahealth$Fields$UpdateFieldMapping = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Icon$ArrowRight = 61;
    var $author$project$Ui$Icon$arrowRight = $author$project$Ui$Icon$viewIcon(61);
    var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$externalId = function(_v0) {
        var record = _v0;
        return record.adE;
    };
    var $author$project$Api$Provider$Integration$Athena$CustomField$All$externalId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$CustomField$Shared$externalId(shared);
    };
    var $author$project$Ui$Form$Select$ItemDisabled = $elm$core$Basics$identity;
    var $author$project$Ui$Form$Select$itemDisabled = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$CustomField$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Integration$Athena$CustomField$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$CustomField$Shared$name(shared);
    };
    var $author$project$Ui$Form$Select$Item = F3(function(a, b, c) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Select$option = $author$project$Ui$Form$Select$Item;
    var $author$project$Pages$Admin$Athenahealth$Fields$athenaCustomFieldsOptions = function(athenaCustomFields) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_fromArray([
            $author$project$Ui$Form$Select$itemDisabled(true)
        ]), $elm$core$Maybe$Nothing, 'Choose athenahealth Custom Field'), A2($elm$core$List$map, function(athenaCustomField) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Integration$Athena$CustomField$All$externalId(athenaCustomField)), $author$project$Api$Provider$Integration$Athena$CustomField$All$name(athenaCustomField) + (' (' + ($author$project$Api$Provider$Integration$Athena$CustomField$All$externalId(athenaCustomField) + ')')));
        }, athenaCustomFields));
    };
    var $author$project$Ui$Form$Select$OnChange = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$onChange = $author$project$Ui$Form$Select$OnChange;
    var $author$project$Ui$Form$Select$Value = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$value = $author$project$Ui$Form$Select$Value;
    var $author$project$Ui$Spinner$Size = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Types$Xs = 0;
    var $author$project$Ui$Spinner$extraSmall = $author$project$Ui$Spinner$Size(0);
    var $author$project$Ui$Form$Select$defaultOptions = {
        EP: _List_Nil,
        d$: false,
        fK: _List_Nil,
        xW: false,
        yf: false,
        q2: false,
        Tk: false,
        afv: $elm$core$Maybe$Nothing,
        aa9: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Form$Select$updateOptionsRecord = F2(function(option_, options) {
        switch(option_.$){
            case 1:
                var bool = option_.a;
                return _Utils_update(options, {
                    d$: bool
                });
            case 0:
                var maybeSelected = option_.a;
                return _Utils_update(options, {
                    aa9: maybeSelected
                });
            case 2:
                var bool = option_.a;
                return _Utils_update(options, {
                    q2: bool
                });
            case 3:
                var bool = option_.a;
                return _Utils_update(options, {
                    Tk: bool
                });
            case 4:
                var list = option_.a;
                return _Utils_update(options, {
                    fK: list
                });
            case 5:
                var string = option_.a;
                return _Utils_update(options, {
                    EP: A2($elm$core$List$cons, string, options.EP)
                });
            case 6:
                var toMsg = option_.a;
                return _Utils_update(options, {
                    afv: $elm$core$Maybe$Just(toMsg)
                });
            case 7:
                var size_ = option_.a;
                switch(size_){
                    case 0:
                        return _Utils_update(options, {
                            EP: A2($elm$core$List$cons, 'input-xs', options.EP)
                        });
                    case 1:
                        return _Utils_update(options, {
                            EP: A2($elm$core$List$cons, 'input-sm', options.EP)
                        });
                    case 2:
                        return _Utils_update(options, {
                            EP: A2($elm$core$List$cons, 'input-md', options.EP)
                        });
                    default:
                        return _Utils_update(options, {
                            EP: A2($elm$core$List$cons, 'input-lg', options.EP)
                        });
                }
            case 8:
                return _Utils_update(options, {
                    yf: true
                });
            default:
                var bool = option_.a;
                return _Utils_update(options, {
                    xW: bool
                });
        }
    });
    var $author$project$Ui$Form$Select$optionsListToRecord = function(optionsList) {
        return A3($elm$core$List$foldl, $author$project$Ui$Form$Select$updateOptionsRecord, $author$project$Ui$Form$Select$defaultOptions, optionsList);
    };
    var $elm$html$Html$select = _VirtualDom_node('select');
    var $author$project$Ui$Form$Select$itemAttributes = function(options) {
        var disabledAttr = options.d$ ? _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'disabled', 'disabled')
        ]) : _List_Nil;
        return A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
            _Utils_Tuple2('disabled', options.d$)
        ])), disabledAttr);
    };
    var $author$project$Ui$Form$Select$defaultItemOptions = {
        d$: false
    };
    var $author$project$Ui$Form$Select$itemOptionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option_, record) {
            var bool = option_;
            return _Utils_update(record, {
                d$: bool
            });
        }), $author$project$Ui$Form$Select$defaultItemOptions, options);
    };
    var $elm$html$Html$optgroup = _VirtualDom_node('optgroup');
    var $elm$html$Html$option = _VirtualDom_node('option');
    var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
    var $author$project$Ui$Form$Select$viewItem = F2(function(currentValue, item_) {
        if (!item_.$) {
            var label_ = item_.a;
            var items = item_.b;
            return A2($elm$html$Html$optgroup, _List_fromArray([
                A2($elm$html$Html$Attributes$attribute, 'label', label_)
            ]), A2($elm$core$List$map, $author$project$Ui$Form$Select$viewItem(currentValue), items));
        } else {
            var options = item_.a;
            var value_ = item_.b;
            var label_ = item_.c;
            var optionsRecord = $author$project$Ui$Form$Select$itemOptionsToRecord(options);
            return A2($elm$html$Html$option, A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'label', label_), A2($elm$core$List$cons, $elm$html$Html$Attributes$selected(_Utils_eq(currentValue, value_)), A2($elm$core$List$cons, $elm$html$Html$Attributes$value(A2($elm$core$Maybe$withDefault, '', value_)), $author$project$Ui$Form$Select$itemAttributes(optionsRecord)))), _List_fromArray([
                $elm$html$Html$text(label_)
            ]));
        }
    });
    var $author$project$Ui$Form$Select$view = F2(function(options, items) {
        var optionsRecord = $author$project$Ui$Form$Select$optionsListToRecord(options);
        var errorDescription = $elm$core$List$isEmpty(optionsRecord.fK) ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-describedby', A2($elm$core$String$join, '. ', optionsRecord.fK))
        ]);
        var ariaInvalid = optionsRecord.q2 ? _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
        ]) : _List_Nil;
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('input-wrapper'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('inline-block', optionsRecord.yf)
            ]))
        ]), _List_fromArray([
            A2($elm$html$Html$select, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-control'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', optionsRecord.EP)), A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(optionsRecord.Tk || optionsRecord.d$), A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('disabled', optionsRecord.Tk || optionsRecord.d$),
                _Utils_Tuple2('feedback-errored', optionsRecord.q2)
            ])), _Utils_ap(function() {
                var _v0 = optionsRecord.afv;
                if (!_v0.$) {
                    var toMsg = _v0.a;
                    return _List_fromArray([
                        $elm$html$Html$Events$onInput(toMsg)
                    ]);
                } else return _List_Nil;
            }(), _Utils_ap(errorDescription, ariaInvalid)))))), A2($elm$core$List$map, $author$project$Ui$Form$Select$viewItem(optionsRecord.aa9), items)),
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('new-dropdown__trigger__chevron')
            ]), _List_fromArray([
                $author$project$Ui$Icon$chevronDown(_List_fromArray([
                    $author$project$Ui$Icon$xs,
                    $author$project$Ui$Icon$info
                ]))
            ])),
            optionsRecord.Tk ? $author$project$Ui$Spinner$view(_List_fromArray([
                $author$project$Ui$Spinner$extraSmall
            ])) : $author$project$Utils$Html$empty,
            optionsRecord.xW ? $author$project$Utils$Html$empty : $author$project$Utils$FormErrors$view(optionsRecord.fK)
        ]));
    });
    var $author$project$Pages$Admin$Athenahealth$Fields$viewAthenaFieldMapping = F2(function(athenaCustomFields, athenaFieldMapping) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    $elm$html$Html$text('Hint data point: '),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text(athenaFieldMapping.zr)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(1)
                ]), _List_fromArray([
                    $author$project$Ui$Icon$arrowRight(_List_Nil)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('athenahealth custom field: ')
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value(athenaFieldMapping.adE),
                        $author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$Athenahealth$Fields$UpdateFieldMapping(athenaFieldMapping))
                    ]), $author$project$Pages$Admin$Athenahealth$Fields$athenaCustomFieldsOptions(athenaCustomFields))
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Ui$Skeleton$input = $author$project$Ui$Skeleton$view('input');
    var $author$project$Ui$Grid$RowElement = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Alignment$FlexCenter = 1;
    var $author$project$Ui$Alignment$itemsCenter = $author$project$Ui$Alignment$Items(1);
    var $author$project$Ui$Element$itemsCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsCenter);
    var $author$project$Ui$Grid$rowItemsCenter = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$itemsCenter);
    var $author$project$Ui$Skeleton$spanMd = $author$project$Ui$Skeleton$Span(2);
    var $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsListSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$repeat, 10, A2($author$project$Ui$Grid$row, _List_fromArray([
        $author$project$Ui$Grid$rowItemsCenter
    ]), _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(6)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Hint data point: ')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(8),
                    $author$project$Ui$Skeleton$spanMd(4)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(1)
        ]), _List_Nil),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(2)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('athenahealth custom field: ')
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(3)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ]))
    ]))));
    var $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStep = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(9),
                    $author$project$Ui$Grid$spanMd(8),
                    $author$project$Ui$Grid$spanSm(7)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Match Custom Fields')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text("We will sync information about each patient\u2019s membership to athenahealth in custom fields.  You will need to configure these custom fields in athenahealth first, and then return to this page once complete.")
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(3),
                    $author$project$Ui$Grid$spanMd(4),
                    $author$project$Ui$Grid$spanSm(5),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Refresh athenahealth Custom Fields'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Fields$RefreshAthenaCustomFields),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Refresh athenahealth Custom Fields')
                    ]))
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            function() {
                var _v0 = model.k5;
                if (_v0.$ === 3) {
                    var athenaCustomFields = _v0.a;
                    return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Admin$Athenahealth$Fields$viewAthenaFieldMapping(athenaCustomFields), model.cB));
                } else return $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsListSkeleton;
            }()
        ]));
    };
    var $author$project$Ui$Button$Disabled = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Button$disabled = $author$project$Ui$Button$Disabled;
    var $author$project$Ui$Panel$Footer = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Panel$footer = $author$project$Ui$Panel$Footer;
    var $author$project$Ui$Alignment$Content = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Alignment$justifyCenter = $author$project$Ui$Alignment$Content(1);
    var $author$project$Ui$Element$justifyCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$justifyCenter);
    var $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStepFooter = function(model) {
        var canContinue = !A2($elm$core$List$any, function(athenaFieldMapping) {
            return _Utils_eq(athenaFieldMapping.adE, $elm$core$Maybe$Nothing);
        }, model.cB);
        return A2($author$project$Ui$Panel$footer, _List_fromArray([
            $author$project$Ui$Element$justifyCenter
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Go to next step'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Fields$CompleteFields),
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$disabled(!canContinue)
            ]), _List_fromArray([
                $elm$html$Html$text('Next Step')
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStepSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(9),
                $author$project$Ui$Grid$spanMd(8),
                $author$project$Ui$Grid$spanSm(7)
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Match Custom Fields')
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(11)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(3),
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$spanSm(5),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Refresh athenahealth Custom Fields')
                ]))
            ]))
        ])),
        $author$project$Ui$HorizontalRule$view(_List_Nil),
        $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsListSkeleton
    ]));
    var $author$project$Pages$Admin$Athenahealth$Fields$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$modal(model.kl)),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Fields$CompleteFields)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('athenahealth')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, function() {
                            var _v0 = model.k4;
                            if (_v0.$ === 3) return _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Fields$StepHeaderMsg, A2($author$project$Components$Admin$Athena$StepHeader$view, model.k4, model.kl)),
                                $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStep(model)
                            ]);
                            else return _List_fromArray([
                                $author$project$Components$Admin$Athena$StepHeader$skeleton,
                                $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStepSkeleton
                            ]);
                        }()),
                        $author$project$Pages$Admin$Athenahealth$Fields$viewFieldsStepFooter(model)
                    ]))
                ]))
            ]),
            $2: 'Integrations | Athenahealth'
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Fields$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Athenahealth$Fields$init,
        aeR: $author$project$Pages$Admin$Athenahealth$Fields$load,
        ag3: $author$project$Pages$Admin$Athenahealth$Fields$save,
        ahE: $author$project$Pages$Admin$Athenahealth$Fields$subscriptions,
        aaO: $author$project$Pages$Admin$Athenahealth$Fields$update,
        aid: $author$project$Pages$Admin$Athenahealth$Fields$view
    });
    var $author$project$Pages$Admin$Athenahealth$Link$GotAthena = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Link$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            k4: $author$project$Api$Data$Loading,
            PU: $elm$core$Maybe$Nothing,
            j_: $author$project$Api$Data$NotAsked,
            kl: $author$project$Components$Admin$Athena$StepHeader$init(1)
        }, A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.Ej, $author$project$Pages$Admin$Athenahealth$Link$GotAthena));
    });
    var $author$project$Pages$Admin$Athenahealth$Link$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Athenahealth$Link$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Link$subscriptions = function(_v0) {
        var stepHeader = _v0.kl;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
    };
    var $author$project$Pages$Admin$Athenahealth$Link$Linked = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Athena$link = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('athena_integration', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('athena_practice_id', $elm$json$Json$Encode$int(fields.JH)),
                _Utils_Tuple2('athena_provider_group_id', $elm$json$Json$Encode$int(fields.JJ))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$AthenaConfiguration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'link'
        ]), $author$project$Api$Provider$Integration$Athena$athenaPath))));
    });
    var $author$project$Pages$Admin$Athenahealth$Link$createAthena = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Integration$Athena$link, apiClient, {
            JH: A2($elm$core$Maybe$withDefault, 0, fields.JH),
            JJ: A2($elm$core$Maybe$withDefault, 0, fields.JJ)
        }, $author$project$Pages$Admin$Athenahealth$Link$Linked);
    });
    var $author$project$Pages$Admin$Athenahealth$Link$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                JH: $elm$core$String$toInt(string)
            });
        } else {
            var string = field.a;
            return _Utils_update(fields, {
                JJ: $elm$core$String$toInt(string)
            });
        }
    });
    var $author$project$Pages$Admin$Athenahealth$Link$AthenaPracticeIdValidation = 0;
    var $rtfeldman$elm_validate$Validate$ifTrue = F2(function(test, error) {
        var getErrors = function(subject) {
            return test(subject) ? _List_fromArray([
                error
            ]) : _List_Nil;
        };
        return getErrors;
    });
    var $rtfeldman$elm_validate$Validate$ifNothing = F2(function(subjectToMaybe, error) {
        return A2($rtfeldman$elm_validate$Validate$ifTrue, function(subject) {
            return _Utils_eq(subjectToMaybe(subject), $elm$core$Maybe$Nothing);
        }, error);
    });
    var $author$project$Api$Provider$AthenaConfiguration$Shared$scopedByProviderGroup = function(_v0) {
        var record = _v0;
        return record.Zz;
    };
    var $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$AthenaConfiguration$Shared$scopedByProviderGroup(shared);
    };
    var $author$project$Pages$Admin$Athenahealth$Link$AthenaProviderGroupIdValidation = 1;
    var $author$project$Pages$Admin$Athenahealth$Link$validateProviderGroupId = F2(function(isRequired, _v0) {
        var athenaProviderGroupId = _v0.JJ;
        return isRequired && !$author$project$Utils$Maybe$toBool(athenaProviderGroupId) ? _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a provider group id')
        ]) : _List_Nil;
    });
    var $author$project$Pages$Admin$Athenahealth$Link$formFieldsValidator = function(model) {
        var providerGroupRequired = function() {
            var _v0 = model.k4;
            if (_v0.$ === 3) {
                var config = _v0.a;
                return $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup(config);
            } else return false;
        }();
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.JH;
            }, _Utils_Tuple2(0, 'Please enter a practice id')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Athenahealth$Link$validateProviderGroupId(providerGroupRequired))
        ]));
    };
    var $author$project$Pages$Admin$Athenahealth$Link$formFieldsInit = {
        JH: $elm$core$Maybe$Nothing,
        JJ: $elm$core$Maybe$Nothing
    };
    var $author$project$Pages$Admin$Athenahealth$Link$setIntegration = F2(function(athenaConfiguration, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            k4: athenaConfiguration,
            PU: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Pages$Admin$Athenahealth$Link$formFieldsInit))
        }), A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 1));
    });
    var $author$project$Pages$Admin$Athenahealth$Link$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Admin$Athenahealth$Link$setIntegration, response, model));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Admin$Athenahealth$Link$setIntegration, response, model));
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    k4: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var field = msg.a;
                var _v3 = model.PU;
                if (!_v3.$) {
                    var form = _v3.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Athenahealth$Link$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var _v4 = model.PU;
                if (!_v4.$) {
                    var form = _v4.a;
                    var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Athenahealth$Link$formFieldsValidator(model), form);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var newForm = _v6.a;
                        var validFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$Loading
                        }), A2($author$project$Pages$Admin$Athenahealth$Link$createAthena, model.Ej, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v5.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations), _List_Nil);
                else {
                    var _v8 = model.PU;
                    if (!_v8.$) {
                        var form = _v8.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(form),
                            j_: response
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            default:
                var subMsg = msg.a;
                var _v9 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.Ej, subMsg, model.kl);
                var stepHeader = _v9.a;
                var subCmd = _v9.b;
                var subOutMsg = _v9.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    kl: stepHeader
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Admin$Athenahealth$Link$Save = {
        $: 2
    };
    var $author$project$Pages$Admin$Athenahealth$Link$AthenaPracticeId = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Link$AthenaProviderGroupId = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Link$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$AutoComplete = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$autoComplete = $author$project$Ui$Form$Input$AutoComplete;
    var $author$project$Ui$Form$Input$CustomAttributes = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$customAttributes = $author$project$Ui$Form$Input$CustomAttributes;
    var $author$project$Ui$Form$Input$Errors = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$errors = $author$project$Ui$Form$Input$Errors;
    var $author$project$Utils$Form$hasValidationErrors = F2(function(validationGroup, form) {
        return !$elm$core$List$isEmpty(A2($author$project$Utils$Form$validationErrors, validationGroup, form));
    });
    var $author$project$Ui$Form$Input$Invalid = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$invalid = $author$project$Ui$Form$Input$Invalid;
    var $author$project$Ui$Form$Input$Placeholder = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$placeholder = $author$project$Ui$Form$Input$Placeholder;
    var $author$project$Ui$Form$Group$Required = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$required = $author$project$Ui$Form$Group$Required;
    var $author$project$Pages$Admin$Athenahealth$Link$viewConfigureInfo = A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Please enter your athenahealth practice ID. This ID can be found by logging into athenahealth, and clicking on your username in the top right. '),
        $elm$html$Html$text("A dropdown will appear with a \u201CPRACTICE\u201D section. Your ID is next to your Practice name in parenthesis.")
    ]));
    var $author$project$Pages$Admin$Athenahealth$Link$viewLinkStep = F3(function(saveRequest, athenaConfig, form) {
        var scopedByProviderGroup = function() {
            if (athenaConfig.$ === 3) {
                var config = athenaConfig.a;
                return $author$project$Api$Provider$AthenaConfiguration$One$scopedByProviderGroup(config);
            } else return false;
        }();
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Connect athenahealth Account')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Pages$Admin$Athenahealth$Link$viewConfigureInfo,
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.JH))),
                    $author$project$Ui$Form$Input$autoComplete(false),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$placeholder('Enter athenahealth Practice ID'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Athenahealth$Link$FormUpdated, $author$project$Pages$Admin$Athenahealth$Link$AthenaPracticeId)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ])),
                scopedByProviderGroup ? $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.JJ))),
                    $author$project$Ui$Form$Input$autoComplete(false),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$customAttributes(_List_fromArray([
                        $elm$html$Html$Attributes$class('mt-2')
                    ])),
                    $author$project$Ui$Form$Input$placeholder('Enter athenahealth Provider Group ID'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Athenahealth$Link$FormUpdated, $author$project$Pages$Admin$Athenahealth$Link$AthenaProviderGroupId)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ])) : $author$project$Utils$Html$empty,
                function() {
                    if (saveRequest.$ === 2) return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('We do not have access yet to your Athena practice. Please make sure you have sign the Authorization & Consent form on the Athena side. If you see this message for more than a few days, please contact us.')
                        ]))
                    ]));
                    else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Athenahealth$Link$viewLinkStepFooter = function(saveRequest) {
        return A2($author$project$Ui$Panel$footer, _List_fromArray([
            $author$project$Ui$Element$justifyCenter
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Got to next step'
            }, _List_fromArray([
                $author$project$Ui$Button$submit,
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
            ]), _List_fromArray([
                $elm$html$Html$text('Next Step')
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Athenahealth$Link$viewLinkStepSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        $author$project$Ui$Typography$headingSm(_List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Connect athenahealth Account')
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_Nil)
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_Nil)
            ])),
            $author$project$Ui$Skeleton$input(_List_Nil)
        ]))
    ]));
    var $author$project$Pages$Admin$Athenahealth$Link$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$modal(model.kl)),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Link$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('athenahealth')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, function() {
                            var _v0 = model.k4;
                            if (_v0.$ === 1) return _List_fromArray([
                                $author$project$Components$Admin$Athena$StepHeader$skeleton,
                                $author$project$Pages$Admin$Athenahealth$Link$viewLinkStepSkeleton
                            ]);
                            else return _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Link$StepHeaderMsg, A2($author$project$Components$Admin$Athena$StepHeader$view, model.k4, model.kl)),
                                function() {
                                    var _v1 = model.PU;
                                    if (!_v1.$) {
                                        var form = _v1.a;
                                        return A3($author$project$Pages$Admin$Athenahealth$Link$viewLinkStep, model.j_, model.k4, form);
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ]);
                        }()),
                        $author$project$Pages$Admin$Athenahealth$Link$viewLinkStepFooter(model.j_)
                    ]))
                ]))
            ]),
            $2: 'Integrations | Athenahealth'
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Link$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Athenahealth$Link$init,
        aeR: $author$project$Pages$Admin$Athenahealth$Link$load,
        ag3: $author$project$Pages$Admin$Athenahealth$Link$save,
        ahE: $author$project$Pages$Admin$Athenahealth$Link$subscriptions,
        aaO: $author$project$Pages$Admin$Athenahealth$Link$update,
        aid: $author$project$Pages$Admin$Athenahealth$Link$view
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$GotAthena = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
    var $elm$core$Set$empty = $elm$core$Dict$empty;
    var $author$project$Pages$Admin$Athenahealth$Locations$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            k4: $author$project$Api$Data$Loading,
            k6: $author$project$Api$Data$NotAsked,
            hA: $author$project$Api$Data$NotAsked,
            iz: $elm$core$Set$empty,
            j_: $author$project$Api$Data$NotAsked,
            kl: $author$project$Components$Admin$Athena$StepHeader$init(2)
        }, A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.Ej, $author$project$Pages$Admin$Athenahealth$Locations$GotAthena(true)));
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$subscriptions = function(_v0) {
        var stepHeader = _v0.kl;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaConfigured = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaDepartments = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaLocationMappings = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$GotLocationMapping = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Athena$configure = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$AthenaConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'configure'
        ]), $author$project$Api$Provider$Integration$Athena$athenaPath)));
    });
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$id(shared);
    };
    var $elm$core$Set$insert = F2(function(key, _v0) {
        var dict = _v0;
        return A3($elm$core$Dict$insert, key, 0, dict);
    });
    var $author$project$Api$Provider$Integration$Athena$Department$All$Department = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$Department$Shared$Department = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$Department$Shared$Record = F3(function(id, name, providerGroup) {
        return {
            aef: id,
            zr: name,
            XI: providerGroup
        };
    });
    var $author$project$Api$Provider$Integration$Athena$Department$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'provider_group', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$Department$Shared$Record))));
    var $author$project$Api$Provider$Integration$Athena$Department$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$Department$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$Department$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$Department$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$Department$departmentsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'departments'
    ]), $author$project$Api$Provider$Integration$Athena$athenaPath);
    var $author$project$Api$Provider$Integration$Athena$Department$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$Department$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$Department$departmentsPath));
    });
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$LocationMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$LocationMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$Record = F3(function(id, name, externalId) {
        return {
            adE: externalId,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$Record))));
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'location_mappings'
    ]), $author$project$Api$Provider$Integration$Athena$athenaPath);
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$LocationMapping$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath));
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$resetHintLocations = function(model) {
        return _Utils_update(model, {
            iz: $elm$core$Set$empty
        });
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$fetchDepartmentsData = function(model) {
        return _Utils_Tuple2(_Utils_update(model, {
            k6: $author$project$Api$Data$Loading,
            hA: $author$project$Api$Data$Loading
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$Integration$Athena$Department$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaDepartments),
            A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaLocationMappings)
        ])));
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$setIntegration = F3(function(athenaConfiguration, fetchDepartments, model) {
        return A2($elm$core$Tuple$mapSecond, function(cmd) {
            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmd,
                A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 2)
            ]));
        }, (fetchDepartments ? $author$project$Pages$Admin$Athenahealth$Locations$fetchDepartmentsData : function(model_) {
            return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
        })(_Utils_update(model, {
            k4: athenaConfiguration
        })));
    });
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$One$LocationMapping = 0;
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingsPath);
    };
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('location_mapping', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('external_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adE))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Integration$Athena$LocationMapping$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$LocationMapping$locationMappingPath(id))));
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var fetchDepartments = msg.a;
                var response = msg.b;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Pages$Admin$Athenahealth$Locations$setIntegration, response, fetchDepartments, model));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Pages$Admin$Athenahealth$Locations$setIntegration, response, fetchDepartments, model));
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    k4: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    k6: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3($author$project$Pages$Admin$Athenahealth$Locations$resetHintLocations(_Utils_update(model, {
                    hA: response
                })), $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    hA: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Athena$configure, model.Ej, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaConfigured), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields), _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    k6: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Athena$Department$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaDepartments), _List_Nil);
            case 6:
                var athenaLocationMapping = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    iz: A2($elm$core$Set$insert, $author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping), model.iz)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var athenaLocationMapping = msg.a;
                var athenaLocationId = msg.b;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$Integration$Athena$LocationMapping$update, model.Ej, $author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping), {
                    adE: $author$project$Utils$String$toMaybe(athenaLocationId)
                }, $author$project$Pages$Admin$Athenahealth$Locations$GotLocationMapping), _List_Nil);
            case 8:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Locations$GotAthenaLocationMappings), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth department have been updated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v6 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.Ej, subMsg, model.kl);
                var stepHeader = _v6.a;
                var subCmd = _v6.b;
                var subOutMsg = _v6.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    kl: stepHeader
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$CompleteLocations = {
        $: 3
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$RefreshAthenaDepartments = {
        $: 5
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$EditAthenaLocationMapping = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$UpdateLocationMapping = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$displayName = F2(function(name, providerGroup) {
        if (!providerGroup.$) {
            var providerGroupId = providerGroup.a;
            return $elm$core$String$concat(_List_fromArray([
                name,
                ' (Provider Group: #',
                providerGroupId,
                ')'
            ]));
        } else return name;
    });
    var $author$project$Api$Provider$Integration$Athena$Department$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Integration$Athena$Department$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$Department$Shared$id(shared);
    };
    var $author$project$Api$Provider$Integration$Athena$Department$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Integration$Athena$Department$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$Department$Shared$name(shared);
    };
    var $author$project$Api$Provider$Integration$Athena$Department$Shared$providerGroup = function(_v0) {
        var record = _v0;
        return record.XI;
    };
    var $author$project$Api$Provider$Integration$Athena$Department$All$providerGroup = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$Department$Shared$providerGroup(shared);
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$athenaDepartmentsOptions = function(athenaDepartments) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_fromArray([
            $author$project$Ui$Form$Select$itemDisabled(true)
        ]), $elm$core$Maybe$Nothing, 'Choose athenahealth Department'), A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Unlink this Department'), A2($elm$core$List$map, function(athenaDepartment) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Integration$Athena$Department$All$id(athenaDepartment)), A2($author$project$Pages$Admin$Athenahealth$Locations$displayName, $author$project$Api$Provider$Integration$Athena$Department$All$name(athenaDepartment), $author$project$Api$Provider$Integration$Athena$Department$All$providerGroup(athenaDepartment)));
        }, athenaDepartments)));
    };
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$externalId = function(_v0) {
        var record = _v0;
        return record.adE;
    };
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$externalId(shared);
    };
    var $elm$core$Dict$member = F2(function(key, dict) {
        var _v0 = A2($elm$core$Dict$get, key, dict);
        if (!_v0.$) return true;
        else return false;
    });
    var $elm$core$Set$member = F2(function(key, _v0) {
        var dict = _v0;
        return A2($elm$core$Dict$member, key, dict);
    });
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Integration$Athena$LocationMapping$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$LocationMapping$Shared$name(shared);
    };
    var $author$project$Ui$Alignment$Between = 0;
    var $author$project$Ui$Alignment$ContentSpacing = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Alignment$spaceBetween = $author$project$Ui$Alignment$ContentSpacing(0);
    var $author$project$Ui$Element$spaceBetween = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$spaceBetween);
    var $author$project$Pages$Admin$Athenahealth$Locations$viewAthenaLocationMapping = F3(function(editingLocationMappings, athenaDepartments, athenaLocationMapping) {
        var isEditingAthenaLocationMapping = A2($elm$core$Set$member, $author$project$Api$Provider$Integration$Athena$LocationMapping$All$id(athenaLocationMapping), editingLocationMappings);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    $elm$html$Html$text('Hint Location: '),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Integration$Athena$LocationMapping$All$name(athenaLocationMapping))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(1)
                ]), _List_fromArray([
                    $author$project$Ui$Icon$arrowRight(_List_Nil)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('athenahealth department: ')
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3)
                ]), _List_fromArray([
                    function() {
                        if (isEditingAthenaLocationMapping) return A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping)),
                            $author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$Athenahealth$Locations$UpdateLocationMapping(athenaLocationMapping))
                        ]), $author$project$Pages$Admin$Athenahealth$Locations$athenaDepartmentsOptions(athenaDepartments));
                        else {
                            var athenaDepartment = A2($elm_community$list_extra$List$Extra$find, function(athenaDepartment_) {
                                return _Utils_eq($elm$core$Maybe$Just($author$project$Api$Provider$Integration$Athena$Department$All$id(athenaDepartment_)), $author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping));
                            }, athenaDepartments);
                            var chosenDepartment = function() {
                                if (!athenaDepartment.$) {
                                    var department_ = athenaDepartment.a;
                                    return A2($author$project$Pages$Admin$Athenahealth$Locations$displayName, $author$project$Api$Provider$Integration$Athena$Department$All$name(department_), $author$project$Api$Provider$Integration$Athena$Department$All$providerGroup(department_));
                                } else return 'Not linked';
                            }();
                            return A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text(chosenDepartment)
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Edit location mapping'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$sm,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Locations$EditAthenaLocationMapping(athenaLocationMapping)),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Edit')
                                ]))
                            ]));
                        }
                    }()
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsListSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$repeat, 10, A2($author$project$Ui$Grid$row, _List_fromArray([
        $author$project$Ui$Grid$rowItemsCenter
    ]), _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(6)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Platform Location: ')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(8),
                    $author$project$Ui$Skeleton$spanMd(4)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(1)
        ]), _List_Nil),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(2)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('athenahealth department: ')
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(3)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ]))
    ]))));
    var $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStepSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(9),
                $author$project$Ui$Grid$spanMd(8),
                $author$project$Ui$Grid$spanSm(7)
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(5)
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(11)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(3),
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$spanSm(5),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Refresh athenahealth Departments')
                ]))
            ]))
        ])),
        $author$project$Ui$HorizontalRule$view(_List_Nil),
        $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsListSkeleton
    ]));
    var $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStep = function(model) {
        var _v0 = model.hA;
        if (_v0.$ === 3) {
            var athenaLocationMappings = _v0.a;
            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanLg(9),
                        $author$project$Ui$Grid$spanMd(8),
                        $author$project$Ui$Grid$spanSm(7)
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text('Match Hint Locations to athenahealth Departments')
                        ])),
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Keep your patients organized by matching your Hint Locations to athenahealth Departments. If a patient is not at a location that is linked to a department, they will not be synced to Athena.')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanLg(3),
                        $author$project$Ui$Grid$spanMd(4),
                        $author$project$Ui$Grid$spanSm(5),
                        $author$project$Ui$Grid$justifyRight
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Refresh athenahealth Departments'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Locations$RefreshAthenaDepartments),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Refresh athenahealth Departments')
                        ]))
                    ]))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                function() {
                    var _v1 = model.k6;
                    if (_v1.$ === 3) {
                        var athenaDepartments = _v1.a;
                        return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, A2($author$project$Pages$Admin$Athenahealth$Locations$viewAthenaLocationMapping, model.iz, athenaDepartments), athenaLocationMappings));
                    } else return $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsListSkeleton;
                }()
            ]));
        } else return $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStepSkeleton;
    };
    var $elm$core$Dict$isEmpty = function(dict) {
        if (dict.$ === -2) return true;
        else return false;
    };
    var $elm$core$Set$isEmpty = function(_v0) {
        var dict = _v0;
        return $elm$core$Dict$isEmpty(dict);
    };
    var $author$project$Ui$Panel$None = {
        $: 5
    };
    var $author$project$Ui$Panel$none = $author$project$Ui$Panel$None;
    var $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStepFooter = function(model) {
        var _v0 = model.hA;
        if (_v0.$ === 3) {
            var athenaLocationMappings = _v0.a;
            var canContinue = A2($elm$core$List$any, function(athenaLocationMapping) {
                return !_Utils_eq($author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(athenaLocationMapping), $elm$core$Maybe$Nothing);
            }, athenaLocationMappings) && $elm$core$Set$isEmpty(model.iz);
            return A2($author$project$Ui$Panel$footer, _List_fromArray([
                $author$project$Ui$Element$justifyCenter
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Go to next step'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Locations$CompleteLocations),
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$disabled(!canContinue)
                ]), _List_fromArray([
                    $elm$html$Html$text('Next Step')
                ]))
            ]));
        } else return $author$project$Ui$Panel$none;
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$modal(model.kl)),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Locations$CompleteLocations)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('athenahealth')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            function() {
                                var _v0 = model.k4;
                                if (_v0.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Locations$StepHeaderMsg, A2($author$project$Components$Admin$Athena$StepHeader$view, model.k4, model.kl));
                                else return $author$project$Components$Admin$Athena$StepHeader$skeleton;
                            }(),
                            $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStep(model)
                        ])),
                        $author$project$Pages$Admin$Athenahealth$Locations$viewLocationsStepFooter(model)
                    ]))
                ]))
            ]),
            $2: 'Integrations | Athenahealth'
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Locations$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Athenahealth$Locations$init,
        aeR: $author$project$Pages$Admin$Athenahealth$Locations$load,
        ag3: $author$project$Pages$Admin$Athenahealth$Locations$save,
        ahE: $author$project$Pages$Admin$Athenahealth$Locations$subscriptions,
        aaO: $author$project$Pages$Admin$Athenahealth$Locations$update,
        aid: $author$project$Pages$Admin$Athenahealth$Locations$view
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$GotAthena = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaFieldMappings = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaLocationMappings = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaProviderMappings = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$ProviderMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$ProviderMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$Record = F3(function(id, name, externalId) {
        return {
            adE: externalId,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$Record))));
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'provider_mappings'
    ]), $author$project$Api$Provider$Integration$Athena$athenaPath);
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$ProviderMapping$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath));
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            k4: $author$project$Api$Data$Loading,
            lk: $author$project$Api$Data$NotAsked,
            ll: false,
            yH: $elm$core$Maybe$Nothing,
            yI: $elm$core$Maybe$Nothing,
            yJ: $elm$core$Maybe$Nothing,
            j_: $author$project$Api$Data$NotAsked,
            j9: false,
            kl: $author$project$Components$Admin$Athena$StepHeader$init(5)
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.Ej, $author$project$Pages$Admin$Athenahealth$Overview$GotAthena),
            A2($author$project$Api$Provider$Integration$Athena$LocationMapping$list, shared.Ej, $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaLocationMappings),
            A2($author$project$Api$Provider$Integration$Athena$FieldMapping$list, shared.Ej, $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaFieldMappings),
            A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, shared.Ej, $author$project$Pages$Admin$Athenahealth$Overview$GotAthenaProviderMappings)
        ])));
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$CloseBulkSyncModal = {
        $: 10
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$subscriptions(model.kl)),
            model.j9 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Athenahealth$Overview$CloseBulkSyncModal) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$Activated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$BulkSynced = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$Updated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Athena$activate = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$AthenaConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'activate'
        ]), $author$project$Api$Provider$Integration$Athena$athenaPath)));
    });
    var $author$project$Api$Provider$Integration$Athena$bulkSyncPatients = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('unlinked_only', $elm$json$Json$Encode$bool(fields.ah8))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bulk_sync_patients'
        ]), $author$project$Api$Provider$Integration$Athena$athenaPath))));
    });
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$externalId = function(_v0) {
        var record = _v0;
        return record.adE;
    };
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$externalId(shared);
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$setIntegration = F2(function(athenaConfiguration, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            k4: athenaConfiguration
        }), A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 5));
    });
    var $author$project$Api$Provider$Integration$Athena$update = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('athena_integration', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('allow_new_patient_creation', $elm$json$Json$Encode$bool(fields.Ja))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$AthenaConfiguration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath)));
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Admin$Athenahealth$Overview$setIntegration, response, model));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Admin$Athenahealth$Overview$setIntegration, response, model));
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    k4: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var locationMappings = response.a;
                    var linkedLocations = A2($elm$core$List$filter, function(locationMapping) {
                        return !_Utils_eq($author$project$Api$Provider$Integration$Athena$LocationMapping$All$externalId(locationMapping), $elm$core$Maybe$Nothing);
                    }, locationMappings);
                    return _Utils_Tuple3(_Utils_update(model, {
                        yI: $elm$core$Maybe$Just($elm$core$List$length(linkedLocations))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var fieldMappings = response.a;
                    var linkedFields = A2($elm$core$List$filter, function(fieldMapping) {
                        return !_Utils_eq($author$project$Api$Provider$Integration$Athena$FieldMapping$All$externalId(fieldMapping), $elm$core$Maybe$Nothing);
                    }, fieldMappings);
                    return _Utils_Tuple3(_Utils_update(model, {
                        yH: $elm$core$Maybe$Just($elm$core$List$length(linkedFields))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var providerMappings = response.a;
                    var linkedProviders = A2($elm$core$List$filter, function(providerMapping) {
                        return !_Utils_eq($author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(providerMapping), $elm$core$Maybe$Nothing);
                    }, providerMappings);
                    return _Utils_Tuple3(_Utils_update(model, {
                        yJ: $elm$core$Maybe$Just($elm$core$List$length(linkedProviders))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Athena$activate, model.Ej, $author$project$Pages$Admin$Athenahealth$Overview$Activated), _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    k4: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration has been activated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var allowNewPatientCreation = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Integration$Athena$update, model.Ej, {
                    Ja: allowNewPatientCreation
                }, $author$project$Pages$Admin$Athenahealth$Overview$Updated), _List_Nil);
            case 7:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    k4: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth integration have been updated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var subMsg = msg.a;
                var _v8 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.Ej, subMsg, model.kl);
                var stepHeader = _v8.a;
                var subCmd = _v8.b;
                var subOutMsg = _v8.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    kl: stepHeader
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg, subCmd), subOutMsg);
            case 9:
                return _Utils_Tuple3(_Utils_update(model, {
                    ll: false,
                    j9: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                return _Utils_Tuple3(_Utils_update(model, {
                    j9: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var checked = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ll: checked
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                return _Utils_Tuple3(_Utils_update(model, {
                    lk: $author$project$Api$Data$Loading,
                    j9: false
                }), A3($author$project$Api$Provider$Integration$Athena$bulkSyncPatients, model.Ej, {
                    ah8: model.ll
                }, $author$project$Pages$Admin$Athenahealth$Overview$BulkSynced), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    lk: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Bulk sync to athenahealth has been initiated. Patients will be synced in the background.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    lk: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$Activate = {
        $: 4
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$ConfirmBulkSync = {
        $: 12
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$SetBulkSyncUnlinkedOnly = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$OnCheck = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$onCheck = $author$project$Ui$Form$Checkbox$OnCheck;
    var $author$project$Ui$Button$secondary = $author$project$Ui$Button$Styled(2);
    var $author$project$Ui$Form$Checkbox$Value = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$value = $author$project$Ui$Form$Checkbox$Value;
    var $author$project$Ui$Form$Checkbox$defaultOptions = {
        hN: _List_Nil,
        p$: _List_Nil,
        fK: _List_Nil,
        Rj: _List_Nil,
        ed: _List_Nil
    };
    var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
    var $author$project$Ui$Form$Checkbox$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var val = option.a;
                    return _Utils_update(record, {
                        Rj: A2($elm$core$List$cons, $elm$html$Html$Attributes$checked(val), record.Rj)
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Rj: A2($elm$core$List$cons, $elm$html$Html$Attributes$required(bool), record.Rj),
                        ed: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('label-required', bool)
                        ])), record.ed)
                    });
                case 3:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Rj: A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(bool), record.Rj),
                        ed: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('text-muted', bool)
                        ])), record.ed)
                    });
                case 4:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Rj: A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(bool), record.Rj),
                        ed: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('text-muted', bool)
                        ])), record.ed)
                    });
                case 2:
                    var toMsg = option.a;
                    return _Utils_update(record, {
                        Rj: A2($elm$core$List$cons, $elm$html$Html$Events$onCheck(toMsg), record.Rj)
                    });
                case 5:
                    var attributes = option.a;
                    return _Utils_update(record, {
                        hN: _Utils_ap(A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), attributes), record.hN)
                    });
                case 6:
                    var attributes = option.a;
                    return _Utils_update(record, {
                        p$: _Utils_ap(A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), attributes), record.p$)
                    });
                case 7:
                    return _Utils_update(record, {
                        hN: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('inline-block'), record.hN)
                    });
                default:
                    var errors_ = option.a;
                    return _Utils_update(record, {
                        fK: errors_
                    });
            }
        }), $author$project$Ui$Form$Checkbox$defaultOptions, options);
    };
    var $author$project$Ui$Form$Checkbox$view = F2(function(options, content) {
        var optionsRecord = $author$project$Ui$Form$Checkbox$optionsToRecord(options);
        return A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('checkbox'), optionsRecord.hN), _List_fromArray([
            A2($elm$html$Html$label, optionsRecord.ed, _List_fromArray([
                A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('checkbox'), optionsRecord.Rj), _List_Nil),
                A2($elm$html$Html$div, optionsRecord.p$, A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content)),
                $author$project$Utils$FormErrors$view(optionsRecord.fK)
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$viewBulkSyncModal = function(model) {
        return model.j9 ? A3($author$project$Ui$Modal$view, $author$project$Pages$Admin$Athenahealth$Overview$CloseBulkSyncModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Sync Patients to athenahealth')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This will sync all patients on linked locations to athenahealth. '),
                    $elm$html$Html$text('This may take some time depending on the number of patients.')
                ])),
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(model.ll),
                    $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$Admin$Athenahealth$Overview$SetBulkSyncUnlinkedOnly)
                ]), _List_fromArray([
                    $elm$html$Html$text('Unlinked patients only')
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel bulk sync'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Overview$CloseBulkSyncModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Start bulk sync'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Overview$ConfirmBulkSync)
                ]), _List_fromArray([
                    $elm$html$Html$text('Start Sync')
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$ToggleNewPatientCreation = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$AthenaConfiguration$Shared$allowNewPatientCreation = function(_v0) {
        var record = _v0;
        return record.Ja;
    };
    var $author$project$Api$Provider$AthenaConfiguration$One$allowNewPatientCreation = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$AthenaConfiguration$Shared$allowNewPatientCreation(shared);
    };
    var $author$project$Ui$Typography$HelpBlock = {
        $: 8
    };
    var $author$project$Ui$Typography$helpBlock = $author$project$Ui$Typography$HelpBlock;
    var $author$project$Api$Provider$AthenaConfiguration$Shared$ignoredFields = function(_v0) {
        var record = _v0;
        return record.Q3;
    };
    var $author$project$Api$Provider$AthenaConfiguration$One$ignoredFields = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$AthenaConfiguration$Shared$ignoredFields(shared);
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStep = F2(function(athenaConfiguration, model) {
        var allowNewPatientCreation = $author$project$Api$Provider$AthenaConfiguration$One$allowNewPatientCreation(athenaConfiguration);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Number of Locations Linked to Departments'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = model.yI;
                        if (!_v0.$) {
                            var linkedLocationsCount = _v0.a;
                            return $elm$html$Html$text($elm$core$String$fromInt(linkedLocationsCount));
                        } else return $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanFromText('100')
                        ]));
                    }()
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Number of Custom Fields Linked'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var _v1 = model.yH;
                        if (!_v1.$) {
                            var linkedFieldsCount = _v1.a;
                            return $elm$html$Html$text($elm$core$String$fromInt(linkedFieldsCount));
                        } else return $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanFromText('100')
                        ]));
                    }()
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Number of Providers Linked'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var _v2 = model.yJ;
                        if (!_v2.$) {
                            var linkedProvidersCount = _v2.a;
                            return $elm$html$Html$text($elm$core$String$fromInt(linkedProvidersCount));
                        } else return $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanFromText('100')
                        ]));
                    }()
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Create patients from athenahealth'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(allowNewPatientCreation),
                    $author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$Athenahealth$Overview$ToggleNewPatientCreation),
                    $author$project$Ui$ToggleSwitch$disabled(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                ])),
                allowNewPatientCreation ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Update linked patients with changes from athenahealth. If a patient is '),
                        $elm$html$Html$text('not found, create a new record in Hint. This is suggested for direct '),
                        $elm$html$Html$text('care practices.')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Note: Only patients in athenahealth departments linked to Hint will be '),
                        $elm$html$Html$text('created in Hint.')
                    ]))
                ])) : A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Update linked patients with changes from athenahealth. If a patient is not found, '),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text('do not create')
                    ])),
                    $elm$html$Html$text(' a record in Hint. This is suggested for hybrid practices '),
                    $elm$html$Html$text('that have both fee-for-service as well as direct care patients.')
                ]))
            ])),
            $elm$core$List$isEmpty($author$project$Api$Provider$AthenaConfiguration$One$ignoredFields(athenaConfiguration)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Fields excluded from the sync'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$String$join, ', ', $author$project$Api$Provider$AthenaConfiguration$One$ignoredFields(athenaConfiguration)))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Athenahealth$Overview$OpenBulkSyncModal = {
        $: 9
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStepFooter = F2(function(athenaConfiguration, model) {
        var status = $author$project$Api$Provider$AthenaConfiguration$One$status(athenaConfiguration);
        return status === 'pending' ? A2($author$project$Ui$Panel$footer, _List_fromArray([
            $author$project$Ui$Element$justifyCenter
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Activate integration'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Overview$Activate),
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
            ]), _List_fromArray([
                $elm$html$Html$text('Activate')
            ]))
        ])) : status === 'active' ? A2($author$project$Ui$Panel$footer, _List_fromArray([
            $author$project$Ui$Element$justifyCenter
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Sync all patients to athenahealth'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Overview$OpenBulkSyncModal),
                $author$project$Ui$Button$loading(_Utils_eq(model.lk, $author$project$Api$Data$Loading))
            ]), _List_fromArray([
                $elm$html$Html$text('Sync Patients to athenahealth')
            ]))
        ])) : $author$project$Ui$Panel$none;
    });
    var $author$project$Ui$Skeleton$Block = 0;
    var $author$project$Ui$Skeleton$Display = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Skeleton$block = $author$project$Ui$Skeleton$Display(0);
    var $author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStepSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Number of Locations Linked to Departments'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('100')
                ]))
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Number of Custom Fields Linked'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('100')
                ]))
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Number of Providers Linked'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('100')
                ]))
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Create patients from athenahealth'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_fromArray([
                $author$project$Ui$Skeleton$spanMd(2),
                $author$project$Ui$Skeleton$span(3)
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(6)
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(7)
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(5)
                ]))
            ]))
        ]))
    ]));
    var $author$project$Pages$Admin$Athenahealth$Overview$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$modal(model.kl)),
                $author$project$Pages$Admin$Athenahealth$Overview$viewBulkSyncModal(model),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Overview$Activate)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('athenahealth')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, function() {
                            var _v0 = model.k4;
                            if (_v0.$ === 3) {
                                var athenaConfiguration = _v0.a;
                                return _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Overview$StepHeaderMsg, A2($author$project$Components$Admin$Athena$StepHeader$view, model.k4, model.kl)),
                                    A2($author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStep, athenaConfiguration, model)
                                ]);
                            } else return _List_fromArray([
                                $author$project$Components$Admin$Athena$StepHeader$skeleton,
                                $author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStepSkeleton
                            ]);
                        }()),
                        function() {
                            var _v1 = model.k4;
                            if (_v1.$ === 3) {
                                var athenaConfiguration = _v1.a;
                                return A2($author$project$Pages$Admin$Athenahealth$Overview$viewOverviewStepFooter, athenaConfiguration, model);
                            } else return $author$project$Ui$Panel$none;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Integrations | Athenahealth'
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Overview$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Athenahealth$Overview$init,
        aeR: $author$project$Pages$Admin$Athenahealth$Overview$load,
        ag3: $author$project$Pages$Admin$Athenahealth$Overview$save,
        ahE: $author$project$Pages$Admin$Athenahealth$Overview$subscriptions,
        aaO: $author$project$Pages$Admin$Athenahealth$Overview$update,
        aid: $author$project$Pages$Admin$Athenahealth$Overview$view
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$GotAthena = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            k4: $author$project$Api$Data$Loading,
            k7: $author$project$Api$Data$NotAsked,
            k8: $author$project$Api$Data$NotAsked,
            iA: $elm$core$Set$empty,
            j_: $author$project$Api$Data$NotAsked,
            kl: $author$project$Components$Admin$Athena$StepHeader$init(4)
        }, A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.Ej, $author$project$Pages$Admin$Athenahealth$Providers$GotAthena(true)));
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$subscriptions = function(_v0) {
        var stepHeader = _v0.kl;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$subscriptions(stepHeader));
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$Completed = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviderMappings = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviders = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$GotProviderMapping = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Athena$complete = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$AthenaConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'complete'
        ]), $author$project$Api$Provider$Integration$Athena$athenaPath)));
    });
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$id(shared);
    };
    var $author$project$Api$Provider$Integration$Athena$Provider$All$Provider = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$Provider$Shared$Provider = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Athena$Provider$Shared$Record = F3(function(id, name, providerGroups) {
        return {
            aef: id,
            zr: name,
            XJ: providerGroups
        };
    });
    var $author$project$Api$Provider$Integration$Athena$Provider$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'provider_groups', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$list($elm$json$Json$Decode$string)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Athena$Provider$Shared$Record))));
    var $author$project$Api$Provider$Integration$Athena$Provider$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$Provider$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$Provider$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Athena$Provider$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Athena$Provider$providersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'providers'
    ]), $author$project$Api$Provider$Integration$Athena$athenaPath);
    var $author$project$Api$Provider$Integration$Athena$Provider$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Athena$Provider$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$Provider$providersPath));
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$resetHintProviders = function(model) {
        return _Utils_update(model, {
            iA: $elm$core$Set$empty
        });
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$fetchProvidersData = function(model) {
        return _Utils_Tuple2(_Utils_update(model, {
            k7: $author$project$Api$Data$Loading,
            k8: $author$project$Api$Data$Loading
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$Integration$Athena$Provider$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviders),
            A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviderMappings)
        ])));
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$setIntegration = F3(function(athenaConfiguration, fetchProviders, model) {
        return A2($elm$core$Tuple$mapSecond, function(cmd) {
            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmd,
                A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 4)
            ]));
        }, (fetchProviders ? $author$project$Pages$Admin$Athenahealth$Providers$fetchProvidersData : function(model_) {
            return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
        })(_Utils_update(model, {
            k4: athenaConfiguration
        })));
    });
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$One$ProviderMapping = 0;
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingsPath);
    };
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('provider_mapping', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('external_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adE))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Integration$Athena$ProviderMapping$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$ProviderMapping$providerMappingPath(id))));
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var fetchProviders = msg.a;
                var response = msg.b;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Pages$Admin$Athenahealth$Providers$setIntegration, response, fetchProviders, model));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Pages$Admin$Athenahealth$Providers$setIntegration, response, fetchProviders, model));
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    k4: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    k8: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3($author$project$Pages$Admin$Athenahealth$Providers$resetHintProviders(_Utils_update(model, {
                    k7: response
                })), $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    k7: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Athena$complete, model.Ej, $author$project$Pages$Admin$Athenahealth$Providers$Completed), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview), _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    k8: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Athena$Provider$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviders), _List_Nil);
            case 6:
                var athenaProviderMapping = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    iA: A2($elm$core$Set$insert, $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping), model.iA)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var athenaProviderMapping = msg.a;
                var athenaProviderId = msg.b;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$Integration$Athena$ProviderMapping$update, model.Ej, $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping), {
                    adE: $author$project$Utils$String$toMaybe(athenaProviderId)
                }, $author$project$Pages$Admin$Athenahealth$Providers$GotProviderMapping), _List_Nil);
            case 8:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Api$Provider$Integration$Athena$ProviderMapping$list, model.Ej, $author$project$Pages$Admin$Athenahealth$Providers$GotAthenaProviderMappings), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your athenahealth provider have been updated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v6 = A3($author$project$Components$Admin$Athena$StepHeader$update, model.Ej, subMsg, model.kl);
                var stepHeader = _v6.a;
                var subCmd = _v6.b;
                var subOutMsg = _v6.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    kl: stepHeader
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$CompleteProviders = {
        $: 3
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$RefreshAthenaProviders = {
        $: 5
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$EditAthenaProviderMapping = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$UpdateProviderMapping = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$displayName = F2(function(name, providerGroups) {
        if (!providerGroups.$) {
            var providerGroupIds = providerGroups.a;
            return $elm$core$String$concat(_List_fromArray([
                name,
                ' (Provider Group: ',
                A2($elm$core$String$join, ', ', A2($elm$core$List$map, function(id) {
                    return '#' + id;
                }, providerGroupIds)),
                ')'
            ]));
        } else return name;
    });
    var $author$project$Api$Provider$Integration$Athena$Provider$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Integration$Athena$Provider$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$Provider$Shared$id(shared);
    };
    var $author$project$Api$Provider$Integration$Athena$Provider$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Integration$Athena$Provider$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$Provider$Shared$name(shared);
    };
    var $author$project$Api$Provider$Integration$Athena$Provider$Shared$providerGroups = function(_v0) {
        var record = _v0;
        return record.XJ;
    };
    var $author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$Provider$Shared$providerGroups(shared);
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$athenaProvidersOptions = function(athenaProviders) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_fromArray([
            $author$project$Ui$Form$Select$itemDisabled(true)
        ]), $elm$core$Maybe$Nothing, 'Choose athenahealth Provider'), A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Unlink this Provider'), A2($elm$core$List$map, function(athenaProvider) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt($author$project$Api$Provider$Integration$Athena$Provider$All$id(athenaProvider))), A2($author$project$Pages$Admin$Athenahealth$Providers$displayName, $author$project$Api$Provider$Integration$Athena$Provider$All$name(athenaProvider), $author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups(athenaProvider)));
        }, athenaProviders)));
    };
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Athena$ProviderMapping$Shared$name(shared);
    };
    var $author$project$Ui$Button$size = $author$project$Ui$Button$Size;
    var $author$project$Pages$Admin$Athenahealth$Providers$viewAthenaProviderMapping = F3(function(editingProviderMappings, athenaProviders, athenaProviderMapping) {
        var isEditingAthenaProviderMapping = A2($elm$core$Set$member, $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$id(athenaProviderMapping), editingProviderMappings);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    $elm$html$Html$text('Hint provider: '),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Integration$Athena$ProviderMapping$All$name(athenaProviderMapping))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(1)
                ]), _List_fromArray([
                    $author$project$Ui$Icon$arrowRight(_List_Nil)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('athenahealth provider: ')
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3)
                ]), _List_fromArray([
                    function() {
                        if (isEditingAthenaProviderMapping) return A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(athenaProviderMapping)),
                            $author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$Athenahealth$Providers$UpdateProviderMapping(athenaProviderMapping))
                        ]), $author$project$Pages$Admin$Athenahealth$Providers$athenaProvidersOptions(athenaProviders));
                        else {
                            var athenaProvider = A2($elm_community$list_extra$List$Extra$find, function(athenaProvider_) {
                                return _Utils_eq($elm$core$Maybe$Just($elm$core$String$fromInt($author$project$Api$Provider$Integration$Athena$Provider$All$id(athenaProvider_))), $author$project$Api$Provider$Integration$Athena$ProviderMapping$All$externalId(athenaProviderMapping));
                            }, athenaProviders);
                            var chosenProvider = function() {
                                if (!athenaProvider.$) {
                                    var provider_ = athenaProvider.a;
                                    return A2($author$project$Pages$Admin$Athenahealth$Providers$displayName, $author$project$Api$Provider$Integration$Athena$Provider$All$name(provider_), $author$project$Api$Provider$Integration$Athena$Provider$All$providerGroups(provider_));
                                } else return 'Not linked';
                            }();
                            return A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text(chosenProvider)
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Edit provider mapping'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$size(0),
                                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Providers$EditAthenaProviderMapping(athenaProviderMapping)),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Edit')
                                ]))
                            ]));
                        }
                    }()
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersListSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$repeat, 10, A2($author$project$Ui$Grid$row, _List_fromArray([
        $author$project$Ui$Grid$rowItemsCenter
    ]), _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(6)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Platform Provider: ')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(8),
                    $author$project$Ui$Skeleton$spanMd(4)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(1)
        ]), _List_Nil),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(2)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('athenahealth provider: ')
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(3)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ]))
    ]))));
    var $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStepSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(9),
                $author$project$Ui$Grid$spanMd(8),
                $author$project$Ui$Grid$spanSm(7)
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Link Providers')
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Keep the primary provider in athenahealth in sync with the the assigned provider in HintOS.')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(3),
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$spanSm(5),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Refresh athenahealth Providers')
                ]))
            ]))
        ])),
        $author$project$Ui$HorizontalRule$view(_List_Nil),
        $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersListSkeleton
    ]));
    var $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStep = function(model) {
        var _v0 = model.k7;
        if (_v0.$ === 3) {
            var athenaProviderMappings = _v0.a;
            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanLg(9),
                        $author$project$Ui$Grid$spanMd(8),
                        $author$project$Ui$Grid$spanSm(7)
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text('Link Providers')
                        ])),
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Keep the primary provider in athenahealth in sync with the the assigned provider in HintOS.')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanLg(3),
                        $author$project$Ui$Grid$spanMd(4),
                        $author$project$Ui$Grid$spanSm(5),
                        $author$project$Ui$Grid$justifyRight
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Refresh athenahealth Providers'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Providers$RefreshAthenaProviders),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Refresh athenahealth Providers')
                        ]))
                    ]))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                function() {
                    var _v1 = model.k8;
                    if (_v1.$ === 3) {
                        var athenaProviders = _v1.a;
                        return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, A2($author$project$Pages$Admin$Athenahealth$Providers$viewAthenaProviderMapping, model.iA, athenaProviders), athenaProviderMappings));
                    } else return $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersListSkeleton;
                }()
            ]));
        } else return $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStepSkeleton;
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStepFooter = function(model) {
        var canContinue = $elm$core$Set$isEmpty(model.iA);
        return A2($author$project$Ui$Panel$footer, _List_fromArray([
            $author$project$Ui$Element$justifyCenter
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Go to next step'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Providers$CompleteProviders),
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$disabled(!canContinue)
            ]), _List_fromArray([
                $elm$html$Html$text('Next Step')
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg, $author$project$Components$Admin$Athena$StepHeader$modal(model.kl)),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Athenahealth$Providers$CompleteProviders)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('athenahealth')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            function() {
                                var _v0 = model.k4;
                                if (_v0.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Admin$Athenahealth$Providers$StepHeaderMsg, A2($author$project$Components$Admin$Athena$StepHeader$view, model.k4, model.kl));
                                else return $author$project$Components$Admin$Athena$StepHeader$skeleton;
                            }(),
                            $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStep(model)
                        ])),
                        $author$project$Pages$Admin$Athenahealth$Providers$viewProvidersStepFooter(model)
                    ]))
                ]))
            ]),
            $2: 'Integrations | Athenahealth'
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Providers$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Athenahealth$Providers$init,
        aeR: $author$project$Pages$Admin$Athenahealth$Providers$load,
        ag3: $author$project$Pages$Admin$Athenahealth$Providers$save,
        ahE: $author$project$Pages$Admin$Athenahealth$Providers$subscriptions,
        aaO: $author$project$Pages$Admin$Athenahealth$Providers$update,
        aid: $author$project$Pages$Admin$Athenahealth$Providers$view
    });
    var $author$project$Pages$Admin$Athenahealth$Top$GotAthena = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Top$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            k4: $author$project$Api$Data$Loading,
            j_: $author$project$Api$Data$NotAsked
        }, A2($author$project$Api$Provider$Integration$Athena$retrieve, shared.Ej, $author$project$Pages$Admin$Athenahealth$Top$GotAthena));
    });
    var $author$project$Pages$Admin$Athenahealth$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Athenahealth$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Athenahealth$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Athenahealth$Top$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Athena$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$AthenaConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Athena$athenaPath));
    });
    var $author$project$Pages$Admin$Athenahealth$Top$setIntegration = F2(function(athenaConfiguration, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            k4: athenaConfiguration
        }), A2($author$project$Components$Admin$Athena$StepHeader$goToStep, athenaConfiguration, 0));
    });
    var $author$project$Pages$Admin$Athenahealth$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Admin$Athenahealth$Top$setIntegration, response, model));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Admin$Athenahealth$Top$setIntegration, response, model));
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    k4: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Athena$create, model.Ej, $author$project$Pages$Admin$Athenahealth$Top$Created), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Athenahealth__Link), _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$Athenahealth$Top$Create = {
        $: 1
    };
    var $author$project$Pages$Admin$Athenahealth$Top$viewStatus = F2(function(status, content) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Status'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Badge$fromString, _List_Nil, status), content))
        ]));
    });
    var $author$project$Pages$Admin$Athenahealth$Top$viewInitialStep = function(_v0) {
        var saveRequest = _v0.j_;
        var athenaConfiguration = _v0.k4;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                if (athenaConfiguration.$ === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSkeleton('Status'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanFromText('inactive')
                        ]))
                    ]))
                ]));
                else return A2($author$project$Pages$Admin$Athenahealth$Top$viewStatus, 'inactive', _List_Nil);
            }(),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Enable athenahealth Integration'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Athenahealth$Top$Create),
                    $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Enable athenahealth Integration')
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('About'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
                    A3($author$project$Ui$Link$externalHref, 'https://www.athenahealth.com/', _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $elm$html$Html$text('athenahealth')
                    ])),
                    $elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, '),
                    $elm$html$Html$text('and act upon relevant clinical information to care for your patients.')
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Our integration will automatically create and synchronize patient demographic, '),
                    $elm$html$Html$text('contact, and membership information with athenahealth.')
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('To configure this integration, you need to provide your existing athenahealth practice ID. '),
                    $elm$html$Html$text('Please contact us if you need help identifying this information')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Athenahealth$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('athenahealth')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            $author$project$Pages$Admin$Athenahealth$Top$viewInitialStep(model)
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Integrations | Athenahealth'
        };
    };
    var $author$project$Pages$Admin$Athenahealth$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Athenahealth$Top$init,
        aeR: $author$project$Pages$Admin$Athenahealth$Top$load,
        ag3: $author$project$Pages$Admin$Athenahealth$Top$save,
        ahE: $author$project$Pages$Admin$Athenahealth$Top$subscriptions,
        aaO: $author$project$Pages$Admin$Athenahealth$Top$update,
        aid: $author$project$Pages$Admin$Athenahealth$Top$view
    });
    var $author$project$Pages$Admin$Billing$GotManagementGroup = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$NotInitialized = {
        $: 0
    };
    var $author$project$Pages$Admin$Billing$GotBankAccounts = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$BankAccount$bankAccountsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bank_accounts'
        ]), basePath);
    };
    var $author$project$Api$Provider$BankAccount$All$BankAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BankAccount$One$BankAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$BankAccount$Shared$BankAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BankAccount$Shared$Record = function(id) {
        return function(name) {
            return function(type_) {
                return function(lastFour) {
                    return function(status) {
                        return function(label) {
                            return function(errorMessage) {
                                return function(lastPaymentErrorMessage) {
                                    return function(createdVia) {
                                        return function(createdByName) {
                                            return function(createdAt) {
                                                return function(bankName) {
                                                    return function(paymentProcessor) {
                                                        return function(assignedMemberships) {
                                                            return {
                                                                JF: assignedMemberships,
                                                                J6: bankName,
                                                                Mx: createdAt,
                                                                Mz: createdByName,
                                                                MA: createdVia,
                                                                O4: errorMessage,
                                                                aef: id,
                                                                aeI: label,
                                                                ST: lastFour,
                                                                SV: lastPaymentErrorMessage,
                                                                zr: name,
                                                                Wo: paymentProcessor,
                                                                ahy: status,
                                                                ah5: type_
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$BankAccount$Shared$AssignedMembership = F2(function(id, planName) {
        return {
            aef: id,
            WM: planName
        };
    });
    var $author$project$Api$Provider$BankAccount$Shared$assignedMembershipDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$Shared$AssignedMembership)));
    var $author$project$Api$Provider$BankAccount$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'assigned_memberships', $elm$json$Json$Decode$list($author$project$Api$Provider$BankAccount$Shared$assignedMembershipDecoder), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bank_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_by_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_via', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_payment_error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_four', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$Shared$Record)))))))))))))));
    var $author$project$Api$Provider$BankAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BankAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$BankAccount$One$Record = F2(function(_default, defaults) {
        return {
            Nn: _default,
            NF: defaults
        };
    });
    var $author$project$Api$Provider$Source$Defaults$Defaults = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Source$Defaults$Record = F2(function(hintCustomer, network) {
        return {
            QN: hintCustomer,
            UK: network
        };
    });
    var $author$project$Api$Provider$Source$Defaults$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'network', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hint_customer', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Source$Defaults$Record)));
    var $author$project$Api$Provider$Source$Defaults$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Source$Defaults$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$BankAccount$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'defaults', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Source$Defaults$decoder), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'default', $elm$json$Json$Decode$bool, false, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$One$Record)));
    var $author$project$Api$Provider$BankAccount$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BankAccount$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BankAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BankAccount$One$BankAccount)));
    var $author$project$Api$Provider$BankAccount$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BankAccount$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Param$List = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Param$list = $author$project$Api$Param$List;
    var $author$project$Api$Provider$BankAccount$list = F3(function(basePath, apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$BankAccount$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', _List_fromArray([
                'assigned_memberships'
            ]))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$BankAccount$bankAccountsPath(basePath))));
    });
    var $author$project$Pages$Admin$Billing$fetchBankAccounts = function(apiClient) {
        return A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$Billing$GotBankAccounts);
    };
    var $author$project$Pages$Admin$Billing$GotCards = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Card$cardsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cards'
        ]), basePath);
    };
    var $author$project$Api$Provider$Card$All$Card = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Card$One$Card = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Card$Shared$Card = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Card$Shared$Record = function(id) {
        return function(name) {
            return function(type_) {
                return function(lastFour) {
                    return function(status) {
                        return function(label) {
                            return function(errorMessage) {
                                return function(lastPaymentErrorMessage) {
                                    return function(expMonth) {
                                        return function(expYear) {
                                            return function(createdVia) {
                                                return function(createdByName) {
                                                    return function(createdAt) {
                                                        return function(cardType) {
                                                            return function(zip) {
                                                                return function(paymentProcessor) {
                                                                    return function(funding) {
                                                                        return function(assignedMemberships) {
                                                                            return {
                                                                                JF: assignedMemberships,
                                                                                KZ: cardType,
                                                                                Mx: createdAt,
                                                                                Mz: createdByName,
                                                                                MA: createdVia,
                                                                                O4: errorMessage,
                                                                                adz: expMonth,
                                                                                adA: expYear,
                                                                                P1: funding,
                                                                                aef: id,
                                                                                aeI: label,
                                                                                ST: lastFour,
                                                                                SV: lastPaymentErrorMessage,
                                                                                zr: name,
                                                                                Wo: paymentProcessor,
                                                                                ahy: status,
                                                                                ah5: type_,
                                                                                tK: zip
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Card$Shared$AssignedMembership = F2(function(id, planName) {
        return {
            aef: id,
            WM: planName
        };
    });
    var $author$project$Api$Provider$Card$Shared$assignedMembershipDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$Shared$AssignedMembership)));
    var $author$project$Api$Provider$Card$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'assigned_memberships', $elm$json$Json$Decode$list($author$project$Api$Provider$Card$Shared$assignedMembershipDecoder), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'funding', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'zip', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'card_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_by_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_via', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exp_year', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exp_month', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_payment_error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_four', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$Shared$Record)))))))))))))))))));
    var $author$project$Api$Provider$Card$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Card$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Card$One$Record = F2(function(_default, defaults) {
        return {
            Nn: _default,
            NF: defaults
        };
    });
    var $author$project$Api$Provider$Card$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'defaults', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Source$Defaults$decoder), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'default', $elm$json$Json$Decode$bool, false, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$One$Record)));
    var $author$project$Api$Provider$Card$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Card$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Card$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Card$One$Card)));
    var $author$project$Api$Provider$Card$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Card$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Card$list = F3(function(basePath, apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Card$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', _List_fromArray([
                'assigned_memberships'
            ]))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Card$cardsPath(basePath))));
    });
    var $author$project$Pages$Admin$Billing$fetchCards = function(apiClient) {
        return A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$Billing$GotCards);
    };
    var $author$project$Pages$Admin$Billing$GotPracticeInvoices = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeInvoice$All$PracticeInvoice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeInvoice$Shared$PracticeInvoice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeInvoice$Shared$Record = function(humanStatus) {
        return function(id) {
            return function(invoiceDate) {
                return function(dueDate) {
                    return function(invoiceNumber) {
                        return function(paidAt) {
                            return function(totalInCents) {
                                return function(paidInCents) {
                                    return function(dueInCents) {
                                        return function(meta) {
                                            return {
                                                Ok: dueDate,
                                                Ol: dueInCents,
                                                QX: humanStatus,
                                                aef: id,
                                                RG: invoiceDate,
                                                RK: invoiceNumber,
                                                Ue: meta,
                                                VQ: paidAt,
                                                VR: paidInCents,
                                                aam: totalInCents
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$PracticeInvoice$Status$Cancelled = 4;
    var $author$project$Api$Provider$PracticeInvoice$Status$Disputed = 6;
    var $author$project$Api$Provider$PracticeInvoice$Status$Draft = 2;
    var $author$project$Api$Provider$PracticeInvoice$Status$Issued = 3;
    var $author$project$Api$Provider$PracticeInvoice$Status$Overdue = 5;
    var $author$project$Api$Provider$PracticeInvoice$Status$Paid = 0;
    var $author$project$Api$Provider$PracticeInvoice$Status$Processing = 1;
    var $author$project$Api$Provider$PracticeInvoice$Status$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'paid':
                return $elm$json$Json$Decode$succeed(0);
            case 'processing':
                return $elm$json$Json$Decode$succeed(1);
            case 'draft':
                return $elm$json$Json$Decode$succeed(2);
            case 'overdue':
                return $elm$json$Json$Decode$succeed(5);
            case 'cancelled':
                return $elm$json$Json$Decode$succeed(4);
            case 'disputed':
                return $elm$json$Json$Decode$succeed(6);
            case 'issued':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail('Unsupported Practice Invoice status: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$PracticeInvoice$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeInvoice$Meta$MetaRecord = function(actions) {
        return {
            tM: actions
        };
    };
    var $author$project$Api$Provider$PracticeInvoice$Meta$ActionsRecord = F6(function(cancel, issue, destroy, paymentsProcess, adjust, refund) {
        return {
            IQ: adjust,
            KW: cancel,
            NT: destroy,
            SB: issue,
            Wu: paymentsProcess,
            Yq: refund
        };
    });
    var $author$project$Api$Provider$PracticeInvoice$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'refund', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'adjust', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payments_process', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'destroy', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issue', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancel', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Meta$ActionsRecord)))))));
    var $author$project$Api$Provider$PracticeInvoice$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$PracticeInvoice$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Meta$MetaRecord));
    var $author$project$Api$Provider$PracticeInvoice$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeInvoice$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticeInvoice$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$PracticeInvoice$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $author$project$Api$Provider$PracticeInvoice$Status$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$Shared$Record)))))))))));
    var $author$project$Api$Provider$PracticeInvoice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeInvoice$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticeInvoice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeInvoice$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Pagination$Model = $elm$core$Basics$identity;
    var $author$project$Api$Pagination$init = {
        bt: 1,
        fY: 10,
        sg: '',
        oQ: 0
    };
    var $author$project$Api$Provider$PracticeInvoice$listDefaults = {
        Fw: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Pagination$limit = function(_v0) {
        var model = _v0;
        return model.fY;
    };
    var $author$project$Api$Pagination$offset = function(_v0) {
        var model = _v0;
        return (model.bt - 1) * model.fY;
    };
    var $author$project$Api$Pagination$toApiParams = function(model) {
        return A2($elm$core$List$map, function(_v0) {
            var key = _v0.a;
            var value = _v0.b;
            return A2($author$project$Api$Param$string, key, value);
        }, _List_fromArray([
            _Utils_Tuple2('offset', $elm$core$String$fromInt($author$project$Api$Pagination$offset(model))),
            _Utils_Tuple2('limit', $elm$core$String$fromInt($author$project$Api$Pagination$limit(model)))
        ]));
    };
    var $author$project$Api$Provider$PracticeInvoice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$PracticeInvoice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Fw;
                if (!_v0.$) {
                    var filter = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', filter)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice',
        'invoices'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PracticeInvoice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PracticeInvoice$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$PracticeInvoice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath)));
    });
    var $author$project$Pages$Admin$Billing$fetchPracticeInvoices = F2(function(apiClient, pagination) {
        return A3($author$project$Api$Provider$PracticeInvoice$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination
            });
        }, $author$project$Pages$Admin$Billing$GotPracticeInvoices);
    });
    var $author$project$Pages$Admin$Billing$GotApplicationFeePlan = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$ApplicationFeePlan$applicationFeePlanPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'fee_plan'
    ]), $author$project$Api$Provider$Practice$practicePath);
    var $author$project$Api$Provider$ApplicationFeePlan$One$ApplicationFeePlan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ApplicationFeePlan$One$Record = function(id) {
        return function(name) {
            return function(pricedBy) {
                return function(collectionFeePercentage) {
                    return function(minimumPerMonthInCents) {
                        return function(totalAchFeeInCents) {
                            return function(totalAchFeePercentage) {
                                return function(totalAmexFeePercentage) {
                                    return function(totalCardFeeInCents) {
                                        return function(totalCardFeePercentage) {
                                            return function(achTransactionFeeCapInCents) {
                                                return function(trancheSize) {
                                                    return {
                                                        Io: achTransactionFeeCapInCents,
                                                        Lz: collectionFeePercentage,
                                                        aef: id,
                                                        Ur: minimumPerMonthInCents,
                                                        zr: name,
                                                        Bs: pricedBy,
                                                        aag: totalAchFeeInCents,
                                                        aah: totalAchFeePercentage,
                                                        aai: totalAmexFeePercentage,
                                                        aaj: totalCardFeeInCents,
                                                        HR: totalCardFeePercentage,
                                                        ah2: trancheSize
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$RecordIntermediate = F2(function(pricedBy, pricingStructure) {
        return {
            Bs: pricedBy,
            Xq: pricingStructure
        };
    });
    var $author$project$Api$Provider$PricingStructure$Shared$PricingStructure = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PricingStructure$Shared$IntermediateRecord = F7(function(id, description, fixedAmountInCents, percentage, splitType, pricingType, tiers) {
        return {
            NQ: description,
            adR: fixedAmountInCents,
            aef: id,
            af9: percentage,
            agn: pricingType,
            ahu: splitType,
            $$: tiers
        };
    });
    var $author$project$Api$Provider$PricingStructure$Shared$Record = F6(function(id, description, fixedAmountInCents, percentage, splitType, pricingType) {
        return {
            NQ: description,
            adR: fixedAmountInCents,
            aef: id,
            af9: percentage,
            agn: pricingType,
            ahu: splitType
        };
    });
    var $author$project$Api$PricingType$FixedAmountInCents = {
        $: 1
    };
    var $author$project$Api$PricingType$Percentage = {
        $: 0
    };
    var $author$project$Api$PricingType$PercentageAndFixedAmount = {
        $: 2
    };
    var $author$project$Api$PricingType$Tiered = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$PricingType$decoder = F2(function(pricingTypeStr, tiers) {
        switch(pricingTypeStr){
            case 'percentage':
                return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$Percentage);
            case 'fixed_amount_in_cents':
                return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$FixedAmountInCents);
            case 'percentage_and_fixed_amount':
                return $elm$json$Json$Decode$succeed($author$project$Api$PricingType$PercentageAndFixedAmount);
            case 'tiered':
                return $elm$core$List$isEmpty(tiers) ? $elm$json$Json$Decode$fail('Must have tiers if tiered') : $elm$json$Json$Decode$succeed($author$project$Api$PricingType$Tiered(tiers));
            default:
                var somethingElse = pricingTypeStr;
                return $elm$json$Json$Decode$fail('Unknown PricingType value: ' + somethingElse);
        }
    });
    var $author$project$Api$Provider$PricingTier$Shared$PricingTier = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PricingTier$Shared$Record = F3(function(fixedAmountInCents, lowerBound, upperBound) {
        return {
            adR: fixedAmountInCents,
            Tx: lowerBound,
            aaS: upperBound
        };
    });
    var $author$project$Api$Provider$PricingTier$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'upper_bound', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lower_bound', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_amount_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingTier$Shared$Record))));
    var $author$project$Api$Provider$PricingTier$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PricingTier$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$SplitType$AllMembers = 0;
    var $author$project$Api$SplitType$Flat = 2;
    var $author$project$Api$SplitType$PrimaryOnly = 1;
    var $author$project$Api$SplitType$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'all_members':
                return $elm$json$Json$Decode$succeed(0);
            case 'primary_only':
                return $elm$json$Json$Decode$succeed(1);
            case 'flat':
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail('Unsupported Pricing Structure -> split_type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
    var $author$project$Api$Provider$PricingStructure$Shared$recordDecoder = A2($elm$json$Json$Decode$andThen, function(intermediate) {
        return A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tiers', A2($author$project$Api$PricingType$decoder, intermediate.agn, intermediate.$$), A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, intermediate.ahu, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, intermediate.af9, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, intermediate.adR, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, intermediate.NQ, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, intermediate.aef, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingStructure$Shared$Record)))))));
    }, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tiers', $elm$json$Json$Decode$list($author$project$Api$Provider$PricingTier$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pricing_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'split_type', $author$project$Api$SplitType$decoder, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'percentage', $elm$json$Json$Decode$float, 0.0, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'fixed_amount_in_cents', $elm$json$Json$Decode$int, 0, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingStructure$Shared$IntermediateRecord)))))))));
    var $author$project$Api$Provider$PricingStructure$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PricingStructure$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ApplicationFeePlan$One$Pmpm = {
        $: 1
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$PmpmTiered = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$Transaction = {
        $: 0
    };
    var $author$project$Api$Provider$PricingStructure$Shared$pricingType = function(_v0) {
        var record = _v0;
        return record.agn;
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$pricedByDecoder = F2(function(pricedByStr, pricingStructure) {
        switch(pricedByStr){
            case 'transaction':
                return $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Transaction);
            case 'pmpm':
                return $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Pmpm);
            case 'pmpm_tiered':
                if (pricingStructure.$ === 1) return $elm$json$Json$Decode$fail('PMPM ApplicationFeePlans must have pricingStructure');
                else {
                    var structure = pricingStructure.a;
                    var _v2 = $author$project$Api$Provider$PricingStructure$Shared$pricingType(structure);
                    if (_v2.$ === 3) {
                        var tiers = _v2.a;
                        return $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$PmpmTiered(tiers));
                    } else return $elm$json$Json$Decode$fail('PMPM Tiered ApplicationFeePlans must have tiers');
                }
            default:
                var somethingElse = pricedByStr;
                return $elm$json$Json$Decode$fail('Unknown PricedBy value: ' + somethingElse);
        }
    });
    var $author$project$Api$Provider$ApplicationFeePlan$One$recordDecoder = A2($elm$json$Json$Decode$andThen, function(intermediate) {
        return A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tranche_size', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ach_transaction_fee_cap_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_card_fee_percentage', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_card_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_amex_fee_percentage', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_ach_fee_percentage', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_ach_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_per_month_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collection_fee_percentage', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'priced_by', A2($author$project$Api$Provider$ApplicationFeePlan$One$pricedByDecoder, intermediate.Bs, intermediate.Xq), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$Record)))))))))))));
    }, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pricing_structure', $elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingStructure$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'priced_by', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApplicationFeePlan$One$RecordIntermediate))));
    var $author$project$Api$Provider$ApplicationFeePlan$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ApplicationFeePlan$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$ApplicationFeePlan$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$ApplicationFeePlan$applicationFeePlanPath));
    });
    var $author$project$Pages$Admin$Billing$fetchApplicationFeePlan = function(apiClient) {
        return A2($author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotApplicationFeePlan);
    };
    var $author$project$Pages$Admin$Billing$GotPracticePricing = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticePricing$One$PracticePricing = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticePricing$One$Record = function(nextBillDate) {
        return function(products) {
            return function(includedMembers) {
                return function(includedRevenue) {
                    return function(livesOveragePriceInCents) {
                        return function(revenueOveragePriceInCents) {
                            return function(txnFees) {
                                return function(trancheBased) {
                                    return function(pmpmFeeInCents) {
                                        return function(trancheMembersCount) {
                                            return function(infoMessageTitle) {
                                                return function(infoMessageBody) {
                                                    return function(manualBilling) {
                                                        return function(hubspotDealUrl) {
                                                            return function(currentMembers) {
                                                                return {
                                                                    MN: currentMembers,
                                                                    QU: hubspotDealUrl,
                                                                    ael: includedMembers,
                                                                    aem: includedRevenue,
                                                                    Re: infoMessageBody,
                                                                    Rf: infoMessageTitle,
                                                                    aeQ: livesOveragePriceInCents,
                                                                    TA: manualBilling,
                                                                    UY: nextBillDate,
                                                                    WR: pmpmFeeInCents,
                                                                    Bt: products,
                                                                    Y2: revenueOveragePriceInCents,
                                                                    ah0: trancheBased,
                                                                    ah1: trancheMembersCount,
                                                                    aaD: txnFees
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$HintBillingComponent = $elm$core$Basics$identity;
    var $author$project$Api$Provider$HintBillingComponent$Shared$Record = function(id) {
        return function(quantity) {
            return function(name) {
                return function(description) {
                    return function(componentType) {
                        return function(unitName) {
                            return function(productType) {
                                return function(addonType) {
                                    return function(priceInCents) {
                                        return function(startDate) {
                                            return function(endDate) {
                                                return function(isBillable) {
                                                    return function(hintBillingProduct) {
                                                        return {
                                                            IG: addonType,
                                                            LT: componentType,
                                                            NQ: description,
                                                            qv: endDate,
                                                            QL: hintBillingProduct,
                                                            aef: id,
                                                            RS: isBillable,
                                                            zr: name,
                                                            Br: priceInCents,
                                                            G7: productType,
                                                            Bu: quantity,
                                                            _0: startDate,
                                                            aaH: unitName
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$HintBillingComponent$AddonType$Free = 3;
    var $author$project$Api$Provider$HintBillingComponent$AddonType$OneTime = 2;
    var $author$project$Api$Provider$HintBillingComponent$AddonType$Recurring = 0;
    var $author$project$Api$Provider$HintBillingComponent$AddonType$RecurringQuantified = 1;
    var $author$project$Api$Provider$HintBillingComponent$AddonType$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'recurring':
                return $elm$json$Json$Decode$succeed(0);
            case 'recurring_quantified':
                return $elm$json$Json$Decode$succeed(1);
            case 'one_time':
                return $elm$json$Json$Decode$succeed(2);
            case 'free':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail('Unsupported addon type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$HintBillingComponent$ComponentType$Addon = 1;
    var $author$project$Api$Provider$HintBillingComponent$ComponentType$BaseFee = 0;
    var $author$project$Api$Provider$HintBillingComponent$ComponentType$CliniciansPackage = 4;
    var $author$project$Api$Provider$HintBillingComponent$ComponentType$Discount = 5;
    var $author$project$Api$Provider$HintBillingComponent$ComponentType$LivesPackage = 2;
    var $author$project$Api$Provider$HintBillingComponent$ComponentType$RevenuePackage = 3;
    var $author$project$Api$Provider$HintBillingComponent$ComponentType$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'base_fee':
                return $elm$json$Json$Decode$succeed(0);
            case 'addon':
                return $elm$json$Json$Decode$succeed(1);
            case 'lives_package':
                return $elm$json$Json$Decode$succeed(2);
            case 'revenue_package':
                return $elm$json$Json$Decode$succeed(3);
            case 'discount':
                return $elm$json$Json$Decode$succeed(5);
            case 'clinicians_package':
                return $elm$json$Json$Decode$succeed(4);
            default:
                return $elm$json$Json$Decode$fail('Unsupported component type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$HintBillingComponent$ProductType$Clinical = 1;
    var $author$project$Api$Provider$HintBillingComponent$ProductType$Core = 0;
    var $author$project$Api$Provider$HintBillingComponent$ProductType$Thea = 2;
    var $author$project$Api$Provider$HintBillingComponent$ProductType$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'core':
                return $elm$json$Json$Decode$succeed(0);
            case 'clinical':
                return $elm$json$Json$Decode$succeed(1);
            case 'thea':
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail('Unsupported component type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$HintBillingComponent$UnitName$Clinician = 4;
    var $author$project$Api$Provider$HintBillingComponent$UnitName$Copilot = 5;
    var $author$project$Api$Provider$HintBillingComponent$UnitName$Dollar = 1;
    var $author$project$Api$Provider$HintBillingComponent$UnitName$Feed = 3;
    var $author$project$Api$Provider$HintBillingComponent$UnitName$Integration = 2;
    var $author$project$Api$Provider$HintBillingComponent$UnitName$Member = 0;
    var $author$project$Api$Provider$HintBillingComponent$UnitName$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'member':
                return $elm$json$Json$Decode$succeed(0);
            case 'dollar':
                return $elm$json$Json$Decode$succeed(1);
            case 'integration':
                return $elm$json$Json$Decode$succeed(2);
            case 'feed':
                return $elm$json$Json$Decode$succeed(3);
            case 'clinician':
                return $elm$json$Json$Decode$succeed(4);
            case 'copilot':
                return $elm$json$Json$Decode$succeed(5);
            default:
                return $elm$json$Json$Decode$fail('Unsupported unit name: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$HintBillingProduct$Shared$HintBillingProduct = $elm$core$Basics$identity;
    var $author$project$Api$Provider$HintBillingProduct$Shared$Record = F7(function(id, name, componentType, unitName, productType, addonType, archived) {
        return {
            IG: addonType,
            JC: archived,
            LT: componentType,
            aef: id,
            zr: name,
            G7: productType,
            aaH: unitName
        };
    });
    var $author$project$Api$Provider$HintBillingProduct$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'archived', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'addon_type', $elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$AddonType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product', $elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$ProductType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'unit_name', $elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$UnitName$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'component_type', $author$project$Api$Provider$HintBillingComponent$ComponentType$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$HintBillingProduct$Shared$Record))))))));
    var $author$project$Api$Provider$HintBillingProduct$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$HintBillingProduct$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$HintBillingComponent$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hint_billing_product', $author$project$Api$Provider$HintBillingProduct$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_billable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'addon_type', $elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$AddonType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product', $elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$ProductType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'unit_name', $elm$json$Json$Decode$nullable($author$project$Api$Provider$HintBillingComponent$UnitName$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'component_type', $author$project$Api$Provider$HintBillingComponent$ComponentType$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$HintBillingComponent$Shared$Record))))))))))))));
    var $author$project$Api$Provider$HintBillingComponent$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$HintBillingComponent$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$TxnFees$TxnFees = $elm$core$Basics$identity;
    var $author$project$Api$Provider$TxnFees$TxnFeesRecord = F6(function(totalAchFeeInCents, totalAchFeePercentage, totalAmexFeePercentage, totalCardFeeInCents, totalCardFeePercentage, achTransactionFeeCapInCents) {
        return {
            Io: achTransactionFeeCapInCents,
            aag: totalAchFeeInCents,
            aah: totalAchFeePercentage,
            aai: totalAmexFeePercentage,
            aaj: totalCardFeeInCents,
            HR: totalCardFeePercentage
        };
    });
    var $author$project$Api$Provider$TxnFees$txnFeesRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ach_transaction_fee_cap_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_card_fee_percentage', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_card_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_amex_fee_percentage', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_ach_fee_percentage', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_ach_fee_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$TxnFees$TxnFeesRecord)))))));
    var $author$project$Api$Provider$TxnFees$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TxnFees$txnFeesRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticePricing$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'current_members', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hubspot_deal_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'manual_billing', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'info_message_body', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'info_message_title', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tranche_members_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pmpm_fee_in_cents', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tranche_based', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'txn_fees', $author$project$Api$Provider$TxnFees$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'revenue_overage_price_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lives_overage_price_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'included_revenue', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'included_members', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'products', $elm$json$Json$Decode$list($author$project$Api$Provider$HintBillingComponent$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$One$Record))))))))))))))));
    var $author$project$Api$Provider$PracticePricing$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticePricing$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticePricing$practiceSettingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice/pricing'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PracticePricing$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PracticePricing$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$practiceSettingsPath));
    });
    var $author$project$Pages$Admin$Billing$fetchPracticePricing = function(apiClient) {
        return A2($author$project$Api$Provider$PracticePricing$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotPracticePricing);
    };
    var $author$project$Pages$Admin$Billing$GotUpgradePricing = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticePricing$Upgrade$UpgradePricing = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticePricing$Upgrade$Record = F6(function(tierName, currentTierName, totalInCents, nextBillDate, components, txnFees) {
        return {
            LU: components,
            MQ: currentTierName,
            UY: nextBillDate,
            $_: tierName,
            aam: totalInCents,
            aaD: txnFees
        };
    });
    var $author$project$Api$Provider$PracticePricing$Upgrade$componentDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'component_type', $author$project$Api$Provider$HintBillingComponent$ComponentType$decode, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'old_price_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed(F5(function(name, priceInCents, quantity, oldPriceInCents, componentType) {
        return {
            LT: componentType,
            zr: name,
            Vj: oldPriceInCents,
            Br: priceInCents,
            Bu: quantity
        };
    })))))));
    var $author$project$Api$Provider$PracticePricing$Upgrade$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'txn_fees', $author$project$Api$Provider$TxnFees$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'components', $elm$json$Json$Decode$list($author$project$Api$Provider$PracticePricing$Upgrade$componentDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'current_tier_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tier_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$Upgrade$Record)))))));
    var $author$project$Api$Provider$PracticePricing$Upgrade$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PracticePricing$Upgrade$recordDecoder);
    var $author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice',
        'pricing',
        'upgrade'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PracticePricing$Upgrade$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PracticePricing$Upgrade$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath));
    });
    var $author$project$Pages$Admin$Billing$fetchUpgradePricing = function(apiClient) {
        return A2($author$project$Api$Provider$PracticePricing$Upgrade$retrieve, apiClient, $author$project$Pages$Admin$Billing$GotUpgradePricing);
    };
    var $author$project$Pages$Admin$Billing$fetchPricingData = function(apiClient) {
        return _List_fromArray([
            $author$project$Pages$Admin$Billing$fetchApplicationFeePlan(apiClient),
            $author$project$Pages$Admin$Billing$fetchPracticePricing(apiClient),
            $author$project$Pages$Admin$Billing$fetchUpgradePricing(apiClient)
        ]);
    };
    var $author$project$Pages$Admin$Billing$GotUninvoicedCharges = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeCharge$All$PracticeCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeCharge$Shared$PracticeCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeCharge$Shared$Record = F7(function(id, description, serviceDescription, quantity, priceInCents, subtotalInCents, fromRecurringCharge) {
        return {
            NQ: description,
            P$: fromRecurringCharge,
            aef: id,
            Br: priceInCents,
            Bu: quantity,
            Z_: serviceDescription,
            $v: subtotalInCents
        };
    });
    var $author$project$Api$Provider$PracticeCharge$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'from_recurring_charge', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subtotal_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'service_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeCharge$Shared$Record))))))));
    var $author$project$Api$Provider$PracticeCharge$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeCharge$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticeCharge$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeCharge$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticeCharge$listDefaults = {
        RA: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$PracticeCharge$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$PracticeCharge$listDefaults);
        var _v0 = options.RA;
        if (!_v0.$) {
            var invoice = _v0.a;
            return _List_fromArray([
                A2($author$project$Api$Param$string, 'invoice', invoice)
            ]);
        } else return _List_Nil;
    };
    var $author$project$Api$Provider$PracticeCharge$practiceChargesPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'practice/charges'
        ]), basePath);
    };
    var $author$project$Api$Provider$PracticeCharge$list = F4(function(basePath, apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PracticeCharge$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$PracticeCharge$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeCharge$practiceChargesPath(basePath))));
    });
    var $author$project$Pages$Admin$Billing$fetchUninvoicedCharges = function(apiClient) {
        return A4($author$project$Api$Provider$PracticeCharge$list, $author$project$Api$Data$providerPath, apiClient, function(d) {
            return _Utils_update(d, {
                RA: $elm$core$Maybe$Just('')
            });
        }, $author$project$Pages$Admin$Billing$GotUninvoicedCharges);
    };
    var $author$project$Api$Provider$ManagementGroup$Shared$ManagementGroup = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ManagementGroup$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$ManagementGroup$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagementGroup$Shared$Record)));
    var $author$project$Api$Provider$ManagementGroup$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ManagementGroup$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ManagementGroup$resourcePath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'management_group'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagementGroup$getCurrent = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$ManagementGroup$Shared$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath));
    });
    var $author$project$Api$Provider$Practice$Shared$hasClinicalAccount = function(_v0) {
        var record = _v0;
        return record.Ql;
    };
    var $author$project$Api$Provider$Practice$One$hasClinicalAccount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$hasClinicalAccount(shared);
    };
    var $author$project$Components$HintBilling$InvoicesTable$Model = $elm$core$Basics$identity;
    var $author$project$Components$HintBilling$InvoicesTable$init = function(currentDate) {
        return {
            cP: currentDate,
            q5: _List_Nil,
            Tk: false
        };
    };
    var $author$project$Api$Feature$StripeCapital = 24;
    var $author$project$Api$Feature$toString = function(feature) {
        switch(feature){
            case 0:
                return 'commissions_tracking';
            case 6:
                return 'joint_product';
            case 3:
                return 'manually_disable_elation_sync';
            case 5:
                return 'membership_auto_renew_editable';
            case 1:
                return 'nonmonthly_sponsor_billing';
            case 4:
                return 'quickbooks_bypass_pmpm_check';
            case 7:
                return 'disable_sponsor_billing';
            case 2:
                return 'tobacco_surcharge';
            case 8:
                return 'custom_js_on_signup_pages';
            case 9:
                return 'report_access';
            case 10:
                return 'multi_language';
            case 11:
                return 'virtual_bank_account';
            case 12:
                return 'customizable_notifications_by_employer';
            case 13:
                return 'passthrough_credit_card_fees';
            case 14:
                return 'allow_stripe_card_readers';
            case 15:
                return 'accounting';
            case 16:
                return 'accounting_without_bookkeeping';
            case 17:
                return 'multiple_retail_memberships';
            case 18:
                return 'manage_data_exports';
            case 19:
                return 'unified_experience';
            case 20:
                return 'age_tiered_couple_rates';
            case 21:
                return 'pricing_versions';
            case 22:
                return 'packages';
            case 23:
                return 'self_buy';
            case 24:
                return 'stripe_capital';
            case 25:
                return 'marketplace_view_tiles';
            case 26:
                return 'nav_reorganization';
            case 27:
                return 'new_messaging_endpoint';
            default:
                return 'stripe_embedded_onboarding';
        }
    };
    var $author$project$Api$Provider$Practice$One$featureEnabled = function(feature) {
        return A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, A2($elm$core$Basics$composeR, function($) {
            return $.Px;
        }, $elm$core$List$member($author$project$Api$Feature$toString(feature))));
    };
    var $author$project$Api$Provider$Practice$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$Practice$One$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$paymentProcessor(shared);
    };
    var $author$project$Pages$Admin$Billing$shouldShowCapitalTile = function(practice) {
        return $author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe' && A2($author$project$Api$Provider$Practice$One$featureEnabled, 24, practice);
    };
    var $author$project$Components$HintBilling$InvoicesTable$withLoadingStatus = F2(function(loadingStatus, _v0) {
        var record = _v0;
        return _Utils_update(record, {
            Tk: loadingStatus
        });
    });
    var $author$project$Pages$Admin$Billing$init = F4(function(session, practice, shared, _v0) {
        var model = {
            Ej: shared.Ej,
            pF: $author$project$Api$Data$Loading,
            v1: $elm$core$Maybe$Nothing,
            pN: $author$project$Api$Data$NotAsked,
            pQ: $author$project$Api$Data$Loading,
            hZ: $elm$core$Maybe$Nothing,
            cP: shared.cP,
            mi: $author$project$Api$Data$Loading,
            Ql: $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice),
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            eo: $author$project$Api$Pagination$init,
            Bb: $author$project$Api$Data$Loading,
            jB: A2($author$project$Components$HintBilling$InvoicesTable$withLoadingStatus, true, $author$project$Components$HintBilling$InvoicesTable$init(shared.cP)),
            cl: $author$project$Api$Data$Loading,
            Z$: session,
            HO: shared.HO,
            oZ: _List_Nil,
            cu: $author$project$Pages$Admin$Billing$NotInitialized,
            o5: $elm$core$Maybe$Nothing,
            kF: $elm$core$Maybe$Nothing
        };
        var managementGroupCmd = $author$project$Pages$Admin$Billing$shouldShowCapitalTile(practice) ? A2($author$project$Api$Provider$ManagementGroup$getCurrent, shared.Ej, $author$project$Pages$Admin$Billing$GotManagementGroup) : $elm$core$Platform$Cmd$none;
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, managementGroupCmd, A2($elm$core$List$cons, A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, shared.Ej, model.eo), A2($elm$core$List$cons, $author$project$Pages$Admin$Billing$fetchCards(shared.Ej), A2($elm$core$List$cons, $author$project$Pages$Admin$Billing$fetchBankAccounts(shared.Ej), A2($elm$core$List$cons, $author$project$Pages$Admin$Billing$fetchUninvoicedCharges(shared.Ej), $author$project$Pages$Admin$Billing$fetchPricingData(shared.Ej))))))));
    });
    var $author$project$Pages$Admin$Billing$load = F2(function(shared, model) {
        var _v0 = _Utils_Tuple2(shared.W1, shared.Z$);
        if (_v0.a.$ === 3 && !_v0.a.a.$ && _v0.b.$ === 3) {
            var _v1 = _v0.a;
            var practice = _v1.a.a;
            var _v2 = _v0.b;
            return _Utils_Tuple2(_Utils_update(model, {
                Ej: shared.Ej,
                W1: practice
            }), $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Billing$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Billing$CapitalOfferLoaded = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$CreateChargeModalMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$UpdateModalMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Ports$Stripe$stripePortOnCapitalOfferLoaded = _Platform_incomingPort('stripePortOnCapitalOfferLoaded', $elm$json$Json$Decode$string);
    var $author$project$Ports$Stripe$onCapitalOfferLoaded = $author$project$Ports$Stripe$stripePortOnCapitalOfferLoaded;
    var $author$project$Components$ApplicationFeePlan$UpdateModal$Close = {
        $: 0
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$ApplicationFeePlan$UpdateModal$Close);
    };
    var $author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked = {
        $: 0
    };
    var $author$project$Components$HintBilling$CreateChargeModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked);
    };
    var $author$project$Components$UpgradePracticeModal$Close = {
        $: 0
    };
    var $author$project$Components$UpgradePracticeModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$UpgradePracticeModal$Close);
    };
    var $author$project$Pages$Admin$Billing$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v0 = model.cu;
                if (!_v0.$) return $elm$core$Platform$Sub$none;
                else {
                    var updateModal = _v0.b;
                    return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, $author$project$Components$ApplicationFeePlan$UpdateModal$subscriptions(updateModal));
                }
            }(),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Billing$CreateChargeModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$HintBilling$CreateChargeModal$subscriptions, model.hZ))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$UpgradePracticeModal$subscriptions, model.kF))),
            $author$project$Ports$Stripe$onCapitalOfferLoaded($author$project$Pages$Admin$Billing$CapitalOfferLoaded)
        ]));
    };
    var $author$project$Pages$Admin$Billing$GotCapitalSession = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$Initialized = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Billing$InvoiceCreated = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeChargeDeleted = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PracticeInvoice$One$PracticeInvoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PracticeInvoice$One$Record = F9(function(autoPayEnabled, autoPayDate, invoiceType, securePdfInlineToken, securePdfPrintableToken, source, payments, charges, purchaseOrderNumber) {
        return {
            JV: autoPayDate,
            JW: autoPayEnabled,
            K9: charges,
            RL: invoiceType,
            Wt: payments,
            XO: purchaseOrderNumber,
            ZC: securePdfInlineToken,
            aha: securePdfPrintableToken,
            Hw: source
        };
    });
    var $author$project$Api$Common$Source$Shared$Source = $elm$core$Basics$identity;
    var $author$project$Api$Common$Source$Shared$Record = function(type_) {
        return function(id) {
            return function(name) {
                return function(label) {
                    return function(status) {
                        return function(lastFour) {
                            return function(createdAt) {
                                return function(external) {
                                    return function(oneTimeUse) {
                                        return function(paymentProcessor) {
                                            return function(funding) {
                                                return {
                                                    Mx: createdAt,
                                                    Po: external,
                                                    P1: funding,
                                                    aef: id,
                                                    aeI: label,
                                                    ST: lastFour,
                                                    zr: name,
                                                    Vu: oneTimeUse,
                                                    Wo: paymentProcessor,
                                                    ahy: status,
                                                    ah5: type_
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Common$Source$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'funding', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'payment_processor', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'one_time_use', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'external', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'created_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'last_four', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Api$Common$Source$Shared$Record))))))))))));
    var $author$project$Api$Common$Source$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Source$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$File$Token$Token = $elm$core$Basics$identity;
    var $author$project$Api$File$Token$decoder = A2($elm$json$Json$Decode$map, function(string) {
        return string;
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Payment$One$Payment = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Payment$Shared$Payment = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Payment$Shared$Record = function(id) {
        return function(status) {
            return function(amountInCents) {
                return function(attemptedInCents) {
                    return function(paidAt) {
                        return function(createdAt) {
                            return function(errorMessage) {
                                return function(external) {
                                    return function(memo) {
                                        return function(isRefundable) {
                                            return function(isRefundableOnPaymentProcessor) {
                                                return function(source) {
                                                    return function(passthroughFees) {
                                                        return function(paymentProcessor) {
                                                            return function(cardReader) {
                                                                return function(isCancelable) {
                                                                    return function(errorCode) {
                                                                        return {
                                                                            Jh: amountInCents,
                                                                            JL: attemptedInCents,
                                                                            ace: cardReader,
                                                                            Mx: createdAt,
                                                                            O3: errorCode,
                                                                            O4: errorMessage,
                                                                            Po: external,
                                                                            aef: id,
                                                                            RU: isCancelable,
                                                                            Sn: isRefundable,
                                                                            So: isRefundableOnPaymentProcessor,
                                                                            ae0: memo,
                                                                            VQ: paidAt,
                                                                            V4: passthroughFees,
                                                                            Wo: paymentProcessor,
                                                                            Hw: source,
                                                                            ahy: status
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CardReader$Shared$CardReader = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CardReader$Shared$Record = F4(function(id, label, serialNumber, paymentProcessor) {
        return {
            aef: id,
            aeI: label,
            Wo: paymentProcessor,
            ZW: serialNumber
        };
    });
    var $author$project$Api$Provider$CardReader$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'serial_number', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$Shared$Record)))));
    var $author$project$Api$Provider$CardReader$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CardReader$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Payment$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_code', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_cancelable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'card_reader', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CardReader$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'passthrough_fees', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_refundable_on_payment_processor', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_refundable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'memo', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'attempted_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$Shared$Record))))))))))))))))));
    var $author$project$Api$Provider$Payment$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Payment$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Payment$One$Record = F3(function(createdBy, refunds, dispute) {
        return {
            My: createdBy,
            N7: dispute,
            Yr: refunds
        };
    });
    var $author$project$Api$Provider$Dispute$Shared$Dispute = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Dispute$Shared$Record = F2(function(id, status) {
        return {
            aef: id,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Dispute$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Dispute$Shared$Record)));
    var $author$project$Api$Provider$Dispute$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Dispute$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Payment$Creator$Creator = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Payment$Creator$Record = function(name) {
        return {
            zr: name
        };
    };
    var $author$project$Api$Provider$Payment$Creator$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$Creator$Record));
    var $author$project$Api$Provider$Payment$Creator$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Payment$Creator$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Refund$One$Refund = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Refund$Shared$Refund = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Refund$Shared$Record = F8(function(id, status, createdAt, external, memo, amountInCents, paymentProcessor, errorMessage) {
        return {
            Jh: amountInCents,
            Mx: createdAt,
            O4: errorMessage,
            Po: external,
            aef: id,
            ae0: memo,
            Wo: paymentProcessor,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Refund$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'memo', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$Shared$Record)))))))));
    var $author$project$Api$Provider$Refund$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Refund$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Refund$One$Record = function(createdBy) {
        return {
            My: createdBy
        };
    };
    var $author$project$Api$Provider$User$Shared$User = $elm$core$Basics$identity;
    var $author$project$Api$Provider$User$Shared$Record = F3(function(name, displayName, isAdmin) {
        return {
            N6: displayName,
            RO: isAdmin,
            zr: name
        };
    });
    var $author$project$Api$Provider$User$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_admin', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'display_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$User$Shared$Record))));
    var $author$project$Api$Provider$User$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$User$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Refund$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_by', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$One$Record));
    var $author$project$Api$Provider$Refund$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Refund$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Refund$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Refund$One$Refund)));
    var $author$project$Api$Provider$Payment$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'dispute', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Dispute$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'refunds', $elm$json$Json$Decode$list($author$project$Api$Provider$Refund$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_by', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Payment$Creator$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$One$Record))));
    var $author$project$Api$Provider$Payment$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Payment$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Payment$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$One$Payment)));
    var $author$project$Api$Provider$PracticeInvoice$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'purchase_order_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charges', $elm$json$Json$Decode$list($author$project$Api$Provider$PracticeCharge$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payments', $elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_printable_token', $author$project$Api$File$Token$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_inline_token', $author$project$Api$File$Token$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_pay_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_pay_enabled', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$One$Record))))))))));
    var $author$project$Api$Provider$PracticeInvoice$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeInvoice$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeInvoice$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeInvoice$One$PracticeInvoice)));
    var $author$project$Api$Provider$PracticeInvoice$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeInvoice$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath));
    });
    var $author$project$Api$Provider$PracticeCharge$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$PracticeCharge$practiceChargesPath($author$project$Api$Data$providerPath))));
    });
    var $author$project$Api$Provider$PracticeCharge$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$PracticeCharge$All$description = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeCharge$Shared$description(shared);
    };
    var $author$project$Api$Provider$PracticePricing$One$hubspotDealUrl = function(_v0) {
        var record = _v0;
        return record.QU;
    };
    var $author$project$Api$Provider$PracticeCharge$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PracticeCharge$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeCharge$Shared$id(shared);
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$GotCategories = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$isBillable = function(_v0) {
        var record = _v0;
        return record.RS;
    };
    var $author$project$Api$Provider$PracticePricing$One$billableProducts = function(_v0) {
        var record = _v0;
        return A2($elm$core$List$filter, function(product) {
            return $author$project$Api$Provider$HintBillingComponent$Shared$isBillable(product);
        }, record.Bt);
    };
    var $author$project$Formatters$Date$Full = {
        $: 0
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$componentType = function(_v0) {
        var record = _v0;
        return record.LT;
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Currency$Currency = $elm$core$Basics$identity;
    var $myrho$elm_round$Round$funNum = F3(function(fun, s, fl) {
        return A2($elm$core$Maybe$withDefault, 0 / 0, $elm$core$String$toFloat(A2(fun, s, fl)));
    });
    var $myrho$elm_round$Round$addSign = F2(function(signed, str) {
        var isNotZero = A2($elm$core$List$any, function(c) {
            return c !== '0' && c !== '.';
        }, $elm$core$String$toList(str));
        return _Utils_ap(signed && isNotZero ? '-' : '', str);
    });
    var $elm$core$Char$fromCode = _Char_fromCode;
    var $myrho$elm_round$Round$increaseNum = function(_v0) {
        var head = _v0.a;
        var tail = _v0.b;
        if (head === '9') {
            var _v1 = $elm$core$String$uncons(tail);
            if (_v1.$ === 1) return '01';
            else {
                var headtail = _v1.a;
                return A2($elm$core$String$cons, '0', $myrho$elm_round$Round$increaseNum(headtail));
            }
        } else {
            var c = $elm$core$Char$toCode(head);
            return c >= 48 && c < 57 ? A2($elm$core$String$cons, $elm$core$Char$fromCode(c + 1), tail) : '0';
        }
    };
    var $elm$core$Basics$isInfinite = _Basics_isInfinite;
    var $elm$core$Basics$isNaN = _Basics_isNaN;
    var $elm$core$String$padRight = F3(function(n, _char, string) {
        return _Utils_ap(string, A2($elm$core$String$repeat, n - $elm$core$String$length(string), $elm$core$String$fromChar(_char)));
    });
    var $elm$core$String$reverse = _String_reverse;
    var $myrho$elm_round$Round$splitComma = function(str) {
        var _v0 = A2($elm$core$String$split, '.', str);
        if (_v0.b) {
            if (_v0.b.b) {
                var before = _v0.a;
                var _v1 = _v0.b;
                var after = _v1.a;
                return _Utils_Tuple2(before, after);
            } else {
                var before = _v0.a;
                return _Utils_Tuple2(before, '0');
            }
        } else return _Utils_Tuple2('0', '0');
    };
    var $myrho$elm_round$Round$toDecimal = function(fl) {
        var _v0 = A2($elm$core$String$split, 'e', $elm$core$String$fromFloat($elm$core$Basics$abs(fl)));
        if (_v0.b) {
            if (_v0.b.b) {
                var num = _v0.a;
                var _v1 = _v0.b;
                var exp = _v1.a;
                var e = A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
                var _v2 = $myrho$elm_round$Round$splitComma(num);
                var before = _v2.a;
                var after = _v2.b;
                var total = _Utils_ap(before, after);
                var zeroed = e < 0 ? A2($elm$core$Maybe$withDefault, '0', A2($elm$core$Maybe$map, function(_v3) {
                    var a = _v3.a;
                    var b = _v3.b;
                    return a + ('.' + b);
                }, A2($elm$core$Maybe$map, $elm$core$Tuple$mapFirst($elm$core$String$fromChar), $elm$core$String$uncons(_Utils_ap(A2($elm$core$String$repeat, $elm$core$Basics$abs(e), '0'), total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
                return _Utils_ap(fl < 0 ? '-' : '', zeroed);
            } else {
                var num = _v0.a;
                return _Utils_ap(fl < 0 ? '-' : '', num);
            }
        } else return '';
    };
    var $myrho$elm_round$Round$roundFun = F3(function(functor, s, fl) {
        if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) return $elm$core$String$fromFloat(fl);
        else {
            var signed = fl < 0;
            var _v0 = $myrho$elm_round$Round$splitComma($myrho$elm_round$Round$toDecimal($elm$core$Basics$abs(fl)));
            var before = _v0.a;
            var after = _v0.b;
            var r = $elm$core$String$length(before) + s;
            var normalized = _Utils_ap(A2($elm$core$String$repeat, -r + 1, '0'), A3($elm$core$String$padRight, r, '0', _Utils_ap(before, after)));
            var totalLen = $elm$core$String$length(normalized);
            var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
            var increase = A2(functor, signed, A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
            var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
            var num = increase ? $elm$core$String$reverse(A2($elm$core$Maybe$withDefault, '1', A2($elm$core$Maybe$map, $myrho$elm_round$Round$increaseNum, $elm$core$String$uncons($elm$core$String$reverse(remains))))) : remains;
            var numLen = $elm$core$String$length(num);
            var numZeroed = num === '0' ? num : s <= 0 ? _Utils_ap(num, A2($elm$core$String$repeat, $elm$core$Basics$abs(s), '0')) : _Utils_cmp(s, $elm$core$String$length(after)) < 0 ? A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num)) : _Utils_ap(before + '.', A3($elm$core$String$padRight, s, '0', after));
            return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
        }
    });
    var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(F2(function(signed, str) {
        var _v0 = $elm$core$String$uncons(str);
        if (_v0.$ === 1) return false;
        else if ('5' === _v0.a.a) {
            if (_v0.a.b === '') {
                var _v1 = _v0.a;
                return !signed;
            } else {
                var _v2 = _v0.a;
                return true;
            }
        } else {
            var _v3 = _v0.a;
            var _int = _v3.a;
            return function(i) {
                return i > 53 && signed || i >= 53 && !signed;
            }($elm$core$Char$toCode(_int));
        }
    }));
    var $myrho$elm_round$Round$roundNum = $myrho$elm_round$Round$funNum($myrho$elm_round$Round$round);
    var $author$project$Utils$Round$float = function(value) {
        return A2($myrho$elm_round$Round$roundNum, 5, value);
    };
    var $author$project$Currency$fromFloat = function(_float) {
        return $elm$core$String$fromFloat($author$project$Utils$Round$float(_float / 100));
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$hintBillingProduct = function(_v0) {
        var record = _v0;
        return record.QL;
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$HintBillingProduct$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents = function(_v0) {
        var record = _v0;
        return record.Br;
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$quantity = function(_v0) {
        var record = _v0;
        return record.Bu;
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $justinmimbs$date$Date$Days = 3;
    var $justinmimbs$date$Date$toMonths = function(rd) {
        var date = $justinmimbs$date$Date$toCalendarDate(rd);
        var wholeMonths = 12 * (date.ail - 1) + ($justinmimbs$date$Date$monthToNumber(date.ae6) - 1);
        return wholeMonths + date.acP / 100;
    };
    var $elm$core$Basics$truncate = _Basics_truncate;
    var $justinmimbs$date$Date$diff = F3(function(unit, _v0, _v1) {
        var rd1 = _v0;
        var rd2 = _v1;
        switch(unit){
            case 0:
                return ($justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1) | 0) / 12 | 0;
            case 1:
                return $justinmimbs$date$Date$toMonths(rd2) - $justinmimbs$date$Date$toMonths(rd1) | 0;
            case 2:
                return (rd2 - rd1) / 7 | 0;
            default:
                return rd2 - rd1;
        }
    });
    var $author$project$Formatters$Date$relative = F3(function(currentDate, option, date) {
        var diff = A3($justinmimbs$date$Date$diff, 3, currentDate, date);
        return !_Utils_eq(option, $elm$core$Maybe$Just('bill')) && _Utils_cmp(diff, -1) < 1 ? _Utils_cmp(diff, -7) < 1 ? A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date) : _Utils_cmp(diff, -2) < 1 ? $elm$core$String$fromInt(-1 * diff) + ' days ago' : 'Yesterday' : diff <= 0 ? 'Today' : diff === 1 ? 'Tomorrow' : diff < 7 ? 'in ' + ($elm$core$String$fromInt(diff) + ' days') : A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date);
    });
    var $author$project$Formatters$Date$timeago = F3(function(currentDate, type_, date) {
        var diff = A3($justinmimbs$date$Date$diff, 3, date, currentDate);
        return _Utils_eq(type_, $elm$core$Maybe$Just('days')) && !diff ? 'today' : _Utils_eq(type_, $elm$core$Maybe$Just('days')) && diff === 1 ? 'tomorrow' : A3($author$project$Formatters$Date$relative, currentDate, $elm$core$Maybe$Nothing, date);
    });
    var $author$project$Formatters$Date$toString = F2(function(format, date) {
        switch(format.$){
            case 0:
                return A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
            case 1:
                return A2($justinmimbs$date$Date$format, 'MMMM ddd', date);
            case 2:
                return A2($justinmimbs$date$Date$format, 'MMMM yyyy', date);
            case 3:
                return A2($justinmimbs$date$Date$format, 'MMMM ddd, yyyy', date);
            case 4:
                var currentDate = format.a;
                var option = format.b;
                return A3($author$project$Formatters$Date$relative, currentDate, option, date);
            default:
                var currentDate = format.a;
                var type_ = format.b;
                return A3($author$project$Formatters$Date$timeago, currentDate, type_, date);
        }
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initHintCustomerProduct = function(charge) {
        var priceInCents = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(charge);
        return {
            NQ: $author$project$Api$Provider$HintBillingComponent$Shared$description(charge),
            qv: $author$project$Api$Provider$HintBillingComponent$Shared$endDate(charge),
            xx: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$HintBillingComponent$Shared$endDate(charge))),
            iP: $author$project$Api$Provider$HintBillingComponent$Shared$componentType(charge),
            QM: $author$project$Api$Provider$HintBillingProduct$Shared$id($author$project$Api$Provider$HintBillingComponent$Shared$hintBillingProduct(charge)),
            aef: $elm$core$Maybe$Just($author$project$Api$Provider$HintBillingComponent$Shared$id(charge)),
            Br: $elm$core$Maybe$Just($author$project$Currency$fromFloat(priceInCents)),
            Bu: A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$HintBillingComponent$Shared$quantity(charge)),
            _0: $author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge),
            _2: A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge))
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initFormFieldsFromPracticePlan = function(charges) {
        var recurringCharges = A2($elm$core$List$map, $author$project$Components$ApplicationFeePlan$UpdateModalForm$initHintCustomerProduct, charges);
        return {
            J8: $elm$core$Maybe$Nothing,
            K9: recurringCharges,
            QT: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$init = function(charges) {
        return $author$project$Utils$Form$init($author$project$Components$ApplicationFeePlan$UpdateModalForm$initFormFieldsFromPracticePlan(charges));
    };
    var $author$project$Api$Provider$PracticePricing$One$isLegacyPricing = function(practicePricing) {
        return $elm$core$List$isEmpty(A2($elm$core$List$filter, function(billingComponent) {
            return !$author$project$Api$Provider$HintBillingComponent$Shared$componentType(billingComponent);
        }, $author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing)));
    };
    var $author$project$Api$Provider$HintBillingProduct$billingComponentsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'billing_components'
    ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'pricing'
    ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice'
    ]), $author$project$Api$Data$providerPath)));
    var $author$project$Api$Provider$HintBillingProduct$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$HintBillingProduct$Shared$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$HintBillingProduct$billingComponentsPath));
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$init = F4(function(apiClient, currentDate, practicePricing, hubspotDealUrl) {
        var charges = $author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing);
        return _Utils_Tuple2({
            K0: _List_Nil,
            K9: charges,
            cP: currentDate,
            PU: $author$project$Components$ApplicationFeePlan$UpdateModalForm$init(charges),
            QU: hubspotDealUrl,
            aeD: !$author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing),
            cj: $elm$core$Dict$empty,
            jH: $jinjor$elm_debounce$Debounce$init
        }, A2($author$project$Api$Provider$HintBillingProduct$list, apiClient, $author$project$Components$ApplicationFeePlan$UpdateModal$GotCategories));
    });
    var $author$project$Components$HintBilling$CreateChargeModal$GotCategories = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$HintBilling$CreateChargeModal$formFieldInit = function(practiceInvoice) {
        return {
            iP: $elm$core$Maybe$Nothing,
            QL: $elm$core$Maybe$Nothing,
            zr: '',
            W3: practiceInvoice,
            Br: $elm$core$Maybe$Nothing,
            Bu: $elm$core$Maybe$Just(1)
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$init = F2(function(apiClient, practiceInvoice) {
        return _Utils_Tuple2({
            K0: _List_Nil,
            PU: $author$project$Utils$Form$init($author$project$Components$HintBilling$CreateChargeModal$formFieldInit(practiceInvoice)),
            nv: $elm$core$Maybe$Nothing,
            jH: $jinjor$elm_debounce$Debounce$init
        }, A2($author$project$Api$Provider$HintBillingProduct$list, apiClient, $author$project$Components$HintBilling$CreateChargeModal$GotCategories));
    });
    var $author$project$Api$Provider$PracticePricing$Upgrade$currentTierName = function(_v0) {
        var record = _v0;
        return record.MQ;
    };
    var $author$project$Api$Platform$Session$One$organizationIsCompany = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq(1), A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.VA)));
    };
    var $author$project$Utils$Analytics$Shared$AnalyticsProperty = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Utils$Analytics$Shared$property = F2(function(key, value) {
        return A2($author$project$Utils$Analytics$Shared$AnalyticsProperty, key, value);
    });
    var $author$project$Utils$Analytics$Shared$appProperty = function(session) {
        var organizationIsCompany = $author$project$Api$Platform$Session$One$organizationIsCompany(session);
        var appName = organizationIsCompany ? 'employer' : 'core';
        return A2($author$project$Utils$Analytics$Shared$property, 'app', appName);
    };
    var $author$project$Utils$Analytics$HintBilling$currentTierProperty = function(value) {
        return A2($author$project$Utils$Analytics$Shared$property, 'current_tier', value);
    };
    var $elm$json$Json$Encode$dict = F3(function(toKey, toValue, dictionary) {
        return _Json_wrap(A3($elm$core$Dict$foldl, F3(function(key, value, obj) {
            return A3(_Json_addField, toKey(key), toValue(value), obj);
        }), _Json_emptyObject(0), dictionary));
    });
    var $author$project$Ports$FullStory$encodeEvent = F2(function(type_, payload) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('type', $elm$json$Json$Encode$string(type_)),
            _Utils_Tuple2('payload', payload)
        ]));
    });
    var $author$project$Ports$FullStory$encodeSimpleEvent = F2(function(type_, payload) {
        return A2($author$project$Ports$FullStory$encodeEvent, type_, A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, $elm$core$Dict$fromList(payload)));
    });
    var $author$project$Ports$FullStory$fullStoryPortLogEvent = _Platform_outgoingPort('fullStoryPortLogEvent', $elm$core$Basics$identity);
    var $author$project$Ports$FullStory$logEvent = F2(function(type_, payload) {
        return $author$project$Ports$FullStory$fullStoryPortLogEvent(A2($author$project$Ports$FullStory$encodeSimpleEvent, type_, payload));
    });
    var $author$project$Ports$Intercom$encodeEvent = F2(function(type_, payload) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('type', $elm$json$Json$Encode$string(type_)),
            _Utils_Tuple2('payload', payload)
        ]));
    });
    var $author$project$Ports$Intercom$encodeSimpleEvent = F2(function(type_, payload) {
        return A2($author$project$Ports$Intercom$encodeEvent, type_, A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$json$Json$Encode$string, $elm$core$Dict$fromList(payload)));
    });
    var $author$project$Ports$Intercom$intercomPortLogEvent = _Platform_outgoingPort('intercomPortLogEvent', $elm$core$Basics$identity);
    var $author$project$Ports$Intercom$logEvent = F2(function(type_, payload) {
        return $author$project$Ports$Intercom$intercomPortLogEvent(A2($author$project$Ports$Intercom$encodeSimpleEvent, type_, payload));
    });
    var $author$project$Utils$Analytics$Shared$propertyToTuple = function(_v0) {
        var key = _v0.a;
        var value = _v0.b;
        return _Utils_Tuple2(key, value);
    };
    var $author$project$Utils$Analytics$Shared$logSimpleEvent = F2(function(eventName, properties) {
        var propertyTuples = A2($elm$core$List$map, $author$project$Utils$Analytics$Shared$propertyToTuple, properties);
        return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Ports$FullStory$logEvent, eventName, propertyTuples),
            A2($author$project$Ports$Intercom$logEvent, eventName, propertyTuples)
        ]));
    });
    var $author$project$Utils$Analytics$HintBilling$newTierProperty = function(value) {
        return A2($author$project$Utils$Analytics$Shared$property, 'new_tier', value);
    };
    var $author$project$Utils$Analytics$HintBilling$logEventWithTiers = F4(function(session, currentTier, newTier, eventName) {
        return A2($author$project$Utils$Analytics$Shared$logSimpleEvent, eventName, _List_fromArray([
            $author$project$Utils$Analytics$Shared$appProperty(session),
            $author$project$Utils$Analytics$HintBilling$currentTierProperty(currentTier),
            $author$project$Utils$Analytics$HintBilling$newTierProperty(newTier)
        ]));
    });
    var $author$project$Api$Provider$PracticePricing$Upgrade$tierName = function(_v0) {
        var record = _v0;
        return record.$_;
    };
    var $author$project$Components$UpgradePracticeModal$logActionPerformedEvent = F3(function(session, pricing, eventName) {
        if (!pricing.$) {
            var pricing_ = pricing.a;
            return A4($author$project$Utils$Analytics$HintBilling$logEventWithTiers, session, $author$project$Api$Provider$PracticePricing$Upgrade$currentTierName(pricing_), $author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing_), eventName);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$UpgradePracticeModal$init = F3(function(upgradePricing, session, hasClinicalAccount) {
        return _Utils_Tuple2({
            abC: false,
            Ql: hasClinicalAccount,
            i_: false,
            Z$: session,
            hc: upgradePricing
        }, A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, session, upgradePricing, 'Self Buy Upgrade Modal Opened'));
    });
    var $author$project$Utils$Analytics$HintBilling$linkTextProperty = function(value) {
        return A2($author$project$Utils$Analytics$Shared$property, 'link_text', value);
    };
    var $author$project$Utils$Analytics$HintBilling$targetUrlProperty = function(value) {
        return A2($author$project$Utils$Analytics$Shared$property, 'target_url', value);
    };
    var $author$project$Utils$Analytics$HintBilling$logLinkClickedEvent = F3(function(session, linkText, targetUrl) {
        return A2($author$project$Utils$Analytics$Shared$logSimpleEvent, 'Self Buy Upgrade Link Clicked', _List_fromArray([
            $author$project$Utils$Analytics$Shared$appProperty(session),
            $author$project$Utils$Analytics$HintBilling$linkTextProperty(linkText),
            $author$project$Utils$Analytics$HintBilling$targetUrlProperty(targetUrl)
        ]));
    });
    var $author$project$Ports$Stripe$stripePortMountCapitalPromoTile = _Platform_outgoingPort('stripePortMountCapitalPromoTile', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('selector', $elm$json$Json$Encode$string($.bi)),
            _Utils_Tuple2('stripeClientSecret', $elm$json$Json$Encode$string($.oF))
        ]));
    });
    var $author$project$Ports$Stripe$mountCapitalPromoTile = F2(function(selector, stripeClientSecret) {
        return $author$project$Ports$Stripe$stripePortMountCapitalPromoTile({
            bi: selector,
            oF: stripeClientSecret
        });
    });
    var $author$project$Ports$Navigation$navigationLoad = _Platform_outgoingPort('navigationLoad', $elm$json$Json$Encode$string);
    var $author$project$Ports$Navigation$load = $author$project$Ports$Navigation$navigationLoad;
    var $author$project$Utils$Route$navigateAndReload = F2(function(params, route) {
        return $author$project$Ports$Navigation$load(A2($author$project$Utils$Route$toString, params, route));
    });
    var $author$project$Pages$Admin$Billing$GotChargeCreated = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeCharge$One$PracticeCharge = 0;
    var $author$project$Api$Provider$PracticeCharge$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Utils$Encode$association = function(id) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string(id))
        ]));
    };
    var $elm$json$Json$Encode$float = _Json_wrap;
    var $author$project$Api$Provider$PracticeCharge$encodeChargeParams = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('description', $elm$json$Json$Encode$string(fields.NQ)),
            _Utils_Tuple2('quantity', $elm$json$Json$Encode$int(fields.Bu)),
            _Utils_Tuple2('price_in_cents', $elm$json$Json$Encode$float(fields.Br)),
            _Utils_Tuple2('hint_billing_product', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.QM))
        ]));
    };
    var $author$project$Api$Provider$PracticeCharge$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('charge', $author$project$Api$Provider$PracticeCharge$encodeChargeParams(fields))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeCharge$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeCharge$practiceChargesPath($author$project$Api$Data$providerPath))));
    });
    var $author$project$Pages$Admin$Billing$saveCharge = F2(function(apiClient, chargeParams) {
        return A3($author$project$Api$Provider$PracticeCharge$create, apiClient, chargeParams, $author$project$Pages$Admin$Billing$GotChargeCreated);
    });
    var $author$project$Api$Provider$Practice$StripeAccount$sessionDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'session_key'
    ]), $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'stripe_account'
    ]), $author$project$Api$Provider$Practice$practicePath);
    var $author$project$Api$Provider$Practice$StripeAccount$session = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$StripeAccount$sessionDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'session'
        ]), $author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
    });
    var $author$project$Api$Pagination$totalCountFromHeaders = F2(function(headers, _v0) {
        var model = _v0;
        var totalCount = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
        return _Utils_update(model, {
            oQ: totalCount
        });
    });
    var $author$project$Api$Pagination$update = F2(function(msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var _int = msg.a;
            return _Utils_update(model, {
                bt: _int
            });
        } else {
            var _int = msg.a;
            return _Utils_update(model, {
                bt: 1,
                fY: _int
            });
        }
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$ApplicationFeePlanUpdated = 2;
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$Closed = 1;
    var $author$project$Components$ApplicationFeePlan$UpdateModal$HubspotDealUpdated = 3;
    var $author$project$Components$ApplicationFeePlan$UpdateModal$None = 0;
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$OutMsg$RefreshPractice = {
        $: 2
    };
    var $author$project$Ui$Toast$Warning = 2;
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeComponentTypeChanged = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Currency$toString = function(_v0) {
        var string = _v0;
        return string;
    };
    var $author$project$Currency$toFloat = A2($elm$core$Basics$composeR, $author$project$Currency$toString, A2($elm$core$Basics$composeR, $elm$core$String$toFloat, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$core$Basics$mul(100)), $elm$core$Maybe$map($author$project$Utils$Round$float))));
    var $author$project$Utils$Billing$ProductPrice$convertPriceInCents = F2(function(currencyPrice, componentType) {
        return A2($elm$core$Maybe$andThen, function(priceInCents) {
            if (!priceInCents) return currencyPrice;
            else {
                var absPrice = $elm$core$Basics$abs(priceInCents);
                var normalizedPrice = function() {
                    if (!componentType.$ && componentType.a === 5) {
                        var _v1 = componentType.a;
                        return -absPrice;
                    } else return absPrice;
                }();
                return $elm$core$Maybe$Just($author$project$Currency$fromFloat(normalizedPrice));
            }
        }, A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, currencyPrice));
    });
    var $elm$core$List$drop = F2(function(n, list) {
        drop: while(true){
            if (n <= 0) return list;
            else {
                if (!list.b) return list;
                else {
                    var x = list.a;
                    var xs = list.b;
                    var $temp$n = n - 1, $temp$list = xs;
                    n = $temp$n;
                    list = $temp$list;
                    continue drop;
                }
            }
        }
    });
    var $elm_community$list_extra$List$Extra$getAt = F2(function(idx, xs) {
        return idx < 0 ? $elm$core$Maybe$Nothing : $elm$core$List$head(A2($elm$core$List$drop, idx, xs));
    });
    var $elm$core$List$takeReverse = F3(function(n, list, kept) {
        takeReverse: while(true){
            if (n <= 0) return kept;
            else {
                if (!list.b) return kept;
                else {
                    var x = list.a;
                    var xs = list.b;
                    var $temp$n = n - 1, $temp$list = xs, $temp$kept = A2($elm$core$List$cons, x, kept);
                    n = $temp$n;
                    list = $temp$list;
                    kept = $temp$kept;
                    continue takeReverse;
                }
            }
        }
    });
    var $elm$core$List$takeTailRec = F2(function(n, list) {
        return $elm$core$List$reverse(A3($elm$core$List$takeReverse, n, list, _List_Nil));
    });
    var $elm$core$List$takeFast = F3(function(ctr, n, list) {
        if (n <= 0) return _List_Nil;
        else {
            var _v0 = _Utils_Tuple2(n, list);
            _v0$1: while(true){
                _v0$5: while(true){
                    if (!_v0.b.b) return list;
                    else if (_v0.b.b.b) switch(_v0.a){
                        case 1:
                            break _v0$1;
                        case 2:
                            var _v2 = _v0.b;
                            var x = _v2.a;
                            var _v3 = _v2.b;
                            var y = _v3.a;
                            return _List_fromArray([
                                x,
                                y
                            ]);
                        case 3:
                            if (_v0.b.b.b.b) {
                                var _v4 = _v0.b;
                                var x = _v4.a;
                                var _v5 = _v4.b;
                                var y = _v5.a;
                                var _v6 = _v5.b;
                                var z = _v6.a;
                                return _List_fromArray([
                                    x,
                                    y,
                                    z
                                ]);
                            } else break _v0$5;
                        default:
                            if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
                                var _v7 = _v0.b;
                                var x = _v7.a;
                                var _v8 = _v7.b;
                                var y = _v8.a;
                                var _v9 = _v8.b;
                                var z = _v9.a;
                                var _v10 = _v9.b;
                                var w = _v10.a;
                                var tl = _v10.b;
                                return ctr > 1000 ? A2($elm$core$List$cons, x, A2($elm$core$List$cons, y, A2($elm$core$List$cons, z, A2($elm$core$List$cons, w, A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2($elm$core$List$cons, x, A2($elm$core$List$cons, y, A2($elm$core$List$cons, z, A2($elm$core$List$cons, w, A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
                            } else break _v0$5;
                    }
                    else {
                        if (_v0.a === 1) break _v0$1;
                        else break _v0$5;
                    }
                }
                return list;
            }
            var _v1 = _v0.b;
            var x = _v1.a;
            return _List_fromArray([
                x
            ]);
        }
    });
    var $elm$core$List$take = F2(function(n, list) {
        return A3($elm$core$List$takeFast, 0, n, list);
    });
    var $elm_community$list_extra$List$Extra$updateAt = F3(function(index, fn, list) {
        if (index < 0) return list;
        else {
            var tail = A2($elm$core$List$drop, index, list);
            var head = A2($elm$core$List$take, index, list);
            if (tail.b) {
                var x = tail.a;
                var xs = tail.b;
                return _Utils_ap(head, A2($elm$core$List$cons, fn(x), xs));
            } else return list;
        }
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField = F2(function(formField, form) {
        switch(formField.$){
            case 0:
                var index = formField.a;
                var string = formField.b;
                var newRecurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(charge) {
                    return _Utils_update(charge, {
                        NQ: string
                    });
                }, form.K9);
                return _Utils_update(form, {
                    K9: newRecurringCharges
                });
            case 1:
                var list = formField.a;
                return _Utils_update(form, {
                    K9: list
                });
            case 2:
                var index = formField.a;
                var string = formField.b;
                var newRecurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(charge) {
                    return _Utils_update(charge, {
                        _2: string
                    });
                }, form.K9);
                return _Utils_update(form, {
                    K9: newRecurringCharges
                });
            case 3:
                var index = formField.a;
                var string = formField.b;
                var newRecurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(charge) {
                    return _Utils_update(charge, {
                        xx: string
                    });
                }, form.K9);
                return _Utils_update(form, {
                    K9: newRecurringCharges
                });
            case 4:
                var index = formField.a;
                var string = formField.b;
                var newRecurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(charge) {
                    return _Utils_update(charge, {
                        QM: string
                    });
                }, form.K9);
                return _Utils_update(form, {
                    K9: newRecurringCharges
                });
            case 5:
                var index = formField.a;
                var string = formField.b;
                var newRecurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(charge) {
                    return _Utils_update(charge, {
                        Bu: A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(string))
                    });
                }, form.K9);
                return _Utils_update(form, {
                    K9: newRecurringCharges
                });
            case 6:
                var index = formField.a;
                var value = formField.b;
                var convertedValue = A2($elm$core$Maybe$andThen, function(charge) {
                    return A2($author$project$Utils$Billing$ProductPrice$convertPriceInCents, value, $elm$core$Maybe$Just(charge.iP));
                }, A2($elm_community$list_extra$List$Extra$getAt, index, form.K9));
                var newRecurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(charge) {
                    return _Utils_update(charge, {
                        Br: convertedValue
                    });
                }, form.K9);
                return _Utils_update(form, {
                    K9: newRecurringCharges
                });
            case 7:
                var value = formField.a;
                return _Utils_update(form, {
                    QT: $author$project$Utils$String$toMaybe(value)
                });
            default:
                var index = formField.a;
                var value = formField.b;
                var newRecurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(charge) {
                    return _Utils_update(charge, {
                        iP: value
                    });
                }, form.K9);
                return _Utils_update(form, {
                    K9: newRecurringCharges
                });
        }
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$convertPriceForCharge = F4(function(form, index, componentType, formWithComponentType) {
        var formFields = $author$project$Utils$Form$fields(form);
        var currentCharge = A2($elm_community$list_extra$List$Extra$getAt, index, formFields.K9);
        var currentPrice = A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, function($) {
            return $.Br;
        }, currentCharge));
        var convertedPrice = A2($author$project$Utils$Billing$ProductPrice$convertPriceInCents, currentPrice, $elm$core$Maybe$Just(componentType));
        return A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged, index, convertedPrice), formWithComponentType);
    });
    var $author$project$Api$Provider$HintBillingProduct$Shared$componentType = function(_v0) {
        var record = _v0;
        return record.LT;
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryComponentTypeById = F2(function(categories, categoryId) {
        return A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingProduct$Shared$componentType, $elm$core$List$head(A2($elm$core$List$filter, function(category) {
            return _Utils_eq($author$project$Api$Provider$HintBillingProduct$Shared$id(category), categoryId);
        }, categories)));
    });
    var $author$project$Api$Provider$HintBillingProduct$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById = F2(function(categories, categoryId) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingProduct$Shared$name, $elm$core$List$head(A2($elm$core$List$filter, function(category) {
            return _Utils_eq($author$project$Api$Provider$HintBillingProduct$Shared$id(category), categoryId);
        }, categories))));
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryFieldChanged = F4(function(model, index, categoryId, categoryField) {
        var newDescription = A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById, model.K0, categoryId);
        var formWithCategory = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, categoryField, model.PU);
        var descriptionField = A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged, index, newDescription);
        var formWithDescription = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, descriptionField, formWithCategory);
        var categoryComponentType = A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryComponentTypeById, model.K0, categoryId);
        return function(form) {
            if (!categoryComponentType.$) {
                var componentType = categoryComponentType.a;
                var formWithComponentType = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeComponentTypeChanged, index, componentType), form);
                return A4($author$project$Components$ApplicationFeePlan$UpdateModal$convertPriceForCharge, form, index, componentType, formWithComponentType);
            } else return form;
        }(formWithDescription);
    });
    var $justinmimbs$date$Date$compare = F2(function(_v0, _v1) {
        var a = _v0;
        var b = _v1;
        return A2($elm$core$Basics$compare, a, b);
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounced = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$debouncePrice = function(_v0) {
        var index = _v0.a;
        var price = _v0.b;
        return A2($elm$core$Task$perform, $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounced, $elm$core$Task$succeed(_Utils_Tuple2(index, price)));
    };
    var $author$project$Utils$Form$fromValidateResult = function(result) {
        if (!result.$) {
            var _v1 = result.a;
            var newForm = _v1.a;
            return newForm;
        } else {
            var newForm = result.a;
            return newForm;
        }
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdValidation = {
        $: 3
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdIsNumber = function(form) {
        var _v0 = form.QT;
        if (!_v0.$) {
            var id = _v0.a;
            var _v1 = $elm$core$String$toInt(id);
            if (!_v1.$) return true;
            else return false;
        } else return true;
    };
    var $rtfeldman$elm_validate$Validate$ifFalse = F2(function(test, error) {
        var getErrors = function(subject) {
            return test(subject) ? _List_Nil : _List_fromArray([
                error
            ]);
        };
        return getErrors;
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdIsNumber, _Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdValidation, 'Must be a number'));
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescription = F2(function(index, charge) {
        return $elm$core$String$isEmpty(charge.NQ) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index), 'Description can\'t be blank')
        ]) : _List_Nil;
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescriptions = function(form) {
        return $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescription, form.K9));
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeDescriptionValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateDescriptions);
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$core$Basics$clamp = F3(function(low, high, number) {
        return _Utils_cmp(number, low) < 0 ? low : _Utils_cmp(number, high) > 0 ? high : number;
    });
    var $justinmimbs$date$Date$fromCalendarDate = F3(function(y, m, d) {
        return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + A3($elm$core$Basics$clamp, 1, A2($justinmimbs$date$Date$daysInMonth, y, m), d);
    });
    var $elm$core$Array$fromListHelp = F3(function(list, nodeList, nodeListSize) {
        fromListHelp: while(true){
            var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
            var jsArray = _v0.a;
            var remainingItems = _v0.b;
            if (_Utils_cmp($elm$core$Elm$JsArray$length(jsArray), $elm$core$Array$branchFactor) < 0) return A2($elm$core$Array$builderToArray, true, {
                R: nodeList,
                y: nodeListSize,
                J: jsArray
            });
            else {
                var $temp$list = remainingItems, $temp$nodeList = A2($elm$core$List$cons, $elm$core$Array$Leaf(jsArray), nodeList), $temp$nodeListSize = nodeListSize + 1;
                list = $temp$list;
                nodeList = $temp$nodeList;
                nodeListSize = $temp$nodeListSize;
                continue fromListHelp;
            }
        }
    });
    var $elm$core$Array$fromList = function(list) {
        if (!list.b) return $elm$core$Array$empty;
        else return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
    };
    var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
    var $elm$core$Array$bitMask = 4294967295 >>> 32 - $elm$core$Array$shiftStep;
    var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
    var $elm$core$Array$getHelp = F3(function(shift, index, tree) {
        getHelp: while(true){
            var pos = $elm$core$Array$bitMask & index >>> shift;
            var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
            if (!_v0.$) {
                var subTree = _v0.a;
                var $temp$shift = shift - $elm$core$Array$shiftStep, $temp$index = index, $temp$tree = subTree;
                shift = $temp$shift;
                index = $temp$index;
                tree = $temp$tree;
                continue getHelp;
            } else {
                var values = _v0.a;
                return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
            }
        }
    });
    var $elm$core$Array$tailIndex = function(len) {
        return len >>> 5 << 5;
    };
    var $elm$core$Array$get = F2(function(index, _v0) {
        var len = _v0.a;
        var startShift = _v0.b;
        var tree = _v0.c;
        var tail = _v0.d;
        return index < 0 || _Utils_cmp(index, len) > -1 ? $elm$core$Maybe$Nothing : _Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1 ? $elm$core$Maybe$Just(A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(A3($elm$core$Array$getHelp, startShift, index, tree));
    });
    var $author$project$Utils$Date$months = _List_fromArray([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ]);
    var $author$project$Utils$Date$monthFromInt = function(intMonth) {
        return A2($elm$core$Array$get, intMonth - 1, $elm$core$Array$fromList($author$project$Utils$Date$months));
    };
    var $author$project$Utils$Date$dateFromCalendar = function(_v0) {
        var yearString = _v0.abw;
        var monthString = _v0.UF;
        var dayString = _v0.Nb;
        var maybeYear = $elm$core$String$toInt(yearString);
        var maybeMonth = A2($elm$core$Maybe$andThen, $author$project$Utils$Date$monthFromInt, $elm$core$String$toInt(monthString));
        var maybeDay = $elm$core$String$toInt(dayString);
        var _v1 = _Utils_Tuple3(maybeDay, maybeMonth, maybeYear);
        if (!_v1.a.$ && !_v1.b.$ && !_v1.c.$) {
            var day = _v1.a.a;
            var month = _v1.b.a;
            var year = _v1.c.a;
            return $elm$core$Result$Ok(A3($justinmimbs$date$Date$fromCalendarDate, year, month, day));
        } else return $elm$core$Result$Err('Invalid Date');
    };
    var $author$project$Utils$Date$DateParts = F3(function(monthString, dayString, yearString) {
        return {
            Nb: dayString,
            UF: monthString,
            abw: yearString
        };
    });
    var $author$project$Utils$Date$validateDatePart = F2(function(length, datePart) {
        return _Utils_eq($elm$core$String$length(datePart), length) ? $elm$parser$Parser$succeed(datePart) : $elm$parser$Parser$problem('Date part is invalid.');
    });
    var $author$project$Utils$Date$chompDatePart = function(length) {
        return A2($elm$parser$Parser$andThen, $author$project$Utils$Date$validateDatePart(length), $elm$parser$Parser$getChompedString($elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
    };
    var $author$project$Utils$Date$dateSeparator = '/';
    var $author$project$Utils$Date$dateParser = function() {
        var stringSeparator = $elm$core$String$fromChar($author$project$Utils$Date$dateSeparator);
        return A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($author$project$Utils$Date$DateParts), A2($elm$parser$Parser$ignorer, $author$project$Utils$Date$chompDatePart(2), $elm$parser$Parser$symbol(stringSeparator))), A2($elm$parser$Parser$ignorer, $author$project$Utils$Date$chompDatePart(2), $elm$parser$Parser$symbol(stringSeparator))), A2($elm$parser$Parser$ignorer, $author$project$Utils$Date$chompDatePart(4), $elm$parser$Parser$end));
    }();
    var $author$project$Utils$Date$fromUsString = function(dateString) {
        var _v0 = A2($elm$parser$Parser$run, $author$project$Utils$Date$dateParser, dateString);
        if (!_v0.$) {
            var dateParts = _v0.a;
            return $author$project$Utils$Date$dateFromCalendar(dateParts);
        } else return $elm$core$Result$Err('Invalid Date');
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDate = F2(function(index, charge) {
        if (charge.xx === '') return _List_Nil;
        else {
            var _v0 = $author$project$Utils$Date$fromUsString(charge.xx);
            if (!_v0.$) return _List_Nil;
            else return _List_fromArray([
                _Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation(index), 'Date is invalid')
            ]);
        }
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDates = function(form) {
        return $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDate, form.K9));
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeEndDateValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateEndDates);
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCentsPositive = F2(function(index, charge) {
        var _v0 = A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, charge.Br);
        if (!_v0.$) {
            var priceInCents = _v0.a;
            var _v1 = _Utils_Tuple2(!priceInCents, charge.iP === 5);
            if (_v1.a && _v1.b) return _List_fromArray([
                _Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index), 'Credit amount cannot be $0')
            ]);
            else return _List_Nil;
        } else return _List_Nil;
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCentsPositive = function(form) {
        return $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCentsPositive, form.K9));
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsPositiveValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCentsPositive);
    var $author$project$Currency$isValidFloat = function(_v0) {
        var string = _v0;
        var _v1 = $elm$core$String$toFloat(string);
        if (!_v1.$) return true;
        else return false;
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCents = F2(function(index, charge) {
        var noValueErrorMessage = charge.iP === 5 ? 'Must be a negative number' : 'Must be a positive number';
        var _v0 = charge.Br;
        if (!_v0.$) {
            var priceInCents = _v0.a;
            return $author$project$Currency$isValidFloat(priceInCents) ? _List_Nil : _List_fromArray([
                _Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index), noValueErrorMessage)
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index), noValueErrorMessage)
        ]);
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCents = function(form) {
        return $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePriceInCents, form.K9));
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validatePricesInCents);
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantity = F2(function(index, charge) {
        return charge.Bu > 0 ? _List_Nil : _List_fromArray([
            _Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index), 'Quantity must be greater than 0.')
        ]);
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantities = function(form) {
        return $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantity, form.K9));
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeQuantityValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateQuantities);
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDate = F2(function(index, charge) {
        var _v0 = $author$project$Utils$Date$fromUsString(charge._2);
        if (!_v0.$) return _List_Nil;
        else return _List_fromArray([
            _Utils_Tuple2($author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation(index), 'Date is invalid')
        ]);
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDates = function(form) {
        return $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDate, form.K9));
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeStartDateValidator = $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$ApplicationFeePlan$UpdateModalForm$validateStartDates);
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeStartDateValidator,
        $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeEndDateValidator,
        $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeDescriptionValidator,
        $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsPositiveValidator,
        $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargePriceInCentsValidator,
        $author$project$Components$ApplicationFeePlan$UpdateModalForm$recurringChargeQuantityValidator,
        $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator
    ]));
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotOnlyValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotDealIdValidator
    ]));
    var $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator = function(model) {
        return model.aeD ? $author$project$Components$ApplicationFeePlan$UpdateModalForm$formFieldsValidator : $author$project$Components$ApplicationFeePlan$UpdateModalForm$hubspotOnlyValidator;
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form).QT;
        if (!_v0.$) return true;
        else return false;
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$initEmptyCustomerProduct = F2(function(category, currentDate) {
        return {
            NQ: $author$project$Api$Provider$HintBillingProduct$Shared$name(category),
            qv: $elm$core$Maybe$Nothing,
            xx: '',
            iP: $author$project$Api$Provider$HintBillingProduct$Shared$componentType(category),
            QM: $author$project$Api$Provider$HintBillingProduct$Shared$id(category),
            aef: $elm$core$Maybe$Nothing,
            Br: $elm$core$Maybe$Nothing,
            Bu: 1,
            _0: currentDate,
            _2: A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, currentDate)
        };
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounceMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $jinjor$elm_debounce$Debounce$Later = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $jinjor$elm_debounce$Debounce$later = $jinjor$elm_debounce$Debounce$Later;
    var $author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(500),
        ah3: $author$project$Components$ApplicationFeePlan$UpdateModal$PriceDebounceMsg
    };
    var $jinjor$elm_debounce$Debounce$Flush = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $jinjor$elm_debounce$Debounce$delayCmd = F2(function(delay, msg) {
        return A2($elm$core$Task$perform, function(_v0) {
            return msg;
        }, $elm$core$Process$sleep(delay));
    });
    var $jinjor$elm_debounce$Debounce$length = function(_v0) {
        var input = _v0.ea;
        return $elm$core$List$length(input);
    };
    var $jinjor$elm_debounce$Debounce$push = F3(function(config, a, _v0) {
        var d = _v0;
        var newDebounce = _Utils_update(d, {
            ea: A2($elm$core$List$cons, a, d.ea)
        });
        var selfCmd = function() {
            var _v1 = config.ahA;
            switch(_v1.$){
                case 0:
                    var offset = _v1.a;
                    return d.Ts ? $elm$core$Platform$Cmd$none : A2($jinjor$elm_debounce$Debounce$delayCmd, offset, $jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Nothing));
                case 1:
                    var offset = _v1.a;
                    var delay = _v1.b;
                    return d.Ts ? $elm$core$Platform$Cmd$none : A2($jinjor$elm_debounce$Debounce$delayCmd, offset, $jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Just(delay)));
                default:
                    var delay = _v1.a;
                    return A2($jinjor$elm_debounce$Debounce$delayCmd, delay, $jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom($jinjor$elm_debounce$Debounce$length(newDebounce)));
            }
        }();
        return _Utils_Tuple2(newDebounce, A2($elm$core$Platform$Cmd$map, config.ah3, selfCmd));
    });
    var $elm_community$list_extra$List$Extra$removeAt = F2(function(index, l) {
        if (index < 0) return l;
        else {
            var _v0 = A2($elm$core$List$drop, index, l);
            if (!_v0.b) return l;
            else {
                var rest = _v0.b;
                return _Utils_ap(A2($elm$core$List$take, index, l), rest);
            }
        }
    });
    var $jinjor$elm_debounce$Debounce$takeLast = F3(function(send, head, tail) {
        return _Utils_Tuple2(_List_Nil, send(head));
    });
    var $jinjor$elm_debounce$Debounce$update = F4(function(config, send, msg, _v0) {
        var d = _v0;
        switch(msg.$){
            case 0:
                return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
            case 1:
                var tryAgainAfter = msg.a;
                var _v2 = d.ea;
                if (_v2.b) {
                    var head = _v2.a;
                    var tail = _v2.b;
                    var selfCmd = function() {
                        if (!tryAgainAfter.$) {
                            var delay = tryAgainAfter.a;
                            return A2($jinjor$elm_debounce$Debounce$delayCmd, delay, $jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Just(delay)));
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    var _v3 = A2(send, head, tail);
                    var input = _v3.a;
                    var sendCmd = _v3.b;
                    return _Utils_Tuple2(_Utils_update(d, {
                        ea: input,
                        Ts: true
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        sendCmd,
                        A2($elm$core$Platform$Cmd$map, config.ah3, selfCmd)
                    ])));
                } else return _Utils_Tuple2(_Utils_update(d, {
                    Ts: false
                }), $elm$core$Platform$Cmd$none);
            default:
                var lastInputLength = msg.a;
                var _v5 = _Utils_Tuple2(_Utils_cmp($elm$core$List$length(d.ea), lastInputLength) < 1, d.ea);
                if (_v5.a && _v5.b.b) {
                    var _v6 = _v5.b;
                    var head = _v6.a;
                    var tail = _v6.b;
                    var _v7 = A2(send, head, tail);
                    var input = _v7.a;
                    var cmd = _v7.b;
                    return _Utils_Tuple2(_Utils_update(d, {
                        ea: input
                    }), cmd);
                } else return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm = F2(function(model, newForm) {
        return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 0,
            zi: _Utils_update(model, {
                PU: newForm
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$PlanUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$backfillDate = F2(function(currentDate, charge) {
        var startDate = function() {
            var _v1 = $author$project$Utils$Date$fromUsString(charge._2);
            if (!_v1.$) {
                var val = _v1.a;
                return val;
            } else return currentDate;
        }();
        var endDate = function() {
            if (charge.xx === '') return $elm$core$Maybe$Nothing;
            else {
                var _v0 = $author$project$Utils$Date$fromUsString(charge.xx);
                if (!_v0.$) {
                    var val = _v0.a;
                    return $elm$core$Maybe$Just(val);
                } else return $elm$core$Maybe$Nothing;
            }
        }();
        return _Utils_update(charge, {
            qv: endDate,
            _0: startDate
        });
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$convertToPricingCharge = function(charge) {
        var _v0 = charge.Br;
        if (!_v0.$) {
            var priceInCents = _v0.a;
            return $elm$core$Maybe$Just({
                NQ: charge.NQ,
                qv: charge.qv,
                QM: charge.QM,
                aef: charge.aef,
                Br: priceInCents,
                Bu: charge.Bu,
                _0: charge._0
            });
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Currency$encodeFloat = A2($elm$core$Basics$composeR, $author$project$Currency$toFloat, $author$project$Utils$Encode$nullable($elm$json$Json$Encode$float));
    var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
    var $author$project$Api$Provider$Practice$Pricing$encodeChargeParams = function(charge) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, charge.aef)),
            _Utils_Tuple2('hint_billing_product', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(charge.QM))
            ]))),
            _Utils_Tuple2('description', $elm$json$Json$Encode$string(charge.NQ)),
            _Utils_Tuple2('quantity', $elm$json$Json$Encode$int(charge.Bu)),
            _Utils_Tuple2('price_in_cents', $author$project$Currency$encodeFloat(charge.Br)),
            _Utils_Tuple2('start_date', $elm$json$Json$Encode$string($justinmimbs$date$Date$toIsoString(charge._0))),
            _Utils_Tuple2('end_date', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $justinmimbs$date$Date$toIsoString), charge.qv))
        ]));
    };
    var $author$project$Api$Provider$Practice$Pricing$pricingPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'pricing'
    ]), $author$project$Api$Provider$Practice$practicePath);
    var $author$project$Api$Provider$Practice$Pricing$update = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_pricing', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('charges', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Practice$Pricing$encodeChargeParams, fields.K9)),
                _Utils_Tuple2('hubspot_deal_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.QT))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$ApplicationFeePlan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$Pricing$pricingPath)));
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$updatePlan = F3(function(apiClient, model, validFields) {
        var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
        var allCharges = formFields.K9;
        var pricingCharges = A2($elm$core$List$filterMap, $author$project$Components$ApplicationFeePlan$UpdateModal$convertToPricingCharge, A2($elm$core$List$map, $author$project$Components$ApplicationFeePlan$UpdateModal$backfillDate(model.cP), allCharges));
        return A3($author$project$Api$Provider$Practice$Pricing$update, apiClient, {
            K9: pricingCharges,
            QT: formFields.QT
        }, $author$project$Components$ApplicationFeePlan$UpdateModal$PlanUpdated);
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: $author$project$Components$ApplicationFeePlan$UpdateModalForm$init(model.K9),
                        cj: $elm$core$Dict$empty,
                        jH: $jinjor$elm_debounce$Debounce$init
                    }),
                    at: _List_Nil
                };
            case 1:
                var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
                var _v1 = A2($author$project$Utils$Form$validate, validator, model.PU);
                if (_v1.$ === 1) {
                    var newForm = _v1.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else {
                    var _v2 = _v1.a;
                    var newForm = _v2.a;
                    var validFormFields = _v2.b;
                    return {
                        EQ: A3($author$project$Components$ApplicationFeePlan$UpdateModal$updatePlan, apiClient, model, validFormFields),
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_fromArray([
                            $author$project$OutMsg$RefreshPractice
                        ])
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var updateEvent = $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified(model.PU) ? 3 : 2;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: updateEvent,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Plan updated')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var field = msg.a;
                var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
                var updatedForm = function() {
                    if (field.$ === 4) {
                        var index = field.a;
                        var categoryId = field.b;
                        return A4($author$project$Components$ApplicationFeePlan$UpdateModal$categoryFieldChanged, model, index, categoryId, field);
                    } else return A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, field, model.PU);
                }();
                return A2($author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm, model, $author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, validator, updatedForm)));
            case 8:
                var index = msg.a;
                var price = msg.b;
                var newPendingPrices = A3($elm$core$Dict$insert, index, price, model.cj);
                var _v5 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig, _Utils_Tuple2(index, price), model.jH);
                var newDebouncer = _v5.a;
                var debounceCmd = _v5.b;
                return {
                    EQ: debounceCmd,
                    adu: 0,
                    zi: _Utils_update(model, {
                        cj: newPendingPrices,
                        jH: newDebouncer
                    }),
                    at: _List_Nil
                };
            case 9:
                var debounceMsg = msg.a;
                var _v6 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$ApplicationFeePlan$UpdateModal$priceDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$ApplicationFeePlan$UpdateModal$debouncePrice), debounceMsg, model.jH);
                var newDebouncer = _v6.a;
                var cmd = _v6.b;
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: _Utils_update(model, {
                        jH: newDebouncer
                    }),
                    at: _List_Nil
                };
            case 10:
                var _v7 = msg.a;
                var index = _v7.a;
                var price = _v7.b;
                var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
                var updatedForm = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargePriceInCentsChanged, index, price), model.PU);
                var newPendingPrices = A2($elm$core$Dict$remove, index, model.cj);
                return function(newForm) {
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            cj: newPendingPrices
                        }),
                        at: _List_Nil
                    };
                }($author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, validator, updatedForm)));
            case 4:
                var dataCategories = msg.a;
                if (dataCategories.$ === 3) {
                    var categories_ = dataCategories.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            K0: categories_
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(dataCategories)
                };
            case 5:
                var fields = $author$project$Utils$Form$fields(model.PU);
                var emptyCharge = function() {
                    var _v9 = $elm$core$List$head(A2($elm$core$List$filter, function(category) {
                        return $author$project$Api$Provider$HintBillingProduct$Shared$name(category) === 'Service Credit';
                    }, model.K0));
                    if (!_v9.$) {
                        var category = _v9.a;
                        return _List_fromArray([
                            A2($author$project$Components$ApplicationFeePlan$UpdateModalForm$initEmptyCustomerProduct, category, model.cP)
                        ]);
                    } else return _List_Nil;
                }();
                var newComponents = _Utils_ap(fields.K9, emptyCharge);
                return A2($author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm, _Utils_update(model, {
                    cj: $elm$core$Dict$empty
                }), A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, $author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(newComponents), model.PU));
            case 6:
                var index = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var maybeCharge = A2($elm_community$list_extra$List$Extra$getAt, index, fields.K9);
                var _v10 = A2($elm$core$Maybe$andThen, function($) {
                    return $.aef;
                }, maybeCharge);
                if (_v10.$ === 1) {
                    if (!maybeCharge.$) {
                        var validator = $author$project$Components$ApplicationFeePlan$UpdateModal$getValidator(model);
                        var updatedCharges = A2($elm_community$list_extra$List$Extra$removeAt, index, fields.K9);
                        var updatedForm = A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, $author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(updatedCharges), model.PU);
                        var newPendingPrices = A2($elm$core$Dict$remove, index, model.cj);
                        return A2($author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm, _Utils_update(model, {
                            cj: newPendingPrices
                        }), $author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, validator, updatedForm)));
                    } else return A2($author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm, model, model.PU);
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 2, 'Existing charges cannot be deleted')
                    ])
                };
            default:
                var index = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var updatedCharges = A2($elm$core$List$indexedMap, F2(function(i, charge) {
                    if (_Utils_eq(i, index)) {
                        var possibleEndDate = A2($justinmimbs$date$Date$compare, charge._0, model.cP) === 2 ? charge._0 : model.cP;
                        return _Utils_update(charge, {
                            xx: A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, possibleEndDate)
                        });
                    } else return charge;
                }), fields.K9);
                return A2($author$project$Components$ApplicationFeePlan$UpdateModal$updateModelWithForm, model, A3($author$project$Utils$Form$update, $author$project$Components$ApplicationFeePlan$UpdateModalForm$updateFormField, $author$project$Components$ApplicationFeePlan$UpdateModalForm$Charges(updatedCharges), model.PU));
        }
    });
    var $author$project$Components$HintBilling$CreateChargeModal$Closed = {
        $: 1
    };
    var $author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$None = {
        $: 0
    };
    var $author$project$Components$HintBilling$CreateChargeModal$PriceInCents = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$SaveCharge = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$PriceDebounced = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$debouncePrice = function(price) {
        return A2($elm$core$Task$perform, $author$project$Components$HintBilling$CreateChargeModal$PriceDebounced, $elm$core$Task$succeed(price));
    };
    var $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    Bu: $elm$core$String$toInt(string)
                });
            case 2:
                var price = field.a;
                var convertedPrice = A2($author$project$Utils$Billing$ProductPrice$convertPriceInCents, price, fields.iP);
                return _Utils_update(fields, {
                    Br: convertedPrice
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    QL: $elm$core$Maybe$Just(string)
                });
            default:
                var componentType = field.a;
                return _Utils_update(fields, {
                    iP: componentType
                });
        }
    });
    var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProductValidation = 3;
    var $author$project$Components$HintBilling$CreateChargeModal$NameValidation = 0;
    var $author$project$Components$HintBilling$CreateChargeModal$validateName = function(fields) {
        return fields.zr === '' ? _List_fromArray([
            _Utils_Tuple2(0, 'Please enter a name.')
        ]) : _List_Nil;
    };
    var $author$project$Components$HintBilling$CreateChargeModal$PriceValidation = 2;
    var $elm$core$Maybe$map2 = F3(function(func, ma, mb) {
        if (ma.$ === 1) return $elm$core$Maybe$Nothing;
        else {
            var a = ma.a;
            if (mb.$ === 1) return $elm$core$Maybe$Nothing;
            else {
                var b = mb.a;
                return $elm$core$Maybe$Just(A2(func, a, b));
            }
        }
    });
    var $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents = function(_v0) {
        var record = _v0;
        return record.Ol;
    };
    var $author$project$Api$Provider$PracticeInvoice$One$dueInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$Shared$paidInCents = function(_v0) {
        var record = _v0;
        return record.VR;
    };
    var $author$project$Api$Provider$PracticeInvoice$One$paidInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$paidInCents(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus = function(_v0) {
        var record = _v0;
        return record.QX;
    };
    var $author$project$Api$Provider$PracticeInvoice$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus(shared);
    };
    var $author$project$Components$HintBilling$CreateChargeModal$maxCreditAmount = function(practiceInvoice) {
        return $author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice) === 3 ? $author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice) : $author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice);
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(function(original, integers, decimals, prefix, suffix) {
        return {
            Nm: decimals,
            Rm: integers,
            VD: original,
            sg: prefix,
            $w: suffix
        };
    });
    var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
    var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
    var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
    var $cuducos$elm_format_number$FormatNumber$Parser$classify = function(formatted) {
        var onlyZeros = A2($elm$core$String$all, function(_char) {
            return _char === '0';
        }, $elm$core$String$concat(A2($elm$core$List$append, formatted.Rm, $elm$core$List$singleton(formatted.Nm))));
        return onlyZeros ? 1 : formatted.VD < 0 ? 2 : 0;
    };
    var $elm$core$String$filter = _String_filter;
    var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(function(desiredLength, value) {
        var length = $elm$core$String$length(value);
        var missing = _Utils_cmp(length, desiredLength) < 0 ? $elm$core$Basics$abs(desiredLength - length) : 0;
        return _Utils_ap(value, A2($elm$core$String$repeat, missing, '0'));
    });
    var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function(decimals) {
        return A2($elm$core$String$right, 1, decimals) !== '0' ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(A2($elm$core$String$dropRight, 1, decimals));
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(function(locale, digits) {
        var _v0 = locale.Nm;
        switch(_v0.$){
            case 1:
                return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
            case 2:
                return digits;
            default:
                var min = _v0.a;
                return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
        }
    });
    var $elm$core$List$tail = function(list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(xs);
        } else return $elm$core$Maybe$Nothing;
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(function(locale, value) {
        var toString = function() {
            var _v1 = locale.Nm;
            switch(_v1.$){
                case 1:
                    var max = _v1.a;
                    return $myrho$elm_round$Round$round(max);
                case 0:
                    return $elm$core$String$fromFloat;
                default:
                    var exact = _v1.a;
                    return $myrho$elm_round$Round$round(exact);
            }
        }();
        var asList = A2($elm$core$String$split, '.', toString(value));
        var decimals = function() {
            var _v0 = $elm$core$List$tail(asList);
            if (!_v0.$) {
                var values = _v0.a;
                return A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(values));
            } else return '';
        }();
        var integers = A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(asList));
        return _Utils_Tuple2(integers, decimals);
    });
    var $cuducos$elm_format_number$FormatNumber$Parser$splitThousands = function(integers) {
        var reversedSplitThousands = function(value) {
            return $elm$core$String$length(value) > 3 ? A2($elm$core$List$cons, A2($elm$core$String$right, 3, value), reversedSplitThousands(A2($elm$core$String$dropRight, 3, value))) : _List_fromArray([
                value
            ]);
        };
        return $elm$core$List$reverse(reversedSplitThousands(integers));
    };
    var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(function(locale, original) {
        var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
        var integers = $cuducos$elm_format_number$FormatNumber$Parser$splitThousands(A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
        var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
        var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
        var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
        switch(_v0){
            case 2:
                return _Utils_update(partial, {
                    sg: locale.afc,
                    $w: locale.afd
                });
            case 0:
                return _Utils_update(partial, {
                    sg: locale.age,
                    $w: locale.agf
                });
            default:
                return _Utils_update(partial, {
                    sg: locale.ain,
                    $w: locale.aio
                });
        }
    });
    var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(function(locale, decimals) {
        return decimals === '' ? '' : _Utils_ap(locale.acV, decimals);
    });
    var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(function(locale, formatted) {
        var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
        var integers = A2($elm$core$String$join, locale.ahS, formatted.Rm);
        var decimals = stringfyDecimals(formatted.Nm);
        return $elm$core$String$concat(_List_fromArray([
            formatted.sg,
            integers,
            decimals,
            formatted.$w
        ]));
    });
    var $cuducos$elm_format_number$FormatNumber$format = F2(function(locale, number_) {
        return A2($cuducos$elm_format_number$FormatNumber$Stringfy$stringfy, locale, A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
    });
    var $author$project$Currency$toInt = function(_v0) {
        var string = _v0;
        return A2($elm$core$Maybe$map, $elm$core$Basics$round, A2($elm$core$Maybe$map, $elm$core$Basics$mul(100), $elm$core$String$toFloat(string)));
    };
    var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $cuducos$elm_format_number$FormatNumber$Locales$Min = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $cuducos$elm_format_number$FormatNumber$Locales$base = {
        acV: '.',
        Nm: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
        afc: "\u2212",
        afd: '',
        age: '',
        agf: '',
        ahS: '',
        ain: '',
        aio: ''
    };
    var $cuducos$elm_format_number$FormatNumber$Locales$usLocale = _Utils_update($cuducos$elm_format_number$FormatNumber$Locales$base, {
        Nm: $cuducos$elm_format_number$FormatNumber$Locales$Exact(2),
        ahS: ','
    });
    var $author$project$Currency$format = function(currency) {
        var _v0 = $author$project$Currency$toInt(currency);
        if (!_v0.$) {
            var cents = _v0.a;
            return '$' + A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, cents / 100);
        } else return 'N/A';
    };
    var $author$project$Currency$fromInt = function(_int) {
        return $elm$core$String$fromFloat(_int / 100);
    };
    var $author$project$Components$HintBilling$CreateChargeModal$priceErrorForInvoice = function(practiceInvoice) {
        if ($author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice) === 3) {
            var dueText = $author$project$Currency$format($author$project$Currency$fromInt($author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)));
            return _List_fromArray([
                _Utils_Tuple2(2, 'Credit cannot excceed the Total Due of ' + (dueText + '.'))
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2(2, 'Credit cannot excceed amount paid.')
        ]);
    };
    var $author$project$Components$HintBilling$CreateChargeModal$validatePrice = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Br, fields.iP);
        if (!_v0.a.$) {
            if (!_v0.b.$) {
                var priceInCents = _v0.a.a;
                var componentType = _v0.b.a;
                var _v1 = $author$project$Currency$toFloat(priceInCents);
                if (!_v1.$) {
                    var price = _v1.a;
                    var _v2 = _Utils_Tuple2(!price, componentType === 5);
                    _v2$2: while(true)if (_v2.a) {
                        if (_v2.b) return _List_fromArray([
                            _Utils_Tuple2(2, 'Credit amount cannot be $0')
                        ]);
                        else break _v2$2;
                    } else {
                        if (_v2.b) return A2($elm$core$Maybe$withDefault, _List_Nil, A3($elm$core$Maybe$map2, F2(function(practiceInvoice_, quantity_) {
                            return _Utils_cmp($elm$core$Basics$abs(price * quantity_), $author$project$Components$HintBilling$CreateChargeModal$maxCreditAmount(practiceInvoice_)) > 0 ? $author$project$Components$HintBilling$CreateChargeModal$priceErrorForInvoice(practiceInvoice_) : _List_Nil;
                        }), fields.W3, fields.Bu));
                        else break _v2$2;
                    }
                    return _List_Nil;
                } else return _List_fromArray([
                    _Utils_Tuple2(2, 'Must be a valid number')
                ]);
            } else return _List_Nil;
        } else {
            var _v3 = _v0.a;
            return _List_fromArray([
                _Utils_Tuple2(2, 'Must be a number')
            ]);
        }
    };
    var $author$project$Components$HintBilling$CreateChargeModal$QuantityValidation = 1;
    var $author$project$Components$HintBilling$CreateChargeModal$validateQuantity = function(fields) {
        var _v0 = fields.Bu;
        if (_v0.$ === 1) return _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a quantity.')
        ]);
        else {
            var qty = _v0.a;
            return qty > 0 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(1, 'Quantity must be greater than 0.')
            ]);
        }
    };
    var $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validatePrice),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validateName),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$HintBilling$CreateChargeModal$validateQuantity),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.QL;
        }, _Utils_Tuple2(3, 'Please select a category.'))
    ]));
    var $author$project$Components$HintBilling$CreateChargeModal$params = function(fields) {
        return {
            NQ: fields.zr,
            QM: fields.QL,
            Br: A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Br)),
            Bu: A2($elm$core$Maybe$withDefault, 1, fields.Bu)
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$PriceDebounceMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(500),
        ah3: $author$project$Components$HintBilling$CreateChargeModal$PriceDebounceMsg
    };
    var $author$project$Components$HintBilling$CreateChargeModal$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$HintBilling$CreateChargeModal$Closed,
                    zi: _Utils_update(model, {
                        nv: $elm$core$Maybe$Nothing,
                        jH: $jinjor$elm_debounce$Debounce$init
                    }),
                    at: _List_Nil
                };
            case 1:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$HintBilling$CreateChargeModal$SaveCharge($author$project$Components$HintBilling$CreateChargeModal$params(fields)),
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var field = msg.a;
                if (field.$ === 2) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                    zi: model,
                    at: _List_Nil
                };
                else return function(updatedForm) {
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                        zi: _Utils_update(model, {
                            PU: updatedForm
                        }),
                        at: _List_Nil
                    };
                }($author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator, A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, field, model.PU))));
            case 5:
                var price = msg.a;
                var _v5 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig, price, model.jH);
                var newDebouncer = _v5.a;
                var debounceCmd = _v5.b;
                return {
                    EQ: debounceCmd,
                    adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                    zi: _Utils_update(model, {
                        nv: $elm$core$Maybe$Just(price),
                        jH: newDebouncer
                    }),
                    at: _List_Nil
                };
            case 6:
                var debounceMsg = msg.a;
                var _v6 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$HintBilling$CreateChargeModal$priceDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$HintBilling$CreateChargeModal$debouncePrice), debounceMsg, model.jH);
                var newDebouncer = _v6.a;
                var cmd = _v6.b;
                return {
                    EQ: cmd,
                    adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                    zi: _Utils_update(model, {
                        jH: newDebouncer
                    }),
                    at: _List_Nil
                };
            case 7:
                var price = msg.a;
                var updatedForm = $author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator, A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, $author$project$Components$HintBilling$CreateChargeModal$PriceInCents(price), model.PU)));
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                    zi: _Utils_update(model, {
                        PU: updatedForm,
                        nv: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var list = response.a;
                    var serviceCreditCategory = $elm$core$List$head(A2($elm$core$List$filter, function(product) {
                        return $author$project$Api$Provider$HintBillingProduct$Shared$name(product) === 'Service Credit';
                    }, list));
                    var updatedForm = function() {
                        if (!serviceCreditCategory.$) {
                            var category = serviceCreditCategory.a;
                            var formWithCategory = A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, $author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct($author$project$Api$Provider$HintBillingProduct$Shared$id(category)), model.PU);
                            var formWithComponentType = A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, $author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType($elm$core$Maybe$Just($author$project$Api$Provider$HintBillingProduct$Shared$componentType(category))), formWithCategory);
                            return A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, $author$project$Components$HintBilling$CreateChargeModal$Name($author$project$Api$Provider$HintBillingProduct$Shared$name(category)), formWithComponentType);
                        } else return model.PU;
                    }();
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                        zi: _Utils_update(model, {
                            K0: list,
                            PU: updatedForm
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var hintBillingProductId = msg.a;
                var hintBillingProduct = $elm$core$List$head(A2($elm$core$List$filter, function(product) {
                    return _Utils_eq($author$project$Api$Provider$HintBillingProduct$Shared$id(product), hintBillingProductId);
                }, model.K0));
                var formWithCategory = A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, $author$project$Components$HintBilling$CreateChargeModal$HintBillingProduct(hintBillingProductId), model.PU);
                var currentPrice = $author$project$Utils$Form$fields(model.PU).Br;
                var componentType = A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingProduct$Shared$componentType, hintBillingProduct);
                var convertedPrice = A2($author$project$Utils$Billing$ProductPrice$convertPriceInCents, currentPrice, componentType);
                var formWithComponentType = A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, $author$project$Components$HintBilling$CreateChargeModal$HintBillingComponentType(componentType), formWithCategory);
                var formWithPrice = A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, $author$project$Components$HintBilling$CreateChargeModal$PriceInCents(convertedPrice), formWithComponentType);
                var categoryName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingProduct$Shared$name, hintBillingProduct));
                var updatedForm = $author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Components$HintBilling$CreateChargeModal$formFieldsValidator, A3($author$project$Utils$Form$update, $author$project$Components$HintBilling$CreateChargeModal$formFieldsUpdate, $author$project$Components$HintBilling$CreateChargeModal$Name(categoryName), formWithPrice)));
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$HintBilling$CreateChargeModal$None,
                    zi: _Utils_update(model, {
                        PU: updatedForm
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$UpgradePracticeModal$Closed = {
        $: 1
    };
    var $author$project$Components$UpgradePracticeModal$CreatedUpgrade = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$UpgradePracticeModal$None = {
        $: 0
    };
    var $author$project$Components$UpgradePracticeModal$UpgradedSuccess = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticePricing$Upgrade$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('upgrade', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('agreed_to_terms', $elm$json$Json$Encode$bool(fields.abC))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$Upgrade$upgradesPath)));
    });
    var $author$project$Components$UpgradePracticeModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, model.Z$, model.hc, 'Self Buy Upgrade Modal Closed'),
                    adu: $author$project$Components$UpgradePracticeModal$Closed,
                    zi: model
                };
            case 1:
                var value = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$UpgradePracticeModal$None,
                    zi: _Utils_update(model, {
                        abC: value
                    })
                };
            case 2:
                return model.i_ ? {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$UpgradePracticeModal$None,
                    zi: model
                } : {
                    EQ: A3($author$project$Api$Provider$PracticePricing$Upgrade$create, apiClient, {
                        abC: model.abC
                    }, $author$project$Components$UpgradePracticeModal$CreatedUpgrade),
                    adu: $author$project$Components$UpgradePracticeModal$None,
                    zi: _Utils_update(model, {
                        i_: true
                    })
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var tier = function() {
                        var _v2 = model.hc;
                        if (!_v2.$) {
                            var pricing = _v2.a;
                            return $author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing);
                        } else return 'plan';
                    }();
                    return {
                        EQ: A3($author$project$Components$UpgradePracticeModal$logActionPerformedEvent, model.Z$, model.hc, 'Self Buy Upgrade Completed'),
                        adu: $author$project$Components$UpgradePracticeModal$UpgradedSuccess('Your upgrade to ' + (tier + ' was successful')),
                        zi: _Utils_update(model, {
                            i_: false
                        })
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$UpgradePracticeModal$None,
                    zi: _Utils_update(model, {
                        i_: false
                    })
                };
            default:
                var text = msg.a;
                var href = msg.b;
                return {
                    EQ: A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.Z$, text, href),
                    adu: $author$project$Components$UpgradePracticeModal$None,
                    zi: model
                };
        }
    });
    var $elm$url$Url$Builder$Relative = {
        $: 1
    };
    var $elm$url$Url$Builder$rootToPrePath = function(root) {
        switch(root.$){
            case 0:
                return '/';
            case 1:
                return '';
            default:
                var prePath = root.a;
                return prePath + '/';
        }
    };
    var $elm$url$Url$Builder$custom = F4(function(root, pathSegments, parameters, maybeFragment) {
        var fragmentless = _Utils_ap($elm$url$Url$Builder$rootToPrePath(root), _Utils_ap(A2($elm$core$String$join, '/', pathSegments), $elm$url$Url$Builder$toQuery(parameters)));
        if (maybeFragment.$ === 1) return fragmentless;
        else {
            var fragment = maybeFragment.a;
            return fragmentless + ('#' + fragment);
        }
    });
    var $author$project$Pages$Admin$Billing$updateUrl = function(maybeCustomPath) {
        var url = $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Billing);
        if (!maybeCustomPath.$) {
            var customPath = maybeCustomPath.a;
            return $author$project$Ports$Navigation$pushUrl(A4($elm$url$Url$Builder$custom, $elm$url$Url$Builder$Relative, _List_fromArray([
                url
            ]), _List_Nil, $elm$core$Maybe$Just(customPath)));
        } else return $author$project$Ports$Navigation$pushUrl(url);
    };
    var $author$project$Components$UpgradePracticeModal$urlParam = function(model) {
        return A2($elm$core$Maybe$map, function(tierName) {
            return 'self-upgrade-' + tierName;
        }, A2($elm$core$Maybe$map, $elm$core$String$toLower, A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticePricing$Upgrade$tierName, model.hc)));
    };
    var $author$project$Components$HintBilling$InvoicesTable$NotPaid = {
        $: 1
    };
    var $author$project$Components$HintBilling$InvoicesTable$PaidTime = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate = function(_v0) {
        var record = _v0;
        return record.RG;
    };
    var $author$project$Api$Provider$PracticeInvoice$All$date = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$Shared$dueDate = function(_v0) {
        var record = _v0;
        return record.Ok;
    };
    var $author$project$Api$Provider$PracticeInvoice$All$dueDate = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeInvoice$Shared$dueDate(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$All$dueInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeInvoice$Shared$dueInCents(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PracticeInvoice$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeInvoice$Shared$id(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber = function(_v0) {
        var record = _v0;
        return record.RK;
    };
    var $author$project$Api$Provider$PracticeInvoice$All$number = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$Shared$paidAt = function(_v0) {
        var record = _v0;
        return record.VQ;
    };
    var $author$project$Api$Provider$PracticeInvoice$All$paidAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeInvoice$Shared$paidAt(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$All$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeInvoice$Shared$humanStatus(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents = function(_v0) {
        var record = _v0;
        return record.aam;
    };
    var $author$project$Api$Provider$PracticeInvoice$All$totalInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents(shared);
    };
    var $author$project$Components$HintBilling$InvoicesTable$withPracticeInvoices = F3(function(practiceInvoices, timeFormatter, _v0) {
        var record = _v0;
        return _Utils_update(record, {
            q5: A2($elm$core$List$map, function(practiceInvoice) {
                return {
                    M4: $author$project$Api$Provider$PracticeInvoice$All$date(practiceInvoice),
                    Ok: $author$project$Api$Provider$PracticeInvoice$All$dueDate(practiceInvoice),
                    Ol: $author$project$Api$Provider$PracticeInvoice$All$dueInCents(practiceInvoice),
                    aef: $author$project$Api$Provider$PracticeInvoice$All$id(practiceInvoice),
                    Gx: $author$project$Api$Provider$PracticeInvoice$All$number(practiceInvoice),
                    GO: function() {
                        var _v1 = $author$project$Api$Provider$PracticeInvoice$All$paidAt(practiceInvoice);
                        if (!_v1.$) {
                            var time = _v1.a;
                            return A2($author$project$Components$HintBilling$InvoicesTable$PaidTime, time, timeFormatter);
                        } else return $author$project$Components$HintBilling$InvoicesTable$NotPaid;
                    }(),
                    ahy: $author$project$Api$Provider$PracticeInvoice$All$status(practiceInvoice),
                    aam: $author$project$Api$Provider$PracticeInvoice$All$totalInCents(practiceInvoice)
                };
            }, practiceInvoices)
        });
    });
    var $author$project$Pages$Admin$Billing$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    mi: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    cl: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pF: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pQ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoices = response.a;
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        eo: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.eo),
                        Bb: response,
                        jB: A2($author$project$Components$HintBilling$InvoicesTable$withLoadingStatus, false, A3($author$project$Components$HintBilling$InvoicesTable$withPracticeInvoices, invoices, model.HO, model.jB))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Bb: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 8:
                var response = msg.a;
                if (response.$ === 3) {
                    var uninvoicedCharges_ = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        oZ: uninvoicedCharges_
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.eo);
                var newModel = _Utils_update(model, {
                    eo: pagination,
                    jB: A2($author$project$Components$HintBilling$InvoicesTable$withLoadingStatus, true, model.jB)
                });
                return _Utils_Tuple3(newModel, A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, model.Ej, pagination), _List_Nil);
            case 6:
                var practicePricing = msg.a;
                var _v3 = model.cu;
                if (!_v3.$) {
                    var hubspotDealUrl = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$PracticePricing$One$hubspotDealUrl, $author$project$Api$Data$toMaybe(model.cl));
                    var _v4 = A4($author$project$Components$ApplicationFeePlan$UpdateModal$init, model.Ej, model.cP, practicePricing, hubspotDealUrl);
                    var newModel = _v4.a;
                    var cmd = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cu: A2($author$project$Pages$Admin$Billing$Initialized, true, newModel)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, cmd), _List_Nil);
                } else {
                    var modal = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cu: A2($author$project$Pages$Admin$Billing$Initialized, true, modal)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 7:
                var subMsg = msg.a;
                var _v5 = model.cu;
                if (!_v5.$) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    var open = _v5.a;
                    var updateModal = _v5.b;
                    var result = A3($author$project$Components$ApplicationFeePlan$UpdateModal$update, model.Ej, subMsg, updateModal);
                    var loadingModel = _Utils_update(model, {
                        mi: $author$project$Api$Data$Loading,
                        cl: $author$project$Api$Data$Loading,
                        cu: $author$project$Pages$Admin$Billing$NotInitialized,
                        o5: $elm$core$Maybe$Nothing
                    });
                    var fetchDataCmd = $elm$core$Platform$Cmd$batch($author$project$Pages$Admin$Billing$fetchPricingData(model.Ej));
                    var _v6 = result.adu;
                    switch(_v6){
                        case 1:
                            return _Utils_Tuple3(_Utils_update(model, {
                                cu: A2($author$project$Pages$Admin$Billing$Initialized, false, result.zi)
                            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.EQ), result.at);
                        case 2:
                            return _Utils_Tuple3(loadingModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                fetchDataCmd,
                                A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.EQ)
                            ])), result.at);
                        case 3:
                            return _Utils_Tuple3(loadingModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                fetchDataCmd,
                                A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.EQ)
                            ])), result.at);
                        default:
                            return _Utils_Tuple3(_Utils_update(model, {
                                cu: A2($author$project$Pages$Admin$Billing$Initialized, open, result.zi)
                            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, result.EQ), result.at);
                    }
                }
            case 10:
                var _v7 = A2($author$project$Components$HintBilling$CreateChargeModal$init, model.Ej, $elm$core$Maybe$Nothing);
                var createChargeModal = _v7.a;
                var createChargeModalCmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    hZ: $elm$core$Maybe$Just(createChargeModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$CreateChargeModalMsg, createChargeModalCmd), _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v8 = model.hZ;
                if (!_v8.$) {
                    var createChargeModal = _v8.a;
                    var result = A2($author$project$Components$HintBilling$CreateChargeModal$update, subMsg, createChargeModal);
                    var _v9 = function() {
                        var _v10 = result.adu;
                        switch(_v10.$){
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                            case 2:
                                var chargeParams = _v10.a;
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($author$project$Pages$Admin$Billing$saveCharge, model.Ej, chargeParams));
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Just(result.zi), $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var createChargeModal_ = _v9.a;
                    var cmd = _v9.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        hZ: createChargeModal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$CreateChargeModalMsg, result.EQ),
                        cmd
                    ])), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var practiceCharge = msg.a;
                var id = $author$project$Api$Provider$PracticeCharge$All$id(practiceCharge);
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$PracticeCharge$delete, model.Ej, id, $author$project$Pages$Admin$Billing$PracticeChargeDeleted(practiceCharge)), _List_Nil);
            case 12:
                var practiceCharge = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var uninvoicedCharges_ = A2($elm$core$List$filter, function(charge) {
                        return !_Utils_eq($author$project$Api$Provider$PracticeCharge$All$id(charge), $author$project$Api$Provider$PracticeCharge$All$id(practiceCharge));
                    }, model.oZ);
                    return _Utils_Tuple3(_Utils_update(model, {
                        oZ: uninvoicedCharges_
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$PracticeCharge$All$description(practiceCharge) + ' was successfully deleted.')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 13:
                var response = msg.a;
                _v12$2: while(true)switch(response.$){
                    case 3:
                        var upgrade = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            o5: $elm$core$Maybe$Just(upgrade)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        if (response.a.$ === 5) {
                            var _v13 = response.a;
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v12$2;
                    default:
                        break _v12$2;
                }
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                var _v14 = A3($author$project$Components$UpgradePracticeModal$init, model.o5, model.Z$, model.Ql);
                var upgradePracticeModal = _v14.a;
                var upgradePracticeModalCmd = _v14.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    kF: $elm$core$Maybe$Just(upgradePracticeModal)
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg, upgradePracticeModalCmd),
                    $author$project$Pages$Admin$Billing$updateUrl($author$project$Components$UpgradePracticeModal$urlParam(upgradePracticeModal))
                ])), _List_Nil);
            case 15:
                var subMsg = msg.a;
                var _v15 = model.kF;
                if (!_v15.$) {
                    var upgradePracticeModal = _v15.a;
                    var result = A3($author$project$Components$UpgradePracticeModal$update, model.Ej, subMsg, upgradePracticeModal);
                    var _v16 = function() {
                        var _v17 = result.adu;
                        switch(_v17.$){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Pages$Admin$Billing$updateUrl($elm$core$Maybe$Nothing), _List_Nil);
                            case 2:
                                var successMsg = _v17.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing), _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, successMsg)
                                ]));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Just(result.zi), $elm$core$Platform$Cmd$none, _List_Nil);
                        }
                    }();
                    var modal_ = _v16.a;
                    var cmd_ = _v16.b;
                    var outMsgs_ = _v16.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        kF: modal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg, result.EQ),
                        cmd_
                    ])), outMsgs_);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                return _Utils_Tuple3(model, A2($author$project$Api$Provider$PracticeInvoice$create, model.Ej, $author$project$Pages$Admin$Billing$InvoiceCreated), _List_Nil);
            case 17:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Pages$Admin$Billing$fetchPracticeInvoices, model.Ej, model.eo),
                    $author$project$Pages$Admin$Billing$fetchUninvoicedCharges(model.Ej)
                ])), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice created successfully.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 18:
                var label = msg.a;
                var url = msg.b;
                return _Utils_Tuple3(model, A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.Z$, label, url), _List_Nil);
            case 19:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, $author$project$Pages$Admin$Billing$fetchUninvoicedCharges(model.Ej), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Charge created successfully.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 20:
                var response = msg.a;
                if (response.$ === 3) {
                    var secret = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        pN: response
                    }), A2($author$project$Ports$Stripe$mountCapitalPromoTile, '#stripe-capital-promo-tile', secret), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    pN: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 21:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(model, A2($author$project$Api$Provider$Practice$StripeAccount$session, model.Ej, $author$project$Pages$Admin$Billing$GotCapitalSession), _List_Nil);
            default:
                var productType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    v1: $elm$core$Maybe$Just(productType)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoicePaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Alignment$justifyEnd = $author$project$Ui$Alignment$Content(2);
    var $author$project$Ui$Element$justifyRight = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$justifyEnd);
    var $author$project$Ui$Modal$Lg = 2;
    var $author$project$Ui$Modal$Size = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Modal$size = $author$project$Ui$Modal$Size;
    var $author$project$Components$ApplicationFeePlan$UpdateModal$Save = {
        $: 1
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdChanged = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$inputSpanMd = function(span) {
        return $author$project$Ui$Form$Group$InputGrid(_List_fromArray([
            'md:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
        ]));
    };
    var $author$project$Ui$Form$Group$labelSpanMd = function(span) {
        return $author$project$Ui$Form$Group$LabelGrid(_List_fromArray([
            'md:' + $author$project$Ui$Form$Group$spanToWidthClass(span)
        ]));
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$viewHubspotDealId = F2(function(form, hubspotDealUrl) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Import from Hubspot Deal'),
            $author$project$Ui$Form$Group$labelSpanMd(3),
            $author$project$Ui$Form$Group$inputSpanMd(4)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', $author$project$Utils$Form$fields(form).QT)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged, $author$project$Components$ApplicationFeePlan$UpdateModalForm$HubspotDealIdChanged)),
                $author$project$Ui$Form$Input$number,
                $author$project$Ui$Form$Input$placeholder('')
            ])),
            function() {
                if (!hubspotDealUrl.$) {
                    var url = hubspotDealUrl.a;
                    return A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$margin(21)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$externalHref, url, _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('View in HubSpot')
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$AddRecurringChargeButtonClicked = {
        $: 5
    };
    var $author$project$Ui$Margin$Top_3 = 18;
    var $author$project$Ui$Icon$Add = 39;
    var $author$project$Ui$Icon$add = $author$project$Ui$Icon$viewIcon(39);
    var $elm$core$List$sum = function(numbers) {
        return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$chargesTotalInCents = function(charges) {
        return $elm$core$List$sum(A2($elm$core$List$filterMap, function(c) {
            return A2($elm$core$Maybe$map, function(cents) {
                return cents * c.Bu;
            }, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, c.Br));
        }, charges));
    };
    var $author$project$Ui$Alignment$Start = 0;
    var $author$project$Ui$Alignment$itemsStart = $author$project$Ui$Alignment$Items(0);
    var $author$project$Ui$Element$itemsStart = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$itemsStart);
    var $author$project$Ui$Grid$justifyLeft = $author$project$Ui$Grid$Element($author$project$Ui$Element$itemsStart);
    var $author$project$Components$ApplicationFeePlan$UpdateModal$viewChargesTotal = function(charges) {
        var totalInCents = $author$project$Components$ApplicationFeePlan$UpdateModal$chargesTotalInCents(charges);
        return totalInCents > 0 ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(6),
                $author$project$Ui$Grid$justifyLeft
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Total')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(6),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Currency$format($author$project$Currency$fromInt(totalInCents)))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$DeleteRecurringCharge = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$EndRecurringCharge = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$Lives = 0;
    var $author$project$Components$ApplicationFeePlan$UpdateModal$PriceInputChanged = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeCategoryChanged = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeEndDateChanged = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeQuantityChanged = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeStartDateChanged = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForExistingCharges = function(categories) {
        return A2($elm$core$List$map, function(category) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$HintBillingProduct$Shared$id(category)), $author$project$Api$Provider$HintBillingProduct$Shared$name(category));
        }, categories);
    };
    var $author$project$Components$HintBilling$HintBillingProductOptions$UpdatePricing = 0;
    var $author$project$Api$Provider$HintBillingProduct$Shared$addonType = function(_v0) {
        var record = _v0;
        return record.IG;
    };
    var $author$project$Api$Provider$HintBillingProduct$Shared$archived = function(_v0) {
        var record = _v0;
        return record.JC;
    };
    var $author$project$Api$Provider$HintBillingComponent$AddonType$isFree = function(addonType) {
        if (addonType === 3) return true;
        else return false;
    };
    var $author$project$Components$HintBilling$HintBillingProductOptions$isFreeProduct = function(hintBillingProduct) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingComponent$AddonType$isFree, $author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct)));
    };
    var $author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime = function(addonType) {
        if (addonType === 2) return true;
        else return false;
    };
    var $author$project$Components$HintBilling$HintBillingProductOptions$isSelectable = F2(function(action, hintBillingProduct) {
        if ($author$project$Api$Provider$HintBillingProduct$Shared$archived(hintBillingProduct) || $author$project$Components$HintBilling$HintBillingProductOptions$isFreeProduct(hintBillingProduct)) return false;
        else switch(action){
            case 0:
                var _v1 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
                switch(_v1){
                    case 0:
                        return false;
                    case 2:
                        return false;
                    case 4:
                        return true;
                    case 3:
                        return false;
                    case 1:
                        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$not, A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime, $author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct))));
                    default:
                        return true;
                }
            case 1:
                var _v2 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
                switch(_v2){
                    case 1:
                        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingComponent$AddonType$isOneTime, $author$project$Api$Provider$HintBillingProduct$Shared$addonType(hintBillingProduct)));
                    case 5:
                        return true;
                    default:
                        return false;
                }
            default:
                var _v3 = $author$project$Api$Provider$HintBillingProduct$Shared$componentType(hintBillingProduct);
                if (_v3 === 5) return true;
                else return false;
        }
    });
    var $author$project$Components$HintBilling$HintBillingProductOptions$toSelectOption = function(hintBillingProduct) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$HintBillingProduct$Shared$id(hintBillingProduct)), $author$project$Api$Provider$HintBillingProduct$Shared$name(hintBillingProduct));
    };
    var $author$project$Components$HintBilling$HintBillingProductOptions$selectOptions = F2(function(action, hintBillingProducts) {
        return A2($elm$core$List$map, $author$project$Components$HintBilling$HintBillingProductOptions$toSelectOption, A2($elm$core$List$filter, $author$project$Components$HintBilling$HintBillingProductOptions$isSelectable(action), hintBillingProducts));
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForNewCharges = function(categories) {
        return A2($author$project$Components$HintBilling$HintBillingProductOptions$selectOptions, 0, categories);
    };
    var $author$project$Ui$Form$CurrencyInput$Disabled = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$disabled = $author$project$Ui$Form$CurrencyInput$Disabled;
    var $author$project$Ui$Form$Input$Disabled = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$disabled = $author$project$Ui$Form$Input$Disabled;
    var $author$project$Ui$Form$Select$Disabled = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$disabled = $author$project$Ui$Form$Select$Disabled;
    var $author$project$Components$ApplicationFeePlan$UpdateModal$getDefaultDescription = F2(function(categories, charge) {
        return $elm$core$String$isEmpty(charge.NQ) ? A2($author$project$Components$ApplicationFeePlan$UpdateModal$getCategoryNameById, categories, charge.QM) : charge.NQ;
    });
    var $author$project$Ui$Form$CurrencyInput$Invalid = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$invalid = function(bool) {
        return $author$project$Ui$Form$CurrencyInput$Invalid(bool);
    };
    var $author$project$Ui$Grid$mb2 = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$mb2);
    var $author$project$Ui$Form$CurrencyInput$OnInput = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$onInput = function(handler) {
        return $author$project$Ui$Form$CurrencyInput$OnInput(handler);
    };
    var $author$project$Ui$Form$CurrencyInput$Value = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$value = function(_int) {
        return $author$project$Ui$Form$CurrencyInput$Value(_int);
    };
    var $author$project$Ui$Form$Input$HideErrors = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$hideErrors = $author$project$Ui$Form$Input$HideErrors;
    var $author$project$Ui$Form$CurrencyInput$defaultOptions = {
        fK: _List_Nil,
        xW: false,
        aq: _List_Nil,
        q2: false,
        A9: $elm$core$Maybe$Nothing,
        sg: true,
        aa9: $elm$core$Maybe$Nothing
    };
    var $author$project$Currency$fromString = $elm$core$Basics$identity;
    var $author$project$Ui$Form$CurrencyInput$inputHandler = function(handler) {
        return A2($elm$core$Basics$composeR, $author$project$Utils$String$toMaybe, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Currency$fromString), handler));
    };
    var $author$project$Ui$Form$CurrencyInput$inputValue = function(currency) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Currency$toString, currency));
    };
    var $author$project$Ui$Form$Input$OnBlur = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$onBlur = $author$project$Ui$Form$Input$OnBlur;
    var $author$project$Ui$Form$Input$Test = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$test = function(dataTest) {
        return $author$project$Ui$Form$Input$Test(dataTest);
    };
    var $author$project$Ui$Form$CurrencyInput$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var handler = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$onInput($author$project$Ui$Form$CurrencyInput$inputHandler(handler)), record.aq)
                    });
                case 9:
                    var handler = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$onBlur(handler), record.aq)
                    });
                case 1:
                    var _int = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$value($author$project$Ui$Form$CurrencyInput$inputValue(_int)), record.aq),
                        aa9: _int
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        q2: bool
                    });
                case 3:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
                case 4:
                    var string = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$placeholder(string), record.aq)
                    });
                case 5:
                    var bool = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$disabled(bool), record.aq)
                    });
                case 6:
                    var string = option.a;
                    return _Utils_update(record, {
                        A9: $elm$core$Maybe$Just(string)
                    });
                case 7:
                    return _Utils_update(record, {
                        sg: false
                    });
                case 8:
                    var string = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$test(string), record.aq)
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        xW: bool
                    });
            }
        }), $author$project$Ui$Form$CurrencyInput$defaultOptions, options);
    };
    var $author$project$Ui$Form$CurrencyInput$view = function(options) {
        var optionsRecord = $author$project$Ui$Form$CurrencyInput$optionsToRecord(options);
        var prefix = optionsRecord.sg ? $author$project$Ui$Form$Input$addon(_List_fromArray([
            $elm$html$Html$text('$')
        ])) : $author$project$Utils$Html$empty;
        return $author$project$Ui$Form$Input$group(A2($elm$core$List$cons, prefix, A2($elm$core$List$cons, $author$project$Ui$Form$Input$view(A2($elm$core$List$cons, $author$project$Ui$Form$Input$invalid(optionsRecord.q2), A2($elm$core$List$cons, $author$project$Ui$Form$Input$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$Input$number, A2($elm$core$List$cons, $author$project$Ui$Form$Input$hideErrors(optionsRecord.xW), optionsRecord.aq))))), function() {
            var _v0 = optionsRecord.A9;
            if (!_v0.$) {
                var postfix_ = _v0.a;
                return _List_fromArray([
                    $author$project$Ui$Form$Input$addon(_List_fromArray([
                        $elm$html$Html$text(postfix_)
                    ]))
                ]);
            } else return _List_Nil;
        }())));
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$viewPackageTotal = F2(function(params, packageType) {
        var totalFloat = A2($elm$core$Maybe$andThen, function(priceInCents) {
            var quantityFloat = params.Bu;
            return A2($elm$core$Maybe$map, $author$project$Currency$fromFloat, A2($elm$core$Maybe$map, $author$project$Utils$Round$float, A2($elm$core$Maybe$map, $elm$core$Basics$mul(quantityFloat), $author$project$Currency$toFloat(priceInCents))));
        }, params.Br);
        if (!totalFloat.$) {
            var value = totalFloat.a;
            return A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Currency$format(value))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Ui$Form$Input$withPreAddon = F2(function(addonText, options) {
        var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
        var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Ui$Form$Input$addon(_List_fromArray([
                    $elm$html$Html$text(addonText)
                ])),
                $author$project$Ui$Form$Input$viewFeedback(optionsRecord),
                A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-control'), A2($elm$core$List$cons, $elm$html$Html$Attributes$value(optionsRecord.aa9), _Utils_ap($author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.ah5), _Utils_ap(optionsRecord.vD, onInputHandler)))), _List_Nil)
            ]),
            A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
        ]));
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringCharge = F4(function(model, fieldsDisabled, index, charge) {
        return A2($author$project$Ui$Grid$row, _List_fromArray([
            $author$project$Ui$Grid$rowItemsCenter
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mb2
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(charge.QM)),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged, $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeCategoryChanged(index))),
                            $author$project$Ui$Form$Select$disabled(fieldsDisabled || !_Utils_eq(charge.aef, $elm$core$Maybe$Nothing))
                        ]), _Utils_eq(charge.aef, $elm$core$Maybe$Nothing) ? $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForNewCharges(model.K0) : $author$project$Components$ApplicationFeePlan$UpdateModal$categoryOptionsForExistingCharges(model.K0))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$group(_List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(charge._2),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged, $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeStartDateChanged(index))),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$ApplicationFeePlan$UpdateModalForm$StartDateValidation(index), model.PU)),
                                $author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
                                $author$project$Ui$Form$Input$disabled(fieldsDisabled)
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$group(_List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(charge.xx),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged, $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeEndDateChanged(index))),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$ApplicationFeePlan$UpdateModalForm$EndDateValidation(index), model.PU)),
                                $author$project$Ui$Form$Input$placeholder('end date'),
                                $author$project$Ui$Form$Input$disabled(fieldsDisabled)
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(A2($author$project$Components$ApplicationFeePlan$UpdateModal$getDefaultDescription, model.K0, charge)),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged, $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeDescriptionChanged(index))),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index), model.PU)),
                            $author$project$Ui$Form$Input$placeholder('charge name'),
                            $author$project$Ui$Form$Input$disabled(fieldsDisabled)
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$ApplicationFeePlan$UpdateModalForm$DescriptionValidation(index), model.PU))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPreAddon, 'Qty', _List_fromArray([
                            $author$project$Ui$Form$Input$value($elm$core$String$fromInt(charge.Bu)),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$ApplicationFeePlan$UpdateModal$FormChanged, $author$project$Components$ApplicationFeePlan$UpdateModalForm$RecurringChargeQuantityChanged(index))),
                            $author$project$Ui$Form$Input$number,
                            $author$project$Ui$Form$Input$disabled(fieldsDisabled),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index), model.PU))
                        ]))),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$ApplicationFeePlan$UpdateModalForm$QuantityValidation(index), model.PU))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$group(_List_fromArray([
                            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                                $author$project$Ui$Form$CurrencyInput$value(A2($elm$core$Maybe$withDefault, charge.Br, A2($elm$core$Dict$get, index, model.cj))),
                                $author$project$Ui$Form$CurrencyInput$onInput($author$project$Components$ApplicationFeePlan$UpdateModal$PriceInputChanged(index)),
                                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index), model.PU)),
                                $author$project$Ui$Form$CurrencyInput$disabled(fieldsDisabled)
                            ]))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$ApplicationFeePlan$UpdateModalForm$PriceInCentsValidation(index), model.PU))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        _Utils_eq(charge.aef, $elm$core$Maybe$Nothing) ? A3($author$project$Ui$Button$view, {
                            abP: 'Delete recurring charge'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$DeleteRecurringCharge(index)),
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                            $author$project$Ui$Button$disabled(fieldsDisabled)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Delete')
                        ])) : A3($author$project$Ui$Button$view, {
                            abP: 'End recurring charge'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$EndRecurringCharge(index)),
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                            $author$project$Ui$Button$disabled(fieldsDisabled)
                        ]), _List_fromArray([
                            $elm$html$Html$text('End')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewPackageTotal, charge, 0)
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringChargesSection = F3(function(model, formFields, fieldsDisabled) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Charges'),
            $author$project$Ui$Form$Group$labelSpanMd(3),
            $author$project$Ui$Form$Group$inputSpanMd(9)
        ]), _Utils_ap(A2($elm$core$List$indexedMap, A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringCharge, model, fieldsDisabled), $author$project$Utils$Form$fields(formFields).K9), _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$margin(18)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Add new recurring charge'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$AddRecurringChargeButtonClicked),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$disabled(fieldsDisabled)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add New')
                ]))
            ])),
            $author$project$Components$ApplicationFeePlan$UpdateModal$viewChargesTotal($author$project$Utils$Form$fields(formFields).K9)
        ])));
    });
    var $author$project$Components$ApplicationFeePlan$UpdateModal$viewBody = function(model) {
        var showIfEditable = function(section) {
            return model.aeD ? section : $author$project$Utils$Html$empty;
        };
        var fieldsDisabled = $author$project$Components$ApplicationFeePlan$UpdateModal$hubspotDealModified(model.PU);
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$onSubmit($author$project$Components$ApplicationFeePlan$UpdateModal$Save),
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Components$ApplicationFeePlan$UpdateModal$viewHubspotDealId, model.PU, model.QU),
            showIfEditable($author$project$Ui$HorizontalRule$view(_List_Nil)),
            showIfEditable(A3($author$project$Components$ApplicationFeePlan$UpdateModal$viewRecurringChargesSection, model, model.PU, fieldsDisabled))
        ]));
    };
    var $author$project$Utils$Form$hasAnyValidationError = function(_v0) {
        var errors_ = _v0.d;
        return !$elm$core$List$isEmpty(errors_);
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$viewFooter = function(model) {
        return _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Cancel and close modal'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$Close)
            ]), _List_fromArray([
                $elm$html$Html$text('Cancel')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Save plan'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$disabled($author$project$Utils$Form$hasAnyValidationError(model.PU)),
                $author$project$Ui$Button$onClick($author$project$Components$ApplicationFeePlan$UpdateModal$Save)
            ]), _List_fromArray([
                $elm$html$Html$text('Save')
            ]))
        ]);
    };
    var $author$project$Components$ApplicationFeePlan$UpdateModal$view = function(model) {
        var modalTitle = model.aeD ? 'Edit Subscription' : 'Reset Pricing with a HubSpot Deal';
        return A3($author$project$Ui$Modal$view, $author$project$Components$ApplicationFeePlan$UpdateModal$Close, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(modalTitle)
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $author$project$Components$ApplicationFeePlan$UpdateModal$viewBody(model)
            ])),
            $author$project$Ui$Modal$footer($author$project$Components$ApplicationFeePlan$UpdateModal$viewFooter(model))
        ]));
    };
    var $author$project$Components$HintBilling$CreateChargeModal$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$HintBillingProductSelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$PriceInputChanged = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$HintBilling$CreateChargeModal$Quantity = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$Errors = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$errors = $author$project$Ui$Form$CurrencyInput$Errors;
    var $author$project$Components$HintBilling$HintBillingProductOptions$AddCharge = 1;
    var $author$project$Components$HintBilling$HintBillingProductOptions$AddCredit = 2;
    var $author$project$Components$HintBilling$CreateChargeModal$hintBillingProductOptions = F2(function(hintBillingProducts, practiceInvoice) {
        var action = function() {
            var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeInvoice$One$status, practiceInvoice);
            if (!_v0.$ && !_v0.a) {
                var _v1 = _v0.a;
                return 2;
            } else return 1;
        }();
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a category'), A2($author$project$Components$HintBilling$HintBillingProductOptions$selectOptions, action, hintBillingProducts));
    });
    var $author$project$Ui$Form$Select$Invalid = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$invalid = $author$project$Ui$Form$Select$Invalid;
    var $author$project$Components$HintBilling$CreateChargeModal$viewBody = F3(function(hintBillingProducts, form, pendingPrice) {
        var fields = $author$project$Utils$Form$fields(form);
        var hintBillingProductId = fields.QL;
        var hintBillingProduct = A2($elm$core$Maybe$andThen, function(hintBillingProductId_) {
            return $elm$core$List$head(A2($elm$core$List$filter, function(hintBillingProduct_) {
                return _Utils_eq($author$project$Api$Provider$HintBillingProduct$Shared$id(hintBillingProduct_), hintBillingProductId_);
            }, hintBillingProducts));
        }, hintBillingProductId);
        var _v0 = fields;
        var name = _v0.zr;
        var quantity = _v0.Bu;
        var priceInCents = _v0.Br;
        var practiceInvoice = _v0.W3;
        var displayPrice = A2($elm$core$Maybe$withDefault, priceInCents, pendingPrice);
        var priceFloat = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, displayPrice));
        var floorTotalInCents = $elm$core$Basics$round(priceFloat * A2($elm$core$Maybe$withDefault, 0, quantity));
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Category'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, function(hbp) {
                        return $author$project$Api$Provider$HintBillingProduct$Shared$id(hbp);
                    }, hintBillingProduct)),
                    $author$project$Ui$Form$Select$onChange($author$project$Components$HintBilling$CreateChargeModal$HintBillingProductSelected),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form))
                ]), A2($author$project$Components$HintBilling$CreateChargeModal$hintBillingProductOptions, hintBillingProducts, practiceInvoice))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Charge Name'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(name),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$HintBilling$CreateChargeModal$FormUpdated, $author$project$Components$HintBilling$CreateChargeModal$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('QTY'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(2)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$number,
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, quantity))),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$HintBilling$CreateChargeModal$FormUpdated, $author$project$Components$HintBilling$CreateChargeModal$Quantity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Price'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$value(displayPrice),
                        $author$project$Ui$Form$CurrencyInput$onInput($author$project$Components$HintBilling$CreateChargeModal$PriceInputChanged),
                        $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                        $author$project$Ui$Form$CurrencyInput$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Total'),
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Currency$format($author$project$Currency$fromInt(floorTotalInCents)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$HintBilling$CreateChargeModal$FormSubmitted = {
        $: 1
    };
    var $author$project$Components$HintBilling$CreateChargeModal$saveButtonLabel = F2(function(hintBillingComponentType, practiceInvoice) {
        var _v0 = _Utils_Tuple2(hintBillingComponentType, A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeInvoice$One$status, practiceInvoice));
        if (!_v0.a.$ && _v0.a.a === 5) {
            if (!_v0.b.$ && !_v0.b.a) {
                var _v1 = _v0.a.a;
                var _v2 = _v0.b.a;
                return 'Add Credit & Refund';
            } else {
                var _v3 = _v0.a.a;
                return 'Add Credit';
            }
        } else return 'Add Charge';
    });
    var $author$project$Components$HintBilling$CreateChargeModal$viewFooter = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var hintBillingComponentType = _v0.iP;
        var practiceInvoice = _v0.W3;
        var buttonLabel = A2($author$project$Components$HintBilling$CreateChargeModal$saveButtonLabel, hintBillingComponentType, practiceInvoice);
        return _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Cancel and close modal'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Cancel')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: buttonLabel
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick($author$project$Components$HintBilling$CreateChargeModal$FormSubmitted)
            ]), _List_fromArray([
                $elm$html$Html$text(buttonLabel)
            ]))
        ]);
    };
    var $author$project$Components$HintBilling$CreateChargeModal$view = F2(function(_v0, modalTitle) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$HintBilling$CreateChargeModal$CloseButtonClicked, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(modalTitle)
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A3($author$project$Components$HintBilling$CreateChargeModal$viewBody, model.K0, model.PU, model.nv)
            ])),
            $author$project$Ui$Modal$footer($author$project$Components$HintBilling$CreateChargeModal$viewFooter(model.PU))
        ]));
    });
    var $author$project$Components$UpgradePracticeModal$ConfirmUpgrade = {
        $: 2
    };
    var $author$project$Ui$Grid$Gutter = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Grid$Md = 2;
    var $author$project$Ui$Grid$gutterMd = $author$project$Ui$Grid$Gutter(2);
    var $author$project$Ui$Element$mt4 = $author$project$Ui$Element$Margin('mt-4');
    var $author$project$Ui$Element$mt8 = $author$project$Ui$Element$Margin('mt-8');
    var $author$project$Ui$Element$Stretch = {
        $: 13
    };
    var $author$project$Ui$Element$stretch = $author$project$Ui$Element$Stretch;
    var $author$project$Ui$Grid$rowItemsStretch = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$stretch);
    var $author$project$Ui$Element$SpaceX = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Element$spaceX4 = $author$project$Ui$Element$SpaceX(4);
    var $author$project$Components$UpgradePracticeModal$AgreedToTerms = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Typography$Danger = 5;
    var $author$project$Ui$Typography$danger = $author$project$Ui$Typography$Color(5);
    var $author$project$Ui$Element$Display = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Element$Flex = 2;
    var $author$project$Ui$Element$flexMd = A2($author$project$Ui$Element$Display, 2, 2);
    var $author$project$Ui$Form$Checkbox$Required = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$required = $author$project$Ui$Form$Checkbox$Required;
    var $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Margin$Left_1 = 11;
    var $author$project$Components$HintBilling$FeatureListLink$link = function(hasClinicalAccount) {
        return hasClinicalAccount ? 'https://www.hint.com/clinical/pricing' : 'https://www.hint.com/pricing';
    };
    var $author$project$Ui$Link$Margin = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Link$margin = $author$project$Ui$Link$Margin;
    var $author$project$Ui$Link$OnClick = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Link$onClick = $author$project$Ui$Link$OnClick;
    var $author$project$Components$UpgradePracticeModal$viewAdditionalInfoFooter = function(hasClinicalAccount) {
        var pricingInfoText = 'view our pricing information';
        var contactSalesText = 'Contact our sales team';
        var contactSalesLinkHref = 'mailto:sales@hint.com';
        return A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$muted
        ]), _List_fromArray([
            $elm$html$Html$text('Have any questions? '),
            A3($author$project$Ui$Link$externalHref, contactSalesLinkHref, _List_fromArray([
                $author$project$Ui$Link$targetBlank,
                $author$project$Ui$Link$onClick(A2($author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked, contactSalesText, contactSalesLinkHref))
            ]), _List_fromArray([
                $elm$html$Html$text(contactSalesText)
            ])),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(' or')
            ])),
            A3($author$project$Ui$Link$externalHref, $author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount), _List_fromArray([
                $author$project$Ui$Link$margin(11),
                $author$project$Ui$Link$targetBlank,
                $author$project$Ui$Link$onClick(A2($author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked, pricingInfoText, $author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount)))
            ]), _List_fromArray([
                $elm$html$Html$text(pricingInfoText)
            ])),
            $elm$html$Html$text(' on our website.')
        ]));
    };
    var $author$project$Components$UpgradePracticeModal$viewConfirmationCheckbox = F2(function(agreedToTerms, hasClinicalAccount) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(agreedToTerms),
                $author$project$Ui$Form$Checkbox$required(true),
                $author$project$Ui$Form$Checkbox$onCheck(function(value) {
                    return $author$project$Components$UpgradePracticeModal$AgreedToTerms(value);
                })
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flexMd
                ]), _List_fromArray([
                    $elm$html$Html$text('I agree to these changes, subject to the previously agreed upon terms of service.'),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]), _List_fromArray([
                        $elm$html$Html$text(' *')
                    ]))
                ]))
            ])),
            $author$project$Components$UpgradePracticeModal$viewAdditionalInfoFooter(hasClinicalAccount)
        ]));
    });
    var $elm$html$Html$h3 = _VirtualDom_node('h3');
    var $author$project$Ui$Typography$heading = function(content) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$h3, _List_fromArray([
            $elm$html$Html$Attributes$class('text-heading-md text-main')
        ]), content));
    };
    var $author$project$Ui$Icon$Star = 71;
    var $author$project$Ui$Alert$Success = 0;
    var $author$project$Ui$Margin$Top_4 = 9;
    var $author$project$Ui$Alert$Alignment = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Alert$alignment = $author$project$Ui$Alert$Alignment;
    var $author$project$Ui$Typography$Black = 8;
    var $author$project$Ui$Typography$black = $author$project$Ui$Typography$Color(8);
    var $author$project$Ui$Icon$Color = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Icon$color = $author$project$Ui$Icon$Color;
    var $author$project$Ui$Alert$margin = $author$project$Ui$Alert$Margin;
    var $author$project$Ui$Alignment$Left = 0;
    var $author$project$Ui$Alignment$textLeft = $author$project$Ui$Alignment$Text(0);
    var $author$project$Components$UpgradePracticeModal$viewClinicalDiscountBanner = function(hasClinicalAccount) {
        return hasClinicalAccount ? A3($author$project$Ui$Alert$view, 0, _List_fromArray([
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
            $author$project$Ui$Alert$margin(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flexMd
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Icon$view, _List_fromArray([
                        $author$project$Ui$Icon$height('1.8rem'),
                        $author$project$Ui$Icon$color('#2A8000')
                    ]), 71)
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold,
                        $author$project$Ui$Typography$margin(5),
                        $author$project$Ui$Typography$black
                    ]), _List_fromArray([
                        $elm$html$Html$text('Thanks for being a Clinical customer!')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$black
                    ]), _List_fromArray([
                        $elm$html$Html$text('You get a '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$bold
                        ]), _List_fromArray([
                            $elm$html$Html$text('20% discount')
                        ])),
                        $elm$html$Html$text(' on clinicians and members.')
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Icon$Calendar = 57;
    var $author$project$Ui$Icon$Scissors = 70;
    var $author$project$Ui$Icon$Sponsors = 11;
    var $author$project$Ui$Icon$StarNote = 72;
    var $author$project$Ui$Element$SpaceY = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Element$spaceY4 = $author$project$Ui$Element$SpaceY(4);
    var $author$project$Ui$Link$IconRight = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Ui$Link$iconRight = $author$project$Ui$Link$IconRight;
    var $author$project$Ui$Icon$Launch = 20;
    var $author$project$Ui$Icon$launch = $author$project$Ui$Icon$viewIcon(20);
    var $author$project$Ui$Link$Md = 2;
    var $author$project$Ui$Link$Size = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Ui$Link$md = $author$project$Ui$Link$Size(2);
    var $author$project$Ui$Link$Sm = 0;
    var $author$project$Ui$Link$sm = $author$project$Ui$Link$Size(0);
    var $author$project$Ui$Link$Style = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Ui$Link$Underline = 5;
    var $author$project$Ui$Link$underline = $author$project$Ui$Link$Style(5);
    var $author$project$Components$HintBilling$FeatureListLink$view = F3(function(hasClinicalAccount, onAnalyticsClick, smallSize) {
        return A3($author$project$Ui$Link$externalHref, $author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount), _List_fromArray([
            $author$project$Ui$Link$targetBlank,
            $author$project$Ui$Link$underline,
            $author$project$Ui$Link$iconRight($author$project$Ui$Icon$launch),
            $author$project$Ui$Link$onClick(A2(onAnalyticsClick, 'See All Features', $author$project$Components$HintBilling$FeatureListLink$link(hasClinicalAccount))),
            smallSize ? $author$project$Ui$Link$sm : $author$project$Ui$Link$md
        ]), _List_fromArray([
            $elm$html$Html$text('See All Features')
        ]));
    });
    var $author$project$Ui$Element$mr2 = $author$project$Ui$Element$Margin('mr-2');
    var $author$project$Components$UpgradePracticeModal$viewFeatureItem = F3(function(title, description, svgIcon) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flexMd,
            $author$project$Ui$Element$itemsStart
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mr2
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$height('1.8rem'),
                    $author$project$Ui$Icon$color('#00BFFF')
                ]), svgIcon)
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text(title)
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text(description)
                ]))
            ]))
        ]));
    });
    var $author$project$Components$UpgradePracticeModal$viewFeaturesList = function(hasClinicalAccount) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4,
            $author$project$Ui$Element$spaceY4
        ]), _List_fromArray([
            A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Lower Fees on Every Transaction', 'Grow your practice and keep more of what you earn. Lower transaction fees apply to every payment, starting with your next one.', 70),
            A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Employer Management & Billing', 'Streamline eligibility tracking, boost enrollments, and simplify billing for sponsoring employers with intuitive, built-in tools.', 11),
            hasClinicalAccount ? A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Hint Copilot', 'Simplify charting and streamline comminication with accurate, AI-generated SOAP notes and patient summaries.', 72) : A3($author$project$Components$UpgradePracticeModal$viewFeatureItem, 'Scheduled Plan Changes', 'Automate annual price increase, plan updates, and special offers so changes go live exactly when you want them.', 57),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A3($author$project$Components$HintBilling$FeatureListLink$view, hasClinicalAccount, $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked, true)
            ]))
        ]));
    };
    var $author$project$Components$UpgradePracticeModal$viewMarketingContent = F2(function(upgradePricing, hasClinicalAccount) {
        var tierName = function() {
            if (!upgradePricing.$) {
                var pricing = upgradePricing.a;
                return $author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing);
            } else return 'Growth';
        }();
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('px-4 py-2')
        ]), _List_fromArray([
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Upgrade to ' + tierName)
            ])),
            $author$project$Components$UpgradePracticeModal$viewClinicalDiscountBanner(hasClinicalAccount),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Unlock All Benefits Now, Pay Nothing Today')
                    ]))
                ])),
                $author$project$Components$UpgradePracticeModal$viewFeaturesList(hasClinicalAccount)
            ]))
        ]));
    });
    var $author$project$Ui$Alert$FullHeight = {
        $: 5
    };
    var $author$project$Ui$Alert$fullHeight = $author$project$Ui$Alert$FullHeight;
    var $author$project$Api$Provider$PracticePricing$Upgrade$components = function(_v0) {
        var record = _v0;
        return record.LU;
    };
    var $author$project$Ui$Element$Direction = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Element$DirectionColumn = 1;
    var $author$project$Ui$Element$flexCol = A2($author$project$Ui$Element$Direction, 0, 1);
    var $author$project$Utils$Currency$fromInt = function(cents) {
        return cents >= 0 ? '$' + A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, cents / 100) : '-$' + A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, $elm$core$Basics$abs(cents) / 100);
    };
    var $author$project$Ui$Element$FullHeight = {
        $: 14
    };
    var $author$project$Ui$Element$fullHeight = $author$project$Ui$Element$FullHeight;
    var $author$project$Ui$HorizontalRule$Margin = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$HorizontalRule$margin = $author$project$Ui$HorizontalRule$Margin;
    var $author$project$Ui$Element$mb4 = $author$project$Ui$Element$Margin('mb-4');
    var $author$project$Api$Provider$PracticePricing$Upgrade$nextBillDate = function(_v0) {
        var record = _v0;
        return record.UY;
    };
    var $author$project$Api$Provider$PracticePricing$Upgrade$totalInCents = function(_v0) {
        var record = _v0;
        return record.aam;
    };
    var $author$project$Api$Provider$PracticePricing$Upgrade$txnFees = function(_v0) {
        var record = _v0;
        return record.aaD;
    };
    var $author$project$Components$UpgradePracticeModal$viewDiscountInfo = A2($author$project$Ui$Typography$p, _List_fromArray([
        $author$project$Ui$Typography$muted,
        $author$project$Ui$Typography$small,
        $author$project$Ui$Typography$margin(9)
    ]), _List_fromArray([
        $elm$html$Html$text('Any existing credits or discounts will continue to apply until they expire.')
    ]));
    var $author$project$Ui$Margin$Right_2 = 16;
    var $author$project$Ui$Typography$Strike = 1;
    var $author$project$Ui$Typography$strike = $author$project$Ui$Typography$Decoration(1);
    var $author$project$Ui$Alignment$Right = 2;
    var $author$project$Ui$Alignment$textRight = $author$project$Ui$Alignment$Text(2);
    var $author$project$Ui$Popover$Body = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Popover$body = $author$project$Ui$Popover$Body;
    var $author$project$Ui$Popover$Dark = 0;
    var $author$project$Ui$Popover$Styling = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Popover$dark = $author$project$Ui$Popover$Styling(0);
    var $author$project$Formatters$Locales$noDecimalLocale = {
        acV: '.',
        Nm: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
        afc: "\u2212",
        afd: '',
        age: '',
        agf: '',
        ahS: ',',
        ain: '',
        aio: ''
    };
    var $author$project$Utils$Currency$fromIntNoDecimals = function(cents) {
        return '$' + A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, cents / 100);
    };
    var $author$project$Ui$Icon$Help = 7;
    var $author$project$Ui$Icon$help = $author$project$Ui$Icon$viewIcon(7);
    var $author$project$Ui$Typography$HelpText = {
        $: 9
    };
    var $author$project$Ui$Typography$helpText = $author$project$Ui$Typography$HelpText;
    var $author$project$Ui$Popover$OnHover = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Popover$onHover = $author$project$Ui$Popover$OnHover;
    var $author$project$Ui$Popover$Size = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Popover$Small = 3;
    var $author$project$Ui$Popover$sm = $author$project$Ui$Popover$Size(3);
    var $author$project$Api$Provider$PracticePricing$TrancheSizes$trancheSize = function(tierName) {
        switch(tierName){
            case 'Growth':
                return $elm$core$Maybe$Just(50);
            case 'Scale':
                return $elm$core$Maybe$Just(250);
            case 'Enterprise':
                return $elm$core$Maybe$Just(500);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$html$Html$Events$onMouseOver = function(msg) {
        return A2($elm$html$Html$Events$on, 'mouseover', $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Ui$Popover$Default = 0;
    var $author$project$Ui$Popover$defaultOptions = {
        x9: true,
        yP: _List_Nil,
        zX: $elm$core$Maybe$Nothing,
        ahq: 0,
        s5: 'popover__elm',
        hh: false
    };
    var $author$project$Ui$Popover$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, optionsRecord) {
            switch(option.$){
                case 0:
                    var style = option.a;
                    return _Utils_update(optionsRecord, {
                        s5: 'popover--dark'
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(optionsRecord, {
                        hh: bool
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(optionsRecord, {
                        x9: bool
                    });
                case 3:
                    var size_ = option.a;
                    return _Utils_update(optionsRecord, {
                        ahq: size_
                    });
                case 4:
                    var msg = option.a;
                    return _Utils_update(optionsRecord, {
                        zX: $elm$core$Maybe$Just(msg)
                    });
                default:
                    var margin_ = option.a;
                    return _Utils_update(optionsRecord, {
                        yP: A2($elm$core$List$cons, $author$project$Ui$Margin$toClass(margin_), optionsRecord.yP)
                    });
            }
        }), $author$project$Ui$Popover$defaultOptions, options);
    };
    var $author$project$Ui$Popover$sectionToContents = function(section) {
        switch(section.$){
            case 0:
                var attributes = section.a;
                var contents = section.b;
                return _List_fromArray([
                    A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('popover__heading'), attributes), contents)
                ]);
            case 1:
                var attributes = section.a;
                var contents = section.b;
                return _List_fromArray([
                    A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('popover__body'), attributes), contents)
                ]);
            default:
                var attributes = section.a;
                var contents = section.b;
                return _List_fromArray([
                    A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('popover__footer'), attributes), contents)
                ]);
        }
    };
    var $author$project$Ui$Popover$sectionsToContents = function(sections) {
        return A2($elm$core$List$concatMap, $author$project$Ui$Popover$sectionToContents, sections);
    };
    var $author$project$Ui$Popover$sizeToClass = function(size_) {
        switch(size_){
            case 0:
                return '';
            case 3:
                return 'popover--sm';
            case 2:
                return 'popover--md';
            default:
                return 'popover--lg';
        }
    };
    var $author$project$Ui$Popover$popoverContent = F2(function(sections, optionsRecord) {
        return A2($elm$html$Html$div, _Utils_ap(optionsRecord.yP, _List_fromArray([
            $elm$html$Html$Attributes$class('popover__content'),
            $elm$html$Html$Attributes$class($author$project$Ui$Popover$sizeToClass(optionsRecord.ahq)),
            $elm$html$Html$Attributes$class(optionsRecord.s5)
        ])), $author$project$Ui$Popover$sectionsToContents(sections));
    });
    var $author$project$Ui$Popover$popoverDisplayedContent = function(content) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('popover__content--displayed')
        ]), content);
    };
    var $author$project$Ui$Popover$popoverView = F4(function(options, displayedContent, sections, maybeModel) {
        var optionsRecord = $author$project$Ui$Popover$optionsToRecord(options);
        if (!maybeModel.$) {
            var model = maybeModel.a;
            return A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('popover__wrapper'),
                $elm$html$Html$Attributes$id(model.aef),
                model.Vw ? $elm$html$Html$Attributes$class('visible') : $elm$html$Html$Attributes$class('')
            ]), _List_fromArray([
                $author$project$Ui$Popover$popoverDisplayedContent(displayedContent),
                A2($author$project$Ui$Popover$popoverContent, sections, optionsRecord)
            ]));
        } else return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('popover__wrapper'),
            A2($elm$core$Maybe$withDefault, $elm$html$Html$Attributes$class(''), A2($elm$core$Maybe$map, $elm$html$Html$Events$onMouseOver, optionsRecord.zX)),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('visible', optionsRecord.hh),
                _Utils_Tuple2('hoverable', optionsRecord.x9)
            ]))
        ]), _List_fromArray([
            $author$project$Ui$Popover$popoverDisplayedContent(displayedContent),
            A2($author$project$Ui$Popover$popoverContent, sections, optionsRecord)
        ]));
    });
    var $author$project$Ui$Popover$view = F3(function(options, displayedContent, sections) {
        return A4($author$project$Ui$Popover$popoverView, options, displayedContent, sections, $elm$core$Maybe$Nothing);
    });
    var $author$project$Components$HintBilling$MemberTranches$view = F4(function(tierName, quantity, itemPriceInCents, onAnalyticsClick) {
        var _v0 = $author$project$Api$Provider$PracticePricing$TrancheSizes$trancheSize(tierName);
        if (!_v0.$) {
            var trancheSize = _v0.a;
            var numberOfTranches = quantity / trancheSize | 0;
            var pricePerTranche = itemPriceInCents / numberOfTranches | 0;
            var perMembersPriceText = $author$project$Utils$Currency$fromIntNoDecimals(pricePerTranche) + ('/mo per ' + ($elm$core$String$fromInt(trancheSize) + ' members '));
            return A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$helpText,
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text(perMembersPriceText),
                A3($author$project$Ui$Popover$view, _List_fromArray([
                    $author$project$Ui$Popover$dark,
                    $author$project$Ui$Popover$sm,
                    $author$project$Ui$Popover$onHover(A2(onAnalyticsClick, perMembersPriceText, 'tooltip'))
                ]), _List_fromArray([
                    $author$project$Ui$Icon$help(_List_Nil)
                ]), _List_fromArray([
                    A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Additional members are automatically added in tranches of ' + ($elm$core$String$fromInt(trancheSize) + ' members. If your member count goes below this tranche, you can downgrade at any time.'))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$UpgradePracticeModal$viewLineItem = F2(function(tierName, component) {
        var quantity = A2($elm$core$Maybe$withDefault, 1, component.Bu);
        var oldPriceInCents = A2($elm$core$Maybe$map, function(price) {
            return quantity * price;
        }, component.Vj);
        var itemPriceInCents = quantity * component.Br;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$black
                ]), _List_fromArray([
                    function() {
                        var _v0 = component.Bu;
                        if (!_v0.$) {
                            var qty = _v0.a;
                            return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text($elm$core$String$fromInt(qty))
                                ])),
                                $elm$html$Html$text(' ' + component.zr)
                            ]));
                        } else return $elm$html$Html$text(component.zr);
                    }()
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    function() {
                        if (!oldPriceInCents.$) {
                            var price = oldPriceInCents.a;
                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$strike,
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight),
                                $author$project$Ui$Typography$margin(16)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt(price))
                            ]));
                        } else return $author$project$Utils$Html$noBreakSpace;
                    }(),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$black
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(itemPriceInCents))
                    ]))
                ]))
            ])),
            component.LT === 2 ? A4($author$project$Components$HintBilling$MemberTranches$view, tierName, quantity, itemPriceInCents, $author$project$Components$UpgradePracticeModal$AnalyticsLinkClicked) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$UpgradePracticeModal$viewLineItems = F2(function(tierName, components) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$spaceY4
        ]), A2($elm$core$List$map, $author$project$Components$UpgradePracticeModal$viewLineItem(tierName), A2($elm$core$List$filter, function(component) {
            return !!component.Br;
        }, components)));
    });
    var $author$project$Ui$Margin$Top_2 = 8;
    var $author$project$Api$Provider$TxnFees$achTransactionFeeCapInCents = function(_v0) {
        var record = _v0;
        return record.Io;
    };
    var $author$project$Api$Provider$TxnFees$amexSurcharge = function(_v0) {
        var record = _v0;
        return record.aai - record.HR;
    };
    var $author$project$Api$Provider$TxnFees$totalAchFeeInCents = function(_v0) {
        var record = _v0;
        return record.aag;
    };
    var $author$project$Api$Provider$TxnFees$totalAchFeePercentage = function(_v0) {
        var record = _v0;
        return record.aah;
    };
    var $author$project$Api$Provider$TxnFees$totalCardFeeInCents = function(_v0) {
        var record = _v0;
        return record.aaj;
    };
    var $author$project$Api$Provider$TxnFees$totalCardFeePercentage = function(_v0) {
        var record = _v0;
        return record.HR;
    };
    var $author$project$Utils$Billing$TxnFees$viewFees = F2(function(txnFees, inline) {
        var totalCardFeePercentage = $elm$core$String$fromFloat($author$project$Api$Provider$TxnFees$totalCardFeePercentage(txnFees)) + '%';
        var totalCardFeeInCents = $elm$core$String$fromInt($author$project$Api$Provider$TxnFees$totalCardFeeInCents(txnFees)) + 'c';
        var totalAchFeePercentage = $elm$core$String$fromFloat($author$project$Api$Provider$TxnFees$totalAchFeePercentage(txnFees)) + '%';
        var totalAchFeeInCents = $elm$core$String$fromInt($author$project$Api$Provider$TxnFees$totalAchFeeInCents(txnFees)) + 'c';
        var amexSurchargeDisplay = ' + ' + ($elm$core$String$fromFloat($author$project$Api$Provider$TxnFees$amexSurcharge(txnFees)) + '% Amex surcharge');
        var achCapDisplay = function() {
            var _v0 = $author$project$Api$Provider$TxnFees$achTransactionFeeCapInCents(txnFees);
            if (!_v0.$) {
                var cap = _v0.a;
                return ' ($' + ($elm$core$String$fromFloat(cap / 100) + ' cap per txn)');
            } else return '';
        }();
        return inline ? A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$black,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('Credit cards: ' + (totalCardFeePercentage + (' + ' + totalCardFeeInCents))),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text(amexSurchargeDisplay)
                ]))
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$black,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('ACH: ' + (totalAchFeePercentage + (' + ' + (totalAchFeeInCents + achCapDisplay))))
            ]))
        ])) : A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Credit Card:')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text(totalCardFeePercentage)
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text(' + ' + totalCardFeeInCents)
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text(amexSurchargeDisplay)
                ]))
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('ACH:')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text(totalAchFeePercentage)
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text(' + ' + totalAchFeeInCents)
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text(achCapDisplay)
                ]))
            ]))
        ]));
    });
    var $author$project$Components$UpgradePracticeModal$viewTransactionFees = function(txnFees) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$black,
                $author$project$Ui$Typography$margin(5),
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('Updated Transaction Fees')
            ])),
            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                $author$project$Ui$HorizontalRule$margin(8)
            ])),
            A2($author$project$Utils$Billing$TxnFees$viewFees, txnFees, true)
        ]));
    };
    var $author$project$Components$UpgradePracticeModal$viewPricingContent = function(pricing) {
        var nextBillDate = function() {
            var _v0 = $author$project$Api$Provider$PracticePricing$Upgrade$nextBillDate(pricing);
            if (!_v0.$) {
                var date = _v0.a;
                return A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date);
            } else return '';
        }();
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flexCol,
            $author$project$Ui$Element$spaceBetween,
            $author$project$Ui$Element$fullHeight
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Your new recurring total')
                    ])),
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticePricing$Upgrade$totalInCents(pricing)))
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('Due on ' + nextBillDate)
                ])),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$margin(9)
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Components$UpgradePracticeModal$viewLineItems, $author$project$Api$Provider$PracticePricing$Upgrade$tierName(pricing), $author$project$Api$Provider$PracticePricing$Upgrade$components(pricing))
                ])),
                $author$project$Components$UpgradePracticeModal$viewDiscountInfo
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Components$UpgradePracticeModal$viewTransactionFees($author$project$Api$Provider$PracticePricing$Upgrade$txnFees(pricing))
            ]))
        ]));
    };
    var $author$project$Components$UpgradePracticeModal$viewPricingSidebar = function(upgradePricing) {
        return A3($author$project$Ui$Alert$view, 1, _List_fromArray([
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
            $author$project$Ui$Alert$fullHeight
        ]), _List_fromArray([
            function() {
                if (!upgradePricing.$) {
                    var pricing = upgradePricing.a;
                    return $author$project$Components$UpgradePracticeModal$viewPricingContent(pricing);
                } else return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$margin(9)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Loading pricing information...')
                    ]))
                ]));
            }()
        ]));
    };
    var $author$project$Components$UpgradePracticeModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$UpgradePracticeModal$Close, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$gutterMd,
                    $author$project$Ui$Grid$rowItemsStretch
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(7)
                    ]), _List_fromArray([
                        A2($author$project$Components$UpgradePracticeModal$viewMarketingContent, model.hc, model.Ql)
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(5)
                    ]), _List_fromArray([
                        $author$project$Components$UpgradePracticeModal$viewPricingSidebar(model.hc)
                    ]))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt8
                ]), _List_fromArray([
                    A2($author$project$Components$UpgradePracticeModal$viewConfirmationCheckbox, model.abC, model.Ql)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$mt4,
                    $author$project$Ui$Element$spaceX4
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and lose modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$secondary,
                        $author$project$Ui$Button$onClick($author$project$Components$UpgradePracticeModal$Close)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Upgrade'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Components$UpgradePracticeModal$ConfirmUpgrade),
                        $author$project$Ui$Button$disabled(!model.abC || model.i_)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Upgrade')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Billing$modals = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.cu;
                if (_v0.$ === 1 && _v0.a) {
                    var modal = _v0.b;
                    return A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$UpdateModalMsg, $author$project$Components$ApplicationFeePlan$UpdateModal$view(modal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v1 = model.hZ;
                if (!_v1.$) {
                    var modal = _v1.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$CreateChargeModalMsg, A2($author$project$Components$HintBilling$CreateChargeModal$view, modal, 'Add Charge or Credit'));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v2 = model.kF;
                if (!_v2.$) {
                    var modal = _v2.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$UpgradePracticeModalMsg, $author$project$Components$UpgradePracticeModal$view(modal));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Api$Provider$PracticePricing$One$manualBilling = function(_v0) {
        var record = _v0;
        return record.TA;
    };
    var $author$project$Pages$Admin$Billing$shouldShowBillingSections = function(practicePricingData) {
        if (practicePricingData.$ === 3) {
            var practicePricing = practicePricingData.a;
            return !$author$project$Api$Provider$PracticePricing$One$manualBilling(practicePricing);
        } else return true;
    };
    var $author$project$Ui$Table$Loading = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Table$loading = $author$project$Ui$Table$Loading;
    var $author$project$Api$Pagination$CurrentPageChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Pagination$ItemsPerPageChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$CurrentPage = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$currentPage = $author$project$Ui$Pagination$List$CurrentPage;
    var $author$project$Ui$Pagination$List$ItemsPerPage = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$itemsPerPage = $author$project$Ui$Pagination$List$ItemsPerPage;
    var $author$project$Ui$Pagination$List$OnClick = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$onClick = $author$project$Ui$Pagination$List$OnClick;
    var $author$project$Ui$Pagination$List$OnPerPageChange = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$onPerPageChange = $author$project$Ui$Pagination$List$OnPerPageChange;
    var $author$project$Ui$Pagination$List$TotalCount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$totalCount = $author$project$Ui$Pagination$List$TotalCount;
    var $author$project$Ui$Element$FullWidth = {
        $: 15
    };
    var $author$project$Ui$Element$fullWidth = $author$project$Ui$Element$FullWidth;
    var $author$project$Ui$Skeleton$inputSm = $author$project$Ui$Skeleton$view('input-sm');
    var $author$project$Ui$Skeleton$inputXs = $author$project$Ui$Skeleton$view('input-xs');
    var $author$project$Ui$Pagination$List$offsetSize = 2;
    var $author$project$Utils$Html$Attributes$none = $elm$html$Html$Attributes$class('');
    var $author$project$Ui$Pagination$List$onClick_ = F2(function(maybeMsg, pageNumber) {
        if (!maybeMsg.$) {
            var msg = maybeMsg.a;
            return $elm$html$Html$Events$onClick(msg(pageNumber));
        } else return $author$project$Utils$Html$Attributes$none;
    });
    var $author$project$Ui$Pagination$List$Md = 1;
    var $author$project$Ui$Pagination$List$defaultOptions = {
        bt: 0,
        xY: false,
        xZ: false,
        fY: 0,
        Tk: false,
        zU: $elm$core$Maybe$Nothing,
        z_: $elm$core$Maybe$Nothing,
        GT: _List_fromArray([
            10,
            25,
            50,
            75,
            100
        ]),
        ahq: 1,
        oQ: 0
    };
    var $author$project$Ui$Pagination$List$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var _int = option.a;
                    return _Utils_update(record, {
                        oQ: _int
                    });
                case 1:
                    var _int = option.a;
                    return _Utils_update(record, {
                        fY: _int
                    });
                case 2:
                    return _Utils_update(record, {
                        xZ: true
                    });
                case 3:
                    return _Utils_update(record, {
                        xY: true
                    });
                case 4:
                    var _int = option.a;
                    return _Utils_update(record, {
                        bt: _int
                    });
                case 5:
                    var toMsg = option.a;
                    return _Utils_update(record, {
                        zU: $elm$core$Maybe$Just(toMsg)
                    });
                case 6:
                    var toMsg = option.a;
                    return _Utils_update(record, {
                        z_: $elm$core$Maybe$Just(toMsg)
                    });
                case 7:
                    var size_ = option.a;
                    return _Utils_update(record, {
                        ahq: size_
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Tk: bool
                    });
            }
        }), $author$project$Ui$Pagination$List$defaultOptions, options);
    };
    var $author$project$Ui$Pagination$List$sizeClass = function(size_) {
        switch(size_){
            case 0:
                return 'pagination--sm';
            case 1:
                return '';
            default:
                return 'pagination--lg';
        }
    };
    var $author$project$Ui$Element$spaceX2 = $author$project$Ui$Element$SpaceX(2);
    var $author$project$Ui$Pagination$List$viewPage = F3(function(currentPage_, maybeMsg, pageNumber) {
        return A2($elm$html$Html$li, _List_fromArray([
            $elm$html$Html$Attributes$class('pagination__item'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('active', _Utils_eq(currentPage_, pageNumber))
            ])),
            A2($author$project$Ui$Pagination$List$onClick_, maybeMsg, pageNumber)
        ]), _List_fromArray([
            $elm$html$Html$text($elm$core$String$fromInt(pageNumber))
        ]));
    });
    var $author$project$Ui$Pagination$List$onPerPageChange_ = function(maybeMsg) {
        if (!maybeMsg.$) {
            var msg = maybeMsg.a;
            return A2($elm$json$Json$Decode$andThen, function(val) {
                var _v1 = $elm$core$String$toInt(val);
                if (!_v1.$) {
                    var n = _v1.a;
                    return $elm$json$Json$Decode$succeed(msg(n));
                } else return $elm$json$Json$Decode$fail('invalid int');
            }, A2($elm$json$Json$Decode$at, _List_fromArray([
                'target',
                'value'
            ]), $elm$json$Json$Decode$string));
        } else return $elm$json$Json$Decode$fail('no onPerPageChange');
    };
    var $author$project$Ui$Pagination$List$viewPerPageSelect = function(options) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('pagination__per-page')
        ]), _List_fromArray([
            A2($elm$html$Html$select, _List_fromArray([
                $elm$html$Html$Attributes$class('pagination__per-page-select'),
                A2($elm$html$Html$Events$on, 'change', $author$project$Ui$Pagination$List$onPerPageChange_(options.z_))
            ]), A2($elm$core$List$map, function(n) {
                return A2($elm$html$Html$option, _List_fromArray([
                    $elm$html$Html$Attributes$value($elm$core$String$fromInt(n)),
                    $elm$html$Html$Attributes$selected(_Utils_eq(n, options.fY))
                ]), _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(n) + ' per page')
                ]));
            }, options.GT))
        ]));
    };
    var $author$project$Ui$Pagination$List$view = function(options) {
        var optionsRecord = $author$project$Ui$Pagination$List$optionsToRecord(options);
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$fullWidth
        ]), function() {
            if (optionsRecord.Tk) {
                var skeleton = function(text) {
                    return (function() {
                        var _v0 = optionsRecord.ahq;
                        if (!_v0) return $author$project$Ui$Skeleton$inputXs;
                        else return $author$project$Ui$Skeleton$inputSm;
                    })()(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText(text + '0')
                    ]));
                };
                return _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceX2,
                        $author$project$Ui$Element$mb2
                    ]), _List_fromArray([
                        skeleton('First'),
                        skeleton('1'),
                        skeleton('2'),
                        skeleton('3'),
                        skeleton('...'),
                        skeleton('Last')
                    ]))
                ]);
            } else {
                var showTotalItems = !optionsRecord.xY && !(_Utils_cmp(optionsRecord.oQ, optionsRecord.fY) < 1 && optionsRecord.xZ);
                return $elm$core$List$concat(_List_fromArray([
                    function() {
                        if (!optionsRecord.oQ) return _List_Nil;
                        else {
                            if (_Utils_cmp(optionsRecord.oQ, optionsRecord.fY) > 0) {
                                var totalPages = $elm$core$Basics$ceiling(optionsRecord.oQ / optionsRecord.fY);
                                var lastVisible = A2($elm$core$Basics$min, optionsRecord.bt + $author$project$Ui$Pagination$List$offsetSize, totalPages);
                                var firstVisible = A2($elm$core$Basics$max, optionsRecord.bt - $author$project$Ui$Pagination$List$offsetSize, 1);
                                var pages = A2($elm$core$List$range, firstVisible, lastVisible);
                                return _List_fromArray([
                                    A2($elm$html$Html$ul, _List_fromArray([
                                        $elm$html$Html$Attributes$class('pagination'),
                                        $elm$html$Html$Attributes$class($author$project$Ui$Pagination$List$sizeClass(optionsRecord.ahq))
                                    ]), $elm$core$List$concat(_List_fromArray([
                                        _List_fromArray([
                                            A2($elm$html$Html$li, _List_fromArray([
                                                $elm$html$Html$Attributes$class('pagination__item'),
                                                $elm$html$Html$Attributes$classList(_List_fromArray([
                                                    _Utils_Tuple2('disabled', optionsRecord.bt === 1)
                                                ])),
                                                A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.zU, 1)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('First')
                                            ]))
                                        ]),
                                        firstVisible > 1 ? _List_fromArray([
                                            A2($elm$html$Html$li, _List_fromArray([
                                                $elm$html$Html$Attributes$class('pagination__item'),
                                                A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.zU, firstVisible - 1)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('...')
                                            ]))
                                        ]) : _List_Nil,
                                        A2($elm$core$List$map, A2($author$project$Ui$Pagination$List$viewPage, optionsRecord.bt, optionsRecord.zU), pages),
                                        _Utils_cmp(lastVisible, totalPages) < 0 ? _List_fromArray([
                                            A2($elm$html$Html$li, _List_fromArray([
                                                $elm$html$Html$Attributes$class('pagination__item'),
                                                A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.zU, lastVisible + 1)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('...')
                                            ]))
                                        ]) : _List_Nil,
                                        _List_fromArray([
                                            A2($elm$html$Html$li, _List_fromArray([
                                                $elm$html$Html$Attributes$class('pagination__item'),
                                                $elm$html$Html$Attributes$classList(_List_fromArray([
                                                    _Utils_Tuple2('disabled', _Utils_eq(optionsRecord.bt, totalPages))
                                                ])),
                                                A2($author$project$Ui$Pagination$List$onClick_, optionsRecord.zU, totalPages)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Last')
                                            ]))
                                        ])
                                    ])))
                                ]);
                            } else return _List_Nil;
                        }
                    }(),
                    function() {
                        if (showTotalItems) {
                            var offsetCount = (optionsRecord.bt - 1) * optionsRecord.fY;
                            var fromItems = offsetCount + 1;
                            var fromItems_ = !optionsRecord.oQ ? 0 : fromItems;
                            var currentPageItemsCount = _Utils_cmp(optionsRecord.fY * optionsRecord.bt, optionsRecord.oQ) > 0 ? optionsRecord.oQ - optionsRecord.fY * (optionsRecord.bt - 1) : optionsRecord.fY;
                            var toItems = fromItems - 1 + currentPageItemsCount;
                            return _List_fromArray([
                                A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$class('pagination__right')
                                ]), _List_fromArray([
                                    A2($elm$html$Html$div, _List_fromArray([
                                        $elm$html$Html$Attributes$class('pagination__total')
                                    ]), _List_fromArray([
                                        $elm$html$Html$text($elm$core$String$fromInt(fromItems_) + (" \u2014 " + ($elm$core$String$fromInt(toItems) + (' of ' + $elm$core$String$fromInt(optionsRecord.oQ)))))
                                    ])),
                                    $author$project$Ui$Pagination$List$viewPerPageSelect(optionsRecord)
                                ]))
                            ]);
                        } else return _List_Nil;
                    }()
                ]));
            }
        }());
    };
    var $author$project$Api$Pagination$view = F2(function(options, _v0) {
        var model = _v0;
        return $author$project$Ui$Pagination$List$view(A2($elm$core$List$cons, $author$project$Ui$Pagination$List$totalCount(model.oQ), A2($elm$core$List$cons, $author$project$Ui$Pagination$List$itemsPerPage(model.fY), A2($elm$core$List$cons, $author$project$Ui$Pagination$List$currentPage(model.bt), A2($elm$core$List$cons, $author$project$Ui$Pagination$List$onClick($author$project$Api$Pagination$CurrentPageChanged), A2($elm$core$List$cons, $author$project$Ui$Pagination$List$onPerPageChange($author$project$Api$Pagination$ItemsPerPageChanged), options))))));
    });
    var $author$project$Api$Provider$PracticeInvoice$Status$toString = function(status_) {
        switch(status_){
            case 0:
                return 'paid';
            case 1:
                return 'processing';
            case 2:
                return 'draft';
            case 5:
                return 'overdue';
            case 4:
                return 'cancelled';
            case 6:
                return 'disputed';
            default:
                return 'issued';
        }
    };
    var $author$project$Api$Provider$PracticeInvoice$Status$toBadge = function(status_) {
        var badgeOption = function() {
            switch(status_){
                case 0:
                    return _List_fromArray([
                        $author$project$Ui$Badge$success
                    ]);
                case 1:
                    return _List_fromArray([
                        $author$project$Ui$Badge$primary
                    ]);
                case 3:
                    return _List_fromArray([
                        $author$project$Ui$Badge$warning
                    ]);
                case 5:
                    return _List_fromArray([
                        $author$project$Ui$Badge$danger
                    ]);
                default:
                    return _List_Nil;
            }
        }();
        return A2($author$project$Ui$Badge$view, badgeOption, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$PracticeInvoice$Status$toString(status_))
        ]));
    };
    var $author$project$Components$HintBilling$InvoicesTable$viewInvoiceUrl = F2(function(id, linkContent) {
        return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String({
            aef: id
        }), _List_Nil, _List_fromArray([
            linkContent
        ]));
    });
    var $author$project$Formatters$Time$Date__Full = 5;
    var $author$project$Components$HintBilling$InvoicesTable$isInvoicePaid = function(invoice) {
        return !invoice.ahy;
    };
    var $author$project$Components$HintBilling$InvoicesTable$viewPaidInfo = function(invoice) {
        if ($author$project$Components$HintBilling$InvoicesTable$isInvoicePaid(invoice)) {
            var _v0 = invoice.GO;
            if (!_v0.$) {
                var time = _v0.a;
                var timeFormatter = _v0.b;
                return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' on ' + A2(timeFormatter, 5, time))
                ]));
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$HintBilling$InvoicesTable$viewInvoice = function(invoice) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Components$HintBilling$InvoicesTable$viewInvoiceUrl, invoice.aef, $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, invoice.M4)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt(invoice.Gx))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Api$Provider$PracticeInvoice$Status$toBadge(invoice.ahy),
                $author$project$Components$HintBilling$InvoicesTable$viewPaidInfo(invoice)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt(invoice.aam))
            ]))
        ]));
    };
    var $author$project$Components$HintBilling$InvoicesTable$viewInvoicesTableHeaders = _List_fromArray([
        A2($author$project$Ui$Table$header, _List_fromArray([
            $author$project$Ui$Table$cellSpan(3)
        ]), _List_fromArray([
            $elm$html$Html$text('Date')
        ])),
        A2($author$project$Ui$Table$header, _List_fromArray([
            $author$project$Ui$Table$cellSpan(2)
        ]), _List_fromArray([
            $elm$html$Html$text('Invoice Number')
        ])),
        A2($author$project$Ui$Table$header, _List_fromArray([
            $author$project$Ui$Table$cellSpan(4)
        ]), _List_fromArray([
            $elm$html$Html$text('Invoice Status')
        ])),
        A2($author$project$Ui$Table$header, _List_fromArray([
            $author$project$Ui$Table$cellSpan(3)
        ]), _List_fromArray([
            $elm$html$Html$text('Invoice Total')
        ]))
    ]);
    var $author$project$Components$HintBilling$InvoicesTable$view = F2(function(_v0, pagination) {
        var record = _v0;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$loading(record.Tk)
            ]), $author$project$Components$HintBilling$InvoicesTable$viewInvoicesTableHeaders, $elm$core$List$isEmpty(record.q5) ? _List_fromArray([
                A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You have no invoices yet!')
                    ]))
                ]))
            ]) : A2($elm$core$List$map, $author$project$Components$HintBilling$InvoicesTable$viewInvoice, record.q5), _List_Nil),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A2($author$project$Api$Pagination$view, _List_Nil, pagination)
            ]))
        ]));
    });
    var $author$project$Ui$Element$Gap = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Element$gap2 = $author$project$Ui$Element$Gap(2);
    var $author$project$Ui$Tooltip$Bottom = 1;
    var $author$project$Pages$Admin$Billing$CreateInvoiceClicked = {
        $: 16
    };
    var $author$project$Ui$Icon$HintHeart = 33;
    var $author$project$Ui$Icon$hintHeart = $author$project$Ui$Icon$viewIcon(33);
    var $author$project$Ui$HinterOnly$icon = $author$project$Ui$Icon$hintHeart;
    var $author$project$Ui$HinterOnly$button = F3(function(accessibility, options, content) {
        return A3($author$project$Ui$Button$view, accessibility, A2($elm$core$List$cons, $author$project$Ui$Button$icon($author$project$Ui$HinterOnly$icon), options), content);
    });
    var $author$project$Ui$Tooltip$Placement = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Tooltip$placement = $author$project$Ui$Tooltip$Placement;
    var $author$project$Ui$Tooltip$placementToAttribute = function(plmnt) {
        switch(plmnt){
            case 0:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('tooltip--top')
                ]);
            case 3:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('tooltip--right')
                ]);
            case 2:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('tooltip--left')
                ]);
            default:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('tooltip--bottom')
                ]);
        }
    };
    var $author$project$Ui$Tooltip$optionsToAttributes = function(options) {
        return _Utils_ap($author$project$Ui$Tooltip$placementToAttribute(options.A6), _Utils_ap(function() {
            var _v0 = options.sm;
            if (!_v0.$) {
                var direction = _v0.a;
                return _List_fromArray([
                    $author$project$Ui$Pull$toClass(direction)
                ]);
            } else return _List_Nil;
        }(), function() {
            var _v1 = options.ni;
            if (!_v1.$) {
                var padding_ = _v1.a;
                return _List_fromArray([
                    $author$project$Ui$Padding$toClass(padding_)
                ]);
            } else return _List_Nil;
        }()));
    };
    var $author$project$Ui$Tooltip$Top = 0;
    var $author$project$Ui$StackingOrder$StackingOrder = $elm$core$Basics$identity;
    var $author$project$Ui$StackingOrder$z100 = 100;
    var $author$project$Ui$Tooltip$defaultOptions = {
        Ir: true,
        ni: $elm$core$Maybe$Nothing,
        A6: 0,
        sm: $elm$core$Maybe$Nothing,
        CH: $author$project$Ui$StackingOrder$z100,
        D1: false
    };
    var $author$project$Ui$Tooltip$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, acc) {
            switch(option.$){
                case 0:
                    var place = option.a;
                    return _Utils_update(acc, {
                        A6: place
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(acc, {
                        Ir: bool
                    });
                case 2:
                    var direction = option.a;
                    return _Utils_update(acc, {
                        sm: $elm$core$Maybe$Just(direction)
                    });
                case 3:
                    var order = option.a;
                    return _Utils_update(acc, {
                        CH: order
                    });
                case 4:
                    return _Utils_update(acc, {
                        D1: true
                    });
                default:
                    var padding_ = option.a;
                    return _Utils_update(acc, {
                        ni: $elm$core$Maybe$Just(padding_)
                    });
            }
        }), $author$project$Ui$Tooltip$defaultOptions, options);
    };
    var $author$project$Ui$StackingOrder$toClass = function(_v0) {
        var _int = _v0;
        return $elm$html$Html$Attributes$class('z-' + $elm$core$String$fromInt(_int));
    };
    var $author$project$Ui$Tooltip$view = F3(function(options, tooltip, contents) {
        var optionsRecord = $author$project$Ui$Tooltip$optionsToRecord(options);
        return optionsRecord.Ir ? A2($elm$html$Html$span, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('tooltip-wrapper'), function() {
            var _v0 = optionsRecord.ni;
            if (!_v0.$) {
                var padding_ = _v0.a;
                return _List_fromArray([
                    $author$project$Ui$Padding$toClass(padding_)
                ]);
            } else return _List_Nil;
        }()), _Utils_ap(contents, _List_fromArray([
            function(attrs) {
                return A2($elm$html$Html$span, attrs, _List_Nil);
            }(function(attrs) {
                return _Utils_ap(attrs, _List_fromArray([
                    A2($elm$html$Html$Attributes$attribute, 'data-text', tooltip),
                    $elm$html$Html$Attributes$class('tooltip'),
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('tooltip--wide', optionsRecord.D1)
                    ])),
                    $author$project$Ui$StackingOrder$toClass(optionsRecord.CH)
                ]));
            }($author$project$Ui$Tooltip$optionsToAttributes(optionsRecord)))
        ]))) : A2($elm$html$Html$span, function() {
            var _v1 = optionsRecord.ni;
            if (!_v1.$) {
                var padding_ = _v1.a;
                return _List_fromArray([
                    $author$project$Ui$Padding$toClass(padding_)
                ]);
            } else return _List_Nil;
        }(), contents);
    });
    var $author$project$Ui$Tooltip$Wide = {
        $: 4
    };
    var $author$project$Ui$Tooltip$wide = $author$project$Ui$Tooltip$Wide;
    var $author$project$Pages$Admin$Billing$viewCreateInvoiceButton = A3($author$project$Ui$Tooltip$view, _List_fromArray([
        $author$project$Ui$Tooltip$placement(1),
        $author$project$Ui$Tooltip$wide
    ]), 'Create the invoice now based on current active counts. The next tranche check will be on the following invoice', _List_fromArray([
        A3($author$project$Ui$HinterOnly$button, {
            abP: 'Bill next month'
        }, _List_fromArray([
            $author$project$Ui$Button$styled(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$CreateInvoiceClicked)
        ]), _List_fromArray([
            $elm$html$Html$text('Bill next month')
        ]))
    ]));
    var $author$project$Pages$Admin$Billing$OpenUpdateModal = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$viewUpdatePricingButton = function(practicePricing) {
        var label = $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? 'Reset Pricing with a HubSpot Deal' : 'Edit Subscription';
        return A3($author$project$Ui$HinterOnly$button, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$styled(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$OpenUpdateModal(practicePricing))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    };
    var $author$project$Pages$Admin$Billing$UpgradePracticeClicked = {
        $: 14
    };
    var $author$project$Pages$Admin$Billing$viewUpgradeButton = function(upgradeAvailable) {
        if (!upgradeAvailable.$) {
            var upgrade = upgradeAvailable.a;
            var label = 'Upgrade to ' + $author$project$Api$Provider$PracticePricing$Upgrade$tierName(upgrade);
            return A3($author$project$Ui$Button$view, {
                abP: label
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$UpgradePracticeClicked)
            ]), _List_fromArray([
                $elm$html$Html$text(label)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Admin$Billing$viewActionButtons = F3(function(dataPracticePricing, isHintAdmin, upgradeAvailable) {
        if (dataPracticePricing.$ === 3) {
            var practicePricing = dataPracticePricing.a;
            return isHintAdmin ? A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                $author$project$Pages$Admin$Billing$viewUpdatePricingButton(practicePricing),
                $author$project$Pages$Admin$Billing$viewCreateInvoiceButton,
                $author$project$Pages$Admin$Billing$viewUpgradeButton(upgradeAvailable)
            ])) : A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                $author$project$Pages$Admin$Billing$viewUpgradeButton(upgradeAvailable)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$PracticePricing$One$products = function(_v0) {
        var record = _v0;
        return record.Bt;
    };
    var $author$project$Pages$Admin$Billing$extractCreditsFromPracticePricing = function(practicePricing) {
        return A2($elm$core$List$filter, function(product) {
            return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) === 5;
        }, $author$project$Api$Provider$PracticePricing$One$products(practicePricing));
    };
    var $author$project$Pages$Admin$Billing$filterCreditsBeforeNextBillDate = F2(function(credits, maybeNextBillDate) {
        if (!maybeNextBillDate.$) {
            var nextBillDate = maybeNextBillDate.a;
            return A2($elm$core$List$filter, function(credit) {
                var _v1 = $author$project$Api$Provider$HintBillingComponent$Shared$endDate(credit);
                if (!_v1.$) {
                    var endDate = _v1.a;
                    return !!A2($justinmimbs$date$Date$compare, endDate, nextBillDate);
                } else return true;
            }, credits);
        } else return credits;
    });
    var $author$project$Api$Provider$PracticePricing$One$nextBillDate = function(_v0) {
        var record = _v0;
        return record.UY;
    };
    var $author$project$Pages$Admin$Billing$AddOneTimeChargeButtonClicked = {
        $: 10
    };
    var $author$project$Pages$Admin$Billing$viewAdditionalChargesHeader = function(isHintAdmin) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(8)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Additional Charges & Credits')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('These will be added to the next invoice when it is created.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(4)
                ]), _List_fromArray([
                    isHintAdmin ? A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: 'Add Charge or Credit'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$AddOneTimeChargeButtonClicked)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add Charge or Credit')
                        ]))
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]);
    };
    var $author$project$Formatters$Date$MonthAndDayAndYear = {
        $: 3
    };
    var $justinmimbs$date$Date$Months = 1;
    var $justinmimbs$date$Date$add = F3(function(unit, n, _v0) {
        var rd = _v0;
        switch(unit){
            case 0:
                return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
            case 1:
                var date = $justinmimbs$date$Date$toCalendarDate(rd);
                var wholeMonths = 12 * (date.ail - 1) + ($justinmimbs$date$Date$monthToNumber(date.ae6) - 1) + n;
                var m = $justinmimbs$date$Date$numberToMonth(A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
                var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
                return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + A2($elm$core$Basics$min, date.acP, A2($justinmimbs$date$Date$daysInMonth, y, m));
            case 2:
                return rd + 7 * n;
            default:
                return rd + n;
        }
    });
    var $author$project$Utils$Date$isLeapYear = function(y) {
        return !A2($elm$core$Basics$modBy, 4, y) && !!A2($elm$core$Basics$modBy, 100, y) || !A2($elm$core$Basics$modBy, 400, y);
    };
    var $author$project$Utils$Date$daysInMonth = F2(function(y, m) {
        switch(m){
            case 0:
                return 31;
            case 1:
                return $author$project$Utils$Date$isLeapYear(y) ? 29 : 28;
            case 2:
                return 31;
            case 3:
                return 30;
            case 4:
                return 31;
            case 5:
                return 30;
            case 6:
                return 31;
            case 7:
                return 31;
            case 8:
                return 30;
            case 9:
                return 31;
            case 10:
                return 30;
            default:
                return 31;
        }
    });
    var $author$project$Utils$Uom$dateDiff = F2(function(m1, m2) {
        var yDiff = $justinmimbs$date$Date$year(m2) - $justinmimbs$date$Date$year(m1);
        var mDiff = $justinmimbs$date$Date$monthNumber(m2) - $justinmimbs$date$Date$monthNumber(m1);
        var dDiff = $justinmimbs$date$Date$day(m2) - $justinmimbs$date$Date$day(m1);
        var _v0 = function() {
            if (dDiff < 0) {
                var daysInLastFullMonth = function(lastFullMonth) {
                    return A2($author$project$Utils$Date$daysInMonth, $justinmimbs$date$Date$year(lastFullMonth), $justinmimbs$date$Date$month(lastFullMonth));
                }(A3($justinmimbs$date$Date$add, 1, -1, A3($justinmimbs$date$Date$fromCalendarDate, $justinmimbs$date$Date$year(m2), $justinmimbs$date$Date$month(A3($justinmimbs$date$Date$add, 1, 1, m2)), 1)));
                return _Utils_Tuple2(_Utils_cmp(daysInLastFullMonth, $justinmimbs$date$Date$day(m1)) < 0 ? daysInLastFullMonth + dDiff + ($justinmimbs$date$Date$day(m1) - daysInLastFullMonth) : daysInLastFullMonth + dDiff, mDiff - 1);
            } else return _Utils_Tuple2(dDiff, mDiff);
        }();
        var dDiff_ = _v0.a;
        var mDiff_ = _v0.b;
        var _v1 = mDiff_ < 0 ? _Utils_Tuple2(12 + mDiff_, yDiff - 1) : _Utils_Tuple2(mDiff_, yDiff);
        var mDiff__ = _v1.a;
        var yDiff_ = _v1.b;
        return {
            acR: dDiff_,
            ae7: mDiff__,
            aim: yDiff_
        };
    });
    var $author$project$Pages$Admin$Billing$calculateMonthsRemaining = F2(function(currentDate, maybeEndDate) {
        if (!maybeEndDate.$) {
            var endDate = maybeEndDate.a;
            if (A2($justinmimbs$date$Date$compare, currentDate, endDate) === 2) return $elm$core$Maybe$Nothing;
            else {
                var billingStartDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
                var diff = A2($author$project$Utils$Uom$dateDiff, billingStartDate, endDate);
                var totalMonths = diff.aim * 12 + diff.ae7;
                return totalMonths > 0 ? $elm$core$Maybe$Just($elm$core$String$fromInt(totalMonths) + ' months left') : !totalMonths && diff.acR >= 0 ? $elm$core$Maybe$Just('This month') : $elm$core$Maybe$Nothing;
            }
        } else return $elm$core$Maybe$Just('forever');
    });
    var $cuducos$elm_format_number$FormatNumber$Locales$Max = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Formatters$Locales$partialPenniesLocale = _Utils_update($cuducos$elm_format_number$FormatNumber$Locales$usLocale, {
        Nm: $cuducos$elm_format_number$FormatNumber$Locales$Max(10)
    });
    var $author$project$Utils$Currency$formatFromFloat = function(cents) {
        var formattedWithTwoDecimals = A2($cuducos$elm_format_number$FormatNumber$format, $cuducos$elm_format_number$FormatNumber$Locales$usLocale, $elm$core$Basics$abs(cents) / 100);
        var formattedWithMaxDecimals = A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$partialPenniesLocale, $elm$core$Basics$abs(cents) / 100);
        return _Utils_cmp($elm$core$String$length(formattedWithMaxDecimals), $elm$core$String$length(formattedWithTwoDecimals)) > -1 ? formattedWithMaxDecimals : formattedWithTwoDecimals;
    };
    var $author$project$Utils$Currency$fromFloat = function(cents) {
        var formatted = $author$project$Utils$Currency$formatFromFloat(cents);
        return cents >= 0 ? '$' + formatted : '-$' + formatted;
    };
    var $author$project$Pages$Admin$Billing$viewCreditTableRow = F4(function(currentDate, maybeNextBillDate, _v0, credit) {
        var creditType = function() {
            var startDateToUse = A2($justinmimbs$date$Date$compare, $author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit), currentDate) === 2 ? $author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit) : currentDate;
            var startDate = $author$project$Api$Provider$HintBillingComponent$Shared$startDate(credit);
            var shouldShowStartsOn = function() {
                if (!maybeNextBillDate.$) {
                    var nextBillDate = maybeNextBillDate.a;
                    return A2($justinmimbs$date$Date$compare, startDate, nextBillDate) === 2;
                } else return false;
            }();
            var baseCreditType = function() {
                var _v2 = A2($author$project$Pages$Admin$Billing$calculateMonthsRemaining, startDateToUse, $author$project$Api$Provider$HintBillingComponent$Shared$endDate(credit));
                if (!_v2.$) {
                    var monthsText = _v2.a;
                    return 'Recurring (' + (monthsText + ')');
                } else return 'One-Time';
            }();
            return shouldShowStartsOn ? baseCreditType + (' - starts on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDayAndYear, startDate)) : baseCreditType;
        }();
        var creditQuantity = function() {
            var _v1 = $author$project$Api$Provider$HintBillingComponent$Shared$quantity(credit);
            if (!_v1.$) {
                var qty = _v1.a;
                return $elm$core$String$fromInt(qty);
            } else return '1';
        }();
        var creditPrice = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(credit);
        var creditName = $author$project$Api$Provider$HintBillingComponent$Shared$description(credit);
        var creditAmount = creditPrice * A2($elm$core$Maybe$withDefault, 1, $author$project$Api$Provider$HintBillingComponent$Shared$quantity(credit));
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text(creditName)
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(creditType)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(creditQuantity)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromFloat(creditPrice))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromFloat(creditAmount))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
        ]));
    });
    var $author$project$Pages$Admin$Billing$DeleteOneTimeChargeClicked = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeCharge$Shared$priceInCents = function(_v0) {
        var record = _v0;
        return record.Br;
    };
    var $author$project$Api$Provider$PracticeCharge$All$priceInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeCharge$Shared$priceInCents(shared);
    };
    var $author$project$Api$Provider$PracticeCharge$Shared$quantity = function(_v0) {
        var record = _v0;
        return record.Bu;
    };
    var $author$project$Api$Provider$PracticeCharge$All$quantity = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeCharge$Shared$quantity(shared);
    };
    var $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents = function(_v0) {
        var record = _v0;
        return record.$v;
    };
    var $author$project$Api$Provider$PracticeCharge$All$subtotalInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(shared);
    };
    var $author$project$Pages$Admin$Billing$viewTableRow = F2(function(isHintAdmin, practiceCharge) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$PracticeCharge$All$description(practiceCharge))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text('One-Time')
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$PracticeCharge$All$quantity(practiceCharge)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromFloat($author$project$Api$Provider$PracticeCharge$All$priceInCents(practiceCharge)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeCharge$All$subtotalInCents(practiceCharge)))
            ])),
            isHintAdmin ? A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$HinterOnly$button, {
                    abP: 'Delete one time charge'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$DeleteOneTimeChargeClicked(practiceCharge)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ]))
            ])) : A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
        ]));
    });
    var $author$project$Ui$Table$ZeroState = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Table$zeroState = $author$project$Ui$Table$ZeroState;
    var $author$project$Pages$Admin$Billing$viewAdditionalChargesTable = F5(function(uninvoicedCharges, credits, isHintAdmin, currentDate, maybeNextBillDate) {
        var creditRows = A2($elm$core$List$map, A3($author$project$Pages$Admin$Billing$viewCreditTableRow, currentDate, maybeNextBillDate, isHintAdmin), credits);
        var chargeRows = A2($elm$core$List$map, $author$project$Pages$Admin$Billing$viewTableRow(isHintAdmin), uninvoicedCharges);
        var allRows = _Utils_ap(chargeRows, creditRows);
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('You have no additional charges yet!')
                    ]))
                ]))
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Charge Name')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Type')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Qty')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Price')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Amount')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ]), allRows, _List_Nil),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt8
            ]), _List_Nil)
        ]);
    });
    var $author$project$Pages$Admin$Billing$viewAdditionalChargesSection = F4(function(uninvoicedCharges, isHintAdmin, practicePricingData, currentDate) {
        var headerView = $author$project$Pages$Admin$Billing$viewAdditionalChargesHeader(isHintAdmin);
        var _v0 = function() {
            if (practicePricingData.$ === 3) {
                var practicePricing = practicePricingData.a;
                return _Utils_Tuple2($author$project$Pages$Admin$Billing$extractCreditsFromPracticePricing(practicePricing), $author$project$Api$Provider$PracticePricing$One$nextBillDate(practicePricing));
            } else return _Utils_Tuple2(_List_Nil, $elm$core$Maybe$Nothing);
        }();
        var credits = _v0.a;
        var nextBillDate = _v0.b;
        var filteredCredits = A2($author$project$Pages$Admin$Billing$filterCreditsBeforeNextBillDate, credits, nextBillDate);
        return A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$cons, $author$project$Ui$HorizontalRule$view(_List_Nil), _Utils_ap(headerView, A5($author$project$Pages$Admin$Billing$viewAdditionalChargesTable, uninvoicedCharges, filteredCredits, isHintAdmin, currentDate, nextBillDate))));
    });
    var $author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents = function(_v0) {
        var record = _v0;
        return record.WR;
    };
    var $author$project$Ui$Typography$Display3 = {
        $: 25
    };
    var $author$project$Ui$Typography$display3 = $author$project$Ui$Typography$Display3;
    var $author$project$Ui$Typography$Info = 3;
    var $author$project$Ui$Typography$info = $author$project$Ui$Typography$Color(3);
    var $author$project$Components$HintBilling$NextBill$skeleton = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$spaceY4,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$block,
                $author$project$Ui$Skeleton$span(2)
            ])),
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$block,
                $author$project$Ui$Skeleton$span(3)
            ]))
        ])),
        A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$info
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$display3
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('$1000')
                ]))
            ]))
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$spanMd(2),
            $author$project$Ui$Skeleton$block
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$spanMd(2),
            $author$project$Ui$Skeleton$block
        ]))
    ]));
    var $author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents = function(_v0) {
        var record = _v0;
        return record.Ur;
    };
    var $author$project$Components$HintBilling$LegacyPricing$startedAddOns = F2(function(currentDate, charges) {
        return A2($elm$core$List$filter, function(charge) {
            return !!A2($justinmimbs$date$Date$compare, currentDate, $author$project$Api$Provider$HintBillingComponent$Shared$startDate(charge));
        }, A2($elm$core$List$filter, function(addon) {
            return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(addon) === 1;
        }, charges));
    });
    var $author$project$Api$Provider$HintBillingComponent$Shared$totalAmountInCents = function(_v0) {
        var record = _v0;
        return record.Br * A2($elm$core$Maybe$withDefault, 0, record.Bu);
    };
    var $author$project$Components$HintBilling$LegacyPricing$viewAddOn = function(product) {
        var amount = $author$project$Utils$Currency$fromFloat($author$project$Api$Provider$HintBillingComponent$Shared$totalAmountInCents(product));
        var description = amount + (' for ' + $author$project$Api$Provider$HintBillingComponent$Shared$description(product));
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('text-gray')
        ]), _List_fromArray([
            $author$project$Ui$Icon$check(_List_Nil),
            $elm$html$Html$text(' ' + description)
        ]));
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$collectionFeePercentage = function(_v0) {
        var record = _v0;
        return record.Lz;
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$pricedBy = function(_v0) {
        var record = _v0;
        return record.Bs;
    };
    var $author$project$Api$Provider$PricingTier$Shared$fixedAmountInCents = function(_v0) {
        var record = _v0;
        return record.adR;
    };
    var $author$project$Api$Provider$PricingTier$Shared$lowerBound = function(_v0) {
        var record = _v0;
        return record.Tx;
    };
    var $author$project$Api$Provider$PricingTier$Shared$upperBound = function(_v0) {
        var record = _v0;
        return record.aaS;
    };
    var $author$project$Api$Provider$PricingTier$Shared$rangeDescription = function(tier) {
        var range = function() {
            var _v1 = $author$project$Api$Provider$PricingTier$Shared$upperBound(tier);
            if (_v1.$ === 1) return $author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) - 1;
            else {
                var actualUpperbound = _v1.a;
                return actualUpperbound - ($author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) - 1);
            }
        }();
        var prettyfiedRange = range < 1000 || !!A2($elm$core$Basics$modBy, 100, range) ? A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, range) : $elm$core$String$concat(_List_fromArray([
            $elm$core$String$fromFloat(range / 1000.0),
            'k'
        ]));
        var prefix = function() {
            if ($author$project$Api$Provider$PricingTier$Shared$lowerBound(tier) === 1) return 'First ';
            else {
                var _v0 = $author$project$Api$Provider$PricingTier$Shared$upperBound(tier);
                if (!_v0.$) return 'Next ';
                else return 'After ';
            }
        }();
        return $elm$core$String$concat(_List_fromArray([
            prefix,
            prettyfiedRange,
            ' members'
        ]));
    };
    var $author$project$Components$HintBilling$LegacyPricing$viewPricingTierInformation = function(pricingTier) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('cascading-pricing-tier')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$PricingTier$Shared$rangeDescription(pricingTier))
                ])),
                A2($elm$html$Html$strong, _List_fromArray([
                    $elm$html$Html$Attributes$class('tile-item-big-number')
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PricingTier$Shared$fixedAmountInCents(pricingTier)))
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' pmpm')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$HintBilling$LegacyPricing$viewPricingTiersInformation = function(tiers) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flex')
            ]), A2($elm$core$List$map, $author$project$Components$HintBilling$LegacyPricing$viewPricingTierInformation, tiers)),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    };
    var $author$project$Components$HintBilling$LegacyPricing$viewPricingInformation = F2(function(feePlan, pmpmFee) {
        var _v0 = $author$project$Api$Provider$ApplicationFeePlan$One$pricedBy(feePlan);
        switch(_v0.$){
            case 0:
                return _List_fromArray([
                    A2($elm$html$Html$strong, _List_fromArray([
                        $elm$html$Html$Attributes$class('tile-item-big-number')
                    ]), _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromFloat($author$project$Api$Provider$ApplicationFeePlan$One$collectionFeePercentage(feePlan)))
                    ])),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('% of collections')
                    ]))
                ]);
            case 1:
                return _List_fromArray([
                    A2($elm$html$Html$strong, _List_fromArray([
                        $elm$html$Html$Attributes$class('tile-item-big-number')
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromFloat(pmpmFee))
                    ])),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' pmpm')
                    ]))
                ]);
            default:
                var tiers = _v0.a;
                return _List_fromArray([
                    $author$project$Components$HintBilling$LegacyPricing$viewPricingTiersInformation(tiers)
                ]);
        }
    });
    var $author$project$Components$HintBilling$LegacyPricing$viewLegacyPricingInformation = F4(function(feePlan, pmpmFee, currentDate, charges) {
        var addOns = A2($author$project$Components$HintBilling$LegacyPricing$startedAddOns, currentDate, charges);
        var hasAddons = !$elm$core$List$isEmpty(addOns);
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), A2($author$project$Components$HintBilling$LegacyPricing$viewPricingInformation, feePlan, pmpmFee))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), $elm$core$List$concat(_List_fromArray([
                    $author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents(feePlan) > 0 ? _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Plan Minimum: ')
                        ])),
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$ApplicationFeePlan$One$minimumPerMonthInCents(feePlan)))
                        ]))
                    ]) : _List_Nil,
                    hasAddons ? _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace,
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Add-Ons: ')
                        ]))
                    ]) : _List_Nil,
                    A2($elm$core$List$map, $author$project$Components$HintBilling$LegacyPricing$viewAddOn, A2($author$project$Components$HintBilling$LegacyPricing$startedAddOns, currentDate, addOns))
                ])))
            ]))
        ]);
    });
    var $author$project$Ui$Popover$Heading = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Popover$heading = $author$project$Ui$Popover$Heading;
    var $author$project$Api$Provider$ApplicationFeePlan$One$achTransactionFeeCapInCents = function(_v0) {
        var record = _v0;
        return record.Io;
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$amexSurcharge = function(_v0) {
        var record = _v0;
        return record.aai - record.HR;
    };
    var $author$project$Ui$HorizontalRule$Style = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$HorizontalRule$Thin = 1;
    var $author$project$Ui$HorizontalRule$thin = $author$project$Ui$HorizontalRule$Style(1);
    var $author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeeInCents = function(_v0) {
        var record = _v0;
        return record.aag;
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeePercentage = function(_v0) {
        var record = _v0;
        return record.aah;
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeeInCents = function(_v0) {
        var record = _v0;
        return record.aaj;
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeePercentage = function(_v0) {
        var record = _v0;
        return record.HR;
    };
    var $author$project$Components$HintBilling$LegacyPricing$viewFeeBreakdown = function(feePlan) {
        var totalCardFeePercentage = $elm$core$String$fromFloat($author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeePercentage(feePlan)) + '%';
        var totalCardFeeInCents = $elm$core$String$fromInt($author$project$Api$Provider$ApplicationFeePlan$One$totalCardFeeInCents(feePlan)) + 'c';
        var totalAchFeePercentage = $elm$core$String$fromFloat($author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeePercentage(feePlan)) + '%';
        var totalAchFeeInCents = $elm$core$String$fromInt($author$project$Api$Provider$ApplicationFeePlan$One$totalAchFeeInCents(feePlan)) + 'c';
        var creditCardTransactionDisplay = 'Credit Card: ' + (totalCardFeePercentage + (' + ' + totalCardFeeInCents));
        var amexSurchargeDisplay = '+ ' + ($elm$core$String$fromFloat($author$project$Api$Provider$ApplicationFeePlan$One$amexSurcharge(feePlan)) + '% surcharge for Amex');
        var achCapDisplay = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(achCap) {
            return ' (' + ($author$project$Utils$Currency$fromInt(achCap) + ' Cap)');
        }, $author$project$Api$Provider$ApplicationFeePlan$One$achTransactionFeeCapInCents(feePlan)));
        var achTransactionDisplay = 'ACH: ' + (totalAchFeePercentage + (' + ' + (totalAchFeeInCents + achCapDisplay)));
        return _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Hint pricing does not include processing fees for accepting card or ACH payments.')
                ])),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(creditCardTransactionDisplay)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$italic
                    ]), _List_fromArray([
                        $elm$html$Html$text(amexSurchargeDisplay)
                    ]))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(achTransactionDisplay)
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Components$HintBilling$LegacyPricing$viewPopover = function(feePlan) {
        return A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
            $author$project$Utils$Html$noBreakSpace,
            $author$project$Ui$Icon$help(_List_Nil)
        ]), _List_fromArray([
            A2($author$project$Ui$Popover$heading, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Transaction Fees')
            ])),
            A2($author$project$Ui$Popover$body, _List_Nil, $author$project$Components$HintBilling$LegacyPricing$viewFeeBreakdown(feePlan))
        ]));
    };
    var $author$project$Components$HintBilling$LegacyPricing$view = F4(function(currentDate, feePlan, pmpmFee, charges) {
        var popoverView = $author$project$Components$HintBilling$LegacyPricing$viewPopover(feePlan);
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Hint Pricing'),
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('small')
                    ]), _List_fromArray([
                        popoverView
                    ]))
                ]))
            ]))
        ])), A4($author$project$Components$HintBilling$LegacyPricing$viewLegacyPricingInformation, feePlan, pmpmFee, currentDate, charges)));
    });
    var $author$project$Pages$Admin$Billing$viewBillingSection = F3(function(applicationFeePlan, practicePricingData, currentDate) {
        return A2($author$project$Ui$Grid$row, _List_Nil, function() {
            var _v0 = _Utils_Tuple2(applicationFeePlan, practicePricingData);
            if (_v0.a.$ === 3 && _v0.b.$ === 3) {
                var _v1 = _v0.a;
                var feePlan = _v1.a;
                var _v2 = _v0.b;
                var practicePricing = _v2.a;
                return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(10)
                    ]), _List_fromArray([
                        A4($author$project$Components$HintBilling$LegacyPricing$view, currentDate, feePlan, $author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(practicePricing), $author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing))
                    ]))
                ]) : _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        $author$project$Utils$Html$empty
                    ]))
                ]);
            } else return _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Components$HintBilling$NextBill$skeleton
                ]))
            ]);
        }());
    });
    var $author$project$Pages$Admin$Billing$viewCapitalPromoTile = F3(function(practice, capitalSession, capitalProductType) {
        if (capitalSession.$ === 3) return $author$project$Pages$Admin$Billing$shouldShowCapitalTile(practice) && !_Utils_eq(capitalProductType, $elm$core$Maybe$Just('none')) ? A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$id('stripe-capital-promo-tile'),
            $elm$html$Html$Attributes$class('mb-4 rounded-lg shadow-card surface-base border-l-4 border-primary p-4')
        ]), _List_Nil) : $elm$html$Html$text('');
        else return $elm$html$Html$text('');
    });
    var $author$project$Ui$Icon$Alert = 5;
    var $author$project$Ui$Margin$NoMargin = 25;
    var $author$project$Ui$Alert$Icon = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Alert$icon = $author$project$Ui$Alert$Icon;
    var $author$project$Api$Provider$PracticePricing$One$infoMessageBody = function(_v0) {
        var record = _v0;
        return record.Re;
    };
    var $author$project$Api$Provider$PracticePricing$One$infoMessageTitle = function(_v0) {
        var record = _v0;
        return record.Rf;
    };
    var $elm$html$Html$h5 = _VirtualDom_node('h5');
    var $author$project$Ui$Typography$title = F2(function(options, content) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$h5, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('text-title-md text-main'), $author$project$Ui$Typography$optionsToAttributes(options)), content));
    });
    var $author$project$Pages$Admin$Billing$viewInfoMessage = function(practicePricingData) {
        if (practicePricingData.$ === 3) {
            var practicePricing = practicePricingData.a;
            var maybeTitle = $author$project$Api$Provider$PracticePricing$One$infoMessageTitle(practicePricing);
            if (!maybeTitle.$) {
                var infoMessageTitle = maybeTitle.a;
                var infoMessageBody = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$PracticePricing$One$infoMessageBody(practicePricing));
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Alert$info, _List_fromArray([
                        $author$project$Ui$Alert$margin(25),
                        $author$project$Ui$Alert$icon(5),
                        $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(infoMessageTitle)
                        ])),
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(infoMessageBody)
                        ]))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil)
                ]));
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Source$BankAccount = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$BankAccount$ProviderAll = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$BankAccount$One$defaults = function(_v0) {
        var record = _v0.b;
        return record.NF;
    };
    var $author$project$Api$Provider$BankAccount$All$defaults = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$defaults(one);
    };
    var $author$project$Api$Provider$Source$Defaults$hintCustomer = function(_v0) {
        var record = _v0;
        return record.QN;
    };
    var $author$project$Api$Source$defaultPracticeBankAccount = function(bankAccounts) {
        return A2($elm$core$Maybe$map, $author$project$Api$Source$BankAccount, A2($elm$core$Maybe$map, $author$project$Api$BankAccount$ProviderAll, A2($elm_community$list_extra$List$Extra$find, function(bankAccount) {
            return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$hintCustomer, $author$project$Api$Provider$BankAccount$All$defaults(bankAccount)));
        }, bankAccounts)));
    };
    var $author$project$Api$Source$Card = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Card$ProviderAll = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Card$One$defaults = function(_v0) {
        var record = _v0.b;
        return record.NF;
    };
    var $author$project$Api$Provider$Card$All$defaults = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$defaults(one);
    };
    var $author$project$Api$Source$defaultPracticeCard = function(cards) {
        return A2($elm$core$Maybe$map, $author$project$Api$Source$Card, A2($elm$core$Maybe$map, $author$project$Api$Card$ProviderAll, A2($elm_community$list_extra$List$Extra$find, function(card) {
            return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$hintCustomer, $author$project$Api$Provider$Card$All$defaults(card)));
        }, cards)));
    };
    var $author$project$Api$Source$defaultPracticeSource = F2(function(cards, bankAccounts) {
        return $elm$core$List$head(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $author$project$Api$Source$defaultPracticeCard(cards),
            $author$project$Api$Source$defaultPracticeBankAccount(bankAccounts)
        ])));
    });
    var $author$project$Components$PaymentSourceDisplayer$LimitedView = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$limitedView = $author$project$Components$PaymentSourceDisplayer$LimitedView;
    var $author$project$Components$PaymentSourceDisplayer$NoPaymentMethodStatus = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus = $author$project$Components$PaymentSourceDisplayer$NoPaymentMethodStatus;
    var $author$project$Components$PaymentSourceDisplayer$Source = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$source = $author$project$Components$PaymentSourceDisplayer$Source;
    var $author$project$Api$Provider$BankAccount$Shared$assignedMemberships = function(_v0) {
        var record = _v0;
        return record.JF;
    };
    var $author$project$Api$Provider$BankAccount$One$assignedMemberships = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$assignedMemberships(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$assignedMemberships = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$assignedMemberships(one);
    };
    var $author$project$Api$BankAccount$assignedMemberships = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$assignedMemberships(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$assignedMemberships(bankAccount_);
            case 2:
                return _List_Nil;
            default:
                return _List_Nil;
        }
    };
    var $author$project$Api$Provider$Card$Shared$assignedMemberships = function(_v0) {
        var record = _v0;
        return record.JF;
    };
    var $author$project$Api$Provider$Card$One$assignedMemberships = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$assignedMemberships(shared);
    };
    var $author$project$Api$Provider$Card$All$assignedMemberships = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$assignedMemberships(one);
    };
    var $author$project$Api$Card$assignedMemberships = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$assignedMemberships(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$assignedMemberships(card_);
            case 2:
                return _List_Nil;
            default:
                return _List_Nil;
        }
    };
    var $author$project$Api$Source$assignedMemberships = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$assignedMemberships(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$assignedMemberships(bankAccount);
            default:
                return _List_Nil;
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Employer$BankAccount$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Employer$BankAccount$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$createdAt(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$createdAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$createdAt(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$BankAccount$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$createdAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$createdAt(one);
    };
    var $author$project$Api$BankAccount$createdAt = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$createdAt(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$createdAt(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$createdAt(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$createdAt(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Employer$Card$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$createdAt(shared);
    };
    var $author$project$Api$Employer$Card$All$createdAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$createdAt(one);
    };
    var $author$project$Api$Provider$Card$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Card$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$Card$All$createdAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$createdAt(one);
    };
    var $author$project$Api$Card$createdAt = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$createdAt(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$createdAt(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$createdAt(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$createdAt(card_);
        }
    };
    var $author$project$Api$Common$Source$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Source$createdAt = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $elm$core$Maybe$Just($author$project$Api$Card$createdAt(card));
            case 1:
                var bankAccount = source.a;
                return $elm$core$Maybe$Just($author$project$Api$BankAccount$createdAt(bankAccount));
            default:
                var source_ = source.a;
                return $author$project$Api$Common$Source$Shared$createdAt(source_);
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdByName = function(_v0) {
        var record = _v0;
        return record.Mz;
    };
    var $author$project$Api$Provider$BankAccount$Shared$createdByName = function(_v0) {
        var record = _v0;
        return record.Mz;
    };
    var $author$project$Api$Provider$BankAccount$One$createdByName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$createdByName(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$createdByName = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$createdByName(one);
    };
    var $author$project$Api$BankAccount$createdByName = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$createdByName(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$createdByName(bankAccount_);
            case 2:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$Card$Shared$createdByName = function(_v0) {
        var record = _v0;
        return record.Mz;
    };
    var $author$project$Api$Provider$Card$One$createdByName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$createdByName(shared);
    };
    var $author$project$Api$Provider$Card$All$createdByName = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$createdByName(one);
    };
    var $author$project$Api$Card$createdByName = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$createdByName(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$createdByName(card_);
            case 2:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Source$createdByName = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$createdByName(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$createdByName(bankAccount);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$createdVia = function(_v0) {
        var record = _v0;
        return record.MA;
    };
    var $author$project$Api$Provider$BankAccount$Shared$createdVia = function(_v0) {
        var record = _v0;
        return record.MA;
    };
    var $author$project$Api$Provider$BankAccount$One$createdVia = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$createdVia(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$createdVia = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$createdVia(one);
    };
    var $author$project$Api$BankAccount$createdVia = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$createdVia(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$createdVia(bankAccount_);
            case 2:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$Card$Shared$createdVia = function(_v0) {
        var record = _v0;
        return record.MA;
    };
    var $author$project$Api$Provider$Card$One$createdVia = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$createdVia(shared);
    };
    var $author$project$Api$Provider$Card$All$createdVia = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$createdVia(one);
    };
    var $author$project$Api$Card$createdVia = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$createdVia(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$createdVia(card_);
            case 2:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Source$createdVia = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$createdVia(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$createdVia(bankAccount);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Employer$BankAccount$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Employer$BankAccount$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$errorMessage(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$errorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$errorMessage(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$BankAccount$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$errorMessage(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$errorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$errorMessage(one);
    };
    var $author$project$Api$BankAccount$errorMessage = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$errorMessage(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$errorMessage(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$errorMessage(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$errorMessage(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Employer$Card$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$errorMessage(shared);
    };
    var $author$project$Api$Employer$Card$All$errorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$errorMessage(one);
    };
    var $author$project$Api$Provider$Card$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$Card$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$errorMessage(shared);
    };
    var $author$project$Api$Provider$Card$All$errorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$errorMessage(one);
    };
    var $author$project$Api$Card$errorMessage = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$errorMessage(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$errorMessage(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$errorMessage(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$errorMessage(card_);
        }
    };
    var $author$project$Api$Source$errorMessage = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$errorMessage(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$errorMessage(bankAccount);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$expMonth = function(_v0) {
        var record = _v0;
        return record.adz;
    };
    var $author$project$Api$Employer$Card$Shared$expMonth = function(_v0) {
        var record = _v0;
        return record.adz;
    };
    var $author$project$Api$Employer$Card$One$expMonth = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$expMonth(shared);
    };
    var $author$project$Api$Employer$Card$All$expMonth = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$expMonth(one);
    };
    var $author$project$Api$Provider$Card$Shared$expMonth = function(_v0) {
        var record = _v0;
        return record.adz;
    };
    var $author$project$Api$Provider$Card$One$expMonth = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$expMonth(shared);
    };
    var $author$project$Api$Provider$Card$All$expMonth = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$expMonth(one);
    };
    var $author$project$Api$Card$expMonth = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$expMonth(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$expMonth(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$expMonth(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$expMonth(card_);
        }
    };
    var $author$project$Api$Source$expMonth = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$expMonth(card);
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$expYear = function(_v0) {
        var record = _v0;
        return record.adA;
    };
    var $author$project$Api$Employer$Card$Shared$expYear = function(_v0) {
        var record = _v0;
        return record.adA;
    };
    var $author$project$Api$Employer$Card$One$expYear = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$expYear(shared);
    };
    var $author$project$Api$Employer$Card$All$expYear = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$expYear(one);
    };
    var $author$project$Api$Provider$Card$Shared$expYear = function(_v0) {
        var record = _v0;
        return record.adA;
    };
    var $author$project$Api$Provider$Card$One$expYear = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$expYear(shared);
    };
    var $author$project$Api$Provider$Card$All$expYear = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$expYear(one);
    };
    var $author$project$Api$Card$expYear = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$expYear(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$expYear(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$expYear(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$expYear(card_);
        }
    };
    var $author$project$Api$Source$expYear = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$expYear(card);
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$funding = function(_v0) {
        var record = _v0;
        return record.P1;
    };
    var $author$project$Api$Provider$Card$Shared$funding = function(_v0) {
        var record = _v0;
        return record.P1;
    };
    var $author$project$Api$Provider$Card$One$funding = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$funding(shared);
    };
    var $author$project$Api$Provider$Card$All$funding = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$funding(one);
    };
    var $author$project$Api$Card$funding = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$funding(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$funding(card_);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$Source$Shared$funding = function(_v0) {
        var record = _v0;
        return record.P1;
    };
    var $author$project$Api$Source$funding = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$funding(card);
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                var source_ = source.a;
                return $author$project$Api$Common$Source$Shared$funding(source_);
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Employer$BankAccount$Shared$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Employer$BankAccount$One$label = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$label(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$label = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$label(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Provider$BankAccount$One$label = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$label(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$label = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$label(one);
    };
    var $author$project$Api$BankAccount$label = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$label(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$label(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$label(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$label(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Employer$Card$One$label = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$label(shared);
    };
    var $author$project$Api$Employer$Card$All$label = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$label(one);
    };
    var $author$project$Api$Provider$Card$Shared$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Provider$Card$One$label = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$label(shared);
    };
    var $author$project$Api$Provider$Card$All$label = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$label(one);
    };
    var $author$project$Api$Card$label = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$label(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$label(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$label(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$label(card_);
        }
    };
    var $author$project$Api$Common$Source$Shared$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Source$label = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$label(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$label(bankAccount);
            default:
                var source_ = source.a;
                return $author$project$Api$Common$Source$Shared$label(source_);
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour = function(_v0) {
        var record = _v0;
        return record.ST;
    };
    var $author$project$Api$Employer$BankAccount$Shared$lastFour = function(_v0) {
        var record = _v0;
        return record.ST;
    };
    var $author$project$Api$Employer$BankAccount$One$lastFour = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$lastFour(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$lastFour = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$lastFour(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$lastFour = function(_v0) {
        var record = _v0;
        return record.ST;
    };
    var $author$project$Api$Provider$BankAccount$One$lastFour = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$lastFour(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$lastFour = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$lastFour(one);
    };
    var $author$project$Api$BankAccount$lastFour = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$lastFour(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$lastFour(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$lastFour(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$lastFour(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$lastFour = function(_v0) {
        var record = _v0;
        return record.ST;
    };
    var $author$project$Api$Employer$Card$One$lastFour = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$lastFour(shared);
    };
    var $author$project$Api$Employer$Card$All$lastFour = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$lastFour(one);
    };
    var $author$project$Api$Provider$Card$Shared$lastFour = function(_v0) {
        var record = _v0;
        return record.ST;
    };
    var $author$project$Api$Provider$Card$One$lastFour = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$lastFour(shared);
    };
    var $author$project$Api$Provider$Card$All$lastFour = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$lastFour(one);
    };
    var $author$project$Api$Card$lastFour = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$lastFour(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$lastFour(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$lastFour(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$lastFour(card_);
        }
    };
    var $author$project$Api$Common$Source$Shared$lastFour = function(_v0) {
        var record = _v0;
        return record.ST;
    };
    var $author$project$Api$Source$lastFour = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$lastFour(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$lastFour(bankAccount);
            default:
                var source_ = source.a;
                return $author$project$Api$Common$Source$Shared$lastFour(source_);
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastPaymentErrorMessage = function(_v0) {
        var record = _v0;
        return record.SV;
    };
    var $author$project$Api$Employer$BankAccount$Shared$lastPaymentErrorMessage = function(_v0) {
        var record = _v0;
        return record.SV;
    };
    var $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$lastPaymentErrorMessage(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$lastPaymentErrorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$lastPaymentErrorMessage = function(_v0) {
        var record = _v0;
        return record.SV;
    };
    var $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$lastPaymentErrorMessage(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$lastPaymentErrorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage(one);
    };
    var $author$project$Api$BankAccount$lastPaymentErrorMessage = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$lastPaymentErrorMessage(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$lastPaymentErrorMessage(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$lastPaymentErrorMessage(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$lastPaymentErrorMessage(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$lastPaymentErrorMessage = function(_v0) {
        var record = _v0;
        return record.SV;
    };
    var $author$project$Api$Employer$Card$One$lastPaymentErrorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$lastPaymentErrorMessage(shared);
    };
    var $author$project$Api$Employer$Card$All$lastPaymentErrorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$lastPaymentErrorMessage(one);
    };
    var $author$project$Api$Provider$Card$Shared$lastPaymentErrorMessage = function(_v0) {
        var record = _v0;
        return record.SV;
    };
    var $author$project$Api$Provider$Card$One$lastPaymentErrorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$lastPaymentErrorMessage(shared);
    };
    var $author$project$Api$Provider$Card$All$lastPaymentErrorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$lastPaymentErrorMessage(one);
    };
    var $author$project$Api$Card$lastPaymentErrorMessage = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$lastPaymentErrorMessage(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$lastPaymentErrorMessage(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$lastPaymentErrorMessage(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$lastPaymentErrorMessage(card_);
        }
    };
    var $author$project$Api$Source$lastPaymentErrorMessage = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$lastPaymentErrorMessage(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$lastPaymentErrorMessage(bankAccount);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$BankAccount$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$BankAccount$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$name(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$name = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$name(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$BankAccount$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$name(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$name = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$name(one);
    };
    var $author$project$Api$BankAccount$name = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$name(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$name(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$name(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$name(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$Card$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$name(shared);
    };
    var $author$project$Api$Employer$Card$All$name = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$name(one);
    };
    var $author$project$Api$Provider$Card$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Card$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$name(shared);
    };
    var $author$project$Api$Provider$Card$All$name = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$name(one);
    };
    var $author$project$Api$Card$name = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$name(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$name(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$name(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$name(card_);
        }
    };
    var $author$project$Api$Common$Source$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Source$name = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$name(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$name(bankAccount);
            default:
                var source_ = source.a;
                return $author$project$Api$Common$Source$Shared$name(source_);
        }
    };
    var $author$project$Components$PaymentSourceDisplayer$defaultOptions = {
        ace: $elm$core$Maybe$Nothing,
        yF: false,
        zM: false,
        V8: $elm$core$Maybe$Nothing,
        Wo: $elm$core$Maybe$Nothing,
        Cv: false,
        or: false,
        Hw: $elm$core$Maybe$Nothing,
        CN: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$PaymentSourceDisplayer$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var source_ = option.a;
                    return _Utils_update(record, {
                        Hw: source_
                    });
                case 1:
                    var cardReader_ = option.a;
                    return _Utils_update(record, {
                        ace: cardReader_
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        yF: bool
                    });
                case 3:
                    var bool = option.a;
                    return _Utils_update(record, {
                        zM: bool
                    });
                case 4:
                    var bool = option.a;
                    return _Utils_update(record, {
                        or: bool
                    });
                case 5:
                    var processor = option.a;
                    return _Utils_update(record, {
                        Wo: $elm$core$Maybe$Just(processor)
                    });
                case 6:
                    var stripePaymentMethodMigration_ = option.a;
                    return _Utils_update(record, {
                        CN: $elm$core$Maybe$Just(stripePaymentMethodMigration_)
                    });
                case 7:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Cv: bool
                    });
                default:
                    var patientId_ = option.a;
                    return _Utils_update(record, {
                        V8: patientId_
                    });
            }
        }), $author$project$Components$PaymentSourceDisplayer$defaultOptions, options);
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Employer$BankAccount$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Employer$BankAccount$One$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$paymentProcessor(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$paymentProcessor = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$paymentProcessor(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$BankAccount$One$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$paymentProcessor(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$paymentProcessor = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$paymentProcessor(one);
    };
    var $author$project$Api$BankAccount$paymentProcessor = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$paymentProcessor(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$paymentProcessor(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$paymentProcessor(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$paymentProcessor(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Employer$Card$One$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$paymentProcessor(shared);
    };
    var $author$project$Api$Employer$Card$All$paymentProcessor = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$paymentProcessor(one);
    };
    var $author$project$Api$Provider$Card$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$Card$One$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$paymentProcessor(shared);
    };
    var $author$project$Api$Provider$Card$All$paymentProcessor = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$paymentProcessor(one);
    };
    var $author$project$Api$Card$paymentProcessor = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$paymentProcessor(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$paymentProcessor(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$paymentProcessor(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$paymentProcessor(card_);
        }
    };
    var $author$project$Api$Common$Source$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Source$paymentProcessor = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$paymentProcessor(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$paymentProcessor(bankAccount);
            default:
                var source_ = source.a;
                return $author$project$Api$Common$Source$Shared$paymentProcessor(source_);
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Employer$BankAccount$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Employer$BankAccount$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$status(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$status = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$status(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$BankAccount$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$status(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$status = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$status(one);
    };
    var $author$project$Api$BankAccount$status = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$status(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$status(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$status(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$status(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Employer$Card$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$status(shared);
    };
    var $author$project$Api$Employer$Card$All$status = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$status(one);
    };
    var $author$project$Api$Provider$Card$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Card$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$status(shared);
    };
    var $author$project$Api$Provider$Card$All$status = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$status(one);
    };
    var $author$project$Api$Card$status = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$status(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$status(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$status(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$status(card_);
        }
    };
    var $author$project$Api$Common$Source$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Source$status = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $elm$core$Maybe$Just($author$project$Api$Card$status(card));
            case 1:
                var bankAccount = source.a;
                return $elm$core$Maybe$Just($author$project$Api$BankAccount$status(bankAccount));
            default:
                var source_ = source.a;
                return $author$project$Api$Common$Source$Shared$status(source_);
        }
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Employer$BankAccount$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Employer$BankAccount$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$type_(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$type_ = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$type_(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$BankAccount$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$type_(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$type_ = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$type_(one);
    };
    var $author$project$Api$BankAccount$type_ = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$type_(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$type_(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$type_(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$type_(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Employer$Card$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$type_(shared);
    };
    var $author$project$Api$Employer$Card$All$type_ = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$type_(one);
    };
    var $author$project$Api$Provider$Card$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$Card$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$type_(shared);
    };
    var $author$project$Api$Provider$Card$All$type_ = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$type_(one);
    };
    var $author$project$Api$Card$type_ = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$type_(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$type_(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$type_(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$type_(card_);
        }
    };
    var $author$project$Api$Common$Source$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Source$type_ = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$type_(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$type_(bankAccount);
            default:
                var source_ = source.a;
                return $author$project$Api$Common$Source$Shared$type_(source_);
        }
    };
    var $author$project$Api$Provider$CardReader$Shared$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$CardReader$Shared$label = function(cardReader) {
        var providerShared = cardReader;
        return $author$project$Api$Provider$CardReader$Shared$label(providerShared);
    };
    var $author$project$Api$Provider$CardReader$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$CardReader$Shared$paymentProcessor = function(cardReader) {
        var providerShared = cardReader;
        return $author$project$Api$Provider$CardReader$Shared$paymentProcessor(providerShared);
    };
    var $author$project$Ui$Badge$Spaced = {
        $: 5
    };
    var $author$project$Ui$Badge$spacedRight = $author$project$Ui$Badge$Spaced;
    var $author$project$Utils$PaymentProcessor$toLabelText = F2(function(isHintAdmin, processor) {
        var _v0 = _Utils_Tuple2(isHintAdmin, processor);
        switch(_v0.b){
            case 'stripe':
                return 'Stripe';
            case 'rainforest':
                if (_v0.a) return 'rainforest';
                else return 'Built-in Processor';
            default:
                return processor;
        }
    });
    var $author$project$Utils$PaymentProcessor$toBadge = F4(function(showProcessor, isHintAdmin, element, getPaymentProcessor) {
        var badge = F2(function(style, label) {
            return $elm$core$Maybe$Just(A2($author$project$Ui$Badge$fromString, _List_fromArray([
                $author$project$Ui$Badge$spacedRight,
                style
            ]), label));
        });
        var _v0 = _Utils_Tuple2(showProcessor, getPaymentProcessor(element));
        _v0$2: while(true){
            if (_v0.a && !_v0.b.$) switch(_v0.b.a){
                case 'stripe':
                    return A2(badge, $author$project$Ui$Badge$primary, A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'stripe'));
                case 'rainforest':
                    return A2(badge, $author$project$Ui$Badge$success, A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'rainforest'));
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$PaymentSourceDisplayer$viewCardReader = F2(function(optionsRecord, cardReader_) {
        var label = $author$project$Api$CardReader$Shared$label(cardReader_);
        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, optionsRecord.or, optionsRecord.or, cardReader_, A2($elm$core$Basics$composeR, $author$project$Api$CardReader$Shared$paymentProcessor, $elm$core$Maybe$Just))),
            A2($elm$html$Html$strong, _List_fromArray([
                $elm$html$Html$Attributes$class('inline')
            ]), _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Card Reader: '),
                    $elm$html$Html$text($author$project$Formatters$String$titleize(label))
                ]))
            ]))
        ]));
    });
    var $author$project$Ui$OverflowWrap$BreakWord = 0;
    var $author$project$Ui$OverflowWrap$breakWord = 0;
    var $elm$html$Html$em = _VirtualDom_node('em');
    var $author$project$Ui$Typography$OverflowWrap = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Typography$overflowWrap = $author$project$Ui$Typography$OverflowWrap;
    var $author$project$Components$PaymentSourceDisplayer$actualPaymentProcessor = F2(function(givenPaymentProcessor_, source_) {
        var _v0 = _Utils_Tuple2(givenPaymentProcessor_, source_.Wo);
        if (!_v0.a.$) {
            var processor = _v0.a.a;
            return $elm$core$Maybe$Just(processor);
        } else if (!_v0.b.$) {
            var _v1 = _v0.a;
            var processor = _v0.b.a;
            return $elm$core$Maybe$Just(processor);
        } else {
            var _v2 = _v0.a;
            var _v3 = _v0.b;
            return $elm$core$Maybe$Nothing;
        }
    });
    var $author$project$Components$PaymentSourceDisplayer$paymentProcessorLabel = F3(function(showProcessor_, givenPaymentProcessor_, source_) {
        return A4($author$project$Utils$PaymentProcessor$toBadge, showProcessor_, showProcessor_, source_, $author$project$Components$PaymentSourceDisplayer$actualPaymentProcessor(givenPaymentProcessor_));
    });
    var $author$project$Components$PaymentSourceDisplayer$sourceName = function(source_) {
        var _v0 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, source_.zr);
        if (!_v0.$) {
            var label = _v0.a;
            return $elm$core$Maybe$Just(label);
        } else return source_.ah5;
    };
    var $elm$core$List$intersperse = F2(function(sep, xs) {
        if (!xs.b) return _List_Nil;
        else {
            var hd = xs.a;
            var tl = xs.b;
            var step = F2(function(x, rest) {
                return A2($elm$core$List$cons, sep, A2($elm$core$List$cons, x, rest));
            });
            var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
            return A2($elm$core$List$cons, hd, spersed);
        }
    });
    var $author$project$Ui$Typography$Primary = 1;
    var $author$project$Ui$Typography$primary = $author$project$Ui$Typography$Color(1);
    var $author$project$Components$PaymentSourceDisplayer$viewMembershipLink = F2(function(patientId_, membership) {
        if (!patientId_.$) {
            var pid = patientId_.a;
            return _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top({
                    y0: membership.aef,
                    V8: pid
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text(membership.WM)
                ]))
            ]);
        } else return _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$primary
            ]), _List_fromArray([
                $elm$html$Html$text(membership.WM)
            ]))
        ]);
    });
    var $author$project$Components$PaymentSourceDisplayer$viewAssignedMemberships = F3(function(showAssignedMemberships_, patientId_, memberships) {
        if (!showAssignedMemberships_) return $author$project$Utils$Html$empty;
        else {
            if (!memberships.b) return $author$project$Utils$Html$empty;
            else {
                var membershipLinks = $elm$core$List$concat(A2($elm$core$List$intersperse, _List_fromArray([
                    $elm$html$Html$text(', ')
                ]), A2($elm$core$List$map, $author$project$Components$PaymentSourceDisplayer$viewMembershipLink(patientId_), memberships)));
                return A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), A2($elm$core$List$cons, $elm$html$Html$text('Assigned to: '), membershipLinks));
            }
        }
    });
    var $author$project$Ui$Typography$Warning = 4;
    var $author$project$Ui$Typography$warning = $author$project$Ui$Typography$Color(4);
    var $author$project$Components$PaymentSourceDisplayer$viewAdditionalInfo = F4(function(timeFormatter, showAssignedMemberships_, patientId_, source_) {
        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
            function() {
                var _v0 = _Utils_Tuple2(source_.O4, source_.SV);
                if (!_v0.a.$) {
                    var errorMessage = _v0.a.a;
                    return A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]), _List_fromArray([
                        $elm$html$Html$text('Invalid: ' + errorMessage)
                    ]));
                } else {
                    if (!_v0.b.$) {
                        var _v1 = _v0.a;
                        var lastPaymentErrorMessage = _v0.b.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$warning
                        ]), _List_fromArray([
                            $elm$html$Html$text('Payment Failed: ' + lastPaymentErrorMessage)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }
            }(),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text('Added ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, timeFormatter(5), source_.Mx)))
                ])),
                function() {
                    var _v2 = _Utils_Tuple2(source_.adz, source_.adA);
                    if (!_v2.a.$ && !_v2.b.$) {
                        var expMonth = _v2.a.a;
                        var expYear = _v2.b.a;
                        var textColor = function() {
                            var _v3 = source_.ahy;
                            if (!_v3.$ && _v3.a === 'expiring') return $author$project$Ui$Typography$danger;
                            else return $author$project$Ui$Typography$muted;
                        }();
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            textColor
                        ]), _List_fromArray([
                            $elm$html$Html$text(', expires ' + ($elm$core$String$fromInt(expMonth) + ('/' + $elm$core$String$fromInt(expYear))))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v4 = source_.tK;
                    if (!_v4.$) {
                        var zip = _v4.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$small
                        ]), _List_fromArray([
                            $elm$html$Html$text(', ZIP code ' + zip)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            function() {
                var _v5 = source_.MA;
                if (!_v5.$) {
                    var createdVia = _v5.a;
                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(createdVia)
                        ])),
                        function() {
                            var _v6 = source_.Mz;
                            if (!_v6.$) {
                                var createdByName = _v6.a;
                                return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(' by ' + createdByName)
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A3($author$project$Components$PaymentSourceDisplayer$viewAssignedMemberships, showAssignedMemberships_, patientId_, source_.JF)
        ]));
    });
    var $author$project$Components$PaymentSourceDisplayer$viewSource = F3(function(timeFormatter, optionsRecord, source_) {
        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A3($author$project$Components$PaymentSourceDisplayer$paymentProcessorLabel, optionsRecord.or, optionsRecord.Wo, source_)),
            function() {
                var _v0 = $author$project$Components$PaymentSourceDisplayer$sourceName(source_);
                if (!_v0.$) {
                    var name = _v0.a;
                    return A2($elm$html$Html$strong, _List_fromArray([
                        $elm$html$Html$Attributes$class('inline')
                    ]), _List_fromArray([
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Formatters$String$titleize(name))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Utils$Html$noBreakSpace,
            function() {
                var _v1 = source_.ST;
                if (!_v1.$) {
                    var lastFour = _v1.a;
                    return A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text('*' + lastFour)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Utils$Html$noBreakSpace,
            function() {
                var _v2 = source_.P1;
                if (!_v2.$) {
                    var funding = _v2.a;
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('(' + (funding + ')'))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Utils$Html$noBreakSpace,
            optionsRecord.zM ? $author$project$Utils$Html$empty : A2($author$project$Ui$Badge$fromString, _List_Nil, A2($elm$core$Maybe$withDefault, 'N/A', source_.ahy)),
            $author$project$Utils$Html$noBreakSpace,
            function() {
                var _v3 = source_.aeI;
                if (!_v3.$) {
                    var label = _v3.a;
                    return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$em, _List_fromArray([
                            $elm$html$Html$Attributes$class('text-muted mr-2')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true),
                                $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
                            ]), _List_fromArray([
                                $elm$html$Html$text(label)
                            ]))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            optionsRecord.yF ? $author$project$Utils$Html$empty : A4($author$project$Components$PaymentSourceDisplayer$viewAdditionalInfo, timeFormatter, optionsRecord.Cv, optionsRecord.V8, source_)
        ]));
    });
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$zip = function(_v0) {
        var record = _v0;
        return record.tK;
    };
    var $author$project$Api$Employer$Card$Shared$zip = function(_v0) {
        var record = _v0;
        return record.tK;
    };
    var $author$project$Api$Employer$Card$One$zip = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$zip(shared);
    };
    var $author$project$Api$Employer$Card$All$zip = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$zip(one);
    };
    var $author$project$Api$Provider$Card$Shared$zip = function(_v0) {
        var record = _v0;
        return record.tK;
    };
    var $author$project$Api$Provider$Card$One$zip = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$zip(shared);
    };
    var $author$project$Api$Provider$Card$All$zip = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$zip(one);
    };
    var $author$project$Api$Card$zip = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$zip(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$zip(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$zip(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$zip(card_);
        }
    };
    var $author$project$Api$Source$zip = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$zip(card);
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$PaymentSourceDisplayer$view = F2(function(timeFormatter, options) {
        var optionsRecord = $author$project$Components$PaymentSourceDisplayer$optionsToRecord(options);
        var _v0 = _Utils_Tuple3(optionsRecord.Hw, optionsRecord.ace, optionsRecord.CN);
        if (!_v0.a.$) {
            var source_ = _v0.a.a;
            return A3($author$project$Components$PaymentSourceDisplayer$viewSource, timeFormatter, optionsRecord, {
                JF: $author$project$Api$Source$assignedMemberships(source_),
                Mx: $author$project$Api$Source$createdAt(source_),
                Mz: $author$project$Api$Source$createdByName(source_),
                MA: $author$project$Api$Source$createdVia(source_),
                O4: $author$project$Api$Source$errorMessage(source_),
                adz: $author$project$Api$Source$expMonth(source_),
                adA: $author$project$Api$Source$expYear(source_),
                P1: $author$project$Api$Source$funding(source_),
                aeI: $author$project$Api$Source$label(source_),
                ST: $author$project$Api$Source$lastFour(source_),
                SV: $author$project$Api$Source$lastPaymentErrorMessage(source_),
                zr: $author$project$Api$Source$name(source_),
                Wo: $author$project$Api$Source$paymentProcessor(source_),
                ahy: $author$project$Api$Source$status(source_),
                ah5: $author$project$Api$Source$type_(source_),
                tK: $author$project$Api$Source$zip(source_)
            });
        } else {
            if (!_v0.b.$) {
                var cardReader_ = _v0.b.a;
                return A2($author$project$Components$PaymentSourceDisplayer$viewCardReader, optionsRecord, cardReader_);
            } else if (!_v0.c.$) {
                var _v1 = _v0.a;
                var _v2 = _v0.b;
                var stripePaymentMethodMigration_ = _v0.c.a;
                return A3($author$project$Components$PaymentSourceDisplayer$viewSource, timeFormatter, optionsRecord, {
                    JF: _List_Nil,
                    Mx: $elm$core$Maybe$Just($author$project$Api$Provider$StripePaymentMethodMigration$All$createdAt(stripePaymentMethodMigration_)),
                    Mz: $author$project$Api$Provider$StripePaymentMethodMigration$All$createdByName(stripePaymentMethodMigration_),
                    MA: $author$project$Api$Provider$StripePaymentMethodMigration$All$createdVia(stripePaymentMethodMigration_),
                    O4: $author$project$Api$Provider$StripePaymentMethodMigration$All$errorMessage(stripePaymentMethodMigration_),
                    adz: $author$project$Api$Provider$StripePaymentMethodMigration$All$expMonth(stripePaymentMethodMigration_),
                    adA: $author$project$Api$Provider$StripePaymentMethodMigration$All$expYear(stripePaymentMethodMigration_),
                    P1: $author$project$Api$Provider$StripePaymentMethodMigration$All$funding(stripePaymentMethodMigration_),
                    aeI: $author$project$Api$Provider$StripePaymentMethodMigration$All$label(stripePaymentMethodMigration_),
                    ST: $author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour(stripePaymentMethodMigration_),
                    SV: $author$project$Api$Provider$StripePaymentMethodMigration$All$lastPaymentErrorMessage(stripePaymentMethodMigration_),
                    zr: $author$project$Api$Provider$StripePaymentMethodMigration$All$name(stripePaymentMethodMigration_),
                    Wo: $elm$core$Maybe$Just($author$project$Api$Provider$StripePaymentMethodMigration$All$paymentProcessor(stripePaymentMethodMigration_)),
                    ahy: $author$project$Api$Provider$StripePaymentMethodMigration$All$status(stripePaymentMethodMigration_),
                    ah5: $elm$core$Maybe$Just($author$project$Api$Provider$StripePaymentMethodMigration$All$type_(stripePaymentMethodMigration_)),
                    tK: $author$project$Api$Provider$StripePaymentMethodMigration$All$zip(stripePaymentMethodMigration_)
                });
            } else {
                var _v3 = _v0.a;
                var _v4 = _v0.b;
                var _v5 = _v0.c;
                return $author$project$Utils$Html$empty;
            }
        }
    });
    var $author$project$Components$PracticeSourceDisplayer$view = F2(function(timeFormatter, source) {
        return A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$helpBlock
        ]), _List_fromArray([
            $elm$html$Html$text('Payment source: '),
            A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                $author$project$Components$PaymentSourceDisplayer$source(source),
                $author$project$Components$PaymentSourceDisplayer$limitedView(true),
                $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true)
            ])),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__PaymentSources, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Edit')
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Billing$viewPracticePaymentSource = F3(function(timeFormatter, cards, bankAccounts) {
        return A2($author$project$Components$PracticeSourceDisplayer$view, timeFormatter, A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts));
    });
    var $author$project$Pages$Admin$Billing$viewInvoicesHeader = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(8)
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Invoices')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    function() {
                        var _v0 = _Utils_Tuple2(model.pQ, model.pF);
                        if (_v0.a.$ === 3 && _v0.b.$ === 3) {
                            var _v1 = _v0.a;
                            var cards = _v1.a;
                            var _v2 = _v0.b;
                            var bankAccounts = _v2.a;
                            return A3($author$project$Pages$Admin$Billing$viewPracticePaymentSource, model.HO, cards, bankAccounts);
                        } else return $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanFromText('Payment source: *Visa 4242')
                        ]));
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Billing$AnalyticsLinkClicked = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Margin$Top_8 = 22;
    var $author$project$Api$Provider$PracticePricing$One$addOns = function(_v0) {
        var record = _v0;
        return A2($elm$core$List$filter, function(product) {
            return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) === 1;
        }, record.Bt);
    };
    var $author$project$Api$Provider$PracticePricing$One$txnFees = function(_v0) {
        var record = _v0;
        return record.aaD;
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Ui$Element$spaceY2 = $author$project$Ui$Element$SpaceY(2);
    var $author$project$Api$Provider$HintBillingComponent$Shared$addonType = function(_v0) {
        var record = _v0;
        return record.IG;
    };
    var $author$project$Components$HintBilling$Pricing$trimSubString = F2(function(name, substringToReplace) {
        return A3($elm$core$String$replace, substringToReplace, '', name);
    });
    var $author$project$Components$HintBilling$Pricing$viewProduct = F3(function(content, maybeQuantity, maybePrice) {
        var totalPrice = function() {
            var _v2 = _Utils_Tuple2(maybeQuantity, maybePrice);
            if (!_v2.a.$ && !_v2.b.$) {
                var quantity = _v2.a.a;
                var price = _v2.b.a;
                var total = quantity * price;
                var formattedTotal = $author$project$Utils$Currency$fromIntNoDecimals($elm$core$Basics$round(total));
                return $elm$core$Maybe$Just(formattedTotal);
            } else return $elm$core$Maybe$Nothing;
        }();
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(A2($elm$core$Maybe$withDefault, 12, A2($elm$core$Maybe$map, function(_v0) {
                    return 9;
                }, totalPrice)))
            ]), _List_fromArray([
                content
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(3)
            ]), _List_fromArray([
                function() {
                    if (!totalPrice.$) {
                        var price = totalPrice.a;
                        return A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                        ]), _List_fromArray([
                            $elm$html$Html$text(price)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    });
    var $author$project$Components$HintBilling$Pricing$viewAddon = function(addOn) {
        var _v0 = _Utils_Tuple2($author$project$Api$Provider$HintBillingComponent$Shared$componentType(addOn), $author$project$Api$Provider$HintBillingComponent$Shared$addonType(addOn));
        if (_v0.a === 1 && !_v0.b.$) {
            var _v1 = _v0.a;
            var addonType = _v0.b.a;
            var shouldShowAddon = addonType === 1 ? A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(qty) {
                return qty > 0;
            }, $author$project$Api$Provider$HintBillingComponent$Shared$quantity(addOn))) : true;
            if (shouldShowAddon) {
                var displayName = A2($author$project$Components$HintBilling$Pricing$trimSubString, $author$project$Api$Provider$HintBillingComponent$Shared$name(addOn), 'Add-on: ');
                return A3($author$project$Components$HintBilling$Pricing$viewProduct, A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Icon$check(_List_Nil),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(displayName)
                    ]))
                ])), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$HintBilling$Pricing$viewAddons = function(addOns) {
        var sortedAddOns = A2($elm$core$List$sortBy, $author$project$Api$Provider$HintBillingComponent$Shared$name, addOns);
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(3)
        ]), $elm$core$List$isEmpty(sortedAddOns) ? _List_Nil : _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Add-Ons')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$br, _List_Nil, _List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceY2
                            ]), A2($elm$core$List$map, $author$project$Components$HintBilling$Pricing$viewAddon, sortedAddOns))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$HintBilling$Pricing$viewFeesBreakdown = function(txnFees) {
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(4)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Transaction Fees *')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$br, _List_Nil, _List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceY2
                            ]), _List_fromArray([
                                A2($author$project$Utils$Billing$TxnFees$viewFees, txnFees, false)
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text('* Transaction fees are taken at the time of the transaction')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Api$Provider$PracticePricing$One$revenueOveragePriceInCents = function(_v0) {
        var record = _v0;
        return record.Y2;
    };
    var $author$project$Components$HintBilling$NextBill$viewNextBillDate = function(maybeNextBillDate) {
        var billDateText = function() {
            if (!maybeNextBillDate.$) {
                var nextBillDAte = maybeNextBillDate.a;
                return ' Next Bill: ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDAte);
            } else return '';
        }();
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(billDateText)
        ]));
    };
    var $author$project$Ui$Element$flex = A2($author$project$Ui$Element$Display, 0, 2);
    var $author$project$Components$HintBilling$NextBill$viewPrice = function(billableProducts) {
        var totalAmountInCents = $elm$core$List$sum(A2($elm$core$List$map, function(product) {
            return $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product) * A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$HintBillingComponent$Shared$quantity(product));
        }, A2($elm$core$List$filter, function(product) {
            return $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) !== 5;
        }, billableProducts)));
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flex,
            $author$project$Ui$Element$gap2,
            $author$project$Ui$Element$itemsCenter
        ]), _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromIntNoDecimals($elm$core$Basics$round(totalAmountInCents)))
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('/ mo')
            ]))
        ]));
    };
    var $author$project$Components$HintBilling$NextBill$view = F2(function(pricing, viewCustomContent) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Monthly Subscription')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    $author$project$Components$HintBilling$NextBill$viewPrice($author$project$Api$Provider$PracticePricing$One$billableProducts(pricing))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    $author$project$Components$HintBilling$NextBill$viewNextBillDate($author$project$Api$Provider$PracticePricing$One$nextBillDate(pricing))
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$margin(12)
                ]), _List_fromArray([
                    viewCustomContent
                ]))
            ]))
        ]));
    });
    var $author$project$Components$HintBilling$Pricing$viewBillingSection = F3(function(applicationFeePlan, pricing, currentDate) {
        return A2($author$project$Ui$Grid$row, _List_Nil, function() {
            if (applicationFeePlan.$ === 3) {
                var feePlan = applicationFeePlan.a;
                return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(pricing) ? _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(10)
                    ]), _List_fromArray([
                        A4($author$project$Components$HintBilling$LegacyPricing$view, currentDate, feePlan, $author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(pricing), $author$project$Api$Provider$PracticePricing$One$billableProducts(pricing))
                    ]))
                ]) : _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$HintBilling$NextBill$view, pricing, $author$project$Utils$Html$empty)
                    ]))
                ]);
            } else return _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Components$HintBilling$NextBill$skeleton
                ]))
            ]);
        }());
    });
    var $author$project$Components$HintBilling$Pricing$createNewGroup = function(addonData) {
        return {
            iU: !addonData.Br ? addonData.Bu : 0,
            zr: addonData.zr,
            es: addonData.Br > 0 ? addonData.Br : 0,
            Bu: addonData.Bu,
            aaH: addonData.aaH
        };
    };
    var $author$project$Api$Provider$HintBillingComponent$UnitName$toString = function(unitName_) {
        switch(unitName_){
            case 0:
                return 'member';
            case 1:
                return 'dollar';
            case 2:
                return 'integration';
            case 3:
                return 'feed';
            case 4:
                return 'clinician';
            default:
                return 'copilot';
        }
    };
    var $author$project$Api$Provider$HintBillingComponent$Shared$unitName = function(_v0) {
        var record = _v0;
        return record.aaH;
    };
    var $author$project$Components$HintBilling$Pricing$extractAddonData = function(addon) {
        var unitName = A2($elm$core$Maybe$map, $author$project$Api$Provider$HintBillingComponent$UnitName$toString, $author$project$Api$Provider$HintBillingComponent$Shared$unitName(addon));
        var quantity = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$HintBillingComponent$Shared$quantity(addon));
        var priceInCents = $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(addon);
        var addonName = A2($author$project$Components$HintBilling$Pricing$trimSubString, $author$project$Api$Provider$HintBillingComponent$Shared$name(addon), 'Add-on:');
        return {
            zr: addonName,
            Br: priceInCents,
            Bu: quantity,
            aaH: unitName
        };
    };
    var $author$project$Components$HintBilling$Pricing$updateExistingGroup = F2(function(group, addonData) {
        return _Utils_update(group, {
            iU: group.iU + (!addonData.Br ? addonData.Bu : 0),
            zr: addonData.Br > 0 ? addonData.zr : group.zr,
            es: addonData.Br > 0 && !group.es ? addonData.Br : group.es,
            Bu: group.Bu + addonData.Bu
        });
    });
    var $author$project$Components$HintBilling$Pricing$groupByUnitName = F2(function(addon, groups) {
        var addonData = $author$project$Components$HintBilling$Pricing$extractAddonData(addon);
        var _v0 = addonData.aaH;
        if (_v0.$ === 1) return A2($elm$core$List$cons, $author$project$Components$HintBilling$Pricing$createNewGroup(addonData), groups);
        else {
            var _v1 = A2($elm$core$List$filter, function(group) {
                return _Utils_eq(group.aaH, addonData.aaH);
            }, groups);
            if (_v1.b) return A2($elm$core$List$map, function(group) {
                return _Utils_eq(group.aaH, addonData.aaH) ? A2($author$project$Components$HintBilling$Pricing$updateExistingGroup, group, addonData) : group;
            }, groups);
            else return A2($elm$core$List$cons, $author$project$Components$HintBilling$Pricing$createNewGroup(addonData), groups);
        }
    });
    var $author$project$Components$HintBilling$Pricing$formatPluralName = F2(function(name, quantity) {
        return _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$bold
            ]), _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt(quantity))
            ])),
            $elm$html$Html$text(A3($elm$core$String$replace, $elm$core$String$fromInt(quantity), '', A2($author$project$Formatters$String$pluralize, name, quantity)))
        ]);
    });
    var $author$project$Components$HintBilling$Pricing$renderAddonGroup = function(group) {
        var pricingDetails = group.iU > 0 && group.es > 0 ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt(group.iU) + (' included in your plan, ' + ($author$project$Utils$Currency$fromIntNoDecimals($elm$core$Basics$round(group.es)) + ' each')))
            ]))
        ]) : _List_Nil;
        var paidQuantity = A2($elm$core$Basics$max, 0, group.Bu - group.iU);
        var content = A2($author$project$Ui$Element$view, _List_Nil, _Utils_ap(A2($author$project$Components$HintBilling$Pricing$formatPluralName, group.zr, group.Bu), pricingDetails));
        return A3($author$project$Components$HintBilling$Pricing$viewProduct, content, $elm$core$Maybe$Just(paidQuantity), $elm$core$Maybe$Just(group.es));
    };
    var $author$project$Components$HintBilling$Pricing$viewPricedAddons = function(addons) {
        return A2($elm$core$List$map, $author$project$Components$HintBilling$Pricing$renderAddonGroup, A2($elm$core$List$filter, function(group) {
            return group.es > 0;
        }, A3($elm$core$List$foldl, $author$project$Components$HintBilling$Pricing$groupByUnitName, _List_Nil, A2($elm$core$List$filter, function(addon) {
            return !_Utils_eq($author$project$Api$Provider$HintBillingComponent$Shared$quantity(addon), $elm$core$Maybe$Nothing);
        }, addons))));
    };
    var $author$project$Api$Provider$PracticePricing$One$currentMembers = function(_v0) {
        var record = _v0;
        return record.MN;
    };
    var $author$project$Api$Provider$ApplicationFeePlan$One$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$HintBilling$Pricing$productTypePrefix = F2(function(hasClinicalAccount, baseFeeName) {
        return hasClinicalAccount ? 'Clinical ' + baseFeeName : 'Core ' + baseFeeName;
    });
    var $author$project$Formatters$Float$toPercentage = function(_float) {
        return $elm$core$String$fromFloat(_float) + '%';
    };
    var $author$project$Components$HintBilling$Pricing$viewProductByType = F6(function(pricing, applicationFeePlan, product, hasClinicalAccount, onAnalyticsClick, maybeRevenueOveragePriceInCents) {
        var quantity = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$HintBillingComponent$Shared$quantity(product));
        var _v0 = $author$project$Api$Provider$HintBillingComponent$Shared$componentType(product);
        switch(_v0){
            case 0:
                return A3($author$project$Components$HintBilling$Pricing$viewProduct, A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Components$HintBilling$Pricing$productTypePrefix, hasClinicalAccount, $author$project$Api$Provider$HintBillingComponent$Shared$name(product)))
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text('Base Subscription Tier. '),
                        A3($author$project$Components$HintBilling$FeatureListLink$view, hasClinicalAccount, onAnalyticsClick, true)
                    ]))
                ])), $elm$core$Maybe$Just(quantity), $elm$core$Maybe$Just($author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
            case 4:
                var name = $author$project$Api$Provider$HintBillingComponent$Shared$name(product);
                var formattedPriceInCents = $author$project$Utils$Currency$fromIntNoDecimals($elm$core$Basics$round($author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
                return A3($author$project$Components$HintBilling$Pricing$viewProduct, A2($author$project$Ui$Element$view, _List_Nil, _Utils_ap(A2($author$project$Components$HintBilling$Pricing$formatPluralName, name, quantity), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(formattedPriceInCents + '/mo per Clinician')
                    ]))
                ]))), $elm$core$Maybe$Just(quantity), $elm$core$Maybe$Just($author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
            case 2:
                var membersPriceInCents = quantity * $elm$core$Basics$round($author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product));
                var feePlanName = function() {
                    if (applicationFeePlan.$ === 3) {
                        var feePlan = applicationFeePlan.a;
                        return $author$project$Api$Provider$ApplicationFeePlan$One$name(feePlan);
                    } else return '';
                }();
                var currentUsageText = ' Current Usage ' + ($elm$core$String$fromInt($author$project$Api$Provider$PracticePricing$One$currentMembers(pricing)) + ' Members');
                return A3($author$project$Components$HintBilling$Pricing$viewProduct, A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Up to ' + ($elm$core$String$fromInt(quantity) + ' Members'))
                    ])),
                    A4($author$project$Components$HintBilling$MemberTranches$view, feePlanName, quantity, membersPriceInCents, onAnalyticsClick),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpText,
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(currentUsageText)
                    ]))
                ])), $elm$core$Maybe$Just(quantity), $elm$core$Maybe$Just($author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
            case 3:
                if ($author$project$Api$Provider$HintBillingComponent$Shared$name(product) !== 'Additional Billed Revenue') {
                    var overageRevenueExplaination = function() {
                        if (!maybeRevenueOveragePriceInCents.$) {
                            var revenueOveragePriceInCents = maybeRevenueOveragePriceInCents.a;
                            return ' (' + ($author$project$Formatters$Float$toPercentage(revenueOveragePriceInCents) + ' on additional revenue)');
                        } else return '';
                    }();
                    var revenueExplainationText = '$' + ($elm$core$String$fromFloat(quantity / 1000) + ('k' + overageRevenueExplaination));
                    return A3($author$project$Components$HintBilling$Pricing$viewProduct, A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Billed Revenue')
                        ])),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$helpText,
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text(revenueExplainationText)
                        ]))
                    ])), $elm$core$Maybe$Just(quantity), $elm$core$Maybe$Just($author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product)));
                } else return $author$project$Utils$Html$empty;
            case 1:
                return $author$project$Utils$Html$empty;
            default:
                return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Components$HintBilling$Pricing$viewProductsBreakDown = F5(function(pricing, applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick) {
        var revenueOveragePriceInCents = $author$project$Api$Provider$PracticePricing$One$revenueOveragePriceInCents(pricing);
        var products = A2($elm$core$List$filter, function(product) {
            return !_Utils_eq($author$project$Api$Provider$HintBillingComponent$Shared$quantity(product), $elm$core$Maybe$Nothing);
        }, $author$project$Api$Provider$PracticePricing$One$billableProducts(pricing));
        var baseFeeHasCost = A2($elm$core$List$any, function(product) {
            return !$author$project$Api$Provider$HintBillingComponent$Shared$componentType(product) && $author$project$Api$Provider$HintBillingComponent$Shared$priceInCents(product) > 0;
        }, products);
        var addOns = $author$project$Api$Provider$PracticePricing$One$addOns(pricing);
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(5)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A3($author$project$Components$HintBilling$Pricing$viewBillingSection, applicationFeePlan, pricing, currentDate)
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceY2
                            ]), _Utils_ap(A2($elm$core$List$map, function(product) {
                                return A6($author$project$Components$HintBilling$Pricing$viewProductByType, pricing, applicationFeePlan, product, hasClinicalAccount, onAnalyticsClick, revenueOveragePriceInCents);
                            }, products), $author$project$Components$HintBilling$Pricing$viewPricedAddons(addOns)))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        hasClinicalAccount && baseFeeHasCost ? $elm$html$Html$text('* Because you are a Clinical customer, you get a 20% discount on clinicians and members.') : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$HintBilling$Pricing$view = F5(function(applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick, pricing) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A5($author$project$Components$HintBilling$Pricing$viewProductsBreakDown, pricing, applicationFeePlan, currentDate, hasClinicalAccount, onAnalyticsClick),
            $author$project$Components$HintBilling$Pricing$viewAddons($author$project$Api$Provider$PracticePricing$One$addOns(pricing)),
            $author$project$Components$HintBilling$Pricing$viewFeesBreakdown($author$project$Api$Provider$PracticePricing$One$txnFees(pricing))
        ]));
    });
    var $author$project$Pages$Admin$Billing$viewProductsSection = F4(function(practicePricingData, applicationFeePlanData, currentDate, hasClinicalAccount) {
        if (practicePricingData.$ === 3) {
            var practicePricing = practicePricingData.a;
            return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$margin(22)
            ]), _List_fromArray([
                A5($author$project$Components$HintBilling$Pricing$view, applicationFeePlanData, currentDate, hasClinicalAccount, $author$project$Pages$Admin$Billing$AnalyticsLinkClicked, practicePricing)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Admin$Billing$viewBody = function(model) {
        var showBillingSections = $author$project$Pages$Admin$Billing$shouldShowBillingSections(model.cl);
        var billingSections = showBillingSections ? _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Billing')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A3($author$project$Pages$Admin$Billing$viewActionButtons, model.cl, model.F3, model.o5)
                    ]))
                ]))
            ])),
            A3($author$project$Pages$Admin$Billing$viewBillingSection, model.mi, model.cl, model.cP),
            A4($author$project$Pages$Admin$Billing$viewProductsSection, model.cl, model.mi, model.cP, model.Ql),
            A4($author$project$Pages$Admin$Billing$viewAdditionalChargesSection, model.oZ, model.F3, model.cl, model.cP)
        ]) : _List_Nil;
        return _List_fromArray([
            $author$project$Pages$Admin$Billing$modals(model),
            A3($author$project$Pages$Admin$Billing$viewCapitalPromoTile, model.W1, model.pN, model.v1),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, $author$project$Pages$Admin$Billing$viewInfoMessage(model.cl), _Utils_ap(billingSections, _List_fromArray([
                    $author$project$Pages$Admin$Billing$viewInvoicesHeader(model),
                    A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$PracticeInvoicePaginationMsg, A2($author$project$Components$HintBilling$InvoicesTable$view, model.jB, model.eo))
                ]))))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Billing$view = function(model) {
        return {
            fb: $author$project$Pages$Admin$Billing$viewBody(model),
            $2: 'Admin | Billing'
        };
    };
    var $author$project$Pages$Admin$Billing$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Billing$init,
        aeR: $author$project$Pages$Admin$Billing$load,
        ag3: $author$project$Pages$Admin$Billing$save,
        ahE: $author$project$Pages$Admin$Billing$subscriptions,
        aaO: $author$project$Pages$Admin$Billing$update,
        aid: $author$project$Pages$Admin$Billing$view
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DropdownMenuMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$DownloadFile$DropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Invoice$DownloadFile$init = function(currentUrl) {
        return {
            fD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'download-files-dropdown',
                ahX: $author$project$Components$Invoice$DownloadFile$DropdownMsg
            })),
            Sk: false,
            aaT: currentUrl
        };
    };
    var $author$project$Components$Invoice$PaymentsHistory$PopoverMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$init = F4(function(timeFormatter, basePath, session, allowPartialRefunds) {
        return {
            vs: allowPartialRefunds,
            vK: basePath,
            cG: $elm$core$Maybe$Nothing,
            hH: $elm$core$Maybe$Nothing,
            gn: $elm$core$Maybe$Nothing,
            eu: $elm$core$Maybe$Nothing,
            jM: $elm$core$Maybe$Nothing,
            Z$: session,
            ke: $elm$core$Maybe$Nothing,
            kf: $elm$core$Maybe$Nothing,
            HO: timeFormatter
        };
    });
    var $author$project$Ui$Popover$Model = $elm$core$Basics$identity;
    var $author$project$Ui$Popover$init = F3(function(id, open, toMsg) {
        return {
            aef: id,
            Vw: open,
            ahX: toMsg
        };
    });
    var $author$project$Components$Invoice$PaymentsHistory$init = F4(function(timeFormatter, basePath, session, allowPartialRefunds) {
        return {
            jt: A4($author$project$Components$PaymentsList$init, timeFormatter, basePath, session, allowPartialRefunds),
            aN: A3($author$project$Ui$Popover$init, 'payment-history', false, $author$project$Components$Invoice$PaymentsHistory$PopoverMsg),
            HO: timeFormatter
        };
    });
    var $author$project$Api$Provider$PracticeInvoice$paymentsBasePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'practice_invoices',
            id_
        ]), $author$project$Api$Data$providerPath);
    };
    var $author$project$Api$Provider$PracticeInvoice$practiceInvoicePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$PracticeInvoice$practiceInvoicesPath);
    };
    var $author$project$Api$Provider$PracticeInvoice$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PracticeInvoice$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)));
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            hZ: $elm$core$Maybe$Nothing,
            lH: $elm$core$Maybe$Nothing,
            cP: shared.cP,
            ib: $elm$core$Maybe$Nothing,
            it: $author$project$Components$Invoice$DownloadFile$init(shared.aaT),
            l_: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'invoice-actions-dropdown-menu',
                ahX: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DropdownMenuMsg
            })),
            aef: params.aef,
            F3: $author$project$Shared$isHintAdmin(shared),
            js: A4($author$project$Components$Invoice$PaymentsHistory$init, shared.HO, $author$project$Api$Provider$PracticeInvoice$paymentsBasePath(params.aef), session, $author$project$Shared$isHintAdmin(shared)),
            W1: practice,
            W3: $author$project$Api$Data$Loading,
            sp: shared.sp,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            HO: shared.HO,
            tG: $elm$core$Maybe$Nothing
        }, A3($author$project$Api$Provider$PracticeInvoice$retrieve, shared.Ej, params.aef, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$Close = {
        $: 0
    };
    var $author$project$Components$Invoice$CreatePaymentModal$GotLocalStorageItem = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ports$LocalStorage$localStorageGotItemPort = _Platform_incomingPort('localStorageGotItemPort', A2($elm$json$Json$Decode$andThen, function(_v0) {
        return A2($elm$json$Json$Decode$andThen, function(_v1) {
            return $elm$json$Json$Decode$succeed(_Utils_Tuple2(_v0, _v1));
        }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
            A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
        ]))));
    }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
    var $author$project$Ports$LocalStorage$gotItem = function(toMsg) {
        return $author$project$Ports$LocalStorage$localStorageGotItemPort(toMsg);
    };
    var $author$project$Components$CardReader$ConnectingModal$Cancel = {
        $: 0
    };
    var $author$project$Components$CardReader$ConnectingModal$StripeReadReusableCardCancelled = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CardReader$ConnectingModal$StripeReaderConnected = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CardReader$ConnectingModal$StripeReaderDisconnected = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$CardReader$ConnectingModal$StripeReusableCardRead = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CardReader$ConnectingModal$StripeTerminalCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ports$StripeTerminal$stripeTerminalPortOnCreated = _Platform_incomingPort('stripeTerminalPortOnCreated', $elm$json$Json$Decode$string);
    var $author$project$Ports$StripeTerminal$onCreated = $author$project$Ports$StripeTerminal$stripeTerminalPortOnCreated;
    var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReadReusableCardCancelled = _Platform_incomingPort('stripeTerminalPortOnReadReusableCardCancelled', A2($elm$json$Json$Decode$andThen, function(_v0) {
        return A2($elm$json$Json$Decode$andThen, function(_v1) {
            return $elm$json$Json$Decode$succeed(_Utils_Tuple2(_v0, _v1));
        }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
            A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
        ]))));
    }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
    var $author$project$Ports$StripeTerminal$onReadReusableCardCancelled = function(toMsg) {
        return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReadReusableCardCancelled(function(_v0) {
            var token = _v0.a;
            var error = _v0.b;
            var result = function() {
                if (!error.$) {
                    var string = error.a;
                    return $elm$core$Result$Err(string);
                } else return $elm$core$Result$Ok(0);
            }();
            return A2(toMsg, token, result);
        });
    };
    var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReaderConnected = _Platform_incomingPort('stripeTerminalPortOnReaderConnected', A2($elm$json$Json$Decode$andThen, function(_v0) {
        return A2($elm$json$Json$Decode$andThen, function(_v1) {
            return $elm$json$Json$Decode$succeed(_Utils_Tuple2(_v0, _v1));
        }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
            A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
        ]))));
    }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
    var $author$project$Ports$StripeTerminal$onReaderConnected = function(toMsg) {
        return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReaderConnected(function(_v0) {
            var token = _v0.a;
            var error = _v0.b;
            var result = function() {
                if (!error.$) {
                    var string = error.a;
                    return $elm$core$Result$Err(string);
                } else return $elm$core$Result$Ok(0);
            }();
            return A2(toMsg, token, result);
        });
    };
    var $author$project$Ports$StripeTerminal$stripeTerminalPortOnReusableCardRead = _Platform_incomingPort('stripeTerminalPortOnReusableCardRead', A2($elm$json$Json$Decode$andThen, function(_v0) {
        return A2($elm$json$Json$Decode$andThen, function(_v1) {
            return A2($elm$json$Json$Decode$andThen, function(_v2) {
                return $elm$json$Json$Decode$succeed(_Utils_Tuple3(_v0, _v1, _v2));
            }, A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$oneOf(_List_fromArray([
                $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
            ]))));
        }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$oneOf(_List_fromArray([
            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
            A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
        ]))));
    }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
    var $author$project$Ports$StripeTerminal$onReusableCardRead = function(toMsg) {
        return $author$project$Ports$StripeTerminal$stripeTerminalPortOnReusableCardRead(function(_v0) {
            var token = _v0.a;
            var paymentMethodId = _v0.b;
            var error = _v0.c;
            var result = function() {
                if (!paymentMethodId.$) {
                    var string = paymentMethodId.a;
                    return $elm$core$Result$Ok(string);
                } else return $elm$core$Result$Err(A2($elm$core$Maybe$withDefault, $author$project$Ui$Toast$defaultError, error));
            }();
            return A2(toMsg, token, result);
        });
    };
    var $author$project$Ports$StripeTerminal$stripeTerminalPortOnUnexpectedReaderDisconnect = _Platform_incomingPort('stripeTerminalPortOnUnexpectedReaderDisconnect', $elm$json$Json$Decode$string);
    var $author$project$Ports$StripeTerminal$onUnexpectedReaderDisconnect = $author$project$Ports$StripeTerminal$stripeTerminalPortOnUnexpectedReaderDisconnect;
    var $author$project$Components$CardReader$ConnectingModal$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ports$StripeTerminal$onCreated($author$project$Components$CardReader$ConnectingModal$StripeTerminalCreated),
            $author$project$Ports$StripeTerminal$onReaderConnected($author$project$Components$CardReader$ConnectingModal$StripeReaderConnected),
            $author$project$Ports$StripeTerminal$onReusableCardRead($author$project$Components$CardReader$ConnectingModal$StripeReusableCardRead),
            $author$project$Ports$StripeTerminal$onReadReusableCardCancelled($author$project$Components$CardReader$ConnectingModal$StripeReadReusableCardCancelled),
            $author$project$Ports$StripeTerminal$onUnexpectedReaderDisconnect($author$project$Components$CardReader$ConnectingModal$StripeReaderDisconnected),
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CardReader$ConnectingModal$Cancel)
        ]));
    };
    var $author$project$Components$CardReader$PaymentModal$Cancel = {
        $: 0
    };
    var $author$project$Components$CardReader$PaymentModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CardReader$PaymentModal$Cancel);
    };
    var $author$project$Components$Invoice$CreatePaymentModal$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = _Utils_Tuple2(model.hI, model.bU);
                if (!_v1.a.$) {
                    var _v2 = _v1.a.a;
                    var cardReaderConnectingModal = _v2.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg, $author$project$Components$CardReader$ConnectingModal$subscriptions(cardReaderConnectingModal));
                } else if (!_v1.b.$) {
                    var _v3 = _v1.b.a;
                    var cardReaderPaymentModal = _v3.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, $author$project$Components$CardReader$PaymentModal$subscriptions(cardReaderPaymentModal));
                } else {
                    var _v4 = _v1.a;
                    var _v5 = _v1.b;
                    return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$CreatePaymentModal$Close);
                }
            }(),
            $author$project$Ports$LocalStorage$gotItem($author$project$Components$Invoice$CreatePaymentModal$GotLocalStorageItem)
        ]));
    };
    var $author$project$Components$Invoice$DownloadFile$CloseModal = {
        $: 3
    };
    var $author$project$Components$Invoice$DownloadFile$subscriptions = function(model) {
        return model.Sk ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$DownloadFile$CloseModal) : $author$project$Ui$Dropdown$subscriptions(model.fD);
    };
    var $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Popover$isOpen = function(msg) {
        var model = msg;
        return model.Vw;
    };
    var $author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentsList$CancelRefundConfirmed = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$ClosePaymentDisputeModal = {
        $: 3
    };
    var $author$project$Components$PaymentsList$CloseRainforestPaymentModal = {
        $: 6
    };
    var $author$project$Components$PaymentsList$RefundModalMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$SimulateDisputeModalMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Invoice$RefundModal$Close = {
        $: 0
    };
    var $author$project$Components$Invoice$RefundModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$RefundModal$Close);
    };
    var $author$project$Components$DisputeModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
    var $author$project$Components$PaymentDisputeModal$subscriptions = F2(function(model, toMsg) {
        var _v0 = model.N7;
        if (!_v0.$) return $author$project$Components$DisputeModal$subscriptions(toMsg);
        else return $elm$core$Platform$Sub$none;
    });
    var $author$project$Components$Rainforest$SessionModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal);
    };
    var $author$project$Components$Rainforest$SimulateDisputeModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Rainforest$SimulateDisputeModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateDisputeModal$CloseModal);
    };
    var $author$project$Components$PaymentsList$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$PaymentsList$RefundModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Invoice$RefundModal$subscriptions, model.jM))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(paymentDisputeModal) {
                return A2($author$project$Components$PaymentDisputeModal$subscriptions, paymentDisputeModal, $author$project$Components$PaymentsList$ClosePaymentDisputeModal);
            }, model.gn)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Rainforest$SessionModal$subscriptions($author$project$Components$PaymentsList$CloseRainforestPaymentModal)), model.eu)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$PaymentsList$SimulateDisputeModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Rainforest$SimulateDisputeModal$subscriptions, model.kf))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Rainforest$SimulateDisputeEventModal$subscriptions, model.ke))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed), $elm$core$Tuple$first), model.cG)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$PaymentsList$CancelRefundConfirmed)), model.hH))
        ]));
    };
    var $author$project$Ui$Popover$Close = 0;
    var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
    var $author$project$Utils$Dom$outsideTarget = F2(function(msg, id) {
        return A2($elm$json$Json$Decode$andThen, function(isOutside) {
            return isOutside ? $elm$json$Json$Decode$succeed(msg) : $elm$json$Json$Decode$fail('inside target');
        }, A2($elm$json$Json$Decode$field, 'target', $author$project$Utils$Dom$isOutsideTarget(id)));
    });
    var $author$project$Utils$Dom$onOutsideMouseDown = F2(function(msg, id) {
        return $elm$browser$Browser$Events$onMouseDown(A2($author$project$Utils$Dom$outsideTarget, msg, id));
    });
    var $author$project$Ui$Popover$decodePressedKey = function(closeMsg) {
        return A2($elm$json$Json$Decode$andThen, function(key) {
            return key === 'Escape' ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
        }, A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
    };
    var $author$project$Ui$Popover$subscribeToEscapeKeyPress = function(closeMsg) {
        return $elm$browser$Browser$Events$onKeyDown($author$project$Ui$Popover$decodePressedKey(closeMsg));
    };
    var $author$project$Ui$Popover$subscriptions = function(_v0) {
        var id = _v0.aef;
        var toMsg = _v0.ahX;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($author$project$Utils$Dom$onOutsideMouseDown, toMsg(0), id),
            $author$project$Ui$Popover$subscribeToEscapeKeyPress(toMsg(0))
        ]));
    };
    var $author$project$Components$Invoice$PaymentsHistory$subscriptions = function(_v0) {
        var paymentsList = _v0.jt;
        var popover = _v0.aN;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg, $author$project$Components$PaymentsList$subscriptions(paymentsList)),
            $author$project$Ui$Popover$isOpen(popover) ? $author$project$Ui$Popover$subscriptions(popover) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(model.l_),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.lH))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg, $author$project$Components$Invoice$DownloadFile$subscriptions(model.it)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg, $author$project$Components$Invoice$PaymentsHistory$subscriptions(model.js)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.ib))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.tG)))
        ]));
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Deleted = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issued = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Paid = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$PracticeInvoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Practice$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Voided = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Adjusted = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Refunded = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeInvoice$adjust = F4(function(apiClient, id_, chargeParams, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_invoice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('charge', $author$project$Api$Provider$PracticeCharge$encodeChargeParams(chargeParams))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'adjust'
        ]), $author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)))));
    });
    var $author$project$Api$Provider$PracticeInvoice$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$id(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$refund = F4(function(apiClient, id_, chargeParams, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_invoice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('charge', $author$project$Api$Provider$PracticeCharge$encodeChargeParams(chargeParams))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'credit_and_refund'
        ]), $author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)))));
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$adjustInvoiceAction = F3(function(apiClient, practiceInvoice, chargeParams) {
        if (practiceInvoice.$ === 3) {
            var practiceInvoice_ = practiceInvoice.a;
            return !$author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice_) ? A4($author$project$Api$Provider$PracticeInvoice$refund, apiClient, $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice_), chargeParams, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Refunded) : A4($author$project$Api$Provider$PracticeInvoice$adjust, apiClient, $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice_), chargeParams, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Adjusted);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Api$Provider$PracticeInvoice$cancel = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeInvoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel'
        ]), $author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_))));
    });
    var $author$project$Api$Payment$Employer_One = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Payment$Provider_One = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$Payment$One$Payment = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$Payment$Shared$Payment = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Payment$Shared$Record = F9(function(id, status, amountInCents, attemptedInCents, createdAt, external, errorMessage, source, paymentProcessor) {
        return {
            Jh: amountInCents,
            JL: attemptedInCents,
            Mx: createdAt,
            O4: errorMessage,
            Po: external,
            aef: id,
            Wo: paymentProcessor,
            Hw: source,
            ahy: status
        };
    });
    var $author$project$Api$Employer$Payment$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'attempted_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$Shared$Record))))))))));
    var $author$project$Api$Employer$Payment$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Payment$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Payment$One$Record = function(refunds) {
        return {
            Yr: refunds
        };
    };
    var $author$project$Api$Employer$Refund$Shared$Refund = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Refund$Shared$Record = F5(function(id, createdAt, status, amountInCents, paymentProcessor) {
        return {
            Jh: amountInCents,
            Mx: createdAt,
            aef: id,
            Wo: paymentProcessor,
            ahy: status
        };
    });
    var $author$project$Api$Employer$Refund$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Refund$Shared$Record))))));
    var $author$project$Api$Employer$Refund$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Refund$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Payment$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'refunds', $elm$json$Json$Decode$list($author$project$Api$Employer$Refund$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$One$Record));
    var $author$project$Api$Employer$Payment$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Payment$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Payment$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Payment$One$Payment)));
    var $author$project$Currency$encode = A2($elm$core$Basics$composeR, $author$project$Currency$toInt, $author$project$Utils$Encode$nullable($elm$json$Json$Encode$int));
    var $author$project$Utils$Date$toIsoString = function(date) {
        return $justinmimbs$date$Date$toIsoString(date);
    };
    var $author$project$Utils$Date$encode = function(date) {
        return $elm$json$Json$Encode$string($author$project$Utils$Date$toIsoString(date));
    };
    var $author$project$Api$Payment$paymentsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'payments'
        ]), basePath);
    };
    var $author$project$Utils$Encode$typedAssociation = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aef)),
            _Utils_Tuple2('type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ah5))
        ]));
    };
    var $author$project$Api$Payment$create = F7(function(basePath, apiClient, session, payableKey, payableId, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2(payableKey, $elm$json$Json$Encode$string(payableId)),
                _Utils_Tuple2('source', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, fields.Hw)),
                _Utils_Tuple2('amount_in_cents', $author$project$Currency$encode(fields.Jh)),
                _Utils_Tuple2('external', $elm$json$Json$Encode$bool(fields.Po)),
                _Utils_Tuple2('memo', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ae0)),
                _Utils_Tuple2('paid_at', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.VQ)),
                _Utils_Tuple2('card_reader', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ace)),
                _Utils_Tuple2('source_one_time_use', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.aht)),
                _Utils_Tuple2('selected_card_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahe)),
                _Utils_Tuple2('selected_card_funding', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahd))
            ])))
        ]));
        return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$Payment$One$decoder, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Payment$Employer_One))) : A3($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Payment$One$decoder, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Payment$Provider_One))))(A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Payment$paymentsPath(basePath))));
    });
    var $author$project$Api$Provider$PracticeInvoice$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_)));
    });
    var $author$project$Api$Common$Source$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Practice$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Practice$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$id(shared);
    };
    var $author$project$Components$Invoice$CreatePaymentModal$External = 1;
    var $author$project$Components$Invoice$CreatePaymentModal$GotBankAccounts = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$GotCards = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Invoice$CreatePaymentModal$PayNow = 0;
    var $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.I9;
    });
    var $author$project$Api$Practice$allowMultipleRetailMemberships = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice_);
        } else return false;
    };
    var $author$project$Api$Provider$CardReader$All$label = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CardReader$Shared$label(shared);
    };
    var $author$project$Api$Provider$CardReader$All$paymentProcessor = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CardReader$Shared$paymentProcessor(shared);
    };
    var $author$project$Utils$PaymentProcessor$toLabel = F3(function(showProcessor, element, getPaymentProcessor) {
        var _v0 = _Utils_Tuple2(showProcessor, getPaymentProcessor(element));
        if (_v0.a && !_v0.b.$) {
            var paymentProcessor_ = _v0.b.a;
            return $elm$core$Maybe$Just('[' + (paymentProcessor_ + ']'));
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel = F2(function(showProcessor, cardReader) {
        return A2($elm$core$String$join, ' ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, cardReader, A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just)),
            $elm$core$Maybe$Just($author$project$Api$Provider$CardReader$All$label(cardReader))
        ])));
    });
    var $author$project$Api$Provider$CardReader$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CardReader$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CardReader$Shared$id(shared);
    };
    var $author$project$Components$Invoice$CreatePaymentModal$cardReaderToValue = function(cardReader) {
        return $elm$core$Maybe$Just($author$project$Api$Provider$CardReader$All$id(cardReader));
    };
    var $author$project$Components$Invoice$CreatePaymentModal$Card = 2;
    var $author$project$Components$Invoice$CreatePaymentModal$Cash = 1;
    var $author$project$Components$Invoice$CreatePaymentModal$Check = 0;
    var $author$project$Components$Invoice$CreatePaymentModal$Other = 4;
    var $author$project$Components$Invoice$CreatePaymentModal$defaultOptions = {
        Fc: 0,
        qn: 0,
        Po: false,
        Fs: _List_fromArray([
            0,
            1,
            2,
            4
        ]),
        or: false
    };
    var $author$project$Components$Invoice$CreatePaymentModal$Manual = 0;
    var $author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Source$Source = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Employer$Invoice$Shared$dueInCents = function(_v0) {
        var record = _v0;
        return record.Ol;
    };
    var $author$project$Api$Employer$Invoice$One$dueInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$dueInCents(shared);
    };
    var $author$project$Api$Provider$Invoice$Shared$dueInCents = function(_v0) {
        var record = _v0.b;
        return record.Ol;
    };
    var $author$project$Api$Provider$Invoice$One$dueInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$dueInCents(shared);
    };
    var $author$project$Api$Invoice$One$dueInCents = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$dueInCents(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$dueInCents(invoice_);
        }
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$dueInCents = function(_v0) {
        var record = _v0;
        return record.Ol;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$dueInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$dueInCents(shared);
    };
    var $author$project$Api$Provider$Statement$Shared$dueInCents = function(_v0) {
        var record = _v0;
        return record.Ol;
    };
    var $author$project$Api$Provider$Statement$One$dueInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$Shared$dueInCents(shared);
    };
    var $author$project$Components$DateInput$DatePickerMsg = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $agustinrhcp$elm_datepicker$DatePicker$formatCell = function(day) {
        return $elm$html$Html$text(day);
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Date$formatDay = function(day) {
        switch(day){
            case 0:
                return 'Mo';
            case 1:
                return 'Tu';
            case 2:
                return 'We';
            case 3:
                return 'Th';
            case 4:
                return 'Fr';
            case 5:
                return 'Sa';
            default:
                return 'Su';
        }
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Date$formatMonth = function(month) {
        switch(month){
            case 0:
                return 'January';
            case 1:
                return 'February';
            case 2:
                return 'March';
            case 3:
                return 'April';
            case 4:
                return 'May';
            case 5:
                return 'June';
            case 6:
                return 'July';
            case 7:
                return 'August';
            case 8:
                return 'September';
            case 9:
                return 'October';
            case 10:
                return 'November';
            default:
                return 'December';
        }
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Date$Off = {
        $: 0
    };
    var $agustinrhcp$elm_datepicker$DatePicker$off = $agustinrhcp$elm_datepicker$DatePicker$Date$Off;
    var $agustinrhcp$elm_datepicker$DatePicker$defaultSettings = {
        pS: $agustinrhcp$elm_datepicker$DatePicker$formatCell,
        hL: $agustinrhcp$elm_datepicker$DatePicker$off,
        lx: 'elm-datepicker--',
        ET: _List_Nil,
        acN: $justinmimbs$date$Date$format('yyyy-MM-dd'),
        acQ: $agustinrhcp$elm_datepicker$DatePicker$Date$formatDay,
        adQ: 6,
        Rj: _List_fromArray([
            $elm$html$Html$Attributes$required(false)
        ]),
        FO: _List_Nil,
        FP: $elm$core$Maybe$Nothing,
        FQ: $elm$core$Maybe$Nothing,
        aeC: $elm$core$Basics$always(false),
        zl: $agustinrhcp$elm_datepicker$DatePicker$Date$formatMonth,
        af$: $justinmimbs$date$Date$fromIsoString,
        r7: 'Please pick a date...',
        pi: $elm$core$String$fromInt
    };
    var $author$project$Components$DateInput$formatWeekday = function(weekday) {
        switch(weekday){
            case 0:
                return 'Mon';
            case 1:
                return 'Tue';
            case 2:
                return 'Wed';
            case 3:
                return 'Thu';
            case 4:
                return 'Fri';
            case 5:
                return 'Sat';
            default:
                return 'Sun';
        }
    };
    var $author$project$Components$DateInput$baseDatePickerSettings = function() {
        var defaultSettings_ = $agustinrhcp$elm_datepicker$DatePicker$defaultSettings;
        return _Utils_update(defaultSettings_, {
            acN: $justinmimbs$date$Date$format('MM/dd/yyyy'),
            acQ: $author$project$Components$DateInput$formatWeekday,
            FO: _List_fromArray([
                _Utils_Tuple2('form-control', true)
            ]),
            af$: $author$project$Utils$Date$fromUsString
        });
    }();
    var $agustinrhcp$elm_datepicker$DatePicker$CurrentDate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
    var $agustinrhcp$elm_datepicker$DatePicker$Day = 0;
    var $agustinrhcp$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
    var $justinmimbs$date$Date$fromPosix = F2(function(zone, posix) {
        return A3($justinmimbs$date$Date$fromCalendarDate, A2($elm$time$Time$toYear, zone, posix), A2($elm$time$Time$toMonth, zone, posix), A2($elm$time$Time$toDay, zone, posix));
    });
    var $elm$time$Time$here = _Time_here(0);
    var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
    var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
    var $agustinrhcp$elm_datepicker$DatePicker$init = _Utils_Tuple2({
        a8: $elm$core$Maybe$Just($agustinrhcp$elm_datepicker$DatePicker$Date$initDate),
        fM: false,
        cb: $elm$core$Maybe$Nothing,
        Vw: false,
        jv: 0,
        aae: $agustinrhcp$elm_datepicker$DatePicker$Date$initDate
    }, A2($elm$core$Task$perform, $agustinrhcp$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
    var $author$project$Components$DateInput$init = function() {
        var _v0 = $agustinrhcp$elm_datepicker$DatePicker$init;
        var datePicker = _v0.a;
        var datePickerCmd = _v0.b;
        return _Utils_Tuple2({
            lR: datePicker
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$DateInput$DatePickerMsg($author$project$Components$DateInput$baseDatePickerSettings), datePickerCmd));
    }();
    var $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource = function(_v0) {
        var record = _v0.b;
        return record.T1;
    };
    var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(function(ma, mb) {
        if (mb.$ === 1) return ma;
        else return mb;
    });
    var $author$project$Api$Employer$Invoice$One$source = function(_v0) {
        var record = _v0.b;
        return record.Hw;
    };
    var $author$project$Api$Provider$Invoice$One$source = function(_v0) {
        var record = _v0.b;
        return record.Hw;
    };
    var $author$project$Api$Invoice$One$source = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$source(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$source(invoice_);
        }
    };
    var $author$project$Api$Provider$CustomerInvoice$One$source = function(_v0) {
        var record = _v0.b;
        return record.Hw;
    };
    var $author$project$Api$Provider$PracticeInvoice$One$source = function(_v0) {
        var record = _v0.b;
        return record.Hw;
    };
    var $author$project$Components$Invoice$CreatePaymentModal$formFieldsFromPayable = F5(function(today, external, defaultExternalSource, allowMultipleMemberships, payable) {
        var _v0 = function() {
            switch(payable.$){
                case 0:
                    var practiceInvoice = payable.b;
                    return _Utils_Tuple2($author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice), A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)));
                case 1:
                    var invoice = payable.b;
                    return _Utils_Tuple2($author$project$Api$Invoice$One$dueInCents(invoice), A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Invoice$One$source(invoice)));
                case 2:
                    var invoice = payable.b;
                    return _Utils_Tuple2($author$project$Api$Invoice$One$dueInCents(invoice), A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Invoice$One$source(invoice)));
                case 3:
                    var invoice = payable.b;
                    return _Utils_Tuple2($author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice), allowMultipleMemberships ? A2($elm_community$maybe_extra$Maybe$Extra$orElse, A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$CustomerInvoice$One$source(invoice)), A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice))) : A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$CustomerInvoice$One$source(invoice)));
                default:
                    var statement = payable.b;
                    return _Utils_Tuple2($author$project$Api$Provider$Statement$One$dueInCents(statement), $elm$core$Maybe$Nothing);
            }
        }();
        var dueInCents = _v0.a;
        var defaultSource = _v0.b;
        var _v2 = $author$project$Components$DateInput$init;
        var dateInput = _v2.a;
        var dateInputCmd = _v2.b;
        return _Utils_Tuple2({
            Jh: $elm$core$Maybe$Just($author$project$Currency$fromInt(dueInCents)),
            cI: 0,
            ace: $elm$core$Maybe$Nothing,
            Po: external,
            mf: defaultExternalSource,
            mF: dueInCents,
            ae0: $elm$core$Maybe$Nothing,
            VQ: $elm$core$Maybe$Just(today),
            GN: dateInput,
            Hw: defaultSource,
            CK: false
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg(dateInput), dateInputCmd));
    });
    var $author$project$Ui$Form$SearchableSelect$init = function(_v0) {
        var id = _v0.aef;
        var toLabel = _v0.ahW;
        var toValue = _v0.g4;
        var toTitle = _v0.ahZ;
        return {
            dJ: $jinjor$elm_debounce$Debounce$init,
            aef: id,
            F7: toLabel,
            yw: toTitle,
            F8: toValue,
            yN: false,
            Vw: false,
            $Y: ''
        };
    };
    var $author$project$Api$BankAccount$EmployerAll = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Employer$BankAccount$bankAccountsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bank_accounts'
        ]), basePath);
    };
    var $author$project$Api$Employer$BankAccount$All$BankAccount = $elm$core$Basics$identity;
    var $author$project$Api$Employer$BankAccount$One$BankAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$BankAccount$Shared$BankAccount = $elm$core$Basics$identity;
    var $author$project$Api$Employer$BankAccount$Shared$Record = function(id) {
        return function(name) {
            return function(type_) {
                return function(lastFour) {
                    return function(status) {
                        return function(label) {
                            return function(errorMessage) {
                                return function(lastPaymentErrorMessage) {
                                    return function(createdAt) {
                                        return function(bankName) {
                                            return function(paymentProcessor) {
                                                return {
                                                    J6: bankName,
                                                    Mx: createdAt,
                                                    O4: errorMessage,
                                                    aef: id,
                                                    aeI: label,
                                                    ST: lastFour,
                                                    SV: lastPaymentErrorMessage,
                                                    zr: name,
                                                    Wo: paymentProcessor,
                                                    ahy: status,
                                                    ah5: type_
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$BankAccount$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bank_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_payment_error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_four', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$Shared$Record))))))))))));
    var $author$project$Api$Employer$BankAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$BankAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$BankAccount$One$Record = function(_default) {
        return {
            Nn: _default
        };
    };
    var $author$project$Api$Employer$BankAccount$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'default', $elm$json$Json$Decode$bool, false, $elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$One$Record));
    var $author$project$Api$Employer$BankAccount$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$BankAccount$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$BankAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$BankAccount$One$BankAccount)));
    var $author$project$Api$Employer$BankAccount$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$BankAccount$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$BankAccount$list = F3(function(basePath, apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$BankAccount$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$BankAccount$bankAccountsPath(basePath)));
    });
    var $author$project$Api$BankAccount$list = F4(function(basePath, apiClient, session, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$BankAccount$list, basePath, apiClient, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$BankAccount$EmployerAll)))) : A3($author$project$Api$Provider$BankAccount$list, basePath, apiClient, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$BankAccount$ProviderAll))));
    });
    var $author$project$Api$Card$EmployerAll = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Employer$Card$cardsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cards'
        ]), basePath);
    };
    var $author$project$Api$Employer$Card$All$Card = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Card$One$Card = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$Card$Shared$Card = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Card$Shared$Record = function(id) {
        return function(name) {
            return function(type_) {
                return function(lastFour) {
                    return function(status) {
                        return function(label) {
                            return function(errorMessage) {
                                return function(lastPaymentErrorMessage) {
                                    return function(expMonth) {
                                        return function(expYear) {
                                            return function(createdAt) {
                                                return function(cardType) {
                                                    return function(zip) {
                                                        return function(paymentProcessor) {
                                                            return {
                                                                KZ: cardType,
                                                                Mx: createdAt,
                                                                O4: errorMessage,
                                                                adz: expMonth,
                                                                adA: expYear,
                                                                aef: id,
                                                                aeI: label,
                                                                ST: lastFour,
                                                                SV: lastPaymentErrorMessage,
                                                                zr: name,
                                                                Wo: paymentProcessor,
                                                                ahy: status,
                                                                ah5: type_,
                                                                tK: zip
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$Card$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'zip', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'card_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exp_year', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exp_month', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_payment_error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_four', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$Shared$Record)))))))))))))));
    var $author$project$Api$Employer$Card$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Card$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Card$One$Record = function(_default) {
        return {
            Nn: _default
        };
    };
    var $author$project$Api$Employer$Card$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'default', $elm$json$Json$Decode$bool, false, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$One$Record));
    var $author$project$Api$Employer$Card$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Card$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Card$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Card$One$Card)));
    var $author$project$Api$Employer$Card$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Card$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Card$list = F3(function(basePath, apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$Card$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Card$cardsPath(basePath)));
    });
    var $author$project$Api$Card$list = F4(function(basePath, apiClient, session, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Card$list, basePath, apiClient, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Card$EmployerAll)))) : A3($author$project$Api$Provider$Card$list, basePath, apiClient, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Card$ProviderAll))));
    });
    var $author$project$Api$Employer$BankAccount$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$BankAccount$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$id(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$id(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$BankAccount$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$id(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$id(one);
    };
    var $author$project$Api$BankAccount$id = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$id(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$id(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$id(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$id(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$Card$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$id(shared);
    };
    var $author$project$Api$Employer$Card$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$id(one);
    };
    var $author$project$Api$Provider$Card$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Card$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$id(shared);
    };
    var $author$project$Api$Provider$Card$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$id(one);
    };
    var $author$project$Api$Card$id = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$id(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$id(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$id(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$id(card_);
        }
    };
    var $author$project$Api$Source$id = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$id(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$id(bankAccount);
            default:
                var source_ = source.a;
                return A2($elm$core$Maybe$withDefault, 'external', $author$project$Api$Common$Source$Shared$id(source_));
        }
    };
    var $author$project$Components$Invoice$CreatePaymentModal$paymentSourceToValue = function(source) {
        return $elm$core$Maybe$Just($author$project$Api$Source$id(source));
    };
    var $author$project$Components$Invoice$CreatePaymentModal$sourceName = function(source_) {
        var _v0 = $author$project$Api$Source$name(source_);
        if (!_v0.$) {
            var name = _v0.a;
            return $elm$core$Maybe$Just(name);
        } else return $author$project$Api$Source$type_(source_);
    };
    var $author$project$Components$Invoice$CreatePaymentModal$sourceLabel = F2(function(showProcessor, source) {
        return A2($elm$core$String$join, ' ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, source, $author$project$Api$Source$paymentProcessor),
            A2($elm$core$Maybe$map, $author$project$Formatters$String$titleize, $author$project$Components$Invoice$CreatePaymentModal$sourceName(source)),
            A2($elm$core$Maybe$map, function(lastFour) {
                return ' * ' + lastFour;
            }, $author$project$Api$Source$lastFour(source)),
            A2($elm$core$Maybe$map, function(funding) {
                return ' (' + (funding + ')');
            }, $author$project$Api$Source$funding(source))
        ])));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$viewCardReader = F2(function(showProcessor, cardReader) {
        return _List_fromArray([
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, showProcessor, showProcessor, cardReader, A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just))),
            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel, showProcessor, cardReader))
            ]))
        ]);
    });
    var $author$project$Components$Invoice$CreatePaymentModal$viewPaymentSource = F2(function(showProcessor, source) {
        return _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, showProcessor, showProcessor, source, $author$project$Api$Source$paymentProcessor)),
                function() {
                    var _v0 = $author$project$Components$Invoice$CreatePaymentModal$sourceName(source);
                    if (!_v0.$) {
                        var name = _v0.a;
                        return A2($elm$html$Html$strong, _List_fromArray([
                            $elm$html$Html$Attributes$class('inline')
                        ]), _List_fromArray([
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Formatters$String$titleize(name))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v1 = $author$project$Api$Source$lastFour(source);
                    if (!_v1.$) {
                        var lastFour = _v1.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('*' + lastFour)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v2 = $author$project$Api$Source$funding(source);
                    if (!_v2.$) {
                        var funding = _v2.a;
                        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('(' + (funding + ')'))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                A2($author$project$Ui$Badge$fromString, _List_Nil, A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Source$status(source))),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v3 = $author$project$Api$Source$label(source);
                    if (!_v3.$) {
                        var label = _v3.a;
                        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$em, _List_fromArray([
                                $elm$html$Html$Attributes$class('text-muted')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true),
                                    $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(label)
                                ]))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]);
    });
    var $author$project$Components$Invoice$CreatePaymentModal$init = function(today) {
        return function(timeFormatter) {
            return function(paymentPath) {
                return function(sourcePath) {
                    return function(apiClient) {
                        return function(session) {
                            return function(practice) {
                                return function(isHintAdmin) {
                                    return function(rainforestEnv) {
                                        return function(optionsBuilder) {
                                            return function(payable) {
                                                var options = optionsBuilder($author$project$Components$Invoice$CreatePaymentModal$defaultOptions);
                                                var displayModal = options.Po ? 1 : 0;
                                                var _v0 = function() {
                                                    var _v1 = _Utils_Tuple2(options.Po, sourcePath);
                                                    if (!_v1.a && !_v1.b.$) {
                                                        var sourcePath_ = _v1.b.a;
                                                        return _Utils_Tuple2($elm$core$Platform$Cmd$batch(_List_fromArray([
                                                            A4($author$project$Api$Card$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreatePaymentModal$GotCards),
                                                            A4($author$project$Api$BankAccount$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreatePaymentModal$GotBankAccounts)
                                                        ])), $author$project$Api$Data$Loading);
                                                    } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
                                                }();
                                                var sourceCmd = _v0.a;
                                                var sourceStatus = _v0.b;
                                                var _v2 = A5($author$project$Components$Invoice$CreatePaymentModal$formFieldsFromPayable, today, options.Po, options.Fc, $author$project$Api$Practice$allowMultipleRetailMemberships(practice), payable);
                                                var fields = _v2.a;
                                                var fieldsCmd = _v2.b;
                                                return _Utils_Tuple2({
                                                    pF: sourceStatus,
                                                    hI: $elm$core$Maybe$Nothing,
                                                    bU: $elm$core$Maybe$Nothing,
                                                    pO: $author$project$Ui$Form$SearchableSelect$init({
                                                        aef: 'card-reader-select',
                                                        ahW: $author$project$Components$Invoice$CreatePaymentModal$viewCardReader(options.or),
                                                        ahZ: $author$project$Components$Invoice$CreatePaymentModal$cardReaderLabel(options.or),
                                                        g4: $author$project$Components$Invoice$CreatePaymentModal$cardReaderToValue
                                                    }),
                                                    hJ: $author$project$Api$Data$NotAsked,
                                                    pQ: sourceStatus,
                                                    qn: displayModal,
                                                    PU: $author$project$Utils$Form$init(fields),
                                                    F3: isHintAdmin,
                                                    z9: options,
                                                    af5: payable,
                                                    ag: $author$project$Api$Data$NotAsked,
                                                    r_: paymentPath,
                                                    r1: $author$project$Ui$Form$SearchableSelect$init({
                                                        aef: 'source-select',
                                                        ahW: $author$project$Components$Invoice$CreatePaymentModal$viewPaymentSource(options.or),
                                                        ahZ: $author$project$Components$Invoice$CreatePaymentModal$sourceLabel(options.or),
                                                        g4: $author$project$Components$Invoice$CreatePaymentModal$paymentSourceToValue
                                                    }),
                                                    W1: practice,
                                                    sp: rainforestEnv,
                                                    Z$: session,
                                                    Hx: sourcePath,
                                                    HO: timeFormatter,
                                                    aae: today,
                                                    V: true
                                                }, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                    fieldsCmd,
                                                    sourceCmd
                                                ])));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$PracticeInvoice$issue = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeInvoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'issue'
        ]), $author$project$Api$Provider$PracticeInvoice$practiceInvoicePath(id_))));
    });
    var $author$project$Components$CardReader$ConnectingModal$Affiliate = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CardReader$ConnectingModal$BrokerAccount = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$CardReader = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$CardReaderSelectMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$Closed = 0;
    var $author$project$Components$CardReader$ConnectingModal$Company = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$None = 1;
    var $author$project$Components$Invoice$CreatePaymentModal$PaidAt = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CardReader$ConnectingModal$Patient = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$PaymentCreated = 2;
    var $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSelectMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CardReader$ConnectingModal$Practice = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$OutMsg$RefreshPatientsList = {
        $: 11
    };
    var $author$project$Components$Invoice$CreatePaymentModal$Source = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Payment$Shared$cardReader = function(_v0) {
        var record = _v0;
        return record.ace;
    };
    var $author$project$Api$Provider$Payment$One$cardReader = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$cardReader(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$cardReader = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$cardReader(shared);
    };
    var $author$project$Api$Payment$cardReader = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$cardReader(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$cardReader(payment_);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Invoice$CreatePaymentModal$CardCreated = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Card$EmployerOne = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Card$ProviderOne = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$PaymentProcessorParams$encode = function(param) {
        if (!param.$) {
            var stripeId = param.a;
            return _List_fromArray([
                _Utils_Tuple2('payment_processor', $elm$json$Json$Encode$string('stripe')),
                _Utils_Tuple2('stripe_id', $elm$json$Json$Encode$string(stripeId))
            ]);
        } else {
            var rainforestId = param.a;
            return _List_fromArray([
                _Utils_Tuple2('payment_processor', $elm$json$Json$Encode$string('rainforest')),
                _Utils_Tuple2('rainforest_id', $elm$json$Json$Encode$string(rainforestId))
            ]);
        }
    };
    var $author$project$Api$Employer$Card$create = F4(function(basePath, apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('card', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('card_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.KZ)), A2($elm$core$List$cons, _Utils_Tuple2('last_four', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ST)), A2($elm$core$List$cons, _Utils_Tuple2('created_via', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.MA)), $author$project$Api$PaymentProcessorParams$encode(fields.Wp))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$Card$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Employer$Card$cardsPath(basePath))));
    });
    var $author$project$Api$Provider$Card$create = F4(function(basePath, apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('card', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    _Utils_Tuple2('card_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.KZ)),
                    _Utils_Tuple2('last_four', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ST)),
                    _Utils_Tuple2('created_via', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.MA))
                ]),
                $author$project$Api$PaymentProcessorParams$encode(fields.Wp),
                function() {
                    var _v0 = fields.Vu;
                    if (!_v0.$) {
                        var oneTimeUse = _v0.a;
                        return _List_fromArray([
                            _Utils_Tuple2('one_time_use', $elm$json$Json$Encode$bool(oneTimeUse))
                        ]);
                    } else return _List_Nil;
                }()
            ]))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Card$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Card$cardsPath(basePath))));
    });
    var $author$project$Api$Card$create = F5(function(basePath, apiClient, session, fields, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Card$create, basePath, apiClient, {
            KZ: fields.KZ,
            MA: fields.MA,
            ST: fields.ST,
            Wp: fields.Wp
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A4($author$project$Api$Provider$Card$create, basePath, apiClient, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$createCard = F5(function(basePath, apiClient, session, formFields, readCard) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(basePath_) {
            return A5($author$project$Api$Card$create, basePath_, apiClient, session, {
                KZ: $elm$core$Maybe$Nothing,
                MA: $elm$core$Maybe$Just(readCard.MA),
                ST: $elm$core$Maybe$Nothing,
                Vu: $elm$core$Maybe$Just(readCard.Vu),
                Wp: readCard.Wp
            }, $author$project$Components$Invoice$CreatePaymentModal$CardCreated(formFields));
        }, basePath));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$Created = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreatePaymentModal$externalSourceCode = function(externalSource) {
        switch(externalSource){
            case 0:
                return 'check';
            case 1:
                return 'cash';
            case 2:
                return 'card';
            case 3:
                return 'eft';
            default:
                return 'other';
        }
    };
    var $author$project$Api$Employer$Invoice$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$Invoice$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$id(shared);
    };
    var $author$project$Api$Provider$Invoice$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Invoice$Shared$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Invoice$Min$id(min);
    };
    var $author$project$Api$Provider$Invoice$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$id(shared);
    };
    var $author$project$Api$Invoice$One$id = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$id(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$id(invoice_);
        }
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$id(shared);
    };
    var $author$project$Api$Provider$Statement$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Statement$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$Shared$id(shared);
    };
    var $author$project$Components$Invoice$CreatePaymentModal$payableIdAndKey = function(payable) {
        var payableKey = function() {
            switch(payable.$){
                case 0:
                    return 'practice_invoice_id';
                case 1:
                    return 'invoice_id';
                case 2:
                    return 'affiliate_bill_id';
                case 3:
                    return 'customer_invoice_id';
                default:
                    return 'statement_id';
            }
        }();
        var payableId = function() {
            switch(payable.$){
                case 0:
                    var practiceInvoice = payable.b;
                    return $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice);
                case 1:
                    var invoice = payable.b;
                    return $author$project$Api$Invoice$One$id(invoice);
                case 2:
                    var invoice = payable.b;
                    return $author$project$Api$Invoice$One$id(invoice);
                case 3:
                    var invoice = payable.b;
                    return $author$project$Api$Provider$CustomerInvoice$One$id(invoice);
                default:
                    var statement = payable.b;
                    return $author$project$Api$Provider$Statement$One$id(statement);
            }
        }();
        return _Utils_Tuple2(payableKey, payableId);
    };
    var $author$project$Components$Invoice$CreatePaymentModal$createPayment = F8(function(externalSource, basePath, apiClient, session, payable, formFields, cardReaderCard, cardReader) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var selectedSource = function() {
            if (externalSource) return $elm$core$Maybe$Just({
                aef: $elm$core$Maybe$Nothing,
                ah5: $elm$core$Maybe$Just($author$project$Components$Invoice$CreatePaymentModal$externalSourceCode(fields.mf))
            });
            else {
                var _v1 = _Utils_Tuple2(cardReaderCard, cardReader);
                if (_v1.a.$ === 1) {
                    if (_v1.b.$ === 1) {
                        var _v2 = _v1.a;
                        var _v3 = _v1.b;
                        return A2($elm$core$Maybe$map, function(source) {
                            return {
                                aef: $elm$core$Maybe$Just($author$project$Api$Source$id(source)),
                                ah5: $author$project$Api$Source$type_(source)
                            };
                        }, fields.Hw);
                    } else return $elm$core$Maybe$Nothing;
                } else {
                    var cardReaderCard_ = _v1.a.a;
                    return $elm$core$Maybe$Just({
                        aef: $elm$core$Maybe$Just($author$project$Api$Card$id(cardReaderCard_)),
                        ah5: $author$project$Api$Card$type_(cardReaderCard_)
                    });
                }
            }
        }();
        var _v0 = $author$project$Components$Invoice$CreatePaymentModal$payableIdAndKey(payable);
        var payableKey = _v0.a;
        var payableId = _v0.b;
        return A7($author$project$Api$Payment$create, basePath, apiClient, session, payableKey, payableId, {
            Jh: A2($elm$core$Maybe$withDefault, $author$project$Currency$fromInt(fields.mF), fields.Jh),
            ace: A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, cardReader),
            Po: fields.Po,
            ae0: fields.ae0,
            VQ: fields.VQ,
            ahd: $elm$core$Maybe$Nothing,
            ahe: $elm$core$Maybe$Nothing,
            Hw: selectedSource,
            aht: $elm$core$Maybe$Just(!fields.CK)
        }, $author$project$Components$Invoice$CreatePaymentModal$Created(formFields));
    });
    var $author$project$Api$Employer$Payment$Shared$external = function(_v0) {
        var record = _v0;
        return record.Po;
    };
    var $author$project$Api$Employer$Payment$One$external = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$external(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$external = function(_v0) {
        var record = _v0;
        return record.Po;
    };
    var $author$project$Api$Provider$Payment$One$external = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$external(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$external = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$external(shared);
    };
    var $author$project$Api$Payment$external = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$external(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$external(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$external(payment_);
        }
    };
    var $author$project$Components$Invoice$CreatePaymentModal$GotCardReaders = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$CardReader$cardReadersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'card_readers'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$CardReader$All$CardReader = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CardReader$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CardReader$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CardReader$listDefaults = {
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Provider$CardReader$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$CardReader$listDefaults);
        return $author$project$Api$Pagination$toApiParams(options.af_);
    };
    var $author$project$Api$Provider$CardReader$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CardReader$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$CardReader$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReadersPath)));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders = function(apiClient) {
        return A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Invoice$CreatePaymentModal$GotCardReaders);
    };
    var $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var _int = field.a;
                return _Utils_update(fields, {
                    Jh: _int
                });
            case 1:
                var dateInput = field.a;
                var date = field.b;
                return _Utils_update(fields, {
                    VQ: date,
                    GN: dateInput
                });
            case 2:
                var externalSource = field.a;
                return _Utils_update(fields, {
                    mf: externalSource
                });
            case 4:
                var source = field.a;
                return _Utils_update(fields, {
                    Hw: source
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    ae0: $author$project$Utils$String$toMaybe(string)
                });
            case 5:
                var cardReader = field.a;
                return _Utils_update(fields, {
                    ace: cardReader
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    CK: bool
                });
        }
    });
    var $author$project$Components$Invoice$CreatePaymentModal$CardReaderValidation = 1;
    var $author$project$Components$Invoice$CreatePaymentModal$AmountInCentsValidation = 0;
    var $author$project$Currency$isValid = F2(function(options, currency) {
        var _v0 = $author$project$Currency$toInt(currency);
        if (!_v0.$) {
            var _int = _v0.a;
            var _v1 = _Utils_Tuple2(options.Uj, options.y_);
            if (!_v1.a.$) {
                if (!_v1.b.$) {
                    var min = _v1.a.a;
                    var max = _v1.b.a;
                    return !(_Utils_cmp(_int, min) < 0 || _Utils_cmp(_int, max) > 0);
                } else {
                    var min = _v1.a.a;
                    var _v2 = _v1.b;
                    return _Utils_cmp(_int, min) > -1;
                }
            } else if (!_v1.b.$) {
                var _v3 = _v1.a;
                var max = _v1.b.a;
                return _Utils_cmp(_int, max) < 1;
            } else {
                var _v4 = _v1.a;
                var _v5 = _v1.b;
                return true;
            }
        } else return false;
    });
    var $author$project$Utils$Validate$isInvalidCurrency = F2(function(options, currency) {
        if (!currency.$) {
            var currency_ = currency.a;
            return !A2($author$project$Currency$isValid, {
                y_: options.y_,
                Uj: options.Uj
            }, currency_);
        } else return !options.abI;
    });
    var $author$project$Components$Invoice$CreatePaymentModal$validateAmountInCents = function(fields) {
        var min = fields.Po ? 0 : 50;
        var max = fields.mF;
        return A2($author$project$Utils$Validate$isInvalidCurrency, {
            abI: false,
            y_: $elm$core$Maybe$Just(max),
            Uj: $elm$core$Maybe$Just(min)
        }, fields.Jh) ? _List_fromArray([
            _Utils_Tuple2(0, 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
        ]) : _List_Nil;
    };
    var $author$project$Components$Invoice$CreatePaymentModal$SourceValidation = 2;
    var $author$project$Components$Invoice$CreatePaymentModal$validateSource = function(fields) {
        return !fields.Po && _Utils_eq(fields.Hw, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(2, 'Please pick a source.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Invoice$CreatePaymentModal$formFieldsValidator = function(useExistingSources) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreatePaymentModal$validateAmountInCents),
            useExistingSources ? $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreatePaymentModal$validateSource) : A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.ace;
            }, _Utils_Tuple2(1, 'Please pick a card reader.'))
        ]));
    };
    var $author$project$Ports$LocalStorage$localStorageGetItemPort = _Platform_outgoingPort('localStorageGetItemPort', $elm$json$Json$Encode$string);
    var $author$project$Ports$LocalStorage$getItem = function(key) {
        return $author$project$Ports$LocalStorage$localStorageGetItemPort(key);
    };
    var $author$project$Components$CardReader$ConnectingModal$Connecting = 0;
    var $author$project$Components$CardReader$ConnectingModal$GotConnectionToken = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CardReader$ConnectingModal$GotReadCardResponse = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$CardReader$ConnectingModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$CardReader$ConnectingModal$Rainforest = 1;
    var $author$project$Components$CardReader$ConnectingModal$Stripe = 0;
    var $author$project$Api$Provider$CardReader$getConnectionToken = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, A2($elm$json$Json$Decode$at, _List_fromArray([
            'token'
        ]), $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'connection_token'
        ]), $author$project$Api$Provider$CardReader$cardReadersPath)));
    });
    var $author$project$Components$CardReader$SimulateForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$CardReader$SimulateForm$initFormFields = {
        acd: $elm$core$Maybe$Just('VISA_SUCCESS'),
        adu: $elm$core$Maybe$Just('PRESENTED')
    };
    var $author$project$Components$CardReader$SimulateForm$init = F2(function(session, cardReaderId) {
        return {
            fe: cardReaderId,
            PU: $author$project$Utils$Form$init($author$project$Components$CardReader$SimulateForm$initFormFields),
            Z$: session,
            oy: $author$project$Api$Data$NotAsked
        };
    });
    var $author$project$Rainforest$isSandbox = function(env) {
        if (!env.$) {
            if (env.a === 1) {
                var _v1 = env.a;
                return true;
            } else {
                var _v2 = env.a;
                return false;
            }
        } else return false;
    };
    var $author$project$Api$Provider$CardReader$cardReaderPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$CardReader$cardReadersPath);
    };
    var $author$project$Api$Provider$CardReader$readCard = F5(function(apiClient, id, ownerType, ownerId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('owner', $author$project$Utils$Encode$typedAssociation({
                aef: $elm$core$Maybe$Just(ownerId),
                ah5: $elm$core$Maybe$Just(ownerType)
            }))
        ]));
        return A4($author$project$Api$Data$post, apiClient, A2($elm$json$Json$Decode$at, _List_fromArray([
            'payment_method_id'
        ]), $elm$json$Json$Decode$string), toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'read_card'
        ]), $author$project$Api$Provider$CardReader$cardReaderPath(id)))));
    });
    var $author$project$Components$CardReader$ConnectingModal$init = F7(function(apiClient, session, isHintAdmin, rainforestEnv, cardReader, owner, storeCard) {
        var _v0 = function() {
            if ($author$project$Api$Provider$CardReader$All$paymentProcessor(cardReader) === 'rainforest') {
                var _v1 = function() {
                    switch(owner.$){
                        case 0:
                            var companyId = owner.a;
                            return _Utils_Tuple2('company', companyId);
                        case 1:
                            var patientId = owner.a;
                            return _Utils_Tuple2('patient', patientId);
                        case 2:
                            var practiceId = owner.a;
                            return _Utils_Tuple2('practice', practiceId);
                        case 3:
                            var brokerAccountId = owner.a;
                            return _Utils_Tuple2('broker_account', brokerAccountId);
                        default:
                            var affiliateId = owner.a;
                            return _Utils_Tuple2('affiliate', affiliateId);
                    }
                }();
                var ownerType = _v1.a;
                var ownerId = _v1.b;
                return _Utils_Tuple3(1, 0, A5($author$project$Api$Provider$CardReader$readCard, apiClient, $author$project$Api$Provider$CardReader$All$id(cardReader), ownerType, ownerId, $author$project$Components$CardReader$ConnectingModal$GotReadCardResponse));
            } else return _Utils_Tuple3(0, 0, A2($author$project$Api$Provider$CardReader$getConnectionToken, apiClient, $author$project$Components$CardReader$ConnectingModal$GotConnectionToken));
        }();
        var paymentProcessor = _v0.a;
        var connectionStatus = _v0.b;
        var connectionCmd = _v0.c;
        var simulateForm = paymentProcessor === 1 && isHintAdmin && $author$project$Rainforest$isSandbox(rainforestEnv) ? $elm$core$Maybe$Just(A2($author$project$Components$CardReader$SimulateForm$init, session, $author$project$Api$Provider$CardReader$All$id(cardReader))) : $elm$core$Maybe$Nothing;
        return _Utils_Tuple2({
            cF: false,
            ace: cardReader,
            dC: connectionStatus,
            p_: $author$project$Api$Data$Loading,
            Wo: paymentProcessor,
            s$: simulateForm,
            CK: storeCard
        }, connectionCmd);
    });
    var $author$project$Components$CardReader$PaymentModal$Connecting = 0;
    var $author$project$Components$CardReader$PaymentModal$GotReadPaymentResponse = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CardReader$PaymentModal$Model = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Payment$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$Payment$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$id(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Payment$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$id(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$id(shared);
    };
    var $author$project$Api$Payment$id = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$id(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$id(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$id(payment_);
        }
    };
    var $author$project$Api$Provider$CardReader$readPayment = F4(function(apiClient, id, paymentId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment_id', $elm$json$Json$Encode$string(paymentId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Payment$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'read_payment'
        ]), $author$project$Api$Provider$CardReader$cardReaderPath(id)))));
    });
    var $author$project$Api$CardReader$readPayment = F5(function(apiClient, session, id, paymentId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$CardReader$readPayment, apiClient, id, paymentId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Payment$Provider_One)));
    });
    var $author$project$Components$CardReader$PaymentModal$init = F6(function(apiClient, session, isHintAdmin, rainforestEnv, cardReaderId, payment) {
        var simulateForm = isHintAdmin && $author$project$Rainforest$isSandbox(rainforestEnv) ? $elm$core$Maybe$Just(A2($author$project$Components$CardReader$SimulateForm$init, session, cardReaderId)) : $elm$core$Maybe$Nothing;
        var _v0 = _Utils_Tuple2(0, A5($author$project$Api$CardReader$readPayment, apiClient, session, cardReaderId, $author$project$Api$Payment$id(payment), $author$project$Components$CardReader$PaymentModal$GotReadPaymentResponse));
        var connectionStatus = _v0.a;
        var connectionCmd = _v0.b;
        return _Utils_Tuple2({
            cF: false,
            fe: cardReaderId,
            dC: connectionStatus,
            p_: $author$project$Api$Data$Loading,
            Wk: payment,
            Z$: session,
            s$: simulateForm
        }, connectionCmd);
    });
    var $elm$core$Tuple$mapBoth = F3(function(funcA, funcB, _v0) {
        var x = _v0.a;
        var y = _v0.b;
        return _Utils_Tuple2(funcA(x), funcB(y));
    });
    var $author$project$Api$Employer$Practice$One$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Practice$paymentProcessor = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$paymentProcessor(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$paymentProcessor(practice_);
        }
    };
    var $author$project$Api$Provider$Practice$Shared$usesCardReaders = function(_v0) {
        var record = _v0;
        return record.aa$;
    };
    var $author$project$Api$Provider$Practice$One$usesCardReaders = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$usesCardReaders(shared);
    };
    var $author$project$Api$Practice$usesCardReaders = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$usesCardReaders(practice_);
        } else return false;
    };
    var $author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch = F3(function(apiClient, response, model) {
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(model.pQ, model.pF);
            if (_v1.a.$ === 3 && _v1.b.$ === 3) {
                var _v2 = _v1.a;
                var cards = _v2.a;
                var _v3 = _v1.b;
                var bankAccounts = _v3.a;
                var useCardReader = $elm$core$List$isEmpty(cards) && $elm$core$List$isEmpty(bankAccounts) && $author$project$Api$Practice$usesCardReaders(model.W1) && !$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$);
                return _Utils_Tuple3(!useCardReader, useCardReader ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked, useCardReader ? $author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders(apiClient) : $elm$core$Platform$Cmd$none);
            } else return _Utils_Tuple3(model.V, model.hJ, $elm$core$Platform$Cmd$none);
        }();
        var useExistingSources = _v0.a;
        var cardReaders = _v0.b;
        var cmd = _v0.c;
        return {
            EQ: cmd,
            adu: 1,
            zi: _Utils_update(model, {
                hJ: cardReaders,
                V: useExistingSources
            }),
            at: $author$project$OutMsg$handleErrorResponse(response)
        };
    });
    var $author$project$Api$Employer$Payment$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Employer$Payment$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$status(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Payment$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$status(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$status(shared);
    };
    var $author$project$Api$Payment$status = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$status(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$status(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$status(payment_);
        }
    };
    var $author$project$Components$CardReader$ConnectingModal$CardRead = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CardReader$ConnectingModal$Closed = {
        $: 0
    };
    var $author$project$Components$CardReader$ConnectingModal$Connected = 1;
    var $author$project$Components$CardReader$ConnectingModal$GotCardReader = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CardReader$ConnectingModal$GotReportCardReadStatus = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CardReader$ConnectingModal$None = {
        $: 2
    };
    var $author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$CardReader$ConnectingModal$SimulateFormMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$CardReader$cancelReadCard = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel_read_card'
        ]), $author$project$Api$Provider$CardReader$cardReaderPath(id))));
    });
    var $author$project$Ports$StripeTerminal$stripeTerminalPortCancelReadReusableCard = _Platform_outgoingPort('stripeTerminalPortCancelReadReusableCard', $elm$json$Json$Encode$string);
    var $author$project$Ports$StripeTerminal$cancelReadReusableCard = $author$project$Ports$StripeTerminal$stripeTerminalPortCancelReadReusableCard;
    var $author$project$Ports$StripeTerminal$stripeTerminalPortConnectReader = _Platform_outgoingPort('stripeTerminalPortConnectReader', function($) {
        var a = $.a;
        var b = $.b;
        return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([
            $elm$json$Json$Encode$string(a),
            function($) {
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('device_sw_version', $elm$json$Json$Encode$string($.ac7)),
                    _Utils_Tuple2('device_type', $elm$json$Json$Encode$string($.ac8)),
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string($.aef)),
                    _Utils_Tuple2('ip_address', $elm$json$Json$Encode$string($.aeA)),
                    _Utils_Tuple2('label', $elm$json$Json$Encode$string($.aeI)),
                    _Utils_Tuple2('livemode', $elm$json$Json$Encode$bool($.aeP)),
                    _Utils_Tuple2('location', $elm$json$Json$Encode$string($.aeT)),
                    _Utils_Tuple2('object', $elm$json$Json$Encode$string($.afq)),
                    _Utils_Tuple2('serial_number', $elm$json$Json$Encode$string($.ahh)),
                    _Utils_Tuple2('status', $elm$json$Json$Encode$string($.ahy))
                ]));
            }(b)
        ]));
    });
    var $author$project$Ports$StripeTerminal$connectReader = F2(function(token, stripeObject) {
        return $author$project$Ports$StripeTerminal$stripeTerminalPortConnectReader(_Utils_Tuple2(token, stripeObject));
    });
    var $author$project$Ports$StripeTerminal$stripeTerminalPortCreate = _Platform_outgoingPort('stripeTerminalPortCreate', $elm$json$Json$Encode$string);
    var $author$project$Ports$StripeTerminal$create = $author$project$Ports$StripeTerminal$stripeTerminalPortCreate;
    var $author$project$Ports$StripeTerminal$stripeTerminalPortClearCachedCredentials = _Platform_outgoingPort('stripeTerminalPortClearCachedCredentials', $elm$json$Json$Encode$string);
    var $author$project$Ports$StripeTerminal$clearCachedCredentials = $author$project$Ports$StripeTerminal$stripeTerminalPortClearCachedCredentials;
    var $author$project$Ports$StripeTerminal$stripeTerminalPortDisconnectReader = _Platform_outgoingPort('stripeTerminalPortDisconnectReader', $elm$json$Json$Encode$string);
    var $author$project$Ports$StripeTerminal$disconnectReader = $author$project$Ports$StripeTerminal$stripeTerminalPortDisconnectReader;
    var $author$project$Components$CardReader$ConnectingModal$disconnectReader = F4(function(apiClient, model, cmd, event) {
        return {
            EQ: function() {
                var _v0 = _Utils_Tuple2(model.Wo, model.p_);
                if (!_v0.a) {
                    if (_v0.b.$ === 3) {
                        var _v1 = _v0.a;
                        var _v2 = _v0.b;
                        var token = _v2.a;
                        return $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Ports$StripeTerminal$disconnectReader(token),
                            $author$project$Ports$StripeTerminal$clearCachedCredentials(token),
                            cmd
                        ]));
                    } else return cmd;
                } else {
                    var _v3 = _v0.a;
                    return $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A3($author$project$Api$Provider$CardReader$cancelReadCard, apiClient, $author$project$Api$Provider$CardReader$All$id(model.ace), $author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
                        cmd
                    ]));
                }
            }(),
            adu: A2($elm$core$Maybe$withDefault, $author$project$Components$CardReader$ConnectingModal$Closed, event),
            zi: _Utils_update(model, {
                cF: false,
                dC: 0
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$CardReader$ConnectingModal$handleStripeFailure = F3(function(apiClient, model, error) {
        var result = A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        var messge = A2($elm$core$String$contains, 'Action canceled.', error) ? $elm$core$Maybe$Nothing : A2($elm$core$String$contains, 'Invalid object shape', error) ? $elm$core$Maybe$Just('We are having trouble talking to the reader, please reach out for help.') : $elm$core$Maybe$Just(error);
        var outMsgs = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$OutMsg$ShowToast(1), $elm$core$List$singleton), messge));
        return _Utils_update(result, {
            at: outMsgs
        });
    });
    var $author$project$Components$CardReader$ConnectingModal$PollCardReadStatus = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CardReader$ConnectingModal$pollReadCardStatus = F2(function(cardReader, paymentMethodId) {
        return A2($elm$core$Task$perform, function(_v0) {
            return A2($author$project$Components$CardReader$ConnectingModal$PollCardReadStatus, cardReader, paymentMethodId);
        }, $elm$core$Process$sleep(2000));
    });
    var $author$project$Api$PaymentProcessorParams$RainforestParams = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$PaymentProcessorParams$rainforestParams = $author$project$Api$PaymentProcessorParams$RainforestParams;
    var $author$project$Api$Provider$CardReader$ReadStatus = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Provider$CardReader$readCardStatusDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$ReadStatus));
    var $author$project$Api$Provider$CardReader$readCardStatus = F4(function(apiClient, id, paymentMethodId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CardReader$readCardStatusDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'payment_method_id', paymentMethodId)
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'read_card_status'
        ]), $author$project$Api$Provider$CardReader$cardReaderPath(id)))));
    });
    var $author$project$Ports$StripeTerminal$stripeTerminalPortReadReusableCard = _Platform_outgoingPort('stripeTerminalPortReadReusableCard', $elm$json$Json$Encode$string);
    var $author$project$Ports$StripeTerminal$readReusableCard = $author$project$Ports$StripeTerminal$stripeTerminalPortReadReusableCard;
    var $author$project$Api$Provider$CardReader$One$CardReader = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CardReader$One$Record = function(stripeObject) {
        return {
            $k: stripeObject
        };
    };
    var $author$project$Api$Provider$CardReader$One$StripeObject = function(device_sw_version) {
        return function(device_type) {
            return function(id) {
                return function(ip_address) {
                    return function(label) {
                        return function(livemode) {
                            return function(location1) {
                                return function(object) {
                                    return function(serial_number) {
                                        return function(status) {
                                            return {
                                                ac7: device_sw_version,
                                                ac8: device_type,
                                                aef: id,
                                                aeA: ip_address,
                                                aeI: label,
                                                aeP: livemode,
                                                aeT: location1,
                                                afq: object,
                                                ahh: serial_number,
                                                ahy: status
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CardReader$One$stripeObjectDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'serial_number', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'object', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'livemode', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ip_address', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'device_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'device_sw_version', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$One$StripeObject)))))))))));
    var $author$project$Api$Provider$CardReader$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_object', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CardReader$One$stripeObjectDecoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReader$One$Record));
    var $author$project$Api$Provider$CardReader$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CardReader$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CardReader$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CardReader$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReaderPath(id)));
    });
    var $author$project$Ports$LocalStorage$localStorageSetItemPort = _Platform_outgoingPort('localStorageSetItemPort', function($) {
        var a = $.a;
        var b = $.b;
        return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([
            $elm$json$Json$Encode$string(a),
            $elm$json$Json$Encode$string(b)
        ]));
    });
    var $author$project$Ports$LocalStorage$setItem = F2(function(key, value) {
        return $author$project$Ports$LocalStorage$localStorageSetItemPort(_Utils_Tuple2(key, value));
    });
    var $author$project$Api$Provider$CardReader$One$stripeObject = function(_v0) {
        var record = _v0;
        return record.$k;
    };
    var $author$project$Api$PaymentProcessorParams$StripeParams = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$PaymentProcessorParams$stripeParams = $author$project$Api$PaymentProcessorParams$StripeParams;
    var $author$project$Components$CardReader$SimulateForm$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var event = field.a;
            return _Utils_update(fields, {
                adu: $author$project$Utils$String$toMaybe(event)
            });
        } else {
            var card = field.a;
            return _Utils_update(fields, {
                acd: $author$project$Utils$String$toMaybe(card)
            });
        }
    });
    var $author$project$Components$CardReader$SimulateForm$CardValidation = 1;
    var $author$project$Components$CardReader$SimulateForm$EventValidation = 0;
    var $author$project$Components$CardReader$SimulateForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.adu;
        }, _Utils_Tuple2(0, 'Please pick an event.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.acd;
        }, _Utils_Tuple2(1, 'Please pick a card.'))
    ]));
    var $author$project$Components$CardReader$SimulateForm$GotSimulateResponse = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$CardReader$simulateDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'success'
    ]), $elm$json$Json$Decode$bool);
    var $author$project$Api$Provider$CardReader$simulate = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('event', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.adu)),
            _Utils_Tuple2('card', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.acd))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CardReader$simulateDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'simulate'
        ]), $author$project$Api$Provider$CardReader$cardReaderPath(id)))));
    });
    var $author$project$Api$CardReader$simulate = F5(function(apiClient, session, id, params, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$CardReader$simulate, apiClient, id, params, toMsg);
    });
    var $author$project$Components$CardReader$SimulateForm$simulate = F4(function(apiClient, session, cardReaderId, validSimulateFormFields) {
        return A5($author$project$Api$CardReader$simulate, apiClient, session, cardReaderId, $rtfeldman$elm_validate$Validate$fromValid(validSimulateFormFields), $author$project$Components$CardReader$SimulateForm$GotSimulateResponse);
    });
    var $author$project$Components$CardReader$SimulateForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CardReader$SimulateForm$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CardReader$SimulateForm$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm,
                        oy: $author$project$Api$Data$Loading
                    }), A4($author$project$Components$CardReader$SimulateForm$simulate, apiClient, model.Z$, model.fe, validFormFields), _List_Nil);
                } else {
                    var newForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var success = response.a;
                    var _v5 = success ? _Utils_Tuple2(3, 'Simulation success') : _Utils_Tuple2(1, 'Simulation failed');
                    var toastLevel = _v5.a;
                    var toastMessage = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        oy: response
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, toastLevel, toastMessage)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    oy: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
        }
    });
    var $author$project$Components$CardReader$ConnectingModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var _v2 = _Utils_Tuple3(model.Wo, model.dC, model.p_);
                if (!_v2.a) {
                    if (!_v2.b) {
                        var _v3 = _v2.a;
                        var _v4 = _v2.b;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$CardReader$ConnectingModal$None,
                            zi: _Utils_update(model, {
                                cF: true
                            }),
                            at: _List_Nil
                        };
                    } else {
                        if (_v2.c.$ === 3) {
                            var _v7 = _v2.a;
                            var _v8 = _v2.c;
                            var token = _v8.a;
                            return {
                                EQ: $author$project$Ports$StripeTerminal$cancelReadReusableCard(token),
                                adu: $author$project$Components$CardReader$ConnectingModal$None,
                                zi: model,
                                at: _List_Nil
                            };
                        } else return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$CardReader$ConnectingModal$Closed,
                            zi: model,
                            at: _List_Nil
                        };
                    }
                } else if (!_v2.b) {
                    var _v5 = _v2.a;
                    var _v6 = _v2.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$CardReader$ConnectingModal$None,
                        zi: _Utils_update(model, {
                            cF: true
                        }),
                        at: _List_Nil
                    };
                } else {
                    var _v9 = _v2.a;
                    var _v10 = _v2.b;
                    return {
                        EQ: A3($author$project$Api$Provider$CardReader$cancelReadCard, apiClient, $author$project$Api$Provider$CardReader$All$id(model.ace), $author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
                        adu: $author$project$Components$CardReader$ConnectingModal$None,
                        zi: _Utils_update(model, {
                            cF: true
                        }),
                        at: _List_Nil
                    };
                }
            case 1:
                var response = msg.a;
                var _v11 = _Utils_Tuple2(model.Wo, response);
                if (!_v11.a && _v11.b.$ === 3) {
                    var _v12 = _v11.a;
                    var _v13 = _v11.b;
                    var token = _v13.a;
                    return {
                        EQ: $author$project$Ports$StripeTerminal$create(token),
                        adu: $author$project$Components$CardReader$ConnectingModal$None,
                        zi: _Utils_update(model, {
                            p_: response
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CardReader$ConnectingModal$Closed,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 9:
                var response = msg.a;
                if (response.$ === 3) {
                    var paymentMethodId = response.a;
                    return model.cF ? A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
                        EQ: A2($author$project$Components$CardReader$ConnectingModal$pollReadCardStatus, model.ace, paymentMethodId),
                        adu: $author$project$Components$CardReader$ConnectingModal$None,
                        zi: _Utils_update(model, {
                            dC: 1
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: A3($author$project$Api$Provider$CardReader$cancelReadCard, apiClient, $author$project$Api$Provider$CardReader$All$id(model.ace), $author$project$Components$CardReader$ConnectingModal$RainforestReadReusableCardCancelled),
                    adu: $author$project$Components$CardReader$ConnectingModal$Closed,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 2:
                var token = msg.a;
                return {
                    EQ: A3($author$project$Api$Provider$CardReader$retrieve, apiClient, $author$project$Api$Provider$CardReader$All$id(model.ace), $author$project$Components$CardReader$ConnectingModal$GotCardReader(token)),
                    adu: $author$project$Components$CardReader$ConnectingModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 3:
                var token = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var cardReader = response.a;
                    var _v16 = function() {
                        var _v17 = _Utils_Tuple2(model.Wo, $author$project$Api$Provider$CardReader$One$stripeObject(cardReader));
                        if (!_v17.a) {
                            if (!_v17.b.$) {
                                var _v18 = _v17.a;
                                var stripeObject = _v17.b.a;
                                return _Utils_Tuple2(0, A2($author$project$Ports$StripeTerminal$connectReader, token, stripeObject));
                            } else {
                                var _v19 = _v17.a;
                                var _v20 = _v17.b;
                                return _Utils_Tuple2(0, $elm$core$Platform$Cmd$none);
                            }
                        } else {
                            var _v21 = _v17.a;
                            return _Utils_Tuple2(1, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var connectionStatus = _v16.a;
                    var cmd = _v16.b;
                    return {
                        EQ: cmd,
                        adu: $author$project$Components$CardReader$ConnectingModal$None,
                        zi: _Utils_update(model, {
                            dC: connectionStatus
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CardReader$ConnectingModal$Closed,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var token = msg.a;
                var result = msg.b;
                if (!result.$) return model.cF ? A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
                    EQ: $author$project$Ports$StripeTerminal$readReusableCard(token),
                    adu: $author$project$Components$CardReader$ConnectingModal$None,
                    zi: _Utils_update(model, {
                        dC: 1
                    }),
                    at: _List_Nil
                };
                else {
                    var error = result.a;
                    return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
                }
            case 5:
                var cardReadResult = msg.b;
                if (!cardReadResult.$) {
                    var paymentMethodId = cardReadResult.a;
                    var readCard = {
                        MA: 'via_card_reader',
                        Vu: !model.CK,
                        Wp: $author$project$Api$PaymentProcessorParams$stripeParams(paymentMethodId)
                    };
                    return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, A2($author$project$Ports$LocalStorage$setItem, 'last-used-card-reader', $author$project$Api$Provider$CardReader$All$id(model.ace)), $elm$core$Maybe$Just($author$project$Components$CardReader$ConnectingModal$CardRead(readCard)));
                } else {
                    var error = cardReadResult.a;
                    return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
                }
            case 6:
                var result = msg.b;
                if (!result.$) return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                else {
                    var error = result.a;
                    return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
                }
            case 7:
                var response = msg.a;
                if (response.$ === 3) return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CardReader$ConnectingModal$Closed,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 8:
                var error = msg.a;
                return A3($author$project$Components$CardReader$ConnectingModal$handleStripeFailure, apiClient, model, error);
            case 10:
                var cardReader = msg.a;
                var paymentMethodId = msg.b;
                return {
                    EQ: A4($author$project$Api$Provider$CardReader$readCardStatus, apiClient, $author$project$Api$Provider$CardReader$All$id(cardReader), paymentMethodId, $author$project$Components$CardReader$ConnectingModal$GotReportCardReadStatus(paymentMethodId)),
                    adu: $author$project$Components$CardReader$ConnectingModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 11:
                var paymentMethodId = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var cardReadStatus = response.a;
                    var _v27 = cardReadStatus.ahy;
                    switch(_v27){
                        case 'active':
                            var readCard = {
                                MA: 'via_card_reader',
                                Vu: !model.CK,
                                Wp: $author$project$Api$PaymentProcessorParams$rainforestParams(paymentMethodId)
                            };
                            return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, A2($author$project$Ports$LocalStorage$setItem, 'last-used-card-reader', $author$project$Api$Provider$CardReader$All$id(model.ace)), $elm$core$Maybe$Just($author$project$Components$CardReader$ConnectingModal$CardRead(readCard)));
                        case 'canceled':
                            return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                        case 'failed':
                            return A4($author$project$Components$CardReader$ConnectingModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                        default:
                            return {
                                EQ: A2($author$project$Components$CardReader$ConnectingModal$pollReadCardStatus, model.ace, paymentMethodId),
                                adu: $author$project$Components$CardReader$ConnectingModal$None,
                                zi: model,
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CardReader$ConnectingModal$None,
                    zi: model,
                    at: $author$project$OutMsg$reportDecodeError(response)
                };
            default:
                var subMsg = msg.a;
                var _v28 = model.s$;
                if (!_v28.$) {
                    var simulateForm = _v28.a;
                    var _v29 = A3($author$project$Components$CardReader$SimulateForm$update, apiClient, subMsg, simulateForm);
                    var simulateForm_ = _v29.a;
                    var simulateFormCmd = _v29.b;
                    var simulateFormOutMsgs = _v29.c;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CardReader$ConnectingModal$SimulateFormMsg, simulateFormCmd),
                        adu: $author$project$Components$CardReader$ConnectingModal$None,
                        zi: _Utils_update(model, {
                            s$: $elm$core$Maybe$Just(simulateForm_)
                        }),
                        at: simulateFormOutMsgs
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CardReader$ConnectingModal$None,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$CardReader$PaymentModal$Closed = 0;
    var $author$project$Components$CardReader$PaymentModal$Connected = 1;
    var $author$project$Components$CardReader$PaymentModal$GotReportPaymentReadStatus = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CardReader$PaymentModal$None = 4;
    var $author$project$Components$CardReader$PaymentModal$PaymentRead = 1;
    var $author$project$Components$CardReader$PaymentModal$PaymentReadCancelled = 3;
    var $author$project$Components$CardReader$PaymentModal$PaymentReadFailed = 2;
    var $author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CardReader$PaymentModal$SimulateFormMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$CardReader$cancelReadPayment = F4(function(apiClient, id, paymentId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment_id', $elm$json$Json$Encode$string(paymentId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel_read_payment'
        ]), $author$project$Api$Provider$CardReader$cardReaderPath(id)))));
    });
    var $author$project$Api$CardReader$cancelReadPayment = F5(function(apiClient, session, id, paymentId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$CardReader$cancelReadPayment, apiClient, id, paymentId, toMsg);
    });
    var $author$project$Components$CardReader$PaymentModal$disconnectReader = F4(function(apiClient, model, cmd, event) {
        return {
            EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                A5($author$project$Api$CardReader$cancelReadPayment, apiClient, model.Z$, model.fe, $author$project$Api$Payment$id(model.Wk), $author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
                cmd
            ])),
            adu: A2($elm$core$Maybe$withDefault, 0, event),
            zi: _Utils_update(model, {
                cF: false,
                dC: 0
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$CardReader$PaymentModal$PollPaymentReadStatus = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus = function(cardReaderId) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Components$CardReader$PaymentModal$PollPaymentReadStatus(cardReaderId);
        }, $elm$core$Process$sleep(2000));
    };
    var $author$project$Api$Provider$CardReader$readPaymentStatus = F4(function(apiClient, id, paymentId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Payment$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'payment_id', paymentId)
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'read_payment_status'
        ]), $author$project$Api$Provider$CardReader$cardReaderPath(id)))));
    });
    var $author$project$Api$CardReader$readPaymentStatus = F5(function(apiClient, session, id, paymentId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$CardReader$readPaymentStatus, apiClient, id, paymentId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Payment$Provider_One)));
    });
    var $author$project$Components$CardReader$PaymentModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var _v2 = _Utils_Tuple2(model.dC, model.p_);
                if (!_v2.a) {
                    var _v3 = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 4,
                        zi: _Utils_update(model, {
                            cF: true
                        }),
                        at: _List_Nil
                    };
                } else {
                    var _v4 = _v2.a;
                    return {
                        EQ: A5($author$project$Api$CardReader$cancelReadPayment, apiClient, model.Z$, model.fe, $author$project$Api$Payment$id(model.Wk), $author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
                        adu: 4,
                        zi: _Utils_update(model, {
                            cF: true
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) return model.cF ? A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing) : {
                    EQ: $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus(model.fe),
                    adu: 4,
                    zi: _Utils_update(model, {
                        dC: 1
                    }),
                    at: _List_Nil
                };
                else return {
                    EQ: A5($author$project$Api$CardReader$cancelReadPayment, apiClient, model.Z$, model.fe, $author$project$Api$Payment$id(model.Wk), $author$project$Components$CardReader$PaymentModal$ReadPaymentCancelled),
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                var response = msg.a;
                if (response.$ === 3) return A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var cardReaderId = msg.a;
                return {
                    EQ: A5($author$project$Api$CardReader$readPaymentStatus, apiClient, model.Z$, cardReaderId, $author$project$Api$Payment$id(model.Wk), $author$project$Components$CardReader$PaymentModal$GotReportPaymentReadStatus),
                    adu: 4,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var payment = response.a;
                    var _v8 = $author$project$Api$Payment$status(payment);
                    switch(_v8){
                        case 'paid':
                            return A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, A2($author$project$Ports$LocalStorage$setItem, 'last-used-card-reader', model.fe), $elm$core$Maybe$Just(1));
                        case 'cancelled':
                            return A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(3));
                        case 'failed':
                            return A4($author$project$Components$CardReader$PaymentModal$disconnectReader, apiClient, model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(2));
                        default:
                            return {
                                EQ: $author$project$Components$CardReader$PaymentModal$pollReadPaymentStatus(model.fe),
                                adu: 4,
                                zi: model,
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 4,
                    zi: model,
                    at: $author$project$OutMsg$reportDecodeError(response)
                };
            default:
                var subMsg = msg.a;
                var _v9 = model.s$;
                if (!_v9.$) {
                    var simulateForm = _v9.a;
                    var _v10 = A3($author$project$Components$CardReader$SimulateForm$update, apiClient, subMsg, simulateForm);
                    var simulateForm_ = _v10.a;
                    var simulateFormCmd = _v10.b;
                    var simulateFormOutMsgs = _v10.c;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CardReader$PaymentModal$SimulateFormMsg, simulateFormCmd),
                        adu: 4,
                        zi: _Utils_update(model, {
                            s$: $elm$core$Maybe$Just(simulateForm_)
                        }),
                        at: simulateFormOutMsgs
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 4,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Ui$Form$SearchableSelect$CustomTrigger = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$TypedDebounced = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$Closed = {
        $: 2
    };
    var $author$project$Ui$Form$SearchableSelect$clearText = function(model) {
        return model.yN ? model : _Utils_update(model, {
            $Y: ''
        });
    };
    var $author$project$Ui$Form$SearchableSelect$close = function(model) {
        return _Utils_Tuple3($author$project$Ui$Form$SearchableSelect$clearText(_Utils_update(model, {
            Vw: false
        })), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Ui$Form$SearchableSelect$Closed));
    };
    var $author$project$Ui$Form$SearchableSelect$DebouncedMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$debounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(300),
        ah3: $author$project$Ui$Form$SearchableSelect$DebouncedMsg
    };
    var $author$project$Ui$Form$SearchableSelect$TextDebounced = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$debounceText = function(text) {
        return A2($elm$core$Task$perform, $author$project$Ui$Form$SearchableSelect$TextDebounced, $elm$core$Task$succeed(text));
    };
    var $author$project$Ui$Form$SearchableSelect$ElementFocused = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$SearchableSelect$focus = function(elementId) {
        return A2($elm$core$Task$attempt, $author$project$Ui$Form$SearchableSelect$ElementFocused(elementId), $elm$browser$Browser$Dom$focus(elementId));
    };
    var $author$project$Ui$Form$SearchableSelect$Selected = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$selectItem = F2(function(maybeItem, model) {
        var _v0 = $author$project$Ui$Form$SearchableSelect$close(model);
        var newModel = _v0.a;
        var newCmd = _v0.b;
        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
            newCmd,
            $author$project$Ui$Form$SearchableSelect$focus(model.aef + '-input')
        ])), $elm$core$Maybe$Just($author$project$Ui$Form$SearchableSelect$Selected(maybeItem)));
    });
    var $elm$core$Char$toLower = _Char_toLower;
    var $author$project$Ui$Form$SearchableSelect$update = F2(function(msg, model) {
        switch(msg.$){
            case 3:
                var elementId = msg.a;
                var result = msg.b;
                return _Utils_Tuple3(model, function() {
                    var _v1 = _Utils_Tuple2(result, _Utils_eq(elementId, model.aef + '-item-active'));
                    if (_v1.a.$ === 1 && _v1.b) return $author$project$Ui$Form$SearchableSelect$focus(model.aef + '-item');
                    else return $elm$core$Platform$Cmd$none;
                }(), $elm$core$Maybe$Nothing);
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    Vw: !model.Vw
                }), $author$project$Ui$Form$SearchableSelect$focus(model.aef + '-input'), $elm$core$Maybe$Nothing);
            case 1:
                return $author$project$Ui$Form$SearchableSelect$close(model);
            case 5:
                return $author$project$Ui$Form$SearchableSelect$close(model);
            case 2:
                var keyCode = msg.a;
                if (keyCode === 27) return $author$project$Ui$Form$SearchableSelect$close(model);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 6:
                var maybeItem = msg.a;
                var keyCode = msg.b;
                switch(keyCode){
                    case 27:
                        var _v4 = $author$project$Ui$Form$SearchableSelect$close(model);
                        var newModel = _v4.a;
                        var newCmd = _v4.b;
                        var event = _v4.c;
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            newCmd,
                            $author$project$Ui$Form$SearchableSelect$focus(model.aef + '-input')
                        ])), event);
                    case 13:
                        return A2($author$project$Ui$Form$SearchableSelect$selectItem, maybeItem, model);
                    default:
                        var _char = $elm$core$Char$fromCode(keyCode);
                        return $elm$core$Char$isAlphaNum(_char) ? _Utils_Tuple3(_Utils_update(model, {
                            $Y: $elm$core$String$fromChar($elm$core$Char$toLower(_char))
                        }), $author$project$Ui$Form$SearchableSelect$focus(model.aef + '-input'), $elm$core$Maybe$Nothing) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                }
            case 4:
                var maybeItem = msg.a;
                return A2($author$project$Ui$Form$SearchableSelect$selectItem, maybeItem, model);
            case 10:
                var id = msg.a;
                return _Utils_Tuple3(model, $author$project$Ui$Form$SearchableSelect$focus(model.aef + '-input'), $elm$core$Maybe$Just($author$project$Ui$Form$SearchableSelect$CustomTrigger(id)));
            case 7:
                var maybeSelected = msg.a;
                var text = msg.b;
                var newText = function() {
                    var _v6 = _Utils_Tuple2(maybeSelected, model.Vw);
                    if (!_v6.a.$ && !_v6.b) {
                        var selected = _v6.a.a;
                        return _Utils_cmp($elm$core$String$length(selected), $elm$core$String$length(text)) > 0 ? '' : A2($elm$core$String$right, 1, text);
                    } else return text;
                }();
                var _v5 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Ui$Form$SearchableSelect$debounceConfig, newText, model.dJ);
                var newDebouncer = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    dJ: newDebouncer,
                    Vw: true,
                    $Y: newText
                }), cmd, $elm$core$Maybe$Nothing);
            case 8:
                var debounceMsg = msg.a;
                var _v7 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Ui$Form$SearchableSelect$debounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Ui$Form$SearchableSelect$debounceText), debounceMsg, model.dJ);
                var newDebouncer = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    dJ: newDebouncer
                }), cmd, $elm$core$Maybe$Nothing);
            default:
                var text = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Ui$Form$SearchableSelect$TypedDebounced(text)));
        }
    });
    var $author$project$Components$DateInput$None = {
        $: 0
    };
    var $author$project$Components$DateInput$Picked = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Disabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$EmptyString = {
        $: 1
    };
    var $agustinrhcp$elm_datepicker$DatePicker$FailedInput = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Invalid = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$None = {
        $: 0
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Picked = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$update = F3(function(settings, msg, _v0) {
        var model = _v0;
        var forceOpen = model.fM;
        switch(msg.$){
            case 0:
                var date = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    a8: $elm$core$Maybe$Just(date),
                    aae: date
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            case 1:
                var date = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    a8: $elm$core$Maybe$Just(date)
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            case 10:
                var date = msg.a;
                var pickable = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    a8: $elm$core$Maybe$Just(date),
                    jv: pickable
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            case 9:
                var pickable = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    jv: pickable
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            case 2:
                var date = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    a8: $elm$core$Maybe$Nothing,
                    cb: $elm$core$Maybe$Nothing,
                    Vw: false
                }), $agustinrhcp$elm_datepicker$DatePicker$Picked(date));
            case 3:
                var text = msg.a;
                var _v2 = settings.af$(text);
                if (!_v2.$) {
                    var date = _v2.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        a8: $elm$core$Maybe$Just(date),
                        cb: $elm$core$Maybe$Just(text),
                        Vw: true
                    }), $agustinrhcp$elm_datepicker$DatePicker$Picked(date));
                } else return _Utils_Tuple2(_Utils_update(model, {
                    cb: $elm$core$Maybe$Just(text),
                    Vw: true
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            case 4:
                if (forceOpen) return _Utils_Tuple2(model, $agustinrhcp$elm_datepicker$DatePicker$None);
                else {
                    var dateEvent = function() {
                        var _v5 = model.cb;
                        if (_v5.$ === 1) return $agustinrhcp$elm_datepicker$DatePicker$FailedInput($agustinrhcp$elm_datepicker$DatePicker$EmptyString);
                        else {
                            if (_v5.a === '') return $agustinrhcp$elm_datepicker$DatePicker$FailedInput($agustinrhcp$elm_datepicker$DatePicker$EmptyString);
                            else {
                                var rawInput = _v5.a;
                                var _v6 = settings.af$(rawInput);
                                if (!_v6.$) {
                                    var date = _v6.a;
                                    return settings.aeC(date) ? $agustinrhcp$elm_datepicker$DatePicker$FailedInput($agustinrhcp$elm_datepicker$DatePicker$Disabled(date)) : $agustinrhcp$elm_datepicker$DatePicker$Picked(date);
                                } else {
                                    var e = _v6.a;
                                    return $agustinrhcp$elm_datepicker$DatePicker$FailedInput($agustinrhcp$elm_datepicker$DatePicker$Invalid(e));
                                }
                            }
                        }
                    }();
                    return _Utils_Tuple2(_Utils_update(model, {
                        a8: function() {
                            if (dateEvent.$ === 2) {
                                var date = dateEvent.a;
                                return $elm$core$Maybe$Just(date);
                            } else return model.a8;
                        }(),
                        cb: function() {
                            if (dateEvent.$ === 2) return $elm$core$Maybe$Nothing;
                            else return model.cb;
                        }()
                    }), dateEvent);
                }
            case 5:
                return _Utils_Tuple2(_Utils_update(model, {
                    fM: false,
                    Vw: true
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            case 6:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: forceOpen
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            case 7:
                return _Utils_Tuple2(_Utils_update(model, {
                    fM: true
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            case 8:
                return _Utils_Tuple2(_Utils_update(model, {
                    fM: false
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
            default:
                var keyCode = msg.a;
                if (keyCode === 27) return _Utils_Tuple2(_Utils_update(model, {
                    Vw: false
                }), $agustinrhcp$elm_datepicker$DatePicker$None);
                else return _Utils_Tuple2(model, $agustinrhcp$elm_datepicker$DatePicker$None);
        }
    });
    var $author$project$Components$DateInput$update = F2(function(msg, model) {
        var datePickerSettings_ = msg.a;
        var subMsg = msg.b;
        var _v1 = A3($agustinrhcp$elm_datepicker$DatePicker$update, datePickerSettings_, subMsg, model.lR);
        var datePicker = _v1.a;
        var datePickerEvent = _v1.b;
        var event = function() {
            _v2$2: while(true)switch(datePickerEvent.$){
                case 2:
                    var date_ = datePickerEvent.a;
                    return $author$project$Components$DateInput$Picked($elm$core$Maybe$Just(date_));
                case 1:
                    if (datePickerEvent.a.$ === 1) {
                        var _v3 = datePickerEvent.a;
                        return $author$project$Components$DateInput$Picked($elm$core$Maybe$Nothing);
                    } else break _v2$2;
                default:
                    break _v2$2;
            }
            return $author$project$Components$DateInput$None;
        }();
        return _Utils_Tuple3(_Utils_update(model, {
            lR: datePicker
        }), $elm$core$Platform$Cmd$none, event);
    });
    var $author$project$Components$Invoice$CreatePaymentModal$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate, A2(field, newDateInput, date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.PU);
            }
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd),
            adu: 1,
            zi: _Utils_update(model, {
                PU: newForm
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$Invoice$CreatePaymentModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 7:
                var response = msg.a;
                return A3($author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch, apiClient, response, _Utils_update(model, {
                    pQ: response
                }));
            case 8:
                var response = msg.a;
                return A3($author$project$Components$Invoice$CreatePaymentModal$shouldDefaultCardReaderSwitch, apiClient, response, _Utils_update(model, {
                    pF: response
                }));
            case 9:
                var response = msg.a;
                return {
                    EQ: $author$project$Ports$LocalStorage$getItem('last-used-card-reader'),
                    adu: 1,
                    zi: _Utils_update(model, {
                        hJ: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 10:
                var _v2 = msg.a;
                var key = _v2.a;
                var value = _v2.b;
                var _v3 = _Utils_Tuple2(key, value);
                if (_v3.a === 'last-used-card-reader' && !_v3.b.$) {
                    var lastUsedCardReaderId = _v3.b.a;
                    var cardReader = A2($elm_community$list_extra$List$Extra$find, function(cardReader_) {
                        return _Utils_eq($author$project$Api$Provider$CardReader$All$id(cardReader_), lastUsedCardReaderId);
                    }, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.hJ)));
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate, $author$project$Components$Invoice$CreatePaymentModal$CardReader(cardReader), model.PU);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 11:
                var useExistingSources = msg.a;
                var _v4 = !useExistingSources && _Utils_eq(model.hJ, $author$project$Api$Data$NotAsked) ? _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Components$Invoice$CreatePaymentModal$fetchCardReaders(apiClient)) : _Utils_Tuple2(model.hJ, $elm$core$Platform$Cmd$none);
                var cardReaders = _v4.a;
                var fetchCardReadersCmd = _v4.b;
                return {
                    EQ: fetchCardReadersCmd,
                    adu: 1,
                    zi: _Utils_update(model, {
                        hJ: cardReaders,
                        V: useExistingSources
                    }),
                    at: _List_Nil
                };
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 2:
                var paymentSourceSelectMsg = msg.a;
                var _v5 = A2($author$project$Ui$Form$SearchableSelect$update, paymentSourceSelectMsg, model.r1);
                var selectModel = _v5.a;
                var selectCmd = _v5.b;
                var event = _v5.c;
                var newForm = function() {
                    if (!event.$ && !event.a.$) {
                        var maybeSource = event.a.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate, $author$project$Components$Invoice$CreatePaymentModal$Source(maybeSource), model.PU);
                    } else return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSelectMsg, selectCmd),
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm,
                        r1: selectModel
                    }),
                    at: _List_Nil
                };
            case 3:
                var cardReaderSelectMsg = msg.a;
                var _v7 = A2($author$project$Ui$Form$SearchableSelect$update, cardReaderSelectMsg, model.pO);
                var selectModel = _v7.a;
                var selectCmd = _v7.b;
                var event = _v7.c;
                var newForm = function() {
                    if (!event.$ && !event.a.$) {
                        var maybeCardReader = event.a.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreatePaymentModal$formFieldsUpdate, $author$project$Components$Invoice$CreatePaymentModal$CardReader(maybeCardReader), model.PU);
                    } else return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderSelectMsg, selectCmd),
                    adu: 1,
                    zi: _Utils_update(model, {
                        pO: selectModel,
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 4:
                var _v9 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$CreatePaymentModal$formFieldsValidator(model.V), model.PU);
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var newForm = _v10.a;
                    var validFormFields = _v10.b;
                    var _v11 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var cardReader = _v11.ace;
                    var storeCard = _v11.CK;
                    var _v12 = function() {
                        var _v13 = _Utils_Tuple3(model.V, cardReader, $author$project$Api$Practice$paymentProcessor(model.W1));
                        if (_v13.a) return _Utils_Tuple3($elm$core$Maybe$Nothing, A8($author$project$Components$Invoice$CreatePaymentModal$createPayment, model.z9.Po, model.r_, apiClient, model.Z$, model.af5, validFormFields, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), $author$project$Api$Data$Loading);
                        else if (!_v13.b.$) {
                            if (_v13.c === 'rainforest') {
                                var cardReader_ = _v13.b.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A8($author$project$Components$Invoice$CreatePaymentModal$createPayment, model.z9.Po, model.r_, apiClient, model.Z$, model.af5, validFormFields, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(cardReader_)), $author$project$Api$Data$Loading);
                            } else {
                                var cardReader_ = _v13.b.a;
                                var owner = function() {
                                    var _v14 = model.af5;
                                    switch(_v14.$){
                                        case 0:
                                            var practiceId = _v14.a;
                                            return $author$project$Components$CardReader$ConnectingModal$Practice(practiceId);
                                        case 1:
                                            var companyId = _v14.a;
                                            return $author$project$Components$CardReader$ConnectingModal$Company(companyId);
                                        case 2:
                                            var affiliateId = _v14.a;
                                            return $author$project$Components$CardReader$ConnectingModal$Affiliate(affiliateId);
                                        case 3:
                                            var patientId = _v14.a;
                                            return $author$project$Components$CardReader$ConnectingModal$Patient(patientId);
                                        default:
                                            var brokerAccountId = _v14.a;
                                            return $author$project$Components$CardReader$ConnectingModal$BrokerAccount(brokerAccountId);
                                    }
                                }();
                                return A2($author$project$Utils$Tuple3$fromTuple2, model.ag, A3($elm$core$Tuple$mapBoth, function(m) {
                                    return $elm$core$Maybe$Just(_Utils_Tuple2(m, validFormFields));
                                }, $elm$core$Platform$Cmd$map($author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg), A7($author$project$Components$CardReader$ConnectingModal$init, apiClient, model.Z$, model.F3, model.sp, cardReader_, owner, storeCard)));
                            }
                        } else {
                            var _v15 = _v13.b;
                            return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, model.ag);
                        }
                    }();
                    var cardReaderConnectingModal = _v12.a;
                    var cmd = _v12.b;
                    var paymentCreatedSaveRequest = _v12.c;
                    return {
                        EQ: cmd,
                        adu: 1,
                        zi: _Utils_update(model, {
                            hI: cardReaderConnectingModal,
                            PU: newForm,
                            ag: paymentCreatedSaveRequest
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v9.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 5:
                var validFormFields = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var payment = response.a;
                    var _v17 = function() {
                        var _v18 = _Utils_Tuple3($author$project$Api$Payment$cardReader(payment), $author$project$Api$Payment$external(payment), $author$project$Api$Payment$status(payment));
                        if (!_v18.a.$) {
                            var cardReader = _v18.a.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, $elm$core$Maybe$Nothing, A3($elm$core$Tuple$mapBoth, function(m) {
                                return $elm$core$Maybe$Just(_Utils_Tuple2(m, validFormFields));
                            }, $elm$core$Platform$Cmd$map($author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg), A6($author$project$Components$CardReader$PaymentModal$init, apiClient, model.Z$, model.F3, model.sp, $author$project$Api$Provider$CardReader$Shared$id(cardReader), payment)));
                        } else {
                            if (_v18.b) {
                                var _v19 = _v18.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(_Utils_Tuple2('Payment added', 3)));
                            } else if (_v18.c === 'failed') {
                                var _v20 = _v18.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(_Utils_Tuple2('Payment failed', 1)));
                            } else {
                                var _v21 = _v18.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(_Utils_Tuple2('Payment processed successfully', 3)));
                            }
                        }
                    }();
                    var cardReaderPaymentModal = _v17.a;
                    var cardReaderPaymentModalCmd = _v17.b;
                    var message = _v17.c;
                    return {
                        EQ: cardReaderPaymentModalCmd,
                        adu: _Utils_eq(cardReaderPaymentModal, $elm$core$Maybe$Nothing) ? 2 : 1,
                        zi: _Utils_update(model, {
                            bU: cardReaderPaymentModal,
                            ag: $author$project$Api$Data$NotAsked
                        }),
                        at: A2($elm$core$List$append, _List_fromArray([
                            $author$project$OutMsg$RefreshPatientsList
                        ]), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(_v22) {
                            var toastMessage_ = _v22.a;
                            var toastLevel_ = _v22.b;
                            return _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, toastLevel_, toastMessage_)
                            ]);
                        }, message)))
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        ag: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 6:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Components$Invoice$CreatePaymentModal$updateDateInputFormField, model, dateInput, subMsg, $author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg, $author$project$Components$Invoice$CreatePaymentModal$PaidAt, function($) {
                    return $.VQ;
                });
            case 12:
                var subMsg = msg.a;
                var _v23 = model.hI;
                if (!_v23.$) {
                    var _v24 = _v23.a;
                    var cardReaderConnectingModal = _v24.a;
                    var validFormFields = _v24.b;
                    var cardReaderConnectingModalResult = A3($author$project$Components$CardReader$ConnectingModal$update, apiClient, subMsg, cardReaderConnectingModal);
                    var _v25 = function() {
                        var _v26 = cardReaderConnectingModalResult.adu;
                        switch(_v26.$){
                            case 1:
                                var card = _v26.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A5($author$project$Components$Invoice$CreatePaymentModal$createCard, model.Hx, apiClient, model.Z$, validFormFields, card));
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ag, $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_Tuple2(cardReaderConnectingModalResult.zi, validFormFields)), model.ag, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var cardReaderConnectingModal_ = _v25.a;
                    var paymentCreatedSaveRequest = _v25.b;
                    var cmd = _v25.c;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg, cardReaderConnectingModalResult.EQ),
                            cmd
                        ])),
                        adu: 1,
                        zi: _Utils_update(model, {
                            hI: cardReaderConnectingModal_,
                            ag: paymentCreatedSaveRequest
                        }),
                        at: cardReaderConnectingModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 13:
                var subMsg = msg.a;
                var _v27 = model.bU;
                if (!_v27.$) {
                    var _v28 = _v27.a;
                    var cardReaderPaymentModal = _v28.a;
                    var validFormFields = _v28.b;
                    var cardReaderPaymentModalResult = A3($author$project$Components$CardReader$PaymentModal$update, apiClient, subMsg, cardReaderPaymentModal);
                    var _v29 = cardReaderPaymentModalResult.adu;
                    switch(_v29){
                        case 1:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 2,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Nothing,
                                    ag: $author$project$Api$Data$NotAsked
                                }),
                                at: _Utils_ap(cardReaderPaymentModalResult.at, _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, 'Payment processed successfully'),
                                    $author$project$OutMsg$RefreshPatientsList
                                ]))
                            };
                        case 3:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 2,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Nothing,
                                    ag: $author$project$Api$Data$NotAsked
                                }),
                                at: _Utils_ap(cardReaderPaymentModalResult.at, _List_fromArray([
                                    $author$project$OutMsg$RefreshPatientsList
                                ]))
                            };
                        case 2:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 2,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Nothing,
                                    ag: $author$project$Api$Data$NotAsked
                                }),
                                at: _Utils_ap(cardReaderPaymentModalResult.at, _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, 'Payment failed'),
                                    $author$project$OutMsg$RefreshPatientsList
                                ]))
                            };
                        case 0:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 1,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Nothing,
                                    ag: $author$project$Api$Data$NotAsked
                                }),
                                at: cardReaderPaymentModalResult.at
                            };
                        default:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 1,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Just(_Utils_Tuple2(cardReaderPaymentModalResult.zi, validFormFields))
                                }),
                                at: cardReaderPaymentModalResult.at
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var validFormFields = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var card = response.a;
                    return {
                        EQ: A8($author$project$Components$Invoice$CreatePaymentModal$createPayment, model.z9.Po, model.r_, apiClient, model.Z$, model.af5, validFormFields, $elm$core$Maybe$Just(card), $elm$core$Maybe$Nothing),
                        adu: 1,
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        ag: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Invoice$DownloadFile$AvailableOptionSelected = 1;
    var $author$project$Components$Invoice$DownloadFile$DownloadFileClicked = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$DownloadFile$GotFile = 3;
    var $author$project$Components$Invoice$DownloadFile$GotToken = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Invoice$DownloadFile$None = 0;
    var $author$project$Components$Invoice$DownloadFile$PollFile = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Invoice$DownloadFile$UnavailableOptionSelected = 2;
    var $author$project$Components$Invoice$DownloadFile$GotFileStatus = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$File$File = $elm$core$Basics$identity;
    var $author$project$Api$File$Record = F2(function(processing, url) {
        return {
            Xv: processing,
            aaT: url
        };
    });
    var $author$project$Api$File$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'processing', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$File$Record)));
    var $author$project$Api$File$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$File$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$File$Token$toString = function(_v0) {
        var string = _v0;
        return string;
    };
    var $author$project$Api$File$retrievePath = function(token) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'files',
            $author$project$Api$File$Token$toString(token)
        ]), $author$project$Api$Data$providerPath);
    };
    var $author$project$Api$File$generate = F3(function(apiClient, token, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$File$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'generate'
        ]), $author$project$Api$File$retrievePath(token))));
    });
    var $author$project$Components$Invoice$DownloadFile$generateFile = F3(function(model, apiClient, token) {
        return model.Sk ? A3($author$project$Api$File$generate, apiClient, token, $author$project$Components$Invoice$DownloadFile$GotFileStatus(token)) : $elm$core$Platform$Cmd$none;
    });
    var $author$project$Api$File$isProcessing = function(_v0) {
        var record = _v0;
        return record.Xv;
    };
    var $author$project$Ports$Navigation$navigationPortOpenInNewWindow = _Platform_outgoingPort('navigationPortOpenInNewWindow', $elm$json$Json$Encode$string);
    var $author$project$Ports$Navigation$openInNewWindow = $author$project$Ports$Navigation$navigationPortOpenInNewWindow;
    var $author$project$Api$Provider$File$One$File = $elm$core$Basics$identity;
    var $author$project$Api$Provider$File$One$Record = function(token) {
        return {
            aaf: token
        };
    };
    var $author$project$Api$Provider$File$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'token', $author$project$Api$File$Token$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$File$One$Record));
    var $author$project$Api$Provider$File$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$File$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$File$retrieveToken = F4(function(apiClient, path, options, toMsg) {
        var lte = options.Gg === '' ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(options.Gg);
        var gte = options.FI === '' ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(options.FI);
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('type', $elm$json$Json$Encode$string('account_statement')),
            _Utils_Tuple2('options', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('date', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('gte', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, gte)),
                    _Utils_Tuple2('lte', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, lte))
                ])))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$File$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'files'
        ]), path))));
    });
    var $author$project$Api$Provider$File$One$token = function(_v0) {
        var record = _v0;
        return record.aaf;
    };
    var $author$project$Api$File$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Components$Invoice$DownloadFile$update = F3(function(apiClient, msg, model) {
        update: while(true)switch(msg.$){
            case 6:
                var path = msg.a;
                var options = msg.b;
                return {
                    EQ: A4($author$project$Api$File$retrieveToken, apiClient, path, options, $author$project$Components$Invoice$DownloadFile$GotToken),
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var file = response.a;
                        var $temp$apiClient = apiClient, $temp$msg = $author$project$Components$Invoice$DownloadFile$DownloadFileClicked($author$project$Api$Provider$File$One$token(file)), $temp$model = model;
                        apiClient = $temp$apiClient;
                        msg = $temp$msg;
                        model = $temp$model;
                        continue update;
                    case 2:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: model,
                            at: $author$project$OutMsg$handleErrorResponse(response)
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: model,
                            at: _List_Nil
                        };
                }
            case 0:
                var token = msg.a;
                var newModel = _Utils_update(model, {
                    Sk: true
                });
                return {
                    EQ: A3($author$project$Components$Invoice$DownloadFile$generateFile, newModel, apiClient, token),
                    adu: 1,
                    zi: newModel,
                    at: _List_Nil
                };
            case 1:
                var token = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var fileStatus = response.a;
                    return $author$project$Api$File$isProcessing(fileStatus) ? {
                        EQ: A2($elm$core$Task$perform, function(_v3) {
                            return $author$project$Components$Invoice$DownloadFile$PollFile(token);
                        }, $elm$core$Process$sleep(2000)),
                        adu: 0,
                        zi: _Utils_update(model, {
                            Sk: true
                        }),
                        at: _List_Nil
                    } : {
                        EQ: A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, $author$project$Ports$Navigation$openInNewWindow, $author$project$Api$File$url(fileStatus))),
                        adu: 3,
                        zi: _Utils_update(model, {
                            Sk: false
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 2:
                var token = msg.a;
                return {
                    EQ: A3($author$project$Components$Invoice$DownloadFile$generateFile, model, apiClient, token),
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 3:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        Sk: false
                    }),
                    at: _List_Nil
                };
            case 4:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.fD);
                var newDropdown = _v4.a;
                var dropdownCmd = _v4.b;
                return {
                    EQ: dropdownCmd,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fD: newDropdown
                    }),
                    at: _List_Nil
                };
            default:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Invoice$PaymentsHistory$DisputeSimulated = 4;
    var $author$project$Components$Invoice$PaymentsHistory$None = 0;
    var $author$project$Components$Invoice$PaymentsHistory$PaymentCancelled = 2;
    var $author$project$Components$Invoice$PaymentsHistory$RefundCancelled = 3;
    var $author$project$Components$Invoice$PaymentsHistory$RefundCreated = 1;
    var $author$project$Components$PaymentsList$DisputeSimulated = 4;
    var $author$project$Components$PaymentsList$GotCancelPayment = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$GotRefundCancelled = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$None = 0;
    var $author$project$Api$Platform$RainforestSession$Payment = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$PaymentCancelled = 2;
    var $author$project$Components$PaymentsList$PaymentDisputeModalMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$RainforestPaymentModalMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Platform$RainforestSession$Refund = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$RefundCancelled = 3;
    var $author$project$Components$PaymentsList$RefundCreated = 1;
    var $author$project$Api$Payment$paymentPath = F2(function(basePath, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Payment$paymentsPath(basePath));
    });
    var $author$project$Api$Payment$cancel = F5(function(basePath, apiClient, session, id_, toMsg) {
        return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$Payment$One$decoder, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Payment$Employer_One))) : A3($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Payment$One$decoder, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Payment$Provider_One))))($author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel'
        ]), A2($author$project$Api$Payment$paymentPath, basePath, id_))));
    });
    var $author$project$Api$Provider$Refund$refundsPath = function(paymentPath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'refunds'
        ]), paymentPath);
    };
    var $author$project$Api$Provider$Refund$refundPath = F2(function(paymentsPath, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Refund$refundsPath(paymentsPath));
    });
    var $author$project$Api$Provider$Refund$cancel = F4(function(paymentPath, apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Refund$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel'
        ]), A2($author$project$Api$Provider$Refund$refundPath, paymentPath, id))));
    });
    var $author$project$Api$Employer$Refund$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Refund$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Refund$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Refund$Shared$id(shared);
    };
    var $author$project$Api$Refund$id = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$id(refund_);
            case 1:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$Shared$id(refund_);
            default:
                var refund_ = refund.a;
                return $author$project$Api$Employer$Refund$Shared$id(refund_);
        }
    };
    var $author$project$Components$Invoice$RefundModal$Model = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Payment$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Employer$Payment$One$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Payment$One$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$amountInCents(shared);
    };
    var $author$project$Api$Payment$amountInCents = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$amountInCents(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$amountInCents(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$amountInCents(payment_);
        }
    };
    var $author$project$Components$Invoice$RefundModal$formFieldsFromPayment = function(payment) {
        return {
            Jh: $elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Payment$amountInCents(payment))),
            ae0: $elm$core$Maybe$Nothing,
            nr: $author$project$Api$Payment$amountInCents(payment)
        };
    };
    var $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor = function(_v0) {
        var record = _v0;
        return record.So;
    };
    var $author$project$Api$Provider$Payment$One$isRefundableOnPaymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundableOnPaymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$isRefundableOnPaymentProcessor(shared);
    };
    var $author$project$Api$Payment$isRefundableOnPaymentProcessor = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$isRefundableOnPaymentProcessor(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundableOnPaymentProcessor(payment_);
            default:
                return false;
        }
    };
    var $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment = function(payment) {
        return !$author$project$Api$Payment$isRefundableOnPaymentProcessor(payment) && !$author$project$Api$Payment$external(payment);
    };
    var $author$project$Components$Invoice$RefundModal$isExternalRefund = function(payment) {
        var oldPaymentProcessorPayment = $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment(payment);
        var externalPayment = $author$project$Api$Payment$external(payment);
        return externalPayment || oldPaymentProcessorPayment;
    };
    var $author$project$Components$Invoice$RefundModal$init = F4(function(timeFormatter, paymentPath, allowPartialRefunds, payment) {
        return {
            vs: allowPartialRefunds,
            qF: $author$project$Components$Invoice$RefundModal$isExternalRefund(payment),
            PU: $author$project$Utils$Form$init($author$project$Components$Invoice$RefundModal$formFieldsFromPayment(payment)),
            Gz: $author$project$Components$Invoice$RefundModal$isOldPaymentProcessorPayment(payment),
            Wk: payment,
            r_: paymentPath,
            j_: $author$project$Api$Data$NotAsked,
            HO: timeFormatter
        };
    });
    var $author$project$Components$PaymentDisputeModal$Loading = {
        $: 2
    };
    var $author$project$Components$PaymentDisputeModal$GotDisputes = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Dispute$All$Dispute = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Dispute$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Dispute$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Dispute$disputesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'disputes'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Sort$Model = $elm$core$Basics$identity;
    var $author$project$Api$Sort$init = {
        Nn: $elm$core$Maybe$Nothing,
        sg: '',
        aa9: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Dispute$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        GS: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Sort$pageParamName = function(prefix) {
        return prefix + 'sort';
    };
    var $author$project$Api$Sort$valueOrDefault = function(_v0) {
        var model = _v0;
        var _v1 = _Utils_Tuple2(model.aa9, model.Nn);
        if (!_v1.a.$) {
            var value = _v1.a.a;
            return $elm$core$Maybe$Just(value);
        } else {
            var _v2 = _v1.a;
            var _default = _v1.b;
            return _default;
        }
    };
    var $author$project$Api$Sort$toPrefixeddParams = F2(function(prefix, _v0) {
        var model = _v0;
        var _v1 = $author$project$Api$Sort$valueOrDefault(model);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var column = _v2.a;
            var direction = _v2.b;
            var sortParam = function() {
                if (!direction) return column;
                else return '-' + column;
            }();
            return _List_fromArray([
                A2($author$project$Api$Param$string, $author$project$Api$Sort$pageParamName(prefix), sortParam)
            ]);
        } else return _List_Nil;
    });
    var $author$project$Api$Sort$toParams = $author$project$Api$Sort$toPrefixeddParams('');
    var $author$project$Api$Provider$Dispute$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Dispute$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Param$string('payment'), $elm$core$List$singleton), options.GS)),
            A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Param$string('status'), $elm$core$List$singleton), options.ahy))
        ]));
    };
    var $author$project$Api$Provider$Dispute$list = F3(function(apiClient, query, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Dispute$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Dispute$listOptionsToParams(query), $author$project$Api$Data$requestTo($author$project$Api$Provider$Dispute$disputesPath)));
    });
    var $author$project$Components$PaymentDisputeModal$fetchDisputes = F2(function(client, paymentId) {
        return A3($author$project$Api$Provider$Dispute$list, client, function(q) {
            return _Utils_update(q, {
                GS: $elm$core$Maybe$Just(paymentId)
            });
        }, $author$project$Components$PaymentDisputeModal$GotDisputes);
    });
    var $author$project$Components$PaymentDisputeModal$init = F2(function(client, paymentId) {
        return _Utils_Tuple2({
            N7: $author$project$Components$PaymentDisputeModal$Loading
        }, A2($author$project$Components$PaymentDisputeModal$fetchDisputes, client, paymentId));
    });
    var $author$project$Components$Rainforest$SessionModal$GotSession = $elm$core$Basics$identity;
    var $author$project$Components$Rainforest$SessionModal$Loading = {
        $: 0
    };
    var $author$project$Api$Platform$RainforestSession$RainforestSession = F4(function(rainforestResourceId, rainforestSessionKey, rainforestResourceType, rainforestParentResourceId) {
        return {
            agr: rainforestParentResourceId,
            ags: rainforestResourceId,
            agt: rainforestResourceType,
            agu: rainforestSessionKey
        };
    });
    var $author$project$Api$Platform$RainforestSession$decodeSession = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rainforest_parent_resource_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rainforest_resource_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rainforest_session_key', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rainforest_resource_id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$RainforestSession$RainforestSession)))));
    var $author$project$Api$Platform$RainforestSession$rainforestSessionsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'rainforest_sessions'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$RainforestSession$create = F3(function(apiClient, resource, toMsg) {
        var _v0 = function() {
            switch(resource.$){
                case 0:
                    var depositId = resource.a;
                    return _Utils_Tuple2('deposit', depositId);
                case 1:
                    var paymentId = resource.a;
                    return _Utils_Tuple2('payment', paymentId);
                default:
                    var refundId = resource.a;
                    return _Utils_Tuple2('refund', refundId);
            }
        }();
        var resoourceType = _v0.a;
        var resoourceId = _v0.b;
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('resource_type', $elm$json$Json$Encode$string(resoourceType)),
            _Utils_Tuple2('resource_id', $elm$json$Json$Encode$string(resoourceId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$RainforestSession$decodeSession, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$RainforestSession$rainforestSessionsPath)));
    });
    var $author$project$Components$Rainforest$SessionModal$init = F2(function(client, resource) {
        return _Utils_Tuple2({
            Hg: resource,
            Z$: $author$project$Components$Rainforest$SessionModal$Loading
        }, A3($author$project$Api$Platform$RainforestSession$create, client, resource, $elm$core$Basics$identity));
    });
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus = 'WON';
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$init = F4(function(basePath, session, payment, dispute) {
        return _Utils_Tuple2({
            vK: basePath,
            N7: dispute,
            Wk: payment,
            Z$: session,
            ox: $author$project$Api$Data$NotAsked,
            ahy: $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Rainforest$SimulateDisputeModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus = 'DISPUTE_ACTION_REQUIRED';
    var $author$project$Components$Rainforest$SimulateDisputeModal$init = F3(function(basePath, session, payment) {
        return _Utils_Tuple2({
            vK: basePath,
            Wk: payment,
            Z$: session,
            oy: $author$project$Api$Data$NotAsked,
            ahy: $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Invoice$RefundModal$Closed = 0;
    var $author$project$Components$Invoice$RefundModal$None = 1;
    var $author$project$Components$Invoice$RefundModal$RefundCreated = 2;
    var $author$project$Components$Invoice$RefundModal$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Refund$create = F4(function(paymentPath, apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('refund', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('amount_in_cents', $author$project$Currency$encode(fields.Jh)),
                _Utils_Tuple2('memo', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ae0)),
                _Utils_Tuple2('external', $elm$json$Json$Encode$bool(fields.Po))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Refund$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Refund$refundsPath(paymentPath))));
    });
    var $author$project$Components$Invoice$RefundModal$createRefund = F4(function(paymentPath, apiClient, formFields, externalRefund) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Refund$create, paymentPath, apiClient, {
            Jh: A2($elm$core$Maybe$withDefault, $author$project$Currency$fromInt(fields.nr), fields.Jh),
            Po: externalRefund,
            ae0: fields.ae0
        }, $author$project$Components$Invoice$RefundModal$Created);
    });
    var $author$project$Components$Invoice$RefundModal$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var _int = field.a;
            return _Utils_update(fields, {
                Jh: _int
            });
        } else {
            var string = field.a;
            return _Utils_update(fields, {
                ae0: $author$project$Utils$String$toMaybe(string)
            });
        }
    });
    var $author$project$Components$Invoice$RefundModal$AmountInCentsValidation = 0;
    var $author$project$Components$Invoice$RefundModal$validateAmountInCents = function(fields) {
        return A2($author$project$Utils$Validate$isInvalidCurrency, {
            abI: false,
            y_: $elm$core$Maybe$Just(fields.nr),
            Uj: $elm$core$Maybe$Just(100)
        }, fields.Jh) ? _List_fromArray([
            _Utils_Tuple2(0, 'Please enter an amount between $1.00 and ' + ($author$project$Utils$Currency$fromInt(fields.nr) + '.'))
        ]) : _List_Nil;
    };
    var $author$project$Components$Invoice$RefundModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$RefundModal$validateAmountInCents)
    ]));
    var $author$project$Components$Invoice$RefundModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$RefundModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 2:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$RefundModal$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    return {
                        EQ: A4($author$project$Components$Invoice$RefundModal$createRefund, model.r_, apiClient, validFormFields, model.qF),
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            j_: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Refund successfully created')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        j_: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$PaymentDisputeModal$DisputeModalMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PaymentDisputeModal$Failed = {
        $: 3
    };
    var $author$project$Components$PaymentDisputeModal$First = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PaymentDisputeModal$NoDisputes = {
        $: 1
    };
    var $author$project$Api$Provider$Dispute$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Dispute$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Dispute$Shared$id(shared);
    };
    var $author$project$Components$DisputeModal$GotSession = $elm$core$Basics$identity;
    var $author$project$Components$DisputeModal$Loading = {
        $: 0
    };
    var $author$project$Api$Platform$Dispute$Session$Rainforest = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Platform$Dispute$Session$RainforestSession = F2(function(chargebackId, sessionKey) {
        return {
            acp: chargebackId,
            ahi: sessionKey
        };
    });
    var $author$project$Api$Platform$Dispute$Session$Stripe = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Platform$Dispute$Session$StripeSession = F2(function(chargeId, sessionKey) {
        return {
            acj: chargeId,
            ahi: sessionKey
        };
    });
    var $author$project$Api$Platform$Dispute$Session$decodeSession = A2($elm$json$Json$Decode$andThen, function(processor) {
        switch(processor){
            case 'rainforest':
                return A2($elm$json$Json$Decode$map, $author$project$Api$Platform$Dispute$Session$Rainforest, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'session_key', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chargeback_id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$Session$RainforestSession))));
            case 'stripe':
                return A2($elm$json$Json$Decode$map, $author$project$Api$Platform$Dispute$Session$Stripe, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'session_key', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$Session$StripeSession))));
            default:
                return $elm$json$Json$Decode$fail('Unsupported processor ' + processor);
        }
    }, A2($elm$json$Json$Decode$at, _List_fromArray([
        'payment_processor'
    ]), $elm$json$Json$Decode$string));
    var $author$project$Api$Platform$Dispute$Session$disputesPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'disputes'
        ]), basePath);
    };
    var $author$project$Api$Platform$Dispute$Session$retrieve = F4(function(basePath, apiClient, disputeId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$Dispute$Session$decodeSession, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            disputeId,
            'session'
        ]), $author$project$Api$Platform$Dispute$Session$disputesPath(basePath))));
    });
    var $author$project$Components$DisputeModal$init = F3(function(basePath, client, disputeId) {
        return _Utils_Tuple2({
            N7: $author$project$Components$DisputeModal$Loading
        }, A4($author$project$Api$Platform$Dispute$Session$retrieve, basePath, client, disputeId, $elm$core$Basics$identity));
    });
    var $author$project$Components$DisputeModal$Failed = {
        $: 1
    };
    var $author$project$Components$DisputeModal$Session = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ports$Stripe$stripePortMountPaymentDisputesComponent = _Platform_outgoingPort('stripePortMountPaymentDisputesComponent', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('chargeId', $elm$json$Json$Encode$string($.acj)),
            _Utils_Tuple2('selector', $elm$json$Json$Encode$string($.bi)),
            _Utils_Tuple2('stripeClientSecret', $elm$json$Json$Encode$string($.oF))
        ]));
    });
    var $author$project$Ports$Stripe$mountPaymentDisputesComponent = F3(function(selector, stripeClientSecret, chargeId) {
        return $author$project$Ports$Stripe$stripePortMountPaymentDisputesComponent({
            acj: chargeId,
            bi: selector,
            oF: stripeClientSecret
        });
    });
    var $author$project$Components$DisputeModal$update = F2(function(msg, model) {
        var response = msg;
        switch(response.$){
            case 3:
                var session = response.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    N7: $author$project$Components$DisputeModal$Session(session)
                }), function() {
                    if (!session.$) return $elm$core$Platform$Cmd$none;
                    else {
                        var stripeSession = session.a;
                        return A3($author$project$Ports$Stripe$mountPaymentDisputesComponent, '#stripe-payment-disputes-' + stripeSession.acj, stripeSession.ahi, stripeSession.acj);
                    }
                }(), _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    N7: $author$project$Components$DisputeModal$Failed
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$PaymentDisputeModal$update = F3(function(client, msg, model) {
        if (!msg.$) {
            var response = msg.a;
            switch(response.$){
                case 3:
                    var disputes = response.a;
                    var _v2 = $elm$core$List$head(disputes);
                    if (!_v2.$) {
                        var dispute = _v2.a;
                        var _v3 = A3($author$project$Components$DisputeModal$init, $author$project$Api$Data$providerPath, client, $author$project$Api$Provider$Dispute$All$id(dispute));
                        var disputeModal = _v3.a;
                        var disputeCmd = _v3.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            N7: $author$project$Components$PaymentDisputeModal$First(disputeModal)
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentDisputeModal$DisputeModalMsg, disputeCmd), _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        N7: $author$project$Components$PaymentDisputeModal$NoDisputes
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                case 2:
                    return _Utils_Tuple3(_Utils_update(model, {
                        N7: $author$project$Components$PaymentDisputeModal$Failed
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                default:
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }
        } else {
            var subMsg = msg.a;
            var _v4 = model.N7;
            if (!_v4.$) {
                var disputeModal = _v4.a;
                var _v5 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
                var newDisputeModal = _v5.a;
                var disputeModalCmd = _v5.b;
                var disputeModalOutMsgs = _v5.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    N7: $author$project$Components$PaymentDisputeModal$First(newDisputeModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentDisputeModal$DisputeModalMsg, disputeModalCmd), disputeModalOutMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Rainforest$SessionModal$Failed = {
        $: 1
    };
    var $author$project$Components$Rainforest$SessionModal$Loaded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Rainforest$SessionModal$update = F2(function(msg, model) {
        var response = msg;
        switch(response.$){
            case 3:
                var session = response.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Z$: $author$project$Components$Rainforest$SessionModal$Loaded(session)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    Z$: $author$project$Components$Rainforest$SessionModal$Failed
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$Closed = 2;
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$DisputeSimulated = 1;
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$GotSimulateDisputeEventResponse = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$None = 0;
    var $author$project$Api$Provider$Dispute$One$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Dispute$Shared$id(shared);
    };
    var $author$project$Api$Dispute$id = function(dispute) {
        if (!dispute.$) {
            var dispute_ = dispute.a;
            return $author$project$Api$Provider$Dispute$One$id(dispute_);
        } else {
            var dispute_ = dispute.a;
            return $author$project$Api$Provider$Dispute$Shared$id(dispute_);
        }
    };
    var $author$project$Api$Dispute$Provider_One = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Dispute$One$Dispute = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Dispute$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Dispute$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Payment$Dispute$paymentsDisputesPath = F2(function(basePath, paymentId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'disputes'
        ]), A2($author$project$Api$Payment$paymentPath, basePath, paymentId));
    });
    var $author$project$Api$Payment$Dispute$paymentsDisputePath = F3(function(basePath, paymentId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), A2($author$project$Api$Payment$Dispute$paymentsDisputesPath, basePath, paymentId));
    });
    var $author$project$Api$Payment$Dispute$simulateEvent = F7(function(basePath, apiClient, session, paymentId, disputeId, status, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('status', $elm$json$Json$Encode$string(status))
        ]));
        return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Basics$always($elm$core$Platform$Cmd$none) : A3($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Dispute$One$decoder, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Dispute$Provider_One))))(A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'simulate_event'
        ]), A3($author$project$Api$Payment$Dispute$paymentsDisputePath, basePath, paymentId, disputeId)))));
    });
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$statuses = _List_fromArray([
        'DISPUTE_ACTION_REQUIRED',
        'PROVISIONAL_WIN',
        'WON',
        'LOST'
    ]);
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var inputStatus = msg.a;
                var selectedStatus = A2($elm_community$list_extra$List$Extra$find, function(status_) {
                    return _Utils_eq(status_, inputStatus);
                }, $author$project$Components$Rainforest$SimulateDisputeEventModal$statuses);
                var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateDisputeEventModal$defaultStatus, selectedStatus);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ahy: status
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: A7($author$project$Api$Payment$Dispute$simulateEvent, model.vK, apiClient, model.Z$, $author$project$Api$Payment$id(model.Wk), $author$project$Api$Dispute$id(model.N7), model.ahy, $author$project$Components$Rainforest$SimulateDisputeEventModal$GotSimulateDisputeEventResponse),
                    adu: 0,
                    zi: _Utils_update(model, {
                        ox: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        ox: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Dispute event simulated successfully')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ox: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Rainforest$SimulateDisputeModal$Closed = 2;
    var $author$project$Components$Rainforest$SimulateDisputeModal$DisputeSimulated = 1;
    var $author$project$Components$Rainforest$SimulateDisputeModal$GotSimulateDisputeResponse = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Rainforest$SimulateDisputeModal$None = 0;
    var $author$project$Api$Payment$Dispute$simulate = F6(function(basePath, apiClient, session, paymentId, status, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('status', $elm$json$Json$Encode$string(status))
        ]));
        return ($author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Basics$always($elm$core$Platform$Cmd$none) : A3($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Dispute$One$decoder, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Dispute$Provider_One))))(A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'simulate'
        ]), A2($author$project$Api$Payment$Dispute$paymentsDisputesPath, basePath, paymentId)))));
    });
    var $author$project$Components$Rainforest$SimulateDisputeModal$statuses = _List_fromArray([
        'DISPUTE_ACTION_REQUIRED',
        'INQUIRY_ACTION_REQUIRED'
    ]);
    var $author$project$Components$Rainforest$SimulateDisputeModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var inputStatus = msg.a;
                var selectedStatus = A2($elm_community$list_extra$List$Extra$find, function(status_) {
                    return _Utils_eq(status_, inputStatus);
                }, $author$project$Components$Rainforest$SimulateDisputeModal$statuses);
                var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateDisputeModal$defaultStatus, selectedStatus);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ahy: status
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: A6($author$project$Api$Payment$Dispute$simulate, model.vK, apiClient, model.Z$, $author$project$Api$Payment$id(model.Wk), model.ahy, $author$project$Components$Rainforest$SimulateDisputeModal$GotSimulateDisputeResponse),
                    adu: 0,
                    zi: _Utils_update(model, {
                        oy: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        oy: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Dispute simulated successfully')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        oy: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$PaymentsList$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var payment = msg.a;
                var paymentPath = A2($author$project$Api$Payment$paymentPath, model.vK, $author$project$Api$Payment$id(payment));
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        jM: $elm$core$Maybe$Just(A4($author$project$Components$Invoice$RefundModal$init, model.HO, paymentPath, model.vs, payment))
                    }),
                    at: _List_Nil
                };
            case 4:
                var subMsg = msg.a;
                var _v1 = model.gn;
                if (!_v1.$) {
                    var paymentDisputeModal = _v1.a;
                    var _v2 = A3($author$project$Components$PaymentDisputeModal$update, apiClient, subMsg, paymentDisputeModal);
                    var newPaymentDisputeModal = _v2.a;
                    var paymentDisputeModalCmd = _v2.b;
                    var paymentDisputeModalOutMsgs = _v2.c;
                    return function(m) {
                        return {
                            EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$PaymentDisputeModalMsg, paymentDisputeModalCmd),
                            adu: 0,
                            zi: m,
                            at: paymentDisputeModalOutMsgs
                        };
                    }(_Utils_update(model, {
                        gn: $elm$core$Maybe$Just(newPaymentDisputeModal)
                    }));
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var subMsg = msg.a;
                var _v3 = model.jM;
                if (!_v3.$) {
                    var refundModal = _v3.a;
                    var refundModalResult = A3($author$project$Components$Invoice$RefundModal$update, apiClient, subMsg, refundModal);
                    var _v4 = function() {
                        var _v5 = refundModalResult.adu;
                        switch(_v5){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Just(refundModalResult.zi), 0);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
                        }
                    }();
                    var refundModal_ = _v4.a;
                    var event = _v4.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RefundModalMsg, refundModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            jM: refundModal_
                        }),
                        at: refundModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var payment = msg.a;
                var _v6 = A2($author$project$Components$PaymentDisputeModal$init, apiClient, $author$project$Api$Payment$id(payment));
                var paymentDisputeModal = _v6.a;
                var paymentDisputeModalCmd = _v6.b;
                return function(m) {
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$PaymentDisputeModalMsg, paymentDisputeModalCmd),
                        adu: 0,
                        zi: m,
                        at: _List_Nil
                    };
                }(_Utils_update(model, {
                    gn: $elm$core$Maybe$Just(paymentDisputeModal)
                }));
            case 3:
                return function(m) {
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: m,
                        at: _List_Nil
                    };
                }(_Utils_update(model, {
                    gn: $elm$core$Maybe$Nothing
                }));
            case 5:
                var payment = msg.a;
                var _v7 = A2($author$project$Components$Rainforest$SessionModal$init, apiClient, $author$project$Api$Platform$RainforestSession$Payment($author$project$Api$Payment$id(payment)));
                var rainforestPaymentModal = _v7.a;
                var rainforestPaymentModalCmd = _v7.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        eu: $elm$core$Maybe$Just(rainforestPaymentModal)
                    }),
                    at: _List_Nil
                };
            case 8:
                var refund = msg.a;
                var _v8 = A2($author$project$Components$Rainforest$SessionModal$init, apiClient, $author$project$Api$Platform$RainforestSession$Refund($author$project$Api$Refund$id(refund)));
                var rainforestPaymentModal = _v8.a;
                var rainforestPaymentModalCmd = _v8.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        eu: $elm$core$Maybe$Just(rainforestPaymentModal)
                    }),
                    at: _List_Nil
                };
            case 7:
                var subMsg = msg.a;
                var _v9 = model.eu;
                if (!_v9.$) {
                    var rainforestPaymentModal = _v9.a;
                    var _v10 = A2($author$project$Components$Rainforest$SessionModal$update, subMsg, rainforestPaymentModal);
                    var newRainforestPaymentModal = _v10.a;
                    var rainforestPaymentModalCmd = _v10.b;
                    var rainforestPaymentModalOutMsg = _v10.c;
                    return function(m) {
                        return {
                            EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$RainforestPaymentModalMsg, rainforestPaymentModalCmd),
                            adu: 0,
                            zi: m,
                            at: rainforestPaymentModalOutMsg
                        };
                    }(_Utils_update(model, {
                        eu: $elm$core$Maybe$Just(newRainforestPaymentModal)
                    }));
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                return function(m) {
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: m,
                        at: _List_Nil
                    };
                }(_Utils_update(model, {
                    eu: $elm$core$Maybe$Nothing
                }));
            case 9:
                var payment = msg.a;
                var _v11 = A3($author$project$Components$Rainforest$SimulateDisputeModal$init, model.vK, model.Z$, payment);
                var simulateDisputeModal = _v11.a;
                var simulateDisputeModalCmd = _v11.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeModalMsg, simulateDisputeModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        kf: $elm$core$Maybe$Just(simulateDisputeModal)
                    }),
                    at: _List_Nil
                };
            case 10:
                var subMsg = msg.a;
                var _v12 = model.kf;
                if (!_v12.$) {
                    var simulateDisputeModal = _v12.a;
                    var simulateDisputeModalResult = A3($author$project$Components$Rainforest$SimulateDisputeModal$update, apiClient, subMsg, simulateDisputeModal);
                    var _v13 = function() {
                        var _v14 = simulateDisputeModalResult.adu;
                        switch(_v14){
                            case 2:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(simulateDisputeModalResult.zi), 0);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 4);
                        }
                    }();
                    var simulateDisputeModal_ = _v13.a;
                    var event = _v13.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeModalMsg, simulateDisputeModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            kf: simulateDisputeModal_
                        }),
                        at: simulateDisputeModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 11:
                var payment = msg.a;
                var dispute = msg.b;
                var _v15 = A4($author$project$Components$Rainforest$SimulateDisputeEventModal$init, model.vK, model.Z$, payment, dispute);
                var simulateDisputeEventModal = _v15.a;
                var simulateDisputeEventModalCmd = _v15.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg, simulateDisputeEventModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        ke: $elm$core$Maybe$Just(simulateDisputeEventModal)
                    }),
                    at: _List_Nil
                };
            case 12:
                var subMsg = msg.a;
                var _v16 = model.ke;
                if (!_v16.$) {
                    var simulateDisputeEventModal = _v16.a;
                    var simulateDisputeEventModalResult = A3($author$project$Components$Rainforest$SimulateDisputeEventModal$update, apiClient, subMsg, simulateDisputeEventModal);
                    var _v17 = function() {
                        var _v18 = simulateDisputeEventModalResult.adu;
                        switch(_v18){
                            case 2:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(simulateDisputeEventModalResult.zi), 0);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 4);
                        }
                    }();
                    var simulateDisputeEventModal_ = _v17.a;
                    var event = _v17.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentsList$SimulateDisputeEventModalMsg, simulateDisputeEventModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            ke: simulateDisputeEventModal_
                        }),
                        at: simulateDisputeEventModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 13:
                var payment = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        cG: $elm$core$Maybe$Just(_Utils_Tuple2(payment, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 16:
                var paymentAndRefund = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        hH: $elm$core$Maybe$Just(paymentAndRefund)
                    }),
                    at: _List_Nil
                };
            case 14:
                var payment = msg.a;
                var confirmed = msg.b;
                return confirmed ? {
                    EQ: A5($author$project$Api$Payment$cancel, model.vK, apiClient, model.Z$, $author$project$Api$Payment$id(payment), $author$project$Components$PaymentsList$GotCancelPayment),
                    adu: 0,
                    zi: _Utils_update(model, {
                        cG: $elm$core$Maybe$Just(_Utils_Tuple2(payment, $author$project$Api$Data$Loading))
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        cG: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 15:
                var response = msg.a;
                var _v19 = model.cG;
                if (!_v19.$) {
                    var _v20 = _v19.a;
                    var payment = _v20.a;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: _Utils_update(model, {
                            cG: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            cG: $elm$core$Maybe$Just(_Utils_Tuple2(payment, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 17:
                var confirmed = msg.a;
                return {
                    EQ: function() {
                        var _v22 = _Utils_Tuple2(confirmed, model.hH);
                        if (_v22.a && !_v22.b.$) {
                            var _v23 = _v22.b.a;
                            var payment = _v23.a;
                            var refund = _v23.b;
                            var paymentPath = A2($author$project$Api$Payment$paymentPath, model.vK, $author$project$Api$Payment$id(payment));
                            return A4($author$project$Api$Provider$Refund$cancel, paymentPath, apiClient, $author$project$Api$Refund$id(refund), $author$project$Components$PaymentsList$GotRefundCancelled);
                        } else return $elm$core$Platform$Cmd$none;
                    }(),
                    adu: 0,
                    zi: _Utils_update(model, {
                        hH: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: function() {
                        if (response.$ === 3) return 3;
                        else return 0;
                    }(),
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Ui$Popover$update = F2(function(msg, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            Vw: false
        });
    });
    var $author$project$Components$Invoice$PaymentsHistory$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var popover = A3($author$project$Ui$Popover$init, 'payment-history', !$author$project$Ui$Popover$isOpen(model.aN), $author$project$Components$Invoice$PaymentsHistory$PopoverMsg);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        aN: popover
                    }),
                    at: _List_Nil
                };
            case 1:
                var subMsg = msg.a;
                var paymentsListResult = A3($author$project$Components$PaymentsList$update, apiClient, subMsg, model.jt);
                var event = function() {
                    var _v1 = paymentsListResult.adu;
                    switch(_v1){
                        case 0:
                            return 0;
                        case 1:
                            return 1;
                        case 2:
                            return 2;
                        case 3:
                            return 3;
                        default:
                            return 4;
                    }
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg, paymentsListResult.EQ),
                    adu: event,
                    zi: _Utils_update(model, {
                        jt: paymentsListResult.zi
                    }),
                    at: paymentsListResult.at
                };
            default:
                var subMsg = msg.a;
                var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aN);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        aN: popoverModel
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    W3: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.l_);
                var dropdownMenu = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    l_: dropdownMenu
                }), cmd, _List_Nil);
            case 2:
                var practiceInvoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    tG: $elm$core$Maybe$Just(_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var practiceInvoice = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    tG: $elm$core$Maybe$Just(_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$PracticeInvoice$cancel, model.Ej, $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice), $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Voided), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    tG: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    W3: response,
                    tG: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var practiceInvoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$PracticeInvoice$issue, model.Ej, $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice), $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issued), _List_Nil);
            case 6:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    W3: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice issued')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var practiceInvoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Just(_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var practiceInvoice = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Just(_Utils_Tuple2(practiceInvoice, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$PracticeInvoice$delete, model.Ej, $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice), $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Deleted), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Nothing
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice removed')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 12:
                var practiceInvoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A7($author$project$Api$Payment$create, $author$project$Api$Data$providerPath, model.Ej, model.Z$, 'practice_invoice_id', $author$project$Api$Provider$PracticeInvoice$One$id(practiceInvoice), {
                    Jh: $author$project$Currency$fromInt($author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)),
                    ace: $elm$core$Maybe$Nothing,
                    Po: false,
                    ae0: $elm$core$Maybe$Nothing,
                    VQ: $elm$core$Maybe$Nothing,
                    ahd: $elm$core$Maybe$Nothing,
                    ahe: $elm$core$Maybe$Nothing,
                    Hw: A2($elm$core$Maybe$map, function(source) {
                        return {
                            aef: $author$project$Api$Common$Source$Shared$id(source),
                            ah5: $author$project$Api$Common$Source$Shared$type_(source)
                        };
                    }, $author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)),
                    aht: $elm$core$Maybe$Nothing
                }, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Paid), _List_Nil);
            case 13:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Billing), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice paid successfully!')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                var practiceInvoice = msg.a;
                var _v6 = $author$project$Components$Invoice$CreatePaymentModal$init(model.cP)(model.HO)($author$project$Api$Data$providerPath)($elm$core$Maybe$Just($author$project$Api$Data$providerPath))(model.Ej)(model.Z$)($author$project$Api$Practice$Provider(model.W1))(model.F3)(model.sp)(function(d) {
                    return _Utils_update(d, {
                        Po: true,
                        or: model.F3
                    });
                })(A2($author$project$Components$Invoice$CreatePaymentModal$PracticeInvoice, $author$project$Api$Provider$Practice$One$id(model.W1), practiceInvoice));
                var createPaymentModal = _v6.a;
                var createPaymentModalCmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    lH: $elm$core$Maybe$Just(createPaymentModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg, createPaymentModalCmd), _List_Nil);
            case 15:
                var subMsg = msg.a;
                var paymentsHistoryResult = A3($author$project$Components$Invoice$PaymentsHistory$update, model.Ej, subMsg, model.js);
                var _v7 = function() {
                    var _v8 = paymentsHistoryResult.adu;
                    switch(_v8){
                        case 0:
                            return _Utils_Tuple2(model.W3, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Ej, model.aef, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
                        case 2:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Ej, model.aef, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
                        case 3:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Ej, model.aef, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
                        default:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Ej, model.aef, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
                    }
                }();
                var practiceInvoice = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    js: paymentsHistoryResult.zi,
                    W3: practiceInvoice
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg, paymentsHistoryResult.EQ),
                    cmd
                ])), paymentsHistoryResult.at);
            case 16:
                var subMsg = msg.a;
                var _v9 = model.lH;
                if (!_v9.$) {
                    var createPaymentModal = _v9.a;
                    var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.Ej, subMsg, createPaymentModal);
                    var _v10 = function() {
                        var _v11 = createPaymentModalResult.adu;
                        switch(_v11){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createPaymentModalResult.zi), model.W3, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A3($author$project$Api$Provider$PracticeInvoice$retrieve, model.Ej, model.aef, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$GotPracticeInvoice));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.W3, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var createPaymentModal_ = _v10.a;
                    var practiceInvoice = _v10.b;
                    var cmd = _v10.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lH: createPaymentModal_,
                        W3: practiceInvoice
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg, createPaymentModalResult.EQ),
                        cmd
                    ])), createPaymentModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var subMsg = msg.a;
                var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.Ej, subMsg, model.it);
                return _Utils_Tuple3(_Utils_update(model, {
                    it: downloadInvoiceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg, downloadInvoiceResult.EQ), downloadInvoiceResult.at);
            case 18:
                var practiceInvoice = msg.a;
                var _v12 = A2($author$project$Components$HintBilling$CreateChargeModal$init, model.Ej, $elm$core$Maybe$Just(practiceInvoice));
                var createChargeModal = _v12.a;
                var createChargeModalCmd = _v12.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    hZ: $elm$core$Maybe$Just(createChargeModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg, createChargeModalCmd), _List_Nil);
            case 19:
                var subMsg = msg.a;
                var _v13 = model.hZ;
                if (!_v13.$) {
                    var createChargeModal = _v13.a;
                    var result = A2($author$project$Components$HintBilling$CreateChargeModal$update, subMsg, createChargeModal);
                    var _v14 = function() {
                        var _v15 = result.adu;
                        switch(_v15.$){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
                            case 2:
                                var chargeParams = _v15.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A3($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$adjustInvoiceAction, model.Ej, model.W3, chargeParams), $author$project$Api$Data$Loading);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Just(result.zi), $elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
                        }
                    }();
                    var createChargeModal_ = _v14.a;
                    var cmd = _v14.b;
                    var saveRequest_ = _v14.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        hZ: createChargeModal_,
                        j_: saveRequest_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg, result.EQ),
                        cmd
                    ])), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    W3: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice adjusted')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    W3: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice refunded')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Formatters$Time$Date__Friendly = 6;
    var $author$project$Ui$Pull$Left = 0;
    var $author$project$Formatters$Time$Time__Friendly = 2;
    var $author$project$Ui$Margin$Top_0 = 19;
    var $author$project$Ui$Breadcrumb$Active = $elm$core$Basics$identity;
    var $author$project$Ui$Breadcrumb$active = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$One$address = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.II;
    });
    var $author$project$Api$Provider$PracticeInvoice$One$autoPayDate = function(_v0) {
        var record = _v0.b;
        return record.JV;
    };
    var $author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled = function(_v0) {
        var record = _v0.b;
        return record.JW;
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$chargeModalTitle = function(practiceInvoiceData) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(status) {
            return !status ? 'Add Credit & Refund' : 'Add Charge or Credit';
        }, A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeInvoice$One$status, $author$project$Api$Data$toMaybe(practiceInvoiceData))));
    };
    var $author$project$Api$Provider$PracticeInvoice$One$charges = function(_v0) {
        var record = _v0.b;
        return record.K9;
    };
    var $author$project$Ui$Form$Group$Clearfix = {
        $: 7
    };
    var $author$project$Ui$Form$Group$clearfix = $author$project$Ui$Form$Group$Clearfix;
    var $author$project$Api$Provider$PracticeInvoice$One$date = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceDate(shared);
    };
    var $author$project$Components$HiConfirm$Detail = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$detail = $author$project$Components$HiConfirm$Detail;
    var $agustinrhcp$elm_mask$Mask$defaultConfig = {
        Ei: '*',
        Fg: '#'
    };
    var $agustinrhcp$elm_mask$Mask$Pattern = $elm$core$Basics$identity;
    var $agustinrhcp$elm_mask$Mask$Any = {
        $: 1
    };
    var $agustinrhcp$elm_mask$Mask$Digit = {
        $: 2
    };
    var $agustinrhcp$elm_mask$Mask$Symbol = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $agustinrhcp$elm_mask$Mask$charToToken = F2(function(_v0, _char) {
        var digitChar = _v0.Fg;
        var anyChar = _v0.Ei;
        return _Utils_eq(_char, digitChar) ? $agustinrhcp$elm_mask$Mask$Digit : _Utils_eq(_char, anyChar) ? $agustinrhcp$elm_mask$Mask$Any : $agustinrhcp$elm_mask$Mask$Symbol(_char);
    });
    var $agustinrhcp$elm_mask$Mask$tokens = F2(function(conf, string) {
        return A2($elm$core$List$map, $agustinrhcp$elm_mask$Mask$charToToken(conf), $elm$core$String$toList(string));
    });
    var $agustinrhcp$elm_mask$Mask$fromStringWithConf = F2(function(conf, string) {
        return A2($agustinrhcp$elm_mask$Mask$tokens, conf, string);
    });
    var $agustinrhcp$elm_mask$Mask$fromString = $agustinrhcp$elm_mask$Mask$fromStringWithConf($agustinrhcp$elm_mask$Mask$defaultConfig);
    var $author$project$Formatters$Phone$phoneMask = '(###) ###-####';
    var $author$project$Formatters$Phone$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Formatters$Phone$phoneMask);
    var $author$project$Formatters$Phone$format = function(phoneNumber) {
        return A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Formatters$Phone$phonePattern, phoneNumber);
    };
    var $author$project$Api$Provider$PracticeCharge$Shared$fromRecurringCharge = function(_v0) {
        var record = _v0;
        return record.P$;
    };
    var $author$project$Ui$Typography$HintLabel = {
        $: 18
    };
    var $author$project$Ui$Typography$hintLabel = $author$project$Ui$Typography$HintLabel;
    var $author$project$Ui$Breadcrumb$Item = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Breadcrumb$item = $author$project$Ui$Breadcrumb$Item;
    var $author$project$Ui$Form$Group$Margin = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$margin = $author$project$Ui$Form$Group$Margin;
    var $author$project$Components$HiConfirm$Noun = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$noun = $author$project$Components$HiConfirm$Noun;
    var $author$project$Components$HiConfirm$Verb = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$verb = $author$project$Components$HiConfirm$Verb;
    var $author$project$Components$Invoice$RefundModal$AmountInCents = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$RefundModal$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$RefundModal$Memo = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$RefundModal$Save = {
        $: 2
    };
    var $author$project$Ui$Typography$Numeric = {
        $: 19
    };
    var $author$project$Ui$Typography$numeric = $author$project$Ui$Typography$Numeric;
    var $author$project$Api$Provider$Payment$Shared$paidAt = function(_v0) {
        var record = _v0;
        return record.VQ;
    };
    var $author$project$Api$Provider$Payment$One$paidAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$paidAt(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$paidAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$paidAt(shared);
    };
    var $author$project$Api$Payment$paidAt = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$paidAt(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$paidAt(payment_);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Employer$Payment$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Employer$Payment$One$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$paymentProcessor(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$Payment$One$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$paymentProcessor(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$paymentProcessor(shared);
    };
    var $author$project$Api$Payment$paymentProcessor = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$paymentProcessor(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$paymentProcessor(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$paymentProcessor(payment_);
        }
    };
    var $author$project$Components$PaymentSourceDisplayer$PaymentProcessor = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$paymentProcessor = $author$project$Components$PaymentSourceDisplayer$PaymentProcessor;
    var $author$project$Api$Employer$Payment$Shared$source = function(_v0) {
        var record = _v0;
        return record.Hw;
    };
    var $author$project$Api$Employer$Payment$One$source = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$source(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$source = function(_v0) {
        var record = _v0;
        return record.Hw;
    };
    var $author$project$Api$Provider$Payment$One$source = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$source(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$source = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$source(shared);
    };
    var $author$project$Api$Payment$source = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$source(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$source(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$source(payment_);
        }
    };
    var $author$project$Components$Invoice$RefundModal$viewExternalRefundAlert = function(oldPaymentProcessorPayment) {
        return A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
            oldPaymentProcessorPayment ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(10)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('This refund can no longer be processed in this platform and must be processed externally. By continuing, you acknowledge that you are responsible for refunding the sponsor outside of this platform.')
                            ]))
                        ]))
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Currency$zero = '0';
    var $author$project$Components$Invoice$RefundModal$view = function(_v0) {
        var model = _v0;
        var source_ = $author$project$Api$Payment$source(model.Wk);
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Invoice$RefundModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(model.qF ? 'Record Refund' : 'Process Refund')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Invoice$RefundModal$Save),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    $author$project$Components$Invoice$RefundModal$viewExternalRefundAlert(model.Gz),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Payment'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, model.HO(5), $author$project$Api$Payment$paidAt(model.Wk)))),
                            $author$project$Api$Payment$external(model.Wk) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
                            A2($author$project$Components$PaymentSourceDisplayer$view, model.HO, _List_fromArray([
                                $author$project$Components$PaymentSourceDisplayer$source(A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source_)),
                                $author$project$Components$PaymentSourceDisplayer$limitedView(true),
                                $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                                $author$project$Components$PaymentSourceDisplayer$paymentProcessor($author$project$Api$Payment$paymentProcessor(model.Wk))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label(model.vs ? 'Available' : 'Refund'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$numeric
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt(fields.nr))
                            ]))
                        ]))
                    ])),
                    model.vs ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Refund'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                            $author$project$Ui$Form$CurrencyInput$value(fields.Jh),
                            $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$RefundModal$FormUpdated, $author$project$Components$Invoice$RefundModal$AmountInCents)),
                            $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Ui$Form$CurrencyInput$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                        ]))
                    ])) : $author$project$Utils$Html$empty,
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Memo'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.ae0)),
                            $author$project$Ui$Form$Input$placeholder('Additional notes about this refund'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$RefundModal$FormUpdated, $author$project$Components$Invoice$RefundModal$Memo))
                        ]))
                    ]))
                ])),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$RefundModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                function() {
                    var label = A2($elm$core$String$join, ' ', _List_fromArray([
                        model.qF ? 'Record' : 'Process',
                        $author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Jh)),
                        'Refund'
                    ]));
                    return A3($author$project$Ui$Button$view, {
                        abP: label
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                        $author$project$Ui$Button$onClick($author$project$Components$Invoice$RefundModal$Save)
                    ]), _List_fromArray([
                        $elm$html$Html$text(label)
                    ]));
                }()
            ]))
        ]));
    };
    var $author$project$WebComponents$Rainforest$ChargebackRespond$view = F2(function(onClose, data) {
        return A3($elm$html$Html$node, 'rainforest-chargeback-respond', _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'session-key', data.ahi),
            A2($elm$html$Html$Attributes$attribute, 'chargeback-id', data.acp),
            A2($elm$html$Html$Attributes$attribute, 'show-respond-button', 'true'),
            A2($elm$html$Html$Attributes$attribute, 'hide-metadata', 'true'),
            A2($elm$html$Html$Attributes$attribute, 'hide-related-info', 'true'),
            A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
            A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
            A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
            A2($elm$html$Html$Events$on, 'close-button-clicked', $elm$json$Json$Decode$succeed(onClose))
        ]), _List_Nil);
    });
    var $author$project$Components$DisputeModal$view = F2(function(onClose, model) {
        return A3($author$project$Ui$Modal$view, onClose, _List_Nil, _Utils_ap(function() {
            var _v0 = model.N7;
            if (_v0.$ === 2) return _List_Nil;
            else return _List_fromArray([
                $author$project$Ui$Modal$header(_List_Nil)
            ]);
        }(), _List_fromArray([
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    var _v1 = model.N7;
                    switch(_v1.$){
                        case 0:
                            return $elm$html$Html$text('Loading...');
                        case 1:
                            return $elm$html$Html$text('There was an error loading the dispute');
                        default:
                            if (!_v1.a.$) {
                                var session = _v1.a.a;
                                return A2($author$project$WebComponents$Rainforest$ChargebackRespond$view, onClose, session);
                            } else {
                                var session = _v1.a.a;
                                return A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$id('stripe-payment-disputes-' + session.acj)
                                ]), _List_Nil);
                            }
                    }
                }()
            ]))
        ])));
    });
    var $author$project$Components$PaymentDisputeModal$viewModal = F2(function(onClose, text) {
        return A3($author$project$Ui$Modal$view, onClose, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_Nil),
            $author$project$Ui$Modal$body(_List_fromArray([
                $elm$html$Html$text(text)
            ]))
        ]));
    });
    var $author$project$Components$PaymentDisputeModal$view = F2(function(onClose, model) {
        var _v0 = model.N7;
        switch(_v0.$){
            case 2:
                return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'Loading...');
            case 0:
                var disputeModal = _v0.a;
                return A2($author$project$Components$DisputeModal$view, onClose, disputeModal);
            case 3:
                return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'There was an error loading the dispute');
            default:
                return A2($author$project$Components$PaymentDisputeModal$viewModal, onClose, 'There was an error loading the dispute');
        }
    });
    var $author$project$Ui$Modal$Xl = 3;
    var $author$project$Components$Rainforest$SessionModal$resourceDescription = function(resource) {
        switch(resource.$){
            case 0:
                return 'deposit';
            case 1:
                return 'payment';
            default:
                return 'refund';
        }
    };
    var $author$project$WebComponents$Rainforest$DepositDetails$view = function(data) {
        return A3($elm$html$Html$node, 'rainforest-deposit-details', _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'session-key', data.ahi),
            A2($elm$html$Html$Attributes$attribute, 'deposit-id', data.ac5),
            A2($elm$html$Html$Attributes$attribute, 'show-payin-signature', ''),
            A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
            A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
            A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
            A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
        ]), _List_Nil);
    };
    var $author$project$WebComponents$Rainforest$PayinDetails$view = function(data) {
        return A3($elm$html$Html$node, 'rainforest-payin-details', _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'session-key', data.ahi),
            A2($elm$html$Html$Attributes$attribute, 'payin-id', data.Wi),
            A2($elm$html$Html$Attributes$attribute, 'show-signature', ''),
            A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
            A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
            A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
            A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
        ]), _List_Nil);
    };
    var $author$project$WebComponents$Rainforest$RefundDetails$view = function(data) {
        return A3($elm$html$Html$node, 'rainforest-refund-details', _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'session-key', data.ahi),
            A2($elm$html$Html$Attributes$attribute, 'refund-id', data.agB),
            A2($elm$html$Html$Attributes$attribute, 'parent-payin-id', data.Wi),
            A2($elm$html$Html$Attributes$attribute, 'show-signature', ''),
            A2($elm$html$Html$Attributes$attribute, 'hide-actions', ''),
            A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
            A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
            A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'Avenir')
        ]), _List_Nil);
    };
    var $author$project$Components$Rainforest$SessionModal$view = F2(function(onClose, model) {
        return A3($author$project$Ui$Modal$view, onClose, _List_fromArray([
            $author$project$Ui$Modal$size(3)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_Nil),
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    var _v0 = model.Z$;
                    switch(_v0.$){
                        case 0:
                            return $elm$html$Html$text('Loading...');
                        case 1:
                            return $elm$html$Html$text('There was an error loading the ' + $author$project$Components$Rainforest$SessionModal$resourceDescription(model.Hg));
                        default:
                            var session = _v0.a;
                            var _v1 = model.Hg;
                            switch(_v1.$){
                                case 0:
                                    return $author$project$WebComponents$Rainforest$DepositDetails$view({
                                        ac5: session.ags,
                                        ahi: session.agu
                                    });
                                case 1:
                                    return $author$project$WebComponents$Rainforest$PayinDetails$view({
                                        Wi: session.ags,
                                        ahi: session.agu
                                    });
                                default:
                                    return $author$project$WebComponents$Rainforest$RefundDetails$view({
                                        Wi: A2($elm$core$Maybe$withDefault, '', session.agr),
                                        agB: session.ags,
                                        ahi: session.agu
                                    });
                            }
                    }
                }()
            ]))
        ]));
    });
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$SimulateDisputeEvent = {
        $: 2
    };
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$StatusSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$statusOptions = A2($elm$core$List$map, function(status) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(status), status);
    }, $author$project$Components$Rainforest$SimulateDisputeEventModal$statuses);
    var $author$project$Components$Rainforest$SimulateDisputeEventModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Simulate Dispute Event')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('Simulate a dispute event for testing purposes.')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Status'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(model.ahy)),
                        $author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateDisputeEventModal$StatusSelected)
                    ]), $author$project$Components$Rainforest$SimulateDisputeEventModal$statusOptions)
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeEventModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Simulate Dispute Event'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeEventModal$SimulateDisputeEvent),
                    $author$project$Ui$Button$loading(_Utils_eq(model.ox, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Simulate Dispute Event')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Rainforest$SimulateDisputeModal$SimulateDispute = {
        $: 2
    };
    var $author$project$Components$Rainforest$SimulateDisputeModal$StatusSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Rainforest$SimulateDisputeModal$statusOptions = A2($elm$core$List$map, function(status) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(status), status);
    }, $author$project$Components$Rainforest$SimulateDisputeModal$statuses);
    var $author$project$Components$Rainforest$SimulateDisputeModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Rainforest$SimulateDisputeModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Simulate Dispute')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('Simulate a dispute for testing purposes. This will mark the payment as disputed.')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Status'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(model.ahy)),
                        $author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateDisputeModal$StatusSelected)
                    ]), $author$project$Components$Rainforest$SimulateDisputeModal$statusOptions)
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Simulate Dispute'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateDisputeModal$SimulateDispute),
                    $author$project$Ui$Button$loading(_Utils_eq(model.oy, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Simulate Dispute')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$PaymentsList$modal = function(_v0) {
        var refundModal = _v0.jM;
        var paymentDisputeModal = _v0.gn;
        var rainforestPaymentModal = _v0.eu;
        var simulateDisputeModal = _v0.kf;
        var simulateDisputeEventModal = _v0.ke;
        var cancelingPayment = _v0.cG;
        var cancellingRefund = _v0.hH;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Invoice$RefundModal$view, $elm$html$Html$map($author$project$Components$PaymentsList$RefundModalMsg)), refundModal)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$PaymentDisputeModal$view($author$project$Components$PaymentsList$ClosePaymentDisputeModal), paymentDisputeModal)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$Rainforest$SessionModal$view($author$project$Components$PaymentsList$CloseRainforestPaymentModal), rainforestPaymentModal)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$SimulateDisputeModal$view, $elm$html$Html$map($author$project$Components$PaymentsList$SimulateDisputeModalMsg)), simulateDisputeModal)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$SimulateDisputeEventModal$view, $elm$html$Html$map($author$project$Components$PaymentsList$SimulateDisputeEventModalMsg)), simulateDisputeEventModal)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(_v1) {
                var payment = _v1.a;
                var cancelRequest = _v1.b;
                return A2($author$project$Components$HiConfirm$modal, $author$project$Components$PaymentsList$CancelPaymentHiConfirmClosed(payment), _List_fromArray([
                    $author$project$Components$HiConfirm$verb('cancel'),
                    $author$project$Components$HiConfirm$noun('payment'),
                    $author$project$Components$HiConfirm$loading(_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
                ]));
            }, cancelingPayment)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(_v2) {
                return A2($author$project$Components$HiConfirm$modal, $author$project$Components$PaymentsList$CancelRefundConfirmed, _List_fromArray([
                    $author$project$Components$HiConfirm$verb('cancel'),
                    $author$project$Components$HiConfirm$noun('refund')
                ]));
            }, cancellingRefund))
        ]));
    };
    var $author$project$Components$Invoice$PaymentsHistory$modal = function(model) {
        return A2($elm$html$Html$map, $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg, $author$project$Components$PaymentsList$modal(model.jt));
    };
    var $author$project$Api$Provider$Practice$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Practice$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$name(shared);
    };
    var $author$project$Api$Common$Phone$Shared$number = function(_v0) {
        var record = _v0;
        return record.Gx;
    };
    var $author$project$Api$Provider$PracticeInvoice$One$number = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$invoiceNumber(shared);
    };
    var $author$project$Api$Provider$PracticeInvoice$One$paidAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$paidAt(shared);
    };
    var $elm$core$List$partition = F2(function(pred, list) {
        var step = F2(function(x, _v0) {
            var trues = _v0.a;
            var falses = _v0.b;
            return pred(x) ? _Utils_Tuple2(A2($elm$core$List$cons, x, trues), falses) : _Utils_Tuple2(trues, A2($elm$core$List$cons, x, falses));
        });
        return A3($elm$core$List$foldr, step, _Utils_Tuple2(_List_Nil, _List_Nil), list);
    });
    var $author$project$Api$Provider$PracticeInvoice$One$payments = function(_v0) {
        var record = _v0.b;
        return record.Wt;
    };
    var $author$project$Api$Provider$Practice$One$phones = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.WG;
    });
    var $author$project$Ui$Typography$Pull = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Typography$pull = $author$project$Ui$Typography$Pull;
    var $author$project$Api$Provider$PracticeInvoice$One$purchaseOrderNumber = function(_v0) {
        var record = _v0.b;
        return record.XO;
    };
    var $author$project$Formatters$Bool$toString = function(bool) {
        return bool ? 'Yes' : 'No';
    };
    var $author$project$Api$Provider$PracticeInvoice$One$totalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$totalInCents(shared);
    };
    var $author$project$Api$Common$Address$Shared$city = function(_v0) {
        var record = _v0;
        return record.pW;
    };
    var $author$project$Api$Common$Address$Shared$line1 = function(_v0) {
        var record = _v0;
        return record.ri;
    };
    var $author$project$Api$Common$Address$Shared$line2 = function(_v0) {
        var record = _v0;
        return record.yG;
    };
    var $author$project$Api$Common$Address$Shared$state = function(_v0) {
        var record = _v0;
        return record.s4;
    };
    var $author$project$Components$AddressDisplay$viewField = F3(function(breakLike, getter, address) {
        var _v0 = getter(address);
        if (!_v0.$) {
            if (_v0.a === '') return $author$project$Utils$Html$empty;
            else {
                var string = _v0.a;
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(string),
                    breakLike ? A2($elm$html$Html$br, _List_Nil, _List_Nil) : $author$project$Utils$Html$empty
                ]));
            }
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Common$Address$Shared$zip = function(_v0) {
        var record = _v0;
        return record.tK;
    };
    var $author$project$Components$AddressDisplay$view = function(address) {
        return A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$phi(true)
        ]), _List_fromArray([
            A3($author$project$Components$AddressDisplay$viewField, true, $author$project$Api$Common$Address$Shared$line1, address),
            A3($author$project$Components$AddressDisplay$viewField, true, $author$project$Api$Common$Address$Shared$line2, address),
            function() {
                var _v0 = A2($elm$core$Maybe$map, $elm$core$String$trim, $author$project$Api$Common$Address$Shared$city(address));
                if (!_v0.$) {
                    if (_v0.a === '') return $author$project$Utils$Html$empty;
                    else {
                        var city = _v0.a;
                        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(city),
                            $elm$html$Html$text(', '),
                            A3($author$project$Components$AddressDisplay$viewField, false, $author$project$Api$Common$Address$Shared$state, address),
                            $author$project$Utils$Html$noBreakSpace,
                            A3($author$project$Components$AddressDisplay$viewField, false, $author$project$Api$Common$Address$Shared$zip, address)
                        ]));
                    }
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$CardReader$SimulateForm$Card = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CardReader$SimulateForm$Event = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CardReader$SimulateForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CardReader$SimulateForm$Simulate = {
        $: 1
    };
    var $author$project$Components$CardReader$SimulateForm$cards = _List_fromArray([
        'VISA_SUCCESS',
        'VISA_42_SUCCESS',
        'VISA_DEBIT_SUCCESS',
        'MC_SUCCESS',
        'MC_2_SUCCESS',
        'MC_DEBIT_SUCCESS',
        'MC_PREPAID_SUCCESS',
        'AMEX_SUCCESS',
        'AMEX_2_SUCCESS',
        'DISCOVER_SUCCESS',
        'DISCOVER_2_SUCCESS',
        'DISCOVER_DEBIT_SUCCESS',
        'DINERS_SUCCESS',
        'DINERS_14_SUCCESS'
    ]);
    var $author$project$Components$CardReader$SimulateForm$cardOptions = A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a card...'), A2($elm$core$List$map, function(card) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(card), card);
    }, $author$project$Components$CardReader$SimulateForm$cards));
    var $author$project$Ui$Form$Select$Errors = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$errors = $author$project$Ui$Form$Select$Errors;
    var $author$project$Components$CardReader$SimulateForm$events = _List_fromArray([
        'PRESENTED',
        'CANCEL'
    ]);
    var $author$project$Components$CardReader$SimulateForm$eventOptions = A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose an event...'), A2($elm$core$List$map, function(event) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(event), event);
    }, $author$project$Components$CardReader$SimulateForm$events));
    var $author$project$Ui$Form$Group$Icon = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$icon = $author$project$Ui$Form$Group$Icon;
    var $author$project$Ui$Icon$SpacedRight = {
        $: 4
    };
    var $author$project$Ui$Icon$spacedRight = $author$project$Ui$Icon$SpacedRight;
    var $author$project$Ui$HinterOnly$formGroup = F2(function(options, content) {
        return A2($author$project$Ui$Form$Group$view, A2($elm$core$List$cons, $author$project$Ui$Form$Group$icon($author$project$Ui$HinterOnly$icon(_List_fromArray([
            $author$project$Ui$Icon$spacedRight
        ]))), options), content);
    });
    var $author$project$Components$CardReader$SimulateForm$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Event')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(fields.adu),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$CardReader$SimulateForm$FormUpdated, $author$project$Components$CardReader$SimulateForm$Event)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ]), $author$project$Components$CardReader$SimulateForm$eventOptions)
            ])),
            A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Card')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(fields.acd),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$CardReader$SimulateForm$FormUpdated, $author$project$Components$CardReader$SimulateForm$Card)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                ]), $author$project$Components$CardReader$SimulateForm$cardOptions)
            ])),
            A3($author$project$Ui$HinterOnly$button, {
                abP: 'Simulate'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$onClick($author$project$Components$CardReader$SimulateForm$Simulate),
                $author$project$Ui$Button$loading(_Utils_eq(model.oy, $author$project$Api$Data$Loading))
            ]), _List_fromArray([
                $elm$html$Html$text('Simulate')
            ]))
        ]));
    };
    var $author$project$Components$CardReader$ConnectingModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$CardReader$ConnectingModal$Cancel, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Processing Card')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                ]), _List_fromArray([
                    !model.dC ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty,
                    A2($author$project$Ui$Typography$p, _List_Nil, function() {
                        var _v1 = model.dC;
                        if (!_v1) return _List_fromArray([
                            $elm$html$Html$text('Connecting to your card reader...')
                        ]);
                        else return _List_fromArray([
                            $elm$html$Html$text('Please insert or swipe your credit card into the card reader now.'),
                            function() {
                                var _v2 = model.s$;
                                if (!_v2.$) {
                                    var simulateForm = _v2.a;
                                    return A2($elm$html$Html$map, $author$project$Components$CardReader$ConnectingModal$SimulateFormMsg, $author$project$Components$CardReader$SimulateForm$view(simulateForm));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]);
                    }())
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel card reader connection'
                }, _List_fromArray([
                    $author$project$Ui$Button$fullWidth(true),
                    $author$project$Ui$Button$onClick($author$project$Components$CardReader$ConnectingModal$Cancel),
                    $author$project$Ui$Button$disabled(model.cF)
                ]), _List_fromArray([
                    model.cF ? $elm$html$Html$text('Cancelling') : $elm$html$Html$text('Cancel')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CardReader$PaymentModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$CardReader$PaymentModal$Cancel, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Processing Card')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                ]), _List_fromArray([
                    !model.dC ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty,
                    A2($author$project$Ui$Typography$p, _List_Nil, function() {
                        var _v1 = model.dC;
                        if (!_v1) return _List_fromArray([
                            $elm$html$Html$text('Connecting to your card reader...')
                        ]);
                        else return _List_fromArray([
                            $elm$html$Html$text('Please insert or swipe your credit card into the card reader now.'),
                            function() {
                                var _v2 = model.s$;
                                if (!_v2.$) {
                                    var simulateForm = _v2.a;
                                    return A2($elm$html$Html$map, $author$project$Components$CardReader$PaymentModal$SimulateFormMsg, $author$project$Components$CardReader$SimulateForm$view(simulateForm));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]);
                    }())
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3),
                        $author$project$Ui$Grid$offset(9)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel card reader connection'
                        }, _List_fromArray([
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$onClick($author$project$Components$CardReader$PaymentModal$Cancel),
                            $author$project$Ui$Button$disabled(model.cF)
                        ]), _List_fromArray([
                            model.cF ? $elm$html$Html$text('Cancelling') : $elm$html$Html$text('Cancel')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Invoice$CreatePaymentModal$CreatePayment = {
        $: 4
    };
    var $author$project$Components$DateInput$Value = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$DateInput$value = $author$project$Components$DateInput$Value;
    var $author$project$Ui$Icon$calendar = $author$project$Ui$Icon$viewIcon(57);
    var $author$project$Components$DateInput$Above = 1;
    var $author$project$Components$DateInput$datePickerSettings = function(optionsRecord) {
        var dataAttributes = function() {
            var _v0 = optionsRecord.w9;
            if (!_v0.$) {
                var dataTest = _v0.a;
                return _List_fromArray([
                    $author$project$Utils$Html$Attributes$test(dataTest)
                ]);
            } else return _List_Nil;
        }();
        var baseSettings_ = $author$project$Components$DateInput$baseDatePickerSettings;
        var ariaAttributes = A2($elm$core$List$cons, optionsRecord.q2 ? A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true') : A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'false'), $elm$core$List$isEmpty(optionsRecord.fK) ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-describedby', A2($elm$core$String$join, '. ', optionsRecord.fK))
        ]));
        return _Utils_update(baseSettings_, {
            Rj: A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(optionsRecord.d$), _Utils_ap(baseSettings_.Rj, _Utils_ap(dataAttributes, ariaAttributes))),
            FO: A2($elm$core$List$cons, _Utils_Tuple2('disabled', optionsRecord.d$), A2($elm$core$List$cons, _Utils_Tuple2('feedback-errored', optionsRecord.q2), A2($elm$core$List$cons, _Utils_Tuple2('elm-datepicker--above', optionsRecord.WX === 1), baseSettings_.FO))),
            aeC: optionsRecord.xk,
            r7: optionsRecord.r7
        });
    };
    var $author$project$Components$DateInput$Below = 0;
    var $author$project$Components$DateInput$defaultOptions = {
        vD: _List_Nil,
        w9: $elm$core$Maybe$Nothing,
        d$: false,
        xk: $elm$core$Basics$always(false),
        fK: _List_Nil,
        xW: false,
        q2: false,
        r7: 'Select a Date',
        WX: 0,
        aa9: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$DateInput$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 1:
                    var string = option.a;
                    return _Utils_update(record, {
                        r7: string
                    });
                case 0:
                    var date = option.a;
                    return _Utils_update(record, {
                        aa9: date
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        d$: bool
                    });
                case 3:
                    var bool = option.a;
                    return _Utils_update(record, {
                        q2: bool
                    });
                case 4:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
                case 5:
                    var string = option.a;
                    return _Utils_update(record, {
                        w9: $elm$core$Maybe$Just(string)
                    });
                case 6:
                    var isDisabled = option.a;
                    return _Utils_update(record, {
                        xk: isDisabled
                    });
                case 7:
                    var attributes = option.a;
                    return _Utils_update(record, {
                        vD: _Utils_ap(A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), attributes), record.vD)
                    });
                case 8:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'), record.vD)
                    });
                case 9:
                    var position = option.a;
                    return _Utils_update(record, {
                        WX: position
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        xW: bool
                    });
            }
        }), $author$project$Components$DateInput$defaultOptions, options);
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Blur = {
        $: 6
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Focus = {
        $: 5
    };
    var $agustinrhcp$elm_datepicker$DatePicker$KeyDown = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$SubmitText = {
        $: 4
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Text = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$ChangePicking = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Month = 1;
    var $agustinrhcp$elm_datepicker$DatePicker$MouseDown = {
        $: 7
    };
    var $agustinrhcp$elm_datepicker$DatePicker$MouseUp = {
        $: 8
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Year = 2;
    var $justinmimbs$date$Date$Years = 0;
    var $agustinrhcp$elm_datepicker$DatePicker$Date$changeYear = F2(function(current, newYear) {
        var _v0 = $elm$core$String$toInt(newYear);
        if (!_v0.$) {
            var year = _v0.a;
            return A3($justinmimbs$date$Date$fromCalendarDate, year, $justinmimbs$date$Date$month(current), $justinmimbs$date$Date$day(current));
        } else return current;
    });
    var $agustinrhcp$elm_datepicker$DatePicker$groupDates = function(dates) {
        var go = F4(function(i, xs, racc, acc) {
            go: while(true){
                if (!xs.b) return $elm$core$List$reverse(acc);
                else {
                    var x = xs.a;
                    var xxs = xs.b;
                    if (i === 6) {
                        var $temp$i = 0, $temp$xs = xxs, $temp$racc = _List_Nil, $temp$acc = A2($elm$core$List$cons, $elm$core$List$reverse(A2($elm$core$List$cons, x, racc)), acc);
                        i = $temp$i;
                        xs = $temp$xs;
                        racc = $temp$racc;
                        acc = $temp$acc;
                        continue go;
                    } else {
                        var $temp$i = i + 1, $temp$xs = xxs, $temp$racc = A2($elm$core$List$cons, x, racc), $temp$acc = acc;
                        i = $temp$i;
                        xs = $temp$xs;
                        racc = $temp$racc;
                        acc = $temp$acc;
                        continue go;
                    }
                }
            }
        });
        return A4(go, 0, dates, _List_Nil, _List_Nil);
    };
    var $agustinrhcp$elm_datepicker$DatePicker$maybeOr = F2(function(lhs, rhs) {
        if (!rhs.$) return rhs;
        else return lhs;
    });
    var $agustinrhcp$elm_datepicker$DatePicker$mkClass = F2(function(_v0, c) {
        var classNamespace = _v0.lx;
        return $elm$html$Html$Attributes$class(_Utils_ap(classNamespace, c));
    });
    var $agustinrhcp$elm_datepicker$DatePicker$split = F2(function(into, list) {
        var _v0 = A2($elm$core$List$take, into, list);
        if (!_v0.b) return _List_Nil;
        else {
            var head = _v0;
            return A2($elm$core$List$cons, head, A2($agustinrhcp$elm_datepicker$DatePicker$split, into, A2($elm$core$List$drop, into, list)));
        }
    });
    var $agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $agustinrhcp$elm_datepicker$DatePicker$mkClassList = F2(function(_v0, cs) {
        var classNamespace = _v0.lx;
        return $elm$html$Html$Attributes$classList(A2($elm$core$List$map, function(_v1) {
            var c = _v1.a;
            var b = _v1.b;
            return _Utils_Tuple2(_Utils_ap(classNamespace, c), b);
        }, cs));
    });
    var $agustinrhcp$elm_datepicker$DatePicker$viewMonth = F3(function(focused, settings, month) {
        var year = $justinmimbs$date$Date$year(focused);
        var day = $justinmimbs$date$Date$day(focused);
        return A2($elm$html$Html$td, _List_fromArray([
            A2($agustinrhcp$elm_datepicker$DatePicker$mkClassList, settings, _List_fromArray([
                _Utils_Tuple2('day', true)
            ])),
            $elm$html$Html$Events$onClick(A2($agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking, A3($justinmimbs$date$Date$fromCalendarDate, year, month, day), 0))
        ]), _List_fromArray([
            settings.pS(settings.zl(month))
        ]));
    });
    var $agustinrhcp$elm_datepicker$DatePicker$monthList = F2(function(focused, settings) {
        var months = _List_fromArray([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ]);
        var splitMonths = A2($agustinrhcp$elm_datepicker$DatePicker$split, 3, months);
        return A2($elm$core$List$map, function(monthsRow) {
            return A2($elm$html$Html$tr, _List_Nil, A2($elm$core$List$map, A2($agustinrhcp$elm_datepicker$DatePicker$viewMonth, focused, settings), monthsRow));
        }, splitMonths);
    });
    var $elm$virtual_dom$VirtualDom$keyedNode = function(tag) {
        return _VirtualDom_keyedNode(_VirtualDom_noScript(tag));
    };
    var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
    var $justinmimbs$date$Date$Day = 11;
    var $justinmimbs$date$Date$weekdayToNumber = function(wd) {
        switch(wd){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 3;
            case 3:
                return 4;
            case 4:
                return 5;
            case 5:
                return 6;
            default:
                return 7;
        }
    };
    var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(function(wd, date) {
        return A2($elm$core$Basics$modBy, 7, $justinmimbs$date$Date$weekdayNumber(date) + 7 - $justinmimbs$date$Date$weekdayToNumber(wd));
    });
    var $justinmimbs$date$Date$firstOfMonth = F2(function(y, m) {
        return $justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m) + 1;
    });
    var $justinmimbs$date$Date$quarterToMonth = function(q) {
        return $justinmimbs$date$Date$numberToMonth(q * 3 - 2);
    };
    var $justinmimbs$date$Date$floor = F2(function(interval, date) {
        var rd = date;
        switch(interval){
            case 0:
                return $justinmimbs$date$Date$firstOfYear($justinmimbs$date$Date$year(date));
            case 1:
                return A2($justinmimbs$date$Date$firstOfMonth, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$quarterToMonth($justinmimbs$date$Date$quarter(date)));
            case 2:
                return A2($justinmimbs$date$Date$firstOfMonth, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$month(date));
            case 3:
                return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
            case 4:
                return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
            case 5:
                return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
            case 6:
                return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
            case 7:
                return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
            case 8:
                return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
            case 9:
                return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
            case 10:
                return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
            default:
                return date;
        }
    });
    var $justinmimbs$date$Date$Weeks = 2;
    var $justinmimbs$date$Date$intervalToUnits = function(interval) {
        switch(interval){
            case 0:
                return _Utils_Tuple2(1, 0);
            case 1:
                return _Utils_Tuple2(3, 1);
            case 2:
                return _Utils_Tuple2(1, 1);
            case 11:
                return _Utils_Tuple2(1, 3);
            default:
                var week = interval;
                return _Utils_Tuple2(1, 2);
        }
    };
    var $justinmimbs$date$Date$ceiling = F2(function(interval, date) {
        var floored = A2($justinmimbs$date$Date$floor, interval, date);
        if (_Utils_eq(date, floored)) return date;
        else {
            var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
            var n = _v0.a;
            var unit = _v0.b;
            return A3($justinmimbs$date$Date$add, unit, n, floored);
        }
    });
    var $justinmimbs$date$Date$rangeHelp = F5(function(unit, step, until, revList, current) {
        rangeHelp: while(true){
            if (_Utils_cmp(current, until) < 0) {
                var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
                var next = _v0;
                var $temp$unit = unit, $temp$step = step, $temp$until = until, $temp$revList = A2($elm$core$List$cons, current, revList), $temp$current = next;
                unit = $temp$unit;
                step = $temp$step;
                until = $temp$until;
                revList = $temp$revList;
                current = $temp$current;
                continue rangeHelp;
            } else return $elm$core$List$reverse(revList);
        }
    });
    var $justinmimbs$date$Date$range = F4(function(interval, step, _v0, _v1) {
        var start = _v0;
        var until = _v1;
        var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
        var n = _v2.a;
        var unit = _v2.b;
        var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
        var first = _v3;
        return _Utils_cmp(first, until) < 0 ? A5($justinmimbs$date$Date$rangeHelp, unit, A2($elm$core$Basics$max, 1, step) * n, until, _List_Nil, first) : _List_Nil;
    });
    var $justinmimbs$date$Date$Friday = 8;
    var $justinmimbs$date$Date$Monday = 4;
    var $justinmimbs$date$Date$Saturday = 9;
    var $justinmimbs$date$Date$Sunday = 10;
    var $justinmimbs$date$Date$Thursday = 7;
    var $justinmimbs$date$Date$Tuesday = 5;
    var $justinmimbs$date$Date$Wednesday = 6;
    var $agustinrhcp$elm_datepicker$DatePicker$Date$weekdayToInterval = function(weekday) {
        switch(weekday){
            case 0:
                return 4;
            case 1:
                return 5;
            case 2:
                return 6;
            case 3:
                return 7;
            case 4:
                return 8;
            case 5:
                return 9;
            default:
                return 10;
        }
    };
    var $agustinrhcp$elm_datepicker$DatePicker$prepareDates = F2(function(date, firstDayOfWeek) {
        var weekdayAsInterval = $agustinrhcp$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
        var start = A2($justinmimbs$date$Date$floor, weekdayAsInterval, A3($justinmimbs$date$Date$fromCalendarDate, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$month(date), 1));
        var firstOfMonth = A3($justinmimbs$date$Date$fromCalendarDate, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$month(date), 1);
        var end = A2($justinmimbs$date$Date$ceiling, weekdayAsInterval, A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
        return {
            MK: A4($justinmimbs$date$Date$range, 11, 1, start, end),
            E$: date
        };
    });
    var $justinmimbs$date$Date$toRataDie = function(_v0) {
        var rd = _v0;
        return rd;
    };
    var $agustinrhcp$elm_datepicker$DatePicker$Pick = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $agustinrhcp$elm_datepicker$DatePicker$viewDay = F5(function(settings, picked, isOtherMonth, isToday, d) {
        var disabled = settings.aeC(d);
        var props = !disabled ? _List_fromArray([
            $elm$html$Html$Events$onClick($agustinrhcp$elm_datepicker$DatePicker$Pick(d))
        ]) : _List_Nil;
        var classList = $agustinrhcp$elm_datepicker$DatePicker$mkClassList(settings);
        return A2($elm$html$Html$td, A2($elm$core$List$cons, classList(_List_fromArray([
            _Utils_Tuple2('day', true),
            _Utils_Tuple2('disabled', disabled),
            _Utils_Tuple2('picked', picked(d)),
            _Utils_Tuple2('today', isToday(d)),
            _Utils_Tuple2('other-month', isOtherMonth(d))
        ])), props), _List_fromArray([
            settings.pS($elm$core$String$fromInt($justinmimbs$date$Date$day(d)))
        ]));
    });
    var $agustinrhcp$elm_datepicker$DatePicker$viewYear = F3(function(focused, settings, year) {
        var month = $justinmimbs$date$Date$month(focused);
        var day = $justinmimbs$date$Date$day(focused);
        return A2($elm$html$Html$td, _List_fromArray([
            A2($agustinrhcp$elm_datepicker$DatePicker$mkClassList, settings, _List_fromArray([
                _Utils_Tuple2('day', true)
            ])),
            $elm$html$Html$Events$onClick(A2($agustinrhcp$elm_datepicker$DatePicker$ChangeFocusAndPicking, A3($justinmimbs$date$Date$fromCalendarDate, year, month, day), 1))
        ]), _List_fromArray([
            settings.pS(settings.pi(year))
        ]));
    });
    var $agustinrhcp$elm_datepicker$DatePicker$yearList = F2(function(focused, settings) {
        var focusedYear = $justinmimbs$date$Date$year(focused);
        var years = A2($elm$core$List$range, focusedYear - 1, focusedYear + 10);
        var splitYears = A2($agustinrhcp$elm_datepicker$DatePicker$split, 3, years);
        return A2($elm$core$List$map, function(yearsRow) {
            return A2($elm$html$Html$tr, _List_Nil, A2($elm$core$List$map, A2($agustinrhcp$elm_datepicker$DatePicker$viewYear, focused, settings), yearsRow));
        }, splitYears);
    });
    var $agustinrhcp$elm_datepicker$DatePicker$Date$yearRange = F2(function(_v0, range) {
        var currentMonth = _v0.E$;
        var today = _v0.aae;
        switch(range.$){
            case 1:
                var num = range.a;
                return A2($elm$core$List$range, $justinmimbs$date$Date$year(currentMonth) - num, $justinmimbs$date$Date$year(currentMonth) + num);
            case 2:
                var start = range.a;
                var end = range.b;
                return A2($elm$core$List$range, start, end);
            case 3:
                var year_ = range.a;
                return A2($elm$core$List$range, year_, $justinmimbs$date$Date$year(today));
            case 4:
                var year_ = range.a;
                return A2($elm$core$List$range, $justinmimbs$date$Date$year(today), year_);
            default:
                return _List_Nil;
        }
    });
    var $agustinrhcp$elm_datepicker$DatePicker$yearRangeActive = function(yearRange) {
        return !_Utils_eq(yearRange, $agustinrhcp$elm_datepicker$DatePicker$Date$Off);
    };
    var $agustinrhcp$elm_datepicker$DatePicker$datePicker = F3(function(pickedDate, settings, _v0) {
        var focused = _v0.a8;
        var today = _v0.aae;
        var picking = _v0.jv;
        var picked = function(d) {
            return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(pdate) {
                return _Utils_eq($justinmimbs$date$Date$toRataDie(pdate), $justinmimbs$date$Date$toRataDie(d));
            }, pickedDate));
        };
        var onChange = function(handler) {
            return A2($elm$html$Html$Events$on, 'change', A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
        };
        var isToday = function(d) {
            return _Utils_eq($justinmimbs$date$Date$toRataDie(d), $justinmimbs$date$Date$toRataDie(today));
        };
        var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.adQ) - 1;
        var dpClass = $agustinrhcp$elm_datepicker$DatePicker$mkClass(settings);
        var currentDate = A2($elm$core$Maybe$withDefault, today, A2($agustinrhcp$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
        var isOtherMonth = function(d) {
            return !_Utils_eq($justinmimbs$date$Date$month(currentDate), $justinmimbs$date$Date$month(d));
        };
        var arrow = F2(function(className, message) {
            return A2($elm$html$Html$button, _List_fromArray([
                dpClass(className),
                $elm$html$Html$Events$onClick(message),
                $elm$html$Html$Attributes$tabindex(-1),
                $elm$html$Html$Attributes$type_('button')
            ]), _List_Nil);
        });
        var _v1 = A2($agustinrhcp$elm_datepicker$DatePicker$prepareDates, currentDate, settings.adQ);
        var currentMonth = _v1.E$;
        var currentDates = _v1.MK;
        var dayList = A2($elm$core$List$map, function(rowDays) {
            return A2($elm$html$Html$tr, _List_fromArray([
                dpClass('row')
            ]), A2($elm$core$List$map, A4($agustinrhcp$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday), rowDays));
        }, $agustinrhcp$elm_datepicker$DatePicker$groupDates(currentDates));
        var isCurrentYear = function(selectedYear) {
            return _Utils_eq($justinmimbs$date$Date$year(currentMonth), selectedYear);
        };
        var yearOption = F2(function(index, selectedYear) {
            return _Utils_Tuple2($elm$core$String$fromInt(index), A2($elm$html$Html$option, _List_fromArray([
                $elm$html$Html$Attributes$value($elm$core$String$fromInt(selectedYear)),
                $elm$html$Html$Attributes$selected(isCurrentYear(selectedYear))
            ]), _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt(selectedYear))
            ])));
        });
        var _v2 = function() {
            var front = function(to_) {
                return A2($elm$core$List$range, $justinmimbs$date$Date$year(currentMonth), to_);
            };
            var back = function(from_) {
                return A2($elm$core$List$range, from_, $justinmimbs$date$Date$year(currentMonth));
            };
            var _v3 = settings.hL;
            switch(_v3.$){
                case 3:
                    var from_ = _v3.a;
                    return _Utils_Tuple2(front(from_ - 1), back($justinmimbs$date$Date$year(today) + 1));
                case 4:
                    var to_ = _v3.a;
                    return _Utils_Tuple2(front($justinmimbs$date$Date$year(today) - 1), back(to_ + 1));
                case 2:
                    var from_ = _v3.a;
                    var to_ = _v3.b;
                    return _Utils_Tuple2(front(from_ - 1), back(to_ + 1));
                case 1:
                    return _Utils_Tuple2(_List_Nil, _List_Nil);
                default:
                    return _Utils_Tuple2(_List_Nil, _List_Nil);
            }
        }();
        var addedYearsFront = _v2.a;
        var addedYearsBack = _v2.b;
        var dropdownYear = A3($elm$html$Html$Keyed$node, 'select', _List_fromArray([
            onChange(A2($elm$core$Basics$composeR, $agustinrhcp$elm_datepicker$DatePicker$Date$changeYear(currentDate), $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus)),
            dpClass('year-menu')
        ]), A2($elm$core$List$indexedMap, yearOption, $elm$core$List$concat(_List_fromArray([
            addedYearsFront,
            A2($agustinrhcp$elm_datepicker$DatePicker$Date$yearRange, {
                E$: currentMonth,
                aae: today
            }, settings.hL),
            addedYearsBack
        ]))));
        return A2($elm$html$Html$div, _List_fromArray([
            dpClass('picker'),
            A2($elm$html$Html$Events$stopPropagationOn, 'mousedown', $elm$json$Json$Decode$succeed(_Utils_Tuple2($agustinrhcp$elm_datepicker$DatePicker$MouseDown, true))),
            A2($elm$html$Html$Events$stopPropagationOn, 'mouseup', $elm$json$Json$Decode$succeed(_Utils_Tuple2($agustinrhcp$elm_datepicker$DatePicker$MouseUp, true)))
        ]), function() {
            switch(picking){
                case 0:
                    return _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            dpClass('picker-header')
                        ]), _List_fromArray([
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('prev-container')
                            ]), _List_fromArray([
                                A2(arrow, 'prev', $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
                            ])),
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('month-container')
                            ]), _List_fromArray([
                                A2($elm$html$Html$button, _List_fromArray([
                                    $elm$html$Html$Attributes$tabindex(-1),
                                    dpClass('month'),
                                    $elm$html$Html$Attributes$type_('button'),
                                    $elm$html$Html$Events$onClick($agustinrhcp$elm_datepicker$DatePicker$ChangePicking(1))
                                ]), _List_fromArray([
                                    $elm$html$Html$text(settings.zl($justinmimbs$date$Date$month(currentMonth)))
                                ])),
                                A2($elm$html$Html$button, _List_fromArray([
                                    $elm$html$Html$Attributes$tabindex(-1),
                                    dpClass('year'),
                                    $elm$html$Html$Attributes$type_('button'),
                                    $elm$html$Html$Events$onClick($agustinrhcp$elm_datepicker$DatePicker$ChangePicking(2))
                                ]), _List_fromArray([
                                    !$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.hL) ? $elm$html$Html$text(settings.pi($justinmimbs$date$Date$year(currentMonth))) : A3($elm$html$Html$Keyed$node, 'span', _List_Nil, _List_fromArray([
                                        _Utils_Tuple2($elm$core$String$fromInt($justinmimbs$date$Date$year(currentMonth)), dropdownYear)
                                    ]))
                                ]))
                            ])),
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('next-container')
                            ]), _List_fromArray([
                                A2(arrow, 'next', $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
                            ]))
                        ])),
                        A2($elm$html$Html$table, _List_fromArray([
                            dpClass('table')
                        ]), _List_fromArray([
                            A2($elm$html$Html$thead, _List_fromArray([
                                dpClass('weekdays')
                            ]), _List_fromArray([
                                A2($elm$html$Html$tr, _List_Nil, A2($elm$core$List$map, function(d) {
                                    return A2($elm$html$Html$td, _List_fromArray([
                                        dpClass('dow')
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(settings.acQ(d))
                                    ]));
                                }, A2($elm$core$List$take, 7, A2($elm$core$List$drop, firstDayOffset, $elm$core$List$concat(A2($elm$core$List$repeat, 2, _List_fromArray([
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6
                                ])))))))
                            ])),
                            A2($elm$html$Html$tbody, _List_fromArray([
                                dpClass('days')
                            ]), dayList)
                        ]))
                    ]);
                case 1:
                    return _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            dpClass('picker-header')
                        ]), _List_fromArray([
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('prev-container')
                            ]), _List_fromArray([
                                A2(arrow, 'prev', $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(A3($justinmimbs$date$Date$add, 0, -1, currentDate)))
                            ])),
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('month-container')
                            ]), _List_fromArray([
                                A2($elm$html$Html$button, _List_fromArray([
                                    dpClass('year'),
                                    $elm$html$Html$Attributes$type_('button'),
                                    $elm$html$Html$Events$onClick($agustinrhcp$elm_datepicker$DatePicker$ChangePicking(2))
                                ]), _List_fromArray([
                                    !$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.hL) ? $elm$html$Html$text(settings.pi($justinmimbs$date$Date$year(currentMonth))) : A3($elm$html$Html$Keyed$node, 'span', _List_Nil, _List_fromArray([
                                        _Utils_Tuple2($elm$core$String$fromInt($justinmimbs$date$Date$year(currentMonth)), dropdownYear)
                                    ]))
                                ]))
                            ])),
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('next-container')
                            ]), _List_fromArray([
                                A2(arrow, 'next', $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(A3($justinmimbs$date$Date$add, 0, 1, currentDate)))
                            ]))
                        ])),
                        A2($elm$html$Html$table, _List_fromArray([
                            dpClass('table')
                        ]), _List_fromArray([
                            A2($elm$html$Html$tbody, _List_fromArray([
                                dpClass('months')
                            ]), A2($agustinrhcp$elm_datepicker$DatePicker$monthList, currentDate, settings))
                        ]))
                    ]);
                default:
                    return _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            dpClass('picker-header')
                        ]), _List_fromArray([
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('prev-container')
                            ]), _List_fromArray([
                                A2(arrow, 'prev', $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(A3($justinmimbs$date$Date$add, 0, -12, currentDate)))
                            ])),
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('month-container')
                            ]), _List_fromArray([
                                A2($elm$html$Html$span, _List_fromArray([
                                    dpClass('year')
                                ]), _List_fromArray([
                                    !$agustinrhcp$elm_datepicker$DatePicker$yearRangeActive(settings.hL) ? $elm$html$Html$text(settings.pi($justinmimbs$date$Date$year(currentMonth))) : A3($elm$html$Html$Keyed$node, 'span', _List_Nil, _List_fromArray([
                                        _Utils_Tuple2($elm$core$String$fromInt($justinmimbs$date$Date$year(currentMonth)), dropdownYear)
                                    ]))
                                ]))
                            ])),
                            A2($elm$html$Html$div, _List_fromArray([
                                dpClass('next-container')
                            ]), _List_fromArray([
                                A2(arrow, 'next', $agustinrhcp$elm_datepicker$DatePicker$ChangeFocus(A3($justinmimbs$date$Date$add, 0, 12, currentDate)))
                            ]))
                        ])),
                        A2($elm$html$Html$table, _List_fromArray([
                            dpClass('table')
                        ]), _List_fromArray([
                            A2($elm$html$Html$tbody, _List_fromArray([
                                dpClass('years')
                            ]), A2($agustinrhcp$elm_datepicker$DatePicker$yearList, currentDate, settings))
                        ]))
                    ]);
            }
        }());
    });
    var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
    var $agustinrhcp$elm_datepicker$DatePicker$view = F3(function(pickedDate, settings, _v0) {
        var model = _v0;
        var potentialInputId = A3($elm$core$Basics$composeR, $elm$core$List$singleton, $elm$core$List$filterMap($elm$core$Basics$identity), A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.FP));
        var inputClasses = A2($elm$core$List$cons, _Utils_Tuple2(settings.lx + 'input', true), settings.FO);
        var inputCommon = function(xs) {
            return A2($elm$html$Html$input, _Utils_ap(_List_fromArray([
                $elm$html$Html$Attributes$classList(inputClasses),
                $elm$html$Html$Attributes$name(A2($elm$core$Maybe$withDefault, '', settings.FQ)),
                $elm$html$Html$Attributes$type_('text'),
                A2($elm$html$Html$Events$on, 'change', $elm$json$Json$Decode$succeed($agustinrhcp$elm_datepicker$DatePicker$SubmitText)),
                $elm$html$Html$Events$onInput($agustinrhcp$elm_datepicker$DatePicker$Text),
                $elm$html$Html$Events$onBlur($agustinrhcp$elm_datepicker$DatePicker$Blur),
                $elm$html$Html$Events$onClick($agustinrhcp$elm_datepicker$DatePicker$Focus),
                $elm$html$Html$Events$onFocus($agustinrhcp$elm_datepicker$DatePicker$Focus),
                A2($elm$html$Html$Events$on, 'keydown', A2($elm$json$Json$Decode$map, $agustinrhcp$elm_datepicker$DatePicker$KeyDown, $elm$html$Html$Events$keyCode))
            ]), _Utils_ap(settings.Rj, _Utils_ap(potentialInputId, xs))), _List_Nil);
        };
        var dateInput = inputCommon(_List_fromArray([
            $elm$html$Html$Attributes$placeholder(settings.r7),
            $elm$html$Html$Attributes$value(A2($elm$core$Maybe$withDefault, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, settings.acN, pickedDate)), model.cb))
        ]));
        var containerClassList = A2($elm$core$List$cons, _Utils_Tuple2(settings.lx + 'container', true), settings.ET);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$classList(containerClassList)
        ]), _List_fromArray([
            dateInput,
            model.Vw ? A3($agustinrhcp$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
        ]));
    });
    var $author$project$Components$DateInput$view = F2(function(options, model) {
        var optionsRecord = $author$project$Components$DateInput$optionsToRecord(options);
        var datePickerSettings_ = $author$project$Components$DateInput$datePickerSettings(optionsRecord);
        return A2($elm$html$Html$div, optionsRecord.vD, _List_fromArray([
            $author$project$Ui$Form$Input$group(_List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$DateInput$DatePickerMsg(datePickerSettings_), A3($agustinrhcp$elm_datepicker$DatePicker$view, optionsRecord.aa9, datePickerSettings_, model.lR)),
                $author$project$Ui$Form$Input$addon(_List_fromArray([
                    $author$project$Ui$Icon$calendar(_List_Nil)
                ]))
            ])),
            optionsRecord.xW ? $elm$html$Html$text('') : $author$project$Utils$FormErrors$view(optionsRecord.fK)
        ]));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$viewCardPaymentWarningModal = function(fields) {
        return fields.mf === 2 ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('')
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$warning
            ]), _List_fromArray([
                $elm$html$Html$text('We will not collect this payment.'),
                $elm$html$Html$text(' This form is used to record a payment made in person, by mail, or using a different payment processor.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Invoice$CreatePaymentModal$ExternalSource = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Radio$OnCheck = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Radio$onCheck = $author$project$Ui$Form$Radio$OnCheck;
    var $author$project$Ui$Form$Radio$Value = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Radio$value = $author$project$Ui$Form$Radio$Value;
    var $author$project$Ui$Form$Radio$inputOptionToAttributes = function(option) {
        switch(option.$){
            case 0:
                var val = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$checked(val)
                ]);
            case 1:
                var toMsg = option.a;
                return _List_fromArray([
                    $elm$html$Html$Events$onCheck(toMsg)
                ]);
            case 2:
                return _List_Nil;
            case 3:
                var disabled_ = option.a;
                return _List_fromArray([
                    $elm$html$Html$Attributes$disabled(disabled_)
                ]);
            case 4:
                return _List_fromArray([
                    A2($elm$html$Html$Attributes$style, '-webkit-appearance', 'none'),
                    A2($elm$html$Html$Attributes$style, 'appearance', 'none'),
                    A2($elm$html$Html$Attributes$style, 'background-color', '#fff'),
                    A2($elm$html$Html$Attributes$style, 'margin', '0')
                ]);
            case 5:
                return _List_Nil;
            default:
                return _List_Nil;
        }
    };
    var $author$project$Ui$Form$Radio$isCard = function(options) {
        return A2($elm$core$List$any, function(opt) {
            if (opt.$ === 6) return true;
            else return false;
        }, options);
    };
    var $author$project$Ui$Form$Radio$labelOptionToAttributes = function(option) {
        switch(option.$){
            case 0:
                return _List_Nil;
            case 1:
                return _List_Nil;
            case 2:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('radio-inline')
                ]);
            case 3:
                var isDisabled = option.a;
                return isDisabled ? _List_fromArray([
                    $elm$html$Html$Attributes$class('opacity-50 cursor-not-allowed')
                ]) : _List_Nil;
            case 4:
                return _List_Nil;
            case 5:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('pl-0')
                ]);
            default:
                return _List_Nil;
        }
    };
    var $author$project$Ui$Form$Radio$view = F2(function(options, content) {
        return $author$project$Ui$Form$Radio$isCard(options) ? A2($elm$html$Html$label, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('radio radio--card'), A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$labelOptionToAttributes, options)), _List_fromArray([
            A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('radio'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class('shrink-0'), A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$inputOptionToAttributes, options))), _List_Nil),
            A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content))
        ])) : A2($elm$html$Html$label, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('radio-inline'), A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$labelOptionToAttributes, options)), _List_fromArray([
            A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('radio'), A2($elm$core$List$concatMap, $author$project$Ui$Form$Radio$inputOptionToAttributes, options)), _List_Nil),
            A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content))
        ]));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceLabel = function(externalSource) {
        switch(externalSource){
            case 0:
                return 'Check';
            case 1:
                return 'Cash';
            case 2:
                return 'External Card';
            case 3:
                return 'Electronic Funds Transfer';
            default:
                return 'Other';
        }
    };
    var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSource = F2(function(currentExternalSource, externalSource) {
        return A2($author$project$Ui$Form$Radio$view, _List_fromArray([
            $author$project$Ui$Form$Radio$value(_Utils_eq(currentExternalSource, externalSource)),
            $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $elm$core$Basics$always($author$project$Components$Invoice$CreatePaymentModal$ExternalSource(externalSource))))
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceLabel(externalSource))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$Memo = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$viewMemoModal = function(fields) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Memo'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.ae0)),
                $author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$Memo))
            ]))
        ]));
    };
    var $author$project$Components$Invoice$CreatePaymentModal$AmountInCents = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$Inline = {
        $: 8
    };
    var $author$project$Ui$Form$Group$inline = $author$project$Ui$Form$Group$Inline;
    var $author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel = F2(function(fields, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Payment'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$inline
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(7)
                ]), _List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$value(fields.Jh),
                        $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$AmountInCents)),
                        $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' of '),
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(fields.mF)),
                        $elm$html$Html$text(' due')
                    ]))
                ]))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
        ]));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceModal = F3(function(model, fields, amountInCentsString) {
        return _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Record External Payment')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel, fields, model),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('On date'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Invoice$CreatePaymentModal$PaidAtDateInputMsg(fields.GN), A2($author$project$Components$DateInput$view, _List_fromArray([
                            $author$project$Components$DateInput$value(fields.VQ)
                        ]), fields.GN))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Paid By'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), A2($elm$core$List$map, $author$project$Components$Invoice$CreatePaymentModal$viewExternalSource(fields.mf), model.z9.Fs)),
                    $author$project$Utils$Html$empty,
                    $author$project$Utils$Html$empty,
                    $author$project$Components$Invoice$CreatePaymentModal$viewMemoModal(fields)
                ])),
                $author$project$Components$Invoice$CreatePaymentModal$viewCardPaymentWarningModal(fields),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Record payment'
                }, _List_fromArray([
                    $author$project$Ui$Button$styled(1),
                    $author$project$Ui$Button$loading(_Utils_eq(model.ag, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                ]), _List_fromArray([
                    $elm$html$Html$text('Record '),
                    $elm$html$Html$text(amountInCentsString),
                    $elm$html$Html$text(' Payment')
                ]))
            ]))
        ]);
    });
    var $author$project$Ui$Margin$Bottom_0_75 = 2;
    var $author$project$Components$Invoice$CreatePaymentModal$StoreCard = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModal$UpdateUseExistingSources = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Icon$Bolt = 47;
    var $author$project$Ui$Icon$bolt = $author$project$Ui$Icon$viewIcon(47);
    var $author$project$Ui$Typography$Gray = 7;
    var $author$project$Ui$Typography$gray = $author$project$Ui$Typography$Color(7);
    var $author$project$Ui$Form$ButtonSelect$Option = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$ButtonSelect$option = F2(function(value, label) {
        return A2($author$project$Ui$Form$ButtonSelect$Option, value, label);
    });
    var $author$project$Ui$Button$group = function(contents) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('button-group')
        ]), contents);
    };
    var $author$project$Ui$Button$Active = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Button$active = $author$project$Ui$Button$Active;
    var $author$project$Ui$Form$ButtonSelect$viewOptionButton = F3(function(currentCardInput, onChange, _v0) {
        var value = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentCardInput, value)),
            $author$project$Ui$Button$onClick(onChange(value))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Ui$Form$ButtonSelect$view = function(_v0) {
        var value = _v0.aa9;
        var options = _v0.z9;
        var onChange = _v0.afv;
        return $author$project$Ui$Button$group(A2($elm$core$List$map, A2($author$project$Ui$Form$ButtonSelect$viewOptionButton, value, onChange), options));
    };
    var $author$project$Ui$Margin$Top_0_5 = 20;
    var $author$project$Ui$Form$SearchableSelect$Disabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$disabled = $author$project$Ui$Form$SearchableSelect$Disabled;
    var $author$project$Ui$Form$SearchableSelect$Errors = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$errors = $author$project$Ui$Form$SearchableSelect$Errors;
    var $author$project$Ui$Form$SearchableSelect$Invalid = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$invalid = $author$project$Ui$Form$SearchableSelect$Invalid;
    var $author$project$Ui$Form$SearchableSelect$Loading = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$loading = $author$project$Ui$Form$SearchableSelect$Loading;
    var $author$project$Ui$Form$SearchableSelect$Item$ActualItem = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$SearchableSelect$Item$new = F2(function(options, item) {
        return A2($author$project$Ui$Form$SearchableSelect$Item$ActualItem, options, item);
    });
    var $author$project$Ui$Form$SearchableSelect$Placeholder = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$placeholder = $author$project$Ui$Form$SearchableSelect$Placeholder;
    var $author$project$Ui$Form$SearchableSelect$Value = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$value = $author$project$Ui$Form$SearchableSelect$Value;
    var $author$project$Ui$Form$SearchableSelect$ContainerBlurred = {
        $: 1
    };
    var $author$project$Ui$Form$SearchableSelect$CustomTriggered = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$InputChanged = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$SearchableSelect$InputKeyDown = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$ItemBlurred = {
        $: 5
    };
    var $author$project$Ui$Form$SearchableSelect$ItemClicked = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$ItemKeyDown = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$SearchableSelect$Open = {
        $: 0
    };
    var $elm$html$Html$i = _VirtualDom_node('i');
    var $author$project$Ui$Form$SearchableSelect$arrowIcon = A2($elm$html$Html$i, _List_fromArray([
        $elm$html$Html$Attributes$class('caret pull-right')
    ]), _List_Nil);
    var $author$project$Ui$Form$SearchableSelect$Item$addValue = F2(function(maybeValue, attrs) {
        if (!maybeValue.$) {
            var val = maybeValue.a;
            return A2($elm$core$List$cons, $elm$html$Html$Attributes$value(val), attrs);
        } else return attrs;
    });
    var $author$project$Ui$Form$SearchableSelect$Item$defaultOptions = {
        d$: false,
        yy: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Form$SearchableSelect$Item$updateOptionsRecord = F2(function(option, options) {
        var bool = option;
        return _Utils_update(options, {
            d$: bool
        });
    });
    var $author$project$Ui$Form$SearchableSelect$Item$optionsListToRecord = function(optionsList) {
        return A3($elm$core$List$foldl, $author$project$Ui$Form$SearchableSelect$Item$updateOptionsRecord, $author$project$Ui$Form$SearchableSelect$Item$defaultOptions, optionsList);
    };
    var $author$project$Ui$Form$SearchableSelect$Item$viewKeyedItem = F2(function(_v0, _v1) {
        var toValue = _v0.g4;
        var toLabel = _v0.ahW;
        var selected = _v0.ah;
        var selectId = _v0.ahc;
        var onBlurred = _v0.aft;
        var onPicked = _v0.afK;
        var onKeyDown = _v0.afG;
        var options = _v1.a;
        var item = _v1.b;
        var value = toValue(item);
        var optionsRecord = $author$project$Ui$Form$SearchableSelect$Item$optionsListToRecord(options);
        var onClickHandler = optionsRecord.d$ ? _List_Nil : _List_fromArray([
            $elm$html$Html$Events$onMouseDown(onPicked($elm$core$Maybe$Just(item)))
        ]);
        var key = A2($elm$core$Maybe$withDefault, A2($elm$core$Maybe$withDefault, '', value), optionsRecord.yy);
        var isSelected = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq(item), selected));
        var itemId = _Utils_ap(selectId, isSelected ? '-item-active' : '-item-' + key);
        var attrsFromSelect = A2($author$project$Ui$Form$SearchableSelect$Item$addValue, value, _List_fromArray([
            $author$project$Utils$Dom$onKeyDown(onKeyDown($elm$core$Maybe$Just(item))),
            A2($author$project$Utils$Dom$onOutsideBlur, onBlurred, selectId),
            $elm$html$Html$Attributes$id(itemId),
            $elm$html$Html$Attributes$name(selectId)
        ]));
        return _Utils_Tuple2(key, A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('ui-select-choices-row'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'option'), A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
            _Utils_Tuple2('active', isSelected),
            _Utils_Tuple2('disabled', optionsRecord.d$)
        ])), _Utils_ap(attrsFromSelect, onClickHandler)))), _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('ui-select-choices-row-inner')
            ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), toLabel(item)))
        ])));
    });
    var $author$project$Ui$Form$SearchableSelect$Item$keyedView = F2(function(optionsFromSelect, item) {
        var triggerToMsg = optionsFromSelect.ah4;
        switch(item.$){
            case 1:
                var nonSelectableItem = item.a;
                if (!nonSelectableItem.$) return _Utils_Tuple2('0', A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('divider')
                ]), _List_Nil));
                else {
                    var content = nonSelectableItem.a;
                    return _Utils_Tuple2('0', A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('ui-select-choices-row disabled')
                    ]), _List_fromArray([
                        A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('ui-select-choices-row-inner')
                        ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content))
                    ])));
                }
            case 2:
                var triggerId = item.a;
                var triggerContent = item.b;
                return _Utils_Tuple2('0', A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('ui-select-choices-row'),
                    $elm$html$Html$Events$onMouseDown(triggerToMsg(triggerId))
                ]), _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('ui-select-choices-row-inner')
                    ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), triggerContent))
                ])));
            default:
                var options = item.a;
                var actualItem = item.b;
                return A2($author$project$Ui$Form$SearchableSelect$Item$viewKeyedItem, optionsFromSelect, _Utils_Tuple2(options, actualItem));
        }
    });
    var $author$project$Ui$Form$SearchableSelect$defaultOptions = {
        EP: _List_Nil,
        d$: false,
        fK: _List_Nil,
        q2: false,
        Tk: false,
        r7: 'Pick an item',
        aa9: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Form$SearchableSelect$updateOptionsRecord = F2(function(option, options) {
        switch(option.$){
            case 2:
                var bool = option.a;
                return _Utils_update(options, {
                    d$: bool
                });
            case 0:
                var maybeSelected = option.a;
                return _Utils_update(options, {
                    aa9: maybeSelected
                });
            case 1:
                var string = option.a;
                return _Utils_update(options, {
                    r7: string
                });
            case 3:
                var bool = option.a;
                return _Utils_update(options, {
                    q2: bool
                });
            case 4:
                var bool = option.a;
                return _Utils_update(options, {
                    d$: bool,
                    Tk: bool
                });
            case 5:
                var list = option.a;
                return _Utils_update(options, {
                    fK: list
                });
            default:
                var string = option.a;
                return _Utils_update(options, {
                    EP: A2($elm$core$List$cons, string, options.EP)
                });
        }
    });
    var $author$project$Ui$Form$SearchableSelect$optionsListToRecord = function(optionsList) {
        return A3($elm$core$List$foldl, $author$project$Ui$Form$SearchableSelect$updateOptionsRecord, $author$project$Ui$Form$SearchableSelect$defaultOptions, optionsList);
    };
    var $author$project$Ui$Form$SearchableSelect$view = F3(function(options, items, model) {
        var optionsRecord = $author$project$Ui$Form$SearchableSelect$optionsListToRecord(options);
        var selectedOptionTitle = A2($elm$core$Maybe$map, model.yw, optionsRecord.aa9);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('ui-select-container ui-select-bootstrap dropdown'),
            $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', optionsRecord.EP)),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('open', model.Vw),
                _Utils_Tuple2('disabled', optionsRecord.Tk)
            ])),
            $elm$html$Html$Attributes$id(model.aef)
        ]), _List_fromArray([
            model.Vw ? A2($elm$html$Html$input, _List_fromArray([
                $elm$html$Html$Attributes$class('form-control ui-select-search'),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('feedback-errored', optionsRecord.q2)
                ])),
                A2($author$project$Utils$Dom$onOutsideBlur, $author$project$Ui$Form$SearchableSelect$ContainerBlurred, model.aef),
                $author$project$Utils$Dom$onKeyDown($author$project$Ui$Form$SearchableSelect$InputKeyDown),
                $elm$html$Html$Attributes$id(model.aef + '-input'),
                $elm$html$Html$Attributes$placeholder('Search...'),
                $elm$html$Html$Attributes$value(function() {
                    var _v0 = _Utils_Tuple2(optionsRecord.aa9, model.Vw);
                    if (!_v0.a.$ && !_v0.b) {
                        var item = _v0.a.a;
                        return model.yw(item);
                    } else return model.$Y;
                }()),
                $elm$html$Html$Events$onInput($author$project$Ui$Form$SearchableSelect$InputChanged(selectedOptionTitle))
            ]), _List_Nil) : A2($elm$html$Html$span, $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    $elm$html$Html$Attributes$class('btn btn-default form-control ui-select-toggle'),
                    $elm$html$Html$Attributes$disabled(optionsRecord.Tk || optionsRecord.d$),
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('btn-disabled', optionsRecord.Tk || optionsRecord.d$),
                        _Utils_Tuple2('feedback-errored', optionsRecord.q2)
                    ]))
                ]),
                optionsRecord.d$ ? _List_Nil : _List_fromArray([
                    $elm$html$Html$Events$onClick($author$project$Ui$Form$SearchableSelect$Open)
                ])
            ])), _List_fromArray([
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('ui-select-match-text pull-left'),
                    A2($elm$html$Html$Attributes$attribute, 'data-recording-sensitive', '')
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, optionsRecord.r7, selectedOptionTitle))
                ])),
                optionsRecord.Tk ? $author$project$Ui$Spinner$view(_List_fromArray([
                    $author$project$Ui$Spinner$extraSmall
                ])) : $author$project$Ui$Form$SearchableSelect$arrowIcon
            ])),
            function() {
                if (!optionsRecord.d$ && model.Vw && !$elm$core$List$isEmpty(items)) {
                    var itemOptions = {
                        aft: $author$project$Ui$Form$SearchableSelect$ItemBlurred,
                        afG: $author$project$Ui$Form$SearchableSelect$ItemKeyDown,
                        afK: $author$project$Ui$Form$SearchableSelect$ItemClicked,
                        ahc: model.aef,
                        ah: optionsRecord.aa9,
                        ahW: model.F7,
                        g4: model.F8,
                        ah4: $author$project$Ui$Form$SearchableSelect$CustomTriggered
                    };
                    return A2($elm$html$Html$ul, _List_fromArray([
                        $elm$html$Html$Attributes$class('ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu')
                    ]), _List_fromArray([
                        A3($elm$html$Html$Keyed$node, 'li', _List_fromArray([
                            $elm$html$Html$Attributes$class('ui-select-choices')
                        ]), A2($elm$core$List$map, $author$project$Ui$Form$SearchableSelect$Item$keyedView(itemOptions), items))
                    ]));
                } else return $elm$html$Html$text('');
            }(),
            $author$project$Utils$FormErrors$view(optionsRecord.fK)
        ]));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$viewCardReaders = function(model) {
        var _v0 = function() {
            var _v1 = model.hJ;
            if (_v1.$ === 3) {
                var cardReaders_ = _v1.a;
                return _Utils_Tuple2(cardReaders_, false);
            } else return _Utils_Tuple2(_List_Nil, true);
        }();
        var cardReaders = _v0.a;
        var cardReadersLoading = _v0.b;
        var _v2 = $author$project$Utils$Form$fields(model.PU);
        var cardReader = _v2.ace;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            !cardReadersLoading && $elm$core$List$isEmpty(cardReaders) ? A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                $elm$html$Html$text('There are no card readers available. Please '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CardReaders, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('add a card reader')
                ])),
                $elm$html$Html$text(' now.')
            ])) : $author$project$Utils$Html$empty,
            A2($elm$html$Html$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderSelectMsg, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
                $author$project$Ui$Form$SearchableSelect$value(cardReader),
                $author$project$Ui$Form$SearchableSelect$placeholder('Choose Card Reader'),
                $author$project$Ui$Form$SearchableSelect$loading(cardReadersLoading),
                $author$project$Ui$Form$SearchableSelect$disabled($elm$core$List$isEmpty(cardReaders)),
                $author$project$Ui$Form$SearchableSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                $author$project$Ui$Form$SearchableSelect$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
            ]), A2($elm$core$List$map, $author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil), cardReaders), model.pO)),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$margin(20),
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('Defaulted to the last reader used on this computer. '),
                $elm$html$Html$text('Tap payments such as Apple Pay & Google Pay are not supported at this time.')
            ]))
        ]));
    };
    var $author$project$Components$Invoice$CreatePaymentModal$viewPaymentSources = F2(function(model, selected) {
        var selectedSourceId = A2($elm$core$Maybe$map, $author$project$Api$Source$id, selected);
        var patientSources = function() {
            var _v1 = _Utils_Tuple2(model.pQ, model.pF);
            if (_v1.a.$ === 3 && _v1.b.$ === 3) {
                var _v2 = _v1.a;
                var cards = _v2.a;
                var _v3 = _v1.b;
                var bankAccounts = _v3.a;
                return $elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, $author$project$Api$Source$createdAt, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$time$Time$posixToMillis), $elm$core$Maybe$withDefault(0))), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Source$Card, cards), A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
            } else return _List_Nil;
        }();
        var isSelectedInList = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(id) {
            return A2($elm$core$List$any, function(s) {
                return _Utils_eq($author$project$Api$Source$id(s), id);
            }, patientSources);
        }, selectedSourceId));
        var sources = function() {
            var _v0 = _Utils_Tuple2(selected, isSelectedInList);
            if (!_v0.a.$ && !_v0.b) {
                var selectedSource = _v0.a.a;
                return A2($elm$core$List$cons, selectedSource, patientSources);
            } else return patientSources;
        }();
        return A2($elm$html$Html$map, $author$project$Components$Invoice$CreatePaymentModal$PaymentSourceSelectMsg, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
            $author$project$Ui$Form$SearchableSelect$value(selected),
            $author$project$Ui$Form$SearchableSelect$placeholder('Select a Source'),
            $author$project$Ui$Form$SearchableSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU)),
            $author$project$Ui$Form$SearchableSelect$errors(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
        ]), A2($elm$core$List$map, $author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil), sources), model.r1));
    });
    var $author$project$Components$Invoice$CreatePaymentModal$viewPayNowModal = F3(function(model, fields, amountInCentsString) {
        return _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Process Payment')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Components$Invoice$CreatePaymentModal$viewPayNowPanel, fields, model),
                    $author$project$Utils$Html$empty,
                    $author$project$Utils$Html$empty,
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Source'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        $author$project$Api$Practice$usesCardReaders(model.W1) && !$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? $author$project$Ui$Form$ButtonSelect$view({
                            afv: $author$project$Components$Invoice$CreatePaymentModal$UpdateUseExistingSources,
                            z9: _List_fromArray([
                                A2($author$project$Ui$Form$ButtonSelect$option, true, 'Existing payment source'),
                                A2($author$project$Ui$Form$ButtonSelect$option, false, 'Card Reader')
                            ]),
                            aa9: model.V
                        }) : $author$project$Utils$Html$empty,
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$margin(2)
                        ]), _List_Nil),
                        model.V ? A2($author$project$Components$Invoice$CreatePaymentModal$viewPaymentSources, model, fields.Hw) : $author$project$Components$Invoice$CreatePaymentModal$viewCardReaders(model)
                    ])),
                    function() {
                        if (!model.V) {
                            var _v0 = function() {
                                var _v1 = model.hJ;
                                if (_v1.$ === 3) {
                                    var cardReaders_ = _v1.a;
                                    return _Utils_Tuple2(cardReaders_, false);
                                } else return _Utils_Tuple2(_List_Nil, true);
                            }();
                            var cardReaders = _v0.a;
                            var cardReadersLoading = _v0.b;
                            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Remember this card'),
                                $author$project$Ui$Form$Group$labelSpan(4),
                                $author$project$Ui$Form$Group$inputSpan(8)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Store card for future use')
                                ])),
                                !cardReadersLoading && !$elm$core$List$isEmpty(cardReaders) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$gray
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Save and set this card as the default payment method for future invoices.')
                                ])) : $author$project$Utils$Html$empty,
                                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                    $author$project$Ui$ToggleSwitch$on(fields.CK),
                                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreatePaymentModal$FormUpdated, $author$project$Components$Invoice$CreatePaymentModal$StoreCard))
                                ]))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    $author$project$Components$Invoice$CreatePaymentModal$viewMemoModal(fields)
                ])),
                $author$project$Utils$Html$empty,
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Process payment now'
                }, _List_fromArray([
                    $author$project$Ui$Button$styled(3),
                    $author$project$Ui$Button$loading(_Utils_eq(model.ag, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$CreatePaymentModal$CreatePayment),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
                ]), _List_fromArray([
                    $elm$html$Html$text(' Process '),
                    $elm$html$Html$text(amountInCentsString),
                    $elm$html$Html$text(' Now')
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Invoice$CreatePaymentModal$viewCreatePaymentModal = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var amountInCentsString = $author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Jh));
        var modalToDisplay = function() {
            var _v0 = model.qn;
            if (!_v0) return A3($author$project$Components$Invoice$CreatePaymentModal$viewPayNowModal, model, fields, amountInCentsString);
            else return A3($author$project$Components$Invoice$CreatePaymentModal$viewExternalSourceModal, model, fields, amountInCentsString);
        }();
        return A3($author$project$Ui$Modal$view, $author$project$Components$Invoice$CreatePaymentModal$Close, _List_Nil, modalToDisplay);
    };
    var $author$project$Components$Invoice$CreatePaymentModal$view = function(_v0) {
        var model = _v0;
        var _v1 = _Utils_Tuple2(model.hI, model.bU);
        if (!_v1.a.$) {
            var _v2 = _v1.a.a;
            var cardReaderConnectingModal = _v2.a;
            return A2($elm$html$Html$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderConnectingModalMsg, $author$project$Components$CardReader$ConnectingModal$view(cardReaderConnectingModal));
        } else if (!_v1.b.$) {
            var _v3 = _v1.b.a;
            var cardReaderPaymentModal = _v3.a;
            return A2($elm$html$Html$map, $author$project$Components$Invoice$CreatePaymentModal$CardReaderPaymentModalMsg, $author$project$Components$CardReader$PaymentModal$view(cardReaderPaymentModal));
        } else {
            var _v4 = _v1.a;
            var _v5 = _v1.b;
            return $author$project$Components$Invoice$CreatePaymentModal$viewCreatePaymentModal(model);
        }
    };
    var $author$project$Components$Invoice$PaymentsHistory$Toggle = {
        $: 0
    };
    var $author$project$Components$PaymentsList$AllowDisputes = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$allowDisputes = $author$project$Components$PaymentsList$AllowDisputes;
    var $author$project$Components$PaymentsList$AllowRefunds = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$allowRefunds = $author$project$Components$PaymentsList$AllowRefunds;
    var $author$project$Components$PaymentsList$IsHintAdmin = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$isHintAdmin = $author$project$Components$PaymentsList$IsHintAdmin;
    var $author$project$Ui$Popover$Large = 1;
    var $author$project$Ui$Popover$lg = $author$project$Ui$Popover$Size(1);
    var $author$project$Components$PaymentsList$ShowRefundMemo = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$showRefundMemo = $author$project$Components$PaymentsList$ShowRefundMemo;
    var $author$project$Components$PaymentsList$defaultOptions = {
        abG: false,
        abJ: false,
        F3: false,
        sS: false,
        ahp: false
    };
    var $author$project$Components$PaymentsList$optionsToRecord = A2($elm$core$List$foldl, F2(function(option, acc) {
        switch(option.$){
            case 0:
                var bool = option.a;
                return _Utils_update(acc, {
                    sS: bool
                });
            case 1:
                var bool = option.a;
                return _Utils_update(acc, {
                    abJ: bool
                });
            case 2:
                var bool = option.a;
                return _Utils_update(acc, {
                    ahp: bool
                });
            case 3:
                var bool = option.a;
                return _Utils_update(acc, {
                    abG: bool
                });
            default:
                var bool = option.a;
                return _Utils_update(acc, {
                    F3: bool
                });
        }
    }), $author$project$Components$PaymentsList$defaultOptions);
    var $author$project$Components$PaymentsList$CancelPayment = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$OpenPaymentDisputeModal = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$OpenRainforestPaymentModal = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$OpenSimulateDisputeEventModal = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentsList$OpenSimulateDisputeModal = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$CardReader$Shared$Provider = $elm$core$Basics$identity;
    var $author$project$Components$PaymentsList$Refund = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Formatters$Time$Time__Full = 0;
    var $author$project$Api$Employer$Payment$Shared$attemptedInCents = function(_v0) {
        var record = _v0;
        return record.JL;
    };
    var $author$project$Api$Employer$Payment$One$attemptedInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$attemptedInCents(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$attemptedInCents = function(_v0) {
        var record = _v0;
        return record.JL;
    };
    var $author$project$Api$Provider$Payment$One$attemptedInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$attemptedInCents(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$attemptedInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$attemptedInCents(shared);
    };
    var $author$project$Api$Payment$attemptedInCents = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$attemptedInCents(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$attemptedInCents(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$attemptedInCents(payment_);
        }
    };
    var $author$project$Components$PaymentSourceDisplayer$CardReader = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$cardReader = $author$project$Components$PaymentSourceDisplayer$CardReader;
    var $author$project$Api$Employer$Payment$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Employer$Payment$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Payment$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$createdAt(shared);
    };
    var $author$project$Api$Payment$createdAt = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$createdAt(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$createdAt(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$createdAt(payment_);
        }
    };
    var $author$project$Api$Provider$Payment$One$createdBy = function(_v0) {
        var record = _v0.b;
        return record.My;
    };
    var $author$project$Api$Payment$createdBy = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$createdBy(payment_);
            case 0:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Ui$Typography$CreatedBy = {
        $: 20
    };
    var $author$project$Ui$Typography$createdBy = $author$project$Ui$Typography$CreatedBy;
    var $author$project$Ui$Icon$CrossCircle = 65;
    var $author$project$Ui$Icon$crossCircle = $author$project$Ui$Icon$viewIcon(65);
    var $author$project$Api$Provider$Payment$Creator$displayName = function(_v0) {
        var creator = _v0;
        return creator.zr;
    };
    var $author$project$Api$Dispute$Provider_Shared = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Payment$One$dispute = function(_v0) {
        var record = _v0.b;
        return record.N7;
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$dispute = function(_v0) {
        var record = _v0.b;
        return record.N7;
    };
    var $author$project$Api$Payment$dispute = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return A2($elm$core$Maybe$map, $author$project$Api$Dispute$Provider_Shared, $author$project$Api$Provider$Payment$One$dispute(payment_));
            case 0:
                var payment_ = payment.a;
                return A2($elm$core$Maybe$map, $author$project$Api$Dispute$Provider_Shared, $author$project$Api$Provider$Payment$SharedWithRefunds$dispute(payment_));
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$Payment$Shared$errorCode = function(_v0) {
        var record = _v0;
        return record.O3;
    };
    var $author$project$Api$Provider$Payment$One$errorCode = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$errorCode(shared);
    };
    var $author$project$Api$Payment$errorCode = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$errorCode(payment_);
            case 0:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Employer$Payment$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Employer$Payment$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Payment$Shared$errorMessage(shared);
    };
    var $author$project$Api$Provider$Payment$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$Payment$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$errorMessage(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$errorMessage(shared);
    };
    var $author$project$Api$Payment$errorMessage = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$errorMessage(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$errorMessage(payment_);
            default:
                var payment_ = payment.a;
                return $author$project$Api$Employer$Payment$One$errorMessage(payment_);
        }
    };
    var $author$project$Formatters$String$humanize = $elm_community$string_extra$String$Extra$humanize;
    var $author$project$Api$Provider$Payment$Shared$isCancelable = function(_v0) {
        var record = _v0;
        return record.RU;
    };
    var $author$project$Api$Provider$Payment$One$isCancelable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$isCancelable(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$isCancelable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$isCancelable(shared);
    };
    var $author$project$Api$Payment$isCancelable = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$isCancelable(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$isCancelable(payment_);
            default:
                return false;
        }
    };
    var $author$project$Api$Provider$Payment$Shared$isRefundable = function(_v0) {
        var record = _v0;
        return record.Sn;
    };
    var $author$project$Api$Provider$Payment$One$isRefundable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$isRefundable(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$isRefundable(shared);
    };
    var $author$project$Api$Payment$isRefundable = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$isRefundable(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$isRefundable(payment_);
            default:
                return false;
        }
    };
    var $author$project$Api$Provider$Payment$Shared$memo = function(_v0) {
        var record = _v0;
        return record.ae0;
    };
    var $author$project$Api$Provider$Payment$One$memo = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$memo(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$memo = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$memo(shared);
    };
    var $author$project$Api$Payment$memo = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$memo(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$memo(payment_);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$Source$Shared$oneTimeUse = function(_v0) {
        var record = _v0;
        return record.Vu;
    };
    var $author$project$Api$Refund$Employer_Shared = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Refund$Provider_One = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Refund$Provider_Shared = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$Payment$One$refunds = function(_v0) {
        var record = _v0.b;
        return record.Yr;
    };
    var $author$project$Api$Provider$Payment$One$refunds = function(_v0) {
        var record = _v0.b;
        return record.Yr;
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$refunds = function(_v0) {
        var record = _v0.b;
        return record.Yr;
    };
    var $author$project$Api$Payment$refunds = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return A2($elm$core$List$map, $author$project$Api$Refund$Provider_One, $author$project$Api$Provider$Payment$One$refunds(payment_));
            case 0:
                var payment_ = payment.a;
                return A2($elm$core$List$map, $author$project$Api$Refund$Provider_Shared, $author$project$Api$Provider$Payment$SharedWithRefunds$refunds(payment_));
            default:
                var payment_ = payment.a;
                return A2($elm$core$List$map, $author$project$Api$Refund$Employer_Shared, $author$project$Api$Employer$Payment$One$refunds(payment_));
        }
    };
    var $author$project$Components$PaymentSourceDisplayer$ShowProcessor = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$showProcessor = $author$project$Components$PaymentSourceDisplayer$ShowProcessor;
    var $author$project$Api$Provider$Dispute$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Dispute$One$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Dispute$Shared$status(shared);
    };
    var $author$project$Api$Dispute$status = function(dispute) {
        if (!dispute.$) {
            var dispute_ = dispute.a;
            return $author$project$Api$Provider$Dispute$One$status(dispute_);
        } else {
            var dispute_ = dispute.a;
            return $author$project$Api$Provider$Dispute$Shared$status(dispute_);
        }
    };
    var $author$project$Ui$Element$textRight = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textRight);
    var $author$project$Api$Platform$Session$One$userIsPracticeAdmin = function(_v0) {
        var record = _v0;
        return record.ag_ === 'practice_admin';
    };
    var $author$project$Ui$Badge$fromStringWithIcon = F3(function(options, label, icon) {
        var content = _List_fromArray([
            icon,
            $elm$html$Html$text($author$project$Ui$Badge$formatLabel(label))
        ]);
        return function(attrs) {
            return A2($elm$html$Html$span, attrs, content);
        }(A2($elm$core$List$cons, $elm$html$Html$Attributes$class('badge badge--icon'), A2($elm$core$List$map, $author$project$Ui$Badge$optionToAttr, _Utils_ap(options, $author$project$Ui$Badge$mapColor(label)))));
    });
    var $author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping = {
        Fa: 'Cardholder should contact their bank to find out why the payment was declined or try a different payment method.',
        Fh: "The bank didn't approve this payment \u2014 often this happens when the purchase is unusual for the cardholder's account, like a new merchant or a different amount than normal. Cardholder should contact the bank to approve the payment, or try another payment method.",
        Fr: 'Ask the cardholder to update their payment method with a valid, unexpired card.',
        FB: 'Use a different payment method or contact the associated bank if this may be an error.',
        FN: 'Double-check the card details and try again.',
        FS: 'Use a different payment method or add funds to the respective account before retrying.',
        FT: 'Some card details weren\'t recognized. Please double-check the card information and try again.',
        FU: 'Some card details weren\'t recognized. Please double-check the card information and try again.',
        FV: 'Some card details weren\'t recognized. Please double-check the card information and try again.',
        Gf: 'This card has been reported lost, so the bank won\'t approve the payment. Try a different payment method or contact the bank if this may be a mistake.',
        Gt: "This card number isn't recognized by the bank \u2014 it may have been entered incorrectly or the card may have been replaced. Please double-check the number or use a different payment method.",
        Gw: 'The card number entered doesn\'t match any known bank. Please double-check the number and try again.',
        GL: 'Cardholder should contact their bank to increase their card limit or use another payment method.',
        G5: 'There was a problem processing the payment. Please try again or use a different payment method.',
        Hj: 'There was a problem processing the payment. Please try again or use a different payment method.',
        Hk: 'Cardholder should contact their bank to find out why the payment was declined or try a different payment method.',
        Hl: "Bank payment failed \u2014 account owner should check the account details and balance or try another method.",
        Hm: 'Contact the bank to find out why the payment was declined or try another payment method.',
        HE: 'Cardholder should contact their bank for more information or try a different payment method',
        HN: 'Cardholder should contact their bank for more information or try a different payment method',
        HW: 'Looks like we couldn\'t use the saved card on file. Please re-enter your card details and try again',
        HZ: 'This card type isn\'t supported. Please try a Visa, Mastercard, or another accepted payment method.'
    };
    var $author$project$Components$PaymentFailedRecommendation$getRecommendationForErrorCode = function(errorCode) {
        var normalizedErrorCode = $elm$core$String$toLower(errorCode);
        switch(normalizedErrorCode){
            case 'declined':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Fa);
            case 'do_not_honor':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Fh);
            case 'expired_card':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Fr);
            case 'fraudulent_card':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FB);
            case 'incorrect_payment_information':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FN);
            case 'insufficient_funds':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FS);
            case 'invalid_card_security_code':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FT);
            case 'invalid_expiration_date':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FU);
            case 'invalid_pin':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.FV);
            case 'lost_card':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Gf);
            case 'no_card_number_on_file_with_issuer':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Gt);
            case 'no_such_card_issuer':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Gw);
            case 'over_limit':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.GL);
            case 'processing_error':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.G5);
            case 'retry':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Hj);
            case 'retry_with_threeds':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Hk);
            case 'risk_decline':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Hm);
            case 'stolen_card':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.HE);
            case 'threeds_challenge_failed':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.HN);
            case 'unexpected_payin_token':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.HW);
            case 'unsupported_card_type':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.HZ);
            case 'return_code':
                return $elm$core$Maybe$Just($author$project$Components$PaymentFailedRecommendation$errorCodeRecommendationMapping.Hl);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Ui$Icon$Warning = 64;
    var $author$project$Ui$Icon$warning = $author$project$Ui$Icon$viewIcon(64);
    var $author$project$Components$PaymentFailedRecommendation$view = F2(function(maybeErrorCode, maybePaymentProcessor) {
        var _v0 = _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Components$PaymentFailedRecommendation$getRecommendationForErrorCode, maybeErrorCode), maybePaymentProcessor);
        if (!_v0.a.$ && !_v0.b.$ && _v0.b.a === 'rainforest') {
            var recommendation = _v0.a.a;
            return A3($author$project$Ui$Popover$view, _List_fromArray([
                $author$project$Ui$Popover$dark
            ]), _List_fromArray([
                A3($author$project$Ui$Badge$fromStringWithIcon, _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]), 'recommendation', $author$project$Ui$Icon$warning(_List_fromArray([
                    $author$project$Ui$Icon$danger
                ])))
            ]), _List_fromArray([
                A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(recommendation)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$PaymentsList$CancelRefundClicked = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$OpenRainforestRefundModal = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Employer$Refund$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Refund$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Refund$One$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Refund$Shared$amountInCents(shared);
    };
    var $author$project$Api$Refund$amountInCents = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$amountInCents(refund_);
            case 1:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$Shared$amountInCents(refund_);
            default:
                var refund_ = refund.a;
                return $author$project$Api$Employer$Refund$Shared$amountInCents(refund_);
        }
    };
    var $author$project$Api$Employer$Refund$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Refund$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Refund$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Refund$Shared$createdAt(shared);
    };
    var $author$project$Api$Refund$createdAt = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$createdAt(refund_);
            case 1:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$Shared$createdAt(refund_);
            default:
                var refund_ = refund.a;
                return $author$project$Api$Employer$Refund$Shared$createdAt(refund_);
        }
    };
    var $author$project$Api$Provider$Refund$One$createdBy = function(_v0) {
        var record = _v0.b;
        return record.My;
    };
    var $author$project$Api$Refund$createdBy = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$createdBy(refund_);
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$User$Shared$displayName = function(_v0) {
        var record = _v0;
        return record.N6;
    };
    var $author$project$Api$Provider$Refund$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$Refund$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Refund$Shared$errorMessage(shared);
    };
    var $author$project$Api$Refund$errorMessage = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$errorMessage(refund_);
            case 1:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$Shared$errorMessage(refund_);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$Refund$Shared$external = function(_v0) {
        var record = _v0;
        return record.Po;
    };
    var $author$project$Api$Provider$Refund$One$external = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Refund$Shared$external(shared);
    };
    var $author$project$Api$Refund$external = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$external(refund_);
            case 1:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$Shared$external(refund_);
            default:
                return false;
        }
    };
    var $author$project$Api$Provider$Refund$Shared$memo = function(_v0) {
        var record = _v0;
        return record.ae0;
    };
    var $author$project$Api$Provider$Refund$One$memo = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Refund$Shared$memo(shared);
    };
    var $author$project$Api$Refund$memo = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$memo(refund_);
            case 1:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$Shared$memo(refund_);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Employer$Refund$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$Refund$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$Refund$One$paymentProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Refund$Shared$paymentProcessor(shared);
    };
    var $author$project$Api$Refund$paymentProcessor = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$paymentProcessor(refund_);
            case 1:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$Shared$paymentProcessor(refund_);
            default:
                var refund_ = refund.a;
                return $author$project$Api$Employer$Refund$Shared$paymentProcessor(refund_);
        }
    };
    var $author$project$Api$Employer$Refund$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Refund$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Refund$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Refund$Shared$status(shared);
    };
    var $author$project$Api$Refund$status = function(refund) {
        switch(refund.$){
            case 0:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$One$status(refund_);
            case 1:
                var refund_ = refund.a;
                return $author$project$Api$Provider$Refund$Shared$status(refund_);
            default:
                var refund_ = refund.a;
                return $author$project$Api$Employer$Refund$Shared$status(refund_);
        }
    };
    var $author$project$Components$PaymentsList$viewRefund = F5(function(timeFormatter, source, optionsRecord, payment, refund) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('payment__refund')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2(timeFormatter, 5, $author$project$Api$Refund$createdAt(refund)))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(7)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Badge$fromString, _List_Nil, function() {
                            var _v0 = _Utils_Tuple2($author$project$Api$Refund$paymentProcessor(refund), $author$project$Api$Refund$status(refund));
                            if (_v0.a === 'rainforest' && _v0.b === 'pending') return 'refund_actually_pending';
                            else {
                                var status = _v0.b;
                                return 'refund_' + status;
                            }
                        }()),
                        function() {
                            if ($author$project$Api$Refund$external(refund)) return $elm$html$Html$text(' Refunded as an external refund');
                            else {
                                var _v1 = $author$project$Api$Refund$status(refund);
                                if (_v1 === 'cancelled') return $elm$html$Html$text('');
                                else return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(' Processed automatically to '),
                                    A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, optionsRecord.F3, optionsRecord.F3, refund, A2($elm$core$Basics$composeR, $author$project$Api$Refund$paymentProcessor, $elm$core$Maybe$Just))),
                                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$name, source)))
                                    ])),
                                    $elm$html$Html$text(' *'),
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$lastFour, source)))
                                ]));
                            }
                        }(),
                        $author$project$Utils$Html$noBreakSpace,
                        $author$project$Utils$Html$noBreakSpace,
                        function() {
                            var _v2 = _Utils_Tuple3(optionsRecord.F3, $author$project$Api$Refund$paymentProcessor(refund), $author$project$Api$Refund$status(refund));
                            _v2$2: while(true){
                                _v2$3: while(true){
                                    _v2$4: while(true)if (_v2.b === 'rainforest') switch(_v2.c){
                                        case 'pending':
                                            return A3($author$project$Ui$Button$view, {
                                                abP: 'Cancel refund'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$link,
                                                $author$project$Ui$Button$icon($author$project$Ui$Icon$crossCircle),
                                                $author$project$Ui$Button$onClick($author$project$Components$PaymentsList$CancelRefundClicked(_Utils_Tuple2(payment, refund)))
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Cancel')
                                            ]));
                                        case 'cancelled':
                                            if (_v2.a) return $author$project$Utils$Html$empty;
                                            else break _v2$4;
                                        case 'failed':
                                            if (_v2.a) break _v2$2;
                                            else break _v2$3;
                                        default:
                                            if (_v2.a) break _v2$2;
                                            else break _v2$4;
                                    }
                                    else {
                                        if (_v2.c === 'failed') break _v2$3;
                                        else break _v2$4;
                                    }
                                    return $author$project$Utils$Html$empty;
                                }
                                return A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$danger
                                ]), _List_fromArray([
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, $author$project$Api$Refund$errorMessage(refund))))
                                ]));
                            }
                            return A3($author$project$Ui$HinterOnly$button, {
                                abP: 'View on rainforest'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$PaymentsList$OpenRainforestRefundModal(refund))
                            ]), _List_fromArray([
                                $elm$html$Html$text('View on Rainforest')
                            ]));
                        }(),
                        function() {
                            var _v3 = _Utils_Tuple2(optionsRecord.ahp, $author$project$Api$Refund$memo(refund));
                            if (_v3.a && !_v3.b.$) {
                                var memo = _v3.b.a;
                                return $elm$html$Html$text(' - ' + memo);
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ])),
                    optionsRecord.sS ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$createdBy
                    ]), _List_fromArray([
                        $elm$html$Html$text('Created by '),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'this platform', A2($elm$core$Maybe$map, $author$project$Api$Provider$User$Shared$displayName, $author$project$Api$Refund$createdBy(refund)))),
                        $elm$html$Html$text(' on '),
                        $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Refund$createdAt(refund)))
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight),
                        $author$project$Ui$Typography$danger
                    ]), _List_fromArray([
                        $author$project$Api$Refund$status(refund) === 'failed' ? A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$strike,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('-' + $author$project$Utils$Currency$fromInt($author$project$Api$Refund$amountInCents(refund)))
                        ])) : A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('-' + $author$project$Utils$Currency$fromInt($author$project$Api$Refund$amountInCents(refund)))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$PaymentsList$viewPayment = F4(function(timeFormatter, optionsRecord, session, payment) {
        var source = $author$project$Api$Payment$source(payment);
        var refunds_ = $author$project$Api$Payment$refunds(payment);
        var cardReader = $author$project$Api$Payment$cardReader(payment);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('payment__item')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        function() {
                            var _v0 = $author$project$Api$Payment$paidAt(payment);
                            if (!_v0.$) {
                                var paidAt_ = _v0.a;
                                return $elm$html$Html$text(A2(timeFormatter, 5, paidAt_));
                            } else return $elm$html$Html$text(A2(timeFormatter, 5, $author$project$Api$Payment$createdAt(payment)));
                        }()
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Payment$status(payment)),
                        $author$project$Api$Payment$external(payment) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
                        A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                            $author$project$Components$PaymentSourceDisplayer$source(A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source)),
                            $author$project$Components$PaymentSourceDisplayer$cardReader(A2($elm$core$Maybe$map, $elm$core$Basics$identity, cardReader)),
                            $author$project$Components$PaymentSourceDisplayer$limitedView(true),
                            $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                            $author$project$Components$PaymentSourceDisplayer$showProcessor(optionsRecord.F3),
                            $author$project$Components$PaymentSourceDisplayer$paymentProcessor($author$project$Api$Payment$paymentProcessor(payment))
                        ])),
                        function() {
                            var _v1 = _Utils_Tuple2($author$project$Api$Payment$status(payment), $author$project$Api$Payment$errorMessage(payment));
                            if (_v1.a === 'failed' && !_v1.b.$) return A2($elm$html$Html$br, _List_Nil, _List_Nil);
                            else return $author$project$Utils$Html$empty;
                        }(),
                        function() {
                            var _v2 = $author$project$Api$Payment$status(payment);
                            switch(_v2){
                                case 'failed':
                                    return A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$danger
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, $author$project$Api$Payment$errorMessage(payment)))),
                                        $author$project$Utils$Html$noBreakSpace,
                                        A2($author$project$Components$PaymentFailedRecommendation$view, $author$project$Api$Payment$errorCode(payment), $elm$core$Maybe$Just($author$project$Api$Payment$paymentProcessor(payment)))
                                    ]));
                                case 'disputed':
                                    var _v3 = _Utils_Tuple2(optionsRecord.abG, $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
                                    if (_v3.a && _v3.b) return A3($author$project$Ui$Button$view, {
                                        abP: 'View dispute'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$onClick($author$project$Components$PaymentsList$OpenPaymentDisputeModal(payment))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('View Dispute')
                                    ]));
                                    else return $author$project$Utils$Html$empty;
                                default:
                                    return $author$project$Utils$Html$empty;
                            }
                        }(),
                        function() {
                            var _v4 = _Utils_Tuple2(optionsRecord.F3, $author$project$Api$Payment$paymentProcessor(payment));
                            if (_v4.a && _v4.b === 'rainforest') return A3($author$project$Ui$HinterOnly$button, {
                                abP: 'View on rainforet '
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$PaymentsList$OpenRainforestPaymentModal(payment))
                            ]), _List_fromArray([
                                $elm$html$Html$text('View on Rainforest')
                            ]));
                            else return $author$project$Utils$Html$empty;
                        }(),
                        function() {
                            var _v5 = _Utils_Tuple3(optionsRecord.F3, $author$project$Api$Payment$paymentProcessor(payment), $author$project$Api$Payment$status(payment));
                            if (_v5.a && _v5.b === 'rainforest' && _v5.c === 'paid') return A3($author$project$Ui$HinterOnly$button, {
                                abP: 'Simulate dispute'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$PaymentsList$OpenSimulateDisputeModal(payment))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Simulate Dispute')
                            ]));
                            else return $author$project$Utils$Html$empty;
                        }(),
                        function() {
                            var _v6 = _Utils_Tuple3(optionsRecord.F3, $author$project$Api$Payment$paymentProcessor(payment), $author$project$Api$Payment$dispute(payment));
                            if (_v6.a && _v6.b === 'rainforest' && !_v6.c.$) {
                                var dispute = _v6.c.a;
                                return $author$project$Api$Dispute$status(dispute) !== 'won' && $author$project$Api$Dispute$status(dispute) !== 'lost' ? A3($author$project$Ui$HinterOnly$button, {
                                    abP: 'Simulate dispute'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$onClick(A2($author$project$Components$PaymentsList$OpenSimulateDisputeEventModal, payment, dispute))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Simulate Dispute Event')
                                ])) : $author$project$Utils$Html$empty;
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        function() {
                            var _v7 = _Utils_Tuple3($author$project$Api$Payment$paymentProcessor(payment), $author$project$Api$Payment$status(payment), $author$project$Api$Payment$isCancelable(payment));
                            if (_v7.a === 'rainforest' && _v7.b === 'paid' && _v7.c) return A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$margin(10)
                            ]), _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Cancel payment'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$onClick($author$project$Components$PaymentsList$CancelPayment(payment)),
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$crossCircle)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Cancel')
                                ])),
                                $author$project$Utils$Html$noBreakSpace,
                                A3($author$project$Ui$Tooltip$view, _List_Nil, 'Payment can be cancelled until 10PM EST', _List_fromArray([
                                    $author$project$Ui$Icon$help(_List_Nil)
                                ]))
                            ]));
                            else return $author$project$Utils$Html$empty;
                        }(),
                        function() {
                            var _v8 = $author$project$Api$Payment$memo(payment);
                            if (!_v8.$) {
                                var memo = _v8.a;
                                return A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(' - ' + memo)
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        optionsRecord.sS ? A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$createdBy
                        ]), _List_fromArray([
                            $elm$html$Html$text('Created by '),
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'this platform', A2($elm$core$Maybe$map, $author$project$Api$Provider$Payment$Creator$displayName, $author$project$Api$Payment$createdBy(payment)))),
                            $elm$html$Html$text(' on '),
                            $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Payment$createdAt(payment)))
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    function() {
                        var isNotBankTransfers = !_Utils_eq(A2($elm$core$Maybe$andThen, $author$project$Api$Common$Source$Shared$type_, source), $elm$core$Maybe$Just('BankTransfer'));
                        return $author$project$Api$Payment$isRefundable(payment) && optionsRecord.abJ && isNotBankTransfers ? A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textRight
                        ]), _List_fromArray([
                            function() {
                                var verb = $author$project$Api$Payment$external(payment) ? 'Record Refund' : 'Process Refund';
                                return A3($author$project$Ui$Button$view, {
                                    abP: verb
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$size(0),
                                    $author$project$Ui$Button$onClick($author$project$Components$PaymentsList$Refund(payment))
                                ]), _List_fromArray([
                                    $elm$html$Html$text(verb)
                                ]));
                            }()
                        ])) : $author$project$Utils$Html$empty;
                    }()
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        _Utils_eq($author$project$Api$Payment$attemptedInCents(payment), $author$project$Api$Payment$amountInCents(payment)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$strike
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Payment$attemptedInCents(payment)))
                        ])),
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Payment$amountInCents(payment)))
                        ]))
                    ])),
                    A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Common$Source$Shared$oneTimeUse, source)) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$createdBy,
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text('One time use')
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('')
                ]))
            ])),
            $elm$core$List$isEmpty(refunds_) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A4($author$project$Components$PaymentsList$viewRefund, timeFormatter, source, optionsRecord, payment), refunds_))
        ]));
    });
    var $author$project$Components$PaymentsList$view = F3(function(options, payments, _v0) {
        var timeFormatter = _v0.HO;
        var session = _v0.Z$;
        var optionsRecord = $author$project$Components$PaymentsList$optionsToRecord(options);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('payments-list')
            ]), A2($elm$core$List$map, A3($author$project$Components$PaymentsList$viewPayment, timeFormatter, optionsRecord, session), payments))
        ]));
    });
    var $author$project$Ui$Popover$viewAsClickable = F4(function(options, displayedContent, sections, _v0) {
        var model = _v0;
        return A4($author$project$Ui$Popover$popoverView, options, displayedContent, sections, $elm$core$Maybe$Just(model));
    });
    var $author$project$Ui$Popover$Visible = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Popover$visible = $author$project$Ui$Popover$Visible;
    var $author$project$Components$Invoice$PaymentsHistory$view = F2(function(_v0, model) {
        var allowRefunds = _v0.abJ;
        var showRefundMemo = _v0.ahp;
        var isHintAdmin = _v0.F3;
        var allowDisputes = _v0.abG;
        var payments = _v0.Wt;
        return $elm$core$List$isEmpty(payments) ? $author$project$Utils$Html$empty : A4($author$project$Ui$Popover$viewAsClickable, _List_fromArray([
            $author$project$Ui$Popover$lg,
            $author$project$Ui$Popover$visible($author$project$Ui$Popover$isOpen(model.aN))
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'View payment\'s history'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Components$Invoice$PaymentsHistory$Toggle)
            ]), _List_fromArray([
                $elm$html$Html$text('Payment History')
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Popover$heading, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Payment History')
            ])),
            A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Invoice$PaymentsHistory$PaymentsListMsg, A3($author$project$Components$PaymentsList$view, _List_fromArray([
                    $author$project$Components$PaymentsList$allowRefunds(allowRefunds),
                    $author$project$Components$PaymentsList$showRefundMemo(showRefundMemo),
                    $author$project$Components$PaymentsList$isHintAdmin(isHintAdmin),
                    $author$project$Components$PaymentsList$allowDisputes(allowDisputes)
                ]), payments, model.jt))
            ]))
        ]), model.aN);
    });
    var $elm$html$Html$ol = _VirtualDom_node('ol');
    var $author$project$Ui$Breadcrumb$itemOptionToAttributes = function(option) {
        var bool = option;
        return _List_fromArray([
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('active', bool)
            ]))
        ]);
    };
    var $author$project$Ui$Breadcrumb$itemOptionsToAttributes = function(options) {
        return A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), A2($elm$core$List$concatMap, $author$project$Ui$Breadcrumb$itemOptionToAttributes, options));
    };
    var $author$project$Ui$Breadcrumb$viewItem = function(_v0) {
        var options = _v0.a;
        var contents = _v0.b;
        return A2($elm$html$Html$li, $author$project$Ui$Breadcrumb$itemOptionsToAttributes(options), contents);
    };
    var $author$project$Ui$Breadcrumb$view = F2(function(_v0, items) {
        return A2($elm$html$Html$ol, _List_fromArray([
            $elm$html$Html$Attributes$class('breadcrumb')
        ]), A2($elm$core$List$map, $author$project$Ui$Breadcrumb$viewItem, items));
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Delete = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issue = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Pay = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$RecordPayment = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Ui$Margin$Right_4 = 17;
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Void = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeInvoice$Meta$adjustAction = function(_v0) {
        var meta = _v0;
        return meta.tM.IQ;
    };
    var $author$project$Ui$Icon$ArrowLeft = 62;
    var $author$project$Ui$Icon$arrowLeft = $author$project$Ui$Icon$viewIcon(62);
    var $author$project$Ui$Link$ButtonSuccess = 1;
    var $author$project$Ui$Link$buttonSuccess = $author$project$Ui$Link$Style(1);
    var $author$project$Ui$Dropdown$Button = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$Warning = 2;
    var $author$project$Ui$Dropdown$buttonWarning = $author$project$Ui$Dropdown$Button(2);
    var $author$project$Api$Provider$PracticeInvoice$Meta$cancelAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KW;
    };
    var $author$project$Api$Provider$PracticeInvoice$Meta$destroyAction = function(_v0) {
        var meta = _v0;
        return meta.tM.NT;
    };
    var $author$project$Ui$Dropdown$Disabled = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$disabled = $author$project$Ui$Dropdown$Disabled;
    var $author$project$Ui$Icon$Dollar = 54;
    var $author$project$Ui$Icon$dollarSign = $author$project$Ui$Icon$viewIcon(54);
    var $author$project$Ui$Dropdown$view = F4(function(options, content, items, model) {
        var toMsg = model.ahX;
        var optionsRecord = $author$project$Ui$Dropdown$optionsToRecord(options);
        if (optionsRecord.Tk) return $author$project$Ui$Skeleton$input(_List_fromArray([
            $author$project$Ui$Skeleton$span(2)
        ]));
        else {
            var errorDescription = $elm$core$List$isEmpty(optionsRecord.fK) ? _List_Nil : _List_fromArray([
                A2($elm$html$Html$Attributes$attribute, 'aria-describedby', A2($elm$core$String$join, '. ', optionsRecord.fK))
            ]);
            var ariaInvalid = optionsRecord.q2 || !$elm$core$List$isEmpty(optionsRecord.fK) ? _List_fromArray([
                A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
            ]) : _List_Nil;
            var buttonAttributes = A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown__trigger'), A2($elm$core$List$cons, $elm$html$Html$Attributes$tabindex(0), A2($elm$core$List$cons, $elm$html$Html$Attributes$id(model.aef + '-trigger'), A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('button'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', _Utils_ap(optionsRecord.lm, optionsRecord.vS))), A2($elm$core$List$cons, $elm$core$String$isEmpty(optionsRecord.abP) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.abP), _Utils_ap(optionsRecord.d$ ? _List_fromArray([
                A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true')
            ]) : optionsRecord.sq ? _List_fromArray([
                $elm$html$Html$Attributes$readonly(true)
            ]) : _List_fromArray([
                $author$project$Ui$Dropdown$triggerKeyHandlers(toMsg),
                $elm$html$Html$Events$onClick(toMsg($author$project$Ui$Dropdown$DropdownButtonClicked))
            ]), _Utils_ap(errorDescription, ariaInvalid))))))));
            return A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('new-dropdown'),
                $elm$html$Html$Attributes$id(model.aef),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('new-dropdown--open', model.Vw && !optionsRecord.d$),
                    _Utils_Tuple2('new-dropdown--invalid', optionsRecord.q2),
                    _Utils_Tuple2('new-dropdown--disabled', optionsRecord.d$)
                ]))
            ]), _List_fromArray([
                A2($elm$html$Html$button, buttonAttributes, _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('inline-flex gap-1 items-center')
                    ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content)),
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('new-dropdown__trigger__chevron'),
                        $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('ml-1 ', !$elm$core$List$isEmpty(content))
                        ]))
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$chevronDown(_List_fromArray([
                            $author$project$Ui$Icon$xs
                        ]))
                    ]))
                ])),
                optionsRecord.d$ ? $elm$html$Html$text('') : A3($author$project$Ui$Dropdown$viewMenu, toMsg, model, items)
            ]));
        }
    });
    var $author$project$Ui$HinterOnly$dropdown = F4(function(options, content, items, dropdownModel) {
        return A4($author$project$Ui$Dropdown$view, options, A2($elm$core$List$cons, $author$project$Ui$HinterOnly$icon(_List_fromArray([
            $author$project$Ui$Icon$spacedRight
        ])), content), items, dropdownModel);
    });
    var $author$project$Ui$Icon$Eraser = 103;
    var $author$project$Ui$Icon$eraser = $author$project$Ui$Icon$viewIcon(103);
    var $author$project$Api$Common$Source$Shared$external = function(_v0) {
        var record = _v0;
        return record.Po;
    };
    var $author$project$Ui$Element$InlineBlock = 1;
    var $author$project$Ui$Element$inlineBlock = A2($author$project$Ui$Element$Display, 0, 1);
    var $author$project$Api$Provider$PracticeInvoice$Meta$issueAction = function(_v0) {
        var meta = _v0;
        return meta.tM.SB;
    };
    var $author$project$Ui$Button$Margin = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Button$margin = $author$project$Ui$Button$Margin;
    var $author$project$Api$Provider$PracticeInvoice$Shared$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Api$Provider$PracticeInvoice$One$meta = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeInvoice$Shared$meta(shared);
    };
    var $author$project$Ui$Element$ml1 = $author$project$Ui$Element$Margin('ml-1');
    var $author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Wu;
    };
    var $author$project$Api$Provider$PracticeInvoice$Meta$refundAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Yq;
    };
    var $author$project$Api$Provider$PracticeInvoice$One$securePdfInlineToken = function(_v0) {
        var record = _v0.b;
        return record.ZC;
    };
    var $author$project$Ui$Button$success = $author$project$Ui$Button$Styled(3);
    var $author$project$Ui$Icon$Export = 51;
    var $author$project$Ui$Icon$export = $author$project$Ui$Icon$viewIcon(51);
    var $author$project$Components$Invoice$DownloadFile$defaultOptions = {
        QZ: true,
        aeI: $elm$core$Maybe$Nothing,
        DI: true
    };
    var $author$project$Components$Invoice$DownloadFile$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            if (!option.$) {
                var string = option.a;
                return _Utils_update(record, {
                    aeI: $elm$core$Maybe$Just(string)
                });
            } else {
                var bool = option.a;
                return _Utils_update(record, {
                    DI: bool
                });
            }
        }), $author$project$Components$Invoice$DownloadFile$defaultOptions, options);
    };
    var $author$project$Components$Invoice$DownloadFile$viewModal = A3($author$project$Ui$Modal$view, $author$project$Components$Invoice$DownloadFile$CloseModal, _List_Nil, _List_fromArray([
        $author$project$Ui$Modal$header(_List_fromArray([
            $author$project$Ui$Modal$title('In Progress')
        ])),
        $author$project$Ui$Modal$body(_List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Your file is being processed and may take a few seconds.')
            ])),
            $author$project$Ui$Spinner$view(_List_Nil)
        ]))
    ]));
    var $author$project$Components$Invoice$DownloadFile$view = F4(function(model, token, options, buttonOptions) {
        var optionsRecord = $author$project$Components$Invoice$DownloadFile$optionsToRecord(options);
        var _v0 = _Utils_Tuple2('Download', $author$project$Ui$Icon$export);
        var verb = _v0.a;
        var icon_ = _v0.b;
        var buttonLabel = function() {
            var _v1 = optionsRecord.aeI;
            if (!_v1.$) {
                var label_ = _v1.a;
                return label_;
            } else return verb;
        }();
        var link = A3($author$project$Ui$Button$view, {
            abP: buttonLabel
        }, A2($elm$core$List$cons, $author$project$Ui$Button$onClick($author$project$Components$Invoice$DownloadFile$DownloadFileClicked(token)), A2($elm$core$List$cons, $author$project$Ui$Button$icon(icon_), buttonOptions)), _List_fromArray([
            $elm$html$Html$text(buttonLabel)
        ]));
        var button = optionsRecord.DI ? A3($author$project$Ui$Tooltip$view, _List_Nil, verb + ' PDF', _List_fromArray([
            link
        ])) : link;
        return A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('inline text-left')
        ]), _List_fromArray([
            button,
            model.Sk ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewActions = F5(function(practiceInvoice, isHintAdmin, saveRequest, dropdownMenu, downloadInvoice) {
        var meta = $author$project$Api$Provider$PracticeInvoice$One$meta(practiceInvoice);
        var actions = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            function() {
                if ($author$project$Api$Provider$PracticeInvoice$Meta$cancelAction(meta)) {
                    var voidText = function() {
                        var _v1 = $author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice);
                        if (!_v1) return 'Void & Refund';
                        else return 'Void';
                    }();
                    return $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Void(practiceInvoice))
                    ]), A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$flex,
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$eraser(_List_Nil),
                        $elm$html$Html$text(voidText)
                    ]))));
                } else return $elm$core$Maybe$Nothing;
            }(),
            $author$project$Api$Provider$PracticeInvoice$Meta$issueAction(meta) ? $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Issue(practiceInvoice))
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                $author$project$Ui$Icon$arrowLeft(_List_Nil),
                $elm$html$Html$text('Return To Issued')
            ])))) : $elm$core$Maybe$Nothing,
            $author$project$Api$Provider$PracticeInvoice$Meta$adjustAction(meta) ? $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal(practiceInvoice))
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                $author$project$Ui$Icon$dollarSign(_List_Nil),
                $elm$html$Html$text('Add Charge or Credit')
            ])))) : $elm$core$Maybe$Nothing,
            $author$project$Api$Provider$PracticeInvoice$Meta$refundAction(meta) ? $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$OpenAdjustModal(practiceInvoice))
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                $author$project$Ui$Icon$dollarSign(_List_Nil),
                $elm$html$Html$text('Add Credit & Refund')
            ])))) : $elm$core$Maybe$Nothing
        ]));
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DownloadInvoiceMsg, A4($author$project$Components$Invoice$DownloadFile$view, downloadInvoice, $author$project$Api$Provider$PracticeInvoice$One$securePdfInlineToken(practiceInvoice), _List_Nil, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$margin(17)
            ]))),
            !$elm$core$List$isEmpty(actions) && isHintAdmin ? A4($author$project$Ui$HinterOnly$dropdown, _List_fromArray([
                $author$project$Ui$Dropdown$disabled(_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
                $author$project$Ui$Dropdown$buttonWarning
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$inlineBlock,
                    $author$project$Ui$Element$ml1
                ]), _List_fromArray([
                    $elm$html$Html$text('Revise Invoice')
                ]))
            ]), actions, dropdownMenu) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$PracticeInvoice$Meta$destroyAction(meta) && isHintAdmin ? A3($author$project$Ui$HinterOnly$button, {
                abP: 'Delete practice invoice'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Delete(practiceInvoice)),
                $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete')
            ])) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta) && !$author$project$Utils$Maybe$toBool($author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice)) ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__PaymentSources, _List_fromArray([
                $author$project$Ui$Link$buttonSuccess
            ]), _List_fromArray([
                $elm$html$Html$text('Add Payment Source')
            ])) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta) && isHintAdmin ? A3($author$project$Ui$HinterOnly$button, {
                abP: 'Record payment'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$RecordPayment(practiceInvoice))
            ]), _List_fromArray([
                $author$project$Utils$Html$noBreakSpace,
                $elm$html$Html$text('Record Payment')
            ])) : $author$project$Utils$Html$empty,
            function() {
                var _v0 = _Utils_Tuple2($author$project$Api$Provider$PracticeInvoice$Meta$paymentsProcessAction(meta), $author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice));
                if (_v0.a && !_v0.b.$) {
                    var source = _v0.b.a;
                    return !$author$project$Api$Common$Source$Shared$external(source) ? A3($author$project$Ui$Button$view, {
                        abP: 'Pay now'
                    }, _List_fromArray([
                        $author$project$Ui$Button$success,
                        $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$Pay(practiceInvoice)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Pay now')
                    ])) : $author$project$Utils$Html$empty;
                } else return $author$project$Utils$Html$empty;
            }()
        ]);
    });
    var $author$project$Api$Provider$PracticeInvoice$One$invoiceType = function(_v0) {
        var record = _v0.b;
        return record.RL;
    };
    var $author$project$Ui$Form$Static$Phi = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Static$phi = $author$project$Ui$Form$Static$Phi;
    var $author$project$Api$Provider$PracticeCharge$Shared$serviceDescription = function(_v0) {
        var record = _v0;
        return record.Z_;
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewCharge = F2(function(practiceInvoice, practiceCharge) {
        var showUsageInfo = $author$project$Api$Provider$PracticeInvoice$One$invoiceType(practiceInvoice) === 'pmpm' && $author$project$Api$Provider$PracticeCharge$Shared$quantity(practiceCharge) > 1;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$PracticeCharge$Shared$description(practiceCharge))
                    ])),
                    $author$project$Utils$Html$noBreakSpace,
                    showUsageInfo ? A3($author$project$Ui$Tooltip$view, _List_Nil, 'Usage charges are based on the preceding billing period', _List_fromArray([
                        $author$project$Ui$Icon$help(_List_Nil)
                    ])) : $author$project$Utils$Html$empty,
                    function() {
                        var _v0 = $author$project$Api$Provider$PracticeCharge$Shared$serviceDescription(practiceCharge);
                        if (!_v0.$) {
                            var serviceDescription = _v0.a;
                            return A2($author$project$Ui$Form$Static$view, _List_fromArray([
                                $author$project$Ui$Form$Static$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text(serviceDescription)
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                ]), _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$PracticeCharge$Shared$quantity(practiceCharge)))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromFloat($author$project$Api$Provider$PracticeCharge$Shared$priceInCents(practiceCharge)))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(practiceCharge)))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeeItem = function(practiceCharge) {
        return A2($elm$html$Html$div, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'padding-left', '2em')
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents(practiceCharge)) + (' for ' + $author$project$Api$Provider$PracticeCharge$Shared$description(practiceCharge)))
        ]));
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeesCharges = function(practiceCharges) {
        if ($elm$core$List$length(practiceCharges) > 0) {
            var itemsDescriptions = A2($elm$core$List$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeeItem, practiceCharges);
            var fixedFeeSubtotalInCents = $elm$core$List$sum(A2($elm$core$List$map, $author$project$Api$Provider$PracticeCharge$Shared$subtotalInCents, practiceCharges));
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), A2($elm$core$List$cons, A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Fixed Fees')
                ])), itemsDescriptions)),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text('1')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(fixedFeeSubtotalInCents))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(fixedFeeSubtotalInCents))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$HiConfirm$CustomTitle = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$customTitle = $author$project$Components$HiConfirm$CustomTitle;
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$voidInvoiceConfirm = F2(function(practiceInvoice, voidRequest) {
        var _v0 = $author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice);
        if (!_v0) {
            var paidInCents = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice));
            var customMessage = $elm$html$Html$text('You are about to void and refund Invoice #' + ($elm$core$String$fromInt($author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)) + (' and refund ' + (paidInCents + ' to the practice.'))));
            return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed(practiceInvoice), _List_fromArray([
                $author$project$Components$HiConfirm$verb('void'),
                $author$project$Components$HiConfirm$customTitle('Void & Refund'),
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    customMessage,
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    $elm$html$Html$text('This action cannot be undone.')
                ])),
                $author$project$Components$HiConfirm$noun('& Refund ' + paidInCents),
                $author$project$Components$HiConfirm$loading(_Utils_eq(voidRequest, $author$project$Api$Data$Loading))
            ]));
        } else {
            var customMessage = $elm$html$Html$text('You are about to void Invoice #' + ($elm$core$String$fromInt($author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)) + '.'));
            return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$VoidHiConfirmClosed(practiceInvoice), _List_fromArray([
                $author$project$Components$HiConfirm$verb('void'),
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    customMessage,
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text('This action cannot be undone.')
                ])),
                $author$project$Components$HiConfirm$noun('Invoice'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(voidRequest, $author$project$Api$Data$Loading))
            ]));
        }
    });
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewBody = function(model) {
        return _List_fromArray([
            function() {
                var _v0 = model.ib;
                if (!_v0.$) {
                    var _v1 = _v0.a;
                    var practiceInvoice = _v1.a;
                    var deleteRequest = _v1.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$DeleteHiConfirmClosed(practiceInvoice), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('Invoice #' + $elm$core$String$fromInt($author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice))),
                        $author$project$Components$HiConfirm$detail('for ' + $author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice))),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v2 = model.tG;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var practiceInvoice = _v3.a;
                    var voidRequest = _v3.b;
                    return A2($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$voidInvoiceConfirm, practiceInvoice, voidRequest);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v4 = model.lH;
                if (!_v4.$) {
                    var createPaymentModal = _v4.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreatePaymentModalMsg, $author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.hZ;
                if (!_v5.$) {
                    var modal = _v5.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$CreateChargeModalMsg, A2($author$project$Components$HintBilling$CreateChargeModal$view, modal, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$chargeModalTitle(model.W3)));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg, $author$project$Components$Invoice$PaymentsHistory$modal(model.js)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, function() {
                    var _v6 = model.W3;
                    if (_v6.$ === 3) {
                        var practiceInvoice = _v6.a;
                        var _v7 = A2($elm$core$List$partition, function(item) {
                            return $author$project$Api$Provider$PracticeCharge$Shared$fromRecurringCharge(item);
                        }, $author$project$Api$Provider$PracticeInvoice$One$charges(practiceInvoice));
                        var fixedFeeCharges = _v7.a;
                        var nonFixedFeeCharges = _v7.b;
                        return $elm$core$List$concat(_List_fromArray([
                            _List_fromArray([
                                A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Billing, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Billing')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                        $author$project$Ui$Breadcrumb$active(true)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)))
                                    ]))
                                ]))),
                                $author$project$Ui$HorizontalRule$view(_List_Nil),
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(6)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$mb2
                                        ]), _List_fromArray([
                                            $author$project$Ui$Typography$heading(_List_fromArray([
                                                $elm$html$Html$text('Invoice '),
                                                $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Provider$PracticeInvoice$One$number(practiceInvoice)))
                                            ]))
                                        ])),
                                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice))),
                                            $author$project$Utils$Html$noBreakSpace,
                                            $author$project$Api$Provider$PracticeInvoice$Status$toBadge($author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice))
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(6)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$justifyRight,
                                            $author$project$Ui$Element$itemsCenter,
                                            $author$project$Ui$Element$gap2
                                        ]), A5($author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewActions, practiceInvoice, model.F3, model.j_, model.l_, model.it))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(6)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Payer'),
                                            $author$project$Ui$Form$Group$labelSpan(4),
                                            $author$project$Ui$Form$Group$inputSpan(8)
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text($author$project$Api$Provider$Practice$One$name(model.W1)),
                                                function() {
                                                    var _v8 = A2($elm$core$Maybe$andThen, $author$project$Api$Common$Phone$Shared$number, $elm$core$List$head($author$project$Api$Provider$Practice$One$phones(model.W1)));
                                                    if (!_v8.$) {
                                                        var phoneNumber = _v8.a;
                                                        return A2($author$project$Ui$Typography$div, _List_fromArray([
                                                            $author$project$Ui$Typography$phi(true)
                                                        ]), _List_fromArray([
                                                            $elm$html$Html$text($author$project$Formatters$Phone$format(phoneNumber))
                                                        ]));
                                                    } else return $author$project$Utils$Html$empty;
                                                }(),
                                                function() {
                                                    var _v9 = $author$project$Api$Provider$Practice$One$address(model.W1);
                                                    if (!_v9.$) {
                                                        var address = _v9.a;
                                                        return $author$project$Components$AddressDisplay$view(address);
                                                    } else return $author$project$Utils$Html$empty;
                                                }()
                                            ]))
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(6)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Invoice Date'),
                                            $author$project$Ui$Form$Group$labelSpan(4),
                                            $author$project$Ui$Form$Group$inputSpan(8),
                                            $author$project$Ui$Form$Group$clearfix
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$PracticeInvoice$One$date(practiceInvoice)))
                                            ]))
                                        ])),
                                        function() {
                                            var _v10 = $author$project$Api$Provider$PracticeInvoice$One$purchaseOrderNumber(practiceInvoice);
                                            if (!_v10.$) {
                                                var purchaseOrderNumber = _v10.a;
                                                return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                                    $author$project$Ui$Form$Group$label('PO #'),
                                                    $author$project$Ui$Form$Group$labelSpan(4),
                                                    $author$project$Ui$Form$Group$inputSpan(8),
                                                    $author$project$Ui$Form$Group$clearfix,
                                                    $author$project$Ui$Form$Group$margin(19)
                                                ]), _List_fromArray([
                                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                        $elm$html$Html$text(purchaseOrderNumber)
                                                    ]))
                                                ]));
                                            } else return $author$project$Utils$Html$empty;
                                        }(),
                                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Autopay'),
                                            $author$project$Ui$Form$Group$labelSpan(4),
                                            $author$project$Ui$Form$Group$inputSpan(8),
                                            $author$project$Ui$Form$Group$clearfix
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled(practiceInvoice)))
                                            ]))
                                        ])),
                                        $author$project$Api$Provider$PracticeInvoice$One$autoPayEnabled(practiceInvoice) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Autopay On'),
                                            $author$project$Ui$Form$Group$labelSpan(4),
                                            $author$project$Ui$Form$Group$inputSpan(8),
                                            $author$project$Ui$Form$Group$clearfix
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$PracticeInvoice$One$autoPayDate(practiceInvoice))))
                                            ]))
                                        ])) : $author$project$Utils$Html$empty,
                                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Payment Source'),
                                            $author$project$Ui$Form$Group$labelSpan(4),
                                            $author$project$Ui$Form$Group$inputSpan(8),
                                            $author$project$Ui$Form$Group$clearfix
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                function() {
                                                    var _v11 = $author$project$Api$Provider$PracticeInvoice$One$source(practiceInvoice);
                                                    if (!_v11.$) {
                                                        var source = _v11.a;
                                                        return A2($author$project$Components$PaymentSourceDisplayer$view, model.HO, _List_fromArray([
                                                            $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just($author$project$Api$Source$Source(source))),
                                                            $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                                                            $author$project$Components$PaymentSourceDisplayer$limitedView(true)
                                                        ]));
                                                    } else return A2($author$project$Ui$Badge$fromString, _List_Nil, 'none');
                                                }()
                                            ]))
                                        ])),
                                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Total Paid'),
                                            $author$project$Ui$Form$Group$labelSpan(4),
                                            $author$project$Ui$Form$Group$inputSpan(8),
                                            $author$project$Ui$Form$Group$clearfix
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeInvoice$One$paidInCents(practiceInvoice))),
                                                    function() {
                                                        if (!$author$project$Api$Provider$PracticeInvoice$One$status(practiceInvoice)) {
                                                            var showPaymentTime = true;
                                                            var format = showPaymentTime ? 2 : 6;
                                                            return $elm$html$Html$text(' on ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, model.HO(format), $author$project$Api$Provider$PracticeInvoice$One$paidAt(practiceInvoice))));
                                                        } else return $author$project$Utils$Html$empty;
                                                    }()
                                                ]))
                                            ])),
                                            A2($elm$html$Html$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$PaymentsHistoryMsg, A2($author$project$Components$Invoice$PaymentsHistory$view, {
                                                abG: model.F3,
                                                abJ: model.F3,
                                                F3: model.F3,
                                                Wt: A2($elm$core$List$map, $author$project$Api$Payment$Provider_One, $author$project$Api$Provider$PracticeInvoice$One$payments(practiceInvoice)),
                                                ahp: false
                                            }, model.js))
                                        ])),
                                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Total Due'),
                                            $author$project$Ui$Form$Group$labelSpan(4),
                                            $author$project$Ui$Form$Group$inputSpan(8),
                                            $author$project$Ui$Form$Group$clearfix
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeInvoice$One$dueInCents(practiceInvoice)))
                                                ]))
                                            ]))
                                        ]))
                                    ]))
                                ])),
                                $author$project$Ui$HorizontalRule$view(_List_Nil),
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(6)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$hintLabel,
                                            $author$project$Ui$Typography$muted,
                                            $author$project$Ui$Typography$pull(0)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Charges')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(2)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$hintLabel,
                                            $author$project$Ui$Typography$numeric
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Qty')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(2)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$hintLabel,
                                            $author$project$Ui$Typography$numeric
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Price')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(2)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$hintLabel,
                                            $author$project$Ui$Typography$numeric
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Amount')
                                        ]))
                                    ]))
                                ]))
                            ]),
                            A2($elm$core$List$cons, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewFixedFeesCharges(fixedFeeCharges), A2($elm$core$List$map, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewCharge(practiceInvoice), nonFixedFeeCharges)),
                            _List_fromArray([
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(3),
                                        $author$project$Ui$Grid$offset(7)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$hintLabel
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Total')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(2)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                                $author$project$Ui$Typography$numeric,
                                                $author$project$Ui$Typography$bold
                                            ]), _List_fromArray([
                                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$PracticeInvoice$One$totalInCents(practiceInvoice)))
                                            ]))
                                        ]))
                                    ]))
                                ]))
                            ])
                        ]));
                    } else return _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]))
                    ]);
                }())
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$view = function(model) {
        return {
            fb: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$viewBody(model),
            $2: 'Admin | Billing'
        };
    };
    var $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$init,
        aeR: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$load,
        ag3: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$save,
        ahE: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$update,
        aid: $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$view
    });
    var $author$project$Pages$Admin$CancellationReasons$GotItems = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$CancellationReason$cancellationReasonsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'cancellation_reasons'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$CancellationReason$All$CancellationReason = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CancellationReason$Shared$CancellationReason = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CancellationReason$Shared$Record = F3(function(id, description, meta) {
        return {
            NQ: description,
            aef: id,
            Ue: meta
        };
    });
    var $author$project$Api$Provider$CancellationReason$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CancellationReason$Meta$MetaRecord = function(editable) {
        return {
            Ot: editable
        };
    };
    var $author$project$Api$Provider$CancellationReason$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CancellationReason$Meta$MetaRecord));
    var $author$project$Api$Provider$CancellationReason$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CancellationReason$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CancellationReason$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$CancellationReason$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CancellationReason$Shared$Record))));
    var $author$project$Api$Provider$CancellationReason$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CancellationReason$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CancellationReason$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CancellationReason$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CancellationReason$listDefaults = {
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Provider$CancellationReason$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$CancellationReason$listDefaults);
        return $author$project$Api$Pagination$toApiParams(options.af_);
    };
    var $author$project$Api$Provider$CancellationReason$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CancellationReason$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$CancellationReason$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$CancellationReason$cancellationReasonsPath)));
    });
    var $author$project$Pages$Admin$CancellationReasons$fetchItems = function(model) {
        return A3($author$project$Api$Provider$CancellationReason$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_
            });
        }, $author$project$Pages$Admin$CancellationReasons$GotItems);
    };
    var $author$project$Pages$Admin$CancellationReasons$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var model = {
            Ej: apiClient,
            $8: $elm$core$Maybe$Nothing,
            dS: $elm$core$Set$empty,
            F6: $elm$core$Maybe$Nothing,
            i$: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$init
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$CancellationReasons$fetchItems(model));
    });
    var $author$project$Pages$Admin$CancellationReasons$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$CancellationReasons$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$CancellationReasons$CancelEdit = {
        $: 2
    };
    var $author$project$Pages$Admin$CancellationReasons$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CancellationReasons$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CancellationReasons$CancelEdit)), model.F6)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CancellationReasons$HiConfirmClosed), model.$8))
        ]));
    };
    var $author$project$Pages$Admin$CancellationReasons$Deleted = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CancellationReason$cancellationReasonPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$CancellationReason$cancellationReasonsPath);
    };
    var $author$project$Api$Provider$CancellationReason$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CancellationReason$cancellationReasonPath(id_)));
    });
    var $author$project$Api$Provider$CancellationReason$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$CancellationReason$All$description = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CancellationReason$Shared$description(shared);
    };
    var $author$project$Pages$Admin$CancellationReasons$formFieldsFromItem = function(item) {
        return $author$project$Api$Provider$CancellationReason$All$description(item);
    };
    var $author$project$Pages$Admin$CancellationReasons$formFieldsInit = '';
    var $author$project$Pages$Admin$CancellationReasons$formFieldsUpdate = F2(function(field, _v0) {
        var description = field;
        return description;
    });
    var $author$project$Pages$Admin$CancellationReasons$DescriptionValidation = 0;
    var $rtfeldman$elm_validate$Validate$isWhitespaceChar = function(_char) {
        return _char === ' ' || _char === '\n' || _char === '\t' || _char === '\u000D';
    };
    var $rtfeldman$elm_validate$Validate$isBlank = function(str) {
        isBlank: while(true){
            var _v0 = $elm$core$String$uncons(str);
            if (!_v0.$) {
                var _v1 = _v0.a;
                var _char = _v1.a;
                var rest = _v1.b;
                if ($rtfeldman$elm_validate$Validate$isWhitespaceChar(_char)) {
                    var $temp$str = rest;
                    str = $temp$str;
                    continue isBlank;
                } else return false;
            } else return true;
        }
    };
    var $rtfeldman$elm_validate$Validate$ifBlank = F2(function(subjectToString, error) {
        return A2($rtfeldman$elm_validate$Validate$ifTrue, function(subject) {
            return $rtfeldman$elm_validate$Validate$isBlank(subjectToString(subject));
        }, error);
    });
    var $author$project$Pages$Admin$CancellationReasons$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter a description.'))
    ]));
    var $author$project$Api$Provider$CancellationReason$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CancellationReason$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CancellationReason$Shared$id(shared);
    };
    var $elm$core$Set$remove = F2(function(key, _v0) {
        var dict = _v0;
        return A2($elm$core$Dict$remove, key, dict);
    });
    var $author$project$Pages$Admin$CancellationReasons$Created = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$CancellationReason$One$CancellationReason = 0;
    var $author$project$Api$Provider$CancellationReason$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$CancellationReason$create = F3(function(apiClient, description_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('cancellation_reason', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('description', $elm$json$Json$Encode$string(description_))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CancellationReason$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CancellationReason$cancellationReasonsPath)));
    });
    var $author$project$Pages$Admin$CancellationReasons$createItem = F2(function(apiClient, formFields) {
        var description = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$CancellationReason$create, apiClient, description, $author$project$Pages$Admin$CancellationReasons$Created);
    });
    var $author$project$Pages$Admin$CancellationReasons$Updated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$CancellationReason$update = F4(function(apiClient, id_, description_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('cancellation_reason', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('description', $elm$json$Json$Encode$string(description_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$CancellationReason$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CancellationReason$cancellationReasonPath(id_))));
    });
    var $author$project$Pages$Admin$CancellationReasons$updateItem = F3(function(apiClient, id, formFields) {
        var description = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$CancellationReason$update, apiClient, id, description, $author$project$Pages$Admin$CancellationReasons$Updated);
    });
    var $author$project$Pages$Admin$CancellationReasons$saveItem = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id = maybeId.a;
            return A3($author$project$Pages$Admin$CancellationReasons$updateItem, apiClient, id, formFields);
        } else return A2($author$project$Pages$Admin$CancellationReasons$createItem, apiClient, formFields);
    });
    var $author$project$Pages$Admin$CancellationReasons$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Admin$CancellationReasons$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var field = msg.a;
                var _v1 = model.F6;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var id = _v2.a;
                    var form = _v2.b;
                    var item = _v2.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CancellationReasons$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, item))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var form = msg.a;
                var id = msg.b;
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CancellationReasons$formFieldsValidator, form);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Admin$CancellationReasons$saveItem, model.Ej, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                var item = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$CancellationReason$All$id(item)), $author$project$Utils$Form$init($author$project$Pages$Admin$CancellationReasons$formFieldsFromItem(item)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        i$: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    i$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var response = msg.a;
                var _v6 = model.F6;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var id = _v7.a;
                    var form = _v7.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Admin$CancellationReasons$fetchItems(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully created')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v9 = model.F6;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Admin$CancellationReasons$fetchItems(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully updated')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, id, model.dS),
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$CancellationReasons$fetchItems(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Cancellation reason successfully deleted')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, id, model.dS)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 9:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Admin$CancellationReasons$fetchItems(newModel), _List_Nil);
            case 10:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Just(id)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing,
                    dS: A2($elm$core$Set$insert, id, model.dS)
                }), A3($author$project$Api$Provider$CancellationReason$delete, model.Ej, id, $author$project$Pages$Admin$CancellationReasons$Deleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$CancellationReasons$New = {
        $: 0
    };
    var $author$project$Pages$Admin$CancellationReasons$PaginationMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Button$default = $author$project$Ui$Button$Styled(0);
    var $author$project$Api$Data$isSuccess = function(data) {
        if (data.$ === 3) return true;
        else return false;
    };
    var $author$project$Ui$Pagination$List$Loading = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$loading = $author$project$Ui$Pagination$List$Loading;
    var $author$project$Components$HiConfirm$Sentence = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$sentence = $author$project$Components$HiConfirm$Sentence;
    var $author$project$Pages$Admin$CancellationReasons$Description = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$CancellationReasons$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$CancellationReasons$Save = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$Input$Autofocus = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$autofocus = $author$project$Ui$Form$Input$Autofocus;
    var $author$project$Pages$Admin$CancellationReasons$viewItemModal = F3(function(maybeId, item, form) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Cancellation Reason',
            Tk: _Utils_eq(item, $author$project$Api$Data$Loading),
            TR: maybeId,
            TS: $elm$core$Maybe$Just('This update will be effective for future and historical terminations.'),
            Vl: $author$project$Pages$Admin$CancellationReasons$CancelEdit,
            Vn: $author$project$Pages$Admin$CancellationReasons$Save(form)
        };
        var description = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Description')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(description),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$placeholder('Add a reason'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CancellationReasons$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Ui$Table$VerticalCentered = {
        $: 2
    };
    var $author$project$Ui$Table$verticalCentered = $author$project$Ui$Table$VerticalCentered;
    var $author$project$Pages$Admin$CancellationReasons$Edit = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$CancellationReasons$OpenHiConfirm = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$CancellationReason$Meta$editable = function(_v0) {
        var meta = _v0;
        return meta.Ot;
    };
    var $author$project$Api$Provider$CancellationReason$Shared$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Api$Provider$CancellationReason$All$meta = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CancellationReason$Shared$meta(shared);
    };
    var $author$project$Pages$Admin$CancellationReasons$viewItem = F2(function(deletingItems, item) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$CancellationReason$All$description(item))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                if ($author$project$Api$Provider$CancellationReason$Meta$editable($author$project$Api$Provider$CancellationReason$All$meta(item))) {
                    var id = $author$project$Api$Provider$CancellationReason$All$id(item);
                    var loading = A2($elm$core$Set$member, id, deletingItems);
                    return _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$gap2,
                            $author$project$Ui$Element$justifyRight
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit cancellation reason'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$disabled(loading),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$CancellationReasons$Edit(item)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Delete cancellation reason'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$size(0),
                                $author$project$Ui$Button$loading(loading),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$CancellationReasons$OpenHiConfirm(id)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Delete')
                            ]))
                        ]))
                    ]);
                } else return _List_Nil;
            }())
        ]));
    });
    var $author$project$Pages$Admin$CancellationReasons$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.i$;
            if (_v1.$ === 3) {
                var items_ = _v1.a;
                return _Utils_Tuple2(false, items_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var items = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('Add a reason to start tracking why patients end their memberships.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Description')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), A2($elm$core$List$map, $author$project$Pages$Admin$CancellationReasons$viewItem(model.dS), items), _List_Nil);
    };
    var $author$project$Pages$Admin$CancellationReasons$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.F6;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        var form = _v1.b;
                        var item = _v1.c;
                        return A3($author$project$Pages$Admin$CancellationReasons$viewItemModal, id, item, form);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.$8;
                    if (!_v2.$) {
                        var id = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$CancellationReasons$HiConfirmClosed(id), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('cancellation reason'),
                            $author$project$Components$HiConfirm$sentence('If a membership currently has this cancellation reason, it will not have it afterwards.')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Reasons for Membership Cancellation')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'New cancellation reason'
                            }, _List_fromArray([
                                $author$project$Ui$Button$default,
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$CancellationReasons$New),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('New Cancellation Reason')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Admin$CancellationReasons$viewPanelBody(model)
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$CancellationReasons$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.i$))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Cancellation Reasons'
        };
    };
    var $author$project$Pages$Admin$CancellationReasons$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CancellationReasons$init,
        aeR: $author$project$Pages$Admin$CancellationReasons$load,
        ag3: $author$project$Pages$Admin$CancellationReasons$save,
        ahE: $author$project$Pages$Admin$CancellationReasons$subscriptions,
        aaO: $author$project$Pages$Admin$CancellationReasons$update,
        aid: $author$project$Pages$Admin$CancellationReasons$view
    });
    var $author$project$Pages$Admin$CardReaders$GotCardReaderConfiguration = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$None = {
        $: 2
    };
    var $author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'card_reader_configuration'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$CardReaderConfiguration$One$CardReaderConfiguration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CardReaderConfiguration$Shared$CardReaderConfiguration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CardReaderConfiguration$Shared$Record = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Provider$CardReaderConfiguration$Shared$Active = 0;
    var $author$project$Api$Provider$CardReaderConfiguration$Shared$Inactive = 1;
    var $author$project$Api$Provider$CardReaderConfiguration$Shared$statusDecoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'active':
                return $elm$json$Json$Decode$succeed(0);
            case 'inactive':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unsupported Card Reader Configuration status: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$CardReaderConfiguration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$Api$Provider$CardReaderConfiguration$Shared$statusDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CardReaderConfiguration$Shared$Record));
    var $author$project$Api$Provider$CardReaderConfiguration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CardReaderConfiguration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CardReaderConfiguration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CardReaderConfiguration$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CardReaderConfiguration$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CardReaderConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath));
    });
    var $author$project$Pages$Admin$CardReaders$init = F4(function(session, practice, shared, _v0) {
        var model = {
            Ej: shared.Ej,
            ace: $author$project$Pages$Admin$CardReaders$None,
            lq: $author$project$Api$Data$Loading,
            hJ: $author$project$Api$Data$Loading,
            ic: $elm$core$Maybe$Nothing,
            fs: $elm$core$Set$empty,
            $9: false,
            qW: shared.qW,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            Z$: session
        };
        return _Utils_Tuple2(model, A2($author$project$Api$Provider$CardReaderConfiguration$retrieve, shared.Ej, $author$project$Pages$Admin$CardReaders$GotCardReaderConfiguration));
    });
    var $author$project$Pages$Admin$CardReaders$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$CardReaders$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$CardReaders$Cancel = {
        $: 6
    };
    var $author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v0 = model.ace;
                if (_v0.$ === 2) return $elm$core$Platform$Sub$none;
                else return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CardReaders$Cancel);
            }(),
            model.$9 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed) : $elm$core$Platform$Sub$none,
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed), model.ic))
        ]));
    };
    var $author$project$Pages$Admin$CardReaders$Adding = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$CardReadersActivated = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$DeletedCardReader = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CardReaders$Editing = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$CardReaderConfiguration$activate = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CardReaderConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'activate'
        ]), $author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath)));
    });
    var $author$project$Pages$Admin$CardReaders$CreatedCardReader = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$CardReader$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('card_reader', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', $elm$json$Json$Encode$string(fields.aeI)),
                _Utils_Tuple2('registration_code', $elm$json$Json$Encode$string(fields.Lk))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CardReader$Shared$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReadersPath)));
    });
    var $author$project$Pages$Admin$CardReaders$create = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            Lk: fields.Lk,
            aeI: fields.aeI
        };
        return A3($author$project$Api$Provider$CardReader$create, apiClient, apiFields, $author$project$Pages$Admin$CardReaders$CreatedCardReader);
    });
    var $author$project$Pages$Admin$CardReaders$CardReadersDeactivated = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$CardReaderConfiguration$deactivate = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CardReaderConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'deactivate'
        ]), $author$project$Api$Provider$CardReaderConfiguration$cardReaderConfigurationPath)));
    });
    var $author$project$Pages$Admin$CardReaders$deactivateIntegration = function(model) {
        return _Utils_Tuple3(model, function(fn) {
            return fn($author$project$Pages$Admin$CardReaders$CardReadersDeactivated);
        }($author$project$Api$Provider$CardReaderConfiguration$deactivate(model.Ej)), _List_Nil);
    };
    var $author$project$Api$Provider$CardReader$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReaderPath(id)));
    });
    var $author$project$Pages$Admin$CardReaders$editFormFieldsUpdate = F2(function(field, _v0) {
        if (field.$ === 1) {
            var string = field.a;
            return string;
        } else return '';
    });
    var $author$project$Pages$Admin$CardReaders$EditLabelValidation = 0;
    var $author$project$Pages$Admin$CardReaders$editFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter a label.'))
    ]));
    var $author$project$Pages$Admin$CardReaders$GotCardReaders = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$fetchCardReaders = function(apiClient) {
        return A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Pages$Admin$CardReaders$GotCardReaders);
    };
    var $author$project$Pages$Admin$CardReaders$formFieldsFromCardReader = function(cardReader) {
        return $author$project$Api$Provider$CardReader$All$label(cardReader);
    };
    var $author$project$Pages$Admin$CardReaders$formFieldsInit = {
        Lk: '',
        aeI: ''
    };
    var $author$project$Pages$Admin$CardReaders$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                Lk: string
            });
        } else {
            var string = field.a;
            return _Utils_update(fields, {
                aeI: string
            });
        }
    });
    var $author$project$Pages$Admin$CardReaders$CodeValidation = 0;
    var $author$project$Pages$Admin$CardReaders$LabelValidation = 1;
    var $author$project$Pages$Admin$CardReaders$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.aeI;
        }, _Utils_Tuple2(1, 'Please enter a label.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.Lk;
        }, _Utils_Tuple2(0, 'Please enter a code.'))
    ]));
    var $author$project$Ports$Intercom$intercomPortOpen = _Platform_outgoingPort('intercomPortOpen', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Intercom$open = function(session) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortOpen(0);
    };
    var $author$project$Api$Provider$CardReaderConfiguration$Shared$status = function(_v0) {
        var shared = _v0;
        return shared.ahy;
    };
    var $author$project$Api$Provider$CardReaderConfiguration$One$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CardReaderConfiguration$Shared$status(shared);
    };
    var $author$project$Pages$Admin$CardReaders$UpdatedCardReader = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$CardReader$update = F4(function(apiClient, id, label_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('card_reader', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', $elm$json$Json$Encode$string(label_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$CardReader$Shared$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CardReader$cardReaderPath(id))));
    });
    var $author$project$Pages$Admin$CardReaders$updateCardReader = F3(function(apiClient, id, validForm) {
        var validLabel = $rtfeldman$elm_validate$Validate$fromValid(validForm);
        return A4($author$project$Api$Provider$CardReader$update, apiClient, id, validLabel, $author$project$Pages$Admin$CardReaders$UpdatedCardReader);
    });
    var $author$project$Pages$Admin$CardReaders$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(model, function(fn) {
                    return fn($author$project$Pages$Admin$CardReaders$CardReadersActivated);
                }($author$project$Api$Provider$CardReaderConfiguration$activate(model.Ej)), _List_Nil);
            case 13:
                var cardReaderConfiguration = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    lq: cardReaderConfiguration
                }), function() {
                    if (cardReaderConfiguration.$ === 3) {
                        var conf = cardReaderConfiguration.a;
                        var _v2 = $author$project$Api$Provider$CardReaderConfiguration$One$status(conf);
                        if (!_v2) return $author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Ej);
                        else return $elm$core$Platform$Cmd$none;
                    } else return $elm$core$Platform$Cmd$none;
                }(), $author$project$OutMsg$reportDecodeError(cardReaderConfiguration));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    hJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    ace: $author$project$Pages$Admin$CardReaders$Adding(_Utils_Tuple2($author$project$Utils$Form$init($author$project$Pages$Admin$CardReaders$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var cardReader = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ace: $author$project$Pages$Admin$CardReaders$Editing(_Utils_Tuple3($author$project$Api$Provider$CardReader$All$id(cardReader), $author$project$Utils$Form$init($author$project$Pages$Admin$CardReaders$formFieldsFromCardReader(cardReader)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var field = msg.a;
                var _v3 = model.ace;
                switch(_v3.$){
                    case 0:
                        var _v4 = _v3.a;
                        var form = _v4.a;
                        var cardReader = _v4.b;
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CardReaders$formFieldsUpdate, field, form);
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$Adding(_Utils_Tuple2(newForm, cardReader))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 1:
                        var _v5 = _v3.a;
                        var id = _v5.a;
                        var form = _v5.b;
                        var editingCardReader = _v5.c;
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CardReaders$editFormFieldsUpdate, field, form);
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$Editing(_Utils_Tuple3(id, newForm, editingCardReader))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 5:
                var saveCardReader = msg.a;
                if (!saveCardReader.$) {
                    var form = saveCardReader.a;
                    var _v7 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CardReaders$formFieldsValidator, form);
                    if (!_v7.$) {
                        var _v8 = _v7.a;
                        var newForm = _v8.a;
                        var validFormFields = _v8.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$Adding(_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
                        }), A2($author$project$Pages$Admin$CardReaders$create, model.Ej, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v7.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$Adding(_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else {
                    var form = saveCardReader.a;
                    var id = saveCardReader.b;
                    var _v9 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CardReaders$editFormFieldsValidator, form);
                    if (!_v9.$) {
                        var _v10 = _v9.a;
                        var newForm = _v10.a;
                        var validFormFields = _v10.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$Editing(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                        }), A3($author$project$Pages$Admin$CardReaders$updateCardReader, model.Ej, id, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v9.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$Editing(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                }
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    ace: $author$project$Pages$Admin$CardReaders$None
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v11 = model.ace;
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var form = _v12.a;
                    if (response.$ === 3) {
                        var cardReader = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$None,
                            hJ: $author$project$Api$Data$Loading
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Ej),
                            A2($author$project$Ports$LocalStorage$setItem, 'last-used-card-reader', $author$project$Api$Provider$CardReader$Shared$id(cardReader))
                        ])), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$CardReader$Shared$label(cardReader))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        ace: $author$project$Pages$Admin$CardReaders$Adding(_Utils_Tuple2(form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$None,
                            hJ: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Ej), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Card reader updated')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            ace: $author$project$Pages$Admin$CardReaders$None
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 9:
                var cardReader = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ic: $elm$core$Maybe$Just(cardReader)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var cardReader = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            hJ: $author$project$Api$Data$Loading,
                            fs: A2($elm$core$Set$remove, $author$project$Api$Provider$CardReader$All$id(cardReader), model.fs)
                        }), $author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Ej), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$CardReader$All$label(cardReader) + ' was successfully removed.')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            fs: A2($elm$core$Set$remove, $author$project$Api$Provider$CardReader$All$id(cardReader), model.fs)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 11:
                var configurationData = msg.a;
                switch(configurationData.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            lq: configurationData
                        }), $author$project$Pages$Admin$CardReaders$fetchCardReaders(model.Ej), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Card reader integration activated. Please add your card reader now.')
                        ]));
                    case 2:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(configurationData));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 12:
                var configurationData = msg.a;
                switch(configurationData.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            lq: configurationData
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Card reader integration deactivated.')
                        ]));
                    case 2:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(configurationData));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 14:
                return _Utils_Tuple3(_Utils_update(model, {
                    $9: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var confirmed = msg.a;
                return confirmed ? $author$project$Pages$Admin$CardReaders$deactivateIntegration(_Utils_update(model, {
                    $9: false
                })) : _Utils_Tuple3(_Utils_update(model, {
                    $9: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var cardReader = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$CardReader$All$id(cardReader);
                    return _Utils_Tuple3(_Utils_update(model, {
                        ic: $elm$core$Maybe$Nothing,
                        fs: A2($elm$core$Set$insert, id, model.fs)
                    }), A3($author$project$Api$Provider$CardReader$delete, model.Ej, id, $author$project$Pages$Admin$CardReaders$DeletedCardReader(cardReader)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ic: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(model, $author$project$Ports$Intercom$open(model.Z$), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$CardReaders$AddCardReaderButtonClicked = {
        $: 2
    };
    var $author$project$Api$Feature$AllowStripeCardReaders = 14;
    var $author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmOpened = {
        $: 14
    };
    var $author$project$Pages$Admin$CardReaders$ShowSupportChat = {
        $: 17
    };
    var $author$project$Pages$Admin$CardReaders$rainforestSetupStepTwo = _List_fromArray([
        $elm$html$Html$text('Set up your new card readers once they arrive by clicking \'Add Card Reader\' above. If you need assistance, please '),
        A3($author$project$Ui$Button$view, {
            abP: 'Contact support'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$ShowSupportChat)
        ]), _List_fromArray([
            $elm$html$Html$text('contact Support')
        ]))
    ]);
    var $author$project$Pages$Admin$CardReaders$stripeSetupStepTwo = _List_fromArray([
        $elm$html$Html$text('Please click on \"Add Card Reader\" above to initiate the process. If you need more assistance such as setting up Wi-Fi, please refer to these'),
        A3($author$project$Ui$Link$externalHref, 'https://docs.stripe.com/terminal/payments/setup-reader', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text(' guides.')
        ]))
    ]);
    var $author$project$Pages$Admin$CardReaders$setupStepTwo = function(practice) {
        return $author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe' ? $author$project$Pages$Admin$CardReaders$stripeSetupStepTwo : $author$project$Pages$Admin$CardReaders$rainforestSetupStepTwo;
    };
    var $author$project$Ui$ListGroup$defaultOptions = {
        vD: _List_Nil,
        D4: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$ListGroup$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            if (!option.$) {
                var contents = option.a;
                return _Utils_update(record, {
                    D4: $elm$core$Maybe$Just(contents)
                });
            } else {
                var style_ = option.a;
                switch(style_){
                    case 0:
                        return _Utils_update(record, {
                            vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('background-success'), record.vD)
                        });
                    case 1:
                        return _Utils_update(record, {
                            vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('background-info'), record.vD)
                        });
                    case 2:
                        return _Utils_update(record, {
                            vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('background-warning'), record.vD)
                        });
                    case 3:
                        return _Utils_update(record, {
                            vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('background-error'), record.vD)
                        });
                    default:
                        return _Utils_update(record, {
                            vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('background-header'), record.vD)
                        });
                }
            }
        }), $author$project$Ui$ListGroup$defaultOptions, options);
    };
    var $author$project$Ui$ListGroup$itemOptionToAttributes = function(option) {
        switch(option.$){
            case 0:
                var style_ = option.a;
                switch(style_){
                    case 0:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('list-group-item-success')
                        ]);
                    case 1:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('list-group-item-info')
                        ]);
                    case 2:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('list-group-item-warning')
                        ]);
                    case 3:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('list-group-item-danger')
                        ]);
                    default:
                        return _List_fromArray([
                            $elm$html$Html$Attributes$class('list-group-item__header')
                        ]);
                }
            case 1:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('clearfix')
                ]);
            case 2:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('note')
                ]);
            case 3:
                return _List_fromArray([
                    $elm$html$Html$Attributes$class('active')
                ]);
            default:
                return _List_fromArray([
                    $author$project$Utils$Html$Attributes$none
                ]);
        }
    };
    var $author$project$Ui$ListGroup$itemOptionsToAttributes = function(options) {
        return A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), A2($elm$core$List$concatMap, $author$project$Ui$ListGroup$itemOptionToAttributes, options));
    };
    var $author$project$Ui$ListGroup$viewItem = function(_v0) {
        var options = _v0.a;
        var contents = _v0.b;
        return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('list-group-item'), $author$project$Ui$ListGroup$itemOptionsToAttributes(options)), contents);
    };
    var $author$project$Ui$ListGroup$viewZeroState = function(zeroState_) {
        return A2($elm$html$Html$li, _List_fromArray([
            $elm$html$Html$Attributes$class('text-center list-group-item')
        ]), _List_fromArray([
            $elm$html$Html$text(zeroState_)
        ]));
    };
    var $author$project$Ui$ListGroup$view = F2(function(options, items) {
        var optionsRecord = $author$project$Ui$ListGroup$optionsToRecord(options);
        return A2($elm$html$Html$ul, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('list-group'), optionsRecord.vD), _Utils_ap(function() {
            var _v0 = _Utils_Tuple2(optionsRecord.D4, $elm$core$List$isEmpty(items));
            if (!_v0.a.$ && _v0.b) {
                var zeroState_ = _v0.a.a;
                return _List_fromArray([
                    $author$project$Ui$ListGroup$viewZeroState(zeroState_)
                ]);
            } else return _List_Nil;
        }(), A2($elm$core$List$map, $author$project$Ui$ListGroup$viewItem, items)));
    });
    var $author$project$Pages$Admin$CardReaders$DeleteCardReaderButtonClicked = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$EditCardReaderButtonClicked = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$ListGroup$Item = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$ListGroup$item = $author$project$Ui$ListGroup$Item;
    var $author$project$Api$Provider$CardReader$Shared$serialNumber = function(_v0) {
        var record = _v0;
        return record.ZW;
    };
    var $author$project$Api$Provider$CardReader$All$serialNumber = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CardReader$Shared$serialNumber(shared);
    };
    var $author$project$Pages$Admin$CardReaders$viewCardReader = F2(function(showProcessor, cardReader) {
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(9)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, showProcessor, showProcessor, cardReader, A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just))),
                        $elm$html$Html$text($author$project$Api$Provider$CardReader$All$label(cardReader))
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(' - SN: ' + $author$project$Api$Provider$CardReader$All$serialNumber(cardReader))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'edit card reader'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$EditCardReaderButtonClicked(cardReader)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete card reader'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$DeleteCardReaderButtonClicked(cardReader)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$CardReaders$viewMigrationAlert = A2($elm$html$Html$div, _List_fromArray([
        $elm$html$Html$Attributes$class('m-0'),
        A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
    ]), _List_fromArray([
        A2($author$project$Ui$Alert$warning, _List_fromArray([
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
        ]), _List_fromArray([
            $elm$html$Html$text('Card readers purchased from Stripe are not compatible with Hint Payments. Please order a new reader as part of Hint Payments setup.'),
            A2($elm$html$Html$ul, _List_fromArray([
                $elm$html$Html$Attributes$class('list-align-left')
            ]), _List_fromArray([
                A2($elm$html$Html$li, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
                ]), _List_fromArray([
                    $elm$html$Html$text('Hint will cover the cost if you want to replace your card reader.')
                ])),
                A2($elm$html$Html$li, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
                ]), _List_fromArray([
                    $elm$html$Html$text('Please complete this '),
                    A3($author$project$Ui$Link$externalHref, 'https://hinthealth.typeform.com/to/xgWqDFVc', _List_Nil, _List_fromArray([
                        $elm$html$Html$text('form')
                    ])),
                    $elm$html$Html$text(' to place an order and we\'ll take care of the rest.')
                ]))
            ]))
        ]))
    ]));
    var $author$project$Ui$Tooltip$Active = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Tooltip$active = $author$project$Ui$Tooltip$Active;
    var $author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip = F2(function(usingStripe, contents) {
        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$active(usingStripe),
            $author$project$Ui$Tooltip$wide
        ]), 'Card readers are only supported on Hint Payments', contents);
    });
    var $author$project$Pages$Admin$CardReaders$viewActiveAccount = function(model) {
        var usingStripe = $author$project$Api$Provider$Practice$One$paymentProcessor(model.W1) === 'stripe';
        var allowAddingReader = !usingStripe || A2($author$project$Api$Provider$Practice$One$featureEnabled, 14, model.W1);
        return _List_fromArray([
            usingStripe ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Pages$Admin$CardReaders$viewMigrationAlert
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'active'),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Deactivate the integration'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmOpened)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Deactivate the integration')
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('You can now allow patients to pay in-person with credit or '),
                    $elm$html$Html$text('debit cards directly using your connected card readers.')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Card Readers'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip, !allowAddingReader, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Add card reader'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$AddCardReaderButtonClicked),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                        $author$project$Ui$Button$disabled(!allowAddingReader)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add Card Reader')
                    ]))
                ])),
                function() {
                    var _v0 = model.hJ;
                    if (_v0.$ === 3) {
                        var cardReaders = _v0.a;
                        return $elm$core$List$isEmpty(cardReaders) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_fromArray([
                            A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
                        ]), _List_fromArray([
                            A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Admin$CardReaders$viewCardReader(model.F3), cardReaders))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            usingStripe ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Setup Information'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($elm$html$Html$ol, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
                ]), _List_fromArray([
                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$title, _List_fromArray([
                            $author$project$Ui$Typography$bold
                        ]), _List_fromArray([
                            $elm$html$Html$text('Order your reader')
                        ]))
                    ])),
                    A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Select and order reader(s) through Hint Support ('),
                        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/en/articles/10967048-ordering-a-card-reader', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('Instructions here')
                        ])),
                        $elm$html$Html$text(').')
                    ])),
                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$title, _List_fromArray([
                            $author$project$Ui$Typography$bold
                        ]), _List_fromArray([
                            $elm$html$Html$text('Set up your new card reader')
                        ]))
                    ])),
                    A2($elm$html$Html$p, _List_Nil, $author$project$Pages$Admin$CardReaders$setupStepTwo(model.W1))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$CardReaders$FormUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$Label = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$Save = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$Updating = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CardReaders$viewEditModal = F3(function(id, form, cardReader) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Card Reader',
            Tk: _Utils_eq(cardReader, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just(id),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$CardReaders$Cancel,
            Vn: function(_v0) {
                return $author$project$Pages$Admin$CardReaders$Save(A2($author$project$Pages$Admin$CardReaders$Updating, form, id));
            }
        };
        var label = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Reader Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(label),
                    $author$project$Ui$Form$Input$placeholder('e.g. Lobby Computer'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Label)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$CardReaders$ActivateIntegrationClicked = {
        $: 0
    };
    var $author$project$Api$Provider$Practice$Shared$hasPaymentProcessorAccount = function(_v0) {
        var record = _v0;
        return record.Qw;
    };
    var $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$hasPaymentProcessorAccount(shared);
    };
    var $author$project$Api$Common$Address$Shared$isAddressIncomplete = function(_v0) {
        var record = _v0;
        return A2($elm$core$List$any, $elm$core$Basics$identity, A2($elm$core$List$map, $elm$core$String$isEmpty, A2($elm$core$List$map, $elm$core$Maybe$withDefault(''), _List_fromArray([
            record.ri,
            record.pW,
            record.s4,
            record.tK,
            record.p0
        ]))));
    };
    var $author$project$Api$Provider$Practice$One$hasValidAddress = function(_v0) {
        var record = _v0.b;
        var _v1 = record.II;
        if (!_v1.$) {
            var address_ = _v1.a;
            return !$author$project$Api$Common$Address$Shared$isAddressIncomplete(address_);
        } else return false;
    };
    var $author$project$Pages$Admin$CardReaders$renderHtmlIf = F2(function(condition, element) {
        return condition ? element : $elm$html$Html$text('');
    });
    var $author$project$Pages$Admin$CardReaders$viewRequirementsAlert = function(practice) {
        var hasValidAddress = $author$project$Api$Provider$Practice$One$hasValidAddress(practice);
        var hasPaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice);
        return hasPaymentProcessorAccount && hasValidAddress ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('m-0'),
            A2($elm$html$Html$Attributes$style, 'padding-top', '1em')
        ]), _List_fromArray([
            A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('The card reader integration requires ')
                ])),
                A2($author$project$Pages$Admin$CardReaders$renderHtmlIf, !hasValidAddress, A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('an up-to-date address')
                ]))),
                A2($author$project$Pages$Admin$CardReaders$renderHtmlIf, !hasPaymentProcessorAccount && !hasValidAddress, A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' and ')
                ]))),
                A2($author$project$Pages$Admin$CardReaders$renderHtmlIf, !hasPaymentProcessorAccount, function() {
                    var _v0 = $author$project$Api$Provider$Practice$One$paymentProcessor(practice);
                    if (_v0 === 'stripe') return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Stripe, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('an active Stripe account')
                    ]));
                    else return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__PaymentProcessing, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('an active Payment Processing account')
                    ]));
                }()),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('.')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$CardReaders$viewInactiveAccount = function(practice) {
        var usingStripe = $author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe';
        var hasValidAddress = $author$project$Api$Provider$Practice$One$hasValidAddress(practice);
        var hasPaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice);
        return _List_fromArray([
            usingStripe ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Pages$Admin$CardReaders$viewRequirementsAlert(practice)
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
                ])),
                A2($author$project$Pages$Admin$CardReaders$withDisabledIFStripeTooltip, usingStripe, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Enable Card Readers Integration'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$disabled(!hasPaymentProcessorAccount || !hasValidAddress || usingStripe),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$CardReaders$ActivateIntegrationClicked)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Enable Card Readers Integration')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('About'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Customers can swipe or insert their cards into our reader for storing and processing payments.')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('How it works'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$ol, _List_fromArray([
                        A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
                    ]), _List_fromArray([
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Enable the card reader integration.')
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Order your card reader(s) through Hint Support ('),
                            A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/en/articles/10967048-ordering-a-card-reader', _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text('Instructions here')
                            ])),
                            $elm$html$Html$text(').')
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Connect your card reader(s) in Hint once they arrive.')
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Start accepting payments using your card reader(s).')
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$CardReaders$Code = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$CardReaders$Creating = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Image$RainforestCardReaderSplash = 6;
    var $author$project$Ui$Popover$Footer = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Popover$footer = $author$project$Ui$Popover$Footer;
    var $author$project$Ui$Image$Height = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Image$height = $author$project$Ui$Image$Height;
    var $author$project$Ui$Image$Cdn = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Image$Local = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Image$imageToSource = function(image) {
        switch(image){
            case 0:
                return $author$project$Ui$Image$Local('find-ga-code');
            case 1:
                return $author$project$Ui$Image$Local('elationemr-logo');
            case 2:
                return $author$project$Ui$Image$Local('stripe-logo');
            case 3:
                return $author$project$Ui$Image$Local('mailgun-logo');
            case 4:
                return $author$project$Ui$Image$Local('sample-check');
            case 5:
                return $author$project$Ui$Image$Local('stripe-terminal-verifone-default-splash');
            case 6:
                return $author$project$Ui$Image$Local('rainforest-terminal-splash');
            case 13:
                return $author$project$Ui$Image$Local('help-circle');
            case 7:
                return $author$project$Ui$Image$Local('elationemr-blue-logo');
            case 8:
                return $author$project$Ui$Image$Cdn('partners/quickbooks/QuickBooks%20Logo_Horz.png');
            case 9:
                return $author$project$Ui$Image$Cdn('partners/quickbooks/C2QB_green_btn_lg_default.png');
            case 10:
                return $author$project$Ui$Image$Cdn('marketing-whitelabel-attribution.svg');
            case 11:
                return $author$project$Ui$Image$Cdn('logo-mark.svg');
            case 12:
                return $author$project$Ui$Image$Cdn('full-logo.svg');
            case 14:
                return $author$project$Ui$Image$Cdn('onboarding-complete.png');
            case 15:
                return $author$project$Ui$Image$Local('product-highlight-image-placeholder');
            default:
                return $author$project$Ui$Image$Local('marketplace-icon-placeholder');
        }
    };
    var $author$project$Ui$Image$nameToCdnSrc = function(imagePath) {
        return 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/' + imagePath;
    };
    var $author$project$Ui$Image$nameToLocalSrc = F2(function(_v0, image) {
        var store = _v0;
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm_community$list_extra$List$Extra$find, function(_v1) {
            var imagePath = _v1.a;
            return _Utils_eq(imagePath, image);
        }, store)));
    });
    var $author$project$Ui$Image$imageToSrc = F2(function(store, image) {
        var _v0 = $author$project$Ui$Image$imageToSource(image);
        if (!_v0.$) {
            var nameString = _v0.a;
            return A2($author$project$Ui$Image$nameToLocalSrc, store, nameString);
        } else {
            var nameString = _v0.a;
            return $author$project$Ui$Image$nameToCdnSrc(nameString);
        }
    });
    var $author$project$Ui$Image$Alt = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$html$Html$img = _VirtualDom_node('img');
    var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
    var $author$project$Ui$Image$defaultOptions = {
        vD: _List_Nil
    };
    var $elm$html$Html$Attributes$height = function(n) {
        return A2(_VirtualDom_attribute, 'height', $elm$core$String$fromInt(n));
    };
    var $author$project$Ui$Image$screenSizeToHeightAutoClass = function(screenSize) {
        return $author$project$Ui$ScreenSize$toClassPrefix(screenSize) + 'h-auto';
    };
    var $elm$html$Html$Attributes$width = function(n) {
        return A2(_VirtualDom_attribute, 'width', $elm$core$String$fromInt(n));
    };
    var $author$project$Ui$Image$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var _int = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$width(_int), record.vD)
                    });
                case 1:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$alt(string), record.vD)
                    });
                case 2:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class(string), record.vD)
                    });
                case 3:
                    var _int = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$height(_int), record.vD)
                    });
                case 4:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('w-full block'), record.vD)
                    });
                case 5:
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class('rounded-lg'), record.vD)
                    });
                default:
                    var screenSize = option.a;
                    var sizeClass = $author$project$Ui$Image$screenSizeToHeightAutoClass(screenSize);
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class(sizeClass), record.vD)
                    });
            }
        }), $author$project$Ui$Image$defaultOptions, options);
    };
    var $elm$html$Html$Attributes$src = function(url) {
        return A2($elm$html$Html$Attributes$stringProperty, 'src', _VirtualDom_noJavaScriptOrHtmlUri(url));
    };
    var $author$project$Ui$Image$viewImg = F3(function(_v0, stringSrc, optionsMinusAlt) {
        var alt = _v0.Jg;
        var options = A2($elm$core$List$cons, $author$project$Ui$Image$Alt(alt), optionsMinusAlt);
        var optionsRecord = $author$project$Ui$Image$optionsToRecord(options);
        return A2($elm$html$Html$img, A2($elm$core$List$cons, $elm$html$Html$Attributes$src(stringSrc), optionsRecord.vD), _List_Nil);
    });
    var $author$project$Ui$Image$view = F4(function(store, accessibilityOptions, options, source) {
        return A3($author$project$Ui$Image$viewImg, accessibilityOptions, A2($author$project$Ui$Image$imageToSrc, store, source), options);
    });
    var $author$project$Ui$Image$Width = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Image$width = $author$project$Ui$Image$Width;
    var $author$project$Pages$Admin$CardReaders$viewRainforestConnectInstructions = function(imageStore) {
        return _List_fromArray([
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Popover$view, _List_fromArray([
                    $author$project$Ui$Popover$dark
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Make sure the reader is on standby mode ')
                        ])),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $author$project$Ui$Icon$help(_List_Nil)
                        ]))
                    ]))
                ]), _List_fromArray([
                    A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('The standby reader screen should look like this:')
                    ])),
                    A2($author$project$Ui$Popover$footer, _List_Nil, _List_fromArray([
                        A4($author$project$Ui$Image$view, imageStore, {
                            Jg: 'Rainforest card reader standby screen displaying 6-digit registration code'
                        }, _List_fromArray([
                            $author$project$Ui$Image$width(320),
                            $author$project$Ui$Image$height(320)
                        ]), 6)
                    ]))
                ]))
            ])),
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($elm$html$Html$p, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
                ]), _List_fromArray([
                    $elm$html$Html$text('Identify the reader\'s registration code.')
                ])),
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Registration codes are the 6 digits displayed on the reader screen.')
                    ]))
                ]))
            ])),
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Fill in the registration code below')
            ]))
        ]);
    };
    var $author$project$Ui$Image$StripeCardReaderSplash = 5;
    var $author$project$Pages$Admin$CardReaders$viewStripeConnectInstructions = function(imageStore) {
        return _List_fromArray([
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Popover$view, _List_fromArray([
                    $author$project$Ui$Popover$dark
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Make sure the reader is on standby mode ')
                        ])),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $author$project$Ui$Icon$help(_List_Nil)
                        ]))
                    ]))
                ]), _List_fromArray([
                    A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('The standby reader screen should look like this:')
                    ])),
                    A2($author$project$Ui$Popover$footer, _List_Nil, _List_fromArray([
                        A4($author$project$Ui$Image$view, imageStore, {
                            Jg: 'Stripe card reader standby screen showing welcome message'
                        }, _List_Nil, 5)
                    ]))
                ]))
            ])),
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($elm$html$Html$p, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
                ]), _List_fromArray([
                    $elm$html$Html$text('Generate a pairing code.')
                ])),
                A2($elm$html$Html$p, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
                ]), _List_fromArray([
                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Keypad: ')
                    ])),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Enter the key sequence 0-7-1-3-9.')
                    ]))
                ])),
                A2($elm$html$Html$p, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'margin-bottom', '3px')
                ]), _List_fromArray([
                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Touchscreen: ')
                    ])),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Swipe right from the left edge of the reader screen to reveal a settings button. '),
                        $elm$html$Html$text('Tap the settings button and enter the admin PIN 0-7-1-3-9. Tap the generate pairing code button.')
                    ]))
                ]))
            ])),
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Fill in the pairing code below')
            ]))
        ]);
    };
    var $author$project$Pages$Admin$CardReaders$viewConnectInstructions = F2(function(imageStore, practice) {
        var _v0 = $author$project$Api$Provider$Practice$One$paymentProcessor(practice);
        if (_v0 === 'stripe') return $author$project$Pages$Admin$CardReaders$viewStripeConnectInstructions(imageStore);
        else return $author$project$Pages$Admin$CardReaders$viewRainforestConnectInstructions(imageStore);
    });
    var $author$project$Pages$Admin$CardReaders$viewModal = F4(function(imageStore, practice, form, cardReader) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Card Reader',
            Tk: _Utils_eq(cardReader, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Nothing,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$CardReaders$Cancel,
            Vn: function(_v1) {
                return $author$project$Pages$Admin$CardReaders$Save($author$project$Pages$Admin$CardReaders$Creating(form));
            }
        };
        var _v0 = $author$project$Utils$Form$fields(form);
        var label = _v0.aeI;
        var code = _v0.Lk;
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('How it works'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$ol, _List_fromArray([
                        A2($elm$html$Html$Attributes$style, 'padding-left', '1em')
                    ]), A2($author$project$Pages$Admin$CardReaders$viewConnectInstructions, imageStore, practice))
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Code'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(code),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Code)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Reader Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(label),
                    $author$project$Ui$Form$Input$placeholder('e.g. Lobby Computer'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CardReaders$FormUpdated, $author$project$Pages$Admin$CardReaders$Label)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$CardReaders$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.ace;
                    switch(_v0.$){
                        case 0:
                            var _v1 = _v0.a;
                            var form = _v1.a;
                            var cardReader = _v1.b;
                            return A4($author$project$Pages$Admin$CardReaders$viewModal, model.qW, model.W1, form, cardReader);
                        case 1:
                            var _v2 = _v0.a;
                            var id = _v2.a;
                            var form = _v2.b;
                            var cardReader = _v2.c;
                            return A3($author$project$Pages$Admin$CardReaders$viewEditModal, id, form, cardReader);
                        default:
                            return $author$project$Utils$Html$empty;
                    }
                }(),
                model.$9 ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$CardReaders$DisableIntegrationHiConfirmClosed, _List_fromArray([
                    $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                        $elm$html$Html$text('Please confirm you would like to deactivate this card reader integration. '),
                        $elm$html$Html$text('Your card readers may need to be synced again manually in the future.')
                    ]))
                ])) : $author$project$Utils$Html$empty,
                function() {
                    var _v3 = model.ic;
                    if (!_v3.$) {
                        var cardReader = _v3.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$CardReaders$DeleteCardReaderHiConfirmClosed(cardReader), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('card reader')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Card Readers')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, function() {
                            var _v4 = model.lq;
                            switch(_v4.$){
                                case 3:
                                    var conf = _v4.a;
                                    var _v5 = $author$project$Api$Provider$CardReaderConfiguration$One$status(conf);
                                    if (!_v5) return $author$project$Pages$Admin$CardReaders$viewActiveAccount(model);
                                    else return $author$project$Pages$Admin$CardReaders$viewInactiveAccount(model.W1);
                                case 1:
                                    return _List_fromArray([
                                        $author$project$Ui$Spinner$view(_List_Nil)
                                    ]);
                                default:
                                    return _List_Nil;
                            }
                        }())
                    ]))
                ]))
            ]),
            $2: 'Integrations | Card Readers'
        };
    };
    var $author$project$Pages$Admin$CardReaders$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CardReaders$init,
        aeR: $author$project$Pages$Admin$CardReaders$load,
        ag3: $author$project$Pages$Admin$CardReaders$save,
        ahE: $author$project$Pages$Admin$CardReaders$subscriptions,
        aaO: $author$project$Pages$Admin$CardReaders$update,
        aid: $author$project$Pages$Admin$CardReaders$view
    });
    var $author$project$Pages$Admin$Categories$GotCategories = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Common$Category$ListOptionals$ThisMonthChargesAggregates = 0;
    var $author$project$Api$Provider$Category$categoriesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'categories'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Category$All$Category = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Category$Shared$Category = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Category$Shared$Record = F3(function(id, name, defaultForMemberships) {
        return {
            Fd: defaultForMemberships,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Category$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_for_memberships', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$Shared$Record))));
    var $author$project$Api$Provider$Category$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Category$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Category$All$Record = F3(function(lastUsedAt, chargesThisMonthCount, chargesThisMonthAmountInCents) {
        return {
            La: chargesThisMonthAmountInCents,
            Lb: chargesThisMonthCount,
            S$: lastUsedAt
        };
    });
    var $author$project$Api$Provider$Category$All$recordDecoder = A3($author$project$Api$Expandable$expandable, 'charges_this_month_amount_in_cents', $elm$json$Json$Decode$int, A3($author$project$Api$Expandable$expandable, 'charges_this_month_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_used_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$All$Record))));
    var $author$project$Api$Provider$Category$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Category$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Category$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$All$Category)));
    var $author$project$Api$Param$Bool = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Param$bool = $author$project$Api$Param$Bool;
    var $author$project$Api$Common$Category$ListOptionals$defaults = {
        Fd: $elm$core$Maybe$Nothing,
        Fq: _List_Nil,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Common$Category$ListOptionals$expandToString = function(expand) {
        return 'this_month_charges_aggregates';
    };
    var $author$project$Api$Expandable$toParam = F2(function(toString, expand) {
        return _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, toString, expand))
        ]);
    });
    var $author$project$Api$Common$Category$ListOptionals$toParams = function(optionals) {
        var options = optionals($author$project$Api$Common$Category$ListOptionals$defaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fd;
                if (!_v2.$) {
                    var bool = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'default_for_memberships', bool)
                    ]);
                } else return _List_Nil;
            }(),
            $elm$core$List$isEmpty(options.Fq) ? _List_Nil : A2($author$project$Api$Expandable$toParam, $author$project$Api$Common$Category$ListOptionals$expandToString, options.Fq),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Category$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Category$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$Category$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Category$categoriesPath)));
    });
    var $author$project$Pages$Admin$Categories$fetchCategories = function(model) {
        return A3($author$project$Api$Provider$Category$list, model.Ej, function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ]),
                af_: model.af_
            });
        }, $author$project$Pages$Admin$Categories$GotCategories);
    };
    var $author$project$Pages$Admin$Categories$init = F4(function(_v0, practice, shared, _v1) {
        var model = {
            Ej: shared.Ej,
            K0: $author$project$Api$Data$Loading,
            EL: $elm$core$Maybe$Nothing,
            dN: $elm$core$Set$empty,
            bX: $elm$core$Maybe$Nothing,
            af_: $author$project$Api$Pagination$init,
            W1: practice,
            HO: shared.HO
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$Categories$fetchCategories(model));
    });
    var $author$project$Pages$Admin$Categories$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Categories$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Categories$CancelCategoryEdit = {
        $: 2
    };
    var $author$project$Pages$Admin$Categories$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Category$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Category$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Category$Shared$id(shared);
    };
    var $author$project$Pages$Admin$Categories$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Categories$CancelCategoryEdit)), model.EL)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Categories$HiConfirmClosed), $author$project$Api$Provider$Category$All$id), model.bX))
        ]));
    };
    var $author$project$Pages$Admin$Categories$CategoryDeleted = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Category$categoryPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Category$categoriesPath);
    };
    var $author$project$Api$Provider$Category$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Category$categoryPath(id_)));
    });
    var $author$project$Api$Provider$Category$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Category$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Category$Shared$name(shared);
    };
    var $author$project$Pages$Admin$Categories$formFieldsFromCategory = function(category) {
        return $author$project$Api$Provider$Category$All$name(category);
    };
    var $author$project$Pages$Admin$Categories$formFieldsInit = '';
    var $author$project$Pages$Admin$Categories$formFieldsUpdate = F2(function(field, _v0) {
        var string = field;
        return string;
    });
    var $author$project$Pages$Admin$Categories$NameValidation = 0;
    var $author$project$Pages$Admin$Categories$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Pages$Admin$Categories$CategoryCreated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Category$One$Category = 0;
    var $author$project$Api$Provider$Category$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Category$create = F3(function(apiClient, name_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('category', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(name_))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Category$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Category$categoriesPath)));
    });
    var $author$project$Pages$Admin$Categories$createCategory = F2(function(apiClient, formFields) {
        var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Category$create, apiClient, name, $author$project$Pages$Admin$Categories$CategoryCreated);
    });
    var $author$project$Pages$Admin$Categories$CategoryUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Category$update = F4(function(apiClient, id_, name_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('category', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(name_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Category$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Category$categoryPath(id_))));
    });
    var $author$project$Pages$Admin$Categories$updateCategory = F3(function(apiClient, id, formFields) {
        var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Category$update, apiClient, id, name, $author$project$Pages$Admin$Categories$CategoryUpdated);
    });
    var $author$project$Pages$Admin$Categories$saveCategory = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id = maybeId.a;
            return A3($author$project$Pages$Admin$Categories$updateCategory, apiClient, id, formFields);
        } else return A2($author$project$Pages$Admin$Categories$createCategory, apiClient, formFields);
    });
    var $author$project$Pages$Admin$Categories$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    EL: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Admin$Categories$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var field = msg.a;
                var _v1 = model.EL;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var id = _v2.a;
                    var form = _v2.b;
                    var category = _v2.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Categories$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        EL: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, category))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var form = msg.a;
                var id = msg.b;
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Categories$formFieldsValidator, form);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        EL: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Admin$Categories$saveCategory, model.Ej, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        EL: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                var category = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    EL: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$Category$All$id(category)), $author$project$Utils$Form$init($author$project$Pages$Admin$Categories$formFieldsFromCategory(category)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    EL: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        K0: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    K0: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var response = msg.a;
                var _v6 = model.EL;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var id = _v7.a;
                    var form = _v7.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        EL: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Admin$Categories$fetchCategories(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully created')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        EL: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v9 = model.EL;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        EL: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Admin$Categories$fetchCategories(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully updated')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        EL: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var id = msg.a;
                var dataCategory = msg.b;
                switch(dataCategory.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            K0: $author$project$Api$Data$Loading,
                            dN: A2($elm$core$Set$remove, id, model.dN)
                        }), $author$project$Pages$Admin$Categories$fetchCategories(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Charge category successfully deleted')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dN: A2($elm$core$Set$remove, id, model.dN)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataCategory));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 9:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Admin$Categories$fetchCategories(newModel), _List_Nil);
            case 10:
                var category = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    bX: $elm$core$Maybe$Just(category)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    dN: A2($elm$core$Set$insert, id, model.dN),
                    bX: $elm$core$Maybe$Nothing
                }), A3($author$project$Api$Provider$Category$delete, model.Ej, id, $author$project$Pages$Admin$Categories$CategoryDeleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    bX: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Categories$NewCategory = {
        $: 0
    };
    var $author$project$Pages$Admin$Categories$PaginationMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$Categories$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Categories$Name = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$Categories$SaveCategory = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Categories$viewCategoryModal = F3(function(maybeId, category, form) {
        var name = $author$project$Utils$Form$fields(form);
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Charge Category',
            Tk: _Utils_eq(category, $author$project$Api$Data$Loading),
            TR: maybeId,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$Categories$CancelCategoryEdit,
            Vn: $author$project$Pages$Admin$Categories$SaveCategory(form)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Name')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(name),
                    $author$project$Ui$Form$Input$placeholder('Diagnostics'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Categories$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Categories$EditCategory = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Feature$JointProduct = 6;
    var $author$project$Pages$Admin$Categories$OpenHiConfirm = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Formatters$Time$Time__AgoInWords = 1;
    var $author$project$Api$Provider$Category$All$chargesThisMonthAmountInCents = function(_v0) {
        var record = _v0.b;
        return record.La;
    };
    var $author$project$Api$Provider$Category$All$chargesThisMonthCount = function(_v0) {
        var record = _v0.b;
        return record.Lb;
    };
    var $author$project$Api$Provider$Category$Shared$defaultForMemberships = function(_v0) {
        var record = _v0;
        return record.Fd;
    };
    var $author$project$Api$Provider$Category$All$defaultForMemberships = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Category$Shared$defaultForMemberships(shared);
    };
    var $author$project$Api$Provider$Category$All$lastUsedAt = function(_v0) {
        var record = _v0.b;
        return record.S$;
    };
    var $author$project$Ui$Link$RouteParams = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Link$routeParams = $author$project$Ui$Link$RouteParams;
    var $author$project$Api$Expandable$withDefault = F2(function(_default, expandable_) {
        if (!expandable_.$) {
            var a = expandable_.a;
            return a;
        } else return _default;
    });
    var $author$project$Pages$Admin$Categories$viewCategory = F4(function(practice, timeFormatter, deletingCategories, category) {
        var id = $author$project$Api$Provider$Category$All$id(category);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Category$All$name(category))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Api$Expandable$withDefault, 0, $author$project$Api$Provider$Category$All$chargesThisMonthCount(category)) > 0 ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Revenue, _List_fromArray([
                    $author$project$Ui$Link$routeParams(_List_fromArray([
                        A2($elm$url$Url$Builder$string, 'category', id)
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(A2($author$project$Api$Expandable$withDefault, 0, $author$project$Api$Provider$Category$All$chargesThisMonthAmountInCents(category))) + ' this month')
                ])) : $elm$html$Html$text('0')
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Never', A2($elm$core$Maybe$map, timeFormatter(1), $author$project$Api$Provider$Category$All$lastUsedAt(category))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                if ($author$project$Api$Provider$Category$All$defaultForMemberships(category)) return _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('Default for memberships')
                    ]))
                ]);
                else {
                    if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && $author$project$Api$Provider$Category$All$name(category) === 'Medications') return _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Default for medications')
                        ]))
                    ]);
                    else {
                        if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && $author$project$Api$Provider$Category$All$name(category) === 'Labs') return _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Default for labs')
                            ]))
                        ]);
                        else {
                            var loading = A2($elm$core$Set$member, id, deletingCategories);
                            return _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$gap2,
                                    $author$project$Ui$Element$justifyRight
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Edit charge category '
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$sm,
                                        $author$project$Ui$Button$disabled(loading),
                                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Categories$EditCategory(category)),
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Edit')
                                    ])),
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Delete charge category '
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$size(0),
                                        $author$project$Ui$Button$loading(loading),
                                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Categories$OpenHiConfirm(category)),
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Delete')
                                    ]))
                                ]))
                            ]);
                        }
                    }
                }
            }())
        ]));
    });
    var $author$project$Pages$Admin$Categories$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.K0;
            if (_v1.$ === 3) {
                var categories_ = _v1.a;
                return _Utils_Tuple2(false, categories_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var categories = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('None')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Name')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Charges this month')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Last used')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), A2($elm$core$List$map, A3($author$project$Pages$Admin$Categories$viewCategory, model.W1, model.HO, model.dN), categories), _List_Nil);
    };
    var $author$project$Pages$Admin$Categories$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.EL;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        var form = _v1.b;
                        var category = _v1.c;
                        return A3($author$project$Pages$Admin$Categories$viewCategoryModal, id, category, form);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.bX;
                    if (!_v2.$) {
                        var category = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Categories$HiConfirmClosed($author$project$Api$Provider$Category$All$id(category)), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('charge category'),
                            $author$project$Components$HiConfirm$detail($author$project$Api$Provider$Category$All$name(category) + ' and remove it from all historical charges')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Charge Categories')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'New charge category'
                        }, _List_fromArray([
                            $author$project$Ui$Button$default,
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Categories$NewCategory),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('New Charge Category')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Admin$Categories$viewPanelBody(model)
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$Categories$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.K0))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Charge Categories'
        };
    };
    var $author$project$Pages$Admin$Categories$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Categories$init,
        aeR: $author$project$Pages$Admin$Categories$load,
        ag3: $author$project$Pages$Admin$Categories$save,
        ahE: $author$project$Pages$Admin$Categories$subscriptions,
        aaO: $author$project$Pages$Admin$Categories$update,
        aid: $author$project$Pages$Admin$Categories$view
    });
    var $author$project$Pages$Admin$ChargeItems$Id_String$ChargeItemFormMsg = $elm$core$Basics$identity;
    var $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$CodeTypeDropdownMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$GotItem = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ChargeItem$Shared$Item = 0;
    var $author$project$Components$TranslatedRichText$DropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$TranslatedRichText$init = F2(function(initialTranslations, dropdownId) {
        return {
            h4: $author$project$Language$english,
            fD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: dropdownId,
                ahX: $author$project$Components$TranslatedRichText$DropdownMsg
            })),
            mI: false,
            aay: initialTranslations
        };
    });
    var $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption = 'deferred';
    var $author$project$Components$Admin$ChargeItems$Form$formFieldsInit = {
        I0: $elm$core$Maybe$Nothing,
        Ky: false,
        EL: $elm$core$Maybe$Nothing,
        Lk: '',
        Lm: $elm$core$Maybe$Nothing,
        p7: $elm$core$Maybe$Nothing,
        Nc: $elm$core$Maybe$Nothing,
        NQ: $elm$core$Maybe$Nothing,
        iy: false,
        Pe: '1',
        Pf: 'months',
        b9: false,
        mw: 0,
        Q4: $elm$core$Maybe$Nothing,
        rc: 0,
        SZ: $elm$core$Maybe$Nothing,
        TC: '',
        Ue: $elm$core$Maybe$Nothing,
        zr: '',
        VO: _List_Nil,
        Br: $elm$core$Maybe$Nothing,
        XT: $elm$core$Maybe$Nothing,
        Y3: $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption,
        eD: A2($author$project$Components$TranslatedRichText$init, $elm$core$Dict$empty, 'rich-description-language'),
        $S: false,
        aap: false,
        aaK: 'each'
    };
    var $author$project$Components$ResourceFilter$All = {
        $: 2
    };
    var $author$project$Components$ResourceFilter$Category$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Category$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Category$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Data$employerPath = $author$project$Api$Data$newPath(_List_fromArray([
        'employer'
    ]));
    var $author$project$Api$Employer$Category$categoriesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'categories'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Category$All$Category = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Category$Shared$Category = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Category$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Employer$Category$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Category$Shared$Record)));
    var $author$project$Api$Employer$Category$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Category$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Category$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Category$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Category$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$Category$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$Category$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$Category$categoriesPath)));
    });
    var $author$project$Api$Category$list = F4(function(apiClient, session, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Category$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Category$All$Employer)))) : A3($author$project$Api$Provider$Category$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Category$All$Provider))));
    });
    var $author$project$Components$ResourceFilter$Category$list = $author$project$Api$Category$list;
    var $author$project$Api$Employer$Category$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$Category$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Category$Shared$id(shared);
    };
    var $author$project$Api$Category$All$id = function(category) {
        if (!category.$) {
            var category_ = category.a;
            return $author$project$Api$Provider$Category$All$id(category_);
        } else {
            var category_ = category.a;
            return $author$project$Api$Employer$Category$All$id(category_);
        }
    };
    var $author$project$Api$Employer$Category$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$Category$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Category$Shared$name(shared);
    };
    var $author$project$Api$Category$All$name = function(category) {
        if (!category.$) {
            var category_ = category.a;
            return $author$project$Api$Provider$Category$All$name(category_);
        } else {
            var category_ = category.a;
            return $author$project$Api$Employer$Category$All$name(category_);
        }
    };
    var $author$project$Components$ResourceFilter$Category$resourceFromAll = function(category) {
        return {
            aef: $author$project$Api$Category$All$id(category),
            zr: $author$project$Api$Category$All$name(category)
        };
    };
    var $author$project$Components$ResourceFilter$Category$fetchResources = F5(function(session, toMsg, apiClient, pagination, query) {
        return A4($author$project$Components$ResourceFilter$Category$list, apiClient, session, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$Category$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$DropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$GotItems = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$SearchableSelect$andMantainTextOnClose = function(model) {
        return _Utils_update(model, {
            yN: true
        });
    };
    var $author$project$Components$ResourceFilter$buildChoiceToValue = F4(function(allValue, noneValue, toValue, choice) {
        switch(choice.$){
            case 2:
                return allValue;
            case 3:
                return noneValue;
            case 0:
                var item = choice.a;
                return $elm$core$Maybe$Just(toValue(item));
            case 1:
                var items = choice.a;
                return $elm$core$Maybe$Just(A2($elm$core$String$join, ',', A2($elm$core$List$map, toValue, items)));
            case 4:
                var extraItem = choice.a;
                return $elm$core$Maybe$Just(extraItem.aa9);
            default:
                var string = choice.a;
                return $elm$core$Maybe$Just(string);
        }
    });
    var $author$project$Components$ResourceFilter$choiceToLabel = F6(function(allLabel, noneLabel, freeTextPrefix, resourceName, toLabel, choice) {
        switch(choice.$){
            case 2:
                return _List_fromArray([
                    $elm$html$Html$text(allLabel)
                ]);
            case 3:
                return _List_fromArray([
                    $elm$html$Html$text(noneLabel)
                ]);
            case 0:
                var item = choice.a;
                return _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), toLabel(item)))
                ]);
            case 1:
                var items = choice.a;
                var count = $elm$core$List$length(items);
                return _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, resourceName, count) + ' Selected')
                    ]))
                ]);
            case 4:
                var extraItem = choice.a;
                return _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text(extraItem.aeI)
                    ]))
                ]);
            default:
                var string = choice.a;
                return _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text(freeTextPrefix),
                        $elm$html$Html$text(string)
                    ]))
                ]);
        }
    });
    var $author$project$Components$ResourceFilter$choiceToTitle = F6(function(allLabel, noneLabel, freeTextPrefix, resourceName, toTitle, choice) {
        switch(choice.$){
            case 2:
                return allLabel;
            case 3:
                return noneLabel;
            case 0:
                var item = choice.a;
                return toTitle(item);
            case 1:
                var items = choice.a;
                var count = $elm$core$List$length(items);
                return A2($author$project$Formatters$String$pluralize, resourceName, count) + ' Selected';
            case 4:
                var extraItem = choice.a;
                return extraItem.aeI;
            default:
                var string = choice.a;
                return _Utils_ap(freeTextPrefix, string);
        }
    });
    var $author$project$Components$ResourceFilter$defaults = {
        Ee: 'All',
        I5: true,
        abE: $elm$core$Maybe$Nothing,
        adw: $elm$core$Maybe$Nothing,
        adx: $elm$core$Maybe$Nothing,
        d4: _List_Nil,
        ad$: false,
        ad0: 'Custom: ',
        ad7: false,
        ad8: false,
        rf: 10,
        U5: 'None',
        afn: false,
        afo: $elm$core$Maybe$Just(''),
        agj: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        Cy: true
    };
    var $author$project$Components$ResourceFilter$SetPreSelected = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$setPreSelected = function(attempts) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Components$ResourceFilter$SetPreSelected(attempts + 1);
        }, $elm$core$Process$sleep(10));
    };
    var $author$project$Api$Pagination$withItemsPerPage = F2(function(itemsPerPage, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            fY: itemsPerPage
        });
    });
    var $author$project$Components$ResourceFilter$init = F3(function(apiClient, required, optionals) {
        var search = required.PC;
        var options = optionals($author$project$Components$ResourceFilter$defaults);
        var pagination = A2($author$project$Api$Pagination$withItemsPerPage, options.rf, $author$project$Api$Pagination$init);
        var choiceToLabelFunc = A5($author$project$Components$ResourceFilter$choiceToLabel, options.Ee, options.U5, options.ad0, required.gD, required.ahW);
        return _Utils_Tuple2({
            EO: choiceToLabelFunc,
            a0: $elm$core$Maybe$Nothing,
            dJ: $jinjor$elm_debounce$Debounce$init,
            fD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'resource-filter-dropdown-' + required.aef,
                ahX: $author$project$Components$ResourceFilter$DropdownMsg
            })),
            adw: options.adw,
            adx: options.adx,
            d4: options.d4,
            xQ: $elm$core$Maybe$Nothing,
            i3: false,
            z9: options,
            af_: pagination,
            agj: options.agj,
            agq: options.agq,
            gD: required.gD,
            sz: required.sz,
            gH: search,
            oa: false,
            sI: function(select_) {
                return options.ad$ ? $author$project$Ui$Form$SearchableSelect$andMantainTextOnClose(select_) : select_;
            }($author$project$Ui$Form$SearchableSelect$init({
                aef: required.aef,
                ahW: choiceToLabelFunc,
                ahZ: A5($author$project$Components$ResourceFilter$choiceToTitle, options.Ee, options.U5, options.ad0, required.gD, required.ahZ),
                g4: A3($author$project$Components$ResourceFilter$buildChoiceToValue, options.abE, options.afo, required.g4)
            })),
            ahW: required.ahW,
            ahZ: required.ahZ,
            g4: required.g4,
            oR: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A4(search, $author$project$Components$ResourceFilter$GotItems(false), apiClient, pagination, options.agq),
            function() {
                var _v0 = options.agj;
                if (!_v0.$) return $author$project$Components$ResourceFilter$setPreSelected(0);
                else return $elm$core$Platform$Cmd$none;
            }()
        ])));
    });
    var $author$project$Components$ResourceFilter$Category$retrieveResource = F4(function(session, toMsg, apiClient, id) {
        return A4($author$project$Components$ResourceFilter$Category$list, apiClient, session, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$Category$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$Category$selectId = 'category';
    var $author$project$Components$ResourceFilter$Category$toTitle = function($) {
        return $.zr;
    };
    var $author$project$Components$ResourceFilter$Category$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Category$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$Category$toValue = function($) {
        return $.aef;
    };
    var $author$project$Components$ResourceFilter$Category$init = F3(function(apiClient, session, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Category$fetchResources(session),
            aef: $author$project$Components$ResourceFilter$Category$selectId,
            gD: 'Category',
            sz: $author$project$Components$ResourceFilter$Category$retrieveResource(session),
            ahW: $author$project$Components$ResourceFilter$Category$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Category$toTitle,
            g4: $author$project$Components$ResourceFilter$Category$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Api$Provider$ChargeItem$chargeItemsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'charge_items'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ChargeItem$chargeItemPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$ChargeItem$chargeItemsPath);
    };
    var $author$project$Api$Provider$ChargeItem$One$ChargeItem = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ChargeItem$Shared$ChargeItem = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ChargeItem$Min$ChargeItem = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ChargeItem$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$ChargeItem$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Min$Record)));
    var $author$project$Api$Provider$ChargeItem$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ChargeItem$Shared$Record = function(description) {
        return function(lastUsedAt) {
            return function(quantityInStock) {
                return function(priceInCents) {
                    return function(lastSetQuantity) {
                        return function(lowInventory) {
                            return function(outOfStock) {
                                return function(taxable) {
                                    return function(buyable) {
                                        return function(trackInventory) {
                                            return function(alertQuantity) {
                                                return function(daysSupply) {
                                                    return function(code) {
                                                        return function(codeType) {
                                                            return function(manufacturer) {
                                                                return function(itemType) {
                                                                    return function(templatePackage) {
                                                                        return function(richDescriptions) {
                                                                            return function(imageUrl) {
                                                                                return {
                                                                                    I0: alertQuantity,
                                                                                    Ky: buyable,
                                                                                    Lk: code,
                                                                                    Lm: codeType,
                                                                                    Nc: daysSupply,
                                                                                    NQ: description,
                                                                                    Q4: imageUrl,
                                                                                    rc: itemType,
                                                                                    SZ: lastSetQuantity,
                                                                                    S$: lastUsedAt,
                                                                                    Tw: lowInventory,
                                                                                    TC: manufacturer,
                                                                                    VI: outOfStock,
                                                                                    Br: priceInCents,
                                                                                    XT: quantityInStock,
                                                                                    Cb: richDescriptions,
                                                                                    $S: taxable,
                                                                                    tm: templatePackage,
                                                                                    aap: trackInventory
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
    var $elm$json$Json$Decode$dict = function(decoder) {
        return A2($elm$json$Json$Decode$map, $elm$core$Dict$fromList, $elm$json$Json$Decode$keyValuePairs(decoder));
    };
    var $author$project$Components$TranslatedRichText$decoder = function(fieldName) {
        var filterNulls = function(dict) {
            return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, function(_v0) {
                var key = _v0.a;
                var maybeValue = _v0.b;
                return A2($elm$core$Maybe$map, function(value) {
                    return _Utils_Tuple2(key, value);
                }, maybeValue);
            }, $elm$core$Dict$toList(dict)));
        };
        return A2($elm$json$Json$Decode$map, filterNulls, A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$dict($elm$json$Json$Decode$nullable($elm$json$Json$Decode$string))));
    };
    var $author$project$Api$Provider$ChargeItem$Shared$decodeRichDescriptions = $author$project$Components$TranslatedRichText$decoder('rich_description');
    var $author$project$Api$Provider$ChargeItem$Shared$Package = 1;
    var $author$project$Api$Provider$ChargeItem$Shared$stringToItemType = function(str) {
        switch(str){
            case 'item':
                return 0;
            case 'package':
                return 1;
            default:
                return 0;
        }
    };
    var $author$project$Api$Provider$ChargeItem$Shared$TemplatePackage = F4(function(packageItems, expirationNumber, expirationUnit, revenueRecognition) {
        return {
            Pe: expirationNumber,
            Pf: expirationUnit,
            VO: packageItems,
            Y3: revenueRecognition
        };
    });
    var $author$project$Api$Provider$PackageItem$Shared$PackageItem = F7(function(id, chargeItemId, chargeItemName, chargeItemTaxable, chargeItemPriceInCents, quantity, priceInCents) {
        return {
            ack: chargeItemId,
            acl: chargeItemName,
            acm: chargeItemPriceInCents,
            acn: chargeItemTaxable,
            aef: id,
            Br: priceInCents,
            Bu: quantity
        };
    });
    var $author$project$Currency$decode = A2($elm$json$Json$Decode$map, $author$project$Currency$fromInt, $elm$json$Json$Decode$int);
    var $author$project$Api$Provider$PackageItem$Shared$decoder = function() {
        var extractChargeItemTaxable = A2($elm$json$Json$Decode$field, 'charge_item', $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'taxable', $elm$json$Json$Decode$bool)));
        var extractChargeItemPriceInCents = A2($elm$json$Json$Decode$field, 'charge_item', $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'price_in_cents', $elm$json$Json$Decode$float)));
        var extractChargeItemName = A2($elm$json$Json$Decode$field, 'charge_item', $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)));
        var extractChargeItemId = A2($elm$json$Json$Decode$field, 'charge_item', A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
        return A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $author$project$Currency$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$int, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, extractChargeItemPriceInCents, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, extractChargeItemTaxable, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, extractChargeItemName, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, extractChargeItemId, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'id', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PackageItem$Shared$PackageItem))))))));
    }();
    var $author$project$Api$Provider$ChargeItem$Shared$templatePackageDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'revenue_recognition', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'expiration_unit', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'expiration_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'package_items', $elm$json$Json$Decode$list($author$project$Api$Provider$PackageItem$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$TemplatePackage)))));
    var $author$project$Api$Provider$ChargeItem$Shared$recordDecoder = function() {
        var decodeTemplatePackage = $elm$json$Json$Decode$oneOf(_List_fromArray([
            A2($elm$json$Json$Decode$field, 'package', A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Api$Provider$ChargeItem$Shared$templatePackageDecoder)),
            $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
        ]));
        return A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'image_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Shared$decodeRichDescriptions, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, decodeTemplatePackage, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'item_type', A2($elm$json$Json$Decode$map, $author$project$Api$Provider$ChargeItem$Shared$stringToItemType, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'manufacturer', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'code_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'code', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'days_supply', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'alert_quantity', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'track_inventory', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'buyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'taxable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'out_of_stock', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'low_inventory', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_set_quantity', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity_in_stock', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_used_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$Record))))))))))))))))))));
    }();
    var $author$project$Api$Provider$ChargeItem$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Shared$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Shared$ChargeItem)));
    var $author$project$Api$Provider$ChargeItem$One$Record = F3(function(category, uom, meta) {
        return {
            EL: category,
            Ue: meta,
            aaK: uom
        };
    });
    var $author$project$Api$Provider$ChargeItem$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ChargeItem$Meta$MetaRecord = F2(function(uom, buyable) {
        return {
            Ky: buyable,
            aaK: uom
        };
    });
    var $author$project$Api$Provider$ChargeItem$Meta$EditableRecord = function(editable) {
        return {
            Ot: editable
        };
    };
    var $author$project$Api$Provider$ChargeItem$Meta$editableRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Meta$EditableRecord));
    var $author$project$Api$Provider$ChargeItem$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'buyable', $author$project$Api$Provider$ChargeItem$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uom', $author$project$Api$Provider$ChargeItem$Meta$editableRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$Meta$MetaRecord)));
    var $author$project$Api$Provider$ChargeItem$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Uom$Shared$Uom = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Uom$Shared$Record = F7(function(code, name, unitClass, periodUnit, periodQuantity, type_, periodInMonths) {
        return {
            Lk: code,
            zr: name,
            WA: periodInMonths,
            gq: periodQuantity,
            gr: periodUnit,
            ah5: type_,
            HX: unitClass
        };
    });
    var $author$project$Api$Provider$Uom$PeriodUnit$Days = 0;
    var $author$project$Api$Provider$Uom$PeriodUnit$HalfYears = 3;
    var $author$project$Api$Provider$Uom$PeriodUnit$Months = 1;
    var $author$project$Api$Provider$Uom$PeriodUnit$Quarters = 2;
    var $author$project$Api$Provider$Uom$PeriodUnit$Years = 4;
    var $author$project$Api$Provider$Uom$PeriodUnit$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'days':
                return $elm$json$Json$Decode$succeed(0);
            case 'months':
                return $elm$json$Json$Decode$succeed(1);
            case 'quarters':
                return $elm$json$Json$Decode$succeed(2);
            case 'half_years':
                return $elm$json$Json$Decode$succeed(3);
            case 'years':
                return $elm$json$Json$Decode$succeed(4);
            default:
                var somethingElse = string;
                return $elm$json$Json$Decode$fail('Unsupported Uom -> period_unit: ' + somethingElse);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Uom$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_quantity', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_unit', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Uom$PeriodUnit$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'unit_class', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'code', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Uom$Shared$Record))))))));
    var $author$project$Api$Provider$Uom$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Uom$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ChargeItem$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$ChargeItem$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uom', $author$project$Api$Provider$Uom$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$One$Record))));
    var $author$project$Api$Provider$ChargeItem$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$One$ChargeItem)));
    var $author$project$Api$Provider$ChargeItem$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$ChargeItem$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemPath(id_)));
    });
    var $author$project$Components$Admin$ChargeItems$Form$init = F4(function(apiClient, session, id, practice) {
        var excludedCategoryTitles = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) ? $elm$core$Maybe$Just(_List_fromArray([
            'Labs'
        ])) : $elm$core$Maybe$Nothing;
        var _v0 = function() {
            if (!id.$) {
                var id_ = id.a;
                return _Utils_Tuple2($elm$core$Maybe$Nothing, A3($author$project$Api$Provider$ChargeItem$retrieve, apiClient, id_, $author$project$Components$Admin$ChargeItems$Form$GotItem));
            } else return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Components$Admin$ChargeItems$Form$formFieldsInit), $elm$core$Platform$Cmd$none);
        }();
        var formFields = _v0.a;
        var cmd = _v0.b;
        var _v2 = A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Uncategorized',
                adx: excludedCategoryTitles,
                afn: false
            });
        });
        var categoryResourceFilter = _v2.a;
        var categoryResourceFilterCmd = _v2.b;
        return _Utils_Tuple2({
            cK: categoryResourceFilter,
            fi: $elm$core$Dict$empty,
            lz: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'code-type',
                ahX: $author$project$Components$Admin$ChargeItems$Form$CodeTypeDropdownMsg
            })),
            PU: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
            aef: id,
            yq: false,
            bz: $elm$core$Dict$empty,
            cg: $elm$core$Dict$empty,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$Admin$ChargeItems$Id_String$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var params = _v1.VU;
        var _v2 = A4($author$project$Components$Admin$ChargeItems$Form$init, apiClient, session, $elm$core$Maybe$Just(params.aef), practice);
        var model = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: model
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$ChargeItems$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$ChargeItems$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$subscriptions = function(model) {
        return $author$project$Ui$Dropdown$subscriptions(model.fD);
    };
    var $author$project$Components$ResourceFilter$Category$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$TranslatedRichText$ContentChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$TranslatedRichText$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            model.mI ? $author$project$Ports$CKEditor$onChange(F2(function(_v0, value) {
                return $author$project$Components$TranslatedRichText$ContentChanged(value);
            })) : $elm$core$Platform$Sub$none,
            $author$project$Ui$Dropdown$subscriptions(model.fD)
        ]));
    };
    var $author$project$Components$Admin$ChargeItems$Form$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, $author$project$Components$ResourceFilter$Category$subscriptions(model.cK)),
            $author$project$Ui$Dropdown$subscriptions(model.lz),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(form) {
                return A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg, $author$project$Components$TranslatedRichText$subscriptions($author$project$Utils$Form$fields(form).eD));
            }, model.PU))
        ]));
    };
    var $author$project$Pages$Admin$ChargeItems$Id_String$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$ChargeItems$Form$subscriptions(model.PU));
    };
    var $author$project$Components$Admin$ChargeItems$Form$Category = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$CodeType = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Extra = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$Image = F2(function(a, b) {
        return {
            $: 26,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$ChargeItems$Form$PackageItemSelected = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$ChargeItems$Form$PackageItemsValidation = 5;
    var $author$project$Components$Admin$ChargeItems$Form$SelectPackageItem = F5(function(a, b, c, d, e) {
        return {
            $: 19,
            a: a,
            b: b,
            c: c,
            d: d,
            e: e
        };
    });
    var $author$project$Ports$Navigation$backPort = _Platform_outgoingPort('backPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Navigation$back = $author$project$Ports$Navigation$backPort(0);
    var $author$project$Api$Provider$ChargeItem$One$category = function(_v0) {
        var record = _v0.b;
        return record.EL;
    };
    var $author$project$Components$Admin$ChargeItems$Form$CodeTypeValidation = 4;
    var $author$project$Components$Admin$ChargeItems$Form$ExpirationValidation = 6;
    var $author$project$Components$Admin$ChargeItems$Form$ImageValidation = 7;
    var $author$project$Components$Admin$ChargeItems$Form$LastSetQuantityValidation = 3;
    var $author$project$Components$Admin$ChargeItems$Form$NameValidation = 0;
    var $author$project$Components$Admin$ChargeItems$Form$PriceInCentsValidation = 2;
    var $author$project$Components$Admin$ChargeItems$Form$UomValidation = 1;
    var $author$project$Utils$Form$clearGroupErrors = F2(function(group, _v0) {
        var originalFields = _v0.a;
        var validated_ = _v0.b;
        var fields_ = _v0.c;
        var errors_ = _v0.d;
        return A4($author$project$Utils$Form$Form, originalFields, validated_, fields_, A2($elm$core$List$filter, function(_v1) {
            var validationGroup = _v1.a;
            return !_Utils_eq(validationGroup, group);
        }, errors_));
    });
    var $author$project$Utils$FileSize$fiveMegabytes = 5242880;
    var $author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Admin$ChargeItems$Form$validateCodeType = function(fields) {
        return fields.Lk !== '' && _Utils_eq(fields.Lm, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(4, 'Please pick a code type.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Admin$ChargeItems$Form$validateExpiration = function(fields) {
        if (fields.b9) {
            var _v0 = $elm$core$String$toInt(fields.Pe);
            if (!_v0.$) {
                var n = _v0.a;
                return n > 0 ? _List_Nil : _List_fromArray([
                    _Utils_Tuple2(6, 'Please enter a positive number for expiration.')
                ]);
            } else return _List_fromArray([
                _Utils_Tuple2(6, 'Please enter a valid positive number for expiration.')
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity = function(fields) {
        var invalid = _Utils_Tuple2(3, 'Please enter a quantity of 0 or more to track inventory for this item');
        var _v0 = _Utils_Tuple2(fields.aap, fields.SZ);
        if (_v0.a) {
            if (!_v0.b.$) {
                var lastSetQuantity = _v0.b.a;
                return lastSetQuantity < 0 ? _List_fromArray([
                    invalid
                ]) : _List_Nil;
            } else {
                var _v1 = _v0.b;
                return _List_fromArray([
                    invalid
                ]);
            }
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$ChargeItems$Form$validatePackageItems = function(fields) {
        if (fields.rc === 1) {
            if ($elm$core$List$isEmpty(fields.VO)) return _List_fromArray([
                _Utils_Tuple2(5, 'Please add at least one item to the package.')
            ]);
            else {
                var missingChargeItem = A2($elm$core$List$any, function(item) {
                    return _Utils_eq(item.ack, $elm$core$Maybe$Nothing);
                }, fields.VO);
                return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                    missingChargeItem ? $elm$core$Maybe$Just(_Utils_Tuple2(5, 'Please select a charge item for each row.')) : $elm$core$Maybe$Nothing
                ]));
            }
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$ChargeItems$Form$validatePriceInCents = function(fields) {
        var _v0 = fields.rc;
        if (_v0 === 1) {
            var _v1 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Br);
            if (!_v1.$) {
                var cents = _v1.a;
                return cents > 0 ? _List_Nil : _List_fromArray([
                    _Utils_Tuple2(2, 'Please enter a price greater than $0.')
                ]);
            } else return _List_fromArray([
                _Utils_Tuple2(2, 'Please enter a price.')
            ]);
        } else return _Utils_eq(fields.Br, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(2, 'Please enter a price.')
        ]) : _List_Nil;
    };
    var $author$project$Utils$Form$validated = function(_v0) {
        var validated_ = _v0.b;
        return validated_;
    };
    var $author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid = function(form) {
        if ($author$project$Utils$Form$validated(form)) {
            var fields = $author$project$Utils$Form$fields(form);
            var isCodeTypeValid = $elm$core$List$isEmpty($author$project$Components$Admin$ChargeItems$Form$validateCodeType(fields));
            var isExpirationValid = $elm$core$List$isEmpty($author$project$Components$Admin$ChargeItems$Form$validateExpiration(fields));
            var isImageValid = _Utils_cmp(fields.mw, $author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize) < 1;
            var isLastSetQuantityValid = $elm$core$List$isEmpty($author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity(fields));
            var isNameValid = !$elm$core$String$isEmpty(fields.zr);
            var isPackageItemsValid = $elm$core$List$isEmpty($author$project$Components$Admin$ChargeItems$Form$validatePackageItems(fields));
            var isPriceValid = $elm$core$List$isEmpty($author$project$Components$Admin$ChargeItems$Form$validatePriceInCents(fields));
            var isUomValid = !$elm$core$String$isEmpty(fields.aaK);
            return (isImageValid ? $author$project$Utils$Form$clearGroupErrors(7) : $elm$core$Basics$identity)((isExpirationValid ? $author$project$Utils$Form$clearGroupErrors(6) : $elm$core$Basics$identity)((isPackageItemsValid ? $author$project$Utils$Form$clearGroupErrors(5) : $elm$core$Basics$identity)((isCodeTypeValid ? $author$project$Utils$Form$clearGroupErrors(4) : $elm$core$Basics$identity)((isLastSetQuantityValid ? $author$project$Utils$Form$clearGroupErrors(3) : $elm$core$Basics$identity)((isPriceValid ? $author$project$Utils$Form$clearGroupErrors(2) : $elm$core$Basics$identity)((isUomValid ? $author$project$Utils$Form$clearGroupErrors(1) : $elm$core$Basics$identity)((isNameValid ? $author$project$Utils$Form$clearGroupErrors(0) : $elm$core$Basics$identity)(form))))))));
        } else return form;
    };
    var $author$project$Components$ResourceFilter$extraItems = F2(function(list, model) {
        return _Utils_update(model, {
            d4: list
        });
    });
    var $author$project$Components$ResourceFilter$Category$extraItems = F2(function(list_, model) {
        var extraItems_ = A2($elm$core$List$map, function(item) {
            return {
                aeI: item.zr,
                aa9: item.aef
            };
        }, list_);
        return _Utils_update(model, {
            bf: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bf)
        });
    });
    var $author$project$Components$ResourceFilter$ChargeItem$extraItems = F2(function(list_, model) {
        var extraItems_ = A2($elm$core$List$map, function(chargeItem) {
            return {
                aeI: chargeItem.zr,
                aa9: chargeItem.aef
            };
        }, list_);
        return _Utils_update(model, {
            bf: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bf)
        });
    });
    var $author$project$Api$Provider$ChargeItem$Shared$alertQuantity = function(_v0) {
        var record = _v0.b;
        return record.I0;
    };
    var $author$project$Api$Provider$ChargeItem$One$alertQuantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$buyable = function(_v0) {
        var record = _v0.b;
        return record.Ky;
    };
    var $author$project$Api$Provider$ChargeItem$One$buyable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$buyable(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$code = function(_v0) {
        var record = _v0.b;
        return record.Lk;
    };
    var $author$project$Api$Provider$ChargeItem$One$code = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
    };
    var $author$project$Api$Provider$Uom$Shared$code = function(_v0) {
        var record = _v0;
        return record.Lk;
    };
    var $author$project$Api$Provider$ChargeItem$Shared$codeType = function(_v0) {
        var record = _v0.b;
        return record.Lm;
    };
    var $author$project$Api$Provider$ChargeItem$One$codeType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$daysSupply = function(_v0) {
        var record = _v0.b;
        return record.Nc;
    };
    var $author$project$Api$Provider$ChargeItem$One$daysSupply = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$daysSupply(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$description = function(_v0) {
        var record = _v0.b;
        return record.NQ;
    };
    var $author$project$Api$Provider$ChargeItem$One$description = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$expirationNumber = function(_v0) {
        var record = _v0.b;
        return A2($elm$core$Maybe$andThen, function($) {
            return $.Pe;
        }, record.tm);
    };
    var $author$project$Api$Provider$ChargeItem$One$expirationNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$expirationNumber(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$expirationUnit = function(_v0) {
        var record = _v0.b;
        return A2($elm$core$Maybe$andThen, function($) {
            return $.Pf;
        }, record.tm);
    };
    var $author$project$Api$Provider$ChargeItem$One$expirationUnit = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$expirationUnit(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$imageUrl = function(_v0) {
        var record = _v0.b;
        return record.Q4;
    };
    var $author$project$Api$Provider$ChargeItem$One$imageUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$imageUrl(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$itemType = function(_v0) {
        var record = _v0.b;
        return record.rc;
    };
    var $author$project$Api$Provider$ChargeItem$One$itemType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity = function(_v0) {
        var record = _v0.b;
        return record.SZ;
    };
    var $author$project$Api$Provider$ChargeItem$One$lastSetQuantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$manufacturer = function(_v0) {
        var record = _v0.b;
        return record.TC;
    };
    var $author$project$Api$Provider$ChargeItem$One$manufacturer = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
    };
    var $author$project$Api$Provider$ChargeItem$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Provider$ChargeItem$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$ChargeItem$Shared$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Min$name(min);
    };
    var $author$project$Api$Provider$ChargeItem$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$packageItems = function(_v0) {
        var record = _v0.b;
        return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function($) {
            return $.VO;
        }, record.tm));
    };
    var $author$project$Api$Provider$ChargeItem$One$packageItems = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$packageItems(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$priceInCents = function(_v0) {
        var record = _v0.b;
        return record.Br;
    };
    var $author$project$Api$Provider$ChargeItem$One$priceInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$quantityInStock = function(_v0) {
        var record = _v0.b;
        return record.XT;
    };
    var $author$project$Api$Provider$ChargeItem$One$quantityInStock = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$revenueRecognition = function(_v0) {
        var record = _v0.b;
        return A2($elm$core$Maybe$andThen, function($) {
            return $.Y3;
        }, record.tm);
    };
    var $author$project$Api$Provider$ChargeItem$One$revenueRecognition = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$revenueRecognition(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$richDescriptions = function(_v0) {
        var record = _v0.b;
        return record.Cb;
    };
    var $author$project$Api$Provider$ChargeItem$One$richDescriptions = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$richDescriptions(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$taxable = function(_v0) {
        var record = _v0.b;
        return record.$S;
    };
    var $author$project$Api$Provider$ChargeItem$One$taxable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$trackInventory = function(_v0) {
        var record = _v0.b;
        return record.aap;
    };
    var $author$project$Api$Provider$ChargeItem$One$trackInventory = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
    };
    var $author$project$Api$Provider$ChargeItem$One$uom = function(_v0) {
        var record = _v0.b;
        return record.aaK;
    };
    var $author$project$Components$Admin$ChargeItems$Form$formFieldsFromItem = function(chargeItem) {
        var packageItems = $author$project$Api$Provider$ChargeItem$One$itemType(chargeItem) === 1 ? A2($elm$core$List$indexedMap, F2(function(index, packageItem) {
            return {
                ack: $elm$core$Maybe$Just(packageItem.ack),
                acl: packageItem.acl,
                acn: packageItem.acn,
                aef: packageItem.aef,
                Br: packageItem.Br,
                Bu: packageItem.Bu,
                K: $elm$core$String$fromInt(index)
            };
        }), $author$project$Api$Provider$ChargeItem$One$packageItems(chargeItem)) : _List_Nil;
        return {
            I0: $author$project$Api$Provider$ChargeItem$One$alertQuantity(chargeItem),
            Ky: $author$project$Api$Provider$ChargeItem$One$buyable(chargeItem),
            EL: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, $author$project$Api$Provider$ChargeItem$One$category(chargeItem)),
            Lk: $author$project$Api$Provider$ChargeItem$One$code(chargeItem),
            Lm: $author$project$Api$Provider$ChargeItem$One$codeType(chargeItem),
            p7: $author$project$Api$Provider$ChargeItem$One$imageUrl(chargeItem),
            Nc: $author$project$Api$Provider$ChargeItem$One$daysSupply(chargeItem),
            NQ: $author$project$Api$Provider$ChargeItem$One$description(chargeItem),
            iy: false,
            Pe: A2($elm$core$Maybe$withDefault, '1', A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Provider$ChargeItem$One$expirationNumber(chargeItem))),
            Pf: A2($elm$core$Maybe$withDefault, 'months', $author$project$Api$Provider$ChargeItem$One$expirationUnit(chargeItem)),
            b9: !_Utils_eq($author$project$Api$Provider$ChargeItem$One$expirationNumber(chargeItem), $elm$core$Maybe$Nothing) || !_Utils_eq($author$project$Api$Provider$ChargeItem$One$expirationUnit(chargeItem), $elm$core$Maybe$Nothing),
            mw: 0,
            Q4: $elm$core$Maybe$Nothing,
            rc: $author$project$Api$Provider$ChargeItem$One$itemType(chargeItem),
            SZ: $author$project$Api$Provider$ChargeItem$One$lastSetQuantity(chargeItem),
            TC: $author$project$Api$Provider$ChargeItem$One$manufacturer(chargeItem),
            Ue: $elm$core$Maybe$Just($author$project$Api$Provider$ChargeItem$One$meta(chargeItem)),
            zr: $author$project$Api$Provider$ChargeItem$One$name(chargeItem),
            VO: packageItems,
            Br: $elm$core$Maybe$Just($author$project$Currency$fromFloat($author$project$Api$Provider$ChargeItem$One$priceInCents(chargeItem))),
            XT: $author$project$Api$Provider$ChargeItem$One$quantityInStock(chargeItem),
            Y3: A2($elm$core$Maybe$withDefault, $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption, $author$project$Api$Provider$ChargeItem$One$revenueRecognition(chargeItem)),
            eD: A2($author$project$Components$TranslatedRichText$init, $author$project$Api$Provider$ChargeItem$One$richDescriptions(chargeItem), 'rich-description-language'),
            $S: $author$project$Api$Provider$ChargeItem$One$taxable(chargeItem),
            aap: $author$project$Api$Provider$ChargeItem$One$trackInventory(chargeItem),
            aaK: $author$project$Api$Provider$Uom$Shared$code($author$project$Api$Provider$ChargeItem$One$uom(chargeItem))
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$adjustPackageItemsPrices = F2(function(newPackagePrice, fields) {
        if (newPackagePrice.$ === 1) return fields;
        else {
            var newPrice = newPackagePrice.a;
            var newTotalCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(newPrice));
            var currentTotal = $elm$core$List$sum(A2($elm$core$List$map, function(item) {
                var qty = item.Bu <= 0 ? 1 : item.Bu;
                var price = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(item.Br));
                return price * qty;
            }, fields.VO));
            var adjustedRules = function() {
                if (!currentTotal) {
                    var itemCount = A2($elm$core$Basics$max, 1, $elm$core$List$length(fields.VO));
                    var pricePerItem = newTotalCents / itemCount | 0;
                    return A2($elm$core$List$map, function(item) {
                        return _Utils_update(item, {
                            Br: $author$project$Currency$fromInt(pricePerItem / (item.Bu <= 0 ? 1 : item.Bu) | 0)
                        });
                    }, fields.VO);
                } else {
                    var ratio = newTotalCents / currentTotal;
                    return A2($elm$core$List$map, function(item) {
                        var currentPrice = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(item.Br));
                        var newItemPrice = $elm$core$Basics$round(currentPrice * ratio);
                        return _Utils_update(item, {
                            Br: $author$project$Currency$fromInt(newItemPrice)
                        });
                    }, fields.VO);
                }
            }();
            return _Utils_update(fields, {
                VO: adjustedRules,
                Br: newPackagePrice
            });
        }
    });
    var $author$project$Api$Provider$Uom$Shared$day = {
        Lk: 'day',
        zr: 'Day',
        WA: $elm$core$Maybe$Nothing,
        gq: $elm$core$Maybe$Just(1),
        gr: $elm$core$Maybe$Just(0),
        ah5: 'Time',
        HX: 'time'
    };
    var $author$project$Api$Provider$Uom$Shared$each = {
        Lk: 'each',
        zr: 'Each',
        WA: $elm$core$Maybe$Nothing,
        gq: $elm$core$Maybe$Nothing,
        gr: $elm$core$Maybe$Nothing,
        ah5: 'Quantity',
        HX: 'quantity'
    };
    var $elm$core$List$all = F2(function(isOkay, list) {
        return !A2($elm$core$List$any, A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay), list);
    });
    var $author$project$Api$Provider$Uom$Shared$unitClass = function(_v0) {
        var record = _v0;
        return record.HX;
    };
    var $author$project$Api$Provider$Uom$filterBylistOptionals = F2(function(options, uom) {
        return A2($elm$core$List$all, $elm$core$Basics$identity, _List_fromArray([
            function() {
                var _v0 = options.HX;
                if (!_v0.$) {
                    var unitClass_ = _v0.a;
                    return _Utils_eq($author$project$Api$Provider$Uom$Shared$unitClass(uom), unitClass_);
                } else return true;
            }()
        ]));
    });
    var $author$project$Api$Provider$Uom$Shared$halfYear = {
        Lk: 'half_year',
        zr: 'Half Year',
        WA: $elm$core$Maybe$Just(6),
        gq: $elm$core$Maybe$Just(6),
        gr: $elm$core$Maybe$Just(1),
        ah5: 'Time',
        HX: 'time'
    };
    var $author$project$Api$Provider$Uom$listOptionalsDefaults = {
        HX: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Uom$Shared$month = {
        Lk: 'month',
        zr: 'Month',
        WA: $elm$core$Maybe$Just(1),
        gq: $elm$core$Maybe$Just(1),
        gr: $elm$core$Maybe$Just(1),
        ah5: 'Time',
        HX: 'time'
    };
    var $author$project$Api$Provider$Uom$Shared$quarter = {
        Lk: 'quarter',
        zr: 'Quarter',
        WA: $elm$core$Maybe$Just(3),
        gq: $elm$core$Maybe$Just(3),
        gr: $elm$core$Maybe$Just(1),
        ah5: 'Time',
        HX: 'time'
    };
    var $author$project$Api$Provider$Uom$Shared$year = {
        Lk: 'year',
        zr: 'Year',
        WA: $elm$core$Maybe$Just(12),
        gq: $elm$core$Maybe$Just(1),
        gr: $elm$core$Maybe$Just(4),
        ah5: 'Time',
        HX: 'time'
    };
    var $author$project$Api$Provider$Uom$list = function(optionals) {
        var options = optionals($author$project$Api$Provider$Uom$listOptionalsDefaults);
        return A2($elm$core$List$filter, $author$project$Api$Provider$Uom$filterBylistOptionals(options), _List_fromArray([
            $author$project$Api$Provider$Uom$Shared$each,
            $author$project$Api$Provider$Uom$Shared$day,
            $author$project$Api$Provider$Uom$Shared$month,
            $author$project$Api$Provider$Uom$Shared$quarter,
            $author$project$Api$Provider$Uom$Shared$halfYear,
            $author$project$Api$Provider$Uom$Shared$year
        ]));
    };
    var $author$project$Utils$Uom$fromCode = function(code) {
        return A2($elm_community$list_extra$List$Extra$find, function(uom_) {
            return _Utils_eq($author$project$Api$Provider$Uom$Shared$code(uom_), code);
        }, $author$project$Api$Provider$Uom$list($elm$core$Basics$identity));
    };
    var $author$project$Api$Provider$Uom$Shared$isTimeBased = function(_v0) {
        var record = _v0;
        return record.HX === 'time';
    };
    var $author$project$Utils$Uom$isTimeBased = function(code) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$isTimeBased, $author$project$Utils$Uom$fromCode(code)));
    };
    var $elm$core$List$maximum = function(list) {
        if (list.b) {
            var x = list.a;
            var xs = list.b;
            return $elm$core$Maybe$Just(A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice = function(fields) {
        var totalPrice = $author$project$Currency$fromInt($elm$core$List$sum(A2($elm$core$List$map, function(item) {
            var qty = item.Bu <= 0 ? 1 : item.Bu;
            var price = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(item.Br));
            return price * qty;
        }, fields.VO)));
        return _Utils_update(fields, {
            Br: $elm$core$Maybe$Just(totalPrice)
        });
    };
    var $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    aap: fields.aap && $author$project$Utils$Uom$isTimeBased(fields.aaK),
                    aaK: string
                });
            case 2:
                var maybeCurrency = field.a;
                return _Utils_update(fields, {
                    Br: maybeCurrency
                });
            case 3:
                if (fields.rc === 1) {
                    var priceToUse = function() {
                        var _v1 = fields.Br;
                        if (_v1.$ === 1) return $elm$core$Maybe$Just($author$project$Currency$zero);
                        else return fields.Br;
                    }();
                    return A2($author$project$Components$Admin$ChargeItems$Form$adjustPackageItemsPrices, priceToUse, fields);
                } else return fields;
            case 4:
                var bool = field.a;
                return _Utils_update(fields, {
                    $S: bool
                });
            case 5:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ky: bool
                });
            case 6:
                var maybeString = field.a;
                return _Utils_update(fields, {
                    EL: maybeString
                });
            case 7:
                var bool = field.a;
                return _Utils_update(fields, {
                    iy: bool && !$author$project$Utils$Maybe$toBool(fields.XT),
                    aap: bool
                });
            case 8:
                var string = field.a;
                return _Utils_update(fields, {
                    SZ: $elm$core$String$toInt(string)
                });
            case 9:
                var string = field.a;
                return _Utils_update(fields, {
                    I0: $elm$core$String$toInt(string)
                });
            case 10:
                var string = field.a;
                var description = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
                return _Utils_update(fields, {
                    NQ: description
                });
            case 11:
                return _Utils_update(fields, {
                    iy: true
                });
            case 12:
                var string = field.a;
                return _Utils_update(fields, {
                    Nc: $elm$core$String$toInt(string)
                });
            case 13:
                var string = field.a;
                return _Utils_update(fields, {
                    Lk: string
                });
            case 14:
                var string = field.a;
                return _Utils_update(fields, {
                    Lm: string
                });
            case 15:
                var string = field.a;
                return _Utils_update(fields, {
                    TC: string
                });
            case 16:
                var itemType = field.a;
                var updatedFields = _Utils_update(fields, {
                    rc: itemType
                });
                return itemType === 1 ? $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(updatedFields) : updatedFields;
            case 17:
                var nextTempId = $elm$core$String$fromInt(1 + A2($elm$core$Maybe$withDefault, -1, $elm$core$List$maximum(A2($elm$core$List$map, function(item) {
                    return A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(item.K));
                }, fields.VO))));
                var newItem = {
                    ack: $elm$core$Maybe$Nothing,
                    acl: $elm$core$Maybe$Nothing,
                    acn: $elm$core$Maybe$Nothing,
                    aef: $elm$core$Maybe$Nothing,
                    Br: $author$project$Currency$zero,
                    Bu: 1,
                    K: nextTempId
                };
                return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(_Utils_update(fields, {
                    VO: _Utils_ap(fields.VO, _List_fromArray([
                        newItem
                    ]))
                }));
            case 18:
                var tempId = field.a;
                return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(_Utils_update(fields, {
                    VO: A2($elm$core$List$filter, function(item) {
                        return !_Utils_eq(item.K, tempId);
                    }, fields.VO)
                }));
            case 19:
                var tempId = field.a;
                var itemId = field.b;
                var itemName = field.c;
                var defaultPrice = field.d;
                var defaultTaxable = field.e;
                return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(_Utils_update(fields, {
                    VO: A2($elm$core$List$map, function(item) {
                        return _Utils_eq(item.K, tempId) ? _Utils_update(item, {
                            ack: $elm$core$Maybe$Just(itemId),
                            acl: $elm$core$Maybe$Just(itemName),
                            acn: $elm$core$Maybe$Just(defaultTaxable),
                            Br: defaultPrice,
                            Bu: 1
                        }) : item;
                    }, fields.VO)
                }));
            case 20:
                var tempId = field.a;
                var quantity = field.b;
                return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(_Utils_update(fields, {
                    VO: A2($elm$core$List$map, function(item) {
                        return _Utils_eq(item.K, tempId) ? _Utils_update(item, {
                            Bu: quantity
                        }) : item;
                    }, fields.VO)
                }));
            case 21:
                var tempId = field.a;
                var maybePrice = field.b;
                return $author$project$Components$Admin$ChargeItems$Form$updatePackagePrice(_Utils_update(fields, {
                    VO: A2($elm$core$List$map, function(item) {
                        return _Utils_eq(item.K, tempId) ? _Utils_update(item, {
                            Br: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, maybePrice)
                        }) : item;
                    }, fields.VO)
                }));
            case 22:
                var bool = field.a;
                return _Utils_update(fields, {
                    b9: bool
                });
            case 23:
                var str = field.a;
                return _Utils_update(fields, {
                    Pe: str
                });
            case 24:
                var maybeUnit = field.a;
                if (!maybeUnit.$) {
                    var unit = maybeUnit.a;
                    return _Utils_update(fields, {
                        Pf: unit
                    });
                } else return fields;
            case 25:
                var value = field.a;
                return _Utils_update(fields, {
                    Y3: value
                });
            default:
                var _int = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    p7: $elm$core$Maybe$Just(string),
                    mw: _int,
                    Q4: $elm$core$Maybe$Just(string)
                });
        }
    });
    var $author$project$Utils$Validate$ifIntGreaterThan = F3(function(subjectToInt, max, error) {
        return A2($rtfeldman$elm_validate$Validate$ifTrue, function(subject) {
            return _Utils_cmp(subjectToInt(subject), max) > 0;
        }, error);
    });
    var $author$project$Components$Admin$ChargeItems$Form$imageValidator = A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
        return $.mw;
    }, $author$project$Components$Admin$ChargeItems$Form$maxImageBytesSize, _Utils_Tuple2(7, 'That image is too large! Our maximum image size is 5 MB.'));
    var $author$project$Components$Admin$ChargeItems$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.aaK;
        }, _Utils_Tuple2(1, 'Please pick a uom.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validatePriceInCents),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateLastSetQuantity),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateCodeType),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validatePackageItems),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$ChargeItems$Form$validateExpiration),
        $author$project$Components$Admin$ChargeItems$Form$imageValidator
    ]));
    var $author$project$Components$ResourceFilter$ChargeItem$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ChargeItem$All$ChargeItem = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ChargeItem$All$Record = F2(function(category, uom) {
        return {
            EL: category,
            aaK: uom
        };
    });
    var $author$project$Api$Provider$ChargeItem$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uom', $author$project$Api$Provider$Uom$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$All$Record)));
    var $author$project$Api$Provider$ChargeItem$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$All$ChargeItem)));
    var $author$project$Api$Provider$ChargeItem$listDefaults = {
        EL: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        FW: $elm$core$Maybe$Nothing,
        rc: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        $S: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$ChargeItem$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$ChargeItem$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.EL;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'category', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.FW;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'inventory', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.$S;
                if (!_v4.$) {
                    var bool = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'taxable', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.rc;
                if (!_v5.$) {
                    var itemType = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'item_type', itemType)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$ChargeItem$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ChargeItem$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$ChargeItem$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath)));
    });
    var $author$project$Components$ResourceFilter$ChargeItem$list = $author$project$Api$Provider$ChargeItem$list;
    var $author$project$Api$Provider$ChargeItem$All$alertQuantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$category = function(_v0) {
        var record = _v0.b;
        return record.EL;
    };
    var $author$project$Api$Provider$ChargeItem$All$code = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$codeType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$description = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$ChargeItem$Shared$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Min$id(min);
    };
    var $author$project$Api$Provider$ChargeItem$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$id(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$itemType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$manufacturer = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$priceInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$quantityInStock = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$taxable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$trackInventory = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
    };
    var $author$project$Api$Provider$ChargeItem$All$uom = function(_v0) {
        var record = _v0.b;
        return record.aaK;
    };
    var $author$project$Components$ResourceFilter$ChargeItem$resourceFromAll = function(chargeItem) {
        return {
            I0: $author$project$Api$Provider$ChargeItem$All$alertQuantity(chargeItem),
            EL: $author$project$Api$Provider$ChargeItem$All$category(chargeItem),
            Lk: $author$project$Api$Provider$ChargeItem$All$code(chargeItem),
            Lm: $author$project$Api$Provider$ChargeItem$All$codeType(chargeItem),
            NQ: $author$project$Api$Provider$ChargeItem$All$description(chargeItem),
            aef: $author$project$Api$Provider$ChargeItem$All$id(chargeItem),
            aeE: $author$project$Api$Provider$ChargeItem$All$itemType(chargeItem) === 1,
            rc: $author$project$Api$Provider$ChargeItem$All$itemType(chargeItem),
            TC: $author$project$Api$Provider$ChargeItem$All$manufacturer(chargeItem),
            zr: $author$project$Api$Provider$ChargeItem$All$name(chargeItem),
            Br: $author$project$Api$Provider$ChargeItem$All$priceInCents(chargeItem),
            XT: $author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem),
            $S: $author$project$Api$Provider$ChargeItem$All$taxable(chargeItem),
            aap: $author$project$Api$Provider$ChargeItem$All$trackInventory(chargeItem),
            aaK: $author$project$Api$Provider$ChargeItem$All$uom(chargeItem)
        };
    };
    var $author$project$Components$ResourceFilter$ChargeItem$fetchResources = F5(function(listOptionals, toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$ChargeItem$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$ChargeItem$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$ChargeItem$retrieveResource = F4(function(listOptionals, toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$ChargeItem$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$ChargeItem$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$ChargeItem$selectId = 'charge_items';
    var $author$project$Components$ResourceFilter$ChargeItem$itemTypeLabel = function(itemType_) {
        if (!itemType_) return 'item';
        else return 'package';
    };
    var $author$project$Api$Provider$Uom$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Formatters$ChargeItemCode$CodeTypeAndCode = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$code = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$code(shared);
    };
    var $author$project$Formatters$ChargeItemCode$code = function(chargeItem) {
        if (!chargeItem.$) {
            var _v1 = chargeItem.a;
            var code_ = _v1.b;
            return code_;
        } else {
            var chargeItemForCharge = chargeItem.a;
            return $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItemForCharge);
        }
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$codeType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$codeType(shared);
    };
    var $author$project$Formatters$ChargeItemCode$codeTypes = _List_fromArray([
        _Utils_Tuple2('cpt', 'CPT'),
        _Utils_Tuple2('loinc', 'LOINC'),
        _Utils_Tuple2('ndc', 'NDC'),
        _Utils_Tuple2('snowmed', 'Snowmed'),
        _Utils_Tuple2('other', 'Other')
    ]);
    var $author$project$Formatters$ChargeItemCode$formatCodeType = function(codeType_) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Dict$get, codeType_, $elm$core$Dict$fromList($author$project$Formatters$ChargeItemCode$codeTypes)));
    };
    var $author$project$Formatters$ChargeItemCode$codeType = function(chargeItem) {
        if (!chargeItem.$) {
            var _v1 = chargeItem.a;
            var codeType_ = _v1.a;
            return $author$project$Formatters$ChargeItemCode$formatCodeType(A2($elm$core$Maybe$withDefault, '', codeType_));
        } else {
            var chargeItemForCharge = chargeItem.a;
            return $author$project$Formatters$ChargeItemCode$formatCodeType(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItemForCharge)));
        }
    };
    var $author$project$Formatters$ChargeItemCode$toString = function(chargeItem) {
        var codeTypeName = $author$project$Formatters$ChargeItemCode$codeType(chargeItem);
        return codeTypeName === '' ? '' : codeTypeName + (' ' + $author$project$Formatters$ChargeItemCode$code(chargeItem));
    };
    var $author$project$Components$ResourceFilter$ChargeItem$titleBase = function(resource) {
        var formattedCode = $author$project$Formatters$ChargeItemCode$toString($author$project$Formatters$ChargeItemCode$CodeTypeAndCode(_Utils_Tuple2(resource.Lm, resource.Lk)));
        return _Utils_ap(resource.zr, _Utils_ap(formattedCode !== '' ? ' - ' + formattedCode : '', resource.TC !== '' ? ' - ' + resource.TC : ''));
    };
    var $author$project$Components$ResourceFilter$ChargeItem$toLabel = F2(function(showItemType, resource) {
        var titleWithItemType = showItemType ? _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$ChargeItem$titleBase(resource)),
            $elm$html$Html$text(' '),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$attrs(_List_fromArray([
                    $elm$html$Html$Attributes$class('text-muted')
                ]))
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Components$ResourceFilter$ChargeItem$itemTypeLabel(resource.rc))
            ]))
        ]) : _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$ChargeItem$titleBase(resource))
        ]);
        var timeBasedUom = $author$project$Api$Provider$Uom$Shared$unitClass(resource.aaK) === 'time';
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, titleWithItemType),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromFloat(resource.Br)),
                    timeBasedUom ? A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(' per ' + $author$project$Api$Provider$Uom$Shared$name(resource.aaK))
                    ])) : $author$project$Utils$Html$empty
                ]))
            ])),
            function() {
                var _v0 = resource.NQ;
                if (!_v0.$) {
                    var description = _v0.a;
                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(description)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]);
    });
    var $author$project$Components$ResourceFilter$ChargeItem$toTitle = function(resource) {
        return $author$project$Components$ResourceFilter$ChargeItem$titleBase(resource);
    };
    var $author$project$Components$ResourceFilter$ChargeItem$toValue = function($) {
        return $.aef;
    };
    var $author$project$Components$ResourceFilter$ChargeItem$initWithItemType = F4(function(showItemTypeInTitle, apiClient, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$ChargeItem$fetchResources(listOptionals),
            aef: $author$project$Components$ResourceFilter$ChargeItem$selectId,
            gD: 'Item',
            sz: $author$project$Components$ResourceFilter$ChargeItem$retrieveResource(listOptionals),
            ahW: $author$project$Components$ResourceFilter$ChargeItem$toLabel(showItemTypeInTitle),
            ahZ: $author$project$Components$ResourceFilter$ChargeItem$toTitle,
            g4: $author$project$Components$ResourceFilter$ChargeItem$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$ChargeItem$init = $author$project$Components$ResourceFilter$ChargeItem$initWithItemType(false);
    var $author$project$Api$Provider$ChargeItem$One$isLab = function(chargeItem) {
        var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$name, $author$project$Api$Provider$ChargeItem$One$category(chargeItem));
        if (!_v0.$) {
            var categoryName_ = _v0.a;
            return categoryName_ === 'Labs';
        } else return false;
    };
    var $author$project$Components$ResourceFilter$preSelectedId = F2(function(id, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            agj: id
        }), $author$project$Components$ResourceFilter$setPreSelected(0));
    });
    var $author$project$Components$ResourceFilter$Category$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Admin$ChargeItems$Form$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString = function(itemType_) {
        if (!itemType_) return 'item';
        else return 'package';
    };
    var $author$project$Api$Provider$ChargeItem$create = F3(function(apiClient, fields, toMsg) {
        var uom = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('code', $elm$json$Json$Encode$string(fields.aaK))
        ]));
        var encodePackageItem = function(item) {
            return $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                function() {
                    var _v3 = item.aef;
                    if (!_v3.$) {
                        var packageItemId = _v3.a;
                        return _List_fromArray([
                            _Utils_Tuple2('id', $elm$json$Json$Encode$string(packageItemId))
                        ]);
                    } else return _List_Nil;
                }(),
                _List_fromArray([
                    _Utils_Tuple2('charge_item', $author$project$Utils$Encode$typedAssociation(item.lv)),
                    _Utils_Tuple2('quantity', $elm$json$Json$Encode$int(item.Bu)),
                    _Utils_Tuple2('price_in_cents', $author$project$Currency$encodeFloat(item.Br))
                ])
            ])));
        };
        var encodePackage = function(pkg) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('package_items', A2($elm$json$Json$Encode$list, encodePackageItem, pkg.VO)),
                _Utils_Tuple2('expiration_number', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, pkg.Pe)),
                _Utils_Tuple2('expiration_unit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, pkg.Pf)),
                _Utils_Tuple2('revenue_recognition', $elm$json$Json$Encode$string(pkg.Y3))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('charge_item', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('price_in_cents', $author$project$Currency$encodeFloat(fields.Br)), A2($elm$core$List$cons, _Utils_Tuple2('description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.NQ)), A2($elm$core$List$cons, _Utils_Tuple2('rich_description', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('en', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Dict$get, 'en', fields.Cb))),
                _Utils_Tuple2('es', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Dict$get, 'es', fields.Cb)))
            ]))), A2($elm$core$List$cons, _Utils_Tuple2('track_inventory', $elm$json$Json$Encode$bool(fields.aap)), A2($elm$core$List$cons, _Utils_Tuple2('alert_quantity', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.I0)), A2($elm$core$List$cons, _Utils_Tuple2('taxable', $elm$json$Json$Encode$bool(fields.$S)), A2($elm$core$List$cons, _Utils_Tuple2('buyable', $elm$json$Json$Encode$bool(fields.Ky)), A2($elm$core$List$cons, _Utils_Tuple2('category', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.EL)), A2($elm$core$List$cons, _Utils_Tuple2('uom', uom), A2($elm$core$List$cons, _Utils_Tuple2('days_supply', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Nc)), A2($elm$core$List$cons, _Utils_Tuple2('code', $elm$json$Json$Encode$string(fields.Lk)), A2($elm$core$List$cons, _Utils_Tuple2('code_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Lm)), A2($elm$core$List$cons, _Utils_Tuple2('manufacturer', $elm$json$Json$Encode$string(fields.TC)), A2($elm$core$List$cons, _Utils_Tuple2('item_type', $elm$json$Json$Encode$string($author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(fields.rc))), _Utils_ap(function() {
                var _v0 = fields.SZ;
                if (!_v0.$) {
                    var lastSetQuantity_ = _v0.a;
                    return _List_fromArray([
                        _Utils_Tuple2('last_set_quantity', $elm$json$Json$Encode$int(lastSetQuantity_))
                    ]);
                } else return _List_Nil;
            }(), _Utils_ap(function() {
                var _v1 = fields.VN;
                if (!_v1.$) {
                    var pkg = _v1.a;
                    return _List_fromArray([
                        _Utils_Tuple2('package', encodePackage(pkg))
                    ]);
                } else return _List_Nil;
            }(), function() {
                var _v2 = fields.Q4;
                if (!_v2.$) {
                    var url = _v2.a;
                    return _List_fromArray([
                        _Utils_Tuple2('image', $elm$json$Json$Encode$string(url))
                    ]);
                } else return _List_Nil;
            }())))))))))))))))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$ChargeItem$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath)));
    });
    var $author$project$Components$TranslatedRichText$translations = function(model) {
        return model.aay;
    };
    var $author$project$Components$Admin$ChargeItems$Form$createItem = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var _package = function() {
            if (fields.rc === 1) {
                var packageItems = A2($elm$core$List$filterMap, function(item) {
                    return A2($elm$core$Maybe$map, function(chargeItemId) {
                        return {
                            lv: {
                                aef: $elm$core$Maybe$Just(chargeItemId),
                                ah5: $elm$core$Maybe$Just('charge_item')
                            },
                            aef: item.aef,
                            Br: item.Br,
                            Bu: item.Bu
                        };
                    }, item.ack);
                }, fields.VO);
                return $elm$core$Maybe$Just({
                    Pe: fields.b9 ? A2($elm$core$Maybe$map, $elm$core$Basics$max(1), $elm$core$String$toInt(fields.Pe)) : $elm$core$Maybe$Nothing,
                    Pf: fields.b9 ? $elm$core$Maybe$Just(fields.Pf) : $elm$core$Maybe$Nothing,
                    VO: packageItems,
                    Y3: fields.Y3
                });
            } else return $elm$core$Maybe$Nothing;
        }();
        var apiFields = {
            I0: fields.I0,
            Ky: fields.Ky,
            EL: fields.EL,
            Lk: fields.Lk,
            Lm: fields.Lm,
            Nc: fields.Nc,
            NQ: fields.NQ,
            Q4: fields.Q4,
            rc: fields.rc,
            SZ: fields.SZ,
            TC: fields.TC,
            zr: fields.zr,
            VN: _package,
            Br: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Br),
            Cb: $author$project$Components$TranslatedRichText$translations(fields.eD),
            $S: fields.$S,
            aap: fields.aap,
            aaK: fields.aaK
        };
        return A3($author$project$Api$Provider$ChargeItem$create, apiClient, apiFields, $author$project$Components$Admin$ChargeItems$Form$Created);
    });
    var $author$project$Components$Admin$ChargeItems$Form$Updated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Utils$Encode$optional = F3(function(fieldName, encoder, maybeValue) {
        if (!maybeValue.$) {
            var value = maybeValue.a;
            return _List_fromArray([
                _Utils_Tuple2(fieldName, encoder(value))
            ]);
        } else return _List_Nil;
    });
    var $author$project$Api$Provider$ChargeItem$update = F4(function(apiClient, id_, fields, toMsg) {
        var uom = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('code', $elm$json$Json$Encode$string(fields.aaK))
        ]));
        var encodePackageItem = function(item) {
            return $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                function() {
                    var _v2 = item.aef;
                    if (!_v2.$) {
                        var packageItemId = _v2.a;
                        return _List_fromArray([
                            _Utils_Tuple2('id', $elm$json$Json$Encode$string(packageItemId))
                        ]);
                    } else return _List_Nil;
                }(),
                _List_fromArray([
                    _Utils_Tuple2('charge_item', $author$project$Utils$Encode$typedAssociation(item.lv)),
                    _Utils_Tuple2('quantity', $elm$json$Json$Encode$int(item.Bu)),
                    _Utils_Tuple2('price_in_cents', $author$project$Currency$encodeFloat(item.Br))
                ])
            ])));
        };
        var encodePackage = function(pkg) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('package_items', A2($elm$json$Json$Encode$list, encodePackageItem, pkg.VO)),
                _Utils_Tuple2('expiration_number', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, pkg.Pe)),
                _Utils_Tuple2('expiration_unit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, pkg.Pf)),
                _Utils_Tuple2('revenue_recognition', $elm$json$Json$Encode$string(pkg.Y3))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('charge_item', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('price_in_cents', $author$project$Currency$encodeFloat(fields.Br)), A2($elm$core$List$cons, _Utils_Tuple2('description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.NQ)), A2($elm$core$List$cons, _Utils_Tuple2('rich_description', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('en', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Dict$get, 'en', fields.Cb))),
                _Utils_Tuple2('es', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Dict$get, 'es', fields.Cb)))
            ]))), A2($elm$core$List$cons, _Utils_Tuple2('track_inventory', $elm$json$Json$Encode$bool(fields.aap)), A2($elm$core$List$cons, _Utils_Tuple2('alert_quantity', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.I0)), A2($elm$core$List$cons, _Utils_Tuple2('taxable', $elm$json$Json$Encode$bool(fields.$S)), A2($elm$core$List$cons, _Utils_Tuple2('buyable', $elm$json$Json$Encode$bool(fields.Ky)), A2($elm$core$List$cons, _Utils_Tuple2('category', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.EL)), A2($elm$core$List$cons, _Utils_Tuple2('uom', uom), A2($elm$core$List$cons, _Utils_Tuple2('days_supply', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Nc)), A2($elm$core$List$cons, _Utils_Tuple2('code', $elm$json$Json$Encode$string(fields.Lk)), A2($elm$core$List$cons, _Utils_Tuple2('code_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Lm)), A2($elm$core$List$cons, _Utils_Tuple2('manufacturer', $elm$json$Json$Encode$string(fields.TC)), A2($elm$core$List$cons, _Utils_Tuple2('item_type', $elm$json$Json$Encode$string($author$project$Api$Provider$ChargeItem$Shared$itemTypeToString(fields.rc))), _Utils_ap(A3($author$project$Utils$Encode$optional, 'last_set_quantity', $elm$json$Json$Encode$int, fields.SZ), _Utils_ap(function() {
                var _v0 = fields.VN;
                if (!_v0.$) {
                    var pkg = _v0.a;
                    return _List_fromArray([
                        _Utils_Tuple2('package', encodePackage(pkg))
                    ]);
                } else return _List_Nil;
            }(), function() {
                var _v1 = fields.Q4;
                if (!_v1.$) {
                    var url = _v1.a;
                    return _List_fromArray([
                        _Utils_Tuple2('image', $elm$json$Json$Encode$string(url))
                    ]);
                } else return _List_Nil;
            }())))))))))))))))))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$ChargeItem$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemPath(id_))));
    });
    var $author$project$Components$Admin$ChargeItems$Form$updateItem = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var _package = function() {
            if (fields.rc === 1) {
                var packageItems = A2($elm$core$List$filterMap, function(item) {
                    return A2($elm$core$Maybe$map, function(chargeItemId) {
                        return {
                            lv: {
                                aef: $elm$core$Maybe$Just(chargeItemId),
                                ah5: $elm$core$Maybe$Just('charge_item')
                            },
                            aef: item.aef,
                            Br: item.Br,
                            Bu: item.Bu
                        };
                    }, item.ack);
                }, fields.VO);
                return $elm$core$Maybe$Just({
                    Pe: fields.b9 ? A2($elm$core$Maybe$map, $elm$core$Basics$max(1), $elm$core$String$toInt(fields.Pe)) : $elm$core$Maybe$Nothing,
                    Pf: fields.b9 ? $elm$core$Maybe$Just(fields.Pf) : $elm$core$Maybe$Nothing,
                    VO: packageItems,
                    Y3: fields.Y3
                });
            } else return $elm$core$Maybe$Nothing;
        }();
        var apiFields = {
            I0: fields.I0,
            Ky: fields.Ky,
            EL: fields.EL,
            Lk: fields.Lk,
            Lm: fields.Lm,
            Nc: fields.Nc,
            NQ: fields.NQ,
            Q4: fields.Q4,
            rc: fields.rc,
            SZ: fields.iy ? fields.SZ : $elm$core$Maybe$Nothing,
            TC: fields.TC,
            zr: fields.zr,
            VN: _package,
            Br: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Br),
            Cb: $author$project$Components$TranslatedRichText$translations(fields.eD),
            $S: fields.$S,
            aap: fields.aap,
            aaK: fields.aaK
        };
        return A4($author$project$Api$Provider$ChargeItem$update, apiClient, id, apiFields, $author$project$Components$Admin$ChargeItems$Form$Updated);
    });
    var $author$project$Components$Admin$ChargeItems$Form$saveItem = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Components$Admin$ChargeItems$Form$updateItem, apiClient, id_, formFields);
        } else return A2($author$project$Components$Admin$ChargeItems$Form$createItem, apiClient, formFields);
    });
    var $author$project$Utils$Form$set = F2(function(fields_, _v0) {
        var originalFields = _v0.a;
        var validated_ = _v0.b;
        var errors_ = _v0.d;
        return A4($author$project$Utils$Form$Form, originalFields, validated_, fields_, errors_);
    });
    var $author$project$Components$ResourceFilter$ChargeItem$setValue = F2(function(resource, model) {
        return _Utils_update(model, {
            Hg: resource
        });
    });
    var $elm$file$File$size = _File_size;
    var $elm$file$File$toUrl = _File_toUrl;
    var $author$project$Components$ResourceFilter$Closed = {
        $: 1
    };
    var $author$project$Components$ResourceFilter$FreeText = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$GotPreselectedItem = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ResourceFilter$ItemSelected = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Many = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$None = {
        $: 3
    };
    var $author$project$Components$ResourceFilter$One = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$SelectMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$DebouncedMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$debounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(300),
        ah3: $author$project$Components$ResourceFilter$DebouncedMsg
    };
    var $author$project$Components$ResourceFilter$DropdownSearchDebounced = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$debounceText = function(text) {
        return A2($elm$core$Task$perform, $author$project$Components$ResourceFilter$DropdownSearchDebounced, $elm$core$Task$succeed(text));
    };
    var $author$project$Components$ResourceFilter$itemChecked = F2(function(model, many) {
        return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: $elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected(many)),
            zi: model,
            at: _List_Nil
        };
    });
    var $author$project$Components$ResourceFilter$itemSelected = F3(function(apiClient, model, selected) {
        return {
            EQ: A4(model.gH, $author$project$Components$ResourceFilter$GotItems(false), apiClient, model.af_, $elm$core$Maybe$Nothing),
            adu: $elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected(A2($elm$core$Maybe$withDefault, $author$project$Components$ResourceFilter$None, selected))),
            zi: _Utils_update(model, {
                agq: $elm$core$Maybe$Nothing
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$ResourceFilter$loadMoreTriggerId = 'load-more';
    var $author$project$Api$Pagination$nextPage = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            bt: model.bt + 1
        });
    };
    var $author$project$Api$Pagination$reset = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            bt: 1
        });
    };
    var $author$project$Components$ResourceFilter$setPreselectedLimit = 20;
    var $author$project$Components$ResourceFilter$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 9:
                var pagination = $author$project$Api$Pagination$nextPage(model.af_);
                return {
                    EQ: A4(model.gH, $author$project$Components$ResourceFilter$GotItems(true), apiClient, pagination, model.agq),
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(model, {
                        i3: true,
                        af_: pagination
                    }),
                    at: _List_Nil
                };
            case 5:
                var a = msg.a;
                return function(newModel) {
                    return A3($author$project$Components$ResourceFilter$itemSelected, apiClient, newModel, a);
                }(_Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_)
                }));
            case 6:
                var a = msg.a;
                return A2($author$project$Components$ResourceFilter$itemChecked, model, a);
            case 4:
                var dropdownMsg = msg.a;
                var _v1 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.fD);
                var dropdown = _v1.a;
                var dropdownCmd = _v1.b;
                return {
                    EQ: dropdownCmd,
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(model, {
                        fD: dropdown
                    }),
                    at: _List_Nil
                };
            case 0:
                var selectMsg = msg.a;
                var _v2 = A2($author$project$Ui$Form$SearchableSelect$update, selectMsg, model.sI);
                var selectModel = _v2.a;
                var selectCmd = _v2.b;
                var selectEvent = _v2.c;
                var _v3 = function() {
                    if (!selectEvent.$) switch(selectEvent.a.$){
                        case 3:
                            var id = selectEvent.a.a;
                            if (_Utils_eq(id, $author$project$Components$ResourceFilter$loadMoreTriggerId)) {
                                var pagination = $author$project$Api$Pagination$nextPage(model.af_);
                                return _Utils_Tuple3(_Utils_update(model, {
                                    i3: true,
                                    af_: pagination
                                }), A4(model.gH, $author$project$Components$ResourceFilter$GotItems(true), apiClient, pagination, model.agq), $elm$core$Maybe$Nothing);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                        case 0:
                            var selected = selectEvent.a.a;
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected(A2($elm$core$Maybe$withDefault, $author$project$Components$ResourceFilter$None, selected))));
                        case 1:
                            var string = selectEvent.a.a;
                            var pagination = $author$project$Api$Pagination$reset(model.af_);
                            return _Utils_Tuple3(_Utils_update(model, {
                                xQ: $author$project$Utils$String$toMaybe(string),
                                af_: pagination,
                                agq: $elm$core$Maybe$Just(string),
                                oa: true
                            }), A4(model.gH, $author$project$Components$ResourceFilter$GotItems(false), apiClient, pagination, $elm$core$Maybe$Just(string)), model.z9.ad$ ? $elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected($author$project$Components$ResourceFilter$FreeText(string))) : $elm$core$Maybe$Nothing);
                        default:
                            var _v5 = selectEvent.a;
                            var pagination = model.z9.ad$ ? model.af_ : $author$project$Api$Pagination$reset(model.af_);
                            return _Utils_Tuple3(_Utils_update(model, {
                                af_: pagination,
                                agq: $elm$core$Maybe$Nothing
                            }), model.z9.ad$ ? $elm$core$Platform$Cmd$none : A4(model.gH, $author$project$Components$ResourceFilter$GotItems(false), apiClient, pagination, $elm$core$Maybe$Nothing), $elm$core$Maybe$Just($author$project$Components$ResourceFilter$Closed));
                    }
                    else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                }();
                var modelAfterEvent = _v3.a;
                var cmdAfterEvent = _v3.b;
                var eventAfterEvent = _v3.c;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$SelectMsg, selectCmd),
                        cmdAfterEvent
                    ])),
                    adu: eventAfterEvent,
                    zi: _Utils_update(modelAfterEvent, {
                        sI: selectModel
                    }),
                    at: _List_Nil
                };
            case 3:
                var attempts = msg.a;
                var _v6 = model.a0;
                if (!_v6.$) {
                    var items = _v6.a;
                    var _v7 = A2($elm$core$Maybe$withDefault, _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none), A2($elm$core$Maybe$map, function(preSelectedId_) {
                        var selected = A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$One, A2($elm_community$list_extra$List$Extra$find, function(item) {
                            return _Utils_eq(model.g4(item), preSelectedId_);
                        }, items));
                        var extraSelected = A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Extra, A2($elm_community$list_extra$List$Extra$find, function(extraItem) {
                            return _Utils_eq(extraItem.aa9, preSelectedId_);
                        }, model.d4));
                        var _v8 = _Utils_Tuple3(selected, extraSelected, preSelectedId_);
                        if (!_v8.a.$) {
                            var selected_ = _v8.a.a;
                            return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected(selected_)), $elm$core$Platform$Cmd$none);
                        } else if (!_v8.b.$) {
                            var extraSelected_ = _v8.b.a;
                            return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected(extraSelected_)), $elm$core$Platform$Cmd$none);
                        } else {
                            var anyString = _v8.c;
                            return $elm$core$String$isEmpty(anyString) && model.z9.afn ? _Utils_Tuple2($elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected($author$project$Components$ResourceFilter$None)), $elm$core$Platform$Cmd$none) : !$elm$core$String$isEmpty(anyString) ? _Utils_Tuple2($elm$core$Maybe$Nothing, A3(model.sz, $author$project$Components$ResourceFilter$GotPreselectedItem(anyString), apiClient, anyString)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                        }
                    }, model.agj));
                    var event = _v7.a;
                    var cmd = _v7.b;
                    return {
                        EQ: cmd,
                        adu: event,
                        zi: _Utils_update(model, {
                            agj: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: _Utils_cmp(attempts, $author$project$Components$ResourceFilter$setPreselectedLimit) > 0 ? $elm$core$Platform$Cmd$none : $author$project$Components$ResourceFilter$setPreSelected(attempts),
                    adu: $elm$core$Maybe$Nothing,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var append = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var items = response.a;
                    var headers = response.b;
                    var dataItems = function() {
                        var _v10 = _Utils_Tuple2(model.adw, model.adx);
                        _v10$2: while(true)if (!_v10.a.$) {
                            if (_v10.b.$ === 1) {
                                var excludedId_ = _v10.a.a;
                                var _v11 = _v10.b;
                                return A2($elm$core$List$filter, function(item) {
                                    return !_Utils_eq(model.g4(item), excludedId_);
                                }, items);
                            } else break _v10$2;
                        } else {
                            if (!_v10.b.$) {
                                var _v12 = _v10.a;
                                var excludedTitles_ = _v10.b.a;
                                return A2($elm$core$List$filter, function(item) {
                                    return !A2($elm$core$List$member, model.ahZ(item), excludedTitles_);
                                }, items);
                            } else break _v10$2;
                        }
                        return items;
                    }();
                    return {
                        EQ: $author$project$Components$ResourceFilter$setPreSelected(0),
                        adu: $elm$core$Maybe$Nothing,
                        zi: _Utils_update(model, {
                            a0: $elm$core$Maybe$Just(append ? _Utils_ap(A2($elm$core$Maybe$withDefault, _List_Nil, model.a0), dataItems) : dataItems),
                            i3: false,
                            oa: false,
                            oR: A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(model, {
                        a0: $elm$core$Maybe$Nothing,
                        i3: false,
                        oa: false,
                        oR: $elm$core$Maybe$Nothing
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 2:
                var preSelectedId_ = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var items = response.a;
                    var preSelectedItem = A2($elm$core$List$filter, function(item) {
                        return A2($elm$core$List$member, model.g4(item), A2($elm$core$String$split, ',', preSelectedId_));
                    }, items);
                    if (preSelectedItem.b) {
                        if (!preSelectedItem.b.b) {
                            var preSelectedItem_ = preSelectedItem.a;
                            return {
                                EQ: $author$project$Components$ResourceFilter$setPreSelected(0),
                                adu: $elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected($author$project$Components$ResourceFilter$One(preSelectedItem_))),
                                zi: _Utils_update(model, {
                                    a0: $elm$core$Maybe$Just(_Utils_ap(A2($elm$core$Maybe$withDefault, _List_Nil, model.a0), _List_fromArray([
                                        preSelectedItem_
                                    ])))
                                }),
                                at: _List_Nil
                            };
                        } else {
                            var preselectedItems = preSelectedItem;
                            return {
                                EQ: $author$project$Components$ResourceFilter$setPreSelected(0),
                                adu: $elm$core$Maybe$Just($author$project$Components$ResourceFilter$ItemSelected($author$project$Components$ResourceFilter$Many(preselectedItems))),
                                zi: _Utils_update(model, {
                                    a0: $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, _List_Nil, model.a0))
                                }),
                                at: _List_Nil
                            };
                        }
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $elm$core$Maybe$Nothing,
                        zi: model,
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $elm$core$Maybe$Nothing,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 8:
                var text = msg.a;
                var _v15 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$ResourceFilter$debounceConfig, text, model.dJ);
                var newDebouncer = _v15.a;
                var cmd = _v15.b;
                return {
                    EQ: cmd,
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(model, {
                        dJ: newDebouncer,
                        agq: $elm$core$Maybe$Just(text)
                    }),
                    at: _List_Nil
                };
            case 10:
                var debounceMsg = msg.a;
                var _v16 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$ResourceFilter$debounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$ResourceFilter$debounceText), debounceMsg, model.dJ);
                var newDebouncer = _v16.a;
                var cmd = _v16.b;
                return {
                    EQ: cmd,
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(model, {
                        dJ: newDebouncer
                    }),
                    at: _List_Nil
                };
            default:
                var text = msg.a;
                var pagination = $author$project$Api$Pagination$reset(model.af_);
                return {
                    EQ: A4(model.gH, $author$project$Components$ResourceFilter$GotItems(false), apiClient, pagination, $elm$core$Maybe$Just(text)),
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(model, {
                        af_: pagination,
                        agq: $elm$core$Maybe$Just(text)
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$ResourceFilter$Category$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$ChargeItem$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$TranslatedRichText$update = F3(function(editorId, msg, model) {
        switch(msg.$){
            case 0:
                var content = msg.a;
                var langKey = $author$project$Language$toValue(model.h4);
                var newTranslations = $elm$core$String$isEmpty(content) ? A2($elm$core$Dict$remove, langKey, model.aay) : A3($elm$core$Dict$insert, langKey, content, model.aay);
                return _Utils_Tuple2(_Utils_update(model, {
                    aay: newTranslations
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var content = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Dict$get, $author$project$Language$toValue(model.h4), model.aay));
                return _Utils_Tuple2(_Utils_update(model, {
                    mI: true
                }), A3($author$project$Ports$CKEditor$replace, editorId, content, _List_Nil));
            case 2:
                var language = msg.a;
                var content = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Dict$get, $author$project$Language$toValue(language), model.aay));
                return _Utils_Tuple2(_Utils_update(model, {
                    h4: language
                }), A2($author$project$Ports$CKEditor$setData, editorId, content));
            default:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.fD);
                var newDropdown = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    fD: newDropdown
                }), cmd);
        }
    });
    var $author$project$Components$ResourceFilter$choiceToValue = F2(function(model, choice) {
        switch(choice.$){
            case 2:
                return model.z9.abE;
            case 3:
                return model.z9.afo;
            case 0:
                var item = choice.a;
                return $elm$core$Maybe$Just(model.g4(item));
            case 1:
                var items = choice.a;
                return $elm$core$Maybe$Just(A2($elm$core$String$join, ',', A2($elm$core$List$map, model.g4, items)));
            case 4:
                var extraItem = choice.a;
                return $elm$core$Maybe$Just(extraItem.aa9);
            default:
                var string = choice.a;
                return $elm$core$Maybe$Just(string);
        }
    });
    var $author$project$Components$ResourceFilter$Category$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Admin$ChargeItems$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var chargeItem = response.a;
                    var formFields = $author$project$Components$Admin$ChargeItems$Form$formFieldsFromItem(chargeItem);
                    var category = $author$project$Api$Provider$ChargeItem$One$category(chargeItem);
                    var _v3 = function() {
                        if ($author$project$Api$Provider$ChargeItem$One$itemType(chargeItem) === 1) {
                            var packageItems = $author$project$Api$Provider$ChargeItem$One$packageItems(chargeItem);
                            var originalPrices = $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, A2($elm$core$List$indexedMap, F2(function(index, item) {
                                return A2($elm$core$Maybe$andThen, function(price) {
                                    return price > 0 ? $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$String$fromInt(index), $author$project$Currency$fromFloat(price))) : $elm$core$Maybe$Nothing;
                                }, item.acm);
                            }), packageItems)));
                            return A3($elm$core$List$foldl, F2(function(rule, _v6) {
                                var _v7 = _v6.a;
                                var filters = _v7.a;
                                var cmds = _v7.b;
                                var _v8 = _v6.b;
                                var tMap = _v8.a;
                                var _v9 = A3($author$project$Components$ResourceFilter$ChargeItem$init, apiClient, function(opts) {
                                    return _Utils_update(opts, {
                                        rc: $elm$core$Maybe$Just('item')
                                    });
                                }, function(d) {
                                    return _Utils_update(d, {
                                        Ee: 'Select a Charge Item'
                                    });
                                });
                                var resourceFilter = _v9.a;
                                var cmd = _v9.b;
                                var finalResourceFilter = function() {
                                    var _v10 = _Utils_Tuple2(rule.ack, rule.acl);
                                    if (!_v10.a.$) {
                                        var id = _v10.a.a;
                                        var maybeName = _v10.b;
                                        var name = A2($elm$core$Maybe$withDefault, id, maybeName);
                                        return A2($author$project$Components$ResourceFilter$ChargeItem$setValue, $author$project$Components$ResourceFilter$Extra({
                                            aeI: name,
                                            aa9: id
                                        }), A2($author$project$Components$ResourceFilter$ChargeItem$extraItems, _List_fromArray([
                                            {
                                                aef: id,
                                                zr: name
                                            }
                                        ]), resourceFilter));
                                    } else return resourceFilter;
                                }();
                                return _Utils_Tuple2(_Utils_Tuple2(A3($elm$core$Dict$insert, rule.K, finalResourceFilter, filters), A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(rule.K), cmd), cmds)), _Utils_Tuple2(tMap, originalPrices));
                            }), _Utils_Tuple2(_Utils_Tuple2($elm$core$Dict$empty, _List_Nil), _Utils_Tuple2($elm$core$Dict$empty, originalPrices)), formFields.VO);
                        } else return _Utils_Tuple2(_Utils_Tuple2($elm$core$Dict$empty, _List_Nil), _Utils_Tuple2($elm$core$Dict$empty, $elm$core$Dict$empty));
                    }();
                    var _v4 = _v3.a;
                    var packageItemFilters = _v4.a;
                    var filterCmds = _v4.b;
                    var _v5 = _v3.b;
                    var taxableMap = _v5.a;
                    var originalPricesMap = _v5.b;
                    var _v11 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Category$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(category_) {
                        return _List_fromArray([
                            {
                                aef: $author$project$Api$Provider$Category$Shared$id(category_),
                                zr: $author$project$Api$Provider$Category$Shared$name(category_)
                            }
                        ]);
                    }, category))), A2($author$project$Components$ResourceFilter$Category$preSelectedId, A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category), model.cK));
                    var categoryResourceFilter = _v11.a;
                    var categoryResourceFilterCmd = _v11.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cK: categoryResourceFilter,
                        fi: taxableMap,
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init(formFields)),
                        yq: $author$project$Api$Provider$ChargeItem$One$isLab(chargeItem),
                        bz: originalPricesMap,
                        cg: packageItemFilters
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
                        $elm$core$Platform$Cmd$batch(filterCmds)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 10:
                var subMsg = msg.a;
                var _v12 = model.PU;
                if (!_v12.$) {
                    var form = _v12.a;
                    var fields = $author$project$Utils$Form$fields(form);
                    var _v13 = A3($author$project$Components$TranslatedRichText$update, 'charge-item-rich-description-editor', subMsg, fields.eD);
                    var newRichDescription = _v13.a;
                    var richDescCmd = _v13.b;
                    var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                        eD: newRichDescription
                    }), form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg, richDescCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var field = msg.a;
                var _v14 = model.PU;
                if (!_v14.$) {
                    var form = _v14.a;
                    var updatedOriginalPrices = function() {
                        if (field.$ === 18) {
                            var tempId = field.a;
                            return A2($elm$core$Dict$remove, tempId, model.bz);
                        } else return model.bz;
                    }();
                    var newForm = (function() {
                        if (field.$ === 17) return $author$project$Utils$Form$clearGroupErrors(5);
                        else return $elm$core$Basics$identity;
                    })()($author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(A3($author$project$Utils$Form$update, $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate, field, form)));
                    var _v15 = function() {
                        switch(field.$){
                            case 17:
                                var formFields = $author$project$Utils$Form$fields(newForm);
                                var tempId = A2($elm$core$Maybe$withDefault, '0', A2($elm$core$Maybe$map, function($) {
                                    return $.K;
                                }, $elm$core$List$head($elm$core$List$reverse(formFields.VO))));
                                var _v17 = A3($author$project$Components$ResourceFilter$ChargeItem$init, apiClient, function(opts) {
                                    return _Utils_update(opts, {
                                        rc: $elm$core$Maybe$Just('item')
                                    });
                                }, function(d) {
                                    return _Utils_update(d, {
                                        Ee: 'Select a Charge Item'
                                    });
                                });
                                var resourceFilter = _v17.a;
                                var cmd = _v17.b;
                                return _Utils_Tuple2(A3($elm$core$Dict$insert, tempId, resourceFilter, model.cg), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(tempId), cmd));
                            case 18:
                                var tempId = field.a;
                                return _Utils_Tuple2(A2($elm$core$Dict$remove, tempId, model.cg), $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple2(model.cg, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var updatedFilters = _v15.a;
                    var filterCmd = _v15.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        bz: updatedOriginalPrices,
                        cg: updatedFilters
                    }), filterCmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var _v20 = model.PU;
                if (!_v20.$) {
                    var form = _v20.a;
                    var _v21 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$ChargeItems$Form$formFieldsValidator, form);
                    if (!_v21.$) {
                        var _v22 = _v21.a;
                        var newForm = _v22.a;
                        var validFormFields = _v22.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$Loading
                        }), A3($author$project$Components$Admin$ChargeItems$Form$saveItem, apiClient, model.aef, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v21.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                var _v23 = model.PU;
                if (!_v23.$) {
                    if (response.$ === 3) {
                        var chargeItem = response.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$ChargeItem$One$name(chargeItem))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                var _v25 = model.PU;
                if (!_v25.$) {
                    if (response.$ === 3) {
                        var chargeItem = response.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$ChargeItem$One$name(chargeItem) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var subMsg = msg.a;
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cK);
                var _v27 = model.PU;
                if (!_v27.$) {
                    var form = _v27.a;
                    var newForm = function() {
                        var _v28 = categoryResourceResult.adu;
                        if (!_v28.$) {
                            if (!_v28.a.$) return A3($author$project$Utils$Form$update, $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate, $author$project$Components$Admin$ChargeItems$Form$Category($author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi)), form);
                            else {
                                var _v29 = _v28.a;
                                return form;
                            }
                        } else return form;
                    }();
                    var newModel = _Utils_update(model, {
                        cK: categoryResourceResult.zi,
                        PU: $elm$core$Maybe$Just(newForm)
                    });
                    return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceResult.EQ), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cK: categoryResourceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, categoryResourceResult.EQ), _List_Nil);
            case 6:
                var tempId = msg.a;
                var subMsg = msg.b;
                var maybeFilter = A2($elm$core$Dict$get, tempId, model.cg);
                var _v30 = function() {
                    if (!maybeFilter.$) {
                        var resourceFilter = maybeFilter.a;
                        var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, resourceFilter);
                        var updatedFilters = A3($elm$core$Dict$insert, tempId, chargeItemResourceResult.zi, model.cg);
                        var _v32 = function() {
                            var _v33 = chargeItemResourceResult.adu;
                            _v33$2: while(true){
                                if (!_v33.$ && !_v33.a.$) switch(_v33.a.a.$){
                                    case 0:
                                        var chargeItem = _v33.a.a.a;
                                        var _v34 = model.PU;
                                        if (!_v34.$) {
                                            var form = _v34.a;
                                            var originalPrice = $author$project$Currency$fromFloat(chargeItem.Br);
                                            var selectedItem = A5($author$project$Components$Admin$ChargeItems$Form$SelectPackageItem, tempId, chargeItem.aef, chargeItem.zr, originalPrice, chargeItem.$S);
                                            var selectedForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate, selectedItem, form);
                                            var newTaxableMap = A3($elm$core$Dict$insert, chargeItem.aef, chargeItem.$S, model.fi);
                                            var newOriginalPrices = A3($elm$core$Dict$insert, tempId, originalPrice, model.bz);
                                            return _Utils_Tuple3($elm$core$Maybe$Just($author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(selectedForm)), newTaxableMap, newOriginalPrices);
                                        } else return _Utils_Tuple3($elm$core$Maybe$Nothing, model.fi, model.bz);
                                    case 4:
                                        return _Utils_Tuple3(model.PU, model.fi, model.bz);
                                    default:
                                        break _v33$2;
                                }
                                else break _v33$2;
                            }
                            return _Utils_Tuple3(model.PU, model.fi, model.bz);
                        }();
                        var updatedForm = _v32.a;
                        var updatedTaxableMap = _v32.b;
                        var updatedOriginalPrices = _v32.c;
                        return _Utils_Tuple2(_Utils_update(model, {
                            fi: updatedTaxableMap,
                            PU: updatedForm,
                            bz: updatedOriginalPrices,
                            cg: updatedFilters
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(tempId), chargeItemResourceResult.EQ));
                    } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var updatedModel = _v30.a;
                var cmd = _v30.b;
                return _Utils_Tuple3(updatedModel, cmd, _List_Nil);
            case 7:
                var subMsg = msg.a;
                var _v35 = A2($author$project$Ui$Dropdown$update, subMsg, model.lz);
                var newDropdown = _v35.a;
                var cmd = _v35.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    lz: newDropdown
                }), cmd, _List_Nil);
            case 8:
                var selectedCodeType = msg.a;
                var newForm = A2($elm$core$Maybe$map, function(form) {
                    return $author$project$Components$Admin$ChargeItems$Form$clearErrorsIfValid(A3($author$project$Utils$Form$update, $author$project$Components$Admin$ChargeItems$Form$formFieldsUpdate, $author$project$Components$Admin$ChargeItems$Form$CodeType(selectedCodeType), form));
                }, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var pictures = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v36) {
                    var task = _v36.a;
                    var size = _v36.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Image(size)), task);
                }, A2($elm$core$Maybe$map, function(picture) {
                    return _Utils_Tuple2($elm$file$File$toUrl(picture), $elm$file$File$size(picture));
                }, $elm$core$List$head(pictures))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            default:
                return _Utils_Tuple3(model, $author$project$Ports$Navigation$back, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$ChargeItems$Id_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$ChargeItems$Form$update, model.Ej, subMsg, model.PU);
        var newForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Admin$ChargeItems$Form$BackButtonClicked = {
        $: 9
    };
    var $author$project$Components$Admin$ChargeItems$Form$Save = {
        $: 2
    };
    var $author$project$Ui$Panel$titleWithButton = F2(function(contents, buttons) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flex,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$spaceBetween
        ]), _List_fromArray([
            $author$project$Ui$Panel$title(contents),
            A2($author$project$Ui$Element$view, _List_Nil, buttons)
        ]));
    });
    var $author$project$Api$Feature$Packages = 22;
    var $author$project$Api$Feature$SelfBuy = 23;
    var $author$project$Api$Provider$ChargeItem$Meta$buyableEditable = function(_v0) {
        var meta = _v0;
        return meta.Ky.Ot;
    };
    var $author$project$Components$TranslatedRichText$EditToggled = {
        $: 1
    };
    var $author$project$Ui$Form$Group$offsetLabel = $author$project$Ui$Form$Group$LabelGrid(_List_fromArray([
        'ml-1/12'
    ]));
    var $hecrj$html_parser$Html$Parser$Element = F3(function(a, b, c) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c
        };
    });
    var $hecrj$html_parser$Html$Parser$chompOneOrMore = function(fn) {
        return A2($elm$parser$Parser$ignorer, $elm$parser$Parser$chompIf(fn), $elm$parser$Parser$chompWhile(fn));
    };
    var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function(c) {
        return c === ' ' || c === '\t' || c === '\n' || c === '\u000D' || c === '\u000C' || c === '\u00A0';
    };
    var $hecrj$html_parser$Html$Parser$closingTag = function(name) {
        var chompName = A2($elm$parser$Parser$andThen, function(closingName) {
            return _Utils_eq($elm$core$String$toLower(closingName), name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
        }, $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore(function(c) {
            return !$hecrj$html_parser$Html$Parser$isSpaceCharacter(c) && c !== '>';
        })));
        return A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$chompIf($elm$core$Basics$eq('<')), $elm$parser$Parser$chompIf($elm$core$Basics$eq('/'))), chompName), $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)), $elm$parser$Parser$chompIf($elm$core$Basics$eq('>')));
    };
    var $hecrj$html_parser$Html$Parser$Comment = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
    var $elm$parser$Parser$Advanced$fromInfo = F4(function(row, col, x, context) {
        return A2($elm$parser$Parser$Advanced$AddRight, $elm$parser$Parser$Advanced$Empty, A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
    });
    var $elm$parser$Parser$Advanced$chompUntil = function(_v0) {
        var str = _v0.a;
        var expecting = _v0.b;
        return function(s) {
            var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.f, s.n4, s.Ln, s.s2);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return _Utils_eq(newOffset, -1) ? A2($elm$parser$Parser$Advanced$Bad, false, A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.aC)) : A3($elm$parser$Parser$Advanced$Good, _Utils_cmp(s.f, newOffset) < 0, 0, {
                Ln: newCol,
                aC: s.aC,
                aeo: s.aeo,
                f: newOffset,
                n4: newRow,
                s2: s.s2
            });
        };
    };
    var $elm$parser$Parser$chompUntil = function(str) {
        return $elm$parser$Parser$Advanced$chompUntil($elm$parser$Parser$toToken(str));
    };
    var $hecrj$html_parser$Html$Parser$commentString = A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$token('<!')), $elm$parser$Parser$token('--')), A2($elm$parser$Parser$ignorer, $elm$parser$Parser$getChompedString($elm$parser$Parser$chompUntil('-->')), $elm$parser$Parser$token('-->')));
    var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
    var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray([
        'area',
        'base',
        'br',
        'col',
        'embed',
        'hr',
        'img',
        'input',
        'link',
        'meta',
        'param',
        'source',
        'track',
        'wbr'
    ]);
    var $hecrj$html_parser$Html$Parser$isVoidElement = function(name) {
        return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
    };
    var $hecrj$html_parser$Html$Parser$many = function(parser_) {
        return A2($elm$parser$Parser$loop, _List_Nil, function(list) {
            return $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$map, function(_new) {
                    return $elm$parser$Parser$Loop(A2($elm$core$List$cons, _new, list));
                }, parser_),
                $elm$parser$Parser$succeed($elm$parser$Parser$Done($elm$core$List$reverse(list)))
            ]));
        });
    };
    var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function(c) {
        return !$hecrj$html_parser$Html$Parser$isSpaceCharacter(c) && c !== '\"' && c !== '\'' && c !== '>' && c !== '/' && c !== '=';
    };
    var $hecrj$html_parser$Html$Parser$tagAttributeName = A2($elm$parser$Parser$map, $elm$core$String$toLower, $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
    var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf($elm$core$Basics$eq(';'));
    var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2('Aacute', "\xc1"),
        _Utils_Tuple2('aacute', "\xe1"),
        _Utils_Tuple2('Abreve', "\u0102"),
        _Utils_Tuple2('abreve', "\u0103"),
        _Utils_Tuple2('ac', "\u223E"),
        _Utils_Tuple2('acd', "\u223F"),
        _Utils_Tuple2('acE', "\u223E\u0333"),
        _Utils_Tuple2('Acirc', "\xc2"),
        _Utils_Tuple2('acirc', "\xe2"),
        _Utils_Tuple2('acute', "\xb4"),
        _Utils_Tuple2('Acy', "\u0410"),
        _Utils_Tuple2('acy', "\u0430"),
        _Utils_Tuple2('AElig', "\xc6"),
        _Utils_Tuple2('aelig', "\xe6"),
        _Utils_Tuple2('af', '\u2061'),
        _Utils_Tuple2('Afr', '\uD835\uDD04'),
        _Utils_Tuple2('afr', '\uD835\uDD1E'),
        _Utils_Tuple2('Agrave', "\xc0"),
        _Utils_Tuple2('agrave', "\xe0"),
        _Utils_Tuple2('alefsym', "\u2135"),
        _Utils_Tuple2('aleph', "\u2135"),
        _Utils_Tuple2('Alpha', "\u0391"),
        _Utils_Tuple2('alpha', "\u03B1"),
        _Utils_Tuple2('Amacr', "\u0100"),
        _Utils_Tuple2('amacr', "\u0101"),
        _Utils_Tuple2('amalg', "\u2A3F"),
        _Utils_Tuple2('amp', '&'),
        _Utils_Tuple2('AMP', '&'),
        _Utils_Tuple2('andand', "\u2A55"),
        _Utils_Tuple2('And', "\u2A53"),
        _Utils_Tuple2('and', "\u2227"),
        _Utils_Tuple2('andd', "\u2A5C"),
        _Utils_Tuple2('andslope', "\u2A58"),
        _Utils_Tuple2('andv', "\u2A5A"),
        _Utils_Tuple2('ang', "\u2220"),
        _Utils_Tuple2('ange', "\u29A4"),
        _Utils_Tuple2('angle', "\u2220"),
        _Utils_Tuple2('angmsdaa', "\u29A8"),
        _Utils_Tuple2('angmsdab', "\u29A9"),
        _Utils_Tuple2('angmsdac', "\u29AA"),
        _Utils_Tuple2('angmsdad', "\u29AB"),
        _Utils_Tuple2('angmsdae', "\u29AC"),
        _Utils_Tuple2('angmsdaf', "\u29AD"),
        _Utils_Tuple2('angmsdag', "\u29AE"),
        _Utils_Tuple2('angmsdah', "\u29AF"),
        _Utils_Tuple2('angmsd', "\u2221"),
        _Utils_Tuple2('angrt', "\u221F"),
        _Utils_Tuple2('angrtvb', "\u22BE"),
        _Utils_Tuple2('angrtvbd', "\u299D"),
        _Utils_Tuple2('angsph', "\u2222"),
        _Utils_Tuple2('angst', "\xc5"),
        _Utils_Tuple2('angzarr', "\u237C"),
        _Utils_Tuple2('Aogon', "\u0104"),
        _Utils_Tuple2('aogon', "\u0105"),
        _Utils_Tuple2('Aopf', '\uD835\uDD38'),
        _Utils_Tuple2('aopf', '\uD835\uDD52'),
        _Utils_Tuple2('apacir', "\u2A6F"),
        _Utils_Tuple2('ap', "\u2248"),
        _Utils_Tuple2('apE', "\u2A70"),
        _Utils_Tuple2('ape', "\u224A"),
        _Utils_Tuple2('apid', "\u224B"),
        _Utils_Tuple2('apos', '\''),
        _Utils_Tuple2('ApplyFunction', '\u2061'),
        _Utils_Tuple2('approx', "\u2248"),
        _Utils_Tuple2('approxeq', "\u224A"),
        _Utils_Tuple2('Aring', "\xc5"),
        _Utils_Tuple2('aring', "\xe5"),
        _Utils_Tuple2('Ascr', '\uD835\uDC9C'),
        _Utils_Tuple2('ascr', '\uD835\uDCB6'),
        _Utils_Tuple2('Assign', "\u2254"),
        _Utils_Tuple2('ast', '*'),
        _Utils_Tuple2('asymp', "\u2248"),
        _Utils_Tuple2('asympeq', "\u224D"),
        _Utils_Tuple2('Atilde', "\xc3"),
        _Utils_Tuple2('atilde', "\xe3"),
        _Utils_Tuple2('Auml', "\xc4"),
        _Utils_Tuple2('auml', "\xe4"),
        _Utils_Tuple2('awconint', "\u2233"),
        _Utils_Tuple2('awint', "\u2A11"),
        _Utils_Tuple2('backcong', "\u224C"),
        _Utils_Tuple2('backepsilon', "\u03F6"),
        _Utils_Tuple2('backprime', "\u2035"),
        _Utils_Tuple2('backsim', "\u223D"),
        _Utils_Tuple2('backsimeq', "\u22CD"),
        _Utils_Tuple2('Backslash', "\u2216"),
        _Utils_Tuple2('Barv', "\u2AE7"),
        _Utils_Tuple2('barvee', "\u22BD"),
        _Utils_Tuple2('barwed', "\u2305"),
        _Utils_Tuple2('Barwed', "\u2306"),
        _Utils_Tuple2('barwedge', "\u2305"),
        _Utils_Tuple2('bbrk', "\u23B5"),
        _Utils_Tuple2('bbrktbrk', "\u23B6"),
        _Utils_Tuple2('bcong', "\u224C"),
        _Utils_Tuple2('Bcy', "\u0411"),
        _Utils_Tuple2('bcy', "\u0431"),
        _Utils_Tuple2('bdquo', "\u201E"),
        _Utils_Tuple2('becaus', "\u2235"),
        _Utils_Tuple2('because', "\u2235"),
        _Utils_Tuple2('Because', "\u2235"),
        _Utils_Tuple2('bemptyv', "\u29B0"),
        _Utils_Tuple2('bepsi', "\u03F6"),
        _Utils_Tuple2('bernou', "\u212C"),
        _Utils_Tuple2('Bernoullis', "\u212C"),
        _Utils_Tuple2('Beta', "\u0392"),
        _Utils_Tuple2('beta', "\u03B2"),
        _Utils_Tuple2('beth', "\u2136"),
        _Utils_Tuple2('between', "\u226C"),
        _Utils_Tuple2('Bfr', '\uD835\uDD05'),
        _Utils_Tuple2('bfr', '\uD835\uDD1F'),
        _Utils_Tuple2('bigcap', "\u22C2"),
        _Utils_Tuple2('bigcirc', "\u25EF"),
        _Utils_Tuple2('bigcup', "\u22C3"),
        _Utils_Tuple2('bigodot', "\u2A00"),
        _Utils_Tuple2('bigoplus', "\u2A01"),
        _Utils_Tuple2('bigotimes', "\u2A02"),
        _Utils_Tuple2('bigsqcup', "\u2A06"),
        _Utils_Tuple2('bigstar', "\u2605"),
        _Utils_Tuple2('bigtriangledown', "\u25BD"),
        _Utils_Tuple2('bigtriangleup', "\u25B3"),
        _Utils_Tuple2('biguplus', "\u2A04"),
        _Utils_Tuple2('bigvee', "\u22C1"),
        _Utils_Tuple2('bigwedge', "\u22C0"),
        _Utils_Tuple2('bkarow', "\u290D"),
        _Utils_Tuple2('blacklozenge', "\u29EB"),
        _Utils_Tuple2('blacksquare', "\u25AA"),
        _Utils_Tuple2('blacktriangle', "\u25B4"),
        _Utils_Tuple2('blacktriangledown', "\u25BE"),
        _Utils_Tuple2('blacktriangleleft', "\u25C2"),
        _Utils_Tuple2('blacktriangleright', "\u25B8"),
        _Utils_Tuple2('blank', "\u2423"),
        _Utils_Tuple2('blk12', "\u2592"),
        _Utils_Tuple2('blk14', "\u2591"),
        _Utils_Tuple2('blk34', "\u2593"),
        _Utils_Tuple2('block', "\u2588"),
        _Utils_Tuple2('bne', "=\u20E5"),
        _Utils_Tuple2('bnequiv', "\u2261\u20E5"),
        _Utils_Tuple2('bNot', "\u2AED"),
        _Utils_Tuple2('bnot', "\u2310"),
        _Utils_Tuple2('Bopf', '\uD835\uDD39'),
        _Utils_Tuple2('bopf', '\uD835\uDD53'),
        _Utils_Tuple2('bot', "\u22A5"),
        _Utils_Tuple2('bottom', "\u22A5"),
        _Utils_Tuple2('bowtie', "\u22C8"),
        _Utils_Tuple2('boxbox', "\u29C9"),
        _Utils_Tuple2('boxdl', "\u2510"),
        _Utils_Tuple2('boxdL', "\u2555"),
        _Utils_Tuple2('boxDl', "\u2556"),
        _Utils_Tuple2('boxDL', "\u2557"),
        _Utils_Tuple2('boxdr', "\u250C"),
        _Utils_Tuple2('boxdR', "\u2552"),
        _Utils_Tuple2('boxDr', "\u2553"),
        _Utils_Tuple2('boxDR', "\u2554"),
        _Utils_Tuple2('boxh', "\u2500"),
        _Utils_Tuple2('boxH', "\u2550"),
        _Utils_Tuple2('boxhd', "\u252C"),
        _Utils_Tuple2('boxHd', "\u2564"),
        _Utils_Tuple2('boxhD', "\u2565"),
        _Utils_Tuple2('boxHD', "\u2566"),
        _Utils_Tuple2('boxhu', "\u2534"),
        _Utils_Tuple2('boxHu', "\u2567"),
        _Utils_Tuple2('boxhU', "\u2568"),
        _Utils_Tuple2('boxHU', "\u2569"),
        _Utils_Tuple2('boxminus', "\u229F"),
        _Utils_Tuple2('boxplus', "\u229E"),
        _Utils_Tuple2('boxtimes', "\u22A0"),
        _Utils_Tuple2('boxul', "\u2518"),
        _Utils_Tuple2('boxuL', "\u255B"),
        _Utils_Tuple2('boxUl', "\u255C"),
        _Utils_Tuple2('boxUL', "\u255D"),
        _Utils_Tuple2('boxur', "\u2514"),
        _Utils_Tuple2('boxuR', "\u2558"),
        _Utils_Tuple2('boxUr', "\u2559"),
        _Utils_Tuple2('boxUR', "\u255A"),
        _Utils_Tuple2('boxv', "\u2502"),
        _Utils_Tuple2('boxV', "\u2551"),
        _Utils_Tuple2('boxvh', "\u253C"),
        _Utils_Tuple2('boxvH', "\u256A"),
        _Utils_Tuple2('boxVh', "\u256B"),
        _Utils_Tuple2('boxVH', "\u256C"),
        _Utils_Tuple2('boxvl', "\u2524"),
        _Utils_Tuple2('boxvL', "\u2561"),
        _Utils_Tuple2('boxVl', "\u2562"),
        _Utils_Tuple2('boxVL', "\u2563"),
        _Utils_Tuple2('boxvr', "\u251C"),
        _Utils_Tuple2('boxvR', "\u255E"),
        _Utils_Tuple2('boxVr', "\u255F"),
        _Utils_Tuple2('boxVR', "\u2560"),
        _Utils_Tuple2('bprime', "\u2035"),
        _Utils_Tuple2('breve', "\u02D8"),
        _Utils_Tuple2('Breve', "\u02D8"),
        _Utils_Tuple2('brvbar', "\xa6"),
        _Utils_Tuple2('bscr', '\uD835\uDCB7'),
        _Utils_Tuple2('Bscr', "\u212C"),
        _Utils_Tuple2('bsemi', "\u204F"),
        _Utils_Tuple2('bsim', "\u223D"),
        _Utils_Tuple2('bsime', "\u22CD"),
        _Utils_Tuple2('bsolb', "\u29C5"),
        _Utils_Tuple2('bsol', '\\'),
        _Utils_Tuple2('bsolhsub', "\u27C8"),
        _Utils_Tuple2('bull', "\u2022"),
        _Utils_Tuple2('bullet', "\u2022"),
        _Utils_Tuple2('bump', "\u224E"),
        _Utils_Tuple2('bumpE', "\u2AAE"),
        _Utils_Tuple2('bumpe', "\u224F"),
        _Utils_Tuple2('Bumpeq', "\u224E"),
        _Utils_Tuple2('bumpeq', "\u224F"),
        _Utils_Tuple2('Cacute', "\u0106"),
        _Utils_Tuple2('cacute', "\u0107"),
        _Utils_Tuple2('capand', "\u2A44"),
        _Utils_Tuple2('capbrcup', "\u2A49"),
        _Utils_Tuple2('capcap', "\u2A4B"),
        _Utils_Tuple2('cap', "\u2229"),
        _Utils_Tuple2('Cap', "\u22D2"),
        _Utils_Tuple2('capcup', "\u2A47"),
        _Utils_Tuple2('capdot', "\u2A40"),
        _Utils_Tuple2('CapitalDifferentialD', "\u2145"),
        _Utils_Tuple2('caps', "\u2229\uFE00"),
        _Utils_Tuple2('caret', "\u2041"),
        _Utils_Tuple2('caron', "\u02C7"),
        _Utils_Tuple2('Cayleys', "\u212D"),
        _Utils_Tuple2('ccaps', "\u2A4D"),
        _Utils_Tuple2('Ccaron', "\u010C"),
        _Utils_Tuple2('ccaron', "\u010D"),
        _Utils_Tuple2('Ccedil', "\xc7"),
        _Utils_Tuple2('ccedil', "\xe7"),
        _Utils_Tuple2('Ccirc', "\u0108"),
        _Utils_Tuple2('ccirc', "\u0109"),
        _Utils_Tuple2('Cconint', "\u2230"),
        _Utils_Tuple2('ccups', "\u2A4C"),
        _Utils_Tuple2('ccupssm', "\u2A50"),
        _Utils_Tuple2('Cdot', "\u010A"),
        _Utils_Tuple2('cdot', "\u010B"),
        _Utils_Tuple2('cedil', "\xb8"),
        _Utils_Tuple2('Cedilla', "\xb8"),
        _Utils_Tuple2('cemptyv', "\u29B2"),
        _Utils_Tuple2('cent', "\xa2"),
        _Utils_Tuple2('centerdot', "\xb7"),
        _Utils_Tuple2('CenterDot', "\xb7"),
        _Utils_Tuple2('cfr', '\uD835\uDD20'),
        _Utils_Tuple2('Cfr', "\u212D"),
        _Utils_Tuple2('CHcy', "\u0427"),
        _Utils_Tuple2('chcy', "\u0447"),
        _Utils_Tuple2('check', "\u2713"),
        _Utils_Tuple2('checkmark', "\u2713"),
        _Utils_Tuple2('Chi', "\u03A7"),
        _Utils_Tuple2('chi', "\u03C7"),
        _Utils_Tuple2('circ', "\u02C6"),
        _Utils_Tuple2('circeq', "\u2257"),
        _Utils_Tuple2('circlearrowleft', "\u21BA"),
        _Utils_Tuple2('circlearrowright', "\u21BB"),
        _Utils_Tuple2('circledast', "\u229B"),
        _Utils_Tuple2('circledcirc', "\u229A"),
        _Utils_Tuple2('circleddash', "\u229D"),
        _Utils_Tuple2('CircleDot', "\u2299"),
        _Utils_Tuple2('circledR', "\xae"),
        _Utils_Tuple2('circledS', "\u24C8"),
        _Utils_Tuple2('CircleMinus', "\u2296"),
        _Utils_Tuple2('CirclePlus', "\u2295"),
        _Utils_Tuple2('CircleTimes', "\u2297"),
        _Utils_Tuple2('cir', "\u25CB"),
        _Utils_Tuple2('cirE', "\u29C3"),
        _Utils_Tuple2('cire', "\u2257"),
        _Utils_Tuple2('cirfnint', "\u2A10"),
        _Utils_Tuple2('cirmid', "\u2AEF"),
        _Utils_Tuple2('cirscir', "\u29C2"),
        _Utils_Tuple2('ClockwiseContourIntegral', "\u2232"),
        _Utils_Tuple2('CloseCurlyDoubleQuote', "\u201D"),
        _Utils_Tuple2('CloseCurlyQuote', "\u2019"),
        _Utils_Tuple2('clubs', "\u2663"),
        _Utils_Tuple2('clubsuit', "\u2663"),
        _Utils_Tuple2('colon', ':'),
        _Utils_Tuple2('Colon', "\u2237"),
        _Utils_Tuple2('Colone', "\u2A74"),
        _Utils_Tuple2('colone', "\u2254"),
        _Utils_Tuple2('coloneq', "\u2254"),
        _Utils_Tuple2('comma', ','),
        _Utils_Tuple2('commat', '@'),
        _Utils_Tuple2('comp', "\u2201"),
        _Utils_Tuple2('compfn', "\u2218"),
        _Utils_Tuple2('complement', "\u2201"),
        _Utils_Tuple2('complexes', "\u2102"),
        _Utils_Tuple2('cong', "\u2245"),
        _Utils_Tuple2('congdot', "\u2A6D"),
        _Utils_Tuple2('Congruent', "\u2261"),
        _Utils_Tuple2('conint', "\u222E"),
        _Utils_Tuple2('Conint', "\u222F"),
        _Utils_Tuple2('ContourIntegral', "\u222E"),
        _Utils_Tuple2('copf', '\uD835\uDD54'),
        _Utils_Tuple2('Copf', "\u2102"),
        _Utils_Tuple2('coprod', "\u2210"),
        _Utils_Tuple2('Coproduct', "\u2210"),
        _Utils_Tuple2('copy', "\xa9"),
        _Utils_Tuple2('COPY', "\xa9"),
        _Utils_Tuple2('copysr', "\u2117"),
        _Utils_Tuple2('CounterClockwiseContourIntegral', "\u2233"),
        _Utils_Tuple2('crarr', "\u21B5"),
        _Utils_Tuple2('cross', "\u2717"),
        _Utils_Tuple2('Cross', "\u2A2F"),
        _Utils_Tuple2('Cscr', '\uD835\uDC9E'),
        _Utils_Tuple2('cscr', '\uD835\uDCB8'),
        _Utils_Tuple2('csub', "\u2ACF"),
        _Utils_Tuple2('csube', "\u2AD1"),
        _Utils_Tuple2('csup', "\u2AD0"),
        _Utils_Tuple2('csupe', "\u2AD2"),
        _Utils_Tuple2('ctdot', "\u22EF"),
        _Utils_Tuple2('cudarrl', "\u2938"),
        _Utils_Tuple2('cudarrr', "\u2935"),
        _Utils_Tuple2('cuepr', "\u22DE"),
        _Utils_Tuple2('cuesc', "\u22DF"),
        _Utils_Tuple2('cularr', "\u21B6"),
        _Utils_Tuple2('cularrp', "\u293D"),
        _Utils_Tuple2('cupbrcap', "\u2A48"),
        _Utils_Tuple2('cupcap', "\u2A46"),
        _Utils_Tuple2('CupCap', "\u224D"),
        _Utils_Tuple2('cup', "\u222A"),
        _Utils_Tuple2('Cup', "\u22D3"),
        _Utils_Tuple2('cupcup', "\u2A4A"),
        _Utils_Tuple2('cupdot', "\u228D"),
        _Utils_Tuple2('cupor', "\u2A45"),
        _Utils_Tuple2('cups', "\u222A\uFE00"),
        _Utils_Tuple2('curarr', "\u21B7"),
        _Utils_Tuple2('curarrm', "\u293C"),
        _Utils_Tuple2('curlyeqprec', "\u22DE"),
        _Utils_Tuple2('curlyeqsucc', "\u22DF"),
        _Utils_Tuple2('curlyvee', "\u22CE"),
        _Utils_Tuple2('curlywedge', "\u22CF"),
        _Utils_Tuple2('curren', "\xa4"),
        _Utils_Tuple2('curvearrowleft', "\u21B6"),
        _Utils_Tuple2('curvearrowright', "\u21B7"),
        _Utils_Tuple2('cuvee', "\u22CE"),
        _Utils_Tuple2('cuwed', "\u22CF"),
        _Utils_Tuple2('cwconint', "\u2232"),
        _Utils_Tuple2('cwint', "\u2231"),
        _Utils_Tuple2('cylcty', "\u232D"),
        _Utils_Tuple2('dagger', "\u2020"),
        _Utils_Tuple2('Dagger', "\u2021"),
        _Utils_Tuple2('daleth', "\u2138"),
        _Utils_Tuple2('darr', "\u2193"),
        _Utils_Tuple2('Darr', "\u21A1"),
        _Utils_Tuple2('dArr', "\u21D3"),
        _Utils_Tuple2('dash', "\u2010"),
        _Utils_Tuple2('Dashv', "\u2AE4"),
        _Utils_Tuple2('dashv', "\u22A3"),
        _Utils_Tuple2('dbkarow', "\u290F"),
        _Utils_Tuple2('dblac', "\u02DD"),
        _Utils_Tuple2('Dcaron', "\u010E"),
        _Utils_Tuple2('dcaron', "\u010F"),
        _Utils_Tuple2('Dcy', "\u0414"),
        _Utils_Tuple2('dcy', "\u0434"),
        _Utils_Tuple2('ddagger', "\u2021"),
        _Utils_Tuple2('ddarr', "\u21CA"),
        _Utils_Tuple2('DD', "\u2145"),
        _Utils_Tuple2('dd', "\u2146"),
        _Utils_Tuple2('DDotrahd', "\u2911"),
        _Utils_Tuple2('ddotseq', "\u2A77"),
        _Utils_Tuple2('deg', "\xb0"),
        _Utils_Tuple2('Del', "\u2207"),
        _Utils_Tuple2('Delta', "\u0394"),
        _Utils_Tuple2('delta', "\u03B4"),
        _Utils_Tuple2('demptyv', "\u29B1"),
        _Utils_Tuple2('dfisht', "\u297F"),
        _Utils_Tuple2('Dfr', '\uD835\uDD07'),
        _Utils_Tuple2('dfr', '\uD835\uDD21'),
        _Utils_Tuple2('dHar', "\u2965"),
        _Utils_Tuple2('dharl', "\u21C3"),
        _Utils_Tuple2('dharr', "\u21C2"),
        _Utils_Tuple2('DiacriticalAcute', "\xb4"),
        _Utils_Tuple2('DiacriticalDot', "\u02D9"),
        _Utils_Tuple2('DiacriticalDoubleAcute', "\u02DD"),
        _Utils_Tuple2('DiacriticalGrave', '`'),
        _Utils_Tuple2('DiacriticalTilde', "\u02DC"),
        _Utils_Tuple2('diam', "\u22C4"),
        _Utils_Tuple2('diamond', "\u22C4"),
        _Utils_Tuple2('Diamond', "\u22C4"),
        _Utils_Tuple2('diamondsuit', "\u2666"),
        _Utils_Tuple2('diams', "\u2666"),
        _Utils_Tuple2('die', "\xa8"),
        _Utils_Tuple2('DifferentialD', "\u2146"),
        _Utils_Tuple2('digamma', "\u03DD"),
        _Utils_Tuple2('disin', "\u22F2"),
        _Utils_Tuple2('div', "\xf7"),
        _Utils_Tuple2('divide', "\xf7"),
        _Utils_Tuple2('divideontimes', "\u22C7"),
        _Utils_Tuple2('divonx', "\u22C7"),
        _Utils_Tuple2('DJcy', "\u0402"),
        _Utils_Tuple2('djcy', "\u0452"),
        _Utils_Tuple2('dlcorn', "\u231E"),
        _Utils_Tuple2('dlcrop', "\u230D"),
        _Utils_Tuple2('dollar', '$'),
        _Utils_Tuple2('Dopf', '\uD835\uDD3B'),
        _Utils_Tuple2('dopf', '\uD835\uDD55'),
        _Utils_Tuple2('Dot', "\xa8"),
        _Utils_Tuple2('dot', "\u02D9"),
        _Utils_Tuple2('DotDot', "\u20DC"),
        _Utils_Tuple2('doteq', "\u2250"),
        _Utils_Tuple2('doteqdot', "\u2251"),
        _Utils_Tuple2('DotEqual', "\u2250"),
        _Utils_Tuple2('dotminus', "\u2238"),
        _Utils_Tuple2('dotplus', "\u2214"),
        _Utils_Tuple2('dotsquare', "\u22A1"),
        _Utils_Tuple2('doublebarwedge', "\u2306"),
        _Utils_Tuple2('DoubleContourIntegral', "\u222F"),
        _Utils_Tuple2('DoubleDot', "\xa8"),
        _Utils_Tuple2('DoubleDownArrow', "\u21D3"),
        _Utils_Tuple2('DoubleLeftArrow', "\u21D0"),
        _Utils_Tuple2('DoubleLeftRightArrow', "\u21D4"),
        _Utils_Tuple2('DoubleLeftTee', "\u2AE4"),
        _Utils_Tuple2('DoubleLongLeftArrow', "\u27F8"),
        _Utils_Tuple2('DoubleLongLeftRightArrow', "\u27FA"),
        _Utils_Tuple2('DoubleLongRightArrow', "\u27F9"),
        _Utils_Tuple2('DoubleRightArrow', "\u21D2"),
        _Utils_Tuple2('DoubleRightTee', "\u22A8"),
        _Utils_Tuple2('DoubleUpArrow', "\u21D1"),
        _Utils_Tuple2('DoubleUpDownArrow', "\u21D5"),
        _Utils_Tuple2('DoubleVerticalBar', "\u2225"),
        _Utils_Tuple2('DownArrowBar', "\u2913"),
        _Utils_Tuple2('downarrow', "\u2193"),
        _Utils_Tuple2('DownArrow', "\u2193"),
        _Utils_Tuple2('Downarrow', "\u21D3"),
        _Utils_Tuple2('DownArrowUpArrow', "\u21F5"),
        _Utils_Tuple2('DownBreve', "\u0311"),
        _Utils_Tuple2('downdownarrows', "\u21CA"),
        _Utils_Tuple2('downharpoonleft', "\u21C3"),
        _Utils_Tuple2('downharpoonright', "\u21C2"),
        _Utils_Tuple2('DownLeftRightVector', "\u2950"),
        _Utils_Tuple2('DownLeftTeeVector', "\u295E"),
        _Utils_Tuple2('DownLeftVectorBar', "\u2956"),
        _Utils_Tuple2('DownLeftVector', "\u21BD"),
        _Utils_Tuple2('DownRightTeeVector', "\u295F"),
        _Utils_Tuple2('DownRightVectorBar', "\u2957"),
        _Utils_Tuple2('DownRightVector', "\u21C1"),
        _Utils_Tuple2('DownTeeArrow', "\u21A7"),
        _Utils_Tuple2('DownTee', "\u22A4"),
        _Utils_Tuple2('drbkarow', "\u2910"),
        _Utils_Tuple2('drcorn', "\u231F"),
        _Utils_Tuple2('drcrop', "\u230C"),
        _Utils_Tuple2('Dscr', '\uD835\uDC9F'),
        _Utils_Tuple2('dscr', '\uD835\uDCB9'),
        _Utils_Tuple2('DScy', "\u0405"),
        _Utils_Tuple2('dscy', "\u0455"),
        _Utils_Tuple2('dsol', "\u29F6"),
        _Utils_Tuple2('Dstrok', "\u0110"),
        _Utils_Tuple2('dstrok', "\u0111"),
        _Utils_Tuple2('dtdot', "\u22F1"),
        _Utils_Tuple2('dtri', "\u25BF"),
        _Utils_Tuple2('dtrif', "\u25BE"),
        _Utils_Tuple2('duarr', "\u21F5"),
        _Utils_Tuple2('duhar', "\u296F"),
        _Utils_Tuple2('dwangle', "\u29A6"),
        _Utils_Tuple2('DZcy', "\u040F"),
        _Utils_Tuple2('dzcy', "\u045F"),
        _Utils_Tuple2('dzigrarr', "\u27FF"),
        _Utils_Tuple2('Eacute', "\xc9"),
        _Utils_Tuple2('eacute', "\xe9"),
        _Utils_Tuple2('easter', "\u2A6E"),
        _Utils_Tuple2('Ecaron', "\u011A"),
        _Utils_Tuple2('ecaron', "\u011B"),
        _Utils_Tuple2('Ecirc', "\xca"),
        _Utils_Tuple2('ecirc', "\xea"),
        _Utils_Tuple2('ecir', "\u2256"),
        _Utils_Tuple2('ecolon', "\u2255"),
        _Utils_Tuple2('Ecy', "\u042D"),
        _Utils_Tuple2('ecy', "\u044D"),
        _Utils_Tuple2('eDDot', "\u2A77"),
        _Utils_Tuple2('Edot', "\u0116"),
        _Utils_Tuple2('edot', "\u0117"),
        _Utils_Tuple2('eDot', "\u2251"),
        _Utils_Tuple2('ee', "\u2147"),
        _Utils_Tuple2('efDot', "\u2252"),
        _Utils_Tuple2('Efr', '\uD835\uDD08'),
        _Utils_Tuple2('efr', '\uD835\uDD22'),
        _Utils_Tuple2('eg', "\u2A9A"),
        _Utils_Tuple2('Egrave', "\xc8"),
        _Utils_Tuple2('egrave', "\xe8"),
        _Utils_Tuple2('egs', "\u2A96"),
        _Utils_Tuple2('egsdot', "\u2A98"),
        _Utils_Tuple2('el', "\u2A99"),
        _Utils_Tuple2('Element', "\u2208"),
        _Utils_Tuple2('elinters', "\u23E7"),
        _Utils_Tuple2('ell', "\u2113"),
        _Utils_Tuple2('els', "\u2A95"),
        _Utils_Tuple2('elsdot', "\u2A97"),
        _Utils_Tuple2('Emacr', "\u0112"),
        _Utils_Tuple2('emacr', "\u0113"),
        _Utils_Tuple2('empty', "\u2205"),
        _Utils_Tuple2('emptyset', "\u2205"),
        _Utils_Tuple2('EmptySmallSquare', "\u25FB"),
        _Utils_Tuple2('emptyv', "\u2205"),
        _Utils_Tuple2('EmptyVerySmallSquare', "\u25AB"),
        _Utils_Tuple2('emsp13', '\u2004'),
        _Utils_Tuple2('emsp14', '\u2005'),
        _Utils_Tuple2('emsp', '\u2003'),
        _Utils_Tuple2('ENG', "\u014A"),
        _Utils_Tuple2('eng', "\u014B"),
        _Utils_Tuple2('ensp', '\u2002'),
        _Utils_Tuple2('Eogon', "\u0118"),
        _Utils_Tuple2('eogon', "\u0119"),
        _Utils_Tuple2('Eopf', '\uD835\uDD3C'),
        _Utils_Tuple2('eopf', '\uD835\uDD56'),
        _Utils_Tuple2('epar', "\u22D5"),
        _Utils_Tuple2('eparsl', "\u29E3"),
        _Utils_Tuple2('eplus', "\u2A71"),
        _Utils_Tuple2('epsi', "\u03B5"),
        _Utils_Tuple2('Epsilon', "\u0395"),
        _Utils_Tuple2('epsilon', "\u03B5"),
        _Utils_Tuple2('epsiv', "\u03F5"),
        _Utils_Tuple2('eqcirc', "\u2256"),
        _Utils_Tuple2('eqcolon', "\u2255"),
        _Utils_Tuple2('eqsim', "\u2242"),
        _Utils_Tuple2('eqslantgtr', "\u2A96"),
        _Utils_Tuple2('eqslantless', "\u2A95"),
        _Utils_Tuple2('Equal', "\u2A75"),
        _Utils_Tuple2('equals', '='),
        _Utils_Tuple2('EqualTilde', "\u2242"),
        _Utils_Tuple2('equest', "\u225F"),
        _Utils_Tuple2('Equilibrium', "\u21CC"),
        _Utils_Tuple2('equiv', "\u2261"),
        _Utils_Tuple2('equivDD', "\u2A78"),
        _Utils_Tuple2('eqvparsl', "\u29E5"),
        _Utils_Tuple2('erarr', "\u2971"),
        _Utils_Tuple2('erDot', "\u2253"),
        _Utils_Tuple2('escr', "\u212F"),
        _Utils_Tuple2('Escr', "\u2130"),
        _Utils_Tuple2('esdot', "\u2250"),
        _Utils_Tuple2('Esim', "\u2A73"),
        _Utils_Tuple2('esim', "\u2242"),
        _Utils_Tuple2('Eta', "\u0397"),
        _Utils_Tuple2('eta', "\u03B7"),
        _Utils_Tuple2('ETH', "\xd0"),
        _Utils_Tuple2('eth', "\xf0"),
        _Utils_Tuple2('Euml', "\xcb"),
        _Utils_Tuple2('euml', "\xeb"),
        _Utils_Tuple2('euro', "\u20AC"),
        _Utils_Tuple2('excl', '!'),
        _Utils_Tuple2('exist', "\u2203"),
        _Utils_Tuple2('Exists', "\u2203"),
        _Utils_Tuple2('expectation', "\u2130"),
        _Utils_Tuple2('exponentiale', "\u2147"),
        _Utils_Tuple2('ExponentialE', "\u2147"),
        _Utils_Tuple2('fallingdotseq', "\u2252"),
        _Utils_Tuple2('Fcy', "\u0424"),
        _Utils_Tuple2('fcy', "\u0444"),
        _Utils_Tuple2('female', "\u2640"),
        _Utils_Tuple2('ffilig', "\uFB03"),
        _Utils_Tuple2('fflig', "\uFB00"),
        _Utils_Tuple2('ffllig', "\uFB04"),
        _Utils_Tuple2('Ffr', '\uD835\uDD09'),
        _Utils_Tuple2('ffr', '\uD835\uDD23'),
        _Utils_Tuple2('filig', "\uFB01"),
        _Utils_Tuple2('FilledSmallSquare', "\u25FC"),
        _Utils_Tuple2('FilledVerySmallSquare', "\u25AA"),
        _Utils_Tuple2('fjlig', 'fj'),
        _Utils_Tuple2('flat', "\u266D"),
        _Utils_Tuple2('fllig', "\uFB02"),
        _Utils_Tuple2('fltns', "\u25B1"),
        _Utils_Tuple2('fnof', "\u0192"),
        _Utils_Tuple2('Fopf', '\uD835\uDD3D'),
        _Utils_Tuple2('fopf', '\uD835\uDD57'),
        _Utils_Tuple2('forall', "\u2200"),
        _Utils_Tuple2('ForAll', "\u2200"),
        _Utils_Tuple2('fork', "\u22D4"),
        _Utils_Tuple2('forkv', "\u2AD9"),
        _Utils_Tuple2('Fouriertrf', "\u2131"),
        _Utils_Tuple2('fpartint', "\u2A0D"),
        _Utils_Tuple2('frac12', "\xbd"),
        _Utils_Tuple2('frac13', "\u2153"),
        _Utils_Tuple2('frac14', "\xbc"),
        _Utils_Tuple2('frac15', "\u2155"),
        _Utils_Tuple2('frac16', "\u2159"),
        _Utils_Tuple2('frac18', "\u215B"),
        _Utils_Tuple2('frac23', "\u2154"),
        _Utils_Tuple2('frac25', "\u2156"),
        _Utils_Tuple2('frac34', "\xbe"),
        _Utils_Tuple2('frac35', "\u2157"),
        _Utils_Tuple2('frac38', "\u215C"),
        _Utils_Tuple2('frac45', "\u2158"),
        _Utils_Tuple2('frac56', "\u215A"),
        _Utils_Tuple2('frac58', "\u215D"),
        _Utils_Tuple2('frac78', "\u215E"),
        _Utils_Tuple2('frasl', "\u2044"),
        _Utils_Tuple2('frown', "\u2322"),
        _Utils_Tuple2('fscr', '\uD835\uDCBB'),
        _Utils_Tuple2('Fscr', "\u2131"),
        _Utils_Tuple2('gacute', "\u01F5"),
        _Utils_Tuple2('Gamma', "\u0393"),
        _Utils_Tuple2('gamma', "\u03B3"),
        _Utils_Tuple2('Gammad', "\u03DC"),
        _Utils_Tuple2('gammad', "\u03DD"),
        _Utils_Tuple2('gap', "\u2A86"),
        _Utils_Tuple2('Gbreve', "\u011E"),
        _Utils_Tuple2('gbreve', "\u011F"),
        _Utils_Tuple2('Gcedil', "\u0122"),
        _Utils_Tuple2('Gcirc', "\u011C"),
        _Utils_Tuple2('gcirc', "\u011D"),
        _Utils_Tuple2('Gcy', "\u0413"),
        _Utils_Tuple2('gcy', "\u0433"),
        _Utils_Tuple2('Gdot', "\u0120"),
        _Utils_Tuple2('gdot', "\u0121"),
        _Utils_Tuple2('ge', "\u2265"),
        _Utils_Tuple2('gE', "\u2267"),
        _Utils_Tuple2('gEl', "\u2A8C"),
        _Utils_Tuple2('gel', "\u22DB"),
        _Utils_Tuple2('geq', "\u2265"),
        _Utils_Tuple2('geqq', "\u2267"),
        _Utils_Tuple2('geqslant', "\u2A7E"),
        _Utils_Tuple2('gescc', "\u2AA9"),
        _Utils_Tuple2('ges', "\u2A7E"),
        _Utils_Tuple2('gesdot', "\u2A80"),
        _Utils_Tuple2('gesdoto', "\u2A82"),
        _Utils_Tuple2('gesdotol', "\u2A84"),
        _Utils_Tuple2('gesl', "\u22DB\uFE00"),
        _Utils_Tuple2('gesles', "\u2A94"),
        _Utils_Tuple2('Gfr', '\uD835\uDD0A'),
        _Utils_Tuple2('gfr', '\uD835\uDD24'),
        _Utils_Tuple2('gg', "\u226B"),
        _Utils_Tuple2('Gg', "\u22D9"),
        _Utils_Tuple2('ggg', "\u22D9"),
        _Utils_Tuple2('gimel', "\u2137"),
        _Utils_Tuple2('GJcy', "\u0403"),
        _Utils_Tuple2('gjcy', "\u0453"),
        _Utils_Tuple2('gla', "\u2AA5"),
        _Utils_Tuple2('gl', "\u2277"),
        _Utils_Tuple2('glE', "\u2A92"),
        _Utils_Tuple2('glj', "\u2AA4"),
        _Utils_Tuple2('gnap', "\u2A8A"),
        _Utils_Tuple2('gnapprox', "\u2A8A"),
        _Utils_Tuple2('gne', "\u2A88"),
        _Utils_Tuple2('gnE', "\u2269"),
        _Utils_Tuple2('gneq', "\u2A88"),
        _Utils_Tuple2('gneqq', "\u2269"),
        _Utils_Tuple2('gnsim', "\u22E7"),
        _Utils_Tuple2('Gopf', '\uD835\uDD3E'),
        _Utils_Tuple2('gopf', '\uD835\uDD58'),
        _Utils_Tuple2('grave', '`'),
        _Utils_Tuple2('GreaterEqual', "\u2265"),
        _Utils_Tuple2('GreaterEqualLess', "\u22DB"),
        _Utils_Tuple2('GreaterFullEqual', "\u2267"),
        _Utils_Tuple2('GreaterGreater', "\u2AA2"),
        _Utils_Tuple2('GreaterLess', "\u2277"),
        _Utils_Tuple2('GreaterSlantEqual', "\u2A7E"),
        _Utils_Tuple2('GreaterTilde', "\u2273"),
        _Utils_Tuple2('Gscr', '\uD835\uDCA2'),
        _Utils_Tuple2('gscr', "\u210A"),
        _Utils_Tuple2('gsim', "\u2273"),
        _Utils_Tuple2('gsime', "\u2A8E"),
        _Utils_Tuple2('gsiml', "\u2A90"),
        _Utils_Tuple2('gtcc', "\u2AA7"),
        _Utils_Tuple2('gtcir', "\u2A7A"),
        _Utils_Tuple2('gt', '>'),
        _Utils_Tuple2('GT', '>'),
        _Utils_Tuple2('Gt', "\u226B"),
        _Utils_Tuple2('gtdot', "\u22D7"),
        _Utils_Tuple2('gtlPar', "\u2995"),
        _Utils_Tuple2('gtquest', "\u2A7C"),
        _Utils_Tuple2('gtrapprox', "\u2A86"),
        _Utils_Tuple2('gtrarr', "\u2978"),
        _Utils_Tuple2('gtrdot', "\u22D7"),
        _Utils_Tuple2('gtreqless', "\u22DB"),
        _Utils_Tuple2('gtreqqless', "\u2A8C"),
        _Utils_Tuple2('gtrless', "\u2277"),
        _Utils_Tuple2('gtrsim', "\u2273"),
        _Utils_Tuple2('gvertneqq', "\u2269\uFE00"),
        _Utils_Tuple2('gvnE', "\u2269\uFE00"),
        _Utils_Tuple2('Hacek', "\u02C7"),
        _Utils_Tuple2('hairsp', '\u200A'),
        _Utils_Tuple2('half', "\xbd"),
        _Utils_Tuple2('hamilt', "\u210B"),
        _Utils_Tuple2('HARDcy', "\u042A"),
        _Utils_Tuple2('hardcy', "\u044A"),
        _Utils_Tuple2('harrcir', "\u2948"),
        _Utils_Tuple2('harr', "\u2194"),
        _Utils_Tuple2('hArr', "\u21D4"),
        _Utils_Tuple2('harrw', "\u21AD"),
        _Utils_Tuple2('Hat', '^'),
        _Utils_Tuple2('hbar', "\u210F"),
        _Utils_Tuple2('Hcirc', "\u0124"),
        _Utils_Tuple2('hcirc', "\u0125"),
        _Utils_Tuple2('hearts', "\u2665"),
        _Utils_Tuple2('heartsuit', "\u2665"),
        _Utils_Tuple2('hellip', "\u2026"),
        _Utils_Tuple2('hercon', "\u22B9"),
        _Utils_Tuple2('hfr', '\uD835\uDD25'),
        _Utils_Tuple2('Hfr', "\u210C"),
        _Utils_Tuple2('HilbertSpace', "\u210B"),
        _Utils_Tuple2('hksearow', "\u2925"),
        _Utils_Tuple2('hkswarow', "\u2926"),
        _Utils_Tuple2('hoarr', "\u21FF"),
        _Utils_Tuple2('homtht', "\u223B"),
        _Utils_Tuple2('hookleftarrow', "\u21A9"),
        _Utils_Tuple2('hookrightarrow', "\u21AA"),
        _Utils_Tuple2('hopf', '\uD835\uDD59'),
        _Utils_Tuple2('Hopf', "\u210D"),
        _Utils_Tuple2('horbar', "\u2015"),
        _Utils_Tuple2('HorizontalLine', "\u2500"),
        _Utils_Tuple2('hscr', '\uD835\uDCBD'),
        _Utils_Tuple2('Hscr', "\u210B"),
        _Utils_Tuple2('hslash', "\u210F"),
        _Utils_Tuple2('Hstrok', "\u0126"),
        _Utils_Tuple2('hstrok', "\u0127"),
        _Utils_Tuple2('HumpDownHump', "\u224E"),
        _Utils_Tuple2('HumpEqual', "\u224F"),
        _Utils_Tuple2('hybull', "\u2043"),
        _Utils_Tuple2('hyphen', "\u2010"),
        _Utils_Tuple2('Iacute', "\xcd"),
        _Utils_Tuple2('iacute', "\xed"),
        _Utils_Tuple2('ic', '\u2063'),
        _Utils_Tuple2('Icirc', "\xce"),
        _Utils_Tuple2('icirc', "\xee"),
        _Utils_Tuple2('Icy', "\u0418"),
        _Utils_Tuple2('icy', "\u0438"),
        _Utils_Tuple2('Idot', "\u0130"),
        _Utils_Tuple2('IEcy', "\u0415"),
        _Utils_Tuple2('iecy', "\u0435"),
        _Utils_Tuple2('iexcl', "\xa1"),
        _Utils_Tuple2('iff', "\u21D4"),
        _Utils_Tuple2('ifr', '\uD835\uDD26'),
        _Utils_Tuple2('Ifr', "\u2111"),
        _Utils_Tuple2('Igrave', "\xcc"),
        _Utils_Tuple2('igrave', "\xec"),
        _Utils_Tuple2('ii', "\u2148"),
        _Utils_Tuple2('iiiint', "\u2A0C"),
        _Utils_Tuple2('iiint', "\u222D"),
        _Utils_Tuple2('iinfin', "\u29DC"),
        _Utils_Tuple2('iiota', "\u2129"),
        _Utils_Tuple2('IJlig', "\u0132"),
        _Utils_Tuple2('ijlig', "\u0133"),
        _Utils_Tuple2('Imacr', "\u012A"),
        _Utils_Tuple2('imacr', "\u012B"),
        _Utils_Tuple2('image', "\u2111"),
        _Utils_Tuple2('ImaginaryI', "\u2148"),
        _Utils_Tuple2('imagline', "\u2110"),
        _Utils_Tuple2('imagpart', "\u2111"),
        _Utils_Tuple2('imath', "\u0131"),
        _Utils_Tuple2('Im', "\u2111"),
        _Utils_Tuple2('imof', "\u22B7"),
        _Utils_Tuple2('imped', "\u01B5"),
        _Utils_Tuple2('Implies', "\u21D2"),
        _Utils_Tuple2('incare', "\u2105"),
        _Utils_Tuple2('in', "\u2208"),
        _Utils_Tuple2('infin', "\u221E"),
        _Utils_Tuple2('infintie', "\u29DD"),
        _Utils_Tuple2('inodot', "\u0131"),
        _Utils_Tuple2('intcal', "\u22BA"),
        _Utils_Tuple2('int', "\u222B"),
        _Utils_Tuple2('Int', "\u222C"),
        _Utils_Tuple2('integers', "\u2124"),
        _Utils_Tuple2('Integral', "\u222B"),
        _Utils_Tuple2('intercal', "\u22BA"),
        _Utils_Tuple2('Intersection', "\u22C2"),
        _Utils_Tuple2('intlarhk', "\u2A17"),
        _Utils_Tuple2('intprod', "\u2A3C"),
        _Utils_Tuple2('InvisibleComma', '\u2063'),
        _Utils_Tuple2('InvisibleTimes', '\u2062'),
        _Utils_Tuple2('IOcy', "\u0401"),
        _Utils_Tuple2('iocy', "\u0451"),
        _Utils_Tuple2('Iogon', "\u012E"),
        _Utils_Tuple2('iogon', "\u012F"),
        _Utils_Tuple2('Iopf', '\uD835\uDD40'),
        _Utils_Tuple2('iopf', '\uD835\uDD5A'),
        _Utils_Tuple2('Iota', "\u0399"),
        _Utils_Tuple2('iota', "\u03B9"),
        _Utils_Tuple2('iprod', "\u2A3C"),
        _Utils_Tuple2('iquest', "\xbf"),
        _Utils_Tuple2('iscr', '\uD835\uDCBE'),
        _Utils_Tuple2('Iscr', "\u2110"),
        _Utils_Tuple2('isin', "\u2208"),
        _Utils_Tuple2('isindot', "\u22F5"),
        _Utils_Tuple2('isinE', "\u22F9"),
        _Utils_Tuple2('isins', "\u22F4"),
        _Utils_Tuple2('isinsv', "\u22F3"),
        _Utils_Tuple2('isinv', "\u2208"),
        _Utils_Tuple2('it', '\u2062'),
        _Utils_Tuple2('Itilde', "\u0128"),
        _Utils_Tuple2('itilde', "\u0129"),
        _Utils_Tuple2('Iukcy', "\u0406"),
        _Utils_Tuple2('iukcy', "\u0456"),
        _Utils_Tuple2('Iuml', "\xcf"),
        _Utils_Tuple2('iuml', "\xef"),
        _Utils_Tuple2('Jcirc', "\u0134"),
        _Utils_Tuple2('jcirc', "\u0135"),
        _Utils_Tuple2('Jcy', "\u0419"),
        _Utils_Tuple2('jcy', "\u0439"),
        _Utils_Tuple2('Jfr', '\uD835\uDD0D'),
        _Utils_Tuple2('jfr', '\uD835\uDD27'),
        _Utils_Tuple2('jmath', "\u0237"),
        _Utils_Tuple2('Jopf', '\uD835\uDD41'),
        _Utils_Tuple2('jopf', '\uD835\uDD5B'),
        _Utils_Tuple2('Jscr', '\uD835\uDCA5'),
        _Utils_Tuple2('jscr', '\uD835\uDCBF'),
        _Utils_Tuple2('Jsercy', "\u0408"),
        _Utils_Tuple2('jsercy', "\u0458"),
        _Utils_Tuple2('Jukcy', "\u0404"),
        _Utils_Tuple2('jukcy', "\u0454"),
        _Utils_Tuple2('Kappa', "\u039A"),
        _Utils_Tuple2('kappa', "\u03BA"),
        _Utils_Tuple2('kappav', "\u03F0"),
        _Utils_Tuple2('Kcedil', "\u0136"),
        _Utils_Tuple2('kcedil', "\u0137"),
        _Utils_Tuple2('Kcy', "\u041A"),
        _Utils_Tuple2('kcy', "\u043A"),
        _Utils_Tuple2('Kfr', '\uD835\uDD0E'),
        _Utils_Tuple2('kfr', '\uD835\uDD28'),
        _Utils_Tuple2('kgreen', "\u0138"),
        _Utils_Tuple2('KHcy', "\u0425"),
        _Utils_Tuple2('khcy', "\u0445"),
        _Utils_Tuple2('KJcy', "\u040C"),
        _Utils_Tuple2('kjcy', "\u045C"),
        _Utils_Tuple2('Kopf', '\uD835\uDD42'),
        _Utils_Tuple2('kopf', '\uD835\uDD5C'),
        _Utils_Tuple2('Kscr', '\uD835\uDCA6'),
        _Utils_Tuple2('kscr', '\uD835\uDCC0'),
        _Utils_Tuple2('lAarr', "\u21DA"),
        _Utils_Tuple2('Lacute', "\u0139"),
        _Utils_Tuple2('lacute', "\u013A"),
        _Utils_Tuple2('laemptyv', "\u29B4"),
        _Utils_Tuple2('lagran', "\u2112"),
        _Utils_Tuple2('Lambda', "\u039B"),
        _Utils_Tuple2('lambda', "\u03BB"),
        _Utils_Tuple2('lang', "\u27E8"),
        _Utils_Tuple2('Lang', "\u27EA"),
        _Utils_Tuple2('langd', "\u2991"),
        _Utils_Tuple2('langle', "\u27E8"),
        _Utils_Tuple2('lap', "\u2A85"),
        _Utils_Tuple2('Laplacetrf', "\u2112"),
        _Utils_Tuple2('laquo', "\xab"),
        _Utils_Tuple2('larrb', "\u21E4"),
        _Utils_Tuple2('larrbfs', "\u291F"),
        _Utils_Tuple2('larr', "\u2190"),
        _Utils_Tuple2('Larr', "\u219E"),
        _Utils_Tuple2('lArr', "\u21D0"),
        _Utils_Tuple2('larrfs', "\u291D"),
        _Utils_Tuple2('larrhk', "\u21A9"),
        _Utils_Tuple2('larrlp', "\u21AB"),
        _Utils_Tuple2('larrpl', "\u2939"),
        _Utils_Tuple2('larrsim', "\u2973"),
        _Utils_Tuple2('larrtl', "\u21A2"),
        _Utils_Tuple2('latail', "\u2919"),
        _Utils_Tuple2('lAtail', "\u291B"),
        _Utils_Tuple2('lat', "\u2AAB"),
        _Utils_Tuple2('late', "\u2AAD"),
        _Utils_Tuple2('lates', "\u2AAD\uFE00"),
        _Utils_Tuple2('lbarr', "\u290C"),
        _Utils_Tuple2('lBarr', "\u290E"),
        _Utils_Tuple2('lbbrk', "\u2772"),
        _Utils_Tuple2('lbrace', '{'),
        _Utils_Tuple2('lbrack', '['),
        _Utils_Tuple2('lbrke', "\u298B"),
        _Utils_Tuple2('lbrksld', "\u298F"),
        _Utils_Tuple2('lbrkslu', "\u298D"),
        _Utils_Tuple2('Lcaron', "\u013D"),
        _Utils_Tuple2('lcaron', "\u013E"),
        _Utils_Tuple2('Lcedil', "\u013B"),
        _Utils_Tuple2('lcedil', "\u013C"),
        _Utils_Tuple2('lceil', "\u2308"),
        _Utils_Tuple2('lcub', '{'),
        _Utils_Tuple2('Lcy', "\u041B"),
        _Utils_Tuple2('lcy', "\u043B"),
        _Utils_Tuple2('ldca', "\u2936"),
        _Utils_Tuple2('ldquo', "\u201C"),
        _Utils_Tuple2('ldquor', "\u201E"),
        _Utils_Tuple2('ldrdhar', "\u2967"),
        _Utils_Tuple2('ldrushar', "\u294B"),
        _Utils_Tuple2('ldsh', "\u21B2"),
        _Utils_Tuple2('le', "\u2264"),
        _Utils_Tuple2('lE', "\u2266"),
        _Utils_Tuple2('LeftAngleBracket', "\u27E8"),
        _Utils_Tuple2('LeftArrowBar', "\u21E4"),
        _Utils_Tuple2('leftarrow', "\u2190"),
        _Utils_Tuple2('LeftArrow', "\u2190"),
        _Utils_Tuple2('Leftarrow', "\u21D0"),
        _Utils_Tuple2('LeftArrowRightArrow', "\u21C6"),
        _Utils_Tuple2('leftarrowtail', "\u21A2"),
        _Utils_Tuple2('LeftCeiling', "\u2308"),
        _Utils_Tuple2('LeftDoubleBracket', "\u27E6"),
        _Utils_Tuple2('LeftDownTeeVector', "\u2961"),
        _Utils_Tuple2('LeftDownVectorBar', "\u2959"),
        _Utils_Tuple2('LeftDownVector', "\u21C3"),
        _Utils_Tuple2('LeftFloor', "\u230A"),
        _Utils_Tuple2('leftharpoondown', "\u21BD"),
        _Utils_Tuple2('leftharpoonup', "\u21BC"),
        _Utils_Tuple2('leftleftarrows', "\u21C7"),
        _Utils_Tuple2('leftrightarrow', "\u2194"),
        _Utils_Tuple2('LeftRightArrow', "\u2194"),
        _Utils_Tuple2('Leftrightarrow', "\u21D4"),
        _Utils_Tuple2('leftrightarrows', "\u21C6"),
        _Utils_Tuple2('leftrightharpoons', "\u21CB"),
        _Utils_Tuple2('leftrightsquigarrow', "\u21AD"),
        _Utils_Tuple2('LeftRightVector', "\u294E"),
        _Utils_Tuple2('LeftTeeArrow', "\u21A4"),
        _Utils_Tuple2('LeftTee', "\u22A3"),
        _Utils_Tuple2('LeftTeeVector', "\u295A"),
        _Utils_Tuple2('leftthreetimes', "\u22CB"),
        _Utils_Tuple2('LeftTriangleBar', "\u29CF"),
        _Utils_Tuple2('LeftTriangle', "\u22B2"),
        _Utils_Tuple2('LeftTriangleEqual', "\u22B4"),
        _Utils_Tuple2('LeftUpDownVector', "\u2951"),
        _Utils_Tuple2('LeftUpTeeVector', "\u2960"),
        _Utils_Tuple2('LeftUpVectorBar', "\u2958"),
        _Utils_Tuple2('LeftUpVector', "\u21BF"),
        _Utils_Tuple2('LeftVectorBar', "\u2952"),
        _Utils_Tuple2('LeftVector', "\u21BC"),
        _Utils_Tuple2('lEg', "\u2A8B"),
        _Utils_Tuple2('leg', "\u22DA"),
        _Utils_Tuple2('leq', "\u2264"),
        _Utils_Tuple2('leqq', "\u2266"),
        _Utils_Tuple2('leqslant', "\u2A7D"),
        _Utils_Tuple2('lescc', "\u2AA8"),
        _Utils_Tuple2('les', "\u2A7D"),
        _Utils_Tuple2('lesdot', "\u2A7F"),
        _Utils_Tuple2('lesdoto', "\u2A81"),
        _Utils_Tuple2('lesdotor', "\u2A83"),
        _Utils_Tuple2('lesg', "\u22DA\uFE00"),
        _Utils_Tuple2('lesges', "\u2A93"),
        _Utils_Tuple2('lessapprox', "\u2A85"),
        _Utils_Tuple2('lessdot', "\u22D6"),
        _Utils_Tuple2('lesseqgtr', "\u22DA"),
        _Utils_Tuple2('lesseqqgtr', "\u2A8B"),
        _Utils_Tuple2('LessEqualGreater', "\u22DA"),
        _Utils_Tuple2('LessFullEqual', "\u2266"),
        _Utils_Tuple2('LessGreater', "\u2276"),
        _Utils_Tuple2('lessgtr', "\u2276"),
        _Utils_Tuple2('LessLess', "\u2AA1"),
        _Utils_Tuple2('lesssim', "\u2272"),
        _Utils_Tuple2('LessSlantEqual', "\u2A7D"),
        _Utils_Tuple2('LessTilde', "\u2272"),
        _Utils_Tuple2('lfisht', "\u297C"),
        _Utils_Tuple2('lfloor', "\u230A"),
        _Utils_Tuple2('Lfr', '\uD835\uDD0F'),
        _Utils_Tuple2('lfr', '\uD835\uDD29'),
        _Utils_Tuple2('lg', "\u2276"),
        _Utils_Tuple2('lgE', "\u2A91"),
        _Utils_Tuple2('lHar', "\u2962"),
        _Utils_Tuple2('lhard', "\u21BD"),
        _Utils_Tuple2('lharu', "\u21BC"),
        _Utils_Tuple2('lharul', "\u296A"),
        _Utils_Tuple2('lhblk', "\u2584"),
        _Utils_Tuple2('LJcy', "\u0409"),
        _Utils_Tuple2('ljcy', "\u0459"),
        _Utils_Tuple2('llarr', "\u21C7"),
        _Utils_Tuple2('ll', "\u226A"),
        _Utils_Tuple2('Ll', "\u22D8"),
        _Utils_Tuple2('llcorner', "\u231E"),
        _Utils_Tuple2('Lleftarrow', "\u21DA"),
        _Utils_Tuple2('llhard', "\u296B"),
        _Utils_Tuple2('lltri', "\u25FA"),
        _Utils_Tuple2('Lmidot', "\u013F"),
        _Utils_Tuple2('lmidot', "\u0140"),
        _Utils_Tuple2('lmoustache', "\u23B0"),
        _Utils_Tuple2('lmoust', "\u23B0"),
        _Utils_Tuple2('lnap', "\u2A89"),
        _Utils_Tuple2('lnapprox', "\u2A89"),
        _Utils_Tuple2('lne', "\u2A87"),
        _Utils_Tuple2('lnE', "\u2268"),
        _Utils_Tuple2('lneq', "\u2A87"),
        _Utils_Tuple2('lneqq', "\u2268"),
        _Utils_Tuple2('lnsim', "\u22E6"),
        _Utils_Tuple2('loang', "\u27EC"),
        _Utils_Tuple2('loarr', "\u21FD"),
        _Utils_Tuple2('lobrk', "\u27E6"),
        _Utils_Tuple2('longleftarrow', "\u27F5"),
        _Utils_Tuple2('LongLeftArrow', "\u27F5"),
        _Utils_Tuple2('Longleftarrow', "\u27F8"),
        _Utils_Tuple2('longleftrightarrow', "\u27F7"),
        _Utils_Tuple2('LongLeftRightArrow', "\u27F7"),
        _Utils_Tuple2('Longleftrightarrow', "\u27FA"),
        _Utils_Tuple2('longmapsto', "\u27FC"),
        _Utils_Tuple2('longrightarrow', "\u27F6"),
        _Utils_Tuple2('LongRightArrow', "\u27F6"),
        _Utils_Tuple2('Longrightarrow', "\u27F9"),
        _Utils_Tuple2('looparrowleft', "\u21AB"),
        _Utils_Tuple2('looparrowright', "\u21AC"),
        _Utils_Tuple2('lopar', "\u2985"),
        _Utils_Tuple2('Lopf', '\uD835\uDD43'),
        _Utils_Tuple2('lopf', '\uD835\uDD5D'),
        _Utils_Tuple2('loplus', "\u2A2D"),
        _Utils_Tuple2('lotimes', "\u2A34"),
        _Utils_Tuple2('lowast', "\u2217"),
        _Utils_Tuple2('lowbar', '_'),
        _Utils_Tuple2('LowerLeftArrow', "\u2199"),
        _Utils_Tuple2('LowerRightArrow', "\u2198"),
        _Utils_Tuple2('loz', "\u25CA"),
        _Utils_Tuple2('lozenge', "\u25CA"),
        _Utils_Tuple2('lozf', "\u29EB"),
        _Utils_Tuple2('lpar', '('),
        _Utils_Tuple2('lparlt', "\u2993"),
        _Utils_Tuple2('lrarr', "\u21C6"),
        _Utils_Tuple2('lrcorner', "\u231F"),
        _Utils_Tuple2('lrhar', "\u21CB"),
        _Utils_Tuple2('lrhard', "\u296D"),
        _Utils_Tuple2('lrm', '\u200E'),
        _Utils_Tuple2('lrtri', "\u22BF"),
        _Utils_Tuple2('lsaquo', "\u2039"),
        _Utils_Tuple2('lscr', '\uD835\uDCC1'),
        _Utils_Tuple2('Lscr', "\u2112"),
        _Utils_Tuple2('lsh', "\u21B0"),
        _Utils_Tuple2('Lsh', "\u21B0"),
        _Utils_Tuple2('lsim', "\u2272"),
        _Utils_Tuple2('lsime', "\u2A8D"),
        _Utils_Tuple2('lsimg', "\u2A8F"),
        _Utils_Tuple2('lsqb', '['),
        _Utils_Tuple2('lsquo', "\u2018"),
        _Utils_Tuple2('lsquor', "\u201A"),
        _Utils_Tuple2('Lstrok', "\u0141"),
        _Utils_Tuple2('lstrok', "\u0142"),
        _Utils_Tuple2('ltcc', "\u2AA6"),
        _Utils_Tuple2('ltcir', "\u2A79"),
        _Utils_Tuple2('lt', '<'),
        _Utils_Tuple2('LT', '<'),
        _Utils_Tuple2('Lt', "\u226A"),
        _Utils_Tuple2('ltdot', "\u22D6"),
        _Utils_Tuple2('lthree', "\u22CB"),
        _Utils_Tuple2('ltimes', "\u22C9"),
        _Utils_Tuple2('ltlarr', "\u2976"),
        _Utils_Tuple2('ltquest', "\u2A7B"),
        _Utils_Tuple2('ltri', "\u25C3"),
        _Utils_Tuple2('ltrie', "\u22B4"),
        _Utils_Tuple2('ltrif', "\u25C2"),
        _Utils_Tuple2('ltrPar', "\u2996"),
        _Utils_Tuple2('lurdshar', "\u294A"),
        _Utils_Tuple2('luruhar', "\u2966"),
        _Utils_Tuple2('lvertneqq', "\u2268\uFE00"),
        _Utils_Tuple2('lvnE', "\u2268\uFE00"),
        _Utils_Tuple2('macr', "\xaf"),
        _Utils_Tuple2('male', "\u2642"),
        _Utils_Tuple2('malt', "\u2720"),
        _Utils_Tuple2('maltese', "\u2720"),
        _Utils_Tuple2('Map', "\u2905"),
        _Utils_Tuple2('map', "\u21A6"),
        _Utils_Tuple2('mapsto', "\u21A6"),
        _Utils_Tuple2('mapstodown', "\u21A7"),
        _Utils_Tuple2('mapstoleft', "\u21A4"),
        _Utils_Tuple2('mapstoup', "\u21A5"),
        _Utils_Tuple2('marker', "\u25AE"),
        _Utils_Tuple2('mcomma', "\u2A29"),
        _Utils_Tuple2('Mcy', "\u041C"),
        _Utils_Tuple2('mcy', "\u043C"),
        _Utils_Tuple2('mdash', "\u2014"),
        _Utils_Tuple2('mDDot', "\u223A"),
        _Utils_Tuple2('measuredangle', "\u2221"),
        _Utils_Tuple2('MediumSpace', '\u205F'),
        _Utils_Tuple2('Mellintrf', "\u2133"),
        _Utils_Tuple2('Mfr', '\uD835\uDD10'),
        _Utils_Tuple2('mfr', '\uD835\uDD2A'),
        _Utils_Tuple2('mho', "\u2127"),
        _Utils_Tuple2('micro', "\xb5"),
        _Utils_Tuple2('midast', '*'),
        _Utils_Tuple2('midcir', "\u2AF0"),
        _Utils_Tuple2('mid', "\u2223"),
        _Utils_Tuple2('middot', "\xb7"),
        _Utils_Tuple2('minusb', "\u229F"),
        _Utils_Tuple2('minus', "\u2212"),
        _Utils_Tuple2('minusd', "\u2238"),
        _Utils_Tuple2('minusdu', "\u2A2A"),
        _Utils_Tuple2('MinusPlus', "\u2213"),
        _Utils_Tuple2('mlcp', "\u2ADB"),
        _Utils_Tuple2('mldr', "\u2026"),
        _Utils_Tuple2('mnplus', "\u2213"),
        _Utils_Tuple2('models', "\u22A7"),
        _Utils_Tuple2('Mopf', '\uD835\uDD44'),
        _Utils_Tuple2('mopf', '\uD835\uDD5E'),
        _Utils_Tuple2('mp', "\u2213"),
        _Utils_Tuple2('mscr', '\uD835\uDCC2'),
        _Utils_Tuple2('Mscr', "\u2133"),
        _Utils_Tuple2('mstpos', "\u223E"),
        _Utils_Tuple2('Mu', "\u039C"),
        _Utils_Tuple2('mu', "\u03BC"),
        _Utils_Tuple2('multimap', "\u22B8"),
        _Utils_Tuple2('mumap', "\u22B8"),
        _Utils_Tuple2('nabla', "\u2207"),
        _Utils_Tuple2('Nacute', "\u0143"),
        _Utils_Tuple2('nacute', "\u0144"),
        _Utils_Tuple2('nang', "\u2220\u20D2"),
        _Utils_Tuple2('nap', "\u2249"),
        _Utils_Tuple2('napE', "\u2A70\u0338"),
        _Utils_Tuple2('napid', "\u224B\u0338"),
        _Utils_Tuple2('napos', "\u0149"),
        _Utils_Tuple2('napprox', "\u2249"),
        _Utils_Tuple2('natural', "\u266E"),
        _Utils_Tuple2('naturals', "\u2115"),
        _Utils_Tuple2('natur', "\u266E"),
        _Utils_Tuple2('nbsp', '\u00A0'),
        _Utils_Tuple2('nbump', "\u224E\u0338"),
        _Utils_Tuple2('nbumpe', "\u224F\u0338"),
        _Utils_Tuple2('ncap', "\u2A43"),
        _Utils_Tuple2('Ncaron', "\u0147"),
        _Utils_Tuple2('ncaron', "\u0148"),
        _Utils_Tuple2('Ncedil', "\u0145"),
        _Utils_Tuple2('ncedil', "\u0146"),
        _Utils_Tuple2('ncong', "\u2247"),
        _Utils_Tuple2('ncongdot', "\u2A6D\u0338"),
        _Utils_Tuple2('ncup', "\u2A42"),
        _Utils_Tuple2('Ncy', "\u041D"),
        _Utils_Tuple2('ncy', "\u043D"),
        _Utils_Tuple2('ndash', "\u2013"),
        _Utils_Tuple2('nearhk', "\u2924"),
        _Utils_Tuple2('nearr', "\u2197"),
        _Utils_Tuple2('neArr', "\u21D7"),
        _Utils_Tuple2('nearrow', "\u2197"),
        _Utils_Tuple2('ne', "\u2260"),
        _Utils_Tuple2('nedot', "\u2250\u0338"),
        _Utils_Tuple2('NegativeMediumSpace', '\u200B'),
        _Utils_Tuple2('NegativeThickSpace', '\u200B'),
        _Utils_Tuple2('NegativeThinSpace', '\u200B'),
        _Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
        _Utils_Tuple2('nequiv', "\u2262"),
        _Utils_Tuple2('nesear', "\u2928"),
        _Utils_Tuple2('nesim', "\u2242\u0338"),
        _Utils_Tuple2('NestedGreaterGreater', "\u226B"),
        _Utils_Tuple2('NestedLessLess', "\u226A"),
        _Utils_Tuple2('NewLine', '\n'),
        _Utils_Tuple2('nexist', "\u2204"),
        _Utils_Tuple2('nexists', "\u2204"),
        _Utils_Tuple2('Nfr', '\uD835\uDD11'),
        _Utils_Tuple2('nfr', '\uD835\uDD2B'),
        _Utils_Tuple2('ngE', "\u2267\u0338"),
        _Utils_Tuple2('nge', "\u2271"),
        _Utils_Tuple2('ngeq', "\u2271"),
        _Utils_Tuple2('ngeqq', "\u2267\u0338"),
        _Utils_Tuple2('ngeqslant', "\u2A7E\u0338"),
        _Utils_Tuple2('nges', "\u2A7E\u0338"),
        _Utils_Tuple2('nGg', "\u22D9\u0338"),
        _Utils_Tuple2('ngsim', "\u2275"),
        _Utils_Tuple2('nGt', "\u226B\u20D2"),
        _Utils_Tuple2('ngt', "\u226F"),
        _Utils_Tuple2('ngtr', "\u226F"),
        _Utils_Tuple2('nGtv', "\u226B\u0338"),
        _Utils_Tuple2('nharr', "\u21AE"),
        _Utils_Tuple2('nhArr', "\u21CE"),
        _Utils_Tuple2('nhpar', "\u2AF2"),
        _Utils_Tuple2('ni', "\u220B"),
        _Utils_Tuple2('nis', "\u22FC"),
        _Utils_Tuple2('nisd', "\u22FA"),
        _Utils_Tuple2('niv', "\u220B"),
        _Utils_Tuple2('NJcy', "\u040A"),
        _Utils_Tuple2('njcy', "\u045A"),
        _Utils_Tuple2('nlarr', "\u219A"),
        _Utils_Tuple2('nlArr', "\u21CD"),
        _Utils_Tuple2('nldr', "\u2025"),
        _Utils_Tuple2('nlE', "\u2266\u0338"),
        _Utils_Tuple2('nle', "\u2270"),
        _Utils_Tuple2('nleftarrow', "\u219A"),
        _Utils_Tuple2('nLeftarrow', "\u21CD"),
        _Utils_Tuple2('nleftrightarrow', "\u21AE"),
        _Utils_Tuple2('nLeftrightarrow', "\u21CE"),
        _Utils_Tuple2('nleq', "\u2270"),
        _Utils_Tuple2('nleqq', "\u2266\u0338"),
        _Utils_Tuple2('nleqslant', "\u2A7D\u0338"),
        _Utils_Tuple2('nles', "\u2A7D\u0338"),
        _Utils_Tuple2('nless', "\u226E"),
        _Utils_Tuple2('nLl', "\u22D8\u0338"),
        _Utils_Tuple2('nlsim', "\u2274"),
        _Utils_Tuple2('nLt', "\u226A\u20D2"),
        _Utils_Tuple2('nlt', "\u226E"),
        _Utils_Tuple2('nltri', "\u22EA"),
        _Utils_Tuple2('nltrie', "\u22EC"),
        _Utils_Tuple2('nLtv', "\u226A\u0338"),
        _Utils_Tuple2('nmid', "\u2224"),
        _Utils_Tuple2('NoBreak', '\u2060'),
        _Utils_Tuple2('NonBreakingSpace', '\u00A0'),
        _Utils_Tuple2('nopf', '\uD835\uDD5F'),
        _Utils_Tuple2('Nopf', "\u2115"),
        _Utils_Tuple2('Not', "\u2AEC"),
        _Utils_Tuple2('not', "\xac"),
        _Utils_Tuple2('NotCongruent', "\u2262"),
        _Utils_Tuple2('NotCupCap', "\u226D"),
        _Utils_Tuple2('NotDoubleVerticalBar', "\u2226"),
        _Utils_Tuple2('NotElement', "\u2209"),
        _Utils_Tuple2('NotEqual', "\u2260"),
        _Utils_Tuple2('NotEqualTilde', "\u2242\u0338"),
        _Utils_Tuple2('NotExists', "\u2204"),
        _Utils_Tuple2('NotGreater', "\u226F"),
        _Utils_Tuple2('NotGreaterEqual', "\u2271"),
        _Utils_Tuple2('NotGreaterFullEqual', "\u2267\u0338"),
        _Utils_Tuple2('NotGreaterGreater', "\u226B\u0338"),
        _Utils_Tuple2('NotGreaterLess', "\u2279"),
        _Utils_Tuple2('NotGreaterSlantEqual', "\u2A7E\u0338"),
        _Utils_Tuple2('NotGreaterTilde', "\u2275"),
        _Utils_Tuple2('NotHumpDownHump', "\u224E\u0338"),
        _Utils_Tuple2('NotHumpEqual', "\u224F\u0338"),
        _Utils_Tuple2('notin', "\u2209"),
        _Utils_Tuple2('notindot', "\u22F5\u0338"),
        _Utils_Tuple2('notinE', "\u22F9\u0338"),
        _Utils_Tuple2('notinva', "\u2209"),
        _Utils_Tuple2('notinvb', "\u22F7"),
        _Utils_Tuple2('notinvc', "\u22F6"),
        _Utils_Tuple2('NotLeftTriangleBar', "\u29CF\u0338"),
        _Utils_Tuple2('NotLeftTriangle', "\u22EA"),
        _Utils_Tuple2('NotLeftTriangleEqual', "\u22EC"),
        _Utils_Tuple2('NotLess', "\u226E"),
        _Utils_Tuple2('NotLessEqual', "\u2270"),
        _Utils_Tuple2('NotLessGreater', "\u2278"),
        _Utils_Tuple2('NotLessLess', "\u226A\u0338"),
        _Utils_Tuple2('NotLessSlantEqual', "\u2A7D\u0338"),
        _Utils_Tuple2('NotLessTilde', "\u2274"),
        _Utils_Tuple2('NotNestedGreaterGreater', "\u2AA2\u0338"),
        _Utils_Tuple2('NotNestedLessLess', "\u2AA1\u0338"),
        _Utils_Tuple2('notni', "\u220C"),
        _Utils_Tuple2('notniva', "\u220C"),
        _Utils_Tuple2('notnivb', "\u22FE"),
        _Utils_Tuple2('notnivc', "\u22FD"),
        _Utils_Tuple2('NotPrecedes', "\u2280"),
        _Utils_Tuple2('NotPrecedesEqual', "\u2AAF\u0338"),
        _Utils_Tuple2('NotPrecedesSlantEqual', "\u22E0"),
        _Utils_Tuple2('NotReverseElement', "\u220C"),
        _Utils_Tuple2('NotRightTriangleBar', "\u29D0\u0338"),
        _Utils_Tuple2('NotRightTriangle', "\u22EB"),
        _Utils_Tuple2('NotRightTriangleEqual', "\u22ED"),
        _Utils_Tuple2('NotSquareSubset', "\u228F\u0338"),
        _Utils_Tuple2('NotSquareSubsetEqual', "\u22E2"),
        _Utils_Tuple2('NotSquareSuperset', "\u2290\u0338"),
        _Utils_Tuple2('NotSquareSupersetEqual', "\u22E3"),
        _Utils_Tuple2('NotSubset', "\u2282\u20D2"),
        _Utils_Tuple2('NotSubsetEqual', "\u2288"),
        _Utils_Tuple2('NotSucceeds', "\u2281"),
        _Utils_Tuple2('NotSucceedsEqual', "\u2AB0\u0338"),
        _Utils_Tuple2('NotSucceedsSlantEqual', "\u22E1"),
        _Utils_Tuple2('NotSucceedsTilde', "\u227F\u0338"),
        _Utils_Tuple2('NotSuperset', "\u2283\u20D2"),
        _Utils_Tuple2('NotSupersetEqual', "\u2289"),
        _Utils_Tuple2('NotTilde', "\u2241"),
        _Utils_Tuple2('NotTildeEqual', "\u2244"),
        _Utils_Tuple2('NotTildeFullEqual', "\u2247"),
        _Utils_Tuple2('NotTildeTilde', "\u2249"),
        _Utils_Tuple2('NotVerticalBar', "\u2224"),
        _Utils_Tuple2('nparallel', "\u2226"),
        _Utils_Tuple2('npar', "\u2226"),
        _Utils_Tuple2('nparsl', "\u2AFD\u20E5"),
        _Utils_Tuple2('npart', "\u2202\u0338"),
        _Utils_Tuple2('npolint', "\u2A14"),
        _Utils_Tuple2('npr', "\u2280"),
        _Utils_Tuple2('nprcue', "\u22E0"),
        _Utils_Tuple2('nprec', "\u2280"),
        _Utils_Tuple2('npreceq', "\u2AAF\u0338"),
        _Utils_Tuple2('npre', "\u2AAF\u0338"),
        _Utils_Tuple2('nrarrc', "\u2933\u0338"),
        _Utils_Tuple2('nrarr', "\u219B"),
        _Utils_Tuple2('nrArr', "\u21CF"),
        _Utils_Tuple2('nrarrw', "\u219D\u0338"),
        _Utils_Tuple2('nrightarrow', "\u219B"),
        _Utils_Tuple2('nRightarrow', "\u21CF"),
        _Utils_Tuple2('nrtri', "\u22EB"),
        _Utils_Tuple2('nrtrie', "\u22ED"),
        _Utils_Tuple2('nsc', "\u2281"),
        _Utils_Tuple2('nsccue', "\u22E1"),
        _Utils_Tuple2('nsce', "\u2AB0\u0338"),
        _Utils_Tuple2('Nscr', '\uD835\uDCA9'),
        _Utils_Tuple2('nscr', '\uD835\uDCC3'),
        _Utils_Tuple2('nshortmid', "\u2224"),
        _Utils_Tuple2('nshortparallel', "\u2226"),
        _Utils_Tuple2('nsim', "\u2241"),
        _Utils_Tuple2('nsime', "\u2244"),
        _Utils_Tuple2('nsimeq', "\u2244"),
        _Utils_Tuple2('nsmid', "\u2224"),
        _Utils_Tuple2('nspar', "\u2226"),
        _Utils_Tuple2('nsqsube', "\u22E2"),
        _Utils_Tuple2('nsqsupe', "\u22E3"),
        _Utils_Tuple2('nsub', "\u2284"),
        _Utils_Tuple2('nsubE', "\u2AC5\u0338"),
        _Utils_Tuple2('nsube', "\u2288"),
        _Utils_Tuple2('nsubset', "\u2282\u20D2"),
        _Utils_Tuple2('nsubseteq', "\u2288"),
        _Utils_Tuple2('nsubseteqq', "\u2AC5\u0338"),
        _Utils_Tuple2('nsucc', "\u2281"),
        _Utils_Tuple2('nsucceq', "\u2AB0\u0338"),
        _Utils_Tuple2('nsup', "\u2285"),
        _Utils_Tuple2('nsupE', "\u2AC6\u0338"),
        _Utils_Tuple2('nsupe', "\u2289"),
        _Utils_Tuple2('nsupset', "\u2283\u20D2"),
        _Utils_Tuple2('nsupseteq', "\u2289"),
        _Utils_Tuple2('nsupseteqq', "\u2AC6\u0338"),
        _Utils_Tuple2('ntgl', "\u2279"),
        _Utils_Tuple2('Ntilde', "\xd1"),
        _Utils_Tuple2('ntilde', "\xf1"),
        _Utils_Tuple2('ntlg', "\u2278"),
        _Utils_Tuple2('ntriangleleft', "\u22EA"),
        _Utils_Tuple2('ntrianglelefteq', "\u22EC"),
        _Utils_Tuple2('ntriangleright', "\u22EB"),
        _Utils_Tuple2('ntrianglerighteq', "\u22ED"),
        _Utils_Tuple2('Nu', "\u039D"),
        _Utils_Tuple2('nu', "\u03BD"),
        _Utils_Tuple2('num', '#'),
        _Utils_Tuple2('numero', "\u2116"),
        _Utils_Tuple2('numsp', '\u2007'),
        _Utils_Tuple2('nvap', "\u224D\u20D2"),
        _Utils_Tuple2('nvdash', "\u22AC"),
        _Utils_Tuple2('nvDash', "\u22AD"),
        _Utils_Tuple2('nVdash', "\u22AE"),
        _Utils_Tuple2('nVDash', "\u22AF"),
        _Utils_Tuple2('nvge', "\u2265\u20D2"),
        _Utils_Tuple2('nvgt', ">\u20D2"),
        _Utils_Tuple2('nvHarr', "\u2904"),
        _Utils_Tuple2('nvinfin', "\u29DE"),
        _Utils_Tuple2('nvlArr', "\u2902"),
        _Utils_Tuple2('nvle', "\u2264\u20D2"),
        _Utils_Tuple2('nvlt', "<\u20D2"),
        _Utils_Tuple2('nvltrie', "\u22B4\u20D2"),
        _Utils_Tuple2('nvrArr', "\u2903"),
        _Utils_Tuple2('nvrtrie', "\u22B5\u20D2"),
        _Utils_Tuple2('nvsim', "\u223C\u20D2"),
        _Utils_Tuple2('nwarhk', "\u2923"),
        _Utils_Tuple2('nwarr', "\u2196"),
        _Utils_Tuple2('nwArr', "\u21D6"),
        _Utils_Tuple2('nwarrow', "\u2196"),
        _Utils_Tuple2('nwnear', "\u2927"),
        _Utils_Tuple2('Oacute', "\xd3"),
        _Utils_Tuple2('oacute', "\xf3"),
        _Utils_Tuple2('oast', "\u229B"),
        _Utils_Tuple2('Ocirc', "\xd4"),
        _Utils_Tuple2('ocirc', "\xf4"),
        _Utils_Tuple2('ocir', "\u229A"),
        _Utils_Tuple2('Ocy', "\u041E"),
        _Utils_Tuple2('ocy', "\u043E"),
        _Utils_Tuple2('odash', "\u229D"),
        _Utils_Tuple2('Odblac', "\u0150"),
        _Utils_Tuple2('odblac', "\u0151"),
        _Utils_Tuple2('odiv', "\u2A38"),
        _Utils_Tuple2('odot', "\u2299"),
        _Utils_Tuple2('odsold', "\u29BC"),
        _Utils_Tuple2('OElig', "\u0152"),
        _Utils_Tuple2('oelig', "\u0153"),
        _Utils_Tuple2('ofcir', "\u29BF"),
        _Utils_Tuple2('Ofr', '\uD835\uDD12'),
        _Utils_Tuple2('ofr', '\uD835\uDD2C'),
        _Utils_Tuple2('ogon', "\u02DB"),
        _Utils_Tuple2('Ograve', "\xd2"),
        _Utils_Tuple2('ograve', "\xf2"),
        _Utils_Tuple2('ogt', "\u29C1"),
        _Utils_Tuple2('ohbar', "\u29B5"),
        _Utils_Tuple2('ohm', "\u03A9"),
        _Utils_Tuple2('oint', "\u222E"),
        _Utils_Tuple2('olarr', "\u21BA"),
        _Utils_Tuple2('olcir', "\u29BE"),
        _Utils_Tuple2('olcross', "\u29BB"),
        _Utils_Tuple2('oline', "\u203E"),
        _Utils_Tuple2('olt', "\u29C0"),
        _Utils_Tuple2('Omacr', "\u014C"),
        _Utils_Tuple2('omacr', "\u014D"),
        _Utils_Tuple2('Omega', "\u03A9"),
        _Utils_Tuple2('omega', "\u03C9"),
        _Utils_Tuple2('Omicron', "\u039F"),
        _Utils_Tuple2('omicron', "\u03BF"),
        _Utils_Tuple2('omid', "\u29B6"),
        _Utils_Tuple2('ominus', "\u2296"),
        _Utils_Tuple2('Oopf', '\uD835\uDD46'),
        _Utils_Tuple2('oopf', '\uD835\uDD60'),
        _Utils_Tuple2('opar', "\u29B7"),
        _Utils_Tuple2('OpenCurlyDoubleQuote', "\u201C"),
        _Utils_Tuple2('OpenCurlyQuote', "\u2018"),
        _Utils_Tuple2('operp', "\u29B9"),
        _Utils_Tuple2('oplus', "\u2295"),
        _Utils_Tuple2('orarr', "\u21BB"),
        _Utils_Tuple2('Or', "\u2A54"),
        _Utils_Tuple2('or', "\u2228"),
        _Utils_Tuple2('ord', "\u2A5D"),
        _Utils_Tuple2('order', "\u2134"),
        _Utils_Tuple2('orderof', "\u2134"),
        _Utils_Tuple2('ordf', "\xaa"),
        _Utils_Tuple2('ordm', "\xba"),
        _Utils_Tuple2('origof', "\u22B6"),
        _Utils_Tuple2('oror', "\u2A56"),
        _Utils_Tuple2('orslope', "\u2A57"),
        _Utils_Tuple2('orv', "\u2A5B"),
        _Utils_Tuple2('oS', "\u24C8"),
        _Utils_Tuple2('Oscr', '\uD835\uDCAA'),
        _Utils_Tuple2('oscr', "\u2134"),
        _Utils_Tuple2('Oslash', "\xd8"),
        _Utils_Tuple2('oslash', "\xf8"),
        _Utils_Tuple2('osol', "\u2298"),
        _Utils_Tuple2('Otilde', "\xd5"),
        _Utils_Tuple2('otilde', "\xf5"),
        _Utils_Tuple2('otimesas', "\u2A36"),
        _Utils_Tuple2('Otimes', "\u2A37"),
        _Utils_Tuple2('otimes', "\u2297"),
        _Utils_Tuple2('Ouml', "\xd6"),
        _Utils_Tuple2('ouml', "\xf6"),
        _Utils_Tuple2('ovbar', "\u233D"),
        _Utils_Tuple2('OverBar', "\u203E"),
        _Utils_Tuple2('OverBrace', "\u23DE"),
        _Utils_Tuple2('OverBracket', "\u23B4"),
        _Utils_Tuple2('OverParenthesis', "\u23DC"),
        _Utils_Tuple2('para', "\xb6"),
        _Utils_Tuple2('parallel', "\u2225"),
        _Utils_Tuple2('par', "\u2225"),
        _Utils_Tuple2('parsim', "\u2AF3"),
        _Utils_Tuple2('parsl', "\u2AFD"),
        _Utils_Tuple2('part', "\u2202"),
        _Utils_Tuple2('PartialD', "\u2202"),
        _Utils_Tuple2('Pcy', "\u041F"),
        _Utils_Tuple2('pcy', "\u043F"),
        _Utils_Tuple2('percnt', '%'),
        _Utils_Tuple2('period', '.'),
        _Utils_Tuple2('permil', "\u2030"),
        _Utils_Tuple2('perp', "\u22A5"),
        _Utils_Tuple2('pertenk', "\u2031"),
        _Utils_Tuple2('Pfr', '\uD835\uDD13'),
        _Utils_Tuple2('pfr', '\uD835\uDD2D'),
        _Utils_Tuple2('Phi', "\u03A6"),
        _Utils_Tuple2('phi', "\u03C6"),
        _Utils_Tuple2('phiv', "\u03D5"),
        _Utils_Tuple2('phmmat', "\u2133"),
        _Utils_Tuple2('phone', "\u260E"),
        _Utils_Tuple2('Pi', "\u03A0"),
        _Utils_Tuple2('pi', "\u03C0"),
        _Utils_Tuple2('pitchfork', "\u22D4"),
        _Utils_Tuple2('piv', "\u03D6"),
        _Utils_Tuple2('planck', "\u210F"),
        _Utils_Tuple2('planckh', "\u210E"),
        _Utils_Tuple2('plankv', "\u210F"),
        _Utils_Tuple2('plusacir', "\u2A23"),
        _Utils_Tuple2('plusb', "\u229E"),
        _Utils_Tuple2('pluscir', "\u2A22"),
        _Utils_Tuple2('plus', '+'),
        _Utils_Tuple2('plusdo', "\u2214"),
        _Utils_Tuple2('plusdu', "\u2A25"),
        _Utils_Tuple2('pluse', "\u2A72"),
        _Utils_Tuple2('PlusMinus', "\xb1"),
        _Utils_Tuple2('plusmn', "\xb1"),
        _Utils_Tuple2('plussim', "\u2A26"),
        _Utils_Tuple2('plustwo', "\u2A27"),
        _Utils_Tuple2('pm', "\xb1"),
        _Utils_Tuple2('Poincareplane', "\u210C"),
        _Utils_Tuple2('pointint', "\u2A15"),
        _Utils_Tuple2('popf', '\uD835\uDD61'),
        _Utils_Tuple2('Popf', "\u2119"),
        _Utils_Tuple2('pound', "\xa3"),
        _Utils_Tuple2('prap', "\u2AB7"),
        _Utils_Tuple2('Pr', "\u2ABB"),
        _Utils_Tuple2('pr', "\u227A"),
        _Utils_Tuple2('prcue', "\u227C"),
        _Utils_Tuple2('precapprox', "\u2AB7"),
        _Utils_Tuple2('prec', "\u227A"),
        _Utils_Tuple2('preccurlyeq', "\u227C"),
        _Utils_Tuple2('Precedes', "\u227A"),
        _Utils_Tuple2('PrecedesEqual', "\u2AAF"),
        _Utils_Tuple2('PrecedesSlantEqual', "\u227C"),
        _Utils_Tuple2('PrecedesTilde', "\u227E"),
        _Utils_Tuple2('preceq', "\u2AAF"),
        _Utils_Tuple2('precnapprox', "\u2AB9"),
        _Utils_Tuple2('precneqq', "\u2AB5"),
        _Utils_Tuple2('precnsim', "\u22E8"),
        _Utils_Tuple2('pre', "\u2AAF"),
        _Utils_Tuple2('prE', "\u2AB3"),
        _Utils_Tuple2('precsim', "\u227E"),
        _Utils_Tuple2('prime', "\u2032"),
        _Utils_Tuple2('Prime', "\u2033"),
        _Utils_Tuple2('primes', "\u2119"),
        _Utils_Tuple2('prnap', "\u2AB9"),
        _Utils_Tuple2('prnE', "\u2AB5"),
        _Utils_Tuple2('prnsim', "\u22E8"),
        _Utils_Tuple2('prod', "\u220F"),
        _Utils_Tuple2('Product', "\u220F"),
        _Utils_Tuple2('profalar', "\u232E"),
        _Utils_Tuple2('profline', "\u2312"),
        _Utils_Tuple2('profsurf', "\u2313"),
        _Utils_Tuple2('prop', "\u221D"),
        _Utils_Tuple2('Proportional', "\u221D"),
        _Utils_Tuple2('Proportion', "\u2237"),
        _Utils_Tuple2('propto', "\u221D"),
        _Utils_Tuple2('prsim', "\u227E"),
        _Utils_Tuple2('prurel', "\u22B0"),
        _Utils_Tuple2('Pscr', '\uD835\uDCAB'),
        _Utils_Tuple2('pscr', '\uD835\uDCC5'),
        _Utils_Tuple2('Psi', "\u03A8"),
        _Utils_Tuple2('psi', "\u03C8"),
        _Utils_Tuple2('puncsp', '\u2008'),
        _Utils_Tuple2('Qfr', '\uD835\uDD14'),
        _Utils_Tuple2('qfr', '\uD835\uDD2E'),
        _Utils_Tuple2('qint', "\u2A0C"),
        _Utils_Tuple2('qopf', '\uD835\uDD62'),
        _Utils_Tuple2('Qopf', "\u211A"),
        _Utils_Tuple2('qprime', "\u2057"),
        _Utils_Tuple2('Qscr', '\uD835\uDCAC'),
        _Utils_Tuple2('qscr', '\uD835\uDCC6'),
        _Utils_Tuple2('quaternions', "\u210D"),
        _Utils_Tuple2('quatint', "\u2A16"),
        _Utils_Tuple2('quest', '?'),
        _Utils_Tuple2('questeq', "\u225F"),
        _Utils_Tuple2('quot', '\"'),
        _Utils_Tuple2('QUOT', '\"'),
        _Utils_Tuple2('rAarr', "\u21DB"),
        _Utils_Tuple2('race', "\u223D\u0331"),
        _Utils_Tuple2('Racute', "\u0154"),
        _Utils_Tuple2('racute', "\u0155"),
        _Utils_Tuple2('radic', "\u221A"),
        _Utils_Tuple2('raemptyv', "\u29B3"),
        _Utils_Tuple2('rang', "\u27E9"),
        _Utils_Tuple2('Rang', "\u27EB"),
        _Utils_Tuple2('rangd', "\u2992"),
        _Utils_Tuple2('range', "\u29A5"),
        _Utils_Tuple2('rangle', "\u27E9"),
        _Utils_Tuple2('raquo', "\xbb"),
        _Utils_Tuple2('rarrap', "\u2975"),
        _Utils_Tuple2('rarrb', "\u21E5"),
        _Utils_Tuple2('rarrbfs', "\u2920"),
        _Utils_Tuple2('rarrc', "\u2933"),
        _Utils_Tuple2('rarr', "\u2192"),
        _Utils_Tuple2('Rarr', "\u21A0"),
        _Utils_Tuple2('rArr', "\u21D2"),
        _Utils_Tuple2('rarrfs', "\u291E"),
        _Utils_Tuple2('rarrhk', "\u21AA"),
        _Utils_Tuple2('rarrlp', "\u21AC"),
        _Utils_Tuple2('rarrpl', "\u2945"),
        _Utils_Tuple2('rarrsim', "\u2974"),
        _Utils_Tuple2('Rarrtl', "\u2916"),
        _Utils_Tuple2('rarrtl', "\u21A3"),
        _Utils_Tuple2('rarrw', "\u219D"),
        _Utils_Tuple2('ratail', "\u291A"),
        _Utils_Tuple2('rAtail', "\u291C"),
        _Utils_Tuple2('ratio', "\u2236"),
        _Utils_Tuple2('rationals', "\u211A"),
        _Utils_Tuple2('rbarr', "\u290D"),
        _Utils_Tuple2('rBarr', "\u290F"),
        _Utils_Tuple2('RBarr', "\u2910"),
        _Utils_Tuple2('rbbrk', "\u2773"),
        _Utils_Tuple2('rbrace', '}'),
        _Utils_Tuple2('rbrack', ']'),
        _Utils_Tuple2('rbrke', "\u298C"),
        _Utils_Tuple2('rbrksld', "\u298E"),
        _Utils_Tuple2('rbrkslu', "\u2990"),
        _Utils_Tuple2('Rcaron', "\u0158"),
        _Utils_Tuple2('rcaron', "\u0159"),
        _Utils_Tuple2('Rcedil', "\u0156"),
        _Utils_Tuple2('rcedil', "\u0157"),
        _Utils_Tuple2('rceil', "\u2309"),
        _Utils_Tuple2('rcub', '}'),
        _Utils_Tuple2('Rcy', "\u0420"),
        _Utils_Tuple2('rcy', "\u0440"),
        _Utils_Tuple2('rdca', "\u2937"),
        _Utils_Tuple2('rdldhar', "\u2969"),
        _Utils_Tuple2('rdquo', "\u201D"),
        _Utils_Tuple2('rdquor', "\u201D"),
        _Utils_Tuple2('rdsh', "\u21B3"),
        _Utils_Tuple2('real', "\u211C"),
        _Utils_Tuple2('realine', "\u211B"),
        _Utils_Tuple2('realpart', "\u211C"),
        _Utils_Tuple2('reals', "\u211D"),
        _Utils_Tuple2('Re', "\u211C"),
        _Utils_Tuple2('rect', "\u25AD"),
        _Utils_Tuple2('reg', "\xae"),
        _Utils_Tuple2('REG', "\xae"),
        _Utils_Tuple2('ReverseElement', "\u220B"),
        _Utils_Tuple2('ReverseEquilibrium', "\u21CB"),
        _Utils_Tuple2('ReverseUpEquilibrium', "\u296F"),
        _Utils_Tuple2('rfisht', "\u297D"),
        _Utils_Tuple2('rfloor', "\u230B"),
        _Utils_Tuple2('rfr', '\uD835\uDD2F'),
        _Utils_Tuple2('Rfr', "\u211C"),
        _Utils_Tuple2('rHar', "\u2964"),
        _Utils_Tuple2('rhard', "\u21C1"),
        _Utils_Tuple2('rharu', "\u21C0"),
        _Utils_Tuple2('rharul', "\u296C"),
        _Utils_Tuple2('Rho', "\u03A1"),
        _Utils_Tuple2('rho', "\u03C1"),
        _Utils_Tuple2('rhov', "\u03F1"),
        _Utils_Tuple2('RightAngleBracket', "\u27E9"),
        _Utils_Tuple2('RightArrowBar', "\u21E5"),
        _Utils_Tuple2('rightarrow', "\u2192"),
        _Utils_Tuple2('RightArrow', "\u2192"),
        _Utils_Tuple2('Rightarrow', "\u21D2"),
        _Utils_Tuple2('RightArrowLeftArrow', "\u21C4"),
        _Utils_Tuple2('rightarrowtail', "\u21A3"),
        _Utils_Tuple2('RightCeiling', "\u2309"),
        _Utils_Tuple2('RightDoubleBracket', "\u27E7"),
        _Utils_Tuple2('RightDownTeeVector', "\u295D"),
        _Utils_Tuple2('RightDownVectorBar', "\u2955"),
        _Utils_Tuple2('RightDownVector', "\u21C2"),
        _Utils_Tuple2('RightFloor', "\u230B"),
        _Utils_Tuple2('rightharpoondown', "\u21C1"),
        _Utils_Tuple2('rightharpoonup', "\u21C0"),
        _Utils_Tuple2('rightleftarrows', "\u21C4"),
        _Utils_Tuple2('rightleftharpoons', "\u21CC"),
        _Utils_Tuple2('rightrightarrows', "\u21C9"),
        _Utils_Tuple2('rightsquigarrow', "\u219D"),
        _Utils_Tuple2('RightTeeArrow', "\u21A6"),
        _Utils_Tuple2('RightTee', "\u22A2"),
        _Utils_Tuple2('RightTeeVector', "\u295B"),
        _Utils_Tuple2('rightthreetimes', "\u22CC"),
        _Utils_Tuple2('RightTriangleBar', "\u29D0"),
        _Utils_Tuple2('RightTriangle', "\u22B3"),
        _Utils_Tuple2('RightTriangleEqual', "\u22B5"),
        _Utils_Tuple2('RightUpDownVector', "\u294F"),
        _Utils_Tuple2('RightUpTeeVector', "\u295C"),
        _Utils_Tuple2('RightUpVectorBar', "\u2954"),
        _Utils_Tuple2('RightUpVector', "\u21BE"),
        _Utils_Tuple2('RightVectorBar', "\u2953"),
        _Utils_Tuple2('RightVector', "\u21C0"),
        _Utils_Tuple2('ring', "\u02DA"),
        _Utils_Tuple2('risingdotseq', "\u2253"),
        _Utils_Tuple2('rlarr', "\u21C4"),
        _Utils_Tuple2('rlhar', "\u21CC"),
        _Utils_Tuple2('rlm', '\u200F'),
        _Utils_Tuple2('rmoustache', "\u23B1"),
        _Utils_Tuple2('rmoust', "\u23B1"),
        _Utils_Tuple2('rnmid', "\u2AEE"),
        _Utils_Tuple2('roang', "\u27ED"),
        _Utils_Tuple2('roarr', "\u21FE"),
        _Utils_Tuple2('robrk', "\u27E7"),
        _Utils_Tuple2('ropar', "\u2986"),
        _Utils_Tuple2('ropf', '\uD835\uDD63'),
        _Utils_Tuple2('Ropf', "\u211D"),
        _Utils_Tuple2('roplus', "\u2A2E"),
        _Utils_Tuple2('rotimes', "\u2A35"),
        _Utils_Tuple2('RoundImplies', "\u2970"),
        _Utils_Tuple2('rpar', ')'),
        _Utils_Tuple2('rpargt', "\u2994"),
        _Utils_Tuple2('rppolint', "\u2A12"),
        _Utils_Tuple2('rrarr', "\u21C9"),
        _Utils_Tuple2('Rrightarrow', "\u21DB"),
        _Utils_Tuple2('rsaquo', "\u203A"),
        _Utils_Tuple2('rscr', '\uD835\uDCC7'),
        _Utils_Tuple2('Rscr', "\u211B"),
        _Utils_Tuple2('rsh', "\u21B1"),
        _Utils_Tuple2('Rsh', "\u21B1"),
        _Utils_Tuple2('rsqb', ']'),
        _Utils_Tuple2('rsquo', "\u2019"),
        _Utils_Tuple2('rsquor', "\u2019"),
        _Utils_Tuple2('rthree', "\u22CC"),
        _Utils_Tuple2('rtimes', "\u22CA"),
        _Utils_Tuple2('rtri', "\u25B9"),
        _Utils_Tuple2('rtrie', "\u22B5"),
        _Utils_Tuple2('rtrif', "\u25B8"),
        _Utils_Tuple2('rtriltri', "\u29CE"),
        _Utils_Tuple2('RuleDelayed', "\u29F4"),
        _Utils_Tuple2('ruluhar', "\u2968"),
        _Utils_Tuple2('rx', "\u211E"),
        _Utils_Tuple2('Sacute', "\u015A"),
        _Utils_Tuple2('sacute', "\u015B"),
        _Utils_Tuple2('sbquo', "\u201A"),
        _Utils_Tuple2('scap', "\u2AB8"),
        _Utils_Tuple2('Scaron', "\u0160"),
        _Utils_Tuple2('scaron', "\u0161"),
        _Utils_Tuple2('Sc', "\u2ABC"),
        _Utils_Tuple2('sc', "\u227B"),
        _Utils_Tuple2('sccue', "\u227D"),
        _Utils_Tuple2('sce', "\u2AB0"),
        _Utils_Tuple2('scE', "\u2AB4"),
        _Utils_Tuple2('Scedil', "\u015E"),
        _Utils_Tuple2('scedil', "\u015F"),
        _Utils_Tuple2('Scirc', "\u015C"),
        _Utils_Tuple2('scirc', "\u015D"),
        _Utils_Tuple2('scnap', "\u2ABA"),
        _Utils_Tuple2('scnE', "\u2AB6"),
        _Utils_Tuple2('scnsim', "\u22E9"),
        _Utils_Tuple2('scpolint', "\u2A13"),
        _Utils_Tuple2('scsim', "\u227F"),
        _Utils_Tuple2('Scy', "\u0421"),
        _Utils_Tuple2('scy', "\u0441"),
        _Utils_Tuple2('sdotb', "\u22A1"),
        _Utils_Tuple2('sdot', "\u22C5"),
        _Utils_Tuple2('sdote', "\u2A66"),
        _Utils_Tuple2('searhk', "\u2925"),
        _Utils_Tuple2('searr', "\u2198"),
        _Utils_Tuple2('seArr', "\u21D8"),
        _Utils_Tuple2('searrow', "\u2198"),
        _Utils_Tuple2('sect', "\xa7"),
        _Utils_Tuple2('semi', ';'),
        _Utils_Tuple2('seswar', "\u2929"),
        _Utils_Tuple2('setminus', "\u2216"),
        _Utils_Tuple2('setmn', "\u2216"),
        _Utils_Tuple2('sext', "\u2736"),
        _Utils_Tuple2('Sfr', '\uD835\uDD16'),
        _Utils_Tuple2('sfr', '\uD835\uDD30'),
        _Utils_Tuple2('sfrown', "\u2322"),
        _Utils_Tuple2('sharp', "\u266F"),
        _Utils_Tuple2('SHCHcy', "\u0429"),
        _Utils_Tuple2('shchcy', "\u0449"),
        _Utils_Tuple2('SHcy', "\u0428"),
        _Utils_Tuple2('shcy', "\u0448"),
        _Utils_Tuple2('ShortDownArrow', "\u2193"),
        _Utils_Tuple2('ShortLeftArrow', "\u2190"),
        _Utils_Tuple2('shortmid', "\u2223"),
        _Utils_Tuple2('shortparallel', "\u2225"),
        _Utils_Tuple2('ShortRightArrow', "\u2192"),
        _Utils_Tuple2('ShortUpArrow', "\u2191"),
        _Utils_Tuple2('shy', '\u00AD'),
        _Utils_Tuple2('Sigma', "\u03A3"),
        _Utils_Tuple2('sigma', "\u03C3"),
        _Utils_Tuple2('sigmaf', "\u03C2"),
        _Utils_Tuple2('sigmav', "\u03C2"),
        _Utils_Tuple2('sim', "\u223C"),
        _Utils_Tuple2('simdot', "\u2A6A"),
        _Utils_Tuple2('sime', "\u2243"),
        _Utils_Tuple2('simeq', "\u2243"),
        _Utils_Tuple2('simg', "\u2A9E"),
        _Utils_Tuple2('simgE', "\u2AA0"),
        _Utils_Tuple2('siml', "\u2A9D"),
        _Utils_Tuple2('simlE', "\u2A9F"),
        _Utils_Tuple2('simne', "\u2246"),
        _Utils_Tuple2('simplus', "\u2A24"),
        _Utils_Tuple2('simrarr', "\u2972"),
        _Utils_Tuple2('slarr', "\u2190"),
        _Utils_Tuple2('SmallCircle', "\u2218"),
        _Utils_Tuple2('smallsetminus', "\u2216"),
        _Utils_Tuple2('smashp', "\u2A33"),
        _Utils_Tuple2('smeparsl', "\u29E4"),
        _Utils_Tuple2('smid', "\u2223"),
        _Utils_Tuple2('smile', "\u2323"),
        _Utils_Tuple2('smt', "\u2AAA"),
        _Utils_Tuple2('smte', "\u2AAC"),
        _Utils_Tuple2('smtes', "\u2AAC\uFE00"),
        _Utils_Tuple2('SOFTcy', "\u042C"),
        _Utils_Tuple2('softcy', "\u044C"),
        _Utils_Tuple2('solbar', "\u233F"),
        _Utils_Tuple2('solb', "\u29C4"),
        _Utils_Tuple2('sol', '/'),
        _Utils_Tuple2('Sopf', '\uD835\uDD4A'),
        _Utils_Tuple2('sopf', '\uD835\uDD64'),
        _Utils_Tuple2('spades', "\u2660"),
        _Utils_Tuple2('spadesuit', "\u2660"),
        _Utils_Tuple2('spar', "\u2225"),
        _Utils_Tuple2('sqcap', "\u2293"),
        _Utils_Tuple2('sqcaps', "\u2293\uFE00"),
        _Utils_Tuple2('sqcup', "\u2294"),
        _Utils_Tuple2('sqcups', "\u2294\uFE00"),
        _Utils_Tuple2('Sqrt', "\u221A"),
        _Utils_Tuple2('sqsub', "\u228F"),
        _Utils_Tuple2('sqsube', "\u2291"),
        _Utils_Tuple2('sqsubset', "\u228F"),
        _Utils_Tuple2('sqsubseteq', "\u2291"),
        _Utils_Tuple2('sqsup', "\u2290"),
        _Utils_Tuple2('sqsupe', "\u2292"),
        _Utils_Tuple2('sqsupset', "\u2290"),
        _Utils_Tuple2('sqsupseteq', "\u2292"),
        _Utils_Tuple2('square', "\u25A1"),
        _Utils_Tuple2('Square', "\u25A1"),
        _Utils_Tuple2('SquareIntersection', "\u2293"),
        _Utils_Tuple2('SquareSubset', "\u228F"),
        _Utils_Tuple2('SquareSubsetEqual', "\u2291"),
        _Utils_Tuple2('SquareSuperset', "\u2290"),
        _Utils_Tuple2('SquareSupersetEqual', "\u2292"),
        _Utils_Tuple2('SquareUnion', "\u2294"),
        _Utils_Tuple2('squarf', "\u25AA"),
        _Utils_Tuple2('squ', "\u25A1"),
        _Utils_Tuple2('squf', "\u25AA"),
        _Utils_Tuple2('srarr', "\u2192"),
        _Utils_Tuple2('Sscr', '\uD835\uDCAE'),
        _Utils_Tuple2('sscr', '\uD835\uDCC8'),
        _Utils_Tuple2('ssetmn', "\u2216"),
        _Utils_Tuple2('ssmile', "\u2323"),
        _Utils_Tuple2('sstarf', "\u22C6"),
        _Utils_Tuple2('Star', "\u22C6"),
        _Utils_Tuple2('star', "\u2606"),
        _Utils_Tuple2('starf', "\u2605"),
        _Utils_Tuple2('straightepsilon', "\u03F5"),
        _Utils_Tuple2('straightphi', "\u03D5"),
        _Utils_Tuple2('strns', "\xaf"),
        _Utils_Tuple2('sub', "\u2282"),
        _Utils_Tuple2('Sub', "\u22D0"),
        _Utils_Tuple2('subdot', "\u2ABD"),
        _Utils_Tuple2('subE', "\u2AC5"),
        _Utils_Tuple2('sube', "\u2286"),
        _Utils_Tuple2('subedot', "\u2AC3"),
        _Utils_Tuple2('submult', "\u2AC1"),
        _Utils_Tuple2('subnE', "\u2ACB"),
        _Utils_Tuple2('subne', "\u228A"),
        _Utils_Tuple2('subplus', "\u2ABF"),
        _Utils_Tuple2('subrarr', "\u2979"),
        _Utils_Tuple2('subset', "\u2282"),
        _Utils_Tuple2('Subset', "\u22D0"),
        _Utils_Tuple2('subseteq', "\u2286"),
        _Utils_Tuple2('subseteqq', "\u2AC5"),
        _Utils_Tuple2('SubsetEqual', "\u2286"),
        _Utils_Tuple2('subsetneq', "\u228A"),
        _Utils_Tuple2('subsetneqq', "\u2ACB"),
        _Utils_Tuple2('subsim', "\u2AC7"),
        _Utils_Tuple2('subsub', "\u2AD5"),
        _Utils_Tuple2('subsup', "\u2AD3"),
        _Utils_Tuple2('succapprox', "\u2AB8"),
        _Utils_Tuple2('succ', "\u227B"),
        _Utils_Tuple2('succcurlyeq', "\u227D"),
        _Utils_Tuple2('Succeeds', "\u227B"),
        _Utils_Tuple2('SucceedsEqual', "\u2AB0"),
        _Utils_Tuple2('SucceedsSlantEqual', "\u227D"),
        _Utils_Tuple2('SucceedsTilde', "\u227F"),
        _Utils_Tuple2('succeq', "\u2AB0"),
        _Utils_Tuple2('succnapprox', "\u2ABA"),
        _Utils_Tuple2('succneqq', "\u2AB6"),
        _Utils_Tuple2('succnsim', "\u22E9"),
        _Utils_Tuple2('succsim', "\u227F"),
        _Utils_Tuple2('SuchThat', "\u220B"),
        _Utils_Tuple2('sum', "\u2211"),
        _Utils_Tuple2('Sum', "\u2211"),
        _Utils_Tuple2('sung', "\u266A"),
        _Utils_Tuple2('sup1', "\xb9"),
        _Utils_Tuple2('sup2', "\xb2"),
        _Utils_Tuple2('sup3', "\xb3"),
        _Utils_Tuple2('sup', "\u2283"),
        _Utils_Tuple2('Sup', "\u22D1"),
        _Utils_Tuple2('supdot', "\u2ABE"),
        _Utils_Tuple2('supdsub', "\u2AD8"),
        _Utils_Tuple2('supE', "\u2AC6"),
        _Utils_Tuple2('supe', "\u2287"),
        _Utils_Tuple2('supedot', "\u2AC4"),
        _Utils_Tuple2('Superset', "\u2283"),
        _Utils_Tuple2('SupersetEqual', "\u2287"),
        _Utils_Tuple2('suphsol', "\u27C9"),
        _Utils_Tuple2('suphsub', "\u2AD7"),
        _Utils_Tuple2('suplarr', "\u297B"),
        _Utils_Tuple2('supmult', "\u2AC2"),
        _Utils_Tuple2('supnE', "\u2ACC"),
        _Utils_Tuple2('supne', "\u228B"),
        _Utils_Tuple2('supplus', "\u2AC0"),
        _Utils_Tuple2('supset', "\u2283"),
        _Utils_Tuple2('Supset', "\u22D1"),
        _Utils_Tuple2('supseteq', "\u2287"),
        _Utils_Tuple2('supseteqq', "\u2AC6"),
        _Utils_Tuple2('supsetneq', "\u228B"),
        _Utils_Tuple2('supsetneqq', "\u2ACC"),
        _Utils_Tuple2('supsim', "\u2AC8"),
        _Utils_Tuple2('supsub', "\u2AD4"),
        _Utils_Tuple2('supsup', "\u2AD6"),
        _Utils_Tuple2('swarhk', "\u2926"),
        _Utils_Tuple2('swarr', "\u2199"),
        _Utils_Tuple2('swArr', "\u21D9"),
        _Utils_Tuple2('swarrow', "\u2199"),
        _Utils_Tuple2('swnwar', "\u292A"),
        _Utils_Tuple2('szlig', "\xdf"),
        _Utils_Tuple2('Tab', '\t'),
        _Utils_Tuple2('target', "\u2316"),
        _Utils_Tuple2('Tau', "\u03A4"),
        _Utils_Tuple2('tau', "\u03C4"),
        _Utils_Tuple2('tbrk', "\u23B4"),
        _Utils_Tuple2('Tcaron', "\u0164"),
        _Utils_Tuple2('tcaron', "\u0165"),
        _Utils_Tuple2('Tcedil', "\u0162"),
        _Utils_Tuple2('tcedil', "\u0163"),
        _Utils_Tuple2('Tcy', "\u0422"),
        _Utils_Tuple2('tcy', "\u0442"),
        _Utils_Tuple2('tdot', "\u20DB"),
        _Utils_Tuple2('telrec', "\u2315"),
        _Utils_Tuple2('Tfr', '\uD835\uDD17'),
        _Utils_Tuple2('tfr', '\uD835\uDD31'),
        _Utils_Tuple2('there4', "\u2234"),
        _Utils_Tuple2('therefore', "\u2234"),
        _Utils_Tuple2('Therefore', "\u2234"),
        _Utils_Tuple2('Theta', "\u0398"),
        _Utils_Tuple2('theta', "\u03B8"),
        _Utils_Tuple2('thetasym', "\u03D1"),
        _Utils_Tuple2('thetav', "\u03D1"),
        _Utils_Tuple2('thickapprox', "\u2248"),
        _Utils_Tuple2('thicksim', "\u223C"),
        _Utils_Tuple2('ThickSpace', '\u205F\u200A'),
        _Utils_Tuple2('ThinSpace', '\u2009'),
        _Utils_Tuple2('thinsp', '\u2009'),
        _Utils_Tuple2('thkap', "\u2248"),
        _Utils_Tuple2('thksim', "\u223C"),
        _Utils_Tuple2('THORN', "\xde"),
        _Utils_Tuple2('thorn', "\xfe"),
        _Utils_Tuple2('tilde', "\u02DC"),
        _Utils_Tuple2('Tilde', "\u223C"),
        _Utils_Tuple2('TildeEqual', "\u2243"),
        _Utils_Tuple2('TildeFullEqual', "\u2245"),
        _Utils_Tuple2('TildeTilde', "\u2248"),
        _Utils_Tuple2('timesbar', "\u2A31"),
        _Utils_Tuple2('timesb', "\u22A0"),
        _Utils_Tuple2('times', "\xd7"),
        _Utils_Tuple2('timesd', "\u2A30"),
        _Utils_Tuple2('tint', "\u222D"),
        _Utils_Tuple2('toea', "\u2928"),
        _Utils_Tuple2('topbot', "\u2336"),
        _Utils_Tuple2('topcir', "\u2AF1"),
        _Utils_Tuple2('top', "\u22A4"),
        _Utils_Tuple2('Topf', '\uD835\uDD4B'),
        _Utils_Tuple2('topf', '\uD835\uDD65'),
        _Utils_Tuple2('topfork', "\u2ADA"),
        _Utils_Tuple2('tosa', "\u2929"),
        _Utils_Tuple2('tprime', "\u2034"),
        _Utils_Tuple2('trade', "\u2122"),
        _Utils_Tuple2('TRADE', "\u2122"),
        _Utils_Tuple2('triangle', "\u25B5"),
        _Utils_Tuple2('triangledown', "\u25BF"),
        _Utils_Tuple2('triangleleft', "\u25C3"),
        _Utils_Tuple2('trianglelefteq', "\u22B4"),
        _Utils_Tuple2('triangleq', "\u225C"),
        _Utils_Tuple2('triangleright', "\u25B9"),
        _Utils_Tuple2('trianglerighteq', "\u22B5"),
        _Utils_Tuple2('tridot', "\u25EC"),
        _Utils_Tuple2('trie', "\u225C"),
        _Utils_Tuple2('triminus', "\u2A3A"),
        _Utils_Tuple2('TripleDot', "\u20DB"),
        _Utils_Tuple2('triplus', "\u2A39"),
        _Utils_Tuple2('trisb', "\u29CD"),
        _Utils_Tuple2('tritime', "\u2A3B"),
        _Utils_Tuple2('trpezium', "\u23E2"),
        _Utils_Tuple2('Tscr', '\uD835\uDCAF'),
        _Utils_Tuple2('tscr', '\uD835\uDCC9'),
        _Utils_Tuple2('TScy', "\u0426"),
        _Utils_Tuple2('tscy', "\u0446"),
        _Utils_Tuple2('TSHcy', "\u040B"),
        _Utils_Tuple2('tshcy', "\u045B"),
        _Utils_Tuple2('Tstrok', "\u0166"),
        _Utils_Tuple2('tstrok', "\u0167"),
        _Utils_Tuple2('twixt', "\u226C"),
        _Utils_Tuple2('twoheadleftarrow', "\u219E"),
        _Utils_Tuple2('twoheadrightarrow', "\u21A0"),
        _Utils_Tuple2('Uacute', "\xda"),
        _Utils_Tuple2('uacute', "\xfa"),
        _Utils_Tuple2('uarr', "\u2191"),
        _Utils_Tuple2('Uarr', "\u219F"),
        _Utils_Tuple2('uArr', "\u21D1"),
        _Utils_Tuple2('Uarrocir', "\u2949"),
        _Utils_Tuple2('Ubrcy', "\u040E"),
        _Utils_Tuple2('ubrcy', "\u045E"),
        _Utils_Tuple2('Ubreve', "\u016C"),
        _Utils_Tuple2('ubreve', "\u016D"),
        _Utils_Tuple2('Ucirc', "\xdb"),
        _Utils_Tuple2('ucirc', "\xfb"),
        _Utils_Tuple2('Ucy', "\u0423"),
        _Utils_Tuple2('ucy', "\u0443"),
        _Utils_Tuple2('udarr', "\u21C5"),
        _Utils_Tuple2('Udblac', "\u0170"),
        _Utils_Tuple2('udblac', "\u0171"),
        _Utils_Tuple2('udhar', "\u296E"),
        _Utils_Tuple2('ufisht', "\u297E"),
        _Utils_Tuple2('Ufr', '\uD835\uDD18'),
        _Utils_Tuple2('ufr', '\uD835\uDD32'),
        _Utils_Tuple2('Ugrave', "\xd9"),
        _Utils_Tuple2('ugrave', "\xf9"),
        _Utils_Tuple2('uHar', "\u2963"),
        _Utils_Tuple2('uharl', "\u21BF"),
        _Utils_Tuple2('uharr', "\u21BE"),
        _Utils_Tuple2('uhblk', "\u2580"),
        _Utils_Tuple2('ulcorn', "\u231C"),
        _Utils_Tuple2('ulcorner', "\u231C"),
        _Utils_Tuple2('ulcrop', "\u230F"),
        _Utils_Tuple2('ultri', "\u25F8"),
        _Utils_Tuple2('Umacr', "\u016A"),
        _Utils_Tuple2('umacr', "\u016B"),
        _Utils_Tuple2('uml', "\xa8"),
        _Utils_Tuple2('UnderBar', '_'),
        _Utils_Tuple2('UnderBrace', "\u23DF"),
        _Utils_Tuple2('UnderBracket', "\u23B5"),
        _Utils_Tuple2('UnderParenthesis', "\u23DD"),
        _Utils_Tuple2('Union', "\u22C3"),
        _Utils_Tuple2('UnionPlus', "\u228E"),
        _Utils_Tuple2('Uogon', "\u0172"),
        _Utils_Tuple2('uogon', "\u0173"),
        _Utils_Tuple2('Uopf', '\uD835\uDD4C'),
        _Utils_Tuple2('uopf', '\uD835\uDD66'),
        _Utils_Tuple2('UpArrowBar', "\u2912"),
        _Utils_Tuple2('uparrow', "\u2191"),
        _Utils_Tuple2('UpArrow', "\u2191"),
        _Utils_Tuple2('Uparrow', "\u21D1"),
        _Utils_Tuple2('UpArrowDownArrow', "\u21C5"),
        _Utils_Tuple2('updownarrow', "\u2195"),
        _Utils_Tuple2('UpDownArrow', "\u2195"),
        _Utils_Tuple2('Updownarrow', "\u21D5"),
        _Utils_Tuple2('UpEquilibrium', "\u296E"),
        _Utils_Tuple2('upharpoonleft', "\u21BF"),
        _Utils_Tuple2('upharpoonright', "\u21BE"),
        _Utils_Tuple2('uplus', "\u228E"),
        _Utils_Tuple2('UpperLeftArrow', "\u2196"),
        _Utils_Tuple2('UpperRightArrow', "\u2197"),
        _Utils_Tuple2('upsi', "\u03C5"),
        _Utils_Tuple2('Upsi', "\u03D2"),
        _Utils_Tuple2('upsih', "\u03D2"),
        _Utils_Tuple2('Upsilon', "\u03A5"),
        _Utils_Tuple2('upsilon', "\u03C5"),
        _Utils_Tuple2('UpTeeArrow', "\u21A5"),
        _Utils_Tuple2('UpTee', "\u22A5"),
        _Utils_Tuple2('upuparrows', "\u21C8"),
        _Utils_Tuple2('urcorn', "\u231D"),
        _Utils_Tuple2('urcorner', "\u231D"),
        _Utils_Tuple2('urcrop', "\u230E"),
        _Utils_Tuple2('Uring', "\u016E"),
        _Utils_Tuple2('uring', "\u016F"),
        _Utils_Tuple2('urtri', "\u25F9"),
        _Utils_Tuple2('Uscr', '\uD835\uDCB0'),
        _Utils_Tuple2('uscr', '\uD835\uDCCA'),
        _Utils_Tuple2('utdot', "\u22F0"),
        _Utils_Tuple2('Utilde', "\u0168"),
        _Utils_Tuple2('utilde', "\u0169"),
        _Utils_Tuple2('utri', "\u25B5"),
        _Utils_Tuple2('utrif', "\u25B4"),
        _Utils_Tuple2('uuarr', "\u21C8"),
        _Utils_Tuple2('Uuml', "\xdc"),
        _Utils_Tuple2('uuml', "\xfc"),
        _Utils_Tuple2('uwangle', "\u29A7"),
        _Utils_Tuple2('vangrt', "\u299C"),
        _Utils_Tuple2('varepsilon', "\u03F5"),
        _Utils_Tuple2('varkappa', "\u03F0"),
        _Utils_Tuple2('varnothing', "\u2205"),
        _Utils_Tuple2('varphi', "\u03D5"),
        _Utils_Tuple2('varpi', "\u03D6"),
        _Utils_Tuple2('varpropto', "\u221D"),
        _Utils_Tuple2('varr', "\u2195"),
        _Utils_Tuple2('vArr', "\u21D5"),
        _Utils_Tuple2('varrho', "\u03F1"),
        _Utils_Tuple2('varsigma', "\u03C2"),
        _Utils_Tuple2('varsubsetneq', "\u228A\uFE00"),
        _Utils_Tuple2('varsubsetneqq', "\u2ACB\uFE00"),
        _Utils_Tuple2('varsupsetneq', "\u228B\uFE00"),
        _Utils_Tuple2('varsupsetneqq', "\u2ACC\uFE00"),
        _Utils_Tuple2('vartheta', "\u03D1"),
        _Utils_Tuple2('vartriangleleft', "\u22B2"),
        _Utils_Tuple2('vartriangleright', "\u22B3"),
        _Utils_Tuple2('vBar', "\u2AE8"),
        _Utils_Tuple2('Vbar', "\u2AEB"),
        _Utils_Tuple2('vBarv', "\u2AE9"),
        _Utils_Tuple2('Vcy', "\u0412"),
        _Utils_Tuple2('vcy', "\u0432"),
        _Utils_Tuple2('vdash', "\u22A2"),
        _Utils_Tuple2('vDash', "\u22A8"),
        _Utils_Tuple2('Vdash', "\u22A9"),
        _Utils_Tuple2('VDash', "\u22AB"),
        _Utils_Tuple2('Vdashl', "\u2AE6"),
        _Utils_Tuple2('veebar', "\u22BB"),
        _Utils_Tuple2('vee', "\u2228"),
        _Utils_Tuple2('Vee', "\u22C1"),
        _Utils_Tuple2('veeeq', "\u225A"),
        _Utils_Tuple2('vellip', "\u22EE"),
        _Utils_Tuple2('verbar', '|'),
        _Utils_Tuple2('Verbar', "\u2016"),
        _Utils_Tuple2('vert', '|'),
        _Utils_Tuple2('Vert', "\u2016"),
        _Utils_Tuple2('VerticalBar', "\u2223"),
        _Utils_Tuple2('VerticalLine', '|'),
        _Utils_Tuple2('VerticalSeparator', "\u2758"),
        _Utils_Tuple2('VerticalTilde', "\u2240"),
        _Utils_Tuple2('VeryThinSpace', '\u200A'),
        _Utils_Tuple2('Vfr', '\uD835\uDD19'),
        _Utils_Tuple2('vfr', '\uD835\uDD33'),
        _Utils_Tuple2('vltri', "\u22B2"),
        _Utils_Tuple2('vnsub', "\u2282\u20D2"),
        _Utils_Tuple2('vnsup', "\u2283\u20D2"),
        _Utils_Tuple2('Vopf', '\uD835\uDD4D'),
        _Utils_Tuple2('vopf', '\uD835\uDD67'),
        _Utils_Tuple2('vprop', "\u221D"),
        _Utils_Tuple2('vrtri', "\u22B3"),
        _Utils_Tuple2('Vscr', '\uD835\uDCB1'),
        _Utils_Tuple2('vscr', '\uD835\uDCCB'),
        _Utils_Tuple2('vsubnE', "\u2ACB\uFE00"),
        _Utils_Tuple2('vsubne', "\u228A\uFE00"),
        _Utils_Tuple2('vsupnE', "\u2ACC\uFE00"),
        _Utils_Tuple2('vsupne', "\u228B\uFE00"),
        _Utils_Tuple2('Vvdash', "\u22AA"),
        _Utils_Tuple2('vzigzag', "\u299A"),
        _Utils_Tuple2('Wcirc', "\u0174"),
        _Utils_Tuple2('wcirc', "\u0175"),
        _Utils_Tuple2('wedbar', "\u2A5F"),
        _Utils_Tuple2('wedge', "\u2227"),
        _Utils_Tuple2('Wedge', "\u22C0"),
        _Utils_Tuple2('wedgeq', "\u2259"),
        _Utils_Tuple2('weierp', "\u2118"),
        _Utils_Tuple2('Wfr', '\uD835\uDD1A'),
        _Utils_Tuple2('wfr', '\uD835\uDD34'),
        _Utils_Tuple2('Wopf', '\uD835\uDD4E'),
        _Utils_Tuple2('wopf', '\uD835\uDD68'),
        _Utils_Tuple2('wp', "\u2118"),
        _Utils_Tuple2('wr', "\u2240"),
        _Utils_Tuple2('wreath', "\u2240"),
        _Utils_Tuple2('Wscr', '\uD835\uDCB2'),
        _Utils_Tuple2('wscr', '\uD835\uDCCC'),
        _Utils_Tuple2('xcap', "\u22C2"),
        _Utils_Tuple2('xcirc', "\u25EF"),
        _Utils_Tuple2('xcup', "\u22C3"),
        _Utils_Tuple2('xdtri', "\u25BD"),
        _Utils_Tuple2('Xfr', '\uD835\uDD1B'),
        _Utils_Tuple2('xfr', '\uD835\uDD35'),
        _Utils_Tuple2('xharr', "\u27F7"),
        _Utils_Tuple2('xhArr', "\u27FA"),
        _Utils_Tuple2('Xi', "\u039E"),
        _Utils_Tuple2('xi', "\u03BE"),
        _Utils_Tuple2('xlarr', "\u27F5"),
        _Utils_Tuple2('xlArr', "\u27F8"),
        _Utils_Tuple2('xmap', "\u27FC"),
        _Utils_Tuple2('xnis', "\u22FB"),
        _Utils_Tuple2('xodot', "\u2A00"),
        _Utils_Tuple2('Xopf', '\uD835\uDD4F'),
        _Utils_Tuple2('xopf', '\uD835\uDD69'),
        _Utils_Tuple2('xoplus', "\u2A01"),
        _Utils_Tuple2('xotime', "\u2A02"),
        _Utils_Tuple2('xrarr', "\u27F6"),
        _Utils_Tuple2('xrArr', "\u27F9"),
        _Utils_Tuple2('Xscr', '\uD835\uDCB3'),
        _Utils_Tuple2('xscr', '\uD835\uDCCD'),
        _Utils_Tuple2('xsqcup', "\u2A06"),
        _Utils_Tuple2('xuplus', "\u2A04"),
        _Utils_Tuple2('xutri', "\u25B3"),
        _Utils_Tuple2('xvee', "\u22C1"),
        _Utils_Tuple2('xwedge', "\u22C0"),
        _Utils_Tuple2('Yacute', "\xdd"),
        _Utils_Tuple2('yacute', "\xfd"),
        _Utils_Tuple2('YAcy', "\u042F"),
        _Utils_Tuple2('yacy', "\u044F"),
        _Utils_Tuple2('Ycirc', "\u0176"),
        _Utils_Tuple2('ycirc', "\u0177"),
        _Utils_Tuple2('Ycy', "\u042B"),
        _Utils_Tuple2('ycy', "\u044B"),
        _Utils_Tuple2('yen', "\xa5"),
        _Utils_Tuple2('Yfr', '\uD835\uDD1C'),
        _Utils_Tuple2('yfr', '\uD835\uDD36'),
        _Utils_Tuple2('YIcy', "\u0407"),
        _Utils_Tuple2('yicy', "\u0457"),
        _Utils_Tuple2('Yopf', '\uD835\uDD50'),
        _Utils_Tuple2('yopf', '\uD835\uDD6A'),
        _Utils_Tuple2('Yscr', '\uD835\uDCB4'),
        _Utils_Tuple2('yscr', '\uD835\uDCCE'),
        _Utils_Tuple2('YUcy', "\u042E"),
        _Utils_Tuple2('yucy', "\u044E"),
        _Utils_Tuple2('yuml', "\xff"),
        _Utils_Tuple2('Yuml', "\u0178"),
        _Utils_Tuple2('Zacute', "\u0179"),
        _Utils_Tuple2('zacute', "\u017A"),
        _Utils_Tuple2('Zcaron', "\u017D"),
        _Utils_Tuple2('zcaron', "\u017E"),
        _Utils_Tuple2('Zcy', "\u0417"),
        _Utils_Tuple2('zcy', "\u0437"),
        _Utils_Tuple2('Zdot', "\u017B"),
        _Utils_Tuple2('zdot', "\u017C"),
        _Utils_Tuple2('zeetrf', "\u2128"),
        _Utils_Tuple2('ZeroWidthSpace', '\u200B'),
        _Utils_Tuple2('Zeta', "\u0396"),
        _Utils_Tuple2('zeta', "\u03B6"),
        _Utils_Tuple2('zfr', '\uD835\uDD37'),
        _Utils_Tuple2('Zfr', "\u2128"),
        _Utils_Tuple2('ZHcy', "\u0416"),
        _Utils_Tuple2('zhcy', "\u0436"),
        _Utils_Tuple2('zigrarr', "\u21DD"),
        _Utils_Tuple2('zopf', '\uD835\uDD6B'),
        _Utils_Tuple2('Zopf', "\u2124"),
        _Utils_Tuple2('Zscr', '\uD835\uDCB5'),
        _Utils_Tuple2('zscr', '\uD835\uDCCF'),
        _Utils_Tuple2('zwj', '\u200D'),
        _Utils_Tuple2('zwnj', '\u200C')
    ]));
    var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2($elm$parser$Parser$map, function(reference) {
        return A2($elm$core$Maybe$withDefault, '&' + (reference + ';'), A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
    }, $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
    var $elm$core$Basics$pow = _Basics_pow;
    var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(function(position, chars, accumulated) {
        fromStringHelp: while(true){
            if (!chars.b) return $elm$core$Result$Ok(accumulated);
            else {
                var _char = chars.a;
                var rest = chars.b;
                switch(_char){
                    case '0':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated;
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '1':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '2':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 2 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '3':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 3 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '4':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 4 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '5':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 5 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '6':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 6 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '7':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 7 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '8':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 8 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case '9':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 9 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case 'a':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 10 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case 'b':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 11 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case 'c':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 12 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case 'd':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 13 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case 'e':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 14 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    case 'f':
                        var $temp$position = position - 1, $temp$chars = rest, $temp$accumulated = accumulated + 15 * A2($elm$core$Basics$pow, 16, position);
                        position = $temp$position;
                        chars = $temp$chars;
                        accumulated = $temp$accumulated;
                        continue fromStringHelp;
                    default:
                        var nonHex = _char;
                        return $elm$core$Result$Err($elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
                }
            }
        }
    });
    var $rtfeldman$elm_hex$Hex$fromString = function(str) {
        if ($elm$core$String$isEmpty(str)) return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
        else {
            var result = function() {
                if (A2($elm$core$String$startsWith, '-', str)) {
                    var list = A2($elm$core$Maybe$withDefault, _List_Nil, $elm$core$List$tail($elm$core$String$toList(str)));
                    return A2($elm$core$Result$map, $elm$core$Basics$negate, A3($rtfeldman$elm_hex$Hex$fromStringHelp, $elm$core$List$length(list) - 1, list, 0));
                } else return A3($rtfeldman$elm_hex$Hex$fromStringHelp, $elm$core$String$length(str) - 1, $elm$core$String$toList(str), 0);
            }();
            var formatError = function(err) {
                return A2($elm$core$String$join, ' ', _List_fromArray([
                    '\"' + (str + '\"'),
                    'is not a valid hexadecimal string because',
                    err
                ]));
            };
            return A2($elm$core$Result$mapError, formatError, result);
        }
    };
    var $elm$core$Char$isHexDigit = function(_char) {
        var code = $elm$core$Char$toCode(_char);
        return 48 <= code && code <= 57 || 65 <= code && code <= 70 || 97 <= code && code <= 102;
    };
    var $hecrj$html_parser$Html$Parser$hexadecimal = A2($elm$parser$Parser$andThen, function(hex) {
        var _v0 = $rtfeldman$elm_hex$Hex$fromString($elm$core$String$toLower(hex));
        if (!_v0.$) {
            var value = _v0.a;
            return $elm$parser$Parser$succeed(value);
        } else {
            var error = _v0.a;
            return $elm$parser$Parser$problem(error);
        }
    }, $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
    var $elm$parser$Parser$ExpectingInt = {
        $: 1
    };
    var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
    var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
    var $elm$parser$Parser$Advanced$bumpOffset = F2(function(newOffset, s) {
        return {
            Ln: s.Ln + (newOffset - s.f),
            aC: s.aC,
            aeo: s.aeo,
            f: newOffset,
            n4: s.n4,
            s2: s.s2
        };
    });
    var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
    var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
    var $elm$parser$Parser$Advanced$consumeExp = F2(function(offset, src) {
        if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
            var eOffset = offset + 1;
            var expOffset = A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src) ? eOffset + 1 : eOffset;
            var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
            return _Utils_eq(expOffset, newOffset) ? -newOffset : newOffset;
        } else return offset;
    });
    var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(function(offset, src) {
        return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2($elm$parser$Parser$Advanced$consumeExp, A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src), src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
    });
    var $elm$parser$Parser$Advanced$finalizeInt = F5(function(invalid, handler, startOffset, _v0, s) {
        var endOffset = _v0.a;
        var n = _v0.b;
        if (handler.$ === 1) {
            var x = handler.a;
            return A2($elm$parser$Parser$Advanced$Bad, true, A2($elm$parser$Parser$Advanced$fromState, s, x));
        } else {
            var toValue = handler.a;
            return _Utils_eq(startOffset, endOffset) ? A2($elm$parser$Parser$Advanced$Bad, _Utils_cmp(s.f, startOffset) < 0, A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3($elm$parser$Parser$Advanced$Good, true, toValue(n), A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
        }
    });
    var $elm$parser$Parser$Advanced$finalizeFloat = F6(function(invalid, expecting, intSettings, floatSettings, intPair, s) {
        var intOffset = intPair.a;
        var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.s2);
        if (floatOffset < 0) return A2($elm$parser$Parser$Advanced$Bad, true, A4($elm$parser$Parser$Advanced$fromInfo, s.n4, s.Ln - (floatOffset + s.f), invalid, s.aC));
        else {
            if (_Utils_eq(s.f, floatOffset)) return A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, expecting));
            else {
                if (_Utils_eq(intOffset, floatOffset)) return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.f, intPair, s);
                else if (floatSettings.$ === 1) {
                    var x = floatSettings.a;
                    return A2($elm$parser$Parser$Advanced$Bad, true, A2($elm$parser$Parser$Advanced$fromState, s, invalid));
                } else {
                    var toValue = floatSettings.a;
                    var _v1 = $elm$core$String$toFloat(A3($elm$core$String$slice, s.f, floatOffset, s.s2));
                    if (_v1.$ === 1) return A2($elm$parser$Parser$Advanced$Bad, true, A2($elm$parser$Parser$Advanced$fromState, s, invalid));
                    else {
                        var n = _v1.a;
                        return A3($elm$parser$Parser$Advanced$Good, true, toValue(n), A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
                    }
                }
            }
        }
    });
    var $elm$parser$Parser$Advanced$number = function(c) {
        return function(s) {
            if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.f, s.s2)) {
                var zeroOffset = s.f + 1;
                var baseOffset = zeroOffset + 1;
                return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.s2) ? A5($elm$parser$Parser$Advanced$finalizeInt, c.q2, c.ad5, baseOffset, A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.s2), s) : A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.s2) ? A5($elm$parser$Parser$Advanced$finalizeInt, c.q2, c.Vi, baseOffset, A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.s2), s) : A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.s2) ? A5($elm$parser$Parser$Advanced$finalizeInt, c.q2, c.Ki, baseOffset, A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.s2), s) : A6($elm$parser$Parser$Advanced$finalizeFloat, c.q2, c.Pd, c.Rl, c.PS, _Utils_Tuple2(zeroOffset, 0), s);
            } else return A6($elm$parser$Parser$Advanced$finalizeFloat, c.q2, c.Pd, c.Rl, c.PS, A3($elm$parser$Parser$Advanced$consumeBase, 10, s.f, s.s2), s);
        };
    };
    var $elm$parser$Parser$Advanced$int = F2(function(expecting, invalid) {
        return $elm$parser$Parser$Advanced$number({
            Ki: $elm$core$Result$Err(invalid),
            Pd: expecting,
            PS: $elm$core$Result$Err(invalid),
            ad5: $elm$core$Result$Err(invalid),
            Rl: $elm$core$Result$Ok($elm$core$Basics$identity),
            q2: invalid,
            Vi: $elm$core$Result$Err(invalid)
        });
    });
    var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
    var $hecrj$html_parser$Html$Parser$numericCharacterReference = function() {
        var codepoint = $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf(function(c) {
                return c === 'x' || c === 'X';
            })), $hecrj$html_parser$Html$Parser$hexadecimal),
            A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompWhile($elm$core$Basics$eq('0'))), $elm$parser$Parser$int)
        ]));
        return A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf($elm$core$Basics$eq('#'))), A2($elm$parser$Parser$map, A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar), codepoint));
    }();
    var $hecrj$html_parser$Html$Parser$characterReference = A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf($elm$core$Basics$eq('&'))), $elm$parser$Parser$oneOf(_List_fromArray([
        A2($elm$parser$Parser$ignorer, $elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference), $hecrj$html_parser$Html$Parser$chompSemicolon),
        A2($elm$parser$Parser$ignorer, $elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference), $hecrj$html_parser$Html$Parser$chompSemicolon),
        $elm$parser$Parser$succeed('&')
    ])));
    var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function(quote) {
        var isQuotedValueChar = function(c) {
            return !_Utils_eq(c, quote) && c !== '&';
        };
        return A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf($elm$core$Basics$eq(quote))), A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$map, $elm$core$String$join(''), $hecrj$html_parser$Html$Parser$many($elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
            $hecrj$html_parser$Html$Parser$characterReference
        ])))), $elm$parser$Parser$chompIf($elm$core$Basics$eq(quote))));
    };
    var $hecrj$html_parser$Html$Parser$oneOrMore = F2(function(type_, parser_) {
        return A2($elm$parser$Parser$loop, _List_Nil, function(list) {
            return $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$map, function(_new) {
                    return $elm$parser$Parser$Loop(A2($elm$core$List$cons, _new, list));
                }, parser_),
                $elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed($elm$parser$Parser$Done($elm$core$List$reverse(list)))
            ]));
        });
    });
    var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function() {
        var isUnquotedValueChar = function(c) {
            return !$hecrj$html_parser$Html$Parser$isSpaceCharacter(c) && c !== '\"' && c !== '\'' && c !== '=' && c !== '<' && c !== '>' && c !== '`' && c !== '&';
        };
        return A2($elm$parser$Parser$map, $elm$core$String$join(''), A2($hecrj$html_parser$Html$Parser$oneOrMore, 'attribute value', $elm$parser$Parser$oneOf(_List_fromArray([
            $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
            $hecrj$html_parser$Html$Parser$characterReference
        ]))));
    }();
    var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(_List_fromArray([
        A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Basics$identity), $elm$parser$Parser$chompIf($elm$core$Basics$eq('='))), $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)), $elm$parser$Parser$oneOf(_List_fromArray([
            $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
            $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
            $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
        ]))),
        $elm$parser$Parser$succeed('')
    ]));
    var $hecrj$html_parser$Html$Parser$tagAttribute = A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, $elm$parser$Parser$succeed($elm$core$Tuple$pair), A2($elm$parser$Parser$ignorer, $hecrj$html_parser$Html$Parser$tagAttributeName, $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))), A2($elm$parser$Parser$ignorer, $hecrj$html_parser$Html$Parser$tagAttributeValue, $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
    var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
    var $hecrj$html_parser$Html$Parser$tagName = A2($elm$parser$Parser$map, $elm$core$String$toLower, $elm$parser$Parser$getChompedString(A2($elm$parser$Parser$ignorer, $elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum), $elm$parser$Parser$chompWhile(function(c) {
        return $elm$core$Char$isAlphaNum(c) || c === '-';
    }))));
    var $hecrj$html_parser$Html$Parser$Text = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $hecrj$html_parser$Html$Parser$text = A2($elm$parser$Parser$map, A2($elm$core$Basics$composeR, $elm$core$String$join(''), $hecrj$html_parser$Html$Parser$Text), A2($hecrj$html_parser$Html$Parser$oneOrMore, 'text element', $elm$parser$Parser$oneOf(_List_fromArray([
        $elm$parser$Parser$getChompedString($hecrj$html_parser$Html$Parser$chompOneOrMore(function(c) {
            return c !== '<' && c !== '&';
        })),
        $hecrj$html_parser$Html$Parser$characterReference
    ]))));
    function $hecrj$html_parser$Html$Parser$cyclic$node() {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $hecrj$html_parser$Html$Parser$text,
            $hecrj$html_parser$Html$Parser$comment,
            $hecrj$html_parser$Html$Parser$cyclic$element()
        ]));
    }
    function $hecrj$html_parser$Html$Parser$cyclic$element() {
        return A2($elm$parser$Parser$andThen, function(_v0) {
            var name = _v0.a;
            var attributes = _v0.b;
            return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)), $elm$parser$Parser$oneOf(_List_fromArray([
                $elm$parser$Parser$chompIf($elm$core$Basics$eq('/')),
                $elm$parser$Parser$succeed(0)
            ]))), $elm$parser$Parser$chompIf($elm$core$Basics$eq('>'))) : A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(A2($hecrj$html_parser$Html$Parser$Element, name, attributes)), $elm$parser$Parser$chompIf($elm$core$Basics$eq('>'))), A2($elm$parser$Parser$ignorer, $hecrj$html_parser$Html$Parser$many($elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$cyclic$node())), $hecrj$html_parser$Html$Parser$closingTag(name)));
        }, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$keeper, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed($elm$core$Tuple$pair), $elm$parser$Parser$chompIf($elm$core$Basics$eq('<'))), A2($elm$parser$Parser$ignorer, $hecrj$html_parser$Html$Parser$tagName, $elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))), $hecrj$html_parser$Html$Parser$tagAttributes));
    }
    var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
    $hecrj$html_parser$Html$Parser$cyclic$node = function() {
        return $hecrj$html_parser$Html$Parser$node;
    };
    var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
    $hecrj$html_parser$Html$Parser$cyclic$element = function() {
        return $hecrj$html_parser$Html$Parser$element;
    };
    var $hecrj$html_parser$Html$Parser$run = function(str) {
        return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2($elm$parser$Parser$run, A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node), str);
    };
    var $hecrj$html_parser$Html$Parser$Util$toAttribute = function(_v0) {
        var name = _v0.a;
        var value = _v0.b;
        return A2($elm$html$Html$Attributes$attribute, name, value);
    };
    var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function(nodes) {
        return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
    };
    var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function(node) {
        switch(node.$){
            case 1:
                var name = node.a;
                var attrs = node.b;
                var children = node.c;
                return A3($elm$html$Html$node, name, A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs), $hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
            case 0:
                var s = node.a;
                return $elm$html$Html$text(s);
            default:
                return $elm$html$Html$text('');
        }
    };
    var $author$project$Utils$Dom$textToHtml = function(htmlString) {
        var _v0 = $hecrj$html_parser$Html$Parser$run(htmlString);
        if (!_v0.$) {
            var nodes = _v0.a;
            return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(nodes);
        } else return _List_Nil;
    };
    var $author$project$Ui$Form$Textarea$Value = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$value = $author$project$Ui$Form$Textarea$Value;
    var $author$project$Components$TranslatedRichText$LanguageSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Icon$Translate = 66;
    var $author$project$Ui$Icon$translate = $author$project$Ui$Icon$viewIcon(66);
    var $author$project$Components$TranslatedRichText$viewLanguageDropdown = F2(function(currentLanguage, dropdown) {
        var languageToItem = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(lang, currentLanguage)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$TranslatedRichText$LanguageSelected(lang))
            ]), $elm$html$Html$text($author$project$Language$toLabel(lang)));
        };
        var items = A2($elm$core$List$map, languageToItem, _List_fromArray([
            $author$project$Language$english,
            $author$project$Language$spanish
        ]));
        return A3($author$project$Ui$Element$custom, 'absolute top-2 right-2 z-50 flex items-center', _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mr2
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$label, _List_fromArray([
                    $author$project$Ui$Typography$hintLabel
                ]), _List_fromArray([
                    $author$project$Ui$Icon$translate(_List_Nil),
                    $elm$html$Html$text('\u00A0'),
                    $elm$html$Html$text('Now editing')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('pr-2')
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Language$toLabel(currentLanguage))
                    ]))
                ]), items, dropdown)
            ]))
        ]));
    });
    var $author$project$Components$TranslatedRichText$view = F2(function(config, model) {
        var groupArgs = config.afr ? _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label('Plan Description'),
            $author$project$Ui$Form$Group$labelClass('')
        ]) : _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8),
            $author$project$Ui$Form$Group$label(config.aeI)
        ]);
        return A2($author$project$Ui$Form$Group$view, groupArgs, _List_fromArray([
            A3($author$project$Ui$Element$custom, 'relative', _List_Nil, function() {
                var currentDescription = A2($elm$core$Dict$get, $author$project$Language$toValue(model.h4), model.aay);
                return _List_fromArray([
                    function() {
                        if (model.mI) return $author$project$Ui$Form$Textarea$view(_List_fromArray([
                            $author$project$Ui$Form$Textarea$rows(10),
                            $author$project$Ui$Form$Textarea$id(config.adg),
                            $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', currentDescription))
                        ]));
                        else {
                            var fallbackDescription = function() {
                                var _v1 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, currentDescription);
                                if (_v1.$ === 1) return A2($elm$core$Dict$get, 'es', model.aay);
                                else return currentDescription;
                            }();
                            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                function() {
                                    if (!fallbackDescription.$) {
                                        var desc = fallbackDescription.a;
                                        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                            A2($elm$html$Html$div, _List_fromArray([
                                                $elm$html$Html$Attributes$class('text-right')
                                            ]), _List_fromArray([
                                                A3($author$project$Ui$Button$view, {
                                                    abP: 'Edit ' + config.aeI
                                                }, _List_fromArray([
                                                    $author$project$Ui$Button$link,
                                                    $author$project$Ui$Button$onClick($author$project$Components$TranslatedRichText$EditToggled)
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text('Edit')
                                                ]))
                                            ])),
                                            A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), $author$project$Utils$Dom$textToHtml(desc)))
                                        ]));
                                    } else return A2($elm$html$Html$div, _List_fromArray([
                                        $elm$html$Html$Attributes$class('flex justify-between items-center')
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$muted
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('No description')
                                        ])),
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Edit ' + config.aeI
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$link,
                                            $author$project$Ui$Button$onClick($author$project$Components$TranslatedRichText$EditToggled)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Edit')
                                        ]))
                                    ]));
                                }()
                            ]));
                        }
                    }(),
                    model.mI ? A2($author$project$Components$TranslatedRichText$viewLanguageDropdown, model.h4, model.fD) : $elm$html$Html$text('')
                ]);
            }())
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionInitialPurchase = 'immediate';
    var $author$project$Components$Admin$ChargeItems$Form$RevenueRecognition = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption = F3(function(selectedValue, optionValue, labelText) {
        return A2($elm$html$Html$label, _List_fromArray([
            $elm$html$Html$Attributes$class('radio-inline')
        ]), _List_fromArray([
            A2($elm$html$Html$input, _List_fromArray([
                $elm$html$Html$Attributes$type_('radio'),
                $elm$html$Html$Attributes$name('revenue-recognition'),
                $elm$html$Html$Attributes$value(optionValue),
                $elm$html$Html$Attributes$checked(_Utils_eq(selectedValue, optionValue)),
                $elm$html$Html$Events$onClick($author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$RevenueRecognition(optionValue)))
            ]), _List_Nil),
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('ml-2')
            ]), _List_fromArray([
                $elm$html$Html$text(labelText)
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognition = function(fields) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Revenue Recognition')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flex flex-wrap gap-4 items-center')
            ]), _List_fromArray([
                A3($author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption, fields.Y3, $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionItemConsumption, 'Upon item consumption (default)'),
                A3($author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognitionOption, fields.Y3, $author$project$Components$Admin$ChargeItems$Form$revenueRecognitionInitialPurchase, 'Upon initial purchase')
            ]))
        ]));
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewAdvancedSettings = function(fields) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$margin(22)
        ]), _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Advanced Settings')
                ]))
            ])),
            $author$project$Components$Admin$ChargeItems$Form$viewRevenueRecognition(fields)
        ]));
    };
    var $author$project$Components$Admin$ChargeItems$Form$Buyable = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewBuyableCheckbox = F2(function(fields, disable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Can be purchased on patient portal')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.Ky),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Buyable)),
                $author$project$Ui$ToggleSwitch$disabled(disable)
            ]))
        ]));
    });
    var $author$project$Components$ResourceFilter$Disabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$disabled = $author$project$Components$ResourceFilter$Disabled;
    var $author$project$Components$ResourceFilter$Value = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$value = $author$project$Components$ResourceFilter$Value;
    var $author$project$Components$ResourceFilter$DropdownItemChecked = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$DropdownItemSelected = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$DropdownSearched = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$AriaLabel = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$ariaLabel = $author$project$Ui$Dropdown$AriaLabel;
    var $author$project$Ui$Dropdown$Checkbox = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Dropdown$checkbox = $author$project$Ui$Dropdown$Checkbox;
    var $author$project$Ui$Dropdown$Item$Checked = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$checked = $author$project$Ui$Dropdown$Item$Checked;
    var $author$project$Ui$Dropdown$Errors = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$errors = $author$project$Ui$Dropdown$Errors;
    var $elm_community$list_extra$List$Extra$filterNot = F2(function(pred, list) {
        return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, pred), list);
    });
    var $author$project$Components$ResourceFilter$DropdownLoadedMore = {
        $: 9
    };
    var $author$project$Ui$Dropdown$Item$OnSelectKeepOpen = {
        $: 10
    };
    var $author$project$Ui$Dropdown$onSelectKeepOpen = $author$project$Ui$Dropdown$Item$OnSelectKeepOpen;
    var $author$project$Ui$Button$Tabindex = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Ui$Button$preventFocus = $author$project$Ui$Button$Tabindex(-1);
    var $author$project$Components$ResourceFilter$infoItem2 = F3(function(items, totalItemsCount, options) {
        if ($elm$core$List$isEmpty(items)) return options.ad7 ? _List_Nil : _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_Nil, $elm$html$Html$text('No results found'))
        ]);
        else {
            var _v0 = _Utils_Tuple2(options.Cy, totalItemsCount);
            if (_v0.a && !_v0.b.$) {
                var totalCount = _v0.b.a;
                var currentCount = $elm$core$List$length(items);
                return _Utils_cmp(totalCount, currentCount) > 0 ? _List_fromArray([
                    A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$ResourceFilter$DropdownLoadedMore),
                        $author$project$Ui$Dropdown$onSelectKeepOpen
                    ]), A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'See more'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$preventFocus
                        ]), _List_fromArray([
                            $elm$html$Html$text('See '),
                            $elm$html$Html$text($elm$core$String$fromInt(options.rf)),
                            $elm$html$Html$text(' more')
                        ])),
                        $elm$html$Html$text(' or type to search')
                    ])))
                ]) : _List_Nil;
            } else return _List_Nil;
        }
    });
    var $author$project$Ui$Dropdown$Input = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$input = $author$project$Ui$Dropdown$Input;
    var $author$project$Ui$Dropdown$Invalid = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$invalid = $author$project$Ui$Dropdown$Invalid;
    var $author$project$Components$ResourceFilter$isChecked = F2(function(choice, item) {
        switch(choice.$){
            case 0:
                var other = choice.a;
                return _Utils_eq(item, other);
            case 1:
                var items = choice.a;
                return A2($elm$core$List$member, item, items);
            default:
                return false;
        }
    });
    var $author$project$Ui$Dropdown$Item$OnCheck = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$onCheck = $author$project$Ui$Dropdown$Item$OnCheck;
    var $author$project$Ui$Dropdown$Item$OnInput = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$onInput = $author$project$Ui$Dropdown$Item$OnInput;
    var $author$project$Components$ResourceFilter$Input = 0;
    var $author$project$Components$ResourceFilter$defaultOptions = {
        abP: '',
        EP: _List_fromArray([
            'resource-filter'
        ]),
        d$: false,
        fK: _List_Nil,
        q2: false,
        Tk: false,
        zo: false,
        s5: 0,
        aa9: $author$project$Components$ResourceFilter$All
    };
    var $author$project$Components$ResourceFilter$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var value_ = option.a;
                    return _Utils_update(record, {
                        aa9: value_
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(record, {
                        q2: bool
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        d$: bool
                    });
                case 3:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
                case 4:
                    var style_ = option.a;
                    return _Utils_update(record, {
                        s5: style_
                    });
                case 5:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Tk: bool
                    });
                case 6:
                    return _Utils_update(record, {
                        zo: true
                    });
                default:
                    var label = option.a;
                    return _Utils_update(record, {
                        abP: label
                    });
            }
        }), $author$project$Components$ResourceFilter$defaultOptions, options);
    };
    var $author$project$Ui$Dropdown$Item$Placeholder = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$placeholder = $author$project$Ui$Dropdown$Item$Placeholder;
    var $author$project$Ui$Dropdown$Separator = {
        $: 1
    };
    var $author$project$Ui$Dropdown$separator = $author$project$Ui$Dropdown$Separator;
    var $author$project$Components$ResourceFilter$toggleItemSelection = F2(function(currentChoice, item) {
        switch(currentChoice.$){
            case 0:
                var other = currentChoice.a;
                return _Utils_eq(other, item) ? $author$project$Components$ResourceFilter$All : $author$project$Components$ResourceFilter$Many(_List_fromArray([
                    other,
                    item
                ]));
            case 1:
                var items = currentChoice.a;
                if (A2($elm$core$List$member, item, items)) {
                    var remainingItems = A2($elm$core$List$filter, $elm$core$Basics$neq(item), items);
                    if (!remainingItems.b) return $author$project$Components$ResourceFilter$All;
                    else {
                        if (!remainingItems.b.b) {
                            var singleItem = remainingItems.a;
                            return $author$project$Components$ResourceFilter$One(singleItem);
                        } else return $author$project$Components$ResourceFilter$Many(remainingItems);
                    }
                } else return $author$project$Components$ResourceFilter$Many(A2($elm$core$List$cons, item, items));
            case 3:
                return $author$project$Components$ResourceFilter$One(item);
            case 2:
                return $author$project$Components$ResourceFilter$One(item);
            case 4:
                return $author$project$Components$ResourceFilter$One(item);
            default:
                return $author$project$Components$ResourceFilter$One(item);
        }
    });
    var $author$project$Ui$Dropdown$Item$Value = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$value = $author$project$Ui$Dropdown$Item$Value;
    var $author$project$Components$ResourceFilter$viewNew = F2(function(options, model) {
        var toLabel_ = function(choice) {
            return A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('w-full')
            ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), model.EO(choice)));
        };
        var optionsRecord = $author$project$Components$ResourceFilter$optionsToRecord(options);
        var items = function() {
            var _v0 = model.a0;
            if (!_v0.$) {
                var list = _v0.a;
                var apiItemsValues = A2($elm$core$List$map, model.g4, list);
                return A2($elm$core$List$cons, $author$project$Ui$Dropdown$input(_List_fromArray([
                    $author$project$Ui$Dropdown$onInput($author$project$Components$ResourceFilter$DropdownSearched),
                    $author$project$Ui$Dropdown$value(A2($elm$core$Maybe$withDefault, '', model.agq)),
                    model.z9.ad$ ? $author$project$Ui$Dropdown$placeholder('Search or type your own...') : $author$project$Ui$Dropdown$placeholder('Search...'),
                    function() {
                        if (model.z9.ad$) return $author$project$Ui$Dropdown$onEnter($author$project$Components$ResourceFilter$DropdownItemSelected($elm$core$Maybe$Just($author$project$Components$ResourceFilter$FreeText(A2($elm$core$Maybe$withDefault, '', model.agq)))));
                        else {
                            if (list.b) {
                                var x = list.a;
                                return $author$project$Ui$Dropdown$onEnter($author$project$Components$ResourceFilter$DropdownItemSelected($elm$core$Maybe$Just($author$project$Components$ResourceFilter$One(x))));
                            } else return $author$project$Ui$Dropdown$placeholder('Search...');
                        }
                    }()
                ])), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, _Utils_ap(function(allAndNone) {
                    if (!allAndNone.b) return _List_Nil;
                    else return _Utils_ap(allAndNone, _List_fromArray([
                        $author$project$Ui$Dropdown$separator
                    ]));
                }(A2($elm$core$List$map, function(_v2) {
                    var label = _v2.a;
                    var choice = _v2.b;
                    return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$selected(_Utils_eq(optionsRecord.aa9, choice)),
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$ResourceFilter$DropdownItemSelected($elm$core$Maybe$Just(choice)))
                    ]), $elm$html$Html$text(label));
                }, A2($elm$core$List$map, $elm$core$Tuple$second, A2($elm$core$List$filter, $elm$core$Tuple$first, _List_fromArray([
                    _Utils_Tuple2(model.z9.I5, _Utils_Tuple2(model.z9.Ee, $author$project$Components$ResourceFilter$All)),
                    _Utils_Tuple2(model.z9.afn, _Utils_Tuple2(model.z9.U5, $author$project$Components$ResourceFilter$None))
                ]))))), _Utils_ap(function() {
                    var _v4 = optionsRecord.aa9;
                    if (_v4.$ === 5) {
                        var string = _v4.a;
                        return _List_fromArray([
                            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                $author$project$Ui$Dropdown$selected(_Utils_eq(optionsRecord.aa9, $author$project$Components$ResourceFilter$FreeText(string))),
                                $author$project$Ui$Dropdown$onSelect($author$project$Components$ResourceFilter$DropdownItemSelected($elm$core$Maybe$Just($author$project$Components$ResourceFilter$FreeText(string))))
                            ]), $elm$html$Html$text(string))
                        ]);
                    } else return _List_Nil;
                }(), _Utils_ap(function() {
                    var _v5 = _Utils_Tuple2(model.z9.ad$, model.agq);
                    _v5$2: while(true){
                        if (!_v5.b.$) {
                            if (_v5.b.a === '') return _List_Nil;
                            else {
                                if (_v5.a) {
                                    var string = _v5.b.a;
                                    return _Utils_eq(optionsRecord.aa9, $author$project$Components$ResourceFilter$FreeText(string)) ? _List_Nil : _List_fromArray([
                                        A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                            $author$project$Ui$Dropdown$onSelect($author$project$Components$ResourceFilter$DropdownItemSelected($elm$core$Maybe$Just($author$project$Components$ResourceFilter$FreeText(string))))
                                        ]), $elm$html$Html$text('Select \"' + (string + '\"')))
                                    ]);
                                } else break _v5$2;
                            }
                        } else break _v5$2;
                    }
                    return _List_Nil;
                }(), _Utils_ap(A2($elm$core$List$map, function(item) {
                    return optionsRecord.zo ? A2($author$project$Ui$Dropdown$checkbox, _List_fromArray([
                        $author$project$Ui$Dropdown$checked(A2($author$project$Components$ResourceFilter$isChecked, optionsRecord.aa9, item)),
                        $author$project$Ui$Dropdown$onCheck($elm$core$Basics$always($author$project$Components$ResourceFilter$DropdownItemChecked(A2($author$project$Components$ResourceFilter$toggleItemSelection, optionsRecord.aa9, item))))
                    ]), toLabel_($author$project$Components$ResourceFilter$One(item))) : A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$selected(_Utils_eq(optionsRecord.aa9, $author$project$Components$ResourceFilter$One(item))),
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$ResourceFilter$DropdownItemSelected($elm$core$Maybe$Just($author$project$Components$ResourceFilter$One(item))))
                    ]), toLabel_($author$project$Components$ResourceFilter$One(item)));
                }, list), _Utils_ap(A2($elm$core$List$map, function(item) {
                    return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$selected(_Utils_eq(optionsRecord.aa9, $author$project$Components$ResourceFilter$Extra(item))),
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$ResourceFilter$DropdownItemSelected($elm$core$Maybe$Just($author$project$Components$ResourceFilter$Extra(item))))
                    ]), toLabel_($author$project$Components$ResourceFilter$Extra(item)));
                }, A2($elm_community$list_extra$List$Extra$filterNot, function(extraItem) {
                    return A2($elm$core$List$member, extraItem.aa9, apiItemsValues);
                }, model.d4)), A3($author$project$Components$ResourceFilter$infoItem2, list, model.oR, model.z9))))))));
            } else return _List_Nil;
        }();
        var choiceToTitle_ = A5($author$project$Components$ResourceFilter$choiceToTitle, model.z9.Ee, model.z9.U5, model.z9.ad0, model.gD, model.ahZ);
        return A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
            $author$project$Ui$Dropdown$disabled(optionsRecord.d$),
            $author$project$Ui$Dropdown$errors(optionsRecord.fK),
            $author$project$Ui$Dropdown$invalid(optionsRecord.q2),
            $author$project$Ui$Dropdown$ariaLabel(optionsRecord.abP)
        ]), _List_fromArray([
            $elm$html$Html$text(choiceToTitle_(optionsRecord.aa9))
        ]), items, model.fD);
    });
    var $author$project$Components$ResourceFilter$Category$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Admin$ChargeItems$Form$viewCategoryInput = F2(function(categoryResourceFilter, disabled) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Category')
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Admin$ChargeItems$Form$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$viewNew, _List_fromArray([
                $author$project$Components$ResourceFilter$disabled(disabled)
            ]), categoryResourceFilter))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$Code = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$CodeTypeSelected = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewCodeInput = F4(function(fields, form, codeTypeDropdown, disabled) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Code')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.Lk),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Code)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 4, form)),
                        $author$project$Ui$Form$Input$disabled(disabled)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    function() {
                        var items = A2($elm$core$List$map, function(_v2) {
                            var codeTypeId = _v2.a;
                            var label = _v2.b;
                            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                $author$project$Ui$Dropdown$onSelect($author$project$Components$Admin$ChargeItems$Form$CodeTypeSelected($elm$core$Maybe$Just(codeTypeId))),
                                $author$project$Ui$Dropdown$selected(_Utils_eq(fields.Lm, $elm$core$Maybe$Just(codeTypeId)))
                            ]), $elm$html$Html$text(label));
                        }, $author$project$Formatters$ChargeItemCode$codeTypes);
                        var currentLabel = function() {
                            var _v0 = fields.Lm;
                            if (!_v0.$) {
                                var codeType = _v0.a;
                                return A2($elm$core$Maybe$withDefault, 'Code Type', A2($elm$core$Maybe$map, $elm$core$Tuple$second, $elm$core$List$head(A2($elm$core$List$filter, function(_v1) {
                                    var id = _v1.a;
                                    return _Utils_eq(id, codeType);
                                }, $author$project$Formatters$ChargeItemCode$codeTypes))));
                            } else return 'Code Type';
                        }();
                        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(currentLabel)
                        ]), items, codeTypeDropdown);
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$DaysSupply = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewDaysSupplyInput = F2(function(fields, disabled) {
        return $author$project$Utils$Uom$isTimeBased(fields.aaK) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Days Supply')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$number,
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Nc))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$DaysSupply)),
                        $author$project$Ui$Form$Input$disabled(disabled)
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$Description = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$Disabled = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$disabled = $author$project$Ui$Form$Textarea$Disabled;
    var $author$project$Ui$Form$Textarea$OnInput = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$onInput = $author$project$Ui$Form$Textarea$OnInput;
    var $author$project$Ui$Form$Textarea$Placeholder = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$placeholder = $author$project$Ui$Form$Textarea$Placeholder;
    var $author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput = F2(function(fields, disabled) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Description')
        ]), _List_fromArray([
            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', fields.NQ)),
                $author$project$Ui$Form$Textarea$phi(true),
                $author$project$Ui$Form$Textarea$placeholder('Additional details for receipt'),
                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Description)),
                $author$project$Ui$Form$Textarea$disabled(disabled)
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Additional detail that will appear on both printed and emailed receipts (e.g. ICD-10 Codes)')
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$ExpirationNumber = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$ExpirationUnit = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$HasExpiration = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$Disabled = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$disabled = $author$project$Ui$Form$Checkbox$Disabled;
    var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
    var $author$project$Components$Admin$ChargeItems$Form$viewExpirationCheckbox = F3(function(fields, form, disable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Expiration')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(fields.b9),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$HasExpiration)),
                $author$project$Ui$Form$Checkbox$disabled(disable)
            ]), _List_fromArray([
                $elm$html$Html$text('Set expiration date for this package')
            ])),
            fields.b9 ? A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$margin(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Expires after '),
                    A2($elm$html$Html$span, _List_fromArray([
                        A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
                        A2($elm$html$Html$Attributes$style, 'width', '50px')
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(fields.Pe),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$ExpirationNumber)),
                            $author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$ExpirationNumber(fields.Pe === '' || fields.Pe === '0' ? '1' : fields.Pe))),
                            $author$project$Ui$Form$Input$disabled(disable),
                            $author$project$Ui$Form$Input$number,
                            $author$project$Ui$Form$Input$customAttributes(_List_fromArray([
                                $elm$html$Html$Attributes$min('1')
                            ]))
                        ]))
                    ])),
                    $elm$html$Html$text(' '),
                    A2($elm$html$Html$span, _List_fromArray([
                        A2($elm$html$Html$Attributes$style, 'display', 'inline-block'),
                        A2($elm$html$Html$Attributes$style, 'width', '120px')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(fields.Pf)),
                            $author$project$Ui$Form$Select$onChange(function(unit) {
                                return $author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$ExpirationUnit($elm$core$Maybe$Just(unit)));
                            }),
                            $author$project$Ui$Form$Select$disabled(disable)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('days'), 'Days'),
                            A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('weeks'), 'Weeks'),
                            A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('months'), 'Months'),
                            A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('years'), 'Years')
                        ]))
                    ])),
                    $elm$html$Html$text(' from purchase date')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock,
                    $author$project$Ui$Typography$margin(21)
                ]), _List_fromArray([
                    $elm$html$Html$text('Package will expire for patients ' + (fields.Pe + (' ' + ((fields.Pe === '1' ? A2($elm$core$String$dropRight, 1, fields.Pf) : fields.Pf) + ' after the date of purchase.'))))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 6, form))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Ui$Form$File$Image = 0;
    var $author$project$Components$Admin$ChargeItems$Form$ImageUploaded = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Form$File$Accept = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$File$accept = $author$project$Ui$Form$File$Accept;
    var $author$project$Ui$Image$fromSrc = $author$project$Ui$Image$viewImg;
    var $author$project$Ui$Form$File$OnInput = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$File$onInput = $author$project$Ui$Form$File$OnInput;
    var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
    var $author$project$Ui$Form$File$acceptedToString = function(accepted) {
        switch(accepted){
            case 1:
                return '.csv';
            case 0:
                return 'image/*';
            case 2:
                return 'application/pdf';
            case 3:
                return '.txt';
            case 4:
                return '.zip';
            default:
                return 'application/xml';
        }
    };
    var $elm$file$File$decoder = _File_decoder;
    var $author$project$Ui$Form$File$filesDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'target',
        'files'
    ]), $elm$json$Json$Decode$list($elm$file$File$decoder));
    var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
    var $author$project$Ui$Form$File$defaultOptions = {
        Id: _List_Nil,
        vE: _List_fromArray([
            $elm$html$Html$Attributes$class('btn')
        ]),
        xi: false,
        d$: false,
        xw: false,
        qZ: false,
        yy: $elm$core$Maybe$Nothing,
        zp: false,
        afE: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Form$File$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var bool = option.a;
                    return _Utils_update(record, {
                        d$: bool
                    });
                case 1:
                    var accepted = option.a;
                    return _Utils_update(record, {
                        Id: A2($elm$core$List$cons, accepted, record.Id)
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        zp: bool
                    });
                case 3:
                    var toMsg = option.a;
                    return _Utils_update(record, {
                        afE: $elm$core$Maybe$Just(toMsg)
                    });
                case 4:
                    var bool = option.a;
                    return _Utils_update(record, {
                        xw: bool
                    });
                case 5:
                    var bool = option.a;
                    return _Utils_update(record, {
                        xi: bool
                    });
                case 6:
                    return _Utils_update(record, {
                        vE: _List_fromArray([
                            $elm$html$Html$Attributes$class('sr-only'),
                            $elm$html$Html$Attributes$tabindex(-1)
                        ])
                    });
                case 7:
                    return _Utils_update(record, {
                        qZ: true
                    });
                default:
                    var k = option.a;
                    return _Utils_update(record, {
                        yy: $elm$core$Maybe$Just(k)
                    });
            }
        }), $author$project$Ui$Form$File$defaultOptions, options);
    };
    var $author$project$Ui$Form$File$view = function(options) {
        var optionsRecord = $author$project$Ui$Form$File$optionsToRecord(options);
        return function(input) {
            var _v1 = optionsRecord.yy;
            if (!_v1.$) {
                var k = _v1.a;
                return A3($elm$html$Html$Keyed$node, 'span', _List_Nil, _List_fromArray([
                    _Utils_Tuple2(k, input)
                ]));
            } else return input;
        }(A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('file'), A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(optionsRecord.d$), A2($elm$core$List$cons, $elm$html$Html$Attributes$multiple(optionsRecord.zp), _Utils_ap(optionsRecord.xi ? _List_fromArray([
            A2($elm$html$Html$Attributes$property, 'webkitdirectory', $elm$json$Json$Encode$bool(true)),
            A2($elm$html$Html$Attributes$property, 'directory', $elm$json$Json$Encode$bool(true)),
            A2($elm$html$Html$Attributes$property, 'mozdirectory', $elm$json$Json$Encode$bool(true))
        ]) : _List_Nil, _Utils_ap(A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), optionsRecord.vE), _Utils_ap($elm$core$List$isEmpty(optionsRecord.Id) ? _List_Nil : _List_fromArray([
            $elm$html$Html$Attributes$accept(A2($elm$core$String$join, ',', A2($elm$core$List$map, $author$project$Ui$Form$File$acceptedToString, optionsRecord.Id)))
        ]), _Utils_ap(function() {
            var _v0 = optionsRecord.afE;
            if (!_v0.$) {
                var onInput_ = _v0.a;
                return _List_fromArray([
                    A2($elm$html$Html$Events$on, 'change', A2($elm$json$Json$Decode$map, onInput_, $author$project$Ui$Form$File$filesDecoder))
                ]);
            } else return _List_Nil;
        }(), optionsRecord.xw ? _List_fromArray([
            $elm$html$Html$Attributes$value('')
        ]) : _List_Nil))))))), _List_Nil));
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewImageField = F2(function(errors, currentImageUrl) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Image')
        ]), _List_fromArray([
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$accept(0),
                $author$project$Ui$Form$File$onInput($author$project$Components$Admin$ChargeItems$Form$ImageUploaded)
            ])),
            function() {
                if (!currentImageUrl.$) {
                    if (currentImageUrl.a === '') return $author$project$Utils$Html$empty;
                    else {
                        var url = currentImageUrl.a;
                        return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mt2
                        ]), _List_fromArray([
                            A3($author$project$Ui$Image$fromSrc, {
                                Jg: 'Charge item image'
                            }, url, _List_fromArray([
                                $author$project$Ui$Image$height(100)
                            ]))
                        ]));
                    }
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Utils$FormErrors$view(errors)
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$AddPackageItem = {
        $: 17
    };
    var $author$project$Ui$Table$Colspan = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Table$colspan = $author$project$Ui$Table$Colspan;
    var $author$project$Ui$Table$ContainerClasses = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Table$containerClasses = $author$project$Ui$Table$ContainerClasses;
    var $author$project$Ui$Table$CellAlignment = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Table$textCenter = $author$project$Ui$Table$CellAlignment($author$project$Ui$Alignment$textCenter);
    var $author$project$Ui$Table$textRight = $author$project$Ui$Table$CellAlignment($author$project$Ui$Alignment$textRight);
    var $author$project$Components$Admin$ChargeItems$Form$RemovePackageItem = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemPrice = F2(function(a, b) {
        return {
            $: 21,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity = F2(function(a, b) {
        return {
            $: 20,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Table$MinWidth = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Table$minWidth = $author$project$Ui$Table$MinWidth;
    var $author$project$Ui$Form$CurrencyInput$Placeholder = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$placeholder = $author$project$Ui$Form$CurrencyInput$Placeholder;
    var $author$project$Ui$Typography$Success = 2;
    var $author$project$Ui$Typography$success = $author$project$Ui$Typography$Color(2);
    var $author$project$Ui$Form$Input$text = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Text);
    var $author$project$Components$ResourceFilter$activeStyleToClass = F2(function(style_, choice) {
        var _v0 = _Utils_Tuple2(style_, choice);
        if (!_v0.a) {
            var _v1 = _v0.a;
            return '';
        } else if (_v0.b.$ === 2) {
            var _v2 = _v0.a;
            var _v3 = _v0.b;
            return '';
        } else {
            var _v4 = _v0.a;
            return 'picker--active';
        }
    });
    var $author$project$Ui$Form$SearchableSelect$Class = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$class = $author$project$Ui$Form$SearchableSelect$Class;
    var $author$project$Ui$Form$SearchableSelect$Item$Divider = {
        $: 0
    };
    var $author$project$Ui$Form$SearchableSelect$Item$NonSelectable = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$Item$divider = $author$project$Ui$Form$SearchableSelect$Item$NonSelectable($author$project$Ui$Form$SearchableSelect$Item$Divider);
    var $author$project$Components$ResourceFilter$ifNothing = F3(function(maybeSth, skeleton, content) {
        return A2($elm$core$Maybe$withDefault, skeleton, A2($elm$core$Maybe$map, $elm$core$Basics$always(content), maybeSth));
    });
    var $author$project$Ui$Form$SearchableSelect$Item$ReadOnly = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$SearchableSelect$Item$readOnly = A2($elm$core$Basics$composeL, $author$project$Ui$Form$SearchableSelect$Item$NonSelectable, $author$project$Ui$Form$SearchableSelect$Item$ReadOnly);
    var $author$project$Ui$Form$SearchableSelect$Item$WithTrigger = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$SearchableSelect$Item$withTrigger = $author$project$Ui$Form$SearchableSelect$Item$WithTrigger;
    var $author$project$Components$ResourceFilter$infoItem = F4(function(loadingMore, items, totalItemsCount, options) {
        if ($elm$core$List$isEmpty(items)) return options.ad7 ? _List_Nil : _List_fromArray([
            $author$project$Ui$Form$SearchableSelect$Item$readOnly(_List_fromArray([
                $elm$html$Html$text('No results found')
            ]))
        ]);
        else {
            var _v0 = _Utils_Tuple2(options.Cy, totalItemsCount);
            if (_v0.a && !_v0.b.$) {
                var totalCount = _v0.b.a;
                var currentCount = $elm$core$List$length(items);
                return _Utils_cmp(totalCount, currentCount) > 0 ? _List_fromArray([
                    A2($author$project$Ui$Form$SearchableSelect$Item$withTrigger, $author$project$Components$ResourceFilter$loadMoreTriggerId, _List_fromArray([
                        function() {
                            var label = A2($elm$core$String$join, ' ', _List_fromArray([
                                'See',
                                $elm$core$String$fromInt(options.rf),
                                'more'
                            ]));
                            return A3($author$project$Ui$Button$view, {
                                abP: label + ' or type to search'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$loading(loadingMore)
                            ]), _List_fromArray([
                                $elm$html$Html$text(label)
                            ]));
                        }(),
                        $elm$html$Html$text(' or type to search')
                    ]))
                ]) : _List_Nil;
            } else return _List_Nil;
        }
    });
    var $author$project$Components$ResourceFilter$styleToClass = function(style_) {
        if (!style_) return '';
        else return 'picker';
    };
    var $author$project$Components$ResourceFilter$view = F2(function(options, model) {
        var placeholder = A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(A2($elm$core$List$map, $elm$core$Tuple$second, A2($elm$core$List$filter, $elm$core$Tuple$first, _List_fromArray([
            _Utils_Tuple2(model.z9.I5, model.z9.Ee),
            _Utils_Tuple2(model.z9.afn, model.z9.U5)
        ])))));
        var optionsRecord = $author$project$Components$ResourceFilter$optionsToRecord(options);
        var _v0 = function() {
            var _v1 = model.a0;
            if (!_v1.$) {
                var list = _v1.a;
                var options_ = A2($elm$core$List$cons, $author$project$Ui$Form$SearchableSelect$value($elm$core$Maybe$Just(optionsRecord.aa9)), model.oa || optionsRecord.Tk ? _List_fromArray([
                    $author$project$Ui$Form$SearchableSelect$loading(true)
                ]) : _List_Nil);
                var formItems = A2($elm$core$List$map, function(item) {
                    return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, $author$project$Components$ResourceFilter$One(item));
                }, list);
                var apiItemsValues = A2($elm$core$List$map, model.g4, list);
                var extraItems_ = A2($elm$core$List$map, function(item) {
                    return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, $author$project$Components$ResourceFilter$Extra(item));
                }, A2($elm_community$list_extra$List$Extra$filterNot, function(extraItem) {
                    return A2($elm$core$List$member, extraItem.aa9, apiItemsValues);
                }, model.d4));
                var freeTextItem = function() {
                    var _v2 = _Utils_Tuple3(model.z9.ad$, model.xQ, model.z9.ad8);
                    if (_v2.a && !_v2.b.$ && !_v2.c) {
                        var string = _v2.b.a;
                        return _Utils_ap($elm$core$List$isEmpty(_Utils_ap(formItems, extraItems_)) ? _List_Nil : _List_fromArray([
                            $author$project$Ui$Form$SearchableSelect$Item$divider
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, $author$project$Components$ResourceFilter$FreeText(string))
                        ]));
                    } else return _List_Nil;
                }();
                var allAndNOneOptions = A2($elm$core$List$map, $elm$core$Tuple$second, A2($elm$core$List$filter, $elm$core$Tuple$first, _List_fromArray([
                    _Utils_Tuple2(model.z9.I5, $author$project$Components$ResourceFilter$All),
                    _Utils_Tuple2(model.z9.afn, $author$project$Components$ResourceFilter$None)
                ])));
                var allAndNOneItems = $elm$core$List$isEmpty(allAndNOneOptions) ? _List_Nil : _Utils_ap(A2($elm$core$List$map, function(allOrNone) {
                    return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, allOrNone);
                }, allAndNOneOptions), _List_fromArray([
                    $author$project$Ui$Form$SearchableSelect$Item$divider
                ]));
                return _Utils_Tuple2(options_, _Utils_ap(allAndNOneItems, _Utils_ap(formItems, _Utils_ap(extraItems_, _Utils_ap(freeTextItem, A4($author$project$Components$ResourceFilter$infoItem, model.i3, list, model.oR, model.z9))))));
            } else return _Utils_Tuple2(_List_fromArray([
                $author$project$Ui$Form$SearchableSelect$loading(true)
            ]), _List_Nil);
        }();
        var selectOptions = _v0.a;
        var items = _v0.b;
        return A2($elm$html$Html$map, $author$project$Components$ResourceFilter$SelectMsg, A3($author$project$Components$ResourceFilter$ifNothing, model.a0, $author$project$Ui$Skeleton$input(_List_Nil), A3($author$project$Ui$Form$SearchableSelect$view, A2($elm$core$List$cons, $author$project$Ui$Form$SearchableSelect$placeholder(placeholder), A2($elm$core$List$cons, $author$project$Ui$Form$SearchableSelect$invalid(optionsRecord.q2), A2($elm$core$List$cons, $author$project$Ui$Form$SearchableSelect$disabled(optionsRecord.d$), A2($elm$core$List$cons, $author$project$Ui$Form$SearchableSelect$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$SearchableSelect$class(A2($elm$core$String$join, ' ', optionsRecord.EP)), A2($elm$core$List$cons, $author$project$Ui$Form$SearchableSelect$class($author$project$Components$ResourceFilter$styleToClass(optionsRecord.s5)), A2($elm$core$List$cons, $author$project$Ui$Form$SearchableSelect$class(A2($author$project$Components$ResourceFilter$activeStyleToClass, optionsRecord.s5, optionsRecord.aa9)), selectOptions))))))), items, model.sI)));
    });
    var $author$project$Components$ResourceFilter$ChargeItem$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Admin$ChargeItems$Form$viewPackageItemRow = F2(function(model, item) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = A2($elm$core$Dict$get, item.K, model.cg);
                    if (!_v0.$) {
                        var resourceFilter = _v0.a;
                        var updatedResourceFilter = function() {
                            var _v2 = _Utils_Tuple2(item.ack, item.acl);
                            if (!_v2.a.$ && !_v2.b.$) {
                                var id = _v2.a.a;
                                var name = _v2.b.a;
                                return A2($author$project$Components$ResourceFilter$ChargeItem$extraItems, _List_fromArray([
                                    {
                                        aef: id,
                                        zr: name
                                    }
                                ]), resourceFilter);
                            } else return resourceFilter;
                        }();
                        return A2($elm$html$Html$map, $author$project$Components$Admin$ChargeItems$Form$PackageItemSelected(item.K), A2($author$project$Components$ResourceFilter$ChargeItem$view, _List_fromArray([
                            $author$project$Components$ResourceFilter$value(function() {
                                var _v1 = item.ack;
                                if (!_v1.$) {
                                    var id = _v1.a;
                                    return $author$project$Components$ResourceFilter$Extra({
                                        aeI: A2($elm$core$Maybe$withDefault, '', item.acl),
                                        aa9: id
                                    });
                                } else return $author$project$Components$ResourceFilter$All;
                            }())
                        ]), updatedResourceFilter));
                    } else return $elm$html$Html$text('');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$minWidth('6em')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$text,
                    $author$project$Ui$Form$Input$value(!item.Bu ? '' : $elm$core$String$fromInt(item.Bu)),
                    $author$project$Ui$Form$Input$onInput(function(val) {
                        var qty = function() {
                            if ($elm$core$String$isEmpty(val)) return 0;
                            else {
                                var _v3 = $elm$core$String$toInt(val);
                                if (!_v3.$) {
                                    var n = _v3.a;
                                    return n >= 0 ? n : item.Bu;
                                } else return item.Bu;
                            }
                        }();
                        return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(A2($author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity, item.K, qty));
                    }),
                    $author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$ChargeItems$Form$FormUpdated(A2($author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemQuantity, item.K, !item.Bu ? 1 : item.Bu))),
                    $author$project$Ui$Form$Input$customAttributes(_List_fromArray([
                        $elm$html$Html$Attributes$type_('number'),
                        $elm$html$Html$Attributes$min('1')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                            $author$project$Ui$Form$CurrencyInput$value($author$project$Currency$toString(item.Br) === '0' ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(item.Br)),
                            $author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
                            $author$project$Ui$Form$CurrencyInput$onInput(function(val) {
                                return $author$project$Components$Admin$ChargeItems$Form$FormUpdated(A2($author$project$Components$Admin$ChargeItems$Form$UpdatePackageItemPrice, item.K, val));
                            })
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        function() {
                            var _v4 = _Utils_Tuple2(item.ack, A2($elm$core$Dict$get, item.K, model.bz));
                            if (!_v4.a.$ && !_v4.b.$) {
                                var originalPrice = _v4.b.a;
                                return !_Utils_eq(originalPrice, item.Br) ? A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$strike,
                                    $author$project$Ui$Typography$muted,
                                    $author$project$Ui$Typography$margin(20)
                                ]), _List_fromArray([
                                    $elm$html$Html$text($author$project$Currency$format(originalPrice))
                                ])) : $elm$html$Html$text('');
                            } else return $elm$html$Html$text('');
                        }()
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textCenter
            ]), _List_fromArray([
                function() {
                    var _v5 = item.acn;
                    if (!_v5.$) {
                        if (_v5.a) return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$success
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$check(_List_fromArray([
                                $author$project$Ui$Icon$success
                            ]))
                        ]));
                        else return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$danger
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$cross(_List_fromArray([
                                $author$project$Ui$Icon$danger
                            ]))
                        ]));
                    } else return A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$cross(_List_fromArray([
                            $author$project$Ui$Icon$danger
                        ]))
                    ]));
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Remove item from package'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$RemovePackageItem(item.K))),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$viewIncludesTable = F3(function(model, fields, form) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Includes')
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A4($author$project$Ui$Table$view, _List_fromArray([
                    $author$project$Ui$Table$containerClasses(_List_fromArray([
                        'table-wrapper',
                        'bg-white'
                    ]))
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Charge Item')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Quantity')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Price per Item')
                    ])),
                    A2($author$project$Ui$Table$header, _List_fromArray([
                        $author$project$Ui$Table$textCenter
                    ]), _List_fromArray([
                        $elm$html$Html$text('Taxable')
                    ])),
                    A2($author$project$Ui$Table$header, _List_fromArray([
                        $author$project$Ui$Table$textRight
                    ]), _List_fromArray([
                        $elm$html$Html$text('')
                    ]))
                ]), $elm$core$List$isEmpty(fields.VO) ? _List_fromArray([
                    A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Table$cell, _List_fromArray([
                            $author$project$Ui$Table$colspan(5),
                            $author$project$Ui$Table$textCenter
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('No items added to this package yet.')
                            ]))
                        ]))
                    ]))
                ]) : A2($elm$core$List$map, $author$project$Components$Admin$ChargeItems$Form$viewPackageItemRow(model), fields.VO), _List_Nil),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$margin(18)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Add item to package'
                    }, _List_fromArray([
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$AddPackageItem)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add to Package')
                    ]))
                ]))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 5, form))
        ]));
    });
    var $author$project$Api$FeatureGate$InventoryAndSalesTax = 2;
    var $author$project$Components$Admin$ChargeItems$Form$TrackInventory = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Employer$Practice$One$featureGates = function(_v0) {
        var record = _v0;
        return record.Pv;
    };
    var $author$project$Api$Provider$Practice$One$featureGates = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Pv;
    });
    var $author$project$Api$Practice$featureGates = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$featureGates(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$featureGates(practice_);
        }
    };
    var $author$project$Api$FeatureGate$codeToString = function(code_) {
        switch(code_){
            case 0:
                return 'multiple_signup_pages';
            case 1:
                return 'charge_uploader';
            case 2:
                return 'inventory_and_sales_tax';
            case 3:
                return 'sponsor_adhoc_invoices';
            case 4:
                return 'patient_credits';
            case 5:
                return 'patient_portal';
            case 6:
                return 'membership_pricing_schedule_plan_changes';
            case 7:
                return 'membership_pricing_advance_pricing_rules';
            case 8:
                return 'employee_uploads';
            case 9:
                return 'manage_employers';
            case 10:
                return 'customize_dunning_schedule';
            case 11:
                return 'engagement_tracking';
            case 12:
                return 'scheduled_partial_payments';
            default:
                return 'multiple_retail_memberships';
        }
    };
    var $author$project$Api$Common$FeatureGate$Shared$hasCode = F2(function(one, _v0) {
        var code = _v0.Lk;
        return _Utils_eq($author$project$Api$FeatureGate$codeToString(one), code);
    });
    var $author$project$Utils$FeatureGate$findByCode = F2(function(code_, list) {
        return A2($elm_community$list_extra$List$Extra$find, function(featureGate) {
            return A2($author$project$Api$Common$FeatureGate$Shared$hasCode, code_, featureGate);
        }, list);
    });
    var $author$project$Utils$FeatureGate$customGate = F3(function(code, practice, gated) {
        var _v0 = A2($author$project$Utils$FeatureGate$findByCode, code, $author$project$Api$Practice$featureGates(practice));
        if (!_v0.$) return $elm$core$Maybe$Just(gated);
        else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Utils$FeatureGate$gate = F3(function(code, practice, htmlMsg) {
        return A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A3($author$project$Utils$FeatureGate$customGate, code, practice, htmlMsg));
    });
    var $author$project$Components$Admin$ChargeItems$Form$viewInventoryCheckbox = F3(function(fields, practice, disabled) {
        return A3($author$project$Utils$FeatureGate$gate, 2, $author$project$Api$Practice$Provider(practice), A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Inventory')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(fields.aap),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$TrackInventory)),
                $author$project$Ui$Form$Checkbox$disabled($author$project$Utils$Uom$isTimeBased(fields.aaK) || disabled)
            ]), _List_fromArray([
                $elm$html$Html$text('Track inventory for this item')
            ])),
            $author$project$Utils$Uom$isTimeBased(fields.aaK) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$info
            ]), _List_fromArray([
                $elm$html$Html$text('Inventory tracking is not available for time based charge items.')
            ])) : $author$project$Utils$Html$empty
        ])));
    });
    var $author$project$Components$Admin$ChargeItems$Form$EditQuantity = {
        $: 11
    };
    var $author$project$Components$Admin$ChargeItems$Form$LastSetQuantity = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewInventoryInput = F3(function(fields, form, disabled) {
        return fields.aap ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Current inventory')
        ]), _List_fromArray([
            fields.iy ? $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$number,
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.SZ))),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$LastSetQuantity)),
                $author$project$Ui$Form$Input$placeholder('37'),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 3, form)),
                $author$project$Ui$Form$Input$disabled(disabled)
            ])) : A2($author$project$Ui$Form$Static$view, _List_Nil, _Utils_ap(function() {
                var _v0 = _Utils_Tuple2(fields.XT, fields.SZ);
                if (!_v0.a.$ && !_v0.b.$) {
                    var quantityInStock = _v0.a.a;
                    var lastSetQuantity = _v0.b.a;
                    return _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt(quantityInStock)),
                        $elm$html$Html$text('/'),
                        $elm$html$Html$text($elm$core$String$fromInt(lastSetQuantity))
                    ]);
                } else return _List_fromArray([
                    $elm$html$Html$text('N/A')
                ]);
            }(), _List_fromArray([
                $author$project$Utils$Html$noBreakSpace,
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit charge item'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$EditQuantity))
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ]))
            ])))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$ChargeItems$Form$AlertQuantity = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewInventoryShowWarningInput = F2(function(fields, disabled) {
        return fields.aap ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Show a warning if the quantity in inventory is below')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$number,
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.I0))),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$AlertQuantity)),
                $author$project$Ui$Form$Input$placeholder('10'),
                $author$project$Ui$Form$Input$disabled(disabled)
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$ChargeItems$Form$Manufacturer = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewManufacturerInput = F2(function(fields, disabled) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Facility / Manufacturer')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(fields.TC),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Manufacturer)),
                $author$project$Ui$Form$Input$disabled(disabled)
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewNameInput = F3(function(fields, form, disabled) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Name')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(fields.zr),
                $author$project$Ui$Form$Input$placeholder(fields.rc === 1 ? 'Package Name' : '800mg Ibuprofen'),
                $author$project$Ui$Form$Input$autofocus(true),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Name)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form)),
                $author$project$Ui$Form$Input$disabled(disabled)
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('What is being charged for on the invoice or receipt.')
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$ApplyPackagePriceAdjustment = {
        $: 3
    };
    var $author$project$Components$Admin$ChargeItems$Form$PriceInCents = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Padding$Top_1 = 6;
    var $author$project$Ui$Form$CurrencyInput$OnBlur = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$onBlur = $author$project$Ui$Form$CurrencyInput$OnBlur;
    var $author$project$Ui$Typography$Padding = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Ui$Typography$padding = $author$project$Ui$Typography$Padding;
    var $author$project$Ui$Form$CurrencyInput$Postfix = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$postfix = $author$project$Ui$Form$CurrencyInput$Postfix;
    var $author$project$Api$Provider$Uom$Shared$periodQuantity = function(_v0) {
        var record = _v0;
        return record.gq;
    };
    var $author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity = function(code) {
        return A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Uom$Shared$periodQuantity, $author$project$Utils$Uom$fromCode(code));
    };
    var $author$project$Api$Provider$Uom$Shared$periodUnit = function(_v0) {
        var record = _v0;
        return record.gr;
    };
    var $author$project$Api$Provider$Uom$PeriodUnit$toString = function(periodUnit_) {
        switch(periodUnit_){
            case 0:
                return 'days';
            case 1:
                return 'months';
            case 2:
                return 'quarters';
            case 3:
                return 'half_years';
            default:
                return 'years';
        }
    };
    var $author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit = function(code) {
        return A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$PeriodUnit$toString, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Uom$Shared$periodUnit, $author$project$Utils$Uom$fromCode(code)));
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewPackagePriceInput = F2(function(fields, form) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Package Price')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$view(A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$value(fields.Br), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$placeholder('0.00'), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$PriceInCents)), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$onBlur($author$project$Components$Admin$ChargeItems$Form$FormUpdated($author$project$Components$Admin$ChargeItems$Form$ApplyPackagePriceAdjustment)), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)), function() {
                        var _v0 = _Utils_Tuple3($author$project$Utils$Uom$isTimeBased(fields.aaK), $author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit(fields.aaK), $author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity(fields.aaK));
                        if (_v0.a && !_v0.b.$ && !_v0.c.$) {
                            var periodUnit = _v0.b.a;
                            var periodQuantity = _v0.c.a;
                            return _List_fromArray([
                                $author$project$Ui$Form$CurrencyInput$postfix('per ' + A2($author$project$Formatters$String$pluralize, periodUnit, periodQuantity))
                            ]);
                        } else return _List_Nil;
                    }()))))))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$padding(6)
                    ]), _List_fromArray([
                        $elm$html$Html$text('+ tax')
                    ]))
                ]))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, form))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$Taxable = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewPriceInput = F4(function(fields, form, practice, disabled) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Price')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(9)
                ]), _List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$view(A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$value(A2($elm$core$Maybe$andThen, function(price) {
                        return $author$project$Currency$toString(price) === '0' ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(price);
                    }, fields.Br)), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$placeholder('0.00'), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$PriceInCents)), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)), function() {
                        var _v0 = _Utils_Tuple3($author$project$Utils$Uom$isTimeBased(fields.aaK), $author$project$Components$Admin$ChargeItems$Form$uomPeriodUnit(fields.aaK), $author$project$Components$Admin$ChargeItems$Form$uomPeriodQuantity(fields.aaK));
                        if (_v0.a && !_v0.b.$ && !_v0.c.$) {
                            var periodUnit = _v0.b.a;
                            var periodQuantity = _v0.c.a;
                            return _List_fromArray([
                                $author$project$Ui$Form$CurrencyInput$postfix('per ' + A2($author$project$Formatters$String$pluralize, periodUnit, periodQuantity))
                            ]);
                        } else return _List_Nil;
                    }()))))),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, form)),
                    fields.$S ? A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Taxes will be added '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$italic
                        ]), _List_fromArray([
                            $elm$html$Html$text('on top of ')
                        ])),
                        $elm$html$Html$text('this price, at invoice-time.')
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A3($author$project$Utils$FeatureGate$gate, 2, $author$project$Api$Practice$Provider(practice), A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(fields.$S),
                        $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Taxable)),
                        $author$project$Ui$Form$Checkbox$disabled(disabled)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Taxable')
                    ])))
                ]))
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Do your members receive a discount for this product or service? '),
                A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/en/articles/5921503-configuring-coverage-plans', _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('Configure a coverage rule')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$ItemType = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Admin$ChargeItems$Form$viewTypeToggle = function(fields) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Type')
        ]), _List_fromArray([
            $author$project$Ui$Form$ButtonSelect$view({
                afv: A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$ItemType),
                z9: _List_fromArray([
                    A2($author$project$Ui$Form$ButtonSelect$option, 0, 'Item'),
                    A2($author$project$Ui$Form$ButtonSelect$option, 1, 'Package')
                ]),
                aa9: fields.rc
            })
        ]));
    };
    var $author$project$Components$Admin$ChargeItems$Form$Uom = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$ChargeItem$Meta$uomEditable = function(_v0) {
        var meta = _v0;
        return meta.aaK.Ot;
    };
    var $elm_community$list_extra$List$Extra$gatherWith = F2(function(testFn, list) {
        var helper = F2(function(scattered, gathered) {
            if (!scattered.b) return $elm$core$List$reverse(gathered);
            else {
                var toGather = scattered.a;
                var population = scattered.b;
                var _v1 = A2($elm$core$List$partition, testFn(toGather), population);
                var gathering = _v1.a;
                var remaining = _v1.b;
                return A2(helper, remaining, A2($elm$core$List$cons, _Utils_Tuple2(toGather, gathering), gathered));
            }
        });
        return A2(helper, list, _List_Nil);
    });
    var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(function(extract, list) {
        return A2($elm_community$list_extra$List$Extra$gatherWith, F2(function(a, b) {
            return _Utils_eq(extract(a), extract(b));
        }), list);
    });
    var $author$project$Ui$Form$Select$Group = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$Select$group = $author$project$Ui$Form$Select$Group;
    var $author$project$Api$Provider$Uom$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Components$Admin$ChargeItems$Form$uomGroupOptions = function(uoms) {
        return A2($elm$core$List$map, function(uom_) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Uom$Shared$code(uom_)), $author$project$Api$Provider$Uom$Shared$name(uom_));
        }, uoms);
    };
    var $author$project$Components$Admin$ChargeItems$Form$uomOptions = A2($elm$core$List$map, function(_v0) {
        var uom = _v0.a;
        var uoms = _v0.b;
        return A2($author$project$Ui$Form$Select$group, $author$project$Api$Provider$Uom$Shared$type_(uom), $author$project$Components$Admin$ChargeItems$Form$uomGroupOptions(A2($elm$core$List$cons, uom, uoms)));
    }, A2($elm_community$list_extra$List$Extra$gatherEqualsBy, $author$project$Api$Provider$Uom$Shared$type_, $author$project$Api$Provider$Uom$list($elm$core$Basics$identity)));
    var $author$project$Components$Admin$ChargeItems$Form$viewUnitOfMeasureSelect = F3(function(fields, form, disabled) {
        var uomEditable = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Meta$uomEditable, fields.Ue));
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Unit of Measure')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(fields.aaK)),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$ChargeItems$Form$FormUpdated, $author$project$Components$Admin$ChargeItems$Form$Uom)),
                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, form)),
                $author$project$Ui$Form$Select$disabled(!uomEditable || disabled)
            ]), $author$project$Components$Admin$ChargeItems$Form$uomOptions),
            uomEditable ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$info
            ]), _List_fromArray([
                $elm$html$Html$text('Cannot be edited while this charge is recurring on memberships.')
            ]))
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$viewForm = F2(function(model, form) {
        var fields = $author$project$Utils$Form$fields(form);
        var typeToggle = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1) ? _List_fromArray([
            $author$project$Components$Admin$ChargeItems$Form$viewTypeToggle(fields)
        ]) : _List_Nil;
        var disable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.W1) && model.yq;
        if (fields.rc === 1) {
            var buyableEditable = function() {
                var _v0 = fields.Ue;
                if (!_v0.$) {
                    var meta = _v0.a;
                    return $author$project$Api$Provider$ChargeItem$Meta$buyableEditable(meta);
                } else return A2($author$project$Api$Provider$Practice$One$featureEnabled, 23, model.W1);
            }();
            return $elm$core$List$concat(_List_fromArray([
                typeToggle,
                A2($elm$core$List$cons, A3($author$project$Components$Admin$ChargeItems$Form$viewNameInput, fields, form, disable), _Utils_ap(buyableEditable ? _List_fromArray([
                    A2($author$project$Components$Admin$ChargeItems$Form$viewImageField, A2($author$project$Utils$Form$validationErrors, 7, form), fields.p7),
                    A2($elm$html$Html$map, $author$project$Components$Admin$ChargeItems$Form$RichDescriptionMsg, A2($author$project$Components$TranslatedRichText$view, {
                        adg: 'charge-item-rich-description-editor',
                        aeI: 'Rich Description',
                        afr: false
                    }, fields.eD))
                ]) : _List_Nil, _List_fromArray([
                    A3($author$project$Components$Admin$ChargeItems$Form$viewIncludesTable, model, fields, form),
                    A2($author$project$Components$Admin$ChargeItems$Form$viewPackagePriceInput, fields, form),
                    A3($author$project$Components$Admin$ChargeItems$Form$viewExpirationCheckbox, fields, form, disable),
                    A2($author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput, fields, disable),
                    A2($author$project$Components$Admin$ChargeItems$Form$viewCategoryInput, model.cK, disable),
                    buyableEditable ? A2($author$project$Components$Admin$ChargeItems$Form$viewBuyableCheckbox, fields, disable) : $author$project$Utils$Html$empty,
                    $author$project$Components$Admin$ChargeItems$Form$viewAdvancedSettings(fields)
                ])))
            ]));
        } else return $elm$core$List$concat(_List_fromArray([
            typeToggle,
            _List_fromArray([
                A3($author$project$Components$Admin$ChargeItems$Form$viewNameInput, fields, form, disable),
                A3($author$project$Components$Admin$ChargeItems$Form$viewUnitOfMeasureSelect, fields, form, disable),
                A2($author$project$Components$Admin$ChargeItems$Form$viewDaysSupplyInput, fields, disable),
                A4($author$project$Components$Admin$ChargeItems$Form$viewPriceInput, fields, form, model.W1, disable),
                A2($author$project$Components$Admin$ChargeItems$Form$viewCategoryInput, model.cK, disable),
                A3($author$project$Components$Admin$ChargeItems$Form$viewInventoryCheckbox, fields, model.W1, disable),
                A3($author$project$Components$Admin$ChargeItems$Form$viewInventoryInput, fields, form, disable),
                A2($author$project$Components$Admin$ChargeItems$Form$viewInventoryShowWarningInput, fields, disable),
                A4($author$project$Components$Admin$ChargeItems$Form$viewCodeInput, fields, form, model.lz, disable),
                A2($author$project$Components$Admin$ChargeItems$Form$viewManufacturerInput, fields, disable),
                A2($author$project$Components$Admin$ChargeItems$Form$viewDescriptionInput, fields, disable)
            ])
        ]));
    });
    var $author$project$Components$Admin$ChargeItems$Form$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        function() {
                            var _v1 = model.aef;
                            if (!_v1.$) return $elm$html$Html$text('Edit');
                            else return $elm$html$Html$text('New Item');
                        }()
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$pull(1)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Delete charge item'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$BackButtonClicked),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$cross)
                            ]), _List_Nil)
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        function() {
                            var _v2 = model.aef;
                            if (!_v2.$) return $elm$html$Html$text('Any changes will affect current recurring charges and future created charges.');
                            else return $elm$html$Html$text('Create a new charge item that can be selected from a saved menu.');
                        }()
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, function() {
                    var _v3 = model.PU;
                    if (!_v3.$) {
                        var form = _v3.a;
                        return A2($author$project$Components$Admin$ChargeItems$Form$viewForm, model, form);
                    } else return _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]))
                    ]);
                }()),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Go back'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$BackButtonClicked)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Back')
                    ])),
                    function() {
                        var verb = function() {
                            var _v4 = model.aef;
                            if (!_v4.$) return 'Update';
                            else return 'Create';
                        }();
                        return A3($author$project$Ui$Button$view, {
                            abP: verb + ' Charge'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$ChargeItems$Form$Save)
                        ]), _List_fromArray([
                            $elm$html$Html$text(verb)
                        ]));
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$ChargeItems$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$ChargeItems$Form$view(model.PU))
            ]),
            $2: 'Admin | Charge Items'
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$ChargeItems$Id_String$init,
        aeR: $author$project$Pages$Admin$ChargeItems$Id_String$load,
        ag3: $author$project$Pages$Admin$ChargeItems$Id_String$save,
        ahE: $author$project$Pages$Admin$ChargeItems$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$ChargeItems$Id_String$update,
        aid: $author$project$Pages$Admin$ChargeItems$Id_String$view
    });
    var $author$project$Pages$Admin$ChargeItems$New$ChargeItemFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$ChargeItems$New$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var _v2 = A4($author$project$Components$Admin$ChargeItems$Form$init, apiClient, session, $elm$core$Maybe$Nothing, practice);
        var form = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$ChargeItems$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$ChargeItems$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$ChargeItems$New$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$ChargeItems$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$Admin$ChargeItems$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$ChargeItems$Form$update, model.Ej, subMsg, model.PU);
        var newForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Admin$ChargeItems$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$ChargeItems$Form$view(model.PU))
            ]),
            $2: 'Admin | Charge Items'
        };
    };
    var $author$project$Pages$Admin$ChargeItems$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$ChargeItems$New$init,
        aeR: $author$project$Pages$Admin$ChargeItems$New$load,
        ag3: $author$project$Pages$Admin$ChargeItems$New$save,
        ahE: $author$project$Pages$Admin$ChargeItems$New$subscriptions,
        aaO: $author$project$Pages$Admin$ChargeItems$New$update,
        aid: $author$project$Pages$Admin$ChargeItems$New$view
    });
    var $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$InventoryDropdownMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$ItemTypeDropdownMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$GotChargeItems = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString = function(status) {
        switch(status){
            case 0:
                return 'in_stock';
            case 1:
                return 'low_inventory';
            default:
                return 'out_of_stock';
        }
    };
    var $author$project$Pages$Admin$ChargeItems$Top$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                EL: model.fg,
                FW: A2($elm$core$Maybe$map, $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString, model.FW),
                rc: A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString, model.rc),
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$fetchItems = function(model) {
        return A3($author$project$Api$Provider$ChargeItem$list, model.Ej, $author$project$Pages$Admin$ChargeItems$Top$fetchParams(model), $author$project$Pages$Admin$ChargeItems$Top$GotChargeItems);
    };
    var $author$project$Ui$SearchInput$Model = $elm$core$Basics$identity;
    var $author$project$Ui$SearchInput$init = function(text) {
        return {
            dJ: $jinjor$elm_debounce$Debounce$init,
            $Y: text
        };
    };
    var $author$project$Utils$Report$CategoryResourceFilter$init = F3(function(apiClient, session, categoryId) {
        return A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'All Categories',
                U5: 'Unassigned',
                afn: true,
                agj: categoryId
            });
        });
    });
    var $author$project$Api$Column$Column = $elm$core$Basics$identity;
    var $author$project$Api$Column$init = F3(function(id, sortable, name) {
        return {
            aef: id,
            zr: name,
            z9: _List_Nil,
            Hv: sortable
        };
    });
    var $author$project$Pages$Admin$ChargeItems$Top$initColumns = function(practice) {
        var taxableColumn = A2($elm$core$Maybe$withDefault, _List_Nil, A3($author$project$Utils$FeatureGate$customGate, 2, $author$project$Api$Practice$Provider(practice), _List_fromArray([
            A3($author$project$Api$Column$init, 'taxable', false, 'Taxable')
        ])));
        var itemTypeColumn = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? _List_fromArray([
            A3($author$project$Api$Column$init, 'item_type', true, 'Item Type')
        ]) : _List_Nil;
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'name', true, 'Name'),
                A3($author$project$Api$Column$init, 'price_in_cents', true, 'Price'),
                A3($author$project$Api$Column$init, 'category', true, 'Category')
            ]),
            itemTypeColumn,
            taxableColumn
        ]));
    };
    var $author$project$Api$Pagination$pageParamName = function(prefix) {
        return prefix + 'page';
    };
    var $author$project$Api$Pagination$fromQuery = F2(function(query, _v0) {
        var model = _v0;
        var currentPage = A2($elm$core$Maybe$withDefault, 1, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, $author$project$Api$Pagination$pageParamName(model.sg), query)));
        return _Utils_update(model, {
            bt: currentPage
        });
    });
    var $author$project$Api$Pagination$initFromQuery = function(query) {
        return A2($author$project$Api$Pagination$fromQuery, query, $author$project$Api$Pagination$init);
    };
    var $author$project$Api$Sort$Asc = 0;
    var $author$project$Api$Sort$Desc = 1;
    var $author$project$Api$Sort$fromQuery = F2(function(query, _v0) {
        var model = _v0;
        var _v1 = A2($elm$core$Dict$get, $author$project$Api$Sort$pageParamName(model.sg), query);
        if (!_v1.$) {
            var sort = _v1.a;
            var direction = A2($elm$core$String$startsWith, '-', sort) ? 1 : 0;
            return _Utils_update(model, {
                Nn: $elm$core$Maybe$Nothing,
                aa9: $elm$core$Maybe$Just(_Utils_Tuple2(A3($elm$core$String$replace, '-', '', sort), direction))
            });
        } else return model;
    });
    var $author$project$Api$Sort$initFromQuery = function(query) {
        return A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init);
    };
    var $author$project$Pages$Admin$ChargeItems$Top$stringToItemType = function(str) {
        switch(str){
            case 'item':
                return $elm$core$Maybe$Just(0);
            case 'package':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Pages$Admin$ChargeItems$Top$InStock = 0;
    var $author$project$Pages$Admin$ChargeItems$Top$LowInventory = 1;
    var $author$project$Pages$Admin$ChargeItems$Top$OutOfStock = 2;
    var $author$project$Pages$Admin$ChargeItems$Top$stringToStockStatus = function(str) {
        switch(str){
            case 'in_stock':
                return $elm$core$Maybe$Just(0);
            case 'low_inventory':
                return $elm$core$Maybe$Just(1);
            case 'out_of_stock':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $elm$url$Url$Builder$relative = F2(function(pathSegments, parameters) {
        return _Utils_ap(A2($elm$core$String$join, '/', pathSegments), $elm$url$Url$Builder$toQuery(parameters));
    });
    var $elm$url$Url$Builder$int = F2(function(key, value) {
        return A2($elm$url$Url$Builder$QueryParameter, $elm$url$Url$percentEncode(key), $elm$core$String$fromInt(value));
    });
    var $author$project$Api$Pagination$perPageParamName = function(prefix) {
        return prefix + 'per_page';
    };
    var $author$project$Api$Pagination$toPageQuery = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            A2($elm$url$Url$Builder$int, $author$project$Api$Pagination$pageParamName(model.sg), model.bt),
            A2($elm$url$Url$Builder$int, $author$project$Api$Pagination$perPageParamName(model.sg), model.fY)
        ]);
    };
    var $author$project$Api$Sort$toQuery = function(_v0) {
        var model = _v0;
        return A2($elm$core$List$concatMap, $author$project$Api$Param$toQuery, A2($author$project$Api$Sort$toPrefixeddParams, model.sg, model));
    };
    var $author$project$Pages$Admin$ChargeItems$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('category'), model.fg),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('inventory'), A2($elm$core$Maybe$map, $author$project$Pages$Admin$ChargeItems$Top$stockStatusToString, model.FW)),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('item_type'), A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Shared$itemTypeToString, model.rc))
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__ChargeItems__Top)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Admin$ChargeItems$Top$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var categoryId = A2($elm$core$Dict$get, 'category', query);
        var apiClient = shared.Ej;
        var _v1 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
        var categoryResourceFilter = _v1.a;
        var categoryResourceFilterCmd = _v1.b;
        var model = {
            Ej: apiClient,
            fg: categoryId,
            cK: categoryResourceFilter,
            bp: $author$project$Api$Data$Loading,
            LC: $author$project$Pages$Admin$ChargeItems$Top$initColumns(practice),
            id: $elm$core$Maybe$Nothing,
            dO: $elm$core$Set$empty,
            adm: shared.adU.adm,
            FW: A2($elm$core$Maybe$andThen, $author$project$Pages$Admin$ChargeItems$Top$stringToStockStatus, A2($elm$core$Dict$get, 'inventory', query)),
            mB: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'inventory-dropdown-filter',
                ahX: $author$project$Pages$Admin$ChargeItems$Top$InventoryDropdownMsg
            })),
            F3: $author$project$Shared$isHintAdmin(shared),
            rc: A2($elm$core$Maybe$andThen, $author$project$Pages$Admin$ChargeItems$Top$stringToItemType, A2($elm$core$Dict$get, 'item_type', query)),
            mP: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'item-type-dropdown-filter',
                ahX: $author$project$Pages$Admin$ChargeItems$Top$ItemTypeDropdownMsg
            })),
            afY: shared.adU.afY,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: $author$project$Api$Sort$initFromQuery(query),
            HO: shared.HO
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            $author$project$Pages$Admin$ChargeItems$Top$fetchItems(model),
            $author$project$Pages$Admin$ChargeItems$Top$updateUrl(model)
        ])));
    });
    var $author$project$Pages$Admin$ChargeItems$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$ChargeItems$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$ChargeItems$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed), $author$project$Api$Provider$ChargeItem$All$id), model.id)),
            $author$project$Ui$Dropdown$subscriptions(model.mB),
            $author$project$Ui$Dropdown$subscriptions(model.mP),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg, $author$project$Components$ResourceFilter$Category$subscriptions(model.cK))
        ]));
    };
    var $author$project$Pages$Admin$ChargeItems$Top$Deleted = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$ChargeItem$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemPath(id_)));
    });
    var $author$project$Api$Sort$update = F2(function(column, _v0) {
        var model = _v0;
        var _v1 = function() {
            var _v2 = $author$project$Api$Sort$valueOrDefault(model);
            if (!_v2.$) {
                var _v3 = _v2.a;
                var currentColumn = _v3.a;
                var currentDirection = _v3.b;
                return _Utils_eq(currentColumn, column) ? currentDirection === 1 ? _Utils_Tuple2(column, 0) : _Utils_Tuple2(column, 1) : _Utils_Tuple2(column, 0);
            } else return _Utils_Tuple2(column, 0);
        }();
        var newColumn = _v1.a;
        var newDirection = _v1.b;
        return _Utils_update(model, {
            aa9: $elm$core$Maybe$Just(_Utils_Tuple2(newColumn, newDirection))
        });
    });
    var $author$project$Components$FileLink$GotFile = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $elm$file$File$Download$bytes = F3(function(name, mime, content) {
        return A2($elm$core$Task$perform, $elm$core$Basics$never, A3(_File_download, name, mime, _File_makeBytesSafeForInternetExplorer(content)));
    });
    var $author$project$Api$Data$formatToMimeType = function(format) {
        return 'text/csv';
    };
    var $elm$http$Http$expectBytesResponse = F2(function(toMsg, toResult) {
        return A3(_Http_expect, 'arraybuffer', _Http_toDataView, A2($elm$core$Basics$composeR, toResult, toMsg));
    });
    var $author$project$Api$Data$handleBytesResponse = function(response) {
        if (response.$ === 4) {
            var metadata = response.a;
            var body = response.b;
            return $elm$core$Result$Ok(_Utils_Tuple2(body, metadata.iL));
        } else return $elm$core$Result$Err($author$project$Api$Data$BadUrl);
    };
    var $author$project$Api$Data$expectString = function(toMsg) {
        return A2($elm$http$Http$expectBytesResponse, A2($elm$core$Basics$composeR, $author$project$Api$Data$fromResult, toMsg), $author$project$Api$Data$handleBytesResponse);
    };
    var $author$project$Api$Data$getFile = F3(function(client, url, toMsg) {
        return $elm$http$Http$request({
            fb: $elm$http$Http$emptyBody,
            Pb: $author$project$Api$Data$expectString(toMsg),
            iL: $author$project$Api$Data$clientHeaders(client),
            Gk: $elm$core$String$toUpper('get'),
            HQ: $elm$core$Maybe$Just(61000),
            tu: $elm$core$Maybe$Nothing,
            aaT: url
        });
    });
    var $author$project$Api$Data$getFileNameFromHeaders = function(headers) {
        return A2($elm$core$Maybe$map, A2($elm$core$String$replace, '\"', ''), A2($elm$core$Maybe$andThen, $elm$core$List$head, A2($elm$core$Maybe$andThen, $elm$core$List$tail, A2($elm$core$Maybe$map, $elm$core$String$split(' filename='), A2($elm$core$Maybe$andThen, $elm$core$List$head, A2($elm$core$Maybe$map, $elm$core$String$split('; filename*'), A2($elm$core$Dict$get, 'content-disposition', headers)))))));
    };
    var $author$project$Components$FileLink$update = function(msg) {
        if (!msg.$) {
            var client = msg.a;
            var url = msg.b;
            var format = msg.c;
            var fetchFile = A3($author$project$Api$Data$getFile, client, url, $author$project$Components$FileLink$GotFile(format));
            return _Utils_Tuple2(fetchFile, _List_Nil);
        } else {
            var format = msg.a;
            var response = msg.b;
            if (response.$ === 3) {
                var file = response.a;
                var headers = response.b;
                var fileName = A2($elm$core$Maybe$withDefault, 'export.' + $author$project$Api$Data$formatToString(format), $author$project$Api$Data$getFileNameFromHeaders(headers));
                return _Utils_Tuple2(A3($elm$file$File$Download$bytes, fileName, $author$project$Api$Data$formatToMimeType(format), file), _List_Nil);
            } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    };
    var $author$project$Ui$SearchInput$None = {
        $: 0
    };
    var $author$project$Ui$SearchInput$SearchChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$DebouncedMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$debounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(300),
        ah3: $author$project$Ui$SearchInput$DebouncedMsg
    };
    var $author$project$Ui$SearchInput$TextDebounced = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$debounceText = function(text) {
        return A2($elm$core$Task$perform, $author$project$Ui$SearchInput$TextDebounced, $elm$core$Task$succeed(text));
    };
    var $author$project$Ui$SearchInput$emitSearchChanged = function(text) {
        return $author$project$Ui$SearchInput$SearchChanged($author$project$Utils$String$toMaybe(text));
    };
    var $author$project$Ui$SearchInput$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var isImmediate = msg.a;
                var text = msg.b;
                if (isImmediate) return _Utils_Tuple3(_Utils_update(model, {
                    $Y: $author$project$Utils$String$toMaybe(text)
                }), $elm$core$Platform$Cmd$none, $author$project$Ui$SearchInput$emitSearchChanged(text));
                else {
                    var _v2 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Ui$SearchInput$debounceConfig, text, model.dJ);
                    var newDebouncer = _v2.a;
                    var cmd = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        dJ: newDebouncer,
                        $Y: $author$project$Utils$String$toMaybe(text)
                    }), cmd, $author$project$Ui$SearchInput$None);
                }
            case 1:
                var debounceMsg = msg.a;
                var _v3 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Ui$SearchInput$debounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Ui$SearchInput$debounceText), debounceMsg, model.dJ);
                var newDebouncer = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    dJ: newDebouncer
                }), cmd, $author$project$Ui$SearchInput$None);
            case 2:
                var text = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Ui$SearchInput$emitSearchChanged(text));
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    $Y: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, $author$project$Ui$SearchInput$SearchChanged($elm$core$Maybe$Nothing));
        }
    });
    var $author$project$Pages$Admin$ChargeItems$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bp: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    bp: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            bp: $author$project$Api$Data$Loading,
                            dO: A2($elm$core$Set$remove, id, model.dO)
                        }), $author$project$Pages$Admin$ChargeItems$Top$fetchItems(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Charge item successfully deleted')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dO: A2($elm$core$Set$remove, id, model.dO)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
                    $author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 4:
                var chargeItem = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    id: $elm$core$Maybe$Just(chargeItem)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    id: $elm$core$Maybe$Nothing,
                    dO: A2($elm$core$Set$insert, id, model.dO)
                }), A3($author$project$Api$Provider$ChargeItem$delete, model.Ej, id, $author$project$Pages$Admin$ChargeItems$Top$Deleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    id: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 0:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
                    $author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 6:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v3.a;
                var searchInputCmd = _v3.b;
                var searchInputEvent = _v3.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v4 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            bp: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$ChargeItems$Top$fetchItems(qModel),
                            $author$project$Pages$Admin$ChargeItems$Top$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 7:
                var subMsg = msg.a;
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, model.Ej, subMsg, model.cK);
                var categoryId = function() {
                    var _v7 = categoryResourceResult.adu;
                    if (!_v7.$) {
                        if (!_v7.a.$) return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi);
                        else {
                            var _v8 = _v7.a;
                            return model.fg;
                        }
                    } else return model.fg;
                }();
                var newModel = _Utils_update(model, {
                    fg: categoryId,
                    cK: categoryResourceResult.zi
                });
                var _v6 = _Utils_eq(model.fg, newModel.fg) ? _Utils_Tuple2(model.bp, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
                    $author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
                ])));
                var chargeItems = _v6.a;
                var cmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    bp: chargeItems
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg, categoryResourceResult.EQ),
                    cmd
                ])), categoryResourceResult.at);
            case 8:
                var subMsg = msg.a;
                var _v9 = A2($author$project$Ui$Dropdown$update, subMsg, model.mB);
                var inventoryDropdown = _v9.a;
                var cmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mB: inventoryDropdown
                }), cmd, _List_Nil);
            case 9:
                var selectedStatus = msg.a;
                var newModel = _Utils_update(model, {
                    bp: $author$project$Api$Data$Loading,
                    FW: selectedStatus,
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
                    $author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 10:
                var subMsg = msg.a;
                var _v10 = A2($author$project$Ui$Dropdown$update, subMsg, model.mP);
                var itemTypeDropdown = _v10.a;
                var cmd = _v10.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mP: itemTypeDropdown
                }), cmd, _List_Nil);
            case 11:
                var selectedType = msg.a;
                var newModel = _Utils_update(model, {
                    bp: $author$project$Api$Data$Loading,
                    rc: selectedType,
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$ChargeItems$Top$fetchItems(newModel),
                    $author$project$Pages$Admin$ChargeItems$Top$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v11 = $author$project$Components$FileLink$update(subMsg);
                var getFileCmdMsg = _v11.a;
                var outMsgs = _v11.b;
                return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg, getFileCmdMsg), outMsgs);
        }
    });
    var $author$project$Pages$Admin$ChargeItems$Top$PaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Link$ButtonDefault = 2;
    var $author$project$Ui$Link$buttonDefault = $author$project$Ui$Link$Style(2);
    var $author$project$Ui$Link$Icon = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Ui$Link$icon = $author$project$Ui$Link$Icon;
    var $author$project$Ui$Link$Pull = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Link$pull = $author$project$Ui$Link$Pull;
    var $author$project$Ui$SearchInput$Clear = {
        $: 3
    };
    var $author$project$Ui$SearchInput$InputChanged = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$Input$AutoCapitalize = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$autoCapitalize = $author$project$Ui$Form$Input$AutoCapitalize;
    var $author$project$Ui$Form$Input$Id = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$id = $author$project$Ui$Form$Input$Id;
    var $author$project$Ui$SearchInput$defaultOptions = {
        vH: false,
        aef: $elm$core$Maybe$Nothing,
        yb: false,
        Tk: false,
        A3: false,
        r7: 'Search'
    };
    var $author$project$Ui$SearchInput$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var string = option.a;
                    return _Utils_update(record, {
                        r7: string
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(record, {
                        A3: bool
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Tk: bool
                    });
                case 3:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vH: bool
                    });
                case 4:
                    var string = option.a;
                    return _Utils_update(record, {
                        aef: $elm$core$Maybe$Just(string)
                    });
                default:
                    return _Utils_update(record, {
                        yb: true
                    });
            }
        }), $author$project$Ui$SearchInput$defaultOptions, options);
    };
    var $author$project$Ui$Form$Input$Wrapped = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$wrapped = $author$project$Ui$Form$Input$Wrapped;
    var $author$project$Ui$SearchInput$view = F2(function(options, _v0) {
        var model = _v0;
        var optionsRecord = $author$project$Ui$SearchInput$optionsToRecord(options);
        return $author$project$Ui$Form$Input$view($elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', model.$Y)),
                $author$project$Ui$Form$Input$placeholder(optionsRecord.r7),
                $author$project$Ui$Form$Input$phi(optionsRecord.A3),
                $author$project$Ui$Form$Input$onInput($author$project$Ui$SearchInput$InputChanged(optionsRecord.yb)),
                $author$project$Ui$Form$Input$autofocus(optionsRecord.vH),
                $author$project$Ui$Form$Input$autoComplete(false),
                $author$project$Ui$Form$Input$autoCapitalize(false),
                $author$project$Ui$Form$Input$test('search-input'),
                $author$project$Ui$Form$Input$wrapped(_List_fromArray([
                    function() {
                        var _v1 = model.$Y;
                        if (!_v1.$) return A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('input-wrapper__icon cursor-pointer'),
                            $elm$html$Html$Events$onClick($author$project$Ui$SearchInput$Clear)
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$cross(_List_Nil)
                        ]));
                        else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]),
            function() {
                var _v2 = optionsRecord.aef;
                if (!_v2.$) {
                    var idValue = _v2.a;
                    return _List_fromArray([
                        $author$project$Ui$Form$Input$id(idValue)
                    ]);
                } else return _List_Nil;
            }()
        ])));
    });
    var $author$project$Pages$Admin$ChargeItems$Top$viewCategoryResourceFilter = function(categoryResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Pages$Admin$ChargeItems$Top$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$viewNew, _List_Nil, categoryResourceFilter));
    };
    var $author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel = function(status) {
        switch(status){
            case 0:
                return 'In Stock';
            case 1:
                return 'Low Inventory';
            default:
                return 'Out of Stock';
        }
    };
    var $author$project$Pages$Admin$ChargeItems$Top$viewInventoryDropdown = function(model) {
        var currentLabel = function() {
            var _v0 = model.FW;
            if (!_v0.$) {
                var status = _v0.a;
                return $author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel(status);
            } else return 'All Inventory';
        }();
        var allStatuses = _List_fromArray([
            0,
            1,
            2
        ]);
        var items = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected($elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Inventory')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$ChargeItems$Top$InventoryStatusSelected($elm$core$Maybe$Just(status)))
            ]), $elm$html$Html$text($author$project$Pages$Admin$ChargeItems$Top$stockStatusToLabel(status)));
        }, allStatuses)));
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentLabel)
        ]), items, model.mB);
    };
    var $author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel = function(itemType) {
        if (!itemType) return 'Items';
        else return 'Packages';
    };
    var $author$project$Pages$Admin$ChargeItems$Top$viewItemTypeDropdown = function(model) {
        var itemTypes = _List_fromArray([
            1,
            0
        ]);
        var items = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected($elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Item Types')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(itemType) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$ChargeItems$Top$ItemTypeSelected($elm$core$Maybe$Just(itemType)))
            ]), $elm$html$Html$text($author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel(itemType)));
        }, itemTypes)));
        var currentLabel = function() {
            var _v0 = model.rc;
            if (!_v0.$) {
                var itemType = _v0.a;
                return $author$project$Pages$Admin$ChargeItems$Top$itemTypeToLabel(itemType);
            } else return 'All Item Types';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentLabel)
        ]), items, model.mP);
    };
    var $author$project$Api$Data$CSV = 0;
    var $author$project$Ui$Tooltip$Left = 2;
    var $author$project$Pages$Admin$ChargeItems$Top$SortTable = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Column$Sortable = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Link$AriaLabel = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Ui$Link$ariaLabel = $author$project$Ui$Link$AriaLabel;
    var $author$project$Api$Data$downloadUrl = F4(function(_v0, path, format, queryParams) {
        var client = _v0;
        var absolutePath = A2($elm$url$Url$Builder$crossOrigin, client.Bo, A2($elm$core$List$cons, 'api', A2($author$project$Api$Data$pathToPieces, $elm$core$Maybe$Just(format), path)));
        return absolutePath(queryParams);
    });
    var $author$project$Pages$Admin$ChargeItems$Top$exportCsvPath = function(model) {
        var csvParams = A2($elm$core$List$concatMap, $author$project$Api$Param$toQuery, $author$project$Api$Provider$ChargeItem$listOptionsToParams($author$project$Pages$Admin$ChargeItems$Top$fetchParams(model)));
        return A4($author$project$Api$Data$downloadUrl, model.Ej, $author$project$Api$Provider$ChargeItem$chargeItemsPath, 0, csvParams);
    };
    var $author$project$Ui$Panel$Table = F4(function(a, b, c, d) {
        return {
            $: 3,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Ui$Panel$table = $author$project$Ui$Panel$Table;
    var $author$project$Ui$Icon$Upload = 50;
    var $author$project$Ui$Icon$upload = $author$project$Ui$Icon$viewIcon(50);
    var $author$project$Ui$Table$OnClick = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Table$onClick = $author$project$Ui$Table$OnClick;
    var $author$project$Ui$Table$Sortable = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Ui$Table$sortable = $author$project$Ui$Table$Sortable;
    var $author$project$Ui$Table$Asc = 0;
    var $author$project$Ui$Table$Desc = 1;
    var $author$project$Api$Sort$directionToTable = function(direction) {
        if (!direction) return 0;
        else return 1;
    };
    var $author$project$Ui$Table$SortDirection = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Ui$Table$sortDirection = $author$project$Ui$Table$SortDirection;
    var $author$project$Api$Sort$toTable = F2(function(column, _v0) {
        var model = _v0;
        var _v1 = $author$project$Api$Sort$valueOrDefault(model);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var currentColumn = _v2.a;
            var currentDirection = _v2.b;
            return _Utils_eq(currentColumn, column) ? _List_fromArray([
                $author$project$Ui$Table$sortDirection($author$project$Api$Sort$directionToTable(currentDirection))
            ]) : _List_Nil;
        } else return _List_Nil;
    });
    var $author$project$Api$Column$view = F2(function(type_, _v0) {
        var column = _v0;
        var atributtesFromType = function() {
            if (!type_.$) {
                var sort = type_.a;
                var toMsg = type_.b;
                return $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        $author$project$Ui$Table$sortable(column.Hv)
                    ]),
                    column.Hv ? _List_fromArray([
                        $author$project$Ui$Table$onClick(toMsg(column.aef))
                    ]) : _List_Nil,
                    A2($author$project$Api$Sort$toTable, column.aef, sort)
                ]));
            } else return _List_Nil;
        }();
        return A2($author$project$Ui$Table$header, _Utils_ap(atributtesFromType, column.z9), _List_fromArray([
            $elm$html$Html$text(column.zr)
        ]));
    });
    var $author$project$Components$FileLink$ExportClicked = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$FileLink$view = F3(function(_v0, linkOptions, linkContent) {
        var client = _v0.Li;
        var url = _v0.aaT;
        var format = _v0.PX;
        return A3($author$project$Ui$Link$externalHref, '#', A2($elm$core$List$cons, $author$project$Ui$Link$onClick(A3($author$project$Components$FileLink$ExportClicked, client, url, format)), linkOptions), linkContent);
    });
    var $author$project$Pages$Admin$ChargeItems$Top$OpenHiConfirm = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Feature$UnifiedExperience = 19;
    var $author$project$Utils$Clinical$getHost = F3(function(isUnifiedExperience, origin, emrHost) {
        return isUnifiedExperience ? origin : emrHost;
    });
    var $author$project$Utils$Clinical$getInventoryUrl = F4(function(isUnifiedExperience, origin, emrHost, searchTerm) {
        return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + ('/inventory/list?search=' + searchTerm);
    });
    var $author$project$Api$Provider$ChargeItem$All$isMedication = function(chargeItem) {
        var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$name, $author$project$Api$Provider$ChargeItem$All$category(chargeItem));
        if (!_v0.$) {
            var categoryName_ = _v0.a;
            return categoryName_ === 'Medications';
        } else return false;
    };
    var $author$project$Api$Provider$ChargeItem$All$lastSetQuantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$lastSetQuantity(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$lastUsedAt = function(_v0) {
        var record = _v0.b;
        return record.S$;
    };
    var $author$project$Api$Provider$ChargeItem$All$lastUsedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$lastUsedAt(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$lowInventory = function(_v0) {
        var record = _v0.b;
        return record.Tw;
    };
    var $author$project$Api$Provider$ChargeItem$All$lowInventory = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$lowInventory(shared);
    };
    var $author$project$Api$Provider$ChargeItem$Shared$outOfStock = function(_v0) {
        var record = _v0.b;
        return record.VI;
    };
    var $author$project$Api$Provider$ChargeItem$All$outOfStock = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$outOfStock(shared);
    };
    var $author$project$Pages$Admin$ChargeItems$Top$viewItem = F6(function(practice, origin, emrHost, timeFormatter, deletingChargeItems, chargeItem) {
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$ChargeItem$All$name(chargeItem)),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    function() {
                        var _v0 = $author$project$Api$Provider$ChargeItem$All$lastUsedAt(chargeItem);
                        if (!_v0.$) {
                            var lastUsedAt = _v0.a;
                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text('Last charged ' + A2(timeFormatter, 1, lastUsedAt))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$formatFromFloat($author$project$Api$Provider$ChargeItem$All$priceInCents(chargeItem))),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text('per '),
                        $elm$html$Html$text($author$project$Api$Provider$Uom$Shared$name($author$project$Api$Provider$ChargeItem$All$uom(chargeItem)))
                    ])),
                    function() {
                        var _v1 = _Utils_Tuple2($author$project$Api$Provider$ChargeItem$All$lastSetQuantity(chargeItem), $author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem));
                        if (!_v1.a.$ && !_v1.b.$) {
                            var lastSetQuantity = _v1.a.a;
                            var quantityInStock = _v1.b.a;
                            return A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text($elm$core$String$fromInt(quantityInStock)),
                                $elm$html$Html$text('/'),
                                $elm$html$Html$text($elm$core$String$fromInt(lastSetQuantity))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v2 = _Utils_Tuple2($author$project$Api$Provider$ChargeItem$All$lowInventory(chargeItem), $author$project$Api$Provider$ChargeItem$All$quantityInStock(chargeItem));
                        if (_v2.a) {
                            if (_v2.b.$ === 1) {
                                var _v3 = _v2.b;
                                return $author$project$Utils$Html$empty;
                            } else {
                                if (!_v2.b.a) return $author$project$Utils$Html$empty;
                                else return A2($author$project$Ui$Typography$label, _List_fromArray([
                                    $author$project$Ui$Typography$warning
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Low Inventory')
                                ]));
                            }
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    $author$project$Api$Provider$ChargeItem$All$outOfStock(chargeItem) ? A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]), _List_fromArray([
                        $elm$html$Html$text('Out of Stock')
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$name, $author$project$Api$Provider$ChargeItem$All$category(chargeItem))))
                ]))
            ]),
            A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm_community$string_extra$String$Extra$toTitleCase($author$project$Api$Provider$ChargeItem$Shared$itemTypeToString($author$project$Api$Provider$ChargeItem$All$itemType(chargeItem))))
                ]))
            ]) : _List_Nil,
            A2($elm$core$Maybe$withDefault, _List_Nil, A3($author$project$Utils$FeatureGate$customGate, 2, $author$project$Api$Practice$Provider(practice), _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$italic
                    ]), _List_fromArray([
                        $author$project$Api$Provider$ChargeItem$All$taxable(chargeItem) ? $author$project$Ui$Icon$check(_List_fromArray([
                            $author$project$Ui$Icon$success
                        ])) : $author$project$Ui$Icon$cross(_List_fromArray([
                            $author$project$Ui$Icon$danger
                        ]))
                    ]))
                ]))
            ]))),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$justifyRight
                    ]), function() {
                        if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) && $author$project$Api$Provider$ChargeItem$All$isMedication(chargeItem)) {
                            var isUnifiedExperience = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice);
                            var chargeItemName = $author$project$Api$Provider$ChargeItem$All$name(chargeItem);
                            var emrInventoryUrl = A4($author$project$Utils$Clinical$getInventoryUrl, isUnifiedExperience, origin, emrHost, chargeItemName);
                            return _List_fromArray([
                                A3($author$project$Ui$Link$externalHref, emrInventoryUrl, _List_fromArray([
                                    $author$project$Ui$Link$sm,
                                    $author$project$Ui$Link$targetBlank,
                                    $author$project$Ui$Link$icon($author$project$Ui$Icon$launch)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Edit in Clinical')
                                ]))
                            ]);
                        } else {
                            var id = $author$project$Api$Provider$ChargeItem$All$id(chargeItem);
                            var loading = A2($elm$core$Set$member, id, deletingChargeItems);
                            return _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String({
                                    aef: id
                                }), _List_fromArray([
                                    $author$project$Ui$Link$sm,
                                    $author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Edit')
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Delete charge item'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$size(0),
                                    $author$project$Ui$Button$loading(loading),
                                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$ChargeItems$Top$OpenHiConfirm(chargeItem)),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Delete')
                                ]))
                            ]);
                        }
                    }())
                ]))
            ])
        ])));
    });
    var $author$project$Pages$Admin$ChargeItems$Top$viewPanelTable = function(model) {
        var zeroStateText = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1) ? 'No charge items or packages found.' : 'No charge items found.';
        var _v0 = function() {
            var _v1 = model.bp;
            if (_v1.$ === 3) {
                var chargeItems_ = _v1.a;
                return _Utils_Tuple2(false, chargeItems_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var chargeItems = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text(zeroStateText)
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$ChargeItems$Top$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$textRight
                ]), _List_fromArray([
                    !A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.W1) || model.F3 ? A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$placement(2)
                    ]), 'Upload from CSV', _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__ChargeItems__Upload, _List_fromArray([
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$upload),
                            $author$project$Ui$Link$ariaLabel('Upload')
                        ]), _List_Nil)
                    ])) : $elm$html$Html$text(''),
                    A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$placement(2)
                    ]), 'Export to CSV', _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$ChargeItems$Top$ExportFileMsg, A3($author$project$Components$FileLink$view, {
                            Li: model.Ej,
                            PX: 0,
                            aaT: $author$project$Pages$Admin$ChargeItems$Top$exportCsvPath(model)
                        }, _List_fromArray([
                            $author$project$Ui$Link$ariaLabel('Export CSV'),
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$export)
                        ]), _List_Nil))
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A5($author$project$Pages$Admin$ChargeItems$Top$viewItem, model.W1, model.afY, model.adm, model.HO, model.dO), chargeItems), _List_Nil);
    };
    var $author$project$Pages$Admin$ChargeItems$Top$view = function(model) {
        var packagesEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1);
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.id;
                    if (!_v0.$) {
                        var chargeItem = _v0.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$ChargeItems$Top$HiConfirmClosed($author$project$Api$Provider$ChargeItem$All$id(chargeItem)), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('charge item'),
                            $author$project$Components$HiConfirm$detail($author$project$Api$Provider$ChargeItem$All$name(chargeItem) + ' and remove it from all existing charges')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text(packagesEnabled ? 'Charge Items & Packages' : 'Charge Items')
                        ])),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__ChargeItems__New, _List_fromArray([
                            $author$project$Ui$Link$buttonDefault,
                            $author$project$Ui$Link$pull(1),
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text(packagesEnabled ? 'New Item or Package' : 'New Item')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
                            _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(4)
                                ]), _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Admin$ChargeItems$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(3)
                                ]), _List_fromArray([
                                    $author$project$Pages$Admin$ChargeItems$Top$viewCategoryResourceFilter(model.cK)
                                ]))
                            ]),
                            A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1) ? _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(2)
                                ]), _List_fromArray([
                                    $author$project$Pages$Admin$ChargeItems$Top$viewItemTypeDropdown(model)
                                ]))
                            ]) : _List_Nil,
                            _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(3)
                                ]), _List_fromArray([
                                    A3($author$project$Utils$FeatureGate$gate, 2, $author$project$Api$Practice$Provider(model.W1), $author$project$Pages$Admin$ChargeItems$Top$viewInventoryDropdown(model))
                                ]))
                            ])
                        ])))
                    ])),
                    $author$project$Pages$Admin$ChargeItems$Top$viewPanelTable(model),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$ChargeItems$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.bp))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: packagesEnabled ? 'Admin | Charge Items & Packages' : 'Admin | Charge Items'
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$ChargeItems$Top$init,
        aeR: $author$project$Pages$Admin$ChargeItems$Top$load,
        ag3: $author$project$Pages$Admin$ChargeItems$Top$save,
        ahE: $author$project$Pages$Admin$ChargeItems$Top$subscriptions,
        aaO: $author$project$Pages$Admin$ChargeItems$Top$update,
        aid: $author$project$Pages$Admin$ChargeItems$Top$view
    });
    var $author$project$Api$Upload$Resource$ChargeItem = 1;
    var $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Upload$Form$GotPendingUploads = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Upload$Form$GotUploadColumns = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Common$Upload$ListOptionals$Pending = 0;
    var $author$project$Api$Provider$Upload$All$Upload = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Upload$Shared$Upload = $elm$core$Basics$identity;
    var $author$project$Api$Common$Upload$Shared$Record = function(id) {
        return function(name) {
            return function(createdAt) {
                return function(status) {
                    return function(rowsTotal) {
                        return function(rowsProcessedOrIgnored) {
                            return function(rowsFailed) {
                                return function(rowsSupressed) {
                                    return function(errorMessage) {
                                        return function(startedAt) {
                                            return function(finishedAt) {
                                                return function(uploaderType) {
                                                    return {
                                                        Mx: createdAt,
                                                        O4: errorMessage,
                                                        PK: finishedAt,
                                                        aef: id,
                                                        zr: name,
                                                        Zd: rowsFailed,
                                                        Zf: rowsProcessedOrIgnored,
                                                        Zg: rowsSupressed,
                                                        Zh: rowsTotal,
                                                        _3: startedAt,
                                                        ahy: status,
                                                        aaR: uploaderType
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Upload$Status$Cancelled = 13;
    var $author$project$Api$Upload$Status$Downloading = 1;
    var $author$project$Api$Upload$Status$EnqueuedForPreprocessing = 2;
    var $author$project$Api$Upload$Status$EnqueuedForProcessing = 7;
    var $author$project$Api$Upload$Status$Failed = 12;
    var $author$project$Api$Upload$Status$Postprocessing = 10;
    var $author$project$Api$Upload$Status$Preprocessing = 4;
    var $author$project$Api$Upload$Status$Processed = 11;
    var $author$project$Api$Upload$Status$Processing = 9;
    var $author$project$Api$Upload$Status$ReadyToPreprocess = 3;
    var $author$project$Api$Upload$Status$ReadyToProcess = 8;
    var $author$project$Api$Upload$Status$ReviewDataMatches = 5;
    var $author$project$Api$Upload$Status$ReviewFileSize = 6;
    var $author$project$Api$Upload$Status$Unattempted = 0;
    var $author$project$Api$Upload$Status$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'unattempted':
                return $elm$json$Json$Decode$succeed(0);
            case 'downloading':
                return $elm$json$Json$Decode$succeed(1);
            case 'enqueued_for_preprocessing':
                return $elm$json$Json$Decode$succeed(2);
            case 'ready_to_preprocess':
                return $elm$json$Json$Decode$succeed(3);
            case 'preprocessing':
                return $elm$json$Json$Decode$succeed(4);
            case 'review_data_matches':
                return $elm$json$Json$Decode$succeed(5);
            case 'review_file_size':
                return $elm$json$Json$Decode$succeed(6);
            case 'enqueued_for_processing':
                return $elm$json$Json$Decode$succeed(7);
            case 'ready_to_process':
                return $elm$json$Json$Decode$succeed(8);
            case 'processing':
                return $elm$json$Json$Decode$succeed(9);
            case 'postprocessing':
                return $elm$json$Json$Decode$succeed(10);
            case 'processed':
                return $elm$json$Json$Decode$succeed(11);
            case 'failed':
                return $elm$json$Json$Decode$succeed(12);
            case 'cancelled':
                return $elm$json$Json$Decode$succeed(13);
            default:
                return $elm$json$Json$Decode$fail('Unsupported upload status: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Upload$UploaderType$Other = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Upload$UploaderType$SponsorAutosync = {
        $: 0
    };
    var $author$project$Api$Upload$UploaderType$SponsorManual = {
        $: 1
    };
    var $author$project$Api$Upload$UploaderType$SponsorManualV2 = {
        $: 2
    };
    var $author$project$Api$Upload$UploaderType$decoder = A2($elm$json$Json$Decode$map, function(string) {
        switch(string){
            case 'sponsor_autosync':
                return $author$project$Api$Upload$UploaderType$SponsorAutosync;
            case 'sponsor_manual':
                return $author$project$Api$Upload$UploaderType$SponsorManual;
            case 'sponsor_manual_v2':
                return $author$project$Api$Upload$UploaderType$SponsorManualV2;
            default:
                var somethingElse = string;
                return $author$project$Api$Upload$UploaderType$Other(somethingElse);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Upload$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uploader_type', $author$project$Api$Upload$UploaderType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'finished_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'started_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows_supressed', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows_failed', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows_processed_or_ignored', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows_total', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$Api$Upload$Status$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Shared$Record)))))))))))));
    var $author$project$Api$Common$Upload$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Upload$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Upload$All$Record = function(meta) {
        return {
            Ue: meta
        };
    };
    var $author$project$Api$Provider$Upload$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Upload$Meta$Record = function(actions) {
        return {
            tM: actions
        };
    };
    var $author$project$Api$Provider$Upload$Meta$ActionsRecord = F4(function(preprocess, process, duplicate, cancel) {
        return {
            KW: cancel,
            Om: duplicate,
            Xl: preprocess,
            Xt: process
        };
    });
    var $author$project$Api$Provider$Upload$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancel', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'duplicate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'process', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'preprocess', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Meta$ActionsRecord)))));
    var $author$project$Api$Provider$Upload$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$Upload$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Meta$Record));
    var $author$project$Api$Provider$Upload$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Upload$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Upload$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Upload$Meta$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$All$Record));
    var $author$project$Api$Provider$Upload$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Upload$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Upload$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$All$Upload)));
    var $author$project$Api$Common$Upload$ListOptionals$defaults = {
        Fw: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        Hg: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Common$Upload$ListOptionals$filterToString = function(filter) {
        return 'pending';
    };
    var $author$project$Api$Upload$Resource$toString = function(resource) {
        switch(resource){
            case 0:
                return 'credit';
            case 1:
                return 'chargeitem';
            case 2:
                return 'practitioner';
            case 3:
                return 'patient';
            case 5:
                return 'membership';
            case 4:
                return 'charge';
            case 6:
                return 'payment_method_import';
            default:
                return 'patient_note';
        }
    };
    var $author$project$Api$Common$Upload$ListOptionals$toParams = function(optionals) {
        var options = optionals($author$project$Api$Common$Upload$ListOptionals$defaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Fw;
                if (!_v0.$) {
                    var filter = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', $author$project$Api$Common$Upload$ListOptionals$filterToString(filter))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Hg;
                if (!_v1.$) {
                    var resource = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'type', $author$project$Api$Upload$Resource$toString(resource))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.agq;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Upload$uploadsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'uploads'
        ]), basePath);
    };
    var $author$project$Api$Provider$Upload$list = F4(function(basePath, apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Upload$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$Upload$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Upload$uploadsPath(basePath))));
    });
    var $author$project$Api$Provider$Upload$Column$UploadColumns = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Upload$Column$UploadColumnsRecord = F2(function(columns, ignoredColumns) {
        return {
            LC: columns,
            Q2: ignoredColumns
        };
    });
    var $author$project$Api$Provider$Upload$Column$Column = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Upload$Column$ColumnRecord = F6(function(name, aliases, help, required, allowedValues, _default) {
        return {
            I1: aliases,
            Je: allowedValues,
            Nn: _default,
            QF: help,
            zr: name,
            agM: required
        };
    });
    var $author$project$Api$Provider$Upload$Column$columnRecordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'default', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'allowed_values', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'required', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'help', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'aliases', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Column$ColumnRecord)))))));
    var $author$project$Api$Provider$Upload$Column$columnDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Upload$Column$columnRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Upload$Column$uploadColumnsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ignored_columns', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'columns', $elm$json$Json$Decode$list($author$project$Api$Provider$Upload$Column$columnDecoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$Column$UploadColumnsRecord)));
    var $author$project$Api$Provider$Upload$Column$uploadColumnsDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Upload$Column$uploadColumnsRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Upload$Column$uploadColumnsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'uploads',
        'columns'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Upload$Column$retrieve = F3(function(apiClient, resource, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Upload$Column$uploadColumnsDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'type', $author$project$Api$Upload$Resource$toString(resource))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Upload$Column$uploadColumnsPath)));
    });
    var $author$project$Components$Upload$Form$init = F4(function(timeFormatter, apiClient, resource, companyId) {
        return _Utils_Tuple2({
            v$: true,
            fl: companyId,
            Sk: $author$project$Api$Data$NotAsked,
            A2: $author$project$Api$Data$Loading,
            Hg: resource,
            ok: false,
            sU: false,
            HO: timeFormatter,
            DP: $author$project$Api$Data$NotAsked,
            DQ: $author$project$Api$Data$Loading,
            he: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Upload$Column$retrieve, apiClient, resource, $author$project$Components$Upload$Form$GotUploadColumns),
            A4($author$project$Api$Provider$Upload$list, $author$project$Api$Data$providerPath, apiClient, function(d) {
                return _Utils_update(d, {
                    Fw: $elm$core$Maybe$Just(0),
                    Hg: $elm$core$Maybe$Just(resource)
                });
            }, $author$project$Components$Upload$Form$GotPendingUploads)
        ])));
    });
    var $author$project$Pages$Admin$ChargeItems$Upload$init = F4(function(_v0, practice, shared, _v1) {
        var _v2 = A4($author$project$Components$Upload$Form$init, shared.HO, shared.Ej, 1, $elm$core$Maybe$Nothing);
        var uploadForm = _v2.a;
        var uploadFormCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            lU: false,
            PU: uploadForm,
            W1: practice
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, uploadFormCmd));
    });
    var $author$project$Pages$Admin$ChargeItems$Upload$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$ChargeItems$Upload$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Upload$Form$CloseCannotUploadModal = {
        $: 8
    };
    var $author$project$Components$Upload$Form$UploadResultMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress = function(onClose) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
    };
    var $author$project$Components$Upload$Result$ExportCsvMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Upload$Result$ModalClosed = {
        $: 4
    };
    var $author$project$Components$ExportCsv$CloseModal = {
        $: 1
    };
    var $author$project$Components$ExportCsv$subscriptions = function(model) {
        return model.ys ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$ExportCsv$CloseModal) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Upload$Result$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Upload$Result$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$Result$ModalClosed)
        ]));
    };
    var $author$project$Components$Upload$Form$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Upload$Form$UploadResultMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Upload$Result$subscriptions, model.he))),
            model.ok ? $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress($author$project$Components$Upload$Form$CloseCannotUploadModal) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Pages$Admin$ChargeItems$Upload$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, $author$project$Components$Upload$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$Admin$ChargeItems$Upload$GotChargeDestroyAll = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$ChargeItem$destroyAll = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ChargeItem$chargeItemsPath));
    });
    var $author$project$Components$Upload$Form$ExportFileMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Upload$Form$GotIsProcessing = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Upload$Form$GotUpload = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Upload$One$Upload = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Upload$One$Record = function(results) {
        return {
            Y_: results
        };
    };
    var $author$project$Api$Common$Upload$Results$Invalid = {
        $: 2
    };
    var $author$project$Api$Common$Upload$Results$Other = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Upload$Results$TooManyUnenrollments = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Common$Upload$Results$TooManyUnenrollmentsRecord = F2(function(message, registrations) {
        return {
            ae1: message,
            agG: registrations
        };
    });
    var $author$project$Api$Common$Upload$Results$RegistrationRecord = F3(function(company, count, idents) {
        return {
            acy: company,
            Me: count,
            aeh: idents
        };
    });
    var $author$project$Api$Common$Upload$Results$UploadWarningsRow = F6(function(ident, firstName, lastName, companyName, dob, externalId) {
        return {
            LN: companyName,
            add: dob,
            adE: externalId,
            PN: firstName,
            aeg: ident,
            SU: lastName
        };
    });
    var $author$project$Api$Common$Upload$Results$oldUploadWarningDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, '', A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, '', A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, '', A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, '', A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, '', A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$UploadWarningsRow)))))));
    var $author$project$Api$Common$Upload$Results$uploadWarningDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'external_id', $elm$json$Json$Decode$string, '', A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'dob', $elm$json$Json$Decode$string, '', A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'company_name', $elm$json$Json$Decode$string, '', A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'last_name', $elm$json$Json$Decode$string, '', A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'first_name', $elm$json$Json$Decode$string, '', A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ident', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$UploadWarningsRow)))))));
    var $author$project$Api$Common$Upload$Results$uploadWarningsDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        $author$project$Api$Common$Upload$Results$uploadWarningDecoder,
        $author$project$Api$Common$Upload$Results$oldUploadWarningDecoder
    ]));
    var $author$project$Api$Common$Upload$Results$registrationRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'idents', $elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$uploadWarningsDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$RegistrationRecord))));
    var $author$project$Api$Common$Upload$Results$tooManyUnenrollmentsRecordDeocder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registrations', $elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$registrationRecordDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'message', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$Results$TooManyUnenrollmentsRecord)));
    var $author$project$Api$Common$Upload$Results$decoder = A2($elm$json$Json$Decode$map, function(list) {
        return A2($elm$core$List$map, function(_v0) {
            var key = _v0.a;
            var value = _v0.b;
            if (key === 'too_many_unenrollments') {
                var _v2 = A2($elm$json$Json$Decode$decodeValue, $author$project$Api$Common$Upload$Results$tooManyUnenrollmentsRecordDeocder, value);
                if (!_v2.$) {
                    var record = _v2.a;
                    return $author$project$Api$Common$Upload$Results$TooManyUnenrollments(record);
                } else return $author$project$Api$Common$Upload$Results$Invalid;
            } else {
                var _v3 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$list($author$project$Api$Common$Upload$Results$uploadWarningsDecoder), value);
                if (!_v3.$) {
                    var list_ = _v3.a;
                    return A2($author$project$Api$Common$Upload$Results$Other, key, list_);
                } else return $author$project$Api$Common$Upload$Results$Invalid;
            }
        }, list);
    }, $elm$json$Json$Decode$keyValuePairs($elm$json$Json$Decode$value));
    var $author$project$Api$Provider$Upload$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'results', $author$project$Api$Common$Upload$Results$decoder, _List_Nil, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$One$Record));
    var $author$project$Api$Provider$Upload$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Upload$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Upload$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Upload$One$Upload)));
    var $author$project$Api$Data$Files = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Data$requestWithFile = F3(function(name, file, _v0) {
        var request = _v0;
        return _Utils_update(request, {
            fb: $elm$core$Maybe$Just(A2($author$project$Api$Data$Files, name, _List_fromArray([
                file
            ])))
        });
    });
    var $author$project$Api$Provider$Upload$create = F4(function(apiClient, resource, file, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Upload$One$decoder, toMsg, A3($author$project$Api$Data$requestWithFile, 'file', file, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'type', $author$project$Api$Upload$Resource$toString(resource))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Upload$uploadsPath($author$project$Api$Data$providerPath)))));
    });
    var $author$project$Api$Common$Upload$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Upload$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$id(shared);
    };
    var $author$project$Api$Provider$Upload$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$id(shared);
    };
    var $author$project$Components$Upload$Result$GotUpload = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$UploadRowManual = 16;
    var $author$project$Components$ExportCsv$init = function(_v0) {
        var resource = _v0.Hg;
        var forCompany = _v0.adW;
        return {
            p3: $author$project$Api$Data$NotAsked,
            qE: false,
            adW: forCompany,
            ys: false,
            dg: $author$project$Api$Data$NotAsked,
            Hg: resource,
            bh: $elm$core$Set$empty
        };
    };
    var $author$project$Api$Provider$Upload$uploadPath = F2(function(basePath, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Upload$uploadsPath(basePath));
    });
    var $author$project$Api$Provider$Upload$retrieve = F4(function(basePath, apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Upload$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Upload$uploadPath, basePath, id_)));
    });
    var $author$project$Components$Upload$Result$init = F2(function(apiClient, id) {
        return _Utils_Tuple2({
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 16
            }),
            aef: id,
            af_: $author$project$Api$Pagination$init,
            DP: $author$project$Api$Data$Loading,
            tC: $author$project$Api$Data$NotAsked
        }, A4($author$project$Api$Provider$Upload$retrieve, $author$project$Api$Data$providerPath, apiClient, id, $author$project$Components$Upload$Result$GotUpload));
    });
    var $author$project$Api$Provider$Company$Upload$companyUploadsPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'uploads'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$Upload$companyUploadsIsProcessingPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'is_processing'
        ]), $author$project$Api$Provider$Company$Upload$companyUploadsPath(companyId));
    };
    var $author$project$Api$Provider$Company$Upload$isProcessingDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'is_processing'
    ]), $elm$json$Json$Decode$bool);
    var $author$project$Api$Provider$Company$Upload$isProcessing = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Company$Upload$isProcessingDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$Upload$companyUploadsIsProcessingPath(companyId)));
    });
    var $author$project$Components$Upload$Result$Closed = 1;
    var $author$project$Components$Upload$Result$None = 0;
    var $author$project$Components$Upload$Result$Result = F4(function(model, cmd, outMsgs, event) {
        return {
            EQ: cmd,
            adu: event,
            zi: model,
            at: outMsgs
        };
    });
    var $author$project$Api$Provider$Report$UploadRowCharge = 17;
    var $author$project$Api$Provider$Report$UploadRowMembership = 19;
    var $author$project$Api$Common$UploadRow$ListOptionals$Failed = 0;
    var $author$project$Components$Upload$Result$GotUploadRows = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$UploadRow$All$UploadRow = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$UploadRow$Shared$UploadRow = $elm$core$Basics$identity;
    var $author$project$Api$Provider$UploadRow$Shared$Record = F6(function(id, rowNumber, status, reviewed, isSupressed, csvRow) {
        return {
            MH: csvRow,
            aef: id,
            St: isSupressed,
            Y6: reviewed,
            Zb: rowNumber,
            ahy: status
        };
    });
    var $author$project$Api$Provider$UploadRow$Status$Created = 0;
    var $author$project$Api$Provider$UploadRow$Status$Enqueued = 2;
    var $author$project$Api$Provider$UploadRow$Status$Failed = 5;
    var $author$project$Api$Provider$UploadRow$Status$Ignored = 6;
    var $author$project$Api$Provider$UploadRow$Status$MappingRequired = 7;
    var $author$project$Api$Provider$UploadRow$Status$Processed = 4;
    var $author$project$Api$Provider$UploadRow$Status$Processing = 3;
    var $author$project$Api$Provider$UploadRow$Status$RequiredFieldMappingRequired = 8;
    var $author$project$Api$Provider$UploadRow$Status$Validated = 1;
    var $author$project$Api$Provider$UploadRow$Status$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'created':
                return $elm$json$Json$Decode$succeed(0);
            case 'validated':
                return $elm$json$Json$Decode$succeed(1);
            case 'enqueued':
                return $elm$json$Json$Decode$succeed(2);
            case 'processing':
                return $elm$json$Json$Decode$succeed(3);
            case 'processed':
                return $elm$json$Json$Decode$succeed(4);
            case 'failed':
                return $elm$json$Json$Decode$succeed(5);
            case 'ignored':
                return $elm$json$Json$Decode$succeed(6);
            case 'mapping_required':
                return $elm$json$Json$Decode$succeed(7);
            case 'required_field_mapping_required':
                return $elm$json$Json$Decode$succeed(8);
            default:
                return $elm$json$Json$Decode$fail('Unsupported upload status: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$UploadRow$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'csv_row', $elm$json$Json$Decode$dict($elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_supressed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reviewed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$Api$Provider$UploadRow$Status$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'row_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$Shared$Record)))))));
    var $author$project$Api$Provider$UploadRow$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadRow$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$UploadRow$All$Record = F2(function(resultData, uploadRowResults) {
        return {
            YY: resultData,
            aaP: uploadRowResults
        };
    });
    var $author$project$Api$Common$UploadRowResult$Data$Data = $elm$core$Basics$identity;
    var $author$project$Api$Common$UploadRowResult$Data$Record = F7(function(value, field, patientIdent, externalId, firstName, lastName, currentDob) {
        return {
            ML: currentDob,
            adE: externalId,
            PD: field,
            PN: firstName,
            SU: lastName,
            V9: patientIdent,
            aa9: value
        };
    });
    var $author$project$Api$Common$UploadRowResult$Data$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'current_dob', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'last_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'first_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'external_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'patient_ident', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'field', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'value', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Api$Common$UploadRowResult$Data$Record))))))));
    var $author$project$Api$Common$UploadRowResult$Data$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$UploadRowResult$Data$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$UploadRowResult$Shared$UploadRowResult = $elm$core$Basics$identity;
    var $author$project$Api$Provider$UploadRowResult$Shared$Record = F4(function(rowNumber, message, resultType, data) {
        return {
            M$: data,
            ae1: message,
            YZ: resultType,
            Zb: rowNumber
        };
    });
    var $author$project$Api$Provider$UploadRowResult$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'data', $elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'result_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'row_number', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRowResult$Shared$Record)))));
    var $author$project$Api$Provider$UploadRowResult$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadRowResult$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$UploadRow$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'upload_row_results', $elm$json$Json$Decode$list($author$project$Api$Provider$UploadRowResult$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'result_data', $elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$All$Record)));
    var $author$project$Api$Provider$UploadRow$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadRow$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadRow$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$All$UploadRow)));
    var $author$project$Api$Sort$withDefault = F3(function(column, direction, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            Nn: $elm$core$Maybe$Just(_Utils_Tuple2(column, direction))
        });
    });
    var $author$project$Api$Common$UploadRow$ListOptionals$defaults = {
        Fw: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        Hg: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'row_number', 0, $author$project$Api$Sort$init),
        HI: $elm$core$Maybe$Nothing,
        H$: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Common$UploadRow$ListOptionals$filterToString = function(filter) {
        switch(filter){
            case 0:
                return 'failed';
            case 1:
                return 'warning';
            default:
                return 'processed';
        }
    };
    var $author$project$Api$Common$UploadRow$ListOptionals$toParams = function(optionals) {
        var options = optionals($author$project$Api$Common$UploadRow$ListOptionals$defaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Fw;
                if (!_v0.$) {
                    var filter = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', $author$project$Api$Common$UploadRow$ListOptionals$filterToString(filter))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Hg;
                if (!_v1.$) {
                    var resource = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'type', $author$project$Api$Upload$Resource$toString(resource))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.H$;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'upload_row_results_result_type', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.HI;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'supress_filter', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.agq;
                if (!_v4.$) {
                    var string = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$UploadRow$uploadRowsPath = function(uploadId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'upload_rows'
        ]), A2($author$project$Api$Provider$Upload$uploadPath, $author$project$Api$Data$providerPath, uploadId));
    };
    var $author$project$Api$Provider$UploadRow$list = F4(function(apiClient, uploadId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$UploadRow$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$UploadRow$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$UploadRow$uploadRowsPath(uploadId))));
    });
    var $author$project$Components$Upload$Result$fetchUploadRows = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$UploadRow$list, apiClient, model.aef, function(d) {
            return _Utils_update(d, {
                Fw: $elm$core$Maybe$Just(0),
                af_: model.af_
            });
        }, $author$project$Components$Upload$Result$GotUploadRows);
    });
    var $author$project$Api$Common$Upload$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Upload$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$status(shared);
    };
    var $author$project$Components$Upload$Result$finishProcessing = function(upload) {
        var _v0 = $author$project$Api$Provider$Upload$One$status(upload);
        switch(_v0){
            case 11:
                return true;
            case 12:
                return true;
            default:
                return false;
        }
    };
    var $author$project$Components$Upload$Result$PollUpload = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Upload$Result$pollUpload = function(upload) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Components$Upload$Result$PollUpload(upload);
        }, $elm$core$Process$sleep(2000));
    };
    var $author$project$Components$ExportCsv$DefaultColumnsSaved = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$ExportFileMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Provider$ReportExport$Shared$Generated = 3;
    var $author$project$Components$ExportCsv$GotCsvReport = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$GotReportExport = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Common$CsvReport$Shared$columns = function(_v0) {
        var record = _v0;
        return record.LC;
    };
    var $author$project$Api$Common$CsvReport$One$columns = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Common$CsvReport$Shared$columns(shared);
    };
    var $author$project$Api$Provider$ReportExport$All$ReportExport = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ReportExport$Shared$ReportExport = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ReportExport$Shared$Record = F4(function(id, status, totalCount, generatedCount) {
        return {
            P8: generatedCount,
            aef: id,
            ahy: status,
            oQ: totalCount
        };
    });
    var $author$project$Api$Provider$ReportExport$Shared$Enqueued = 1;
    var $author$project$Api$Provider$ReportExport$Shared$Generating = 2;
    var $author$project$Api$Provider$ReportExport$Shared$Pending = 0;
    var $author$project$Api$Provider$ReportExport$Shared$decodeStatus = function(string) {
        switch(string){
            case 'pending':
                return $elm$json$Json$Decode$succeed(0);
            case 'enqueued':
                return $elm$json$Json$Decode$succeed(1);
            case 'generating':
                return $elm$json$Json$Decode$succeed(2);
            case 'generated':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail('Unsupported report export status: ' + string);
        }
    };
    var $author$project$Api$Provider$ReportExport$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'generated_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$ReportExport$Shared$decodeStatus, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ReportExport$Shared$Record)))));
    var $author$project$Api$Provider$ReportExport$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ReportExport$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ReportExport$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ReportExport$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ReportExport$reportExportsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'exports'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Report$resourceToString = function(resource) {
        switch(resource){
            case 0:
                return 'Patient';
            case 1:
                return 'SignupAttempt';
            case 2:
                return 'StatementLine';
            case 3:
                return 'Invoice';
            case 6:
                return 'RevenueLine';
            case 7:
                return 'DeferredRevenueLine';
            case 8:
                return 'TaxLine';
            case 9:
                return 'PaymentApplicationLine';
            case 10:
                return 'MembershipPatient';
            case 11:
                return 'Membership';
            case 12:
                return 'CustomerInvoice';
            case 13:
                return 'Deposit';
            case 14:
                return 'CreditLine';
            case 15:
                return 'Credit';
            case 16:
                return 'UploadRowManual';
            case 17:
                return 'UploadRowCharge';
            case 18:
                return 'UploadRowSponsor';
            case 19:
                return 'UploadRowMembership';
            case 20:
                return 'Location';
            case 4:
                return 'InvoiceLine';
            case 5:
                return 'AffiliateBillLine';
            case 21:
                return 'Dispute';
            case 22:
                return 'AffiliateAncillaryCharge';
            case 23:
                return 'CompanyRegistration';
            default:
                return 'PaymentMethodImport';
        }
    };
    var $author$project$Api$Param$toValue = function(params) {
        return $elm$json$Json$Encode$object(A2($elm$core$List$map, function(param) {
            switch(param.$){
                case 0:
                    var key = param.a;
                    var string_ = param.b;
                    return _Utils_Tuple2(key, $elm$json$Json$Encode$string(string_));
                case 1:
                    var key = param.a;
                    var bool_ = param.b;
                    return _Utils_Tuple2(key, $elm$json$Json$Encode$bool(bool_));
                case 2:
                    var key = param.a;
                    var date_ = param.b;
                    return _Utils_Tuple2(key, $elm$json$Json$Encode$string($author$project$Utils$Date$toQuery(date_)));
                default:
                    var key = param.a;
                    var list_ = param.b;
                    var _v1 = _Utils_Tuple2($elm$core$List$length(list_) > 1, $elm$core$List$head(list_));
                    if (!_v1.a && !_v1.b.$) {
                        var string_ = _v1.b.a;
                        return _Utils_Tuple2(key, $elm$json$Json$Encode$string(string_));
                    } else return _Utils_Tuple2(key, A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, list_));
            }
        }, params));
    };
    var $author$project$Api$Provider$ReportExport$create = F5(function(apiClient, resource, params, columns, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('export', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('resource', $elm$json$Json$Encode$string($author$project$Api$Provider$Report$resourceToString(resource))),
                _Utils_Tuple2('columns', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, columns)),
                _Utils_Tuple2('report_params', $author$project$Api$Param$toValue(params))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$ReportExport$All$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ReportExport$reportExportsPath)));
    });
    var $elm$core$Set$fromList = function(list) {
        return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
    };
    var $author$project$Api$Provider$ReportExport$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$ReportExport$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportExport$Shared$id(shared);
    };
    var $author$project$Api$Common$CsvReport$CsvReportColumn$name = function(_v0) {
        var record = _v0;
        return record.wd.zr;
    };
    var $author$project$Components$ExportCsv$PollReportExport = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$pollReportExport = function(reportExport) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Components$ExportCsv$PollReportExport(reportExport);
        }, $elm$core$Process$sleep(2000));
    };
    var $author$project$Api$Common$CsvReport$CsvReport$csvReportPath = F2(function(forCompany, resource) {
        var path = forCompany ? $author$project$Api$Data$employerPath : $author$project$Api$Data$providerPath;
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'csv_reports',
            $author$project$Api$Provider$Report$resourceToString(resource)
        ]), path);
    });
    var $author$project$Api$Common$CsvReport$One$CsvReport = $elm$core$Basics$identity;
    var $author$project$Api$Common$CsvReport$Shared$CsvReport = $elm$core$Basics$identity;
    var $author$project$Api$Common$CsvReport$Shared$Record = function(columns) {
        return {
            LC: columns
        };
    };
    var $author$project$Api$Common$CsvReport$CsvReportColumn$CsvReportColumn = $elm$core$Basics$identity;
    var $author$project$Api$Common$CsvReport$CsvReportColumn$WrapperRecord = function(column) {
        return {
            wd: column
        };
    };
    var $author$project$Api$Common$CsvReport$CsvReportColumn$Record = F3(function(name, title, includeByDefault) {
        return {
            Q9: includeByDefault,
            zr: name,
            $2: title
        };
    });
    var $author$project$Api$Common$CsvReport$CsvReportColumn$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'include_by_default', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$CsvReportColumn$Record))));
    var $author$project$Api$Common$CsvReport$CsvReportColumn$wrapperRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'column', $author$project$Api$Common$CsvReport$CsvReportColumn$recordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$CsvReportColumn$WrapperRecord));
    var $author$project$Api$Common$CsvReport$CsvReportColumn$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$CsvReport$CsvReportColumn$wrapperRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$CsvReport$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'columns', $elm$json$Json$Decode$list($author$project$Api$Common$CsvReport$CsvReportColumn$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Common$CsvReport$Shared$Record));
    var $author$project$Api$Common$CsvReport$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$CsvReport$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$CsvReport$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$CsvReport$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$CsvReport$CsvReport$retrieve = F4(function(apiClient, forCompany, resource, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$CsvReport$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Common$CsvReport$CsvReport$csvReportPath, forCompany, resource)));
    });
    var $author$project$Api$Provider$ReportExport$reportExportPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$ReportExport$reportExportsPath);
    };
    var $author$project$Api$Provider$ReportExport$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$ReportExport$All$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ReportExport$reportExportPath(id_)));
    });
    var $author$project$Api$Common$CsvReport$CsvReport$saveColumns = F4(function(apiClient, resource, defaultColumns, toMsg) {
        var forCompany = false;
        var defaultColumnsString = A2($elm$core$String$join, ',', $elm$core$Set$toList(defaultColumns));
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('default_columns', $elm$json$Json$Encode$string(defaultColumnsString))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'update_default_columns'
        ]), A2($author$project$Api$Common$CsvReport$CsvReport$csvReportPath, forCompany, resource)))));
    });
    var $author$project$Api$Common$CsvReport$CsvReportColumn$includeByDefault = function(_v0) {
        var record = _v0;
        return record.wd.Q9;
    };
    var $author$project$Components$ExportCsv$selectDefaultColumns = function(csvReport) {
        return $elm$core$Set$fromList(A2($elm$core$List$map, $author$project$Api$Common$CsvReport$CsvReportColumn$name, A2($elm$core$List$filter, $author$project$Api$Common$CsvReport$CsvReportColumn$includeByDefault, $author$project$Api$Common$CsvReport$One$columns(csvReport))));
    };
    var $author$project$Api$Provider$ReportExport$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$ReportExport$All$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportExport$Shared$status(shared);
    };
    var $author$project$Components$ExportCsv$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    ys: true
                }), A4($author$project$Api$Common$CsvReport$CsvReport$retrieve, apiClient, model.adW, model.Hg, $author$project$Components$ExportCsv$GotCsvReport), _List_Nil);
            case 1:
                return _Utils_Tuple3($author$project$Components$ExportCsv$init({
                    adW: model.adW,
                    Hg: model.Hg
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var dataCsvReport = msg.a;
                if (dataCsvReport.$ === 3) {
                    var csvReport = dataCsvReport.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        p3: dataCsvReport,
                        bh: $author$project$Components$ExportCsv$selectDefaultColumns(csvReport)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    p3: dataCsvReport
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(dataCsvReport));
            case 3:
                var csvReport = msg.a;
                var selectedColumns = $elm$core$Set$fromList(A2($elm$core$List$map, $author$project$Api$Common$CsvReport$CsvReportColumn$name, $author$project$Api$Common$CsvReport$One$columns(csvReport)));
                return _Utils_Tuple3(_Utils_update(model, {
                    bh: selectedColumns
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    bh: $elm$core$Set$empty
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                return _Utils_Tuple3(model, A4($author$project$Api$Common$CsvReport$CsvReport$saveColumns, apiClient, model.Hg, model.bh, $author$project$Components$ExportCsv$DefaultColumnsSaved), _List_Nil);
            case 5:
                var columnName = msg.a;
                var selected = msg.b;
                var selectedColumns = !selected ? A2($elm$core$Set$remove, columnName, model.bh) : A2($elm$core$Set$insert, columnName, model.bh);
                return _Utils_Tuple3(_Utils_update(model, {
                    bh: selectedColumns
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var reportParams_ = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    qE: true,
                    dg: $author$project$Api$Data$Loading
                }), A5($author$project$Api$Provider$ReportExport$create, apiClient, model.Hg, reportParams_, $elm$core$Set$toList(model.bh), $author$project$Components$ExportCsv$GotReportExport), _List_Nil);
            case 7:
                var dataReportExport = msg.a;
                var cmd = function() {
                    if (dataReportExport.$ === 3) {
                        var reportExport = dataReportExport.a;
                        return $author$project$Api$Provider$ReportExport$All$status(reportExport) !== 3 ? $author$project$Components$ExportCsv$pollReportExport(reportExport) : $elm$core$Platform$Cmd$none;
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    dg: dataReportExport
                }), cmd, $author$project$OutMsg$reportDecodeError(dataReportExport));
            case 8:
                var reportExport = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$ReportExport$retrieve, apiClient, $author$project$Api$Provider$ReportExport$All$id(reportExport), $author$project$Components$ExportCsv$GotReportExport), _List_Nil);
            case 9:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v4 = $author$project$Components$FileLink$update(subMsg);
                var getFileCmdMsg = _v4.a;
                var outMsgs = _v4.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$ExportCsv$ExportFileMsg, getFileCmdMsg),
                    A2($elm$core$Task$perform, function(_v5) {
                        return $author$project$Components$ExportCsv$CloseModal;
                    }, $elm$core$Task$succeed(0))
                ])), outMsgs);
        }
    });
    var $author$project$Api$Common$Upload$Shared$uploaderType = function(_v0) {
        var record = _v0;
        return record.aaR;
    };
    var $author$project$Api$Provider$Upload$One$uploaderType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
    };
    var $author$project$Components$Upload$Result$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var upload = response.a;
                    var resource = function() {
                        var _v2 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
                        _v2$2: while(true){
                            if (_v2.$ === 3) switch(_v2.a){
                                case 'charge':
                                    return 17;
                                case 'membership':
                                    return 19;
                                default:
                                    break _v2$2;
                            }
                            else break _v2$2;
                        }
                        return 16;
                    }();
                    var exportCsv = $author$project$Components$ExportCsv$init({
                        adW: false,
                        Hg: resource
                    });
                    var cmd = $author$project$Components$Upload$Result$finishProcessing(upload) ? A2($author$project$Components$Upload$Result$fetchUploadRows, apiClient, model) : $author$project$Components$Upload$Result$pollUpload(upload);
                    return A4($author$project$Components$Upload$Result$Result, _Utils_update(model, {
                        md: exportCsv,
                        DP: response
                    }), cmd, _List_Nil, 0);
                } else return A4($author$project$Components$Upload$Result$Result, _Utils_update(model, {
                    DP: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response), 0);
            case 1:
                var upload = msg.a;
                return A4($author$project$Components$Upload$Result$Result, model, A4($author$project$Api$Provider$Upload$retrieve, $author$project$Api$Data$providerPath, apiClient, $author$project$Api$Provider$Upload$One$id(upload), $author$project$Components$Upload$Result$GotUpload), _List_Nil, 0);
            case 2:
                var response = msg.a;
                var pagination = function() {
                    if (response.$ === 3) {
                        var headers = response.b;
                        return A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_);
                    } else return model.af_;
                }();
                return A4($author$project$Components$Upload$Result$Result, _Utils_update(model, {
                    af_: pagination,
                    tC: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response), 0);
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return A4($author$project$Components$Upload$Result$Result, newModel, A2($author$project$Components$Upload$Result$fetchUploadRows, apiClient, newModel), _List_Nil, 0);
            case 4:
                return A4($author$project$Components$Upload$Result$Result, model, $elm$core$Platform$Cmd$none, _List_Nil, 1);
            default:
                var subMsg = msg.a;
                var _v4 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v4.a;
                var subCmd = _v4.b;
                var subOutMsg = _v4.c;
                var newModel = _Utils_update(model, {
                    md: exportCsv
                });
                return A4($author$project$Components$Upload$Result$Result, newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Result$ExportCsvMsg, subCmd), subOutMsg, 0);
        }
    });
    var $author$project$Components$Upload$Form$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    DQ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    sU: !model.sU
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var files = msg.a;
                var _v1 = $elm$core$List$head(files);
                if (!_v1.$) {
                    var file = _v1.a;
                    var _v2 = model.fl;
                    if (!_v2.$) {
                        var companyId = _v2.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Sk: $author$project$Api$Data$Loading
                        }), A3($author$project$Api$Provider$Company$Upload$isProcessing, apiClient, companyId, $author$project$Components$Upload$Form$GotIsProcessing(file)), _List_Nil);
                    } else return _Utils_Tuple3(model, A4($author$project$Api$Provider$Upload$create, apiClient, model.Hg, file, $author$project$Components$Upload$Form$GotUpload), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var file = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var isProcessing = response.a;
                    var cmd = isProcessing ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Upload$create, apiClient, model.Hg, file, $author$project$Components$Upload$Form$GotUpload);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Sk: response,
                        ok: isProcessing
                    }), cmd, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Sk: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var upload = response.a;
                    var _v5 = A2($author$project$Components$Upload$Result$init, apiClient, $author$project$Api$Provider$Upload$One$id(upload));
                    var uploadResult = _v5.a;
                    var uploadResultCmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        DP: response,
                        he: $elm$core$Maybe$Just(uploadResult)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, uploadResultCmd), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    DP: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    A2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var subMsg = msg.a;
                var _v6 = model.he;
                if (!_v6.$) {
                    var uploadResult = _v6.a;
                    var result = A3($author$project$Components$Upload$Result$update, apiClient, subMsg, uploadResult);
                    var uploadResult_ = function() {
                        var _v7 = result.adu;
                        if (!_v7) return $elm$core$Maybe$Just(result.zi);
                        else return $elm$core$Maybe$Nothing;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        he: uploadResult_
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, result.EQ), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var upload = msg.a;
                var _v8 = A2($author$project$Components$Upload$Result$init, apiClient, $author$project$Api$Provider$Upload$All$id(upload));
                var uploadResult = _v8.a;
                var uploadResultCmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    he: $elm$core$Maybe$Just(uploadResult)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$UploadResultMsg, uploadResultCmd), _List_Nil);
            case 8:
                return _Utils_Tuple3(_Utils_update(model, {
                    ok: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v9 = $author$project$Components$FileLink$update(subMsg);
                var getFileCmdMsg = _v9.a;
                var outMsgs = _v9.b;
                return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, $author$project$Components$Upload$Form$ExportFileMsg, getFileCmdMsg), outMsgs);
        }
    });
    var $author$project$Pages$Admin$ChargeItems$Upload$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$Upload$Form$update, model.Ej, subMsg, model.PU);
                var uploadForm = _v1.a;
                var subCmd = _v1.b;
                var subOutMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: uploadForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, subCmd), subOutMsgs);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    lU: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    lU: false
                }), A2($author$project$Api$Provider$ChargeItem$destroyAll, model.Ej, $author$project$Pages$Admin$ChargeItems$Upload$GotChargeDestroyAll), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    lU: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Charges were successfully removed.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$ChargeItems$Upload$HiConfirmChargesClosed = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Common$Upload$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Upload$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$name(shared);
    };
    var $author$project$Components$ExportCsv$OpenModal = {
        $: 0
    };
    var $author$project$Components$ExportCsv$customButton = F2(function(options, children) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Export to csv'
        }, _Utils_ap(options, _List_fromArray([
            $author$project$Ui$Button$onClick($author$project$Components$ExportCsv$OpenModal),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$export)
        ])), _List_fromArray([
            A3($author$project$Ui$Tooltip$view, _List_fromArray([
                $author$project$Ui$Tooltip$placement(2)
            ]), 'Export to CSV', A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), children))
        ]));
    });
    var $author$project$Components$ExportCsv$button = A2($author$project$Components$ExportCsv$customButton, _List_fromArray([
        $author$project$Ui$Button$link,
        $author$project$Ui$Button$padding($author$project$Ui$Padding$none)
    ]), _List_Nil);
    var $author$project$Components$Upload$Result$failed = F2(function(upload, uploadRows) {
        var _v0 = _Utils_Tuple2($author$project$Api$Provider$Upload$One$status(upload), $elm$core$List$isEmpty(uploadRows));
        if (_v0.a === 12) {
            var _v1 = _v0.a;
            return true;
        } else {
            if (!_v0.b) return true;
            else return false;
        }
    });
    var $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored = function(_v0) {
        var record = _v0;
        return record.Zf;
    };
    var $author$project$Api$Provider$Upload$One$rowsProcessedOrIgnored = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
    };
    var $author$project$Api$Common$Upload$Shared$rowsTotal = function(_v0) {
        var record = _v0;
        return record.Zh;
    };
    var $author$project$Api$Provider$Upload$One$rowsTotal = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
    };
    var $author$project$Ui$Alert$success = $author$project$Ui$Alert$view(0);
    var $author$project$Components$Upload$Result$exportParams = function(upload) {
        var _v0 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
        if (_v0.$ === 3) return _List_fromArray([
            A2($author$project$Api$Param$string, 'filter', '')
        ]);
        else return _List_fromArray([
            A2($author$project$Api$Param$string, 'filter', 'failed')
        ]);
    };
    var $author$project$Components$ExportCsv$Filter = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$filter = $author$project$Components$ExportCsv$Filter;
    var $author$project$Components$ExportCsv$DeselectAllColumns = {
        $: 4
    };
    var $author$project$Components$ExportCsv$SaveDefaultColumns = {
        $: 10
    };
    var $author$project$Components$ExportCsv$SelectAllColumns = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$StartExport = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Link$ButtonPrimary = 0;
    var $author$project$Ui$Link$buttonPrimary = $author$project$Ui$Link$Style(0);
    var $author$project$Components$ExportCsv$paramsForCsv = F2(function(optionsRecord, selectedColumns) {
        return A2($elm$core$List$concatMap, $author$project$Api$Param$toQuery, A2($elm$core$List$append, function() {
            var _v0 = optionsRecord.Fw;
            if (!_v0.$) {
                var filter_ = _v0.a;
                return _List_fromArray([
                    A2($author$project$Api$Param$string, 'filter', filter_)
                ]);
            } else return _List_Nil;
        }(), A2($elm$core$List$append, _List_fromArray([
            A2($author$project$Api$Param$list, 'columns', selectedColumns)
        ]), optionsRecord.VU)));
    });
    var $author$project$Components$ExportCsv$downloadCsvHref = F3(function(apiClient, optionsRecord, selectedColumns) {
        return A2($elm$core$Maybe$map, function(path_) {
            return A4($author$project$Api$Data$downloadUrl, apiClient, path_, 0, A2($author$project$Components$ExportCsv$paramsForCsv, optionsRecord, selectedColumns));
        }, optionsRecord.V6);
    });
    var $author$project$Formatters$Int$formatNumber = function(number) {
        return A2($cuducos$elm_format_number$FormatNumber$format, $author$project$Formatters$Locales$noDecimalLocale, number);
    };
    var $author$project$Ui$Link$FullWidth = {
        $: 7
    };
    var $author$project$Ui$Link$fullWidth = $author$project$Ui$Link$FullWidth;
    var $author$project$Api$Provider$ReportExport$Shared$generatedCount = function(_v0) {
        var record = _v0;
        return record.P8;
    };
    var $author$project$Api$Provider$ReportExport$All$generatedCount = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportExport$Shared$generatedCount(shared);
    };
    var $author$project$Components$ExportCsv$totalCountLimit = 200000;
    var $author$project$Components$ExportCsv$isInvalid = function(totalCount) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(count) {
            return _Utils_cmp(count, $author$project$Components$ExportCsv$totalCountLimit) > 0;
        }, totalCount));
    };
    var $author$project$Components$ExportCsv$defaultOptions = {
        Fw: $elm$core$Maybe$Nothing,
        VU: _List_Nil,
        V6: $elm$core$Maybe$Nothing,
        jQ: false,
        BJ: _List_Nil,
        oQ: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$ExportCsv$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var totalCount = option.a;
                    return _Utils_update(record, {
                        jQ: true,
                        oQ: totalCount
                    });
                case 1:
                    var dict = option.a;
                    return _Utils_update(record, {
                        VU: dict
                    });
                case 2:
                    var dict = option.a;
                    return _Utils_update(record, {
                        BJ: dict
                    });
                case 3:
                    var string = option.a;
                    return _Utils_update(record, {
                        Fw: $elm$core$Maybe$Just(string)
                    });
                default:
                    var path_ = option.a;
                    return _Utils_update(record, {
                        V6: $elm$core$Maybe$Just(path_)
                    });
            }
        }), $author$project$Components$ExportCsv$defaultOptions, options);
    };
    var $author$project$Components$ExportCsv$reportExportGenerated = function(dataReportExport) {
        if (dataReportExport.$ === 3) {
            var reportExport = dataReportExport.a;
            return $author$project$Api$Provider$ReportExport$All$status(reportExport) === 3;
        } else return false;
    };
    var $author$project$Components$ExportCsv$reportExportHref = F2(function(apiClient, dataReportExport) {
        return A2($elm$core$Maybe$map, function(reportExport) {
            var reportExportPath = $author$project$Api$Provider$ReportExport$reportExportPath($author$project$Api$Provider$ReportExport$All$id(reportExport));
            return A4($author$project$Api$Data$downloadUrl, apiClient, reportExportPath, 0, _List_Nil);
        }, $author$project$Api$Data$toMaybe(dataReportExport));
    });
    var $elm$core$Dict$sizeHelp = F2(function(n, dict) {
        sizeHelp: while(true){
            if (dict.$ === -2) return n;
            else {
                var left = dict.d;
                var right = dict.e;
                var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right), $temp$dict = left;
                n = $temp$n;
                dict = $temp$dict;
                continue sizeHelp;
            }
        }
    });
    var $elm$core$Dict$size = function(dict) {
        return A2($elm$core$Dict$sizeHelp, 0, dict);
    };
    var $elm$core$Set$size = function(_v0) {
        var dict = _v0;
        return $elm$core$Dict$size(dict);
    };
    var $author$project$Api$Provider$ReportExport$Shared$totalCount = function(_v0) {
        var record = _v0;
        return record.oQ;
    };
    var $author$project$Api$Provider$ReportExport$All$totalCount = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportExport$Shared$totalCount(shared);
    };
    var $author$project$Components$ExportCsv$ToggleColumn = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$Checkbox$Attr = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$attr = function(attributes) {
        return $author$project$Ui$Form$Checkbox$Attr(attributes);
    };
    var $author$project$Api$Common$CsvReport$CsvReportColumn$title = function(_v0) {
        var record = _v0;
        return record.wd.$2;
    };
    var $author$project$Components$ExportCsv$viewColumn = F2(function(selectedColumns, column) {
        var columnName = $author$project$Api$Common$CsvReport$CsvReportColumn$name(column);
        return A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
            $author$project$Ui$Form$Checkbox$value(A2($elm$core$Set$member, columnName, selectedColumns)),
            $author$project$Ui$Form$Checkbox$attr(_List_fromArray([
                $elm$html$Html$Attributes$class('text-left')
            ])),
            $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$ExportCsv$ToggleColumn(columnName))
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Common$CsvReport$CsvReportColumn$title(column))
        ]));
    });
    var $author$project$Components$ExportCsv$viewModal = F3(function(apiClient, options, model) {
        var optionsRecord = $author$project$Components$ExportCsv$optionsToRecord(options);
        return A3($author$project$Ui$Modal$view, $author$project$Components$ExportCsv$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Export to CSV')
                ]))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    if (model.qE) return A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center')
                    ]), $elm$core$List$concat(_List_fromArray([
                        !$author$project$Components$ExportCsv$reportExportGenerated(model.dg) || !optionsRecord.jQ ? _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil)
                        ]) : _List_Nil,
                        optionsRecord.jQ ? $author$project$Components$ExportCsv$reportExportGenerated(model.dg) ? _List_fromArray([
                            A2($author$project$Ui$Alert$success, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Your export was generated successfully.')
                            ]))
                        ]) : _List_fromArray([
                            $elm$html$Html$text('Your export may take a few minutes to generate.'),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            function() {
                                var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ReportExport$All$totalCount, $author$project$Api$Data$toMaybe(model.dg));
                                if (!_v0.$) {
                                    var totalCount = _v0.a;
                                    return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Generated ' + ($elm$core$String$fromInt(A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ReportExport$All$generatedCount, $author$project$Api$Data$toMaybe(model.dg)))) + (' out of ' + $elm$core$String$fromInt(totalCount))))
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]) : _List_Nil
                    ])));
                    else {
                        var _v1 = model.p3;
                        if (_v1.$ === 3) {
                            var csvReport = _v1.a;
                            var flexItemClass = 'relative after:absolute after:content-[\'|\'] after:-right-2 after:translate-x-1/2';
                            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('You\'re about to export and download the report. Please select the columns below:'),
                                    A2($elm$html$Html$div, _List_fromArray([
                                        $elm$html$Html$Attributes$class('well well-sm'),
                                        A2($elm$html$Html$Attributes$style, 'overflow-y', 'scroll'),
                                        A2($elm$html$Html$Attributes$style, 'max-height', '212px')
                                    ]), A2($elm$core$List$map, $author$project$Components$ExportCsv$viewColumn(model.bh), $author$project$Api$Common$CsvReport$One$columns(csvReport)))
                                ])),
                                A2($elm$html$Html$p, _List_fromArray([
                                    $elm$html$Html$Attributes$class('flex justify-end gap-4')
                                ]), _List_fromArray([
                                    A2($elm$html$Html$span, _List_fromArray([
                                        $elm$html$Html$Attributes$class(flexItemClass)
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Select all'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$link,
                                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                            $author$project$Ui$Button$onClick($author$project$Components$ExportCsv$SelectAllColumns(csvReport))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Select All')
                                        ]))
                                    ])),
                                    A2($elm$html$Html$span, _List_fromArray([
                                        $elm$html$Html$Attributes$class(flexItemClass)
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Select all'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$link,
                                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                            $author$project$Ui$Button$onClick($author$project$Components$ExportCsv$DeselectAllColumns)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Unselect All')
                                        ]))
                                    ])),
                                    !model.adW ? A2($elm$html$Html$span, _List_fromArray([
                                        $elm$html$Html$Attributes$class(flexItemClass)
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Save selection'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$link,
                                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                            $author$project$Ui$Button$onClick($author$project$Components$ExportCsv$SaveDefaultColumns)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Save Selection')
                                        ]))
                                    ])) : $author$project$Utils$Html$empty,
                                    A2($elm$html$Html$span, _List_fromArray([
                                        $elm$html$Html$Attributes$class('text-muted pull-right')
                                    ]), _List_fromArray([
                                        $elm$html$Html$text($elm$core$String$fromInt($elm$core$Set$size(model.bh)) + (' of ' + ($elm$core$String$fromInt($elm$core$List$length($author$project$Api$Common$CsvReport$One$columns(csvReport))) + ' columns to be exported')))
                                    ]))
                                ])),
                                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                                    $author$project$Components$ExportCsv$isInvalid(optionsRecord.oQ) ? $author$project$Utils$FormErrors$view(_List_fromArray([
                                        'Your report exceeds the  ' + ($author$project$Formatters$Int$formatNumber($author$project$Components$ExportCsv$totalCountLimit) + ' items limit and cannot be exported. Please refine your search criteria (e.g., adjust date ranges or filters) to reduce the number of records, then try again.')
                                    ])) : $author$project$Utils$Html$empty
                                ]))
                            ]));
                        } else return A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('text-center')
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]));
                    }
                }()
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                optionsRecord.jQ && $author$project$Components$ExportCsv$reportExportGenerated(model.dg) ? A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('text-center')
                ]), _List_fromArray([
                    function() {
                        var _v2 = A2($author$project$Components$ExportCsv$reportExportHref, apiClient, model.dg);
                        if (!_v2.$) {
                            var reportExportHref_ = _v2.a;
                            return A2($elm$html$Html$map, $author$project$Components$ExportCsv$ExportFileMsg, A3($author$project$Components$FileLink$view, {
                                Li: apiClient,
                                PX: 0,
                                aaT: reportExportHref_
                            }, _List_fromArray([
                                $author$project$Ui$Link$buttonPrimary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Download')
                            ])));
                        } else return A3($author$project$Ui$Button$view, {
                            abP: 'Download'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$disabled(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Download')
                        ]));
                    }()
                ])) : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel'
                        }, _List_fromArray([
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$onClick($author$project$Components$ExportCsv$CloseModal)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), function() {
                        if (optionsRecord.jQ) return _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Export'
                            }, _List_fromArray([
                                $author$project$Ui$Button$fullWidth(true),
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$disabled(model.qE || $author$project$Components$ExportCsv$isInvalid(optionsRecord.oQ)),
                                $author$project$Ui$Button$onClick($author$project$Components$ExportCsv$StartExport(optionsRecord.BJ)),
                                $author$project$Ui$Button$loading(_Utils_eq(optionsRecord.oQ, $elm$core$Maybe$Nothing))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Export')
                            ]))
                        ]);
                        else {
                            var _v3 = A3($author$project$Components$ExportCsv$downloadCsvHref, apiClient, optionsRecord, $elm$core$Set$toList(model.bh));
                            if (!_v3.$) {
                                var downloadCsvHref_ = _v3.a;
                                return _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Components$ExportCsv$ExportFileMsg, A3($author$project$Components$FileLink$view, {
                                        Li: apiClient,
                                        PX: 0,
                                        aaT: downloadCsvHref_
                                    }, _List_fromArray([
                                        $author$project$Ui$Link$buttonPrimary,
                                        $author$project$Ui$Link$fullWidth
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Export')
                                    ])))
                                ]);
                            } else return _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Export'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$disabled(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Export')
                                ]))
                            ]);
                        }
                    }())
                ]))
            ]))
        ]));
    });
    var $author$project$Components$ExportCsv$modal = F3(function(apiClient, options, model) {
        return model.ys ? A3($author$project$Components$ExportCsv$viewModal, apiClient, options, model) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$ExportCsv$Params = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$params = $author$project$Components$ExportCsv$Params;
    var $author$project$Components$ExportCsv$Path = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$path = $author$project$Components$ExportCsv$Path;
    var $author$project$Components$Upload$Result$viewExportToCsvModal = F3(function(apiClient, upload, model) {
        return A2($elm$html$Html$map, $author$project$Components$Upload$Result$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
            $author$project$Components$ExportCsv$params($author$project$Components$Upload$Result$exportParams(upload)),
            $author$project$Components$ExportCsv$path($author$project$Api$Provider$UploadRow$uploadRowsPath($author$project$Api$Provider$Upload$One$id(upload))),
            $author$project$Components$ExportCsv$filter('upload')
        ]), model.md));
    });
    var $author$project$Components$Upload$Result$PaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Panel$Danger = 4;
    var $author$project$Ui$Panel$Styling = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Panel$danger = $author$project$Ui$Panel$Styling(4);
    var $author$project$Api$Common$Upload$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$Upload$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$errorMessage(shared);
    };
    var $author$project$Components$Upload$Result$errorMessages = function(upload) {
        return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$String$split('\n'), $author$project$Api$Provider$Upload$One$errorMessage(upload)));
    };
    var $author$project$Api$Provider$UploadRow$All$uploadRowResults = function(_v0) {
        var record = _v0.b;
        return record.aaP;
    };
    var $author$project$Api$Provider$UploadRowResult$Shared$data = function(_v0) {
        var record = _v0;
        return record.M$;
    };
    var $author$project$Api$Common$UploadRowResult$Data$field = function(_v0) {
        var record = _v0;
        return record.PD;
    };
    var $author$project$Components$Upload$Result$errorField = function(uploadRowResult) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$field, $author$project$Api$Provider$UploadRowResult$Shared$data(uploadRowResult)));
    };
    var $author$project$Api$Common$UploadRowResult$Data$value = function(_v0) {
        var record = _v0;
        return record.aa9;
    };
    var $author$project$Components$Upload$Result$errorFieldValue = function(uploadRowResult) {
        return A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$value, $author$project$Api$Provider$UploadRowResult$Shared$data(uploadRowResult));
    };
    var $author$project$Api$Provider$UploadRowResult$Shared$message = function(_v0) {
        var record = _v0;
        return record.ae1;
    };
    var $author$project$Api$Provider$UploadRowResult$Shared$rowNumber = function(_v0) {
        var record = _v0;
        return record.Zb;
    };
    var $author$project$Components$Upload$Result$viewUploadRowResult = function(uploadRowResult) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$UploadRowResult$Shared$rowNumber(uploadRowResult)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Upload$Result$errorField(uploadRowResult))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    function() {
                        var _v0 = $author$project$Components$Upload$Result$errorFieldValue(uploadRowResult);
                        if (!_v0.$) {
                            var value = _v0.a;
                            return $elm$html$Html$text(value);
                        } else return $elm$html$Html$text('Blank');
                    }()
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$UploadRowResult$Shared$message(uploadRowResult)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
        ]));
    };
    var $author$project$Components$Upload$Result$viewUploadRow = function(uploadRow) {
        return A2($elm$core$List$map, $author$project$Components$Upload$Result$viewUploadRowResult, $author$project$Api$Provider$UploadRow$All$uploadRowResults(uploadRow));
    };
    var $author$project$Components$Upload$Result$viewUploadErrors = F2(function(model, upload) {
        return _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$danger
            ]), A2($elm$core$List$cons, A2($author$project$Ui$Panel$heading, _List_Nil, A2($elm$core$List$map, function(message) {
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(message)
                ]));
            }, $author$project$Components$Upload$Result$errorMessages(upload))), function() {
                var _v0 = model.tC;
                if (_v0.$ === 3) {
                    var list = _v0.a;
                    return $elm$core$List$isEmpty(list) ? _List_Nil : _List_fromArray([
                        A4($author$project$Ui$Panel$table, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Row #')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Field')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Value')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Error')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$class('pull-right')
                                ]), _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Components$Upload$Result$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                                ]))
                            ]))
                        ]), A2($elm$core$List$concatMap, $author$project$Components$Upload$Result$viewUploadRow, list), _List_Nil),
                        A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Upload$Result$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_))
                        ]))
                    ]);
                } else return _List_Nil;
            }()))
        ]);
    });
    var $author$project$Components$Upload$Result$viewModalBody = F3(function(apiClient, model, upload) {
        var _v0 = _Utils_Tuple2($author$project$Components$Upload$Result$finishProcessing(upload), model.tC);
        if (_v0.a && _v0.b.$ === 3) {
            var _v1 = _v0.b;
            var uploadRows = _v1.a;
            return A2($elm$core$List$cons, A3($author$project$Components$Upload$Result$viewExportToCsvModal, apiClient, upload, model), A2($author$project$Components$Upload$Result$failed, upload, uploadRows) ? A2($author$project$Components$Upload$Result$viewUploadErrors, model, upload) : _List_fromArray([
                A2($author$project$Ui$Alert$success, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Your file was uploaded successfully.'),
                    function() {
                        var _v2 = $author$project$Api$Provider$Upload$One$uploaderType(upload);
                        if (_v2.$ === 3) return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Export results: '),
                            A2($elm$html$Html$map, $author$project$Components$Upload$Result$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                        ]));
                        else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]));
        } else return _List_fromArray([
            $author$project$Ui$Spinner$view(_List_Nil),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            $elm$html$Html$text('Your upload is processing and may take a few minutes.'),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            $author$project$Api$Provider$Upload$One$rowsTotal(upload) > 0 ? $elm$html$Html$text('Processed ' + (A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Api$Provider$Upload$One$rowsProcessedOrIgnored)(upload) + (' out of ' + A2($elm$core$Basics$composeL, $elm$core$String$fromInt, $author$project$Api$Provider$Upload$One$rowsTotal)(upload)))) : $author$project$Utils$Html$empty
        ]);
    });
    var $author$project$Components$Upload$Result$modal = F2(function(apiClient, model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Upload$Result$ModalClosed, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                function() {
                    var _v0 = model.DP;
                    if (_v0.$ === 3) {
                        var upload = _v0.a;
                        return $author$project$Ui$Modal$title(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Upload$One$name(upload)));
                    } else return $author$project$Ui$Spinner$view(_List_Nil);
                }()
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('text-center')
                ]), function() {
                    var _v1 = model.DP;
                    if (_v1.$ === 3) {
                        var upload = _v1.a;
                        return A3($author$project$Components$Upload$Result$viewModalBody, apiClient, model, upload);
                    } else return _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]);
                }())
            ]))
        ]));
    });
    var $author$project$Components$Upload$CannotUploadModal$view = function(onClose) {
        return A3($author$project$Ui$Modal$view, onClose, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('There is an upload currently in process. Please wait for it to be done before starting another.')
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Understood'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick(onClose)
                ]), _List_fromArray([
                    $elm$html$Html$text('OK')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Upload$Form$modal = F2(function(apiClient, model) {
        var _v0 = _Utils_Tuple2(model.ok, model.he);
        if (!_v0.b.$) {
            var uploadResult = _v0.b.a;
            return A2($elm$html$Html$map, $author$project$Components$Upload$Form$UploadResultMsg, A2($author$project$Components$Upload$Result$modal, apiClient, uploadResult));
        } else {
            if (_v0.a) return $author$project$Components$Upload$CannotUploadModal$view($author$project$Components$Upload$Form$CloseCannotUploadModal);
            else return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Pages$Admin$ChargeItems$Upload$DeleteAllCharges = {
        $: 1
    };
    var $author$project$Ui$Form$File$Csv = 1;
    var $author$project$Components$Upload$Form$FileUploaded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Upload$Resource$Membership = 5;
    var $author$project$Api$Provider$Upload$Column$columns = function(_v0) {
        var uploadColumns = _v0;
        return uploadColumns.LC;
    };
    var $author$project$Ui$Form$File$Disabled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$File$disabled = $author$project$Ui$Form$File$Disabled;
    var $author$project$Ui$Form$File$Empty = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$File$empty = $author$project$Ui$Form$File$Empty;
    var $author$project$Api$Provider$Upload$templatePath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'template'
    ]), $author$project$Api$Provider$Upload$uploadsPath($author$project$Api$Data$providerPath));
    var $author$project$Components$Upload$Form$exportCsvPath = F2(function(apiClient, model) {
        return A4($author$project$Api$Data$downloadUrl, apiClient, $author$project$Api$Provider$Upload$templatePath, 0, _List_fromArray([
            A2($elm$url$Url$Builder$string, 'type', $author$project$Api$Upload$Resource$toString(model.Hg))
        ]));
    });
    var $author$project$Api$Provider$Upload$Column$ignoredColumns = function(_v0) {
        var uploadColumns = _v0;
        return uploadColumns.Q2;
    };
    var $author$project$Api$Provider$Upload$Column$columnAliases = function(_v0) {
        var column = _v0;
        return column.I1;
    };
    var $author$project$Api$Provider$Upload$Column$columnAllowedValues = function(_v0) {
        var column = _v0;
        return column.Je;
    };
    var $author$project$Api$Provider$Upload$Column$columnDefault = function(_v0) {
        var column = _v0;
        return column.Nn;
    };
    var $author$project$Api$Provider$Upload$Column$columnHelp = function(_v0) {
        var column = _v0;
        return column.QF;
    };
    var $author$project$Api$Provider$Upload$Column$columnName = function(_v0) {
        var column = _v0;
        return column.zr;
    };
    var $author$project$Api$Provider$Upload$Column$columnRequired = function(_v0) {
        var column = _v0;
        return column.agM;
    };
    var $author$project$Ui$Typography$em = F2(function(options, content) {
        return A2($elm$html$Html$em, $author$project$Ui$Typography$optionsToAttributes(options), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content));
    });
    var $author$project$Components$Upload$Form$formatAliases = function(column) {
        return A2($elm$core$String$join, ', ', A2($elm$core$List$map, function(columnAlias) {
            return '\"' + (columnAlias + '\"');
        }, $author$project$Api$Provider$Upload$Column$columnAliases(column)));
    };
    var $author$project$Components$Upload$Form$viewColumn = function(column) {
        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Upload$Column$columnName(column)),
            $author$project$Api$Provider$Upload$Column$columnRequired(column) ? A2($author$project$Ui$Typography$em, _List_fromArray([
                $author$project$Ui$Typography$danger,
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text(' * required')
            ])) : $author$project$Utils$Html$empty,
            function() {
                var _v0 = $author$project$Api$Provider$Upload$Column$columnAllowedValues(column);
                if (!_v0.$) {
                    var allowedValues = _v0.a;
                    return A2($author$project$Ui$Typography$em, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(allowedValues)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v1 = $author$project$Api$Provider$Upload$Column$columnDefault(column);
                if (!_v1.$) {
                    var _default = _v1.a;
                    return A2($author$project$Ui$Typography$em, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(' Default: ' + _default)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            $elm$core$List$isEmpty($author$project$Api$Provider$Upload$Column$columnAliases(column)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$em, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text(' Aliases: ' + $author$project$Components$Upload$Form$formatAliases(column))
            ])),
            function() {
                var _v2 = $author$project$Api$Provider$Upload$Column$columnHelp(column);
                if (!_v2.$) {
                    var help = _v2.a;
                    return A3($author$project$Ui$Tooltip$view, _List_Nil, help, _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace,
                        $author$project$Ui$Icon$help(_List_Nil)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Upload$Form$ToggleIgnored = {
        $: 1
    };
    var $author$project$Components$Upload$Form$viewIgnoredColumns = F2(function(showIgnored, ignoredColumns) {
        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Click'),
            $author$project$Utils$Html$noBreakSpace,
            A3($author$project$Ui$Button$view, {
                abP: 'see list of extra columns accepted'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Components$Upload$Form$ToggleIgnored)
            ]), _List_fromArray([
                $elm$html$Html$text('here')
            ])),
            $author$project$Utils$Html$noBreakSpace,
            $elm$html$Html$text('to see the list of extra columns that are accepted but its value will be ignored.'),
            showIgnored ? A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, function(ignoredColumn) {
                return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(ignoredColumn)
                ]));
            }, ignoredColumns)) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Upload$Form$ViewUploadResult = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Common$Upload$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Upload$All$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$Upload$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$name(shared);
    };
    var $author$project$Components$Upload$Form$viewPendingUpload = F2(function(timeFormatter, pendingUpload) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Upload$All$name(pendingUpload)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Provider$Upload$All$createdAt(pendingUpload)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'View progress'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Components$Upload$Form$ViewUploadResult(pendingUpload))
                ]), _List_fromArray([
                    $elm$html$Html$text('View Progress')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Upload$Form$viewPendingUploads = F2(function(timeFormatter, pendingUploads) {
        if (pendingUploads.$ === 3) {
            var pendingUploads_ = pendingUploads.a;
            return $elm$core$List$isEmpty(pendingUploads_) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Pending uploads')
                ])),
                A4($author$project$Ui$Panel$table, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('File Name')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Uploaded at')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ]), A2($elm$core$List$map, $author$project$Components$Upload$Form$viewPendingUpload(timeFormatter), pendingUploads_), _List_Nil)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Upload$Form$view = F2(function(apiClient, model) {
        var _v0 = model.DQ;
        if (_v0.$ === 3) {
            var uploadColumns = _v0.a;
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Step 2. Create a CSV file.')
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('It should include these exact headers:')
                ])),
                A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, $author$project$Components$Upload$Form$viewColumn, $author$project$Api$Provider$Upload$Column$columns(uploadColumns))),
                $elm$core$List$isEmpty($author$project$Api$Provider$Upload$Column$ignoredColumns(uploadColumns)) ? $author$project$Utils$Html$empty : A2($author$project$Components$Upload$Form$viewIgnoredColumns, model.sU, $author$project$Api$Provider$Upload$Column$ignoredColumns(uploadColumns)),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Get started with our ready-to-go template'),
                    $author$project$Utils$Html$noBreakSpace,
                    model.Hg === 5 ? A3($author$project$Ui$Link$externalHref, 'https://docs.google.com/spreadsheets/d/1gOlyMYkKwCRuI682gvS2Z8VJq9LdChM_px-4g28MXZs/edit?gid=2103379914', _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $elm$html$Html$text('here.')
                    ])) : A2($elm$html$Html$map, $author$project$Components$Upload$Form$ExportFileMsg, A3($author$project$Components$FileLink$view, {
                        Li: apiClient,
                        PX: 0,
                        aaT: A2($author$project$Components$Upload$Form$exportCsvPath, apiClient, model)
                    }, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('here.')
                    ])))
                ])),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Step 3. Upload the file.')
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    model.v$ ? $elm$html$Html$text('Don\'t worry, once it\'s uploaded you\'ll be able to fix any errors.') : $elm$html$Html$text('There is an upload in process. Uploading will be available when it is complete.')
                ])),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Form$File$view(_List_fromArray([
                            $author$project$Ui$Form$File$disabled(!model.v$),
                            $author$project$Ui$Form$File$accept(1),
                            $author$project$Ui$Form$File$onInput($author$project$Components$Upload$Form$FileUploaded),
                            $author$project$Ui$Form$File$empty(true)
                        ]))
                    ]))
                ])),
                A2($author$project$Components$Upload$Form$viewPendingUploads, model.HO, model.A2)
            ]));
        } else return $author$project$Ui$Spinner$view(_List_Nil);
    });
    var $author$project$Pages$Admin$ChargeItems$Upload$viewBody = function(model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Upload Charge Items')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top, _List_Nil, _List_fromArray([
                            $author$project$Ui$Icon$cross(_List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                !A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.W1) ? A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Want to Start Over?')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Click the button below to remove existing charge items.')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete all charge items'
                    }, _List_fromArray([
                        $author$project$Ui$Button$danger,
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$ChargeItems$Upload$DeleteAllCharges)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete All Charge Items')
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A2($elm$html$Html$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, A2($author$project$Components$Upload$Form$view, model.Ej, model.PU))
            ])),
            A2($author$project$Ui$Panel$footer, _List_fromArray([
                $author$project$Ui$Element$justifyCenter,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top, _List_fromArray([
                    $author$project$Ui$Link$buttonDefault
                ]), _List_fromArray([
                    $elm$html$Html$text('Back')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$ChargeItems$Upload$view = function(model) {
        return {
            fb: _List_fromArray([
                model.lU ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$ChargeItems$Upload$HiConfirmChargesClosed, _List_fromArray([
                    $author$project$Components$HiConfirm$verb('Delete All Charges'),
                    $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Warning: ')
                        ])),
                        $elm$html$Html$text('this will delete all the charges from the practice.')
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A2($elm$html$Html$map, $author$project$Pages$Admin$ChargeItems$Upload$UploadFormMsg, A2($author$project$Components$Upload$Form$modal, model.Ej, model.PU)),
                $author$project$Pages$Admin$ChargeItems$Upload$viewBody(model)
            ]),
            $2: 'Admin | Charge Items'
        };
    };
    var $author$project$Pages$Admin$ChargeItems$Upload$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$ChargeItems$Upload$init,
        aeR: $author$project$Pages$Admin$ChargeItems$Upload$load,
        ag3: $author$project$Pages$Admin$ChargeItems$Upload$save,
        ahE: $author$project$Pages$Admin$ChargeItems$Upload$subscriptions,
        aaO: $author$project$Pages$Admin$ChargeItems$Upload$update,
        aid: $author$project$Pages$Admin$ChargeItems$Upload$view
    });
    var $author$project$Pages$Admin$Commissions$init = F4(function(session, practice, shared, _v0) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            W1: practice,
            Z$: session
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Commissions$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Commissions$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Commissions$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Commissions$GotPractice = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$enableCommissions = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enable_commissions'
        ]), $author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Admin$Commissions$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(model, A2($author$project$Api$Provider$Practice$enableCommissions, model.Ej, $author$project$Pages$Admin$Commissions$GotPractice), _List_Nil);
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        W1: practice
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Commissions successfully enabled'),
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                return _Utils_Tuple3(model, $author$project$Ports$Intercom$open(model.Z$), _List_Nil);
        }
    });
    var $author$project$Formatters$Date$MonthAndYear = {
        $: 2
    };
    var $author$project$Api$Provider$Practice$One$commissionsEnabled = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.LF;
    });
    var $author$project$Api$Provider$Practice$One$commissionsTrackingFrom = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.LG;
    });
    var $author$project$Api$Feature$CommissionsTracking = 0;
    var $author$project$Pages$Admin$Commissions$Enable = {
        $: 0
    };
    var $author$project$Pages$Admin$Commissions$ShowSupportChat = {
        $: 2
    };
    var $author$project$Pages$Admin$Commissions$viewEnableForm = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$autocomplete(false),
                $author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Commissions$Enable)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Description')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Once enabled, We will allow a broker to be associated with a retail membership and/or employers. '),
                        $elm$html$Html$text('Commissions will be automatically calculated for these relationships.')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('')
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Enable commissions'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$disabled(!A2($author$project$Api$Provider$Practice$One$featureEnabled, 0, model.W1))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Enable commissions')
                    ])),
                    A2($author$project$Api$Provider$Practice$One$featureEnabled, 0, model.W1) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Commissions is not yet available for your account, please '),
                            A3($author$project$Ui$Button$view, {
                                abP: 'contact us'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Commissions$ShowSupportChat)
                            ]), _List_fromArray([
                                $elm$html$Html$text('contact us')
                            ])),
                            $elm$html$Html$text(' to learn more.')
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Commissions$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $author$project$Api$Provider$Practice$One$commissionsEnabled(model.W1) ? $elm$html$Html$text('Commissions set-up') : $elm$html$Html$text('Enable commissions for this practice')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Api$Provider$Practice$One$commissionsEnabled(model.W1) ? _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8),
                            $author$project$Ui$Form$Group$label('Commission Status')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Tracking started in '),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$MonthAndYear), $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.W1))))
                            ]))
                        ]))
                    ]) : $author$project$Pages$Admin$Commissions$viewEnableForm(model))
                ]))
            ]),
            $2: 'Admin | Commissions'
        };
    };
    var $author$project$Pages$Admin$Commissions$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Commissions$init,
        aeR: $author$project$Pages$Admin$Commissions$load,
        ag3: $author$project$Pages$Admin$Commissions$save,
        ahE: $author$project$Pages$Admin$Commissions$subscriptions,
        aaO: $author$project$Pages$Admin$Commissions$update,
        aid: $author$project$Pages$Admin$Commissions$view
    });
    var $author$project$Components$Plan$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Api$Feature$TobaccoSurcharge = 2;
    var $author$project$Api$Provider$Plan$CoveragePlan = 1;
    var $author$project$Components$Plan$Form$GotItem = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Plan$McePricing = 2;
    var $author$project$Api$Provider$Plan$One$Plan = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Plan$Shared$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Plan$Shared$Record = function(id) {
        return function(name) {
            return function(_default) {
                return function(buyable) {
                    return function(addon) {
                        return function(activeMembershipPatientsCount) {
                            return function(activeCompaniesCount) {
                                return function(planType) {
                                    return function(allowedBillingPeriodCodes) {
                                        return function(defaultPeriodInMonths) {
                                            return function(groupPricingType) {
                                                return function(groupDiscountRules) {
                                                    return function(tobaccoSurchargeType) {
                                                        return function(tobaccoSurchargeInCents) {
                                                            return function(tobaccoSurchargePercentage) {
                                                                return function(billsAtEndOfPeriod) {
                                                                    return function(maximumAge) {
                                                                        return function(minimumAge) {
                                                                            return function(isMcePlan) {
                                                                                return function(minimumEnrollmentPeriodInMonths) {
                                                                                    return function(isDestroyable) {
                                                                                        return function(ageRateRules) {
                                                                                            return function(individualRateRule) {
                                                                                                return function(coupleRateRule) {
                                                                                                    return function(singleParentWithSingleChildRateRuleEnabled) {
                                                                                                        return function(singleParentWithSingleChildRateRule) {
                                                                                                            return function(singleParentRateRule) {
                                                                                                                return function(familyWithSingleChildRateRuleEnabled) {
                                                                                                                    return function(familyWithSingleChildRateRule) {
                                                                                                                        return function(additionalAdultRateRule) {
                                                                                                                            return function(additionalChildRateRule) {
                                                                                                                                return function(familyRateRule) {
                                                                                                                                    return function(discountRules) {
                                                                                                                                        return function(coupleDiscountRule) {
                                                                                                                                            return function(singleParentDiscountRule) {
                                                                                                                                                return function(familyDiscountRule) {
                                                                                                                                                    return function(additionalAdultDiscountRule) {
                                                                                                                                                        return function(additionalChildDiscountRule) {
                                                                                                                                                            return function(childrenOnlyDiscountRule) {
                                                                                                                                                                return function(specialRates) {
                                                                                                                                                                    return function(pricingFrom) {
                                                                                                                                                                        return function(sponsorFeeDeal) {
                                                                                                                                                                            return function(coveragePlan) {
                                                                                                                                                                                return function(imageUrl) {
                                                                                                                                                                                    return {
                                                                                                                                                                                        Is: activeCompaniesCount,
                                                                                                                                                                                        Iv: activeMembershipPatientsCount,
                                                                                                                                                                                        tQ: additionalAdultDiscountRule,
                                                                                                                                                                                        ID: additionalAdultRateRule,
                                                                                                                                                                                        tR: additionalChildDiscountRule,
                                                                                                                                                                                        IE: additionalChildRateRule,
                                                                                                                                                                                        IF: addon,
                                                                                                                                                                                        I_: ageRateRules,
                                                                                                                                                                                        Ef: allowedBillingPeriodCodes,
                                                                                                                                                                                        Kh: billsAtEndOfPeriod,
                                                                                                                                                                                        Ky: buyable,
                                                                                                                                                                                        wb: childrenOnlyDiscountRule,
                                                                                                                                                                                        wX: coupleDiscountRule,
                                                                                                                                                                                        Mh: coupleRateRule,
                                                                                                                                                                                        Mn: coveragePlan,
                                                                                                                                                                                        Nn: _default,
                                                                                                                                                                                        Ny: defaultPeriodInMonths,
                                                                                                                                                                                        N2: discountRules,
                                                                                                                                                                                        xG: familyDiscountRule,
                                                                                                                                                                                        Pr: familyRateRule,
                                                                                                                                                                                        Pt: familyWithSingleChildRateRule,
                                                                                                                                                                                        Pu: familyWithSingleChildRateRuleEnabled,
                                                                                                                                                                                        Qd: groupDiscountRules,
                                                                                                                                                                                        Qh: groupPricingType,
                                                                                                                                                                                        aef: id,
                                                                                                                                                                                        Q4: imageUrl,
                                                                                                                                                                                        Rb: individualRateRule,
                                                                                                                                                                                        R1: isDestroyable,
                                                                                                                                                                                        R9: isMcePlan,
                                                                                                                                                                                        TQ: maximumAge,
                                                                                                                                                                                        Un: minimumAge,
                                                                                                                                                                                        Up: minimumEnrollmentPeriodInMonths,
                                                                                                                                                                                        zr: name,
                                                                                                                                                                                        WN: planType,
                                                                                                                                                                                        Xp: pricingFrom,
                                                                                                                                                                                        CE: singleParentDiscountRule,
                                                                                                                                                                                        _w: singleParentRateRule,
                                                                                                                                                                                        _y: singleParentWithSingleChildRateRule,
                                                                                                                                                                                        _z: singleParentWithSingleChildRateRuleEnabled,
                                                                                                                                                                                        _M: specialRates,
                                                                                                                                                                                        _S: sponsorFeeDeal,
                                                                                                                                                                                        aab: tobaccoSurchargeInCents,
                                                                                                                                                                                        aac: tobaccoSurchargePercentage,
                                                                                                                                                                                        aad: tobaccoSurchargeType
                                                                                                                                                                                    };
                                                                                                                                                                                };
                                                                                                                                                                            };
                                                                                                                                                                        };
                                                                                                                                                                    };
                                                                                                                                                                };
                                                                                                                                                            };
                                                                                                                                                        };
                                                                                                                                                    };
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$PlanType$AffiliateDependable = 4;
    var $author$project$Api$PlanType$Company = 0;
    var $author$project$Api$PlanType$Mce = 3;
    var $author$project$Api$PlanType$Retail = 2;
    var $author$project$Api$PlanType$SponsorFixedFee = 1;
    var $author$project$Api$PlanType$decodePlanType = function(string) {
        switch(string){
            case 'company':
                return $elm$json$Json$Decode$succeed(0);
            case 'sponsor_fixed_fee':
                return $elm$json$Json$Decode$succeed(1);
            case 'retail':
                return $elm$json$Json$Decode$succeed(2);
            case 'mce':
                return $elm$json$Json$Decode$succeed(3);
            case 'affiliate_dependable':
                return $elm$json$Json$Decode$succeed(4);
            default:
                return $elm$json$Json$Decode$fail('Unsupported plan type: ' + string);
        }
    };
    var $author$project$Api$PlanType$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$PlanType$decodePlanType, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$CoveragePlan$One$CoveragePlan = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CoveragePlan$Shared$CoveragePlan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoveragePlan$Shared$Record = F3(function(id, name, coverageRules) {
        return {
            acC: coverageRules,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$CoverageRule$One$CoverageRule = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CoverageRule$Shared$CoverageRule = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoverageRule$Shared$Record = function(id) {
        return function(ruleType) {
            return function(amountInCents) {
                return function(timePeriod) {
                    return function(quantity) {
                        return function(percentage) {
                            return function(patientContributionPercentage) {
                                return function(sponsorContributionPercentage) {
                                    return function(item) {
                                        return function(published) {
                                            return function(category) {
                                                return {
                                                    Jh: amountInCents,
                                                    EL: category,
                                                    aef: id,
                                                    F6: item,
                                                    af3: patientContributionPercentage,
                                                    af9: percentage,
                                                    XM: published,
                                                    Bu: quantity,
                                                    ag0: ruleType,
                                                    ahv: sponsorContributionPercentage,
                                                    ahU: timePeriod
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CoverageRule$Shared$Category = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$CoverageRule$Shared$categoryDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Category$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$Category));
    var $author$project$Api$Provider$CoverageRule$Shared$ChargeItem = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$CoverageRule$Shared$chargeItemDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$ChargeItem));
    var $author$project$Api$Provider$Category$Min$Category = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Category$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Category$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Category$Min$Record)));
    var $author$project$Api$Provider$Category$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Category$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CoverageRule$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'published', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'item', $elm$json$Json$Decode$oneOf(_List_fromArray([
        $author$project$Api$Provider$CoverageRule$Shared$chargeItemDecoder,
        $author$project$Api$Provider$CoverageRule$Shared$categoryDecoder
    ])), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsor_contribution_percentage', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient_contribution_percentage', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'percentage', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'time_period', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rule_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$Shared$Record))))))))))));
    var $author$project$Api$Provider$CoverageRule$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoverageRule$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CoverageRule$One$Record = function(unpublishedRule) {
        return {
            HY: unpublishedRule
        };
    };
    var $author$project$Api$Provider$CoverageRule$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'unpublished_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CoverageRule$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$One$Record));
    var $author$project$Api$Provider$CoverageRule$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoverageRule$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoverageRule$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRule$One$CoverageRule)));
    var $author$project$Api$Provider$CoveragePlan$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'coverage_rules', $elm$json$Json$Decode$list($author$project$Api$Provider$CoverageRule$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$Shared$Record))));
    var $author$project$Api$Provider$CoveragePlan$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoveragePlan$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CoveragePlan$One$Record = F2(function(plans, coverageDocuments) {
        return {
            Mm: coverageDocuments,
            WO: plans
        };
    });
    var $author$project$Api$Provider$CoverageDocument$Shared$CoverageDocument = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoverageDocument$Shared$Record = F3(function(id, fileName, url) {
        return {
            PF: fileName,
            aef: id,
            aaT: url
        };
    });
    var $author$project$Api$Provider$CoverageDocument$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageDocument$Shared$Record))));
    var $author$project$Api$Provider$CoverageDocument$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoverageDocument$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Plan$Min$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Plan$Min$Record = F5(function(id, maximumAge, minimumAge, name, tobaccoSurchargeType) {
        return {
            aef: id,
            TQ: maximumAge,
            Un: minimumAge,
            zr: name,
            aad: tobaccoSurchargeType
        };
    });
    var $author$project$Api$Provider$Plan$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tobacco_surcharge_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'maximum_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Min$Record))))));
    var $author$project$Api$Provider$Plan$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Plan$Min$recordDecoder);
    var $author$project$Api$Provider$CoveragePlan$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'coverage_documents', $elm$json$Json$Decode$list($author$project$Api$Provider$CoverageDocument$Shared$decoder), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plans', $elm$json$Json$Decode$list($author$project$Api$Provider$Plan$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$One$Record)));
    var $author$project$Api$Provider$CoveragePlan$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoveragePlan$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoveragePlan$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveragePlan$One$CoveragePlan)));
    var $author$project$Api$Provider$DiscountRule$Shared$DiscountRule = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DiscountRule$Shared$Record = function(fromSize) {
        return function(toSize) {
            return function(calculatedBy) {
                return function(monthMaximumInCents) {
                    return function(monthMaximumInCentsEdited) {
                        return function(quarterMaximumInCents) {
                            return function(quarterMaximumInCentsEdited) {
                                return function(semiAnnualMaximumInCents) {
                                    return function(semiAnnualMaximumInCentsEdited) {
                                        return function(annualMaximumInCents) {
                                            return function(annualMaximumInCentsEdited) {
                                                return function(monthAmountOffInCents) {
                                                    return function(monthAmountOffInCentsEdited) {
                                                        return function(quarterAmountOffInCents) {
                                                            return function(quarterAmountOffInCentsEdited) {
                                                                return function(semiAnnualAmountOffInCents) {
                                                                    return function(semiAnnualAmountOffInCentsEdited) {
                                                                        return function(annualAmountOffInCents) {
                                                                            return function(annualAmountOffInCentsEdited) {
                                                                                return function(monthPercentOff) {
                                                                                    return function(monthPercentOffEdited) {
                                                                                        return function(quarterPercentOff) {
                                                                                            return function(quarterPercentOffEdited) {
                                                                                                return function(semiAnnualPercentOff) {
                                                                                                    return function(semiAnnualPercentOffEdited) {
                                                                                                        return function(annualPercentOff) {
                                                                                                            return function(annualPercentOffEdited) {
                                                                                                                return {
                                                                                                                    Jm: annualAmountOffInCents,
                                                                                                                    Jn: annualAmountOffInCentsEdited,
                                                                                                                    Jo: annualMaximumInCents,
                                                                                                                    Jp: annualMaximumInCentsEdited,
                                                                                                                    Js: annualPercentOff,
                                                                                                                    Jt: annualPercentOffEdited,
                                                                                                                    KD: calculatedBy,
                                                                                                                    P0: fromSize,
                                                                                                                    Uv: monthAmountOffInCents,
                                                                                                                    Uw: monthAmountOffInCentsEdited,
                                                                                                                    Ux: monthMaximumInCents,
                                                                                                                    Uy: monthMaximumInCentsEdited,
                                                                                                                    UC: monthPercentOff,
                                                                                                                    UD: monthPercentOffEdited,
                                                                                                                    XW: quarterAmountOffInCents,
                                                                                                                    XX: quarterAmountOffInCentsEdited,
                                                                                                                    XY: quarterMaximumInCents,
                                                                                                                    XZ: quarterMaximumInCentsEdited,
                                                                                                                    X0: quarterPercentOff,
                                                                                                                    X1: quarterPercentOffEdited,
                                                                                                                    ZJ: semiAnnualAmountOffInCents,
                                                                                                                    ZK: semiAnnualAmountOffInCentsEdited,
                                                                                                                    ZL: semiAnnualMaximumInCents,
                                                                                                                    ZM: semiAnnualMaximumInCentsEdited,
                                                                                                                    ZP: semiAnnualPercentOff,
                                                                                                                    ZQ: semiAnnualPercentOffEdited,
                                                                                                                    $6: toSize
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$DiscountRule$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'annual_percent_off_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'annual_percent_off', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'semi_annual_percent_off_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'semi_annual_percent_off', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'quarter_percent_off_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'quarter_percent_off', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'month_percent_off_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'month_percent_off', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'annual_amount_off_in_cents_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'annual_amount_off_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'semi_annual_amount_off_in_cents_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'semi_annual_amount_off_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'quarter_amount_off_in_cents_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'quarter_amount_off_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'month_amount_off_in_cents_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'month_amount_off_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'annual_maximum_in_cents_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'annual_maximum_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'semi_annual_maximum_in_cents_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'semi_annual_maximum_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'quarter_maximum_in_cents_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'quarter_maximum_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'month_maximum_in_cents_edited', $elm$json$Json$Decode$bool, false, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'month_maximum_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'calculated_by', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_size', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'from_size', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DiscountRule$Shared$Record))))))))))))))))))))))))))));
    var $author$project$Api$Provider$DiscountRule$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DiscountRule$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$RateRule$Shared$RateRule = $elm$core$Basics$identity;
    var $author$project$Api$Provider$RateRule$Shared$Record = F6(function(type_, fromAge, toAge, unit, periodRates, coupleAgeRateRule) {
        return {
            Mg: coupleAgeRateRule,
            P_: fromAge,
            dc: periodRates,
            $4: toAge,
            ah5: type_,
            aaG: unit
        };
    });
    var $author$project$Api$Provider$RateRule$Shared$CoupleAgeRateRule = function(periodRates) {
        return {
            dc: periodRates
        };
    };
    var $author$project$Api$Provider$RateRule$Shared$PeriodRates = F8(function(monthAmountInCents, monthAmountInCentsEdited, quarterAmountInCents, quarterAmountInCentsEdited, semiAnnualAmountInCents, semiAnnualAmountInCentsEdited, annualAmountInCents, annualAmountInCentsEdited) {
        return {
            Jk: annualAmountInCents,
            e3: annualAmountInCentsEdited,
            Uu: monthAmountInCents,
            gb: monthAmountInCentsEdited,
            XU: quarterAmountInCents,
            gx: quarterAmountInCentsEdited,
            ZH: semiAnnualAmountInCents,
            gM: semiAnnualAmountInCentsEdited
        };
    });
    var $author$project$Api$Provider$RateRule$Shared$periodRatesDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'annual_amount_in_cents_edited', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'annual_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'semi_annual_amount_in_cents_edited', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'semi_annual_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quarter_amount_in_cents_edited', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quarter_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'month_amount_in_cents_edited', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'month_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$PeriodRates)))))))));
    var $author$project$Api$Provider$RateRule$Shared$coupleAgeRateRuleDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RateRule$Shared$periodRatesDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$CoupleAgeRateRule));
    var $author$project$Api$RateRuleType$AdditionalAdult = {
        $: 6
    };
    var $author$project$Api$RateRuleType$AdditionalChild = {
        $: 7
    };
    var $author$project$Api$RateRuleType$AgeBased = {
        $: 8
    };
    var $author$project$Api$RateRuleType$AgeBasedCouple = {
        $: 9
    };
    var $author$project$Api$RateRuleType$Couple = {
        $: 1
    };
    var $author$project$Api$RateRuleType$Family = {
        $: 3
    };
    var $author$project$Api$RateRuleType$FamilyWithSingleChild = {
        $: 5
    };
    var $author$project$Api$RateRuleType$Individual = {
        $: 0
    };
    var $author$project$Api$RateRuleType$SingleParent = {
        $: 2
    };
    var $author$project$Api$RateRuleType$SingleParentWithSingleChild = {
        $: 4
    };
    var $author$project$Api$RateRuleType$Unknown = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$RateRuleType$decode = A2($elm$json$Json$Decode$map, function(string) {
        switch(string){
            case 'individual':
                return $author$project$Api$RateRuleType$Individual;
            case 'couple':
                return $author$project$Api$RateRuleType$Couple;
            case 'single_parent':
                return $author$project$Api$RateRuleType$SingleParent;
            case 'family':
                return $author$project$Api$RateRuleType$Family;
            case 'single_parent_with_single_child':
                return $author$project$Api$RateRuleType$SingleParentWithSingleChild;
            case 'family_with_single_child':
                return $author$project$Api$RateRuleType$FamilyWithSingleChild;
            case 'additional_adult':
                return $author$project$Api$RateRuleType$AdditionalAdult;
            case 'additional_child':
                return $author$project$Api$RateRuleType$AdditionalChild;
            case 'age_based':
                return $author$project$Api$RateRuleType$AgeBased;
            case 'age_based_couple':
                return $author$project$Api$RateRuleType$AgeBasedCouple;
            default:
                var somethingElse = string;
                return $author$project$Api$RateRuleType$Unknown(somethingElse);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$RateRule$Shared$Months = 1;
    var $author$project$Api$Provider$RateRule$Shared$Years = 0;
    var $author$project$Api$Provider$RateRule$Shared$stringToUnit = function(str) {
        switch(str){
            case 'years':
                return 0;
            case 'months':
                return 1;
            default:
                return 0;
        }
    };
    var $author$project$Api$Provider$RateRule$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'couple_age_rate', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$coupleAgeRateRuleDecoder), A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RateRule$Shared$periodRatesDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'unit', A2($elm$json$Json$Decode$map, $author$project$Api$Provider$RateRule$Shared$stringToUnit, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'from_age', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$RateRuleType$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Shared$Record)))))));
    var $author$project$Api$Provider$RateRule$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RateRule$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SpecialRate$Shared$SpecialRate = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SpecialRate$Shared$Record = function(id) {
        return function(name) {
            return function(monthAmountInCents) {
                return function(monthAmountInCentsEdited) {
                    return function(quarterAmountInCents) {
                        return function(quarterAmountInCentsEdited) {
                            return function(semiAnnualAmountInCents) {
                                return function(semiAnnualAmountInCentsEdited) {
                                    return function(annualAmountInCents) {
                                        return function(annualAmountInCentsEdited) {
                                            return function(isDestroyable) {
                                                return {
                                                    Jk: annualAmountInCents,
                                                    e3: annualAmountInCentsEdited,
                                                    aef: id,
                                                    R1: isDestroyable,
                                                    Uu: monthAmountInCents,
                                                    gb: monthAmountInCentsEdited,
                                                    zr: name,
                                                    XU: quarterAmountInCents,
                                                    gx: quarterAmountInCentsEdited,
                                                    ZH: semiAnnualAmountInCents,
                                                    gM: semiAnnualAmountInCentsEdited
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$SpecialRate$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'annual_amount_in_cents_edited', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'annual_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'semi_annual_amount_in_cents_edited', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'semi_annual_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quarter_amount_in_cents_edited', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quarter_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'month_amount_in_cents_edited', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'month_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SpecialRate$Shared$Record))))))))))));
    var $author$project$Api$Provider$SpecialRate$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SpecialRate$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SponsorFeeDeal$Shared$SponsorFeeDeal = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SponsorFeeDeal$Shared$Record = function(amountInCents) {
        return {
            Jh: amountInCents
        };
    };
    var $author$project$Api$Provider$SponsorFeeDeal$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SponsorFeeDeal$Shared$Record));
    var $author$project$Api$Provider$SponsorFeeDeal$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SponsorFeeDeal$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Plan$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'image_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($author$project$Api$Expandable$expandable, 'coverage_plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'sponsor_fee_deal', $elm$json$Json$Decode$nullable($author$project$Api$Provider$SponsorFeeDeal$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'pricing_from', $elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingStructure$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'special_rates', $elm$json$Json$Decode$list($author$project$Api$Provider$SpecialRate$Shared$decoder), _List_Nil, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'children_only_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'additional_child_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'additional_adult_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'family_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'single_parent_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'couple_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'discount_rules', $elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder), _List_Nil, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'family_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'additional_child_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'additional_adult_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'family_with_single_child_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_with_single_child_rate_rule_enabled', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'single_parent_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'single_parent_with_single_child_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'single_parent_with_single_child_rate_rule_enabled', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'couple_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'individual_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'age_rate_rules', $elm$json$Json$Decode$list($author$project$Api$Provider$RateRule$Shared$decoder), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_enrollment_period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_mce_plan', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'maximum_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bills_at_end_of_period', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tobacco_surcharge_percentage', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tobacco_surcharge_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tobacco_surcharge_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'group_discount_rules', $elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'group_pricing_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allowed_billing_period_codes', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan_type', $author$project$Api$PlanType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_companies_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_membership_patients_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'addon', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'buyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Shared$Record)))))))))))))))))))))))))))))))))))))))))))));
    var $author$project$Api$Provider$Plan$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Plan$One$Record = function(defaultPeriod) {
        return function(maxRegistrationFeeInCents) {
            return function(individualRegistrationFeeInCents) {
                return function(defaultChargeName) {
                    return function(defaultChargeDescription) {
                        return function(contractExpires) {
                            return function(contractPeriodInMonths) {
                                return function(contractType) {
                                    return function(contractEmailsEnabled) {
                                        return function(contractRenewalEmailLeadTime) {
                                            return function(iua) {
                                                return function(monthAdjustmentPercent) {
                                                    return function(monthAllowed) {
                                                        return function(quarterAdjustmentPercent) {
                                                            return function(quarterAllowed) {
                                                                return function(semiAnnualAdjustmentPercent) {
                                                                    return function(semiAnnualAllowed) {
                                                                        return function(annualAdjustmentPercent) {
                                                                            return function(annualAllowed) {
                                                                                return function(familyNumAdultsIncluded) {
                                                                                    return function(familyNumChildrenIncluded) {
                                                                                        return function(groupPricingFamilyNumChildrenIncluded) {
                                                                                            return function(numberAdditionalChildrenAllowed) {
                                                                                                return function(childrenAgeLimit) {
                                                                                                    return function(splitRevenueType) {
                                                                                                        return function(fixedChildrenAgeLimit) {
                                                                                                            return function(appliesGroupDiscountInTiers) {
                                                                                                                return function(discountsEnabled) {
                                                                                                                    return function(registrationFeeName) {
                                                                                                                        return function(registrationFeeDescription) {
                                                                                                                            return function(registrationFeeCategory) {
                                                                                                                                return function(descriptions) {
                                                                                                                                    return function(meta) {
                                                                                                                                        return function(mcePricing) {
                                                                                                                                            return function(upcomingPricingVersion) {
                                                                                                                                                return function(pricingEffectivenessType) {
                                                                                                                                                    return function(usedInScheduledPlanChanges) {
                                                                                                                                                        return {
                                                                                                                                                            vu: annualAdjustmentPercent,
                                                                                                                                                            vv: annualAllowed,
                                                                                                                                                            Jy: appliesGroupDiscountInTiers,
                                                                                                                                                            wa: childrenAgeLimit,
                                                                                                                                                            L4: contractEmailsEnabled,
                                                                                                                                                            L5: contractExpires,
                                                                                                                                                            L6: contractPeriodInMonths,
                                                                                                                                                            L7: contractRenewalEmailLeadTime,
                                                                                                                                                            EW: contractType,
                                                                                                                                                            xb: defaultChargeDescription,
                                                                                                                                                            xc: defaultChargeName,
                                                                                                                                                            Nx: defaultPeriod,
                                                                                                                                                            Ff: descriptions,
                                                                                                                                                            xm: discountsEnabled,
                                                                                                                                                            Pq: familyNumAdultsIncluded,
                                                                                                                                                            xH: familyNumChildrenIncluded,
                                                                                                                                                            PO: fixedChildrenAgeLimit,
                                                                                                                                                            Qg: groupPricingFamilyNumChildrenIncluded,
                                                                                                                                                            Rd: individualRegistrationFeeInCents,
                                                                                                                                                            SI: iua,
                                                                                                                                                            TN: maxRegistrationFeeInCents,
                                                                                                                                                            TU: mcePricing,
                                                                                                                                                            Ue: meta,
                                                                                                                                                            zj: monthAdjustmentPercent,
                                                                                                                                                            zk: monthAllowed,
                                                                                                                                                            zP: numberAdditionalChildrenAllowed,
                                                                                                                                                            Xo: pricingEffectivenessType,
                                                                                                                                                            Bw: quarterAdjustmentPercent,
                                                                                                                                                            Bx: quarterAllowed,
                                                                                                                                                            Ys: registrationFeeCategory,
                                                                                                                                                            BG: registrationFeeDescription,
                                                                                                                                                            BH: registrationFeeName,
                                                                                                                                                            Cn: semiAnnualAdjustmentPercent,
                                                                                                                                                            Co: semiAnnualAllowed,
                                                                                                                                                            _P: splitRevenueType,
                                                                                                                                                            aaN: upcomingPricingVersion,
                                                                                                                                                            aaW: usedInScheduledPlanChanges
                                                                                                                                                        };
                                                                                                                                                    };
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$ContractType$AutoRenew = 1;
    var $author$project$Api$ContractType$Terminate = 0;
    var $author$project$Api$ContractType$fromString = function(string) {
        switch(string){
            case 'terminate':
                return $elm$core$Maybe$Just(0);
            case 'auto-renew':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$ContractType$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        return A2($elm$core$Maybe$withDefault, $elm$json$Json$Decode$fail('Unsupported contract type: ' + string), A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, $author$project$Api$ContractType$fromString(string)));
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$PricingEffectivenessType$Anniversary = 2;
    var $author$project$Api$PricingEffectivenessType$ContractRenewal = 1;
    var $author$project$Api$PricingEffectivenessType$FirstBillAfter = 0;
    var $author$project$Api$PricingEffectivenessType$fromString = function(string) {
        switch(string){
            case 'first_bill_after':
                return $elm$core$Maybe$Just(0);
            case 'contract_renewal':
                return $elm$core$Maybe$Just(1);
            case 'anniversary':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$PricingEffectivenessType$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        return A2($elm$core$Maybe$withDefault, $elm$json$Json$Decode$fail('Unsupported pricing effectiveness type: ' + string), A2($elm$core$Maybe$map, $elm$json$Json$Decode$succeed, $author$project$Api$PricingEffectivenessType$fromString(string)));
    }, $elm$json$Json$Decode$string);
    var $elm$core$Dict$singleton = F2(function(key, value) {
        return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
    });
    var $author$project$Components$TranslatedRichText$decoderWithFallback = function(fieldName) {
        return $elm$json$Json$Decode$oneOf(_List_fromArray([
            $author$project$Components$TranslatedRichText$decoder(fieldName),
            A2($elm$json$Json$Decode$map, function(s) {
                return A2($elm$core$Dict$singleton, 'en', s);
            }, A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$string)),
            $elm$json$Json$Decode$succeed($elm$core$Dict$empty)
        ]));
    };
    var $author$project$Api$Provider$Plan$One$decodeDescriptions = $author$project$Components$TranslatedRichText$decoderWithFallback('description');
    var $author$project$Api$Provider$McePricing$One$McePricing = $elm$core$Basics$identity;
    var $author$project$Api$Provider$McePricing$One$Record = F4(function(coupleRates, familyRates, individualRates, singleParentWithChildrenRates) {
        return {
            Mi: coupleRates,
            Ps: familyRates,
            Rc: individualRates,
            _x: singleParentWithChildrenRates
        };
    });
    var $author$project$Api$Provider$McePricing$One$AgeBand = F3(function(fromAge, toAge, priceInCents) {
        return {
            P_: fromAge,
            Br: priceInCents,
            $4: toAge
        };
    });
    var $elm$json$Json$Decode$map3 = _Json_map3;
    var $author$project$Api$Provider$McePricing$One$ageBandDecoder = A4($elm$json$Json$Decode$map3, $author$project$Api$Provider$McePricing$One$AgeBand, A2($elm$json$Json$Decode$field, 'from_age', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'to_age', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'price_in_cents', $elm$json$Json$Decode$int));
    var $elm$json$Json$Decode$map4 = _Json_map4;
    var $author$project$Api$Provider$McePricing$One$recordDecoder = A5($elm$json$Json$Decode$map4, $author$project$Api$Provider$McePricing$One$Record, A2($elm$json$Json$Decode$field, 'single_parent_with_children_rates', $elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)), A2($elm$json$Json$Decode$field, 'family_rates', $elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)), A2($elm$json$Json$Decode$field, 'individual_rates', $elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)), A2($elm$json$Json$Decode$field, 'couple_rates', $elm$json$Json$Decode$list($author$project$Api$Provider$McePricing$One$ageBandDecoder)));
    var $author$project$Api$Provider$McePricing$One$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$McePricing$One$recordDecoder);
    var $author$project$Api$Provider$Plan$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Plan$Meta$MetaRecord = F6(function(allPeriodCodes, allowedPeriodCodes, rules, iuaOptions, allowedPeriodsInMonths, contractTypes) {
        return {
            I6: allPeriodCodes,
            Jc: allowedPeriodCodes,
            Jd: allowedPeriodsInMonths,
            L8: contractTypes,
            SJ: iuaOptions,
            Zk: rules
        };
    });
    var $author$project$Api$Provider$Plan$Meta$RulesRecord = function(individualRegistrationFeeInCents) {
        return function(minimumEnrollmentPeriodInMonths) {
            return function(maxRegistrationFeeInCents) {
                return function(fixedChildrenAgeLimit) {
                    return function(familyNumAdultsIncluded) {
                        return function(familyNumChildrenIncluded) {
                            return function(groupPricingFamilyNumChildrenIncluded) {
                                return function(coupleDiscountRule) {
                                    return function(familyDiscountRule) {
                                        return function(singleParentDiscountRule) {
                                            return function(additionalChildDiscountRule) {
                                                return function(additionalAdultDiscountRule) {
                                                    return function(childrenOnlyDiscountRule) {
                                                        return function(numberAdditionalChildrenAllowed) {
                                                            return function(childrenAgeLimit) {
                                                                return {
                                                                    tQ: additionalAdultDiscountRule,
                                                                    tR: additionalChildDiscountRule,
                                                                    wa: childrenAgeLimit,
                                                                    wb: childrenOnlyDiscountRule,
                                                                    wX: coupleDiscountRule,
                                                                    xG: familyDiscountRule,
                                                                    Pq: familyNumAdultsIncluded,
                                                                    xH: familyNumChildrenIncluded,
                                                                    PO: fixedChildrenAgeLimit,
                                                                    Qg: groupPricingFamilyNumChildrenIncluded,
                                                                    Rd: individualRegistrationFeeInCents,
                                                                    TN: maxRegistrationFeeInCents,
                                                                    Up: minimumEnrollmentPeriodInMonths,
                                                                    zP: numberAdditionalChildrenAllowed,
                                                                    CE: singleParentDiscountRule
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Plan$Meta$RuleRecord = function(enabled) {
        return {
            OM: enabled
        };
    };
    var $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enabled', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$RuleRecord));
    var $author$project$Api$Provider$Plan$Meta$rulesRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'children_age_limit', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_additional_children_allowed', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'children_only_discount_rule', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'additional_adult_discount_rule', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'additional_child_discount_rule', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'single_parent_discount_rule', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_discount_rule', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'couple_discount_rule', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'group_pricing_family_num_children_included', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_num_children_included', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_num_adults_included', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_children_age_limit', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_registration_fee_in_cents', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_enrollment_period_in_months', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'individual_registration_fee_in_cents', $author$project$Api$Provider$Plan$Meta$ruleRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$RulesRecord))))))))))))))));
    var $author$project$Api$Provider$Plan$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_types', $elm$json$Json$Decode$list($author$project$Api$ContractType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allowed_periods_in_months', $elm$json$Json$Decode$list($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'iua_options', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rules', $author$project$Api$Provider$Plan$Meta$rulesRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allowed_period_codes', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'all_period_codes', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$Meta$MetaRecord)))))));
    var $author$project$Api$Provider$Plan$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PricingVersion$Shared$PricingVersion = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PricingVersion$Shared$Record = function(id) {
        return function(appliesGroupDiscountInTiers) {
            return function(childrenAgeLimit) {
                return function(discountsEnabled) {
                    return function(effectiveDate) {
                        return function(familyNumAdultsIncluded) {
                            return function(familyNumChildrenIncluded) {
                                return function(familyWithSingleChildRateRuleEnabled) {
                                    return function(fixedChildrenAgeLimit) {
                                        return function(groupPricingFamilyNumChildrenIncluded) {
                                            return function(groupPricingType) {
                                                return function(individualRegistrationFeeInCents) {
                                                    return function(maxRegistrationFeeInCents) {
                                                        return function(name) {
                                                            return function(numberAdditionalChildrenAllowed) {
                                                                return function(registrationFeeName) {
                                                                    return function(singleParentWithSingleChildRateRuleEnabled) {
                                                                        return function(splitRevenueType) {
                                                                            return function(additionalAdultDiscountRule) {
                                                                                return function(additionalChildDiscountRule) {
                                                                                    return function(ageRateRules) {
                                                                                        return function(individualRateRule) {
                                                                                            return function(coupleRateRule) {
                                                                                                return function(singleParentRateRule) {
                                                                                                    return function(familyWithSingleChildRateRule) {
                                                                                                        return function(additionalAdultRateRule) {
                                                                                                            return function(additionalChildRateRule) {
                                                                                                                return function(familyRateRule) {
                                                                                                                    return function(childrenOnlyDiscountRule) {
                                                                                                                        return function(coupleDiscountRule) {
                                                                                                                            return function(familyDiscountRule) {
                                                                                                                                return function(groupDiscountRules) {
                                                                                                                                    return function(singleParentWithSingleChildRateRule) {
                                                                                                                                        return function(singleParentDiscountRule) {
                                                                                                                                            return function(specialRates) {
                                                                                                                                                return function(registrationFeeDescription) {
                                                                                                                                                    return function(registrationFeeCategoryId) {
                                                                                                                                                        return {
                                                                                                                                                            tQ: additionalAdultDiscountRule,
                                                                                                                                                            ID: additionalAdultRateRule,
                                                                                                                                                            tR: additionalChildDiscountRule,
                                                                                                                                                            IE: additionalChildRateRule,
                                                                                                                                                            I_: ageRateRules,
                                                                                                                                                            Jy: appliesGroupDiscountInTiers,
                                                                                                                                                            wa: childrenAgeLimit,
                                                                                                                                                            wb: childrenOnlyDiscountRule,
                                                                                                                                                            wX: coupleDiscountRule,
                                                                                                                                                            Mh: coupleRateRule,
                                                                                                                                                            xm: discountsEnabled,
                                                                                                                                                            Ow: effectiveDate,
                                                                                                                                                            xG: familyDiscountRule,
                                                                                                                                                            Pq: familyNumAdultsIncluded,
                                                                                                                                                            xH: familyNumChildrenIncluded,
                                                                                                                                                            Pr: familyRateRule,
                                                                                                                                                            Pt: familyWithSingleChildRateRule,
                                                                                                                                                            Pu: familyWithSingleChildRateRuleEnabled,
                                                                                                                                                            PO: fixedChildrenAgeLimit,
                                                                                                                                                            Qd: groupDiscountRules,
                                                                                                                                                            Qg: groupPricingFamilyNumChildrenIncluded,
                                                                                                                                                            Qh: groupPricingType,
                                                                                                                                                            aef: id,
                                                                                                                                                            Rb: individualRateRule,
                                                                                                                                                            Rd: individualRegistrationFeeInCents,
                                                                                                                                                            TN: maxRegistrationFeeInCents,
                                                                                                                                                            zr: name,
                                                                                                                                                            zP: numberAdditionalChildrenAllowed,
                                                                                                                                                            BF: registrationFeeCategoryId,
                                                                                                                                                            BG: registrationFeeDescription,
                                                                                                                                                            BH: registrationFeeName,
                                                                                                                                                            CE: singleParentDiscountRule,
                                                                                                                                                            _w: singleParentRateRule,
                                                                                                                                                            _y: singleParentWithSingleChildRateRule,
                                                                                                                                                            _z: singleParentWithSingleChildRateRuleEnabled,
                                                                                                                                                            _M: specialRates,
                                                                                                                                                            _P: splitRevenueType
                                                                                                                                                        };
                                                                                                                                                    };
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$PricingVersion$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registration_fee_category', $elm$json$Json$Decode$nullable(A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'registration_fee_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'special_rates', $elm$json$Json$Decode$list($author$project$Api$Provider$SpecialRate$Shared$decoder), _List_Nil, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'single_parent_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'single_parent_with_single_child_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'group_discount_rules', $elm$json$Json$Decode$list($author$project$Api$Provider$DiscountRule$Shared$decoder), _List_Nil, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'family_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'couple_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'children_only_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'family_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'additional_child_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'additional_adult_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'family_with_single_child_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'single_parent_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'couple_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'individual_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'age_rate_rules', $elm$json$Json$Decode$list($author$project$Api$Provider$RateRule$Shared$decoder), _List_Nil, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'additional_child_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'additional_adult_discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Shared$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'split_revenue_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'single_parent_with_single_child_rate_rule_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registration_fee_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_additional_children_allowed', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'individual_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'group_pricing_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'group_pricing_family_num_children_included', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_children_age_limit', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_with_single_child_rate_rule_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_num_children_included', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_num_adults_included', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'effective_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discounts_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'children_age_limit', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'applies_group_discount_in_tiers', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$Shared$Record))))))))))))))))))))))))))))))))))))));
    var $author$project$Api$Provider$PricingVersion$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PricingVersion$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Plan$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'used_in_scheduled_plan_changes', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pricing_effectiveness_type', $author$project$Api$PricingEffectivenessType$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'upcoming_pricing_version', $elm$json$Json$Decode$nullable($author$project$Api$Provider$PricingVersion$Shared$decoder), A3($author$project$Api$Expandable$expandable, 'mce_pricing', $elm$json$Json$Decode$nullable($author$project$Api$Provider$McePricing$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Plan$Meta$decoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$One$decodeDescriptions, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registration_fee_category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registration_fee_description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registration_fee_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discounts_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'applies_group_discount_in_tiers', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_children_age_limit', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'split_revenue_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'children_age_limit', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_additional_children_allowed', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'group_pricing_family_num_children_included', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_num_children_included', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_num_adults_included', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'annual_allowed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'annual_adjustment_percent', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'semi_annual_allowed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'semi_annual_adjustment_percent', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quarter_allowed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quarter_adjustment_percent', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'month_allowed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'month_adjustment_percent', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'iua', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_renewal_email_lead_time', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_emails_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_type', $elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_expires', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_charge_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_charge_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'individual_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_period', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$One$Record))))))))))))))))))))))))))))))))))))));
    var $author$project$Api$Provider$Plan$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$One$Plan)));
    var $author$project$Api$Provider$Plan$expandToString = function(expand) {
        switch(expand){
            case 0:
                return 'pricing';
            case 1:
                return 'coverage_plan';
            default:
                return 'mce_pricing';
        }
    };
    var $author$project$Api$Provider$Plan$plansPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'plans'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Plan$planPath = function(planId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            planId
        ]), $author$project$Api$Provider$Plan$plansPath);
    };
    var $author$project$Api$Provider$Plan$retrieve = F4(function(apiClient, planId, expand, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$planPath(planId))));
    });
    var $author$project$Components$Plan$Form$fetchPlan = F3(function(apiClient, id, loadSubsequentPlan) {
        return A4($author$project$Api$Provider$Plan$retrieve, apiClient, id, _List_fromArray([
            1,
            2
        ]), $author$project$Components$Plan$Form$GotItem(loadSubsequentPlan));
    });
    var $author$project$Components$Plan$Form$init = F9(function(apiClient, _v0, currentDate, session, practice, _v1, listRoute, id, settings) {
        var _v2 = $author$project$Components$DateInput$init;
        var planChangeChangeOnDateInput = _v2.a;
        var planChangeChangeOnDateInputCmd = _v2.b;
        return _Utils_Tuple2({
            hm: $elm$core$Maybe$Nothing,
            hT: $elm$core$Maybe$Nothing,
            cP: currentDate,
            fr: $elm$core$Maybe$Nothing,
            PU: $elm$core$Maybe$Nothing,
            aeb: settings.aeb,
            aef: id,
            F6: $author$project$Api$Data$Loading,
            Gc: listRoute,
            r8: planChangeChangeOnDateInput,
            jx: false,
            gt: $elm$core$Maybe$Nothing,
            W1: practice,
            W4: settings.W4,
            agk: _Utils_Tuple2(0, $author$project$Api$Data$NotAsked),
            eq: $jinjor$elm_debounce$Debounce$init,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            ot: false,
            oN: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice)
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Components$Plan$Form$fetchPlan, apiClient, id, true),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg, planChangeChangeOnDateInputCmd)
        ])));
    });
    var $author$project$Pages$Admin$CompanyPlans$Id_String$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var timeZone = _v0.HP;
        var currentDate = _v0.cP;
        var hinterViewOff = _v0.aeb;
        var query = _v1.Bz;
        var params = _v1.VU;
        return A2($elm$core$Tuple$mapFirst, function(planForm) {
            return {
                Ej: apiClient,
                nB: planForm
            };
        }, A9($author$project$Components$Plan$Form$init, apiClient, timeZone, currentDate, session, practice, query, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top, params.aef, {
            aeb: hinterViewOff,
            W4: false
        }));
    });
    var $author$project$Pages$Admin$CompanyPlans$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$CompanyPlans$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Plan$Form$AddCoveragePlanModalMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$BasicPlanFormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ConfirmUpdateModalMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$DeleteHiConfirmClosed = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$BasicForm$DescriptionMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$subscriptions = function(_v0) {
        var form = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        var _v1 = fields.cK;
        if (!_v1.$) {
            var categoryResourceFilter = _v1.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, $author$project$Components$ResourceFilter$Category$subscriptions(categoryResourceFilter));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Plan$BasicForm$subscriptions = function(_v0) {
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, $author$project$Components$Plan$Form$RegistrationFeePricingFields$subscriptions(fields.de)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Plan$BasicForm$DescriptionMsg, $author$project$Components$TranslatedRichText$subscriptions(fields.NQ))
        ]));
    };
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$Close = {
        $: 1
    };
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Plan$Form$AddCoveragePlanModal$Close);
    };
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$Close = {
        $: 2
    };
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Plan$Form$ConfirmUpdateModal$Close);
    };
    var $author$project$Components$Plan$Form$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v1) {
                var form = _v1.b;
                var fields = $author$project$Utils$Form$fields(form);
                return A2($elm$core$Platform$Sub$map, $author$project$Components$Plan$Form$BasicPlanFormUpdated, $author$project$Components$Plan$BasicForm$subscriptions(fields.aB));
            }, model.PU)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Plan$Form$ConfirmUpdateModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v2) {
                var confirmUpdateModal = _v2.b;
                return $author$project$Components$Plan$Form$ConfirmUpdateModal$subscriptions(confirmUpdateModal);
            }, model.hT))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Plan$Form$AddCoveragePlanModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$subscriptions, model.hm))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Plan$Form$DeleteHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fr)))
        ]));
    };
    var $author$project$Pages$Admin$CompanyPlans$Id_String$subscriptions = function(model) {
        return $author$project$Components$Plan$Form$subscriptions(model.nB);
    };
    var $author$project$Components$Plan$Form$BasicPlan = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$MembershipScheduledChange$Type$Contract = 2;
    var $author$project$Components$Plan$Form$CoveragePlan = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$CoveragePlanAll = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$MembershipScheduledChange$Type$Duration = 1;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GotPreview = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupPricingType = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$MembershipPricingFields = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$PlanChange = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$PlanChangeChangeOnDate = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$PlanChangeToPlan = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$PlanDeleted = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$SpecialRatesFieldsUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$SubsequentPlanUpdated = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ToggleFixedMembershipPricing = {
        $: 27
    };
    var $author$project$Api$ContractType$toString = function(contractType) {
        if (!contractType) return 'terminate';
        else return 'auto-renew';
    };
    var $author$project$Api$ContractType$encode = A2($elm$core$Basics$composeR, $author$project$Api$ContractType$toString, $elm$json$Json$Encode$string);
    var $author$project$Api$PricingEffectivenessType$toString = function(pricingEffectivenessType) {
        switch(pricingEffectivenessType){
            case 0:
                return 'first_bill_after';
            case 1:
                return 'contract_renewal';
            default:
                return 'anniversary';
        }
    };
    var $author$project$Api$PricingEffectivenessType$encode = A2($elm$core$Basics$composeR, $author$project$Api$PricingEffectivenessType$toString, $elm$json$Json$Encode$string);
    var $author$project$Percentage$toFloat = function(_v0) {
        var string = _v0;
        return $elm$core$String$toFloat(string);
    };
    var $author$project$Percentage$encode = A2($elm$core$Basics$composeR, $author$project$Percentage$toFloat, $author$project$Utils$Encode$nullable($elm$json$Json$Encode$float));
    var $author$project$Api$Provider$Plan$encodeCoupleAgeRateRuleFields = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('month_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Uu)),
            _Utils_Tuple2('month_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gb)),
            _Utils_Tuple2('quarter_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.XU)),
            _Utils_Tuple2('quarter_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gx)),
            _Utils_Tuple2('semi_annual_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.ZH)),
            _Utils_Tuple2('semi_annual_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gM)),
            _Utils_Tuple2('annual_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Jk)),
            _Utils_Tuple2('annual_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.e3))
        ]));
    };
    var $author$project$Api$Provider$RateRule$Shared$unitToString = function(unit_) {
        if (!unit_) return 'years';
        else return 'months';
    };
    var $author$project$Api$Provider$Plan$encodeAgeRateRuleFields = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('from_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.P_)),
            _Utils_Tuple2('to_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.$4)),
            _Utils_Tuple2('unit', $elm$json$Json$Encode$string($author$project$Api$Provider$RateRule$Shared$unitToString(fields.aaG))),
            _Utils_Tuple2('month_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Uu)),
            _Utils_Tuple2('month_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gb)),
            _Utils_Tuple2('quarter_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.XU)),
            _Utils_Tuple2('quarter_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gx)),
            _Utils_Tuple2('semi_annual_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.ZH)),
            _Utils_Tuple2('semi_annual_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gM)),
            _Utils_Tuple2('annual_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Jk)),
            _Utils_Tuple2('annual_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.e3)),
            _Utils_Tuple2('couple_age_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeCoupleAgeRateRuleFields, fields.Mg))
        ]));
    };
    var $author$project$Api$Provider$Plan$encodeFamilyDiscountRule = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('month_maximum_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Ux)),
            _Utils_Tuple2('month_maximum_in_cents_edited', $elm$json$Json$Encode$bool(fields.Uy)),
            _Utils_Tuple2('quarter_maximum_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.XY)),
            _Utils_Tuple2('quarter_maximum_in_cents_edited', $elm$json$Json$Encode$bool(fields.XZ)),
            _Utils_Tuple2('semi_annual_maximum_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.ZL)),
            _Utils_Tuple2('semi_annual_maximum_in_cents_edited', $elm$json$Json$Encode$bool(fields.ZM)),
            _Utils_Tuple2('annual_maximum_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Jo)),
            _Utils_Tuple2('annual_maximum_in_cents_edited', $elm$json$Json$Encode$bool(fields.Jp))
        ]));
    };
    var $author$project$Api$Provider$Plan$encodeFixedRateRule = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('month_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Uu)),
            _Utils_Tuple2('month_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gb)),
            _Utils_Tuple2('quarter_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.XU)),
            _Utils_Tuple2('quarter_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gx)),
            _Utils_Tuple2('semi_annual_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.ZH)),
            _Utils_Tuple2('semi_annual_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gM)),
            _Utils_Tuple2('annual_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Jk)),
            _Utils_Tuple2('annual_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.e3))
        ]));
    };
    var $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('from_size', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.P0)),
            _Utils_Tuple2('to_size', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.$6)),
            _Utils_Tuple2('calculated_by', $elm$json$Json$Encode$string(fields.KD)),
            _Utils_Tuple2('month_amount_off_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Uv)),
            _Utils_Tuple2('month_amount_off_in_cents_edited', $elm$json$Json$Encode$bool(fields.Uw)),
            _Utils_Tuple2('quarter_amount_off_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.XW)),
            _Utils_Tuple2('quarter_amount_off_in_cents_edited', $elm$json$Json$Encode$bool(fields.XX)),
            _Utils_Tuple2('semi_annual_amount_off_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.ZJ)),
            _Utils_Tuple2('semi_annual_amount_off_in_cents_edited', $elm$json$Json$Encode$bool(fields.ZK)),
            _Utils_Tuple2('annual_amount_off_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Jm)),
            _Utils_Tuple2('annual_amount_off_in_cents_edited', $elm$json$Json$Encode$bool(fields.Jn)),
            _Utils_Tuple2('month_percent_off', A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.UC)),
            _Utils_Tuple2('month_percent_off_edited', $elm$json$Json$Encode$bool(fields.UD)),
            _Utils_Tuple2('quarter_percent_off', A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.X0)),
            _Utils_Tuple2('quarter_percent_off_edited', $elm$json$Json$Encode$bool(fields.X1)),
            _Utils_Tuple2('semi_annual_percent_off', A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.ZP)),
            _Utils_Tuple2('semi_annual_percent_off_edited', $elm$json$Json$Encode$bool(fields.ZQ)),
            _Utils_Tuple2('annual_percent_off', A2($author$project$Utils$Encode$nullable, $author$project$Percentage$encode, fields.Js)),
            _Utils_Tuple2('annual_percent_off_edited', $elm$json$Json$Encode$bool(fields.Jt))
        ]));
    };
    var $author$project$Api$Provider$Plan$encodeSpecialRateFields = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aef)),
            _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
            _Utils_Tuple2('month_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Uu)),
            _Utils_Tuple2('month_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gb)),
            _Utils_Tuple2('quarter_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.XU)),
            _Utils_Tuple2('quarter_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gx)),
            _Utils_Tuple2('semi_annual_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.ZH)),
            _Utils_Tuple2('semi_annual_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.gM)),
            _Utils_Tuple2('annual_amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Jk)),
            _Utils_Tuple2('annual_amount_in_cents_edited', $elm$json$Json$Encode$bool(fields.e3)),
            _Utils_Tuple2('_create', $elm$json$Json$Encode$bool(fields.Mw)),
            _Utils_Tuple2('_destroy', $elm$json$Json$Encode$bool(fields.NU))
        ]));
    };
    var $author$project$Api$Provider$Plan$encodeUpdateFields = function(fields) {
        return $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('addon', $elm$json$Json$Encode$bool(fields.IF)), A2($elm$core$List$cons, _Utils_Tuple2('buyable', $elm$json$Json$Encode$bool(fields.Ky)), A2($elm$core$List$cons, _Utils_Tuple2('default_period', $elm$json$Json$Encode$string(fields.Nx)), A2($elm$core$List$cons, _Utils_Tuple2('bills_at_end_of_period', $elm$json$Json$Encode$bool(fields.Kh)), A2($elm$core$List$cons, _Utils_Tuple2('discounts_enabled', $elm$json$Json$Encode$bool(fields.xm)), A2($elm$core$List$cons, _Utils_Tuple2('registration_fee_name', $elm$json$Json$Encode$string(fields.BH)), A2($elm$core$List$cons, _Utils_Tuple2('registration_fee_description', $elm$json$Json$Encode$string(fields.BG)), A2($elm$core$List$cons, _Utils_Tuple2('individual_registration_fee_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Rd)), A2($elm$core$List$cons, _Utils_Tuple2('minimum_enrollment_period_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Up)), A2($elm$core$List$cons, _Utils_Tuple2('default_charge_name', $elm$json$Json$Encode$string(fields.xc)), A2($elm$core$List$cons, _Utils_Tuple2('default_charge_description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.xb)), A2($elm$core$List$cons, _Utils_Tuple2('registration_fee_category', A2($author$project$Utils$Encode$nullable, function(id) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(id))
            ]));
        }, fields.BF)), A2($elm$core$List$cons, _Utils_Tuple2('max_registration_fee_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.TN)), A2($elm$core$List$cons, _Utils_Tuple2('iua', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.SI)), A2($elm$core$List$cons, _Utils_Tuple2('month_adjustment_percent', $author$project$Percentage$encode(fields.zj)), A2($elm$core$List$cons, _Utils_Tuple2('month_allowed', $elm$json$Json$Encode$bool(fields.zk)), A2($elm$core$List$cons, _Utils_Tuple2('quarter_adjustment_percent', $author$project$Percentage$encode(fields.Bw)), A2($elm$core$List$cons, _Utils_Tuple2('quarter_allowed', $elm$json$Json$Encode$bool(fields.Bx)), A2($elm$core$List$cons, _Utils_Tuple2('semi_annual_adjustment_percent', $author$project$Percentage$encode(fields.Cn)), A2($elm$core$List$cons, _Utils_Tuple2('semi_annual_allowed', $elm$json$Json$Encode$bool(fields.Co)), A2($elm$core$List$cons, _Utils_Tuple2('annual_adjustment_percent', $author$project$Percentage$encode(fields.vu)), A2($elm$core$List$cons, _Utils_Tuple2('annual_allowed', $elm$json$Json$Encode$bool(fields.vv)), A2($elm$core$List$cons, _Utils_Tuple2('tobacco_surcharge_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aad)), A2($elm$core$List$cons, _Utils_Tuple2('tobacco_surcharge_percentage', $author$project$Percentage$encode(fields.aac)), A2($elm$core$List$cons, _Utils_Tuple2('tobacco_surcharge_in_cents', $author$project$Currency$encode(fields.aab)), A2($elm$core$List$cons, _Utils_Tuple2('contract_expires', $elm$json$Json$Encode$bool(fields.L5)), A2($elm$core$List$cons, _Utils_Tuple2('contract_period_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.L6)), A2($elm$core$List$cons, _Utils_Tuple2('contract_type', A2($author$project$Utils$Encode$nullable, $author$project$Api$ContractType$encode, fields.EW)), A2($elm$core$List$cons, _Utils_Tuple2('contract_emails_enabled', $elm$json$Json$Encode$bool(fields.L4)), A2($elm$core$List$cons, _Utils_Tuple2('contract_renewal_email_lead_time', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.L7)), A2($elm$core$List$cons, _Utils_Tuple2('minimum_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Un)), A2($elm$core$List$cons, _Utils_Tuple2('maximum_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.TQ)), A2($elm$core$List$cons, _Utils_Tuple2('coverage_plan', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.Mn)), A2($elm$core$List$cons, _Utils_Tuple2('sponsor_fee_deal', $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Hy))
        ]))), A2($elm$core$List$cons, _Utils_Tuple2('age_rate_rules', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, fields.I_)), A2($elm$core$List$cons, _Utils_Tuple2('group_pricing_type', $elm$json$Json$Encode$string(fields.Qh)), A2($elm$core$List$cons, _Utils_Tuple2('fixed_children_age_limit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.PO)), A2($elm$core$List$cons, _Utils_Tuple2('family_num_adults_included', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Pq)), A2($elm$core$List$cons, _Utils_Tuple2('family_num_children_included', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.xH)), A2($elm$core$List$cons, _Utils_Tuple2('group_pricing_family_num_children_included', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Qg)), A2($elm$core$List$cons, _Utils_Tuple2('number_additional_children_allowed', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.zP)), A2($elm$core$List$cons, _Utils_Tuple2('children_age_limit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.wa)), A2($elm$core$List$cons, _Utils_Tuple2('split_revenue_type', $elm$json$Json$Encode$string(fields._P)), A2($elm$core$List$cons, _Utils_Tuple2('applies_group_discount_in_tiers', $elm$json$Json$Encode$bool(fields.Jy)), A2($elm$core$List$cons, _Utils_Tuple2('single_parent_with_single_child_rate_rule_enabled', $elm$json$Json$Encode$bool(fields._z)), A2($elm$core$List$cons, _Utils_Tuple2('family_with_single_child_rate_rule_enabled', $elm$json$Json$Encode$bool(fields.Pu)), A2($elm$core$List$cons, _Utils_Tuple2('couple_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.Mh)), A2($elm$core$List$cons, _Utils_Tuple2('family_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.Pr)), A2($elm$core$List$cons, _Utils_Tuple2('individual_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.Rb)), A2($elm$core$List$cons, _Utils_Tuple2('single_parent_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields._w)), A2($elm$core$List$cons, _Utils_Tuple2('single_parent_with_single_child_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields._y)), A2($elm$core$List$cons, _Utils_Tuple2('family_with_single_child_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.Pt)), A2($elm$core$List$cons, _Utils_Tuple2('additional_adult_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.ID)), A2($elm$core$List$cons, _Utils_Tuple2('additional_child_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, fields.IE)), A2($elm$core$List$cons, _Utils_Tuple2('couple_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.wX)), A2($elm$core$List$cons, _Utils_Tuple2('family_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.xG)), A2($elm$core$List$cons, _Utils_Tuple2('single_parent_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.CE)), A2($elm$core$List$cons, _Utils_Tuple2('additional_adult_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.tQ)), A2($elm$core$List$cons, _Utils_Tuple2('additional_child_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.tR)), A2($elm$core$List$cons, _Utils_Tuple2('children_only_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.wb)), A2($elm$core$List$cons, _Utils_Tuple2('group_discount_rules', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields, fields.Qd)), A2($elm$core$List$cons, _Utils_Tuple2('special_rates', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeSpecialRateFields, fields._M)), A2($elm$core$List$cons, _Utils_Tuple2('description', $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('en', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Dict$get, 'en', fields.Ff))),
            _Utils_Tuple2('es', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Dict$get, 'es', fields.Ff)))
        ]))), A2($elm$core$List$cons, _Utils_Tuple2('pricing_effectiveness_type', $author$project$Api$PricingEffectivenessType$encode(fields.Xo)), function() {
            var _v0 = fields.Q4;
            if (!_v0.$) {
                var url = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('image', $elm$json$Json$Encode$string(url))
                ]);
            } else return _List_Nil;
        }()))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))));
    };
    var $author$project$Api$Data$requestWithTracker = F2(function(tracker, _v0) {
        var request = _v0;
        return _Utils_update(request, {
            tu: $elm$core$Maybe$Just(tracker)
        });
    });
    var $author$project$Api$Provider$Plan$calculate = F6(function(apiClient, expand, tracker, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('plan', $author$project$Api$Provider$Plan$encodeUpdateFields(fields))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, A2($author$project$Api$Data$requestWithTracker, tracker, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'calculate'
        ]), $author$project$Api$Provider$Plan$planPath(id)))))));
    });
    var $author$project$Components$Plan$Form$BasicPlanFieldValidation = {
        $: 10
    };
    var $author$project$Components$Plan$BasicForm$hasErrors = function(_v0) {
        var form = _v0.b;
        return $author$project$Utils$Form$hasAnyValidationError(form);
    };
    var $author$project$Components$Plan$Form$validateBasicPlanFormFields = function(_v0) {
        var basicPlan = _v0.aB;
        return $author$project$Components$Plan$BasicForm$hasErrors(basicPlan) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Plan$Form$BasicPlanFieldValidation, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation = {
        $: 2
    };
    var $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation = {
        $: 4
    };
    var $author$project$Components$Plan$Form$ContractTypeValidation = {
        $: 3
    };
    var $author$project$Api$Provider$Plan$Meta$allowedPeriodsInMonths = function(_v0) {
        var meta = _v0;
        return meta.Jd;
    };
    var $author$project$Api$Provider$Plan$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid = F2(function(plan, contractPeriodInMonths) {
        var maxPeriod = $elm$core$List$maximum($author$project$Api$Provider$Plan$Meta$allowedPeriodsInMonths($author$project$Api$Provider$Plan$One$meta(plan)));
        var _v0 = _Utils_Tuple2(contractPeriodInMonths, maxPeriod);
        if (!_v0.a.$ && !_v0.b.$) {
            var contractPeriodInMonths_ = _v0.a.a;
            var maxPeriod_ = _v0.b.a;
            return !!(contractPeriodInMonths_ % maxPeriod_);
        } else return false;
    });
    var $author$project$Api$Provider$Plan$Shared$isMcePlan = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, false, record.R9);
    };
    var $author$project$Api$Provider$Plan$One$isMcePlan = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$isMcePlan(shared);
    };
    var $author$project$Utils$Validate$isOutsideIntRange = F2(function(options, _int) {
        var _v0 = _Utils_Tuple3(_int, options.Uj, options.y_);
        if (!_v0.a.$) {
            if (!_v0.b.$) {
                if (!_v0.c.$) {
                    var int_ = _v0.a.a;
                    var min = _v0.b.a;
                    var max = _v0.c.a;
                    return _Utils_cmp(int_, min) < 0 || _Utils_cmp(int_, max) > 0;
                } else {
                    var int_ = _v0.a.a;
                    var min = _v0.b.a;
                    var _v1 = _v0.c;
                    return _Utils_cmp(int_, min) < 0;
                }
            } else if (!_v0.c.$) {
                var int_ = _v0.a.a;
                var _v2 = _v0.b;
                var max = _v0.c.a;
                return _Utils_cmp(int_, max) > 0;
            } else {
                var _v3 = _v0.b;
                var _v4 = _v0.c;
                return false;
            }
        } else {
            var _v5 = _v0.a;
            return !options.abI;
        }
    });
    var $author$project$Api$Provider$Plan$Shared$planType = function(_v0) {
        var record = _v0;
        return record.WN;
    };
    var $author$project$Api$Provider$Plan$One$planType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$planType(shared);
    };
    var $author$project$Components$Plan$Form$validateContract = F2(function(plan, fields) {
        var planType = $author$project$Api$Provider$Plan$One$planType(plan);
        var isMcePlan = $author$project$Api$Provider$Plan$One$isMcePlan(plan);
        var forCompany = !$author$project$Api$Provider$Plan$One$planType(plan);
        return planType !== 1 && !isMcePlan && !forCompany ? $elm$core$List$concat(_List_fromArray([
            fields.L5 && A2($author$project$Utils$Validate$isOutsideIntRange, {
                abI: false,
                y_: $elm$core$Maybe$Just(48),
                Uj: $elm$core$Maybe$Just(1)
            }, fields.L6) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, 'Please enter a number between 1 and 48.')
            ]) : fields.L5 && A2($author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid, plan, fields.L6) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, '')
            ]) : _List_Nil,
            fields.L5 && _Utils_eq(fields.EW, $elm$core$Maybe$Nothing) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$ContractTypeValidation, 'Please pick an action.')
            ]) : _List_Nil,
            fields.L5 && fields.L4 && A2($author$project$Utils$Validate$isOutsideIntRange, {
                abI: false,
                y_: $elm$core$Maybe$Just(365),
                Uj: $elm$core$Maybe$Just(1)
            }, fields.L7) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, 'Please enter a number between 1 and 365.')
            ]) : _List_Nil
        ])) : _List_Nil;
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsValidation = {
        $: 11
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$hasAnyValidationError(form);
    };
    var $author$project$Components$Plan$Form$validateFamilyMembershipPricingFields = function(_v0) {
        var familyMembershipPricingForm = _v0.cY;
        return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(familyMembershipPricingForm) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFieldsValidation, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$validatePricingRuleAmountInCents = F3(function(defaultPeriod, pricingRule, validationGroup) {
        var min = 0;
        var max = 999999999;
        return $elm$core$List$concat(_List_fromArray([
            (defaultPeriod === 'month' || pricingRule.gb) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Uu) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('month'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'quarter' || pricingRule.gx) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.XU) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('quarter'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'semi_annual' || pricingRule.gM) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.ZH) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('semi_annual'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'annual' || pricingRule.e3) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Jk) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('annual'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil
        ]));
    });
    var $author$project$Percentage$isValid = F2(function(options, percentage) {
        var _v0 = $author$project$Percentage$toFloat(percentage);
        if (!_v0.$) {
            var _float = _v0.a;
            var _v1 = _Utils_Tuple2(options.Uj, options.y_);
            if (!_v1.a.$) {
                if (!_v1.b.$) {
                    var min = _v1.a.a;
                    var max = _v1.b.a;
                    return !(_Utils_cmp(_float, min) < 0 || _Utils_cmp(_float, max) > 0);
                } else {
                    var min = _v1.a.a;
                    var _v2 = _v1.b;
                    return _Utils_cmp(_float, min) > -1;
                }
            } else if (!_v1.b.$) {
                var _v3 = _v1.a;
                var max = _v1.b.a;
                return _Utils_cmp(_float, max) < 1;
            } else {
                var _v4 = _v1.a;
                var _v5 = _v1.b;
                return true;
            }
        } else return false;
    });
    var $author$project$Utils$Validate$isInvalidPercentage = F2(function(options, percentage) {
        if (!percentage.$) {
            var percentage_ = percentage.a;
            return !A2($author$project$Percentage$isValid, {
                y_: options.y_,
                Uj: options.Uj
            }, percentage_);
        } else return !options.abI;
    });
    var $author$project$Components$Plan$Form$validatePricingRulePercentage = F3(function(defaultPeriod, pricingRule, validationGroup) {
        var min = 0;
        var max = 100;
        return $elm$core$List$concat(_List_fromArray([
            (defaultPeriod === 'month' || pricingRule.UB) && A2($author$project$Utils$Validate$isInvalidPercentage, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.UA) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('month'), 'Please enter a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'quarter' || pricingRule.X$) && A2($author$project$Utils$Validate$isInvalidPercentage, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.X_) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('quarter'), 'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'semi_annual' || pricingRule.ZO) && A2($author$project$Utils$Validate$isInvalidPercentage, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.ZN) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('semi_annual'), 'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'annual' || pricingRule.Jr) && A2($author$project$Utils$Validate$isInvalidPercentage, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Jq) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('annual'), 'Please enter an a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.'))))
            ]) : _List_Nil
        ]));
    });
    var $author$project$Components$Plan$Form$validateGroupDiscountRule = F3(function(defaultPeriod, index, fields) {
        var _v0 = fields.KD;
        switch(_v0){
            case 'amount_off_in_cents':
                return A3($author$project$Components$Plan$Form$validatePricingRuleAmountInCents, defaultPeriod, {
                    Jk: fields.Jm,
                    e3: fields.Jn,
                    Uu: fields.Uv,
                    gb: fields.Uw,
                    XU: fields.XW,
                    gx: fields.XX,
                    ZH: fields.ZJ,
                    gM: fields.ZK
                }, $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation(index));
            case 'percent_off':
                return A3($author$project$Components$Plan$Form$validatePricingRulePercentage, defaultPeriod, {
                    Jq: fields.Js,
                    Jr: fields.Jt,
                    UA: fields.UC,
                    UB: fields.UD,
                    X_: fields.X0,
                    X$: fields.X1,
                    ZN: fields.ZP,
                    ZO: fields.ZQ
                }, $author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation(index));
            default:
                return _List_Nil;
        }
    });
    var $author$project$Components$Plan$Form$validateGroupMembershipPricingFields = F3(function(sharedFields, plan, fields) {
        var planType = $author$project$Api$Provider$Plan$One$planType(plan);
        var isMcePlan = $author$project$Api$Provider$Plan$One$isMcePlan(plan);
        return planType !== 1 && !isMcePlan && fields.Qh === 'group' ? $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$Plan$Form$validateGroupDiscountRule(sharedFields.Nx), fields.Qd)) : _List_Nil;
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFieldsValidation = {
        $: 13
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$hasAnyValidationError(form);
    };
    var $author$project$Components$Plan$Form$validateGroupTierPricingFields = function(_v0) {
        var groupTierPricingForm = _v0.i;
        return $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(groupTierPricingForm) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFieldsValidation, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsValidation = {
        $: 12
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$hasAnyValidationError(form);
    };
    var $author$project$Components$Plan$Form$validateIndividualMembershipPricingFields = function(_v0) {
        var membershipPricingForm = _v0.c$;
        return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(membershipPricingForm) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Plan$Form$IndividualMembershipPricingFieldsValidation, '')
        ]) : _List_Nil;
    };
    var $author$project$Api$Provider$MembershipScheduledChange$Type$Date = 0;
    var $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation = {
        $: 5
    };
    var $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation = {
        $: 6
    };
    var $author$project$Components$Plan$Form$PlanChangeToPlanValidation = {
        $: 7
    };
    var $author$project$Utils$Date$isAfter = F2(function(date, otherDate) {
        return A2($justinmimbs$date$Date$compare, date, otherDate) === 2;
    });
    var $author$project$Utils$Date$isBefore = F2(function(date, otherDate) {
        return !A2($justinmimbs$date$Date$compare, date, otherDate);
    });
    var $author$project$Utils$Validate$isOutsideDateRange = F2(function(options, date) {
        var _v0 = _Utils_Tuple3(date, options.Uj, options.y_);
        if (!_v0.a.$) {
            if (!_v0.b.$) {
                if (!_v0.c.$) {
                    var date_ = _v0.a.a;
                    var min = _v0.b.a;
                    var max = _v0.c.a;
                    return A2($author$project$Utils$Date$isBefore, date_, min) || A2($author$project$Utils$Date$isAfter, date_, max);
                } else {
                    var date_ = _v0.a.a;
                    var min = _v0.b.a;
                    var _v1 = _v0.c;
                    return A2($author$project$Utils$Date$isBefore, date_, min);
                }
            } else if (!_v0.c.$) {
                var date_ = _v0.a.a;
                var _v2 = _v0.b;
                var max = _v0.c.a;
                return A2($author$project$Utils$Date$isAfter, date_, max);
            } else {
                var _v3 = _v0.b;
                var _v4 = _v0.c;
                return false;
            }
        } else {
            var _v5 = _v0.a;
            return !options.abI;
        }
    });
    var $author$project$Components$Plan$Form$validatePlanChange = F3(function(currentDate, planChangeEnabled, _v0) {
        var planChange = _v0.jw;
        if (planChangeEnabled) {
            var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
            var params = planChange.VU;
            return $elm$core$List$concat(_List_fromArray([
                planChange.bW && _Utils_eq(params.$5, $elm$core$Maybe$Nothing) ? _List_fromArray([
                    _Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeToPlanValidation, 'Please pick a plan.')
                ]) : _List_Nil,
                planChange.bW && !params.ah5 && A2($author$project$Utils$Validate$isOutsideDateRange, {
                    abI: false,
                    y_: $elm$core$Maybe$Nothing,
                    Uj: $elm$core$Maybe$Just(yesterdayDate)
                }, params.K3) ? _List_fromArray([
                    _Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, 'Please enter a date greater or equal than yesterday')
                ]) : _List_Nil,
                planChange.bW && params.ah5 === 1 && A2($author$project$Utils$Validate$isOutsideIntRange, {
                    abI: false,
                    y_: $elm$core$Maybe$Just(48),
                    Uj: $elm$core$Maybe$Just(1)
                }, params.K2) ? _List_fromArray([
                    _Utils_Tuple2($author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, 'Please enter a number between 1 and 48.')
                ]) : _List_Nil
            ]));
        } else return _List_Nil;
    });
    var $author$project$Components$Plan$Form$SpecialRatesFieldsValidation = {
        $: 14
    };
    var $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$hasAnyValidationError(form);
    };
    var $author$project$Components$Plan$Form$validateSpecialRatesFields = function(_v0) {
        var specialRatesForm = _v0.dj;
        return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Plan$Form$SpecialRatesFieldsValidation, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation = {
        $: 0
    };
    var $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation = {
        $: 1
    };
    var $author$project$Components$Plan$Form$validateTobaccoSurcharge = F3(function(tobaccoSurchargeEnabled, plan, fields) {
        var planType = $author$project$Api$Provider$Plan$One$planType(plan);
        if (planType !== 1 && tobaccoSurchargeEnabled && !_Utils_eq(fields.aad, $elm$core$Maybe$Nothing)) {
            var percentageTobaccoSurchargeType = _Utils_eq(fields.aad, $elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(fields.aad, $elm$core$Maybe$Just('percentage_per_membership'));
            if (percentageTobaccoSurchargeType && A2($author$project$Utils$Validate$isInvalidPercentage, {
                abI: false,
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Just(0)
            }, fields.aac)) return _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, 'Please enter a number between 0 and 100.')
            ]);
            else {
                var minAmountInCents = 0;
                var maxAmountInCents = 999999999;
                return !percentageTobaccoSurchargeType && A2($author$project$Utils$Validate$isInvalidCurrency, {
                    abI: false,
                    y_: $elm$core$Maybe$Just(maxAmountInCents),
                    Uj: $elm$core$Maybe$Just(minAmountInCents)
                }, fields.aab) ? _List_fromArray([
                    _Utils_Tuple2($author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation, 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(minAmountInCents) + (' and ' + ($author$project$Utils$Currency$fromInt(maxAmountInCents) + '.'))))
                ]) : _List_Nil;
            }
        } else return _List_Nil;
    });
    var $author$project$Components$Plan$Form$formFieldsValidator = F5(function(sharedField, currentDate, tobaccoSurchargeEnabled, planChangeEnabled, plan) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateContract(plan)),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Plan$Form$validatePlanChange, currentDate, planChangeEnabled)),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Plan$Form$validateTobaccoSurcharge, tobaccoSurchargeEnabled, plan)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateIndividualMembershipPricingFields),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateGroupTierPricingFields),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateSpecialRatesFields),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Plan$Form$validateGroupMembershipPricingFields, sharedField, plan)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateBasicPlanFormFields),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$validateFamilyMembershipPricingFields)
        ]));
    });
    var $author$project$Components$Plan$BasicForm$formFields = function(_v0) {
        var form = _v0.b;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Components$Plan$Form$initSharedFields = F2(function(plan, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var groupPricingType = _v0.Qh;
        var basicPlan = _v0.aB;
        var _v1 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
        var defaultPeriod = _v1.Nx;
        return {
            Nx: defaultPeriod,
            Qh: groupPricingType,
            GW: $elm$core$Maybe$Just(plan)
        };
    });
    var $author$project$Components$Plan$Form$PreviewDebouncedMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$previewDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Plan$Form$PreviewDebouncedMsg
    };
    var $author$project$Components$Plan$BasicForm$BasicPlanForm = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$RegistrationFeePricingForm = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCentsValidation = 0;
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCentsValidation = 1;
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validateRegistrationFeePricing = function(fields) {
        return $elm$core$List$concat(_List_fromArray([
            fields.Zk.Rd.OM && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Just(1)
            }, fields.Rd) ? _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a number greater than 0.')
            ]) : _List_Nil,
            fields.Zk.TN.OM && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Just(1)
            }, fields.TN) ? _List_fromArray([
                _Utils_Tuple2(1, 'Please enter a number greater than 0.')
            ]) : _List_Nil
        ]));
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$Form$RegistrationFeePricingFields$validateRegistrationFeePricing)
    ]));
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$validate = function(_v0) {
        var form = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$core$Result$mapError, $elm$core$Basics$identity, A2($elm$core$Result$map, $elm$core$Tuple$mapFirst($elm$core$Basics$identity), A2($author$project$Utils$Form$validate, $author$project$Components$Plan$Form$RegistrationFeePricingFields$validator, A2($author$project$Utils$Form$set, fields, form))));
    };
    var $author$project$Components$Plan$BasicForm$NameValidation = 0;
    var $author$project$Components$Plan$BasicForm$RegistrationFeeNameValidation = 8;
    var $author$project$Components$Plan$BasicForm$ImageValidation = 10;
    var $author$project$Components$Plan$BasicForm$maxImageBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Plan$BasicForm$imageValidator = A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
        return $.mw;
    }, $author$project$Components$Plan$BasicForm$maxImageBytesSize, _Utils_Tuple2(10, 'That image is too large! Our maximum image size is 5 MB.'));
    var $author$project$Components$Plan$BasicForm$DefaultChargeNameValidation = 6;
    var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonthsValidation = 5;
    var $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercentValidation = 4;
    var $author$project$Components$Plan$BasicForm$MonthAdjustmentPercentValidation = 1;
    var $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercentValidation = 2;
    var $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercentValidation = 3;
    var $author$project$Components$Plan$BasicForm$validateBillingPeriod = F3(function(periodAllowed, adjustmentPercent, validationGroup) {
        return periodAllowed && A2($author$project$Utils$Validate$isInvalidPercentage, {
            abI: false,
            y_: $elm$core$Maybe$Nothing,
            Uj: $elm$core$Maybe$Just(0)
        }, adjustmentPercent) ? _List_fromArray([
            _Utils_Tuple2(validationGroup, 'Please enter a number between 0 and 100.')
        ]) : _List_Nil;
    });
    var $author$project$Components$Plan$BasicForm$validateBillingPeriods = function(fields) {
        return fields.Kh ? _List_Nil : $elm$core$List$concat(_List_fromArray([
            A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.zk, fields.zj, 1),
            A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.Bx, fields.Bw, 2),
            A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.Co, fields.Cn, 3),
            A3($author$project$Components$Plan$BasicForm$validateBillingPeriod, fields.vv, fields.vu, 4)
        ]));
    };
    var $author$project$Components$Plan$BasicForm$validateBillingOptions = F2(function(maybePlan, fields) {
        var planType = A2($elm$core$Maybe$withDefault, 2, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
        var isMcePlan = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
        if (planType !== 1 && !isMcePlan) {
            var forCompany = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(plan) {
                return !$author$project$Api$Provider$Plan$One$planType(plan);
            }, maybePlan));
            return $elm$core$List$concat(_List_fromArray([
                fields.Zk.Up.OM && !forCompany && A2($author$project$Utils$Validate$isOutsideIntRange, {
                    abI: false,
                    y_: $elm$core$Maybe$Just(12),
                    Uj: $elm$core$Maybe$Just(1)
                }, fields.Up) ? _List_fromArray([
                    _Utils_Tuple2(5, 'Please enter a number between 1 and 12.')
                ]) : _List_Nil,
                $rtfeldman$elm_validate$Validate$isBlank(fields.xc) ? _List_fromArray([
                    _Utils_Tuple2(6, 'Please enter a name.')
                ]) : _List_Nil,
                $author$project$Components$Plan$BasicForm$validateBillingPeriods(fields)
            ]));
        } else return _List_Nil;
    });
    var $author$project$Components$Plan$BasicForm$RegistrationFeePricingValidation = 9;
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$hasErrors = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$hasAnyValidationError(form);
    };
    var $author$project$Components$Plan$BasicForm$validateRegistrationFeePricing = function(fields) {
        return $author$project$Components$Plan$Form$RegistrationFeePricingFields$hasErrors(fields.de) ? _List_fromArray([
            _Utils_Tuple2(9, 'Please fix the registration fee validation errors.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCentsValidation = 7;
    var $author$project$Components$Plan$BasicForm$validateSponsorFeeDeal = F2(function(maybePlan, fields) {
        var planType = A2($elm$core$Maybe$withDefault, 2, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
        return planType === 1 && A2($author$project$Utils$Validate$isInvalidCurrency, {
            abI: false,
            y_: $elm$core$Maybe$Nothing,
            Uj: $elm$core$Maybe$Just(1)
        }, fields.Hy) ? _List_fromArray([
            _Utils_Tuple2(7, 'Please enter a number greater than 0.')
        ]) : _List_Nil;
    });
    var $author$project$Components$Plan$BasicForm$validator = F2(function(_v0, maybePlan) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.zr;
            }, _Utils_Tuple2(0, 'Please enter a name.')),
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.BH;
            }, _Utils_Tuple2(8, 'Please enter a registration fee name.')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$BasicForm$validateRegistrationFeePricing),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$BasicForm$validateBillingOptions(maybePlan)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$BasicForm$validateSponsorFeeDeal(maybePlan)),
            $author$project$Components$Plan$BasicForm$imageValidator
        ]));
    });
    var $author$project$Components$Plan$BasicForm$validate = F2(function(_v0, maybePlan) {
        var settings = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        var validatedRegistrationFeeForm = function() {
            var _v1 = $author$project$Components$Plan$Form$RegistrationFeePricingFields$validate(fields.de);
            if (!_v1.$) {
                var _v2 = _v1.a;
                var newForm_ = _v2.a;
                return newForm_;
            } else {
                var newForm_ = _v1.a;
                return newForm_;
            }
        }();
        var updatedFields = _Utils_update(fields, {
            de: validatedRegistrationFeeForm
        });
        return A2($elm$core$Result$mapError, function(f) {
            return A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, f);
        }, A2($elm$core$Result$map, $elm$core$Tuple$mapFirst(function(f) {
            return A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, f);
        }), A2($author$project$Utils$Form$validate, A2($author$project$Components$Plan$BasicForm$validator, settings, maybePlan), A2($author$project$Utils$Form$set, updatedFields, form))));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyMembershipPricingForm = $elm$core$Basics$identity;
    var $author$project$Api$DiscountRuleType$AdditionalAdult = 3;
    var $author$project$Api$DiscountRuleType$AdditionalChild = 4;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation = {
        $: 1
    };
    var $author$project$Api$DiscountRuleType$ChildrenOnly = 5;
    var $author$project$Api$DiscountRuleType$Couple = 0;
    var $author$project$Api$DiscountRuleType$Family = 2;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation = {
        $: 0
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation = {
        $: 2
    };
    var $author$project$Api$DiscountRuleType$SingleParent = 1;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents = F3(function(defaultPeriod, discountRule, validationGroup) {
        return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(discountRule_) {
            var min = 0;
            var max = 9999900;
            return $elm$core$List$concat(_List_fromArray([
                (defaultPeriod === 'month' || discountRule_.Uy) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                    abI: false,
                    y_: $elm$core$Maybe$Just(max),
                    Uj: $elm$core$Maybe$Just(min)
                }, discountRule_.Ux) ? _List_fromArray([
                    _Utils_Tuple2(validationGroup('month'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
                ]) : _List_Nil,
                (defaultPeriod === 'quarter' || discountRule_.XZ) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                    abI: false,
                    y_: $elm$core$Maybe$Just(max),
                    Uj: $elm$core$Maybe$Just(min)
                }, discountRule_.XY) ? _List_fromArray([
                    _Utils_Tuple2(validationGroup('quarter'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
                ]) : _List_Nil,
                (defaultPeriod === 'semi_annual' || discountRule_.ZM) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                    abI: false,
                    y_: $elm$core$Maybe$Just(max),
                    Uj: $elm$core$Maybe$Just(min)
                }, discountRule_.ZL) ? _List_fromArray([
                    _Utils_Tuple2(validationGroup('semi_annual'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
                ]) : _List_Nil,
                (defaultPeriod === 'annual' || discountRule_.Jp) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                    abI: false,
                    y_: $elm$core$Maybe$Just(max),
                    Uj: $elm$core$Maybe$Just(min)
                }, discountRule_.Jo) ? _List_fromArray([
                    _Utils_Tuple2(validationGroup('annual'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
                ]) : _List_Nil
            ]));
        }, discountRule));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule = F3(function(defaultPeriod, type_, fields) {
        switch(type_){
            case 0:
                return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents, defaultPeriod, fields.wX, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
            case 1:
                return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents, defaultPeriod, fields.CE, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
            case 2:
                return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents, defaultPeriod, fields.xG, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
            case 3:
                return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents, defaultPeriod, fields.tQ, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
            case 4:
                return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents, defaultPeriod, fields.tR, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
            default:
                return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRuleRuleMaximumInCents, defaultPeriod, fields.wb, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(type_));
        }
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyMembershipPricingFields = F3(function(sharedFields, maybePlan, fields) {
        var planType = A2($elm$core$Maybe$withDefault, 2, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
        var isMcePlan = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
        if (planType !== 1 && !isMcePlan && sharedFields.Qh === 'family') {
            var _v0 = fields;
            var rules = _v0.Zk;
            return $elm$core$List$concat(_List_fromArray([
                rules.wX.OM ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nx, 0, fields) : _List_Nil,
                rules.xG.OM ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nx, 2, fields) : _List_Nil,
                rules.CE.OM ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nx, 1, fields) : _List_Nil,
                rules.xG.OM || rules.CE.OM ? $elm$core$List$concat(_List_fromArray([
                    rules.xH.OM && A2($author$project$Utils$Validate$isOutsideIntRange, {
                        abI: false,
                        y_: $elm$core$Maybe$Nothing,
                        Uj: $elm$core$Maybe$Just(0)
                    }, fields.xH) ? _List_fromArray([
                        _Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, 'Please enter a number greater than or equal to 0.')
                    ]) : _List_Nil,
                    rules.xH.OM && rules.tR.OM ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nx, 4, fields) : _List_Nil,
                    rules.xH.OM && rules.zP.OM && A2($author$project$Utils$Validate$isOutsideIntRange, {
                        abI: false,
                        y_: $elm$core$Maybe$Nothing,
                        Uj: $elm$core$Maybe$Just(0)
                    }, fields.zP) ? _List_fromArray([
                        _Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, 'Please enter a number greater than or equal to 0.')
                    ]) : _List_Nil,
                    rules.tQ.OM ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nx, 3, fields) : _List_Nil,
                    rules.wb.OM ? A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyDiscountRule, sharedFields.Nx, 5, fields) : _List_Nil,
                    rules.wa.OM && A2($author$project$Utils$Validate$isOutsideIntRange, {
                        abI: false,
                        y_: $elm$core$Maybe$Nothing,
                        Uj: $elm$core$Maybe$Just(1)
                    }, fields.wa) ? _List_fromArray([
                        _Utils_Tuple2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, 'Please enter a number greater than or equal to 1.')
                    ]) : _List_Nil
                ])) : _List_Nil
            ]));
        } else return _List_Nil;
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validator = F2(function(sharedFields, maybePlan) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validateFamilyMembershipPricingFields, sharedFields, maybePlan))
        ]));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate = F3(function(_v0, sharedFields, maybePlan) {
        var form = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$core$Result$mapError, $elm$core$Basics$identity, A2($elm$core$Result$map, $elm$core$Tuple$mapFirst($elm$core$Basics$identity), A2($author$project$Utils$Form$validate, A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validator, sharedFields, maybePlan), A2($author$project$Utils$Form$set, fields, form))));
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupTierPricingForm = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation = {
        $: 2
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation = {
        $: 1
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation = {
        $: 3
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$validatePricingRuleAmountInCents = F3(function(defaultPeriod, pricingRule, validationGroup) {
        var min = 0;
        var max = 999999999;
        return $elm$core$List$concat(_List_fromArray([
            (defaultPeriod === 'month' || pricingRule.gb) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Uu) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('month'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'quarter' || pricingRule.gx) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.XU) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('quarter'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'semi_annual' || pricingRule.gM) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.ZH) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('semi_annual'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'annual' || pricingRule.e3) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Jk) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('annual'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil
        ]));
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule = F3(function(defaultPeriod, rateRuleType, rateRule) {
        var createValidationGroup = function(period) {
            return A2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation, rateRuleType, period);
        };
        return A3($author$project$Components$Plan$Form$GroupTierPricingFields$validatePricingRuleAmountInCents, defaultPeriod, rateRule, createValidationGroup);
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$validateGroupTierPricing = F3(function(sharedFields, maybePlan, fields) {
        var planType = A2($elm$core$Maybe$withDefault, 2, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
        var isMcePlan = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
        return planType !== 1 && !isMcePlan && sharedFields.Qh === 'fixed_pricing' ? $elm$core$List$concat(_List_fromArray([
            A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nx, $author$project$Api$RateRuleType$Individual, fields.Rb),
            A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nx, $author$project$Api$RateRuleType$Couple, fields.Mh),
            A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nx, $author$project$Api$RateRuleType$SingleParent, fields._w),
            A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nx, $author$project$Api$RateRuleType$Family, fields.Pr),
            fields._z ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nx, $author$project$Api$RateRuleType$SingleParentWithSingleChild, fields._y) : _List_Nil,
            fields.Pu ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nx, $author$project$Api$RateRuleType$FamilyWithSingleChild, fields.Pt) : _List_Nil,
            fields.Zk.Pq.OM ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nx, $author$project$Api$RateRuleType$AdditionalAdult, fields.ID) : _List_Nil,
            fields.Zk.Qg.OM ? A3($author$project$Components$Plan$Form$GroupTierPricingFields$validateFixedRateRule, sharedFields.Nx, $author$project$Api$RateRuleType$AdditionalChild, fields.IE) : _List_Nil,
            fields.Zk.PO.OM && A2($author$project$Utils$Validate$isOutsideIntRange, {
                abI: false,
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Just(1)
            }, fields.PO) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, 'Please enter a number greater or equal than 1.')
            ]) : _List_Nil,
            fields.Zk.Pq.OM && A2($author$project$Utils$Validate$isOutsideIntRange, {
                abI: false,
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Just(2)
            }, fields.Pq) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, 'Please enter a number greater or equal than 2.')
            ]) : _List_Nil,
            fields.Zk.Qg.OM && A2($author$project$Utils$Validate$isOutsideIntRange, {
                abI: false,
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Just(0)
            }, fields.Qg) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, 'Please enter a number greater than 0.')
            ]) : _List_Nil
        ])) : _List_Nil;
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$validator = F2(function(sharedFields, maybePlan) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Plan$Form$GroupTierPricingFields$validateGroupTierPricing, sharedFields, maybePlan))
        ]));
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$validate = F3(function(sharedFields, _v0, maybePlan) {
        var form = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$core$Result$mapError, $elm$core$Basics$identity, A2($elm$core$Result$map, $elm$core$Tuple$mapFirst($elm$core$Basics$identity), A2($author$project$Utils$Form$validate, A2($author$project$Components$Plan$Form$GroupTierPricingFields$validator, sharedFields, maybePlan), A2($author$project$Utils$Form$set, fields, form))));
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$IndividualMembershipPricingForm = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents = F3(function(defaultPeriod, pricingRule, validationGroup) {
        var min = 0;
        var max = 999999999;
        return $elm$core$List$concat(_List_fromArray([
            (defaultPeriod === 'month' || pricingRule.gb) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Uu) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('month'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'quarter' || pricingRule.gx) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.XU) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('quarter'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'semi_annual' || pricingRule.gM) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.ZH) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('semi_annual'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil,
            (defaultPeriod === 'annual' || pricingRule.e3) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Jk) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('annual'), 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
            ]) : _List_Nil
        ]));
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validateIndividualMembershipPricing = F3(function(sharedFields, maybePlan, fields) {
        var planType = A2($elm$core$Maybe$withDefault, 2, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
        var isMcePlan = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
        return planType !== 1 && !isMcePlan && sharedFields.Qh !== 'fixed_pricing' ? $elm$core$List$concat(A2($elm$core$List$indexedMap, F2(function(index, ageRateRule) {
            var flatAgeRateRule = {
                Jk: ageRateRule.dc.Jk,
                e3: ageRateRule.dc.e3,
                Uu: ageRateRule.dc.Uu,
                gb: ageRateRule.dc.gb,
                XU: ageRateRule.dc.XU,
                gx: ageRateRule.dc.gx,
                ZH: ageRateRule.dc.ZH,
                gM: ageRateRule.dc.gM
            };
            var individualValidation = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents, sharedFields.Nx, flatAgeRateRule, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation(index));
            var coupleValidation = function() {
                var _v0 = ageRateRule.Mg;
                if (!_v0.$) {
                    var coupleRule = _v0.a;
                    var flatCoupleRule = {
                        Jk: coupleRule.dc.Jk,
                        e3: coupleRule.dc.e3,
                        Uu: coupleRule.dc.Uu,
                        gb: coupleRule.dc.gb,
                        XU: coupleRule.dc.XU,
                        gx: coupleRule.dc.gx,
                        ZH: coupleRule.dc.ZH,
                        gM: coupleRule.dc.gM
                    };
                    return A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validatePricingRuleAmountInCents, sharedFields.Nx, flatCoupleRule, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation(index));
                } else return _List_Nil;
            }();
            return _Utils_ap(individualValidation, coupleValidation);
        }), fields.I_)) : _List_Nil;
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validator = F2(function(sharedFields, maybePlan) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validateIndividualMembershipPricing, sharedFields, maybePlan))
        ]));
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate = F3(function(sharedFields, _v0, maybePlan) {
        var form = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$core$Result$mapError, $elm$core$Basics$identity, A2($elm$core$Result$map, $elm$core$Tuple$mapFirst($elm$core$Basics$identity), A2($author$project$Utils$Form$validate, A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validator, sharedFields, maybePlan), A2($author$project$Utils$Form$set, fields, form))));
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRatesForm = $elm$core$Basics$identity;
    var $author$project$Api$FeatureGate$MembershipPricingAdvancePricingRules = 7;
    var $author$project$Utils$FeatureGate$gateAvailable = F2(function(code, practice) {
        var _v0 = A2($author$project$Utils$FeatureGate$findByCode, code, $author$project$Api$Practice$featureGates(practice));
        if (!_v0.$) return true;
        else return false;
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$SpecialRatesFields$validatePricingRuleAmountInCents = F3(function(defaultPeriod, pricingRule, validationGroup) {
        var min = 0;
        var max = 999999999;
        return $elm$core$List$concat(_List_fromArray([
            (defaultPeriod === 'month' || pricingRule.gb) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Uu) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('month'), 'Please enter an amount between $0.00 and $9,999,999.99.')
            ]) : _List_Nil,
            (defaultPeriod === 'quarter' || pricingRule.gx) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.XU) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('quarter'), 'Please enter an amount between $0.00 and $9,999,999.99.')
            ]) : _List_Nil,
            (defaultPeriod === 'semi_annual' || pricingRule.gM) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.ZH) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('semi_annual'), 'Please enter an amount between $0.00 and $9,999,999.99.')
            ]) : _List_Nil,
            (defaultPeriod === 'annual' || pricingRule.e3) && A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, pricingRule.Jk) ? _List_fromArray([
                _Utils_Tuple2(validationGroup('annual'), 'Please enter an amount between $0.00 and $9,999,999.99.')
            ]) : _List_Nil
        ]));
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRate = F3(function(defaultPeriod, index, fields) {
        return fields.NU ? _List_Nil : $elm$core$List$concat(_List_fromArray([
            $elm$core$String$isEmpty(fields.zr) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index), 'Please enter a name.')
            ]) : _List_Nil,
            A3($author$project$Components$Plan$Form$SpecialRatesFields$validatePricingRuleAmountInCents, defaultPeriod, fields, $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation(index))
        ]));
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRates = F4(function(sharedFields, practice, maybePlan, fields) {
        var planType = A2($elm$core$Maybe$withDefault, 2, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
        var isMcePlan = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
        return planType !== 1 && !isMcePlan && A2($author$project$Utils$FeatureGate$gateAvailable, 7, $author$project$Api$Practice$Provider(practice)) ? $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRate(sharedFields.Nx), fields._M)) : _List_Nil;
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$validator = F3(function(sharedFields, practice, maybePlan) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors(A3($author$project$Components$Plan$Form$SpecialRatesFields$validateSpecialRates, sharedFields, practice, maybePlan))
        ]));
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$validate = F4(function(sharedFields, practice, _v0, maybePlan) {
        var form = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$core$Result$mapError, $elm$core$Basics$identity, A2($elm$core$Result$map, $elm$core$Tuple$mapFirst($elm$core$Basics$identity), A2($author$project$Utils$Form$validate, A3($author$project$Components$Plan$Form$SpecialRatesFields$validator, sharedFields, practice, maybePlan), A2($author$project$Utils$Form$set, fields, form))));
    });
    var $author$project$Components$Plan$Form$validateFormFields = F3(function(plan, practice, form) {
        var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
        var fields = $author$project$Utils$Form$fields(form);
        var validatedFamilyMembershipPricingForm = function() {
            var _v8 = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate, fields.cY, sharedFields, $elm$core$Maybe$Just(plan));
            if (!_v8.$) {
                var _v9 = _v8.a;
                var newForm_ = _v9.a;
                return newForm_;
            } else {
                var newForm_ = _v8.a;
                return newForm_;
            }
        }();
        var validatedGroupTierPricingForm = function() {
            var _v6 = A3($author$project$Components$Plan$Form$GroupTierPricingFields$validate, sharedFields, fields.i, $elm$core$Maybe$Just(plan));
            if (!_v6.$) {
                var _v7 = _v6.a;
                var newForm_ = _v7.a;
                return newForm_;
            } else {
                var newForm_ = _v6.a;
                return newForm_;
            }
        }();
        var validatedMembershipPricingForm = function() {
            var _v4 = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate, sharedFields, fields.c$, $elm$core$Maybe$Just(plan));
            if (!_v4.$) {
                var _v5 = _v4.a;
                var newForm_ = _v5.a;
                return newForm_;
            } else {
                var newForm_ = _v4.a;
                return newForm_;
            }
        }();
        var validatedSpecialRatesForm = function() {
            var _v2 = A4($author$project$Components$Plan$Form$SpecialRatesFields$validate, sharedFields, practice, fields.dj, $elm$core$Maybe$Just(plan));
            if (!_v2.$) {
                var _v3 = _v2.a;
                var newForm_ = _v3.a;
                return newForm_;
            } else {
                var newForm_ = _v2.a;
                return newForm_;
            }
        }();
        var basicPlanForm = function() {
            var _v0 = A2($author$project$Components$Plan$BasicForm$validate, fields.aB, $elm$core$Maybe$Just(plan));
            if (!_v0.$) {
                var _v1 = _v0.a;
                var newForm_ = _v1.a;
                return newForm_;
            } else {
                var newForm_ = _v0.a;
                return newForm_;
            }
        }();
        return A2($author$project$Utils$Form$set, _Utils_update(fields, {
            aB: basicPlanForm,
            cY: validatedFamilyMembershipPricingForm,
            i: validatedGroupTierPricingForm,
            c$: validatedMembershipPricingForm,
            dj: validatedSpecialRatesForm
        }), form);
    });
    var $author$project$Components$Plan$Form$calculate = F4(function(plan, form, opts, model) {
        var newValidForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.W1, form);
        var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, newValidForm);
        var isValid = !opts.aa8 || $author$project$Utils$Maybe$toBool($elm$core$Result$toMaybe(A2($author$project$Utils$Form$validate, A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.cP, model.oN, model.jx, plan), newValidForm)));
        var _v0 = opts._b && isValid ? A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Plan$Form$previewDebounceConfig, $author$project$Utils$Form$fields(form), model.eq) : _Utils_Tuple2(model.eq, $elm$core$Platform$Cmd$none);
        var newDebouncer = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(function() {
            if (opts._b && isValid) return _Utils_update(model, {
                eq: newDebouncer
            });
            else {
                if (!isValid) {
                    var previewId = model.agk.a + 1;
                    return _Utils_update(model, {
                        agk: _Utils_Tuple2(previewId, $author$project$Api$Data$NotAsked),
                        eq: newDebouncer
                    });
                } else return _Utils_update(model, {
                    eq: newDebouncer
                });
            }
        }(), cmd);
    });
    var $author$project$Components$Plan$Form$calculateAfterValidation = F5(function(model, plan, form, opts, showWarningModal) {
        var validatedForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.W1, form);
        var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, validatedForm);
        var _v0 = A2($author$project$Utils$Form$validate, A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.cP, model.oN, model.jx, plan), validatedForm);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var newForm_ = _v1.a;
            return A4($author$project$Components$Plan$Form$calculate, plan, newForm_, opts, _Utils_update(model, {
                PU: $elm$core$Maybe$Just(_Utils_Tuple2(plan, newForm_)),
                ot: showWarningModal
            }));
        } else return _Utils_Tuple2(_Utils_update(model, {
            PU: $elm$core$Maybe$Just(_Utils_Tuple2(plan, form)),
            ot: showWarningModal
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$calculateOpts = function(field) {
        var _v0 = function() {
            switch(field.$){
                case 0:
                    return _Utils_Tuple2(false, false);
                case 1:
                    return _Utils_Tuple2(false, false);
                default:
                    return _Utils_Tuple2(false, false);
            }
        }();
        var shouldCalculate_ = _v0.a;
        var validateCalculateFields = _v0.b;
        return {
            _b: shouldCalculate_,
            aa8: validateCalculateFields
        };
    };
    var $author$project$Components$Plan$BasicForm$calculateOpts = function(field) {
        var _v0 = function() {
            switch(field.$){
                case 0:
                    return _Utils_Tuple2(false, false);
                case 20:
                    return _Utils_Tuple2(false, false);
                case 21:
                    return _Utils_Tuple2(false, false);
                case 1:
                    return _Utils_Tuple2(false, false);
                case 2:
                    return _Utils_Tuple2(false, false);
                case 17:
                    return _Utils_Tuple2(false, false);
                case 5:
                    return _Utils_Tuple2(false, false);
                case 6:
                    return _Utils_Tuple2(false, false);
                case 19:
                    return _Utils_Tuple2(false, false);
                case 3:
                    return _Utils_Tuple2(true, false);
                case 4:
                    return _Utils_Tuple2(true, false);
                case 9:
                    return _Utils_Tuple2(true, true);
                case 10:
                    return _Utils_Tuple2(true, true);
                case 11:
                    return _Utils_Tuple2(true, true);
                case 12:
                    return _Utils_Tuple2(true, true);
                case 13:
                    return _Utils_Tuple2(true, true);
                case 14:
                    return _Utils_Tuple2(true, true);
                case 15:
                    return _Utils_Tuple2(true, false);
                case 16:
                    return _Utils_Tuple2(true, true);
                case 7:
                    return _Utils_Tuple2(false, false);
                case 22:
                    return _Utils_Tuple2(false, false);
                case 8:
                    return _Utils_Tuple2(false, false);
                case 18:
                    return _Utils_Tuple2(false, false);
                case 23:
                    var registrationField = field.a;
                    var opts = $author$project$Components$Plan$Form$RegistrationFeePricingFields$calculateOpts(registrationField);
                    return _Utils_Tuple2(opts._b, opts.aa8);
                default:
                    return _Utils_Tuple2(false, false);
            }
        }();
        var shouldCalculate_ = _v0.a;
        var validateCalculateFields = _v0.b;
        return {
            _b: shouldCalculate_,
            aa8: validateCalculateFields
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts = function(field) {
        var _v0 = function() {
            switch(field.$){
                case 2:
                    return _Utils_Tuple2(false, true);
                case 3:
                    return _Utils_Tuple2(false, true);
                case 4:
                    return _Utils_Tuple2(false, true);
                case 5:
                    return _Utils_Tuple2(true, true);
                case 6:
                    return _Utils_Tuple2(false, true);
                case 7:
                    return _Utils_Tuple2(true, true);
                case 0:
                    return _Utils_Tuple2(false, true);
                case 1:
                    return _Utils_Tuple2(false, false);
                default:
                    return _Utils_Tuple2(false, false);
            }
        }();
        var shouldCalculate_ = _v0.a;
        var validateCalculateFields = _v0.b;
        return {
            _b: shouldCalculate_,
            aa8: validateCalculateFields
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts = function(field) {
        var _v0 = function() {
            switch(field.$){
                case 0:
                    return _Utils_Tuple2(true, false);
                case 1:
                    return _Utils_Tuple2(true, false);
                case 2:
                    return _Utils_Tuple2(true, false);
                case 3:
                    return _Utils_Tuple2(true, false);
                case 4:
                    return _Utils_Tuple2(true, false);
                case 5:
                    return _Utils_Tuple2(true, false);
                case 6:
                    return _Utils_Tuple2(true, false);
                case 7:
                    return _Utils_Tuple2(true, false);
                case 8:
                    return _Utils_Tuple2(false, true);
                case 9:
                    return _Utils_Tuple2(false, true);
                case 10:
                    return _Utils_Tuple2(false, true);
                case 11:
                    return _Utils_Tuple2(false, true);
                case 12:
                    return _Utils_Tuple2(false, false);
                case 13:
                    return _Utils_Tuple2(true, false);
                case 14:
                    return _Utils_Tuple2(false, false);
                case 15:
                    return _Utils_Tuple2(false, false);
                case 16:
                    return _Utils_Tuple2(true, false);
                case 17:
                    return _Utils_Tuple2(false, false);
                case 18:
                    return _Utils_Tuple2(true, false);
                default:
                    return _Utils_Tuple2(true, false);
            }
        }();
        var shouldCalculate_ = _v0.a;
        var validateCalculateFields = _v0.b;
        return {
            _b: shouldCalculate_,
            aa8: validateCalculateFields
        };
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts = function(field) {
        var _v0 = function() {
            switch(field.$){
                case 0:
                    return _Utils_Tuple2(true, true);
                case 1:
                    return _Utils_Tuple2(true, true);
                case 2:
                    return _Utils_Tuple2(false, true);
                case 3:
                    return _Utils_Tuple2(true, true);
                case 4:
                    return _Utils_Tuple2(true, true);
                case 5:
                    return _Utils_Tuple2(false, true);
                case 6:
                    return _Utils_Tuple2(true, true);
                case 7:
                    return _Utils_Tuple2(true, true);
                case 8:
                    return _Utils_Tuple2(false, true);
                case 9:
                    return _Utils_Tuple2(true, true);
                case 10:
                    return _Utils_Tuple2(true, false);
                default:
                    return _Utils_Tuple2(false, false);
            }
        }();
        var shouldCalculate_ = _v0.a;
        var validateCalculateFields = _v0.b;
        return {
            _b: shouldCalculate_,
            aa8: validateCalculateFields
        };
    };
    var $author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts = function(field) {
        var _v0 = function() {
            switch(field.$){
                case 0:
                    return _Utils_Tuple2(true, true);
                case 1:
                    return _Utils_Tuple2(true, true);
                case 2:
                    return _Utils_Tuple2(false, true);
                case 3:
                    return _Utils_Tuple2(true, true);
                case 4:
                    return _Utils_Tuple2(false, true);
                default:
                    return _Utils_Tuple2(true, true);
            }
        }();
        var shouldCalculate_ = _v0.a;
        var validateCalculateFields = _v0.b;
        return {
            _b: shouldCalculate_,
            aa8: validateCalculateFields
        };
    };
    var $elm$http$Http$cancel = function(tracker) {
        return $elm$http$Http$command($elm$http$Http$Cancel(tracker));
    };
    var $author$project$Api$Provider$CoveragePlan$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CoveragePlan$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CoveragePlan$Shared$id(shared);
    };
    var $author$project$Api$Provider$CoveragePlan$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoveragePlan$Shared$id(shared);
    };
    var $author$project$Components$Plan$Form$coveragePlanId = function(coveragePlan) {
        if (!coveragePlan.$) {
            var coveragePlan_ = coveragePlan.a;
            return $author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_);
        } else {
            var coveragePlan_ = coveragePlan.a;
            return $author$project$Api$Provider$CoveragePlan$All$id(coveragePlan_);
        }
    };
    var $author$project$Components$Plan$Form$PreviewDebounced = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$debounceCalculate = function(formFields) {
        return A2($elm$core$Task$perform, $author$project$Components$Plan$Form$PreviewDebounced, $elm$core$Task$succeed(formFields));
    };
    var $author$project$Api$Provider$Plan$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$planPath(id)));
    });
    var $author$project$Components$Plan$Form$GotSubsequentPlan = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$SubsequentPlan$One$SubsequentPlan = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$SubsequentPlan$Min$SubsequentPlan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SubsequentPlan$Min$Record = F2(function(id, type_) {
        return {
            aef: id,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$MembershipScheduledChange$Type$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'date':
                return $elm$json$Json$Decode$succeed(0);
            case 'duration':
                return $elm$json$Json$Decode$succeed(1);
            case 'contract':
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail('Unsupported membership scheduled change type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$SubsequentPlan$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Provider$MembershipScheduledChange$Type$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$Min$Record)));
    var $author$project$Api$Provider$SubsequentPlan$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SubsequentPlan$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SubsequentPlan$One$Record = F3(function(changeAfterMonths, changeOnDate, toPlan) {
        return {
            K2: changeAfterMonths,
            K3: changeOnDate,
            $5: toPlan
        };
    });
    var $author$project$Api$Provider$SubsequentPlan$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'change_on_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'change_after_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$One$Record))));
    var $author$project$Api$Provider$SubsequentPlan$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SubsequentPlan$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SubsequentPlan$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SubsequentPlan$One$SubsequentPlan)));
    var $author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath = function(planId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'subsequent_plan'
        ]), $author$project$Api$Provider$Plan$planPath(planId));
    };
    var $author$project$Api$Provider$Plan$SubsequentPlan$retrieve = F3(function(apiClient, planId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$SubsequentPlan$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)));
    });
    var $author$project$Components$Plan$Form$fetchSubsequentPlan = F2(function(apiClient, id) {
        return A3($author$project$Api$Provider$Plan$SubsequentPlan$retrieve, apiClient, id, $author$project$Components$Plan$Form$GotSubsequentPlan);
    });
    var $author$project$Api$Provider$Plan$Shared$ageRateRules = function(_v0) {
        var record = _v0;
        return record.I_;
    };
    var $author$project$Api$Provider$Plan$One$ageRateRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
    };
    var $author$project$Components$Plan$Form$PlanChange$clean = function(planChange) {
        var params = planChange.VU;
        return planChange.VU.ah5 === 2 ? _Utils_update(planChange, {
            VU: _Utils_update(params, {
                K2: $elm$core$Maybe$Nothing,
                K3: $elm$core$Maybe$Nothing
            })
        }) : !planChange.VU.ah5 ? _Utils_update(planChange, {
            VU: _Utils_update(params, {
                K2: $elm$core$Maybe$Nothing
            })
        }) : _Utils_update(planChange, {
            VU: _Utils_update(params, {
                K3: $elm$core$Maybe$Nothing
            })
        });
    };
    var $author$project$Components$Plan$Form$exclusiveRanges = F5(function(fromGetter, fromSetter, toGetter, toSetter, range) {
        if ($elm$core$List$isEmpty(range)) return range;
        else {
            var minimum = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, fromGetter, $elm$core$List$head(range)));
            return A2($elm$core$List$indexedMap, F2(function(index, current) {
                var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
                var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
                var newTo = function() {
                    var _v1 = _Utils_Tuple2(next, toGetter(current));
                    if (_v1.a.$ === 1) {
                        var _v2 = _v1.a;
                        return $elm$core$Maybe$Nothing;
                    } else if (_v1.b.$ === 1) {
                        var _v3 = _v1.b;
                        return toGetter(current);
                    } else {
                        var currentTo = _v1.b.a;
                        var currentFrom = fromGetter(current);
                        return _Utils_cmp(currentTo, currentFrom) < 1 ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
                    }
                }();
                var newFrom = function() {
                    var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
                    if (!_v0.$) {
                        var _int = _v0.a;
                        return _int + 1;
                    } else return minimum;
                }();
                return A2(toSetter, newTo, A2(fromSetter, newFrom, current));
            }), range);
        }
    });
    var $author$project$Components$Plan$Form$exclusiveSizeRanges = A4($author$project$Components$Plan$Form$exclusiveRanges, function($) {
        return $.P0;
    }, F2(function(from, item) {
        return _Utils_update(item, {
            P0: from
        });
    }), function($) {
        return $.$6;
    }, F2(function(to, item) {
        return _Utils_update(item, {
            $6: to
        });
    }));
    var $author$project$Api$Provider$RateRule$Shared$fromAge = function(_v0) {
        var record = _v0;
        return record.P_;
    };
    var $author$project$Api$Employer$Plan$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$Plan$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$id(shared);
    };
    var $author$project$Api$Employer$Plan$One$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$id(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Plan$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$id(shared);
    };
    var $author$project$Api$Provider$Plan$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$id(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$id(shared);
    };
    var $author$project$Api$Plan$id = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$id(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$id(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$id(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$id(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$id(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$id(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$id(plan_);
        }
    };
    var $elm_community$list_extra$List$Extra$last = function(items) {
        last: while(true){
            if (!items.b) return $elm$core$Maybe$Nothing;
            else if (!items.b.b) {
                var x = items.a;
                return $elm$core$Maybe$Just(x);
            } else {
                var rest = items.b;
                var $temp$items = rest;
                items = $temp$items;
                continue last;
            }
        }
    };
    var $author$project$Components$Plan$Form$maxGroupFromSize = 10;
    var $author$project$Api$Employer$Plan$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$Plan$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$name(shared);
    };
    var $author$project$Api$Employer$Plan$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$name(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Plan$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$name(shared);
    };
    var $author$project$Api$Provider$Plan$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$name(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$name(shared);
    };
    var $author$project$Api$Plan$name = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$name(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$name(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$name(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$name(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$name(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$name(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$name(plan_);
        }
    };
    var $author$project$Utils$List$prepend = F2(function(xs, ys) {
        return _Utils_ap(ys, xs);
    });
    var $author$project$Components$Plan$Form$GroupDiscountRuleField$default = function(defaultPeriod) {
        return function(groupDiscountRule) {
            switch(defaultPeriod){
                case 'month':
                    return _Utils_update(groupDiscountRule, {
                        Uv: $elm$core$Maybe$Just($author$project$Currency$zero)
                    });
                case 'quarter':
                    return _Utils_update(groupDiscountRule, {
                        XW: $elm$core$Maybe$Just($author$project$Currency$zero)
                    });
                case 'semi_annual':
                    return _Utils_update(groupDiscountRule, {
                        ZJ: $elm$core$Maybe$Just($author$project$Currency$zero)
                    });
                case 'annual':
                    return _Utils_update(groupDiscountRule, {
                        Jm: $elm$core$Maybe$Just($author$project$Currency$zero)
                    });
                default:
                    return groupDiscountRule;
            }
        }({
            Jm: $elm$core$Maybe$Nothing,
            Jn: false,
            Eh: false,
            Js: $elm$core$Maybe$Nothing,
            Jt: false,
            py: false,
            KD: 'amount_off_in_cents',
            P0: 2,
            Uv: $elm$core$Maybe$Nothing,
            Uw: false,
            Gm: false,
            UC: $elm$core$Maybe$Nothing,
            UD: false,
            m9: false,
            XW: $elm$core$Maybe$Nothing,
            XX: false,
            G9: false,
            X0: $elm$core$Maybe$Nothing,
            X1: false,
            so: false,
            ZJ: $elm$core$Maybe$Nothing,
            ZK: false,
            Ho: false,
            ZP: $elm$core$Maybe$Nothing,
            ZQ: false,
            sM: false,
            $6: $elm$core$Maybe$Nothing
        });
    };
    var $author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom = F2(function(defaultPeriod, base) {
        return function(groupDiscountRule) {
            var _v0 = _Utils_Tuple2(base.KD, defaultPeriod);
            _v0$8: while(true)switch(_v0.a){
                case 'amount_off_in_cents':
                    switch(_v0.b){
                        case 'month':
                            return _Utils_update(groupDiscountRule, {
                                Uv: base.Uv,
                                Uw: true
                            });
                        case 'quarter':
                            return _Utils_update(groupDiscountRule, {
                                XW: base.XW,
                                XX: true
                            });
                        case 'semi_annual':
                            return _Utils_update(groupDiscountRule, {
                                ZJ: base.ZJ,
                                ZK: true
                            });
                        case 'annual':
                            return _Utils_update(groupDiscountRule, {
                                Jm: base.Jm,
                                Jn: true
                            });
                        default:
                            break _v0$8;
                    }
                case 'percent_off':
                    switch(_v0.b){
                        case 'month':
                            return _Utils_update(groupDiscountRule, {
                                UC: base.UC,
                                UD: true
                            });
                        case 'quarter':
                            return _Utils_update(groupDiscountRule, {
                                X0: base.X0,
                                X1: true
                            });
                        case 'semi_annual':
                            return _Utils_update(groupDiscountRule, {
                                ZP: base.ZP,
                                ZQ: true
                            });
                        case 'annual':
                            return _Utils_update(groupDiscountRule, {
                                Js: base.Js,
                                Jt: true
                            });
                        default:
                            break _v0$8;
                    }
                default:
                    break _v0$8;
            }
            return groupDiscountRule;
        }(function(groupDiscountRule) {
            return _Utils_update(groupDiscountRule, {
                KD: base.KD,
                P0: A2($elm$core$Maybe$withDefault, 0, base.$6) + 1
            });
        }($author$project$Components$Plan$Form$GroupDiscountRuleField$default(defaultPeriod)));
    });
    var $author$project$Api$Provider$RateRule$Shared$toAge = function(_v0) {
        var record = _v0;
        return record.$4;
    };
    var $author$project$Utils$List$updateLast = F2(function(f, xs) {
        if (!xs.b) return xs;
        else return A3($elm_community$list_extra$List$Extra$updateAt, $elm$core$List$length(xs) - 1, f, xs);
    });
    var $author$project$Components$Plan$Form$formFieldsUpdate = F3(function(plan, field, fields) {
        switch(field.$){
            case 0:
                var basicPlanForm = field.a;
                return _Utils_update(fields, {
                    aB: basicPlanForm
                });
            case 1:
                var membershipPricingForm = field.a;
                return _Utils_update(fields, {
                    c$: membershipPricingForm
                });
            case 2:
                var familyMembershipPricingForm = field.a;
                return _Utils_update(fields, {
                    cY: familyMembershipPricingForm
                });
            case 3:
                var groupTierPricingForm = field.a;
                return _Utils_update(fields, {
                    i: groupTierPricingForm
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    SI: $author$project$Utils$String$toMaybe(string)
                });
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    aad: string
                });
            case 6:
                var currency = field.a;
                return _Utils_update(fields, {
                    aab: currency
                });
            case 7:
                var percentage = field.a;
                return _Utils_update(fields, {
                    aac: percentage
                });
            case 8:
                var bool = field.a;
                var planChange = function() {
                    if (_Utils_eq(fields.jw.VU.aef, $elm$core$Maybe$Nothing)) {
                        var planChangeType = bool ? 2 : 1;
                        return $author$project$Components$Plan$Form$PlanChange$clean(function(planChange_) {
                            var params = fields.jw.VU;
                            return _Utils_update(planChange_, {
                                VU: _Utils_update(params, {
                                    ah5: planChangeType
                                })
                            });
                        }(fields.jw));
                    } else return fields.jw;
                }();
                return _Utils_update(fields, {
                    L5: bool,
                    jw: planChange,
                    Xo: 0
                });
            case 9:
                var string = field.a;
                return _Utils_update(fields, {
                    L6: $elm$core$String$toInt(string)
                });
            case 10:
                var string = field.a;
                return _Utils_update(fields, {
                    EW: $author$project$Api$ContractType$fromString(string)
                });
            case 11:
                var bool = field.a;
                return _Utils_update(fields, {
                    L4: bool
                });
            case 12:
                var bool = field.a;
                return _Utils_update(fields, {
                    xm: bool
                });
            case 13:
                var string = field.a;
                return _Utils_update(fields, {
                    L7: $elm$core$String$toInt(string)
                });
            case 14:
                var bool = field.a;
                var ageRateRules = $author$project$Api$Provider$Plan$One$ageRateRules(plan);
                var minimumAge = bool && $elm$core$List$length(ageRateRules) > 1 ? A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$toAge, $elm$core$List$head(ageRateRules)) : $elm$core$Maybe$Just(0);
                return _Utils_update(fields, {
                    xp: bool,
                    Un: minimumAge
                });
            case 15:
                var string = field.a;
                return _Utils_update(fields, {
                    Un: $elm$core$String$toInt(string)
                });
            case 16:
                var bool = field.a;
                var ageRateRules = $author$project$Api$Provider$Plan$One$ageRateRules(plan);
                var maximumAge = bool && $elm$core$List$length(ageRateRules) > 1 ? A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$fromAge, $elm_community$list_extra$List$Extra$last(ageRateRules)) : $elm$core$Maybe$Nothing;
                return _Utils_update(fields, {
                    xo: bool,
                    TQ: maximumAge
                });
            case 17:
                var string = field.a;
                return _Utils_update(fields, {
                    TQ: $elm$core$String$toInt(string)
                });
            case 18:
                var coveragePlan = field.a;
                return _Utils_update(fields, {
                    Mn: coveragePlan
                });
            case 19:
                var planChange = field.a;
                return _Utils_update(fields, {
                    jw: planChange
                });
            case 20:
                var type_ = field.a;
                var planChange = fields.jw;
                var params = planChange.VU;
                return _Utils_update(fields, {
                    jw: $author$project$Components$Plan$Form$PlanChange$clean(_Utils_update(planChange, {
                        VU: _Utils_update(params, {
                            ah5: type_
                        })
                    }))
                });
            case 21:
                var string = field.a;
                var planChange = fields.jw;
                var params = planChange.VU;
                return _Utils_update(fields, {
                    jw: _Utils_update(planChange, {
                        VU: _Utils_update(params, {
                            K2: $elm$core$String$toInt(string)
                        })
                    })
                });
            case 22:
                var date = field.a;
                var planChange = fields.jw;
                var params = planChange.VU;
                return _Utils_update(fields, {
                    jw: _Utils_update(planChange, {
                        VU: _Utils_update(params, {
                            K3: date
                        })
                    })
                });
            case 23:
                var newPlan = field.a;
                var toPlan = A2($elm$core$Maybe$map, function(newPlan_) {
                    return {
                        aef: $author$project$Api$Plan$id(newPlan_),
                        zr: $author$project$Api$Plan$name(newPlan_)
                    };
                }, newPlan);
                var planChange = fields.jw;
                var params = planChange.VU;
                return _Utils_update(fields, {
                    jw: _Utils_update(planChange, {
                        VU: _Utils_update(params, {
                            $5: toPlan
                        })
                    })
                });
            case 24:
                var planChange = fields.jw;
                return _Utils_update(fields, {
                    jw: _Utils_update(planChange, {
                        bW: true
                    })
                });
            case 25:
                var planChange = fields.jw;
                var newPlanChange = _Utils_eq(planChange.VU.aef, $elm$core$Maybe$Nothing) ? _Utils_update(planChange, {
                    bW: false
                }) : _Utils_update(planChange, {
                    jN: true
                });
                return _Utils_update(fields, {
                    jw: newPlanChange
                });
            case 26:
                var planChange = fields.jw;
                return _Utils_update(fields, {
                    jw: _Utils_update(planChange, {
                        jN: false
                    })
                });
            case 27:
                var groupPricingType = fields.Qh === 'fixed_pricing' ? 'family' : 'fixed_pricing';
                return _Utils_update(fields, {
                    Qh: groupPricingType
                });
            case 29:
                var bool = field.a;
                return _Utils_update(fields, {
                    Jy: bool
                });
            case 30:
                var bool = field.a;
                var groupDiscountRulesCalculatedBy = bool ? 'percent_off' : 'amount_off_in_cents';
                return _Utils_update(fields, {
                    Qd: A2($elm$core$List$map, function(groupDiscountRule) {
                        return _Utils_update(groupDiscountRule, {
                            KD: groupDiscountRulesCalculatedBy
                        });
                    }, fields.Qd)
                });
            case 28:
                var string = field.a;
                return _Utils_update(fields, {
                    Qh: string
                });
            case 31:
                return A2($elm$core$Maybe$withDefault, fields, A2($elm$core$Maybe$map, function(_v2) {
                    var newGroupDiscountRule = _v2.a;
                    var newLastGroupDiscountRule = _v2.b;
                    return _Utils_update(fields, {
                        Qd: A2($author$project$Utils$List$prepend, _List_fromArray([
                            newGroupDiscountRule
                        ]), A2($author$project$Utils$List$updateLast, function(last) {
                            return A2($elm$core$Maybe$withDefault, last, newLastGroupDiscountRule);
                        }, fields.Qd))
                    });
                }, A2($elm$core$Maybe$map, function(lastGroupDiscountRule) {
                    var lastToSize = _Utils_cmp(lastGroupDiscountRule.P0 + 1, $author$project$Components$Plan$Form$maxGroupFromSize - 1) > 0 ? $author$project$Components$Plan$Form$maxGroupFromSize - 1 : lastGroupDiscountRule.P0 + 1;
                    var newLastGroupDiscountRule_ = _Utils_update(lastGroupDiscountRule, {
                        $6: $elm$core$Maybe$Just(lastToSize)
                    });
                    var _v1 = $author$project$Components$Plan$BasicForm$formFields(fields.aB);
                    var defaultPeriod = _v1.Nx;
                    return _Utils_Tuple2(A2($author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom, defaultPeriod, newLastGroupDiscountRule_), $elm$core$Maybe$Just(newLastGroupDiscountRule_));
                }, $elm_community$list_extra$List$Extra$last(fields.Qd))));
            case 32:
                var index = field.a;
                return _Utils_update(fields, {
                    Qd: $author$project$Components$Plan$Form$exclusiveSizeRanges(A2($elm_community$list_extra$List$Extra$removeAt, index, fields.Qd))
                });
            case 33:
                var index = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    Qd: $author$project$Components$Plan$Form$exclusiveSizeRanges(A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                        return _Utils_update(groupDiscountRule, {
                            P0: A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(string))
                        });
                    }, fields.Qd))
                });
            case 34:
                var index = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    Qd: $author$project$Components$Plan$Form$exclusiveSizeRanges(A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                        return _Utils_update(groupDiscountRule, {
                            $6: $elm$core$String$toInt(string)
                        });
                    }, fields.Qd))
                });
            case 35:
                var index = field.a;
                var period = field.b;
                var currency = field.c;
                return _Utils_update(fields, {
                    Qd: A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(groupDiscountRule, {
                                    Uv: currency,
                                    Uw: true
                                });
                            case 'quarter':
                                return _Utils_update(groupDiscountRule, {
                                    XW: currency,
                                    XX: true
                                });
                            case 'semi_annual':
                                return _Utils_update(groupDiscountRule, {
                                    ZJ: currency,
                                    ZK: true
                                });
                            case 'annual':
                                return _Utils_update(groupDiscountRule, {
                                    Jm: currency,
                                    Jn: true
                                });
                            default:
                                return groupDiscountRule;
                        }
                    }, fields.Qd)
                });
            case 36:
                var index = field.a;
                var period = field.b;
                return _Utils_update(fields, {
                    Qd: A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(groupDiscountRule, {
                                    Gm: true
                                });
                            case 'quarter':
                                return _Utils_update(groupDiscountRule, {
                                    G9: true
                                });
                            case 'semi_annual':
                                return _Utils_update(groupDiscountRule, {
                                    Ho: true
                                });
                            case 'annual':
                                return _Utils_update(groupDiscountRule, {
                                    Eh: true
                                });
                            default:
                                return groupDiscountRule;
                        }
                    }, fields.Qd)
                });
            case 37:
                var index = field.a;
                var period = field.b;
                return _Utils_update(fields, {
                    Qd: A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(groupDiscountRule, {
                                    Uw: false,
                                    Gm: false
                                });
                            case 'quarter':
                                return _Utils_update(groupDiscountRule, {
                                    XX: false,
                                    G9: false
                                });
                            case 'semi_annual':
                                return _Utils_update(groupDiscountRule, {
                                    ZK: false,
                                    Ho: false
                                });
                            case 'annual':
                                return _Utils_update(groupDiscountRule, {
                                    Jn: false,
                                    Eh: false
                                });
                            default:
                                return groupDiscountRule;
                        }
                    }, fields.Qd)
                });
            case 38:
                var index = field.a;
                var period = field.b;
                var percent = field.c;
                return _Utils_update(fields, {
                    Qd: A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(groupDiscountRule, {
                                    UC: percent,
                                    UD: true
                                });
                            case 'quarter':
                                return _Utils_update(groupDiscountRule, {
                                    X0: percent,
                                    X1: true
                                });
                            case 'semi_annual':
                                return _Utils_update(groupDiscountRule, {
                                    ZP: percent,
                                    ZQ: true
                                });
                            case 'annual':
                                return _Utils_update(groupDiscountRule, {
                                    Js: percent,
                                    Jt: true
                                });
                            default:
                                return groupDiscountRule;
                        }
                    }, fields.Qd)
                });
            case 39:
                var index = field.a;
                var period = field.b;
                return _Utils_update(fields, {
                    Qd: A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(groupDiscountRule, {
                                    m9: true
                                });
                            case 'quarter':
                                return _Utils_update(groupDiscountRule, {
                                    so: true
                                });
                            case 'semi_annual':
                                return _Utils_update(groupDiscountRule, {
                                    sM: true
                                });
                            case 'annual':
                                return _Utils_update(groupDiscountRule, {
                                    py: true
                                });
                            default:
                                return groupDiscountRule;
                        }
                    }, fields.Qd)
                });
            case 40:
                var index = field.a;
                var period = field.b;
                return _Utils_update(fields, {
                    Qd: A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(groupDiscountRule, {
                                    UD: false,
                                    m9: false
                                });
                            case 'quarter':
                                return _Utils_update(groupDiscountRule, {
                                    X1: false,
                                    so: false
                                });
                            case 'semi_annual':
                                return _Utils_update(groupDiscountRule, {
                                    ZQ: false,
                                    sM: false
                                });
                            case 'annual':
                                return _Utils_update(groupDiscountRule, {
                                    Jt: false,
                                    py: false
                                });
                            default:
                                return groupDiscountRule;
                        }
                    }, fields.Qd)
                });
            default:
                var pricingEffectivenessType = field.a;
                return _Utils_update(fields, {
                    Xo: pricingEffectivenessType
                });
        }
    });
    var $author$project$Api$Provider$PricingVersion$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsInit = {
        Mn: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$ResourceFilter$CoveragePlan$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoveragePlan$coveragePlansPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'coverage_plans'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$CoveragePlan$All$CoveragePlan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoveragePlan$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoveragePlan$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CoveragePlan$listDefaults = {
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$CoveragePlan$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$CoveragePlan$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$CoveragePlan$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CoveragePlan$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$CoveragePlan$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlansPath)));
    });
    var $author$project$Components$ResourceFilter$CoveragePlan$list = $author$project$Api$Provider$CoveragePlan$list;
    var $author$project$Components$ResourceFilter$CoveragePlan$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$CoveragePlan$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$CoveragePlan$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$CoveragePlan$list, apiClient, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$CoveragePlan$selectId = 'coverage-plans';
    var $author$project$Api$Provider$CoveragePlan$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$CoveragePlan$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CoveragePlan$Shared$name(shared);
    };
    var $author$project$Components$ResourceFilter$CoveragePlan$toTitle = $author$project$Api$Provider$CoveragePlan$All$name;
    var $author$project$Components$ResourceFilter$CoveragePlan$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$CoveragePlan$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$CoveragePlan$toValue = $author$project$Api$Provider$CoveragePlan$All$id;
    var $author$project$Components$ResourceFilter$CoveragePlan$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$CoveragePlan$fetchResources,
            aef: $author$project$Components$ResourceFilter$CoveragePlan$selectId,
            gD: 'Coverage Plan',
            sz: $author$project$Components$ResourceFilter$CoveragePlan$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$CoveragePlan$toLabel,
            ahZ: $author$project$Components$ResourceFilter$CoveragePlan$toTitle,
            g4: $author$project$Components$ResourceFilter$CoveragePlan$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$init = F2(function(apiClient, id) {
        var _v0 = A2($author$project$Components$ResourceFilter$CoveragePlan$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Coverage Plan',
                adw: id
            });
        });
        var coveragePlanResourceFilter = _v0.a;
        var coveragePlanResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            w$: coveragePlanResourceFilter,
            PU: $author$project$Utils$Form$init($author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsInit),
            aef: id
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg, coveragePlanResourceFilterCmd));
    });
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$GotPatientsCount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('subsequent_plan', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('change_after_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.K2)),
                _Utils_Tuple2('change_on_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.K3)),
                _Utils_Tuple2('to_plan', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.$5))
            ])))
        ]));
    };
    var $author$project$Api$Provider$Plan$SubsequentPlan$patientsCountDecoder = A2($elm$json$Json$Decode$field, 'patients_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int));
    var $author$project$Api$Provider$Plan$SubsequentPlan$patientsCount = F4(function(apiClient, planId, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Plan$SubsequentPlan$patientsCountDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields(fields), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients_count'
        ]), $author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)))));
    });
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$init = F5(function(apiClient, practice, plan, params, planChange) {
        var _v0 = function() {
            if (planChange.bW) {
                var apiFields = {
                    K2: planChange.VU.K2,
                    K3: planChange.VU.K3,
                    $5: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, planChange.VU.$5)
                };
                return _Utils_Tuple2($author$project$Api$Data$Loading, A4($author$project$Api$Provider$Plan$SubsequentPlan$patientsCount, apiClient, $author$project$Api$Provider$Plan$One$id(plan), apiFields, $author$project$Components$Plan$Form$ConfirmUpdateModal$GotPatientsCount));
            } else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
        }();
        var patientsCount = _v0.a;
        var patientsCountCmd = _v0.b;
        return _Utils_Tuple2({
            VU: params,
            Wd: patientsCount,
            GW: plan,
            jw: planChange,
            W1: practice
        }, patientsCountCmd);
    });
    var $author$project$Utils$Tuple3$mapSecond = F2(function(mapFunc, _v0) {
        var first_ = _v0.a;
        var second_ = _v0.b;
        var third_ = _v0.c;
        return _Utils_Tuple3(first_, mapFunc(second_), third_);
    });
    var $author$project$Api$FeatureGate$MembershipPricingSchedulePlanChanges = 6;
    var $author$project$Components$Plan$Form$CoveragePlanOne = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers = function(_v0) {
        var record = _v0.b;
        return record.Jy;
    };
    var $author$project$Api$Provider$Plan$One$contractEmailsEnabled = function(_v0) {
        var record = _v0.b;
        return record.L4;
    };
    var $author$project$Api$Provider$Plan$One$contractExpires = function(_v0) {
        var record = _v0.b;
        return record.L5;
    };
    var $author$project$Api$Provider$Plan$One$contractPeriodInMonths = function(_v0) {
        var record = _v0.b;
        return record.L6;
    };
    var $author$project$Api$Provider$Plan$One$contractRenewalEmailLeadTime = function(_v0) {
        var record = _v0.b;
        return record.L7;
    };
    var $author$project$Api$Provider$Plan$One$contractType = function(_v0) {
        var record = _v0.b;
        return record.EW;
    };
    var $author$project$Api$Provider$Plan$Shared$coveragePlan = function(_v0) {
        var record = _v0;
        return record.Mn;
    };
    var $author$project$Api$Provider$Plan$One$coveragePlan = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$coveragePlan(shared);
    };
    var $author$project$Components$Plan$Form$defaultGroupRules = function(defaultPeriod) {
        return _List_fromArray([
            $author$project$Components$Plan$Form$GroupDiscountRuleField$default(defaultPeriod)
        ]);
    };
    var $author$project$Api$Provider$Plan$One$defaultPeriod = function(_v0) {
        var record = _v0.b;
        return record.Nx;
    };
    var $author$project$Api$Provider$Plan$One$discountsEnabled = function(_v0) {
        var record = _v0.b;
        return record.xm;
    };
    var $author$project$Api$Provider$Plan$Shared$addon = function(_v0) {
        var record = _v0;
        return record.IF;
    };
    var $author$project$Api$Provider$Plan$One$addon = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$addon(shared);
    };
    var $author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Plan$One$annualAdjustmentPercent = function(_v0) {
        var record = _v0.b;
        return record.vu;
    };
    var $author$project$Api$Provider$Plan$One$annualAllowed = function(_v0) {
        var record = _v0.b;
        return record.vv;
    };
    var $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod = function(_v0) {
        var record = _v0;
        return record.Kh;
    };
    var $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$buyable = function(_v0) {
        var record = _v0;
        return record.Ky;
    };
    var $author$project$Api$Provider$Plan$One$buyable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$buyable(shared);
    };
    var $author$project$Api$Provider$Plan$One$defaultChargeDescription = function(_v0) {
        var record = _v0.b;
        return record.xb;
    };
    var $author$project$Api$Provider$Plan$One$defaultChargeName = function(_v0) {
        var record = _v0.b;
        return record.xc;
    };
    var $author$project$Api$Provider$Plan$One$descriptions = function(_v0) {
        var record = _v0.b;
        return record.Ff;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$individualRegistrationFeeInCents = function(_v0) {
        var record = _v0;
        return record.Rd;
    };
    var $author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$individualRegistrationFeeInCents(shared);
    };
    var $author$project$Api$Provider$Plan$Meta$individualRegistrationFeeInCentsRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.Rd.OM;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$maxRegistrationFeeInCents = function(_v0) {
        var record = _v0;
        return record.TN;
    };
    var $author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$maxRegistrationFeeInCents(shared);
    };
    var $author$project$Api$Provider$Plan$Meta$maxRegistrationFeeInCentsRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.TN.OM;
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules = F2(function(meta, maybePricingVersion) {
        if (!maybePricingVersion.$) {
            var pv = maybePricingVersion.a;
            return {
                Rd: {
                    OM: !_Utils_eq($author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents(pv), $elm$core$Maybe$Nothing)
                },
                TN: {
                    OM: !_Utils_eq($author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents(pv), $elm$core$Maybe$Nothing)
                }
            };
        } else return {
            Rd: {
                OM: $author$project$Api$Provider$Plan$Meta$individualRegistrationFeeInCentsRuleEnabled(meta)
            },
            TN: {
                OM: $author$project$Api$Provider$Plan$Meta$maxRegistrationFeeInCentsRuleEnabled(meta)
            }
        };
    });
    var $author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents = function(_v0) {
        var record = _v0.b;
        return record.Rd;
    };
    var $author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents = function(_v0) {
        var record = _v0.b;
        return record.TN;
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees = F2(function(plan, maybePricingVersion) {
        if (!maybePricingVersion.$) {
            var pv = maybePricingVersion.a;
            return {
                yd: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$PricingVersion$One$individualRegistrationFeeInCents(pv)),
                y_: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$PricingVersion$One$maxRegistrationFeeInCents(pv))
            };
        } else return {
            yd: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents(plan)),
            y_: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents(plan))
        };
    });
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$fill = F2(function(plan, maybePricingVersion) {
        var fees = A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees, plan, maybePricingVersion);
        return $author$project$Utils$Form$init({
            cK: $elm$core$Maybe$Nothing,
            Rd: fees.yd,
            TN: fees.y_,
            Zk: A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules, $author$project$Api$Provider$Plan$One$meta(plan), maybePricingVersion)
        });
    });
    var $author$project$Api$Provider$Category$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Plan$One$registrationFeeCategory = function(_v0) {
        var record = _v0.b;
        return record.Ys;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeCategoryId = function(_v0) {
        var record = _v0;
        return record.BF;
    };
    var $author$project$Api$Provider$PricingVersion$One$registrationFeeCategoryId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeCategoryId(shared);
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$fillAsync = F4(function(plan, maybePricingVersion, apiClient, session) {
        var meta = $author$project$Api$Provider$Plan$One$meta(plan);
        var fees = A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$registrationFees, plan, maybePricingVersion);
        var categoryId = function() {
            if (!maybePricingVersion.$) {
                var pv = maybePricingVersion.a;
                return $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$PricingVersion$One$registrationFeeCategoryId(pv)));
            } else return A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$id, $author$project$Api$Provider$Plan$One$registrationFeeCategory(plan));
        }();
        var _v0 = A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                I5: false,
                U5: 'Unassigned',
                afn: true,
                afo: $elm$core$Maybe$Just('')
            });
        });
        var categoryResourceFilter = _v0.a;
        var categoryResourceFilterInitCmd = _v0.b;
        var _v1 = A2($author$project$Components$ResourceFilter$Category$preSelectedId, categoryId, categoryResourceFilter);
        var categoryResourceFilterWithPreselected = _v1.a;
        var categoryResourceFilterCmd = _v1.b;
        return _Utils_Tuple2($author$project$Utils$Form$init({
            cK: $elm$core$Maybe$Just(categoryResourceFilterWithPreselected),
            Rd: fees.yd,
            TN: fees.y_,
            Zk: A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$initRules, meta, maybePricingVersion)
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, categoryResourceFilterInitCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, categoryResourceFilterCmd)
        ])));
    });
    var $author$project$Percentage$Percentage = $elm$core$Basics$identity;
    var $author$project$Percentage$fromFloat = function(_float) {
        return $elm$core$String$fromFloat(_float);
    };
    var $author$project$Api$Provider$Plan$Shared$imageUrl = function(_v0) {
        var record = _v0;
        return record.Q4;
    };
    var $author$project$Api$Provider$Plan$One$imageUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$imageUrl(shared);
    };
    var $author$project$Api$Provider$Plan$Meta$minimumEnrollmentPeriodInMonthsRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.Up.OM;
    };
    var $author$project$Components$Plan$BasicForm$initRules = function(meta) {
        return {
            Up: {
                OM: $author$project$Api$Provider$Plan$Meta$minimumEnrollmentPeriodInMonthsRuleEnabled(meta)
            }
        };
    };
    var $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths = function(_v0) {
        var record = _v0;
        return record.Up;
    };
    var $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
    };
    var $author$project$Api$Provider$Plan$One$monthAdjustmentPercent = function(_v0) {
        var record = _v0.b;
        return record.zj;
    };
    var $author$project$Api$Provider$Plan$One$monthAllowed = function(_v0) {
        var record = _v0.b;
        return record.zk;
    };
    var $author$project$Api$Provider$Category$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Plan$One$quarterAdjustmentPercent = function(_v0) {
        var record = _v0.b;
        return record.Bw;
    };
    var $author$project$Api$Provider$Plan$One$quarterAllowed = function(_v0) {
        var record = _v0.b;
        return record.Bx;
    };
    var $author$project$Api$Provider$Plan$One$registrationFeeDescription = function(_v0) {
        var record = _v0.b;
        return record.BG;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeDescription = function(_v0) {
        var record = _v0;
        return record.BG;
    };
    var $author$project$Api$Provider$PricingVersion$One$registrationFeeDescription = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeDescription(shared);
    };
    var $author$project$Api$Provider$Plan$One$registrationFeeName = function(_v0) {
        var record = _v0.b;
        return record.BH;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$registrationFeeName = function(_v0) {
        var record = _v0;
        return record.BH;
    };
    var $author$project$Api$Provider$PricingVersion$One$registrationFeeName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$registrationFeeName(shared);
    };
    var $author$project$Api$Provider$Plan$One$semiAnnualAdjustmentPercent = function(_v0) {
        var record = _v0.b;
        return record.Cn;
    };
    var $author$project$Api$Provider$Plan$One$semiAnnualAllowed = function(_v0) {
        var record = _v0.b;
        return record.Co;
    };
    var $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal = function(_v0) {
        var record = _v0;
        return record._S;
    };
    var $author$project$Api$Provider$Plan$One$sponsorFeeDeal = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
    };
    var $author$project$Components$Plan$BasicForm$fill = F6(function(practice, plan, practiceIsOnboarding, isViewingAsHinter, maybeApiContext, maybePricingVersion) {
        var settings = {
            yu: isViewingAsHinter,
            W1: practice,
            W4: practiceIsOnboarding
        };
        var _v0 = function() {
            if (!maybeApiContext.$) {
                var _v2 = maybeApiContext.a;
                var apiClient = _v2.a;
                var session = _v2.b;
                return A4($author$project$Components$Plan$Form$RegistrationFeePricingFields$fillAsync, plan, maybePricingVersion, apiClient, session);
            } else return _Utils_Tuple2(A2($author$project$Components$Plan$Form$RegistrationFeePricingFields$fill, plan, maybePricingVersion), $elm$core$Platform$Cmd$none);
        }();
        var registrationFeePricingForm = _v0.a;
        var regCmd = _v0.b;
        return _Utils_Tuple2(A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, $author$project$Utils$Form$init({
            IF: $author$project$Api$Provider$Plan$One$addon(plan),
            vu: $elm$core$Maybe$Just($author$project$Percentage$fromFloat($author$project$Api$Provider$Plan$One$annualAdjustmentPercent(plan))),
            vv: $author$project$Api$Provider$Plan$One$annualAllowed(plan),
            Kh: $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod(plan),
            Ky: $author$project$Api$Provider$Plan$One$buyable(plan),
            p7: $author$project$Api$Provider$Plan$One$imageUrl(plan),
            xb: A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, $author$project$Api$Provider$Plan$One$defaultChargeDescription(plan)),
            xc: $author$project$Api$Provider$Plan$One$defaultChargeName(plan),
            Nx: $author$project$Api$Provider$Plan$One$defaultPeriod(plan),
            NQ: A2($author$project$Components$TranslatedRichText$init, $author$project$Api$Provider$Plan$One$descriptions(plan), 'plan-description-language-dropdown'),
            qr: false,
            iB: false,
            l1: false,
            mw: 0,
            Q4: $elm$core$Maybe$Nothing,
            Up: $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths(plan),
            zj: $elm$core$Maybe$Just($author$project$Percentage$fromFloat($author$project$Api$Provider$Plan$One$monthAdjustmentPercent(plan))),
            zk: $author$project$Api$Provider$Plan$One$monthAllowed(plan),
            zr: $author$project$Api$Provider$Plan$One$name(plan),
            Bw: $elm$core$Maybe$Just($author$project$Percentage$fromFloat($author$project$Api$Provider$Plan$One$quarterAdjustmentPercent(plan))),
            Bx: $author$project$Api$Provider$Plan$One$quarterAllowed(plan),
            BF: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$id, $author$project$Api$Provider$Plan$One$registrationFeeCategory(plan)),
            sr: A2($elm$core$Maybe$withDefault, 'Unassigned', A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$name, $author$project$Api$Provider$Plan$One$registrationFeeCategory(plan))),
            BG: function() {
                if (!maybePricingVersion.$) {
                    var pv = maybePricingVersion.a;
                    return A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$PricingVersion$One$registrationFeeDescription(pv));
                } else return $author$project$Api$Provider$Plan$One$registrationFeeDescription(plan);
            }(),
            BH: A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Plan$One$registrationFeeName(plan), A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$registrationFeeName, maybePricingVersion)),
            de: registrationFeePricingForm,
            Zk: $author$project$Components$Plan$BasicForm$initRules($author$project$Api$Provider$Plan$One$meta(plan)),
            Cn: $elm$core$Maybe$Just($author$project$Percentage$fromFloat($author$project$Api$Provider$Plan$One$semiAnnualAdjustmentPercent(plan))),
            Co: $author$project$Api$Provider$Plan$One$semiAnnualAllowed(plan),
            Hy: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$map, $author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents, $author$project$Api$Provider$Plan$One$sponsorFeeDeal(plan)))
        })), A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, regCmd));
    });
    var $author$project$Api$Provider$Plan$One$childrenAgeLimit = function(_v0) {
        var record = _v0.b;
        return record.wa;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$childrenAgeLimit = function(_v0) {
        var record = _v0;
        return record.wa;
    };
    var $author$project$Api$Provider$PricingVersion$One$childrenAgeLimit = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$childrenAgeLimit(shared);
    };
    var $author$project$Api$Provider$Plan$One$familyNumChildrenIncluded = function(_v0) {
        var record = _v0.b;
        return record.xH;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$familyNumChildrenIncluded = function(_v0) {
        var record = _v0;
        return record.xH;
    };
    var $author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$familyNumChildrenIncluded(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$additionalAdultDiscountRule = function(_v0) {
        var record = _v0;
        return record.tQ;
    };
    var $author$project$Api$Provider$Plan$One$additionalAdultDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$additionalAdultDiscountRule(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$additionalChildDiscountRule = function(_v0) {
        var record = _v0;
        return record.tR;
    };
    var $author$project$Api$Provider$Plan$One$additionalChildDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$additionalChildDiscountRule(shared);
    };
    var $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents = function(_v0) {
        var record = _v0;
        return record.Jo;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited = function(_v0) {
        var record = _v0;
        return record.Jp;
    };
    var $author$project$Api$Provider$Plan$Shared$childrenOnlyDiscountRule = function(_v0) {
        var record = _v0;
        return record.wb;
    };
    var $author$project$Api$Provider$Plan$One$childrenOnlyDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$childrenOnlyDiscountRule(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$coupleDiscountRule = function(_v0) {
        var record = _v0;
        return record.wX;
    };
    var $author$project$Api$Provider$Plan$One$coupleDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$coupleDiscountRule(shared);
    };
    var $author$project$Components$Plan$Form$FamilyDiscountRuleField$empty = function(type_) {
        return {
            Jo: $elm$core$Maybe$Nothing,
            Jp: false,
            vw: false,
            Ux: $elm$core$Maybe$Nothing,
            Uy: false,
            zm: false,
            XY: $elm$core$Maybe$Nothing,
            XZ: false,
            By: false,
            ZL: $elm$core$Maybe$Nothing,
            ZM: false,
            Cp: false,
            ah5: type_
        };
    };
    var $author$project$Api$Provider$Plan$Shared$familyDiscountRule = function(_v0) {
        var record = _v0;
        return record.xG;
    };
    var $author$project$Api$Provider$Plan$One$familyDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyDiscountRule(shared);
    };
    var $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents = function(_v0) {
        var record = _v0;
        return record.Ux;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited = function(_v0) {
        var record = _v0;
        return record.Uy;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents = function(_v0) {
        var record = _v0;
        return record.XY;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited = function(_v0) {
        var record = _v0;
        return record.XZ;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents = function(_v0) {
        var record = _v0;
        return record.ZL;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited = function(_v0) {
        var record = _v0;
        return record.ZM;
    };
    var $author$project$Api$Provider$Plan$Shared$singleParentDiscountRule = function(_v0) {
        var record = _v0;
        return record.CE;
    };
    var $author$project$Api$Provider$Plan$One$singleParentDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentDiscountRule(shared);
    };
    var $author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer = F3(function(type_, defaultIfMissing, maybePlan) {
        return function(_v1) {
            var discountRule = _v1.a;
            var defaultIfMissing_ = _v1.b;
            var _v2 = _Utils_Tuple2(discountRule, defaultIfMissing_);
            if (!_v2.a.$) {
                var discountRule_ = _v2.a.a;
                return $elm$core$Maybe$Just({
                    Jo: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents(discountRule_)),
                    Jp: $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited(discountRule_),
                    vw: false,
                    Ux: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents(discountRule_)),
                    Uy: $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited(discountRule_),
                    zm: false,
                    XY: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents(discountRule_)),
                    XZ: $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited(discountRule_),
                    By: false,
                    ZL: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents(discountRule_)),
                    ZM: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited(discountRule_),
                    Cp: false,
                    ah5: type_
                });
            } else if (_v2.b) {
                var _v3 = _v2.a;
                return $elm$core$Maybe$Just($author$project$Components$Plan$Form$FamilyDiscountRuleField$empty(type_));
            } else {
                var _v4 = _v2.a;
                return $elm$core$Maybe$Nothing;
            }
        }(function() {
            switch(type_){
                case 0:
                    return _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$coupleDiscountRule, maybePlan), defaultIfMissing);
                case 1:
                    return _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$singleParentDiscountRule, maybePlan), defaultIfMissing);
                case 2:
                    return _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$familyDiscountRule, maybePlan), defaultIfMissing);
                case 3:
                    return _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$additionalAdultDiscountRule, maybePlan), defaultIfMissing);
                case 4:
                    return _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$additionalChildDiscountRule, maybePlan), defaultIfMissing);
                default:
                    return _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Plan$One$childrenOnlyDiscountRule, maybePlan), defaultIfMissing);
            }
        }());
    });
    var $author$project$Api$Provider$PricingVersion$Shared$additionalAdultDiscountRule = function(_v0) {
        var record = _v0;
        return record.tQ;
    };
    var $author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$additionalAdultDiscountRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$additionalChildDiscountRule = function(_v0) {
        var record = _v0;
        return record.tR;
    };
    var $author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$additionalChildDiscountRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$childrenOnlyDiscountRule = function(_v0) {
        var record = _v0;
        return record.wb;
    };
    var $author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$childrenOnlyDiscountRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$coupleDiscountRule = function(_v0) {
        var record = _v0;
        return record.wX;
    };
    var $author$project$Api$Provider$PricingVersion$One$coupleDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$coupleDiscountRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$familyDiscountRule = function(_v0) {
        var record = _v0;
        return record.xG;
    };
    var $author$project$Api$Provider$PricingVersion$One$familyDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$familyDiscountRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$singleParentDiscountRule = function(_v0) {
        var record = _v0;
        return record.CE;
    };
    var $author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$singleParentDiscountRule(shared);
    };
    var $author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServerAndPricingVersion = F3(function(type_, defaultIfMissing, pricingVersion) {
        return function(_v1) {
            var discountRule = _v1.a;
            var defaultIfMissing_ = _v1.b;
            var _v2 = _Utils_Tuple2(discountRule, defaultIfMissing_);
            if (!_v2.a.$) {
                var discountRule_ = _v2.a.a;
                return $elm$core$Maybe$Just({
                    Jo: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCents(discountRule_)),
                    Jp: $author$project$Api$Provider$DiscountRule$Shared$annualMaximumInCentsEdited(discountRule_),
                    vw: false,
                    Ux: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCents(discountRule_)),
                    Uy: $author$project$Api$Provider$DiscountRule$Shared$monthMaximumInCentsEdited(discountRule_),
                    zm: false,
                    XY: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCents(discountRule_)),
                    XZ: $author$project$Api$Provider$DiscountRule$Shared$quarterMaximumInCentsEdited(discountRule_),
                    By: false,
                    ZL: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCents(discountRule_)),
                    ZM: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualMaximumInCentsEdited(discountRule_),
                    Cp: false,
                    ah5: type_
                });
            } else if (_v2.b) {
                var _v3 = _v2.a;
                return $elm$core$Maybe$Just($author$project$Components$Plan$Form$FamilyDiscountRuleField$empty(type_));
            } else {
                var _v4 = _v2.a;
                return $elm$core$Maybe$Nothing;
            }
        }(function() {
            switch(type_){
                case 0:
                    return _Utils_Tuple2($author$project$Api$Provider$PricingVersion$One$coupleDiscountRule(pricingVersion), defaultIfMissing);
                case 1:
                    return _Utils_Tuple2($author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule(pricingVersion), defaultIfMissing);
                case 2:
                    return _Utils_Tuple2($author$project$Api$Provider$PricingVersion$One$familyDiscountRule(pricingVersion), defaultIfMissing);
                case 3:
                    return _Utils_Tuple2($author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule(pricingVersion), defaultIfMissing);
                case 4:
                    return _Utils_Tuple2($author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule(pricingVersion), defaultIfMissing);
                default:
                    return _Utils_Tuple2($author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule(pricingVersion), defaultIfMissing);
            }
        }());
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule = F3(function(maybePricingVersion, discountRuleType, plan) {
        if (!maybePricingVersion.$) {
            var pricingVersion = maybePricingVersion.a;
            return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServerAndPricingVersion, discountRuleType, false, pricingVersion);
        } else return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, discountRuleType, false, $elm$core$Maybe$Just(plan));
    });
    var $author$project$Api$Provider$Plan$Meta$additionalAdultDiscountRuleRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.tQ.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$additionalChildDiscountRuleRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.tR.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$childrenAgeLimitRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.wa.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$childrenOnlyDiscountRuleRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.wb.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$coupleDiscountRuleRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.wX.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$familyDiscountRuleRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.xG.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$familyNumChildrenIncludedRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.xH.OM;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$numberAdditionalChildrenAllowed = function(_v0) {
        var record = _v0;
        return record.zP;
    };
    var $author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$numberAdditionalChildrenAllowed(shared);
    };
    var $author$project$Api$Provider$Plan$Meta$numberAdditionalChildrenAllowedRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.zP.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$singleParentDiscountRuleRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.CE.OM;
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initRules = F2(function(meta, maybePricingVersion) {
        var pricingVersionHas = function(accessor) {
            if (!maybePricingVersion.$) {
                var pv = maybePricingVersion.a;
                var _v2 = accessor(pv);
                if (!_v2.$) return true;
                else return false;
            } else return false;
        };
        if (!maybePricingVersion.$) return {
            tQ: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$additionalAdultDiscountRule)
            },
            tR: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$additionalChildDiscountRule)
            },
            wa: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$childrenAgeLimit)
            },
            wb: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$childrenOnlyDiscountRule)
            },
            wX: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$coupleDiscountRule)
            },
            xG: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$familyDiscountRule)
            },
            xH: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded)
            },
            zP: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed)
            },
            CE: {
                OM: pricingVersionHas($author$project$Api$Provider$PricingVersion$One$singleParentDiscountRule)
            }
        };
        else return {
            tQ: {
                OM: $author$project$Api$Provider$Plan$Meta$additionalAdultDiscountRuleRuleEnabled(meta)
            },
            tR: {
                OM: $author$project$Api$Provider$Plan$Meta$additionalChildDiscountRuleRuleEnabled(meta)
            },
            wa: {
                OM: $author$project$Api$Provider$Plan$Meta$childrenAgeLimitRuleEnabled(meta)
            },
            wb: {
                OM: $author$project$Api$Provider$Plan$Meta$childrenOnlyDiscountRuleRuleEnabled(meta)
            },
            wX: {
                OM: $author$project$Api$Provider$Plan$Meta$coupleDiscountRuleRuleEnabled(meta)
            },
            xG: {
                OM: $author$project$Api$Provider$Plan$Meta$familyDiscountRuleRuleEnabled(meta)
            },
            xH: {
                OM: $author$project$Api$Provider$Plan$Meta$familyNumChildrenIncludedRuleEnabled(meta)
            },
            zP: {
                OM: $author$project$Api$Provider$Plan$Meta$numberAdditionalChildrenAllowedRuleEnabled(meta)
            },
            CE: {
                OM: $author$project$Api$Provider$Plan$Meta$singleParentDiscountRuleRuleEnabled(meta)
            }
        };
    });
    var $author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed = function(_v0) {
        var record = _v0.b;
        return record.zP;
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField = F3(function(maybePricingVersion, pricingVersionGetter, planValue) {
        if (!maybePricingVersion.$) {
            var pricingVersion = maybePricingVersion.a;
            return pricingVersionGetter(pricingVersion);
        } else return planValue;
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill = F2(function(plan, maybePricingVersion) {
        var singleParentDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 1, plan);
        var numberAdditionalChildrenAllowed = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField, maybePricingVersion, $author$project$Api$Provider$PricingVersion$One$numberAdditionalChildrenAllowed, $author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed(plan));
        var familyNumChildrenIncluded = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField, maybePricingVersion, $author$project$Api$Provider$PricingVersion$One$familyNumChildrenIncluded, $author$project$Api$Provider$Plan$One$familyNumChildrenIncluded(plan));
        var familyDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 2, plan);
        var coupleDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 0, plan);
        var childrenOnlyDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 5, plan);
        var childrenAgeLimit = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$resolveIntField, maybePricingVersion, $author$project$Api$Provider$PricingVersion$One$childrenAgeLimit, $author$project$Api$Provider$Plan$One$childrenAgeLimit(plan));
        var additionalChildDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 4, plan);
        var additionalAdultDiscountRule = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$getDiscountRule, maybePricingVersion, 3, plan);
        return $author$project$Utils$Form$init({
            tQ: additionalAdultDiscountRule,
            tR: additionalChildDiscountRule,
            wa: childrenAgeLimit,
            wb: childrenOnlyDiscountRule,
            wX: coupleDiscountRule,
            xG: familyDiscountRule,
            xH: familyNumChildrenIncluded,
            zP: numberAdditionalChildrenAllowed,
            Zk: A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$initRules, $author$project$Api$Provider$Plan$One$meta(plan), maybePricingVersion),
            CE: singleParentDiscountRule
        });
    });
    var $author$project$Api$Provider$PricingVersion$Shared$appliesGroupDiscountInTiers = function(_v0) {
        var record = _v0;
        return record.Jy;
    };
    var $author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$appliesGroupDiscountInTiers(shared);
    };
    var $author$project$Api$Provider$Plan$One$familyNumAdultsIncluded = function(_v0) {
        var record = _v0.b;
        return record.Pq;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$familyNumAdultsIncluded = function(_v0) {
        var record = _v0;
        return record.Pq;
    };
    var $author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$familyNumAdultsIncluded(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var record = _v0;
        return record.Pu;
    };
    var $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var record = _v0;
        return record.Pu;
    };
    var $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Provider$Plan$One$fixedChildrenAgeLimit = function(_v0) {
        var record = _v0.b;
        return record.PO;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$fixedChildrenAgeLimit = function(_v0) {
        var record = _v0;
        return record.PO;
    };
    var $author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$fixedChildrenAgeLimit(shared);
    };
    var $author$project$Api$Provider$Plan$One$groupPricingFamilyNumChildrenIncluded = function(_v0) {
        var record = _v0.b;
        return record.Qg;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$groupPricingFamilyNumChildrenIncluded = function(_v0) {
        var record = _v0;
        return record.Qg;
    };
    var $author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$groupPricingFamilyNumChildrenIncluded(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$additionalAdultRateRule = function(_v0) {
        var record = _v0;
        return record.ID;
    };
    var $author$project$Api$Provider$Plan$One$additionalAdultRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$additionalAdultRateRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$additionalAdultRateRule = function(_v0) {
        var record = _v0;
        return record.ID;
    };
    var $author$project$Api$Provider$PricingVersion$One$additionalAdultRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$additionalAdultRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$additionalChildRateRule = function(_v0) {
        var record = _v0;
        return record.IE;
    };
    var $author$project$Api$Provider$Plan$One$additionalChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$additionalChildRateRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$additionalChildRateRule = function(_v0) {
        var record = _v0;
        return record.IE;
    };
    var $author$project$Api$Provider$PricingVersion$One$additionalChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$additionalChildRateRule(shared);
    };
    var $author$project$Api$Provider$RateRule$Shared$annualAmountInCents = function(_v0) {
        var record = _v0;
        return record.dc.Jk;
    };
    var $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited = function(_v0) {
        var record = _v0;
        return record.dc.e3;
    };
    var $author$project$Api$Provider$Plan$Shared$coupleRateRule = function(_v0) {
        var record = _v0;
        return record.Mh;
    };
    var $author$project$Api$Provider$Plan$One$coupleRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$coupleRateRule = function(_v0) {
        var record = _v0;
        return record.Mh;
    };
    var $author$project$Api$Provider$PricingVersion$One$coupleRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$coupleRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$familyRateRule = function(_v0) {
        var record = _v0;
        return record.Pr;
    };
    var $author$project$Api$Provider$Plan$One$familyRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$familyRateRule = function(_v0) {
        var record = _v0;
        return record.Pr;
    };
    var $author$project$Api$Provider$PricingVersion$One$familyRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$familyRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule = function(_v0) {
        var record = _v0;
        return record.Pt;
    };
    var $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRule = function(_v0) {
        var record = _v0;
        return record.Pt;
    };
    var $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$familyWithSingleChildRateRule(shared);
    };
    var $author$project$Components$Plan$Form$FixedRateRuleField$getRateRule = F4(function(planGetter, pricingVersionGetter, plan, maybePricingVersion) {
        if (!maybePricingVersion.$) {
            var pricingVersion = maybePricingVersion.a;
            return pricingVersionGetter(pricingVersion);
        } else return planGetter(plan);
    });
    var $author$project$Api$Provider$Plan$Shared$individualRateRule = function(_v0) {
        var record = _v0;
        return record.Rb;
    };
    var $author$project$Api$Provider$Plan$One$individualRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$individualRateRule = function(_v0) {
        var record = _v0;
        return record.Rb;
    };
    var $author$project$Api$Provider$PricingVersion$One$individualRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$individualRateRule(shared);
    };
    var $author$project$Api$Provider$RateRule$Shared$monthAmountInCents = function(_v0) {
        var record = _v0;
        return record.dc.Uu;
    };
    var $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited = function(_v0) {
        var record = _v0;
        return record.dc.gb;
    };
    var $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents = function(_v0) {
        var record = _v0;
        return record.dc.XU;
    };
    var $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited = function(_v0) {
        var record = _v0;
        return record.dc.gx;
    };
    var $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents = function(_v0) {
        var record = _v0;
        return record.dc.ZH;
    };
    var $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited = function(_v0) {
        var record = _v0;
        return record.dc.gM;
    };
    var $author$project$Api$Provider$Plan$Shared$singleParentRateRule = function(_v0) {
        var record = _v0;
        return record._w;
    };
    var $author$project$Api$Provider$Plan$One$singleParentRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$singleParentRateRule = function(_v0) {
        var record = _v0;
        return record._w;
    };
    var $author$project$Api$Provider$PricingVersion$One$singleParentRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$singleParentRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule = function(_v0) {
        var record = _v0;
        return record._y;
    };
    var $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRule = function(_v0) {
        var record = _v0;
        return record._y;
    };
    var $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRule(shared);
    };
    var $author$project$Components$Plan$Form$FixedRateRuleField$initFromServer = F4(function(defaultPeriod, type_, plan, maybePricingVersion) {
        var rateRule = function() {
            switch(type_.$){
                case 0:
                    return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$individualRateRule, $author$project$Api$Provider$PricingVersion$One$individualRateRule, plan, maybePricingVersion);
                case 1:
                    return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$coupleRateRule, $author$project$Api$Provider$PricingVersion$One$coupleRateRule, plan, maybePricingVersion);
                case 2:
                    return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$singleParentRateRule, $author$project$Api$Provider$PricingVersion$One$singleParentRateRule, plan, maybePricingVersion);
                case 3:
                    return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$familyRateRule, $author$project$Api$Provider$PricingVersion$One$familyRateRule, plan, maybePricingVersion);
                case 4:
                    return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule, $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRule, plan, maybePricingVersion);
                case 5:
                    return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule, $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRule, plan, maybePricingVersion);
                case 6:
                    return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$additionalAdultRateRule, $author$project$Api$Provider$PricingVersion$One$additionalAdultRateRule, plan, maybePricingVersion);
                case 7:
                    return A4($author$project$Components$Plan$Form$FixedRateRuleField$getRateRule, $author$project$Api$Provider$Plan$One$additionalChildRateRule, $author$project$Api$Provider$PricingVersion$One$additionalChildRateRule, plan, maybePricingVersion);
                case 8:
                    return $elm$core$Maybe$Nothing;
                case 9:
                    return $elm$core$Maybe$Nothing;
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }();
        return function(fixedRateRule) {
            var baseAmountInCents = function() {
                switch(type_.$){
                    case 0:
                        return 8000;
                    case 1:
                        return 10000;
                    case 2:
                        return 13000;
                    case 3:
                        return 20000;
                    case 4:
                        return 11000;
                    case 5:
                        return 16000;
                    case 6:
                        return 10000;
                    case 7:
                        return 10000;
                    case 8:
                        return 0;
                    case 9:
                        return 0;
                    default:
                        return 0;
                }
            }();
            switch(defaultPeriod){
                case 'month':
                    return _Utils_update(fixedRateRule, {
                        Uu: $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, $author$project$Currency$fromInt(baseAmountInCents), fixedRateRule.Uu))
                    });
                case 'annual':
                    return _Utils_update(fixedRateRule, {
                        Jk: $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, $author$project$Currency$fromInt(baseAmountInCents * 12), fixedRateRule.Jk))
                    });
                default:
                    return fixedRateRule;
            }
        }({
            Jk: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$annualAmountInCents, rateRule)),
            e3: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited, rateRule)),
            Jl: false,
            Uu: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$monthAmountInCents, rateRule)),
            gb: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited, rateRule)),
            Gl: false,
            XU: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents, rateRule)),
            gx: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited, rateRule)),
            XV: false,
            ZH: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents, rateRule)),
            gM: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited, rateRule)),
            ZI: false,
            ah5: type_
        });
    });
    var $author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.Pq.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.PO.OM;
    };
    var $author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled = function(_v0) {
        var meta = _v0;
        return meta.Zk.Qg.OM;
    };
    var $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var record = _v0;
        return record._z;
    };
    var $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var record = _v0;
        return record._z;
    };
    var $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$initRules = F2(function(plan, maybePricingVersion) {
        var ruleEnabled = F2(function(pvAccessor, planDefault) {
            if (!maybePricingVersion.$) {
                var pv = maybePricingVersion.a;
                return pvAccessor(pv);
            } else return planDefault;
        });
        var meta = $author$project$Api$Provider$Plan$One$meta(plan);
        return {
            Pq: {
                OM: A2(ruleEnabled, function(pv) {
                    return !_Utils_eq($author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded(pv), $elm$core$Maybe$Nothing);
                }, $author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled(meta))
            },
            Pt: {
                OM: A2(ruleEnabled, $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled, $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan))
            },
            PO: {
                OM: A2(ruleEnabled, function(pv) {
                    return !_Utils_eq($author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit(pv), $elm$core$Maybe$Nothing);
                }, $author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled(meta))
            },
            Qg: {
                OM: A2(ruleEnabled, function(pv) {
                    return !_Utils_eq($author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded(pv), $elm$core$Maybe$Nothing);
                }, $author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled(meta))
            },
            _y: {
                OM: A2(ruleEnabled, $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled, $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan))
            }
        };
    });
    var $author$project$Api$Provider$Plan$One$splitRevenueType = function(_v0) {
        var record = _v0.b;
        return record._P;
    };
    var $author$project$Api$Provider$PricingVersion$Shared$splitRevenueType = function(_v0) {
        var record = _v0;
        return record._P;
    };
    var $author$project$Api$Provider$PricingVersion$One$splitRevenueType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$splitRevenueType(shared);
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$initFromServer = F2(function(plan, maybePricingVersion) {
        var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
        var familyRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Family, plan, maybePricingVersion);
        var familyWithSingleChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$FamilyWithSingleChild, plan, maybePricingVersion);
        var individualRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Individual, plan, maybePricingVersion);
        var singleParentRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$SingleParent, plan, maybePricingVersion);
        var singleParentWithSingleChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$SingleParentWithSingleChild, plan, maybePricingVersion);
        var coupleRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$Couple, plan, maybePricingVersion);
        var additionalChildRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$AdditionalChild, plan, maybePricingVersion);
        var additionalAdultRateRule = A4($author$project$Components$Plan$Form$FixedRateRuleField$initFromServer, defaultPeriod, $author$project$Api$RateRuleType$AdditionalAdult, plan, maybePricingVersion);
        return $author$project$Utils$Form$init({
            ID: additionalAdultRateRule,
            IE: additionalChildRateRule,
            Jy: function() {
                if (!maybePricingVersion.$) {
                    var pv = maybePricingVersion.a;
                    return A2($elm$core$Maybe$withDefault, false, $author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers(pv));
                } else return A2($elm$core$Maybe$withDefault, false, $author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan));
            }(),
            Mh: coupleRateRule,
            Pq: function() {
                if (!maybePricingVersion.$) {
                    var pv = maybePricingVersion.a;
                    return $author$project$Api$Provider$PricingVersion$One$familyNumAdultsIncluded(pv);
                } else return $author$project$Api$Provider$Plan$One$familyNumAdultsIncluded(plan);
            }(),
            Pr: familyRateRule,
            Pt: familyWithSingleChildRateRule,
            Pu: A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan), A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$familyWithSingleChildRateRuleEnabled, maybePricingVersion)),
            PO: function() {
                if (!maybePricingVersion.$) {
                    var pv = maybePricingVersion.a;
                    return $author$project$Api$Provider$PricingVersion$One$fixedChildrenAgeLimit(pv);
                } else return $author$project$Api$Provider$Plan$One$fixedChildrenAgeLimit(plan);
            }(),
            Qg: function() {
                if (!maybePricingVersion.$) {
                    var pv = maybePricingVersion.a;
                    return $author$project$Api$Provider$PricingVersion$One$groupPricingFamilyNumChildrenIncluded(pv);
                } else return $author$project$Api$Provider$Plan$One$groupPricingFamilyNumChildrenIncluded(plan);
            }(),
            Rb: individualRateRule,
            Zk: A2($author$project$Components$Plan$Form$GroupTierPricingFields$initRules, plan, maybePricingVersion),
            _w: singleParentRateRule,
            _y: singleParentWithSingleChildRateRule,
            _z: A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan), A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingVersion$One$singleParentWithSingleChildRateRuleEnabled, maybePricingVersion)),
            _P: function() {
                if (!maybePricingVersion.$) {
                    var pv = maybePricingVersion.a;
                    return A2($elm$core$Maybe$withDefault, 'even_children', $author$project$Api$Provider$PricingVersion$One$splitRevenueType(pv));
                } else return A2($elm$core$Maybe$withDefault, 'even_children', $author$project$Api$Provider$Plan$One$splitRevenueType(plan));
            }()
        });
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$fill = F2(function(plan, maybePricingVersion) {
        return A2($author$project$Components$Plan$Form$GroupTierPricingFields$initFromServer, plan, maybePricingVersion);
    });
    var $author$project$Api$Provider$PricingVersion$Shared$ageRateRules = function(_v0) {
        var record = _v0;
        return record.I_;
    };
    var $author$project$Api$Provider$PricingVersion$One$ageRateRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$ageRateRules(shared);
    };
    var $author$project$Components$Plan$Form$AgeRateRuleField$empty = {
        Mg: $elm$core$Maybe$Nothing,
        P_: 0,
        dc: {
            Jk: $elm$core$Maybe$Nothing,
            e3: false,
            Jl: false,
            Uu: $elm$core$Maybe$Just($author$project$Currency$zero),
            gb: false,
            Gl: false,
            XU: $elm$core$Maybe$Nothing,
            gx: false,
            XV: false,
            ZH: $elm$core$Maybe$Nothing,
            gM: false,
            ZI: false
        },
        $4: $elm$core$Maybe$Nothing,
        aaG: 0
    };
    var $author$project$Currency$multiply = F2(function(_int, currency) {
        return A2($elm$core$Maybe$withDefault, currency, A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$map, $elm$core$Basics$mul(_int), $author$project$Currency$toInt(currency))));
    });
    var $author$project$Components$Plan$Form$AgeRateRuleField$default = function(defaultPeriod) {
        var defaultAmount = $author$project$Currency$fromInt(5000);
        if (defaultPeriod === 'month') {
            var updatedPeriodRates = $author$project$Components$Plan$Form$AgeRateRuleField$empty.dc;
            return _Utils_update($author$project$Components$Plan$Form$AgeRateRuleField$empty, {
                dc: _Utils_update(updatedPeriodRates, {
                    Uu: $elm$core$Maybe$Just(defaultAmount)
                })
            });
        } else {
            var updatedPeriodRates = $author$project$Components$Plan$Form$AgeRateRuleField$empty.dc;
            return _Utils_update($author$project$Components$Plan$Form$AgeRateRuleField$empty, {
                dc: _Utils_update(updatedPeriodRates, {
                    Jk: $elm$core$Maybe$Just(A2($author$project$Currency$multiply, 12, defaultAmount))
                })
            });
        }
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules = function(defaultPeriod) {
        return _List_fromArray([
            $author$project$Components$Plan$Form$AgeRateRuleField$default(defaultPeriod)
        ]);
    };
    var $author$project$Components$Plan$Form$AgeRateRuleField$convertCoupleAgeRateRule = function(serverCoupleRule) {
        return {
            dc: {
                Jk: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.dc.Jk),
                e3: serverCoupleRule.dc.e3,
                Jl: false,
                Uu: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.dc.Uu),
                gb: serverCoupleRule.dc.gb,
                Gl: false,
                XU: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.dc.XU),
                gx: serverCoupleRule.dc.gx,
                XV: false,
                ZH: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, serverCoupleRule.dc.ZH),
                gM: serverCoupleRule.dc.gM,
                ZI: false
            }
        };
    };
    var $author$project$Api$Provider$RateRule$Shared$coupleAgeRateRule = function(_v0) {
        var record = _v0;
        return record.Mg;
    };
    var $author$project$Api$Provider$RateRule$Shared$unit = function(_v0) {
        var record = _v0;
        return record.aaG;
    };
    var $author$project$Components$Plan$Form$AgeRateRuleField$initFromServer = function(ageRateRule) {
        return {
            Mg: A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$AgeRateRuleField$convertCoupleAgeRateRule, $author$project$Api$Provider$RateRule$Shared$coupleAgeRateRule(ageRateRule)),
            P_: $author$project$Api$Provider$RateRule$Shared$fromAge(ageRateRule),
            dc: {
                Jk: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$RateRule$Shared$annualAmountInCents(ageRateRule)),
                e3: $author$project$Api$Provider$RateRule$Shared$annualAmountInCentsEdited(ageRateRule),
                Jl: false,
                Uu: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$RateRule$Shared$monthAmountInCents(ageRateRule)),
                gb: $author$project$Api$Provider$RateRule$Shared$monthAmountInCentsEdited(ageRateRule),
                Gl: false,
                XU: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents(ageRateRule)),
                gx: $author$project$Api$Provider$RateRule$Shared$quarterAmountInCentsEdited(ageRateRule),
                XV: false,
                ZH: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents(ageRateRule)),
                gM: $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCentsEdited(ageRateRule),
                ZI: false
            },
            $4: $author$project$Api$Provider$RateRule$Shared$toAge(ageRateRule),
            aaG: $author$project$Api$Provider$RateRule$Shared$unit(ageRateRule)
        };
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill = F2(function(plan, maybePricingVersion) {
        var planType = $author$project$Api$Provider$Plan$One$planType(plan);
        var ageRateRules = function() {
            if (!maybePricingVersion.$) {
                var pricingVersion = maybePricingVersion.a;
                return A2($elm$core$List$map, $author$project$Components$Plan$Form$AgeRateRuleField$initFromServer, $author$project$Api$Provider$PricingVersion$One$ageRateRules(pricingVersion));
            } else return A2($elm$core$List$map, $author$project$Components$Plan$Form$AgeRateRuleField$initFromServer, $author$project$Api$Provider$Plan$One$ageRateRules(plan));
        }();
        return $author$project$Utils$Form$init({
            I_: function() {
                if (planType !== 1 && $elm$core$List$isEmpty(ageRateRules)) {
                    var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
                    return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules(defaultPeriod);
                } else return ageRateRules;
            }()
        });
    });
    var $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents = function(_v0) {
        var record = _v0;
        return record.Jk;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited = function(_v0) {
        var record = _v0;
        return record.e3;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$isDestroyable = function(_v0) {
        var record = _v0;
        return record.R1;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents = function(_v0) {
        var record = _v0;
        return record.Uu;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited = function(_v0) {
        var record = _v0;
        return record.gb;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents = function(_v0) {
        var record = _v0;
        return record.XU;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited = function(_v0) {
        var record = _v0;
        return record.gx;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents = function(_v0) {
        var record = _v0;
        return record.ZH;
    };
    var $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited = function(_v0) {
        var record = _v0;
        return record.gM;
    };
    var $author$project$Components$Plan$Form$SpecialRateField$initFromServer = function(specialRate) {
        return {
            Jk: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(specialRate)),
            e3: $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited(specialRate),
            Jl: false,
            Mw: false,
            NU: false,
            aef: $elm$core$Maybe$Just($author$project$Api$Provider$SpecialRate$Shared$id(specialRate)),
            R1: $author$project$Api$Provider$SpecialRate$Shared$isDestroyable(specialRate),
            Uu: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(specialRate)),
            gb: $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited(specialRate),
            Gl: false,
            zr: $author$project$Api$Provider$SpecialRate$Shared$name(specialRate),
            XU: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(specialRate)),
            gx: $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited(specialRate),
            XV: false,
            ZH: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(specialRate)),
            gM: $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited(specialRate),
            ZI: false
        };
    };
    var $author$project$Api$Provider$Plan$Shared$specialRates = function(_v0) {
        var record = _v0;
        return record._M;
    };
    var $author$project$Api$Provider$Plan$One$specialRates = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$specialRates = function(_v0) {
        var record = _v0;
        return record._M;
    };
    var $author$project$Api$Provider$PricingVersion$One$specialRates = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$specialRates(shared);
    };
    var $author$project$Components$Plan$Form$SpecialRateField$updateFromServer = F2(function(serverSpecialRates, specialRate) {
        var matchingServerSpecialRate = A2($elm_community$list_extra$List$Extra$find, function(serverSpecialRate) {
            return _Utils_eq(specialRate.zr, $author$project$Api$Provider$SpecialRate$Shared$name(serverSpecialRate));
        }, serverSpecialRates);
        if (!matchingServerSpecialRate.$) {
            var matchingServerSpecialRate_ = matchingServerSpecialRate.a;
            return _Utils_update(specialRate, {
                Jk: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(matchingServerSpecialRate_)),
                e3: $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCentsEdited(matchingServerSpecialRate_),
                Jl: false,
                aef: $elm$core$Maybe$Just($author$project$Api$Provider$SpecialRate$Shared$id(matchingServerSpecialRate_)),
                R1: $author$project$Api$Provider$SpecialRate$Shared$isDestroyable(matchingServerSpecialRate_),
                Uu: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(matchingServerSpecialRate_)),
                gb: $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCentsEdited(matchingServerSpecialRate_),
                Gl: false,
                XU: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(matchingServerSpecialRate_)),
                gx: $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCentsEdited(matchingServerSpecialRate_),
                XV: false,
                ZH: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(matchingServerSpecialRate_)),
                gM: $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCentsEdited(matchingServerSpecialRate_),
                ZI: false
            });
        } else return specialRate;
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$initFromServer = F3(function(currentSpecialRates, plan, maybePricingVersion) {
        var serverSpecialRates = function() {
            if (!maybePricingVersion.$) {
                var pricingVersion = maybePricingVersion.a;
                return $author$project$Api$Provider$PricingVersion$One$specialRates(pricingVersion);
            } else return $author$project$Api$Provider$Plan$One$specialRates(plan);
        }();
        var specialRates = function() {
            if (!currentSpecialRates.$) {
                var currentSpecialRates_ = currentSpecialRates.a;
                return A2($elm$core$List$map, $author$project$Components$Plan$Form$SpecialRateField$updateFromServer(serverSpecialRates), currentSpecialRates_);
            } else return A2($elm$core$List$map, $author$project$Components$Plan$Form$SpecialRateField$initFromServer, serverSpecialRates);
        }();
        return $author$project$Utils$Form$init({
            _M: specialRates
        });
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$fill = F2(function(plan, maybePricingVersion) {
        return A3($author$project$Components$Plan$Form$SpecialRatesFields$initFromServer, $elm$core$Maybe$Nothing, plan, maybePricingVersion);
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$fillWithCurrent = F3(function(currentSpecialRates, plan, maybePricingVersion) {
        return A3($author$project$Components$Plan$Form$SpecialRatesFields$initFromServer, $elm$core$Maybe$Just(currentSpecialRates), plan, maybePricingVersion);
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$formFields = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm = F3(function(maybeCurrentForm, plan, maybePricingVersion) {
        if (!maybeCurrentForm.$) {
            var currentForm = maybeCurrentForm.a;
            var currentSpecialRates = $author$project$Components$Plan$Form$SpecialRatesFields$formFields(currentForm)._M;
            return A3($author$project$Components$Plan$Form$SpecialRatesFields$fillWithCurrent, currentSpecialRates, plan, maybePricingVersion);
        } else return A2($author$project$Components$Plan$Form$SpecialRatesFields$fill, plan, maybePricingVersion);
    });
    var $author$project$Api$Provider$Plan$Shared$groupDiscountRules = function(_v0) {
        var record = _v0;
        return record.Qd;
    };
    var $author$project$Api$Provider$Plan$One$groupDiscountRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$groupDiscountRules(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$groupPricingType = function(_v0) {
        var record = _v0;
        return record.Qh;
    };
    var $author$project$Api$Provider$Plan$One$groupPricingType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
    };
    var $author$project$Components$Plan$Form$PlanChange$init = {
        bW: false,
        VU: {
            K2: $elm$core$Maybe$Nothing,
            K3: $elm$core$Maybe$Nothing,
            L6: $elm$core$Maybe$Nothing,
            aef: $elm$core$Maybe$Nothing,
            $5: $elm$core$Maybe$Nothing,
            ah5: 1
        },
        jN: false
    };
    var $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCents = function(_v0) {
        var record = _v0;
        return record.Jm;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCentsEdited = function(_v0) {
        var record = _v0;
        return record.Jn;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$annualPercentOff = function(_v0) {
        var record = _v0;
        return record.Js;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$annualPercentOffEdited = function(_v0) {
        var record = _v0;
        return record.Jt;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$calculatedBy = function(_v0) {
        var record = _v0;
        return record.KD;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$fromSize = function(_v0) {
        var record = _v0;
        return record.P0;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCents = function(_v0) {
        var record = _v0;
        return record.Uv;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCentsEdited = function(_v0) {
        var record = _v0;
        return record.Uw;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$monthPercentOff = function(_v0) {
        var record = _v0;
        return record.UC;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$monthPercentOffEdited = function(_v0) {
        var record = _v0;
        return record.UD;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCents = function(_v0) {
        var record = _v0;
        return record.XW;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCentsEdited = function(_v0) {
        var record = _v0;
        return record.XX;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOff = function(_v0) {
        var record = _v0;
        return record.X0;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOffEdited = function(_v0) {
        var record = _v0;
        return record.X1;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCents = function(_v0) {
        var record = _v0;
        return record.ZJ;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCentsEdited = function(_v0) {
        var record = _v0;
        return record.ZK;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOff = function(_v0) {
        var record = _v0;
        return record.ZP;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOffEdited = function(_v0) {
        var record = _v0;
        return record.ZQ;
    };
    var $author$project$Api$Provider$DiscountRule$Shared$toSize = function(_v0) {
        var record = _v0;
        return record.$6;
    };
    var $author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer = function(groupDiscountRule) {
        return {
            Jm: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCents(groupDiscountRule)),
            Jn: $author$project$Api$Provider$DiscountRule$Shared$annualAmountOffInCentsEdited(groupDiscountRule),
            Eh: false,
            Js: A2($elm$core$Maybe$map, $author$project$Percentage$fromFloat, $author$project$Api$Provider$DiscountRule$Shared$annualPercentOff(groupDiscountRule)),
            Jt: $author$project$Api$Provider$DiscountRule$Shared$annualPercentOffEdited(groupDiscountRule),
            py: false,
            KD: $author$project$Api$Provider$DiscountRule$Shared$calculatedBy(groupDiscountRule),
            P0: $author$project$Api$Provider$DiscountRule$Shared$fromSize(groupDiscountRule),
            Uv: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCents(groupDiscountRule)),
            Uw: $author$project$Api$Provider$DiscountRule$Shared$monthAmountOffInCentsEdited(groupDiscountRule),
            Gm: false,
            UC: A2($elm$core$Maybe$map, $author$project$Percentage$fromFloat, $author$project$Api$Provider$DiscountRule$Shared$monthPercentOff(groupDiscountRule)),
            UD: $author$project$Api$Provider$DiscountRule$Shared$monthPercentOffEdited(groupDiscountRule),
            m9: false,
            XW: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCents(groupDiscountRule)),
            XX: $author$project$Api$Provider$DiscountRule$Shared$quarterAmountOffInCentsEdited(groupDiscountRule),
            G9: false,
            X0: A2($elm$core$Maybe$map, $author$project$Percentage$fromFloat, $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOff(groupDiscountRule)),
            X1: $author$project$Api$Provider$DiscountRule$Shared$quarterPercentOffEdited(groupDiscountRule),
            so: false,
            ZJ: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCents(groupDiscountRule)),
            ZK: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualAmountOffInCentsEdited(groupDiscountRule),
            Ho: false,
            ZP: A2($elm$core$Maybe$map, $author$project$Percentage$fromFloat, $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOff(groupDiscountRule)),
            ZQ: $author$project$Api$Provider$DiscountRule$Shared$semiAnnualPercentOffEdited(groupDiscountRule),
            sM: false,
            $6: $author$project$Api$Provider$DiscountRule$Shared$toSize(groupDiscountRule)
        };
    };
    var $author$project$Components$Plan$Form$initRules = function(meta) {
        return {
            Pq: {
                OM: $author$project$Api$Provider$Plan$Meta$familyNumAdultsIncludedRuleEnabled(meta)
            },
            PO: {
                OM: $author$project$Api$Provider$Plan$Meta$fixedChildrenAgeLimitRuleEnabled(meta)
            },
            Qg: {
                OM: $author$project$Api$Provider$Plan$Meta$groupPricingFamilyNumChildrenIncludedRuleEnabled(meta)
            }
        };
    };
    var $author$project$Api$Provider$Plan$One$iua = function(_v0) {
        var record = _v0.b;
        return record.SI;
    };
    var $author$project$Api$Provider$Plan$Shared$maximumAge = function(_v0) {
        var record = _v0;
        return record.TQ;
    };
    var $author$project$Api$Provider$Plan$One$maximumAge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$minimumAge = function(_v0) {
        var record = _v0;
        return record.Un;
    };
    var $author$project$Api$Provider$Plan$One$minimumAge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
    };
    var $author$project$Api$Provider$Plan$One$pricingEffectivenessType = function(_v0) {
        var record = _v0.b;
        return record.Xo;
    };
    var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeInCents = function(_v0) {
        var record = _v0;
        return record.aab;
    };
    var $author$project$Api$Provider$Plan$One$tobaccoSurchargeInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeInCents(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargePercentage = function(_v0) {
        var record = _v0;
        return record.aac;
    };
    var $author$project$Api$Provider$Plan$One$tobaccoSurchargePercentage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargePercentage(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType = function(_v0) {
        var record = _v0;
        return record.aad;
    };
    var $author$project$Api$Provider$Plan$One$tobaccoSurchargeType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
    };
    var $author$project$Components$Plan$Form$initFormFields = F4(function(apiClient, model, currentPlanChange, plan) {
        var planType = $author$project$Api$Provider$Plan$One$planType(plan);
        var minimumAge = $author$project$Api$Provider$Plan$One$minimumAge(plan);
        var membershipPricingForm = A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
        var maximumAge = $author$project$Api$Provider$Plan$One$maximumAge(plan);
        var groupTierPricingForm = A2($author$project$Components$Plan$Form$GroupTierPricingFields$fill, plan, $elm$core$Maybe$Nothing);
        var groupDiscountRules = A2($elm$core$List$map, $author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer, $author$project$Api$Provider$Plan$One$groupDiscountRules(plan));
        var familyPricingForm = A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
        var currentSpecialRatesForm = A2($elm$core$Maybe$map, function($) {
            return $.dj;
        }, A2($elm$core$Maybe$map, $author$project$Utils$Form$fields, A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.PU)));
        var specialRatesForm = A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, currentSpecialRatesForm, plan, $elm$core$Maybe$Nothing);
        var coveragePlan = function() {
            var _v2 = $author$project$Api$Provider$Plan$One$coveragePlan(plan);
            if (!_v2.$ && !_v2.a.$) {
                var coveragePlan_ = _v2.a.a;
                return $elm$core$Maybe$Just($author$project$Components$Plan$Form$CoveragePlanOne(coveragePlan_));
            } else return $elm$core$Maybe$Nothing;
        }();
        var _v0 = model;
        var practice = _v0.W1;
        var _v1 = A6($author$project$Components$Plan$BasicForm$fill, practice, plan, model.W4, A2($author$project$Utils$User$isViewingAsHinter, model.Z$, model.aeb), $elm$core$Maybe$Just(_Utils_Tuple2(apiClient, model.Z$)), $elm$core$Maybe$Nothing);
        var basicPlanForm = _v1.a;
        var basicPlanFormCmd = _v1.b;
        return _Utils_Tuple2({
            Jy: A2($elm$core$Maybe$withDefault, false, $author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan)),
            aB: basicPlanForm,
            L4: $author$project$Api$Provider$Plan$One$contractEmailsEnabled(plan),
            L5: $author$project$Api$Provider$Plan$One$contractExpires(plan),
            L6: $author$project$Api$Provider$Plan$One$contractPeriodInMonths(plan),
            L7: $author$project$Api$Provider$Plan$One$contractRenewalEmailLeadTime(plan),
            EW: $author$project$Api$Provider$Plan$One$contractType(plan),
            Mn: coveragePlan,
            xm: $author$project$Api$Provider$Plan$One$discountsEnabled(plan),
            xo: !_Utils_eq(maximumAge, $elm$core$Maybe$Nothing) && !_Utils_eq(maximumAge, $elm$core$Maybe$Just(0)),
            xp: !_Utils_eq(minimumAge, $elm$core$Maybe$Nothing) && !_Utils_eq(minimumAge, $elm$core$Maybe$Just(0)),
            cY: familyPricingForm,
            Qd: function() {
                if (planType !== 1 && $elm$core$List$isEmpty(groupDiscountRules)) {
                    var defaultPeriod = $author$project$Api$Provider$Plan$One$defaultPeriod(plan);
                    return $author$project$Components$Plan$Form$defaultGroupRules(defaultPeriod);
                } else return groupDiscountRules;
            }(),
            Qh: $author$project$Api$Provider$Plan$One$groupPricingType(plan),
            i: groupTierPricingForm,
            SI: $author$project$Api$Provider$Plan$One$iua(plan),
            TQ: maximumAge,
            c$: membershipPricingForm,
            Un: minimumAge,
            jw: A2($elm$core$Maybe$withDefault, $author$project$Components$Plan$Form$PlanChange$init, currentPlanChange),
            Xo: $author$project$Api$Provider$Plan$One$pricingEffectivenessType(plan),
            Zk: $author$project$Components$Plan$Form$initRules($author$project$Api$Provider$Plan$One$meta(plan)),
            dj: specialRatesForm,
            aab: $elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Provider$Plan$One$tobaccoSurchargeInCents(plan))),
            aac: $elm$core$Maybe$Just($author$project$Percentage$fromFloat($author$project$Api$Provider$Plan$One$tobaccoSurchargePercentage(plan))),
            aad: $author$project$Api$Provider$Plan$One$tobaccoSurchargeType(plan)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$BasicPlanFormUpdated, basicPlanFormCmd));
    });
    var $author$project$Components$ResourceFilter$Plan$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Plan$EmployerAll = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Plan$ProviderAll = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Employer$Plan$All$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Plan$Shared$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Plan$Shared$Record = function(id) {
        return function(name) {
            return function(planType) {
                return function(allowedBillingPeriodCodes) {
                    return function(defaultPeriodInMonths) {
                        return function(defaultPeriod) {
                            return function(maximumAge) {
                                return function(minimumAge) {
                                    return function(tobaccoSurchargeType) {
                                        return function(groupPricingType) {
                                            return function(maxRegistrationFeeInCents) {
                                                return function(individualRegistrationFeeInCents) {
                                                    return function(billsAtEndOfPeriod) {
                                                        return function(minimumEnrollmentPeriodInMonths) {
                                                            return function(ageRateRules) {
                                                                return function(individualRateRule) {
                                                                    return function(coupleRateRule) {
                                                                        return function(singleParentWithSingleChildRateRuleEnabled) {
                                                                            return function(singleParentWithSingleChildRateRule) {
                                                                                return function(singleParentRateRule) {
                                                                                    return function(familyWithSingleChildRateRuleEnabled) {
                                                                                        return function(familyWithSingleChildRateRule) {
                                                                                            return function(familyRateRule) {
                                                                                                return function(sponsorFeeDeal) {
                                                                                                    return {
                                                                                                        I_: ageRateRules,
                                                                                                        Ef: allowedBillingPeriodCodes,
                                                                                                        Kh: billsAtEndOfPeriod,
                                                                                                        Mh: coupleRateRule,
                                                                                                        Nx: defaultPeriod,
                                                                                                        Ny: defaultPeriodInMonths,
                                                                                                        Pr: familyRateRule,
                                                                                                        Pt: familyWithSingleChildRateRule,
                                                                                                        Pu: familyWithSingleChildRateRuleEnabled,
                                                                                                        Qh: groupPricingType,
                                                                                                        aef: id,
                                                                                                        Rb: individualRateRule,
                                                                                                        Rd: individualRegistrationFeeInCents,
                                                                                                        TN: maxRegistrationFeeInCents,
                                                                                                        TQ: maximumAge,
                                                                                                        Un: minimumAge,
                                                                                                        Up: minimumEnrollmentPeriodInMonths,
                                                                                                        zr: name,
                                                                                                        WN: planType,
                                                                                                        _w: singleParentRateRule,
                                                                                                        _y: singleParentWithSingleChildRateRule,
                                                                                                        _z: singleParentWithSingleChildRateRuleEnabled,
                                                                                                        _S: sponsorFeeDeal,
                                                                                                        aad: tobaccoSurchargeType
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$RateRule$Shared$RateRule = $elm$core$Basics$identity;
    var $author$project$Api$Employer$RateRule$Shared$Record = F8(function(type_, fromAge, toAge, unit, monthAmountInCents, quarterAmountInCents, semiAnnualAmountInCents, annualAmountInCents) {
        return {
            Jk: annualAmountInCents,
            P_: fromAge,
            Uu: monthAmountInCents,
            XU: quarterAmountInCents,
            ZH: semiAnnualAmountInCents,
            $4: toAge,
            ah5: type_,
            aaG: unit
        };
    });
    var $author$project$Api$Employer$RateRule$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'annual_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'semi_annual_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quarter_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'month_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'unit', A2($elm$json$Json$Decode$map, $author$project$Api$Provider$RateRule$Shared$stringToUnit, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'from_age', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$RateRuleType$decode, $elm$json$Json$Decode$succeed($author$project$Api$Employer$RateRule$Shared$Record)))))))));
    var $author$project$Api$Employer$RateRule$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$RateRule$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$SponsorFeeDeal$Shared$SponsorFeeDeal = $elm$core$Basics$identity;
    var $author$project$Api$Employer$SponsorFeeDeal$Shared$Record = function(amountInCents) {
        return {
            Jh: amountInCents
        };
    };
    var $author$project$Api$Employer$SponsorFeeDeal$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Employer$SponsorFeeDeal$Shared$Record));
    var $author$project$Api$Employer$SponsorFeeDeal$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$SponsorFeeDeal$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Plan$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'sponsor_fee_deal', $elm$json$Json$Decode$nullable($author$project$Api$Employer$SponsorFeeDeal$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'family_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'family_with_single_child_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'family_with_single_child_rate_rule_enabled', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'single_parent_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'single_parent_with_single_child_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'single_parent_with_single_child_rate_rule_enabled', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'couple_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'individual_rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Employer$RateRule$Shared$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'age_rate_rules', $elm$json$Json$Decode$list($author$project$Api$Employer$RateRule$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_enrollment_period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bills_at_end_of_period', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'individual_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'group_pricing_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tobacco_surcharge_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'maximum_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_period', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allowed_billing_period_codes', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan_type', $author$project$Api$PlanType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Plan$Shared$Record)))))))))))))))))))))))));
    var $author$project$Api$Employer$Plan$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Plan$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Plan$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Plan$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Plan$listDefaults = {
        agq: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Employer$Plan$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Employer$Plan$listDefaults);
        var _v0 = options.agq;
        if (!_v0.$) {
            var string = _v0.a;
            return _List_fromArray([
                A2($author$project$Api$Param$string, 'q', string)
            ]);
        } else return _List_Nil;
    };
    var $author$project$Api$Employer$Plan$plansPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'plans'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Plan$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$Plan$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Employer$Plan$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$Plan$plansPath)));
    });
    var $author$project$Api$Provider$Plan$All$Plan = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Plan$All$Record = F6(function(defaultPeriod, maxRegistrationFeeInCents, individualRegistrationFeeInCents, contractExpires, contractPeriodInMonths, contractType) {
        return {
            L5: contractExpires,
            L6: contractPeriodInMonths,
            EW: contractType,
            Nx: defaultPeriod,
            Rd: individualRegistrationFeeInCents,
            TN: maxRegistrationFeeInCents
        };
    });
    var $author$project$Api$Provider$Plan$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_type', $elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_expires', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'individual_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_period', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$All$Record)))))));
    var $author$project$Api$Provider$Plan$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$All$Plan)));
    var $author$project$Api$Provider$Plan$listDefaults = {
        Em: $elm$core$Maybe$Nothing,
        En: $elm$core$Maybe$Nothing,
        Eo: $elm$core$Maybe$Nothing,
        Kh: $elm$core$Maybe$Nothing,
        Fq: _List_Nil,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        A8: _List_Nil,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$PlanType$toString = function(planType) {
        switch(planType){
            case 0:
                return 'company';
            case 1:
                return 'sponsor_fixed_fee';
            case 2:
                return 'retail';
            case 3:
                return 'mce';
            default:
                return 'affiliate_dependable';
        }
    };
    var $author$project$Api$Provider$Plan$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Plan$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            $elm$core$List$isEmpty(options.A8) ? _List_Nil : _List_fromArray([
                A2($author$project$Api$Param$string, 'plan_type', A2($elm$core$String$join, ',', A2($elm$core$List$map, $author$project$Api$PlanType$toString, options.A8)))
            ]),
            _List_fromArray([
                A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, options.Fq))
            ]),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v2 = options.Eo;
                if (!_v2.$) {
                    var coveragePlanId = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'available_for_coverage_plan', coveragePlanId)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.En;
                if (!_v3.$) {
                    var companyId = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'available_for_company', companyId)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.Em;
                if (!_v4.$) {
                    var affiliateId = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'available_for_affiliation', affiliateId)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.Kh;
                if (!_v5.$) {
                    var bool = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'bills_at_end_of_period', bool)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Provider$Plan$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Plan$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Plan$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
    });
    var $author$project$Api$Plan$list = F4(function(apiClient, session, optionals, toMsg) {
        if ($author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
            var options = optionals($author$project$Api$Provider$Plan$listDefaults);
            return A3($author$project$Api$Employer$Plan$list, apiClient, function(d) {
                return _Utils_update(d, {
                    agq: options.agq
                });
            }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Plan$EmployerAll))));
        } else return A3($author$project$Api$Provider$Plan$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Plan$ProviderAll))));
    });
    var $author$project$Components$ResourceFilter$Plan$list = $author$project$Api$Plan$list;
    var $author$project$Components$ResourceFilter$Plan$fetchResources = F6(function(session, listOptionals, toMsg, apiClient, pagination, query) {
        return A4($author$project$Components$ResourceFilter$Plan$list, apiClient, session, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$Plan$retrieveResource = F5(function(session, listOptionals, toMsg, apiClient, id) {
        return A4($author$project$Components$ResourceFilter$Plan$list, apiClient, session, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$Plan$selectId = 'plans';
    var $author$project$Components$ResourceFilter$Plan$toTitle = $author$project$Api$Plan$name;
    var $author$project$Components$ResourceFilter$Plan$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Plan$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$Plan$toValue = $author$project$Api$Plan$id;
    var $author$project$Components$ResourceFilter$Plan$init = F4(function(apiClient, session, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: A2($author$project$Components$ResourceFilter$Plan$fetchResources, session, listOptionals),
            aef: $author$project$Components$ResourceFilter$Plan$selectId,
            gD: 'Plan',
            sz: A2($author$project$Components$ResourceFilter$Plan$retrieveResource, session, listOptionals),
            ahW: $author$project$Components$ResourceFilter$Plan$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Plan$toTitle,
            g4: $author$project$Components$ResourceFilter$Plan$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Plan$Form$initPlanChangeToPlanResourceFilter = F3(function(apiClient, session, planType) {
        return A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                A8: _List_fromArray([
                    planType
                ])
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Plan'
            });
        });
    });
    var $author$project$Components$Plan$Form$resetParamsOnScope = F3(function(apiClient, response, model) {
        if (response.$ === 3) {
            var plan = response.a;
            var planType = $author$project$Api$Provider$Plan$One$planType(plan);
            var planChangeEnabled = A2($author$project$Utils$FeatureGate$gateAvailable, 6, $author$project$Api$Practice$Provider(model.W1)) && !planType || planType === 2 || planType === 3;
            var currentPlanChange = A2($elm$core$Maybe$map, function($) {
                return $.jw;
            }, A2($elm$core$Maybe$map, $author$project$Utils$Form$fields, A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.PU)));
            var _v1 = planChangeEnabled && _Utils_eq(model.gt, $elm$core$Maybe$Nothing) ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A3($author$project$Components$Plan$Form$initPlanChangeToPlanResourceFilter, apiClient, model.Z$, planType)) : _Utils_Tuple2(model.gt, $elm$core$Platform$Cmd$none);
            var planChangeToPlanResourceFilter = _v1.a;
            var planChangeToPlanResourceFilterCmd = _v1.b;
            var _v2 = A4($author$project$Components$Plan$Form$initFormFields, apiClient, model, currentPlanChange, plan);
            var formFields = _v2.a;
            var formFieldsCmd = _v2.b;
            return _Utils_Tuple3(_Utils_update(model, {
                PU: $elm$core$Maybe$Just(_Utils_Tuple2(plan, $author$project$Utils$Form$init(formFields))),
                F6: response,
                jx: planChangeEnabled,
                gt: planChangeToPlanResourceFilter
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg, planChangeToPlanResourceFilterCmd),
                formFieldsCmd
            ])), _List_Nil);
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
    });
    var $author$project$Components$Plan$Form$SubsequentPlanDeleted = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Plan$SubsequentPlan$delete = F3(function(apiClient, planId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId)));
    });
    var $author$project$Components$Plan$Form$PlanUpdated = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('plan', $author$project$Api$Provider$Plan$encodeUpdateFields(fields))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$planPath(id))));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$formFields = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields = function(_v0) {
        var form = _v0;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Percentage$zero = '0';
    var $author$project$Components$Plan$Form$updatePlanFields = function(formFields) {
        var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(formFields.c$);
        var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(formFields.cY);
        var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(formFields.aB);
        var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.de);
        return {
            tQ: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.tQ.OM ? familyMembershipPricingFormFields.tQ : $elm$core$Maybe$Nothing),
            ID: function() {
                if ($author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Zk.Pq.OM) {
                    var additionalAdultRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).ID;
                    return $elm$core$Maybe$Just({
                        Jk: additionalAdultRateRule.Jk,
                        e3: additionalAdultRateRule.e3,
                        Uu: additionalAdultRateRule.Uu,
                        gb: additionalAdultRateRule.gb,
                        XU: additionalAdultRateRule.XU,
                        gx: additionalAdultRateRule.gx,
                        ZH: additionalAdultRateRule.ZH,
                        gM: additionalAdultRateRule.gM
                    });
                } else {
                    if (formFields.Qh === 'family' && !_Utils_eq(familyMembershipPricingFormFields.tQ, $elm$core$Maybe$Nothing)) return A2($elm$core$Maybe$map, function(familyDiscountRule) {
                        return {
                            Jk: familyDiscountRule.Jo,
                            e3: familyDiscountRule.Jp,
                            Uu: familyDiscountRule.Ux,
                            gb: familyDiscountRule.Uy,
                            XU: familyDiscountRule.XY,
                            gx: familyDiscountRule.XZ,
                            ZH: familyDiscountRule.ZL,
                            gM: familyDiscountRule.ZM
                        };
                    }, familyMembershipPricingFormFields.tQ);
                    else return $elm$core$Maybe$Nothing;
                }
            }(),
            tR: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.tR.OM ? familyMembershipPricingFormFields.tR : $elm$core$Maybe$Nothing),
            IE: function() {
                if ($author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Zk.Qg.OM) {
                    var additionalChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).IE;
                    return $elm$core$Maybe$Just({
                        Jk: additionalChildRateRule.Jk,
                        e3: additionalChildRateRule.e3,
                        Uu: additionalChildRateRule.Uu,
                        gb: additionalChildRateRule.gb,
                        XU: additionalChildRateRule.XU,
                        gx: additionalChildRateRule.gx,
                        ZH: additionalChildRateRule.ZH,
                        gM: additionalChildRateRule.gM
                    });
                } else {
                    if (formFields.Qh === 'family' && !_Utils_eq(familyMembershipPricingFormFields.tR, $elm$core$Maybe$Nothing)) return A2($elm$core$Maybe$map, function(familyDiscountRule) {
                        return {
                            Jk: familyDiscountRule.Jo,
                            e3: familyDiscountRule.Jp,
                            Uu: familyDiscountRule.Ux,
                            gb: familyDiscountRule.Uy,
                            XU: familyDiscountRule.XY,
                            gx: familyDiscountRule.XZ,
                            ZH: familyDiscountRule.ZL,
                            gM: familyDiscountRule.ZM
                        };
                    }, familyMembershipPricingFormFields.tR);
                    else return $elm$core$Maybe$Nothing;
                }
            }(),
            IF: basicPlanFormFields.IF,
            I_: A2($elm$core$List$map, function(ageRateRule) {
                return {
                    Jk: ageRateRule.dc.Jk,
                    e3: ageRateRule.dc.e3,
                    Mg: A2($elm$core$Maybe$map, function(coupleRule) {
                        return {
                            Jk: coupleRule.dc.Jk,
                            e3: coupleRule.dc.e3,
                            Uu: coupleRule.dc.Uu,
                            gb: coupleRule.dc.gb,
                            XU: coupleRule.dc.XU,
                            gx: coupleRule.dc.gx,
                            ZH: coupleRule.dc.ZH,
                            gM: coupleRule.dc.gM
                        };
                    }, ageRateRule.Mg),
                    P_: $elm$core$Maybe$Just(ageRateRule.P_),
                    Uu: ageRateRule.dc.Uu,
                    gb: ageRateRule.dc.gb,
                    XU: ageRateRule.dc.XU,
                    gx: ageRateRule.dc.gx,
                    ZH: ageRateRule.dc.ZH,
                    gM: ageRateRule.dc.gM,
                    $4: ageRateRule.$4,
                    aaG: ageRateRule.aaG
                };
            }, membershipPricingFormFields.I_),
            vu: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.vu),
            vv: basicPlanFormFields.vv,
            Jy: formFields.Jy,
            Kh: basicPlanFormFields.Kh,
            Ky: basicPlanFormFields.Ky,
            wa: familyMembershipPricingFormFields.wa,
            wb: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.wb.OM ? familyMembershipPricingFormFields.wb : $elm$core$Maybe$Nothing),
            L4: formFields.L4,
            L5: formFields.L5,
            L6: formFields.L6,
            L7: formFields.L7,
            EW: formFields.EW,
            wX: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.wX.OM ? familyMembershipPricingFormFields.wX : $elm$core$Maybe$Nothing),
            Mh: function() {
                if (formFields.Qh === 'fixed_pricing') {
                    var coupleRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Mh;
                    return $elm$core$Maybe$Just({
                        Jk: coupleRateRule.Jk,
                        e3: coupleRateRule.e3,
                        Uu: coupleRateRule.Uu,
                        gb: coupleRateRule.gb,
                        XU: coupleRateRule.XU,
                        gx: coupleRateRule.gx,
                        ZH: coupleRateRule.ZH,
                        gM: coupleRateRule.gM
                    });
                } else return $elm$core$Maybe$Nothing;
            }(),
            Mn: A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$coveragePlanId, formFields.Mn),
            xb: basicPlanFormFields.xb,
            xc: basicPlanFormFields.xc,
            Nx: basicPlanFormFields.Nx,
            Ff: $author$project$Components$TranslatedRichText$translations(basicPlanFormFields.NQ),
            xm: formFields.xm,
            xG: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.xG.OM ? familyMembershipPricingFormFields.xG : $elm$core$Maybe$Nothing),
            Pq: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Zk.Pq.OM ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Pq : $elm$core$Maybe$Nothing,
            xH: familyMembershipPricingFormFields.xH,
            Pr: function() {
                if (formFields.Qh === 'fixed_pricing') {
                    var familyRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Pr;
                    return $elm$core$Maybe$Just({
                        Jk: familyRateRule.Jk,
                        e3: familyRateRule.e3,
                        Uu: familyRateRule.Uu,
                        gb: familyRateRule.gb,
                        XU: familyRateRule.XU,
                        gx: familyRateRule.gx,
                        ZH: familyRateRule.ZH,
                        gM: familyRateRule.gM
                    });
                } else return $elm$core$Maybe$Nothing;
            }(),
            Pt: function() {
                if (formFields.Qh === 'fixed_pricing' && $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Pu) {
                    var familyWithSingleChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Pt;
                    return $elm$core$Maybe$Just({
                        Jk: familyWithSingleChildRateRule.Jk,
                        e3: familyWithSingleChildRateRule.e3,
                        Uu: familyWithSingleChildRateRule.Uu,
                        gb: familyWithSingleChildRateRule.gb,
                        XU: familyWithSingleChildRateRule.XU,
                        gx: familyWithSingleChildRateRule.gx,
                        ZH: familyWithSingleChildRateRule.ZH,
                        gM: familyWithSingleChildRateRule.gM
                    });
                } else return $elm$core$Maybe$Nothing;
            }(),
            Pu: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Pu,
            PO: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Zk.PO.OM ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).PO : $elm$core$Maybe$Nothing,
            Qd: A2($elm$core$List$map, function(groupDiscountRule) {
                return {
                    Jm: groupDiscountRule.Jm,
                    Jn: groupDiscountRule.Jn,
                    Js: groupDiscountRule.Js,
                    Jt: groupDiscountRule.Jt,
                    KD: groupDiscountRule.KD,
                    P0: $elm$core$Maybe$Just(groupDiscountRule.P0),
                    Uv: groupDiscountRule.Uv,
                    Uw: groupDiscountRule.Uw,
                    UC: groupDiscountRule.UC,
                    UD: groupDiscountRule.UD,
                    XW: groupDiscountRule.XW,
                    XX: groupDiscountRule.XX,
                    X0: groupDiscountRule.X0,
                    X1: groupDiscountRule.X1,
                    ZJ: groupDiscountRule.ZJ,
                    ZK: groupDiscountRule.ZK,
                    ZP: groupDiscountRule.ZP,
                    ZQ: groupDiscountRule.ZQ,
                    $6: groupDiscountRule.$6
                };
            }, formFields.Qd),
            Qg: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Zk.Qg.OM ? $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Qg : $elm$core$Maybe$Nothing,
            Qh: formFields.Qh,
            Q4: basicPlanFormFields.Q4,
            Rb: function() {
                if (formFields.Qh === 'fixed_pricing') {
                    var individualRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i).Rb;
                    return $elm$core$Maybe$Just({
                        Jk: individualRateRule.Jk,
                        e3: individualRateRule.e3,
                        Uu: individualRateRule.Uu,
                        gb: individualRateRule.gb,
                        XU: individualRateRule.XU,
                        gx: individualRateRule.gx,
                        ZH: individualRateRule.ZH,
                        gM: individualRateRule.gM
                    });
                } else return $elm$core$Maybe$Nothing;
            }(),
            Rd: registrationFeeFields.Zk.Rd.OM ? registrationFeeFields.Rd : $elm$core$Maybe$Nothing,
            SI: formFields.SI,
            TN: registrationFeeFields.Zk.TN.OM ? registrationFeeFields.TN : $elm$core$Maybe$Nothing,
            TQ: formFields.TQ,
            Un: formFields.Un,
            Up: basicPlanFormFields.Up,
            zj: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.zj),
            zk: basicPlanFormFields.zk,
            zr: basicPlanFormFields.zr,
            zP: familyMembershipPricingFormFields.zP,
            Xo: formFields.Xo,
            Bw: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bw),
            Bx: basicPlanFormFields.Bx,
            BF: A2($elm$core$Maybe$andThen, function(id) {
                return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
            }, basicPlanFormFields.BF),
            BG: basicPlanFormFields.BG,
            BH: basicPlanFormFields.BH,
            Cn: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Cn),
            Co: basicPlanFormFields.Co,
            CE: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.CE.OM ? familyMembershipPricingFormFields.CE : $elm$core$Maybe$Nothing),
            _w: function() {
                if (formFields.Qh === 'fixed_pricing') {
                    var singleParentRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._w;
                    return $elm$core$Maybe$Just({
                        Jk: singleParentRateRule.Jk,
                        e3: singleParentRateRule.e3,
                        Uu: singleParentRateRule.Uu,
                        gb: singleParentRateRule.gb,
                        XU: singleParentRateRule.XU,
                        gx: singleParentRateRule.gx,
                        ZH: singleParentRateRule.ZH,
                        gM: singleParentRateRule.gM
                    });
                } else return $elm$core$Maybe$Nothing;
            }(),
            _y: function() {
                if (formFields.Qh === 'fixed_pricing' && $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._z) {
                    var singleParentWithSingleChildRateRule = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._y;
                    return $elm$core$Maybe$Just({
                        Jk: singleParentWithSingleChildRateRule.Jk,
                        e3: singleParentWithSingleChildRateRule.e3,
                        Uu: singleParentWithSingleChildRateRule.Uu,
                        gb: singleParentWithSingleChildRateRule.gb,
                        XU: singleParentWithSingleChildRateRule.XU,
                        gx: singleParentWithSingleChildRateRule.gx,
                        ZH: singleParentWithSingleChildRateRule.ZH,
                        gM: singleParentWithSingleChildRateRule.gM
                    });
                } else return $elm$core$Maybe$Nothing;
            }(),
            _z: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._z,
            _M: A2($elm$core$List$map, function(specialRate) {
                return {
                    Jk: specialRate.Jk,
                    e3: specialRate.e3,
                    Mw: specialRate.Mw,
                    NU: specialRate.NU,
                    aef: specialRate.aef,
                    Uu: specialRate.Uu,
                    gb: specialRate.gb,
                    zr: specialRate.zr,
                    XU: specialRate.XU,
                    gx: specialRate.gx,
                    ZH: specialRate.ZH,
                    gM: specialRate.gM
                };
            }, $author$project$Components$Plan$Form$SpecialRatesFields$formFields(formFields.dj)._M),
            _P: $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(formFields.i)._P,
            Hy: basicPlanFormFields.Hy,
            aab: A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, formFields.aab),
            aac: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, formFields.aac),
            aad: formFields.aad
        };
    };
    var $author$project$Components$Plan$Form$updatePlanRequest = F3(function(apiClient, id, validFields) {
        return A4($author$project$Api$Provider$Plan$update, apiClient, id, $author$project$Components$Plan$Form$updatePlanFields($rtfeldman$elm_validate$Validate$fromValid(validFields)), $author$project$Components$Plan$Form$PlanUpdated);
    });
    var $author$project$Components$Plan$Form$saveItem = F3(function(apiClient, id, validFormFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        var planChange = _v0.jw;
        return planChange.jN ? A3($author$project$Api$Provider$Plan$SubsequentPlan$delete, apiClient, id, $author$project$Components$Plan$Form$SubsequentPlanDeleted(validFormFields)) : A3($author$project$Components$Plan$Form$updatePlanRequest, apiClient, id, validFormFields);
    });
    var $author$project$Components$Plan$BasicForm$showWarningModal = function(field) {
        switch(field.$){
            case 0:
                return false;
            case 20:
                return false;
            case 21:
                return false;
            case 1:
                return false;
            case 5:
                return false;
            case 6:
                return false;
            case 7:
                return false;
            case 22:
                return false;
            case 8:
                return false;
            case 18:
                var rule = field.a;
                return false;
            case 17:
                return false;
            case 23:
                return false;
            case 24:
                return false;
            default:
                return true;
        }
    };
    var $author$project$Api$Provider$Plan$One$upcomingPricingVersion = function(_v0) {
        var record = _v0.b;
        return record.aaN;
    };
    var $author$project$Api$Provider$Plan$SubsequentPlan$update = F4(function(apiClient, planId, fields, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$SubsequentPlan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Provider$Plan$SubsequentPlan$encodeUpdateFields(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$SubsequentPlan$subsequentPlansPath(planId))));
    });
    var $author$project$Components$Plan$BasicForm$FieldUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$Image = F2(function(a, b) {
        return {
            $: 24,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$BasicForm$NoChange = {
        $: 1
    };
    var $author$project$Components$Plan$BasicForm$RegistrationFeePricingField = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId = function(_v0) {
        var form = _v0;
        return A2($elm$core$Maybe$andThen, function(id) {
            return $elm$core$String$isEmpty(id) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id);
        }, A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$Category$value, $author$project$Utils$Form$fields(form).cK));
    };
    var $author$project$Components$ResourceFilter$Category$selectedName = function(model) {
        var _v0 = model.Hg;
        switch(_v0.$){
            case 3:
                return 'Unassigned';
            case 0:
                var resource = _v0.a;
                return resource.zr;
            case 2:
                return 'All';
            default:
                return 'Unassigned';
        }
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryName = function(_v0) {
        var form = _v0;
        return A2($elm$core$Maybe$withDefault, 'Unassigned', A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Category$selectedName, $author$project$Utils$Form$fields(form).cK));
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$FieldUpdated = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$updateField = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var currency = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Rd: currency
                }), $elm$core$Platform$Cmd$none, field);
            case 1:
                var currency = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    TN: currency
                }), $elm$core$Platform$Cmd$none, field);
            default:
                var ruleType = field.a;
                if (!ruleType) {
                    var bool = !fields.Zk.Rd.OM;
                    return _Utils_Tuple3(_Utils_update(fields, {
                        Zk: {
                            Rd: {
                                OM: bool
                            },
                            TN: fields.Zk.TN
                        }
                    }), $elm$core$Platform$Cmd$none, field);
                } else {
                    var bool = !fields.Zk.TN.OM;
                    return _Utils_Tuple3(_Utils_update(fields, {
                        Zk: {
                            Rd: fields.Zk.Rd,
                            TN: {
                                OM: bool
                            }
                        }
                    }), $elm$core$Platform$Cmd$none, field);
                }
        }
    });
    var $author$project$Utils$Form$updateWithCmdAndEvent = F3(function(updater, field_, _v0) {
        var originalFields = _v0.a;
        var validated_ = _v0.b;
        var fields_ = _v0.c;
        var errors_ = _v0.d;
        var _v1 = A2(updater, field_, fields_);
        var updated = _v1.a;
        var cmd = _v1.b;
        var event = _v1.c;
        return _Utils_Tuple3(A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_), cmd, event);
    });
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$update = F3(function(apiClient, msg, _v0) {
        var form = _v0;
        if (!msg.$) {
            var field = msg.a;
            var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$RegistrationFeePricingFields$updateField, field, form);
            var newForm = _v2.a;
            var newFormCmd = _v2.b;
            var event = _v2.c;
            return {
                EQ: newFormCmd,
                adu: event,
                zi: newForm,
                at: _List_Nil
            };
        } else {
            var categoryMsg = msg.a;
            var fields = $author$project$Utils$Form$fields(form);
            var _v3 = fields.cK;
            if (!_v3.$) {
                var categoryResourceFilter = _v3.a;
                var result = A3($author$project$Components$ResourceFilter$Category$update, apiClient, categoryMsg, categoryResourceFilter);
                var newFields = _Utils_update(fields, {
                    cK: $elm$core$Maybe$Just(result.zi)
                });
                var newForm = A2($author$project$Utils$Form$set, newFields, form);
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, result.EQ),
                    adu: $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents($elm$core$Maybe$Nothing),
                    zi: newForm,
                    at: result.at
                };
            } else return {
                EQ: $elm$core$Platform$Cmd$none,
                adu: $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents($elm$core$Maybe$Nothing),
                zi: form,
                at: _List_Nil
            };
        }
    });
    var $author$project$Components$Plan$BasicForm$toggleRule = F4(function(maybePlan, rule, bool, fields) {
        var rules = fields.Zk;
        var newValue = F2(function(enabled, getter) {
            if (!maybePlan.$) {
                var plan = maybePlan.a;
                return enabled ? getter(plan) : $elm$core$Maybe$Nothing;
            } else return $elm$core$Maybe$Nothing;
        });
        return _Utils_update(fields, {
            Up: A2(newValue, bool, $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths),
            Zk: _Utils_update(rules, {
                Up: {
                    OM: bool
                }
            })
        });
    });
    var $author$project$Currency$divide = F2(function(_int, currency) {
        return A2($elm$core$Maybe$withDefault, currency, A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$map, function(currency_) {
            return currency_ / _int | 0;
        }, $author$project$Currency$toInt(currency))));
    });
    var $author$project$Components$Plan$BasicForm$resetSponsorFeeDealAmountInCents = F2(function(defaultPeriod, sponsorFeeDealAmountInCents) {
        switch(defaultPeriod){
            case 'annual':
                return A2($elm$core$Maybe$map, $author$project$Currency$multiply(12), sponsorFeeDealAmountInCents);
            case 'month':
                return A2($elm$core$Maybe$map, $author$project$Currency$divide(12), sponsorFeeDealAmountInCents);
            default:
                return sponsorFeeDealAmountInCents;
        }
    });
    var $author$project$Components$Plan$BasicForm$updateDefaultPeriod = F3(function(maybePlan, defaultPeriod, fields) {
        var sponsorFeeDealAmountInCents = function() {
            if (!maybePlan.$) {
                var plan = maybePlan.a;
                return $author$project$Api$Provider$Plan$One$planType(plan) === 1 ? A2($author$project$Components$Plan$BasicForm$resetSponsorFeeDealAmountInCents, defaultPeriod, fields.Hy) : fields.Hy;
            } else return fields.Hy;
        }();
        return _Utils_Tuple2(_Utils_update(fields, {
            Nx: defaultPeriod,
            Hy: sponsorFeeDealAmountInCents
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Plan$BasicForm$updateField = F5(function(_v0, _v1, maybePlan, field, form) {
        switch(field.$){
            case 0:
                var name = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    zr: name
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 2:
                var buyable = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Ky: buyable
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 20:
                var registrationFeeName = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    BH: registrationFeeName
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 21:
                var registrationFeeDescription = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    BG: registrationFeeDescription
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 1:
                var bool = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    IF: bool
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 3:
                var bool = field.a;
                var defaultPeriod = bool ? 'annual' : 'month';
                var _v3 = A3($author$project$Components$Plan$BasicForm$updateDefaultPeriod, maybePlan, defaultPeriod, form);
                var fields = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(fields, cmd, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 4:
                var bool = field.a;
                var _v4 = A3($author$project$Components$Plan$BasicForm$updateDefaultPeriod, maybePlan, 'month', _Utils_update(form, {
                    Kh: bool
                }));
                var fields = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(fields, cmd, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 19:
                var currency = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Hy: currency
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 5:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    xc: string
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 6:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    xb: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 7:
                return _Utils_Tuple3(_Utils_update(form, {
                    qr: true
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 22:
                return _Utils_Tuple3(_Utils_update(form, {
                    l1: true
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 8:
                return _Utils_Tuple3(_Utils_update(form, {
                    iB: !form.iB
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 9:
                var percentage = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    zj: percentage
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 10:
                var bool = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    zk: bool
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 11:
                var percentage = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Bw: percentage
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 12:
                var bool = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Bx: bool
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 13:
                var percentage = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Cn: percentage
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 14:
                var bool = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Co: bool
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 15:
                var percentage = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    vu: percentage
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 16:
                var bool = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    vv: bool
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 17:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Up: $elm$core$String$toInt(string)
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 18:
                var rule = field.a;
                var bool = field.b;
                return _Utils_Tuple3(A4($author$project$Components$Plan$BasicForm$toggleRule, maybePlan, rule, bool, form), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            case 23:
                return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
            default:
                var _int = field.a;
                var string = field.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    p7: $elm$core$Maybe$Just(string),
                    mw: _int,
                    Q4: $elm$core$Maybe$Just(string)
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$BasicForm$FieldUpdated(field));
        }
    });
    var $author$project$Components$Plan$BasicForm$update = F4(function(apiClient, msg, _v0, maybePlan) {
        var settings = _v0.a;
        var form = _v0.b;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, A3($author$project$Components$Plan$BasicForm$updateField, apiClient, settings, maybePlan), field, form);
                var newForm = _v2.a;
                var cmd = _v2.b;
                var event = _v2.c;
                return {
                    EQ: cmd,
                    adu: event,
                    zi: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
                    at: _List_Nil
                };
            case 1:
                var registrationFeeMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(form);
                var result = A3($author$project$Components$Plan$Form$RegistrationFeePricingFields$update, apiClient, registrationFeeMsg, fields.de);
                var updatedFields = _Utils_update(fields, {
                    BF: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(result.zi),
                    sr: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryName(result.zi),
                    de: result.zi
                });
                var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, result.EQ),
                    adu: function() {
                        var _v3 = result.adu;
                        var field = _v3;
                        return $author$project$Components$Plan$BasicForm$FieldUpdated($author$project$Components$Plan$BasicForm$RegistrationFeePricingField(field));
                    }(),
                    zi: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
                    at: result.at
                };
            case 3:
                var pictures = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v4) {
                    var task = _v4.a;
                    var size = _v4.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Image(size)), task);
                }, A2($elm$core$Maybe$map, function(picture) {
                    return _Utils_Tuple2($elm$file$File$toUrl(picture), $elm$file$File$size(picture));
                }, $elm$core$List$head(pictures))));
                return {
                    EQ: cmd,
                    adu: $author$project$Components$Plan$BasicForm$NoChange,
                    zi: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, form),
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(form);
                var _v5 = A3($author$project$Components$TranslatedRichText$update, 'plan-description-editor', subMsg, fields.NQ);
                var newDescription = _v5.a;
                var descCmd = _v5.b;
                var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    NQ: newDescription
                }), form);
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$BasicForm$DescriptionMsg, descCmd),
                    adu: $author$project$Components$Plan$BasicForm$NoChange,
                    zi: A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, newForm),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$Added = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$Closed = {
        $: 1
    };
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlan = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$None = {
        $: 0
    };
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate = F2(function(field, fields) {
        var coveragePlan = field;
        return _Utils_update(fields, {
            Mn: coveragePlan
        });
    });
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanValidation = 0;
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Mn;
        }, _Utils_Tuple2(0, 'Please pick a coverage plan'))
    ]));
    var $author$project$Components$ResourceFilter$CoveragePlan$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Plan$Form$AddCoveragePlanModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var coveragePlan = _v4.Mn;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: A2($elm$core$Maybe$withDefault, $author$project$Components$Plan$Form$AddCoveragePlanModal$None, A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$Added, coveragePlan)),
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Plan$Form$AddCoveragePlanModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            default:
                var subMsg = msg.a;
                var coveragePlanResourceResult = A3($author$project$Components$ResourceFilter$CoveragePlan$update, apiClient, subMsg, model.w$);
                var newForm = function() {
                    var _v5 = coveragePlanResourceResult.adu;
                    _v5$2: while(true){
                        if (!_v5.$ && !_v5.a.$) switch(_v5.a.a.$){
                            case 0:
                                var coveragePlan = _v5.a.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate, $elm$core$Maybe$Just(coveragePlan), model.PU);
                            case 2:
                                var _v6 = _v5.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$AddCoveragePlanModal$formFieldsUpdate, $elm$core$Maybe$Nothing, model.PU);
                            default:
                                break _v5$2;
                        }
                        else break _v5$2;
                    }
                    return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg, coveragePlanResourceResult.EQ),
                    adu: $author$project$Components$Plan$Form$AddCoveragePlanModal$None,
                    zi: _Utils_update(model, {
                        w$: coveragePlanResourceResult.zi,
                        PU: newForm
                    }),
                    at: coveragePlanResourceResult.at
                };
        }
    });
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$Closed = 1;
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$Confirmed = 2;
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$None = 0;
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        Wd: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 2:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            default:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$SetPeriodMaximumInCentsEdited = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingTypeToggled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$toggleRule = F4(function(rule, bool, fields, maybePlan) {
        var rules = fields.Zk;
        var newValue = F2(function(enabled, getter) {
            return enabled ? getter(maybePlan) : $elm$core$Maybe$Nothing;
        });
        switch(rule){
            case 0:
                return _Utils_update(fields, {
                    xH: A2(newValue, bool, $elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$familyNumChildrenIncluded)),
                    Zk: _Utils_update(rules, {
                        xH: {
                            OM: bool
                        }
                    })
                });
            case 1:
                return _Utils_update(fields, {
                    wX: A2(newValue, bool, function(_v1) {
                        return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 0, true, $elm$core$Maybe$Nothing);
                    }),
                    Zk: _Utils_update(rules, {
                        wX: {
                            OM: bool
                        }
                    })
                });
            case 2:
                return _Utils_update(fields, {
                    xG: A2(newValue, bool, function(_v2) {
                        return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 2, true, $elm$core$Maybe$Nothing);
                    }),
                    Zk: _Utils_update(rules, {
                        xG: {
                            OM: bool
                        }
                    })
                });
            case 3:
                return _Utils_update(fields, {
                    Zk: _Utils_update(rules, {
                        CE: {
                            OM: bool
                        }
                    }),
                    CE: A2(newValue, bool, function(_v3) {
                        return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 1, true, $elm$core$Maybe$Nothing);
                    })
                });
            case 4:
                return _Utils_update(fields, {
                    tR: A2(newValue, bool, function(_v4) {
                        return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 4, true, $elm$core$Maybe$Nothing);
                    }),
                    Zk: _Utils_update(rules, {
                        tR: {
                            OM: bool
                        }
                    })
                });
            case 5:
                return _Utils_update(fields, {
                    wb: A2(newValue, bool, function(_v5) {
                        return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 5, true, $elm$core$Maybe$Nothing);
                    }),
                    Zk: _Utils_update(rules, {
                        wb: {
                            OM: bool
                        }
                    })
                });
            case 6:
                return _Utils_update(fields, {
                    zP: A2(newValue, bool, $elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$numberAdditionalChildrenAllowed)),
                    Zk: _Utils_update(rules, {
                        zP: {
                            OM: bool
                        }
                    })
                });
            case 7:
                return _Utils_update(fields, {
                    tQ: A2(newValue, bool, function(_v6) {
                        return A3($author$project$Components$Plan$Form$FamilyDiscountRuleField$initFromServer, 3, true, $elm$core$Maybe$Nothing);
                    }),
                    Zk: _Utils_update(rules, {
                        tQ: {
                            OM: bool
                        }
                    })
                });
            default:
                return _Utils_update(fields, {
                    wa: A2(newValue, bool, $elm$core$Maybe$andThen($author$project$Api$Provider$Plan$One$childrenAgeLimit)),
                    Zk: _Utils_update(rules, {
                        wa: {
                            OM: bool
                        }
                    })
                });
        }
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField = F3(function(maybePlan, field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingTypeToggled(string));
            case 1:
                var rule = field.a;
                var bool = field.b;
                return _Utils_Tuple3(A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$toggleRule, rule, bool, fields, maybePlan), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
            case 2:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    xH: $elm$core$String$toInt(string)
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
            case 3:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    zP: $elm$core$String$toInt(string)
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
            case 4:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    wa: $elm$core$String$toInt(string)
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
            case 5:
                var type_ = field.a;
                var period = field.b;
                var currency = field.c;
                return _Utils_Tuple3(function(_v2) {
                    var getter = _v2.a;
                    var setter = _v2.b;
                    return setter(A2($elm$core$Maybe$map, function(familyDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(familyDiscountRule, {
                                    Ux: currency,
                                    Uy: true
                                });
                            case 'quarter':
                                return _Utils_update(familyDiscountRule, {
                                    XY: currency,
                                    XZ: true
                                });
                            case 'semi_annual':
                                return _Utils_update(familyDiscountRule, {
                                    ZL: currency,
                                    ZM: true
                                });
                            case 'annual':
                                return _Utils_update(familyDiscountRule, {
                                    Jo: currency,
                                    Jp: true
                                });
                            default:
                                return familyDiscountRule;
                        }
                    }, getter(fields)));
                }(function() {
                    switch(type_){
                        case 0:
                            return _Utils_Tuple2(function($) {
                                return $.wX;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    wX: familyDiscountRule
                                });
                            });
                        case 1:
                            return _Utils_Tuple2(function($) {
                                return $.CE;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    CE: familyDiscountRule
                                });
                            });
                        case 2:
                            return _Utils_Tuple2(function($) {
                                return $.xG;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    xG: familyDiscountRule
                                });
                            });
                        case 3:
                            return _Utils_Tuple2(function($) {
                                return $.tQ;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    tQ: familyDiscountRule
                                });
                            });
                        case 4:
                            return _Utils_Tuple2(function($) {
                                return $.tR;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    tR: familyDiscountRule
                                });
                            });
                        default:
                            return _Utils_Tuple2(function($) {
                                return $.wb;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    wb: familyDiscountRule
                                });
                            });
                    }
                }()), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
            case 8:
                var period = field.a;
                return _Utils_Tuple3(function(_v4) {
                    var getter = _v4.a;
                    var setter = _v4.b;
                    return setter(A2($elm$core$Maybe$map, function(familyDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(familyDiscountRule, {
                                    Uy: true
                                });
                            case 'quarter':
                                return _Utils_update(familyDiscountRule, {
                                    XZ: true
                                });
                            case 'semi_annual':
                                return _Utils_update(familyDiscountRule, {
                                    ZM: true
                                });
                            case 'annual':
                                return _Utils_update(familyDiscountRule, {
                                    Jp: true
                                });
                            default:
                                return familyDiscountRule;
                        }
                    }, getter(fields)));
                }(_Utils_Tuple2(function($) {
                    return $.xG;
                }, function(familyDiscountRule) {
                    return _Utils_update(fields, {
                        xG: familyDiscountRule
                    });
                })), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
            case 6:
                var type_ = field.a;
                var period = field.b;
                return _Utils_Tuple3(function(_v7) {
                    var getter = _v7.a;
                    var setter = _v7.b;
                    return setter(A2($elm$core$Maybe$map, function(familyDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(familyDiscountRule, {
                                    zm: true
                                });
                            case 'quarter':
                                return _Utils_update(familyDiscountRule, {
                                    By: true
                                });
                            case 'semi_annual':
                                return _Utils_update(familyDiscountRule, {
                                    Cp: true
                                });
                            case 'annual':
                                return _Utils_update(familyDiscountRule, {
                                    vw: true
                                });
                            default:
                                return familyDiscountRule;
                        }
                    }, getter(fields)));
                }(function() {
                    switch(type_){
                        case 0:
                            return _Utils_Tuple2(function($) {
                                return $.wX;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    wX: familyDiscountRule
                                });
                            });
                        case 1:
                            return _Utils_Tuple2(function($) {
                                return $.CE;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    CE: familyDiscountRule
                                });
                            });
                        case 2:
                            return _Utils_Tuple2(function($) {
                                return $.xG;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    xG: familyDiscountRule
                                });
                            });
                        case 3:
                            return _Utils_Tuple2(function($) {
                                return $.tQ;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    tQ: familyDiscountRule
                                });
                            });
                        case 4:
                            return _Utils_Tuple2(function($) {
                                return $.tR;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    tR: familyDiscountRule
                                });
                            });
                        default:
                            return _Utils_Tuple2(function($) {
                                return $.wb;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    wb: familyDiscountRule
                                });
                            });
                    }
                }()), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
            default:
                var type_ = field.a;
                var period = field.b;
                return _Utils_Tuple3(function(_v10) {
                    var getter = _v10.a;
                    var setter = _v10.b;
                    return setter(A2($elm$core$Maybe$map, function(familyDiscountRule) {
                        switch(period){
                            case 'month':
                                return _Utils_update(familyDiscountRule, {
                                    Uy: false,
                                    zm: false
                                });
                            case 'quarter':
                                return _Utils_update(familyDiscountRule, {
                                    XZ: false,
                                    By: false
                                });
                            case 'semi_annual':
                                return _Utils_update(familyDiscountRule, {
                                    ZM: false,
                                    Cp: false
                                });
                            case 'annual':
                                return _Utils_update(familyDiscountRule, {
                                    Jp: false,
                                    vw: false
                                });
                            default:
                                return familyDiscountRule;
                        }
                    }, getter(fields)));
                }(function() {
                    switch(type_){
                        case 0:
                            return _Utils_Tuple2(function($) {
                                return $.wX;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    wX: familyDiscountRule
                                });
                            });
                        case 1:
                            return _Utils_Tuple2(function($) {
                                return $.CE;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    CE: familyDiscountRule
                                });
                            });
                        case 2:
                            return _Utils_Tuple2(function($) {
                                return $.xG;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    xG: familyDiscountRule
                                });
                            });
                        case 3:
                            return _Utils_Tuple2(function($) {
                                return $.tQ;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    tQ: familyDiscountRule
                                });
                            });
                        case 4:
                            return _Utils_Tuple2(function($) {
                                return $.tR;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    tR: familyDiscountRule
                                });
                            });
                        default:
                            return _Utils_Tuple2(function($) {
                                return $.wb;
                            }, function(familyDiscountRule) {
                                return _Utils_update(fields, {
                                    wb: familyDiscountRule
                                });
                            });
                    }
                }()), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FieldUpdated(field));
        }
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$update = F3(function(msg, _v0, maybePlan) {
        var form = _v0;
        if (!msg.$) {
            var field = msg.a;
            var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField(maybePlan), field, form);
            var newForm = _v2.a;
            var newFormCmd = _v2.b;
            var event = _v2.c;
            return {
                EQ: newFormCmd,
                adu: event,
                zi: newForm,
                at: _List_Nil
            };
        } else {
            var defaultPeriod = msg.a;
            var _v3 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateField(maybePlan), $author$project$Components$Plan$Form$FamilyMembershipPricingFields$SetPeriodMaximumInCentsEdited(defaultPeriod), form);
            var newForm = _v3.a;
            var newFormCmd = _v3.b;
            var event = _v3.c;
            return {
                EQ: newFormCmd,
                adu: event,
                zi: newForm,
                at: _List_Nil
            };
        }
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$SetAllRateRulePeriodAmountInCentsEdited = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedMembershipPricingToggled = {
        $: 1
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited = F2(function(period, rateRule) {
        switch(period){
            case 'month':
                return _Utils_update(rateRule, {
                    gb: true
                });
            case 'quarter':
                return _Utils_update(rateRule, {
                    gx: true
                });
            case 'semi_annual':
                return _Utils_update(rateRule, {
                    gM: true
                });
            case 'annual':
                return _Utils_update(rateRule, {
                    e3: true
                });
            default:
                return rateRule;
        }
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$updateField = F3(function(_v0, field, fields) {
        switch(field.$){
            case 0:
                var rateRule = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Rb: rateRule
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 1:
                var rateRule = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Mh: rateRule
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 2:
                var rateRule = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Pr: rateRule
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 3:
                var rateRule = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _w: rateRule
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 4:
                var rateRule = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _y: rateRule
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 5:
                var rateRule = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Pt: rateRule
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 6:
                var rateRule = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    ID: rateRule
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 7:
                var rateRule = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    IE: rateRule
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 8:
                var age = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    PO: age
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 9:
                var adults = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Pq: adults
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 10:
                var children = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Qg: children
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 11:
                var revenueType = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _P: revenueType
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 14:
                var enabled = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _z: enabled
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 15:
                var enabled = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Pu: enabled
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
            case 12:
                var ruleType = field.a;
                switch(ruleType){
                    case 0:
                        var rules = fields.Zk;
                        var bool = !rules.PO.OM;
                        return _Utils_Tuple3(_Utils_update(fields, {
                            Zk: _Utils_update(rules, {
                                PO: {
                                    OM: bool
                                }
                            })
                        }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
                    case 1:
                        var rules = fields.Zk;
                        var bool = !rules.Pq.OM;
                        return _Utils_Tuple3(_Utils_update(fields, {
                            Zk: _Utils_update(rules, {
                                Pq: {
                                    OM: bool
                                }
                            })
                        }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
                    default:
                        var rules = fields.Zk;
                        var bool = !rules.Qg.OM;
                        return _Utils_Tuple3(_Utils_update(fields, {
                            Zk: _Utils_update(rules, {
                                Qg: {
                                    OM: bool
                                }
                            })
                        }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
                }
            case 13:
                return _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedMembershipPricingToggled);
            case 16:
                var type_ = field.a;
                var period = field.b;
                var currency = field.c;
                return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)), A2($elm$core$Maybe$map, function(_v4) {
                    var getter = _v4.a;
                    var setter = _v4.b;
                    var fixedRateRule = getter(fields);
                    var updatedFixedRateRule = function() {
                        switch(period){
                            case 'month':
                                return _Utils_update(fixedRateRule, {
                                    Uu: currency,
                                    gb: true
                                });
                            case 'quarter':
                                return _Utils_update(fixedRateRule, {
                                    XU: currency,
                                    gx: true
                                });
                            case 'semi_annual':
                                return _Utils_update(fixedRateRule, {
                                    ZH: currency,
                                    gM: true
                                });
                            case 'annual':
                                return _Utils_update(fixedRateRule, {
                                    Jk: currency,
                                    e3: true
                                });
                            default:
                                return fixedRateRule;
                        }
                    }();
                    var rateRuleUpdatedEvent = function() {
                        switch(type_.$){
                            case 0:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated(updatedFixedRateRule);
                            case 1:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated(updatedFixedRateRule);
                            case 2:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated(updatedFixedRateRule);
                            case 3:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated(updatedFixedRateRule);
                            case 4:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated(updatedFixedRateRule);
                            case 5:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated(updatedFixedRateRule);
                            case 6:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated(updatedFixedRateRule);
                            case 7:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated(updatedFixedRateRule);
                            default:
                                return field;
                        }
                    }();
                    return _Utils_Tuple3(setter(updatedFixedRateRule), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(rateRuleUpdatedEvent));
                }, function() {
                    switch(type_.$){
                        case 0:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Rb;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Rb: fixedRateRule
                                });
                            }));
                        case 1:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Mh;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Mh: fixedRateRule
                                });
                            }));
                        case 2:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $._w;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    _w: fixedRateRule
                                });
                            }));
                        case 3:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Pr;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Pr: fixedRateRule
                                });
                            }));
                        case 4:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $._y;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    _y: fixedRateRule
                                });
                            }));
                        case 5:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Pt;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Pt: fixedRateRule
                                });
                            }));
                        case 6:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.ID;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    ID: fixedRateRule
                                });
                            }));
                        case 7:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.IE;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    IE: fixedRateRule
                                });
                            }));
                        case 8:
                            return $elm$core$Maybe$Nothing;
                        case 9:
                            return $elm$core$Maybe$Nothing;
                        default:
                            return $elm$core$Maybe$Nothing;
                    }
                }()));
            case 17:
                var type_ = field.a;
                var period = field.b;
                return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)), A2($elm$core$Maybe$map, function(_v8) {
                    var getter = _v8.a;
                    var setter = _v8.b;
                    var fixedRateRule = getter(fields);
                    var updatedFixedRateRule = function() {
                        switch(period){
                            case 'month':
                                return _Utils_update(fixedRateRule, {
                                    Gl: true
                                });
                            case 'quarter':
                                return _Utils_update(fixedRateRule, {
                                    XV: true
                                });
                            case 'semi_annual':
                                return _Utils_update(fixedRateRule, {
                                    ZI: true
                                });
                            case 'annual':
                                return _Utils_update(fixedRateRule, {
                                    Jl: true
                                });
                            default:
                                return fixedRateRule;
                        }
                    }();
                    return _Utils_Tuple3(setter(updatedFixedRateRule), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
                }, function() {
                    switch(type_.$){
                        case 0:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Rb;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Rb: fixedRateRule
                                });
                            }));
                        case 1:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Mh;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Mh: fixedRateRule
                                });
                            }));
                        case 2:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $._w;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    _w: fixedRateRule
                                });
                            }));
                        case 3:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Pr;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Pr: fixedRateRule
                                });
                            }));
                        case 4:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $._y;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    _y: fixedRateRule
                                });
                            }));
                        case 5:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Pt;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Pt: fixedRateRule
                                });
                            }));
                        case 6:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.ID;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    ID: fixedRateRule
                                });
                            }));
                        case 7:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.IE;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    IE: fixedRateRule
                                });
                            }));
                        case 8:
                            return $elm$core$Maybe$Nothing;
                        case 9:
                            return $elm$core$Maybe$Nothing;
                        default:
                            return $elm$core$Maybe$Nothing;
                    }
                }()));
            case 18:
                var type_ = field.a;
                var period = field.b;
                return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field)), A2($elm$core$Maybe$map, function(_v11) {
                    var getter = _v11.a;
                    var setter = _v11.b;
                    var fixedRateRule = getter(fields);
                    var updatedFixedRateRule = function() {
                        switch(period){
                            case 'month':
                                return _Utils_update(fixedRateRule, {
                                    Uu: $elm$core$Maybe$Nothing,
                                    gb: false,
                                    Gl: false
                                });
                            case 'quarter':
                                return _Utils_update(fixedRateRule, {
                                    XU: $elm$core$Maybe$Nothing,
                                    gx: false,
                                    XV: false
                                });
                            case 'semi_annual':
                                return _Utils_update(fixedRateRule, {
                                    ZH: $elm$core$Maybe$Nothing,
                                    gM: false,
                                    ZI: false
                                });
                            case 'annual':
                                return _Utils_update(fixedRateRule, {
                                    Jk: $elm$core$Maybe$Nothing,
                                    e3: false,
                                    Jl: false
                                });
                            default:
                                return fixedRateRule;
                        }
                    }();
                    var rateRuleUpdatedEvent = function() {
                        switch(type_.$){
                            case 0:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$IndividualRateRuleUpdated(updatedFixedRateRule);
                            case 1:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$CoupleRateRuleUpdated(updatedFixedRateRule);
                            case 2:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentRateRuleUpdated(updatedFixedRateRule);
                            case 3:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyRateRuleUpdated(updatedFixedRateRule);
                            case 4:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleUpdated(updatedFixedRateRule);
                            case 5:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleUpdated(updatedFixedRateRule);
                            case 6:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalAdultRateRuleUpdated(updatedFixedRateRule);
                            case 7:
                                return $author$project$Components$Plan$Form$GroupTierPricingFields$AdditionalChildRateRuleUpdated(updatedFixedRateRule);
                            default:
                                return field;
                        }
                    }();
                    return _Utils_Tuple3(setter(updatedFixedRateRule), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(rateRuleUpdatedEvent));
                }, function() {
                    switch(type_.$){
                        case 0:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Rb;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Rb: fixedRateRule
                                });
                            }));
                        case 1:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Mh;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Mh: fixedRateRule
                                });
                            }));
                        case 2:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $._w;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    _w: fixedRateRule
                                });
                            }));
                        case 3:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Pr;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Pr: fixedRateRule
                                });
                            }));
                        case 4:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $._y;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    _y: fixedRateRule
                                });
                            }));
                        case 5:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.Pt;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    Pt: fixedRateRule
                                });
                            }));
                        case 6:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.ID;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    ID: fixedRateRule
                                });
                            }));
                        case 7:
                            return $elm$core$Maybe$Just(_Utils_Tuple2(function($) {
                                return $.IE;
                            }, function(fixedRateRule) {
                                return _Utils_update(fields, {
                                    IE: fixedRateRule
                                });
                            }));
                        case 8:
                            return $elm$core$Maybe$Nothing;
                        case 9:
                            return $elm$core$Maybe$Nothing;
                        default:
                            return $elm$core$Maybe$Nothing;
                    }
                }()));
            default:
                var defaultPeriod = field.a;
                var updatedFields = _Utils_update(fields, {
                    ID: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.ID),
                    IE: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.IE),
                    Mh: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.Mh),
                    Pr: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.Pr),
                    Pt: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.Pt),
                    Rb: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields.Rb),
                    _w: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields._w),
                    _y: A2($author$project$Components$Plan$Form$GroupTierPricingFields$setRateRulePeriodEdited, defaultPeriod, fields._y)
                });
                return _Utils_Tuple3(updatedFields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$GroupTierPricingFields$FieldUpdated(field));
        }
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$update = F3(function(sharedFields, msg, _v0) {
        var form = _v0;
        if (!msg.$) {
            var field = msg.a;
            var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$GroupTierPricingFields$updateField(sharedFields), field, form);
            var newForm = _v2.a;
            var newFormCmd = _v2.b;
            var event = _v2.c;
            return {
                EQ: newFormCmd,
                adu: event,
                zi: newForm,
                at: _List_Nil
            };
        } else {
            var defaultPeriod = msg.a;
            var _v3 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$GroupTierPricingFields$updateField(sharedFields), $author$project$Components$Plan$Form$GroupTierPricingFields$SetAllRateRulePeriodAmountInCentsEdited(defaultPeriod), form);
            var newForm = _v3.a;
            var newFormCmd = _v3.b;
            var event = _v3.c;
            return {
                EQ: newFormCmd,
                adu: event,
                zi: newForm,
                at: _List_Nil
            };
        }
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$SetAgeRateRulePeriodAmountInCentsEdited = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FixedMembershipPricingToggled = {
        $: 1
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveRanges = F5(function(fromGetter, fromSetter, toGetter, toSetter, range) {
        if ($elm$core$List$isEmpty(range)) return range;
        else {
            var minimum = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, fromGetter, $elm$core$List$head(range)));
            return A2($elm$core$List$indexedMap, F2(function(index, current) {
                var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
                var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
                var newTo = function() {
                    var _v1 = _Utils_Tuple2(next, toGetter(current));
                    if (_v1.a.$ === 1) {
                        var _v2 = _v1.a;
                        return $elm$core$Maybe$Nothing;
                    } else if (_v1.b.$ === 1) {
                        var _v3 = _v1.b;
                        return toGetter(current);
                    } else {
                        var currentTo = _v1.b.a;
                        var currentFrom = fromGetter(current);
                        return _Utils_cmp(currentTo, currentFrom) < 1 ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
                    }
                }();
                var newFrom = function() {
                    var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
                    if (!_v0.$) {
                        var _int = _v0.a;
                        return _int + 1;
                    } else return minimum;
                }();
                return A2(toSetter, newTo, A2(fromSetter, newFrom, current));
            }), range);
        }
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveAgeRanges = A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveRanges, function(item) {
        return !item.aaG ? item.P_ * 12 : item.P_;
    }, F2(function(from, item) {
        return !item.aaG ? _Utils_update(item, {
            P_: $elm$core$Basics$ceiling(from / 12)
        }) : _Utils_update(item, {
            P_: from
        });
    }), function(item) {
        return !item.aaG ? A2($elm$core$Maybe$map, function(age) {
            return age * 12;
        }, item.$4) : item.$4;
    }, F2(function(to, item) {
        return !item.aaG ? _Utils_update(item, {
            $4: A2($elm$core$Maybe$map, function(age) {
                return $elm$core$Basics$ceiling(age / 12);
            }, to)
        }) : _Utils_update(item, {
            $4: to
        });
    }));
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$lastRuleIsInYears = function(rules) {
        var _v0 = $elm_community$list_extra$List$Extra$last(rules);
        if (!_v0.$) {
            var lastRule = _v0.a;
            return !!lastRule.aaG ? A2($author$project$Utils$List$updateLast, function(rule) {
                return _Utils_update(rule, {
                    aaG: 0
                });
            }, rules) : rules;
        } else return rules;
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules = function(rules) {
        return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$exclusiveAgeRanges($author$project$Components$Plan$Form$IndividualMembershipPricingFields$lastRuleIsInYears(rules));
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths = 23;
    var $author$project$Components$Plan$Form$AgeRateRuleField$startingFrom = F2(function(defaultPeriod, base) {
        return function(ageRateRule) {
            switch(defaultPeriod){
                case 'month':
                    var updatedPeriodRates = ageRateRule.dc;
                    return _Utils_update(ageRateRule, {
                        dc: _Utils_update(updatedPeriodRates, {
                            Uu: base.dc.Uu
                        })
                    });
                case 'quarter':
                    var updatedPeriodRates = ageRateRule.dc;
                    return _Utils_update(ageRateRule, {
                        dc: _Utils_update(updatedPeriodRates, {
                            XU: base.dc.XU
                        })
                    });
                case 'semi_annual':
                    var updatedPeriodRates = ageRateRule.dc;
                    return _Utils_update(ageRateRule, {
                        dc: _Utils_update(updatedPeriodRates, {
                            ZH: base.dc.ZH
                        })
                    });
                case 'annual':
                    var updatedPeriodRates = ageRateRule.dc;
                    return _Utils_update(ageRateRule, {
                        dc: _Utils_update(updatedPeriodRates, {
                            Jk: base.dc.Jk
                        })
                    });
                default:
                    return ageRateRule;
            }
        }({
            Mg: $elm$core$Maybe$Nothing,
            P_: A2($elm$core$Maybe$withDefault, 0, base.$4) + 1,
            dc: {
                Jk: $elm$core$Maybe$Nothing,
                e3: false,
                Jl: false,
                Uu: $elm$core$Maybe$Just($author$project$Currency$zero),
                gb: false,
                Gl: false,
                XU: $elm$core$Maybe$Nothing,
                gx: false,
                XV: false,
                ZH: $elm$core$Maybe$Nothing,
                gM: false,
                ZI: false
            },
            $4: $elm$core$Maybe$Nothing,
            aaG: 0
        });
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField = F3(function(sharedFields, field, fields) {
        switch(field.$){
            case 0:
                var _v1 = function() {
                    var _v2 = $elm_community$list_extra$List$Extra$last(fields.I_);
                    if (_v2.$ === 1) return _Utils_Tuple2($author$project$Components$Plan$Form$AgeRateRuleField$empty, $elm$core$Maybe$Nothing);
                    else {
                        var lastAgeRateRule = _v2.a;
                        var newLastAgeRateRule_ = _Utils_update(lastAgeRateRule, {
                            $4: $elm$core$Maybe$Just(lastAgeRateRule.P_ + 19)
                        });
                        return _Utils_Tuple2(A2($author$project$Components$Plan$Form$AgeRateRuleField$startingFrom, sharedFields.Nx, newLastAgeRateRule_), $elm$core$Maybe$Just(newLastAgeRateRule_));
                    }
                }();
                var newAgeRateRule = _v1.a;
                var newLastAgeRateRule = _v1.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A2($author$project$Utils$List$prepend, _List_fromArray([
                        newAgeRateRule
                    ]), A2($author$project$Utils$List$updateLast, function(last) {
                        return A2($elm$core$Maybe$withDefault, last, newLastAgeRateRule);
                    }, fields.I_)))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 1:
                var index = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A2($elm_community$list_extra$List$Extra$removeAt, index, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 2:
                var index = field.a;
                var string = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A3($elm_community$list_extra$List$Extra$updateAt, index, function(ageRateRule) {
                        return _Utils_update(ageRateRule, {
                            $4: $elm$core$String$toInt(string)
                        });
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 3:
                var index = field.a;
                var string = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A3($elm_community$list_extra$List$Extra$updateAt, index, function(ageRateRule) {
                        var unit = $author$project$Api$Provider$RateRule$Shared$stringToUnit(string);
                        return _Utils_update(ageRateRule, {
                            $4: unit === 1 ? A2($elm$core$Maybe$map, function(age) {
                                return A2($elm$core$Basics$min, age, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths);
                            }, ageRateRule.$4) : ageRateRule.$4,
                            aaG: unit
                        });
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 11:
                var period = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A2($elm$core$List$map, function(ageRateRule) {
                        var updatedPeriodRates = ageRateRule.dc;
                        switch(period){
                            case 'month':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        gb: true
                                    })
                                });
                            case 'quarter':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        gx: true
                                    })
                                });
                            case 'semi_annual':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        gM: true
                                    })
                                });
                            case 'annual':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        e3: true
                                    })
                                });
                            default:
                                return ageRateRule;
                        }
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 4:
                var index = field.a;
                var period = field.b;
                var currency = field.c;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A3($elm_community$list_extra$List$Extra$updateAt, index, function(ageRateRule) {
                        var updatedPeriodRates = ageRateRule.dc;
                        switch(period){
                            case 'month':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        Uu: currency,
                                        gb: true
                                    })
                                });
                            case 'quarter':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        XU: currency,
                                        gx: true
                                    })
                                });
                            case 'semi_annual':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        ZH: currency,
                                        gM: true
                                    })
                                });
                            case 'annual':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        Jk: currency,
                                        e3: true
                                    })
                                });
                            default:
                                return ageRateRule;
                        }
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 5:
                var index = field.a;
                var period = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A3($elm_community$list_extra$List$Extra$updateAt, index, function(ageRateRule) {
                        var updatedPeriodRates = ageRateRule.dc;
                        switch(period){
                            case 'month':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        Gl: true
                                    })
                                });
                            case 'quarter':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        XV: true
                                    })
                                });
                            case 'semi_annual':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        ZI: true
                                    })
                                });
                            case 'annual':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        Jl: true
                                    })
                                });
                            default:
                                return ageRateRule;
                        }
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 6:
                var index = field.a;
                var period = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A3($elm_community$list_extra$List$Extra$updateAt, index, function(ageRateRule) {
                        var updatedPeriodRates = ageRateRule.dc;
                        switch(period){
                            case 'month':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        gb: false,
                                        Gl: false
                                    })
                                });
                            case 'quarter':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        gx: false,
                                        XV: false
                                    })
                                });
                            case 'semi_annual':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        gM: false,
                                        ZI: false
                                    })
                                });
                            case 'annual':
                                return _Utils_update(ageRateRule, {
                                    dc: _Utils_update(updatedPeriodRates, {
                                        e3: false,
                                        Jl: false
                                    })
                                });
                            default:
                                return ageRateRule;
                        }
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 7:
                var index = field.a;
                var period = field.b;
                var currency = field.c;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A3($elm_community$list_extra$List$Extra$updateAt, index, function(ageRateRule) {
                        var _v7 = ageRateRule.Mg;
                        if (!_v7.$) {
                            var coupleRule = _v7.a;
                            var updatedPeriodRates = coupleRule.dc;
                            var updatedCoupleRule = function() {
                                switch(period){
                                    case 'month':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                Uu: currency,
                                                gb: true
                                            })
                                        });
                                    case 'quarter':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                XU: currency,
                                                gx: true
                                            })
                                        });
                                    case 'semi_annual':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                ZH: currency,
                                                gM: true
                                            })
                                        });
                                    case 'annual':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                Jk: currency,
                                                e3: true
                                            })
                                        });
                                    default:
                                        return coupleRule;
                                }
                            }();
                            return _Utils_update(ageRateRule, {
                                Mg: $elm$core$Maybe$Just(updatedCoupleRule)
                            });
                        } else return ageRateRule;
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 8:
                var index = field.a;
                var period = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A3($elm_community$list_extra$List$Extra$updateAt, index, function(ageRateRule) {
                        var _v9 = ageRateRule.Mg;
                        if (!_v9.$) {
                            var coupleRule = _v9.a;
                            var updatedPeriodRates = coupleRule.dc;
                            var updatedCoupleRule = function() {
                                switch(period){
                                    case 'month':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                Gl: true
                                            })
                                        });
                                    case 'quarter':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                XV: true
                                            })
                                        });
                                    case 'semi_annual':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                ZI: true
                                            })
                                        });
                                    case 'annual':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                Jl: true
                                            })
                                        });
                                    default:
                                        return coupleRule;
                                }
                            }();
                            return _Utils_update(ageRateRule, {
                                Mg: $elm$core$Maybe$Just(updatedCoupleRule)
                            });
                        } else return ageRateRule;
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            case 9:
                var index = field.a;
                var period = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$fixupAgeRules(A3($elm_community$list_extra$List$Extra$updateAt, index, function(ageRateRule) {
                        var _v11 = ageRateRule.Mg;
                        if (!_v11.$) {
                            var coupleRule = _v11.a;
                            var updatedPeriodRates = coupleRule.dc;
                            var updatedCoupleRule = function() {
                                switch(period){
                                    case 'month':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                gb: false,
                                                Gl: false
                                            })
                                        });
                                    case 'quarter':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                gx: false,
                                                XV: false
                                            })
                                        });
                                    case 'semi_annual':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                gM: false,
                                                ZI: false
                                            })
                                        });
                                    case 'annual':
                                        return _Utils_update(coupleRule, {
                                            dc: _Utils_update(updatedPeriodRates, {
                                                e3: false,
                                                Jl: false
                                            })
                                        });
                                    default:
                                        return coupleRule;
                                }
                            }();
                            return _Utils_update(ageRateRule, {
                                Mg: $elm$core$Maybe$Just(updatedCoupleRule)
                            });
                        } else return ageRateRule;
                    }, fields.I_))
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FieldUpdated(field));
            default:
                return _Utils_Tuple3(fields, $elm$core$Platform$Cmd$none, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FixedMembershipPricingToggled);
        }
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$update = F3(function(sharedFields, msg, _v0) {
        var form = _v0;
        if (!msg.$) {
            var field = msg.a;
            var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField(sharedFields), field, form);
            var newForm = _v2.a;
            var newFormCmd = _v2.b;
            var event = _v2.c;
            return {
                EQ: newFormCmd,
                adu: event,
                zi: newForm,
                at: _List_Nil
            };
        } else {
            var defaultPeriod = msg.a;
            var _v3 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateField(sharedFields), $author$project$Components$Plan$Form$IndividualMembershipPricingFields$SetAgeRateRulePeriodAmountInCentsEdited(defaultPeriod), form);
            var newForm = _v3.a;
            var newFormCmd = _v3.b;
            var event = _v3.c;
            return {
                EQ: newFormCmd,
                adu: event,
                zi: newForm,
                at: _List_Nil
            };
        }
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$FieldUpdated = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$SpecialRateField$empty = {
        Jk: $elm$core$Maybe$Nothing,
        e3: false,
        Jl: false,
        Mw: true,
        NU: false,
        aef: $elm$core$Maybe$Nothing,
        R1: true,
        Uu: $elm$core$Maybe$Nothing,
        gb: false,
        Gl: false,
        zr: '',
        XU: $elm$core$Maybe$Nothing,
        gx: false,
        XV: false,
        ZH: $elm$core$Maybe$Nothing,
        gM: false,
        ZI: false
    };
    var $author$project$Components$Plan$Form$SpecialRatesFields$updateField = F3(function(_v0, field, fields) {
        switch(field.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(fields, {
                    _M: _Utils_ap(fields._M, _List_fromArray([
                        $author$project$Components$Plan$Form$SpecialRateField$empty
                    ]))
                }), $elm$core$Platform$Cmd$none, field);
            case 1:
                var index = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _M: A3($elm_community$list_extra$List$Extra$updateAt, index, function(specialRate) {
                        return _Utils_update(specialRate, {
                            NU: true
                        });
                    }, fields._M)
                }), $elm$core$Platform$Cmd$none, field);
            case 2:
                var index = field.a;
                var string = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _M: A3($elm_community$list_extra$List$Extra$updateAt, index, function(specialRate) {
                        return _Utils_update(specialRate, {
                            zr: string
                        });
                    }, fields._M)
                }), $elm$core$Platform$Cmd$none, field);
            case 3:
                var index = field.a;
                var period = field.b;
                var currency = field.c;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _M: A3($elm_community$list_extra$List$Extra$updateAt, index, function(specialRate) {
                        switch(period){
                            case 'month':
                                return _Utils_update(specialRate, {
                                    Uu: currency,
                                    gb: true
                                });
                            case 'quarter':
                                return _Utils_update(specialRate, {
                                    XU: currency,
                                    gx: true
                                });
                            case 'semi_annual':
                                return _Utils_update(specialRate, {
                                    ZH: currency,
                                    gM: true
                                });
                            case 'annual':
                                return _Utils_update(specialRate, {
                                    Jk: currency,
                                    e3: true
                                });
                            default:
                                return specialRate;
                        }
                    }, fields._M)
                }), $elm$core$Platform$Cmd$none, field);
            case 4:
                var index = field.a;
                var period = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _M: A3($elm_community$list_extra$List$Extra$updateAt, index, function(specialRate) {
                        switch(period){
                            case 'month':
                                return _Utils_update(specialRate, {
                                    Gl: true
                                });
                            case 'quarter':
                                return _Utils_update(specialRate, {
                                    XV: true
                                });
                            case 'semi_annual':
                                return _Utils_update(specialRate, {
                                    ZI: true
                                });
                            case 'annual':
                                return _Utils_update(specialRate, {
                                    Jl: true
                                });
                            default:
                                return specialRate;
                        }
                    }, fields._M)
                }), $elm$core$Platform$Cmd$none, field);
            default:
                var index = field.a;
                var period = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _M: A3($elm_community$list_extra$List$Extra$updateAt, index, function(specialRate) {
                        switch(period){
                            case 'month':
                                return _Utils_update(specialRate, {
                                    gb: false,
                                    Gl: false
                                });
                            case 'quarter':
                                return _Utils_update(specialRate, {
                                    gx: false,
                                    XV: false
                                });
                            case 'semi_annual':
                                return _Utils_update(specialRate, {
                                    gM: false,
                                    ZI: false
                                });
                            case 'annual':
                                return _Utils_update(specialRate, {
                                    e3: false,
                                    Jl: false
                                });
                            default:
                                return specialRate;
                        }
                    }, fields._M)
                }), $elm$core$Platform$Cmd$none, field);
        }
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$update = F3(function(sharedFields, msg, _v0) {
        var form = _v0;
        var field = msg;
        var _v2 = A3($author$project$Components$Plan$Form$SpecialRatesFields$updateField, sharedFields, field, $author$project$Utils$Form$fields(form));
        var updatedFields = _v2.a;
        var cmd = _v2.b;
        var event = _v2.c;
        return {
            EQ: cmd,
            adu: event,
            zi: A2($author$project$Utils$Form$set, updatedFields, form),
            at: _List_Nil
        };
    });
    var $author$project$Components$ResourceFilter$Plan$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Plan$Form$updateDateInputFormField = F6(function(model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
        var dateInput = dateInputGetter(model);
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var dateInputEvent = _v0.c;
        var newForm = A2($elm$core$Maybe$map, function(_v1) {
            var plan = _v1.a;
            var form = _v1.b;
            var newForm_ = function() {
                if (dateInputEvent.$ === 1) {
                    var date = dateInputEvent.a;
                    var field_ = toField(date);
                    return A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), field_, form);
                } else return form;
            }();
            return _Utils_Tuple2(plan, newForm_);
        }, model.PU);
        return _Utils_Tuple3(A2(dateInputSetter, newDateInput, _Utils_update(model, {
            PU: newForm
        })), A2($elm$core$Platform$Cmd$map, toMsg, subCmd), _List_Nil);
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$DefaultPeriodUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod = F3(function(defaultPeriod, maybePlan, _v0) {
        var form = _v0;
        return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$update, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$DefaultPeriodUpdated(defaultPeriod), form, maybePlan);
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$DefaultPeriodUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod = F3(function(sharedFields, defaultPeriod, _v0) {
        var form = _v0;
        return A3($author$project$Components$Plan$Form$GroupTierPricingFields$update, sharedFields, $author$project$Components$Plan$Form$GroupTierPricingFields$DefaultPeriodUpdated(defaultPeriod), form);
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$DefaultPeriodUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod = F3(function(sharedFields, defaultPeriod, _v0) {
        var form = _v0;
        return A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$DefaultPeriodUpdated(defaultPeriod), form);
    });
    var $author$project$Components$Plan$Form$calculateOpts = function(field) {
        var _v0 = function() {
            switch(field.$){
                case 0:
                    return _Utils_Tuple2(false, false);
                case 1:
                    return _Utils_Tuple2(true, true);
                case 2:
                    return _Utils_Tuple2(true, true);
                case 3:
                    return _Utils_Tuple2(true, true);
                case 4:
                    return _Utils_Tuple2(false, false);
                case 5:
                    return _Utils_Tuple2(false, false);
                case 6:
                    return _Utils_Tuple2(false, false);
                case 7:
                    return _Utils_Tuple2(false, false);
                case 8:
                    return _Utils_Tuple2(false, false);
                case 11:
                    return _Utils_Tuple2(false, false);
                case 12:
                    return _Utils_Tuple2(false, false);
                case 9:
                    return _Utils_Tuple2(false, false);
                case 10:
                    return _Utils_Tuple2(false, false);
                case 13:
                    return _Utils_Tuple2(false, false);
                case 14:
                    return _Utils_Tuple2(false, false);
                case 15:
                    return _Utils_Tuple2(false, false);
                case 16:
                    return _Utils_Tuple2(false, false);
                case 17:
                    return _Utils_Tuple2(false, false);
                case 18:
                    return _Utils_Tuple2(false, false);
                case 19:
                    return _Utils_Tuple2(false, false);
                case 20:
                    return _Utils_Tuple2(false, false);
                case 21:
                    return _Utils_Tuple2(false, false);
                case 22:
                    return _Utils_Tuple2(false, false);
                case 23:
                    return _Utils_Tuple2(false, false);
                case 24:
                    return _Utils_Tuple2(false, false);
                case 25:
                    return _Utils_Tuple2(false, false);
                case 26:
                    return _Utils_Tuple2(false, false);
                case 27:
                    return _Utils_Tuple2(true, false);
                case 28:
                    return _Utils_Tuple2(false, true);
                case 29:
                    return _Utils_Tuple2(false, true);
                case 30:
                    return _Utils_Tuple2(false, true);
                case 31:
                    return _Utils_Tuple2(true, true);
                case 32:
                    return _Utils_Tuple2(true, true);
                case 33:
                    return _Utils_Tuple2(false, true);
                case 34:
                    return _Utils_Tuple2(false, true);
                case 35:
                    return _Utils_Tuple2(true, true);
                case 36:
                    return _Utils_Tuple2(false, true);
                case 37:
                    return _Utils_Tuple2(true, true);
                case 38:
                    return _Utils_Tuple2(true, true);
                case 39:
                    return _Utils_Tuple2(false, true);
                case 40:
                    return _Utils_Tuple2(true, true);
                default:
                    return _Utils_Tuple2(false, false);
            }
        }();
        var shouldCalculate_ = _v0.a;
        var validateCalculateFields = _v0.b;
        return {
            _b: shouldCalculate_,
            aa8: validateCalculateFields
        };
    };
    var $author$project$Components$Plan$Form$showWarningModalIfFieldChanged = function(field) {
        switch(field.$){
            case 0:
                return false;
            case 19:
                return false;
            default:
                return true;
        }
    };
    var $author$project$Components$Plan$Form$updateForm = F4(function(model, plan, field, form) {
        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), field, form);
        return A4($author$project$Components$Plan$Form$calculate, plan, newForm, $author$project$Components$Plan$Form$calculateOpts(field), _Utils_update(model, {
            PU: $elm$core$Maybe$Just(_Utils_Tuple2(plan, newForm)),
            ot: $author$project$Components$Plan$Form$showWarningModalIfFieldChanged(field)
        }));
    });
    var $author$project$Api$Provider$SubsequentPlan$One$changeAfterMonths = function(_v0) {
        var record = _v0.b;
        return record.K2;
    };
    var $author$project$Api$Provider$SubsequentPlan$One$changeOnDate = function(_v0) {
        var record = _v0.b;
        return record.K3;
    };
    var $author$project$Api$Provider$Plan$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$SubsequentPlan$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$SubsequentPlan$One$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$SubsequentPlan$Min$id(min);
    };
    var $author$project$Api$Provider$Plan$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$SubsequentPlan$One$toPlan = function(_v0) {
        var record = _v0.b;
        return record.$5;
    };
    var $author$project$Api$Provider$SubsequentPlan$Min$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$SubsequentPlan$One$type_ = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$SubsequentPlan$Min$type_(min);
    };
    var $author$project$Components$Plan$Form$PlanChange$updateFromSubsequentPlan = F2(function(subsequentPlan, planChange) {
        var params = planChange.VU;
        var toPlan = $author$project$Api$Provider$SubsequentPlan$One$toPlan(subsequentPlan);
        return _Utils_update(planChange, {
            VU: _Utils_update(params, {
                K2: $author$project$Api$Provider$SubsequentPlan$One$changeAfterMonths(subsequentPlan),
                K3: $author$project$Api$Provider$SubsequentPlan$One$changeOnDate(subsequentPlan),
                aef: $elm$core$Maybe$Just($author$project$Api$Provider$SubsequentPlan$One$id(subsequentPlan)),
                $5: A2($elm$core$Maybe$map, function(toPlan_) {
                    return {
                        aef: $author$project$Api$Provider$Plan$Min$id(toPlan_),
                        zr: $author$project$Api$Provider$Plan$Min$name(toPlan_)
                    };
                }, toPlan),
                ah5: $author$project$Api$Provider$SubsequentPlan$One$type_(subsequentPlan)
            })
        });
    });
    var $author$project$Components$Plan$Form$updateSuccess = function(model) {
        var route = model.W4 ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.Gc);
        return _Utils_Tuple3(model, route, _List_fromArray([
            A2($author$project$OutMsg$ShowToast, 3, 'Your pricing has been updated')
        ]));
    };
    var $author$project$Components$Plan$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var loadSubsequentPlan = msg.a;
                var response = msg.b;
                return A2($author$project$Utils$Tuple3$mapSecond, function(cmd) {
                    return $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        loadSubsequentPlan ? A2($author$project$Components$Plan$Form$fetchSubsequentPlan, apiClient, model.aef) : $elm$core$Platform$Cmd$none
                    ]));
                }, A3($author$project$Components$Plan$Form$resetParamsOnScope, apiClient, response, model));
            case 1:
                var response = msg.a;
                var _v2 = model.PU;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var plan = _v3.a;
                    var form = _v3.b;
                    var _v4 = $author$project$Utils$Form$fields(form);
                    var planChange = _v4.jw;
                    _v5$2: while(true)switch(response.$){
                        case 3:
                            var subsequentPlan = response.a;
                            var _v6 = A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$PlanChange(A2($author$project$Components$Plan$Form$PlanChange$updateFromSubsequentPlan, subsequentPlan, planChange)), form);
                            var newModel = _v6.a;
                            var formCmd = _v6.b;
                            return _Utils_Tuple3(newModel, formCmd, _List_Nil);
                        case 2:
                            if (response.a.$ === 5) {
                                var _v7 = response.a;
                                var params = planChange.VU;
                                var _v8 = $author$project$Utils$Form$fields(form);
                                var contractExpires = _v8.L5;
                                var planChangeType = contractExpires ? 2 : 1;
                                var newParams = _Utils_update(params, {
                                    ah5: planChangeType
                                });
                                var _v9 = A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$PlanChange(_Utils_update(planChange, {
                                    VU: newParams
                                })), form);
                                var newModel = _v9.a;
                                var formCmd = _v9.b;
                                return _Utils_Tuple3(newModel, formCmd, _List_Nil);
                            } else break _v5$2;
                        default:
                            break _v5$2;
                    }
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var field = msg.a;
                var _v10 = model.PU;
                if (!_v10.$) {
                    var _v11 = _v10.a;
                    var plan = _v11.a;
                    var form = _v11.b;
                    var _v12 = A4($author$project$Components$Plan$Form$updateForm, model, plan, field, form);
                    var newModel = _v12.a;
                    var formCmd = _v12.b;
                    return _Utils_Tuple3(newModel, formCmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var planFormMsg = msg.a;
                var _v13 = model.PU;
                if (!_v13.$) {
                    var _v14 = _v13.a;
                    var plan = _v14.a;
                    var form = _v14.b;
                    var _v15 = $author$project$Utils$Form$fields(form);
                    var basicPlan = _v15.aB;
                    var familyMembershipPricingForm = _v15.cY;
                    var membershipPricingForm = _v15.c$;
                    var groupTierPricingForm = _v15.i;
                    var newBasicPlanResult = A4($author$project$Components$Plan$BasicForm$update, apiClient, planFormMsg, basicPlan, $elm$core$Maybe$Just(plan));
                    var _v16 = function() {
                        var _v17 = newBasicPlanResult.adu;
                        if (_v17.$ === 1) {
                            var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.zi), form);
                            return _Utils_Tuple2(_Utils_update(model, {
                                PU: $elm$core$Maybe$Just(_Utils_Tuple2(plan, newForm))
                            }), $elm$core$Platform$Cmd$none);
                        } else {
                            var field = _v17.a;
                            if (field.$ === 3) {
                                var defaultPeriod = field.a;
                                var tempForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.zi), form);
                                var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, tempForm);
                                var defaultPeriodString = defaultPeriod ? 'annual' : 'month';
                                var familyMembershipPricingResult = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod, defaultPeriodString, $elm$core$Maybe$Just(plan), familyMembershipPricingForm);
                                var groupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, groupTierPricingForm);
                                var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, membershipPricingForm);
                                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$GroupTierPricingFields(groupTierPricingResult.zi), A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$MembershipPricingFields(newMembershipPricingResult.zi), A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$FamilyMembershipPricingFields(familyMembershipPricingResult.zi), tempForm)));
                                return A5($author$project$Components$Plan$Form$calculateAfterValidation, model, plan, newForm, $author$project$Components$Plan$BasicForm$calculateOpts(field), true);
                            } else {
                                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$BasicPlan(newBasicPlanResult.zi), form);
                                return A5($author$project$Components$Plan$Form$calculateAfterValidation, model, plan, newForm, $author$project$Components$Plan$BasicForm$calculateOpts(field), $author$project$Components$Plan$BasicForm$showWarningModal(field));
                            }
                        }
                    }();
                    var newModel = _v16.a;
                    var formCmd = _v16.b;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$BasicPlanFormUpdated, newBasicPlanResult.EQ)
                    ])), newBasicPlanResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var planFormMsg = msg.a;
                var _v19 = model.PU;
                if (!_v19.$) {
                    var _v20 = _v19.a;
                    var plan = _v20.a;
                    var form = _v20.b;
                    var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
                    var _v21 = $author$project$Utils$Form$fields(form);
                    var membershipPricingForm = _v21.c$;
                    var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, planFormMsg, membershipPricingForm);
                    var _v22 = function() {
                        var _v23 = newMembershipPricingResult.adu;
                        if (!_v23.$) {
                            var field = _v23.a;
                            var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$MembershipPricingFields(newMembershipPricingResult.zi), form);
                            return A5($author$project$Components$Plan$Form$calculateAfterValidation, model, plan, newForm, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field), true);
                        } else return A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$ToggleFixedMembershipPricing, form);
                    }();
                    var newModel = _v22.a;
                    var formCmd = _v22.b;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.EQ)
                    ])), newMembershipPricingResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var planFormMsg = msg.a;
                var _v24 = model.PU;
                if (!_v24.$) {
                    var _v25 = _v24.a;
                    var plan = _v25.a;
                    var form = _v25.b;
                    var _v26 = $author$project$Utils$Form$fields(form);
                    var familyMembershipPricingForm = _v26.cY;
                    var newFamilyMembershipPricingResult = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$update, planFormMsg, familyMembershipPricingForm, $elm$core$Maybe$Just(plan));
                    var _v27 = function() {
                        var _v28 = newFamilyMembershipPricingResult.adu;
                        if (!_v28.$) {
                            var groupPricingType = _v28.a;
                            return A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$GroupPricingType(groupPricingType), form);
                        } else {
                            var field = _v28.a;
                            var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$FamilyMembershipPricingFields(newFamilyMembershipPricingResult.zi), form);
                            return A5($author$project$Components$Plan$Form$calculateAfterValidation, model, plan, newForm, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field), true);
                        }
                    }();
                    var newModel = _v27.a;
                    var formCmd = _v27.b;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.EQ)
                    ])), newFamilyMembershipPricingResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var planFormMsg = msg.a;
                var _v29 = model.PU;
                if (!_v29.$) {
                    var _v30 = _v29.a;
                    var plan = _v30.a;
                    var form = _v30.b;
                    var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
                    var _v31 = $author$project$Utils$Form$fields(form);
                    var groupTierPricingForm = _v31.i;
                    var newGroupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$update, sharedFields, planFormMsg, groupTierPricingForm);
                    var _v32 = function() {
                        var _v33 = newGroupTierPricingResult.adu;
                        if (!_v33.$) {
                            var field = _v33.a;
                            var currentFields = $author$project$Utils$Form$fields(form);
                            var updatedFields = _Utils_update(currentFields, {
                                i: newGroupTierPricingResult.zi
                            });
                            var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
                            return A5($author$project$Components$Plan$Form$calculateAfterValidation, model, plan, newForm, $author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts(field), true);
                        } else return A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$ToggleFixedMembershipPricing, form);
                    }();
                    var newModel = _v32.a;
                    var formCmd = _v32.b;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.EQ)
                    ])), newGroupTierPricingResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var planFormMsg = msg.a;
                var _v34 = model.PU;
                if (!_v34.$) {
                    var _v35 = _v34.a;
                    var plan = _v35.a;
                    var form = _v35.b;
                    var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
                    var _v36 = $author$project$Utils$Form$fields(form);
                    var specialRatesForm = _v36.dj;
                    var newSpecialRatesResult = A3($author$project$Components$Plan$Form$SpecialRatesFields$update, sharedFields, planFormMsg, specialRatesForm);
                    var _v37 = function() {
                        var _v38 = newSpecialRatesResult.adu;
                        var field = _v38;
                        var currentFields = $author$project$Utils$Form$fields(form);
                        var updatedFields = _Utils_update(currentFields, {
                            dj: newSpecialRatesResult.zi
                        });
                        var newForm = A2($author$project$Utils$Form$set, updatedFields, form);
                        return A5($author$project$Components$Plan$Form$calculateAfterValidation, model, plan, newForm, $author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field), true);
                    }();
                    var newModel = _v37.a;
                    var formCmd = _v37.b;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$SpecialRatesFieldsUpdated, newSpecialRatesResult.EQ)
                    ])), newSpecialRatesResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var plan = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(plan, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var plan = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(plan, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$Plan$delete, apiClient, $author$project$Api$Provider$Plan$One$id(plan), $author$project$Components$Plan$Form$PlanDeleted(plan)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var plan = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.Gc), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Plan removed')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(plan, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                var _v40 = model.PU;
                if (!_v40.$) {
                    var _v41 = _v40.a;
                    var plan = _v41.a;
                    var form = _v41.b;
                    var newValidForm = A3($author$project$Components$Plan$Form$validateFormFields, plan, model.W1, form);
                    var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, newValidForm);
                    var _v42 = A2($author$project$Utils$Form$validate, A5($author$project$Components$Plan$Form$formFieldsValidator, sharedFields, model.cP, model.oN, model.jx, plan), newValidForm);
                    if (!_v42.$) {
                        var _v43 = _v42.a;
                        var newForm = _v43.a;
                        var validFormFields = _v43.b;
                        var _v44 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                        var planChange = _v44.jw;
                        if (model.ot || planChange.bW) {
                            var _v45 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                            var contractExpires = _v45.L5;
                            var _v46 = A5($author$project$Components$Plan$Form$ConfirmUpdateModal$init, apiClient, model.W1, plan, {
                                L5: contractExpires
                            }, planChange);
                            var confirmUpdateModal = _v46.a;
                            var confirmUpdateModalCmd = _v46.b;
                            return _Utils_Tuple3(_Utils_update(model, {
                                hT: $elm$core$Maybe$Just(_Utils_Tuple2(validFormFields, confirmUpdateModal)),
                                PU: $elm$core$Maybe$Just(_Utils_Tuple2(plan, newForm))
                            }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$ConfirmUpdateModalMsg, confirmUpdateModalCmd), _List_Nil);
                        } else return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_Tuple2(plan, newForm)),
                            j_: $author$project$Api$Data$Loading
                        }), A3($author$project$Components$Plan$Form$saveItem, apiClient, model.aef, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v42.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_Tuple2(plan, newForm)),
                            j_: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var response = msg.a;
                var _v47 = model.PU;
                if (!_v47.$) {
                    var _v48 = _v47.a;
                    var form = _v48.b;
                    if (response.$ === 3) {
                        var _v50 = $author$project$Utils$Form$fields(form);
                        var planChange = _v50.jw;
                        if (planChange.bW) {
                            var apiFields = {
                                K2: planChange.VU.K2,
                                K3: planChange.VU.K3,
                                $5: A2($elm$core$Maybe$map, function($) {
                                    return $.aef;
                                }, planChange.VU.$5)
                            };
                            return _Utils_Tuple3(model, A4($author$project$Api$Provider$Plan$SubsequentPlan$update, apiClient, model.aef, apiFields, $author$project$Components$Plan$Form$SubsequentPlanUpdated), _List_Nil);
                        } else return $author$project$Components$Plan$Form$updateSuccess(model);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var subMsg = msg.a;
                var _v51 = model.hT;
                if (!_v51.$) {
                    var _v52 = _v51.a;
                    var validFormFields = _v52.a;
                    var confirmUpdateModal = _v52.b;
                    var confirmUpdateModalResult = A2($author$project$Components$Plan$Form$ConfirmUpdateModal$update, subMsg, confirmUpdateModal);
                    var _v53 = function() {
                        var _v54 = confirmUpdateModalResult.adu;
                        switch(_v54){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_Tuple2(validFormFields, confirmUpdateModalResult.zi)), model.j_, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.j_, $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A3($author$project$Components$Plan$Form$saveItem, apiClient, model.aef, validFormFields));
                        }
                    }();
                    var newConfirmUpdateModal = _v53.a;
                    var saveRequest = _v53.b;
                    var saveItemCmd = _v53.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        hT: newConfirmUpdateModal,
                        j_: saveRequest
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$ConfirmUpdateModalMsg, confirmUpdateModalResult.EQ),
                        saveItemCmd
                    ])), confirmUpdateModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var validFormFields = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(model, A3($author$project$Components$Plan$Form$updatePlanRequest, apiClient, model.aef, validFormFields), _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                var response = msg.a;
                if (response.$ === 3) return $author$project$Components$Plan$Form$updateSuccess(model);
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 16:
                var debounceMsg = msg.a;
                var _v57 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Plan$Form$previewDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Plan$Form$debounceCalculate), debounceMsg, model.eq);
                var newDebouncer = _v57.a;
                var cmd = _v57.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    eq: newDebouncer
                }), cmd, _List_Nil);
            case 17:
                var formFields = msg.a;
                var previousPreviewId = model.agk.a;
                var previewId = previousPreviewId + 1;
                return _Utils_Tuple3(_Utils_update(model, {
                    agk: _Utils_Tuple2(previewId, $author$project$Api$Data$Loading)
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A6($author$project$Api$Provider$Plan$calculate, apiClient, _List_fromArray([
                        1
                    ]), 'plan_preview_' + $elm$core$String$fromInt(previewId), model.aef, $author$project$Components$Plan$Form$updatePlanFields(formFields), $author$project$Components$Plan$Form$GotPreview(previewId)),
                    $elm$http$Http$cancel('plan_preview_' + $elm$core$String$fromInt(previousPreviewId))
                ])), _List_Nil);
            case 18:
                var previewId = msg.a;
                var response = msg.b;
                return _Utils_eq(model.agk.a, previewId) ? A3($author$project$Components$Plan$Form$resetParamsOnScope, apiClient, response, model) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var _v58 = model.PU;
                if (!_v58.$) {
                    var _v59 = _v58.a;
                    var form = _v59.b;
                    var _v60 = $author$project$Utils$Form$fields(form);
                    var coveragePlan = _v60.Mn;
                    var _v61 = A2($author$project$Components$Plan$Form$AddCoveragePlanModal$init, apiClient, A2($elm$core$Maybe$map, $author$project$Components$Plan$Form$coveragePlanId, coveragePlan));
                    var addCoveragePlanModal = _v61.a;
                    var addCoveragePlanModalCmd = _v61.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        hm: $elm$core$Maybe$Just(addCoveragePlanModal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModalMsg, addCoveragePlanModalCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 20:
                var subMsg = msg.a;
                var _v62 = model.PU;
                if (!_v62.$) {
                    var _v63 = _v62.a;
                    var plan = _v63.a;
                    var form = _v63.b;
                    var _v64 = model.hm;
                    if (!_v64.$) {
                        var addCoveragePlanModal = _v64.a;
                        var addCoveragePlanModalResult = A3($author$project$Components$Plan$Form$AddCoveragePlanModal$update, apiClient, subMsg, addCoveragePlanModal);
                        var _v65 = function() {
                            var _v66 = addCoveragePlanModalResult.adu;
                            switch(_v66.$){
                                case 0:
                                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(addCoveragePlanModalResult.zi));
                                case 1:
                                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                                default:
                                    var coveragePlan = _v66.a;
                                    return A2($author$project$Utils$Tuple3$fromTuple2, $elm$core$Maybe$Nothing, A4($author$project$Components$Plan$Form$updateForm, model, plan, $author$project$Components$Plan$Form$CoveragePlan($elm$core$Maybe$Just($author$project$Components$Plan$Form$CoveragePlanAll(coveragePlan))), form));
                            }
                        }();
                        var newModel = _v65.a;
                        var formCmd = _v65.b;
                        var newAddCoveragePlanModal = _v65.c;
                        return _Utils_Tuple3(_Utils_update(newModel, {
                            hm: newAddCoveragePlanModal
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$AddCoveragePlanModalMsg, addCoveragePlanModalResult.EQ),
                            formCmd
                        ])), addCoveragePlanModalResult.at);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 21:
                var subMsg = msg.a;
                return A6($author$project$Components$Plan$Form$updateDateInputFormField, model, function($) {
                    return $.r8;
                }, F2(function(newDateInput, model_) {
                    return _Utils_update(model_, {
                        r8: newDateInput
                    });
                }), subMsg, $author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg, $author$project$Components$Plan$Form$PlanChangeChangeOnDate);
            case 22:
                var subMsg = msg.a;
                var _v67 = model.gt;
                if (!_v67.$) {
                    var planChangeToPlanResourceFilter = _v67.a;
                    var planChangeToPlanResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planChangeToPlanResourceFilter);
                    var newForm = function() {
                        var _v68 = _Utils_Tuple2(model.PU, planChangeToPlanResourceFilterResult.adu);
                        if (!_v68.a.$ && !_v68.b.$ && !_v68.b.a.$) {
                            if (!_v68.b.a.a.$) {
                                var _v69 = _v68.a.a;
                                var plan = _v69.a;
                                var form = _v69.b;
                                var newPlan = _v68.b.a.a.a;
                                return $elm$core$Maybe$Just(_Utils_Tuple2(plan, A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$PlanChangeToPlan($elm$core$Maybe$Just(newPlan)), form)));
                            } else {
                                var _v70 = _v68.a.a;
                                var plan = _v70.a;
                                var form = _v70.b;
                                return $elm$core$Maybe$Just(_Utils_Tuple2(plan, A3($author$project$Utils$Form$update, $author$project$Components$Plan$Form$formFieldsUpdate(plan), $author$project$Components$Plan$Form$PlanChangeToPlan($elm$core$Maybe$Nothing), form)));
                            }
                        } else return model.PU;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm,
                        gt: $elm$core$Maybe$Just(planChangeToPlanResourceFilterResult.zi)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg, planChangeToPlanResourceFilterResult.EQ), planChangeToPlanResourceFilterResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 23:
                var _v71 = model.PU;
                if (!_v71.$) {
                    var _v72 = _v71.a;
                    var plan = _v72.a;
                    return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New({
                        aef: $author$project$Api$Provider$Plan$One$id(plan)
                    })), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var _v73 = model.PU;
                if (!_v73.$) {
                    var _v74 = _v73.a;
                    var plan = _v74.a;
                    var _v75 = $author$project$Api$Provider$Plan$One$upcomingPricingVersion(plan);
                    if (!_v75.$) {
                        var pricingVersion = _v75.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String({
                            aef: $author$project$Api$Provider$Plan$One$id(plan),
                            ago: $author$project$Api$Provider$PricingVersion$Shared$id(pricingVersion)
                        })), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$CompanyPlans$Id_String$update = F2(function(msg, model) {
        return A2($author$project$Utils$Tuple3$mapFirst, function(planForm) {
            return _Utils_update(model, {
                nB: planForm
            });
        }, A3($author$project$Components$Plan$Form$update, model.Ej, msg, model.nB));
    });
    var $author$project$Components$Plan$Form$DeletePlan = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$Save = {
        $: 11
    };
    var $author$project$Api$Provider$Plan$Shared$isDestroyable = function(_v0) {
        var record = _v0;
        return record.R1;
    };
    var $author$project$Api$Provider$Plan$One$isDestroyable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$isDestroyable(shared);
    };
    var $author$project$Ui$Link$Mailto = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Link$mailto = F3(function(mailto_, options, content) {
        return A2($author$project$Ui$Link$view, A2($elm$core$List$cons, $author$project$Ui$Link$Mailto(mailto_), options), content);
    });
    var $author$project$Api$Provider$Plan$One$usedInScheduledPlanChanges = function(_v0) {
        var record = _v0.b;
        return record.aaW;
    };
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$Save = {
        $: 0
    };
    var $author$project$Components$ResourceFilter$Errors = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$errors = $author$project$Components$ResourceFilter$Errors;
    var $author$project$Components$ResourceFilter$Invalid = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$invalid = $author$project$Components$ResourceFilter$Invalid;
    var $author$project$Components$ResourceFilter$CoveragePlan$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Plan$Form$AddCoveragePlanModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Plan$Form$AddCoveragePlanModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title((_Utils_eq(model.aef, $elm$core$Maybe$Nothing) ? 'Add' : 'Change') + ' Coverage Plan')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$onSubmit($author$project$Components$Plan$Form$AddCoveragePlanModal$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8),
                        $author$project$Ui$Form$Group$label('Coverage Plan'),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Plan$Form$AddCoveragePlanModal$CoveragePlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$CoveragePlan$view, _List_fromArray([
                            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                        ]), model.w$))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$AddCoveragePlanModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                function() {
                    var verb = _Utils_eq(model.aef, $elm$core$Maybe$Nothing) ? 'Add' : 'Update';
                    return A3($author$project$Ui$Button$view, {
                        abP: verb
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$AddCoveragePlanModal$Save)
                    ]), _List_fromArray([
                        $elm$html$Html$text(verb)
                    ]));
                }()
            ]))
        ]));
    };
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$Confirm = {
        $: 1
    };
    var $author$project$Api$Provider$Plan$Shared$activeCompaniesCount = function(_v0) {
        var record = _v0;
        return record.Is;
    };
    var $author$project$Api$Provider$Plan$One$activeCompaniesCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$activeCompaniesCount(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount = function(_v0) {
        var record = _v0;
        return record.Iv;
    };
    var $author$project$Api$Provider$Plan$One$activeMembershipPatientsCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount(shared);
    };
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$maxPatientsCount = 100;
    var $author$project$Ui$Types$Sm = 1;
    var $author$project$Ui$Spinner$small = $author$project$Ui$Spinner$Size(1);
    var $author$project$Api$Provider$Practice$Shared$usesSponsors = function(_v0) {
        var record = _v0;
        return record.aa3;
    };
    var $author$project$Api$Provider$Practice$One$usesSponsors = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$usesSponsors(shared);
    };
    var $author$project$Formatters$String$sponsorize = F2(function(practice, string) {
        if ($author$project$Api$Provider$Practice$One$usesSponsors(practice)) switch(string){
            case 'employee':
                return 'member';
            case 'Employee':
                return 'Member';
            case 'employees':
                return 'members';
            case 'employer':
                return 'sponsor';
            case 'employers':
                return 'sponsors';
            case 'Employer':
                return 'Sponsor';
            case 'Employers':
                return 'Sponsors';
            case 'Company':
                return 'Sponsor';
            case 'Companies':
                return 'Sponsors';
            case 'Employer Invoices':
                return 'Sponsor Invoices';
            default:
                return string;
        }
        else return string;
    });
    var $author$project$Components$Plan$Form$ConfirmUpdateModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Plan$Form$ConfirmUpdateModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Confirm updates')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Updated membership pricing')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You\'re about to update membership pricing which may affect the rates of '),
                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Api$Provider$Plan$One$activeMembershipPatientsCount(model.GW))),
                        !$author$project$Api$Provider$Plan$One$planType(model.GW) ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('across '),
                            $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, A2($author$project$Formatters$String$sponsorize, model.W1, 'employer'), $author$project$Api$Provider$Plan$One$activeCompaniesCount(model.GW)))
                        ])) : $author$project$Utils$Html$empty,
                        $elm$html$Html$text(' on their next bill unless they have a manual rate set.')
                    ])),
                    model.VU.L5 ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Note: these pricing changes will apply to patients on this plan immediately, not at the end of their contract period.')
                    ])) : $author$project$Utils$Html$empty
                ])),
                model.jw.bW ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Added plan change')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You have enabled a plan change effective '),
                        function() {
                            var _v0 = model.jw.VU.ah5;
                            switch(_v0){
                                case 1:
                                    var changeAfterMonths = A2($elm$core$Maybe$withDefault, 0, model.jw.VU.K2);
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', changeAfterMonths)),
                                        $elm$html$Html$text(' after the membership starts.')
                                    ]));
                                case 0:
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('on '),
                                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), model.jw.VU.K3)))
                                    ]));
                                default:
                                    var contractPeriodInMonths = A2($elm$core$Maybe$withDefault, 0, model.jw.VU.L6);
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths)),
                                        $elm$html$Html$text(' after the membership starts.')
                                    ]));
                            }
                        }(),
                        function() {
                            var _v1 = model.Wd;
                            switch(_v1.$){
                                case 3:
                                    var patientsCount = _v1.a;
                                    return A2($author$project$Ui$Typography$span, _List_Nil, function() {
                                        if (!patientsCount.$) {
                                            if (!patientsCount.a) return _List_fromArray([
                                                $author$project$Utils$Html$noBreakSpace,
                                                $elm$html$Html$text('No patients with this plan will be transitioned to the new plan if you confirm this.')
                                            ]);
                                            else {
                                                var count = patientsCount.a;
                                                return _List_fromArray([
                                                    $author$project$Utils$Html$noBreakSpace,
                                                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', count)),
                                                    $elm$html$Html$text(' with this plan will be immediately transitioned to the new plan if you confirm this. '),
                                                    $elm$html$Html$text('You will receive an email with an attachment containing the patient ids of the patients affected.')
                                                ]);
                                            }
                                        } else return _List_fromArray([
                                            $author$project$Utils$Html$noBreakSpace,
                                            $elm$html$Html$text('More than '),
                                            $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Components$Plan$Form$ConfirmUpdateModal$maxPatientsCount)),
                                            $elm$html$Html$text(' with this plan will be immediately transitioned to the new plan if you confirm this. '),
                                            $elm$html$Html$text('You will receive an email with an attachment containing the patient ids of the patients affected.')
                                        ]);
                                    }());
                                case 0:
                                    return $author$project$Utils$Html$empty;
                                default:
                                    return $author$project$Ui$Spinner$view(_List_fromArray([
                                        $author$project$Ui$Spinner$small
                                    ]));
                            }
                        }()
                    ]))
                ])) : $author$project$Utils$Html$empty,
                model.jw.jN ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Removed plan change')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You have removed the plan change. '),
                        $elm$html$Html$text('All the memberships that were already transitioned to the new plan will not be moved back.')
                    ]))
                ])) : $author$project$Utils$Html$empty
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ConfirmUpdateModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Confirm updates'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ConfirmUpdateModal$Confirm)
                ]), _List_fromArray([
                    $elm$html$Html$text('Confirm updates')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Plan$Form$modal = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.fr;
                if (!_v0.$) {
                    var _v1 = _v0.a;
                    var plan = _v1.a;
                    var deleteRequest = _v1.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Plan$Form$DeleteHiConfirmClosed(plan), A2($elm$core$List$cons, $author$project$Components$HiConfirm$noun('plan'), A2($elm$core$List$cons, $author$project$Components$HiConfirm$verb('delete'), A2($elm$core$List$cons, $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading)), $author$project$Api$Provider$Plan$One$usedInScheduledPlanChanges(plan) ? _List_fromArray([
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('This plan is used in scheduled plan changes. Deleting it will remove those scheduled changes from existing and new memberships.')
                        ]))
                    ]) : _List_Nil))));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v2 = model.hT;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var confirmUpdateModal = _v3.b;
                    return A2($elm$html$Html$map, $author$project$Components$Plan$Form$ConfirmUpdateModalMsg, $author$project$Components$Plan$Form$ConfirmUpdateModal$view(confirmUpdateModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v4 = model.hm;
                if (!_v4.$) {
                    var addCoveragePlanModal = _v4.a;
                    return A2($elm$html$Html$map, $author$project$Components$Plan$Form$AddCoveragePlanModalMsg, $author$project$Components$Plan$Form$AddCoveragePlanModal$view(addCoveragePlanModal));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Ui$Grid$offsetSm = $author$project$Ui$Grid$Offset(1);
    var $author$project$Ui$Panel$OnlyBorderLeft = {
        $: 3
    };
    var $author$project$Ui$Panel$onlyBorderLeft = $author$project$Ui$Panel$OnlyBorderLeft;
    var $author$project$Components$Plan$Form$viewBackButton = function(listRoute) {
        return A3($author$project$Ui$Link$route, listRoute, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Back')
        ]));
    };
    var $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory = {
        $: 8
    };
    var $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription = {
        $: 22
    };
    var $author$project$Components$Plan$BasicForm$RegistrationFeeDescription = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$RegistrationFeeName = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$Addon = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Feature$MultipleRetailMemberships = 17;
    var $author$project$Ui$Form$Group$LabelHelp = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$labelHelp = $author$project$Ui$Form$Group$LabelHelp;
    var $author$project$Components$Plan$BasicForm$viewAddonPlanField = F3(function(form, settings, forCompany) {
        var hasMultipleMemberships = A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, settings.W1);
        var showAddonToggle = hasMultipleMemberships && settings.yu && !forCompany;
        if (showAddonToggle) {
            var _v0 = $author$project$Utils$Form$fields(form);
            var addon = _v0.IF;
            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Enrollment Settings')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$offsetLabel,
                    $author$project$Ui$Form$Group$labelSpanSm(5),
                    $author$project$Ui$Form$Group$inputSpanSm(6),
                    $author$project$Ui$Form$Group$label('Add-On Plan'),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Patients can enroll in multiple add-ons at once'))
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(addon),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Addon))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Plan$BasicForm$BillsAtEndOfPeriod = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$DefaultChargeDescription = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$DefaultChargeName = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$EditDefaultChargeDescription = {
        $: 7
    };
    var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonths = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonthsRule = 0;
    var $author$project$Components$Plan$BasicForm$ToggleRule = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$PeriodInMonthsInput$view = function(_v0) {
        var value = _v0.aa9;
        var onInput = _v0.afE;
        var invalid = _v0.q2;
        var errors = _v0.fK;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Form$Input$group(_List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
                    $author$project$Ui$Form$Input$onInput(onInput),
                    $author$project$Ui$Form$Input$invalid(invalid)
                ])),
                $author$project$Ui$Form$Input$addon(_List_fromArray([
                    A2($elm$core$Maybe$withDefault, 0, value) === 1 ? $elm$html$Html$text('month') : $elm$html$Html$text('months')
                ]))
            ])),
            $author$project$Utils$FormErrors$view(errors)
        ]));
    };
    var $author$project$Ui$SupportDocumentLink$view = function(supportDocumenUrl) {
        return A3($author$project$Ui$Link$externalHref, supportDocumenUrl, _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                A3($author$project$Ui$Tooltip$view, _List_Nil, 'Click to Learn More', _List_fromArray([
                    $author$project$Ui$Icon$help(_List_Nil)
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Plan$BasicForm$DefaultPeriod = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$Meta$allPeriodCodes = function(_v0) {
        var meta = _v0;
        return meta.I6;
    };
    var $author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes = _List_fromArray([
        'month',
        'quarter',
        'semi_annual',
        'annual'
    ]);
    var $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercent = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$AnnualAllowed = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$MonthAllowed = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercent = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$QuarterAllowed = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercent = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$SemiAnnualAllowed = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Ui$Form$PercentageInput$Invalid = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$PercentageInput$invalid = $author$project$Ui$Form$PercentageInput$Invalid;
    var $author$project$Ui$Grid$None = 0;
    var $author$project$Ui$Grid$noGutter = $author$project$Ui$Grid$Gutter(0);
    var $author$project$Ui$Form$PercentageInput$OnInput = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$PercentageInput$onInput = $author$project$Ui$Form$PercentageInput$OnInput;
    var $author$project$Ui$Grid$rowItemsEnd = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$itemsEnd);
    var $author$project$Ui$Form$PercentageInput$Value = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$PercentageInput$value = $author$project$Ui$Form$PercentageInput$Value;
    var $author$project$Ui$Form$PercentageInput$defaultOptions = {
        fK: _List_Nil,
        aq: _List_Nil,
        q2: false,
        aa9: $elm$core$Maybe$Nothing
    };
    var $author$project$Percentage$fromString = $elm$core$Basics$identity;
    var $author$project$Ui$Form$PercentageInput$inputHandler = function(handler) {
        return A2($elm$core$Basics$composeR, $author$project$Utils$String$toMaybe, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Percentage$fromString), handler));
    };
    var $author$project$Percentage$toString = function(_v0) {
        var string = _v0;
        return string;
    };
    var $author$project$Ui$Form$PercentageInput$inputValue = function(percentage) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Percentage$toString, percentage));
    };
    var $author$project$Ui$Form$PercentageInput$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var handler = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$onInput($author$project$Ui$Form$PercentageInput$inputHandler(handler)), record.aq)
                    });
                case 1:
                    var percentage = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$value($author$project$Ui$Form$PercentageInput$inputValue(percentage)), record.aq),
                        aa9: percentage
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        q2: bool
                    });
                case 3:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
                case 4:
                    var string = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$placeholder(string), record.aq)
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$disabled(bool), record.aq)
                    });
            }
        }), $author$project$Ui$Form$PercentageInput$defaultOptions, options);
    };
    var $author$project$Ui$Form$PercentageInput$view = function(options) {
        var optionsRecord = $author$project$Ui$Form$PercentageInput$optionsToRecord(options);
        return $author$project$Ui$Form$Input$group(_List_fromArray([
            $author$project$Ui$Form$Input$view(A2($elm$core$List$cons, $author$project$Ui$Form$Input$invalid(optionsRecord.q2), A2($elm$core$List$cons, $author$project$Ui$Form$Input$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$Input$number, optionsRecord.aq)))),
            $author$project$Ui$Form$Input$addon(_List_fromArray([
                $elm$html$Html$text('%')
            ]))
        ]));
    };
    var $author$project$Components$Plan$BasicForm$viewPeriodField = F3(function(defaultPeriod, form, periodCode) {
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = function() {
            switch(periodCode){
                case 'month':
                    return _Utils_Tuple2(fields.zk, $author$project$Components$Plan$BasicForm$MonthAllowed);
                case 'quarter':
                    return _Utils_Tuple2(fields.Bx, $author$project$Components$Plan$BasicForm$QuarterAllowed);
                case 'semi_annual':
                    return _Utils_Tuple2(fields.Co, $author$project$Components$Plan$BasicForm$SemiAnnualAllowed);
                case 'annual':
                    return _Utils_Tuple2(fields.vv, $author$project$Components$Plan$BasicForm$AnnualAllowed);
                default:
                    return _Utils_Tuple2(fields.zk, $author$project$Components$Plan$BasicForm$MonthAllowed);
            }
        }();
        var on = _v0.a;
        var field = _v0.b;
        return !_Utils_eq(periodCode, defaultPeriod) ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsEnd,
                $author$project$Ui$Grid$noGutter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4),
                    $author$project$Ui$Grid$offsetSm(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small
                        ]), _List_fromArray([
                            $author$project$Utils$Html$noBreakSpace
                        ])),
                        $elm$html$Html$text($author$project$Formatters$String$humanize(periodCode)),
                        $elm$html$Html$text('ly')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(2),
                    $author$project$Ui$Grid$justifyLeft
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(on),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, field))
                    ]))
                ])),
                function() {
                    if (on) {
                        var _v2 = function() {
                            switch(periodCode){
                                case 'month':
                                    return _Utils_Tuple3(fields.zj, $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent, 1);
                                case 'quarter':
                                    return _Utils_Tuple3(fields.Bw, $author$project$Components$Plan$BasicForm$QuarterAdjustmentPercent, 2);
                                case 'semi_annual':
                                    return _Utils_Tuple3(fields.Cn, $author$project$Components$Plan$BasicForm$SemiAnnualAdjustmentPercent, 3);
                                case 'annual':
                                    return _Utils_Tuple3(fields.vu, $author$project$Components$Plan$BasicForm$AnnualAdjustmentPercent, 4);
                                default:
                                    return _Utils_Tuple3(fields.zj, $author$project$Components$Plan$BasicForm$MonthAdjustmentPercent, 1);
                            }
                        }();
                        var adjustmentPercentage = _v2.a;
                        var adjustmentField = _v2.b;
                        var adjustmentValidation = _v2.c;
                        return A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(4)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                function() {
                                    switch(defaultPeriod){
                                        case 'month':
                                            return $elm$html$Html$text('Default Discount');
                                        case 'annual':
                                            return $elm$html$Html$text('Default Surcharge');
                                        default:
                                            return $author$project$Utils$Html$empty;
                                    }
                                }()
                            ])),
                            $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                                $author$project$Ui$Form$PercentageInput$value(adjustmentPercentage),
                                $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, adjustmentField)),
                                $author$project$Ui$Form$PercentageInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, adjustmentValidation, form))
                            ])),
                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, adjustmentValidation, form))
                        ]));
                    } else return $author$project$Ui$Grid$none;
                }()
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Plan$BasicForm$viewBillingPeriodsFields = F3(function(practiceIsOnboarding, maybePlan, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var billsAtEndOfPeriod = _v0.Kh;
        var defaultPeriod = _v0.Nx;
        var formGroupOptions = _Utils_ap(billsAtEndOfPeriod ? _List_fromArray([
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('You can only bill monthly when billing at the end of the period'))
        ]) : _List_Nil, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label(practiceIsOnboarding ? 'Default Billing Period is month' : 'Default Billing Period'),
            $author$project$Ui$Form$Group$labelClass('')
        ]));
        return A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, formGroupOptions, _List_fromArray([
            practiceIsOnboarding ? $author$project$Utils$Html$empty : $author$project$Ui$Button$group(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Select annual period'
                }, _List_fromArray([
                    $author$project$Ui$Button$disabled(billsAtEndOfPeriod),
                    $author$project$Ui$Button$active(defaultPeriod === 'annual'),
                    $author$project$Ui$Button$onClick($author$project$Components$Plan$BasicForm$FormUpdated($author$project$Components$Plan$BasicForm$DefaultPeriod(true)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Annual')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Select monthly period'
                }, _List_fromArray([
                    $author$project$Ui$Button$disabled(billsAtEndOfPeriod),
                    $author$project$Ui$Button$active(defaultPeriod !== 'annual'),
                    $author$project$Ui$Button$onClick($author$project$Components$Plan$BasicForm$FormUpdated($author$project$Components$Plan$BasicForm$DefaultPeriod(false)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Month')
                ]))
            ]))
        ])), function() {
            if (!billsAtEndOfPeriod) {
                var allPeriodCodes = function() {
                    if (!maybePlan.$) {
                        var plan = maybePlan.a;
                        var meta = $author$project$Api$Provider$Plan$One$meta(plan);
                        return $author$project$Api$Provider$Plan$Meta$allPeriodCodes(meta);
                    } else return $author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes;
                }();
                return A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$offsetLabel,
                    $author$project$Ui$Form$Group$labelSpanSm(5),
                    $author$project$Ui$Form$Group$inputSpanSm(6),
                    $author$project$Ui$Form$Group$label('Additional billing periods'),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$labelHelp(defaultPeriod === 'month' ? $elm$html$Html$text('Offer a percentage off pre-paid memberships') : $elm$html$Html$text('Set a surcharge for shorter billing periods'))
                ]), _List_Nil), A2($elm$core$List$map, A2($author$project$Components$Plan$BasicForm$viewPeriodField, defaultPeriod, form), allPeriodCodes));
            } else return _List_Nil;
        }());
    });
    var $author$project$Components$Plan$BasicForm$viewBillingOptionsFields = F3(function(practiceIsOnboarding, maybePlan, form) {
        var isMcePlan = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$isMcePlan, maybePlan));
        var forCompany = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(plan) {
            return !$author$project$Api$Provider$Plan$One$planType(plan);
        }, maybePlan));
        var editingPlan = !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing);
        var showForm = !forCompany && editingPlan && !practiceIsOnboarding && !isMcePlan;
        var _v0 = $author$project$Utils$Form$fields(form);
        var billsAtEndOfPeriod = _v0.Kh;
        var rules = _v0.Zk;
        var minimumEnrollmentPeriodInMonths = _v0.Up;
        var defaultPeriod = _v0.Nx;
        var defaultChargeName = _v0.xc;
        var defaultChargeDescription = _v0.xb;
        var editingDefaultChargeDescription = _v0.qr;
        return A2($author$project$Ui$Typography$div, _List_Nil, $elm$core$List$concat(_List_fromArray([
            $elm$core$List$singleton(A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Do you want to allow patients to pay you in advance?')
                ])),
                A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
            ]))),
            function() {
                if (showForm) {
                    var disableToggle = function() {
                        if (!maybePlan.$) {
                            var plan = maybePlan.a;
                            return $author$project$Api$Provider$Plan$One$activeMembershipPatientsCount(plan) > 0;
                        } else return false;
                    }();
                    return $elm$core$List$singleton(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$labelSpanSm(5),
                        $author$project$Ui$Form$Group$inputSpanSm(6),
                        $author$project$Ui$Form$Group$label('Bill at the End of the Billing Period'),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('This will only impact newly created memberships'))
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(billsAtEndOfPeriod),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$BillsAtEndOfPeriod)),
                            $author$project$Ui$ToggleSwitch$disabled(disableToggle)
                        ]))
                    ])));
                } else return _List_Nil;
            }(),
            isMcePlan ? _List_Nil : A3($author$project$Components$Plan$BasicForm$viewBillingPeriodsFields, practiceIsOnboarding, maybePlan, form),
            showForm ? $elm$core$List$singleton(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Minimum Initial Enrollment Period'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('You may prevent patients from cancelling for up to 12 months')),
                $author$project$Ui$Form$Group$required(rules.Up.OM)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                $author$project$Ui$ToggleSwitch$on(rules.Up.OM),
                                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$ToggleRule(0)))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), _List_fromArray([
                        rules.Up.OM ? $author$project$Ui$Form$PeriodInMonthsInput$view({
                            fK: A2($author$project$Utils$Form$validationErrors, 5, form),
                            q2: A2($author$project$Utils$Form$hasValidationErrors, 5, form),
                            afE: A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$MinimumEnrollmentPeriodInMonths),
                            aa9: minimumEnrollmentPeriodInMonths
                        }) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]))) : _List_Nil,
            editingPlan && !practiceIsOnboarding ? $elm$core$List$singleton(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Invoice Detail'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('How would you like these charges to be shown on your invoices?')),
                $author$project$Ui$Form$Group$required(rules.Up.OM)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Charge Name')
                        ])),
                        $author$project$Ui$Form$Input$group(_List_fromArray([
                            $author$project$Ui$Form$Input$addon(_List_fromArray([
                                defaultPeriod === 'month' ? $elm$html$Html$text('Monthly') : $elm$html$Html$text('Annual')
                            ])),
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(defaultChargeName),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$DefaultChargeName)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 6, form))
                            ]))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 6, form))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Charge Description')
                        ])),
                        editingDefaultChargeDescription ? $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', defaultChargeDescription)),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$DefaultChargeDescription)),
                            $author$project$Ui$Form$Input$phi(true),
                            $author$project$Ui$Form$Input$placeholder('None')
                        ])) : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit default charge description'
                            }, _List_fromArray([
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Components$Plan$BasicForm$FormUpdated($author$project$Components$Plan$BasicForm$EditDefaultChargeDescription))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ])),
                            function() {
                                if (!defaultChargeDescription.$) {
                                    var defaultChargeDescription_ = defaultChargeDescription.a;
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(defaultChargeDescription_)
                                    ]));
                                } else return A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    $elm$html$Html$text('None')
                                ]));
                            }()
                        ]))
                    ]))
                ]))
            ]))) : _List_Nil
        ])));
    });
    var $author$project$Components$Plan$BasicForm$ImageUploaded = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$viewImageField = F2(function(errors, currentImageUrl) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label('Plan Image'),
            $author$project$Ui$Form$Group$labelClass('')
        ]), _List_fromArray([
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$accept(0),
                $author$project$Ui$Form$File$onInput($author$project$Components$Plan$BasicForm$ImageUploaded)
            ])),
            function() {
                if (!currentImageUrl.$) {
                    if (currentImageUrl.a === '') return $author$project$Utils$Html$empty;
                    else {
                        var url = currentImageUrl.a;
                        return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mt2
                        ]), _List_fromArray([
                            A3($author$project$Ui$Image$fromSrc, {
                                Jg: 'Plan image'
                            }, url, _List_fromArray([
                                $author$project$Ui$Image$height(100)
                            ]))
                        ]));
                    }
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Utils$FormErrors$view(errors)
        ]));
    });
    var $author$project$Components$Plan$BasicForm$Buyable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$viewNameAndDescriptionFields = F4(function(fields, nameErrors, forCompany, buyableEditable) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Plan Name & Description')
            ])),
            !forCompany ? A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('This will be displayed to your patients when they enroll through online signup')
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Plan Name'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Name)),
                    $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(nameErrors)),
                    $author$project$Ui$Form$Input$errors(nameErrors)
                ]))
            ])),
            A2($elm$html$Html$map, $author$project$Components$Plan$BasicForm$DescriptionMsg, A2($author$project$Components$TranslatedRichText$view, {
                adg: 'plan-description-editor',
                aeI: 'Plan Description',
                afr: true
            }, fields.NQ)),
            buyableEditable ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Allow members to enroll via Patient Portal'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.Ky),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$Buyable))
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCentsRule = 0;
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCents = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCentsRule = 1;
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Category$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields = F4(function(parentFormData, onParentFieldMsg, onComponentMsg, _v0) {
        var form = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$mb2,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Registration Fees')
                ])),
                A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Fee for Individual'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$required(fields.Zk.Rd.OM)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(fields.Zk.Rd.OM),
                            $author$project$Ui$ToggleSwitch$onChange(function(_v1) {
                                return onComponentMsg($author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated($author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule(0)));
                            })
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), _List_fromArray([
                        fields.Zk.Rd.OM ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                                $author$project$Ui$Form$CurrencyInput$value(fields.Rd),
                                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, onComponentMsg, $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated), $author$project$Components$Plan$Form$RegistrationFeePricingFields$IndividualRegistrationFeeInCents)),
                                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                            ])),
                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Max fee for family'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$required(fields.Zk.TN.OM)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(fields.Zk.TN.OM),
                            $author$project$Ui$ToggleSwitch$onChange(function(_v2) {
                                return onComponentMsg($author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated($author$project$Components$Plan$Form$RegistrationFeePricingFields$ToggleRule(1)));
                            })
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), _List_fromArray([
                        fields.Zk.TN.OM ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                                $author$project$Ui$Form$CurrencyInput$value(fields.TN),
                                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, onComponentMsg, $author$project$Components$Plan$Form$RegistrationFeePricingFields$FormUpdated), $author$project$Components$Plan$Form$RegistrationFeePricingFields$MaxRegistrationFeeInCents)),
                                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                            ])),
                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form))
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Invoice Detail'),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('How would you like these charges to be shown on your invoices?')),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Charge Name')
                        ])),
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(parentFormData.BH),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, onParentFieldMsg, parentFormData.afM)),
                            $author$project$Ui$Form$Input$invalid(parentFormData.ad4)
                        ])),
                        $author$project$Utils$FormErrors$view(parentFormData.agF)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Charge Description')
                        ])),
                        parentFormData.l1 ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(parentFormData.BG),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, onParentFieldMsg, parentFormData.afL)),
                                $author$project$Ui$Form$Input$invalid(false),
                                $author$project$Ui$Form$Input$placeholder('None')
                            ])),
                            $author$project$Utils$FormErrors$view(_List_Nil)
                        ])) : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit registration fee description'
                            }, _List_fromArray([
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick(onParentFieldMsg(parentFormData.afz))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ])),
                            function() {
                                var _v3 = $author$project$Utils$String$toMaybe(parentFormData.BG);
                                if (!_v3.$) {
                                    var description = _v3.a;
                                    return A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$muted
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(description)
                                    ]));
                                } else return A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    $elm$html$Html$text('None')
                                ]));
                            }()
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Charge Category')
                        ])),
                        function() {
                            if (!parentFormData.iB) return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Edit registration fee category'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$pull(1),
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$onClick(onParentFieldMsg(parentFormData.afy))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Edit')
                                ])),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    $elm$html$Html$text(parentFormData.K1)
                                ]))
                            ]));
                            else {
                                var _v4 = fields.cK;
                                if (!_v4.$) {
                                    var categoryResourceFilter = _v4.a;
                                    return A2($elm$html$Html$map, onComponentMsg, A2($elm$html$Html$map, $author$project$Components$Plan$Form$RegistrationFeePricingFields$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$view, _List_Nil, categoryResourceFilter)));
                                } else return $author$project$Utils$Html$empty;
                            }
                        }()
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCents = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes = function(_v0) {
        var meta = _v0;
        return meta.Jc;
    };
    var $author$project$Api$Period$numberOfMonths = function(_v0) {
        var period = _v0;
        return period.jk;
    };
    var $author$project$Api$Period$Period = $elm$core$Basics$identity;
    var $author$project$Api$Period$list = _List_fromArray([
        {
            lg: 'monthly',
            Lk: 'month',
            jk: 1,
            nR: 'Monthly'
        },
        {
            lg: 'quarterly',
            Lk: 'quarter',
            jk: 3,
            nR: 'Quarterly'
        },
        {
            lg: 'semi-annually',
            Lk: 'semi_annual',
            jk: 6,
            nR: 'Semi-Annual'
        },
        {
            lg: 'annually',
            Lk: 'annual',
            jk: 12,
            nR: 'Annual'
        }
    ]);
    var $author$project$Api$Period$retrieve = function(code_) {
        return A2($elm_community$list_extra$List$Extra$find, function(_v0) {
            var period = _v0;
            return _Utils_eq(period.Lk, code_);
        }, $author$project$Api$Period$list);
    };
    var $author$project$Components$Plan$BasicForm$fixedFeeAmountForPeriod = F4(function(fields, defaultPeriod, sponsorFeeDealAmountInCents, periodCode) {
        var period = $author$project$Api$Period$retrieve(periodCode);
        var periodInMonths = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $author$project$Api$Period$numberOfMonths, period));
        var amount = function(amount_) {
            return defaultPeriod === 'annual' ? amount_ / 12 | 0 : amount_;
        }(periodInMonths * A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, sponsorFeeDealAmountInCents)));
        var adjustment = _Utils_eq(defaultPeriod, periodCode) ? 0 : function(adjustment_) {
            return defaultPeriod === 'month' ? adjustment_ * -1 : adjustment_;
        }(function() {
            switch(periodCode){
                case 'month':
                    return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.zj));
                case 'quarter':
                    return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Bw));
                case 'semi_annual':
                    return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Cn));
                case 'annual':
                    return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.vu));
                default:
                    return 0;
            }
        }());
        return $elm$core$Basics$round(amount * (1 + adjustment / 100));
    });
    var $author$project$Components$Plan$BasicForm$viewPeriod = F4(function(fields, defaultPeriod, sponsorFeeDealAmountInCents, allowedPeriod) {
        return !_Utils_eq(defaultPeriod, allowedPeriod) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(12)
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(allowedPeriod)),
                $author$project$Utils$Html$noBreakSpace,
                $elm$html$Html$text($author$project$Utils$Currency$fromInt(A4($author$project$Components$Plan$BasicForm$fixedFeeAmountForPeriod, fields, defaultPeriod, sponsorFeeDealAmountInCents, allowedPeriod)))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Plan$BasicForm$viewSponsorFeeDealFields = F3(function(practiceIsOnboarding, plan, form) {
        var meta = $author$project$Api$Provider$Plan$One$meta(plan);
        var allowedPeriodCodes = $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta);
        var fields = $author$project$Utils$Form$fields(form);
        var defaultPeriod = fields.Nx;
        var sponsorFeeDealAmountInCents = fields.Hy;
        return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label('Amount'),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(defaultPeriod)),
                $elm$html$Html$text(' rate')
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$value(sponsorFeeDealAmountInCents),
                    $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$SponsorFeeDealAmountInCents)),
                    $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 7, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 7, form))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, A3($author$project$Components$Plan$BasicForm$viewPeriod, fields, defaultPeriod, sponsorFeeDealAmountInCents), allowedPeriodCodes))
        ])), A3($author$project$Components$Plan$BasicForm$viewBillingPeriodsFields, practiceIsOnboarding, $elm$core$Maybe$Just(plan), form)));
    });
    var $author$project$Components$Plan$BasicForm$view = F2(function(_v0, maybePlan) {
        var settings = _v0.a;
        var form = _v0.b;
        var planType = A2($elm$core$Maybe$withDefault, 2, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$planType, maybePlan));
        var forCompany = !planType;
        var fields = $author$project$Utils$Form$fields(form);
        var errorsFor = function(group) {
            return A2($author$project$Utils$Form$validationErrors, group, form);
        };
        var buyableEditable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 23, settings.W1);
        return _List_fromArray([
            A4($author$project$Components$Plan$BasicForm$viewNameAndDescriptionFields, fields, errorsFor(0), forCompany, buyableEditable),
            buyableEditable ? A2($author$project$Components$Plan$BasicForm$viewImageField, errorsFor(10), fields.p7) : $author$project$Utils$Html$empty,
            $author$project$Utils$Html$noBreakSpace,
            A3($author$project$Components$Plan$BasicForm$viewAddonPlanField, form, settings, forCompany),
            $author$project$Utils$Html$noBreakSpace,
            A4($author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields, {
                K1: fields.sr,
                iB: fields.iB,
                l1: fields.l1,
                ad4: A2($author$project$Utils$Form$hasValidationErrors, 8, form),
                afy: $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory,
                afz: $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription,
                afL: $author$project$Components$Plan$BasicForm$RegistrationFeeDescription,
                afM: $author$project$Components$Plan$BasicForm$RegistrationFeeName,
                BG: fields.BG,
                BH: fields.BH,
                agF: A2($author$project$Utils$Form$validationErrors, 8, form)
            }, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, fields.de),
            function() {
                if (planType === 1) {
                    if (!maybePlan.$) {
                        var plan = maybePlan.a;
                        return A3($author$project$Components$Plan$BasicForm$viewSponsorFeeDealFields, settings.W4, plan, form);
                    } else return $author$project$Utils$Html$empty;
                } else return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    A3($author$project$Components$Plan$BasicForm$viewBillingOptionsFields, settings.W4, maybePlan, form)
                ]));
            }()
        ]);
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedRule = 1;
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleEnabled = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitRule = 0;
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedRule = 2;
    var $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleEnabled = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleFixedMembershipPricing = {
        $: 13
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$McePricing$One$coupleRates = function(_v0) {
        var record = _v0;
        return record.Mi;
    };
    var $author$project$Api$Provider$McePricing$One$familyRates = function(_v0) {
        var record = _v0;
        return record.Ps;
    };
    var $author$project$Utils$RateRule$groupTierCode = F2(function(retail, type_) {
        if (retail) switch(type_.$){
            case 0:
                return 'MEM';
            case 1:
                return 'MSP';
            case 2:
                return 'MCH';
            case 3:
                return 'FAM';
            case 4:
                return '';
            case 5:
                return '';
            case 6:
                return '';
            case 8:
                return '';
            case 9:
                return '';
            case 7:
                return '';
            default:
                return '';
        }
        else switch(type_.$){
            case 0:
                return 'EMP';
            case 1:
                return 'ESP';
            case 2:
                return 'ECH';
            case 3:
                return 'FAM';
            case 4:
                return '';
            case 5:
                return '';
            case 6:
                return '';
            case 8:
                return '';
            case 9:
                return '';
            case 7:
                return '';
            default:
                return '';
        }
    });
    var $author$project$Utils$RateRule$groupTierName = function(type_) {
        switch(type_.$){
            case 0:
                return 'Primary';
            case 1:
                return 'Primary + Spouse';
            case 2:
                return 'Primary + Children';
            case 3:
                return 'Family';
            case 4:
                return 'Primary + 1 Child';
            case 5:
                return 'Primary + Spouse + 1 Child';
            case 6:
                return 'Additional Adult Rate';
            case 7:
                return 'Additional Child Rate';
            case 8:
                return 'Age Based';
            case 9:
                return 'Age Based Couple';
            default:
                var name = type_.a;
                return name;
        }
    };
    var $author$project$Api$Provider$McePricing$One$individualRates = function(_v0) {
        var record = _v0;
        return record.Rc;
    };
    var $author$project$Ui$Form$Group$labelHtml = A2($elm$core$Basics$composeR, $author$project$Ui$Form$Group$Html, $author$project$Ui$Form$Group$Label);
    var $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates = function(_v0) {
        var record = _v0;
        return record._x;
    };
    var $author$project$Ui$Icon$Transfer = 49;
    var $author$project$Ui$Icon$transfer = $author$project$Ui$Icon$viewIcon(49);
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncluded = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAdultsLimitField = F5(function(label, enabled, value, form, onToggle) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label(label),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Turn off for no limit'))
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4),
                    $author$project$Ui$Grid$justifyLeft
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(enabled),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $elm$core$Basics$always(onToggle)))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8)
                ]), enabled ? _List_fromArray([
                    $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPreAddon, 'Up to and including', _List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncluded), $elm$core$String$toInt)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, form))
                    ]))),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyNumAdultsIncludedValidation, form))
                ]) : _List_Nil)
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimit = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAgeLimitField = F5(function(label, enabled, value, form, onToggle) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label(label),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Turn off for no limit. Children above the age limit will be billed as adults'))
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4),
                    $author$project$Ui$Grid$justifyLeft
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(enabled),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $elm$core$Basics$always(onToggle)))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8)
                ]), enabled ? _List_fromArray([
                    $author$project$Ui$Form$Input$group(_List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimit), $elm$core$String$toInt)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, form))
                        ])),
                        $author$project$Ui$Form$Input$addon(_List_fromArray([
                            $elm$html$Html$text('& under')
                        ]))
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$FixedChildrenAgeLimitValidation, form))
                ]) : _List_Nil)
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncluded = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewChildrenLimitField = F5(function(label, enabled, value, form, onToggle) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label(label),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Turn off for no limit'))
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4),
                    $author$project$Ui$Grid$justifyLeft
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(enabled),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $elm$core$Basics$always(onToggle)))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8)
                ]), enabled ? _List_fromArray([
                    $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPreAddon, 'Up to and including', _List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncluded), $elm$core$String$toInt)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, form))
                    ]))),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$GroupTierPricingFields$GroupPricingFamilyNumChildrenIncludedValidation, form))
                ]) : _List_Nil)
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCents = F3(function(a, b, c) {
        return {
            $: 16,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsEdit = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsReset = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRulePeriod = F5(function(defaultPeriod, form, rule, isDiscount, period) {
        var _v0 = function() {
            switch(period){
                case 'month':
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
                case 'quarter':
                    return _Utils_Tuple3(rule.XU, rule.XV, rule.gx);
                case 'semi_annual':
                    return _Utils_Tuple3(rule.ZH, rule.ZI, rule.gM);
                case 'annual':
                    return _Utils_Tuple3(rule.Jk, rule.Jl, rule.e3);
                default:
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
            }
        }();
        var periodAmountInCents = _v0.a;
        var editingPeriod = _v0.b;
        var periodEdited = _v0.c;
        return A2($author$project$Ui$Typography$div, _List_Nil, _Utils_eq(defaultPeriod, period) || editingPeriod ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
            ])),
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, rule.Vp(period))),
                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, rule.GU(period), form))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, rule.GU(period), form))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
                    isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    periodEdited ? A3($author$project$Ui$Button$view, {
                        abP: 'Reset period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated(rule.YS(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Reset')
                    ])) : $author$project$Utils$Html$empty,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated(rule.Or(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRule = F5(function(defaultPeriod, form, periods, rule, isDiscount) {
        return A2($elm$core$List$map, A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRulePeriod, defaultPeriod, form, rule, isDiscount), periods);
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule = F4(function(defaultPeriod, plan, form, fixedRateRule) {
        var meta = $author$project$Api$Provider$Plan$One$meta(plan);
        return A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewAmountInCentsPricingRule, defaultPeriod, form, $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta), {
            Jk: fixedRateRule.Jk,
            e3: fixedRateRule.e3,
            Jl: fixedRateRule.Jl,
            Or: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsEdit(fixedRateRule.ah5),
            Uu: fixedRateRule.Uu,
            gb: fixedRateRule.gb,
            Gl: fixedRateRule.Gl,
            Vp: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCents(fixedRateRule.ah5),
            GU: function(period) {
                return A2($author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsValidation, fixedRateRule.ah5, period);
            },
            XU: fixedRateRule.XU,
            gx: fixedRateRule.gx,
            XV: fixedRateRule.XV,
            YS: $author$project$Components$Plan$Form$GroupTierPricingFields$FixedRateRuleAmountInCentsReset(fixedRateRule.ah5),
            ZH: fixedRateRule.ZH,
            gM: fixedRateRule.gM,
            ZI: fixedRateRule.ZI
        }, false);
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Typography$ControlLabel = {
        $: 14
    };
    var $author$project$Ui$Typography$controlLabel = $author$project$Ui$Typography$ControlLabel;
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewRateSplitSection = F2(function(fields, form) {
        var currentFields = $author$project$Utils$Form$fields(form);
        var splitRevenueType = currentFields._P;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Rate Split')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('For memberships with more than one member, choose how the rate will be split.')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$controlLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text('With Spouse')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                            $author$project$Ui$Form$Radio$value(splitRevenueType === 'even_children'),
                            $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_children'))))
                        ]), _List_fromArray([
                            $elm$html$Html$text('The spouse receives the \"Primary + Spouse\" minus the \"Primary\" rate.'),
                            function() {
                                var _v0 = _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Mh.Uu), A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Rb.Uu));
                                if (!_v0.a.$ && !_v0.b.$) {
                                    var coupleMonthAmountInCents = _v0.a.a;
                                    var individualMonthAmountInCents = _v0.b.a;
                                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$small,
                                        $author$project$Ui$Typography$muted,
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Assign the primary member a rate of '),
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(individualMonthAmountInCents)),
                                        $elm$html$Html$text(', and the spouse a rate of '),
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(coupleMonthAmountInCents - individualMonthAmountInCents)),
                                        $elm$html$Html$text('.')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                            $author$project$Ui$Form$Radio$value(splitRevenueType === 'even_adult_children'),
                            $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_adult_children'))))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Primary and spouse split the the \"Primary + Spouse\" rate.'),
                            function() {
                                var _v1 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Mh.Uu);
                                if (!_v1.$) {
                                    var coupleMonthAmountInCents = _v1.a;
                                    var halfCoupleRate = $elm$core$Basics$floor(coupleMonthAmountInCents / 2);
                                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$small,
                                        $author$project$Ui$Typography$muted,
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Assign the primary member a rate of '),
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(coupleMonthAmountInCents - halfCoupleRate)),
                                        $elm$html$Html$text(', and the spouse a rate of '),
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(halfCoupleRate)),
                                        $elm$html$Html$text('.')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$controlLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text('With Children')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                            $author$project$Ui$Form$Checkbox$value(splitRevenueType !== 'even_all'),
                            $author$project$Ui$Form$Checkbox$disabled(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Split the remaining rate evenly among the children'),
                            function() {
                                var _v2 = _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Rb.Uu), A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields._w.Uu));
                                if (!_v2.a.$ && !_v2.b.$) {
                                    var individualMonthAmountInCents = _v2.a.a;
                                    var singleParentMonthAmountInCents = _v2.b.a;
                                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$small,
                                        $author$project$Ui$Typography$muted,
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('For single parents, assign the children a combined rate of '),
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(singleParentMonthAmountInCents - individualMonthAmountInCents)),
                                        $elm$html$Html$text(' divided evenly between them.'),
                                        $elm$html$Html$text('If there\'s only one child, assign them the entire '),
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(singleParentMonthAmountInCents - individualMonthAmountInCents)),
                                        $elm$html$Html$text('.')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            function() {
                                var _v3 = _Utils_Tuple2(A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Pr.Uu), A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Mh.Uu));
                                if (!_v3.a.$ && !_v3.b.$) {
                                    var familyMonthAmountInCents = _v3.a.a;
                                    var coupleMonthAmountInCents = _v3.b.a;
                                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$small,
                                        $author$project$Ui$Typography$muted,
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('For families, assign the children a combined rate of '),
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(familyMonthAmountInCents - coupleMonthAmountInCents)),
                                        $elm$html$Html$text(' divided evenly between them.')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$controlLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text('Everyone')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                            $author$project$Ui$Form$Radio$value(splitRevenueType === 'even_all'),
                            $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$Form$GroupTierPricingFields$SplitRevenueType('even_all'))))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Divide the group rate evenly across all members.'),
                            function() {
                                var _v4 = A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Pr.Uu);
                                if (!_v4.$) {
                                    var familyMonthAmountInCents = _v4.a;
                                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$small,
                                        $author$project$Ui$Typography$muted,
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('For a family of four, they will each receive a rate of '),
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($elm$core$Basics$round(familyMonthAmountInCents / 4))),
                                        $elm$html$Html$text('. If the family rate does not divide evenly, some individual rates will be '),
                                        $elm$html$Html$text('adjusted by a few pennies so that the individual rates will sum to the group rate.')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Api$Provider$McePricing$One$getLowestAgeBandPrice = function(ageBands) {
        return A2($elm$core$Maybe$map, function($) {
            return $.Br;
        }, $elm$core$List$head(ageBands));
    };
    var $author$project$Api$Provider$Plan$One$mcePricing = function(_v0) {
        var record = _v0.b;
        return record.TU;
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewMceLowestAgeBandValue = function(mceLowestAgeBandValue) {
        return $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
            function() {
                if (!mceLowestAgeBandValue.$) {
                    var mceValue_ = mceLowestAgeBandValue.a;
                    return $author$project$Ui$Form$CurrencyInput$value($elm$core$Maybe$Just($author$project$Currency$fromInt(mceValue_)));
                } else return $author$project$Ui$Form$CurrencyInput$value($elm$core$Maybe$Nothing);
            }(),
            $author$project$Ui$Form$CurrencyInput$disabled(true)
        ]));
    };
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing = F5(function(plan, defaultPeriod, fixedRateRule, mceRateRule, form) {
        var _v0 = $author$project$Api$Provider$Plan$One$mcePricing(plan);
        if (!_v0.$) {
            var maybePricing = _v0.a;
            return $elm$core$List$singleton($author$project$Components$Plan$Form$GroupTierPricingFields$viewMceLowestAgeBandValue(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$McePricing$One$getLowestAgeBandPrice, A2($elm$core$Maybe$map, mceRateRule, maybePricing))));
        } else return A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, defaultPeriod, plan, form, fixedRateRule);
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$viewGroupTierPricingFieldsWithSharedFields = F3(function(sharedFields, plan, _v0) {
        var form = _v0;
        var forCompany = !$author$project$Api$Provider$Plan$One$planType(plan);
        var fourTierHelpUrl = forCompany ? 'https://support.hint.com/employers/four-tier-pricing' : 'https://support.hint.com/account-configuration/four-tier-pricing-for-patients';
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Group Tier Pricing'),
                $author$project$Utils$Html$noBreakSpace,
                A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$SupportDocumentLink$view(fourTierHelpUrl))
            ])),
            $author$project$Api$Provider$Plan$One$isMcePlan(plan) ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                abP: ' Switch to Individual Rates with Discounts'
            }, _List_fromArray([
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated($author$project$Components$Plan$Form$GroupTierPricingFields$ToggleFixedMembershipPricing))
            ]), _List_fromArray([
                $author$project$Ui$Icon$transfer(_List_Nil),
                $elm$html$Html$text(' Switch to Individual Rates with Discounts')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Group Tier pricing assigns one of the defined tiers to every primary member and their dependents.')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text($author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Individual)),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Utils$RateRule$groupTierCode, $author$project$Api$Provider$Plan$One$planType(plan) === 2, $author$project$Api$RateRuleType$Individual))
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_Nil),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nx, fields.Rb, $author$project$Api$Provider$McePricing$One$individualRates, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text($author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Couple)),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Utils$RateRule$groupTierCode, $author$project$Api$Provider$Plan$One$planType(plan) === 2, $author$project$Api$RateRuleType$Couple))
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_Nil),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nx, fields.Mh, $author$project$Api$Provider$McePricing$One$coupleRates, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text($author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$FamilyWithSingleChild)),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Utils$RateRule$groupTierCode, $author$project$Api$Provider$Plan$One$planType(plan) === 2, $author$project$Api$RateRuleType$FamilyWithSingleChild))
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(fields.Pu),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$FamilyWithSingleChildRateRuleEnabled)),
                            $author$project$Ui$ToggleSwitch$disabled($author$project$Api$Provider$Plan$One$isMcePlan(plan))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), fields.Pu ? A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nx, fields.Pt, $author$project$Api$Provider$McePricing$One$familyRates, form) : _List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text($author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$SingleParent)),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Utils$RateRule$groupTierCode, $author$project$Api$Provider$Plan$One$planType(plan) === 2, $author$project$Api$RateRuleType$SingleParent))
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_Nil),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nx, fields._w, $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text($author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$SingleParentWithSingleChild)),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Utils$RateRule$groupTierCode, $author$project$Api$Provider$Plan$One$planType(plan) === 2, $author$project$Api$RateRuleType$SingleParentWithSingleChild))
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(fields._z),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$GroupTierPricingFields$FormUpdated, $author$project$Components$Plan$Form$GroupTierPricingFields$SingleParentWithSingleChildRateRuleEnabled)),
                            $author$project$Ui$ToggleSwitch$disabled($author$project$Api$Provider$Plan$One$isMcePlan(plan))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), fields._z ? A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nx, fields._y, $author$project$Api$Provider$McePricing$One$singleParentWithChildrenRates, form) : _List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text($author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$Family)),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Utils$RateRule$groupTierCode, $author$project$Api$Provider$Plan$One$planType(plan) === 2, $author$project$Api$RateRuleType$Family))
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_Nil),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateWithMcePricing, plan, sharedFields.Nx, fields.Pr, $author$project$Api$Provider$McePricing$One$familyRates, form))
                ]))
            ])),
            A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewAgeLimitField, 'Children Age Limit', fields.Zk.PO.OM, fields.PO, form, $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(0)),
            A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewAdultsLimitField, 'Limit Adults in Family Plan', fields.Zk.Pq.OM, fields.Pq, form, $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(1)),
            fields.Zk.Pq.OM ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text($author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$AdditionalAdult)),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Utils$RateRule$groupTierCode, $author$project$Api$Provider$Plan$One$planType(plan) === 2, $author$project$Api$RateRuleType$AdditionalAdult))
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('For group that don\'t fall into tiers above (i.e. 3 adults)'))
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_Nil),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, sharedFields.Nx, plan, form, fields.ID))
                ]))
            ])) : $elm$html$Html$text(''),
            A5($author$project$Components$Plan$Form$GroupTierPricingFields$viewChildrenLimitField, 'Limit Children in Family Plan', fields.Zk.Qg.OM, fields.Qg, form, $author$project$Components$Plan$Form$GroupTierPricingFields$ToggleRule(2)),
            fields.Zk.Qg.OM ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text($author$project$Utils$RateRule$groupTierName($author$project$Api$RateRuleType$AdditionalChild)),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Utils$RateRule$groupTierCode, $author$project$Api$Provider$Plan$One$planType(plan) === 2, $author$project$Api$RateRuleType$AdditionalChild))
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('For groups that exceed the children limit'))
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_Nil),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), A4($author$project$Components$Plan$Form$GroupTierPricingFields$viewFixedRateRule, sharedFields.Nx, plan, form, fields.IE))
                ]))
            ])) : $elm$html$Html$text(''),
            A2($author$project$Components$Plan$Form$GroupTierPricingFields$viewRateSplitSection, fields, form)
        ]));
    });
    var $author$project$Components$Plan$Form$GroupTierPricingFields$view = F3(function(sharedFields, maybePlan, groupTierPricingForm) {
        if (!maybePlan.$) {
            var plan = maybePlan.a;
            return A3($author$project$Components$Plan$Form$GroupTierPricingFields$viewGroupTierPricingFieldsWithSharedFields, sharedFields, plan, groupTierPricingForm);
        } else return $elm$html$Html$text('');
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAdd = {
        $: 0
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ToggleFixedMembershipPricing = {
        $: 10
    };
    var $elm_community$list_extra$List$Extra$zip = $elm$core$List$map2($elm$core$Tuple$pair);
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$rulesetHasGaps = function(rules) {
        if ($elm$core$List$length(rules) <= 1) return false;
        else {
            var pairs = A2($elm_community$list_extra$List$Extra$zip, rules, A2($elm$core$List$drop, 1, rules));
            return A2($elm$core$List$any, function(_v0) {
                var current = _v0.a;
                var next = _v0.b;
                var _v1 = current.$4;
                if (_v1.$ === 1) return false;
                else {
                    var currentTo = _v1.a;
                    if (_Utils_eq(current.aaG, next.aaG)) return _Utils_cmp(currentTo + 1, next.P_) < 0;
                    else {
                        var nextFromMonths = !next.aaG ? next.P_ * 12 : next.P_;
                        var currentToMonths = !current.aaG ? currentTo * 12 : currentTo;
                        return _Utils_cmp(currentToMonths + 1, nextFromMonths) < 0;
                    }
                }
            }, pairs);
        }
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCents = F3(function(a, b, c) {
        return {
            $: 4,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsEdit = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsReset = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleRemove = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleToAge = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleUnit = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Feature$AgeTieredCoupleRates = 20;
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCents = F3(function(a, b, c) {
        return {
            $: 7,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsEdit = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsReset = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleToAgeOptions = function(unit) {
        var maxAge = function() {
            if (unit === 1) return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$maxMonths;
            else return 150;
        }();
        return A2($elm$core$List$map, function(age) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(age)), $elm$core$String$fromInt(age));
        }, A2($elm$core$List$range, 0, maxAge));
    };
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleUnitOptions = _List_fromArray([
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$RateRule$Shared$unitToString(1)), 'Months'),
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$RateRule$Shared$unitToString(0)), 'Years')
    ]);
    var $author$project$Api$Employer$Practice$One$featureEnabled = F2(function(feature, _v0) {
        var record = _v0;
        return A2($elm$core$List$member, $author$project$Api$Feature$toString(feature), record.Px);
    });
    var $author$project$Api$Practice$featureEnabled = F2(function(feature, practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return A2($author$project$Api$Provider$Practice$One$featureEnabled, feature, practice_);
        } else {
            var practice_ = practice.a;
            return A2($author$project$Api$Employer$Practice$One$featureEnabled, feature, practice_);
        }
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$isUnitEditable = F2(function(rules, index) {
        var prevAgeRateRule = A2($elm_community$list_extra$List$Extra$getAt, index - 1, rules);
        var nextAgeRateRule = A2($elm_community$list_extra$List$Extra$getAt, index + 1, rules);
        var isPrevRuleYears = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(rule) {
            return !rule.aaG;
        }, prevAgeRateRule));
        var isNextRuleMonths = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(unit) {
            return unit === 1;
        }, A2($elm$core$Maybe$map, function($) {
            return $.aaG;
        }, nextAgeRateRule)));
        var isLast = _Utils_eq(index, $elm$core$List$length(rules) - 1);
        return !isLast && !isPrevRuleYears && !isNextRuleMonths;
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRulePeriod = F7(function(_v0, form, editingPlan, rule, isDiscount, isCouplePricing, period) {
        var defaultPeriod = _v0.Nx;
        var _v1 = function() {
            switch(period){
                case 'month':
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
                case 'quarter':
                    return _Utils_Tuple3(rule.XU, rule.XV, rule.gx);
                case 'semi_annual':
                    return _Utils_Tuple3(rule.ZH, rule.ZI, rule.gM);
                case 'annual':
                    return _Utils_Tuple3(rule.Jk, rule.Jl, rule.e3);
                default:
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
            }
        }();
        var periodAmountInCents = _v1.a;
        var editingPeriod = _v1.b;
        var periodEdited = _v1.c;
        return A2($author$project$Ui$Typography$div, _List_Nil, _Utils_eq(defaultPeriod, period) || editingPeriod ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                isCouplePricing ? $elm$html$Html$text('Couple ') : $elm$html$Html$text(''),
                isCouplePricing ? $elm$html$Html$text($elm$core$String$toLower($author$project$Formatters$String$humanize(period))) : $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
            ])),
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated, rule.Vp(period))),
                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, rule.GU(period), form))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, rule.GU(period), form))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), !editingPlan ? _List_Nil : _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
                    isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    periodEdited ? A3($author$project$Ui$Button$view, {
                        abP: 'Reset period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated(rule.YS(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Reset')
                    ])) : $author$project$Utils$Html$empty,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated(rule.Or(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule = F7(function(sharedFields, form, _v0, periods, rule, isDiscount, isCouplePricing) {
        var editingPlan = _v0.Ou;
        return A2($elm$core$List$map, A6($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRulePeriod, sharedFields, form, editingPlan, rule, isDiscount, isCouplePricing), periods);
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAgeRateRule = F6(function(sharedFields, practice, maybePlan, form, index, ageRateRule) {
        var periodCodes = A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes, A2($elm$core$Maybe$map, function(plan) {
            return $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes($author$project$Api$Provider$Plan$One$meta(plan));
        }, maybePlan));
        var isFirst = !index;
        var _v0 = $author$project$Utils$Form$fields(form);
        var ageRateRules = _v0.I_;
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace
                    ])),
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt(ageRateRule.P_))
                    ]))
                ]))
            ]),
            function() {
                if (_Utils_eq(ageRateRule.$4, $elm$core$Maybe$Nothing)) return _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small
                        ]), _List_fromArray([
                            $author$project$Utils$Html$noBreakSpace
                        ])),
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('All')
                        ]))
                    ]))
                ]);
                else {
                    var isLast = _Utils_eq($elm$core$List$length(ageRateRules) - 1, index);
                    return isLast ? _List_Nil : _List_fromArray([
                        A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $author$project$Utils$Html$noBreakSpace
                            ])),
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, ageRateRule.$4)),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleToAge(index)))
                            ]), $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleToAgeOptions(ageRateRule.aaG))
                        ]))
                    ]);
                }
            }(),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace
                    ])),
                    A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$isUnitEditable, ageRateRules, index) ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$RateRule$Shared$unitToString(ageRateRule.aaG))),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleUnit(index)))
                    ]), $author$project$Components$Plan$Form$IndividualMembershipPricingFields$ageRateRuleUnitOptions) : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('capitalize')
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$RateRule$Shared$unitToString(ageRateRule.aaG))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace
                    ])),
                    !isFirst ? A3($author$project$Ui$Button$view, {
                        abP: 'Remove age rule'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated($author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleRemove(index))),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Remove')
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, $elm$core$List$concat(_List_fromArray([
                    A7($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule, sharedFields, form, {
                        Ou: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
                    }, periodCodes, {
                        Jk: ageRateRule.dc.Jk,
                        e3: ageRateRule.dc.e3,
                        Jl: ageRateRule.dc.Jl,
                        Or: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsEdit(index),
                        Uu: ageRateRule.dc.Uu,
                        gb: ageRateRule.dc.gb,
                        Gl: ageRateRule.dc.Gl,
                        Vp: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCents(index),
                        GU: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsValidation(index),
                        XU: ageRateRule.dc.XU,
                        gx: ageRateRule.dc.gx,
                        XV: ageRateRule.dc.XV,
                        YS: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAmountInCentsReset(index),
                        ZH: ageRateRule.dc.ZH,
                        gM: ageRateRule.dc.gM,
                        ZI: ageRateRule.dc.ZI
                    }, false, false),
                    function() {
                        if (A2($author$project$Api$Practice$featureEnabled, 20, $author$project$Api$Practice$Provider(practice))) {
                            var _v1 = ageRateRule.Mg;
                            if (!_v1.$) {
                                var coupleRule = _v1.a;
                                return A2($elm$core$List$cons, A2($elm$html$Html$div, _List_fromArray([
                                    A2($elm$html$Html$Attributes$style, 'margin-top', '20px')
                                ]), _List_Nil), A7($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAmountInCentsPricingRule, sharedFields, form, {
                                    Ou: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
                                }, periodCodes, {
                                    Jk: coupleRule.dc.Jk,
                                    e3: coupleRule.dc.e3,
                                    Jl: coupleRule.dc.Jl,
                                    Or: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsEdit(index),
                                    Uu: coupleRule.dc.Uu,
                                    gb: coupleRule.dc.gb,
                                    Gl: coupleRule.dc.Gl,
                                    Vp: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCents(index),
                                    GU: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsValidation(index),
                                    XU: coupleRule.dc.XU,
                                    gx: coupleRule.dc.gx,
                                    XV: coupleRule.dc.XV,
                                    YS: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$CoupleAgeRateRuleAmountInCentsReset(index),
                                    ZH: coupleRule.dc.ZH,
                                    gM: coupleRule.dc.gM,
                                    ZI: coupleRule.dc.ZI
                                }, false, true));
                            } else return _List_Nil;
                        } else return _List_Nil;
                    }()
                ])))
            ])
        ])));
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewIndividualMembershipPricingFields = F4(function(sharedFields, practice, maybePlan, _v0) {
        var form = _v0;
        var _v1 = $author$project$Utils$Form$fields(form);
        var ageRateRules = _v1.I_;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Individual Membership Rates'),
                $author$project$Utils$Html$noBreakSpace,
                A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A3($author$project$Utils$FeatureGate$gate, 7, $author$project$Api$Practice$Provider(practice), function() {
                    if (!maybePlan.$) return A3($author$project$Ui$Button$view, {
                        abP: 'Switch to group tier pricing'
                    }, _List_fromArray([
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated($author$project$Components$Plan$Form$IndividualMembershipPricingFields$ToggleFixedMembershipPricing))
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$transfer(_List_Nil),
                        $elm$html$Html$text(' Switch to Group tier pricing')
                    ]));
                    else return $author$project$Utils$Html$empty;
                }()),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Set one individual rate or age based rates with the option for family or group discounts.')
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                function() {
                    var messageStyle = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$rulesetHasGaps($author$project$Utils$Form$fields(form).I_) ? '' : 'invisible';
                    return A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$warning
                    ]), _List_fromArray([
                        A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class(messageStyle)
                        ]), _List_fromArray([
                            $elm$html$Html$text('We noticed a gap between your age tiers. Patients whose ages don\'t match any tier will automatically be charged the first tier price. You can adjust the ranges before saving.')
                        ]))
                    ]));
                }()
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(11),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Table$header, _List_fromArray([
                            $author$project$Ui$Table$cellSpan(2)
                        ]), _List_fromArray([
                            $elm$html$Html$text('From Age')
                        ])),
                        A2($author$project$Ui$Table$header, _List_fromArray([
                            $author$project$Ui$Table$cellSpan(2)
                        ]), _List_fromArray([
                            $elm$html$Html$text('To Age')
                        ])),
                        A2($author$project$Ui$Table$header, _List_fromArray([
                            $author$project$Ui$Table$cellSpan(2)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Units')
                        ])),
                        A2($author$project$Ui$Table$header, _List_fromArray([
                            $author$project$Ui$Table$cellSpan(2)
                        ]), _List_Nil),
                        A2($author$project$Ui$Table$header, _List_fromArray([
                            $author$project$Ui$Table$cellSpan(4)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Rate')
                        ]))
                    ]), A2($elm$core$List$indexedMap, A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewAgeRateRule, sharedFields, practice, maybePlan, form), ageRateRules), _List_fromArray([
                        A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Add age range'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$IndividualMembershipPricingFields$FormUpdated($author$project$Components$Plan$Form$IndividualMembershipPricingFields$AgeRateRuleAdd)),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add Range')
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$view = F4(function(sharedFields, practice, maybePlan, _v0) {
        var form = _v0;
        return A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$viewIndividualMembershipPricingFields, sharedFields, practice, maybePlan, form);
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$FormUpdated = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAdd = {
        $: 0
    };
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCents = F3(function(a, b, c) {
        return {
            $: 3,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsEdit = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsReset = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateName = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateRemove = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Icon$Minus = 73;
    var $author$project$Ui$Icon$minus = $author$project$Ui$Icon$viewIcon(73);
    var $author$project$Ui$Table$None = {
        $: 0
    };
    var $author$project$Ui$Table$none = $author$project$Ui$Table$None;
    var $author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRulePeriod = F5(function(defaultPeriod, form, rule, isDiscount, period) {
        var _v0 = function() {
            switch(period){
                case 'month':
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
                case 'quarter':
                    return _Utils_Tuple3(rule.XU, rule.XV, rule.gx);
                case 'semi_annual':
                    return _Utils_Tuple3(rule.ZH, rule.ZI, rule.gM);
                case 'annual':
                    return _Utils_Tuple3(rule.Jk, rule.Jl, rule.e3);
                default:
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
            }
        }();
        var periodAmountInCents = _v0.a;
        var editingPeriod = _v0.b;
        var periodEdited = _v0.c;
        return A2($author$project$Ui$Typography$div, _List_Nil, _Utils_eq(defaultPeriod, period) || editingPeriod ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
            ])),
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, rule.Vp(period))),
                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, rule.GU(period), form))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, rule.GU(period), form))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
                    isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    periodEdited ? A3($author$project$Ui$Button$view, {
                        abP: 'Reset period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick(rule.YS(period))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Reset')
                    ])) : $author$project$Utils$Html$empty,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick(rule.Or(period))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRule = F5(function(defaultPeriod, form, periods, rule, isDiscount) {
        return A2($elm$core$List$map, A4($author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRulePeriod, defaultPeriod, form, rule, isDiscount), periods);
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$viewSpecialRateFields = F4(function(plan, form, index, specialRate) {
        return specialRate.NU ? $author$project$Ui$Table$none : A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace
                ])),
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(specialRate.zr),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateName(index))),
                    $author$project$Ui$Form$Input$placeholder('Student Rate'),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index), form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateNameValidation(index), form))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$active(!specialRate.R1)
                    ]), 'Cannot be removed because active members are on it.', _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Remove special rate'
                        }, _List_fromArray([
                            $author$project$Ui$Button$disabled(!specialRate.R1),
                            $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateRemove(index)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$minus)
                        ]), _List_fromArray([
                            $elm$html$Html$text(' Remove')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, A5($author$project$Components$Plan$Form$SpecialRatesFields$viewAmountInCentsPricingRule, $author$project$Api$Provider$Plan$One$defaultPeriod(plan), form, $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes($author$project$Api$Provider$Plan$One$meta(plan)), {
                Jk: specialRate.Jk,
                e3: specialRate.e3,
                Jl: specialRate.Jl,
                Or: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsEdit(index),
                Uu: specialRate.Uu,
                gb: specialRate.gb,
                Gl: specialRate.Gl,
                Vp: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCents(index),
                GU: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsValidation(index),
                XU: specialRate.XU,
                gx: specialRate.gx,
                XV: specialRate.XV,
                YS: $author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAmountInCentsReset(index),
                ZH: specialRate.ZH,
                gM: specialRate.gM,
                ZI: specialRate.ZI
            }, false))
        ]));
    });
    var $author$project$Components$Plan$Form$SpecialRatesFields$view = F2(function(plan, _v0) {
        var form = _v0;
        var _v1 = $author$project$Utils$Form$fields(form);
        var specialRates = _v1._M;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Special Rates')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('If the rates above do not fully cover your fee schedule, you can define special rates below (e.g., \"College Student\"). You can then manually apply these on a per-person basis. They will also be displayed on patient invoices in place of the charge\'s name.')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(11),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A4($author$project$Ui$Table$view, _List_fromArray([
                        $author$project$Ui$Table$zeroState(_List_fromArray([
                            $elm$html$Html$text('No special rates on this plan.')
                        ]))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Table$header, _List_fromArray([
                            $author$project$Ui$Table$cellSpan(6)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Name')
                        ])),
                        A2($author$project$Ui$Table$header, _List_fromArray([
                            $author$project$Ui$Table$cellSpan(2)
                        ]), _List_Nil),
                        A2($author$project$Ui$Table$header, _List_fromArray([
                            $author$project$Ui$Table$cellSpan(4)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Rate')
                        ]))
                    ]), A2($elm$core$List$indexedMap, A2($author$project$Components$Plan$Form$SpecialRatesFields$viewSpecialRateFields, plan, form), specialRates), _List_fromArray([
                        A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Add special rate'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$SpecialRatesFields$SpecialRateAdd),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add Special Rate')
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$MaximumAge = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$MinimumAge = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ToggleMaximumAge = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ToggleMinimumAge = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ageRestrictionOptions = A2($elm$core$List$map, function(age) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(age)), $elm$core$String$fromInt(age));
    }, A2($elm$core$List$range, 0, 150));
    var $author$project$Components$Plan$Form$viewAgeRestrictionsFields = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var editMinimumAge = _v0.xp;
        var editMaximumAge = _v0.xo;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Age restrictions')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Patients above or below these age limits will not be able to enroll in this plan online. Your practice staff will see a warning if they try to enroll patients outside the age range.')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Minimum Age'),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(editMinimumAge),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ToggleMinimumAge))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), _List_fromArray([
                        function() {
                            if (editMinimumAge) {
                                var _v1 = $author$project$Utils$Form$fields(form);
                                var minimumAge = _v1.Un;
                                return A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, minimumAge)),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$MinimumAge))
                                ]), $author$project$Components$Plan$Form$ageRestrictionOptions);
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Maximum Age'),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(editMaximumAge),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ToggleMaximumAge))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), _List_fromArray([
                        function() {
                            if (editMaximumAge) {
                                var _v2 = $author$project$Utils$Form$fields(form);
                                var maximumAge = _v2.TQ;
                                return A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, maximumAge)),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$MaximumAge))
                                ]), $author$project$Components$Plan$Form$ageRestrictionOptions);
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Plan$Form$ContractExpires = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ContractEmailsEnabled = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ContractPeriodInMonths = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ContractRenewalEmailLeadTime = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$ContractType = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$Meta$contractTypes = function(_v0) {
        var meta = _v0;
        return meta.L8;
    };
    var $author$project$Components$Plan$Form$contractTypeOptions = function(planMeta) {
        var contractTypes = $author$project$Api$Provider$Plan$Meta$contractTypes(planMeta);
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose an action'), A2($elm$core$List$map, function(type_) {
            var typeString = $author$project$Api$ContractType$toString(type_);
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(typeString), $author$project$Formatters$String$titleize($author$project$Formatters$String$humanize(typeString)));
        }, contractTypes));
    };
    var $author$project$Components$Plan$Form$viewContractExpiresFields = F2(function(plan, form) {
        var planMeta = $author$project$Api$Provider$Plan$One$meta(plan);
        var _v0 = $author$project$Utils$Form$fields(form);
        var contractPeriodInMonths = _v0.L6;
        var contractType = _v0.EW;
        var contractEmailsEnabled = _v0.L4;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Contract Period'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$PeriodInMonthsInput$view({
                    fK: A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, form),
                    q2: A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractPeriodInMonthsValidation, form),
                    afE: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractPeriodInMonths),
                    aa9: contractPeriodInMonths
                }),
                A2($author$project$Components$Plan$Form$isContractPeriodInMonthsInvalid, plan, contractPeriodInMonths) ? A2($author$project$Ui$Alert$danger, _List_fromArray([
                    $author$project$Ui$Alert$margin(20)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text('The contract period should be a multiple of the longest billing period. For example, for a membership with annual billing, the contract can be 12, 24, 36, etc. months long.')
                    ]))
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Default Behavior at End of Contract'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$ContractType$toString, contractType)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractType)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractTypeValidation, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractTypeValidation, form))
                ]), $author$project$Components$Plan$Form$contractTypeOptions(planMeta))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Send Renewal Email'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('If set to off, we will not email patients regarding their renewal or termination'))
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(contractEmailsEnabled),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractEmailsEnabled))
                ]))
            ])),
            function() {
                if (contractEmailsEnabled) {
                    var _v1 = $author$project$Utils$Form$fields(form);
                    var contractRenewalEmailLeadTime = _v1.L7;
                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$labelSpanSm(5),
                        $author$project$Ui$Form$Group$inputSpanSm(6),
                        $author$project$Ui$Form$Group$label('Renewal email lead time'),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$group(_List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, contractRenewalEmailLeadTime))),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTime)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, form))
                            ])),
                            $author$project$Ui$Form$Input$addon(_List_fromArray([
                                A2($elm$core$Maybe$withDefault, 0, contractRenewalEmailLeadTime) === 1 ? $elm$html$Html$text('day') : $elm$html$Html$text('days')
                            ]))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$ContractRenewalEmailLeadTimeValidation, form))
                    ]));
                } else return $elm$html$Html$text('');
            }()
        ]);
    });
    var $author$project$Components$Plan$Form$viewContractPeriodFields = F2(function(plan, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var contractExpires = _v0.L5;
        return A2($elm$core$List$cons, A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flex,
            $author$project$Ui$Element$gap2
        ]), _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Contract Period'),
                A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/setting-a-contract-length'))
            ]))
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label('Contract Expiration'),
            $author$project$Ui$Form$Group$labelClass('')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(contractExpires),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$ContractExpires))
            ]))
        ])), contractExpires ? A2($author$project$Components$Plan$Form$viewContractExpiresFields, plan, form) : _List_Nil));
    });
    var $author$project$Components$Plan$Form$OpenCoveragePlanModal = {
        $: 19
    };
    var $author$project$Api$Provider$CoveragePlan$Shared$coverageRules = function(_v0) {
        var record = _v0;
        return record.acC;
    };
    var $author$project$Api$Provider$CoveragePlan$All$coverageRules = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CoveragePlan$Shared$coverageRules(shared);
    };
    var $author$project$Api$Provider$CoveragePlan$One$coverageRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoveragePlan$Shared$coverageRules(shared);
    };
    var $author$project$Components$Plan$Form$coveragePlanCoverageRules = function(coveragePlan) {
        if (!coveragePlan.$) {
            var coveragePlan_ = coveragePlan.a;
            return $author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_);
        } else {
            var coveragePlan_ = coveragePlan.a;
            return $author$project$Api$Provider$CoveragePlan$All$coverageRules(coveragePlan_);
        }
    };
    var $author$project$Api$Provider$CoveragePlan$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoveragePlan$Shared$name(shared);
    };
    var $author$project$Components$Plan$Form$coveragePlanName = function(coveragePlan) {
        if (!coveragePlan.$) {
            var coveragePlan_ = coveragePlan.a;
            return $author$project$Api$Provider$CoveragePlan$One$name(coveragePlan_);
        } else {
            var coveragePlan_ = coveragePlan.a;
            return $author$project$Api$Provider$CoveragePlan$All$name(coveragePlan_);
        }
    };
    var $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton = A3($author$project$Ui$Button$view, {
        abP: 'Delete plan coverage'
    }, _List_fromArray([
        $author$project$Ui$Button$pull(1),
        $author$project$Ui$Button$size(0),
        $author$project$Ui$Button$link,
        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$CoveragePlan($elm$core$Maybe$Nothing))),
        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
    ]), _List_fromArray([
        $elm$html$Html$text('Delete')
    ]));
    var $author$project$Components$Plan$Form$viewCoveragePlanUndoButton = F2(function(originalCoveragePlan, action) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Undo ' + action
        }, _List_fromArray([
            $author$project$Ui$Button$pull(1),
            $author$project$Ui$Button$size(0),
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$CoveragePlan($elm$core$Maybe$Just($author$project$Components$Plan$Form$CoveragePlanOne(originalCoveragePlan))))),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
        ]), _List_fromArray([
            $elm$html$Html$text('Undo '),
            $elm$html$Html$text(action)
        ]));
    });
    var $author$project$Components$CoverageRuleDescription$One = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage = function(_v0) {
        var record = _v0;
        return record.af3;
    };
    var $author$project$Api$Provider$CoverageRule$One$patientContributionPercentage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage = function(_v0) {
        var record = _v0;
        return record.ahv;
    };
    var $author$project$Api$Provider$CoverageRule$One$sponsorContributionPercentage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(shared);
    };
    var $author$project$Components$CoverageRuleDescription$coveredBy = function(coverageRule) {
        var sponsorContributionPercentage = function() {
            if (!coverageRule.$) {
                var shared = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(shared);
            } else {
                var one = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$One$sponsorContributionPercentage(one);
            }
        }();
        var patientContributionPercentage = function() {
            if (!coverageRule.$) {
                var shared = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(shared);
            } else {
                var one = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$One$patientContributionPercentage(one);
            }
        }();
        var _v0 = _Utils_Tuple2(patientContributionPercentage, sponsorContributionPercentage);
        if (!_v0.a.$ && !_v0.b.$) {
            var patientContributionPercentage_ = _v0.a.a;
            var sponsorContributionPercentage_ = _v0.b.a;
            return _Utils_cmp(patientContributionPercentage_, sponsorContributionPercentage_) > 0 ? 'patient' : 'sponsor';
        } else return 'sponsor';
    };
    var $author$project$Ui$Typography$Underline = 0;
    var $author$project$Ui$Typography$underline = $author$project$Ui$Typography$Decoration(0);
    var $author$project$Components$CoverageRuleDescription$highlightText = F2(function(string, shouldHighlightText) {
        return shouldHighlightText ? A2($author$project$Ui$Typography$strong, _List_fromArray([
            $author$project$Ui$Typography$underline
        ]), _List_fromArray([
            $elm$html$Html$text(string)
        ])) : $elm$html$Html$text(string);
    });
    var $author$project$Api$Provider$CoverageRule$Shared$All = 0;
    var $author$project$Api$Provider$CoverageRule$Shared$UnderPrice = 1;
    var $author$project$Api$Provider$CoverageRule$Shared$includedOption = function(_v0) {
        var record = _v0;
        if (record.ag0 === 'included') {
            var _v1 = record.Jh;
            if (!_v1.$) return $elm$core$Maybe$Just(1);
            else return $elm$core$Maybe$Just(0);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$CoverageRule$One$includedOption = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$item = function(_v0) {
        var record = _v0;
        return record.F6;
    };
    var $author$project$Api$Provider$CoverageRule$One$item = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$item(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$CoverageRule$One$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$percentage = function(_v0) {
        var record = _v0;
        return record.af9;
    };
    var $author$project$Api$Provider$CoverageRule$One$percentage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$percentage(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$quantity = function(_v0) {
        var record = _v0;
        return record.Bu;
    };
    var $author$project$Api$Provider$CoverageRule$One$quantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$quantity(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$ruleType = function(_v0) {
        var record = _v0;
        return record.ag0;
    };
    var $author$project$Api$Provider$CoverageRule$One$ruleType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$ruleType(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$BeginningOfYear = 0;
    var $author$project$Api$Provider$CoverageRule$Shared$MembershipRenewalDate = 1;
    var $author$project$Api$Provider$CoverageRule$Shared$timePeriod = function(_v0) {
        var record = _v0;
        var _v1 = record.ahU;
        _v1$2: while(true){
            if (!_v1.$) switch(_v1.a){
                case 'beginning_of_year':
                    return $elm$core$Maybe$Just(0);
                case 'membership_renewal_date':
                    return $elm$core$Maybe$Just(1);
                default:
                    break _v1$2;
            }
            else break _v1$2;
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$CoverageRule$One$timePeriod = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$timePeriod(shared);
    };
    var $author$project$Components$CoverageRuleDescription$ruleTypeText = F2(function(coverageRule, shouldHighlightText) {
        var ruleType = function() {
            if (!coverageRule.$) {
                var shared = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$Shared$ruleType(shared);
            } else {
                var one = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$One$ruleType(one);
            }
        }();
        var amountInCents = $author$project$Utils$Currency$fromInt(A2($elm$core$Maybe$withDefault, 0, function(coverageRule_) {
            if (!coverageRule_.$) {
                var shared = coverageRule_.a;
                return $author$project$Api$Provider$CoverageRule$Shared$amountInCents(shared);
            } else {
                var one = coverageRule_.a;
                return $author$project$Api$Provider$CoverageRule$One$amountInCents(one);
            }
        }(coverageRule)));
        switch(ruleType){
            case 'pass_through':
                return _List_fromArray([
                    $elm$html$Html$text(' will be')
                ]);
            case 'included':
                var includedOption = function() {
                    if (!coverageRule.$) {
                        var shared = coverageRule.a;
                        return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
                    } else {
                        var one = coverageRule.a;
                        return $author$project$Api$Provider$CoverageRule$One$includedOption(one);
                    }
                }();
                var amountText = function() {
                    if (!includedOption.$) {
                        if (includedOption.a === 1) {
                            var _v2 = includedOption.a;
                            return ' if they cost less than ' + amountInCents;
                        } else {
                            var _v3 = includedOption.a;
                            return '';
                        }
                    } else return '';
                }();
                return _List_fromArray([
                    $elm$html$Html$text(' are '),
                    A2($author$project$Components$CoverageRuleDescription$highlightText, 'included', shouldHighlightText),
                    $elm$html$Html$text(' in the membership at no additional charge'),
                    A2($author$project$Components$CoverageRuleDescription$highlightText, amountText, shouldHighlightText)
                ]);
            case 'flat_amount':
                return _List_fromArray([
                    $elm$html$Html$text(' will be '),
                    A2($author$project$Components$CoverageRuleDescription$highlightText, amountInCents, shouldHighlightText)
                ]);
            case 'discounted':
                var percentage = $author$project$Formatters$Float$toPercentage(A2($elm$core$Maybe$withDefault, 0.0, function(coverageRule_) {
                    if (!coverageRule_.$) {
                        var shared = coverageRule_.a;
                        return $author$project$Api$Provider$CoverageRule$Shared$percentage(shared);
                    } else {
                        var one = coverageRule_.a;
                        return $author$project$Api$Provider$CoverageRule$One$percentage(one);
                    }
                }(coverageRule)));
                return _List_fromArray([
                    $elm$html$Html$text(' will receive a '),
                    A2($author$project$Components$CoverageRuleDescription$highlightText, 'discount of ', shouldHighlightText),
                    A2($author$project$Components$CoverageRuleDescription$highlightText, percentage, shouldHighlightText),
                    $elm$html$Html$text(' with the amount due')
                ]);
            case 'surcharge':
                return _List_fromArray([
                    $elm$html$Html$text(' will have a surcharge of '),
                    A2($author$project$Components$CoverageRuleDescription$highlightText, amountInCents, shouldHighlightText),
                    $elm$html$Html$text(' added to the charge, the amount due will be')
                ]);
            case 'limited_quantity':
                var quantity = A2($elm$core$Maybe$withDefault, 0, function(coverageRule_) {
                    if (!coverageRule_.$) {
                        var shared = coverageRule_.a;
                        return $author$project$Api$Provider$CoverageRule$Shared$quantity(shared);
                    } else {
                        var one = coverageRule_.a;
                        return $author$project$Api$Provider$CoverageRule$One$quantity(one);
                    }
                }(coverageRule));
                var _v6 = function() {
                    var _v7 = function(coverageRule_) {
                        if (!coverageRule_.$) {
                            var shared = coverageRule_.a;
                            return $author$project$Api$Provider$CoverageRule$Shared$timePeriod(shared);
                        } else {
                            var one = coverageRule_.a;
                            return $author$project$Api$Provider$CoverageRule$One$timePeriod(one);
                        }
                    }(coverageRule);
                    if (!_v7.$) {
                        if (!_v7.a) {
                            var _v9 = _v7.a;
                            return _Utils_Tuple2('', 'Jan 1st');
                        } else {
                            var _v10 = _v7.a;
                            return _Utils_Tuple2('patient\'s ', 'membership renewal date');
                        }
                    } else return _Utils_Tuple2('', '');
                }();
                var timePeriodSubject = _v6.a;
                var timePeriod = _v6.b;
                return _List_fromArray([
                    $elm$html$Html$text(' are limited to a quantity of '),
                    A2($author$project$Components$CoverageRuleDescription$highlightText, A2($author$project$Formatters$String$pluralize, 'unit', quantity), shouldHighlightText),
                    $elm$html$Html$text(' per period resetting on '),
                    $elm$html$Html$text(timePeriodSubject),
                    A2($author$project$Components$CoverageRuleDescription$highlightText, timePeriod, shouldHighlightText),
                    $elm$html$Html$text(', additional units will be')
                ]);
            default:
                return _List_Nil;
        }
    });
    var $author$project$Components$CoverageRuleDescription$view = F2(function(coverageRule, shouldHighlightText) {
        var item = function() {
            if (!coverageRule.$) {
                var shared = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$Shared$item(shared);
            } else {
                var one = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$One$item(one);
            }
        }();
        var itemName = function() {
            if (item.$ === 1) {
                var category = item.a;
                return 'All ' + $author$project$Formatters$String$pluralOf($author$project$Api$Provider$Category$Shared$name(category));
            } else {
                var chargeItem = item.a;
                return $author$project$Formatters$String$pluralOf($author$project$Api$Provider$ChargeItem$Shared$name(chargeItem));
            }
        }();
        var includedOption = function() {
            if (!coverageRule.$) {
                var shared = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$Shared$includedOption(shared);
            } else {
                var one = coverageRule.a;
                return $author$project$Api$Provider$CoverageRule$One$includedOption(one);
            }
        }();
        var coveredByText = function() {
            if (!includedOption.$) {
                var includedOption_ = includedOption.a;
                if (includedOption_ === 1) return _List_fromArray([
                    $elm$html$Html$text(', those above are paid for by the '),
                    A3($elm$core$Basics$apR, $author$project$Components$CoverageRuleDescription$coveredBy(coverageRule), $author$project$Components$CoverageRuleDescription$highlightText, shouldHighlightText)
                ]);
                else return _List_Nil;
            } else return _List_fromArray([
                $elm$html$Html$text(' paid for by the '),
                A3($elm$core$Basics$apR, $author$project$Components$CoverageRuleDescription$coveredBy(coverageRule), $author$project$Components$CoverageRuleDescription$highlightText, shouldHighlightText)
            ]);
        }();
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Components$CoverageRuleDescription$highlightText, itemName, shouldHighlightText), _Utils_ap(A2($author$project$Components$CoverageRuleDescription$ruleTypeText, coverageRule, shouldHighlightText), coveredByText)));
    });
    var $author$project$Components$Plan$Form$viewCoverageRule = function(coverageRule) {
        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            A2($author$project$Components$CoverageRuleDescription$view, $author$project$Components$CoverageRuleDescription$One(coverageRule), true)
        ]));
    };
    var $author$project$Components$Plan$Form$viewCoveragePlanFields = F2(function(plan, form) {
        var originalCoveragePlan = function() {
            var _v14 = $author$project$Api$Provider$Plan$One$coveragePlan(plan);
            if (!_v14.$) {
                var coveragePlan_ = _v14.a;
                return coveragePlan_;
            } else return $elm$core$Maybe$Nothing;
        }();
        var _v0 = $author$project$Utils$Form$fields(form);
        var coveragePlan = _v0.Mn;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Coverage')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Select charge items that will be covered with this plan.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight,
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Manage Coverage Plans')
                        ])),
                        !_Utils_eq(coveragePlan, $elm$core$Maybe$Nothing) || !_Utils_eq(originalCoveragePlan, $elm$core$Maybe$Nothing) ? A3($author$project$Ui$Button$view, {
                            abP: 'Change coverage plan'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$OpenCoveragePlanModal)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Change Coverage Plan')
                        ])) : A3($author$project$Ui$Button$view, {
                            abP: 'Add coverage plan'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$OpenCoveragePlanModal),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add Coverage Plan')
                        ]))
                    ]))
                ]))
            ])),
            !_Utils_eq(coveragePlan, $elm$core$Maybe$Nothing) || !_Utils_eq(originalCoveragePlan, $elm$core$Maybe$Nothing) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(3)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$hintLabel
                            ]), _List_fromArray([
                                $elm$html$Html$text('Coverage Plan')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$hintLabel
                            ]), _List_fromArray([
                                $elm$html$Html$text('Included charges')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$ListGroup$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(3)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                        function() {
                                            var _v1 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
                                            if (!_v1.a.$) {
                                                var coveragePlan_ = _v1.a.a;
                                                return $elm$html$Html$text($author$project$Components$Plan$Form$coveragePlanName(coveragePlan_));
                                            } else if (!_v1.b.$) {
                                                var _v2 = _v1.a;
                                                return $elm$html$Html$text('Removed');
                                            } else {
                                                var _v3 = _v1.a;
                                                var _v4 = _v1.b;
                                                return $author$project$Utils$Html$empty;
                                            }
                                        }()
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(7)
                                ]), function() {
                                    var _v5 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
                                    if (!_v5.a.$) {
                                        var coveragePlan_ = _v5.a.a;
                                        return A2($elm$core$List$map, $author$project$Components$Plan$Form$viewCoverageRule, $author$project$Components$Plan$Form$coveragePlanCoverageRules(coveragePlan_));
                                    } else if (!_v5.b.$) {
                                        var _v6 = _v5.a;
                                        return _List_Nil;
                                    } else {
                                        var _v7 = _v5.a;
                                        var _v8 = _v5.b;
                                        return _List_Nil;
                                    }
                                }()),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(2)
                                ]), _List_fromArray([
                                    function() {
                                        var _v9 = _Utils_Tuple2(coveragePlan, originalCoveragePlan);
                                        if (!_v9.a.$) {
                                            if (!_v9.b.$) {
                                                var coveragePlan_ = _v9.a.a;
                                                var originalCoveragePlan_ = _v9.b.a;
                                                return !_Utils_eq($author$project$Components$Plan$Form$coveragePlanId(coveragePlan_), $author$project$Api$Provider$CoveragePlan$One$id(originalCoveragePlan_)) ? A2($author$project$Components$Plan$Form$viewCoveragePlanUndoButton, originalCoveragePlan_, 'Chgange') : $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton;
                                            } else {
                                                var _v11 = _v9.b;
                                                return $author$project$Components$Plan$Form$viewCoveragePlanDeleteButton;
                                            }
                                        } else if (!_v9.b.$) {
                                            var _v10 = _v9.a;
                                            var originalCoveragePlan_ = _v9.b.a;
                                            return A2($author$project$Components$Plan$Form$viewCoveragePlanUndoButton, originalCoveragePlan_, 'Delete');
                                        } else {
                                            var _v12 = _v9.a;
                                            var _v13 = _v9.b;
                                            return $author$project$Utils$Html$empty;
                                        }
                                    }()
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$AdditionalAdultDiscountRule = 7;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$AdditionalChildDiscountRule = 4;
    var $author$project$Ui$Padding$Bottom_1 = 8;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimit = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitRule = 8;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenOnlyDiscountRule = 5;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$CoupleDiscountRule = 1;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRule = 2;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncluded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedRule = 0;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowed = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedRule = 6;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$SingleParentDiscountRule = 3;
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCents = F3(function(a, b, c) {
        return {
            $: 5,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsEdit = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsReset = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRulePeriod = F6(function(_v0, form, editingPlan, rule, isDiscount, period) {
        var defaultPeriod = _v0.Nx;
        var _v1 = function() {
            switch(period){
                case 'month':
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
                case 'quarter':
                    return _Utils_Tuple3(rule.XU, rule.XV, rule.gx);
                case 'semi_annual':
                    return _Utils_Tuple3(rule.ZH, rule.ZI, rule.gM);
                case 'annual':
                    return _Utils_Tuple3(rule.Jk, rule.Jl, rule.e3);
                default:
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
            }
        }();
        var periodAmountInCents = _v1.a;
        var editingPeriod = _v1.b;
        var periodEdited = _v1.c;
        return A2($author$project$Ui$Typography$div, _List_Nil, _Utils_eq(defaultPeriod, period) || editingPeriod ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
            ])),
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, rule.Vp(period))),
                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, rule.GU(period), form))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, rule.GU(period), form))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), !editingPlan ? _List_Nil : _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
                    isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    periodEdited ? A3($author$project$Ui$Button$view, {
                        abP: 'Reset period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated(rule.YS(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Reset')
                    ])) : $author$project$Utils$Html$empty,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated(rule.Or(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRule = F6(function(sharedFields, form, _v0, periods, rule, isDiscount) {
        var editingPlan = _v0.Ou;
        return A2($elm$core$List$map, A5($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRulePeriod, sharedFields, form, editingPlan, rule, isDiscount), periods);
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule = F4(function(sharedFields, maybePlan, form, familyDiscountRule) {
        return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(familyDiscountRule_) {
            var periodCodes = A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Plan$Meta$defaultAllPeriodCodes, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes, A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$One$meta, sharedFields.GW)));
            return A6($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewAmountInCentsPricingRule, sharedFields, form, {
                Ou: !_Utils_eq(maybePlan, $elm$core$Maybe$Nothing)
            }, periodCodes, {
                Jk: familyDiscountRule_.Jo,
                e3: familyDiscountRule_.Jp,
                Jl: familyDiscountRule_.vw,
                Or: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsEdit(familyDiscountRule_.ah5),
                Uu: familyDiscountRule_.Ux,
                gb: familyDiscountRule_.Uy,
                Gl: familyDiscountRule_.zm,
                Vp: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCents(familyDiscountRule_.ah5),
                GU: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsValidation(familyDiscountRule_.ah5),
                XU: familyDiscountRule_.XY,
                gx: familyDiscountRule_.XZ,
                XV: familyDiscountRule_.By,
                YS: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyDiscountRuleMaximumInCentsReset(familyDiscountRule_.ah5),
                ZH: familyDiscountRule_.ZL,
                gM: familyDiscountRule_.ZM,
                ZI: familyDiscountRule_.Cp
            }, false);
        }, familyDiscountRule));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyMembershipPricingFields = F3(function(sharedFields, maybePlan, _v0) {
        var form = _v0;
        var _v1 = $author$project$Utils$Form$fields(form);
        var rules = _v1.Zk;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                if (!maybePlan.$) return A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$padding(8)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Switch to group discounts'
                    }, _List_fromArray([
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated($author$project$Components$Plan$Form$FamilyMembershipPricingFields$GroupPricingType('group')))
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$transfer(_List_Nil),
                        $elm$html$Html$text(' Switch to Group Discounts')
                    ]))
                ]));
                else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Couple Rate'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Up to 2 adults of any age, no children')),
                $author$project$Ui$Form$Group$required(rules.wX.OM)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(rules.wX.OM),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(1)))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), function() {
                        if (rules.wX.OM) {
                            var _v3 = $author$project$Utils$Form$fields(form);
                            var coupleDiscountRule = _v3.wX;
                            return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, coupleDiscountRule);
                        } else return _List_Nil;
                    }())
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Family Rate'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Up to 2 adults of any age, plus children')),
                $author$project$Ui$Form$Group$required(rules.xG.OM)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(rules.xG.OM),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(2)))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), function() {
                        if (rules.xG.OM) {
                            var _v4 = $author$project$Utils$Form$fields(form);
                            var familyDiscountRule = _v4.xG;
                            return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, familyDiscountRule);
                        } else return _List_Nil;
                    }())
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Single Parent Rate'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('One adult of any age, plus children')),
                $author$project$Ui$Form$Group$required(rules.CE.OM)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$justifyLeft
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(rules.CE.OM),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(3)))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), function() {
                        if (rules.CE.OM) {
                            var _v5 = $author$project$Utils$Form$fields(form);
                            var singleParentDiscountRule = _v5.CE;
                            return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, singleParentDiscountRule);
                        } else return _List_Nil;
                    }())
                ]))
            ])),
            function() {
                if (rules.xG.OM || rules.CE.OM) {
                    var _v6 = $author$project$Utils$Form$fields(form);
                    var familyNumChildrenIncluded = _v6.xH;
                    var childrenAgeLimit = _v6.wa;
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$offsetLabel,
                            $author$project$Ui$Form$Group$labelSpanSm(5),
                            $author$project$Ui$Form$Group$inputSpanSm(6),
                            $author$project$Ui$Form$Group$label('Limit Children in Family Plans'),
                            $author$project$Ui$Form$Group$labelClass(''),
                            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Turn off for no limit')),
                            $author$project$Ui$Form$Group$required(rules.xH.OM)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(4)
                                ]), _List_fromArray([
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(rules.xH.OM),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(0)))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(8)
                                ]), rules.xH.OM ? _List_fromArray([
                                    $author$project$Ui$Form$Input$group(_List_fromArray([
                                        $author$project$Ui$Form$Input$addon(_List_fromArray([
                                            $elm$html$Html$text('Up to and including')
                                        ])),
                                        $author$project$Ui$Form$Input$view(_List_fromArray([
                                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, familyNumChildrenIncluded))),
                                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncluded)),
                                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, form))
                                        ]))
                                    ])),
                                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FamilyNumChildrenIncludedValidation, form))
                                ]) : _List_Nil)
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$offsetLabel,
                            $author$project$Ui$Form$Group$labelSpanSm(5),
                            $author$project$Ui$Form$Group$inputSpanSm(6),
                            $author$project$Ui$Form$Group$label('Additional Child Rate'),
                            $author$project$Ui$Form$Group$labelClass(''),
                            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Turn off to use the individual rate')),
                            $author$project$Ui$Form$Group$required(rules.tR.OM)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(4)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$small
                                    ]), _List_fromArray([
                                        $author$project$Utils$Html$noBreakSpace
                                    ])),
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(rules.tR.OM),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(4)))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(8)
                                ]), function() {
                                    if (rules.tR.OM) {
                                        var _v7 = $author$project$Utils$Form$fields(form);
                                        var additionalChildDiscountRule = _v7.tR;
                                        return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, additionalChildDiscountRule);
                                    } else return _List_fromArray([
                                        $author$project$Utils$Html$empty
                                    ]);
                                }())
                            ]))
                        ])),
                        rules.xH.OM ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$offsetLabel,
                            $author$project$Ui$Form$Group$labelSpanSm(5),
                            $author$project$Ui$Form$Group$inputSpanSm(6),
                            $author$project$Ui$Form$Group$label('Number of Additional Children Allowed'),
                            $author$project$Ui$Form$Group$labelClass(''),
                            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Turn off for no limit')),
                            $author$project$Ui$Form$Group$required(rules.zP.OM)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(4)
                                ]), _List_fromArray([
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(rules.zP.OM),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(6)))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(8)
                                ]), function() {
                                    if (rules.zP.OM) {
                                        var _v8 = $author$project$Utils$Form$fields(form);
                                        var numberAdditionalChildrenAllowed = _v8.zP;
                                        return _List_fromArray([
                                            $author$project$Ui$Form$Input$group(_List_fromArray([
                                                $author$project$Ui$Form$Input$addon(_List_fromArray([
                                                    $elm$html$Html$text('Up to and including')
                                                ])),
                                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, numberAdditionalChildrenAllowed))),
                                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowed)),
                                                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, form))
                                                ]))
                                            ])),
                                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$NumberAdditionalChildrenAllowedValidation, form))
                                        ]);
                                    } else return _List_Nil;
                                }())
                            ]))
                        ])) : $author$project$Utils$Html$empty,
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$offsetLabel,
                            $author$project$Ui$Form$Group$labelSpanSm(5),
                            $author$project$Ui$Form$Group$inputSpanSm(6),
                            $author$project$Ui$Form$Group$label('Additional Adult Rate'),
                            $author$project$Ui$Form$Group$labelClass(''),
                            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Turn off to use the individual rate')),
                            $author$project$Ui$Form$Group$required(rules.tQ.OM)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(4)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$small
                                    ]), _List_fromArray([
                                        $author$project$Utils$Html$noBreakSpace
                                    ])),
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(rules.tQ.OM),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(7)))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(8)
                                ]), function() {
                                    if (rules.tQ.OM) {
                                        var _v9 = $author$project$Utils$Form$fields(form);
                                        var additionalAdultDiscountRule = _v9.tQ;
                                        return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, additionalAdultDiscountRule);
                                    } else return _List_Nil;
                                }())
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$offsetLabel,
                            $author$project$Ui$Form$Group$labelSpanSm(5),
                            $author$project$Ui$Form$Group$inputSpanSm(6),
                            $author$project$Ui$Form$Group$label('Maximum Age of Child'),
                            $author$project$Ui$Form$Group$labelClass(''),
                            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Turn off for no limit')),
                            $author$project$Ui$Form$Group$required(rules.wa.OM)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(4)
                                ]), _List_fromArray([
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(rules.wa.OM),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(8)))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(8)
                                ]), rules.wa.OM ? _List_fromArray([
                                    $author$project$Ui$Form$Input$group(_List_fromArray([
                                        $author$project$Ui$Form$Input$addon(_List_fromArray([
                                            $elm$html$Html$text('Up to and including')
                                        ])),
                                        $author$project$Ui$Form$Input$view(_List_fromArray([
                                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, childrenAgeLimit))),
                                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimit)),
                                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, form))
                                        ]))
                                    ])),
                                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ChildrenAgeLimitValidation, form))
                                ]) : _List_Nil)
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$offsetLabel,
                            $author$project$Ui$Form$Group$labelSpanSm(5),
                            $author$project$Ui$Form$Group$inputSpanSm(6),
                            $author$project$Ui$Form$Group$label('Children Only Rate'),
                            $author$project$Ui$Form$Group$labelClass(''),
                            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Children enrolling independently without an adult')),
                            $author$project$Ui$Form$Group$required(rules.wb.OM)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(4)
                                ]), _List_fromArray([
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(rules.wb.OM),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$FormUpdated, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$ToggleRule(5)))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(8)
                                ]), function() {
                                    if (rules.wb.OM) {
                                        var _v10 = $author$project$Utils$Form$fields(form);
                                        var childrenOnlyDiscountRule = _v10.wb;
                                        return A4($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyDiscountRule, sharedFields, maybePlan, form, childrenOnlyDiscountRule);
                                    } else return _List_fromArray([
                                        $author$project$Utils$Html$empty
                                    ]);
                                }())
                            ]))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$view = F3(function(sharedFields, maybePlan, _v0) {
        var form = _v0;
        return A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$viewFamilyMembershipPricingFields, sharedFields, maybePlan, form);
    });
    var $author$project$Components$Plan$Form$DiscountsEnabled = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Ui$Form$Radio$Inline = {
        $: 2
    };
    var $author$project$Ui$Form$Radio$inline = $author$project$Ui$Form$Radio$Inline;
    var $author$project$Components$Plan$Form$viewFamilyDiscountsToggle = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var discountsEnabled = _v0.xm;
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Do you offer discounts to family members who enroll together?'),
                $author$project$Utils$Html$noBreakSpace,
                A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(discountsEnabled),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$Form$DiscountsEnabled(true))))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Yes')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(!discountsEnabled),
                        $author$project$Ui$Form$Radio$inline,
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$Form$DiscountsEnabled(false))))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('No')
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Utils$Html$noBreakSpace
        ]));
    };
    var $author$project$Components$Plan$Form$viewFamilyMembershipPricing = F3(function(sharedFields, plan, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var familyMembershipPricingForm = _v0.cY;
        var discountsEnabled = _v0.xm;
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $author$project$Components$Plan$Form$viewFamilyDiscountsToggle(form),
            discountsEnabled ? A2($elm$html$Html$map, $author$project$Components$Plan$Form$FamilyMembershipPricingFieldsUpdated, A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$view, sharedFields, $elm$core$Maybe$Just(plan), familyMembershipPricingForm)) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Plan$Form$AppliesGroupDiscountInTiers = function(a) {
        return {
            $: 29,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupDiscountRuleAdd = {
        $: 31
    };
    var $author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy = function(a) {
        return {
            $: 30,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCents = F3(function(a, b, c) {
        return {
            $: 35,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsEdit = F2(function(a, b) {
        return {
            $: 36,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsReset = F2(function(a, b) {
        return {
            $: 37,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupDiscountRuleFromSize = F2(function(a, b) {
        return {
            $: 33,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupDiscountRulePercentOff = F3(function(a, b, c) {
        return {
            $: 38,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffEdit = F2(function(a, b) {
        return {
            $: 39,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupDiscountRulePercentOffReset = F2(function(a, b) {
        return {
            $: 40,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$GroupDiscountRuleRemove = function(a) {
        return {
            $: 32,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$GroupDiscountRuleToSize = F2(function(a, b) {
        return {
            $: 34,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Plan$Form$groupDiscountRuleSizeOptions = function(start) {
        return A2($elm$core$List$map, function(size) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(size)), A2($author$project$Formatters$String$pluralize, 'Member', size));
        }, A2($elm$core$List$range, start, 9));
    };
    var $author$project$Components$Plan$Form$viewAmountInCentsPricingRulePeriod = F4(function(form, rule, isDiscount, period) {
        var _v0 = function() {
            switch(period){
                case 'month':
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
                case 'quarter':
                    return _Utils_Tuple3(rule.XU, rule.XV, rule.gx);
                case 'semi_annual':
                    return _Utils_Tuple3(rule.ZH, rule.ZI, rule.gM);
                case 'annual':
                    return _Utils_Tuple3(rule.Jk, rule.Jl, rule.e3);
                default:
                    return _Utils_Tuple3(rule.Uu, rule.Gl, rule.gb);
            }
        }();
        var periodAmountInCents = _v0.a;
        var editingPeriod = _v0.b;
        var periodEdited = _v0.c;
        var _v2 = $author$project$Utils$Form$fields(form);
        var basicPlan = _v2.aB;
        var _v3 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
        var defaultPeriod = _v3.Nx;
        return A2($author$project$Ui$Typography$div, _List_Nil, _Utils_eq(defaultPeriod, period) || editingPeriod ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
            ])),
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, rule.Vp(period))),
                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, rule.GU(period), form))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, rule.GU(period), form))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, periodAmountInCents))),
                    isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    periodEdited ? A3($author$project$Ui$Button$view, {
                        abP: 'Reset period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated(rule.YS(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Reset')
                    ])) : $author$project$Utils$Html$empty,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit period amount'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated(rule.Or(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$viewAmountInCentsPricingRule = F4(function(form, periods, rule, isDiscount) {
        return A2($elm$core$List$map, A3($author$project$Components$Plan$Form$viewAmountInCentsPricingRulePeriod, form, rule, isDiscount), periods);
    });
    var $author$project$Percentage$format = function(percentage) {
        var _v0 = $author$project$Percentage$toFloat(percentage);
        if (!_v0.$) {
            var _float = _v0.a;
            return $elm$core$String$fromFloat(_float) + '%';
        } else return 'N/A';
    };
    var $author$project$Components$Plan$Form$viewPercentOffPricingRulePeriod = F4(function(form, rule, isDiscount, period) {
        var _v0 = function() {
            switch(period){
                case 'month':
                    return _Utils_Tuple3(rule.UC, rule.m9, rule.UD);
                case 'quarter':
                    return _Utils_Tuple3(rule.X0, rule.so, rule.X1);
                case 'semi_annual':
                    return _Utils_Tuple3(rule.ZP, rule.sM, rule.ZQ);
                case 'annual':
                    return _Utils_Tuple3(rule.Js, rule.py, rule.Jt);
                default:
                    return _Utils_Tuple3(rule.UC, rule.m9, rule.UD);
            }
        }();
        var periodPercentOff = _v0.a;
        var editingPeriod = _v0.b;
        var periodEdited = _v0.c;
        var _v2 = $author$project$Utils$Form$fields(form);
        var basicPlan = _v2.aB;
        var _v3 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
        var defaultPeriod = _v3.Nx;
        return A2($author$project$Ui$Typography$div, _List_Nil, _Utils_eq(defaultPeriod, period) || editingPeriod ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                isDiscount ? $elm$html$Html$text(' discount') : $elm$html$Html$text(' rate')
            ])),
            $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                $author$project$Ui$Form$PercentageInput$value(periodPercentOff),
                $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, rule.Vq(period))),
                $author$project$Ui$Form$PercentageInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, rule.GV(period), form))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, rule.GV(period), form))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Percentage$format(A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, periodPercentOff))),
                    isDiscount ? $elm$html$Html$text(' off') : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    periodEdited ? A3($author$project$Ui$Button$view, {
                        abP: 'Reset period percent off'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated(rule.YT(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Reset')
                    ])) : $author$project$Utils$Html$empty,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit period percent off'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated(rule.Os(period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$viewPercentOffPricingRule = F4(function(form, periods, rule, isDiscount) {
        return A2($elm$core$List$map, A3($author$project$Components$Plan$Form$viewPercentOffPricingRulePeriod, form, rule, isDiscount), periods);
    });
    var $author$project$Components$Plan$Form$viewGroupDiscountRule = F4(function(plan, form, index, groupDiscountRule) {
        var meta = $author$project$Api$Provider$Plan$One$meta(plan);
        var isFirst = !index;
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, isFirst ? _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(groupDiscountRule.P0))),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$GroupDiscountRuleFromSize(index)))
                ]), $author$project$Components$Plan$Form$groupDiscountRuleSizeOptions(0))
            ]) : _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(groupDiscountRule.P0))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, !_Utils_eq(groupDiscountRule.$6, $elm$core$Maybe$Nothing) ? _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, groupDiscountRule.$6)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$GroupDiscountRuleToSize(index)))
                ]), $author$project$Components$Plan$Form$groupDiscountRuleSizeOptions(groupDiscountRule.P0))
            ]) : _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('All Members')
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                !isFirst ? A3($author$project$Ui$Button$view, {
                    abP: 'Remove group disount rule'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$GroupDiscountRuleRemove(index))),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Remove')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v0 = groupDiscountRule.KD;
                switch(_v0){
                    case 'amount_off_in_cents':
                        return A4($author$project$Components$Plan$Form$viewAmountInCentsPricingRule, form, $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta), {
                            Jk: groupDiscountRule.Jm,
                            e3: groupDiscountRule.Jn,
                            Jl: groupDiscountRule.Eh,
                            Or: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsEdit(index),
                            Uu: groupDiscountRule.Uv,
                            gb: groupDiscountRule.Uw,
                            Gl: groupDiscountRule.Gm,
                            Vp: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCents(index),
                            GU: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsValidation(index),
                            XU: groupDiscountRule.XW,
                            gx: groupDiscountRule.XX,
                            XV: groupDiscountRule.G9,
                            YS: $author$project$Components$Plan$Form$GroupDiscountRuleAmountOffInCentsReset(index),
                            ZH: groupDiscountRule.ZJ,
                            gM: groupDiscountRule.ZK,
                            ZI: groupDiscountRule.Ho
                        }, true);
                    case 'percent_off':
                        return A4($author$project$Components$Plan$Form$viewPercentOffPricingRule, form, $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes(meta), {
                            Js: groupDiscountRule.Js,
                            Jt: groupDiscountRule.Jt,
                            py: groupDiscountRule.py,
                            Os: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffEdit(index),
                            UC: groupDiscountRule.UC,
                            UD: groupDiscountRule.UD,
                            m9: groupDiscountRule.m9,
                            Vq: $author$project$Components$Plan$Form$GroupDiscountRulePercentOff(index),
                            GV: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffValidation(index),
                            X0: groupDiscountRule.X0,
                            X1: groupDiscountRule.X1,
                            so: groupDiscountRule.so,
                            YT: $author$project$Components$Plan$Form$GroupDiscountRulePercentOffReset(index),
                            ZP: groupDiscountRule.ZP,
                            ZQ: groupDiscountRule.ZQ,
                            sM: groupDiscountRule.sM
                        }, true);
                    default:
                        return _List_Nil;
                }
            }())
        ]));
    });
    var $author$project$Components$Plan$Form$viewGroupMembershipPricingFields = F2(function(plan, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var appliesGroupDiscountInTiers = _v0.Jy;
        var groupDiscountRules = _v0.Qd;
        var discountsEnabled = _v0.xm;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Components$Plan$Form$viewFamilyDiscountsToggle(form),
            function() {
                if (discountsEnabled) {
                    var groupDiscountRulesCalculatedBy = A2($elm$core$Maybe$map, function($) {
                        return $.KD;
                    }, $elm$core$List$head(groupDiscountRules));
                    var allowNewGroupRule = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(lastFromSize) {
                        return _Utils_cmp(lastFromSize, $author$project$Components$Plan$Form$maxGroupFromSize) < 0;
                    }, A2($elm$core$Maybe$map, function($) {
                        return $.P0;
                    }, $elm_community$list_extra$List$Extra$last(groupDiscountRules))));
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$padding(8)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Switch to family rates'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$GroupPricingType('family')))
                            ]), _List_fromArray([
                                $author$project$Ui$Icon$transfer(_List_Nil),
                                $elm$html$Html$text(' Switch to Family Rates')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$offset(1)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                                        $author$project$Ui$Form$Radio$value(appliesGroupDiscountInTiers),
                                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$Form$AppliesGroupDiscountInTiers(true))))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Apply Discounts in Tiers.'),
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$muted,
                                            $author$project$Ui$Typography$bold
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Per member discount will apply to members depending on which range they are in')
                                        ]))
                                    ]))
                                ])),
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                                        $author$project$Ui$Form$Radio$value(!appliesGroupDiscountInTiers),
                                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$Form$AppliesGroupDiscountInTiers(false))))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Apply Same Discount to Entire Group'),
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$muted,
                                            $author$project$Ui$Typography$bold
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Per member discount from the last added member will apply to all members in group')
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$offsetLabel,
                            $author$project$Ui$Form$Group$labelSpanSm(5),
                            $author$project$Ui$Form$Group$inputSpanSm(6),
                            $author$project$Ui$Form$Group$label('Default Discount Type'),
                            $author$project$Ui$Form$Group$labelClass('')
                        ]), _List_fromArray([
                            $author$project$Ui$Button$group(_List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Select percentage base discount calculation'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$active(_Utils_eq(groupDiscountRulesCalculatedBy, $elm$core$Maybe$Just('percent_off'))),
                                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy(true)))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('%')
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Select fixed discount rate'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$active(!_Utils_eq(groupDiscountRulesCalculatedBy, $elm$core$Maybe$Just('percent_off'))),
                                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$ToggleGroupDiscountRulesCalculatedBy(false)))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('$')
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(11),
                                $author$project$Ui$Grid$offsetSm(1)
                            ]), _List_fromArray([
                                A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Table$header, _List_fromArray([
                                        $author$project$Ui$Table$cellSpan(3)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('From')
                                    ])),
                                    A2($author$project$Ui$Table$header, _List_fromArray([
                                        $author$project$Ui$Table$cellSpan(3)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('To')
                                    ])),
                                    A2($author$project$Ui$Table$header, _List_fromArray([
                                        $author$project$Ui$Table$cellSpan(2)
                                    ]), _List_Nil),
                                    A2($author$project$Ui$Table$header, _List_fromArray([
                                        $author$project$Ui$Table$cellSpan(4)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Discount per Member')
                                    ]))
                                ]), A2($elm$core$List$indexedMap, A2($author$project$Components$Plan$Form$viewGroupDiscountRule, plan, form), groupDiscountRules), _List_fromArray([
                                    A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                                        A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                                        A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                                        A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                                            allowNewGroupRule ? A3($author$project$Ui$Button$view, {
                                                abP: 'Add group range discount rule'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$GroupDiscountRuleAdd)),
                                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Add Range')
                                            ])) : $author$project$Utils$Html$empty
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Plan$Form$Iua = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$Meta$iuaOptions = function(_v0) {
        var meta = _v0;
        return meta.SJ;
    };
    var $author$project$Components$Plan$Form$iuaOptions = function(meta) {
        return A2($elm$core$List$map, function(iua) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(iua), $author$project$Formatters$String$titleize(iua));
        }, $author$project$Api$Provider$Plan$Meta$iuaOptions(meta));
    };
    var $author$project$Components$Plan$Form$viewIuaOptionsFields = F2(function(plan, form) {
        var meta = $author$project$Api$Provider$Plan$One$meta(plan);
        var _v0 = $author$project$Utils$Form$fields(form);
        var iua = _v0.SI;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Initial Unshareable Amount')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('IUA'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(iua),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$Iua))
                ]), $author$project$Components$Plan$Form$iuaOptions(meta))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Form$PlanChangeAdd = {
        $: 24
    };
    var $author$project$Components$Plan$Form$PlanChangeChangeAfterMonths = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$PlanChangeRemove = {
        $: 25
    };
    var $author$project$Components$Plan$Form$PlanChangeType = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$PlanChangeUndoRemove = {
        $: 26
    };
    var $author$project$Components$DateInput$Errors = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$DateInput$errors = $author$project$Components$DateInput$Errors;
    var $author$project$Components$DateInput$Invalid = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$DateInput$invalid = $author$project$Components$DateInput$Invalid;
    var $author$project$Components$ResourceFilter$Plan$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Plan$Form$viewPlanChangeFields = F3(function(changeOnDateInput, toPlanResourceFilter, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var planChange = _v0.jw;
        var _v1 = planChange.VU;
        var type_ = _v1.ah5;
        var changeAfterMonths = _v1.K2;
        var changeOnDate = _v1.K3;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Plan Change')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Plan Change'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('You may schedule this membership plan to change into another existing membership plan automatically'))
            ]), _List_fromArray([
                !_Utils_eq(planChange.VU.aef, $elm$core$Maybe$Nothing) || planChange.bW ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    !_Utils_eq(planChange.VU.aef, $elm$core$Maybe$Nothing) && !planChange.jN ? $elm$html$Html$text('Scheduled') : $author$project$Utils$Html$empty,
                    _Utils_eq(planChange.VU.aef, $elm$core$Maybe$Nothing) && planChange.bW ? $elm$html$Html$text('Active') : $author$project$Utils$Html$empty,
                    planChange.jN ? $elm$html$Html$text('Removed') : $author$project$Utils$Html$empty,
                    planChange.jN ? A3($author$project$Ui$Button$view, {
                        abP: 'Undo plan removal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeUndoRemove))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Undo')
                    ])) : A3($author$project$Ui$Button$view, {
                        abP: 'Remove plan change'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeRemove))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Remove')
                    ]))
                ])) : $author$project$Utils$Html$empty,
                _Utils_eq(planChange.VU.aef, $elm$core$Maybe$Nothing) && !planChange.bW ? A3($author$project$Ui$Button$view, {
                    abP: 'Add plan change'
                }, _List_fromArray([
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$FormUpdated($author$project$Components$Plan$Form$PlanChangeAdd)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add plan change')
                ])) : $author$project$Utils$Html$empty
            ])),
            !planChange.jN && (!_Utils_eq(planChange.VU.aef, $elm$core$Maybe$Nothing) || planChange.bW) ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$offsetLabel,
                    $author$project$Ui$Form$Group$labelSpanSm(5),
                    $author$project$Ui$Form$Group$inputSpanSm(6),
                    $author$project$Ui$Form$Group$label('Effective date'),
                    $author$project$Ui$Form$Group$labelClass('')
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, type_ === 2 ? _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(12)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, function() {
                                var _v2 = planChange.VU.L6;
                                if (!_v2.$) {
                                    var contractPeriodInMonths = _v2.a;
                                    return _List_fromArray([
                                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths))
                                    ]);
                                } else return _List_fromArray([
                                    $elm$html$Html$text('Contract period')
                                ]);
                            }())
                        ]))
                    ]) : !_Utils_eq(planChange.VU.aef, $elm$core$Maybe$Nothing) ? _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(12)
                        ]), _List_fromArray([
                            function() {
                                switch(type_){
                                    case 1:
                                        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$String$pluralize('month'), changeAfterMonths))),
                                            $elm$html$Html$text(' since member starts')
                                        ]));
                                    case 0:
                                        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), changeOnDate)))
                                        ]));
                                    default:
                                        return $author$project$Utils$Html$empty;
                                }
                            }()
                        ]))
                    ]) : _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(6)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$ButtonSelect$view({
                                afv: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PlanChangeType),
                                z9: _List_fromArray([
                                    A2($author$project$Ui$Form$ButtonSelect$option, 1, 'Periods of months'),
                                    A2($author$project$Ui$Form$ButtonSelect$option, 0, 'Date')
                                ]),
                                aa9: type_
                            })
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(6)
                        ]), _List_fromArray([
                            function() {
                                switch(type_){
                                    case 1:
                                        return $author$project$Ui$Form$PeriodInMonthsInput$view({
                                            fK: A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, form),
                                            q2: A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonthsValidation, form),
                                            afE: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PlanChangeChangeAfterMonths),
                                            aa9: changeAfterMonths
                                        });
                                    case 0:
                                        return A2($elm$html$Html$map, $author$project$Components$Plan$Form$PlanChangeChangeOnDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                                            $author$project$Components$DateInput$value(changeOnDate),
                                            $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, form)),
                                            $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeChangeOnDateValidation, form))
                                        ]), changeOnDateInput));
                                    default:
                                        return $author$project$Utils$Html$empty;
                                }
                            }()
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$offsetLabel,
                    $author$project$Ui$Form$Group$labelSpanSm(5),
                    $author$project$Ui$Form$Group$inputSpanSm(6),
                    $author$project$Ui$Form$Group$label('New plan'),
                    $author$project$Ui$Form$Group$labelClass('')
                ]), _List_fromArray([
                    function() {
                        if (!_Utils_eq(planChange.VU.aef, $elm$core$Maybe$Nothing)) return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, function($) {
                                return $.zr;
                            }, planChange.VU.$5)))
                        ]));
                        else {
                            if (!toPlanResourceFilter.$) {
                                var toPlanResourceFilter_ = toPlanResourceFilter.a;
                                return A2($elm$html$Html$map, $author$project$Components$Plan$Form$PlanChangeToPlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                                    $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$PlanChangeToPlanValidation, form)),
                                    $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$PlanChangeToPlanValidation, form))
                                ]), toPlanResourceFilter_));
                            } else return $author$project$Utils$Html$empty;
                        }
                    }()
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Plan$Form$EditPricingVersion = {
        $: 24
    };
    var $author$project$Components$Plan$Form$PricingEffectivenessTypeChanged = function(a) {
        return {
            $: 41,
            a: a
        };
    };
    var $author$project$Api$Feature$PricingVersions = 21;
    var $author$project$Components$Plan$Form$ScheduleNewPriceChange = {
        $: 23
    };
    var $author$project$Api$Provider$PricingVersion$Shared$effectiveDate = function(_v0) {
        var record = _v0;
        return record.Ow;
    };
    var $author$project$Components$Plan$Form$viewPriceChangeSection = F3(function(practice, plan, formFields) {
        if (A2($author$project$Api$Provider$Practice$One$featureEnabled, 21, practice)) {
            var _v0 = $author$project$Api$Provider$Plan$One$upcomingPricingVersion(plan);
            if (!_v0.$) {
                var pricingVersion = _v0.a;
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Price Change')
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$labelSpanSm(5),
                        $author$project$Ui$Form$Group$inputSpanSm(6),
                        $author$project$Ui$Form$Group$label('Price Change'),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('You may schedule the pricing for this membership plan to change automatically.'))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Scheduled, Effective starting ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$PricingVersion$Shared$effectiveDate(pricingVersion))),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit price change'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$EditPricingVersion)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$labelSpanSm(5),
                        $author$project$Ui$Form$Group$inputSpanSm(6),
                        $author$project$Ui$Form$Group$label('When should members see this new pricing?'),
                        $author$project$Ui$Form$Group$labelClass('')
                    ]), _List_fromArray([
                        $author$project$Ui$Form$ButtonSelect$view({
                            afv: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$PricingEffectivenessTypeChanged),
                            z9: _List_fromArray([
                                A2($author$project$Ui$Form$ButtonSelect$option, 0, 'On First Bill after Effective Date'),
                                formFields.L5 ? A2($author$project$Ui$Form$ButtonSelect$option, 1, 'On Contract Renewal') : A2($author$project$Ui$Form$ButtonSelect$option, 2, 'On Members\' Anniversary')
                            ]),
                            aa9: formFields.Xo
                        })
                    ]))
                ]));
            } else return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Price Change')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$offsetLabel,
                    $author$project$Ui$Form$Group$labelSpanSm(5),
                    $author$project$Ui$Form$Group$inputSpanSm(6),
                    $author$project$Ui$Form$Group$label('Price Change'),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('You may schedule the pricing for this membership plan to change automatically.'))
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Schedule price change'
                        }, _List_fromArray([
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$ScheduleNewPriceChange),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Schedule Price Change')
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Plan$Form$TobaccoSurchargeInCents = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$TobaccoSurchargePercentage = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$TobaccoSurchargeType = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Plan$Form$viewTobaccoSurchargeFields = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var tobaccoSurchargeType = _v0.aad;
        var percentageTobaccoSurchargeType = _Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing) || _Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Just('percentage_per_membership'));
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Tobacco Surcharge')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$label('Tobacco surcharge'),
                $author$project$Ui$Form$Group$labelClass('')
            ]), _List_fromArray([
                $author$project$Ui$Form$ButtonSelect$view({
                    afv: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeType),
                    z9: _List_fromArray([
                        A2($author$project$Ui$Form$ButtonSelect$option, $elm$core$Maybe$Nothing, 'Disabled'),
                        A2($author$project$Ui$Form$ButtonSelect$option, percentageTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_member') : $elm$core$Maybe$Just('fixed_per_member'), 'Per member'),
                        A2($author$project$Ui$Form$ButtonSelect$option, percentageTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_membership') : $elm$core$Maybe$Just('fixed_per_membership'), 'Per membership')
                    ]),
                    aa9: tobaccoSurchargeType
                })
            ])),
            function() {
                if (!_Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing)) {
                    var perMemberTobaccoSurchargeType = _Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Just('percentage_per_member')) || _Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Just('fixed_per_member'));
                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$labelSpanSm(5),
                        $author$project$Ui$Form$Group$inputSpanSm(6),
                        $author$project$Ui$Form$Group$label('Surcharge type'),
                        $author$project$Ui$Form$Group$labelClass('')
                    ]), _List_fromArray([
                        $author$project$Ui$Form$ButtonSelect$view({
                            afv: A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeType),
                            z9: _List_fromArray([
                                A2($author$project$Ui$Form$ButtonSelect$option, perMemberTobaccoSurchargeType ? $elm$core$Maybe$Just('percentage_per_member') : $elm$core$Maybe$Just('percentage_per_membership'), 'Percentage'),
                                A2($author$project$Ui$Form$ButtonSelect$option, perMemberTobaccoSurchargeType ? $elm$core$Maybe$Just('fixed_per_member') : $elm$core$Maybe$Just('fixed_per_membership'), 'Fixed')
                            ]),
                            aa9: tobaccoSurchargeType
                        })
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                if (!_Utils_eq(tobaccoSurchargeType, $elm$core$Maybe$Nothing)) {
                    var label = percentageTobaccoSurchargeType ? 'Percentage' : 'Amount';
                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$labelSpanSm(5),
                        $author$project$Ui$Form$Group$inputSpanSm(6),
                        $author$project$Ui$Form$Group$label(label),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$required(true)
                    ]), function() {
                        if (percentageTobaccoSurchargeType) {
                            var _v1 = $author$project$Utils$Form$fields(form);
                            var tobaccoSurchargePercentage = _v1.aac;
                            return _List_fromArray([
                                $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                                    $author$project$Ui$Form$PercentageInput$value(tobaccoSurchargePercentage),
                                    $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargePercentage)),
                                    $author$project$Ui$Form$PercentageInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, form))
                                ])),
                                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$TobaccoSurchargePercentageValidation, form))
                            ]);
                        } else {
                            var _v2 = $author$project$Utils$Form$fields(form);
                            var tobaccoSurchargeInCents = _v2.aab;
                            return _List_fromArray([
                                $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                                    $author$project$Ui$Form$CurrencyInput$value(tobaccoSurchargeInCents),
                                    $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Plan$Form$FormUpdated, $author$project$Components$Plan$Form$TobaccoSurchargeInCents)),
                                    $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation, form))
                                ])),
                                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Plan$Form$TobaccoSurchargeInCentsValidation, form))
                            ]);
                        }
                    }());
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Plan$Form$viewForm = F3(function(model, plan, form) {
        var sharedFields = A2($author$project$Components$Plan$Form$initSharedFields, plan, form);
        var planType = $author$project$Api$Provider$Plan$One$planType(plan);
        var _v0 = $author$project$Utils$Form$fields(form);
        var basicPlan = _v0.aB;
        var membershipPricingForm = _v0.c$;
        var allBasicFields = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Plan$Form$BasicPlanFormUpdated), A2($author$project$Components$Plan$BasicForm$view, basicPlan, $elm$core$Maybe$Just(plan)));
        return $elm$core$List$concat(_List_fromArray([
            allBasicFields,
            _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    sharedFields.Qh === 'fixed_pricing' ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A2($elm$html$Html$map, $author$project$Components$Plan$Form$GroupTierPricingFieldsUpdated, A3($author$project$Components$Plan$Form$GroupTierPricingFields$view, sharedFields, $elm$core$Maybe$Just(plan), $author$project$Utils$Form$fields(form).i))
                    ])) : A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A2($elm$html$Html$map, $author$project$Components$Plan$Form$IndividualMembershipPricingFieldsUpdated, A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$view, sharedFields, model.W1, $elm$core$Maybe$Just(plan), membershipPricingForm))
                    ])),
                    sharedFields.Qh === 'family' ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A3($author$project$Components$Plan$Form$viewFamilyMembershipPricing, sharedFields, plan, form)
                    ])) : $author$project$Utils$Html$empty,
                    sharedFields.Qh === 'group' ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A2($author$project$Components$Plan$Form$viewGroupMembershipPricingFields, plan, form)
                    ])) : $author$project$Utils$Html$empty
                ])),
                model.W4 ? A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$padding(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$info
                        ]), _List_fromArray([
                            $elm$html$Html$text('If you\'re looking for additional options, or have more than one plan, you can access advanced settings after saving your plan.')
                        ]))
                    ]))
                ])) : $author$project$Utils$Html$empty
            ]),
            planType === 1 ? _List_fromArray([
                $author$project$Utils$Html$empty
            ]) : !model.W4 ? _List_fromArray([
                !$author$project$Api$Provider$Plan$One$isMcePlan(plan) ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    A2($author$project$Components$Plan$Form$viewCoveragePlanFields, plan, form)
                ])) : $author$project$Utils$Html$empty,
                model.oN ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    $author$project$Components$Plan$Form$viewTobaccoSurchargeFields(form)
                ])) : $author$project$Utils$Html$empty,
                $author$project$Api$Provider$Plan$One$isMcePlan(plan) ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    A2($author$project$Components$Plan$Form$viewIuaOptionsFields, plan, form)
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    !$author$project$Api$Provider$Plan$One$isMcePlan(plan) ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        $author$project$Components$Plan$Form$viewAgeRestrictionsFields(form)
                    ])) : $author$project$Utils$Html$empty,
                    function() {
                        if (A2($author$project$Utils$FeatureGate$gateAvailable, 7, $author$project$Api$Practice$Provider(model.W1))) {
                            var forCompany = !$author$project$Api$Provider$Plan$One$planType(plan);
                            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                $author$project$Ui$HorizontalRule$view(_List_Nil),
                                $author$project$Ui$Typography$heading(_List_fromArray([
                                    $elm$html$Html$text('Advanced Pricing Rules')
                                ])),
                                $author$project$Utils$Html$noBreakSpace,
                                !forCompany && !$author$project$Api$Provider$Plan$One$isMcePlan(plan) ? A2($author$project$Ui$Typography$div, _List_Nil, A2($author$project$Components$Plan$Form$viewContractPeriodFields, plan, form)) : $author$project$Utils$Html$empty,
                                model.jx ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    A3($author$project$Components$Plan$Form$viewPlanChangeFields, model.r8, model.gt, form)
                                ])) : $author$project$Utils$Html$empty,
                                A3($author$project$Components$Plan$Form$viewPriceChangeSection, model.W1, plan, $author$project$Utils$Form$fields(form)),
                                function() {
                                    if (!$author$project$Api$Provider$Plan$One$isMcePlan(plan)) {
                                        var _v1 = $author$project$Utils$Form$fields(form);
                                        var specialRatesForm = _v1.dj;
                                        return A2($elm$html$Html$map, $author$project$Components$Plan$Form$SpecialRatesFieldsUpdated, A2($author$project$Components$Plan$Form$SpecialRatesFields$view, plan, specialRatesForm));
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]) : _List_fromArray([
                $author$project$Utils$Html$empty
            ])
        ]));
    });
    var $author$project$Components$Plan$Form$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            $author$project$Components$Plan$Form$modal(model),
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$autocomplete(false),
                $author$project$Ui$Form$onSubmit($author$project$Components$Plan$Form$Save)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, model.W4 ? _List_fromArray([
                    $author$project$Ui$Panel$onlyBorderLeft
                ]) : _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, function() {
                        var _v1 = model.PU;
                        if (!_v1.$) {
                            var _v2 = _v1.a;
                            var plan = _v2.a;
                            var form = _v2.b;
                            return A3($author$project$Components$Plan$Form$viewForm, model, plan, form);
                        } else return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Panel$footer, _List_fromArray([
                        $author$project$Ui$Element$flexCol
                    ]), function() {
                        var _v3 = model.PU;
                        if (!_v3.$) {
                            var _v4 = _v3.a;
                            var plan = _v4.a;
                            var form = _v4.b;
                            return _List_fromArray([
                                $author$project$Utils$Form$hasAnyValidationError(form) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$offsetSm(3),
                                        $author$project$Ui$Grid$spanSm(6)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Please review the errors above')
                                        ]))
                                    ]))
                                ])) : $author$project$Utils$Html$empty,
                                $author$project$Api$Provider$Plan$One$isMcePlan(plan) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$offsetSm(3),
                                        $author$project$Ui$Grid$spanSm(6)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('This plan requires special pricing. '),
                                            $elm$html$Html$text('If you have questions or need to make changes, please contact us at '),
                                            A3($author$project$Ui$Link$mailto, 'support@hint.com', _List_Nil, _List_fromArray([
                                                $elm$html$Html$text('support@hint.com')
                                            ]))
                                        ]))
                                    ]))
                                ])) : $author$project$Utils$Html$empty,
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$gap2,
                                    $author$project$Ui$Element$justifyCenter,
                                    $author$project$Ui$Element$itemsCenter
                                ]), _List_fromArray([
                                    $author$project$Components$Plan$Form$viewBackButton(model.Gc),
                                    $author$project$Api$Provider$Plan$One$isDestroyable(plan) ? A3($author$project$Ui$Button$view, {
                                        abP: 'Delete plan'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$danger,
                                        $author$project$Ui$Button$onClick($author$project$Components$Plan$Form$DeletePlan(plan)),
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Delete')
                                    ])) : $author$project$Utils$Html$empty,
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Save plan'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$primary,
                                        $author$project$Ui$Button$submit,
                                        $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Save Plan')
                                    ]))
                                ]))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Components$Plan$Form$viewBackButton(model.Gc)
                        ]);
                    }())
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$CompanyPlans$Id_String$view = function(model) {
        return {
            fb: $author$project$Components$Plan$Form$view(model.nB),
            $2: 'Admin | Sponsor Plans'
        };
    };
    var $author$project$Pages$Admin$CompanyPlans$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CompanyPlans$Id_String$init,
        aeR: $author$project$Pages$Admin$CompanyPlans$Id_String$load,
        ag3: $author$project$Pages$Admin$CompanyPlans$Id_String$save,
        ahE: $author$project$Pages$Admin$CompanyPlans$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$CompanyPlans$Id_String$update,
        aid: $author$project$Pages$Admin$CompanyPlans$Id_String$view
    });
    var $author$project$Pages$Admin$CompanyPlans$New$NewMsg = $elm$core$Basics$identity;
    var $author$project$Components$Admin$Plans$New$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$Plans$New$formFieldsInit = function(type_) {
        return {
            Ma: $elm$core$Maybe$Nothing,
            zr: '',
            ah5: type_
        };
    };
    var $author$project$Components$Admin$Plans$New$initPlanResourceFilter = F3(function(apiClient, session, planType) {
        return A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                A8: _List_fromArray([
                    planType
                ])
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'None'
            });
        });
    });
    var $author$project$Components$Admin$Plans$New$init = F5(function(apiClient, session, planType, listRoute, editRoute) {
        var _v0 = A3($author$project$Components$Admin$Plans$New$initPlanResourceFilter, apiClient, session, planType);
        var planResourceFilter = _v0.a;
        var planResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Fj: editRoute,
            PU: $author$project$Utils$Form$init($author$project$Components$Admin$Plans$New$formFieldsInit(planType)),
            Gc: listRoute,
            GW: $author$project$Api$Data$NotAsked,
            jy: planResourceFilter,
            WN: planType,
            Z$: session
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterCmd));
    });
    var $author$project$Pages$Admin$CompanyPlans$New$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var _v3 = A5($author$project$Components$Admin$Plans$New$init, apiClient, session, 0, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top, $author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String);
        var form = _v3.a;
        var newCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd));
    });
    var $author$project$Pages$Admin$CompanyPlans$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$CompanyPlans$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$CompanyPlans$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Admin$Plans$New$CopyFrom = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Plans$New$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$createBasic = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                _Utils_Tuple2('plan', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('plan_type', $elm$json$Json$Encode$string($author$project$Api$PlanType$toString(fields.WN))),
                    _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr))
                ])))
            ]),
            function() {
                var _v0 = fields.Ma;
                if (!_v0.$) {
                    var id_ = _v0.a;
                    return _List_fromArray([
                        _Utils_Tuple2('copy_from', $author$project$Utils$Encode$association(id_))
                    ]);
                } else return _List_Nil;
            }()
        ])));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
    });
    var $author$project$Components$Admin$Plans$New$createPlan = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Plan$createBasic, apiClient, {
            Ma: fields.Ma,
            zr: fields.zr,
            WN: fields.ah5
        }, $author$project$Components$Admin$Plans$New$Created);
    });
    var $author$project$Components$Admin$Plans$New$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    Ma: string
                });
            default:
                var type_ = field.a;
                return _Utils_update(fields, {
                    ah5: type_
                });
        }
    });
    var $author$project$Components$Admin$Plans$New$NameValidation = 0;
    var $author$project$Components$Admin$Plans$New$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a plan name.'))
    ]));
    var $author$project$Components$ResourceFilter$Plan$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Admin$Plans$New$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Plans$New$formFieldsUpdate, field, model.PU);
                var _v2 = function() {
                    if (field.$ === 2) {
                        var planType = field.a;
                        return A3($author$project$Components$Admin$Plans$New$initPlanResourceFilter, apiClient, model.Z$, planType);
                    } else return _Utils_Tuple2(model.jy, $elm$core$Platform$Cmd$none);
                }();
                var planResourceFilter = _v2.a;
                var planResourceFilterCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm,
                    jy: planResourceFilter
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterCmd), _List_Nil);
            case 1:
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Plans$New$formFieldsValidator, model.PU);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm,
                        GW: $author$project$Api$Data$Loading
                    }), A2($author$project$Components$Admin$Plans$New$createPlan, apiClient, validFormFields), _List_Nil);
                } else {
                    var newForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var plan = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        GW: response
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.Fj({
                        aef: $author$project$Api$Provider$Plan$One$id(plan)
                    })), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Plan successfully created.'),
                        $author$project$OutMsg$RefreshPractice
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    GW: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var planResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jy);
                var modelAfterEvent = function() {
                    var _v7 = planResourceFilterResult.adu;
                    if (!_v7.$) {
                        if (!_v7.a.$) return _Utils_update(model, {
                            PU: A3($author$project$Utils$Form$update, $author$project$Components$Admin$Plans$New$formFieldsUpdate, $author$project$Components$Admin$Plans$New$CopyFrom($author$project$Components$ResourceFilter$Plan$value(planResourceFilterResult.zi)), model.PU)
                        });
                        else {
                            var _v8 = _v7.a;
                            return model;
                        }
                    } else return model;
                }();
                return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
                    jy: planResourceFilterResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, planResourceFilterResult.EQ), planResourceFilterResult.at);
        }
    });
    var $author$project$Pages$Admin$CompanyPlans$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$Plans$New$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var newCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd), outMsgs);
    });
    var $author$project$Components$Admin$Plans$New$Create = {
        $: 1
    };
    var $author$project$Components$Admin$Plans$New$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Plans$New$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Plans$New$Type = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$Plans$New$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$onSubmit($author$project$Components$Admin$Plans$New$Create),
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Create New Plan')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Name your plan'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$autofocus(true),
                            $author$project$Ui$Form$Input$value(fields.zr),
                            $author$project$Ui$Form$Input$placeholder('New Membership Type'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Plans$New$FormUpdated, $author$project$Components$Admin$Plans$New$Name)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Copy plan details from'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Admin$Plans$New$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.jy))
                    ])),
                    fields.ah5 !== 2 ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Plan Type'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        $author$project$Ui$Button$group(_List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Select per member type '
                            }, _List_fromArray([
                                $author$project$Ui$Button$active(!fields.ah5),
                                $author$project$Ui$Button$onClick($author$project$Components$Admin$Plans$New$FormUpdated($author$project$Components$Admin$Plans$New$Type(0)))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Per member')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Select fixed fee type '
                            }, _List_fromArray([
                                $author$project$Ui$Button$active(fields.ah5 === 1),
                                $author$project$Ui$Button$onClick($author$project$Components$Admin$Plans$New$FormUpdated($author$project$Components$Admin$Plans$New$Type(1)))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Fixed fee')
                            ]))
                        ]))
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, model.Gc, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Create new plan'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$loading(_Utils_eq(model.GW, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Create New Plan')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$CompanyPlans$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$Plans$New$view(model.PU))
            ]),
            $2: 'Admin | Sponsor Plans'
        };
    };
    var $author$project$Pages$Admin$CompanyPlans$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CompanyPlans$New$init,
        aeR: $author$project$Pages$Admin$CompanyPlans$New$load,
        ag3: $author$project$Pages$Admin$CompanyPlans$New$save,
        ahE: $author$project$Pages$Admin$CompanyPlans$New$subscriptions,
        aaO: $author$project$Pages$Admin$CompanyPlans$New$update,
        aid: $author$project$Pages$Admin$CompanyPlans$New$view
    });
    var $author$project$Pages$Admin$CompanyPlans$Top$ListMsg = $elm$core$Basics$identity;
    var $author$project$Components$Admin$Plans$List$GotPlans = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$Pricing = 0;
    var $author$project$Components$Admin$Plans$List$fetchPlans = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Plan$list, apiClient, function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ]),
                af_: model.af_,
                A8: model.A8,
                agq: model.agq
            });
        }, $author$project$Components$Admin$Plans$List$GotPlans);
    });
    var $author$project$Components$Admin$Plans$List$init = function(apiClient) {
        return function(session) {
            return function(userIsAdmin) {
                return function(planTypes) {
                    return function(listRoute) {
                        return function(newRoute) {
                            return function(editRoute) {
                                return function(help) {
                                    return function(query) {
                                        return function(_v0) {
                                            return function(practice) {
                                                var isOnboarding = _v0.aK;
                                                var q = A2($elm$core$Dict$get, 'q', query);
                                                var allowMultipleRetailMemberships = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships, practice));
                                                var model = {
                                                    I9: allowMultipleRetailMemberships,
                                                    Fj: editRoute,
                                                    QF: help,
                                                    aK: isOnboarding,
                                                    Gc: listRoute,
                                                    Gs: newRoute,
                                                    af_: $author$project$Api$Pagination$initFromQuery(query),
                                                    A8: planTypes,
                                                    WO: $author$project$Api$Data$Loading,
                                                    W1: practice,
                                                    agq: q,
                                                    sG: $author$project$Ui$SearchInput$init(q),
                                                    Z$: session,
                                                    DT: userIsAdmin
                                                };
                                                return _Utils_Tuple2(model, A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, model));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Pages$Admin$CompanyPlans$Top$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var query = _v1.Bz;
        var _v2 = $author$project$Components$Admin$Plans$List$init(apiClient)(session)($author$project$Api$Platform$User$Shared$isAdmin($author$project$Api$Platform$Session$One$user(session)))(_List_fromArray([
            0,
            1,
            3
        ]))($author$project$Spa$Generated$Route$Admin__CompanyPlans__Top)($author$project$Spa$Generated$Route$Admin__CompanyPlans__New)($author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String)(_List_Nil)(query)({
            aK: false
        })($elm$core$Maybe$Just(practice));
        var list = _v2.a;
        var listCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            rk: list
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
    });
    var $author$project$Pages$Admin$CompanyPlans$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$CompanyPlans$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$CompanyPlans$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$Plans$List$SearchInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Practice$One$practiceOnboarding = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.W5;
    });
    var $author$project$Api$Provider$PracticeOnboarding$AccountStep$toString = function(stepType) {
        switch(stepType){
            case 0:
                return 'not_started';
            case 1:
                return 'contact_info';
            case 2:
                return 'membership_pricing';
            case 3:
                return 'patient_agreements';
            case 4:
                return 'users_setup';
            case 5:
                return 'communications_setup';
            case 6:
                return 'legal_setup';
            case 7:
                return 'setup_completed';
            default:
                return 'setup_completed';
        }
    };
    var $author$project$Components$Admin$Plans$List$PracticeOnboardingUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice_onboardings'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath);
    };
    var $author$project$Api$Provider$PracticeOnboarding$updateAccountStep = F4(function(apiClient, accountStep, id, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_onboarding', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('account_step', $elm$json$Json$Encode$string(accountStep))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
    });
    var $author$project$Components$Admin$Plans$List$updatePracticeOnboarding = F3(function(apiClient, onboardId, accountStep) {
        return A4($author$project$Api$Provider$PracticeOnboarding$updateAccountStep, apiClient, accountStep, onboardId, $author$project$Components$Admin$Plans$List$PracticeOnboardingUpdated);
    });
    var $author$project$Components$Admin$Plans$List$completePlansStep = F2(function(apiClient, practice) {
        var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$Shared$id, $author$project$Api$Provider$Practice$One$practiceOnboarding(practice));
        if (!_v0.$) {
            var onboardId = _v0.a;
            return A3($author$project$Components$Admin$Plans$List$updatePracticeOnboarding, apiClient, onboardId, $author$project$Api$Provider$PracticeOnboarding$AccountStep$toString(2));
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Api$Provider$Practice$disableMultipleRetailMemberships = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'multiple_retail_memberships',
            'disable'
        ]), $author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Api$Provider$Practice$enableMultipleRetailMemberships = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'multiple_retail_memberships',
            'enable'
        ]), $author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Components$Admin$Plans$List$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString(model.Gc)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Components$Admin$Plans$List$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        WO: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    WO: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            WO: $author$project$Api$Data$Loading,
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, qModel),
                            $author$project$Components$Admin$Plans$List$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Plans$List$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    WO: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Admin$Plans$List$fetchPlans, apiClient, newModel),
                    $author$project$Components$Admin$Plans$List$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var _v5 = model.W1;
                if (!_v5.$) {
                    var practice = _v5.a;
                    return _Utils_Tuple3(model, A2($author$project$Components$Admin$Plans$List$completePlansStep, apiClient, practice), _List_Nil);
                } else return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents), _List_Nil);
            case 4:
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans__New), _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var enabled = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    I9: enabled
                }), enabled ? A2($author$project$Api$Provider$Practice$enableMultipleRetailMemberships, apiClient, $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated) : A2($author$project$Api$Provider$Practice$disableMultipleRetailMemberships, apiClient, $author$project$Components$Admin$Plans$List$AllowMultipleRetailMembershipsUpdated), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$RefreshPractice
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    I9: !model.I9
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$CompanyPlans$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.Ej, subMsg, model.rk);
        var list = _v1.a;
        var listCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: list
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd), outMsgs);
    });
    var $author$project$Components$Admin$Plans$List$AddAnother = {
        $: 4
    };
    var $author$project$Components$Admin$Plans$List$NextStep = {
        $: 3
    };
    var $author$project$Components$Admin$Plans$List$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Skeleton$card = $author$project$Ui$Skeleton$view('card');
    var $author$project$Ui$Grid$mt2 = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$mt2);
    var $author$project$Api$FeatureGate$MultipleRetailMemberships = 13;
    var $author$project$Components$Admin$Plans$List$ToggleAllowMultipleRetailMemberships = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Grid$mb4 = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$mb4);
    var $author$project$Ui$Grid$mt4 = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$mt4);
    var $author$project$Components$Admin$Plans$List$viewAllowMultipleRetailMembershipsSetting = function(model) {
        var isGateAvailable = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Practice$Provider, $author$project$Utils$FeatureGate$gateAvailable(13)), model.W1));
        if (isGateAvailable) {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(model.I9),
                $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$Plans$List$ToggleAllowMultipleRetailMemberships)
            ]));
            var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patients can join more than one active retail membership at the same time, each with its own billing rules and member settings.')
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text('Note: Multiple employer-sponsored memberships, networks, and affiliate practices are not yet supported.')
                ]))
            ]));
            return A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mt4,
                $author$project$Ui$Grid$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Allow patients to enroll in multiple retail memberships'),
                        $author$project$Ui$Form$Group$labelHelp(labelHelp),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$labelSpan(8),
                        $author$project$Ui$Form$Group$inputSpan(4),
                        $author$project$Ui$Form$Group$clearfix
                    ]), _List_Nil)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    toggleSwitch
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Period$billName = function(_v0) {
        var period = _v0;
        return period.lg;
    };
    var $author$project$Api$Provider$Plan$Shared$default = function(_v0) {
        var record = _v0;
        return record.Nn;
    };
    var $author$project$Api$Provider$Plan$All$default = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$default(shared);
    };
    var $elm_community$string_extra$String$Extra$ellipsisWith = F3(function(howLong, append, string) {
        return _Utils_cmp($elm$core$String$length(string), howLong) < 1 ? string : _Utils_ap(A2($elm$core$String$left, howLong - $elm$core$String$length(append), string), append);
    });
    var $elm_community$string_extra$String$Extra$ellipsis = F2(function(howLong, string) {
        return A3($elm_community$string_extra$String$Extra$ellipsisWith, howLong, '...', string);
    });
    var $author$project$Formatters$String$ellipsis = $elm_community$string_extra$String$Extra$ellipsis;
    var $author$project$Api$Provider$Plan$Shared$periods = function(_v0) {
        var record = _v0;
        return A2($elm$core$List$filterMap, $author$project$Api$Period$retrieve, record.Ef);
    };
    var $author$project$Api$Provider$Plan$All$periods = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$periods(shared);
    };
    var $elm_community$string_extra$String$Extra$toSentenceBaseCase = function(list) {
        _v0$2: while(true){
            if (list.b) {
                if (!list.b.b) {
                    var x = list.a;
                    return x;
                } else {
                    if (!list.b.b.b) {
                        var x = list.a;
                        var _v1 = list.b;
                        var y = _v1.a;
                        return x + (' and ' + y);
                    } else break _v0$2;
                }
            } else break _v0$2;
        }
        return '';
    };
    var $elm_community$string_extra$String$Extra$toSentenceHelper = F3(function(lastPart, sentence, list) {
        toSentenceHelper: while(true){
            if (!list.b) return sentence;
            else if (!list.b.b) {
                var x = list.a;
                return _Utils_ap(sentence, _Utils_ap(lastPart, x));
            } else {
                var x = list.a;
                var xs = list.b;
                var $temp$lastPart = lastPart, $temp$sentence = sentence + (', ' + x), $temp$list = xs;
                lastPart = $temp$lastPart;
                sentence = $temp$sentence;
                list = $temp$list;
                continue toSentenceHelper;
            }
        }
    });
    var $elm_community$string_extra$String$Extra$toSentence = function(list) {
        if (list.b && list.b.b && list.b.b.b) {
            var x = list.a;
            var _v1 = list.b;
            var y = _v1.a;
            var _v2 = _v1.b;
            var z = _v2.a;
            var more = _v2.b;
            return A3($elm_community$string_extra$String$Extra$toSentenceHelper, ' and ', x + (', ' + y), A2($elm$core$List$cons, z, more));
        } else return $elm_community$string_extra$String$Extra$toSentenceBaseCase(list);
    };
    var $author$project$Formatters$String$toSentence = $elm_community$string_extra$String$Extra$toSentence;
    var $author$project$Api$RateRule$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$RateRule$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Plan$Shared$ageRateRules = function(_v0) {
        var record = _v0;
        return record.I_;
    };
    var $author$project$Api$Employer$Plan$All$ageRateRules = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$ageRateRules(shared);
    };
    var $author$project$Api$Employer$Plan$One$ageRateRules = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$ageRateRules(shared);
    };
    var $author$project$Api$Provider$Plan$All$ageRateRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$ageRateRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$ageRateRules(shared);
    };
    var $author$project$Api$Plan$ageRateRules = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$List$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$Shared$ageRateRules(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$List$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$SharedWithContractInfo$ageRateRules(plan_));
            case 4:
                var plan_ = plan.a;
                return A2($elm$core$List$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$Shared$ageRateRules(plan_));
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$List$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$All$ageRateRules(plan_));
            case 6:
                var plan_ = plan.a;
                return A2($elm$core$List$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$All$ageRateRules(plan_));
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$List$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$One$ageRateRules(plan_));
            default:
                var plan_ = plan.a;
                return A2($elm$core$List$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$One$ageRateRules(plan_));
        }
    };
    var $author$project$Api$Employer$Company$One$billAffiliateRate = function(_v0) {
        var record = _v0.b;
        return record.Kb;
    };
    var $author$project$Api$Provider$Company$Shared$billAffiliateRate = function(_v0) {
        var record = _v0;
        return record.Kb;
    };
    var $author$project$Api$Provider$Company$One$billAffiliateRate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$billAffiliateRate(shared);
    };
    var $author$project$Api$Company$billAffiliateRate = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$billAffiliateRate(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$billAffiliateRate(company_);
        }
    };
    var $author$project$Api$Network$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Network$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Practice$One$network = function(_v0) {
        var record = _v0;
        return record.UK;
    };
    var $author$project$Api$Provider$Practice$One$network = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.UK;
    });
    var $author$project$Api$Practice$network = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$Provider, $author$project$Api$Provider$Practice$One$network(practice_));
        } else {
            var practice_ = practice.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$Employer, $author$project$Api$Employer$Practice$One$network(practice_));
        }
    };
    var $author$project$Api$Employer$Network$Shared$ratesFromAffiliate = function(_v0) {
        var record = _v0;
        return record.X9;
    };
    var $author$project$Api$Provider$Network$Shared$ratesFromAffiliate = function(_v0) {
        var record = _v0;
        return record.X9;
    };
    var $author$project$Api$Network$Shared$ratesFromAffiliate = function(network) {
        if (!network.$) {
            var network_ = network.a;
            return $author$project$Api$Provider$Network$Shared$ratesFromAffiliate(network_);
        } else {
            var network_ = network.a;
            return $author$project$Api$Employer$Network$Shared$ratesFromAffiliate(network_);
        }
    };
    var $author$project$Components$Plan$Summary$Pricing$billAffiliateRate = F2(function(practice, company) {
        var network = A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Practice$network, practice));
        var ratesFromAffiliate = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$ratesFromAffiliate, network));
        var billAffiliateRateCompanySetting = function() {
            if (!company.$) {
                var company_ = company.a;
                return $author$project$Api$Company$billAffiliateRate(company_);
            } else return false;
        }();
        return ratesFromAffiliate && billAffiliateRateCompanySetting;
    });
    var $author$project$Api$Employer$Plan$Shared$coupleRateRule = function(_v0) {
        var record = _v0;
        return record.Mh;
    };
    var $author$project$Api$Employer$Plan$All$coupleRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$coupleRateRule(shared);
    };
    var $author$project$Api$Employer$Plan$One$coupleRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$coupleRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$All$coupleRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$coupleRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$coupleRateRule(shared);
    };
    var $author$project$Api$Plan$coupleRateRule = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$Shared$coupleRateRule(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$SharedWithContractInfo$coupleRateRule(plan_));
            case 4:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$Shared$coupleRateRule(plan_));
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$All$coupleRateRule(plan_));
            case 6:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$All$coupleRateRule(plan_));
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$One$coupleRateRule(plan_));
            default:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$One$coupleRateRule(plan_));
        }
    };
    var $author$project$Api$Employer$Plan$Shared$familyRateRule = function(_v0) {
        var record = _v0;
        return record.Pr;
    };
    var $author$project$Api$Employer$Plan$All$familyRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$familyRateRule(shared);
    };
    var $author$project$Api$Employer$Plan$One$familyRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$familyRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$All$familyRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyRateRule(shared);
    };
    var $author$project$Api$Plan$familyRateRule = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$Shared$familyRateRule(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$SharedWithContractInfo$familyRateRule(plan_));
            case 4:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$Shared$familyRateRule(plan_));
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$All$familyRateRule(plan_));
            case 6:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$All$familyRateRule(plan_));
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$One$familyRateRule(plan_));
            default:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$One$familyRateRule(plan_));
        }
    };
    var $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule = function(_v0) {
        var record = _v0;
        return record.Pt;
    };
    var $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Plan$familyWithSingleChildRateRule = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRule(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRule(plan_));
            case 4:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRule(plan_));
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRule(plan_));
            case 6:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRule(plan_));
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRule(plan_));
            default:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRule(plan_));
        }
    };
    var $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var record = _v0;
        return record.Pu;
    };
    var $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Plan$familyWithSingleChildRateRuleEnabled = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$familyWithSingleChildRateRuleEnabled(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$familyWithSingleChildRateRuleEnabled(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$familyWithSingleChildRateRuleEnabled(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$familyWithSingleChildRateRuleEnabled(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$familyWithSingleChildRateRuleEnabled(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$familyWithSingleChildRateRuleEnabled(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$familyWithSingleChildRateRuleEnabled(plan_);
        }
    };
    var $author$project$Api$Employer$Plan$Shared$groupPricingType = function(_v0) {
        var record = _v0;
        return record.Qh;
    };
    var $author$project$Api$Employer$Plan$All$groupPricingType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$groupPricingType(shared);
    };
    var $author$project$Api$Employer$Plan$One$groupPricingType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$groupPricingType(shared);
    };
    var $author$project$Api$Provider$Plan$All$groupPricingType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$groupPricingType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$groupPricingType(shared);
    };
    var $author$project$Api$Plan$groupPricingType = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$groupPricingType(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$groupPricingType(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$groupPricingType(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$groupPricingType(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$groupPricingType(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$groupPricingType(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$groupPricingType(plan_);
        }
    };
    var $author$project$Api$Provider$Plan$Shared$discountRules = function(_v0) {
        var record = _v0;
        return record.N2;
    };
    var $author$project$Api$Provider$Plan$All$discountRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
    };
    var $author$project$Api$Provider$Plan$One$discountRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$discountRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$discountRules(shared);
    };
    var $author$project$Api$Plan$hasDiscountRules = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$Shared$discountRules(plan_));
            case 1:
                var plan_ = plan.a;
                return !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$SharedWithContractInfo$discountRules(plan_));
            case 4:
                return false;
            case 2:
                var plan_ = plan.a;
                return !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$All$discountRules(plan_));
            case 6:
                return false;
            case 3:
                var plan_ = plan.a;
                return !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$One$discountRules(plan_));
            default:
                return false;
        }
    };
    var $author$project$Api$Provider$Plan$All$specialRates = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$specialRates(shared);
    };
    var $author$project$Api$Plan$hasSpecialRates = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$Shared$specialRates(plan_));
            case 1:
                var plan_ = plan.a;
                return !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(plan_));
            case 4:
                return false;
            case 2:
                var plan_ = plan.a;
                return !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$All$specialRates(plan_));
            case 6:
                return false;
            case 3:
                var plan_ = plan.a;
                return !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$One$specialRates(plan_));
            default:
                return false;
        }
    };
    var $author$project$Api$Employer$Plan$Shared$individualRateRule = function(_v0) {
        var record = _v0;
        return record.Rb;
    };
    var $author$project$Api$Employer$Plan$All$individualRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$individualRateRule(shared);
    };
    var $author$project$Api$Employer$Plan$One$individualRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$individualRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$All$individualRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$individualRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$individualRateRule(shared);
    };
    var $author$project$Api$Plan$individualRateRule = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$Shared$individualRateRule(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$SharedWithContractInfo$individualRateRule(plan_));
            case 4:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$Shared$individualRateRule(plan_));
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$All$individualRateRule(plan_));
            case 6:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$All$individualRateRule(plan_));
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$One$individualRateRule(plan_));
            default:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$One$individualRateRule(plan_));
        }
    };
    var $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents = function(_v0) {
        var record = _v0;
        return record.Rd;
    };
    var $author$project$Api$Employer$Plan$All$individualRegistrationFeeInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(shared);
    };
    var $author$project$Api$Employer$Plan$One$individualRegistrationFeeInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(shared);
    };
    var $author$project$Api$Provider$Plan$All$individualRegistrationFeeInCents = function(_v0) {
        var record = _v0.b;
        return record.Rd;
    };
    var $author$project$Api$Plan$individualRegistrationFeeInCents = function(plan) {
        switch(plan.$){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$individualRegistrationFeeInCents(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$individualRegistrationFeeInCents(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$individualRegistrationFeeInCents(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$individualRegistrationFeeInCents(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$individualRegistrationFeeInCents(plan_);
        }
    };
    var $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents = function(_v0) {
        var record = _v0;
        return record.TN;
    };
    var $author$project$Api$Employer$Plan$All$maxRegistrationFeeInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(shared);
    };
    var $author$project$Api$Employer$Plan$One$maxRegistrationFeeInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(shared);
    };
    var $author$project$Api$Provider$Plan$All$maxRegistrationFeeInCents = function(_v0) {
        var record = _v0.b;
        return record.TN;
    };
    var $author$project$Api$Plan$maxRegistrationFeeInCents = function(plan) {
        switch(plan.$){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$maxRegistrationFeeInCents(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$maxRegistrationFeeInCents(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$maxRegistrationFeeInCents(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$maxRegistrationFeeInCents(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$maxRegistrationFeeInCents(plan_);
        }
    };
    var $author$project$Api$Employer$Plan$Shared$periods = function(_v0) {
        var record = _v0;
        return A2($elm$core$List$filterMap, $author$project$Api$Period$retrieve, record.Ef);
    };
    var $author$project$Api$Employer$Plan$All$periods = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$periods(shared);
    };
    var $author$project$Api$Employer$Plan$One$periods = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$periods(shared);
    };
    var $author$project$Api$Provider$Plan$One$periods = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$periods(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$periods = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$periods(shared);
    };
    var $author$project$Api$Plan$periods = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$periods(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$periods(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$periods(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$periods(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$periods(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$periods(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$periods(plan_);
        }
    };
    var $author$project$Api$Employer$Plan$Shared$planType = function(_v0) {
        var record = _v0;
        return record.WN;
    };
    var $author$project$Api$Employer$Plan$All$planType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$planType(shared);
    };
    var $author$project$Api$Employer$Plan$One$planType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$planType(shared);
    };
    var $author$project$Api$Provider$Plan$All$planType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$planType(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$planType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$planType(shared);
    };
    var $author$project$Api$Plan$planType = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$planType(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$planType(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$planType(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$planType(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$planType(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$planType(plan_);
        }
    };
    var $author$project$Api$Period$rateName = function(_v0) {
        var period = _v0;
        return period.nR;
    };
    var $author$project$Api$Employer$Plan$Shared$singleParentRateRule = function(_v0) {
        var record = _v0;
        return record._w;
    };
    var $author$project$Api$Employer$Plan$All$singleParentRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$singleParentRateRule(shared);
    };
    var $author$project$Api$Employer$Plan$One$singleParentRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$singleParentRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$All$singleParentRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentRateRule(shared);
    };
    var $author$project$Api$Plan$singleParentRateRule = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$Shared$singleParentRateRule(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentRateRule(plan_));
            case 4:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$Shared$singleParentRateRule(plan_));
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$All$singleParentRateRule(plan_));
            case 6:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$All$singleParentRateRule(plan_));
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$One$singleParentRateRule(plan_));
            default:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$One$singleParentRateRule(plan_));
        }
    };
    var $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule = function(_v0) {
        var record = _v0;
        return record._y;
    };
    var $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(shared);
    };
    var $author$project$Api$Plan$singleParentWithSingleChildRateRule = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRule(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRule(plan_));
            case 4:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRule(plan_));
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRule(plan_));
            case 6:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRule(plan_));
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Provider, $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRule(plan_));
            default:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$Employer, $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRule(plan_));
        }
    };
    var $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var record = _v0;
        return record._z;
    };
    var $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRuleEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(shared);
    };
    var $author$project$Api$Plan$singleParentWithSingleChildRateRuleEnabled = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$singleParentWithSingleChildRateRuleEnabled(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$singleParentWithSingleChildRateRuleEnabled(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$singleParentWithSingleChildRateRuleEnabled(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$singleParentWithSingleChildRateRuleEnabled(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$singleParentWithSingleChildRateRuleEnabled(plan_);
        }
    };
    var $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents = function(_v0) {
        var record = _v0;
        return record.adR;
    };
    var $author$project$Api$PricingStructure$fixedAmountInCents = function(pricingStructure) {
        var pricingStructure_ = pricingStructure;
        return $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(pricingStructure_);
    };
    var $author$project$Api$Provider$PricingStructure$Shared$percentage = function(_v0) {
        var record = _v0;
        return record.af9;
    };
    var $author$project$Api$PricingStructure$percentage = function(pricingStructure) {
        var pricingStructure_ = pricingStructure;
        return $author$project$Api$Provider$PricingStructure$Shared$percentage(pricingStructure_);
    };
    var $author$project$Api$PricingStructure$ProviderShared = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Plan$Shared$pricingFrom = function(_v0) {
        var record = _v0;
        return record.Xp;
    };
    var $author$project$Api$Provider$Plan$All$pricingFrom = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
    };
    var $author$project$Api$Provider$Plan$One$pricingFrom = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$pricingFrom = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$pricingFrom(shared);
    };
    var $author$project$Api$Plan$pricingFrom = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $elm$core$Basics$identity, $author$project$Api$Provider$Plan$Shared$pricingFrom(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $elm$core$Basics$identity, $author$project$Api$Provider$Plan$SharedWithContractInfo$pricingFrom(plan_));
            case 4:
                return $elm$core$Maybe$Nothing;
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $elm$core$Basics$identity, $author$project$Api$Provider$Plan$All$pricingFrom(plan_));
            case 6:
                return $elm$core$Maybe$Nothing;
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $elm$core$Basics$identity, $author$project$Api$Provider$Plan$One$pricingFrom(plan_));
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Plan$Summary$Percentage$view = function(plan) {
        var pricingFrom = $author$project$Api$Plan$pricingFrom(plan);
        return _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$PricingStructure$percentage, $author$project$Formatters$Float$toPercentage), pricingFrom)))
            ])),
            function() {
                var _v0 = A2($elm$core$Maybe$map, $author$project$Api$PricingStructure$fixedAmountInCents, pricingFrom);
                if (!_v0.$) {
                    var fixedAmountInCents = _v0.a;
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        fixedAmountInCents >= 0 ? $elm$html$Html$text(' + ') : $elm$html$Html$text(' - '),
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($elm$core$Basics$abs(fixedAmountInCents)))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text(' per member')
            ]))
        ]);
    };
    var $author$project$Api$Employer$SponsorFeeDeal$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$SponsorFeeDeal$Shared$amountInCents = function(sponsorFeeDeal) {
        if (!sponsorFeeDeal.$) {
            var sponsorFeeDeal_ = sponsorFeeDeal.a;
            return $author$project$Api$Provider$SponsorFeeDeal$Shared$amountInCents(sponsorFeeDeal_);
        } else {
            var sponsorFeeDeal_ = sponsorFeeDeal.a;
            return $author$project$Api$Employer$SponsorFeeDeal$Shared$amountInCents(sponsorFeeDeal_);
        }
    };
    var $author$project$Api$SponsorFeeDeal$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$SponsorFeeDeal$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal = function(_v0) {
        var record = _v0;
        return record._S;
    };
    var $author$project$Api$Employer$Plan$All$sponsorFeeDeal = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(shared);
    };
    var $author$project$Api$Employer$Plan$One$sponsorFeeDeal = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(shared);
    };
    var $author$project$Api$Provider$Plan$All$sponsorFeeDeal = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$sponsorFeeDeal = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(shared);
    };
    var $author$project$Api$Plan$sponsorFeeDeal = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$SponsorFeeDeal$Shared$Provider, $author$project$Api$Provider$Plan$Shared$sponsorFeeDeal(plan_));
            case 1:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$SponsorFeeDeal$Shared$Provider, $author$project$Api$Provider$Plan$SharedWithContractInfo$sponsorFeeDeal(plan_));
            case 4:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$SponsorFeeDeal$Shared$Employer, $author$project$Api$Employer$Plan$Shared$sponsorFeeDeal(plan_));
            case 2:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$SponsorFeeDeal$Shared$Provider, $author$project$Api$Provider$Plan$All$sponsorFeeDeal(plan_));
            case 6:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$SponsorFeeDeal$Shared$Employer, $author$project$Api$Employer$Plan$All$sponsorFeeDeal(plan_));
            case 3:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$SponsorFeeDeal$Shared$Provider, $author$project$Api$Provider$Plan$One$sponsorFeeDeal(plan_));
            default:
                var plan_ = plan.a;
                return A2($elm$core$Maybe$map, $author$project$Api$SponsorFeeDeal$Shared$Employer, $author$project$Api$Employer$Plan$One$sponsorFeeDeal(plan_));
        }
    };
    var $author$project$Components$Plan$Summary$SponsorFeeDeal$view = F2(function(companyPricing, plan) {
        var fixedFee = A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Fixed Fee')
            ]))
        ]));
        return _List_fromArray([
            companyPricing ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(5)
                ]), _List_fromArray([
                    fixedFee
                ]))
            ])) : fixedFee,
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$SponsorFeeDeal$Shared$amountInCents, $author$project$Utils$Currency$fromInt), $author$project$Api$Plan$sponsorFeeDeal(plan))))
            ]))
        ]);
    });
    var $author$project$Formatters$Int$ageRangeMonths = F2(function(fromAge, toAge) {
        if (_Utils_eq($elm$core$Maybe$Just(fromAge), toAge)) return !fromAge ? 'First month' : $elm$core$String$fromInt(fromAge) + ' months';
        else {
            if (!fromAge && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) return 'All ages';
            else {
                var ageRange_ = !fromAge ? 'Birth' : fromAge === 1 && _Utils_eq(toAge, $elm$core$Maybe$Nothing) ? $elm$core$String$fromInt(fromAge) + ' month' : $elm$core$String$fromInt(fromAge) + ' months';
                if (!toAge.$) {
                    var toAge_ = toAge.a;
                    return ageRange_ + (' to ' + ($elm$core$String$fromInt(toAge_) + ' months'));
                } else return ageRange_ + ' and up';
            }
        }
    });
    var $author$project$Formatters$Int$ageRangeYears = F2(function(fromAge, toAge) {
        if (_Utils_eq($elm$core$Maybe$Just(fromAge), toAge)) return !fromAge ? 'First year' : 'Age ' + $elm$core$String$fromInt(fromAge);
        else {
            if (!fromAge && _Utils_eq(toAge, $elm$core$Maybe$Nothing)) return 'All ages';
            else {
                var ageRange_ = !fromAge ? 'Birth' : fromAge === 1 && _Utils_eq(toAge, $elm$core$Maybe$Nothing) ? 'Age ' + $elm$core$String$fromInt(fromAge) : 'Ages ' + $elm$core$String$fromInt(fromAge);
                if (!toAge.$) {
                    var toAge_ = toAge.a;
                    return ageRange_ + (' to ' + $elm$core$String$fromInt(toAge_));
                } else return ageRange_ + ' and up';
            }
        }
    });
    var $author$project$Formatters$Int$ageRange = F3(function(fromAge, toAge, unit) {
        if (!unit) return A2($author$project$Formatters$Int$ageRangeYears, fromAge, toAge);
        else return A2($author$project$Formatters$Int$ageRangeMonths, fromAge, toAge);
    });
    var $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes = function(_v0) {
        var record = _v0;
        return record.Ef;
    };
    var $author$project$Api$Employer$Plan$All$allowedBillingPeriodCodes = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(shared);
    };
    var $author$project$Api$Employer$Plan$One$allowedBillingPeriodCodes = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes = function(_v0) {
        var record = _v0;
        return record.Ef;
    };
    var $author$project$Api$Provider$Plan$All$allowedBillingPeriodCodes = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
    };
    var $author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$allowedBillingPeriodCodes = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(shared);
    };
    var $author$project$Api$Plan$allowedBillingPeriodCodes = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$allowedBillingPeriodCodes(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$allowedBillingPeriodCodes(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$allowedBillingPeriodCodes(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$allowedBillingPeriodCodes(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$allowedBillingPeriodCodes(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$allowedBillingPeriodCodes(plan_);
        }
    };
    var $author$project$Api$Employer$RateRule$Shared$annualAmountInCents = function(_v0) {
        var record = _v0;
        return record.Jk;
    };
    var $author$project$Api$RateRule$Shared$annualAmountInCents = function(rateRule) {
        if (!rateRule.$) {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Provider$RateRule$Shared$annualAmountInCents(rateRule_);
        } else {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Employer$RateRule$Shared$annualAmountInCents(rateRule_);
        }
    };
    var $author$project$Api$Employer$RateRule$Shared$monthAmountInCents = function(_v0) {
        var record = _v0;
        return record.Uu;
    };
    var $author$project$Api$RateRule$Shared$monthAmountInCents = function(rateRule) {
        if (!rateRule.$) {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Provider$RateRule$Shared$monthAmountInCents(rateRule_);
        } else {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Employer$RateRule$Shared$monthAmountInCents(rateRule_);
        }
    };
    var $author$project$Api$Employer$RateRule$Shared$quarterAmountInCents = function(_v0) {
        var record = _v0;
        return record.XU;
    };
    var $author$project$Api$RateRule$Shared$quarterAmountInCents = function(rateRule) {
        if (!rateRule.$) {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Provider$RateRule$Shared$quarterAmountInCents(rateRule_);
        } else {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Employer$RateRule$Shared$quarterAmountInCents(rateRule_);
        }
    };
    var $author$project$Api$Employer$RateRule$Shared$semiAnnualAmountInCents = function(_v0) {
        var record = _v0;
        return record.ZH;
    };
    var $author$project$Api$RateRule$Shared$semiAnnualAmountInCents = function(rateRule) {
        if (!rateRule.$) {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Provider$RateRule$Shared$semiAnnualAmountInCents(rateRule_);
        } else {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Employer$RateRule$Shared$semiAnnualAmountInCents(rateRule_);
        }
    };
    var $author$project$Components$Plan$Summary$Pricing$amountForPeriodCode = F2(function(ageRateRule, code) {
        return A2($elm$core$Maybe$withDefault, 0, function() {
            switch(code){
                case 'month':
                    return $author$project$Api$RateRule$Shared$monthAmountInCents(ageRateRule);
                case 'quarter':
                    return $author$project$Api$RateRule$Shared$quarterAmountInCents(ageRateRule);
                case 'semi_annual':
                    return $author$project$Api$RateRule$Shared$semiAnnualAmountInCents(ageRateRule);
                case 'annual':
                    return $author$project$Api$RateRule$Shared$annualAmountInCents(ageRateRule);
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }());
    });
    var $author$project$Api$Period$code = function(_v0) {
        var period = _v0;
        return period.Lk;
    };
    var $author$project$Api$Employer$RateRule$Shared$fromAge = function(_v0) {
        var record = _v0;
        return record.P_;
    };
    var $author$project$Api$RateRule$Shared$fromAge = function(rateRule) {
        if (!rateRule.$) {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Provider$RateRule$Shared$fromAge(rateRule_);
        } else {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Employer$RateRule$Shared$fromAge(rateRule_);
        }
    };
    var $author$project$Api$Employer$Plan$Shared$period = function(_v0) {
        var record = _v0;
        return $author$project$Api$Period$retrieve(record.Nx);
    };
    var $author$project$Api$Employer$Plan$All$period = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$period(shared);
    };
    var $author$project$Api$Employer$Plan$One$period = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$period(shared);
    };
    var $author$project$Api$Provider$Plan$All$period = function(_v0) {
        var record = _v0.b;
        return $author$project$Api$Period$retrieve(record.Nx);
    };
    var $author$project$Api$Provider$Plan$One$period = function(_v0) {
        var record = _v0.b;
        return $author$project$Api$Period$retrieve(record.Nx);
    };
    var $author$project$Api$Plan$period = function(plan) {
        switch(plan.$){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$period(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$period(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$period(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$period(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$period(plan_);
        }
    };
    var $author$project$Api$Employer$RateRule$Shared$toAge = function(_v0) {
        var record = _v0;
        return record.$4;
    };
    var $author$project$Api$RateRule$Shared$toAge = function(rateRule) {
        if (!rateRule.$) {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Provider$RateRule$Shared$toAge(rateRule_);
        } else {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Employer$RateRule$Shared$toAge(rateRule_);
        }
    };
    var $author$project$Api$Employer$RateRule$Shared$unit = function(_v0) {
        var record = _v0;
        return record.aaG;
    };
    var $author$project$Api$RateRule$Shared$unit = function(rateRule) {
        if (!rateRule.$) {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Provider$RateRule$Shared$unit(rateRule_);
        } else {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Employer$RateRule$Shared$unit(rateRule_);
        }
    };
    var $author$project$Components$Plan$Summary$Pricing$viewAgeRateRule = F2(function(plan, ageRateRule) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(8)
            ]), _List_fromArray([
                $elm$html$Html$text(A3($author$project$Formatters$Int$ageRange, $author$project$Api$RateRule$Shared$fromAge(ageRateRule), $author$project$Api$RateRule$Shared$toAge(ageRateRule), $author$project$Api$RateRule$Shared$unit(ageRateRule)))
            ])),
            function() {
                var _v0 = _Utils_Tuple2($author$project$Api$Plan$period(plan), $elm$core$List$head($author$project$Api$Plan$allowedBillingPeriodCodes(plan)));
                if (!_v0.a.$) {
                    var period = _v0.a.a;
                    var amountInCents = A2($author$project$Components$Plan$Summary$Pricing$amountForPeriodCode, ageRateRule, $author$project$Api$Period$code(period));
                    return A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('numeric')
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(amountInCents))
                        ]))
                    ]));
                } else if (!_v0.b.$) {
                    var _v1 = _v0.a;
                    var allowedBillingPeriodCode = _v0.b.a;
                    var amountInCents = A2($author$project$Components$Plan$Summary$Pricing$amountForPeriodCode, ageRateRule, allowedBillingPeriodCode);
                    return A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('numeric')
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(amountInCents))
                        ]))
                    ]));
                } else {
                    var _v2 = _v0.a;
                    var _v3 = _v0.b;
                    return $author$project$Ui$Grid$none;
                }
            }()
        ]));
    });
    var $author$project$Api$Employer$RateRule$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$RateRule$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$RateRule$Shared$type_ = function(rateRule) {
        if (!rateRule.$) {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Provider$RateRule$Shared$type_(rateRule_);
        } else {
            var rateRule_ = rateRule.a;
            return $author$project$Api$Employer$RateRule$Shared$type_(rateRule_);
        }
    };
    var $author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule = F2(function(retailPlan, rateRule) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(8)
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$RateRule$groupTierName, A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$type_, rateRule)))),
                $author$project$Utils$Html$noBreakSpace,
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('text-label-md text-muted')
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$RateRule$groupTierCode(retailPlan), A2($elm$core$Maybe$map, $author$project$Api$RateRule$Shared$type_, rateRule))))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4)
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('numeric')
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Api$RateRule$Shared$monthAmountInCents, rateRule))))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Plan$Summary$Pricing$viewRegistrationFee = F2(function(individualRegistrationFeeInCents, maxRegistrationFeeInCents) {
        var hasMaxRegistrationFeeInCents = $author$project$Utils$Maybe$toBool(maxRegistrationFeeInCents);
        var hasIndividualRegistrationFeeInCents = $author$project$Utils$Maybe$toBool(individualRegistrationFeeInCents);
        return hasIndividualRegistrationFeeInCents || hasMaxRegistrationFeeInCents ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Registration Fees: '),
            function() {
                if (!individualRegistrationFeeInCents.$) {
                    var individualRegistrationFeeInCents_ = individualRegistrationFeeInCents.a;
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(individualRegistrationFeeInCents_)),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text(' per individual')
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            hasIndividualRegistrationFeeInCents && hasMaxRegistrationFeeInCents ? $elm$html$Html$text(' or ') : $author$project$Utils$Html$empty,
            function() {
                if (!maxRegistrationFeeInCents.$) {
                    var maxRegistrationFeeInCents_ = maxRegistrationFeeInCents.a;
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(maxRegistrationFeeInCents_)),
                        $elm$html$Html$text(' Max')
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Plan$Summary$Pricing$view = F3(function(plan, practice, company) {
        var _v0 = $author$project$Api$Plan$planType(plan);
        switch(_v0){
            case 4:
                return A2($elm$html$Html$div, _List_Nil, $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Percentage Retainer Pricing')
                            ]))
                        ]))
                    ]),
                    $author$project$Components$Plan$Summary$Percentage$view(plan)
                ])));
            case 1:
                return A2($elm$html$Html$div, _List_Nil, A2($author$project$Components$Plan$Summary$SponsorFeeDeal$view, false, plan));
            default:
                var showbillAffiliateRateText = A2($author$project$Components$Plan$Summary$Pricing$billAffiliateRate, practice, company);
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    function() {
                        if ($author$project$Api$Plan$groupPricingType(plan) !== 'fixed_pricing') {
                            var ageRateRules = $author$project$Api$Plan$ageRateRules(plan);
                            return A2($author$project$Ui$Typography$p, _List_Nil, $elm$core$List$concat(_List_fromArray([
                                _List_fromArray([
                                    $elm$core$List$length(ageRateRules) > 1 ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Grid$column, _List_fromArray([
                                            $author$project$Ui$Grid$span(8)
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Period$rateName, $author$project$Formatters$String$titleize), $elm$core$List$head($author$project$Api$Plan$periods(plan))))),
                                                $elm$html$Html$text(' Age Based Pricing')
                                            ]))
                                        ])),
                                        showbillAffiliateRateText ? A2($author$project$Ui$Grid$column, _List_fromArray([
                                            $author$project$Ui$Grid$span(4)
                                        ]), _List_fromArray([
                                            A2($elm$html$Html$div, _List_fromArray([
                                                $elm$html$Html$Attributes$class('numeric')
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Will be billed the affiliate rate')
                                            ]))
                                        ])) : A2($author$project$Ui$Grid$column, _List_fromArray([
                                            $author$project$Ui$Grid$span(4)
                                        ]), _List_Nil)
                                    ])) : $elm$core$List$length(ageRateRules) === 1 ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Grid$column, _List_fromArray([
                                            $author$project$Ui$Grid$span(8)
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text('Individual Pricing')
                                            ]))
                                        ])),
                                        showbillAffiliateRateText ? A2($author$project$Ui$Grid$column, _List_fromArray([
                                            $author$project$Ui$Grid$span(4)
                                        ]), _List_fromArray([
                                            A2($elm$html$Html$div, _List_fromArray([
                                                $elm$html$Html$Attributes$class('numeric')
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Will be billed the affiliate rate')
                                            ]))
                                        ])) : A2($author$project$Ui$Grid$column, _List_fromArray([
                                            $author$project$Ui$Grid$span(4)
                                        ]), _List_Nil)
                                    ])) : $author$project$Utils$Html$empty
                                ]),
                                !showbillAffiliateRateText ? A2($elm$core$List$map, $author$project$Components$Plan$Summary$Pricing$viewAgeRateRule(plan), ageRateRules) : _List_Nil
                            ])));
                        } else return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(8)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Group Tier Pricing')
                                    ]))
                                ])),
                                showbillAffiliateRateText ? A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(4)
                                ]), _List_fromArray([
                                    A2($elm$html$Html$div, _List_fromArray([
                                        $elm$html$Html$Attributes$class('numeric')
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Will be billed the affiliate rate')
                                    ]))
                                ])) : A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(4)
                                ]), _List_Nil)
                            ])),
                            function() {
                                if (showbillAffiliateRateText) return $author$project$Utils$Html$empty;
                                else {
                                    var retailPlan = $author$project$Api$Plan$planType(plan) === 2;
                                    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                        A2($author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule, retailPlan, $author$project$Api$Plan$individualRateRule(plan)),
                                        A2($author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule, retailPlan, $author$project$Api$Plan$coupleRateRule(plan)),
                                        $author$project$Api$Plan$singleParentWithSingleChildRateRuleEnabled(plan) ? A2($author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule, retailPlan, $author$project$Api$Plan$singleParentWithSingleChildRateRule(plan)) : $author$project$Utils$Html$empty,
                                        A2($author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule, retailPlan, $author$project$Api$Plan$singleParentRateRule(plan)),
                                        $author$project$Api$Plan$familyWithSingleChildRateRuleEnabled(plan) ? A2($author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule, retailPlan, $author$project$Api$Plan$familyWithSingleChildRateRule(plan)) : $author$project$Utils$Html$empty,
                                        A2($author$project$Components$Plan$Summary$Pricing$viewGroupTierPricingRule, retailPlan, $author$project$Api$Plan$familyRateRule(plan))
                                    ]));
                                }
                            }()
                        ]));
                    }(),
                    $author$project$Api$Plan$hasDiscountRules(plan) && $author$project$Api$Plan$groupPricingType(plan) === 'family' ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Family Discounts Available')
                    ])) : $author$project$Utils$Html$empty,
                    $author$project$Api$Plan$hasDiscountRules(plan) && $author$project$Api$Plan$groupPricingType(plan) === 'group' ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Group Discounts Available')
                    ])) : $author$project$Utils$Html$empty,
                    $author$project$Api$Plan$hasSpecialRates(plan) ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Special Rates Available')
                    ])) : $author$project$Utils$Html$empty,
                    A2($author$project$Components$Plan$Summary$Pricing$viewRegistrationFee, $author$project$Api$Plan$individualRegistrationFeeInCents(plan), $author$project$Api$Plan$maxRegistrationFeeInCents(plan))
                ]));
        }
    });
    var $author$project$Api$Provider$Plan$All$activeCompaniesCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$activeCompaniesCount(shared);
    };
    var $author$project$Api$Provider$Plan$All$activeMembershipPatientsCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$activeMembershipPatientsCount(shared);
    };
    var $author$project$Ui$Typography$Badge = {
        $: 11
    };
    var $author$project$Ui$Typography$badge = $author$project$Ui$Typography$Badge;
    var $author$project$Components$Admin$Plans$List$viewBadge = function(plan) {
        var _v0 = function() {
            var _v1 = $author$project$Api$Provider$Plan$All$planType(plan);
            switch(_v1){
                case 2:
                    return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Api$Provider$Plan$All$activeMembershipPatientsCount(plan)), 'Active patients on this plan');
                case 0:
                    return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Api$Provider$Plan$All$activeCompaniesCount(plan)), 'Active companies on this plan');
                default:
                    return _Utils_Tuple2($elm$core$Maybe$Nothing, '');
            }
        }();
        var count = _v0.a;
        var tooltip = _v0.b;
        if (!count.$) {
            var count_ = count.a;
            return A3($author$project$Ui$Tooltip$view, _List_Nil, tooltip, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$badge
                ]), _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(count_))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Link$Disabled = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Link$disabled = $author$project$Ui$Link$Disabled;
    var $author$project$Api$Provider$Plan$Shared$isAffiliate = function(_v0) {
        return false;
    };
    var $author$project$Api$Provider$Plan$All$isAffiliate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$isAffiliate(shared);
    };
    var $author$project$Components$Admin$Plans$List$viewEditLink = F2(function(model, plan) {
        var disableEdit = $author$project$Api$Provider$Plan$All$isAffiliate(plan) && !model.DT;
        var editLink = A3($author$project$Ui$Link$route, model.Fj({
            aef: $author$project$Api$Provider$Plan$All$id(plan)
        }), _List_fromArray([
            $author$project$Ui$Link$buttonDefault,
            $author$project$Ui$Link$disabled(disableEdit)
        ]), _List_fromArray([
            $elm$html$Html$text('View / Edit')
        ]));
        return disableEdit ? A3($author$project$Ui$Tooltip$view, _List_Nil, 'Contact us to change this plan', _List_fromArray([
            editLink
        ])) : editLink;
    });
    var $author$project$Components$Admin$Plans$List$viewPlanSummary = F2(function(model, plan) {
        var name_ = $author$project$Api$Provider$Plan$All$name(plan);
        var maxLength = $author$project$Api$Provider$Plan$All$default(plan) ? 32 : 40;
        var name = _Utils_cmp($elm$core$String$length(name_), maxLength) > 0 ? A3($author$project$Ui$Tooltip$view, _List_Nil, name_, _List_fromArray([
            $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, maxLength, name_))
        ])) : $elm$html$Html$text(name_);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2,
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        name
                    ])),
                    $author$project$Components$Admin$Plans$List$viewBadge(plan)
                ])),
                $author$project$Api$Provider$Plan$All$default(plan) ? A2($author$project$Ui$Badge$view, _List_fromArray([
                    $author$project$Ui$Badge$primary
                ]), _List_fromArray([
                    $elm$html$Html$text('Default')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Can bill '),
                        $elm$html$Html$text($author$project$Formatters$String$toSentence(A2($elm$core$List$map, $author$project$Api$Period$billName, $author$project$Api$Provider$Plan$All$periods(plan))))
                    ])),
                    A3($author$project$Components$Plan$Summary$Pricing$view, $author$project$Api$Plan$ProviderAll(plan), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
                    model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A2($author$project$Components$Admin$Plans$List$viewEditLink, model, plan)
                    ])),
                    $author$project$Ui$Clearfix$view,
                    $author$project$Api$Provider$Plan$All$default(plan) ? A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text('This is your default for new memberships and online signup')
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Plans$List$viewPlan = F2(function(model, plan) {
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(6)
        ]), _List_fromArray([
            A2($author$project$Components$Admin$Plans$List$viewPlanSummary, model, plan)
        ]));
    });
    var $author$project$Components$Admin$Plans$List$view = function(model) {
        return A2($author$project$Ui$Panel$view, model.aK ? _List_fromArray([
            $author$project$Ui$Panel$onlyBorderLeft
        ]) : _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Membership pricing plans')
                    ])),
                    model.aK ? $author$project$Utils$Html$empty : A3($author$project$Ui$Link$route, model.Gs, _List_fromArray([
                        $author$project$Ui$Link$buttonDefault,
                        $author$project$Ui$Link$pull(1),
                        $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('New Plan')
                    ]))
                ])),
                $elm$core$List$isEmpty(model.QF) ? $author$project$Utils$Html$empty : A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), model.QF)),
                model.aK ? $author$project$Utils$Html$empty : $author$project$Components$Admin$Plans$List$viewAllowMultipleRetailMembershipsSetting(model),
                model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mt2
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Admin$Plans$List$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, function() {
                    var _v0 = model.WO;
                    if (_v0.$ === 3) {
                        var plans = _v0.a;
                        return A2($elm$core$List$map, $author$project$Components$Admin$Plans$List$viewPlan(model), plans);
                    } else return A2($elm$core$List$repeat, 10, A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$span(4)
                            ])),
                            $author$project$Ui$Skeleton$card(_List_Nil)
                        ]))
                    ])));
                }())
            ])),
            model.aK ? A2($author$project$Ui$Panel$footer, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Add another plan'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Plans$List$AddAnother)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Another')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Go to next step'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Plans$List$NextStep)
                ]), _List_fromArray([
                    $elm$html$Html$text('Next')
                ]))
            ])) : A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Admin$Plans$List$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.WO))
                ]), model.af_))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$CompanyPlans$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$Plans$List$view(model.rk))
            ]),
            $2: 'Admin | Sponsor Plans'
        };
    };
    var $author$project$Pages$Admin$CompanyPlans$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CompanyPlans$Top$init,
        aeR: $author$project$Pages$Admin$CompanyPlans$Top$load,
        ag3: $author$project$Pages$Admin$CompanyPlans$Top$save,
        ahE: $author$project$Pages$Admin$CompanyPlans$Top$subscriptions,
        aaO: $author$project$Pages$Admin$CompanyPlans$Top$update,
        aid: $author$project$Pages$Admin$CompanyPlans$Top$view
    });
    var $author$project$Pages$Admin$Coupons$ArchivedDropdownMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $elm_community$string_extra$String$Extra$replaceSlice = F4(function(substitution, start, end, string) {
        return _Utils_ap(A3($elm$core$String$slice, 0, start, string), _Utils_ap(substitution, A3($elm$core$String$slice, end, $elm$core$String$length(string), string)));
    });
    var $author$project$Utils$Url$addParams = F2(function(url, qparams) {
        var urlDoesNotHaveQueryParams = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $elm$core$String$isEmpty, A2($elm$core$Maybe$andThen, function($) {
            return $.Bz;
        }, $elm$url$Url$fromString(url))));
        var querySeparator = urlDoesNotHaveQueryParams ? '?' : '&';
        var queryString = A4($elm_community$string_extra$String$Extra$replaceSlice, querySeparator, 0, 1, $elm$url$Url$Builder$toQuery(qparams));
        return _Utils_ap(url, queryString);
    });
    var $author$project$Pages$Admin$Coupons$buildCouponUrl = F2(function(memberPortalSignupUrl, code) {
        return A2($author$project$Utils$Url$addParams, memberPortalSignupUrl, _List_fromArray([
            A2($elm$url$Url$Builder$string, 'coupon', code)
        ]));
    });
    var $author$project$Pages$Admin$Coupons$GotCoupons = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Coupon$couponsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'coupons'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Coupon$All$Coupon = $elm$core$Basics$identity;
    var $author$project$Api$Common$Coupon$Shared$Coupon = $elm$core$Basics$identity;
    var $author$project$Api$Common$Coupon$Shared$Record = function(id) {
        return function(code) {
            return function(description) {
                return function(percentOff) {
                    return function(amountOffInCents) {
                        return function(applyToEachPatient) {
                            return function(createdAt) {
                                return function(isRedeemable) {
                                    return function(redeemableFrom) {
                                        return function(redeemableUntil) {
                                            return function(durationInMonths) {
                                                return function(isArchived) {
                                                    return {
                                                        Ji: amountOffInCents,
                                                        JA: applyToEachPatient,
                                                        Lk: code,
                                                        Mx: createdAt,
                                                        NQ: description,
                                                        On: durationInMonths,
                                                        aef: id,
                                                        RR: isArchived,
                                                        Sm: isRedeemable,
                                                        Wz: percentOff,
                                                        Ym: redeemableFrom,
                                                        Yn: redeemableUntil
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Common$Coupon$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_archived', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'duration_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redeemable_until', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redeemable_from', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_redeemable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'apply_to_each_patient', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_off_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'percent_off', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'code', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Coupon$Shared$Record)))))))))))));
    var $author$project$Api$Common$Coupon$Shared$decode = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Coupon$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Coupon$All$decode = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Coupon$Shared$decode, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Coupon$listDefaults = {
        JC: $elm$core$Maybe$Nothing,
        Fw: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        Hc: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'code', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Provider$Coupon$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Coupon$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.JC;
                if (!_v0.$) {
                    var bool = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'archived', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Hc;
                if (!_v1.$) {
                    var bool = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'redeemable', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.agq;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Provider$Coupon$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Coupon$All$decode), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Coupon$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponsPath)));
    });
    var $author$project$Pages$Admin$Coupons$fetchCoupons = function(model) {
        return A3($author$project$Api$Provider$Coupon$list, model.Ej, function(d) {
            return _Utils_update(d, {
                JC: $elm$core$Maybe$Just(model.JC)
            });
        }, $author$project$Pages$Admin$Coupons$GotCoupons);
    };
    var $author$project$Utils$Bool$fromString = function(string) {
        switch(string){
            case 'true':
                return $elm$core$Maybe$Just(true);
            case 'false':
                return $elm$core$Maybe$Just(false);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$Practice$One$memberPortalSignupUrl = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.TW;
    });
    var $author$project$Pages$Admin$Coupons$init = F4(function(_v0, practice, shared, _v1) {
        var query = _v1.Bz;
        var archived = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$andThen, $author$project$Utils$Bool$fromString, A2($elm$core$Dict$get, 'archived', query)));
        var model = {
            Ej: shared.Ej,
            JC: archived,
            k2: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'archived-dropdown-filter',
                ahX: $author$project$Pages$Admin$Coupons$ArchivedDropdownMsg
            })),
            hz: $elm$core$Maybe$Nothing,
            aX: $elm$core$Set$empty,
            Mj: $elm$core$Maybe$Nothing,
            EX: $author$project$Pages$Admin$Coupons$buildCouponUrl($author$project$Api$Provider$Practice$One$memberPortalSignupUrl(practice)),
            wY: $author$project$Api$Data$Loading,
            cP: shared.cP
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$Coupons$fetchCoupons(model));
    });
    var $author$project$Pages$Admin$Coupons$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Coupons$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Coupons$CancelEdit = {
        $: 3
    };
    var $author$project$Pages$Admin$Coupons$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Coupons$subscriptions = function(_v0) {
        var coupon = _v0.Mj;
        var archivingCoupon = _v0.hz;
        var archivedDropdown = _v0.k2;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Coupons$CancelEdit)), coupon)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Coupons$HiConfirmClosed), archivingCoupon)),
            $author$project$Ui$Dropdown$subscriptions(archivedDropdown)
        ]));
    };
    var $author$project$Pages$Admin$Coupons$Archived = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Coupons$GotCoupon = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$RedeemableFrom = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Coupons$RedeemableUntil = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Coupons$Unarchived = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Coupon$couponPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Coupon$couponsPath);
    };
    var $author$project$Api$Provider$Coupon$couponArchivePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'archive'
        ]), $author$project$Api$Provider$Coupon$couponPath(id_));
    };
    var $author$project$Api$Provider$Coupon$One$Coupon = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Coupon$One$Record = function(meta) {
        return {
            Ue: meta
        };
    };
    var $author$project$Api$Provider$Coupon$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Coupon$Meta$MetaRecord = F5(function(code, percentOff, durationInMonths, redeemableFrom, redeemableUntil) {
        return {
            Lk: code,
            On: durationInMonths,
            Wz: percentOff,
            Ym: redeemableFrom,
            Yn: redeemableUntil
        };
    });
    var $author$project$Api$Provider$Coupon$Meta$EditableRecord = function(editable) {
        return {
            Ot: editable
        };
    };
    var $author$project$Api$Provider$Coupon$Meta$editableRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$Meta$EditableRecord));
    var $author$project$Api$Provider$Coupon$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redeemable_until', $author$project$Api$Provider$Coupon$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redeemable_from', $author$project$Api$Provider$Coupon$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'duration_in_months', $author$project$Api$Provider$Coupon$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'percent_off', $author$project$Api$Provider$Coupon$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'code', $author$project$Api$Provider$Coupon$Meta$editableRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$Meta$MetaRecord))))));
    var $author$project$Api$Provider$Coupon$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Coupon$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Coupon$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Coupon$Meta$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$One$Record));
    var $author$project$Api$Provider$Coupon$One$decode = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Coupon$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Coupon$Shared$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Coupon$One$Coupon)));
    var $author$project$Api$Provider$Coupon$archive = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Coupon$One$decode, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponArchivePath(id_)));
    });
    var $author$project$Api$Common$Coupon$Shared$amountOffInCents = function(_v0) {
        var record = _v0;
        return record.Ji;
    };
    var $author$project$Api$Provider$Coupon$One$amountOffInCents = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$amountOffInCents(common);
    };
    var $author$project$Api$Common$Coupon$Shared$applyToEachPatient = function(_v0) {
        var record = _v0;
        return record.JA;
    };
    var $author$project$Api$Provider$Coupon$One$applyToEachPatient = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$applyToEachPatient(common);
    };
    var $author$project$Api$Common$Coupon$Shared$code = function(_v0) {
        var record = _v0;
        return record.Lk;
    };
    var $author$project$Api$Provider$Coupon$One$code = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$code(common);
    };
    var $author$project$Api$Common$Coupon$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$Coupon$One$description = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$description(common);
    };
    var $author$project$Api$Common$Coupon$Shared$durationInMonths = function(_v0) {
        var record = _v0;
        return record.On;
    };
    var $author$project$Api$Provider$Coupon$One$durationInMonths = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$durationInMonths(common);
    };
    var $author$project$Api$Common$Coupon$Shared$percentOff = function(_v0) {
        var record = _v0;
        return record.Wz;
    };
    var $author$project$Api$Provider$Coupon$One$percentOff = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$percentOff(common);
    };
    var $author$project$Api$Common$Coupon$Shared$redeemableFrom = function(_v0) {
        var record = _v0;
        return record.Ym;
    };
    var $author$project$Api$Provider$Coupon$One$redeemableFrom = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$redeemableFrom(common);
    };
    var $author$project$Api$Common$Coupon$Shared$redeemableUntil = function(_v0) {
        var record = _v0;
        return record.Yn;
    };
    var $author$project$Api$Provider$Coupon$One$redeemableUntil = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$redeemableUntil(common);
    };
    var $author$project$Pages$Admin$Coupons$formFieldsFromCoupon = function(coupon) {
        var _v0 = $author$project$Components$DateInput$init;
        var redeemableUntilDateInput = _v0.a;
        var redeemableUntilDateInputCmd = _v0.b;
        var _v1 = $author$project$Components$DateInput$init;
        var redeemableFromDateInput = _v1.a;
        var redeemableFromDateInputCmd = _v1.b;
        return _Utils_Tuple2({
            Ji: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$Coupon$One$amountOffInCents(coupon)),
            JA: $author$project$Api$Provider$Coupon$One$applyToEachPatient(coupon),
            Lk: $author$project$Api$Provider$Coupon$One$code(coupon),
            NQ: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Coupon$One$description(coupon)),
            On: $author$project$Api$Provider$Coupon$One$durationInMonths(coupon),
            Wz: A2($elm$core$Maybe$map, $author$project$Percentage$fromFloat, $author$project$Api$Provider$Coupon$One$percentOff(coupon)),
            Ym: $elm$core$Maybe$Just($author$project$Api$Provider$Coupon$One$redeemableFrom(coupon)),
            nS: redeemableFromDateInput,
            Yn: $author$project$Api$Provider$Coupon$One$redeemableUntil(coupon),
            nT: redeemableUntilDateInput
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(redeemableFromDateInput), redeemableFromDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(redeemableUntilDateInput), redeemableUntilDateInputCmd)
        ])));
    };
    var $author$project$Pages$Admin$Coupons$formFieldsInit = function(today) {
        var _v0 = $author$project$Components$DateInput$init;
        var redeemableUntilDateInput = _v0.a;
        var redeemableUntilDateInputCmd = _v0.b;
        var _v1 = $author$project$Components$DateInput$init;
        var redeemableFromDateInput = _v1.a;
        var redeemableFromDateInputCmd = _v1.b;
        return _Utils_Tuple2({
            Ji: $elm$core$Maybe$Nothing,
            JA: true,
            Lk: '',
            NQ: '',
            On: $elm$core$Maybe$Nothing,
            Wz: $elm$core$Maybe$Nothing,
            Ym: $elm$core$Maybe$Just(today),
            nS: redeemableFromDateInput,
            Yn: $elm$core$Maybe$Nothing,
            nT: redeemableUntilDateInput
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(redeemableFromDateInput), redeemableFromDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(redeemableUntilDateInput), redeemableUntilDateInputCmd)
        ])));
    };
    var $author$project$Pages$Admin$Coupons$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    Lk: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    NQ: string
                });
            case 2:
                var _float = field.a;
                return _Utils_update(fields, {
                    Wz: _float
                });
            case 3:
                var _int = field.a;
                return _Utils_update(fields, {
                    Ji: _int
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    JA: A2($elm$core$Maybe$withDefault, true, $author$project$Utils$Bool$fromString(string))
                });
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    On: $elm$core$String$toInt(string)
                });
            case 6:
                var dateInput = field.a;
                var date = field.b;
                return _Utils_update(fields, {
                    Ym: date,
                    nS: dateInput
                });
            default:
                var dateInput = field.a;
                var date = field.b;
                return _Utils_update(fields, {
                    Yn: date,
                    nT: dateInput
                });
        }
    });
    var $author$project$Pages$Admin$Coupons$RedeemableFromValidation = 2;
    var $author$project$Pages$Admin$Coupons$CodeValidation = 0;
    var $elm$regex$Regex$contains = _Regex_contains;
    var $author$project$Utils$Regex$matches = F2(function(userRegex, string) {
        var _v0 = $elm$regex$Regex$fromString(userRegex);
        if (_v0.$ === 1) return false;
        else {
            var regex = _v0.a;
            return A2($elm$regex$Regex$contains, regex, string);
        }
    });
    var $author$project$Utils$Validate$doesNotMatchRegex = F2(function(string, regex) {
        return !A2($author$project$Utils$Regex$matches, regex, string);
    });
    var $author$project$Pages$Admin$Coupons$validateCode = function(fields) {
        return $rtfeldman$elm_validate$Validate$isBlank(fields.Lk) ? _List_fromArray([
            _Utils_Tuple2(0, 'Please enter a code.')
        ]) : A2($author$project$Utils$Validate$doesNotMatchRegex, fields.Lk, '^[a-zA-Z\\d]+$') ? _List_fromArray([
            _Utils_Tuple2(0, 'Coupons can only include numbers and letters. Please remove any spaces or punctuation.')
        ]) : _List_Nil;
    };
    var $author$project$Pages$Admin$Coupons$DiscountValidation = 1;
    var $author$project$Pages$Admin$Coupons$validateDiscount = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Ji, fields.Wz);
        if (_v0.a.$ === 1 && _v0.b.$ === 1) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            return _List_fromArray([
                _Utils_Tuple2(1, 'Please enter a discount.')
            ]);
        } else return _List_Nil;
    };
    var $author$project$Pages$Admin$Coupons$RedeemableUntilValidation = 3;
    var $author$project$Pages$Admin$Coupons$validateRedeemableUntil = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Ym, fields.Yn);
        if (!_v0.a.$ && !_v0.b.$) {
            var redeemableFrom = _v0.a.a;
            var redeemableUntil = _v0.b.a;
            return A2($justinmimbs$date$Date$compare, redeemableUntil, redeemableFrom) !== 2 ? _List_fromArray([
                _Utils_Tuple2(3, 'Coupon must be active for at least one day.')
            ]) : _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Pages$Admin$Coupons$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateCode),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Ym;
        }, _Utils_Tuple2(2, 'Please enter an start date.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateDiscount),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Coupons$validateRedeemableUntil)
    ]));
    var $author$project$Api$Common$Coupon$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Coupon$All$id = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$id(common);
    };
    var $author$project$Api$Common$Coupon$Shared$isArchived = function(_v0) {
        var record = _v0;
        return record.RR;
    };
    var $author$project$Api$Provider$Coupon$All$isArchived = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$isArchived(common);
    };
    var $author$project$Api$Provider$Coupon$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Coupon$One$decode, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponPath(id_)));
    });
    var $author$project$Pages$Admin$Coupons$Created = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$apiFields = function(fields) {
        return {
            Ji: fields.Ji,
            JA: fields.JA,
            Lk: fields.Lk,
            NQ: fields.NQ,
            On: fields.On,
            Wz: A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Wz),
            Ym: fields.Ym,
            Yn: fields.Yn
        };
    };
    var $author$project$Api$Provider$Coupon$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('coupon', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('code', $elm$json$Json$Encode$string(fields.Lk)),
                _Utils_Tuple2('description', $elm$json$Json$Encode$string(fields.NQ)),
                _Utils_Tuple2('percent_off', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.Wz)),
                _Utils_Tuple2('amount_off_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Ji)),
                _Utils_Tuple2('redeemable_from', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Ym)),
                _Utils_Tuple2('redeemable_until', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Yn)),
                _Utils_Tuple2('duration_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.On)),
                _Utils_Tuple2('apply_to_each_patient', $elm$json$Json$Encode$bool(fields.JA))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Coupon$One$decode, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponsPath)));
    });
    var $author$project$Pages$Admin$Coupons$createCoupon = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Coupon$create, apiClient, $author$project$Pages$Admin$Coupons$apiFields(fields), $author$project$Pages$Admin$Coupons$Created);
    });
    var $author$project$Api$Provider$Coupon$One$id = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Coupon$Shared$id(common);
    };
    var $author$project$Pages$Admin$Coupons$Updated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Coupon$update = F4(function(apiClient, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('coupon', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('code', $elm$json$Json$Encode$string(fields.Lk)),
                _Utils_Tuple2('description', $elm$json$Json$Encode$string(fields.NQ)),
                _Utils_Tuple2('percent_off', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.Wz)),
                _Utils_Tuple2('amount_off_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Ji)),
                _Utils_Tuple2('redeemable_from', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Ym)),
                _Utils_Tuple2('redeemable_until', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Yn)),
                _Utils_Tuple2('duration_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.On)),
                _Utils_Tuple2('apply_to_each_patient', $elm$json$Json$Encode$bool(fields.JA))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Coupon$One$decode, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponPath(id_))));
    });
    var $author$project$Pages$Admin$Coupons$updateCoupon = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Coupon$update, apiClient, id, $author$project$Pages$Admin$Coupons$apiFields(fields), $author$project$Pages$Admin$Coupons$Updated);
    });
    var $author$project$Pages$Admin$Coupons$saveCoupon = F3(function(apiClient, coupon, formFields) {
        if (!coupon.$) {
            var coupon_ = coupon.a;
            return A3($author$project$Pages$Admin$Coupons$updateCoupon, apiClient, $author$project$Api$Provider$Coupon$One$id(coupon_), formFields);
        } else return A2($author$project$Pages$Admin$Coupons$createCoupon, apiClient, formFields);
    });
    var $author$project$Api$Provider$Coupon$couponUnarchivePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unarchive'
        ]), $author$project$Api$Provider$Coupon$couponPath(id_));
    };
    var $author$project$Api$Provider$Coupon$unarchive = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Coupon$One$decode, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Coupon$couponUnarchivePath(id_)));
    });
    var $author$project$Pages$Admin$Coupons$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = model.Mj;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var id = _v1.a;
            var form = _v1.b;
            var coupon = _v1.c;
            var _v2 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
            var newDateInput = _v2.a;
            var subCmd = _v2.b;
            var event = _v2.c;
            var newForm = function() {
                if (event.$ === 1) {
                    var date = event.a;
                    return A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Coupons$formFieldsUpdate, A2(field, newDateInput, date), form);
                } else {
                    var fields = $author$project$Utils$Form$fields(form);
                    return A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Coupons$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), form);
                }
            }();
            return _Utils_Tuple3(_Utils_update(model, {
                Mj: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, coupon))
            }), A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd), _List_Nil);
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Ports$Navigation$replaceUrl = _Platform_outgoingPort('replaceUrl', $elm$json$Json$Encode$string);
    var $author$project$Pages$Admin$Coupons$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$url$Url$Builder$string, 'archived', $author$project$Utils$Bool$toString(model.JC))
        ]);
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Coupons)
        ]), queryParams));
    };
    var $author$project$Pages$Admin$Coupons$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var _v1 = $author$project$Pages$Admin$Coupons$formFieldsInit(model.cP);
                var fields = _v1.a;
                var fieldsCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    Mj: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init(fields), $author$project$Api$Data$NotAsked))
                }), fieldsCmd, _List_Nil);
            case 6:
                var field = msg.a;
                var _v2 = model.Mj;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var coupon = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Coupons$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mj: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, coupon))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var form = msg.a;
                var coupon = msg.b;
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Coupons$formFieldsValidator, form);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mj: $elm$core$Maybe$Just(_Utils_Tuple3(coupon, newForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Admin$Coupons$saveCoupon, model.Ej, coupon, validFormFields), _List_Nil);
                } else {
                    var newForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mj: $elm$core$Maybe$Just(_Utils_Tuple3(coupon, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                var coupon = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$Coupon$retrieve, model.Ej, $author$project$Api$Provider$Coupon$All$id(coupon), $author$project$Pages$Admin$Coupons$GotCoupon), _List_Nil);
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var coupon = response.a;
                    var _v7 = $author$project$Pages$Admin$Coupons$formFieldsFromCoupon(coupon);
                    var fields = _v7.a;
                    var fieldsCmd = _v7.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mj: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(coupon), $author$project$Utils$Form$init(fields), $author$project$Api$Data$NotAsked))
                    }), fieldsCmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    Mj: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    wY: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var response = msg.a;
                var _v8 = model.Mj;
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var id = _v9.a;
                    var form = _v9.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        Mj: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Admin$Coupons$fetchCoupons(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Coupon successfully created')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        Mj: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                var _v11 = model.Mj;
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var id = _v12.a;
                    var form = _v12.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        Mj: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Admin$Coupons$fetchCoupons(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Coupon successfully updated')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        Mj: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            aX: A2($elm$core$Set$remove, id, model.aX),
                            wY: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$Coupons$fetchCoupons(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'The coupon was successfully archived')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            aX: A2($elm$core$Set$remove, id, model.aX)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 10:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            aX: A2($elm$core$Set$remove, id, model.aX),
                            wY: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$Coupons$fetchCoupons(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'The coupon was successfully unarchived')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            aX: A2($elm$core$Set$remove, id, model.aX)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 11:
                var coupon = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    hz: $elm$core$Maybe$Just(coupon)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var coupon = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$Coupon$All$id(coupon);
                    var cmd = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? A3($author$project$Api$Provider$Coupon$unarchive, model.Ej, id, $author$project$Pages$Admin$Coupons$Unarchived(id)) : A3($author$project$Api$Provider$Coupon$archive, model.Ej, id, $author$project$Pages$Admin$Coupons$Archived(id));
                    return _Utils_Tuple3(_Utils_update(model, {
                        hz: $elm$core$Maybe$Nothing,
                        aX: A2($elm$core$Set$insert, id, model.aX)
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    hz: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Pages$Admin$Coupons$updateDateInputFormField, model, dateInput, subMsg, $author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg, $author$project$Pages$Admin$Coupons$RedeemableFrom, function($) {
                    return $.Ym;
                });
            case 14:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Pages$Admin$Coupons$updateDateInputFormField, model, dateInput, subMsg, $author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg, $author$project$Pages$Admin$Coupons$RedeemableUntil, function($) {
                    return $.Yn;
                });
            case 15:
                var subMsg = msg.a;
                var _v16 = A2($author$project$Ui$Dropdown$update, subMsg, model.k2);
                var dropdown = _v16.a;
                var dropdownCmd = _v16.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    k2: dropdown
                }), dropdownCmd, _List_Nil);
            default:
                var archived = msg.a;
                var newModel = _Utils_update(model, {
                    JC: archived,
                    wY: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$Coupons$fetchCoupons(newModel),
                    $author$project$Pages$Admin$Coupons$updateUrl(newModel)
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Coupons$New = {
        $: 0
    };
    var $author$project$Pages$Admin$Coupons$ArchivedSelected = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$archivedDropdownOptions = function(archived) {
        return _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(!archived),
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$Coupons$ArchivedSelected(false))
            ]), $elm$html$Html$text('Current')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(archived),
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$Coupons$ArchivedSelected(true))
            ]), $elm$html$Html$text('Archived'))
        ]);
    };
    var $author$project$Pages$Admin$Coupons$viewArchivedDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(model.JC ? 'Archived' : 'Current')
        ]), $author$project$Pages$Admin$Coupons$archivedDropdownOptions(model.JC), model.k2);
    };
    var $author$project$Pages$Admin$Coupons$AmountOffInCents = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$ApplyToEachPatient = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$Code = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$Description = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$DurationInMonths = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$FormUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$PercentOff = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$Save = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Coupons$applyToEachPatientOptions = _List_fromArray([
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('true'), 'once for each patient'),
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('false'), 'once per membership')
    ]);
    var $author$project$Api$Provider$Coupon$Meta$codeEditable = function(_v0) {
        var meta = _v0;
        return meta.Lk.Ot;
    };
    var $author$project$Ui$Form$PercentageInput$Disabled = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$PercentageInput$disabled = $author$project$Ui$Form$PercentageInput$Disabled;
    var $author$project$Api$Provider$Coupon$Meta$durationInMonthsEditable = function(_v0) {
        var meta = _v0;
        return meta.On.Ot;
    };
    var $author$project$Ui$Form$Select$Inline = {
        $: 8
    };
    var $author$project$Ui$Form$Select$inline = $author$project$Ui$Form$Select$Inline;
    var $author$project$Api$Provider$Coupon$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Provider$Coupon$Meta$percentOffEditable = function(_v0) {
        var meta = _v0;
        return meta.Wz.Ot;
    };
    var $author$project$Ui$Form$PercentageInput$Placeholder = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$PercentageInput$placeholder = $author$project$Ui$Form$PercentageInput$Placeholder;
    var $author$project$Api$Provider$Coupon$Meta$redeemableFromEditable = function(_v0) {
        var meta = _v0;
        return meta.Ym.Ot;
    };
    var $author$project$Api$Provider$Coupon$Meta$redeemableUntilEditable = function(_v0) {
        var meta = _v0;
        return meta.Yn.Ot;
    };
    var $author$project$Ui$Form$PeriodInMonthsSelect$selectOptions = F2(function(noneLabel, options) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), noneLabel), A2($elm$core$List$map, function(month) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(month)), $elm$core$String$fromInt(month));
        }, options));
    });
    var $author$project$Ui$Form$PeriodInMonthsSelect$view = function(_v0) {
        var value = _v0.aa9;
        var onChange = _v0.afv;
        var noneLabel = _v0.U5;
        var options = _v0.z9;
        return $author$project$Ui$Form$Input$group(_List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, value)),
                $author$project$Ui$Form$Select$onChange(onChange)
            ]), A2($author$project$Ui$Form$PeriodInMonthsSelect$selectOptions, noneLabel, options)),
            $author$project$Ui$Form$Input$addon(_List_fromArray([
                A2($elm$core$Maybe$withDefault, 0, value) === 1 ? $elm$html$Html$text('month') : $elm$html$Html$text('months')
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Coupons$viewDiscount = F3(function(percentOff, amountOffInCents, applyToEachPatient) {
        var _v0 = _Utils_Tuple2(percentOff, amountOffInCents);
        if (!_v0.a.$) {
            var percentOff_ = _v0.a.a;
            return _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromFloat(percentOff_) + '% off')
            ]);
        } else if (!_v0.b.$) {
            var _v1 = _v0.a;
            var amountOffInCents_ = _v0.b.a;
            return _List_fromArray([
                $elm$html$Html$text($author$project$Currency$format(amountOffInCents_)),
                $elm$html$Html$text(' / '),
                applyToEachPatient ? $elm$html$Html$text('patient') : $elm$html$Html$text('membership')
            ]);
        } else {
            var _v2 = _v0.a;
            var _v3 = _v0.b;
            return _List_Nil;
        }
    });
    var $author$project$Pages$Admin$Coupons$viewDuration = function(durationInMonths) {
        if (!durationInMonths.$) {
            var durationInMonths_ = durationInMonths.a;
            return $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', durationInMonths_));
        } else return $elm$html$Html$text('unlimited');
    };
    var $author$project$Pages$Admin$Coupons$viewCouponModal = F4(function(couponUrl, coupon, saveRequest, form) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Coupon',
            Tk: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
            TR: A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$id, coupon),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$Coupons$CancelEdit,
            Vn: $elm$core$Basics$always(A2($author$project$Pages$Admin$Coupons$Save, form, coupon))
        };
        var isNew = !$author$project$Utils$Maybe$toBool(coupon);
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(isNew),
                $author$project$Ui$Form$Group$label('Coupon Code')
            ]), A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$Meta$codeEditable, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.Lk),
                    $author$project$Ui$Form$Input$placeholder('gethealthy'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$Code)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]) : _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(fields.Lk)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Description')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.NQ),
                    $author$project$Ui$Form$Input$placeholder('Marketing Campaign in Get Healthy Magazine'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$Description))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Monthly Discount'),
                $author$project$Ui$Form$Group$required(isNew)
            ]), A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$Meta$percentOffEditable, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                            $author$project$Ui$Form$PercentageInput$value(fields.Wz),
                            $author$project$Ui$Form$PercentageInput$placeholder('5.5'),
                            $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$PercentOff)),
                            $author$project$Ui$Form$PercentageInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                            $author$project$Ui$Form$PercentageInput$disabled($author$project$Utils$Maybe$toBool(fields.Ji))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(2)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('or')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                            $author$project$Ui$Form$CurrencyInput$value(fields.Ji),
                            $author$project$Ui$Form$CurrencyInput$placeholder('7.50'),
                            $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$AmountOffInCents)),
                            $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                            $author$project$Ui$Form$CurrencyInput$disabled($author$project$Utils$Maybe$toBool(fields.Wz))
                        ]))
                    ]))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form)),
                function() {
                    var _v0 = fields.Ji;
                    if (!_v0.$) return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('This coupon to apply'),
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Utils$Bool$toString(fields.JA))),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$ApplyToEachPatient)),
                            $author$project$Ui$Form$Select$inline
                        ]), $author$project$Pages$Admin$Coupons$applyToEachPatientOptions)
                    ]));
                    else return $author$project$Utils$Html$empty;
                }()
            ]) : _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, A3($author$project$Pages$Admin$Coupons$viewDiscount, A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.Wz), fields.Ji, fields.JA))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Coupon Duration')
            ]), _Utils_ap(A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$Meta$durationInMonthsEditable, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray([
                $author$project$Ui$Form$PeriodInMonthsSelect$view({
                    U5: 'Unlimited',
                    afv: A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Coupons$FormUpdated, $author$project$Pages$Admin$Coupons$DurationInMonths),
                    z9: A2($elm$core$List$range, 1, 12),
                    aa9: fields.On
                })
            ]) : _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $author$project$Pages$Admin$Coupons$viewDuration(fields.On)
                ]))
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Time period monthly discount is applied.')
                ]))
            ]))),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(isNew),
                $author$project$Ui$Form$Group$label('Start Date')
            ]), _Utils_ap(A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$Meta$redeemableFromEditable, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Coupons$RedeemableFromDateInputMsg(fields.nS), A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(fields.Ym),
                    $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                    $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                ]), fields.nS))
            ]) : _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), fields.Ym)))
                ]))
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Date coupon can first be redeemed.')
                ]))
            ]))),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('End Date')
            ]), _Utils_ap(A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$Meta$redeemableUntilEditable, A2($elm$core$Maybe$map, $author$project$Api$Provider$Coupon$One$meta, coupon))) ? _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Coupons$RedeemableUntilDateInputMsg(fields.nT), A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(fields.Yn),
                    $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                    $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
                ]), fields.nT))
            ]) : _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'none', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), fields.Yn)))
                ]))
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Last day coupon can be redeemed. Leave blank for no end date.')
                ]))
            ]))),
            $elm$core$String$length(fields.Lk) > 0 ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Signup URL')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$externalHref, couponUrl(fields.Lk), _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $elm$html$Html$text(couponUrl(fields.Lk))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Link to your Online Signup page with this coupon applied')
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Api$Common$Coupon$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Coupon$All$createdAt = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$createdAt(common);
    };
    var $author$project$Pages$Admin$Coupons$sortCoupons = function(coupons) {
        return $elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Coupon$All$createdAt, $elm$time$Time$posixToMillis), coupons));
    };
    var $author$project$Pages$Admin$Coupons$Archive = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Admin$Coupons$Edit = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Coupon$All$amountOffInCents = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$amountOffInCents(common);
    };
    var $author$project$Api$Provider$Coupon$All$applyToEachPatient = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$applyToEachPatient(common);
    };
    var $author$project$Api$Provider$Coupon$All$code = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$code(common);
    };
    var $author$project$Api$Provider$Coupon$All$durationInMonths = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$durationInMonths(common);
    };
    var $author$project$Api$Common$Coupon$Shared$isRedeemable = function(_v0) {
        var record = _v0;
        return record.Sm;
    };
    var $author$project$Api$Provider$Coupon$All$isRedeemable = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$isRedeemable(common);
    };
    var $author$project$Api$Provider$Coupon$All$percentOff = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$percentOff(common);
    };
    var $author$project$Api$Provider$Coupon$All$redeemableFrom = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$redeemableFrom(common);
    };
    var $author$project$Api$Provider$Coupon$All$redeemableUntil = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Coupon$Shared$redeemableUntil(common);
    };
    var $author$project$Pages$Admin$Coupons$viewCoupon = F2(function(archivingCoupons, coupon) {
        var status = $author$project$Api$Provider$Coupon$All$isRedeemable(coupon) ? 'redeemable' : 'not_redeemable';
        var id = $author$project$Api$Provider$Coupon$All$id(coupon);
        var loading = A2($elm$core$Set$member, id, archivingCoupons);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Coupon$All$code(coupon))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, A3($author$project$Pages$Admin$Coupons$viewDiscount, $author$project$Api$Provider$Coupon$All$percentOff(coupon), A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$Coupon$All$amountOffInCents(coupon)), $author$project$Api$Provider$Coupon$All$applyToEachPatient(coupon))),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Coupon$All$redeemableFrom(coupon)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Provider$Coupon$All$redeemableUntil(coupon);
                    if (!_v0.$) {
                        var redeemableUntil = _v0.a;
                        return $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, redeemableUntil));
                    } else return $elm$html$Html$text('none');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Pages$Admin$Coupons$viewDuration($author$project$Api$Provider$Coupon$All$durationInMonths(coupon))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, status)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit coupon'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$disabled(loading),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Coupons$Edit(coupon)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    function() {
                        var verb = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? 'Unarchive' : 'Archive';
                        return A3($author$project$Ui$Button$view, {
                            abP: verb + ' coupon'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$size(0),
                            $author$project$Ui$Button$loading(loading),
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Coupons$Archive(coupon))
                        ]), _List_fromArray([
                            $elm$html$Html$text(verb)
                        ]));
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Coupons$viewPanelTable = function(model) {
        var action = model.JC ? 'archived' : 'unarchived';
        var _v0 = function() {
            var _v1 = model.wY;
            if (_v1.$ === 3) {
                var coupons_ = _v1.a;
                return _Utils_Tuple2(false, coupons_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var coupons = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You dont have any ' + (action + ' coupons.'))
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Coupon Code')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Amount Off')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Start Date')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('End Date')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Duration')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Status')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), A2($elm$core$List$map, $author$project$Pages$Admin$Coupons$viewCoupon(model.aX), $author$project$Pages$Admin$Coupons$sortCoupons(coupons)), _List_Nil);
    };
    var $author$project$Pages$Admin$Coupons$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.Mj;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var coupon = _v1.a;
                        var form = _v1.b;
                        var saveRequest = _v1.c;
                        return A4($author$project$Pages$Admin$Coupons$viewCouponModal, model.EX, coupon, saveRequest, form);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.hz;
                    if (!_v2.$) {
                        var coupon = _v2.a;
                        var action = $author$project$Api$Provider$Coupon$All$isArchived(coupon) ? 'unarchive' : 'archive';
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Coupons$HiConfirmClosed(coupon), _List_fromArray([
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text('You\'re about to ' + (action + ' this coupon'))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Coupons')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Create new coupon'
                            }, _List_fromArray([
                                $author$project$Ui$Button$default,
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Coupons$New),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('New Coupon')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(4),
                                $author$project$Ui$Grid$spanSm(2),
                                $author$project$Ui$Grid$spanMd(3)
                            ]), _List_fromArray([
                                $author$project$Pages$Admin$Coupons$viewArchivedDropdown(model)
                            ]))
                        ]))
                    ])),
                    $author$project$Pages$Admin$Coupons$viewPanelTable(model)
                ]))
            ]),
            $2: 'Admin | Coupons'
        };
    };
    var $author$project$Pages$Admin$Coupons$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Coupons$init,
        aeR: $author$project$Pages$Admin$Coupons$load,
        ag3: $author$project$Pages$Admin$Coupons$save,
        ahE: $author$project$Pages$Admin$Coupons$subscriptions,
        aaO: $author$project$Pages$Admin$Coupons$update,
        aid: $author$project$Pages$Admin$Coupons$view
    });
    var $author$project$Pages$Admin$CoveragePlans$Id_String$CoveragePlanFormMsg = $elm$core$Basics$identity;
    var $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$CoveragePlans$Form$GotPlans = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$fetchPlans = F2(function(apiClient, model) {
        var params = function(d) {
            return _Utils_update(d, {
                Eo: $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, '', model.aef)),
                af_: model.af_,
                agq: model.r9,
                ahs: $author$project$Api$Sort$init
            });
        };
        return A3($author$project$Api$Provider$Plan$list, apiClient, params, $author$project$Components$Admin$CoveragePlans$Form$GotPlans);
    });
    var $author$project$Components$Admin$CoveragePlans$Form$formFieldsInit = {
        abD: false,
        zr: '',
        WO: _List_Nil
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm_community$list_extra$List$Extra$indexedFoldr = F3(function(func, acc, list) {
        var step = F2(function(x, _v0) {
            var i = _v0.a;
            var thisAcc = _v0.b;
            return _Utils_Tuple2(i - 1, A3(func, i, x, thisAcc));
        });
        return A3($elm$core$List$foldr, step, _Utils_Tuple2($elm$core$List$length(list) - 1, acc), list).b;
    });
    var $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$Creating = 0;
    var $author$project$Components$Admin$CoverageRules$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$Viewing = 2;
    var $author$project$Api$Provider$CoverageRule$Shared$category = function(_v0) {
        var record = _v0;
        return record.EL;
    };
    var $author$project$Api$Provider$CoverageRule$One$category = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$category(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$Patient = 0;
    var $author$project$Components$Admin$CoverageRules$Form$initFormFields = {
        Jh: $elm$core$Maybe$Nothing,
        dE: 0,
        aef: $elm$core$Maybe$Nothing,
        F6: $elm$core$Maybe$Nothing,
        rc: 'charge_category',
        af9: $elm$core$Maybe$Nothing,
        Bu: $elm$core$Maybe$Nothing,
        ag0: $elm$core$Maybe$Nothing,
        ahU: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$CoverageRule$Shared$Sponsor = 1;
    var $author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy = F2(function(patientPercentage, sponsorPercentage) {
        var _v0 = _Utils_Tuple2(patientPercentage, sponsorPercentage);
        if (!_v0.a.$ && !_v0.b.$) {
            var patientContributionPercentage_ = _v0.a.a;
            var sponsorContributionPercentage_ = _v0.b.a;
            return _Utils_cmp(patientContributionPercentage_, sponsorContributionPercentage_) > 0 ? 0 : 1;
        } else return 0;
    });
    var $author$project$Api$Provider$CoverageRule$Shared$coveredBy = function(_v0) {
        var record = _v0;
        return A2($author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy, record.af3, record.ahv);
    };
    var $author$project$Api$Provider$CoverageRule$One$coveredBy = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$coveredBy(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CoverageRule$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$id(shared);
    };
    var $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue = function(ruleTypeOption) {
        var id = ruleTypeOption.aef;
        return $elm$core$Maybe$Just(id);
    };
    var $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption = function(ruleTypeOption) {
        var includedOption = ruleTypeOption.d9;
        return includedOption;
    };
    var $author$project$Components$Admin$CoverageRules$Form$RuleType = $elm$core$Basics$identity;
    var $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions = _List_fromArray([
        {
            aef: 'included',
            d9: $elm$core$Maybe$Just(0),
            zr: 'Included at no additional cost'
        },
        {
            aef: 'included',
            d9: $elm$core$Maybe$Just(1),
            zr: 'Included if they cost less than'
        },
        {
            aef: 'discounted',
            d9: $elm$core$Maybe$Nothing,
            zr: 'Discounted'
        },
        {
            aef: 'surcharge',
            d9: $elm$core$Maybe$Nothing,
            zr: 'Surcharged'
        },
        {
            aef: 'flat_amount',
            d9: $elm$core$Maybe$Nothing,
            zr: 'Charged a flat amount'
        },
        {
            aef: 'pass_through',
            d9: $elm$core$Maybe$Nothing,
            zr: 'Passed through at cost'
        },
        {
            aef: 'limited_quantity',
            d9: $elm$core$Maybe$Nothing,
            zr: 'Limited to a quantity'
        }
    ]);
    var $author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule = function(coverageRule) {
        var timePeriod = $author$project$Api$Provider$CoverageRule$One$timePeriod(coverageRule);
        var ruleType = $elm$core$List$head(A2($elm$core$List$filter, function(option) {
            return _Utils_eq(A2($elm$core$Maybe$withDefault, '', $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(option)), $author$project$Api$Provider$CoverageRule$One$ruleType(coverageRule)) && _Utils_eq($author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption(option), $author$project$Api$Provider$CoverageRule$One$includedOption(coverageRule));
        }, $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions));
        var quantity = $author$project$Api$Provider$CoverageRule$One$quantity(coverageRule);
        var percentage = $author$project$Api$Provider$CoverageRule$One$percentage(coverageRule);
        var id = $author$project$Api$Provider$CoverageRule$One$id(coverageRule);
        var coveredBy = $author$project$Api$Provider$CoverageRule$One$coveredBy(coverageRule);
        var amountInCents = A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$CoverageRule$One$amountInCents(coverageRule));
        var _v0 = function() {
            var _v1 = $author$project$Api$Provider$CoverageRule$One$item(coverageRule);
            if (_v1.$ === 1) {
                var category_ = _v1.a;
                return _Utils_Tuple2($elm$core$Maybe$Just({
                    aef: $author$project$Api$Provider$Category$Shared$id(category_),
                    zr: $author$project$Api$Provider$Category$Shared$name(category_)
                }), 'charge_category');
            } else {
                var chargeItem = _v1.a;
                return _Utils_Tuple2($elm$core$Maybe$Just({
                    aef: $author$project$Api$Provider$ChargeItem$Shared$id(chargeItem),
                    zr: $author$project$Api$Provider$ChargeItem$Shared$name(chargeItem)
                }), 'charge_item');
            }
        }();
        var item = _v0.a;
        var itemType = _v0.b;
        return {
            Jh: amountInCents,
            dE: coveredBy,
            aef: $elm$core$Maybe$Just(id),
            F6: item,
            rc: itemType,
            af9: percentage,
            Bu: quantity,
            ag0: ruleType,
            ahU: timePeriod
        };
    };
    var $author$project$Api$Provider$CoverageRule$One$unpublishedCoveredBy = function(_v0) {
        var record = _v0.b;
        var _v1 = record.HY;
        if (!_v1.$) {
            var unpublishedRule_ = _v1.a;
            return A2($author$project$Api$Provider$CoverageRule$Shared$buildCoveredBy, $author$project$Api$Provider$CoverageRule$Shared$patientContributionPercentage(unpublishedRule_), $author$project$Api$Provider$CoverageRule$Shared$sponsorContributionPercentage(unpublishedRule_));
        } else return 0;
    };
    var $author$project$Api$Provider$CoverageRule$One$unpublishedRule = function(_v0) {
        var record = _v0.b;
        return record.HY;
    };
    var $author$project$Components$Admin$CoverageRules$Form$initUnpublishedRuleForm = function(coverageRule) {
        var coverageRuleFields = $author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule(coverageRule);
        var initForm = function(unpublishedRule) {
            var unpublishedRuleId = $author$project$Api$Provider$CoverageRule$Shared$id(unpublishedRule);
            return _Utils_eq(coverageRuleFields.aef, $elm$core$Maybe$Just(unpublishedRuleId)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Utils$Form$init(_Utils_update(coverageRuleFields, {
                Jh: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$CoverageRule$Shared$amountInCents(unpublishedRule)),
                dE: $author$project$Api$Provider$CoverageRule$One$unpublishedCoveredBy(coverageRule),
                aef: $elm$core$Maybe$Just(unpublishedRuleId),
                af9: $author$project$Api$Provider$CoverageRule$Shared$percentage(unpublishedRule)
            })));
        };
        return A2($elm$core$Maybe$andThen, initForm, $author$project$Api$Provider$CoverageRule$One$unpublishedRule(coverageRule));
    };
    var $author$project$Api$Provider$CoverageRule$Shared$isPublished = function(_v0) {
        var record = _v0;
        return record.XM;
    };
    var $author$project$Api$Provider$CoverageRule$One$isPublished = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$isPublished(shared);
    };
    var $author$project$Components$Admin$CoverageRules$Form$ruleIsUnpublished = function(coverageRule) {
        return $elm$core$Maybe$Just(!$author$project$Api$Provider$CoverageRule$One$isPublished(coverageRule));
    };
    var $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle = function(ruleTypeOption) {
        var name = ruleTypeOption.zr;
        return name;
    };
    var $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToLabel = function(ruleTypeOption) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle(ruleTypeOption))
        ]);
    };
    var $author$project$Components$Admin$CoverageRules$Form$wasCreatedWithoutPublishing = function(coverageRule) {
        return $elm$core$Maybe$Just(_Utils_eq(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(r) {
            return $author$project$Api$Provider$CoverageRule$Shared$id(r);
        }, $author$project$Api$Provider$CoverageRule$One$unpublishedRule(coverageRule))), $author$project$Api$Provider$CoverageRule$One$id(coverageRule)));
    };
    var $author$project$Components$Admin$CoverageRules$Form$init = F6(function(apiClient, session, maybeCoverageRule, coveragePlanId, _v0, coverageRuleUsage) {
        var readOnly = _v0.Ya;
        var ruleTypeSelect = $author$project$Ui$Form$SearchableSelect$init({
            aef: 'ruleType',
            ahW: $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToLabel,
            ahZ: $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptionToTitle,
            g4: $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue
        });
        var newUnpublishedRule = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$wasCreatedWithoutPublishing, maybeCoverageRule));
        var wasDeleted = !newUnpublishedRule && A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleIsUnpublished, maybeCoverageRule));
        var editMode = _Utils_eq(maybeCoverageRule, $elm$core$Maybe$Nothing) ? 0 : 2;
        var category_ = A2($elm$core$Maybe$map, function(categoryMin) {
            return {
                aef: $author$project$Api$Provider$Category$Min$id(categoryMin),
                zr: $author$project$Api$Provider$Category$Min$name(categoryMin)
            };
        }, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$CoverageRule$One$category, maybeCoverageRule));
        var _v1 = function() {
            if (!maybeCoverageRule.$) {
                var coverageRule = maybeCoverageRule.a;
                return _Utils_Tuple3($author$project$Utils$Form$init($author$project$Components$Admin$CoverageRules$Form$initFormFieldsFromRule(coverageRule)), $author$project$Components$Admin$CoverageRules$Form$initUnpublishedRuleForm(coverageRule), A2($elm$core$Task$perform, $author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected, $elm$core$Task$succeed(coverageRule)));
            } else return _Utils_Tuple3($author$project$Utils$Form$init($author$project$Components$Admin$CoverageRules$Form$initFormFields), $elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        }();
        var form = _v1.a;
        var editedForm = _v1.b;
        var resourceFilterPreSelectCmd = _v1.c;
        var _v3 = A3($author$project$Components$ResourceFilter$ChargeItem$init, apiClient, function(opts) {
            return _Utils_update(opts, {
                rc: $elm$core$Maybe$Just('item')
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Charge Item'
            });
        });
        var chargeItemResourceFilter = _v3.a;
        var chargeItemResourceFilterCmd = _v3.b;
        var _v4 = A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Category'
            });
        });
        var categoryResourceFilter = _v4.a;
        var categoryResourceFilterCmd = _v4.b;
        return _Utils_Tuple2({
            EL: category_,
            cK: categoryResourceFilter,
            cL: chargeItemResourceFilter,
            w_: coveragePlanId,
            Mo: maybeCoverageRule,
            EY: coverageRuleUsage,
            aG: wasDeleted,
            aI: editMode,
            PU: form,
            ce: newUnpublishedRule,
            Ya: readOnly,
            n5: ruleTypeSelect,
            Cd: $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions,
            Z$: session,
            L: editedForm
        }, editMode === 2 ? resourceFilterPreSelectCmd : $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            resourceFilterPreSelectCmd
        ])));
    });
    var $author$project$Api$Provider$CoverageRuleUsage$Shared$coverageRule = function(_v0) {
        var record = _v0;
        return record.Mo;
    };
    var $author$project$Api$Provider$CoverageRuleUsage$All$coverageRule = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CoverageRuleUsage$Shared$coverageRule(shared);
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$selectCoverageRuleUsage = F2(function(coverageRule, coverageRuleUsages) {
        return A2($elm$core$Maybe$andThen, function(coverageRuleUsages_) {
            return $elm$core$List$head(A2($elm$core$List$filter, function(usage) {
                return _Utils_eq($author$project$Api$Provider$CoverageRule$One$id($author$project$Api$Provider$CoverageRuleUsage$All$coverageRule(usage)), $author$project$Api$Provider$CoverageRule$One$id(coverageRule));
            }, coverageRuleUsages_));
        }, coverageRuleUsages);
    });
    var $author$project$Components$Admin$CoveragePlans$Rules$init = F6(function(apiClient, session, coveragePlanId, coverageRules, coverageRuleUsages, _v0) {
        var readOnly = _v0.Ya;
        var filteredRules = readOnly ? A2($elm$core$List$filter, $author$project$Api$Provider$CoverageRule$One$isPublished, coverageRules) : coverageRules;
        var _v1 = A3($elm_community$list_extra$List$Extra$indexedFoldr, F3(function(index, rule, _v2) {
            var forms = _v2.a;
            var cmds = _v2.b;
            var _v3 = A6($author$project$Components$Admin$CoverageRules$Form$init, apiClient, session, $elm$core$Maybe$Just(rule), coveragePlanId, {
                Ya: readOnly
            }, A2($author$project$Components$Admin$CoveragePlans$Rules$selectCoverageRuleUsage, rule, coverageRuleUsages));
            var form = _v3.a;
            var cmd = _v3.b;
            var cmd_ = A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index), cmd);
            return _Utils_Tuple2(A2($elm$core$List$cons, form, forms), A2($elm$core$List$cons, cmd_, cmds));
        }), _Utils_Tuple2(_List_Nil, _List_Nil), filteredRules);
        var coverageRuleForms = _v1.a;
        var cmds_ = _v1.b;
        return _Utils_Tuple2({
            w_: coveragePlanId,
            Mp: coverageRuleUsages,
            acC: coverageRuleForms,
            Ya: readOnly,
            Z$: session
        }, $elm$core$Platform$Cmd$batch(cmds_));
    });
    var $author$project$Components$Admin$CoveragePlans$Form$initPagination = A2($author$project$Api$Pagination$withItemsPerPage, 5, $author$project$Api$Pagination$init);
    var $author$project$Api$Provider$CoveragePlan$coveragePlanPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$CoveragePlan$coveragePlansPath);
    };
    var $author$project$Api$Provider$CoveragePlan$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CoveragePlan$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_)));
    });
    var $author$project$Components$Admin$CoveragePlans$Form$init = F4(function(apiClient, session, practice, id) {
        var _v0 = function() {
            if (!id.$) {
                var id_ = id.a;
                var cmd = A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, cmd);
            } else {
                var _v2 = A6($author$project$Components$Admin$CoveragePlans$Rules$init, apiClient, session, $elm$core$Maybe$Nothing, _List_Nil, $elm$core$Maybe$Nothing, {
                    Ya: false
                });
                var coverageRulesModel_ = _v2.a;
                var coverageRulesCmd_ = _v2.b;
                var cmd = A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverageRulesCmd_);
                return _Utils_Tuple3($elm$core$Maybe$Just($author$project$Components$Admin$CoveragePlans$Form$formFieldsInit), $elm$core$Maybe$Just(coverageRulesModel_), cmd);
            }
        }();
        var formFields = _v0.a;
        var coverageRules = _v0.b;
        var command = _v0.c;
        var model = {
            Mm: $elm$core$Maybe$Nothing,
            Mn: $elm$core$Maybe$Nothing,
            acC: coverageRules,
            h7: $jinjor$elm_debounce$Debounce$init,
            PU: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
            aef: id,
            af_: $author$project$Components$Admin$CoveragePlans$Form$initPagination,
            gu: _List_Nil,
            r9: $elm$core$Maybe$Nothing,
            WO: $author$project$Api$Data$Loading,
            W1: practice,
            Ch: false,
            sJ: false,
            Z$: session
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            command,
            A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, model)
        ])));
    });
    var $author$project$Pages$Admin$CoveragePlans$Id_String$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var params = _v1.VU;
        var _v2 = A4($author$project$Components$Admin$CoveragePlans$Form$init, apiClient, session, practice, $elm$core$Maybe$Just(params.aef));
        var form = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$CoveragePlans$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $elm$core$Basics$xor = _Basics_xor;
    var $author$project$Components$Admin$CoverageRules$Form$isUnpublished = function(_v0) {
        var model = _v0;
        return !_Utils_eq(model.L, $elm$core$Maybe$Nothing) || model.ce !== model.aG;
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$unpublishedRulesExists = function(model) {
        return A2($elm$core$List$any, function(rule) {
            return $author$project$Components$Admin$CoverageRules$Form$isUnpublished(rule);
        }, model.acC);
    };
    var $author$project$Components$Admin$CoveragePlans$Form$save = F2(function(_v0, shared) {
        var model = _v0;
        var pendingChangesExists = !model.Ch && A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$unpublishedRulesExists, model.acC));
        return _Utils_update(shared, {
            af8: pendingChangesExists ? $elm$core$Maybe$Just('You have draft changes to your coverage plan. If you would like to publish these changes, click the publish button at the bottom of the page.') : $elm$core$Maybe$Nothing
        });
    });
    var $author$project$Pages$Admin$CoveragePlans$Id_String$save = F2(function(_v0, shared) {
        var form = _v0.PU;
        return A2($author$project$Components$Admin$CoveragePlans$Form$save, form, shared);
    });
    var $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$Close = {
        $: 0
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageDocuments$UploadModal$Close);
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, $author$project$Components$Admin$CoverageDocuments$UploadModal$subscriptions(model.cN)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fr)))
        ]));
    };
    var $author$project$Components$Admin$CoverageRules$Form$AttemptedCancel = {
        $: 13
    };
    var $author$project$Components$Admin$CoverageRules$Form$subscriptions = function(_v0) {
        var model = _v0;
        var _v1 = model.aI;
        switch(_v1){
            case 0:
                return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel);
            case 1:
                return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel);
            default:
                return $elm$core$Platform$Sub$none;
        }
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(A2($elm$core$List$indexedMap, F2(function(index, rule) {
            return A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index), $author$project$Components$Admin$CoverageRules$Form$subscriptions(rule));
        }), model.acC));
    };
    var $author$project$Components$Admin$CoveragePlans$Form$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.acC))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$subscriptions, model.Mm)))
        ]));
    };
    var $author$project$Pages$Admin$CoveragePlans$Id_String$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$CoveragePlans$Form$subscriptions(model.PU));
    };
    var $author$project$Components$Admin$CoveragePlans$Form$AllPlans = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$PlanAdd = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$PlanRemove = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$CoveragePlan$One$coverageDocuments = function(_v0) {
        var record = _v0.b;
        return record.Mm;
    };
    var $author$project$Components$Admin$CoveragePlans$Form$DebounceMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$debounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(300),
        ah3: $author$project$Components$Admin$CoveragePlans$Form$DebounceMsg
    };
    var $author$project$Components$Admin$CoveragePlans$Form$TextDebounced = {
        $: 12
    };
    var $author$project$Components$Admin$CoveragePlans$Form$debounceText = function(text) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Components$Admin$CoveragePlans$Form$TextDebounced;
        }, $elm$core$Task$succeed(text));
    };
    var $author$project$Api$Provider$CoveragePlan$One$plans = function(_v0) {
        var record = _v0.b;
        return record.WO;
    };
    var $author$project$Components$Admin$CoveragePlans$Form$formFieldsFromItem = function(coveragePlan) {
        return {
            abD: false,
            zr: $author$project$Api$Provider$CoveragePlan$One$name(coveragePlan),
            WO: A2($elm$core$List$map, function(plan) {
                return {
                    aef: $author$project$Api$Provider$Plan$Min$id(plan),
                    zr: $author$project$Api$Provider$Plan$Min$name(plan)
                };
            }, $author$project$Api$Provider$CoveragePlan$One$plans(coveragePlan))
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var plan = field.a;
                var plan_ = A2($elm_community$list_extra$List$Extra$find, function(plan__) {
                    return _Utils_eq(plan__.aef, plan.aef);
                }, fields.WO);
                var plans = function() {
                    if (!plan_.$) return fields.WO;
                    else return A2($elm$core$List$cons, {
                        aef: plan.aef,
                        zr: plan.zr
                    }, fields.WO);
                }();
                return _Utils_update(fields, {
                    WO: plans
                });
            case 2:
                var id = field.a;
                return _Utils_update(fields, {
                    WO: A2($elm_community$list_extra$List$Extra$filterNot, function(plan) {
                        return _Utils_eq(plan.aef, id);
                    }, fields.WO)
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    abD: bool
                });
        }
    });
    var $author$project$Components$Admin$CoveragePlans$Form$NameValidation = 0;
    var $author$project$Components$Admin$CoveragePlans$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Components$Admin$CoverageDocuments$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoverageDocument$Shared$fileName = function(_v0) {
        var record = _v0;
        return record.PF;
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$initFormFields = function(coverageDocument) {
        if (!coverageDocument.$) {
            var coverageDocument_ = coverageDocument.a;
            return {
                adN: $elm$core$Maybe$Nothing,
                PF: $author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument_)
            };
        } else return {
            adN: $elm$core$Maybe$Nothing,
            PF: ''
        };
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$init = F2(function(coveragePlanId, coverageDocument) {
        var fields = $author$project$Components$Admin$CoverageDocuments$UploadModal$initFormFields(coverageDocument);
        return {
            p1: coverageDocument,
            w_: coveragePlanId,
            PU: $author$project$Utils$Form$init(fields),
            j_: $author$project$Api$Data$NotAsked
        };
    });
    var $author$project$Components$Admin$CoverageDocuments$Form$init = F5(function(_v0, session, coveragePlanId, coverageDocuments, displayUploadModal) {
        return _Utils_Tuple2({
            cN: A2($author$project$Components$Admin$CoverageDocuments$UploadModal$init, coveragePlanId, $elm$core$Maybe$Nothing),
            Mm: coverageDocuments,
            w_: coveragePlanId,
            fr: $elm$core$Maybe$Nothing,
            ir: displayUploadModal,
            Z$: session
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Admin$CoveragePlans$Form$onSaved = F3(function(response, model, successMsg) {
        var _v0 = model.PU;
        if (!_v0.$) {
            if (response.$ === 3) {
                var coveragePlan = response.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Ch: true
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, _Utils_ap($author$project$Api$Provider$CoveragePlan$One$name(coveragePlan), successMsg))
                ]));
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Components$Admin$CoveragePlans$Form$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$Updated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$CoveragePlan$save = F4(function(apiClient, maybeId, fields, toMsg) {
        var encodeCoverageRule = function(coverageRule) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.aef)),
                _Utils_Tuple2('amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, coverageRule.Jh)),
                _Utils_Tuple2('time_period', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.ahU)),
                _Utils_Tuple2('quantity', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, coverageRule.Bu)),
                _Utils_Tuple2('percentage', $elm$json$Json$Encode$string(coverageRule.af9)),
                _Utils_Tuple2('patient_contribution_percentage', $elm$json$Json$Encode$string(coverageRule.af3)),
                _Utils_Tuple2('sponsor_contribution_percentage', $elm$json$Json$Encode$string(coverageRule.ahv)),
                _Utils_Tuple2('rule_type', $elm$json$Json$Encode$string(coverageRule.ag0)),
                _Utils_Tuple2('item', $author$project$Utils$Encode$typedAssociation(coverageRule.F6))
            ]));
        };
        var encodedCoverageRules = function() {
            if (!maybeId.$) return _List_Nil;
            else return _List_fromArray([
                _Utils_Tuple2('coverage_rules', A2($elm$json$Json$Encode$list, encodeCoverageRule, fields.acC))
            ]);
        }();
        var body_ = $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('plans', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.WO)), A2($elm$core$List$cons, _Utils_Tuple2('all_plans', $elm$json$Json$Encode$bool(fields.abD)), encodedCoverageRules))));
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$CoveragePlan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_))));
        } else return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CoveragePlan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlansPath)));
    });
    var $author$project$Components$Admin$CoverageRules$Form$isDeleted = function(_v0) {
        var model = _v0;
        return model.aG;
    };
    var $author$project$Components$Admin$CoverageRules$Form$formToParams = F3(function(form, deleted, publishedRule) {
        var fields = $author$project$Utils$Form$fields(form);
        var itemId = function() {
            var _v5 = fields.F6;
            if (!_v5.$) {
                var item = _v5.a;
                return item.aef;
            } else return '';
        }();
        var percentage = $elm$core$String$fromFloat(A2($elm$core$Maybe$withDefault, 0.0, fields.af9));
        var ruleType = function() {
            var _v4 = fields.ag0;
            if (!_v4.$) {
                var ruleType_ = _v4.a;
                return A2($elm$core$Maybe$withDefault, '', $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType_));
            } else return '';
        }();
        var timePeriod = function() {
            var _v1 = fields.ahU;
            if (!_v1.$) {
                if (!_v1.a) {
                    var _v2 = _v1.a;
                    return $elm$core$Maybe$Just('beginning_of_year');
                } else {
                    var _v3 = _v1.a;
                    return $elm$core$Maybe$Just('membership_renewal_date');
                }
            } else return $elm$core$Maybe$Nothing;
        }();
        var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ag0);
        var amountInCents = ruleType === 'included' && _Utils_eq(typeIncludedOption, $elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Nothing : fields.Jh;
        var _v0 = !fields.dE ? _Utils_Tuple2('100', '0') : _Utils_Tuple2('0', '100');
        var patientContribution = _v0.a;
        var sponsorContribution = _v0.b;
        return {
            Jh: amountInCents,
            NT: deleted,
            aef: fields.aef,
            F6: {
                aef: $elm$core$Maybe$Just(itemId),
                ah5: $elm$core$Maybe$Just(fields.rc)
            },
            af3: patientContribution,
            af9: percentage,
            XN: publishedRule,
            Bu: fields.Bu,
            ag0: ruleType,
            ahv: sponsorContribution,
            ahU: timePeriod
        };
    });
    var $author$project$Components$Admin$CoverageRules$Form$toParams = function(_v0) {
        var model = _v0;
        return A3($author$project$Components$Admin$CoverageRules$Form$formToParams, model.PU, model.aG, $elm$core$Maybe$Nothing);
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$toParams = function(model) {
        var notDeletedRules = A2($elm$core$List$filter, function(rule) {
            return !$author$project$Components$Admin$CoverageRules$Form$isDeleted(rule);
        }, model.acC);
        return A2($elm$core$List$map, $author$project$Components$Admin$CoverageRules$Form$toParams, notDeletedRules);
    };
    var $author$project$Components$Admin$CoveragePlans$Form$saveCoveragePlan = F4(function(apiClient, maybeId, formFields, coverageRules) {
        var msg = function() {
            if (!maybeId.$) return $author$project$Components$Admin$CoveragePlans$Form$Updated;
            else return $author$project$Components$Admin$CoveragePlans$Form$Created;
        }();
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            abD: fields.abD,
            acC: $author$project$Components$Admin$CoveragePlans$Rules$toParams(coverageRules),
            zr: fields.zr,
            WO: A2($elm$core$List$map, function(plan) {
                return plan.aef;
            }, fields.WO)
        };
        return A4($author$project$Api$Provider$CoveragePlan$save, apiClient, maybeId, apiFields, msg);
    });
    var $author$project$Components$Admin$CoverageDocuments$Form$DeletedCoverageDocument = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$CoverageDocuments$Form$DocumentDeleted = 1;
    var $author$project$Components$Admin$CoverageDocuments$Form$DocumentSaved = 2;
    var $author$project$Components$Admin$CoverageDocuments$Form$None = 0;
    var $author$project$Api$Provider$CoverageDocument$coverageDocumentsPath = function(coveragePlanId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'coverage_documents'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            coveragePlanId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'coverage_plans'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$CoverageDocument$delete = F4(function(apiClient, coveragePlanId, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId))));
    });
    var $author$project$Api$Provider$CoverageDocument$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$Closed = 0;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$File = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileNameValidation = 1;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileValidation = 0;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$None = 1;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$UploadCreated = 2;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$UploadUpdated = 3;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$Created = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $elm_community$string_extra$String$Extra$clean = function(string) {
        return $elm$core$String$trim(A3($elm$regex$Regex$replace, $elm_community$string_extra$String$Extra$regexFromString('\\s\\s+'), $elm$core$Basics$always(' '), string));
    };
    var $author$project$Api$Data$Multipart = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Data$requestMultipartBody = F2(function(parts, _v0) {
        var request = _v0;
        return _Utils_update(request, {
            fb: $elm$core$Maybe$Just($author$project$Api$Data$Multipart(parts))
        });
    });
    var $elm$http$Http$stringPart = _Http_pair;
    var $author$project$Api$Provider$CoverageDocument$createUpload = F4(function(apiClient, coveragePlanId, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestMultipartBody, function() {
            var _v0 = fields.adN;
            if (!_v0.$) {
                var file = _v0.a;
                return _List_fromArray([
                    A2($elm$http$Http$filePart, 'coverage_document[pdf_upload]', file),
                    A2($elm$http$Http$stringPart, 'coverage_document[file_name]', fields.PF)
                ]);
            } else return _List_Nil;
        }(), $author$project$Api$Data$requestTo($author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId))));
    });
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$createUpload = F3(function(apiClient, coveragePlanId, validFormFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        var file = _v0.adN;
        var fileName = _v0.PF;
        return A4($author$project$Api$Provider$CoverageDocument$createUpload, apiClient, coveragePlanId, {
            adN: file,
            PF: $elm_community$string_extra$String$Extra$clean(fileName)
        }, $author$project$Components$Admin$CoverageDocuments$UploadModal$Created);
    });
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$Updated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$CoverageDocument$update = F5(function(apiClient, coveragePlanId, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('coverage_document', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('file_name', $elm$json$Json$Encode$string(fields.PF))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$CoverageDocument$coverageDocumentsPath(coveragePlanId)))));
    });
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$editUpload = F4(function(apiClient, coveragePlanId, coverageDocument, validFormFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        var fileName = _v0.PF;
        return A5($author$project$Api$Provider$CoverageDocument$update, apiClient, coveragePlanId, $author$project$Api$Provider$CoverageDocument$Shared$id(coverageDocument), {
            PF: $elm_community$string_extra$String$Extra$clean(fileName)
        }, $author$project$Components$Admin$CoverageDocuments$UploadModal$Updated);
    });
    var $elm$file$File$name = _File_name;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var file = field.a;
            var newFileName = $rtfeldman$elm_validate$Validate$isBlank(fields.PF) ? A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$file$File$name, file)) : fields.PF;
            return _Utils_update(fields, {
                adN: file,
                PF: newFileName
            });
        } else {
            var fileName = field.a;
            return _Utils_update(fields, {
                PF: fileName
            });
        }
    });
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.adN;
        }, _Utils_Tuple2(0, 'Please select a file.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.PF;
        }, _Utils_Tuple2(1, 'Please enter a file name.'))
    ]));
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidatorForEdit = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.PF;
        }, _Utils_Tuple2(1, 'Please enter a file name.'))
    ]));
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 1:
                var files = msg.a;
                var file = $elm$core$List$head(files);
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsUpdate, $author$project$Components$Admin$CoverageDocuments$UploadModal$File(file), model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 3:
                var _v2 = function() {
                    var _v3 = model.p1;
                    if (!_v3.$) {
                        var coverageDocument_ = _v3.a;
                        return _Utils_Tuple2(A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidatorForEdit, model.PU), A3($author$project$Components$Admin$CoverageDocuments$UploadModal$editUpload, apiClient, model.w_, coverageDocument_));
                    } else return _Utils_Tuple2(A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoverageDocuments$UploadModal$formFieldsValidator, model.PU), A2($author$project$Components$Admin$CoverageDocuments$UploadModal$createUpload, apiClient, model.w_));
                }();
                var formValidationResult = _v2.a;
                var cmdToExecute = _v2.b;
                if (!formValidationResult.$) {
                    var _v5 = formValidationResult.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return {
                        EQ: cmdToExecute(validFormFields),
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            j_: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = formValidationResult.a;
                    var errorList = A2($elm$core$List$append, A2($author$project$Utils$Form$validationErrors, 1, newForm), A2($author$project$Utils$Form$validationErrors, 0, newForm));
                    var errorMsg = A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(errorList));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, errorMsg)
                        ])
                    };
                }
            case 4:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Document successfully uploaded.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        j_: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 3,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Document successfully updated.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        j_: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Admin$CoverageDocuments$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var coverageDocument = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just(_Utils_Tuple2(coverageDocument, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 1:
                var coverageDocument = msg.a;
                var confirmed = msg.b;
                return confirmed ? {
                    EQ: A4($author$project$Api$Provider$CoverageDocument$delete, apiClient, model.w_, $author$project$Api$Provider$CoverageDocument$Shared$id(coverageDocument), $author$project$Components$Admin$CoverageDocuments$Form$DeletedCoverageDocument(coverageDocument)),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just(_Utils_Tuple2(coverageDocument, $author$project$Api$Data$Loading))
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 2:
                var coverageDocument = msg.a;
                var response = msg.b;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Document removed')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just(_Utils_Tuple2(coverageDocument, response))
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var subMsg = msg.a;
                var uploadModalResult = A3($author$project$Components$Admin$CoverageDocuments$UploadModal$update, apiClient, subMsg, model.cN);
                var _v3 = uploadModalResult.adu;
                switch(_v3){
                    case 0:
                        return {
                            EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.EQ),
                            adu: 0,
                            zi: _Utils_update(model, {
                                cN: uploadModalResult.zi,
                                ir: false
                            }),
                            at: uploadModalResult.at
                        };
                    case 1:
                        return {
                            EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.EQ),
                            adu: 0,
                            zi: _Utils_update(model, {
                                cN: uploadModalResult.zi
                            }),
                            at: uploadModalResult.at
                        };
                    case 2:
                        return {
                            EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.EQ),
                            adu: 2,
                            zi: _Utils_update(model, {
                                cN: uploadModalResult.zi,
                                ir: false
                            }),
                            at: uploadModalResult.at
                        };
                    default:
                        return {
                            EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, uploadModalResult.EQ),
                            adu: 2,
                            zi: _Utils_update(model, {
                                cN: uploadModalResult.zi,
                                ir: false
                            }),
                            at: uploadModalResult.at
                        };
                }
            default:
                var coverageDocument = msg.a;
                var newModdal = A2($author$project$Components$Admin$CoverageDocuments$UploadModal$init, model.w_, $elm$core$Maybe$Just(coverageDocument));
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        cN: newModdal,
                        ir: true
                    }),
                    at: _List_Nil
                };
        }
    });
    var $elm_community$list_extra$List$Extra$setAt = F2(function(index, value) {
        return A2($elm_community$list_extra$List$Extra$updateAt, index, $elm$core$Basics$always(value));
    });
    var $author$project$Components$Admin$CoverageRules$Form$Editing = 1;
    var $author$project$Components$Admin$CoverageRules$Form$Id = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$ItemAdd = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$Restored = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$RuleTypeSelectMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$RuleTypeUpdate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$Deleted = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CoverageRule$coverageRulesPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'coverage_rules'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'coverage_plans'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$CoverageRule$coverageRulePath = F2(function(coveragePlanId, coverageRuleId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            coverageRuleId
        ]), $author$project$Api$Provider$CoverageRule$coverageRulesPath(coveragePlanId));
    });
    var $author$project$Api$Provider$CoverageRule$delete = F4(function(apiClient, coveragePlanId, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_)));
    });
    var $author$project$Api$Provider$CoverageRule$unpublish = F4(function(apiClient, coveragePlanId, id_, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unpublish'
        ]), A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
    });
    var $author$project$Components$Admin$CoverageRules$Form$deleteRule = F4(function(apiClient, model, coveragePlanId, coverageRuleId) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var _v0 = fields.aef;
        if (!_v0.$) {
            var id_ = _v0.a;
            return model.ce || !_Utils_eq(coverageRuleId, id_) ? A4($author$project$Api$Provider$CoverageRule$delete, apiClient, coveragePlanId, coverageRuleId, $author$project$Components$Admin$CoverageRules$Form$Deleted(coverageRuleId)) : A4($author$project$Api$Provider$CoverageRule$unpublish, apiClient, coveragePlanId, coverageRuleId, $author$project$Components$Admin$CoverageRules$Form$Deleted(coverageRuleId));
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Admin$CoverageRules$Form$ruleTypeId = function(ruleType) {
        if (!ruleType.$) {
            var ruleTypeOption = ruleType.a;
            return A2($elm$core$Maybe$withDefault, '', $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleTypeOption));
        } else return '';
    };
    var $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate = F2(function(field, form) {
        switch(field.$){
            case 0:
                var id = field.a;
                return _Utils_update(form, {
                    aef: id
                });
            case 1:
                var ruleTypeOption = field.a;
                var timePeriod = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleTypeOption) === 'limited_quantity' ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Nothing;
                var itemType = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleTypeOption) === 'limited_quantity' ? 'charge_item' : form.rc;
                return _Utils_update(form, {
                    rc: itemType,
                    ag0: ruleTypeOption,
                    ahU: timePeriod
                });
            case 6:
                var coveredBy = field.a;
                return _Utils_update(form, {
                    dE: coveredBy
                });
            case 7:
                var timePeriod = field.a;
                return _Utils_update(form, {
                    ahU: $elm$core$Maybe$Just(timePeriod)
                });
            case 8:
                var quantity = field.a;
                return _Utils_update(form, {
                    Bu: $elm$core$String$toInt(quantity)
                });
            case 3:
                var amountInCents = field.a;
                return _Utils_update(form, {
                    Jh: amountInCents
                });
            case 4:
                var percentage = field.a;
                return _Utils_update(form, {
                    af9: $elm$core$String$toFloat(percentage)
                });
            case 2:
                var item = field.a;
                return _Utils_update(form, {
                    F6: item
                });
            default:
                var itemType = field.a;
                return _Utils_update(form, {
                    F6: $elm$core$Maybe$Nothing,
                    rc: itemType
                });
        }
    });
    var $author$project$Components$Admin$CoverageRules$Form$RuleTypeValidation = 0;
    var $author$project$Components$Admin$CoverageRules$Form$AmountInCentsValidation = 4;
    var $author$project$Components$Admin$CoverageRules$Form$validateAmountInCents = function(_v0) {
        var ruleType = _v0.ag0;
        var amountInCents = _v0.Jh;
        var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, ruleType);
        var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
        var isUnderPriceIncluded = typeId === 'included' && _Utils_eq(typeIncludedOption, $elm$core$Maybe$Just(1));
        var isRequired = isUnderPriceIncluded || typeId === 'flat_amount' || typeId === 'surcharge';
        return A2($author$project$Utils$Validate$isInvalidCurrency, {
            abI: !isRequired,
            y_: $elm$core$Maybe$Nothing,
            Uj: $elm$core$Maybe$Just(0)
        }, amountInCents) ? _List_fromArray([
            _Utils_Tuple2(4, 'Please enter a valid amount.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Admin$CoverageRules$Form$CategoryValidation = 2;
    var $author$project$Components$Admin$CoverageRules$Form$ChargeItemValidation = 1;
    var $author$project$Components$Admin$CoverageRules$Form$ItemTypeValidation = 3;
    var $author$project$Components$Admin$CoverageRules$Form$validateForm = function(form) {
        var _v0 = _Utils_Tuple2(form.rc, form.F6);
        _v0$3: while(true){
            if (_v0.b.$ === 1) switch(_v0.a){
                case 'charge_category':
                    var _v1 = _v0.b;
                    return _List_fromArray([
                        _Utils_Tuple2(2, 'Please pick a category.')
                    ]);
                case 'charge_item':
                    var _v2 = _v0.b;
                    return _List_fromArray([
                        _Utils_Tuple2(1, 'Please pick a charge item.')
                    ]);
                case '':
                    var _v3 = _v0.b;
                    return _List_fromArray([
                        _Utils_Tuple2(3, 'Please pick a category or item.')
                    ]);
                default:
                    break _v0$3;
            }
            else break _v0$3;
        }
        return _List_Nil;
    };
    var $author$project$Components$Admin$CoverageRules$Form$PercentageValidation = 6;
    var $author$project$Components$Admin$CoverageRules$Form$validatePercentage = function(_v0) {
        var ruleType = _v0.ag0;
        var percentage = _v0.af9;
        var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
        var _v1 = _Utils_Tuple2(typeId, percentage);
        if (_v1.a === 'discounted' && _v1.b.$ === 1) {
            var _v2 = _v1.b;
            return _List_fromArray([
                _Utils_Tuple2(6, 'Please pick a valid quantity.')
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$CoverageRules$Form$QuantityValidation = 5;
    var $author$project$Components$Admin$CoverageRules$Form$validateQuantity = function(_v0) {
        var ruleType = _v0.ag0;
        var quantity = _v0.Bu;
        var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(ruleType);
        var _v1 = _Utils_Tuple2(typeId, quantity);
        if (_v1.a === 'limited_quantity' && _v1.b.$ === 1) {
            var _v2 = _v1.b;
            return _List_fromArray([
                _Utils_Tuple2(5, 'Please pick a valid quantity.')
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$CoverageRules$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.ag0;
        }, _Utils_Tuple2(0, 'Please pick a coverage rule.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateAmountInCents),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateQuantity),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validatePercentage),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$CoverageRules$Form$validateForm)
    ]));
    var $author$project$Components$ResourceFilter$ChargeItem$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Api$Provider$CoverageRule$publish = F4(function(apiClient, coveragePlanId, id_, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'publish'
        ]), A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
    });
    var $author$project$Components$Admin$CoverageRules$Form$GotChargeItem = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$Updated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$formChanged = F2(function(form, updatedForm) {
        var unpublishedFields = $author$project$Utils$Form$fields(updatedForm);
        var publishedFields = $author$project$Utils$Form$fields(form);
        var original = _Utils_update(publishedFields, {
            aef: $elm$core$Maybe$Nothing
        });
        var changed = _Utils_update(unpublishedFields, {
            aef: $elm$core$Maybe$Nothing
        });
        return !_Utils_eq(original, changed);
    });
    var $author$project$Api$Provider$CoverageRule$save = F5(function(apiClient, coveragePlanId, maybeId, coverageRule, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.aef)),
            _Utils_Tuple2('amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, coverageRule.Jh)),
            _Utils_Tuple2('percentage', $elm$json$Json$Encode$string(coverageRule.af9)),
            _Utils_Tuple2('time_period', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.ahU)),
            _Utils_Tuple2('quantity', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, coverageRule.Bu)),
            _Utils_Tuple2('patient_contribution_percentage', $elm$json$Json$Encode$string(coverageRule.af3)),
            _Utils_Tuple2('sponsor_contribution_percentage', $elm$json$Json$Encode$string(coverageRule.ahv)),
            _Utils_Tuple2('rule_type', $elm$json$Json$Encode$string(coverageRule.ag0)),
            _Utils_Tuple2('item', $author$project$Utils$Encode$typedAssociation(coverageRule.F6)),
            _Utils_Tuple2('published_rule', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, coverageRule.XN))
            ])))
        ]));
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$CoverageRule$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$CoverageRule$coverageRulePath, coveragePlanId, id_))));
        } else return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CoverageRule$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CoverageRule$coverageRulesPath(coveragePlanId))));
    });
    var $author$project$Components$Admin$CoverageRules$Form$saveOrDeleteUnpublishedRule = F3(function(apiClient, model, form) {
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = _Utils_Tuple2(model.w_, model.L);
        _v0$2: while(true)if (!_v0.a.$) {
            if (!_v0.b.$) {
                var coveragePlanId = _v0.a.a;
                var unpublishedForm = _v0.b.a;
                var unpublishedFields = $author$project$Utils$Form$fields(unpublishedForm);
                var fieldsChanged = A2($author$project$Components$Admin$CoverageRules$Form$formChanged, model.PU, unpublishedForm);
                var revertedChanges = !fieldsChanged && !_Utils_eq(unpublishedFields.aef, $elm$core$Maybe$Nothing) && !model.ce;
                var cmd = function() {
                    if (revertedChanges) return A4($author$project$Components$Admin$CoverageRules$Form$deleteRule, apiClient, model, coveragePlanId, A2($elm$core$Maybe$withDefault, '', unpublishedFields.aef));
                    else {
                        if (fieldsChanged) {
                            var coverageRule = A3($author$project$Components$Admin$CoverageRules$Form$formToParams, form, model.aG, $author$project$Utils$Form$fields(model.PU).aef);
                            return A5($author$project$Api$Provider$CoverageRule$save, apiClient, coveragePlanId, fields.aef, coverageRule, $author$project$Components$Admin$CoverageRules$Form$Updated);
                        } else return $elm$core$Platform$Cmd$none;
                    }
                }();
                return _Utils_Tuple3(model, cmd, _List_Nil);
            } else break _v0$2;
        } else {
            if (!_v0.b.$) {
                var _v1 = _v0.a;
                var unpublishedForm = _v0.b.a;
                var _v2 = function() {
                    var _v3 = fields.F6;
                    if (!_v3.$) {
                        var item = _v3.a;
                        return fields.rc === 'charge_item' ? _Utils_Tuple2(A3($author$project$Api$Provider$ChargeItem$retrieve, apiClient, item.aef, $author$project$Components$Admin$CoverageRules$Form$GotChargeItem), $elm$core$Maybe$Nothing) : _Utils_Tuple2($elm$core$Platform$Cmd$none, $elm$core$Maybe$Just({
                            aef: item.aef,
                            zr: item.zr
                        }));
                    } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                }();
                var cmd = _v2.a;
                var category_ = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    EL: category_,
                    aI: 2,
                    PU: unpublishedForm,
                    L: $elm$core$Maybe$Nothing
                }), cmd, _List_Nil);
            } else break _v0$2;
        }
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Components$Admin$CoverageRules$Form$searchRuleTypes = function(query) {
        return A2($elm$core$List$filter, function(option) {
            var ruleType = option;
            return A2($elm$core$String$contains, query, ruleType.zr);
        }, $author$project$Components$Admin$CoverageRules$Form$ruleTypeOptions);
    };
    var $author$project$Components$Admin$CoverageRules$Form$updateForms = F2(function(model, field) {
        var updateField = function(form) {
            return A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate, field, form);
        };
        if (model.aI === 2) return _Utils_update(model, {
            PU: updateField(model.PU)
        });
        else {
            var initEditForm = function() {
                var _v0 = model.L;
                if (!_v0.$) {
                    var editForm = _v0.a;
                    return editForm;
                } else {
                    var idUpdate = model.ce ? $author$project$Components$Admin$CoverageRules$Form$Id($author$project$Utils$Form$fields(model.PU).aef) : $author$project$Components$Admin$CoverageRules$Form$Id($elm$core$Maybe$Nothing);
                    return A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate, idUpdate, model.PU);
                }
            }();
            var updatedForm = updateField(initEditForm);
            return _Utils_update(model, {
                L: $elm$core$Maybe$Just(updatedForm)
            });
        }
    });
    var $author$project$Components$Admin$CoverageRules$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 3:
                var field = msg.a;
                var updatedForm = A2($author$project$Components$Admin$CoverageRules$Form$updateForms, model, field);
                var _v2 = A3($author$project$Components$ResourceFilter$ChargeItem$init, apiClient, function(opts) {
                    return _Utils_update(opts, {
                        rc: $elm$core$Maybe$Just('item')
                    });
                }, function(d) {
                    return _Utils_update(d, {
                        Ee: 'Select a Charge Item'
                    });
                });
                var chargeItemResourceFilter = _v2.a;
                var chargeItemResourceFilterCmd = _v2.b;
                var _v3 = A3($author$project$Components$ResourceFilter$Category$init, apiClient, model.Z$, function(d) {
                    return _Utils_update(d, {
                        Ee: 'Select a Category'
                    });
                });
                var categoryResourceFilter = _v3.a;
                var categoryResourceFilterCmd = _v3.b;
                var _v4 = function() {
                    if (field.$ === 5) return _Utils_Tuple2(_Utils_update(updatedForm, {
                        cK: categoryResourceFilter,
                        cL: chargeItemResourceFilter
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd)
                    ])));
                    else return _Utils_Tuple2(updatedForm, $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(newModel, cmd, _List_Nil);
            case 12:
                var response = msg.a;
                if (response.$ === 3) {
                    var chargeItem = response.a;
                    var _v7 = $author$project$Api$Provider$ChargeItem$One$category(chargeItem);
                    if (!_v7.$) {
                        var oneCategory = _v7.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            EL: $elm$core$Maybe$Just({
                                aef: $author$project$Api$Provider$Category$Shared$id(oneCategory),
                                zr: $author$project$Api$Provider$Category$Shared$name(oneCategory)
                            })
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 4:
                var _v8 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoverageRules$Form$formFieldsValidator, A2($elm$core$Maybe$withDefault, model.PU, model.L));
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var form = _v9.a;
                    return A3($author$project$Components$Admin$CoverageRules$Form$saveOrDeleteUnpublishedRule, apiClient, model, form);
                } else {
                    var form = _v8.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        L: $elm$core$Maybe$Just(form)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 6:
                var resourceFilterPreSelectCmd = function() {
                    var _v12 = model.Mo;
                    if (!_v12.$) {
                        var coverageRule = _v12.a;
                        return A2($elm$core$Task$perform, $author$project$Components$Admin$CoverageRules$Form$ResourceFilterPreSelected, $elm$core$Task$succeed(coverageRule));
                    } else return $elm$core$Platform$Cmd$none;
                }();
                var _v10 = A3($author$project$Components$ResourceFilter$ChargeItem$init, apiClient, function(opts) {
                    return _Utils_update(opts, {
                        rc: $elm$core$Maybe$Just('item')
                    });
                }, function(d) {
                    return _Utils_update(d, {
                        Ee: 'Select a Charge Item'
                    });
                });
                var chargeItemResourceFilter = _v10.a;
                var chargeItemResourceFilterCmd = _v10.b;
                var _v11 = A3($author$project$Components$ResourceFilter$Category$init, apiClient, model.Z$, function(d) {
                    return _Utils_update(d, {
                        Ee: 'Select a Category'
                    });
                });
                var categoryResourceFilter = _v11.a;
                var categoryResourceFilterCmd = _v11.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    cK: categoryResourceFilter,
                    cL: chargeItemResourceFilter,
                    aI: 1
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
                    resourceFilterPreSelectCmd
                ])), _List_Nil);
            case 7:
                var maybeCoverageRuleId = msg.a;
                var deleted = _Utils_eq(model.w_, $elm$core$Maybe$Nothing) && _Utils_eq(maybeCoverageRuleId, $elm$core$Maybe$Nothing);
                var cmd = function() {
                    var _v13 = _Utils_Tuple2(model.w_, maybeCoverageRuleId);
                    if (!_v13.a.$ && !_v13.b.$) {
                        var coveragePlanId = _v13.a.a;
                        var coverageRuleId = _v13.b.a;
                        return A4($author$project$Components$Admin$CoverageRules$Form$deleteRule, apiClient, model, coveragePlanId, coverageRuleId);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    aG: deleted,
                    L: $elm$core$Maybe$Nothing
                }), cmd, _List_Nil);
            case 0:
                var selectMsg = msg.a;
                var _v14 = A2($author$project$Ui$Form$SearchableSelect$update, selectMsg, model.n5);
                var selectModel = _v14.a;
                var selectCmd = _v14.b;
                var event = _v14.c;
                var modelAfterEvent = function() {
                    _v15$2: while(true){
                        if (!event.$) switch(event.a.$){
                            case 0:
                                var ruleType = event.a.a;
                                return A2($author$project$Components$Admin$CoverageRules$Form$updateForms, model, $author$project$Components$Admin$CoverageRules$Form$RuleTypeUpdate(ruleType));
                            case 1:
                                var string = event.a.a;
                                return _Utils_update(model, {
                                    Cd: $author$project$Components$Admin$CoverageRules$Form$searchRuleTypes(string)
                                });
                            default:
                                break _v15$2;
                        }
                        else break _v15$2;
                    }
                    return model;
                }();
                return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
                    n5: selectModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$RuleTypeSelectMsg, selectCmd), _List_Nil);
            case 5:
                var coverageRule = msg.a;
                var _v16 = $author$project$Api$Provider$CoverageRule$One$item(coverageRule);
                if (_v16.$ === 1) {
                    var category_ = _v16.a;
                    var _v17 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Category$extraItems(_List_fromArray([
                        {
                            aef: $author$project$Api$Provider$Category$Shared$id(category_),
                            zr: $author$project$Api$Provider$Category$Shared$name(category_)
                        }
                    ])), A2($author$project$Components$ResourceFilter$Category$preSelectedId, $elm$core$Maybe$Just($author$project$Api$Provider$Category$Shared$id(category_)), model.cK));
                    var categoryResourceFilter = _v17.a;
                    var categoryResourceFilterCmd = _v17.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cK: categoryResourceFilter
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd), _List_Nil);
                } else {
                    var chargeItem = _v16.a;
                    var _v18 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$ChargeItem$extraItems(_List_fromArray([
                        {
                            aef: $author$project$Api$Provider$ChargeItem$Shared$id(chargeItem),
                            zr: $author$project$Api$Provider$ChargeItem$Shared$name(chargeItem)
                        }
                    ])), A2($author$project$Components$ResourceFilter$ChargeItem$preSelectedId, $elm$core$Maybe$Just($author$project$Api$Provider$ChargeItem$Shared$id(chargeItem)), model.cL));
                    var chargeItemResourceFilter = _v18.a;
                    var chargeItemResourceFilterCmd = _v18.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cL: chargeItemResourceFilter
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd), _List_Nil);
                }
            case 1:
                var subMsg = msg.a;
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cK);
                var newModelForms = function() {
                    var _v19 = categoryResourceResult.adu;
                    _v19$2: while(true){
                        if (!_v19.$ && !_v19.a.$) switch(_v19.a.a.$){
                            case 0:
                                var category_ = _v19.a.a.a;
                                var item = $elm$core$Maybe$Just({
                                    aef: category_.aef,
                                    zr: category_.zr
                                });
                                return A2($author$project$Components$Admin$CoverageRules$Form$updateForms, model, $author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
                            case 4:
                                var preSelectedItem = _v19.a.a.a;
                                var item = $elm$core$Maybe$Just({
                                    aef: preSelectedItem.aa9,
                                    zr: preSelectedItem.aeI
                                });
                                return A2($author$project$Components$Admin$CoverageRules$Form$updateForms, model, $author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
                            default:
                                break _v19$2;
                        }
                        else break _v19$2;
                    }
                    return model;
                }();
                var newModel = _Utils_update(newModelForms, {
                    cK: categoryResourceResult.zi
                });
                return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, categoryResourceResult.EQ), categoryResourceResult.at);
            case 2:
                var subMsg = msg.a;
                var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cL);
                var newModelForms = function() {
                    var _v20 = chargeItemResourceResult.adu;
                    _v20$2: while(true){
                        if (!_v20.$ && !_v20.a.$) switch(_v20.a.a.$){
                            case 0:
                                var chargeItem = _v20.a.a.a;
                                var item = $elm$core$Maybe$Just({
                                    aef: chargeItem.aef,
                                    zr: chargeItem.zr
                                });
                                return A2($author$project$Components$Admin$CoverageRules$Form$updateForms, model, $author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
                            case 4:
                                var preSelectedItem = _v20.a.a.a;
                                var item = $elm$core$Maybe$Just({
                                    aef: preSelectedItem.aa9,
                                    zr: preSelectedItem.aeI
                                });
                                return A2($author$project$Components$Admin$CoverageRules$Form$updateForms, model, $author$project$Components$Admin$CoverageRules$Form$ItemAdd(item));
                            default:
                                break _v20$2;
                        }
                        else break _v20$2;
                    }
                    return model;
                }();
                var newModel = _Utils_update(newModelForms, {
                    cL: chargeItemResourceResult.zi
                });
                return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.EQ), chargeItemResourceResult.at);
            case 8:
                var response = msg.a;
                if (response.$ === 3) {
                    var coverageRule = response.a;
                    var _v22 = model.L;
                    if (!_v22.$) {
                        var editedForm_ = _v22.a;
                        var updatedForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoverageRules$Form$formFieldsUpdate, $author$project$Components$Admin$CoverageRules$Form$Id($elm$core$Maybe$Just($author$project$Api$Provider$CoverageRule$One$id(coverageRule))), editedForm_);
                        var newModel = _Utils_update(model, {
                            aI: 2
                        });
                        var coverageRuleCategory = A2($elm$core$Maybe$map, function(category_) {
                            return {
                                aef: $author$project$Api$Provider$Category$Min$id(category_),
                                zr: $author$project$Api$Provider$Category$Min$name(category_)
                            };
                        }, $author$project$Api$Provider$CoverageRule$One$category(coverageRule));
                        return model.ce ? _Utils_Tuple3(_Utils_update(newModel, {
                            EL: coverageRuleCategory,
                            PU: updatedForm,
                            ce: true,
                            L: $elm$core$Maybe$Nothing
                        }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(newModel, {
                            EL: coverageRuleCategory,
                            L: $elm$core$Maybe$Just(updatedForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var id_ = msg.a;
                var response = msg.b;
                var publishedFields = $author$project$Utils$Form$fields(model.PU);
                var _v23 = _Utils_Tuple2(response, publishedFields.aef);
                if (_v23.a.$ === 3 && !_v23.b.$) {
                    var _v24 = _v23.a;
                    var coverageRuleId = _v23.b.a;
                    if (_Utils_eq(coverageRuleId, id_)) return _Utils_Tuple3(_Utils_update(model, {
                        aG: true
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                    else {
                        var _v25 = model.L;
                        if (!_v25.$) {
                            var editedForm_ = _v25.a;
                            var unpublishedFields = $author$project$Utils$Form$fields(editedForm_);
                            return _Utils_eq(A2($elm$core$Maybe$withDefault, '', unpublishedFields.aef), id_) ? _Utils_Tuple3(_Utils_update(model, {
                                L: $elm$core$Maybe$Nothing
                            }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var coverageRuleId = msg.a;
                var cmd = function() {
                    var _v26 = model.w_;
                    if (!_v26.$) {
                        var coveragePlanId = _v26.a;
                        return A4($author$project$Api$Provider$CoverageRule$publish, apiClient, coveragePlanId, coverageRuleId, $author$project$Components$Admin$CoverageRules$Form$Restored);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 11:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aG: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var _v27 = model.aI;
                switch(_v27){
                    case 0:
                        return _Utils_Tuple3(_Utils_update(model, {
                            aG: true,
                            aI: 2
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            aI: 2,
                            L: $elm$core$Maybe$Nothing
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Components$Admin$CoveragePlans$Rules$update = F3(function(apiClient, msg, model) {
        if (!msg.$) {
            var index = msg.a;
            var subMsg = msg.b;
            var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, model.acC);
            if (!_v1.$) {
                var coverageRuleForm = _v1.a;
                var _v2 = A3($author$project$Components$Admin$CoverageRules$Form$update, apiClient, subMsg, coverageRuleForm);
                var updatedCoverageRuleForm = _v2.a;
                var subCmd = _v2.b;
                var subOutMsg = _v2.c;
                var coverageRules = A3($elm_community$list_extra$List$Extra$setAt, index, updatedCoverageRuleForm, model.acC);
                return _Utils_Tuple3(_Utils_update(model, {
                    acC: coverageRules
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index), subCmd), subOutMsg);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
            var _v3 = A6($author$project$Components$Admin$CoverageRules$Form$init, apiClient, model.Z$, $elm$core$Maybe$Nothing, model.w_, {
                Ya: model.Ya
            }, $elm$core$Maybe$Nothing);
            var newForm = _v3.a;
            var cmd = _v3.b;
            var coverageRules = _Utils_ap(model.acC, _List_fromArray([
                newForm
            ]));
            return _Utils_Tuple3(_Utils_update(model, {
                acC: coverageRules
            }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg($elm$core$List$length(model.acC)), cmd), _List_Nil);
        }
    });
    var $author$project$Api$Pagination$withTotalCount = F2(function(totalCount, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            oQ: totalCount
        });
    });
    var $author$project$Components$Admin$CoveragePlans$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var coveragePlan = response.a;
                    var _v3 = A6($author$project$Components$Admin$CoveragePlans$Rules$init, apiClient, model.Z$, model.aef, $author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan), $elm$core$Maybe$Nothing, {
                        Ya: false
                    });
                    var coverageRules = _v3.a;
                    var coverateRulesCmd = _v3.b;
                    var _v4 = A5($author$project$Components$Admin$CoverageDocuments$Form$init, apiClient, model.Z$, $author$project$Api$Provider$CoveragePlan$One$id(coveragePlan), $author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan), false);
                    var coverageDocuments = _v4.a;
                    var coverageDocumentsCmd = _v4.b;
                    var cmd = $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverateRulesCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, coverageDocumentsCmd)
                    ]));
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mm: $elm$core$Maybe$Just(coverageDocuments),
                        Mn: $elm$core$Maybe$Just(coveragePlan),
                        acC: $elm$core$Maybe$Just(coverageRules),
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Components$Admin$CoveragePlans$Form$formFieldsFromItem(coveragePlan)))
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var field = msg.a;
                var _v5 = model.PU;
                if (!_v5.$) {
                    var form = _v5.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var _v6 = _Utils_Tuple2(model.PU, model.acC);
                if (!_v6.a.$ && !_v6.b.$) {
                    var form = _v6.a.a;
                    var coverageRules = _v6.b.a;
                    var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$CoveragePlans$Form$formFieldsValidator, form);
                    if (!_v7.$) {
                        var _v8 = _v7.a;
                        var newForm = _v8.a;
                        var validFormFields = _v8.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), A4($author$project$Components$Admin$CoveragePlans$Form$saveCoveragePlan, apiClient, model.aef, validFormFields, coverageRules), _List_Nil);
                    } else {
                        var newForm = _v7.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                return A3($author$project$Components$Admin$CoveragePlans$Form$onSaved, response, model, ' was successfully created.');
            case 4:
                var response = msg.a;
                return A3($author$project$Components$Admin$CoveragePlans$Form$onSaved, response, model, ' was successfully updated.');
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var plans = response.a;
                    var headers = response.b;
                    var totalCount = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
                    var planRecords = A2($elm$core$List$map, function(plan) {
                        return {
                            aef: $author$project$Api$Provider$Plan$All$id(plan),
                            zr: $author$project$Api$Provider$Plan$All$name(plan)
                        };
                    }, plans);
                    var pagination = A2($author$project$Api$Pagination$withTotalCount, totalCount, model.af_);
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: pagination,
                        gu: _Utils_ap(model.gu, planRecords),
                        WO: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    WO: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var allPlans = msg.a;
                var _v10 = model.PU;
                if (!_v10.$) {
                    var form = _v10.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate, $author$project$Components$Admin$CoveragePlans$Form$AllPlans(allPlans), form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        sJ: allPlans
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var plan = msg.a;
                var enabled = msg.b;
                var newForm = enabled ? A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate, $author$project$Components$Admin$CoveragePlans$Form$PlanAdd(plan)), model.PU) : A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$CoveragePlans$Form$formFieldsUpdate, $author$project$Components$Admin$CoveragePlans$Form$PlanRemove(plan.aef)), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, newModel), _List_Nil);
            case 13:
                var subMsg = msg.a;
                var _v11 = model.acC;
                if (!_v11.$) {
                    var coverageRules = _v11.a;
                    var _v12 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, coverageRules);
                    var newCoverageRulesForm = _v12.a;
                    var coverageRulesCmd = _v12.b;
                    var coverageRulesOutMsgs = _v12.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        acC: $elm$core$Maybe$Just(newCoverageRulesForm)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg, coverageRulesCmd), coverageRulesOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var query = msg.a;
                var _v13 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$CoveragePlans$Form$debounceConfig, query, model.h7);
                var debounce = _v13.a;
                var cmd = _v13.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    h7: debounce,
                    r9: $elm$core$Maybe$Just(query)
                }), cmd, _List_Nil);
            case 11:
                var dMsg = msg.a;
                var _v14 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Admin$CoveragePlans$Form$debounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$CoveragePlans$Form$debounceText), dMsg, model.h7);
                var debounce = _v14.a;
                var cmd = _v14.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    h7: debounce
                }), cmd, _List_Nil);
            case 12:
                var newModel = _Utils_update(model, {
                    af_: $author$project$Components$Admin$CoveragePlans$Form$initPagination,
                    gu: _List_Nil
                });
                return _Utils_Tuple3(newModel, A2($author$project$Components$Admin$CoveragePlans$Form$fetchPlans, apiClient, newModel), _List_Nil);
            case 14:
                var _v15 = model.Mn;
                if (!_v15.$) {
                    var coveragePlan_ = _v15.a;
                    var _v16 = A5($author$project$Components$Admin$CoverageDocuments$Form$init, apiClient, model.Z$, $author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_), $author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan_), true);
                    var coverageDocumentForm = _v16.a;
                    var coverageDocumentsCmd = _v16.b;
                    var newModel = _Utils_update(model, {
                        Mm: $elm$core$Maybe$Just(coverageDocumentForm)
                    });
                    return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, coverageDocumentsCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v17 = model.Mm;
                if (!_v17.$) {
                    var coverageDocuments_ = _v17.a;
                    var result = A3($author$project$Components$Admin$CoverageDocuments$Form$update, apiClient, subMsg, coverageDocuments_);
                    var retrievePlan = function() {
                        var _v18 = _Utils_Tuple2(model.aef, result.adu);
                        _v18$2: while(true){
                            if (!_v18.a.$) switch(_v18.b){
                                case 1:
                                    var id_ = _v18.a.a;
                                    var _v19 = _v18.b;
                                    return A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
                                case 2:
                                    var id_ = _v18.a.a;
                                    var _v20 = _v18.b;
                                    return A3($author$project$Api$Provider$CoveragePlan$retrieve, apiClient, id_, $author$project$Components$Admin$CoveragePlans$Form$GotCoveragePlan);
                                default:
                                    break _v18$2;
                            }
                            else break _v18$2;
                        }
                        return $elm$core$Platform$Cmd$none;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mm: $elm$core$Maybe$Just(result.zi)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, result.EQ),
                        retrievePlan
                    ])), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$CoveragePlans$Id_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$CoveragePlans$Form$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Admin$CoveragePlans$Form$AttemptedSubmit = {
        $: 2
    };
    var $author$project$Components$Admin$CoveragePlans$Form$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$CoveragePlans$Form$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$category = function(_v0) {
        var model = _v0;
        return model.EL;
    };
    var $elm_community$list_extra$List$Extra$uniqueHelp = F4(function(f, existing, remaining, accumulator) {
        uniqueHelp: while(true){
            if (!remaining.b) return $elm$core$List$reverse(accumulator);
            else {
                var first = remaining.a;
                var rest = remaining.b;
                var computedFirst = f(first);
                if (A2($elm$core$Set$member, computedFirst, existing)) {
                    var $temp$f = f, $temp$existing = existing, $temp$remaining = rest, $temp$accumulator = accumulator;
                    f = $temp$f;
                    existing = $temp$existing;
                    remaining = $temp$remaining;
                    accumulator = $temp$accumulator;
                    continue uniqueHelp;
                } else {
                    var $temp$f = f, $temp$existing = A2($elm$core$Set$insert, computedFirst, existing), $temp$remaining = rest, $temp$accumulator = A2($elm$core$List$cons, first, accumulator);
                    f = $temp$f;
                    existing = $temp$existing;
                    remaining = $temp$remaining;
                    accumulator = $temp$accumulator;
                    continue uniqueHelp;
                }
            }
        }
    });
    var $elm_community$list_extra$List$Extra$uniqueBy = F2(function(f, list) {
        return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, $elm$core$Set$empty, list, _List_Nil);
    });
    var $author$project$Components$Admin$CoveragePlans$Rules$allCategories = function(coverageRuleFormsWithIndex) {
        return A2($elm$core$List$sortBy, function($) {
            return $.zr;
        }, A2($elm_community$list_extra$List$Extra$uniqueBy, function($) {
            return $.aef;
        }, A2($elm$core$List$filterMap, $author$project$Components$Admin$CoverageRules$Form$category, A2($elm$core$List$map, function(tuple) {
            return tuple.a;
        }, coverageRuleFormsWithIndex))));
    };
    var $author$project$Components$Admin$CoverageRules$Form$isReallyDeleted = function(_v0) {
        var model = _v0;
        return model.aG && (_Utils_eq(model.w_, $elm$core$Maybe$Nothing) || model.ce);
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleAdded = {
        $: 1
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$viewAddCoverageRuleButton = A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Add coverage rule'
        }, _List_fromArray([
            $author$project$Ui$Button$onClick($author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleAdded),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
        ]), _List_fromArray([
            $elm$html$Html$text('Add Coverage Rule')
        ]))
    ]));
    var $author$project$Ui$ListGroup$Header = 4;
    var $author$project$Components$Admin$CoveragePlans$Rules$isRuleInCategory = F2(function(ruleForm, categoryId) {
        var _v0 = $author$project$Components$Admin$CoverageRules$Form$category(ruleForm);
        if (!_v0.$) {
            var cat = _v0.a;
            return _Utils_eq(cat.aef, categoryId);
        } else return false;
    });
    var $author$project$Ui$ListGroup$Style = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$ListGroup$style = $author$project$Ui$ListGroup$Style;
    var $author$project$Components$Admin$CoverageRules$Form$AttemptedSubmit = {
        $: 4
    };
    var $author$project$Components$Admin$CoverageRules$Form$editingForm = function(model) {
        var _v0 = model.L;
        if (!_v0.$) {
            var editedForm = _v0.a;
            return editedForm;
        } else return model.PU;
    };
    var $author$project$Components$Admin$CoverageRules$Form$AmountInCents = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$Percentage = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$viewAmountOrPercentageInput = F2(function(fields, form) {
        var _v0 = fields.ag0;
        if (!_v0.$) {
            var ruleType = _v0.a;
            var currencyInput = A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Amount')
            ]), _List_fromArray([
                $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$value(fields.Jh),
                    $author$project$Ui$Form$CurrencyInput$placeholder('0.00'),
                    $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
                    $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$AmountInCents))
                ]))
            ]));
            var _v1 = $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType);
            _v1$4: while(true){
                if (!_v1.$) switch(_v1.a){
                    case 'flat_amount':
                        return currencyInput;
                    case 'surcharge':
                        return currencyInput;
                    case 'discounted':
                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpanSm(3),
                            $author$project$Ui$Form$Group$inputSpanSm(9),
                            $author$project$Ui$Form$Group$label('Percentage')
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$group(_List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value($elm$core$String$fromFloat(A2($elm$core$Maybe$withDefault, 0, fields.af9))),
                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$Percentage)),
                                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 6, form))
                                ])),
                                $author$project$Ui$Form$Input$addon(_List_fromArray([
                                    $elm$html$Html$text('%')
                                ]))
                            ]))
                        ]));
                    case 'included':
                        var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ag0);
                        return _Utils_eq(typeIncludedOption, $elm$core$Maybe$Just(1)) ? currencyInput : $author$project$Utils$Html$empty;
                    default:
                        break _v1$4;
                }
                else break _v1$4;
            }
            return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$CoverageRules$Form$viewCategoryResourceFilter = F2(function(categoryResourceFilter, form) {
        return A2($elm$html$Html$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$view, _List_fromArray([
            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form))
        ]), categoryResourceFilter));
    });
    var $author$project$Components$Admin$CoverageRules$Form$viewChargeItemResourceFilter = F2(function(chargeItemResourceFilter, form) {
        return A2($elm$html$Html$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, A2($author$project$Components$ResourceFilter$ChargeItem$view, _List_fromArray([
            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
        ]), chargeItemResourceFilter));
    });
    var $author$project$Components$Admin$CoverageRules$Form$viewChargeItemOrCategoryFilter = F3(function(model, form, isEditing) {
        var fields = $author$project$Utils$Form$fields(form);
        var isCategory = fields.rc === 'charge_category';
        var chargeLabel = isCategory ? 'Charge category' : 'Charge Item';
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label(chargeLabel)
        ]), _List_fromArray([
            isEditing ? isCategory ? A2($elm$html$Html$map, $author$project$Components$Admin$CoverageRules$Form$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$view, _List_fromArray([
                $author$project$Components$ResourceFilter$disabled(isEditing)
            ]), model.cK)) : A2($elm$html$Html$map, $author$project$Components$Admin$CoverageRules$Form$ChargeItemResourceFilterMsg, A2($author$project$Components$ResourceFilter$ChargeItem$view, _List_fromArray([
                $author$project$Components$ResourceFilter$disabled(isEditing)
            ]), model.cL)) : isCategory ? A2($author$project$Components$Admin$CoverageRules$Form$viewCategoryResourceFilter, model.cK, form) : A2($author$project$Components$Admin$CoverageRules$Form$viewChargeItemResourceFilter, model.cL, form)
        ]));
    });
    var $author$project$Components$Admin$CoverageRules$Form$CoveredBy = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$viewCoveredBy = function(coveredBy) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Amount Due Paid For By')
        ]), _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                    $author$project$Ui$Form$Radio$value(!coveredBy),
                    $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Admin$CoverageRules$Form$CoveredBy(0))))
                ]), _List_fromArray([
                    $elm$html$Html$text('Patient')
                ])),
                A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                    $author$project$Ui$Form$Radio$value(coveredBy === 1),
                    $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Admin$CoverageRules$Form$CoveredBy(1))))
                ]), _List_fromArray([
                    $elm$html$Html$text('Sponsor')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$CoverageRules$Form$ItemType = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Radio$Disabled = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Radio$disabled = $author$project$Ui$Form$Radio$Disabled;
    var $author$project$Components$Admin$CoverageRules$Form$viewItemType = F2(function(form, isEditing) {
        var fields = $author$project$Utils$Form$fields(form);
        var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ag0);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Applies To')
        ]), _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                    $author$project$Ui$Form$Radio$value(fields.rc === 'charge_category'),
                    $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Admin$CoverageRules$Form$ItemType('charge_category')))),
                    $author$project$Ui$Form$Radio$disabled(isEditing || $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(fields.ag0) === 'limited_quantity')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Charge Category')
                    ]))
                ])),
                A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                    $author$project$Ui$Form$Radio$value(fields.rc === 'charge_item'),
                    $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Admin$CoverageRules$Form$ItemType('charge_item')))),
                    $author$project$Ui$Form$Radio$disabled(isEditing || _Utils_eq(typeIncludedOption, $elm$core$Maybe$Just(1)))
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Charge Item')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$CoverageRules$Form$Quantity = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$viewQuantity = F3(function(quantity, form, isEditing) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Quantity')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value($elm$core$String$fromInt(A2($elm$core$Maybe$withDefault, 0, quantity))),
                $author$project$Ui$Form$Input$phi(true),
                $author$project$Ui$Form$Input$disabled(isEditing),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $author$project$Components$Admin$CoverageRules$Form$Quantity))
            ]))
        ]));
    });
    var $author$project$Components$Admin$CoverageRules$Form$disableSelectItem = F2(function(itemType, ruleTypeOption) {
        var _v0 = _Utils_Tuple3(itemType, $author$project$Components$Admin$CoverageRules$Form$ruleTypeId($elm$core$Maybe$Just(ruleTypeOption)), $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption(ruleTypeOption));
        _v0$2: while(true)switch(_v0.a){
            case 'charge_item':
                if (_v0.b === 'included' && !_v0.c.$ && _v0.c.a === 1) {
                    var _v1 = _v0.c.a;
                    return true;
                } else break _v0$2;
            case 'charge_category':
                if (_v0.b === 'limited_quantity') return true;
                else break _v0$2;
            default:
                break _v0$2;
        }
        return false;
    });
    var $author$project$Ui$Form$SearchableSelect$Item$Disabled = $elm$core$Basics$identity;
    var $author$project$Ui$Form$SearchableSelect$Item$disabled = $elm$core$Basics$identity;
    var $author$project$Components$Admin$CoverageRules$Form$viewRuleType = F3(function(model, form, isEditing) {
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Coverage Rule')
        ]), _List_fromArray([
            isEditing ? A2($elm$html$Html$map, $author$project$Components$Admin$CoverageRules$Form$RuleTypeSelectMsg, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
                $author$project$Ui$Form$SearchableSelect$value(fields.ag0),
                $author$project$Ui$Form$SearchableSelect$disabled(isEditing)
            ]), _List_Nil, model.n5)) : A2($elm$html$Html$map, $author$project$Components$Admin$CoverageRules$Form$RuleTypeSelectMsg, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
                $author$project$Ui$Form$SearchableSelect$value(fields.ag0),
                $author$project$Ui$Form$SearchableSelect$placeholder('Select Coverage Rule'),
                $author$project$Ui$Form$SearchableSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
            ]), A2($elm$core$List$map, function(ruleTypeOption) {
                return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_fromArray([
                    $author$project$Ui$Form$SearchableSelect$Item$disabled(A2($author$project$Components$Admin$CoverageRules$Form$disableSelectItem, fields.rc, ruleTypeOption))
                ]), ruleTypeOption);
            }, model.Cd), model.n5))
        ]));
    });
    var $author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder = F2(function(shouldUnderlineText, form) {
        var fields = $author$project$Utils$Form$fields(form);
        var includedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ag0);
        var itemName = function() {
            var _v1 = fields.F6;
            if (!_v1.$) {
                var item = _v1.a;
                return item.zr;
            } else return '';
        }();
        var ruleType = function() {
            var _v0 = fields.ag0;
            if (!_v0.$) {
                var ruleType_ = _v0.a;
                return A2($elm$core$Maybe$withDefault, '', $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue(ruleType_));
            } else return '';
        }();
        return {
            Jh: fields.Jh,
            dE: !fields.dE ? 'patient' : 'sponsor',
            d9: includedOption,
            aeH: itemName,
            rc: fields.rc,
            af9: fields.af9,
            Bu: fields.Bu,
            ag0: ruleType,
            ahm: shouldUnderlineText,
            ahU: fields.ahU
        };
    });
    var $author$project$Components$CoverageRuleSentence$formatPercentage = function(percentage) {
        if (!percentage.$) {
            var percentage_ = percentage.a;
            return $author$project$Formatters$Float$toPercentage(percentage_);
        } else return '___%';
    };
    var $author$project$Components$CoverageRuleSentence$formatRuleItemName = function(record) {
        var pluralName = $author$project$Formatters$String$pluralOf(record.aeH);
        return record.rc === 'charge_category' ? 'All ' + pluralName : pluralName;
    };
    var $author$project$Components$CoverageRuleSentence$spanText = function(string) {
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $author$project$Utils$Html$noBreakSpace,
            $elm$html$Html$text(string),
            $author$project$Utils$Html$noBreakSpace
        ]));
    };
    var $author$project$Components$CoverageRuleSentence$strongText = F2(function(string, shouldUnderlineText) {
        return shouldUnderlineText ? A2($author$project$Ui$Typography$strong, _List_fromArray([
            $author$project$Ui$Typography$underline
        ]), _List_fromArray([
            $elm$html$Html$text(string)
        ])) : A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
            $elm$html$Html$text(string)
        ]));
    });
    var $author$project$Components$CoverageRuleSentence$viewDiscounted = function(record) {
        return _List_fromArray([
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatRuleItemName(record), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('will receive a'),
            A2($author$project$Components$CoverageRuleSentence$strongText, 'discount of ' + $author$project$Components$CoverageRuleSentence$formatPercentage(record.af9), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('with the amount due paid for by the'),
            A2($author$project$Components$CoverageRuleSentence$strongText, record.dE, record.ahm)
        ]);
    };
    var $author$project$Components$CoverageRuleSentence$formatAmount = function(amountInCents) {
        if (!amountInCents.$) {
            var amountInCents_ = amountInCents.a;
            return $author$project$Currency$format(amountInCents_);
        } else return '$___';
    };
    var $author$project$Components$CoverageRuleSentence$viewFlatAmount = function(record) {
        return _List_fromArray([
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatRuleItemName(record), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('will be'),
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatAmount(record.Jh), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('paid for by the'),
            A2($author$project$Components$CoverageRuleSentence$strongText, record.dE, record.ahm)
        ]);
    };
    var $author$project$Components$CoverageRuleSentence$viewIncludedAll = function(record) {
        return _List_fromArray([
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatRuleItemName(record), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('are'),
            A2($author$project$Components$CoverageRuleSentence$strongText, 'included', record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('in the membership at no additional charge')
        ]);
    };
    var $author$project$Components$CoverageRuleSentence$noBreakSpaceRight = function(string) {
        return $elm$html$Html$text(_Utils_ap(string, $author$project$Utils$String$noBreakSpace));
    };
    var $author$project$Components$CoverageRuleSentence$viewIncludedUnderPrice = function(record) {
        return _List_fromArray([
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatRuleItemName(record), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('are'),
            A2($author$project$Components$CoverageRuleSentence$strongText, 'included', record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('in the membership at no additional charge if they cost less than'),
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatAmount(record.Jh), record.ahm),
            $author$project$Components$CoverageRuleSentence$noBreakSpaceRight(','),
            $author$project$Components$CoverageRuleSentence$noBreakSpaceRight('those above are paid for by the'),
            A2($author$project$Components$CoverageRuleSentence$strongText, record.dE, record.ahm)
        ]);
    };
    var $author$project$Components$CoverageRuleSentence$viewIncluded = function(record) {
        var _v0 = record.d9;
        if (!_v0.$) {
            if (!_v0.a) {
                var _v1 = _v0.a;
                return $author$project$Components$CoverageRuleSentence$viewIncludedAll(record);
            } else {
                var _v2 = _v0.a;
                return $author$project$Components$CoverageRuleSentence$viewIncludedUnderPrice(record);
            }
        } else return _List_Nil;
    };
    var $author$project$Components$CoverageRuleSentence$viewLimitedQuantity = function(record) {
        var quantity = function() {
            var _v4 = record.Bu;
            if (!_v4.$) {
                var quantity_ = _v4.a;
                return A2($author$project$Formatters$String$pluralize, 'unit', quantity_);
            } else return '___ units';
        }();
        var _v0 = function() {
            var _v1 = record.ahU;
            if (!_v1.$) {
                if (!_v1.a) {
                    var _v2 = _v1.a;
                    return _Utils_Tuple2('', 'Jan 1st,');
                } else {
                    var _v3 = _v1.a;
                    return _Utils_Tuple2(' the patient\'s', 'membership renewal date,');
                }
            } else return _Utils_Tuple2('', '');
        }();
        var subject = _v0.a;
        var timePeriod = _v0.b;
        return _List_fromArray([
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatRuleItemName(record), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('are'),
            A2($author$project$Components$CoverageRuleSentence$strongText, 'limited to a quantity', record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('of'),
            A2($author$project$Components$CoverageRuleSentence$strongText, quantity, record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('per period resetting on' + subject),
            A2($author$project$Components$CoverageRuleSentence$strongText, timePeriod, record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('additional units will be paid for by the'),
            A2($author$project$Components$CoverageRuleSentence$strongText, record.dE, record.ahm)
        ]);
    };
    var $author$project$Components$CoverageRuleSentence$viewPassThrough = function(record) {
        return _List_fromArray([
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatRuleItemName(record), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('will be paid for by the'),
            A2($author$project$Components$CoverageRuleSentence$strongText, record.dE, record.ahm)
        ]);
    };
    var $author$project$Components$CoverageRuleSentence$viewSurcharge = function(record) {
        return _List_fromArray([
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatRuleItemName(record), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('will have a surcharge of'),
            A2($author$project$Components$CoverageRuleSentence$strongText, $author$project$Components$CoverageRuleSentence$formatAmount(record.Jh), record.ahm),
            $author$project$Components$CoverageRuleSentence$spanText('added to the charge, the amount due will be paid for by the'),
            A2($author$project$Components$CoverageRuleSentence$strongText, record.dE, record.ahm)
        ]);
    };
    var $author$project$Components$CoverageRuleSentence$view = function(record) {
        return A2($elm$html$Html$span, _List_Nil, function() {
            var _v0 = record.ag0;
            switch(_v0){
                case 'included':
                    return $author$project$Components$CoverageRuleSentence$viewIncluded(record);
                case 'flat_amount':
                    return $author$project$Components$CoverageRuleSentence$viewFlatAmount(record);
                case 'discounted':
                    return $author$project$Components$CoverageRuleSentence$viewDiscounted(record);
                case 'surcharge':
                    return $author$project$Components$CoverageRuleSentence$viewSurcharge(record);
                case 'pass_through':
                    return $author$project$Components$CoverageRuleSentence$viewPassThrough(record);
                case 'limited_quantity':
                    return $author$project$Components$CoverageRuleSentence$viewLimitedQuantity(record);
                default:
                    return _List_Nil;
            }
        }());
    };
    var $author$project$Components$Admin$CoverageRules$Form$viewSentencePreview = F2(function(fields, form) {
        var _v0 = _Utils_Tuple2(fields.F6, fields.ag0);
        if (!_v0.a.$ && !_v0.b.$) return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$label('Preview')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $author$project$Components$CoverageRuleSentence$view(A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, false, form))
                ]))
            ]))
        ]));
        else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$CoverageRules$Form$TimePeriod = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$viewTimePeriod = F2(function(timePeriod, isEditing) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Time period')
        ]), _List_fromArray([
            $elm$html$Html$text('Time-period resetting on:'),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                    $author$project$Ui$Form$Radio$value(_Utils_eq(timePeriod, $elm$core$Maybe$Just(0))),
                    $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Admin$CoverageRules$Form$TimePeriod(0)))),
                    $author$project$Ui$Form$Radio$disabled(isEditing)
                ]), _List_fromArray([
                    $elm$html$Html$text('Jan 1st')
                ])),
                A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                    $author$project$Ui$Form$Radio$value(_Utils_eq(timePeriod, $elm$core$Maybe$Just(1))),
                    $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageRules$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$Admin$CoverageRules$Form$TimePeriod(1)))),
                    $author$project$Ui$Form$Radio$disabled(isEditing)
                ]), _List_fromArray([
                    $elm$html$Html$text('Renewal Date')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm = function(model) {
        var submitVerb = function() {
            var _v1 = model.aI;
            switch(_v1){
                case 0:
                    return 'Create';
                case 1:
                    return 'Save';
                default:
                    return '';
            }
        }();
        var modalTitle = function() {
            var _v0 = model.aI;
            switch(_v0){
                case 0:
                    return 'Add Coverage Rule';
                case 1:
                    return 'Edit Coverage Rule';
                default:
                    return '';
            }
        }();
        var isEditing = model.aI === 1;
        var form = $author$project$Components$Admin$CoverageRules$Form$editingForm(model);
        var fields = $author$project$Utils$Form$fields(form);
        var typeId = $author$project$Components$Admin$CoverageRules$Form$ruleTypeId(fields.ag0);
        var typeIncludedOption = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIncludedOption, fields.ag0);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$CoverageRules$Form$AttemptedCancel, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(modalTitle)
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Components$Admin$CoverageRules$Form$viewItemType, form, isEditing),
                A3($author$project$Components$Admin$CoverageRules$Form$viewChargeItemOrCategoryFilter, model, form, isEditing),
                A3($author$project$Components$Admin$CoverageRules$Form$viewRuleType, model, form, isEditing),
                A2($author$project$Components$Admin$CoverageRules$Form$viewAmountOrPercentageInput, fields, form),
                typeId === 'limited_quantity' ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A3($author$project$Components$Admin$CoverageRules$Form$viewQuantity, fields.Bu, form, isEditing),
                    A2($author$project$Components$Admin$CoverageRules$Form$viewTimePeriod, fields.ahU, isEditing)
                ])) : $author$project$Utils$Html$empty,
                typeId === '' || typeId === 'included' && !_Utils_eq(typeIncludedOption, $elm$core$Maybe$Just(1)) ? $author$project$Utils$Html$empty : $author$project$Components$Admin$CoverageRules$Form$viewCoveredBy(fields.dE),
                A2($author$project$Components$Admin$CoverageRules$Form$viewSentencePreview, fields, form)
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedCancel)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: submitVerb
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedSubmit)
                ]), _List_fromArray([
                    $elm$html$Html$text(submitVerb)
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$CoverageRules$Form$AttemptedCancelDelete = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageRules$Form$cancelDelete = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = fields.aef;
        if (!_v0.$) {
            var id_ = _v0.a;
            return _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel deletion'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedCancelDelete(id_))
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel Deletion')
                ]))
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$CoverageRules$Form$AttemptedDelete = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Icon$UnpublishedRuleArrow = 2;
    var $author$project$Ui$Icon$unpublishedRuleArrow = $author$project$Ui$Icon$viewIcon(2);
    var $author$project$Components$Admin$CoverageRules$Form$unpublishedTag = _List_fromArray([
        $author$project$Utils$Html$noBreakSpace,
        $author$project$Utils$Html$noBreakSpace,
        A2($author$project$Ui$Badge$fromString, _List_Nil, 'unpublished_change')
    ]);
    var $author$project$Components$Admin$CoverageRules$Form$unpublishedSentence = function(editedForm) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('coverage-rule__unpublished')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('coverage-rule__unpublished__arrow')
            ]), _List_fromArray([
                $author$project$Ui$Icon$unpublishedRuleArrow(_List_Nil)
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('coverage-rule__unpublished__warning')
            ]), _List_fromArray([
                A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(10)
                        ]), A2($elm$core$List$cons, $author$project$Components$CoverageRuleSentence$view(A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, true, editedForm)), $author$project$Components$Admin$CoverageRules$Form$unpublishedTag)),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(2),
                            $author$project$Ui$Grid$justifyRight
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Cancel change'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$size(0),
                                $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedDelete($author$project$Utils$Form$fields(editedForm).aef))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel Change')
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Api$Provider$CoverageRuleUsage$Shared$coveredCharges = function(_v0) {
        var record = _v0;
        return record.Mr;
    };
    var $author$project$Api$Provider$CoverageRuleUsage$All$coveredCharges = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CoverageRuleUsage$Shared$coveredCharges(shared);
    };
    var $author$project$Api$Provider$CoverageRule$Shared$itemName = function(_v0) {
        var record = _v0;
        var _v1 = record.F6;
        if (!_v1.$) {
            var i = _v1.a;
            return $author$project$Api$Provider$ChargeItem$Shared$name(i);
        } else {
            var cat = _v1.a;
            return $author$project$Api$Provider$Category$Shared$name(cat);
        }
    };
    var $author$project$Api$Provider$CoverageRule$One$itemName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CoverageRule$Shared$itemName(shared);
    };
    var $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItems = function(_v0) {
        var record = _v0;
        return record.Yv;
    };
    var $author$project$Api$Provider$CoverageRuleUsage$All$remainingItems = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItems(shared);
    };
    var $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItemsUntil = function(_v0) {
        var record = _v0;
        return record.Yw;
    };
    var $author$project$Api$Provider$CoverageRuleUsage$All$remainingItemsUntil = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CoverageRuleUsage$Shared$remainingItemsUntil(shared);
    };
    var $author$project$Api$Provider$CoveredCharge$Min$coveredDate = function(_v0) {
        var record = _v0;
        return record.Ms;
    };
    var $author$project$Api$Provider$CoveredCharge$Min$quantity = function(_v0) {
        var record = _v0;
        return record.Bu;
    };
    var $author$project$Components$CoverageRuleUsage$viewCoveredCharge = function(coveredCharge) {
        var quantity = $author$project$Api$Provider$CoveredCharge$Min$quantity(coveredCharge);
        var date = $author$project$Api$Provider$CoveredCharge$Min$coveredDate(coveredCharge);
        var string = $justinmimbs$date$Date$toIsoString(date) + (' - ' + (A2($author$project$Formatters$String$pluralize, 'unit', quantity) + ' utilized'));
        return A2($elm$html$Html$li, _List_fromArray([
            $elm$html$Html$Attributes$class('timeline__item')
        ]), _List_fromArray([
            $elm$html$Html$text(string)
        ]));
    };
    var $author$project$Components$CoverageRuleUsage$viewCoveredCharges = function(coveredCharges) {
        return $elm$core$List$isEmpty(coveredCharges) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Popover$view, _List_fromArray([
                $author$project$Ui$Popover$dark,
                $author$project$Ui$Popover$sm
            ]), _List_fromArray([
                $author$project$Ui$Icon$help(_List_Nil)
            ]), _List_fromArray([
                A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$ul, _List_fromArray([
                        $elm$html$Html$Attributes$class('timeline mb-0 mt-05 ml-1')
                    ]), A2($elm$core$List$map, $author$project$Components$CoverageRuleUsage$viewCoveredCharge, coveredCharges))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CoverageRuleUsage$view = function(coverageRuleUsage) {
        var remainingQuantity = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$CoverageRuleUsage$All$remainingItems(coverageRuleUsage));
        var itemName = $author$project$Api$Provider$CoverageRule$One$itemName($author$project$Api$Provider$CoverageRuleUsage$All$coverageRule(coverageRuleUsage));
        var remainingDescriptionPrefix = $elm$core$String$fromInt(remainingQuantity) + (' included ' + itemName);
        var description = function() {
            switch(remainingQuantity){
                case 0:
                    var remainingItemsUntil = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$CoverageRuleUsage$All$remainingItemsUntil(coverageRuleUsage));
                    return 'All included ' + (itemName + (' have been used until ' + remainingItemsUntil));
                case 1:
                    return remainingDescriptionPrefix + ' remains';
                default:
                    return remainingDescriptionPrefix + ' remain';
            }
        }();
        return A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$small
        ]), _List_fromArray([
            $elm$html$Html$text(description),
            $author$project$Utils$Html$noBreakSpace,
            $author$project$Components$CoverageRuleUsage$viewCoveredCharges($author$project$Api$Provider$CoverageRuleUsage$All$coveredCharges(coverageRuleUsage))
        ]));
    };
    var $author$project$Components$Admin$CoverageRules$Form$AttemptedEdit = {
        $: 6
    };
    var $author$project$Components$Admin$CoverageRules$Form$cannotBeEdited = F2(function(form, unpublishedForm) {
        var fields = $author$project$Utils$Form$fields(form);
        var ruleType = A2($elm$core$Maybe$andThen, $author$project$Components$Admin$CoverageRules$Form$ruleTypeIdToValue, fields.ag0);
        var isIncluded = A2($elm$core$Maybe$map, function(r) {
            return r === 'included';
        }, ruleType);
        return A2($elm$core$Maybe$withDefault, false, isIncluded) && fields.rc === 'charge_item' || !_Utils_eq(unpublishedForm, $elm$core$Maybe$Nothing);
    });
    var $author$project$Components$Admin$CoverageRules$Form$viewRuleActions = F2(function(form, unpublishedForm) {
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Edit rule'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedEdit),
                $author$project$Ui$Button$disabled(A2($author$project$Components$Admin$CoverageRules$Form$cannotBeEdited, form, unpublishedForm)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
            ]), _List_fromArray([
                $elm$html$Html$text('Edit')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Delete rule'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageRules$Form$AttemptedDelete(fields.aef)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete')
            ]))
        ]);
    });
    var $author$project$Components$Admin$CoverageRules$Form$viewSentence = function(model) {
        var unpublishedTagIfUnpublished = model.aG || model.ce ? A2($author$project$Ui$Typography$span, _List_Nil, $author$project$Components$Admin$CoverageRules$Form$unpublishedTag) : $author$project$Utils$Html$empty;
        var sentenceOptions = model.aG ? _List_fromArray([
            $author$project$Ui$Typography$strike,
            $author$project$Ui$Typography$gray
        ]) : _List_Nil;
        var emptySecondRow = A2($author$project$Ui$Grid$row, _List_Nil, _List_Nil);
        var _v0 = model.Ya ? _Utils_Tuple2(12, 0) : _Utils_Tuple2(10, 2);
        var gridSentenceSpace = _v0.a;
        var gridActionsSpace = _v0.b;
        var _v1 = _Utils_Tuple2(model.PU, model.L);
        var form = _v1.a;
        var editedForm = _v1.b;
        var sentenceRow = _List_fromArray([
            $author$project$Components$CoverageRuleSentence$view(A2($author$project$Components$Admin$CoverageRules$Form$sentenceRecordBuilder, true, form))
        ]);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(gridSentenceSpace)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, sentenceOptions, sentenceRow),
                    unpublishedTagIfUnpublished,
                    function() {
                        var _v2 = model.EY;
                        if (!_v2.$) {
                            var coverageRuleUsage = _v2.a;
                            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                $author$project$Components$CoverageRuleUsage$view(coverageRuleUsage)
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(gridActionsSpace),
                    $author$project$Ui$Grid$justifyRight
                ]), model.aG ? $author$project$Components$Admin$CoverageRules$Form$cancelDelete(form) : !model.Ya ? A2($author$project$Components$Admin$CoverageRules$Form$viewRuleActions, form, editedForm) : _List_Nil)
            ])),
            function() {
                if (!editedForm.$) {
                    var editedForm_ = editedForm.a;
                    return model.ce ? emptySecondRow : !model.Ya ? $author$project$Components$Admin$CoverageRules$Form$unpublishedSentence(editedForm_) : emptySecondRow;
                } else return emptySecondRow;
            }()
        ]));
    };
    var $author$project$Components$Admin$CoverageRules$Form$view = function(_v0) {
        var model = _v0;
        var _v1 = model.aI;
        switch(_v1){
            case 0:
                return $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm(model);
            case 1:
                return $author$project$Components$Admin$CoverageRules$Form$viewCreateOrEditForm(model);
            default:
                return $author$project$Components$Admin$CoverageRules$Form$viewSentence(model);
        }
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow = F2(function(ruleForm, index) {
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Admin$CoveragePlans$Rules$CoverageRuleFormMsg(index), $author$project$Components$Admin$CoverageRules$Form$view(ruleForm))
        ]));
    });
    var $author$project$Components$Admin$CoveragePlans$Rules$viewCategorizedCoverageRuleForms = F2(function(categories, coverageRuleFormsWithIndex) {
        return A2($elm$core$List$concatMap, function(category) {
            var rulesInThisCategory = A2($elm$core$List$filter, function(tuple) {
                return A2($author$project$Components$Admin$CoveragePlans$Rules$isRuleInCategory, tuple.a, category.aef);
            }, coverageRuleFormsWithIndex);
            return A2($elm$core$List$cons, A2($author$project$Ui$ListGroup$item, _List_fromArray([
                $author$project$Ui$ListGroup$style(4)
            ]), _List_fromArray([
                $elm$html$Html$text($elm$core$String$toUpper(category.zr))
            ])), A2($elm$core$List$map, function(tuple) {
                return A2($author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow, tuple.a, tuple.b);
            }, rulesInThisCategory));
        }, categories);
    });
    var $author$project$Ui$FontWeight$Normal = 1;
    var $author$project$Ui$Typography$FontWeight = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Ui$Typography$fontWeight = $author$project$Ui$Typography$FontWeight;
    var $author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageTooltip = A2($author$project$Ui$Typography$div, _List_fromArray([
        $author$project$Ui$Typography$pull(1)
    ]), _List_fromArray([
        A3($author$project$Ui$Tooltip$view, _List_Nil, 'Uncategorized rules are charge items that are not associated with a charge category. You can assign a category to your charge items under Admin -> Charges & Taxes.', _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $author$project$Ui$Icon$help(_List_Nil)
            ]))
        ])),
        $author$project$Utils$Html$noBreakSpace,
        A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$fontWeight(1)
        ]), _List_fromArray([
            $elm$html$Html$text('What are uncategorized coverage rules?')
        ]))
    ]));
    var $author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageRuleForms = function(ruleForms) {
        return $elm$core$List$isEmpty(ruleForms) ? _List_Nil : A2($elm$core$List$cons, A2($author$project$Ui$ListGroup$item, _List_fromArray([
            $author$project$Ui$ListGroup$style(4)
        ]), _List_fromArray([
            $elm$html$Html$text('UNCATEGORIZED'),
            $author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageTooltip
        ])), A2($elm$core$List$map, function(tuple) {
            return A2($author$project$Components$Admin$CoveragePlans$Rules$viewRuleFormRow, tuple.a, tuple.b);
        }, ruleForms));
    };
    var $author$project$Components$Admin$CoveragePlans$Rules$view = function(model) {
        var activeCoverageRuleFormsWithIndex = A2($elm$core$List$filter, function(tuple) {
            return !$author$project$Components$Admin$CoverageRules$Form$isReallyDeleted(tuple.a);
        }, A2($elm$core$List$indexedMap, F2(function(index, rule) {
            return _Utils_Tuple2(rule, index);
        }), model.acC));
        var categories = $author$project$Components$Admin$CoveragePlans$Rules$allCategories(activeCoverageRuleFormsWithIndex);
        var uncategorizedCoverageRuleFormsWithIndex = A2($elm$core$List$filter, function(tuple) {
            return _Utils_eq($author$project$Components$Admin$CoverageRules$Form$category(tuple.a), $elm$core$Maybe$Nothing);
        }, activeCoverageRuleFormsWithIndex);
        return A2($author$project$Ui$ListGroup$view, _List_Nil, _Utils_ap(A2($author$project$Components$Admin$CoveragePlans$Rules$viewCategorizedCoverageRuleForms, categories, activeCoverageRuleFormsWithIndex), _Utils_ap($author$project$Components$Admin$CoveragePlans$Rules$viewUncategorizedCoverageRuleForms(uncategorizedCoverageRuleFormsWithIndex), model.Ya ? _List_Nil : _List_fromArray([
            $author$project$Components$Admin$CoveragePlans$Rules$viewAddCoverageRuleButton
        ]))));
    };
    var $author$project$Components$Admin$CoveragePlans$Form$AddDocumentUpload = {
        $: 14
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$FileUploaded = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$File$Pdf = 2;
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$Save = {
        $: 3
    };
    var $author$project$Components$Admin$CoverageDocuments$UploadModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$CoverageDocuments$UploadModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(_Utils_eq(model.p1, $elm$core$Maybe$Nothing) ? 'Upload PDF Document' : 'Edit PDF Document')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Admin$CoverageDocuments$UploadModal$Save),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('File'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(4)
                    ]), _List_fromArray([
                        function() {
                            var _v1 = model.p1;
                            if (!_v1.$) {
                                var coverageDocument_ = _v1.a;
                                return A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$padding(6),
                                    $author$project$Ui$Typography$margin(21)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$margin(11)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text($author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument_))
                                    ]))
                                ]));
                            } else return $author$project$Ui$Form$File$view(_List_fromArray([
                                $author$project$Ui$Form$File$accept(2),
                                $author$project$Ui$Form$File$onInput($author$project$Components$Admin$CoverageDocuments$UploadModal$FileUploaded)
                            ]));
                        }()
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(4),
                        $author$project$Ui$Form$Group$required(true),
                        $author$project$Ui$Form$Group$label('Visible PDF File Name')
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(fields.PF),
                            $author$project$Ui$Form$Input$phi(true),
                            $author$project$Ui$Form$Input$placeholder('File Name'),
                            $author$project$Ui$Form$Input$autofocus(true),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoverageDocuments$UploadModal$FormUpdated, $author$project$Components$Admin$CoverageDocuments$UploadModal$FileName)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageDocuments$UploadModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save upload'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageDocuments$UploadModal$Save),
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$modal = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                var _v1 = model.fr;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var coverageDocument = _v2.a;
                    var deleteRequest = _v2.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Admin$CoverageDocuments$Form$DeleteHiConfirmClosed(coverageDocument), _List_fromArray([
                        $author$project$Components$HiConfirm$noun('document'),
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('Are you sure you want to delete ' + $author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument))
                        ])),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            model.ir ? A2($elm$html$Html$map, $author$project$Components$Admin$CoverageDocuments$Form$DocumentUploadModalMsg, $author$project$Components$Admin$CoverageDocuments$UploadModal$view(model.cN)) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$Delete = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$Edit = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$viewListActions = function(coverageDocument) {
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(2)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$pull(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit coverage document'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageDocuments$Form$Edit(coverageDocument))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete coverage document'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$CoverageDocuments$Form$Delete(coverageDocument))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Api$Provider$CoverageDocument$Shared$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$viewListItems = function(coverageDocument) {
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(10)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$externalHref, $author$project$Api$Provider$CoverageDocument$Shared$url(coverageDocument), _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$CoverageDocument$Shared$fileName(coverageDocument)),
                    $elm$html$Html$text('  '),
                    $author$project$Ui$Icon$launch(_List_fromArray([
                        $author$project$Ui$Icon$sm
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Components$Admin$CoverageDocuments$Form$modal(model),
            $elm$core$List$isEmpty(model.Mm) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, function(coverageDocument) {
                    return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        $author$project$Components$Admin$CoverageDocuments$Form$viewListItems(coverageDocument),
                        $author$project$Components$Admin$CoverageDocuments$Form$viewListActions(coverageDocument)
                    ]));
                }, model.Mm))
            ]))
        ]));
    };
    var $author$project$Components$Admin$CoveragePlans$Form$viewCoverageDocuments = function(model) {
        var _v0 = model.aef;
        if (!_v0.$) {
            var coverageDocumentList = function() {
                var _v1 = _Utils_Tuple2(model.Mm, model.Mn);
                if (!_v1.a.$ && !_v1.b.$) {
                    var coveragePlan = _v1.b.a;
                    return $author$project$Api$Provider$CoveragePlan$One$coverageDocuments(coveragePlan);
                } else return _List_Nil;
            }();
            var addButton = A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Upload pdf document'
                    }, _List_fromArray([
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$CoveragePlans$Form$AddDocumentUpload)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Upload Pdf Document')
                    ]))
                ]))
            ]));
            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Benefit Overview Documents')
                ])),
                A2($elm$html$Html$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$modal, model.Mm))),
                A2($author$project$Ui$ListGroup$view, _List_Nil, $elm$core$List$isEmpty(coverageDocumentList) ? _List_fromArray([
                    addButton
                ]) : _List_fromArray([
                    A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Admin$CoveragePlans$Form$CoverageDocumentsMsg, A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$view, model.Mm)))
                    ])),
                    addButton
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$CoveragePlans$Form$PlanSearched = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$ListGroup$Clearfix = {
        $: 1
    };
    var $author$project$Ui$ListGroup$clearfix = $author$project$Ui$ListGroup$Clearfix;
    var $author$project$Ui$ListGroup$Note = {
        $: 2
    };
    var $author$project$Ui$ListGroup$note = $author$project$Ui$ListGroup$Note;
    var $author$project$Components$Admin$CoveragePlans$Form$searchInput = function(planSearchQuery) {
        return A2($author$project$Ui$ListGroup$item, _List_fromArray([
            $author$project$Ui$ListGroup$clearfix,
            $author$project$Ui$ListGroup$note
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$onInput($author$project$Components$Admin$CoveragePlans$Form$PlanSearched),
                $author$project$Ui$Form$Input$placeholder('Search...'),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', planSearchQuery))
            ]))
        ]));
    };
    var $author$project$Components$Admin$CoveragePlans$Form$SelectedAllPlans = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $elm$html$Html$b = _VirtualDom_node('b');
    var $author$project$Components$Admin$CoveragePlans$Form$selectAllOption = function(selectAllPlans) {
        return A2($author$project$Ui$ListGroup$item, _List_fromArray([
            $author$project$Ui$ListGroup$clearfix,
            $author$project$Ui$ListGroup$note
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(selectAllPlans),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$CoveragePlans$Form$SelectedAllPlans)
            ]), _List_fromArray([
                A2($elm$html$Html$b, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(selectAllPlans ? 'Unselect All' : 'Select All')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$CoveragePlans$Form$PaginationMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Pagination$More$CurrentPage = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Pagination$More$currentPage = $author$project$Ui$Pagination$More$CurrentPage;
    var $author$project$Ui$Pagination$More$ItemsPerPage = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Pagination$More$itemsPerPage = $author$project$Ui$Pagination$More$ItemsPerPage;
    var $author$project$Ui$Pagination$More$OnClick = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Pagination$More$onClick = $author$project$Ui$Pagination$More$OnClick;
    var $author$project$Ui$Pagination$More$TotalCount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Pagination$More$totalCount = $author$project$Ui$Pagination$More$TotalCount;
    var $author$project$Ui$Pagination$More$defaultOptions = {
        bt: 0,
        fY: 0,
        Tk: false,
        zU: $elm$core$Maybe$Nothing,
        oQ: 0
    };
    var $author$project$Ui$Pagination$More$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var _int = option.a;
                    return _Utils_update(record, {
                        oQ: _int
                    });
                case 1:
                    var _int = option.a;
                    return _Utils_update(record, {
                        fY: _int
                    });
                case 2:
                    var _int = option.a;
                    return _Utils_update(record, {
                        bt: _int
                    });
                case 3:
                    var toMsg = option.a;
                    return _Utils_update(record, {
                        zU: $elm$core$Maybe$Just(toMsg)
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Tk: bool
                    });
            }
        }), $author$project$Ui$Pagination$More$defaultOptions, options);
    };
    var $author$project$Ui$Pagination$More$viewPageSpan = F3(function(label, maybeMsg, pageNumber) {
        var attributes = function() {
            if (!maybeMsg.$) {
                var msg = maybeMsg.a;
                return _List_fromArray([
                    $elm$html$Html$Events$onClick(msg(pageNumber))
                ]);
            } else return _List_Nil;
        }();
        return A2($elm$html$Html$span, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('clickable'), attributes), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Ui$Pagination$More$view = function(options) {
        var optionsRecord = $author$project$Ui$Pagination$More$optionsToRecord(options);
        if (optionsRecord.Tk) return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Spinner$view(_List_fromArray([
                $author$project$Ui$Spinner$small
            ]))
        ]));
        else {
            var totalRemaining = optionsRecord.oQ - optionsRecord.bt * optionsRecord.fY;
            if (totalRemaining < 0) return $author$project$Utils$Html$empty;
            else {
                var linkText = 'Show more (' + ($elm$core$String$fromInt(totalRemaining) + ' hidden)');
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Pagination$More$viewPageSpan, linkText, optionsRecord.zU, optionsRecord.bt + 1)
                ]));
            }
        }
    };
    var $author$project$Api$Pagination$viewAsShowMore = F2(function(options, _v0) {
        var model = _v0;
        return $author$project$Ui$Pagination$More$view(A2($elm$core$List$cons, $author$project$Ui$Pagination$More$totalCount(model.oQ), A2($elm$core$List$cons, $author$project$Ui$Pagination$More$itemsPerPage(model.fY), A2($elm$core$List$cons, $author$project$Ui$Pagination$More$currentPage(model.bt), A2($elm$core$List$cons, $author$project$Ui$Pagination$More$onClick($author$project$Api$Pagination$CurrentPageChanged), options)))));
    });
    var $author$project$Components$Admin$CoveragePlans$Form$showMoreItem = F2(function(totalRemaining, pagination) {
        return !!totalRemaining ? _List_fromArray([
            A2($author$project$Ui$ListGroup$item, _List_fromArray([
                $author$project$Ui$ListGroup$clearfix,
                $author$project$Ui$ListGroup$note
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Admin$CoveragePlans$Form$PaginationMsg, A2($author$project$Api$Pagination$viewAsShowMore, _List_Nil, pagination))
            ]))
        ]) : _List_Nil;
    });
    var $author$project$Components$Admin$CoveragePlans$Form$SelectedPlan = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$CoveragePlans$Form$planInCoveragePlan = F2(function(plans, plan) {
        return A2($elm$core$List$member, plan.aef, A2($elm$core$List$map, function(planRecord) {
            return planRecord.aef;
        }, plans));
    });
    var $author$project$Components$Admin$CoveragePlans$Form$viewPlan = F3(function(fields, selectAllPlans, plan) {
        return A2($author$project$Ui$ListGroup$item, _List_fromArray([
            $author$project$Ui$ListGroup$clearfix,
            $author$project$Ui$ListGroup$note
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(selectAllPlans || A2($author$project$Components$Admin$CoveragePlans$Form$planInCoveragePlan, fields.WO, plan)),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$CoveragePlans$Form$SelectedPlan(plan))
            ]), _List_fromArray([
                $elm$html$Html$text(plan.zr)
            ]))
        ]));
    });
    var $author$project$Components$Admin$CoveragePlans$Form$viewPlans = F2(function(model, form) {
        var _v0 = model.WO;
        if (_v0.$ === 3) {
            var headers = _v0.b;
            var searchItem = $author$project$Components$Admin$CoveragePlans$Form$searchInput(model.r9);
            if ($elm$core$List$length(model.gu) > 0) {
                var totalCount = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
                var totalRemaining = totalCount - $elm$core$List$length(model.gu);
                var fields = $author$project$Utils$Form$fields(form);
                return A2($author$project$Ui$ListGroup$view, _List_Nil, $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        searchItem,
                        $author$project$Components$Admin$CoveragePlans$Form$selectAllOption(model.sJ)
                    ]),
                    A2($elm$core$List$map, A2($author$project$Components$Admin$CoveragePlans$Form$viewPlan, fields, model.sJ), model.gu),
                    A2($author$project$Components$Admin$CoveragePlans$Form$showMoreItem, totalRemaining, model.af_)
                ])));
            } else return A2($author$project$Ui$ListGroup$view, _List_Nil, _List_fromArray([
                searchItem,
                A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('No plans found')
                ]))
            ]));
        } else return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]), _List_fromArray([
            $author$project$Ui$Spinner$view(_List_Nil)
        ]));
    });
    var $author$project$Components$Admin$CoveragePlans$Form$viewForm = F2(function(model, form) {
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Coverage Plan Name')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$CoveragePlans$Form$FormUpdated, $author$project$Components$Admin$CoveragePlans$Form$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Connected Membership Plans')
            ]), _List_fromArray([
                A2($author$project$Components$Admin$CoveragePlans$Form$viewPlans, model, form)
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Covered Charge Categories & Items')
            ])),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$html$Html$map($author$project$Components$Admin$CoveragePlans$Form$CoverageRulesMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$view, model.acC))),
            $author$project$Components$Admin$CoveragePlans$Form$viewCoverageDocuments(model)
        ]);
    });
    var $author$project$Components$Admin$CoveragePlans$Form$view = function(_v0) {
        var model = _v0;
        var newRecord = function() {
            var _v2 = model.aef;
            if (!_v2.$) return false;
            else return true;
        }();
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$onSubmit($author$project$Components$Admin$CoveragePlans$Form$AttemptedSubmit)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text(newRecord ? 'New Coverage Plan' : 'Edit Coverage Plan')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, function() {
                    var _v1 = model.PU;
                    if (!_v1.$) {
                        var form = _v1.a;
                        return A2($author$project$Components$Admin$CoveragePlans$Form$viewForm, model, form);
                    } else return _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]))
                    ]);
                }()),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$justifyCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Publish coverage plan'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit
                    ]), _List_fromArray([
                        $elm$html$Html$text('Publish')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$CoveragePlans$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$CoveragePlans$Form$view(model.PU))
            ]),
            $2: 'Admin | Coverage Plans'
        };
    };
    var $author$project$Pages$Admin$CoveragePlans$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CoveragePlans$Id_String$init,
        aeR: $author$project$Pages$Admin$CoveragePlans$Id_String$load,
        ag3: $author$project$Pages$Admin$CoveragePlans$Id_String$save,
        ahE: $author$project$Pages$Admin$CoveragePlans$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$CoveragePlans$Id_String$update,
        aid: $author$project$Pages$Admin$CoveragePlans$Id_String$view
    });
    var $author$project$Pages$Admin$CoveragePlans$New$CoveragePlanFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$CoveragePlans$New$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var _v2 = A4($author$project$Components$Admin$CoveragePlans$Form$init, apiClient, session, practice, $elm$core$Maybe$Nothing);
        var form = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$CoveragePlans$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$CoveragePlans$New$save = F2(function(_v0, shared) {
        var form = _v0.PU;
        return A2($author$project$Components$Admin$CoveragePlans$Form$save, form, shared);
    });
    var $author$project$Pages$Admin$CoveragePlans$New$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$CoveragePlans$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$Admin$CoveragePlans$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$CoveragePlans$Form$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Admin$CoveragePlans$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$CoveragePlans$Form$view(model.PU))
            ]),
            $2: 'Admin | Coverage Plans'
        };
    };
    var $author$project$Pages$Admin$CoveragePlans$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CoveragePlans$New$init,
        aeR: $author$project$Pages$Admin$CoveragePlans$New$load,
        ag3: $author$project$Pages$Admin$CoveragePlans$New$save,
        ahE: $author$project$Pages$Admin$CoveragePlans$New$subscriptions,
        aaO: $author$project$Pages$Admin$CoveragePlans$New$update,
        aid: $author$project$Pages$Admin$CoveragePlans$New$view
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$GotList = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$fetchList = function(model) {
        return A3($author$project$Api$Provider$CoveragePlan$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Pages$Admin$CoveragePlans$Top$GotList);
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var query = _v3.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: apiClient,
            $8: $elm$core$Maybe$Nothing,
            dS: $elm$core$Set$empty,
            i$: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: $author$project$Api$Sort$initFromQuery(query)
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$CoveragePlans$Top$fetchList(model));
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$subscriptions = function(model) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed), $author$project$Api$Provider$CoveragePlan$All$id), model.$8));
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$Deleted = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$CoveragePlan$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CoveragePlan$coveragePlanPath(id_)));
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__CoveragePlans__Top)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        i$: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    i$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, id, model.dS),
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$CoveragePlans$Top$fetchList(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Coverage plan successfully deleted')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, id, model.dS)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$CoveragePlans$Top$fetchList(newModel),
                    $author$project$Pages$Admin$CoveragePlans$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$CoveragePlans$Top$fetchList(newModel),
                    $author$project$Pages$Admin$CoveragePlans$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 4:
                var deletingItem = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Just(deletingItem)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing,
                    dS: A2($elm$core$Set$insert, id, model.dS)
                }), A3($author$project$Api$Provider$CoveragePlan$delete, model.Ej, id, $author$project$Pages$Admin$CoveragePlans$Top$Deleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v3.a;
                var searchInputCmd = _v3.b;
                var searchInputEvent = _v3.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v4 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            i$: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$CoveragePlans$Top$fetchList(qModel),
                            $author$project$Pages$Admin$CoveragePlans$Top$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$SortTable = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', false, 'Name'),
        A3($author$project$Api$Column$init, 'charges', false, 'Included charges')
    ]);
    var $author$project$Pages$Admin$CoveragePlans$Top$Delete = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$viewCoverageRule = function(coverageRule) {
        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            A2($author$project$Components$CoverageRuleDescription$view, $author$project$Components$CoverageRuleDescription$One(coverageRule), false)
        ]));
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$viewItem = F2(function(deletingItems, coveragePlan) {
        var id = $author$project$Api$Provider$CoveragePlan$All$id(coveragePlan);
        var loading = A2($elm$core$Set$member, id, deletingItems);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$CoveragePlan$All$name(coveragePlan))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Admin$CoveragePlans$Top$viewCoverageRule, $author$project$Api$Provider$CoveragePlan$All$coverageRules(coveragePlan))),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String({
                        aef: id
                    }), _List_fromArray([
                        $author$project$Ui$Link$sm,
                        $author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete coverage plan'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$CoveragePlans$Top$Delete(coveragePlan)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$CoveragePlans$Top$viewPanelTable = function(model) {
        var _v0 = function() {
            var _v1 = model.i$;
            if (_v1.$ === 3) {
                var items_ = _v1.a;
                return _Utils_Tuple2(false, items_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var items = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('No coverage plans found.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$CoveragePlans$Top$SortTable)), $author$project$Pages$Admin$CoveragePlans$Top$columns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ])
        ])), A2($elm$core$List$map, $author$project$Pages$Admin$CoveragePlans$Top$viewItem(model.dS), items), _List_Nil);
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.$8;
                    if (!_v0.$) {
                        var item = _v0.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$CoveragePlans$Top$HiConfirmClosed($author$project$Api$Provider$CoveragePlan$All$id(item)), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('coverage plan'),
                            $author$project$Components$HiConfirm$detail($author$project$Api$Provider$CoveragePlan$All$name(item) + ' and remove it from all existing plans')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween,
                            $author$project$Ui$Element$itemsCenter
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Coverage Plans')
                            ])),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CoveragePlans__New, _List_fromArray([
                                $author$project$Ui$Link$buttonDefault,
                                $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('New Coverage Plan')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(12)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Admin$CoveragePlans$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                                ]))
                            ]))
                        ]))
                    ])),
                    $author$project$Pages$Admin$CoveragePlans$Top$viewPanelTable(model),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$CoveragePlans$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.i$))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Coverage Plans'
        };
    };
    var $author$project$Pages$Admin$CoveragePlans$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CoveragePlans$Top$init,
        aeR: $author$project$Pages$Admin$CoveragePlans$Top$load,
        ag3: $author$project$Pages$Admin$CoveragePlans$Top$save,
        ahE: $author$project$Pages$Admin$CoveragePlans$Top$subscriptions,
        aaO: $author$project$Pages$Admin$CoveragePlans$Top$update,
        aid: $author$project$Pages$Admin$CoveragePlans$Top$view
    });
    var $author$project$Pages$Admin$CreditCategories$GotCreditCategories = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$CreditCategory$creditCategoriesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'credit_categories'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$CreditCategory$All$CreditCategory = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CreditCategory$Shared$CreditCategory = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CreditCategory$Shared$Record = F7(function(id, name, canSetAmount, amountInCents, canSetExpiration, expiresInDays, isDestroyable) {
        return {
            Jh: amountInCents,
            KT: canSetAmount,
            KU: canSetExpiration,
            Pi: expiresInDays,
            aef: id,
            R1: isDestroyable,
            zr: name
        };
    });
    var $author$project$Api$Provider$CreditCategory$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'expires_in_days', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_set_expiration', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_set_amount', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CreditCategory$Shared$Record))))))));
    var $author$project$Api$Provider$CreditCategory$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CreditCategory$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CreditCategory$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CreditCategory$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CreditCategory$listDefaults = {
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Provider$CreditCategory$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$CreditCategory$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$CreditCategory$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CreditCategory$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$CreditCategory$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$CreditCategory$creditCategoriesPath)));
    });
    var $author$project$Pages$Admin$CreditCategories$fetchCreditCategories = function(model) {
        return A3($author$project$Api$Provider$CreditCategory$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Pages$Admin$CreditCategories$GotCreditCategories);
    };
    var $author$project$Pages$Admin$CreditCategories$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var query = _v3.Bz;
        var model = {
            Ej: apiClient,
            cO: $author$project$Api$Data$Loading,
            MB: $elm$core$Maybe$Nothing,
            dP: $elm$core$Set$empty,
            ie: $elm$core$Maybe$Nothing,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            agq: A2($elm$core$Dict$get, 'q', query),
            sG: $author$project$Ui$SearchInput$init(A2($elm$core$Dict$get, 'q', query)),
            ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$initFromQuery(query))
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model));
    });
    var $author$project$Pages$Admin$CreditCategories$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$CreditCategories$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit = {
        $: 3
    };
    var $author$project$Pages$Admin$CreditCategories$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CreditCategories$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit)), model.MB)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$CreditCategories$HiConfirmClosed), model.ie))
        ]));
    };
    var $author$project$Pages$Admin$CreditCategories$CreditCategoryDeleted = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CreditCategories$SearchInputMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$CreditCategory$creditCategoryPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$CreditCategory$creditCategoriesPath);
    };
    var $author$project$Api$Provider$CreditCategory$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CreditCategory$creditCategoryPath(id_)));
    });
    var $author$project$Api$Provider$CreditCategory$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$CreditCategory$All$amountInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CreditCategory$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$CreditCategory$Shared$canSetAmount = function(_v0) {
        var record = _v0;
        return record.KT;
    };
    var $author$project$Api$Provider$CreditCategory$All$canSetAmount = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CreditCategory$Shared$canSetAmount(shared);
    };
    var $author$project$Api$Provider$CreditCategory$Shared$canSetExpiration = function(_v0) {
        var record = _v0;
        return record.KU;
    };
    var $author$project$Api$Provider$CreditCategory$All$canSetExpiration = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CreditCategory$Shared$canSetExpiration(shared);
    };
    var $author$project$Api$Provider$CreditCategory$Shared$expiresInDays = function(_v0) {
        var record = _v0;
        return record.Pi;
    };
    var $author$project$Api$Provider$CreditCategory$All$expiresInDays = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CreditCategory$Shared$expiresInDays(shared);
    };
    var $author$project$Api$Provider$CreditCategory$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$CreditCategory$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CreditCategory$Shared$name(shared);
    };
    var $author$project$Pages$Admin$CreditCategories$formFieldsFromCreditCategory = function(creditCategory) {
        return {
            Jh: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$CreditCategory$All$amountInCents(creditCategory)),
            KT: $author$project$Api$Provider$CreditCategory$All$canSetAmount(creditCategory),
            KU: $author$project$Api$Provider$CreditCategory$All$canSetExpiration(creditCategory),
            Pi: $author$project$Api$Provider$CreditCategory$All$expiresInDays(creditCategory),
            zr: $author$project$Api$Provider$CreditCategory$All$name(creditCategory)
        };
    };
    var $author$project$Pages$Admin$CreditCategories$formFieldsInit = {
        Jh: $elm$core$Maybe$Nothing,
        KT: true,
        KU: true,
        Pi: $elm$core$Maybe$Nothing,
        zr: ''
    };
    var $author$project$Pages$Admin$CreditCategories$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var _int = field.a;
                return _Utils_update(fields, {
                    Jh: _int
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    Pi: $elm$core$String$toInt(string)
                });
        }
    });
    var $author$project$Pages$Admin$CreditCategories$NameValidation = 0;
    var $author$project$Pages$Admin$CreditCategories$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Api$Provider$CreditCategory$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CreditCategory$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CreditCategory$Shared$id(shared);
    };
    var $author$project$Api$Provider$CreditCategory$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CreditCategory$Shared$name(shared);
    };
    var $author$project$Pages$Admin$CreditCategories$CreditCategoryCreated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$CreditCategory$One$CreditCategory = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CreditCategory$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CreditCategory$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CreditCategory$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('credit_category', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), _Utils_ap(function() {
                var _v0 = fields.Jh;
                if (!_v0.$) {
                    var amountInCents_ = _v0.a;
                    return _List_fromArray([
                        _Utils_Tuple2('amount_in_cents', $author$project$Currency$encode(amountInCents_))
                    ]);
                } else return _List_Nil;
            }(), function() {
                var _v1 = fields.Pi;
                if (!_v1.$) {
                    var expiresInDays_ = _v1.a;
                    return _List_fromArray([
                        _Utils_Tuple2('expires_in_days', $elm$json$Json$Encode$int(expiresInDays_))
                    ]);
                } else return _List_Nil;
            }()))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CreditCategory$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CreditCategory$creditCategoriesPath)));
    });
    var $author$project$Pages$Admin$CreditCategories$createCreditCategory = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            Jh: fields.Jh,
            Pi: fields.Pi,
            zr: fields.zr
        };
        return A3($author$project$Api$Provider$CreditCategory$create, apiClient, apiFields, $author$project$Pages$Admin$CreditCategories$CreditCategoryCreated);
    });
    var $author$project$Pages$Admin$CreditCategories$CreditCategoryUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$CreditCategory$update = F4(function(apiClient, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('credit_category', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Jh)),
                _Utils_Tuple2('expires_in_days', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Pi))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$CreditCategory$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CreditCategory$creditCategoryPath(id_))));
    });
    var $author$project$Pages$Admin$CreditCategories$updateCreditCategory = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            Jh: fields.Jh,
            Pi: fields.Pi,
            zr: fields.zr
        };
        return A4($author$project$Api$Provider$CreditCategory$update, apiClient, id, apiFields, $author$project$Pages$Admin$CreditCategories$CreditCategoryUpdated);
    });
    var $author$project$Pages$Admin$CreditCategories$saveCreditCategory = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Pages$Admin$CreditCategories$updateCreditCategory, apiClient, id_, formFields);
        } else return A2($author$project$Pages$Admin$CreditCategories$createCreditCategory, apiClient, formFields);
    });
    var $author$project$Pages$Admin$CreditCategories$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__CreditCategories)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Admin$CreditCategories$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cO: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cO: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    MB: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Admin$CreditCategories$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var creditCategory = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    MB: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$CreditCategory$All$id(creditCategory)), $author$project$Utils$Form$init($author$project$Pages$Admin$CreditCategories$formFieldsFromCreditCategory(creditCategory)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    MB: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var field = msg.a;
                var _v2 = model.MB;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var creditCategory = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$CreditCategories$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        MB: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, creditCategory))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var form = msg.a;
                var id = msg.b;
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$CreditCategories$formFieldsValidator, form);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        MB: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Admin$CreditCategories$saveCreditCategory, model.Ej, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        MB: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 5:
                var creditCategory = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ie: $elm$core$Maybe$Just(creditCategory)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v6 = model.MB;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var id = _v7.a;
                    var form = _v7.b;
                    if (response.$ === 3) {
                        var creditCategory = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            cO: $author$project$Api$Data$Loading,
                            MB: $elm$core$Maybe$Nothing
                        }), $author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$CreditCategory$One$name(creditCategory))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        MB: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                var _v9 = model.MB;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) {
                        var creditCategory = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            cO: $author$project$Api$Data$Loading,
                            MB: $elm$core$Maybe$Nothing
                        }), $author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$CreditCategory$One$name(creditCategory) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        MB: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var creditCategory = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            cO: $author$project$Api$Data$Loading,
                            dP: A2($elm$core$Set$remove, $author$project$Api$Provider$CreditCategory$All$id(creditCategory), model.dP)
                        }), $author$project$Pages$Admin$CreditCategories$fetchCreditCategories(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$CreditCategory$All$name(creditCategory) + ' was successfully removed.')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dP: A2($elm$core$Set$remove, $author$project$Api$Provider$CreditCategory$All$id(creditCategory), model.dP)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 10:
                var creditCategory = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$CreditCategory$All$id(creditCategory);
                    return _Utils_Tuple3(_Utils_update(model, {
                        dP: A2($elm$core$Set$insert, id, model.dP),
                        ie: $elm$core$Maybe$Nothing
                    }), A3($author$project$Api$Provider$CreditCategory$delete, model.Ej, id, $author$project$Pages$Admin$CreditCategories$CreditCategoryDeleted(creditCategory)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ie: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    cO: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$CreditCategories$fetchCreditCategories(newModel),
                    $author$project$Pages$Admin$CreditCategories$updateUrl(newModel)
                ])), _List_Nil);
            case 13:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$CreditCategories$fetchCreditCategories(newModel),
                    $author$project$Pages$Admin$CreditCategories$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v13 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v13.a;
                var searchInputCmd = _v13.b;
                var searchInputEvent = _v13.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v14 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            cO: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$CreditCategories$fetchCreditCategories(qModel),
                            $author$project$Pages$Admin$CreditCategories$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v14.a;
                var cmd = _v14.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$CreditCategories$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$CreditCategories$NewCreditCategory = {
        $: 1
    };
    var $author$project$Pages$Admin$CreditCategories$PaginationMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Admin$CreditCategories$AmountInCents = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$CreditCategories$ExpiresInDays = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$CreditCategories$FormUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$CreditCategories$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$CreditCategories$SaveCreditCategory = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$CreditCategories$viewCreditCategoryModal = F3(function(id, form, creditCategory) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Credit Category',
            Tk: _Utils_eq(creditCategory, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$CreditCategories$CancelCreditCategoryEdit,
            Vn: $author$project$Pages$Admin$CreditCategories$SaveCreditCategory(form)
        };
        var _v0 = $author$project$Utils$Form$fields(form);
        var name = _v0.zr;
        var amountInCents = _v0.Jh;
        var expiresInDays = _v0.Pi;
        var canSetAmount = _v0.KT;
        var canSetExpiration = _v0.KU;
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(name),
                    $author$project$Ui$Form$Input$placeholder('Refer a Friend'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Amount')
            ]), _List_fromArray([
                $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$value(amountInCents),
                    $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$AmountInCents)),
                    $author$project$Ui$Form$CurrencyInput$placeholder('25.00'),
                    $author$project$Ui$Form$CurrencyInput$disabled(!canSetAmount)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Expiration')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, expiresInDays))),
                        $author$project$Ui$Form$Input$placeholder('60'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$CreditCategories$FormUpdated, $author$project$Pages$Admin$CreditCategories$ExpiresInDays)),
                        $author$project$Ui$Form$Input$disabled(!canSetExpiration)
                    ])),
                    $author$project$Ui$Form$Input$addon(_List_fromArray([
                        $elm$html$Html$text('days')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$CreditCategories$SortTable = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Admin$CreditCategories$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'Name'),
        A3($author$project$Api$Column$init, 'amount', false, 'Amount'),
        A3($author$project$Api$Column$init, 'expiration', false, 'Expiration')
    ]);
    var $author$project$Pages$Admin$CreditCategories$help = _List_fromArray([
        $elm$html$Html$text('Credit categories let you easily create and track similar credits by prefilling repeated fields. '),
        $elm$html$Html$text('You cannot add credits to an account without first adding credit categories. '),
        $elm$html$Html$text('Amount and expiration are optional fields. '),
        $elm$html$Html$text('For more information see our '),
        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/account-configuration/adding-and-applying-credits', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('help docs')
        ])),
        $elm$html$Html$text('.')
    ]);
    var $author$project$Pages$Admin$CreditCategories$DeleteCreditCategory = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$CreditCategories$EditCreditCategory = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$CreditCategory$Shared$isDestroyable = function(_v0) {
        var record = _v0;
        return record.R1;
    };
    var $author$project$Api$Provider$CreditCategory$All$isDestroyable = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CreditCategory$Shared$isDestroyable(shared);
    };
    var $author$project$Pages$Admin$CreditCategories$viewCreditCategory = F2(function(deletingCreditCategories, creditCategory) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$CreditCategory$All$name(creditCategory))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Provider$CreditCategory$All$amountInCents(creditCategory);
                    if (!_v0.$) {
                        var amountInCents = _v0.a;
                        return $elm$html$Html$text($author$project$Utils$Currency$fromInt(amountInCents));
                    } else return $elm$html$Html$text('No prefilled amount');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v1 = $author$project$Api$Provider$CreditCategory$All$expiresInDays(creditCategory);
                    if (!_v1.$) {
                        var expiresInDays = _v1.a;
                        return $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'day', expiresInDays));
                    } else return $elm$html$Html$text('Does not expire');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit credit category'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$CreditCategories$EditCreditCategory(creditCategory)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    function() {
                        if ($author$project$Api$Provider$CreditCategory$All$isDestroyable(creditCategory)) {
                            var id = $author$project$Api$Provider$CreditCategory$All$id(creditCategory);
                            var loading = A2($elm$core$Set$member, id, deletingCreditCategories);
                            return A3($author$project$Ui$Button$view, {
                                abP: 'Delete credit category'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$size(0),
                                $author$project$Ui$Button$loading(loading),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$CreditCategories$DeleteCreditCategory(creditCategory)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Delete')
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$CreditCategories$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.cO;
            if (_v1.$ === 3) {
                var creditCategories_ = _v1.a;
                return _Utils_Tuple2(false, creditCategories_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var creditCategories = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, $author$project$Pages$Admin$CreditCategories$help),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb2
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Admin$CreditCategories$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                ]))
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('None, add a category to be able to create credits.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$CreditCategories$SortTable)), $author$project$Pages$Admin$CreditCategories$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textRight
                        ]), _List_fromArray([
                            A3($author$project$Ui$Tooltip$view, _List_Nil, 'Upload from CSV', _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Credits__Upload, _List_fromArray([
                                    $author$project$Ui$Link$icon($author$project$Ui$Icon$upload),
                                    $author$project$Ui$Link$ariaLabel('Upload')
                                ]), _List_Nil)
                            ]))
                        ]))
                    ]))
                ])
            ])), A2($elm$core$List$map, $author$project$Pages$Admin$CreditCategories$viewCreditCategory(model.dP), creditCategories), _List_Nil)
        ]);
    };
    var $author$project$Pages$Admin$CreditCategories$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.MB;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        var form = _v1.b;
                        var creditCategory = _v1.c;
                        return A3($author$project$Pages$Admin$CreditCategories$viewCreditCategoryModal, id, form, creditCategory);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.ie;
                    if (!_v2.$) {
                        var creditCategory = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$CreditCategories$HiConfirmClosed(creditCategory), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('credit category'),
                            $author$project$Components$HiConfirm$detail($author$project$Api$Provider$CreditCategory$All$name(creditCategory) + '. This will not affect outstanding credits')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            $elm$html$Html$text('Credit Categories')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Create new credit category'
                            }, _List_fromArray([
                                $author$project$Ui$Button$default,
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$CreditCategories$NewCreditCategory),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('New Credit Category')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Admin$CreditCategories$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$CreditCategories$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Credit Categories'
        };
    };
    var $author$project$Pages$Admin$CreditCategories$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$CreditCategories$init,
        aeR: $author$project$Pages$Admin$CreditCategories$load,
        ag3: $author$project$Pages$Admin$CreditCategories$save,
        ahE: $author$project$Pages$Admin$CreditCategories$subscriptions,
        aaO: $author$project$Pages$Admin$CreditCategories$update,
        aid: $author$project$Pages$Admin$CreditCategories$view
    });
    var $author$project$Api$Upload$Resource$Credit = 0;
    var $author$project$Pages$Admin$Credits$Upload$UploadFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$Credits$Upload$init = F4(function(_v0, _v1, shared, _v2) {
        var _v3 = A4($author$project$Components$Upload$Form$init, shared.HO, shared.Ej, 0, $elm$core$Maybe$Nothing);
        var uploadForm = _v3.a;
        var uploadFormCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: uploadForm
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
    });
    var $author$project$Pages$Admin$Credits$Upload$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Credits$Upload$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Credits$Upload$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Upload$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$Admin$Credits$Upload$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Upload$Form$update, model.Ej, subMsg, model.PU);
        var uploadForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: uploadForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsgs);
    });
    var $author$project$Pages$Admin$Credits$Upload$viewBody = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Import Patient Credits Information')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$Upload$Form$view, model.Ej, model.PU))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Credits$Upload$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$Upload$Form$modal, model.Ej, model.PU)),
                $author$project$Pages$Admin$Credits$Upload$viewBody(model)
            ]),
            $2: 'Admin | Credits'
        };
    };
    var $author$project$Pages$Admin$Credits$Upload$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Credits$Upload$init,
        aeR: $author$project$Pages$Admin$Credits$Upload$load,
        ag3: $author$project$Pages$Admin$Credits$Upload$save,
        ahE: $author$project$Pages$Admin$Credits$Upload$subscriptions,
        aaO: $author$project$Pages$Admin$Credits$Upload$update,
        aid: $author$project$Pages$Admin$Credits$Upload$view
    });
    var $author$project$Pages$Admin$DataExport$Id_String$GotDataExports = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$DataExportGroup$dataExportGroupsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'data_export_groups'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$DataExportGroup$dataExportGroupPath = function(dataExportGroupId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            dataExportGroupId
        ]), $author$project$Api$Provider$DataExportGroup$dataExportGroupsPath);
    };
    var $author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath = function(dataExportGroupId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'data_exports'
        ]), $author$project$Api$Provider$DataExportGroup$dataExportGroupPath(dataExportGroupId));
    };
    var $author$project$Api$Provider$DataExport$All$DataExport = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$DataExport$Shared$DataExport = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DataExport$Shared$Record = F8(function(id, exportFileName, encrypted, status, exportedAt, errorMessage, exportGenerated, dataExportConfiguration) {
        return {
            M0: dataExportConfiguration,
            OO: encrypted,
            O4: errorMessage,
            Pl: exportFileName,
            Pm: exportGenerated,
            Pn: exportedAt,
            aef: id,
            ahy: status
        };
    });
    var $author$project$Api$Provider$DataExportConfiguration$Shared$DataExportConfiguration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DataExportConfiguration$Shared$Record = function(id) {
        return function(enabled) {
            return function(contactEmail) {
                return function(contactPhone) {
                    return function(destination) {
                        return function(sftpHost) {
                            return function(sftpPort) {
                                return function(sftpUsername) {
                                    return function(s3Bucket) {
                                        return function(s3Region) {
                                            return function(encryptionKey) {
                                                return function(encryptionRecipient) {
                                                    return function(testExportFileName) {
                                                        return function(incrementalMode) {
                                                            return function(excludeDefaultTables) {
                                                                return function(manualExportPerformed) {
                                                                    return function(fileNameFormat) {
                                                                        return {
                                                                            L0: contactEmail,
                                                                            L2: contactPhone,
                                                                            NS: destination,
                                                                            OM: enabled,
                                                                            OP: encryptionKey,
                                                                            OQ: encryptionRecipient,
                                                                            O9: excludeDefaultTables,
                                                                            PG: fileNameFormat,
                                                                            aef: id,
                                                                            Ra: incrementalMode,
                                                                            TB: manualExportPerformed,
                                                                            Zl: s3Bucket,
                                                                            Zm: s3Region,
                                                                            Z4: sftpHost,
                                                                            Z5: sftpPort,
                                                                            Z6: sftpUsername,
                                                                            $X: testExportFileName
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_name_format', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'manual_export_performed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exclude_default_tables', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'incremental_mode', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'test_export_file_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'encryption_recipient', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'encryption_key', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 's3_region', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 's3_bucket', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sftp_username', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sftp_port', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sftp_host', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'destination', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contact_phone', $elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contact_email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportConfiguration$Shared$Record))))))))))))))))));
    var $author$project$Api$Provider$DataExportConfiguration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExportConfiguration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DataExport$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'data_export_configuration', $author$project$Api$Provider$DataExportConfiguration$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'export_generated', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exported_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'encrypted', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'export_file_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$Shared$Record)))))))));
    var $author$project$Api$Provider$DataExport$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExport$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DataExport$All$Record = function(entityName) {
        return {
            O0: entityName
        };
    };
    var $author$project$Api$Provider$DataExport$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'entity_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$All$Record));
    var $author$project$Api$Provider$DataExport$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExport$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExport$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExport$All$DataExport)));
    var $author$project$Api$Provider$DataExportGroup$DataExport$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$DataExportGroup$DataExport$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$DataExportGroup$DataExport$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$DataExportGroup$DataExport$list = F4(function(apiClient, dataExportGroupId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$DataExportGroup$DataExport$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath(dataExportGroupId))));
    });
    var $author$project$Pages$Admin$DataExport$Id_String$fetchDataExports = function(model) {
        return A4($author$project$Api$Provider$DataExportGroup$DataExport$list, model.Ej, model.aef, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                ahs: model.ahs
            });
        }, $author$project$Pages$Admin$DataExport$Id_String$GotDataExports);
    };
    var $author$project$Pages$Admin$DataExport$Id_String$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var params = _v2.VU;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: shared.Ej,
            M2: $author$project$Api$Data$Loading,
            aef: params.aef,
            F3: $author$project$Shared$isHintAdmin(shared),
            af_: $author$project$Api$Pagination$initFromQuery(query),
            agq: q,
            jO: $elm$core$Maybe$Nothing,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: $author$project$Api$Sort$initFromQuery(query),
            HO: shared.HO
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(model));
    });
    var $author$project$Pages$Admin$DataExport$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$DataExport$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close = {
        $: 0
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close);
    };
    var $author$project$Pages$Admin$DataExport$Id_String$subscriptions = function(model) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$subscriptions, model.jO)));
    };
    var $author$project$Pages$Admin$DataExport$Id_String$GotSignedFileUrl = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$init = F2(function(dataExportGroupId, dataExport) {
        return {
            hS: false,
            w7: dataExport,
            E5: dataExportGroupId,
            nX: $author$project$Api$Data$NotAsked
        };
    });
    var $author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath = F2(function(dataExportGroupId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$DataExportGroup$DataExport$dataExportsPath(dataExportGroupId));
    });
    var $author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrlDecoder = A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrl = F4(function(apiClient, dataExportGroupId, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrlDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_file_url'
        ]), A2($author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath, dataExportGroupId, id_))));
    });
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Closed = 1;
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$GotRemoveResponse = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$None = 0;
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Removed = 2;
    var $author$project$Api$Provider$DataExport$Shared$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Provider$DataExport$Shared$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExport$Shared$record, function($) {
        return $.aef;
    });
    var $author$project$Api$Provider$DataExport$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExport$Shared$id(shared);
    };
    var $author$project$Api$Provider$DataExport$One$DataExport = 0;
    var $author$project$Api$Provider$DataExport$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$DataExportGroup$DataExport$removeFromDestination = F4(function(apiClient, dataExportGroupId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$DataExport$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'remove_from_destination'
        ]), A2($author$project$Api$Provider$DataExportGroup$DataExport$dataExportPath, dataExportGroupId, id))));
    });
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                return model.hS ? {
                    EQ: A4($author$project$Api$Provider$DataExportGroup$DataExport$removeFromDestination, apiClient, model.E5, $author$project$Api$Provider$DataExport$All$id(model.w7), $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$GotRemoveResponse),
                    adu: 0,
                    zi: _Utils_update(model, {
                        nX: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        nX: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Export removed.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        nX: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var bool = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        hS: bool
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Pages$Admin$DataExport$Id_String$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__DataExport__Id_String({
                aef: model.aef
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Admin$DataExport$Id_String$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        M2: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    M2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(newModel),
                    $author$project$Pages$Admin$DataExport$Id_String$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(newModel),
                    $author$project$Pages$Admin$DataExport$Id_String$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var dataExportId = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$DataExportGroup$DataExport$signedFileUrl, model.Ej, model.aef, dataExportId, $author$project$Pages$Admin$DataExport$Id_String$GotSignedFileUrl), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(url), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var dataExport = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    jO: $elm$core$Maybe$Just(A2($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$init, model.aef, dataExport))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v3 = model.jO;
                if (!_v3.$) {
                    var removeFromDestinationModal = _v3.a;
                    var result = A3($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$update, model.Ej, subMsg, removeFromDestinationModal);
                    var _v4 = function() {
                        var _v5 = result.adu;
                        switch(_v5){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(result.zi), $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Pages$Admin$DataExport$Id_String$fetchDataExports(model));
                        }
                    }();
                    var updatedRemoveFromDestinationModal = _v4.a;
                    var cmd = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        jO: updatedRemoveFromDestinationModal
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg, result.EQ)
                    ])), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$DataExport$Id_String$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Remove = {
        $: 1
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$ConfirmUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewConfirmInput = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(model.hS),
                $author$project$Ui$Form$Checkbox$required(true),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$ConfirmUpdated)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('By checking this box I confirm that I have verified that the files to be removed'),
                    $elm$html$Html$text('and the destination server accurate.')
                ]))
            ])),
            $author$project$Utils$FormErrors$view(model.hS ? _List_Nil : _List_fromArray([
                'Please confirm that the files to be removed and the destination server and path are accurate.'
            ]))
        ]));
    };
    var $author$project$Api$Provider$DataExport$Shared$dataExportConfiguration = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExport$Shared$record, function($) {
        return $.M0;
    });
    var $author$project$Api$Provider$DataExport$All$dataExportConfiguration = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExport$Shared$dataExportConfiguration(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$destination = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.NS;
    });
    var $author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.Zl;
    });
    var $author$project$Api$Provider$DataExportConfiguration$Shared$s3Region = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.Zm;
    });
    var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.Z4;
    });
    var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.Z5;
    });
    var $author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.Z6;
    });
    var $author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription = function(dataExportConfiguration) {
        var _v0 = $author$project$Api$Provider$DataExportConfiguration$Shared$destination(dataExportConfiguration);
        switch(_v0){
            case 'sftp':
                return 'sftp://' + (A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername(dataExportConfiguration)) + ('@' + (A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost(dataExportConfiguration)) + (':' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort(dataExportConfiguration)))))));
            case 's3':
                return 's3://' + (A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$DataExportConfiguration$Shared$s3Region(dataExportConfiguration)) + ('/' + A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(dataExportConfiguration))));
            default:
                return 'unknown destination';
        }
    };
    var $author$project$Api$Provider$DataExport$All$entityName = function(_v0) {
        var record = _v0.b;
        return record.O0;
    };
    var $author$project$Api$Provider$DataExport$Shared$exportFileName = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExport$Shared$record, function($) {
        return $.Pl;
    });
    var $author$project$Api$Provider$DataExport$All$exportFileName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExport$Shared$exportFileName(shared);
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewPreview = function(dataExport) {
        var dataExportConfiguration = $author$project$Api$Provider$DataExport$All$dataExportConfiguration(dataExport);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('mb-2')
            ]), _List_fromArray([
                $elm$html$Html$text('The platform will remove the following files from the given destination.')
            ])),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Entity Name: ')
            ])),
            $elm$html$Html$text($author$project$Api$Provider$DataExport$All$entityName(dataExport)),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Destination: ')
            ])),
            $elm$html$Html$text($author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Files: ')
            ])),
            A2($elm$html$Html$ul, _List_Nil, _List_fromArray([
                A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$DataExport$All$exportFileName(dataExport)))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Remove From Destination')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewPreview(model.w7),
                $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$viewConfirmInput(model)
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Remove From Destination'
                }, _List_fromArray([
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExport$RemoveFromDestinationModal$Remove),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$disabled(!model.hS),
                    $author$project$Ui$Button$loading(_Utils_eq(model.nX, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Remove From Destination')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$DataExport$Id_String$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$DataExport$Id_String$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
        A3($author$project$Api$Column$init, 'export_file_name', true, 'Export File Name'),
        A3($author$project$Api$Column$init, 'encrypted', true, 'Encrypted'),
        A3($author$project$Api$Column$init, 'status', true, 'Status'),
        A3($author$project$Api$Column$init, 'exported_at', true, 'Exported At'),
        A3($author$project$Api$Column$init, 'error_message', false, 'Error Message')
    ]);
    var $author$project$Components$Admin$DataExportConfiguration$Help$view = A2($author$project$Ui$Typography$p, _List_fromArray([
        $author$project$Ui$Typography$muted
    ]), _List_fromArray([
        $elm$html$Html$text('See our '),
        A3($author$project$Ui$Link$externalHref, 'https://docs.google.com/document/d/1s8wgwrN-Ltlw6r0w_g7WflS7DLZS4SFARQBgKxCYvfs/edit?tab=t.0', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('developer documentation')
        ])),
        $elm$html$Html$text(' and'),
        A3($author$project$Ui$Link$externalHref, 'https://miro.com/app/board/uXjVIg-hLbw=/?moveToWidget=3458764635611947784&cot=14', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('ERD Schema')
        ])),
        $elm$html$Html$text(' for standard Data Exporter tables.')
    ]));
    var $author$project$Formatters$Time$DateTime__Full = 4;
    var $author$project$Pages$Admin$DataExport$Id_String$OpenFileDocument = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$DataExport$Id_String$OpenRemoveFromDestinationModal = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$DataExport$Shared$encrypted = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExport$Shared$record, function($) {
        return $.OO;
    });
    var $author$project$Api$Provider$DataExport$All$encrypted = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExport$Shared$encrypted(shared);
    };
    var $author$project$Api$Provider$DataExport$Shared$errorMessage = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExport$Shared$record, function($) {
        return $.O4;
    });
    var $author$project$Api$Provider$DataExport$All$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExport$Shared$errorMessage(shared);
    };
    var $author$project$Api$Provider$DataExport$Shared$exportGenerated = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExport$Shared$record, function($) {
        return $.Pm;
    });
    var $author$project$Api$Provider$DataExport$All$exportGenerated = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExport$Shared$exportGenerated(shared);
    };
    var $author$project$Api$Provider$DataExport$Shared$exportedAt = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExport$Shared$record, function($) {
        return $.Pn;
    });
    var $author$project$Api$Provider$DataExport$All$exportedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExport$Shared$exportedAt(shared);
    };
    var $author$project$Api$Provider$DataExport$Shared$status = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExport$Shared$record, function($) {
        return $.ahy;
    });
    var $author$project$Api$Provider$DataExport$All$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExport$Shared$status(shared);
    };
    var $author$project$Pages$Admin$DataExport$Id_String$viewDataExport = F3(function(timeFormatter, isHintAdmin, dataExport) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription($author$project$Api$Provider$DataExport$All$dataExportConfiguration(dataExport)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$DataExport$All$exportFileName(dataExport)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Provider$DataExport$All$encrypted(dataExport)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$DataExport$All$status(dataExport))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, timeFormatter(4), $author$project$Api$Provider$DataExport$All$exportedAt(dataExport))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$DataExport$All$errorMessage(dataExport)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                isHintAdmin && $author$project$Api$Provider$DataExport$All$exportGenerated(dataExport) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$pull(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_Nil, 'Download file', _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: 'Download file'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$DataExport$Id_String$OpenFileDocument($author$project$Api$Provider$DataExport$All$id(dataExport))),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$export)
                        ]), _List_Nil)
                    ]))
                ])) : $author$project$Utils$Html$empty,
                isHintAdmin && $author$project$Api$Provider$DataExport$All$status(dataExport) === 'exported' ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$pull(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_Nil, 'Remove from destination', _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: 'Remove from destination'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$DataExport$Id_String$OpenRemoveFromDestinationModal(dataExport))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Remove from destination')
                        ]))
                    ]))
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Admin$DataExport$Id_String$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.M2;
            if (_v1.$ === 3) {
                var dataExports_ = _v1.a;
                return _Utils_Tuple2(false, dataExports_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var dataExports = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                $elm$html$Html$text('Manage exports.'),
                $author$project$Components$Admin$DataExportConfiguration$Help$view
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No exports found.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$DataExport$Id_String$SortTable)), $author$project$Pages$Admin$DataExport$Id_String$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, A2($author$project$Pages$Admin$DataExport$Id_String$viewDataExport, model.HO, model.F3), dataExports), _List_Nil)
        ]);
    };
    var $author$project$Pages$Admin$DataExport$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$html$Html$map($author$project$Pages$Admin$DataExport$Id_String$RemoveFromDestinationModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExport$RemoveFromDestinationModal$view, model.jO))),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__DataExport__Top, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Exports')
                                ]))
                            ])),
                            A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                $author$project$Ui$Breadcrumb$active(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text(model.aef)
                            ]))
                        ])))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Admin$DataExport$Id_String$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        function() {
                            var _v0 = model.M2;
                            if (_v0.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Admin$DataExport$Id_String$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_));
                            else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Admin | Data Exporter | Exports'
        };
    };
    var $author$project$Pages$Admin$DataExport$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$DataExport$Id_String$init,
        aeR: $author$project$Pages$Admin$DataExport$Id_String$load,
        ag3: $author$project$Pages$Admin$DataExport$Id_String$save,
        ahE: $author$project$Pages$Admin$DataExport$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$DataExport$Id_String$update,
        aid: $author$project$Pages$Admin$DataExport$Id_String$view
    });
    var $author$project$Pages$Admin$DataExport$Top$GotDataExportGroups = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$DataExportGroup$All$DataExportGroup = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$DataExportGroup$Shared$DataExportGroup = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DataExportGroup$Shared$Record = F3(function(id, timestamp, dataExportConfiguration) {
        return {
            M0: dataExportConfiguration,
            aef: id,
            $0: timestamp
        };
    });
    var $author$project$Api$Provider$DataExportGroup$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'data_export_configuration', $author$project$Api$Provider$DataExportConfiguration$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'timestamp', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$Shared$Record))));
    var $author$project$Api$Provider$DataExportGroup$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExportGroup$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DataExportGroup$All$Record = F2(function(entityName, dataExports) {
        return {
            M2: dataExports,
            O0: entityName
        };
    });
    var $author$project$Api$Provider$DataExportGroup$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'data_exports', $elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'entity_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$All$Record)));
    var $author$project$Api$Provider$DataExportGroup$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExportGroup$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExportGroup$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$All$DataExportGroup)));
    var $author$project$Api$Provider$DataExportGroup$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$DataExportGroup$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$DataExportGroup$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$DataExportGroup$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$DataExportGroup$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$DataExportGroup$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportGroup$dataExportGroupsPath)));
    });
    var $author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups = function(model) {
        return A3($author$project$Api$Provider$DataExportGroup$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                ahs: model.ahs
            });
        }, $author$project$Pages$Admin$DataExport$Top$GotDataExportGroups);
    };
    var $author$project$Pages$Admin$DataExport$Top$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: shared.Ej,
            lP: $author$project$Api$Data$Loading,
            F3: $author$project$Shared$isHintAdmin(shared),
            af_: $author$project$Api$Pagination$initFromQuery(query),
            agq: q,
            jO: $elm$core$Maybe$Nothing,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: A3($author$project$Api$Sort$withDefault, 'timestamp', 1, $author$project$Api$Sort$initFromQuery(query)),
            HO: shared.HO
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(model));
    });
    var $author$project$Pages$Admin$DataExport$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$DataExport$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close = {
        $: 0
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close);
    };
    var $author$project$Pages$Admin$DataExport$Top$subscriptions = function(model) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$subscriptions, model.jO)));
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$init = function(dataExportGroup) {
        return {
            hS: false,
            w8: dataExportGroup,
            nX: $author$project$Api$Data$NotAsked
        };
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Closed = 1;
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$GotRemoveResponse = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$None = 0;
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Removed = 2;
    var $author$project$Api$Provider$DataExportGroup$Shared$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Provider$DataExportGroup$Shared$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportGroup$Shared$record, function($) {
        return $.aef;
    });
    var $author$project$Api$Provider$DataExportGroup$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExportGroup$Shared$id(shared);
    };
    var $author$project$Api$Provider$DataExportGroup$One$DataExportGroup = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$DataExportGroup$One$Record = F2(function(entityName, dataExports) {
        return {
            M2: dataExports,
            O0: entityName
        };
    });
    var $author$project$Api$Provider$DataExportGroup$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'data_exports', $elm$json$Json$Decode$list($author$project$Api$Provider$DataExport$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'entity_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$One$Record)));
    var $author$project$Api$Provider$DataExportGroup$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExportGroup$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExportGroup$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DataExportGroup$One$DataExportGroup)));
    var $author$project$Api$Provider$DataExportGroup$removeFromDestination = F3(function(apiClient, dataExportGroupId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$DataExportGroup$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'remove_from_destination'
        ]), $author$project$Api$Provider$DataExportGroup$dataExportGroupPath(dataExportGroupId))));
    });
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                return model.hS ? {
                    EQ: A3($author$project$Api$Provider$DataExportGroup$removeFromDestination, apiClient, $author$project$Api$Provider$DataExportGroup$All$id(model.w8), $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$GotRemoveResponse),
                    adu: 0,
                    zi: _Utils_update(model, {
                        nX: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        nX: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Export removed.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        nX: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var bool = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        hS: bool
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Pages$Admin$DataExport$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__DataExport__Top)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Admin$DataExport$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lP: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    lP: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(newModel),
                    $author$project$Pages$Admin$DataExport$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$DataExport$Top$fetchDataExportGroups(newModel),
                    $author$project$Pages$Admin$DataExport$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var dataExportGroup = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    jO: $elm$core$Maybe$Just($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$init(dataExportGroup))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v2 = model.jO;
                if (!_v2.$) {
                    var removeFromDestinationModal = _v2.a;
                    var result = A3($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$update, model.Ej, subMsg, removeFromDestinationModal);
                    var updatedRemoveFromDestinationModal = function() {
                        var _v3 = result.adu;
                        switch(_v3){
                            case 0:
                                return $elm$core$Maybe$Just(result.zi);
                            case 1:
                                return $elm$core$Maybe$Nothing;
                            default:
                                return $elm$core$Maybe$Nothing;
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        jO: updatedRemoveFromDestinationModal
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg, result.EQ), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$DataExport$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Remove = {
        $: 1
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$ConfirmUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewConfirmInput = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(model.hS),
                $author$project$Ui$Form$Checkbox$required(true),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$ConfirmUpdated)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('By checking this box I confirm that I have verified that the files to be removed'),
                    $elm$html$Html$text('and the destination server accurate.')
                ]))
            ])),
            $author$project$Utils$FormErrors$view(model.hS ? _List_Nil : _List_fromArray([
                'Please confirm that the files to be removed and the destination server and path are accurate.'
            ]))
        ]));
    };
    var $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportGroup$Shared$record, function($) {
        return $.M0;
    });
    var $author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration(shared);
    };
    var $author$project$Api$Provider$DataExportGroup$All$dataExports = function(_v0) {
        var record = _v0.b;
        return record.M2;
    };
    var $author$project$Api$Provider$DataExportGroup$All$entityName = function(_v0) {
        var record = _v0.b;
        return record.O0;
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewDataExport = function(dataExport) {
        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$DataExport$Shared$exportFileName(dataExport)))
        ]));
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewPreview = function(dataExportGroup) {
        var dataExportConfiguration = $author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration(dataExportGroup);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('mb-2')
            ]), _List_fromArray([
                $elm$html$Html$text('The platform will remove the following files from the given destination.')
            ])),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Entity Name: ')
            ])),
            $elm$html$Html$text($author$project$Api$Provider$DataExportGroup$All$entityName(dataExportGroup)),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Destination: ')
            ])),
            $elm$html$Html$text($author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Files: ')
            ])),
            A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewDataExport, $author$project$Api$Provider$DataExportGroup$All$dataExports(dataExportGroup)))
        ]));
    };
    var $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Remove From Destination')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewPreview(model.w8),
                $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$viewConfirmInput(model)
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Remove From Destination'
                }, _List_fromArray([
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$Remove),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$disabled(!model.hS),
                    $author$project$Ui$Button$loading(_Utils_eq(model.nX, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Remove From Destination')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$DataExport$Top$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$DataExport$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
        A3($author$project$Api$Column$init, 'timestamp', true, 'Exported At')
    ]);
    var $author$project$Pages$Admin$DataExport$Top$OpenRemoveFromDestinationModal = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$DataExportGroup$Shared$timestamp = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportGroup$Shared$record, function($) {
        return $.$0;
    });
    var $author$project$Api$Provider$DataExportGroup$All$timestamp = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExportGroup$Shared$timestamp(shared);
    };
    var $author$project$Pages$Admin$DataExport$Top$viewDataExportGroup = F3(function(timeFormatter, isHintAdmin, dataExportGroup) {
        var withLink = function(contents) {
            return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__DataExport__Id_String({
                aef: $author$project$Api$Provider$DataExportGroup$All$id(dataExportGroup)
            }), _List_Nil, contents);
        };
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                withLink(_List_fromArray([
                    $elm$html$Html$text($author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription($author$project$Api$Provider$DataExportGroup$All$dataExportConfiguration(dataExportGroup)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                withLink(_List_fromArray([
                    $elm$html$Html$text(A2(timeFormatter, 4, $author$project$Api$Provider$DataExportGroup$All$timestamp(dataExportGroup)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                isHintAdmin ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$pull(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_Nil, 'Remove from destination', _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: 'Remove from destination'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$DataExport$Top$OpenRemoveFromDestinationModal(dataExportGroup))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Remove from destination')
                        ]))
                    ]))
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Admin$DataExport$Top$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.lP;
            if (_v1.$ === 3) {
                var dataExportGroups_ = _v1.a;
                return _Utils_Tuple2(false, dataExportGroups_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var dataExportGroups = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                $elm$html$Html$text('Manage exports.'),
                $author$project$Components$Admin$DataExportConfiguration$Help$view
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No exports found.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$DataExport$Top$SortTable)), $author$project$Pages$Admin$DataExport$Top$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, A2($author$project$Pages$Admin$DataExport$Top$viewDataExportGroup, model.HO, model.F3), dataExportGroups), _List_Nil)
        ]);
    };
    var $author$project$Pages$Admin$DataExport$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$html$Html$map($author$project$Pages$Admin$DataExport$Top$RemoveFromDestinationModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportGroup$RemoveFromDestinationModal$view, model.jO))),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Exports')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Admin$DataExport$Top$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        function() {
                            var _v0 = model.lP;
                            if (_v0.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Admin$DataExport$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_));
                            else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Admin | Data Exporter | Exports'
        };
    };
    var $author$project$Pages$Admin$DataExport$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$DataExport$Top$init,
        aeR: $author$project$Pages$Admin$DataExport$Top$load,
        ag3: $author$project$Pages$Admin$DataExport$Top$save,
        ahE: $author$project$Pages$Admin$DataExport$Top$subscriptions,
        aaO: $author$project$Pages$Admin$DataExport$Top$update,
        aid: $author$project$Pages$Admin$DataExport$Top$view
    });
    var $author$project$Pages$Admin$DataExportSettings$Id_String$DataExportConfigurationFormMsg = $elm$core$Basics$identity;
    var $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfiguration = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$PhoneInput$US = 0;
    var $author$project$Components$PhoneInput$International = 1;
    var $author$project$Api$Common$Phone$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Common$Phone$Shared$usFormattable = function(_v0) {
        var record = _v0;
        return record.H0;
    };
    var $author$project$Utils$Phone$fromApi = function(phone) {
        var region = $author$project$Api$Common$Phone$Shared$usFormattable(phone) ? 0 : 1;
        return {
            Gx: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$Phone$Shared$number(phone)),
            agE: region,
            ah5: $author$project$Api$Common$Phone$Shared$type_(phone)
        };
    };
    var $author$project$Components$PhoneInput$Model = $elm$core$Basics$identity;
    var $author$project$Components$PhoneInput$PhoneRegionDropdownMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PhoneInput$PhoneTypeDropdownMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PhoneInput$defaults = {
        Iz: false,
        abK: true,
        ac_: $author$project$Api$Common$Phone$Shared$Mobile,
        ada: false,
        ms: false,
        y_: 5,
        nU: _List_fromArray([
            0,
            1
        ]),
        agM: false,
        ah6: _List_fromArray([
            $author$project$Api$Common$Phone$Shared$Mobile,
            $author$project$Api$Common$Phone$Shared$Home,
            $author$project$Api$Common$Phone$Shared$Office
        ])
    };
    var $author$project$Components$PhoneInput$initPhone = F3(function(type_, region, number) {
        return {
            Gx: number,
            agE: region,
            ah5: type_
        };
    });
    var $author$project$Components$PhoneInput$emptyPhone = function(type_) {
        return A3($author$project$Components$PhoneInput$initPhone, type_, 0, '');
    };
    var $author$project$Components$PhoneInput$phoneRegionDropdownId = F2(function(id, index) {
        return id + ('phone-input-phone-region' + $elm$core$String$fromInt(index));
    });
    var $author$project$Components$PhoneInput$phoneTypeDropdownId = F2(function(id, index) {
        return id + ('phone-input-phone-type' + $elm$core$String$fromInt(index));
    });
    var $author$project$Components$PhoneInput$init = F3(function(id, phones, optionals) {
        var options = optionals($author$project$Components$PhoneInput$defaults);
        var phones_ = $elm$core$List$isEmpty(phones) && options.Iz ? _List_fromArray([
            $author$project$Components$PhoneInput$emptyPhone(options.ac_)
        ]) : phones;
        return {
            abK: options.abK,
            ac_: options.ac_,
            ada: options.ada,
            PU: $author$project$Utils$Form$init(A2($elm$core$List$indexedMap, F2(function(index, phone) {
                return _Utils_Tuple3(phone, $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                    aef: A2($author$project$Components$PhoneInput$phoneTypeDropdownId, id, index),
                    ahX: $author$project$Components$PhoneInput$PhoneTypeDropdownMsg(index)
                })), $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                    aef: A2($author$project$Components$PhoneInput$phoneRegionDropdownId, id, index),
                    ahX: $author$project$Components$PhoneInput$PhoneRegionDropdownMsg(index)
                })));
            }), phones_)),
            ms: options.ms,
            aef: id,
            y_: options.y_,
            nU: options.nU,
            agM: options.agM,
            ah6: options.ah6
        };
    });
    var $author$project$Components$PhoneInput$require = F2(function(required, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            agM: required
        });
    });
    var $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput = function(maybePhone) {
        return A2($author$project$Components$PhoneInput$require, true, A3($author$project$Components$PhoneInput$init, 'data-export-configuration-contact-phone-input', _List_fromArray([
            A2($elm$core$Maybe$withDefault, {
                Gx: '',
                agE: 0,
                ah5: $author$project$Api$Common$Phone$Shared$Mobile
            }, A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone))
        ]), function(opts) {
            return _Utils_update(opts, {
                abK: false,
                y_: 1
            });
        }));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$emptyFormFieldsInit = function(isHintAdmin) {
        return {
            L0: $elm$core$Maybe$Nothing,
            L2: $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput($elm$core$Maybe$Nothing),
            NS: $elm$core$Maybe$Nothing,
            OM: false,
            iD: false,
            OP: $elm$core$Maybe$Nothing,
            OQ: $elm$core$Maybe$Nothing,
            O9: !isHintAdmin,
            PG: $elm$core$Maybe$Just(':timestamp:/:file_name:'),
            my: false,
            TB: false,
            Zl: $elm$core$Maybe$Nothing,
            Zm: $elm$core$Maybe$Nothing,
            Z4: $elm$core$Maybe$Nothing,
            Z5: $elm$core$Maybe$Nothing,
            Hq: $elm$core$Maybe$Nothing,
            sN: false,
            Z6: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'data_export_configurations'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath);
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$DataExportConfiguration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DataExportConfiguration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExportConfiguration$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DataExportConfiguration$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$DataExportConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id)));
    });
    var $author$project$Components$Admin$DataExportConfiguration$Form$init = F4(function(apiClient, isHintAdmin, id, singleton) {
        var _v0 = function() {
            if (!id.$) {
                var id_ = id.a;
                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A3($author$project$Api$Provider$DataExportConfiguration$retrieve, apiClient, id_, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfiguration));
            } else return _Utils_Tuple3($elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Components$Admin$DataExportConfiguration$Form$emptyFormFieldsInit(isHintAdmin))), $author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
        }();
        var form = _v0.a;
        var dataExportConfiguration = _v0.b;
        var retrieveCmd = _v0.c;
        var model = {
            M0: dataExportConfiguration,
            iG: $elm$core$Maybe$Nothing,
            PU: form,
            aef: id,
            F3: isHintAdmin,
            j_: $author$project$Api$Data$NotAsked,
            s0: singleton,
            kw: $elm$core$Maybe$Nothing
        };
        return _Utils_Tuple2(model, retrieveCmd);
    });
    var $author$project$Pages$Admin$DataExportSettings$Id_String$init = F4(function(_v0, _v1, shared, _v2) {
        var params = _v2.VU;
        var query = _v2.Bz;
        var singleton = _Utils_eq(A2($elm$core$Dict$get, 'singleton', query), $elm$core$Maybe$Just('true'));
        var _v3 = A4($author$project$Components$Admin$DataExportConfiguration$Form$init, shared.Ej, $author$project$Shared$isHintAdmin(shared), $elm$core$Maybe$Just(params.aef), singleton);
        var form = _v3.a;
        var cmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$DataExportSettings$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$DataExportSettings$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Close = {
        $: 0
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportConfiguration$ExportModal$Close);
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close = {
        $: 0
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close);
    };
    var $author$project$Components$PhoneInput$subscriptions = function(_v0) {
        var model = _v0;
        var phones = $author$project$Utils$Form$fields(model.PU);
        return $elm$core$Platform$Sub$batch(A2($elm$core$List$map, function(_v1) {
            var typeDropdown = _v1.b;
            var regionDropdown = _v1.c;
            return $elm$core$Platform$Sub$batch(_List_fromArray([
                $author$project$Ui$Dropdown$subscriptions(typeDropdown),
                $author$project$Ui$Dropdown$subscriptions(regionDropdown)
            ]));
        }, phones));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions, model.kw))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions, model.iG))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg), A2($elm$core$Maybe$map, $author$project$Components$PhoneInput$subscriptions, A2($elm$core$Maybe$map, function($) {
                return $.L2;
            }, A2($elm$core$Maybe$map, $author$project$Utils$Form$fields, model.PU)))))
        ]));
    };
    var $author$project$Pages$Admin$DataExportSettings$Id_String$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$DataExportConfiguration$Form$subscriptions(model.PU));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhone = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$None = {
        $: 0
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$Saved = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Common$Phone$Shared$typeEncoder = function(type__) {
        switch(type__.$){
            case 0:
                return $elm$json$Json$Encode$string('mobile');
            case 1:
                return $elm$json$Json$Encode$string('home');
            case 2:
                return $elm$json$Json$Encode$string('office');
            default:
                var otherDescription = type__.a;
                return $elm$json$Json$Encode$string(otherDescription);
        }
    };
    var $author$project$Api$Common$Phone$Shared$encode = function(phone) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('type', $author$project$Api$Common$Phone$Shared$typeEncoder(phone.ah5)),
            _Utils_Tuple2('number', $elm$json$Json$Encode$string(phone.Gx)),
            _Utils_Tuple2('us_formattable', $elm$json$Json$Encode$bool(phone.H0))
        ]));
    };
    var $author$project$Api$Provider$DataExportConfiguration$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('data_export_configuration', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('enabled', $elm$json$Json$Encode$bool(fields.OM)),
                _Utils_Tuple2('contact_email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.L0)),
                _Utils_Tuple2('contact_phone', A2($author$project$Utils$Encode$nullable, $author$project$Api$Common$Phone$Shared$encode, fields.L2)),
                _Utils_Tuple2('destination', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.NS)),
                _Utils_Tuple2('sftp_host', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Z4)),
                _Utils_Tuple2('sftp_port', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Z5)),
                _Utils_Tuple2('sftp_username', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Z6)),
                _Utils_Tuple2('sftp_private_key', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Hq)),
                _Utils_Tuple2('s3_bucket', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Zl)),
                _Utils_Tuple2('s3_region', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Zm)),
                _Utils_Tuple2('encryption_key', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OP)),
                _Utils_Tuple2('encryption_recipient', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OQ)),
                _Utils_Tuple2('incremental_mode', $elm$json$Json$Encode$bool(fields.Ra)),
                _Utils_Tuple2('exclude_default_tables', $elm$json$Json$Encode$bool(fields.O9)),
                _Utils_Tuple2('file_name_format', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.PG))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$DataExportConfiguration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath)));
    });
    var $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString = function(destination) {
        if (!destination) return 'sftp';
        else return 's3';
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$contactEmail = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.L0;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$contactEmail = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$contactEmail(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$contactPhone = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.L2;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$contactPhone = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$contactPhone(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$destination = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$destination(shared);
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$S3 = 1;
    var $author$project$Components$Admin$DataExportConfiguration$Form$Sftp = 0;
    var $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString = function(string) {
        switch(string){
            case 'sftp':
                return $elm$core$Maybe$Just(0);
            case 's3':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$enabled = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.OM;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$enabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$enabled(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionKey = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.OP;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$encryptionKey = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionKey(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionRecipient = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.OQ;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$encryptionRecipient = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$encryptionRecipient(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$excludeDefaultTables = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.O9;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$excludeDefaultTables = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$excludeDefaultTables(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$fileNameFormat = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.PG;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$fileNameFormat = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$fileNameFormat(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$incrementalMode = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.Ra;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$incrementalMode = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$incrementalMode(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$manualExportPerformed = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.TB;
    });
    var $author$project$Api$Provider$DataExportConfiguration$One$manualExportPerformed = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$manualExportPerformed(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$s3Bucket = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$s3Region = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$s3Region(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$sftpHost = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpHost(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$sftpPort = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpPort(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$sftpUsername = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$sftpUsername(shared);
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit = function(dataExportConfiguration) {
        var encryptionKey = $author$project$Api$Provider$DataExportConfiguration$One$encryptionKey(dataExportConfiguration);
        return {
            L0: $author$project$Api$Provider$DataExportConfiguration$One$contactEmail(dataExportConfiguration),
            L2: $author$project$Components$Admin$DataExportConfiguration$Form$initPhoneInput($author$project$Api$Provider$DataExportConfiguration$One$contactPhone(dataExportConfiguration)),
            NS: $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString($author$project$Api$Provider$DataExportConfiguration$One$destination(dataExportConfiguration)),
            OM: $author$project$Api$Provider$DataExportConfiguration$One$enabled(dataExportConfiguration),
            iD: !_Utils_eq(encryptionKey, $elm$core$Maybe$Nothing),
            OP: encryptionKey,
            OQ: $author$project$Api$Provider$DataExportConfiguration$One$encryptionRecipient(dataExportConfiguration),
            O9: $author$project$Api$Provider$DataExportConfiguration$One$excludeDefaultTables(dataExportConfiguration),
            PG: $elm$core$Maybe$Just($author$project$Api$Provider$DataExportConfiguration$One$fileNameFormat(dataExportConfiguration)),
            my: $author$project$Api$Provider$DataExportConfiguration$One$incrementalMode(dataExportConfiguration),
            TB: $author$project$Api$Provider$DataExportConfiguration$One$manualExportPerformed(dataExportConfiguration),
            Zl: $author$project$Api$Provider$DataExportConfiguration$One$s3Bucket(dataExportConfiguration),
            Zm: $author$project$Api$Provider$DataExportConfiguration$One$s3Region(dataExportConfiguration),
            Z4: $author$project$Api$Provider$DataExportConfiguration$One$sftpHost(dataExportConfiguration),
            Z5: $author$project$Api$Provider$DataExportConfiguration$One$sftpPort(dataExportConfiguration),
            Hq: $elm$core$Maybe$Nothing,
            sN: true,
            Z6: $author$project$Api$Provider$DataExportConfiguration$One$sftpUsername(dataExportConfiguration)
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    OM: bool
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    L0: $author$project$Utils$String$toMaybe(string)
                });
            case 2:
                var phone = field.a;
                return _Utils_update(fields, {
                    L2: phone
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    NS: $author$project$Components$Admin$DataExportConfiguration$Form$destinationFromString(string)
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    Z4: $author$project$Utils$String$toMaybe(string)
                });
            case 5:
                var _int = field.a;
                return _Utils_update(fields, {
                    Z5: $elm$core$String$toInt(_int)
                });
            case 6:
                var string = field.a;
                return _Utils_update(fields, {
                    Z6: $author$project$Utils$String$toMaybe(string)
                });
            case 7:
                var string = field.a;
                return _Utils_update(fields, {
                    Hq: $author$project$Utils$String$toMaybe(string)
                });
            case 8:
                var string = field.a;
                return _Utils_update(fields, {
                    Zl: $author$project$Utils$String$toMaybe(string)
                });
            case 9:
                var string = field.a;
                return _Utils_update(fields, {
                    Zm: $author$project$Utils$String$toMaybe(string)
                });
            case 10:
                var bool = field.a;
                return _Utils_update(fields, {
                    iD: bool
                });
            case 11:
                var string = field.a;
                return _Utils_update(fields, {
                    OP: $author$project$Utils$String$toMaybe(string)
                });
            case 12:
                var string = field.a;
                return _Utils_update(fields, {
                    OQ: $author$project$Utils$String$toMaybe(string)
                });
            case 13:
                var bool = field.a;
                return _Utils_update(fields, {
                    my: bool
                });
            case 14:
                var bool = field.a;
                return _Utils_update(fields, {
                    O9: bool
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    PG: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Components$PhoneInput$PhoneValidation = $elm$core$Basics$identity;
    var $author$project$Components$PhoneInput$phoneMask = '(###) ###-####';
    var $author$project$Components$PhoneInput$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Components$PhoneInput$phoneMask);
    var $author$project$Components$PhoneInput$phoneIncomplete = F2(function(phoneNumber, phoneRegion) {
        if (!phoneRegion) {
            var maskedPhone = A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$PhoneInput$phonePattern, phoneNumber);
            return $elm$core$String$length(maskedPhone) > 0 && !_Utils_eq($elm$core$String$length($author$project$Components$PhoneInput$phoneMask), $elm$core$String$length(maskedPhone));
        } else return false;
    });
    var $author$project$Components$PhoneInput$validatePhone = F3(function(isRequired, index, _v0) {
        var phone = _v0.a;
        return A2($author$project$Components$PhoneInput$phoneIncomplete, phone.Gx, phone.agE) ? _List_fromArray([
            _Utils_Tuple2(index, 'Please enter a valid phone number.')
        ]) : !index && isRequired && $elm$core$String$isEmpty(phone.Gx) ? _List_fromArray([
            _Utils_Tuple2(index, 'Please enter a phone number.')
        ]) : _List_Nil;
    });
    var $author$project$Components$PhoneInput$validatePhones = F2(function(isRequired, phones) {
        return $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Components$PhoneInput$validatePhone(isRequired), phones));
    });
    var $author$project$Components$PhoneInput$formFieldsValidator = function(isRequired) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$PhoneInput$validatePhones(isRequired))
        ]));
    };
    var $author$project$Components$PhoneInput$getPhones = function(_v0) {
        var model = _v0;
        var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$PhoneInput$formFieldsValidator(model.agM), model.PU);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var formFields = _v2.b;
            return $elm$core$Maybe$Just(A2($elm$core$List$map, function(_v3) {
                var phone = _v3.a;
                return phone;
            }, $rtfeldman$elm_validate$Validate$fromValid(formFields)));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$GotPreview = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DataExportConfiguration$export = F4(function(apiClient, id, _v0, toMsg) {
        var preview = _v0.agk;
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('preview', $elm$json$Json$Encode$bool(preview))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$DataExportGroup$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'export'
        ]), $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id)))));
    });
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$init = F2(function(apiClient, dataExportConfigurationId) {
        return _Utils_Tuple2({
            hS: false,
            E4: dataExportConfigurationId,
            me: $author$project$Api$Data$NotAsked,
            sh: $author$project$Api$Data$Loading
        }, A4($author$project$Api$Provider$DataExportConfiguration$export, apiClient, dataExportConfigurationId, {
            agk: true
        }, $author$project$Components$Admin$DataExportConfiguration$ExportModal$GotPreview));
    });
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$NotTested = {
        $: 0
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init = function(dataExportConfiguration) {
        return {
            M0: dataExportConfiguration,
            kx: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$NotTested
        };
    };
    var $author$project$Utils$Phone$toRecord = function(phone) {
        var usFormattable = function() {
            var _v0 = phone.agE;
            if (!_v0) return true;
            else return false;
        }();
        return {
            Gx: phone.Gx,
            ah5: phone.ah5,
            H0: usFormattable
        };
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$toShared = function(_v0) {
        var shared = _v0;
        return shared;
    };
    var $author$project$Api$Provider$DataExportConfiguration$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('data_export_configuration', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('enabled', $elm$json$Json$Encode$bool(fields.OM)), A2($elm$core$List$cons, _Utils_Tuple2('contact_email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.L0)), A2($elm$core$List$cons, _Utils_Tuple2('contact_phone', A2($author$project$Utils$Encode$nullable, $author$project$Api$Common$Phone$Shared$encode, fields.L2)), A2($elm$core$List$cons, _Utils_Tuple2('destination', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.NS)), A2($elm$core$List$cons, _Utils_Tuple2('sftp_host', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Z4)), A2($elm$core$List$cons, _Utils_Tuple2('sftp_port', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Z5)), A2($elm$core$List$cons, _Utils_Tuple2('sftp_username', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Z6)), A2($elm$core$List$cons, _Utils_Tuple2('s3_bucket', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Zl)), A2($elm$core$List$cons, _Utils_Tuple2('s3_region', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Zm)), A2($elm$core$List$cons, _Utils_Tuple2('encryption_key', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OP)), A2($elm$core$List$cons, _Utils_Tuple2('encryption_recipient', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OQ)), A2($elm$core$List$cons, _Utils_Tuple2('incremental_mode', $elm$json$Json$Encode$bool(fields.Ra)), A2($elm$core$List$cons, _Utils_Tuple2('exclude_default_tables', $elm$json$Json$Encode$bool(fields.O9)), A2($elm$core$List$cons, _Utils_Tuple2('file_name_format', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.PG)), _Utils_eq(fields.Hq, $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray([
                _Utils_Tuple2('sftp_private_key', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Hq))
            ])))))))))))))))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$DataExportConfiguration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id))));
    });
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Closed = 1;
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Exported = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Exporting = 2;
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$None = 0;
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        sh: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                return model.hS ? {
                    EQ: A4($author$project$Api$Provider$DataExportConfiguration$export, apiClient, model.E4, {
                        agk: false
                    }, $author$project$Components$Admin$DataExportConfiguration$ExportModal$Exported),
                    adu: 0,
                    zi: _Utils_update(model, {
                        me: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        me: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Export is being generated.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        me: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var bool = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        hS: bool
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Closed = 1;
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Failed = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$None = 0;
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Success = {
        $: 2
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Testing = {
        $: 1
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnectionResponse = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.aef;
    });
    var $author$project$Api$Provider$DataExportConfiguration$testConnection = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $elm$json$Json$Decode$bool, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'test_connection'
        ]), $author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationPath(id))));
    });
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$testConnectionCmd = F2(function(apiClient, dataExportConfiguration) {
        return A3($author$project$Api$Provider$DataExportConfiguration$testConnection, apiClient, $author$project$Api$Provider$DataExportConfiguration$Shared$id(dataExportConfiguration), $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnectionResponse);
    });
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: A2($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$testConnectionCmd, apiClient, model.M0),
                    adu: 0,
                    zi: _Utils_update(model, {
                        kx: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Testing
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                kx: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Success
                            }),
                            at: _List_Nil
                        };
                    case 2:
                        var error = response.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                kx: $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Failed($author$project$Api$Data$errorToString(error))
                            }),
                            at: _List_Nil
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: model,
                            at: _List_Nil
                        };
                }
        }
    });
    var $author$project$Components$PhoneInput$Phones = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PhoneInput$numPhoneMaskDigits = $elm$core$String$length(A2($elm$core$String$filter, function(c) {
        return c === '#';
    }, $author$project$Components$PhoneInput$phoneMask));
    var $author$project$Components$PhoneInput$clipPhoneNumberToMask = F2(function(phoneNumber, phoneRegion) {
        return !phoneRegion && _Utils_cmp($elm$core$String$length(phoneNumber), $author$project$Components$PhoneInput$numPhoneMaskDigits) > 0 ? A2($elm$core$String$left, $author$project$Components$PhoneInput$numPhoneMaskDigits, phoneNumber) : phoneNumber;
    });
    var $author$project$Formatters$PhoneType$fromString = function(string) {
        switch(string){
            case 'Mobile':
                return $author$project$Api$Common$Phone$Shared$Mobile;
            case 'Home':
                return $author$project$Api$Common$Phone$Shared$Home;
            case 'Office':
                return $author$project$Api$Common$Phone$Shared$Office;
            default:
                var otherDescription = string;
                return $author$project$Api$Common$Phone$Shared$Other(otherDescription);
        }
    };
    var $author$project$Components$PhoneInput$formFieldsUpdate = F2(function(field, phones) {
        switch(field.$){
            case 0:
                var phones_ = field.a;
                return phones_;
            case 1:
                var index = field.a;
                var type_ = field.b;
                return A3($elm_community$list_extra$List$Extra$updateAt, index, function(_v1) {
                    var phone = _v1.a;
                    var typeDropdown = _v1.b;
                    var regionDropdown = _v1.c;
                    return _Utils_Tuple3(_Utils_update(phone, {
                        ah5: $author$project$Formatters$PhoneType$fromString(type_)
                    }), typeDropdown, regionDropdown);
                }, phones);
            case 2:
                var index = field.a;
                var region = field.b;
                return A3($elm_community$list_extra$List$Extra$updateAt, index, function(_v2) {
                    var phone = _v2.a;
                    var typeDropdown = _v2.b;
                    var regionDropdown = _v2.c;
                    return _Utils_Tuple3(_Utils_update(phone, {
                        Gx: A2($author$project$Components$PhoneInput$clipPhoneNumberToMask, phone.Gx, region),
                        agE: region
                    }), typeDropdown, regionDropdown);
                }, phones);
            default:
                var index = field.a;
                var number = field.b;
                return A3($elm_community$list_extra$List$Extra$updateAt, index, function(_v3) {
                    var phone = _v3.a;
                    var typeDropdown = _v3.b;
                    var regionDropdown = _v3.c;
                    return _Utils_Tuple3(_Utils_update(phone, {
                        Gx: number
                    }), typeDropdown, regionDropdown);
                }, phones);
        }
    });
    var $author$project$Components$PhoneInput$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var phones = $author$project$Utils$Form$fields(model.PU);
                var lastIndex = $elm$core$List$length(phones);
                var newPhones = _Utils_ap(phones, _List_fromArray([
                    _Utils_Tuple3($author$project$Components$PhoneInput$emptyPhone(model.ac_), $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                        aef: A2($author$project$Components$PhoneInput$phoneTypeDropdownId, model.aef, lastIndex),
                        ahX: $author$project$Components$PhoneInput$PhoneTypeDropdownMsg(lastIndex)
                    })), $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                        aef: A2($author$project$Components$PhoneInput$phoneRegionDropdownId, model.aef, lastIndex),
                        ahX: $author$project$Components$PhoneInput$PhoneRegionDropdownMsg(lastIndex)
                    })))
                ]));
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$PhoneInput$formFieldsUpdate, $author$project$Components$PhoneInput$Phones(newPhones), model.PU)
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var index = msg.a;
                var phones = $author$project$Utils$Form$fields(model.PU);
                var newPhones = A2($elm_community$list_extra$List$Extra$removeAt, index, phones);
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$PhoneInput$formFieldsUpdate, $author$project$Components$PhoneInput$Phones(newPhones), model.PU)
                }), $elm$core$Platform$Cmd$none);
            case 2:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$PhoneInput$formFieldsUpdate, field, model.PU);
                var validatedForm = function() {
                    var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$PhoneInput$formFieldsValidator(model.agM), newForm);
                    if (!_v2.$) {
                        var _v3 = _v2.a;
                        var form = _v3.a;
                        return form;
                    } else {
                        var form = _v2.a;
                        return form;
                    }
                }();
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: validatedForm
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var index = msg.a;
                var dropdownMsg = msg.b;
                var phones = $author$project$Utils$Form$fields(model.PU);
                var maybePhone = A2($elm_community$list_extra$List$Extra$getAt, index, phones);
                var _v4 = function() {
                    if (!maybePhone.$) {
                        var _v6 = maybePhone.a;
                        var phone = _v6.a;
                        var typeDropdown = _v6.b;
                        var regionDropdown = _v6.c;
                        var _v7 = A2($author$project$Ui$Dropdown$update, dropdownMsg, typeDropdown);
                        var updatedTypeDropdown = _v7.a;
                        var dropdownCmd = _v7.b;
                        var updatedPhonesList = A3($elm_community$list_extra$List$Extra$setAt, index, _Utils_Tuple3(phone, updatedTypeDropdown, regionDropdown), phones);
                        return _Utils_Tuple2(updatedPhonesList, dropdownCmd);
                    } else return _Utils_Tuple2(phones, $elm$core$Platform$Cmd$none);
                }();
                var updatedPhones = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$PhoneInput$formFieldsUpdate, $author$project$Components$PhoneInput$Phones(updatedPhones), model.PU)
                }), cmd);
            default:
                var index = msg.a;
                var dropdownMsg = msg.b;
                var phones = $author$project$Utils$Form$fields(model.PU);
                var maybePhone = A2($elm_community$list_extra$List$Extra$getAt, index, phones);
                var _v8 = function() {
                    if (!maybePhone.$) {
                        var _v10 = maybePhone.a;
                        var phone = _v10.a;
                        var typeDropdown = _v10.b;
                        var regionDropdown = _v10.c;
                        var _v11 = A2($author$project$Ui$Dropdown$update, dropdownMsg, regionDropdown);
                        var updatedRegionDropdown = _v11.a;
                        var dropdownCmd = _v11.b;
                        var updatedPhonesList = A3($elm_community$list_extra$List$Extra$setAt, index, _Utils_Tuple3(phone, typeDropdown, updatedRegionDropdown), phones);
                        return _Utils_Tuple2(updatedPhonesList, dropdownCmd);
                    } else return _Utils_Tuple2(phones, $elm$core$Platform$Cmd$none);
                }();
                var updatedPhones = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$PhoneInput$formFieldsUpdate, $author$project$Components$PhoneInput$Phones(updatedPhones), model.PU)
                }), cmd);
        }
    });
    var $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmailValidation = 0;
    var $author$project$Components$Admin$DataExportConfiguration$Form$DestinationValidation = 2;
    var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKeyValidation = 9;
    var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipientValidation = 10;
    var $author$project$Components$Admin$DataExportConfiguration$Form$S3BucketValidation = 7;
    var $author$project$Components$Admin$DataExportConfiguration$Form$S3RegionValidation = 8;
    var $author$project$Components$Admin$DataExportConfiguration$Form$SftpHostValidation = 3;
    var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPortValidation = 4;
    var $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsernameValidation = 5;
    var $rtfeldman$elm_validate$Validate$validEmail = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, A2($elm$regex$Regex$fromStringWith, {
        acf: true,
        ae8: false
    }, '^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$'));
    var $rtfeldman$elm_validate$Validate$isValidEmail = function(email) {
        return A2($elm$regex$Regex$contains, $rtfeldman$elm_validate$Validate$validEmail, email);
    };
    var $author$project$Utils$Validate$isInvalidEmail = F2(function(options, email) {
        if (!email.$) {
            var email_ = email.a;
            return $rtfeldman$elm_validate$Validate$isBlank(email_) ? !options.abH : !$rtfeldman$elm_validate$Validate$isValidEmail(email_);
        } else return !options.abH;
    });
    var $author$project$Utils$Validate$ifInvalidEmail = F3(function(options, subjectToEmail, error) {
        return A2($rtfeldman$elm_validate$Validate$ifTrue, function(subject) {
            return A2($author$project$Utils$Validate$isInvalidEmail, options, subjectToEmail(subject));
        }, error);
    });
    var $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneValidation = 1;
    var $author$project$Components$PhoneInput$hasErrors = function(_v0) {
        var model = _v0;
        return $author$project$Utils$Form$hasAnyValidationError(model.PU);
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$validatePhone = function(_v0) {
        var contactPhone = _v0.L2;
        return $author$project$Components$PhoneInput$hasErrors(contactPhone) ? _List_fromArray([
            _Utils_Tuple2(1, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKeyValidation = 6;
    var $author$project$Components$Admin$DataExportConfiguration$Form$validateSftpPrivateKey = function(_v0) {
        var sftpPrivateKey = _v0.Hq;
        var sftpPrivateKeyAlreadySaved = _v0.sN;
        return _Utils_eq(sftpPrivateKey, $elm$core$Maybe$Nothing) && !sftpPrivateKeyAlreadySaved ? _List_fromArray([
            _Utils_Tuple2(6, 'Please enter an SFTP private key.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsValidator = F2(function(destination, encryptionEnabled) {
        return $rtfeldman$elm_validate$Validate$all($elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Utils$Validate$ifInvalidEmail, {
                    abH: false
                }, function($) {
                    return $.L0;
                }, _Utils_Tuple2(0, 'Please enter a contact email.')),
                $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$DataExportConfiguration$Form$validatePhone),
                A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                    return $.NS;
                }, _Utils_Tuple2(2, 'Please select a destination.'))
            ]),
            function() {
                if (!destination.$) {
                    if (!destination.a) {
                        var _v1 = destination.a;
                        return _List_fromArray([
                            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                                return $.Z4;
                            }, _Utils_Tuple2(3, 'Please enter an SFTP host.')),
                            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                                return $.Z5;
                            }, _Utils_Tuple2(4, 'Please enter an SFTP port.')),
                            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                                return $.Z6;
                            }, _Utils_Tuple2(5, 'Please enter an SFTP username.')),
                            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$DataExportConfiguration$Form$validateSftpPrivateKey)
                        ]);
                    } else {
                        var _v2 = destination.a;
                        return _List_fromArray([
                            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                                return $.Zl;
                            }, _Utils_Tuple2(7, 'Please enter an S3 bucket.')),
                            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                                return $.Zm;
                            }, _Utils_Tuple2(8, 'Please enter an S3 region.'))
                        ]);
                    }
                } else return _List_Nil;
            }(),
            encryptionEnabled ? _List_fromArray([
                A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                    return $.OP;
                }, _Utils_Tuple2(9, 'Please enter an encryption key.')),
                A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                    return $.OQ;
                }, _Utils_Tuple2(10, 'Please enter an encryption recipient.'))
            ]) : _List_Nil
        ])));
    });
    var $author$project$Utils$Result$merge = function(result) {
        if (!result.$) {
            var ok = result.a;
            return ok;
        } else {
            var err = result.a;
            return err;
        }
    };
    var $author$project$Components$PhoneInput$validate = function(_v0) {
        var model = _v0;
        return $author$project$Utils$Result$merge(A2($elm$core$Result$map, function(_v1) {
            var form = _v1.a;
            return _Utils_update(model, {
                PU: form
            });
        }, A2($elm$core$Result$mapError, function(form) {
            return _Utils_update(model, {
                PU: form
            });
        }, A2($author$project$Utils$Form$validate, $author$project$Components$PhoneInput$formFieldsValidator(model.agM), model.PU))));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$validate = function(model) {
        var _v0 = model.PU;
        if (!_v0.$) {
            var form = _v0.a;
            var fields = $author$project$Utils$Form$fields(form);
            var formWithValidatedPhone = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                L2: $author$project$Components$PhoneInput$validate(fields.L2)
            }), form);
            var _v1 = fields;
            var destination = _v1.NS;
            var encryptionEnabled = _v1.iD;
            return A2($elm$core$Result$mapError, function(validatedForm) {
                return _Utils_update(model, {
                    PU: $elm$core$Maybe$Just(validatedForm)
                });
            }, A2($elm$core$Result$map, function(_v2) {
                var validatedForm = _v2.a;
                var validFormFields = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: $elm$core$Maybe$Just(validatedForm)
                }), validFormFields);
            }, A2($author$project$Utils$Form$validate, A2($author$project$Components$Admin$DataExportConfiguration$Form$formFieldsValidator, destination, encryptionEnabled), formWithValidatedPhone)));
        } else return $elm$core$Result$Err(model);
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var dataExportConfiguration = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                        zi: _Utils_update(model, {
                            M0: response,
                            PU: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit(dataExportConfiguration)))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                var field = msg.a;
                var _v3 = model.PU;
                if (!_v3.$) {
                    var form = _v3.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                        zi: _Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var _v4 = $author$project$Components$Admin$DataExportConfiguration$Form$validate(model);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newModel = _v5.a;
                    var validFormFields = _v5.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var phoneNumber = A2($elm$core$Maybe$map, $author$project$Utils$Phone$toRecord, $elm$core$List$head(A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Components$PhoneInput$getPhones(fields.L2))));
                    var apiFields = {
                        L0: fields.L0,
                        L2: phoneNumber,
                        NS: A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, fields.NS),
                        OM: fields.OM,
                        OP: fields.OP,
                        OQ: fields.OQ,
                        O9: fields.O9,
                        PG: fields.PG,
                        Ra: fields.my,
                        Zl: fields.Zl,
                        Zm: fields.Zm,
                        Z4: fields.Z4,
                        Z5: fields.Z5,
                        Hq: fields.Hq,
                        Z6: fields.Z6
                    };
                    var cmd = function() {
                        var _v6 = model.aef;
                        if (!_v6.$) {
                            var id = _v6.a;
                            return A4($author$project$Api$Provider$DataExportConfiguration$update, apiClient, id, apiFields, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved);
                        } else return A3($author$project$Api$Provider$DataExportConfiguration$create, apiClient, apiFields, $author$project$Components$Admin$DataExportConfiguration$Form$GotDataExportConfigurationSaved);
                    }();
                    return {
                        EQ: cmd,
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                        zi: _Utils_update(newModel, {
                            j_: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newModel = _v4.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                        zi: newModel,
                        at: _List_Nil
                    };
                }
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var dataExportConfiguration = response.a;
                    var successMsg = function() {
                        var _v8 = model.aef;
                        if (!_v8.$) return 'Settings updated successfully';
                        else return 'Settings created successfully';
                    }();
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$Saved(dataExportConfiguration),
                        zi: _Utils_update(model, {
                            PU: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Components$Admin$DataExportConfiguration$Form$formFieldsInit(dataExportConfiguration))),
                            j_: response
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, successMsg)
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                    zi: _Utils_update(model, {
                        j_: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var _v9 = model.M0;
                if (_v9.$ === 3) {
                    var dataExportConfiguration = _v9.a;
                    var modalModel = $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init($author$project$Api$Provider$DataExportConfiguration$One$toShared(dataExportConfiguration));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                        zi: _Utils_update(model, {
                            kw: $elm$core$Maybe$Just(modalModel)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                var subMsg = msg.a;
                var _v10 = model.kw;
                if (!_v10.$) {
                    var modalModel = _v10.a;
                    var testConnectionModalResult = A3($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update, apiClient, subMsg, modalModel);
                    var testConnectionModal = function() {
                        var _v11 = testConnectionModalResult.adu;
                        if (!_v11) return $elm$core$Maybe$Just(testConnectionModalResult.zi);
                        else return $elm$core$Maybe$Nothing;
                    }();
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg, testConnectionModalResult.EQ),
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                        zi: _Utils_update(model, {
                            kw: testConnectionModal
                        }),
                        at: testConnectionModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var subMsg = msg.a;
                var _v12 = model.PU;
                if (!_v12.$) {
                    var form = _v12.a;
                    var _v13 = $author$project$Utils$Form$fields(form);
                    var contactPhone = _v13.L2;
                    var _v14 = A2($author$project$Components$PhoneInput$update, subMsg, contactPhone);
                    var phoneInput = _v14.a;
                    var cmd = _v14.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$DataExportConfiguration$Form$formFieldsUpdate, $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhone(phoneInput), form);
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg, cmd),
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                        zi: _Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var _v15 = function() {
                    var _v16 = model.aef;
                    if (!_v16.$) {
                        var id = _v16.a;
                        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$Admin$DataExportConfiguration$ExportModal$init, apiClient, id)));
                    } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                }();
                var exportModal = _v15.a;
                var exportModalCmd = _v15.b;
                return {
                    EQ: exportModalCmd,
                    adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                    zi: _Utils_update(model, {
                        iG: exportModal
                    }),
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                var _v17 = model.iG;
                if (!_v17.$) {
                    var exportModal = _v17.a;
                    var exportModalResult = A3($author$project$Components$Admin$DataExportConfiguration$ExportModal$update, apiClient, subMsg, exportModal);
                    var updatedExportModal = function() {
                        var _v18 = exportModalResult.adu;
                        switch(_v18){
                            case 0:
                                return $elm$core$Maybe$Just(exportModalResult.zi);
                            case 1:
                                return $elm$core$Maybe$Nothing;
                            default:
                                return $elm$core$Maybe$Nothing;
                        }
                    }();
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg, exportModalResult.EQ),
                        adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                        zi: _Utils_update(model, {
                            iG: updatedExportModal
                        }),
                        at: exportModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$DataExportConfiguration$Form$None,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Pages$Admin$DataExportSettings$Id_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var dataExportConfigurationFormResult = A3($author$project$Components$Admin$DataExportConfiguration$Form$update, model.Ej, subMsg, model.PU);
        var cmd = function() {
            var _v1 = dataExportConfigurationFormResult.adu;
            if (_v1.$ === 1) return $elm$core$Platform$Cmd$none;
            else return $elm$core$Platform$Cmd$none;
        }();
        return _Utils_Tuple3(_Utils_update(model, {
            PU: dataExportConfigurationFormResult.zi
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dataExportConfigurationFormResult.EQ),
            cmd
        ])), dataExportConfigurationFormResult.at);
    });
    var $author$project$Components$Admin$DataExportConfiguration$Form$UpdateDataExportConfiguration = {
        $: 2
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$backRoute = function(model) {
        return model.s0 ? $author$project$Spa$Generated$Route$Admin__DataExport__Top : $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top;
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$Export = {
        $: 1
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$ConfirmUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewConfirmInput = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(model.hS),
                $author$project$Ui$Form$Checkbox$required(true),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Admin$DataExportConfiguration$ExportModal$ConfirmUpdated)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('By checking this box I confirm that I have verified that both'),
                    $elm$html$Html$text(' the files to be sent and the destination server and path are accurate')
                ]))
            ]))
        ]));
    };
    var $author$project$Api$Provider$DataExportGroup$One$dataExportConfiguration = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$DataExportGroup$Shared$dataExportConfiguration(shared);
    };
    var $author$project$Api$Provider$DataExportGroup$One$dataExports = function(_v0) {
        var record = _v0.b;
        return record.M2;
    };
    var $author$project$Api$Provider$DataExportGroup$One$entityName = function(_v0) {
        var record = _v0.b;
        return record.O0;
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewDataExport = function(dataExport) {
        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$DataExport$Shared$exportFileName(dataExport)))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewPreview = function(previewRequest) {
        if (previewRequest.$ === 3) {
            var dataExportGroup = previewRequest.a;
            var dataExportConfiguration = $author$project$Api$Provider$DataExportGroup$One$dataExportConfiguration(dataExportGroup);
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mb-2')
                ]), _List_fromArray([
                    $elm$html$Html$text('The platform will send the following files to the given destination.')
                ])),
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Entity Name: ')
                ])),
                $elm$html$Html$text($author$project$Api$Provider$DataExportGroup$One$entityName(dataExportGroup)),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Destination: ')
                ])),
                $elm$html$Html$text($author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Files: ')
                ])),
                A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewDataExport, $author$project$Api$Provider$DataExportGroup$One$dataExports(dataExportGroup)))
            ]));
        } else return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]), _List_fromArray([
            $author$project$Ui$Spinner$view(_List_Nil)
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$ExportModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$DataExportConfiguration$ExportModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Export Now')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewPreview(model.sh),
                $author$project$Components$Admin$DataExportConfiguration$ExportModal$viewConfirmInput(model)
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$ExportModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Export Now'
                }, _List_fromArray([
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$ExportModal$Export),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$disabled(!model.hS),
                    $author$project$Ui$Button$loading(_Utils_eq(model.me, $author$project$Api$Data$Loading) || _Utils_eq(model.sh, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Export Now')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnection = {
        $: 1
    };
    var $author$project$Ui$Typography$b = F2(function(options, content) {
        return A2($elm$html$Html$b, $author$project$Ui$Typography$optionsToAttributes(options), content);
    });
    var $author$project$Ui$OrderedList$Item = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$OrderedList$item = $author$project$Ui$OrderedList$Item;
    var $elm$html$Html$pre = _VirtualDom_node('pre');
    var $author$project$Ui$Typography$pre = F2(function(options, content) {
        return A2($elm$html$Html$pre, $author$project$Ui$Typography$optionsToAttributes(options), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), content));
    });
    var $author$project$Ui$Typography$PreWrap = {
        $: 15
    };
    var $author$project$Ui$Typography$preWrap = $author$project$Ui$Typography$PreWrap;
    var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3BucketPolicy = function(bucketName) {
        return A3($elm$core$String$replace, 'NAME_OF_BUCKET', bucketName, '\n{\n  "Version": "2012-10-17",\n  "Statement": [\n    {\n      "Sid": "HintDataExport",\n      "Effect": "Allow",\n      "Principal": {\n        "AWS": "arn:aws:iam::540645937361:root"\n      },\n      "Action": [\n        "s3:GetObject",\n        "s3:PutObject"\n      ],\n      "Resource": [\n        "arn:aws:s3:::NAME_OF_BUCKET",\n        "arn:aws:s3:::NAME_OF_BUCKET/*"\n      ]\n    }\n  ]\n}\n    ');
    };
    var $author$project$Ui$OrderedList$defaultOptions = {
        vD: _List_Nil
    };
    var $author$project$Ui$OrderedList$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            if (!option.$) {
                var padding_ = option.a;
                return _Utils_update(record, {
                    vD: A2($elm$core$List$cons, $author$project$Ui$Padding$toClass(padding_), record.vD)
                });
            } else return _Utils_update(record, {
                vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('i'), record.vD)
            });
        }), $author$project$Ui$OrderedList$defaultOptions, options);
    };
    var $author$project$Ui$OrderedList$itemOptionToAttributes = function(option) {
        var margin_ = option;
        return _List_fromArray([
            $author$project$Ui$Margin$toClass(margin_)
        ]);
    };
    var $author$project$Ui$OrderedList$itemOptionsToAttributes = function(options) {
        return A2($elm$core$List$map, $elm$html$Html$Attributes$map($elm$core$Basics$never), A2($elm$core$List$concatMap, $author$project$Ui$OrderedList$itemOptionToAttributes, options));
    };
    var $author$project$Ui$OrderedList$viewItem = function(item_) {
        var options = item_.a;
        var contents = item_.b;
        return A2($elm$html$Html$li, $author$project$Ui$OrderedList$itemOptionsToAttributes(options), contents);
    };
    var $author$project$Ui$OrderedList$view = F2(function(options, items) {
        var optionsRecord = $author$project$Ui$OrderedList$optionsToRecord(options);
        return A2($elm$html$Html$ol, optionsRecord.vD, A2($elm$core$List$map, $author$project$Ui$OrderedList$viewItem, items));
    });
    var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3Guide = function(dataExportConfiguration) {
        var bucketName = A2($elm$core$Maybe$withDefault, 'NAME_OF_BUCKET', $author$project$Api$Provider$DataExportConfiguration$Shared$s3Bucket(dataExportConfiguration));
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('S3 Configuration Steps')
            ])),
            A2($author$project$Ui$OrderedList$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$OrderedList$item, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Create an S3 bucket named \"'),
                    $elm$html$Html$text(bucketName),
                    $elm$html$Html$text('\". '),
                    A2($author$project$Ui$Typography$b, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Do not use Access Control Lists (ACLS). ')
                    ])),
                    A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You are responsible for the security of your bucket, including requiring encryption at rest, '),
                        $elm$html$Html$text('object locks and replication as appropriate.')
                    ]))
                ])),
                A2($author$project$Ui$OrderedList$item, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Apply the IAM policy below to the bucket'),
                    A2($author$project$Ui$Typography$pre, _List_fromArray([
                        $author$project$Ui$Typography$preWrap
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3BucketPolicy(bucketName))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$view = function(dataExportConfiguration) {
        var _v0 = $author$project$Api$Provider$DataExportConfiguration$Shared$destination(dataExportConfiguration);
        switch(_v0){
            case 's3':
                return $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$s3Guide(dataExportConfiguration);
            case 'sftp':
                return $author$project$Utils$Html$empty;
            default:
                return $author$project$Utils$Html$empty;
        }
    };
    var $author$project$Api$Provider$DataExportConfiguration$Shared$testExportFileName = A2($elm$core$Basics$composeR, $author$project$Api$Provider$DataExportConfiguration$Shared$record, function($) {
        return $.$X;
    });
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestFileDetails = function(dataExportConfiguration) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('mb-2')
            ]), _List_fromArray([
                $elm$html$Html$text('The platform will try to send a test to verify your data export configuration.')
            ])),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Destination: ')
            ])),
            $elm$html$Html$text($author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription(dataExportConfiguration)),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Path: ')
            ])),
            $elm$html$Html$text($author$project$Api$Provider$DataExportConfiguration$Shared$testExportFileName(dataExportConfiguration))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestStatus = function(testResult) {
        switch(testResult.$){
            case 0:
                return $author$project$Utils$Html$empty;
            case 1:
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mb-4')
                ]), _List_fromArray([
                    A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Testing connection...')
                    ]))
                ]));
            case 2:
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mb-4')
                ]), _List_fromArray([
                    A2($author$project$Ui$Alert$success, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Connection test successful!')
                    ]))
                ]));
            default:
                var message = testResult.a;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mb-4')
                ]), _List_fromArray([
                    A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Connection test failed. Please check your configuration and try again.'),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Error: ')
                            ])),
                            $elm$html$Html$text(message)
                        ]))
                    ]))
                ]));
        }
    };
    var $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Test Connection')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestFileDetails(model.M0),
                $author$project$Components$Admin$DataExportConfiguration$ConfigurationGuide$view(model.M0),
                $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$viewTestStatus(model.kx)
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ])),
                function() {
                    var _v0 = model.kx;
                    if (_v0.$ === 1) return A3($author$project$Ui$Button$view, {
                        abP: 'Testing connection'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$loading(true),
                        $author$project$Ui$Button$disabled(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Testing...')
                    ]));
                    else return A3($author$project$Ui$Button$view, {
                        abP: 'Test connection'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$TestConnection)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Test Connection')
                    ]));
                }()
            ]))
        ]));
    };
    var $author$project$Ui$Padding$Left_0_5 = 2;
    var $author$project$Components$Admin$DataExportConfiguration$Form$OpenExportModal = {
        $: 7
    };
    var $author$project$Utils$Form$dirty = function(_v0) {
        var originalFields = _v0.a;
        var fields_ = _v0.c;
        return !_Utils_eq(originalFields, fields_);
    };
    var $author$project$Ui$Button$md = $author$project$Ui$Button$Size(1);
    var $author$project$Ui$Tooltip$Padding = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Tooltip$padding = $author$project$Ui$Tooltip$Padding;
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewExportButton = function(model) {
        var disabled = _Utils_eq(model.aef, $elm$core$Maybe$Nothing) || A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Utils$Form$dirty, model.PU));
        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$placement(0),
            $author$project$Ui$Tooltip$active(disabled),
            $author$project$Ui$Tooltip$wide,
            $author$project$Ui$Tooltip$padding(2)
        ]), 'You must save the settings before you can export data.', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Export Now'
            }, _List_fromArray([
                $author$project$Ui$Button$pull(1),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$Form$OpenExportModal),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                $author$project$Ui$Button$disabled(disabled),
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$md
            ]), _List_fromArray([
                $elm$html$Html$text('Export Now')
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmail = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$Email = {
        $: 4
    };
    var $author$project$Ui$Form$Input$email = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Email);
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewContactEmailInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var contactEmail = _v0.L0;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Contact Email'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', contactEmail)),
                $author$project$Ui$Form$Input$placeholder('example@example.com'),
                $author$project$Ui$Form$Input$email,
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$ContactEmail)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    };
    var $author$project$Components$PhoneInput$PhoneAdded = {
        $: 0
    };
    var $author$project$Formatters$PhoneType$toString = function(type_) {
        switch(type_.$){
            case 0:
                return 'Mobile';
            case 1:
                return 'Home';
            case 2:
                return 'Office';
            default:
                var otherDescription = type_.a;
                return otherDescription;
        }
    };
    var $author$project$Components$PhoneInput$viewAddMore = F2(function(phones, max) {
        return _Utils_cmp($elm$core$List$length(phones), max) < 0;
    });
    var $author$project$Components$PhoneInput$FormFieldUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PhoneInput$PhoneRemoved = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PhoneInput$PhoneType = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Grid$justifyCenter = $author$project$Ui$Grid$Element($author$project$Ui$Element$justifyCenter);
    var $author$project$Components$PhoneInput$PhoneNumber = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PhoneInput$PhoneRegion = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$Input$AutoCorrect = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$autoCorrect = $author$project$Ui$Form$Input$AutoCorrect;
    var $author$project$Ui$Form$Input$MaskedValue = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$Input$maskedValue = $author$project$Ui$Form$Input$MaskedValue;
    var $author$project$Components$PhoneInput$phonePlaceholder = A3($elm$core$String$replace, '#', '5', $author$project$Components$PhoneInput$phoneMask);
    var $author$project$Components$PhoneInput$regionToString = function(region) {
        if (!region) return 'US';
        else return 'Int\'l';
    };
    var $author$project$Ui$Form$Input$SpellCheck = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$spellCheck = $author$project$Ui$Form$Input$SpellCheck;
    var $author$project$Ui$Form$Input$Tel = {
        $: 0
    };
    var $author$project$Ui$Form$Input$tel = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Tel);
    var $author$project$Ui$Form$Input$WithFeedback = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$withFeedback = $author$project$Ui$Form$Input$WithFeedback;
    var $author$project$Components$PhoneInput$viewNumberInput = F5(function(regions, form, regionDropdown, index, phone) {
        var phoneNumber = phone.Gx;
        return $author$project$Ui$Form$Input$group(_List_fromArray([
            A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                $author$project$Ui$Dropdown$ariaLabel('Phone region')
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Components$PhoneInput$regionToString(phone.agE))
            ]), A2($elm$core$List$map, function(region) {
                return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$PhoneInput$FormFieldUpdated(A2($author$project$Components$PhoneInput$PhoneRegion, index, region))),
                    $author$project$Ui$Dropdown$selected(_Utils_eq(region, phone.agE))
                ]), $elm$html$Html$text($author$project$Components$PhoneInput$regionToString(region)));
            }, regions), regionDropdown),
            function() {
                var _v0 = phone.agE;
                if (!_v0) return $author$project$Ui$Form$Input$view(_List_fromArray([
                    A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$PhoneInput$phonePattern, phoneNumber),
                    $author$project$Ui$Form$Input$placeholder($author$project$Components$PhoneInput$phonePlaceholder),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$PhoneInput$FormFieldUpdated, $author$project$Components$PhoneInput$PhoneNumber(index)), $elm$core$String$filter($elm$core$Char$isDigit)), $elm$core$String$left(14))),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, index, form)),
                    $author$project$Ui$Form$Input$autoComplete(false),
                    $author$project$Ui$Form$Input$autoCorrect(false),
                    $author$project$Ui$Form$Input$autoCapitalize(false),
                    $author$project$Ui$Form$Input$spellCheck(false),
                    $author$project$Ui$Form$Input$tel,
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$withFeedback($author$project$Utils$Form$validated(form))
                ]));
                else return $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(phoneNumber),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$PhoneInput$FormFieldUpdated, $author$project$Components$PhoneInput$PhoneNumber(index))),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, index, form)),
                    $author$project$Ui$Form$Input$autoComplete(false),
                    $author$project$Ui$Form$Input$autoCorrect(false),
                    $author$project$Ui$Form$Input$autoCapitalize(false),
                    $author$project$Ui$Form$Input$spellCheck(false),
                    $author$project$Ui$Form$Input$tel,
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$withFeedback($author$project$Utils$Form$validated(form))
                ]));
            }()
        ]));
    });
    var $author$project$Components$PhoneInput$viewPhone = function(max) {
        return function(isRequired) {
            return function(allowRemove) {
                return function(phoneTypes) {
                    return function(regions) {
                        return function(disablePhoneType) {
                            return function(hidePhoneType) {
                                return function(form) {
                                    return function(index) {
                                        return function(_v0) {
                                            var phone = _v0.a;
                                            var typeDropdown = _v0.b;
                                            var regionDropdown = _v0.c;
                                            var phoneInputGridAttrs = hidePhoneType ? (max > 1 || !isRequired) && allowRemove ? _List_fromArray([
                                                $author$project$Ui$Grid$spanSm(11),
                                                $author$project$Ui$Grid$span(10)
                                            ]) : _List_fromArray([
                                                $author$project$Ui$Grid$spanSm(11),
                                                $author$project$Ui$Grid$span(12)
                                            ]) : max === 1 && isRequired || !allowRemove ? _List_fromArray([
                                                $author$project$Ui$Grid$spanSm(8),
                                                $author$project$Ui$Grid$span(12)
                                            ]) : _List_fromArray([
                                                $author$project$Ui$Grid$spanSm(7),
                                                $author$project$Ui$Grid$span(10)
                                            ]);
                                            return A2($author$project$Ui$Grid$row, _List_fromArray([
                                                $author$project$Ui$Grid$rowItemsCenter
                                            ]), $elm$core$List$concat(_List_fromArray([
                                                !hidePhoneType ? _List_fromArray([
                                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                                        $author$project$Ui$Grid$spanSm(4),
                                                        $author$project$Ui$Grid$span(12)
                                                    ]), _List_fromArray([
                                                        A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                                                            $author$project$Ui$Dropdown$disabled(disablePhoneType),
                                                            $author$project$Ui$Dropdown$ariaLabel('Phone type')
                                                        ]), _List_fromArray([
                                                            $elm$html$Html$text($author$project$Formatters$PhoneType$toString(phone.ah5))
                                                        ]), A2($elm$core$List$map, function(phoneType) {
                                                            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                                                $author$project$Ui$Dropdown$onSelect($author$project$Components$PhoneInput$FormFieldUpdated(A2($author$project$Components$PhoneInput$PhoneType, index, $author$project$Formatters$PhoneType$toString(phoneType)))),
                                                                $author$project$Ui$Dropdown$selected(_Utils_eq(phoneType, phone.ah5))
                                                            ]), $elm$html$Html$text($author$project$Formatters$PhoneType$toString(phoneType)));
                                                        }, phoneTypes), typeDropdown)
                                                    ])),
                                                    A2($author$project$Ui$Grid$column, phoneInputGridAttrs, _List_fromArray([
                                                        A5($author$project$Components$PhoneInput$viewNumberInput, regions, form, regionDropdown, index, phone)
                                                    ]))
                                                ]) : _List_fromArray([
                                                    A2($author$project$Ui$Grid$column, phoneInputGridAttrs, _List_fromArray([
                                                        A5($author$project$Components$PhoneInput$viewNumberInput, regions, form, regionDropdown, index, phone)
                                                    ]))
                                                ]),
                                                (max > 1 || !isRequired) && allowRemove ? _List_fromArray([
                                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                                        $author$project$Ui$Grid$spanSm(1),
                                                        $author$project$Ui$Grid$span(2),
                                                        $author$project$Ui$Grid$justifyCenter
                                                    ]), !index && isRequired ? _List_Nil : _List_fromArray([
                                                        A3($author$project$Ui$Button$view, {
                                                            abP: 'Remove phone'
                                                        }, _List_fromArray([
                                                            $author$project$Ui$Button$link,
                                                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                                                            $author$project$Ui$Button$onClick($author$project$Components$PhoneInput$PhoneRemoved(index))
                                                        ]), _List_Nil)
                                                    ]))
                                                ]) : _List_Nil
                                            ])));
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Components$PhoneInput$view = function(_v0) {
        var model = _v0;
        var phones = $author$project$Utils$Form$fields(model.PU);
        var phoneTypes = A2($elm_community$list_extra$List$Extra$uniqueBy, $author$project$Formatters$PhoneType$toString, $elm$core$List$concat(_List_fromArray([
            model.ah6,
            A2($elm$core$List$map, function(_v1) {
                var phone = _v1.a;
                return phone.ah5;
            }, phones)
        ])));
        return A2($elm$html$Html$div, _List_Nil, $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$indexedMap, A8($author$project$Components$PhoneInput$viewPhone, model.y_, model.agM, model.abK, phoneTypes, model.nU, model.ada, model.ms, model.PU), phones),
            A2($author$project$Components$PhoneInput$viewAddMore, phones, model.y_) ? _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var label = A2($elm$core$String$join, ' ', _List_fromArray([
                            'Add',
                            !$elm$core$List$isEmpty(phones) ? 'Another' : '',
                            ' Phone'
                        ]));
                        return A3($author$project$Ui$Button$view, {
                            abP: label
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$PhoneInput$PhoneAdded)
                        ]), _List_fromArray([
                            $elm$html$Html$text(label)
                        ]));
                    }()
                ]))
            ]) : _List_Nil
        ])));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewContactPhoneInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var contactPhone = _v0.L2;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Contact Phone'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Admin$DataExportConfiguration$Form$ContactPhoneInputMsg, $author$project$Components$PhoneInput$view(contactPhone))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$Destination = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$destinationOptions = A2($elm$core$List$map, function(_v0) {
        var destination = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Form$Select$option, _List_Nil, A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, destination), label);
    }, _List_fromArray([
        _Utils_Tuple2($elm$core$Maybe$Nothing, 'Select a destination'),
        _Utils_Tuple2($elm$core$Maybe$Just(0), 'SFTP'),
        _Utils_Tuple2($elm$core$Maybe$Just(1), 'S3')
    ]));
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewDestinationInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var destination = _v0.NS;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Destination')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$Form$destinationToString, destination)),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$Destination)),
                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
            ]), $author$project$Components$Admin$DataExportConfiguration$Form$destinationOptions)
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$Enabled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewEnabledInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var enabled = _v0.OM;
        var manualExportPerformed = _v0.TB;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Enabled')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(enabled),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$Enabled)),
                $author$project$Ui$ToggleSwitch$disabled(!manualExportPerformed)
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Enables data export files to send daily.')
            ])),
            !manualExportPerformed ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text('A manual export has to be performed before enabling daily exports.'),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                $elm$html$Html$text('Click the '),
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('\"Export Now\"')
                ])),
                $elm$html$Html$text(' button below to perform a manual export.')
            ])) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionEnabled = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionEnabledInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var encryptionEnabled = _v0.iD;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Encryption Enabled')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(encryptionEnabled),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionEnabled))
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('When encryption is enabled, the data will be encrypted before it is sent to the destination.')
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKey = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$Errors = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$errors = $author$project$Ui$Form$Textarea$Errors;
    var $author$project$Ui$Form$Textarea$Invalid = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$invalid = $author$project$Ui$Form$Textarea$Invalid;
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionKeyInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var encryptionKey = _v0.OP;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Encryption Key'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', encryptionKey)),
                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionKey)),
                $author$project$Ui$Form$Textarea$invalid(A2($author$project$Utils$Form$hasValidationErrors, 9, form)),
                $author$project$Ui$Form$Textarea$errors(A2($author$project$Utils$Form$validationErrors, 9, form))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipient = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionRecipientInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var encryptionRecipient = _v0.OQ;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Encryption Recipient'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', encryptionRecipient)),
                $author$project$Ui$Form$Input$placeholder('example@example.com'),
                $author$project$Ui$Form$Input$autofocus(true),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$EncryptionRecipient)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 10, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 10, form))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$ExcludeDefaultTables = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewExcludeDefaultTablesInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var excludeDefaultTables = _v0.O9;
        return A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Exclude Default Tables')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(excludeDefaultTables),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$ExcludeDefaultTables))
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('By default, all tables from data export will be sent.'),
                $author$project$Utils$Html$noBreakSpace,
                $elm$html$Html$text('When this is enabled, only the custom tables will be sent.')
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormat = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormatValidation = 11;
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewFileNameFormatInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var fileNameFormat = _v0.PG;
        var destination = _v0.NS;
        return A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('File Name Format')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fileNameFormat)),
                $author$project$Ui$Form$Input$placeholder(':timestamp:/:file_name:'),
                $author$project$Ui$Form$Input$autofocus(true),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$FileNameFormat)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 11, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 11, form))
            ])),
            function() {
                if (!destination.$) {
                    var destination_ = destination.a;
                    return A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('By default, the export will be placed in '),
                        function() {
                            if (!destination_) return $elm$html$Html$text('the home directory of the SFTP user.');
                            else return $elm$html$Html$text('the root of the S3 bucket.');
                        }(),
                        $author$project$Utils$Html$noBreakSpace,
                        $elm$html$Html$text('Only change this if the customers request the file to be placed in a specific directory.'),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $elm$html$Html$text('If that happens add the requested path as prefix to whats already there.'),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $elm$html$Html$text('Example: '),
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(':timestamp:/:file_name:')
                        ])),
                        $elm$html$Html$text(' becomes '),
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('/requested/path/:timestamp:/:file_name:')
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$Incremental = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewIncrementalInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var incremental = _v0.my;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Sync Mode')
        ]), _List_fromArray([
            $author$project$Ui$Button$group(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Full'
                }, _List_fromArray([
                    $author$project$Ui$Button$active(!incremental),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated($author$project$Components$Admin$DataExportConfiguration$Form$Incremental(false)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Full')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Incremental'
                }, _List_fromArray([
                    $author$project$Ui$Button$active(incremental),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated($author$project$Components$Admin$DataExportConfiguration$Form$Incremental(true)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Incremental')
                ]))
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Full: ')
                ])),
                $elm$html$Html$text('Each daily file includes all records.')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Incremental: ')
                ])),
                $elm$html$Html$text('Each daily file includes records that have been created, updated, or deleted within the past 7 days. The first export of the month includes all records.')
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$S3Bucket = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewS3BucketInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var s3Bucket = _v0.Zl;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('S3 Bucket'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', s3Bucket)),
                $author$project$Ui$Form$Input$placeholder('S3 Bucket'),
                $author$project$Ui$Form$Input$autofocus(true),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$S3Bucket)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 7, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 7, form))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$S3Region = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$s3RegionOptions = A2($elm$core$List$map, function(_v0) {
        var region = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Form$Select$option, _List_Nil, region, _Utils_ap(label, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(region_) {
            return ' (' + (region_ + ')');
        }, region))));
    }, _List_fromArray([
        _Utils_Tuple2($elm$core$Maybe$Nothing, 'Select a region'),
        _Utils_Tuple2($elm$core$Maybe$Just('us-east-1'), 'US East (N. Virginia)'),
        _Utils_Tuple2($elm$core$Maybe$Just('us-east-2'), 'US East (Ohio)'),
        _Utils_Tuple2($elm$core$Maybe$Just('us-west-1'), 'US West (N. California)'),
        _Utils_Tuple2($elm$core$Maybe$Just('us-west-2'), 'US West (Oregon)'),
        _Utils_Tuple2($elm$core$Maybe$Just('af-south-1'), 'Africa (Cape Town)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-east-1'), 'Asia Pacific (Hong Kong)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-south-2'), 'Asia Pacific (Hyderabad)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-southeast-3'), 'Asia Pacific (Jakarta)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-southeast-5'), 'Asia Pacific (Malaysia)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-southeast-4'), 'Asia Pacific (Melbourne)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-south-1'), 'Asia Pacific (Mumbai)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-northeast-3'), 'Asia Pacific (Osaka)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-northeast-2'), 'Asia Pacific (Seoul)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-southeast-1'), 'Asia Pacific (Singapore)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-southeast-2'), 'Asia Pacific (Sydney)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-east-2'), 'Asia Pacific (Taipei)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-southeast-7'), 'Asia Pacific (Thailand)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ap-northeast-1'), 'Asia Pacific (Tokyo)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ca-central-1'), 'Canada (Central)'),
        _Utils_Tuple2($elm$core$Maybe$Just('ca-west-1'), 'Canada West (Calgary)'),
        _Utils_Tuple2($elm$core$Maybe$Just('eu-central-1'), 'Europe (Frankfurt)'),
        _Utils_Tuple2($elm$core$Maybe$Just('eu-west-1'), 'Europe (Ireland)'),
        _Utils_Tuple2($elm$core$Maybe$Just('eu-west-2'), 'Europe (London)'),
        _Utils_Tuple2($elm$core$Maybe$Just('eu-south-1'), 'Europe (Milan)'),
        _Utils_Tuple2($elm$core$Maybe$Just('eu-west-3'), 'Europe (Paris)'),
        _Utils_Tuple2($elm$core$Maybe$Just('eu-south-2'), 'Europe (Spain)'),
        _Utils_Tuple2($elm$core$Maybe$Just('eu-north-1'), 'Europe (Stockholm)'),
        _Utils_Tuple2($elm$core$Maybe$Just('eu-central-2'), 'Europe (Zurich)'),
        _Utils_Tuple2($elm$core$Maybe$Just('il-central-1'), 'Israel (Tel Aviv)'),
        _Utils_Tuple2($elm$core$Maybe$Just('mx-central-1'), 'Mexico (Central)'),
        _Utils_Tuple2($elm$core$Maybe$Just('me-south-1'), 'Middle East (Bahrain)'),
        _Utils_Tuple2($elm$core$Maybe$Just('me-central-1'), 'Middle East (UAE)'),
        _Utils_Tuple2($elm$core$Maybe$Just('sa-east-1'), "South America (S\xe3o Paulo)")
    ]));
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewS3RegionInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var s3Region = _v0.Zm;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('S3 Region'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(s3Region),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$S3Region)),
                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 8, form)),
                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 8, form))
            ]), $author$project$Components$Admin$DataExportConfiguration$Form$s3RegionOptions)
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$SftpHost = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpHostInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var sftpHost = _v0.Z4;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('SFTP Host'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', sftpHost)),
                $author$project$Ui$Form$Input$placeholder('sftp.example.com'),
                $author$project$Ui$Form$Input$autofocus(true),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpHost)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPort = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPortInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var sftpPort = _v0.Z5;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('SFTP Port'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, sftpPort))),
                $author$project$Ui$Form$Input$placeholder('22'),
                $author$project$Ui$Form$Input$autofocus(true),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpPort)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 4, form))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKey = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPrivateKeyInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var sftpPrivateKey = _v0.Hq;
        var sftpPrivateKeyAlreadySaved = _v0.sN;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('SFTP Private Key'),
            $author$project$Ui$Form$Group$required(!sftpPrivateKeyAlreadySaved)
        ]), _List_fromArray([
            sftpPrivateKeyAlreadySaved ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Your SFTP private key is saved. Use the space below to edit or change the key.')
            ])) : $author$project$Utils$Html$empty,
            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', sftpPrivateKey)),
                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpPrivateKey)),
                $author$project$Ui$Form$Textarea$invalid(A2($author$project$Utils$Form$hasValidationErrors, 6, form)),
                $author$project$Ui$Form$Textarea$errors(A2($author$project$Utils$Form$validationErrors, 6, form))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsername = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpUsernameInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var sftpUsername = _v0.Z6;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('SFTP Username'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', sftpUsername)),
                $author$project$Ui$Form$Input$placeholder('username'),
                $author$project$Ui$Form$Input$autofocus(true),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$DataExportConfiguration$Form$FormUpdated, $author$project$Components$Admin$DataExportConfiguration$Form$SftpUsername)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 5, form))
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewForm = F2(function(isHintAdmin, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var destination = _v0.NS;
        var encryptionEnabled = _v0.iD;
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Components$Admin$DataExportConfiguration$Form$viewEnabledInput(form),
                $author$project$Components$Admin$DataExportConfiguration$Form$viewContactEmailInput(form),
                $author$project$Components$Admin$DataExportConfiguration$Form$viewContactPhoneInput(form),
                $author$project$Components$Admin$DataExportConfiguration$Form$viewDestinationInput(form)
            ]),
            function() {
                if (!destination.$) {
                    if (!destination.a) {
                        var _v2 = destination.a;
                        return _List_fromArray([
                            $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpHostInput(form),
                            $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPortInput(form),
                            $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpUsernameInput(form),
                            $author$project$Components$Admin$DataExportConfiguration$Form$viewSftpPrivateKeyInput(form)
                        ]);
                    } else {
                        var _v3 = destination.a;
                        return _List_fromArray([
                            $author$project$Components$Admin$DataExportConfiguration$Form$viewS3BucketInput(form),
                            $author$project$Components$Admin$DataExportConfiguration$Form$viewS3RegionInput(form)
                        ]);
                    }
                } else return _List_Nil;
            }(),
            _List_fromArray([
                $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionEnabledInput(form)
            ]),
            encryptionEnabled ? _List_fromArray([
                $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionKeyInput(form),
                $author$project$Components$Admin$DataExportConfiguration$Form$viewEncryptionRecipientInput(form)
            ]) : _List_Nil,
            _List_fromArray([
                $author$project$Components$Admin$DataExportConfiguration$Form$viewIncrementalInput(form)
            ]),
            isHintAdmin ? _List_fromArray([
                $author$project$Components$Admin$DataExportConfiguration$Form$viewExcludeDefaultTablesInput(form),
                $author$project$Components$Admin$DataExportConfiguration$Form$viewFileNameFormatInput(form)
            ]) : _List_Nil
        ]));
    });
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewSaveButton = function(model) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Save settings'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$submit,
            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
        ]), _List_fromArray([
            $elm$html$Html$text('Save')
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$TestConnection = {
        $: 4
    };
    var $author$project$Ui$Icon$TestConnection = 74;
    var $author$project$Ui$Icon$testConnection = $author$project$Ui$Icon$viewIcon(74);
    var $author$project$Components$Admin$DataExportConfiguration$Form$viewTestConnectionButton = function(model) {
        var disabled = function() {
            var _v0 = model.aef;
            if (!_v0.$) return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Utils$Form$dirty, model.PU));
            else return true;
        }();
        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$placement(0),
            $author$project$Ui$Tooltip$active(disabled),
            $author$project$Ui$Tooltip$wide,
            $author$project$Ui$Tooltip$padding(2)
        ]), 'You must save the settings before you can test the connection.', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Test Connection'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$Admin$DataExportConfiguration$Form$TestConnection),
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$icon($author$project$Ui$Icon$testConnection),
                $author$project$Ui$Button$disabled(disabled)
            ]), _List_fromArray([
                $elm$html$Html$text('Test Connection')
            ]))
        ]));
    };
    var $author$project$Components$Admin$DataExportConfiguration$Form$view = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$html$Html$map($author$project$Components$Admin$DataExportConfiguration$Form$TestConnectionModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view, model.kw))),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$html$Html$map($author$project$Components$Admin$DataExportConfiguration$Form$ExportModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$view, model.iG))),
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$autocomplete(false),
                $author$project$Ui$Form$onSubmit($author$project$Components$Admin$DataExportConfiguration$Form$UpdateDataExportConfiguration)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            function() {
                                var _v1 = _Utils_Tuple2(model.aef, model.s0);
                                if (!_v1.a.$) {
                                    if (_v1.b) return $author$project$Utils$Html$empty;
                                    else return $elm$html$Html$text('Edit');
                                } else {
                                    var _v2 = _v1.a;
                                    return $elm$html$Html$text('Add data export settings');
                                }
                            }()
                        ]), _List_fromArray([
                            model.s0 ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$pull(1)
                            ]), _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Components$Admin$DataExportConfiguration$Form$backRoute(model), _List_Nil, _List_fromArray([
                                    $author$project$Ui$Icon$cross(_List_Nil)
                                ]))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, function() {
                        var _v3 = model.PU;
                        if (!_v3.$) {
                            var form = _v3.a;
                            return A2($author$project$Components$Admin$DataExportConfiguration$Form$viewForm, model.F3, form);
                        } else return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Panel$footer, _List_fromArray([
                        $author$project$Ui$Element$justifyCenter,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Components$Admin$DataExportConfiguration$Form$backRoute(model), _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Back')
                        ])),
                        $author$project$Components$Admin$DataExportConfiguration$Form$viewSaveButton(model),
                        $author$project$Components$Admin$DataExportConfiguration$Form$viewTestConnectionButton(model),
                        $author$project$Components$Admin$DataExportConfiguration$Form$viewExportButton(model)
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$DataExportSettings$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$DataExportConfiguration$Form$view(model.PU))
            ]),
            $2: 'Admin | Data Exporter | Settings'
        };
    };
    var $author$project$Pages$Admin$DataExportSettings$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$DataExportSettings$Id_String$init,
        aeR: $author$project$Pages$Admin$DataExportSettings$Id_String$load,
        ag3: $author$project$Pages$Admin$DataExportSettings$Id_String$save,
        ahE: $author$project$Pages$Admin$DataExportSettings$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$DataExportSettings$Id_String$update,
        aid: $author$project$Pages$Admin$DataExportSettings$Id_String$view
    });
    var $author$project$Pages$Admin$DataExportSettings$New$DataExportConfigurationFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$DataExportSettings$New$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var singleton = _Utils_eq(A2($elm$core$Dict$get, 'singleton', query), $elm$core$Maybe$Just('true'));
        var _v3 = A4($author$project$Components$Admin$DataExportConfiguration$Form$init, shared.Ej, $author$project$Shared$isHintAdmin(shared), $elm$core$Maybe$Nothing, singleton);
        var form = _v3.a;
        var cmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form,
            s0: singleton
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$DataExportSettings$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$DataExportSettings$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$DataExportSettings$New$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$DataExportConfiguration$Form$subscriptions(model.PU));
    };
    var $author$project$Api$Provider$DataExportConfiguration$One$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$id(shared);
    };
    var $author$project$Pages$Admin$DataExportSettings$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var dataExportConfigurationFormResult = A3($author$project$Components$Admin$DataExportConfiguration$Form$update, model.Ej, subMsg, model.PU);
        var cmd = function() {
            var _v1 = dataExportConfigurationFormResult.adu;
            if (_v1.$ === 1) {
                var dataExportConfiguration = _v1.a;
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$fromList(_List_fromArray([
                    _Utils_Tuple2('singleton', model.s0 ? 'true' : 'false')
                ])), $author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String({
                    aef: $author$project$Api$Provider$DataExportConfiguration$One$id(dataExportConfiguration)
                }));
            } else return $elm$core$Platform$Cmd$none;
        }();
        return _Utils_Tuple3(_Utils_update(model, {
            PU: dataExportConfigurationFormResult.zi
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dataExportConfigurationFormResult.EQ),
            cmd
        ])), dataExportConfigurationFormResult.at);
    });
    var $author$project$Pages$Admin$DataExportSettings$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$DataExportConfiguration$Form$view(model.PU))
            ]),
            $2: 'Admin | Data Exporter | Settings'
        };
    };
    var $author$project$Pages$Admin$DataExportSettings$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$DataExportSettings$New$init,
        aeR: $author$project$Pages$Admin$DataExportSettings$New$load,
        ag3: $author$project$Pages$Admin$DataExportSettings$New$save,
        ahE: $author$project$Pages$Admin$DataExportSettings$New$subscriptions,
        aaO: $author$project$Pages$Admin$DataExportSettings$New$update,
        aid: $author$project$Pages$Admin$DataExportSettings$New$view
    });
    var $author$project$Pages$Admin$DataExportSettings$Top$GotDataExportConfigurations = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$DataExportConfiguration$All$DataExportConfiguration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DataExportConfiguration$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DataExportConfiguration$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DataExportConfiguration$listDefaults = {
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Provider$DataExportConfiguration$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$DataExportConfiguration$listDefaults);
        return $author$project$Api$Pagination$toApiParams(options.af_);
    };
    var $author$project$Api$Provider$DataExportConfiguration$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$DataExportConfiguration$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$DataExportConfiguration$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$DataExportConfiguration$dataExportConfigurationsPath)));
    });
    var $author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations = function(model) {
        return A3($author$project$Api$Provider$DataExportConfiguration$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_
            });
        }, $author$project$Pages$Admin$DataExportSettings$Top$GotDataExportConfigurations);
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var query = _v3.Bz;
        var model = {
            Ej: apiClient,
            qf: $author$project$Api$Data$NotAsked,
            iG: $elm$core$Maybe$Nothing,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            kw: $elm$core$Maybe$Nothing
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations(model));
    });
    var $author$project$Pages$Admin$DataExportSettings$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$DataExportSettings$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$subscriptions, model.kw))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$subscriptions, model.iG)))
        ]));
    };
    var $author$project$Api$Provider$DataExportConfiguration$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$id(shared);
    };
    var $author$project$Api$Provider$DataExportConfiguration$All$toShared = function(_v0) {
        var shared = _v0;
        return shared;
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__DataExportSettings__Top)
        ]), $author$project$Api$Pagination$toPageQuery(model.af_)));
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var dataExportConfigurations = response.a;
                    var headers = response.b;
                    var cmd = function() {
                        var _v2 = _Utils_Tuple2($elm$core$List$length(dataExportConfigurations), $elm$core$List$head(dataExportConfigurations));
                        _v2$2: while(true)switch(_v2.a){
                            case 0:
                                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$fromList(_List_fromArray([
                                    _Utils_Tuple2('singleton', 'true')
                                ])), $author$project$Spa$Generated$Route$Admin__DataExportSettings__New);
                            case 1:
                                if (!_v2.b.$) {
                                    var dataExportConfiguration = _v2.b.a;
                                    return A2($author$project$Utils$Route$navigate, $elm$core$Dict$fromList(_List_fromArray([
                                        _Utils_Tuple2('singleton', 'true')
                                    ])), $author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String({
                                        aef: $author$project$Api$Provider$DataExportConfiguration$All$id(dataExportConfiguration)
                                    }));
                                } else break _v2$2;
                            default:
                                break _v2$2;
                        }
                        return $elm$core$Platform$Cmd$none;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        qf: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$DataExportSettings$Top$fetchDataExportConfigurations(newModel),
                    $author$project$Pages$Admin$DataExportSettings$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var dataExportConfiguration = msg.a;
                var modalModel = $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$init($author$project$Api$Provider$DataExportConfiguration$All$toShared(dataExportConfiguration));
                return _Utils_Tuple3(_Utils_update(model, {
                    kw: $elm$core$Maybe$Just(modalModel)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v3 = model.kw;
                if (!_v3.$) {
                    var modalModel = _v3.a;
                    var testConnectionModalResult = A3($author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$update, model.Ej, subMsg, modalModel);
                    var testConnectionModal = function() {
                        var _v4 = testConnectionModalResult.adu;
                        if (!_v4) return $elm$core$Maybe$Just(testConnectionModalResult.zi);
                        else return $elm$core$Maybe$Nothing;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        kw: testConnectionModal
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg, testConnectionModalResult.EQ), testConnectionModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var id = msg.a;
                var _v5 = A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$Admin$DataExportConfiguration$ExportModal$init, model.Ej, id)));
                var exportModal = _v5.a;
                var exportModalCmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    iG: exportModal
                }), exportModalCmd, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v6 = model.iG;
                if (!_v6.$) {
                    var exportModal = _v6.a;
                    var exportModalResult = A3($author$project$Components$Admin$DataExportConfiguration$ExportModal$update, model.Ej, subMsg, exportModal);
                    var updatedExportModal = function() {
                        var _v7 = exportModalResult.adu;
                        switch(_v7){
                            case 0:
                                return $elm$core$Maybe$Just(exportModalResult.zi);
                            case 1:
                                return $elm$core$Maybe$Nothing;
                            default:
                                return $elm$core$Maybe$Nothing;
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        iG: updatedExportModal
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg, exportModalResult.EQ), exportModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$DataExportSettings$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Column$NonSortable = {
        $: 1
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'destination', false, 'Destination'),
        A3($author$project$Api$Column$init, 'enabled', false, 'Enabled')
    ]);
    var $author$project$Pages$Admin$DataExportSettings$Top$OpenExportModal = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$TestConnection = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$DataExportConfiguration$All$enabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DataExportConfiguration$Shared$enabled(shared);
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$viewDataExportConfiguration = function(dataExportConfiguration) {
        var id = $author$project$Api$Provider$DataExportConfiguration$All$id(dataExportConfiguration);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Admin$DataExportConfiguration$Utils$destinationDescription($author$project$Api$Provider$DataExportConfiguration$All$toShared(dataExportConfiguration)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Provider$DataExportConfiguration$All$enabled(dataExportConfiguration)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$minWidth('11rem'),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String({
                    aef: id
                }), _List_fromArray([
                    $author$project$Ui$Link$sm,
                    $author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Test Connection'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$DataExportSettings$Top$TestConnection(dataExportConfiguration)),
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$testConnection)
                ]), _List_fromArray([
                    $elm$html$Html$text('Test Connection')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Export Now'
                }, _List_fromArray([
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$DataExportSettings$Top$OpenExportModal(id)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm
                ]), _List_fromArray([
                    $elm$html$Html$text('Export Now')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.qf;
            if (_v1.$ === 3) {
                var dataExportConfigurations_ = _v1.a;
                return _Utils_Tuple2(false, dataExportConfigurations_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var dataExportConfigurations = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                $elm$html$Html$text('Manage settings.')
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No settings found.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Admin$DataExportSettings$Top$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Pages$Admin$DataExportSettings$Top$viewDataExportConfiguration, dataExportConfigurations), _List_Nil)
        ]);
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$html$Html$map($author$project$Pages$Admin$DataExportSettings$Top$TestConnectionModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$TestConnectionModal$view, model.kw))),
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$html$Html$map($author$project$Pages$Admin$DataExportSettings$Top$ExportModalMsg), A2($elm$core$Maybe$map, $author$project$Components$Admin$DataExportConfiguration$ExportModal$view, model.iG))),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__DataExportSettings__New, _List_fromArray([
                            $author$project$Ui$Link$buttonDefault,
                            $author$project$Ui$Link$pull(1),
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('New Data Exporter')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Admin$DataExportSettings$Top$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        function() {
                            var _v0 = model.qf;
                            if (_v0.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Admin$DataExportSettings$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_));
                            else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Admin | Data Exporter | Settings'
        };
    };
    var $author$project$Pages$Admin$DataExportSettings$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$DataExportSettings$Top$init,
        aeR: $author$project$Pages$Admin$DataExportSettings$Top$load,
        ag3: $author$project$Pages$Admin$DataExportSettings$Top$save,
        ahE: $author$project$Pages$Admin$DataExportSettings$Top$subscriptions,
        aaO: $author$project$Pages$Admin$DataExportSettings$Top$update,
        aid: $author$project$Pages$Admin$DataExportSettings$Top$view
    });
    var $author$project$Pages$Admin$Developers$ApiKeys$GotManagedPartner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$hasManagedPartner = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Qt;
    });
    var $author$project$Api$Provider$ManagedPartner$One$ManagedPartner = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ManagedPartner$Shared$ManagedPartner = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ManagedPartner$Shared$Record = F3(function(id, webhooksSignatureApiKey, sandboxEnabled) {
        return {
            aef: id,
            Zo: sandboxEnabled,
            abm: webhooksSignatureApiKey
        };
    });
    var $author$project$Api$Provider$ApiKey$Shared$ApiKey = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ApiKey$Shared$Record = F6(function(id, token, label, createdAt, lastUsedAt, deactivatedAt) {
        return {
            Mx: createdAt,
            Ni: deactivatedAt,
            aef: id,
            aeI: label,
            S$: lastUsedAt,
            aaf: token
        };
    });
    var $author$project$Api$Provider$ApiKey$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deactivated_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_used_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'token', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ApiKey$Shared$Record)))))));
    var $author$project$Api$Provider$ApiKey$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ApiKey$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ManagedPartner$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sandbox_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'webhooks_signature_api_key', $elm$json$Json$Decode$nullable($author$project$Api$Provider$ApiKey$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$Shared$Record))));
    var $author$project$Api$Provider$ManagedPartner$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ManagedPartner$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ManagedPartner$One$Record = function(integration) {
        return {
            Rn: integration
        };
    };
    var $author$project$Api$Provider$Integration$Shared$Integration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Shared$Record = F3(function(id, status, authorizationCode) {
        return {
            JS: authorizationCode,
            aef: id,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Integration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'authorization_code', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Shared$Record))));
    var $author$project$Api$Provider$Integration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ManagedPartner$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Integration$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$One$Record));
    var $author$project$Api$Provider$ManagedPartner$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ManagedPartner$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ManagedPartner$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ManagedPartner$One$ManagedPartner)));
    var $author$project$Api$Provider$ManagedPartner$managedPartnerPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'managed_partner'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagedPartner$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$ManagedPartner$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$managedPartnerPath));
    });
    var $author$project$Pages$Admin$Developers$ApiKeys$init = F4(function(session, practice, shared, _v0) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            iW: $elm$core$Maybe$Nothing,
            rp: $author$project$Api$Data$Loading,
            jm: $elm$core$Maybe$Nothing,
            HO: shared.HO
        }, $author$project$Api$Provider$Practice$One$hasManagedPartner(practice) ? A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Ej, $author$project$Pages$Admin$Developers$ApiKeys$GotManagedPartner) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)));
    });
    var $author$project$Pages$Admin$Developers$ApiKeys$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Developers$ApiKeys$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$CancelEdit = {
        $: 4
    };
    var $author$project$Components$Developers$ManageApiKeys$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Developers$ManageApiKeys$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Developers$ManageApiKeys$CancelEdit)), model.F6)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Developers$ManageApiKeys$HiConfirmClosed), model.$8))
        ]));
    };
    var $author$project$Pages$Admin$Developers$ApiKeys$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageApiKeys$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg)), model.jm)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageApiKeys$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg)), model.iW))
        ]));
    };
    var $author$project$Components$Developers$ManageApiKeys$Integration = 1;
    var $author$project$Components$Developers$ManageApiKeys$Partner = 0;
    var $author$project$Components$Developers$ManageApiKeys$GotManagedPartner = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$Model = $elm$core$Basics$identity;
    var $author$project$Components$Developers$ManageApiKeys$GotApiKeys = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'managed_partner',
        'api_keys'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ApiKey$All$ApiKey = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ApiKey$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ApiKey$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ManagedPartner$ApiKey$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ApiKey$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath));
    });
    var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'managed_partner',
        'integration',
        'api_keys'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ApiKey$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath));
    });
    var $author$project$Components$Developers$ManageApiKeys$fetchApiKeys = F2(function(apiClient, owner) {
        if (!owner) return A2($author$project$Api$Provider$ManagedPartner$ApiKey$list, apiClient, $author$project$Components$Developers$ManageApiKeys$GotApiKeys);
        else return A2($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$list, apiClient, $author$project$Components$Developers$ManageApiKeys$GotApiKeys);
    });
    var $author$project$Components$Developers$ManageApiKeys$init = F3(function(apiClient, timeFormatter, owner) {
        var model = {
            bQ: $author$project$Api$Data$Loading,
            $8: $elm$core$Maybe$Nothing,
            F6: $elm$core$Maybe$Nothing,
            rp: $author$project$Api$Data$NotAsked,
            VM: owner,
            HO: timeFormatter,
            bI: $elm$core$Set$empty,
            dq: $elm$core$Set$empty
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, owner),
            function() {
                if (!owner) return A2($author$project$Api$Provider$ManagedPartner$retrieve, apiClient, $author$project$Components$Developers$ManageApiKeys$GotManagedPartner);
                else return $elm$core$Platform$Cmd$none;
            }()
        ])));
    });
    var $author$project$Api$Provider$ManagedPartner$One$integration = function(_v0) {
        var record = _v0.b;
        return record.Rn;
    };
    var $author$project$Components$Developers$ManageApiKeys$Created = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$Deleted = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$Updated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$WebhooksSignatureApiKeyUpdated = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Ports$Clipboard$clipboardCopyPort = _Platform_outgoingPort('clipboardCopyPort', $elm$json$Json$Encode$string);
    var $author$project$Ports$Clipboard$copy = function(string) {
        return $author$project$Ports$Clipboard$clipboardCopyPort(string);
    };
    var $author$project$Api$Provider$ApiKey$One$ApiKey = 0;
    var $author$project$Api$Provider$ApiKey$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$ManagedPartner$ApiKey$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('api_key', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', $elm$json$Json$Encode$string(params.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$ApiKey$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath)));
    });
    var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('api_key', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', $elm$json$Json$Encode$string(params.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$ApiKey$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath)));
    });
    var $author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$ManagedPartner$ApiKey$apiKeysPath);
    };
    var $author$project$Api$Provider$ManagedPartner$ApiKey$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath(id_)));
    });
    var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeysPath);
    };
    var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath(id_)));
    });
    var $author$project$Api$Provider$ApiKey$Shared$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Provider$ApiKey$All$label = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ApiKey$Shared$label(shared);
    };
    var $author$project$Components$Developers$ManageApiKeys$formFieldsFromItem = function(apiKey) {
        return {
            aeI: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$ApiKey$All$label(apiKey))
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$formFieldsInit = {
        aeI: ''
    };
    var $author$project$Components$Developers$ManageApiKeys$formFieldsUpdate = F2(function(field, fields) {
        var string = field;
        return _Utils_update(fields, {
            aeI: string
        });
    });
    var $author$project$Components$Developers$ManageApiKeys$ApiKeyLabelValidation = 0;
    var $author$project$Components$Developers$ManageApiKeys$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.aeI;
        }, _Utils_Tuple2(0, 'Please enter a label.'))
    ]));
    var $author$project$Api$Provider$ApiKey$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$ApiKey$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ApiKey$Shared$id(shared);
    };
    var $author$project$Api$Provider$ManagedPartner$ApiKey$update = F4(function(apiClient, id_, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('api_key', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', $elm$json$Json$Encode$string(params.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$ApiKey$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$ApiKey$apiKeyPath(id_))));
    });
    var $author$project$Api$Provider$ManagedPartner$Integration$ApiKey$update = F4(function(apiClient, id_, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('api_key', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', $elm$json$Json$Encode$string(params.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$ApiKey$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$apiKeyPath(id_))));
    });
    var $author$project$Api$Provider$ManagedPartner$updateWebhooksSignatureApiKey = F3(function(apiClient, id_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhooks_signature_api_key', $author$project$Utils$Encode$association(id_))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$ManagedPartner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'webhooks_signature_api_key'
        ]), $author$project$Api$Provider$ManagedPartner$managedPartnerPath))));
    });
    var $author$project$Components$Developers$ManageApiKeys$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    bQ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    rp: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Developers$ManageApiKeys$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var apiKey = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(apiKey), $author$project$Utils$Form$init($author$project$Components$Developers$ManageApiKeys$formFieldsFromItem(apiKey)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var field = msg.a;
                var _v2 = model.F6;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var maybeApiKey = _v3.a;
                    var form = _v3.b;
                    var request = _v3.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeApiKey, A3($author$project$Utils$Form$update, $author$project$Components$Developers$ManageApiKeys$formFieldsUpdate, field, form), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var maybeApiKey = msg.a;
                var form = msg.b;
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Developers$ManageApiKeys$formFieldsValidator, form);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var validatedForm = _v5.a;
                    var validFormFields = _v5.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var cmd = function() {
                        if (maybeApiKey.$ === 1) {
                            var _v7 = model.VM;
                            if (!_v7) return A3($author$project$Api$Provider$ManagedPartner$ApiKey$create, apiClient, {
                                aeI: fields.aeI
                            }, $author$project$Components$Developers$ManageApiKeys$Created);
                            else return A3($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$create, apiClient, {
                                aeI: fields.aeI
                            }, $author$project$Components$Developers$ManageApiKeys$Created);
                        } else {
                            var apiKey = maybeApiKey.a;
                            var _v8 = model.VM;
                            if (!_v8) return A4($author$project$Api$Provider$ManagedPartner$ApiKey$update, apiClient, $author$project$Api$Provider$ApiKey$All$id(apiKey), {
                                aeI: fields.aeI
                            }, $author$project$Components$Developers$ManageApiKeys$Updated);
                            else return A4($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$update, apiClient, $author$project$Api$Provider$ApiKey$All$id(apiKey), {
                                aeI: fields.aeI
                            }, $author$project$Components$Developers$ManageApiKeys$Updated);
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeApiKey, validatedForm, $author$project$Api$Data$Loading))
                    }), cmd, _List_Nil);
                } else {
                    var validatedForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeApiKey, validatedForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 7:
                var response = msg.a;
                var _v9 = model.F6;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var maybeApiKey = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        bQ: $author$project$Api$Data$Loading,
                        F6: $elm$core$Maybe$Nothing
                    }), A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.VM), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'API key created.')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeApiKey, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                var _v12 = model.F6;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var maybeApiKey = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        bQ: $author$project$Api$Data$Loading,
                        F6: $elm$core$Maybe$Nothing
                    }), A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.VM), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'API key updated.')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeApiKey, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var apiKey = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Just(apiKey)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var apiKey = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var deleteCmd = function() {
                        var _v15 = model.VM;
                        if (!_v15) return A3($author$project$Api$Provider$ManagedPartner$ApiKey$delete, apiClient, $author$project$Api$Provider$ApiKey$All$id(apiKey), $author$project$Components$Developers$ManageApiKeys$Deleted);
                        else return A3($author$project$Api$Provider$ManagedPartner$Integration$ApiKey$delete, apiClient, $author$project$Api$Provider$ApiKey$All$id(apiKey), $author$project$Components$Developers$ManageApiKeys$Deleted);
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Nothing
                    }), deleteCmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bQ: $author$project$Api$Data$Loading
                }), A2($author$project$Components$Developers$ManageApiKeys$fetchApiKeys, apiClient, model.VM), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'API key deleted.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 12:
                var apiKey = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    bI: A2($elm$core$Set$insert, $author$project$Api$Provider$ApiKey$All$id(apiKey), model.bI)
                }), A3($author$project$Api$Provider$ManagedPartner$updateWebhooksSignatureApiKey, apiClient, $author$project$Api$Provider$ApiKey$All$id(apiKey), $author$project$Components$Developers$ManageApiKeys$WebhooksSignatureApiKeyUpdated(apiKey)), _List_Nil);
            case 13:
                var apiKey = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    rp: response,
                    bI: A2($elm$core$Set$remove, $author$project$Api$Provider$ApiKey$All$id(apiKey), model.bI)
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Webhooks signature API key updated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    bI: A2($elm$core$Set$remove, $author$project$Api$Provider$ApiKey$All$id(apiKey), model.bI)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                var tokenStr = msg.a;
                var visibleApiKeyTokens = A2($elm$core$Set$member, tokenStr, model.dq) ? A2($elm$core$Set$remove, tokenStr, model.dq) : A2($elm$core$Set$insert, tokenStr, model.dq);
                return _Utils_Tuple3(_Utils_update(model, {
                    dq: visibleApiKeyTokens
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var tokenStr = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(tokenStr), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard.')
                ]));
        }
    });
    var $author$project$Pages$Admin$Developers$ApiKeys$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var managedPartner = response.a;
                    var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
                    if (!_v2.$) {
                        var _v3 = A3($author$project$Components$Developers$ManageApiKeys$init, model.Ej, model.HO, 0);
                        var partnerApiKeys = _v3.a;
                        var partnerCmd = _v3.b;
                        var _v4 = A3($author$project$Components$Developers$ManageApiKeys$init, model.Ej, model.HO, 1);
                        var integrationApiKeys = _v4.a;
                        var integrationCmd = _v4.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            iW: $elm$core$Maybe$Just(integrationApiKeys),
                            rp: response,
                            jm: $elm$core$Maybe$Just(partnerApiKeys)
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg, partnerCmd),
                            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg, integrationCmd)
                        ])), _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        rp: response
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    rp: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v5 = model.jm;
                if (!_v5.$) {
                    var partnerApiKeys = _v5.a;
                    var _v6 = A3($author$project$Components$Developers$ManageApiKeys$update, model.Ej, subMsg, partnerApiKeys);
                    var updated = _v6.a;
                    var cmd = _v6.b;
                    var outMsgs = _v6.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        jm: $elm$core$Maybe$Just(updated)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg, cmd), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v7 = model.iW;
                if (!_v7.$) {
                    var integrationApiKeys = _v7.a;
                    var _v8 = A3($author$project$Components$Developers$ManageApiKeys$update, model.Ej, subMsg, integrationApiKeys);
                    var updated = _v8.a;
                    var cmd = _v8.b;
                    var outMsgs = _v8.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        iW: $elm$core$Maybe$Just(updated)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg, cmd), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Developers$ManageApiKeys$CopyToken = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$Delete = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$Edit = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$New = {
        $: 2
    };
    var $author$project$Components$Developers$ManageApiKeys$ToggleToken = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$UseForWebhooksSignature = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Ui$Icon$Copy = 15;
    var $author$project$Ui$Icon$copy = $author$project$Ui$Icon$viewIcon(15);
    var $author$project$Api$Provider$ApiKey$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$ApiKey$All$createdAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ApiKey$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$ApiKey$Shared$deactivatedAt = function(_v0) {
        var record = _v0;
        return record.Ni;
    };
    var $author$project$Api$Provider$ApiKey$All$deactivatedAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ApiKey$Shared$deactivatedAt(shared);
    };
    var $author$project$Api$Provider$ApiKey$Shared$lastUsedAt = function(_v0) {
        var record = _v0;
        return record.S$;
    };
    var $author$project$Api$Provider$ApiKey$All$lastUsedAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ApiKey$Shared$lastUsedAt(shared);
    };
    var $author$project$Api$Provider$ApiKey$Shared$token = function(_v0) {
        var record = _v0;
        return record.aaf;
    };
    var $author$project$Api$Provider$ApiKey$All$token = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ApiKey$Shared$token(shared);
    };
    var $author$project$Components$Developers$ManageApiKeys$viewDeleteButton = F4(function(disabled, loading, apiKey, onDelete) {
        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$active(disabled),
            $author$project$Ui$Tooltip$padding(2)
        ]), 'Can\'t remove the API key used for webhooks signature.', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Delete API key'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$loading(loading),
                $author$project$Ui$Button$onClick(onDelete(apiKey)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                $author$project$Ui$Button$disabled(disabled)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete')
            ]))
        ]));
    });
    var $author$project$Components$Developers$ManageApiKeys$viewEditButton = F3(function(loading, apiKey, onEdit) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Edit API key'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$onClick(onEdit(apiKey)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
            $author$project$Ui$Button$loading(loading)
        ]), _List_fromArray([
            $elm$html$Html$text('Edit')
        ]));
    });
    var $author$project$Ui$Icon$Visibility = 52;
    var $author$project$Ui$Icon$visibility = $author$project$Ui$Icon$viewIcon(52);
    var $author$project$Ui$Icon$VisibilityOff = 53;
    var $author$project$Ui$Icon$visibilityOff = $author$project$Ui$Icon$viewIcon(53);
    var $author$project$Components$Developers$ManageApiKeys$viewApiKeyRow = F2(function(config, apiKey) {
        var tokenStr = $author$project$Api$Provider$ApiKey$All$token(apiKey);
        var visible = A2($elm$core$Set$member, tokenStr, config.dq);
        var statusBadge = function() {
            var _v2 = $author$project$Api$Provider$ApiKey$All$deactivatedAt(apiKey);
            if (!_v2.$) return A2($author$project$Ui$Badge$view, _List_fromArray([
                $author$project$Ui$Badge$danger
            ]), _List_fromArray([
                $elm$html$Html$text('Deactivated')
            ]));
            else return A2($author$project$Ui$Badge$view, _List_fromArray([
                $author$project$Ui$Badge$success
            ]), _List_fromArray([
                $elm$html$Html$text('Active')
            ]));
        }();
        var loading = A2($elm$core$Set$member, $author$project$Api$Provider$ApiKey$All$id(apiKey), config.bI);
        var _v0 = visible ? _Utils_Tuple2($author$project$Ui$Icon$visibilityOff, 'Hide token') : _Utils_Tuple2($author$project$Ui$Icon$visibility, 'Show token');
        var visibleIcon = _v0.a;
        var visibleAriaLabel = _v0.b;
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, "\u2014", $author$project$Api$Provider$ApiKey$All$label(apiKey)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), visible ? _List_fromArray([
                    $elm$html$Html$text(tokenStr)
                ]) : _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$String$repeat, $elm$core$String$length(tokenStr) - 4, "\u2022")),
                    $elm$html$Html$text(A2($elm$core$String$right, 4, tokenStr))
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: visibleAriaLabel
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick(config.GC(tokenStr)),
                    $author$project$Ui$Button$icon(visibleIcon),
                    $author$project$Ui$Button$margin(10)
                ]), _List_Nil),
                A3($author$project$Ui$Button$view, {
                    abP: 'Copy token'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick(config.GB(tokenStr)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                    $author$project$Ui$Button$margin(10)
                ]), _List_Nil)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2(config.HO, 5, $author$project$Api$Provider$ApiKey$All$createdAt(apiKey)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Never', A2($elm$core$Maybe$map, config.HO(5), $author$project$Api$Provider$ApiKey$All$lastUsedAt(apiKey))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                statusBadge
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), function() {
                var _v1 = config.GD;
                if (!_v1.$) {
                    var onUseForWebhooksSignature = _v1.a;
                    var isWebhooksSignatureKey = _Utils_eq($elm$core$Maybe$Just($author$project$Api$Provider$ApiKey$All$id(apiKey)), config.H5);
                    return isWebhooksSignatureKey ? _List_fromArray([
                        A2($author$project$Ui$Badge$view, _List_fromArray([
                            $author$project$Ui$Badge$info
                        ]), _List_fromArray([
                            $elm$html$Html$text('Webhooks Signature')
                        ])),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$padding(2)
                        ]), _List_fromArray([
                            A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, apiKey, config.rJ)
                        ])),
                        A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, true, loading, apiKey, config.rI)
                    ]) : _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Use API key for webhooks signature'
                        }, _List_fromArray([
                            $author$project$Ui$Button$secondary,
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick(onUseForWebhooksSignature(apiKey)),
                            $author$project$Ui$Button$loading(loading)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Use for webhooks signature')
                        ])),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$padding(2)
                        ]), _List_fromArray([
                            A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, apiKey, config.rJ)
                        ])),
                        A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, false, loading, apiKey, config.rI)
                    ]);
                } else return _List_fromArray([
                    A3($author$project$Components$Developers$ManageApiKeys$viewEditButton, loading, apiKey, config.rJ),
                    A4($author$project$Components$Developers$ManageApiKeys$viewDeleteButton, false, loading, apiKey, config.rI)
                ]);
            }())
        ]));
    });
    var $author$project$Components$Developers$ManageApiKeys$viewApiKeysTable = function(config) {
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any API keys yet.')
            ])),
            $author$project$Ui$Table$loading(config.Tk)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Label')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Token')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Created')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Last Used')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Status')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), A2($elm$core$List$map, $author$project$Components$Developers$ManageApiKeys$viewApiKeyRow(config), config.bQ), _List_Nil);
    };
    var $author$project$Components$Developers$ManageApiKeys$ApiKeyLabel = $elm$core$Basics$identity;
    var $author$project$Components$Developers$ManageApiKeys$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageApiKeys$Save = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Developers$ManageApiKeys$viewCreateEditModal = F3(function(maybeApiKey, form, request) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'API Key',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: A2($elm$core$Maybe$map, $author$project$Api$Provider$ApiKey$All$id, maybeApiKey),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Developers$ManageApiKeys$CancelEdit,
            Vn: $elm$core$Basics$always(A2($author$project$Components$Developers$ManageApiKeys$Save, maybeApiKey, form))
        };
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Label')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.aeI),
                    $author$project$Ui$Form$Input$placeholder('e.g. Production'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Developers$ManageApiKeys$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Api$Provider$ManagedPartner$Shared$webhooksSignatureApiKey = function(_v0) {
        var record = _v0;
        return record.abm;
    };
    var $author$project$Api$Provider$ManagedPartner$One$webhooksSignatureApiKey = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ManagedPartner$Shared$webhooksSignatureApiKey(shared);
    };
    var $author$project$Components$Developers$ManageApiKeys$view = function(_v0) {
        var model = _v0;
        var webhooksSignatureId = function() {
            var _v7 = model.rp;
            if (_v7.$ === 3) {
                var mp = _v7.a;
                return A2($elm$core$Maybe$map, $author$project$Api$Provider$ApiKey$Shared$id, $author$project$Api$Provider$ManagedPartner$One$webhooksSignatureApiKey(mp));
            } else return $elm$core$Maybe$Nothing;
        }();
        var _v1 = function() {
            var _v2 = model.VM;
            if (!_v2) return _Utils_Tuple2('API Keys', $elm$core$Maybe$Just($author$project$Components$Developers$ManageApiKeys$UseForWebhooksSignature));
            else return _Utils_Tuple2('Integration API Keys', $elm$core$Maybe$Nothing);
        }();
        var panelTitle = _v1.a;
        var onUseForWebhooksSignature = _v1.b;
        return _List_fromArray([
            function() {
                var _v3 = model.F6;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var maybeApiKey = _v4.a;
                    var form = _v4.b;
                    var request = _v4.c;
                    return A3($author$project$Components$Developers$ManageApiKeys$viewCreateEditModal, maybeApiKey, form, request);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.$8;
                if (!_v5.$) {
                    var apiKey = _v5.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Developers$ManageApiKeys$HiConfirmClosed(apiKey), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('API key'),
                        $author$project$Components$HiConfirm$detail(A2($elm$core$Maybe$withDefault, 'API Key', $author$project$Api$Provider$ApiKey$All$label(apiKey)))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        $elm$html$Html$text(panelTitle)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'New API key'
                        }, _List_fromArray([
                            $author$project$Ui$Button$default,
                            $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageApiKeys$New),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('New API Key')
                        ]))
                    ]))
                ])),
                $author$project$Components$Developers$ManageApiKeys$viewApiKeysTable({
                    bQ: function() {
                        var _v6 = model.bQ;
                        if (_v6.$ === 3) {
                            var keys = _v6.a;
                            return keys;
                        } else return _List_Nil;
                    }(),
                    Tk: _Utils_eq(model.bQ, $author$project$Api$Data$Loading),
                    GB: $author$project$Components$Developers$ManageApiKeys$CopyToken,
                    rI: $author$project$Components$Developers$ManageApiKeys$Delete,
                    rJ: $author$project$Components$Developers$ManageApiKeys$Edit,
                    GC: $author$project$Components$Developers$ManageApiKeys$ToggleToken,
                    GD: onUseForWebhooksSignature,
                    HO: model.HO,
                    bI: model.bI,
                    dq: model.dq,
                    H5: webhooksSignatureId
                })
            ]))
        ]);
    };
    var $author$project$Ui$Skeleton$spanSm = $author$project$Ui$Skeleton$Span(1);
    var $author$project$Components$Developers$ManageApiKeys$skeleton = A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanMd(5)
                ]))
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_fromArray([
                    $author$project$Ui$Skeleton$spanSm(3)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$repeat, 3, $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$block
        ]))))
    ]));
    var $author$project$Pages$Admin$Developers$ApiKeys$viewSkeleton = A2($elm$core$List$repeat, 2, $author$project$Components$Developers$ManageApiKeys$skeleton);
    var $author$project$Pages$Admin$Developers$ApiKeys$view = function(model) {
        return {
            fb: function() {
                var _v0 = model.rp;
                if (_v0.$ === 1) return $author$project$Pages$Admin$Developers$ApiKeys$viewSkeleton;
                else return $elm$core$List$concat(_List_fromArray([
                    A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageApiKeys$view, $elm$core$List$map($elm$html$Html$map($author$project$Pages$Admin$Developers$ApiKeys$PartnerMsg))), model.jm)),
                    A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageApiKeys$view, $elm$core$List$map($elm$html$Html$map($author$project$Pages$Admin$Developers$ApiKeys$IntegrationMsg))), model.iW))
                ]));
            }(),
            $2: 'Admin | Developers | API Keys'
        };
    };
    var $author$project$Pages$Admin$Developers$ApiKeys$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Developers$ApiKeys$init,
        aeR: $author$project$Pages$Admin$Developers$ApiKeys$load,
        ag3: $author$project$Pages$Admin$Developers$ApiKeys$save,
        ahE: $author$project$Pages$Admin$Developers$ApiKeys$subscriptions,
        aaO: $author$project$Pages$Admin$Developers$ApiKeys$update,
        aid: $author$project$Pages$Admin$Developers$ApiKeys$view
    });
    var $author$project$Pages$Admin$Developers$GetStarted$GotManagedPartner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Developers$GetStarted$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            lI: $author$project$Api$Data$NotAsked,
            rp: $author$project$Api$Data$Loading
        }, A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Ej, $author$project$Pages$Admin$Developers$GetStarted$GotManagedPartner));
    });
    var $author$project$Pages$Admin$Developers$GetStarted$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Developers$GetStarted$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Developers$GetStarted$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Developers$GetStarted$GotCreateIntegration = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$ManagedPartner$Integration$integrationPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'managed_partner',
        'integration'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagedPartner$Integration$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Integration$Shared$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$integrationPath));
    });
    var $author$project$Pages$Admin$Developers$GetStarted$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var managedPartner = response.a;
                    var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
                    if (!_v2.$) return _Utils_Tuple3(_Utils_update(model, {
                        rp: response
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys), _List_Nil);
                    else return _Utils_Tuple3(_Utils_update(model, {
                        rp: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    rp: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    lI: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$ManagedPartner$Integration$create, model.Ej, $author$project$Pages$Admin$Developers$GetStarted$GotCreateIntegration), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    lI: response
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys), _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    lI: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$Developers$GetStarted$ClickedGetStarted = {
        $: 1
    };
    var $author$project$Pages$Admin$Developers$GetStarted$viewGetStarted = function(loading) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Your integration is not set up yet. Click the button below to create your integration and get access to API keys and webhook endpoints.')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Get started'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Developers$GetStarted$ClickedGetStarted),
                $author$project$Ui$Button$loading(loading)
            ]), _List_fromArray([
                $elm$html$Html$text('Get Started')
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Developers$GetStarted$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text('Get Started with Developer Settings')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Admin$Developers$GetStarted$viewGetStarted(_Utils_eq(model.lI, $author$project$Api$Data$Loading))
                    ]))
                ]))
            ]),
            $2: 'Admin | Developers | Get Started'
        };
    };
    var $author$project$Pages$Admin$Developers$GetStarted$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Developers$GetStarted$init,
        aeR: $author$project$Pages$Admin$Developers$GetStarted$load,
        ag3: $author$project$Pages$Admin$Developers$GetStarted$save,
        ahE: $author$project$Pages$Admin$Developers$GetStarted$subscriptions,
        aaO: $author$project$Pages$Admin$Developers$GetStarted$update,
        aid: $author$project$Pages$Admin$Developers$GetStarted$view
    });
    var $author$project$Pages$Admin$Developers$Sandboxes$SandboxesMsg = $elm$core$Basics$identity;
    var $author$project$Components$Developers$ManageSandboxes$GotManagedPartner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageSandboxes$GotSandboxPartners = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageSandboxes$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Partner$All$Partner = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Partner$Shared$Partner = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Partner$Shared$Record = F2(function(name, logoUrl) {
        return {
            Tu: logoUrl,
            zr: name
        };
    });
    var $author$project$Api$Provider$Partner$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'logo_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$Shared$Record)));
    var $author$project$Api$Provider$Partner$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Partner$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Partner$All$Record = F2(function(id, organizationId) {
        return {
            aef: id,
            afV: organizationId
        };
    });
    var $author$project$Api$Provider$Partner$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$All$Record)));
    var $author$project$Api$Provider$Partner$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Partner$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Partner$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$All$Partner)));
    var $author$project$Api$Provider$ManagedPartner$Sandbox$Partner$sandboxPartnersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'managed_partner',
        'sandboxes',
        'partners'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagedPartner$Sandbox$Partner$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Partner$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$sandboxPartnersPath));
    });
    var $author$project$Api$Provider$Practice$All$Practice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Practice$Min$Practice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Practice$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$Min$Record)));
    var $author$project$Api$Provider$Practice$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practice$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Practice$All$Record = function(organizationId) {
        return {
            afV: organizationId
        };
    };
    var $author$project$Api$Provider$Practice$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$All$Record));
    var $author$project$Api$Provider$Practice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practice$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$All$Practice)));
    var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'managed_partner',
        'sandboxes',
        'practices'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Practice$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath));
    });
    var $author$project$Components$Developers$ManageSandboxes$init = function(apiClient) {
        return _Utils_Tuple2({
            bN: $elm$core$Maybe$Nothing,
            bO: $elm$core$Maybe$Nothing,
            rp: $author$project$Api$Data$Loading,
            sD: $author$project$Api$Data$Loading,
            sE: $author$project$Api$Data$Loading
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$ManagedPartner$retrieve, apiClient, $author$project$Components$Developers$ManageSandboxes$GotManagedPartner),
            A2($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPartners),
            A2($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices)
        ])));
    };
    var $author$project$Pages$Admin$Developers$Sandboxes$init = F4(function(session, practice, shared, _v0) {
        if ($author$project$Api$Provider$Practice$One$hasManagedPartner(practice)) {
            var _v1 = $author$project$Components$Developers$ManageSandboxes$init(shared.Ej);
            var sandboxesModel = _v1.a;
            var sandboxesCmd = _v1.b;
            return _Utils_Tuple2({
                Ej: shared.Ej,
                jZ: $elm$core$Maybe$Just(sandboxesModel)
            }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, sandboxesCmd));
        } else return _Utils_Tuple2({
            Ej: shared.Ej,
            jZ: $elm$core$Maybe$Nothing
        }, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)));
    });
    var $author$project$Pages$Admin$Developers$Sandboxes$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Developers$Sandboxes$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Developers$ManageSandboxes$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Developers$Sandboxes$subscriptions = function(model) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageSandboxes$subscriptions, $elm$core$Platform$Sub$map($elm$core$Basics$identity)), model.jZ));
    };
    var $author$project$OutMsg$GoToRouteAndReloadAction = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageSandboxes$SandboxPartnerCreated = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Developers$ManageSandboxes$SandboxPracticeCreated = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$OutMsg$SwitchToOrganization = F3(function(a, b, c) {
        return {
            $: 15,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Provider$Partner$One$Partner = 0;
    var $author$project$Api$Provider$Partner$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$ManagedPartner$Sandbox$Partner$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(params.zr))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Partner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$sandboxPartnersPath)));
    });
    var $author$project$Api$Provider$Practice$IdAndName$Practice = 0;
    var $author$project$Api$Provider$Practice$IdAndName$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$ManagedPartner$Sandbox$Practice$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(params.zr))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$IdAndName$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$sandboxPracticesPath)));
    });
    var $author$project$Components$Developers$ManageSandboxes$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    rp: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    sD: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    sE: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    bN: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just('Sandbox'), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    bN: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var name = msg.a;
                var _v2 = model.bN;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var request = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bN: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$String$toMaybe(name), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var _v4 = model.bN;
                if (!_v4.$ && !_v4.a.a.$) {
                    var _v5 = _v4.a;
                    var name = _v5.a.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bN: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name), $author$project$Api$Data$Loading))
                    }), A3($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$create, apiClient, {
                        zr: name
                    }, $author$project$Components$Developers$ManageSandboxes$SandboxPartnerCreated(name)), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var name = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bN: $elm$core$Maybe$Nothing,
                    sD: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$ManagedPartner$Sandbox$Partner$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPartners), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Sandbox added')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    bN: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name), response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                return _Utils_Tuple3(_Utils_update(model, {
                    bO: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just('Sandbox Practice'), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                return _Utils_Tuple3(_Utils_update(model, {
                    bO: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var name = msg.a;
                var _v7 = model.bO;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var request = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bO: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$String$toMaybe(name), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var _v9 = model.bO;
                if (!_v9.$ && !_v9.a.a.$) {
                    var _v10 = _v9.a;
                    var name = _v10.a.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bO: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name), $author$project$Api$Data$Loading))
                    }), A3($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$create, apiClient, {
                        zr: name
                    }, $author$project$Components$Developers$ManageSandboxes$SandboxPracticeCreated(name)), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var name = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bO: $elm$core$Maybe$Nothing,
                    sE: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$ManagedPartner$Sandbox$Practice$list, apiClient, $author$project$Components$Developers$ManageSandboxes$GotSandboxPractices), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Sandbox practice added')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    bO: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name), response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var organizationId = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToRouteAndReloadAction($author$project$Spa$Generated$Route$Patients__Top))
                ]));
        }
    });
    var $author$project$Pages$Admin$Developers$Sandboxes$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = model.jZ;
        if (!_v1.$) {
            var sandboxes = _v1.a;
            var _v2 = A3($author$project$Components$Developers$ManageSandboxes$update, model.Ej, subMsg, sandboxes);
            var updated = _v2.a;
            var cmd = _v2.b;
            var outMsgs = _v2.c;
            return _Utils_Tuple3(_Utils_update(model, {
                jZ: $elm$core$Maybe$Just(updated)
            }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), outMsgs);
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Components$Developers$ManageSandboxes$skeleton = A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(6)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanMd(5)
                        ]))
                    ]), _List_fromArray([
                        $author$project$Ui$Skeleton$input(_List_fromArray([
                            $author$project$Ui$Skeleton$spanSm(3)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$repeat, 3, $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block
                ]))))
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(6)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanMd(5)
                        ]))
                    ]), _List_fromArray([
                        $author$project$Ui$Skeleton$input(_List_fromArray([
                            $author$project$Ui$Skeleton$spanSm(3)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$repeat, 3, $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block
                ]))))
            ]))
        ]))
    ]));
    var $author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerClosed = {
        $: 4
    };
    var $author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerNameUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageSandboxes$SaveSandboxPartner = {
        $: 6
    };
    var $author$project$Components$Developers$ManageSandboxes$viewAddSandboxPartnerModal = F2(function(name, request) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerClosed, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add Sandbox Partner')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Name'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', name)),
                        $author$project$Ui$Form$Input$onInput($author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerNameUpdated),
                        $author$project$Ui$Form$Input$invalid(_Utils_eq(name, $elm$core$Maybe$Nothing)),
                        $author$project$Ui$Form$Input$errors(_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray([
                            'Name is required'
                        ]) : _List_Nil)
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPartnerClosed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add Sandbox Partner'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$SaveSandboxPartner),
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Sandbox Partner')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed = {
        $: 9
    };
    var $author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeNameUpdated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageSandboxes$SaveSandboxPractice = {
        $: 11
    };
    var $author$project$Components$Developers$ManageSandboxes$viewAddSandboxPracticeModal = F2(function(name, request) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add Sandbox Practice')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Name'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', name)),
                        $author$project$Ui$Form$Input$onInput($author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeNameUpdated),
                        $author$project$Ui$Form$Input$invalid(_Utils_eq(name, $elm$core$Maybe$Nothing)),
                        $author$project$Ui$Form$Input$errors(_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray([
                            'Name is required'
                        ]) : _List_Nil)
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPracticeClosed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add Sandbox Practice'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$SaveSandboxPractice),
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Sandbox Practice')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Developers$ManageSandboxes$NewSandboxPartner = {
        $: 3
    };
    var $author$project$Api$Provider$ManagedPartner$Shared$sandboxEnabled = function(_v0) {
        var record = _v0;
        return record.Zo;
    };
    var $author$project$Api$Provider$ManagedPartner$One$sandboxEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ManagedPartner$Shared$sandboxEnabled(shared);
    };
    var $author$project$Components$Developers$ManageSandboxes$SwitchToSandbox = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Provider$ManagedPartner$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$ManagedPartner$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ManagedPartner$Shared$id(shared);
    };
    var $author$project$Api$Provider$Partner$All$id = function(_v0) {
        var record = _v0.b;
        return record.aef;
    };
    var $author$project$Api$Provider$Partner$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Partner$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Partner$Shared$name(shared);
    };
    var $author$project$Api$Provider$Partner$All$organizationId = function(_v0) {
        var record = _v0.b;
        return record.afV;
    };
    var $author$project$Components$Developers$ManageSandboxes$viewSandboxPartnerRow = F2(function(managedPartner, sandboxPartner) {
        var sandboxName = $author$project$Api$Provider$Partner$All$name(sandboxPartner);
        var isCurrentSandbox = _Utils_eq($author$project$Api$Provider$Partner$All$id(sandboxPartner), $author$project$Api$Provider$ManagedPartner$One$id(managedPartner));
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(sandboxName)
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                isCurrentSandbox ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                    abP: 'Switch' + sandboxName
                }, _List_fromArray([
                    $author$project$Ui$Button$default,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$SwitchToSandbox($author$project$Api$Provider$Partner$All$organizationId(sandboxPartner)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Switch')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Developers$ManageSandboxes$viewSandboxPartnersTable = F2(function(managedPartner, model) {
        var _v0 = function() {
            var _v1 = model.sD;
            if (_v1.$ === 3) {
                var partners = _v1.a;
                return _Utils_Tuple2(false, partners);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var sandboxPartners = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any sandbox partners')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Name')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), A2($elm$core$List$map, $author$project$Components$Developers$ManageSandboxes$viewSandboxPartnerRow(managedPartner), sandboxPartners), _List_Nil);
    });
    var $author$project$Components$Developers$ManageSandboxes$viewSandboxPartners = F2(function(managedPartner, model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Sandbox Partners')
                ]), _List_fromArray([
                    $author$project$Api$Provider$ManagedPartner$One$sandboxEnabled(managedPartner) ? A3($author$project$Ui$Button$view, {
                        abP: 'Add sandbox partner'
                    }, _List_fromArray([
                        $author$project$Ui$Button$default,
                        $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPartner)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add Sandbox Partner')
                    ])) : $author$project$Utils$Html$empty
                ]))
            ])),
            A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPartnersTable, managedPartner, model)
        ]));
    });
    var $author$project$Components$Developers$ManageSandboxes$NewSandboxPractice = {
        $: 8
    };
    var $author$project$Api$Provider$Practice$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Practice$All$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Practice$Min$id(min);
    };
    var $author$project$Api$Provider$Practice$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Practice$All$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Practice$Min$name(min);
    };
    var $author$project$Api$Provider$Practice$All$organizationId = function(_v0) {
        var record = _v0.b;
        return record.afV;
    };
    var $author$project$Components$Developers$ManageSandboxes$viewSandboxPracticeRow = F2(function(managedPartner, sandboxPractice) {
        var sandboxName = $author$project$Api$Provider$Practice$All$name(sandboxPractice);
        var isCurrentSandbox = _Utils_eq($author$project$Api$Provider$Practice$All$id(sandboxPractice), $author$project$Api$Provider$ManagedPartner$One$id(managedPartner));
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(sandboxName)
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                isCurrentSandbox ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                    abP: 'Switch' + sandboxName
                }, _List_fromArray([
                    $author$project$Ui$Button$default,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$SwitchToSandbox($author$project$Api$Provider$Practice$All$organizationId(sandboxPractice)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Switch')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Developers$ManageSandboxes$viewSandboxPracticesTable = F2(function(managedPartner, model) {
        var _v0 = function() {
            var _v1 = model.sE;
            if (_v1.$ === 3) {
                var practices = _v1.a;
                return _Utils_Tuple2(false, practices);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var sandboxPractices = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any sandbox practices')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Name')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), A2($elm$core$List$map, $author$project$Components$Developers$ManageSandboxes$viewSandboxPracticeRow(managedPartner), sandboxPractices), _List_Nil);
    });
    var $author$project$Components$Developers$ManageSandboxes$viewSandboxPractices = F2(function(managedPartner, model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Sandbox Practices')
                ]), _List_fromArray([
                    $author$project$Api$Provider$ManagedPartner$One$sandboxEnabled(managedPartner) ? A3($author$project$Ui$Button$view, {
                        abP: 'Add sandbox practice'
                    }, _List_fromArray([
                        $author$project$Ui$Button$default,
                        $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageSandboxes$NewSandboxPractice)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add Sandbox Practice')
                    ])) : $author$project$Utils$Html$empty
                ]))
            ])),
            A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPracticesTable, managedPartner, model)
        ]));
    });
    var $author$project$Components$Developers$ManageSandboxes$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            function() {
                var _v1 = model.bN;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var name = _v2.a;
                    var request = _v2.b;
                    return A2($author$project$Components$Developers$ManageSandboxes$viewAddSandboxPartnerModal, name, request);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.bO;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var name = _v4.a;
                    var request = _v4.b;
                    return A2($author$project$Components$Developers$ManageSandboxes$viewAddSandboxPracticeModal, name, request);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.rp;
                if (_v5.$ === 3) {
                    var managedPartner = _v5.a;
                    return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(6)
                        ]), _List_fromArray([
                            A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPartners, managedPartner, model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(6)
                        ]), _List_fromArray([
                            A2($author$project$Components$Developers$ManageSandboxes$viewSandboxPractices, managedPartner, model)
                        ]))
                    ]));
                } else return $author$project$Components$Developers$ManageSandboxes$skeleton;
            }()
        ]);
    };
    var $author$project$Pages$Admin$Developers$Sandboxes$view = function(model) {
        return {
            fb: function() {
                var _v0 = model.jZ;
                if (_v0.$ === 1) return _List_fromArray([
                    $author$project$Components$Developers$ManageSandboxes$skeleton
                ]);
                else {
                    var sandboxes = _v0.a;
                    return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Developers$ManageSandboxes$view(sandboxes));
                }
            }(),
            $2: 'Admin | Developers | Sandboxes'
        };
    };
    var $author$project$Pages$Admin$Developers$Sandboxes$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Developers$Sandboxes$init,
        aeR: $author$project$Pages$Admin$Developers$Sandboxes$load,
        ag3: $author$project$Pages$Admin$Developers$Sandboxes$save,
        ahE: $author$project$Pages$Admin$Developers$Sandboxes$subscriptions,
        aaO: $author$project$Pages$Admin$Developers$Sandboxes$update,
        aid: $author$project$Pages$Admin$Developers$Sandboxes$view
    });
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$GotManagedPartner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$init = F4(function(session, practice, shared, _v0) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            iX: $elm$core$Maybe$Nothing,
            rp: $author$project$Api$Data$Loading,
            jp: $elm$core$Maybe$Nothing,
            HO: shared.HO
        }, $author$project$Api$Provider$Practice$One$hasManagedPartner(practice) ? A2($author$project$Api$Provider$ManagedPartner$retrieve, shared.Ej, $author$project$Pages$Admin$Developers$WebhookEndpoints$GotManagedPartner) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)));
    });
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit = {
        $: 3
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit)), model.F6)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed), model.$8))
        ]));
    };
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageWebhookEndpoints$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg)), model.jp)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageWebhookEndpoints$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg)), model.iX))
        ]));
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$Integration = 1;
    var $author$project$Components$Developers$ManageWebhookEndpoints$Partner = 0;
    var $author$project$Components$Developers$ManageWebhookEndpoints$Model = $elm$core$Basics$identity;
    var $author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$WebhookEndpoint$All$WebhookEndpoint = $elm$core$Basics$identity;
    var $author$project$Api$Provider$WebhookEndpoint$Shared$WebhookEndpoint = $elm$core$Basics$identity;
    var $author$project$Api$Provider$WebhookEndpoint$Shared$Record = F4(function(id, webhookUrl, createdAt, lastDeliveredAt) {
        return {
            Mx: createdAt,
            aef: id,
            SR: lastDeliveredAt,
            abj: webhookUrl
        };
    });
    var $author$project$Api$Provider$WebhookEndpoint$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_delivered_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'webhook_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$WebhookEndpoint$Shared$Record)))));
    var $author$project$Api$Provider$WebhookEndpoint$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$WebhookEndpoint$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$WebhookEndpoint$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$WebhookEndpoint$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'managed_partner',
        'integration',
        'webhook_endpoints'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$WebhookEndpoint$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath));
    });
    var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'managed_partner',
        'webhook_endpoints'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$WebhookEndpoint$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath));
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints = F2(function(apiClient, owner) {
        if (!owner) return A2($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$list, apiClient, $author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints);
        else return A2($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$list, apiClient, $author$project$Components$Developers$ManageWebhookEndpoints$GotWebhookEndpoints);
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$init = F3(function(apiClient, timeFormatter, owner) {
        return _Utils_Tuple2({
            $8: $elm$core$Maybe$Nothing,
            F6: $elm$core$Maybe$Nothing,
            VM: owner,
            HO: timeFormatter,
            hj: $author$project$Api$Data$Loading
        }, A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, owner));
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$Created = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$Deleted = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$Updated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$WebhookEndpoint$One$WebhookEndpoint = 0;
    var $author$project$Api$Provider$WebhookEndpoint$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhook_endpoint', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('webhook_url', $elm$json$Json$Encode$string(params.abj))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$WebhookEndpoint$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath)));
    });
    var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhook_endpoint', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('webhook_url', $elm$json$Json$Encode$string(params.abj))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$WebhookEndpoint$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath)));
    });
    var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointsPath);
    };
    var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath(id_)));
    });
    var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointsPath);
    };
    var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath(id_)));
    });
    var $author$project$Api$Provider$WebhookEndpoint$Shared$webhookUrl = function(_v0) {
        var record = _v0;
        return record.abj;
    };
    var $author$project$Api$Provider$WebhookEndpoint$All$webhookUrl = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$WebhookEndpoint$Shared$webhookUrl(shared);
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsFromItem = function(endpoint) {
        return {
            abj: $author$project$Api$Provider$WebhookEndpoint$All$webhookUrl(endpoint)
        };
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsInit = {
        abj: ''
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsUpdate = F2(function(field, fields) {
        var string = field;
        return _Utils_update(fields, {
            abj: string
        });
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$WebhookUrlValidation = 0;
    var $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.abj;
        }, _Utils_Tuple2(0, 'Please enter a URL.')),
        A2($rtfeldman$elm_validate$Validate$ifFalse, function(f) {
            return $elm$core$String$isEmpty(f.abj) || A2($elm$core$String$startsWith, 'https://', f.abj);
        }, _Utils_Tuple2(0, 'URL must start with https://.'))
    ]));
    var $author$project$Api$Provider$WebhookEndpoint$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$WebhookEndpoint$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$WebhookEndpoint$Shared$id(shared);
    };
    var $author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$update = F4(function(apiClient, id_, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhook_endpoint', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('webhook_url', $elm$json$Json$Encode$string(params.abj))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$WebhookEndpoint$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$webhookEndpointPath(id_))));
    });
    var $author$project$Api$Provider$ManagedPartner$WebhookEndpoint$update = F4(function(apiClient, id_, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhook_endpoint', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('webhook_url', $elm$json$Json$Encode$string(params.abj))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$WebhookEndpoint$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$webhookEndpointPath(id_))));
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    hj: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Developers$ManageWebhookEndpoints$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var endpoint = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(endpoint), $author$project$Utils$Form$init($author$project$Components$Developers$ManageWebhookEndpoints$formFieldsFromItem(endpoint)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var field = msg.a;
                var _v2 = model.F6;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var maybeEndpoint = _v3.a;
                    var form = _v3.b;
                    var request = _v3.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeEndpoint, A3($author$project$Utils$Form$update, $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsUpdate, field, form), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var maybeEndpoint = msg.a;
                var form = msg.b;
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Developers$ManageWebhookEndpoints$formFieldsValidator, form);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var validatedForm = _v5.a;
                    var validFormFields = _v5.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var cmd = function() {
                        if (maybeEndpoint.$ === 1) {
                            var _v7 = model.VM;
                            if (!_v7) return A3($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$create, apiClient, {
                                abj: fields.abj
                            }, $author$project$Components$Developers$ManageWebhookEndpoints$Created);
                            else return A3($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$create, apiClient, {
                                abj: fields.abj
                            }, $author$project$Components$Developers$ManageWebhookEndpoints$Created);
                        } else {
                            var endpoint = maybeEndpoint.a;
                            var _v8 = model.VM;
                            if (!_v8) return A4($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$update, apiClient, $author$project$Api$Provider$WebhookEndpoint$All$id(endpoint), {
                                abj: fields.abj
                            }, $author$project$Components$Developers$ManageWebhookEndpoints$Updated);
                            else return A4($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$update, apiClient, $author$project$Api$Provider$WebhookEndpoint$All$id(endpoint), {
                                abj: fields.abj
                            }, $author$project$Components$Developers$ManageWebhookEndpoints$Updated);
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeEndpoint, validatedForm, $author$project$Api$Data$Loading))
                    }), cmd, _List_Nil);
                } else {
                    var validatedForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeEndpoint, validatedForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 6:
                var response = msg.a;
                var _v9 = model.F6;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var maybeEndpoint = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Nothing,
                        hj: $author$project$Api$Data$Loading
                    }), A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.VM), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint added.')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeEndpoint, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v12 = model.F6;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var maybeEndpoint = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Nothing,
                        hj: $author$project$Api$Data$Loading
                    }), A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.VM), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint updated.')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(maybeEndpoint, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var endpoint = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Just(endpoint)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var endpoint = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var deleteCmd = function() {
                        var _v15 = model.VM;
                        if (!_v15) return A3($author$project$Api$Provider$ManagedPartner$WebhookEndpoint$delete, apiClient, $author$project$Api$Provider$WebhookEndpoint$All$id(endpoint), $author$project$Components$Developers$ManageWebhookEndpoints$Deleted);
                        else return A3($author$project$Api$Provider$ManagedPartner$Integration$WebhookEndpoint$delete, apiClient, $author$project$Api$Provider$WebhookEndpoint$All$id(endpoint), $author$project$Components$Developers$ManageWebhookEndpoints$Deleted);
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Nothing
                    }), deleteCmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    hj: $author$project$Api$Data$Loading
                }), A2($author$project$Components$Developers$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model.VM), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint deleted.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var managedPartner = response.a;
                    var _v2 = $author$project$Api$Provider$ManagedPartner$One$integration(managedPartner);
                    if (!_v2.$) {
                        var _v3 = A3($author$project$Components$Developers$ManageWebhookEndpoints$init, model.Ej, model.HO, 0);
                        var partnerWebhookEndpoints = _v3.a;
                        var partnerCmd = _v3.b;
                        var _v4 = A3($author$project$Components$Developers$ManageWebhookEndpoints$init, model.Ej, model.HO, 1);
                        var integrationWebhookEndpoints = _v4.a;
                        var integrationCmd = _v4.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            iX: $elm$core$Maybe$Just(integrationWebhookEndpoints),
                            rp: response,
                            jp: $elm$core$Maybe$Just(partnerWebhookEndpoints)
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg, partnerCmd),
                            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg, integrationCmd)
                        ])), _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        rp: response
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Developers__GetStarted), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    rp: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v5 = model.jp;
                if (!_v5.$) {
                    var partnerWebhookEndpoints = _v5.a;
                    var _v6 = A3($author$project$Components$Developers$ManageWebhookEndpoints$update, model.Ej, subMsg, partnerWebhookEndpoints);
                    var updated = _v6.a;
                    var cmd = _v6.b;
                    var outMsgs = _v6.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        jp: $elm$core$Maybe$Just(updated)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg, cmd), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v7 = model.iX;
                if (!_v7.$) {
                    var integrationWebhookEndpoints = _v7.a;
                    var _v8 = A3($author$project$Components$Developers$ManageWebhookEndpoints$update, model.Ej, subMsg, integrationWebhookEndpoints);
                    var updated = _v8.a;
                    var cmd = _v8.b;
                    var outMsgs = _v8.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        iX: $elm$core$Maybe$Just(updated)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg, cmd), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$New = {
        $: 1
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$FormUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$Save = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$WebhookUrl = $elm$core$Basics$identity;
    var $author$project$Components$Developers$ManageWebhookEndpoints$viewCreateEditModal = F3(function(maybeEndpoint, form, request) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Webhook Endpoint',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: A2($elm$core$Maybe$map, $author$project$Api$Provider$WebhookEndpoint$All$id, maybeEndpoint),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Developers$ManageWebhookEndpoints$CancelEdit,
            Vn: $elm$core$Basics$always(A2($author$project$Components$Developers$ManageWebhookEndpoints$Save, maybeEndpoint, form))
        };
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('URL')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.abj),
                    $author$project$Ui$Form$Input$placeholder('https://example.com/webhook'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Developers$ManageWebhookEndpoints$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$Delete = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$Edit = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$WebhookEndpoint$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$WebhookEndpoint$All$createdAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$WebhookEndpoint$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$WebhookEndpoint$Shared$lastDeliveredAt = function(_v0) {
        var record = _v0;
        return record.SR;
    };
    var $author$project$Api$Provider$WebhookEndpoint$All$lastDeliveredAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$WebhookEndpoint$Shared$lastDeliveredAt(shared);
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$viewWebhookRow = F2(function(timeFormatter, endpoint) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$WebhookEndpoint$All$webhookUrl(endpoint))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2(timeFormatter, 5, $author$project$Api$Provider$WebhookEndpoint$All$createdAt(endpoint)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Never', A2($elm$core$Maybe$map, timeFormatter(5), $author$project$Api$Provider$WebhookEndpoint$All$lastDeliveredAt(endpoint))))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit webhook endpoint'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageWebhookEndpoints$Edit(endpoint)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ])),
                $author$project$Utils$Html$noBreakSpace,
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete webhook endpoint'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageWebhookEndpoints$Delete(endpoint)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Developers$ManageWebhookEndpoints$view = function(_v0) {
        var model = _v0;
        var panelTitle = function() {
            var _v5 = model.VM;
            if (!_v5) return 'Webhook Endpoints';
            else return 'Integration Webhook Endpoints';
        }();
        return _List_fromArray([
            function() {
                var _v1 = model.F6;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var maybeEndpoint = _v2.a;
                    var form = _v2.b;
                    var request = _v2.c;
                    return A3($author$project$Components$Developers$ManageWebhookEndpoints$viewCreateEditModal, maybeEndpoint, form, request);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.$8;
                if (!_v3.$) {
                    var endpoint = _v3.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Developers$ManageWebhookEndpoints$HiConfirmClosed(endpoint), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('webhook endpoint'),
                        $author$project$Components$HiConfirm$detail($author$project$Api$Provider$WebhookEndpoint$All$webhookUrl(endpoint))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        $elm$html$Html$text(panelTitle)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add webhook endpoint'
                        }, _List_fromArray([
                            $author$project$Ui$Button$default,
                            $author$project$Ui$Button$onClick($author$project$Components$Developers$ManageWebhookEndpoints$New),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add Endpoint')
                        ]))
                    ]))
                ])),
                A4($author$project$Ui$Panel$table, _List_fromArray([
                    $author$project$Ui$Table$zeroState(_List_fromArray([
                        $elm$html$Html$text('You don\'t have any webhook endpoints yet.')
                    ])),
                    $author$project$Ui$Table$loading(_Utils_eq(model.hj, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('URL')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Created')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Last Delivered')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ]), function() {
                    var _v4 = model.hj;
                    if (_v4.$ === 3) {
                        var endpoints = _v4.a;
                        return A2($elm$core$List$map, $author$project$Components$Developers$ManageWebhookEndpoints$viewWebhookRow(model.HO), endpoints);
                    } else return _List_Nil;
                }(), _List_Nil)
            ]))
        ]);
    };
    var $author$project$Components$Developers$ManageWebhookEndpoints$skeleton = A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanMd(5)
                ]))
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_fromArray([
                    $author$project$Ui$Skeleton$spanSm(3)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$repeat, 3, $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$block
        ]))))
    ]));
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$viewSkeleton = A2($elm$core$List$repeat, 2, $author$project$Components$Developers$ManageWebhookEndpoints$skeleton);
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$view = function(model) {
        return {
            fb: function() {
                var _v0 = model.rp;
                if (_v0.$ === 1) return $author$project$Pages$Admin$Developers$WebhookEndpoints$viewSkeleton;
                else return $elm$core$List$concat(_List_fromArray([
                    A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageWebhookEndpoints$view, $elm$core$List$map($elm$html$Html$map($author$project$Pages$Admin$Developers$WebhookEndpoints$PartnerMsg))), model.jp)),
                    A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Developers$ManageWebhookEndpoints$view, $elm$core$List$map($elm$html$Html$map($author$project$Pages$Admin$Developers$WebhookEndpoints$IntegrationMsg))), model.iX))
                ]));
            }(),
            $2: 'Admin | Developers | Webhook Endpoints'
        };
    };
    var $author$project$Pages$Admin$Developers$WebhookEndpoints$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Developers$WebhookEndpoints$init,
        aeR: $author$project$Pages$Admin$Developers$WebhookEndpoints$load,
        ag3: $author$project$Pages$Admin$Developers$WebhookEndpoints$save,
        ahE: $author$project$Pages$Admin$Developers$WebhookEndpoints$subscriptions,
        aaO: $author$project$Pages$Admin$Developers$WebhookEndpoints$update,
        aid: $author$project$Pages$Admin$Developers$WebhookEndpoints$view
    });
    var $author$project$Pages$Admin$Documents$Id_String$DocumentFormMsg = $elm$core$Basics$identity;
    var $author$project$Components$Admin$Documents$Form$GotItem = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$LanguageDropdownMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$Model = $elm$core$Basics$identity;
    var $author$project$Api$Feature$MultiLanguage = 10;
    var $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$File = 1;
    var $author$project$Api$Provider$Document$AcceptanceType$TypeName = 1;
    var $author$project$Components$Admin$Documents$Form$formFieldsInit = function(practice) {
        return _Utils_Tuple2({
            Ib: 'I have read and agree to the ' + $author$project$Api$Provider$Practice$One$name(practice),
            Ic: 1,
            Ir: true,
            EU: $elm$core$Maybe$Nothing,
            d1: $elm$core$Maybe$Nothing,
            Of: _List_Nil,
            Og: $elm$core$Maybe$Just('Agreement'),
            xn: 1,
            qJ: 0,
            PH: $elm$core$Maybe$Nothing,
            qP: false,
            Tg: $elm$core$Maybe$Nothing,
            zr: '',
            WN: 2,
            agM: true,
            _i: true,
            ahy: 'published',
            aay: _List_Nil
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Components$ResourceFilter$Location$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Location$All$Location = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Location$Shared$Location = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Location$Shared$Record = function(id) {
        return function(name) {
            return function(onlineSignupVisibility) {
                return function(businessLocation) {
                    return function(virtual) {
                        return function(phoneNumber) {
                            return function(address) {
                                return function(locationGroup) {
                                    return function(affiliation) {
                                        return function(isMaster) {
                                            return function(isSynced) {
                                                return {
                                                    II: address,
                                                    IY: affiliation,
                                                    Kx: businessLocation,
                                                    aef: id,
                                                    R8: isMaster,
                                                    Su: isSynced,
                                                    rm: locationGroup,
                                                    zr: name,
                                                    Vv: onlineSignupVisibility,
                                                    WF: phoneNumber,
                                                    abe: virtual
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Affiliate$AffiliateMin$Affiliate = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Affiliate$AffiliateMin$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Affiliate$AffiliateMin$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$AffiliateMin$Record)));
    var $author$project$Api$Provider$Affiliate$AffiliateMin$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliate$AffiliateMin$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Location$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_synced', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_master', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'affiliation', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location_group', $elm$json$Json$Decode$nullable($author$project$Api$Common$LocationGroup$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phone_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'virtual', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'business_location', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'online_signup_visibility', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Shared$Record))))))))))));
    var $author$project$Api$Provider$Location$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Location$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Location$All$Record = F2(function(hasPatients, meta) {
        return {
            Qu: hasPatients,
            Ue: meta
        };
    });
    var $author$project$Api$Provider$Location$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Location$Meta$MetaRecord = function(actions) {
        return {
            tM: actions
        };
    };
    var $author$project$Api$Provider$Location$Meta$ActionsRecord = function(_delete) {
        return {
            NH: _delete
        };
    };
    var $author$project$Api$Provider$Location$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'delete', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Meta$ActionsRecord));
    var $author$project$Api$Provider$Location$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$Location$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$Meta$MetaRecord));
    var $author$project$Api$Provider$Location$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Location$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Location$All$recordDecoder = A3($author$project$Api$Expandable$expandable, 'meta', $author$project$Api$Provider$Location$Meta$decoder, A3($author$project$Api$Expandable$expandable, 'has_patients', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$All$Record)));
    var $author$project$Api$Provider$Location$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Location$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Location$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Location$All$Location)));
    var $author$project$Api$Provider$Location$expandToString = function(expand) {
        return 'meta';
    };
    var $author$project$Api$Provider$Location$listDefaults = {
        Eb: $elm$core$Maybe$Nothing,
        Fq: _List_Nil,
        aef: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        GF: $elm$core$Maybe$Nothing,
        af_: $elm$core$Maybe$Nothing,
        agi: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        Hs: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Provider$Location$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Location$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.rm;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.af_;
                if (!_v3.$) {
                    var pagination = _v3.a;
                    return $author$project$Api$Pagination$toApiParams(pagination);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            function() {
                var _v4 = options.GF;
                if (!_v4.$) {
                    var bool = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'online_signup', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.Hs;
                if (!_v5.$) {
                    var ident = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'signup_page', ident)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.agi;
                if (!_v6.$) {
                    var ident = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', ident)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v7 = options.Eb;
                if (!_v7.$) {
                    var ident = _v7.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'affiliate', ident)
                    ]);
                } else return _List_Nil;
            }(),
            A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Location$expandToString, options.Fq)
        ]));
    };
    var $author$project$Api$Provider$Location$locationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'locations'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Location$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Location$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Location$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Location$locationsPath)));
    });
    var $author$project$Components$ResourceFilter$Location$list = $author$project$Api$Provider$Location$list;
    var $author$project$Api$Affiliate$AffiliateMin$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Location$Shared$affiliation = function(_v0) {
        var record = _v0;
        return record.IY;
    };
    var $author$project$Api$Provider$Location$All$affiliation = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$affiliation(shared);
    };
    var $author$project$Api$Provider$Location$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Location$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$id(shared);
    };
    var $author$project$Api$Provider$Location$Shared$isMaster = function(_v0) {
        var record = _v0;
        return record.R8;
    };
    var $author$project$Api$Provider$Location$All$isMaster = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$isMaster(shared);
    };
    var $author$project$Api$Provider$Location$Shared$isSynced = function(_v0) {
        var record = _v0;
        return record.Su;
    };
    var $author$project$Api$Provider$Location$All$isSynced = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$isSynced(shared);
    };
    var $author$project$Api$Provider$Location$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Location$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$name(shared);
    };
    var $author$project$Components$ResourceFilter$Location$resourceFromAll = function(location1) {
        return {
            IY: A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Provider, $author$project$Api$Provider$Location$All$affiliation(location1)),
            aef: $author$project$Api$Provider$Location$All$id(location1),
            R8: $author$project$Api$Provider$Location$All$isMaster(location1),
            Su: $author$project$Api$Provider$Location$All$isSynced(location1),
            zr: $author$project$Api$Provider$Location$All$name(location1)
        };
    };
    var $author$project$Components$ResourceFilter$Location$fetchResources = F6(function(locationGroupId, listOptionals, toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Location$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                rm: locationGroupId,
                af_: $elm$core$Maybe$Just(pagination),
                agq: query
            });
        }), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$Location$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$Location$retrieveResource = F5(function(locationGroupId, listOptionals, toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Location$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id),
                rm: locationGroupId,
                af_: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
            });
        }), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$Location$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$Location$selectId = 'locations';
    var $author$project$Components$SyncedIcon$Master = 0;
    var $author$project$Components$SyncedIcon$Role = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$SyncedIcon$master = $author$project$Components$SyncedIcon$Role(0);
    var $author$project$Components$SyncedIcon$SyncStatus = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$SyncedIcon$status = $author$project$Components$SyncedIcon$SyncStatus;
    var $author$project$Components$SyncedIcon$Synced = 1;
    var $author$project$Components$SyncedIcon$synced = $author$project$Components$SyncedIcon$Role(1);
    var $author$project$Components$ResourceFilter$Location$toTitle = function($) {
        return $.zr;
    };
    var $author$project$Ui$Icon$Current = 4;
    var $author$project$Ui$Icon$currentColor = $author$project$Ui$Icon$IconColor(4);
    var $author$project$Ui$Icon$SyncedTo = 0;
    var $author$project$Ui$Icon$syncedTo = $author$project$Ui$Icon$viewIcon(0);
    var $author$project$Components$SyncedIcon$defaultOptions = {
        hP: $author$project$Ui$Icon$currentColor,
        QZ: $author$project$Ui$Icon$syncedTo,
        Tk: false,
        ahq: $author$project$Ui$Icon$base
    };
    var $author$project$Ui$Icon$Primary = 1;
    var $author$project$Ui$Icon$primary = $author$project$Ui$Icon$IconColor(1);
    var $author$project$Ui$Icon$SyncedFrom = 1;
    var $author$project$Ui$Icon$syncedFrom = $author$project$Ui$Icon$viewIcon(1);
    var $author$project$Components$SyncedIcon$optionToRecord = F2(function(option, record) {
        switch(option.$){
            case 2:
                var _v1 = option.a;
                return _Utils_update(record, {
                    ahq: $author$project$Ui$Icon$base
                });
            case 0:
                if (!option.a) {
                    var _v2 = option.a;
                    return _Utils_update(record, {
                        QZ: $author$project$Ui$Icon$syncedTo
                    });
                } else {
                    var _v3 = option.a;
                    return _Utils_update(record, {
                        QZ: $author$project$Ui$Icon$syncedFrom
                    });
                }
            default:
                if (option.a.$ === 1) {
                    var _v4 = option.a;
                    return record;
                } else {
                    var status_ = option.a.a;
                    switch(status_){
                        case 2:
                            return _Utils_update(record, {
                                hP: $author$project$Ui$Icon$primary
                            });
                        case 1:
                            return _Utils_update(record, {
                                hP: $author$project$Ui$Icon$currentColor
                            });
                        case 3:
                            return _Utils_update(record, {
                                hP: $author$project$Ui$Icon$danger
                            });
                        default:
                            return _Utils_update(record, {
                                hP: $author$project$Ui$Icon$info
                            });
                    }
                }
        }
    });
    var $author$project$Components$SyncedIcon$view = function(options) {
        var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$SyncedIcon$optionToRecord, $author$project$Components$SyncedIcon$defaultOptions, options);
        return optionsRecord.Tk ? $author$project$Utils$Html$empty : A2($elm$html$Html$map, $elm$core$Basics$never, optionsRecord.QZ(_List_fromArray([
            optionsRecord.hP,
            optionsRecord.ahq
        ])));
    };
    var $author$project$Components$ResourceFilter$Location$toLabel = function(resource) {
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceX2
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Components$ResourceFilter$Location$toTitle(resource))
                ])),
                resource.R8 ? $author$project$Components$SyncedIcon$view(_List_fromArray([
                    $author$project$Components$SyncedIcon$master,
                    $author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
                ])) : $elm$html$Html$text(''),
                resource.Su ? $author$project$Components$SyncedIcon$view(_List_fromArray([
                    $author$project$Components$SyncedIcon$synced,
                    $author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
                ])) : $elm$html$Html$text('')
            ]))
        ]);
    };
    var $author$project$Components$ResourceFilter$Location$toValue = function($) {
        return $.aef;
    };
    var $author$project$Components$ResourceFilter$Location$init = F4(function(apiClient, locationGroupId, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: A2($author$project$Components$ResourceFilter$Location$fetchResources, locationGroupId, listOptionals),
            aef: $author$project$Components$ResourceFilter$Location$selectId,
            gD: 'Location',
            sz: A2($author$project$Components$ResourceFilter$Location$retrieveResource, locationGroupId, listOptionals),
            ahW: $author$project$Components$ResourceFilter$Location$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Location$toTitle,
            g4: $author$project$Components$ResourceFilter$Location$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Admin$Documents$Form$initPlanResourceFilter = F3(function(apiClient, session, planType) {
        var planTypes = !planType ? _List_fromArray([
            0,
            1
        ]) : _List_fromArray([
            2,
            3
        ]);
        return A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                A8: planTypes
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Plan'
            });
        });
    });
    var $author$project$Api$Provider$Document$One$Document = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Document$Shared$Document = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Document$Shared$Record = function(id) {
        return function(documentType) {
            return function(name) {
                return function(active) {
                    return function(showOnSignup) {
                        return function(required) {
                            return function(documentAgreementsCount) {
                                return function(acceptanceText) {
                                    return function(acceptanceType) {
                                        return function(status) {
                                            return {
                                                Ib: acceptanceText,
                                                Ic: acceptanceType,
                                                Ir: active,
                                                Oe: documentAgreementsCount,
                                                Og: documentType,
                                                aef: id,
                                                zr: name,
                                                agM: required,
                                                _i: showOnSignup,
                                                ahy: status
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Document$AcceptanceType$ClickBox = 0;
    var $author$project$Api$Provider$Document$AcceptanceType$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'click_box':
                return $elm$json$Json$Decode$succeed(0);
            case 'type_name':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unsupported document -> acceptance type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Document$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'acceptance_type', $author$project$Api$Provider$Document$AcceptanceType$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'acceptance_text', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'document_agreements_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'required', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'show_on_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'document_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$Shared$Record)))))))))));
    var $author$project$Api$Provider$Document$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Document$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Document$One$Record = F3(function(currentDocumentVersion, documentScopes, translations) {
        return {
            acH: currentDocumentVersion,
            Of: documentScopes,
            aay: translations
        };
    });
    var $author$project$Api$Provider$DocumentVersion$Shared$DocumentVersion = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DocumentVersion$Shared$Record = F5(function(id, documentVersionType, content, linkUrl, createdAt) {
        return {
            EU: content,
            Mx: createdAt,
            xn: documentVersionType,
            aef: id,
            Tg: linkUrl
        };
    });
    var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$Link = 0;
    var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$Text = 2;
    var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'file':
                return $elm$json$Json$Decode$succeed(1);
            case 'text':
                return $elm$json$Json$Decode$succeed(2);
            case 'link':
                return $elm$json$Json$Decode$succeed(0);
            default:
                return $elm$json$Json$Decode$fail('Unsupported document version -> document version type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$DocumentVersion$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'link_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'content', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'document_version_type', $author$project$Api$Provider$DocumentVersion$DocumentVersionType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DocumentVersion$Shared$Record))))));
    var $author$project$Api$Provider$DocumentVersion$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DocumentVersion$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Translation$All$Record = F4(function(id, content, field, language) {
        return {
            EU: content,
            PD: field,
            aef: id,
            yC: language
        };
    });
    var $author$project$Api$Provider$Translation$All$Translation = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Translation$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'language', $author$project$Language$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'field', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'content', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Translation$All$Record))))), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DocumentScope$Shared$DocumentScope = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DocumentScope$Shared$Record = F3(function(scopeIdent, scopeName, scopeType) {
        return {
            Zw: scopeIdent,
            Zx: scopeName,
            Zy: scopeType
        };
    });
    var $author$project$Api$Provider$DocumentScope$Shared$Location = 1;
    var $author$project$Api$Provider$DocumentScope$Shared$Plan = 0;
    var $author$project$Api$Provider$DocumentScope$Shared$scopeTypeDecoder = function(string) {
        switch(string){
            case 'Plan':
                return $elm$json$Json$Decode$succeed(0);
            case 'Location':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unsupported document scope -> scope type: ' + string);
        }
    };
    var $author$project$Api$Provider$DocumentScope$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'scope_type', A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$DocumentScope$Shared$scopeTypeDecoder, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'scope_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'scope_ident', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DocumentScope$Shared$Record))));
    var $author$project$Api$Provider$DocumentScope$Shared$sharedDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DocumentScope$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Document$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'translations', $elm$json$Json$Decode$list($author$project$Api$Provider$Translation$All$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'document_scopes', $elm$json$Json$Decode$list($author$project$Api$Provider$DocumentScope$Shared$sharedDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'current_document_version', $author$project$Api$Provider$DocumentVersion$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$One$Record))));
    var $author$project$Api$Provider$Document$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Document$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Document$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$One$Document)));
    var $author$project$Api$Provider$Document$documentsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'documents'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Document$documentPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Document$documentsPath);
    };
    var $author$project$Api$Provider$Document$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Document$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentPath(id_)));
    });
    var $author$project$Components$Admin$Documents$Form$init = F5(function(apiClient, session, id, practice, _v0) {
        var isOnboarding = _v0.aK;
        var multiLanguage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice);
        var _v1 = A3($author$project$Components$Admin$Documents$Form$initPlanResourceFilter, apiClient, session, 2);
        var planResourceFilter = _v1.a;
        var planResourceFilterCmd = _v1.b;
        var _v2 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Location'
            });
        });
        var locationResourceFilter = _v2.a;
        var locationResourceFilterCmd = _v2.b;
        var _v3 = function() {
            if (!id.$) {
                var id_ = id.a;
                return _Utils_Tuple2($elm$core$Maybe$Nothing, A3($author$project$Api$Provider$Document$retrieve, apiClient, id_, $author$project$Components$Admin$Documents$Form$GotItem));
            } else return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, $author$project$Components$Admin$Documents$Form$formFieldsInit(practice));
        }();
        var formFields = _v3.a;
        var cmd = _v3.b;
        return _Utils_Tuple2({
            w2: $elm$core$Maybe$Nothing,
            lY: multiLanguage ? $elm$core$Maybe$Just($author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'document-content-language-dropdown',
                ahX: $author$project$Components$Admin$Documents$Form$LanguageDropdownMsg
            }))) : $elm$core$Maybe$Nothing,
            fC: $author$project$Language$english,
            PU: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
            aef: id,
            RR: false,
            aK: isOnboarding,
            ro: locationResourceFilter,
            jy: planResourceFilter,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            ahy: 'published',
            g7: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg, locationResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$Admin$Documents$Id_String$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var params = _v1.VU;
        var _v2 = A5($author$project$Components$Admin$Documents$Form$init, apiClient, session, $elm$core$Maybe$Just(params.aef), practice, {
            aK: false
        });
        var form = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$Documents$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Documents$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Admin$Documents$Form$Content = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Documents$Form$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$Ignore = {
        $: 0
    };
    var $author$project$Components$Admin$Documents$Form$TranslationsInputMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$documentContentEditorId = 'document-content-editor';
    var $author$project$Components$TranslationsInput$ModalClosed = {
        $: 0
    };
    var $author$project$Components$TranslationsInput$subscriptions = function(_v0) {
        var open = _v0.Vw;
        var languageDropdown = _v0.mS;
        return open ? languageDropdown.Vw ? $author$project$Ui$Dropdown$subscriptions(languageDropdown) : $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$TranslationsInput$ModalClosed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Admin$Documents$Form$subscriptions = function(_v0) {
        var translationInput = _v0.g7;
        var documentTranslationLanguage = _v0.fC;
        var documentTranslationDropdown = _v0.lY;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$TranslationsInput$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$Admin$Documents$Form$TranslationsInputMsg)), translationInput)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Ui$Dropdown$subscriptions, documentTranslationDropdown)),
            $author$project$Ports$CKEditor$onChange(F2(function(elementId, value) {
                return _Utils_eq(elementId, $author$project$Components$Admin$Documents$Form$documentContentEditorId) ? A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Content(documentTranslationLanguage))(value) : $author$project$Components$Admin$Documents$Form$Ignore;
            }))
        ]));
    };
    var $author$project$Pages$Admin$Documents$Id_String$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$Documents$Form$subscriptions(model.PU));
    };
    var $author$project$Components$Admin$Documents$Form$Archived = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$DocumentScopeAdd = F3(function(a, b, c) {
        return {
            $: 10,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Admin$Documents$Form$DocumentVersionType = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$File = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Documents$Form$GotSignedFileUrl = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$Save = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$Unarchived = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$Provider$Document$documentArchivePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'archive'
        ]), $author$project$Api$Provider$Document$documentPath(id_));
    };
    var $author$project$Api$Provider$Document$archive = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Document$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentArchivePath(id_)));
    });
    var $author$project$Components$Admin$Documents$Form$contentByLanguage = F2(function(language, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var content = _v0.EU;
        var translations = _v0.aay;
        return _Utils_eq(language, $author$project$Language$english) ? content : A2($elm$core$Maybe$map, function($) {
            return $.EU;
        }, A2($elm_community$list_extra$List$Extra$find, function(t) {
            return _Utils_eq(t.yC, language) && t.PD === 'content';
        }, translations));
    });
    var $author$project$Api$Provider$Document$One$currentDocumentVersion = function(_v0) {
        var record = _v0.b;
        return record.acH;
    };
    var $author$project$Components$TranslationsInput$Document = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$document = $author$project$Components$TranslationsInput$Document;
    var $author$project$Api$Provider$Document$Shared$acceptanceText = function(_v0) {
        var record = _v0;
        return record.Ib;
    };
    var $author$project$Api$Provider$Document$One$acceptanceText = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$acceptanceText(shared);
    };
    var $author$project$Api$Provider$Document$Shared$acceptanceType = function(_v0) {
        var record = _v0;
        return record.Ic;
    };
    var $author$project$Api$Provider$Document$One$acceptanceType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$acceptanceType(shared);
    };
    var $author$project$Api$Provider$Document$Shared$active = function(_v0) {
        var record = _v0;
        return record.Ir;
    };
    var $author$project$Api$Provider$Document$One$active = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$active(shared);
    };
    var $author$project$Api$Provider$DocumentVersion$Shared$content = function(_v0) {
        var record = _v0;
        return record.EU;
    };
    var $author$project$Api$Provider$Translation$All$content = function(_v0) {
        var translation = _v0;
        return translation.EU;
    };
    var $author$project$Api$Provider$Document$One$documentScopes = function(_v0) {
        var record = _v0.b;
        return record.Of;
    };
    var $author$project$Api$Provider$Document$Shared$documentType = function(_v0) {
        var record = _v0;
        return record.Og;
    };
    var $author$project$Api$Provider$Document$One$documentType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$documentType(shared);
    };
    var $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType = function(_v0) {
        var record = _v0;
        return record.xn;
    };
    var $author$project$Api$Provider$Translation$All$field = function(_v0) {
        var translation = _v0;
        return translation.PD;
    };
    var $author$project$Api$Provider$Translation$All$language = function(_v0) {
        var translation = _v0;
        return translation.yC;
    };
    var $author$project$Api$Provider$DocumentVersion$Shared$linkUrl = function(_v0) {
        var record = _v0;
        return record.Tg;
    };
    var $author$project$Api$Provider$Document$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Document$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$name(shared);
    };
    var $author$project$Api$Provider$Document$Shared$required = function(_v0) {
        var record = _v0;
        return record.agM;
    };
    var $author$project$Api$Provider$Document$One$required = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$required(shared);
    };
    var $author$project$Api$Provider$DocumentScope$Shared$scopeIdent = function(_v0) {
        var record = _v0;
        return record.Zw;
    };
    var $author$project$Api$Provider$DocumentScope$Shared$scopeName = function(_v0) {
        var record = _v0;
        return record.Zx;
    };
    var $author$project$Api$Provider$DocumentScope$Shared$scopeType = function(_v0) {
        var record = _v0;
        return record.Zy;
    };
    var $author$project$Api$Provider$Document$Shared$showOnSignup = function(_v0) {
        var record = _v0;
        return record._i;
    };
    var $author$project$Api$Provider$Document$One$showOnSignup = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$showOnSignup(shared);
    };
    var $author$project$Api$Provider$Document$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Document$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$status(shared);
    };
    var $author$project$Api$Provider$Document$One$translations = function(_v0) {
        var record = _v0.b;
        return record.aay;
    };
    var $author$project$Components$Admin$Documents$Form$formFieldsFromItem = function(document1) {
        var documentScopes = A2($elm$core$List$map, function(documentScope) {
            return {
                Zw: $author$project$Api$Provider$DocumentScope$Shared$scopeIdent(documentScope),
                Zx: $author$project$Api$Provider$DocumentScope$Shared$scopeName(documentScope),
                Zy: $author$project$Api$Provider$DocumentScope$Shared$scopeType(documentScope)
            };
        }, $author$project$Api$Provider$Document$One$documentScopes(document1));
        var currentDocumentVersion = $author$project$Api$Provider$Document$One$currentDocumentVersion(document1);
        var documentVersionType = $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType(currentDocumentVersion);
        var content = $author$project$Api$Provider$DocumentVersion$Shared$content(currentDocumentVersion);
        var cmd = documentVersionType === 2 ? A3($author$project$Ports$CKEditor$replace, $author$project$Components$Admin$Documents$Form$documentContentEditorId, A2($elm$core$Maybe$withDefault, '', content), _List_Nil) : $elm$core$Platform$Cmd$none;
        return _Utils_Tuple2({
            Ib: $author$project$Api$Provider$Document$One$acceptanceText(document1),
            Ic: $author$project$Api$Provider$Document$One$acceptanceType(document1),
            Ir: $author$project$Api$Provider$Document$One$active(document1),
            EU: content,
            d1: A2($elm$core$Maybe$map, $author$project$Api$Provider$DocumentScope$Shared$scopeType, $elm$core$List$head($author$project$Api$Provider$Document$One$documentScopes(document1))),
            Of: documentScopes,
            Og: $elm$core$Maybe$Just($author$project$Api$Provider$Document$One$documentType(document1)),
            xn: documentVersionType,
            qJ: 0,
            PH: $elm$core$Maybe$Nothing,
            qP: documentVersionType === 1,
            Tg: $author$project$Api$Provider$DocumentVersion$Shared$linkUrl(currentDocumentVersion),
            zr: $author$project$Api$Provider$Document$One$name(document1),
            WN: 2,
            agM: $author$project$Api$Provider$Document$One$required(document1),
            _i: $author$project$Api$Provider$Document$One$showOnSignup(document1),
            ahy: $author$project$Api$Provider$Document$One$status(document1),
            aay: A2($elm$core$List$map, function(t) {
                return {
                    EU: $author$project$Api$Provider$Translation$All$content(t),
                    PD: $author$project$Api$Provider$Translation$All$field(t),
                    yC: $author$project$Api$Provider$Translation$All$language(t)
                };
            }, $author$project$Api$Provider$Document$One$translations(document1))
        }, cmd);
    };
    var $author$project$Components$Admin$Documents$Form$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    Og: $author$project$Utils$String$toMaybe(string)
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 2:
                var documentVersionType = field.a;
                return _Utils_update(fields, {
                    xn: documentVersionType
                });
            case 3:
                var _int = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    qJ: _int,
                    PH: $elm$core$Maybe$Just(string),
                    qP: true
                });
            case 4:
                var language = field.a;
                var string = field.b;
                if (_Utils_eq(language, $author$project$Language$english)) return _Utils_update(fields, {
                    EU: $author$project$Utils$String$toMaybe(string)
                });
                else {
                    var translations = A2($elm$core$List$cons, {
                        EU: string,
                        PD: 'content',
                        yC: language
                    }, A2($elm$core$List$filter, function(t) {
                        return !(_Utils_eq(t.yC, language) && t.PD === 'content');
                    }, fields.aay));
                    return _Utils_update(fields, {
                        aay: translations
                    });
                }
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    Tg: $author$project$Utils$String$toMaybe(string)
                });
            case 6:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ir: bool
                });
            case 7:
                var bool = field.a;
                return _Utils_update(fields, {
                    _i: bool
                });
            case 8:
                var documentScopeType = field.a;
                return _Utils_update(fields, {
                    d1: documentScopeType,
                    Of: _List_Nil
                });
            case 9:
                var planType = field.a;
                return _Utils_update(fields, {
                    WN: planType
                });
            case 10:
                var scopeType = field.a;
                var id = field.b;
                var name = field.c;
                var documentScope = A2($elm_community$list_extra$List$Extra$find, function(documentScope_) {
                    return _Utils_eq(documentScope_.Zy, scopeType) && _Utils_eq(documentScope_.Zw, id);
                }, fields.Of);
                var documentScopes = function() {
                    if (!documentScope.$) return fields.Of;
                    else return A2($elm$core$List$cons, {
                        Zw: id,
                        Zx: name,
                        Zy: scopeType
                    }, fields.Of);
                }();
                return _Utils_update(fields, {
                    Of: documentScopes
                });
            case 11:
                var scopeType = field.a;
                var id = field.b;
                var documentScopes = A2($elm_community$list_extra$List$Extra$filterNot, function(documentScope) {
                    return _Utils_eq(documentScope.Zy, scopeType) && _Utils_eq(documentScope.Zw, id);
                }, fields.Of);
                return _Utils_update(fields, {
                    Of: documentScopes
                });
            case 12:
                var bool = field.a;
                return _Utils_update(fields, {
                    agM: bool,
                    _i: bool || fields._i
                });
            case 13:
                var string = field.a;
                return _Utils_update(fields, {
                    Ic: string
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    Ib: string
                });
        }
    });
    var $author$project$Components$Admin$Documents$Form$DocumentTypeValidation = 0;
    var $author$project$Components$Admin$Documents$Form$NameValidation = 1;
    var $author$project$Components$Admin$Documents$Form$ContentValidation = 4;
    var $author$project$Components$Admin$Documents$Form$validateContent = function(fields) {
        var invalid = _Utils_Tuple2(4, 'Please enter some text');
        var _v0 = _Utils_Tuple2(fields.xn, fields.EU);
        if (_v0.a === 2) {
            if (!_v0.b.$) {
                var _v1 = _v0.a;
                var content = _v0.b.a;
                return $elm$core$String$isEmpty(content) ? _List_fromArray([
                    invalid
                ]) : _List_Nil;
            } else {
                var _v2 = _v0.a;
                var _v3 = _v0.b;
                return _List_fromArray([
                    invalid
                ]);
            }
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$Documents$Form$DocumentScopesValidation = 5;
    var $author$project$Components$Admin$Documents$Form$validateDocumentScopes = function(fields) {
        var invalid = function(scopeName) {
            return _Utils_Tuple2(5, 'Please specify at least one ' + (scopeName + '.'));
        };
        var _v0 = _Utils_Tuple2(fields.d1, $elm$core$List$isEmpty(fields.Of));
        _v0$2: while(true){
            if (!_v0.a.$) {
                if (!_v0.a.a) {
                    if (_v0.b) {
                        var _v1 = _v0.a.a;
                        return _List_fromArray([
                            invalid('plan')
                        ]);
                    } else break _v0$2;
                } else {
                    if (_v0.b) {
                        var _v2 = _v0.a.a;
                        return _List_fromArray([
                            invalid('location')
                        ]);
                    } else break _v0$2;
                }
            } else break _v0$2;
        }
        return _List_Nil;
    };
    var $author$project$Components$Admin$Documents$Form$FileValidation = 3;
    var $author$project$Components$Admin$Documents$Form$maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Admin$Documents$Form$validateFile = function(fields) {
        var _v0 = _Utils_Tuple2(fields.xn, fields.qP);
        if (_v0.a === 1) {
            if (_v0.b) {
                var _v1 = _v0.a;
                return _Utils_cmp(fields.qJ, $author$project$Components$Admin$Documents$Form$maxFileBytesSize) > 0 ? _List_fromArray([
                    _Utils_Tuple2(3, 'That file is too large! Our maximum file size is 5 mb.')
                ]) : _List_Nil;
            } else {
                var _v2 = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2(3, 'Please upload a file')
                ]);
            }
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$Documents$Form$UrlValidation = 2;
    var $author$project$Components$Admin$Documents$Form$validateUrl = function(fields) {
        var invalid = _Utils_Tuple2(2, 'URL must start with https://');
        var _v0 = _Utils_Tuple2(fields.xn, fields.Tg);
        if (!_v0.a) {
            if (!_v0.b.$) {
                var _v1 = _v0.a;
                var linkUrl = _v0.b.a;
                return A2($elm$core$String$startsWith, 'https://', linkUrl) ? _List_Nil : _List_fromArray([
                    invalid
                ]);
            } else {
                var _v2 = _v0.a;
                var _v3 = _v0.b;
                return _List_fromArray([
                    invalid
                ]);
            }
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$Documents$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Og;
        }, _Utils_Tuple2(0, 'Please pick a document type.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(1, 'Please enter a name.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateUrl),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateFile),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateContent),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$Documents$Form$validateDocumentScopes)
    ]));
    var $author$project$Api$Provider$Document$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Document$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$id(shared);
    };
    var $author$project$Api$Provider$DocumentVersion$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$TranslationsInput$LanguageDropdownMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$init = function(translatable_) {
        var availableLanguages = _List_fromArray([
            $author$project$Language$spanish
        ]);
        return {
            vI: availableLanguages,
            PU: $elm$core$Maybe$Nothing,
            yC: A2($elm$core$Maybe$withDefault, $author$project$Language$spanish, $elm$core$List$head(availableLanguages)),
            mS: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'translations-language-dropdown',
                ahX: $author$project$Components$TranslationsInput$LanguageDropdownMsg
            })),
            Vw: false,
            g6: translatable_,
            aay: $author$project$Api$Data$NotAsked
        };
    };
    var $author$project$Components$Admin$Documents$Form$isDocumentArchived = function(status) {
        return status === 'archived';
    };
    var $author$project$Components$Admin$Documents$Form$Created = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$ResetAndAddAnother = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$apiFields = function(fields) {
        return {
            Ib: fields.Ib,
            Ic: fields.Ic,
            Ir: fields.Ir,
            EU: fields.EU,
            Of: A2($elm$core$List$map, function(documentScope) {
                return {
                    Zw: documentScope.Zw,
                    Zy: documentScope.Zy
                };
            }, fields.Of),
            Og: A2($elm$core$Maybe$withDefault, '', fields.Og),
            xn: fields.xn,
            adN: fields.PH,
            zr: fields.zr,
            agM: fields.agM,
            _i: fields._i,
            ahy: fields.ahy,
            aay: fields.aay,
            aaT: fields.Tg
        };
    };
    var $author$project$Api$Provider$Document$encodeTranslations = $elm$json$Json$Encode$list(function(t) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('field', $elm$json$Json$Encode$string(t.PD)),
            _Utils_Tuple2('content', $elm$json$Json$Encode$string(t.EU)),
            _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(t.yC)))
        ]));
    });
    var $author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString = function(scopeType_) {
        if (!scopeType_) return 'Plan';
        else return 'Location';
    };
    var $author$project$Api$Provider$Document$AcceptanceType$toString = function(acceptanceType_) {
        if (!acceptanceType_) return 'click_box';
        else return 'type_name';
    };
    var $author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString = function(documentVersionType_) {
        switch(documentVersionType_){
            case 0:
                return 'link';
            case 1:
                return 'file';
            default:
                return 'text';
        }
    };
    var $author$project$Api$Provider$Document$create = F3(function(apiClient, fields, toMsg) {
        var documentVersion = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('document_version_type', $elm$json$Json$Encode$string($author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString(fields.xn))),
            function() {
                var _v1 = fields.xn;
                switch(_v1){
                    case 1:
                        return _Utils_Tuple2('file', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adN));
                    case 0:
                        return _Utils_Tuple2('url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aaT));
                    default:
                        return _Utils_Tuple2('content', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.EU));
                }
            }()
        ]));
        var documentScopes_ = A2($elm$json$Json$Encode$list, function(_v0) {
            var scopeType = _v0.Zy;
            var scopeIdent = _v0.Zw;
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('scope_type', $elm$json$Json$Encode$string($author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString(scopeType))),
                _Utils_Tuple2('scope_ident', $elm$json$Json$Encode$string(scopeIdent))
            ]));
        }, fields.Of);
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('document', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('required', $elm$json$Json$Encode$bool(fields.agM)),
                _Utils_Tuple2('active', $elm$json$Json$Encode$bool(fields.Ir)),
                _Utils_Tuple2('show_on_signup', $elm$json$Json$Encode$bool(fields._i)),
                _Utils_Tuple2('acceptance_text', $elm$json$Json$Encode$string(fields.Ib)),
                _Utils_Tuple2('document_type', $elm$json$Json$Encode$string(fields.Og)),
                _Utils_Tuple2('acceptance_type', $elm$json$Json$Encode$string($author$project$Api$Provider$Document$AcceptanceType$toString(fields.Ic))),
                _Utils_Tuple2('document_scopes', documentScopes_),
                _Utils_Tuple2('document_version', documentVersion),
                _Utils_Tuple2('status', $elm$json$Json$Encode$string(fields.ahy)),
                _Utils_Tuple2('translations', $author$project$Api$Provider$Document$encodeTranslations(fields.aay))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Document$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentsPath)));
    });
    var $author$project$Components$Admin$Documents$Form$createItem = F3(function(apiClient, formFields, addAnother) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var createMsg = addAnother ? $author$project$Components$Admin$Documents$Form$ResetAndAddAnother : $author$project$Components$Admin$Documents$Form$Created;
        return A3($author$project$Api$Provider$Document$create, apiClient, $author$project$Components$Admin$Documents$Form$apiFields(fields), createMsg);
    });
    var $author$project$Components$Admin$Documents$Form$Updated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Document$update = F4(function(apiClient, id_, fields, toMsg) {
        var documentVersion = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('document_version_type', $elm$json$Json$Encode$string($author$project$Api$Provider$DocumentVersion$DocumentVersionType$toString(fields.xn))),
            function() {
                var _v1 = fields.xn;
                switch(_v1){
                    case 1:
                        return _Utils_Tuple2('file', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adN));
                    case 0:
                        return _Utils_Tuple2('url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aaT));
                    default:
                        return _Utils_Tuple2('content', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.EU));
                }
            }()
        ]));
        var documentScopes_ = A2($elm$json$Json$Encode$list, function(_v0) {
            var scopeType = _v0.Zy;
            var scopeIdent = _v0.Zw;
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('scope_type', $elm$json$Json$Encode$string($author$project$Api$Provider$DocumentScope$Shared$scopeTypeToString(scopeType))),
                _Utils_Tuple2('scope_ident', $elm$json$Json$Encode$string(scopeIdent))
            ]));
        }, fields.Of);
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('document', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('required', $elm$json$Json$Encode$bool(fields.agM)),
                _Utils_Tuple2('active', $elm$json$Json$Encode$bool(fields.Ir)),
                _Utils_Tuple2('show_on_signup', $elm$json$Json$Encode$bool(fields._i)),
                _Utils_Tuple2('acceptance_text', $elm$json$Json$Encode$string(fields.Ib)),
                _Utils_Tuple2('document_type', $elm$json$Json$Encode$string(fields.Og)),
                _Utils_Tuple2('acceptance_type', $elm$json$Json$Encode$string($author$project$Api$Provider$Document$AcceptanceType$toString(fields.Ic))),
                _Utils_Tuple2('document_scopes', documentScopes_),
                _Utils_Tuple2('document_version', documentVersion),
                _Utils_Tuple2('translations', $author$project$Api$Provider$Document$encodeTranslations(fields.aay))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Document$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentPath(id_))));
    });
    var $author$project$Components$Admin$Documents$Form$updateItem = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Document$update, apiClient, id, $author$project$Components$Admin$Documents$Form$apiFields(fields), $author$project$Components$Admin$Documents$Form$Updated);
    });
    var $author$project$Components$Admin$Documents$Form$saveItem = F4(function(apiClient, maybeId, formFields, addAnother) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Components$Admin$Documents$Form$updateItem, apiClient, id_, formFields);
        } else return A3($author$project$Components$Admin$Documents$Form$createItem, apiClient, formFields, addAnother);
    });
    var $author$project$Api$Provider$DocumentVersion$documentVersionsPath = function(documentId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'document_versions'
        ]), $author$project$Api$Provider$Document$documentPath(documentId));
    };
    var $author$project$Api$Provider$DocumentVersion$documentVersionPath = F2(function(documentId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$DocumentVersion$documentVersionsPath(documentId));
    });
    var $author$project$Api$Provider$DocumentVersion$signedFileUrlDecoder = A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$DocumentVersion$signedFileUrl = F4(function(apiClient, documentId, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$DocumentVersion$signedFileUrlDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_file_url'
        ]), A2($author$project$Api$Provider$DocumentVersion$documentVersionPath, documentId, id_))));
    });
    var $author$project$Components$Admin$Documents$Form$PracticeOnboardingUpdated = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$updatePracticeOnboarding = F3(function(apiClient, onboardId, accountStep) {
        return A4($author$project$Api$Provider$PracticeOnboarding$updateAccountStep, apiClient, accountStep, onboardId, $author$project$Components$Admin$Documents$Form$PracticeOnboardingUpdated);
    });
    var $author$project$Components$Admin$Documents$Form$skipDocumentsSetup = F2(function(apiClient, practice) {
        var onboardId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$Shared$id, $author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
        return A3($author$project$Components$Admin$Documents$Form$updatePracticeOnboarding, apiClient, onboardId, $author$project$Api$Provider$PracticeOnboarding$AccountStep$toString(3));
    });
    var $author$project$Api$Provider$Document$documentUnarchivePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unarchive'
        ]), $author$project$Api$Provider$Document$documentPath(id_));
    };
    var $author$project$Api$Provider$Document$unarchive = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Document$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentUnarchivePath(id_)));
    });
    var $author$project$Components$ResourceFilter$Location$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$TranslationsInput$Content = $elm$core$Basics$identity;
    var $author$project$Components$TranslationsInput$TranslationCreated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$TranslationDeleted = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$TranslationUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$findTranslation = F3(function(lang, field, translations) {
        return $elm$core$List$head(A2($elm$core$List$filter, function(t) {
            return _Utils_eq($author$project$Api$Provider$Translation$All$language(t), lang) && _Utils_eq($author$project$Api$Provider$Translation$All$field(t), field);
        }, translations));
    });
    var $author$project$Api$Provider$Translation$All$id = function(_v0) {
        var translation = _v0;
        return translation.aef;
    };
    var $author$project$Components$TranslationsInput$andInitForm = F4(function(field, defaultContent, translations, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        var translation = A3($author$project$Components$TranslationsInput$findTranslation, model.yC, field, translations);
        return _Utils_Tuple2(_Utils_update(model, {
            PU: $elm$core$Maybe$Just($author$project$Utils$Form$init({
                EU: A2($elm$core$Maybe$withDefault, defaultContent, A2($elm$core$Maybe$map, $author$project$Api$Provider$Translation$All$content, translation)),
                PD: field,
                aef: A2($elm$core$Maybe$map, $author$project$Api$Provider$Translation$All$id, translation)
            })),
            Vw: true
        }), cmd);
    });
    var $author$project$Components$TranslationsInput$GotTranslations = F3(function(a, b, c) {
        return {
            $: 2,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Translation$listOptionsToParams = function(params) {
        return _List_fromArray([
            A2($author$project$Api$Param$string, 'translatable_id', params.DM),
            A2($author$project$Api$Param$string, 'translatable_type', params.DN)
        ]);
    };
    var $author$project$Api$Translation$translationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'translations'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Translation$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Translation$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Translation$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Translation$translationsPath)));
    });
    var $author$project$Components$TranslationsInput$translatableToId = function(translatable_) {
        switch(translatable_.$){
            case 0:
                var id = translatable_.a;
                return id;
            case 1:
                var id = translatable_.a;
                return id;
            default:
                return '';
        }
    };
    var $author$project$Components$TranslationsInput$translatableToResource = function(translatable_) {
        switch(translatable_.$){
            case 0:
                return 'lead_sources';
            case 1:
                return 'documents';
            default:
                return 'practices';
        }
    };
    var $author$project$Components$TranslationsInput$andOpenModal = F4(function(client, field, defaultContent, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        var _v1 = model.aay;
        switch(_v1.$){
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: true
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A3($author$project$Api$Translation$list, client, {
                        DM: $author$project$Components$TranslationsInput$translatableToId(model.g6),
                        DN: $author$project$Components$TranslationsInput$translatableToResource(model.g6)
                    }, A2($author$project$Components$TranslationsInput$GotTranslations, field, defaultContent))
                ])));
            case 3:
                var translations = _v1.a;
                return A4($author$project$Components$TranslationsInput$andInitForm, field, defaultContent, translations, _Utils_Tuple2(_Utils_update(model, {
                    Vw: true
                }), cmd));
            default:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: true
                }), cmd);
        }
    });
    var $author$project$Api$Translation$encodeCreateFields = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('translation', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('translatable_id', $elm$json$Json$Encode$string(fields.DM)),
                _Utils_Tuple2('translatable_type', $elm$json$Json$Encode$string(fields.DN)),
                _Utils_Tuple2('field', $elm$json$Json$Encode$string(fields.PD)),
                _Utils_Tuple2('content', $elm$json$Json$Encode$string(fields.EU)),
                _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.yC)))
            ])))
        ]));
    };
    var $author$project$Api$Translation$create = F3(function(apiClient, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Translation$All$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Translation$encodeCreateFields(fields), $author$project$Api$Data$requestTo($author$project$Api$Translation$translationsPath)));
    });
    var $author$project$Api$Translation$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Provider$Translation$All$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Translation$translationsPath)));
    });
    var $author$project$Api$Translation$encodeUpdateFields = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('translation', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('field', $elm$json$Json$Encode$string(fields.PD)),
                _Utils_Tuple2('content', $elm$json$Json$Encode$string(fields.EU)),
                _Utils_Tuple2('language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.yC)))
            ])))
        ]));
    };
    var $author$project$Api$Translation$update = F4(function(apiClient, id, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Translation$All$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Translation$encodeUpdateFields(fields), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Translation$translationsPath))));
    });
    var $author$project$Components$TranslationsInput$updateFormFields = F2(function(field, form) {
        var content = field;
        return _Utils_update(form, {
            EU: content
        });
    });
    var $author$project$Components$TranslationsInput$update = F3(function(client, msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: false
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var field = msg.a;
                var defaultContent = msg.b;
                return A4($author$project$Components$TranslationsInput$andOpenModal, client, field, defaultContent, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
            case 2:
                var field = msg.a;
                var defaultContent = msg.b;
                var response = msg.c;
                return function(modelCmd) {
                    if (response.$ === 3) {
                        var translations = response.a;
                        return A4($author$project$Components$TranslationsInput$andInitForm, field, defaultContent, translations, modelCmd);
                    } else return modelCmd;
                }(_Utils_Tuple2(_Utils_update(model, {
                    aay: response
                }), $elm$core$Platform$Cmd$none));
            case 7:
                var translationId = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: false
                }), A3($author$project$Api$Translation$delete, client, translationId, $author$project$Components$TranslationsInput$TranslationDeleted));
            case 3:
                var content = msg.a;
                var _v2 = model.PU;
                if (!_v2.$) {
                    var form = _v2.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(A3($author$project$Utils$Form$update, $author$project$Components$TranslationsInput$updateFormFields, content, form))
                    }), $elm$core$Platform$Cmd$none);
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 5:
                var translation = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: $elm$core$Maybe$Nothing,
                    Vw: false,
                    aay: function() {
                        if (translation.$ === 3) {
                            var translation_ = translation.a;
                            return A2($author$project$Api$Data$map, function(translations) {
                                return A2($elm$core$List$cons, translation_, translations);
                            }, model.aay);
                        } else return model.aay;
                    }()
                }), $elm$core$Platform$Cmd$none);
            case 6:
                var translation = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: $elm$core$Maybe$Nothing,
                    Vw: false,
                    aay: function() {
                        if (translation.$ === 3) {
                            var translation_ = translation.a;
                            return A2($author$project$Api$Data$map, function(translations) {
                                return A2($elm$core$List$map, function(t) {
                                    return _Utils_eq($author$project$Api$Provider$Translation$All$id(t), $author$project$Api$Provider$Translation$All$id(translation_)) ? translation_ : t;
                                }, translations);
                            }, model.aay);
                        } else return model.aay;
                    }()
                }), $elm$core$Platform$Cmd$none);
            case 8:
                var translation = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    aay: function() {
                        if (translation.$ === 3) {
                            var translation_ = translation.a;
                            return A2($author$project$Api$Data$map, function(translations) {
                                return A2($elm$core$List$filterMap, function(t) {
                                    return _Utils_eq($author$project$Api$Provider$Translation$All$id(t), $author$project$Api$Provider$Translation$All$id(translation_)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(t);
                                }, translations);
                            }, model.aay);
                        } else return model.aay;
                    }()
                }), $elm$core$Platform$Cmd$none);
            case 4:
                var _v6 = model.PU;
                if (!_v6.$) {
                    var form = _v6.a;
                    return A2($elm$core$Tuple$pair, model, function(_v7) {
                        var id = _v7.aef;
                        var content = _v7.EU;
                        var field = _v7.PD;
                        if (!id.$) {
                            var id_ = id.a;
                            var body = {
                                EU: content,
                                PD: field,
                                yC: model.yC
                            };
                            return A4($author$project$Api$Translation$update, client, id_, body, $author$project$Components$TranslationsInput$TranslationUpdated);
                        } else {
                            var body = {
                                EU: content,
                                PD: field,
                                yC: model.yC,
                                DM: $author$project$Components$TranslationsInput$translatableToId(model.g6),
                                DN: $author$project$Components$TranslationsInput$translatableToResource(model.g6)
                            };
                            return A3($author$project$Api$Translation$create, client, body, $author$project$Components$TranslationsInput$TranslationCreated);
                        }
                    }($author$project$Utils$Form$fields(form)));
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 9:
                var dropdownMsg = msg.a;
                var _v9 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.mS);
                var dropdown = _v9.a;
                var dropdownCmd = _v9.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    mS: dropdown
                }), dropdownCmd);
            default:
                var language = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: $elm$core$Maybe$Nothing,
                    yC: language
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$Admin$Documents$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var document1 = response.a;
                    var translationInput = $author$project$Components$TranslationsInput$init($author$project$Components$TranslationsInput$document($author$project$Api$Provider$Document$One$id(document1)));
                    var status = $author$project$Api$Provider$Document$One$status(document1);
                    var currentDocumentVersion = $author$project$Api$Provider$Document$One$currentDocumentVersion(document1);
                    var _v3 = $author$project$Components$Admin$Documents$Form$formFieldsFromItem(document1);
                    var formFields = _v3.a;
                    var cmd = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        w2: $elm$core$Maybe$Just($author$project$Api$Provider$DocumentVersion$Shared$id(currentDocumentVersion)),
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init(formFields)),
                        RR: $author$project$Components$Admin$Documents$Form$isDocumentArchived(status),
                        ahy: status,
                        g7: $elm$core$Maybe$Just(translationInput)
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 2:
                var field = msg.a;
                var _v4 = model.PU;
                if (!_v4.$) {
                    var form = _v4.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field, form);
                    var cmd = function() {
                        if (_Utils_eq(field, $author$project$Components$Admin$Documents$Form$DocumentVersionType(2))) {
                            var content = A2($author$project$Components$Admin$Documents$Form$contentByLanguage, model.fC, newForm);
                            return A3($author$project$Ports$CKEditor$replace, $author$project$Components$Admin$Documents$Form$documentContentEditorId, A2($elm$core$Maybe$withDefault, '', content), _List_Nil);
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    var _v5 = function() {
                        if (field.$ === 9) {
                            var planType = field.a;
                            return A3($author$project$Components$Admin$Documents$Form$initPlanResourceFilter, apiClient, model.Z$, planType);
                        } else return _Utils_Tuple2(model.jy, $elm$core$Platform$Cmd$none);
                    }();
                    var planResourceFilter = _v5.a;
                    var planResourceFilterCmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        jy: planResourceFilter
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceFilterCmd)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var files = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v7) {
                    var task = _v7.a;
                    var size = _v7.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$File(size)), task);
                }, A2($elm$core$Maybe$map, function(file) {
                    return _Utils_Tuple2($elm$file$File$toUrl(file), $elm$file$File$size(file));
                }, $elm$core$List$head(files))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 4:
                var addAnother = msg.a;
                var _v8 = model.PU;
                if (!_v8.$) {
                    var form = _v8.a;
                    var _v9 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Documents$Form$formFieldsValidator, form);
                    if (!_v9.$) {
                        var _v10 = _v9.a;
                        var newForm = _v10.a;
                        var validFormFields = _v10.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$Loading
                        }), A4($author$project$Components$Admin$Documents$Form$saveItem, apiClient, model.aef, validFormFields, addAnother), _List_Nil);
                    } else {
                        var newForm = _v9.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                return _Utils_Tuple3(model, A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$Components$Admin$Documents$Form$Save(true)), $elm$core$Task$succeed($elm$core$Basics$identity)), _List_Nil);
            case 6:
                var response = msg.a;
                var _v11 = model.PU;
                if (!_v11.$) {
                    if (response.$ === 3) {
                        var document1 = response.a;
                        return _Utils_Tuple3(model, model.aK ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$Document$One$name(document1))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v13 = model.PU;
                if (!_v13.$) {
                    if (response.$ === 3) {
                        var document1 = response.a;
                        var _v15 = A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, $author$project$Components$Admin$Documents$Form$formFieldsInit(model.W1));
                        var formFields = _v15.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
                            j_: response
                        }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$Document$One$name(document1))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                var _v16 = model.PU;
                if (!_v16.$) {
                    if (response.$ === 3) {
                        var document1 = response.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Document$One$name(document1) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var subMsg = msg.a;
                var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jy);
                var newForm = function() {
                    var _v18 = planResourceResult.adu;
                    if (!_v18.$ && !_v18.a.$ && !_v18.a.a.$) {
                        var plan = _v18.a.a.a;
                        var field = A3($author$project$Components$Admin$Documents$Form$DocumentScopeAdd, 0, $author$project$Api$Plan$id(plan), $author$project$Api$Plan$name(plan));
                        return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field), model.PU);
                    } else return model.PU;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm,
                    jy: planResourceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, planResourceResult.EQ), planResourceResult.at);
            case 10:
                var subMsg = msg.a;
                var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.ro);
                var newForm = function() {
                    var _v19 = locationResourceResult.adu;
                    if (!_v19.$ && !_v19.a.$ && !_v19.a.a.$) {
                        var location1 = _v19.a.a.a;
                        var field = A3($author$project$Components$Admin$Documents$Form$DocumentScopeAdd, 1, location1.aef, location1.zr);
                        return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$Documents$Form$formFieldsUpdate, field), model.PU);
                    } else return model.PU;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm,
                    ro: locationResourceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg, locationResourceResult.EQ), locationResourceResult.at);
            case 11:
                var documentId = msg.a;
                var documentVersionId = msg.b;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$DocumentVersion$signedFileUrl, apiClient, documentId, documentVersionId, $author$project$Components$Admin$Documents$Form$GotSignedFileUrl), _List_Nil);
            case 12:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(url), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 13:
                var _v21 = model.aef;
                if (!_v21.$) {
                    var id_ = _v21.a;
                    return _Utils_Tuple3(model, A3($author$project$Api$Provider$Document$archive, apiClient, id_, $author$project$Components$Admin$Documents$Form$Archived), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var response = msg.a;
                var _v22 = model.PU;
                if (!_v22.$) {
                    if (response.$ === 3) {
                        var document1 = response.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Document$One$name(document1) + ' was successfully archived.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var _v24 = model.aef;
                if (!_v24.$) {
                    var id_ = _v24.a;
                    return _Utils_Tuple3(model, A3($author$project$Api$Provider$Document$unarchive, apiClient, id_, $author$project$Components$Admin$Documents$Form$Unarchived), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var response = msg.a;
                var _v25 = model.PU;
                if (!_v25.$) {
                    if (response.$ === 3) {
                        var document1 = response.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Documents__Top), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Document$One$name(document1) + ' was successfully unarchived.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                return _Utils_Tuple3(model, A2($author$project$Components$Admin$Documents$Form$skipDocumentsSetup, apiClient, model.W1), _List_Nil);
            case 18:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 19:
                var msg_ = msg.a;
                var _v28 = A2($elm$core$Maybe$withDefault, _Utils_Tuple2(model.g7, $elm$core$Platform$Cmd$none), A2($elm$core$Maybe$map, $elm$core$Tuple$mapFirst($elm$core$Maybe$Just), A2($elm$core$Maybe$map, A2($author$project$Components$TranslationsInput$update, apiClient, msg_), model.g7)));
                var translationInput = _v28.a;
                var translationsCmd = _v28.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    g7: translationInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Documents$Form$TranslationsInputMsg, translationsCmd), _List_Nil);
            case 20:
                var dropdownMsg = msg.a;
                var _v29 = model.lY;
                if (!_v29.$) {
                    var dropdown = _v29.a;
                    var _v30 = A2($author$project$Ui$Dropdown$update, dropdownMsg, dropdown);
                    var newDropdown = _v30.a;
                    var dropdownCmd = _v30.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lY: $elm$core$Maybe$Just(newDropdown)
                    }), dropdownCmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var lang = msg.a;
                var _v31 = model.PU;
                if (!_v31.$) {
                    var form = _v31.a;
                    var fields = $author$project$Utils$Form$fields(form);
                    var ckEditorCmd = function() {
                        if (fields.xn === 2) {
                            var content = A2($author$project$Components$Admin$Documents$Form$contentByLanguage, lang, form);
                            return A2($author$project$Ports$CKEditor$setData, $author$project$Components$Admin$Documents$Form$documentContentEditorId, A2($elm$core$Maybe$withDefault, '', content));
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        fC: lang
                    }), ckEditorCmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    fC: lang
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Documents$Id_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Admin$Documents$Form$Archive = {
        $: 13
    };
    var $author$project$Ui$Button$warning = $author$project$Ui$Button$Styled(4);
    var $author$project$Components$Admin$Documents$Form$viewArchiveButton = function(model) {
        var _v0 = model.ahy;
        if (_v0 === 'unpublished') return A3($author$project$Ui$Button$view, {
            abP: 'Archive document'
        }, _List_fromArray([
            $author$project$Ui$Button$warning,
            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$Archive)
        ]), _List_fromArray([
            $elm$html$Html$text('Archive')
        ]));
        else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$Documents$Form$AcceptanceText = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$Active = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$DocumentType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$FileUploaded = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$LanguageSelected = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$LinkUrl = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$Name = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$OpenFileDocument = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Documents$Form$Required = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$ShowOnSignup = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$DefaultContent = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$default = $author$project$Components$TranslationsInput$DefaultContent;
    var $author$project$Components$Admin$Documents$Form$documentTypes = _List_fromArray([
        'Contract',
        'Agreement',
        'Terms and Conditions'
    ]);
    var $author$project$Components$Admin$Documents$Form$documentTypeOptions = A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Select a Document Type'), A2($elm$core$List$map, function(documentType) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(documentType), documentType);
    }, $author$project$Components$Admin$Documents$Form$documentTypes));
    var $author$project$Ui$Element$FlexAuto = {
        $: 12
    };
    var $author$project$Ui$Element$flexAuto = $author$project$Ui$Element$FlexAuto;
    var $author$project$Ui$Well$Size = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Well$small = $author$project$Ui$Well$Size(1);
    var $author$project$Components$ResourceFilter$Location$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$TranslationsInput$ModalOpened = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TranslationsInput$String = 0;
    var $author$project$Components$TranslationsInput$defaultOptions = {
        wT: 0,
        xd: ''
    };
    var $author$project$Components$TranslationsInput$ContentChanged = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$RemovedTranslation = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$TranslationSubmitted = {
        $: 4
    };
    var $author$project$Components$TranslationsInput$LanguageSelected = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$viewLanguageSelect = function(_v0) {
        var languageDropdown = _v0.mS;
        var language = _v0.yC;
        var availableLanguages = _v0.vI;
        var languageToItem = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(lang, language)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$TranslationsInput$LanguageSelected(lang))
            ]), $elm$html$Html$text($author$project$Language$toLabel(lang)));
        };
        var items = A2($elm$core$List$map, languageToItem, availableLanguages);
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Language$toLabel(language))
        ]), items, languageDropdown);
    };
    var $author$project$Components$TranslationsInput$viewForm = F3(function(optionsRecord, form, model) {
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$onSubmit($author$project$Components$TranslationsInput$TranslationSubmitted)
        ]), _List_fromArray([
            $elm$core$List$length(model.vI) > 1 ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$label('Now Editing')
            ]), _List_fromArray([
                $author$project$Components$TranslationsInput$viewLanguageSelect(model)
            ])) : $elm$html$Html$text(''),
            A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = optionsRecord.wT;
                    if (!_v0) return $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.EU),
                        $author$project$Ui$Form$Input$onInput($author$project$Components$TranslationsInput$ContentChanged)
                    ]));
                    else return $author$project$Ui$Form$Textarea$view(_List_fromArray([
                        $author$project$Ui$Form$Textarea$value(fields.EU),
                        $author$project$Ui$Form$Textarea$onInput($author$project$Components$TranslationsInput$ContentChanged)
                    ]));
                }()
            ])),
            A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$TranslationsInput$ModalClosed)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        function() {
                            var _v1 = fields.aef;
                            if (!_v1.$) {
                                var translationId = _v1.a;
                                return A3($author$project$Ui$Button$view, {
                                    abP: 'Remove translation'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$danger,
                                    $author$project$Ui$Button$onClick($author$project$Components$TranslationsInput$RemovedTranslation(translationId))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Remove')
                                ]));
                            } else return $elm$html$Html$text('');
                        }(),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Save translation'
                        }, _List_fromArray([
                            $author$project$Ui$Button$submit,
                            $author$project$Ui$Button$primary
                        ]), _List_fromArray([
                            $elm$html$Html$text('Save')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$TranslationsInput$viewModal = F2(function(optionsRecord, model) {
        return model.Vw ? A3($author$project$Ui$Modal$view, $author$project$Components$TranslationsInput$ModalClosed, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Edit ' + ($author$project$Language$toLabel(model.yC) + ' Translation'))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    var _v0 = model.PU;
                    if (!_v0.$) {
                        var form_ = _v0.a;
                        return A3($author$project$Components$TranslationsInput$viewForm, optionsRecord, form_, model);
                    } else return $elm$html$Html$text('');
                }()
            ]))
        ])) : $elm$html$Html$text('');
    });
    var $author$project$Components$TranslationsInput$view = F3(function(field, options, model) {
        var optionsRecord = A3($elm$core$List$foldl, F2(function(option, acc) {
            if (!option.$) {
                var defaultContent = option.a;
                return _Utils_update(acc, {
                    xd: defaultContent
                });
            } else {
                var contentType = option.a;
                return _Utils_update(acc, {
                    wT: contentType
                });
            }
        }), $author$project$Components$TranslationsInput$defaultOptions, options);
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$inlineBlock
        ]), _List_fromArray([
            A2($author$project$Components$TranslationsInput$viewModal, optionsRecord, model),
            A3($author$project$Ui$Button$view, {
                abP: 'Edit translation'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick(A2($author$project$Components$TranslationsInput$ModalOpened, field, optionsRecord.xd)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$translate)
            ]), _List_fromArray([
                $elm$html$Html$text('Edit Translation')
            ]))
        ]));
    });
    var $author$project$Components$Admin$Documents$Form$AcceptanceType = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton = F4(function(currentAcceptanceType, acceptanceType, label, isDisabled) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentAcceptanceType, acceptanceType)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$FormUpdated($author$project$Components$Admin$Documents$Form$AcceptanceType(acceptanceType))),
            $author$project$Ui$Button$disabled(isDisabled)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Admin$Documents$Form$DocumentScopeRemove = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Documents$Form$viewDocumentScope = function(documentScope) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(documentScope.Zx),
            A3($author$project$Ui$Button$view, {
                abP: 'Remove ' + documentScope.Zx
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$FormUpdated(A2($author$project$Components$Admin$Documents$Form$DocumentScopeRemove, documentScope.Zy, documentScope.Zw))),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$Admin$Documents$Form$DocumentScopeType = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton = F4(function(currentDocumentScopeType, documentScopeType, label, isDisabled) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentDocumentScopeType, documentScopeType)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$FormUpdated($author$project$Components$Admin$Documents$Form$DocumentScopeType(documentScopeType))),
            $author$project$Ui$Button$disabled(isDisabled)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton = F4(function(currentDocumentVersionType, documentVersionType, label, isDisabled) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentDocumentVersionType, documentVersionType)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$FormUpdated($author$project$Components$Admin$Documents$Form$DocumentVersionType(documentVersionType))),
            $author$project$Ui$Button$disabled(isDisabled)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Admin$Documents$Form$PlanType = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$Documents$Form$viewPlanTypeButton = F4(function(currentPlanType, planType, label, isDisabled) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentPlanType, planType)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$FormUpdated($author$project$Components$Admin$Documents$Form$PlanType(planType))),
            $author$project$Ui$Button$disabled(isDisabled)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Admin$Documents$Form$viewForm = F2(function(model, form) {
        var isFormDisabled = model.RR;
        var fields = $author$project$Utils$Form$fields(form);
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$label('Document')
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(4)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value(fields.Og),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$DocumentType)),
                                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, form)),
                                $author$project$Ui$Form$Select$disabled(isFormDisabled)
                            ]), $author$project$Components$Admin$Documents$Form$documentTypeOptions)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(8)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(fields.zr),
                                $author$project$Ui$Form$Input$placeholder('Name of Document, e.g. \"Member Contract\"'),
                                $author$project$Ui$Form$Input$autofocus(true),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Name)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form)),
                                $author$project$Ui$Form$Input$disabled(isFormDisabled)
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Choose the type of document and how it will be shown throughout the application, e.g. \" Member contract \".')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$label('Upload Document')
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(9)
                        ]), _List_fromArray([
                            $author$project$Ui$Button$group(_List_fromArray([
                                A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.xn, 1, 'Upload a PDF document', isFormDisabled),
                                A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.xn, 2, 'Copy & paste text', isFormDisabled),
                                A4($author$project$Components$Admin$Documents$Form$viewDocumentVersionTypeButton, fields.xn, 0, 'Link to a document', isFormDisabled)
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(3)
                        ]), _List_fromArray([
                            function() {
                                var _v0 = _Utils_Tuple2(model.lY, fields.xn === 2);
                                if (!_v0.a.$ && _v0.b) {
                                    var dropdown = _v0.a.a;
                                    var languageToItem = function(lang) {
                                        return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                            $author$project$Ui$Dropdown$selected(_Utils_eq(lang, model.fC)),
                                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Admin$Documents$Form$LanguageSelected(lang))
                                        ]), $elm$html$Html$text($author$project$Language$toLabel(lang)));
                                    };
                                    var items = A2($elm$core$List$map, languageToItem, _List_fromArray([
                                        $author$project$Language$english,
                                        $author$project$Language$spanish
                                    ]));
                                    return A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$flexMd,
                                        $author$project$Ui$Element$flexAuto,
                                        $author$project$Ui$Element$itemsCenter
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$mr2
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                                $author$project$Ui$Typography$hintLabel
                                            ]), _List_fromArray([
                                                $author$project$Ui$Icon$translate(_List_Nil),
                                                $author$project$Utils$Html$noBreakSpace,
                                                $elm$html$Html$text('Now editing')
                                            ]))
                                        ])),
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$flexAuto
                                        ]), _List_fromArray([
                                            A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text($author$project$Language$toLabel(model.fC))
                                            ]), items, dropdown)
                                        ]))
                                    ]));
                                } else return $elm$html$Html$text('');
                            }()
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('')
                ]), _List_fromArray([
                    function() {
                        var _v1 = fields.xn;
                        switch(_v1){
                            case 1:
                                return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(6)
                                    ]), _List_fromArray([
                                        $author$project$Ui$Form$File$view(_List_fromArray([
                                            $author$project$Ui$Form$File$accept(2),
                                            $author$project$Ui$Form$File$onInput($author$project$Components$Admin$Documents$Form$FileUploaded),
                                            $author$project$Ui$Form$File$disabled(isFormDisabled)
                                        ])),
                                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 3, form))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(6)
                                    ]), _List_fromArray([
                                        function() {
                                            var _v2 = _Utils_Tuple3(model.aef, model.w2, fields.PH);
                                            if (!_v2.a.$ && !_v2.b.$ && _v2.c.$ === 1) {
                                                var id = _v2.a.a;
                                                var currentDocumentVersionId = _v2.b.a;
                                                var _v3 = _v2.c;
                                                return A3($author$project$Ui$Button$view, {
                                                    abP: 'View file'
                                                }, _List_fromArray([
                                                    $author$project$Ui$Button$link,
                                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                                    $author$project$Ui$Button$onClick(A2($author$project$Components$Admin$Documents$Form$OpenFileDocument, id, currentDocumentVersionId))
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text('View file')
                                                ]));
                                            } else return $author$project$Utils$Html$empty;
                                        }()
                                    ]))
                                ]));
                            case 2:
                                return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(12)
                                    ]), _List_fromArray([
                                        $author$project$Ui$Form$Textarea$view(_List_fromArray([
                                            $author$project$Ui$Form$Textarea$id($author$project$Components$Admin$Documents$Form$documentContentEditorId),
                                            $author$project$Ui$Form$Textarea$disabled(isFormDisabled)
                                        ])),
                                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 4, form))
                                    ]))
                                ]));
                            default:
                                return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(12)
                                    ]), _List_fromArray([
                                        $author$project$Ui$Form$Input$view(_List_fromArray([
                                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.Tg)),
                                            $author$project$Ui$Form$Input$placeholder('https://www.practice.com/patient-terms-and-conditions'),
                                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$LinkUrl)),
                                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                                            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, form)),
                                            $author$project$Ui$Form$Input$disabled(isFormDisabled)
                                        ]))
                                    ]))
                                ]));
                        }
                    }()
                ])),
                model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Published')
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(fields.Ir),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Active)),
                        $author$project$Ui$ToggleSwitch$disabled(isFormDisabled)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Only published documents can be viewed and accepted within this platform.')
                    ]))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Show on Online Signup')
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(fields._i),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$ShowOnSignup)),
                        $author$project$Ui$ToggleSwitch$disabled(!fields.Ir || fields.agM || isFormDisabled)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Enable this to allow acceptance of the document through Online Signup.')
                    ]))
                ])),
                model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Visible')
                ]), _List_fromArray([
                    $author$project$Ui$Button$group(_List_fromArray([
                        A4($author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton, fields.d1, $elm$core$Maybe$Nothing, 'Everyone', isFormDisabled),
                        A4($author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton, fields.d1, $elm$core$Maybe$Just(0), 'Specific Plans', isFormDisabled),
                        A4($author$project$Components$Admin$Documents$Form$viewDocumentScopeTypeButton, fields.d1, $elm$core$Maybe$Just(1), 'Specific Locations', isFormDisabled)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Show this document all the time, or only to people enrolling for specific plans / locations')
                    ]))
                ]))
            ]),
            function() {
                var _v4 = _Utils_Tuple2(fields.d1, model.aK);
                if (_v4.b) return _List_fromArray([
                    $author$project$Utils$Html$empty
                ]);
                else {
                    if (!_v4.a.$) {
                        if (!_v4.a.a) {
                            var _v5 = _v4.a.a;
                            return _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$labelSpan(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$label('Plans Type')
                                ]), _List_fromArray([
                                    $author$project$Ui$Button$group(_List_fromArray([
                                        A4($author$project$Components$Admin$Documents$Form$viewPlanTypeButton, fields.WN, 2, 'Retail', isFormDisabled),
                                        A4($author$project$Components$Admin$Documents$Form$viewPlanTypeButton, fields.WN, 0, 'Employers', isFormDisabled)
                                    ]))
                                ])),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$labelSpan(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$label('Restrict To Plans')
                                ]), A2($elm$core$List$cons, A2($elm$html$Html$map, $author$project$Components$Admin$Documents$Form$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                                    $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
                                    $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 5, form)),
                                    $author$project$Components$ResourceFilter$disabled(isFormDisabled)
                                ]), model.jy)), A2($elm$core$List$map, $author$project$Components$Admin$Documents$Form$viewDocumentScope, fields.Of)))
                            ]);
                        } else {
                            var _v6 = _v4.a.a;
                            return _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$labelSpan(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$label('Restrict To Locations')
                                ]), A2($elm$core$List$cons, A2($elm$html$Html$map, $author$project$Components$Admin$Documents$Form$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                                    $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
                                    $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 5, form)),
                                    $author$project$Components$ResourceFilter$disabled(isFormDisabled)
                                ]), model.ro)), A2($elm$core$List$map, $author$project$Components$Admin$Documents$Form$viewDocumentScope, fields.Of)))
                            ]);
                        }
                    } else return _List_Nil;
                }
            }(),
            _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Required for Online Signup')
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(fields.agM),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$Required)),
                        $author$project$Ui$ToggleSwitch$disabled(!fields.Ir || isFormDisabled)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Block online signup unless document is accepted.')
                    ]))
                ])),
                model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Acceptance type')
                ]), _List_fromArray([
                    $author$project$Ui$Button$group(_List_fromArray([
                        A4($author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton, fields.Ic, 0, 'Checking a checkbox', isFormDisabled),
                        A4($author$project$Components$Admin$Documents$Form$viewAcceptanceTypeButton, fields.Ic, 1, 'Typing patient name', isFormDisabled)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Choose how the document can be accepted through Online Signup')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Acceptance text')
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mr2,
                            $author$project$Ui$Element$flexAuto
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(fields.Ib),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Documents$Form$FormUpdated, $author$project$Components$Admin$Documents$Form$AcceptanceText)),
                                $author$project$Ui$Form$Input$disabled(isFormDisabled)
                            ]))
                        ])),
                        A2($elm$html$Html$map, $author$project$Components$Admin$Documents$Form$TranslationsInputMsg, A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($author$project$Components$TranslationsInput$view, 'acceptance_text', _List_fromArray([
                            $author$project$Components$TranslationsInput$default(fields.Ib)
                        ])), model.g7)))
                    ])),
                    model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('You can change the text we use on the signup page.'),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $elm$html$Html$text('Here\'s how it will look: ')
                    ])),
                    model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Well$view, _List_fromArray([
                        $author$project$Ui$Well$small
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                            $author$project$Ui$Form$Checkbox$disabled(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(fields.Ib),
                            $author$project$Utils$Html$noBreakSpace,
                            A3($author$project$Ui$Button$view, {
                                abP: fields.zr
                            }, _List_fromArray([
                                $author$project$Ui$Button$link
                            ]), _List_fromArray([
                                $elm$html$Html$text(fields.zr)
                            ]))
                        ]))
                    ]))
                ]))
            ])
        ]));
    });
    var $author$project$Components$Admin$Documents$Form$SaveAndAddAnother = {
        $: 5
    };
    var $author$project$Components$Admin$Documents$Form$SkipDocumentsSetup = {
        $: 17
    };
    var $author$project$Components$Admin$Documents$Form$viewOnboardingButtons = function(model) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$spaceBetween
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Skip documents setup'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$pull(0),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$SkipDocumentsSetup)
            ]), _List_fromArray([
                $elm$html$Html$text('Skip')
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight,
                $author$project$Ui$Element$itemsEnd
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Save and add another document'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$SaveAndAddAnother)
                ]), _List_fromArray([
                    $elm$html$Html$text('Save & Add Another')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save document'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$Save(false))
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$Documents$Form$viewSaveButton = function(model) {
        return model.RR ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
            abP: function() {
                var _v0 = model.aef;
                if (!_v0.$) return 'Update document';
                else return 'Create document';
            }()
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$Save(false))
        ]), _List_fromArray([
            function() {
                var _v1 = model.aef;
                if (!_v1.$) return $elm$html$Html$text('Update');
                else return $elm$html$Html$text('Create');
            }()
        ]));
    };
    var $author$project$Components$Admin$Documents$Form$Unarchive = {
        $: 15
    };
    var $author$project$Components$Admin$Documents$Form$viewUnarchiveButton = function(model) {
        return model.RR ? A3($author$project$Ui$Button$view, {
            abP: 'Unarchive document'
        }, _List_fromArray([
            $author$project$Ui$Button$warning,
            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$Documents$Form$Unarchive)
        ]), _List_fromArray([
            $elm$html$Html$text('Unarchive')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$Documents$Form$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, model.aK ? _List_fromArray([
                $author$project$Ui$Panel$onlyBorderLeft
            ]) : _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        function() {
                            var _v1 = model.aef;
                            if (!_v1.$) return $elm$html$Html$text('Edit');
                            else return $elm$html$Html$text('Add your patient agreement');
                        }()
                    ]), _List_fromArray([
                        model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$pull(1)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Documents__Top, _List_Nil, _List_fromArray([
                                $author$project$Ui$Icon$cross(_List_Nil)
                            ]))
                        ]))
                    ])),
                    function() {
                        var _v2 = model.aef;
                        if (!_v2.$) return $author$project$Utils$Html$empty;
                        else return A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add a document that can be e-signed by patient during Online Signup. Don\'t have an agreement yet? Click '),
                            A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/en/articles/4045458-sample-patient-agreement', _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text('here')
                            ])),
                            $elm$html$Html$text(' to download our sample patient agreement.')
                        ]));
                    }()
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, function() {
                    var _v3 = model.PU;
                    if (!_v3.$) {
                        var form = _v3.a;
                        return A2($author$project$Components$Admin$Documents$Form$viewForm, model, form);
                    } else return _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]))
                    ]);
                }()),
                model.aK ? A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    $author$project$Components$Admin$Documents$Form$viewOnboardingButtons(model)
                ])) : A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Documents__Top, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Back')
                    ])),
                    $author$project$Components$Admin$Documents$Form$viewSaveButton(model),
                    $author$project$Components$Admin$Documents$Form$viewArchiveButton(model),
                    $author$project$Components$Admin$Documents$Form$viewUnarchiveButton(model)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Documents$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$Documents$Form$view(model.PU))
            ]),
            $2: 'Admin | Documents'
        };
    };
    var $author$project$Pages$Admin$Documents$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Documents$Id_String$init,
        aeR: $author$project$Pages$Admin$Documents$Id_String$load,
        ag3: $author$project$Pages$Admin$Documents$Id_String$save,
        ahE: $author$project$Pages$Admin$Documents$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$Documents$Id_String$update,
        aid: $author$project$Pages$Admin$Documents$Id_String$view
    });
    var $author$project$Pages$Admin$Documents$New$DocumentFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$Documents$New$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var _v2 = A5($author$project$Components$Admin$Documents$Form$init, apiClient, session, $elm$core$Maybe$Nothing, practice, {
            aK: false
        });
        var form = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$Documents$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Documents$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Documents$New$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$Documents$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$Admin$Documents$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Admin$Documents$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$Documents$Form$view(model.PU))
            ]),
            $2: 'Admin | Documents'
        };
    };
    var $author$project$Pages$Admin$Documents$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Documents$New$init,
        aeR: $author$project$Pages$Admin$Documents$New$load,
        ag3: $author$project$Pages$Admin$Documents$New$save,
        ahE: $author$project$Pages$Admin$Documents$New$subscriptions,
        aaO: $author$project$Pages$Admin$Documents$New$update,
        aid: $author$project$Pages$Admin$Documents$New$view
    });
    var $author$project$Pages$Admin$Documents$Top$GotDocuments = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Document$All$Document = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Document$All$Record = F2(function(currentDocumentVersion, documentScopes) {
        return {
            acH: currentDocumentVersion,
            Of: documentScopes
        };
    });
    var $author$project$Api$Provider$Document$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'document_scopes', $elm$json$Json$Decode$list($author$project$Api$Provider$DocumentScope$Shared$sharedDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'current_document_version', $author$project$Api$Provider$DocumentVersion$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$All$Record)));
    var $author$project$Api$Provider$Document$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Document$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Document$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Document$All$Document)));
    var $author$project$Api$Provider$Document$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$Document$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Document$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Document$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Document$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Document$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentsPath)));
    });
    var $author$project$Pages$Admin$Documents$Top$fetchDocuments = function(model) {
        return A3($author$project$Api$Provider$Document$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Pages$Admin$Documents$Top$GotDocuments);
    };
    var $author$project$Pages$Admin$Documents$Top$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var query = _v3.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: apiClient,
            bY: $elm$core$Maybe$Nothing,
            ft: $elm$core$Set$empty,
            bu: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: $author$project$Api$Sort$initFromQuery(query)
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$Documents$Top$fetchDocuments(model));
    });
    var $author$project$Pages$Admin$Documents$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Documents$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Documents$Top$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Document$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$id(shared);
    };
    var $author$project$Pages$Admin$Documents$Top$subscriptions = function(model) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Documents$Top$HiConfirmClosed), $author$project$Api$Provider$Document$All$id), model.bY));
    };
    var $author$project$Pages$Admin$Documents$Top$DocumentDeleted = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Documents$Top$SearchInputMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Document$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Document$documentPath(id_)));
    });
    var $author$project$Pages$Admin$Documents$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Documents__Top)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Admin$Documents$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bu: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    bu: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            ft: A2($elm$core$Set$remove, id, model.ft),
                            bu: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$Documents$Top$fetchDocuments(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Document successfully deleted')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            ft: A2($elm$core$Set$remove, id, model.ft)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$Documents$Top$fetchDocuments(newModel),
                    $author$project$Pages$Admin$Documents$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$Documents$Top$fetchDocuments(newModel),
                    $author$project$Pages$Admin$Documents$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 4:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    bY: $elm$core$Maybe$Nothing,
                    ft: A2($elm$core$Set$insert, id, model.ft)
                }), A3($author$project$Api$Provider$Document$delete, model.Ej, id, $author$project$Pages$Admin$Documents$Top$DocumentDeleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    bY: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v3.a;
                var searchInputCmd = _v3.b;
                var searchInputEvent = _v3.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v4 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            bu: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$Documents$Top$fetchDocuments(qModel),
                            $author$project$Pages$Admin$Documents$Top$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Documents$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Documents$Top$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Document$Shared$documentAgreementsCount = function(_v0) {
        var record = _v0;
        return record.Oe;
    };
    var $author$project$Api$Provider$Document$All$documentAgreementsCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$documentAgreementsCount(shared);
    };
    var $author$project$Api$Provider$Document$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$name(shared);
    };
    var $author$project$Pages$Admin$Documents$Top$deleteMessage = function(document1) {
        return _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('You\'re about to delete document '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Document$All$name(document1))
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This will permanently delete '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Document$All$documentAgreementsCount(document1)))
                    ])),
                    $elm$html$Html$text(' signed agreement(s) from patients. If you\'d like to retain your existing patient documents, please unpublish this document instead.')
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Are you sure you want to delete this document?')
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Documents$Top$SortTable = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Documents$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'Document Name'),
        A3($author$project$Api$Column$init, 'visible', false, 'Visible'),
        A3($author$project$Api$Column$init, 'show_on_signup', true, 'Shown on Signup'),
        A3($author$project$Api$Column$init, 'required', true, 'Required'),
        A3($author$project$Api$Column$init, 'status', true, 'Status')
    ]);
    var $author$project$Pages$Admin$Documents$Top$documentScopeToString = function(scopeType) {
        if (scopeType === 1) return 'Locations: ';
        else return 'Plans: ';
    };
    var $author$project$Api$Provider$Document$All$documentScopes = function(_v0) {
        var all = _v0.b;
        return all.Of;
    };
    var $author$project$Pages$Admin$Documents$Top$listDocumentScopes = function(documentScopes) {
        return A2($elm$core$String$join, ', ', A2($elm$core$List$map, $author$project$Api$Provider$DocumentScope$Shared$scopeName, documentScopes));
    };
    var $author$project$Api$Provider$Document$All$required = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$required(shared);
    };
    var $author$project$Api$Provider$Document$All$showOnSignup = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$showOnSignup(shared);
    };
    var $author$project$Api$Provider$Document$All$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Document$Shared$status(shared);
    };
    var $author$project$Pages$Admin$Documents$Top$viewDocument = function(document1) {
        var id = $author$project$Api$Provider$Document$All$id(document1);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Document$All$name(document1))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, function() {
                    var _v0 = $elm$core$List$head($author$project$Api$Provider$Document$All$documentScopes(document1));
                    if (!_v0.$) {
                        var documentScope = _v0.a;
                        return _List_fromArray([
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Pages$Admin$Documents$Top$documentScopeToString($author$project$Api$Provider$DocumentScope$Shared$scopeType(documentScope)))
                            ])),
                            $elm$html$Html$text($author$project$Pages$Admin$Documents$Top$listDocumentScopes($author$project$Api$Provider$Document$All$documentScopes(document1)))
                        ]);
                    } else return _List_fromArray([
                        $elm$html$Html$text('Everyone')
                    ]);
                }())
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Provider$Document$All$showOnSignup(document1)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Provider$Document$All$required(document1)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Document$All$status(document1))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$minWidth('11rem'),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Documents__Id_String({
                    aef: id
                }), _List_fromArray([
                    $author$project$Ui$Link$sm,
                    $author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Documents$Top$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.bu;
            if (_v1.$ === 3) {
                var documents_ = _v1.a;
                return _Utils_Tuple2(false, documents_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var documents = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                $elm$html$Html$text('Manage who can see your documents - published documents are available to all users in the app, and each document can be configured to be viewable and/or required during online signup. To learn more, see our '),
                A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/online-signup/adding-multiple-patient-contracts-or-agreements', _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('support article.')
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb2
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$Documents$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                    ]))
                ]))
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No documents found.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$Documents$Top$SortTable)), $author$project$Pages$Admin$Documents$Top$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Pages$Admin$Documents$Top$viewDocument, documents), _List_Nil)
        ]);
    };
    var $author$project$Pages$Admin$Documents$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.bY;
                    if (!_v0.$) {
                        var document1 = _v0.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Documents$Top$HiConfirmClosed($author$project$Api$Provider$Document$All$id(document1)), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('document'),
                            $author$project$Components$HiConfirm$customMessage($author$project$Pages$Admin$Documents$Top$deleteMessage(document1))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            $elm$html$Html$text('Documents')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Documents__New, _List_fromArray([
                                $author$project$Ui$Link$buttonDefault,
                                $author$project$Ui$Link$pull(1),
                                $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('New Document')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Admin$Documents$Top$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        function() {
                            var _v1 = model.bu;
                            if (_v1.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Admin$Documents$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_));
                            else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Admin | Documents'
        };
    };
    var $author$project$Pages$Admin$Documents$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Documents$Top$init,
        aeR: $author$project$Pages$Admin$Documents$Top$load,
        ag3: $author$project$Pages$Admin$Documents$Top$save,
        ahE: $author$project$Pages$Admin$Documents$Top$subscriptions,
        aaO: $author$project$Pages$Admin$Documents$Top$update,
        aid: $author$project$Pages$Admin$Documents$Top$view
    });
    var $author$project$Pages$Admin$Elation$Link$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej
        }, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
    });
    var $author$project$Pages$Admin$Elation$Link$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Elation$Link$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Elation$Link$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Elation$Link$update = F2(function(msg, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Admin$Elation$Link$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Redirecting...'
        };
    };
    var $author$project$Pages$Admin$Elation$Link$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Elation$Link$init,
        aeR: $author$project$Pages$Admin$Elation$Link$load,
        ag3: $author$project$Pages$Admin$Elation$Link$save,
        ahE: $author$project$Pages$Admin$Elation$Link$subscriptions,
        aaO: $author$project$Pages$Admin$Elation$Link$update,
        aid: $author$project$Pages$Admin$Elation$Link$view
    });
    var $author$project$Pages$Admin$Elation$Overview$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej
        }, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
    });
    var $author$project$Pages$Admin$Elation$Overview$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Elation$Overview$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Elation$Overview$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Elation$Overview$update = F2(function(msg, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Admin$Elation$Overview$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Redirecting...'
        };
    };
    var $author$project$Pages$Admin$Elation$Overview$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Elation$Overview$init,
        aeR: $author$project$Pages$Admin$Elation$Overview$load,
        ag3: $author$project$Pages$Admin$Elation$Overview$save,
        ahE: $author$project$Pages$Admin$Elation$Overview$subscriptions,
        aaO: $author$project$Pages$Admin$Elation$Overview$update,
        aid: $author$project$Pages$Admin$Elation$Overview$view
    });
    var $author$project$Pages$Admin$Elation$Providers$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej
        }, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
    });
    var $author$project$Pages$Admin$Elation$Providers$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Elation$Providers$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Elation$Providers$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Elation$Providers$update = F2(function(msg, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Admin$Elation$Providers$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Redirecting...'
        };
    };
    var $author$project$Pages$Admin$Elation$Providers$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Elation$Providers$init,
        aeR: $author$project$Pages$Admin$Elation$Providers$load,
        ag3: $author$project$Pages$Admin$Elation$Providers$save,
        ahE: $author$project$Pages$Admin$Elation$Providers$subscriptions,
        aaO: $author$project$Pages$Admin$Elation$Providers$update,
        aid: $author$project$Pages$Admin$Elation$Providers$view
    });
    var $author$project$Pages$Admin$Elation$Top$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej
        }, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Slug_String({
            _A: 'elation'
        })));
    });
    var $author$project$Pages$Admin$Elation$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Elation$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Elation$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Elation$Top$update = F2(function(msg, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Admin$Elation$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Redirecting...'
        };
    };
    var $author$project$Pages$Admin$Elation$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Elation$Top$init,
        aeR: $author$project$Pages$Admin$Elation$Top$load,
        ag3: $author$project$Pages$Admin$Elation$Top$save,
        ahE: $author$project$Pages$Admin$Elation$Top$subscriptions,
        aaO: $author$project$Pages$Admin$Elation$Top$update,
        aid: $author$project$Pages$Admin$Elation$Top$view
    });
    var $author$project$Pages$Admin$ElationLegacy$GotElation = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Elation$One$Elation = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Elation$One$Record = F3(function(status, userName, isSyncing) {
        return {
            Sv: isSyncing,
            ahy: status,
            aib: userName
        };
    });
    var $author$project$Api$Provider$Elation$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_syncing', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'username', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Elation$One$Record))));
    var $author$project$Api$Provider$Elation$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Elation$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Elation$elationPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'elation'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Elation$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Elation$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath));
    });
    var $author$project$Pages$Admin$ElationLegacy$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            fz: false,
            fG: $author$project$Api$Data$Loading,
            PU: $elm$core$Maybe$Nothing,
            qW: shared.qW,
            oJ: $author$project$Api$Data$NotAsked
        }, A2($author$project$Api$Provider$Elation$retrieve, shared.Ej, $author$project$Pages$Admin$ElationLegacy$GotElation));
    });
    var $author$project$Pages$Admin$ElationLegacy$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$ElationLegacy$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$ElationLegacy$HiConfirmClosed = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$ElationLegacy$subscriptions = function(_v0) {
        var disabling = _v0.fz;
        return disabling ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$ElationLegacy$HiConfirmClosed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$ElationLegacy$Disabled = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$ElationLegacy$Synced = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$ElationLegacy$Created = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Elation$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('elation', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('username', $elm$json$Json$Encode$string(fields.aib)),
                _Utils_Tuple2('password', $elm$json$Json$Encode$string(fields.af2))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Elation$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath)));
    });
    var $author$project$Pages$Admin$ElationLegacy$createElation = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Elation$create, apiClient, fields, $author$project$Pages$Admin$ElationLegacy$Created);
    });
    var $author$project$Api$Provider$Elation$delete = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Provider$Elation$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Elation$elationPath));
    });
    var $author$project$Api$Provider$Elation$One$userName = function(_v0) {
        var record = _v0;
        return record.aib;
    };
    var $author$project$Pages$Admin$ElationLegacy$formFieldsInit = function(elation) {
        return {
            af2: '',
            aib: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Elation$One$userName(elation))
        };
    };
    var $author$project$Pages$Admin$ElationLegacy$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                aib: string
            });
        } else {
            var string = field.a;
            return _Utils_update(fields, {
                af2: string
            });
        }
    });
    var $author$project$Pages$Admin$ElationLegacy$PasswordValidation = 1;
    var $author$project$Pages$Admin$ElationLegacy$UserNameValidation = 0;
    var $author$project$Pages$Admin$ElationLegacy$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.aib;
        }, _Utils_Tuple2(0, 'Please enter an api key')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.af2;
        }, _Utils_Tuple2(1, 'Please enter a password'))
    ]));
    var $author$project$Pages$Admin$ElationLegacy$Poll = {
        $: 1
    };
    var $author$project$Api$Provider$Elation$One$isSyncing = function(_v0) {
        var record = _v0;
        return record.Sv;
    };
    var $author$project$Pages$Admin$ElationLegacy$poll = function(elation) {
        return $author$project$Api$Provider$Elation$One$isSyncing(elation) ? A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Pages$Admin$ElationLegacy$Poll;
        }, $elm$core$Process$sleep(2000)) : $elm$core$Platform$Cmd$none;
    };
    var $author$project$Api$Provider$Elation$One$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Elation$sync = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Elation$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'sync'
        ]), $author$project$Api$Provider$Elation$elationPath)));
    });
    var $author$project$Pages$Admin$ElationLegacy$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var elation = response.a;
                    var form = $author$project$Api$Provider$Elation$One$status(elation) === 'disabled' ? $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$Form$init($author$project$Pages$Admin$ElationLegacy$formFieldsInit(elation)), $author$project$Api$Data$NotAsked)) : $elm$core$Maybe$Nothing;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fG: response,
                        PU: form
                    }), $author$project$Pages$Admin$ElationLegacy$poll(elation), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    fG: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(model, A2($author$project$Api$Provider$Elation$retrieve, model.Ej, $author$project$Pages$Admin$ElationLegacy$GotElation), _List_Nil);
            case 2:
                var field = msg.a;
                var _v2 = model.PU;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var form = _v3.a;
                    var saveRequest = _v3.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$ElationLegacy$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, saveRequest))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v4 = model.PU;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var form = _v5.a;
                    var saveRequest = _v5.b;
                    var _v6 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$ElationLegacy$formFieldsValidator, form);
                    if (!_v6.$) {
                        var _v7 = _v6.a;
                        var newForm = _v7.a;
                        var validFormFields = _v7.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
                        }), A2($author$project$Pages$Admin$ElationLegacy$createElation, model.Ej, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v6.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, saveRequest))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    fG: response,
                    PU: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your elation credentials have been saved.')
                ]));
                else {
                    var _v9 = model.PU;
                    if (!_v9.$) {
                        var _v10 = _v9.a;
                        var form = _v10.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_Tuple2(form, response))
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    oJ: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Elation$sync, model.Ej, $author$project$Pages$Admin$ElationLegacy$Synced), _List_Nil);
            case 6:
                var response = msg.a;
                if (response.$ === 3) {
                    var elation = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        oJ: $author$project$Api$Data$NotAsked
                    }), $author$project$Pages$Admin$ElationLegacy$poll(elation), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    oJ: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    fz: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(model, A2($author$project$Api$Provider$Elation$delete, model.Ej, $author$project$Pages$Admin$ElationLegacy$Disabled), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    fz: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var elation = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fz: false,
                        fG: response,
                        PU: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$Form$init($author$project$Pages$Admin$ElationLegacy$formFieldsInit(elation)), $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been disabled.')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    fz: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Ui$Image$ElationEMRLogo = 1;
    var $author$project$Pages$Admin$ElationLegacy$Save = {
        $: 3
    };
    var $author$project$Pages$Admin$ElationLegacy$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$ElationLegacy$Password = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$ElationLegacy$UserName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$PasswordInput$Errors = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$PasswordInput$errors = $author$project$Ui$Form$PasswordInput$Errors;
    var $author$project$Ui$Form$PasswordInput$Invalid = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$PasswordInput$invalid = $author$project$Ui$Form$PasswordInput$Invalid;
    var $author$project$Ui$Form$PasswordInput$OnInput = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$PasswordInput$onInput = $author$project$Ui$Form$PasswordInput$OnInput;
    var $author$project$Ui$Form$PasswordInput$Value = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$PasswordInput$value = $author$project$Ui$Form$PasswordInput$Value;
    var $author$project$Ui$Form$PasswordInput$defaultOptions = {
        fK: _List_Nil,
        aq: _List_Nil,
        q2: false,
        r7: 'Password',
        CL: $elm$core$Maybe$Nothing,
        aa9: $elm$core$Maybe$Nothing,
        D2: false
    };
    var $author$project$Ui$Form$PasswordInput$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var handler = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$onInput(handler), record.aq)
                    });
                case 1:
                    var string = option.a;
                    return _Utils_update(record, {
                        aq: A2($elm$core$List$cons, $author$project$Ui$Form$Input$value(string), record.aq),
                        aa9: $elm$core$Maybe$Just(string)
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        q2: bool
                    });
                case 3:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
                case 4:
                    var maybeStrength = option.a;
                    return _Utils_update(record, {
                        CL: maybeStrength
                    });
                case 5:
                    var string = option.a;
                    return _Utils_update(record, {
                        r7: string
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        D2: bool
                    });
            }
        }), $author$project$Ui$Form$PasswordInput$defaultOptions, options);
    };
    var $author$project$Ui$Form$Input$Password = {
        $: 5
    };
    var $author$project$Ui$Form$Input$password = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Password);
    var $author$project$Utils$PasswordStrength$suggestions = function(_v0) {
        var record = _v0;
        return record.ahF;
    };
    var $author$project$Ui$ProgressBar$Danger = {
        $: 4
    };
    var $author$project$Ui$ProgressBar$danger = $author$project$Ui$ProgressBar$Danger;
    var $author$project$Utils$PasswordStrength$strength = function(_v0) {
        var record = _v0;
        return record.ahB;
    };
    var $author$project$Ui$ProgressBar$Success = {
        $: 2
    };
    var $author$project$Ui$ProgressBar$success = $author$project$Ui$ProgressBar$Success;
    var $author$project$Ui$ProgressBar$Bar = $elm$core$Basics$identity;
    var $author$project$Ui$ProgressBar$bar = function(options) {
        return options;
    };
    var $author$project$Ui$ProgressBar$defaultOptions = {
        EP: _List_Nil,
        CA: false,
        aih: 0
    };
    var $author$project$Ui$ProgressBar$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'progress-bar-striped', record.EP)
                    });
                case 1:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'active', record.EP)
                    });
                case 2:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'progress-bar-success', record.EP)
                    });
                case 3:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'progress-bar-info', record.EP)
                    });
                case 4:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'progress-bar-danger', record.EP)
                    });
                case 5:
                    return _Utils_update(record, {
                        EP: A2($elm$core$List$cons, 'progress-bar-warning', record.EP)
                    });
                case 6:
                    return _Utils_update(record, {
                        CA: true
                    });
                default:
                    var _float = option.a;
                    return _Utils_update(record, {
                        aih: _float
                    });
            }
        }), $author$project$Ui$ProgressBar$defaultOptions, options);
    };
    var $author$project$Ui$ProgressBar$viewBar = function(_v0) {
        var options = _v0;
        var optionsRecord = $author$project$Ui$ProgressBar$optionsToRecord(options);
        var width_ = optionsRecord.aih;
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('progress-bar'),
            $elm$html$Html$Attributes$class(A2($elm$core$String$join, ' ', optionsRecord.EP)),
            A2($elm$html$Html$Attributes$style, 'width', $elm$core$String$fromFloat(width_) + '%'),
            A2($elm$html$Html$Attributes$attribute, 'aria-valuenow', $elm$core$String$fromFloat(width_)),
            A2($elm$html$Html$Attributes$attribute, 'aria-valuemin', '0'),
            A2($elm$html$Html$Attributes$attribute, 'aria-valuemax', '100')
        ]), optionsRecord.CA ? _List_fromArray([
            $elm$html$Html$text(A2($myrho$elm_round$Round$round, 2, width_) + '%')
        ]) : _List_Nil);
    };
    var $author$project$Ui$ProgressBar$stacked = function(bars) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('progress')
        ]), A2($elm$core$List$map, $author$project$Ui$ProgressBar$viewBar, bars));
    };
    var $author$project$Ui$ProgressBar$view = function(options) {
        return $author$project$Ui$ProgressBar$stacked(_List_fromArray([
            $author$project$Ui$ProgressBar$bar(options)
        ]));
    };
    var $author$project$Ui$ProgressBar$Warning = {
        $: 5
    };
    var $author$project$Ui$ProgressBar$warning = $author$project$Ui$ProgressBar$Warning;
    var $author$project$Ui$ProgressBar$Width = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$ProgressBar$width = $author$project$Ui$ProgressBar$Width;
    var $author$project$Ui$Form$PasswordInput$viewProgressBar = function(passwordStrength) {
        var _v0 = function() {
            var _v1 = $author$project$Utils$PasswordStrength$strength(passwordStrength);
            switch(_v1){
                case 1:
                    return _Utils_Tuple2(1, $author$project$Ui$ProgressBar$danger);
                case 2:
                    return _Utils_Tuple2(2, $author$project$Ui$ProgressBar$danger);
                case 3:
                    return _Utils_Tuple2(3, $author$project$Ui$ProgressBar$warning);
                case 4:
                    return _Utils_Tuple2(4, $author$project$Ui$ProgressBar$success);
                default:
                    return _Utils_Tuple2(0, $author$project$Ui$ProgressBar$danger);
            }
        }();
        var width = _v0.a;
        var style = _v0.b;
        return $author$project$Ui$ProgressBar$view(_List_fromArray([
            $author$project$Ui$ProgressBar$width(25 * width + 5),
            style
        ]));
    };
    var $author$project$Ui$Form$PasswordInput$view = function(options) {
        var optionsRecord = $author$project$Ui$Form$PasswordInput$optionsToRecord(options);
        return A2($elm$html$Html$div, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Ui$Form$Input$view(A2($elm$core$List$cons, $author$project$Ui$Form$Input$phi(true), A2($elm$core$List$cons, $author$project$Ui$Form$Input$withFeedback(optionsRecord.D2), A2($elm$core$List$cons, $author$project$Ui$Form$Input$password, A2($elm$core$List$cons, $author$project$Ui$Form$Input$invalid(optionsRecord.q2), A2($elm$core$List$cons, $author$project$Ui$Form$Input$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$Input$placeholder(optionsRecord.r7), optionsRecord.aq)))))))
            ]),
            function() {
                var _v0 = optionsRecord.CL;
                if (_v0.$ === 1) return _List_Nil;
                else {
                    var passwordStrength = _v0.a;
                    return _List_fromArray([
                        $author$project$Ui$Form$PasswordInput$viewProgressBar(passwordStrength),
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/user-account-setup/password-creation-and-reset', _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                    $author$project$Ui$Tooltip$placement(0)
                                ]), 'Click to Learn More', _List_fromArray([
                                    $author$project$Ui$Icon$help(_List_Nil)
                                ]))
                            ])),
                            $elm$core$List$isEmpty($author$project$Utils$PasswordStrength$suggestions(passwordStrength)) ? $author$project$Utils$Html$empty : A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Tip: ' + A2($elm$core$String$join, ' ', $author$project$Utils$PasswordStrength$suggestions(passwordStrength)))
                            ]))
                        ]))
                    ]);
                }
            }()
        ])));
    };
    var $author$project$Pages$Admin$ElationLegacy$viewDisabledBody = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Elation API Key'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.aib),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ElationLegacy$FormUpdated, $author$project$Pages$Admin$ElationLegacy$UserName)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Password'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$PasswordInput$view(_List_fromArray([
                    $author$project$Ui$Form$PasswordInput$value(fields.af2),
                    $author$project$Ui$Form$PasswordInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ElationLegacy$FormUpdated, $author$project$Pages$Admin$ElationLegacy$Password)),
                    $author$project$Ui$Form$PasswordInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$PasswordInput$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
                        A3($author$project$Ui$Link$externalHref, 'https://www.elationemr.com', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('Elation')
                        ])),
                        $elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, and act upon relevant clinical information to care for your patients.')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Our integration with Elation will automatically create and synchronize patient demographic, membership, and insurance information created here with Elation.'),
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('To configure this integration, contact the Elation team and ask for your Elation API Key & Password.')
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('We provide this integration only as a convenience to you. Elation is solely responsible for its service, content and policies, including those related to privacy and security. Please review Elation\'s Terms of Service, and Privacy Policy to ensure they meet your business and legal requirements.')
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$ElationLegacy$viewDisabledFooter = function(saveRequest) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Edit and enable'
            }, _List_fromArray([
                $author$project$Ui$Button$submit,
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
            ]), _List_fromArray([
                $elm$html$Html$text('Save & Enable')
            ]))
        ]));
    };
    var $author$project$Pages$Admin$ElationLegacy$Disable = {
        $: 7
    };
    var $author$project$Pages$Admin$ElationLegacy$Sync = {
        $: 5
    };
    var $author$project$Pages$Admin$ElationLegacy$viewEnabledBody = F2(function(model, elation) {
        var status = $author$project$Api$Provider$Elation$One$status(elation) === 'enabled' ? 'connected' : $author$project$Api$Provider$Elation$One$status(elation);
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, status)
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('To stop syncing or change your credentials please '),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Disable integration'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$ElationLegacy$Disable),
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none)
                    ]), _List_fromArray([
                        $elm$html$Html$text('disable this integration.')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Elation API Key'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Elation$One$userName(elation)))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Password'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('************')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Failures'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_fromArray([
                        $author$project$Ui$Link$routeParams(_List_fromArray([
                            A2($elm$url$Url$Builder$string, 'filter', 'with_failed_sync')
                        ]))
                    ]), _List_fromArray([
                        $elm$html$Html$text('See failed records here.')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Push to Elation'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Push out of sync records'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.oJ, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$ElationLegacy$Sync)
                ]), _List_fromArray([
                    $elm$html$Html$text('Push out of sync records')
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Admin$ElationLegacy$view = function(model) {
        return {
            fb: _List_fromArray([
                model.fz ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$ElationLegacy$HiConfirmClosed, _List_fromArray([
                    $author$project$Components$HiConfirm$verb('disable'),
                    $author$project$Components$HiConfirm$noun('elation integration')
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Admin$ElationLegacy$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            A4($author$project$Ui$Image$view, model.qW, {
                                Jg: 'ElationEMR Logo'
                            }, _List_fromArray([
                                $author$project$Ui$Image$width(200)
                            ]), 1)
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, function() {
                            var _v0 = model.fG;
                            if (_v0.$ === 3) {
                                var elation = _v0.a;
                                var _v1 = model.PU;
                                if (!_v1.$) {
                                    var _v2 = _v1.a;
                                    var form = _v2.a;
                                    return $author$project$Pages$Admin$ElationLegacy$viewDisabledBody(form);
                                } else return A2($author$project$Pages$Admin$ElationLegacy$viewEnabledBody, model, elation);
                            } else return _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                                ]), _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_Nil)
                                ]))
                            ]);
                        }()),
                        function() {
                            var _v3 = model.fG;
                            if (_v3.$ === 3) {
                                var _v4 = model.PU;
                                if (!_v4.$) {
                                    var _v5 = _v4.a;
                                    var saveRequest = _v5.b;
                                    return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                                        $author$project$Pages$Admin$ElationLegacy$viewDisabledFooter(saveRequest)
                                    ]));
                                } else return $author$project$Ui$Panel$none;
                            } else return $author$project$Ui$Panel$none;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Integrations | Elation Health'
        };
    };
    var $author$project$Pages$Admin$ElationLegacy$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$ElationLegacy$init,
        aeR: $author$project$Pages$Admin$ElationLegacy$load,
        ag3: $author$project$Pages$Admin$ElationLegacy$save,
        ahE: $author$project$Pages$Admin$ElationLegacy$subscriptions,
        aaO: $author$project$Pages$Admin$ElationLegacy$update,
        aid: $author$project$Pages$Admin$ElationLegacy$view
    });
    var $author$project$Pages$Admin$Features$BetaFeaturesMsg = $elm$core$Basics$identity;
    var $author$project$Components$Hinter$BetaFeatures$Practice = 0;
    var $author$project$Components$Hinter$BetaFeatures$GotFeatures = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Hinter$BetaFeatures$Model = $elm$core$Basics$identity;
    var $author$project$Components$Hinter$BetaFeatures$basePath = function(owner) {
        return $author$project$Api$Data$providerPath;
    };
    var $author$project$Api$Common$Feature$Shared$Feature = $elm$core$Basics$identity;
    var $author$project$Api$Common$Feature$Shared$Record = F3(function(id, name, enabled) {
        return {
            OM: enabled,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Common$Feature$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Feature$Shared$Record))));
    var $author$project$Api$Common$Feature$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Feature$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Feature$featuresPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'features'
        ]), basePath);
    };
    var $author$project$Api$Common$Feature$list = F3(function(basePath, apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Common$Feature$Shared$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Common$Feature$featuresPath(basePath)));
    });
    var $author$project$Components$Hinter$BetaFeatures$init = F2(function(apiClient, owner) {
        return _Utils_Tuple2({
            Px: $author$project$Api$Data$Loading,
            VM: owner
        }, A3($author$project$Api$Common$Feature$list, $author$project$Components$Hinter$BetaFeatures$basePath(owner), apiClient, $author$project$Components$Hinter$BetaFeatures$GotFeatures));
    });
    var $author$project$Pages$Admin$Features$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var _v4 = A2($author$project$Components$Hinter$BetaFeatures$init, apiClient, 0);
        var betaFeatures = _v4.a;
        var betaFeaturesCmd = _v4.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            le: betaFeatures
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, betaFeaturesCmd));
    });
    var $author$project$Pages$Admin$Features$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Features$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Hinter$BetaFeatures$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Features$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Hinter$BetaFeatures$subscriptions(model.le));
    };
    var $author$project$Components$Hinter$BetaFeatures$GotEnableResponse = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Common$Feature$enable = F5(function(basePath, apiClient, featureId, enabledStatus, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('feature', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(featureId)),
                _Utils_Tuple2('enabled', $elm$json$Json$Encode$bool(enabledStatus))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Common$Feature$Shared$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            featureId
        ]), $author$project$Api$Common$Feature$featuresPath(basePath)))));
    });
    var $author$project$Api$Common$Feature$Shared$enabled = function(_v0) {
        var record = _v0;
        return record.OM;
    };
    var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
    var $author$project$Api$Common$Feature$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Hinter$BetaFeatures$replaceUpdated = F2(function(newFeature, feature) {
        return _Utils_eq($author$project$Api$Common$Feature$Shared$id(feature), $author$project$Api$Common$Feature$Shared$id(newFeature)) ? newFeature : feature;
    });
    var $author$project$Components$Hinter$BetaFeatures$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var id = msg.a;
                var enabled = msg.b;
                return _Utils_Tuple3(model, A5($author$project$Api$Common$Feature$enable, $author$project$Components$Hinter$BetaFeatures$basePath(model.VM), apiClient, id, enabled, $author$project$Components$Hinter$BetaFeatures$GotEnableResponse), _List_Nil);
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var feature = response.a;
                    var newFeatures = A2($author$project$Api$Data$map, $elm$core$List$map($author$project$Components$Hinter$BetaFeatures$replaceUpdated(feature)), model.Px);
                    var newModel = _Utils_update(model, {
                        Px: newFeatures
                    });
                    var message = $author$project$Api$Common$Feature$Shared$enabled(feature) ? 'Feature enabled!' : 'Feature disabled!';
                    return _Utils_Tuple3(newModel, $elm$browser$Browser$Navigation$reload, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, message),
                        function() {
                            var _v3 = model.VM;
                            return $author$project$OutMsg$RefreshPractice;
                        }()
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Px: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$Features$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Hinter$BetaFeatures$update, model.Ej, subMsg, model.le);
        var betaFeatures = _v1.a;
        var cmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            le: betaFeatures
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), outMsgs);
    });
    var $author$project$Components$Hinter$BetaFeatures$ChangeFeature = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Feature$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$Hinter$BetaFeatures$viewFeature = function(feature) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Common$Feature$Shared$name(feature))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on($author$project$Api$Common$Feature$Shared$enabled(feature)),
                        $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Hinter$BetaFeatures$ChangeFeature($author$project$Api$Common$Feature$Shared$id(feature)))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Hinter$BetaFeatures$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Beta Features')
                ]))
            ])),
            A4($author$project$Ui$Panel$table, _List_fromArray([
                $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.Px))
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Name')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Enabled')
                ]))
            ]), function() {
                var _v1 = model.Px;
                if (_v1.$ === 3) {
                    var features = _v1.a;
                    return A2($elm$core$List$map, $author$project$Components$Hinter$BetaFeatures$viewFeature, features);
                } else return _List_Nil;
            }(), _List_Nil)
        ]));
    };
    var $author$project$Pages$Admin$Features$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Hinter$BetaFeatures$view(model.le))
            ]),
            $2: 'Admin | Beta Features'
        };
    };
    var $author$project$Pages$Admin$Features$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Features$init,
        aeR: $author$project$Pages$Admin$Features$load,
        ag3: $author$project$Pages$Admin$Features$save,
        ahE: $author$project$Pages$Admin$Features$subscriptions,
        aaO: $author$project$Pages$Admin$Features$update,
        aid: $author$project$Pages$Admin$Features$view
    });
    var $author$project$Pages$Admin$HipaaAuthorizations$None = {
        $: 0
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$GotPatients = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$WithoutHipaaAuthorization = {
        $: 5
    };
    var $author$project$Api$Provider$Patient$All$Patient = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$Shared$Patient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$Shared$Record = function(id) {
        return function(age) {
            return function(archived) {
                return function(autopay) {
                    return function(chosenFirstName) {
                        return function(chosenLastName) {
                            return function(chosenMiddleName) {
                                return function(chosenTitle) {
                                    return function(chosenSuffix) {
                                        return function(dob) {
                                            return function(email) {
                                                return function(firstName) {
                                                    return function(gender) {
                                                        return function(genderIdentity) {
                                                            return function(genderOther) {
                                                                return function(hipaaAuthorizationAccepted) {
                                                                    return function(hipaaAuthorizationAcceptedAt) {
                                                                        return function(joinedPracticeDate) {
                                                                            return function(lastName) {
                                                                                return function(leadSourceOther) {
                                                                                    return function(membershipStatus) {
                                                                                        return function(middleName) {
                                                                                            return function(name) {
                                                                                                return function(phones) {
                                                                                                    return function(pronoun) {
                                                                                                        return function(sex) {
                                                                                                            return function(syncToEmr) {
                                                                                                                return function(usesTobacco) {
                                                                                                                    return function(engagementStatus) {
                                                                                                                        return {
                                                                                                                            IZ: age,
                                                                                                                            JC: archived,
                                                                                                                            JY: autopay,
                                                                                                                            Lc: chosenFirstName,
                                                                                                                            Ld: chosenLastName,
                                                                                                                            Le: chosenMiddleName,
                                                                                                                            Lf: chosenSuffix,
                                                                                                                            Lg: chosenTitle,
                                                                                                                            add: dob,
                                                                                                                            OH: email,
                                                                                                                            OU: engagementStatus,
                                                                                                                            PN: firstName,
                                                                                                                            P5: gender,
                                                                                                                            P6: genderIdentity,
                                                                                                                            P7: genderOther,
                                                                                                                            QR: hipaaAuthorizationAccepted,
                                                                                                                            QS: hipaaAuthorizationAcceptedAt,
                                                                                                                            aef: id,
                                                                                                                            SK: joinedPracticeDate,
                                                                                                                            SU: lastName,
                                                                                                                            S3: leadSourceOther,
                                                                                                                            T5: membershipStatus,
                                                                                                                            Uh: middleName,
                                                                                                                            zr: name,
                                                                                                                            WG: phones,
                                                                                                                            XF: pronoun,
                                                                                                                            Z3: sex,
                                                                                                                            $H: syncToEmr,
                                                                                                                            aa4: usesTobacco
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Patient$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'engagement_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_tobacco', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sync_to_emr', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sex', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pronoun', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($author$project$Api$Expandable$expandable, 'phones', $elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'middle_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lead_source_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'joined_practice_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hipaa_authorization_accepted_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hipaa_authorization_accepted', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender_identity', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'dob', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_suffix', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_title', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_middle_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_last_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_first_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'autopay', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'archived', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Shared$Record))))))))))))))))))))))))))))));
    var $author$project$Api$Provider$Patient$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$All$Record = function(sponsorName) {
        return function(flaggedNotesCount) {
            return function(isMaster) {
                return function(isSynced) {
                    return function(isAffiliated) {
                        return function(affiliateSyncStatus) {
                            return function(networkSyncStatus) {
                                return function(practitioner) {
                                    return function(location1) {
                                        return function(membershipPatients) {
                                            return function(membershipThrough) {
                                                return {
                                                    IX: affiliateSyncStatus,
                                                    PR: flaggedNotesCount,
                                                    RQ: isAffiliated,
                                                    R8: isMaster,
                                                    Su: isSynced,
                                                    aeT: location1,
                                                    T$: membershipPatients,
                                                    T6: membershipThrough,
                                                    UP: networkSyncStatus,
                                                    agi: practitioner,
                                                    _W: sponsorName
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientAll$MembershipPatient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipPatient$ForPatientAll$Record = F4(function(status, startDate, membership, plan) {
        return {
            jc: membership,
            GW: plan,
            _0: startDate,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Membership$Min$Membership = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Membership$Min$Record = F3(function(id, status, isPrimary) {
        return {
            aef: id,
            aeF: isPrimary,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Membership$Min$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'is_primary', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Min$Record))));
    var $author$project$Api$Provider$Membership$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Membership$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$MembershipPatient$ForPatientAll$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Plan$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership', $author$project$Api$Provider$Membership$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientAll$Record)))));
    var $author$project$Api$Provider$MembershipPatient$ForPatientAll$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipPatient$ForPatientAll$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$Min$Patient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$Min$Record = F5(function(id, name, email, dob, age) {
        return {
            IZ: age,
            add: dob,
            OH: email,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Patient$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'dob', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Min$Record))))));
    var $author$project$Api$Provider$Patient$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$SyncStatus$Failed = 3;
    var $author$project$Api$Provider$Patient$SyncStatus$Inactive = 0;
    var $author$project$Api$Provider$Patient$SyncStatus$Pending = 1;
    var $author$project$Api$Provider$Patient$SyncStatus$Synced = 2;
    var $author$project$Api$Provider$Patient$SyncStatus$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'inactive':
                return $elm$json$Json$Decode$succeed(0);
            case 'pending':
                return $elm$json$Json$Decode$succeed(1);
            case 'synced':
                return $elm$json$Json$Decode$succeed(2);
            case 'failed':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail('Unexpected sync status ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Practitioner$Min$Practitioner = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practitioner$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Practitioner$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Min$Record)));
    var $author$project$Api$Provider$Practitioner$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practitioner$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_through', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_patients', $elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForPatientAll$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'network_sync_status', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate_sync_status', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_affiliated', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_synced', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_master', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'flagged_notes_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsor_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$All$Record))))))))))));
    var $author$project$Api$Provider$Patient$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$All$Patient)));
    var $author$project$Api$Provider$Patient$filterToString = function(filter) {
        switch(filter.$){
            case 0:
                switch(filter.a){
                    case 0:
                        var _v1 = filter.a;
                        return 'current_membership';
                    case 2:
                        var _v2 = filter.a;
                        return 'future_membership';
                    case 3:
                        var _v3 = filter.a;
                        return 'with_unconfirmed_membership';
                    case 1:
                        var _v4 = filter.a;
                        return 'inactive';
                    default:
                        var _v5 = filter.a;
                        return 'archived';
                }
            case 1:
                if (filter.a) return 'with_autopay';
                else return 'without_autopay';
            case 2:
                return 'active_membership';
            case 3:
                return 'past_due_customer_invoices';
            case 4:
                return 'account_owner_without_payment_info';
            case 5:
                return 'without_hipaa_authorization';
            case 6:
                return 'without_email';
            case 7:
                return 'with_flagged_notes';
            case 8:
                return 'with_failed_integrations';
            case 9:
                return 'with_unsynced_integrations';
            case 10:
                return 'new_activations_since_date';
            case 11:
                return 'new_terminations_since_date';
            case 12:
                return 'with_upcoming_birthday';
            case 13:
                switch(filter.a){
                    case 0:
                        var _v6 = filter.a;
                        return 'currently_engaged';
                    case 1:
                        var _v7 = filter.a;
                        return 'previously_engaged';
                    default:
                        var _v8 = filter.a;
                        return 'never_engaged';
                }
            case 14:
                return 'with_bounced_emails';
            default:
                return 'with_unsubscribed_emails';
        }
    };
    var $author$project$Api$Provider$Patient$listDefaults = {
        IY: $elm$core$Maybe$Nothing,
        acy: $elm$core$Maybe$Nothing,
        Fw: _List_Nil,
        aef: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        GW: $elm$core$Maybe$Nothing,
        agi: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$Patient$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Patient$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Fw;
                if (!_v0.b) return _List_Nil;
                else {
                    var filters = _v0;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', A2($elm$core$String$join, ',', A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters)))
                    ]);
                }
            }(),
            function() {
                var _v1 = options.agq;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.aef;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.acy;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'company', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.GW;
                if (!_v4.$) {
                    var string = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'plan', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.rm;
                if (!_v5.$) {
                    var string = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.aeT;
                if (!_v6.$) {
                    var string = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v7 = options.agi;
                if (!_v7.$) {
                    var string = _v7.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v8 = options.IY;
                if (!_v8.$) {
                    var string = _v8.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'affiliation', string)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Provider$Patient$patientsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'patients'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Patient$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Patient$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Patient$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath)));
    });
    var $author$project$Pages$Admin$HipaaAuthorizations$fetchPatients = function(model) {
        return A3($author$project$Api$Provider$Patient$list, model.Ej, function(d) {
            return _Utils_update(d, {
                Fw: _List_fromArray([
                    $author$project$Api$Provider$Patient$WithoutHipaaAuthorization
                ]),
                af_: model.af_
            });
        }, $author$project$Pages$Admin$HipaaAuthorizations$GotPatients);
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var model = {
            aU: $author$project$Pages$Admin$HipaaAuthorizations$None,
            Ej: apiClient,
            rF: 0,
            af_: $author$project$Api$Pagination$init,
            AD: $author$project$Api$Data$Loading,
            nC: false
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model));
    });
    var $author$project$Pages$Admin$HipaaAuthorizations$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$HipaaAuthorizations$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed = {
        $: 4
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$subscriptions = function(_v0) {
        var acceptingFor = _v0.aU;
        if (!acceptingFor.$) return $elm$core$Platform$Sub$none;
        else return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed);
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForAll = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForOne = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$HipaaAuthorizations$All = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$One = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$One$Patient = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$One$Record = function(requestPayInfoSentAt) {
        return function(requestPendingDocumentsAcceptanceSentAt) {
            return function(location1) {
                return function(practitioner) {
                    return function(company) {
                        return function(companyAccounts) {
                            return function(payer) {
                                return function(payees) {
                                    return function(age) {
                                        return function(membershipThrough) {
                                            return function(flaggedNotesCount) {
                                                return function(isMaster) {
                                                    return function(isSynced) {
                                                        return function(isAffiliated) {
                                                            return function(syncedRecordId) {
                                                                return function(network) {
                                                                    return function(masterRecordId) {
                                                                        return function(affiliate) {
                                                                            return function(affiliateSyncStatus) {
                                                                                return function(networkSyncStatus) {
                                                                                    return function(overdueAmountInCents) {
                                                                                        return function(title) {
                                                                                            return function(stripeLink) {
                                                                                                return function(phones) {
                                                                                                    return function(usesBillingAddress) {
                                                                                                        return function(address) {
                                                                                                            return function(billingAddress) {
                                                                                                                return function(ssn) {
                                                                                                                    return function(knownPractice) {
                                                                                                                        return function(dpcPatient) {
                                                                                                                            return function(assignedAffiliation) {
                                                                                                                                return function(preferredLanguage) {
                                                                                                                                    return function(leadSource) {
                                                                                                                                        return function(accountAccessSentAt) {
                                                                                                                                            return function(lastPortalAccessedAt) {
                                                                                                                                                return function(mergedInto) {
                                                                                                                                                    return function(healthInsurance) {
                                                                                                                                                        return function(companyRegistrations) {
                                                                                                                                                            return function(owedInCents) {
                                                                                                                                                                return function(creditInCents) {
                                                                                                                                                                    return function(creditExpiresSoon) {
                                                                                                                                                                        return function(defaultSource) {
                                                                                                                                                                            return function(sourcesCount) {
                                                                                                                                                                                return function(integrations) {
                                                                                                                                                                                    return function(customForms) {
                                                                                                                                                                                        return function(hasPaymentMethod) {
                                                                                                                                                                                            return function(profilePictureUrl) {
                                                                                                                                                                                                return function(createdAt) {
                                                                                                                                                                                                    return function(suffix) {
                                                                                                                                                                                                        return function(emergencyContact) {
                                                                                                                                                                                                            return function(exemptFromCreditCardFees) {
                                                                                                                                                                                                                return function(shouldChargeCreditCardFees) {
                                                                                                                                                                                                                    return {
                                                                                                                                                                                                                        Ik: accountAccessSentAt,
                                                                                                                                                                                                                        II: address,
                                                                                                                                                                                                                        Eb: affiliate,
                                                                                                                                                                                                                        IX: affiliateSyncStatus,
                                                                                                                                                                                                                        IZ: age,
                                                                                                                                                                                                                        JE: assignedAffiliation,
                                                                                                                                                                                                                        Ke: billingAddress,
                                                                                                                                                                                                                        acy: company,
                                                                                                                                                                                                                        LK: companyAccounts,
                                                                                                                                                                                                                        LQ: companyRegistrations,
                                                                                                                                                                                                                        Mx: createdAt,
                                                                                                                                                                                                                        MC: creditExpiresSoon,
                                                                                                                                                                                                                        MD: creditInCents,
                                                                                                                                                                                                                        MU: customForms,
                                                                                                                                                                                                                        ND: defaultSource,
                                                                                                                                                                                                                        Oi: dpcPatient,
                                                                                                                                                                                                                        OJ: emergencyContact,
                                                                                                                                                                                                                        Pa: exemptFromCreditCardFees,
                                                                                                                                                                                                                        PR: flaggedNotesCount,
                                                                                                                                                                                                                        Qv: hasPaymentMethod,
                                                                                                                                                                                                                        QC: healthInsurance,
                                                                                                                                                                                                                        Rt: integrations,
                                                                                                                                                                                                                        RQ: isAffiliated,
                                                                                                                                                                                                                        R8: isMaster,
                                                                                                                                                                                                                        Su: isSynced,
                                                                                                                                                                                                                        SM: knownPractice,
                                                                                                                                                                                                                        SW: lastPortalAccessedAt,
                                                                                                                                                                                                                        S1: leadSource,
                                                                                                                                                                                                                        aeT: location1,
                                                                                                                                                                                                                        TK: masterRecordId,
                                                                                                                                                                                                                        T6: membershipThrough,
                                                                                                                                                                                                                        Ud: mergedInto,
                                                                                                                                                                                                                        UK: network,
                                                                                                                                                                                                                        UP: networkSyncStatus,
                                                                                                                                                                                                                        VJ: overdueAmountInCents,
                                                                                                                                                                                                                        VL: owedInCents,
                                                                                                                                                                                                                        Wf: payees,
                                                                                                                                                                                                                        GR: payer,
                                                                                                                                                                                                                        WG: phones,
                                                                                                                                                                                                                        agi: practitioner,
                                                                                                                                                                                                                        Xh: preferredLanguage,
                                                                                                                                                                                                                        XE: profilePictureUrl,
                                                                                                                                                                                                                        YF: requestPayInfoSentAt,
                                                                                                                                                                                                                        YG: requestPendingDocumentsAcceptanceSentAt,
                                                                                                                                                                                                                        _c: shouldChargeCreditCardFees,
                                                                                                                                                                                                                        _J: sourcesCount,
                                                                                                                                                                                                                        __: ssn,
                                                                                                                                                                                                                        $j: stripeLink,
                                                                                                                                                                                                                        $w: suffix,
                                                                                                                                                                                                                        $K: syncedRecordId,
                                                                                                                                                                                                                        $2: title,
                                                                                                                                                                                                                        aa_: usesBillingAddress
                                                                                                                                                                                                                    };
                                                                                                                                                                                                                };
                                                                                                                                                                                                            };
                                                                                                                                                                                                        };
                                                                                                                                                                                                    };
                                                                                                                                                                                                };
                                                                                                                                                                                            };
                                                                                                                                                                                        };
                                                                                                                                                                                    };
                                                                                                                                                                                };
                                                                                                                                                                            };
                                                                                                                                                                        };
                                                                                                                                                                    };
                                                                                                                                                                };
                                                                                                                                                            };
                                                                                                                                                        };
                                                                                                                                                    };
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Patient$One$BankAccount_ = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$One$bankAccountDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BankAccount$One$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$BankAccount_));
    var $author$project$Api$Provider$Patient$One$Card_ = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$One$cardDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Card$One$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Card_));
    var $author$project$Api$Common$EmergencyContact$Shared$EmergencyContact = $elm$core$Basics$identity;
    var $author$project$Api$Common$EmergencyContact$Shared$Record = F7(function(id, name, firstName, lastName, relationship, email, phone) {
        return {
            OH: email,
            PN: firstName,
            aef: id,
            SU: lastName,
            zr: name,
            WE: phone,
            Yu: relationship
        };
    });
    var $author$project$Api$Common$EmergencyContact$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phone', $elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'relationship', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$EmergencyContact$Shared$Record))))))));
    var $author$project$Api$Common$EmergencyContact$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$EmergencyContact$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$SocialSecurityNumber$Masked$SocialSecurityNumber = $elm$core$Basics$identity;
    var $author$project$Api$Common$SocialSecurityNumber$Masked$MaskedRecord = function(maskedNumber) {
        return {
            TJ: maskedNumber
        };
    };
    var $author$project$Api$Common$SocialSecurityNumber$Masked$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'masked_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Common$SocialSecurityNumber$Masked$MaskedRecord));
    var $author$project$Api$Common$SocialSecurityNumber$Masked$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$SocialSecurityNumber$Masked$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$Min$Company = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Company$Min$Record = F3(function(id, name, companyType) {
        return {
            LR: companyType,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Company$CompanyType$Child = 1;
    var $author$project$Api$Company$CompanyType$Network = 0;
    var $author$project$Api$Company$CompanyType$Parent = 2;
    var $author$project$Api$Company$CompanyType$Standalone = 3;
    var $author$project$Api$Company$CompanyType$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'network':
                return $elm$json$Json$Decode$succeed(0);
            case 'child':
                return $elm$json$Json$Decode$succeed(1);
            case 'parent':
                return $elm$json$Json$Decode$succeed(2);
            case 'standalone':
                return $elm$json$Json$Decode$succeed(3);
            default:
                var somethingElse = string;
                return $elm$json$Json$Decode$fail('Unknown Company -> company_type: ' + somethingElse);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Company$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_type', $author$project$Api$Company$CompanyType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$Min$Record))));
    var $author$project$Api$Provider$Company$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Company$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyAccount$ForPatient$CompanyAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyAccount$Shared$CompanyAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyAccount$Min$CompanyAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyAccount$Min$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$CompanyAccount$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Min$Record));
    var $author$project$Api$Provider$CompanyAccount$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyAccount$Shared$Record = F5(function(isEligible, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, needsApproval) {
        return {
            OD: eligibilityEndDate,
            OE: eligibilityStartDate,
            R2: isEligible,
            UI: needsApproval,
            ahQ: terminationRequestedAt
        };
    });
    var $author$project$Api$Provider$CompanyAccount$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'needs_approval', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'eligibility_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'eligibility_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_requested_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_eligible', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Shared$Record))))));
    var $author$project$Api$Provider$CompanyAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$Shared$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Shared$CompanyAccount)));
    var $author$project$Api$Provider$CompanyAccount$ForPatient$Record = F3(function(company, subscriber, companyRegistrations) {
        return {
            acy: company,
            LQ: companyRegistrations,
            $r: subscriber
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$CompanyRegistration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$Shared$CompanyRegistration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyRegistration$Shared$Record = F8(function(id, type_, isSubscriber, externalId, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, membershipEndDate) {
        return {
            OD: eligibilityEndDate,
            OE: eligibilityStartDate,
            adE: externalId,
            aef: id,
            Ss: isSubscriber,
            T_: membershipEndDate,
            ahQ: terminationRequestedAt,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'eligibility_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'eligibility_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_requested_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'external_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_subscriber', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$Shared$Record)))))))));
    var $author$project$Api$Provider$CompanyRegistration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$Record = F2(function(patient, isCurrentMember) {
        return {
            RY: isCurrentMember,
            V7: patient
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_current_member', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$Record)));
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$CompanyRegistration)));
    var $author$project$Api$Provider$CompanyAccount$ForPatient$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_registrations', $elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subscriber', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $author$project$Api$Provider$Company$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$ForPatient$Record))));
    var $author$project$Api$Provider$CompanyAccount$ForPatient$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$ForPatient$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$ForPatient$CompanyAccount)));
    var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$CompanyRegistration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$Record = function(account) {
        return {
            Ij: account
        };
    };
    var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'account', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForPatientOne$Record));
    var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$ForPatientOne$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForPatientOne$CompanyRegistration)));
    var $author$project$Api$Provider$FormResponse$One$FormResponse = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$FormResponse$Shared$FormResponse = $elm$core$Basics$identity;
    var $author$project$Api$Provider$FormResponse$Shared$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$FormResponse$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$Shared$Record));
    var $author$project$Api$Provider$FormResponse$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$FormResponse$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$FormResponse$One$Record = F2(function(form, formResponseItems) {
        return {
            PU: form,
            PW: formResponseItems
        };
    });
    var $author$project$Api$Provider$FormResponseItem$Shared$FormResponseItem = $elm$core$Basics$identity;
    var $author$project$Api$Provider$FormResponseItem$Shared$Record = F3(function(id, formItemId, answer) {
        return {
            Ju: answer,
            FA: formItemId,
            aef: id
        };
    });
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(function(path, valDecoder, decoder) {
        return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$at, path, valDecoder), decoder);
    });
    var $author$project$Api$Provider$FormResponseItem$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'answer', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray([
        'form_item',
        'id'
    ]), $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponseItem$Shared$Record))));
    var $author$project$Api$Provider$FormResponseItem$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$FormResponseItem$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$FormResponse$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'form_response_items', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$list($author$project$Api$Provider$FormResponseItem$Shared$decoder)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'form', $author$project$Api$Provider$Form$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$One$Record)));
    var $author$project$Api$Provider$FormResponse$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$FormResponse$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$FormResponse$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$FormResponse$One$FormResponse)));
    var $author$project$Api$Provider$HealthInsurance$Shared$HealthInsurance = $elm$core$Basics$identity;
    var $author$project$Api$Provider$HealthInsurance$Shared$Record = F5(function(memberId, groupId, payerName, highDeductible, carrier) {
        return {
            K_: carrier,
            Qf: groupId,
            QJ: highDeductible,
            TV: memberId,
            Wg: payerName
        };
    });
    var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$HealthInsuranceCarrier = $elm$core$Basics$identity;
    var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$Record = F4(function(id, collectGroupId, collectHighDeductible, collectMemberId) {
        return {
            Lr: collectGroupId,
            Ls: collectHighDeductible,
            Lv: collectMemberId,
            aef: id
        };
    });
    var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_member_id', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_high_deductible', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_group_id', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$HealthInsuranceCarrier$Shared$Record)))));
    var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$HealthInsuranceCarrier$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$HealthInsurance$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'carrier', $elm$json$Json$Decode$nullable($author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'high_deductible', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payer_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'group_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'member_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$HealthInsurance$Shared$Record))))));
    var $author$project$Api$Provider$HealthInsurance$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$HealthInsurance$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$KnownPractice$Shared$KnownPractice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$KnownPractice$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$KnownPractice$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$KnownPractice$Shared$Record)));
    var $author$project$Api$Provider$KnownPractice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$KnownPractice$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$LeadSource$Shared$LeadSource = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LeadSource$Shared$SharedRecord = F4(function(id, name, showOnOnlineSignup, patientsCount) {
        return {
            aef: id,
            zr: name,
            Wd: patientsCount,
            _h: showOnOnlineSignup
        };
    });
    var $author$project$Api$Provider$LeadSource$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patients_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'show_on_online_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LeadSource$Shared$SharedRecord)))));
    var $author$project$Api$Provider$LeadSource$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LeadSource$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Organization$Shared$Organization = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Organization$Min$Organization = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Organization$Min$Record = F3(function(type_, id, name) {
        return {
            aef: id,
            zr: name,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$Organization$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$OrganizationType$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Organization$Min$Record))));
    var $author$project$Api$Provider$Organization$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Organization$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Organization$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Organization$Min$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$DpcPatient$Patient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$DpcPatient$Record = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Provider$Patient$DpcPatient$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$DpcPatient$Record));
    var $author$project$Api$Provider$Patient$DpcPatient$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$DpcPatient$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Practitioner$Shared$Practitioner = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practitioner$Shared$Record = function(id) {
        return function(name) {
            return function(isMaster) {
                return function(isSynced) {
                    return function(onlineSignupVisibility) {
                        return function(isProvider) {
                            return function(acceptsEnrollmentsFromEmployer) {
                                return function(acceptsEnrollmentsFromRetail) {
                                    return function(panelSize) {
                                        return function(panelSizeLimit) {
                                            return function(email) {
                                                return function(autoDetermineOnlineSignupVisibilityFromPanelSize) {
                                                    return function(maxPatientAge) {
                                                        return function(minPatientAge) {
                                                            return function(education) {
                                                                return function(syncedPatientsCount) {
                                                                    return function(elationPhysicianId) {
                                                                        return function(bio) {
                                                                            return function(photoUrl) {
                                                                                return function(gender) {
                                                                                    return function(genderOther) {
                                                                                        return function(npi) {
                                                                                            return function(openingsSize) {
                                                                                                return function(meta) {
                                                                                                    return function(affiliation) {
                                                                                                        return function(practiceName) {
                                                                                                            return function(practitionerType) {
                                                                                                                return {
                                                                                                                    pj: acceptsEnrollmentsFromEmployer,
                                                                                                                    pk: acceptsEnrollmentsFromRetail,
                                                                                                                    IY: affiliation,
                                                                                                                    JU: autoDetermineOnlineSignupVisibilityFromPanelSize,
                                                                                                                    Kj: bio,
                                                                                                                    Ov: education,
                                                                                                                    OA: elationPhysicianId,
                                                                                                                    OH: email,
                                                                                                                    P5: gender,
                                                                                                                    P7: genderOther,
                                                                                                                    aef: id,
                                                                                                                    R8: isMaster,
                                                                                                                    Sl: isProvider,
                                                                                                                    Su: isSynced,
                                                                                                                    TM: maxPatientAge,
                                                                                                                    Ue: meta,
                                                                                                                    Ul: minPatientAge,
                                                                                                                    zr: name,
                                                                                                                    U9: npi,
                                                                                                                    Vv: onlineSignupVisibility,
                                                                                                                    Vy: openingsSize,
                                                                                                                    VS: panelSize,
                                                                                                                    VT: panelSizeLimit,
                                                                                                                    WI: photoUrl,
                                                                                                                    agg: practiceName,
                                                                                                                    Xb: practitionerType,
                                                                                                                    $J: syncedPatientsCount
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Practitioner$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practitioner$Meta$MetaFields = function(bio) {
        return function(education) {
            return function(email) {
                return function(gender) {
                    return function(treatsAge) {
                        return function(name) {
                            return function(npi) {
                                return function(photo) {
                                    return function(panelSizeLimit) {
                                        return function(specialtyNames) {
                                            return function(locations) {
                                                return {
                                                    Kj: bio,
                                                    Ov: education,
                                                    OH: email,
                                                    P5: gender,
                                                    Tq: locations,
                                                    zr: name,
                                                    U9: npi,
                                                    VT: panelSizeLimit,
                                                    WH: photo,
                                                    _O: specialtyNames,
                                                    aaz: treatsAge
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Utils$MetaFields$Editable = {
        $: 0
    };
    var $author$project$Utils$MetaFields$NonEditable = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Utils$MetaFields$decodeEditable = A2($elm$json$Json$Decode$andThen, function(editable) {
        return editable ? $elm$json$Json$Decode$succeed($author$project$Utils$MetaFields$Editable) : A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'explanation', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Utils$MetaFields$NonEditable));
    }, A2($elm$json$Json$Decode$field, 'editable', $elm$json$Json$Decode$bool));
    var $author$project$Api$Provider$Practitioner$Meta$decodeMetaFields = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'locations', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'specialty_names', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'panel_size_limit', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'photo', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'npi', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'treats_age', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'education', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bio', $author$project$Utils$MetaFields$decodeEditable, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Meta$MetaFields))))))))))));
    var $author$project$Api$Provider$Practitioner$Meta$decode = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practitioner$Meta$decodeMetaFields, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Gender$Female = 1;
    var $author$project$Api$Gender$Intersex = 2;
    var $author$project$Api$Gender$Male = 0;
    var $author$project$Api$Gender$Other = 3;
    var $author$project$Api$Gender$genderDecoder = function(string) {
        switch(string){
            case 'male':
                return $elm$json$Json$Decode$succeed(0);
            case 'female':
                return $elm$json$Json$Decode$succeed(1);
            case 'intersex':
                return $elm$json$Json$Decode$succeed(2);
            case 'other':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail('Unsupported gender: ' + string);
        }
    };
    var $author$project$Api$Gender$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$Gender$genderDecoder, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Npi$Shared$Npi = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Npi$Shared$Record = F5(function(number, type_, organizationName, firstName, lastName) {
        return {
            PN: firstName,
            SU: lastName,
            Gx: number,
            VB: organizationName,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$Npi$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Npi$Shared$Record))))));
    var $author$project$Api$Provider$Npi$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Npi$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Practitioner$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'practitioner_type', $elm$json$Json$Decode$string, '', A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'practice_name', $elm$json$Json$Decode$string, '', A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'affiliation', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Practitioner$Meta$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'openings_size', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'npi', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Npi$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender', $elm$json$Json$Decode$nullable($author$project$Api$Gender$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'photo_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bio', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'elation_physician_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'synced_patients_count', $elm$json$Json$Decode$int, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'education', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min_patient_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_patient_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_determine_online_signup_visibility_from_panel_size', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'panel_size_limit', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'panel_size', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_enrollments_from_retail', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_enrollments_from_employer', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_provider', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'online_signup_visibility', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_synced', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_master', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Shared$Record))))))))))))))))))))))))))));
    var $author$project$Api$Provider$Practitioner$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practitioner$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$FormResponse$One$form = function(_v0) {
        var record = _v0.b;
        return record.PU;
    };
    var $author$project$Api$Provider$CustomForm$FormAnswer = $elm$core$Basics$identity;
    var $author$project$Api$Provider$FormResponseItem$Shared$answer = function(_v0) {
        var record = _v0;
        return record.Ju;
    };
    var $author$project$Api$Provider$FormResponseItem$Shared$formItemId = function(_v0) {
        var record = _v0;
        return record.FA;
    };
    var $author$project$Api$Provider$FormResponse$One$formResponseItems = function(_v0) {
        var record = _v0.b;
        return record.PW;
    };
    var $author$project$Api$Provider$FormResponseItem$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CustomForm$formItemToFormQuestion = F2(function(formResponse, formItem) {
        var allResponseItems = $author$project$Api$Provider$FormResponse$One$formResponseItems(formResponse);
        var responseItems = function() {
            if (!allResponseItems.$) {
                var responseItems_ = allResponseItems.a;
                return A2($elm$core$List$filter, function(responseItem) {
                    return _Utils_eq($author$project$Api$Provider$FormResponseItem$Shared$formItemId(responseItem), $author$project$Api$Provider$FormItem$Shared$id(formItem));
                }, responseItems_);
            } else return _List_Nil;
        }();
        if ($elm$core$List$isEmpty(responseItems)) return {
            pz: _List_Nil,
            aef: $author$project$Api$Provider$FormItem$Shared$id(formItem),
            $2: $author$project$Api$Provider$FormItem$Shared$title(formItem),
            ah5: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType($author$project$Api$Provider$FormItem$Shared$type_(formItem))
        };
        else {
            var toFormAnswer = F2(function(id_, answer) {
                return {
                    NT: $elm$core$Maybe$Nothing,
                    aef: id_,
                    $Y: answer
                };
            });
            var answers_ = A2($elm$core$List$map, function(item) {
                return A2(toFormAnswer, $author$project$Api$Provider$FormResponseItem$Shared$id(item), $author$project$Api$Provider$FormResponseItem$Shared$answer(item));
            }, responseItems);
            return {
                pz: answers_,
                aef: $author$project$Api$Provider$FormItem$Shared$id(formItem),
                $2: $author$project$Api$Provider$FormItem$Shared$title(formItem),
                ah5: $author$project$Api$Provider$CustomForm$itemTypeToQuestionType($author$project$Api$Provider$FormItem$Shared$type_(formItem))
            };
        }
    });
    var $author$project$Api$Provider$FormResponse$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$FormResponse$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$FormResponse$Shared$id(shared);
    };
    var $author$project$Api$Provider$CustomForm$initFromFormResponse = function(formResponse) {
        var form = $author$project$Api$Provider$FormResponse$One$form(formResponse);
        var formItems = $author$project$Api$Provider$Form$Shared$items(form);
        var questions_ = A2($elm$core$List$map, function(formItem) {
            return A2($author$project$Api$Provider$CustomForm$formItemToFormQuestion, formResponse, formItem);
        }, formItems);
        return {
            xP: $author$project$Api$Provider$FormResponse$One$id(formResponse),
            aef: $author$project$Api$Provider$Form$Shared$id(form),
            zr: $author$project$Api$Provider$Form$Shared$name(form),
            BA: questions_
        };
    };
    var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(function(path, valDecoder, fallback, decoder) {
        return A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value), valDecoder, fallback), decoder);
    });
    var $author$project$Api$Provider$ExternalRecord$ExternalRecord = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ExternalRecord$Record = F4(function(conflicts, errorMessage, source, status) {
        return {
            LY: conflicts,
            O4: errorMessage,
            Hw: source,
            ahy: status
        };
    });
    var $author$project$Api$Provider$ExternalRecord$Conflict = F3(function(name, ours, theirs) {
        return {
            zr: name,
            afZ: ours,
            ahR: theirs
        };
    });
    var $author$project$Api$Provider$ExternalRecord$conflictDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'theirs', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ours', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ExternalRecord$Conflict))));
    var $author$project$Api$Provider$ExternalRecord$Failed = 2;
    var $author$project$Api$Provider$ExternalRecord$Inactive = 1;
    var $author$project$Api$Provider$ExternalRecord$Pending = 3;
    var $author$project$Api$Provider$ExternalRecord$Processing = 5;
    var $author$project$Api$Provider$ExternalRecord$Skipped = 4;
    var $author$project$Api$Provider$ExternalRecord$Successful = 0;
    var $author$project$Api$Provider$ExternalRecord$statusCodeDecoder = function(string) {
        switch(string){
            case 'successful':
                return $elm$json$Json$Decode$succeed(0);
            case 'inactive':
                return $elm$json$Json$Decode$succeed(1);
            case 'failed':
                return $elm$json$Json$Decode$succeed(2);
            case 'pending':
                return $elm$json$Json$Decode$succeed(3);
            case 'skipped':
                return $elm$json$Json$Decode$succeed(4);
            case 'processing':
                return $elm$json$Json$Decode$succeed(5);
            default:
                return $elm$json$Json$Decode$fail('Unsupported external record status: ' + string);
        }
    };
    var $author$project$Api$Provider$ExternalRecord$decoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$ExternalRecord$statusCodeDecoder, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'conflicts', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$list($author$project$Api$Provider$ExternalRecord$conflictDecoder)), $elm$json$Json$Decode$succeed($author$project$Api$Provider$ExternalRecord$Record)))));
    var $author$project$Api$Provider$ExternalRecord$statusDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ExternalRecord$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'should_charge_credit_card_fees', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exempt_from_credit_card_fees', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'emergency_contact', $elm$json$Json$Decode$nullable($author$project$Api$Common$EmergencyContact$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'suffix', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'profile_picture_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_payment_method', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'form_responses', A2($elm$json$Json$Decode$map, $elm$core$List$map($author$project$Api$Provider$CustomForm$initFromFormResponse), $elm$json$Json$Decode$list($author$project$Api$Provider$FormResponse$One$decoder)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integrations', $elm$json$Json$Decode$list($author$project$Api$Provider$ExternalRecord$statusDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sources_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_source', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$oneOf(_List_fromArray([
        $author$project$Api$Provider$Patient$One$cardDecoder,
        $author$project$Api$Provider$Patient$One$bankAccountDecoder
    ]))), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credit_expires_soon', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credit_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owed_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_registrations', $elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForPatientOne$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'health_insurance', $elm$json$Json$Decode$nullable($author$project$Api$Provider$HealthInsurance$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'merged_into', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_portal_accessed_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'account_access_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lead_source', $elm$json$Json$Decode$nullable($author$project$Api$Provider$LeadSource$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'preferred_language', $author$project$Language$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'assigned_affiliation', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'dpc_patient', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$DpcPatient$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'known_practice', $elm$json$Json$Decode$nullable($author$project$Api$Provider$KnownPractice$Shared$decoder), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'ssn', $elm$json$Json$Decode$nullable($author$project$Api$Common$SocialSecurityNumber$Masked$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_billing_address', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phones', $elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_link', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'overdue_in_cents', $elm$json$Json$Decode$int, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'network_sync_status', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'affiliate_sync_status', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SyncStatus$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'affiliate', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt, _List_fromArray([
        'master_record',
        'id'
    ]), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'network', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Shared$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt, _List_fromArray([
        'synced_record',
        'id'
    ]), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_affiliated', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_synced', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_master', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'flagged_notes_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_through', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payees', $elm$json$Json$Decode$list($author$project$Api$Provider$Patient$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payer', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_accounts', $elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAccount$ForPatient$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_pending_documents_acceptance_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_pay_info_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Record)))))))))))))))))))))))))))))))))))))))))))))))))))));
    var $author$project$Api$Provider$Patient$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$One$Patient)));
    var $author$project$Api$Provider$Patient$patientPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Patient$patientsPath);
    };
    var $author$project$Api$Provider$Patient$acceptHipaaAuthorization = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'accept_hipaa_authorization'
        ]), $author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Api$Provider$Patient$acceptHipaaAuthorizationAll = F2(function(apiClient, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('do_all', $elm$json$Json$Encode$bool(true))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'accept_hipaa_authorization'
        ]), $author$project$Api$Provider$Patient$patientsPath))));
    });
    var $author$project$Api$Provider$Patient$Shared$id = function(_v0) {
        var shared = _v0;
        return shared.aef;
    };
    var $author$project$Api$Provider$Patient$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$id(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$name = function(_v0) {
        var shared = _v0;
        return shared.zr;
    };
    var $author$project$Api$Provider$Patient$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$name(shared);
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$FetchPatients = {
        $: 9
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$pollPatients = A2($elm$core$Task$perform, function(_v0) {
        return $author$project$Pages$Admin$HipaaAuthorizations$FetchPatients;
    }, $elm$core$Process$sleep(1000));
    var $author$project$Pages$Admin$HipaaAuthorizations$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    var totalCount = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
                    var cmd = model.nC && totalCount > 0 ? $author$project$Pages$Admin$HipaaAuthorizations$pollPatients : $elm$core$Platform$Cmd$none;
                    return _Utils_Tuple3(_Utils_update(model, {
                        rF: totalCount,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        AD: response,
                        nC: model.nC && totalCount > 0
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    AD: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(newModel), _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    aU: $author$project$Pages$Admin$HipaaAuthorizations$All($author$project$Api$Data$NotAsked)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var patient = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aU: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, $author$project$Api$Data$NotAsked)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    aU: $author$project$Pages$Admin$HipaaAuthorizations$None
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    aU: $author$project$Pages$Admin$HipaaAuthorizations$All($author$project$Api$Data$Loading)
                }), A2($author$project$Api$Provider$Patient$acceptHipaaAuthorizationAll, model.Ej, $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForAll), _List_Nil);
            case 6:
                var patient = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aU: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, $author$project$Api$Data$Loading)
                }), A3($author$project$Api$Provider$Patient$acceptHipaaAuthorization, model.Ej, $author$project$Api$Provider$Patient$All$id(patient), $author$project$Pages$Admin$HipaaAuthorizations$AcceptedForOne(patient)), _List_Nil);
            case 8:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    aU: $author$project$Pages$Admin$HipaaAuthorizations$None,
                    AD: $author$project$Api$Data$Loading,
                    nC: true
                }), $author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Accepting HIPAA for all patients. This may take a couple moments...')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    aU: $author$project$Pages$Admin$HipaaAuthorizations$All(response)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var patient = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    aU: $author$project$Pages$Admin$HipaaAuthorizations$None,
                    AD: $author$project$Api$Data$Loading
                }), $author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'You successfully accepted the ePHI waiver. ' + ($author$project$Api$Provider$Patient$All$name(patient) + ' will now receive notifications.'))
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    aU: A2($author$project$Pages$Admin$HipaaAuthorizations$One, patient, response)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    AD: $author$project$Api$Data$Loading
                }), $author$project$Pages$Admin$HipaaAuthorizations$fetchPatients(model), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$HipaaAuthorizations$AcceptForAll = {
        $: 5
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$AcceptForOne = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal = F3(function(numberPatientsNotAuthorized, patient, response) {
        var _v0 = function() {
            if (!patient.$) {
                var patient_ = patient.a;
                return _Utils_Tuple2($author$project$Pages$Admin$HipaaAuthorizations$AcceptForOne(patient_), A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Patient$All$name(patient_))
                ])));
            } else return _Utils_Tuple2($author$project$Pages$Admin$HipaaAuthorizations$AcceptForAll, $elm$html$Html$text('All'));
        }();
        var buttonMsg = _v0.a;
        var buttonSubject = _v0.b;
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Authorization to commmunicate over non-encrypted media')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, function() {
                    if (!patient.$) {
                        var patient_ = patient.a;
                        return _List_fromArray([
                            $elm$html$Html$text('You have received authorization from '),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$All$name(patient_))
                            ])),
                            $elm$html$Html$text(' that allow us to send non-encrypted communications to '),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$All$name(patient_))
                            ])),
                            $elm$html$Html$text(' that may include Protected Health Information. '),
                            $elm$html$Html$text('This is not reversible.')
                        ]);
                    } else return _List_fromArray([
                        $elm$html$Html$text('You have received authorization from '),
                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', numberPatientsNotAuthorized)),
                        $elm$html$Html$text(' that allow us to send non-encrypted communications to each of them that may include Protected Health Information. '),
                        $elm$html$Html$text('This is not reversible.')
                    ]);
                }()),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Do you have a signed copy of the non-encrypted communications waiver from '),
                    function() {
                        if (!patient.$) {
                            var patient_ = patient.a;
                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$All$name(patient_))
                            ]));
                        } else return $elm$html$Html$text('all of these patients');
                    }()
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$HipaaAuthorizations$AcceptModalClosed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Accept ePHI'
                }, _List_fromArray([
                    $author$project$Ui$Button$success,
                    $author$project$Ui$Button$onClick(buttonMsg),
                    $author$project$Ui$Button$loading(_Utils_eq(response, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Yes, Accept for '),
                    buttonSubject
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$HipaaAuthorizations$AcceptingForAll = {
        $: 2
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$AcceptingForOne = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Shared$email = function(_v0) {
        var shared = _v0;
        return shared.OH;
    };
    var $author$project$Api$Provider$Patient$All$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$email(shared);
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$viewPatient = function(patient) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Patient$All$name(patient))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$All$email(patient)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'accept ePHI waiver'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$HipaaAuthorizations$AcceptingForOne(patient))
                ]), _List_fromArray([
                    $elm$html$Html$text('Accept ePHI waiver')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$viewPanel = function(model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('ePHI Communication Waivers')
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Accept for all patients'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$HipaaAuthorizations$AcceptingForAll)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Accept for All Patients')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = model.AD;
                    if (_v0.$ === 3) {
                        var patients = _v0.a;
                        return $elm$core$List$isEmpty(patients) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('The following patients have not authorized our system to send them unencrypted electronic '),
                            $elm$html$Html$text('communications which may contain Protected Health Information, such as emails about invoices and receipts.'),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            $elm$html$Html$text('We will not send emails or other electronic notifications which '),
                            $elm$html$Html$text('may contain Protected Health Information to these patients.')
                        ]));
                    } else return $author$project$Ui$Spinner$view(_List_Nil);
                }(),
                A4($author$project$Ui$Table$view, _List_fromArray([
                    $author$project$Ui$Table$zeroState(_List_fromArray([
                        $elm$html$Html$text('All of your active patients have agreed to allow all email communications from this platform, so they should be receiving notifications from our system.')
                    ])),
                    $author$project$Ui$Table$loading(_Utils_eq(model.AD, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Patient')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Email')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ]), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$map($author$project$Pages$Admin$HipaaAuthorizations$viewPatient), $author$project$Api$Data$toMaybe(model.AD))), _List_Nil)
            ])),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$HipaaAuthorizations$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.AD))
                ]), model.af_))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.aU;
                    switch(_v0.$){
                        case 1:
                            var id = _v0.a;
                            var response = _v0.b;
                            return A3($author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal, model.rF, $elm$core$Maybe$Just(id), response);
                        case 2:
                            var response = _v0.a;
                            return A3($author$project$Pages$Admin$HipaaAuthorizations$viewAcceptModal, model.rF, $elm$core$Maybe$Nothing, response);
                        default:
                            return $author$project$Utils$Html$empty;
                    }
                }(),
                $author$project$Pages$Admin$HipaaAuthorizations$viewPanel(model)
            ]),
            $2: 'Admin | ePHI Waivers'
        };
    };
    var $author$project$Pages$Admin$HipaaAuthorizations$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$HipaaAuthorizations$init,
        aeR: $author$project$Pages$Admin$HipaaAuthorizations$load,
        ag3: $author$project$Pages$Admin$HipaaAuthorizations$save,
        ahE: $author$project$Pages$Admin$HipaaAuthorizations$subscriptions,
        aaO: $author$project$Pages$Admin$HipaaAuthorizations$update,
        aid: $author$project$Pages$Admin$HipaaAuthorizations$view
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$GotIntegration = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$One$Integration = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Provider$Partner$ForIntegrationOne$Partner = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Partner$ForIntegrationOne$Record = F9(function(active, authType, email, integrationDescription, supportUrl, marketingUrl, signupUrl, productDescription, postActivationRedirectUrl) {
        return {
            Ir: active,
            JO: authType,
            OH: email,
            Ro: integrationDescription,
            TH: marketingUrl,
            WY: postActivationRedirectUrl,
            Xz: productDescription,
            _u: signupUrl,
            $y: supportUrl
        };
    });
    var $author$project$Api$Provider$Partner$ForIntegrationOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_activation_redirect_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signup_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'marketing_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'support_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auth_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$ForIntegrationOne$Record))))))))));
    var $author$project$Api$Provider$Partner$ForIntegrationOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Partner$ForIntegrationOne$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Partner$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Partner$ForIntegrationOne$Partner)));
    var $author$project$Api$Provider$Integration$One$Record = F6(function(connectionUrl, addon, partnerApp, product, autoGrantPartnerAppAccess, defaultPartnerAppRole) {
        return {
            IF: addon,
            abQ: autoGrantPartnerAppAccess,
            LZ: connectionUrl,
            acZ: defaultPartnerAppRole,
            VY: partnerApp,
            Xw: product
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Shared$Product = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$Shared$Record = function(slug) {
        return function(name) {
            return function(distributionType) {
                return function(listingStatus) {
                    return function(summary) {
                        return function(iconUrl) {
                            return function(builtByName) {
                                return function(builtByUrl) {
                                    return function(featured) {
                                        return function(type_) {
                                            return function(categories) {
                                                return {
                                                    Ku: builtByName,
                                                    Kv: builtByUrl,
                                                    K0: categories,
                                                    N9: distributionType,
                                                    Pw: featured,
                                                    Q_: iconUrl,
                                                    Tj: listingStatus,
                                                    zr: name,
                                                    _A: slug,
                                                    $x: summary,
                                                    ah5: type_
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Common$Marketplace$Product$Category$Category = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$Category$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Category$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Category$Record))));
    var $author$project$Api$Common$Marketplace$Product$DistributionType$Public = 0;
    var $author$project$Api$Common$Marketplace$Product$DistributionType$Unlisted = 1;
    var $author$project$Api$Common$Marketplace$Product$DistributionType$fromString = function(string) {
        switch(string){
            case 'public':
                return $elm$core$Maybe$Just(0);
            case 'unlisted':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$Marketplace$Product$DistributionType$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        var _v0 = $author$project$Api$Common$Marketplace$Product$DistributionType$fromString(string);
        if (!_v0.$) {
            var distributionType = _v0.a;
            return $elm$json$Json$Decode$succeed(distributionType);
        } else return $elm$json$Json$Decode$fail('Invalid distribution type: ' + string);
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Marketplace$Product$ProductType$App = 0;
    var $author$project$Api$Common$Marketplace$Product$ProductType$Integration = 1;
    var $author$project$Api$Common$Marketplace$Product$ProductType$Solution = 2;
    var $author$project$Api$Common$Marketplace$Product$ProductType$decoder = A2($elm$json$Json$Decode$andThen, function(str) {
        switch(str){
            case 'app':
                return $elm$json$Json$Decode$succeed(0);
            case 'integration':
                return $elm$json$Json$Decode$succeed(1);
            case 'solution':
                return $elm$json$Json$Decode$succeed(2);
            default:
                var other = str;
                return $elm$json$Json$Decode$fail('Unknown product type: ' + other);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Marketplace$Product$Status$Beta = 4;
    var $author$project$Api$Common$Marketplace$Product$Status$ComingSoon = 3;
    var $author$project$Api$Common$Marketplace$Product$Status$Decommissioned = 8;
    var $author$project$Api$Common$Marketplace$Product$Status$Deprecated = 7;
    var $author$project$Api$Common$Marketplace$Product$Status$Hidden = 0;
    var $author$project$Api$Common$Marketplace$Product$Status$Live = 5;
    var $author$project$Api$Common$Marketplace$Product$Status$Researching = 2;
    var $author$project$Api$Common$Marketplace$Product$Status$Sunsetting = 6;
    var $author$project$Api$Common$Marketplace$Product$Status$Unpublished = 1;
    var $author$project$Api$Common$Marketplace$Product$Status$fromString = function(string) {
        switch(string){
            case 'hidden':
                return $elm$core$Maybe$Just(0);
            case 'unpublished':
                return $elm$core$Maybe$Just(1);
            case 'researching':
                return $elm$core$Maybe$Just(2);
            case 'coming_soon':
                return $elm$core$Maybe$Just(3);
            case 'beta':
                return $elm$core$Maybe$Just(4);
            case 'live':
                return $elm$core$Maybe$Just(5);
            case 'sunsetting':
                return $elm$core$Maybe$Just(6);
            case 'deprecated':
                return $elm$core$Maybe$Just(7);
            case 'decommissioned':
                return $elm$core$Maybe$Just(8);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$Marketplace$Product$Status$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        var _v0 = $author$project$Api$Common$Marketplace$Product$Status$fromString(string);
        if (!_v0.$) {
            var status = _v0.a;
            return $elm$json$Json$Decode$succeed(status);
        } else return $elm$json$Json$Decode$fail('Invalid status: ' + string);
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Marketplace$Product$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'categories', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Common$Marketplace$Product$ProductType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'featured', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'built_by_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'built_by_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'icon_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'summary', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'listing_status', $author$project$Api$Common$Marketplace$Product$Status$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'distribution_type', $author$project$Api$Common$Marketplace$Product$DistributionType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'slug', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Shared$Record))))))))))));
    var $author$project$Api$Common$Marketplace$Product$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$PartnerApp$Shared$PartnerApp = $elm$core$Basics$identity;
    var $author$project$Api$Common$PartnerApp$Shared$Record = F5(function(id, name, anchors, partner, partnerRoles) {
        return {
            Eg: anchors,
            aef: id,
            zr: name,
            VW: partner,
            V1: partnerRoles
        };
    });
    var $author$project$Api$Common$Partner$Min$Partner = $elm$core$Basics$identity;
    var $author$project$Api$Common$Partner$Min$Record = function(slug) {
        return {
            _A: slug
        };
    };
    var $author$project$Api$Common$Partner$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'slug', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Partner$Min$Record));
    var $author$project$Api$Common$Partner$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Partner$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$PartnerApp$Anchor$Anchor = $elm$core$Basics$identity;
    var $author$project$Api$Common$PartnerApp$Anchor$Record = F5(function(id, type_, corePageIconUrl, corePageIconLabel, settingsLabel) {
        return {
            Mc: corePageIconLabel,
            Md: corePageIconUrl,
            aef: id,
            Z0: settingsLabel,
            ah5: type_
        };
    });
    var $author$project$Api$Common$PartnerApp$Anchor$ClinicalInteraction = 1;
    var $author$project$Api$Common$PartnerApp$Anchor$CorePage = 0;
    var $author$project$Api$Common$PartnerApp$Anchor$Settings = 2;
    var $author$project$Api$Common$PartnerApp$Anchor$anchorTypeDecoder = A2($elm$json$Json$Decode$andThen, function(typeString) {
        switch(typeString){
            case 'core_page':
                return $elm$json$Json$Decode$succeed(0);
            case 'clinical_interaction':
                return $elm$json$Json$Decode$succeed(1);
            case 'settings':
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail('Unknown anchor type: ' + typeString);
        }
    }, A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
    var $author$project$Api$Common$PartnerApp$Anchor$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'settings_label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'core_page_icon_label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'core_page_icon_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$PartnerApp$Anchor$anchorTypeDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$PartnerApp$Anchor$Record)))))), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$PartnerApp$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_roles', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner', $author$project$Api$Common$Partner$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'anchors', $elm$json$Json$Decode$list($author$project$Api$Common$PartnerApp$Anchor$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$PartnerApp$Shared$Record))))));
    var $author$project$Api$Common$PartnerApp$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$PartnerApp$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Addon$Shared$Addon = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Addon$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Addon$Min$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_partner_app_role', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_grant_partner_app_access', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product', $author$project$Api$Common$Marketplace$Product$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_app', $elm$json$Json$Decode$nullable($author$project$Api$Common$PartnerApp$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'addon', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Addon$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'connection_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$One$Record)))))));
    var $author$project$Api$Provider$Integration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Partner$ForIntegrationOne$decoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$One$Integration))));
    var $author$project$Api$Provider$Integration$integrationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'integrations'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Integration$integrationPath = function(slugOrId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            slugOrId
        ]), $author$project$Api$Provider$Integration$integrationsPath);
    };
    var $author$project$Api$Provider$Integration$retrieve = F3(function(apiClient, slug, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Integration$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$integrationPath(slug)));
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var params = _v2.VU;
        return _Utils_Tuple2({
            bL: $elm$core$Maybe$Nothing,
            Ej: apiClient,
            dH: $elm$core$Maybe$Nothing,
            Rn: $author$project$Api$Data$Loading,
            c9: $elm$core$Maybe$Nothing,
            Z$: session
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Ports$Navigation$pushUrl($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Slug_String({
                _A: params._A
            }))),
            A3($author$project$Api$Provider$Integration$retrieve, apiClient, params._A, $author$project$Pages$Admin$Integrations$Slug_String$GotIntegration)
        ])));
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$ActivateHiConfirmClosed = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$DeactivateHiConfirmClosed = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit = {
        $: 9
    };
    var $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$PracticeUser$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$PracticeUser$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Admin$PartnerApp$Team$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg, $author$project$Components$ResourceFilter$PracticeUser$subscriptions(model.ep)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit)), model.A))
        ]));
    };
    var $author$project$Ui$Nav$GotUnderlinePosition = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ports$NavTabs$onNavTabActivePositionChange = _Platform_incomingPort('onNavTabActivePositionChange', A2($elm$json$Json$Decode$andThen, function(width) {
        return A2($elm$json$Json$Decode$andThen, function(navId) {
            return A2($elm$json$Json$Decode$andThen, function(left) {
                return $elm$json$Json$Decode$succeed({
                    aeL: left,
                    afb: navId,
                    aih: width
                });
            }, A2($elm$json$Json$Decode$field, 'left', $elm$json$Json$Decode$float));
        }, A2($elm$json$Json$Decode$field, 'navId', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float)));
    var $author$project$Ui$Nav$subscriptions = function(_v0) {
        var toMsg = _v0.ahX;
        return A2($elm$core$Platform$Sub$map, toMsg, $author$project$Ports$NavTabs$onNavTabActivePositionChange($author$project$Ui$Nav$GotUnderlinePosition));
    };
    var $author$project$Components$Admin$PartnerApp$Manage$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = model.co;
                if (!_v1.$) {
                    var partnerAppTeam = _v1.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg, $author$project$Components$Admin$PartnerApp$Team$subscriptions(partnerAppTeam));
                } else return $elm$core$Platform$Sub$none;
            }(),
            $author$project$Ui$Nav$subscriptions(model.nb)
        ]));
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Integrations$Slug_String$ActivateHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.bL))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Integrations$Slug_String$DeactivateHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.dH))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Admin$PartnerApp$Manage$subscriptions, model.c9)))
        ]));
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$Activated = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$Deactivated = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$PartnerActivated = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Integration$activate = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Integration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'activate'
        ]), $author$project$Api$Provider$Integration$integrationPath(id))));
    });
    var $author$project$Api$Provider$Partner$ForIntegrationOne$authType = function(_v0) {
        var record = _v0.b;
        return record.JO;
    };
    var $author$project$Api$Provider$Integration$One$authType = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$authType(partner);
    };
    var $author$project$Api$Provider$Integration$connect = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Integration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'connect'
        ]), $author$project$Api$Provider$Integration$integrationPath(id))));
    });
    var $author$project$Api$Provider$Integration$One$connectionUrl = function(_v0) {
        var record = _v0.c;
        return record.LZ;
    };
    var $author$project$Api$Provider$Integration$deactivate = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Integration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'deactivate'
        ]), $author$project$Api$Provider$Integration$integrationPath(id))));
    });
    var $author$project$Api$Provider$Integration$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Integration$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Integration$Shared$id(shared);
    };
    var $author$project$Components$Admin$PartnerApp$Manage$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$PartnerApp$Manage$NavMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Manage$Team = 0;
    var $author$project$Ui$Nav$Model = $elm$core$Basics$identity;
    var $author$project$Ports$NavTabs$navTabActiveChanged = _Platform_outgoingPort('navTabActiveChanged', $elm$json$Json$Encode$string);
    var $author$project$Ui$Nav$init = F2(function(navId, toMsg) {
        return _Utils_Tuple2({
            aef: navId,
            ahX: toMsg,
            HU: 0,
            HV: 0
        }, $author$project$Ports$NavTabs$navTabActiveChanged(navId));
    });
    var $author$project$Components$Admin$PartnerApp$Manage$PartnerAppSettingsMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Manage$SettingsModel = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Manage$TeamModel = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Settings$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$PartnerApp$Settings$MountSettingsSurface = 0;
    var $author$project$Api$Common$PartnerApp$Anchor$isSettings = function(_v0) {
        var record = _v0;
        var _v1 = record.ah5;
        if (_v1 === 2) return true;
        else return false;
    };
    var $author$project$Api$Common$PartnerApp$Shared$settingsAnchor = function(_v0) {
        var record = _v0;
        return A2($elm_community$list_extra$List$Extra$find, $author$project$Api$Common$PartnerApp$Anchor$isSettings, record.Eg);
    };
    var $author$project$Components$Admin$PartnerApp$Settings$init = function(partnerApp) {
        var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp);
        return _Utils_Tuple2({
            VY: partnerApp
        }, function() {
            if (!settingsAnchor.$) return A2($elm$core$Task$perform, function(_v1) {
                return 0;
            }, $elm$core$Process$sleep(1000));
            else return $elm$core$Platform$Cmd$none;
        }());
    };
    var $author$project$Components$Admin$PartnerApp$Team$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$PartnerApp$Team$GotTeamMembers = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Common$PartnerApp$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PartnerAppUser$All$PartnerAppUser = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PartnerAppUser$Shared$PartnerAppUser = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PartnerAppUser$Shared$Record = F3(function(id, email, partnerRoles) {
        return {
            OH: email,
            aef: id,
            V1: partnerRoles
        };
    });
    var $author$project$Api$Provider$PartnerAppUser$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_roles', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$Shared$Record))));
    var $author$project$Api$Provider$PartnerAppUser$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PartnerAppUser$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PartnerAppUser$All$Record = function(practiceUser) {
        return {
            W7: practiceUser
        };
    };
    var $author$project$Api$Provider$PracticeUser$Shared$PracticeUser = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeUser$Shared$Record = function(id) {
        return function(email) {
            return function(role) {
                return function(notificationsEnabled) {
                    return function(invitationPending) {
                        return function(isOwner) {
                            return function(isDestroyable) {
                                return function(restrictedByGroups) {
                                    return function(user) {
                                        return function(reportRestricted) {
                                            return {
                                                OH: email,
                                                aef: id,
                                                Ry: invitationPending,
                                                R1: isDestroyable,
                                                Sf: isOwner,
                                                U8: notificationsEnabled,
                                                YB: reportRestricted,
                                                YW: restrictedByGroups,
                                                ag_: role,
                                                aaX: user
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$User$One$User = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$User$One$Record = function(mfaStatus) {
        return {
            Ug: mfaStatus
        };
    };
    var $author$project$Api$Provider$User$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mfa_status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$User$One$Record));
    var $author$project$Api$Provider$User$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$User$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$User$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$User$One$User)));
    var $author$project$Api$Provider$PracticeUser$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'report_restricted', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'user', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'restricted_by_groups', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_owner', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_pending', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'notifications_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'role', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$Shared$Record)))))))))));
    var $author$project$Api$Provider$PracticeUser$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeUser$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PartnerAppUser$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_user', $author$project$Api$Provider$PracticeUser$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$All$Record));
    var $author$project$Api$Provider$PartnerAppUser$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PartnerAppUser$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PartnerAppUser$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PartnerAppUser$All$PartnerAppUser)));
    var $author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$PartnerApp$partnerAppsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner_apps'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PartnerApp$partnerAppPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$PartnerApp$partnerAppsPath);
    };
    var $author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath = function(partnerAppId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'team_members'
        ]), $author$project$Api$Provider$PartnerApp$partnerAppPath(partnerAppId));
    };
    var $author$project$Api$Provider$PartnerApp$TeamMember$list = F4(function(apiClient, partnerAppId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PartnerAppUser$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$PartnerApp$TeamMember$listOptionalsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId))));
    });
    var $author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$PartnerApp$TeamMember$list, apiClient, $author$project$Api$Common$PartnerApp$Shared$id(model.VY), function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Components$Admin$PartnerApp$Team$GotTeamMembers);
    });
    var $author$project$Api$Provider$TeamMember$Accepted = 0;
    var $author$project$Api$Provider$PracticeUser$All$PracticeUser = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PracticeUser$All$Record = F2(function(invitationUrl, locationGroups) {
        return {
            Rz: invitationUrl,
            Tl: locationGroups
        };
    });
    var $author$project$Api$Provider$LocationGroup$Min$LocationGroup = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LocationGroup$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$LocationGroup$Min$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticeUser$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location_groups', $elm$json$Json$Decode$list($author$project$Api$Provider$LocationGroup$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$All$Record)));
    var $author$project$Api$Provider$PracticeUser$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeUser$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeUser$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$All$PracticeUser)));
    var $author$project$Api$Provider$TeamMember$filterToString = function(filter) {
        return 'accepted';
    };
    var $author$project$Api$Provider$TeamMember$listOptionalsDefaults = {
        Fw: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$TeamMember$listOptionalsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$TeamMember$listOptionalsDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fw;
                if (!_v2.$) {
                    var filter = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', $author$project$Api$Provider$TeamMember$filterToString(filter))
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$TeamMember$teamMembersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'team_members'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$TeamMember$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PracticeUser$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$TeamMember$listOptionalsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
    });
    var $author$project$Components$ResourceFilter$PracticeUser$list = $author$project$Api$Provider$TeamMember$list;
    var $author$project$Components$ResourceFilter$PracticeUser$fetchResources = F5(function(listOptionals, toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$PracticeUser$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$PracticeUser$retrieveResource = F4(function(listOptionals, toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$PracticeUser$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$PracticeUser$selectId = 'practice-users';
    var $author$project$Api$Provider$PracticeUser$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$PracticeUser$All$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$email(shared);
    };
    var $author$project$Api$Provider$User$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$User$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$User$Shared$name(shared);
    };
    var $author$project$Api$Provider$PracticeUser$Shared$user = function(_v0) {
        var record = _v0;
        return record.aaX;
    };
    var $author$project$Api$Provider$PracticeUser$All$user = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$user(shared);
    };
    var $author$project$Components$ResourceFilter$PracticeUser$toTitle = function(resource) {
        var user = $author$project$Api$Provider$PracticeUser$All$user(resource);
        if (!user.$) {
            var user_ = user.a;
            return $author$project$Api$Provider$User$One$name(user_);
        } else return $author$project$Api$Provider$PracticeUser$All$email(resource);
    };
    var $author$project$Components$ResourceFilter$PracticeUser$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$PracticeUser$toTitle(resource))
        ]);
    };
    var $author$project$Api$Provider$PracticeUser$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PracticeUser$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$id(shared);
    };
    var $author$project$Components$ResourceFilter$PracticeUser$toValue = $author$project$Api$Provider$PracticeUser$All$id;
    var $author$project$Components$ResourceFilter$PracticeUser$init = F3(function(apiClient, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$PracticeUser$fetchResources(listOptionals),
            aef: $author$project$Components$ResourceFilter$PracticeUser$selectId,
            gD: 'User',
            sz: $author$project$Components$ResourceFilter$PracticeUser$retrieveResource(listOptionals),
            ahW: $author$project$Components$ResourceFilter$PracticeUser$toLabel,
            ahZ: $author$project$Components$ResourceFilter$PracticeUser$toTitle,
            g4: $author$project$Components$ResourceFilter$PracticeUser$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter = function(apiClient) {
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg), A3($author$project$Components$ResourceFilter$PracticeUser$init, apiClient, function(d) {
            return _Utils_update(d, {
                Fw: $elm$core$Maybe$Just(0)
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select A User',
                afn: false
            });
        }));
    };
    var $author$project$Api$Provider$Integration$One$autoGrantPartnerAppAccess = function(_v0) {
        var record = _v0.c;
        return record.abQ;
    };
    var $author$project$Api$Provider$Integration$One$defaultPartnerAppRole = function(_v0) {
        var record = _v0.c;
        return record.acZ;
    };
    var $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration = function(integration) {
        return {
            abQ: $author$project$Api$Provider$Integration$One$autoGrantPartnerAppAccess(integration),
            acZ: $author$project$Api$Provider$Integration$One$defaultPartnerAppRole(integration)
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$init = F4(function(apiClient, integration, partnerApp, currentUser) {
        var _v0 = $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter(apiClient);
        var practiceUserResourceFilter = _v0.a;
        var practiceUserResourceFilterCmd = _v0.b;
        var model = {
            E2: currentUser,
            lV: $elm$core$Maybe$Nothing,
            dZ: $elm$core$Set$empty,
            Rn: integration,
            af_: $author$project$Api$Pagination$init,
            VY: partnerApp,
            ep: practiceUserResourceFilter,
            agq: $elm$core$Maybe$Nothing,
            sG: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
            di: $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration(integration),
            og: $author$project$Api$Data$NotAsked,
            ahs: A3($author$project$Api$Sort$withDefault, 'user_first_name', 0, $author$project$Api$Sort$init),
            A: $elm$core$Maybe$Nothing,
            eO: $author$project$Api$Data$Loading
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model),
            practiceUserResourceFilterCmd
        ])));
    });
    var $author$project$Components$Admin$PartnerApp$Manage$initSectionModel = F5(function(apiClient, integration, partnerApp, currentUser, section) {
        if (!section) return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg), A2($elm$core$Tuple$mapFirst, $author$project$Components$Admin$PartnerApp$Manage$TeamModel, A4($author$project$Components$Admin$PartnerApp$Team$init, apiClient, integration, partnerApp, currentUser)));
        else return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Manage$PartnerAppSettingsMsg), A2($elm$core$Tuple$mapFirst, $author$project$Components$Admin$PartnerApp$Manage$SettingsModel, $author$project$Components$Admin$PartnerApp$Settings$init(partnerApp)));
    });
    var $author$project$Components$Admin$PartnerApp$Manage$init = F4(function(apiClient, integration, partnerApp, currentUser) {
        var _v0 = A5($author$project$Components$Admin$PartnerApp$Manage$initSectionModel, apiClient, integration, partnerApp, currentUser, 0);
        var section = _v0.a;
        var sectionCmd = _v0.b;
        var _v1 = A2($author$project$Ui$Nav$init, 'partner-app-manage-nav', $author$project$Components$Admin$PartnerApp$Manage$NavMsg);
        var nav = _v1.a;
        var navCmd = _v1.b;
        var model = {
            E2: currentUser,
            Rn: integration,
            nb: nav,
            VY: partnerApp,
            co: section
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            navCmd,
            sectionCmd
        ])));
    });
    var $author$project$Api$Provider$Partner$ForIntegrationOne$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Partner$Shared$name(shared);
    };
    var $author$project$Api$Provider$Integration$One$name = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$name(partner);
    };
    var $author$project$Api$Provider$Integration$One$partnerApp = function(_v0) {
        var record = _v0.c;
        return record.VY;
    };
    var $author$project$Api$Provider$Partner$ForIntegrationOne$postActivationRedirectUrl = function(_v0) {
        var record = _v0.b;
        return record.WY;
    };
    var $author$project$Api$Provider$Integration$One$postActivationRedirectUrl = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$postActivationRedirectUrl(partner);
    };
    var $author$project$Api$Provider$Integration$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Integration$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Integration$Shared$status(shared);
    };
    var $author$project$Ports$PartnerApps$partnerAppsMount = _Platform_outgoingPort('partnerAppsMount', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('appId', $elm$json$Json$Encode$string($.abN)),
            _Utils_Tuple2('id', $elm$json$Json$Encode$string($.aef)),
            _Utils_Tuple2('type_', $elm$json$Json$Encode$string($.ah5))
        ]));
    });
    var $author$project$Ports$PartnerApps$mount = F2(function(id, options) {
        return $author$project$Ports$PartnerApps$partnerAppsMount({
            abN: options.abN,
            aef: id,
            ah5: options.ah5
        });
    });
    var $author$project$Components$Admin$PartnerApp$Settings$update = F2(function(msg, _v0) {
        var model = _v0;
        return _Utils_Tuple3(model, A2($author$project$Ports$PartnerApps$mount, 'partner-app-settings', {
            abN: $author$project$Api$Common$PartnerApp$Shared$id(model.VY),
            ah5: 'settings'
        }), _List_Nil);
    });
    var $author$project$Components$Admin$PartnerApp$Team$IntegrationUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$PracticeUser = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$SearchInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$SettingsSaved = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$TeamMemberDeleted = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath = F2(function(partnerAppId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId));
    });
    var $author$project$Api$Provider$PartnerApp$TeamMember$delete = F4(function(apiClient, partnerAppId, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath, partnerAppId, id)));
    });
    var $author$project$Api$Provider$PartnerAppUser$Shared$partnerRoles = function(_v0) {
        var record = _v0;
        return record.V1;
    };
    var $author$project$Api$Provider$PartnerAppUser$All$partnerRoles = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PartnerAppUser$Shared$partnerRoles(shared);
    };
    var $author$project$Api$Provider$PartnerAppUser$All$practiceUser = function(_v0) {
        var record = _v0.b;
        return record.W7;
    };
    var $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromShared = function(practiceUser) {
        return {
            aef: $author$project$Api$Provider$PracticeUser$Shared$id(practiceUser)
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$formFieldsFromTeamMember = function(teamMember) {
        var practiceUser = $author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember);
        return {
            gk: $elm$core$List$head($author$project$Api$Provider$PartnerAppUser$All$partnerRoles(teamMember)),
            agh: _List_fromArray([
                $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromShared(practiceUser)
            ])
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$formFieldsInit = {
        gk: $elm$core$Maybe$Nothing,
        agh: _List_Nil
    };
    var $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var practiceUsers = field.a;
            return _Utils_update(fields, {
                agh: practiceUsers
            });
        } else {
            var string = field.a;
            return _Utils_update(fields, {
                gk: $author$project$Utils$String$toMaybe(string)
            });
        }
    });
    var $author$project$Components$Admin$PartnerApp$Team$PracticeUserValidation = 0;
    var $rtfeldman$elm_validate$Validate$ifEmptyList = F2(function(subjectToList, error) {
        return A2($rtfeldman$elm_validate$Validate$ifTrue, function(subject) {
            return $elm$core$List$isEmpty(subjectToList(subject));
        }, error);
    });
    var $author$project$Components$Admin$PartnerApp$Team$PartnerRoleValidation = 1;
    var $author$project$Api$Common$PartnerApp$Shared$partnerRoles = function(_v0) {
        var record = _v0;
        return record.V1;
    };
    var $author$project$Components$Admin$PartnerApp$Team$validatePartnerRole = F2(function(partnerApp, fields) {
        return $elm$core$List$isEmpty($author$project$Api$Common$PartnerApp$Shared$partnerRoles(partnerApp)) ? _List_Nil : _Utils_eq(fields.gk, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(1, 'Please pick a role.')
        ]) : _List_Nil;
    });
    var $author$project$Components$Admin$PartnerApp$Team$formFieldsValidator = function(partnerApp) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifEmptyList, function($) {
                return $.agh;
            }, _Utils_Tuple2(0, 'Please pick at least one user.')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$PartnerApp$Team$validatePartnerRole(partnerApp))
        ]));
    };
    var $author$project$Components$Admin$PartnerApp$Team$None = {
        $: 0
    };
    var $author$project$Components$Admin$PartnerApp$Team$noEvent = F3(function(m, c, o) {
        return {
            EQ: c,
            adu: $author$project$Components$Admin$PartnerApp$Team$None,
            zi: m,
            at: o
        };
    });
    var $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll = function(practiceUser) {
        return {
            aef: $author$project$Api$Provider$PracticeUser$All$id(practiceUser)
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$TeamMemberCreated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$PartnerAppUser$One$PartnerAppUser = 0;
    var $author$project$Api$Provider$PartnerAppUser$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$PartnerApp$TeamMember$bulkCreate = F4(function(apiClient, partnerAppId, fields, toMsg) {
        var encodeTeamMember = function(practiceUser) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('practice_user', $author$project$Utils$Encode$association(practiceUser)),
                _Utils_Tuple2('partner_roles', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.V1))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('team_members', A2($elm$json$Json$Encode$list, encodeTeamMember, fields.agh))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PartnerAppUser$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bulk_create'
        ]), $author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMembersPath(partnerAppId)))));
    });
    var $author$project$Components$Admin$PartnerApp$Team$createTeamMember = F3(function(apiClient, partnerApp, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$PartnerApp$TeamMember$bulkCreate, apiClient, $author$project$Api$Common$PartnerApp$Shared$id(partnerApp), {
            V1: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$singleton, fields.gk)),
            agh: A2($elm$core$List$map, function($) {
                return $.aef;
            }, fields.agh)
        }, $author$project$Components$Admin$PartnerApp$Team$TeamMemberCreated);
    });
    var $author$project$Components$Admin$PartnerApp$Team$TeamMemberUpdated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$PartnerApp$TeamMember$update = F5(function(apiClient, partnerAppId, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('team_member', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('partner_roles', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.V1))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$PartnerAppUser$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$PartnerApp$TeamMember$partnerAppTeamMemberPath, partnerAppId, id_))));
    });
    var $author$project$Components$Admin$PartnerApp$Team$updateTeamMember = F4(function(apiClient, partnerApp, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A5($author$project$Api$Provider$PartnerApp$TeamMember$update, apiClient, $author$project$Api$Common$PartnerApp$Shared$id(partnerApp), id, {
            V1: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$singleton, fields.gk))
        }, $author$project$Components$Admin$PartnerApp$Team$TeamMemberUpdated);
    });
    var $author$project$Components$Admin$PartnerApp$Team$saveTeamMember = F4(function(apiClient, partnerApp, maybeId, formFields) {
        if (!maybeId.$) {
            var id = maybeId.a;
            return A4($author$project$Components$Admin$PartnerApp$Team$updateTeamMember, apiClient, partnerApp, id, formFields);
        } else return A3($author$project$Components$Admin$PartnerApp$Team$createTeamMember, apiClient, partnerApp, formFields);
    });
    var $author$project$Components$Admin$PartnerApp$Team$setAutoGrant = F2(function(value, form) {
        return _Utils_update(form, {
            abQ: value
        });
    });
    var $author$project$Components$Admin$PartnerApp$Team$setDefaultRole = F2(function(value, form) {
        return _Utils_update(form, {
            acZ: value
        });
    });
    var $author$project$Api$Provider$Integration$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('integration', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('auto_grant_partner_app_access', $elm$json$Json$Encode$bool(fields.abQ)),
                _Utils_Tuple2('default_partner_app_role', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.acZ))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Integration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$integrationPath(id))));
    });
    var $author$project$Components$ResourceFilter$PracticeUser$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Admin$PartnerApp$Team$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        eO: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs),
                    eO: $author$project$Api$Data$Loading
                });
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, newModel, A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, newModel), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    eO: $author$project$Api$Data$Loading
                });
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, newModel, A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, newModel), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v3.a;
                var searchInputCmd = _v3.b;
                var searchInputEvent = _v3.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v4 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q,
                            eO: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple2(qModel, A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, qModel));
                    }
                }();
                var newModel = _v4.a;
                var cmd = _v4.b;
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 4:
                var _v6 = $author$project$Components$Admin$PartnerApp$Team$initPracticeUserResourceFilter(apiClient);
                var practiceUserResourceFilter = _v6.a;
                var practiceUserResourceFilterCmd = _v6.b;
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    ep: practiceUserResourceFilter,
                    A: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Admin$PartnerApp$Team$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), practiceUserResourceFilterCmd, _List_Nil);
            case 5:
                var field = msg.a;
                var _v7 = model.A;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var teamMember = _v8.a;
                    var form = _v8.b;
                    var request = _v8.c;
                    return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, A3($author$project$Utils$Form$update, $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate, field, form), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var form = msg.a;
                var teamMember = msg.b;
                var id = msg.c;
                var _v9 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$PartnerApp$Team$formFieldsValidator(model.VY), form);
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var newForm = _v10.a;
                    var validFormFields = _v10.b;
                    return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
                    }), A4($author$project$Components$Admin$PartnerApp$Team$saveTeamMember, apiClient, model.VY, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v9.a;
                    return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 7:
                var response = msg.a;
                var _v11 = model.A;
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var teamMember = _v12.a;
                    var form = _v12.b;
                    if (response.$ === 3) return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        A: $elm$core$Maybe$Nothing
                    }), A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
                    ]));
                    else return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var teamMember = msg.a;
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    A: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(teamMember), $author$project$Utils$Form$init($author$project$Components$Admin$PartnerApp$Team$formFieldsFromTeamMember(teamMember)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    A: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var response = msg.a;
                var _v14 = model.A;
                if (!_v14.$) {
                    var _v15 = _v14.a;
                    var id = _v15.a;
                    var form = _v15.b;
                    if (response.$ === 3) return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        A: $elm$core$Maybe$Nothing
                    }), A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
                    ]));
                    else return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var teamMember = msg.a;
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    lV: $elm$core$Maybe$Just(teamMember)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    lV: $elm$core$Maybe$Nothing,
                    dZ: A2($elm$core$Set$insert, id, model.dZ)
                }), A4($author$project$Api$Provider$PartnerApp$TeamMember$delete, apiClient, $author$project$Api$Common$PartnerApp$Shared$id(model.VY), id, $author$project$Components$Admin$PartnerApp$Team$TeamMemberDeleted(id)), _List_Nil) : A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    lV: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                            dZ: A2($elm$core$Set$remove, id, model.dZ),
                            eO: $author$project$Api$Data$Loading
                        }), A2($author$project$Components$Admin$PartnerApp$Team$fetchTeamMembers, apiClient, model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
                        ]));
                    case 2:
                        return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                            dZ: A2($elm$core$Set$remove, id, model.dZ)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 14:
                var subMsg = msg.a;
                var practiceUserResourceResult = A3($author$project$Components$ResourceFilter$PracticeUser$update, apiClient, subMsg, model.ep);
                var _v18 = model.A;
                if (!_v18.$) {
                    var _v19 = _v18.a;
                    var id = _v19.a;
                    var form = _v19.b;
                    var request = _v19.c;
                    var newForm = function() {
                        var _v20 = practiceUserResourceResult.adu;
                        if (!_v20.$) {
                            if (!_v20.a.$) switch(_v20.a.a.$){
                                case 2:
                                    var _v21 = _v20.a.a;
                                    return A3($author$project$Utils$Form$update, $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate, $author$project$Components$Admin$PartnerApp$Team$PracticeUser(_List_Nil), form);
                                case 0:
                                    var practiceUser = _v20.a.a.a;
                                    return A3($author$project$Utils$Form$update, $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate, $author$project$Components$Admin$PartnerApp$Team$PracticeUser(_List_fromArray([
                                        $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll(practiceUser)
                                    ])), form);
                                case 1:
                                    var practiceUsers = _v20.a.a.a;
                                    return A3($author$project$Utils$Form$update, $author$project$Components$Admin$PartnerApp$Team$formFieldsUpdate, $author$project$Components$Admin$PartnerApp$Team$PracticeUser(A2($elm$core$List$map, $author$project$Components$Admin$PartnerApp$Team$practiceUserRecordFromAll, practiceUsers)), form);
                                default:
                                    return form;
                            }
                            else {
                                var _v22 = _v20.a;
                                return form;
                            }
                        } else return form;
                    }();
                    return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                        ep: practiceUserResourceResult.zi,
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, request))
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg, practiceUserResourceResult.EQ), _List_Nil);
                } else return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    ep: practiceUserResourceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg, practiceUserResourceResult.EQ), _List_Nil);
            case 15:
                var value = msg.a;
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    di: A2($author$project$Components$Admin$PartnerApp$Team$setAutoGrant, value, model.di)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var value = msg.a;
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    di: A2($author$project$Components$Admin$PartnerApp$Team$setDefaultRole, $author$project$Utils$String$toMaybe(value), model.di)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    og: $author$project$Api$Data$Loading
                }), A4($author$project$Api$Provider$Integration$update, apiClient, $author$project$Api$Provider$Integration$One$id(model.Rn), model.di, $author$project$Components$Admin$PartnerApp$Team$SettingsSaved), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var integration = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$PartnerApp$Team$IntegrationUpdated(integration),
                        zi: _Utils_update(model, {
                            Rn: integration,
                            di: $author$project$Components$Admin$PartnerApp$Team$settingsFormFromIntegration(integration),
                            og: $author$project$Api$Data$NotAsked
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Settings saved')
                        ])
                    };
                } else return A3($author$project$Components$Admin$PartnerApp$Team$noEvent, _Utils_update(model, {
                    og: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Ui$Nav$update = F2(function(msg, _v0) {
        var model = _v0;
        if (msg.$ === 1) {
            var navId = msg.a.afb;
            var width = msg.a.aih;
            var left = msg.a.aeL;
            return _Utils_eq(navId, model.aef) ? _Utils_Tuple2(_Utils_update(model, {
                HU: left,
                HV: width
            }), $elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(model, $author$project$Ports$NavTabs$navTabActiveChanged(model.aef));
    });
    var $author$project$Components$Admin$PartnerApp$Manage$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v2 = model.co;
                if (!_v2.$) {
                    var partnerAppTeam = _v2.a;
                    var result = A3($author$project$Components$Admin$PartnerApp$Team$update, apiClient, subMsg, partnerAppTeam);
                    var integration = function() {
                        var _v3 = result.adu;
                        if (_v3.$ === 1) {
                            var updated = _v3.a;
                            return updated;
                        } else return model.Rn;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        Rn: integration,
                        co: $author$project$Components$Admin$PartnerApp$Manage$TeamModel(result.zi)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg, result.EQ), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v4 = model.co;
                if (_v4.$ === 1) {
                    var partnerAppSettings = _v4.a;
                    var _v5 = A2($author$project$Components$Admin$PartnerApp$Settings$update, subMsg, partnerAppSettings);
                    var partnerAppSettings_ = _v5.a;
                    var partnerAppSettingsCmd = _v5.b;
                    var partnerAppSettingsOutMsgs = _v5.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        co: $author$project$Components$Admin$PartnerApp$Manage$SettingsModel(partnerAppSettings_)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PartnerApp$Manage$PartnerAppSettingsMsg, partnerAppSettingsCmd), partnerAppSettingsOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var navMsg = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Admin$PartnerApp$Manage$NavMsg), A2($elm$core$Tuple$mapFirst, function(newNav) {
                    return _Utils_update(model, {
                        nb: newNav
                    });
                }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
            default:
                var section = msg.a;
                var _v6 = A5($author$project$Components$Admin$PartnerApp$Manage$initSectionModel, apiClient, model.Rn, model.VY, model.E2, section);
                var sectionModel = _v6.a;
                var sectionCmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    co: sectionModel
                }), sectionCmd, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var integration = response.a;
                    var _v2 = function() {
                        var _v3 = _Utils_Tuple2($author$project$Api$Provider$Integration$One$status(integration), $author$project$Api$Provider$Integration$One$partnerApp(integration));
                        if (_v3.a === 'active' && !_v3.b.$) {
                            var partnerApp = _v3.b.a;
                            return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Components$Admin$PartnerApp$Manage$init, model.Ej, integration, partnerApp, $author$project$Api$Platform$Session$One$user(model.Z$))));
                        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                    }();
                    var partnerAppManage = _v2.a;
                    var partnerAppManageCmd = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Rn: response,
                        c9: partnerAppManage
                    }), partnerAppManageCmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Rn: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var integration = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    bL: $elm$core$Maybe$Just(_Utils_Tuple2(integration, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var integration = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    bL: $elm$core$Maybe$Just(_Utils_Tuple2(integration, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$Integration$activate, model.Ej, $author$project$Api$Provider$Integration$One$id(integration), $author$project$Pages$Admin$Integrations$Slug_String$Activated(integration)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    bL: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var integration = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var integration_ = response.a;
                    var activatingIntegration = $author$project$Api$Provider$Integration$One$authType(integration_) === 'automatic_headless' ? $elm$core$Maybe$Just(_Utils_Tuple2(integration_, response)) : $elm$core$Maybe$Nothing;
                    var _v5 = function() {
                        var _v6 = _Utils_Tuple2($author$project$Api$Provider$Integration$One$status(integration_), $author$project$Api$Provider$Integration$One$partnerApp(integration_));
                        if (_v6.a === 'active' && !_v6.b.$) {
                            var partnerApp = _v6.b.a;
                            return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Components$Admin$PartnerApp$Manage$init, model.Ej, integration_, partnerApp, $author$project$Api$Platform$Session$One$user(model.Z$))));
                        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                    }();
                    var partnerAppManage = _v5.a;
                    var partnerAppManageCmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bL: activatingIntegration,
                        Rn: response,
                        c9: partnerAppManage
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        partnerAppManageCmd,
                        function() {
                            var _v7 = _Utils_Tuple2($author$project$Api$Provider$Integration$One$authType(integration_), $author$project$Api$Provider$Integration$One$connectionUrl(integration_));
                            _v7$2: while(true)switch(_v7.a){
                                case 'automatic_redirect':
                                    if (!_v7.b.$) {
                                        var connectionUrl = _v7.b.a;
                                        return $author$project$Ports$Navigation$openInNewWindow(connectionUrl);
                                    } else break _v7$2;
                                case 'automatic_headless':
                                    return A3($author$project$Api$Provider$Integration$connect, model.Ej, $author$project$Api$Provider$Integration$One$id(integration_), $author$project$Pages$Admin$Integrations$Slug_String$PartnerActivated(integration_));
                                default:
                                    break _v7$2;
                            }
                            return $elm$core$Platform$Cmd$none;
                        }()
                    ])), $author$project$Api$Provider$Integration$One$authType(integration_) === 'automatic_headless' ? _List_Nil : _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Integration$One$name(integration) + ' activated')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    bL: $elm$core$Maybe$Just(_Utils_Tuple2(integration, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var integration = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bL: $elm$core$Maybe$Nothing,
                    Rn: response
                }), function() {
                    var _v9 = _Utils_Tuple2($author$project$Api$Provider$Integration$One$authType(integration), $author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
                    if (_v9.a === 'automatic_headless' && !_v9.b.$) {
                        var postActivationRedirectUrl = _v9.b.a;
                        return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
                    } else return $elm$core$Platform$Cmd$none;
                }(), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Integration$One$name(integration) + ' activated')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    bL: $elm$core$Maybe$Just(_Utils_Tuple2(integration, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var integration = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    dH: $elm$core$Maybe$Just(_Utils_Tuple2(integration, $author$project$Api$Data$NotAsked)),
                    c9: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var integration = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    dH: $elm$core$Maybe$Just(_Utils_Tuple2(integration, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$Integration$deactivate, model.Ej, $author$project$Api$Provider$Integration$One$id(integration), $author$project$Pages$Admin$Integrations$Slug_String$Deactivated(integration)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    dH: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var integration = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    dH: $elm$core$Maybe$Nothing,
                    Rn: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Integration$One$name(integration) + ' deactivated')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    dH: $elm$core$Maybe$Just(_Utils_Tuple2(integration, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v11 = model.c9;
                if (!_v11.$) {
                    var partnerAppManage = _v11.a;
                    var _v12 = A3($author$project$Components$Admin$PartnerApp$Manage$update, model.Ej, subMsg, partnerAppManage);
                    var partnerAppManage_ = _v12.a;
                    var partnerAppManageCmd = _v12.b;
                    var partnerAppManageOutMsgs = _v12.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        c9: $elm$core$Maybe$Just(partnerAppManage_)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg, partnerAppManageCmd), partnerAppManageOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate = function(integration) {
        return $author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_redirect' || $author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless';
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$disclaimerMessage = function(integration) {
        var name = $author$project$Api$Provider$Integration$One$name(integration);
        var message = _List_fromArray([
            $elm$html$Html$text('We provide this integration only as a convenience to you. '),
            $elm$html$Html$text(name),
            $elm$html$Html$text(' is solely responsible for its service, content and policies, including those related to privacy and security. Please review '),
            $elm$html$Html$text(name),
            $elm$html$Html$text("\u2019s Terms of Service, and Privacy Policy to ensure they meet your business and legal requirements.")
        ]);
        return $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration) ? A2($elm$core$List$cons, $elm$html$Html$text('You are about to be redirected to '), A2($elm$core$List$cons, $elm$html$Html$text(name), A2($elm$core$List$cons, $elm$html$Html$text("\u2019s login page. Sign in with your "), A2($elm$core$List$cons, $elm$html$Html$text(name), A2($elm$core$List$cons, $elm$html$Html$text(' credentials, and they should provide you with next steps, if any.'), A2($elm$core$List$cons, A2($elm$html$Html$br, _List_Nil, _List_Nil), A2($elm$core$List$cons, A2($elm$html$Html$br, _List_Nil, _List_Nil), message))))))) : message;
    };
    var $author$project$Components$Admin$PartnerApp$Team$DeleteConfirmClosed = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PartnerAppUser$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$PartnerAppUser$All$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PartnerAppUser$Shared$email(shared);
    };
    var $author$project$Api$Provider$PartnerAppUser$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PartnerAppUser$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PartnerAppUser$Shared$id(shared);
    };
    var $author$project$Components$Admin$PartnerApp$Team$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$PartnerRole = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$SaveTeamMember = F3(function(a, b, c) {
        return {
            $: 6,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$ResourceFilter$Multi = {
        $: 6
    };
    var $author$project$Components$ResourceFilter$multi = $author$project$Components$ResourceFilter$Multi;
    var $author$project$Components$Admin$PartnerApp$Team$roleOptions = F2(function(emptyLabel, roles) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, emptyLabel), A2($elm$core$List$map, function(role) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(role), $author$project$Formatters$String$titleize($author$project$Formatters$String$humanize(role)));
        }, roles));
    });
    var $author$project$Components$ResourceFilter$PracticeUser$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Ui$Margin$Bottom_0_25 = 1;
    var $author$project$Ui$Button$mb2 = $author$project$Ui$Button$Margin(1);
    var $author$project$Ui$Icon$SpacedLeft = {
        $: 3
    };
    var $author$project$Ui$Icon$spacedLeft = $author$project$Ui$Icon$SpacedLeft;
    var $author$project$Components$ResourceFilter$viewMultiSelected_ = F2(function(model, items) {
        return A2($elm$core$List$map, function(item) {
            return A3($author$project$Ui$Button$view, {
                abP: 'Remove selection'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$ResourceFilter$DropdownItemChecked(A2($author$project$Components$ResourceFilter$toggleItemSelection, $author$project$Components$ResourceFilter$Many(items), item))),
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$mb2
            ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), _List_fromArray([
                $elm$html$Html$text(model.ahZ(item)),
                $author$project$Ui$Icon$cross(_List_fromArray([
                    $author$project$Ui$Icon$xs,
                    $author$project$Ui$Icon$spacedLeft
                ]))
            ])));
        }, items);
    });
    var $author$project$Components$ResourceFilter$viewMultiSelected = F2(function(choice, model) {
        switch(choice.$){
            case 3:
                return _List_fromArray([
                    $elm$html$Html$text('No ' + model.gD),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Remove selection'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$ResourceFilter$DropdownItemChecked($author$project$Components$ResourceFilter$All)),
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$mb2
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$cross(_List_fromArray([
                            $author$project$Ui$Icon$xs,
                            $author$project$Ui$Icon$spacedLeft
                        ]))
                    ]))
                ]);
            case 2:
                return _List_Nil;
            case 4:
                return _List_Nil;
            case 0:
                var item = choice.a;
                return A2($author$project$Components$ResourceFilter$viewMultiSelected_, model, _List_fromArray([
                    item
                ]));
            case 5:
                return _List_Nil;
            default:
                var items = choice.a;
                return A2($author$project$Components$ResourceFilter$viewMultiSelected_, model, items);
        }
    });
    var $author$project$Components$ResourceFilter$PracticeUser$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$Admin$PartnerApp$Team$viewTeamMemberModal = F4(function(model, teamMember, request, form) {
        var partnerRoles = $author$project$Api$Common$PartnerApp$Shared$partnerRoles(model.VY);
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Team Member',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: A2($elm$core$Maybe$map, $author$project$Api$Provider$PartnerAppUser$All$id, teamMember),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Admin$PartnerApp$Team$CancelTeamMemberEdit,
            Vn: A2($author$project$Components$Admin$PartnerApp$Team$SaveTeamMember, form, teamMember)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('User'),
                $author$project$Ui$Form$Group$required(_Utils_eq(teamMember, $elm$core$Maybe$Nothing))
            ]), _List_fromArray([
                function() {
                    if (!teamMember.$) {
                        var teamMember_ = teamMember.a;
                        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$User$One$name, $author$project$Api$Provider$PracticeUser$Shared$user($author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember_)))))
                        ]));
                    } else return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A2($elm$html$Html$map, $author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg, A2($author$project$Components$ResourceFilter$PracticeUser$view, _List_fromArray([
                        $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                        $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, form)),
                        $author$project$Components$ResourceFilter$multi
                    ]), model.ep)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Admin$PartnerApp$Team$PracticeUserResourceFilterMsg), $author$project$Components$ResourceFilter$PracticeUser$viewMultiSelected(model.ep))));
                }(),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ])),
            function() {
                if ($elm$core$List$isEmpty(partnerRoles)) return $author$project$Utils$Html$empty;
                else {
                    var fields = $author$project$Utils$Form$fields(form);
                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$required(true),
                        $author$project$Ui$Form$Group$label('Role')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value(fields.gk),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$PartnerApp$Team$FormUpdated, $author$project$Components$Admin$PartnerApp$Team$PartnerRole)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                            $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                        ]), A2($author$project$Components$Admin$PartnerApp$Team$roleOptions, 'Pick a role', $author$project$Api$Common$PartnerApp$Shared$partnerRoles(model.VY)))
                    ]));
                }
            }()
        ]));
    });
    var $author$project$Components$Admin$PartnerApp$Team$modal = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            function() {
                var _v1 = model.A;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var teamMember = _v2.a;
                    var form = _v2.b;
                    var request = _v2.c;
                    return A4($author$project$Components$Admin$PartnerApp$Team$viewTeamMemberModal, model, teamMember, request, form);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.lV;
                if (!_v3.$) {
                    var teamMember = _v3.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Admin$PartnerApp$Team$DeleteConfirmClosed($author$project$Api$Provider$PartnerAppUser$All$id(teamMember)), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('remove'),
                        $author$project$Components$HiConfirm$noun('team member'),
                        $author$project$Components$HiConfirm$detail($author$project$Api$Provider$PartnerAppUser$All$email(teamMember))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]);
    };
    var $author$project$Components$Admin$PartnerApp$Manage$modal = function(_v0) {
        var model = _v0;
        var _v1 = model.co;
        if (!_v1.$) {
            var partnerAppTeam = _v1.a;
            return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg), $author$project$Components$Admin$PartnerApp$Team$modal(partnerAppTeam)));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$Activate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$Deactivate = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Partner$ForIntegrationOne$active = function(_v0) {
        var record = _v0.b;
        return record.Ir;
    };
    var $author$project$Api$Provider$Integration$One$active = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$active(partner);
    };
    var $author$project$Api$Provider$Integration$One$addon = function(_v0) {
        var record = _v0.c;
        return record.IF;
    };
    var $author$project$Api$Provider$Integration$Shared$authorizationCode = function(_v0) {
        var record = _v0;
        return record.JS;
    };
    var $author$project$Api$Provider$Integration$One$authorizationCode = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Integration$Shared$authorizationCode(shared);
    };
    var $author$project$Ui$Typography$AuthorizationCode = {
        $: 21
    };
    var $author$project$Ui$Typography$authorizationCode = $author$project$Ui$Typography$AuthorizationCode;
    var $author$project$Api$Provider$Partner$ForIntegrationOne$email = function(_v0) {
        var record = _v0.b;
        return record.OH;
    };
    var $author$project$Api$Provider$Integration$One$email = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$email(partner);
    };
    var $author$project$Api$Provider$Partner$ForIntegrationOne$integrationDescription = function(_v0) {
        var record = _v0.b;
        return record.Ro;
    };
    var $author$project$Api$Provider$Integration$One$integrationDescription = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$integrationDescription(partner);
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$isZion = function(integration) {
        return $author$project$Api$Provider$Integration$One$name(integration) === 'Zion Health';
    };
    var $author$project$Api$Provider$Partner$Shared$logoUrl = function(_v0) {
        var record = _v0;
        return record.Tu;
    };
    var $author$project$Api$Provider$Partner$ForIntegrationOne$logoUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Partner$Shared$logoUrl(shared);
    };
    var $author$project$Api$Provider$Integration$One$logoUrl = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$logoUrl(partner);
    };
    var $author$project$Api$Provider$Partner$ForIntegrationOne$marketingUrl = function(_v0) {
        var record = _v0.b;
        return record.TH;
    };
    var $author$project$Api$Provider$Integration$One$marketingUrl = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$marketingUrl(partner);
    };
    var $author$project$Api$Provider$Partner$ForIntegrationOne$productDescription = function(_v0) {
        var record = _v0.b;
        return record.Xz;
    };
    var $author$project$Api$Provider$Integration$One$productDescription = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$productDescription(partner);
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$showIntegrateButton = function(integration) {
        return $author$project$Api$Provider$Integration$One$status(integration) === 'inactive' && $author$project$Api$Provider$Integration$One$active(integration) && $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration);
    };
    var $author$project$Api$Provider$Partner$ForIntegrationOne$signupUrl = function(_v0) {
        var record = _v0.b;
        return record._u;
    };
    var $author$project$Api$Provider$Integration$One$signupUrl = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$signupUrl(partner);
    };
    var $author$project$Api$Provider$Partner$ForIntegrationOne$supportUrl = function(_v0) {
        var record = _v0.b;
        return record.$y;
    };
    var $author$project$Api$Provider$Integration$One$supportUrl = function(_v0) {
        var partner = _v0.b;
        return $author$project$Api$Provider$Partner$ForIntegrationOne$supportUrl(partner);
    };
    var $author$project$Api$Provider$Addon$Min$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Api$Provider$Addon$Shared$url = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Addon$Min$url(min);
    };
    var $author$project$Components$Admin$PartnerApp$Manage$Settings = 1;
    var $author$project$Components$Admin$PartnerApp$Manage$sections = function(partnerApp) {
        return A2($elm$core$List$cons, 0, !_Utils_eq($author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp), $elm$core$Maybe$Nothing) ? _List_fromArray([
            1
        ]) : _List_Nil);
    };
    var $author$project$Components$Admin$PartnerApp$Manage$SectionChanged = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Nav$Active = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Nav$activeItem = $author$project$Ui$Nav$Active;
    var $author$project$Ui$Nav$Item = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Nav$item = $author$project$Ui$Nav$Item;
    var $author$project$Ui$Nav$OnClick = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Nav$onItemClick = $author$project$Ui$Nav$OnClick;
    var $author$project$Api$Common$PartnerApp$Anchor$settingsLabel = function(_v0) {
        var record = _v0;
        var _v1 = record.ah5;
        switch(_v1){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                return record.Z0;
        }
    };
    var $author$project$Components$Admin$PartnerApp$Manage$sectionName = F2(function(partnerApp, section) {
        if (!section) return 'Manage User Access';
        else return A2($elm$core$Maybe$withDefault, 'Settings', A2($elm$core$Maybe$andThen, $author$project$Api$Common$PartnerApp$Anchor$settingsLabel, $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp)));
    });
    var $author$project$Components$Admin$PartnerApp$Manage$sectionsToNavItem = F3(function(partnerApp, currentSection, section) {
        var isActive = function() {
            var _v0 = _Utils_Tuple2(currentSection, section);
            _v0$2: while(true)if (!_v0.a.$) {
                if (!_v0.b) {
                    var _v1 = _v0.b;
                    return true;
                } else break _v0$2;
            } else {
                if (_v0.b === 1) {
                    var _v2 = _v0.b;
                    return true;
                } else break _v0$2;
            }
            return false;
        }();
        return A2($author$project$Ui$Nav$item, _List_fromArray([
            $author$project$Ui$Nav$activeItem(isActive),
            $author$project$Ui$Nav$onItemClick($author$project$Components$Admin$PartnerApp$Manage$SectionChanged(section))
        ]), _List_fromArray([
            $elm$html$Html$text(A2($author$project$Components$Admin$PartnerApp$Manage$sectionName, partnerApp, section))
        ]));
    });
    var $author$project$Components$Admin$PartnerApp$Settings$view = function(_v0) {
        var model = _v0;
        var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(model.VY);
        if (!settingsAnchor.$) return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('partner-app-settings-wrapper'),
            $elm$html$Html$Attributes$id('partner-app-settings')
        ]), _List_Nil);
        else return $elm$html$Html$text('');
    };
    var $author$project$Components$Admin$PartnerApp$Team$AddTeamMember = {
        $: 4
    };
    var $author$project$Components$Admin$PartnerApp$Team$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$SortTable = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$columns = function(partnerApp) {
        return A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'email', false, 'Email'), $elm$core$List$isEmpty($author$project$Api$Common$PartnerApp$Shared$partnerRoles(partnerApp)) ? _List_Nil : _List_fromArray([
            A3($author$project$Api$Column$init, 'custom_partner_role', false, 'Partner Role')
        ])));
    };
    var $author$project$Components$Admin$PartnerApp$Team$AutoGrantChanged = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$DefaultRoleChanged = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Admin$PartnerApp$Team$SaveSettings = {
        $: 17
    };
    var $author$project$Components$Admin$PartnerApp$Team$viewSettings = function(model) {
        var settingsLoading = _Utils_eq(model.og, $author$project$Api$Data$Loading);
        var partnerRoles = $author$project$Api$Common$PartnerApp$Shared$partnerRoles(model.VY);
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Access Settings')
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(6),
                    $author$project$Ui$Form$Group$inputSpan(6),
                    $author$project$Ui$Form$Group$label('Automatically grant access to new team members')
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(model.di.abQ),
                        $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$PartnerApp$Team$AutoGrantChanged)
                    ]))
                ])),
                $elm$core$List$isEmpty(partnerRoles) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(6),
                    $author$project$Ui$Form$Group$inputSpan(6),
                    $author$project$Ui$Form$Group$label('Default role for new team members')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value(model.di.acZ),
                        $author$project$Ui$Form$Select$onChange($author$project$Components$Admin$PartnerApp$Team$DefaultRoleChanged)
                    ]), A2($author$project$Components$Admin$PartnerApp$Team$roleOptions, 'No default role', partnerRoles))
                ]))
            ])),
            A2($author$project$Ui$Panel$footer, _List_fromArray([
                $author$project$Ui$Element$justifyCenter
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Save access settings'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(settingsLoading),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$PartnerApp$Team$SaveSettings)
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$PartnerApp$Team$EditTeamMember = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Table$Info = 2;
    var $author$project$Ui$Padding$Left_2 = 3;
    var $author$project$Components$Admin$PartnerApp$Team$OpenDeleteConfirm = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Platform$User$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Ui$Table$Styled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Table$styled = $author$project$Ui$Table$Styled;
    var $author$project$Components$Admin$PartnerApp$Team$viewTeamMember = F4(function(currentUser, partnerApp, deletingTeamMembers, teamMember) {
        var isCurrentUser = _Utils_eq($author$project$Api$Provider$PartnerAppUser$All$email(teamMember), $author$project$Api$Platform$User$Shared$email(currentUser));
        var rowOptions = isCurrentUser ? _List_fromArray([
            $author$project$Ui$Table$styled(2)
        ]) : _List_Nil;
        var id = $author$project$Api$Provider$PartnerAppUser$All$id(teamMember);
        var loading = A2($elm$core$Set$member, id, deletingTeamMembers);
        return A2($author$project$Ui$Table$row, rowOptions, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$User$One$name, $author$project$Api$Provider$PracticeUser$Shared$user($author$project$Api$Provider$PartnerAppUser$All$practiceUser(teamMember)))))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$PartnerAppUser$All$email(teamMember))
                ]))
            ]),
            $elm$core$List$isEmpty($author$project$Api$Common$PartnerApp$Shared$partnerRoles(partnerApp)) ? _List_Nil : _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize), $elm$core$List$head($author$project$Api$Provider$PartnerAppUser$All$partnerRoles(teamMember)))))
                ]))
            ]),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$textRight
                ]), _List_fromArray([
                    $elm$core$List$isEmpty($author$project$Api$Common$PartnerApp$Shared$partnerRoles(partnerApp)) ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                        abP: 'Edit team member'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$disabled(loading || !$author$project$Api$Platform$User$Shared$isAdmin(currentUser)),
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$PartnerApp$Team$EditTeamMember(teamMember)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete team member'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$PartnerApp$Team$OpenDeleteConfirm(teamMember)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                        $author$project$Ui$Button$padding(3)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ])
        ])));
    });
    var $author$project$Components$Admin$PartnerApp$Team$view = function(_v0) {
        var model = _v0;
        var _v1 = function() {
            var _v2 = model.eO;
            if (_v2.$ === 3) {
                var teamMembers_ = _v2.a;
                return _Utils_Tuple2(false, teamMembers_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v1.a;
        var teamMembers = _v1.b;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Admin$PartnerApp$Team$viewSettings(model),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$fullWidth
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Admin$PartnerApp$Team$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add user'
                        }, _List_fromArray([
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$PartnerApp$Team$AddTeamMember)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add User')
                        ]))
                    ]))
                ])),
                A4($author$project$Ui$Panel$table, _List_fromArray([
                    $author$project$Ui$Table$verticalCentered,
                    $author$project$Ui$Table$zeroState(_List_fromArray([
                        $elm$html$Html$text('No users are allowed to access this integration.')
                    ])),
                    $author$project$Ui$Table$loading(loading)
                ]), $elm$core$List$concat(_List_fromArray([
                    A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Admin$PartnerApp$Team$SortTable)), $author$project$Components$Admin$PartnerApp$Team$columns(model.VY)),
                    _List_fromArray([
                        A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                    ])
                ])), A2($elm$core$List$map, A3($author$project$Components$Admin$PartnerApp$Team$viewTeamMember, model.E2, model.VY, model.dZ), teamMembers), _List_Nil),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Admin$PartnerApp$Team$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.eO))
                    ]), model.af_))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$PartnerApp$Manage$toPane = function(sectionModel) {
        if (!sectionModel.$) {
            var partnerAppTeam = sectionModel.a;
            return A2($elm$html$Html$map, $author$project$Components$Admin$PartnerApp$Manage$PartnerAppTeamMsg, $author$project$Components$Admin$PartnerApp$Team$view(partnerAppTeam));
        } else {
            var partnerAppSettings = sectionModel.a;
            return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Admin$PartnerApp$Manage$PartnerAppSettingsMsg, $author$project$Components$Admin$PartnerApp$Settings$view(partnerAppSettings))
                ]))
            ]));
        }
    };
    var $author$project$Ui$Nav$navOptionsToOptionsRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            return _Utils_update(record, {
                CF: true
            });
        }), {
            CF: false
        }, options);
    };
    var $author$project$Ui$Nav$defaultOptions = {
        Ir: false,
        aef: $elm$core$Maybe$Nothing,
        rj: _List_Nil,
        zU: $elm$core$Maybe$Nothing,
        d: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Nav$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 1:
                    var linkOptions_ = option.a;
                    return _Utils_update(record, {
                        rj: _Utils_ap(record.rj, linkOptions_)
                    });
                case 0:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Ir: bool
                    });
                case 2:
                    var route_ = option.a;
                    return _Utils_update(record, {
                        d: $elm$core$Maybe$Just(route_)
                    });
                case 3:
                    var string = option.a;
                    return _Utils_update(record, {
                        aef: $elm$core$Maybe$Just(string)
                    });
                default:
                    var handler = option.a;
                    return _Utils_update(record, {
                        zU: $elm$core$Maybe$Just(handler)
                    });
            }
        }), $author$project$Ui$Nav$defaultOptions, options);
    };
    var $author$project$Ui$Nav$ItemClicked = {
        $: 0
    };
    var $elm$html$Html$Events$onMouseUp = function(msg) {
        return A2($elm$html$Html$Events$on, 'mouseup', $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Ui$Nav$viewNonEmptyItem = F3(function(toMsg, options, contents) {
        var optionsRecord = $author$project$Ui$Nav$optionsToRecord(options);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('nav-tabs__item'),
            A2($elm$html$Html$Attributes$attribute, 'role', 'presentation'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('nav-tabs__item--active', optionsRecord.Ir)
            ])),
            function() {
                var _v0 = _Utils_Tuple2(optionsRecord.zU, optionsRecord.Ir);
                if (!_v0.a.$ && !_v0.b) {
                    var handler = _v0.a.a;
                    return $elm$html$Html$Events$onClick(handler);
                } else return $author$project$Utils$Html$Attributes$none;
            }(),
            optionsRecord.Ir ? $author$project$Utils$Html$Attributes$none : A2($elm$html$Html$Attributes$map, toMsg, $elm$html$Html$Events$onMouseUp($author$project$Ui$Nav$ItemClicked)),
            A2($elm$core$Maybe$withDefault, $elm$html$Html$Attributes$class(''), A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, optionsRecord.aef))
        ]), _List_fromArray([
            contents
        ]));
    });
    var $author$project$Ui$Nav$viewItem = F2(function(toMsg, item_) {
        switch(item_.$){
            case 0:
                var options = item_.a;
                var html = item_.b;
                var optionsRecord = $author$project$Ui$Nav$optionsToRecord(options);
                return A3($author$project$Ui$Nav$viewNonEmptyItem, toMsg, options, function() {
                    var _v1 = optionsRecord.d;
                    if (!_v1.$) {
                        var route_ = _v1.a;
                        return A2($elm$html$Html$map, $elm$core$Basics$never, A3($author$project$Ui$Link$route, route_, optionsRecord.rj, html));
                    } else return A2($elm$html$Html$map, $elm$core$Basics$never, A3($author$project$Ui$Button$view, {
                        abP: 'Nav Item'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), html));
                }());
            case 1:
                var options = item_.a;
                var html = item_.b;
                return A3($author$project$Ui$Nav$viewNonEmptyItem, toMsg, options, html);
            default:
                return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Ui$Nav$view = F3(function(options, items, _v0) {
        var underlineWidth = _v0.HV;
        var underlineLeft = _v0.HU;
        var id = _v0.aef;
        var toMsg = _v0.ahX;
        var transform = 'translateX(' + ($elm$core$String$fromFloat(underlineLeft) + ('px) ' + ('scaleX(' + ($elm$core$String$fromFloat(underlineWidth) + ')'))));
        var optionsRecord = $author$project$Ui$Nav$navOptionsToOptionsRecord(options);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('nav-tabs'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('nav-tabs--slim', optionsRecord.CF)
            ])),
            $elm$html$Html$Attributes$id(id)
        ]), A2($elm$core$List$cons, A2($elm$html$Html$span, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'transform', transform),
            $elm$html$Html$Attributes$class('nav-tabs__underline')
        ]), _List_Nil), A2($elm$core$List$map, $author$project$Ui$Nav$viewItem(toMsg), items)));
    });
    var $author$project$Components$Admin$PartnerApp$Manage$view = function(_v0) {
        var model = _v0;
        var sectionNavItems = A2($elm$core$List$map, A2($author$project$Components$Admin$PartnerApp$Manage$sectionsToNavItem, model.VY, model.co), $author$project$Components$Admin$PartnerApp$Manage$sections(model.VY));
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('layout-header')
                ]), _List_fromArray([
                    A3($author$project$Ui$Nav$view, _List_Nil, sectionNavItems, model.nb)
                ])),
                $author$project$Components$Admin$PartnerApp$Manage$toPane(model.co)
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$viewPanel = F2(function(model, integration) {
        var supportUrl = $author$project$Api$Provider$Integration$One$supportUrl(integration);
        var status = $author$project$Api$Provider$Integration$One$status(integration);
        var name = $author$project$Api$Provider$Integration$One$name(integration);
        var marketingUrl = $author$project$Api$Provider$Integration$One$marketingUrl(integration);
        var email = $author$project$Api$Provider$Integration$One$email(integration);
        var deactivateStates = _List_fromArray([
            'active',
            'pending',
            'requested'
        ]);
        var addon = $author$project$Api$Provider$Integration$One$addon(integration);
        var addonUrl = A2($elm$core$Maybe$map, $author$project$Api$Provider$Addon$Shared$url, addon);
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, $author$project$Api$Provider$Integration$One$logoUrl(integration));
                    if (!_v0.$) {
                        var url = _v0.a;
                        return A3($author$project$Ui$Image$fromSrc, {
                            Jg: name
                        }, url, _List_fromArray([
                            $author$project$Ui$Image$height(30)
                        ]));
                    } else return $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text(name)
                    ]));
                }()
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Status'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Badge$fromString, _List_Nil, status),
                        A2($elm$core$List$member, status, deactivateStates) ? A3($author$project$Ui$Button$view, {
                            abP: 'Cancel integration'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Integrations$Slug_String$Deactivate(integration))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel Integration')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(''),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        function() {
                            var _v1 = _Utils_Tuple2($author$project$Api$Provider$Integration$One$active(integration), status);
                            _v1$2: while(true){
                                if (!_v1.a) switch(_v1.b){
                                    case 'inactive':
                                        return A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('This isn\'t ready yet! But you can let us know you\'d like this integration by requesting it below. This does not commit you to actually integrating with them.')
                                        ]));
                                    case 'requested':
                                        return A2($author$project$Ui$Alert$success, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Thanks for letting us know! We\'ll keep you posted on progress towards this integration.')
                                        ]));
                                    default:
                                        break _v1$2;
                                }
                                else break _v1$2;
                            }
                            return $author$project$Utils$Html$empty;
                        }(),
                        $author$project$Pages$Admin$Integrations$Slug_String$showIntegrateButton(integration) ? A3($author$project$Ui$Button$view, {
                            abP: 'Integrate with ' + name
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Integrations$Slug_String$Activate(integration))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Integrate with ' + name)
                        ])) : $author$project$Utils$Html$empty,
                        status === 'inactive' && !$author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration) ? A3($author$project$Ui$Button$view, {
                            abP: 'Integration with' + name
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Integrations$Slug_String$Activate(integration))
                        ]), _List_fromArray([
                            $author$project$Api$Provider$Integration$One$active(integration) ? $elm$html$Html$text('Integrate') : $elm$html$Html$text('I\'m Interested in Integrating'),
                            $elm$html$Html$text(' with '),
                            $elm$html$Html$text(name)
                        ])) : $author$project$Utils$Html$empty,
                        status === 'active' ? A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$success
                        ]), _List_fromArray([
                            $elm$html$Html$text('Congratulations! You\'ve successfully integrated with '),
                            $elm$html$Html$text(name)
                        ])) : $author$project$Utils$Html$empty,
                        status === 'pending' && $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration) ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('If you haven\'t been contacted by '),
                                    $elm$html$Html$text(name),
                                    $elm$html$Html$text(' about next steps for this integration, then something probably went wrong.')
                                ]))
                            ])),
                            A3($author$project$Ui$Link$externalHref, A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Integration$One$connectionUrl(integration)), _List_fromArray([
                                $author$project$Ui$Link$targetBlank,
                                $author$project$Ui$Link$buttonPrimary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Try again')
                            ]))
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ])),
                function() {
                    var _v2 = _Utils_Tuple2(status, addonUrl);
                    if (_v2.a === 'active' && !_v2.b.$) {
                        var addonUrl_ = _v2.b.a;
                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Signup Url'),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$pre, _List_fromArray([
                                    $author$project$Ui$Typography$authorizationCode
                                ]), _List_fromArray([
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', addonUrl_))
                                ])),
                                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Give this unique link to your patients who wish to join '),
                                    $elm$html$Html$text(name),
                                    $elm$html$Html$text('.')
                                ])),
                                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('To add '),
                                    $elm$html$Html$text(name),
                                    $elm$html$Html$text(' enrollment to your signup pages, check off the '),
                                    $elm$html$Html$text(name),
                                    $elm$html$Html$text(' box on the signup pages in your '),
                                    A3($author$project$Ui$Link$externalHref, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__SignupPages__Top), _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Online Signup')
                                    ])),
                                    $elm$html$Html$text(' settings.')
                                ]))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                status === 'pending' && $author$project$Api$Provider$Integration$One$active(integration) && !$author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Authorization Code'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$pre, _List_fromArray([
                            $author$project$Ui$Typography$authorizationCode
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$Integration$One$authorizationCode(integration)))
                        ])),
                        A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(name),
                                $elm$html$Html$text(' does not support automatic integrations yet. Please email them at'),
                                A3($author$project$Ui$Link$mailto, A2($elm$core$Maybe$withDefault, '', email), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', email))
                                ])),
                                $elm$html$Html$text(' and they can provide you with next steps.')
                            ]))
                        ]))
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('About'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, function() {
                        if (!addon.$) return _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Integration$One$productDescription(integration)))
                            ]))
                        ]);
                        else return _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'No information provided yet. Please contact ' + (name + ' for more.'), $author$project$Api$Provider$Integration$One$productDescription(integration)))
                            ])),
                            $author$project$Utils$Maybe$toBool(marketingUrl) || $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Integration$One$signupUrl(integration)) ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                function() {
                                    var _v4 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, marketingUrl);
                                    if (!_v4.$) {
                                        var marketingUrl_ = _v4.a;
                                        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Learn more '),
                                            A3($author$project$Ui$Link$externalHref, marketingUrl_, _List_fromArray([
                                                $author$project$Ui$Link$targetBlank
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('here')
                                            ])),
                                            $elm$html$Html$text('.')
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }(),
                                $author$project$Utils$Html$noBreakSpace,
                                function() {
                                    var _v5 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, $author$project$Api$Provider$Integration$One$signupUrl(integration));
                                    if (!_v5.$) {
                                        var signupUrl = _v5.a;
                                        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Signup '),
                                            A3($author$project$Ui$Link$externalHref, signupUrl, _List_fromArray([
                                                $author$project$Ui$Link$targetBlank
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('here')
                                            ])),
                                            $elm$html$Html$text('.')
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ])) : $author$project$Utils$Html$empty
                        ]);
                    }())
                ])),
                function() {
                    if (!addon.$) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label(name + ' Resources'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, $author$project$Pages$Admin$Integrations$Slug_String$isZion(integration) ? _List_fromArray([
                            $elm$html$Html$text('For resources about membership in the Zion Health healthshare, '),
                            A3($author$project$Ui$Link$externalHref, A2($elm$core$Maybe$withDefault, '', marketingUrl), _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text('click here')
                            ])),
                            $elm$html$Html$text('.')
                        ]) : _List_Nil)
                    ]));
                    else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Maybe$toBool(addon) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Support'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('If you need any support from '),
                        $elm$html$Html$text(name),
                        $elm$html$Html$text(', '),
                        $author$project$Pages$Admin$Integrations$Slug_String$isZion(integration) ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('email '),
                            A3($author$project$Ui$Link$mailto, A2($elm$core$Maybe$withDefault, '', email), _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', email))
                            ])),
                            $elm$html$Html$text('.')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ])) : $author$project$Utils$Html$empty,
                !$author$project$Utils$Maybe$toBool(addon) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('What To Expect'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'No information provided yet. Please contact ' + (name + ' for more.'), A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, $author$project$Api$Provider$Integration$One$integrationDescription(integration))))
                    ]))
                ])) : $author$project$Utils$Html$empty,
                !$author$project$Utils$Maybe$toBool(addon) && ($author$project$Utils$Maybe$toBool(supportUrl) || $author$project$Utils$Maybe$toBool(email)) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Support'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('If you need any support from '),
                        $elm$html$Html$text(name),
                        $elm$html$Html$text(','),
                        function() {
                            var _v7 = _Utils_Tuple2(supportUrl, email);
                            if (!_v7.a.$) {
                                var supportUrl_ = _v7.a.a;
                                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(' please go '),
                                    A3($author$project$Ui$Link$externalHref, supportUrl_, _List_fromArray([
                                        $author$project$Ui$Link$targetBlank
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('here')
                                    ])),
                                    $elm$html$Html$text('.')
                                ]));
                            } else {
                                if (!_v7.b.$) {
                                    var _v8 = _v7.a;
                                    var email_ = _v7.b.a;
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(' please click '),
                                        A3($author$project$Ui$Link$mailto, email_, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('here')
                                        ])),
                                        $elm$html$Html$text('.')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }
                        }()
                    ]))
                ])) : $author$project$Utils$Html$empty,
                function() {
                    var _v9 = model.c9;
                    if (!_v9.$) {
                        var partnerAppManage = _v9.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg, $author$project$Components$Admin$PartnerApp$Manage$view(partnerAppManage));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Integrations$Slug_String$view = function(model) {
        var integrationName = function() {
            var _v7 = model.Rn;
            if (_v7.$ === 3) {
                var integration = _v7.a;
                return $author$project$Api$Provider$Integration$One$name(integration);
            } else return '';
        }();
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.bL;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var integration = _v1.a;
                        var request = _v1.b;
                        var verbPrefix = $author$project$Pages$Admin$Integrations$Slug_String$canAutomaticallyIntegrate(integration) ? 'Connect with ' : 'Enable ';
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Integrations$Slug_String$ActivateHiConfirmClosed(integration), _List_fromArray([
                            $author$project$Components$HiConfirm$verb(_Utils_ap(verbPrefix, $author$project$Api$Provider$Integration$One$name(integration))),
                            $author$project$Components$HiConfirm$customMessage($author$project$Pages$Admin$Integrations$Slug_String$disclaimerMessage(integration)),
                            $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.dH;
                    if (!_v2.$) {
                        var _v3 = _v2.a;
                        var integration = _v3.a;
                        var request = _v3.b;
                        var status = $author$project$Api$Provider$Integration$One$status(integration);
                        var _v4 = status === 'active' ? _Utils_Tuple2('deactivate', _List_fromArray([
                            $elm$html$Html$text('Are you sure you want to deactivate '),
                            $elm$html$Html$text($author$project$Api$Provider$Integration$One$name(integration)),
                            $elm$html$Html$text('? This will immediately cease the integration, and reactivating may take time.')
                        ])) : status === 'pending' || status === 'requested' ? _Utils_Tuple2('cancel integration', _List_fromArray([
                            $elm$html$Html$text('Are you sure you want to cancel your pending integration with '),
                            $elm$html$Html$text($author$project$Api$Provider$Integration$One$name(integration)),
                            $elm$html$Html$text('?')
                        ])) : _Utils_Tuple2('', _List_Nil);
                        var verb = _v4.a;
                        var customMessage = _v4.b;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Integrations$Slug_String$DeactivateHiConfirmClosed(integration), _List_fromArray([
                            $author$project$Components$HiConfirm$verb(verb),
                            $author$project$Components$HiConfirm$customMessage(customMessage),
                            $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v5 = model.c9;
                    if (!_v5.$) {
                        var partnerAppManage = _v5.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Admin$Integrations$Slug_String$PartnerAppManageMsg, $author$project$Components$Admin$PartnerApp$Manage$modal(partnerAppManage));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v6 = model.Rn;
                    if (_v6.$ === 3) {
                        var integration = _v6.a;
                        return A2($author$project$Ui$Form$view, _List_fromArray([
                            $author$project$Ui$Form$horizontal,
                            $author$project$Ui$Form$autocomplete(true),
                            $author$project$Ui$Form$noValidate(true)
                        ]), _List_fromArray([
                            A2($author$project$Pages$Admin$Integrations$Slug_String$viewPanel, model, integration)
                        ]));
                    } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]));
                }()
            ]),
            $2: 'Integrations | ' + integrationName
        };
    };
    var $author$project$Pages$Admin$Integrations$Slug_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Integrations$Slug_String$init,
        aeR: $author$project$Pages$Admin$Integrations$Slug_String$load,
        ag3: $author$project$Pages$Admin$Integrations$Slug_String$save,
        ahE: $author$project$Pages$Admin$Integrations$Slug_String$subscriptions,
        aaO: $author$project$Pages$Admin$Integrations$Slug_String$update,
        aid: $author$project$Pages$Admin$Integrations$Slug_String$view
    });
    var $author$project$Pages$Admin$InternalSettings$GotCurrentGroup = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$InternalSettings$GotGroups = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$ManagementGroup$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'management_groups'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ManagementGroup$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ManagementGroup$Shared$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$listPath));
    });
    var $author$project$Pages$Admin$InternalSettings$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        return _Utils_Tuple2({
            Ej: apiClient,
            p6: $elm$core$Maybe$Nothing,
            xT: _List_Nil
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$ManagementGroup$getCurrent, apiClient, $author$project$Pages$Admin$InternalSettings$GotCurrentGroup),
            A2($author$project$Api$Provider$ManagementGroup$list, apiClient, $author$project$Pages$Admin$InternalSettings$GotGroups)
        ])));
    });
    var $author$project$Pages$Admin$InternalSettings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$InternalSettings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$InternalSettings$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$InternalSettings$ManagementGroupSaved = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$ManagementGroup$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$ManagementGroup$update = F3(function(apiClient, id, toMsg) {
        var params = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string(id))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $elm$json$Json$Decode$maybe($author$project$Api$Provider$ManagementGroup$Shared$decoder), toMsg, A2($author$project$Api$Data$requestWithJson, params, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath)));
    });
    var $author$project$Pages$Admin$InternalSettings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var dataGroup = msg.a;
                switch(dataGroup.$){
                    case 3:
                        var group = dataGroup.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            p6: $elm$core$Maybe$Just(group)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        var error = dataGroup.a;
                        if (error.$ === 5) return _Utils_Tuple3(_Utils_update(model, {
                            p6: $elm$core$Maybe$Nothing
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                        else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataGroup));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataGroup));
                }
            case 1:
                var dataGroups = msg.a;
                if (dataGroups.$ === 3) {
                    var groups = dataGroups.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        xT: groups
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataGroups));
            case 2:
                var groupId = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$ManagementGroup$update, model.Ej, groupId, $author$project$Pages$Admin$InternalSettings$ManagementGroupSaved), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    if (!response.a.$) {
                        var group = response.a.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated management group to ' + $author$project$Api$Provider$ManagementGroup$Shared$name(group))
                        ]));
                    } else {
                        var _v5 = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully removed management group')
                        ]));
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$InternalSettings$ManagementGroupSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$ManagementGroup$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Pages$Admin$InternalSettings$managementGroupOptions = function(model) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'None'), A2($elm$core$List$map, function(managementGroup) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$ManagementGroup$Shared$id(managementGroup)), $author$project$Api$Provider$ManagementGroup$Shared$name(managementGroup));
        }, model.xT));
    };
    var $author$project$Pages$Admin$InternalSettings$viewManagementGroupSelection = function(model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Management Group'),
            $author$project$Ui$Form$Group$labelSpanMd(3),
            $author$project$Ui$Form$Group$inputSpanMd(4),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Provider$ManagementGroup$Shared$id, model.p6)),
                $author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$InternalSettings$ManagementGroupSelected)
            ]), $author$project$Pages$Admin$InternalSettings$managementGroupOptions(model))
        ]));
    };
    var $author$project$Pages$Admin$InternalSettings$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Internal Settings')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Admin$InternalSettings$viewManagementGroupSelection(model)
                    ]))
                ]))
            ]),
            $2: 'Admin | Internal Settings'
        };
    };
    var $author$project$Pages$Admin$InternalSettings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$InternalSettings$init,
        aeR: $author$project$Pages$Admin$InternalSettings$load,
        ag3: $author$project$Pages$Admin$InternalSettings$save,
        ahE: $author$project$Pages$Admin$InternalSettings$subscriptions,
        aaO: $author$project$Pages$Admin$InternalSettings$update,
        aid: $author$project$Pages$Admin$InternalSettings$view
    });
    var $author$project$Pages$Admin$InvoiceSettings$GotCompanyInvoiceSetting = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$GotPaymentSourceSetting = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$companyInvoiceSetting = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.LL;
    });
    var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id = function(_v0) {
        var shared = _v0;
        return shared.aef;
    };
    var $author$project$Api$Provider$PaymentSourceSetting$Shared$id = function(_v0) {
        var shared = _v0;
        return shared.aef;
    };
    var $author$project$Api$Provider$Practice$One$paymentSourceSetting = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Ws;
    });
    var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'company_invoice_settings'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingsPath);
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$ForPractice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$Record = function(invoiceUpcomingAutoSend) {
        return function(invoiceAutoSend) {
            return function(invoiceAutoSendDay) {
                return function(invoiceAutoSendMonth) {
                    return function(invoiceAutoIssue) {
                        return function(invoiceAutoIssueDay) {
                            return function(invoiceAutoIssueMonth) {
                                return function(invoiceDueDay) {
                                    return function(invoiceDueMonth) {
                                        return function(invoiceAutoPay) {
                                            return function(invoiceAutoPayDay) {
                                                return function(invoiceAutoPayMonth) {
                                                    return function(invoiceGracePeriodDays) {
                                                        return function(chargePhiDetailsEnabled) {
                                                            return function(chargePhiDetailsUpdatedAt) {
                                                                return function(chargePhiDetailsUpdatedBy) {
                                                                    return function(chargeRouteToRecurringInvoice) {
                                                                        return function(billingEnabled) {
                                                                            return function(billingStartDate) {
                                                                                return function(hideSponsorInvoices) {
                                                                                    return {
                                                                                        Eu: billingEnabled,
                                                                                        Kg: billingStartDate,
                                                                                        K6: chargePhiDetailsEnabled,
                                                                                        K7: chargePhiDetailsUpdatedAt,
                                                                                        K8: chargePhiDetailsUpdatedBy,
                                                                                        EM: chargeRouteToRecurringInvoice,
                                                                                        QI: hideSponsorInvoices,
                                                                                        RB: invoiceAutoIssue,
                                                                                        RC: invoiceAutoIssueDay,
                                                                                        FY: invoiceAutoIssueMonth,
                                                                                        RD: invoiceAutoPay,
                                                                                        FZ: invoiceAutoPayDay,
                                                                                        F_: invoiceAutoPayMonth,
                                                                                        RE: invoiceAutoSend,
                                                                                        RF: invoiceAutoSendDay,
                                                                                        F$: invoiceAutoSendMonth,
                                                                                        RH: invoiceDueDay,
                                                                                        F0: invoiceDueMonth,
                                                                                        F1: invoiceGracePeriodDays,
                                                                                        F2: invoiceUpcomingAutoSend
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthAfter = 2;
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthBefore = 0;
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$MonthOfTheInvoice = 1;
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString = function(option) {
        switch(option){
            case 'month_before':
                return $elm$core$Maybe$Just(0);
            case 'month_of_the_invoice':
                return $elm$core$Maybe$Just(1);
            case 'month_after':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        var _v0 = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
        if (!_v0.$) {
            var option = _v0.a;
            return $elm$json$Json$Decode$succeed(option);
        } else return $elm$json$Json$Decode$fail('Unsupported month configuration option: ' + string);
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hide_sponsor_invoices', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_route_to_recurring_invoice', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_phi_details_updated_by', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_phi_details_updated_at', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_phi_details_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_grace_period_days', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_pay_month', $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_pay_day', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_pay', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_due_month', $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_due_day', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue_month', $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue_day', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send_month', $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send_day', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_upcoming_auto_send', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$Record)))))))))))))))))))));
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id_)));
    });
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$ForPractice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$Record = F3(function(acceptsAch, acceptsCards, acceptsAmex) {
        return {
            Ie: acceptsAch,
            If: acceptsAmex,
            Ig: acceptsCards
        };
    });
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_amex', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_cards', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_ach', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$ForPractice$Record))));
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PaymentSourceSetting$ForPractice$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'payment_source_settings'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingsPath);
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id_)));
    });
    var $author$project$Pages$Admin$InvoiceSettings$init = F4(function(_v0, practice, shared, _v1) {
        var paymentSettingId = $author$project$Api$Provider$PaymentSourceSetting$Shared$id($author$project$Api$Provider$Practice$One$paymentSourceSetting(practice));
        var companySettingId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id($author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
        return _Utils_Tuple2({
            Ej: shared.Ej,
            LL: $author$project$Api$Data$Loading,
            cP: shared.cP,
            PU: $elm$core$Maybe$Nothing,
            iN: false,
            aef: companySettingId,
            F3: $author$project$Shared$isHintAdmin(shared),
            aM: $elm$core$Maybe$Nothing,
            r$: paymentSettingId,
            Ws: $author$project$Api$Data$Loading,
            W1: practice
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, shared.Ej, companySettingId, $author$project$Pages$Admin$InvoiceSettings$GotCompanyInvoiceSetting),
            A3($author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve, shared.Ej, paymentSettingId, $author$project$Pages$Admin$InvoiceSettings$GotPaymentSourceSetting)
        ])));
    });
    var $author$project$Pages$Admin$InvoiceSettings$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            cP: shared.cP
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$InvoiceSettings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$subscriptions = function(_v0) {
        var hiConfirmOpen = _v0.iN;
        return hiConfirmOpen ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$InvoiceSettings$updateMonthOptionField = F3(function(monthOption, updateField, fields) {
        return A2($elm$core$Maybe$withDefault, fields, A2($elm$core$Maybe$map, updateField, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
    });
    var $author$project$Pages$Admin$InvoiceSettings$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    F2: bool
                });
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    RE: bool
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    RF: A2($elm$core$Maybe$withDefault, 1, $elm$core$String$toInt(string))
                });
            case 3:
                var monthOption = field.a;
                return A2($elm$core$Maybe$withDefault, fields, A2($elm$core$Maybe$map, function(option) {
                    return _Utils_update(fields, {
                        F$: option
                    });
                }, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
            case 4:
                var bool = field.a;
                return _Utils_update(fields, {
                    RB: bool
                });
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    RC: A2($elm$core$Maybe$withDefault, 1, $elm$core$String$toInt(string))
                });
            case 6:
                var monthOption = field.a;
                return A2($elm$core$Maybe$withDefault, fields, A2($elm$core$Maybe$map, function(option) {
                    return _Utils_update(fields, {
                        FY: option
                    });
                }, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
            case 7:
                var string = field.a;
                return _Utils_update(fields, {
                    RH: A2($elm$core$Maybe$withDefault, 1, $elm$core$String$toInt(string))
                });
            case 8:
                var monthOption = field.a;
                return A2($elm$core$Maybe$withDefault, fields, A2($elm$core$Maybe$map, function(option) {
                    return _Utils_update(fields, {
                        F0: option
                    });
                }, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(monthOption)));
            case 9:
                var bool = field.a;
                return _Utils_update(fields, {
                    RD: bool
                });
            case 10:
                var string = field.a;
                return _Utils_update(fields, {
                    FZ: A2($elm$core$Maybe$withDefault, 1, $elm$core$String$toInt(string))
                });
            case 11:
                var monthOption = field.a;
                return A3($author$project$Pages$Admin$InvoiceSettings$updateMonthOptionField, monthOption, function(option) {
                    return _Utils_update(fields, {
                        F_: option
                    });
                }, fields);
            case 12:
                var string = field.a;
                return _Utils_update(fields, {
                    F1: A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(string))
                });
            case 13:
                var bool = field.a;
                return _Utils_update(fields, {
                    K6: bool
                });
            case 14:
                var bool = field.a;
                return _Utils_update(fields, {
                    EM: bool
                });
            case 15:
                var bool = field.a;
                return _Utils_update(fields, {
                    Eu: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    QI: bool
                });
        }
    });
    var $author$project$Pages$Admin$InvoiceSettings$IssueDateValidation = 0;
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt = function(option) {
        switch(option){
            case 0:
                return -1;
            case 1:
                return 0;
            default:
                return 1;
        }
    };
    var $author$project$Pages$Admin$InvoiceSettings$isOnOrAfter = F2(function(_v0, _v1) {
        var firstDay = _v0.a;
        var firstMonth = _v0.b;
        var secondDay = _v1.a;
        var secondMonth = _v1.b;
        var secondMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(secondMonth);
        var firstMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(firstMonth);
        return _Utils_eq(firstMonthInt, secondMonthInt) ? _Utils_cmp(firstDay, secondDay) < 1 : _Utils_cmp(firstMonthInt, secondMonthInt) < 0;
    });
    var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate = function(form) {
        return form.RD && form.RB ? A2($author$project$Pages$Admin$InvoiceSettings$isOnOrAfter, _Utils_Tuple2(form.RC, form.FY), _Utils_Tuple2(form.FZ, form.F_)) : true;
    };
    var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate, _Utils_Tuple2(0, 'The Issue date must be before or on the autopay date'));
    var $author$project$Pages$Admin$InvoiceSettings$AutoPayDateValidation = 1;
    var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate = function(form) {
        return form.RE && form.RD ? A2($author$project$Pages$Admin$InvoiceSettings$isOnOrAfter, _Utils_Tuple2(form.RF, form.F$), _Utils_Tuple2(form.FZ, form.F_)) : true;
    };
    var $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate, _Utils_Tuple2(1, 'The autopay date must be on or after the Invoice Created notification date'));
    var $author$project$Pages$Admin$InvoiceSettings$DueDateValidation = 2;
    var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate = function(form) {
        return form.RD ? A2($author$project$Pages$Admin$InvoiceSettings$isOnOrAfter, _Utils_Tuple2(form.FZ, form.F_), _Utils_Tuple2(form.RH, form.F0)) : true;
    };
    var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate, _Utils_Tuple2(2, 'The invoice must be due on or after the autopay date'));
    var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate = function(form) {
        return form.RD || !form.RE ? true : A2($author$project$Pages$Admin$InvoiceSettings$isOnOrAfter, _Utils_Tuple2(form.RF, form.F$), _Utils_Tuple2(form.RH, form.F0));
    };
    var $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate, _Utils_Tuple2(2, 'The invoice must be due on or after the Invoice Created notification date'));
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingValidation = 3;
    var $author$project$Pages$Admin$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, function(_v0) {
        var invoiceUpcomingAutoSend = _v0.F2;
        var invoiceAutoSend = _v0.RE;
        return invoiceUpcomingAutoSend ? invoiceAutoSend : true;
    }, _Utils_Tuple2(3, 'This notification can only be enabled if the Invoice Created notification is also enabled'));
    var $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $author$project$Pages$Admin$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator,
        $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator,
        $author$project$Pages$Admin$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator,
        $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator,
        $author$project$Pages$Admin$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator
    ]));
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled = function(_v0) {
        var forPractice = _v0;
        return forPractice.Eu;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled = function(_v0) {
        var forPractice = _v0;
        return forPractice.K6;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice = function(_v0) {
        var forPractice = _v0;
        return forPractice.EM;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices = function(_v0) {
        var forPractice = _v0;
        return forPractice.QI;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue = function(_v0) {
        var forPractice = _v0;
        return forPractice.RB;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay = function(_v0) {
        var forPractice = _v0;
        return forPractice.RC;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth = function(_v0) {
        var forPractice = _v0;
        return forPractice.FY;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay = function(_v0) {
        var forPractice = _v0;
        return forPractice.RD;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay = function(_v0) {
        var forPractice = _v0;
        return forPractice.FZ;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth = function(_v0) {
        var forPractice = _v0;
        return forPractice.F_;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend = function(_v0) {
        var forPractice = _v0;
        return forPractice.RE;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay = function(_v0) {
        var forPractice = _v0;
        return forPractice.RF;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth = function(_v0) {
        var forPractice = _v0;
        return forPractice.F$;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay = function(_v0) {
        var forPractice = _v0;
        return forPractice.RH;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth = function(_v0) {
        var forPractice = _v0;
        return forPractice.F0;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays = function(_v0) {
        var forPractice = _v0;
        return forPractice.F1;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend = function(_v0) {
        var forPractice = _v0;
        return forPractice.F2;
    };
    var $author$project$Pages$Admin$InvoiceSettings$initFormFields = function(companyInvoiceSetting) {
        return _Utils_Tuple2({
            Eu: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(companyInvoiceSetting),
            K6: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled(companyInvoiceSetting),
            EM: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice(companyInvoiceSetting),
            QI: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices(companyInvoiceSetting),
            RB: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue(companyInvoiceSetting),
            RC: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay(companyInvoiceSetting),
            FY: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth(companyInvoiceSetting),
            RD: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay(companyInvoiceSetting),
            FZ: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay(companyInvoiceSetting),
            F_: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth(companyInvoiceSetting),
            RE: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend(companyInvoiceSetting),
            RF: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay(companyInvoiceSetting),
            F$: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth(companyInvoiceSetting),
            RH: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay(companyInvoiceSetting),
            F0: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth(companyInvoiceSetting),
            F1: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays(companyInvoiceSetting),
            F2: $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend(companyInvoiceSetting)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch = function(_v0) {
        var forPractice = _v0;
        return forPractice.Ie;
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex = function(_v0) {
        var forPractice = _v0;
        return forPractice.If;
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards = function(_v0) {
        var forPractice = _v0;
        return forPractice.Ig;
    };
    var $author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields = function(paymentSourceSetting) {
        return {
            Ie: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch(paymentSourceSetting),
            If: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex(paymentSourceSetting),
            Ig: $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards(paymentSourceSetting)
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ie: bool
                });
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    If: bool,
                    Ig: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    If: bool
                });
        }
    });
    var $author$project$Pages$Admin$InvoiceSettings$AcceptsAmexValidation = 0;
    var $author$project$Pages$Admin$InvoiceSettings$sponsorAcceptsAllCards = function(form) {
        return !(!form.Ig && form.If);
    };
    var $author$project$Pages$Admin$InvoiceSettings$acceptsAmexValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Admin$InvoiceSettings$sponsorAcceptsAllCards, _Utils_Tuple2(0, 'If the sponsor does not accept cards they cannot accept Amex'));
    var $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $author$project$Pages$Admin$InvoiceSettings$acceptsAmexValidator
    ]));
    var $author$project$Pages$Admin$InvoiceSettings$CompanyInvoiceSettingUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString = function(option) {
        switch(option){
            case 0:
                return 'month_before';
            case 1:
                return 'month_of_the_invoice';
            default:
                return 'month_after';
        }
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder = function(monthOption) {
        return $elm$json$Json$Encode$string($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(monthOption));
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company_invoice_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('invoice_upcoming_auto_send', $elm$json$Json$Encode$bool(fields.F2)),
                _Utils_Tuple2('invoice_auto_send', $elm$json$Json$Encode$bool(fields.RE)),
                _Utils_Tuple2('invoice_auto_send_day', $elm$json$Json$Encode$int(fields.RF)),
                _Utils_Tuple2('invoice_auto_send_month', $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.F$)),
                _Utils_Tuple2('invoice_auto_issue', $elm$json$Json$Encode$bool(fields.RB)),
                _Utils_Tuple2('invoice_auto_issue_day', $elm$json$Json$Encode$int(fields.RC)),
                _Utils_Tuple2('invoice_auto_issue_month', $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.FY)),
                _Utils_Tuple2('invoice_due_day', $elm$json$Json$Encode$int(fields.RH)),
                _Utils_Tuple2('invoice_due_month', $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.F0)),
                _Utils_Tuple2('invoice_auto_pay', $elm$json$Json$Encode$bool(fields.RD)),
                _Utils_Tuple2('invoice_auto_pay_day', $elm$json$Json$Encode$int(fields.FZ)),
                _Utils_Tuple2('invoice_auto_pay_month', $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder(fields.F_)),
                _Utils_Tuple2('invoice_grace_period_days', $elm$json$Json$Encode$int(fields.F1)),
                _Utils_Tuple2('charge_phi_details_enabled', $elm$json$Json$Encode$bool(fields.K6)),
                _Utils_Tuple2('charge_route_to_recurring_invoice', $elm$json$Json$Encode$bool(fields.EM)),
                _Utils_Tuple2('billing_enabled', $elm$json$Json$Encode$bool(fields.Eu)),
                _Utils_Tuple2('hide_sponsor_invoices', $elm$json$Json$Encode$bool(fields.QI))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id))));
    });
    var $author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting = F3(function(apiClient, id, formFields) {
        var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var flattenedForm = {
            Eu: validated.Eu,
            K6: validated.K6,
            EM: validated.EM,
            QI: validated.QI,
            RB: validated.RB,
            RC: validated.RC,
            FY: validated.FY,
            RD: validated.RD,
            FZ: validated.FZ,
            F_: validated.F_,
            RE: validated.RE,
            RF: validated.RF,
            F$: validated.F$,
            RH: validated.RH,
            F0: validated.F0,
            F1: validated.F1,
            F2: validated.F2
        };
        return A4($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$update, apiClient, id, flattenedForm, $author$project$Pages$Admin$InvoiceSettings$CompanyInvoiceSettingUpdated);
    });
    var $author$project$Pages$Admin$InvoiceSettings$PaymentSourceSettingUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForPractice$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment_source_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('accepts_ach', $elm$json$Json$Encode$bool(fields.Ie)),
                _Utils_Tuple2('accepts_cards', $elm$json$Json$Encode$bool(fields.Ig)),
                _Utils_Tuple2('accepts_amex', $elm$json$Json$Encode$bool(fields.If))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$PaymentSourceSetting$ForPractice$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id))));
    });
    var $author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting = F3(function(apiClient, id, formFields) {
        return A4($author$project$Api$Provider$PaymentSourceSetting$ForPractice$update, apiClient, id, $rtfeldman$elm_validate$Validate$fromValid(formFields), $author$project$Pages$Admin$InvoiceSettings$PaymentSourceSettingUpdated);
    });
    var $author$project$Pages$Admin$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting = function(model) {
        var _v0 = _Utils_Tuple2(model.PU, model.aM);
        if (!_v0.a.$) {
            if (_v0.b.$ === 1) {
                var form = _v0.a.a;
                var _v1 = _v0.b;
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator, form);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        LL: $author$project$Api$Data$Loading,
                        PU: $elm$core$Maybe$Just(newForm)
                    }), A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.Ej, model.aef, validFormFields), _List_Nil);
                } else {
                    var newForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            } else {
                var form = _v0.a.a;
                var paymentForm = _v0.b.a;
                var _v4 = _Utils_Tuple2(A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator, form), A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator, paymentForm));
                if (!_v4.a.$) {
                    if (!_v4.b.$) {
                        var _v5 = _v4.a.a;
                        var newForm = _v5.a;
                        var validFormFields = _v5.b;
                        var _v6 = _v4.b.a;
                        var newPaymentForm = _v6.a;
                        var validPaymentFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            LL: $author$project$Api$Data$Loading,
                            PU: $elm$core$Maybe$Just(newForm),
                            aM: $elm$core$Maybe$Just(newPaymentForm),
                            Ws: $author$project$Api$Data$Loading
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.Ej, model.aef, validFormFields),
                            A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.Ej, model.r$, validPaymentFormFields)
                        ])), _List_Nil);
                    } else {
                        var _v7 = _v4.a.a;
                        var newForm = _v7.a;
                        var validFormFields = _v7.b;
                        var newPaymentForm = _v4.b.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            LL: $author$project$Api$Data$Loading,
                            PU: $elm$core$Maybe$Just(newForm),
                            aM: $elm$core$Maybe$Just(newPaymentForm)
                        }), A3($author$project$Pages$Admin$InvoiceSettings$updateCompanyInvoiceSetting, model.Ej, model.aef, validFormFields), _List_Nil);
                    }
                } else if (!_v4.b.$) {
                    var newForm = _v4.a.a;
                    var _v8 = _v4.b.a;
                    var newPaymentForm = _v8.a;
                    var validPaymentFormFields = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        aM: $elm$core$Maybe$Just(newPaymentForm),
                        Ws: $author$project$Api$Data$Loading
                    }), A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.Ej, model.r$, validPaymentFormFields), _List_Nil);
                } else {
                    var newForm = _v4.a.a;
                    var newPaymentForm = _v4.b.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        aM: $elm$core$Maybe$Just(newPaymentForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            }
        } else if (!_v0.b.$) {
            var _v9 = _v0.a;
            var paymentForm = _v0.b.a;
            var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsValidator, paymentForm);
            if (!_v10.$) {
                var _v11 = _v10.a;
                var newForm = _v11.a;
                var validFormFields = _v11.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    aM: $elm$core$Maybe$Just(newForm),
                    Ws: $author$project$Api$Data$Loading
                }), A3($author$project$Pages$Admin$InvoiceSettings$updatePaymentSourceSetting, model.Ej, model.r$, validFormFields), _List_Nil);
            } else {
                var newForm = _v10.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aM: $elm$core$Maybe$Just(newForm)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            }
        } else {
            var _v12 = _v0.a;
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    };
    var $author$project$Pages$Admin$InvoiceSettings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var companyInvoiceSetting = response.a;
                    var _v2 = $author$project$Pages$Admin$InvoiceSettings$initFormFields(companyInvoiceSetting);
                    var fields = _v2.a;
                    var cmd = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        LL: response,
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init(fields))
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    LL: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var paymentSourceSetting = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aM: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields(paymentSourceSetting))),
                        Ws: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Ws: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var companyInvoiceSetting = response.a;
                    var _v5 = $author$project$Pages$Admin$InvoiceSettings$initFormFields(companyInvoiceSetting);
                    var fields = _v5.a;
                    var cmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        LL: response,
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init(fields))
                    }), cmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Invoice settings updated')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    LL: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var paymentSourceSetting = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aM: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Pages$Admin$InvoiceSettings$initPaymentFormFields(paymentSourceSetting))),
                        Ws: response
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Payment options settings updated')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Ws: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var field = msg.a;
                var _v7 = model.PU;
                if (!_v7.$) {
                    var form = _v7.a;
                    return function(newForm) {
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }($author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$InvoiceSettings$formFieldsValidator, A3($author$project$Utils$Form$update, $author$project$Pages$Admin$InvoiceSettings$formFieldsUpdate, field, form))));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var field = msg.a;
                var _v8 = model.aM;
                if (!_v8.$) {
                    var form = _v8.a;
                    return function(newForm) {
                        return _Utils_Tuple3(_Utils_update(model, {
                            aM: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }(A3($author$project$Utils$Form$update, $author$project$Pages$Admin$InvoiceSettings$paymentFormFieldsUpdate, field, form));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    iN: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var confirmed = msg.a;
                return confirmed ? $author$project$Pages$Admin$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting(_Utils_update(model, {
                    iN: false
                })) : _Utils_Tuple3(_Utils_update(model, {
                    iN: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$InvoiceSettings$HiConfirmOpened = {
        $: 6
    };
    var $author$project$Ui$Link$ButtonSecondary = 3;
    var $author$project$Ui$Link$buttonSecondary = $author$project$Ui$Link$Style(3);
    var $author$project$Api$Feature$DisableSponsorBilling = 7;
    var $author$project$Api$FeatureGate$SponsorAdHocInvoices = 3;
    var $author$project$Pages$Admin$InvoiceSettings$ChargeRouteToRecurringInvoice = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Grid$offsetMd = $author$project$Ui$Grid$Offset(2);
    var $author$project$Pages$Admin$InvoiceSettings$viewChargeRouteToRecurringInvoice = function(fields) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Add Service Charges to Membership Invoices')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('When point-of-care service charges are paid for by the employer, '),
                        $elm$html$Html$text('automatically add these charges to the employer\'s next draft membership invoice. If this setting is disabled, '),
                        $elm$html$Html$text('service charges will be added to a separate service invoice.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$offsetMd(9),
                                $author$project$Ui$Grid$spanMd(3),
                                $author$project$Ui$Grid$justifyRight
                            ]), _List_fromArray([
                                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                    $author$project$Ui$ToggleSwitch$on(fields.EM),
                                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$ChargeRouteToRecurringInvoice))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$InvoiceSettings$BillingEnabled = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$viewEnableBillingToggle = F2(function(isHintAdmin, form) {
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(fields.Eu),
                        $author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$BillingEnabled))
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Admin$InvoiceSettings$viewEnableBilling = F2(function(isHintAdmin, form) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Billing (Hinter only)')
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('We will bill sponsors when this setting is enabled. When this setting is disabled, we will not bill sponsors, but are still tracking employee eligibility')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), A2($author$project$Pages$Admin$InvoiceSettings$viewEnableBillingToggle, isHintAdmin, form))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$HideSponsorInvoices = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoicesToggle = F2(function(isHintAdmin, form) {
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(fields.QI),
                        $author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$HideSponsorInvoices))
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoices = F2(function(isHintAdmin, form) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Hide Sponsor Invoice Tab (Hinter only)')
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('When billing is disabled for sponsors, the Invoices tab will be hidden in the employer portal.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), A2($author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoicesToggle, isHintAdmin, form))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$ChargePhiDetailsEnabled = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedAt = function(_v0) {
        var forPractice = _v0;
        return forPractice.K7;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedBy = function(_v0) {
        var forPractice = _v0;
        return forPractice.K8;
    };
    var $author$project$Api$Provider$User$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Pages$Admin$InvoiceSettings$viewIncludeChargeDetails = F3(function(fields, model, sponsorized) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Include Full Charge Details')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Allow the '),
                        $elm$html$Html$text(sponsorized),
                        $elm$html$Html$text(' to see full charge details and patient names when viewing or downloading the invoice. '),
                        $elm$html$Html$text('Since these details may contain protected health information, this setting is off by default.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    function() {
                        var _v0 = $author$project$Api$Data$toMaybe(model.LL);
                        if (!_v0.$) {
                            var companyInvoiceSetting = _v0.a;
                            var _v1 = $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedAt(companyInvoiceSetting);
                            if (!_v1.$) {
                                var chargePhiDetailsUpdatedAt = _v1.a;
                                return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanMd(12)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$muted,
                                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Updated by '),
                                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$User$Min$name, $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsUpdatedBy(companyInvoiceSetting)))),
                                            $elm$html$Html$text(' on '),
                                            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargePhiDetailsUpdatedAt))
                                        ]))
                                    ]))
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$justifyRight
                        ]), _List_fromArray([
                            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                $author$project$Ui$ToggleSwitch$on(fields.K6),
                                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$ChargePhiDetailsEnabled))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPay = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayDay = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayMonth = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$daysOfMonth = A2($elm$core$List$range, 1, 31);
    var $author$project$Formatters$Int$ordinal = function(_int) {
        var ordinalSuffix = function(n) {
            var n_ = $elm$core$Basics$abs(n);
            if ((A2($elm$core$Basics$modBy, 100, n_) / 10 | 0) === 1) return 'th';
            else {
                var _v0 = A2($elm$core$Basics$modBy, 10, n_);
                switch(_v0){
                    case 1:
                        return 'st';
                    case 2:
                        return 'nd';
                    case 3:
                        return 'rd';
                    default:
                        return 'th';
                }
            }
        };
        return _Utils_ap($elm$core$String$fromInt(_int), ordinalSuffix(_int));
    };
    var $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions = A2($elm$core$List$map, function(day) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(day)), $author$project$Formatters$Int$ordinal(day));
    }, $author$project$Pages$Admin$InvoiceSettings$daysOfMonth);
    var $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate = _List_fromArray([
        0,
        1,
        2
    ]);
    var $author$project$Pages$Admin$InvoiceSettings$monthOptions = A2($elm$core$List$map, function(option) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)), $author$project$Formatters$String$humanize($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)));
    }, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate);
    var $author$project$Pages$Admin$InvoiceSettings$viewErrorRow = function(message) {
        return A2($elm$html$Html$div, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$danger,
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text(message)
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceAutoPayDate = F3(function(fields, form, sponsorized) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Scheduled Autopay Date')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Payment for the full amount of all issued invoices will be automatically attempted on the specified date. ' + ('Payments will not be processed for non-issued invoices. This date is visible to the  ' + (sponsorized + '.')))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$offsetMd(1),
                                $author$project$Ui$Grid$spanMd(5)
                            ]), _List_fromArray([
                                fields.RD ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.F_))),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayMonth)),
                                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                                ]), $author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(3)
                            ]), _List_fromArray([
                                fields.RD ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(fields.FZ))),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPayDay)),
                                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                                ]), $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions) : $author$project$Utils$Html$empty
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(3)
                            ]), _List_fromArray([
                                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                    $author$project$Ui$ToggleSwitch$on(fields.RD),
                                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoPay))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Utils$Form$hasValidationErrors, 1, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Admin$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 1, form))) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSend = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendDay = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendMonth = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceCreated = F2(function(fields, sponsorized) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Notification: Invoice Created')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Sent to '),
                        $elm$html$Html$text($author$project$Formatters$String$pluralOf(sponsorized)),
                        $elm$html$Html$text(' on the specified day. Invoices can be sent regardless'),
                        $elm$html$Html$text(' of whether they are still in draft or have been issued.')
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Notifications__Company, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('View and customize the notification')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$offsetMd(1),
                            $author$project$Ui$Grid$spanMd(5)
                        ]), _List_fromArray([
                            fields.RE ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.F$))),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendMonth))
                            ]), $author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(3)
                        ]), _List_fromArray([
                            fields.RE ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(fields.RF))),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSendDay))
                            ]), $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions) : $author$project$Utils$Html$empty
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(3)
                        ]), _List_fromArray([
                            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                $author$project$Ui$ToggleSwitch$on(fields.RE),
                                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoSend))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceDueDay = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceDueMonth = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$invoiceDueDayOptions = $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions;
    var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceDueDate = F3(function(fields, form, sponsorized) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Due Date')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('The day when the invoice is considered \"due\". This date is visible to the ' + (sponsorized + ' and printed on the invoice.'))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$offsetMd(4),
                                $author$project$Ui$Grid$spanMd(5)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.F0))),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceDueMonth)),
                                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form))
                                ]), $author$project$Pages$Admin$InvoiceSettings$monthOptions)
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(3)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(fields.RH))),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceDueDay)),
                                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form))
                                ]), $author$project$Pages$Admin$InvoiceSettings$invoiceDueDayOptions)
                            ]))
                        ])),
                        A2($author$project$Utils$Form$hasValidationErrors, 2, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Admin$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 2, form))) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceGracePeriodDays = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceGracePeriod = function(fields) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Grace Period')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('If the invoice is not yet paid after the grace period passes, '),
                        $elm$html$Html$text('each employee\'s membership status will be set to \"unpaid\" '),
                        $elm$html$Html$text('and the invoice will be considered \"overdue\". The grace period starts after the due date.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$offsetMd(6),
                                $author$project$Ui$Grid$spanMd(6)
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPreAddon, '# of days', _List_fromArray([
                                    $author$project$Ui$Form$Input$value($elm$core$String$fromInt(fields.F1)),
                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceGracePeriodDays))
                                ])))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssue = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueDay = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueMonth = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$invoiceAutoIssueDayOptions = $author$project$Pages$Admin$InvoiceSettings$invoiceAutoSendDayOptions;
    var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceIssueDate = F3(function(fields, form, sponsorized) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Scheduled Issue Date')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Invoices will be automatically issued on the specified date, locking charges in place and preventing ' + ($author$project$Formatters$String$pluralOf(sponsorized) + (' from making any changes. Once issued, ' + (sponsorized + ' can pay invoices manually, or invoices will be automatically processed based on the Scheduled Autopay Date settings.'))))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$offsetMd(1),
                                $author$project$Ui$Grid$spanMd(5)
                            ]), _List_fromArray([
                                fields.RB ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(fields.FY))),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueMonth)),
                                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                                ]), $author$project$Pages$Admin$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(3)
                            ]), _List_fromArray([
                                fields.RB ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(fields.RC))),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssueDay)),
                                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                                ]), $author$project$Pages$Admin$InvoiceSettings$invoiceAutoIssueDayOptions) : $author$project$Utils$Html$empty
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(3)
                            ]), _List_fromArray([
                                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                    $author$project$Ui$ToggleSwitch$on(fields.RB),
                                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceAutoIssue))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Admin$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingAutoSend = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$viewInvoiceUpcoming = F3(function(fields, form, sponsorized) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Notification: Invoice Upcoming')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Sent to '),
                        $elm$html$Html$text($author$project$Formatters$String$pluralOf(sponsorized)),
                        $elm$html$Html$text(' to let them know when to expect an invoice. '),
                        $elm$html$Html$text("This notification is sent 1 week prior to the \u201CInvoice Created\u201D notification")
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Notifications__Company, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('View and customize the notification')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$offsetMd(9),
                            $author$project$Ui$Grid$spanMd(3),
                            $author$project$Ui$Grid$justifyRight
                        ]), _List_fromArray([
                            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                $author$project$Ui$ToggleSwitch$on(fields.F2),
                                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$FormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$InvoiceUpcomingAutoSend))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Utils$Form$hasValidationErrors, 3, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Admin$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 3, form))) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Ui$Timeline$ASC = 0;
    var $author$project$Components$InvoiceSetting$Timeline$createTimelineDate = F3(function(today, eventMonth, eventDay) {
        return function(date) {
            return A3($justinmimbs$date$Date$fromCalendarDate, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$month(date), eventDay);
        }(A3($justinmimbs$date$Date$add, 1, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(eventMonth) + 1, today));
    });
    var $author$project$Pages$Admin$InvoiceSettings$createTimelineEventAttributes = F2(function(form, today) {
        var createTimelineDate = $author$project$Components$InvoiceSetting$Timeline$createTimelineDate(today);
        var dueDate = A2(createTimelineDate, form.F0, form.RH);
        var unpaidDate = A3($justinmimbs$date$Date$add, 3, form.F1, A2(createTimelineDate, form.F0, form.RH));
        var upcomingDate = A3($justinmimbs$date$Date$add, 2, -1, A2(createTimelineDate, form.F$, form.RF));
        var autopayDate = A2(createTimelineDate, form.F_, form.FZ);
        var autoSendDate = A2(createTimelineDate, form.F$, form.RF);
        var autoIssueDate = A2(createTimelineDate, form.FY, form.RC);
        return _List_fromArray([
            _Utils_Tuple3(form.F2 && form.RE, upcomingDate, 'Send \"Upcoming\" email'),
            _Utils_Tuple3(form.RE, autoSendDate, 'Send \"Created\" email'),
            _Utils_Tuple3(form.RB, autoIssueDate, 'Issue Invoice'),
            _Utils_Tuple3(form.RD, autopayDate, 'Autopay Invoice'),
            _Utils_Tuple3(true, dueDate, 'Due Date'),
            _Utils_Tuple3(true, unpaidDate, 'Employees show as unpaid')
        ]);
    });
    var $author$project$Components$InvoiceSetting$Timeline$createTimelineEvent = function(_v0) {
        var eventDate = _v0.a;
        var event = _v0.b;
        return {
            M4: eventDate,
            acM: $elm$core$Maybe$Nothing,
            NQ: event
        };
    };
    var $author$project$Components$InvoiceSetting$Timeline$isEnabled = function(_v0) {
        var bool = _v0.a;
        var date = _v0.b;
        var string = _v0.c;
        return bool ? $elm$core$Maybe$Just(_Utils_Tuple2(date, string)) : $elm$core$Maybe$Nothing;
    };
    var $author$project$Components$InvoiceSetting$Timeline$createTimelineEvents = function(eventsData) {
        return A2($elm$core$List$map, $author$project$Components$InvoiceSetting$Timeline$createTimelineEvent, A2($elm$core$List$filterMap, $author$project$Components$InvoiceSetting$Timeline$isEnabled, eventsData));
    };
    var $elm_community$list_extra$List$Extra$unconsLast = function(list) {
        var _v0 = $elm$core$List$reverse(list);
        if (!_v0.b) return $elm$core$Maybe$Nothing;
        else {
            var last_ = _v0.a;
            var rest = _v0.b;
            return $elm$core$Maybe$Just(_Utils_Tuple2(last_, $elm$core$List$reverse(rest)));
        }
    };
    var $author$project$Ui$Timeline$mergeSortedEvents = function(events) {
        return A3($elm$core$List$foldl, F2(function(currentEvent, newEvents) {
            var _v0 = $elm_community$list_extra$List$Extra$unconsLast(newEvents);
            if (!_v0.$) {
                var _v1 = _v0.a;
                var lastEvent = _v1.a;
                var firstBunch = _v1.b;
                return _Utils_eq(currentEvent.M4, lastEvent.M4) ? A2($elm$core$List$append, firstBunch, _List_fromArray([
                    {
                        M4: currentEvent.M4,
                        acM: currentEvent.acM,
                        NQ: lastEvent.NQ + (', ' + currentEvent.NQ)
                    }
                ])) : A2($elm$core$List$append, firstBunch, _List_fromArray([
                    lastEvent,
                    currentEvent
                ]));
            } else return _List_fromArray([
                currentEvent
            ]);
        }), _List_Nil, events);
    };
    var $author$project$Ui$Timeline$compareEvents = F2(function(event1, event2) {
        return A2($justinmimbs$date$Date$compare, event1.M4, event2.M4);
    });
    var $elm$core$List$sortWith = _List_sortWith;
    var $author$project$Ui$Timeline$sort = F2(function(sorting, events) {
        if (!sorting) return A2($elm$core$List$sortWith, $author$project$Ui$Timeline$compareEvents, events);
        else return $elm$core$List$reverse(A2($elm$core$List$sortWith, $author$project$Ui$Timeline$compareEvents, events));
    });
    var $author$project$Formatters$Date$MonthAndDay = {
        $: 1
    };
    var $author$project$Ui$Timeline$viewTimelineEvent = function(event) {
        var dateHtml = function() {
            var _v0 = event.acM;
            if (!_v0.$) {
                var dateDescription = _v0.a;
                return A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text(dateDescription)
                ]));
            } else return A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDay, event.M4))
            ]));
        }();
        return A2($elm$html$Html$li, _List_fromArray([
            $elm$html$Html$Attributes$class('timeline__item')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('timeline__item-content')
            ]), _List_fromArray([
                dateHtml,
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(event.NQ)
                ]))
            ]))
        ]));
    };
    var $author$project$Ui$Timeline$view = F2(function(sorting, events) {
        return A2($elm$html$Html$ul, _List_fromArray([
            $elm$html$Html$Attributes$class('timeline timeline--lg timeline--horizontal')
        ]), A2($elm$core$List$map, $author$project$Ui$Timeline$viewTimelineEvent, $author$project$Ui$Timeline$mergeSortedEvents(A2($author$project$Ui$Timeline$sort, sorting, events))));
    });
    var $author$project$Pages$Admin$InvoiceSettings$viewTimeline = F2(function(currentDate, fields) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Timeline$view, 0, $author$project$Components$InvoiceSetting$Timeline$createTimelineEvents(A2($author$project$Pages$Admin$InvoiceSettings$createTimelineEventAttributes, fields, currentDate)))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$viewForm = F2(function(model, form) {
        var sponsorized = A2($author$project$Formatters$String$sponsorize, model.W1, 'employer');
        var fields = $author$project$Utils$Form$fields(form);
        var hideSponsorInvoicesSection = !fields.Eu ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Pages$Admin$InvoiceSettings$viewHideSponsorInvoices, model.F3, form)
        ])) : $author$project$Utils$Html$empty;
        var enableBillingSection = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.W1) ? !model.F3 && fields.Eu ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Pages$Admin$InvoiceSettings$viewEnableBilling, model.F3, form)
        ])) : $author$project$Utils$Html$empty;
        return _List_fromArray([
            A2($author$project$Pages$Admin$InvoiceSettings$viewTimeline, model.cP, fields),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            enableBillingSection,
            hideSponsorInvoicesSection,
            A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceUpcoming, fields, form, sponsorized),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Pages$Admin$InvoiceSettings$viewInvoiceCreated, fields, sponsorized),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceIssueDate, fields, form, sponsorized),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceAutoPayDate, fields, form, sponsorized),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A3($author$project$Pages$Admin$InvoiceSettings$viewInvoiceDueDate, fields, form, sponsorized),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Pages$Admin$InvoiceSettings$viewInvoiceGracePeriod(fields),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A3($author$project$Pages$Admin$InvoiceSettings$viewIncludeChargeDetails, fields, model, sponsorized),
            A3($author$project$Utils$FeatureGate$gate, 3, $author$project$Api$Practice$Provider(model.W1), $author$project$Pages$Admin$InvoiceSettings$viewChargeRouteToRecurringInvoice(fields))
        ]);
    });
    var $author$project$Pages$Admin$InvoiceSettings$AcceptsAch = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$AcceptsAmex = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$AcceptsCards = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Typography$titleSm = F2(function(options, content) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$h5, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('text-title-sm text-main'), $author$project$Ui$Typography$optionsToAttributes(options)), content));
    });
    var $author$project$Pages$Admin$InvoiceSettings$viewPaymentOptions = F3(function(fields, form, sponsorized) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Payment Options')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Choose payment options available to  ' + (sponsorized + 's.'))
                    ]))
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('ml-1 pl-1')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Accept Bank Accounts')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('pt-05')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$offsetMd(9),
                                    $author$project$Ui$Grid$spanMd(3),
                                    $author$project$Ui$Grid$justifyRight
                                ]), _List_fromArray([
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(fields.Ie),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsAch))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Accept Credit Cards')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('pt-05')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$offsetMd(9),
                                    $author$project$Ui$Grid$spanMd(3),
                                    $author$project$Ui$Grid$justifyRight
                                ]), _List_fromArray([
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(fields.Ig),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsCards))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Accept American Express')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('pt-05')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$offsetMd(9),
                                    $author$project$Ui$Grid$spanMd(3),
                                    $author$project$Ui$Grid$justifyRight
                                ]), _List_fromArray([
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(fields.If),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$InvoiceSettings$PaymentFormFieldUpdated, $author$project$Pages$Admin$InvoiceSettings$AcceptsAmex)),
                                        $author$project$Ui$ToggleSwitch$disabled(!fields.Ig)
                                    ]))
                                ]))
                            ])),
                            A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Admin$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$InvoiceSettings$viewPaymentSettingsForm = F2(function(model, form) {
        var sponsorized = A2($author$project$Formatters$String$sponsorize, model.W1, 'employer');
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A3($author$project$Pages$Admin$InvoiceSettings$viewPaymentOptions, fields, form, sponsorized)
        ]);
    });
    var $author$project$Pages$Admin$InvoiceSettings$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    model.iN ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$InvoiceSettings$HiConfirmClosed, _List_fromArray([
                        $author$project$Components$HiConfirm$verb('Confirm'),
                        $author$project$Components$HiConfirm$noun('Global Settings'),
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('You are changing the global ' + (A2($author$project$Formatters$String$sponsorize, model.W1, 'employer') + (' settings only. This will not affect any ' + (A2($author$project$Formatters$String$sponsorize, model.W1, 'employers') + ' that have setting overrides in place.'))))
                        ]))
                    ])) : $author$project$Utils$Html$empty,
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Example of Upcoming Month')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$div, _List_Nil, function() {
                                var _v0 = model.PU;
                                if (!_v0.$) {
                                    var form = _v0.a;
                                    return A2($author$project$Pages$Admin$InvoiceSettings$viewForm, model, form);
                                } else return _List_fromArray([
                                    A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                                    ]), _List_fromArray([
                                        $author$project$Ui$Spinner$view(_List_Nil)
                                    ]))
                                ]);
                            }()),
                            A2($elm$html$Html$div, _List_Nil, function() {
                                var _v1 = model.aM;
                                if (!_v1.$) {
                                    var form = _v1.a;
                                    return A2($author$project$Pages$Admin$InvoiceSettings$viewPaymentSettingsForm, model, form);
                                } else return _List_fromArray([
                                    A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                                    ]), _List_fromArray([
                                        $author$project$Ui$Spinner$view(_List_Nil)
                                    ]))
                                ]);
                            }())
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            function() {
                                if ($author$project$Utils$Maybe$toBool(model.PU)) {
                                    var nonSubmittable = function() {
                                        var _v2 = model.PU;
                                        if (!_v2.$) {
                                            var form = _v2.a;
                                            return $author$project$Utils$Form$hasAnyValidationError(form);
                                        } else return true;
                                    }();
                                    return A3($author$project$Ui$Button$view, {
                                        abP: 'Update invoice settings'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$primary,
                                        $author$project$Ui$Button$loading(_Utils_eq(model.LL, $author$project$Api$Data$Loading)),
                                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$InvoiceSettings$HiConfirmOpened),
                                        $author$project$Ui$Button$disabled(nonSubmittable)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Update')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Admin | Invoice Settings'
        };
    };
    var $author$project$Pages$Admin$InvoiceSettings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$InvoiceSettings$init,
        aeR: $author$project$Pages$Admin$InvoiceSettings$load,
        ag3: $author$project$Pages$Admin$InvoiceSettings$save,
        ahE: $author$project$Pages$Admin$InvoiceSettings$subscriptions,
        aaO: $author$project$Pages$Admin$InvoiceSettings$update,
        aid: $author$project$Pages$Admin$InvoiceSettings$view
    });
    var $author$project$Pages$Admin$LeadSources$GotItems = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$LeadSource$All$LeadSource = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LeadSource$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LeadSource$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$LeadSource$leadSourcesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'lead_sources'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$LeadSource$listDefaults = {
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$LeadSource$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$LeadSource$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$LeadSource$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$LeadSource$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$LeadSource$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$LeadSource$leadSourcesPath)));
    });
    var $author$project$Pages$Admin$LeadSources$fetchItems = function(model) {
        return A3($author$project$Api$Provider$LeadSource$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_
            });
        }, $author$project$Pages$Admin$LeadSources$GotItems);
    };
    var $author$project$Pages$Admin$LeadSources$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var model = {
            Ej: apiClient,
            $8: $elm$core$Maybe$Nothing,
            dS: $elm$core$Set$empty,
            F6: $elm$core$Maybe$Nothing,
            i$: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$init,
            eQ: _List_Nil
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$LeadSources$fetchItems(model));
    });
    var $author$project$Pages$Admin$LeadSources$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$LeadSources$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$LeadSources$CancelEdit = {
        $: 3
    };
    var $author$project$Pages$Admin$LeadSources$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$LeadSources$TranslationsInputMsg = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$LeadSources$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$LeadSources$CancelEdit)), model.F6)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$LeadSources$HiConfirmClosed), model.$8)),
            $elm$core$Platform$Sub$batch(A2($elm$core$List$map, function(input) {
                return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$LeadSources$TranslationsInputMsg(input.g6), $author$project$Components$TranslationsInput$subscriptions(input));
            }, model.eQ))
        ]));
    };
    var $author$project$Pages$Admin$LeadSources$Deleted = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$LeadSource$leadSourcePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$LeadSource$leadSourcesPath);
    };
    var $author$project$Api$Provider$LeadSource$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$LeadSource$leadSourcePath(id_)));
    });
    var $author$project$Api$Provider$LeadSource$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$LeadSource$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$LeadSource$Shared$name(shared);
    };
    var $author$project$Api$Provider$LeadSource$Shared$showOnOnlineSignup = function(_v0) {
        var record = _v0;
        return record._h;
    };
    var $author$project$Api$Provider$LeadSource$All$showOnOnlineSignup = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$LeadSource$Shared$showOnOnlineSignup(shared);
    };
    var $author$project$Pages$Admin$LeadSources$formFieldsFromItem = function(item) {
        return {
            zr: $author$project$Api$Provider$LeadSource$All$name(item),
            _h: $author$project$Api$Provider$LeadSource$All$showOnOnlineSignup(item)
        };
    };
    var $author$project$Pages$Admin$LeadSources$formFieldsInit = {
        zr: '',
        _h: false
    };
    var $author$project$Pages$Admin$LeadSources$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                zr: string
            });
        } else {
            var bool = field.a;
            return _Utils_update(fields, {
                _h: bool
            });
        }
    });
    var $author$project$Pages$Admin$LeadSources$NameValidation = 0;
    var $author$project$Pages$Admin$LeadSources$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Api$Provider$LeadSource$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$LeadSource$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$LeadSource$Shared$id(shared);
    };
    var $author$project$Components$TranslationsInput$LeadSource = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$leadSource = $author$project$Components$TranslationsInput$LeadSource;
    var $author$project$Api$Provider$LeadSource$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$LeadSource$Shared$name(shared);
    };
    var $author$project$Pages$Admin$LeadSources$Created = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$LeadSource$One$LeadSource = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LeadSource$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LeadSource$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$LeadSource$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('lead_source', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('show_on_online_signup', $elm$json$Json$Encode$bool(fields._h))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$LeadSource$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$LeadSource$leadSourcesPath)));
    });
    var $author$project$Pages$Admin$LeadSources$createItem = F2(function(apiClient, formFields) {
        return A3($author$project$Api$Provider$LeadSource$create, apiClient, $rtfeldman$elm_validate$Validate$fromValid(formFields), $author$project$Pages$Admin$LeadSources$Created);
    });
    var $author$project$Pages$Admin$LeadSources$Updated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$LeadSource$update = F4(function(apiClient, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('lead_source', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('show_on_online_signup', $elm$json$Json$Encode$bool(fields._h))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$LeadSource$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$LeadSource$leadSourcePath(id_))));
    });
    var $author$project$Pages$Admin$LeadSources$updateItem = F3(function(apiClient, id, formFields) {
        return A4($author$project$Api$Provider$LeadSource$update, apiClient, id, $rtfeldman$elm_validate$Validate$fromValid(formFields), $author$project$Pages$Admin$LeadSources$Updated);
    });
    var $author$project$Pages$Admin$LeadSources$saveItem = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Pages$Admin$LeadSources$updateItem, apiClient, id_, formFields);
        } else return A2($author$project$Pages$Admin$LeadSources$createItem, apiClient, formFields);
    });
    var $author$project$Components$TranslationsInput$translatable = function($) {
        return $.g6;
    };
    var $author$project$Pages$Admin$LeadSources$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var items = response.a;
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        i$: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        eQ: A2($elm$core$List$map, function(item) {
                            return $author$project$Components$TranslationsInput$init($author$project$Components$TranslationsInput$leadSource($author$project$Api$Provider$LeadSource$All$id(item)));
                        }, items)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    i$: response,
                    eQ: _List_Nil
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Admin$LeadSources$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var item = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$LeadSource$All$id(item)), $author$project$Utils$Form$init($author$project$Pages$Admin$LeadSources$formFieldsFromItem(item)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var field = msg.a;
                var _v2 = model.F6;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var item = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$LeadSources$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, item))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var form = msg.a;
                var id = msg.b;
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$LeadSources$formFieldsValidator, form);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Admin$LeadSources$saveItem, model.Ej, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 5:
                var item = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Just(item)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v6 = model.F6;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var id = _v7.a;
                    var form = _v7.b;
                    if (response.$ === 3) {
                        var item = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            F6: $elm$core$Maybe$Nothing,
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$LeadSources$fetchItems(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$LeadSource$One$name(item))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                var _v9 = model.F6;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) {
                        var item = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            F6: $elm$core$Maybe$Nothing,
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$LeadSources$fetchItems(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$LeadSource$One$name(item) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var item = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Provider$LeadSource$All$id(item), model.dS),
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$LeadSources$fetchItems(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$LeadSource$All$name(item) + ' was successfully removed.')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Provider$LeadSource$All$id(item), model.dS)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 10:
                var item = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$LeadSource$All$id(item);
                    return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Nothing,
                        dS: A2($elm$core$Set$insert, id, model.dS)
                    }), A3($author$project$Api$Provider$LeadSource$delete, model.Ej, id, $author$project$Pages$Admin$LeadSources$Deleted(item)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var translatable = msg.a;
                var msg_ = msg.b;
                var maybeUpdate = A2($elm$core$Maybe$map, A2($author$project$Components$TranslationsInput$update, model.Ej, msg_), $elm$core$List$head(A2($elm$core$List$filter, function(input) {
                    return _Utils_eq($author$project$Components$TranslationsInput$translatable(input), translatable);
                }, model.eQ)));
                if (maybeUpdate.$ === 1) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    var _v14 = maybeUpdate.a;
                    var translationInput = _v14.a;
                    var translationsCmd = _v14.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        eQ: A2($elm$core$List$map, function(input) {
                            return _Utils_eq($author$project$Components$TranslationsInput$translatable(translationInput), $author$project$Components$TranslationsInput$translatable(input)) ? translationInput : input;
                        }, model.eQ)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$LeadSources$TranslationsInputMsg(translatable), translationsCmd), _List_Nil);
                }
            default:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Admin$LeadSources$fetchItems(newModel), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$LeadSources$New = {
        $: 1
    };
    var $author$project$Pages$Admin$LeadSources$PaginationMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Admin$LeadSources$FormUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$LeadSources$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$LeadSources$Save = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$LeadSources$ShowOnOnlineSignup = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$LeadSources$viewEditModal = F3(function(id, form, item) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Lead Source',
            Tk: _Utils_eq(item, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$LeadSources$CancelEdit,
            Vn: $author$project$Pages$Admin$LeadSources$Save(form)
        };
        var _v0 = $author$project$Utils$Form$fields(form);
        var name = _v0.zr;
        var showOnOnlineSignup = _v0._h;
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(name),
                    $author$project$Ui$Form$Input$placeholder('Online Ad'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$LeadSources$FormUpdated, $author$project$Pages$Admin$LeadSources$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Show On Online Signup')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(showOnOnlineSignup),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$LeadSources$FormUpdated, $author$project$Pages$Admin$LeadSources$ShowOnOnlineSignup))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$LeadSources$help = $elm$core$String$concat(_List_fromArray([
        'Use lead sources to track where new patients are coming from, whether they were a former patient, ',
        'heard about you from a friend, from a website, or from specific marketing. The lead sources ',
        'can be chosen on online signup or assigned directly to a patient. Our signup pages also allow ',
        'specifying a specific lead source using a custom URL, which allows you to track signups ',
        'from a specific email or landing page.'
    ]));
    var $author$project$Pages$Admin$LeadSources$Delete = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$LeadSources$Edit = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$forTranslatable = F2(function(translatable_, inputs) {
        return $elm$core$List$head(A2($elm$core$List$filter, function(input) {
            return _Utils_eq(input.g6, translatable_);
        }, inputs));
    });
    var $author$project$Pages$Admin$LeadSources$isOther = function(item) {
        return $author$project$Api$Provider$LeadSource$All$name(item) === 'Other';
    };
    var $author$project$Ui$Element$ml2 = $author$project$Ui$Element$Margin('ml-2');
    var $author$project$Api$Provider$LeadSource$Shared$patientsCount = function(_v0) {
        var record = _v0;
        return record.Wd;
    };
    var $author$project$Api$Provider$LeadSource$All$patientsCount = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$LeadSource$Shared$patientsCount(shared);
    };
    var $author$project$Pages$Admin$LeadSources$viewItem = F3(function(deletingItems, translationInputs, item) {
        var id = $author$project$Api$Provider$LeadSource$All$id(item);
        var translatable = $author$project$Components$TranslationsInput$leadSource(id);
        var translationInput = A2($author$project$Components$TranslationsInput$forTranslatable, translatable, translationInputs);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$LeadSource$All$name(item)),
                function() {
                    if (!translationInput.$) {
                        var input = translationInput.a;
                        return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$inlineBlock,
                            $author$project$Ui$Element$ml2
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Admin$LeadSources$TranslationsInputMsg(input.g6), A3($author$project$Components$TranslationsInput$view, 'name', _List_fromArray([
                                $author$project$Components$TranslationsInput$default($author$project$Api$Provider$LeadSource$All$name(item))
                            ]), input))
                        ]));
                    } else return $elm$html$Html$text('');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Formatters$Bool$toString($author$project$Api$Provider$LeadSource$All$showOnOnlineSignup(item))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$LeadSource$All$patientsCount(item)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                if ($author$project$Pages$Admin$LeadSources$isOther(item)) return _List_Nil;
                else {
                    var loading = A2($elm$core$Set$member, id, deletingItems);
                    return _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$gap2,
                            $author$project$Ui$Element$justifyRight
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit lead source'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$LeadSources$Edit(item)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Delete lead source'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$loading(loading),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$LeadSources$Delete(item)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Delete')
                            ]))
                        ]))
                    ]);
                }
            }())
        ]));
    });
    var $author$project$Pages$Admin$LeadSources$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.i$;
            if (_v1.$ === 3) {
                var items_ = _v1.a;
                return _Utils_Tuple2(false, items_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var items = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Pages$Admin$LeadSources$help)
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('There are no lead sources.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Name')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Show on online signup')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patients count')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ]), A2($elm$core$List$map, A2($author$project$Pages$Admin$LeadSources$viewItem, model.dS, model.eQ), items), _List_Nil)
        ]);
    };
    var $author$project$Pages$Admin$LeadSources$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.F6;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        var form = _v1.b;
                        var item = _v1.c;
                        return A3($author$project$Pages$Admin$LeadSources$viewEditModal, id, form, item);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.$8;
                    if (!_v2.$) {
                        var item = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$LeadSources$HiConfirmClosed(item), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('lead source'),
                            $author$project$Components$HiConfirm$detail($author$project$Api$Provider$LeadSource$All$name(item))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter,
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Lead Source')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'New lead source'
                            }, _List_fromArray([
                                $author$project$Ui$Button$default,
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$LeadSources$New),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('New Lead Source')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Admin$LeadSources$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$LeadSources$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.i$))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Lead Sources'
        };
    };
    var $author$project$Pages$Admin$LeadSources$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$LeadSources$init,
        aeR: $author$project$Pages$Admin$LeadSources$load,
        ag3: $author$project$Pages$Admin$LeadSources$save,
        ahE: $author$project$Pages$Admin$LeadSources$subscriptions,
        aaO: $author$project$Pages$Admin$LeadSources$update,
        aid: $author$project$Pages$Admin$LeadSources$view
    });
    var $author$project$Pages$Admin$Locations$GotLocationGroups = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$Location = 20;
    var $author$project$Pages$Admin$Locations$urlParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    };
    var $author$project$Pages$Admin$Locations$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Locations)
        ]), $author$project$Pages$Admin$Locations$urlParams(model));
    };
    var $author$project$Pages$Admin$Locations$GotList = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Location$Meta = 0;
    var $author$project$Pages$Admin$Locations$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ]),
                af_: $elm$core$Maybe$Just(model.af_),
                agq: model.agq,
                ahs: model.ahs
            });
        };
    };
    var $author$project$Pages$Admin$Locations$fetchList = function(model) {
        return A3($author$project$Api$Provider$Location$list, model.Ej, $author$project$Pages$Admin$Locations$fetchParams(model), $author$project$Pages$Admin$Locations$GotList);
    };
    var $author$project$Components$Admin$Location$DeleteModal$Closed = {
        $: 0
    };
    var $author$project$Components$Admin$Location$DeleteModal$init = $author$project$Components$Admin$Location$DeleteModal$Closed;
    var $author$project$Components$LinkedRecords$Closed = {
        $: 0
    };
    var $author$project$Components$LinkedRecords$init = $author$project$Components$LinkedRecords$Closed;
    var $author$project$Api$Provider$LocationGroup$All$LocationGroup = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$LocationGroup$All$AllRecord = F2(function(locationsCount, integrationRecords) {
        return {
            Rr: integrationRecords,
            Tr: locationsCount
        };
    });
    var $author$project$Api$Provider$IntegrationRecord$One$IntegrationRecord = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$IntegrationRecord$Shared$IntegrationRecord = $elm$core$Basics$identity;
    var $author$project$Api$Provider$IntegrationRecord$Shared$Record = F7(function(integrationSyncStatus, integrationLastSyncedAt, integrationRecordId, unsyncedReason, errorMessage, webLink, meta) {
        return {
            O4: errorMessage,
            Rp: integrationLastSyncedAt,
            Rq: integrationRecordId,
            Rs: integrationSyncStatus,
            Ue: meta,
            aaJ: unsyncedReason,
            abh: webLink
        };
    });
    var $author$project$Api$IntegrationRecord$Status$Enabled = 3;
    var $author$project$Api$IntegrationRecord$Status$Errored = 2;
    var $author$project$Api$IntegrationRecord$Status$Synced = 0;
    var $author$project$Api$IntegrationRecord$Status$Unsynced = 1;
    var $author$project$Api$IntegrationRecord$Status$decode = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'synced':
                return $elm$json$Json$Decode$succeed(0);
            case 'unsynced':
                return $elm$json$Json$Decode$succeed(1);
            case 'errored':
                return $elm$json$Json$Decode$succeed(2);
            case 'enabled':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail('Unsupported integration record status: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$IntegrationRecord$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$IntegrationRecord$Meta$Record = function(actions) {
        return {
            tM: actions
        };
    };
    var $author$project$Api$Provider$IntegrationRecord$Meta$Action = F3(function(name, description, available) {
        return {
            abS: available,
            NQ: description,
            zr: name
        };
    });
    var $author$project$Api$Provider$IntegrationRecord$Meta$CopyToClipboard = 1;
    var $author$project$Api$Provider$IntegrationRecord$Meta$EditPartnerId = 3;
    var $author$project$Api$Provider$IntegrationRecord$Meta$ForcePushData = 2;
    var $author$project$Api$Provider$IntegrationRecord$Meta$Unlink = 0;
    var $author$project$Api$Provider$IntegrationRecord$Meta$actionNameDecoder = function(string) {
        switch(string){
            case 'unlink':
                return $elm$json$Json$Decode$succeed(0);
            case 'copy_to_clipboard':
                return $elm$json$Json$Decode$succeed(1);
            case 'force_push_data':
                return $elm$json$Json$Decode$succeed(2);
            case 'edit_partner_id':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail('Unsupported integration record action: ' + string);
        }
    };
    var $author$project$Api$Provider$IntegrationRecord$Meta$actionDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'available', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$IntegrationRecord$Meta$actionNameDecoder, $elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Meta$Action))));
    var $author$project$Api$Provider$IntegrationRecord$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$Meta$actionDecoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Meta$Record));
    var $author$project$Api$Provider$IntegrationRecord$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$IntegrationRecord$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$IntegrationRecord$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$IntegrationRecord$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration_web_link', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'unsynced_reason', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration_record_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration_last_synced_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration_sync_status', $author$project$Api$IntegrationRecord$Status$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$Shared$Record))))))));
    var $author$project$Api$Provider$IntegrationRecord$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$IntegrationRecord$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$IntegrationRecord$One$Athena = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$IntegrationRecord$One$None = {
        $: 1
    };
    var $author$project$Api$Provider$IntegrationRecord$One$Record = F2(function(integration, metadata) {
        return {
            Rn: integration,
            Uf: metadata
        };
    });
    var $author$project$Api$Provider$Integration$SharedWithInlinePartner$Integration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Integration$SharedWithInlinePartner$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Partner$Shared$decoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$SharedWithInlinePartner$Integration)));
    var $author$project$Api$Provider$IntegrationRecord$One$MetadataRecord = function(localPatientId) {
        return {
            aeS: localPatientId
        };
    };
    var $author$project$Api$Provider$IntegrationRecord$One$metadataDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'athena_local_patient_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$MetadataRecord));
    var $author$project$Api$Provider$IntegrationRecord$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'metadata', $elm$json$Json$Decode$oneOf(_List_fromArray([
        A2($elm$json$Json$Decode$map, $author$project$Api$Provider$IntegrationRecord$One$Athena, $author$project$Api$Provider$IntegrationRecord$One$metadataDecoder),
        $elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$None)
    ])), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration', $author$project$Api$Provider$Integration$SharedWithInlinePartner$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$Record)));
    var $author$project$Api$Provider$IntegrationRecord$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$IntegrationRecord$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$IntegrationRecord$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$IntegrationRecord$One$IntegrationRecord)));
    var $author$project$Api$Provider$LocationGroup$All$recordDecoder = A3($author$project$Api$Expandable$expandable, 'integration_records', $elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'locations_count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LocationGroup$All$AllRecord)));
    var $author$project$Api$Provider$LocationGroup$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LocationGroup$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$LocationGroup$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LocationGroup$All$LocationGroup)));
    var $author$project$Api$Provider$LocationGroup$expandToString = function(expand) {
        return 'integration_records';
    };
    var $author$project$Api$Provider$LocationGroup$listDefaults = {
        Fq: _List_Nil,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Provider$LocationGroup$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$LocationGroup$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$LocationGroup$expandToString, options.Fq),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$LocationGroup$locationGroupsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'location_groups'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$LocationGroup$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$LocationGroup$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$LocationGroup$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$LocationGroup$locationGroupsPath)));
    });
    var $author$project$Pages$Admin$Locations$init = F4(function(_v0, practice, shared, _v1) {
        var query = _v1.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: shared.Ej,
            ia: $author$project$Components$Admin$Location$DeleteModal$init,
            $8: $elm$core$Maybe$Nothing,
            dS: $elm$core$Set$empty,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 20
            }),
            F3: $author$project$Shared$isHintAdmin(shared),
            F6: $elm$core$Maybe$Nothing,
            i$: $author$project$Api$Data$Loading,
            mV: $author$project$Components$LinkedRecords$init,
            Tl: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$initFromQuery(query))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Admin$Locations$fetchList(model),
            A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
            A3($author$project$Api$Provider$LocationGroup$list, model.Ej, $elm$core$Basics$identity, $author$project$Pages$Admin$Locations$GotLocationGroups)
        ])));
    });
    var $author$project$Pages$Admin$Locations$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Locations$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Locations$AddressInputMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$CancelEdit = {
        $: 9
    };
    var $author$project$Pages$Admin$Locations$DeleteModalMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$ExportCsvMsg = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Locations$LinkedRecordsMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$PhoneInputMsg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$AddressInput$AddressSuggestionsReceived = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$AddressInput$PlaceDetailsReceived = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Ports$GooglePlaces$googlePlacesAutocompleteSuggestionsResponse = _Platform_incomingPort('googlePlacesAutocompleteSuggestionsResponse', A2($elm$json$Json$Decode$andThen, function(suggestions) {
        return A2($elm$json$Json$Decode$andThen, function(id) {
            return $elm$json$Json$Decode$succeed({
                aef: id,
                ahF: suggestions
            });
        }, A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'suggestions', $elm$json$Json$Decode$value)));
    var $author$project$Ports$GooglePlaces$autocompleteSuggestionsResponse = function(decoder) {
        return $author$project$Ports$GooglePlaces$googlePlacesAutocompleteSuggestionsResponse(decoder);
    };
    var $author$project$Api$GoogleMaps$AutocompleteSuggestion$AutocompleteSuggestion = F3(function(description, placeId, types) {
        return {
            NQ: description,
            WK: placeId,
            ah6: types
        };
    });
    var $author$project$Api$GoogleMaps$AutocompleteSuggestion$decoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'types', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'place_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$AutocompleteSuggestion$AutocompleteSuggestion))));
    var $author$project$Api$GoogleMaps$AutocompleteSuggestion$decodeList = $elm$json$Json$Decode$list($author$project$Api$GoogleMaps$AutocompleteSuggestion$decoder);
    var $author$project$Api$GoogleMaps$AutocompleteSuggestion$onGetAutocompleteSuggestionsResponse = function(toMsg) {
        return $author$project$Ports$GooglePlaces$autocompleteSuggestionsResponse(function(_v0) {
            var id = _v0.aef;
            var suggestions = _v0.ahF;
            return A2(toMsg, id, A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeValue, $author$project$Api$GoogleMaps$AutocompleteSuggestion$decodeList, suggestions)));
        });
    };
    var $author$project$Api$GoogleMaps$Place$Place = F5(function(addressComponents, formattedAddress, name, placeId, types) {
        return {
            D8: addressComponents,
            adX: formattedAddress,
            zr: name,
            WK: placeId,
            ah6: types
        };
    });
    var $author$project$Api$GoogleMaps$Place$AddressComponent = F3(function(longName, shortName, types) {
        return {
            Tv: longName,
            Z9: shortName,
            ah6: types
        };
    });
    var $author$project$Api$GoogleMaps$Place$OtherComponent = 37;
    var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel1 = 5;
    var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel2 = 6;
    var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel3 = 7;
    var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel4 = 8;
    var $author$project$Api$GoogleMaps$Place$AdministrativeAreaLevel5 = 9;
    var $author$project$Api$GoogleMaps$Place$Airport = 23;
    var $author$project$Api$GoogleMaps$Place$BusStation = 33;
    var $author$project$Api$GoogleMaps$Place$ColloquialArea = 10;
    var $author$project$Api$GoogleMaps$Place$Country = 4;
    var $author$project$Api$GoogleMaps$Place$Establishment = 29;
    var $author$project$Api$GoogleMaps$Place$Floor = 27;
    var $author$project$Api$GoogleMaps$Place$Intersection = 2;
    var $author$project$Api$GoogleMaps$Place$Locality = 11;
    var $author$project$Api$GoogleMaps$Place$NaturalFeature = 22;
    var $author$project$Api$GoogleMaps$Place$Neighborhood = 18;
    var $author$project$Api$GoogleMaps$Place$Park = 24;
    var $author$project$Api$GoogleMaps$Place$Parking = 31;
    var $author$project$Api$GoogleMaps$Place$PointOfInterest = 30;
    var $author$project$Api$GoogleMaps$Place$Political = 3;
    var $author$project$Api$GoogleMaps$Place$PostBox = 25;
    var $author$project$Api$GoogleMaps$Place$PostalCode = 21;
    var $author$project$Api$GoogleMaps$Place$PostalCodeSuffix = 36;
    var $author$project$Api$GoogleMaps$Place$PostalTown = 32;
    var $author$project$Api$GoogleMaps$Place$Premise = 19;
    var $author$project$Api$GoogleMaps$Place$Room = 28;
    var $author$project$Api$GoogleMaps$Place$Route = 1;
    var $author$project$Api$GoogleMaps$Place$StreetAddress = 0;
    var $author$project$Api$GoogleMaps$Place$StreetNumber = 26;
    var $author$project$Api$GoogleMaps$Place$Sublocality = 12;
    var $author$project$Api$GoogleMaps$Place$SublocalityLevel1 = 13;
    var $author$project$Api$GoogleMaps$Place$SublocalityLevel2 = 14;
    var $author$project$Api$GoogleMaps$Place$SublocalityLevel3 = 15;
    var $author$project$Api$GoogleMaps$Place$SublocalityLevel4 = 16;
    var $author$project$Api$GoogleMaps$Place$SublocalityLevel5 = 17;
    var $author$project$Api$GoogleMaps$Place$Subpremise = 20;
    var $author$project$Api$GoogleMaps$Place$TrainStation = 34;
    var $author$project$Api$GoogleMaps$Place$TransitStation = 35;
    var $author$project$Api$GoogleMaps$Place$componentTypeList = _List_fromArray([
        _Utils_Tuple2('street_address', 0),
        _Utils_Tuple2('route', 1),
        _Utils_Tuple2('intersection', 2),
        _Utils_Tuple2('political', 3),
        _Utils_Tuple2('country', 4),
        _Utils_Tuple2('administrative_area_level_1', 5),
        _Utils_Tuple2('administrative_area_level_2', 6),
        _Utils_Tuple2('administrative_area_level_3', 7),
        _Utils_Tuple2('administrative_area_level_4', 8),
        _Utils_Tuple2('administrative_area_level_5', 9),
        _Utils_Tuple2('colloquial_area', 10),
        _Utils_Tuple2('locality', 11),
        _Utils_Tuple2('sublocality', 12),
        _Utils_Tuple2('sublocality_level_1', 13),
        _Utils_Tuple2('sublocality_level_2', 14),
        _Utils_Tuple2('sublocality_level_3', 15),
        _Utils_Tuple2('sublocality_level_4', 16),
        _Utils_Tuple2('sublocality_level_5', 17),
        _Utils_Tuple2('neighborhood', 18),
        _Utils_Tuple2('premise', 19),
        _Utils_Tuple2('subpremise', 20),
        _Utils_Tuple2('postal_code', 21),
        _Utils_Tuple2('natural_feature', 22),
        _Utils_Tuple2('airport', 23),
        _Utils_Tuple2('park', 24),
        _Utils_Tuple2('post_box', 25),
        _Utils_Tuple2('street_number', 26),
        _Utils_Tuple2('floor', 27),
        _Utils_Tuple2('room', 28),
        _Utils_Tuple2('establishment', 29),
        _Utils_Tuple2('point_of_interest', 30),
        _Utils_Tuple2('parking', 31),
        _Utils_Tuple2('postal_town', 32),
        _Utils_Tuple2('bus_station', 33),
        _Utils_Tuple2('train_station', 34),
        _Utils_Tuple2('transit_station', 35),
        _Utils_Tuple2('postal_code_suffix', 36)
    ]);
    var $author$project$Api$GoogleMaps$Place$componentTypeMap = $elm$core$Dict$fromList($author$project$Api$GoogleMaps$Place$componentTypeList);
    var $author$project$Api$GoogleMaps$Place$stringToComponentType = function(str) {
        return A2($elm$core$Maybe$withDefault, 37, A2($elm$core$Dict$get, str, $author$project$Api$GoogleMaps$Place$componentTypeMap));
    };
    var $author$project$Api$GoogleMaps$Place$mapComponentType = A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $author$project$Api$GoogleMaps$Place$stringToComponentType);
    var $author$project$Api$GoogleMaps$Place$typeDecoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$GoogleMaps$Place$mapComponentType, $elm$json$Json$Decode$string);
    var $author$project$Api$GoogleMaps$Place$typeListDecoder = $elm$json$Json$Decode$list($author$project$Api$GoogleMaps$Place$typeDecoder);
    var $author$project$Api$GoogleMaps$Place$decodeAddressComponent = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'types', $author$project$Api$GoogleMaps$Place$typeListDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'short_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'long_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$Place$AddressComponent))));
    var $author$project$Api$GoogleMaps$Place$decoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'types', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'place_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'formatted_address', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_components', $elm$json$Json$Decode$list($author$project$Api$GoogleMaps$Place$decodeAddressComponent), $elm$json$Json$Decode$succeed($author$project$Api$GoogleMaps$Place$Place))))));
    var $author$project$Ports$GooglePlaces$googlePlacesPlaceDetailsResponse = _Platform_incomingPort('googlePlacesPlaceDetailsResponse', A2($elm$json$Json$Decode$andThen, function(id) {
        return A2($elm$json$Json$Decode$andThen, function(address) {
            return $elm$json$Json$Decode$succeed({
                II: address,
                aef: id
            });
        }, A2($elm$json$Json$Decode$field, 'address', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)));
    var $author$project$Ports$GooglePlaces$placeDetailsResponse = function(handler) {
        return $author$project$Ports$GooglePlaces$googlePlacesPlaceDetailsResponse(handler);
    };
    var $author$project$Api$GoogleMaps$Place$onGetPlaceDetailsResponse = function(toMsg) {
        return $author$project$Ports$GooglePlaces$placeDetailsResponse(function(_v0) {
            var id = _v0.aef;
            var address = _v0.II;
            return A2(toMsg, id, A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$json$Json$Decode$decodeString, $author$project$Api$GoogleMaps$Place$decoder, address)));
        });
    };
    var $author$project$Components$AddressInput$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(model.hr),
            $author$project$Api$GoogleMaps$AutocompleteSuggestion$onGetAutocompleteSuggestionsResponse($author$project$Components$AddressInput$AddressSuggestionsReceived),
            $author$project$Api$GoogleMaps$Place$onGetPlaceDetailsResponse($author$project$Components$AddressInput$PlaceDetailsReceived)
        ]));
    };
    var $author$project$Components$Admin$Location$DeleteModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Admin$Location$DeleteModal$subscriptions = function(model) {
        if (model.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Location$DeleteModal$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$LinkedRecords$CloseModal = {
        $: 1
    };
    var $author$project$Components$LinkedRecords$subscriptions = function(model) {
        if (model.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$LinkedRecords$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Locations$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v0 = model.F6;
                if (!_v0.$) {
                    var _v1 = _v0.a;
                    var form = _v1.b;
                    var _v2 = $author$project$Utils$Form$fields(form);
                    var phone = _v2.WE;
                    var address = _v2.II;
                    return $elm$core$Platform$Sub$batch(_List_fromArray([
                        A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Locations$PhoneInputMsg, $author$project$Components$PhoneInput$subscriptions(phone)),
                        A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Locations$AddressInputMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$AddressInput$subscriptions, address)))
                    ]));
                } else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Locations$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Locations$LinkedRecordsMsg, $author$project$Components$LinkedRecords$subscriptions(model.mV)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Locations$DeleteModalMsg, $author$project$Components$Admin$Location$DeleteModal$subscriptions(model.ia)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Locations$CancelEdit)), model.F6)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Locations$HiConfirmClosed), model.$8))
        ]));
    };
    var $author$project$Pages$Admin$Locations$Address = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$Deleted = F2(function(a, b) {
        return {
            $: 15,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Locations$Phone = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$SearchInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Location$locationPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Location$locationsPath);
    };
    var $author$project$Api$Provider$Location$delete = F4(function(apiClient, id_, reassignToLocation, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, function() {
            if (!reassignToLocation.$) {
                var string = reassignToLocation.a;
                return _List_fromArray([
                    A2($author$project$Api$Param$string, 'reassign_to_location_id', string)
                ]);
            } else return _List_Nil;
        }(), $author$project$Api$Data$requestTo($author$project$Api$Provider$Location$locationPath(id_))));
    });
    var $author$project$Pages$Admin$Locations$initPhoneInput = function(phoneNumber) {
        var phone = A2($elm$core$Maybe$map, A2($author$project$Components$PhoneInput$initPhone, $author$project$Api$Common$Phone$Shared$Office, 0), phoneNumber);
        return A3($author$project$Components$PhoneInput$init, 'location-phone-input', A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$singleton, phone)), function(d) {
            return _Utils_update(d, {
                Iz: true,
                abK: false,
                ac_: $author$project$Api$Common$Phone$Shared$Office,
                y_: 1,
                nU: _List_fromArray([
                    0
                ])
            });
        });
    };
    var $author$project$Pages$Admin$Locations$formFieldsForBusinessLocation = function(name) {
        return _Utils_Tuple2({
            II: $elm$core$Maybe$Nothing,
            Kx: true,
            rm: $elm$core$Maybe$Nothing,
            zr: name,
            Vv: true,
            WE: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
            abe: false
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Api$Provider$Location$Shared$businessLocation = function(_v0) {
        var record = _v0;
        return record.Kx;
    };
    var $author$project$Api$Provider$Location$All$businessLocation = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$businessLocation(shared);
    };
    var $author$project$Api$Common$LocationGroup$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Common$LocationGroup$Shared$id = function(_v0) {
        var min = _v0;
        return $author$project$Api$Common$LocationGroup$Min$id(min);
    };
    var $author$project$Api$Provider$Location$Shared$locationGroup = function(_v0) {
        var record = _v0;
        return record.rm;
    };
    var $author$project$Api$Provider$Location$All$locationGroup = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$locationGroup(shared);
    };
    var $author$project$Api$Provider$Location$Shared$onlineSignupVisibility = function(_v0) {
        var record = _v0;
        return record.Vv;
    };
    var $author$project$Api$Provider$Location$All$onlineSignupVisibility = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$onlineSignupVisibility(shared);
    };
    var $author$project$Api$Provider$Location$Shared$virtual = function(_v0) {
        var record = _v0;
        return record.abe;
    };
    var $author$project$Api$Provider$Location$All$virtual = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$virtual(shared);
    };
    var $author$project$Pages$Admin$Locations$formFieldsFromBusinessLocation = function(location1) {
        return _Utils_Tuple2({
            II: $elm$core$Maybe$Nothing,
            Kx: $author$project$Api$Provider$Location$All$businessLocation(location1),
            rm: A2($elm$core$Maybe$map, $author$project$Api$Common$LocationGroup$Shared$id, $author$project$Api$Provider$Location$All$locationGroup(location1)),
            zr: $author$project$Api$Provider$Location$All$name(location1),
            Vv: $author$project$Api$Provider$Location$All$onlineSignupVisibility(location1),
            WE: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
            abe: $author$project$Api$Provider$Location$All$virtual(location1)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Api$Provider$Location$Shared$address = function(_v0) {
        var record = _v0;
        return record.II;
    };
    var $author$project$Api$Provider$Location$All$address = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$address(shared);
    };
    var $author$project$Api$Common$Address$Shared$country = function(_v0) {
        var record = _v0;
        return record.p0;
    };
    var $author$project$Components$AddressInput$formFieldsFromMaybeAddress = function(address) {
        return {
            cx: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line1, address),
            e$: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line2, address),
            pW: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$city, address),
            p0: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$country, address),
            s4: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$state, address),
            tK: A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, address)
        };
    };
    var $author$project$Components$AddressInput$Address1DropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$AddressInput$Model = $elm$core$Basics$identity;
    var $author$project$Components$AddressInput$initFromFields = F2(function(id, fields) {
        return _Utils_Tuple2({
            hr: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: id + '-address1-dropdown',
                ahX: $author$project$Components$AddressInput$Address1DropdownMsg
            })),
            h7: $jinjor$elm_debounce$Debounce$init,
            PU: $author$project$Utils$Form$init(fields),
            aef: id,
            agM: false,
            aQ: true,
            ahF: _List_Nil
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$AddressInput$initFromApi = F2(function(id, address) {
        return A2($author$project$Components$AddressInput$initFromFields, id, $author$project$Components$AddressInput$formFieldsFromMaybeAddress(address));
    });
    var $author$project$Api$Provider$Location$Shared$phoneNumber = function(_v0) {
        var record = _v0;
        return record.WF;
    };
    var $author$project$Api$Provider$Location$All$phoneNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Location$Shared$phoneNumber(shared);
    };
    var $author$project$Components$AddressInput$withRequired = F2(function(required_, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            agM: required_
        });
    });
    var $author$project$Pages$Admin$Locations$formFieldsFromItem = function(location1) {
        var _v0 = A2($author$project$Components$AddressInput$initFromApi, 'location-' + $author$project$Api$Provider$Location$All$id(location1), $author$project$Api$Provider$Location$All$address(location1));
        var addressInput = _v0.a;
        var addressInputCmd = _v0.b;
        return _Utils_Tuple2({
            II: $elm$core$Maybe$Just(A2($author$project$Components$AddressInput$withRequired, !$author$project$Api$Provider$Location$All$virtual(location1), addressInput)),
            Kx: $author$project$Api$Provider$Location$All$businessLocation(location1),
            rm: A2($elm$core$Maybe$map, $author$project$Api$Common$LocationGroup$Shared$id, $author$project$Api$Provider$Location$All$locationGroup(location1)),
            zr: $author$project$Api$Provider$Location$All$name(location1),
            Vv: $author$project$Api$Provider$Location$All$onlineSignupVisibility(location1),
            WE: $author$project$Pages$Admin$Locations$initPhoneInput($author$project$Api$Provider$Location$All$phoneNumber(location1)),
            abe: $author$project$Api$Provider$Location$All$virtual(location1)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd));
    };
    var $author$project$Components$AddressInput$formFieldsInit = {
        cx: $elm$core$Maybe$Nothing,
        e$: $elm$core$Maybe$Nothing,
        pW: $elm$core$Maybe$Nothing,
        p0: $elm$core$Maybe$Nothing,
        s4: $elm$core$Maybe$Nothing,
        tK: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$AddressInput$init = function(id) {
        return A2($author$project$Components$AddressInput$initFromFields, id, $author$project$Components$AddressInput$formFieldsInit);
    };
    var $author$project$Pages$Admin$Locations$formFieldsInit = function() {
        var _v0 = $author$project$Components$AddressInput$init('new-location');
        var addressInput = _v0.a;
        var addressInputCmd = _v0.b;
        return _Utils_Tuple2({
            II: $elm$core$Maybe$Just(A2($author$project$Components$AddressInput$withRequired, true, addressInput)),
            Kx: false,
            rm: $elm$core$Maybe$Nothing,
            zr: '',
            Vv: true,
            WE: $author$project$Pages$Admin$Locations$initPhoneInput($elm$core$Maybe$Nothing),
            abe: false
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd));
    }();
    var $author$project$Pages$Admin$Locations$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    II: A2($elm$core$Maybe$map, $author$project$Components$AddressInput$withRequired(!bool), fields.II),
                    abe: bool
                });
            case 3:
                var string = field.a;
                var locationGroup = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
                return _Utils_update(fields, {
                    rm: locationGroup
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    Vv: bool
                });
            case 4:
                var phone = field.a;
                return _Utils_update(fields, {
                    WE: phone
                });
            default:
                var address = field.a;
                return _Utils_update(fields, {
                    II: $elm$core$Maybe$Just(address)
                });
        }
    });
    var $author$project$Pages$Admin$Locations$NameValidation = 0;
    var $author$project$Pages$Admin$Locations$AddressValidation = 2;
    var $author$project$Components$AddressInput$AddressValidation = 0;
    var $author$project$Components$AddressInput$hasAnyAddressData = F2(function(showCountry, fields) {
        return $author$project$Utils$Maybe$toBool(fields.cx) || $author$project$Utils$Maybe$toBool(fields.pW) || $author$project$Utils$Maybe$toBool(fields.s4) || $author$project$Utils$Maybe$toBool(fields.tK) || showCountry && $author$project$Utils$Maybe$toBool(fields.p0);
    });
    var $author$project$Components$AddressInput$validateAddress1 = F2(function(config, fields) {
        var effectiveRequired = config.mK || A2($author$project$Components$AddressInput$hasAnyAddressData, config.aQ, fields);
        return effectiveRequired && !$author$project$Utils$Maybe$toBool(fields.cx) ? _List_fromArray([
            _Utils_Tuple2(0, 'Please enter an address.')
        ]) : _List_Nil;
    });
    var $author$project$Components$AddressInput$validateAddress1MaxLength = function(_v0) {
        var address1 = _v0.cx;
        if (!address1.$) {
            var value = address1.a;
            return $elm$core$String$length(value) > 50 ? _List_fromArray([
                _Utils_Tuple2(0, 'Address line 1 must be 50 characters or less.')
            ]) : _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Components$AddressInput$validateAddress2MaxLength = function(_v0) {
        var address2 = _v0.e$;
        if (!address2.$) {
            var value = address2.a;
            return $elm$core$String$length(value) > 50 ? _List_fromArray([
                _Utils_Tuple2(0, 'Address line 2 must be 50 characters or less.')
            ]) : _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Components$AddressInput$CityValidation = 1;
    var $author$project$Components$AddressInput$validateCity = F2(function(config, fields) {
        var effectiveRequired = config.mK || A2($author$project$Components$AddressInput$hasAnyAddressData, config.aQ, fields);
        return effectiveRequired && !$author$project$Utils$Maybe$toBool(fields.pW) ? _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a city.')
        ]) : _List_Nil;
    });
    var $author$project$Components$AddressInput$StateValidation = 2;
    var $author$project$Components$AddressInput$validateState = F2(function(config, fields) {
        var effectiveRequired = config.mK || A2($author$project$Components$AddressInput$hasAnyAddressData, config.aQ, fields);
        return effectiveRequired && !$author$project$Utils$Maybe$toBool(fields.s4) ? _List_fromArray([
            _Utils_Tuple2(2, 'Please enter a state.')
        ]) : _List_Nil;
    });
    var $author$project$Components$AddressInput$ZipValidation = 3;
    var $author$project$Components$AddressInput$validateZip = F2(function(config, fields) {
        var effectiveRequired = config.mK || A2($author$project$Components$AddressInput$hasAnyAddressData, config.aQ, fields);
        return effectiveRequired && !$author$project$Utils$Maybe$toBool(fields.tK) ? _List_fromArray([
            _Utils_Tuple2(3, 'Please enter a zip code.')
        ]) : _List_Nil;
    });
    var $author$project$Components$AddressInput$formFieldsValidator = function(config) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateAddress1(config)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateAddress1MaxLength),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateAddress2MaxLength),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateCity(config)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateState(config)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$AddressInput$validateZip(config))
        ]));
    };
    var $author$project$Components$AddressInput$validateForm = function(model) {
        var config = {
            mK: model.agM,
            aQ: model.aQ
        };
        var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$AddressInput$formFieldsValidator(config), model.PU);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var form = _v1.a;
            return _Utils_Tuple2(form, true);
        } else {
            var form = _v0.a;
            return _Utils_Tuple2(form, false);
        }
    };
    var $author$project$Components$AddressInput$isValid = function(_v0) {
        var model = _v0;
        return $author$project$Components$AddressInput$validateForm(model).b;
    };
    var $author$project$Pages$Admin$Locations$validateAddress = function(fields) {
        var _v0 = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$isValid, fields.II);
        if (!_v0.$ && !_v0.a) return _List_fromArray([
            _Utils_Tuple2(2, 'Please enter an address')
        ]);
        else return _List_Nil;
    };
    var $author$project$Pages$Admin$Locations$LocationGroupValidation = 1;
    var $author$project$Pages$Admin$Locations$validateLocationGroup = F2(function(requireGroupForLocations, fields) {
        var _v0 = _Utils_Tuple2(requireGroupForLocations, fields.rm);
        if (_v0.a && _v0.b.$ === 1) {
            var _v1 = _v0.b;
            return _List_fromArray([
                _Utils_Tuple2(1, 'Please pick a location group')
            ]);
        } else return _List_Nil;
    });
    var $author$project$Pages$Admin$Locations$PhoneValidation = 3;
    var $author$project$Pages$Admin$Locations$validatePhone = function(fields) {
        var _v0 = $author$project$Components$PhoneInput$getPhones(fields.WE);
        if (!_v0.$) return _List_Nil;
        else return _List_fromArray([
            _Utils_Tuple2(3, 'Please enter a valid phone')
        ]);
    };
    var $author$project$Pages$Admin$Locations$formFieldsValidator = function(requireGroupForLocations) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.zr;
            }, _Utils_Tuple2(0, 'Please enter a name.')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Locations$validateLocationGroup(requireGroupForLocations)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Locations$validateAddress),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Locations$validatePhone)
        ]));
    };
    var $author$project$Api$Provider$Location$All$hasPatients = function(_v0) {
        var record = _v0.b;
        return record.Qu;
    };
    var $author$project$Api$Provider$Location$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Location$Shared$name(shared);
    };
    var $author$project$Components$Admin$Location$DeleteModal$Open = F4(function(a, b, c, d) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Components$Admin$Location$DeleteModal$Reassign = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment = {
        $: 1
    };
    var $author$project$Components$Admin$Location$DeleteModal$open = F2(function(location1, remainingLocations) {
        var action = $elm$core$List$isEmpty(remainingLocations) ? $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment : $author$project$Components$Admin$Location$DeleteModal$Reassign($elm$core$Maybe$Nothing);
        return A4($author$project$Components$Admin$Location$DeleteModal$Open, location1, remainingLocations, action, $author$project$Api$Data$NotAsked);
    });
    var $author$project$Api$Provider$Practice$One$requireGroupForLocations = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.agL;
    });
    var $author$project$Pages$Admin$Locations$Created = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Provider$Location$One$Location = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Location$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Location$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Address$Shared$encode = function(address) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('line1', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.ri)),
            _Utils_Tuple2('line2', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.yG)),
            _Utils_Tuple2('city', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.pW)),
            _Utils_Tuple2('state', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.s4)),
            _Utils_Tuple2('zip', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.tK)),
            _Utils_Tuple2('country', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.p0))
        ]));
    };
    var $author$project$Api$Provider$Location$create = F3(function(apiClient, fields, toMsg) {
        var addressField = function() {
            var _v0 = fields.II;
            if (!_v0.$) {
                var address__ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('address', $author$project$Api$Common$Address$Shared$encode(address__))
                ]);
            } else return _List_Nil;
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('location', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('online_signup_visibility', $elm$json$Json$Encode$bool(fields.Vv)), A2($elm$core$List$cons, _Utils_Tuple2('phone_number', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeR, function($) {
                return $.Gx;
            }, $elm$json$Json$Encode$string), fields.WE)), A2($elm$core$List$cons, _Utils_Tuple2('virtual', $elm$json$Json$Encode$bool(fields.abe)), A2($elm$core$List$cons, _Utils_Tuple2('business_location', $elm$json$Json$Encode$bool(fields.Kx)), A2($elm$core$List$cons, _Utils_Tuple2('location_group', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.rm)), addressField))))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Location$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Location$locationsPath)));
    });
    var $author$project$Components$AddressInput$getAddress = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return {
            pW: fields.pW,
            p0: fields.p0,
            ri: fields.cx,
            yG: fields.e$,
            s4: fields.s4,
            tK: fields.tK
        };
    };
    var $author$project$Pages$Admin$Locations$locationFromFields = function(fields) {
        var phone = A2($elm$core$Maybe$andThen, $elm$core$List$head, $author$project$Components$PhoneInput$getPhones(fields.WE));
        var address = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$getAddress, fields.II);
        return {
            II: address,
            Kx: fields.Kx,
            rm: fields.rm,
            zr: fields.zr,
            Vv: fields.Vv,
            WE: phone,
            abe: fields.abe
        };
    };
    var $author$project$Pages$Admin$Locations$createItem = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Location$create, apiClient, $author$project$Pages$Admin$Locations$locationFromFields(fields), $author$project$Pages$Admin$Locations$Created);
    });
    var $author$project$Pages$Admin$Locations$Updated = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Api$Provider$Location$update = F4(function(apiClient, id_, fields, toMsg) {
        var addressField = function() {
            var _v0 = fields.II;
            if (!_v0.$) {
                var address__ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('address', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('line1', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.ri)),
                        _Utils_Tuple2('line2', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.yG)),
                        _Utils_Tuple2('city', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.pW)),
                        _Utils_Tuple2('state', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.s4)),
                        _Utils_Tuple2('zip', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.tK)),
                        _Utils_Tuple2('country', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address__.p0))
                    ])))
                ]);
            } else return _List_Nil;
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('location', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('online_signup_visibility', $elm$json$Json$Encode$bool(fields.Vv)), A2($elm$core$List$cons, _Utils_Tuple2('phone_number', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeR, function($) {
                return $.Gx;
            }, $elm$json$Json$Encode$string), fields.WE)), A2($elm$core$List$cons, _Utils_Tuple2('virtual', $elm$json$Json$Encode$bool(fields.abe)), A2($elm$core$List$cons, _Utils_Tuple2('business_location', $elm$json$Json$Encode$bool(fields.Kx)), A2($elm$core$List$cons, _Utils_Tuple2('location_group', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.rm)), addressField))))))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Location$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Location$locationPath(id_))));
    });
    var $author$project$Pages$Admin$Locations$updateItem = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Location$update, apiClient, id, $author$project$Pages$Admin$Locations$locationFromFields(fields), $author$project$Pages$Admin$Locations$Updated);
    });
    var $author$project$Pages$Admin$Locations$saveItem = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Pages$Admin$Locations$updateItem, apiClient, id_, formFields);
        } else return A2($author$project$Pages$Admin$Locations$createItem, apiClient, formFields);
    });
    var $author$project$Api$Provider$Practice$One$trackPatientsByLocation = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.aaq;
    });
    var $author$project$Components$AddressInput$Address1 = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$AddressInput$PerformSearch = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$AddressInput$debounceAddress = function(address) {
        return A2($elm$core$Task$perform, $author$project$Components$AddressInput$PerformSearch, $elm$core$Task$succeed(address));
    };
    var $author$project$Components$AddressInput$DebounceMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$AddressInput$debounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(300),
        ah3: $author$project$Components$AddressInput$DebounceMsg
    };
    var $author$project$Components$AddressInput$formFieldsUpdate = F2(function(field, form) {
        switch(field.$){
            case 0:
                var address1 = field.a;
                return _Utils_update(form, {
                    cx: address1
                });
            case 1:
                var address2 = field.a;
                return _Utils_update(form, {
                    e$: address2
                });
            case 2:
                var city = field.a;
                return _Utils_update(form, {
                    pW: city
                });
            case 3:
                var state = field.a;
                return _Utils_update(form, {
                    s4: state
                });
            case 4:
                var zip = field.a;
                return _Utils_update(form, {
                    tK: zip
                });
            default:
                var country = field.a;
                return _Utils_update(form, {
                    p0: country
                });
        }
    });
    var $author$project$Ports$GooglePlaces$AddressWithId = F2(function(address, id) {
        return {
            II: address,
            aef: id
        };
    });
    var $author$project$Ports$GooglePlaces$googlePlacesGetAutocompleteSuggestions = _Platform_outgoingPort('googlePlacesGetAutocompleteSuggestions', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('address', $elm$json$Json$Encode$string($.II)),
            _Utils_Tuple2('id', $elm$json$Json$Encode$string($.aef))
        ]));
    });
    var $author$project$Ports$GooglePlaces$getAutocompleteSuggestions = function(addressQuery) {
        return $author$project$Ports$GooglePlaces$googlePlacesGetAutocompleteSuggestions(addressQuery);
    };
    var $author$project$Api$GoogleMaps$AutocompleteSuggestion$getAutocompleteSuggestions = function(_v0) {
        var searchTerm = _v0.ag8;
        var id = _v0.aef;
        return $author$project$Ports$GooglePlaces$getAutocompleteSuggestions(A2($author$project$Ports$GooglePlaces$AddressWithId, searchTerm, id));
    };
    var $author$project$Ports$GooglePlaces$PlaceWithId = F2(function(placeId, id) {
        return {
            aef: id,
            WK: placeId
        };
    });
    var $author$project$Ports$GooglePlaces$googlePlacesGetPlaceDetails = _Platform_outgoingPort('googlePlacesGetPlaceDetails', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string($.aef)),
            _Utils_Tuple2('placeId', $elm$json$Json$Encode$string($.WK))
        ]));
    });
    var $author$project$Ports$GooglePlaces$getPlaceDetails = function(details) {
        return $author$project$Ports$GooglePlaces$googlePlacesGetPlaceDetails(details);
    };
    var $author$project$Api$GoogleMaps$Place$getPlaceDetails = function(_v0) {
        var placeId = _v0.WK;
        var id = _v0.aef;
        return $author$project$Ports$GooglePlaces$getPlaceDetails(A2($author$project$Ports$GooglePlaces$PlaceWithId, placeId, id));
    };
    var $author$project$Api$GoogleMaps$AutocompleteSuggestion$placeId = function(suggestion) {
        return suggestion.WK;
    };
    var $author$project$Components$AddressInput$Address2 = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$AddressInput$City = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$AddressInput$Country = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$AddressInput$State = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$AddressInput$Zip = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$GoogleMaps$Place$getComponentLongName = F2(function(place, componentType) {
        return A2($elm$core$Maybe$map, function($) {
            return $.Tv;
        }, $elm$core$List$head(A2($elm$core$List$filter, function(c) {
            return A2($elm$core$List$member, componentType, c.ah6);
        }, place.D8)));
    });
    var $author$project$Utils$String$ifEmptyThen = F2(function(thenStr, str) {
        return $author$project$Utils$String$isBlank(str) ? thenStr : str;
    });
    var $author$project$Components$AddressInput$cityString = function(place) {
        var subLocality = A2($elm$core$Maybe$withDefault, '', A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 12));
        var locality = A2($elm$core$Maybe$withDefault, '', A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 11));
        return A2($author$project$Utils$String$ifEmptyThen, subLocality, locality);
    };
    var $author$project$Components$AddressInput$countryString = function(place) {
        return A2($elm$core$Maybe$withDefault, '', A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 4));
    };
    var $author$project$Api$GoogleMaps$Place$getComponentShortName = F2(function(place, componentType) {
        return A2($elm$core$Maybe$map, function($) {
            return $.Z9;
        }, $elm$core$List$head(A2($elm$core$List$filter, function(c) {
            return A2($elm$core$List$member, componentType, c.ah6);
        }, place.D8)));
    });
    var $author$project$Components$AddressInput$stateString = function(place) {
        return A2($elm$core$Maybe$withDefault, '', A2($author$project$Api$GoogleMaps$Place$getComponentShortName, place, 5));
    };
    var $author$project$Components$AddressInput$zipString = function(place) {
        return A2($elm$core$Maybe$withDefault, '', A2($author$project$Api$GoogleMaps$Place$getComponentLongName, place, 21));
    };
    var $author$project$Components$AddressInput$updateFormByPlace = F3(function(place, form, showCountry) {
        return (showCountry ? A2($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, $author$project$Components$AddressInput$Country($author$project$Utils$String$toMaybe($author$project$Components$AddressInput$countryString(place)))) : $elm$core$Basics$identity)(A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, $author$project$Components$AddressInput$Zip($author$project$Utils$String$toMaybe($author$project$Components$AddressInput$zipString(place))), A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, $author$project$Components$AddressInput$State($author$project$Utils$String$toMaybe($author$project$Components$AddressInput$stateString(place))), A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, $author$project$Components$AddressInput$City($author$project$Utils$String$toMaybe($author$project$Components$AddressInput$cityString(place))), A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, $author$project$Components$AddressInput$Address2($author$project$Utils$String$toMaybe('')), A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, $author$project$Components$AddressInput$Address1($author$project$Utils$String$toMaybe(place.zr)), form))))));
    });
    var $author$project$Components$AddressInput$validate = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            PU: $author$project$Components$AddressInput$validateForm(model).a
        });
    };
    var $author$project$Components$AddressInput$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                if (!msg.a.$) {
                    var address = msg.a.a;
                    var updatedModel = _Utils_update(model, {
                        PU: A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, $author$project$Components$AddressInput$Address1(address), model.PU)
                    });
                    var _v2 = function() {
                        if (!address.$) {
                            var addressText = address.a;
                            return A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$AddressInput$debounceConfig, addressText, model.h7);
                        } else return _Utils_Tuple2(model.h7, $elm$core$Platform$Cmd$none);
                    }();
                    var debounce = _v2.a;
                    var cmd = _v2.b;
                    return _Utils_Tuple3(_Utils_update(updatedModel, {
                        h7: debounce
                    }), cmd, _List_Nil);
                } else {
                    var field = msg.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, field, model.PU)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                return _Utils_Tuple3($author$project$Components$AddressInput$validate(model), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var subMsg = msg.a;
                var wasOpen = model.hr.Vw;
                var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.hr);
                var address1Dropdown = _v4.a;
                var cmd = _v4.b;
                var updatedModel = _Utils_update(model, {
                    hr: address1Dropdown
                });
                return wasOpen && !address1Dropdown.Vw ? _Utils_Tuple3($author$project$Components$AddressInput$validate(updatedModel), cmd, _List_Nil) : _Utils_Tuple3(updatedModel, cmd, _List_Nil);
            case 4:
                var debounceMsg = msg.a;
                var _v5 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$AddressInput$debounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$AddressInput$debounceAddress), debounceMsg, model.h7);
                var debounce = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    h7: debounce
                }), cmd, _List_Nil);
            case 5:
                var searchTerm = msg.a;
                return _Utils_Tuple3(model, $author$project$Api$GoogleMaps$AutocompleteSuggestion$getAutocompleteSuggestions({
                    aef: model.aef,
                    ag8: searchTerm
                }), _List_Nil);
            case 2:
                var id = msg.a;
                var placeResult = msg.b;
                if (_Utils_eq(id, model.aef)) {
                    if (!placeResult.$) {
                        var place = placeResult.a;
                        var newForm = A3($author$project$Components$AddressInput$updateFormByPlace, place, model.PU, model.aQ);
                        var newModel = _Utils_update(model, {
                            PU: newForm
                        });
                        return _Utils_Tuple3($author$project$Components$AddressInput$validate(newModel), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else {
                        var error = placeResult.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$DecodeFailed(error)
                        ]));
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var id = msg.a;
                var suggestionsResult = msg.b;
                if (_Utils_eq(id, model.aef)) {
                    if (!suggestionsResult.$) {
                        var suggestions = suggestionsResult.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ahF: suggestions
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else {
                        var error = suggestionsResult.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ahF: _List_Nil
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$DecodeFailed(error)
                        ]));
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var suggestion = msg.a;
                var updatedModel = _Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$AddressInput$formFieldsUpdate, $author$project$Components$AddressInput$Address1($elm$core$Maybe$Just(suggestion.NQ)), model.PU),
                    ahF: _List_Nil
                });
                return _Utils_Tuple3(updatedModel, $author$project$Api$GoogleMaps$Place$getPlaceDetails({
                    aef: model.aef,
                    WK: $author$project$Api$GoogleMaps$AutocompleteSuggestion$placeId(suggestion)
                }), _List_Nil);
        }
    });
    var $author$project$Components$Admin$Location$DeleteModal$Deleted = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Location$DeleteModal$LocationDeleted = 1;
    var $author$project$Components$Admin$Location$DeleteModal$None = 0;
    var $author$project$Components$Admin$Location$DeleteModal$isValid = function(action) {
        if (!action.$) {
            var newLocation = action.a;
            return $author$project$Utils$Maybe$toBool(newLocation);
        } else return true;
    };
    var $author$project$Components$Admin$Location$DeleteModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Admin$Location$DeleteModal$Closed,
                    at: _List_Nil
                };
            case 2:
                var action = msg.a;
                if (model.$ === 1) {
                    var location1 = model.a;
                    var remainingLocations = model.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: A4($author$project$Components$Admin$Location$DeleteModal$Open, location1, remainingLocations, action, $author$project$Api$Data$NotAsked),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Admin$Location$DeleteModal$Closed,
                    at: _List_Nil
                };
            case 4:
                var id = msg.a;
                if (model.$ === 1) {
                    var location1 = model.a;
                    var remainingLocations = model.b;
                    var action = model.c;
                    var response = model.d;
                    if (!action.$) {
                        var newLocation = A2($elm_community$list_extra$List$Extra$find, function(location_) {
                            return _Utils_eq(id, $author$project$Api$Provider$Location$All$id(location_));
                        }, remainingLocations);
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: A4($author$project$Components$Admin$Location$DeleteModal$Open, location1, remainingLocations, $author$project$Components$Admin$Location$DeleteModal$Reassign(newLocation), response),
                            at: _List_Nil
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: A4($author$project$Components$Admin$Location$DeleteModal$Open, location1, remainingLocations, $author$project$Components$Admin$Location$DeleteModal$RemoveAssignment, response),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Admin$Location$DeleteModal$Closed,
                    at: _List_Nil
                };
            case 1:
                if (model.$ === 1) {
                    var location1 = model.a;
                    var remainingLocations = model.b;
                    var action = model.c;
                    if ($author$project$Components$Admin$Location$DeleteModal$isValid(action)) {
                        var newLocation = function() {
                            if (!action.$) {
                                var newLocation_ = action.a;
                                return newLocation_;
                            } else return $elm$core$Maybe$Nothing;
                        }();
                        return {
                            EQ: A4($author$project$Api$Provider$Location$delete, apiClient, $author$project$Api$Provider$Location$All$id(location1), A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, newLocation), $author$project$Components$Admin$Location$DeleteModal$Deleted(newLocation)),
                            adu: 0,
                            zi: A4($author$project$Components$Admin$Location$DeleteModal$Open, location1, remainingLocations, action, $author$project$Api$Data$Loading),
                            at: _List_Nil
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: A4($author$project$Components$Admin$Location$DeleteModal$Open, location1, remainingLocations, action, $author$project$Api$Data$NotAsked),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Admin$Location$DeleteModal$Closed,
                    at: _List_Nil
                };
            default:
                var newLocation = msg.a;
                var response = msg.b;
                if (model.$ === 1) {
                    var location1 = model.a;
                    var remainingLocations = model.b;
                    var action = model.c;
                    switch(response.$){
                        case 3:
                            var message = function() {
                                if (!newLocation.$) {
                                    var newLocation_ = newLocation.a;
                                    return $elm$core$String$concat(_List_fromArray([
                                        ' All patients currently assigned to ',
                                        $author$project$Api$Provider$Location$All$name(location1),
                                        ' will be assigned to ',
                                        $author$project$Api$Provider$Location$All$name(newLocation_),
                                        '.',
                                        'For large volumes of patients, this may take a few minutes behind the scenes.'
                                    ]));
                                } else return '';
                            }();
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                zi: $author$project$Components$Admin$Location$DeleteModal$Closed,
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Location$All$name(location1) + (' was successfully removed.' + message)),
                                    $author$project$OutMsg$RefreshPractice
                                ])
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: A4($author$project$Components$Admin$Location$DeleteModal$Open, location1, remainingLocations, action, response),
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: model,
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Admin$Location$DeleteModal$Closed,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$LinkedRecords$GotLinkedRecords = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$LinkedRecords$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$LinkedRecord$All$LinkedRecord = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$LinkedRecord$Shared$LinkedRecord = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LinkedRecord$Shared$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$LinkedRecord$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$Shared$Record));
    var $author$project$Api$Provider$LinkedRecord$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LinkedRecord$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$LinkedRecord$All$AllRecord = function(practice) {
        return {
            W1: practice
        };
    };
    var $author$project$Api$Provider$LinkedRecord$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Provider$Practice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$All$AllRecord));
    var $author$project$Api$Provider$LinkedRecord$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LinkedRecord$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LinkedRecord$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LinkedRecord$All$LinkedRecord)));
    var $author$project$Api$Provider$LinkedRecord$linkablePath = function(linkable) {
        var id_ = linkable;
        return $author$project$Api$Provider$Location$locationPath(id_);
    };
    var $author$project$Api$Provider$LinkedRecord$linkedRecordsPath = function(linkable) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'linked_records'
        ]), $author$project$Api$Provider$LinkedRecord$linkablePath(linkable));
    };
    var $author$project$Api$Provider$LinkedRecord$list = F3(function(apiClient, linkable, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$LinkedRecord$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$LinkedRecord$linkedRecordsPath(linkable)));
    });
    var $author$project$Components$LinkedRecords$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var linkable = msg.a;
                return _Utils_Tuple3($author$project$Components$LinkedRecords$Open($author$project$Api$Data$Loading), A3($author$project$Api$Provider$LinkedRecord$list, apiClient, linkable, $author$project$Components$LinkedRecords$GotLinkedRecords), _List_Nil);
            case 1:
                return _Utils_Tuple3($author$project$Components$LinkedRecords$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (model.$ === 1) return _Utils_Tuple3($author$project$Components$LinkedRecords$Open(response), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Locations$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        i$: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    i$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            i$: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$Locations$fetchList(qModel),
                            A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    i$: $author$project$Api$Data$Loading,
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$Locations$fetchList(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    i$: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$Locations$fetchList(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Locations$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 4:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tl: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 5:
                var _v5 = $author$project$Pages$Admin$Locations$formFieldsInit;
                var formFields = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 6:
                var _v6 = $author$project$Pages$Admin$Locations$formFieldsForBusinessLocation($author$project$Api$Provider$Practice$One$name(model.W1));
                var formFields = _v6.a;
                var cmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 8:
                var item = msg.a;
                var _v7 = $author$project$Pages$Admin$Locations$formFieldsFromItem(item);
                var formFields = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$Location$All$id(item)), $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 7:
                var item = msg.a;
                var _v8 = $author$project$Pages$Admin$Locations$formFieldsFromBusinessLocation(item);
                var formFields = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$Location$All$id(item)), $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 9:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var field = msg.a;
                var _v9 = model.F6;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    var item = _v10.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Locations$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, item))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var form = msg.a;
                var id = msg.b;
                var fields = $author$project$Utils$Form$fields(form);
                var address = A2($elm$core$Maybe$map, $author$project$Components$AddressInput$validate, fields.II);
                var newForm = function() {
                    if (!address.$) {
                        var address_ = address.a;
                        return A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Locations$formFieldsUpdate, $author$project$Pages$Admin$Locations$Address(address_), form);
                    } else return form;
                }();
                var _v11 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Locations$formFieldsValidator($author$project$Api$Provider$Practice$One$requireGroupForLocations(model.W1)), newForm);
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var validatedForm = _v12.a;
                    var validFormFields = _v12.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Admin$Locations$saveItem, model.Ej, id, validFormFields), _List_Nil);
                } else {
                    var validatedForm = _v11.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 11:
                var item = msg.a;
                var locations = msg.b;
                if ($elm$core$List$length(locations) === 1 && $author$project$Api$Provider$Practice$One$trackPatientsByLocation(model.W1)) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 1, 'Practice tracks patients by locations. Can\'t delete last one.')
                ]));
                else {
                    var _v14 = _Utils_Tuple2(A2($author$project$Api$Expandable$withDefault, true, $author$project$Api$Provider$Location$All$hasPatients(item)), $author$project$Api$Provider$Location$All$isMaster(item) || $author$project$Api$Provider$Location$All$isSynced(item));
                    if (_v14.a) {
                        if (_v14.b) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 2, 'This location is currently part of an affiliation. Please contact us to unlink this location prior to deletion')
                        ]));
                        else {
                            var remainingLocations = A2($elm$core$List$filter, function(remainingLocation) {
                                return !_Utils_eq($author$project$Api$Provider$Location$All$id(item), $author$project$Api$Provider$Location$All$id(remainingLocation));
                            }, locations);
                            return _Utils_Tuple3(_Utils_update(model, {
                                ia: A2($author$project$Components$Admin$Location$DeleteModal$open, item, remainingLocations)
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        }
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Just(item)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 13:
                var response = msg.a;
                var _v15 = model.F6;
                if (!_v15.$) {
                    var _v16 = _v15.a;
                    var id = _v16.a;
                    var form = _v16.b;
                    if (response.$ === 3) {
                        var item = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            F6: $elm$core$Maybe$Nothing,
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$Locations$fetchList(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$Location$One$name(item)),
                            $author$project$OutMsg$RefreshPractice
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var response = msg.a;
                var _v18 = model.F6;
                if (!_v18.$) {
                    var _v19 = _v18.a;
                    var id = _v19.a;
                    var form = _v19.b;
                    if (response.$ === 3) {
                        var item = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            F6: $elm$core$Maybe$Nothing,
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$Locations$fetchList(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Location$One$name(item) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var item = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Provider$Location$All$id(item), model.dS),
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$Locations$fetchList(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Location$All$name(item) + ' was successfully removed.'),
                            $author$project$OutMsg$RefreshPractice
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Provider$Location$All$id(item), model.dS)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 16:
                var item = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$Location$All$id(item);
                    return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Nothing,
                        dS: A2($elm$core$Set$insert, id, model.dS)
                    }), A4($author$project$Api$Provider$Location$delete, model.Ej, id, $elm$core$Maybe$Nothing, $author$project$Pages$Admin$Locations$Deleted(item)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var subMsg = msg.a;
                var _v22 = A3($author$project$Components$LinkedRecords$update, model.Ej, subMsg, model.mV);
                var linkedRecords = _v22.a;
                var subCmd = _v22.b;
                var subOutMsg = _v22.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    mV: linkedRecords
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$LinkedRecordsMsg, subCmd), subOutMsg);
            case 18:
                var subMsg = msg.a;
                var _v23 = model.F6;
                if (!_v23.$) {
                    var _v24 = _v23.a;
                    var id = _v24.a;
                    var form = _v24.b;
                    var item = _v24.c;
                    var _v25 = $author$project$Utils$Form$fields(form);
                    var phone = _v25.WE;
                    var _v26 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
                    var phoneInput = _v26.a;
                    var phoneCmd = _v26.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Locations$formFieldsUpdate, $author$project$Pages$Admin$Locations$Phone(phoneInput), form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, item))
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$PhoneInputMsg, phoneCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var subMsg = msg.a;
                var _v27 = model.F6;
                if (!_v27.$) {
                    var _v28 = _v27.a;
                    var id = _v28.a;
                    var form = _v28.b;
                    var item = _v28.c;
                    var _v29 = $author$project$Utils$Form$fields(form);
                    var address = _v29.II;
                    if (!address.$) {
                        var address_ = address.a;
                        var _v31 = A2($author$project$Components$AddressInput$update, subMsg, address_);
                        var addressInputModel = _v31.a;
                        var addressInputCmd = _v31.b;
                        var outMsgs = _v31.c;
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Locations$formFieldsUpdate, $author$project$Pages$Admin$Locations$Address(addressInputModel), form);
                        return _Utils_Tuple3(_Utils_update(model, {
                            F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, item))
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$AddressInputMsg, addressInputCmd), outMsgs);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 20:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Admin$Location$DeleteModal$update, model.Ej, subMsg, model.ia);
                var _v32 = function() {
                    var _v33 = result.adu;
                    if (_v33 === 1) return _Utils_Tuple2(_Utils_update(model, {
                        i$: $author$project$Api$Data$Loading
                    }), $author$project$Pages$Admin$Locations$fetchList(model));
                    else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v32.a;
                var cmd = _v32.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    ia: result.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$DeleteModalMsg, result.EQ)
                ])), result.at);
            default:
                var subMsg = msg.a;
                var _v34 = A3($author$project$Components$ExportCsv$update, model.Ej, subMsg, model.md);
                var exportCsv = _v34.a;
                var subCmd = _v34.b;
                var subOutMsg = _v34.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Locations$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Admin$Locations$New = {
        $: 5
    };
    var $author$project$Pages$Admin$Locations$NewBusinessAddress = {
        $: 6
    };
    var $author$project$Pages$Admin$Locations$PaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$hasBusinessLocation = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, A2($elm$core$Basics$composeR, function($) {
        return $.Kx;
    }, $author$project$Utils$Maybe$toBool));
    var $author$project$Api$Provider$LinkedRecord$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$LinkedRecord$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$LinkedRecord$Shared$id(shared);
    };
    var $author$project$Api$Provider$LinkedRecord$All$practice = function(_v0) {
        var record = _v0.b;
        return record.W1;
    };
    var $author$project$Components$LinkedRecords$viewLinkedRecord = function(linkedRecord) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Practice$Min$name($author$project$Api$Provider$LinkedRecord$All$practice(linkedRecord)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$LinkedRecord$All$id(linkedRecord))
            ]))
        ]));
    };
    var $author$project$Components$LinkedRecords$viewTable = function(linkedRecords) {
        var _v0 = function() {
            if (linkedRecords.$ === 3) {
                var list = linkedRecords.a;
                return _Utils_Tuple2(false, list);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var linkedRecords_ = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$loading(loading),
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('No linked records.')
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Practice Name')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Linked Record ID')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$LinkedRecords$viewLinkedRecord, linkedRecords_), _List_Nil);
    };
    var $author$project$Components$LinkedRecords$modal = function(model) {
        if (model.$ === 1) {
            var linkedRecords = model.a;
            return A3($author$project$Ui$Modal$view, $author$project$Components$LinkedRecords$CloseModal, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Linked Records')
                    ]))
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    $author$project$Components$LinkedRecords$viewTable(linkedRecords)
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Components$LinkedRecords$CloseModal)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Close')
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$Location$DeleteModal$Delete = {
        $: 1
    };
    var $author$project$Components$Admin$Location$DeleteModal$UpdateAction = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$Location$DeleteModal$UpdateNewLocation = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$Location$DeleteModal$locationOptions = function(locations) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a location...'), A2($elm$core$List$map, function(location1) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Location$All$id(location1)), $author$project$Api$Provider$Location$All$name(location1));
        }, locations));
    };
    var $author$project$Components$Admin$Location$DeleteModal$viewModal = F4(function(location1, remainingLocations, action, request) {
        var _v0 = function() {
            if (!action.$) return _Utils_Tuple2(true, false);
            else return _Utils_Tuple2(false, true);
        }();
        var reassignActive = _v0.a;
        var removeAssignmentActive = _v0.b;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$Location$DeleteModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('What would you like to do with patients assigned to this location?')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Action'),
                    $author$project$Ui$Form$Group$labelSpan(2),
                    $author$project$Ui$Form$Group$inputSpan(10)
                ]), _List_fromArray([
                    $author$project$Ui$Button$group(_List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Reasign to new location'
                        }, _List_fromArray([
                            $author$project$Ui$Button$active(reassignActive),
                            $author$project$Ui$Button$disabled($elm$core$List$isEmpty(remainingLocations)),
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$Location$DeleteModal$UpdateAction($author$project$Components$Admin$Location$DeleteModal$Reassign($elm$core$Maybe$Nothing)))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Reassign')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Remove location assignment'
                        }, _List_fromArray([
                            $author$project$Ui$Button$active(removeAssignmentActive),
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$Location$DeleteModal$UpdateAction($author$project$Components$Admin$Location$DeleteModal$RemoveAssignment))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Remove assignment')
                        ]))
                    ])),
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pt-05')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            function() {
                                if (!action.$) return $elm$html$Html$text('All patients currently assigned to ' + ($author$project$Api$Provider$Location$All$name(location1) + ' will be assigned to the location selected below'));
                                else return $elm$html$Html$text('All patients currently assigned to ' + ($author$project$Api$Provider$Location$All$name(location1) + ' will no longer be assigned to a location'));
                            }()
                        ]))
                    ])),
                    function() {
                        if (!action.$) {
                            var newLocation = action.a;
                            var newLocationInvalid = !$author$project$Utils$Maybe$toBool(newLocation);
                            return A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('pt-05')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, newLocation)),
                                    $author$project$Ui$Form$Select$onChange($author$project$Components$Admin$Location$DeleteModal$UpdateNewLocation),
                                    $author$project$Ui$Form$Select$invalid(newLocationInvalid),
                                    $author$project$Ui$Form$Select$errors(newLocationInvalid ? _List_fromArray([
                                        'Please pick a location for reassignment'
                                    ]) : _List_Nil)
                                ]), $author$project$Components$Admin$Location$DeleteModal$locationOptions(remainingLocations))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Location$DeleteModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete location'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Location$DeleteModal$Delete),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Location$DeleteModal$view = function(model) {
        if (model.$ === 1) {
            var location1 = model.a;
            var remainingLocations = model.b;
            var action = model.c;
            var request = model.d;
            return A4($author$project$Components$Admin$Location$DeleteModal$viewModal, location1, remainingLocations, action, request);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Admin$Locations$FormUpdated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$LocationGroup = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$OnlineSignupVisibility = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$Save = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Locations$Virtual = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$Loading = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$loading = $author$project$Ui$Form$Select$Loading;
    var $author$project$Api$Provider$LocationGroup$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$LocationGroup$Shared$id(shared);
    };
    var $author$project$Api$Common$LocationGroup$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Common$LocationGroup$Shared$name = function(_v0) {
        var min = _v0;
        return $author$project$Api$Common$LocationGroup$Min$name(min);
    };
    var $author$project$Api$Provider$LocationGroup$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$LocationGroup$Shared$name(shared);
    };
    var $author$project$Pages$Admin$Locations$locationGroupOptions = function(locationGroups) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'None'), A2($elm$core$List$map, function(locationGroup) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$LocationGroup$All$id(locationGroup)), $author$project$Api$Provider$LocationGroup$All$name(locationGroup));
        }, locationGroups));
    };
    var $author$project$Components$AddressInput$CountryValidation = 4;
    var $author$project$Components$AddressInput$FieldBlurred = {
        $: 1
    };
    var $author$project$Components$AddressInput$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$AddressInput$SuggestionSelected = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$AriaLabel = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$ariaLabel = $author$project$Ui$Form$Input$AriaLabel;
    var $author$project$Ui$Dropdown$ComboboxPlaceholder = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$comboboxPlaceholder = $author$project$Ui$Dropdown$ComboboxPlaceholder;
    var $author$project$Ui$Form$Input$MaxLength = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$maxLength = $author$project$Ui$Form$Input$MaxLength;
    var $author$project$Components$AddressInput$defaultOptions = {
        d$: false
    };
    var $author$project$Components$AddressInput$updateOptionsRecord = F2(function(option, options) {
        var bool = option;
        return _Utils_update(options, {
            d$: bool
        });
    });
    var $author$project$Components$AddressInput$optionsListToRecord = function(optionsList) {
        return A3($elm$core$List$foldl, $author$project$Components$AddressInput$updateOptionsRecord, $author$project$Components$AddressInput$defaultOptions, optionsList);
    };
    var $author$project$Components$AddressInput$validationGroupElementId = F2(function(modelId, validationGroup) {
        switch(validationGroup){
            case 0:
                return modelId + '-address';
            case 1:
                return modelId + '-city';
            case 2:
                return modelId + '-state';
            case 3:
                return modelId + '-zip';
            default:
                return modelId + '-country';
        }
    });
    var $author$project$Ui$Dropdown$ComboboxInputFocused = {
        $: 2
    };
    var $author$project$Ui$Dropdown$ComboboxInputTyped = {
        $: 1
    };
    var $author$project$Ui$Dropdown$comboboxTriggerKeyHandlers = F2(function(onEnterMsg, toMsg) {
        return A2($elm$html$Html$Events$custom, 'keydown', A2($elm$json$Json$Decode$andThen, function(key) {
            var andPreventDefault = $elm$json$Json$Decode$map(function(msg_) {
                return {
                    ae1: msg_,
                    Bq: true,
                    CJ: true
                };
            });
            switch(key){
                case 'ArrowDown':
                    return andPreventDefault($elm$json$Json$Decode$succeed(toMsg($author$project$Ui$Dropdown$ArrowPressed(1))));
                case 'ArrowUp':
                    return andPreventDefault($elm$json$Json$Decode$succeed(toMsg($author$project$Ui$Dropdown$ArrowPressed(0))));
                case 'Enter':
                    if (!onEnterMsg.$) {
                        var msg = onEnterMsg.a;
                        return andPreventDefault($elm$json$Json$Decode$succeed(msg));
                    } else return $elm$json$Json$Decode$fail('ignore');
                default:
                    return $elm$json$Json$Decode$succeed({
                        ae1: toMsg($author$project$Ui$Dropdown$ComboboxInputTyped),
                        Bq: false,
                        CJ: false
                    });
            }
        }, A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
    });
    var $author$project$Ui$Dropdown$decodePressedKey = F2(function(expectedKey, toMsg) {
        return A2($elm$json$Json$Decode$andThen, function(key) {
            return _Utils_eq(key, expectedKey) ? $elm$json$Json$Decode$succeed(toMsg) : $elm$json$Json$Decode$fail('ignore');
        }, A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
    });
    var $author$project$Ui$Dropdown$onEnterUp = function(msg) {
        return A2($elm$html$Html$Events$custom, 'keyup', A2($elm$json$Json$Decode$map, function(msg_) {
            return {
                ae1: msg_,
                Bq: true,
                CJ: true
            };
        }, A2($author$project$Ui$Dropdown$decodePressedKey, 'Enter', msg)));
    };
    var $author$project$Ui$Dropdown$viewCombobox = F4(function(options, inputOptions, items, model) {
        var toMsg = model.ahX;
        var optionsRecord = $author$project$Ui$Dropdown$optionsToRecord(options);
        var errorDescription = $elm$core$List$isEmpty(optionsRecord.fK) ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-describedby', A2($elm$core$String$join, '. ', optionsRecord.fK))
        ]);
        var ariaInvalid = optionsRecord.q2 || !$elm$core$List$isEmpty(optionsRecord.fK) ? _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'aria-invalid', 'true')
        ]) : _List_Nil;
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('new-dropdown'),
            $elm$html$Html$Attributes$id(model.aef),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('new-dropdown--open', model.Vw && !optionsRecord.d$ && !optionsRecord.sq),
                _Utils_Tuple2('new-dropdown--invalid', optionsRecord.q2 || !$elm$core$List$isEmpty(optionsRecord.fK)),
                _Utils_Tuple2('new-dropdown--disabled', optionsRecord.d$),
                _Utils_Tuple2('new-dropdown--readonly', optionsRecord.sq)
            ]))
        ]), _List_fromArray([
            A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('new-dropdown__trigger new-dropdown__trigger--input'), A2($elm$core$List$cons, $elm$html$Html$Attributes$id(model.aef + '-trigger'), A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('text'), A2($elm$core$List$cons, $elm$html$Html$Attributes$autocomplete(false), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'listbox'), A2($elm$core$List$cons, $elm$html$Html$Events$onFocus(toMsg($author$project$Ui$Dropdown$ComboboxInputFocused)), A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('combobox'), A2($elm$core$List$cons, $elm$html$Html$Events$onInput(inputOptions.afE), A2($elm$core$List$cons, $elm$html$Html$Attributes$placeholder(optionsRecord.we), A2($elm$core$List$cons, $elm$html$Html$Attributes$value(inputOptions.aa9), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-expanded', model.Vw ? 'true' : 'false'), A2($elm$core$List$cons, $elm$core$String$isEmpty(optionsRecord.abP) ? $elm$html$Html$Attributes$class('') : A2($elm$html$Html$Attributes$attribute, 'aria-label', optionsRecord.abP), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'options-list'), A2($elm$core$List$cons, model.Vw ? A2($elm$html$Html$Attributes$map, toMsg, $author$project$Ui$Dropdown$onEnterUp($author$project$Ui$Dropdown$DropdownButtonClicked)) : $elm$html$Html$Attributes$class(''), _Utils_ap(optionsRecord.d$ ? _List_fromArray([
                A2($elm$html$Html$Attributes$attribute, 'aria-disabled', 'true'),
                $elm$html$Html$Attributes$disabled(true)
            ]) : optionsRecord.sq ? _List_fromArray([
                $elm$html$Html$Attributes$readonly(true)
            ]) : _List_fromArray([
                A2($author$project$Ui$Dropdown$comboboxTriggerKeyHandlers, model.Vw ? inputOptions.afA : $elm$core$Maybe$Nothing, toMsg)
            ]), _Utils_ap(errorDescription, ariaInvalid)))))))))))))))), _List_Nil),
            optionsRecord.d$ || optionsRecord.sq ? $elm$html$Html$text('') : $elm$core$List$isEmpty(items) ? $elm$html$Html$text('') : A3($author$project$Ui$Dropdown$viewMenu, toMsg, model, items)
        ]));
    });
    var $author$project$Components$AddressInput$view = F2(function(options, _v0) {
        var model = _v0;
        var optionsRecord = $author$project$Components$AddressInput$optionsListToRecord(options);
        var _v1 = model.aQ ? _Utils_Tuple3(7, 5, 4) : _Utils_Tuple3(5, 4, 3);
        var cityColumnSize = _v1.a;
        var stateColumnSize = _v1.b;
        var zipColumnSize = _v1.c;
        var _v2 = $author$project$Utils$Form$fields(model.PU);
        var address1 = _v2.cx;
        var address2 = _v2.e$;
        var city = _v2.pW;
        var state = _v2.s4;
        var zip = _v2.tK;
        var country = _v2.p0;
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$id(model.aef)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('select')
                    ]), _List_fromArray([
                        A4($author$project$Ui$Dropdown$viewCombobox, _List_fromArray([
                            $author$project$Ui$Dropdown$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Ui$Dropdown$disabled(optionsRecord.d$),
                            $author$project$Ui$Dropdown$comboboxPlaceholder('Address line 1')
                        ]), {
                            afA: A2($elm$core$Maybe$map, $author$project$Components$AddressInput$SuggestionSelected, $elm$core$List$head(model.ahF)),
                            afE: A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Address1), $author$project$Utils$String$toMaybe),
                            aa9: A2($elm$core$Maybe$withDefault, '', address1)
                        }, A2($elm$core$List$map, function(suggestion) {
                            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                $author$project$Ui$Dropdown$onSelect($author$project$Components$AddressInput$SuggestionSelected(suggestion))
                            ]), $elm$html$Html$text(suggestion.NQ));
                        }, model.ahF), model.hr)
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ])),
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', address2)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Address2), $author$project$Utils$String$toMaybe)),
                        $author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
                        $author$project$Ui$Form$Input$disabled(optionsRecord.d$),
                        $author$project$Ui$Form$Input$placeholder('Address line 2'),
                        $author$project$Ui$Form$Input$ariaLabel('Address line 2'),
                        $author$project$Ui$Form$Input$maxLength(50),
                        $author$project$Ui$Form$Input$autoComplete(false),
                        $author$project$Ui$Form$Input$autoCorrect(false),
                        $author$project$Ui$Form$Input$autoCapitalize(false),
                        $author$project$Ui$Form$Input$spellCheck(false),
                        $author$project$Ui$Form$Input$phi(true)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(cityColumnSize)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$id(A2($author$project$Components$AddressInput$validationGroupElementId, model.aef, 1)),
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', city)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$City), $author$project$Utils$String$toMaybe)),
                        $author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                        $author$project$Ui$Form$Input$disabled(optionsRecord.d$),
                        $author$project$Ui$Form$Input$placeholder('City'),
                        $author$project$Ui$Form$Input$ariaLabel('City')
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(stateColumnSize)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$id(A2($author$project$Components$AddressInput$validationGroupElementId, model.aef, 2)),
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', state)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$State), $author$project$Utils$String$toMaybe)),
                        $author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU)),
                        $author$project$Ui$Form$Input$disabled(optionsRecord.d$),
                        $author$project$Ui$Form$Input$placeholder('State'),
                        $author$project$Ui$Form$Input$ariaLabel('State')
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(zipColumnSize)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$id(A2($author$project$Components$AddressInput$validationGroupElementId, model.aef, 3)),
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', zip)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Zip), $author$project$Utils$String$toMaybe)),
                        $author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                        $author$project$Ui$Form$Input$disabled(optionsRecord.d$),
                        $author$project$Ui$Form$Input$placeholder('Zip Code'),
                        $author$project$Ui$Form$Input$ariaLabel('Zip Code'),
                        $author$project$Ui$Form$Input$autoComplete(false),
                        $author$project$Ui$Form$Input$autoCorrect(false),
                        $author$project$Ui$Form$Input$autoCapitalize(false),
                        $author$project$Ui$Form$Input$spellCheck(false)
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 3, model.PU))
                ])),
                model.aQ ? A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$id(A2($author$project$Components$AddressInput$validationGroupElementId, model.aef, 4)),
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', country)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$AddressInput$FormUpdated, $author$project$Components$AddressInput$Country), $author$project$Utils$String$toMaybe)),
                        $author$project$Ui$Form$Input$onBlur($author$project$Components$AddressInput$FieldBlurred),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, model.PU)),
                        $author$project$Ui$Form$Input$disabled(optionsRecord.d$),
                        $author$project$Ui$Form$Input$placeholder('Country'),
                        $author$project$Ui$Form$Input$ariaLabel('Country')
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 4, model.PU))
                ])) : A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Locations$viewModal = F4(function(model, id, form, item) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Location',
            Tk: _Utils_eq(item, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$Locations$CancelEdit,
            Vn: $author$project$Pages$Admin$Locations$Save(form)
        };
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = function() {
            var _v1 = model.Tl;
            if (_v1.$ === 3) {
                var locationGroups_ = _v1.a;
                return _Utils_Tuple2(false, locationGroups_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var locationGroupsLoading = _v0.a;
        var locationGroups = _v0.b;
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$placeholder('Location Name'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Virtual')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.abe),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$Virtual))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Address'),
                $author$project$Ui$Form$Group$required(!fields.abe)
            ]), _List_fromArray([
                function() {
                    var _v2 = fields.II;
                    if (!_v2.$) {
                        var addressInput = _v2.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$AddressInputMsg, A2($author$project$Components$AddressInput$view, _List_Nil, addressInput));
                    } else return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$AddressDisplay$view, $author$project$Api$Provider$Practice$One$address(model.W1))),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('You can edit this address on the '),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Admin > Account page')
                            ]))
                        ]))
                    ]));
                }()
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Group'),
                $author$project$Ui$Form$Group$required($author$project$Api$Provider$Practice$One$requireGroupForLocations(model.W1))
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(fields.rm),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$LocationGroup)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, form)),
                    $author$project$Ui$Form$Select$loading(locationGroupsLoading)
                ]), $author$project$Pages$Admin$Locations$locationGroupOptions(locationGroups))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Phone')
            ]), function() {
                var _v3 = _Utils_Tuple2(fields.Kx, $elm$core$List$head($author$project$Api$Provider$Practice$One$phones(model.W1)));
                if (_v3.a) {
                    if (!_v3.b.$) {
                        var phone = _v3.b.a;
                        var _v4 = $author$project$Api$Common$Phone$Shared$number(phone);
                        if (!_v4.$) {
                            var number = _v4.a;
                            return _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Formatters$Phone$format(number)),
                                    $elm$html$Html$text(' (' + ($author$project$Formatters$PhoneType$toString($author$project$Api$Common$Phone$Shared$type_(phone)) + ')'))
                                ]))
                            ]);
                        } else return _List_Nil;
                    } else {
                        var _v5 = _v3.b;
                        return _List_Nil;
                    }
                } else return _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$PhoneInputMsg, $author$project$Components$PhoneInput$view(fields.WE)),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 3, form))
                ]);
            }()),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Allow Online Signup')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.Vv),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Locations$FormUpdated, $author$project$Pages$Admin$Locations$OnlineSignupVisibility))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Locations$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'Name'),
        A3($author$project$Api$Column$init, '', false, 'Address'),
        A3($author$project$Api$Column$init, '', false, 'Phone'),
        A3($author$project$Api$Column$init, '', false, 'Group'),
        A3($author$project$Api$Column$init, 'online_signup_visibility', true, 'Online signup')
    ]);
    var $author$project$Pages$Admin$Locations$Delete = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Locations$Edit = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$Locations$EditBusinessItemClicked = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$LinkedRecord$Location = $elm$core$Basics$identity;
    var $author$project$Components$LinkedRecords$OpenModal = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Icon$Link = 102;
    var $author$project$Ui$Icon$link = $author$project$Ui$Icon$viewIcon(102);
    var $author$project$Components$LinkedRecords$button = function(linkable) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Link record'
        }, _List_fromArray([
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$onClick($author$project$Components$LinkedRecords$OpenModal(linkable)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$link)
        ]), _List_Nil);
    };
    var $author$project$Api$Provider$Location$Meta$deleteAction = function(_v0) {
        var meta = _v0;
        return meta.tM.NH;
    };
    var $author$project$Api$Expandable$map = F2(function(f, expandable_) {
        if (!expandable_.$) {
            var a = expandable_.a;
            return $author$project$Api$Expandable$Expanded(f(a));
        } else return $author$project$Api$Expandable$NotExpanded;
    });
    var $author$project$Api$Provider$Location$All$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Pages$Admin$Locations$viewItem = F3(function(model, items, item) {
        var id = $author$project$Api$Provider$Location$All$id(item);
        var loading = A2($elm$core$Set$member, id, model.dS);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Location$All$name(item)),
                $author$project$Utils$Html$noBreakSpace,
                model.F3 ? A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$LinkedRecordsMsg, $author$project$Components$LinkedRecords$button(id)) : $author$project$Utils$Html$empty,
                $author$project$Api$Provider$Location$All$businessLocation(item) ? A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text('Business Location')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = _Utils_Tuple2($author$project$Api$Provider$Location$All$virtual(item), $author$project$Api$Provider$Location$All$address(item));
                    if (_v0.a) return A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('Virtual location')
                    ]));
                    else if (!_v0.b.$) {
                        var address = _v0.b.a;
                        return $author$project$Components$AddressDisplay$view(address);
                    } else {
                        var _v1 = _v0.b;
                        return $elm$html$Html$text('N/A');
                    }
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Phone$format, $author$project$Api$Provider$Location$All$phoneNumber(item))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$LocationGroup$Shared$name, $author$project$Api$Provider$Location$All$locationGroup(item))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Api$Provider$Location$All$onlineSignupVisibility(item) ? $author$project$Ui$Icon$check(_List_fromArray([
                    $author$project$Ui$Icon$success
                ])) : $author$project$Ui$Icon$cross(_List_fromArray([
                    $author$project$Ui$Icon$danger
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit location'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Api$Provider$Location$All$businessLocation(item) ? $author$project$Ui$Button$onClick($author$project$Pages$Admin$Locations$EditBusinessItemClicked(item)) : $author$project$Ui$Button$onClick($author$project$Pages$Admin$Locations$Edit(item)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete location'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$onClick(A2($author$project$Pages$Admin$Locations$Delete, item, items)),
                        $author$project$Ui$Button$disabled(!A2($author$project$Api$Expandable$withDefault, false, A2($author$project$Api$Expandable$map, $author$project$Api$Provider$Location$Meta$deleteAction, $author$project$Api$Provider$Location$All$meta(item)))),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Locations$viewPanelTable = function(model) {
        var _v0 = function() {
            var _v1 = model.i$;
            if (_v1.$ === 3) {
                var items_ = _v1.a;
                return _Utils_Tuple2(false, items_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var items = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You have no locations.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$Locations$SortTable)), $author$project$Pages$Admin$Locations$columns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A2($author$project$Pages$Admin$Locations$viewItem, model, items), items), _List_Nil);
    };
    var $author$project$Pages$Admin$Locations$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$LinkedRecordsMsg, $author$project$Components$LinkedRecords$modal(model.mV)),
                A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, model.Ej, _List_fromArray([
                    $author$project$Components$ExportCsv$path($author$project$Api$Provider$Location$locationsPath),
                    $author$project$Components$ExportCsv$params(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Location$listOptionsToParams, $author$project$Pages$Admin$Locations$fetchParams)(model))
                ]), model.md)),
                function() {
                    var _v0 = model.F6;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        var form = _v1.b;
                        var item = _v1.c;
                        return A4($author$project$Pages$Admin$Locations$viewModal, model, id, form, item);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.$8;
                    if (!_v2.$) {
                        var item = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Locations$HiConfirmClosed(item), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('location'),
                            $author$project$Components$HiConfirm$detail($author$project$Api$Provider$Location$All$name(item))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$DeleteModalMsg, $author$project$Components$Admin$Location$DeleteModal$view(model.ia)),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            $elm$html$Html$text('Locations')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Add new location'
                            }, _List_fromArray([
                                $author$project$Ui$Button$default,
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Locations$New),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('New Location')
                            ])),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$pull(1)
                            ]), _List_fromArray([
                                $author$project$Utils$Html$noBreakSpace
                            ])),
                            $author$project$Api$Provider$Practice$One$hasBusinessLocation(model.W1) ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                                abP: 'Include primary business address as a location'
                            }, _List_fromArray([
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Locations$NewBusinessAddress)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Include primary business address as a location')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                                ]))
                            ]))
                        ]))
                    ])),
                    $author$project$Pages$Admin$Locations$viewPanelTable(model),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$Locations$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.i$))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Locations'
        };
    };
    var $author$project$Pages$Admin$Locations$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Locations$init,
        aeR: $author$project$Pages$Admin$Locations$load,
        ag3: $author$project$Pages$Admin$Locations$save,
        ahE: $author$project$Pages$Admin$Locations$subscriptions,
        aaO: $author$project$Pages$Admin$Locations$update,
        aid: $author$project$Pages$Admin$Locations$view
    });
    var $author$project$Pages$Admin$Mailgun$GotMailgun = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Mailgun$formFieldsInit = {
        OH: '',
        xr: ''
    };
    var $author$project$Api$Provider$Mailgun$One$Mailgun = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Mailgun$One$Record = F5(function(status, domain, email, sendingDnsRecords, meta) {
        return {
            Oh: domain,
            OH: email,
            Ue: meta,
            ZT: sendingDnsRecords,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Mailgun$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Mailgun$Meta$MetaRecord = function(actions) {
        return {
            tM: actions
        };
    };
    var $author$project$Api$Provider$Mailgun$Meta$ActionsRecord = F2(function(setup, verify) {
        return {
            Z1: setup,
            abb: verify
        };
    });
    var $author$project$Api$Provider$Mailgun$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'verify', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'setup', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$Meta$ActionsRecord)));
    var $author$project$Api$Provider$Mailgun$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$Mailgun$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$Meta$MetaRecord));
    var $author$project$Api$Provider$Mailgun$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Mailgun$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Mailgun$SendingDnsRecord$SendingDnsRecord = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Mailgun$SendingDnsRecord$Record = F4(function(valid, recordType, name, value) {
        return {
            zr: name,
            Yj: recordType,
            aa7: valid,
            aa9: value
        };
    });
    var $author$project$Api$Provider$Mailgun$SendingDnsRecord$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'value', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'record_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'valid', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$SendingDnsRecord$Record)))));
    var $author$project$Api$Provider$Mailgun$SendingDnsRecord$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Mailgun$SendingDnsRecord$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Mailgun$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Mailgun$Meta$decoder, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'sending_dns_records', $elm$json$Json$Decode$list($author$project$Api$Provider$Mailgun$SendingDnsRecord$decoder), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'domain', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Mailgun$One$Record))))));
    var $author$project$Api$Provider$Mailgun$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Mailgun$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Mailgun$mailgunPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'mailgun'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Mailgun$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Mailgun$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Mailgun$mailgunPath));
    });
    var $author$project$Api$Provider$Practice$Shared$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Api$Provider$Practice$One$url = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$url(shared);
    };
    var $author$project$Pages$Admin$Mailgun$init = F4(function(_v0, practice, shared, _v1) {
        var domain = A2($elm$core$Maybe$map, function($) {
            return $.aec;
        }, A2($elm$core$Maybe$andThen, $elm$url$Url$fromString, $author$project$Api$Provider$Practice$One$url(practice)));
        return _Utils_Tuple2({
            Ej: shared.Ej,
            Oh: domain,
            w: false,
            PU: $author$project$Utils$Form$init($author$project$Pages$Admin$Mailgun$formFieldsInit),
            qW: shared.qW,
            F3: $author$project$Shared$isHintAdmin(shared),
            mY: $author$project$Api$Data$Loading,
            oh: $author$project$Api$Data$NotAsked,
            pd: $author$project$Api$Data$NotAsked
        }, A2($author$project$Api$Provider$Mailgun$retrieve, shared.Ej, $author$project$Pages$Admin$Mailgun$GotMailgun));
    });
    var $author$project$Pages$Admin$Mailgun$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Mailgun$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Mailgun$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Mailgun$Verified = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Mailgun$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                OH: string
            });
        } else {
            var domain = field.a;
            var string = field.b;
            return _Utils_update(fields, {
                OH: string + ('@' + domain),
                xr: string
            });
        }
    });
    var $author$project$Pages$Admin$Mailgun$EmailValidation = 0;
    var $author$project$Pages$Admin$Mailgun$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: false
        }, A2($elm$core$Basics$composeR, function($) {
            return $.OH;
        }, $elm$core$Maybe$Just), _Utils_Tuple2(0, 'Please enter a valid email'))
    ]));
    var $author$project$Pages$Admin$Mailgun$GotSetup = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Mailgun$setup = F3(function(apiClient, email_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('email', $elm$json$Json$Encode$string(email_))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Mailgun$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'setup'
        ]), $author$project$Api$Provider$Mailgun$mailgunPath))));
    });
    var $author$project$Pages$Admin$Mailgun$setupMailgun = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Mailgun$setup, apiClient, fields.OH, $author$project$Pages$Admin$Mailgun$GotSetup);
    });
    var $author$project$Api$Provider$Mailgun$verify = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Mailgun$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'verify'
        ]), $author$project$Api$Provider$Mailgun$mailgunPath)));
    });
    var $author$project$Pages$Admin$Mailgun$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    mY: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Mailgun$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Mailgun$formFieldsValidator, model.PU);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var newForm = _v2.a;
                    var validFormFields = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm,
                        oh: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Admin$Mailgun$setupMailgun, model.Ej, validFormFields), _List_Nil);
                } else {
                    var newForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    w: false,
                    PU: $author$project$Utils$Form$init($author$project$Pages$Admin$Mailgun$formFieldsInit),
                    mY: response,
                    oh: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your mailgun credentials have been saved.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    oh: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    pd: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Mailgun$verify, model.Ej, $author$project$Pages$Admin$Mailgun$Verified), _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    mY: response,
                    pd: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your dns records are being verified.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    pd: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    w: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Ui$Image$MailgunLogo = 3;
    var $author$project$Pages$Admin$Mailgun$EditEmail = {
        $: 6
    };
    var $author$project$Pages$Admin$Mailgun$Email = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Mailgun$EmailLocalPart = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Mailgun$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Mailgun$Setup = {
        $: 2
    };
    var $author$project$Pages$Admin$Mailgun$Verify = {
        $: 4
    };
    var $author$project$Api$Provider$Mailgun$One$domain = function(_v0) {
        var record = _v0;
        return record.Oh;
    };
    var $author$project$Api$Provider$Mailgun$One$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$Mailgun$One$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Api$Provider$Mailgun$One$sendingDnsRecords = function(_v0) {
        var record = _v0;
        return record.ZT;
    };
    var $author$project$Api$Provider$Mailgun$Meta$setupAaction = function(_v0) {
        var meta = _v0;
        return meta.tM.Z1;
    };
    var $author$project$Api$Provider$Mailgun$One$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Mailgun$Meta$verifyAction = function(_v0) {
        var meta = _v0;
        return meta.tM.abb;
    };
    var $author$project$Api$Provider$Mailgun$SendingDnsRecord$name = function(_v0) {
        var sendingDnsRecord = _v0;
        return sendingDnsRecord.zr;
    };
    var $author$project$Api$Provider$Mailgun$SendingDnsRecord$recordType = function(_v0) {
        var sendingDnsRecord = _v0;
        return sendingDnsRecord.Yj;
    };
    var $author$project$Api$Provider$Mailgun$SendingDnsRecord$valid = function(_v0) {
        var sendingDnsRecord = _v0;
        return sendingDnsRecord.aa7;
    };
    var $author$project$Api$Provider$Mailgun$SendingDnsRecord$value = function(_v0) {
        var sendingDnsRecord = _v0;
        return sendingDnsRecord.aa9;
    };
    var $author$project$Pages$Admin$Mailgun$viewSendingDnsRecord = function(sendingDnsRecord) {
        return _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Record Configured: '),
                    $author$project$Api$Provider$Mailgun$SendingDnsRecord$valid(sendingDnsRecord) === 'valid' ? $author$project$Ui$Icon$check(_List_fromArray([
                        $author$project$Ui$Icon$success
                    ])) : $author$project$Ui$Icon$cross(_List_fromArray([
                        $author$project$Ui$Icon$danger
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Record Type: '),
                    A2($author$project$Ui$Typography$pre, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Mailgun$SendingDnsRecord$recordType(sendingDnsRecord))
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Hostname: '),
                    A2($author$project$Ui$Typography$pre, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Mailgun$SendingDnsRecord$name(sendingDnsRecord))
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Value: '),
                    A2($author$project$Ui$Typography$pre, _List_fromArray([
                        $author$project$Ui$Typography$preWrap
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Mailgun$SendingDnsRecord$value(sendingDnsRecord))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Mailgun$viewPanelBody = F2(function(model, mailgun) {
        var meta = $author$project$Api$Provider$Mailgun$One$meta(mailgun);
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Mailgun$One$status(mailgun)),
                    function() {
                        var _v0 = model.Oh;
                        if (_v0.$ === 1) return A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            $elm$html$Html$text('You do not have a website setup on your practice, please add that '),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('here')
                            ])),
                            $elm$html$Html$text(' before configuring Mailgun.')
                        ]));
                        else return $author$project$Utils$Html$empty;
                    }()
                ])),
                $author$project$Api$Provider$Mailgun$Meta$setupAaction(meta) && !model.w && $author$project$Utils$Maybe$toBool(model.Oh) ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Integrate with mailgun'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$EditEmail)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Integrate with Mailgun')
                    ]))
                ])) : $author$project$Utils$Html$empty
            ])),
            function() {
                var _v1 = _Utils_Tuple2($author$project$Api$Provider$Mailgun$One$status(mailgun) === 'active', $author$project$Api$Provider$Mailgun$Meta$verifyAction(meta));
                if (_v1.a) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('DNS Settings'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Icon$check(_List_fromArray([
                            $author$project$Ui$Icon$success
                        ])),
                        $elm$html$Html$text(' Correctly configured')
                    ]))
                ]));
                else {
                    if (_v1.b) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('DNS Settings'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), A2($elm$core$List$cons, A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Please set the following DNS records up on your website\'s DNS server.  For more information on how to do that '),
                        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/integrations/mailgun-integration', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('click here')
                        ])),
                        $elm$html$Html$text(' . This may take 24-48 hours for the changes to take effect.')
                    ])), A2($elm$core$List$cons, A3($author$project$Ui$Button$view, {
                        abP: 'Check dns records'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$Verify),
                        $author$project$Ui$Button$loading(_Utils_eq(model.pd, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Check DNS records now')
                    ])), A2($elm$core$List$concatMap, $author$project$Pages$Admin$Mailgun$viewSendingDnsRecord, $author$project$Api$Provider$Mailgun$One$sendingDnsRecords(mailgun)))));
                    else return $author$project$Utils$Html$empty;
                }
            }(),
            function() {
                var _v2 = $author$project$Api$Provider$Mailgun$One$domain(mailgun);
                if (!_v2.$) {
                    var domain = _v2.a;
                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Domain'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(domain)
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Mailgun$One$email(mailgun)) || model.w ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Email'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                function() {
                    var _v3 = _Utils_Tuple2(model.w, model.Oh);
                    if (_v3.a && !_v3.b.$) {
                        var domain = _v3.b.a;
                        var fields = $author$project$Utils$Form$fields(model.PU);
                        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock
                            ]), _List_fromArray([
                                $elm$html$Html$text('You must be able to receive email at this address for patients to be able to reply to emails. '),
                                $elm$html$Html$text('If you want to use another email address and it is at a domain you own (not @gmail.com, @outlook.com, etc) contact us.')
                            ])),
                            model.F3 ? $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(fields.OH),
                                $author$project$Ui$Form$Input$autoComplete(false),
                                $author$project$Ui$Form$Input$placeholder('billing@example.com'),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Mailgun$FormUpdated, $author$project$Pages$Admin$Mailgun$Email)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU))
                            ])) : $author$project$Ui$Form$Input$group(_List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value(fields.xr),
                                    $author$project$Ui$Form$Input$autoComplete(false),
                                    $author$project$Ui$Form$Input$placeholder('billing'),
                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Mailgun$FormUpdated, $author$project$Pages$Admin$Mailgun$EmailLocalPart(domain))),
                                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU))
                                ])),
                                $author$project$Ui$Form$Input$addon(_List_fromArray([
                                    $elm$html$Html$text('@' + domain)
                                ]))
                            ])),
                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, model.PU)),
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Setup mailgun integration'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$primary,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Mailgun$Setup),
                                    $author$project$Ui$Button$loading(_Utils_eq(model.oh, $author$project$Api$Data$Loading))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Setup')
                                ]))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                !model.w ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Mailgun$One$email(mailgun)))
                ])) : $author$project$Utils$Html$empty
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('About'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Our Mailgun integration allows you to customize the domain and email address for notifications that are sent from our platform.')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Learn more '),
                        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/integrations/mailgun-integration', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('here')
                        ])),
                        $elm$html$Html$text('.')
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Admin$Mailgun$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            A4($author$project$Ui$Image$view, model.qW, {
                                Jg: 'Mailgun Logo'
                            }, _List_fromArray([
                                $author$project$Ui$Image$width(200)
                            ]), 3)
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, function() {
                            var _v0 = model.mY;
                            if (_v0.$ === 3) {
                                var mailgun = _v0.a;
                                return A2($author$project$Pages$Admin$Mailgun$viewPanelBody, model, mailgun);
                            } else return _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                                ]), _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_Nil)
                                ]))
                            ]);
                        }())
                    ]))
                ]))
            ]),
            $2: 'Integrations | Mailgun'
        };
    };
    var $author$project$Pages$Admin$Mailgun$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Mailgun$init,
        aeR: $author$project$Pages$Admin$Mailgun$load,
        ag3: $author$project$Pages$Admin$Mailgun$save,
        ahE: $author$project$Pages$Admin$Mailgun$subscriptions,
        aaO: $author$project$Pages$Admin$Mailgun$update,
        aid: $author$project$Pages$Admin$Mailgun$view
    });
    var $author$project$Pages$Admin$Notes$NotesMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Note$Practice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Notes$FlaggedDropdownMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Notes$Model = $elm$core$Basics$identity;
    var $author$project$Components$Notes$GotNotes = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Note$All$Note = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Note$Shared$Note = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Note$Shared$Record = F6(function(id, content, flagged, createdAt, createdBy, meta) {
        return {
            EU: content,
            Mx: createdAt,
            My: createdBy,
            Fx: flagged,
            aef: id,
            Ue: meta
        };
    });
    var $author$project$Api$Provider$Note$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Note$Meta$MetaRecord = function(editable) {
        return {
            Ot: editable
        };
    };
    var $author$project$Api$Provider$Note$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Note$Meta$MetaRecord));
    var $author$project$Api$Provider$Note$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Note$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Note$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Note$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_by', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'flagged', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'content', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Note$Shared$Record)))))));
    var $author$project$Api$Provider$Note$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Note$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Note$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Note$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Note$listDefaults = {
        Fx: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Note$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Note$listDefaults);
        var _v0 = options.Fx;
        if (!_v0.$) {
            var bool = _v0.a;
            return _List_fromArray([
                A2($author$project$Api$Param$bool, 'flagged', bool)
            ]);
        } else return _List_Nil;
    };
    var $author$project$Api$Provider$Note$practicePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'practice',
            id_
        ]), $author$project$Api$Data$providerPath);
    };
    var $author$project$Api$Provider$Note$notablePath = function(notable) {
        switch(notable.$){
            case 0:
                var id_ = notable.a;
                return $author$project$Api$Provider$Note$practicePath(id_);
            case 1:
                var id_ = notable.a;
                return $author$project$Api$Provider$Company$companyPath(id_);
            default:
                var id_ = notable.a;
                return $author$project$Api$Provider$Patient$patientPath(id_);
        }
    };
    var $author$project$Api$Provider$Note$notesPath = function(notable) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'notes'
        ]), $author$project$Api$Provider$Note$notablePath(notable));
    };
    var $author$project$Api$Provider$Note$list = F4(function(apiClient, notable, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Note$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Note$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Note$notesPath(notable))));
    });
    var $author$project$Components$Notes$fetchNotes = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$Note$list, apiClient, model.ji, $elm$core$Basics$identity, $author$project$Components$Notes$GotNotes);
    });
    var $author$project$Components$Notes$All = 0;
    var $author$project$Components$Notes$Flagged = 1;
    var $author$project$Components$Notes$Unflagged = 2;
    var $author$project$Components$Notes$flaggedOptionFromQuery = function(queryString) {
        _v0$2: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'flagged':
                    return 1;
                case 'unflagged':
                    return 2;
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return 0;
    };
    var $author$project$Components$Notes$init = F6(function(apiClient, timeFormatter, baseRoute, query, notable, isPracticeAdmin) {
        var model = {
            Eq: baseRoute,
            ih: $elm$core$Maybe$Nothing,
            dU: $elm$core$Set$empty,
            Fx: $author$project$Components$Notes$flaggedOptionFromQuery(A2($elm$core$Dict$get, 'flagged', query)),
            mm: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'flagged-dropdown-filter',
                ahX: $author$project$Components$Notes$FlaggedDropdownMsg
            })),
            d7: $elm$core$Set$empty,
            F4: isPracticeAdmin,
            ji: notable,
            S: $elm$core$Maybe$Nothing,
            jj: $author$project$Api$Data$Loading,
            HO: timeFormatter
        };
        return _Utils_Tuple2(model, A2($author$project$Components$Notes$fetchNotes, apiClient, model));
    });
    var $author$project$Pages$Admin$Notes$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A6($author$project$Components$Notes$init, shared.Ej, shared.HO, $author$project$Spa$Generated$Route$Admin__Notes, query, $author$project$Api$Provider$Note$Practice($author$project$Api$Provider$Practice$One$id(practice)), $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
        var notes = _v1.a;
        var notesCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: notes
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
    });
    var $author$project$Pages$Admin$Notes$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notes$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Notes$CancelNoteEdit = {
        $: 11
    };
    var $author$project$Components$Notes$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Notes$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = model.S;
                if (!_v1.$) return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Notes$CancelNoteEdit);
                else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Notes$HiConfirmClosed), model.ih)),
            $author$project$Ui$Dropdown$subscriptions(model.mm)
        ]));
    };
    var $author$project$Pages$Admin$Notes$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Notes$subscriptions(model.rk));
    };
    var $author$project$Components$Notes$NoteDeleted = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Notes$NoteFlagged = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Note$notePath = F2(function(notable, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Note$notesPath(notable));
    });
    var $author$project$Api$Provider$Note$delete = F4(function(apiClient, notable, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Note$notePath, notable, id_)));
    });
    var $author$project$Api$Provider$Note$One$Note = 0;
    var $author$project$Api$Provider$Note$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Note$flag = F5(function(apiClient, notable, id_, flagged_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('note', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('flagged', $elm$json$Json$Encode$bool(flagged_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Note$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Note$notePath, notable, id_))));
    });
    var $author$project$Api$Provider$Note$Shared$content = function(_v0) {
        var record = _v0;
        return record.EU;
    };
    var $author$project$Api$Provider$Note$All$content = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Note$Shared$content(shared);
    };
    var $author$project$Components$Notes$formFieldsFromNote = function(note) {
        return $author$project$Api$Provider$Note$All$content(note);
    };
    var $author$project$Components$Notes$formFieldsInit = '';
    var $author$project$Components$Notes$formFieldsUpdate = F2(function(field, _v0) {
        var string = field;
        return string;
    });
    var $author$project$Components$Notes$ContentValidation = 0;
    var $author$project$Components$Notes$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter some content.'))
    ]));
    var $author$project$Api$Provider$Note$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Note$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Note$Shared$id(shared);
    };
    var $author$project$Components$Notes$NoteCreated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Note$create = F4(function(apiClient, notable, content_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('note', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('content', $elm$json$Json$Encode$string(content_))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Note$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Note$notesPath(notable))));
    });
    var $author$project$Components$Notes$createNote = F3(function(apiClient, notable, formFields) {
        var content = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Note$create, apiClient, notable, content, $author$project$Components$Notes$NoteCreated);
    });
    var $author$project$Components$Notes$NoteUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Note$update = F5(function(apiClient, notable, id_, content_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('note', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('content', $elm$json$Json$Encode$string(content_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Note$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Note$notePath, notable, id_))));
    });
    var $author$project$Components$Notes$updateNote = F4(function(apiClient, notable, id, formFields) {
        var content = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A5($author$project$Api$Provider$Note$update, apiClient, notable, id, content, $author$project$Components$Notes$NoteUpdated);
    });
    var $author$project$Components$Notes$saveNote = F4(function(apiClient, notable, maybeId, formFields) {
        if (!maybeId.$) {
            var id = maybeId.a;
            return A4($author$project$Components$Notes$updateNote, apiClient, notable, id, formFields);
        } else return A3($author$project$Components$Notes$createNote, apiClient, notable, formFields);
    });
    var $author$project$Components$Notes$flaggedOptionToValue = function(option) {
        switch(option){
            case 1:
                return 'flagged';
            case 2:
                return 'unflagged';
            default:
                return '';
        }
    };
    var $author$project$Components$Notes$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            function() {
                var _v0 = model.Fx;
                if (!_v0) return $elm$core$Maybe$Nothing;
                else return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'flagged', $author$project$Components$Notes$flaggedOptionToValue(model.Fx)));
            }()
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString(model.Eq)
        ]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    };
    var $author$project$Components$Notes$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    jj: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    S: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Notes$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var field = msg.a;
                var _v2 = model.S;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var note = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Notes$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        S: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, note))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var id = msg.a;
                var bool = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    d7: A2($elm$core$Set$insert, id, model.d7)
                }), A5($author$project$Api$Provider$Note$flag, apiClient, model.ji, id, bool, $author$project$Components$Notes$NoteFlagged(id)), _List_Nil);
            case 4:
                var note = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    S: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$Note$All$id(note)), $author$project$Utils$Form$init($author$project$Components$Notes$formFieldsFromNote(note)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ih: $elm$core$Maybe$Just(id)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                var _v4 = model.S;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var id = _v5.a;
                    var form = _v5.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        S: $elm$core$Maybe$Nothing
                    }), A2($author$project$Components$Notes$fetchNotes, apiClient, model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Note successfully created')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        S: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            d7: A2($elm$core$Set$remove, id, model.d7),
                            jj: $author$project$Api$Data$Loading
                        }), A2($author$project$Components$Notes$fetchNotes, apiClient, model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Note successfully updated')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            d7: A2($elm$core$Set$remove, id, model.d7)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 8:
                var response = msg.a;
                var _v8 = model.S;
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var id = _v9.a;
                    var form = _v9.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        S: $elm$core$Maybe$Nothing
                    }), A2($author$project$Components$Notes$fetchNotes, apiClient, model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Note successfully updated')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        S: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dU: A2($elm$core$Set$remove, id, model.dU),
                            jj: $author$project$Api$Data$Loading
                        }), A2($author$project$Components$Notes$fetchNotes, apiClient, model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Note successfully deleted')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dU: A2($elm$core$Set$remove, id, model.dU)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 10:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    ih: $elm$core$Maybe$Nothing,
                    dU: A2($elm$core$Set$insert, id, model.dU)
                }), A4($author$project$Api$Provider$Note$delete, apiClient, model.ji, id, $author$project$Components$Notes$NoteDeleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    ih: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                return _Utils_Tuple3(_Utils_update(model, {
                    S: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var form = msg.a;
                var id = msg.b;
                var _v12 = A2($author$project$Utils$Form$validate, $author$project$Components$Notes$formFieldsValidator, form);
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var newForm = _v13.a;
                    var validFormFields = _v13.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        S: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A4($author$project$Components$Notes$saveNote, apiClient, model.ji, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v12.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        S: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 13:
                var subMsg = msg.a;
                var _v14 = A2($author$project$Ui$Dropdown$update, subMsg, model.mm);
                var dropdown = _v14.a;
                var dropdownCmd = _v14.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mm: dropdown
                }), dropdownCmd, _List_Nil);
            default:
                var flagged = msg.a;
                var newModel = _Utils_update(model, {
                    Fx: flagged,
                    jj: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Notes$fetchNotes, apiClient, newModel),
                    $author$project$Components$Notes$updateUrl(newModel)
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Notes$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Notes$update, model.Ej, subMsg, model.rk);
        var notes = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: notes
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Notes$NewNote = {
        $: 1
    };
    var $author$project$Api$Provider$Note$Shared$flagged = function(_v0) {
        var record = _v0;
        return record.Fx;
    };
    var $author$project$Api$Provider$Note$All$flagged = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Note$Shared$flagged(shared);
    };
    var $author$project$Components$Notes$filterNotes = F2(function(flagged, notes) {
        return A2($elm$core$List$filter, function(note) {
            switch(flagged){
                case 0:
                    return true;
                case 1:
                    return $author$project$Api$Provider$Note$All$flagged(note);
                default:
                    return !$author$project$Api$Provider$Note$All$flagged(note);
            }
        }, notes);
    });
    var $author$project$Components$Notes$FlaggedFiltered = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Notes$flaggedOptionToLabel = function(option) {
        switch(option){
            case 1:
                return 'Flagged';
            case 2:
                return 'Unflagged';
            default:
                return 'All Notes';
        }
    };
    var $author$project$Components$Notes$flaggedDropdownOptions = function(currentFlaggedOption) {
        var flaggedOptionToItem = function(option) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentFlaggedOption, option)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Notes$FlaggedFiltered(option))
            ]), $elm$html$Html$text($author$project$Components$Notes$flaggedOptionToLabel(option)));
        };
        return A2($elm$core$List$cons, flaggedOptionToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, flaggedOptionToItem, _List_fromArray([
            1,
            2
        ]))));
    };
    var $author$project$Components$Notes$viewFlaggedDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Components$Notes$flaggedOptionToLabel(model.Fx))
        ]), $author$project$Components$Notes$flaggedDropdownOptions(model.Fx), model.mm);
    };
    var $author$project$Components$Notes$DeleteNote = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Notes$EditNote = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Notes$FlagNote = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Note$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Note$All$createdAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Note$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$Note$Shared$createdBy = function(_v0) {
        var record = _v0;
        return record.My;
    };
    var $author$project$Api$Provider$Note$All$createdBy = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Note$Shared$createdBy(shared);
    };
    var $author$project$Api$Provider$Note$Meta$editable = function(_v0) {
        var meta = _v0;
        return meta.Ot;
    };
    var $author$project$Ui$Icon$Flag = 43;
    var $author$project$Ui$Icon$flag = $author$project$Ui$Icon$viewIcon(43);
    var $author$project$Api$Provider$Note$Shared$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Api$Provider$Note$All$meta = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Note$Shared$meta(shared);
    };
    var $author$project$Ui$OverflowWrap$WrapWord = 3;
    var $author$project$Ui$OverflowWrap$wrapWord = 3;
    var $author$project$Components$Notes$viewNote = F5(function(timeFormatter, flaggingNotes, deletingNotes, note, isPracticeAdmin) {
        var id = $author$project$Api$Provider$Note$All$id(note);
        var loading = A2($elm$core$Set$member, id, flaggingNotes) || A2($elm$core$Set$member, id, deletingNotes);
        return A2($author$project$Ui$ListGroup$item, _List_fromArray([
            $author$project$Ui$ListGroup$clearfix,
            $author$project$Ui$ListGroup$note
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$phi(true),
                        $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$wrapWord),
                        $author$project$Ui$Typography$preWrap
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Note$All$content(note))
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$User$Shared$name, $author$project$Api$Provider$Note$All$createdBy(note)))),
                        $elm$html$Html$text(' commented on '),
                        $elm$html$Html$text(A2(timeFormatter, 5, $author$project$Api$Provider$Note$All$createdAt(note)))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        function() {
                            var noteFlagged = $author$project$Api$Provider$Note$All$flagged(note);
                            var verb = noteFlagged ? 'Unflag' : 'Flag';
                            return A3($author$project$Ui$Button$view, {
                                abP: verb + ' note'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$loading(loading),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$Notes$FlagNote, id, !noteFlagged)),
                                $author$project$Ui$Button$styled(noteFlagged ? 1 : 0),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
                            ]), _List_fromArray([
                                $elm$html$Html$text(verb)
                            ]));
                        }(),
                        $author$project$Api$Provider$Note$Meta$editable($author$project$Api$Provider$Note$All$meta(note)) ? A3($author$project$Ui$Button$view, {
                            abP: 'Edit note'
                        }, _List_fromArray([
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick($author$project$Components$Notes$EditNote(note)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Edit')
                        ])) : $author$project$Utils$Html$empty,
                        $author$project$Api$Provider$Note$Meta$editable($author$project$Api$Provider$Note$All$meta(note)) || isPracticeAdmin ? A3($author$project$Ui$Button$view, {
                            abP: 'Delete note'
                        }, _List_fromArray([
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$danger,
                            $author$project$Ui$Button$loading(loading),
                            $author$project$Ui$Button$onClick($author$project$Components$Notes$DeleteNote(id))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Delete')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Notes$Content = $elm$core$Basics$identity;
    var $author$project$Components$Notes$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Notes$SaveNote = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Notes$viewNoteModal = F3(function(maybeId, note, form) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Note',
            Tk: _Utils_eq(note, $author$project$Api$Data$Loading),
            TR: maybeId,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Notes$CancelNoteEdit,
            Vn: $author$project$Components$Notes$SaveNote(form)
        };
        var content = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Content')
            ]), _List_fromArray([
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$value(content),
                    $author$project$Ui$Form$Textarea$phi(true),
                    $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Notes$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Textarea$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Components$Notes$viewNoteSkeleton = A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(3)
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(6)
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(7)
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(6)
            ]))
        ]))
    ]));
    var $author$project$Components$Notes$noun = function(notable) {
        switch(notable.$){
            case 0:
                return 'practice';
            case 1:
                return 'company';
            default:
                return 'patient';
        }
    };
    var $author$project$Components$Notes$zeroStateText = F2(function(notable, flagged) {
        return 'This ' + ($author$project$Components$Notes$noun(notable) + (' has no ' + ($author$project$Components$Notes$flaggedOptionToValue(flagged) + ' notes')));
    });
    var $author$project$Components$Notes$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            function() {
                var _v1 = model.S;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var id = _v2.a;
                    var form = _v2.b;
                    var note = _v2.c;
                    return A3($author$project$Components$Notes$viewNoteModal, id, note, form);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.ih;
                if (!_v3.$) {
                    var id = _v3.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Notes$HiConfirmClosed(id), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('note')
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Notes')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add new note'
                        }, _List_fromArray([
                            $author$project$Ui$Button$default,
                            $author$project$Ui$Button$onClick($author$project$Components$Notes$NewNote),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('New Note')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(4)
                        ]), _List_fromArray([
                            $author$project$Components$Notes$viewFlaggedDropdown(model)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    function() {
                        var _v4 = model.jj;
                        if (_v4.$ === 3) {
                            var notes = _v4.a;
                            var filteredNotes = A2($author$project$Components$Notes$filterNotes, model.Fx, notes);
                            return $elm$core$List$isEmpty(filteredNotes) ? A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $elm$html$Html$text(A2($author$project$Components$Notes$zeroStateText, model.ji, model.Fx))
                            ])) : A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, function(note) {
                                return A5($author$project$Components$Notes$viewNote, model.HO, model.d7, model.dU, note, model.F4);
                            }, filteredNotes));
                        } else return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$repeat, 5, $author$project$Components$Notes$viewNoteSkeleton));
                    }()
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Notes$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Notes$view(model.rk)),
            $2: 'Admin | Notes'
        };
    };
    var $author$project$Pages$Admin$Notes$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Notes$init,
        aeR: $author$project$Pages$Admin$Notes$load,
        ag3: $author$project$Pages$Admin$Notes$save,
        ahE: $author$project$Pages$Admin$Notes$subscriptions,
        aaO: $author$project$Pages$Admin$Notes$update,
        aid: $author$project$Pages$Admin$Notes$view
    });
    var $author$project$Pages$Admin$Notifications$Company$AdminTableMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$NotificationSetting$Company = 3;
    var $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$GotPracticeNotificationSettings = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$NotificationSetting$Membership = 1;
    var $author$project$Api$Provider$NotificationSetting$All$NotificationSetting = $elm$core$Basics$identity;
    var $author$project$Api$Provider$NotificationSetting$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$NotificationSetting$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$NotificationSetting$list = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$NotificationSetting$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$NotificationSetting$notificationSettingsPath(companyId)));
    });
    var $author$project$Api$Provider$NotificationSetting$categoryToString = function(category) {
        switch(category){
            case 0:
                return 'patient';
            case 1:
                return 'membership';
            case 2:
                return 'practice';
            case 3:
                return 'company';
            default:
                return 'employee';
        }
    };
    var $author$project$Api$Provider$NotificationSetting$categoryToParams = function(category) {
        if (category === 2) return _List_fromArray([
            A2($author$project$Api$Param$string, 'category_name', 'practice')
        ]);
        else return _List_fromArray([
            A2($author$project$Api$Param$string, 'category_name', $author$project$Api$Provider$NotificationSetting$categoryToString(category)),
            A2($author$project$Api$Param$string, 'sender_type', 'practice')
        ]);
    };
    var $author$project$Api$Provider$NotificationSetting$listDefaults = {
        EL: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$NotificationSetting$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$NotificationSetting$listDefaults);
        var _v0 = options.EL;
        if (!_v0.$) {
            var category = _v0.a;
            return $author$project$Api$Provider$NotificationSetting$categoryToParams(category);
        } else return _List_Nil;
    };
    var $author$project$Api$Provider$NotificationSetting$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$NotificationSetting$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$NotificationSetting$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$NotificationSetting$notificationSettingsPath)));
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$fetchAllNotificationSettings = F2(function(apiClient, model) {
        var _v0 = model.aC;
        if (_v0.$ === 1) {
            var companyId = _v0.a;
            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                A3($author$project$Api$Provider$NotificationSetting$list, apiClient, function(d) {
                    return _Utils_update(d, {
                        EL: $elm$core$Maybe$Just(1)
                    });
                }, $author$project$Components$Admin$NotificationSetting$AdminTable$GotPracticeNotificationSettings),
                A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings)
            ]));
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings = F2(function(apiClient, model) {
        var _v0 = model.aC;
        if (_v0.$ === 1) {
            var id = _v0.a;
            return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, id, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
        } else return A3($author$project$Api$Provider$NotificationSetting$list, apiClient, function(d) {
            return _Utils_update(d, {
                EL: $elm$core$Maybe$Just(model.EL)
            });
        }, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$Closed = {
        $: 0
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$init = $author$project$Components$Admin$NotificationSetting$MassEmail$Closed;
    var $author$project$Components$Admin$NotificationSetting$AdminTable$init = F4(function(apiClient, session, context, category) {
        var model = {
            EL: category,
            aC: context,
            Tk: true,
            m2: $author$project$Components$Admin$NotificationSetting$MassEmail$init,
            ru: false,
            U7: $elm$core$Maybe$Nothing,
            bd: _List_Nil,
            sb: $author$project$Api$Data$Loading,
            agk: $elm$core$Maybe$Nothing,
            Z$: session,
            Cx: false
        };
        return _Utils_Tuple2(model, function() {
            if (!context.$) return A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings, apiClient, model);
            else return A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchAllNotificationSettings, apiClient, model);
        }());
    });
    var $author$project$Pages$Admin$Notifications$Company$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var _v3 = A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 3);
        var adminTable = _v3.a;
        var adminTableCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            rk: adminTable
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
    });
    var $author$project$Pages$Admin$Notifications$Company$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notifications$Company$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$Close = {
        $: 1
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$subscriptions = function(model) {
        switch(model.$){
            case 0:
                return $elm$core$Platform$Sub$none;
            case 1:
                return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$MassEmail$Close);
            default:
                return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$MassEmail$Close);
        }
    };
    var $author$project$Components$Admin$NotificationSetting$Preview$CloseModal = {
        $: 0
    };
    var $author$project$Components$Admin$NotificationSetting$Preview$subscriptions = function(model) {
        return model.Vw ? $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v0 = A2($elm$core$Maybe$map, function($) {
                    return $.Vw;
                }, model.fD);
                if (!_v0.$ && _v0.a) return $elm$core$Platform$Sub$none;
                else return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$NotificationSetting$Preview$CloseModal);
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Ui$Dropdown$subscriptions, model.fD))
        ])) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v0 = model.agk;
                if (!_v0.$) {
                    var preview = _v0.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg, $author$project$Components$Admin$NotificationSetting$Preview$subscriptions(preview));
                } else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg, $author$project$Components$Admin$NotificationSetting$MassEmail$subscriptions(model.m2)),
            $elm$core$Platform$Sub$batch(A2($elm$core$List$map, function(_v2) {
                var setting = _v2.a;
                var customize = _v2.b;
                return A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(setting), $author$project$Components$Admin$NotificationSetting$Customize$subscriptions(customize));
            }, A2($elm$core$List$map, function(_v1) {
                var setting = _v1.a;
                var customize = _v1.c;
                return A2($elm$core$Tuple$pair, setting, customize);
            }, model.bd)))
        ]));
    };
    var $author$project$Pages$Admin$Notifications$Company$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rk));
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideCreated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideRemoved = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg = F3(function(a, b, c) {
        return {
            $: 4,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Provider$NotificationSetting$All$disableable = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$disableable(shared);
    };
    var $author$project$Api$Provider$NotificationSetting$All$enabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$enabled(shared);
    };
    var $author$project$Api$Provider$NotificationSetting$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$id(shared);
    };
    var $author$project$Components$Admin$NotificationSetting$Toggle$allGetters = {
        N_: $author$project$Api$Provider$NotificationSetting$All$disableable,
        OM: $author$project$Api$Provider$NotificationSetting$All$enabled,
        aef: $author$project$Api$Provider$NotificationSetting$All$id
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$customEnabled = function(_v0) {
        var record = _v0;
        return record.MT;
    };
    var $author$project$Api$Provider$NotificationSetting$All$customEnabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$customEnabled(shared);
    };
    var $author$project$Components$Admin$NotificationSetting$Preview$LanguageDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$NotificationSetting$All$isTranslatable = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$isTranslatable(shared);
    };
    var $author$project$Components$Admin$NotificationSetting$Preview$GotPreview = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting = F3(function(client, language, model) {
        var _v0 = model.aC;
        if (_v0.$ === 1) {
            var companyId = _v0.a;
            return A5($author$project$Api$Provider$Company$NotificationSetting$preview, client, companyId, $author$project$Api$Provider$NotificationSetting$All$id(model.U7), {
                fb: $elm$core$Maybe$Nothing,
                yC: language,
                HF: $elm$core$Maybe$Nothing
            }, $author$project$Components$Admin$NotificationSetting$Preview$GotPreview(language));
        } else return A4($author$project$Api$Provider$NotificationSetting$preview, client, $author$project$Api$Provider$NotificationSetting$All$id(model.U7), {
            fb: $elm$core$Maybe$Nothing,
            yC: language,
            HF: $elm$core$Maybe$Nothing
        }, $author$project$Components$Admin$NotificationSetting$Preview$GotPreview(language));
    });
    var $author$project$Components$Admin$NotificationSetting$Preview$init = F4(function(client, multiLanguage, notificationSetting, context) {
        var language = $author$project$Language$english;
        var model = {
            aC: context,
            fD: multiLanguage && $author$project$Api$Provider$NotificationSetting$All$isTranslatable(notificationSetting) ? $elm$core$Maybe$Just($author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'preview-language-dropdown',
                ahX: $author$project$Components$Admin$NotificationSetting$Preview$LanguageDropdownMsg
            }))) : $elm$core$Maybe$Nothing,
            yC: language,
            U7: notificationSetting,
            Vw: true,
            agk: A2($elm$core$Dict$singleton, $author$project$Language$toValue(language), $author$project$Api$Data$Loading)
        };
        return _Utils_Tuple2(model, A3($author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting, client, language, model));
    });
    var $author$project$Api$Provider$NotificationSetting$All$toShared = function(_v0) {
        var shared = _v0;
        return shared;
    };
    var $author$project$Components$Admin$NotificationSetting$Customize$initFromAll = F2(function(notificationSettingAll, context) {
        return A2($author$project$Components$Admin$NotificationSetting$Customize$init, $author$project$Api$Provider$NotificationSetting$All$toShared(notificationSettingAll), context);
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipEndedId = 'patient_membership_ended';
    var $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipMemberRemovedId = 'patient_membership_member_removed';
    var $author$project$Components$Admin$NotificationSetting$AdminTable$overridableCompanyToggleIds = _List_fromArray([
        $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipEndedId,
        $author$project$Components$Admin$NotificationSetting$AdminTable$patientMembershipMemberRemovedId
    ]);
    var $author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle = function(id) {
        return A2($elm$core$List$member, id, $author$project$Components$Admin$NotificationSetting$AdminTable$overridableCompanyToggleIds);
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$Previewing = F3(function(a, b, c) {
        return {
            $: 2,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$GotPatientsWithoutEmail = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$WithoutEmail = {
        $: 6
    };
    var $author$project$Api$Pagination$empty = A2($author$project$Api$Pagination$withItemsPerPage, 0, $author$project$Api$Pagination$init);
    var $author$project$Components$Admin$NotificationSetting$MassEmail$fetchPatientsWithoutEmail = function(apiClient) {
        return A3($author$project$Api$Provider$Patient$list, apiClient, function(d) {
            return _Utils_update(d, {
                Fw: _List_fromArray([
                    $author$project$Api$Provider$Patient$WithoutEmail
                ]),
                af_: $author$project$Api$Pagination$empty
            });
        }, $author$project$Components$Admin$NotificationSetting$MassEmail$GotPatientsWithoutEmail);
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment = function(selected) {
        return {
            ahb: $elm$core$Maybe$Nothing,
            ah: selected
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields = {
        hk: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
        hl: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
        iS: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false),
        iT: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(false)
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    hk: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
                });
            case 1:
                var string = field.a;
                var _v1 = fields;
                var activeRetail = _v1.hk;
                return _Utils_update(fields, {
                    hk: _Utils_update(activeRetail, {
                        ahb: $elm$core$Maybe$Just(string)
                    })
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    hl: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
                });
            case 3:
                var string = field.a;
                var _v2 = fields;
                var activeSponsored = _v2.hl;
                return _Utils_update(fields, {
                    hl: _Utils_update(activeSponsored, {
                        ahb: $elm$core$Maybe$Just(string)
                    })
                });
            case 4:
                var bool = field.a;
                return _Utils_update(fields, {
                    iS: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
                });
            case 5:
                var string = field.a;
                var _v3 = fields;
                var inactiveRetail = _v3.iS;
                return _Utils_update(fields, {
                    iS: _Utils_update(inactiveRetail, {
                        ahb: $elm$core$Maybe$Just(string)
                    })
                });
            case 6:
                var bool = field.a;
                return _Utils_update(fields, {
                    iT: $author$project$Components$Admin$NotificationSetting$MassEmail$initSegment(bool)
                });
            default:
                var string = field.a;
                var _v4 = fields;
                var inactiveSponsored = _v4.iT;
                return _Utils_update(fields, {
                    iT: _Utils_update(inactiveSponsored, {
                        ahb: $elm$core$Maybe$Just(string)
                    })
                });
        }
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$SegmentsValidation = 0;
    var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailValidation = 1;
    var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredValidation = 2;
    var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailValidation = 3;
    var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredValidation = 4;
    var $author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments = function(fields) {
        return A2($elm$core$List$filterMap, function(_v0) {
            var segment = _v0.a;
            var validationGroup = _v0.b;
            return segment.ah ? $elm$core$Maybe$Just(_Utils_Tuple2(segment, validationGroup)) : $elm$core$Maybe$Nothing;
        }, _List_fromArray([
            _Utils_Tuple2(fields.hk, 1),
            _Utils_Tuple2(fields.hl, 2),
            _Utils_Tuple2(fields.iS, 3),
            _Utils_Tuple2(fields.iT, 4)
        ]));
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$validatePatientsOneOffEmailSegments = function(fields) {
        var selectedSegments_ = $author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments(fields);
        return $elm$core$List$isEmpty(selectedSegments_) ? _List_fromArray([
            _Utils_Tuple2(0, 'Please check at least one.')
        ]) : A2($elm$core$List$filterMap, function(_v0) {
            var segment = _v0.a;
            var validationGroup = _v0.b;
            return segment.ah && _Utils_eq(segment.ahb, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just(_Utils_Tuple2(validationGroup, 'Please pick one.')) : $elm$core$Maybe$Nothing;
        }, selectedSegments_);
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsValidator = function(type_) {
        return $rtfeldman$elm_validate$Validate$all(type_ === 'patients_one_off_email' ? _List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$NotificationSetting$MassEmail$validatePatientsOneOffEmailSegments)
        ]) : _List_Nil);
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$Notification$notificationsPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'notifications'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$Notification$bulk = F5(function(apiClient, type_, segments, companyId, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('type', $elm$json$Json$Encode$string(type_)),
                _Utils_Tuple2('segments', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, segments))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bulk'
        ]), $author$project$Api$Provider$Company$Notification$notificationsPath(companyId)))));
    });
    var $author$project$Api$Provider$Notification$notificationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'notifications'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Notification$bulk = F4(function(apiClient, type_, segments, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('type', $elm$json$Json$Encode$string(type_)),
                _Utils_Tuple2('segments', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, segments))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bulk'
        ]), $author$project$Api$Provider$Notification$notificationsPath))));
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$sendBulkNotification = F3(function(client, shared, segments) {
        var _v0 = shared.aC;
        if (_v0.$ === 1) {
            var id = _v0.a;
            return A5($author$project$Api$Provider$Company$Notification$bulk, client, $author$project$Api$Provider$NotificationSetting$All$id(shared.U7), segments, id, $author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification);
        } else return A4($author$project$Api$Provider$Notification$bulk, client, $author$project$Api$Provider$NotificationSetting$All$id(shared.U7), segments, $author$project$Components$Admin$NotificationSetting$MassEmail$GotBulkNotification);
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$update = F4(function(apiClient, msg, model, context) {
        switch(msg.$){
            case 0:
                var session = msg.a;
                var notificationSetting = msg.b;
                var shared = {
                    aC: context,
                    U7: notificationSetting,
                    np: $author$project$Api$Data$Loading,
                    Z$: session
                };
                var formFields = $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields;
                return _Utils_Tuple3(A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, shared, $author$project$Utils$Form$init(formFields)), $author$project$Components$Admin$NotificationSetting$MassEmail$fetchPatientsWithoutEmail(apiClient), _List_Nil);
            case 6:
                var response = msg.a;
                var _v1 = _Utils_Tuple2(model, response);
                if (_v1.a.$ === 1) {
                    var _v2 = _v1.a;
                    var shared = _v2.a;
                    var notificationForm = _v2.b;
                    return _Utils_Tuple3(A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, _Utils_update(shared, {
                        np: response
                    }), notificationForm), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                return _Utils_Tuple3($author$project$Components$Admin$NotificationSetting$MassEmail$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                if (model.$ === 1) {
                    var shared = model.a;
                    var notificationForm = model.b;
                    var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsValidator($author$project$Api$Provider$NotificationSetting$All$id(shared.U7)), notificationForm);
                    if (!_v4.$) {
                        var _v5 = _v4.a;
                        var validFormFields = _v5.b;
                        var segments = A2($elm$core$List$filterMap, function($) {
                            return $.ahb;
                        }, A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Components$Admin$NotificationSetting$MassEmail$selectedSegments($rtfeldman$elm_validate$Validate$fromValid(validFormFields))));
                        return _Utils_Tuple3(A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, $author$project$Api$Data$NotAsked), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else {
                        var newForm = _v4.a;
                        return _Utils_Tuple3(A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, shared, newForm), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var field = msg.a;
                if (model.$ === 1) {
                    var shared = model.a;
                    var notificationForm = model.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$NotificationSetting$MassEmail$notificationSettingFormFieldsUpdate, field, notificationForm);
                    return _Utils_Tuple3(A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, shared, newForm), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                if (model.$ === 2) {
                    var shared = model.a;
                    var formFields = $author$project$Components$Admin$NotificationSetting$MassEmail$initNotificationFormFields;
                    return _Utils_Tuple3(A2($author$project$Components$Admin$NotificationSetting$MassEmail$SelectingSegments, shared, $author$project$Utils$Form$init(formFields)), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                if (model.$ === 2) {
                    var shared = model.a;
                    var segments = model.b;
                    return _Utils_Tuple3(A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, $author$project$Api$Data$Loading), A3($author$project$Components$Admin$NotificationSetting$MassEmail$sendBulkNotification, apiClient, shared, segments), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (model.$ === 2) {
                    var shared = model.a;
                    var segments = model.b;
                    if (response.$ === 3) return _Utils_Tuple3($author$project$Components$Admin$NotificationSetting$MassEmail$Closed, $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Notifications are being sent.')
                    ]));
                    else return _Utils_Tuple3(A3($author$project$Components$Admin$NotificationSetting$MassEmail$Previewing, shared, segments, response), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Admin$NotificationSetting$Preview$update = F3(function(client, msg, model) {
        switch(msg.$){
            case 3:
                var dropdownMsg = msg.a;
                var _v1 = model.fD;
                if (!_v1.$) {
                    var dropdown = _v1.a;
                    var _v2 = A2($author$project$Ui$Dropdown$update, dropdownMsg, dropdown);
                    var newDropdown = _v2.a;
                    var dropdownCmd = _v2.b;
                    return _Utils_Tuple2(_Utils_update(model, {
                        fD: $elm$core$Maybe$Just(newDropdown)
                    }), dropdownCmd);
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: false
                }), $elm$core$Platform$Cmd$none);
            case 2:
                var language = msg.a;
                var _v3 = function() {
                    var _v4 = A2($elm$core$Dict$get, $author$project$Language$toValue(language), model.agk);
                    if (_v4.$ === 1) return _Utils_Tuple2(A3($elm$core$Dict$insert, $author$project$Language$toValue(language), $author$project$Api$Data$Loading, model.agk), A3($author$project$Components$Admin$NotificationSetting$Preview$previewNotificationSetting, client, language, model));
                    else return _Utils_Tuple2(model.agk, $elm$core$Platform$Cmd$none);
                }();
                var preview = _v3.a;
                var previewCmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    yC: language,
                    agk: preview
                }), previewCmd);
            default:
                var language = msg.a;
                var preview = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    agk: A3($elm$core$Dict$insert, $author$project$Language$toValue(language), preview, model.agk)
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$withAdminUser = F2(function(isAdmin, model) {
        return _Utils_update(model, {
            DT: isAdmin
        });
    });
    var $author$project$Components$Admin$NotificationSetting$Customize$withMultiLanguage = F2(function(multiLanguage, model) {
        return _Utils_update(model, {
            ru: multiLanguage
        });
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var notificationSettings = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Tk: false,
                        bd: A2($elm$core$List$map, function(notificationSetting) {
                            return _Utils_Tuple3(notificationSetting, A2($author$project$Components$Admin$NotificationSetting$Toggle$init, $author$project$Components$Admin$NotificationSetting$Toggle$allGetters, notificationSetting), A2($author$project$Components$Admin$NotificationSetting$Customize$withMultiLanguage, model.ru, A2($author$project$Components$Admin$NotificationSetting$Customize$withAdminUser, $author$project$Api$Platform$User$Shared$isAdmin($author$project$Api$Platform$Session$One$user(model.Z$)), A2($author$project$Components$Admin$NotificationSetting$Customize$initFromAll, notificationSetting, model.aC))));
                        }, notificationSettings)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false,
                    bd: _List_Nil
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    sb: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var notificationSetting = msg.a;
                var _v3 = A4($author$project$Components$Admin$NotificationSetting$Preview$init, apiClient, model.ru, notificationSetting, model.aC);
                var preview = _v3.a;
                var previewCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    agk: $elm$core$Maybe$Just(preview)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg, previewCmd), _List_Nil);
            case 3:
                var currentSetting = msg.a;
                var subMsg = msg.b;
                var id = $author$project$Api$Provider$NotificationSetting$All$id(currentSetting);
                return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, function(_v5) {
                    var customizeNotification = _v5.c;
                    var result = A3($author$project$Components$Admin$NotificationSetting$Customize$update, apiClient, subMsg, customizeNotification);
                    var _v6 = function() {
                        var _v7 = result.adu;
                        if (_v7 === 1) return _Utils_Tuple2(true, A2($author$project$Components$Admin$NotificationSetting$AdminTable$fetchNotificationSettings, apiClient, model));
                        else return _Utils_Tuple2(false, $elm$core$Platform$Cmd$none);
                    }();
                    var loading = _v6.a;
                    var cmd = _v6.b;
                    return function(settings) {
                        return _Utils_Tuple3(_Utils_update(model, {
                            Tk: loading,
                            bd: settings
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(currentSetting), result.EQ),
                            cmd
                        ])), result.at);
                    }(A3($elm_community$list_extra$List$Extra$updateIf, function(_v8) {
                        var notificationSetting_ = _v8.a;
                        return _Utils_eq($author$project$Api$Provider$NotificationSetting$All$id(notificationSetting_), id);
                    }, function(_v9) {
                        var notificationSetting_ = _v9.a;
                        var toggleNotification = _v9.b;
                        return _Utils_Tuple3(notificationSetting_, toggleNotification, result.zi);
                    }, model.bd));
                }, A2($elm_community$list_extra$List$Extra$find, function(_v4) {
                    var notificationSetting = _v4.a;
                    return _Utils_eq($author$project$Api$Provider$NotificationSetting$All$id(notificationSetting), id);
                }, model.bd)));
            case 4:
                var id = msg.a;
                var toggleNotification = msg.b;
                var subMsg = msg.c;
                var refetchCmd = function() {
                    if ($author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle(id)) {
                        var _v13 = model.aC;
                        if (_v13.$ === 1) {
                            var companyId = _v13.a;
                            return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
                        } else return $elm$core$Platform$Cmd$none;
                    } else return $elm$core$Platform$Cmd$none;
                }();
                var _v10 = A4($author$project$Components$Admin$NotificationSetting$Toggle$update, apiClient, model.aC, subMsg, toggleNotification);
                var toggleNotification_ = _v10.a;
                var subCmd = _v10.b;
                var subOutMsg = _v10.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    bd: A3($elm_community$list_extra$List$Extra$updateIf, function(_v11) {
                        var notificationSetting_ = _v11.a;
                        return _Utils_eq($author$project$Api$Provider$NotificationSetting$All$id(notificationSetting_), id);
                    }, function(_v12) {
                        var notificationSetting_ = _v12.a;
                        var translateInput = _v12.c;
                        return _Utils_Tuple3(notificationSetting_, toggleNotification_, translateInput);
                    }, model.bd)
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification_), subCmd),
                    refetchCmd
                ])), subOutMsg);
            case 5:
                var id = msg.a;
                var companySetting = A2($elm$core$Maybe$map, function(_v18) {
                    var ns = _v18.a;
                    return ns;
                }, A2($elm_community$list_extra$List$Extra$find, function(_v17) {
                    var ns = _v17.a;
                    return _Utils_eq($author$project$Api$Provider$NotificationSetting$All$id(ns), id);
                }, model.bd));
                var hasOverride = function() {
                    if (!companySetting.$) {
                        var company = companySetting.a;
                        return !_Utils_eq($author$project$Api$Provider$NotificationSetting$All$customEnabled(company), $elm$core$Maybe$Nothing);
                    } else return false;
                }();
                var cmd = function() {
                    if (hasOverride) {
                        var _v14 = model.aC;
                        if (_v14.$ === 1) {
                            var companyId = _v14.a;
                            return A5($author$project$Api$Provider$Company$NotificationSetting$reset, apiClient, companyId, id, {
                                yC: $author$project$Language$english
                            }, $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideRemoved);
                        } else return $elm$core$Platform$Cmd$none;
                    } else {
                        var _v15 = _Utils_Tuple2(model.aC, companySetting);
                        if (_v15.a.$ === 1 && !_v15.b.$) {
                            var companyId = _v15.a.a;
                            var company = _v15.b.a;
                            var currentValue = $author$project$Api$Provider$NotificationSetting$All$enabled(company);
                            return A5($author$project$Api$Provider$Company$NotificationSetting$toggle, apiClient, companyId, id, currentValue, $author$project$Components$Admin$NotificationSetting$AdminTable$OverrideCreated);
                        } else return $elm$core$Platform$Cmd$none;
                    }
                }();
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 8:
                var subMsg = msg.a;
                var _v19 = A4($author$project$Components$Admin$NotificationSetting$MassEmail$update, apiClient, subMsg, model.m2, model.aC);
                var massEmail = _v19.a;
                var massEmailCmd = _v19.b;
                var massEmailOutMsgs = _v19.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false,
                    m2: massEmail
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg, massEmailCmd), massEmailOutMsgs);
            case 9:
                var previewMsg = msg.a;
                var _v20 = model.agk;
                if (!_v20.$) {
                    var preview = _v20.a;
                    return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg), A2($elm$core$Tuple$mapFirst, function(prev) {
                        return _Utils_update(model, {
                            agk: $elm$core$Maybe$Just(prev)
                        });
                    }, A3($author$project$Components$Admin$NotificationSetting$Preview$update, apiClient, previewMsg, preview))));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                if (response.$ === 3) {
                    var refetchCmd = function() {
                        var _v22 = model.aC;
                        if (_v22.$ === 1) {
                            var companyId = _v22.a;
                            return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    return _Utils_Tuple3(model, refetchCmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Override created. You can now customize this setting.')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var refetchCmd = function() {
                        var _v24 = model.aC;
                        if (_v24.$ === 1) {
                            var companyId = _v24.a;
                            return A3($author$project$Api$Provider$Company$NotificationSetting$list, apiClient, companyId, $author$project$Components$Admin$NotificationSetting$AdminTable$GotNotificationSettings);
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    return _Utils_Tuple3(model, refetchCmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Override removed. Now using practice default.')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$Notifications$Company$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Ej, subMsg, model.rk);
        var adminTable = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: adminTable
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Api$Provider$NotificationSetting$Shared$bodyExample = function(_v0) {
        var record = _v0;
        return record.Kk;
    };
    var $author$project$Api$Provider$NotificationSetting$All$bodyExample = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$bodyExample(shared);
    };
    var $author$project$Api$Provider$NotificationSetting$Shared$subjectExample = function(_v0) {
        var record = _v0;
        return record.$o;
    };
    var $author$project$Api$Provider$NotificationSetting$All$subjectExample = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$subjectExample(shared);
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveRetail = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$Errors = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$errors = $author$project$Ui$Form$Checkbox$Errors;
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveRetailPatients = F2(function(form, activeRetail) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(activeRetail.ah),
                        $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveRetail)),
                        $author$project$Ui$Form$Checkbox$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Retail patients')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(activeRetail.ahb, $elm$core$Maybe$Just('all_active_retail'))),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $elm$core$Basics$always($author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment('all_active_retail')))),
                        $author$project$Ui$Form$Radio$disabled(!activeRetail.ah)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('All retail patients.'),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Primary and dependent patients associated with an active/pending retail membership.')
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(activeRetail.ahb, $elm$core$Maybe$Just('active_retail_membership_owners'))),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $elm$core$Basics$always($author$project$Components$Admin$NotificationSetting$MassEmail$ActiveRetailSegment('active_retail_membership_owners')))),
                        $author$project$Ui$Form$Radio$disabled(!activeRetail.ah)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Membership owners only.'),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Only the patients who pay for an active/pending retail membership (includes membership owners who are only payers).')
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveSponsored = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveSponsoredPatients = F2(function(form, activeSponsored) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(activeSponsored.ah),
                        $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleActiveSponsored)),
                        $author$project$Ui$Form$Checkbox$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Sponsored patients')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(activeSponsored.ahb, $elm$core$Maybe$Just('all_active_sponsored'))),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $elm$core$Basics$always($author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment('all_active_sponsored')))),
                        $author$project$Ui$Form$Radio$disabled(!activeSponsored.ah)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('All sponsored patients.'),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Primary and dependent patients associated with an active/pending employer- or network-sponsored membership.')
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(activeSponsored.ahb, $elm$core$Maybe$Just('active_sponsored_membership_owners'))),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $elm$core$Basics$always($author$project$Components$Admin$NotificationSetting$MassEmail$ActiveSponsoredSegment('active_sponsored_membership_owners')))),
                        $author$project$Ui$Form$Radio$disabled(!activeSponsored.ah)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Membership owners only.'),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Only primary active employee or primary member of the network-sponsored membership.')
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveRetail = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveRetailPatients = F2(function(form, inactiveRetail) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(inactiveRetail.ah),
                        $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveRetail)),
                        $author$project$Ui$Form$Checkbox$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Retail patients')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(inactiveRetail.ahb, $elm$core$Maybe$Just('all_inactive_retail'))),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $elm$core$Basics$always($author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment('all_inactive_retail')))),
                        $author$project$Ui$Form$Radio$disabled(!inactiveRetail.ah)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('All retail patients.'),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Primary and dependent inactive patients on an inactive retail membership.')
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(inactiveRetail.ahb, $elm$core$Maybe$Just('inactive_retail_membership_owners'))),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $elm$core$Basics$always($author$project$Components$Admin$NotificationSetting$MassEmail$InactiveRetailSegment('inactive_retail_membership_owners')))),
                        $author$project$Ui$Form$Radio$disabled(!inactiveRetail.ah)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Membership owners only.'),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Only inactive patients who have previously owned a membership or are a payer on an active membership.')
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveSponsored = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveSponsoredPatients = F2(function(form, inactiveSponsored) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(inactiveSponsored.ah),
                        $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $author$project$Components$Admin$NotificationSetting$MassEmail$ToggleInactiveSponsored)),
                        $author$project$Ui$Form$Checkbox$errors(A2($author$project$Utils$Form$validationErrors, 4, form))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Sponsored patients')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(inactiveSponsored.ahb, $elm$core$Maybe$Just('all_inactive_sponsored'))),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $elm$core$Basics$always($author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment('all_inactive_sponsored')))),
                        $author$project$Ui$Form$Radio$disabled(!inactiveSponsored.ah)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('All sponsored patients.'),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Primary and dependent inactive patients associated with a network or employer sponsor.')
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(inactiveSponsored.ahb, $elm$core$Maybe$Just('inactive_sponsored_membership_owners'))),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$NotificationSetting$MassEmail$NotificationFormFieldUpdated, $elm$core$Basics$always($author$project$Components$Admin$NotificationSetting$MassEmail$InactiveSponsoredSegment('inactive_sponsored_membership_owners')))),
                        $author$project$Ui$Form$Radio$disabled(!inactiveSponsored.ah)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Membership owners only.'),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Only primary inactive employee or primary member of the network-sponsored membership.')
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection = F2(function(patientsWithoutEmail, segments) {
        var patientsWithoutEmailCount = function() {
            if (patientsWithoutEmail.$ === 3) {
                var headers = patientsWithoutEmail.b;
                return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
            } else return 0;
        }();
        return A2($elm$core$List$cons, A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            patientsWithoutEmailCount > 0 ? A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Note:')
                ])),
                $elm$html$Html$text(' We cannot email patients who are missing an email address. You have '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_fromArray([
                    $author$project$Ui$Link$routeParams(_List_fromArray([
                        A2($elm$url$Url$Builder$string, 'filter', 'without_email')
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', patientsWithoutEmailCount))
                ])),
                $elm$html$Html$text(' without an email address.')
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Select the recipients of your email')
            ]))
        ])), segments);
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewPatientsOneOffEmailContent = F2(function(form, shared) {
        var resource = shared.aC;
        var _v0 = $author$project$Utils$Form$fields(form);
        var activeRetail = _v0.hk;
        var inactiveRetail = _v0.iS;
        var activeSponsored = _v0.hl;
        var inactiveSponsored = _v0.iT;
        return A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection, shared.np, _List_fromArray([
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Active Patients')
            ])),
            _Utils_eq(resource, $author$project$Api$Provider$Notification$PracticeContext) ? A2($author$project$Ui$Typography$div, _List_Nil, A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveRetailPatients, form, activeRetail)) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Typography$div, _List_Nil, A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewActiveSponsoredPatients, form, activeSponsored)),
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Inactive Patients')
            ])),
            _Utils_eq(resource, $author$project$Api$Provider$Notification$PracticeContext) ? A2($author$project$Ui$Typography$div, _List_Nil, A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveRetailPatients, form, inactiveRetail)) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Typography$div, _List_Nil, A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewInactiveSponsoredPatients, form, inactiveSponsored))
        ]));
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewPreview = F2(function(subject, body) {
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Subject Line')
            ]), _List_fromArray([
                subject
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Body')
            ]), _List_fromArray([
                body
            ]))
        ]);
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModalBody = function(model) {
        switch(model.$){
            case 0:
                return _List_Nil;
            case 2:
                var shared = model.a;
                var delivery = model.c;
                return _Utils_ap(A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewPreview, A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$NotificationSetting$All$subjectExample(shared.U7))
                    ]))
                ])), A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$p, _List_fromArray([
                        $elm$html$Html$Attributes$class('notification-email-layout')
                    ]), _List_fromArray([
                        A2($author$project$Api$HtmlTemplate$view, $author$project$Api$Phi$displayAttr, $author$project$Api$Provider$NotificationSetting$All$bodyExample(shared.U7))
                    ]))
                ]))), _List_fromArray([
                    function() {
                        if (delivery.$ === 2) {
                            var error = delivery.a;
                            return A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Error sending email')
                                ])),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                $elm$html$Html$text($author$project$Api$Data$errorToString(error))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]));
            default:
                var shared = model.a;
                var form = model.b;
                var _v2 = $author$project$Api$Provider$NotificationSetting$All$id(shared.U7);
                switch(_v2){
                    case 'patient_setup_payment_information':
                        return A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewSegmentsSelection, shared.np, _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(12)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                                        $author$project$Ui$Form$Checkbox$disabled(true)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Employees')
                                    ])),
                                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                                        $author$project$Ui$Form$Checkbox$disabled(true)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Patients')
                                    ])),
                                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                                        $author$project$Ui$Form$Checkbox$disabled(true),
                                        $author$project$Ui$Form$Checkbox$value(true)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Membership Owners')
                                    ])),
                                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                                        $author$project$Ui$Form$Checkbox$disabled(true),
                                        $author$project$Ui$Form$Checkbox$value(true)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Missing Payment Information')
                                    ]))
                                ]))
                            ]))
                        ]));
                    case 'provider_and_location_selection_request':
                        var patientsWithoutEmailCount = function() {
                            var _v3 = shared.np;
                            if (_v3.$ === 3) {
                                var headers = _v3.b;
                                return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
                            } else return 0;
                        }();
                        return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                patientsWithoutEmailCount > 0 ? A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Note:')
                                    ])),
                                    $elm$html$Html$text(' We cannot email patients who are missing an email address. You have '),
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_fromArray([
                                        $author$project$Ui$Link$routeParams(_List_fromArray([
                                            A2($elm$url$Url$Builder$string, 'filter', 'without_email')
                                        ]))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', patientsWithoutEmailCount))
                                    ])),
                                    $elm$html$Html$text(' without an email address.')
                                ])) : $author$project$Utils$Html$empty
                            ]))
                        ]);
                    case 'patients_one_off_email':
                        return A2($author$project$Components$Admin$NotificationSetting$MassEmail$viewPatientsOneOffEmailContent, form, shared);
                    default:
                        return _List_Nil;
                }
        }
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$Preview = {
        $: 2
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$SelectSegments = {
        $: 3
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$Send = {
        $: 5
    };
    var $author$project$Utils$FormErrors$alert = F2(function(style, errorList) {
        return $elm$core$List$isEmpty(errorList) ? $author$project$Utils$Html$empty : A3($author$project$Ui$Alert$view, style, _List_fromArray([
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textCenter)
        ]), A2($elm$core$List$map, $elm$html$Html$text, errorList));
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModalFooter = function(model) {
        return $elm$core$List$singleton(A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap2
        ]), function() {
            switch(model.$){
                case 0:
                    return _List_Nil;
                case 2:
                    var request = model.c;
                    var loading = function() {
                        if (request.$ === 1) return true;
                        else return false;
                    }();
                    return _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel and close modal'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$SelectSegments)
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$chevronDown(_List_fromArray([
                                $author$project$Ui$Icon$rotate90
                            ])),
                            $elm$html$Html$text('Back')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Email patients'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$submit,
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$Send),
                            $author$project$Ui$Button$loading(loading),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Email Patients')
                        ]))
                    ]);
                default:
                    var form = model.b;
                    return _List_fromArray([
                        A2($author$project$Utils$FormErrors$alert, 2, A2($author$project$Utils$Form$validationErrors, 0, form)),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Preview before sending'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$MassEmail$Preview)
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$chevronDown(_List_fromArray([
                                $author$project$Ui$Icon$rotate270
                            ])),
                            $elm$html$Html$text(' Preview Before Sending')
                        ]))
                    ]);
            }
        }()));
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$NotificationSetting$MassEmail$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Send Mass Email')
            ])),
            $author$project$Ui$Modal$body($author$project$Components$Admin$NotificationSetting$MassEmail$viewModalBody(model)),
            $author$project$Ui$Modal$footer($author$project$Components$Admin$NotificationSetting$MassEmail$viewModalFooter(model))
        ]));
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$modal = function(model) {
        switch(model.$){
            case 0:
                return $author$project$Utils$Html$empty;
            case 1:
                return $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal(model);
            default:
                return $author$project$Components$Admin$NotificationSetting$MassEmail$viewModal(model);
        }
    };
    var $author$project$Components$Admin$NotificationSetting$Preview$LanguageSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$NotificationSetting$All$description = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$description(shared);
    };
    var $author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$NotificationSetting$Shared$shortDescriptionHtml(shared);
    };
    var $author$project$Components$Admin$NotificationSetting$Preview$viewSkeleton = _List_fromArray([
        $author$project$Ui$Skeleton$text(_List_Nil),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Subject Line')
        ]), _List_fromArray([
            A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Skeleton subject')
                ]))
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Body')
        ]), _List_fromArray([
            A2($author$project$Ui$Well$view, _List_Nil, A2($elm$core$List$repeat, 10, $author$project$Ui$Skeleton$text(_List_Nil)))
        ]))
    ]);
    var $author$project$Components$Admin$NotificationSetting$Preview$view = function(model) {
        return model.Vw ? A3($author$project$Ui$Modal$view, $author$project$Components$Admin$NotificationSetting$Preview$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title($author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml(model.U7))
            ])),
            $author$project$Ui$Modal$body(A2($elm$core$List$cons, A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$NotificationSetting$All$description(model.U7))
            ])), A2($elm$core$List$cons, function() {
                var _v0 = model.fD;
                if (!_v0.$) {
                    var dropdown = _v0.a;
                    var languageToItem = function(lang) {
                        return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$selected(_Utils_eq(lang, model.yC)),
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Admin$NotificationSetting$Preview$LanguageSelected(lang))
                        ]), $elm$html$Html$text($author$project$Language$toLabel(lang)));
                    };
                    var items = A2($elm$core$List$map, languageToItem, _List_fromArray([
                        $author$project$Language$english,
                        $author$project$Language$spanish
                    ]));
                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Viewing'),
                        $author$project$Ui$Form$Group$labelSpan(2),
                        $author$project$Ui$Form$Group$inputSpan(4)
                    ]), _List_fromArray([
                        A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Language$toLabel(model.yC))
                        ]), items, dropdown)
                    ]));
                } else return $elm$html$Html$text('');
            }(), function() {
                var _v1 = A2($elm$core$Dict$get, $author$project$Language$toValue(model.yC), model.agk);
                if (!_v1.$ && _v1.a.$ === 3) {
                    var _v2 = _v1.a;
                    var preview = _v2.a;
                    var subject = $author$project$Api$Provider$NotificationSettingPreview$subject(preview);
                    var body = $author$project$Api$Provider$NotificationSettingPreview$body(preview);
                    return _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Subject'),
                            $author$project$Ui$Form$Group$labelSpan(2)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(subject)
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Body'),
                            $author$project$Ui$Form$Group$labelSpan(2)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$class('notification-email-layout')
                                ]), _List_fromArray([
                                    A2($author$project$Api$HtmlTemplate$view, _List_Nil, body)
                                ]))
                            ]))
                        ]))
                    ]);
                } else return $author$project$Components$Admin$NotificationSetting$Preview$viewSkeleton;
            }()))),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$Preview$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ]))
            ]))
        ])) : $elm$html$Html$text('');
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$ViewNotificationSetting = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$MassEmail$OpenModal = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$NotificationSetting$MassEmail$supportedNotificationTypeIds = _List_fromArray([
        'patient_setup_payment_information',
        'patients_one_off_email',
        'provider_and_location_selection_request'
    ]);
    var $author$project$Components$Admin$NotificationSetting$MassEmail$button = F2(function(session, notificationSetting) {
        var canSendMassEmail = A2($elm$core$List$member, $author$project$Api$Provider$NotificationSetting$All$id(notificationSetting), $author$project$Components$Admin$NotificationSetting$MassEmail$supportedNotificationTypeIds);
        return canSendMassEmail ? A3($author$project$Ui$Button$view, {
            abP: 'Send Email'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick(A2($author$project$Components$Admin$NotificationSetting$MassEmail$OpenModal, session, notificationSetting))
        ]), _List_fromArray([
            $elm$html$Html$text('Send Email')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$viewDunningScheduleLink = F2(function(notificationSettingId, showCustomizeDunningFeature) {
        var invoiceSettingLink = A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Schedule')
        ]));
        var _v0 = _Utils_Tuple2(notificationSettingId, showCustomizeDunningFeature);
        _v0$2: while(true){
            if (_v0.b) switch(_v0.a){
                case 'patient_charge_failed':
                    return invoiceSettingLink;
                case 'patient_charge_failed_followup':
                    return invoiceSettingLink;
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$ToggleOverrideToggleVisibility = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$getNotificationSettingById = F2(function(id, data) {
        if (data.$ === 3) {
            var settings = data.a;
            return A2($elm_community$list_extra$List$Extra$find, function(setting) {
                return _Utils_eq($author$project$Api$Provider$NotificationSetting$All$id(setting), id);
            }, settings);
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$viewCompanyOverrideToggle = F3(function(id, toggleNotification, model) {
        var viewToggle = A2($elm$html$Html$map, A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification), $author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
        var practiceSettingsLoaded = function() {
            var _v4 = model.sb;
            if (_v4.$ === 3) return true;
            else return false;
        }();
        if (!practiceSettingsLoaded) return viewToggle;
        else {
            var companySetting = A2($elm$core$Maybe$map, function(_v3) {
                var ns = _v3.a;
                return ns;
            }, A2($elm_community$list_extra$List$Extra$find, function(_v2) {
                var ns = _v2.a;
                return _Utils_eq($author$project$Api$Provider$NotificationSetting$All$id(ns), id);
            }, model.bd));
            if (companySetting.$ === 1) return $author$project$Utils$Html$empty;
            else {
                var company = companySetting.a;
                var hasOverride = !_Utils_eq($author$project$Api$Provider$NotificationSetting$All$customEnabled(company), $elm$core$Maybe$Nothing);
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('flex flex-col items-start gap-2')
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        function() {
                            if (hasOverride) return viewToggle;
                            else {
                                var practiceSetting = A2($author$project$Components$Admin$NotificationSetting$AdminTable$getNotificationSettingById, id, model.sb);
                                if (!practiceSetting.$) {
                                    var practice = practiceSetting.a;
                                    return A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text($author$project$Api$Provider$NotificationSetting$All$enabled(practice) ? 'On' : 'Off')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }
                        }()
                    ])),
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('w-36')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: hasOverride ? 'Remove override' : 'Override'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleOverrideToggleVisibility(id))
                        ]), _List_fromArray([
                            $elm$html$Html$text(hasOverride ? 'Remove override' : 'Override')
                        ]))
                    ]))
                ]));
            }
        }
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$viewOverrideToggle = F3(function(id, toggleNotification, model) {
        var _v0 = model.aC;
        if (_v0.$ === 1) return $author$project$Components$Admin$NotificationSetting$AdminTable$isOverridableCompanyToggle(id) ? A3($author$project$Components$Admin$NotificationSetting$AdminTable$viewCompanyOverrideToggle, id, toggleNotification, model) : A2($elm$html$Html$map, A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification), $author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
        else return A2($elm$html$Html$map, A2($author$project$Components$Admin$NotificationSetting$AdminTable$ToggleNotificationMsg, id, toggleNotification), $author$project$Components$Admin$NotificationSetting$Toggle$view(toggleNotification));
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$viewSettingsLink = function(notificationSettingId) {
        var invoiceSettingLink = A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__InvoiceSettings, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Manage Sponsor Invoice Settings')
        ]));
        switch(notificationSettingId){
            case 'employer_invoice_created':
                return invoiceSettingLink;
            case 'employer_invoice_generating':
                return invoiceSettingLink;
            default:
                return $author$project$Utils$Html$empty;
        }
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$viewNotificationSetting = F5(function(session, showCustomizeDunningFeature, index, _v0, model) {
        var notificationSetting = _v0.a;
        var toggleNotification = _v0.b;
        var customizeModel = _v0.c;
        var id = $author$project$Api$Provider$NotificationSetting$All$id(notificationSetting);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$id(id)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt(index + 1) + (' - ' + $author$project$Api$Provider$NotificationSetting$All$shortDescriptionHtml(notificationSetting)))
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$NotificationSetting$All$description(notificationSetting)),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    $author$project$Api$Provider$NotificationSetting$All$id(notificationSetting) === 'patients_one_off_email' ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Learn how to customize a message '),
                        A3($author$project$Ui$Link$externalHref, 'http://support.hint.com/en/articles/3864748-custom-notifications', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('here')
                        ]))
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'View notification setting'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$NotificationSetting$AdminTable$ViewNotificationSetting(notificationSetting))
                    ]), _List_fromArray([
                        $elm$html$Html$text('View')
                    ])),
                    A2($elm$html$Html$map, $author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(notificationSetting), $author$project$Components$Admin$NotificationSetting$Customize$button(customizeModel)),
                    A2($elm$html$Html$map, $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg, A2($author$project$Components$Admin$NotificationSetting$MassEmail$button, session, notificationSetting)),
                    A2($author$project$Components$Admin$NotificationSetting$AdminTable$viewDunningScheduleLink, $author$project$Api$Provider$NotificationSetting$All$id(notificationSetting), showCustomizeDunningFeature)
                ])),
                A2($elm$html$Html$map, $author$project$Components$Admin$NotificationSetting$AdminTable$CustomizeNotificationMsg(notificationSetting), $author$project$Components$Admin$NotificationSetting$Customize$modal(customizeModel))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Components$Admin$NotificationSetting$AdminTable$viewOverrideToggle, id, toggleNotification, model),
                $author$project$Components$Admin$NotificationSetting$AdminTable$viewSettingsLink($author$project$Api$Provider$NotificationSetting$All$id(notificationSetting))
            ]))
        ]));
    });
    var $author$project$Components$Admin$NotificationSetting$AdminTable$viewTable = function(model) {
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$loading(model.Tk)
        ]), _List_Nil, A2($elm$core$List$indexedMap, F2(function(index, item) {
            return A5($author$project$Components$Admin$NotificationSetting$AdminTable$viewNotificationSetting, model.Z$, model.Cx, index, item, model);
        }), model.bd), _List_Nil);
    };
    var $author$project$Components$Admin$NotificationSetting$AdminTable$view = function(model) {
        return _List_fromArray([
            function() {
                var _v0 = model.agk;
                if (!_v0.$) {
                    var preview = _v0.a;
                    return A2($elm$html$Html$map, $author$project$Components$Admin$NotificationSetting$AdminTable$PreviewMsg, $author$project$Components$Admin$NotificationSetting$Preview$view(preview));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($elm$html$Html$map, $author$project$Components$Admin$NotificationSetting$AdminTable$MassEmailMsg, $author$project$Components$Admin$NotificationSetting$MassEmail$modal(model.m2)),
            $author$project$Components$Admin$NotificationSetting$AdminTable$viewTable(model)
        ]);
    };
    var $author$project$Pages$Admin$Notifications$Company$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Employer Notifications')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('These are emails that will be sent to any employers who are sponsoring employee memberships.')
                    ])), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rk))))
                ]))
            ]),
            $2: 'Admin | Notifications'
        };
    };
    var $author$project$Pages$Admin$Notifications$Company$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Notifications$Company$init,
        aeR: $author$project$Pages$Admin$Notifications$Company$load,
        ag3: $author$project$Pages$Admin$Notifications$Company$save,
        ahE: $author$project$Pages$Admin$Notifications$Company$subscriptions,
        aaO: $author$project$Pages$Admin$Notifications$Company$update,
        aid: $author$project$Pages$Admin$Notifications$Company$view
    });
    var $author$project$Pages$Admin$Notifications$Employee$AdminTableMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$NotificationSetting$Employee = 4;
    var $author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature = F2(function(multiLanguage, model) {
        return _Utils_update(model, {
            ru: multiLanguage
        });
    });
    var $author$project$Pages$Admin$Notifications$Employee$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var multilanguageEnabled = A2($author$project$Api$Practice$featureEnabled, 10, $author$project$Api$Practice$Provider(practice));
        var _v2 = A2($elm$core$Tuple$mapFirst, $author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled), A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 4));
        var adminTable = _v2.a;
        var adminTableCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            rk: adminTable
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
    });
    var $author$project$Pages$Admin$Notifications$Employee$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notifications$Employee$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Notifications$Employee$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rk));
    };
    var $author$project$Pages$Admin$Notifications$Employee$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Ej, subMsg, model.rk);
        var adminTable = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: adminTable
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Admin$Notifications$Employee$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Employee Notifications')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('These are emails that will be sent to any patients who are being sponsored by their employers. '),
                        $elm$html$Html$text('They will also receive any patient emails that don\'t relate to payment of their memberships.')
                    ])), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rk))))
                ]))
            ]),
            $2: 'Admin | Notifications'
        };
    };
    var $author$project$Pages$Admin$Notifications$Employee$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Notifications$Employee$init,
        aeR: $author$project$Pages$Admin$Notifications$Employee$load,
        ag3: $author$project$Pages$Admin$Notifications$Employee$save,
        ahE: $author$project$Pages$Admin$Notifications$Employee$subscriptions,
        aaO: $author$project$Pages$Admin$Notifications$Employee$update,
        aid: $author$project$Pages$Admin$Notifications$Employee$view
    });
    var $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ZS;
    });
    var $author$project$Pages$Admin$Notifications$Membership$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var multilanguageEnabled = A2($author$project$Api$Practice$featureEnabled, 10, $author$project$Api$Practice$Provider(practice));
        var _v2 = A2($elm$core$Tuple$mapFirst, $author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled), A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 1));
        var adminTable = _v2.a;
        var adminTableCmd = _v2.b;
        return _Utils_Tuple2({
            kZ: adminTable,
            Ej: apiClient,
            W1: $author$project$Api$Data$NotAsked,
            ZS: $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification(practice)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg, adminTableCmd));
    });
    var $author$project$Pages$Admin$Notifications$Membership$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notifications$Membership$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Notifications$Membership$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg, $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.kZ));
    };
    var $author$project$Pages$Admin$Notifications$Membership$GotPractice = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$updateSendZeroRevenueMembershipNotification = F3(function(apiClient, bool, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('send_zero_revenue_membership_notification', $elm$json$Json$Encode$bool(bool))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Admin$Notifications$Membership$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Ej, subMsg, model.kZ);
                var adminTable = _v1.a;
                var subCmd = _v1.b;
                var subOutMsg = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    kZ: adminTable
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Membership$AdminTableMsg, subCmd), subOutMsg);
            case 1:
                var bool = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    W1: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Practice$updateSendZeroRevenueMembershipNotification, model.Ej, !bool, $author$project$Pages$Admin$Notifications$Membership$GotPractice), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        W1: response,
                        ZS: $author$project$Api$Provider$Practice$One$sendZeroRevenueMembershipNotification(practice)
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your membership notifications have been updated'),
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    W1: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$Notifications$Membership$SendZeroRevenueMembershipNotificationChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$Loading = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$loading = $author$project$Ui$Form$Checkbox$Loading;
    var $author$project$Pages$Admin$Notifications$Membership$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Membership Notifications')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('These are emails that will be sent to your patients automatically. Please remember, we do not send emails to patients without an ePHI waiver. '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('See who hasn\'t signed an ePHI waiver here.')
                        ]))
                    ])), A2($elm$core$List$cons, A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(!model.ZS),
                        $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$Admin$Notifications$Membership$SendZeroRevenueMembershipNotificationChanged),
                        $author$project$Ui$Form$Checkbox$loading(_Utils_eq(model.W1, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Don\'t send membership payment notifications to $0 memberships')
                        ]))
                    ])), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Admin$Notifications$Membership$AdminTableMsg), $author$project$Components$Admin$NotificationSetting$AdminTable$view(model.kZ)))))
                ]))
            ]),
            $2: 'Admin | Notifications'
        };
    };
    var $author$project$Pages$Admin$Notifications$Membership$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Notifications$Membership$init,
        aeR: $author$project$Pages$Admin$Notifications$Membership$load,
        ag3: $author$project$Pages$Admin$Notifications$Membership$save,
        ahE: $author$project$Pages$Admin$Notifications$Membership$subscriptions,
        aaO: $author$project$Pages$Admin$Notifications$Membership$update,
        aid: $author$project$Pages$Admin$Notifications$Membership$view
    });
    var $author$project$Pages$Admin$Notifications$Patient$AdminTableMsg = $elm$core$Basics$identity;
    var $author$project$Api$FeatureGate$CustomizeDunningSchedule = 10;
    var $author$project$Api$Provider$NotificationSetting$Patient = 0;
    var $author$project$Components$Admin$NotificationSetting$AdminTable$withCustomizeDunningFeature = F2(function(showCustomizeDunningFeature, model) {
        return _Utils_update(model, {
            Cx: showCustomizeDunningFeature
        });
    });
    var $author$project$Pages$Admin$Notifications$Patient$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var multiLanguageEnable = A2($author$project$Api$Practice$featureEnabled, 10, $author$project$Api$Practice$Provider(practice));
        var customDunningEnabled = A2($author$project$Utils$FeatureGate$gateAvailable, 10, $author$project$Api$Practice$Provider(practice));
        var _v2 = A2($elm$core$Tuple$mapFirst, $author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multiLanguageEnable), A2($elm$core$Tuple$mapFirst, $author$project$Components$Admin$NotificationSetting$AdminTable$withCustomizeDunningFeature(customDunningEnabled), A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 0)));
        var adminTable = _v2.a;
        var adminTableCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            rk: adminTable
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
    });
    var $author$project$Pages$Admin$Notifications$Patient$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notifications$Patient$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Notifications$Patient$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rk));
    };
    var $author$project$Pages$Admin$Notifications$Patient$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Ej, subMsg, model.rk);
        var adminTable = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: adminTable
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Admin$Notifications$Patient$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Patient Notifications')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('These are emails that will be sent to your patients automatically. '),
                        $elm$html$Html$text('Please remember, we will not automatically send emails that contain personal information to patients without the ePHI waiver. '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('See who hasn\'t signed an ePHI waiver here.')
                        ]))
                    ])), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rk))))
                ]))
            ]),
            $2: 'Admin | Notifications'
        };
    };
    var $author$project$Pages$Admin$Notifications$Patient$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Notifications$Patient$init,
        aeR: $author$project$Pages$Admin$Notifications$Patient$load,
        ag3: $author$project$Pages$Admin$Notifications$Patient$save,
        ahE: $author$project$Pages$Admin$Notifications$Patient$subscriptions,
        aaO: $author$project$Pages$Admin$Notifications$Patient$update,
        aid: $author$project$Pages$Admin$Notifications$Patient$view
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$GotDunningSchedule = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$DunningSchedule$One$DunningSchedule = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DunningSchedule$Shared$DunningSchedule = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DunningSchedule$Shared$Record = function(ruleList) {
        return {
            Zi: ruleList
        };
    };
    var $author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$ScheduleBreakDown = F2(function(action, delayInDaysFromDunningStart) {
        return {
            D7: action,
            ac1: delayInDaysFromDunningStart
        };
    });
    var $author$project$Api$Provider$DunningSchedule$ScheduleAction$AttemptInvoicePayment = 0;
    var $author$project$Api$Provider$DunningSchedule$ScheduleAction$DunningFailed = 3;
    var $author$project$Api$Provider$DunningSchedule$ScheduleAction$SendDunningNotification = 1;
    var $author$project$Api$Provider$DunningSchedule$ScheduleAction$SendDunningNotificationFollowup = 2;
    var $author$project$Api$Provider$DunningSchedule$ScheduleAction$decoder = A2($elm$json$Json$Decode$andThen, function(stringAction) {
        switch(stringAction){
            case 'AttemptInvoicePayment':
                return $elm$json$Json$Decode$succeed(0);
            case 'SendDunningNotification':
                return $elm$json$Json$Decode$succeed(1);
            case 'SendDunningNotificationFollowup':
                return $elm$json$Json$Decode$succeed(2);
            case 'DunningFailed':
                return $elm$json$Json$Decode$succeed(3);
            default:
                var unsupported = stringAction;
                return $elm$json$Json$Decode$fail('unsupported action type ' + unsupported);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$decoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'delay_in_days_from_dunning_start', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'action', $author$project$Api$Provider$DunningSchedule$ScheduleAction$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$ScheduleBreakDown)));
    var $author$project$Api$Provider$DunningSchedule$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'schedule', $elm$json$Json$Decode$list($author$project$Api$Provider$DunningSchedule$ScheduleBreakDown$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$DunningSchedule$Shared$Record));
    var $author$project$Api$Provider$DunningSchedule$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DunningSchedule$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DunningSchedule$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DunningSchedule$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DunningSchedule$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$DunningSchedule$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'dunning_schedules'
        ]), $author$project$Api$Data$providerPath)));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$fetchDunningSchedule = function(apiClient) {
        return A2($author$project$Api$Provider$DunningSchedule$retrieve, apiClient, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$GotDunningSchedule);
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        return _Utils_Tuple2({
            Ej: apiClient,
            ak: _List_Nil,
            O: _List_Nil,
            fK: _List_Nil,
            W1: practice,
            eG: $author$project$Api$Data$Loading,
            Z$: session
        }, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$fetchDunningSchedule(apiClient));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$Failed = 0;
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$BothEmailsSameDay = {
        $: 1
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$bothEmailsSameDayValidation = F2(function(chargeFailedList, chargeFailedFollowupToValidateList) {
        var chargeFailedDelaysInDays = A2($elm$core$List$map, function($) {
            return $.ac1;
        }, A2($elm$core$List$map, $elm$core$Tuple$first, chargeFailedList));
        var onSameDay = function(item) {
            return A2($elm$core$List$member, item.ac1, chargeFailedDelaysInDays);
        };
        return A2($elm$core$List$map, function(_v0) {
            var item = _v0.a;
            var errors = _v0.b;
            return _Utils_Tuple2(item, _Utils_ap(errors, onSameDay(item) ? _List_fromArray([
                $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$BothEmailsSameDay
            ]) : _List_Nil));
        }, chargeFailedFollowupToValidateList);
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ScheduleCreated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$DunningSchedule$scheduleActionToStringEncoder = function(action) {
        return $elm$json$Json$Encode$string(function() {
            switch(action){
                case 0:
                    return 'AttemptInvoicePayment';
                case 1:
                    return 'SendDunningNotification';
                case 2:
                    return 'SendDunningNotificationFollowup';
                default:
                    return 'DunningFailed';
            }
        }());
    };
    var $author$project$Api$Provider$DunningSchedule$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('dunning_schedule', A2($elm$json$Json$Encode$list, function(_v0) {
                var action = _v0.D7;
                var delayInDaysFromDunningStart = _v0.ac1;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('action', $author$project$Api$Provider$DunningSchedule$scheduleActionToStringEncoder(action)),
                    _Utils_Tuple2('delay_in_days_from_dunning_start', $elm$json$Json$Encode$int(delayInDaysFromDunningStart))
                ]));
            }, fields))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$DunningSchedule$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'dunning_schedules'
        ]), $author$project$Api$Data$providerPath))));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction = F2(function(schedule, action) {
        return A2($elm$core$List$map, function(item) {
            return _Utils_Tuple2(item, _List_Nil);
        }, A2($elm$core$List$filter, function(listItem) {
            return _Utils_eq(listItem.D7, action);
        }, schedule));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunction = F2(function(a, b) {
        var _v0 = _Utils_Tuple2(a.D7, b.D7);
        if (_v0.a === 3) {
            var _v1 = _v0.a;
            return 2;
        } else {
            if (_v0.b === 3) {
                var _v2 = _v0.b;
                return 0;
            } else return _Utils_cmp(a.ac1, b.ac1) < 0 ? 0 : _Utils_cmp(a.ac1, b.ac1) > 0 ? 2 : !a.D7 ? 0 : 2;
        }
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createSchedule = F4(function(apiClient, currentSchedule, chargeFailedSchedule, chargeFailedFollowupSchedule) {
        var dunningFailedSchedule = A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, currentSchedule, 3);
        var attemptPaymentSchedule = A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, currentSchedule, 0);
        var unorderedSchedule = _Utils_ap(attemptPaymentSchedule, _Utils_ap(chargeFailedSchedule, _Utils_ap(chargeFailedFollowupSchedule, dunningFailedSchedule)));
        var newSchedule = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunction, A2($elm$core$List$map, $elm$core$Tuple$first, unorderedSchedule));
        return A3($author$project$Api$Provider$DunningSchedule$create, apiClient, newSchedule, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ScheduleCreated);
    });
    var $author$project$Api$Provider$DunningSchedule$Shared$ruleList = function(_v0) {
        var record = _v0;
        return record.Zi;
    };
    var $author$project$Api$Provider$DunningSchedule$One$ruleList = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$DunningSchedule$Shared$ruleList(shared);
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$SameEmailForSameDay = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$validateSameDayEmail = F2(function(validatingItem, list) {
        return function(errors) {
            return _Utils_Tuple2(validatingItem, errors);
        }(A2($elm$core$List$map, function(_v1) {
            var index = _v1.a;
            return $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$SameEmailForSameDay($elm$core$String$fromInt(index));
        }, A2($elm$core$List$filter, function(_v0) {
            var item = _v0.b;
            return _Utils_eq(item.ac1, validatingItem.ac1);
        }, A2($elm$core$List$indexedMap, F2(function(index, item) {
            return _Utils_Tuple2(index + 1, item);
        }), $elm$core$List$reverse(list)))));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation = function(scheduleList) {
        var _v0 = $elm$core$List$reverse(scheduleList);
        if (!_v0.b) return _List_Nil;
        else {
            var last = _v0.a;
            var rest = _v0.b;
            var validatedLast = A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$validateSameDayEmail, last.a, A2($elm$core$List$map, $elm$core$Tuple$first, rest));
            var unReversed = $elm$core$List$reverse(rest);
            return _Utils_ap($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(unReversed), _List_fromArray([
                validatedLast
            ]));
        }
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var schedule = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ak: A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, $author$project$Api$Provider$DunningSchedule$One$ruleList(schedule), 2),
                        O: A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, $author$project$Api$Provider$DunningSchedule$One$ruleList(schedule), 1),
                        eG: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    eG: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var index = msg.a;
                var newDelayInDaysString = msg.b;
                var newRule = {
                    D7: 1,
                    ac1: A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(newDelayInDaysString))
                };
                var newSchedule = A3($elm_community$list_extra$List$Extra$setAt, index, _Utils_Tuple2(newRule, _List_Nil), model.O);
                return _Utils_Tuple3(_Utils_update(model, {
                    O: newSchedule
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var index = msg.a;
                var newDelayInDaysString = msg.b;
                var newRule = {
                    D7: 2,
                    ac1: A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(newDelayInDaysString))
                };
                var newSchedule = A3($elm_community$list_extra$List$Extra$setAt, index, _Utils_Tuple2(newRule, _List_Nil), model.ak);
                return _Utils_Tuple3(_Utils_update(model, {
                    ak: newSchedule
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var validatedChargeFailedSchedule = $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(model.O);
                var validatedChargeFailedFollowupScheedule = A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$bothEmailsSameDayValidation, model.O, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sameEmailForSameDayValidation(model.ak));
                var chargeFailedScheduleErrors = A2($elm$core$List$concatMap, $elm$core$Tuple$second, validatedChargeFailedSchedule);
                var chargeFailedFollowupScheduleErrors = A2($elm$core$List$concatMap, $elm$core$Tuple$second, validatedChargeFailedFollowupScheedule);
                var _v2 = function() {
                    var _v3 = _Utils_Tuple2(chargeFailedScheduleErrors, chargeFailedFollowupScheduleErrors);
                    if (!_v3.a.b && !_v3.b.b) {
                        var currentSchedule = function() {
                            var _v4 = model.eG;
                            if (_v4.$ === 3) {
                                var schedule = _v4.a;
                                return $author$project$Api$Provider$DunningSchedule$One$ruleList(schedule);
                            } else return _List_Nil;
                        }();
                        return _Utils_Tuple2(A4($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createSchedule, model.Ej, currentSchedule, validatedChargeFailedSchedule, validatedChargeFailedFollowupScheedule), _List_Nil);
                    } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 1, 'Unable to save the schedule. Please check the errors.')
                    ]));
                }();
                var createCmd = _v2.a;
                var outMsgs = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ak: validatedChargeFailedFollowupScheedule,
                    O: validatedChargeFailedSchedule
                }), createCmd, outMsgs);
            case 3:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var schedule = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ak: A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, $author$project$Api$Provider$DunningSchedule$One$ruleList(schedule), 2),
                            O: A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, $author$project$Api$Provider$DunningSchedule$One$ruleList(schedule), 1),
                            eG: response
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Schedule succesfully updated')
                        ]));
                    case 2:
                        var errors = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            eG: response
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Api$Data$errorToString(errors))
                        ]));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            eG: response
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 4:
                var scheduleType = msg.a;
                if (!scheduleType) {
                    var initialDelay = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $elm$core$Basics$add(1), A2($elm$core$Maybe$map, function($) {
                        return $.ac1;
                    }, A2($elm$core$Maybe$map, $elm$core$Tuple$first, $elm$core$List$head($elm$core$List$reverse(model.O))))));
                    var chargeFailedSchedule = _Utils_ap(model.O, _List_fromArray([
                        _Utils_Tuple2({
                            D7: 1,
                            ac1: initialDelay
                        }, _List_Nil)
                    ]));
                    return _Utils_Tuple3(_Utils_update(model, {
                        O: chargeFailedSchedule
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else {
                    var chargeFailedFollowupSchedule = _Utils_ap(model.ak, _List_fromArray([
                        _Utils_Tuple2({
                            D7: 2,
                            ac1: 0
                        }, _List_Nil)
                    ]));
                    return _Utils_Tuple3(_Utils_update(model, {
                        ak: chargeFailedFollowupSchedule
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var index = msg.a;
                var scheduleType = msg.b;
                if (!scheduleType) {
                    var chargeFailedSchedule = A2($elm_community$list_extra$List$Extra$removeAt, index, model.O);
                    return _Utils_Tuple3(_Utils_update(model, {
                        O: chargeFailedSchedule
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else {
                    var chargeFailedFollowupSchedule = A2($elm_community$list_extra$List$Extra$removeAt, index, model.ak);
                    return _Utils_Tuple3(_Utils_update(model, {
                        ak: chargeFailedFollowupSchedule
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ValidateAndCreateSchedule = {
        $: 6
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays = F2(function(a, b) {
        return _Utils_cmp(a.ac1, b.ac1) < 0 ? 0 : _Utils_cmp(a.ac1, b.ac1) > 0 ? 2 : 1;
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$didScheduleChange = F3(function(original, chargeFailedSchedule, chargeFailedFollowupSchedule) {
        var orderedOriginalFollowup = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays, A2($elm$core$List$map, $elm$core$Tuple$first, A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, $author$project$Api$Provider$DunningSchedule$One$ruleList(original), 2)));
        var orderedOriginalChargeFailed = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays, A2($elm$core$List$map, $elm$core$Tuple$first, A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$filterScheduleByAction, $author$project$Api$Provider$DunningSchedule$One$ruleList(original), 1)));
        var orderedNewFollowup = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays, chargeFailedFollowupSchedule);
        var orderedNewChargeFailed = A2($elm$core$List$sortWith, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$sortingFunctionOnlyByDelayInDays, chargeFailedSchedule);
        return !_Utils_eq(orderedOriginalChargeFailed, orderedNewChargeFailed) || !_Utils_eq(orderedOriginalFollowup, orderedNewFollowup);
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBreadcrumbs = A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Notifications__Patient, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Patient Notifications')
            ]))
        ])),
        A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
            $author$project$Ui$Breadcrumb$active(true)
        ]), _List_fromArray([
            $elm$html$Html$text('Schedule \"Charge Failed\" emails and follow-ups')
        ]))
    ])));
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$AddEmailToScheduleButtonClicked = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$Followup = 1;
    var $author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart = function(rule) {
        return rule.ac1;
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText = function(error) {
        if (!error.$) {
            var emailName = error.a;
            return 'You have already scheduled the Email #' + (emailName + ' to go out on this day.');
        } else return 'You have scheduled both emails to go out on this day. Please adjust the schedule and update.';
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewFirstNotification = F2(function(delayInDays, _v0) {
        var scheduleAction = _v0.a;
        var errors = _v0.b;
        var updateSchedule = scheduleAction === 1 ? $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule(0) : $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule(0);
        return A2($author$project$Ui$Grid$row, _List_fromArray([
            $author$project$Ui$Grid$mt2
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Email #' + $elm$core$String$fromInt(1))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPreAddon, '# of days after a failed charge', _List_fromArray([
                        $author$project$Ui$Form$Input$value($elm$core$String$fromInt(delayInDays)),
                        $author$project$Ui$Form$Input$onInput(updateSchedule),
                        $author$project$Ui$Form$Input$number
                    ]))),
                    A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, function(error) {
                        return A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$danger
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText(error))
                        ]));
                    }, errors))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$DeleteEmailFromScheduleButtonClicked = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotification = F3(function(index, delayInDays, _v0) {
        var scheduleAction = _v0.a;
        var errors = _v0.b;
        var _v1 = scheduleAction === 1 ? _Utils_Tuple2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedSchedule(index + 1), 0) : _Utils_Tuple2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$UpdateChargeFailedFollowupSchedule(index + 1), 1);
        var updateSchedule = _v1.a;
        var emailType = _v1.b;
        return A2($author$project$Ui$Grid$row, _List_fromArray([
            $author$project$Ui$Grid$mt2
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Email #' + $elm$core$String$fromInt(index + 2))
                ])),
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mt2
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(11)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPreAddon, '# of days after a failed charge', _List_fromArray([
                                $author$project$Ui$Form$Input$value($elm$core$String$fromInt(delayInDays)),
                                $author$project$Ui$Form$Input$onInput(updateSchedule),
                                $author$project$Ui$Form$Input$number
                            ])))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Delete email from schedule'
                        }, _List_fromArray([
                            $author$project$Ui$Button$secondary,
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                            $author$project$Ui$Button$onClick(A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$DeleteEmailFromScheduleButtonClicked, index + 1, emailType))
                        ]), _List_Nil)
                    ]))
                ])),
                A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, function(error) {
                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$errorText(error))
                    ]));
                }, errors))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications = F2(function(notifications, notificationType) {
        var _v0 = notificationType === 1 ? _Utils_Tuple3('1 - Charge Failed', 'Sent to patients if they have a failed charge.', 0) : _Utils_Tuple3('2 - Charge Failed (Follow-up)', 'Sent to patients if they have a failed charge and we have already sent them an email, but received no response. This email is usually sent as a final reminder prior to membership termination.', 1);
        var headerText = _v0.a;
        var helpText = _v0.b;
        var scheduleType = _v0.c;
        var _v1 = function() {
            if (!notifications.b) return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
            else {
                var first_ = notifications.a;
                var rest_ = notifications.b;
                return _Utils_Tuple2($elm$core$Maybe$Just(first_), rest_);
            }
        }();
        var maybeFirst = _v1.a;
        var rest = _v1.b;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb2
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$heading(_List_fromArray([
                            $elm$html$Html$text(headerText)
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$helpText
                    ]), _List_fromArray([
                        $elm$html$Html$text(helpText)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$margin(17)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Schedule')
                    ]))
                ])),
                function() {
                    if (!maybeFirst.$) {
                        var _v4 = maybeFirst.a;
                        var first = _v4.a;
                        var errors = _v4.b;
                        return A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(10)
                        ]), _List_fromArray([
                            A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewFirstNotification, $author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart(first), _Utils_Tuple2(first.D7, errors))
                        ]));
                    } else return A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(10)
                    ]), _List_Nil);
                }(),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_Nil),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(10)
                ]), A2($elm$core$List$indexedMap, F2(function(index, _v5) {
                    var item = _v5.a;
                    var errors = _v5.b;
                    return A3($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotification, index, $author$project$Api$Provider$DunningSchedule$One$delayInDaysFromDunningStart(item), _Utils_Tuple2(item.D7, errors));
                }), rest))
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(2)
                ]), _List_Nil),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(2)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Add email to schedule'
                    }, _List_fromArray([
                        $author$project$Ui$Button$secondary,
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$AddEmailToScheduleButtonClicked(scheduleType))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add Email to Schedule')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent = function(_v0) {
        var eventDate = _v0.a;
        var eventDay = _v0.b;
        var event = _v0.c;
        return {
            M4: eventDate,
            acM: $elm$core$Maybe$Just($elm$core$String$fromInt(eventDay) + ' days after a failed charge'),
            NQ: event
        };
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes = function(scheduleBreakdown) {
        var eventDescription = function() {
            var _v0 = scheduleBreakdown.D7;
            switch(_v0){
                case 1:
                    return 'Send \"Charge Failed\"';
                case 2:
                    return 'Send \"Charge Failed (Follow-up)\"';
                default:
                    return 'Unknown';
            }
        }();
        var eventDate = $justinmimbs$date$Date$fromRataDie(scheduleBreakdown.ac1);
        return _Utils_Tuple3(eventDate, scheduleBreakdown.ac1, eventDescription);
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewTimeline = F2(function(chargeFailedSchedule, chargeFailedFollowupSchedule) {
        var chargeFailedFollowupEvents = A2($elm$core$List$map, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent, A2($elm$core$List$map, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes, chargeFailedFollowupSchedule));
        var chargeFailedEvents = A2($elm$core$List$map, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEvent, A2($elm$core$List$map, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$createTimelineEventAttributes, chargeFailedSchedule));
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('mt-6 -mb-8')
        ]), _List_fromArray([
            A2($author$project$Ui$Timeline$view, 0, _Utils_ap(chargeFailedEvents, chargeFailedFollowupEvents))
        ]));
    });
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBody = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBreadcrumbs,
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Schedule \"Charge Failed\" emails and follow-ups')
                    ])),
                    A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewTimeline, A2($elm$core$List$map, $elm$core$Tuple$first, model.O), A2($elm$core$List$map, $elm$core$Tuple$first, model.ak))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications, model.O, 1),
                    A2($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewNotifications, model.ak, 2)
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Notifications__Patient, _List_fromArray([
                        $author$project$Ui$Link$buttonDefault
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    function() {
                        var _v0 = model.eG;
                        if (_v0.$ === 3) {
                            var schedule = _v0.a;
                            var scheduleChanged = A3($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$didScheduleChange, schedule, A2($elm$core$List$map, $elm$core$Tuple$first, model.O), A2($elm$core$List$map, $elm$core$Tuple$first, model.ak));
                            return A3($author$project$Ui$Button$view, {
                                abP: 'Update schedule'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Patient$DunningSchedule$ValidateAndCreateSchedule),
                                $author$project$Ui$Button$disabled(!scheduleChanged)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Update Schedule')
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$view = function(model) {
        return {
            fb: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$viewBody(model),
            $2: 'Admin | Notifications'
        };
    };
    var $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$init,
        aeR: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$load,
        ag3: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$save,
        ahE: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$subscriptions,
        aaO: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$update,
        aid: $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$view
    });
    var $author$project$Pages$Admin$Notifications$Practice$AdminTableMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$NotificationSetting$Practice = 2;
    var $author$project$Pages$Admin$Notifications$Practice$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var _v3 = A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, apiClient, session, $author$project$Api$Provider$Notification$PracticeContext, 2);
        var adminTable = _v3.a;
        var adminTableCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            rk: adminTable
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
    });
    var $author$project$Pages$Admin$Notifications$Practice$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notifications$Practice$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Notifications$Practice$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rk));
    };
    var $author$project$Pages$Admin$Notifications$Practice$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Ej, subMsg, model.rk);
        var adminTable = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: adminTable
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Admin$Notifications$Practice$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Practice Notifications')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('These are emails that will be sent to members of your team.')
                    ])), A2($elm$core$List$cons, A2($elm$html$Html$ul, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Admins, Managers, Staff and Staff Limited users are expected to receive all of the following email notifications, if enabled.')
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Reports Only users will not receive any of the following email notifications.')
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Read Only users will only receive the new patient email notifications.')
                        ]))
                    ])), A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$italic
                    ]), _List_fromArray([
                        $elm$html$Html$text('Note: If a role is restricted by location groups, the user will only receive the emails with content relevant to their assigned location groups. If the role is not restricted by location groups, they are expected to receive all email notifications.')
                    ])), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rk))))))
                ]))
            ]),
            $2: 'Admin | Notifications'
        };
    };
    var $author$project$Pages$Admin$Notifications$Practice$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Notifications$Practice$init,
        aeR: $author$project$Pages$Admin$Notifications$Practice$load,
        ag3: $author$project$Pages$Admin$Notifications$Practice$save,
        ahE: $author$project$Pages$Admin$Notifications$Practice$subscriptions,
        aaO: $author$project$Pages$Admin$Notifications$Practice$update,
        aid: $author$project$Pages$Admin$Notifications$Practice$view
    });
    var $author$project$Api$Provider$Practice$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$Practice$One$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$email(shared);
    };
    var $author$project$Api$Provider$Practice$One$emailReplyAddress = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.adi;
    });
    var $author$project$Api$Provider$Practice$One$footer = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.adV;
    });
    var $author$project$Api$Provider$Practice$One$greetsFormally = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ad2;
    });
    var $author$project$Api$Provider$Practice$One$salutation = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ag2;
    });
    var $author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields = function(practice) {
        return {
            adi: $author$project$Api$Provider$Practice$One$emailReplyAddress(practice),
            adV: $author$project$Api$Provider$Practice$One$footer(practice),
            ad2: $author$project$Api$Provider$Practice$One$greetsFormally(practice),
            ag2: $author$project$Api$Provider$Practice$One$salutation(practice)
        };
    };
    var $author$project$Components$TranslationsInput$Practice = {
        $: 2
    };
    var $author$project$Components$TranslationsInput$practice = $author$project$Components$TranslationsInput$Practice;
    var $author$project$Pages$Admin$Notifications$Settings$init = F4(function(_v0, practice, _v1, _v2) {
        var apiClient = _v1.Ej;
        return _Utils_Tuple2({
            Ej: apiClient,
            fF: false,
            PU: $author$project$Utils$Form$init($author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields(practice)),
            Gq: A2($author$project$Api$Practice$featureEnabled, 10, $author$project$Api$Practice$Provider(practice)),
            W1: $author$project$Api$Data$NotAsked,
            sa: $author$project$Api$Provider$Practice$One$email(practice),
            oU: $author$project$Components$TranslationsInput$init($author$project$Components$TranslationsInput$practice)
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notifications$Settings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Notifications$Settings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Notifications$Settings$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg, $author$project$Components$TranslationsInput$subscriptions(model.oU));
    };
    var $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    adi: $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string)
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    ag2: string
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    ad2: bool
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    adV: string
                });
        }
    });
    var $author$project$Pages$Admin$Notifications$Settings$EmailValidation = 0;
    var $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: true
        }, function($) {
            return $.adi;
        }, _Utils_Tuple2(0, 'Please enter a valid email.'))
    ]));
    var $author$project$Pages$Admin$Notifications$Settings$GotPractice = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$resetPracticeEmailReplyAddress = F2(function(apiClient, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('email_reply_address', $elm$json$Json$Encode$null)
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Admin$Notifications$Settings$resetPracticeEmailReplyAddress = function(apiClient) {
        return A2($author$project$Api$Provider$Practice$resetPracticeEmailReplyAddress, apiClient, $author$project$Pages$Admin$Notifications$Settings$GotPractice);
    };
    var $author$project$Api$Provider$Practice$updateNotificationsSettings = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('email_reply_address', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adi)),
                _Utils_Tuple2('salutation', $elm$json$Json$Encode$string(fields.ag2)),
                _Utils_Tuple2('greets_formally', $elm$json$Json$Encode$bool(fields.ad2)),
                _Utils_Tuple2('footer', $elm$json$Json$Encode$string(fields.adV))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Admin$Notifications$Settings$updatePractice = F2(function(apiClient, formFields) {
        return A3($author$project$Api$Provider$Practice$updateNotificationsSettings, apiClient, $rtfeldman$elm_validate$Validate$fromValid(formFields), $author$project$Pages$Admin$Notifications$Settings$GotPractice);
    });
    var $author$project$Pages$Admin$Notifications$Settings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    fF: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    W1: $author$project$Api$Data$Loading
                }), $author$project$Pages$Admin$Notifications$Settings$resetPracticeEmailReplyAddress(model.Ej), _List_Nil);
            case 2:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsUpdate, field, model.PU);
                var validatedForm = function() {
                    var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator, newForm);
                    if (!_v1.$) {
                        var _v2 = _v1.a;
                        var form = _v2.a;
                        return form;
                    } else {
                        var form = _v1.a;
                        return form;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: validatedForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Notifications$Settings$practiceFormFieldsValidator, model.PU);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm,
                        W1: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Admin$Notifications$Settings$updatePractice, model.Ej, validFormFields), _List_Nil);
                } else {
                    var newForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fF: false,
                        PU: $author$project$Utils$Form$init($author$project$Pages$Admin$Notifications$Settings$initPracticeFormFields(practice)),
                        W1: response
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your practice\'s notification settings have been updated'),
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v6 = A3($author$project$Components$TranslationsInput$update, model.Ej, subMsg, model.oU);
                var translationsInput = _v6.a;
                var translationsInputCmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oU: translationsInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg, translationsInputCmd), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Notifications$Settings$EditEmailReplyAddress = {
        $: 0
    };
    var $author$project$Pages$Admin$Notifications$Settings$EmailReplyAddress = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Notifications$Settings$Footer = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Notifications$Settings$GreetsFormally = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Notifications$Settings$ResetEmailReplyAddress = {
        $: 1
    };
    var $author$project$Pages$Admin$Notifications$Settings$Salutation = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Notifications$Settings$UpdatePractice = {
        $: 3
    };
    var $author$project$Pages$Admin$Notifications$Settings$canEditEmail = F2(function(emailReplyAddress, model) {
        var practiceEmailIsEmpty = $elm$core$String$isEmpty(A2($elm$core$Maybe$withDefault, '', model.sa));
        var emailReplyAddressIsEmpty = $elm$core$String$isEmpty(A2($elm$core$Maybe$withDefault, '', emailReplyAddress));
        var _v0 = _Utils_Tuple3(model.fF, emailReplyAddressIsEmpty, practiceEmailIsEmpty);
        if (_v0.a) return false;
        else {
            if (_v0.b && _v0.c) return false;
            else return true;
        }
    });
    var $author$project$Pages$Admin$Notifications$Settings$greetsFormallyDescription = function(greetsFormally) {
        return $elm$html$Html$text(greetsFormally ? $elm$core$String$concat(_List_fromArray([
            'Recipient will be addressed using their title if it has been specified. ',
            'If title has not been specified, but gender has been specified, they will be addressed using \"Mr.\" or \"Ms.\". ',
            'If neither title or gender has been specified, they will be addressed using their first name.'
        ])) : 'Recipient will be addressed by their first name.');
    };
    var $author$project$Pages$Admin$Notifications$Settings$hintDefaultEmail = 'hello@hint.com';
    var $author$project$Components$TranslationsInput$ContentType = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$TranslationsInput$Text = 1;
    var $author$project$Components$TranslationsInput$textarea = $author$project$Components$TranslationsInput$ContentType(1);
    var $author$project$Pages$Admin$Notifications$Settings$viewPanel = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var emailReplyAddress = _v0.adi;
        var salutation = _v0.ag2;
        var greetsFormally = _v0.ad2;
        var footer = _v0.adV;
        var email = function() {
            var _v6 = _Utils_Tuple3(model.fF, emailReplyAddress, model.sa);
            if (_v6.a) return A2($elm$core$Maybe$withDefault, '', emailReplyAddress);
            else {
                if (!_v6.b.$) {
                    var emailReplyAddress_ = _v6.b.a;
                    return emailReplyAddress_;
                } else if (!_v6.c.$) {
                    var practiceEmail = _v6.c.a;
                    return practiceEmail;
                } else {
                    var _v7 = _v6.b;
                    var _v8 = _v6.c;
                    return $author$project$Pages$Admin$Notifications$Settings$hintDefaultEmail;
                }
            }
        }();
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Notification Settings')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Email Address')
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Reply-to Email Address'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$inputSpanSm(7)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$group(_List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$placeholder('example@mail.com'),
                                $author$project$Ui$Form$Input$value(email),
                                $author$project$Ui$Form$Input$disabled(!model.fF),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$EmailReplyAddress)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU))
                            ])),
                            $author$project$Ui$Form$Input$addon(_List_fromArray([
                                A2($author$project$Pages$Admin$Notifications$Settings$canEditEmail, emailReplyAddress, model) ? A3($author$project$Ui$Button$view, {
                                    abP: 'Edit email replay address'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$sm,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$EditEmailReplyAddress)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Edit')
                                ])) : $author$project$Utils$Html$empty
                            ]))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, model.PU)),
                        function() {
                            if (model.fF) return $author$project$Utils$Html$empty;
                            else {
                                var emailDescription = function() {
                                    var _v1 = _Utils_Tuple2(emailReplyAddress, model.sa);
                                    if (_v1.b.$ === 1) {
                                        if (_v1.a.$ === 1) {
                                            var _v2 = _v1.a;
                                            var _v3 = _v1.b;
                                            return _List_fromArray([
                                                $elm$html$Html$text('You do not have a contact email set for your practice. '),
                                                $elm$html$Html$text('Once set, we will send emails from this address on your behalf. '),
                                                $elm$html$Html$text('You can set this email on the '),
                                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text('Admin > General')
                                                ])),
                                                $elm$html$Html$text(' settings page.')
                                            ]);
                                        } else {
                                            var _v5 = _v1.b;
                                            return _List_fromArray([
                                                $elm$html$Html$text('We are sending emails from a custom email address.  You can edit this address above.'),
                                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                                $elm$html$Html$text('You do not have a contact email set for your practice. Please set one on the '),
                                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text('Admin > General')
                                                ])),
                                                $elm$html$Html$text(' settings page. '),
                                                $elm$html$Html$text("Once set you can return here to configure emails to be sent from your practice\u2019s contact email.")
                                            ]);
                                        }
                                    } else if (_v1.a.$ === 1) {
                                        var _v4 = _v1.a;
                                        return _List_fromArray([
                                            $elm$html$Html$text('We are sending emails from your practice\'s email address on your behalf. '),
                                            $elm$html$Html$text('You can change this email on the '),
                                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text('Admin > General')
                                            ])),
                                            $elm$html$Html$text(' settings page.'),
                                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                            $elm$html$Html$text('If you want to use a different email address to send emails click the edit button above.')
                                        ]);
                                    } else {
                                        var practiceEmail_ = _v1.b.a;
                                        return _List_fromArray([
                                            $elm$html$Html$text("We are sending emails from an email that is different than your practice\u2019s contact email address. "),
                                            $elm$html$Html$text("You can edit this email above, or reset it to use your practice\u2019s contact email. "),
                                            A3($author$project$Ui$Button$view, {
                                                abP: 'Reset to ' + practiceEmail_
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$link,
                                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$ResetEmailReplyAddress)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Reset to ' + practiceEmail_)
                                            ]))
                                        ]);
                                    }
                                }();
                                return A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$small,
                                    $author$project$Ui$Typography$muted
                                ]), emailDescription);
                            }
                        }()
                    ])),
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Greeting')
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Salutation'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$inputSpanSm(7)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(salutation),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$Salutation))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Use recipient\'s title and last name?'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$inputSpanSm(7)
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(greetsFormally),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$GreetsFormally))
                        ])),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $author$project$Pages$Admin$Notifications$Settings$greetsFormallyDescription(greetsFormally)
                        ]))
                    ])),
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Closing')
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Content'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$offsetLabel,
                        $author$project$Ui$Form$Group$inputSpanSm(7)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Textarea$view(_List_fromArray([
                            $author$project$Ui$Form$Textarea$rows(5),
                            $author$project$Ui$Form$Textarea$value(footer),
                            $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Notifications$Settings$PracticeFormFieldUpdated, $author$project$Pages$Admin$Notifications$Settings$Footer))
                        ])),
                        model.Gq ? A2($elm$html$Html$map, $author$project$Pages$Admin$Notifications$Settings$TranslationsInputMsg, A3($author$project$Components$TranslationsInput$view, 'footer', _List_fromArray([
                            $author$project$Components$TranslationsInput$default(footer),
                            $author$project$Components$TranslationsInput$textarea
                        ]), model.oU)) : $elm$html$Html$text('')
                    ]))
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_fromArray([
                        $author$project$Ui$Link$buttonSecondary
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Save settings'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$loading(_Utils_eq(model.W1, $author$project$Api$Data$Loading)),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Notifications$Settings$UpdatePractice)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Save')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Notifications$Settings$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Admin$Notifications$Settings$viewPanel(model)
            ]),
            $2: 'Admin | Notifications'
        };
    };
    var $author$project$Pages$Admin$Notifications$Settings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Notifications$Settings$init,
        aeR: $author$project$Pages$Admin$Notifications$Settings$load,
        ag3: $author$project$Pages$Admin$Notifications$Settings$save,
        ahE: $author$project$Pages$Admin$Notifications$Settings$subscriptions,
        aaO: $author$project$Pages$Admin$Notifications$Settings$update,
        aid: $author$project$Pages$Admin$Notifications$Settings$view
    });
    var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $agustinrhcp$elm_datepicker$DatePicker$initFromDate = function(date) {
        return {
            a8: $elm$core$Maybe$Just(date),
            fM: false,
            cb: $elm$core$Maybe$Nothing,
            Vw: false,
            jv: 0,
            aae: date
        };
    };
    var $author$project$Components$DateInput$initFromDate = function(currentDate) {
        var datePicker = $agustinrhcp$elm_datepicker$DatePicker$initFromDate(currentDate);
        return {
            lR: datePicker
        };
    };
    var $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.aco;
    });
    var $author$project$Api$Provider$Practice$One$collectLocationOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.acw;
    });
    var $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Lx;
    });
    var $author$project$Api$Provider$Practice$One$collectSSNOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Ly;
    });
    var $author$project$Api$Provider$Practice$One$defaultPatientsPreferredLanguage = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Nw;
    });
    var $author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ac0;
    });
    var $author$project$Api$Provider$Practice$One$engagementThreshold = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ads;
    });
    var $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.af0;
    });
    var $author$project$Api$Provider$Practice$One$passthroughFeesCutoffEnabled = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.af1;
    });
    var $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.agP;
    });
    var $author$project$Api$Provider$Practice$One$requiresLocation = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.YK;
    });
    var $author$project$Api$Provider$Practice$One$requiresPatientEmail = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.YM;
    });
    var $author$project$Api$Provider$Practice$One$requiresPatientMobile = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.YN;
    });
    var $author$project$Api$Provider$Practice$One$requiresPractitioner = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.YP;
    });
    var $author$project$Api$Provider$Practice$One$requiresSSN = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.YQ;
    });
    var $author$project$Api$Provider$Practice$One$ssnEnabled = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $._$;
    });
    var $author$project$Pages$Admin$Patients$mapFormFields = function(practice) {
        return {
            aco: $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice),
            acw: $author$project$Api$Provider$Practice$One$collectLocationOnSignup(practice),
            Lx: $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice),
            Ly: $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice),
            ac$: $author$project$Api$Provider$Practice$One$defaultPatientsPreferredLanguage(practice),
            ac0: $author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter(practice),
            ads: $elm$core$String$fromInt($author$project$Api$Provider$Practice$One$engagementThreshold(practice)),
            af0: $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice),
            af1: $author$project$Api$Provider$Practice$One$passthroughFeesCutoffEnabled(practice),
            agL: $author$project$Api$Provider$Practice$One$requireGroupForLocations(practice),
            agP: $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies(practice),
            YK: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
            YM: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
            YN: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
            YP: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
            YQ: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
            _$: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
            aaq: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice)
        };
    };
    var $author$project$Pages$Admin$Patients$init = F4(function(_v0, practice, _v1, _v2) {
        var apiClient = _v1.Ej;
        var _v3 = function() {
            var _v4 = $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice);
            if (!_v4.$) {
                var date = _v4.a;
                return _Utils_Tuple2($author$project$Components$DateInput$initFromDate(date), $elm$core$Platform$Cmd$none);
            } else return $author$project$Components$DateInput$init;
        }();
        var dateInputModel = _v3.a;
        var dateInputMsg = _v3.b;
        var model = {
            Ej: apiClient,
            l9: $jinjor$elm_debounce$Debounce$init,
            adM: $author$project$Pages$Admin$Patients$mapFormFields(practice),
            rT: dateInputModel,
            W1: practice
        };
        return _Utils_Tuple2(model, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(dateInputModel), dateInputMsg));
    });
    var $author$project$Pages$Admin$Patients$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Patients$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Patients$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$GotEnableResponse = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDate = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$EngagementThresholdDebounced = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$debouncePriceCheck = function(cmd) {
        return A2($elm$core$Task$perform, $author$project$Pages$Admin$Patients$EngagementThresholdDebounced, $elm$core$Task$succeed(cmd));
    };
    var $author$project$Pages$Admin$Patients$EngagementThresholdDebouncedMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(300),
        ah3: $author$project$Pages$Admin$Patients$EngagementThresholdDebouncedMsg
    };
    var $author$project$Pages$Admin$Patients$updateField = F2(function(field, fields) {
        switch(field.$){
            case 1:
                var enabled = field.a;
                return _Utils_update(fields, {
                    Ly: enabled ? 2 : fields.Ly,
                    YQ: enabled
                });
            case 2:
                var enabled = field.a;
                return _Utils_update(fields, {
                    acw: enabled ? 2 : fields.acw,
                    YK: enabled
                });
            case 5:
                var enabled = field.a;
                return _Utils_update(fields, {
                    Lx: enabled ? 2 : fields.Lx,
                    YP: enabled
                });
            case 6:
                var enabled = field.a;
                return _Utils_update(fields, {
                    acw: enabled ? fields.acw : 0,
                    YK: enabled && fields.YK,
                    aaq: enabled
                });
            case 0:
                var enabled = field.a;
                return _Utils_update(fields, {
                    Ly: enabled ? fields.Ly : 0,
                    YQ: enabled && fields.YQ,
                    _$: enabled
                });
            case 7:
                var enabled = field.a;
                return _Utils_update(fields, {
                    aco: enabled
                });
            case 3:
                var enabled = field.a;
                return _Utils_update(fields, {
                    YM: enabled
                });
            case 4:
                var enabled = field.a;
                return _Utils_update(fields, {
                    YN: enabled
                });
            case 8:
                var enabled = field.a;
                return _Utils_update(fields, {
                    agP: enabled
                });
            case 9:
                var enabled = field.a;
                return _Utils_update(fields, {
                    af1: enabled
                });
            case 10:
                var date = field.a;
                return _Utils_update(fields, {
                    af0: date
                });
            case 11:
                var enabled = field.a;
                return _Utils_update(fields, {
                    agL: enabled
                });
            case 12:
                var threshold = field.a;
                return _Utils_update(fields, {
                    ads: threshold
                });
            case 13:
                var language = field.a;
                return _Utils_update(fields, {
                    ac$: language
                });
            default:
                var enabled = field.a;
                return _Utils_update(fields, {
                    ac0: enabled
                });
        }
    });
    var $author$project$Api$CollectOnSignup$encoder = function(customType) {
        return $elm$json$Json$Encode$string(function() {
            switch(customType){
                case 0:
                    return 'no';
                case 1:
                    return 'optional';
                case 2:
                    return 'require';
                case 3:
                    return 'default';
                default:
                    return 'yes';
            }
        }());
    };
    var $author$project$Api$Provider$Practice$updateSettings = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('ssn_enabled', $elm$json$Json$Encode$bool(fields._$)),
                _Utils_Tuple2('requires_ssn', $elm$json$Json$Encode$bool(fields.YQ)),
                _Utils_Tuple2('requires_patient_email', $elm$json$Json$Encode$bool(fields.YM)),
                _Utils_Tuple2('requires_patient_mobile', $elm$json$Json$Encode$bool(fields.YN)),
                _Utils_Tuple2('requires_practitioner', $elm$json$Json$Encode$bool(fields.YP)),
                _Utils_Tuple2('requires_location', $elm$json$Json$Encode$bool(fields.YK)),
                _Utils_Tuple2('require_default_location_for_companies', $elm$json$Json$Encode$bool(fields.agP)),
                _Utils_Tuple2('require_group_for_locations', $elm$json$Json$Encode$bool(fields.agL)),
                _Utils_Tuple2('track_patients_by_location', $elm$json$Json$Encode$bool(fields.aaq)),
                _Utils_Tuple2('charge_patients_credit_card_fees', $elm$json$Json$Encode$bool(fields.aco)),
                _Utils_Tuple2('passthrough_fees_cutoff_enabled', $elm$json$Json$Encode$bool(fields.af1)),
                _Utils_Tuple2('passthrough_fees_cutoff_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.af0)),
                _Utils_Tuple2('engagement_threshold', $elm$json$Json$Encode$int(A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(fields.ads)))),
                _Utils_Tuple2('collect_ssn_on_signup', $author$project$Api$CollectOnSignup$encoder(fields.Ly)),
                _Utils_Tuple2('collect_practitioner_on_signup', $author$project$Api$CollectOnSignup$encoder(fields.Lx)),
                _Utils_Tuple2('collect_location_on_signup', $author$project$Api$CollectOnSignup$encoder(fields.acw)),
                _Utils_Tuple2('default_patients_preferred_language', $elm$json$Json$Encode$string($author$project$Language$toValue(fields.ac$))),
                _Utils_Tuple2('default_to_active_patients_filter', $elm$json$Json$Encode$bool(fields.ac0))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Admin$Patients$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newFields = A2($author$project$Pages$Admin$Patients$updateField, field, $author$project$Pages$Admin$Patients$mapFormFields(model.W1));
                if (field.$ === 12) {
                    var threshold = field.a;
                    var updateSettingsCmd = $elm$core$String$length(threshold) > 0 ? A3($author$project$Api$Provider$Practice$updateSettings, model.Ej, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse) : $elm$core$Platform$Cmd$none;
                    var _v2 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig, updateSettingsCmd, model.l9);
                    var newDebouncer = _v2.a;
                    var cmd = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        l9: newDebouncer,
                        adM: newFields
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    adM: newFields
                }), A3($author$project$Api$Provider$Practice$updateSettings, model.Ej, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse), _List_Nil);
            case 1:
                var debounceMsg = msg.a;
                var _v3 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Pages$Admin$Patients$engagementThresholdDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Pages$Admin$Patients$debouncePriceCheck), debounceMsg, model.l9);
                var newDebouncer = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    l9: newDebouncer
                }), cmd, _List_Nil);
            case 2:
                var cmd = msg.a;
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 3:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var practice = response.a;
                        var message = 'Your practice has been updated';
                        var _v5 = function() {
                            var _v6 = $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice);
                            if (!_v6.$) {
                                var date = _v6.a;
                                return _Utils_Tuple2($author$project$Components$DateInput$initFromDate(date), $elm$core$Platform$Cmd$none);
                            } else return $author$project$Components$DateInput$init;
                        }();
                        var dateInputModel = _v5.a;
                        var dateInputMsg = _v5.b;
                        var newModel = _Utils_update(model, {
                            adM: $author$project$Pages$Admin$Patients$mapFormFields(practice),
                            rT: dateInputModel,
                            W1: practice
                        });
                        return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(dateInputModel), dateInputMsg), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, message),
                            $author$project$OutMsg$PracticeUpdated(response)
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            adM: $author$project$Pages$Admin$Patients$mapFormFields(model.W1)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            case 4:
                var newFields = A2($author$project$Pages$Admin$Patients$updateField, $author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees(true), model.adM);
                return _Utils_Tuple3(_Utils_update(model, {
                    adM: newFields
                }), A3($author$project$Api$Provider$Practice$updateSettings, model.Ej, newFields, $author$project$Pages$Admin$Patients$GotEnableResponse), _List_Nil);
            case 5:
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$Practice$updateSettings, model.Ej, model.adM, $author$project$Pages$Admin$Patients$GotEnableResponse), _List_Nil);
            default:
                var dateInput = msg.a;
                var subMsg = msg.b;
                var _v7 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
                var newDateInput = _v7.a;
                var subCmd = _v7.b;
                var event = _v7.c;
                var updatedDate = function() {
                    if (event.$ === 1) {
                        var date = event.a;
                        return date;
                    } else return model.adM.af0;
                }();
                var newFields = A2($author$project$Pages$Admin$Patients$updateField, $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDate(updatedDate), model.adM);
                return _Utils_Tuple3(_Utils_update(model, {
                    adM: newFields,
                    rT: newDateInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(newDateInput), subCmd), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Patients$FieldChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$PassthroughCreditCardFeesAgreeAndEnableClicked = {
        $: 4
    };
    var $author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset = F5(function(offset, label, labelHelp, toggleSwitch, content) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(8 - offset),
                $author$project$Ui$Grid$offset(offset)
            ]), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(label),
                $author$project$Ui$Form$Group$labelHelp(labelHelp),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelSpan(8),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$clearfix
            ]), _List_Nil), content)),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                toggleSwitch
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Patients$settingToggleWithContent = F4(function(label, labelHelp, toggleSwitch, content) {
        return A5($author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset, 0, label, labelHelp, toggleSwitch, content);
    });
    var $author$project$Pages$Admin$Patients$settingToggle = F3(function(label, labelHelp, toggleSwitch) {
        return A4($author$project$Pages$Admin$Patients$settingToggleWithContent, label, labelHelp, toggleSwitch, _List_Nil);
    });
    var $author$project$Api$Feature$PassthroughCreditCardFees = 13;
    var $author$project$Pages$Admin$Patients$showChargePatientsCreditCardFees = function(practice) {
        return A2($author$project$Api$Provider$Practice$One$featureEnabled, 13, practice) || $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice) || $author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest';
    };
    var $author$project$Ui$Icon$Circled = {
        $: 7
    };
    var $author$project$Ui$Icon$circled = $author$project$Ui$Icon$Circled;
    var $author$project$Ui$Element$gap4 = $author$project$Ui$Element$Gap(4);
    var $author$project$Ui$Panel$Subtle = {
        $: 4
    };
    var $author$project$Ui$Panel$subtle = $author$project$Ui$Panel$Subtle;
    var $author$project$Pages$Admin$Patients$viewExpandedWarningWell = F3(function(enabled, message, extraHtmlBody) {
        return A2($author$project$Ui$Grid$row, _List_fromArray([
            $author$project$Ui$Grid$mb4
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_fromArray([
                    $author$project$Ui$Panel$subtle
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$flex,
                            $author$project$Ui$Element$gap4
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                enabled ? $author$project$Ui$Icon$crossCircle(_List_Nil) : $author$project$Ui$Icon$check(_List_fromArray([
                                    $author$project$Ui$Icon$circled,
                                    $author$project$Ui$Icon$success
                                ]))
                            ])),
                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(message),
                                A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), extraHtmlBody)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateUpdateButtonClicked = {
        $: 5
    };
    var $author$project$Pages$Admin$Patients$PassthroughFeesCutoffEnabled = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$viewPassthroughFeesCutoff = F3(function(practice, fields, passthroughFeesCutoffDateInput) {
        if ($author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice)) {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.af1),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$PassthroughFeesCutoffEnabled))
            ]));
            var labelHelp = $elm$html$Html$text('When enabled, patients created prior to this date will not be surcharged for credit card fees.');
            var dateDirty = _Utils_eq(fields.af0, $author$project$Api$Provider$Practice$One$passthroughFeesCutoffDate(practice));
            return A5($author$project$Pages$Admin$Patients$settingToggleWithContentAndOffset, 1, 'Apply only to new patients', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch, $elm$core$List$singleton(A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap4,
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateInputMsg(passthroughFeesCutoffDateInput), A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(fields.af0)
                ]), passthroughFeesCutoffDateInput)),
                A3($author$project$Ui$Button$view, {
                    abP: 'Update cutoff date'
                }, _List_fromArray([
                    $author$project$Ui$Button$styled(2),
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Patients$PassthroughFeesCutoffDateUpdateButtonClicked),
                    $author$project$Ui$Button$disabled(dateDirty)
                ]), _List_fromArray([
                    $elm$html$Html$text('Update Cutoff Date')
                ]))
            ]))));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Admin$Patients$viewChargePatientsCreditCardFees = F3(function(practice, fields, passthroughFeesCutoffDateInput) {
        if ($author$project$Pages$Admin$Patients$showChargePatientsCreditCardFees(practice)) {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.aco),
                $author$project$Ui$ToggleSwitch$disabled(!fields.aco),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$ChargePatientsCreditCardFees))
            ]));
            var labelHelp = $elm$html$Html$text('Patients paying with a credit card will be responsible for any applicable credit card fees.');
            return _List_fromArray([
                A3($author$project$Pages$Admin$Patients$settingToggle, 'Surcharge patients for credit card fees', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch),
                A3($author$project$Pages$Admin$Patients$viewPassthroughFeesCutoff, practice, fields, passthroughFeesCutoffDateInput),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A3($author$project$Pages$Admin$Patients$viewExpandedWarningWell, !fields.aco, ' To enable this, you must first agree to our legal terms.', $elm$core$Maybe$Just(A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mt2
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('By enabling this feature, I affirm that our surcharge policy will comply with applicable laws and credit card network regulations.')
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('I acknowledge that Hint Health is not responsible for compliance of our surcharge policy. Hint Health advises that we seek the advice of a competent attorney or accountant licensed to practice in our jurisdiction before implementing a surcharge policy.')
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(3)
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Agree and enable'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$pull(0),
                                        $author$project$Ui$Button$disabled(fields.aco),
                                        $author$project$Ui$Button$styled(2),
                                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Patients$PassthroughCreditCardFeesAgreeAndEnableClicked)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Agree & Enable')
                                    ]))
                                ]))
                            ]))
                        ]))))
                    ]))
                ]))
            ]);
        } else return _List_Nil;
    });
    var $author$project$Pages$Admin$Patients$DefaultPreferredLanguage = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$LanguageInput$OnChange = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$LanguageInput$onChange = $author$project$Components$LanguageInput$OnChange;
    var $author$project$Components$LanguageInput$Value = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$LanguageInput$value = $author$project$Components$LanguageInput$Value;
    var $author$project$Language$fromString = function(string) {
        switch(string){
            case 'en':
                return 0;
            case 'es':
                return 1;
            default:
                return 0;
        }
    };
    var $author$project$Components$LanguageInput$OptionsRecord = F2(function(value, onChange) {
        return {
            afv: onChange,
            aa9: value
        };
    });
    var $author$project$Components$LanguageInput$optionsToRecord = A2($elm$core$List$foldl, F2(function(option, record) {
        if (!option.$) {
            var val = option.a;
            return _Utils_update(record, {
                aa9: $elm$core$Maybe$Just(val)
            });
        } else {
            var handler = option.a;
            return _Utils_update(record, {
                afv: $elm$core$Maybe$Just(handler)
            });
        }
    }), A2($author$project$Components$LanguageInput$OptionsRecord, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
    var $author$project$Components$LanguageInput$view = function(options) {
        var optionsRecord = $author$project$Components$LanguageInput$optionsToRecord(options);
        return A2($author$project$Ui$Form$Select$view, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Language$toValue, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $author$project$Ui$Form$Select$value)), optionsRecord.aa9),
            A2($elm$core$Maybe$map, $author$project$Ui$Form$Select$onChange, A2($elm$core$Maybe$map, function(handler) {
                return A2($elm$core$Basics$composeL, handler, $author$project$Language$fromString);
            }, optionsRecord.afv))
        ])), A2($elm$core$List$map, function(option) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Language$toValue(option)), $author$project$Language$toLabel(option));
        }, _List_fromArray([
            $author$project$Language$english,
            $author$project$Language$spanish
        ])));
    };
    var $author$project$Pages$Admin$Patients$viewDefaultPreferredLanguage = F2(function(practice, fields) {
        return A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$label('Default preferred language'),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$labelHelp(A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Default preferred language for new patients')
                    ]))),
                    $author$project$Ui$Form$Group$labelSpan(10),
                    $author$project$Ui$Form$Group$inputSpan(2),
                    $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('This language will be set, by default, on all new patients created. Changing the default language will not impact any existing patients language settings and will only be used moving forward.\n                            '))
                ]), _List_fromArray([
                    $author$project$Components$LanguageInput$view(_List_fromArray([
                        $author$project$Components$LanguageInput$value(fields.ac$),
                        $author$project$Components$LanguageInput$onChange(A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Patients$DefaultPreferredLanguage, $author$project$Pages$Admin$Patients$FieldChanged))
                    ]))
                ]))
            ]))
        ])) : $elm$html$Html$text('');
    });
    var $author$project$Pages$Admin$Patients$DefaultToActivePatientsFilter = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$viewDefaultToActivePatientsFilter = function(fields) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(fields.ac0),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$DefaultToActivePatientsFilter))
        ]));
        var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Whether or not the patient list will default to showing only active patients.')
        ]));
        return A3($author$project$Pages$Admin$Patients$settingToggle, 'Default to active patients filter', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Pages$Admin$Patients$SSNEnabled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$viewEnableSSN = function(fields) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(fields._$),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$SSNEnabled))
        ]));
        var labelHelp = fields._$ ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Collection of SSN for patients is enabled')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('To change signup SSN collection see ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Signup, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here')
                ]))
            ]))
        ])) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Collection of SSN for patients is disabled')
        ]));
        return A3($author$project$Pages$Admin$Patients$settingToggle, 'Enable SSN', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Pages$Admin$Patients$EngagementThreshold = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$FeatureGate$EngagementTracking = 11;
    var $author$project$Api$Provider$Practice$Shared$isAffiliate = function(_v0) {
        var record = _v0;
        return record.RP;
    };
    var $author$project$Api$Provider$Practice$One$isAffiliate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$isAffiliate(shared);
    };
    var $author$project$Api$Provider$Practice$Shared$isNetwork = function(_v0) {
        var record = _v0;
        return record.Sd;
    };
    var $author$project$Api$Provider$Practice$One$isNetwork = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$isNetwork(shared);
    };
    var $author$project$Pages$Admin$Patients$viewEngagementThreshold = F2(function(practice, fields) {
        var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
        var gateIsAvailable = A2($author$project$Utils$FeatureGate$gateAvailable, 11, $author$project$Api$Practice$Provider(practice));
        if (gateIsAvailable || practiceIsAffiliateOrNetwork) {
            var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('\n                        Set the number of months after receiving a service that the patient will\n                        switch from Currently Engaged to Previously Engaged.\n                        ')
            ]));
            var disableInput = !gateIsAvailable && practiceIsAffiliateOrNetwork;
            var inputValue = disableInput ? '12' : fields.ads;
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$required(true),
                        $author$project$Ui$Form$Group$label('Engagement Threshold'),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$labelHelp(labelHelp),
                        $author$project$Ui$Form$Group$clearfix,
                        $author$project$Ui$Form$Group$labelSpan(10),
                        $author$project$Ui$Form$Group$inputSpan(2)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$group(_List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(inputValue),
                                $author$project$Ui$Form$Input$number,
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$EngagementThreshold)),
                                $author$project$Ui$Form$Input$withFeedback(true),
                                $author$project$Ui$Form$Input$disabled(disableInput)
                            ])),
                            $author$project$Ui$Form$Input$addon(_List_fromArray([
                                $elm$html$Html$text('months')
                            ]))
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$Practice$One$hasLocations = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, A2($elm$core$Basics$composeR, function($) {
        return $.Ue;
    }, function($) {
        return $.Qr;
    }));
    var $author$project$Pages$Admin$Patients$viewLocationsWarning = function(practice) {
        return $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice) && !$author$project$Api$Provider$Practice$One$hasLocations(practice) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You are tracking patients by location but don\'t have any locations setup yet. Go ')
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Locations, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('here')
                    ])),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' to setup locations.')
                    ]))
                ]))
            ]))
        ])) : $elm$html$Html$text('');
    };
    var $author$project$Pages$Admin$Patients$RequiresDefaultLocationForCompanies = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Qm;
    });
    var $author$project$Pages$Admin$Patients$viewWarningWell = F2(function(enabled, message) {
        return A3($author$project$Pages$Admin$Patients$viewExpandedWarningWell, enabled, message, $elm$core$Maybe$Just($author$project$Utils$Html$empty));
    });
    var $author$project$Pages$Admin$Patients$viewRequireCompanyDefaultLocation = F2(function(practice, fields) {
        if (fields.aaq) {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.agP),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresDefaultLocationForCompanies)),
                $author$project$Ui$ToggleSwitch$disabled($author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation(practice))
            ]));
            var labelHelp = fields.agP ? A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('A default location is required on all companies.')
            ])) : A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('A default location can optionally be set on a company. When a patient is created without a location no location will be assigned. ')
                ])),
                A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patients without a location assigned may not be synced to partners')
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' until one is assigned.')
                ]))
            ]));
            return _List_fromArray([
                A3($author$project$Pages$Admin$Patients$settingToggle, 'Require companies to have a default location', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch),
                A2($author$project$Pages$Admin$Patients$viewWarningWell, $author$project$Api$Provider$Practice$One$hasCompaniesWithoutDefaultLocation(practice), ' To enable this, ensure that every company has a default location assigned.')
            ]);
        } else return _List_Nil;
    });
    var $author$project$Pages$Admin$Patients$RequireGroupForLocations = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Qs;
    });
    var $author$project$Pages$Admin$Patients$viewRequireGroupInLocations = F2(function(practice, fields) {
        if (fields.aaq) {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.agL),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequireGroupForLocations)),
                $author$project$Ui$ToggleSwitch$disabled($author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup(practice))
            ]));
            var labelHelp = fields.agL ? A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('A group is required on all locations.')
            ])) : A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('A group can optionally be set on a location. ')
                ])),
                A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patient in locations without a group assigned may not be synced to partners')
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' until one is assigned.')
                ]))
            ]));
            return _List_fromArray([
                A3($author$project$Pages$Admin$Patients$settingToggle, 'Require every location to have a group assigned', labelHelp, toggleSwitch),
                A2($author$project$Pages$Admin$Patients$viewWarningWell, $author$project$Api$Provider$Practice$One$hasLocationsWithoutGroup(practice), ' To enable this, ensure that every location has a group assigned.')
            ]);
        } else return _List_Nil;
    });
    var $author$project$Pages$Admin$Patients$RequiresLocation = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$viewRequireLocationSelection = F2(function(practice, fields) {
        if (fields.aaq) {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.YK),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresLocation)),
                $author$project$Ui$ToggleSwitch$disabled(!$author$project$Api$Provider$Practice$One$hasLocations(practice))
            ]));
            var labelHelpRequiresLocation = $author$project$Api$Provider$Practice$One$requiresLocation(practice) ? A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Locations will be collected and required always.')
            ])) : A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = fields.acw;
                    switch(_v0){
                        case 0:
                            return $elm$html$Html$text('Locations are optional. If enabled, this will enforce collection on signup.');
                        case 2:
                            return $elm$html$Html$text('Locations are required during online signup.');
                        default:
                            return $elm$html$Html$text('');
                    }
                }()
            ]));
            var labelHelpHasLocations = !$author$project$Api$Provider$Practice$One$hasLocations(practice) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This practice has no locations. You need to add some ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Locations, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' to enable this feature.')
                ]))
            ])) : $elm$html$Html$text('');
            var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                labelHelpHasLocations,
                labelHelpRequiresLocation
            ]));
            return A3($author$project$Pages$Admin$Patients$settingToggle, 'Require location selection for every patient', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
        } else return $elm$html$Html$text('');
    });
    var $author$project$Pages$Admin$Patients$RequiresPatientEmail = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$viewRequirePatientEmailSelection = function(fields) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(fields.YM),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPatientEmail))
        ]));
        var labelHelp = fields.YM ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Email is required when creating or updating any patient in app or on signup.')
        ])) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Email can be collected but is not required for all patients.')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Email is required only for the primary member on signup.')
            ]))
        ]));
        return A3($author$project$Pages$Admin$Patients$settingToggle, 'Require email for every patient', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Pages$Admin$Patients$RequiresPatientMobile = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$viewRequirePatientMobileSelection = function(fields) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(fields.YN),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPatientMobile))
        ]));
        var labelHelp = fields.YN ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Mobile phone is required when creating or updating any patient in app or on signup.')
        ])) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Mobile phone can be collected but is not required for all patients.')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Any phone type is required only for the primary member on signup.')
            ]))
        ]));
        return A3($author$project$Pages$Admin$Patients$settingToggle, 'Require a mobile phone number for every patient', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Pages$Admin$Patients$RequiresPractitioner = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$hasPractitioners = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, A2($elm$core$Basics$composeR, function($) {
        return $.Ue;
    }, function($) {
        return $.Qx;
    }));
    var $author$project$Pages$Admin$Patients$viewRequireProviderSelection = F2(function(practice, fields) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(fields.YP),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresPractitioner)),
            $author$project$Ui$ToggleSwitch$disabled(!$author$project$Api$Provider$Practice$One$hasPractitioners(practice))
        ]));
        var labelHelp = fields.YP ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Providers will be collected and required.')
        ])) : $author$project$Api$Provider$Practice$One$hasPractitioners(practice) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = fields.Lx;
                    switch(_v0){
                        case 0:
                            return $elm$html$Html$text('Providers will not be collected during signup.');
                        case 1:
                            return $elm$html$Html$text('Providers are optional during signup.');
                        case 2:
                            return $elm$html$Html$text('Providers are required during signup only.');
                        default:
                            return $elm$html$Html$text('');
                    }
                }()
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If enabled, this will enforce collection. ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Signup, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('See here')
                ]))
            ]))
        ])) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('This practice has no providers. You need to add some')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Providers__Top, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' to enable this feature.')
                ]))
            ]))
        ]));
        return A3($author$project$Pages$Admin$Patients$settingToggle, 'Require provider selection for every patient', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    });
    var $author$project$Pages$Admin$Patients$RequiresSSN = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$viewRequireSSNSelection = function(fields) {
        if (fields._$) {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.YQ),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$RequiresSSN))
            ]));
            var labelHelp = fields.YQ ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('When editing a patient, entering a SSN will be always required')
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('SSN collection will be enforced on signup.')
                ]))
            ])) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('SSN on patients is optional.')
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = fields.Ly;
                        switch(_v0){
                            case 0:
                                return $elm$html$Html$text('SSN collection is disabled on signup.');
                            case 1:
                                return $elm$html$Html$text('SSN collection is optional on signup.');
                            case 2:
                                return $elm$html$Html$text('SSN collection is required on signup.');
                            default:
                                return $elm$html$Html$text('');
                        }
                    }()
                ]))
            ]));
            return A3($author$project$Pages$Admin$Patients$settingToggle, 'Require SSN selection for every patient', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
        } else return $elm$html$Html$text('');
    };
    var $author$project$Pages$Admin$Patients$TrackPatientsByLocation = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Patients$viewTrackLocation = function(fields) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(fields.aaq),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Patients$FieldChanged, $author$project$Pages$Admin$Patients$TrackPatientsByLocation))
        ]));
        var labelHelp = fields.aaq ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = fields.acw;
                    switch(_v0){
                        case 0:
                            return $elm$html$Html$text('Locations for patients can be assigned but are not collected during signup.');
                        case 2:
                            return $elm$html$Html$text('Locations for patients can be assigned and are required during signup.');
                        default:
                            return $elm$html$Html$text('');
                    }
                }()
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('To change signup location collection see  ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Signup, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here')
                ]))
            ]))
        ])) : A2($elm$html$Html$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Location support is not enabled. If toggled, you can track patients by location.')
        ]));
        return A3($author$project$Pages$Admin$Patients$settingToggle, 'Track patients by location', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Pages$Admin$Patients$view = function(_v0) {
        var practice = _v0.W1;
        var fields = _v0.adM;
        var passthroughFeesCutoffDateInput = _v0.rT;
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Patients')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, $author$project$Pages$Admin$Patients$viewLocationsWarning(practice), A2($elm$core$List$cons, $author$project$Pages$Admin$Patients$viewEnableSSN(fields), A2($elm$core$List$cons, $author$project$Pages$Admin$Patients$viewRequireSSNSelection(fields), A2($elm$core$List$cons, $author$project$Pages$Admin$Patients$viewRequirePatientEmailSelection(fields), A2($elm$core$List$cons, $author$project$Pages$Admin$Patients$viewRequirePatientMobileSelection(fields), A2($elm$core$List$cons, A2($author$project$Pages$Admin$Patients$viewRequireProviderSelection, practice, fields), _Utils_ap(A3($author$project$Pages$Admin$Patients$viewChargePatientsCreditCardFees, practice, fields, passthroughFeesCutoffDateInput), A2($elm$core$List$cons, $author$project$Pages$Admin$Patients$viewTrackLocation(fields), A2($elm$core$List$cons, A2($author$project$Pages$Admin$Patients$viewRequireLocationSelection, practice, fields), _Utils_ap(A2($author$project$Pages$Admin$Patients$viewRequireCompanyDefaultLocation, practice, fields), _Utils_ap(A2($author$project$Pages$Admin$Patients$viewRequireGroupInLocations, practice, fields), _List_fromArray([
                        A2($author$project$Pages$Admin$Patients$viewEngagementThreshold, practice, fields),
                        A2($author$project$Pages$Admin$Patients$viewDefaultPreferredLanguage, practice, fields),
                        $author$project$Pages$Admin$Patients$viewDefaultToActivePatientsFilter(fields)
                    ])))))))))))))
                ]))
            ]),
            $2: 'Admin | Patient Settings'
        };
    };
    var $author$project$Pages$Admin$Patients$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Patients$init,
        aeR: $author$project$Pages$Admin$Patients$load,
        ag3: $author$project$Pages$Admin$Patients$save,
        ahE: $author$project$Pages$Admin$Patients$subscriptions,
        aaO: $author$project$Pages$Admin$Patients$update,
        aid: $author$project$Pages$Admin$Patients$view
    });
    var $author$project$Api$Provider$Report$PaymentMethodImport = 24;
    var $author$project$Pages$Admin$PaymentMethodImport$Pending = 1;
    var $author$project$Pages$Admin$PaymentMethodImport$StatusDropdownMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentMethodImport$GotPaymentMethodImports = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$PaymentMethodMigration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PaymentMethodMigration$One$PaymentMethodMigration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$PaymentMethodMigration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$Record = F7(function(id, status, sourceProcessor, migrationId, sourceCustomerId, sourcePaymentMethodId, description) {
        return {
            NQ: description,
            aef: id,
            Ui: migrationId,
            _E: sourceCustomerId,
            _F: sourcePaymentMethodId,
            _G: sourceProcessor,
            ahy: status
        };
    });
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source_payment_method_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source_customer_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'migration_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$Shared$Record))))))));
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PaymentMethodMigration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PaymentMethodMigration$One$Record = F2(function(owner, metadata) {
        return {
            Uf: metadata,
            VM: owner
        };
    });
    var $author$project$Api$Common$Payable$Owner$Min$Owner = $elm$core$Basics$identity;
    var $author$project$Api$Common$Payable$Owner$Min$Record = F3(function(id, name, type_) {
        return {
            aef: id,
            zr: name,
            ah5: type_
        };
    });
    var $author$project$Api$Common$Payable$Owner$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Owner$Min$Record))));
    var $author$project$Api$Common$Payable$Owner$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Payable$Owner$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PaymentMethodMigration$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'metadata', $elm$json$Json$Decode$value, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$One$Record)));
    var $author$project$Api$Provider$PaymentMethodMigration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PaymentMethodMigration$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PaymentMethodMigration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethodMigration$One$PaymentMethodMigration)));
    var $author$project$Api$Provider$PaymentMethodMigration$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PaymentMethodMigration$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PaymentMethodImport$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$PaymentMethodImport$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$PaymentMethodImport$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.ahy;
                if (!_v0.$) {
                    var status = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', status)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'payment_method_imports'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PaymentMethodImport$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PaymentMethodMigration$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$PaymentMethodImport$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath)));
    });
    var $author$project$Pages$Admin$PaymentMethodImport$statusOptionToValue = function(option) {
        switch(option){
            case 1:
                return $elm$core$Maybe$Just('pending');
            case 2:
                return $elm$core$Maybe$Just('imported');
            case 3:
                return $elm$core$Maybe$Just('ignored');
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations = F2(function(apiClient, model) {
        var optionals = function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                ahs: model.ahs,
                ahy: $author$project$Pages$Admin$PaymentMethodImport$statusOptionToValue(model.ahy)
            });
        };
        return A3($author$project$Api$Provider$PaymentMethodImport$list, apiClient, optionals, $author$project$Pages$Admin$PaymentMethodImport$GotPaymentMethodImports);
    });
    var $author$project$Pages$Admin$PaymentMethodImport$init = F4(function(session, _v0, shared, _v1) {
        var model = {
            Ej: shared.Ej,
            EE: A3($author$project$Permission$canGoTo, session, shared.aeb, 17),
            EF: A3($author$project$Permission$canGoTo, session, shared.aeb, 44),
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 24
            }),
            d8: $elm$core$Maybe$Nothing,
            iR: $elm$core$Maybe$Nothing,
            F3: $author$project$Shared$isHintAdmin(shared),
            af_: $author$project$Api$Pagination$init,
            ci: $author$project$Api$Data$Loading,
            ahs: $author$project$Api$Sort$init,
            ahy: 1,
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'status-dropdown-filter',
                ahX: $author$project$Pages$Admin$PaymentMethodImport$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, shared.Ej, model));
    });
    var $author$project$Pages$Admin$PaymentMethodImport$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$PaymentMethodImport$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Close = {
        $: 0
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$PaymentMethodImport$ImportModal$Close);
    };
    var $author$project$Pages$Admin$PaymentMethodImport$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v0) {
                var paymentMethodMigration = _v0.a;
                return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed(paymentMethodMigration));
            }, model.d8)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg), A2($elm$core$Maybe$map, function(importModal) {
                return $author$project$Components$Admin$PaymentMethodImport$ImportModal$subscriptions(importModal);
            }, model.iR))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md))
        ]));
    };
    var $author$project$Pages$Admin$PaymentMethodImport$GotIgnoreResponse = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PaymentMethodMigration$Shared$id(shared);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$id(one);
    };
    var $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportsPath);
    };
    var $author$project$Api$Provider$PaymentMethodImport$ignore = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PaymentMethodMigration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'ignore'
        ]), $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath(id))));
    });
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Company$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Company$All$Company = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Company$Shared$Company = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Company$Shared$Record = function(id) {
        return function(name) {
            return function(companyType) {
                return function(createdAt) {
                    return function(periodInMonths) {
                        return function(allowCustomMembershipPlan) {
                            return function(postSignupButtonLabel) {
                                return function(postSignupMessage) {
                                    return function(postSignupRedirectUrl) {
                                        return function(redirectsPostSignup) {
                                            return function(requiresEmployeeDivisions) {
                                                return function(showPostSignupFooterButton) {
                                                    return function(customPostSignupPage) {
                                                        return function(stripeLink) {
                                                            return function(nextInvoiceDate) {
                                                                return function(inactive) {
                                                                    return function(backBillPeriods) {
                                                                        return function(limitBackBill) {
                                                                            return function(billAffiliateRate) {
                                                                                return {
                                                                                    I8: allowCustomMembershipPlan,
                                                                                    J3: backBillPeriods,
                                                                                    Kb: billAffiliateRate,
                                                                                    LR: companyType,
                                                                                    Mx: createdAt,
                                                                                    MZ: customPostSignupPage,
                                                                                    aef: id,
                                                                                    Q8: inactive,
                                                                                    Tc: limitBackBill,
                                                                                    zr: name,
                                                                                    U$: nextInvoiceDate,
                                                                                    WA: periodInMonths,
                                                                                    WZ: postSignupButtonLabel,
                                                                                    W_: postSignupMessage,
                                                                                    W$: postSignupRedirectUrl,
                                                                                    Yp: redirectsPostSignup,
                                                                                    YJ: requiresEmployeeDivisions,
                                                                                    _j: showPostSignupFooterButton,
                                                                                    $j: stripeLink
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Company$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_affiliate_rate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'limit_back_bill', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'back_bill_periods', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'inactive', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_invoice_date', $elm$json$Json$Decode$maybe($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_link', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'custom_post_signup_page', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'show_post_signup_footer_button', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_employee_divisions', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redirects_post_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_redirect_url', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_message', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_button_label', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allow_custom_membership_plan', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_type', $author$project$Api$Company$CompanyType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$Shared$Record))))))))))))))))))));
    var $author$project$Api$Provider$Company$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Company$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$All$Record = F8(function(status, flaggedNotesCount, usesEmployeeDivisions, eligibleCount, enrolledCount, needsApprovalCount, owedInCents, plans) {
        return {
            OG: eligibleCount,
            OX: enrolledCount,
            PR: flaggedNotesCount,
            UJ: needsApprovalCount,
            VL: owedInCents,
            WO: plans,
            ahy: status,
            aa1: usesEmployeeDivisions
        };
    });
    var $author$project$Api$Provider$Company$All$recordDecoder = A3($author$project$Api$Expandable$expandable, 'plans', $elm$json$Json$Decode$list($author$project$Api$Provider$Plan$Shared$decoder), A3($author$project$Api$Expandable$expandable, 'owed_in_cents', $elm$json$Json$Decode$int, A3($author$project$Api$Expandable$expandable, 'needs_approval_count', $elm$json$Json$Decode$int, A3($author$project$Api$Expandable$expandable, 'enrolled_count', $elm$json$Json$Decode$int, A3($author$project$Api$Expandable$expandable, 'eligible_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_employee_divisions', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'flagged_notes_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$All$Record)))))))));
    var $author$project$Api$Provider$Company$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Company$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Company$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$All$Company)));
    var $author$project$Api$Provider$Company$expandToString = function(expand) {
        switch(expand){
            case 0:
                return 'plans';
            case 1:
                return 'eligible_count';
            case 2:
                return 'enrolled_count';
            case 3:
                return 'needs_approval_count';
            default:
                return 'owed_in_cents';
        }
    };
    var $author$project$Api$Provider$Company$listDefaults = {
        Fq: _List_Nil,
        Fw: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        GW: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
        Hz: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Company$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Company$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fw;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.GW;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'plans', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.Hz;
                if (!_v4.$) {
                    var string = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'sponsor_type', string)
                    ]);
                } else return _List_Nil;
            }(),
            A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Company$expandToString, options.Fq),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Company$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Company$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Company$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companiesPath)));
    });
    var $author$project$Components$ResourceFilter$Company$list = $author$project$Api$Provider$Company$list;
    var $author$project$Components$ResourceFilter$Company$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Company$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Company$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Company$list, apiClient, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Company$selectId = 'companies';
    var $author$project$Api$Provider$Company$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Company$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$name(shared);
    };
    var $author$project$Components$ResourceFilter$Company$toTitle = $author$project$Api$Provider$Company$All$name;
    var $author$project$Components$ResourceFilter$Company$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Company$toTitle(resource))
        ]);
    };
    var $author$project$Api$Provider$Company$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Company$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$id(shared);
    };
    var $author$project$Components$ResourceFilter$Company$toValue = $author$project$Api$Provider$Company$All$id;
    var $author$project$Components$ResourceFilter$Company$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Company$fetchResources,
            aef: $author$project$Components$ResourceFilter$Company$selectId,
            gD: 'Sponsor',
            sz: $author$project$Components$ResourceFilter$Company$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$Company$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Company$toTitle,
            g4: $author$project$Components$ResourceFilter$Company$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$Patient$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$Patient$list = $author$project$Api$Provider$Patient$list;
    var $author$project$Components$ResourceFilter$Patient$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Patient$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Patient$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Patient$list, apiClient, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, toMsg);
    });
    var $author$project$Api$Provider$Patient$Shared$age = function(_v0) {
        var shared = _v0;
        return shared.IZ;
    };
    var $author$project$Api$Provider$Patient$All$age = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$age(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$membershipStatus = function(_v0) {
        var shared = _v0;
        return shared.T5;
    };
    var $author$project$Api$Provider$Patient$All$membershipStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
    };
    var $author$project$Ui$Badge$SizeSm = {
        $: 2
    };
    var $author$project$Ui$Badge$sm = $author$project$Ui$Badge$SizeSm;
    var $author$project$Components$ResourceFilter$Patient$toLabel = function(resource) {
        return A2($elm$core$List$intersperse, A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('mr-2')
        ]), _List_Nil), A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $elm$core$Maybe$Just($elm$html$Html$text($author$project$Api$Provider$Patient$All$name(resource))),
            A2($elm$core$Maybe$map, function(age) {
                return $elm$html$Html$text(age);
            }, A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Provider$Patient$All$age(resource))),
            $elm$core$Maybe$Just(A2($author$project$Ui$Badge$fromString, _List_fromArray([
                $author$project$Ui$Badge$sm
            ]), $author$project$Api$Provider$Patient$All$membershipStatus(resource)))
        ])));
    };
    var $author$project$Components$ResourceFilter$Patient$toTitle = function(resource) {
        return _Utils_ap($author$project$Api$Provider$Patient$All$name(resource), _Utils_ap(function() {
            var _v0 = $author$project$Api$Provider$Patient$All$age(resource);
            if (!_v0.$) {
                var age = _v0.a;
                return ' - ' + $elm$core$String$fromInt(age);
            } else return '';
        }(), !$elm$core$String$isEmpty($author$project$Api$Provider$Patient$All$membershipStatus(resource)) ? ' - ' + $author$project$Formatters$String$humanize($author$project$Api$Provider$Patient$All$membershipStatus(resource)) : ''));
    };
    var $author$project$Components$ResourceFilter$Patient$toValue = $author$project$Api$Provider$Patient$All$id;
    var $author$project$Components$ResourceFilter$Patient$initWithId = F3(function(selectId_, apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Patient$fetchResources,
            aef: selectId_,
            gD: 'Patient',
            sz: $author$project$Components$ResourceFilter$Patient$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$Patient$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Patient$toTitle,
            g4: $author$project$Components$ResourceFilter$Patient$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$Patient$selectId = 'patients';
    var $author$project$Components$ResourceFilter$Patient$init = $author$project$Components$ResourceFilter$Patient$initWithId($author$project$Components$ResourceFilter$Patient$selectId);
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientOwnerType = 1;
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$initFormFields = {
        acy: $elm$core$Maybe$Nothing,
        Q6: false,
        ek: 1,
        V7: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$init = F2(function(apiClient, paymentMethodMigration) {
        var _v0 = A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Patient'
            });
        });
        var patientResourceFilter = _v0.a;
        var patientResourceFilterCmd = _v0.b;
        var _v1 = A2($author$project$Components$ResourceFilter$Company$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select an Employer'
            });
        });
        var companyResourceFilter = _v1.a;
        var companyResourceFilterCmd = _v1.b;
        return _Utils_Tuple2({
            pY: companyResourceFilter,
            PU: $author$project$Utils$Form$init($author$project$Components$Admin$PaymentMethodImport$ImportModal$initFormFields),
            mx: $author$project$Api$Data$NotAsked,
            rX: patientResourceFilter,
            rY: paymentMethodMigration
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg, companyResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg, patientResourceFilterCmd)
        ])));
    });
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Closed = 1;
    var $author$project$Api$Provider$PaymentMethodImport$Company = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Company = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$GotImportReponse = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Imported = 2;
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$None = 0;
    var $author$project$Api$Provider$PaymentMethodImport$Patient = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var ownerType = field.a;
                return _Utils_update(fields, {
                    ek: ownerType
                });
            case 1:
                var company = field.a;
                return _Utils_update(fields, {
                    acy: company
                });
            case 2:
                var patient = field.a;
                return _Utils_update(fields, {
                    V7: patient
                });
            default:
                var importAllForOwner = field.a;
                return _Utils_update(fields, {
                    Q6: importAllForOwner
                });
        }
    });
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyValidation = 0;
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$validateCompany = function(fields) {
        var _v0 = _Utils_Tuple2(fields.ek, fields.acy);
        if (!_v0.a) {
            if (_v0.b.$ === 1) {
                var _v1 = _v0.a;
                var _v2 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(0, 'Please select an employer.')
                ]);
            } else {
                var _v3 = _v0.a;
                return _List_Nil;
            }
        } else {
            var _v4 = _v0.a;
            return _List_Nil;
        }
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientValidation = 1;
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$validatePatient = function(fields) {
        var _v0 = _Utils_Tuple2(fields.ek, fields.V7);
        if (_v0.a === 1) {
            if (_v0.b.$ === 1) {
                var _v1 = _v0.a;
                var _v2 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(1, 'Please select a patient.')
                ]);
            } else {
                var _v3 = _v0.a;
                return _List_Nil;
            }
        } else {
            var _v4 = _v0.a;
            return _List_Nil;
        }
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$PaymentMethodImport$ImportModal$validatePatient),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$PaymentMethodImport$ImportModal$validateCompany)
    ]));
    var $author$project$Api$Provider$PaymentMethodImport$import_ = F4(function(apiClient, id, _v0, toMsg) {
        var owner = _v0.VM;
        var importAllForOwner = _v0.Q6;
        var _v1 = function() {
            if (!owner.$) {
                var patientId = owner.a;
                return _Utils_Tuple2('patient', patientId);
            } else {
                var companyId = owner.a;
                return _Utils_Tuple2('company', companyId);
            }
        }();
        var ownerType = _v1.a;
        var ownerId = _v1.b;
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('owner', $author$project$Utils$Encode$typedAssociation({
                aef: $elm$core$Maybe$Just(ownerId),
                ah5: $elm$core$Maybe$Just(ownerType)
            })),
            _Utils_Tuple2('import_all_for_owner', $elm$json$Json$Encode$bool(importAllForOwner))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PaymentMethodMigration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'import'
        ]), $author$project$Api$Provider$PaymentMethodImport$paymentMethodImportPath(id)))));
    });
    var $author$project$Components$ResourceFilter$Company$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$Patient$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 2:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var id = $author$project$Api$Provider$PaymentMethodMigration$All$id(model.rY);
                    var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var ownerType = _v4.ek;
                    var company = _v4.acy;
                    var patient = _v4.V7;
                    var importAllForOwner = _v4.Q6;
                    var owner = function() {
                        if (ownerType === 1) {
                            var patientId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$All$id, patient));
                            return $author$project$Api$Provider$PaymentMethodImport$Patient(patientId);
                        } else {
                            var companyId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$All$id, company));
                            return $author$project$Api$Provider$PaymentMethodImport$Company(companyId);
                        }
                    }();
                    var importParams = {
                        Q6: importAllForOwner,
                        VM: owner
                    };
                    return {
                        EQ: A4($author$project$Api$Provider$PaymentMethodImport$import_, apiClient, id, importParams, $author$project$Components$Admin$PaymentMethodImport$ImportModal$GotImportReponse),
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            mx: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 3:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        mx: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully imported.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        mx: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var subMsg = msg.a;
                var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pY);
                var newForm = function() {
                    var _v7 = companyResourceResult.adu;
                    _v7$2: while(true){
                        if (!_v7.$ && !_v7.a.$) switch(_v7.a.a.$){
                            case 0:
                                var company = _v7.a.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate, $author$project$Components$Admin$PaymentMethodImport$ImportModal$Company($elm$core$Maybe$Just(company)), model.PU);
                            case 2:
                                var _v8 = _v7.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate, $author$project$Components$Admin$PaymentMethodImport$ImportModal$Company($elm$core$Maybe$Nothing), model.PU);
                            default:
                                break _v7$2;
                        }
                        else break _v7$2;
                    }
                    return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg, companyResourceResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        pY: companyResourceResult.zi,
                        PU: newForm
                    }),
                    at: companyResourceResult.at
                };
            default:
                var subMsg = msg.a;
                var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rX);
                var newForm = function() {
                    var _v9 = patientResourceResult.adu;
                    _v9$2: while(true){
                        if (!_v9.$ && !_v9.a.$) switch(_v9.a.a.$){
                            case 0:
                                var patient = _v9.a.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate, $author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient($elm$core$Maybe$Just(patient)), model.PU);
                            case 2:
                                var _v10 = _v9.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Admin$PaymentMethodImport$ImportModal$formFieldsUpdate, $author$project$Components$Admin$PaymentMethodImport$ImportModal$Patient($elm$core$Maybe$Nothing), model.PU);
                            default:
                                break _v9$2;
                        }
                        else break _v9$2;
                    }
                    return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg, patientResourceResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm,
                        rX: patientResourceResult.zi
                    }),
                    at: patientResourceResult.at
                };
        }
    });
    var $author$project$Pages$Admin$PaymentMethodImport$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        ci: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ci: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var newModel = _Utils_update(model, {
                    af_: A2($author$project$Api$Pagination$update, subMsg, model.af_)
                });
                return _Utils_Tuple3(newModel, A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Ej, newModel), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Ej, newModel), _List_Nil);
            case 3:
                var paymentMethodMigration = msg.a;
                var _v2 = A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$init, model.Ej, paymentMethodMigration);
                var importModal = _v2.a;
                var importModalCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    iR: $elm$core$Maybe$Just(importModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg, importModalCmd), _List_Nil);
            case 4:
                var importModalMsg = msg.a;
                var _v3 = model.iR;
                if (!_v3.$) {
                    var importModal = _v3.a;
                    var importModalResult = A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$update, model.Ej, importModalMsg, importModal);
                    var _v4 = function() {
                        var _v5 = importModalResult.adu;
                        switch(_v5){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(importModalResult.zi), model.ci, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ci, $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Ej, model));
                        }
                    }();
                    var newImportModal = _v4.a;
                    var paymentMethodImports = _v4.b;
                    var paymentMethodImportsCmd = _v4.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        iR: newImportModal,
                        ci: paymentMethodImports
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg, importModalResult.EQ),
                        paymentMethodImportsCmd
                    ])), importModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var paymentMethodMigration = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    d8: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var paymentMethodMigration = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$PaymentMethodMigration$All$id(paymentMethodMigration);
                    return _Utils_Tuple3(_Utils_update(model, {
                        d8: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$Loading))
                    }), A3($author$project$Api$Provider$PaymentMethodImport$ignore, model.Ej, id, $author$project$Pages$Admin$PaymentMethodImport$GotIgnoreResponse(paymentMethodMigration)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    d8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var paymentMethodMigration = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    d8: $elm$core$Maybe$Nothing,
                    ci: $author$project$Api$Data$Loading
                }), A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Ej, model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully ignored.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    d8: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodMigration, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var subMsg = msg.a;
                var _v7 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var dropdown = _v7.a;
                var dropdownCmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: dropdown
                }), dropdownCmd, _List_Nil);
            case 9:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ci: $author$project$Api$Data$Loading,
                    ahy: status
                });
                return _Utils_Tuple3(newModel, A2($author$project$Pages$Admin$PaymentMethodImport$retrievePaymentMethodMigrations, model.Ej, newModel), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v8 = A3($author$project$Components$ExportCsv$update, model.Ej, subMsg, model.md);
                var exportCsv = _v8.a;
                var subCmd = _v8.b;
                var subOutMsgs = _v8.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg, subCmd), subOutMsgs);
        }
    });
    var $author$project$Pages$Admin$PaymentMethodImport$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentMethodImport$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentMethodImport$paymentMethodImportsColumns = _List_fromArray([
        A3($author$project$Api$Column$init, '', false, 'Status'),
        A3($author$project$Api$Column$init, '', false, 'Owner'),
        A3($author$project$Api$Column$init, '', false, 'Source Processor'),
        A3($author$project$Api$Column$init, '', false, 'Migration ID'),
        A3($author$project$Api$Column$init, '', false, 'Source Customer ID'),
        A3($author$project$Api$Column$init, '', false, 'Source Payment Method ID'),
        A3($author$project$Api$Column$init, '', false, 'Description'),
        A3($author$project$Api$Column$init, '', false, 'Metadata')
    ]);
    var $author$project$Components$ExportCsv$Report = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$report = $author$project$Components$ExportCsv$Report;
    var $author$project$Api$Data$totalCount = function(data) {
        if (data.$ === 3) {
            var headers = data.b;
            return A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyOwnerType = 0;
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$Import = {
        $: 2
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$ImportAllForOwner = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceCustomerId = function(_v0) {
        var record = _v0;
        return record._E;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$sourceCustomerId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceCustomerId(shared);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$sourceCustomerId(one);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourcePaymentMethodId = function(_v0) {
        var record = _v0;
        return record._F;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$sourcePaymentMethodId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourcePaymentMethodId(shared);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$sourcePaymentMethodId(one);
    };
    var $author$project$Components$ResourceFilter$Company$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewCompanyResourceFilter = F2(function(companyResourceFilter, form) {
        return A2($elm$html$Html$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$view, _List_fromArray([
            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
        ]), companyResourceFilter));
    });
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$OwnerType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton = F3(function(currentOwnerType, ownerType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select owner type ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentOwnerType, ownerType)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated($author$project$Components$Admin$PaymentMethodImport$ImportModal$OwnerType(ownerType)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$ResourceFilter$Patient$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$viewPatientResourceFilter = F2(function(patientResourceFilter, form) {
        return A2($elm$html$Html$map, $author$project$Components$Admin$PaymentMethodImport$ImportModal$PatientResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$view, _List_fromArray([
            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
        ]), patientResourceFilter));
    });
    var $author$project$Components$Admin$PaymentMethodImport$ImportModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$PaymentMethodImport$ImportModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Import Payment Method '),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId(model.rY)))
                ]))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Admin$PaymentMethodImport$ImportModal$Import),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Owner Type'),
                        $author$project$Ui$Form$Group$labelSpan(3),
                        $author$project$Ui$Form$Group$inputSpan(9)
                    ]), _List_fromArray([
                        $author$project$Ui$Button$group(_List_fromArray([
                            A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton, fields.ek, 1, 'Patient'),
                            A3($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewOwnerTypeButton, fields.ek, 0, 'Employer')
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Owner'),
                        $author$project$Ui$Form$Group$labelSpan(3),
                        $author$project$Ui$Form$Group$inputSpan(9),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        function() {
                            var _v1 = fields.ek;
                            if (_v1 === 1) return A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewPatientResourceFilter, model.rX, model.PU);
                            else return A2($author$project$Components$Admin$PaymentMethodImport$ImportModal$viewCompanyResourceFilter, model.pY, model.PU);
                        }()
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpan(3),
                        $author$project$Ui$Form$Group$inputSpan(9),
                        $author$project$Ui$Form$Group$label('')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                            $author$project$Ui$Form$Checkbox$value(fields.Q6),
                            $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Admin$PaymentMethodImport$ImportModal$FormUpdated, $author$project$Components$Admin$PaymentMethodImport$ImportModal$ImportAllForOwner))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Apply same owner for all '),
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId(model.rY)))
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel action'
                        }, _List_fromArray([
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$PaymentMethodImport$ImportModal$Close)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Import payment method'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$PaymentMethodImport$ImportModal$Import),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                            $author$project$Ui$Button$loading(_Utils_eq(model.mx, $author$project$Api$Data$Loading))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Import')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$PaymentMethodImport$Ignore = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentMethodImport$Import = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$description = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PaymentMethodMigration$Shared$description(shared);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$description = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$description(one);
    };
    var $author$project$Api$Common$Payable$Owner$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$metadata = function(_v0) {
        var record = _v0.b;
        return record.Uf;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$metadata = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$metadata(one);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$migrationId = function(_v0) {
        var record = _v0;
        return record.Ui;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$migrationId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PaymentMethodMigration$Shared$migrationId(shared);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$migrationId = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$migrationId(one);
    };
    var $author$project$Api$Common$Payable$Owner$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$owner = function(_v0) {
        var record = _v0.b;
        return record.VM;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$owner = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$owner(one);
    };
    var $the_sett$elm_pretty_printer$Pretty$Text = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $the_sett$elm_pretty_printer$Pretty$string = $the_sett$elm_pretty_printer$Pretty$Text;
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$boolToDoc = function(bool) {
        return bool ? $the_sett$elm_pretty_printer$Pretty$string('true') : $the_sett$elm_pretty_printer$Pretty$string('false');
    };
    var $the_sett$elm_pretty_printer$Pretty$Concatenate = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $the_sett$elm_pretty_printer$Pretty$append = F2(function(doc1, doc2) {
        return A2($the_sett$elm_pretty_printer$Pretty$Concatenate, function(_v0) {
            return doc1;
        }, function(_v1) {
            return doc2;
        });
    });
    var $the_sett$elm_pretty_printer$Pretty$char = function(c) {
        return $the_sett$elm_pretty_printer$Pretty$Text($elm$core$String$fromChar(c));
    };
    var $the_sett$elm_pretty_printer$Pretty$Line = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $the_sett$elm_pretty_printer$Pretty$line = A2($the_sett$elm_pretty_printer$Pretty$Line, ' ', '');
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBracket = A2($the_sett$elm_pretty_printer$Pretty$append, $the_sett$elm_pretty_printer$Pretty$line, $the_sett$elm_pretty_printer$Pretty$char(']'));
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$commaLine = A2($the_sett$elm_pretty_printer$Pretty$append, $the_sett$elm_pretty_printer$Pretty$char(','), $the_sett$elm_pretty_printer$Pretty$line);
    var $the_sett$elm_pretty_printer$Pretty$Empty = {
        $: 0
    };
    var $the_sett$elm_pretty_printer$Pretty$empty = $the_sett$elm_pretty_printer$Pretty$Empty;
    var $the_sett$elm_pretty_printer$Pretty$join = F2(function(sep, docs) {
        join: while(true){
            if (!docs.b) return $the_sett$elm_pretty_printer$Pretty$empty;
            else if (!docs.a.$) {
                var _v1 = docs.a;
                var ds = docs.b;
                var $temp$sep = sep, $temp$docs = ds;
                sep = $temp$sep;
                docs = $temp$docs;
                continue join;
            } else {
                var d = docs.a;
                var ds = docs.b;
                var step = F2(function(x, rest) {
                    if (!x.$) return rest;
                    else {
                        var doc = x;
                        return A2($the_sett$elm_pretty_printer$Pretty$append, sep, A2($the_sett$elm_pretty_printer$Pretty$append, doc, rest));
                    }
                });
                var spersed = A3($elm$core$List$foldr, step, $the_sett$elm_pretty_printer$Pretty$empty, ds);
                return A2($the_sett$elm_pretty_printer$Pretty$append, d, spersed);
            }
        }
    });
    var $the_sett$elm_pretty_printer$Pretty$Nest = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $the_sett$elm_pretty_printer$Pretty$nest = F2(function(depth, doc) {
        return A2($the_sett$elm_pretty_printer$Pretty$Nest, depth, function(_v0) {
            return doc;
        });
    });
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$openBracket = A2($the_sett$elm_pretty_printer$Pretty$append, $the_sett$elm_pretty_printer$Pretty$char('['), $the_sett$elm_pretty_printer$Pretty$line);
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$listToDoc = F2(function(indent, list) {
        return $elm$core$List$isEmpty(list) ? $the_sett$elm_pretty_printer$Pretty$string('[]') : A2($the_sett$elm_pretty_printer$Pretty$append, A2($the_sett$elm_pretty_printer$Pretty$nest, indent, A2($the_sett$elm_pretty_printer$Pretty$append, $ThinkAlexandria$elm_pretty_print_json$Json$Print$openBracket, A2($the_sett$elm_pretty_printer$Pretty$join, $ThinkAlexandria$elm_pretty_print_json$Json$Print$commaLine, list))), $ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBracket);
    });
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$nullToDoc = function(maybeDoc) {
        if (!maybeDoc.$) {
            var doc = maybeDoc.a;
            return doc;
        } else return $the_sett$elm_pretty_printer$Pretty$string('null');
    };
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$numberToDoc = function(num) {
        return $the_sett$elm_pretty_printer$Pretty$string($elm$core$String$fromFloat(num));
    };
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBrace = A2($the_sett$elm_pretty_printer$Pretty$append, $the_sett$elm_pretty_printer$Pretty$line, $the_sett$elm_pretty_printer$Pretty$char('}'));
    var $the_sett$elm_pretty_printer$Pretty$space = $the_sett$elm_pretty_printer$Pretty$char(' ');
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$colonSpace = A2($the_sett$elm_pretty_printer$Pretty$append, $the_sett$elm_pretty_printer$Pretty$char(':'), $the_sett$elm_pretty_printer$Pretty$space);
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$openBrace = A2($the_sett$elm_pretty_printer$Pretty$append, $the_sett$elm_pretty_printer$Pretty$char('{'), $the_sett$elm_pretty_printer$Pretty$line);
    var $the_sett$elm_pretty_printer$Pretty$surround = F3(function(left, right, doc) {
        return A2($the_sett$elm_pretty_printer$Pretty$append, A2($the_sett$elm_pretty_printer$Pretty$append, left, doc), right);
    });
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc = function(s) {
        return A3($the_sett$elm_pretty_printer$Pretty$surround, $the_sett$elm_pretty_printer$Pretty$char('\"'), $the_sett$elm_pretty_printer$Pretty$char('\"'), $the_sett$elm_pretty_printer$Pretty$string(s));
    };
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$objectToDoc = F2(function(indent, pairs) {
        return $elm$core$List$isEmpty(pairs) ? $the_sett$elm_pretty_printer$Pretty$string('{}') : A2($the_sett$elm_pretty_printer$Pretty$append, A2($the_sett$elm_pretty_printer$Pretty$nest, indent, A2($the_sett$elm_pretty_printer$Pretty$append, $ThinkAlexandria$elm_pretty_print_json$Json$Print$openBrace, A2($the_sett$elm_pretty_printer$Pretty$join, A2($the_sett$elm_pretty_printer$Pretty$append, $the_sett$elm_pretty_printer$Pretty$char(','), $the_sett$elm_pretty_printer$Pretty$line), A2($elm$core$List$map, function(_v0) {
            var key = _v0.a;
            var doc = _v0.b;
            return A2($the_sett$elm_pretty_printer$Pretty$append, $ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc(key), A2($the_sett$elm_pretty_printer$Pretty$append, $ThinkAlexandria$elm_pretty_print_json$Json$Print$colonSpace, doc));
        }, pairs)))), $ThinkAlexandria$elm_pretty_print_json$Json$Print$closeBrace);
    });
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc = function(indent) {
        return A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$nullToDoc, $elm$json$Json$Decode$maybe($elm$json$Json$Decode$oneOf(_List_fromArray([
            A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$stringToDoc, $elm$json$Json$Decode$string),
            A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$numberToDoc, $elm$json$Json$Decode$float),
            A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$boolToDoc, $elm$json$Json$Decode$bool),
            A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$listToDoc(indent), $elm$json$Json$Decode$lazy(function(_v0) {
                return $elm$json$Json$Decode$list($ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent));
            })),
            A2($elm$json$Json$Decode$map, $ThinkAlexandria$elm_pretty_print_json$Json$Print$objectToDoc(indent), $elm$json$Json$Decode$lazy(function(_v1) {
                return $elm$json$Json$Decode$keyValuePairs($ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent));
            }))
        ]))));
    };
    var $the_sett$elm_pretty_printer$Pretty$NLine = F3(function(a, b, c) {
        return {
            $: 2,
            a: a,
            b: b,
            c: c
        };
    });
    var $the_sett$elm_pretty_printer$Pretty$NNil = {
        $: 0
    };
    var $the_sett$elm_pretty_printer$Pretty$NText = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $the_sett$elm_pretty_printer$Pretty$fits = F2(function(w, normal) {
        fits: while(true){
            if (w < 0) return false;
            else switch(normal.$){
                case 0:
                    return true;
                case 1:
                    var text = normal.a;
                    var innerNormal = normal.b;
                    var $temp$w = w - $elm$core$String$length(text), $temp$normal = innerNormal(0);
                    w = $temp$w;
                    normal = $temp$normal;
                    continue fits;
                default:
                    return true;
            }
        }
    });
    var $the_sett$elm_pretty_printer$Pretty$better = F4(function(w, k, doc, doc2Fn) {
        return A2($the_sett$elm_pretty_printer$Pretty$fits, w - k, doc) ? doc : doc2Fn(0);
    });
    var $the_sett$elm_pretty_printer$Pretty$best = F3(function(width, startCol, x) {
        var be = F3(function(w, k, docs) {
            be: while(true){
                if (!docs.b) return $the_sett$elm_pretty_printer$Pretty$NNil;
                else switch(docs.a.b.$){
                    case 0:
                        var _v1 = docs.a;
                        var i = _v1.a;
                        var _v2 = _v1.b;
                        var ds = docs.b;
                        var $temp$w = w, $temp$k = k, $temp$docs = ds;
                        w = $temp$w;
                        k = $temp$k;
                        docs = $temp$docs;
                        continue be;
                    case 1:
                        var _v3 = docs.a;
                        var i = _v3.a;
                        var _v4 = _v3.b;
                        var doc = _v4.a;
                        var doc2 = _v4.b;
                        var ds = docs.b;
                        var $temp$w = w, $temp$k = k, $temp$docs = A2($elm$core$List$cons, _Utils_Tuple2(i, doc(0)), A2($elm$core$List$cons, _Utils_Tuple2(i, doc2(0)), ds));
                        w = $temp$w;
                        k = $temp$k;
                        docs = $temp$docs;
                        continue be;
                    case 2:
                        var _v5 = docs.a;
                        var i = _v5.a;
                        var _v6 = _v5.b;
                        var j = _v6.a;
                        var doc = _v6.b;
                        var ds = docs.b;
                        var $temp$w = w, $temp$k = k, $temp$docs = A2($elm$core$List$cons, _Utils_Tuple2(i + j, doc(0)), ds);
                        w = $temp$w;
                        k = $temp$k;
                        docs = $temp$docs;
                        continue be;
                    case 3:
                        var _v7 = docs.a;
                        var i = _v7.a;
                        var text = _v7.b.a;
                        var ds = docs.b;
                        return A2($the_sett$elm_pretty_printer$Pretty$NText, text, function(_v8) {
                            return A3(be, w, k + $elm$core$String$length(text), ds);
                        });
                    case 4:
                        var _v9 = docs.a;
                        var i = _v9.a;
                        var _v10 = _v9.b;
                        var vsep = _v10.b;
                        var ds = docs.b;
                        return A3($the_sett$elm_pretty_printer$Pretty$NLine, i, vsep, function(_v11) {
                            return A3(be, w, i + $elm$core$String$length(vsep), ds);
                        });
                    case 5:
                        var _v12 = docs.a;
                        var i = _v12.a;
                        var _v13 = _v12.b;
                        var doc = _v13.a;
                        var doc2 = _v13.b;
                        var ds = docs.b;
                        return A4($the_sett$elm_pretty_printer$Pretty$better, w, k, A3(be, w, k, A2($elm$core$List$cons, _Utils_Tuple2(i, doc), ds)), function(_v14) {
                            return A3(be, w, k, A2($elm$core$List$cons, _Utils_Tuple2(i, doc2), ds));
                        });
                    case 6:
                        var _v15 = docs.a;
                        var i = _v15.a;
                        var fn = _v15.b.a;
                        var ds = docs.b;
                        var $temp$w = w, $temp$k = k, $temp$docs = A2($elm$core$List$cons, _Utils_Tuple2(i, fn(i)), ds);
                        w = $temp$w;
                        k = $temp$k;
                        docs = $temp$docs;
                        continue be;
                    default:
                        var _v16 = docs.a;
                        var i = _v16.a;
                        var fn = _v16.b.a;
                        var ds = docs.b;
                        var $temp$w = w, $temp$k = k, $temp$docs = A2($elm$core$List$cons, _Utils_Tuple2(i, fn(k)), ds);
                        w = $temp$w;
                        k = $temp$k;
                        docs = $temp$docs;
                        continue be;
                }
            }
        });
        return A3(be, width, startCol, _List_fromArray([
            _Utils_Tuple2(0, x)
        ]));
    });
    var $the_sett$elm_pretty_printer$Pretty$copy = F2(function(i, s) {
        return !i ? '' : _Utils_ap(s, A2($the_sett$elm_pretty_printer$Pretty$copy, i - 1, s));
    });
    var $the_sett$elm_pretty_printer$Pretty$layout = function(normal) {
        var layoutInner = F2(function(normal2, acc) {
            layoutInner: while(true)switch(normal2.$){
                case 0:
                    return acc;
                case 1:
                    var text = normal2.a;
                    var innerNormal = normal2.b;
                    var $temp$normal2 = innerNormal(0), $temp$acc = A2($elm$core$List$cons, text, acc);
                    normal2 = $temp$normal2;
                    acc = $temp$acc;
                    continue layoutInner;
                default:
                    var i = normal2.a;
                    var sep = normal2.b;
                    var innerNormal = normal2.c;
                    var norm = innerNormal(0);
                    if (norm.$ === 2) {
                        var $temp$normal2 = innerNormal(0), $temp$acc = A2($elm$core$List$cons, '\n' + sep, acc);
                        normal2 = $temp$normal2;
                        acc = $temp$acc;
                        continue layoutInner;
                    } else {
                        var $temp$normal2 = innerNormal(0), $temp$acc = A2($elm$core$List$cons, '\n' + (A2($the_sett$elm_pretty_printer$Pretty$copy, i, ' ') + sep), acc);
                        normal2 = $temp$normal2;
                        acc = $temp$acc;
                        continue layoutInner;
                    }
            }
        });
        return $elm$core$String$concat($elm$core$List$reverse(A2(layoutInner, normal, _List_Nil)));
    };
    var $the_sett$elm_pretty_printer$Pretty$pretty = F2(function(w, doc) {
        return $the_sett$elm_pretty_printer$Pretty$layout(A3($the_sett$elm_pretty_printer$Pretty$best, w, 0, doc));
    });
    var $ThinkAlexandria$elm_pretty_print_json$Json$Print$prettyValue = F2(function(_v0, json) {
        var columns = _v0.LC;
        var indent = _v0.aeo;
        return A2($elm$core$Result$mapError, $elm$json$Json$Decode$errorToString, A2($elm$core$Result$map, $the_sett$elm_pretty_printer$Pretty$pretty(columns), A2($elm$json$Json$Decode$decodeValue, $ThinkAlexandria$elm_pretty_print_json$Json$Print$decodeDoc(indent), json)));
    });
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceProcessor = function(_v0) {
        var record = _v0;
        return record._G;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$sourceProcessor = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PaymentMethodMigration$Shared$sourceProcessor(shared);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$sourceProcessor = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$sourceProcessor(one);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$PaymentMethodMigration$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PaymentMethodMigration$Shared$status(shared);
    };
    var $author$project$Api$Provider$PaymentMethodMigration$All$status = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PaymentMethodMigration$One$status(one);
    };
    var $author$project$Api$Common$Payable$Owner$Min$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Pages$Admin$PaymentMethodImport$viewPaymentMethodImport = F3(function(canGoToPatients, canGoToCompany, paymentMethodMigration) {
        var owner = $author$project$Api$Provider$PaymentMethodMigration$All$owner(paymentMethodMigration);
        var ownerName = A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, owner));
        var ownerPath = A2($elm$core$Maybe$andThen, function(owner_) {
            var _v1 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
            switch(_v1){
                case 'Patient':
                    return canGoToPatients ? $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top({
                        V8: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
                    })) : $elm$core$Maybe$Nothing;
                case 'Company':
                    return canGoToCompany ? $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources({
                        fl: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
                    })) : $elm$core$Maybe$Nothing;
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }, owner);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    if (!ownerPath.$) {
                        var ownerPath_ = ownerPath.a;
                        return A3($author$project$Ui$Link$route, ownerPath_, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(ownerName)
                        ]));
                    } else return $elm$html$Html$text(ownerName);
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$PaymentMethodMigration$All$sourceProcessor(paymentMethodMigration))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$PaymentMethodMigration$All$migrationId(paymentMethodMigration)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$PaymentMethodMigration$All$sourceCustomerId(paymentMethodMigration)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$PaymentMethodMigration$All$sourcePaymentMethodId(paymentMethodMigration)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$PaymentMethodMigration$All$description(paymentMethodMigration)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$pre, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'max-width', '400px'),
                    A2($elm$html$Html$Attributes$style, 'max-height', '100px')
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Result$withDefault, '', A2($ThinkAlexandria$elm_pretty_print_json$Json$Print$prettyValue, {
                        LC: 10,
                        aeo: 2
                    }, $author$project$Api$Provider$PaymentMethodMigration$All$metadata(paymentMethodMigration))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$pull(1)
                ]), _List_fromArray([
                    $author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'missing_in_hint' || $author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'ignored' ? A3($author$project$Ui$Button$view, {
                        abP: 'Import payment method'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$PaymentMethodImport$Import(paymentMethodMigration)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Import')
                    ])) : $author$project$Utils$Html$empty,
                    $author$project$Api$Provider$PaymentMethodMigration$All$status(paymentMethodMigration) === 'missing_in_hint' ? A3($author$project$Ui$Button$view, {
                        abP: 'Ignore payment method'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$PaymentMethodImport$Ignore(paymentMethodMigration)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Ignore')
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$PaymentMethodImport$All = 0;
    var $author$project$Pages$Admin$PaymentMethodImport$Ignored = 3;
    var $author$project$Pages$Admin$PaymentMethodImport$Imported = 2;
    var $author$project$Pages$Admin$PaymentMethodImport$StatusFiltered = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel = function(option) {
        switch(option){
            case 1:
                return 'Pending';
            case 2:
                return 'Imported';
            case 3:
                return 'Ignored';
            default:
                return 'All';
        }
    };
    var $author$project$Pages$Admin$PaymentMethodImport$statusDropdownOptions = function(currentStatusOption) {
        var statusOptionToItem = function(option) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatusOption, option)),
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Admin$PaymentMethodImport$StatusFiltered(option))
            ]), $elm$html$Html$text($author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel(option)));
        };
        return A2($elm$core$List$cons, statusOptionToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, statusOptionToItem, _List_fromArray([
            1,
            2,
            3
        ]))));
    };
    var $author$project$Pages$Admin$PaymentMethodImport$viewStatusDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Pages$Admin$PaymentMethodImport$statusOptionToLabel(model.ahy))
        ]), $author$project$Pages$Admin$PaymentMethodImport$statusDropdownOptions(model.ahy), model.oD);
    };
    var $author$project$Pages$Admin$PaymentMethodImport$viewBody = function(model) {
        var _v0 = function() {
            var _v1 = model.ci;
            if (_v1.$ === 3) {
                var paymentMethodImports_ = _v1.a;
                return _Utils_Tuple2(false, paymentMethodImports_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var paymentMethodImports = _v0.b;
        return _List_fromArray([
            function() {
                var _v2 = model.iR;
                if (!_v2.$) {
                    var importModal = _v2.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Admin$PaymentMethodImport$ImportModalMsg, $author$project$Components$Admin$PaymentMethodImport$ImportModal$view(importModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.d8;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var paymentMethodMigration = _v4.a;
                    var ignoreRequest = _v4.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$PaymentMethodImport$IgnoreHiConfirmClosed(paymentMethodMigration), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('ignore'),
                        $author$project$Components$HiConfirm$noun('payment method migration'),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(ignoreRequest, $author$project$Api$Data$Loading)),
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('You are about to ignore this payment method migration. You can review and import ignored payment methods later.')
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($elm$html$Html$map, $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, model.Ej, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.ci))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Payment Method Import')
                    ]))
                ])),
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(4)
                        ]), _List_fromArray([
                            $author$project$Pages$Admin$PaymentMethodImport$viewStatusDropdown(model)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A4($author$project$Ui$Table$view, _List_fromArray([
                        $author$project$Ui$Table$loading(loading),
                        $author$project$Ui$Table$zeroState(_List_fromArray([
                            $elm$html$Html$text('All payment methods are migrated to Hint Payments!')
                        ]))
                    ]), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$PaymentMethodImport$SortTable)), $author$project$Pages$Admin$PaymentMethodImport$paymentMethodImportsColumns), _List_fromArray([
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$pull(1)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Admin$PaymentMethodImport$ExportCsvMsg, $author$project$Components$ExportCsv$button),
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload, _List_fromArray([
                                    $author$project$Ui$Link$icon($author$project$Ui$Icon$upload),
                                    $author$project$Ui$Link$ariaLabel('Import from CSV')
                                ]), _List_Nil)
                            ]))
                        ]))
                    ])), A2($elm$core$List$map, A2($author$project$Pages$Admin$PaymentMethodImport$viewPaymentMethodImport, model.EF, model.EE), paymentMethodImports), _List_Nil)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Admin$PaymentMethodImport$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(loading)
                    ]), model.af_))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$PaymentMethodImport$view = function(model) {
        return {
            fb: $author$project$Pages$Admin$PaymentMethodImport$viewBody(model),
            $2: 'Admin | Payment Method Import'
        };
    };
    var $author$project$Pages$Admin$PaymentMethodImport$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$PaymentMethodImport$init,
        aeR: $author$project$Pages$Admin$PaymentMethodImport$load,
        ag3: $author$project$Pages$Admin$PaymentMethodImport$save,
        ahE: $author$project$Pages$Admin$PaymentMethodImport$subscriptions,
        aaO: $author$project$Pages$Admin$PaymentMethodImport$update,
        aid: $author$project$Pages$Admin$PaymentMethodImport$view
    });
    var $author$project$Api$Upload$Resource$PaymentMethodImport = 6;
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$UploadFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$init = F4(function(_v0, _v1, shared, _v2) {
        var _v3 = A4($author$project$Components$Upload$Form$init, shared.HO, shared.Ej, 6, $elm$core$Maybe$Nothing);
        var uploadForm = _v3.a;
        var uploadFormCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: uploadForm
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
    });
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Upload$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Upload$Form$update, model.Ej, subMsg, model.PU);
        var uploadForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: uploadForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsgs);
    });
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$viewBody = function(model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Upload Payment Method Imports')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__PaymentMethodImport, _List_Nil, _List_fromArray([
                            $author$project$Ui$Icon$cross(_List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$Upload$Form$view, model.Ej, model.PU))
            ])),
            A2($author$project$Ui$Panel$footer, _List_fromArray([
                $author$project$Ui$Element$justifyCenter
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__PaymentMethodImport, _List_fromArray([
                    $author$project$Ui$Link$buttonDefault
                ]), _List_fromArray([
                    $elm$html$Html$text('Back')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$Upload$Form$modal, model.Ej, model.PU)),
                $author$project$Pages$Admin$PaymentMethodImport$Upload$viewBody(model)
            ]),
            $2: 'Admin | Payment Method Import'
        };
    };
    var $author$project$Pages$Admin$PaymentMethodImport$Upload$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$PaymentMethodImport$Upload$init,
        aeR: $author$project$Pages$Admin$PaymentMethodImport$Upload$load,
        ag3: $author$project$Pages$Admin$PaymentMethodImport$Upload$save,
        ahE: $author$project$Pages$Admin$PaymentMethodImport$Upload$subscriptions,
        aaO: $author$project$Pages$Admin$PaymentMethodImport$Upload$update,
        aid: $author$project$Pages$Admin$PaymentMethodImport$Upload$view
    });
    var $author$project$Pages$Admin$PaymentProcessing$PaymentProcessingMsg = $elm$core$Basics$identity;
    var $author$project$Components$PaymentProcessing$CreateAccount = {
        $: 2
    };
    var $author$project$Components$PaymentProcessing$GotRainforestAccount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus = function(a) {
        return {
            $: 44,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$Loading = {
        $: 0
    };
    var $author$project$Components$PaymentProcessing$Model = $elm$core$Basics$identity;
    var $author$project$Components$PaymentProcessing$StripeConnecting = {
        $: 3
    };
    var $author$project$Api$Feature$StripeEmbeddedOnboarding = 28;
    var $author$project$Api$Provider$Practice$Shared$hasStripeAccount = function(_v0) {
        var record = _v0;
        return record.QB;
    };
    var $author$project$Api$Provider$Practice$One$hasStripeAccount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$hasStripeAccount(shared);
    };
    var $author$project$Api$Provider$Practice$StripeAccount$OnboardingStatus = F2(function(detailsSubmitted, clientSecret) {
        return {
            acr: clientSecret,
            ac6: detailsSubmitted
        };
    });
    var $author$project$Api$Provider$Practice$StripeAccount$onboardingStatusDecoder = A3($elm$json$Json$Decode$map2, $author$project$Api$Provider$Practice$StripeAccount$OnboardingStatus, A2($elm$json$Json$Decode$field, 'details_submitted', $elm$json$Json$Decode$bool), $elm$json$Json$Decode$maybe(A2($elm$json$Json$Decode$field, 'client_secret', $elm$json$Json$Decode$string)));
    var $author$project$Api$Provider$Practice$StripeAccount$onboardingStatus = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$StripeAccount$onboardingStatusDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'onboarding_status'
        ]), $author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
    });
    var $author$project$Api$Provider$RainforestAccount$One$RainforestAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$RainforestAccount$Shared$RainforestAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$RainforestAccount$Shared$Record = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Provider$RainforestAccount$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$Shared$Record));
    var $author$project$Api$Provider$RainforestAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RainforestAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$RainforestAccount$One$Record = function(merchantId) {
        return function(merchantApplicationId) {
            return function(merchantApplicationStatus) {
                return function(statementDescriptor) {
                    return function(depositAccountLast4) {
                        return function(depositAccountRoutingNumber) {
                            return function(depositAccountBankName) {
                                return function(depositAccountAccountType) {
                                    return function(platformTokenMigrationCompletedAt) {
                                        return function(depositFrequency) {
                                            return {
                                                NM: depositAccountAccountType,
                                                NN: depositAccountBankName,
                                                NO: depositAccountLast4,
                                                NP: depositAccountRoutingNumber,
                                                ac4: depositFrequency,
                                                T9: merchantApplicationId,
                                                Ua: merchantApplicationStatus,
                                                Ub: merchantId,
                                                WQ: platformTokenMigrationCompletedAt,
                                                _5: statementDescriptor
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$RainforestAccount$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_frequency', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'platform_token_migration_completed_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_account_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_bank_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_routing_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_last_4', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'statement_descriptor', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'merchant_application_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'merchant_application_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'merchant_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$One$Record)))))))))));
    var $author$project$Api$Provider$RainforestAccount$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RainforestAccount$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RainforestAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$RainforestAccount$One$RainforestAccount)));
    var $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'rainforest_account'
    ]), $author$project$Api$Provider$Practice$practicePath);
    var $author$project$Api$Provider$Practice$RainforestAccount$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
    });
    var $author$project$Components$PaymentProcessing$GotBankAccountsOnStripe = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$StripePaymentMethodMigration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$Record = function(id) {
        return function(type_) {
            return function(sourceBrand) {
                return function(lastFour) {
                    return function(isDefault) {
                        return function(lastUsedAt) {
                            return function(requestPayInfoSentAt) {
                                return function(owner) {
                                    return function(createdAt) {
                                        return function(label) {
                                            return function(name) {
                                                return function(expMonth) {
                                                    return function(expYear) {
                                                        return function(errorMessage) {
                                                            return function(lastPaymentErrorMessage) {
                                                                return function(zip) {
                                                                    return function(createdVia) {
                                                                        return function(status) {
                                                                            return function(createdByName) {
                                                                                return function(funding) {
                                                                                    return function(paymentProcessor) {
                                                                                        return {
                                                                                            Mx: createdAt,
                                                                                            Mz: createdByName,
                                                                                            MA: createdVia,
                                                                                            O4: errorMessage,
                                                                                            adz: expMonth,
                                                                                            adA: expYear,
                                                                                            P1: funding,
                                                                                            aef: id,
                                                                                            R0: isDefault,
                                                                                            aeI: label,
                                                                                            ST: lastFour,
                                                                                            SV: lastPaymentErrorMessage,
                                                                                            S$: lastUsedAt,
                                                                                            zr: name,
                                                                                            VM: owner,
                                                                                            Wo: paymentProcessor,
                                                                                            YF: requestPayInfoSentAt,
                                                                                            _D: sourceBrand,
                                                                                            ahy: status,
                                                                                            ah5: type_,
                                                                                            tK: zip
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'funding', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_by_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_via', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'zip', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_payment_error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exp_year', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'exp_month', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_pay_info_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_used_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_default', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_four', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_method_brand', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$StripePaymentMethodMigration$All$Record))))))))))))))))))))));
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$StripePaymentMethodMigration$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$StripePaymentMethodMigration$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$StripePaymentMethodMigration$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'stripe_payment_method_migrations'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$StripePaymentMethodMigration$bankAccounts = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$StripePaymentMethodMigration$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bank_accounts'
        ]), $author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
    });
    var $author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe = F2(function(apiClient, model) {
        var optionals = function(d) {
            return _Utils_update(d, {
                af_: model.e9,
                ahs: model.ld
            });
        };
        return A3($author$project$Api$Provider$StripePaymentMethodMigration$bankAccounts, apiClient, optionals, $author$project$Components$PaymentProcessing$GotBankAccountsOnStripe);
    });
    var $author$project$Components$PaymentProcessing$GotCardsOnStripe = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$cards = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$StripePaymentMethodMigration$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$StripePaymentMethodMigration$listOptionsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cards'
        ]), $author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
    });
    var $author$project$Components$PaymentProcessing$retrieveCardsOnStripe = F2(function(apiClient, model) {
        var optionals = function(d) {
            return _Utils_update(d, {
                af_: model.ff,
                ahs: model.lr
            });
        };
        return A3($author$project$Api$Provider$StripePaymentMethodMigration$cards, apiClient, optionals, $author$project$Components$PaymentProcessing$GotCardsOnStripe);
    });
    var $author$project$Components$PaymentProcessing$init = F5(function(session, practice, shared, _v0, _v1) {
        var isOnboarding = _v1.aK;
        var isStripeEmbedded = A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice);
        var _v2 = isStripeEmbedded ? $author$project$Api$Provider$Practice$One$hasStripeAccount(practice) ? _Utils_Tuple2($author$project$Components$PaymentProcessing$StripeConnecting, A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, shared.Ej, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus)) : _Utils_Tuple2($author$project$Components$PaymentProcessing$CreateAccount, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Components$PaymentProcessing$Loading, A2($author$project$Api$Provider$Practice$RainforestAccount$retrieve, shared.Ej, $author$project$Components$PaymentProcessing$GotRainforestAccount));
        var initialStatus = _v2.a;
        var initialCmd = _v2.b;
        var model = {
            cC: $author$project$Api$Data$Loading,
            e9: $author$project$Api$Pagination$init,
            ld: A3($author$project$Api$Sort$withDefault, 'last_used_at', 1, $author$project$Api$Sort$init),
            EE: A3($author$project$Permission$canGoTo, session, shared.aeb, 17),
            EF: A3($author$project$Permission$canGoTo, session, shared.aeb, 44),
            cJ: $author$project$Api$Data$Loading,
            ff: $author$project$Api$Pagination$init,
            lr: A3($author$project$Api$Sort$withDefault, 'last_used_at', 1, $author$project$Api$Sort$init),
            dK: $elm$core$Maybe$Nothing,
            fr: $author$project$Api$Data$NotAsked,
            dV: $elm$core$Maybe$Nothing,
            l7: $author$project$Api$Data$NotAsked,
            qW: shared.qW,
            F3: $author$project$Shared$isHintAdmin(shared),
            aK: isOnboarding,
            y4: false,
            jf: $elm$core$Maybe$Nothing,
            W1: practice,
            cn: $author$project$Api$Data$Loading,
            BC: $author$project$Rainforest$isSandbox(shared.sp),
            ey: $elm$core$Maybe$Nothing,
            ez: $elm$core$Maybe$Nothing,
            jT: $elm$core$Maybe$Nothing,
            n6: $author$project$Api$Data$NotAsked,
            Z$: session,
            Ct: $elm$core$Maybe$Nothing,
            sW: true,
            kd: $elm$core$Maybe$Nothing,
            ahy: initialStatus,
            gZ: false,
            oJ: $author$project$Api$Data$NotAsked,
            HO: shared.HO,
            o2: $author$project$Api$Data$NotAsked,
            aaX: $author$project$Api$Platform$Session$One$user(session)
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            initialCmd,
            A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, shared.Ej, model),
            A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, shared.Ej, model)
        ])));
    });
    var $author$project$Pages$Admin$PaymentProcessing$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$PaymentProcessing$init, session, practice, shared, query, {
            aK: false
        });
        var paymentProcessing = _v1.a;
        var paymentProcessingCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            F3: $author$project$Shared$isHintAdmin(shared),
            ns: paymentProcessing
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentProcessingCmd));
    });
    var $author$project$Pages$Admin$PaymentProcessing$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$PaymentProcessing$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$PaymentProcessing$DeleteHiConfirmClosed = F3(function(a, b, c) {
        return {
            $: 22,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg = function(a) {
        return {
            $: 39,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed = F3(function(a, b, c) {
        return {
            $: 24,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$PaymentProcessing$ResetAccountModalMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$StripeHiConfirmClosed = function(a) {
        return {
            $: 48,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$StripeOnboardingExited = {
        $: 45
    };
    var $author$project$Components$PaymentProcessing$StripeOnboardingStepChanged = {
        $: 46
    };
    var $author$project$Ports$Stripe$stripePortOnboardingExited = _Platform_incomingPort('stripePortOnboardingExited', $elm$json$Json$Decode$null(0));
    var $author$project$Ports$Stripe$onOnboardingExited = function(msg) {
        return $author$project$Ports$Stripe$stripePortOnboardingExited($elm$core$Basics$always(msg));
    };
    var $author$project$Ports$Stripe$stripePortOnboardingStepChanged = _Platform_incomingPort('stripePortOnboardingStepChanged', $elm$json$Json$Decode$null(0));
    var $author$project$Ports$Stripe$onOnboardingStepChanged = function(msg) {
        return $author$project$Ports$Stripe$stripePortOnboardingStepChanged($elm$core$Basics$always(msg));
    };
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal);
    };
    var $author$project$Components$Rainforest$ResetAccountModal$Close = {
        $: 0
    };
    var $author$project$Components$Rainforest$ResetAccountModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$ResetAccountModal$Close);
    };
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$Close = {
        $: 0
    };
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Rainforest$SimulateApplicationEventModal$Close);
    };
    var $author$project$Components$PaymentProcessing$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg)), model.kd)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$ResetAccountModal$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$ResetAccountModalMsg)), model.jT)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v1) {
                var deletingPaymentMethodType = _v1.a;
                var deletingPaymentMethod = _v1.b;
                return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(A2($author$project$Components$PaymentProcessing$DeleteHiConfirmClosed, deletingPaymentMethodType, deletingPaymentMethod));
            }, model.dV)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v2) {
                var requestingUpdatePaymentMethodType = _v2.a;
                var requestingUpdatePaymentMethod = _v2.b;
                return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(A2($author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed, requestingUpdatePaymentMethodType, requestingUpdatePaymentMethod));
            }, model.ez)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$MigrateBackToStripeModal$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg)), model.jf)),
            function() {
                var _v3 = model.ahy;
                if (_v3.$ === 4) return $elm$core$Platform$Sub$batch(_List_fromArray([
                    $author$project$Ports$Stripe$onOnboardingExited($author$project$Components$PaymentProcessing$StripeOnboardingExited),
                    $author$project$Ports$Stripe$onOnboardingStepChanged($author$project$Components$PaymentProcessing$StripeOnboardingStepChanged)
                ]));
                else return $elm$core$Platform$Sub$none;
            }(),
            model.gZ ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$PaymentProcessing$StripeHiConfirmClosed) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Pages$Admin$PaymentProcessing$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$PaymentProcessing$subscriptions(model.ns));
    };
    var $author$project$Components$PaymentProcessing$Deleted = F3(function(a, b, c) {
        return {
            $: 21,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$PaymentProcessing$DeletedAll = F2(function(a, b) {
        return {
            $: 28,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentProcessing$DepositFrequencyUpdated = function(a) {
        return {
            $: 41,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$GotConnectedToStripe = function(a) {
        return {
            $: 43,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$GotDeleteRainforestAccount = function(a) {
        return {
            $: 37,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$GotPractice = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$GotRainforestAccountCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$GotRainforestAccountEnabled = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$GotRunPlatformMigration = function(a) {
        return {
            $: 35,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$HasRainforestAccountAccount = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$PaymentInfoUpdated = F3(function(a, b, c) {
        return {
            $: 25,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$PaymentProcessing$RequestedPaymentInfoUpdateAll = F2(function(a, b) {
        return {
            $: 31,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentProcessing$StripeConnected = {
        $: 5
    };
    var $author$project$Components$PaymentProcessing$StripeDisconnected = function(a) {
        return {
            $: 49,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$StripeEmbeddedOnboarding = {
        $: 4
    };
    var $author$project$Components$PaymentProcessing$Synced = function(a) {
        return {
            $: 33,
            a: a
        };
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$bulkDelete = F3(function(apiClient, paymentMethodType, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment_method_type', $elm$json$Json$Encode$string(paymentMethodType))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bulk_delete'
        ]), $author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
    });
    var $author$project$Api$Provider$StripePaymentMethodMigration$bulkRequestPayInfoUpdate = F3(function(apiClient, paymentMethodType, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment_method_type', $elm$json$Json$Encode$string(paymentMethodType))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bulk_request_pay_info'
        ]), $author$project$Api$Provider$StripePaymentMethodMigration$stripePaymentMethodMigrationsPath))));
    });
    var $author$project$Components$PaymentProcessing$PracticeOnboardingUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$complete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'complete'
        ]), $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
    });
    var $author$project$Components$PaymentProcessing$completeSetup = F2(function(apiClient, practice) {
        var onboardId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$Shared$id, $author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
        return A3($author$project$Api$Provider$PracticeOnboarding$complete, apiClient, onboardId, $author$project$Components$PaymentProcessing$PracticeOnboardingUpdated);
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
    });
    var $author$project$Api$Provider$Practice$StripeAccount$createAccount = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath));
    });
    var $author$project$Api$Provider$BankAccount$bankAccountPath = F2(function(basePath, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$BankAccount$bankAccountsPath(basePath));
    });
    var $author$project$Api$Provider$BankAccount$delete = F4(function(basePath, apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)));
    });
    var $author$project$Api$Provider$Card$cardPath = F2(function(basePath, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Card$cardsPath(basePath));
    });
    var $author$project$Api$Provider$Card$delete = F4(function(basePath, apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Card$cardPath, basePath, id_)));
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$delete = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath));
    });
    var $author$project$Api$Provider$Practice$StripeAccount$disconnect = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'disconnect'
        ]), $author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$enable = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enable'
        ]), $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$init = {
        m7: $author$project$Api$Data$NotAsked,
        rr: false
    };
    var $author$project$Components$Rainforest$ResetAccountModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Rainforest$ResetAccountModal$init = function(reset) {
        return _Utils_Tuple2({
            je: $elm$core$Maybe$Nothing,
            su: $author$project$Api$Data$NotAsked,
            Hf: reset
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus = 'COMPLETED';
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$reviewTypes = _List_fromArray([
        'BUSINESS_NAME_TIN',
        'BUSINESS_VERIFICATION',
        'FINANCIAL_1',
        'FINANCIAL_2',
        'DEPOSIT_METHOD_1',
        'OWNER_1_NAME_SSN',
        'OWNER_2_NAME_SSN',
        'OWNER_3_NAME_SSN',
        'OWNER_4_NAME_SSN'
    ]);
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$init = function(simulateStatusChange) {
        return _Utils_Tuple2({
            su: $author$project$Api$Data$NotAsked,
            n2: $elm$core$Dict$fromList(A2($elm$core$List$map, function(reviewType) {
                return _Utils_Tuple2(reviewType, false);
            }, $author$project$Components$Rainforest$SimulateApplicationEventModal$reviewTypes)),
            Ht: simulateStatusChange,
            ahy: $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Ports$Stripe$stripePortMountAccountOnboardingComponent = _Platform_outgoingPort('stripePortMountAccountOnboardingComponent', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('selector', $elm$json$Json$Encode$string($.bi)),
            _Utils_Tuple2('stripeClientSecret', $elm$json$Json$Encode$string($.oF))
        ]));
    });
    var $author$project$Ports$Stripe$mountAccountOnboardingComponent = F2(function(selector, stripeClientSecret) {
        return $author$project$Ports$Stripe$stripePortMountAccountOnboardingComponent({
            bi: selector,
            oF: stripeClientSecret
        });
    });
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$owner = function(_v0) {
        var record = _v0;
        return record.VM;
    };
    var $author$project$Components$PaymentProcessing$PrefilledWithFakeData = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$RainforestAccount$fakePrefill = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'fake_prefill'
        ]), $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Components$PaymentProcessing$prefillWithFakeData = function(apiClient) {
        return A2($author$project$Api$Provider$Practice$RainforestAccount$fakePrefill, apiClient, $author$project$Components$PaymentProcessing$PrefilledWithFakeData);
    };
    var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$RequestPaymentInfo = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$Record = function(requestPayInfoSentAt) {
        return {
            YF: requestPayInfoSentAt
        };
    };
    var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_pay_info_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$RequestPaymentInfoOne$Record));
    var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$RequestPaymentInfoOne$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$requestPaymentInfo = F4(function(apiClient, id_, replacesPaymentMethodId, toMsg) {
        var body = $elm$json$Json$Encode$object(function() {
            if (!replacesPaymentMethodId.$) {
                var replacesPaymentMethodId_ = replacesPaymentMethodId.a;
                return _List_fromArray([
                    _Utils_Tuple2('replaces_payment_method_id', $elm$json$Json$Encode$string(replacesPaymentMethodId_))
                ]);
            } else return _List_Nil;
        }());
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$RequestPaymentInfoOne$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'request_payment_info'
        ]), $author$project$Api$Provider$Patient$patientPath(id_)))));
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$reset = F3(function(apiClient, merchantName, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('merchant_name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, merchantName))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reset'
        ]), $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
    });
    var $author$project$Api$Provider$Practice$expandToString = function(expand) {
        if (!expand) return 'signup_settings';
        else return 'default_plan';
    };
    var $author$project$Api$Provider$Practice$retrieveDefaults = {
        Fq: _List_Nil
    };
    var $author$project$Api$Provider$Practice$retrieveOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Practice$retrieveDefaults);
        return _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Practice$expandToString, options.Fq))
        ]);
    };
    var $author$project$Api$Provider$Practice$retrieve = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Practice$retrieveOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Components$PaymentProcessing$GotSetupSessionKey = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$RainforestAccount$One$record = function(_v0) {
        var record_ = _v0.b;
        return record_;
    };
    var $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.Ua;
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$setup = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, A2($elm$json$Json$Decode$field, 'session_key', $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'setup'
        ]), $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Components$PaymentProcessing$retrieveSetupSessionKey = F2(function(apiClient, rainforestAccount) {
        return $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount) !== 'completed' ? A2($author$project$Api$Provider$Practice$RainforestAccount$setup, apiClient, $author$project$Components$PaymentProcessing$GotSetupSessionKey) : $elm$core$Platform$Cmd$none;
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$runPlatformMigration = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'run_platform_migration'
        ]), $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$simulateStatusChange = F4(function(apiClient, status, reviewTypes, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('status', $elm$json$Json$Encode$string(status)),
            _Utils_Tuple2('review_types', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, reviewTypes))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'simulate_status_change'
        ]), $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$sync = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'sync'
        ]), $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Api$Provider$Practice$RainforestAccount$update = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('rainforest_account', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('deposit_frequency', $elm$json$Json$Encode$string(fields.ac4))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$Closed = 2;
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$GotMigrateBackToStripeResponse = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigratedBackToStripe = 1;
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$None = 0;
    var $author$project$Api$Provider$Practice$RainforestAccount$migrateBackToStripe = F3(function(apiClient, migratePaymentMethods, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('migrate_payment_methods', $elm$json$Json$Encode$bool(migratePaymentMethods))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RainforestAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'migrate_back_to_stripe'
        ]), $author$project$Api$Provider$Practice$RainforestAccount$rainforestAccountPath))));
    });
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var migratePaymentMethods = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        rr: migratePaymentMethods
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: A3($author$project$Api$Provider$Practice$RainforestAccount$migrateBackToStripe, apiClient, model.rr, $author$project$Components$Rainforest$MigrateBackToStripeModal$GotMigrateBackToStripeResponse),
                    adu: 0,
                    zi: _Utils_update(model, {
                        m7: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        m7: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Reverted to Stripe successfully')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        m7: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Rainforest$ResetAccountModal$Closed = {
        $: 1
    };
    var $author$project$Components$Rainforest$ResetAccountModal$GotReset = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Rainforest$ResetAccountModal$None = {
        $: 0
    };
    var $author$project$Components$Rainforest$ResetAccountModal$Reseted = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Rainforest$ResetAccountModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                var string = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Rainforest$ResetAccountModal$None,
                    zi: _Utils_update(model, {
                        je: $author$project$Utils$String$toMaybe(string)
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: A3(model.Hf, apiClient, model.je, $author$project$Components$Rainforest$ResetAccountModal$GotReset),
                    adu: $author$project$Components$Rainforest$ResetAccountModal$None,
                    zi: _Utils_update(model, {
                        su: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var rainforestAccount = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: A2($author$project$Components$Rainforest$ResetAccountModal$Reseted, rainforestAccount, response),
                        zi: _Utils_update(model, {
                            su: response
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Application Status Changed')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Rainforest$ResetAccountModal$None,
                    zi: _Utils_update(model, {
                        su: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Rainforest$ResetAccountModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$Closed = 1;
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$GotSimulate = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$None = 0;
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$Simulated = 2;
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$statuses = _List_fromArray([
        'COMPLETED',
        'DECLINED',
        'NEEDS_INFORMATION'
    ]);
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                var inputStatus = msg.a;
                var selectedStatus = A2($elm_community$list_extra$List$Extra$find, function(status_) {
                    return _Utils_eq(status_, inputStatus);
                }, $author$project$Components$Rainforest$SimulateApplicationEventModal$statuses);
                var status = A2($elm$core$Maybe$withDefault, $author$project$Components$Rainforest$SimulateApplicationEventModal$defaultStatus, selectedStatus);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ahy: status
                    }),
                    at: _List_Nil
                };
            case 2:
                var reviewType = msg.a;
                var value = msg.b;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        n2: A3($elm$core$Dict$insert, reviewType, value, model.n2)
                    }),
                    at: _List_Nil
                };
            case 3:
                var reviewTypes_ = function() {
                    var _v2 = model.ahy;
                    if (_v2 === 'NEEDS_INFORMATION') return A2($elm$core$List$filterMap, function(_v3) {
                        var reviewType = _v3.a;
                        var value = _v3.b;
                        return value ? $elm$core$Maybe$Just(reviewType) : $elm$core$Maybe$Nothing;
                    }, $elm$core$Dict$toList(model.n2));
                    else return _List_Nil;
                }();
                return {
                    EQ: A4(model.Ht, apiClient, model.ahy, reviewTypes_, $author$project$Components$Rainforest$SimulateApplicationEventModal$GotSimulate),
                    adu: 0,
                    zi: _Utils_update(model, {
                        su: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        su: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Application Status Changed')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        su: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$PaymentProcessing$update = F3(function(msg, _v0, apiClient) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v2$2: while(true)switch(response.$){
                    case 3:
                        var rainforestAccount = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            cn: response,
                            ahy: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
                        }), A2($author$project$Components$PaymentProcessing$retrieveSetupSessionKey, apiClient, rainforestAccount), _List_fromArray([
                            $author$project$OutMsg$RefreshPractice
                        ]));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v3 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                ahy: $author$project$Components$PaymentProcessing$CreateAccount
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v2$2;
                    default:
                        break _v2$2;
                }
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    ahy: $author$project$Components$PaymentProcessing$Loading
                }), A2($author$project$Api$Provider$Practice$RainforestAccount$create, apiClient, $author$project$Components$PaymentProcessing$GotRainforestAccountCreated), _List_Nil);
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var rainforestAccount = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cn: response,
                        ahy: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
                    }), A2($author$project$Components$PaymentProcessing$retrieveSetupSessionKey, apiClient, rainforestAccount), _List_fromArray([
                        $author$project$OutMsg$RefreshPractice
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ahy: $author$project$Components$PaymentProcessing$CreateAccount
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var sessionKey = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Ct: $elm$core$Maybe$Just(sessionKey)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                return _Utils_Tuple3(model, A2($author$project$Components$PaymentProcessing$completeSetup, apiClient, model.W1), _List_Nil);
            case 6:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    y4: true
                }), model.aK ? $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete),
                    A2($author$project$Components$PaymentProcessing$completeSetup, apiClient, model.W1)
                ])) : $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Payment Processing Application submited')
                ]));
            case 10:
                var _v7 = $author$project$Components$Rainforest$SimulateApplicationEventModal$init($author$project$Api$Provider$Practice$RainforestAccount$simulateStatusChange);
                var simulateApplicationEventModal = _v7.a;
                var simulateApplicationEventModalCmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    kd: $elm$core$Maybe$Just(simulateApplicationEventModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg, simulateApplicationEventModalCmd), _List_Nil);
            case 11:
                var simulateApplicationEventModalMsg = msg.a;
                var _v8 = model.kd;
                if (!_v8.$) {
                    var simulateApplicationEventModal = _v8.a;
                    var simulateApplicationEventModalResult = A3($author$project$Components$Rainforest$SimulateApplicationEventModal$update, apiClient, simulateApplicationEventModalMsg, simulateApplicationEventModal);
                    var simulateApplicationEventModal_ = function() {
                        var _v9 = simulateApplicationEventModalResult.adu;
                        switch(_v9){
                            case 1:
                                return $elm$core$Maybe$Nothing;
                            case 2:
                                return $elm$core$Maybe$Nothing;
                            default:
                                return $elm$core$Maybe$Just(simulateApplicationEventModalResult.zi);
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        kd: simulateApplicationEventModal_
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg, simulateApplicationEventModalResult.EQ), simulateApplicationEventModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var _v10 = $author$project$Components$Rainforest$ResetAccountModal$init($author$project$Api$Provider$Practice$RainforestAccount$reset);
                var resetAccountModal = _v10.a;
                var resetAccountModalCmd = _v10.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    jT: $elm$core$Maybe$Just(resetAccountModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$ResetAccountModalMsg, resetAccountModalCmd), _List_Nil);
            case 13:
                var resetAccountModalMsg = msg.a;
                var _v11 = model.jT;
                if (!_v11.$) {
                    var resetAccountModal = _v11.a;
                    var resetAccountModalResult = A3($author$project$Components$Rainforest$ResetAccountModal$update, apiClient, resetAccountModalMsg, resetAccountModal);
                    var _v12 = function() {
                        var _v13 = resetAccountModalResult.adu;
                        switch(_v13.$){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ahy, model.cn);
                            case 2:
                                var rainforestAccount_ = _v13.a;
                                var rainforestAccountResponse = _v13.b;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount_), rainforestAccountResponse);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Just(resetAccountModalResult.zi), model.ahy, model.cn);
                        }
                    }();
                    var resetAccountModal_ = _v12.a;
                    var status = _v12.b;
                    var rainforestAccount = _v12.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cn: rainforestAccount,
                        jT: resetAccountModal_,
                        ahy: status
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$ResetAccountModalMsg, resetAccountModalResult.EQ), resetAccountModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    l7: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Practice$RainforestAccount$enable, apiClient, $author$project$Components$PaymentProcessing$GotRainforestAccountEnabled), _List_Nil);
            case 8:
                var response = msg.a;
                if (response.$ === 3) {
                    var rainforestAccount = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        l7: $author$project$Api$Data$NotAsked,
                        cn: response,
                        ahy: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
                    }), A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Components$PaymentProcessing$GotPractice), _List_fromArray([
                        $author$project$OutMsg$RefreshPractice,
                        A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account enabled')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    l7: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        W1: practice
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                return _Utils_Tuple3(model, $author$project$Components$PaymentProcessing$prefillWithFakeData(apiClient), _List_Nil);
            case 15:
                var response = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 17:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cC: response,
                        e9: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.e9)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cC: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 16:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cJ: response,
                        ff: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.ff)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 18:
                var paymentMethodType = msg.a;
                var subMsg = msg.b;
                var newModel = function() {
                    if (!paymentMethodType) return _Utils_update(model, {
                        ff: A2($author$project$Api$Pagination$update, subMsg, model.ff)
                    });
                    else return _Utils_update(model, {
                        e9: A2($author$project$Api$Pagination$update, subMsg, model.e9)
                    });
                }();
                return _Utils_Tuple3(newModel, function() {
                    if (!paymentMethodType) return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
                    else return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
                }(), _List_Nil);
            case 19:
                var paymentMethodType = msg.a;
                var columnId = msg.b;
                var newModel = function() {
                    if (!paymentMethodType) return _Utils_update(model, {
                        lr: A2($author$project$Api$Sort$update, columnId, model.lr)
                    });
                    else return _Utils_update(model, {
                        ld: A2($author$project$Api$Sort$update, columnId, model.ld)
                    });
                }();
                return _Utils_Tuple3(newModel, function() {
                    if (!paymentMethodType) return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
                    else return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
                }(), _List_Nil);
            case 20:
                var paymentMethodType = msg.a;
                var paymentMethod = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    dV: $elm$core$Maybe$Just(_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 22:
                var paymentMethodType = msg.a;
                var paymentMethod = msg.b;
                var confirmed = msg.c;
                if (confirmed) {
                    var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
                    var ownerPath = A2($elm$core$Maybe$andThen, function(owner_) {
                        var _v25 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
                        switch(_v25){
                            case 'Patient':
                                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$patientPath($author$project$Api$Common$Payable$Owner$Min$id(owner_)));
                            case 'Company':
                                return $elm$core$Maybe$Just($author$project$Api$Provider$Company$companyPath($author$project$Api$Common$Payable$Owner$Min$id(owner_)));
                            default:
                                return $elm$core$Maybe$Nothing;
                        }
                    }, owner);
                    var id = $author$project$Api$Provider$StripePaymentMethodMigration$All$id(paymentMethod);
                    return _Utils_Tuple3(_Utils_update(model, {
                        dV: $elm$core$Maybe$Just(_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$Loading))
                    }), function() {
                        var _v22 = _Utils_Tuple2(ownerPath, paymentMethodType);
                        if (!_v22.a.$) {
                            if (!_v22.b) {
                                var ownerPath_ = _v22.a.a;
                                var _v23 = _v22.b;
                                return A4($author$project$Api$Provider$Card$delete, ownerPath_, apiClient, id, A2($author$project$Components$PaymentProcessing$Deleted, paymentMethodType, paymentMethod));
                            } else {
                                var ownerPath_ = _v22.a.a;
                                var _v24 = _v22.b;
                                return A4($author$project$Api$Provider$BankAccount$delete, ownerPath_, apiClient, id, A2($author$project$Components$PaymentProcessing$Deleted, paymentMethodType, paymentMethod));
                            }
                        } else return $elm$core$Platform$Cmd$none;
                    }(), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    dV: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 21:
                var paymentMethodType = msg.a;
                var paymentMethod = msg.b;
                var response = msg.c;
                if (response.$ === 3) {
                    var newModel = function() {
                        if (!paymentMethodType) return _Utils_update(model, {
                            cJ: $author$project$Api$Data$Loading
                        });
                        else return _Utils_update(model, {
                            cC: $author$project$Api$Data$Loading
                        });
                    }();
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        dV: $elm$core$Maybe$Nothing
                    }), function() {
                        if (!paymentMethodType) return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
                        else return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
                    }(), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Payment method was successfully removed.')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    dV: $elm$core$Maybe$Just(_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 23:
                var paymentMethodType = msg.a;
                var paymentMethod = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ez: $elm$core$Maybe$Just(_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 24:
                var paymentMethodType = msg.a;
                var paymentMethod = msg.b;
                var confirmed = msg.c;
                if (confirmed) {
                    var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
                    return _Utils_Tuple3(_Utils_update(model, {
                        ez: $elm$core$Maybe$Just(_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$Loading))
                    }), A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(owner_) {
                        var _v29 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
                        switch(_v29){
                            case 'Patient':
                                var id = $author$project$Api$Provider$StripePaymentMethodMigration$All$id(paymentMethod);
                                return A4($author$project$Api$Provider$Patient$requestPaymentInfo, apiClient, $author$project$Api$Common$Payable$Owner$Min$id(owner_), $elm$core$Maybe$Just(id), A2($author$project$Components$PaymentProcessing$PaymentInfoUpdated, paymentMethodType, paymentMethod));
                            case 'Company':
                                return $elm$core$Platform$Cmd$none;
                            default:
                                return $elm$core$Platform$Cmd$none;
                        }
                    }, owner)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ez: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 25:
                var paymentMethodType = msg.a;
                var paymentMethod = msg.b;
                var response = msg.c;
                if (response.$ === 3) {
                    var newModel = function() {
                        if (!paymentMethodType) return _Utils_update(model, {
                            cJ: $author$project$Api$Data$Loading
                        });
                        else return _Utils_update(model, {
                            cC: $author$project$Api$Data$Loading
                        });
                    }();
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        ez: $elm$core$Maybe$Nothing
                    }), function() {
                        if (!paymentMethodType) return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, newModel);
                        else return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, newModel);
                    }(), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Request to update payment method was successfully sent.')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ez: $elm$core$Maybe$Just(_Utils_Tuple3(paymentMethodType, paymentMethod, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 26:
                var paymentMethodType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    dK: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 27:
                var paymentMethodType = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var paymentMethodType_ = function() {
                        if (!paymentMethodType) return 'card';
                        else return 'bank_account';
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        dK: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$Loading))
                    }), A3($author$project$Api$Provider$StripePaymentMethodMigration$bulkDelete, apiClient, paymentMethodType_, $author$project$Components$PaymentProcessing$DeletedAll(paymentMethodType)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    dK: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 28:
                var paymentMethodType = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var newModel = function() {
                        if (!paymentMethodType) return _Utils_update(model, {
                            cJ: $author$project$Api$Data$Loading
                        });
                        else return _Utils_update(model, {
                            cC: $author$project$Api$Data$Loading
                        });
                    }();
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        dK: $elm$core$Maybe$Nothing
                    }), function() {
                        if (!paymentMethodType) return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
                        else return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
                    }(), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Deleting all payment methods . This may take a couple moments...')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    dK: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 29:
                var paymentMethodType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ey: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 30:
                var paymentMethodType = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var paymentMethodType_ = function() {
                        if (!paymentMethodType) return 'card';
                        else return 'bank_account';
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        ey: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$Loading))
                    }), A3($author$project$Api$Provider$StripePaymentMethodMigration$bulkRequestPayInfoUpdate, apiClient, paymentMethodType_, $author$project$Components$PaymentProcessing$RequestedPaymentInfoUpdateAll(paymentMethodType)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ey: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 31:
                var paymentMethodType = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var newModel = function() {
                        if (!paymentMethodType) return _Utils_update(model, {
                            cJ: $author$project$Api$Data$Loading
                        });
                        else return _Utils_update(model, {
                            cC: $author$project$Api$Data$Loading
                        });
                    }();
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        ey: $elm$core$Maybe$Nothing
                    }), function() {
                        if (!paymentMethodType) return A2($author$project$Components$PaymentProcessing$retrieveCardsOnStripe, apiClient, model);
                        else return A2($author$project$Components$PaymentProcessing$retrieveBankAccountsOnStripe, apiClient, model);
                    }(), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Sending request to update all payment methods . This may take a couple moments...')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ey: $elm$core$Maybe$Just(_Utils_Tuple2(paymentMethodType, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 32:
                return _Utils_Tuple3(_Utils_update(model, {
                    oJ: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Practice$RainforestAccount$sync, apiClient, $author$project$Components$PaymentProcessing$Synced), _List_Nil);
            case 33:
                var response = msg.a;
                if (response.$ === 3) {
                    var rainforestAccount = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cn: response,
                        ahy: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount),
                        oJ: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Sync with Rainforest was successful.')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    oJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 34:
                return _Utils_Tuple3(_Utils_update(model, {
                    n6: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Practice$RainforestAccount$runPlatformMigration, apiClient, $author$project$Components$PaymentProcessing$GotRunPlatformMigration), _List_Nil);
            case 35:
                var response = msg.a;
                if (response.$ === 3) {
                    var rainforestAccount = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        n6: response,
                        ahy: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount)
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Platform migration was started.')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    n6: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 36:
                return _Utils_Tuple3(_Utils_update(model, {
                    fr: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Practice$RainforestAccount$delete, apiClient, $author$project$Components$PaymentProcessing$GotDeleteRainforestAccount), _List_Nil);
            case 37:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    fr: $author$project$Api$Data$NotAsked,
                    ahy: $author$project$Components$PaymentProcessing$CreateAccount
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account was successfully deleted.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    fr: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 38:
                var migrateBackToStripeModal = $author$project$Components$Rainforest$MigrateBackToStripeModal$init;
                return _Utils_Tuple3(_Utils_update(model, {
                    jf: $elm$core$Maybe$Just(migrateBackToStripeModal)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 39:
                var subMsg = msg.a;
                var _v44 = model.jf;
                if (!_v44.$) {
                    var migrateBackToStripeModal = _v44.a;
                    var migrateBackToStripeModalResult = A3($author$project$Components$Rainforest$MigrateBackToStripeModal$update, apiClient, subMsg, migrateBackToStripeModal);
                    var _v45 = function() {
                        var _v46 = migrateBackToStripeModalResult.adu;
                        switch(_v46){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(migrateBackToStripeModalResult.zi), $elm$core$Platform$Cmd$none, _List_Nil);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Components$PaymentProcessing$GotPractice), _List_fromArray([
                                    $author$project$OutMsg$RefreshPractice
                                ]));
                        }
                    }();
                    var updatedMigrateBackToStripeModal = _v45.a;
                    var cmd = _v45.b;
                    var outMsgs = _v45.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        jf: updatedMigrateBackToStripeModal
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg, migrateBackToStripeModalResult.EQ)
                    ])), _Utils_ap(outMsgs, migrateBackToStripeModalResult.at));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 40:
                var depositFrequency = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    o2: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Practice$RainforestAccount$update, apiClient, {
                    ac4: depositFrequency
                }, $author$project$Components$PaymentProcessing$DepositFrequencyUpdated), _List_Nil);
            case 41:
                var response = msg.a;
                if (response.$ === 3) {
                    var rainforestAccount = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cn: response,
                        ahy: $author$project$Components$PaymentProcessing$HasRainforestAccountAccount(rainforestAccount),
                        o2: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Deposit frequency was successfully updated.')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    o2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 42:
                return _Utils_Tuple3(_Utils_update(model, {
                    ahy: $author$project$Components$PaymentProcessing$StripeConnecting
                }), A2($author$project$Api$Provider$Practice$StripeAccount$createAccount, apiClient, $author$project$Components$PaymentProcessing$GotConnectedToStripe), _List_Nil);
            case 43:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        W1: practice,
                        ahy: $author$project$Components$PaymentProcessing$StripeConnecting
                    }), A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, apiClient, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus), _List_fromArray([
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ahy: $author$project$Components$PaymentProcessing$CreateAccount
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 44:
                var response = msg.a;
                if (response.$ === 3) {
                    var detailsSubmitted = response.a.ac6;
                    var clientSecret = response.a.acr;
                    if (detailsSubmitted) return _Utils_Tuple3(_Utils_update(model, {
                        ahy: $author$project$Components$PaymentProcessing$StripeConnected
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                    else {
                        if (!clientSecret.$) {
                            var secret = clientSecret.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                sW: true,
                                ahy: $author$project$Components$PaymentProcessing$StripeEmbeddedOnboarding
                            }), A2($author$project$Ports$Stripe$mountAccountOnboardingComponent, '#stripe-account-onboarding', secret), _List_Nil);
                        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ahy: $author$project$Components$PaymentProcessing$CreateAccount
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 45:
                return _Utils_Tuple3(_Utils_update(model, {
                    ahy: $author$project$Components$PaymentProcessing$StripeConnecting
                }), A2($author$project$Api$Provider$Practice$StripeAccount$onboardingStatus, apiClient, $author$project$Components$PaymentProcessing$GotStripeOnboardingStatus), _List_Nil);
            case 46:
                return _Utils_Tuple3(_Utils_update(model, {
                    sW: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 47:
                return _Utils_Tuple3(_Utils_update(model, {
                    gZ: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 48:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(model, A2($author$project$Api$Provider$Practice$StripeAccount$disconnect, apiClient, $author$project$Components$PaymentProcessing$StripeDisconnected), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    gZ: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 49:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        W1: practice,
                        ahy: $author$project$Components$PaymentProcessing$CreateAccount,
                        gZ: false
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been disconnected.'),
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    gZ: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                return _Utils_Tuple3(model, $author$project$Ports$Intercom$open(model.Z$), _List_Nil);
        }
    });
    var $author$project$Pages$Admin$PaymentProcessing$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$PaymentProcessing$update, subMsg, model.ns, model.Ej);
        var paymentProcessing = _v1.a;
        var paymentProcessingCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            ns: paymentProcessing
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentProcessingCmd), outMsgs);
    });
    var $author$project$Components$PaymentProcessing$DeleteAllHiConfirmClosed = F2(function(a, b) {
        return {
            $: 27,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentProcessing$DeleteRainforestAccount = {
        $: 36
    };
    var $author$project$Components$PaymentProcessing$OpenResetAccountModal = {
        $: 12
    };
    var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAllHiConfirmClosed = F2(function(a, b) {
        return {
            $: 30,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentProcessing$Sync = {
        $: 32
    };
    var $author$project$Components$HiConfirm$ButtonStyle = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$buttonStyle = $author$project$Components$HiConfirm$ButtonStyle;
    var $author$project$Api$Provider$RainforestAccount$Shared$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Provider$RainforestAccount$Shared$status = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$Shared$record, function($) {
        return $.ahy;
    });
    var $author$project$Api$Provider$RainforestAccount$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RainforestAccount$Shared$status(shared);
    };
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigrateBackToStripe = {
        $: 2
    };
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$MigratePaymentMethodsChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Rainforest$MigrateBackToStripeModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Migrate back to Stripe')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('Migrate the practice back to to Stripe.')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Migrate Payment Methods'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(model.rr),
                        $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Rainforest$MigrateBackToStripeModal$MigratePaymentMethodsChanged)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Also migrate payment methods to back to Stripe.')
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$MigrateBackToStripeModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Revert to Stripe'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$MigrateBackToStripeModal$MigrateBackToStripe),
                    $author$project$Ui$Button$loading(_Utils_eq(model.m7, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Migrate back to Stripe')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Rainforest$ResetAccountModal$MerchantNameChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Rainforest$ResetAccountModal$Reset = {
        $: 2
    };
    var $author$project$Components$Rainforest$ResetAccountModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Rainforest$ResetAccountModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Reset Rainforest Account')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This will:'),
                    A2($elm$html$Html$ul, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$li, _List_fromArray([
                            A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
                        ]), _List_fromArray([
                            $elm$html$Html$text('Remove the current link between the practice and Rainforest')
                        ])),
                        A2($elm$html$Html$li, _List_fromArray([
                            A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
                        ]), _List_fromArray([
                            $elm$html$Html$text('Create a new Rainforest Merchant with the given name')
                        ])),
                        A2($elm$html$Html$li, _List_fromArray([
                            A2($elm$html$Html$Attributes$style, 'list-style-position', 'inside')
                        ]), _List_fromArray([
                            $elm$html$Html$text('Link the practice to the new Rainforest Merchant')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Merchant Name'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', model.je)),
                        $author$project$Ui$Form$Input$onInput($author$project$Components$Rainforest$ResetAccountModal$MerchantNameChanged),
                        $author$project$Ui$Form$Input$invalid(_Utils_eq(model.je, $elm$core$Maybe$Nothing)),
                        $author$project$Ui$Form$Input$errors(_Utils_eq(model.je, $elm$core$Maybe$Nothing) ? _List_fromArray([
                            'Merchant name is required'
                        ]) : _List_Nil)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('This is the name of the Rainforest Merchant that will be created. '),
                        $elm$html$Html$text('By default we use the practice id as the merchant name but since we cannot reuse merchant names, '),
                        $elm$html$Html$text('we will need provide a new name here. '),
                        A2($author$project$Ui$Typography$b, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Suggestion is to use the practice id followed by a dash with the number of merchants we have created for this practice.'),
                            $elm$html$Html$text('Example: pra-abc1234-2')
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$ResetAccountModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Reset Rainforest Account'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.su, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$ResetAccountModal$Reset)
                ]), _List_fromArray([
                    $elm$html$Html$text('Reset')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$ReviewTypeSelected = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$Simulate = {
        $: 3
    };
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$StatusSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$statusOptions = A2($elm$core$List$map, function(status) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(status), status);
    }, $author$project$Components$Rainforest$SimulateApplicationEventModal$statuses);
    var $author$project$Components$Rainforest$SimulateApplicationEventModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Rainforest$SimulateApplicationEventModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Simulate Application Status Change')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('In the production environment, this step is handled through callback events. In Staging, Feature, and Dev environments, it can be simulated.')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Status'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(model.ahy)),
                        $author$project$Ui$Form$Select$onChange($author$project$Components$Rainforest$SimulateApplicationEventModal$StatusSelected)
                    ]), $author$project$Components$Rainforest$SimulateApplicationEventModal$statusOptions)
                ])),
                model.ahy === 'NEEDS_INFORMATION' ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Review Types'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$clearfix
                ]), A2($elm$core$List$map, function(_v1) {
                    var reviewType = _v1.a;
                    var value = _v1.b;
                    return A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(value),
                        $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Rainforest$SimulateApplicationEventModal$ReviewTypeSelected(reviewType))
                    ]), _List_fromArray([
                        $elm$html$Html$text(reviewType)
                    ]));
                }, $elm$core$Dict$toList(model.n2))) : $author$project$Utils$Html$empty
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateApplicationEventModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Simulate application event'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.su, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Rainforest$SimulateApplicationEventModal$Simulate)
                ]), _List_fromArray([
                    $elm$html$Html$text('Simulate')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$PaymentProcessing$viewCreateAccountBody = F2(function(isOnboarding, isStripeEmbedded) {
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(isOnboarding ? '' : 'Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$inputSpanMd(6)
            ]), _List_fromArray([
                isOnboarding ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
                ])),
                isStripeEmbedded ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Connect your Stripe account to start accepting payments through Hint.')
                ])) : A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This platform streamlines the process of accepting patient payments by providing a secure, compliant, and efficient solution.'),
                    $elm$html$Html$text(' To configure your Payment Processing account, click \"Connect\".')
                ]))
            ]))
        ]);
    });
    var $author$project$Components$PaymentProcessing$ConnectToStripe = {
        $: 42
    };
    var $author$project$Components$PaymentProcessing$CreateRainforestAccount = {
        $: 1
    };
    var $author$project$Components$PaymentProcessing$SkipSetup = {
        $: 5
    };
    var $author$project$Components$PaymentProcessing$viewCreateAccountFooter = function(_v0) {
        var model = _v0;
        var isStripeEmbedded = A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, model.W1);
        var connectButton = isStripeEmbedded ? A3($author$project$Ui$Button$view, {
            abP: 'Connect to Stripe'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$ConnectToStripe)
        ]), _List_fromArray([
            $elm$html$Html$text('Connect to Stripe')
        ])) : A3($author$project$Ui$Button$view, {
            abP: 'Connect account'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$CreateRainforestAccount)
        ]), _List_fromArray([
            $elm$html$Html$text('Connect')
        ]));
        return model.aK ? _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Skip account creation'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$pull(0),
                $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$SkipSetup)
            ]), _List_fromArray([
                $elm$html$Html$text('Skip')
            ])),
            connectButton
        ]) : _List_fromArray([
            connectButton
        ]);
    };
    var $author$project$Components$PaymentProcessing$EnableRainforest = {
        $: 7
    };
    var $author$project$Components$PaymentProcessing$MerchantOnboardingSubmitted = {
        $: 3
    };
    var $author$project$Components$PaymentProcessing$MigrateBackToStripe = {
        $: 38
    };
    var $author$project$Components$PaymentProcessing$OpenSimulateModal = {
        $: 10
    };
    var $author$project$Components$PaymentProcessing$RunPlatformMigration = {
        $: 34
    };
    var $author$project$Components$PaymentProcessing$applicationIsProcessing = F2(function(rainforestAccount, _v0) {
        var merchantOnboardingSubmitted = _v0.y4;
        return merchantOnboardingSubmitted || 'processing' === $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
    });
    var $author$project$Api$Provider$RainforestAccount$One$depositAccountAccountType = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.NM;
    });
    var $author$project$Api$Provider$RainforestAccount$One$depositAccountBankName = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.NN;
    });
    var $author$project$Api$Provider$RainforestAccount$One$depositAccountLast4 = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.NO;
    });
    var $author$project$Api$Provider$RainforestAccount$One$depositAccountRoutingNumber = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.NP;
    });
    var $author$project$Api$Provider$RainforestAccount$One$depositFrequency = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.ac4;
    });
    var $author$project$Ui$HinterOnly$linkRoute = F3(function(route, options, content) {
        return A3($author$project$Ui$Link$route, route, A2($elm$core$List$cons, $author$project$Ui$Link$icon($author$project$Ui$HinterOnly$icon), options), content);
    });
    var $author$project$Api$Provider$RainforestAccount$One$merchantApplicationId = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.T9;
    });
    var $author$project$Api$Provider$RainforestAccount$One$merchantId = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.Ub;
    });
    var $author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $.WQ;
    });
    var $author$project$Api$Provider$RainforestAccount$One$statementDescriptor = A2($elm$core$Basics$composeR, $author$project$Api$Provider$RainforestAccount$One$record, function($) {
        return $._5;
    });
    var $author$project$Ui$Alert$textLeft = $author$project$Ui$Alert$Alignment($author$project$Ui$Alignment$textLeft);
    var $author$project$WebComponents$Rainforest$MerchantOnboarding$view = F2(function(msg, data) {
        return A3($elm$html$Html$node, 'rainforest-merchant-onboarding', _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'session-key', data.ahi),
            A2($elm$html$Html$Attributes$attribute, 'merchant-id', data.Ub),
            A2($elm$html$Html$Attributes$attribute, 'merchant-application-id', data.T9),
            A2($elm$html$Html$Attributes$attribute, 'hide-display-header', ''),
            A2($elm$html$Html$Events$on, 'submitted', $elm$json$Json$Decode$succeed(msg)),
            A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
            A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
            A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
            A2($elm$html$Html$Attributes$attribute, 'terms-and-conditions-url', 'https://www.hint.com/terms-processing')
        ]), _List_Nil);
    });
    var $author$project$Components$PaymentProcessing$UpdateDepositFrequency = function(a) {
        return {
            $: 40,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$viewDepositFrequencyButton = F4(function(updateRequest, currentDepositFrequency, depositFrequency, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentDepositFrequency, depositFrequency)),
            $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$UpdateDepositFrequency(depositFrequency)),
            $author$project$Ui$Button$loading(_Utils_eq(updateRequest, $author$project$Api$Data$Loading))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$PaymentProcessing$viewInProgressAlert = A2($author$project$Ui$Alert$info, _List_fromArray([
        $author$project$Ui$Alert$mb2,
        $author$project$Ui$Alert$textLeft
    ]), _List_fromArray([
        A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Setup Hint Payments')
        ])),
        A2($elm$html$Html$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text("To start processing payments in Hint, please complete the form below. It takes about 5\u201310 minutes and requires key details like your account\u2019s contact info, tax ID, bank details, and ownership info (including SSN).")
        ]))
    ]));
    var $author$project$Components$PaymentProcessing$viewInReviewAlert = A2($author$project$Ui$Alert$info, _List_fromArray([
        $author$project$Ui$Alert$mb2,
        $author$project$Ui$Alert$textLeft
    ]), _List_fromArray([
        A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
            $elm$html$Html$text("Application Submitted \u2014 Under Review")
        ])),
        A2($elm$html$Html$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text("Thank you for submitting your payment setup form! We\u2019re currently reviewing your details \u2014 this usually takes a few business days. No action is needed right now.")
        ]))
    ]));
    var $author$project$Components$PaymentProcessing$viewHasAccountBody = F2(function(rainforestAccount, _v0) {
        var model = _v0;
        return $elm$core$List$concat(_List_fromArray([
            model.aK ? _List_Nil : _List_fromArray([
                function() {
                    var _v1 = $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
                    switch(_v1){
                        case 'created':
                            return $author$project$Components$PaymentProcessing$viewInProgressAlert;
                        case 'in_progress':
                            return $author$project$Components$PaymentProcessing$viewInProgressAlert;
                        case 'processing':
                            return $author$project$Components$PaymentProcessing$viewInReviewAlert;
                        case 'in_review':
                            return $author$project$Components$PaymentProcessing$viewInReviewAlert;
                        case 'needs_information':
                            return A2($author$project$Ui$Alert$info, _List_fromArray([
                                $author$project$Ui$Alert$mb2,
                                $author$project$Ui$Alert$textLeft
                            ]), _List_fromArray([
                                A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text("Action Needed \u2014 More Info Required")
                                ])),
                                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text("To finish setting up Hint Payments, we need a bit more information. Please use the form below to provide the missing details. Once submitted, we\u2019ll review and confirm your setup \u2014 usually within a few business days. We\u2019ll notify you by email when it's complete.")
                                ]))
                            ]));
                        case 'completed':
                            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Status'),
                                $author$project$Ui$Form$Group$labelSpanSm(4),
                                $author$project$Ui$Form$Group$inputSpanSm(8)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$RainforestAccount$One$status(rainforestAccount))
                                ]))
                            ]));
                        default:
                            return $elm$html$Html$text('');
                    }
                }()
            ]),
            function() {
                var _v2 = $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
                if (_v2 === 'completed') return $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Statement Descriptor'),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$RainforestAccount$One$statementDescriptor(rainforestAccount)))
                            ]))
                        ])),
                        model.F3 ? A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Deposit Frequency'),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            $author$project$Ui$Button$group(_List_fromArray([
                                A4($author$project$Components$PaymentProcessing$viewDepositFrequencyButton, model.o2, $author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount), 'daily', 'Daily'),
                                A4($author$project$Components$PaymentProcessing$viewDepositFrequencyButton, model.o2, $author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount), 'weekly', 'Weekly'),
                                A4($author$project$Components$PaymentProcessing$viewDepositFrequencyButton, model.o2, $author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount), 'monthly', 'Monthly'),
                                A4($author$project$Components$PaymentProcessing$viewDepositFrequencyButton, model.o2, $author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount), 'disabled', 'Disabled')
                            ])),
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock
                            ]), _List_fromArray([
                                $elm$html$Html$text('Deposits will be processed on '),
                                function() {
                                    var _v3 = $author$project$Api$Provider$RainforestAccount$One$depositFrequency(rainforestAccount);
                                    switch(_v3){
                                        case 'daily':
                                            return $elm$html$Html$text('each US banking day');
                                        case 'weekly':
                                            return $elm$html$Html$text('the first US banking day of the week');
                                        case 'monthly':
                                            return $elm$html$Html$text('the first US banking day of the month');
                                        case 'disabled':
                                            return $elm$html$Html$text('never');
                                        default:
                                            return $elm$html$Html$text('N/A');
                                    }
                                }()
                            ]))
                        ])) : $author$project$Utils$Html$empty,
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Deposit Account'),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Bank Name: ')
                                ])),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$RainforestAccount$One$depositAccountBankName(rainforestAccount)))
                            ])),
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Last 4: ')
                                ])),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$RainforestAccount$One$depositAccountLast4(rainforestAccount)))
                            ])),
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Routing Number: ')
                                ])),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$RainforestAccount$One$depositAccountRoutingNumber(rainforestAccount)))
                            ])),
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Account Type: ')
                                ])),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$RainforestAccount$One$depositAccountAccountType(rainforestAccount)))
                            ]))
                        ]))
                    ]),
                    model.F3 ? _List_fromArray([
                        A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Payment Processor'),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, true, true, model.W1, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$paymentProcessor, $elm$core$Maybe$Just))),
                                $author$project$Api$Provider$Practice$One$paymentProcessor(model.W1) !== 'rainforest' ? A3($author$project$Ui$HinterOnly$button, {
                                    abP: 'Switch payment processor to rainforest'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$secondary,
                                    $author$project$Ui$Button$sm,
                                    $author$project$Ui$Button$loading(_Utils_eq(model.l7, $author$project$Api$Data$Loading)),
                                    $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$EnableRainforest)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Switch to Rainforest')
                                ])) : $author$project$Api$Provider$Practice$One$hasStripeAccount(model.W1) ? A3($author$project$Ui$HinterOnly$button, {
                                    abP: 'Migrate back to stripe'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$secondary,
                                    $author$project$Ui$Button$sm,
                                    $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$MigrateBackToStripe)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Migrate back to Stripe')
                                ])) : $author$project$Utils$Html$empty,
                                A3($author$project$Ui$HinterOnly$linkRoute, $author$project$Spa$Generated$Route$Admin__PaymentMethodImport, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Manage Payment Sources Import')
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Rainforest Merchant ID'),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$RainforestAccount$One$merchantId(rainforestAccount)))
                            ]))
                        ])),
                        A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Platform Migration Completed At'),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, model.HO(1), $author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt(rainforestAccount)))),
                                _Utils_eq($author$project$Api$Provider$RainforestAccount$One$platformTokenMigrationCompletedAt(rainforestAccount), $elm$core$Maybe$Nothing) ? A3($author$project$Ui$HinterOnly$button, {
                                    abP: 'Run platform migration'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$secondary,
                                    $author$project$Ui$Button$sm,
                                    $author$project$Ui$Button$loading(_Utils_eq(model.n6, $author$project$Api$Data$Loading)),
                                    $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$RunPlatformMigration)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Run platform migration')
                                ])) : $author$project$Utils$Html$empty
                            ]))
                        ]))
                    ]) : _List_Nil
                ]));
                else return _List_fromArray([
                    model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Application Status'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount))
                        ]))
                    ])),
                    model.F3 && model.BC && A2($author$project$Components$PaymentProcessing$applicationIsProcessing, rainforestAccount, model) ? A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8),
                        $author$project$Ui$Form$Group$label('')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Simulate status change'
                            }, _List_fromArray([
                                $author$project$Ui$Button$secondary,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$OpenSimulateModal)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Simulate Status Change')
                            ]))
                        ]))
                    ])) : $author$project$Utils$Html$empty
                ]);
            }(),
            function() {
                var _v4 = _Utils_Tuple3(A2($author$project$Components$PaymentProcessing$applicationIsProcessing, rainforestAccount, model), $author$project$Api$Provider$RainforestAccount$One$merchantApplicationStatus(rainforestAccount), model.Ct);
                _v4$1: while(true){
                    if (_v4.a) return _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label(''),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanMd(12),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock
                            ]), _List_fromArray([
                                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Your payment processing account is under review, we will notify you when it\'s approved or if more information is needed.')
                                ]))
                            ]))
                        ]))
                    ]);
                    else if (!_v4.c.$) {
                        if (_v4.b === 'completed') break _v4$1;
                        else {
                            var setupSessionKey = _v4.c.a;
                            return _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label(''),
                                    model.aK ? $author$project$Ui$Form$Group$labelSpanSm(0) : $author$project$Ui$Form$Group$labelSpanSm(4),
                                    model.aK ? $author$project$Ui$Form$Group$inputSpanMd(12) : $author$project$Ui$Form$Group$inputSpanMd(8)
                                ]), _List_fromArray([
                                    A2($author$project$WebComponents$Rainforest$MerchantOnboarding$view, $author$project$Components$PaymentProcessing$MerchantOnboardingSubmitted, {
                                        T9: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$RainforestAccount$One$merchantApplicationId(rainforestAccount)),
                                        Ub: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$RainforestAccount$One$merchantId(rainforestAccount)),
                                        ahi: setupSessionKey
                                    })
                                ]))
                            ]);
                        }
                    } else {
                        if (_v4.b === 'completed') break _v4$1;
                        else {
                            var _v5 = _v4.c;
                            return _List_Nil;
                        }
                    }
                }
                return _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label(''),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanMd(12),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('You can review your patient payment report ')
                            ])),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__PaymentApplications, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('here')
                            ])),
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('.')
                            ]))
                        ]))
                    ]))
                ]);
            }()
        ]));
    });
    var $author$project$Components$PaymentProcessing$PrefillWithFakeDataClicked = {
        $: 14
    };
    var $author$project$Components$PaymentProcessing$viewHasAccountFooter = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            function() {
                var _v0 = _Utils_Tuple2(model.F3 && model.BC, A2($author$project$Api$Data$map, $author$project$Api$Provider$RainforestAccount$One$status, model.cn));
                if (_v0.a && _v0.b.$ === 3 && _v0.b.a === 'pending') {
                    var _v1 = _v0.b;
                    return A3($author$project$Ui$HinterOnly$button, {
                        abP: 'Prefill with fake data'
                    }, _List_fromArray([
                        $author$project$Ui$Button$secondary,
                        $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$PrefillWithFakeDataClicked)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Prefill')
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            model.aK ? A3($author$project$Ui$Button$view, {
                abP: 'Skip and finish later'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$SkipSetup)
            ]), _List_fromArray([
                $elm$html$Html$text('Finish Later')
            ])) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Components$PaymentProcessing$viewLoadingBody = _List_fromArray([
        A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$helpBlock,
            $author$project$Ui$Typography$muted,
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]), _List_fromArray([
            $author$project$Ui$Spinner$view(_List_Nil)
        ]))
    ]);
    var $author$project$Components$PaymentProcessing$DisconnectStripe = {
        $: 47
    };
    var $author$project$Components$PaymentProcessing$ShowStripeSupportChat = {
        $: 50
    };
    var $author$project$Ui$HinterOnly$linkHref = F3(function(externalHref_, options, content) {
        return A3($author$project$Ui$Link$externalHref, externalHref_, A2($elm$core$List$cons, $author$project$Ui$Link$icon($author$project$Ui$HinterOnly$icon), options), content);
    });
    var $author$project$Api$Provider$Practice$Shared$stripeLink = function(_v0) {
        var record = _v0;
        return record.$j;
    };
    var $author$project$Api$Provider$Practice$One$stripeLink = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$stripeLink(shared);
    };
    var $author$project$Components$Stripe$ConnectedView$view = function(config) {
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'connected'),
                    config.F3 ? A3($author$project$Ui$HinterOnly$button, {
                        abP: 'Disconnect from stripe'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick(config.afx)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Disconnect From Stripe')
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('You can review your patient payment report '),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__PaymentApplications, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('here')
                    ])),
                    $elm$html$Html$text(' and our latest negotiated transaction fees '),
                    A3($author$project$Ui$Link$externalHref, 'http://www.hint.com/pricing#stripe', _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $elm$html$Html$text('here')
                    ])),
                    $elm$html$Html$text('.'),
                    $elm$html$Html$text('If you would like to disable this integration please '),
                    A3($author$project$Ui$Button$view, {
                        abP: 'contact us'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick(config.afO)
                    ]), _List_fromArray([
                        $elm$html$Html$text('contact us')
                    ])),
                    $elm$html$Html$text('.')
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, function() {
                        if (config.F3) {
                            var stripeLink = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Practice$One$stripeLink(config.W1));
                            return _List_fromArray([
                                A3($author$project$Ui$HinterOnly$linkHref, stripeLink, _List_fromArray([
                                    $author$project$Ui$Link$targetBlank
                                ]), _List_fromArray([
                                    $elm$html$Html$text(' View on Stripe')
                                ]))
                            ]);
                        } else return _List_Nil;
                    }())
                ]))
            ]))
        ]);
    };
    var $author$project$Components$PaymentProcessing$viewStripeConnectedBody = function(model) {
        return $author$project$Components$Stripe$ConnectedView$view({
            F3: model.F3,
            afx: $author$project$Components$PaymentProcessing$DisconnectStripe,
            afO: $author$project$Components$PaymentProcessing$ShowStripeSupportChat,
            W1: model.W1
        });
    };
    var $author$project$Components$PaymentProcessing$viewStripeConnectingBody = _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Status'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, 'connecting')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $author$project$Ui$Spinner$view(_List_Nil)
            ]))
        ]))
    ]);
    var $elm$html$Html$Attributes$hidden = $elm$html$Html$Attributes$boolProperty('hidden');
    var $author$project$Components$PaymentProcessing$viewStripeEmbeddedOnboardingBody = function(showStepOneAlert) {
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$hidden(!showStepOneAlert)
            ]), _List_fromArray([
                A2($author$project$Ui$Alert$warning, _List_fromArray([
                    $author$project$Ui$Alert$mb2,
                    $author$project$Ui$Alert$textLeft
                ]), _List_fromArray([
                    $elm$html$Html$text('STEP ONE: To get started, verify your new Stripe account through the link sent to your practice\'s email address. Then proceed to complete the form below.')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$id('stripe-account-onboarding')
            ]), _List_Nil)
        ]);
    };
    var $author$project$Components$PaymentProcessing$BankAccount = 1;
    var $author$project$Ui$Padding$Bottom_3 = 9;
    var $author$project$Components$PaymentProcessing$Card = 0;
    var $author$project$Components$PaymentProcessing$DeleteAll = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$PaginationMsg = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAll = function(a) {
        return {
            $: 29,
            a: a
        };
    };
    var $author$project$Components$PaymentProcessing$SortTable = F2(function(a, b) {
        return {
            $: 19,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Data$getIntFromHeaders = F2(function(data, headerName) {
        if (data.$ === 3) {
            var headers = data.b;
            return A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, headerName, headers));
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$PaymentProcessing$paymentMethodsOnStripeColumns = _List_fromArray([
        A3($author$project$Api$Column$init, '', false, 'Owner'),
        A3($author$project$Api$Column$init, '', false, 'Payment Method'),
        A3($author$project$Api$Column$init, '', false, 'Status'),
        A3($author$project$Api$Column$init, 'last_used_at', true, 'Last Used'),
        A3($author$project$Api$Column$init, '', false, '')
    ]);
    var $author$project$Components$PaymentProcessing$Delete = F2(function(a, b) {
        return {
            $: 20,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdate = F2(function(a, b) {
        return {
            $: 23,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$isDefault = function(_v0) {
        var record = _v0;
        return record.R0;
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$lastUsedAt = function(_v0) {
        var record = _v0;
        return record.S$;
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$paymentMethodBrand = function(_v0) {
        var record = _v0;
        return record._D;
    };
    var $author$project$Api$Provider$StripePaymentMethodMigration$All$requestPayInfoSentAt = function(_v0) {
        var record = _v0;
        return record.YF;
    };
    var $author$project$Components$PaymentSourceDisplayer$StripePaymentMethodMigration = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$stripePaymentMethodMigration = $author$project$Components$PaymentSourceDisplayer$StripePaymentMethodMigration;
    var $author$project$Components$PaymentProcessing$viewPaymentMethodOnStripe = F5(function(timeFormatter, canGoToPatients, canGoToCompany, paymentMethodType, paymentMethod) {
        var owner = $author$project$Api$Provider$StripePaymentMethodMigration$All$owner(paymentMethod);
        var ownerName = A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, owner));
        var ownerPath = A2($elm$core$Maybe$andThen, function(owner_) {
            var _v3 = $author$project$Api$Common$Payable$Owner$Min$type_(owner_);
            switch(_v3){
                case 'Patient':
                    return canGoToPatients ? $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top({
                        V8: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
                    })) : $elm$core$Maybe$Nothing;
                case 'Company':
                    return canGoToCompany ? $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources({
                        fl: $author$project$Api$Common$Payable$Owner$Min$id(owner_)
                    })) : $elm$core$Maybe$Nothing;
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }, owner);
        var lastFour = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$StripePaymentMethodMigration$All$lastFour(paymentMethod));
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    if (!ownerPath.$) {
                        var ownerPath_ = ownerPath.a;
                        return A3($author$project$Ui$Link$route, ownerPath_, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(ownerName)
                        ]));
                    } else return $elm$html$Html$text(ownerName);
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$StripePaymentMethodMigration$All$paymentMethodBrand(paymentMethod) + (' ' + lastFour))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                    $author$project$Components$PaymentSourceDisplayer$stripePaymentMethodMigration(paymentMethod),
                    $author$project$Components$PaymentSourceDisplayer$showProcessor(false)
                ])),
                $author$project$Api$Provider$StripePaymentMethodMigration$All$isDefault(paymentMethod) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Never', A2($elm$core$Maybe$map, timeFormatter(1), $author$project$Api$Provider$StripePaymentMethodMigration$All$lastUsedAt(paymentMethod))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$pull(1),
                    $author$project$Ui$Typography$padding(2)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete payment method'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$onClick(A2($author$project$Components$PaymentProcessing$Delete, paymentMethodType, paymentMethod)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ])),
                function() {
                    var _v1 = A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$type_, owner);
                    _v1$2: while(true){
                        if (!_v1.$) switch(_v1.a){
                            case 'Patient':
                                var lastRequestSent = function() {
                                    var _v2 = $author$project$Api$Provider$StripePaymentMethodMigration$All$requestPayInfoSentAt(paymentMethod);
                                    if (!_v2.$) {
                                        var patientRequestInfoSentAt_ = _v2.a;
                                        var sentAt = A2(timeFormatter, 1, patientRequestInfoSentAt_);
                                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$muted
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Last request sent ' + (sentAt + '.'))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }();
                                return A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$pull(1)
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Request new payment information'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$size(0),
                                        $author$project$Ui$Button$onClick(A2($author$project$Components$PaymentProcessing$RequestPaymentInfoUpdate, paymentMethodType, paymentMethod)),
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Request new payment information')
                                    ])),
                                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                    lastRequestSent
                                ]));
                            case 'Company':
                                return A3($author$project$Ui$Tooltip$view, _List_Nil, 'Please reach out to the company directly', _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Request new payment information'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$size(0),
                                        $author$project$Ui$Button$disabled(true),
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Request new payment information')
                                    ]))
                                ]));
                            default:
                                break _v1$2;
                        }
                        else break _v1$2;
                    }
                    return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    });
    var $author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe = F2(function(model, paymentMethodType) {
        var _v0 = function() {
            if (!paymentMethodType) return _Utils_Tuple3(model.cJ, model.lr, model.ff);
            else return _Utils_Tuple3(model.cC, model.ld, model.e9);
        }();
        var paymentMethodsOnStripe = _v0.a;
        var sort = _v0.b;
        var pagination = _v0.c;
        var onStripeCount = A2($elm$core$Maybe$withDefault, 0, A2($author$project$Api$Data$getIntFromHeaders, paymentMethodsOnStripe, 'x-total-count'));
        if (onStripeCount > 0) {
            var title = function() {
                if (!paymentMethodType) return 'Cards';
                else return 'Bank Accounts';
            }();
            var onRainforestCount = A2($elm$core$Maybe$withDefault, 0, A2($author$project$Api$Data$getIntFromHeaders, paymentMethodsOnStripe, 'x-on-rainforest-count'));
            var totalCount = onStripeCount + onRainforestCount;
            var _v2 = function() {
                if (paymentMethodsOnStripe.$ === 3) {
                    var list_ = paymentMethodsOnStripe.a;
                    return _Utils_Tuple2(false, list_);
                } else return _Utils_Tuple2(true, _List_Nil);
            }();
            var loading = _v2.a;
            var list = _v2.b;
            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$pull(0)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$bold
                        ]), _List_fromArray([
                            $elm$html$Html$text(title)
                        ])),
                        $elm$html$Html$text(' - '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$info
                        ]), _List_fromArray([
                            $elm$html$Html$text('Total Payment Methods: '),
                            $elm$html$Html$text($elm$core$String$fromInt(totalCount))
                        ])),
                        $elm$html$Html$text(' - '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$success
                        ]), _List_fromArray([
                            $elm$html$Html$text('Live on Hint Payments: '),
                            $elm$html$Html$text($elm$core$String$fromInt(onRainforestCount))
                        ])),
                        $elm$html$Html$text(' - '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$danger
                        ]), _List_fromArray([
                            $elm$html$Html$text('Remaining on Stripe: '),
                            $elm$html$Html$text($elm$core$String$fromInt(onStripeCount))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$pull(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Request all payment methods'
                    }, _List_fromArray([
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$loading(_Utils_eq($elm$core$Maybe$Just($author$project$Api$Data$Loading), A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.ey))),
                        $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAll(paymentMethodType)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Request All')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete all payment methods'
                    }, _List_fromArray([
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$loading(_Utils_eq($elm$core$Maybe$Just($author$project$Api$Data$Loading), A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.dK))),
                        $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$DeleteAll(paymentMethodType)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete All')
                    ]))
                ])),
                $author$project$Ui$Clearfix$view,
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$padding(8)
                ]), _List_Nil),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A4($author$project$Ui$Table$view, _List_fromArray([
                            $author$project$Ui$Table$loading(loading),
                            $author$project$Ui$Table$zeroState(_List_fromArray([
                                $elm$html$Html$text('All payment methods are migrated to Hint Payments!')
                            ]))
                        ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, sort, $author$project$Components$PaymentProcessing$SortTable(paymentMethodType))), $author$project$Components$PaymentProcessing$paymentMethodsOnStripeColumns), A2($elm$core$List$map, A4($author$project$Components$PaymentProcessing$viewPaymentMethodOnStripe, model.HO, model.EF, model.EE, paymentMethodType), list), _List_Nil)
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$PaymentProcessing$PaginationMsg(paymentMethodType), A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(loading)
                        ]), pagination))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$PaymentProcessing$viewStripePaymentSourceMigration = function(model) {
        var hasPaymentMethodsOnStripe = function() {
            var _v0 = _Utils_Tuple2(model.cJ, model.cC);
            if (_v0.a.$ === 3 && _v0.b.$ === 3) {
                var _v1 = _v0.a;
                var cardsOnStripe_ = _v1.a;
                var _v2 = _v0.b;
                var bankAccountsOnStripe_ = _v2.a;
                return !$elm$core$List$isEmpty(cardsOnStripe_) || !$elm$core$List$isEmpty(bankAccountsOnStripe_);
            } else return false;
        }();
        return hasPaymentMethodsOnStripe ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('')
        ]), _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Stripe Payment Source Migration')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpText
            ]), _List_fromArray([
                $elm$html$Html$text('Your transition to Hint Payments is nearly complete.'),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                $elm$html$Html$text('Some patient payment sources are still on Stripe and may process there until migration is finished. '),
                $elm$html$Html$text('Use this dashboard to review or delete outdated sources, or request updated info to help wrap up your migration sooner.')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('Note: This list excludes archived patients and companies')
            ])),
            A2($author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe, model, 0),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$padding(9)
            ]), _List_Nil),
            A2($author$project$Components$PaymentProcessing$viewPaymentMethodsOnStripe, model, 1)
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$PaymentProcessing$view = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            function() {
                var _v1 = model.dV;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var paymentMethodType = _v2.a;
                    var paymentMethod = _v2.b;
                    var deletingRequest = _v2.c;
                    return A2($author$project$Components$HiConfirm$modal, A2($author$project$Components$PaymentProcessing$DeleteHiConfirmClosed, paymentMethodType, paymentMethod), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('payment method'),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(deletingRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.ez;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var paymentMethodType = _v4.a;
                    var paymentMethod = _v4.b;
                    var requestingRequest = _v4.c;
                    return A2($author$project$Components$HiConfirm$modal, A2($author$project$Components$PaymentProcessing$RequestPaymentInfoHiConfirmClosed, paymentMethodType, paymentMethod), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('request'),
                        $author$project$Components$HiConfirm$noun('payment info update'),
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('You are about to send an email asking the patient to update this payment method.')
                        ])),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(requestingRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.dK;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var paymentMethodType = _v6.a;
                    var deletingRequest = _v6.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$PaymentProcessing$DeleteAllHiConfirmClosed(paymentMethodType), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete all'),
                        $author$project$Components$HiConfirm$noun('payment methods'),
                        $author$project$Components$HiConfirm$buttonStyle(5),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(deletingRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v7 = model.ey;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var paymentMethodType = _v8.a;
                    var requestingRequest = _v8.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$PaymentProcessing$RequestPaymentInfoUpdateAllHiConfirmClosed(paymentMethodType), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('request'),
                        $author$project$Components$HiConfirm$noun('payment info update'),
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('You are about to send emails asking patients to update all payment methods .')
                        ])),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(requestingRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$SimulateApplicationEventModal$view, $elm$html$Html$map($author$project$Components$PaymentProcessing$SimulateApplicationEventModalMsg)), model.kd)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$ResetAccountModal$view, $elm$html$Html$map($author$project$Components$PaymentProcessing$ResetAccountModalMsg)), model.jT)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$MigrateBackToStripeModal$view, $elm$html$Html$map($author$project$Components$PaymentProcessing$MigrateBackToStripeModalMsg)), model.jf)),
            model.gZ ? A2($author$project$Components$HiConfirm$modal, $author$project$Components$PaymentProcessing$StripeHiConfirmClosed, _List_fromArray([
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    $elm$html$Html$text('WARNING: You\'re about to remove your ability to process credit cards and bank accounts! Please be sure this is what you want to do. If you reconnect the same Stripe account, then all existing cards / bank accounts will remain intact. Otherwise, they will not. Either way, this application will not be able to process any electronic transactions for you while you\'re account is disconnected.')
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$autocomplete(false)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, model.aK ? _List_fromArray([
                    $author$project$Ui$Panel$onlyBorderLeft
                ]) : _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween,
                            $author$project$Ui$Element$itemsCenter
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                model.aK ? $elm$html$Html$text('Setup Payment Processing') : $elm$html$Html$text('Payment Processing')
                            ])),
                            function() {
                                if (model.F3) {
                                    var _v9 = model.ahy;
                                    if (_v9.$ === 1) {
                                        var rainforestAccount = _v9.a;
                                        return A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$gap2,
                                            $author$project$Ui$Element$justifyRight
                                        ]), _List_fromArray([
                                            A3($author$project$Ui$HinterOnly$button, {
                                                abP: 'Sync with Rainforest'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$secondary,
                                                $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$Sync),
                                                $author$project$Ui$Button$loading(_Utils_eq(model.oJ, $author$project$Api$Data$Loading))
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Sync with Rainforest')
                                            ])),
                                            A3($author$project$Ui$HinterOnly$button, {
                                                abP: 'Reset Rainforest account'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$secondary,
                                                $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$OpenResetAccountModal)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Reset Rainforest account')
                                            ])),
                                            $author$project$Api$Provider$RainforestAccount$One$status(rainforestAccount) === 'canceled' ? A3($author$project$Ui$HinterOnly$button, {
                                                abP: 'Delete Rainforest account'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$danger,
                                                $author$project$Ui$Button$onClick($author$project$Components$PaymentProcessing$DeleteRainforestAccount),
                                                $author$project$Ui$Button$loading(_Utils_eq(model.fr, $author$project$Api$Data$Loading))
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Delete Rainforest account')
                                            ])) : $author$project$Utils$Html$empty
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ])),
                        model.aK ? A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Set up your Payment Processing account to start accepting payments.')
                        ])) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _Utils_ap(function() {
                        var _v10 = model.ahy;
                        switch(_v10.$){
                            case 0:
                                return $author$project$Components$PaymentProcessing$viewLoadingBody;
                            case 1:
                                var rainforestAccount = _v10.a;
                                return A2($author$project$Components$PaymentProcessing$viewHasAccountBody, rainforestAccount, model);
                            case 2:
                                return A2($author$project$Components$PaymentProcessing$viewCreateAccountBody, model.aK, A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, model.W1));
                            case 3:
                                return $author$project$Components$PaymentProcessing$viewStripeConnectingBody;
                            case 4:
                                return $author$project$Components$PaymentProcessing$viewStripeEmbeddedOnboardingBody(model.sW);
                            default:
                                return $author$project$Components$PaymentProcessing$viewStripeConnectedBody(model);
                        }
                    }(), $author$project$Api$Provider$Practice$One$paymentProcessor(model.W1) === 'rainforest' && !model.aK ? _List_fromArray([
                        $author$project$Components$PaymentProcessing$viewStripePaymentSourceMigration(model)
                    ]) : _List_Nil)),
                    function() {
                        var _v11 = model.ahy;
                        switch(_v11.$){
                            case 2:
                                return A2($author$project$Ui$Panel$footer, _List_fromArray([
                                    model.aK ? $author$project$Ui$Element$spaceBetween : $author$project$Ui$Element$justifyCenter,
                                    $author$project$Ui$Element$gap4
                                ]), $author$project$Components$PaymentProcessing$viewCreateAccountFooter(model));
                            case 1:
                                return A2($author$project$Ui$Panel$footer, _List_fromArray([
                                    $author$project$Ui$Element$justifyCenter,
                                    $author$project$Ui$Element$gap4
                                ]), _List_fromArray([
                                    $author$project$Components$PaymentProcessing$viewHasAccountFooter(model)
                                ]));
                            default:
                                return $author$project$Ui$Panel$none;
                        }
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$PaymentProcessing$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$PaymentProcessing$view(model.ns))
            ]),
            $2: 'Admin | Payment Processing'
        };
    };
    var $author$project$Pages$Admin$PaymentProcessing$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$PaymentProcessing$init,
        aeR: $author$project$Pages$Admin$PaymentProcessing$load,
        ag3: $author$project$Pages$Admin$PaymentProcessing$save,
        ahE: $author$project$Pages$Admin$PaymentProcessing$subscriptions,
        aaO: $author$project$Pages$Admin$PaymentProcessing$update,
        aid: $author$project$Pages$Admin$PaymentProcessing$view
    });
    var $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$Closed = {
        $: 0
    };
    var $author$project$Components$CreatePaymentMethodModal$init = $author$project$Components$CreatePaymentMethodModal$Closed;
    var $author$project$Components$Practice$PaymentSources$init = F6(function(session, practice, imageStore, timeFormatter, isHintAdmin, rainforestEnv) {
        return _Utils_Tuple2({
            pF: $author$project$Api$Data$Loading,
            pQ: $author$project$Api$Data$Loading,
            lG: $author$project$Components$CreatePaymentMethodModal$init,
            fw: $elm$core$Maybe$Nothing,
            dW: $elm$core$Set$empty,
            qW: imageStore,
            F3: isHintAdmin,
            W1: practice,
            sp: rainforestEnv,
            Z$: session,
            HO: timeFormatter
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$PaymentSources$GotBankAccounts = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentSources$GotCards = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentSources$loadData = function(apiClient) {
        return _Utils_Tuple3($author$project$Api$Data$Loading, $author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$PaymentSources$GotCards),
            A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Admin$PaymentSources$GotBankAccounts)
        ])));
    };
    var $author$project$Pages$Admin$PaymentSources$init = F4(function(session, practice, shared, _v0) {
        var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
        var _v1 = A6($author$project$Components$Practice$PaymentSources$init, session, practice, shared.qW, shared.HO, isHintAdmin, shared.sp);
        var practicePaymentSources = _v1.a;
        var practicePaymentSourcesCmd = _v1.b;
        var _v2 = $author$project$Pages$Admin$PaymentSources$loadData(shared.Ej);
        var cards = _v2.a;
        var bankAccounts = _v2.b;
        var cmd = _v2.c;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            pF: bankAccounts,
            pQ: cards,
            F3: isHintAdmin,
            aL: $elm$core$Maybe$Nothing,
            W1: practice,
            ck: practicePaymentSources,
            Z$: session,
            HO: shared.HO
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg, practicePaymentSourcesCmd)
        ])));
    });
    var $author$project$Pages$Admin$PaymentSources$load = F2(function(shared, model) {
        var _v0 = shared.Z$;
        if (_v0.$ === 3) {
            var session = _v0.a;
            return _Utils_Tuple2(_Utils_update(model, {
                Z$: session
            }), $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$PaymentSources$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$PaymentSources$CancelEdit = {
        $: 4
    };
    var $author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$Close = {
        $: 1
    };
    var $author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$GotLocalStorageItem = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$GotStripeCardPaymentMethod = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$StripeElementTypeChanged = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Ports$Stripe$stripePortOnSetupIntentChange = _Platform_incomingPort('stripePortOnSetupIntentChange', $elm$json$Json$Decode$string);
    var $author$project$Ports$Stripe$onSetupIntentChanged = function(elementType) {
        return $author$project$Ports$Stripe$stripePortOnSetupIntentChange(elementType);
    };
    var $author$project$Ports$Stripe$StripeSetupIntentResponse = F3(function(selector, paymentMethod, error) {
        return {
            xy: error,
            Wl: paymentMethod,
            bi: selector
        };
    });
    var $author$project$Ports$Stripe$StripeCardPaymentMethod = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Ports$Stripe$stripePaymentMethodFromSetupIntentDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_method', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Ports$Stripe$StripeCardPaymentMethod));
    var $author$project$Ports$Stripe$stripeSetupIntentResponseDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'setup_intent', $elm$json$Json$Decode$maybe($author$project$Ports$Stripe$stripePaymentMethodFromSetupIntentDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'selector', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Ports$Stripe$StripeSetupIntentResponse))));
    var $author$project$Ports$Stripe$decodeStripeSetupIntentResponse = F2(function(msg, response) {
        var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$Stripe$stripeSetupIntentResponseDecoder, response);
        if (!_v0.$) {
            var setupIntentResponse = _v0.a;
            var _v1 = setupIntentResponse.Wl;
            if (_v1.$ === 1) {
                var _v2 = setupIntentResponse.xy;
                if (_v2.$ === 1) return msg($elm$core$Result$Err(''));
                else {
                    var error = _v2.a;
                    return msg($elm$core$Result$Err(error));
                }
            } else {
                var setupIntent = _v1.a;
                return msg($elm$core$Result$Ok(setupIntent));
            }
        } else return msg($elm$core$Result$Err('Something went wrong, please try again.'));
    });
    var $author$project$Ports$Stripe$stripePortOnSetupIntentConfirmed = _Platform_incomingPort('stripePortOnSetupIntentConfirmed', $elm$json$Json$Decode$value);
    var $author$project$Ports$Stripe$onSetupIntentConfirmed = function(response) {
        return $author$project$Ports$Stripe$stripePortOnSetupIntentConfirmed($author$project$Ports$Stripe$decodeStripeSetupIntentResponse(response));
    };
    var $author$project$Components$CreatePaymentMethodModal$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                if (model.$ === 1) return $author$project$Ports$Stripe$onSetupIntentConfirmed($author$project$Components$CreatePaymentMethodModal$GotStripeCardPaymentMethod);
                else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                if (model.$ === 1) {
                    var connectingModal = model.a.hW;
                    if (!connectingModal.$) {
                        var justConnectingModal = connectingModal.a;
                        return A2($elm$core$Platform$Sub$map, $author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg, $author$project$Components$CardReader$ConnectingModal$subscriptions(justConnectingModal));
                    } else return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CreatePaymentMethodModal$Close);
                } else return $elm$core$Platform$Sub$none;
            }(),
            $author$project$Ports$LocalStorage$gotItem($author$project$Components$CreatePaymentMethodModal$GotLocalStorageItem),
            $author$project$Ports$Stripe$onSetupIntentChanged($author$project$Components$CreatePaymentMethodModal$StripeElementTypeChanged)
        ]));
    };
    var $author$project$Components$Practice$PaymentSources$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg, $author$project$Components$CreatePaymentMethodModal$subscriptions(model.lG));
    };
    var $author$project$Pages$Admin$PaymentSources$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg, $author$project$Components$Practice$PaymentSources$subscriptions(model.ck)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$PaymentSources$CancelEdit)), model.aL))
        ]));
    };
    var $author$project$Pages$Admin$PaymentSources$formFieldsFromPaymentCategory = function(paymentCategory) {
        return {
            EL: paymentCategory.EL,
            Hw: paymentCategory.ND
        };
    };
    var $author$project$Pages$Admin$PaymentSources$formFieldsUpdate = F3(function(sources, field, fields) {
        var string = field;
        return _Utils_update(fields, {
            Hw: A2($elm_community$list_extra$List$Extra$find, function(source) {
                return _Utils_eq($author$project$Api$Source$id(source), string);
            }, sources)
        });
    });
    var $author$project$Pages$Admin$PaymentSources$SourceValidation = 0;
    var $author$project$Pages$Admin$PaymentSources$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Hw;
        }, _Utils_Tuple2(0, 'Please pick a source.'))
    ]));
    var $author$project$Components$Practice$PaymentSources$initBankAccounts = F2(function(bankAccounts, model) {
        return _Utils_update(model, {
            pF: bankAccounts
        });
    });
    var $author$project$Components$Practice$PaymentSources$initCards = F2(function(cards, model) {
        return _Utils_update(model, {
            pQ: cards
        });
    });
    var $author$project$Components$Practice$PaymentSources$Deleted = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Practice$PaymentSources$None = 2;
    var $author$project$Components$Practice$PaymentSources$PaymentMethodCreated = 0;
    var $author$project$Components$Practice$PaymentSources$PaymentMethodDeleted = 1;
    var $author$project$Api$Employer$BankAccount$bankAccountPath = F2(function(basePath, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Employer$BankAccount$bankAccountsPath(basePath));
    });
    var $author$project$Api$Employer$BankAccount$delete = F4(function(basePath, apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_)));
    });
    var $author$project$Api$BankAccount$delete = F5(function(basePath, apiClient, session, bankAccount, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$BankAccount$delete, basePath, apiClient, $author$project$Api$BankAccount$id(bankAccount), toMsg) : A4($author$project$Api$Provider$BankAccount$delete, basePath, apiClient, $author$project$Api$BankAccount$id(bankAccount), toMsg);
    });
    var $author$project$Api$Employer$Card$cardPath = F2(function(basePath, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Employer$Card$cardsPath(basePath));
    });
    var $author$project$Api$Employer$Card$delete = F4(function(basePath, apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$Card$cardPath, basePath, id_)));
    });
    var $author$project$Api$Card$delete = F5(function(basePath, apiClient, session, card, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Card$delete, basePath, apiClient, $author$project$Api$Card$id(card), toMsg) : A4($author$project$Api$Provider$Card$delete, basePath, apiClient, $author$project$Api$Card$id(card), toMsg);
    });
    var $author$project$Api$Source$delete = F5(function(basePath, apiClient, session, source, toMsg) {
        switch(source.$){
            case 0:
                var card = source.a;
                return A5($author$project$Api$Card$delete, basePath, apiClient, session, card, toMsg);
            case 1:
                var bankAccount = source.a;
                return A5($author$project$Api$BankAccount$delete, basePath, apiClient, session, bankAccount, toMsg);
            default:
                return $elm$core$Platform$Cmd$none;
        }
    });
    var $author$project$Components$CreatePaymentMethodModal$BankAccount = 0;
    var $author$project$Components$CreatePaymentMethodModal$Card = 1;
    var $author$project$Components$CreatePaymentMethodModal$CardReader = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$GotCardReaders = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$GotPaymentInfoUpdate = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$GotSetupConfig = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$Loading = {
        $: 0
    };
    var $author$project$Components$CreatePaymentMethodModal$None = 1;
    var $author$project$Components$CreatePaymentMethodModal$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$PaymentMethodCreatedEvent = 0;
    var $author$project$Components$CreatePaymentMethodModal$Rainforest = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$Stripe = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished = {
        $: 9
    };
    var $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Employer$Company$One$acceptsAmex = function(_v0) {
        var one = _v0.b;
        return one.If;
    };
    var $author$project$Api$Provider$Company$One$acceptsAmex = function(_v0) {
        var record = _v0.b;
        return record.If;
    };
    var $author$project$Api$Company$acceptsAmex = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$acceptsAmex(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$acceptsAmex(company_);
        }
    };
    var $author$project$Components$CreatePaymentMethodModal$acceptsAmex = F2(function(owner, session) {
        if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) return true;
        else {
            if (!owner.$) {
                var company = owner.a;
                return $author$project$Api$Company$acceptsAmex(company);
            } else return true;
        }
    });
    var $author$project$Components$CreatePaymentMethodModal$andNoop = function(model) {
        return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 1,
            zi: model,
            at: _List_Nil
        };
    };
    var $0ui$elm_task_parallel$Task$Parallel$ItemLoaded = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $0ui$elm_task_parallel$Task$Parallel$ListState = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $0ui$elm_task_parallel$Task$Parallel$routeTo = F2(function(successMsg, failureMsg) {
        return A2($elm$core$Basics$composeR, $elm$core$Task$andThen(A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $elm$core$Result$Ok)), A2($elm$core$Basics$composeR, $elm$core$Task$onError(A2($elm$core$Basics$composeL, $elm$core$Task$succeed, $elm$core$Result$Err)), $elm$core$Task$perform(function(result) {
            if (!result.$) {
                var a = result.a;
                return successMsg(a);
            } else {
                var err = result.a;
                return failureMsg(err);
            }
        })));
    });
    var $0ui$elm_task_parallel$Task$Parallel$attemptList = function(_v0) {
        var tasks = _v0.$O;
        var onUpdates = _v0.Vr;
        var onSuccess = _v0.Vo;
        var onFailure = _v0.Vm;
        return _Utils_Tuple2(A2($0ui$elm_task_parallel$Task$Parallel$ListState, onSuccess, A2($elm$core$List$map, $elm$core$Basics$always($elm$core$Maybe$Nothing), tasks)), $elm$core$Platform$Cmd$batch(A2($elm$core$List$indexedMap, F2(function(index, task) {
            return A3($0ui$elm_task_parallel$Task$Parallel$routeTo, A2($elm$core$Basics$composeL, onUpdates, $0ui$elm_task_parallel$Task$Parallel$ItemLoaded(index)), onFailure, task);
        }), tasks)));
    };
    var $author$project$Ports$Stripe$StripeElementsOptions = {};
    var $elm$core$Maybe$destruct = F3(function(_default, func, maybe) {
        if (!maybe.$) {
            var a = maybe.a;
            return func(a);
        } else return _default;
    });
    var $author$project$Ports$Stripe$stripePortBuildAndMountElementWithSetupIntent = _Platform_outgoingPort('stripePortBuildAndMountElementWithSetupIntent', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('acceptAmex', $elm$json$Json$Encode$bool($.D6)),
            _Utils_Tuple2('name', $elm$json$Json$Encode$string($.zr)),
            _Utils_Tuple2('options', function($) {
                return $elm$json$Json$Encode$object(_List_Nil);
            }($.z9)),
            _Utils_Tuple2('practiceStripePublicKey', function($) {
                return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, $);
            }($.G2)),
            _Utils_Tuple2('selector', $elm$json$Json$Encode$string($.bi)),
            _Utils_Tuple2('setupIntentSecret', $elm$json$Json$Encode$string($.Hp)),
            _Utils_Tuple2('zip', $elm$json$Json$Encode$string($.tK))
        ]));
    });
    var $author$project$Ports$Stripe$buildAndMountElementWithSetupIntent = F6(function(practiceStripePublicKey, setupIntentSecret, selector, acceptAmex, name, zip) {
        return $author$project$Ports$Stripe$stripePortBuildAndMountElementWithSetupIntent({
            D6: acceptAmex,
            zr: name,
            z9: $author$project$Ports$Stripe$StripeElementsOptions,
            G2: practiceStripePublicKey,
            bi: selector,
            Hp: setupIntentSecret,
            tK: zip
        });
    });
    var $author$project$Api$Employer$Company$One$address = function(_v0) {
        var record = _v0.b;
        return record.II;
    };
    var $author$project$Api$Provider$Company$One$address = function(_v0) {
        var record = _v0.b;
        return record.II;
    };
    var $author$project$Api$Company$address = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$address(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$address(company_);
        }
    };
    var $author$project$Api$Employer$Practice$One$address = function(_v0) {
        var record = _v0;
        return record.II;
    };
    var $author$project$Api$Practice$address = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$address(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$address(practice_);
        }
    };
    var $author$project$Api$Provider$Patient$One$address = function(_v0) {
        var record = _v0.b;
        return record.II;
    };
    var $author$project$Api$Provider$Patient$One$billingAddress = function(_v0) {
        var record = _v0.b;
        return record.Ke;
    };
    var $author$project$Api$Employer$Company$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$Company$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$name(shared);
    };
    var $author$project$Api$Provider$Company$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$name(shared);
    };
    var $author$project$Api$Company$name = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$name(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$name(company_);
        }
    };
    var $author$project$Api$Employer$Practice$One$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Practice$name = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$name(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$name(practice_);
        }
    };
    var $author$project$Api$Provider$Patient$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$name(shared);
    };
    var $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner = function(owner) {
        switch(owner.$){
            case 1:
                var practice = owner.a;
                var zip = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, $author$project$Api$Practice$address(practice)));
                return _Utils_Tuple2($author$project$Api$Practice$name(practice), zip);
            case 0:
                var company = owner.a;
                var zip = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, $author$project$Api$Company$address(company)));
                return _Utils_Tuple2($author$project$Api$Company$name(company), zip);
            default:
                var patient = owner.a;
                var billing = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, $author$project$Api$Provider$Patient$One$billingAddress(patient)));
                var zip = !$elm$core$String$isEmpty(billing) ? billing : A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, $author$project$Api$Provider$Patient$One$address(patient)));
                return _Utils_Tuple2($author$project$Api$Provider$Patient$One$name(patient), zip);
        }
    };
    var $author$project$Components$CreatePaymentMethodModal$stripeElementId = 'card-element';
    var $author$project$Api$Employer$Practice$One$stripePublishableKey = function(_v0) {
        var record = _v0;
        return record.$l;
    };
    var $author$project$Api$Provider$Practice$Shared$stripePublishableKey = function(_v0) {
        var record = _v0;
        return record.$l;
    };
    var $author$project$Api$Provider$Practice$One$stripePublishableKey = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$stripePublishableKey(shared);
    };
    var $author$project$Api$Practice$stripePublishableKey = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$stripePublishableKey(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$stripePublishableKey(practice_);
        }
    };
    var $author$project$Components$CreatePaymentMethodModal$buildStripeElement = F4(function(practice, clientSecret, owner, session) {
        var _v0 = $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner(owner);
        var name = _v0.a;
        var zip = _v0.b;
        return A6($author$project$Ports$Stripe$buildAndMountElementWithSetupIntent, $author$project$Api$Practice$stripePublishableKey(practice), clientSecret, '#' + $author$project$Components$CreatePaymentMethodModal$stripeElementId, A2($author$project$Components$CreatePaymentMethodModal$acceptsAmex, owner, session), name, zip);
    });
    var $author$project$Components$CreatePaymentMethodModal$cardParamsFromReader = function(readCard) {
        return {
            KZ: $elm$core$Maybe$Nothing,
            MA: $elm$core$Maybe$Just(readCard.MA),
            ST: $elm$core$Maybe$Nothing,
            Vu: $elm$core$Maybe$Just(readCard.Vu),
            Wp: readCard.Wp
        };
    };
    var $author$project$Ports$Stripe$stripePortConfirmSetupIntent = _Platform_outgoingPort('stripePortConfirmSetupIntent', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('options', function($) {
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('billingOptions', function($) {
                        return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, function($) {
                            return $elm$json$Json$Encode$object(_List_fromArray([
                                _Utils_Tuple2('name', $elm$json$Json$Encode$string($.zr))
                            ]));
                        }, $);
                    }($.ab2))
                ]));
            }($.z9)),
            _Utils_Tuple2('selector', $elm$json$Json$Encode$string($.bi))
        ]));
    });
    var $author$project$Ports$Stripe$confirmSetupIntent = F2(function(selector, options) {
        return $author$project$Ports$Stripe$stripePortConfirmSetupIntent({
            z9: options,
            bi: selector
        });
    });
    var $author$project$Components$CreatePaymentMethodModal$Created = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CreatePaymentMethodModal$createCardFromReader = F5(function(basePath, apiClient, session, categories, cardParams) {
        return A5($author$project$Api$Card$create, basePath, apiClient, session, cardParams, $author$project$Components$CreatePaymentMethodModal$Created(categories));
    });
    var $author$project$Components$CreatePaymentMethodModal$PaymentMethodCreated = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Api$PaymentMethod$PaymentMethod = $elm$core$Basics$identity;
    var $author$project$Api$PaymentMethod$SharedRecordBankAccount = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$PaymentMethod$bankAccountOneDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$SharedRecordBankAccount, $author$project$Api$Provider$BankAccount$Shared$decoder), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$PaymentMethod$SharedRecordCard = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$PaymentMethod$cardOneDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$SharedRecordCard, $author$project$Api$Provider$Card$Shared$decoder), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$PaymentMethod$oneDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        $author$project$Api$PaymentMethod$cardOneDecoder,
        $author$project$Api$PaymentMethod$bankAccountOneDecoder
    ]));
    var $author$project$Api$PaymentMethod$paymentMethodsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'payment_methods'
        ]), basePath);
    };
    var $author$project$Api$PaymentMethod$create = F5(function(basePath, apiClient, param, setAsDefault, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment_method', $elm$json$Json$Encode$object(_Utils_ap($author$project$Api$PaymentProcessorParams$encode(param), function() {
                if (!setAsDefault.$) {
                    var value = setAsDefault.a;
                    return _List_fromArray([
                        _Utils_Tuple2('set_as_default', $elm$json$Json$Encode$bool(value))
                    ]);
                } else return _List_Nil;
            }())))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$PaymentMethod$oneDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$PaymentMethod$paymentMethodsPath(basePath))));
    });
    var $author$project$Components$CreatePaymentMethodModal$createPaymentMethod = F5(function(basePath, apiClient, paymentMethodParams, categories, setAsDefault) {
        return A5($author$project$Api$PaymentMethod$create, basePath, apiClient, paymentMethodParams, $elm$core$Maybe$Just(setAsDefault), $author$project$Components$CreatePaymentMethodModal$PaymentMethodCreated(categories));
    });
    var $elm_community$list_extra$List$Extra$remove = F2(function(x, xs) {
        if (!xs.b) return _List_Nil;
        else {
            var y = xs.a;
            var ys = xs.b;
            return _Utils_eq(x, y) ? ys : A2($elm$core$List$cons, y, A2($elm_community$list_extra$List$Extra$remove, x, ys));
        }
    });
    var $author$project$Components$CreatePaymentMethodModal$formFieldsUpdate = F3(function(cardReaders, field, fields) {
        switch(field.$){
            case 0:
                var cardInput = field.a;
                return _Utils_update(fields, {
                    cI: cardInput
                });
            case 1:
                var id = field.a;
                return _Utils_update(fields, {
                    ace: A2($elm_community$list_extra$List$Extra$find, function(cardReader_) {
                        return _Utils_eq($author$project$Api$Provider$CardReader$All$id(cardReader_), id);
                    }, cardReaders)
                });
            case 2:
                var category = field.a;
                var bool = field.b;
                var categories = bool ? A2($elm$core$List$cons, category, fields.K0) : A2($elm_community$list_extra$List$Extra$remove, category, fields.K0);
                return _Utils_update(fields, {
                    K0: categories
                });
            case 3:
                var brand = field.a;
                return _Utils_update(fields, {
                    v2: brand
                });
            default:
                var value = field.a;
                return _Utils_update(fields, {
                    gO: value
                });
        }
    });
    var $author$project$Components$CreatePaymentMethodModal$NameValidation = 0;
    var $author$project$Components$CreatePaymentMethodModal$CardBrandValidation = 2;
    var $author$project$Components$CreatePaymentMethodModal$validateCardBrand = F3(function(processorConfig, acceptsAmex_, fields) {
        var _v0 = _Utils_Tuple3(processorConfig, acceptsAmex_, fields.v2);
        if (_v0.a.$ === 2 && !_v0.b && _v0.c === 'AMERICAN_EXPRESS') return _List_fromArray([
            _Utils_Tuple2(2, 'American Express is not accepted.')
        ]);
        else return _List_Nil;
    });
    var $author$project$Components$CreatePaymentMethodModal$CardReaderValidation = 1;
    var $author$project$Components$CreatePaymentMethodModal$validateCardReader = function(fields) {
        var _v0 = _Utils_Tuple2(fields.cI, fields.ace);
        if (_v0.a === 1 && _v0.b.$ === 1) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            return _List_fromArray([
                _Utils_Tuple2(1, 'Please pick a card reader.')
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$CreatePaymentMethodModal$formFieldsValidator = F2(function(processorConfig, acceptsAmex_) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.zr;
            }, _Utils_Tuple2(0, 'Please enter a name.')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CreatePaymentMethodModal$validateCardReader),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$CreatePaymentMethodModal$validateCardBrand, processorConfig, acceptsAmex_))
        ]));
    });
    var $author$project$Api$Provider$Card$All$one_ = function(_v0) {
        var one = _v0;
        return one;
    };
    var $author$project$Api$Provider$Card$One$shared_ = function(_v0) {
        var shared = _v0.a;
        return shared;
    };
    var $author$project$Api$PaymentMethod$fromCardAll = function(card) {
        return $author$project$Api$PaymentMethod$SharedRecordCard($author$project$Api$Provider$Card$One$shared_($author$project$Api$Provider$Card$All$one_(card)));
    };
    var $author$project$Api$PaymentMethod$fromCardOne = function(card) {
        return $author$project$Api$PaymentMethod$SharedRecordCard($author$project$Api$Provider$Card$One$shared_(card));
    };
    var $author$project$Api$PaymentMethod$Rainforest = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$PaymentMethod$RainforestSetupConfig = F3(function(sessionKey, paymentMethodConfigId, allowedMethods) {
        return {
            abL: allowedMethods,
            af7: paymentMethodConfigId,
            ahi: sessionKey
        };
    });
    var $author$project$Api$PaymentMethod$Stripe = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$PaymentMethod$setupDecoder = $elm$json$Json$Decode$oneOf(_List_fromArray([
        A2($elm$json$Json$Decode$andThen, function(processor) {
            switch(processor){
                case 'stripe':
                    return A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$Stripe, A2($elm$json$Json$Decode$at, _List_fromArray([
                        'stripe_client_secret'
                    ]), $elm$json$Json$Decode$string));
                case 'rainforest':
                    return A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$Rainforest, A4($elm$json$Json$Decode$map3, $author$project$Api$PaymentMethod$RainforestSetupConfig, A2($elm$json$Json$Decode$at, _List_fromArray([
                        'session_key'
                    ]), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$at, _List_fromArray([
                        'payment_method_config_id'
                    ]), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$at, _List_fromArray([
                        'allowed_methods'
                    ]), $elm$json$Json$Decode$string)));
                default:
                    return $elm$json$Json$Decode$fail('Unsupported processor ' + processor);
            }
        }, A2($elm$json$Json$Decode$at, _List_fromArray([
            'payment_processor'
        ]), $elm$json$Json$Decode$string)),
        A2($elm$json$Json$Decode$map, $author$project$Api$PaymentMethod$Stripe, A2($elm$json$Json$Decode$at, _List_fromArray([
            'stripe_client_secret'
        ]), $elm$json$Json$Decode$string))
    ]));
    var $author$project$Api$PaymentMethod$getClientSecret = F3(function(basePath, apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$PaymentMethod$setupDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'setup'
        ]), $author$project$Api$PaymentMethod$paymentMethodsPath(basePath))));
    });
    var $author$project$Api$Employer$Company$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$Company$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$id(shared);
    };
    var $author$project$Api$Provider$Company$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$id(shared);
    };
    var $author$project$Api$Company$id = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$id(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$id(company_);
        }
    };
    var $author$project$Api$Employer$Practice$One$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Practice$id = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$id(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$id(practice_);
        }
    };
    var $author$project$Api$Provider$Patient$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$id(shared);
    };
    var $author$project$Components$CreatePaymentMethodModal$Manual = 0;
    var $author$project$Api$Provider$Source$Defaults$HintCustomer = 0;
    var $author$project$Api$Provider$Source$Defaults$Network = 1;
    var $author$project$Api$Practice$isNetwork = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$isNetwork(practice_);
        } else return false;
    };
    var $author$project$Components$Practice$PaymentCategoriesPicker$allCategories = function(practice) {
        return A2($elm$core$List$cons, 0, $author$project$Api$Practice$isNetwork(practice) ? _List_fromArray([
            1
        ]) : _List_Nil);
    };
    var $author$project$Components$CreatePaymentMethodModal$initFormFields = F4(function(practice, owner, session, processorConfig) {
        var processorElement = function() {
            switch(processorConfig.$){
                case 1:
                    var clientSecret = processorConfig.a;
                    return A4($author$project$Components$CreatePaymentMethodModal$buildStripeElement, practice, clientSecret, owner, session);
                case 2:
                    return $elm$core$Platform$Cmd$none;
                default:
                    return $elm$core$Platform$Cmd$none;
            }
        }();
        var _v0 = $author$project$Components$CreatePaymentMethodModal$getNameAndZipWithOwner(owner);
        var name = _v0.a;
        return _Utils_Tuple2({
            v2: '',
            cI: 0,
            ace: $elm$core$Maybe$Nothing,
            K0: function() {
                if (owner.$ === 1) {
                    var prac = owner.a;
                    return $author$project$Components$Practice$PaymentCategoriesPicker$allCategories(prac);
                } else return _List_Nil;
            }(),
            zr: name,
            gO: true
        }, processorElement);
    });
    var $author$project$Api$Employer$Company$One$acceptsAch = function(_v0) {
        var record = _v0.b;
        return record.Ie;
    };
    var $author$project$Api$Provider$Company$One$acceptsAch = function(_v0) {
        var record = _v0.b;
        return record.Ie;
    };
    var $author$project$Api$Company$acceptsAch = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$acceptsAch(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$acceptsAch(company_);
        }
    };
    var $author$project$Components$CreatePaymentMethodModal$acceptsAch = F2(function(owner, session) {
        if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) return true;
        else {
            if (!owner.$) {
                var company = owner.a;
                return $author$project$Api$Company$acceptsAch(company);
            } else return true;
        }
    });
    var $author$project$Api$Employer$Company$One$acceptsCards = function(_v0) {
        var record = _v0.b;
        return record.Ig;
    };
    var $author$project$Api$Provider$Company$One$acceptsCards = function(_v0) {
        var record = _v0.b;
        return record.Ig;
    };
    var $author$project$Api$Company$acceptsCards = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$acceptsCards(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$acceptsCards(company_);
        }
    };
    var $author$project$Components$CreatePaymentMethodModal$acceptsCards = F2(function(owner, session) {
        if (!$author$project$Api$Platform$Session$One$organizationIsCompany(session)) return true;
        else {
            if (!owner.$) {
                var company = owner.a;
                return $author$project$Api$Company$acceptsCards(company);
            } else return true;
        }
    });
    var $author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled = F2(function(owner, session) {
        return !A2($author$project$Components$CreatePaymentMethodModal$acceptsCards, owner, session) && !A2($author$project$Components$CreatePaymentMethodModal$acceptsAch, owner, session);
    });
    var $author$project$Api$Provider$Patient$One$requestPayInfoSentAt = function(_v0) {
        var record = _v0.b;
        return record.YF;
    };
    var $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt = function(_v0) {
        var record = _v0;
        return record.YF;
    };
    var $author$project$Api$Data$stringifyPath = function(_v0) {
        var path = _v0;
        return $elm$core$String$concat(path);
    };
    var $author$project$Ports$Rainforest$rainforestSubmitPaymentMethod = _Platform_outgoingPort('rainforestSubmitPaymentMethod', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Rainforest$submitPaymentMethod = $author$project$Ports$Rainforest$rainforestSubmitPaymentMethod(0);
    var $elm$core$Task$mapError = F2(function(convert, task) {
        return A2($elm$core$Task$onError, A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert), task);
    });
    var $author$project$Api$Provider$Source$Defaults$categoryName = function(category) {
        if (!category) return 'hint_customer';
        else return 'network';
    };
    var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
    var $elm$http$Http$resultToTask = function(result) {
        if (!result.$) {
            var a = result.a;
            return $elm$core$Task$succeed(a);
        } else {
            var x = result.a;
            return $elm$core$Task$fail(x);
        }
    };
    var $elm$http$Http$task = function(r) {
        return A3(_Http_toTask, 0, $elm$http$Http$resultToTask, {
            abF: false,
            fb: r.fb,
            Pb: r.agS,
            iL: r.iL,
            Gk: r.Gk,
            HQ: r.HQ,
            tu: $elm$core$Maybe$Nothing,
            aaT: r.aaT
        });
    };
    var $author$project$Api$Data$taskResolver = F2(function(decoder, response) {
        var result = A2($author$project$Api$Data$handleJsonResponse, decoder, response);
        if (!result.$) {
            var _v1 = result.a;
            var value = _v1.a;
            var headers = _v1.b;
            return $elm$core$Result$Ok(A2($author$project$Api$Data$Success, value, headers));
        } else {
            var error = result.a;
            return $elm$core$Result$Err($author$project$Api$Data$Failure(error));
        }
    });
    var $author$project$Api$Data$taskRequest = F4(function(method, client, decoder, request) {
        return $elm$http$Http$task({
            fb: $author$project$Api$Data$requestBody(request),
            iL: A2($author$project$Api$Data$requestHeaders, client, request),
            Gk: $elm$core$String$toUpper(method),
            agS: $elm$http$Http$stringResolver($author$project$Api$Data$taskResolver(decoder)),
            HQ: $elm$core$Maybe$Nothing,
            aaT: A2($author$project$Api$Data$requestToUrl, client, request)
        });
    });
    var $author$project$Api$Data$postTask = $author$project$Api$Data$taskRequest('post');
    var $author$project$Api$Provider$BankAccount$updateDefaultTask = F4(function(basePath, apiClient, id_, category) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('category', $elm$json$Json$Encode$string($author$project$Api$Provider$Source$Defaults$categoryName(category)))
        ]));
        return A3($author$project$Api$Data$postTask, apiClient, $author$project$Api$Provider$BankAccount$Shared$decoder, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'default'
        ]), A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)))));
    });
    var $author$project$Api$Provider$Card$updateDefaultTask = F4(function(basePath, apiClient, id_, category) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('category', $elm$json$Json$Encode$string($author$project$Api$Provider$Source$Defaults$categoryName(category)))
        ]));
        return A3($author$project$Api$Data$postTask, apiClient, $author$project$Api$Provider$Card$Shared$decoder, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'default'
        ]), A2($author$project$Api$Provider$Card$cardPath, basePath, id_)))));
    });
    var $author$project$Api$PaymentMethod$updateDefaultTask = F4(function(basePath, apiClient, paymentMethod, category) {
        if (!paymentMethod.$) {
            var card = paymentMethod.a;
            return A2($elm$core$Task$mapError, function(dataSuccesCard) {
                return A2($author$project$Api$Data$map, function(card_) {
                    return $author$project$Api$PaymentMethod$SharedRecordCard(card_);
                }, dataSuccesCard);
            }, A2($elm$core$Task$map, function(dataSuccesCard) {
                return A2($author$project$Api$Data$map, function(card_) {
                    return $author$project$Api$PaymentMethod$SharedRecordCard(card_);
                }, dataSuccesCard);
            }, A4($author$project$Api$Provider$Card$updateDefaultTask, basePath, apiClient, $author$project$Api$Provider$Card$Shared$id(card), category)));
        } else {
            var bankAccount = paymentMethod.a;
            return A2($elm$core$Task$mapError, function(dataSuccesBankAccount) {
                return A2($author$project$Api$Data$map, function(bankAccount_) {
                    return $author$project$Api$PaymentMethod$SharedRecordBankAccount(bankAccount_);
                }, dataSuccesBankAccount);
            }, A2($elm$core$Task$map, function(dataSuccesBankAccount) {
                return A2($author$project$Api$Data$map, function(bankAccount_) {
                    return $author$project$Api$PaymentMethod$SharedRecordBankAccount(bankAccount_);
                }, dataSuccesBankAccount);
            }, A4($author$project$Api$Provider$BankAccount$updateDefaultTask, basePath, apiClient, $author$project$Api$Provider$BankAccount$Shared$id(bankAccount), category)));
        }
    });
    var $0ui$elm_task_parallel$Task$Parallel$toCmd = A2($elm$core$Basics$composeR, $elm$core$Maybe$map(A2($elm$core$Basics$composeR, $elm$core$Task$succeed, $elm$core$Task$perform($elm$core$Basics$identity))), $elm$core$Maybe$withDefault($elm$core$Platform$Cmd$none));
    var $0ui$elm_task_parallel$Task$Parallel$updateList = F2(function(_v0, _v1) {
        var onSuccess = _v0.a;
        var items = _v0.b;
        var index = _v1.a;
        var newItem = _v1.b;
        var updatedItems = A2($elm$core$List$indexedMap, F2(function(i, maybeItem) {
            return _Utils_eq(i, index) ? $elm$core$Maybe$Just(newItem) : maybeItem;
        }), items);
        return A2($elm$core$List$any, $elm$core$Basics$eq($elm$core$Maybe$Nothing), updatedItems) ? _Utils_Tuple2(A2($0ui$elm_task_parallel$Task$Parallel$ListState, onSuccess, updatedItems), $elm$core$Platform$Cmd$none) : _Utils_Tuple2(A2($0ui$elm_task_parallel$Task$Parallel$ListState, onSuccess, updatedItems), $0ui$elm_task_parallel$Task$Parallel$toCmd($elm$core$Maybe$Just(onSuccess(A2($elm$core$List$filterMap, $elm$core$Basics$identity, updatedItems)))));
    });
    var $author$project$Components$CreatePaymentMethodModal$CardBrand = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$updateRainforest = F5(function(apiClient, basePath, msg, config, model) {
        switch(msg.$){
            case 0:
                var rainforestId = msg.a;
                var _v1 = $author$project$Utils$Form$fields(model.PU);
                var setAsDefault = _v1.gO;
                return _Utils_Tuple2(_Utils_update(model, {
                    au: $author$project$Components$CreatePaymentMethodModal$Rainforest(config)
                }), A5($author$project$Components$CreatePaymentMethodModal$createPaymentMethod, basePath, apiClient, $author$project$Api$PaymentProcessorParams$rainforestParams(rainforestId), _List_Nil, setAsDefault));
            case 1:
                var isValid = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    au: $author$project$Components$CreatePaymentMethodModal$Rainforest(_Utils_update(config, {
                        yt: isValid
                    }))
                }), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2(_Utils_update(model, {
                    au: $author$project$Components$CreatePaymentMethodModal$Rainforest(_Utils_update(config, {
                        c_: false
                    }))
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var elementType = msg.a;
                var selectedPaymentOption = function() {
                    switch(elementType){
                        case 'ACH':
                            return 0;
                        case 'CARD':
                            return 1;
                        default:
                            return 1;
                    }
                }();
                return _Utils_Tuple2(_Utils_update(model, {
                    au: $author$project$Components$CreatePaymentMethodModal$Rainforest(config),
                    dh: selectedPaymentOption
                }), $elm$core$Platform$Cmd$none);
            default:
                var brand = msg.a;
                var field = $author$project$Components$CreatePaymentMethodModal$CardBrand(brand);
                var cardReaders = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.hJ));
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders), field, model.PU);
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$CreatePaymentMethodModal$update = F3(function(apiClient, msg, model) {
        if (model.$ === 1) {
            var open = model.a;
            switch(msg.$){
                case 1:
                    return $author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Closed);
                case 17:
                    var elementType = msg.a;
                    var _v2 = open.au;
                    if (_v2.$ === 1) {
                        var selectedPaymentOption = function() {
                            switch(elementType){
                                case 'us_bank_account':
                                    return 0;
                                case 'card':
                                    return 1;
                                default:
                                    return 1;
                            }
                        }();
                        return $author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                            dh: selectedPaymentOption
                        })));
                    } else return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
                case 2:
                    var field = msg.a;
                    var cmd = function() {
                        var _v4 = _Utils_Tuple2(field, open.au);
                        if (!_v4.a.$ && !_v4.a.a && _v4.b.$ === 1) {
                            var _v5 = _v4.a.a;
                            var secret = _v4.b.a;
                            return A4($author$project$Components$CreatePaymentMethodModal$buildStripeElement, open.W1, secret, open.VM, open.Z$);
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    var cardReaders = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(open.hJ));
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders), field, open.PU);
                    return {
                        EQ: cmd,
                        adu: 1,
                        zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                            PU: newForm
                        })),
                        at: _List_Nil
                    };
                case 3:
                    var _v6 = A2($author$project$Utils$Form$validate, A2($author$project$Components$CreatePaymentMethodModal$formFieldsValidator, open.au, A2($author$project$Components$CreatePaymentMethodModal$acceptsAmex, open.VM, open.Z$)), open.PU);
                    if (!_v6.$) {
                        var _v7 = _v6.a;
                        var newForm = _v7.a;
                        var validFormFields = _v7.b;
                        var _v8 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                        var cardInput = _v8.cI;
                        var cardReader = _v8.ace;
                        var _v9 = function() {
                            var _v10 = _Utils_Tuple2(cardInput, cardReader);
                            if (!_v10.a) {
                                var _v11 = _v10.a;
                                var portCall = function() {
                                    var _v12 = open.au;
                                    switch(_v12.$){
                                        case 1:
                                            return A2($author$project$Ports$Stripe$confirmSetupIntent, '#' + $author$project$Components$CreatePaymentMethodModal$stripeElementId, {
                                                ab2: $elm$core$Maybe$Nothing
                                            });
                                        case 2:
                                            return $author$project$Ports$Rainforest$submitPaymentMethod;
                                        default:
                                            return $elm$core$Platform$Cmd$none;
                                    }
                                }();
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, portCall, $author$project$Api$Data$Loading);
                            } else if (!_v10.b.$) {
                                var _v13 = _v10.a;
                                var cardReader_ = _v10.b.a;
                                var owner = function() {
                                    var _v14 = open.VM;
                                    switch(_v14.$){
                                        case 0:
                                            var company = _v14.a;
                                            return $author$project$Components$CardReader$ConnectingModal$Company($author$project$Api$Company$id(company));
                                        case 1:
                                            var practice = _v14.a;
                                            return $author$project$Components$CardReader$ConnectingModal$Practice($author$project$Api$Practice$id(practice));
                                        default:
                                            var patient = _v14.a;
                                            return $author$project$Components$CardReader$ConnectingModal$Patient($author$project$Api$Provider$Patient$One$id(patient));
                                    }
                                }();
                                return A2($author$project$Utils$Tuple3$fromTuple2, open.j_, A3($elm$core$Tuple$mapBoth, $elm$core$Maybe$Just, $elm$core$Platform$Cmd$map($author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg), A7($author$project$Components$CardReader$ConnectingModal$init, apiClient, open.Z$, open.F3, open.sp, cardReader_, owner, true)));
                            } else {
                                var _v15 = _v10.a;
                                var _v16 = _v10.b;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, open.j_);
                            }
                        }();
                        var connectingModal = _v9.a;
                        var cmd = _v9.b;
                        var saveRequest = _v9.c;
                        return {
                            EQ: cmd,
                            adu: 1,
                            zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                                hW: connectingModal,
                                PU: newForm,
                                j_: saveRequest
                            })),
                            at: _List_Nil
                        };
                    } else {
                        var newForm = _v6.a;
                        return $author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                            PU: newForm
                        })));
                    }
                case 4:
                    var cardPaymentMethodResult = msg.a;
                    if (!cardPaymentMethodResult.$) {
                        var stripeCardPaymentMethod = cardPaymentMethodResult.a;
                        var params = $author$project$Api$PaymentProcessorParams$stripeParams(stripeCardPaymentMethod.aef);
                        var _v18 = $author$project$Utils$Form$fields(open.PU);
                        var categories = _v18.K0;
                        var setAsDefault = _v18.gO;
                        return {
                            EQ: A5($author$project$Components$CreatePaymentMethodModal$createPaymentMethod, open.vK, apiClient, params, categories, setAsDefault),
                            adu: 1,
                            zi: model,
                            at: _List_Nil
                        };
                    } else {
                        var errorMessage = cardPaymentMethodResult.a;
                        var errorString = A2($elm$core$String$contains, 'billing_details[name]', errorMessage) ? 'Please enter a valid card holder name.' : errorMessage;
                        return {
                            EQ: A3($author$project$Api$PaymentMethod$getClientSecret, open.vK, apiClient, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig),
                            adu: 1,
                            zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                                j_: $author$project$Api$Data$NotAsked
                            })),
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 1, errorString)
                            ])
                        };
                    }
                case 5:
                    var categories = msg.a;
                    var response = msg.b;
                    if (response.$ === 3) {
                        var card = response.a;
                        var _v20 = $author$project$Utils$Form$fields(open.PU);
                        var setAsDefault = _v20.gO;
                        var tasks = function() {
                            if (setAsDefault) switch(card.$){
                                case 0:
                                    var card_ = card.a;
                                    return A2($elm$core$List$map, function(category) {
                                        return A4($author$project$Api$PaymentMethod$updateDefaultTask, open.vK, apiClient, $author$project$Api$PaymentMethod$fromCardOne(card_), category);
                                    }, categories);
                                case 1:
                                    var card_ = card.a;
                                    return A2($elm$core$List$map, function(category) {
                                        return A4($author$project$Api$PaymentMethod$updateDefaultTask, open.vK, apiClient, $author$project$Api$PaymentMethod$fromCardAll(card_), category);
                                    }, categories);
                                case 2:
                                    return _List_Nil;
                                default:
                                    return _List_Nil;
                            }
                            else return _List_Nil;
                        }();
                        var _v21 = $elm$core$List$isEmpty(tasks) ? _Utils_Tuple2($elm$core$Maybe$Nothing, A2($elm$core$Task$perform, function(_v22) {
                            return $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished;
                        }, $elm$time$Time$now)) : A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, $0ui$elm_task_parallel$Task$Parallel$attemptList({
                            Vm: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed,
                            Vo: $elm$core$Basics$always($author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished),
                            Vr: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated,
                            $O: tasks
                        }));
                        var updateDefaultsState = _v21.a;
                        var updateDefaultsCmd = _v21.b;
                        return {
                            EQ: updateDefaultsCmd,
                            adu: 1,
                            zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                                o1: updateDefaultsState
                            })),
                            at: _List_Nil
                        };
                    } else return $author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                        j_: response
                    })));
                case 6:
                    var categories = msg.a;
                    var response = msg.b;
                    switch(response.$){
                        case 3:
                            var paymentMethod = response.a;
                            var tasks = function() {
                                if ($author$project$Api$Data$stringifyPath(open.vK) === 'employer') return _List_Nil;
                                else {
                                    var _v27 = $author$project$Utils$Form$fields(open.PU);
                                    var setAsDefault = _v27.gO;
                                    return setAsDefault ? A2($elm$core$List$map, function(category) {
                                        return A4($author$project$Api$PaymentMethod$updateDefaultTask, open.vK, apiClient, paymentMethod, category);
                                    }, categories) : _List_Nil;
                                }
                            }();
                            var _v25 = $elm$core$List$isEmpty(tasks) ? _Utils_Tuple2($elm$core$Maybe$Nothing, A2($elm$core$Task$perform, function(_v26) {
                                return $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished;
                            }, $elm$time$Time$now)) : A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, $0ui$elm_task_parallel$Task$Parallel$attemptList({
                                Vm: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFailed,
                                Vo: $elm$core$Basics$always($author$project$Components$CreatePaymentMethodModal$UpdateDefaultsFinished),
                                Vr: $author$project$Components$CreatePaymentMethodModal$UpdateDefaultsUpdated,
                                $O: tasks
                            }));
                            var updateDefaultsState = _v25.a;
                            var updateDefaultsCmd = _v25.b;
                            return {
                                EQ: updateDefaultsCmd,
                                adu: 1,
                                zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                                    o1: updateDefaultsState
                                })),
                                at: _List_Nil
                            };
                        case 2:
                            return {
                                EQ: A3($author$project$Api$PaymentMethod$getClientSecret, open.vK, apiClient, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig),
                                adu: 1,
                                zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                                    j_: $author$project$Api$Data$NotAsked
                                })),
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                zi: model,
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                    }
                case 7:
                    var updateDefaultsMsg = msg.a;
                    var _v28 = function() {
                        var _v29 = open.o1;
                        if (!_v29.$) {
                            var updateDefaultsState_ = _v29.a;
                            return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($0ui$elm_task_parallel$Task$Parallel$updateList, updateDefaultsState_, updateDefaultsMsg));
                        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                    }();
                    var newUpdateDefaultsState = _v28.a;
                    var updateDefaultsCmd = _v28.b;
                    return {
                        EQ: updateDefaultsCmd,
                        adu: 1,
                        zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                            o1: newUpdateDefaultsState
                        })),
                        at: _List_Nil
                    };
                case 8:
                    var response = msg.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: model,
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                case 9:
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: $author$project$Components$CreatePaymentMethodModal$Closed,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Payment Method successfully added.')
                        ])
                    };
                case 10:
                    var response = msg.a;
                    return {
                        EQ: $author$project$Ports$LocalStorage$getItem('last-used-card-reader'),
                        adu: 1,
                        zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                            hJ: response
                        })),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                case 11:
                    var _v30 = msg.a;
                    var key = _v30.a;
                    var value = _v30.b;
                    var _v31 = _Utils_Tuple2(key, value);
                    if (_v31.a === 'last-used-card-reader' && !_v31.b.$) {
                        var lastUsedCardReaderId = _v31.b.a;
                        var cardReaders = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(open.hJ));
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CreatePaymentMethodModal$formFieldsUpdate(cardReaders), $author$project$Components$CreatePaymentMethodModal$CardReader(lastUsedCardReaderId), open.PU);
                        return $author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                            PU: newForm
                        })));
                    } else return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
                case 12:
                    var subMsg = msg.a;
                    var _v32 = open.hW;
                    if (!_v32.$) {
                        var connectingModal = _v32.a;
                        var connectingModalResult = A3($author$project$Components$CardReader$ConnectingModal$update, apiClient, subMsg, connectingModal);
                        var _v33 = function() {
                            var _v34 = connectingModalResult.adu;
                            switch(_v34.$){
                                case 1:
                                    var card = _v34.a;
                                    var cardParams = $author$project$Components$CreatePaymentMethodModal$cardParamsFromReader(card);
                                    var _v35 = $author$project$Utils$Form$fields(open.PU);
                                    var categories = _v35.K0;
                                    return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A5($author$project$Components$CreatePaymentMethodModal$createCardFromReader, open.vK, apiClient, open.Z$, categories, cardParams));
                                case 0:
                                    return _Utils_Tuple3($elm$core$Maybe$Nothing, open.j_, $elm$core$Platform$Cmd$none);
                                default:
                                    return _Utils_Tuple3($elm$core$Maybe$Just(connectingModalResult.zi), open.j_, $elm$core$Platform$Cmd$none);
                            }
                        }();
                        var connectingModal_ = _v33.a;
                        var saveRequest = _v33.b;
                        var cmd = _v33.c;
                        return {
                            EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                                A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg, connectingModalResult.EQ),
                                cmd
                            ])),
                            adu: 1,
                            zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                                hW: connectingModal_,
                                j_: saveRequest
                            })),
                            at: connectingModalResult.at
                        };
                    } else return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
                case 0:
                    return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
                case 13:
                    var response = msg.a;
                    if (response.$ === 3) {
                        var setup = response.a;
                        var config = function() {
                            if (!setup.$) {
                                var secret = setup.a;
                                return $author$project$Components$CreatePaymentMethodModal$Stripe(secret);
                            } else {
                                var sessionKey = setup.a.ahi;
                                var paymentMethodConfigId = setup.a.af7;
                                var allowedMethods = setup.a.abL;
                                return $author$project$Components$CreatePaymentMethodModal$Rainforest({
                                    abL: allowedMethods,
                                    c_: true,
                                    yt: false,
                                    af7: paymentMethodConfigId,
                                    ahi: sessionKey
                                });
                            }
                        }();
                        var _v37 = A4($author$project$Components$CreatePaymentMethodModal$initFormFields, open.W1, open.VM, open.Z$, config);
                        var formFields = _v37.a;
                        var formFieldsCmd = _v37.b;
                        return {
                            EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                                formFieldsCmd,
                                $author$project$Ports$LocalStorage$getItem('last-used-card-reader')
                            ])),
                            adu: 1,
                            zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                                PU: $author$project$Utils$Form$init(formFields),
                                c_: false,
                                au: config
                            })),
                            at: _List_Nil
                        };
                    } else return function(res) {
                        return _Utils_update(res, {
                            at: $author$project$OutMsg$handleErrorResponse(response)
                        });
                    }($author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                        c_: false
                    }))));
                case 16:
                    var rainforestMsg = msg.a;
                    var _v39 = open.au;
                    if (_v39.$ === 2) {
                        var config = _v39.a;
                        return function(_v40) {
                            var m = _v40.a;
                            var cmd = _v40.b;
                            return {
                                EQ: cmd,
                                adu: 1,
                                zi: m,
                                at: _List_Nil
                            };
                        }(A2($elm$core$Tuple$mapFirst, $author$project$Components$CreatePaymentMethodModal$Open, A5($author$project$Components$CreatePaymentMethodModal$updateRainforest, apiClient, open.vK, rainforestMsg, config, open)));
                    } else return $author$project$Components$CreatePaymentMethodModal$andNoop($author$project$Components$CreatePaymentMethodModal$Open(open));
                case 14:
                    var cmd = function() {
                        var _v41 = open.VM;
                        if (_v41.$ === 2) {
                            var patient = _v41.a;
                            return A4($author$project$Api$Provider$Patient$requestPaymentInfo, apiClient, $author$project$Api$Provider$Patient$One$id(patient), $elm$core$Maybe$Nothing, $author$project$Components$CreatePaymentMethodModal$GotPaymentInfoUpdate);
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    return {
                        EQ: cmd,
                        adu: 1,
                        zi: model,
                        at: _List_Nil
                    };
                default:
                    var response = msg.a;
                    if (response.$ === 3) {
                        var requestPayInfo = response.a;
                        var _v43 = open.VM;
                        if (_v43.$ === 2) {
                            var patient = _v43.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                                    AC: $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt(requestPayInfo)
                                })),
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, 'An email has been sent to ' + ($author$project$Api$Provider$Patient$One$name(patient) + ' requesting new payment information.'))
                                ])
                            };
                        } else return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 1,
                            zi: model,
                            at: $author$project$OutMsg$handleErrorResponse(response)
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: model,
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
            }
        } else {
            if (!msg.$) {
                var openOptions = msg.a;
                var useCardReaders = openOptions.tD && $author$project$Api$Practice$usesCardReaders(openOptions.W1);
                var patientRequestInfoSentAt = function() {
                    var _v46 = openOptions.VM;
                    if (_v46.$ === 2) {
                        var patient = _v46.a;
                        return $author$project$Api$Provider$Patient$One$requestPayInfoSentAt(patient);
                    } else return $elm$core$Maybe$Nothing;
                }();
                var cardReaderCmd = useCardReaders ? A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Components$CreatePaymentMethodModal$GotCardReaders) : $elm$core$Platform$Cmd$none;
                var _v45 = A4($author$project$Components$CreatePaymentMethodModal$initFormFields, openOptions.W1, openOptions.VM, openOptions.Z$, $author$project$Components$CreatePaymentMethodModal$Loading);
                var formFields = _v45.a;
                var formFieldsCmd = _v45.b;
                var open = {
                    vK: openOptions.vK,
                    hJ: $author$project$Api$Data$Loading,
                    hW: $elm$core$Maybe$Nothing,
                    PU: $author$project$Utils$Form$init(formFields),
                    qW: openOptions.qW,
                    F3: openOptions.F3,
                    c_: true,
                    VM: openOptions.VM,
                    AC: patientRequestInfoSentAt,
                    W1: openOptions.W1,
                    au: $author$project$Components$CreatePaymentMethodModal$Loading,
                    sp: openOptions.sp,
                    j_: $author$project$Api$Data$NotAsked,
                    dh: 1,
                    Z$: openOptions.Z$,
                    HO: openOptions.HO,
                    o1: $elm$core$Maybe$Nothing,
                    tD: useCardReaders
                };
                var setupIntentCmd = !A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, openOptions.VM, openOptions.Z$) ? A3($author$project$Api$PaymentMethod$getClientSecret, open.vK, apiClient, $author$project$Components$CreatePaymentMethodModal$GotSetupConfig) : $elm$core$Platform$Cmd$none;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formFieldsCmd,
                        cardReaderCmd,
                        setupIntentCmd
                    ])),
                    adu: 1,
                    zi: $author$project$Components$CreatePaymentMethodModal$Open(_Utils_update(open, {
                        c_: !A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, openOptions.VM, openOptions.Z$)
                    })),
                    at: _List_Nil
                };
            } else return $author$project$Components$CreatePaymentMethodModal$andNoop(model);
        }
    });
    var $author$project$Components$Practice$PaymentSources$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var createPaymentMethodModalResult = A3($author$project$Components$CreatePaymentMethodModal$update, apiClient, subMsg, model.lG);
                var _v1 = function() {
                    var _v2 = createPaymentMethodModalResult.adu;
                    if (!_v2) return _Utils_Tuple3(_Utils_update(model, {
                        pF: $author$project$Api$Data$Loading,
                        pQ: $author$project$Api$Data$Loading
                    }), $elm$core$Platform$Cmd$none, 0);
                    else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 2);
                }();
                var newModel = _v1.a;
                var cmd = _v1.b;
                var event = _v1.c;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg, createPaymentMethodModalResult.EQ),
                        cmd
                    ])),
                    adu: event,
                    zi: _Utils_update(newModel, {
                        lG: createPaymentMethodModalResult.zi
                    }),
                    at: createPaymentMethodModalResult.at
                };
            case 1:
                var source = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        fw: $elm$core$Maybe$Just(source)
                    }),
                    at: _List_Nil
                };
            case 3:
                var source = msg.a;
                var confirmed = msg.b;
                return confirmed ? {
                    EQ: A5($author$project$Api$Source$delete, $author$project$Api$Data$providerPath, apiClient, model.Z$, source, $author$project$Components$Practice$PaymentSources$Deleted(source)),
                    adu: 2,
                    zi: _Utils_update(model, {
                        fw: $elm$core$Maybe$Nothing,
                        dW: A2($elm$core$Set$insert, $author$project$Api$Source$id(source), model.dW)
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        fw: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            default:
                var source = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 1,
                            zi: _Utils_update(model, {
                                pF: $author$project$Api$Data$Loading,
                                pQ: $author$project$Api$Data$Loading,
                                fw: $elm$core$Maybe$Nothing,
                                dW: A2($elm$core$Set$remove, $author$project$Api$Source$id(source), model.dW)
                            }),
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Source successfully deleted')
                            ])
                        };
                    case 2:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 2,
                            zi: _Utils_update(model, {
                                dW: A2($elm$core$Set$remove, $author$project$Api$Source$id(source), model.dW)
                            }),
                            at: $author$project$OutMsg$handleErrorResponse(response)
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 2,
                            zi: model,
                            at: _List_Nil
                        };
                }
        }
    });
    var $author$project$Pages$Admin$PaymentSources$Updated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$BankAccount$EmployerOne = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$BankAccount$ProviderOne = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$BankAccount$updateDefault = F4(function(basePath, apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$BankAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'default'
        ]), A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_))));
    });
    var $author$project$Api$Provider$BankAccount$updateDefault = F5(function(basePath, apiClient, id_, category, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('category', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$categoryName, category)))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BankAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'default'
        ]), A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_)))));
    });
    var $author$project$Api$BankAccount$updateDefault = F6(function(basePath, apiClient, session, bankAccount, category, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$BankAccount$updateDefault, basePath, apiClient, $author$project$Api$BankAccount$id(bankAccount), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$BankAccount$EmployerOne))) : A5($author$project$Api$Provider$BankAccount$updateDefault, basePath, apiClient, $author$project$Api$BankAccount$id(bankAccount), category, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$BankAccount$ProviderOne)));
    });
    var $author$project$Api$Employer$Card$updateDefault = F4(function(basePath, apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$Card$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'default'
        ]), A2($author$project$Api$Employer$Card$cardPath, basePath, id_))));
    });
    var $author$project$Api$Provider$Card$updateDefault = F5(function(basePath, apiClient, id_, category, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('category', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$categoryName, category)))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Card$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'default'
        ]), A2($author$project$Api$Provider$Card$cardPath, basePath, id_)))));
    });
    var $author$project$Api$Card$updateDefault = F6(function(basePath, apiClient, session, card, category, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Card$updateDefault, basePath, apiClient, $author$project$Api$Card$id(card), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A5($author$project$Api$Provider$Card$updateDefault, basePath, apiClient, $author$project$Api$Card$id(card), category, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
    });
    var $author$project$Api$Source$updateDefault = F6(function(basePath, apiClient, session, source, category, toMsg) {
        switch(source.$){
            case 0:
                var card = source.a;
                return A6($author$project$Api$Card$updateDefault, basePath, apiClient, session, card, category, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Source$Card)));
            case 1:
                var bankAccount = source.a;
                return A6($author$project$Api$BankAccount$updateDefault, basePath, apiClient, session, bankAccount, category, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Source$BankAccount)));
            default:
                return $elm$core$Platform$Cmd$none;
        }
    });
    var $author$project$Pages$Admin$PaymentSources$updateSource = F3(function(apiClient, session, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var _v0 = fields.Hw;
        if (!_v0.$) {
            var source = _v0.a;
            return A6($author$project$Api$Source$updateDefault, $author$project$Api$Data$providerPath, apiClient, session, source, $elm$core$Maybe$Just(fields.EL), $author$project$Pages$Admin$PaymentSources$Updated);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Pages$Admin$PaymentSources$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pQ: response,
                    ck: A2($author$project$Components$Practice$PaymentSources$initCards, response, model.ck)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pF: response,
                    ck: A2($author$project$Components$Practice$PaymentSources$initBankAccounts, response, model.ck)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var sources = msg.a;
                var paymentCategory = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    aL: $elm$core$Maybe$Just(_Utils_Tuple3(sources, $author$project$Utils$Form$init($author$project$Pages$Admin$PaymentSources$formFieldsFromPaymentCategory(paymentCategory)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var field = msg.a;
                var _v1 = model.aL;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var sources = _v2.a;
                    var form = _v2.b;
                    var paymentCategory = _v2.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$PaymentSources$formFieldsUpdate(sources), field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        aL: $elm$core$Maybe$Just(_Utils_Tuple3(sources, newForm, paymentCategory))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    aL: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var _v3 = model.aL;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var sources = _v4.a;
                    var form = _v4.b;
                    var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$PaymentSources$formFieldsValidator, form);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var newForm = _v6.a;
                        var validFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            aL: $elm$core$Maybe$Just(_Utils_Tuple3(sources, newForm, $author$project$Api$Data$Loading))
                        }), A3($author$project$Pages$Admin$PaymentSources$updateSource, model.Ej, model.Z$, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v5.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            aL: $elm$core$Maybe$Just(_Utils_Tuple3(sources, newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                var _v7 = model.aL;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var sources = _v8.a;
                    var form = _v8.b;
                    if (response.$ === 3) {
                        var _v10 = $author$project$Pages$Admin$PaymentSources$loadData(model.Ej);
                        var cards = _v10.a;
                        var bankAccounts = _v10.b;
                        var cmd = _v10.c;
                        return _Utils_Tuple3(_Utils_update(model, {
                            pF: bankAccounts,
                            pQ: cards,
                            aL: $elm$core$Maybe$Nothing
                        }), cmd, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Default source successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        aL: $elm$core$Maybe$Just(_Utils_Tuple3(sources, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var practicePaymentSourcesResult = A3($author$project$Components$Practice$PaymentSources$update, model.Ej, subMsg, model.ck);
                var _v11 = function() {
                    var _v12 = practicePaymentSourcesResult.adu;
                    switch(_v12){
                        case 0:
                            return $author$project$Pages$Admin$PaymentSources$loadData(model.Ej);
                        case 1:
                            return $author$project$Pages$Admin$PaymentSources$loadData(model.Ej);
                        default:
                            return _Utils_Tuple3(model.pQ, model.pF, $elm$core$Platform$Cmd$none);
                    }
                }();
                var cards = _v11.a;
                var bankAccounts = _v11.b;
                var cmd = _v11.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    pF: bankAccounts,
                    pQ: cards,
                    ck: practicePaymentSourcesResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg, practicePaymentSourcesResult.EQ),
                    cmd
                ])), practicePaymentSourcesResult.at);
        }
    });
    var $author$project$Api$Platform$Organization$Shared$isNetwork = function(_v0) {
        var record = _v0.b;
        return record.Sd;
    };
    var $author$project$Components$CreatePaymentMethodModal$Approved = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$CardBrandUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$Category = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CreatePaymentMethodModal$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$Loaded = {
        $: 2
    };
    var $author$project$Components$CreatePaymentMethodModal$MethodUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$RainforestMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$Reader = 1;
    var $author$project$Components$CreatePaymentMethodModal$Save = {
        $: 3
    };
    var $author$project$Components$CreatePaymentMethodModal$SetAsDefault = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Margin$Top_0_75 = 7;
    var $author$project$Components$CreatePaymentMethodModal$ValidityChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$cardReaderLabel = F2(function(showProcessor, cardReader) {
        return A2($elm$core$String$join, ' ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, cardReader, A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just)),
            $elm$core$Maybe$Just($author$project$Api$Provider$CardReader$All$label(cardReader))
        ])));
    });
    var $author$project$Components$CreatePaymentMethodModal$cardReaderOptions = F2(function(showProcessor, cardReaders) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a card reader...'), A2($elm$core$List$map, function(cardReader) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$CardReader$All$id(cardReader)), A2($author$project$Components$CreatePaymentMethodModal$cardReaderLabel, showProcessor, cardReader));
        }, cardReaders));
    });
    var $author$project$Ui$HorizontalRule$Double = 0;
    var $author$project$Ui$HorizontalRule$double = $author$project$Ui$HorizontalRule$Style(0);
    var $author$project$Api$Employer$Practice$One$hasPaymentProcessorAccount = function(_v0) {
        var record = _v0;
        return record.Qw;
    };
    var $author$project$Api$Practice$hasPaymentProcessorAccount = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$hasPaymentProcessorAccount(practice_);
        }
    };
    var $author$project$Ui$Types$Lg = 3;
    var $author$project$Ui$Spinner$large = $author$project$Ui$Spinner$Size(3);
    var $author$project$Api$Platform$Session$One$organizationIsAdminPractice = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq(0), A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.VA))) && record.ag_ === 'practice_admin';
    };
    var $author$project$Utils$PaymentProcessor$toSetupAlert = F2(function(practice, prefix) {
        return A2($author$project$Ui$Alert$warning, _List_Nil, $elm$core$List$concat(_List_fromArray([
            function() {
                if (!prefix.$) {
                    var prefix_ = prefix.a;
                    return _List_fromArray([
                        $elm$html$Html$text(prefix_),
                        $elm$html$Html$text(', please')
                    ]);
                } else return _List_fromArray([
                    $elm$html$Html$text('Please')
                ]);
            }(),
            _List_fromArray([
                $author$project$Utils$Html$noBreakSpace,
                $elm$html$Html$text('setup'),
                $author$project$Utils$Html$noBreakSpace
            ]),
            $author$project$Api$Practice$paymentProcessor(practice) === 'stripe' && !A2($author$project$Api$Practice$featureEnabled, 28, practice) ? _List_fromArray([
                $elm$html$Html$text('your '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Stripe, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Stripe integration')
                ])),
                $elm$html$Html$text('.')
            ]) : _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__PaymentProcessing, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Payment Processing')
                ])),
                $elm$html$Html$text('.')
            ])
        ])));
    });
    var $author$project$Api$Provider$Source$Defaults$categoryLabel = function(category) {
        if (!category) return 'Hint Payments';
        else return 'Affiliate Payments';
    };
    var $author$project$Components$Practice$PaymentCategoriesPicker$viewPaymentCategory = F3(function(categories, toMsg, category) {
        var checked = $author$project$Utils$Maybe$toBool(A2($elm_community$list_extra$List$Extra$find, function(category_) {
            return _Utils_eq(category_, category);
        }, categories));
        return A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
            $author$project$Ui$Form$Checkbox$value(checked),
            $author$project$Ui$Form$Checkbox$onCheck(toMsg(category))
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Source$Defaults$categoryLabel(category))
        ]));
    });
    var $author$project$Components$Practice$PaymentCategoriesPicker$view = F3(function(practice, currentCategories, toMsg) {
        return $author$project$Api$Practice$isNetwork(practice) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                $author$project$Ui$HorizontalRule$double
            ])),
            A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Set default for following categories')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb4
            ]), A2($elm$core$List$map, A2($author$project$Components$Practice$PaymentCategoriesPicker$viewPaymentCategory, currentCategories, toMsg), $author$project$Components$Practice$PaymentCategoriesPicker$allCategories(practice)))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$WebComponents$Rainforest$Payment$approvedDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'detail'
    ]), A2($elm$json$Json$Decode$index, 0, A2($elm$json$Json$Decode$at, _List_fromArray([
        'data',
        'payment_method_id'
    ]), $elm$json$Json$Decode$string)));
    var $author$project$WebComponents$Rainforest$Payment$cardBrandUpdatedDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'detail'
    ]), A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
    var $author$project$WebComponents$Rainforest$Payment$methodUpdatedDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'detail'
    ]), A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
    var $author$project$WebComponents$Rainforest$Payment$view = F2(function(_v0, data) {
        var onApproved = _v0.afs;
        var onInvalid = _v0.afF;
        var onValid = _v0.afR;
        var onLoaded = _v0.afH;
        var onMethodUpdated = _v0.afI;
        var onCardBrandUpdated = _v0.afu;
        return A3($elm$html$Html$node, 'rainforest-payment', _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'session-key', data.ahi),
            A2($elm$html$Html$Attributes$attribute, 'payment-method-config-id', data.af7),
            A2($elm$html$Html$Attributes$attribute, 'allowed-methods', data.abL),
            A2($elm$html$Html$Attributes$attribute, 'hide-button', ''),
            A2($elm$html$Html$Events$on, 'approved', A2($elm$json$Json$Decode$map, onApproved, $author$project$WebComponents$Rainforest$Payment$approvedDecoder)),
            A2($elm$html$Html$Events$on, 'valid', $elm$json$Json$Decode$succeed(onValid)),
            A2($elm$html$Html$Events$on, 'invalid', $elm$json$Json$Decode$succeed(onInvalid)),
            A2($elm$html$Html$Events$on, 'loaded', $elm$json$Json$Decode$succeed(onLoaded)),
            A2($elm$html$Html$Events$on, 'method-updated', A2($elm$json$Json$Decode$map, onMethodUpdated, $author$project$WebComponents$Rainforest$Payment$methodUpdatedDecoder)),
            A2($elm$html$Html$Events$on, 'card-brand-updated', A2($elm$json$Json$Decode$map, onCardBrandUpdated, $author$project$WebComponents$Rainforest$Payment$cardBrandUpdatedDecoder)),
            A2($elm$html$Html$Attributes$attribute, 'style-button-color', 'var(--color-primary-300)'),
            A2($elm$html$Html$Attributes$attribute, 'style-button-border-radius', '9999px'),
            A2($elm$html$Html$Attributes$attribute, 'style-font-family', 'sans-serif'),
            A2($elm$html$Html$Attributes$attribute, 'style-placeholder-text', 'true')
        ]), _List_Nil);
    });
    var $author$project$Components$CreatePaymentMethodModal$CardInput = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$viewCardInputButton = F3(function(currentCardInput, cardInput, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentCardInput, cardInput)),
            $author$project$Ui$Button$onClick($author$project$Components$CreatePaymentMethodModal$FormUpdated($author$project$Components$CreatePaymentMethodModal$CardInput(cardInput)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Ui$Margin$Bottom_0 = 0;
    var $author$project$Ui$Image$SampleCheck = 4;
    var $author$project$Components$CreatePaymentMethodModal$viewCheckTooltipHelper = function(imageStore) {
        return A2($elm$html$Html$div, _List_fromArray([
            $author$project$Ui$Margin$toClass(8),
            $author$project$Ui$Margin$toClass(0)
        ]), _List_fromArray([
            A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Where are these numbers on a check?'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none)
                ]), _List_fromArray([
                    $elm$html$Html$text('Where are these numbers on a check?')
                ]))
            ]), _List_fromArray([
                A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                    A4($author$project$Ui$Image$view, imageStore, {
                        Jg: 'Example check showing routing number on bottom left and account number in center bottom'
                    }, _List_Nil, 4)
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer = A2($author$project$Ui$Element$view, _List_fromArray([
        $author$project$Ui$Element$mb2
    ]), _List_fromArray([
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(12)
            ]), _List_fromArray([
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('To initiate an ACH charge, the Operating Rules of the National Automated '),
                    $elm$html$Html$text('Clearing House Associations (NACHA) require you to have your customer\'s consent '),
                    $elm$html$Html$text('to debit or credit their bank account and initiate a charge over the ACH network. '),
                    $elm$html$Html$text('You must be capable of producing copies of your customer\'s authorization if requested.')
                ])),
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('A breach of the NACHA rules makes you potentially liable for regulatory penalties '),
                        $elm$html$Html$text('and fees, as well as a reversal of any related transaction. ')
                    ])),
                    $elm$html$Html$text('For details on the rules that the NACHA requires, '),
                    A2($elm$html$Html$a, _List_fromArray([
                        $elm$html$Html$Attributes$href('https://www.nacha.org/newrules'),
                        $elm$html$Html$Attributes$target('_blank')
                    ]), _List_fromArray([
                        $elm$html$Html$text('visit their site.')
                    ])),
                    $elm$html$Html$text(' See our '),
                    A2($elm$html$Html$a, _List_fromArray([
                        $elm$html$Html$Attributes$href('https://www.hint.com/terms'),
                        $elm$html$Html$Attributes$target('_blank')
                    ]), _List_fromArray([
                        $elm$html$Html$text('terms')
                    ])),
                    $elm$html$Html$text(' for more information.')
                ]))
            ]))
        ]))
    ]));
    var $author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer = F4(function(showCardDisclaimer, showHintDisclaimer, practice, selectedPaymentOption) {
        var _v0 = _Utils_Tuple3(selectedPaymentOption, showCardDisclaimer, showHintDisclaimer);
        _v0$2: while(true)if (_v0.a === 1) {
            if (_v0.b) {
                var _v1 = _v0.a;
                return _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$inputSpanMd(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$warning
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Using a credit card will cost the provider an additional 2% in processing fees for your memberships. ')
                            ])),
                            $elm$html$Html$text('Please consider using your bank account instead.')
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$inputSpanMd(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('By entering your account information you authorize '),
                            $elm$html$Html$text($author$project$Api$Practice$name(practice)),
                            $elm$html$Html$text(' to electronically debit and credit your account on a recurring basis as set forth in the contract. '),
                            $elm$html$Html$text('You understand you can contact '),
                            $elm$html$Html$text($author$project$Api$Practice$name(practice)),
                            $elm$html$Html$text(' to revoke this authorization at any time.')
                        ]))
                    ]))
                ]);
            } else break _v0$2;
        } else {
            if (_v0.c) {
                var _v2 = _v0.a;
                return _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$inputSpanMd(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('By entering your account information you authorize this platform to electronically debit and credit your account on '),
                            $elm$html$Html$text('a recurring basis as set forth in the contract. You understand you can contact us to revoke '),
                            $elm$html$Html$text('this authorization at any time.')
                        ]))
                    ]))
                ]);
            } else break _v0$2;
        }
        return _List_fromArray([
            $author$project$Utils$Html$empty
        ]);
    });
    var $author$project$Components$CreatePaymentMethodModal$RequestForPaymentInfo = {
        $: 14
    };
    var $author$project$Components$CreatePaymentMethodModal$viewSendRequestToPatient = F3(function(patient, patientRequestInfoSentAt, timeFormatter) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Send request to patient'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$CreatePaymentMethodModal$RequestForPaymentInfo),
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Send request to patient')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('We will email '),
                        $elm$html$Html$text($author$project$Api$Provider$Patient$One$name(patient)),
                        $elm$html$Html$text(' a form to update their payment method and provide this authorization.')
                    ]))
                ]))
            ])),
            function() {
                if (!patientRequestInfoSentAt.$) {
                    var requestPayInfoSentAt = patientRequestInfoSentAt.a;
                    return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(12)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text('Last request for payment source sent '),
                                $elm$html$Html$text(A2(timeFormatter, 1, requestPayInfoSentAt)),
                                $elm$html$Html$text('.')
                            ]))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$CreatePaymentMethodModal$viewAddCardModal = function(open) {
        var showPaymentDisclaimers = $author$project$Api$Platform$Session$One$organizationIsCompany(open.Z$);
        var showContactPatientBox = function() {
            var _v17 = open.dh;
            if (!_v17) return true;
            else return false;
        }();
        var paymentProcessingEnabled = function() {
            var _v16 = open.VM;
            if (_v16.$ === 1) return true;
            else return $author$project$Api$Practice$hasPaymentProcessorAccount(open.W1);
        }();
        var modalTitle = 'Add Payment Method';
        var fields = $author$project$Utils$Form$fields(open.PU);
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(true),
            $author$project$Ui$Form$onSubmit($author$project$Components$CreatePaymentMethodModal$Save)
        ]), _List_fromArray([
            A3($author$project$Ui$Modal$view, $author$project$Components$CreatePaymentMethodModal$Close, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title(modalTitle)
                ])),
                $author$project$Ui$Modal$body(A2($elm$core$List$cons, function() {
                    var _v0 = _Utils_Tuple3(showContactPatientBox, paymentProcessingEnabled, showPaymentDisclaimers);
                    if (!_v0.b) {
                        if (!_v0.c) return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mb4
                        ]), _List_fromArray([
                            A2($author$project$Utils$PaymentProcessor$toSetupAlert, open.W1, $elm$core$Maybe$Just('In order to add payment options'))
                        ]));
                        else return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mb4
                        ]), _List_fromArray([
                            A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Your account is not configured to allow credit cards.')
                            ]))
                        ]));
                    } else {
                        if (_v0.a) return $author$project$Utils$Html$empty;
                        else return $author$project$Utils$Html$empty;
                    }
                }(), A2($elm$core$List$cons, function() {
                    var _v1 = open.VM;
                    if (_v1.$ === 2) {
                        var patient = _v1.a;
                        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            A3($author$project$Components$CreatePaymentMethodModal$viewSendRequestToPatient, patient, open.AC, open.HO),
                            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                                $author$project$Ui$HorizontalRule$double
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(), A2($elm$core$List$cons, function() {
                    var _v2 = _Utils_Tuple2(open.tD, showPaymentDisclaimers);
                    if (_v2.a && !_v2.b) {
                        var manualInputOptionText = 'Enter Information Here';
                        var cardReaderOptionText = 'Use Card Reader';
                        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Source')
                                ]))
                            ])),
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('How would you like to add a payment method? ')
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$inputSpanMd(12),
                                $author$project$Ui$Form$Group$clearfix
                            ]), _List_fromArray([
                                $author$project$Ui$Button$group(_List_fromArray([
                                    A3($author$project$Components$CreatePaymentMethodModal$viewCardInputButton, fields.cI, 0, manualInputOptionText),
                                    A3($author$project$Components$CreatePaymentMethodModal$viewCardInputButton, fields.cI, 1, cardReaderOptionText)
                                ]))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                                $author$project$Ui$HorizontalRule$double
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(), _Utils_ap(function() {
                    var _v3 = fields.cI;
                    if (!_v3) {
                        var loading = open.c_ || function() {
                            var _v9 = open.au;
                            if (_v9.$ === 2) {
                                var config = _v9.a;
                                return config.c_;
                            } else return false;
                        }();
                        return _List_fromArray([
                            $author$project$Utils$Html$empty,
                            A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$class('stripe-card')
                                ]), _List_fromArray([
                                    loading ? A2($elm$html$Html$div, _List_fromArray([
                                        $elm$html$Html$Attributes$class('spinner-modal')
                                    ]), _List_fromArray([
                                        $author$project$Ui$Spinner$view(_List_fromArray([
                                            $author$project$Ui$Spinner$large
                                        ]))
                                    ])) : $elm$html$Html$text(''),
                                    function() {
                                        var _v4 = open.au;
                                        switch(_v4.$){
                                            case 0:
                                                return $elm$html$Html$text('');
                                            case 1:
                                                return A2($elm$html$Html$div, _List_fromArray([
                                                    $elm$html$Html$Attributes$id($author$project$Components$CreatePaymentMethodModal$stripeElementId)
                                                ]), _List_Nil);
                                            default:
                                                var config = _v4.a;
                                                var _v5 = config;
                                                var sessionKey = _v5.ahi;
                                                var paymentMethodConfigId = _v5.af7;
                                                var allowedMethods = _v5.abL;
                                                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                                    A2($author$project$WebComponents$Rainforest$Payment$view, {
                                                        afs: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$Approved, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
                                                        afu: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$CardBrandUpdated, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
                                                        afF: $author$project$Components$CreatePaymentMethodModal$RainforestMsg($author$project$Components$CreatePaymentMethodModal$ValidityChanged(false)),
                                                        afH: $author$project$Components$CreatePaymentMethodModal$RainforestMsg($author$project$Components$CreatePaymentMethodModal$Loaded),
                                                        afI: A2($elm$core$Basics$composeR, $author$project$Components$CreatePaymentMethodModal$MethodUpdated, $author$project$Components$CreatePaymentMethodModal$RainforestMsg),
                                                        afR: $author$project$Components$CreatePaymentMethodModal$RainforestMsg($author$project$Components$CreatePaymentMethodModal$ValidityChanged(true))
                                                    }, {
                                                        abL: allowedMethods,
                                                        af7: paymentMethodConfigId,
                                                        ahi: sessionKey
                                                    }),
                                                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, open.PU))
                                                ]));
                                        }
                                    }(),
                                    function() {
                                        var showCheckHelperText = function() {
                                            var _v8 = open.VM;
                                            switch(_v8.$){
                                                case 2:
                                                    return $author$project$Api$Platform$Session$One$organizationIsAdminPractice(open.Z$);
                                                case 0:
                                                    return $author$project$Api$Platform$Session$One$organizationIsAdminPractice(open.Z$);
                                                default:
                                                    return false;
                                            }
                                        }();
                                        var _v6 = _Utils_Tuple2(open.dh, showCheckHelperText);
                                        if (!_v6.a && _v6.b) {
                                            var _v7 = _v6.a;
                                            return $author$project$Components$CreatePaymentMethodModal$viewCheckTooltipHelper(open.qW);
                                        } else return $author$project$Utils$Html$empty;
                                    }()
                                ]))
                            ]))
                        ]);
                    } else return $elm$core$List$singleton(A2($author$project$Ui$Form$Group$view, _List_Nil, function() {
                        var _v10 = open.hJ;
                        if (_v10.$ === 3) {
                            var cardReaders = _v10.a;
                            return $elm$core$List$isEmpty(cardReaders) ? _List_fromArray([
                                A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('There are no card readers available. Please '),
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CardReaders, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('add a card reader')
                                    ])),
                                    $elm$html$Html$text(' now.')
                                ]))
                            ]) : _List_fromArray([
                                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, fields.ace)),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$CreatePaymentMethodModal$FormUpdated, $author$project$Components$CreatePaymentMethodModal$CardReader)),
                                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, open.PU)),
                                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, open.PU))
                                ]), A2($author$project$Components$CreatePaymentMethodModal$cardReaderOptions, open.F3, cardReaders)),
                                A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Tap payments such as Apple Pay & Google Pay are not supported at this time.')
                                ]))
                            ]);
                        } else return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]))
                        ]);
                    }()));
                }(), _Utils_ap(function() {
                    if (showPaymentDisclaimers) {
                        var _v11 = open.VM;
                        if (!_v11.$) return A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, showPaymentDisclaimers, true, open.W1, open.dh);
                        else return A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, false, true, open.W1, open.dh);
                    } else return _List_Nil;
                }(), function() {
                    var _v12 = open.VM;
                    switch(_v12.$){
                        case 2:
                            var nachaDisclaimerElements = function() {
                                var _v13 = open.dh;
                                if (!_v13) return !fields.cI ? _List_fromArray([
                                    A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$mt4,
                                        $author$project$Ui$Element$mb2
                                    ]), _List_fromArray([
                                        $author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer
                                    ]))
                                ]) : _List_fromArray([
                                    $author$project$Utils$Html$empty
                                ]);
                                else return _List_fromArray([
                                    $author$project$Utils$Html$empty
                                ]);
                            }();
                            return A2($elm$core$List$cons, A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt4,
                                $author$project$Ui$Element$mb2
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                                    $author$project$Ui$Form$Checkbox$value(fields.gO),
                                    $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$CreatePaymentMethodModal$FormUpdated, $author$project$Components$CreatePaymentMethodModal$SetAsDefault))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Set as the default payment method for this patient')
                                ]))
                            ])), nachaDisclaimerElements);
                        case 0:
                            return !$author$project$Api$Platform$Session$One$organizationIsCompany(open.Z$) ? _List_fromArray([
                                $author$project$Components$CreatePaymentMethodModal$viewNachaDisclaimer
                            ]) : A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, open.VM, open.Z$) ? _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$warning
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('The practice has disabled adding payment information for this account. Contact the practice administrator for more information.')
                                    ]))
                                ]))
                            ]) : _List_fromArray([
                                $author$project$Utils$Html$empty
                            ]);
                        default:
                            var practice = _v12.a;
                            return _List_fromArray([
                                A2($elm$html$Html$div, _List_fromArray([
                                    $author$project$Ui$Margin$toClass(7)
                                ]), A2($elm$core$List$cons, A3($author$project$Components$Practice$PaymentCategoriesPicker$view, practice, fields.K0, F2(function(c, b) {
                                    return $author$project$Components$CreatePaymentMethodModal$FormUpdated(A2($author$project$Components$CreatePaymentMethodModal$Category, c, b));
                                })), A4($author$project$Components$CreatePaymentMethodModal$viewSelectedPaymentMethodDisclaimer, false, true, practice, open.dh)))
                            ]);
                    }
                }())))))),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$CreatePaymentMethodModal$Close)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    function() {
                        var valid = function() {
                            var _v14 = _Utils_Tuple2(fields.cI, open.au);
                            if (!_v14.a && _v14.b.$ === 2) {
                                var _v15 = _v14.a;
                                var conf = _v14.b.a;
                                return conf.yt;
                            } else return true;
                        }();
                        var disabled = !valid || A2($author$project$Components$CreatePaymentMethodModal$isAddPaymentMethodDisabled, open.VM, open.Z$);
                        return A3($author$project$Ui$Button$view, {
                            abP: modalTitle
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$submit,
                            $author$project$Ui$Button$loading(_Utils_eq(open.j_, $author$project$Api$Data$Loading)),
                            $author$project$Ui$Button$disabled(disabled)
                        ]), _List_fromArray([
                            $elm$html$Html$text(modalTitle)
                        ]));
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CreatePaymentMethodModal$modal = function(model) {
        if (model.$ === 1) {
            var open = model.a;
            var _v1 = open.hW;
            if (!_v1.$) {
                var connectingModal = _v1.a;
                return A2($elm$html$Html$map, $author$project$Components$CreatePaymentMethodModal$ConnectingModalMsg, $author$project$Components$CardReader$ConnectingModal$view(connectingModal));
            } else return $author$project$Components$CreatePaymentMethodModal$viewAddCardModal(open);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Practice$PaymentSources$modal = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg, $author$project$Components$CreatePaymentMethodModal$modal(model.lG))
        ]));
    };
    var $author$project$Api$Provider$Source$Defaults$network = function(_v0) {
        var record = _v0;
        return record.UK;
    };
    var $author$project$Api$Source$defaultNetworkBankAccount = function(bankAccounts) {
        return A2($elm$core$Maybe$map, $author$project$Api$Source$BankAccount, A2($elm$core$Maybe$map, $author$project$Api$BankAccount$ProviderAll, A2($elm_community$list_extra$List$Extra$find, function(bankAccount) {
            return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$network, $author$project$Api$Provider$BankAccount$All$defaults(bankAccount)));
        }, bankAccounts)));
    };
    var $author$project$Api$Source$defaultNetworkCard = function(cards) {
        return A2($elm$core$Maybe$map, $author$project$Api$Source$Card, A2($elm$core$Maybe$map, $author$project$Api$Card$ProviderAll, A2($elm_community$list_extra$List$Extra$find, function(card) {
            return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Source$Defaults$network, $author$project$Api$Provider$Card$All$defaults(card)));
        }, cards)));
    };
    var $author$project$Api$Source$defaultNetworkSource = F2(function(cards, bankAccounts) {
        return $elm$core$List$head(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $author$project$Api$Source$defaultNetworkCard(cards),
            $author$project$Api$Source$defaultNetworkBankAccount(bankAccounts)
        ])));
    });
    var $author$project$Pages$Admin$PaymentSources$paymentCategories = F3(function(isNetwork, cards, bankAccounts) {
        return A2($elm$core$List$cons, {
            EL: 0,
            ND: A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts)
        }, isNetwork ? _List_fromArray([
            {
                EL: 1,
                ND: A2($author$project$Api$Source$defaultNetworkSource, cards, bankAccounts)
            }
        ]) : _List_Nil);
    });
    var $author$project$Components$Practice$PaymentSources$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CreatePaymentMethodModal$Practice = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$OpenModal = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$button = function(openOptions) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Add payment method'
        }, _List_fromArray([
            $author$project$Ui$Button$onClick($author$project$Components$CreatePaymentMethodModal$OpenModal(openOptions)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
        ]), _List_fromArray([
            $elm$html$Html$text('Add Payment Method')
        ]));
    };
    var $author$project$Api$Employer$BankAccount$Shared$bankName = function(_v0) {
        var record = _v0;
        return record.J6;
    };
    var $author$project$Api$Employer$BankAccount$One$bankName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$BankAccount$Shared$bankName(shared);
    };
    var $author$project$Api$Employer$BankAccount$All$bankName = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$bankName(one);
    };
    var $author$project$Api$Provider$BankAccount$Shared$bankName = function(_v0) {
        var record = _v0;
        return record.J6;
    };
    var $author$project$Api$Provider$BankAccount$One$bankName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BankAccount$Shared$bankName(shared);
    };
    var $author$project$Api$Provider$BankAccount$All$bankName = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$bankName(one);
    };
    var $author$project$Api$BankAccount$bankName = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$bankName(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$bankName(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$bankName(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$bankName(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$Shared$cardType = function(_v0) {
        var record = _v0;
        return record.KZ;
    };
    var $author$project$Api$Employer$Card$One$cardType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Card$Shared$cardType(shared);
    };
    var $author$project$Api$Employer$Card$All$cardType = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$cardType(one);
    };
    var $author$project$Api$Provider$Card$Shared$cardType = function(_v0) {
        var record = _v0;
        return record.KZ;
    };
    var $author$project$Api$Provider$Card$One$cardType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Card$Shared$cardType(shared);
    };
    var $author$project$Api$Provider$Card$All$cardType = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$cardType(one);
    };
    var $author$project$Api$Card$cardType = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$cardType(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$cardType(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$cardType(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$cardType(card_);
        }
    };
    var $author$project$Api$Source$detail = function(source) {
        var _v0 = function() {
            switch(source.$){
                case 1:
                    var bankAccount = source.a;
                    return _Utils_Tuple2(A2($elm$core$Maybe$withDefault, '', $author$project$Api$BankAccount$bankName(bankAccount)), A2($elm$core$Maybe$withDefault, '', $author$project$Api$Source$lastFour(source)));
                case 0:
                    var card = source.a;
                    return _Utils_Tuple2(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Card$cardType(card)), A2($elm$core$Maybe$withDefault, '', $author$project$Api$Source$lastFour(source)));
                default:
                    var source_ = source.a;
                    return _Utils_Tuple2(A2($elm$core$Maybe$withDefault, 'external', $author$project$Api$Common$Source$Shared$type_(source_)), A2($elm$core$Maybe$withDefault, '', $author$project$Api$Source$lastFour(source)));
            }
        }();
        var prefix = _v0.a;
        var lastFour_ = _v0.b;
        return prefix + (' *' + lastFour_);
    };
    var $author$project$Api$Source$noun = function(source) {
        switch(source.$){
            case 1:
                return 'bank account';
            case 0:
                return 'card';
            default:
                var source_ = source.a;
                return A2($elm$core$Maybe$withDefault, 'external', $author$project$Api$Common$Source$Shared$type_(source_));
        }
    };
    var $author$project$Api$Provider$Practice$One$stripeCustomerLink = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.$g;
    });
    var $author$project$Components$Practice$PaymentSources$Delete = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Practice$PaymentSources$canDeleteSource = F3(function(source, maybeDefaultSource, maybeDefaultNetworkSource) {
        return !A2($elm$core$Maybe$withDefault, false, A2($elm_community$maybe_extra$Maybe$Extra$orElse, A2($elm$core$Maybe$map, function(defaultNetworkSource) {
            return _Utils_eq($author$project$Api$Source$id(defaultNetworkSource), $author$project$Api$Source$id(source));
        }, maybeDefaultNetworkSource), A2($elm$core$Maybe$map, function(defaultSource) {
            return _Utils_eq($author$project$Api$Source$id(defaultSource), $author$project$Api$Source$id(source));
        }, maybeDefaultSource)));
    });
    var $author$project$Components$Practice$PaymentSources$viewSource = F7(function(timeFormatter, isHintAdmin, deletingSources, maybeDefaultSource, maybeDefaultNetworkSource, canManageSources, source) {
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                        $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just(source)),
                        $author$project$Components$PaymentSourceDisplayer$showProcessor(isHintAdmin)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    function() {
                        if (canManageSources && A3($author$project$Components$Practice$PaymentSources$canDeleteSource, source, maybeDefaultSource, maybeDefaultNetworkSource)) {
                            var loading = A2($elm$core$Set$member, $author$project$Api$Source$id(source), deletingSources);
                            return A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                            ]), _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Delete payment source'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$loading(loading),
                                    $author$project$Ui$Button$onClick($author$project$Components$Practice$PaymentSources$Delete(source))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Delete')
                                ]))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Practice$PaymentSources$view = F2(function(model, canManageSources) {
        var openOptions = {
            vK: $author$project$Api$Data$providerPath,
            qW: model.qW,
            F3: model.F3,
            VM: $author$project$Components$CreatePaymentMethodModal$Practice($author$project$Api$Practice$Provider(model.W1)),
            W1: $author$project$Api$Practice$Provider(model.W1),
            sp: model.sp,
            Z$: model.Z$,
            HO: model.HO,
            tD: false
        };
        var loading = !($author$project$Api$Data$isSuccess(model.pQ) && $author$project$Api$Data$isSuccess(model.pF));
        var createPaymentMethodButton = A2($elm$html$Html$map, $author$project$Components$Practice$PaymentSources$CreatePaymentMethodModalMsg, $author$project$Components$CreatePaymentMethodModal$button(openOptions));
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(model.pQ, model.pF);
            if (_v1.a.$ === 3 && _v1.b.$ === 3) {
                var _v2 = _v1.a;
                var cards = _v2.a;
                var _v3 = _v1.b;
                var bankAccounts = _v3.a;
                return _Utils_Tuple3($elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, $author$project$Api$Source$createdAt, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$time$Time$posixToMillis), $elm$core$Maybe$withDefault(0))), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll), cards), A2($elm$core$List$map, A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll), bankAccounts)))), A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts), A2($author$project$Api$Source$defaultNetworkSource, cards, bankAccounts));
            } else return _Utils_Tuple3(_List_Nil, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
        }();
        var sources = _v0.a;
        var defaultSource = _v0.b;
        var defaultNetworkSource = _v0.c;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flex,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Practice Payment Sources')
                    ])),
                    function() {
                        if (model.F3) {
                            var maybeStripeCustomerLink = $author$project$Api$Provider$Practice$One$stripeCustomerLink(model.W1);
                            return A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(stripeCustomerLink) {
                                return A3($author$project$Ui$HinterOnly$linkHref, stripeCustomerLink, _List_fromArray([
                                    $author$project$Ui$Link$targetBlank
                                ]), _List_fromArray([
                                    $elm$html$Html$text(' View on Stripe')
                                ]));
                            }, maybeStripeCustomerLink));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                createPaymentMethodButton
            ])),
            function() {
                var _v4 = model.fw;
                if (!_v4.$) {
                    var source = _v4.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Practice$PaymentSources$HiConfirmClosed(source), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun($author$project$Api$Source$noun(source)),
                        $author$project$Components$HiConfirm$detail($author$project$Api$Source$detail(source))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            loading ? A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
            ]), _List_fromArray([
                $author$project$Ui$Spinner$view(_List_Nil)
            ])) : A2($author$project$Ui$ListGroup$view, _List_Nil, $elm$core$List$isEmpty(sources) ? _List_fromArray([
                A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('You have not added any credit cards or bank accounts.')
                ]))
            ]) : A2($elm$core$List$map, A6($author$project$Components$Practice$PaymentSources$viewSource, model.HO, model.F3, model.dW, defaultSource, defaultNetworkSource, canManageSources), sources))
        ]));
    });
    var $author$project$Pages$Admin$PaymentSources$Edit = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$PaymentSources$viewPaymentCategory = F4(function(timeFormatter, showProcessor, sources, paymentCategory) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Source$Defaults$categoryLabel(paymentCategory.EL))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                    $author$project$Components$PaymentSourceDisplayer$source(paymentCategory.ND),
                    $author$project$Components$PaymentSourceDisplayer$limitedView(true),
                    $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                    $author$project$Components$PaymentSourceDisplayer$showProcessor(showProcessor)
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$core$List$isEmpty(sources) ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                    abP: 'Edit payment source'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$onClick(A2($author$project$Pages$Admin$PaymentSources$Edit, sources, paymentCategory))
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit Payment Source')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$PaymentSources$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$PaymentSources$Source = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$PaymentSources$Update = {
        $: 5
    };
    var $author$project$Pages$Admin$PaymentSources$sourceName = function(source_) {
        var _v0 = $author$project$Api$Source$name(source_);
        if (!_v0.$) {
            var label = _v0.a;
            return $elm$core$Maybe$Just(label);
        } else return $author$project$Api$Source$type_(source_);
    };
    var $author$project$Pages$Admin$PaymentSources$sourceLabel = F2(function(showProcessor, source) {
        return A2($elm$core$String$join, ' ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, source, $author$project$Api$Source$paymentProcessor),
            A2($elm$core$Maybe$map, $author$project$Formatters$String$titleize, $author$project$Pages$Admin$PaymentSources$sourceName(source)),
            A2($elm$core$Maybe$map, function(lastFour) {
                return ' * ' + lastFour;
            }, $author$project$Api$Source$lastFour(source))
        ])));
    });
    var $author$project$Pages$Admin$PaymentSources$sourceOptions = F2(function(showProcessor, sources) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a source...'), A2($elm$core$List$map, function(source) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Source$id(source)), A2($author$project$Pages$Admin$PaymentSources$sourceLabel, showProcessor, source));
        }, sources));
    });
    var $author$project$Pages$Admin$PaymentSources$viewPaymentCategoryModal = F4(function(showProcessor, sources, form, updateRequest) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Payment Source',
            Tk: _Utils_eq(updateRequest, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just(''),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$PaymentSources$CancelEdit,
            Vn: $elm$core$Basics$always($author$project$Pages$Admin$PaymentSources$Update)
        };
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Category')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Source$Defaults$categoryLabel(fields.EL))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Payment Source'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Source$id, fields.Hw)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$PaymentSources$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]), A2($author$project$Pages$Admin$PaymentSources$sourceOptions, showProcessor, sources))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$PaymentSources$view = function(model) {
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(model.pQ, model.pF);
            if (_v1.a.$ === 3 && _v1.b.$ === 3) {
                var _v2 = _v1.a;
                var cards = _v2.a;
                var _v3 = _v1.b;
                var bankAccounts = _v3.a;
                return _Utils_Tuple3(false, $elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, $author$project$Api$Source$createdAt, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$time$Time$posixToMillis), $elm$core$Maybe$withDefault(0))), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll), cards), A2($elm$core$List$map, A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll), bankAccounts)))), A3($author$project$Pages$Admin$PaymentSources$paymentCategories, A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$organization, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($author$project$Api$Platform$Organization$Shared$isNetwork), $elm$core$Maybe$withDefault(false)))(model.Z$), cards, bankAccounts));
            } else return _Utils_Tuple3(true, _List_Nil, _List_Nil);
        }();
        var loading = _v0.a;
        var sources = _v0.b;
        var paymentCategories_ = _v0.c;
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg, $author$project$Components$Practice$PaymentSources$modal(model.ck)),
                function() {
                    var _v4 = model.aL;
                    if (!_v4.$) {
                        var _v5 = _v4.a;
                        var sources_ = _v5.a;
                        var form = _v5.b;
                        var updateRequest = _v5.c;
                        return A4($author$project$Pages$Admin$PaymentSources$viewPaymentCategoryModal, model.F3, sources_, form, updateRequest);
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$PaymentSources$PracticePaymentSourcesMsg, A2($author$project$Components$Practice$PaymentSources$view, model.ck, true)),
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text('Payment Categories')
                        ])),
                        A4($author$project$Ui$Table$view, _List_fromArray([
                            $author$project$Ui$Table$loading(loading)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Category')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Payment Source')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                        ]), A2($elm$core$List$map, A3($author$project$Pages$Admin$PaymentSources$viewPaymentCategory, model.HO, model.F3, sources), paymentCategories_), _List_Nil)
                    ]))
                ]))
            ]),
            $2: 'Admin | Payment Sources'
        };
    };
    var $author$project$Pages$Admin$PaymentSources$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$PaymentSources$init,
        aeR: $author$project$Pages$Admin$PaymentSources$load,
        ag3: $author$project$Pages$Admin$PaymentSources$save,
        ahE: $author$project$Pages$Admin$PaymentSources$subscriptions,
        aaO: $author$project$Pages$Admin$PaymentSources$update,
        aid: $author$project$Pages$Admin$PaymentSources$view
    });
    var $author$project$Pages$Admin$Plans$Id_String$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var timeZone = _v0.HP;
        var currentDate = _v0.cP;
        var hinterViewOff = _v0.aeb;
        var query = _v1.Bz;
        var params = _v1.VU;
        return A2($elm$core$Tuple$mapFirst, function(planForm) {
            return {
                Ej: apiClient,
                nB: planForm
            };
        }, A9($author$project$Components$Plan$Form$init, apiClient, timeZone, currentDate, session, practice, query, $author$project$Spa$Generated$Route$Admin__Plans__Top, params.aef, {
            aeb: hinterViewOff,
            W4: false
        }));
    });
    var $author$project$Pages$Admin$Plans$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Plans$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Plans$Id_String$subscriptions = function(model) {
        return $author$project$Components$Plan$Form$subscriptions(model.nB);
    };
    var $author$project$Pages$Admin$Plans$Id_String$update = F2(function(msg, model) {
        return A2($author$project$Utils$Tuple3$mapFirst, function(planForm) {
            return _Utils_update(model, {
                nB: planForm
            });
        }, A3($author$project$Components$Plan$Form$update, model.Ej, msg, model.nB));
    });
    var $author$project$Pages$Admin$Plans$Id_String$view = function(model) {
        return {
            fb: $author$project$Components$Plan$Form$view(model.nB),
            $2: 'Admin | Membership Plans'
        };
    };
    var $author$project$Pages$Admin$Plans$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Plans$Id_String$init,
        aeR: $author$project$Pages$Admin$Plans$Id_String$load,
        ag3: $author$project$Pages$Admin$Plans$Id_String$save,
        ahE: $author$project$Pages$Admin$Plans$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$Plans$Id_String$update,
        aid: $author$project$Pages$Admin$Plans$Id_String$view
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$FormMsg = $elm$core$Basics$identity;
    var $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$GotCurrentDate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$PricingVersion$One$PricingVersion = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PricingVersion$One$Record = function(plan) {
        return {
            GW: plan
        };
    };
    var $author$project$Api$Provider$PricingVersion$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Plan$One$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$One$Record));
    var $author$project$Api$Provider$PricingVersion$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PricingVersion$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PricingVersion$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PricingVersion$One$PricingVersion)));
    var $author$project$Api$Provider$PricingVersion$pricingVersionsPath = function(planId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'plans',
            planId,
            'pricing_versions'
        ]), $author$project$Api$Data$providerPath);
    };
    var $author$project$Api$Provider$PricingVersion$new = F3(function(apiClient, planId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PricingVersion$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'new'
        ]), $author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
    });
    var $author$project$Api$Provider$PricingVersion$retrieve = F4(function(apiClient, planId, pricingVersionId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PricingVersion$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            pricingVersionId
        ]), $author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
    });
    var $author$project$Components$PricingVersions$Form$fetchPricingVersion = F3(function(apiClient, planId, pricingVersionId) {
        if (!pricingVersionId.$) {
            var pricingVersionId_ = pricingVersionId.a;
            return A4($author$project$Api$Provider$PricingVersion$retrieve, apiClient, planId, pricingVersionId_, $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion);
        } else return A3($author$project$Api$Provider$PricingVersion$new, apiClient, planId, $author$project$Components$PricingVersions$Form$GotUpcomingPricingVersion);
    });
    var $author$project$Components$PricingVersions$Form$init = F4(function(apiClient, settings, _v0, pricingVersionId) {
        var _v1 = $author$project$Components$DateInput$init;
        var effectiveDateInput = _v1.a;
        var effectiveDateCmd = _v1.b;
        return _Utils_Tuple2({
            k: $author$project$Api$Data$Loading,
            J8: settings.J8,
            cP: $elm$core$Maybe$Nothing,
            iC: effectiveDateInput,
            PU: $elm$core$Maybe$Nothing,
            F6: $author$project$Api$Data$NotAsked,
            Gc: settings.Gc,
            W1: settings.W1,
            agk: _Utils_Tuple2(0, $author$project$Api$Data$NotAsked),
            eq: $jinjor$elm_debounce$Debounce$init,
            nJ: $author$project$Api$Data$Loading,
            ago: pricingVersionId,
            Z$: settings.Z$,
            gU: false
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Components$PricingVersions$Form$fetchPricingVersion, apiClient, settings.J8, pricingVersionId),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg, effectiveDateCmd),
            A2($elm$core$Task$perform, $author$project$Components$PricingVersions$Form$GotCurrentDate, $justinmimbs$date$Date$today)
        ])));
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        var settings = {
            J8: params.aef,
            Gc: $author$project$Spa$Generated$Route$Admin__Plans__Top,
            W1: practice,
            Z$: session
        };
        var _v1 = A4($author$project$Components$PricingVersions$Form$init, shared.Ej, settings, params.aef, $elm$core$Maybe$Nothing);
        var form = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form,
            W1: practice,
            Z$: session,
            Cu: shared
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            Cu: shared
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$subscriptions = function(_v0) {
        var model = _v0;
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(form) {
            return A2($elm$core$Platform$Sub$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, $author$project$Components$Plan$BasicForm$subscriptions(form.aB));
        }, model.PU));
    };
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$PricingVersions$Form$subscriptions(model.PU));
    };
    var $author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$GotPreview = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$PricingVersionCreated = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$PricingVersionUpdated = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing = {
        $: 10
    };
    var $author$project$Api$Provider$PricingVersion$encodeFields = function(fields) {
        var planFields = fields.WL;
        var baseFields = _List_fromArray([
            _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
            _Utils_Tuple2('effective_date', $elm$json$Json$Encode$string(fields.Ow)),
            _Utils_Tuple2('registration_fee_name', $elm$json$Json$Encode$string(fields.BH)),
            _Utils_Tuple2('registration_fee_description', $elm$json$Json$Encode$string(fields.BG)),
            _Utils_Tuple2('registration_fee_category', A2($author$project$Utils$Encode$nullable, function(id) {
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(id))
                ]));
            }, fields.BF)),
            _Utils_Tuple2('discounts_enabled', $elm$json$Json$Encode$bool(fields.xm)),
            _Utils_Tuple2('group_pricing_type', $elm$json$Json$Encode$string(fields.Qh)),
            _Utils_Tuple2('split_revenue_type', $elm$json$Json$Encode$string(planFields._P)),
            _Utils_Tuple2('applies_group_discount_in_tiers', $elm$json$Json$Encode$bool(fields.Jy)),
            _Utils_Tuple2('single_parent_with_single_child_rate_rule_enabled', $elm$json$Json$Encode$bool(planFields._z)),
            _Utils_Tuple2('family_with_single_child_rate_rule_enabled', $elm$json$Json$Encode$bool(planFields.Pu)),
            _Utils_Tuple2('group_discount_rules_calculated_by', function() {
                var _v0 = fields.Qe;
                if (!_v0.$) {
                    var calculatedBy = _v0.a;
                    return $elm$json$Json$Encode$string(calculatedBy);
                } else return $elm$json$Json$Encode$string('percent_off');
            }()),
            _Utils_Tuple2('children_age_limit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.wa)),
            _Utils_Tuple2('family_num_children_included', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.xH)),
            _Utils_Tuple2('family_num_adults_included', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.Pq)),
            _Utils_Tuple2('fixed_children_age_limit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.PO)),
            _Utils_Tuple2('group_pricing_family_num_children_included', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.Qg)),
            _Utils_Tuple2('number_additional_children_allowed', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.zP)),
            _Utils_Tuple2('default_charge_name', $elm$json$Json$Encode$string(planFields.xc)),
            _Utils_Tuple2('default_charge_description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, planFields.xb)),
            _Utils_Tuple2('individual_registration_fee_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, planFields.Rd)),
            _Utils_Tuple2('max_registration_fee_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, planFields.TN)),
            _Utils_Tuple2('minimum_enrollment_period_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, planFields.Up)),
            _Utils_Tuple2('individual_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.Rb)),
            _Utils_Tuple2('couple_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.Mh)),
            _Utils_Tuple2('family_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.Pr)),
            _Utils_Tuple2('single_parent_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields._w)),
            _Utils_Tuple2('single_parent_with_single_child_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields._y)),
            _Utils_Tuple2('family_with_single_child_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.Pt)),
            _Utils_Tuple2('additional_adult_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.ID)),
            _Utils_Tuple2('additional_child_rate_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFixedRateRule, planFields.IE)),
            _Utils_Tuple2('couple_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.wX)),
            _Utils_Tuple2('family_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.xG)),
            _Utils_Tuple2('single_parent_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.CE)),
            _Utils_Tuple2('additional_adult_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.tQ)),
            _Utils_Tuple2('additional_child_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.tR)),
            _Utils_Tuple2('children_only_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, planFields.wb)),
            _Utils_Tuple2('group_discount_rules', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeGroupDiscountRuleFields, planFields.Qd)),
            _Utils_Tuple2('special_rates', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeSpecialRateFields, planFields._M)),
            _Utils_Tuple2('age_rate_rules', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, planFields.I_))
        ]);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('pricing_version', $elm$json$Json$Encode$object(baseFields))
        ]));
    };
    var $author$project$Api$Provider$PricingVersion$calculate = F7(function(apiClient, planId, pricingVersionId, expand, tracker, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Provider$PricingVersion$encodeFields(fields), A2($author$project$Api$Data$requestWithTracker, tracker, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Plan$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            pricingVersionId,
            'calculate'
        ]), $author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId)))))));
    });
    var $author$project$Components$PricingVersions$Form$formFields = function(form) {
        return {
            Jy: form.Jy,
            aB: form.aB,
            xm: form.xm,
            Ow: form.Ow,
            aJ: form.aJ,
            cY: form.cY,
            Qd: form.Qd,
            Qe: form.Qe,
            Qh: form.Qh,
            i: form.i,
            c$: form.c$,
            zr: form.zr,
            o: form.o,
            dj: form.dj
        };
    };
    var $author$project$Components$PricingVersions$Form$PreviewDebouncedMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$previewDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$PricingVersions$Form$PreviewDebouncedMsg
    };
    var $author$project$Components$PricingVersions$Form$validateEffectiveDate = F2(function(touched, maybeDate) {
        if (!touched) return _List_Nil;
        else {
            if (maybeDate.$ === 1) return _List_fromArray([
                'Please enter an effective date.'
            ]);
            else return _List_Nil;
        }
    });
    var $author$project$Components$PricingVersions$Form$validatePricingVersionName = function(name) {
        var trimmedName = $elm$core$String$trim(name);
        return $elm$core$String$isEmpty(trimmedName) ? _List_fromArray([
            'Please enter a name.'
        ]) : _List_Nil;
    };
    var $author$project$Components$PricingVersions$Form$validateForm = F3(function(_v0, _v1, form) {
        var specialRatesHasErrors = function() {
            var _v2 = form.dj;
            if (!_v2.$) {
                var specialRatesForm = _v2.a;
                return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
            } else return false;
        }();
        var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.zr);
        var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(form.c$);
        var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(form.i);
        var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(form.cY);
        var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, form.aJ, form.Ow);
        var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(form.aB);
        return $elm$core$List$isEmpty(nameErrors) && $elm$core$List$isEmpty(effectiveDateErrors) && !basicPlanHasErrors && !individualPricingHasErrors && !familyPricingHasErrors && !groupTierPricingHasErrors && !specialRatesHasErrors;
    });
    var $author$project$Components$PricingVersions$Form$calculate = F4(function(model, plan, form, opts) {
        var isValid = !opts.aa8 || A3($author$project$Components$PricingVersions$Form$validateForm, $elm$core$Maybe$Just(plan), model.W1, form);
        var _v0 = opts._b && isValid ? A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$PricingVersions$Form$previewDebounceConfig, $author$project$Components$PricingVersions$Form$formFields(form), model.eq) : _Utils_Tuple2(model.eq, $elm$core$Platform$Cmd$none);
        var newDebouncer = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(function() {
            if (opts._b && isValid) return _Utils_update(model, {
                PU: $elm$core$Maybe$Just(form),
                eq: newDebouncer
            });
            else {
                if (!isValid) {
                    var previewId = model.agk.a + 1;
                    return _Utils_update(model, {
                        PU: $elm$core$Maybe$Just(form),
                        agk: _Utils_Tuple2(previewId, $author$project$Api$Data$NotAsked),
                        eq: newDebouncer
                    });
                } else return _Utils_update(model, {
                    PU: $elm$core$Maybe$Just(form),
                    eq: newDebouncer
                });
            }
        }(), cmd);
    });
    var $author$project$Api$Provider$PricingVersion$create = F4(function(apiClient, planId, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Provider$PricingVersion$encodeFields(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId))));
    });
    var $author$project$Components$PricingVersions$Form$PreviewDebounced = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$debounceCalculate = function(pricingFormFields) {
        return A2($elm$core$Task$perform, $author$project$Components$PricingVersions$Form$PreviewDebounced, $elm$core$Task$succeed(pricingFormFields));
    };
    var $author$project$Api$Provider$PricingVersion$One$effectiveDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$effectiveDate(shared);
    };
    var $author$project$Components$PricingVersions$Form$exclusiveRanges = F5(function(fromGetter, fromSetter, toGetter, toSetter, range) {
        if ($elm$core$List$isEmpty(range)) return range;
        else {
            var minimum = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, fromGetter, $elm$core$List$head(range)));
            return A2($elm$core$List$indexedMap, F2(function(index, current) {
                var prev = A2($elm_community$list_extra$List$Extra$getAt, index - 1, range);
                var next = A2($elm_community$list_extra$List$Extra$getAt, index + 1, range);
                var newTo = function() {
                    var _v1 = _Utils_Tuple2(next, toGetter(current));
                    if (_v1.a.$ === 1) {
                        var _v2 = _v1.a;
                        return $elm$core$Maybe$Nothing;
                    } else if (_v1.b.$ === 1) {
                        var _v3 = _v1.b;
                        return toGetter(current);
                    } else {
                        var currentTo = _v1.b.a;
                        var currentFrom = fromGetter(current);
                        return _Utils_cmp(currentTo, currentFrom) < 1 ? $elm$core$Maybe$Just(currentFrom) : toGetter(current);
                    }
                }();
                var newFrom = function() {
                    var _v0 = A2($elm$core$Maybe$andThen, toGetter, prev);
                    if (!_v0.$) {
                        var _int = _v0.a;
                        return _int + 1;
                    } else return minimum;
                }();
                return A2(toSetter, newTo, A2(fromSetter, newFrom, current));
            }), range);
        }
    });
    var $author$project$Components$PricingVersions$Form$exclusiveSizeRanges = A4($author$project$Components$PricingVersions$Form$exclusiveRanges, function($) {
        return $.P0;
    }, F2(function(from, item) {
        return _Utils_update(item, {
            P0: from
        });
    }), function($) {
        return $.$6;
    }, F2(function(to, item) {
        return _Utils_update(item, {
            $6: to
        });
    }));
    var $author$project$Components$PricingVersions$Form$initFormFieldsWithSpecialRates = F6(function(apiClient, session, practice, plan, maybePricingVersion, currentSpecialRatesForm) {
        var specialRatesForm = $elm$core$Maybe$Just(A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, currentSpecialRatesForm, plan, $elm$core$Maybe$Nothing));
        var membershipPricingForm = A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
        var groupTierPricingForm = A2($author$project$Components$Plan$Form$GroupTierPricingFields$fill, plan, $elm$core$Maybe$Nothing);
        var groupDiscountRules = A2($elm$core$List$map, $author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer, $author$project$Api$Provider$Plan$One$groupDiscountRules(plan));
        var familyMembershipPricingForm = A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill, plan, $elm$core$Maybe$Nothing);
        var _v0 = A6($author$project$Components$Plan$BasicForm$fill, practice, plan, false, false, $elm$core$Maybe$Just(_Utils_Tuple2(apiClient, session)), maybePricingVersion);
        var basicPlanForm = _v0.a;
        var basicPlanCmd = _v0.b;
        return _Utils_Tuple2({
            Jy: A2($elm$core$Maybe$withDefault, false, $author$project$Api$Provider$Plan$One$appliesGroupDiscountInTiers(plan)),
            aB: basicPlanForm,
            xm: $author$project$Api$Provider$Plan$One$discountsEnabled(plan),
            Ow: $elm$core$Maybe$Nothing,
            aJ: false,
            cY: familyMembershipPricingForm,
            Qd: groupDiscountRules,
            Qe: $elm$core$Maybe$Just('percent_off'),
            Qh: $author$project$Api$Provider$Plan$One$groupPricingType(plan),
            i: groupTierPricingForm,
            c$: membershipPricingForm,
            zr: '',
            o: false,
            dj: specialRatesForm
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, basicPlanCmd));
    });
    var $author$project$Api$Provider$PricingVersion$Shared$discountsEnabled = function(_v0) {
        var record = _v0;
        return record.xm;
    };
    var $author$project$Api$Provider$PricingVersion$One$discountsEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$discountsEnabled(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$groupDiscountRules = function(_v0) {
        var record = _v0;
        return record.Qd;
    };
    var $author$project$Api$Provider$PricingVersion$One$groupDiscountRules = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$groupDiscountRules(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$groupPricingType = function(_v0) {
        var record = _v0;
        return record.Qh;
    };
    var $author$project$Api$Provider$PricingVersion$One$groupPricingType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$groupPricingType(shared);
    };
    var $author$project$Api$Provider$PricingVersion$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$PricingVersion$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PricingVersion$Shared$name(shared);
    };
    var $author$project$Api$Provider$PricingVersion$One$plan = function(_v0) {
        var record = _v0.b;
        return record.GW;
    };
    var $author$project$Components$PricingVersions$Form$initFormFromPricingVersion = F6(function(apiClient, session, pricingVersion, plan, practice, currentDate) {
        var loadedGroupDiscountRules = A2($elm$core$List$map, $author$project$Components$Plan$Form$GroupDiscountRuleField$initFromServer, $author$project$Api$Provider$PricingVersion$One$groupDiscountRules(pricingVersion));
        var groupDiscountRules = $elm$core$List$isEmpty(loadedGroupDiscountRules) ? _List_fromArray([
            $author$project$Components$Plan$Form$GroupDiscountRuleField$default($author$project$Api$Provider$Plan$One$defaultPeriod($author$project$Api$Provider$PricingVersion$One$plan(pricingVersion)))
        ]) : loadedGroupDiscountRules;
        var groupDiscountRulesCalculatedBy = A2($elm$core$Maybe$map, function($) {
            return $.KD;
        }, $elm$core$List$head(groupDiscountRules));
        var defaultName = function() {
            if (!currentDate.$) {
                var date = currentDate.a;
                return $elm$core$String$fromInt($justinmimbs$date$Date$year(date) + 1) + ' Pricing';
            } else return '2025 Pricing';
        }();
        var pricingVersionName = A2($elm$core$Maybe$withDefault, defaultName, $author$project$Api$Provider$PricingVersion$One$name(pricingVersion));
        var _v0 = A6($author$project$Components$Plan$BasicForm$fill, practice, plan, false, false, $elm$core$Maybe$Just(_Utils_Tuple2(apiClient, session)), $elm$core$Maybe$Just(pricingVersion));
        var basicPlan = _v0.a;
        var basicPlanCmd = _v0.b;
        return _Utils_Tuple2({
            Jy: A2($elm$core$Maybe$withDefault, true, $author$project$Api$Provider$PricingVersion$One$appliesGroupDiscountInTiers(pricingVersion)),
            aB: basicPlan,
            xm: $author$project$Api$Provider$PricingVersion$One$discountsEnabled(pricingVersion),
            Ow: $elm$core$Maybe$Just($author$project$Api$Provider$PricingVersion$One$effectiveDate(pricingVersion)),
            aJ: false,
            cY: A2($author$project$Components$Plan$Form$FamilyMembershipPricingFields$fill, plan, $elm$core$Maybe$Just(pricingVersion)),
            Qd: groupDiscountRules,
            Qe: groupDiscountRulesCalculatedBy,
            Qh: $author$project$Api$Provider$PricingVersion$One$groupPricingType(pricingVersion),
            i: A2($author$project$Components$Plan$Form$GroupTierPricingFields$fill, plan, $elm$core$Maybe$Just(pricingVersion)),
            c$: A2($author$project$Components$Plan$Form$IndividualMembershipPricingFields$fill, plan, $elm$core$Maybe$Just(pricingVersion)),
            zr: pricingVersionName,
            o: false,
            dj: $elm$core$Maybe$Just(A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, $elm$core$Maybe$Nothing, plan, $elm$core$Maybe$Just(pricingVersion)))
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, basicPlanCmd));
    });
    var $author$project$Components$PricingVersions$Form$initSharedFields = F2(function(maybePlan, form) {
        var basicPlanFields = $author$project$Components$Plan$BasicForm$formFields(form.aB);
        return {
            Nx: basicPlanFields.Nx,
            Qh: form.Qh,
            GW: maybePlan
        };
    });
    var $author$project$Components$PricingVersions$Form$maxGroupFromSize = 10;
    var $author$project$Components$PricingVersions$Form$planRoute = function(planId) {
        return $author$project$Spa$Generated$Route$Admin__Plans__Id_String({
            aef: planId
        });
    };
    var $author$project$Api$Provider$PricingVersion$update = F5(function(apiClient, planId, pricingVersionId, fields, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Provider$PricingVersion$encodeFields(fields), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            pricingVersionId
        ]), $author$project$Api$Provider$PricingVersion$pricingVersionsPath(planId)))));
    });
    var $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate = function(pricingFormFields) {
        var specialRatesFormFields = function() {
            var _v0 = pricingFormFields.dj;
            if (!_v0.$) {
                var specialRatesForm = _v0.a;
                return $author$project$Components$Plan$Form$SpecialRatesFields$formFields(specialRatesForm);
            } else return {
                _M: _List_Nil
            };
        }();
        var groupTierPricingFormFields = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(pricingFormFields.i);
        var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(pricingFormFields.cY);
        var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(pricingFormFields.aB);
        var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.de);
        return {
            tQ: A2($elm$core$Maybe$map, function(rule) {
                return {
                    Jo: rule.Jo,
                    Jp: rule.Jp,
                    Ux: rule.Ux,
                    Uy: rule.Uy,
                    XY: rule.XY,
                    XZ: rule.XZ,
                    ZL: rule.ZL,
                    ZM: rule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.tQ.OM ? familyMembershipPricingFormFields.tQ : $elm$core$Maybe$Nothing),
            ID: groupTierPricingFormFields.Zk.Pq.OM ? $elm$core$Maybe$Just({
                Jk: groupTierPricingFormFields.ID.Jk,
                e3: groupTierPricingFormFields.ID.e3,
                Uu: groupTierPricingFormFields.ID.Uu,
                gb: groupTierPricingFormFields.ID.gb,
                XU: groupTierPricingFormFields.ID.XU,
                gx: groupTierPricingFormFields.ID.gx,
                ZH: groupTierPricingFormFields.ID.ZH,
                gM: groupTierPricingFormFields.ID.gM
            }) : $elm$core$Maybe$Nothing,
            tR: A2($elm$core$Maybe$map, function(rule) {
                return {
                    Jo: rule.Jo,
                    Jp: rule.Jp,
                    Ux: rule.Ux,
                    Uy: rule.Uy,
                    XY: rule.XY,
                    XZ: rule.XZ,
                    ZL: rule.ZL,
                    ZM: rule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.tR.OM ? familyMembershipPricingFormFields.tR : $elm$core$Maybe$Nothing),
            IE: groupTierPricingFormFields.Zk.Qg.OM ? $elm$core$Maybe$Just({
                Jk: groupTierPricingFormFields.IE.Jk,
                e3: groupTierPricingFormFields.IE.e3,
                Uu: groupTierPricingFormFields.IE.Uu,
                gb: groupTierPricingFormFields.IE.gb,
                XU: groupTierPricingFormFields.IE.XU,
                gx: groupTierPricingFormFields.IE.gx,
                ZH: groupTierPricingFormFields.IE.ZH,
                gM: groupTierPricingFormFields.IE.gM
            }) : $elm$core$Maybe$Nothing,
            IF: basicPlanFormFields.IF,
            I_: function() {
                var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(pricingFormFields.c$);
                var ageRateRules = membershipPricingFormFields.I_;
                return A2($elm$core$List$map, function(ageRateRule) {
                    return {
                        Jk: ageRateRule.dc.Jk,
                        e3: ageRateRule.dc.e3,
                        Mg: A2($elm$core$Maybe$map, function(coupleRule) {
                            return {
                                Jk: coupleRule.dc.Jk,
                                e3: coupleRule.dc.e3,
                                Uu: coupleRule.dc.Uu,
                                gb: coupleRule.dc.gb,
                                XU: coupleRule.dc.XU,
                                gx: coupleRule.dc.gx,
                                ZH: coupleRule.dc.ZH,
                                gM: coupleRule.dc.gM
                            };
                        }, ageRateRule.Mg),
                        P_: $elm$core$Maybe$Just(ageRateRule.P_),
                        Uu: ageRateRule.dc.Uu,
                        gb: ageRateRule.dc.gb,
                        XU: ageRateRule.dc.XU,
                        gx: ageRateRule.dc.gx,
                        ZH: ageRateRule.dc.ZH,
                        gM: ageRateRule.dc.gM,
                        $4: ageRateRule.$4,
                        aaG: ageRateRule.aaG
                    };
                }, ageRateRules);
            }(),
            vu: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.vu),
            vv: basicPlanFormFields.vv,
            Jy: pricingFormFields.Jy,
            Kh: basicPlanFormFields.Kh,
            Ky: basicPlanFormFields.Ky,
            wa: familyMembershipPricingFormFields.wa,
            wb: A2($elm$core$Maybe$map, function(rule) {
                return {
                    Jo: rule.Jo,
                    Jp: rule.Jp,
                    Ux: rule.Ux,
                    Uy: rule.Uy,
                    XY: rule.XY,
                    XZ: rule.XZ,
                    ZL: rule.ZL,
                    ZM: rule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.wb.OM ? familyMembershipPricingFormFields.wb : $elm$core$Maybe$Nothing),
            L4: false,
            L5: false,
            L6: $elm$core$Maybe$Nothing,
            L7: $elm$core$Maybe$Nothing,
            EW: $elm$core$Maybe$Nothing,
            wX: A2($elm$core$Maybe$map, function(rule) {
                return {
                    Jo: rule.Jo,
                    Jp: rule.Jp,
                    Ux: rule.Ux,
                    Uy: rule.Uy,
                    XY: rule.XY,
                    XZ: rule.XZ,
                    ZL: rule.ZL,
                    ZM: rule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.wX.OM ? familyMembershipPricingFormFields.wX : $elm$core$Maybe$Nothing),
            Mh: $elm$core$Maybe$Just({
                Jk: groupTierPricingFormFields.Mh.Jk,
                e3: groupTierPricingFormFields.Mh.e3,
                Uu: groupTierPricingFormFields.Mh.Uu,
                gb: groupTierPricingFormFields.Mh.gb,
                XU: groupTierPricingFormFields.Mh.XU,
                gx: groupTierPricingFormFields.Mh.gx,
                ZH: groupTierPricingFormFields.Mh.ZH,
                gM: groupTierPricingFormFields.Mh.gM
            }),
            Mn: $elm$core$Maybe$Nothing,
            xb: basicPlanFormFields.xb,
            xc: basicPlanFormFields.xc,
            Nx: basicPlanFormFields.Nx,
            Ff: $elm$core$Dict$empty,
            xm: pricingFormFields.xm,
            xG: A2($elm$core$Maybe$map, function(rule) {
                return {
                    Jo: rule.Jo,
                    Jp: rule.Jp,
                    Ux: rule.Ux,
                    Uy: rule.Uy,
                    XY: rule.XY,
                    XZ: rule.XZ,
                    ZL: rule.ZL,
                    ZM: rule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.xG.OM ? familyMembershipPricingFormFields.xG : $elm$core$Maybe$Nothing),
            Pq: groupTierPricingFormFields.Zk.Pq.OM ? groupTierPricingFormFields.Pq : $elm$core$Maybe$Nothing,
            xH: familyMembershipPricingFormFields.xH,
            Pr: $elm$core$Maybe$Just({
                Jk: groupTierPricingFormFields.Pr.Jk,
                e3: groupTierPricingFormFields.Pr.e3,
                Uu: groupTierPricingFormFields.Pr.Uu,
                gb: groupTierPricingFormFields.Pr.gb,
                XU: groupTierPricingFormFields.Pr.XU,
                gx: groupTierPricingFormFields.Pr.gx,
                ZH: groupTierPricingFormFields.Pr.ZH,
                gM: groupTierPricingFormFields.Pr.gM
            }),
            Pt: groupTierPricingFormFields.Pu ? $elm$core$Maybe$Just({
                Jk: groupTierPricingFormFields.Pt.Jk,
                e3: groupTierPricingFormFields.Pt.e3,
                Uu: groupTierPricingFormFields.Pt.Uu,
                gb: groupTierPricingFormFields.Pt.gb,
                XU: groupTierPricingFormFields.Pt.XU,
                gx: groupTierPricingFormFields.Pt.gx,
                ZH: groupTierPricingFormFields.Pt.ZH,
                gM: groupTierPricingFormFields.Pt.gM
            }) : $elm$core$Maybe$Nothing,
            Pu: groupTierPricingFormFields.Pu,
            PO: groupTierPricingFormFields.Zk.PO.OM ? groupTierPricingFormFields.PO : $elm$core$Maybe$Nothing,
            Qd: A2($elm$core$List$map, function(groupDiscountRule) {
                return {
                    Jm: groupDiscountRule.Jm,
                    Jn: groupDiscountRule.Jn,
                    Js: groupDiscountRule.Js,
                    Jt: groupDiscountRule.Jt,
                    KD: groupDiscountRule.KD,
                    P0: $elm$core$Maybe$Just(groupDiscountRule.P0),
                    Uv: groupDiscountRule.Uv,
                    Uw: groupDiscountRule.Uw,
                    UC: groupDiscountRule.UC,
                    UD: groupDiscountRule.UD,
                    XW: groupDiscountRule.XW,
                    XX: groupDiscountRule.XX,
                    X0: groupDiscountRule.X0,
                    X1: groupDiscountRule.X1,
                    ZJ: groupDiscountRule.ZJ,
                    ZK: groupDiscountRule.ZK,
                    ZP: groupDiscountRule.ZP,
                    ZQ: groupDiscountRule.ZQ,
                    $6: groupDiscountRule.$6
                };
            }, pricingFormFields.Qd),
            Qg: groupTierPricingFormFields.Zk.Qg.OM ? groupTierPricingFormFields.Qg : $elm$core$Maybe$Nothing,
            Qh: pricingFormFields.Qh,
            Q4: $elm$core$Maybe$Nothing,
            Rb: $elm$core$Maybe$Just({
                Jk: groupTierPricingFormFields.Rb.Jk,
                e3: groupTierPricingFormFields.Rb.e3,
                Uu: groupTierPricingFormFields.Rb.Uu,
                gb: groupTierPricingFormFields.Rb.gb,
                XU: groupTierPricingFormFields.Rb.XU,
                gx: groupTierPricingFormFields.Rb.gx,
                ZH: groupTierPricingFormFields.Rb.ZH,
                gM: groupTierPricingFormFields.Rb.gM
            }),
            Rd: registrationFeeFields.Zk.Rd.OM ? registrationFeeFields.Rd : $elm$core$Maybe$Nothing,
            SI: $elm$core$Maybe$Nothing,
            TN: registrationFeeFields.Zk.TN.OM ? registrationFeeFields.TN : $elm$core$Maybe$Nothing,
            TQ: $elm$core$Maybe$Nothing,
            Un: $elm$core$Maybe$Nothing,
            Up: basicPlanFormFields.Up,
            zj: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.zj),
            zk: basicPlanFormFields.zk,
            zr: basicPlanFormFields.zr,
            zP: familyMembershipPricingFormFields.zP,
            Xo: 0,
            Bw: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bw),
            Bx: basicPlanFormFields.Bx,
            BF: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(basicPlanFormFields.de),
            BG: basicPlanFormFields.BG,
            BH: basicPlanFormFields.BH,
            Cn: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Cn),
            Co: basicPlanFormFields.Co,
            CE: A2($elm$core$Maybe$map, function(rule) {
                return {
                    Jo: rule.Jo,
                    Jp: rule.Jp,
                    Ux: rule.Ux,
                    Uy: rule.Uy,
                    XY: rule.XY,
                    XZ: rule.XZ,
                    ZL: rule.ZL,
                    ZM: rule.ZM
                };
            }, familyMembershipPricingFormFields.Zk.CE.OM ? familyMembershipPricingFormFields.CE : $elm$core$Maybe$Nothing),
            _w: $elm$core$Maybe$Just({
                Jk: groupTierPricingFormFields._w.Jk,
                e3: groupTierPricingFormFields._w.e3,
                Uu: groupTierPricingFormFields._w.Uu,
                gb: groupTierPricingFormFields._w.gb,
                XU: groupTierPricingFormFields._w.XU,
                gx: groupTierPricingFormFields._w.gx,
                ZH: groupTierPricingFormFields._w.ZH,
                gM: groupTierPricingFormFields._w.gM
            }),
            _y: groupTierPricingFormFields._z ? $elm$core$Maybe$Just({
                Jk: groupTierPricingFormFields._y.Jk,
                e3: groupTierPricingFormFields._y.e3,
                Uu: groupTierPricingFormFields._y.Uu,
                gb: groupTierPricingFormFields._y.gb,
                XU: groupTierPricingFormFields._y.XU,
                gx: groupTierPricingFormFields._y.gx,
                ZH: groupTierPricingFormFields._y.ZH,
                gM: groupTierPricingFormFields._y.gM
            }) : $elm$core$Maybe$Nothing,
            _z: groupTierPricingFormFields._z,
            _M: A2($elm$core$List$map, function(specialRate) {
                return {
                    Jk: specialRate.Jk,
                    e3: specialRate.e3,
                    Mw: specialRate.Mw,
                    NU: specialRate.NU,
                    aef: specialRate.aef,
                    Uu: specialRate.Uu,
                    gb: specialRate.gb,
                    zr: specialRate.zr,
                    XU: specialRate.XU,
                    gx: specialRate.gx,
                    ZH: specialRate.ZH,
                    gM: specialRate.gM
                };
            }, A2($elm$core$List$filter, function(specialRate) {
                return !specialRate.NU;
            }, specialRatesFormFields._M)),
            _P: groupTierPricingFormFields._P,
            Hy: basicPlanFormFields.Hy,
            aab: $author$project$Currency$zero,
            aac: $author$project$Percentage$zero,
            aad: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Components$PricingVersions$Form$updatePlanFieldsForSave = function(pricingFormFields) {
        var specialRatesFormFields = function() {
            var _v0 = pricingFormFields.dj;
            if (!_v0.$) {
                var specialRatesForm = _v0.a;
                return $author$project$Components$Plan$Form$SpecialRatesFields$formFields(specialRatesForm);
            } else return {
                _M: _List_Nil
            };
        }();
        var planFieldsForCalculate = $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate(pricingFormFields);
        return _Utils_update(planFieldsForCalculate, {
            _M: A2($elm$core$List$map, function(specialRate) {
                return {
                    Jk: specialRate.Jk,
                    e3: specialRate.e3,
                    Mw: specialRate.Mw,
                    NU: specialRate.NU,
                    aef: specialRate.aef,
                    Uu: specialRate.Uu,
                    gb: specialRate.gb,
                    zr: specialRate.zr,
                    XU: specialRate.XU,
                    gx: specialRate.gx,
                    ZH: specialRate.ZH,
                    gM: specialRate.gM
                };
            }, specialRatesFormFields._M)
        });
    };
    var $author$project$Components$PricingVersions$Form$validateFormFields = F3(function(maybePlan, practice, form) {
        var validatedBasicPlan = function() {
            var _v8 = A2($author$project$Components$Plan$BasicForm$validate, form.aB, maybePlan);
            if (!_v8.$) {
                var _v9 = _v8.a;
                var newForm_ = _v9.a;
                return newForm_;
            } else {
                var newForm_ = _v8.a;
                return newForm_;
            }
        }();
        var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
        var validatedFamilyMembershipPricingForm = function() {
            var _v6 = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate, form.cY, sharedFields, maybePlan);
            if (!_v6.$) {
                var _v7 = _v6.a;
                var newForm_ = _v7.a;
                return newForm_;
            } else {
                var newForm_ = _v6.a;
                return newForm_;
            }
        }();
        var validatedGroupTierPricingForm = function() {
            var _v4 = A3($author$project$Components$Plan$Form$GroupTierPricingFields$validate, sharedFields, form.i, maybePlan);
            if (!_v4.$) {
                var _v5 = _v4.a;
                var newForm_ = _v5.a;
                return newForm_;
            } else {
                var newForm_ = _v4.a;
                return newForm_;
            }
        }();
        var validatedIndividualMembershipPricingForm = function() {
            var _v2 = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate, sharedFields, form.c$, maybePlan);
            if (!_v2.$) {
                var _v3 = _v2.a;
                var newForm_ = _v3.a;
                return newForm_;
            } else {
                var newForm_ = _v2.a;
                return newForm_;
            }
        }();
        var validatedSpecialRatesForm = A2($elm$core$Maybe$map, function(specialRatesForm) {
            var _v0 = A4($author$project$Components$Plan$Form$SpecialRatesFields$validate, sharedFields, practice, specialRatesForm, maybePlan);
            if (!_v0.$) {
                var _v1 = _v0.a;
                var newForm_ = _v1.a;
                return newForm_;
            } else {
                var newForm_ = _v0.a;
                return newForm_;
            }
        }, form.dj);
        return _Utils_update(form, {
            aB: validatedBasicPlan,
            cY: validatedFamilyMembershipPricingForm,
            i: validatedGroupTierPricingForm,
            c$: validatedIndividualMembershipPricingForm,
            dj: validatedSpecialRatesForm
        });
    });
    var $author$project$Components$PricingVersions$Form$update = F3(function(apiClient, msg, _v0) {
        update: while(true){
            var model = _v0;
            switch(msg.$){
                case 1:
                    var currentDate = msg.a;
                    var currentYear = $justinmimbs$date$Date$year(currentDate);
                    var nextYear = currentYear + 1;
                    var newName = $elm$core$String$fromInt(nextYear) + ' Pricing';
                    var newForm = A2($elm$core$Maybe$map, function(form) {
                        return _Utils_update(form, {
                            zr: newName
                        });
                    }, model.PU);
                    var updatedItem = function() {
                        var _v2 = model.F6;
                        if (_v2.$ === 3) {
                            var pricingVersion = _v2.a;
                            var meta = _v2.b;
                            return A2($author$project$Api$Data$Success, _Utils_update(pricingVersion, {
                                zr: newName
                            }), meta);
                        } else {
                            var other = _v2;
                            return other;
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        cP: $elm$core$Maybe$Just(currentDate),
                        PU: newForm,
                        F6: updatedItem
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                case 0:
                    var pricingVersionData = msg.a;
                    if (pricingVersionData.$ === 3) {
                        var pricingVersion = pricingVersionData.a;
                        var meta = pricingVersionData.b;
                        var updatedEffectiveDateInput = function() {
                            var _v7 = model.ago;
                            if (!_v7.$) return $author$project$Components$DateInput$initFromDate($author$project$Api$Provider$PricingVersion$One$effectiveDate(pricingVersion));
                            else return model.iC;
                        }();
                        var plan = $author$project$Api$Provider$PricingVersion$One$plan(pricingVersion);
                        var planData = A2($author$project$Api$Data$Success, plan, meta);
                        var _v4 = A6($author$project$Components$PricingVersions$Form$initFormFromPricingVersion, apiClient, model.Z$, pricingVersion, plan, model.W1, model.cP);
                        var initialForm = _v4.a;
                        var initCmd = _v4.b;
                        var finalForm = function() {
                            var _v5 = model.PU;
                            if (!_v5.$) {
                                var existingForm = _v5.a;
                                return _Utils_update(initialForm, {
                                    Ow: existingForm.Ow,
                                    aJ: existingForm.aJ,
                                    zr: existingForm.zr,
                                    o: existingForm.o
                                });
                            } else {
                                var _v6 = model.ago;
                                if (!_v6.$) return initialForm;
                                else return _Utils_update(initialForm, {
                                    Ow: $elm$core$Maybe$Nothing
                                });
                            }
                        }();
                        return _Utils_Tuple3(_Utils_update(model, {
                            k: planData,
                            iC: updatedEffectiveDateInput,
                            PU: $elm$core$Maybe$Just(finalForm),
                            nJ: pricingVersionData
                        }), initCmd, _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        k: A2($author$project$Api$Data$map, $author$project$Api$Provider$PricingVersion$One$plan, pricingVersionData),
                        nJ: pricingVersionData
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                case 2:
                    var name = msg.a;
                    var _v8 = model.PU;
                    if (!_v8.$) {
                        var form = _v8.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_update(form, {
                                zr: name,
                                o: false
                            }))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 3:
                    var subMsg = msg.a;
                    var _v9 = A2($author$project$Components$DateInput$update, subMsg, model.iC);
                    var newDateInput = _v9.a;
                    var subCmd = _v9.b;
                    var dateInputEvent = _v9.c;
                    var newForm = A2($elm$core$Maybe$map, function(form) {
                        if (dateInputEvent.$ === 1) {
                            var date = dateInputEvent.a;
                            return _Utils_update(form, {
                                Ow: date,
                                aJ: true
                            });
                        } else return form;
                    }, model.PU);
                    return _Utils_Tuple3(_Utils_update(model, {
                        iC: newDateInput,
                        PU: newForm
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg, subCmd), _List_Nil);
                case 9:
                    var formField = msg.a;
                    switch(formField.$){
                        case 0:
                            var enabled = formField.a;
                            var _v12 = _Utils_Tuple2(model.PU, model.k);
                            if (!_v12.a.$ && _v12.b.$ === 3) {
                                var form = _v12.a.a;
                                var _v13 = _v12.b;
                                var plan = _v13.a;
                                var newForm = _Utils_update(form, {
                                    xm: enabled
                                });
                                var calculateOpts = {
                                    _b: true,
                                    aa8: false
                                };
                                return function(_v14) {
                                    var newModel = _v14.a;
                                    var cmd = _v14.b;
                                    return _Utils_Tuple3(newModel, cmd, _List_Nil);
                                }(A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 1:
                            var groupPricingType = formField.a;
                            var _v15 = _Utils_Tuple2(model.PU, model.k);
                            if (!_v15.a.$ && _v15.b.$ === 3) {
                                var form = _v15.a.a;
                                var _v16 = _v15.b;
                                var plan = _v16.a;
                                var newForm = _Utils_update(form, {
                                    Qh: groupPricingType
                                });
                                var calculateOpts = {
                                    _b: true,
                                    aa8: false
                                };
                                return function(_v17) {
                                    var newModel = _v17.a;
                                    var cmd = _v17.b;
                                    return _Utils_Tuple3(newModel, cmd, _List_Nil);
                                }(A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 2:
                            var applies = formField.a;
                            var _v18 = _Utils_Tuple2(model.PU, model.k);
                            if (!_v18.a.$ && _v18.b.$ === 3) {
                                var form = _v18.a.a;
                                var _v19 = _v18.b;
                                var plan = _v19.a;
                                var newForm = _Utils_update(form, {
                                    Jy: applies
                                });
                                var calculateOpts = {
                                    _b: true,
                                    aa8: false
                                };
                                return function(_v20) {
                                    var newModel = _v20.a;
                                    var cmd = _v20.b;
                                    return _Utils_Tuple3(newModel, cmd, _List_Nil);
                                }(A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 3:
                            var isPercent = formField.a;
                            var _v21 = model.PU;
                            if (!_v21.$) {
                                var form = _v21.a;
                                var calculatedBy = isPercent ? 'percent_off' : 'amount_off_in_cents';
                                var updatedGroupDiscountRules = A2($elm$core$List$map, function(groupDiscountRule) {
                                    return _Utils_update(groupDiscountRule, {
                                        KD: calculatedBy
                                    });
                                }, form.Qd);
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    Qe: $elm$core$Maybe$Just(calculatedBy)
                                });
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 4:
                            var _v22 = model.PU;
                            if (!_v22.$) {
                                var form = _v22.a;
                                var updatedGroupDiscountRules = A2($elm$core$Maybe$withDefault, form.Qd, A2($elm$core$Maybe$map, function(_v24) {
                                    var newGroupDiscountRule = _v24.a;
                                    var newLastGroupDiscountRule = _v24.b;
                                    return A2($author$project$Utils$List$prepend, _List_fromArray([
                                        newGroupDiscountRule
                                    ]), A2($author$project$Utils$List$updateLast, function(last) {
                                        return A2($elm$core$Maybe$withDefault, last, newLastGroupDiscountRule);
                                    }, form.Qd));
                                }, A2($elm$core$Maybe$map, function(lastGroupDiscountRule) {
                                    var lastToSize = _Utils_cmp(lastGroupDiscountRule.P0 + 1, $author$project$Components$PricingVersions$Form$maxGroupFromSize - 1) > 0 ? $author$project$Components$PricingVersions$Form$maxGroupFromSize - 1 : lastGroupDiscountRule.P0 + 1;
                                    var newLastGroupDiscountRule_ = _Utils_update(lastGroupDiscountRule, {
                                        $6: $elm$core$Maybe$Just(lastToSize)
                                    });
                                    var _v23 = $author$project$Components$Plan$BasicForm$formFields(form.aB);
                                    var defaultPeriod = _v23.Nx;
                                    return _Utils_Tuple2(A2($author$project$Components$Plan$Form$GroupDiscountRuleField$startingFrom, defaultPeriod, newLastGroupDiscountRule_), $elm$core$Maybe$Just(newLastGroupDiscountRule_));
                                }, $elm_community$list_extra$List$Extra$last(form.Qd))));
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 8:
                            var index = formField.a;
                            var period = formField.b;
                            var currency = formField.c;
                            var _v25 = model.PU;
                            if (!_v25.$) {
                                var form = _v25.a;
                                var updatedGroupDiscountRules = A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                                    switch(period){
                                        case 'month':
                                            return _Utils_update(groupDiscountRule, {
                                                Uv: currency,
                                                Uw: true
                                            });
                                        case 'quarter':
                                            return _Utils_update(groupDiscountRule, {
                                                XW: currency,
                                                XX: true
                                            });
                                        case 'semi_annual':
                                            return _Utils_update(groupDiscountRule, {
                                                ZJ: currency,
                                                ZK: true
                                            });
                                        case 'annual':
                                            return _Utils_update(groupDiscountRule, {
                                                Jm: currency,
                                                Jn: true
                                            });
                                        default:
                                            return groupDiscountRule;
                                    }
                                }, form.Qd);
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                var cmd = function() {
                                    if (currency.$ === 1) return $elm$core$Platform$Cmd$none;
                                    else {
                                        var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
                                        return $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
                                    }
                                }();
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), cmd, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 11:
                            var index = formField.a;
                            var period = formField.b;
                            var percentage = formField.c;
                            var _v28 = model.PU;
                            if (!_v28.$) {
                                var form = _v28.a;
                                var updatedGroupDiscountRules = A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                                    switch(period){
                                        case 'month':
                                            return _Utils_update(groupDiscountRule, {
                                                UC: percentage,
                                                UD: true
                                            });
                                        case 'quarter':
                                            return _Utils_update(groupDiscountRule, {
                                                X0: percentage,
                                                X1: true
                                            });
                                        case 'semi_annual':
                                            return _Utils_update(groupDiscountRule, {
                                                ZP: percentage,
                                                ZQ: true
                                            });
                                        case 'annual':
                                            return _Utils_update(groupDiscountRule, {
                                                Js: percentage,
                                                Jt: true
                                            });
                                        default:
                                            return groupDiscountRule;
                                    }
                                }, form.Qd);
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                var cmd = function() {
                                    if (percentage.$ === 1) return $elm$core$Platform$Cmd$none;
                                    else {
                                        var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
                                        return $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
                                    }
                                }();
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), cmd, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 5:
                            var index = formField.a;
                            var _v31 = _Utils_Tuple2(model.PU, model.k);
                            if (!_v31.a.$ && _v31.b.$ === 3) {
                                var form = _v31.a.a;
                                var _v32 = _v31.b;
                                var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(A2($elm_community$list_extra$List$Extra$removeAt, index, form.Qd));
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
                                var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), cmd, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 6:
                            var index = formField.a;
                            var string = formField.b;
                            var _v33 = _Utils_Tuple2(model.PU, model.k);
                            if (!_v33.a.$ && _v33.b.$ === 3) {
                                var form = _v33.a.a;
                                var _v34 = _v33.b;
                                var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                                    return _Utils_update(groupDiscountRule, {
                                        P0: A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(string))
                                    });
                                }, form.Qd));
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
                                var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), cmd, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 7:
                            var index = formField.a;
                            var string = formField.b;
                            var _v35 = _Utils_Tuple2(model.PU, model.k);
                            if (!_v35.a.$ && _v35.b.$ === 3) {
                                var form = _v35.a.a;
                                var _v36 = _v35.b;
                                var updatedGroupDiscountRules = $author$project$Components$PricingVersions$Form$exclusiveSizeRanges(A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                                    return _Utils_update(groupDiscountRule, {
                                        $6: $elm$core$String$toInt(string)
                                    });
                                }, form.Qd));
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                var newFormFields = $author$project$Components$PricingVersions$Form$formFields(newForm);
                                var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), cmd, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 9:
                            var index = formField.a;
                            var period = formField.b;
                            var _v37 = model.PU;
                            if (!_v37.$) {
                                var form = _v37.a;
                                var updatedGroupDiscountRules = A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                                    switch(period){
                                        case 'month':
                                            return _Utils_update(groupDiscountRule, {
                                                Gm: true
                                            });
                                        case 'quarter':
                                            return _Utils_update(groupDiscountRule, {
                                                G9: true
                                            });
                                        case 'semi_annual':
                                            return _Utils_update(groupDiscountRule, {
                                                Ho: true
                                            });
                                        case 'annual':
                                            return _Utils_update(groupDiscountRule, {
                                                Eh: true
                                            });
                                        default:
                                            return _Utils_update(groupDiscountRule, {
                                                Gm: true
                                            });
                                    }
                                }, form.Qd);
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 12:
                            var index = formField.a;
                            var period = formField.b;
                            var _v39 = model.PU;
                            if (!_v39.$) {
                                var form = _v39.a;
                                var updatedGroupDiscountRules = A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                                    switch(period){
                                        case 'month':
                                            return _Utils_update(groupDiscountRule, {
                                                m9: true
                                            });
                                        case 'quarter':
                                            return _Utils_update(groupDiscountRule, {
                                                so: true
                                            });
                                        case 'semi_annual':
                                            return _Utils_update(groupDiscountRule, {
                                                sM: true
                                            });
                                        case 'annual':
                                            return _Utils_update(groupDiscountRule, {
                                                py: true
                                            });
                                        default:
                                            return _Utils_update(groupDiscountRule, {
                                                m9: true
                                            });
                                    }
                                }, form.Qd);
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                return _Utils_Tuple3(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 10:
                            var index = formField.a;
                            var period = formField.b;
                            var _v41 = _Utils_Tuple2(model.PU, model.k);
                            if (!_v41.a.$ && _v41.b.$ === 3) {
                                var form = _v41.a.a;
                                var _v42 = _v41.b;
                                var plan = _v42.a;
                                var updatedGroupDiscountRules = A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                                    switch(period){
                                        case 'month':
                                            return _Utils_update(groupDiscountRule, {
                                                Uv: $elm$core$Maybe$Nothing,
                                                Uw: false,
                                                Gm: false
                                            });
                                        case 'quarter':
                                            return _Utils_update(groupDiscountRule, {
                                                XW: $elm$core$Maybe$Nothing,
                                                XX: false,
                                                G9: false
                                            });
                                        case 'semi_annual':
                                            return _Utils_update(groupDiscountRule, {
                                                ZJ: $elm$core$Maybe$Nothing,
                                                ZK: false,
                                                Ho: false
                                            });
                                        case 'annual':
                                            return _Utils_update(groupDiscountRule, {
                                                Jm: $elm$core$Maybe$Nothing,
                                                Jn: false,
                                                Eh: false
                                            });
                                        default:
                                            return groupDiscountRule;
                                    }
                                }, form.Qd);
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                var calculateOpts = {
                                    _b: true,
                                    aa8: false
                                };
                                return function(_v43) {
                                    var newModel = _v43.a;
                                    var cmd = _v43.b;
                                    return _Utils_Tuple3(newModel, cmd, _List_Nil);
                                }(A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        default:
                            var index = formField.a;
                            var period = formField.b;
                            var _v45 = _Utils_Tuple2(model.PU, model.k);
                            if (!_v45.a.$ && _v45.b.$ === 3) {
                                var form = _v45.a.a;
                                var _v46 = _v45.b;
                                var plan = _v46.a;
                                var updatedGroupDiscountRules = A3($elm_community$list_extra$List$Extra$updateAt, index, function(groupDiscountRule) {
                                    switch(period){
                                        case 'month':
                                            return _Utils_update(groupDiscountRule, {
                                                UC: $elm$core$Maybe$Nothing,
                                                UD: false,
                                                m9: false
                                            });
                                        case 'quarter':
                                            return _Utils_update(groupDiscountRule, {
                                                X0: $elm$core$Maybe$Nothing,
                                                X1: false,
                                                so: false
                                            });
                                        case 'semi_annual':
                                            return _Utils_update(groupDiscountRule, {
                                                ZP: $elm$core$Maybe$Nothing,
                                                ZQ: false,
                                                sM: false
                                            });
                                        case 'annual':
                                            return _Utils_update(groupDiscountRule, {
                                                Js: $elm$core$Maybe$Nothing,
                                                Jt: false,
                                                py: false
                                            });
                                        default:
                                            return groupDiscountRule;
                                    }
                                }, form.Qd);
                                var newForm = _Utils_update(form, {
                                    Qd: updatedGroupDiscountRules,
                                    o: false
                                });
                                var calculateOpts = {
                                    _b: true,
                                    aa8: false
                                };
                                return function(_v47) {
                                    var newModel = _v47.a;
                                    var cmd = _v47.b;
                                    return _Utils_Tuple3(newModel, cmd, _List_Nil);
                                }(A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                case 4:
                    var planFormMsg = msg.a;
                    var _v49 = _Utils_Tuple2(model.PU, model.k);
                    if (!_v49.a.$ && _v49.b.$ === 3) {
                        var form = _v49.a.a;
                        var _v50 = _v49.b;
                        var plan = _v50.a;
                        var newBasicPlanResult = A4($author$project$Components$Plan$BasicForm$update, apiClient, planFormMsg, form.aB, $elm$core$Maybe$Just(plan));
                        var _v51 = function() {
                            var _v52 = newBasicPlanResult.adu;
                            if (_v52.$ === 1) return _Utils_Tuple2(_Utils_update(model, {
                                PU: $elm$core$Maybe$Just(_Utils_update(form, {
                                    aB: newBasicPlanResult.zi
                                }))
                            }), $elm$core$Platform$Cmd$none);
                            else {
                                var field = _v52.a;
                                var newForm = _Utils_update(form, {
                                    aB: newBasicPlanResult.zi
                                });
                                if (field.$ === 3) {
                                    var defaultPeriod = field.a;
                                    var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, $elm$core$Maybe$Just(plan), newForm);
                                    var defaultPeriodString = defaultPeriod ? 'annual' : 'month';
                                    var familyMembershipPricingResult = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$updateDefaultPeriod, defaultPeriodString, $elm$core$Maybe$Just(plan), form.cY);
                                    var groupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, form.i);
                                    var individualMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$updateDefaultPeriod, sharedFields, defaultPeriodString, form.c$);
                                    var finalForm = _Utils_update(newForm, {
                                        cY: familyMembershipPricingResult.zi,
                                        i: groupTierPricingResult.zi,
                                        c$: individualMembershipPricingResult.zi
                                    });
                                    var newFormFields = $author$project$Components$PricingVersions$Form$formFields(finalForm);
                                    var cmd = $author$project$Components$PricingVersions$Form$debounceCalculate(newFormFields);
                                    return _Utils_Tuple2(_Utils_update(model, {
                                        PU: $elm$core$Maybe$Just(finalForm)
                                    }), cmd);
                                } else {
                                    var calculateOpts = $author$project$Components$Plan$BasicForm$calculateOpts(field);
                                    return calculateOpts._b ? A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts) : _Utils_Tuple2(_Utils_update(model, {
                                        PU: $elm$core$Maybe$Just(newForm)
                                    }), $elm$core$Platform$Cmd$none);
                                }
                            }
                        }();
                        var newModel = _v51.a;
                        var formCmd = _v51.b;
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            formCmd,
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$BasicPlanFormUpdated, newBasicPlanResult.EQ)
                        ])), newBasicPlanResult.at);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 8:
                    var planFormMsg = msg.a;
                    var _v54 = _Utils_Tuple2(model.PU, model.k);
                    if (!_v54.a.$ && _v54.b.$ === 3) {
                        var form = _v54.a.a;
                        var _v55 = _v54.b;
                        var plan = _v55.a;
                        var specialRatesForm = function() {
                            var _v58 = form.dj;
                            if (!_v58.$) {
                                var existingForm = _v58.a;
                                return existingForm;
                            } else {
                                var maybePricingVersion = function() {
                                    var _v59 = model.nJ;
                                    if (_v59.$ === 3) {
                                        var pricingVersion = _v59.a;
                                        return $elm$core$Maybe$Just(pricingVersion);
                                    } else return $elm$core$Maybe$Nothing;
                                }();
                                return A3($author$project$Components$Plan$Form$SpecialRatesFields$fillFromCurrentForm, $elm$core$Maybe$Nothing, plan, maybePricingVersion);
                            }
                        }();
                        var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, $elm$core$Maybe$Just(plan), form);
                        var newSpecialRatesResult = A3($author$project$Components$Plan$Form$SpecialRatesFields$update, sharedFields, planFormMsg, specialRatesForm);
                        var _v56 = function() {
                            var _v57 = newSpecialRatesResult.adu;
                            var field = _v57;
                            var newForm = _Utils_update(form, {
                                dj: $elm$core$Maybe$Just(newSpecialRatesResult.zi)
                            });
                            return $author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field)._b ? A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, $author$project$Components$Plan$Form$SpecialRatesFields$calculateOpts(field)) : _Utils_Tuple2(_Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm)
                            }), $elm$core$Platform$Cmd$none);
                        }();
                        var newModel = _v56.a;
                        var formCmd = _v56.b;
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated, newSpecialRatesResult.EQ),
                            formCmd
                        ])), newSpecialRatesResult.at);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 5:
                    var planFormMsg = msg.a;
                    var _v60 = _Utils_Tuple2(model.PU, model.k);
                    if (!_v60.a.$ && _v60.b.$ === 3) {
                        var form = _v60.a.a;
                        var _v61 = _v60.b;
                        var plan = _v61.a;
                        var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, $elm$core$Maybe$Just(plan), form);
                        var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, planFormMsg, form.c$);
                        var _v62 = function() {
                            var _v63 = newMembershipPricingResult.adu;
                            if (!_v63.$) {
                                var field = _v63.a;
                                var newForm = _Utils_update(form, {
                                    c$: newMembershipPricingResult.zi
                                });
                                return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field)._b ? A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, $author$project$Components$Plan$Form$IndividualMembershipPricingFields$calculateOpts(field)) : _Utils_Tuple2(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), $elm$core$Platform$Cmd$none);
                            } else {
                                var newForm = _Utils_update(form, {
                                    c$: newMembershipPricingResult.zi
                                });
                                var _v64 = A3($author$project$Components$PricingVersions$Form$update, apiClient, $author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing, _Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }));
                                var updatedModel = _v64.a;
                                var updatedCmd = _v64.b;
                                return _Utils_Tuple2(updatedModel, updatedCmd);
                            }
                        }();
                        var newModel = _v62.a;
                        var formCmd = _v62.b;
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.EQ),
                            formCmd
                        ])), newMembershipPricingResult.at);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 6:
                    var planFormMsg = msg.a;
                    var _v65 = _Utils_Tuple2(model.PU, model.k);
                    if (!_v65.a.$ && _v65.b.$ === 3) {
                        var form = _v65.a.a;
                        var _v66 = _v65.b;
                        var plan = _v66.a;
                        var newFamilyMembershipPricingResult = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$update, planFormMsg, form.cY, $elm$core$Maybe$Just(plan));
                        var _v67 = function() {
                            var _v68 = newFamilyMembershipPricingResult.adu;
                            if (!_v68.$) {
                                var groupPricingType = _v68.a;
                                var newForm = _Utils_update(form, {
                                    cY: newFamilyMembershipPricingResult.zi
                                });
                                var finalForm = _Utils_update(newForm, {
                                    Qh: groupPricingType
                                });
                                return A4($author$project$Components$PricingVersions$Form$calculate, model, plan, finalForm, {
                                    _b: true,
                                    aa8: false
                                });
                            } else {
                                var field = _v68.a;
                                var newForm = _Utils_update(form, {
                                    cY: newFamilyMembershipPricingResult.zi
                                });
                                return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field)._b ? A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, $author$project$Components$Plan$Form$FamilyMembershipPricingFields$calculateOpts(field)) : _Utils_Tuple2(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), $elm$core$Platform$Cmd$none);
                            }
                        }();
                        var newModel = _v67.a;
                        var formCmd = _v67.b;
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.EQ),
                            formCmd
                        ])), newFamilyMembershipPricingResult.at);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 7:
                    var planFormMsg = msg.a;
                    var _v69 = model.PU;
                    if (!_v69.$) {
                        var form = _v69.a;
                        var maybePlan = function() {
                            var _v76 = model.k;
                            if (_v76.$ === 3) {
                                var plan = _v76.a;
                                return $elm$core$Maybe$Just(plan);
                            } else return $elm$core$Maybe$Nothing;
                        }();
                        var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
                        var newGroupTierPricingResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$update, sharedFields, planFormMsg, form.i);
                        var newForm = _Utils_update(form, {
                            i: newGroupTierPricingResult.zi
                        });
                        var _v70 = newGroupTierPricingResult.adu;
                        if (_v70.$ === 1) {
                            var $temp$apiClient = apiClient, $temp$msg = $author$project$Components$PricingVersions$Form$ToggleFixedMembershipPricing, $temp$_v0 = _Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm)
                            });
                            apiClient = $temp$apiClient;
                            msg = $temp$msg;
                            _v0 = $temp$_v0;
                            continue update;
                        } else {
                            var field = _v70.a;
                            var updatedModel = _Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm)
                            });
                            var calculateOpts = $author$project$Components$Plan$Form$GroupTierPricingFields$calculateOpts(field);
                            var shouldActuallyCalculate = function() {
                                if (field.$ === 12) {
                                    var ruleType = field.a;
                                    var tierFormFields = $author$project$Components$Plan$Form$GroupTierPricingFields$formFields(newForm.i);
                                    switch(ruleType){
                                        case 0:
                                            return !_Utils_eq(tierFormFields.PO, $elm$core$Maybe$Nothing);
                                        case 1:
                                            return !_Utils_eq(tierFormFields.Pq, $elm$core$Maybe$Nothing);
                                        default:
                                            return !_Utils_eq(tierFormFields.Qg, $elm$core$Maybe$Nothing);
                                    }
                                } else return calculateOpts._b;
                            }();
                            var _v71 = function() {
                                if (shouldActuallyCalculate) {
                                    var _v72 = model.k;
                                    if (_v72.$ === 3) {
                                        var plan = _v72.a;
                                        var updateResult = A3($author$project$Components$Plan$Form$GroupTierPricingFields$updateDefaultPeriod, sharedFields, sharedFields.Nx, newGroupTierPricingResult.zi);
                                        var calculatedForm = _Utils_update(newForm, {
                                            i: updateResult.zi
                                        });
                                        var _v73 = A4($author$project$Components$PricingVersions$Form$calculate, updatedModel, plan, calculatedForm, calculateOpts);
                                        var calcModel = _v73.a;
                                        var calcCmd = _v73.b;
                                        return _Utils_Tuple2(calcModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                            A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.EQ),
                                            A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, updateResult.EQ),
                                            calcCmd
                                        ])));
                                    } else return _Utils_Tuple2(updatedModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.EQ));
                                } else return _Utils_Tuple2(updatedModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, newGroupTierPricingResult.EQ));
                            }();
                            var calculatedModel = _v71.a;
                            var calculatedCmd = _v71.b;
                            return _Utils_Tuple3(calculatedModel, calculatedCmd, newGroupTierPricingResult.at);
                        }
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 10:
                    var _v77 = _Utils_Tuple2(model.PU, model.k);
                    if (!_v77.a.$ && _v77.b.$ === 3) {
                        var form = _v77.a.a;
                        var _v78 = _v77.b;
                        var plan = _v78.a;
                        var newGroupPricingType = form.Qh === 'fixed_pricing' ? 'family' : 'fixed_pricing';
                        var newForm = _Utils_update(form, {
                            Qh: newGroupPricingType
                        });
                        var calculateOpts = {
                            _b: true,
                            aa8: false
                        };
                        return function(_v79) {
                            var newModel = _v79.a;
                            var cmd = _v79.b;
                            return _Utils_Tuple3(newModel, cmd, _List_Nil);
                        }(A4($author$project$Components$PricingVersions$Form$calculate, model, plan, newForm, calculateOpts));
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 11:
                    return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Components$PricingVersions$Form$planRoute(model.J8)), _List_Nil);
                case 12:
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 2, 'dummy delete')
                    ]));
                case 13:
                    var _v80 = _Utils_Tuple2(model.PU, model.k);
                    if (!_v80.a.$ && _v80.b.$ === 3) {
                        var form = _v80.a.a;
                        var _v81 = _v80.b;
                        var plan = _v81.a;
                        var validatedForm = A3($author$project$Components$PricingVersions$Form$validateFormFields, $elm$core$Maybe$Just(plan), model.W1, form);
                        var specialRatesHasErrors = function() {
                            var _v83 = validatedForm.dj;
                            if (!_v83.$) {
                                var specialRatesForm = _v83.a;
                                return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
                            } else return false;
                        }();
                        var newForm = _Utils_update(validatedForm, {
                            aJ: true,
                            o: true
                        });
                        var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(validatedForm.zr);
                        var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(validatedForm.c$);
                        var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(validatedForm.i);
                        var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(validatedForm.cY);
                        var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, true, validatedForm.Ow);
                        var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(validatedForm.aB);
                        var hasErrors = !($elm$core$List$isEmpty(nameErrors) && $elm$core$List$isEmpty(effectiveDateErrors)) || basicPlanHasErrors || individualPricingHasErrors || familyPricingHasErrors || groupTierPricingHasErrors || specialRatesHasErrors;
                        if (hasErrors) return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            gU: true
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                        else {
                            var pricingVersionName = newForm.zr;
                            var planUpdateFields = function() {
                                var isCreate = _Utils_eq(model.ago, $elm$core$Maybe$Nothing);
                                var fields = $author$project$Components$PricingVersions$Form$updatePlanFieldsForSave($author$project$Components$PricingVersions$Form$formFields(newForm));
                                return isCreate ? _Utils_update(fields, {
                                    _M: A2($elm$core$List$map, function(sr) {
                                        return _Utils_update(sr, {
                                            Mw: true,
                                            NU: false,
                                            aef: $elm$core$Maybe$Nothing
                                        });
                                    }, A2($elm$core$List$filter, function(sr) {
                                        return !sr.NU;
                                    }, fields._M))
                                }) : fields;
                            }();
                            var planId = $author$project$Api$Provider$Plan$One$id(plan);
                            var effectiveDateString = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, newForm.Ow));
                            var currentBasicPlanFields = $author$project$Components$Plan$BasicForm$formFields(newForm.aB);
                            var editedRegistrationFeeCategoryId = $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(currentBasicPlanFields.de);
                            var editedRegistrationFeeDescription = currentBasicPlanFields.BG;
                            var editedRegistrationFeeName = currentBasicPlanFields.BH;
                            var createFields = {
                                Jy: newForm.Jy,
                                xm: newForm.xm,
                                Ow: effectiveDateString,
                                Qe: newForm.Qe,
                                Qh: newForm.Qh,
                                zr: pricingVersionName,
                                WL: planUpdateFields,
                                BF: editedRegistrationFeeCategoryId,
                                BG: editedRegistrationFeeDescription,
                                BH: editedRegistrationFeeName
                            };
                            var saveCmd = function() {
                                var _v82 = model.ago;
                                if (!_v82.$) {
                                    var pvId = _v82.a;
                                    return A5($author$project$Api$Provider$PricingVersion$update, apiClient, planId, pvId, createFields, $author$project$Components$PricingVersions$Form$PricingVersionUpdated);
                                } else return A4($author$project$Api$Provider$PricingVersion$create, apiClient, planId, createFields, $author$project$Components$PricingVersions$Form$PricingVersionCreated);
                            }();
                            return _Utils_Tuple3(_Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm),
                                gU: false
                            }), saveCmd, _List_Nil);
                        }
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 14:
                    var response = msg.a;
                    switch(response.$){
                        case 3:
                            return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Components$PricingVersions$Form$planRoute(model.J8)), _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Price change created successfully')
                            ]));
                        case 2:
                            var error = response.a;
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                            ]));
                        default:
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                case 15:
                    var response = msg.a;
                    switch(response.$){
                        case 3:
                            return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Components$PricingVersions$Form$planRoute(model.J8)), _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Price change updated successfully')
                            ]));
                        case 2:
                            var error = response.a;
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                            ]));
                        default:
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                case 16:
                    var subMsg = msg.a;
                    var _v86 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$PricingVersions$Form$previewDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$PricingVersions$Form$debounceCalculate), subMsg, model.eq);
                    var newDebouncer = _v86.a;
                    var debouncerCmd = _v86.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        eq: newDebouncer
                    }), debouncerCmd, _List_Nil);
                case 17:
                    var pricingFormFields = msg.a;
                    var _v87 = model.k;
                    if (_v87.$ === 3) {
                        var previousPreviewId = model.agk.a;
                        var previewId = previousPreviewId + 1;
                        var tracker = 'pricing_version_preview_' + $elm$core$String$fromInt(previewId);
                        var planUpdateFields = $author$project$Components$PricingVersions$Form$updatePlanFieldsForCalculate(pricingFormFields);
                        var calculateCmd = function() {
                            var _v88 = model.ago;
                            if (!_v88.$) {
                                var pvId = _v88.a;
                                var effectiveDateString = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, pricingFormFields.Ow));
                                var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(pricingFormFields.aB);
                                var createFields = {
                                    Jy: pricingFormFields.Jy,
                                    xm: pricingFormFields.xm,
                                    Ow: effectiveDateString,
                                    Qe: pricingFormFields.Qe,
                                    Qh: pricingFormFields.Qh,
                                    zr: pricingFormFields.zr,
                                    WL: planUpdateFields,
                                    BF: $author$project$Components$Plan$Form$RegistrationFeePricingFields$getCategoryId(basicPlanFormFields.de),
                                    BG: basicPlanFormFields.BG,
                                    BH: basicPlanFormFields.BH
                                };
                                return A7($author$project$Api$Provider$PricingVersion$calculate, apiClient, model.J8, pvId, _List_fromArray([
                                    1
                                ]), tracker, createFields, $author$project$Components$PricingVersions$Form$GotPreview(previewId));
                            } else return A6($author$project$Api$Provider$Plan$calculate, apiClient, _List_fromArray([
                                1
                            ]), tracker, model.J8, planUpdateFields, $author$project$Components$PricingVersions$Form$GotPreview(previewId));
                        }();
                        return _Utils_Tuple3(_Utils_update(model, {
                            agk: _Utils_Tuple2(previewId, $author$project$Api$Data$Loading)
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            calculateCmd,
                            $elm$http$Http$cancel('pricing_version_preview_' + $elm$core$String$fromInt(previousPreviewId))
                        ])), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                default:
                    var previewId = msg.a;
                    var response = msg.b;
                    if (_Utils_eq(model.agk.a, previewId)) switch(response.$){
                        case 3:
                            var calculatedPlan = response.a;
                            var maybePricingVersion = function() {
                                var _v93 = model.nJ;
                                if (_v93.$ === 3) {
                                    var pv = _v93.a;
                                    return $elm$core$Maybe$Just(pv);
                                } else return $elm$core$Maybe$Nothing;
                            }();
                            var currentSpecialRatesForm = A2($elm$core$Maybe$andThen, function($) {
                                return $.dj;
                            }, model.PU);
                            var _v90 = A6($author$project$Components$PricingVersions$Form$initFormFieldsWithSpecialRates, apiClient, model.Z$, model.W1, calculatedPlan, maybePricingVersion, currentSpecialRatesForm);
                            var calculatedForm = _v90.a;
                            var calculatedFormCmd = _v90.b;
                            var newForm = function() {
                                var _v91 = model.PU;
                                if (!_v91.$) {
                                    var existingForm = _v91.a;
                                    return _Utils_update(calculatedForm, {
                                        aB: existingForm.aB,
                                        xm: existingForm.xm,
                                        Ow: existingForm.Ow,
                                        aJ: existingForm.aJ,
                                        Qd: A3($elm$core$List$map2, F2(function(calculated, existing) {
                                            var isPercentValid = function(maybePercent) {
                                                if (!maybePercent.$) {
                                                    var percent = maybePercent.a;
                                                    return A2($author$project$Percentage$isValid, {
                                                        y_: $elm$core$Maybe$Just(100),
                                                        Uj: $elm$core$Maybe$Just(0)
                                                    }, percent);
                                                } else return true;
                                            };
                                            return _Utils_update(calculated, {
                                                Jn: existing.Jn,
                                                Eh: false,
                                                Js: existing.Jt && !isPercentValid(existing.Js) ? existing.Js : calculated.Js,
                                                Jt: existing.Jt,
                                                py: false,
                                                Uw: existing.Uw,
                                                Gm: false,
                                                UC: existing.UD && !isPercentValid(existing.UC) ? existing.UC : calculated.UC,
                                                UD: existing.UD,
                                                m9: false,
                                                XX: existing.XX,
                                                G9: false,
                                                X0: existing.X1 && !isPercentValid(existing.X0) ? existing.X0 : calculated.X0,
                                                X1: existing.X1,
                                                so: false,
                                                ZK: existing.ZK,
                                                Ho: false,
                                                ZP: existing.ZQ && !isPercentValid(existing.ZP) ? existing.ZP : calculated.ZP,
                                                ZQ: existing.ZQ,
                                                sM: false
                                            });
                                        }), calculatedForm.Qd, existingForm.Qd),
                                        zr: existingForm.zr,
                                        o: existingForm.o
                                    });
                                } else return calculatedForm;
                            }();
                            return _Utils_Tuple3(_Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm),
                                agk: _Utils_Tuple2(previewId, response)
                            }), calculatedFormCmd, _List_Nil);
                        case 2:
                            return _Utils_Tuple3(_Utils_update(model, {
                                agk: _Utils_Tuple2(previewId, response)
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        case 1:
                            return _Utils_Tuple3(_Utils_update(model, {
                                agk: _Utils_Tuple2(previewId, response)
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        default:
                            return _Utils_Tuple3(_Utils_update(model, {
                                agk: _Utils_Tuple2(previewId, response)
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                    else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }
        }
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$PricingVersions$Form$update, model.Ej, subMsg, model.PU);
        var newForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$PricingVersions$Form$Delete = {
        $: 12
    };
    var $author$project$Components$PricingVersions$Form$NavigateBack = {
        $: 11
    };
    var $author$project$Components$PricingVersions$Form$Save = {
        $: 13
    };
    var $author$project$Ui$Button$Close = {
        $: 12
    };
    var $author$project$Ui$Button$close = $author$project$Ui$Button$Close;
    var $author$project$Components$PricingVersions$Form$hasAnyValidationErrors = F3(function(_v0, _v1, form) {
        var specialRatesHasErrors = function() {
            var _v2 = form.dj;
            if (!_v2.$) {
                var specialRatesForm = _v2.a;
                return $author$project$Components$Plan$Form$SpecialRatesFields$hasErrors(specialRatesForm);
            } else return false;
        }();
        var nameErrors = $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.zr);
        var individualPricingHasErrors = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(form.c$);
        var groupTierPricingHasErrors = $author$project$Components$Plan$Form$GroupTierPricingFields$hasErrors(form.i);
        var groupDiscountRulesHaveErrors = false;
        var familyPricingHasErrors = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(form.cY);
        var effectiveDateErrors = A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, form.aJ, form.Ow);
        var basicPlanHasErrors = $author$project$Components$Plan$BasicForm$hasErrors(form.aB);
        return !($elm$core$List$isEmpty(nameErrors) && $elm$core$List$isEmpty(effectiveDateErrors)) || basicPlanHasErrors || individualPricingHasErrors || familyPricingHasErrors || groupTierPricingHasErrors || specialRatesHasErrors || groupDiscountRulesHaveErrors;
    });
    var $author$project$Components$PricingVersions$Form$NameChanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$BasicForm$hasRegistrationFeeNameError = function(_v0) {
        var form = _v0.b;
        return A2($author$project$Utils$Form$hasValidationErrors, 8, form);
    };
    var $author$project$Components$Plan$BasicForm$registrationFeeNameErrors = function(_v0) {
        var form = _v0.b;
        return A2($author$project$Utils$Form$validationErrors, 8, form);
    };
    var $author$project$Components$PricingVersions$Form$viewBasicPlanFieldsForPricingVersion = F2(function(basicPlan, _v0) {
        var fields = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
        return _List_fromArray([
            A4($author$project$Components$Plan$Form$RegistrationFeePricingFields$viewRegistrationFeePricingFields, {
                K1: fields.sr,
                iB: fields.iB,
                l1: fields.l1,
                ad4: $author$project$Components$Plan$BasicForm$hasRegistrationFeeNameError(basicPlan),
                afy: $author$project$Components$Plan$BasicForm$EditRegistrationFeeCategory,
                afz: $author$project$Components$Plan$BasicForm$EditRegistrationFeeDescription,
                afL: $author$project$Components$Plan$BasicForm$RegistrationFeeDescription,
                afM: $author$project$Components$Plan$BasicForm$RegistrationFeeName,
                BG: fields.BG,
                BH: fields.BH,
                agF: $author$project$Components$Plan$BasicForm$registrationFeeNameErrors(basicPlan)
            }, $author$project$Components$Plan$BasicForm$FormUpdated, $author$project$Components$Plan$BasicForm$RegistrationFeePricingFieldsMsg, fields.de)
        ]);
    });
    var $author$project$Components$PricingVersions$Form$DiscountsEnabled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$FormUpdated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle = function(form) {
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Do you offer discounts to family members who enroll together?'),
                $author$project$Utils$Html$noBreakSpace,
                A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(form.xm),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$PricingVersions$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$PricingVersions$Form$DiscountsEnabled(true))))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Yes')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(!form.xm),
                        $author$project$Ui$Form$Radio$inline,
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$PricingVersions$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$PricingVersions$Form$DiscountsEnabled(false))))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('No')
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Utils$Html$noBreakSpace
        ]));
    };
    var $author$project$Components$PricingVersions$Form$viewFamilyMembershipPricing = F3(function(sharedFields, plan, form) {
        var discountsEnabled = form.xm;
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle(form),
            function() {
                if (discountsEnabled) {
                    var familyMembershipPricingForm = form.cY;
                    return A2($elm$html$Html$map, $author$project$Components$PricingVersions$Form$FamilyMembershipPricingFieldsUpdated, A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$view, sharedFields, $elm$core$Maybe$Just(plan), familyMembershipPricingForm));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAdd = {
        $: 4
    };
    var $author$project$Components$PricingVersions$Form$GroupPricingType = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$GroupDiscountRuleFromSize = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$GroupDiscountRuleRemove = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$PricingVersions$Form$GroupDiscountRuleToSize = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions = function(start) {
        return A2($elm$core$List$map, function(size) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(size)), A2($author$project$Formatters$String$pluralize, 'Member', size));
        }, A2($elm$core$List$range, start, 9));
    };
    var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCents = F3(function(a, b, c) {
        return {
            $: 8,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsEdit = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsReset = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$validateGroupDiscountRuleAmountOffInCents = F3(function(index, period, form) {
        var groupDiscountRule = A2($elm_community$list_extra$List$Extra$getAt, index, form.Qd);
        var defaultPeriod = function() {
            var basicFields = $author$project$Components$Plan$BasicForm$formFields(form.aB);
            return basicFields.Nx === 'annual' ? 'annual' : 'month';
        }();
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(groupDiscountRule, period);
            _v1$4: while(true){
                if (!_v1.a.$) switch(_v1.b){
                    case 'month':
                        var rule = _v1.a.a;
                        return _Utils_Tuple2(rule.Uv, rule.Uw);
                    case 'quarter':
                        var rule = _v1.a.a;
                        return _Utils_Tuple2(rule.XW, rule.XX);
                    case 'semi_annual':
                        var rule = _v1.a.a;
                        return _Utils_Tuple2(rule.ZJ, rule.ZK);
                    case 'annual':
                        var rule = _v1.a.a;
                        return _Utils_Tuple2(rule.Jm, rule.Jn);
                    default:
                        break _v1$4;
                }
                else break _v1$4;
            }
            return _Utils_Tuple2($elm$core$Maybe$Nothing, false);
        }();
        var periodAmount = _v0.a;
        var periodEdited = _v0.b;
        if (_Utils_eq(defaultPeriod, period) || periodEdited) {
            if (periodAmount.$ === 1) return _List_fromArray([
                'Please enter an amount.'
            ]);
            else {
                var amount = periodAmount.a;
                var min = 0;
                var max = 999999999;
                var amountInt = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(amount));
                return _Utils_cmp(amountInt, min) < 0 || _Utils_cmp(amountInt, max) > 0 ? _List_fromArray([
                    'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.')))
                ]) : _List_Nil;
            }
        } else return _List_Nil;
    });
    var $author$project$Components$PricingVersions$Form$validateGroupDiscountRulePercentOff = F3(function(index, period, form) {
        var groupDiscountRule = A2($elm_community$list_extra$List$Extra$getAt, index, form.Qd);
        var defaultPeriod = function() {
            var basicFields = $author$project$Components$Plan$BasicForm$formFields(form.aB);
            return basicFields.Nx === 'annual' ? 'annual' : 'month';
        }();
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(groupDiscountRule, period);
            _v1$4: while(true){
                if (!_v1.a.$) switch(_v1.b){
                    case 'month':
                        var rule = _v1.a.a;
                        return _Utils_Tuple2(rule.UC, rule.UD);
                    case 'quarter':
                        var rule = _v1.a.a;
                        return _Utils_Tuple2(rule.X0, rule.X1);
                    case 'semi_annual':
                        var rule = _v1.a.a;
                        return _Utils_Tuple2(rule.ZP, rule.ZQ);
                    case 'annual':
                        var rule = _v1.a.a;
                        return _Utils_Tuple2(rule.Js, rule.Jt);
                    default:
                        break _v1$4;
                }
                else break _v1$4;
            }
            return _Utils_Tuple2($elm$core$Maybe$Nothing, false);
        }();
        var periodPercent = _v0.a;
        var periodEdited = _v0.b;
        if (_Utils_eq(defaultPeriod, period) || periodEdited) {
            if (periodPercent.$ === 1) return _List_fromArray([
                'Please enter a percentage.'
            ]);
            else {
                var percent = periodPercent.a;
                var min = 0;
                var max = 100;
                return !A2($author$project$Percentage$isValid, {
                    y_: $elm$core$Maybe$Just(max),
                    Uj: $elm$core$Maybe$Just(min)
                }, percent) ? _List_fromArray([
                    'Please enter a percentage between ' + ($author$project$Formatters$Float$toPercentage(min) + (' and ' + ($author$project$Formatters$Float$toPercentage(max) + '.')))
                ]) : _List_Nil;
            }
        } else return _List_Nil;
    });
    var $author$project$Components$PricingVersions$Form$validationErrors = F2(function(validationGroup, form) {
        if (!validationGroup.$) {
            var index = validationGroup.a;
            var period = validationGroup.b;
            return form.o ? A3($author$project$Components$PricingVersions$Form$validateGroupDiscountRuleAmountOffInCents, index, period, form) : _List_Nil;
        } else {
            var index = validationGroup.a;
            var period = validationGroup.b;
            return form.o ? A3($author$project$Components$PricingVersions$Form$validateGroupDiscountRulePercentOff, index, period, form) : _List_Nil;
        }
    });
    var $author$project$Components$PricingVersions$Form$hasValidationErrors = F2(function(validationGroup, form) {
        return !$elm$core$List$isEmpty(A2($author$project$Components$PricingVersions$Form$validationErrors, validationGroup, form));
    });
    var $author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRulePeriodForPricingVersions = F5(function(_v0, form, index, groupDiscountRule, period) {
        var _v1 = function() {
            switch(period){
                case 'month':
                    return _Utils_Tuple3(groupDiscountRule.Uv, groupDiscountRule.Gm, groupDiscountRule.Uw);
                case 'quarter':
                    return _Utils_Tuple3(groupDiscountRule.XW, groupDiscountRule.G9, groupDiscountRule.XX);
                case 'semi_annual':
                    return _Utils_Tuple3(groupDiscountRule.ZJ, groupDiscountRule.Ho, groupDiscountRule.ZK);
                case 'annual':
                    return _Utils_Tuple3(groupDiscountRule.Jm, groupDiscountRule.Eh, groupDiscountRule.Jn);
                default:
                    return _Utils_Tuple3(groupDiscountRule.Uv, groupDiscountRule.Gm, groupDiscountRule.Uw);
            }
        }();
        var periodAmountInCents = _v1.a;
        var editingPeriod = _v1.b;
        var periodEdited = _v1.c;
        var _v3 = $author$project$Components$Plan$BasicForm$formFields(form.aB);
        var defaultPeriod = _v3.Nx;
        return A2($author$project$Ui$Typography$div, _List_Nil, _Utils_eq(defaultPeriod, period) || editingPeriod ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                $elm$html$Html$text(' discount')
            ])),
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(periodAmountInCents),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$PricingVersions$Form$FormUpdated, A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCents, index, period))),
                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Components$PricingVersions$Form$hasValidationErrors, A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation, index, period), form))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Components$PricingVersions$Form$validationErrors, A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsValidation, index, period), form))
        ]) : _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text(function() {
                        if (!periodAmountInCents.$) {
                            var amount = periodAmountInCents.a;
                            return $author$project$Currency$format(amount);
                        } else return '$0.00';
                    }()),
                    $elm$html$Html$text(' off'),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit period amount off'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated(A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsEdit, index, period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    periodEdited ? A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Reset period amount off'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated(A2($author$project$Components$PricingVersions$Form$GroupDiscountRuleAmountOffInCentsReset, index, period)))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Reset')
                        ])),
                        $author$project$Utils$Html$noBreakSpace
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRuleForPricingVersions = F5(function(plan, form, periods, index, groupDiscountRule) {
        return A2($elm$core$List$map, A4($author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRulePeriodForPricingVersions, plan, form, index, groupDiscountRule), periods);
    });
    var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOff = F3(function(a, b, c) {
        return {
            $: 11,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffEdit = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffReset = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingVersions$Form$viewPercentOffPricingRulePeriodForPricingVersions = F5(function(_v0, form, index, groupDiscountRule, period) {
        var _v1 = function() {
            switch(period){
                case 'month':
                    return _Utils_Tuple3(groupDiscountRule.UC, groupDiscountRule.m9, groupDiscountRule.UD);
                case 'quarter':
                    return _Utils_Tuple3(groupDiscountRule.X0, groupDiscountRule.so, groupDiscountRule.X1);
                case 'semi_annual':
                    return _Utils_Tuple3(groupDiscountRule.ZP, groupDiscountRule.sM, groupDiscountRule.ZQ);
                case 'annual':
                    return _Utils_Tuple3(groupDiscountRule.Js, groupDiscountRule.py, groupDiscountRule.Jt);
                default:
                    return _Utils_Tuple3(groupDiscountRule.UC, groupDiscountRule.m9, groupDiscountRule.UD);
            }
        }();
        var periodPercentOff = _v1.a;
        var editingPeriod = _v1.b;
        var periodEdited = _v1.c;
        var _v3 = $author$project$Components$Plan$BasicForm$formFields(form.aB);
        var defaultPeriod = _v3.Nx;
        return A2($author$project$Ui$Typography$div, _List_Nil, _Utils_eq(defaultPeriod, period) || editingPeriod ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                $elm$html$Html$text(' discount')
            ])),
            $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                $author$project$Ui$Form$PercentageInput$value(periodPercentOff),
                $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$PricingVersions$Form$FormUpdated, A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOff, index, period))),
                $author$project$Ui$Form$PercentageInput$invalid(A2($author$project$Components$PricingVersions$Form$hasValidationErrors, A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation, index, period), form))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Components$PricingVersions$Form$validationErrors, A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffValidation, index, period), form))
        ]) : _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize(period)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text(function() {
                        if (!periodPercentOff.$) {
                            var percentage = periodPercentOff.a;
                            return $author$project$Percentage$format(percentage);
                        } else return '0%';
                    }()),
                    $elm$html$Html$text(' off'),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit period percent off'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated(A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffEdit, index, period)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    periodEdited ? A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Reset period percent off'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated(A2($author$project$Components$PricingVersions$Form$GroupDiscountRulePercentOffReset, index, period)))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Reset')
                        ])),
                        $author$project$Utils$Html$noBreakSpace
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Components$PricingVersions$Form$viewPercentOffPricingRuleForPricingVersions = F5(function(plan, form, periods, index, groupDiscountRule) {
        return A2($elm$core$List$map, A4($author$project$Components$PricingVersions$Form$viewPercentOffPricingRulePeriodForPricingVersions, plan, form, index, groupDiscountRule), periods);
    });
    var $author$project$Components$PricingVersions$Form$viewGroupDiscountRule = F4(function(plan, form, index, groupDiscountRule) {
        var isFirst = !index;
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, isFirst ? _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(groupDiscountRule.P0))),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$PricingVersions$Form$FormUpdated, $author$project$Components$PricingVersions$Form$GroupDiscountRuleFromSize(index)))
                ]), $author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions(0))
            ]) : _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(groupDiscountRule.P0))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, !_Utils_eq(groupDiscountRule.$6, $elm$core$Maybe$Nothing) ? _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, groupDiscountRule.$6)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$PricingVersions$Form$FormUpdated, $author$project$Components$PricingVersions$Form$GroupDiscountRuleToSize(index)))
                ]), $author$project$Components$PricingVersions$Form$groupDiscountRuleSizeOptions(groupDiscountRule.P0))
            ]) : _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('All Members')
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_Nil),
                !isFirst ? A3($author$project$Ui$Button$view, {
                    abP: 'Remove group disount rule'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated($author$project$Components$PricingVersions$Form$GroupDiscountRuleRemove(index))),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Remove')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v0 = groupDiscountRule.KD;
                switch(_v0){
                    case 'amount_off_in_cents':
                        return A5($author$project$Components$PricingVersions$Form$viewAmountInCentsPricingRuleForPricingVersions, plan, form, $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes($author$project$Api$Provider$Plan$One$meta(plan)), index, groupDiscountRule);
                    case 'percent_off':
                        return A5($author$project$Components$PricingVersions$Form$viewPercentOffPricingRuleForPricingVersions, plan, form, $author$project$Api$Provider$Plan$Meta$allowedPeriodCodes($author$project$Api$Provider$Plan$One$meta(plan)), index, groupDiscountRule);
                    default:
                        return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Not set')
                            ]))
                        ]);
                }
            }())
        ]));
    });
    var $author$project$Components$PricingVersions$Form$viewGroupMembershipPricingFields = F2(function(plan, form) {
        var discountsEnabled = form.xm;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Components$PricingVersions$Form$viewFamilyDiscountsToggle(form),
            function() {
                if (discountsEnabled) {
                    var groupDiscountRules = form.Qd;
                    var groupDiscountRulesCalculatedBy = A2($elm$core$Maybe$map, function($) {
                        return $.KD;
                    }, $elm$core$List$head(groupDiscountRules));
                    var appliesGroupDiscountInTiers = form.Jy;
                    var allowNewGroupRule = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(lastFromSize) {
                        return _Utils_cmp(lastFromSize, $author$project$Components$PricingVersions$Form$maxGroupFromSize) < 0;
                    }, A2($elm$core$Maybe$map, function($) {
                        return $.P0;
                    }, $elm_community$list_extra$List$Extra$last(groupDiscountRules))));
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$padding(8)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Switch to family rates'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated($author$project$Components$PricingVersions$Form$GroupPricingType('family')))
                            ]), _List_fromArray([
                                $author$project$Ui$Icon$transfer(_List_Nil),
                                $elm$html$Html$text(' Switch to Family Rates')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$offset(1)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                                        $author$project$Ui$Form$Radio$value(appliesGroupDiscountInTiers),
                                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$PricingVersions$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers(true))))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Apply Discounts in Tiers.'),
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$muted,
                                            $author$project$Ui$Typography$bold
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Per member discount will apply to members depending on which range they are in')
                                        ]))
                                    ]))
                                ])),
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                                        $author$project$Ui$Form$Radio$value(!appliesGroupDiscountInTiers),
                                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$PricingVersions$Form$FormUpdated, $elm$core$Basics$always($author$project$Components$PricingVersions$Form$AppliesGroupDiscountInTiers(false))))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Apply Same Discount to Entire Group'),
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$muted,
                                            $author$project$Ui$Typography$bold
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Per member discount from the last added member will apply to all members in group')
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$offsetLabel,
                            $author$project$Ui$Form$Group$labelSpanSm(5),
                            $author$project$Ui$Form$Group$inputSpanSm(6),
                            $author$project$Ui$Form$Group$label('Default Discount Type'),
                            $author$project$Ui$Form$Group$labelClass('')
                        ]), _List_fromArray([
                            $author$project$Ui$Button$group(_List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Select percentage base discount calculation'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$active(_Utils_eq(groupDiscountRulesCalculatedBy, $elm$core$Maybe$Just('percent_off'))),
                                    $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated($author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy(true)))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('%')
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Select fixed discount rate'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$active(!_Utils_eq(groupDiscountRulesCalculatedBy, $elm$core$Maybe$Just('percent_off'))),
                                    $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated($author$project$Components$PricingVersions$Form$ToggleGroupDiscountRulesCalculatedBy(false)))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('$')
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(11),
                                $author$project$Ui$Grid$offsetSm(1)
                            ]), _List_fromArray([
                                A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Table$header, _List_fromArray([
                                        $author$project$Ui$Table$cellSpan(3)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('From')
                                    ])),
                                    A2($author$project$Ui$Table$header, _List_fromArray([
                                        $author$project$Ui$Table$cellSpan(3)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('To')
                                    ])),
                                    A2($author$project$Ui$Table$header, _List_fromArray([
                                        $author$project$Ui$Table$cellSpan(2)
                                    ]), _List_Nil),
                                    A2($author$project$Ui$Table$header, _List_fromArray([
                                        $author$project$Ui$Table$cellSpan(4)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Discount per Member')
                                    ]))
                                ]), A2($elm$core$List$indexedMap, A2($author$project$Components$PricingVersions$Form$viewGroupDiscountRule, plan, form), groupDiscountRules), _List_fromArray([
                                    A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                                        A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                                        A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                                        A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                                            allowNewGroupRule ? A3($author$project$Ui$Button$view, {
                                                abP: 'Add group range discount rule'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$FormUpdated($author$project$Components$PricingVersions$Form$GroupDiscountRuleAdd)),
                                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Add Range')
                                            ])) : $author$project$Utils$Html$empty
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$PricingVersions$Form$viewForm = F3(function(model, _v0, form) {
        var nameErrors = model.gU ? $author$project$Components$PricingVersions$Form$validatePricingVersionName(form.zr) : _List_Nil;
        var maybePlan = function() {
            var _v9 = model.k;
            if (_v9.$ === 3) {
                var plan = _v9.a;
                return $elm$core$Maybe$Just(plan);
            } else return $elm$core$Maybe$Nothing;
        }();
        var sharedFields = A2($author$project$Components$PricingVersions$Form$initSharedFields, maybePlan, form);
        var pricingFields = _List_fromArray([
            sharedFields.Qh === 'fixed_pricing' ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                A2($elm$html$Html$map, $author$project$Components$PricingVersions$Form$GroupTierPricingFieldsUpdated, A3($author$project$Components$Plan$Form$GroupTierPricingFields$view, sharedFields, function() {
                    var _v3 = model.k;
                    if (_v3.$ === 3) {
                        var plan = _v3.a;
                        return $elm$core$Maybe$Just(plan);
                    } else return $elm$core$Maybe$Nothing;
                }(), form.i))
            ])) : A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                A2($elm$html$Html$map, $author$project$Components$PricingVersions$Form$IndividualMembershipPricingFieldsUpdated, A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$view, sharedFields, model.W1, function() {
                    var _v4 = model.k;
                    if (_v4.$ === 3) {
                        var plan = _v4.a;
                        return $elm$core$Maybe$Just(plan);
                    } else return $elm$core$Maybe$Nothing;
                }(), form.c$))
            ])),
            sharedFields.Qh === 'family' ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                function() {
                    var _v5 = model.k;
                    if (_v5.$ === 3) {
                        var plan = _v5.a;
                        return A3($author$project$Components$PricingVersions$Form$viewFamilyMembershipPricing, sharedFields, plan, form);
                    } else return $author$project$Utils$Html$empty;
                }()
            ])) : $author$project$Utils$Html$empty,
            sharedFields.Qh === 'group' ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                function() {
                    var _v6 = model.k;
                    if (_v6.$ === 3) {
                        var plan = _v6.a;
                        return A2($author$project$Components$PricingVersions$Form$viewGroupMembershipPricingFields, plan, form);
                    } else return $author$project$Utils$Html$empty;
                }()
            ])) : $author$project$Utils$Html$empty,
            function() {
                var _v7 = _Utils_Tuple2(form.dj, model.k);
                if (!_v7.a.$ && _v7.b.$ === 3) {
                    var specialRatesForm = _v7.a.a;
                    var _v8 = _v7.b;
                    var plan = _v8.a;
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A2($elm$html$Html$map, $author$project$Components$PricingVersions$Form$SpecialRatesFieldsUpdated, A2($author$project$Components$Plan$Form$SpecialRatesFields$view, plan, specialRatesForm))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]);
        var effectiveDateErrors = model.gU ? A2($author$project$Components$PricingVersions$Form$validateEffectiveDate, true, form.Ow) : _List_Nil;
        var basicPlanFields = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$PricingVersions$Form$BasicPlanFormUpdated), A2($author$project$Components$PricingVersions$Form$viewBasicPlanFieldsForPricingVersion, form.aB, function() {
            var _v2 = model.k;
            if (_v2.$ === 3) {
                var plan = _v2.a;
                return $elm$core$Maybe$Just(plan);
            } else return $elm$core$Maybe$Nothing;
        }()));
        var basicFields = _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text('Name of Pricing Version '),
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-danger')
                    ]), _List_fromArray([
                        $elm$html$Html$text('*')
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('This will not be displayed to patients.'))
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(form.zr),
                    $author$project$Ui$Form$Input$onInput($author$project$Components$PricingVersions$Form$NameChanged),
                    $author$project$Ui$Form$Input$placeholder(function() {
                        var _v1 = model.cP;
                        if (!_v1.$) {
                            var currentDate = _v1.a;
                            return $elm$core$String$fromInt($justinmimbs$date$Date$year(currentDate) + 1) + ' Pricing';
                        } else return '2025 Pricing';
                    }()),
                    $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(nameErrors)),
                    $author$project$Ui$Form$Input$errors(nameErrors)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(5),
                $author$project$Ui$Form$Group$inputSpanSm(6),
                $author$project$Ui$Form$Group$labelHtml(_List_fromArray([
                    $elm$html$Html$text('Effective Date '),
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-danger')
                    ]), _List_fromArray([
                        $elm$html$Html$text('*')
                    ]))
                ])),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('The day your new pricing will start to go into effect.'))
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$PricingVersions$Form$EffectiveDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(form.Ow),
                    $author$project$Components$DateInput$invalid(!$elm$core$List$isEmpty(effectiveDateErrors)),
                    $author$project$Components$DateInput$errors(effectiveDateErrors)
                ]), model.iC))
            ]))
        ]);
        return $elm$core$List$concat(_List_fromArray([
            basicFields,
            basicPlanFields,
            pricingFields
        ]));
    });
    var $author$project$Components$PricingVersions$Form$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$autocomplete(false),
                $author$project$Ui$Form$onSubmit($author$project$Components$PricingVersions$Form$Save)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            $elm$html$Html$text('Schedule Pricing Change')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Close'
                            }, _List_fromArray([
                                $author$project$Ui$Button$close,
                                $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$NavigateBack)
                            ]), _List_fromArray([
                                $elm$html$Html$text("\xd7")
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, function() {
                        var _v1 = _Utils_Tuple3(model.F6, model.k, model.PU);
                        _v1$2: while(true){
                            _v1$4: while(true)switch(_v1.b.$){
                                case 3:
                                    switch(_v1.a.$){
                                        case 3:
                                            if (!_v1.c.$) {
                                                var _v2 = _v1.a;
                                                var pricingVersion = _v2.a;
                                                var _v3 = _v1.b;
                                                var form = _v1.c.a;
                                                return A3($author$project$Components$PricingVersions$Form$viewForm, model, pricingVersion, form);
                                            } else break _v1$4;
                                        case 0:
                                            if (!_v1.c.$) {
                                                var _v4 = _v1.a;
                                                var _v5 = _v1.b;
                                                var form = _v1.c.a;
                                                return A3($author$project$Components$PricingVersions$Form$viewForm, model, {
                                                    aef: '',
                                                    zr: form.zr
                                                }, form);
                                            } else break _v1$4;
                                        case 2:
                                            break _v1$2;
                                        default:
                                            break _v1$4;
                                    }
                                case 2:
                                    if (_v1.a.$ === 2) break _v1$2;
                                    else return _List_fromArray([
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Error loading base plan')
                                        ]))
                                    ]);
                                default:
                                    if (_v1.a.$ === 2) break _v1$2;
                                    else break _v1$4;
                            }
                            return _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                                ]), _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_Nil)
                                ]))
                            ]);
                        }
                        return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Error loading pricing version')
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Panel$footer, _List_fromArray([
                        $author$project$Ui$Element$flexCol
                    ]), function() {
                        var _v6 = _Utils_Tuple3(model.F6, model.k, model.PU);
                        _v6$2: while(true){
                            if (_v6.b.$ === 3 && !_v6.c.$) switch(_v6.a.$){
                                case 3:
                                    var _v7 = _v6.a;
                                    var _v8 = _v6.b;
                                    var plan = _v8.a;
                                    var form = _v6.c.a;
                                    return _List_fromArray([
                                        model.gU && A3($author$project$Components$PricingVersions$Form$hasAnyValidationErrors, $elm$core$Maybe$Just(plan), model.W1, form) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                                $author$project$Ui$Grid$offsetSm(3),
                                                $author$project$Ui$Grid$spanSm(6)
                                            ]), _List_fromArray([
                                                A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text('Please review the errors above')
                                                ]))
                                            ]))
                                        ])) : $author$project$Utils$Html$empty,
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$gap2,
                                            $author$project$Ui$Element$justifyCenter,
                                            $author$project$Ui$Element$itemsCenter
                                        ]), _List_fromArray([
                                            A3($author$project$Ui$Link$route, $author$project$Components$PricingVersions$Form$planRoute(model.J8), _List_Nil, _List_fromArray([
                                                $elm$html$Html$text('Back')
                                            ])),
                                            A3($author$project$Ui$Button$view, {
                                                abP: 'Delete pricing version'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$danger,
                                                $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Delete),
                                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Delete')
                                            ])),
                                            A3($author$project$Ui$Button$view, {
                                                abP: 'Save pricing version'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$primary,
                                                $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Save)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Save Changes')
                                            ]))
                                        ]))
                                    ]);
                                case 0:
                                    var _v9 = _v6.a;
                                    var _v10 = _v6.b;
                                    var plan = _v10.a;
                                    var form = _v6.c.a;
                                    return _List_fromArray([
                                        model.gU && A3($author$project$Components$PricingVersions$Form$hasAnyValidationErrors, $elm$core$Maybe$Just(plan), model.W1, form) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                                $author$project$Ui$Grid$offsetSm(3),
                                                $author$project$Ui$Grid$spanSm(6)
                                            ]), _List_fromArray([
                                                A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text('Please review the errors above')
                                                ]))
                                            ]))
                                        ])) : $author$project$Utils$Html$empty,
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$gap2,
                                            $author$project$Ui$Element$justifyCenter,
                                            $author$project$Ui$Element$itemsCenter
                                        ]), _List_fromArray([
                                            A3($author$project$Ui$Link$route, $author$project$Components$PricingVersions$Form$planRoute(model.J8), _List_Nil, _List_fromArray([
                                                $elm$html$Html$text('Back')
                                            ])),
                                            A3($author$project$Ui$Button$view, {
                                                abP: 'Save Change'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$primary,
                                                $author$project$Ui$Button$onClick($author$project$Components$PricingVersions$Form$Save)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Save Change')
                                            ]))
                                        ]))
                                    ]);
                                default:
                                    break _v6$2;
                            }
                            else break _v6$2;
                        }
                        return _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Components$PricingVersions$Form$planRoute(model.J8), _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Back')
                            ]))
                        ]);
                    }())
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$PricingVersions$Form$view(model.PU)),
            $2: 'New Pricing Version'
        };
    };
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$init,
        aeR: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$load,
        ag3: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$save,
        ahE: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$subscriptions,
        aaO: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$update,
        aid: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$view
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$FormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        var settings = {
            J8: params.aef,
            Gc: $author$project$Spa$Generated$Route$Admin__Plans__Top,
            W1: practice,
            Z$: session
        };
        var _v1 = A4($author$project$Components$PricingVersions$Form$init, shared.Ej, settings, params.aef, $elm$core$Maybe$Just(params.ago));
        var form = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form,
            W1: practice,
            Z$: session,
            Cu: shared
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            Cu: shared
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$PricingVersions$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$PricingVersions$Form$update, model.Ej, subMsg, model.PU);
        var newForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$PricingVersions$Form$view(model.PU)),
            $2: 'Edit Pricing Version'
        };
    };
    var $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$init,
        aeR: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$load,
        ag3: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$save,
        ahE: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$subscriptions,
        aaO: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$update,
        aid: $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$view
    });
    var $author$project$Pages$Admin$Plans$New$NewMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$Plans$New$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var _v3 = A5($author$project$Components$Admin$Plans$New$init, apiClient, session, 2, $author$project$Spa$Generated$Route$Admin__Plans__Top, $author$project$Spa$Generated$Route$Admin__Plans__Id_String);
        var _new = _v3.a;
        var newCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: _new
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd));
    });
    var $author$project$Pages$Admin$Plans$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Plans$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Plans$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Plans$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$Plans$New$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var newCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, newCmd), outMsgs);
    });
    var $author$project$Pages$Admin$Plans$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$Plans$New$view(model.PU))
            ]),
            $2: 'Admin | Membership Plans'
        };
    };
    var $author$project$Pages$Admin$Plans$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Plans$New$init,
        aeR: $author$project$Pages$Admin$Plans$New$load,
        ag3: $author$project$Pages$Admin$Plans$New$save,
        ahE: $author$project$Pages$Admin$Plans$New$subscriptions,
        aaO: $author$project$Pages$Admin$Plans$New$update,
        aid: $author$project$Pages$Admin$Plans$New$view
    });
    var $author$project$Pages$Admin$Plans$Top$ListMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$Plans$Top$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var query = _v1.Bz;
        var planTypes = _List_fromArray([
            2,
            3
        ]);
        var _v2 = $author$project$Components$Admin$Plans$List$init(apiClient)(session)($author$project$Api$Platform$User$Shared$isAdmin($author$project$Api$Platform$Session$One$user(session)))(planTypes)($author$project$Spa$Generated$Route$Admin__Plans__Top)($author$project$Spa$Generated$Route$Admin__Plans__New)($author$project$Spa$Generated$Route$Admin__Plans__Id_String)(_List_fromArray([
            $elm$html$Html$text('You can change your default plan by editing your default signup page '),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__SignupPages__Top, _List_fromArray([
                $author$project$Ui$Link$sm
            ]), _List_fromArray([
                $elm$html$Html$text('here')
            ])),
            $elm$html$Html$text('.')
        ]))(query)({
            aK: false
        })($elm$core$Maybe$Just(practice));
        var list = _v2.a;
        var listCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            rk: list
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
    });
    var $author$project$Pages$Admin$Plans$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Plans$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Plans$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Plans$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.Ej, subMsg, model.rk);
        var list = _v1.a;
        var listCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: list
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd), outMsgs);
    });
    var $author$project$Pages$Admin$Plans$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$Plans$List$view(model.rk))
            ]),
            $2: 'Admin | Membership Plans'
        };
    };
    var $author$project$Pages$Admin$Plans$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Plans$Top$init,
        aeR: $author$project$Pages$Admin$Plans$Top$load,
        ag3: $author$project$Pages$Admin$Plans$Top$save,
        ahE: $author$project$Pages$Admin$Plans$Top$subscriptions,
        aaO: $author$project$Pages$Admin$Plans$Top$update,
        aid: $author$project$Pages$Admin$Plans$Top$view
    });
    var $author$project$Pages$Admin$Practice$AccountFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$Closed = {
        $: 0
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$init = $author$project$Components$Admin$Practice$DeactivateModal$Closed;
    var $author$project$Components$Practice$AccountForm$EmrDropdownMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$One$defaultMembershipStartDate = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Nu;
    });
    var $author$project$Components$Practice$AccountForm$AddressInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$ein = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Oy;
    });
    var $author$project$Api$Provider$Practice$One$emr = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.adl;
    });
    var $author$project$Api$Provider$Practice$One$emrOther = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.adn;
    });
    var $author$project$Components$Practice$AccountForm$initPhoneInput = function(phones) {
        return A3($author$project$Components$PhoneInput$init, 'practice-phone-input', A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones), function(d) {
            return _Utils_update(d, {
                Iz: true,
                ac_: $author$project$Api$Common$Phone$Shared$Office,
                y_: 1,
                agM: true
            });
        });
    };
    var $author$project$Api$Provider$Practice$Shared$logoUrl = function(_v0) {
        var record = _v0;
        return record.Tu;
    };
    var $author$project$Api$Provider$Practice$One$logoUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$logoUrl(shared);
    };
    var $author$project$Api$WhitelabelSetting$patientFacingFaviconPngUrl = function(_v0) {
        var record = _v0;
        return record.GP;
    };
    var $author$project$Api$Provider$Practice$One$sessionTimeoutInMinutes = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ahj;
    });
    var $author$project$Components$AddressInput$withHiddenCountry = F2(function(hiddenCountry, _v0) {
        var model = _v0;
        return hiddenCountry ? _Utils_update(model, {
            aQ: false
        }) : _Utils_update(model, {
            aQ: true
        });
    });
    var $author$project$Components$Practice$AccountForm$formFieldsFromPractice = F3(function(addressIsRequired, practice, dataWhitelabelSettings) {
        var faviconUrl = function() {
            if (dataWhitelabelSettings.$ === 3) {
                var whitelabelSettings = dataWhitelabelSettings.a;
                return $author$project$Api$WhitelabelSetting$patientFacingFaviconPngUrl(whitelabelSettings);
            } else return $elm$core$Maybe$Nothing;
        }();
        var _v0 = A2($author$project$Components$AddressInput$initFromApi, 'practice', $author$project$Api$Provider$Practice$One$address(practice));
        var addressInput = _v0.a;
        var addressInputCmd = _v0.b;
        return _Utils_Tuple2({
            II: A2($author$project$Components$AddressInput$withHiddenCountry, true, A2($author$project$Components$AddressInput$withRequired, addressIsRequired, addressInput)),
            w3: faviconUrl,
            MM: $author$project$Api$Provider$Practice$One$logoUrl(practice),
            Oy: $author$project$Api$Provider$Practice$One$ein(practice),
            OH: $author$project$Api$Provider$Practice$One$email(practice),
            adl: $author$project$Api$Provider$Practice$One$emr(practice),
            adn: $author$project$Api$Provider$Practice$One$emrOther(practice),
            Fu: 0,
            xI: $elm$core$Maybe$Nothing,
            Ge: 0,
            Tu: $elm$core$Maybe$Nothing,
            zr: $author$project$Api$Provider$Practice$One$name(practice),
            WE: $author$project$Components$Practice$AccountForm$initPhoneInput($author$project$Api$Provider$Practice$One$phones(practice)),
            ahj: $author$project$Api$Provider$Practice$One$sessionTimeoutInMinutes(practice),
            aaT: $author$project$Api$Provider$Practice$One$url(practice)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$AddressInputMsg, addressInputCmd));
    });
    var $author$project$Components$Practice$AccountForm$init = F4(function(practice, dataWhitelabelSetting, sharedModel, _v0) {
        var isOnboarding = _v0.aK;
        var onboardingClinical = _v0.Vt;
        var hasClinical = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice) || onboardingClinical;
        var defaultMembershipStartDate = $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice);
        var currentDate = sharedModel.cP;
        var addressIsRequired = hasClinical || A2($justinmimbs$date$Date$compare, defaultMembershipStartDate, currentDate) !== 2;
        var _v1 = A3($author$project$Components$Practice$AccountForm$formFieldsFromPractice, addressIsRequired, practice, dataWhitelabelSetting);
        var formFields = _v1.a;
        var formFieldsCmd = _v1.b;
        return _Utils_Tuple2({
            D9: addressIsRequired,
            Ej: sharedModel.Ej,
            cP: currentDate,
            Nf: $author$project$Components$Admin$Practice$DeactivateModal$init,
            ib: false,
            l6: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'emr',
                ahX: $author$project$Components$Practice$AccountForm$EmrDropdownMsg
            })),
            PU: $author$project$Utils$Form$init(formFields),
            mq: hasClinical,
            F3: $author$project$Shared$isHintAdmin(sharedModel),
            aK: isOnboarding,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked
        }, formFieldsCmd);
    });
    var $author$project$Pages$Admin$Practice$init = F4(function(session, practice, shared, _v0) {
        var _v1 = A4($author$project$Components$Practice$AccountForm$init, practice, shared.abq, shared, {
            aK: false,
            Vt: false
        });
        var accountFormModel = _v1.a;
        var accountFormCmd = _v1.b;
        return _Utils_Tuple2({
            cv: accountFormModel,
            Ej: shared.Ej,
            Nf: $author$project$Components$Admin$Practice$DeactivateModal$init,
            ib: false,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            Cu: shared
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, accountFormCmd));
    });
    var $author$project$Pages$Admin$Practice$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Practice$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Practice$DeactivateModalMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$Practice$HiConfirmClosed = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$subscriptions = function(model) {
        if (model.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Practice$DeactivateModal$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Practice$AccountForm$PhoneInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$subscriptions = function(_v0) {
        var model = _v0;
        var _v1 = $author$project$Utils$Form$fields(model.PU);
        var phone = _v1.WE;
        var address = _v1.II;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Practice$AccountForm$AddressInputMsg, $author$project$Components$AddressInput$subscriptions(address)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Practice$AccountForm$PhoneInputMsg, $author$project$Components$PhoneInput$subscriptions(phone)),
            $author$project$Ui$Dropdown$subscriptions(model.l6)
        ]));
    };
    var $author$project$Pages$Admin$Practice$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Practice$AccountFormMsg, $author$project$Components$Practice$AccountForm$subscriptions(model.cv)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Practice$DeactivateModalMsg, $author$project$Components$Admin$Practice$DeactivateModal$subscriptions(model.Nf)),
            model.ib ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Admin$Practice$HiConfirmClosed) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Pages$Admin$Practice$Deleted = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$OutMsg$WhitelabelSettingsUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$delete = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath));
    });
    var $author$project$Ports$Session$logoutPort = _Platform_outgoingPort('logoutPort', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('redirect', $elm$json$Json$Encode$bool($.agy))
        ]));
    });
    var $author$project$Ports$Session$logout = function(options) {
        return $author$project$Ports$Session$logoutPort(options);
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Practice$DeactivateModal$Open = F6(function(a, b, c, d, e, f) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c,
            d: d,
            e: e,
            f: f
        };
    });
    var $author$project$Api$Provider$Practice$Shared$cancellationReasonOther = function(_v0) {
        var record = _v0;
        return record.aca;
    };
    var $author$project$Api$Provider$Practice$One$cancellationReasonOther = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$cancellationReasonOther(shared);
    };
    var $author$project$Api$Provider$Practice$Shared$deactivateOn = function(_v0) {
        var record = _v0;
        return record.Ng;
    };
    var $author$project$Api$Provider$Practice$One$deactivateOn = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$deactivateOn(shared);
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons = _List_fromArray([
        'Practice closed',
        'Practice closed [Retired]',
        'Lost to competitor: Akute',
        'Lost to competitor: Athena',
        'Lost to competitor: AtlasMD',
        'Lost to competitor: Cerbo',
        'Lost to competitor: Charm',
        'Lost to competitor: eCW',
        'Lost to competitor: Elation',
        'Lost to competitor: Healthie',
        'Lost to competitor: Jane',
        'Lost to competitor: Optimantra',
        'Lost to competitor: SigmaMD',
        'Lost to competitor: Tebra',
        'Lost to competitor: Vibrant',
        'Lost to competitor: Other',
        'Never onboarded',
        'Merged Hint accounts',
        'Abandoned membership model',
        'Deactivated freemium affiliate',
        'Pricing rollout 2024',
        'Dormant Account',
        'Unknown'
    ]);
    var $author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason = A2($elm$core$Maybe$withDefault, '', $elm$core$List$head($author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons));
    var $author$project$Components$Admin$Practice$DeactivateModal$open = function(practice) {
        var cancellationReason = A2($elm$core$Maybe$withDefault, $author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason, $author$project$Api$Provider$Practice$One$cancellationReasonOther(practice));
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2(A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practice, false, $author$project$Api$Data$NotAsked, $author$project$Api$Provider$Practice$One$deactivateOn(practice), dateInput, cancellationReason), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg(dateInput), dateInputCmd));
    };
    var $author$project$Pages$Admin$Practice$WhitelabelSettingRetrieved = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Api$WhitelabelSetting$WhitelabelSetting = $elm$core$Basics$identity;
    var $author$project$Api$WhitelabelSetting$Record = F8(function(practiceFacingLogoUrl, practiceFacingLogoAltText, practiceFacingFaviconIcoUrl, practiceFacingFaviconPngUrl, practiceFacingFaviconAppleUrl, patientFacingFaviconPngUrl, brandName, branded) {
        return {
            Ey: brandName,
            Ez: branded,
            GP: patientFacingFaviconPngUrl,
            GY: practiceFacingFaviconAppleUrl,
            GZ: practiceFacingFaviconIcoUrl,
            G_: practiceFacingFaviconPngUrl,
            G$: practiceFacingLogoAltText,
            G0: practiceFacingLogoUrl
        };
    });
    var $author$project$Api$WhitelabelSetting$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'branded', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'brand_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient_facing_favicon_png_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_facing_favicon_apple_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_facing_favicon_png_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_facing_favicon_ico_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_facing_logo_alt_text', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_facing_logo_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$WhitelabelSetting$Record)))))))));
    var $author$project$Api$WhitelabelSetting$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$WhitelabelSetting$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$WhitelabelSetting$employerWhitelabelSettingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'whitelabel_settings'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$WhitelabelSetting$employerRetrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$WhitelabelSetting$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$WhitelabelSetting$employerWhitelabelSettingsPath));
    });
    var $author$project$Api$WhitelabelSetting$providerWhitelabelSettingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'whitelabel_settings'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$WhitelabelSetting$providerRetrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$WhitelabelSetting$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$WhitelabelSetting$providerWhitelabelSettingsPath));
    });
    var $author$project$Api$WhitelabelSetting$retrieve = F3(function(apiClient, session, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$WhitelabelSetting$employerRetrieve, apiClient, toMsg) : A2($author$project$Api$WhitelabelSetting$providerRetrieve, apiClient, toMsg);
    });
    var $author$project$Pages$Admin$Practice$retrieveWhitelabelSetting = F3(function(practice, apiClient, session) {
        return A3($author$project$Api$WhitelabelSetting$retrieve, apiClient, session, $author$project$Pages$Admin$Practice$WhitelabelSettingRetrieved(practice));
    });
    var $author$project$Components$Admin$Practice$DeactivateModal$Deactivated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$None = {
        $: 0
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$PracticeDeactivated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$deactivate = F5(function(apiClient, removePracticeUsers, maybeDate, cancellationReason, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('remove_practice_users', $elm$json$Json$Encode$bool(removePracticeUsers)),
            _Utils_Tuple2('deactivation_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, maybeDate)),
            _Utils_Tuple2('cancellation_reason_other', $elm$json$Json$Encode$string(cancellationReason))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'deactivate'
        ]), $author$project$Api$Provider$Practice$practicePath))));
    });
    var $author$project$Components$Admin$Practice$DeactivateModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                    zi: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
                    at: _List_Nil
                };
            case 2:
                var bool = msg.a;
                if (model.$ === 1) {
                    var practitioner = model.a;
                    var maybeDate = model.d;
                    var dateInput = model.e;
                    var cancellationReason = model.f;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                        zi: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, bool, $author$project$Api$Data$NotAsked, maybeDate, dateInput, cancellationReason),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                    zi: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
                    at: _List_Nil
                };
            case 4:
                var dateInputModel = msg.a;
                var dateInputMsg = msg.b;
                var _v2 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
                var newDateInput = _v2.a;
                var subCmd = _v2.b;
                var event = _v2.c;
                if (model.$ === 1) {
                    var practitioner = model.a;
                    var removePracticeUsers = model.b;
                    var data = model.c;
                    var currentMaybeDate = model.d;
                    var cancellationReason = model.f;
                    if (event.$ === 1) {
                        var maybeDate = event.a;
                        return {
                            EQ: subCmd,
                            adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                            zi: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, data, maybeDate, newDateInput, cancellationReason),
                            at: _List_Nil
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                        zi: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, data, currentMaybeDate, newDateInput, cancellationReason),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                    zi: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
                    at: _List_Nil
                };
            case 5:
                var inputReason = msg.a;
                if (model.$ === 1) {
                    var practitioner = model.a;
                    var removePracticeUsers = model.b;
                    var maybeDate = model.d;
                    var dateInput = model.e;
                    var selectedCancellationReason = A2($elm_community$list_extra$List$Extra$getAt, A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(inputReason)), $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons);
                    var cancellationReason = A2($elm$core$Maybe$withDefault, $author$project$Components$Admin$Practice$DeactivateModal$defaultCancellationReason, selectedCancellationReason);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                        zi: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, $author$project$Api$Data$NotAsked, maybeDate, dateInput, cancellationReason),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                    zi: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
                    at: _List_Nil
                };
            case 1:
                if (model.$ === 1) {
                    var practitioner = model.a;
                    var removePracticeUsers = model.b;
                    var maybeDate = model.d;
                    var dateInput = model.e;
                    var cancellationReason = model.f;
                    return {
                        EQ: A5($author$project$Api$Provider$Practice$deactivate, apiClient, removePracticeUsers, maybeDate, cancellationReason, $author$project$Components$Admin$Practice$DeactivateModal$Deactivated),
                        adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                        zi: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, $author$project$Api$Data$Loading, maybeDate, dateInput, cancellationReason),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                    zi: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (model.$ === 1) {
                    var practitioner = model.a;
                    var removePracticeUsers = model.b;
                    var maybeDate = model.d;
                    var dateInput = model.e;
                    var cancellationReason = model.f;
                    switch(response.$){
                        case 3:
                            var practice = response.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: $author$project$Components$Admin$Practice$DeactivateModal$PracticeDeactivated(practice),
                                zi: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, 'Practice has been deactivated/scheduled for deactivation'),
                                    $author$project$OutMsg$PracticeUpdated(response)
                                ])
                            };
                        case 2:
                            var error = response.a;
                            var errorString = $author$project$Api$Data$errorToString(error);
                            var errorMessage = $elm$core$String$isEmpty(errorString) ? 'This practice cannot be deactivated. Please contact us for more information.' : errorString;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                                zi: A6($author$project$Components$Admin$Practice$DeactivateModal$Open, practitioner, removePracticeUsers, response, maybeDate, dateInput, cancellationReason),
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, errorMessage)
                                ])
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                                zi: model,
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$Practice$DeactivateModal$None,
                    zi: $author$project$Components$Admin$Practice$DeactivateModal$Closed,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Practice$AccountForm$Address = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$Emr = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$EmrOther = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$Favicon = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Practice$AccountForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$Logo = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Practice$AccountForm$Phone = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    aaT: $author$project$Utils$String$toMaybe(string)
                });
            case 2:
                var _int = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    MM: $elm$core$Maybe$Just(string),
                    Ge: _int,
                    Tu: $elm$core$Maybe$Just(string)
                });
            case 3:
                var _int = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    w3: $elm$core$Maybe$Just(string),
                    Fu: _int,
                    xI: $elm$core$Maybe$Just(string)
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    OH: $author$project$Utils$String$toMaybe(string)
                });
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    Oy: $author$project$Utils$String$toMaybe(string)
                });
            case 6:
                var string = field.a;
                return _Utils_update(fields, {
                    ahj: $elm$core$String$toInt(string)
                });
            case 7:
                var phone = field.a;
                return _Utils_update(fields, {
                    WE: phone
                });
            case 8:
                var address = field.a;
                return _Utils_update(fields, {
                    II: address
                });
            case 9:
                var maybeEmr = field.a;
                return _Utils_update(fields, {
                    adl: maybeEmr
                });
            default:
                var maybeString = field.a;
                return _Utils_update(fields, {
                    adn: maybeString
                });
        }
    });
    var $author$project$Components$Practice$AccountForm$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v2 = $author$project$Utils$Form$fields(model.PU);
                var address = _v2.II;
                var _v3 = A2($author$project$Components$AddressInput$update, subMsg, address);
                var addressInputModel = _v3.a;
                var addressInputCmd = _v3.b;
                var outMsgs = _v3.c;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, $author$project$Components$Practice$AccountForm$Address(addressInputModel), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$AddressInputMsg, addressInputCmd), outMsgs);
            case 1:
                var logos = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v4) {
                    var task = _v4.a;
                    var size = _v4.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Logo(size)), task);
                }, A2($elm$core$Maybe$map, function(logo) {
                    return _Utils_Tuple2($elm$file$File$toUrl(logo), $elm$file$File$size(logo));
                }, $elm$core$List$head(logos))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 2:
                var favicon = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v5) {
                    var task = _v5.a;
                    var size = _v5.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Favicon(size)), task);
                }, A2($elm$core$Maybe$map, function(logo) {
                    return _Utils_Tuple2($elm$file$File$toUrl(logo), $elm$file$File$size(logo));
                }, $elm$core$List$head(favicon))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v6 = $author$project$Utils$Form$fields(model.PU);
                var phone = _v6.WE;
                var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
                var phoneInput = _v7.a;
                var phoneCmd = _v7.b;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, $author$project$Components$Practice$AccountForm$Phone(phoneInput), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Practice$AccountForm$PhoneInputMsg, phoneCmd), _List_Nil);
            case 5:
                var subMsg = msg.a;
                var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, model.l6);
                var newDropdown = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    l6: newDropdown
                }), cmd, _List_Nil);
            default:
                var emrOption = msg.a;
                var newForm = function() {
                    if (!emrOption.$) {
                        var emr = emrOption.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, $author$project$Components$Practice$AccountForm$EmrOther($elm$core$Maybe$Nothing), A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, $author$project$Components$Practice$AccountForm$Emr($elm$core$Maybe$Just(emr)), model.PU));
                    } else return A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, $author$project$Components$Practice$AccountForm$Emr($elm$core$Maybe$Nothing), model.PU);
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Practice$Updated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$practiceFromFields = function(fields) {
        var phones = A2($elm$core$List$map, $author$project$Utils$Phone$toRecord, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Components$PhoneInput$getPhones(fields.WE)));
        var address = $author$project$Components$AddressInput$getAddress(fields.II);
        return {
            II: address,
            Oy: fields.Oy,
            OH: fields.OH,
            adl: fields.adl,
            adn: fields.adn,
            adJ: fields.xI,
            Tt: fields.Tu,
            zr: fields.zr,
            WG: phones,
            ahj: fields.ahj,
            aaT: fields.aaT
        };
    };
    var $author$project$Api$Provider$Practice$Emr$toValue = function(_v0) {
        var id = _v0.aef;
        return id;
    };
    var $author$project$Api$Provider$Practice$update = F3(function(apiClient, fields, toMsg) {
        var phones_ = A2($elm$json$Json$Encode$list, function(phone) {
            return $author$project$Api$Common$Phone$Shared$encode(phone);
        }, fields.WG);
        var logo_ = function() {
            var _v1 = fields.Tt;
            if (!_v1.$) {
                var base64 = _v1.a;
                return _List_fromArray([
                    _Utils_Tuple2('logo', $elm$json$Json$Encode$string(base64))
                ]);
            } else return _List_Nil;
        }();
        var favicon_ = function() {
            var _v0 = fields.adJ;
            if (!_v0.$) {
                var base64 = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('favicon', $elm$json$Json$Encode$string(base64))
                ]);
            } else return _List_Nil;
        }();
        var address_ = $author$project$Api$Common$Address$Shared$encode(fields.II);
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aaT)), A2($elm$core$List$cons, _Utils_Tuple2('email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OH)), A2($elm$core$List$cons, _Utils_Tuple2('ein', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oy)), A2($elm$core$List$cons, _Utils_Tuple2('session_timeout_in_minutes', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.ahj)), A2($elm$core$List$cons, _Utils_Tuple2('address', address_), A2($elm$core$List$cons, _Utils_Tuple2('phones', phones_), A2($elm$core$List$cons, _Utils_Tuple2('emr', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$Emr$toValue, $elm$json$Json$Encode$string), fields.adl)), A2($elm$core$List$cons, _Utils_Tuple2('emr_other', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adn)), _Utils_ap(logo_, favicon_))))))))))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Admin$Practice$updatePractice = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Practice$update, apiClient, $author$project$Components$Practice$AccountForm$practiceFromFields(fields), $author$project$Pages$Admin$Practice$Updated);
    });
    var $author$project$Components$Practice$AccountForm$LogoValidation = 2;
    var $author$project$Components$Practice$AccountForm$NameValidation = 0;
    var $author$project$Components$Practice$AccountForm$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Practice$AccountForm$AddressValidation = 6;
    var $author$project$Components$Practice$AccountForm$validateAddress = F2(function(_v0, fields) {
        return !$author$project$Components$AddressInput$isValid(fields.II) ? _List_fromArray([
            _Utils_Tuple2(6, 'Please enter a valid address.')
        ]) : _List_Nil;
    });
    var $author$project$Components$Practice$AccountForm$EinValidation = 5;
    var $author$project$Ui$Form$Ein$einFormat = '^(?!00|[01][789]|2[89]|[4678]9|7[08]|9[67])\\d\\d\\d{7}$';
    var $author$project$Components$Practice$AccountForm$validateEin = function(fields) {
        var _v0 = fields.Oy;
        if (_v0.$ === 1) return _List_Nil;
        else {
            var ein = _v0.a;
            return A2($author$project$Utils$Regex$matches, $author$project$Ui$Form$Ein$einFormat, ein) ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(5, 'Please enter a valid EIN.')
            ]);
        }
    };
    var $author$project$Components$Practice$AccountForm$EmailValidation = 3;
    var $author$project$Components$Practice$AccountForm$validateEmail = F2(function(model, fields) {
        var _v0 = fields.OH;
        if (_v0.$ === 1) return model.mq && model.aK ? _List_fromArray([
            _Utils_Tuple2(3, 'Please enter an email.')
        ]) : _List_Nil;
        else {
            var email = _v0.a;
            return $rtfeldman$elm_validate$Validate$isValidEmail(email) ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(3, 'Please enter a valid email.')
            ]);
        }
    });
    var $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutesValidation = 4;
    var $author$project$Components$Practice$AccountForm$validateSessionTimeout = function(fields) {
        var invalid = _List_fromArray([
            _Utils_Tuple2(4, 'Please enter a number between 5 and 480.')
        ]);
        var _v0 = fields.ahj;
        if (!_v0.$) {
            var sessionTimeoutInMinutes = _v0.a;
            return sessionTimeoutInMinutes < 5 || sessionTimeoutInMinutes > 480 ? invalid : _List_Nil;
        } else return invalid;
    };
    var $author$project$Components$Practice$AccountForm$UrlValidation = 1;
    var $author$project$Utils$Url$validUrlRegex = '^(http:\\/\\/www\\.|https:\\/\\/www\\.|http:\\/\\/|https:\\/\\/)?[a-z0-9]+([\\-\\.]{1}[a-z0-9]+)*\\.[a-z]{2,10}(:[0-9]{1,5})?(\\/.*)?$';
    var $author$project$Components$Practice$AccountForm$validateUrl = F2(function(model, fields) {
        var _v0 = fields.aaT;
        if (_v0.$ === 1) return _List_Nil;
        else {
            var url = _v0.a;
            return !model.aK && !A2($author$project$Utils$Regex$matches, $author$project$Utils$Url$validUrlRegex, url) && !$elm$core$String$isEmpty(url) ? _List_fromArray([
                _Utils_Tuple2(1, 'Please enter a valid URL.')
            ]) : _List_Nil;
        }
    });
    var $author$project$Components$Practice$AccountForm$formFieldsValidator = function(model) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.zr;
            }, _Utils_Tuple2(0, 'Please enter a name.')),
            A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
                return $.Ge;
            }, $author$project$Components$Practice$AccountForm$maxLogoBytesSize, _Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateUrl(model)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateEmail(model)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateAddress(model)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateEin),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Practice$AccountForm$validateSessionTimeout)
        ]));
    };
    var $author$project$Components$Practice$AccountForm$validate = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        var address = $author$project$Components$AddressInput$validate(fields.II);
        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Practice$AccountForm$formFieldsUpdate, $author$project$Components$Practice$AccountForm$Address(address), model.PU);
        return A2($elm$core$Result$mapError, function(validatedForm) {
            return _Utils_update(model, {
                PU: validatedForm
            });
        }, A2($elm$core$Result$map, function(_v1) {
            var validatedForm = _v1.a;
            var validFormFields = _v1.b;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: validatedForm
            }), validFormFields);
        }, A2($author$project$Utils$Form$validate, $author$project$Components$Practice$AccountForm$formFieldsValidator(model), newForm)));
    };
    var $author$project$Pages$Admin$Practice$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$Practice$AccountForm$update, subMsg, model.cv);
                var accountFormModel = _v1.a;
                var accountFormCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    cv: accountFormModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, accountFormCmd), _List_Nil);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    ib: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    ib: false,
                    j_: $author$project$Api$Data$NotAsked
                }), $author$project$Ports$Session$logout({
                    agy: true
                }), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Practice has been deleted')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    ib: false,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var _v3 = $author$project$Components$Practice$AccountForm$validate(model.cv);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var validatedForm = _v4.a;
                    var validFormFields = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cv: validatedForm,
                        j_: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Admin$Practice$updatePractice, model.Ej, validFormFields), _List_Nil);
                } else {
                    var formErrors = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cv: formErrors,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 4:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Practice$delete, model.Ej, $author$project$Pages$Admin$Practice$Deleted), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    ib: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), A3($author$project$Pages$Admin$Practice$retrieveWhitelabelSetting, practice, model.Ej, model.Z$), _List_fromArray([
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var practice = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var _v7 = A4($author$project$Components$Practice$AccountForm$init, practice, response, model.Cu, {
                        aK: false,
                        Vt: false
                    });
                    var form = _v7.a;
                    var cmds = _v7.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cv: form
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$AccountFormMsg, cmds), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
                        $author$project$OutMsg$WhitelabelSettingsUpdated(response)
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var _v8 = $author$project$Components$Admin$Practice$DeactivateModal$open(model.W1);
                var deactivateModalModel = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    Nf: deactivateModalModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$DeactivateModalMsg, cmd), _List_Nil);
            default:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Admin$Practice$DeactivateModal$update, model.Ej, subMsg, model.Nf);
                var newModel = function() {
                    var _v9 = result.adu;
                    if (_v9.$ === 1) {
                        var practice = _v9.a;
                        return _Utils_update(model, {
                            W1: practice
                        });
                    } else return model;
                }();
                return _Utils_Tuple3(_Utils_update(newModel, {
                    Nf: result.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Practice$DeactivateModalMsg, result.EQ), result.at);
        }
    });
    var $author$project$Pages$Admin$Practice$Deactivate = {
        $: 6
    };
    var $author$project$Pages$Admin$Practice$Delete = {
        $: 1
    };
    var $author$project$Pages$Admin$Practice$FormSubmitted = {
        $: 3
    };
    var $author$project$Api$Provider$Practice$Shared$deactivated = function(_v0) {
        var record = _v0;
        return record.Nh;
    };
    var $author$project$Api$Provider$Practice$One$deactivated = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$deactivated(shared);
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$CancellationReasonSelected = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$Deactivate = {
        $: 1
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$RemovePracticeUsersUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasonOptions = A2($elm$core$List$indexedMap, F2(function(index, reason) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(index)), reason);
    }), $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasons);
    var $author$project$Components$Admin$Practice$DeactivateModal$viewModal = F6(function(practice, removePracticeUsers, request, maybeDate, dateInput, cancellationReason) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$Practice$DeactivateModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Deactivate Practice')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $elm$html$Html$text('You\'re about to deactivate Practice '),
                        $elm$html$Html$text($author$project$Api$Provider$Practice$One$name(practice)),
                        $elm$html$Html$text(' which stops all billing, payments and notifications. Admins will still be able to login to export data and download reports. This action cannot be undone.')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Prevent users from accessing the Practice'),
                    $author$project$Ui$Form$Group$labelSpan(6),
                    $author$project$Ui$Form$Group$labelSpanSm(8),
                    $author$project$Ui$Form$Group$inputSpan(6),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(removePracticeUsers),
                        $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$Practice$DeactivateModal$RemovePracticeUsersUpdated)
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Schedule Deactivation Date'),
                    $author$project$Ui$Form$Group$labelSpan(6),
                    $author$project$Ui$Form$Group$labelSpanSm(8),
                    $author$project$Ui$Form$Group$inputSpan(6),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Admin$Practice$DeactivateModal$DateInputMsg(dateInput), A2($author$project$Components$DateInput$view, _List_fromArray([
                        $author$project$Components$DateInput$value(maybeDate)
                    ]), dateInput))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Cancellation Reason'),
                    $author$project$Ui$Form$Group$labelSpan(6),
                    $author$project$Ui$Form$Group$labelSpanSm(8),
                    $author$project$Ui$Form$Group$inputSpan(6),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(cancellationReason)),
                        $author$project$Ui$Form$Select$onChange($author$project$Components$Admin$Practice$DeactivateModal$CancellationReasonSelected)
                    ]), $author$project$Components$Admin$Practice$DeactivateModal$cancellationReasonOptions)
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Practice$DeactivateModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Deactivate practice'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Practice$DeactivateModal$Deactivate)
                ]), _List_fromArray([
                    $elm$html$Html$text('Deactivate Practice')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Practice$DeactivateModal$view = function(model) {
        if (model.$ === 1) {
            var practitioner = model.a;
            var removePracticeUsers = model.b;
            var request = model.c;
            var maybeDate = model.d;
            var dateInput = model.e;
            var cancellationReason = model.f;
            return A6($author$project$Components$Admin$Practice$DeactivateModal$viewModal, practitioner, removePracticeUsers, request, maybeDate, dateInput, cancellationReason);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Practice$AccountForm$Ein = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$Email = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutes = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$Url = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Ein$Errors = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Ein$errors = $author$project$Ui$Form$Ein$Errors;
    var $author$project$Ui$Form$Ein$Invalid = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$Ein$invalid = function(bool) {
        return $author$project$Ui$Form$Ein$Invalid(bool);
    };
    var $author$project$Ui$Form$Ein$OnInput = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Ein$onInput = $author$project$Ui$Form$Ein$OnInput;
    var $author$project$Ui$Form$Ein$Value = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Ein$value = $author$project$Ui$Form$Ein$Value;
    var $author$project$Ui$Form$Ein$einMask = '##-#######';
    var $author$project$Ui$Form$Ein$einPattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Ui$Form$Ein$einMask);
    var $author$project$Ui$Form$Input$OnMaskedInput = F3(function(a, b, c) {
        return {
            $: 10,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Input$onMaskedInput = $author$project$Ui$Form$Input$OnMaskedInput;
    var $author$project$Ui$Form$Ein$defaultOptions = {
        fK: _List_Nil,
        q2: false,
        afE: $elm$core$Maybe$Nothing,
        r7: $elm$core$Maybe$Nothing,
        aa9: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Form$Ein$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var handler = option.a;
                    return _Utils_update(record, {
                        afE: $elm$core$Maybe$Just(handler)
                    });
                case 1:
                    var string = option.a;
                    return _Utils_update(record, {
                        aa9: string
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        q2: bool
                    });
                case 3:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
                default:
                    var string = option.a;
                    return _Utils_update(record, {
                        r7: $elm$core$Maybe$Just(string)
                    });
            }
        }), $author$project$Ui$Form$Ein$defaultOptions, options);
    };
    var $author$project$Ui$Form$Ein$view = function(options) {
        var optionsRecord = $author$project$Ui$Form$Ein$optionsToRecord(options);
        var value_ = A2($elm$core$Maybe$withDefault, '', optionsRecord.aa9);
        var onInput_ = function() {
            var _v0 = optionsRecord.afE;
            if (!_v0.$) {
                var handler = _v0.a;
                return _List_fromArray([
                    A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Ui$Form$Ein$einPattern, value_, handler)
                ]);
            } else return _List_Nil;
        }();
        return $author$project$Ui$Form$Input$view(A2($elm$core$List$cons, $author$project$Ui$Form$Input$autoComplete(false), A2($elm$core$List$cons, A2($author$project$Ui$Form$Input$maskedValue, $author$project$Ui$Form$Ein$einPattern, value_), A2($elm$core$List$cons, $author$project$Ui$Form$Input$invalid(optionsRecord.q2), A2($elm$core$List$cons, $author$project$Ui$Form$Input$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$Input$placeholder(A2($elm$core$Maybe$withDefault, '', optionsRecord.r7)), onInput_))))));
    };
    var $author$project$Components$Practice$AccountForm$EmrSelected = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$Emr$toLabel = function(_v0) {
        var name = _v0.zr;
        return name;
    };
    var $author$project$Api$Provider$Practice$Emr$toOption = function(_v0) {
        var option = _v0.af;
        return option;
    };
    var $author$project$Components$Practice$AccountForm$viewEmrSelect = F2(function(model, fields) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9),
            $author$project$Ui$Form$Group$label('EMR')
        ]), _List_fromArray([
            function() {
                var items = A2($elm$core$List$map, function(emr) {
                    return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$Practice$AccountForm$EmrSelected($elm$core$Maybe$Just(emr))),
                        $author$project$Ui$Dropdown$selected(_Utils_eq(fields.adl, $elm$core$Maybe$Just(emr)))
                    ]), $elm$html$Html$text($author$project$Api$Provider$Practice$Emr$toLabel(emr)));
                }, $author$project$Api$Provider$Practice$Emr$options);
                var currentLabel = function() {
                    var _v0 = fields.adl;
                    if (!_v0.$) {
                        var emr = _v0.a;
                        return $author$project$Api$Provider$Practice$Emr$toLabel(emr);
                    } else return 'Select an EMR';
                }();
                return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(currentLabel)
                ]), items, model.l6);
            }(),
            _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$toOption, fields.adl), $elm$core$Maybe$Just(13)) ? A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('mt-2')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.adn)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$EmrOther), $author$project$Utils$String$toMaybe))
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Practice$AccountForm$FaviconUploaded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$LogoUploaded = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Practice$AccountForm$viewLogos = F3(function(_v0, form, isOnboarding) {
        var currentLogoUrl = _v0.MM;
        var currentFaviconUrl = _v0.w3;
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('mt-2 mb-2')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Logo')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Recommended size: 400x200 px or larger.'),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $elm$html$Html$text('Supported image file: JPG, PNG')
                    ])),
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(0),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Practice$AccountForm$LogoUploaded),
                        $author$project$Ui$Form$File$empty(true)
                    ])),
                    function() {
                        if (!currentLogoUrl.$) {
                            if (currentLogoUrl.a === '') return $author$project$Utils$Html$empty;
                            else {
                                var url = currentLogoUrl.a;
                                return A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt4
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Image$fromSrc, {
                                        Jg: 'Uploaded image'
                                    }, url, _List_fromArray([
                                        $author$project$Ui$Image$height(50)
                                    ])),
                                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, form))
                                ]));
                            }
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                isOnboarding ? A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_Nil) : A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Browser Tab Image (Favicon)')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Recommended size: 260x260 px or larger.'),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $elm$html$Html$text('Supported image file: PNG')
                    ])),
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(0),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Practice$AccountForm$FaviconUploaded),
                        $author$project$Ui$Form$File$empty(true)
                    ])),
                    function() {
                        if (!currentFaviconUrl.$) {
                            if (currentFaviconUrl.a === '') return $author$project$Utils$Html$empty;
                            else {
                                var url = currentFaviconUrl.a;
                                return A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt4
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Image$fromSrc, {
                                        Jg: 'Uploaded favicon'
                                    }, url, _List_fromArray([
                                        $author$project$Ui$Image$height(50)
                                    ]))
                                ]));
                            }
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Practice$AccountForm$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Website')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.aaT)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Url)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Practice Logo'),
                $author$project$Ui$Form$Group$labelHelp(A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$helpText,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text('Shown to Patients')
                ])))
            ]), _List_fromArray([
                A3($author$project$Components$Practice$AccountForm$viewLogos, fields, model.PU, model.aK)
            ])),
            model.aK && model.mq ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Practice Phone')
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Practice$AccountForm$PhoneInputMsg, $author$project$Components$PhoneInput$view(fields.WE))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Practice Email'),
                $author$project$Ui$Form$Group$required(model.mq && model.aK)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.OH)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Email)),
                    $author$project$Ui$Form$Input$placeholder('contact@mypractice.com'),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 3, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Bussiness Address'),
                $author$project$Ui$Form$Group$required(model.D9)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Practice$AccountForm$AddressInputMsg, A2($author$project$Components$AddressInput$view, _List_Nil, fields.II))
            ])),
            model.aK ? $author$project$Utils$Html$empty : A2($author$project$Components$Practice$AccountForm$viewEmrSelect, model, fields),
            model.aK && model.mq ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Employer Identification Number (EIN)')
            ]), _List_fromArray([
                $author$project$Ui$Form$Ein$view(_List_fromArray([
                    $author$project$Ui$Form$Ein$value(fields.Oy),
                    $author$project$Ui$Form$Ein$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$Ein)),
                    $author$project$Ui$Form$Ein$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, model.PU)),
                    $author$project$Ui$Form$Ein$errors(A2($author$project$Utils$Form$validationErrors, 5, model.PU))
                ]))
            ])),
            model.aK ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpan(9),
                $author$project$Ui$Form$Group$label('Auto Logout After'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$number,
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.ahj))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Practice$AccountForm$FormUpdated, $author$project$Components$Practice$AccountForm$SessionTimeoutInMinutes)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, model.PU))
                    ])),
                    $author$project$Ui$Form$Input$addon(_List_fromArray([
                        $elm$html$Html$text('minutes')
                    ]))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 4, model.PU)),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpText
                ]), _List_fromArray([
                    $elm$html$Html$text('In order to protect your patients\' data when you are not using the app, the application will log you out after this number of minutes.')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Practice$view = function(model) {
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        return {
            fb: _List_fromArray([
                function() {
                    if (model.ib) {
                        var practiceName = $author$project$Api$Provider$Practice$One$name(model.W1);
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Practice$HiConfirmClosed, _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun(practiceName),
                            $author$project$Components$HiConfirm$loading(loading),
                            $author$project$Components$HiConfirm$detail(' and disable all login access')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($elm$html$Html$map, $author$project$Pages$Admin$Practice$DeactivateModalMsg, $author$project$Components$Admin$Practice$DeactivateModal$view(model.Nf)),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Admin$Practice$FormSubmitted)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Practice')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mb4
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$muted
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('The practice info on this page will be used for invoicing, patient billing inquiries and automated notifications')
                                    ]))
                                ])),
                                A2($elm$html$Html$map, $author$project$Pages$Admin$Practice$AccountFormMsg, $author$project$Components$Practice$AccountForm$view(model.cv)),
                                function() {
                                    var _v0 = model.j_;
                                    if (_v0.$ === 2) {
                                        var error = _v0.a;
                                        return A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$mt4
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text($author$project$Api$Data$errorToString(error))
                                            ]))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            function() {
                                var _v1 = _Utils_Tuple2(model.F3, $author$project$Api$Provider$Practice$One$deactivated(model.W1));
                                if (_v1.a) {
                                    if (!_v1.b) return A3($author$project$Ui$HinterOnly$button, {
                                        abP: 'Deactivate practice'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$danger,
                                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Practice$Deactivate)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Deactivate')
                                    ]));
                                    else return A3($author$project$Ui$HinterOnly$button, {
                                        abP: 'Delete practice'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$danger,
                                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Practice$Delete)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Delete')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Update practice'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Update')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Admin | Practice'
        };
    };
    var $author$project$Pages$Admin$Practice$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Practice$init,
        aeR: $author$project$Pages$Admin$Practice$load,
        ag3: $author$project$Pages$Admin$Practice$save,
        ahE: $author$project$Pages$Admin$Practice$subscriptions,
        aaO: $author$project$Pages$Admin$Practice$update,
        aid: $author$project$Pages$Admin$Practice$view
    });
    var $author$project$Pages$Admin$ProviderGroups$GotLocationGroups = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$LocationGroup$IntegrationRecords = 0;
    var $author$project$Pages$Admin$ProviderGroups$fetchLocationGroups = function(model) {
        return A3($author$project$Api$Provider$LocationGroup$list, model.Ej, function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ])
            });
        }, $author$project$Pages$Admin$ProviderGroups$GotLocationGroups);
    };
    var $author$project$Pages$Admin$ProviderGroups$init = F4(function(_v0, practice, _v1, _v2) {
        var apiClient = _v1.Ej;
        var model = {
            Ej: apiClient,
            ig: $elm$core$Maybe$Nothing,
            dT: $elm$core$Set$empty,
            rm: $elm$core$Maybe$Nothing,
            Tl: $author$project$Api$Data$Loading,
            agL: $author$project$Api$Provider$Practice$One$requireGroupForLocations(practice)
        };
        return _Utils_Tuple2(model, $author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model));
    });
    var $author$project$Pages$Admin$ProviderGroups$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$ProviderGroups$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit = {
        $: 3
    };
    var $author$project$Pages$Admin$ProviderGroups$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$ProviderGroups$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit)), model.rm)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ProviderGroups$HiConfirmClosed), model.ig))
        ]));
    };
    var $author$project$Pages$Admin$ProviderGroups$LocationGroupDeleted = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$LocationGroup$locationGroupPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$LocationGroup$locationGroupsPath);
    };
    var $author$project$Api$Provider$LocationGroup$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$LocationGroup$locationGroupPath(id_)));
    });
    var $author$project$Pages$Admin$ProviderGroups$formFieldsFromLocationGroup = function(locationGroup) {
        return $author$project$Api$Provider$LocationGroup$All$name(locationGroup);
    };
    var $author$project$Pages$Admin$ProviderGroups$formFieldsInit = '';
    var $author$project$Pages$Admin$ProviderGroups$formFieldsUpdate = F2(function(field, _v0) {
        var name = field;
        return name;
    });
    var $author$project$Pages$Admin$ProviderGroups$NameValidation = 0;
    var $author$project$Pages$Admin$ProviderGroups$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Api$Provider$LocationGroup$All$locationsCount = function(_v0) {
        var record = _v0.b;
        return record.Tr;
    };
    var $author$project$Api$Provider$LocationGroup$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Common$LocationGroup$Shared$name(shared);
    };
    var $author$project$Pages$Admin$ProviderGroups$LocationGroupCreated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$LocationGroup$One$LocationGroup = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LocationGroup$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$LocationGroup$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$LocationGroup$create = F3(function(apiClient, name_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('location_group', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(name_))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$LocationGroup$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$LocationGroup$locationGroupsPath)));
    });
    var $author$project$Pages$Admin$ProviderGroups$createLocationGroup = F2(function(apiClient, formFields) {
        var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$LocationGroup$create, apiClient, name, $author$project$Pages$Admin$ProviderGroups$LocationGroupCreated);
    });
    var $author$project$Pages$Admin$ProviderGroups$LocationGroupUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$LocationGroup$update = F4(function(apiClient, id_, name_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('location_group', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(name_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$LocationGroup$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$LocationGroup$locationGroupPath(id_))));
    });
    var $author$project$Pages$Admin$ProviderGroups$updateLocationGroup = F3(function(apiClient, id, formFields) {
        var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$LocationGroup$update, apiClient, id, name, $author$project$Pages$Admin$ProviderGroups$LocationGroupUpdated);
    });
    var $author$project$Pages$Admin$ProviderGroups$saveLocationGroup = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Pages$Admin$ProviderGroups$updateLocationGroup, apiClient, id_, formFields);
        } else return A2($author$project$Pages$Admin$ProviderGroups$createLocationGroup, apiClient, formFields);
    });
    var $author$project$Pages$Admin$ProviderGroups$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    rm: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Admin$ProviderGroups$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var locationGroup = msg.a;
                return $author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0 && model.agL ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    ig: $elm$core$Maybe$Just(locationGroup)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var locationGroup = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    ig: $elm$core$Maybe$Nothing,
                    dT: A2($elm$core$Set$insert, $author$project$Api$Provider$LocationGroup$All$id(locationGroup), model.dT)
                }), A3($author$project$Api$Provider$LocationGroup$delete, model.Ej, $author$project$Api$Provider$LocationGroup$All$id(locationGroup), $author$project$Pages$Admin$ProviderGroups$LocationGroupDeleted(locationGroup)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    ig: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var locationGroup = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    rm: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$LocationGroup$All$id(locationGroup)), $author$project$Utils$Form$init($author$project$Pages$Admin$ProviderGroups$formFieldsFromLocationGroup(locationGroup)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var form = msg.a;
                var id = msg.b;
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$ProviderGroups$formFieldsValidator, form);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var newForm = _v2.a;
                    var validFormFields = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        rm: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Admin$ProviderGroups$saveLocationGroup, model.Ej, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        rm: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    rm: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var dataLocationGroups = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tl: dataLocationGroups
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(dataLocationGroups));
            case 6:
                var field = msg.a;
                var _v3 = model.rm;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var id = _v4.a;
                    var form = _v4.b;
                    var locationGroup = _v4.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$ProviderGroups$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        rm: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, locationGroup))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var dataLocationGroup = msg.a;
                var _v5 = model.rm;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var id = _v6.a;
                    var form = _v6.b;
                    if (dataLocationGroup.$ === 3) {
                        var locationGroup = dataLocationGroup.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            rm: $elm$core$Maybe$Nothing,
                            Tl: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$LocationGroup$One$name(locationGroup))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        rm: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, dataLocationGroup))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataLocationGroup));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var dataLocationGroup = msg.a;
                var _v8 = model.rm;
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var id = _v9.a;
                    var form = _v9.b;
                    if (dataLocationGroup.$ === 3) {
                        var locationGroup = dataLocationGroup.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            rm: $elm$core$Maybe$Nothing,
                            Tl: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$LocationGroup$One$name(locationGroup) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        rm: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, dataLocationGroup))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataLocationGroup));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var locationGroup = msg.a;
                var dataLocationGroup = msg.b;
                switch(dataLocationGroup.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dT: A2($elm$core$Set$remove, $author$project$Api$Provider$LocationGroup$All$id(locationGroup), model.dT),
                            Tl: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$ProviderGroups$fetchLocationGroups(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$LocationGroup$All$name(locationGroup) + ' was successfully removed.')
                        ]));
                    case 2:
                        var error = dataLocationGroup.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            dT: A2($elm$core$Set$remove, $author$project$Api$Provider$LocationGroup$All$id(locationGroup), model.dT)
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(dataLocationGroup)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Admin$ProviderGroups$NewLocationGroup = {
        $: 0
    };
    var $author$project$Pages$Admin$ProviderGroups$FormUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$ProviderGroups$Name = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$ProviderGroups$SaveLocationGroup = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$ProviderGroups$viewLocationGroupModal = F3(function(id, form, locationGroup) {
        var name = $author$project$Utils$Form$fields(form);
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Location Group',
            Tk: _Utils_eq(locationGroup, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$ProviderGroups$CancelLocationGroupEdit,
            Vn: $author$project$Pages$Admin$ProviderGroups$SaveLocationGroup(form)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$label('Description'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(name),
                    $author$project$Ui$Form$Input$placeholder('Downtown Clinic'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$ProviderGroups$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$ProviderGroups$DeleteLocationGroup = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$ProviderGroups$EditLocationGroup = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$LocationGroup$All$integrationRecords = function(_v0) {
        var record = _v0.b;
        return record.Rr;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$integration = function(_v0) {
        var record = _v0.b;
        return record.Rn;
    };
    var $author$project$Api$Provider$IntegrationRecord$Shared$integrationSyncStatus = function(_v0) {
        var record = _v0;
        return record.Rs;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$IntegrationRecord$Shared$integrationSyncStatus(shared);
    };
    var $author$project$Api$Provider$Integration$SharedWithInlinePartner$name = function(_v0) {
        var inlinePartner = _v0.b;
        return $author$project$Api$Provider$Partner$Shared$name(inlinePartner);
    };
    var $author$project$Api$IntegrationRecord$Status$toString = function(status) {
        switch(status){
            case 0:
                return 'synced';
            case 1:
                return 'unsynced';
            case 2:
                return 'errored';
            default:
                return 'enabled';
        }
    };
    var $author$project$Pages$Admin$ProviderGroups$viewIntegrationRecord = function(integrationRecord) {
        return A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('spaced-out small')
        ]), function() {
            var _v0 = $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus(integrationRecord);
            if (!_v0) return _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Integration$SharedWithInlinePartner$name($author$project$Api$Provider$IntegrationRecord$One$integration(integrationRecord)))
                ])),
                $author$project$Utils$Html$noBreakSpace,
                A2($author$project$Ui$Badge$fromString, _List_Nil, A2($elm$core$Basics$composeR, $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus, $author$project$Api$IntegrationRecord$Status$toString)(integrationRecord))
            ]);
            else return _List_Nil;
        }());
    };
    var $author$project$Pages$Admin$ProviderGroups$viewLocationGroup = F3(function(requireGroupForLocations, deletingLocationGroups, locationGroup) {
        var preventDelete = $author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0 && requireGroupForLocations;
        var integrationRecords = A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$LocationGroup$All$integrationRecords(locationGroup));
        var id = $author$project$Api$Provider$LocationGroup$All$id(locationGroup);
        var deleting = A2($elm$core$Set$member, id, deletingLocationGroups);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, A2($elm$core$List$cons, $elm$html$Html$text($author$project$Api$Provider$LocationGroup$All$name(locationGroup)), A2($elm$core$List$map, $author$project$Pages$Admin$ProviderGroups$viewIntegrationRecord, integrationRecords))),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit location group'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$ProviderGroups$EditLocationGroup(locationGroup)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete location group'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$disabled(preventDelete),
                        $author$project$Ui$Button$loading(deleting),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$ProviderGroups$DeleteLocationGroup(locationGroup)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$ProviderGroups$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.Tl;
            if (_v1.$ === 3) {
                var locationGroups_ = _v1.a;
                return _Utils_Tuple2(false, locationGroups_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var locationGroups = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You have no Location Groups.'),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                function() {
                    var label = 'Add a Location Group here';
                    return A3($author$project$Ui$Button$view, {
                        abP: label
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$ProviderGroups$NewLocationGroup)
                    ]), _List_fromArray([
                        $elm$html$Html$text(label)
                    ]));
                }()
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Name')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), A2($elm$core$List$map, A2($author$project$Pages$Admin$ProviderGroups$viewLocationGroup, model.agL, model.dT), locationGroups), _List_Nil);
    };
    var $author$project$Pages$Admin$ProviderGroups$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.rm;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        var form = _v1.b;
                        var locationGroup = _v1.c;
                        return A3($author$project$Pages$Admin$ProviderGroups$viewLocationGroupModal, id, form, locationGroup);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.ig;
                    if (!_v2.$) {
                        var locationGroup = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$ProviderGroups$HiConfirmClosed(locationGroup), _Utils_ap($author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup) > 0 ? _List_fromArray([
                            $author$project$Components$HiConfirm$sentence('It is currently assigned to ' + (A2($author$project$Formatters$String$pluralize, 'location', $author$project$Api$Provider$LocationGroup$All$locationsCount(locationGroup)) + '. Are you sure?'))
                        ]) : _List_Nil, _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('location group')
                        ])));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            $elm$html$Html$text('Location Groups')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Add new location group'
                            }, _List_fromArray([
                                $author$project$Ui$Button$default,
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$ProviderGroups$NewLocationGroup),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('New Location Group')
                            ]))
                        ])),
                        A2($elm$html$Html$em, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Lets you assign a group to any location')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Admin$ProviderGroups$viewPanelBody(model)
                    ]))
                ]))
            ]),
            $2: 'Admin | Location Groups'
        };
    };
    var $author$project$Pages$Admin$ProviderGroups$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$ProviderGroups$init,
        aeR: $author$project$Pages$Admin$ProviderGroups$load,
        ag3: $author$project$Pages$Admin$ProviderGroups$save,
        ahE: $author$project$Pages$Admin$ProviderGroups$subscriptions,
        aaO: $author$project$Pages$Admin$ProviderGroups$update,
        aid: $author$project$Pages$Admin$ProviderGroups$view
    });
    var $author$project$Pages$Admin$Providers$Top$GotElationPhysicians = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$GotLocations = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$GotPracticeSettings = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$GotSpecialties = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$GotList = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Practitioner$Locations = 0;
    var $author$project$Api$Provider$Practitioner$All$Practitioner = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Practitioner$All$Record = F2(function(specialties, locations) {
        return {
            Tq: locations,
            _N: specialties
        };
    });
    var $author$project$Api$Provider$Practitioner$All$recordDecoder = A3($author$project$Api$Expandable$expandable, 'locations', $elm$json$Json$Decode$list($author$project$Api$Provider$Location$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'specialties', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$All$Record)));
    var $author$project$Api$Provider$Practitioner$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practitioner$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practitioner$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$All$Practitioner)));
    var $author$project$Api$Provider$Practitioner$expandToString = function(expand) {
        if (!expand) return 'locations';
        else return 'practice_extras';
    };
    var $author$project$Api$Provider$Practitioner$listDefaults = {
        pj: $elm$core$Maybe$Nothing,
        pk: $elm$core$Maybe$Nothing,
        Eb: $elm$core$Maybe$Nothing,
        Fq: _List_Nil,
        aef: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        GF: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        Hs: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Provider$Practitioner$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Practitioner$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.rm;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.aeT;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.GF;
                if (!_v4.$) {
                    var bool = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'online_signup', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.pj;
                if (!_v5.$) {
                    var bool = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'accepts_enrollments_from_employer', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.pk;
                if (!_v6.$) {
                    var bool = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'accepts_enrollments_from_retail', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v7 = options.Eb;
                if (!_v7.$) {
                    var string = _v7.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'affiliate', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v8 = options.Hs;
                if (!_v8.$) {
                    var ident = _v8.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'signup_page', ident)
                    ]);
                } else return _List_Nil;
            }(),
            A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Practitioner$expandToString, options.Fq),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Practitioner$practitionersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practitioners'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Practitioner$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Practitioner$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$practitionersPath)));
    });
    var $author$project$Pages$Admin$Providers$Top$fetchList = function(model) {
        return A3($author$project$Api$Provider$Practitioner$list, model.Ej, function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ]),
                af_: model.af_,
                agq: model.agq
            });
        }, $author$project$Pages$Admin$Providers$Top$GotList);
    };
    var $author$project$Pages$Admin$Providers$Top$GotPracticeProviderCount = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount = function(model) {
        return A3($author$project$Api$Provider$Practitioner$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: A2($author$project$Api$Pagination$withItemsPerPage, 1, $author$project$Api$Pagination$init)
            });
        }, $author$project$Pages$Admin$Providers$Top$GotPracticeProviderCount);
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$Closed = {
        $: 0
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$init = $author$project$Components$Admin$Practitioner$DeleteModal$Closed;
    var $author$project$Api$Provider$ElationPhysician$All$ElationPhysician = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ElationPhysician$All$AllRecord = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$ElationPhysician$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationPhysician$All$AllRecord)));
    var $author$project$Api$Provider$ElationPhysician$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ElationPhysician$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Practitioner$ElationPhysician$elationPhysiciansPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'elation_physicians'
    ]), $author$project$Api$Provider$Practitioner$practitionersPath);
    var $author$project$Api$Provider$Practitioner$ElationPhysician$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ElationPhysician$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$ElationPhysician$elationPhysiciansPath));
    });
    var $author$project$Api$Provider$Specialty$All$Specialty = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Specialty$Shared$Specialty = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Specialty$Shared$Record = function(name) {
        return {
            zr: name
        };
    };
    var $author$project$Api$Provider$Specialty$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Specialty$Shared$Record));
    var $author$project$Api$Provider$Specialty$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Specialty$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Specialty$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Specialty$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Specialty$specialtiesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'specialties'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Specialty$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Specialty$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Specialty$specialtiesPath));
    });
    var $author$project$Api$Provider$PracticeSettings$One$PracticeSettings = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeSettings$One$Record = function(showNpi) {
        return {
            _g: showNpi
        };
    };
    var $author$project$Api$Provider$PracticeSettings$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'show_npi', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeSettings$One$Record));
    var $author$project$Api$Provider$PracticeSettings$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeSettings$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticeSettings$practiceSettingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice/settings'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PracticeSettings$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PracticeSettings$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeSettings$practiceSettingsPath));
    });
    var $author$project$Pages$Admin$Providers$Top$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var rawUrl = _v0.agv;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            aW: $elm$core$Maybe$Nothing,
            Ej: shared.Ej,
            ia: $author$project$Components$Admin$Practitioner$DeleteModal$init,
            $8: $elm$core$Maybe$Nothing,
            dS: $elm$core$Set$empty,
            NI: $elm$core$Set$empty,
            xq: $author$project$Api$Data$Loading,
            F3: $author$project$Shared$isHintAdmin(shared),
            F6: $elm$core$Maybe$Nothing,
            i$: $author$project$Api$Data$Loading,
            mV: $author$project$Components$LinkedRecords$init,
            Tq: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            sc: $elm$core$Maybe$Nothing,
            sd: $author$project$Api$Data$Loading,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            _N: $author$project$Api$Data$Loading,
            aaT: rawUrl
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Admin$Providers$Top$fetchList(model),
            $author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model),
            A3($author$project$Api$Provider$Location$list, shared.Ej, $elm$core$Basics$identity, $author$project$Pages$Admin$Providers$Top$GotLocations),
            A2($author$project$Api$Provider$Specialty$list, shared.Ej, $author$project$Pages$Admin$Providers$Top$GotSpecialties),
            A2($author$project$Api$Provider$Practitioner$ElationPhysician$list, shared.Ej, $author$project$Pages$Admin$Providers$Top$GotElationPhysicians),
            A2($author$project$Api$Provider$PracticeSettings$retrieve, shared.Ej, $author$project$Pages$Admin$Providers$Top$GotPracticeSettings)
        ])));
    });
    var $author$project$Pages$Admin$Providers$Top$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Providers$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Providers$Top$CancelAddLocation = {
        $: 23
    };
    var $author$project$Pages$Admin$Providers$Top$CancelEdit = {
        $: 8
    };
    var $author$project$Pages$Admin$Providers$Top$DeleteModalMsg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$subscriptions = function(modal) {
        if (modal.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$Practitioner$DeleteModal$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Providers$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg, $author$project$Components$LinkedRecords$subscriptions(model.mV)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Providers$Top$DeleteModalMsg, $author$project$Components$Admin$Practitioner$DeleteModal$subscriptions(model.ia)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Providers$Top$CancelAddLocation)), model.aW)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Providers$Top$CancelEdit)), model.F6)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Providers$Top$HiConfirmClosed), model.$8))
        ]));
    };
    var $author$project$Pages$Admin$Providers$Top$Deleted = F2(function(a, b) {
        return {
            $: 15,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Providers$Top$FormUpdated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$LocationAdded = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$Photo = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Providers$Top$PracticeSettingsUpdated = function(a) {
        return {
            $: 27,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$SearchInputMsg = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Api$Provider$Practitioner$practitionerPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Practitioner$practitionersPath);
    };
    var $author$project$Api$Provider$Practitioner$Location$locationsPath = function(practitionerId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'locations'
        ]), $author$project$Api$Provider$Practitioner$practitionerPath(practitionerId));
    };
    var $author$project$Api$Provider$Practitioner$Location$create = F4(function(apiClient, practitionerId, id, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('location', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(id))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Location$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$Location$locationsPath(practitionerId))));
    });
    var $author$project$Api$Provider$Practitioner$delete = F4(function(apiClient, id_, reassignToPractitioner, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, function() {
            if (!reassignToPractitioner.$) {
                var string = reassignToPractitioner.a;
                return _List_fromArray([
                    A2($author$project$Api$Param$string, 'reassign_to_practitioner_id', string)
                ]);
            } else return _List_Nil;
        }(), $author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$practitionerPath(id_))));
    });
    var $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromEmployer = function(_v0) {
        var record = _v0;
        return record.pj;
    };
    var $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromEmployer = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromEmployer(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromRetail = function(_v0) {
        var record = _v0;
        return record.pk;
    };
    var $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromRetail = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$acceptsEnrollmentsFromRetail(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$autoDetermineOnlineSignupVisibilityFromPanelSize = function(_v0) {
        var record = _v0;
        return record.JU;
    };
    var $author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$autoDetermineOnlineSignupVisibilityFromPanelSize(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$bio = function(_v0) {
        var record = _v0;
        return record.Kj;
    };
    var $author$project$Api$Provider$Practitioner$All$bio = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$bio(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$education = function(_v0) {
        var record = _v0;
        return record.Ov;
    };
    var $author$project$Api$Provider$Practitioner$All$education = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$education(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$elationPhysicianId = function(_v0) {
        var record = _v0;
        return record.OA;
    };
    var $author$project$Api$Provider$Practitioner$All$elationPhysicianId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$elationPhysicianId(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$Practitioner$All$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$email(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$gender = function(_v0) {
        var record = _v0;
        return record.P5;
    };
    var $author$project$Api$Provider$Practitioner$All$gender = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$gender(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$genderOther = function(_v0) {
        var record = _v0;
        return record.P7;
    };
    var $author$project$Api$Provider$Practitioner$All$genderOther = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$genderOther(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$isProvider = function(_v0) {
        var record = _v0;
        return record.Sl;
    };
    var $author$project$Api$Provider$Practitioner$All$isProvider = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$isProvider(shared);
    };
    var $author$project$Api$Provider$Practitioner$All$locations = function(_v0) {
        var record = _v0.b;
        return record.Tq;
    };
    var $author$project$Api$Provider$Practitioner$Shared$maxPatientAge = function(_v0) {
        var record = _v0;
        return record.TM;
    };
    var $author$project$Api$Provider$Practitioner$All$maxPatientAge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$maxPatientAge(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Api$Provider$Practitioner$All$meta = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$meta(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$minPatientAge = function(_v0) {
        var record = _v0;
        return record.Ul;
    };
    var $author$project$Api$Provider$Practitioner$All$minPatientAge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$minPatientAge(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Practitioner$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$name(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$npi = function(_v0) {
        var record = _v0;
        return record.U9;
    };
    var $author$project$Api$Provider$Practitioner$All$npi = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$npi(shared);
    };
    var $author$project$Api$Provider$Npi$Shared$number = function(_v0) {
        var record = _v0;
        return record.Gx;
    };
    var $author$project$Api$Provider$Practitioner$Shared$onlineSignupVisibility = function(_v0) {
        var record = _v0;
        return record.Vv;
    };
    var $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$onlineSignupVisibility(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$panelSize = function(_v0) {
        var record = _v0;
        return record.VS;
    };
    var $author$project$Api$Provider$Practitioner$All$panelSize = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$panelSize(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$panelSizeLimit = function(_v0) {
        var record = _v0;
        return record.VT;
    };
    var $author$project$Api$Provider$Practitioner$All$panelSizeLimit = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$panelSizeLimit(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$photoUrl = function(_v0) {
        var record = _v0;
        return record.WI;
    };
    var $author$project$Api$Provider$Practitioner$All$photoUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$photoUrl(shared);
    };
    var $author$project$Api$Provider$Practitioner$All$specialties = function(_v0) {
        var record = _v0.b;
        return record._N;
    };
    var $author$project$Api$Provider$Practitioner$Shared$syncedPatientsCount = function(_v0) {
        var record = _v0;
        return record.$J;
    };
    var $author$project$Api$Provider$Practitioner$All$syncedPatientsCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$syncedPatientsCount(shared);
    };
    var $author$project$Pages$Admin$Providers$Top$formFieldsFromItem = function(item) {
        var locationsList = A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$Practitioner$All$locations(item));
        var emptyList = _List_fromArray([
            ''
        ]);
        var locations = $elm$core$List$isEmpty(locationsList) ? emptyList : A2($elm$core$List$map, function(location1) {
            return $author$project$Api$Provider$Location$Shared$id(location1);
        }, locationsList);
        var specialties = $elm$core$List$isEmpty($author$project$Api$Provider$Practitioner$All$specialties(item)) ? emptyList : $author$project$Api$Provider$Practitioner$All$specialties(item);
        var education = $elm$core$List$isEmpty($author$project$Api$Provider$Practitioner$All$education(item)) ? emptyList : $author$project$Api$Provider$Practitioner$All$education(item);
        return {
            pj: $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromEmployer(item),
            pk: $author$project$Api$Provider$Practitioner$All$acceptsEnrollmentsFromRetail(item),
            JU: $author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize(item),
            Kj: $author$project$Api$Provider$Practitioner$All$bio(item),
            p9: $author$project$Api$Provider$Practitioner$All$photoUrl(item),
            Ov: education,
            OA: $author$project$Api$Provider$Practitioner$All$elationPhysicianId(item),
            OH: $author$project$Api$Provider$Practitioner$All$email(item),
            P5: $author$project$Api$Provider$Practitioner$All$gender(item),
            P7: $author$project$Api$Provider$Practitioner$All$genderOther(item),
            Sl: $author$project$Api$Provider$Practitioner$All$isProvider(item),
            Tq: locations,
            TM: $author$project$Api$Provider$Practitioner$All$maxPatientAge(item),
            Ue: $elm$core$Maybe$Just($author$project$Api$Provider$Practitioner$All$meta(item)),
            Ul: $author$project$Api$Provider$Practitioner$All$minPatientAge(item),
            zr: $author$project$Api$Provider$Practitioner$All$name(item),
            U9: $author$project$Api$Provider$Practitioner$All$isProvider(item) ? A2($elm$core$Maybe$map, $author$project$Api$Provider$Npi$Shared$number, $author$project$Api$Provider$Practitioner$All$npi(item)) : $elm$core$Maybe$Nothing,
            Vv: $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility(item),
            VS: $elm$core$Maybe$Just($author$project$Api$Provider$Practitioner$All$panelSize(item)),
            VT: $author$project$Api$Provider$Practitioner$All$panelSizeLimit(item),
            r6: 0,
            WI: $elm$core$Maybe$Nothing,
            _N: specialties,
            $J: $author$project$Api$Provider$Practitioner$All$syncedPatientsCount(item)
        };
    };
    var $author$project$Pages$Admin$Providers$Top$formFieldsInit = {
        pj: true,
        pk: true,
        JU: false,
        Kj: $elm$core$Maybe$Nothing,
        p9: $elm$core$Maybe$Nothing,
        Ov: _List_fromArray([
            ''
        ]),
        OA: $elm$core$Maybe$Nothing,
        OH: $elm$core$Maybe$Nothing,
        P5: $elm$core$Maybe$Nothing,
        P7: $elm$core$Maybe$Nothing,
        Sl: true,
        Tq: _List_fromArray([
            ''
        ]),
        TM: $elm$core$Maybe$Nothing,
        Ue: $elm$core$Maybe$Nothing,
        Ul: $elm$core$Maybe$Nothing,
        zr: '',
        U9: $elm$core$Maybe$Nothing,
        Vv: true,
        VS: $elm$core$Maybe$Nothing,
        VT: $elm$core$Maybe$Nothing,
        r6: 0,
        WI: $elm$core$Maybe$Nothing,
        _N: _List_fromArray([
            ''
        ]),
        $J: 0
    };
    var $author$project$Pages$Admin$Providers$Top$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 23:
                var bool = field.a;
                return _Utils_update(fields, {
                    pj: bool
                });
            case 24:
                var bool = field.a;
                return _Utils_update(fields, {
                    pk: bool
                });
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    Kj: $author$project$Utils$String$toMaybe(string)
                });
            case 2:
                var gender = field.a;
                return _Utils_update(fields, {
                    P5: $elm$core$Maybe$Just(gender)
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    P7: $author$project$Utils$String$toMaybe(string)
                });
            case 4:
                var _int = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    p9: $elm$core$Maybe$Just(string),
                    r6: _int,
                    WI: $elm$core$Maybe$Just(string)
                });
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    OH: $author$project$Utils$String$toMaybe(string)
                });
            case 6:
                var string = field.a;
                return _Utils_update(fields, {
                    Ul: $elm$core$String$toInt(string)
                });
            case 7:
                var string = field.a;
                return _Utils_update(fields, {
                    TM: $elm$core$String$toInt(string)
                });
            case 8:
                var index = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    _N: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields._N)
                });
            case 9:
                var index = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    Tq: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields.Tq)
                });
            case 11:
                return _Utils_update(fields, {
                    Tq: _Utils_ap(fields.Tq, _List_fromArray([
                        ''
                    ]))
                });
            case 12:
                var index = field.a;
                return _Utils_update(fields, {
                    Tq: A2($elm_community$list_extra$List$Extra$removeAt, index, fields.Tq)
                });
            case 10:
                return _Utils_update(fields, {
                    _N: _Utils_ap(fields._N, _List_fromArray([
                        ''
                    ]))
                });
            case 13:
                var index = field.a;
                return _Utils_update(fields, {
                    _N: A2($elm_community$list_extra$List$Extra$removeAt, index, fields._N)
                });
            case 14:
                var index = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    Ov: A3($elm_community$list_extra$List$Extra$setAt, index, string, fields.Ov)
                });
            case 15:
                return _Utils_update(fields, {
                    Ov: _Utils_ap(fields.Ov, _List_fromArray([
                        ''
                    ]))
                });
            case 16:
                var index = field.a;
                return _Utils_update(fields, {
                    Ov: A2($elm_community$list_extra$List$Extra$removeAt, index, fields.Ov)
                });
            case 17:
                var string = field.a;
                return _Utils_update(fields, {
                    OA: $author$project$Utils$String$toMaybe(string)
                });
            case 18:
                var string = field.a;
                var panelSizeLimit = $elm$core$String$toInt(string);
                var onlineSignupVisibility = function() {
                    var _v1 = _Utils_Tuple3(fields.JU, fields.VS, panelSizeLimit);
                    if (_v1.a && !_v1.b.$ && !_v1.c.$) {
                        var panelSize = _v1.b.a;
                        var panelSizeLimit_ = _v1.c.a;
                        return _Utils_cmp(panelSize, panelSizeLimit_) < 0;
                    } else return fields.Vv;
                }();
                return _Utils_update(fields, {
                    Vv: onlineSignupVisibility,
                    VT: panelSizeLimit
                });
            case 19:
                var bool = field.a;
                var onlineSignupVisibility = function() {
                    var _v2 = _Utils_Tuple2(fields.VS, fields.VT);
                    if (!_v2.a.$ && !_v2.b.$) {
                        var panelSize = _v2.a.a;
                        var panelSizeLimit = _v2.b.a;
                        return _Utils_cmp(panelSize, panelSizeLimit) < 0;
                    } else return fields.Vv;
                }();
                return _Utils_update(fields, {
                    JU: bool,
                    Vv: onlineSignupVisibility
                });
            case 20:
                var string = field.a;
                return _Utils_update(fields, {
                    U9: $author$project$Utils$String$toMaybe(string)
                });
            case 21:
                var bool = field.a;
                return _Utils_update(fields, {
                    Vv: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    Sl: !bool
                });
        }
    });
    var $author$project$Pages$Admin$Providers$Top$NameValidation = 0;
    var $author$project$Pages$Admin$Providers$Top$PhotoValidation = 2;
    var $author$project$Pages$Admin$Providers$Top$maxPhotoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Pages$Admin$Providers$Top$LocationsValidation = 3;
    var $author$project$Pages$Admin$Providers$Top$validateLocations = function(fields) {
        return _Utils_eq(fields.Tq, _List_fromArray([
            ''
        ])) ? _List_fromArray([
            _Utils_Tuple2(3, 'Please enter at least one location.')
        ]) : _List_Nil;
    };
    var $author$project$Pages$Admin$Providers$Top$NpiValidation = 1;
    var $author$project$Utils$MetaFields$alwaysEditable = $author$project$Utils$MetaFields$Editable;
    var $author$project$Utils$MetaFields$isEditable = function(editable) {
        if (!editable.$) return true;
        else return false;
    };
    var $author$project$Utils$MetaFields$isUneditable = A2($elm$core$Basics$composeR, $author$project$Utils$MetaFields$isEditable, $elm$core$Basics$not);
    var $ahstro$elm_luhn$Helpers$checksum = F2(function(checkDigit, sum) {
        return !A2($elm$core$Basics$modBy, 10, sum + checkDigit) ? $elm$core$Result$Ok(true) : $elm$core$Result$Err('Incorrect checksum');
    });
    var $ahstro$elm_luhn$Helpers$doubleAtEvenIndices = $elm$core$List$indexedMap(F2(function(index, num) {
        return !A2($elm$core$Basics$modBy, 2, index) ? num * 2 : num;
    }));
    var $ahstro$elm_luhn$Helpers$keepUnder10 = function(num) {
        return num >= 10 ? num - 9 : num;
    };
    var $ahstro$elm_luhn$Helpers$notEmpty = function(nums) {
        return $elm$core$List$isEmpty(nums) ? $elm$core$Result$Err('Input string is only check digit') : $elm$core$Result$Ok(nums);
    };
    var $ahstro$elm_luhn$Helpers$toListOfInt = function(strings) {
        return A3($elm$core$List$foldl, F2(function(numberString, acc) {
            var _v0 = $elm$core$String$toInt(numberString);
            if (!_v0.$) {
                var num = _v0.a;
                return A2($elm$core$Result$map, $elm$core$List$cons(num), acc);
            } else return $elm$core$Result$Err('Not a number: ' + numberString);
        }), $elm$core$Result$Ok(_List_Nil), $elm$core$List$reverse(strings));
    };
    var $ahstro$elm_luhn$Luhn$validate = function(numberString) {
        var numbers = $ahstro$elm_luhn$Helpers$toListOfInt($elm$core$List$reverse(A2($elm$core$String$split, '', numberString)));
        var checkDigit = A2($elm$core$Result$withDefault, 0, A2($elm$core$Result$andThen, A2($elm$core$Basics$composeL, $elm$core$Result$fromMaybe('Input string is empty'), $elm$core$List$head), numbers));
        return A2($elm$core$Result$map, function(_v0) {
            return numberString;
        }, A2($elm$core$Result$andThen, $ahstro$elm_luhn$Helpers$checksum(checkDigit), A2($elm$core$Result$map, $elm$core$List$sum, A2($elm$core$Result$map, $elm$core$List$map($ahstro$elm_luhn$Helpers$keepUnder10), A2($elm$core$Result$map, $ahstro$elm_luhn$Helpers$doubleAtEvenIndices, A2($elm$core$Result$andThen, $ahstro$elm_luhn$Helpers$notEmpty, A2($elm$core$Result$andThen, A2($elm$core$Basics$composeL, $elm$core$Result$fromMaybe('Input string is empty'), $elm$core$List$tail), numbers)))))));
    };
    var $ahstro$elm_luhn$Luhn$isValid = function(numberString) {
        var _v0 = $ahstro$elm_luhn$Luhn$validate(numberString);
        if (!_v0.$) return true;
        else return false;
    };
    var $author$project$Api$Provider$Practitioner$Meta$npi = function(_v0) {
        var fields = _v0;
        return fields.U9;
    };
    var $author$project$Pages$Admin$Providers$Top$validateNpi = function(fields) {
        var npiValidationMessage = _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a valid npi.')
        ]);
        var editable = A2($elm$core$Maybe$withDefault, $author$project$Utils$MetaFields$alwaysEditable, A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Meta$npi, fields.Ue));
        var _v0 = _Utils_Tuple2(fields.U9, $author$project$Utils$MetaFields$isUneditable(editable));
        if (!_v0.b) {
            if (!_v0.a.$) {
                var npi = _v0.a.a;
                return $elm$core$String$length(npi) === 10 && $ahstro$elm_luhn$Luhn$isValid('80840' + npi) ? _List_Nil : npiValidationMessage;
            } else {
                var _v1 = _v0.a;
                return fields.Sl ? npiValidationMessage : _List_Nil;
            }
        } else return _List_Nil;
    };
    var $author$project$Pages$Admin$Providers$Top$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Providers$Top$validateNpi),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Admin$Providers$Top$validateLocations),
        A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
            return $.r6;
        }, $author$project$Pages$Admin$Providers$Top$maxPhotoBytesSize, _Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
    ]));
    var $author$project$Pages$Admin$Providers$Top$hasMoreThanOnePracticeProvider = F2(function(model, practitioners) {
        var _v0 = model.sc;
        if (!_v0.$) {
            var count = _v0.a;
            return count > 1;
        } else return $elm$core$List$length(practitioners) > 1;
    });
    var $author$project$Api$Provider$Practitioner$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Practitioner$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$id(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$isSynced = function(_v0) {
        var record = _v0;
        return record.Su;
    };
    var $author$project$Api$Provider$Practitioner$All$isSynced = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$isSynced(shared);
    };
    var $author$project$Api$Provider$Practitioner$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Practitioner$Shared$name(shared);
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$Reassign = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Practitioner$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$Practitioner$list = $author$project$Api$Provider$Practitioner$list;
    var $author$project$Api$Provider$Practitioner$Shared$affiliation = function(_v0) {
        var record = _v0;
        return record.IY;
    };
    var $author$project$Api$Provider$Practitioner$All$affiliation = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$affiliation(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$isMaster = function(_v0) {
        var record = _v0;
        return record.R8;
    };
    var $author$project$Api$Provider$Practitioner$All$isMaster = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$isMaster(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$openingsSize = function(_v0) {
        var record = _v0;
        return record.Vy;
    };
    var $author$project$Api$Provider$Practitioner$All$openingsSize = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$openingsSize(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$practiceName = function(_v0) {
        var record = _v0;
        return record.agg;
    };
    var $author$project$Api$Provider$Practitioner$All$practiceName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$practiceName(shared);
    };
    var $author$project$Api$Provider$Practitioner$Shared$practitionerType = function(_v0) {
        var record = _v0;
        return record.Xb;
    };
    var $author$project$Api$Provider$Practitioner$All$practitionerType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practitioner$Shared$practitionerType(shared);
    };
    var $author$project$Components$ResourceFilter$Practitioner$resourceFromAll = function(practitioner) {
        return {
            IY: A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Provider, $author$project$Api$Provider$Practitioner$All$affiliation(practitioner)),
            aef: $author$project$Api$Provider$Practitioner$All$id(practitioner),
            R8: $author$project$Api$Provider$Practitioner$All$isMaster(practitioner),
            Su: $author$project$Api$Provider$Practitioner$All$isSynced(practitioner),
            zr: $author$project$Api$Provider$Practitioner$All$name(practitioner),
            Vy: $author$project$Api$Provider$Practitioner$All$openingsSize(practitioner),
            agg: $author$project$Api$Provider$Practitioner$All$practiceName(practitioner),
            Xb: $author$project$Api$Provider$Practitioner$All$practitionerType(practitioner)
        };
    };
    var $author$project$Components$ResourceFilter$Practitioner$fetchResources = F5(function(listOptionals, toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Practitioner$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$Practitioner$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$Practitioner$retrieveResource = F4(function(listOptionals, toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Practitioner$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$Practitioner$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$Practitioner$selectId = 'practitioners';
    var $author$project$Components$ResourceFilter$Practitioner$openings = function(resource) {
        var _v0 = resource.Vy;
        if (!_v0.$) {
            if (!_v0.a) return 'Full';
            else {
                var size = _v0.a;
                return A2($author$project$Formatters$String$pluralize, 'opening', size);
            }
        } else return 'No panel limit';
    };
    var $author$project$Components$ResourceFilter$Practitioner$panelLimit = function(resource) {
        var _v0 = resource.Vy;
        if (!_v0.$) {
            if (!_v0.a) return 'No Slots';
            else {
                var size = _v0.a;
                return $elm$core$String$fromInt(size) + ' Slots';
            }
        } else return 'No limit';
    };
    var $author$project$Components$ResourceFilter$Practitioner$extraText = function(resource) {
        var practitionerType_ = resource.Xb;
        var practiceName_ = resource.agg;
        return $elm$core$String$isEmpty(practiceName_) && $elm$core$String$isEmpty(practitionerType_) ? $elm$core$Maybe$Just($author$project$Components$ResourceFilter$Practitioner$openings(resource)) : $elm$core$Maybe$Just(practitionerType_ + (' | ' + (A2($elm$core$String$left, 50, practiceName_) + (' [ ' + ($author$project$Components$ResourceFilter$Practitioner$panelLimit(resource) + ' ]')))));
    };
    var $author$project$Components$ResourceFilter$Practitioner$toTitle = function($) {
        return $.zr;
    };
    var $author$project$Components$ResourceFilter$Practitioner$toLabel = function(resource) {
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$spaceX2
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceX2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Components$ResourceFilter$Practitioner$toTitle(resource))
                    ])),
                    resource.R8 ? $author$project$Components$SyncedIcon$view(_List_fromArray([
                        $author$project$Components$SyncedIcon$master,
                        $author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
                    ])) : $elm$html$Html$text(''),
                    resource.Su ? $author$project$Components$SyncedIcon$view(_List_fromArray([
                        $author$project$Components$SyncedIcon$synced,
                        $author$project$Components$SyncedIcon$status($elm$core$Maybe$Nothing)
                    ])) : $elm$html$Html$text('')
                ])),
                A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function(info) {
                    return A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(info)
                    ]));
                }, $author$project$Components$ResourceFilter$Practitioner$extraText(resource)))
            ]))
        ]);
    };
    var $author$project$Components$ResourceFilter$Practitioner$toValue = function($) {
        return $.aef;
    };
    var $author$project$Components$ResourceFilter$Practitioner$init = F3(function(apiClient, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Practitioner$fetchResources(listOptionals),
            aef: $author$project$Components$ResourceFilter$Practitioner$selectId,
            gD: 'Provider',
            sz: $author$project$Components$ResourceFilter$Practitioner$retrieveResource(listOptionals),
            ahW: $author$project$Components$ResourceFilter$Practitioner$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Practitioner$toTitle,
            g4: $author$project$Components$ResourceFilter$Practitioner$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Admin$Practitioner$DeleteModal$open = F4(function(apiClient, practitioner, hasSyncedPatients, hasMoreThanOnePractitioner) {
        var action = $author$project$Components$Admin$Practitioner$DeleteModal$Reassign($elm$core$Maybe$Nothing);
        var _v0 = A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Choose a practitioner...',
                adw: $elm$core$Maybe$Just($author$project$Api$Provider$Practitioner$All$id(practitioner))
            });
        });
        var practitionerResourceFilter = _v0.a;
        var practitionerResourceFilterCmd = _v0.b;
        var localState = {
            D7: action,
            xV: hasMoreThanOnePractitioner,
            FJ: hasSyncedPatients,
            agi: practitioner,
            jE: practitionerResourceFilter,
            su: $author$project$Api$Data$NotAsked
        };
        return _Utils_Tuple2($author$project$Components$Admin$Practitioner$DeleteModal$Open(localState), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd));
    });
    var $author$project$Pages$Admin$Providers$Top$Created = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Provider$Practitioner$One$Practitioner = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practitioner$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practitioner$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Gender$toString = function(gender) {
        switch(gender){
            case 0:
                return 'male';
            case 1:
                return 'female';
            case 2:
                return 'intersex';
            default:
                return 'other';
        }
    };
    var $author$project$Api$Gender$encode = function(gender) {
        return A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$Gender$toString)(gender);
    };
    var $author$project$Api$Provider$Practitioner$create = F3(function(apiClient, fields, toMsg) {
        var photo_ = function() {
            var _v1 = fields.WH;
            if (!_v1.$) {
                var base64 = _v1.a;
                return _List_fromArray([
                    _Utils_Tuple2('photo', $elm$json$Json$Encode$string(base64))
                ]);
            } else return _List_Nil;
        }();
        var npi_ = function() {
            var _v0 = fields.U9;
            if (!_v0.$) {
                var number = _v0.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('number', $elm$json$Json$Encode$string(number))
                ]));
            } else return $elm$json$Json$Encode$null;
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practitioner', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('accepts_enrollments_from_employer', $elm$json$Json$Encode$bool(fields.pj)), A2($elm$core$List$cons, _Utils_Tuple2('accepts_enrollments_from_retail', $elm$json$Json$Encode$bool(fields.pk)), A2($elm$core$List$cons, _Utils_Tuple2('min_patient_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Ul)), A2($elm$core$List$cons, _Utils_Tuple2('max_patient_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.TM)), A2($elm$core$List$cons, _Utils_Tuple2('panel_size_limit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.VT)), A2($elm$core$List$cons, _Utils_Tuple2('auto_determine_online_signup_visibility_from_panel_size', $elm$json$Json$Encode$bool(fields.JU)), A2($elm$core$List$cons, _Utils_Tuple2('elation_physician_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OA)), A2($elm$core$List$cons, _Utils_Tuple2('email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OH)), A2($elm$core$List$cons, _Utils_Tuple2('bio', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Kj)), A2($elm$core$List$cons, _Utils_Tuple2('gender', A2($author$project$Utils$Encode$nullable, $author$project$Api$Gender$encode, fields.P5)), A2($elm$core$List$cons, _Utils_Tuple2('gender_other', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.P7)), A2($elm$core$List$cons, _Utils_Tuple2('education', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.Ov)), A2($elm$core$List$cons, _Utils_Tuple2('specialties', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields._N)), A2($elm$core$List$cons, _Utils_Tuple2('locations', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Tq)), A2($elm$core$List$cons, _Utils_Tuple2('npi', npi_), A2($elm$core$List$cons, _Utils_Tuple2('online_signup_visibility', $elm$json$Json$Encode$bool(fields.Vv)), A2($elm$core$List$cons, _Utils_Tuple2('is_provider', $elm$json$Json$Encode$bool(fields.Sl)), photo_))))))))))))))))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practitioner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$practitionersPath)));
    });
    var $author$project$Pages$Admin$Providers$Top$practitionerFromFields = function(fields) {
        return {
            pj: fields.pj,
            pk: fields.pk,
            JU: fields.JU,
            Kj: fields.Kj,
            Ov: fields.Ov,
            OA: fields.OA,
            OH: fields.OH,
            P5: fields.P5,
            P7: fields.P7,
            Sl: fields.Sl,
            Tq: fields.Tq,
            TM: fields.TM,
            Ul: fields.Ul,
            zr: fields.zr,
            U9: fields.Sl ? fields.U9 : $elm$core$Maybe$Nothing,
            Vv: fields.Vv,
            VT: fields.VT,
            WH: fields.WI,
            _N: fields._N
        };
    };
    var $author$project$Pages$Admin$Providers$Top$createItem = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Practitioner$create, apiClient, $author$project$Pages$Admin$Providers$Top$practitionerFromFields(fields), $author$project$Pages$Admin$Providers$Top$Created);
    });
    var $author$project$Pages$Admin$Providers$Top$Updated = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Api$Provider$Practitioner$update = F4(function(apiClient, id_, fields, toMsg) {
        var photo_ = function() {
            var _v1 = fields.WH;
            if (!_v1.$) {
                var base64 = _v1.a;
                return _List_fromArray([
                    _Utils_Tuple2('photo', $elm$json$Json$Encode$string(base64))
                ]);
            } else return _List_Nil;
        }();
        var npi_ = function() {
            var _v0 = fields.U9;
            if (!_v0.$) {
                var number = _v0.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('number', $elm$json$Json$Encode$string(number))
                ]));
            } else return $elm$json$Json$Encode$null;
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practitioner', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('accepts_enrollments_from_employer', $elm$json$Json$Encode$bool(fields.pj)), A2($elm$core$List$cons, _Utils_Tuple2('accepts_enrollments_from_retail', $elm$json$Json$Encode$bool(fields.pk)), A2($elm$core$List$cons, _Utils_Tuple2('min_patient_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Ul)), A2($elm$core$List$cons, _Utils_Tuple2('max_patient_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.TM)), A2($elm$core$List$cons, _Utils_Tuple2('panel_size_limit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.VT)), A2($elm$core$List$cons, _Utils_Tuple2('auto_determine_online_signup_visibility_from_panel_size', $elm$json$Json$Encode$bool(fields.JU)), A2($elm$core$List$cons, _Utils_Tuple2('elation_physician_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OA)), A2($elm$core$List$cons, _Utils_Tuple2('email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OH)), A2($elm$core$List$cons, _Utils_Tuple2('bio', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Kj)), A2($elm$core$List$cons, _Utils_Tuple2('gender', A2($author$project$Utils$Encode$nullable, $author$project$Api$Gender$encode, fields.P5)), A2($elm$core$List$cons, _Utils_Tuple2('gender_other', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.P7)), A2($elm$core$List$cons, _Utils_Tuple2('education', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.Ov)), A2($elm$core$List$cons, _Utils_Tuple2('specialties', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields._N)), A2($elm$core$List$cons, _Utils_Tuple2('locations', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Tq)), A2($elm$core$List$cons, _Utils_Tuple2('npi', npi_), A2($elm$core$List$cons, _Utils_Tuple2('online_signup_visibility', $elm$json$Json$Encode$bool(fields.Vv)), A2($elm$core$List$cons, _Utils_Tuple2('is_provider', $elm$json$Json$Encode$bool(fields.Sl)), photo_))))))))))))))))))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practitioner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practitioner$practitionerPath(id_))));
    });
    var $author$project$Pages$Admin$Providers$Top$updateItem = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Practitioner$update, apiClient, id, $author$project$Pages$Admin$Providers$Top$practitionerFromFields(fields), $author$project$Pages$Admin$Providers$Top$Updated);
    });
    var $author$project$Pages$Admin$Providers$Top$saveItem = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Pages$Admin$Providers$Top$updateItem, apiClient, id_, formFields);
        } else return A2($author$project$Pages$Admin$Providers$Top$createItem, apiClient, formFields);
    });
    var $author$project$Components$Admin$Practitioner$DeleteModal$Deleted = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Practitioner$DeleteModal$None = 0;
    var $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerDeleted = 1;
    var $author$project$Components$Admin$Practitioner$DeleteModal$isValid = function(action) {
        if (!action.$) {
            var practitionerId = action.a;
            return $author$project$Utils$Maybe$toBool(practitionerId);
        } else return true;
    };
    var $author$project$Components$ResourceFilter$Practitioner$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Admin$Practitioner$DeleteModal$update = F3(function(apiClient, msg, modal) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    bc: $author$project$Components$Admin$Practitioner$DeleteModal$Closed,
                    at: _List_Nil
                };
            case 2:
                var action = msg.a;
                if (modal.$ === 1) {
                    var state = modal.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        bc: $author$project$Components$Admin$Practitioner$DeleteModal$Open(_Utils_update(state, {
                            D7: action,
                            su: $author$project$Api$Data$NotAsked
                        })),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    bc: $author$project$Components$Admin$Practitioner$DeleteModal$Closed,
                    at: _List_Nil
                };
            case 1:
                if (modal.$ === 1) {
                    var state = modal.a;
                    if ($author$project$Components$Admin$Practitioner$DeleteModal$isValid(state.D7)) {
                        var newPractitionerId = function() {
                            var _v3 = state.D7;
                            if (!_v3.$) {
                                var practitionerId = _v3.a;
                                return practitionerId;
                            } else return $elm$core$Maybe$Nothing;
                        }();
                        return {
                            EQ: A4($author$project$Api$Provider$Practitioner$delete, apiClient, $author$project$Api$Provider$Practitioner$All$id(state.agi), newPractitionerId, $author$project$Components$Admin$Practitioner$DeleteModal$Deleted(newPractitionerId)),
                            adu: 0,
                            bc: $author$project$Components$Admin$Practitioner$DeleteModal$Open(_Utils_update(state, {
                                su: $author$project$Api$Data$Loading
                            })),
                            at: _List_Nil
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        bc: $author$project$Components$Admin$Practitioner$DeleteModal$Open(_Utils_update(state, {
                            su: $author$project$Api$Data$NotAsked
                        })),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    bc: $author$project$Components$Admin$Practitioner$DeleteModal$Closed,
                    at: _List_Nil
                };
            case 3:
                var newPractitionerId = msg.a;
                var response = msg.b;
                if (modal.$ === 1) {
                    var state = modal.a;
                    switch(response.$){
                        case 3:
                            var message = function() {
                                if (!newPractitionerId.$) {
                                    var newPractitionerName = function() {
                                        var _v7 = state.jE.Hg;
                                        if (!_v7.$) {
                                            var resource = _v7.a;
                                            return resource.zr;
                                        } else return 'the selected provider';
                                    }();
                                    return $elm$core$String$concat(_List_fromArray([
                                        ' All patients currently assigned to ',
                                        $author$project$Api$Provider$Practitioner$All$name(state.agi),
                                        ' will be assigned to ',
                                        newPractitionerName,
                                        '.',
                                        'For large volumes of patients, this may take a few minutes behind the scenes.'
                                    ]));
                                } else return '';
                            }();
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                bc: $author$project$Components$Admin$Practitioner$DeleteModal$Closed,
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Practitioner$All$name(state.agi) + (' was successfully removed.' + message)),
                                    $author$project$OutMsg$RefreshPractice
                                ])
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                bc: $author$project$Components$Admin$Practitioner$DeleteModal$Open(_Utils_update(state, {
                                    su: response
                                })),
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                bc: modal,
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    bc: $author$project$Components$Admin$Practitioner$DeleteModal$Closed,
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                if (modal.$ === 1) {
                    var state = modal.a;
                    var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, state.jE);
                    var newAction = function() {
                        var _v9 = practitionerResourceResult.adu;
                        _v9$2: while(true){
                            if (!_v9.$ && !_v9.a.$) switch(_v9.a.a.$){
                                case 0:
                                    var resource = _v9.a.a.a;
                                    return $author$project$Components$Admin$Practitioner$DeleteModal$Reassign($elm$core$Maybe$Just(resource.aef));
                                case 2:
                                    var _v10 = _v9.a.a;
                                    return state.D7;
                                default:
                                    break _v9$2;
                            }
                            else break _v9$2;
                        }
                        return state.D7;
                    }();
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg, practitionerResourceResult.EQ),
                        adu: 0,
                        bc: $author$project$Components$Admin$Practitioner$DeleteModal$Open(_Utils_update(state, {
                            D7: newAction,
                            jE: practitionerResourceResult.zi
                        })),
                        at: practitionerResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    bc: $author$project$Components$Admin$Practitioner$DeleteModal$Closed,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Api$Provider$PracticeSettings$updateShowNpi = F3(function(apiClient, showNpi_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_settings', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('show_npi', $elm$json$Json$Encode$bool(showNpi_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$PracticeSettings$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeSettings$practiceSettingsPath)));
    });
    var $author$project$Pages$Admin$Providers$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            model.aaT.V6
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Pages$Admin$Providers$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        i$: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    i$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var response = msg.a;
                var practiceProviderCount = function() {
                    if (response.$ === 3) {
                        var practitioners = response.a;
                        var headers = response.b;
                        return $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, $elm$core$List$length(practitioners), A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers))));
                    } else return model.sc;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    sc: practiceProviderCount
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 2:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tq: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 3:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    _N: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 4:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    xq: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 5:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    sd: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 6:
                var formFields = $author$project$Pages$Admin$Providers$Top$formFieldsInit;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var item = msg.a;
                var formFields = $author$project$Pages$Admin$Providers$Top$formFieldsFromItem(item);
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$Practitioner$All$id(item)), $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var photos = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v3) {
                    var task = _v3.a;
                    var size = _v3.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Photo(size)), task);
                }, A2($elm$core$Maybe$map, function(photo) {
                    return _Utils_Tuple2($elm$file$File$toUrl(photo), $elm$file$File$size(photo));
                }, $elm$core$List$head(photos))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 10:
                var field = msg.a;
                var _v4 = model.F6;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var id = _v5.a;
                    var form = _v5.b;
                    var item = _v5.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Providers$Top$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, item))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var form = msg.a;
                var id = msg.b;
                var _v6 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Providers$Top$formFieldsValidator, form);
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var validatedForm = _v7.a;
                    var validFormFields = _v7.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Admin$Providers$Top$saveItem, model.Ej, id, validFormFields), _List_Nil);
                } else {
                    var validatedForm = _v6.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, validatedForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 11:
                var item = msg.a;
                var practitioners = msg.b;
                var hasMoreThanOnePractitioner = A2($author$project$Pages$Admin$Providers$Top$hasMoreThanOnePracticeProvider, model, practitioners);
                if (!hasMoreThanOnePractitioner && !!$author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(model.W1)) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 1, 'Practice collects practitioners during signup. Can\'t delete last one.')
                ]));
                else {
                    if ($author$project$Api$Provider$Practitioner$All$isSynced(item)) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 2, 'This provider is currently part of an affiliation. Please contact Hint to unlink this provider prior to deletion.')
                    ]));
                    else {
                        var fields = $author$project$Pages$Admin$Providers$Top$formFieldsFromItem(item);
                        var hasSyncedPatients = fields.$J > 0;
                        var _v8 = A4($author$project$Components$Admin$Practitioner$DeleteModal$open, model.Ej, item, hasSyncedPatients, hasMoreThanOnePractitioner);
                        var deleteModal = _v8.a;
                        var deleteModalCmd = _v8.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ia: deleteModal
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$DeleteModalMsg, deleteModalCmd), _List_Nil);
                    }
                }
            case 13:
                var response = msg.a;
                var _v9 = model.F6;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) {
                        var item = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            F6: $elm$core$Maybe$Nothing,
                            i$: $author$project$Api$Data$Loading
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$Providers$Top$fetchList(model),
                            $author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
                        ])), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$Practitioner$One$name(item)),
                            $author$project$OutMsg$RefreshPractice
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var response = msg.a;
                var _v12 = model.F6;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var id = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) {
                        var item = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            F6: $elm$core$Maybe$Nothing,
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$Providers$Top$fetchList(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Practitioner$One$name(item) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var item = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Provider$Practitioner$All$id(item), model.dS),
                            i$: $author$project$Api$Data$Loading
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$Providers$Top$fetchList(model),
                            $author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
                        ])), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Practitioner$All$name(item) + ' was successfully removed.'),
                            $author$project$OutMsg$RefreshPractice
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Provider$Practitioner$All$id(item), model.dS)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 19:
                var item = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aW: $elm$core$Maybe$Just(_Utils_Tuple3(item, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 20:
                var string = msg.a;
                var _v16 = model.aW;
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var item = _v17.a;
                    var request = _v17.c;
                    var locationId = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
                    return _Utils_Tuple3(_Utils_update(model, {
                        aW: $elm$core$Maybe$Just(_Utils_Tuple3(item, locationId, request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 21:
                var _v18 = model.aW;
                if (!_v18.$ && !_v18.a.b.$) {
                    var _v19 = _v18.a;
                    var item = _v19.a;
                    var locationId = _v19.b.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aW: $elm$core$Maybe$Just(_Utils_Tuple3(item, $elm$core$Maybe$Just(locationId), $author$project$Api$Data$Loading))
                    }), A4($author$project$Api$Provider$Practitioner$Location$create, model.Ej, $author$project$Api$Provider$Practitioner$All$id(item), locationId, $author$project$Pages$Admin$Providers$Top$LocationAdded), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 22:
                var response = msg.a;
                var _v20 = model.aW;
                if (!_v20.$ && !_v20.a.b.$) {
                    var _v21 = _v20.a;
                    var item = _v21.a;
                    var locationId = _v21.b.a;
                    switch(response.$){
                        case 3:
                            var location1 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                aW: $elm$core$Maybe$Nothing,
                                i$: $author$project$Api$Data$Loading
                            }), $author$project$Pages$Admin$Providers$Top$fetchList(model), _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Location$One$name(location1) + (' was successfully added to ' + ($author$project$Api$Provider$Practitioner$All$name(item) + '.')))
                            ]));
                        case 2:
                            return _Utils_Tuple3(_Utils_update(model, {
                                aW: $elm$core$Maybe$Just(_Utils_Tuple3(item, $elm$core$Maybe$Just(locationId), response))
                            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                        default:
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 23:
                return _Utils_Tuple3(_Utils_update(model, {
                    aW: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var item = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$Practitioner$All$id(item);
                    return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Nothing,
                        dS: A2($elm$core$Set$insert, id, model.dS)
                    }), A4($author$project$Api$Provider$Practitioner$delete, model.Ej, id, $elm$core$Maybe$Nothing, $author$project$Pages$Admin$Providers$Top$Deleted(item)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var subMsg = msg.a;
                var _v23 = A3($author$project$Components$LinkedRecords$update, model.Ej, subMsg, model.mV);
                var linkedRecords = _v23.a;
                var subCmd = _v23.b;
                var subOutMsg = _v23.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    mV: linkedRecords
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg, subCmd), subOutMsg);
            case 18:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Admin$Practitioner$DeleteModal$update, model.Ej, subMsg, model.ia);
                var _v24 = function() {
                    var _v25 = result.adu;
                    if (_v25 === 1) return _Utils_Tuple2(_Utils_update(model, {
                        i$: $author$project$Api$Data$Loading
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Pages$Admin$Providers$Top$fetchList(model),
                        $author$project$Pages$Admin$Providers$Top$fetchPracticeProviderCount(model)
                    ])));
                    else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v24.a;
                var cmd = _v24.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    ia: result.bc
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$DeleteModalMsg, result.EQ)
                ])), result.at);
            case 24:
                var bool = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$PracticeSettings$updateShowNpi, model.Ej, bool, $author$project$Pages$Admin$Providers$Top$PracticeSettingsUpdated), _List_Nil);
            case 25:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    i$: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$Providers$Top$fetchList(newModel),
                    $author$project$Pages$Admin$Providers$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 26:
                var subMsg = msg.a;
                var _v26 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v26.a;
                var searchInputCmd = _v26.b;
                var searchInputEvent = _v26.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v27 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            i$: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$Providers$Top$fetchList(qModel),
                            $author$project$Pages$Admin$Providers$Top$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v27.a;
                var cmd = _v27.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Providers$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var newModel = _Utils_update(model, {
                        sd: response
                    });
                    var message = 'Your practice has been updated';
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, message)
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Admin$Providers$Top$New = {
        $: 6
    };
    var $author$project$Pages$Admin$Providers$Top$PaginationMsg = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$Delete = {
        $: 1
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment = {
        $: 1
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Practitioner$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$ResourceFilter$Practitioner$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Admin$Practitioner$DeleteModal$viewModal = function(state) {
        var action = state.xV ? state.D7 : $author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment;
        var _v0 = function() {
            if (!action.$) return _Utils_Tuple2(true, false);
            else return _Utils_Tuple2(false, true);
        }();
        var reassignActive = _v0.a;
        var removeAssignmentActive = _v0.b;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$Practitioner$DeleteModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('What would you like to do with patients assigned to this provider?')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Action'),
                    $author$project$Ui$Form$Group$labelSpan(2),
                    $author$project$Ui$Form$Group$inputSpan(10)
                ]), _List_fromArray([
                    $author$project$Ui$Button$group(_List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Reassign to a different provider'
                        }, _List_fromArray([
                            $author$project$Ui$Button$active(reassignActive),
                            $author$project$Ui$Button$disabled(!state.xV),
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction($author$project$Components$Admin$Practitioner$DeleteModal$Reassign($elm$core$Maybe$Nothing)))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Reassign')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Remove assignment'
                        }, _List_fromArray([
                            $author$project$Ui$Button$active(removeAssignmentActive),
                            $author$project$Ui$Button$disabled(state.FJ),
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$Practitioner$DeleteModal$UpdateAction($author$project$Components$Admin$Practitioner$DeleteModal$RemoveAssignment))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Remove assignment')
                        ]))
                    ])),
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pt-05')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            function() {
                                if (!action.$) return $elm$html$Html$text('All patients currently assigned to ' + ($author$project$Api$Provider$Practitioner$All$name(state.agi) + ' will be assigned to the provider selected below'));
                                else return $elm$html$Html$text('All patients currently assigned to ' + ($author$project$Api$Provider$Practitioner$All$name(state.agi) + ' will no longer be assigned to a provider'));
                            }()
                        ]))
                    ])),
                    function() {
                        if (!action.$) {
                            var invalidPractitioner = function() {
                                var _v4 = $author$project$Components$ResourceFilter$Practitioner$value(state.jE);
                                if (!_v4.$) return false;
                                else return true;
                            }();
                            return A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('pt-05')
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Components$Admin$Practitioner$DeleteModal$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$view, _List_fromArray([
                                    invalidPractitioner ? $author$project$Components$ResourceFilter$errors(_List_fromArray([
                                        'Please pick a provider for reassignment'
                                    ])) : $author$project$Components$ResourceFilter$errors(_List_Nil)
                                ]), state.jE))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Practitioner$DeleteModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete provider'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(state.su, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Practitioner$DeleteModal$Delete),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$Practitioner$DeleteModal$view = function(modal) {
        if (modal.$ === 1) {
            var state = modal.a;
            return $author$project$Components$Admin$Practitioner$DeleteModal$viewModal(state);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Admin$Providers$Top$LocationSelected = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$SaveLocation = {
        $: 21
    };
    var $author$project$Pages$Admin$Providers$Top$locationOptions = F2(function(practitioner, locations) {
        var practitionerLocationIds = A2($elm$core$List$map, $author$project$Api$Provider$Location$Shared$id, A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$Practitioner$All$locations(practitioner)));
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Pick a location'), A2($elm$core$List$map, function(location1) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Location$All$id(location1)), $author$project$Api$Provider$Location$All$name(location1));
        }, A2($elm_community$list_extra$List$Extra$filterNot, function(location1) {
            return A2($elm$core$List$member, $author$project$Api$Provider$Location$All$id(location1), practitionerLocationIds);
        }, locations)));
    });
    var $author$project$Pages$Admin$Providers$Top$viewAddLocationModal = F4(function(model, item, locationId, request) {
        var _v0 = function() {
            var _v1 = model.Tq;
            if (_v1.$ === 3) {
                var locations_ = _v1.a;
                return _Utils_Tuple2(false, locations_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var locationLoading = _v0.a;
        var locations = _v0.b;
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Admin$Providers$Top$CancelAddLocation, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add location to ' + $author$project$Api$Provider$Practitioner$All$name(item))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    if ($elm$core$List$isEmpty(locations)) return A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You have no locations, '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Locations, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('add them here first')
                        ]))
                    ]));
                    else {
                        var invalid = !$author$project$Utils$Maybe$toBool(locationId);
                        return A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value(locationId),
                            $author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$Providers$Top$LocationSelected),
                            $author$project$Ui$Form$Select$invalid(invalid),
                            $author$project$Ui$Form$Select$loading(locationLoading)
                        ]), A2($author$project$Pages$Admin$Providers$Top$locationOptions, item, locations));
                    }
                }()
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$CancelAddLocation)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add location'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$SaveLocation),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$Save = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Practitioner$Meta$bio = function(_v0) {
        var fields = _v0;
        return fields.Kj;
    };
    var $author$project$Api$Provider$Practitioner$Meta$education = function(_v0) {
        var fields = _v0;
        return fields.Ov;
    };
    var $author$project$Api$Provider$Practice$Shared$elationEnabled = function(_v0) {
        var record = _v0;
        return record.Oz;
    };
    var $author$project$Api$Provider$Practice$One$elationEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$elationEnabled(shared);
    };
    var $author$project$Api$Provider$Practitioner$Meta$email = function(_v0) {
        var fields = _v0;
        return fields.OH;
    };
    var $author$project$Api$Provider$Practitioner$Meta$gender = function(_v0) {
        var fields = _v0;
        return fields.P5;
    };
    var $author$project$Api$Provider$Practitioner$Meta$locations = function(_v0) {
        var fields = _v0;
        return fields.Tq;
    };
    var $author$project$Api$Provider$Practitioner$Meta$name = function(_v0) {
        var fields = _v0;
        return fields.zr;
    };
    var $author$project$Api$Provider$Practitioner$Meta$panelSizeLimit = function(_v0) {
        var fields = _v0;
        return fields.VT;
    };
    var $author$project$Api$Provider$Practitioner$Meta$photo = function(_v0) {
        var fields = _v0;
        return fields.WH;
    };
    var $author$project$Api$Provider$Practitioner$Meta$specialtyNames = function(_v0) {
        var fields = _v0;
        return fields._O;
    };
    var $author$project$Api$Provider$Practitioner$Meta$treatsAge = function(_v0) {
        var fields = _v0;
        return fields.aaz;
    };
    var $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromEmployer = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromRetail = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$viewAcceptsEnrollmentsForm = F2(function(acceptsEnrollmentsFromEmployer, acceptsEnrollmentsFromRetail) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$inputSpan(9),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$label('Accepting Enrollments From')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(acceptsEnrollmentsFromEmployer),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromEmployer))
            ]), _List_fromArray([
                $elm$html$Html$text('Employer')
            ])),
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(acceptsEnrollmentsFromRetail),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AcceptsEnrollmentsFromRetail))
            ]), _List_fromArray([
                $elm$html$Html$text('Retail')
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$Bio = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Utils$MetaFields$explanation = function(metaField) {
        if (!metaField.$) return $elm$core$Maybe$Nothing;
        else {
            var explanation_ = metaField.a;
            return explanation_;
        }
    };
    var $author$project$Pages$Admin$Providers$Top$withinTooltipIf = F2(function(maybeExplanation, content) {
        if (!maybeExplanation.$) {
            var explanation = maybeExplanation.a;
            return A3($author$project$Ui$Tooltip$view, _List_Nil, explanation, _List_fromArray([
                content
            ]));
        } else return content;
    });
    var $author$project$Pages$Admin$Providers$Top$viewBio = F2(function(bio, editable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Bio')
        ]), _List_fromArray([
            A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Textarea$view(_List_fromArray([
                $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', bio)),
                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Bio)),
                $author$project$Ui$Form$Textarea$disabled($author$project$Utils$MetaFields$isUneditable(editable))
            ])))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$AddEducation = {
        $: 15
    };
    var $author$project$Pages$Admin$Providers$Top$Education = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Providers$Top$RemoveEducation = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$viewEducation = F4(function(educations, editable, index, education) {
        var isLast = _Utils_eq(index, $elm$core$List$length(educations) - 1);
        var isFirst = !index;
        var label = isFirst ? 'Education' : '';
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label(label)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$group(_List_fromArray([
                A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(education),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Education(index))),
                    $author$project$Ui$Form$Input$placeholder('Stanford Medical School'),
                    $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(editable))
                ]))),
                $elm$core$List$length(educations) > 1 ? A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A3($author$project$Ui$Button$view, {
                    abP: 'Remove education'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$RemoveEducation(index))),
                    $author$project$Ui$Button$disabled($author$project$Utils$MetaFields$isUneditable(editable)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$minus)
                ]), _List_Nil)) : $author$project$Utils$Html$empty,
                isLast ? A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A3($author$project$Ui$Button$view, {
                    abP: 'Add education'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddEducation)),
                    $author$project$Ui$Button$disabled($author$project$Utils$MetaFields$isUneditable(editable)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                ]), _List_Nil)) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$ElationPhysicianId = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Api$Provider$ElationPhysician$All$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$ElationPhysician$All$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Pages$Admin$Providers$Top$elationPhysicianOptions = function(elationPhysicians) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'None'), A2($elm$core$List$map, function(elationPhysician) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$ElationPhysician$All$id(elationPhysician)), $author$project$Api$Provider$ElationPhysician$All$name(elationPhysician));
        }, elationPhysicians));
    };
    var $author$project$Pages$Admin$Providers$Top$viewElationSync = F2(function(elationPhysicianId, elationPhysicians) {
        var _v0 = function() {
            if (elationPhysicians.$ === 3) {
                var physicians = elationPhysicians.a;
                return _Utils_Tuple2(false, physicians);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var elationPhysiciansLoading = _v0.a;
        var elationPhysicians_ = _v0.b;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Elation Sync')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(elationPhysicianId),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$ElationPhysicianId)),
                $author$project$Ui$Form$Select$disabled($elm$core$List$isEmpty(elationPhysicians_)),
                $author$project$Ui$Form$Select$loading(elationPhysiciansLoading)
            ]), $author$project$Pages$Admin$Providers$Top$elationPhysicianOptions(elationPhysicians_))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$Email = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$viewEmail = F2(function(email, editable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Email')
        ]), _List_fromArray([
            A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', email)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Email)),
                $author$project$Ui$Form$Input$placeholder('dr.mccoy@example.com'),
                $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(editable))
            ])))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$Gender = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$GenderOther = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Gender$Disabled = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Gender$disabled = $author$project$Ui$Form$Gender$Disabled;
    var $author$project$Ui$Form$Gender$Gender = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Gender$gender = $author$project$Ui$Form$Gender$Gender;
    var $author$project$Ui$Form$Gender$GenderOther = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$Gender$genderOther = $author$project$Ui$Form$Gender$GenderOther;
    var $author$project$Ui$Form$Gender$OnGenderChange = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Gender$onGenderChange = $author$project$Ui$Form$Gender$OnGenderChange;
    var $author$project$Ui$Form$Gender$OnGenderOtherChange = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$Gender$onGenderOtherChange = $author$project$Ui$Form$Gender$OnGenderOtherChange;
    var $author$project$Ui$Form$Gender$defaultOptions = {
        vD: _List_Nil,
        d$: false,
        fK: _List_Nil,
        P5: $elm$core$Maybe$Nothing,
        P7: $elm$core$Maybe$Nothing,
        q2: false,
        zV: $elm$core$Maybe$Nothing,
        zW: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$Form$Gender$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$id(string), record.vD)
                    });
                case 3:
                    var handler = option.a;
                    return _Utils_update(record, {
                        zV: $elm$core$Maybe$Just(handler)
                    });
                case 4:
                    var handler = option.a;
                    return _Utils_update(record, {
                        zW: $elm$core$Maybe$Just(handler)
                    });
                case 1:
                    var gender_ = option.a;
                    return _Utils_update(record, {
                        P5: gender_
                    });
                case 2:
                    var string = option.a;
                    return _Utils_update(record, {
                        P7: string
                    });
                case 5:
                    var bool = option.a;
                    return _Utils_update(record, {
                        d$: bool
                    });
                case 6:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('feedback-errored', bool)
                        ])), record.vD),
                        q2: bool
                    });
                default:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
            }
        }), $author$project$Ui$Form$Gender$defaultOptions, options);
    };
    var $author$project$Ui$Form$Gender$viewGenderOption = F2(function(options, gender_) {
        var genderString = $author$project$Api$Gender$toString(gender_);
        return A2($elm$html$Html$label, _List_fromArray([
            $elm$html$Html$Attributes$class('radio-inline')
        ]), _List_fromArray([
            A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$type_('radio'), A2($elm$core$List$cons, $elm$html$Html$Attributes$name('gender'), A2($elm$core$List$cons, $elm$html$Html$Attributes$value(genderString), A2($elm$core$List$cons, $elm$html$Html$Attributes$checked(_Utils_eq($elm$core$Maybe$Just(gender_), options.P5)), A2($elm$core$List$cons, $elm$html$Html$Attributes$disabled(options.d$), function() {
                var _v0 = options.zV;
                if (!_v0.$) {
                    var handler = _v0.a;
                    return _List_fromArray([
                        $elm$html$Html$Events$onInput(A2($elm$core$Basics$composeL, handler, $elm$core$Basics$always(gender_)))
                    ]);
                } else return _List_Nil;
            }()))))), _List_Nil),
            $elm$html$Html$text($author$project$Formatters$String$titleize(genderString))
        ]));
    });
    var $author$project$Ui$Form$Gender$view = function(options) {
        var optionsRecord = $author$project$Ui$Form$Gender$optionsToRecord(options);
        var genderOptions = _List_fromArray([
            0,
            1,
            3
        ]);
        var radios = A2($elm$core$List$map, $author$project$Ui$Form$Gender$viewGenderOption(optionsRecord), genderOptions);
        var genderExplanation = $elm$core$Maybe$Nothing;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                function() {
                    if (!genderExplanation.$) {
                        var genderExplanation_ = genderExplanation.a;
                        return A3($author$project$Ui$Tooltip$view, _List_Nil, genderExplanation_, radios);
                    } else return A2($elm$html$Html$div, _List_Nil, radios);
                }()
            ])),
            _Utils_eq(optionsRecord.P5, $elm$core$Maybe$Just(3)) ? A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(A2($elm$core$List$cons, $author$project$Ui$Form$Input$placeholder('Description'), A2($elm$core$List$cons, $author$project$Ui$Form$Input$autoComplete(false), A2($elm$core$List$cons, $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', optionsRecord.P7)), A2($elm$core$List$cons, $author$project$Ui$Form$Input$disabled(optionsRecord.d$), A2($elm$core$List$cons, $author$project$Ui$Form$Input$phi(true), function() {
                    var _v1 = optionsRecord.zW;
                    if (!_v1.$) {
                        var handler = _v1.a;
                        return _List_fromArray([
                            $author$project$Ui$Form$Input$onInput(handler)
                        ]);
                    } else return _List_Nil;
                }()))))))
            ])) : $author$project$Ui$Grid$none
        ]));
    };
    var $author$project$Pages$Admin$Providers$Top$viewGender = F3(function(gender, genderOther, editable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Gender')
        ]), _List_fromArray([
            A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Gender$view(_List_fromArray([
                $author$project$Ui$Form$Gender$gender(gender),
                $author$project$Ui$Form$Gender$genderOther(genderOther),
                $author$project$Ui$Form$Gender$onGenderChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Gender)),
                $author$project$Ui$Form$Gender$onGenderOtherChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$GenderOther)),
                $author$project$Ui$Form$Gender$disabled($author$project$Utils$MetaFields$isUneditable(editable))
            ])))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$AddLocationItem = {
        $: 11
    };
    var $author$project$Pages$Admin$Providers$Top$Location = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Providers$Top$RemoveLocationItem = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$locationDropdownOptions = F3(function(allLocations, locations, location1) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Select'), A2($elm$core$List$map, function(location_) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Location$All$id(location_)), $author$project$Api$Provider$Location$All$name(location_));
        }, A2($elm_community$list_extra$List$Extra$filterNot, function(location_) {
            return !_Utils_eq($author$project$Api$Provider$Location$All$id(location_), location1) && A2($elm$core$List$member, $author$project$Api$Provider$Location$All$id(location_), locations);
        }, allLocations)));
    });
    var $author$project$Pages$Admin$Providers$Top$viewLocationsDropdown = F7(function(form, allLocationsLoading, allLocations, locations, editable, index, location1) {
        var isLast = _Utils_eq(index, $elm$core$List$length(locations) - 1);
        var isFirst = !index;
        var label = isFirst ? 'Locations' : '';
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label(label),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$group(_List_fromArray([
                A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(location1)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Location(index))),
                    $author$project$Ui$Form$Select$loading(allLocationsLoading),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 3, form)),
                    $author$project$Ui$Form$Select$disabled($author$project$Utils$MetaFields$isUneditable(editable))
                ]), A3($author$project$Pages$Admin$Providers$Top$locationDropdownOptions, allLocations, locations, location1))),
                $elm$core$List$length(locations) > 1 && $author$project$Utils$MetaFields$isEditable(editable) ? A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A3($author$project$Ui$Button$view, {
                    abP: 'Remove Location'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$disabled($author$project$Utils$MetaFields$isUneditable(editable)),
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$RemoveLocationItem(index))),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$minus)
                ]), _List_Nil)) : $author$project$Utils$Html$empty,
                isLast ? A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A3($author$project$Ui$Button$view, {
                    abP: 'Add Location'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddLocationItem)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$disabled($author$project$Utils$MetaFields$isUneditable(editable))
                ]), _List_Nil)) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$IsProvider = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$Npi = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$Inline = {
        $: 7
    };
    var $author$project$Ui$Form$Checkbox$inline = $author$project$Ui$Form$Checkbox$Inline;
    var $author$project$Pages$Admin$Providers$Top$viewNPI = F4(function(isProvider, npi, editable, errors) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('NPI'),
            $author$project$Ui$Form$Group$required(isProvider)
        ]), _List_fromArray([
            A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', npi)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Npi)),
                $author$project$Ui$Form$Input$maxLength(10),
                $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(errors)),
                $author$project$Ui$Form$Input$errors(errors),
                $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(editable))
            ]))),
            $author$project$Utils$Html$noBreakSpace,
            A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(!isProvider),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$IsProvider)),
                $author$project$Ui$Form$Checkbox$inline,
                $author$project$Ui$Form$Checkbox$disabled($author$project$Utils$MetaFields$isUneditable(editable))
            ]), _List_fromArray([
                $elm$html$Html$text('Not a provider, does not have an NPI')
            ])))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$viewName = F3(function(name, editable, errors) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Name'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(name),
                $author$project$Ui$Form$Input$placeholder('Dr. Leonard McCoy, MD'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Name)),
                $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(errors)),
                $author$project$Ui$Form$Input$errors(errors),
                $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(editable))
            ])))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$AutoDetermineOnlineSignupVisibilityFromPanelSize = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$OnlineSignupVisibility = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$viewOnlineSignup = F2(function(onlineSignupVisibility, autoDetermineOnlineSignupVisibilityFromPanelSize) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Online Signup')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(onlineSignupVisibility),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$OnlineSignupVisibility)),
                $author$project$Ui$ToggleSwitch$disabled(autoDetermineOnlineSignupVisibilityFromPanelSize)
            ])),
            $author$project$Utils$Html$noBreakSpace,
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(autoDetermineOnlineSignupVisibilityFromPanelSize),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$AutoDetermineOnlineSignupVisibilityFromPanelSize)),
                $author$project$Ui$Form$Checkbox$inline
            ]), _List_fromArray([
                $elm$html$Html$text('Auto determine from panel size')
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$PanelSizeLimit = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$viewPanelSize = F4(function(autoDetermineOnlineSignupVisibilityFromPanelSize, panelSizeLimit, panelSize, editable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Panel Size Limit'),
            $author$project$Ui$Form$Group$required(autoDetermineOnlineSignupVisibilityFromPanelSize)
        ]), _List_fromArray([
            A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$number,
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, panelSizeLimit))),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$PanelSizeLimit)),
                $author$project$Ui$Form$Input$placeholder('No Limit'),
                $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(editable))
            ]))),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$helpText
            ]), _List_fromArray([
                $elm$html$Html$text('Current Panel Size: '),
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, panelSize)))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$viewPhoto = F2(function(currentPhotoUrl, errors) {
        if (!currentPhotoUrl.$) {
            var url = currentPhotoUrl.a;
            return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$label('')
            ]), _List_fromArray([
                A3($author$project$Ui$Image$fromSrc, {
                    Jg: 'Provider photo'
                }, url, _List_fromArray([
                    $author$project$Ui$Image$height(100)
                ])),
                $author$project$Utils$FormErrors$view(errors)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Admin$Providers$Top$PhotoUploaded = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$viewPhotoLabel = function(editable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Photo')
        ]), _List_fromArray([
            A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$accept(0),
                $author$project$Ui$Form$File$onInput($author$project$Pages$Admin$Providers$Top$PhotoUploaded),
                $author$project$Ui$Form$File$empty(true),
                $author$project$Ui$Form$File$disabled($author$project$Utils$MetaFields$isUneditable(editable))
            ])))
        ]));
    };
    var $author$project$Pages$Admin$Providers$Top$AddSpecialty = {
        $: 10
    };
    var $author$project$Pages$Admin$Providers$Top$RemoveSpecialty = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$Specialty = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Specialty$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Specialty$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Specialty$Shared$name(shared);
    };
    var $author$project$Pages$Admin$Providers$Top$specialtyOptions = F3(function(allSpecialties, specialties, specialty) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), ''), A2($elm$core$List$map, function(specialty_) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Specialty$All$name(specialty_)), $author$project$Api$Provider$Specialty$All$name(specialty_));
        }, A2($elm_community$list_extra$List$Extra$filterNot, function(specialty_) {
            return !_Utils_eq($author$project$Api$Provider$Specialty$All$name(specialty_), specialty) && A2($elm$core$List$member, $author$project$Api$Provider$Specialty$All$name(specialty_), specialties);
        }, allSpecialties)));
    });
    var $author$project$Pages$Admin$Providers$Top$viewSpecialty = F6(function(allSpecialtiesLoading, allSpecialties, specialties, editable, index, specialty) {
        var isLast = _Utils_eq(index, $elm$core$List$length(specialties) - 1);
        var isFirst = !index;
        var label = isFirst ? 'Specialties' : '';
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label(label)
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flex space-between')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(specialty)),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$Specialty(index))),
                        $author$project$Ui$Form$Select$loading(allSpecialtiesLoading),
                        $author$project$Ui$Form$Select$disabled($author$project$Utils$MetaFields$isUneditable(editable))
                    ]), A3($author$project$Pages$Admin$Providers$Top$specialtyOptions, allSpecialties, specialties, specialty))),
                    $elm$core$List$length(specialties) > 1 ? A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A3($author$project$Ui$Button$view, {
                        abP: 'Remove specialty'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$RemoveSpecialty(index))),
                        $author$project$Ui$Button$disabled($author$project$Utils$MetaFields$isUneditable(editable)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$minus),
                        $author$project$Ui$Button$sm
                    ]), _List_Nil)) : $author$project$Utils$Html$empty,
                    isLast ? A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), A3($author$project$Ui$Button$view, {
                        abP: 'Add speciality'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$FormUpdated($author$project$Pages$Admin$Providers$Top$AddSpecialty)),
                        $author$project$Ui$Button$disabled($author$project$Utils$MetaFields$isUneditable(editable)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                        $author$project$Ui$Button$sm
                    ]), _List_Nil)) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$MaxPatientAge = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$MinPatientAge = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$viewTreatsAge = F3(function(minPatientAge, maxPatientAge, editable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Treats Ages')
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$number,
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, minPatientAge))),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$MinPatientAge)),
                    $author$project$Ui$Form$Input$placeholder('0'),
                    $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(editable))
                ]))),
                A2($author$project$Ui$Typography$label, _List_fromArray([
                    $author$project$Ui$Typography$controlLabel
                ]), _List_fromArray([
                    $elm$html$Html$text('To')
                ])),
                A2($author$project$Pages$Admin$Providers$Top$withinTooltipIf, $author$project$Utils$MetaFields$explanation(editable), $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$number,
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, maxPatientAge))),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Providers$Top$FormUpdated, $author$project$Pages$Admin$Providers$Top$MaxPatientAge)),
                    $author$project$Ui$Form$Input$placeholder('100'),
                    $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(editable))
                ])))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$viewModal = F4(function(model, id, form, item) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Provider',
            Tk: _Utils_eq(item, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$Providers$Top$CancelEdit,
            Vn: $author$project$Pages$Admin$Providers$Top$Save(form)
        };
        var ifTrue = F2(function(bool, field) {
            return bool ? field : $author$project$Utils$Html$empty;
        });
        var fields = $author$project$Utils$Form$fields(form);
        var meta = function(accessor) {
            return A2($elm$core$Maybe$withDefault, $author$project$Utils$MetaFields$alwaysEditable, A2($elm$core$Maybe$map, accessor, fields.Ue));
        };
        var errorsFor = function(group) {
            return A2($author$project$Utils$Form$validationErrors, group, form);
        };
        var _v0 = function() {
            var _v1 = model._N;
            if (_v1.$ === 3) {
                var specialties_ = _v1.a;
                return _Utils_Tuple2(false, specialties_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var specialtiesLoading = _v0.a;
        var specialties = _v0.b;
        var _v2 = function() {
            var _v3 = model.Tq;
            if (_v3.$ === 3) {
                var locations_ = _v3.a;
                return _Utils_Tuple2(false, locations_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var locationsLoading = _v2.a;
        var locations = _v2.b;
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Pages$Admin$Providers$Top$viewName, fields.zr, meta($author$project$Api$Provider$Practitioner$Meta$name), errorsFor(0)),
                A4($author$project$Pages$Admin$Providers$Top$viewNPI, fields.Sl, fields.U9, meta($author$project$Api$Provider$Practitioner$Meta$npi), errorsFor(1)),
                A2($author$project$Pages$Admin$Providers$Top$viewBio, fields.Kj, meta($author$project$Api$Provider$Practitioner$Meta$bio)),
                A3($author$project$Pages$Admin$Providers$Top$viewGender, fields.P5, fields.P7, meta($author$project$Api$Provider$Practitioner$Meta$gender)),
                $author$project$Pages$Admin$Providers$Top$viewPhotoLabel(meta($author$project$Api$Provider$Practitioner$Meta$photo)),
                A2($author$project$Pages$Admin$Providers$Top$viewPhoto, fields.p9, errorsFor(2)),
                A2($author$project$Pages$Admin$Providers$Top$viewEmail, fields.OH, meta($author$project$Api$Provider$Practitioner$Meta$email)),
                A3($author$project$Pages$Admin$Providers$Top$viewTreatsAge, fields.Ul, fields.TM, meta($author$project$Api$Provider$Practitioner$Meta$treatsAge))
            ]),
            A2($elm$core$List$indexedMap, A4($author$project$Pages$Admin$Providers$Top$viewSpecialty, specialtiesLoading, specialties, fields._N, meta($author$project$Api$Provider$Practitioner$Meta$specialtyNames)), fields._N),
            A2($elm$core$List$indexedMap, A2($author$project$Pages$Admin$Providers$Top$viewEducation, fields.Ov, meta($author$project$Api$Provider$Practitioner$Meta$education)), fields.Ov),
            A2($elm$core$List$indexedMap, A5($author$project$Pages$Admin$Providers$Top$viewLocationsDropdown, form, locationsLoading, locations, fields.Tq, meta($author$project$Api$Provider$Practitioner$Meta$locations)), fields.Tq),
            _List_fromArray([
                A2(ifTrue, $author$project$Api$Provider$Practice$One$elationEnabled(model.W1), A2($author$project$Pages$Admin$Providers$Top$viewElationSync, fields.OA, model.xq)),
                A2($author$project$Pages$Admin$Providers$Top$viewOnlineSignup, fields.Vv, fields.JU),
                A4($author$project$Pages$Admin$Providers$Top$viewPanelSize, fields.JU, fields.VT, fields.VS, meta($author$project$Api$Provider$Practitioner$Meta$panelSizeLimit)),
                A2($author$project$Pages$Admin$Providers$Top$viewAcceptsEnrollmentsForm, fields.pj, fields.pk)
            ])
        ])));
    });
    var $author$project$Pages$Admin$Providers$Top$NpiSettingChanged = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeSettings$One$showNpi = function(_v0) {
        var record = _v0;
        return record._g;
    };
    var $author$project$Pages$Admin$Providers$Top$viewEnableNpiToggle = function(practiceSettings) {
        var labelHelp = $elm$html$Html$text('A providers\'s NPI will be displayed on invoices and other communications with customers such as patients or employers');
        var _v0 = function() {
            switch(practiceSettings.$){
                case 2:
                    return _Utils_Tuple3(false, true, false);
                case 3:
                    var settings = practiceSettings.a;
                    return _Utils_Tuple3(false, false, $author$project$Api$Provider$PracticeSettings$One$showNpi(settings));
                default:
                    return _Utils_Tuple3(true, true, false);
            }
        }();
        var loading = _v0.a;
        var disabled = _v0.b;
        var on = _v0.c;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Display NPI to customers'),
                    $author$project$Ui$Form$Group$labelHelp(labelHelp),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$labelSpan(8),
                    $author$project$Ui$Form$Group$inputSpan(4),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(on),
                            $author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Admin$Providers$Top$NpiSettingChanged),
                            $author$project$Ui$ToggleSwitch$disabled(disabled || loading)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Providers$Top$AddLocation = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Admin$Providers$Top$Delete = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Providers$Top$Edit = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$Shared$subdomain = function(_v0) {
        var record = _v0;
        return record.$n;
    };
    var $author$project$Api$Provider$Practice$One$subdomain = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$subdomain(shared);
    };
    var $author$project$Pages$Admin$Providers$Top$customUrl = F2(function(practice, practitioner) {
        return 'https://' + ($author$project$Api$Provider$Practice$One$subdomain(practice) + ('.hint.com/signup?practitioner=' + $author$project$Api$Provider$Practitioner$All$id(practitioner)));
    });
    var $author$project$Api$Provider$Npi$Shared$firstName = function(_v0) {
        var record = _v0;
        return record.PN;
    };
    var $author$project$Api$Provider$Npi$Shared$lastName = function(_v0) {
        var record = _v0;
        return record.SU;
    };
    var $author$project$Api$Provider$Npi$Shared$organizationName = function(_v0) {
        var record = _v0;
        return record.VB;
    };
    var $author$project$Api$Provider$Npi$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Pages$Admin$Providers$Top$npiName = function(npi) {
        var _v0 = $author$project$Api$Provider$Npi$Shared$type_(npi);
        if (!_v0.$ && _v0.a === 'organization') return A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Npi$Shared$organizationName(npi));
        else {
            var _v1 = _Utils_Tuple2($author$project$Api$Provider$Npi$Shared$firstName(npi), $author$project$Api$Provider$Npi$Shared$lastName(npi));
            if (!_v1.a.$ && !_v1.b.$) {
                var firstName = _v1.a.a;
                var lastName = _v1.b.a;
                return firstName + (' ' + lastName);
            } else return '';
        }
    };
    var $author$project$Pages$Admin$Providers$Top$viewField_ = F2(function(labelOption, content) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            labelOption,
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$labelSpanMd(2),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$inputSpanMd(10)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, content)
        ]));
    });
    var $author$project$Pages$Admin$Providers$Top$viewField = function(label) {
        return $author$project$Pages$Admin$Providers$Top$viewField_($author$project$Ui$Form$Group$label(label));
    };
    var $author$project$Pages$Admin$Providers$Top$viewLocation = function(location1) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$phi(true)
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Location$Shared$name(location1)),
            $author$project$Utils$Html$noBreakSpace
        ]));
    };
    var $author$project$Pages$Admin$Providers$Top$viewItem = F3(function(model, items, item) {
        var panelSizeLimit = A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Provider$Practitioner$All$panelSizeLimit(item));
        var onlineSignupVisibility = $author$project$Api$Provider$Practitioner$All$onlineSignupVisibility(item);
        var locations = A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$Practitioner$All$locations(item));
        var id = $author$project$Api$Provider$Practitioner$All$id(item);
        var loading = A2($elm$core$Set$member, id, model.dS);
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Practitioner$All$name(item))
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        A3($author$project$Ui$Tooltip$view, _List_Nil, 'active patient count', _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$badge
                            ]), _List_fromArray([
                                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Practitioner$All$panelSize(item)))
                            ]))
                        ]))
                    ])),
                    $author$project$Api$Provider$Practitioner$All$isMaster(item) ? $author$project$Components$SyncedIcon$view(_List_fromArray([
                        $author$project$Components$SyncedIcon$master
                    ])) : $author$project$Utils$Html$empty,
                    $author$project$Api$Provider$Practitioner$All$isSynced(item) ? $author$project$Components$SyncedIcon$view(_List_fromArray([
                        $author$project$Components$SyncedIcon$synced
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit provider'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$Edit(item)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete provider'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$onClick(A2($author$project$Pages$Admin$Providers$Top$Delete, item, items)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceY2
            ]), _List_fromArray([
                A2($author$project$Pages$Admin$Providers$Top$viewField, 'Online Signup', _List_fromArray([
                    onlineSignupVisibility ? $author$project$Ui$Icon$check(_List_fromArray([
                        $author$project$Ui$Icon$success
                    ])) : $author$project$Ui$Icon$cross(_List_fromArray([
                        $author$project$Ui$Icon$danger
                    ])),
                    $author$project$Api$Provider$Practitioner$All$autoDetermineOnlineSignupVisibilityFromPanelSize(item) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$helpText,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        onlineSignupVisibility ? $elm$html$Html$text(' Automatically set by panel size. Disabled after panel reaches ' + (A2($elm$core$Maybe$withDefault, 'N/A', panelSizeLimit) + '.')) : $elm$html$Html$text(' Automatically set by panel size. Re-enabled after panel drops below ' + (A2($elm$core$Maybe$withDefault, 'N/A', panelSizeLimit) + '.'))
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Pages$Admin$Providers$Top$viewField, 'Treats ages', _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '0', A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Provider$Practitioner$All$minPatientAge(item))) + (' to ' + A2($elm$core$Maybe$withDefault, 'max', A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Provider$Practitioner$All$maxPatientAge(item)))))
                ])),
                function() {
                    var _v0 = $author$project$Api$Provider$Practitioner$All$email(item);
                    if (!_v0.$) {
                        var email = _v0.a;
                        return A2($author$project$Pages$Admin$Providers$Top$viewField, 'Email', _List_fromArray([
                            $elm$html$Html$text(email)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $elm$core$List$isEmpty($author$project$Api$Provider$Practitioner$All$specialties(item)) ? $author$project$Utils$Html$empty : A2($author$project$Pages$Admin$Providers$Top$viewField, 'Specialties', _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$toSentence($author$project$Api$Provider$Practitioner$All$specialties(item)))
                ])),
                $elm$core$List$isEmpty($author$project$Api$Provider$Practitioner$All$education(item)) ? $author$project$Utils$Html$empty : A2($author$project$Pages$Admin$Providers$Top$viewField, 'Education', _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$toSentence($author$project$Api$Provider$Practitioner$All$education(item)))
                ])),
                A2($author$project$Pages$Admin$Providers$Top$viewField, 'Locations', _Utils_ap($elm$core$List$isEmpty(locations) ? _List_fromArray([
                    $elm$html$Html$text('None')
                ]) : A2($elm$core$List$map, $author$project$Pages$Admin$Providers$Top$viewLocation, locations), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, $author$project$Api$Provider$Practitioner$All$isSynced(item) ? _List_Nil : _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add location'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$AddLocation(item))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add Location')
                        ]))
                    ]))
                ]))),
                A2($author$project$Pages$Admin$Providers$Top$viewField, 'Custom Signup URL', _List_fromArray([
                    A3($author$project$Ui$Link$externalHref, A2($author$project$Pages$Admin$Providers$Top$customUrl, model.W1, item), _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Pages$Admin$Providers$Top$customUrl, model.W1, item))
                    ]))
                ])),
                A2($author$project$Pages$Admin$Providers$Top$viewField, 'Panel Limit', _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'None', panelSizeLimit))
                ])),
                function() {
                    if ($author$project$Api$Provider$Practice$One$elationEnabled(model.W1)) {
                        var _v1 = $author$project$Api$Provider$Practitioner$All$elationPhysicianId(item);
                        if (!_v1.$) return A2($author$project$Pages$Admin$Providers$Top$viewField, 'Elation', _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, 'synced')
                        ]));
                        else return A2($author$project$Pages$Admin$Providers$Top$viewField, 'Elation', _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    if ($author$project$Api$Provider$Practitioner$All$isProvider(item)) {
                        var _v2 = $author$project$Api$Provider$Practitioner$All$npi(item);
                        if (!_v2.$) {
                            var npi = _v2.a;
                            return A2($author$project$Pages$Admin$Providers$Top$viewField, 'NPI', _List_fromArray([
                                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Provider$Npi$Shared$number(npi))
                                ])),
                                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, $author$project$Api$Provider$Npi$Shared$type_(npi))))
                                ])),
                                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Pages$Admin$Providers$Top$npiName(npi))
                                ]))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    });
    var $author$project$Ui$ListGroup$body = function(contents) {
        return A2($elm$html$Html$p, _List_fromArray([
            $elm$html$Html$Attributes$class('list-group-item-text')
        ]), contents);
    };
    var $author$project$Pages$Admin$Providers$Top$viewFieldSkeleton = function(label) {
        return A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Pages$Admin$Providers$Top$viewField_($author$project$Ui$Form$Group$labelSkeleton(label)));
    };
    var $author$project$Pages$Admin$Providers$Top$viewItemSkeleton = A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
        A2($elm$html$Html$h3, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Provider Name')
            ]))
        ])),
        $author$project$Ui$ListGroup$body(_List_fromArray([
            A2($author$project$Pages$Admin$Providers$Top$viewFieldSkeleton, 'Online Signup', $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('  ')
            ]))),
            A2($author$project$Pages$Admin$Providers$Top$viewFieldSkeleton, 'Treats ages', $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(3)
            ]))),
            A2($author$project$Pages$Admin$Providers$Top$viewFieldSkeleton, 'Location', $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(2)
            ]))),
            A2($author$project$Pages$Admin$Providers$Top$viewFieldSkeleton, 'Custom Signup URL', $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(6)
            ]))),
            A2($author$project$Pages$Admin$Providers$Top$viewFieldSkeleton, 'Panel Item', $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('100')
            ])))
        ]))
    ]));
    var $author$project$Pages$Admin$Providers$Top$viewSearch = function(model) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb2,
            $author$project$Ui$Element$mt2
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(8),
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$Providers$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Ui$ListGroup$ZeroState = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$ListGroup$zeroState = $author$project$Ui$ListGroup$ZeroState;
    var $author$project$Pages$Admin$Providers$Top$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.i$;
            if (_v1.$ === 3) {
                var items_ = _v1.a;
                return _Utils_Tuple2(false, items_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var items = _v0.b;
        return _List_fromArray([
            $author$project$Pages$Admin$Providers$Top$viewEnableNpiToggle(model.sd),
            $author$project$Pages$Admin$Providers$Top$viewSearch(model),
            loading ? A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$repeat, 10, A2($author$project$Ui$ListGroup$item, _List_Nil, $elm$core$List$singleton($author$project$Pages$Admin$Providers$Top$viewItemSkeleton)))) : A2($author$project$Ui$ListGroup$view, _List_fromArray([
                $author$project$Ui$ListGroup$zeroState('You have no providers.')
            ]), A2($elm$core$List$map, A2($author$project$Pages$Admin$Providers$Top$viewItem, model, items), items))
        ]);
    };
    var $author$project$Pages$Admin$Providers$Top$view = function(model) {
        return {
            fb: function() {
                var loading = function() {
                    var _v5 = model.i$;
                    if (_v5.$ === 3) return false;
                    else return true;
                }();
                return _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Admin$Providers$Top$LinkedRecordsMsg, $author$project$Components$LinkedRecords$modal(model.mV)),
                    function() {
                        var _v0 = model.F6;
                        if (!_v0.$) {
                            var _v1 = _v0.a;
                            var id = _v1.a;
                            var form = _v1.b;
                            var item = _v1.c;
                            return A4($author$project$Pages$Admin$Providers$Top$viewModal, model, id, form, item);
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v2 = model.$8;
                        if (!_v2.$) {
                            var item = _v2.a;
                            return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Providers$Top$HiConfirmClosed(item), _List_fromArray([
                                $author$project$Components$HiConfirm$verb('delete'),
                                $author$project$Components$HiConfirm$noun('provider'),
                                $author$project$Components$HiConfirm$detail($author$project$Api$Provider$Practitioner$All$name(item))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    A2($elm$html$Html$map, $author$project$Pages$Admin$Providers$Top$DeleteModalMsg, $author$project$Components$Admin$Practitioner$DeleteModal$view(model.ia)),
                    function() {
                        var _v3 = model.aW;
                        if (!_v3.$) {
                            var _v4 = _v3.a;
                            var item = _v4.a;
                            var locationId = _v4.b;
                            var request = _v4.c;
                            return A4($author$project$Pages$Admin$Providers$Top$viewAddLocationModal, model, item, locationId, request);
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                                $elm$html$Html$text('Providers')
                            ]), _List_fromArray([
                                A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$class('pull-right')
                                ]), _List_fromArray([
                                    model.F3 ? A3($author$project$Ui$HinterOnly$linkRoute, $author$project$Spa$Generated$Route$Admin__Providers__Upload, _List_fromArray([
                                        $author$project$Ui$Link$buttonDefault,
                                        $author$project$Ui$Link$ariaLabel('Upload')
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Upload from CSV')
                                    ])) : $author$project$Utils$Html$empty,
                                    $author$project$Utils$Html$noBreakSpace,
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Add new provider'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$default,
                                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Providers$Top$New),
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('New Provider')
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Admin$Providers$Top$viewPanelBody(model)),
                        A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Admin$Providers$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                                $author$project$Ui$Pagination$List$loading(loading)
                            ]), model.af_))
                        ]))
                    ]))
                ]);
            }(),
            $2: 'Admin | Providers'
        };
    };
    var $author$project$Pages$Admin$Providers$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Providers$Top$init,
        aeR: $author$project$Pages$Admin$Providers$Top$load,
        ag3: $author$project$Pages$Admin$Providers$Top$save,
        ahE: $author$project$Pages$Admin$Providers$Top$subscriptions,
        aaO: $author$project$Pages$Admin$Providers$Top$update,
        aid: $author$project$Pages$Admin$Providers$Top$view
    });
    var $author$project$Api$Upload$Resource$Practitioner = 2;
    var $author$project$Pages$Admin$Providers$Upload$UploadFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$Providers$Upload$init = F4(function(_v0, _v1, shared, _v2) {
        var _v3 = A4($author$project$Components$Upload$Form$init, shared.HO, shared.Ej, 2, $elm$core$Maybe$Nothing);
        var uploadForm = _v3.a;
        var uploadFormCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: uploadForm
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, uploadFormCmd));
    });
    var $author$project$Pages$Admin$Providers$Upload$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Providers$Upload$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Providers$Upload$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Upload$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$Admin$Providers$Upload$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Upload$Form$update, model.Ej, subMsg, model.PU);
        var uploadForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: uploadForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsgs);
    });
    var $author$project$Pages$Admin$Providers$Upload$viewBody = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Upload Providers')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$Upload$Form$view, model.Ej, model.PU))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Providers$Upload$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$Upload$Form$modal, model.Ej, model.PU)),
                $author$project$Pages$Admin$Providers$Upload$viewBody(model)
            ]),
            $2: 'Admin | Providers'
        };
    };
    var $author$project$Pages$Admin$Providers$Upload$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Providers$Upload$init,
        aeR: $author$project$Pages$Admin$Providers$Upload$load,
        ag3: $author$project$Pages$Admin$Providers$Upload$save,
        ahE: $author$project$Pages$Admin$Providers$Upload$subscriptions,
        aaO: $author$project$Pages$Admin$Providers$Upload$update,
        aid: $author$project$Pages$Admin$Providers$Upload$view
    });
    var $author$project$Pages$Admin$Quickbooks$Top$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            Bz: query
        }, function() {
            var _v3 = A2($elm$core$Dict$get, 'code', query);
            if (!_v3.$) return A2($author$project$Utils$Route$navigate, query, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings);
            else return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Slug_String({
                _A: 'quickbooks'
            }));
        }());
    });
    var $author$project$Pages$Admin$Quickbooks$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Quickbooks$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Quickbooks$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Quickbooks$Top$update = F2(function(msg, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Admin$Quickbooks$Top$view = function(_v0) {
        return {
            fb: _List_fromArray([
                $elm$html$Html$text('Redirecting to marketplace...')
            ]),
            $2: 'Redirecting...'
        };
    };
    var $author$project$Pages$Admin$Quickbooks$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Quickbooks$Top$init,
        aeR: $author$project$Pages$Admin$Quickbooks$Top$load,
        ag3: $author$project$Pages$Admin$Quickbooks$Top$save,
        ahE: $author$project$Pages$Admin$Quickbooks$Top$subscriptions,
        aaO: $author$project$Pages$Admin$Quickbooks$Top$update,
        aid: $author$project$Pages$Admin$Quickbooks$Top$view
    });
    var $author$project$Spa$Page$applicationPrivate = function(page) {
        return {
            aeq: F2(function(shared, url) {
                var _v0 = shared.Z$;
                switch(_v0.$){
                    case 3:
                        var session = _v0.a;
                        return !A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil) : A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3(page.aeq, session, shared, url)));
                    case 1:
                        return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 0:
                        return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $author$project$Ports$Session$authorize({
                            agy: true
                        }), _List_Nil);
                    default:
                        return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            }),
            aeR: F2(function(shared, model) {
                var _v1 = _Utils_Tuple2(shared.Z$, model);
                _v1$2: while(true){
                    if (!_v1.b.$) switch(_v1.a.$){
                        case 3:
                            var _v2 = _v1.a;
                            var session = _v2.a;
                            var url = _v1.b.a;
                            if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT)) return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                            else {
                                var _v3 = A3(page.aeq, session, shared, url);
                                var pageModel = _v3.a;
                                var cmd = _v3.b;
                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoaded(pageModel), cmd, _List_Nil);
                            }
                        case 2:
                            return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                        default:
                            break _v1$2;
                    }
                    else break _v1$2;
                }
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aeR, shared, _Utils_update(modelWithSession, {
                        Ej: shared.Ej
                    }))));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            ag3: F2(function(model, shared) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2(page.ag3, modelWithSession, shared);
                } else return shared;
            }),
            ahE: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.ahE(modelWithSession);
                } else return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(msg, model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aaO, msg, modelWithSession));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.aid(modelWithSession);
                } else return {
                    fb: $author$project$Components$BlankPage$view,
                    $2: 'Loading...'
                };
            }
        };
    };
    var $author$project$Pages$Admin$ScheduledJobs$GotScheduledJobs = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$ScheduledJob$ScheduledJob = $elm$core$Basics$identity;
    var $author$project$Api$ScheduledJob$OptionsRecord = function(description) {
        return {
            NQ: description
        };
    };
    var $author$project$Api$ScheduledJob$optionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$ScheduledJob$OptionsRecord));
    var $author$project$Api$ScheduledJob$itemDecoder = A2($elm$json$Json$Decode$andThen, function(a) {
        return A2($elm$json$Json$Decode$andThen, function(b) {
            return A2($elm$json$Json$Decode$map, function(c) {
                return _Utils_Tuple3(a, b, c);
            }, A2($elm$json$Json$Decode$index, 2, $author$project$Api$ScheduledJob$optionsRecordDecoder));
        }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string));
    var $author$project$Api$ScheduledJob$scheduledJobDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$ScheduledJob$itemDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$ScheduledJob$scheduledJobsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'scheduled_jobs'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$ScheduledJob$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$ScheduledJob$scheduledJobDecoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$ScheduledJob$scheduledJobsPath));
    });
    var $author$project$Pages$Admin$ScheduledJobs$init = F3(function(_v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        return _Utils_Tuple2({
            Ej: apiClient,
            sF: $author$project$Api$Data$Loading,
            oV: $elm$core$Maybe$Nothing
        }, A2($author$project$Api$ScheduledJob$list, apiClient, $author$project$Pages$Admin$ScheduledJobs$GotScheduledJobs));
    });
    var $author$project$Pages$Admin$ScheduledJobs$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$ScheduledJobs$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$ScheduledJobs$subscriptions = function(_v0) {
        var triggerScheduledJobIndex = _v0.oV;
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed), triggerScheduledJobIndex));
    };
    var $author$project$Pages$Admin$ScheduledJobs$GotTriggerResponse = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$ScheduledJob$trigger = F3(function(apiClient, scheduledJobId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('scheduled_job', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$int(scheduledJobId))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$ScheduledJob$scheduledJobsPath)));
    });
    var $author$project$Pages$Admin$ScheduledJobs$update = F2(function(msg, model) {
        switch(msg.$){
            case 2:
                var index = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    oV: $elm$core$Maybe$Just(index)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var index = msg.a;
                var confirmed = msg.b;
                var cmd = confirmed ? A3($author$project$Api$ScheduledJob$trigger, model.Ej, index, $author$project$Pages$Admin$ScheduledJobs$GotTriggerResponse) : $elm$core$Platform$Cmd$none;
                return _Utils_Tuple3(_Utils_update(model, {
                    oV: $elm$core$Maybe$Nothing
                }), cmd, _List_Nil);
            case 0:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Job Enqueued!')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var dataScheduledJobs = msg.a;
                var newModel = _Utils_update(model, {
                    sF: dataScheduledJobs
                });
                if (dataScheduledJobs.$ === 2) {
                    var error = dataScheduledJobs.a;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(dataScheduledJobs)));
                } else return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$ScheduledJobs$TriggerScheduledJob = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$ScheduledJob$cron = function(_v0) {
        var _v1 = _v0;
        var cron_ = _v1.a;
        return cron_;
    };
    var $author$project$Pages$Admin$ScheduledJobs$cronGuruLink = function(cron) {
        return 'https://crontab.guru/#' + A3($elm$core$String$replace, ' ', '_', cron);
    };
    var $author$project$Api$ScheduledJob$description = function(_v0) {
        var _v1 = _v0;
        var optionsRecord = _v1.c;
        return optionsRecord.NQ;
    };
    var $author$project$Api$ScheduledJob$name = function(_v0) {
        var _v1 = _v0;
        var name_ = _v1.b;
        return name_;
    };
    var $author$project$Pages$Admin$ScheduledJobs$viewScheduledJobs = F2(function(index, scheduledJob) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$ScheduledJob$description(scheduledJob))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$ScheduledJob$name(scheduledJob))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$externalHref, $author$project$Pages$Admin$ScheduledJobs$cronGuruLink($author$project$Api$ScheduledJob$cron(scheduledJob)), _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$ScheduledJob$cron(scheduledJob))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Enqueue scheduled job now'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$ScheduledJobs$TriggerScheduledJob(index))
                ]), _List_fromArray([
                    $elm$html$Html$text('Enqueue Now')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$ScheduledJobs$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.oV;
                    if (!_v0.$) {
                        var index = _v0.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$ScheduledJobs$HiConfirmClosed(index), _List_fromArray([
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text('Are you sure you want to enqueue this job?')
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Scheduled Jobs')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A4($author$project$Ui$Table$view, _List_fromArray([
                            $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.sF))
                        ]), _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Description')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Worker Name')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Cron Schedule')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('')
                            ]))
                        ]), function() {
                            var _v1 = model.sF;
                            if (_v1.$ === 3) {
                                var scheduledJobs = _v1.a;
                                return A2($elm$core$List$indexedMap, $author$project$Pages$Admin$ScheduledJobs$viewScheduledJobs, scheduledJobs);
                            } else return _List_Nil;
                        }(), _List_Nil)
                    ]))
                ]))
            ]),
            $2: 'Admin | Scheduled Jobs'
        };
    };
    var $author$project$Pages$Admin$ScheduledJobs$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Admin$ScheduledJobs$init,
        aeR: $author$project$Pages$Admin$ScheduledJobs$load,
        ag3: $author$project$Pages$Admin$ScheduledJobs$save,
        ahE: $author$project$Pages$Admin$ScheduledJobs$subscriptions,
        aaO: $author$project$Pages$Admin$ScheduledJobs$update,
        aid: $author$project$Pages$Admin$ScheduledJobs$view
    });
    var $author$project$Api$Provider$Practice$One$membershipCancellationEnabled = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ae$;
    });
    var $author$project$Pages$Admin$SelfService$mapFormFields = function(practice) {
        return {
            ae$: $author$project$Api$Provider$Practice$One$membershipCancellationEnabled(practice)
        };
    };
    var $author$project$Pages$Admin$SelfService$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        return _Utils_Tuple2({
            Ej: apiClient,
            adM: $author$project$Pages$Admin$SelfService$mapFormFields(practice),
            W1: practice,
            Z$: session
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$SelfService$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$SelfService$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$SelfService$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$SelfService$MembershipCancellationToggled = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$SelfService$updateField = F2(function(field, fields) {
        var enabled = field;
        return _Utils_update(fields, {
            ae$: enabled
        });
    });
    var $author$project$Api$Provider$Practice$updateMembershipCancellationEnabled = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('membership_cancellation_enabled', $elm$json$Json$Encode$bool(fields.ae$))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Admin$SelfService$update = F2(function(msg, model) {
        if (!msg.$) {
            var field = msg.a;
            var newFields = A2($author$project$Pages$Admin$SelfService$updateField, field, $author$project$Pages$Admin$SelfService$mapFormFields(model.W1));
            return _Utils_Tuple3(_Utils_update(model, {
                adM: newFields
            }), A3($author$project$Api$Provider$Practice$updateMembershipCancellationEnabled, model.Ej, newFields, $author$project$Pages$Admin$SelfService$MembershipCancellationToggled), _List_Nil);
        } else {
            var response = msg.a;
            if (response.$ === 3) {
                var practice = response.a;
                var newModel = _Utils_update(model, {
                    adM: $author$project$Pages$Admin$SelfService$mapFormFields(practice),
                    W1: practice
                });
                var message = 'Your practice has been updated';
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, message),
                    $author$project$OutMsg$PracticeUpdated(response)
                ]));
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Api$Provider$Practice$One$selfServiceRequestAccessUrl = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.ZG;
    });
    var $author$project$Pages$Admin$SelfService$selfServiceUrl = function(practice) {
        return $author$project$Api$Provider$Practice$One$selfServiceRequestAccessUrl(practice);
    };
    var $author$project$Pages$Admin$SelfService$FieldChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$SelfService$MembershipCancellationEnabled = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$SelfService$settingToggle = F3(function(label, labelHelp, toggleSwitch) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(label),
                    $author$project$Ui$Form$Group$labelHelp(labelHelp),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$labelSpan(9),
                    $author$project$Ui$Form$Group$inputSpan(3),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(3),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                toggleSwitch
            ]))
        ]));
    });
    var $author$project$Pages$Admin$SelfService$viewMembershipCancellationSetting = function(fields) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(fields.ae$),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$SelfService$FieldChanged, $elm$core$Basics$identity))
        ]));
        var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Some states require that canceling a subscription must be as easy as signing up. If you offer online sign-up, be sure to check your state laws to stay compliant.')
            ]))
        ]));
        return A3($author$project$Pages$Admin$SelfService$settingToggle, 'Allow patients to cancel via patient portal', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Pages$Admin$SelfService$view = function(_v0) {
        var practice = _v0.W1;
        var fields = _v0.adM;
        return {
            fb: function() {
                var url = $author$project$Pages$Admin$SelfService$selfServiceUrl(practice);
                return _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Patient Portal')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Add this custom URL to your website to allow patients to manage their invoices, payment methods, plan members, and agreements.')
                            ])),
                            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$labelSpan(3),
                                    $author$project$Ui$Form$Group$inputSpan(4),
                                    $author$project$Ui$Form$Group$label('Patient Portal Self-Service URL')
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                        A3($author$project$Ui$Link$externalHref, url, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text(url)
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(12)
                                ]), _List_fromArray([
                                    $author$project$Ui$HorizontalRule$view(_List_fromArray([
                                        $author$project$Ui$HorizontalRule$thin
                                    ])),
                                    $author$project$Utils$Html$noBreakSpace,
                                    $author$project$Pages$Admin$SelfService$viewMembershipCancellationSetting(fields),
                                    $author$project$Utils$Html$noBreakSpace
                                ]))
                            ]))
                        ]))
                    ]))
                ]);
            }(),
            $2: 'Admin | Self-Service'
        };
    };
    var $author$project$Pages$Admin$SelfService$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$SelfService$init,
        aeR: $author$project$Pages$Admin$SelfService$load,
        ag3: $author$project$Pages$Admin$SelfService$save,
        ahE: $author$project$Pages$Admin$SelfService$subscriptions,
        aaO: $author$project$Pages$Admin$SelfService$update,
        aid: $author$project$Pages$Admin$SelfService$view
    });
    var $author$project$Pages$Admin$Signup$GotCurrentDate = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Signup$InitPractice = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Signup$GotDefaultSignupPage = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$SignupPage$All$SignupPage = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SignupPage$Shared$SignupPage = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SignupPage$Shared$Record = function(id) {
        return function(slug) {
            return function(_default) {
                return function(active) {
                    return function(type_) {
                        return function(url) {
                            return function(baseUrl) {
                                return function(isDestroyable) {
                                    return function(acceptsNewSignup) {
                                        return function(limitAvailablePractitioners) {
                                            return function(limitAvailableLocations) {
                                                return function(limitAvailableLocationGroups) {
                                                    return function(useCustomSettings) {
                                                        return function(redirectsPostSignup) {
                                                            return function(postSignupRedirectUrl) {
                                                                return function(postSignupMessage) {
                                                                    return function(showPostSignupFooterButton) {
                                                                        return function(postSignupButtonLabel) {
                                                                            return function(chargeItem) {
                                                                                return function(signupPagePlans) {
                                                                                    return function(addons) {
                                                                                        return {
                                                                                            Ih: acceptsNewSignup,
                                                                                            Ir: active,
                                                                                            IH: addons,
                                                                                            abX: baseUrl,
                                                                                            lv: chargeItem,
                                                                                            Nn: _default,
                                                                                            aef: id,
                                                                                            R1: isDestroyable,
                                                                                            S9: limitAvailableLocationGroups,
                                                                                            Ta: limitAvailableLocations,
                                                                                            Tb: limitAvailablePractitioners,
                                                                                            WZ: postSignupButtonLabel,
                                                                                            W_: postSignupMessage,
                                                                                            W$: postSignupRedirectUrl,
                                                                                            Yp: redirectsPostSignup,
                                                                                            _j: showPostSignupFooterButton,
                                                                                            _s: signupPagePlans,
                                                                                            _A: slug,
                                                                                            ah5: type_,
                                                                                            aaT: url,
                                                                                            aaU: useCustomSettings
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$SignupPagePlan$Shared$SignupPagePlan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SignupPagePlan$Shared$Record = F2(function(id, plan) {
        return {
            aef: id,
            GW: plan
        };
    });
    var $author$project$Api$Provider$SignupPagePlan$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Plan$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPagePlan$Shared$Record)));
    var $author$project$Api$Provider$SignupPagePlan$Shared$sharedDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SignupPagePlan$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SignupPage$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'addons', $elm$json$Json$Decode$list($author$project$Api$Provider$Addon$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signup_page_plans', $elm$json$Json$Decode$list($author$project$Api$Provider$SignupPagePlan$Shared$sharedDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_item', $elm$json$Json$Decode$nullable($author$project$Api$Provider$ChargeItem$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_button_label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'show_post_signup_footer_button', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_redirect_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redirects_post_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'use_custom_settings', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'limit_available_location_groups', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'limit_available_locations', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'limit_available_practitioners', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_new_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'base_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'slug', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$Shared$Record))))))))))))))))))))));
    var $author$project$Api$Provider$SignupPage$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SignupPage$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SignupPage$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SignupPage$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SignupPage$signupPagesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'signup_pages'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$SignupPage$getDefault = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$SignupPage$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$bool, 'default', true)
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
    });
    var $author$project$Pages$Admin$Signup$getDefaultSignupPage = function(model) {
        return A2($author$project$Api$Provider$SignupPage$getDefault, model.Ej, $author$project$Pages$Admin$Signup$GotDefaultSignupPage);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$One$postSignupButtonLabel = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.WZ;
    });
    var $author$project$Api$Provider$Practice$One$postSignupMessage = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.W_;
    });
    var $author$project$Api$Provider$Practice$One$postSignupRedirectUrl = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.W$;
    });
    var $author$project$Api$Provider$Practice$One$redirectsPostSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Yp;
    });
    var $author$project$Api$Provider$Practice$One$showPostSignupFooterButton = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $._j;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsInit = function(practice) {
        return {
            WZ: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Practice$One$postSignupButtonLabel(practice)),
            W_: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Practice$One$postSignupMessage(practice)),
            W$: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Practice$One$postSignupRedirectUrl(practice)),
            Yp: $author$project$Api$Provider$Practice$One$redirectsPostSignup(practice),
            _j: $author$project$Api$Provider$Practice$One$showPostSignupFooterButton(practice)
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init = function(practice) {
        return {
            im: $elm$core$Set$empty,
            fK: _List_Nil,
            PU: $author$project$Utils$Form$init($author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsInit(practice)),
            o$: $jinjor$elm_debounce$Debounce$init
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$One$allowPayerOnBehalfOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Jb;
    });
    var $author$project$Api$Provider$Practice$One$allowedZipCodesOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Jf;
    });
    var $author$project$Api$Provider$Practice$One$autoConfirmSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.JT;
    });
    var $author$project$Api$Provider$Practice$One$collectAddressOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Lo;
    });
    var $author$project$Api$Provider$Practice$One$collectBillingAddressOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Lp;
    });
    var $author$project$Api$Provider$Practice$One$collectBrokerOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Lq;
    });
    var $author$project$Api$Provider$Practice$One$collectInsuranceOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Lt;
    });
    var $author$project$Api$Provider$Practice$One$collectLeadSourceOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Lu;
    });
    var $author$project$Api$Provider$Practice$One$mergeDuplicatePatientsOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Uc;
    });
    var $author$project$Api$Provider$Practice$One$minEnrollAge = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Uk;
    });
    var $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Xj;
    });
    var $author$project$Api$Provider$Practice$One$restrictZipCodesOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.YV;
    });
    var $author$project$Api$Provider$Practice$One$startDateSelectableOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $._1;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsInit = function(practice) {
        var minEnrollAge = $author$project$Api$Provider$Practice$One$minEnrollAge(practice);
        return {
            Jb: $author$project$Api$Provider$Practice$One$allowPayerOnBehalfOnSignup(practice),
            px: $author$project$Api$Provider$Practice$One$allowedZipCodesOnSignup(practice),
            la: $author$project$Api$Provider$Practice$One$autoConfirmSignup(practice),
            Lo: $author$project$Api$Provider$Practice$One$collectAddressOnSignup(practice),
            Lp: $author$project$Api$Provider$Practice$One$collectBillingAddressOnSignup(practice),
            Lq: $author$project$Api$Provider$Practice$One$collectBrokerOnSignup(practice),
            Lt: $author$project$Api$Provider$Practice$One$collectInsuranceOnSignup(practice),
            Lu: $author$project$Api$Provider$Practice$One$collectLeadSourceOnSignup(practice),
            acw: $author$project$Api$Provider$Practice$One$collectLocationOnSignup(practice),
            Lx: $author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice),
            Ly: $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice),
            S0: $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice),
            Uc: $author$project$Api$Provider$Practice$One$mergeDuplicatePatientsOnSignup(practice),
            Uk: minEnrollAge,
            m8: $author$project$Utils$Maybe$toBool(minEnrollAge),
            Xj: $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup(practice),
            gE: $author$project$Api$Provider$Practice$One$restrictZipCodesOnSignup(practice),
            _1: $author$project$Api$Provider$Practice$One$startDateSelectableOnSignup(practice)
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed = {
        $: 0
    };
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$init = $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed;
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$One$acceptsAch = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Ie;
    });
    var $author$project$Api$Provider$Practice$Shared$acceptsAmex = function(_v0) {
        var record = _v0;
        return record.If;
    };
    var $author$project$Api$Provider$Practice$One$acceptsAmex = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$acceptsAmex(shared);
    };
    var $author$project$Api$Provider$Practice$Shared$acceptsCards = function(_v0) {
        var record = _v0;
        return record.Ig;
    };
    var $author$project$Api$Provider$Practice$One$acceptsCards = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$acceptsCards(shared);
    };
    var $author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Lw;
    });
    var $author$project$Api$Provider$Practice$Shared$encourageAch = function(_v0) {
        var record = _v0;
        return record.ON;
    };
    var $author$project$Api$Provider$Practice$One$encourageAch = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$encourageAch(shared);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsInit = function(practice) {
        return {
            Ie: $author$project$Api$Provider$Practice$One$acceptsAch(practice),
            If: $author$project$Api$Provider$Practice$One$acceptsAmex(practice),
            Ig: $author$project$Api$Provider$Practice$One$acceptsCards(practice),
            Lw: $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup(practice)),
            ON: $author$project$Api$Provider$Practice$One$encourageAch(practice)
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$init = function(practice) {
        var form = $author$project$Utils$Form$init($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsInit(practice));
        var fields = $author$project$Utils$Form$fields(form);
        var model = {
            PU: form,
            W1: practice,
            G4: $author$project$Api$Provider$Practice$One$prepayFirstPaymentOnSignup(practice),
            sP: !fields.If
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Ui$TagsInput$init = function(id) {
        return {
            aef: id,
            qU: false,
            cZ: '',
            sT: false
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$init = function(practice) {
        var _v0 = $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$init(practice);
        var paymentSourceComponentModel = _v0.a;
        return {
            lu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$init,
            im: $elm$core$Set$empty,
            fK: _List_Nil,
            PU: $author$project$Utils$Form$init($author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsInit(practice)),
            r0: paymentSourceComponentModel,
            W1: practice,
            tj: $author$project$Ui$TagsInput$init('restrict-by-zip-codes'),
            o$: $jinjor$elm_debounce$Debounce$init
        };
    };
    var $author$project$Api$Provider$SignupSettings$Min$customJavascriptText = function(_v0) {
        var record = _v0;
        return record.MV;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsInit = function(fields) {
        return {
            qe: fields.qe,
            _r: A2($elm$core$Maybe$withDefault, '', fields._r),
            $n: fields.$n
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$init = function(fields) {
        return {
            im: $elm$core$Set$empty,
            fK: _List_Nil,
            PU: $author$project$Utils$Form$init($author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsInit(fields)),
            td: $author$project$Api$Data$NotAsked,
            o$: $jinjor$elm_debounce$Debounce$init
        };
    };
    var $author$project$Api$Provider$Practice$One$signupPageNotFoundRedirectUrl = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $._r;
    });
    var $author$project$Api$Provider$Practice$One$signupSettings = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $._t;
    });
    var $author$project$Api$Expandable$toMaybe = function(expandable_) {
        if (!expandable_.$) {
            var a = expandable_.a;
            return $elm$core$Maybe$Just(a);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Pages$Admin$Signup$initSignupPageComponent = function(practice) {
        return $author$project$Components$Admin$GlobalSignupSettings$SignupPage$init({
            qe: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupSettings$Min$customJavascriptText, $author$project$Api$Expandable$toMaybe($author$project$Api$Provider$Practice$One$signupSettings(practice)))),
            _r: $author$project$Api$Provider$Practice$One$signupPageNotFoundRedirectUrl(practice),
            $n: $author$project$Api$Provider$Practice$One$subdomain(practice)
        });
    };
    var $author$project$Api$Provider$Practice$SignupSettings = 0;
    var $author$project$Pages$Admin$Signup$practiceOptionals = function(optionals) {
        return _Utils_update(optionals, {
            Fq: _List_fromArray([
                0
            ])
        });
    };
    var $author$project$Pages$Admin$Signup$init = F4(function(session, practice, shared, _v0) {
        var settingsComponentModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice);
        var confirmationComponentModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice);
        var model = {
            Ej: shared.Ej,
            hU: confirmationComponentModel,
            cP: $elm$core$Maybe$Nothing,
            NC: $elm$core$Maybe$Nothing,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: $author$project$Api$Data$Loading,
            Z$: session,
            j7: settingsComponentModel,
            gV: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Practice$retrieve, shared.Ej, $author$project$Pages$Admin$Signup$practiceOptionals, $author$project$Pages$Admin$Signup$InitPractice),
            $author$project$Pages$Admin$Signup$getDefaultSignupPage(model),
            A2($elm$core$Task$perform, $author$project$Pages$Admin$Signup$GotCurrentDate, $justinmimbs$date$Date$today)
        ])));
    });
    var $author$project$Pages$Admin$Signup$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Signup$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Signup$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Signup$ConfirmationComponentMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Signup$SettingsComponentMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Signup$SignupPageComponentMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$OnChange = $elm$core$Basics$identity;
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate = function(field) {
        return A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges, $elm$core$Task$succeed(field));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors = function(model) {
        return _Utils_update(model, {
            fK: _List_Nil
        });
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup = function(bool) {
        return _Utils_Tuple2('redirects_post_signup', $elm$json$Json$Encode$bool(bool));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeField = F2(function(model, field) {
        switch(field.$){
            case 0:
                var string = field.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('post_signup_button_label', $elm$json$Json$Encode$string(string))
                ]));
            case 1:
                var string = field.a;
                var _v1 = $author$project$Utils$Form$fields(model.PU);
                var redirectsPostSignup = _v1.Yp;
                return $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('post_signup_redirect_url', $elm$json$Json$Encode$string(string)), redirectsPostSignup ? _List_fromArray([
                    $author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup(redirectsPostSignup)
                ]) : _List_Nil));
            case 2:
                var bool = field.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('show_post_signup_footer_button', $elm$json$Json$Encode$bool(bool))
                ]));
            case 3:
                var bool = field.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    $author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeRedirectsPostSignup(bool)
                ]));
            default:
                var string = field.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('post_signup_message', $elm$json$Json$Encode$string(string))
                ]));
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$CustomButtonUrlValidation = 0;
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabelValidation = 1;
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessageValidation = 4;
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignupValidation = 3;
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButtonValidation = 2;
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldValidationGroup = function(field) {
        switch(field.$){
            case 1:
                return 0;
            case 0:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            default:
                return 4;
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup = F2(function(validation, errors) {
        return A2($elm$core$List$filterMap, function(_v0) {
            var errValidation = _v0.a;
            var errMessage = _v0.b;
            return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
        }, errors);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors = F2(function(validationGroup, errors) {
        return !$elm$core$List$isEmpty(A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup, validationGroup, errors));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldHasErrors = F2(function(model, field) {
        var errored = A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldValidationGroup(field), model.fK);
        if (field.$ === 3) {
            var redirectsPostSignup = field.a;
            return redirectsPostSignup ? errored || A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors, 0, model.fK) : errored;
        } else return errored;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName = function(field) {
        switch(field.$){
            case 0:
                return 'postSignupButtonLabel';
            case 1:
                return 'customButtonUrl';
            case 2:
                return 'showPostSignupFooterButton';
            case 3:
                return 'redirectsPostSignup';
            default:
                return 'postSignupMessage';
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$isFieldDirty = F2(function(field, model) {
        return A2($elm$core$Set$member, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field), model.im);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$debounceUpdateForField = function(field) {
        switch(field.$){
            case 0:
                return true;
            case 1:
                return true;
            case 2:
                return true;
            case 3:
                return true;
            default:
                return true;
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$UpdateDebounceMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$UpdateDebounceMsg
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$processUpdate = F2(function(field, model) {
        if ($author$project$Components$Admin$GlobalSignupSettings$Confirmation$debounceUpdateForField(field)) {
            var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig, field, model.o$);
            var debounceModel = _v0.a;
            var debounceCmd = _v0.b;
            return _Utils_Tuple2(_Utils_update(model, {
                o$: debounceModel
            }), debounceCmd);
        } else return _Utils_Tuple2(model, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate(field));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldDirty = F2(function(field, model) {
        return _Utils_update(model, {
            im: A2($elm$core$Set$insert, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field), model.im)
        });
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldPristine = F2(function(field, model) {
        return _Utils_update(model, {
            im: A2($elm$core$Set$remove, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldName(field), model.im)
        });
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    WZ: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    W$: string
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    _j: bool
                });
            case 3:
                var bool = field.a;
                return _Utils_update(fields, {
                    Yp: bool
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    W_: string
                });
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateField = F2(function(field, model) {
        return _Utils_update(model, {
            PU: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$formFieldsUpdate, field, model.PU)
        });
    });
    var $author$project$Utils$Maybe$isNothing = function(maybe) {
        if (!maybe.$) return false;
        else return true;
    };
    var $author$project$Utils$Validate$isInvalidUrlStricter = function(url) {
        return $elm$core$String$isEmpty(url) ? false : $author$project$Utils$Maybe$isNothing($elm$url$Url$fromString(url));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validateCustomButtonUrl = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var postSignupRedirectUrl = _v0.W$;
        var redirectsPostSignup = _v0.Yp;
        return redirectsPostSignup && $author$project$Utils$String$isBlank(postSignupRedirectUrl) ? _List_fromArray([
            _Utils_Tuple2(0, 'cannot be blank')
        ]) : $author$project$Utils$Validate$isInvalidUrlStricter(postSignupRedirectUrl) ? _List_fromArray([
            _Utils_Tuple2(0, 'is not a valid URL')
        ]) : _List_Nil;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$Confirmation$validateCustomButtonUrl)
    ]));
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validate = function(model) {
        return $author$project$Utils$Result$merge(A2($elm$core$Result$mapError, function(errors) {
            return _Utils_update(model, {
                fK: errors
            });
        }, A2($elm$core$Result$map, $rtfeldman$elm_validate$Validate$fromValid, A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validator, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors(model)))));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var modelWithForm = A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldDirty, field, A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateField, field, model));
                var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$processUpdate, field, modelWithForm);
                var newModel = _v2.a;
                var updateCmd = _v2.b;
                return _Utils_Tuple3(newModel, updateCmd, $elm$core$Maybe$Nothing);
            case 1:
                var debounceMsg = msg.a;
                var _v3 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$updateDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$Confirmation$applyUpdate), debounceMsg, model.o$);
                var newDebouncer = _v3.a;
                var debounceCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    o$: newDebouncer
                }), debounceCmd, $elm$core$Maybe$Nothing);
            default:
                var field = msg.a;
                var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$validate(model);
                if (A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$isFieldDirty, field, model) && !A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$fieldHasErrors, validatedModel, field)) {
                    var pristineModel = $author$project$Components$Admin$GlobalSignupSettings$Confirmation$clearErrors(A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$setFieldPristine, field, model));
                    return _Utils_Tuple3(pristineModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$encodeField, pristineModel, field)));
                } else return _Utils_Tuple3(validatedModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowedZipCodes = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$LaunchDate = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$OnChange = $elm$core$Basics$identity;
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge = {
        $: 3
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate = function(field) {
        _v0$2: while(true)switch(field.$){
            case 16:
                return A2($elm$core$Task$perform, $elm$core$Basics$identity, $elm$core$Task$succeed($author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge));
            case 15:
                if (field.a) return $elm$core$Platform$Cmd$none;
                else break _v0$2;
            default:
                break _v0$2;
        }
        return A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges, $elm$core$Task$succeed(field));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue = F2(function(forceRequire, collectAddressOption) {
        return forceRequire ? 2 : collectAddressOption;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress = function(collectOption) {
        return _Utils_Tuple2('collect_address_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject = F2(function(key, value) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2(key, value)
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField = F2(function(model, field) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return !bool ? $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('auto_confirm_signups', $elm$json$Json$Encode$bool(bool)),
                    _Utils_Tuple2('prepay_first_payment_on_signup', $elm$json$Json$Encode$bool(false))
                ])) : A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'auto_confirm_signups', $elm$json$Json$Encode$bool(bool));
            case 1:
                var bool = field.a;
                return bool ? $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('prepay_first_payment_on_signup', $elm$json$Json$Encode$bool(bool)),
                    _Utils_Tuple2('collect_payment_source_on_signup', $author$project$Api$CollectOnSignup$encoder(2))
                ])) : A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'prepay_first_payment_on_signup', $elm$json$Json$Encode$bool(bool));
            case 2:
                var bool = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'merge_duplicate_patients_on_online_signup', $elm$json$Json$Encode$bool(bool));
            case 3:
                var restrict = field.a;
                var _v1 = $author$project$Utils$Form$fields(model.PU);
                var collectAddressOnSignup = _v1.Lo;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('restrict_zip_codes_on_signup', $elm$json$Json$Encode$bool(restrict)),
                    $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress(A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue, restrict, collectAddressOnSignup))
                ]));
            case 4:
                var zipCodes = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'allowed_zip_codes_on_signup', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, zipCodes));
            case 5:
                var collectOption = field.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    $author$project$Components$Admin$GlobalSignupSettings$Settings$encodeCollectAddress(collectOption)
                ]));
            case 6:
                var collectOption = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'collect_billing_address_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
            case 7:
                var collectOption = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'collect_practitioner_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
            case 8:
                var collectOption = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'collect_location_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
            case 9:
                var collectOption = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'collect_ssn_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
            case 10:
                var collectOption = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'collect_lead_source_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
            case 11:
                var collectOption = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'collect_broker_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
            case 12:
                var collectOption = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'allows_payer_on_behalf_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
            case 13:
                var bool = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'start_date_selectable_on_signup', $elm$json$Json$Encode$bool(bool));
            case 14:
                var collectOption = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'collect_insurance_on_signup', $author$project$Api$CollectOnSignup$encoder(collectOption));
            case 15:
                return $elm$json$Json$Encode$null;
            case 16:
                var maybeAge = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'min_enroll_age', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, $elm$core$String$toInt(maybeAge)));
            default:
                var date = field.a;
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeObject, 'launch_date', $author$project$Utils$Date$encode(date));
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString = function(minEnrollAge) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, minEnrollAge));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeValidation = 0;
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$NoValidation = 1;
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldValidationGroup = function(field) {
        if (field.$ === 16) return 0;
        else return 1;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$errorsForGroup = F2(function(validation, errors) {
        return A2($elm$core$List$filterMap, function(_v0) {
            var errValidation = _v0.a;
            var errMessage = _v0.b;
            return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
        }, errors);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$groupHasErrors = F2(function(validationGroup, errors) {
        return !$elm$core$List$isEmpty(A2($author$project$Components$Admin$GlobalSignupSettings$Settings$errorsForGroup, validationGroup, errors));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldHasErrors = F2(function(field, errors) {
        return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$groupHasErrors, $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldValidationGroup(field), errors);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$hasErrors = function(model) {
        return !$elm$core$List$isEmpty(model.fK);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString = function(field) {
        if (field.$ === 16) return 'minEnrollAge';
        else return '';
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$isFieldDirty = F2(function(field, model) {
        return A2($elm$core$Set$member, $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field), model.im);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$GotToday = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open = F3(function(a, b, c) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$open = function() {
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2(A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, $elm$core$Maybe$Nothing, dateInput, $elm$core$Maybe$Nothing), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$GotToday, $justinmimbs$date$Date$today),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg(dateInput), dateInputCmd)
        ])));
    }();
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$debounceUpdateForField = function(field) {
        if (field.$ === 16) return true;
        else return false;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$UpdateDebounceMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Admin$GlobalSignupSettings$Settings$UpdateDebounceMsg
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$processUpdate = F2(function(field, model) {
        var _v0 = _Utils_Tuple2($author$project$Components$Admin$GlobalSignupSettings$Settings$debounceUpdateForField(field), field);
        if (_v0.a) {
            var _v1 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig, field, model.o$);
            var debounceModel = _v1.a;
            var debounceCmd = _v1.b;
            return _Utils_Tuple2(_Utils_update(model, {
                o$: debounceModel
            }), debounceCmd);
        } else {
            if (_v0.b.$ === 15) {
                if (_v0.b.a) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                else return _Utils_Tuple2(model, A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $elm$core$Task$succeed($author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge(''))));
            } else return _Utils_Tuple2(model, $author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate(field));
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldDirty = F2(function(field, model) {
        return _Utils_update(model, {
            im: A2($elm$core$Set$insert, $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field), model.im)
        });
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldPristine = F2(function(field, model) {
        return _Utils_update(model, {
            im: A2($elm$core$Set$remove, $author$project$Components$Admin$GlobalSignupSettings$Settings$fieldNameString(field), model.im)
        });
    });
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateChanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$LaunchDateChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None = {
        $: 0
    };
    var $author$project$Api$Provider$Practice$changeLaunchDate = F3(function(apiClient, maybeDate, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('new_launch_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, maybeDate))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'launch_date'
        ]), $author$project$Api$Provider$Practice$practicePath))));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                    zi: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed,
                    at: _List_Nil
                };
            case 3:
                var dateInputModel = msg.a;
                var dateInputMsg = msg.b;
                var _v1 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
                var newDateInput = _v1.a;
                var subCmd = _v1.b;
                var event = _v1.c;
                if (model.$ === 1) {
                    var maybeToday = model.c;
                    if (event.$ === 1) {
                        var maybeDate = event.a;
                        return {
                            EQ: subCmd,
                            adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                            zi: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, newDateInput, maybeToday),
                            at: _List_Nil
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                        zi: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, $elm$core$Maybe$Nothing, newDateInput, maybeToday),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                    zi: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed,
                    at: _List_Nil
                };
            case 1:
                if (model.$ === 1) {
                    var maybeDate = model.a;
                    var dateInput = model.b;
                    var maybeToday = model.c;
                    return {
                        EQ: A3($author$project$Api$Provider$Practice$changeLaunchDate, apiClient, maybeDate, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateChanged),
                        adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                        zi: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, dateInput, maybeToday),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                    zi: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (model.$ === 1) {
                    var maybeDate = model.a;
                    var dateInput = model.b;
                    var maybeToday = model.c;
                    switch(response.$){
                        case 3:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$LaunchDateChanged(maybeDate),
                                zi: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed,
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, 'Practice launch date has been Updated'),
                                    $author$project$OutMsg$PracticeUpdated(response)
                                ])
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                                zi: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, dateInput, maybeToday),
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, 'Practice launch date cannot be changed. Please contact us for more information.')
                                ])
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                                zi: model,
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                    zi: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed,
                    at: _List_Nil
                };
            default:
                var today = msg.a;
                if (model.$ === 1) {
                    var maybeDate = model.a;
                    var dateInput = model.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                        zi: A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Open, maybeDate, dateInput, $elm$core$Maybe$Just(today)),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$None,
                    zi: $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$Closed,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$OnChange = $elm$core$Basics$identity;
    var $author$project$Api$CollectOnSignup$encoderMaybe = function(maybeCustomType) {
        if (!maybeCustomType.$) {
            var customType = maybeCustomType.a;
            return $author$project$Api$CollectOnSignup$encoder(customType);
        } else return $elm$json$Json$Encode$null;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$encodeForm = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('collect_payment_source_on_signup', $author$project$Api$CollectOnSignup$encoderMaybe(fields.Lw)),
            _Utils_Tuple2('accepts_ach', $elm$json$Json$Encode$bool(fields.Ie)),
            _Utils_Tuple2('accepts_cards', $elm$json$Json$Encode$bool(fields.Ig)),
            _Utils_Tuple2('encourage_ach', $elm$json$Json$Encode$bool(fields.ON)),
            _Utils_Tuple2('accepts_amex', $elm$json$Json$Encode$bool(fields.If))
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var collectSignupRequirement = field.a;
                if (!collectSignupRequirement.$) {
                    var value = collectSignupRequirement.a;
                    if (!value) return _Utils_update(fields, {
                        Ie: false,
                        If: false,
                        Ig: false,
                        Lw: $elm$core$Maybe$Just(value),
                        ON: false
                    });
                    else return _Utils_update(fields, {
                        Ie: true,
                        Ig: true,
                        Lw: $elm$core$Maybe$Just(value)
                    });
                } else return fields;
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ie: bool
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ig: bool
                });
            case 3:
                var bool = field.a;
                return _Utils_update(fields, {
                    ON: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    If: bool
                });
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$update = F2(function(msg, _v0) {
        var model = _v0;
        var field = msg;
        var newModel = function() {
            if (field.$ === 4 && !field.a) return _Utils_update(model, {
                sP: true
            });
            else return _Utils_update(model, {
                sP: false
            });
        }();
        var form = A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$formFieldsUpdate, field, model.PU);
        return _Utils_Tuple3(_Utils_update(newModel, {
            PU: form
        }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$encodeForm(form)));
    });
    var $author$project$Ui$TagsInput$TagRemoved = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$TagsInput$TagAdded = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$TagsInput$mask = function(pattern_) {
        return $agustinrhcp$elm_mask$Mask$fromString(pattern_);
    };
    var $author$project$Ui$TagsInput$tagFitsPattern = F2(function(maybePattern, tag) {
        if (!maybePattern.$) {
            var pattern_ = maybePattern.a;
            var maskedTag = A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Ui$TagsInput$mask(pattern_), tag);
            return _Utils_eq(maskedTag, tag) && _Utils_eq($elm$core$String$length(maskedTag), $elm$core$String$length(pattern_));
        } else return true;
    });
    var $author$project$Ui$TagsInput$isTagValid = F3(function(maybePattern, tags_, tag) {
        var trimmed = $elm$core$String$trim(tag);
        return A2($author$project$Ui$TagsInput$tagFitsPattern, maybePattern, trimmed) && !A2($elm$core$List$member, trimmed, tags_);
    });
    var $author$project$Ui$TagsInput$submitInput = F4(function(ignoreNextInputUpdate, pattern_, tags_, model) {
        var valid = A3($author$project$Ui$TagsInput$isTagValid, pattern_, tags_, model.cZ);
        var newModel = _Utils_update(model, {
            qU: ignoreNextInputUpdate,
            sT: !valid
        });
        return valid ? _Utils_Tuple3(_Utils_update(newModel, {
            cZ: ''
        }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Ui$TagsInput$TagAdded(model.cZ))) : _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
    });
    var $author$project$Ui$TagsInput$updateInputValue = F2(function(newValue, model) {
        var modelAfterSubmit = _Utils_update(model, {
            qU: false
        });
        var newModel = model.qU ? modelAfterSubmit : _Utils_update(modelAfterSubmit, {
            cZ: $elm$core$String$trim(newValue),
            sT: false
        });
        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
    });
    var $author$project$Ui$TagsInput$update = F2(function(msg, model) {
        switch(msg.$){
            case 1:
                var str = msg.a;
                return A2($author$project$Ui$TagsInput$updateInputValue, str, model);
            case 0:
                var str = msg.a;
                return A2($author$project$Ui$TagsInput$updateInputValue, str, model);
            case 2:
                var pattern_ = msg.a;
                var tags_ = msg.b;
                var key = msg.c;
                switch(key){
                    case 13:
                        return A4($author$project$Ui$TagsInput$submitInput, false, pattern_, tags_, model);
                    case 32:
                        return A4($author$project$Ui$TagsInput$submitInput, true, pattern_, tags_, model);
                    case 188:
                        return A4($author$project$Ui$TagsInput$submitInput, true, pattern_, tags_, model);
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                }
            case 3:
                var pattern_ = msg.a;
                var tags_ = msg.b;
                return A4($author$project$Ui$TagsInput$submitInput, false, pattern_, tags_, model);
            default:
                var tag = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Ui$TagsInput$TagRemoved(tag)));
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return !bool ? _Utils_update(fields, {
                    la: bool,
                    Xj: false
                }) : _Utils_update(fields, {
                    la: bool
                });
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    Xj: bool
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    Uc: bool
                });
            case 3:
                var restrict = field.a;
                return _Utils_update(fields, {
                    gE: restrict
                });
            case 4:
                var zipCodes = field.a;
                return _Utils_update(fields, {
                    px: zipCodes
                });
            case 5:
                var collectAddress = field.a;
                return _Utils_update(fields, {
                    Lo: collectAddress
                });
            case 6:
                var collectShippingAddress = field.a;
                return _Utils_update(fields, {
                    Lp: collectShippingAddress
                });
            case 7:
                var collectPractitioner = field.a;
                return _Utils_update(fields, {
                    Lx: collectPractitioner
                });
            case 8:
                var collectLocation = field.a;
                return _Utils_update(fields, {
                    acw: collectLocation
                });
            case 9:
                var collectSSN = field.a;
                return _Utils_update(fields, {
                    Ly: collectSSN
                });
            case 10:
                var collectLeadSource = field.a;
                return _Utils_update(fields, {
                    Lu: collectLeadSource
                });
            case 11:
                var collectBroker = field.a;
                return _Utils_update(fields, {
                    Lq: collectBroker
                });
            case 12:
                var allowPayerOnBehalfOnSignup = field.a;
                return _Utils_update(fields, {
                    Jb: allowPayerOnBehalfOnSignup
                });
            case 13:
                var startDateSelectableOnSignup = field.a;
                return _Utils_update(fields, {
                    _1: startDateSelectableOnSignup
                });
            case 14:
                var collectOption = field.a;
                return _Utils_update(fields, {
                    Lt: collectOption
                });
            case 15:
                var bool = field.a;
                return _Utils_update(fields, {
                    m8: bool
                });
            case 16:
                var age = field.a;
                return _Utils_update(fields, {
                    Uk: $elm$core$String$toInt(age)
                });
            default:
                var date = field.a;
                return _Utils_update(fields, {
                    S0: date
                });
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$updateField = F2(function(field, model) {
        return _Utils_update(model, {
            PU: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$Settings$formFieldsUpdate, field, model.PU)
        });
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$clearErrors = function(model) {
        return _Utils_update(model, {
            fK: _List_Nil
        });
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$validateMinEnrollAge = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var minEnrollAge = _v0.Uk;
        var minEnrollAgeEnabled = _v0.m8;
        var _v1 = _Utils_Tuple2(minEnrollAge, minEnrollAgeEnabled);
        if (_v1.a.$ === 1 && _v1.b) {
            var _v2 = _v1.a;
            return _List_fromArray([
                _Utils_Tuple2(0, 'min enroll age is required')
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$Settings$validateMinEnrollAge)
    ]));
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$validate = function(model) {
        return $author$project$Utils$Result$merge(A2($elm$core$Result$mapError, function(errors) {
            return _Utils_update(model, {
                fK: errors
            });
        }, A2($elm$core$Result$map, $rtfeldman$elm_validate$Validate$fromValid, A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$Admin$GlobalSignupSettings$Settings$validator, $author$project$Components$Admin$GlobalSignupSettings$Settings$clearErrors(model)))));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var modelWithForm = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldDirty, field, A2($author$project$Components$Admin$GlobalSignupSettings$Settings$updateField, field, model));
                var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$processUpdate, field, modelWithForm);
                var newModel = _v2.a;
                var updateCmd = _v2.b;
                return _Utils_Tuple3(newModel, updateCmd, $elm$core$Maybe$Nothing);
            case 5:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$TagsInput$update, subMsg, model.tj);
                var newTagsInput = _v3.a;
                var tagsInputMsg = _v3.b;
                var maybeEvent = _v3.c;
                var modelWithComponent = _Utils_update(model, {
                    tj: newTagsInput
                });
                var _v4 = $author$project$Utils$Form$fields(modelWithComponent.PU);
                var restrictZipCodes = _v4.gE;
                var allowedZipCodes = _v4.px;
                var _v5 = A2($elm$core$Maybe$withDefault, _Utils_Tuple2(modelWithComponent, $elm$core$Maybe$Nothing), A2($elm$core$Maybe$map, function(event) {
                    var newZips = function() {
                        if (!event.$) {
                            var tag = event.a;
                            return _Utils_ap(allowedZipCodes, _List_fromArray([
                                tag
                            ]));
                        } else {
                            var tag = event.a;
                            return A2($elm_community$list_extra$List$Extra$remove, tag, allowedZipCodes);
                        }
                    }();
                    var newZipsField = $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowedZipCodes(newZips);
                    var modelWithField = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$updateField, newZipsField, modelWithComponent);
                    return _Utils_Tuple2(modelWithField, restrictZipCodes && $elm$core$List$isEmpty(newZips) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField, modelWithField, newZipsField)));
                }, maybeEvent));
                var newModel = _v5.a;
                var saveEvent = _v5.b;
                return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg, tagsInputMsg), saveEvent);
            case 1:
                var subMsg = msg.a;
                var _v7 = A2($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$update, subMsg, model.r0);
                var newComponentModel = _v7.a;
                var updateCmd = _v7.b;
                var maybeEvent = _v7.c;
                var event = A2($elm$core$Maybe$map, function(event_) {
                    var field = event_;
                    return field;
                }, maybeEvent);
                var modelWithComponent = _Utils_update(model, {
                    r0: newComponentModel
                });
                return _Utils_Tuple3(modelWithComponent, A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg, updateCmd), event);
            case 2:
                var field = msg.a;
                var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$validate(model);
                return A2($author$project$Components$Admin$GlobalSignupSettings$Settings$isFieldDirty, field, model) && !A2($author$project$Components$Admin$GlobalSignupSettings$Settings$fieldHasErrors, field, validatedModel.fK) ? _Utils_Tuple3(A2($author$project$Components$Admin$GlobalSignupSettings$Settings$setFieldPristine, field, model), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(A2($author$project$Components$Admin$GlobalSignupSettings$Settings$encodeField, validatedModel, field))) : _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 3:
                var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$Settings$validate(model);
                if ($author$project$Components$Admin$GlobalSignupSettings$Settings$hasErrors(validatedModel)) return _Utils_Tuple3(validatedModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                else {
                    var _v9 = $author$project$Utils$Form$fields(model.PU);
                    var minEnrollAge = _v9.Uk;
                    return _Utils_Tuple3(validatedModel, A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$Settings$SaveChanges, $elm$core$Task$succeed($author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge($author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString(minEnrollAge)))), $elm$core$Maybe$Nothing);
                }
            case 4:
                var debounceMsg = msg.a;
                var _v10 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Admin$GlobalSignupSettings$Settings$updateDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$Settings$applyUpdate), debounceMsg, model.o$);
                var newDebouncer = _v10.a;
                var debounceCmd = _v10.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    o$: newDebouncer
                }), debounceCmd, $elm$core$Maybe$Nothing);
            case 6:
                var _v11 = $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$open;
                var launchDateModal = _v11.a;
                var cmd = _v11.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    lu: launchDateModal
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg, cmd), $elm$core$Maybe$Nothing);
            default:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$update, apiClient, subMsg, model.lu);
                var cmd = function() {
                    var _v12 = result.adu;
                    if (_v12.$ === 1 && !_v12.a.$) {
                        var dateStart = _v12.a.a;
                        return A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $elm$core$Task$succeed($author$project$Components$Admin$GlobalSignupSettings$Settings$LaunchDate(dateStart)));
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    lu: result.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg, result.EQ)
                ])), $elm$core$Maybe$Nothing);
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$OnChange = $elm$core$Basics$identity;
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainChecked = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate = function(field) {
        if (!field.$) return A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain, $elm$core$Task$succeed(field));
        else return A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges, $elm$core$Task$succeed(field));
    };
    var $author$project$Api$Provider$Practice$Subdomains$subdomainsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'subdomains',
        'new'
    ]), $author$project$Api$Provider$Practice$practicePath);
    var $author$project$Api$Provider$Practice$Subdomains$checkSubdomain = F3(function(apiClient, toMsg, subdomain) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'subdomain[name]', subdomain)
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$Subdomains$subdomainsPath)));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors = function(model) {
        return _Utils_update(model, {
            fK: _List_Nil
        });
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName = function(field) {
        switch(field.$){
            case 0:
                return 'subdomain';
            case 1:
                return 'signup_page_not_found_redirect_url';
            default:
                return 'custom_javascript_text';
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$encodeField = function(field) {
        var fieldName_ = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field);
        switch(field.$){
            case 0:
                var subdomain = field.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2(fieldName_, $elm$json$Json$Encode$string(subdomain))
                ]));
            case 1:
                var url = field.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2(fieldName_, $elm$json$Json$Encode$string(url))
                ]));
            default:
                var text = field.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('signup_settings', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2(fieldName_, $elm$json$Json$Encode$string(text))
                    ])))
                ]));
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascriptValidation = 2;
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrlValidation = 1;
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainValidation = 0;
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldValidationGroup = function(field) {
        switch(field.$){
            case 0:
                return 0;
            case 1:
                return 1;
            default:
                return 2;
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup = F2(function(validation, errors) {
        return A2($elm$core$List$filterMap, function(_v0) {
            var errValidation = _v0.a;
            var errMessage = _v0.b;
            return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
        }, errors);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors = F2(function(validationGroup, errors) {
        return !$elm$core$List$isEmpty(A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, validationGroup, errors));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldHasErrors = F2(function(field, errors) {
        return A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldValidationGroup(field), errors);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty = F2(function(field, model) {
        return A2($elm$core$Set$member, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field), model.im);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$debounceUpdateForField = function(field) {
        switch(field.$){
            case 0:
                return true;
            case 1:
                return true;
            default:
                return true;
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$UpdateDebounceMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Admin$GlobalSignupSettings$SignupPage$UpdateDebounceMsg
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$processUpdate = F2(function(field, model) {
        if ($author$project$Components$Admin$GlobalSignupSettings$SignupPage$debounceUpdateForField(field)) {
            var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig, field, model.o$);
            var debounceModel = _v0.a;
            var debounceCmd = _v0.b;
            return _Utils_Tuple2(_Utils_update(model, {
                o$: debounceModel
            }), debounceCmd);
        } else return _Utils_Tuple2(model, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate(field));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldDirty = F2(function(field, model) {
        return _Utils_update(model, {
            im: A2($elm$core$Set$insert, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field), model.im)
        });
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldPristine = F2(function(field, model) {
        return _Utils_update(model, {
            im: A2($elm$core$Set$remove, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldName(field), model.im)
        });
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var subdomain = field.a;
                return _Utils_update(fields, {
                    $n: subdomain
                });
            case 1:
                var url = field.a;
                return _Utils_update(fields, {
                    _r: url
                });
            default:
                var text = field.a;
                return _Utils_update(fields, {
                    qe: text
                });
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateField = F2(function(field, model) {
        return _Utils_update(model, {
            PU: A3($author$project$Utils$Form$update, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$formFieldsUpdate, field, model.PU)
        });
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateCustomJavascript = function(_v0) {
        return _List_Nil;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSignupPageNotFoundRedirectUrl = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var signupPageNotFoundRedirectUrl = _v0._r;
        return $author$project$Utils$Validate$isInvalidUrlStricter(signupPageNotFoundRedirectUrl) ? _List_fromArray([
            _Utils_Tuple2(1, 'is not a valid URL')
        ]) : _List_Nil;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$parseErrorString = F2(function(token, errorString) {
        var tokenSingular = $elm$core$String$trim(token) + ' ';
        var tokenPlural = 'and ' + tokenSingular;
        return A2($elm$core$List$map, function(err) {
            return A3($elm$core$String$replace, tokenSingular, '', err);
        }, A2($elm$core$String$split, tokenPlural, errorString));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSubdomain = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var subdomain = _v0.$n;
        if ($author$project$Utils$String$isBlank(subdomain)) return _List_fromArray([
            _Utils_Tuple2(0, 'cannot be blank')
        ]);
        else {
            var _v1 = model.td;
            switch(_v1.$){
                case 2:
                    var error = _v1.a;
                    return A2($elm$core$List$map, function(errString) {
                        return _Utils_Tuple2(0, errString);
                    }, A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$parseErrorString, 'Subdomain ', $author$project$Api$Data$errorToString(error)));
                case 1:
                    return _List_fromArray([
                        _Utils_Tuple2(0, 'is being checked')
                    ]);
                default:
                    return _List_Nil;
            }
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSubdomain),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateSignupPageNotFoundRedirectUrl),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validateCustomJavascript)
    ]));
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate = function(model) {
        return $author$project$Utils$Result$merge(A2($elm$core$Result$mapError, function(errors) {
            return _Utils_update(model, {
                fK: errors
            });
        }, A2($elm$core$Result$map, $rtfeldman$elm_validate$Validate$fromValid, A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validator, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors(model)))));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var modelWithForm = A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldDirty, field, A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateField, field, model));
                var _v2 = A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$processUpdate, field, modelWithForm);
                var newModel = _v2.a;
                var updateCmd = _v2.b;
                return _Utils_Tuple3(newModel, updateCmd, $elm$core$Maybe$Nothing);
            case 1:
                var field = msg.a;
                if (A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty, field, model)) {
                    var _v3 = $author$project$Utils$Form$fields(model.PU);
                    var subdomain = _v3.$n;
                    return _Utils_Tuple3(_Utils_update(model, {
                        td: $author$project$Api$Data$Loading
                    }), A3($author$project$Api$Provider$Practice$Subdomains$checkSubdomain, apiClient, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SubdomainChecked, subdomain), $elm$core$Maybe$Nothing);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 2:
                var data = msg.a;
                var modelWithData = _Utils_update(model, {
                    td: data
                });
                switch(data.$){
                    case 3:
                        var _v5 = $author$project$Utils$Form$fields(modelWithData.PU);
                        var subdomain = _v5.$n;
                        return _Utils_Tuple3(modelWithData, A2($elm$core$Task$perform, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges, $elm$core$Task$succeed($author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain(subdomain))), $elm$core$Maybe$Nothing);
                    case 2:
                        return _Utils_Tuple3($author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate(modelWithData), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                    default:
                        return _Utils_Tuple3(modelWithData, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                }
            case 3:
                var debounceMsg = msg.a;
                var _v6 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$updateDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Admin$GlobalSignupSettings$SignupPage$applyUpdate), debounceMsg, model.o$);
                var newDebouncer = _v6.a;
                var debounceCmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    o$: newDebouncer
                }), debounceCmd, $elm$core$Maybe$Nothing);
            default:
                var field = msg.a;
                var validatedModel = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$validate(model);
                if (A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$isFieldDirty, field, model) && !A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$fieldHasErrors, field, validatedModel.fK)) {
                    var pristineModel = $author$project$Components$Admin$GlobalSignupSettings$SignupPage$clearErrors(A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$setFieldPristine, field, model));
                    return _Utils_Tuple3(pristineModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Components$Admin$GlobalSignupSettings$SignupPage$encodeField(field)));
                } else return _Utils_Tuple3(validatedModel, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
    });
    var $author$project$Pages$Admin$Signup$PracticeUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Signup$updatePractice = F2(function(model, encodedValue) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', encodedValue)
        ]));
        return A4($author$project$Api$Data$patch, model.Ej, $author$project$Api$Provider$Practice$One$decoder, $author$project$Pages$Admin$Signup$PracticeUpdated, A2($author$project$Api$Data$requestWithJson, body, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Practice$retrieveOptionsToParams($author$project$Pages$Admin$Signup$practiceOptionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath))));
    });
    var $author$project$Pages$Admin$Signup$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$update, subMsg, model.hU);
                var newComponentModel = _v1.a;
                var updateCmd = _v1.b;
                var maybeEvent = _v1.c;
                var modelWithComponent = _Utils_update(model, {
                    hU: newComponentModel
                });
                var practiceUpdateCmd = function() {
                    if (!maybeEvent.$) {
                        var encodedChange = maybeEvent.a;
                        return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(modelWithComponent, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$ConfirmationComponentMsg, updateCmd),
                    practiceUpdateCmd
                ])), _List_Nil);
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var signupPages = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        NC: $elm$core$List$head(signupPages)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 2:
                var subMsg = msg.a;
                var _v4 = A3($author$project$Components$Admin$GlobalSignupSettings$SignupPage$update, model.Ej, subMsg, model.gV);
                var newComponentModel = _v4.a;
                var componentUpdateCmd = _v4.b;
                var maybeEvent = _v4.c;
                var modelWithComponent = _Utils_update(model, {
                    gV: newComponentModel
                });
                var practiceUpdateCmd = function() {
                    if (!maybeEvent.$) {
                        var encodedChange = maybeEvent.a;
                        return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(modelWithComponent, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$SignupPageComponentMsg, componentUpdateCmd),
                    practiceUpdateCmd
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v6 = A3($author$project$Components$Admin$GlobalSignupSettings$Settings$update, model.Ej, subMsg, model.j7);
                var newComponentModel = _v6.a;
                var componentUpdateCmd = _v6.b;
                var maybeEvent = _v6.c;
                var modelWithComponent = _Utils_update(model, {
                    j7: newComponentModel
                });
                var practiceUpdateCmd = function() {
                    if (!maybeEvent.$) {
                        var encodedChange = maybeEvent.a;
                        return A2($author$project$Pages$Admin$Signup$updatePractice, modelWithComponent, encodedChange);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(modelWithComponent, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Signup$SettingsComponentMsg, componentUpdateCmd),
                    practiceUpdateCmd
                ])), _List_Nil);
            case 4:
                var response = msg.a;
                var modelWithPractice = _Utils_update(model, {
                    W1: response
                });
                if (response.$ === 3) {
                    var practice = response.a;
                    var modelWithComponents = _Utils_update(modelWithPractice, {
                        gV: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
                    });
                    return _Utils_Tuple3(modelWithComponents, $author$project$Pages$Admin$Signup$getDefaultSignupPage(modelWithComponents), _List_Nil);
                } else return _Utils_Tuple3(modelWithPractice, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    var modelWithComponents = _Utils_update(model, {
                        hU: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice),
                        W1: response,
                        j7: $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice),
                        gV: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
                    });
                    return _Utils_Tuple3(modelWithComponents, $author$project$Pages$Admin$Signup$getDefaultSignupPage(modelWithComponents), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else {
                    var newModel = function() {
                        var _v10 = model.W1;
                        if (_v10.$ === 3) {
                            var practice = _v10.a;
                            return _Utils_update(model, {
                                hU: $author$project$Components$Admin$GlobalSignupSettings$Confirmation$init(practice),
                                j7: $author$project$Components$Admin$GlobalSignupSettings$Settings$init(practice),
                                gV: $author$project$Pages$Admin$Signup$initSignupPageComponent(practice)
                            });
                        } else return model;
                    }();
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            default:
                var currentDate = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    cP: $elm$core$Maybe$Just(currentDate)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Api$Provider$SignupPage$Shared$baseUrl = function(_v0) {
        var record = _v0;
        return record.abX;
    };
    var $author$project$Api$Provider$SignupPage$All$baseUrl = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$baseUrl(shared);
    };
    var $author$project$Pages$Admin$Signup$help = function(model) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$small
        ]), _List_fromArray([
            $elm$html$Html$text('at '),
            A3($author$project$Ui$Link$externalHref, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.NC)), _List_fromArray([
                $author$project$Ui$Link$targetBlank
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.NC)))
            ]))
        ]));
    };
    var $author$project$Components$LoadingPage$view = _List_fromArray([
        A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]), _List_fromArray([
            $author$project$Ui$Spinner$view(_List_Nil)
        ]))
    ]);
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignup = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle = F3(function(label, labelHelp, toggleSwitch) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(label),
            $author$project$Ui$Form$Group$labelHelp(labelHelp),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$clearfix,
            $author$project$Ui$Form$Group$inputSpan(4),
            $author$project$Ui$Form$Group$labelSpan(7),
            $author$project$Ui$Form$Group$offsetLabel
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                toggleSwitch
            ]))
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewAutoRedirectToggle = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var redirectsPostSignup = _v0.Yp;
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$RedirectsPostSignup))
        ]));
        return A3($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle, 'Auto Redirect to External Site', $elm$html$Html$text(''), toggleSwitch);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonText = F4(function(practice, model, redirectsPostSignup, showPostSignupFooterButton) {
        if (!redirectsPostSignup && showPostSignupFooterButton) {
            var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If left blank, button will read \"Go to ' + ($author$project$Api$Provider$Practice$One$name(practice) + ' Website\".'))
                ]))
            ]));
            var _v0 = $author$project$Utils$Form$fields(model.PU);
            var postSignupButtonLabel = _v0.WZ;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(7),
                $author$project$Ui$Form$Group$label('Custom Button Text'),
                $author$project$Ui$Form$Group$labelHelp(labelHelp),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$clearfix
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(postSignupButtonLabel),
                    $author$project$Ui$Form$Input$placeholder('Go to ' + ($author$project$Api$Provider$Practice$One$name(practice) + ' Website')),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel)),
                    $author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges($author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupButtonLabel(postSignupButtonLabel))),
                    $author$project$Ui$Form$Input$withFeedback(true)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Icon$alert = $author$project$Ui$Icon$viewIcon(5);
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewErrorRow = function(message) {
        return A2($elm$html$Html$div, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Ui$Icon$alert(_List_Nil),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$margin(10),
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(message)
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonUrl = F4(function(practice, model, redirectsPostSignup, showPostSignupFooterButton) {
        if (!redirectsPostSignup && !showPostSignupFooterButton) return $author$project$Utils$Html$empty;
        else {
            var labelHelp = redirectsPostSignup ? $elm$html$Html$text('') : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Account')
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(').')
                ]))
            ]));
            var _v0 = redirectsPostSignup ? _Utils_Tuple2('Redirect URL', true) : _Utils_Tuple2('Custom Button URL', false);
            var title = _v0.a;
            var required = _v0.b;
            var _v1 = $author$project$Utils$Form$fields(model.PU);
            var postSignupRedirectUrl = _v1.W$;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(7),
                $author$project$Ui$Form$Group$label(title),
                $author$project$Ui$Form$Group$labelHelp(labelHelp),
                $author$project$Ui$Form$Group$required(required),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$clearfix
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(postSignupRedirectUrl),
                    $author$project$Ui$Form$Input$placeholder(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Practice$One$url(practice))),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$groupHasErrors, 0, model.fK)),
                    $author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges($author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupRedirectUrl(postSignupRedirectUrl))),
                    $author$project$Ui$Form$Input$withFeedback(true)
                ])),
                A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewErrorRow, A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$errorsForGroup, 0, model.fK)))
            ]));
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$OnBlur = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$onBlur = $author$project$Ui$Form$Textarea$OnBlur;
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomMessage = F2(function(model, redirectsPostSignup) {
        if (redirectsPostSignup) return $author$project$Utils$Html$empty;
        else {
            var labelHelpText = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('If left blank, the default message is \"We are thrilled to have you as a new member! Expect to receive an invoice once your membership is confirmed.\"')
            ]));
            var _v0 = $author$project$Utils$Form$fields(model.PU);
            var postSignupMessage = _v0.W_;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$offsetLabel,
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(7),
                $author$project$Ui$Form$Group$label('Custom Message for Plan Signup Pages'),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$labelHelp(labelHelpText),
                $author$project$Ui$Form$Group$clearfix
            ]), _List_fromArray([
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$placeholder('If you have any questions feel free to call our office at (333) 123-4567.'),
                    $author$project$Ui$Form$Textarea$value(postSignupMessage),
                    $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage)),
                    $author$project$Ui$Form$Textarea$onBlur($author$project$Components$Admin$GlobalSignupSettings$Confirmation$SaveChanges($author$project$Components$Admin$GlobalSignupSettings$Confirmation$PostSignupMessage(postSignupMessage)))
                ]))
            ]));
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButton = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewPostSignupButtonToggle = F2(function(redirectsPostSignup, showPostSignupFooterButton) {
        if (redirectsPostSignup) return $author$project$Utils$Html$empty;
        else {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$Confirmation$ShowPostSignupFooterButton))
            ]));
            var labelHelpText = showPostSignupFooterButton ? 'A button is displayed that can be configured below with a custom text and URL.' : 'No button will be shown, and employee should be instructed to close their current signup tab.';
            var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text(labelHelpText)
            ]));
            return A3($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewSettingToggle, 'Show Redirect Button on Confirmation', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Confirmation$view = F2(function(practice, _v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb4
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Confirmation Page')
                ]))
            ])),
            $author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewAutoRedirectToggle(model),
            A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomMessage, model, fields.Yp),
            A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewPostSignupButtonToggle, fields.Yp, fields._j),
            A4($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonText, practice, model, fields.Yp, fields._j),
            A4($author$project$Components$Admin$GlobalSignupSettings$Confirmation$viewCustomButtonUrl, practice, model, fields.Yp, fields._j)
        ]));
    });
    var $author$project$Pages$Admin$Signup$viewConfirmationComponent = F2(function(practice, confirmationComponent) {
        return A2($elm$html$Html$map, $author$project$Pages$Admin$Signup$ConfirmationComponentMsg, A2($author$project$Components$Admin$GlobalSignupSettings$Confirmation$view, practice, confirmationComponent));
    });
    var $author$project$Pages$Admin$Signup$viewMemberAgreementsText = A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$offset(1)
        ]), _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('You can add and configure your Agreements  '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Documents__Top, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here')
                ]))
            ]))
        ]))
    ]));
    var $author$project$Pages$Admin$Signup$viewMemberAgreementsSection = A2($author$project$Ui$Element$view, _List_fromArray([
        $author$project$Ui$Element$mb4
    ]), _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Member Agreements')
            ]))
        ])),
        $author$project$Pages$Admin$Signup$viewMemberAgreementsText
    ]));
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$futureLaunchDate = F2(function(currentDate, defaultMembershipStartDate) {
        var _v0 = A2($justinmimbs$date$Date$compare, defaultMembershipStartDate, currentDate);
        if (_v0 === 2) return true;
        else return false;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$StartDateSelectable = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle = F3(function(label, labelHelp, toggleSwitch) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(label),
                    $author$project$Ui$Form$Group$labelHelp(labelHelp),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix,
                    $author$project$Ui$Form$Group$labelSpan(8),
                    $author$project$Ui$Form$Group$inputSpan(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        toggleSwitch
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowFutureStartDate = function(startDateSelectableOnSignup) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(startDateSelectableOnSignup),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$StartDateSelectable))
        ]));
        var labelHelpText = startDateSelectableOnSignup ? 'The patient can choose any day in the future to start their membership.' : 'The member will not get a choice and the membership will start the day the form is submitted.';
        var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(labelHelpText)
        ]));
        return A3($author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle, 'Allow Future Start Dates', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowPayerOnBehalf = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField = function(fieldName) {
        switch(fieldName){
            case 'CollectAddress':
                return _List_fromArray([
                    0,
                    1,
                    2
                ]);
            case 'CollectBillingAddress':
                return _List_fromArray([
                    0,
                    1,
                    2
                ]);
            case 'CollectPractitioner':
                return _List_fromArray([
                    0,
                    1,
                    2
                ]);
            case 'CollectLocation':
                return _List_fromArray([
                    0,
                    2
                ]);
            case 'CollectSSN':
                return _List_fromArray([
                    0,
                    1,
                    2
                ]);
            case 'CollectLeadSource':
                return _List_fromArray([
                    0,
                    1,
                    2
                ]);
            case 'CollectBroker':
                return _List_fromArray([
                    0,
                    1,
                    2
                ]);
            case 'AllowPayerOnBehalf':
                return _List_fromArray([
                    0,
                    4,
                    3,
                    2
                ]);
            case 'CollectInsurance':
                return _List_fromArray([
                    0,
                    4
                ]);
            default:
                return _List_Nil;
        }
    };
    var $author$project$Api$CollectOnSignup$label = function(collectOnSignup) {
        switch(collectOnSignup){
            case 0:
                return 'No';
            case 1:
                return 'Optional';
            case 2:
                return 'Require';
            case 3:
                return 'Yes (and set as default)';
            default:
                return 'Yes';
        }
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignupButton = F4(function(currentCollectOnSignup, selectedCollectOnSignup, disabled, toFieldMsg) {
        var label = $author$project$Api$CollectOnSignup$label(selectedCollectOnSignup);
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
            $author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated(toFieldMsg(selectedCollectOnSignup))),
            $author$project$Ui$Button$disabled(disabled)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup = F6(function(collectOnSignup, label, labelHelp, disabled, collectOptionsList, toFieldMsg) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(label),
                    $author$project$Ui$Form$Group$labelHelp(labelHelp),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        $author$project$Ui$Button$group(A2($elm$core$List$map, function(option) {
                            return A4($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignupButton, collectOnSignup, option, disabled, toFieldMsg);
                        }, collectOptionsList))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowNonMemberPayer = function(collectOption) {
        var labelHelpText = function() {
            switch(collectOption){
                case 0:
                    return 'The payer will be also enrolled as patient.';
                case 4:
                    return 'The payer can choose to not be enrolled as a patient, but will be enrolled by default.';
                case 3:
                    return 'The payer can choose to be enrolled as a patient, but will not be enrolled by default.';
                case 2:
                    return 'The payer will not be enrolled as patient.';
                default:
                    return '';
            }
        }();
        return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOption, 'Allow non-member payers', $elm$html$Html$text(labelHelpText), false, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('AllowPayerOnBehalf'), $author$project$Components$Admin$GlobalSignupSettings$Settings$AllowPayerOnBehalf);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$AutoConfirmMembership = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAutoConfirmMembership = F3(function(futureLaunch, defaultMembershipStartDate, autoConfirmMembership) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(autoConfirmMembership),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$AutoConfirmMembership))
        ]));
        var labelHelpText = function() {
            var _v0 = _Utils_Tuple2(autoConfirmMembership, futureLaunch);
            if (_v0.a) {
                if (_v0.b) return 'Memberships will be charged on ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', defaultMembershipStartDate);
                else return 'Memberships will be charged immediately.';
            } else return 'Memberships will be charged once confirmed.';
        }();
        var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(labelHelpText)
        ]));
        return A3($author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle, 'Auto Confirm Memberships', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectAddress = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectAddress = F2(function(restrictZipCodes, collectOption) {
        var collectOptionOverride = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectAddressValue, restrictZipCodes, collectOption);
        var labelHelpText = function() {
            switch(collectOptionOverride){
                case 0:
                    return 'Addresses will not be collected.';
                case 1:
                    return 'Addresses are optional and can be left blank.';
                case 2:
                    return 'An address is required for each member.';
                default:
                    return '';
            }
        }();
        return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOptionOverride, 'Collect Address', $elm$html$Html$text(labelHelpText), restrictZipCodes, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectAddress'), $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectAddress);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBroker = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectBroker = function(collectOption) {
        var labelHelpText = function() {
            switch(collectOption){
                case 0:
                    return 'Brokers will not be collected.';
                case 1:
                    return 'Brokers are optional and can be left blank.';
                case 2:
                    return 'A broker is required for each member.';
                default:
                    return '';
            }
        }();
        return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOption, 'Collect Broker', $elm$html$Html$text(labelHelpText), false, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectBroker'), $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBroker);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectInsurance = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectInsurance = function(collectOption) {
        var labelHelpText = function() {
            switch(collectOption){
                case 0:
                    return 'Insurance (or an alternative) will not be collected.';
                case 4:
                    return 'Insurance (or an alternative) will be collected, patients can answer they don\'t have coverage.';
                default:
                    return '';
            }
        }();
        return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOption, 'Collect Insurance', $elm$html$Html$text(labelHelpText), false, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectInsurance'), $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectInsurance);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLeadSource = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLeadSource = function(collectOption) {
        var labelHelpText = function() {
            switch(collectOption){
                case 0:
                    return 'Lead sources will not be collected.';
                case 1:
                    return 'Lead sources are optional and can be left blank.';
                case 2:
                    return 'A lead source is required for each member.';
                default:
                    return '';
            }
        }();
        return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOption, 'Collect Lead Source', $elm$html$Html$text(labelHelpText), false, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectLeadSource'), $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLeadSource);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLocation = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectLocationHelp = F2(function(collectLocationEditable, collectOption) {
        if (collectLocationEditable) return $elm$html$Html$text(function() {
            switch(collectOption){
                case 0:
                    return 'Locations will not be collected.';
                case 2:
                    return 'A location is required for each member.';
                default:
                    return '';
            }
        }());
        else switch(collectOption){
            case 0:
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('This practice has no locations. You can add some ')
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Locations, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('here')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('.')
                    ]))
                ]));
            case 2:
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('This practice requires all members to have a location, you can change this setting ')
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Patients, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('here')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('.')
                    ]))
                ]));
            default:
                return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Api$Provider$Practice$One$isCollectLocationOnSignupEditable = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, A2($elm$core$Basics$composeR, function($) {
        return $.Ue;
    }, A2($elm$core$Basics$composeR, function($) {
        return $.acw;
    }, function($) {
        return $.Ot;
    })));
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLocation = F2(function(practice, collectOption) {
        var showCollectLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        if (showCollectLocation) {
            var collectLocationEditable = $author$project$Api$Provider$Practice$One$isCollectLocationOnSignupEditable(practice);
            var labelHelp = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$collectLocationHelp, collectLocationEditable, collectOption);
            return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOption, 'Collect Location', labelHelp, !collectLocationEditable, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectLocation'), $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectLocation);
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectPractitioner = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$collectProviderHelp = F3(function(collectProviderEditable, hasProviders, collectOption) {
        return collectProviderEditable ? $elm$html$Html$text(function() {
            switch(collectOption){
                case 0:
                    return 'Providers will not be collected.';
                case 1:
                    return 'Providers are optional and can be left blank.';
                case 2:
                    return 'A provider is required for each member.';
                default:
                    return '';
            }
        }()) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            hasProviders ? $elm$html$Html$text('') : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This practice has no providers. You can add some ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Providers__Top, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('.')
                ]))
            ])),
            collectOption === 2 ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This practice requires all members to have a provider, you can change this setting ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Patients, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('.')
                ]))
            ])) : $elm$html$Html$text('')
        ]));
    });
    var $author$project$Api$Provider$Practice$One$isCollectPractitionerOnSignupEditable = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, A2($elm$core$Basics$composeR, function($) {
        return $.Ue;
    }, A2($elm$core$Basics$composeR, function($) {
        return $.Lx;
    }, function($) {
        return $.Ot;
    })));
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectProvider = F2(function(practice, collectOption) {
        var hasProviders = $author$project$Api$Provider$Practice$One$hasPractitioners(practice);
        var collectProviderEditable = $author$project$Api$Provider$Practice$One$isCollectPractitionerOnSignupEditable(practice);
        var labelHelp = A3($author$project$Components$Admin$GlobalSignupSettings$Settings$collectProviderHelp, collectProviderEditable, hasProviders, collectOption);
        return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOption, 'Collect Provider', labelHelp, !collectProviderEditable, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectPractitioner'), $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectPractitioner);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectSSN = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectSSN = F2(function(requiresSSN, collectOption) {
        var labelHelpText = function() {
            switch(collectOption){
                case 0:
                    return 'SSN will not be collected.';
                case 1:
                    return 'SSN are optional and can be left blank.';
                case 2:
                    return 'A SSN is required for each member. This will prevent people without SSNs from signing up.';
                default:
                    return '';
            }
        }();
        var labelHelp = requiresSSN ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text(labelHelpText)
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('SSN is required for every patient, you can change this setting '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Patients, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here.')
                ]))
            ]))
        ])) : $elm$html$Html$text(labelHelpText);
        return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOption, 'Collect SSN', labelHelp, requiresSSN, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectSSN'), $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectSSN);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBillingAddress = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectShippingAddress = F2(function(disabled, collectOption) {
        var labelHelpText = function() {
            switch(collectOption){
                case 0:
                    return 'Shipping addresses will not be collected.';
                case 1:
                    return 'Shipping addresses are optional and can be left blank.';
                case 2:
                    return 'A shipping address is required for each member.';
                default:
                    return '';
            }
        }();
        return A6($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectOnSignup, collectOption, 'Collect Shipping Address', $elm$html$Html$text(labelHelpText), disabled, $author$project$Components$Admin$GlobalSignupSettings$Settings$collectOptionsForField('CollectBillingAddress'), $author$project$Components$Admin$GlobalSignupSettings$Settings$CollectBillingAddress);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModal = {
        $: 6
    };
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$ChangeLaunchDate = {
        $: 1
    };
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$DateInput$DisabledPickerDates = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$DateInput$disabledPickerDates = $author$project$Components$DateInput$DisabledPickerDates;
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$viewModal = F3(function(maybeDate, dateInput, today) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Change Launch Date')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Changing your launch date will not automatically change the membership start date or invoice date for any paid memberships. All pending and unpaid memberships will receive new membership start and bill dates. All unpaid membership invoices will be voided. '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Invoices, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Click here')
                        ])),
                        $elm$html$Html$text(' to view paid invoices.')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Launch Date'),
                    $author$project$Ui$Form$Group$labelSpan(6),
                    $author$project$Ui$Form$Group$labelSpanSm(8),
                    $author$project$Ui$Form$Group$inputSpan(6),
                    $author$project$Ui$Form$Group$inputSpanSm(4),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$DateInputMsg(dateInput), A2($author$project$Components$DateInput$view, _List_fromArray([
                        $author$project$Components$DateInput$value(maybeDate),
                        $author$project$Components$DateInput$disabledPickerDates(function(date) {
                            return A2($author$project$Utils$Date$isBefore, date, today);
                        })
                    ]), dateInput))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Change launch date'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$ChangeLaunchDate),
                    $author$project$Ui$Button$disabled(_Utils_eq(maybeDate, $elm$core$Maybe$Nothing))
                ]), _List_fromArray([
                    $elm$html$Html$text('Change Launch Date')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$view = function(model) {
        if (model.$ === 1) {
            var maybeDate = model.a;
            var dateInput = model.b;
            var maybeToday = model.c;
            if (!maybeToday.$) {
                var today = maybeToday.a;
                return A3($author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$viewModal, maybeDate, dateInput, today);
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewModal = function(changeLaunchDateModal) {
        if (!changeLaunchDateModal.$) {
            var modal = changeLaunchDateModal.a;
            return A2($elm$html$Html$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModalMsg, $author$project$Components$Admin$GlobalSignupSettings$ChangeLaunchDateModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMembershipStartDate = F4(function(futureLaunch, defaultMembershipStartDate, isHinter, changeLaunchDateModal) {
        var shouldShowStartDate = futureLaunch || isHinter;
        if (shouldShowStartDate) {
            var startDate = A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, defaultMembershipStartDate);
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(11),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Membership Start Date'),
                        $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Memberships will start on your launch date.')),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$clearfix,
                        $author$project$Ui$Form$Group$labelSpan(8),
                        $author$project$Ui$Form$Group$inputSpan(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$justifyRight
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(startDate),
                                $author$project$Utils$Html$noBreakSpace
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit Launch Date'
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Components$Admin$GlobalSignupSettings$Settings$OpenChangeDateModal),
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$margin(10),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit Launch Date')
                            ]))
                        ]))
                    ])),
                    $author$project$Components$Admin$GlobalSignupSettings$Settings$viewModal(changeLaunchDateModal)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$MergeInactivePatients = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMergeInactivePatients = function(mergeDuplicatePatientsOnSignup) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(mergeDuplicatePatientsOnSignup),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MergeInactivePatients))
        ]));
        var labelHelpText = mergeDuplicatePatientsOnSignup ? '\n                If a signup matches an inactive patient by name and date of birth,\n                that patient will be re-enrolled and have their payment, contract, and insurance information updated.\n                If a signup matches an active patient,\n                an error will be shown directing the prospective patient to contact the practice.\n                ' : 'Always create new patients.';
        var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(labelHelpText)
        ]));
        return A3($author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle, 'Merge with Matching Inactive Patients', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMinEnrollmentAge = F2(function(minEnrollmentAge, minEnrollAgeEnabled) {
        return minEnrollAgeEnabled ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(10),
                $author$project$Ui$Grid$offsetSm(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$label('Minimum Enroll Age'),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix,
                    $author$project$Ui$Form$Group$labelSpan(9),
                    $author$project$Ui$Form$Group$inputSpan(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value($author$project$Components$Admin$GlobalSignupSettings$Settings$enrollAgeToString(minEnrollmentAge)),
                            $author$project$Ui$Form$Input$number,
                            $author$project$Ui$Form$Input$placeholder('18'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAge)),
                            $author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$GlobalSignupSettings$Settings$ValidateMinEnrollAge),
                            $author$project$Ui$Form$Input$withFeedback(true)
                        ]))
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$CollectPaymentSourceOnSignup = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$FormUpdated = $elm$core$Basics$identity;
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton = F6(function(collectOnSignupButtonEnabled, currentCollectOnSignup, selectedCollectOnSignup, toMsg, toFieldMsg, label) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
            $author$project$Ui$Button$onClick(toMsg(toFieldMsg(selectedCollectOnSignup))),
            $author$project$Ui$Button$disabled(!collectOnSignupButtonEnabled)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignup = F8(function(collectOnSignupButtonEnabled, collectOnSignup, label, labelHelp, viewPracticeDefault, childrenContent, toMsg, toFieldMsg) {
        var extraCollectOption = viewPracticeDefault ? _List_fromArray([
            A6($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton, collectOnSignupButtonEnabled, collectOnSignup, $elm$core$Maybe$Nothing, toMsg, toFieldMsg, 'Practice Default')
        ]) : _List_Nil;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(label),
                $author$project$Ui$Form$Group$labelHelp(labelHelp),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$clearfix
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    $author$project$Ui$Button$group(A2($elm$core$List$cons, A6($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton, collectOnSignupButtonEnabled, collectOnSignup, $elm$core$Maybe$Just(0), toMsg, toFieldMsg, 'No'), A2($elm$core$List$cons, A6($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton, collectOnSignupButtonEnabled, collectOnSignup, $elm$core$Maybe$Just(1), toMsg, toFieldMsg, 'Optional'), A2($elm$core$List$cons, A6($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignupButton, collectOnSignupButtonEnabled, collectOnSignup, $elm$core$Maybe$Just(2), toMsg, toFieldMsg, 'Require'), extraCollectOption))))
                ]))
            ])), childrenContent))
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAch = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle = F3(function(label, labelHelp, toggleSwitch) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(label),
            $author$project$Ui$Form$Group$labelHelp(labelHelp),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$clearfix,
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpan(7),
            $author$project$Ui$Form$Group$inputSpan(4)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                toggleSwitch
            ]))
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch = F3(function(practiceSetting, disabled, toFieldMsg) {
        return $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(practiceSetting),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, toFieldMsg)),
            $author$project$Ui$ToggleSwitch$disabled(disabled)
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAchToggle = function(fields) {
        var disableToggle = function() {
            var _v0 = fields.Lw;
            if (!_v0.$ && !_v0.a) {
                var _v1 = _v0.a;
                return true;
            } else return !fields.Ig;
        }();
        return A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle, 'Accept Bank Accounts', $elm$html$Html$text(''), A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.Ie, disableToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAch));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAmex = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAmexWarning = function(showAmexWarning) {
        return showAmexWarning ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
            $elm$html$Html$text('If members have already added American Express cards, these will still continue to be charged, but members will not be allowed to add new American Express cards.')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAmexToggle = F2(function(fields, showAmexWarning) {
        if (fields.Ig) {
            var showDisabledToggle = function() {
                var _v0 = fields.Lw;
                if (!_v0.$ && !_v0.a) {
                    var _v1 = _v0.a;
                    return true;
                } else return false;
            }();
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle, 'Accept American Express', $elm$html$Html$text(''), A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.If, showDisabledToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsAmex)),
                $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAmexWarning(showAmexWarning)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsCards = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsCardsToggle = function(fields) {
        var disableToggle = function() {
            var _v0 = fields.Lw;
            if (!_v0.$ && !_v0.a) {
                var _v1 = _v0.a;
                return true;
            } else return !fields.Ie;
        }();
        return A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle, 'Accept Credit Cards', $elm$html$Html$text(''), A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.Ig, disableToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$AcceptsCards));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$EncourageAch = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewEncourageAchToggle = function(fields) {
        if (fields.Ie && fields.Ig) {
            var showDisabledToggle = function() {
                var _v0 = fields.Lw;
                if (!_v0.$ && !_v0.a) {
                    var _v1 = _v0.a;
                    return true;
                } else return false;
            }();
            var encourageMembersText = fields.ON ? 'When both bank accounts and credit cards are accepted, a small note would be added to the credit cards form on signup.' : '';
            return A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewSettingToggle, 'Encourage Members to Choose Bank Account', $elm$html$Html$text(encourageMembersText), A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewToggleSwitch, fields.ON, showDisabledToggle, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$EncourageAch));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewPaymentSourceAcceptedOptions = F3(function(fields, hasActivePaymentProcessorAccount, showAmexWarning) {
        return $author$project$Utils$Maybe$isNothing(fields.Lw) || !hasActivePaymentProcessorAccount ? _List_Nil : _List_fromArray([
            $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAchToggle(fields),
            $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsCardsToggle(fields),
            $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewEncourageAchToggle(fields),
            A2($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewAcceptsAmexToggle, fields, showAmexWarning)
        ]);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectPaymentSource = F4(function(fields, hasActivePaymentProcessorAccount, prepayFirstPayment, showAmexWarning) {
        var practiceSetting = A3($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewPaymentSourceAcceptedOptions, fields, hasActivePaymentProcessorAccount, showAmexWarning);
        var labelHelpText = function() {
            var _v0 = fields.Lw;
            _v0$3: while(true){
                if (!_v0.$) switch(_v0.a){
                    case 0:
                        var _v1 = _v0.a;
                        return 'Payment Source will not be collected.';
                    case 1:
                        var _v2 = _v0.a;
                        return 'Payment Source is optional and can be left blank.';
                    case 2:
                        var _v3 = _v0.a;
                        return 'A Payment Source is required.';
                    default:
                        break _v0$3;
                }
                else break _v0$3;
            }
            return '';
        }();
        var collectOnSignupButtonEnabled = !prepayFirstPayment && hasActivePaymentProcessorAccount;
        return A8($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectOnSignup, collectOnSignupButtonEnabled, fields.Lw, 'Collect Payment Source', $elm$html$Html$text(labelHelpText), false, practiceSetting, $elm$core$Basics$identity, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$CollectPaymentSourceOnSignup);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewStripeAccountWarning = function(practice) {
        return $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(5),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Utils$PaymentProcessor$toSetupAlert, $author$project$Api$Practice$Provider(practice), $elm$core$Maybe$Just('In order to collect payment sources'))
            ]))
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$view = function(_v0) {
        var model = _v0;
        var hasActivePaymentProcessorAccount = $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(model.W1);
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb4
        ]), _List_fromArray([
            A4($author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewCollectPaymentSource, fields, hasActivePaymentProcessorAccount, model.G4, model.sP),
            $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$viewStripeAccountWarning(model.W1)
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewPaymentSource = function(model) {
        return A2($elm$html$Html$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$PaymentSourceComponentMsg, $author$project$Components$Admin$GlobalSignupSettings$PaymentSource$view(model.r0));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$PrepayFirstPaymentOnSignup = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggleOffset = F3(function(label, labelHelp, toggleSwitch) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(label),
                    $author$project$Ui$Form$Group$labelHelp(labelHelp),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix,
                    $author$project$Ui$Form$Group$labelSpan(8),
                    $author$project$Ui$Form$Group$inputSpan(4),
                    $author$project$Ui$Form$Group$offsetLabel
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        toggleSwitch
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewPrepayFirstPaymentOnSignup = F2(function(prepayFirstPaymentOnSignup, autoConfirmMembership) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(prepayFirstPaymentOnSignup),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$PrepayFirstPaymentOnSignup)),
            $author$project$Ui$ToggleSwitch$disabled(!autoConfirmMembership)
        ]));
        var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('This allows you to collect a prepayment when your practice is launching in the future or for patients who select a future membership start date from the sign-up form. When enabled, the patient\'s first membership invoice will be paid upon submission of the sign-up form. ')
        ]));
        return A3($author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggleOffset, 'Prepay First Payment', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeEnabled = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictEnrollmentAge = function(minEnrollAgeEnabled) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(minEnrollAgeEnabled),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$MinEnrollAgeEnabled))
        ]));
        var labelHelpText = minEnrollAgeEnabled ? 'Under-age patients cannot be enrolled into a membership without an active adult also enrolled.' : 'Do not restrict patient enrollment into a membership based on age. Plans restrictions still apply.';
        var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(labelHelpText)
        ]));
        return A3($author$project$Components$Admin$GlobalSignupSettings$Settings$viewSettingToggle, 'Restrict enrollment by age', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$RestrictZipCodes = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$TagsInput$Pattern = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$TagsInput$pattern = $author$project$Ui$TagsInput$Pattern;
    var $author$project$Ui$TagsInput$Required = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$TagsInput$required = $author$project$Ui$TagsInput$Required;
    var $author$project$Ui$TagsInput$Tags = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$TagsInput$tags = $author$project$Ui$TagsInput$Tags;
    var $author$project$Ui$TagsInput$defaultOptions = {
        gm: $elm$core$Maybe$Nothing,
        agM: false,
        g_: _List_Nil
    };
    var $author$project$Ui$TagsInput$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var tags_ = option.a;
                    return _Utils_update(record, {
                        g_: tags_
                    });
                case 1:
                    var string = option.a;
                    return _Utils_update(record, {
                        gm: $elm$core$Maybe$Just(string)
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        agM: bool
                    });
            }
        }), $author$project$Ui$TagsInput$defaultOptions, options);
    };
    var $author$project$Ui$TagsInput$InputBlur = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$TagsInput$InputChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$TagsInput$InputKeyDown = F3(function(a, b, c) {
        return {
            $: 2,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$TagsInput$MaskedInputChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$OnKeyDown = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$onKeyDown = $author$project$Ui$Form$Input$OnKeyDown;
    var $author$project$Ui$TagsInput$viewInput = F2(function(options, model) {
        return $author$project$Ui$Form$Input$view(A2($elm$core$List$cons, $author$project$Ui$Form$Input$onKeyDown(A2($author$project$Ui$TagsInput$InputKeyDown, options.gm, options.g_)), A2($elm$core$List$cons, $author$project$Ui$Form$Input$onBlur(A2($author$project$Ui$TagsInput$InputBlur, options.gm, options.g_)), A2($elm$core$List$cons, $author$project$Ui$Form$Input$invalid(model.sT && !A3($author$project$Ui$TagsInput$isTagValid, options.gm, options.g_, model.cZ)), function() {
            var _v0 = options.gm;
            if (!_v0.$) {
                var pattern_ = _v0.a;
                return _List_fromArray([
                    A2($author$project$Ui$Form$Input$maskedValue, $author$project$Ui$TagsInput$mask(pattern_), model.cZ),
                    A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Ui$TagsInput$mask(pattern_), model.cZ, $author$project$Ui$TagsInput$MaskedInputChanged),
                    $author$project$Ui$Form$Input$placeholder(pattern_ + ',')
                ]);
            } else return _List_fromArray([
                $author$project$Ui$Form$Input$value(model.cZ),
                $author$project$Ui$Form$Input$onInput($author$project$Ui$TagsInput$InputChanged),
                $author$project$Ui$Form$Input$placeholder('tag name,')
            ]);
        }()))));
    });
    var $author$project$Ui$TagsInput$maskedTags = F2(function(maybePattern, tags_) {
        return A2($elm$core$List$filter, $author$project$Ui$TagsInput$tagFitsPattern(maybePattern), tags_);
    });
    var $author$project$Utils$String$notBlank = function(string) {
        return !$author$project$Utils$String$isBlank(string);
    };
    var $elm_community$list_extra$List$Extra$unique = function(list) {
        return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, $elm$core$Set$empty, list, _List_Nil);
    };
    var $author$project$Ui$TagsInput$filterTags = F2(function(maybePattern, tags_) {
        return A2($author$project$Ui$TagsInput$maskedTags, maybePattern, $elm_community$list_extra$List$Extra$unique(A2($elm$core$List$filter, $author$project$Utils$String$notBlank, A2($elm$core$List$map, $elm$core$String$trim, tags_))));
    });
    var $author$project$Ui$TagsInput$RemoveTag = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$TagsInput$viewTag = function(tag) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('tag-item')
        ]), _List_fromArray([
            $elm$html$Html$text(tag),
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('ml-05'),
                $elm$html$Html$Events$onClick($author$project$Ui$TagsInput$RemoveTag(tag))
            ]), _List_fromArray([
                $author$project$Ui$Icon$cross(_List_fromArray([
                    $author$project$Ui$Icon$xs
                ]))
            ]))
        ]));
    };
    var $author$project$Ui$TagsInput$viewTags = function(options) {
        var filteredTags = A2($author$project$Ui$TagsInput$filterTags, options.gm, options.g_);
        return A2($elm$core$List$map, $author$project$Ui$TagsInput$viewTag, filteredTags);
    };
    var $author$project$Ui$TagsInput$view = F2(function(options, model) {
        var optionsRecord = $author$project$Ui$TagsInput$optionsToRecord(options);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('tags-list'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('invalid', optionsRecord.agM && $elm$core$List$isEmpty(optionsRecord.g_))
            ])),
            $elm$html$Html$Attributes$id(model.aef)
        ]), A2($elm$core$List$cons, A2($author$project$Ui$TagsInput$viewInput, optionsRecord, model), $author$project$Ui$TagsInput$viewTags(optionsRecord)));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowedZipCodes = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var restrictZipCodes = _v0.gE;
        var allowedZipCodes = _v0.px;
        return restrictZipCodes ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$inputSpanSm(7),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$label('Allowed Zip Codes'),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Zip codes can be copy/pasted into this field as long as they are separated by commas.')),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Admin$GlobalSignupSettings$Settings$TagsInputMsg, A2($author$project$Ui$TagsInput$view, _List_fromArray([
                $author$project$Ui$TagsInput$tags(allowedZipCodes),
                $author$project$Ui$TagsInput$pattern('#####'),
                $author$project$Ui$TagsInput$required(true)
            ]), model.tj))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictZipCodes = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var restrictZipCodes = _v0.gE;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$offsetSm(1),
                $author$project$Ui$Grid$spanSm(11)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Restrict by Zip Codes'),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(restrictZipCodes),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$Settings$FormFieldUpdated, $author$project$Components$Admin$GlobalSignupSettings$Settings$RestrictZipCodes))
                        ]))
                    ]))
                ])),
                $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowedZipCodes(model)
            ]))
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$Settings$view = F4(function(currentDate, practice, isHintAdmin, _v0) {
        var model = _v0;
        var requiresSSN = $author$project$Api$Provider$Practice$One$requiresSSN(practice);
        var fields = $author$project$Utils$Form$fields(model.PU);
        var defaultMembershipStartDate = $author$project$Api$Provider$Practice$One$defaultMembershipStartDate(practice);
        var futureLaunch = A2($author$project$Components$Admin$GlobalSignupSettings$Settings$futureLaunchDate, currentDate, defaultMembershipStartDate);
        var changeLaunchDateModal = model.lu;
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb4
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Admin')
                ]))
            ])),
            A4($author$project$Components$Admin$GlobalSignupSettings$Settings$viewMembershipStartDate, futureLaunch, defaultMembershipStartDate, isHintAdmin, $elm$core$Maybe$Just(changeLaunchDateModal)),
            A3($author$project$Components$Admin$GlobalSignupSettings$Settings$viewAutoConfirmMembership, futureLaunch, defaultMembershipStartDate, fields.la),
            A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewPrepayFirstPaymentOnSignup, fields.Xj, fields.la),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewMergeInactivePatients(fields.Uc),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewPaymentSource(model),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictZipCodes(model),
            A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectAddress, fields.gE, fields.Lo),
            A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectShippingAddress, fields.gE, fields.Lp),
            A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectProvider, practice, fields.Lx),
            A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLocation, practice, fields.acw),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectInsurance(fields.Lt),
            A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectSSN, requiresSSN, fields.Ly),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectLeadSource(fields.Lu),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewCollectBroker(fields.Lq),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowFutureStartDate(fields._1),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewRestrictEnrollmentAge(fields.m8),
            A2($author$project$Components$Admin$GlobalSignupSettings$Settings$viewMinEnrollmentAge, fields.Uk, fields.m8),
            $author$project$Components$Admin$GlobalSignupSettings$Settings$viewAllowNonMemberPayer(fields.Jb)
        ]));
    });
    var $author$project$Pages$Admin$Signup$viewSettingsComponent = F4(function(currentDate, practice, settingsComponent, isHintAdmin) {
        return A2($elm$html$Html$map, $author$project$Pages$Admin$Signup$SettingsComponentMsg, A4($author$project$Components$Admin$GlobalSignupSettings$Settings$view, currentDate, practice, isHintAdmin, settingsComponent));
    });
    var $author$project$Api$Feature$CustomJsOnSignupPages = 8;
    var $author$project$Utils$Html$htmlIf = F2(function(ifCondition, element) {
        return ifCondition ? element : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewAddCustomJavascript = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var customJavascript = _v0.qe;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(7),
            $author$project$Ui$Form$Group$label('Add Custom Javascript'),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Please review your signup pages to confirm that your code is valid.')),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$clearfix
        ]), _List_fromArray([
            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                $author$project$Ui$Form$Textarea$rows(5),
                $author$project$Ui$Form$Textarea$value(customJavascript),
                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript)),
                $author$project$Ui$Form$Textarea$invalid(A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 2, model.fK)),
                $author$project$Ui$Form$Textarea$onBlur($author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges($author$project$Components$Admin$GlobalSignupSettings$SignupPage$CustomJavascript(customJavascript))),
                $author$project$Ui$Form$Textarea$errors(A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 2, model.fK))
            ]))
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewCustomUrl = function(practice) {
        var signupUrl = $author$project$Api$Provider$Practice$One$memberPortalSignupUrl(practice);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(7),
            $author$project$Ui$Form$Group$label('Custom Url'),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$clearfix
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A3($author$project$Ui$Link$externalHref, signupUrl, _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text(signupUrl)
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewPracticeName = function(practice) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(7),
            $author$project$Ui$Form$Group$label('Practice Name'),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$clearfix
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Practice$One$name(practice))
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Input$Url = {
        $: 3
    };
    var $author$project$Ui$Form$Input$url = $author$project$Ui$Form$Input$Type($author$project$Ui$Form$Input$Url);
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow = function(message) {
        return A2($elm$html$Html$div, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    $author$project$Ui$Icon$alert(_List_Nil),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$margin(10),
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(message)
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSignupPageNotFoundRedirectUrl = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var signupPageNotFoundRedirectUrl = _v0._r;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(7),
            $author$project$Ui$Form$Group$label('Signup Page Not Found Url'),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('When a patient tries to use a signup page that is no longer\n            live or never existed they will be shown a message including the practice\'s phone,\n            email and this url.')),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$clearfix
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(signupPageNotFoundRedirectUrl),
                $author$project$Ui$Form$Input$url,
                $author$project$Ui$Form$Input$placeholder('https://www.mypractice.com'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 1, model.fK)),
                $author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$GlobalSignupSettings$SignupPage$SaveChanges($author$project$Components$Admin$GlobalSignupSettings$SignupPage$SignupPageNotFoundRedirectUrl(signupPageNotFoundRedirectUrl))),
                $author$project$Ui$Form$Input$withFeedback(true)
            ])),
            A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow, A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 1, model.fK)))
        ]));
    };
    var $author$project$Utils$Regex$replace = F3(function(userRegex, newString, string) {
        var _v0 = $elm$regex$Regex$fromString(userRegex);
        if (_v0.$ === 1) return string;
        else {
            var regex = _v0.a;
            return A3($elm$regex$Regex$replace, regex, function(_v1) {
                return newString;
            }, string);
        }
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$subdomainify = function(practice) {
        return A3($author$project$Utils$Regex$replace, '[^\\w-]', '', A3($author$project$Utils$Regex$replace, ' ', '-', $elm$core$String$toLower($author$project$Api$Provider$Practice$One$name(practice))));
    };
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSubdomain = F2(function(practice, model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var subdomain = _v0.$n;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$offsetLabel,
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(7),
            $author$project$Ui$Form$Group$label('Subdomain'),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$clearfix
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(subdomain),
                $author$project$Ui$Form$Input$placeholder($author$project$Components$Admin$GlobalSignupSettings$SignupPage$subdomainify(practice)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$FormUpdated, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$groupHasErrors, 0, model.fK)),
                $author$project$Ui$Form$Input$onBlur($author$project$Components$Admin$GlobalSignupSettings$SignupPage$CheckSubdomain($author$project$Components$Admin$GlobalSignupSettings$SignupPage$Subdomain(subdomain))),
                $author$project$Ui$Form$Input$withFeedback(true)
            ])),
            A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewErrorRow, A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$errorsForGroup, 0, model.fK)))
        ]));
    });
    var $author$project$Components$Admin$GlobalSignupSettings$SignupPage$view = F2(function(practice, _v0) {
        var model = _v0;
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb4
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Signup Page')
                ]))
            ])),
            $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewPracticeName(practice),
            A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSubdomain, practice, model),
            $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewCustomUrl(practice),
            $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewSignupPageNotFoundRedirectUrl(model),
            A2($author$project$Utils$Html$htmlIf, A2($author$project$Api$Provider$Practice$One$featureEnabled, 8, practice), $author$project$Components$Admin$GlobalSignupSettings$SignupPage$viewAddCustomJavascript(model))
        ]));
    });
    var $author$project$Pages$Admin$Signup$viewSignupPageComponent = F2(function(practice, signupPageComponent) {
        return A2($elm$html$Html$map, $author$project$Pages$Admin$Signup$SignupPageComponentMsg, A2($author$project$Components$Admin$GlobalSignupSettings$SignupPage$view, practice, signupPageComponent));
    });
    var $author$project$Pages$Admin$Signup$viewPanelBody = function(model) {
        var _v0 = _Utils_Tuple2(model.W1, model.cP);
        if (_v0.a.$ === 3 && !_v0.b.$) {
            var _v1 = _v0.a;
            var practice = _v1.a;
            var currentDate = _v0.b.a;
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Pages$Admin$Signup$viewSignupPageComponent, practice, model.gV),
                A4($author$project$Pages$Admin$Signup$viewSettingsComponent, currentDate, practice, model.j7, model.F3),
                $author$project$Pages$Admin$Signup$viewMemberAgreementsSection,
                A2($author$project$Pages$Admin$Signup$viewConfirmationComponent, practice, model.hU)
            ]));
        } else return A2($elm$html$Html$div, _List_Nil, $author$project$Components$LoadingPage$view);
    };
    var $author$project$Pages$Admin$Signup$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Member Signup Form')
                        ])),
                        $author$project$Pages$Admin$Signup$help(model)
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Admin$Signup$viewPanelBody(model)
                    ]))
                ]))
            ]),
            $2: 'Admin | Signup Settings'
        };
    };
    var $author$project$Pages$Admin$Signup$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Signup$init,
        aeR: $author$project$Pages$Admin$Signup$load,
        ag3: $author$project$Pages$Admin$Signup$save,
        ahE: $author$project$Pages$Admin$Signup$subscriptions,
        aaO: $author$project$Pages$Admin$Signup$update,
        aid: $author$project$Pages$Admin$Signup$view
    });
    var $author$project$Pages$Admin$SignupPages$Id_String$FormMsg = $elm$core$Basics$identity;
    var $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$CompanyPlan = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$GotItem = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$RetailPlan = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$formFieldsInit = function(companyId) {
        return {
            Ir: true,
            IH: _List_Nil,
            lv: $elm$core$Maybe$Nothing,
            fl: companyId,
            S9: false,
            Ta: false,
            Tb: false,
            Tl: _List_Nil,
            Tq: _List_Nil,
            WZ: $elm$core$Maybe$Nothing,
            W_: $elm$core$Maybe$Nothing,
            W$: $elm$core$Maybe$Nothing,
            Xc: _List_Nil,
            Yp: false,
            _j: false,
            _s: _List_Nil,
            _A: '',
            ah5: 'signup',
            aaU: false
        };
    };
    var $author$project$Components$ResourceFilter$CompanyPlan$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$CompanyPlan$EmployerAll = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$CompanyPlan$ProviderAll = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyPlan$companyPlansPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'company_plans'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$CompanyPlan$All$CompanyPlan = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$CompanyPlan$Shared$CompanyPlan = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CompanyPlan$Shared$Record = F3(function(id, availableForEnrollment, isDefault) {
        return {
            JZ: availableForEnrollment,
            aef: id,
            R0: isDefault
        };
    });
    var $author$project$Api$Employer$CompanyPlan$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_default', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'available_for_enrollment', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$Shared$Record))));
    var $author$project$Api$Employer$CompanyPlan$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyPlan$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$CompanyPlan$All$Record = function(plan) {
        return {
            GW: plan
        };
    };
    var $author$project$Api$Employer$CompanyPlan$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Employer$Plan$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$All$Record));
    var $author$project$Api$Employer$CompanyPlan$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyPlan$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyPlan$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyPlan$All$CompanyPlan)));
    var $author$project$Api$Employer$CompanyPlan$expandToString = function(expand) {
        return 'pricing';
    };
    var $author$project$Api$Employer$CompanyPlan$listDefaults = {
        Fq: _List_Nil,
        aef: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Employer$CompanyPlan$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Employer$CompanyPlan$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.aef;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            _List_fromArray([
                A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Employer$CompanyPlan$expandToString, options.Fq))
            ])
        ]));
    };
    var $author$project$Api$Employer$CompanyPlan$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$CompanyPlan$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Employer$CompanyPlan$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyPlan$companyPlansPath)));
    });
    var $author$project$Api$Provider$CompanyPlan$companyPlansPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'company_plans'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$CompanyPlan$All$CompanyPlan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyPlan$One$CompanyPlan = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyPlan$Shared$CompanyPlan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyPlan$Shared$Record = F3(function(id, availableForEnrollment, isDefault) {
        return {
            JZ: availableForEnrollment,
            aef: id,
            R0: isDefault
        };
    });
    var $author$project$Api$Provider$CompanyPlan$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_default', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'available_for_enrollment', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$Shared$Record))));
    var $author$project$Api$Provider$CompanyPlan$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyPlan$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyPlan$One$Record = function(plan) {
        return {
            GW: plan
        };
    };
    var $author$project$Api$Provider$CompanyPlan$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Plan$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$One$Record));
    var $author$project$Api$Provider$CompanyPlan$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyPlan$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyPlan$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyPlan$One$CompanyPlan)));
    var $author$project$Api$Provider$CompanyPlan$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyPlan$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyPlan$expandToString = function(expand) {
        return 'pricing';
    };
    var $author$project$Api$Provider$CompanyPlan$listDefaults = {
        Fq: _List_Nil,
        aef: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$CompanyPlan$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$CompanyPlan$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.aef;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            _List_fromArray([
                A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CompanyPlan$expandToString, options.Fq))
            ])
        ]));
    };
    var $author$project$Api$Provider$CompanyPlan$list = F4(function(apiClient, companyId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CompanyPlan$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$CompanyPlan$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId))));
    });
    var $author$project$Api$Employer$CompanyPlan$Pricing = 0;
    var $author$project$Api$CompanyPlan$expandToEmployer = function(expand) {
        return 0;
    };
    var $author$project$Api$CompanyPlan$listDefaults = {
        Fq: _List_Nil,
        aef: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$CompanyPlan$optionalsToEmployer = function(optionals) {
        var options = optionals($author$project$Api$CompanyPlan$listDefaults);
        return function(d) {
            return _Utils_update(d, {
                Fq: A2($elm$core$List$map, $author$project$Api$CompanyPlan$expandToEmployer, options.Fq),
                aef: options.aef
            });
        };
    };
    var $author$project$Api$Provider$CompanyPlan$Pricing = 0;
    var $author$project$Api$CompanyPlan$expandToProvider = function(expand) {
        return 0;
    };
    var $author$project$Api$CompanyPlan$optionalsToProvider = function(optionals) {
        var options = optionals($author$project$Api$CompanyPlan$listDefaults);
        return function(d) {
            return _Utils_update(d, {
                Fq: A2($elm$core$List$map, $author$project$Api$CompanyPlan$expandToProvider, options.Fq),
                aef: options.aef
            });
        };
    };
    var $author$project$Api$CompanyPlan$list = F5(function(apiClient, session, companyId, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$CompanyPlan$list, apiClient, $author$project$Api$CompanyPlan$optionalsToEmployer(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$CompanyPlan$EmployerAll)))) : A4($author$project$Api$Provider$CompanyPlan$list, apiClient, companyId, $author$project$Api$CompanyPlan$optionalsToProvider(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$CompanyPlan$ProviderAll))));
    });
    var $author$project$Components$ResourceFilter$CompanyPlan$list = F5(function(apiClient, session, companyId, optionals, toMsg) {
        return A5($author$project$Api$CompanyPlan$list, apiClient, session, companyId, optionals, toMsg);
    });
    var $author$project$Components$ResourceFilter$CompanyPlan$fetchResources = F6(function(session, companyId, toMsg, apiClient, _v0, _v1) {
        return A5($author$project$Components$ResourceFilter$CompanyPlan$list, apiClient, session, companyId, $elm$core$Basics$identity, toMsg);
    });
    var $author$project$Components$ResourceFilter$CompanyPlan$retrieveResource = F5(function(session, companyId, toMsg, apiClient, id) {
        return A5($author$project$Components$ResourceFilter$CompanyPlan$list, apiClient, session, companyId, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$CompanyPlan$selectId = 'company_plans';
    var $author$project$Api$Plan$EmployerShared = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Plan$ProviderShared = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyPlan$All$plan = function(_v0) {
        var record = _v0.b;
        return record.GW;
    };
    var $author$project$Api$Provider$CompanyPlan$One$plan = function(_v0) {
        var record = _v0.b;
        return record.GW;
    };
    var $author$project$Api$Provider$CompanyPlan$All$plan = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$CompanyPlan$One$plan(one);
    };
    var $author$project$Api$CompanyPlan$plan = function(companyPlan) {
        switch(companyPlan.$){
            case 0:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Plan$ProviderShared($author$project$Api$Provider$CompanyPlan$One$plan(companyPlan_));
            case 1:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Plan$ProviderShared($author$project$Api$Provider$CompanyPlan$All$plan(companyPlan_));
            default:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Plan$EmployerShared($author$project$Api$Employer$CompanyPlan$All$plan(companyPlan_));
        }
    };
    var $author$project$Components$ResourceFilter$CompanyPlan$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$CompanyPlan$plan, $author$project$Api$Plan$name);
    var $author$project$Components$ResourceFilter$CompanyPlan$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$CompanyPlan$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$CompanyPlan$toValue = A2($elm$core$Basics$composeR, $author$project$Api$CompanyPlan$plan, $author$project$Api$Plan$id);
    var $author$project$Components$ResourceFilter$CompanyPlan$init = F4(function(apiClient, session, companyId, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: A2($author$project$Components$ResourceFilter$CompanyPlan$fetchResources, session, companyId),
            aef: $author$project$Components$ResourceFilter$CompanyPlan$selectId,
            gD: 'Plan',
            sz: A2($author$project$Components$ResourceFilter$CompanyPlan$retrieveResource, session, companyId),
            ahW: $author$project$Components$ResourceFilter$CompanyPlan$toLabel,
            ahZ: $author$project$Components$ResourceFilter$CompanyPlan$toTitle,
            g4: $author$project$Components$ResourceFilter$CompanyPlan$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$LocationGroup$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$LocationGroup$list = $author$project$Api$Provider$LocationGroup$list;
    var $author$project$Components$ResourceFilter$LocationGroup$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$LocationGroup$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$LocationGroup$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$LocationGroup$list, apiClient, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$LocationGroup$selectId = 'location_groups';
    var $author$project$Components$ResourceFilter$LocationGroup$toTitle = $author$project$Api$Provider$LocationGroup$All$name;
    var $author$project$Components$ResourceFilter$LocationGroup$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$LocationGroup$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$LocationGroup$toValue = $author$project$Api$Provider$LocationGroup$All$id;
    var $author$project$Components$ResourceFilter$LocationGroup$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$LocationGroup$fetchResources,
            aef: $author$project$Components$ResourceFilter$LocationGroup$selectId,
            gD: 'Group',
            sz: $author$project$Components$ResourceFilter$LocationGroup$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$LocationGroup$toLabel,
            ahZ: $author$project$Components$ResourceFilter$LocationGroup$toTitle,
            g4: $author$project$Components$ResourceFilter$LocationGroup$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Api$Provider$SignupPage$One$SignupPage = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$SignupPage$One$Record = F3(function(practitioners, locations, locationGroups) {
        return {
            Tl: locationGroups,
            Tq: locations,
            Xc: practitioners
        };
    });
    var $author$project$Api$Provider$SignupPage$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location_groups', $elm$json$Json$Decode$list($author$project$Api$Common$LocationGroup$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'locations', $elm$json$Json$Decode$list($author$project$Api$Provider$Location$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioners', $elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$One$Record))));
    var $author$project$Api$Provider$SignupPage$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SignupPage$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SignupPage$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$One$SignupPage)));
    var $author$project$Api$Provider$SignupPage$signupPagePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$SignupPage$signupPagesPath);
    };
    var $author$project$Api$Provider$SignupPage$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$SignupPage$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagePath(id_)));
    });
    var $author$project$Components$Admin$SignupPages$Form$init = F6(function(apiClient, session, practice, id, companyId, query) {
        var _v0 = A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, function(d) {
            return _Utils_update(d, {
                GF: $elm$core$Maybe$Just(true)
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Provider'
            });
        });
        var practitionerResourceFilter = _v0.a;
        var practitionerResourceFilterCmd = _v0.b;
        var _v1 = function() {
            if (!companyId.$) {
                var id_ = companyId.a;
                return A3($elm$core$Tuple$mapBoth, function(companyPlanModel) {
                    return $author$project$Components$Admin$SignupPages$Form$CompanyPlan(companyPlanModel);
                }, function(companyPlanCmd) {
                    return A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg, companyPlanCmd);
                }, A4($author$project$Components$ResourceFilter$CompanyPlan$init, apiClient, session, id_, function(d) {
                    return _Utils_update(d, {
                        Ee: 'Select a Plan'
                    });
                }));
            } else return A3($elm$core$Tuple$mapBoth, function(retailModel) {
                return $author$project$Components$Admin$SignupPages$Form$RetailPlan(retailModel);
            }, function(retailCmd) {
                return A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg, retailCmd);
            }, A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
                return _Utils_update(d, {
                    A8: _List_fromArray([
                        2,
                        3
                    ])
                });
            }, function(d) {
                return _Utils_update(d, {
                    Ee: 'Select a Plan'
                });
            }));
        }();
        var planResourceFilter = _v1.a;
        var planResourceFilterCmd = _v1.b;
        var _v3 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, function(d) {
            return _Utils_update(d, {
                GF: $elm$core$Maybe$Just(true)
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Location'
            });
        });
        var locationResourceFilter = _v3.a;
        var locationResourceFilterCmd = _v3.b;
        var _v4 = A2($author$project$Components$ResourceFilter$LocationGroup$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Location Group'
            });
        });
        var locationGroupResourceFilter = _v4.a;
        var locationGroupResourceFilterCmd = _v4.b;
        var _v5 = function() {
            if (!id.$) {
                var id_ = id.a;
                return _Utils_Tuple2($elm$core$Maybe$Nothing, A3($author$project$Api$Provider$SignupPage$retrieve, apiClient, id_, $author$project$Components$Admin$SignupPages$Form$GotItem));
            } else return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Components$Admin$SignupPages$Form$formFieldsInit(companyId))), $elm$core$Platform$Cmd$none);
        }();
        var form = _v5.a;
        var cmd = _v5.b;
        var _v7 = A3($author$project$Components$ResourceFilter$ChargeItem$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Charge'
            });
        });
        var chargeItemResourceFilter = _v7.a;
        var chargeItemResourceFilterCmd = _v7.b;
        return _Utils_Tuple2({
            cL: chargeItemResourceFilter,
            fl: companyId,
            PU: form,
            aef: id,
            rn: locationGroupResourceFilter,
            ro: locationResourceFilter,
            jy: planResourceFilter,
            W1: practice,
            jE: practitionerResourceFilter,
            Bz: query,
            j_: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            planResourceFilterCmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg, locationGroupResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$Admin$SignupPages$Id_String$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var params = _v1.VU;
        var query = _v1.Bz;
        var _v2 = A6($author$project$Components$Admin$SignupPages$Form$init, apiClient, session, practice, $elm$core$Maybe$Just(params.aef), $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(query));
        var form = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Admin$SignupPages$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$SignupPages$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$SignupPages$Id_String$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Admin$SignupPages$Form$ChargeItem = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$CompanyPlanAdd = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$LocationAdd = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$LocationGroupAdd = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$PlanAdd = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$PractitionerAdd = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$addons = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.IH;
    });
    var $author$project$Api$Provider$SignupPage$Shared$chargeItem = function(_v0) {
        var record = _v0;
        return record.lv;
    };
    var $author$project$Api$Provider$SignupPage$One$chargeItem = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$chargeItem(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$active = function(_v0) {
        var record = _v0;
        return record.Ir;
    };
    var $author$project$Api$Provider$SignupPage$One$active = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$active(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$addons = function(_v0) {
        var record = _v0;
        return record.IH;
    };
    var $author$project$Api$Provider$SignupPage$One$addons = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$addons(shared);
    };
    var $author$project$Api$Provider$Addon$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Addon$Shared$id = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Addon$Min$id(min);
    };
    var $author$project$Api$Provider$SignupPagePlan$Shared$id = function(_v0) {
        var shared = _v0;
        return shared.aef;
    };
    var $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocationGroups = function(_v0) {
        var record = _v0;
        return record.S9;
    };
    var $author$project$Api$Provider$SignupPage$One$limitAvailableLocationGroups = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocationGroups(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocations = function(_v0) {
        var record = _v0;
        return record.Ta;
    };
    var $author$project$Api$Provider$SignupPage$One$limitAvailableLocations = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$limitAvailableLocations(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$limitAvailablePractitioners = function(_v0) {
        var record = _v0;
        return record.Tb;
    };
    var $author$project$Api$Provider$SignupPage$One$limitAvailablePractitioners = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$limitAvailablePractitioners(shared);
    };
    var $author$project$Api$Provider$SignupPage$One$locationGroups = function(_v0) {
        var record = _v0.b;
        return record.Tl;
    };
    var $author$project$Api$Provider$SignupPage$One$locations = function(_v0) {
        var record = _v0.b;
        return record.Tq;
    };
    var $author$project$Api$Provider$Addon$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Addon$Shared$name = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Addon$Min$name(min);
    };
    var $author$project$Api$Provider$SignupPagePlan$Shared$plan = function(_v0) {
        var shared = _v0;
        return shared.GW;
    };
    var $author$project$Api$Provider$SignupPage$Shared$postSignupButtonLabel = function(_v0) {
        var record = _v0;
        return record.WZ;
    };
    var $author$project$Api$Provider$SignupPage$One$postSignupButtonLabel = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$postSignupButtonLabel(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$postSignupMessage = function(_v0) {
        var record = _v0;
        return record.W_;
    };
    var $author$project$Api$Provider$SignupPage$One$postSignupMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$postSignupMessage(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$postSignupRedirectUrl = function(_v0) {
        var record = _v0;
        return record.W$;
    };
    var $author$project$Api$Provider$SignupPage$One$postSignupRedirectUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$postSignupRedirectUrl(shared);
    };
    var $author$project$Api$Provider$SignupPage$One$practitioners = function(_v0) {
        var record = _v0.b;
        return record.Xc;
    };
    var $author$project$Api$Provider$SignupPage$Shared$redirectsPostSignup = function(_v0) {
        var record = _v0;
        return record.Yp;
    };
    var $author$project$Api$Provider$SignupPage$One$redirectsPostSignup = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$redirectsPostSignup(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$showPostSignupFooterButton = function(_v0) {
        var record = _v0;
        return record._j;
    };
    var $author$project$Api$Provider$SignupPage$One$showPostSignupFooterButton = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$showPostSignupFooterButton(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$signupPagePlans = function(_v0) {
        var record = _v0;
        return record._s;
    };
    var $author$project$Api$Provider$SignupPage$One$signupPagePlans = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$signupPagePlans(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$slug = function(_v0) {
        var record = _v0;
        return record._A;
    };
    var $author$project$Api$Provider$SignupPage$One$slug = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$slug(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$SignupPage$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$type_(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$useCustomSettings = function(_v0) {
        var record = _v0;
        return record.aaU;
    };
    var $author$project$Api$Provider$SignupPage$One$useCustomSettings = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$SignupPage$Shared$useCustomSettings(shared);
    };
    var $author$project$Components$Admin$SignupPages$Form$formFieldsFromItem = F2(function(item, companyId) {
        return {
            Ir: $author$project$Api$Provider$SignupPage$One$active(item),
            IH: A2($elm$core$List$map, function(addon) {
                return {
                    aef: $author$project$Api$Provider$Addon$Shared$id(addon),
                    zr: $author$project$Api$Provider$Addon$Shared$name(addon)
                };
            }, $author$project$Api$Provider$SignupPage$One$addons(item)),
            lv: A2($elm$core$Maybe$map, function(chargeItem) {
                return {
                    aef: $author$project$Api$Provider$ChargeItem$Min$id(chargeItem),
                    zr: $author$project$Api$Provider$ChargeItem$Min$name(chargeItem),
                    $S: false
                };
            }, $author$project$Api$Provider$SignupPage$One$chargeItem(item)),
            fl: companyId,
            S9: $author$project$Api$Provider$SignupPage$One$limitAvailableLocationGroups(item),
            Ta: $author$project$Api$Provider$SignupPage$One$limitAvailableLocations(item),
            Tb: $author$project$Api$Provider$SignupPage$One$limitAvailablePractitioners(item),
            Tl: A2($elm$core$List$map, function(locationGroup) {
                return {
                    aef: $author$project$Api$Common$LocationGroup$Shared$id(locationGroup),
                    zr: $author$project$Api$Common$LocationGroup$Shared$name(locationGroup)
                };
            }, $author$project$Api$Provider$SignupPage$One$locationGroups(item)),
            Tq: A2($elm$core$List$map, function(location1) {
                return {
                    aef: $author$project$Api$Provider$Location$Shared$id(location1),
                    zr: $author$project$Api$Provider$Location$Shared$name(location1)
                };
            }, $author$project$Api$Provider$SignupPage$One$locations(item)),
            WZ: $author$project$Api$Provider$SignupPage$One$postSignupButtonLabel(item),
            W_: $author$project$Api$Provider$SignupPage$One$postSignupMessage(item),
            W$: $author$project$Api$Provider$SignupPage$One$postSignupRedirectUrl(item),
            Xc: A2($elm$core$List$map, function(practitioner) {
                return {
                    aef: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
                    zr: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
                };
            }, $author$project$Api$Provider$SignupPage$One$practitioners(item)),
            Yp: $author$project$Api$Provider$SignupPage$One$redirectsPostSignup(item),
            _j: $author$project$Api$Provider$SignupPage$One$showPostSignupFooterButton(item),
            _s: A2($elm$core$List$map, function(signupPagePlan) {
                return {
                    aef: $elm$core$Maybe$Just($author$project$Api$Provider$SignupPagePlan$Shared$id(signupPagePlan)),
                    agd: $author$project$Api$Provider$Plan$Min$id($author$project$Api$Provider$SignupPagePlan$Shared$plan(signupPagePlan)),
                    WM: $author$project$Api$Provider$Plan$Min$name($author$project$Api$Provider$SignupPagePlan$Shared$plan(signupPagePlan))
                };
            }, $author$project$Api$Provider$SignupPage$One$signupPagePlans(item)),
            _A: $author$project$Api$Provider$SignupPage$One$slug(item),
            ah5: $author$project$Api$Provider$SignupPage$One$type_(item),
            aaU: $author$project$Api$Provider$SignupPage$One$useCustomSettings(item)
        };
    });
    var $author$project$Formatters$String$slugify = function(string) {
        return A3($author$project$Utils$Regex$replace, '-+$', '', A3($author$project$Utils$Regex$replace, '^-+', '', A3($author$project$Utils$Regex$replace, '\\-\\-+', '-', A3($author$project$Utils$Regex$replace, '[^\\w\\-]+', '', A3($author$project$Utils$Regex$replace, '\\s+', '-', $elm$core$String$toLower(string))))));
    };
    var $author$project$Components$Admin$SignupPages$Form$defaultSlug = F2(function(signupPagePlans, currentSlug) {
        var _v0 = _Utils_Tuple2($elm$core$List$length(signupPagePlans), $elm$core$List$head(signupPagePlans));
        if (_v0.a === 1 && !_v0.b.$) {
            var signupPagePlan = _v0.b.a;
            return $author$project$Formatters$String$slugify(signupPagePlan.WM);
        } else return currentSlug;
    });
    var $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate = F3(function(addons, field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    ah5: string
                });
            case 1:
                var plan = field.a;
                var plan_ = A2($elm_community$list_extra$List$Extra$find, function(plan__) {
                    return _Utils_eq(plan__.agd, $author$project$Api$Plan$id(plan));
                }, fields._s);
                var signupPagePlans = function() {
                    if (!plan_.$) return fields._s;
                    else return A2($elm$core$List$cons, {
                        aef: $elm$core$Maybe$Nothing,
                        agd: $author$project$Api$Plan$id(plan),
                        WM: $author$project$Api$Plan$name(plan)
                    }, fields._s);
                }();
                return _Utils_update(fields, {
                    _s: signupPagePlans,
                    _A: A2($author$project$Components$Admin$SignupPages$Form$defaultSlug, signupPagePlans, fields._A)
                });
            case 2:
                var companyPlan = field.a;
                var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
                var signupPagePlan = A2($elm_community$list_extra$List$Extra$find, function(signupPagePlan_) {
                    return _Utils_eq(signupPagePlan_.agd, $author$project$Api$Plan$id(plan));
                }, fields._s);
                var signupPagePlans = function() {
                    if (!signupPagePlan.$) return fields._s;
                    else return A2($elm$core$List$cons, {
                        aef: $elm$core$Maybe$Nothing,
                        agd: $author$project$Api$Plan$id(plan),
                        WM: $author$project$Api$Plan$name(plan)
                    }, fields._s);
                }();
                var newSlug = $elm$core$String$isEmpty(fields._A) ? A2($author$project$Components$Admin$SignupPages$Form$defaultSlug, signupPagePlans, fields._A) : fields._A;
                return _Utils_update(fields, {
                    _s: signupPagePlans,
                    _A: newSlug
                });
            case 3:
                var id = field.a;
                return _Utils_update(fields, {
                    _s: A2($elm_community$list_extra$List$Extra$filterNot, function(signupPagePlan) {
                        return _Utils_eq(signupPagePlan.agd, id);
                    }, fields._s)
                });
            case 4:
                var chargeItem = field.a;
                return _Utils_update(fields, {
                    lv: A2($elm$core$Maybe$map, function(chargeItem_) {
                        return {
                            aef: chargeItem_.aef,
                            zr: chargeItem_.zr,
                            $S: chargeItem_.$S
                        };
                    }, chargeItem)
                });
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    _A: string
                });
            case 6:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ir: bool
                });
            case 7:
                var id = field.a;
                var addon = A2($elm_community$list_extra$List$Extra$find, function(addon_) {
                    return _Utils_eq($author$project$Api$Provider$Addon$Min$id(addon_), id);
                }, addons);
                var addons_ = function() {
                    if (!addon.$) {
                        var addon_ = addon.a;
                        return A2($elm$core$List$cons, {
                            aef: $author$project$Api$Provider$Addon$Min$id(addon_),
                            zr: $author$project$Api$Provider$Addon$Min$name(addon_)
                        }, fields.IH);
                    } else return fields.IH;
                }();
                return _Utils_update(fields, {
                    IH: addons_
                });
            case 8:
                var id = field.a;
                return _Utils_update(fields, {
                    IH: A2($elm_community$list_extra$List$Extra$filterNot, function(addon) {
                        return _Utils_eq(addon.aef, id);
                    }, fields.IH)
                });
            case 9:
                var bool = field.a;
                return _Utils_update(fields, {
                    Tb: bool
                });
            case 10:
                var practitioner = field.a;
                var practitioner_ = A2($elm_community$list_extra$List$Extra$find, function(practitioner__) {
                    return _Utils_eq(practitioner__.aef, practitioner.aef);
                }, fields.Xc);
                var practitioners = function() {
                    if (!practitioner_.$) return fields.Xc;
                    else return A2($elm$core$List$cons, {
                        aef: practitioner.aef,
                        zr: practitioner.zr
                    }, fields.Xc);
                }();
                return _Utils_update(fields, {
                    Xc: practitioners
                });
            case 11:
                var id = field.a;
                return _Utils_update(fields, {
                    Xc: A2($elm_community$list_extra$List$Extra$filterNot, function(practitioner) {
                        return _Utils_eq(practitioner.aef, id);
                    }, fields.Xc)
                });
            case 12:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ta: bool
                });
            case 13:
                var bool = field.a;
                return _Utils_update(fields, {
                    S9: bool
                });
            case 14:
                var location1 = field.a;
                var location_ = A2($elm_community$list_extra$List$Extra$find, function(location__) {
                    return _Utils_eq(location__.aef, location1.aef);
                }, fields.Tq);
                var locations = function() {
                    if (!location_.$) return fields.Tq;
                    else return A2($elm$core$List$cons, {
                        aef: location1.aef,
                        zr: location1.zr
                    }, fields.Tq);
                }();
                return _Utils_update(fields, {
                    Tq: locations
                });
            case 15:
                var locationGroup = field.a;
                var locationGroup_ = A2($elm_community$list_extra$List$Extra$find, function(locationGroup__) {
                    return _Utils_eq(locationGroup__.aef, $author$project$Api$Provider$LocationGroup$All$id(locationGroup));
                }, fields.Tl);
                var locationGroups = function() {
                    if (!locationGroup_.$) return fields.Tl;
                    else return A2($elm$core$List$cons, {
                        aef: $author$project$Api$Provider$LocationGroup$All$id(locationGroup),
                        zr: $author$project$Api$Provider$LocationGroup$All$name(locationGroup)
                    }, fields.Tl);
                }();
                return _Utils_update(fields, {
                    Tl: locationGroups
                });
            case 16:
                var id = field.a;
                return _Utils_update(fields, {
                    Tq: A2($elm_community$list_extra$List$Extra$filterNot, function(location1) {
                        return _Utils_eq(location1.aef, id);
                    }, fields.Tq)
                });
            case 17:
                var id = field.a;
                return _Utils_update(fields, {
                    Tl: A2($elm_community$list_extra$List$Extra$filterNot, function(locationGroup) {
                        return _Utils_eq(locationGroup.aef, id);
                    }, fields.Tl)
                });
            case 18:
                var bool = field.a;
                return _Utils_update(fields, {
                    aaU: bool
                });
            case 19:
                var bool = field.a;
                return _Utils_update(fields, {
                    Yp: bool
                });
            case 20:
                var string = field.a;
                return _Utils_update(fields, {
                    W$: $author$project$Utils$String$toMaybe(string)
                });
            case 21:
                var string = field.a;
                return _Utils_update(fields, {
                    W_: $author$project$Utils$String$toMaybe(string)
                });
            case 22:
                var bool = field.a;
                return _Utils_update(fields, {
                    _j: bool
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    WZ: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Components$Admin$SignupPages$Form$SlugValidation = 0;
    var $author$project$Utils$Validate$ifShorterThan = F3(function(subjectToString, min, error) {
        return A2($rtfeldman$elm_validate$Validate$ifTrue, function(subject) {
            return _Utils_cmp($elm$core$String$length(subjectToString(subject)), min) < 0;
        }, error);
    });
    var $author$project$Components$Admin$SignupPages$Form$ChargeItemValidation = 2;
    var $author$project$Components$Admin$SignupPages$Form$validateChargeItem = function(fields) {
        var _v0 = _Utils_Tuple2(fields.ah5, fields.lv);
        if (_v0.a === 'checkout') {
            if (!_v0.b.$) {
                var chargeItem = _v0.b.a;
                return chargeItem.$S ? _List_fromArray([
                    _Utils_Tuple2(2, 'We are unable to support collecting sales tax through checkout pages due to the complexity of sales & use tax laws throughout the country. Please select a different item for your signup page.')
                ]) : _List_Nil;
            } else {
                var _v1 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(2, 'Please pick a charge')
                ]);
            }
        } else return _List_Nil;
    };
    var $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrlValidation = 3;
    var $author$project$Utils$Validate$isInvalidUrl = function(url) {
        return $elm$core$String$isEmpty(url) ? false : !(A2($elm$core$String$startsWith, 'http://', url) || A2($elm$core$String$startsWith, 'https://', url));
    };
    var $author$project$Components$Admin$SignupPages$Form$validatePostSignupRedirectUrl = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Yp, fields.W$);
        if (_v0.b.$ === 1) {
            if (_v0.a) {
                var _v1 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(3, 'Please enter an url')
                ]);
            } else {
                var _v2 = _v0.b;
                return _List_Nil;
            }
        } else {
            var postSignupRedirectUrl = _v0.b.a;
            return $author$project$Utils$Validate$isInvalidUrl(postSignupRedirectUrl) ? _List_fromArray([
                _Utils_Tuple2(3, 'URL must start with http:// or https://')
            ]) : _List_Nil;
        }
    };
    var $author$project$Components$Admin$SignupPages$Form$SignupPagePlansValidation = 1;
    var $author$project$Components$Admin$SignupPages$Form$validateSignupPagePlans = function(fields) {
        var _v0 = _Utils_Tuple2(fields.ah5, $elm$core$List$isEmpty(fields._s));
        if (_v0.a === 'signup' && _v0.b) return _List_fromArray([
            _Utils_Tuple2(1, 'Please select at least one plan')
        ]);
        else return _List_Nil;
    };
    var $author$project$Components$Admin$SignupPages$Form$validateSlugPattern = function(fields) {
        return $elm$core$String$isEmpty(fields._A) ? _List_Nil : A2($author$project$Utils$Regex$matches, '^[a-z0-9](?:-?[a-z0-9])*$', fields._A) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(0, 'Must have only lowercase letters, numbers and dashes')
        ]);
    };
    var $author$project$Components$Admin$SignupPages$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateSignupPagePlans),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateChargeItem),
        A3($author$project$Utils$Validate$ifShorterThan, function($) {
            return $._A;
        }, 4, _Utils_Tuple2(0, 'Must be 4 or more letters')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validateSlugPattern),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Admin$SignupPages$Form$validatePostSignupRedirectUrl)
    ]));
    var $author$project$Components$Admin$SignupPages$Form$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$SignupPage$create = F3(function(apiClient, fields, toMsg) {
        var encodeSignupPagePlan = function(signupPagePlan) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, signupPagePlan.aef)),
                _Utils_Tuple2('plan', $author$project$Utils$Encode$association(signupPagePlan.agd))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('signup_page', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('active', $elm$json$Json$Encode$bool(fields.Ir)),
                _Utils_Tuple2('slug', $elm$json$Json$Encode$string(fields._A)),
                _Utils_Tuple2('use_custom_settings', $elm$json$Json$Encode$bool(fields.aaU)),
                _Utils_Tuple2('post_signup_message', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.W_)),
                _Utils_Tuple2('post_signup_redirect_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.W$)),
                _Utils_Tuple2('post_signup_button_label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WZ)),
                _Utils_Tuple2('redirects_post_signup', $elm$json$Json$Encode$bool(fields.Yp)),
                _Utils_Tuple2('show_post_signup_footer_button', $elm$json$Json$Encode$bool(fields._j)),
                _Utils_Tuple2('limit_available_practitioners', $elm$json$Json$Encode$bool(fields.Tb)),
                _Utils_Tuple2('limit_available_locations', $elm$json$Json$Encode$bool(fields.Ta)),
                _Utils_Tuple2('limit_available_location_groups', $elm$json$Json$Encode$bool(fields.S9)),
                _Utils_Tuple2('charge_item', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.lv)),
                _Utils_Tuple2('signup_page_plans', A2($elm$json$Json$Encode$list, encodeSignupPagePlan, fields._s)),
                _Utils_Tuple2('addons', A2($elm$json$Json$Encode$list, A2($elm$core$Basics$composeL, $author$project$Utils$Encode$association, function($) {
                    return $.aef;
                }), fields.IH)),
                _Utils_Tuple2('practitioners', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Xc)),
                _Utils_Tuple2('locations', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Tq)),
                _Utils_Tuple2('location_groups', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Tl)),
                _Utils_Tuple2('company', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.acy))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$SignupPage$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
    });
    var $author$project$Components$Admin$SignupPages$Form$signupFormFields = function(fields) {
        return {
            Ir: fields.Ir,
            IH: A2($elm$core$List$map, function(addon) {
                return {
                    aef: addon.aef
                };
            }, fields.IH),
            lv: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.lv),
            acy: fields.fl,
            S9: fields.S9,
            Ta: fields.Ta,
            Tb: fields.Tb,
            Tl: A2($elm$core$List$map, function($) {
                return $.aef;
            }, fields.Tl),
            Tq: A2($elm$core$List$map, function($) {
                return $.aef;
            }, fields.Tq),
            WZ: fields.WZ,
            W_: fields.W_,
            W$: fields.W$,
            Xc: A2($elm$core$List$map, function($) {
                return $.aef;
            }, fields.Xc),
            Yp: fields.Yp,
            _j: fields._j,
            _s: A2($elm$core$List$map, function(signupPagePlan) {
                return {
                    aef: signupPagePlan.aef,
                    agd: signupPagePlan.agd
                };
            }, fields._s),
            _A: fields._A,
            aaU: fields.aaU
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$createItem = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$SignupPage$create, apiClient, $author$project$Components$Admin$SignupPages$Form$signupFormFields(fields), $author$project$Components$Admin$SignupPages$Form$Created);
    });
    var $author$project$Components$Admin$SignupPages$Form$Updated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$SignupPage$update = F4(function(apiClient, id_, fields, toMsg) {
        var encodeSignupPagePlan = function(signupPagePlan) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, signupPagePlan.aef)),
                _Utils_Tuple2('plan', $author$project$Utils$Encode$association(signupPagePlan.agd))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('signup_page', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('active', $elm$json$Json$Encode$bool(fields.Ir)),
                _Utils_Tuple2('slug', $elm$json$Json$Encode$string(fields._A)),
                _Utils_Tuple2('use_custom_settings', $elm$json$Json$Encode$bool(fields.aaU)),
                _Utils_Tuple2('post_signup_message', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.W_)),
                _Utils_Tuple2('post_signup_redirect_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.W$)),
                _Utils_Tuple2('post_signup_button_label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WZ)),
                _Utils_Tuple2('redirects_post_signup', $elm$json$Json$Encode$bool(fields.Yp)),
                _Utils_Tuple2('show_post_signup_footer_button', $elm$json$Json$Encode$bool(fields._j)),
                _Utils_Tuple2('limit_available_practitioners', $elm$json$Json$Encode$bool(fields.Tb)),
                _Utils_Tuple2('limit_available_locations', $elm$json$Json$Encode$bool(fields.Ta)),
                _Utils_Tuple2('limit_available_location_groups', $elm$json$Json$Encode$bool(fields.S9)),
                _Utils_Tuple2('charge_item', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.lv)),
                _Utils_Tuple2('signup_page_plans', A2($elm$json$Json$Encode$list, encodeSignupPagePlan, fields._s)),
                _Utils_Tuple2('addons', A2($elm$json$Json$Encode$list, A2($elm$core$Basics$composeL, $author$project$Utils$Encode$association, function($) {
                    return $.aef;
                }), fields.IH)),
                _Utils_Tuple2('practitioners', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Xc)),
                _Utils_Tuple2('locations', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Tq)),
                _Utils_Tuple2('location_groups', A2($elm$json$Json$Encode$list, $author$project$Utils$Encode$association, fields.Tl)),
                _Utils_Tuple2('company', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.acy))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$SignupPage$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagePath(id_))));
    });
    var $author$project$Components$Admin$SignupPages$Form$updateItem = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$SignupPage$update, apiClient, id, $author$project$Components$Admin$SignupPages$Form$signupFormFields(fields), $author$project$Components$Admin$SignupPages$Form$Updated);
    });
    var $author$project$Components$Admin$SignupPages$Form$saveItem = F3(function(apiClient, id, formFields) {
        if (!id.$) {
            var id_ = id.a;
            return A3($author$project$Components$Admin$SignupPages$Form$updateItem, apiClient, id_, formFields);
        } else return A2($author$project$Components$Admin$SignupPages$Form$createItem, apiClient, formFields);
    });
    var $author$project$Components$Admin$SignupPages$Form$saveRoute = function(companyId) {
        if (!companyId.$) {
            var id_ = companyId.a;
            return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup({
                fl: id_
            });
        } else return $author$project$Spa$Generated$Route$Admin__SignupPages__Top;
    };
    var $author$project$Components$ResourceFilter$CompanyPlan$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$LocationGroup$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Admin$SignupPages$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var signupPage = response.a;
                    var chargeItem = $author$project$Api$Provider$SignupPage$One$chargeItem(signupPage);
                    var _v3 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$ChargeItem$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(chargeItem_) {
                        return _List_fromArray([
                            {
                                aef: $author$project$Api$Provider$ChargeItem$Min$id(chargeItem_),
                                zr: $author$project$Api$Provider$ChargeItem$Min$name(chargeItem_)
                            }
                        ]);
                    }, chargeItem))), A2($author$project$Components$ResourceFilter$ChargeItem$preSelectedId, A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Min$id, chargeItem), model.cL));
                    var chargeItemResourceFilter = _v3.a;
                    var chargeItemResourceFilterCmd = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cL: chargeItemResourceFilter,
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init(A2($author$project$Components$Admin$SignupPages$Form$formFieldsFromItem, signupPage, model.fl)))
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 2:
                var _v4 = model.PU;
                if (!_v4.$) {
                    var form = _v4.a;
                    var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$SignupPages$Form$formFieldsValidator, form);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var newForm = _v6.a;
                        var validFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$Loading
                        }), A3($author$project$Components$Admin$SignupPages$Form$saveItem, apiClient, model.aef, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v5.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var field = msg.a;
                var _v7 = model.PU;
                if (!_v7.$) {
                    var form = _v7.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate($author$project$Api$Provider$Practice$One$addons(model.W1)), field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Components$Admin$SignupPages$Form$saveRoute(model.fl)), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Successfully created page')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var queryParams = A2($elm$core$Maybe$withDefault, $elm$core$Dict$empty, model.Bz);
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), A2($author$project$Utils$Route$navigate, queryParams, $author$project$Components$Admin$SignupPages$Form$saveRoute(model.fl)), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Page was successfully updated.')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var subMsg = msg.a;
                var _v10 = model.jy;
                if (!_v10.$) {
                    var resourceFilter = _v10.a;
                    var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, resourceFilter);
                    var newForm = function() {
                        var _v11 = planResourceResult.adu;
                        if (!_v11.$ && !_v11.a.$ && !_v11.a.a.$) {
                            var plan = _v11.a.a.a;
                            return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate($author$project$Api$Provider$Practice$One$addons(model.W1)), $author$project$Components$Admin$SignupPages$Form$PlanAdd(plan)), model.PU);
                        } else return model.PU;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm,
                        jy: $author$project$Components$Admin$SignupPages$Form$RetailPlan(planResourceResult.zi)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg, planResourceResult.EQ), planResourceResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var subMsg = msg.a;
                var _v12 = model.jy;
                if (_v12.$ === 1) {
                    var resourceFilter = _v12.a;
                    var planResourceResult = A3($author$project$Components$ResourceFilter$CompanyPlan$update, apiClient, subMsg, resourceFilter);
                    var newForm = function() {
                        var _v13 = planResourceResult.adu;
                        if (!_v13.$ && !_v13.a.$ && !_v13.a.a.$) {
                            var companyPlan = _v13.a.a.a;
                            return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate($author$project$Api$Provider$Practice$One$addons(model.W1)), $author$project$Components$Admin$SignupPages$Form$CompanyPlanAdd(companyPlan)), model.PU);
                        } else return model.PU;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm,
                        jy: $author$project$Components$Admin$SignupPages$Form$CompanyPlan(planResourceResult.zi)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg, planResourceResult.EQ), planResourceResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var subMsg = msg.a;
                var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cL);
                var newForm = function() {
                    var _v14 = chargeItemResourceResult.adu;
                    _v14$2: while(true){
                        if (!_v14.$ && !_v14.a.$) switch(_v14.a.a.$){
                            case 0:
                                var chargeItem = _v14.a.a.a;
                                return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate($author$project$Api$Provider$Practice$One$addons(model.W1)), $author$project$Components$Admin$SignupPages$Form$ChargeItem($elm$core$Maybe$Just(chargeItem))), model.PU);
                            case 2:
                                var _v15 = _v14.a.a;
                                return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate($author$project$Api$Provider$Practice$One$addons(model.W1)), $author$project$Components$Admin$SignupPages$Form$ChargeItem($elm$core$Maybe$Nothing)), model.PU);
                            default:
                                break _v14$2;
                        }
                        else break _v14$2;
                    }
                    return model.PU;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    cL: chargeItemResourceResult.zi,
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.EQ), chargeItemResourceResult.at);
            case 8:
                var subMsg = msg.a;
                var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.jE);
                var newForm = function() {
                    var _v16 = practitionerResourceResult.adu;
                    if (!_v16.$ && !_v16.a.$ && !_v16.a.a.$) {
                        var practitioner = _v16.a.a.a;
                        return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate($author$project$Api$Provider$Practice$One$addons(model.W1)), $author$project$Components$Admin$SignupPages$Form$PractitionerAdd(practitioner)), model.PU);
                    } else return model.PU;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm,
                    jE: practitionerResourceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg, practitionerResourceResult.EQ), practitionerResourceResult.at);
            case 9:
                var subMsg = msg.a;
                var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.ro);
                var newForm = function() {
                    var _v17 = locationResourceResult.adu;
                    if (!_v17.$ && !_v17.a.$ && !_v17.a.a.$) {
                        var location1 = _v17.a.a.a;
                        return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate($author$project$Api$Provider$Practice$One$addons(model.W1)), $author$project$Components$Admin$SignupPages$Form$LocationAdd(location1)), model.PU);
                    } else return model.PU;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm,
                    ro: locationResourceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg, locationResourceResult.EQ), locationResourceResult.at);
            default:
                var subMsg = msg.a;
                var locationGroupResourceResult = A3($author$project$Components$ResourceFilter$LocationGroup$update, apiClient, subMsg, model.rn);
                var newForm = function() {
                    var _v18 = locationGroupResourceResult.adu;
                    if (!_v18.$ && !_v18.a.$ && !_v18.a.a.$) {
                        var locationGroup = _v18.a.a.a;
                        return A2($elm$core$Maybe$map, A2($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$Form$formFieldsUpdate($author$project$Api$Provider$Practice$One$addons(model.W1)), $author$project$Components$Admin$SignupPages$Form$LocationGroupAdd(locationGroup)), model.PU);
                    } else return model.PU;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm,
                    rn: locationGroupResourceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg, locationGroupResourceResult.EQ), locationGroupResourceResult.at);
        }
    });
    var $author$project$Pages$Admin$SignupPages$Id_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.Ej, subMsg, model.PU);
        var newForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Admin$SignupPages$Form$Save = {
        $: 2
    };
    var $author$project$Components$Admin$SignupPages$Form$isChargeItemSelected = function(chargeItem) {
        return $author$project$Utils$Maybe$toBool(chargeItem);
    };
    var $author$project$Components$Admin$SignupPages$Form$isPlanSelected = function(signupPagePlans) {
        return !$elm$core$List$isEmpty(signupPagePlans);
    };
    var $author$project$Components$Admin$SignupPages$Form$isBillingOptionMethod = F2(function(signupPagePlans, chargeItem) {
        return $author$project$Components$Admin$SignupPages$Form$isPlanSelected(signupPagePlans) || $author$project$Components$Admin$SignupPages$Form$isChargeItemSelected(chargeItem);
    });
    var $author$project$Components$Admin$SignupPages$Form$isPostSignupRedirectionCompleted = F2(function(redirectsPostSignup, postSignupRedirectUrl) {
        return !redirectsPostSignup || $author$project$Utils$Maybe$toBool(postSignupRedirectUrl);
    });
    var $author$project$Components$Admin$SignupPages$Form$isSlugSelected = function(slug) {
        return !$author$project$Utils$String$isBlank(slug);
    };
    var $author$project$Components$Admin$SignupPages$Form$canSave = function(fields) {
        return A2($author$project$Components$Admin$SignupPages$Form$isBillingOptionMethod, fields._s, fields.lv) && $author$project$Components$Admin$SignupPages$Form$isSlugSelected(fields._A) && A2($author$project$Components$Admin$SignupPages$Form$isPostSignupRedirectionCompleted, fields.Yp, fields.W$);
    };
    var $author$project$Components$Admin$SignupPages$Form$cancelRoute = function(companyId) {
        if (!companyId.$) {
            var id_ = companyId.a;
            return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup({
                fl: id_
            });
        } else return $author$project$Spa$Generated$Route$Admin__SignupPages__Top;
    };
    var $author$project$Api$Provider$Practice$One$locationGroupsCount = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Tm;
    });
    var $author$project$Components$ResourceFilter$CompanyPlan$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Admin$SignupPages$Form$viewPlanFilter = F2(function(planFilter, form) {
        if (!planFilter.$) {
            var planResourceFilter = planFilter.a;
            return A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$Form$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
            ]), planResourceFilter));
        } else {
            var companyPlanFilter = planFilter.a;
            return A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$Form$CompanyPlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$CompanyPlan$view, _List_fromArray([
                $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
            ]), companyPlanFilter));
        }
    });
    var $author$project$Components$Admin$SignupPages$Form$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$PlanRemove = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewSignupPagePlan = F2(function(signupPagePlans, signupPagePlan) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(signupPagePlan.WM),
            $elm$core$List$length(signupPagePlans) > 1 ? A3($author$project$Ui$Button$view, {
                abP: 'Delete signup page plan'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$FormUpdated($author$project$Components$Admin$SignupPages$Form$PlanRemove(signupPagePlan.agd))),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_Nil) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$viewBillingMethod = F4(function(fields, planResourceFilter, chargeItemResourceFilter, form) {
        return fields.ah5 === 'signup' ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Plan'),
            $author$project$Ui$Form$Group$required(true)
        ]), A2($elm$core$List$cons, A2($author$project$Components$Admin$SignupPages$Form$viewPlanFilter, planResourceFilter, form), A2($elm$core$List$map, $author$project$Components$Admin$SignupPages$Form$viewSignupPagePlan(fields._s), fields._s))) : A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Charge'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$Form$ChargeItemResourceFilterMsg, A2($author$project$Components$ResourceFilter$ChargeItem$view, _List_fromArray([
                $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
            ]), chargeItemResourceFilter))
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrl = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewCustomButtonUrl = function(postSignupRedirectUrlInput) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Custom Button URL')
        ]), _List_fromArray([
            postSignupRedirectUrlInput,
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Account')
                ])),
                $elm$html$Html$text(').')
            ]))
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$PostSignupButtonLabel = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewPostSignupButtonLabel = F2(function(postSignupButtonLabel, practiceName) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Custom Button Text')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('Go to ' + (practiceName + ' Website')),
                $author$project$Ui$Form$Input$maxLength(30),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', postSignupButtonLabel)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupButtonLabel))
            ])),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('If left blank, button will read \"Go to '),
                $elm$html$Html$text(practiceName),
                $elm$html$Html$text(' Website\".')
            ]))
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$ShowPostSignupFooterButton = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewPostSignupFooterButton = function(showPostSignupFooterButton) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Show Redirect Button on Confirmation')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$ShowPostSignupFooterButton))
            ])),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                showPostSignupFooterButton ? $elm$html$Html$text('A button is displayed that can be configured below with a custom text and URL.') : $elm$html$Html$text('No button will be shown, and user should be instructed to close their current signup tab.')
            ]))
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$PostSignupMessage = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewPostSignupMessage = function(postSignupMessage) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Custom Message')
        ]), _List_fromArray([
            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                $author$project$Ui$Form$Textarea$placeholder('If you have any questions feel free to call our office at (333) 123-4567.'),
                $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', postSignupMessage)),
                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupMessage))
            ]))
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$RedirectsPostSignup = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewRedirectPostSignup = function(redirectsPostSignup) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Auto Redirect to External Site')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$RedirectsPostSignup))
            ]))
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$viewRedirectUrl = function(postSignupRedirectUrlInput) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Redirect URL'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            postSignupRedirectUrlInput
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$viewCustomSettings = F3(function(fields, practice, form) {
        var postSignupRedirectUrlInput = $author$project$Ui$Form$Input$view(_List_fromArray([
            $author$project$Ui$Form$Input$url,
            $author$project$Ui$Form$Input$placeholder(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Practice$One$url(practice))),
            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.W$)),
            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$PostSignupRedirectUrl)),
            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
        ]));
        return A2($elm$core$List$cons, $author$project$Components$Admin$SignupPages$Form$viewRedirectPostSignup(fields.Yp), fields.Yp ? _List_fromArray([
            $author$project$Components$Admin$SignupPages$Form$viewRedirectUrl(postSignupRedirectUrlInput)
        ]) : _List_fromArray([
            $author$project$Components$Admin$SignupPages$Form$viewPostSignupMessage(fields.W_),
            $author$project$Components$Admin$SignupPages$Form$viewPostSignupFooterButton(fields._j),
            fields._j ? A2($author$project$Components$Admin$SignupPages$Form$viewPostSignupButtonLabel, fields.WZ, $author$project$Api$Provider$Practice$One$name(practice)) : $author$project$Utils$Html$empty,
            fields._j ? $author$project$Components$Admin$SignupPages$Form$viewCustomButtonUrl(postSignupRedirectUrlInput) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$UseCustomSettings = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewEnableConfirmationSettings = function(fields) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Enable Confirmation Settings')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.aaU),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$UseCustomSettings))
            ]))
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocationGroups = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$LocationGroup$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Admin$SignupPages$Form$LocationGroupRemove = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewLocationGroup = function(locationGroup) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(locationGroup.zr),
            A3($author$project$Ui$Button$view, {
                abP: 'Remove location group'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$FormUpdated($author$project$Components$Admin$SignupPages$Form$LocationGroupRemove(locationGroup.aef))),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$viewLocationGroupSettings = F2(function(fields, locationGroupResourceFilter) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Enable Location Group Settings')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.S9),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocationGroups))
            ])),
            fields.S9 ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Providers assigned to a location within one of the groups selected will be available during enrollment.')
            ])), A2($elm$core$List$cons, A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$Form$LocationGroupResourceFilterMsg, A2($author$project$Components$ResourceFilter$LocationGroup$view, _List_Nil, locationGroupResourceFilter)), A2($elm$core$List$map, $author$project$Components$Admin$SignupPages$Form$viewLocationGroup, A2($elm$core$List$sortBy, function($) {
                return $.zr;
            }, A2($elm$core$List$map, function(p) {
                return _Utils_update(p, {
                    zr: $elm$core$String$trim(p.zr)
                });
            }, fields.Tl)))))) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocations = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$LocationRemove = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewLocation = function(location1) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(location1.zr),
            A3($author$project$Ui$Button$view, {
                abP: 'Remove location'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$FormUpdated($author$project$Components$Admin$SignupPages$Form$LocationRemove(location1.aef))),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$viewLocationSettings = F2(function(fields, locationResourceFilter) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Enable Location Settings')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.Ta),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailableLocations))
            ])),
            fields.Ta ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Selected location(s) will display on the patient\'s enrollment page.')
            ])), A2($elm$core$List$cons, A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$Form$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_Nil, locationResourceFilter)), A2($elm$core$List$map, $author$project$Components$Admin$SignupPages$Form$viewLocation, A2($elm$core$List$sortBy, function($) {
                return $.zr;
            }, A2($elm$core$List$map, function(p) {
                return _Utils_update(p, {
                    zr: $elm$core$String$trim(p.zr)
                });
            }, fields.Tq)))))) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$Type = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$buttonStyle = F2(function(type_, currentType_) {
        return _Utils_eq(type_, currentType_) ? 1 : 0;
    });
    var $author$project$Ui$Icon$Cart = 58;
    var $author$project$Ui$Icon$cart = $author$project$Ui$Icon$viewIcon(58);
    var $author$project$Ui$Icon$OnlineSignup = 27;
    var $author$project$Ui$Icon$onlineSignup = $author$project$Ui$Icon$viewIcon(27);
    var $author$project$Components$Admin$SignupPages$Form$viewPageType = F2(function(id, fields) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Signup / Checkout')
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Select plan signup page'
            }, _List_fromArray([
                $author$project$Ui$Button$styled(A2($author$project$Components$Admin$SignupPages$Form$buttonStyle, 'signup', fields.ah5)),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$FormUpdated($author$project$Components$Admin$SignupPages$Form$Type('signup'))),
                $author$project$Ui$Button$disabled($author$project$Utils$Maybe$toBool(id)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$onlineSignup)
            ]), _List_Nil),
            A3($author$project$Ui$Button$view, {
                abP: 'Select checkout page'
            }, _List_fromArray([
                $author$project$Ui$Button$styled(A2($author$project$Components$Admin$SignupPages$Form$buttonStyle, 'checkout', fields.ah5)),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$FormUpdated($author$project$Components$Admin$SignupPages$Form$Type('checkout'))),
                $author$project$Ui$Button$disabled($author$project$Utils$Maybe$toBool(id)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$cart)
            ]), _List_Nil)
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$LimitAvailablePractitioners = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$PractitionerRemove = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewPractitioner = function(practitioner) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(practitioner.zr),
            A3($author$project$Ui$Button$view, {
                abP: 'Remove practitioner'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$FormUpdated($author$project$Components$Admin$SignupPages$Form$PractitionerRemove(practitioner.aef))),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$viewProviderSettings = F2(function(fields, practitionerResourceFilter) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Enable Provider Settings')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.Tb),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$LimitAvailablePractitioners))
            ])),
            fields.Tb ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Selected provider(s) will display on the patient\'s enrollment page.')
            ])), A2($elm$core$List$cons, A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$Form$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, practitionerResourceFilter)), A2($elm$core$List$map, $author$project$Components$Admin$SignupPages$Form$viewPractitioner, A2($elm$core$List$sortBy, function($) {
                return $.zr;
            }, A2($elm$core$List$map, function(p) {
                return _Utils_update(p, {
                    zr: $elm$core$String$trim(p.zr)
                });
            }, fields.Xc)))))) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$Slug = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewSlug = F2(function(fields, form) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Url'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$group(_List_fromArray([
                $author$project$Ui$Form$Input$addon(_List_fromArray([
                    fields.ah5 === 'signup' ? $elm$html$Html$text('signup/') : $elm$html$Html$text('checkout/')
                ])),
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields._A),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$Slug))
                ]))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$Active = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewStatus = F2(function(fields, practice) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Live')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.Ir),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$Active))
            ])),
            !$author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice) ? A3($author$project$Ui$Tooltip$view, _List_Nil, 'The Signup Page will remain inactive until you finish setting up Payment Processing', _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace,
                    $author$project$Ui$Icon$help(_List_Nil)
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Admin$SignupPages$Form$AddonAdd = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$addonOptions = F2(function(addons, currentAddons) {
        var signupPageAddonIds = A2($elm$core$List$map, function($) {
            return $.aef;
        }, currentAddons);
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Select an Addon'), A2($elm$core$List$map, function(addon) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Addon$Min$id(addon)), $author$project$Api$Provider$Addon$Min$name(addon));
        }, A2($elm_community$list_extra$List$Extra$filterNot, function(addon) {
            return A2($elm$core$List$member, $author$project$Api$Provider$Addon$Min$id(addon), signupPageAddonIds);
        }, addons)));
    });
    var $author$project$Components$Admin$SignupPages$Form$AddonRemove = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$Form$viewAddon = function(addon) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(addon.zr),
            A3($author$project$Ui$Button$view, {
                abP: 'Delete addon'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$FormUpdated($author$project$Components$Admin$SignupPages$Form$AddonRemove(addon.aef))),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$Admin$SignupPages$Form$viewWrapAround = F3(function(fields, companyId, practice) {
        var practiceAddons = $author$project$Api$Provider$Practice$One$addons(practice);
        return $elm$core$List$isEmpty(practiceAddons) || $author$project$Utils$Maybe$toBool(companyId) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Wrap-Arounds')
        ]), A2($elm$core$List$cons, A2($author$project$Ui$Form$Select$view, _List_fromArray([
            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$SignupPages$Form$FormUpdated, $author$project$Components$Admin$SignupPages$Form$AddonAdd))
        ]), A2($author$project$Components$Admin$SignupPages$Form$addonOptions, practiceAddons, fields.IH)), A2($elm$core$List$map, $author$project$Components$Admin$SignupPages$Form$viewAddon, fields.IH)));
    });
    var $author$project$Components$Admin$SignupPages$Form$viewForm = F2(function(model, form) {
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$core$List$cons, $author$project$Utils$Maybe$isNothing(model.fl) ? A2($author$project$Components$Admin$SignupPages$Form$viewPageType, model.aef, fields) : $author$project$Utils$Html$empty, A2($elm$core$List$cons, A4($author$project$Components$Admin$SignupPages$Form$viewBillingMethod, fields, model.jy, model.cL, form), A2($elm$core$List$cons, A2($author$project$Components$Admin$SignupPages$Form$viewSlug, fields, form), A2($elm$core$List$cons, A2($author$project$Components$Admin$SignupPages$Form$viewStatus, fields, model.W1), A2($elm$core$List$cons, A3($author$project$Components$Admin$SignupPages$Form$viewWrapAround, fields, model.fl, model.W1), A2($elm$core$List$cons, $author$project$Api$Provider$Practice$One$locationGroupsCount(model.W1) > 0 ? A2($author$project$Components$Admin$SignupPages$Form$viewLocationGroupSettings, fields, model.rn) : $author$project$Utils$Html$empty, A2($elm$core$List$cons, A2($author$project$Components$Admin$SignupPages$Form$viewLocationSettings, fields, model.ro), A2($elm$core$List$cons, A2($author$project$Components$Admin$SignupPages$Form$viewProviderSettings, fields, model.jE), A2($elm$core$List$cons, $author$project$Components$Admin$SignupPages$Form$viewEnableConfirmationSettings(fields), fields.aaU ? A3($author$project$Components$Admin$SignupPages$Form$viewCustomSettings, fields, model.W1, form) : _List_Nil)))))))));
    });
    var $author$project$Components$Admin$SignupPages$Form$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$onSubmit($author$project$Components$Admin$SignupPages$Form$Save)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        function() {
                            var _v1 = model.aef;
                            if (!_v1.$) return $elm$html$Html$text('Edit Signup Page');
                            else return $elm$html$Html$text('New Signup Page');
                        }()
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$pull(1)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__SignupPages__Top, _List_Nil, _List_fromArray([
                                $author$project$Ui$Icon$cross(_List_Nil)
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, function() {
                    var _v2 = model.PU;
                    if (!_v2.$) {
                        var form = _v2.a;
                        return A2($author$project$Components$Admin$SignupPages$Form$viewForm, model, form);
                    } else return _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]))
                    ]);
                }()),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Components$Admin$SignupPages$Form$cancelRoute(model.fl), _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Back')
                    ])),
                    function() {
                        var verb = function() {
                            var _v4 = model.aef;
                            if (!_v4.$) return 'Update';
                            else return 'Create';
                        }();
                        var allowSave = function() {
                            var _v3 = model.PU;
                            if (!_v3.$) {
                                var form = _v3.a;
                                return $author$project$Components$Admin$SignupPages$Form$canSave($author$project$Utils$Form$fields(form));
                            } else return true;
                        }();
                        return A3($author$project$Ui$Button$view, {
                            abP: verb
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$Form$Save),
                            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                            $author$project$Ui$Button$disabled(!allowSave)
                        ]), _List_fromArray([
                            $elm$html$Html$text(verb)
                        ]));
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$SignupPages$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$SignupPages$Form$view(model.PU))
            ]),
            $2: 'Admin | Signup Pages'
        };
    };
    var $author$project$Pages$Admin$SignupPages$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$SignupPages$Id_String$init,
        aeR: $author$project$Pages$Admin$SignupPages$Id_String$load,
        ag3: $author$project$Pages$Admin$SignupPages$Id_String$save,
        ahE: $author$project$Pages$Admin$SignupPages$Id_String$subscriptions,
        aaO: $author$project$Pages$Admin$SignupPages$Id_String$update,
        aid: $author$project$Pages$Admin$SignupPages$Id_String$view
    });
    var $author$project$Pages$Admin$SignupPages$New$FormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Admin$SignupPages$New$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var _v2 = A6($author$project$Components$Admin$SignupPages$Form$init, apiClient, session, practice, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
        var form = _v2.a;
        var formCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
    });
    var $author$project$Pages$Admin$SignupPages$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$SignupPages$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$SignupPages$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$SignupPages$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var formCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd), outMsgs);
    });
    var $author$project$Pages$Admin$SignupPages$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$SignupPages$Form$view(model.PU))
            ]),
            $2: 'Admin | Signup Pages'
        };
    };
    var $author$project$Pages$Admin$SignupPages$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$SignupPages$New$init,
        aeR: $author$project$Pages$Admin$SignupPages$New$load,
        ag3: $author$project$Pages$Admin$SignupPages$New$save,
        ahE: $author$project$Pages$Admin$SignupPages$New$subscriptions,
        aaO: $author$project$Pages$Admin$SignupPages$New$update,
        aid: $author$project$Pages$Admin$SignupPages$New$view
    });
    var $author$project$Pages$Admin$SignupPages$Top$GotItems = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$SignupPage$listDefaults = {
        fl: $elm$core$Maybe$Nothing,
        af_: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
    };
    var $author$project$Api$Provider$SignupPage$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$SignupPage$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.fl;
                if (!_v0.$) {
                    var companyId = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'company_id', companyId)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.af_;
                if (!_v1.$) {
                    var pagination = _v1.a;
                    return $author$project$Api$Pagination$toApiParams(pagination);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Provider$SignupPage$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$SignupPage$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$SignupPage$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagesPath)));
    });
    var $author$project$Pages$Admin$SignupPages$Top$fetchItems = function(model) {
        return A3($author$project$Api$Provider$SignupPage$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: $elm$core$Maybe$Just(model.af_)
            });
        }, $author$project$Pages$Admin$SignupPages$Top$GotItems);
    };
    var $author$project$Pages$Admin$SignupPages$Top$GotDefault = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$SignupPages$Top$getDefault = function(model) {
        return A2($author$project$Api$Provider$SignupPage$getDefault, model.Ej, $author$project$Pages$Admin$SignupPages$Top$GotDefault);
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$init = $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed;
    var $author$project$Pages$Admin$SignupPages$Top$init = F4(function(_v0, practice, _v1, _v2) {
        var apiClient = _v1.Ej;
        var query = _v2.Bz;
        var model = {
            IH: $author$project$Api$Provider$Practice$One$addons(practice),
            Ej: apiClient,
            fp: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$init(apiClient),
            NC: $elm$core$Maybe$Nothing,
            $8: $elm$core$Maybe$Nothing,
            dS: $elm$core$Set$empty,
            i$: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            Ba: $author$project$Api$Provider$Practice$One$hasPaymentProcessorAccount(practice),
            o0: $author$project$Api$Data$NotAsked
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Admin$SignupPages$Top$fetchItems(model),
            $author$project$Pages$Admin$SignupPages$Top$getDefault(model)
        ])));
    });
    var $author$project$Pages$Admin$SignupPages$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$SignupPages$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Broker$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$Broker$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$ResourceFilter$LeadSource$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$LeadSource$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$ResourceFilter$Location$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$ResourceFilter$Practitioner$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$subscriptions = function(model) {
        if (model.$ === 1) {
            var open_ = model.a;
            return $elm$core$Platform$Sub$batch(_List_fromArray([
                $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal),
                $author$project$Ui$Dropdown$subscriptions(open_.lh),
                $author$project$Ui$Dropdown$subscriptions(open_.lF),
                A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg, $author$project$Components$ResourceFilter$Practitioner$subscriptions(open_.jE)),
                A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg, $author$project$Components$ResourceFilter$Location$subscriptions(open_.ro)),
                A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg, $author$project$Components$ResourceFilter$LeadSource$subscriptions(open_.mT)),
                A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg, $author$project$Components$ResourceFilter$Broker$subscriptions(open_.lj))
            ]));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$SignupPages$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$subscriptions(model.fp)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed), model.$8))
        ]));
    };
    var $author$project$Pages$Admin$SignupPages$Top$DefaultSignupPageUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$SignupPages$Top$Deleted = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$SignupPage$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$SignupPage$signupPagePath(id_)));
    });
    var $author$project$Api$Provider$SignupPage$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$SignupPage$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$id(shared);
    };
    var $author$project$Api$Provider$SignupPage$makeDefault = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$SignupPage$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'default'
        ]), $author$project$Api$Provider$SignupPage$signupPagePath(id_))));
    });
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponDropdownMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotCoupons = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotSignupPageOne = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsInit = {
        pH: $elm$core$Maybe$Nothing,
        vQ: $elm$core$Maybe$Nothing,
        Mj: $elm$core$Maybe$Nothing,
        S1: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        agi: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Broker$brokersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'brokers'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Broker$All$Broker = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Broker$Shared$Broker = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Broker$Shared$Record = F4(function(id, name, endedOn, brokerAccount) {
        return {
            vR: brokerAccount,
            OT: endedOn,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$BrokerAccount$Shared$BrokerAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BrokerAccount$Shared$Record = F5(function(id, name, retailEnabled, multipleBrokers, ratePeriodSchedule) {
        return {
            aef: id,
            UG: multipleBrokers,
            zr: name,
            X6: ratePeriodSchedule,
            agX: retailEnabled
        };
    });
    var $author$project$Api$Provider$RatePeriodSchedule$Shared$RatePeriodSchedule = $elm$core$Basics$identity;
    var $author$project$Api$Provider$RatePeriodSchedule$Shared$Record = function(intervals) {
        return {
            aeu: intervals
        };
    };
    var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$RatePeriodScheduleInterval = $elm$core$Basics$identity;
    var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$Record = F2(function(intervalInMonths, pricingStructure) {
        return {
            aet: intervalInMonths,
            Xq: pricingStructure
        };
    });
    var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pricing_structure', $author$project$Api$Provider$PricingStructure$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'interval_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Api$Provider$RatePeriodScheduleInterval$Shared$Record)));
    var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$RatePeriodSchedule$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'intervals', $elm$json$Json$Decode$list($author$project$Api$Provider$RatePeriodScheduleInterval$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$RatePeriodSchedule$Shared$Record));
    var $author$project$Api$Provider$RatePeriodSchedule$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RatePeriodSchedule$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$BrokerAccount$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rate_period_schedule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RatePeriodSchedule$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'multiple_brokers', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'retail_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$Shared$Record))))));
    var $author$project$Api$Provider$BrokerAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Broker$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'broker_account', $author$project$Api$Provider$BrokerAccount$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ended_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Broker$Shared$Record)))));
    var $author$project$Api$Provider$Broker$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Broker$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Broker$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Broker$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Broker$listDefaults = {
        vR: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        Q8: $elm$core$Maybe$Nothing,
        Gu: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        Hi: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$Broker$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Broker$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Hi;
                if (!_v2.$) {
                    var bool = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'retail', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.Q8;
                if (!_v3.$) {
                    var bool = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'inactive', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.vR;
                if (!_v4.$) {
                    var string = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'broker_account', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.Gu;
                if (!_v5.$) {
                    var bool = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'no_end', bool)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Broker$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Broker$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Broker$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Broker$brokersPath)));
    });
    var $author$project$Components$ResourceFilter$Broker$list = $author$project$Api$Provider$Broker$list;
    var $author$project$Components$ResourceFilter$Broker$fetchResources = F5(function(listOptionals, toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Broker$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$Broker$retrieveResource = F4(function(listOptionals, toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Broker$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$Broker$selectId = 'brokers';
    var $author$project$Api$Provider$Broker$Shared$brokerAccount = function(_v0) {
        var record = _v0;
        return record.vR;
    };
    var $author$project$Api$Provider$Broker$All$brokerAccount = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Broker$Shared$brokerAccount(shared);
    };
    var $author$project$Api$Provider$Broker$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Broker$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Broker$Shared$name(shared);
    };
    var $author$project$Api$Provider$BrokerAccount$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$ResourceFilter$Broker$toTitle = function(resource) {
        return $author$project$Api$Provider$Broker$All$name(resource) + (' - ' + $author$project$Api$Provider$BrokerAccount$Shared$name($author$project$Api$Provider$Broker$All$brokerAccount(resource)));
    };
    var $author$project$Components$ResourceFilter$Broker$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Broker$toTitle(resource))
        ]);
    };
    var $author$project$Api$Provider$Broker$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Broker$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Broker$Shared$id(shared);
    };
    var $author$project$Components$ResourceFilter$Broker$toValue = $author$project$Api$Provider$Broker$All$id;
    var $author$project$Components$ResourceFilter$Broker$init = F3(function(apiClient, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Broker$fetchResources(listOptionals),
            aef: $author$project$Components$ResourceFilter$Broker$selectId,
            gD: 'Broker',
            sz: $author$project$Components$ResourceFilter$Broker$retrieveResource(listOptionals),
            ahW: $author$project$Components$ResourceFilter$Broker$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Broker$toTitle,
            g4: $author$project$Components$ResourceFilter$Broker$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$LeadSource$list = $author$project$Api$Provider$LeadSource$list;
    var $author$project$Components$ResourceFilter$LeadSource$fetchResources = F5(function(listOptionals, toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$LeadSource$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$LeadSource$retrieveResource = F4(function(listOptionals, toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$LeadSource$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$LeadSource$selectId = 'lead-sources';
    var $author$project$Components$ResourceFilter$LeadSource$toTitle = function(resource) {
        return $author$project$Api$Provider$LeadSource$All$name(resource);
    };
    var $author$project$Components$ResourceFilter$LeadSource$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$LeadSource$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$LeadSource$toValue = $author$project$Api$Provider$LeadSource$All$id;
    var $author$project$Components$ResourceFilter$LeadSource$init = F3(function(apiClient, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$LeadSource$fetchResources(listOptionals),
            aef: $author$project$Components$ResourceFilter$LeadSource$selectId,
            gD: 'Lead Source',
            sz: $author$project$Components$ResourceFilter$LeadSource$retrieveResource(listOptionals),
            ahW: $author$project$Components$ResourceFilter$LeadSource$toLabel,
            ahZ: $author$project$Components$ResourceFilter$LeadSource$toTitle,
            g4: $author$project$Components$ResourceFilter$LeadSource$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$open = F2(function(signupPage, model) {
        if (!model.$) {
            var apiClient = model.a;
            var _v1 = A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, function(d) {
                return _Utils_update(d, {
                    GF: $elm$core$Maybe$Just(true),
                    Hs: $elm$core$Maybe$Just($author$project$Api$Provider$SignupPage$All$id(signupPage))
                });
            }, function(d) {
                return _Utils_update(d, {
                    Ee: 'None'
                });
            });
            var practitionerResourceFilter = _v1.a;
            var practitionerResourceFilterCmd = _v1.b;
            var _v2 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, function(d) {
                return _Utils_update(d, {
                    GF: $elm$core$Maybe$Just(true),
                    Hs: $elm$core$Maybe$Just($author$project$Api$Provider$SignupPage$All$id(signupPage))
                });
            }, function(d) {
                return _Utils_update(d, {
                    Ee: 'None'
                });
            });
            var locationResourceFilter = _v2.a;
            var locationResourceFilterCmd = _v2.b;
            var _v3 = A3($author$project$Components$ResourceFilter$LeadSource$init, apiClient, $elm$core$Basics$identity, function(d) {
                return _Utils_update(d, {
                    Ee: 'None'
                });
            });
            var leadSourceResourceFilter = _v3.a;
            var leadSourceResourceFilterCmd = _v3.b;
            var _v4 = A3($author$project$Components$ResourceFilter$Broker$init, apiClient, function(d) {
                return _Utils_update(d, {
                    Hi: $elm$core$Maybe$Just(true)
                });
            }, function(d) {
                return _Utils_update(d, {
                    Ee: 'None'
                });
            });
            var brokerResourceFilter = _v4.a;
            var brokerResourceFilterCmd = _v4.b;
            return _Utils_Tuple2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open({
                Jc: $elm$core$Maybe$Nothing,
                lh: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                    aef: 'billing-period-dropdown-filter',
                    ahX: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodDropdownMsg
                })),
                lj: brokerResourceFilter,
                lF: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                    aef: 'coupon-dropdown-filter',
                    ahX: $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponDropdownMsg
                })),
                wY: $author$project$Api$Data$Loading,
                PU: $author$project$Utils$Form$init($author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsInit),
                mT: leadSourceResourceFilter,
                ro: locationResourceFilter,
                jE: practitionerResourceFilter,
                Hs: signupPage
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                A3($author$project$Api$Provider$Coupon$list, apiClient, function(d) {
                    return _Utils_update(d, {
                        Hc: $elm$core$Maybe$Just(true)
                    });
                }, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotCoupons),
                A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
                A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg, locationResourceFilterCmd),
                A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd),
                A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg, brokerResourceFilterCmd),
                A3($author$project$Api$Provider$SignupPage$retrieve, apiClient, $author$project$Api$Provider$SignupPage$All$id(signupPage), $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotSignupPageOne)
            ])));
        } else {
            var open_ = model.a;
            return _Utils_Tuple2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(open_), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriod = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Broker = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Coupon = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotPlanAllowedCodes = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSource = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Location = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Practitioner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    agi: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    aeT: string
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    pH: string
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    Mj: string
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    S1: string
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    vQ: string
                });
        }
    });
    var $author$project$Components$ResourceFilter$Broker$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$LeadSource$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$Broker$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$ResourceFilter$LeadSource$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$ResourceFilter$Location$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$update = F3(function(apiClient, msg, model) {
        if (!model.$) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        else {
            var open_ = model.a;
            switch(msg.$){
                case 0:
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Closed(apiClient), $elm$core$Platform$Cmd$none, _List_Nil);
                case 1:
                    var subMsg = msg.a;
                    var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, open_.jE);
                    var newForm = function() {
                        var _v2 = practitionerResourceResult.adu;
                        if (!_v2.$ && !_v2.a.$) return A3($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Practitioner($author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.zi)), open_.PU);
                        else return open_.PU;
                    }();
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        PU: newForm,
                        jE: practitionerResourceResult.zi
                    })), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg, practitionerResourceResult.EQ), practitionerResourceResult.at);
                case 2:
                    var subMsg = msg.a;
                    var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, open_.ro);
                    var newForm = function() {
                        var _v3 = locationResourceResult.adu;
                        if (!_v3.$ && !_v3.a.$) return A3($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Location($author$project$Components$ResourceFilter$Location$value(locationResourceResult.zi)), open_.PU);
                        else return open_.PU;
                    }();
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        PU: newForm,
                        ro: locationResourceResult.zi
                    })), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg, locationResourceResult.EQ), locationResourceResult.at);
                case 3:
                    var subMsg = msg.a;
                    var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, open_.lh);
                    var billingPeriodDropdown = _v4.a;
                    var cmd = _v4.b;
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        lh: billingPeriodDropdown
                    })), cmd, _List_Nil);
                case 4:
                    var selectedPeriod = msg.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriod(selectedPeriod), open_.PU);
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        PU: newForm
                    })), $elm$core$Platform$Cmd$none, _List_Nil);
                case 5:
                    var response = msg.a;
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        wY: response
                    })), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                case 12:
                    var response = msg.a;
                    var planIds = function() {
                        if (response.$ === 3) {
                            var sp = response.a;
                            return A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$SignupPagePlan$Shared$plan, $author$project$Api$Provider$Plan$Min$id), $author$project$Api$Provider$SignupPage$One$signupPagePlans(sp));
                        } else return _List_Nil;
                    }();
                    var planFetchCmds = $elm$core$Platform$Cmd$batch(A2($elm$core$List$map, function(id_) {
                        return A4($author$project$Api$Provider$Plan$retrieve, apiClient, id_, _List_Nil, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$GotPlanAllowedCodes);
                    }, planIds));
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(open_), planFetchCmds, $author$project$OutMsg$handleErrorResponse(response));
                case 11:
                    var response = msg.a;
                    var newAllowed = function() {
                        if (response.$ === 3) {
                            var plan = response.a;
                            return $elm_community$list_extra$List$Extra$unique($author$project$Api$Provider$Plan$One$allowedBillingPeriodCodes(plan));
                        } else return _List_Nil;
                    }();
                    var merged = function() {
                        var _v6 = open_.Jc;
                        if (!_v6.$) {
                            var existing = _v6.a;
                            return $elm_community$list_extra$List$Extra$unique(_Utils_ap(existing, newAllowed));
                        } else return newAllowed;
                    }();
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        Jc: $elm$core$Maybe$Just(merged)
                    })), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                case 6:
                    var subMsg = msg.a;
                    var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, open_.lF);
                    var couponDropdown = _v8.a;
                    var cmd = _v8.b;
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        lF: couponDropdown
                    })), cmd, _List_Nil);
                case 7:
                    var selectedCoupon = msg.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Coupon(selectedCoupon), open_.PU);
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        PU: newForm
                    })), $elm$core$Platform$Cmd$none, _List_Nil);
                case 8:
                    var subMsg = msg.a;
                    var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, open_.mT);
                    var newForm = function() {
                        var _v9 = leadSourceResourceResult.adu;
                        if (!_v9.$ && !_v9.a.$) return A3($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSource($author$project$Components$ResourceFilter$LeadSource$value(leadSourceResourceResult.zi)), open_.PU);
                        else return open_.PU;
                    }();
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        PU: newForm,
                        mT: leadSourceResourceResult.zi
                    })), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg, leadSourceResourceResult.EQ), leadSourceResourceResult.at);
                case 9:
                    var subMsg = msg.a;
                    var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, open_.lj);
                    var newForm = function() {
                        var _v10 = brokerResourceResult.adu;
                        if (!_v10.$ && !_v10.a.$) return A3($author$project$Utils$Form$update, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$formFieldsUpdate, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Broker($author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.zi)), open_.PU);
                        else return open_.PU;
                    }();
                    return _Utils_Tuple3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Open(_Utils_update(open_, {
                        lj: brokerResourceResult.zi,
                        PU: newForm
                    })), A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg, brokerResourceResult.EQ), brokerResourceResult.at);
                default:
                    var url = msg.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(url), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
                    ]));
            }
        }
    });
    var $author$project$Pages$Admin$SignupPages$Top$updateUrl = function(model) {
        var queryParams = _List_Nil;
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__SignupPages__Top)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Pages$Admin$SignupPages$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        i$: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    i$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var signupPages = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        NC: $elm$core$List$head(signupPages)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$SignupPages$Top$fetchItems(newModel),
                    $author$project$Pages$Admin$SignupPages$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    o0: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$SignupPage$makeDefault, model.Ej, id, $author$project$Pages$Admin$SignupPages$Top$DefaultSignupPageUpdated), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    i$: $author$project$Api$Data$Loading,
                    o0: response
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$SignupPages$Top$fetchItems(model),
                    $author$project$Pages$Admin$SignupPages$Top$getDefault(model)
                ])), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Default page updated')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    o0: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 5:
                var item = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Just(item)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var item = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Provider$SignupPage$All$id(item), model.dS),
                            i$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$SignupPages$Top$fetchItems(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Page was successfully removed.')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Provider$SignupPage$All$id(item), model.dS)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 7:
                var item = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$SignupPage$All$id(item);
                    return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Nothing,
                        dS: A2($elm$core$Set$insert, id, model.dS)
                    }), A3($author$project$Api$Provider$SignupPage$delete, model.Ej, id, $author$project$Pages$Admin$SignupPages$Top$Deleted(item)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var item = msg.a;
                var _v5 = A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$open, item, model.fp);
                var customizeUrl = _v5.a;
                var customizeUrlCmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    fp: customizeUrl
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg, customizeUrlCmd), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v6 = A3($author$project$Components$Admin$SignupPages$CustomizeUrlModal$update, model.Ej, subMsg, model.fp);
                var customizeUrl = _v6.a;
                var customizeUrlCmd = _v6.b;
                var outMsgs = _v6.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    fp: customizeUrl
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg, customizeUrlCmd), outMsgs);
        }
    });
    var $author$project$Api$FeatureGate$MultipleSignupPages = 0;
    var $author$project$Pages$Admin$SignupPages$Top$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$SignupPages$Top$UpdateDefaultSignupPage = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$SignupPage$All$slug = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$slug(shared);
    };
    var $author$project$Pages$Admin$SignupPages$Top$defaultPageOptions = F2(function(items, _default) {
        var allItems = function() {
            if (!_default.$) {
                var defaultSignupPage = _default.a;
                return A2($elm$core$List$cons, defaultSignupPage, A2($elm$core$List$filter, function(item) {
                    return !_Utils_eq($author$project$Api$Provider$SignupPage$All$id(item), $author$project$Api$Provider$SignupPage$All$id(defaultSignupPage));
                }, items));
            } else return items;
        }();
        return A2($elm$core$List$map, function(item) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$SignupPage$All$id(item)), '/signup/' + $author$project$Api$Provider$SignupPage$All$slug(item));
        }, allItems);
    });
    var $author$project$Ui$Form$Select$Size = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$size = $author$project$Ui$Form$Select$Size;
    var $author$project$Pages$Admin$SignupPages$Top$help = function(model) {
        var _v0 = model.i$;
        if (_v0.$ === 3) {
            var items = _v0.a;
            return A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('Available at '),
                A3($author$project$Ui$Link$externalHref, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.NC)), _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$baseUrl, model.NC)))
                ])),
                $elm$html$Html$text(' which will redirect to '),
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('form-inline')
                ]), _List_fromArray([
                    $elm$core$List$length(items) > 1 ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$inline,
                        $author$project$Ui$Form$Select$size(1),
                        $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$id, model.NC)),
                        $author$project$Ui$Form$Select$onChange($author$project$Pages$Admin$SignupPages$Top$UpdateDefaultSignupPage),
                        $author$project$Ui$Form$Select$loading(_Utils_eq(model.o0, $author$project$Api$Data$Loading))
                    ]), A2($author$project$Pages$Admin$SignupPages$Top$defaultPageOptions, items, model.NC)) : $elm$html$Html$text('/signup/' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$slug, model.NC)))
                ]))
            ]));
        } else return $author$project$Ui$Spinner$view(_List_Nil);
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$Copy = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$SignupPage$Shared$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Api$Provider$SignupPage$All$url = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$url(shared);
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$buildUrl = F2(function(signupPage, fields) {
        var queryParams = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('practitioner'), fields.agi),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('location'), fields.aeT),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('billing_period'), fields.pH),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('coupon'), fields.Mj),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('lead'), fields.S1),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('broker'), fields.vQ)
        ]));
        if ($elm$core$List$isEmpty(queryParams)) return $elm$core$Maybe$Nothing;
        else {
            var signupPageUrl = $author$project$Api$Provider$SignupPage$All$url(signupPage);
            return $elm$core$Maybe$Just(A2($author$project$Utils$Url$addParams, signupPageUrl, queryParams));
        }
    });
    var $author$project$Api$Provider$SignupPage$All$type_ = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$type_(shared);
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName = function(billName) {
        return A3($elm$core$String$replace, '-', '_', $elm$core$String$toLower(billName));
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewBillingPeriodDropdown = F2(function(model, billingPeriod) {
        var loading = _Utils_eq(model.Jc, $elm$core$Maybe$Nothing);
        var items = function() {
            if (loading) return _List_fromArray([
                A2($author$project$Ui$Dropdown$item, _List_Nil, $elm$html$Html$text('Loading...'))
            ]);
            else {
                var allowedCodes = A2($elm$core$Maybe$withDefault, _List_Nil, model.Jc);
                var periods = A2($elm$core$List$filter, function(p) {
                    return A2($elm$core$List$member, $author$project$Api$Period$code(p), allowedCodes);
                }, $author$project$Api$Period$list);
                return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected($elm$core$Maybe$Nothing))
                ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(p) {
                    var periodValue = $author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName($author$project$Api$Period$billName(p));
                    var periodLabel = $elm_community$string_extra$String$Extra$toSentenceCase($author$project$Api$Period$billName(p));
                    return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$Admin$SignupPages$CustomizeUrlModal$BillingPeriodSelected($elm$core$Maybe$Just(periodValue))),
                        $author$project$Ui$Dropdown$selected(_Utils_eq(billingPeriod, $elm$core$Maybe$Just(periodValue)))
                    ]), $elm$html$Html$text(periodLabel));
                }, periods)));
            }
        }();
        var currentLabel = function() {
            if (!billingPeriod.$) {
                var period = billingPeriod.a;
                return A2($elm$core$Maybe$withDefault, 'None', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Period$billName, $elm_community$string_extra$String$Extra$toSentenceCase), $elm$core$List$head(A2($elm$core$List$filter, function(p) {
                    return _Utils_eq($author$project$Components$Admin$SignupPages$CustomizeUrlModal$normalizeBillName($author$project$Api$Period$billName(p)), period);
                }, $author$project$Api$Period$list))));
            } else return 'None';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentLabel)
        ]), items, model.lh);
    });
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewCouponDropdown = F2(function(model, coupon) {
        var items = function() {
            var _v1 = model.wY;
            if (_v1.$ === 3) {
                var coupons = _v1.a;
                return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected($elm$core$Maybe$Nothing))
                ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(couponItem) {
                    var couponCode = $author$project$Api$Provider$Coupon$All$code(couponItem);
                    return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$Admin$SignupPages$CustomizeUrlModal$CouponSelected($elm$core$Maybe$Just(couponCode))),
                        $author$project$Ui$Dropdown$selected(_Utils_eq(coupon, $elm$core$Maybe$Just(couponCode)))
                    ]), $elm$html$Html$text(couponCode));
                }, coupons)));
            } else return _List_fromArray([
                A2($author$project$Ui$Dropdown$item, _List_Nil, $elm$html$Html$text('Loading...'))
            ]);
        }();
        var currentLabel = function() {
            if (!coupon.$) {
                var couponCode = coupon.a;
                return couponCode;
            } else return 'None';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentLabel)
        ]), items, model.lF);
    });
    var $author$project$Components$ResourceFilter$Broker$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$ResourceFilter$LeadSource$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$ResourceFilter$Location$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$ResourceFilter$Practitioner$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewModal = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var url = A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$buildUrl, model.Hs, fields);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Customize URL')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Edit the form below to generate a unique URL to send to your patients.')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Patient & Billing')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('This information will be displayed to the patient, but can not be changed.')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9),
                    $author$project$Ui$Form$Group$label('Practitioner')
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$viewNew, _List_Nil, model.jE))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9),
                    $author$project$Ui$Form$Group$label('Location')
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$viewNew, _List_Nil, model.ro))
                ])),
                $author$project$Api$Provider$SignupPage$All$type_(model.Hs) === 'signup' ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9),
                    $author$project$Ui$Form$Group$label('Billing Period')
                ]), _List_fromArray([
                    A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewBillingPeriodDropdown, model, fields.pH)
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9),
                    $author$project$Ui$Form$Group$label('Coupon')
                ]), _List_fromArray([
                    A2($author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewCouponDropdown, model, fields.Mj)
                ])),
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Sales & Marketing')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('This information will be recorded but will not be displayed to the patient.')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9),
                    $author$project$Ui$Form$Group$label('Lead Source')
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$LeadSourceResourceFilterMsg, A2($author$project$Components$ResourceFilter$LeadSource$viewNew, _List_Nil, model.mT))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9),
                    $author$project$Ui$Form$Group$label('Broker')
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$BrokerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_Nil, model.lj))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Once applying a form from above, copy the new url below or test it by '),
                        function() {
                            if (!url.$) {
                                var url_ = url.a;
                                return A3($author$project$Ui$Link$externalHref, url_, _List_fromArray([
                                    $author$project$Ui$Link$targetBlank
                                ]), _List_fromArray([
                                    $elm$html$Html$text('clicking here')
                                ]));
                            } else return $elm$html$Html$text('clicking here');
                        }(),
                        $elm$html$Html$text('.')
                    ])),
                    $author$project$Ui$Form$Input$group(_List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', url)),
                            $author$project$Ui$Form$Input$disabled(true)
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy url'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$disabled(!$author$project$Utils$Maybe$toBool(url)),
                            $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$CustomizeUrlModal$Copy(A2($elm$core$Maybe$withDefault, '', url)))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Copy')
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('The url generated below is not stored, but can be re-created here at any time.')
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$SignupPages$CustomizeUrlModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Done')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Admin$SignupPages$CustomizeUrlModal$view = function(model) {
        if (model.$ === 1) {
            var open_ = model.a;
            return $author$project$Components$Admin$SignupPages$CustomizeUrlModal$viewModal(open_);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Admin$SignupPages$Top$viewNewSignupPageButton = A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__SignupPages__New, _List_fromArray([
        $author$project$Ui$Link$buttonDefault,
        $author$project$Ui$Link$pull(1),
        $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
    ]), _List_fromArray([
        $elm$html$Html$text('New Signup Page')
    ]));
    var $author$project$Pages$Admin$SignupPages$Top$CustomizeUrl = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$SignupPages$Top$Delete = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$SignupPage$Shared$acceptsNewSignup = function(_v0) {
        var record = _v0;
        return record.Ih;
    };
    var $author$project$Api$Provider$SignupPage$All$acceptsNewSignup = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$acceptsNewSignup(shared);
    };
    var $author$project$Api$Provider$SignupPage$All$active = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$active(shared);
    };
    var $author$project$Api$Provider$SignupPage$All$addons = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$addons(shared);
    };
    var $author$project$Api$Pagination$currentPageNumber = function(_v0) {
        var model = _v0;
        return model.bt;
    };
    var $author$project$Api$Provider$SignupPage$Shared$default = function(_v0) {
        var record = _v0;
        return record.Nn;
    };
    var $author$project$Api$Provider$SignupPage$All$default = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$default(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$listSignupPagePlans = function(signupPage) {
        return $author$project$Formatters$String$toSentence(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$SignupPagePlan$Shared$plan, $author$project$Api$Provider$Plan$Min$name), $author$project$Api$Provider$SignupPage$Shared$signupPagePlans(signupPage)));
    };
    var $author$project$Api$Provider$SignupPage$Shared$displayName = function(signupPage) {
        return $author$project$Api$Provider$SignupPage$Shared$type_(signupPage) === 'checkout' ? A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$Min$name, $author$project$Api$Provider$SignupPage$Shared$chargeItem(signupPage))) : $author$project$Api$Provider$SignupPage$Shared$listSignupPagePlans(signupPage);
    };
    var $author$project$Api$Provider$SignupPage$All$displayName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$displayName(shared);
    };
    var $author$project$Api$Provider$SignupPage$Shared$isDestroyable = function(_v0) {
        var record = _v0;
        return record.R1;
    };
    var $author$project$Api$Provider$SignupPage$All$isDestroyable = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SignupPage$Shared$isDestroyable(shared);
    };
    var $author$project$Pages$Admin$SignupPages$Top$listSignupPageAddons = function(addons) {
        return $author$project$Formatters$String$toSentence(A2($elm$core$List$map, $author$project$Api$Provider$Addon$Shared$name, addons));
    };
    var $author$project$Ui$OverflowWrap$WordBreakAll = 4;
    var $author$project$Ui$OverflowWrap$wordBreakAll = 4;
    var $author$project$Pages$Admin$SignupPages$Top$viewItem = F2(function(model, item) {
        var status = model.Ba && $author$project$Api$Provider$SignupPage$All$active(item) && $author$project$Api$Provider$SignupPage$All$acceptsNewSignup(item) ? 'live' : !$author$project$Api$Provider$SignupPage$All$acceptsNewSignup(item) ? 'error' : 'inactive';
        var id = $author$project$Api$Provider$SignupPage$All$id(item);
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                        $author$project$Api$Provider$SignupPage$All$type_(item) === 'checkout' ? $author$project$Ui$Icon$cart(_List_Nil) : $author$project$Ui$Icon$onlineSignup(_List_Nil)
                    ])),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$SignupPage$All$displayName(item))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$wordBreakAll)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$externalHref, $author$project$Api$Provider$SignupPage$All$url(item), _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$SignupPage$All$url(item))
                        ]))
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Customize URL'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$SignupPages$Top$CustomizeUrl(item))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Customize URL')
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, status)
                ]))
            ]),
            $elm$core$List$isEmpty(model.IH) ? _List_Nil : _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Pages$Admin$SignupPages$Top$listSignupPageAddons($author$project$Api$Provider$SignupPage$All$addons(item)))
                ]))
            ]),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__SignupPages__Id_String({
                            aef: id
                        }), _List_fromArray([
                            $author$project$Ui$Link$routeParams(_List_fromArray([
                                A2($elm$url$Url$Builder$string, 'page', $elm$core$String$fromInt($author$project$Api$Pagination$currentPageNumber(model.af_)))
                            ])),
                            $author$project$Ui$Link$sm,
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Edit')
                        ])),
                        $author$project$Api$Provider$SignupPage$All$default(item) ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, 'default')
                        ])) : $author$project$Utils$Html$empty,
                        function() {
                            if ($author$project$Api$Provider$SignupPage$All$isDestroyable(item)) {
                                var loading = A2($elm$core$Set$member, id, model.dS);
                                return A3($author$project$Ui$Button$view, {
                                    abP: 'Delete signup page'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$size(0),
                                    $author$project$Ui$Button$loading(loading),
                                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$SignupPages$Top$Delete(item)),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Delete')
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ])
        ])));
    });
    var $author$project$Pages$Admin$SignupPages$Top$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.i$;
            if (_v1.$ === 3) {
                var items_ = _v1.a;
                return _Utils_Tuple2(false, items_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var items = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('There are no signup pages.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Plan / Charge')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Url')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Status')
                ]))
            ]),
            $elm$core$List$isEmpty(model.IH) ? _List_Nil : _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Wrap-Arounds Enabled')
                ]))
            ]),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ])
        ])), A2($elm$core$List$map, $author$project$Pages$Admin$SignupPages$Top$viewItem(model), items), _List_Nil);
    };
    var $author$project$Pages$Admin$SignupPages$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.$8;
                    if (!_v0.$) {
                        var item = _v0.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$SignupPages$Top$HiConfirmClosed(item), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('signup page'),
                            $author$project$Components$HiConfirm$detail('. It will no longer be available for new patients to sign up')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($elm$html$Html$map, $author$project$Pages$Admin$SignupPages$Top$CustomizeUrlMsg, $author$project$Components$Admin$SignupPages$CustomizeUrlModal$view(model.fp)),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        model.Ba ? $author$project$Utils$Html$empty : A2($author$project$Utils$PaymentProcessor$toSetupAlert, $author$project$Api$Practice$Provider(model.W1), $elm$core$Maybe$Just('In order to enable signup pages')),
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            $elm$html$Html$text('Signup Pages')
                        ]), _List_fromArray([
                            A3($author$project$Utils$FeatureGate$gate, 0, $author$project$Api$Practice$Provider(model.W1), $author$project$Pages$Admin$SignupPages$Top$viewNewSignupPageButton)
                        ])),
                        $author$project$Pages$Admin$SignupPages$Top$help(model)
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Admin$SignupPages$Top$viewPanelBody(model)
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$SignupPages$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.i$))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Signup Pages'
        };
    };
    var $author$project$Pages$Admin$SignupPages$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$SignupPages$Top$init,
        aeR: $author$project$Pages$Admin$SignupPages$Top$load,
        ag3: $author$project$Pages$Admin$SignupPages$Top$save,
        ahE: $author$project$Pages$Admin$SignupPages$Top$subscriptions,
        aaO: $author$project$Pages$Admin$SignupPages$Top$update,
        aid: $author$project$Pages$Admin$SignupPages$Top$view
    });
    var $author$project$Pages$Admin$Stripe$StripeMsg = $elm$core$Basics$identity;
    var $author$project$Components$Stripe$Connected = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Stripe$Connecting = {
        $: 0
    };
    var $author$project$Components$Stripe$CreateStripeAccount = {
        $: 3
    };
    var $author$project$Components$Stripe$FailedToConnect = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Stripe$HasStripeAccount = {
        $: 2
    };
    var $author$project$Components$Stripe$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeOnboarding$Shared$accountStep = function(_v0) {
        var record = _v0;
        return record.Im;
    };
    var $author$project$Api$Provider$Practice$StripeAccount$connect = F3(function(apiClient, code, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('stripe_account', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('code', $elm$json$Json$Encode$string(code))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$StripeAccount$stripeAccountPath)));
    });
    var $author$project$Components$Stripe$init = F5(function(session, practice, shared, query, _v0) {
        var isOnboarding = _v0.aK;
        var setupCompleted = A2($elm$core$Maybe$withDefault, 7, A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$Shared$accountStep, $author$project$Api$Provider$Practice$One$practiceOnboarding(practice))) === 7;
        var shouldRedirectToPracticeSetupStripe = !setupCompleted && !isOnboarding;
        var _v1 = function() {
            var _v2 = _Utils_Tuple2(A2($elm$core$Dict$get, 'error', query), shouldRedirectToPracticeSetupStripe);
            if (!_v2.b) {
                if (!_v2.a.$) return _Utils_Tuple2($author$project$Components$Stripe$FailedToConnect(A2($elm$core$Dict$get, 'error_description', query)), $elm$core$Platform$Cmd$none);
                else {
                    var _v3 = _v2.a;
                    var _v4 = A2($elm$core$Dict$get, 'code', query);
                    if (!_v4.$) {
                        var string = _v4.a;
                        return _Utils_Tuple2($author$project$Components$Stripe$Connecting, A3($author$project$Api$Provider$Practice$StripeAccount$connect, shared.Ej, string, $author$project$Components$Stripe$Connected));
                    } else return $author$project$Api$Provider$Practice$One$hasStripeAccount(practice) ? _Utils_Tuple2($author$project$Components$Stripe$HasStripeAccount, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Components$Stripe$CreateStripeAccount, $elm$core$Platform$Cmd$none);
                }
            } else return _Utils_Tuple2($author$project$Components$Stripe$CreateStripeAccount, A2($author$project$Utils$Route$navigate, query, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing));
        }();
        var status = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple2({
            fA: false,
            qW: shared.qW,
            F3: $author$project$Shared$isHintAdmin(shared),
            aK: isOnboarding,
            W1: practice,
            Z$: session,
            ahy: status,
            aaX: $author$project$Api$Platform$Session$One$user(session)
        }, cmd);
    });
    var $author$project$Pages$Admin$Stripe$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Stripe$init, session, practice, shared, query, {
            aK: false
        });
        var stripe = _v1.a;
        var stripeCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            F3: $author$project$Shared$isHintAdmin(shared),
            oE: stripe
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, stripeCmd));
    });
    var $author$project$Pages$Admin$Stripe$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Stripe$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Stripe$HiConfirmClosed = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Stripe$subscriptions = function(_v0) {
        var model = _v0;
        return model.fA ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Stripe$HiConfirmClosed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Admin$Stripe$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Stripe$subscriptions(model.oE));
    };
    var $author$project$Components$Stripe$Disconnected = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Stripe$PracticeOnboardingUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Stripe$skipStripeSetup = F2(function(apiClient, practice) {
        var onboardId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$Shared$id, $author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
        return A3($author$project$Api$Provider$PracticeOnboarding$complete, apiClient, onboardId, $author$project$Components$Stripe$PracticeOnboardingUpdated);
    });
    var $author$project$Components$Stripe$update = F3(function(msg, _v0, apiClient) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v2$2: while(true)switch(response.$){
                    case 3:
                        var practice = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            W1: practice,
                            ahy: $author$project$Components$Stripe$HasStripeAccount
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been connected.'),
                            $author$project$OutMsg$PracticeUpdated(response)
                        ]));
                    case 2:
                        if (response.a.$ === 6) {
                            var _v3 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                ahy: $author$project$Components$Stripe$FailedToConnect($elm$core$Maybe$Nothing)
                            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                        } else break _v2$2;
                    default:
                        break _v2$2;
                }
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    fA: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                return _Utils_Tuple3(model, A2($author$project$Components$Stripe$skipStripeSetup, apiClient, model.W1), _List_Nil);
            case 8:
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete), _List_Nil);
            case 7:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Complete), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(model, A2($author$project$Api$Provider$Practice$StripeAccount$disconnect, apiClient, $author$project$Components$Stripe$Disconnected), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    fA: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fA: false,
                        W1: practice,
                        ahy: $author$project$Components$Stripe$CreateStripeAccount
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your stripe integration has been disconnected.'),
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    fA: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                return _Utils_Tuple3(model, $author$project$Ports$Intercom$open(model.Z$), _List_Nil);
            default:
                var status = $author$project$Api$Provider$Practice$One$hasStripeAccount(model.W1) ? $author$project$Components$Stripe$HasStripeAccount : $author$project$Components$Stripe$CreateStripeAccount;
                return _Utils_Tuple3(_Utils_update(model, {
                    ahy: status
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Stripe$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Stripe$update, subMsg, model.oE, model.Ej);
        var stripe = _v1.a;
        var stripeCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            oE: stripe
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, stripeCmd), outMsgs);
    });
    var $author$project$Ui$Image$StripeLogo = 2;
    var $author$project$Components$Stripe$viewConnectingBody = _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Status'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, 'connecting')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $author$project$Ui$Spinner$view(_List_Nil)
            ]))
        ]))
    ]);
    var $author$project$Components$Stripe$viewCreateStripeAccountBody = _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Status'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, 'inactive')
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Stripe is a global payments platform that instantly enables business of all sizes to accept and process payments online. Our negotiated volume discount with Stripe can be reviewed '),
                A3($author$project$Ui$Link$externalHref, 'http://www.hint.com/pricing#stripe', _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                $elm$html$Html$text('.')
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('To configure this integration click \'Connect to Stripe\' and you will have the option of creating, or connecting to an existing Stripe account.')
            ]))
        ]))
    ]);
    var $author$project$Components$Stripe$SkipStripeSetup = {
        $: 6
    };
    var $author$project$Api$Platform$User$Shared$firstName = function(_v0) {
        var record = _v0;
        return record.PN;
    };
    var $author$project$Api$Platform$User$Shared$lastName = function(_v0) {
        var record = _v0;
        return record.SU;
    };
    var $author$project$Api$Provider$Practice$Shared$stripeClientId = function(_v0) {
        var record = _v0;
        return record.$d;
    };
    var $author$project$Api$Provider$Practice$One$stripeClientId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$stripeClientId(shared);
    };
    var $author$project$Components$Stripe$stripeConnectBaseUrl = 'https://connect.stripe.com/oauth/authorize';
    var $author$project$Api$Common$Address$Shared$stripeCountryCode = function(_v0) {
        var record = _v0;
        return record.$f;
    };
    var $author$project$Components$Stripe$stripeConnectUrl = function(_v0) {
        var model = _v0;
        var practiceAddress = $author$project$Api$Provider$Practice$One$address(model.W1);
        var stripeUser = _List_fromArray([
            _Utils_Tuple2('first_name', $author$project$Api$Platform$User$Shared$firstName(model.aaX)),
            _Utils_Tuple2('last_name', $author$project$Api$Platform$User$Shared$lastName(model.aaX)),
            _Utils_Tuple2('email', $author$project$Api$Platform$User$Shared$email(model.aaX)),
            _Utils_Tuple2('phone_number', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Phone$Shared$number, $elm$core$List$head($author$project$Api$Provider$Practice$One$phones(model.W1))))),
            _Utils_Tuple2('url', A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Practice$One$url(model.W1))),
            _Utils_Tuple2('product_description', 'Primary and urgent care services at a fixed monthly price'),
            _Utils_Tuple2('business_name', $author$project$Api$Provider$Practice$One$name(model.W1)),
            _Utils_Tuple2('business_type', 'sole_prop'),
            _Utils_Tuple2('street_address', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$line1, practiceAddress))),
            _Utils_Tuple2('city', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$city, practiceAddress))),
            _Utils_Tuple2('zip', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$zip, practiceAddress))),
            _Utils_Tuple2('state', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$state, practiceAddress))),
            _Utils_Tuple2('country', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Common$Address$Shared$stripeCountryCode, practiceAddress)))
        ]);
        var queryParams = A2($elm$core$List$cons, A2($elm$url$Url$Builder$string, 'client_id', $author$project$Api$Provider$Practice$One$stripeClientId(model.W1)), A2($elm$core$List$cons, A2($elm$url$Url$Builder$string, 'response_type', 'code'), A2($elm$core$List$cons, A2($elm$url$Url$Builder$string, 'scope', 'read_write'), A2($elm$core$List$map, function(_v1) {
            var key = _v1.a;
            var value = _v1.b;
            return A2($elm$url$Url$Builder$string, 'stripe_user[' + (key + ']'), value);
        }, stripeUser))));
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Components$Stripe$stripeConnectBaseUrl
        ]), queryParams);
    };
    var $author$project$Components$Stripe$viewCreateStripeAccountFooter = function(model) {
        return model.aK ? _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Skip setting up stripe'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$pull(0),
                $author$project$Ui$Button$onClick($author$project$Components$Stripe$SkipStripeSetup)
            ]), _List_fromArray([
                $elm$html$Html$text('Skip')
            ])),
            $author$project$Api$Provider$Practice$One$paymentProcessor(model.W1) === 'stripe' ? A3($author$project$Ui$Link$externalHref, $author$project$Components$Stripe$stripeConnectUrl(model), _List_fromArray([
                $author$project$Ui$Link$buttonPrimary,
                $author$project$Ui$Link$targetBlank
            ]), _List_fromArray([
                $elm$html$Html$text('Connect to Stripe')
            ])) : $author$project$Utils$Html$empty
        ]) : $author$project$Api$Provider$Practice$One$paymentProcessor(model.W1) === 'stripe' ? _List_fromArray([
            A3($author$project$Ui$Link$externalHref, $author$project$Components$Stripe$stripeConnectUrl(model), _List_fromArray([
                $author$project$Ui$Link$buttonPrimary,
                $author$project$Ui$Link$targetBlank
            ]), _List_fromArray([
                $elm$html$Html$text('Connect to Stripe')
            ]))
        ]) : _List_Nil;
    };
    var $author$project$Components$Stripe$viewFailedToConnectBody = function(errorDescription) {
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'failed')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $author$project$Utils$FormErrors$view(_List_fromArray([
                        A2($elm$core$Maybe$withDefault, '', errorDescription)
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Components$Stripe$Reset = {
        $: 5
    };
    var $author$project$Components$Stripe$viewFailedToConnectFooter = function(model) {
        return _List_fromArray([
            model.aK ? A3($author$project$Ui$Button$view, {
                abP: 'Skip setting up stripe'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$pull(0),
                $author$project$Ui$Button$onClick($author$project$Components$Stripe$SkipStripeSetup)
            ]), _List_fromArray([
                $elm$html$Html$text('Skip')
            ])) : $author$project$Utils$Html$empty,
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Stripe, _List_fromArray([
                $author$project$Ui$Link$buttonPrimary,
                $author$project$Ui$Link$onClick($author$project$Components$Stripe$Reset)
            ]), _List_fromArray([
                $elm$html$Html$text('Start over')
            ]))
        ]);
    };
    var $author$project$Components$Stripe$Disconnect = {
        $: 1
    };
    var $author$project$Components$Stripe$ShowSupportChat = {
        $: 4
    };
    var $author$project$Components$Stripe$viewHasStripeAccountBody = function(model) {
        return $author$project$Components$Stripe$ConnectedView$view({
            F3: model.F3,
            afx: $author$project$Components$Stripe$Disconnect,
            afO: $author$project$Components$Stripe$ShowSupportChat,
            W1: model.W1
        });
    };
    var $author$project$Components$Stripe$PracticeOnboardingRedirect = {
        $: 8
    };
    var $author$project$Components$Stripe$viewHasStripeAccountFooter = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                model.aK ? A3($author$project$Ui$Button$view, {
                    abP: 'Go to next step'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$onClick($author$project$Components$Stripe$PracticeOnboardingRedirect)
                ]), _List_fromArray([
                    $elm$html$Html$text('Next')
                ])) : $author$project$Utils$Html$empty
            ]))
        ]);
    };
    var $author$project$Components$Stripe$view = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            model.fA ? A2($author$project$Components$HiConfirm$modal, $author$project$Components$Stripe$HiConfirmClosed, _List_fromArray([
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    $elm$html$Html$text('WARNING: You\'re about to remove your ability to process credit cards and bank accounts! Please be sure this is what you want to do. If you reconnect the same Stripe account, then all existing cards / bank accounts will remain intact. Otherwise, they will not. Either way, this application will not be able to process any electronic transactions for you while you\'re account is disconnected.')
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$autocomplete(false)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, model.aK ? _List_fromArray([
                    $author$project$Ui$Panel$onlyBorderLeft
                ]) : _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Setup Stripe Account')
                        ])),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('We partner with Stripe for secure payments, and setting up your Stripe account is a necessary step to ensure you can receive payments. This step takes about 10 minutes to complete.')
                        ])),
                        $author$project$Api$Provider$Practice$One$paymentProcessor(model.W1) !== 'stripe' ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Connecting to Stripe its not possible for practices using Hint Payments.')
                        ])) : $author$project$Utils$Html$empty,
                        A4($author$project$Ui$Image$view, model.qW, {
                            Jg: 'Stripe Logo'
                        }, _List_fromArray([
                            $author$project$Ui$Image$width(200)
                        ]), 2)
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, function() {
                        var _v1 = model.ahy;
                        switch(_v1.$){
                            case 0:
                                return $author$project$Components$Stripe$viewConnectingBody;
                            case 1:
                                var description = _v1.a;
                                return $author$project$Components$Stripe$viewFailedToConnectBody(description);
                            case 2:
                                return $author$project$Components$Stripe$viewHasStripeAccountBody(model);
                            default:
                                return $author$project$Components$Stripe$viewCreateStripeAccountBody;
                        }
                    }()),
                    function() {
                        var _v2 = model.ahy;
                        switch(_v2.$){
                            case 1:
                                return A2($author$project$Ui$Panel$footer, _List_fromArray([
                                    $author$project$Ui$Element$justifyCenter,
                                    $author$project$Ui$Element$gap2
                                ]), $author$project$Components$Stripe$viewFailedToConnectFooter(model));
                            case 3:
                                return A2($author$project$Ui$Panel$footer, _List_fromArray([
                                    $author$project$Ui$Element$justifyCenter,
                                    $author$project$Ui$Element$gap2
                                ]), $author$project$Components$Stripe$viewCreateStripeAccountFooter(model));
                            case 2:
                                return A2($author$project$Ui$Panel$footer, _List_fromArray([
                                    $author$project$Ui$Element$justifyCenter,
                                    $author$project$Ui$Element$gap2
                                ]), $author$project$Components$Stripe$viewHasStripeAccountFooter(model));
                            default:
                                return $author$project$Ui$Panel$none;
                        }
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Stripe$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Stripe$view(model.oE))
            ]),
            $2: 'Integrations | Stripe'
        };
    };
    var $author$project$Pages$Admin$Stripe$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Stripe$init,
        aeR: $author$project$Pages$Admin$Stripe$load,
        ag3: $author$project$Pages$Admin$Stripe$save,
        ahE: $author$project$Pages$Admin$Stripe$subscriptions,
        aaO: $author$project$Pages$Admin$Stripe$update,
        aid: $author$project$Pages$Admin$Stripe$view
    });
    var $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Taxes$TaxProfilesMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$GotData = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$TaxJurisdiction$All$TaxJurisdiction = $elm$core$Basics$identity;
    var $author$project$Api$Provider$TaxJurisdiction$Shared$TaxJurisdiction = $elm$core$Basics$identity;
    var $author$project$Api$Provider$TaxJurisdiction$Shared$Record = F3(function(id, name, rate) {
        return {
            aef: id,
            zr: name,
            X5: rate
        };
    });
    var $author$project$Api$Provider$TaxJurisdiction$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rate', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxJurisdiction$Shared$Record))));
    var $author$project$Api$Provider$TaxJurisdiction$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TaxJurisdiction$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$TaxJurisdiction$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TaxJurisdiction$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'tax_jurisdictions'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$TaxJurisdiction$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$TaxJurisdiction$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath));
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions = function(apiClient) {
        return A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxJurisdictions$GotData);
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$init = function(apiClient) {
        var model = {
            ii: $elm$core$Maybe$Nothing,
            dX: $elm$core$Set$empty,
            tl: $elm$core$Maybe$Nothing,
            $Q: $author$project$Api$Data$Loading
        };
        return _Utils_Tuple2(model, $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient));
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxProfiles = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$TaxProfile$All$TaxProfile = $elm$core$Basics$identity;
    var $author$project$Api$Provider$TaxProfile$One$TaxProfile = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$TaxProfile$Shared$TaxProfile = $elm$core$Basics$identity;
    var $author$project$Api$Provider$TaxProfile$Shared$Record = F3(function(id, name, rate) {
        return {
            aef: id,
            zr: name,
            X5: rate
        };
    });
    var $author$project$Api$Provider$TaxProfile$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rate', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$Shared$Record))));
    var $author$project$Api$Provider$TaxProfile$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TaxProfile$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$TaxProfile$One$Record = function(taxJurisdictions) {
        return {
            $Q: taxJurisdictions
        };
    };
    var $author$project$Api$Provider$TaxProfile$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tax_jurisdictions', $elm$json$Json$Decode$list($author$project$Api$Provider$TaxJurisdiction$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$One$Record));
    var $author$project$Api$Provider$TaxProfile$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TaxProfile$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TaxProfile$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxProfile$One$TaxProfile)));
    var $author$project$Api$Provider$TaxProfile$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TaxProfile$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$TaxProfile$taxProfilesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'tax_profiles'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$TaxProfile$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$TaxProfile$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$TaxProfile$taxProfilesPath));
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles = function(apiClient) {
        return A2($author$project$Api$Provider$TaxProfile$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxProfiles);
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$init = function(apiClient) {
        var model = {
            ij: $elm$core$Maybe$Nothing,
            dY: $elm$core$Set$empty,
            $Q: $author$project$Api$Data$Loading,
            $R: $elm$core$Maybe$Nothing,
            g2: $author$project$Api$Data$Loading
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions),
            $author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient)
        ])));
    };
    var $author$project$Pages$Admin$Taxes$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var _v4 = $author$project$Components$Admin$Taxes$TaxProfiles$init(apiClient);
        var taxProfiles = _v4.a;
        var taxProfilesCmd = _v4.b;
        var _v5 = $author$project$Components$Admin$Taxes$TaxJurisdictions$init(apiClient);
        var taxJurisdictions = _v5.a;
        var taxJurisdictionsCmd = _v5.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            $Q: taxJurisdictions,
            g2: taxProfiles
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, taxProfilesCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg, taxJurisdictionsCmd)
        ])));
    });
    var $author$project$Pages$Admin$Taxes$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Taxes$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit = {
        $: 2
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit)), model.tl)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed), model.ii))
        ]));
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit = {
        $: 4
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = model.$R;
                if (!_v1.$) return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit);
                else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed), model.ij))
        ]));
    };
    var $author$project$Pages$Admin$Taxes$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg, $author$project$Components$Admin$Taxes$TaxJurisdictions$subscriptions(model.$Q)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, $author$project$Components$Admin$Taxes$TaxProfiles$subscriptions(model.g2))
        ]));
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$taxJurisdictionsUpdated = F2(function(apiClient, _v0) {
        var model = _v0;
        return _Utils_Tuple2(_Utils_update(model, {
            $Q: $author$project$Api$Data$Loading,
            g2: $author$project$Api$Data$Loading
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Admin$Taxes$TaxProfiles$GotTaxJurisdictions),
            $author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient)
        ])));
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$Deleted = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$None = 0;
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$TaxJurisdictionsUpdated = 1;
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$Created = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$TaxJurisdiction$One$TaxJurisdiction = $elm$core$Basics$identity;
    var $author$project$Api$Provider$TaxJurisdiction$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TaxJurisdiction$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$TaxJurisdiction$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('tax_jurisdiction', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('rate', $elm$json$Json$Encode$float(fields.X5))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$TaxJurisdiction$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath)));
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$create = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            zr: fields.zr,
            X5: A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.X5))
        };
        return A3($author$project$Api$Provider$TaxJurisdiction$create, apiClient, apiFields, $author$project$Components$Admin$Taxes$TaxJurisdictions$Created);
    });
    var $author$project$Api$Provider$TaxJurisdiction$taxJurisdictionPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$TaxJurisdiction$taxJurisdictionsPath);
    };
    var $author$project$Api$Provider$TaxJurisdiction$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$TaxJurisdiction$taxJurisdictionPath(id_)));
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsInit = {
        zr: '',
        X5: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                zr: string
            });
        } else {
            var _float = field.a;
            return _Utils_update(fields, {
                X5: _float
            });
        }
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$NameValidation = 0;
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$RateValidation = 1;
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.X5;
        }, _Utils_Tuple2(1, 'Please enter a rate.'))
    ]));
    var $author$project$Api$Provider$TaxJurisdiction$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$TaxJurisdiction$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$TaxJurisdiction$Shared$id(shared);
    };
    var $author$project$Api$Provider$TaxJurisdiction$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$TaxJurisdiction$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$TaxJurisdiction$Shared$name(shared);
    };
    var $author$project$Api$Provider$TaxJurisdiction$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$TaxJurisdiction$Shared$name(shared);
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        $Q: response
                    }),
                    at: $author$project$OutMsg$reportDecodeError(response)
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        tl: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsInit), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        tl: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 3:
                var field = msg.a;
                var _v2 = model.tl;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var taxJurisdiction = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            tl: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, taxJurisdiction))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                var form = msg.a;
                var id = msg.b;
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Taxes$TaxJurisdictions$formFieldsValidator, form);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return {
                        EQ: A2($author$project$Components$Admin$Taxes$TaxJurisdictions$create, apiClient, validFormFields),
                        adu: 0,
                        zi: _Utils_update(model, {
                            tl: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v4.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            tl: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                        }),
                        at: _List_Nil
                    };
                }
            case 4:
                var taxJurisdiction = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ii: $elm$core$Maybe$Just(taxJurisdiction)
                    }),
                    at: _List_Nil
                };
            case 6:
                var response = msg.a;
                var _v6 = model.tl;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var id = _v7.a;
                    var form = _v7.b;
                    if (response.$ === 3) {
                        var taxJurisdiction = response.a;
                        return {
                            EQ: $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient),
                            adu: 1,
                            zi: _Utils_update(model, {
                                tl: $elm$core$Maybe$Nothing,
                                $Q: $author$project$Api$Data$Loading
                            }),
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$TaxJurisdiction$One$name(taxJurisdiction))
                            ])
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            tl: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var taxJurisdiction = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return {
                            EQ: $author$project$Components$Admin$Taxes$TaxJurisdictions$fetchTaxJurisdictions(apiClient),
                            adu: 1,
                            zi: _Utils_update(model, {
                                dX: A2($elm$core$Set$remove, $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction), model.dX),
                                $Q: $author$project$Api$Data$Loading
                            }),
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction) + ' was successfully removed.')
                            ])
                        };
                    case 2:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                dX: A2($elm$core$Set$remove, $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction), model.dX)
                            }),
                            at: $author$project$OutMsg$handleErrorResponse(response)
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: model,
                            at: _List_Nil
                        };
                }
            default:
                var taxJurisdiction = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
                    return {
                        EQ: A3($author$project$Api$Provider$TaxJurisdiction$delete, apiClient, id, $author$project$Components$Admin$Taxes$TaxJurisdictions$Deleted(taxJurisdiction)),
                        adu: 0,
                        zi: _Utils_update(model, {
                            ii: $elm$core$Maybe$Nothing,
                            dX: A2($elm$core$Set$insert, id, model.dX)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ii: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$Deleted = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$TaxProfile$taxProfilePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$TaxProfile$taxProfilesPath);
    };
    var $author$project$Api$Provider$TaxProfile$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$TaxProfile$taxProfilePath(id_)));
    });
    var $author$project$Api$Provider$TaxProfile$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$TaxProfile$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$TaxProfile$Shared$name(shared);
    };
    var $author$project$Api$Provider$TaxProfile$All$name = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$TaxProfile$One$name(one);
    };
    var $author$project$Api$Provider$TaxProfile$One$taxJurisdictions = function(_v0) {
        var record = _v0.b;
        return record.$Q;
    };
    var $author$project$Api$Provider$TaxProfile$All$taxJurisdictions = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$TaxProfile$One$taxJurisdictions(one);
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsFromTaxProfile = function(taxProfile) {
        return {
            zr: $author$project$Api$Provider$TaxProfile$All$name(taxProfile),
            $Q: $elm$core$Set$fromList(A2($elm$core$List$map, $author$project$Api$Provider$TaxJurisdiction$Shared$id, $author$project$Api$Provider$TaxProfile$All$taxJurisdictions(taxProfile)))
        };
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsInit = {
        zr: '',
        $Q: $elm$core$Set$empty
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                zr: string
            });
        } else {
            var id = field.a;
            var bool = field.b;
            var taxJurisdictions = bool ? A2($elm$core$Set$insert, id, fields.$Q) : A2($elm$core$Set$remove, id, fields.$Q);
            return _Utils_update(fields, {
                $Q: taxJurisdictions
            });
        }
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$NameValidation = 0;
    var $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Api$Provider$TaxProfile$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$TaxProfile$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$TaxProfile$Shared$id(shared);
    };
    var $author$project$Api$Provider$TaxProfile$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$TaxProfile$One$id(one);
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$Created = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $elm$core$Set$foldl = F3(function(func, initialState, _v0) {
        var dict = _v0;
        return A3($elm$core$Dict$foldl, F3(function(key, _v1, state) {
            return A2(func, key, state);
        }), initialState, dict);
    });
    var $elm$json$Json$Encode$set = F2(function(func, entries) {
        return _Json_wrap(A3($elm$core$Set$foldl, _Json_addEntry(func), _Json_emptyArray(0), entries));
    });
    var $author$project$Api$Provider$TaxProfile$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('tax_profile', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('tax_jurisdictions', A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, fields.$Q))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$TaxProfile$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$TaxProfile$taxProfilesPath)));
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$create = F2(function(apiClient, formFields) {
        return A3($author$project$Api$Provider$TaxProfile$create, apiClient, $rtfeldman$elm_validate$Validate$fromValid(formFields), $author$project$Components$Admin$Taxes$TaxProfiles$Created);
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$Updated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$TaxProfile$update = F4(function(apiClient, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('tax_profile', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('tax_jurisdictions', A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, fields.$Q))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$TaxProfile$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$TaxProfile$taxProfilePath(id_))));
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$updateTaxProfile = F3(function(apiClient, id, formFields) {
        return A4($author$project$Api$Provider$TaxProfile$update, apiClient, id, $rtfeldman$elm_validate$Validate$fromValid(formFields), $author$project$Components$Admin$Taxes$TaxProfiles$Updated);
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$save = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Components$Admin$Taxes$TaxProfiles$updateTaxProfile, apiClient, id_, formFields);
        } else return A2($author$project$Components$Admin$Taxes$TaxProfiles$create, apiClient, formFields);
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $Q: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    g2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    $R: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Admin$Taxes$TaxProfiles$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var taxProfile = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $R: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$TaxProfile$All$id(taxProfile)), $author$project$Utils$Form$init($author$project$Components$Admin$Taxes$TaxProfiles$formFieldsFromTaxProfile(taxProfile)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    $R: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var field = msg.a;
                var _v2 = model.$R;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var taxProfile = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        $R: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, taxProfile))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var form = msg.a;
                var id = msg.b;
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Taxes$TaxProfiles$formFieldsValidator, form);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        $R: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Components$Admin$Taxes$TaxProfiles$save, apiClient, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        $R: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 6:
                var taxProfile = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ij: $elm$core$Maybe$Just(taxProfile)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                var _v6 = model.$R;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var id = _v7.a;
                    var form = _v7.b;
                    if (response.$ === 3) {
                        var taxProfile = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            $R: $elm$core$Maybe$Nothing,
                            g2: $author$project$Api$Data$Loading
                        }), $author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$TaxProfile$One$name(taxProfile))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        $R: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var response = msg.a;
                var _v9 = model.$R;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) {
                        var taxProfile = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            $R: $elm$core$Maybe$Nothing,
                            g2: $author$project$Api$Data$Loading
                        }), $author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$TaxProfile$One$name(taxProfile) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        $R: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var taxProfile = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dY: A2($elm$core$Set$remove, $author$project$Api$Provider$TaxProfile$All$id(taxProfile), model.dY),
                            g2: $author$project$Api$Data$Loading
                        }), $author$project$Components$Admin$Taxes$TaxProfiles$fetchTaxProfiles(apiClient), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$TaxProfile$All$name(taxProfile) + ' was successfully removed.')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dY: A2($elm$core$Set$remove, $author$project$Api$Provider$TaxProfile$All$id(taxProfile), model.dY)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var taxProfile = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$TaxProfile$All$id(taxProfile);
                    return _Utils_Tuple3(_Utils_update(model, {
                        ij: $elm$core$Maybe$Nothing,
                        dY: A2($elm$core$Set$insert, id, model.dY)
                    }), A3($author$project$Api$Provider$TaxProfile$delete, apiClient, id, $author$project$Components$Admin$Taxes$TaxProfiles$Deleted(taxProfile)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ij: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Admin$Taxes$update = F2(function(msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var _v1 = A3($author$project$Components$Admin$Taxes$TaxProfiles$update, model.Ej, subMsg, model.g2);
            var taxProfiles = _v1.a;
            var subCmd = _v1.b;
            var subOutMsg = _v1.c;
            return _Utils_Tuple3(_Utils_update(model, {
                g2: taxProfiles
            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, subCmd), subOutMsg);
        } else {
            var subMsg = msg.a;
            var result = A3($author$project$Components$Admin$Taxes$TaxJurisdictions$update, model.Ej, subMsg, model.$Q);
            var _v2 = function() {
                var _v3 = result.adu;
                if (!_v3) return _Utils_Tuple2(model.g2, $elm$core$Platform$Cmd$none);
                else return A2($author$project$Components$Admin$Taxes$TaxProfiles$taxJurisdictionsUpdated, model.Ej, model.g2);
            }();
            var taxProfiles = _v2.a;
            var taxProfilesCmd = _v2.b;
            return _Utils_Tuple3(_Utils_update(model, {
                $Q: result.zi,
                g2: taxProfiles
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxProfilesMsg, taxProfilesCmd),
                A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg, result.EQ)
            ])), result.at);
        }
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$New = {
        $: 1
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$help = _List_fromArray([
        $elm$html$Html$text('Tax jurisdictions represent each individual area that levies a sales tax. '),
        $elm$html$Html$text('These include states, counties, cities, and municipalities. For more information, please refer to our '),
        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/account-configuration/creating-sales-tax-profiles-and-jurisdictions', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('help docs')
        ])),
        $elm$html$Html$text('.')
    ]);
    var $author$project$Ui$Element$Small = 1;
    var $author$project$Ui$Element$textSm = $author$project$Ui$Element$Text(1);
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$Rate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$Save = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$PercentageInput$Errors = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$PercentageInput$errors = $author$project$Ui$Form$PercentageInput$Errors;
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewModal = F3(function(id, form, taxJurisdiction) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Sales Tax Jurisdiction',
            Tk: _Utils_eq(taxJurisdiction, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Admin$Taxes$TaxJurisdictions$CancelEdit,
            Vn: $author$project$Components$Admin$Taxes$TaxJurisdictions$Save(form)
        };
        var _v0 = $author$project$Utils$Form$fields(form);
        var name = _v0.zr;
        var rate = _v0.X5;
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(name),
                    $author$project$Ui$Form$Input$placeholder('City of San Francisco, CA'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated, $author$project$Components$Admin$Taxes$TaxJurisdictions$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Rate'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                    $author$project$Ui$Form$PercentageInput$value(rate),
                    $author$project$Ui$Form$PercentageInput$placeholder('1.25'),
                    $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxJurisdictions$FormUpdated, $author$project$Components$Admin$Taxes$TaxJurisdictions$Rate)),
                    $author$project$Ui$Form$PercentageInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$PercentageInput$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$Delete = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$TaxJurisdiction$Shared$rate = function(_v0) {
        var record = _v0;
        return record.X5;
    };
    var $author$project$Api$Provider$TaxJurisdiction$All$rate = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$TaxJurisdiction$Shared$rate(shared);
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewTaxJurisdiction = F2(function(deletingTaxJurisdictions, taxJurisdiction) {
        var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
        var loading = A2($elm$core$Set$member, id, deletingTaxJurisdictions);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromFloat($author$project$Api$Provider$TaxJurisdiction$All$rate(taxJurisdiction)) + '%')
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete tax jurisdiction'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxJurisdictions$Delete(taxJurisdiction)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.$Q;
            if (_v1.$ === 3) {
                var taxJurisdictions_ = _v1.a;
                return _Utils_Tuple2(false, taxJurisdictions_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var taxJurisdictions = _v0.b;
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('None')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Name')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Rate')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ]), A2($elm$core$List$map, $author$project$Components$Admin$Taxes$TaxJurisdictions$viewTaxJurisdiction(model.dX), taxJurisdictions), _List_Nil)
        ]);
    };
    var $author$project$Components$Admin$Taxes$TaxJurisdictions$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            function() {
                var _v1 = model.tl;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var id = _v2.a;
                    var form = _v2.b;
                    var taxJurisdiction = _v2.c;
                    return A3($author$project$Components$Admin$Taxes$TaxJurisdictions$viewModal, id, form, taxJurisdiction);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.ii;
                if (!_v3.$) {
                    var taxJurisdiction = _v3.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Admin$Taxes$TaxJurisdictions$HiConfirmClosed(taxJurisdiction), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('jurisdiction'),
                        $author$project$Components$HiConfirm$detail($author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction) + 'and remove it from existing profiles. This will effect draft invoices using those tax profiles.')
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$gap4
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Sales Tax Jurisdictions')
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textMuted,
                            $author$project$Ui$Element$textSm
                        ]), $author$project$Components$Admin$Taxes$TaxJurisdictions$help)
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'New tax jurisdiction'
                    }, _List_fromArray([
                        $author$project$Ui$Button$default,
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxJurisdictions$New),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('New Tax Jurisdiction')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Components$Admin$Taxes$TaxJurisdictions$viewPanelBody(model))
            ]))
        ]);
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$New = {
        $: 2
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$help = _List_fromArray([
        $elm$html$Html$text('Tax profiles represent a collection of tax jurisdictions. In order to collect tax, you will assign '),
        $elm$html$Html$text('a profile to an invoice.  The profile determines the total sales tax rate that will be applied. '),
        $elm$html$Html$text('For more information, please refer to our '),
        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/account-configuration/creating-sales-tax-profiles-and-jurisdictions', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('help docs')
        ])),
        $elm$html$Html$text('.')
    ]);
    var $author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$Save = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$TaxJurisdictions = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdictionToggleSwitch = F2(function(taxJurisdictions, taxJurisdiction) {
        var id = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
        var taxJurisdictionEnabled = A2($elm$core$Set$member, id, taxJurisdictions);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(taxJurisdictionEnabled),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated, $author$project$Components$Admin$Taxes$TaxProfiles$TaxJurisdictions(id)))
            ])),
            $author$project$Utils$Html$noBreakSpace,
            $elm$html$Html$text($author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction)),
            $elm$html$Html$text(' - '),
            $elm$html$Html$text($elm$core$String$fromFloat($author$project$Api$Provider$TaxJurisdiction$All$rate(taxJurisdiction)) + '%')
        ]));
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$viewModal = F4(function(taxJurisdictions, id, form, taxProfile) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Tax Profile',
            Tk: _Utils_eq(taxProfile, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Admin$Taxes$TaxProfiles$CancelEdit,
            Vn: $author$project$Components$Admin$Taxes$TaxProfiles$Save(form)
        };
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Name')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$placeholder('San Francisco'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Taxes$TaxProfiles$FormUpdated, $author$project$Components$Admin$Taxes$TaxProfiles$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Jurisdictions')
            ]), function() {
                if (taxJurisdictions.$ === 3) {
                    var taxJurisdictions_ = taxJurisdictions.a;
                    return $elm$core$List$isEmpty(taxJurisdictions_) ? _List_fromArray([
                        $elm$html$Html$text('You have not created any tax jurisdictions. Please add the appropriate jurisdictions then select them here.')
                    ]) : A2($elm$core$List$map, $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdictionToggleSwitch(fields.$Q), taxJurisdictions_);
                } else return _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_fromArray([
                            $author$project$Ui$Spinner$small
                        ]))
                    ]))
                ]);
            }())
        ]));
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$Delete = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$Edit = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$TaxProfile$Shared$rate = function(_v0) {
        var record = _v0;
        return record.X5;
    };
    var $author$project$Api$Provider$TaxProfile$One$rate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$TaxProfile$Shared$rate(shared);
    };
    var $author$project$Api$Provider$TaxProfile$All$rate = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$TaxProfile$One$rate(one);
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdiction = function(taxJurisdiction) {
        return A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$small
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$TaxJurisdiction$Shared$name(taxJurisdiction)),
            $elm$html$Html$text(' - '),
            $elm$html$Html$text($elm$core$String$fromFloat($author$project$Api$Provider$TaxJurisdiction$Shared$rate(taxJurisdiction)) + '%')
        ]));
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxProfile = F2(function(deletingTaxProfiles, taxProfile) {
        var id = $author$project$Api$Provider$TaxProfile$All$id(taxProfile);
        var loading = A2($elm$core$Set$member, id, deletingTaxProfiles);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$TaxProfile$All$name(taxProfile))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromFloat($author$project$Api$Provider$TaxProfile$All$rate(taxProfile)) + '%')
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, A2($elm$core$List$map, $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxJurisdiction, $author$project$Api$Provider$TaxProfile$All$taxJurisdictions(taxProfile))),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit tax profile'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxProfiles$Edit(taxProfile)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit tax profile'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxProfiles$Delete(taxProfile)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Taxes$TaxProfiles$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.g2;
            if (_v1.$ === 3) {
                var taxProfiles_ = _v1.a;
                return _Utils_Tuple2(false, taxProfiles_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var taxProfiles = _v0.b;
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('None'),
                    A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$List$isEmpty, $author$project$Api$Data$toMaybe(model.$Q))) ? $elm$html$Html$text(', please add a tax jursidiction below first.') : $author$project$Utils$Html$empty
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Name')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Rate')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Jurisdictions')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ]), A2($elm$core$List$map, $author$project$Components$Admin$Taxes$TaxProfiles$viewTaxProfile(model.dY), taxProfiles), _List_Nil)
        ]);
    };
    var $author$project$Components$Admin$Taxes$TaxProfiles$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            function() {
                var _v1 = model.$R;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var id = _v2.a;
                    var form = _v2.b;
                    var taxProfile = _v2.c;
                    return A4($author$project$Components$Admin$Taxes$TaxProfiles$viewModal, model.$Q, id, form, taxProfile);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.ij;
                if (!_v3.$) {
                    var taxProfile = _v3.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Admin$Taxes$TaxProfiles$HiConfirmClosed(taxProfile), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('profile'),
                        $author$project$Components$HiConfirm$detail($author$project$Api$Provider$TaxProfile$All$name(taxProfile) + ' and make it unavailable as an option. This will not effect issued invoices.')
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap4
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Sales Tax Profiles')
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textMuted,
                            $author$project$Ui$Element$textSm
                        ]), $author$project$Components$Admin$Taxes$TaxProfiles$help)
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'New tax profile'
                    }, _List_fromArray([
                        $author$project$Ui$Button$default,
                        $author$project$Ui$Button$onClick($author$project$Components$Admin$Taxes$TaxProfiles$New),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('New Tax Profile')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Components$Admin$Taxes$TaxProfiles$viewPanelBody(model))
            ]))
        ]);
    };
    var $author$project$Pages$Admin$Taxes$view = function(model) {
        return {
            fb: _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Admin$Taxes$TaxProfilesMsg), $author$project$Components$Admin$Taxes$TaxProfiles$view(model.g2)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Admin$Taxes$TaxJurisdictionsMsg), $author$project$Components$Admin$Taxes$TaxJurisdictions$view(model.$Q))),
            $2: 'Admin | Sales Tax'
        };
    };
    var $author$project$Pages$Admin$Taxes$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Taxes$init,
        aeR: $author$project$Pages$Admin$Taxes$load,
        ag3: $author$project$Pages$Admin$Taxes$save,
        ahE: $author$project$Pages$Admin$Taxes$subscriptions,
        aaO: $author$project$Pages$Admin$Taxes$update,
        aid: $author$project$Pages$Admin$Taxes$view
    });
    var $author$project$Pages$Admin$Team$GotLocationGroups = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$GotRoles = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$ToogleOrganizationMfa$Practice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Team)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Pages$Admin$Team$GotTeamMembers = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$fetchTeamMembers = function(model) {
        return A3($author$project$Api$Provider$TeamMember$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Pages$Admin$Team$GotTeamMembers);
    };
    var $author$project$Api$Provider$Practice$One$hasOwner = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, A2($elm$core$Basics$composeR, function($) {
        return $.VM;
    }, $author$project$Utils$Maybe$toBool));
    var $author$project$Components$Admin$ToogleOrganizationMfa$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$ToogleOrganizationMfa$init = F2(function(session, organization) {
        return {
            E2: $author$project$Api$Platform$Session$One$user(session),
            VA: organization,
            Z$: session,
            ty: $author$project$Api$Data$NotAsked,
            o4: $author$project$Api$Data$NotAsked
        };
    });
    var $author$project$Api$Common$Role$All$Role = $elm$core$Basics$identity;
    var $author$project$Api$Common$Role$Shared$Role = $elm$core$Basics$identity;
    var $author$project$Api$Common$Role$Shared$Record = F2(function(name, permissionSets) {
        return {
            zr: name,
            WD: permissionSets
        };
    });
    var $author$project$Api$Common$Role$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'permission_sets', $elm$json$Json$Decode$list($author$project$Api$Common$PermissionSet$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Role$Shared$Record)));
    var $author$project$Api$Common$Role$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Role$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Role$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Role$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Role$rolesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'roles'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Role$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Role$rolesPath));
    });
    var $author$project$Pages$Admin$Team$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            tT: !$author$project$Api$Provider$Practice$One$hasOwner(practice),
            Ej: shared.Ej,
            E2: $author$project$Api$Platform$Session$One$user(session),
            lV: $elm$core$Maybe$Nothing,
            dZ: $elm$core$Set$empty,
            iq: $elm$core$Maybe$Nothing,
            aea: shared.aea,
            F3: $author$project$Shared$isHintAdmin(shared),
            Tl: $author$project$Api$Data$Loading,
            ef: $elm$core$Set$empty,
            afY: shared.adU.afY,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            agq: q,
            Cc: $author$project$Api$Data$Loading,
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'user_first_name', 0, $author$project$Api$Sort$initFromQuery(query)),
            A: $elm$core$Maybe$Nothing,
            eO: $author$project$Api$Data$Loading,
            ts: A2($author$project$Components$Admin$ToogleOrganizationMfa$init, session, $author$project$Components$Admin$ToogleOrganizationMfa$Practice(practice))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Admin$Team$fetchTeamMembers(model),
            A2($author$project$Api$Provider$Role$list, shared.Ej, $author$project$Pages$Admin$Team$GotRoles),
            A3($author$project$Api$Provider$LocationGroup$list, shared.Ej, $elm$core$Basics$identity, $author$project$Pages$Admin$Team$GotLocationGroups),
            A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Admin$Team$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Team$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Team$CancelTeamMemberEdit = {
        $: 4
    };
    var $author$project$Pages$Admin$Team$DeleteConfirmClosed = F2(function(a, b) {
        return {
            $: 15,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Team$DisableMfaConfirmClosed = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Team$subscriptions = function(_v0) {
        var teamMember = _v0.A;
        var deletingTeamMember = _v0.lV;
        var disablingMfaTeamMember = _v0.iq;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Admin$Team$CancelTeamMemberEdit)), teamMember)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Team$DeleteConfirmClosed), $author$project$Api$Provider$PracticeUser$All$id), deletingTeamMember)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Admin$Team$DisableMfaConfirmClosed), disablingMfaTeamMember))
        ]));
    };
    var $author$project$Pages$Admin$Team$GotInvitation = F3(function(a, b, c) {
        return {
            $: 22,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Pages$Admin$Team$InviteLinkMsg = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$MfaStatus = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$SearchInputMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$TeamMemberAdminCompleted = F2(function(a, b) {
        return {
            $: 25,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Team$TeamMemberDeleted = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Team$TeamMemberMfaDisabled = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$ToogleOrganizationMfa = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Api$Provider$TeamMember$teamMemberPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$TeamMember$teamMembersPath);
    };
    var $author$project$Api$Provider$TeamMember$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMemberPath(id_)));
    });
    var $author$project$Api$Provider$TeamMember$disableMfa = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'mfa'
        ]), $author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
    });
    var $author$project$Api$Provider$LocationGroup$Min$id = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$LocationGroup$Min$id(common);
    };
    var $author$project$Api$Provider$PracticeUser$All$locationGroups = function(_v0) {
        var record = _v0.b;
        return record.Tl;
    };
    var $author$project$Api$Provider$User$One$mfaStatus = function(_v0) {
        var record = _v0.b;
        return record.Ug;
    };
    var $author$project$Pages$Admin$Team$mfaStatus = function(teamMember) {
        var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$PracticeUser$All$user, teamMember);
        if (!_v0.$) {
            var user = _v0.a;
            return $author$project$Api$Provider$User$One$mfaStatus(user);
        } else return 'invite pending';
    };
    var $author$project$Api$Provider$PracticeUser$Shared$notificationsEnabled = function(_v0) {
        var record = _v0;
        return record.U8;
    };
    var $author$project$Api$Provider$PracticeUser$All$notificationsEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$notificationsEnabled(shared);
    };
    var $author$project$Api$Provider$PracticeUser$Shared$reportRestricted = function(_v0) {
        var record = _v0;
        return record.YB;
    };
    var $author$project$Api$Provider$PracticeUser$All$reportRestricted = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$reportRestricted(shared);
    };
    var $author$project$Api$Provider$PracticeUser$Shared$restrictedByGroups = function(_v0) {
        var record = _v0;
        return record.YW;
    };
    var $author$project$Api$Provider$PracticeUser$All$restrictedByGroups = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$restrictedByGroups(shared);
    };
    var $author$project$Api$Provider$PracticeUser$Shared$role = function(_v0) {
        var record = _v0;
        return record.ag_;
    };
    var $author$project$Api$Provider$PracticeUser$All$role = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$role(shared);
    };
    var $author$project$Pages$Admin$Team$formFieldsFromTeamMember = function(teamMember) {
        var locationGroups = $elm$core$Set$fromList(A2($elm$core$List$map, $author$project$Api$Provider$LocationGroup$Min$id, $author$project$Api$Provider$PracticeUser$All$locationGroups(teamMember)));
        return {
            abX: '',
            OH: $author$project$Api$Provider$PracticeUser$All$email(teamMember),
            aez: false,
            Tl: locationGroups,
            Ug: $author$project$Pages$Admin$Team$mfaStatus($elm$core$Maybe$Just(teamMember)),
            U8: $author$project$Api$Provider$PracticeUser$All$notificationsEnabled(teamMember),
            YB: $author$project$Api$Provider$PracticeUser$All$reportRestricted(teamMember),
            YW: $author$project$Api$Provider$PracticeUser$All$restrictedByGroups(teamMember),
            ag_: $author$project$Api$Provider$PracticeUser$All$role(teamMember)
        };
    };
    var $author$project$Pages$Admin$Team$formFieldsInit = function(origin) {
        return {
            abX: origin + '/join/',
            OH: '',
            aez: true,
            Tl: $elm$core$Set$empty,
            Ug: $author$project$Pages$Admin$Team$mfaStatus($elm$core$Maybe$Nothing),
            U8: true,
            YB: false,
            YW: false,
            ag_: ''
        };
    };
    var $author$project$Pages$Admin$Team$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    OH: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    YW: fields.YW && string !== 'admin',
                    ag_: string
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    U8: bool
                });
            case 3:
                var bool = field.a;
                return _Utils_update(fields, {
                    YW: bool
                });
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    Ug: string
                });
            case 6:
                var id = field.a;
                var bool = field.b;
                var locationGroups = bool ? A2($elm$core$Set$insert, id, fields.Tl) : A2($elm$core$Set$remove, id, fields.Tl);
                return _Utils_update(fields, {
                    Tl: locationGroups
                });
            case 7:
                var bool = field.a;
                return _Utils_update(fields, {
                    aez: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    YB: bool
                });
        }
    });
    var $author$project$Pages$Admin$Team$EmailValidation = 0;
    var $author$project$Pages$Admin$Team$RoleValidation = 1;
    var $author$project$Pages$Admin$Team$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: false
        }, A2($elm$core$Basics$composeR, function($) {
            return $.OH;
        }, $elm$core$Maybe$Just), _Utils_Tuple2(0, 'Please enter a valid email.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.ag_;
        }, _Utils_Tuple2(1, 'Please pick a role.'))
    ]));
    var $author$project$Api$Provider$PracticeUser$One$PracticeUser = 0;
    var $author$project$Api$Provider$PracticeUser$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$TeamMember$invite = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeUser$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invite'
        ]), $author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
    });
    var $author$project$Api$Provider$TeamMember$makeSuperAdmin = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeUser$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_super_admin'
        ]), $author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
    });
    var $author$project$Pages$Admin$Team$TeamMemberCreated = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Provider$TeamMember$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('team_member', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('base_url', $elm$json$Json$Encode$string(fields.abX)),
                _Utils_Tuple2('email', $elm$json$Json$Encode$string(fields.OH)),
                _Utils_Tuple2('role', $elm$json$Json$Encode$string(fields.ag_)),
                _Utils_Tuple2('notifications_enabled', $elm$json$Json$Encode$bool(fields.U8)),
                _Utils_Tuple2('restricted_by_groups', $elm$json$Json$Encode$bool(fields.YW)),
                _Utils_Tuple2('location_groups', A2($elm$json$Json$Encode$set, $author$project$Utils$Encode$association, fields.Tl)),
                _Utils_Tuple2('report_restricted', $elm$json$Json$Encode$bool(fields.YB))
            ]))),
            _Utils_Tuple2('invite', $elm$json$Json$Encode$bool(fields.aez))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeUser$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
    });
    var $author$project$Pages$Admin$Team$createTeamMember = F3(function(apiClient, _v0, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$TeamMember$create, apiClient, {
            abX: fields.abX,
            OH: fields.OH,
            aez: fields.aez,
            Tl: fields.Tl,
            U8: fields.U8,
            YB: fields.YB,
            YW: fields.YW,
            ag_: fields.ag_
        }, $author$project$Pages$Admin$Team$TeamMemberCreated);
    });
    var $author$project$Pages$Admin$Team$TeamMemberUpdated = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$TeamMember$encodeLicense = function(license) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('license_number', $elm$json$Json$Encode$string(A2($elm$core$Maybe$withDefault, '', license.Gx))),
            _Utils_Tuple2('state', $elm$json$Json$Encode$string(A2($elm$core$Maybe$withDefault, '', license.s4))),
            _Utils_Tuple2('expiration', $elm$json$Json$Encode$string(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$Date$toIsoString, license.adC.a))))
        ]));
    };
    var $author$project$Components$TeamForm$providerStatusToString = function(status) {
        switch(status){
            case 0:
                return 'full_time';
            case 1:
                return 'part_time';
            default:
                return 'no_provider';
        }
    };
    var $author$project$Api$Provider$TeamMember$update = F4(function(apiClient, id_, fields, toMsg) {
        var providerStatusValue = A2($elm$core$Maybe$map, $author$project$Components$TeamForm$providerStatusToString, fields.XK);
        var encodeMaskedDate = function(stringDate) {
            return A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, $elm$core$Result$toMaybe(A2($elm$core$Result$map, $author$project$Utils$Date$encode, $author$project$Utils$Date$fromUsString(A2($agustinrhcp$elm_mask$Mask$mask, $agustinrhcp$elm_mask$Mask$fromString('##/##/####'), stringDate)))));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('team_member', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                A3($author$project$Utils$Encode$optional, 'role', $elm$json$Json$Encode$string, fields.ag_),
                A3($author$project$Utils$Encode$optional, 'notifications_enabled', $elm$json$Json$Encode$bool, fields.U8),
                A3($author$project$Utils$Encode$optional, 'restricted_by_groups', $elm$json$Json$Encode$bool, fields.YW),
                A3($author$project$Utils$Encode$optional, 'location_groups', $elm$json$Json$Encode$set($author$project$Utils$Encode$association), fields.Tl),
                A3($author$project$Utils$Encode$optional, 'report_restricted', $elm$json$Json$Encode$bool, fields.YB),
                A3($author$project$Utils$Encode$optional, 'phone_number', $elm$json$Json$Encode$string, fields.WF),
                A3($author$project$Utils$Encode$optional, 'npi', $elm$json$Json$Encode$string, fields.U9),
                A3($author$project$Utils$Encode$optional, 'prescriber_type', $elm$json$Json$Encode$string, fields.Xm),
                A3($author$project$Utils$Encode$optional, 'dob', encodeMaskedDate, fields.M7),
                A3($author$project$Utils$Encode$optional, 'education_degree', $elm$json$Json$Encode$string, fields.NG),
                A3($author$project$Utils$Encode$optional, 'dea_licenses', $elm$json$Json$Encode$list($author$project$Api$Provider$TeamMember$encodeLicense), $elm$core$List$isEmpty(fields.xa) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.xa)),
                A3($author$project$Utils$Encode$optional, 'provider_status', $elm$json$Json$Encode$string, providerStatusValue),
                A3($author$project$Utils$Encode$optional, 'state_licenses', $elm$json$Json$Encode$list($author$project$Api$Provider$TeamMember$encodeLicense), $elm$core$List$isEmpty(fields.CI) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.CI))
            ]))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$PracticeUser$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMemberPath(id_))));
    });
    var $author$project$Pages$Admin$Team$updateTeamMember = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$TeamMember$update, apiClient, id, {
            M7: $elm$core$Maybe$Nothing,
            xa: _List_Nil,
            NG: $elm$core$Maybe$Nothing,
            Tl: $elm$core$Maybe$Just(fields.Tl),
            U8: $elm$core$Maybe$Just(fields.U8),
            U9: $elm$core$Maybe$Nothing,
            WF: $elm$core$Maybe$Nothing,
            Xm: $elm$core$Maybe$Nothing,
            XK: $elm$core$Maybe$Nothing,
            YB: $elm$core$Maybe$Just(fields.YB),
            YW: $elm$core$Maybe$Just(fields.YW),
            ag_: $elm$core$Maybe$Just(fields.ag_),
            CI: _List_Nil
        }, $author$project$Pages$Admin$Team$TeamMemberUpdated);
    });
    var $author$project$Pages$Admin$Team$saveTeamMember = F4(function(apiClient, adminOnly, maybeId, formFields) {
        if (!maybeId.$) {
            var id = maybeId.a;
            return A3($author$project$Pages$Admin$Team$updateTeamMember, apiClient, id, formFields);
        } else return A3($author$project$Pages$Admin$Team$createTeamMember, apiClient, adminOnly, formFields);
    });
    var $author$project$Components$Admin$ToogleOrganizationMfa$GotPartner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$ToogleOrganizationMfa$GotPractice = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$ToogleOrganizationMfa$None = {
        $: 0
    };
    var $author$project$Components$Admin$ToogleOrganizationMfa$Partner = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$ToogleOrganizationMfa$PartnerUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$OutMsg$PartnerUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$ToogleOrganizationMfa$PracticeUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$One$Partner = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$Partner$Shared$Partner = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Partner$Shared$Record = function(id) {
        return function(name) {
            return function(organizationId) {
                return function(requiresMfa) {
                    return function(slug) {
                        return function(marketingUrl) {
                            return function(signupUrl) {
                                return function(supportUrl) {
                                    return function(redirectUrl) {
                                        return function(productDescription) {
                                            return function(integrationDescription) {
                                                return function(authType) {
                                                    return function(logoUrl) {
                                                        return function(marketplaceIconUrl) {
                                                            return function(email) {
                                                                return function(technicalEmail) {
                                                                    return function(usesIntegrationRecords) {
                                                                        return function(active) {
                                                                            return function(archived) {
                                                                                return function(webhooksDisabled) {
                                                                                    return function(webhooksPaused) {
                                                                                        return function(maxRequestsPperMinute) {
                                                                                            return function(practicesReadOnly) {
                                                                                                return function(listenedEvents) {
                                                                                                    return function(unmuteSelfWebhooks) {
                                                                                                        return function(postActivationRedirectUrl) {
                                                                                                            return function(sandboxEnabled) {
                                                                                                                return function(productType) {
                                                                                                                    return function(websiteUrl) {
                                                                                                                        return {
                                                                                                                            Ir: active,
                                                                                                                            JC: archived,
                                                                                                                            JO: authType,
                                                                                                                            OH: email,
                                                                                                                            aef: id,
                                                                                                                            Ro: integrationDescription,
                                                                                                                            Ti: listenedEvents,
                                                                                                                            Tu: logoUrl,
                                                                                                                            TH: marketingUrl,
                                                                                                                            TI: marketplaceIconUrl,
                                                                                                                            TO: maxRequestsPperMinute,
                                                                                                                            zr: name,
                                                                                                                            afV: organizationId,
                                                                                                                            WY: postActivationRedirectUrl,
                                                                                                                            W9: practicesReadOnly,
                                                                                                                            Xz: productDescription,
                                                                                                                            G7: productType,
                                                                                                                            Yo: redirectUrl,
                                                                                                                            YL: requiresMfa,
                                                                                                                            Zo: sandboxEnabled,
                                                                                                                            _u: signupUrl,
                                                                                                                            _A: slug,
                                                                                                                            $y: supportUrl,
                                                                                                                            $U: technicalEmail,
                                                                                                                            aaI: unmuteSelfWebhooks,
                                                                                                                            aa2: usesIntegrationRecords,
                                                                                                                            abk: webhooksDisabled,
                                                                                                                            abl: webhooksPaused,
                                                                                                                            abn: websiteUrl
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Partner$Partner$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'website_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_type', $author$project$Api$Common$Marketplace$Product$ProductType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sandbox_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_activation_redirect_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'unmute_self_webhooks', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'listened_events', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practices_read_only', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_requests_per_minute', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'webhooks_paused', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'webhooks_disabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'archived', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_integration_records', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'technical_email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'marketplace_icon_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'logo_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auth_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redirect_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'support_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signup_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'marketing_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'slug', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_mfa', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$Shared$Record))))))))))))))))))))))))))))));
    var $author$project$Api$Partner$Partner$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Partner$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Partner$One$Record = function(webhooksSignatureApiKey) {
        return function(sandboxOf) {
            return function(hasSandboxPartners) {
                return function(hasSandboxPractices) {
                    return function(product) {
                        return function(productOverview) {
                            return function(productHighlights) {
                                return function(productQuotes) {
                                    return function(productLinks) {
                                        return function(productDataFlows) {
                                            return function(managedBy) {
                                                return function(productCategories) {
                                                    return function(customPartnerAgreementFileName) {
                                                        return function(addendumAgreementFileName) {
                                                            return function(customApiAccessAgreementFileName) {
                                                                return function(customBaaAgreementFileName) {
                                                                    return function(partnerDocumentAgreement) {
                                                                        return function(addendumDocumentAgreement) {
                                                                            return function(apiAccessDocumentAgreement) {
                                                                                return function(address) {
                                                                                    return function(baaType) {
                                                                                        return function(baaDocumentAgreement) {
                                                                                            return {
                                                                                                IB: addendumAgreementFileName,
                                                                                                IC: addendumDocumentAgreement,
                                                                                                II: address,
                                                                                                Jw: apiAccessDocumentAgreement,
                                                                                                J1: baaDocumentAgreement,
                                                                                                J2: baaType,
                                                                                                MR: customApiAccessAgreementFileName,
                                                                                                MS: customBaaAgreementFileName,
                                                                                                MY: customPartnerAgreementFileName,
                                                                                                Qy: hasSandboxPartners,
                                                                                                Qz: hasSandboxPractices,
                                                                                                Tz: managedBy,
                                                                                                VZ: partnerDocumentAgreement,
                                                                                                Xw: product,
                                                                                                Xx: productCategories,
                                                                                                Xy: productDataFlows,
                                                                                                XA: productHighlights,
                                                                                                XB: productLinks,
                                                                                                XC: productOverview,
                                                                                                XD: productQuotes,
                                                                                                Zp: sandboxOf,
                                                                                                abm: webhooksSignatureApiKey
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Partner$ApiKey$Shared$ApiKey = $elm$core$Basics$identity;
    var $author$project$Api$Partner$ApiKey$Shared$Record = F6(function(id, token, createdAt, lastUsedAt, deactivatedAt, label) {
        return {
            Mx: createdAt,
            Ni: deactivatedAt,
            aef: id,
            aeI: label,
            S$: lastUsedAt,
            aaf: token
        };
    });
    var $author$project$Api$Partner$ApiKey$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deactivated_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_used_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'token', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$Shared$Record)))))));
    var $author$project$Api$Partner$ApiKey$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$ApiKey$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$BaaType$Contractor = 0;
    var $author$project$Api$Partner$BaaType$Independent = 1;
    var $author$project$Api$Partner$BaaType$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'contractor':
                return $elm$json$Json$Decode$succeed(0);
            case 'independent':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unsupported BAA type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Partner$DocumentAgreement$Shared$DocumentAgreement = $elm$core$Basics$identity;
    var $author$project$Api$Partner$DocumentAgreement$Shared$Record = F2(function(signedAt, user) {
        return {
            _n: signedAt,
            aaX: user
        };
    });
    var $author$project$Api$Partner$User$Shared$User = $elm$core$Basics$identity;
    var $author$project$Api$Partner$User$Shared$Record = F2(function(name, isAdmin) {
        return {
            RO: isAdmin,
            zr: name
        };
    });
    var $author$project$Api$Partner$User$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_admin', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$User$Shared$Record)));
    var $author$project$Api$Partner$User$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$User$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$DocumentAgreement$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signed_by', $author$project$Api$Partner$User$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signed_at', $elm_community$json_extra$Json$Decode$Extra$datetime, $elm$json$Json$Decode$succeed($author$project$Api$Partner$DocumentAgreement$Shared$Record)));
    var $author$project$Api$Partner$DocumentAgreement$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$DocumentAgreement$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProduct$Shared$PartnerProduct = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProduct$Shared$Record = function(id) {
        return function(slug) {
            return function(distributionType) {
                return function(status) {
                    return function(featured) {
                        return function(name) {
                            return function(summary) {
                                return function(builtByName) {
                                    return function(builtByUrl) {
                                        return function(type_) {
                                            return function(backlinkUrl) {
                                                return {
                                                    J5: backlinkUrl,
                                                    Ku: builtByName,
                                                    Kv: builtByUrl,
                                                    N9: distributionType,
                                                    Pw: featured,
                                                    aef: id,
                                                    zr: name,
                                                    _A: slug,
                                                    ahy: status,
                                                    $x: summary,
                                                    ah5: type_
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'backlink_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Common$Marketplace$Product$ProductType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'built_by_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'built_by_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'summary', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'featured', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$Api$Common$Marketplace$Product$Status$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'distribution_type', $author$project$Api$Common$Marketplace$Product$DistributionType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'slug', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$Shared$Record)))))))))))));
    var $author$project$Api$Partner$PartnerProductCategory$Shared$PartnerProductCategory = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProductCategory$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Partner$PartnerProductCategory$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductCategory$Shared$Record)));
    var $author$project$Api$Partner$PartnerProductCategory$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProductCategory$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProductCategory$One$decoder = $author$project$Api$Partner$PartnerProductCategory$Shared$decoder;
    var $author$project$Api$Partner$PartnerProductDataFlow$Shared$PartnerProductDataFlow = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProductDataFlow$Shared$Record = F4(function(id, hintName, partnerName, syncDirection) {
        return {
            QQ: hintName,
            aef: id,
            V$: partnerName,
            $F: syncDirection
        };
    });
    var $author$project$Api$Common$Marketplace$Product$SyncDirection$Bidirectional = 2;
    var $author$project$Api$Common$Marketplace$Product$SyncDirection$FromHint = 0;
    var $author$project$Api$Common$Marketplace$Product$SyncDirection$ToHint = 1;
    var $author$project$Api$Common$Marketplace$Product$SyncDirection$fromString = function(string) {
        switch(string){
            case 'from_hint':
                return $elm$core$Maybe$Just(0);
            case 'to_hint':
                return $elm$core$Maybe$Just(1);
            case 'bidirectional':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$Marketplace$Product$SyncDirection$decoder = A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$Api$Common$Marketplace$Product$SyncDirection$fromString, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$json$Json$Decode$succeed), $elm$core$Maybe$withDefault($elm$json$Json$Decode$fail('Unsupported sync direction')))), $elm$json$Json$Decode$string);
    var $author$project$Api$Partner$PartnerProductDataFlow$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sync_direction', $author$project$Api$Common$Marketplace$Product$SyncDirection$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hint_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductDataFlow$Shared$Record)))));
    var $author$project$Api$Partner$PartnerProductDataFlow$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProductDataFlow$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProductHighlight$Shared$PartnerProductHighlight = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProductHighlight$Shared$Record = F4(function(id, title, description, imageUrl) {
        return {
            NQ: description,
            aef: id,
            Q4: imageUrl,
            $2: title
        };
    });
    var $author$project$Api$Partner$PartnerProductHighlight$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'image_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductHighlight$Shared$Record)))));
    var $author$project$Api$Partner$PartnerProductHighlight$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProductHighlight$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProductLink$Shared$PartnerProductLink = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProductLink$Shared$Record = F7(function(id, title, linkType, value, utmCampaign, utmContent, composedUrl) {
        return {
            LX: composedUrl,
            aef: id,
            Tf: linkType,
            $2: title,
            aa5: utmCampaign,
            aa6: utmContent,
            aa9: value
        };
    });
    var $author$project$Api$Common$Marketplace$Product$LinkType$Email = 1;
    var $author$project$Api$Common$Marketplace$Product$LinkType$Phone = 2;
    var $author$project$Api$Common$Marketplace$Product$LinkType$Url = 0;
    var $author$project$Api$Common$Marketplace$Product$LinkType$fromString = function(string) {
        switch(string){
            case 'url':
                return $elm$core$Maybe$Just(0);
            case 'email':
                return $elm$core$Maybe$Just(1);
            case 'phone':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$Marketplace$Product$LinkType$decoder = A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$Api$Common$Marketplace$Product$LinkType$fromString, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$json$Json$Decode$succeed), $elm$core$Maybe$withDefault($elm$json$Json$Decode$fail('Unsupported link type')))), $elm$json$Json$Decode$string);
    var $author$project$Api$Partner$PartnerProductLink$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'composed_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'utm_content', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'utm_campaign', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'value', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'link_type', $author$project$Api$Common$Marketplace$Product$LinkType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductLink$Shared$Record))))))));
    var $author$project$Api$Partner$PartnerProductLink$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProductLink$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProductOverview$Shared$ProductOverview = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProductOverview$Shared$Record = F2(function(description, images) {
        return {
            NQ: description,
            Q5: images
        };
    });
    var $author$project$Api$Partner$ProductImage$Shared$ProductImage = $elm$core$Basics$identity;
    var $author$project$Api$Partner$ProductImage$Shared$Record = F3(function(id, alt, url) {
        return {
            Jg: alt,
            aef: id,
            aaT: url
        };
    });
    var $author$project$Api$Partner$ProductImage$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'alt', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$ProductImage$Shared$Record)))), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProductOverview$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'images', $elm$json$Json$Decode$list($author$project$Api$Partner$ProductImage$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductOverview$Shared$Record)));
    var $author$project$Api$Partner$PartnerProductOverview$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProductOverview$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProductQuote$Shared$PartnerProductQuote = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProductQuote$Shared$Record = F5(function(id, text, author, authorTitle, authorImageUrl) {
        return {
            JP: author,
            JQ: authorImageUrl,
            JR: authorTitle,
            aef: id,
            $Y: text
        };
    });
    var $author$project$Api$Partner$PartnerProductQuote$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'author_image_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'author_title', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'author', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'text', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductQuote$Shared$Record))))));
    var $author$project$Api$Partner$PartnerProductQuote$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProductQuote$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Partner$One$ManagedByManagementGroup = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$One$ManagedByPractice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$ManagementGroup$Min$ManagementGroup = $elm$core$Basics$identity;
    var $author$project$Api$Partner$ManagementGroup$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Partner$ManagementGroup$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$ManagementGroup$Min$Record)));
    var $author$project$Api$Partner$ManagementGroup$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$ManagementGroup$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Practice$Min$Practice = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Practice$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Partner$Practice$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Min$Record)));
    var $author$project$Api$Partner$Practice$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Practice$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Partner$One$managedByDecoder = A2($elm$json$Json$Decode$andThen, function(managedByType) {
        if (managedByType.$ === 1) return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
        else switch(managedByType.a){
            case 'Practice':
                return A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'managed_by', $author$project$Api$Partner$Practice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$ManagedByPractice)));
            case 'ManagementGroup':
                return A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'managed_by', $author$project$Api$Partner$ManagementGroup$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$ManagedByManagementGroup)));
            default:
                var somethingElse = managedByType.a;
                return $elm$json$Json$Decode$fail('Unsupported managed by type ' + somethingElse);
        }
    }, A2($elm$json$Json$Decode$at, _List_fromArray([
        'managed_by_type'
    ]), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
    var $author$project$Api$Partner$Partner$One$SandboxOfPartner = 1;
    var $author$project$Api$Partner$Partner$One$SandboxOfPractice = 0;
    var $author$project$Api$Partner$Partner$One$sandboxOfDecoder = A2($elm$json$Json$Decode$andThen, function(sandboxOfType) {
        if (sandboxOfType.$ === 1) return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
        else switch(sandboxOfType.a){
            case 'Practice':
                return $elm$json$Json$Decode$succeed($elm$core$Maybe$Just(0));
            case 'Partner':
                return $elm$json$Json$Decode$succeed($elm$core$Maybe$Just(1));
            default:
                var somethingElse = sandboxOfType.a;
                return $elm$json$Json$Decode$fail('Unsupported sandbox of type ' + somethingElse);
        }
    }, A2($elm$json$Json$Decode$at, _List_fromArray([
        'sandbox_of_type'
    ]), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
    var $author$project$Api$Partner$Partner$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'baa_document_agreement', $elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'baa_type', $elm$json$Json$Decode$nullable($author$project$Api$Partner$BaaType$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'api_access_document_agreement', $elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'addendum_document_agreement', $elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_document_agreement', $elm$json$Json$Decode$nullable($author$project$Api$Partner$DocumentAgreement$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'custom_baa_agreement_file_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'custom_api_access_agreement_file_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'addendum_agreement_file_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'custom_partner_agreement_file_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_categories', $elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductCategory$One$decoder), A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Partner$One$managedByDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_data_flows', $elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductDataFlow$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_links', $elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductLink$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_quotes', $elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductQuote$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_highlights', $elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductHighlight$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_overview', $elm$json$Json$Decode$nullable($author$project$Api$Partner$PartnerProductOverview$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product', $elm$json$Json$Decode$nullable($author$project$Api$Partner$PartnerProduct$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_sandbox_practices', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_sandbox_partners', $elm$json$Json$Decode$bool, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Partner$One$sandboxOfDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'webhooks_signature_api_key', $elm$json$Json$Decode$nullable($author$project$Api$Partner$ApiKey$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$Record)))))))))))))))))))))));
    var $author$project$Api$Partner$Partner$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Partner$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Partner$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Partner$One$Partner)));
    var $author$project$Api$Data$partnerPath = $author$project$Api$Data$newPath(_List_fromArray([
        'partner'
    ]));
    var $author$project$Api$Partner$Partner$partnerPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Partner$updateMfaRequirement = F3(function(apiClient, requiresMfa_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('requires_mfa', $elm$json$Json$Encode$bool(requiresMfa_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$Partner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
    });
    var $author$project$Api$Provider$Practice$updateMfaRequirement = F3(function(apiClient, requiresMfa_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('requires_mfa', $elm$json$Json$Encode$bool(requiresMfa_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Components$Admin$ToogleOrganizationMfa$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var bool = msg.a;
                var _v2 = model.VA;
                if (!_v2.$) return {
                    EQ: A3($author$project$Api$Provider$Practice$updateMfaRequirement, apiClient, bool, $author$project$Components$Admin$ToogleOrganizationMfa$GotPractice),
                    adu: $author$project$Components$Admin$ToogleOrganizationMfa$None,
                    zi: _Utils_update(model, {
                        o4: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
                else return {
                    EQ: A3($author$project$Api$Partner$Partner$updateMfaRequirement, apiClient, bool, $author$project$Components$Admin$ToogleOrganizationMfa$GotPartner),
                    adu: $author$project$Components$Admin$ToogleOrganizationMfa$None,
                    zi: _Utils_update(model, {
                        ty: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$ToogleOrganizationMfa$PracticeUpdated(practice),
                        zi: _Utils_update(model, {
                            VA: $author$project$Components$Admin$ToogleOrganizationMfa$Practice(practice),
                            o4: response
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Your practice has been updated'),
                            $author$project$OutMsg$PracticeUpdated(response)
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$ToogleOrganizationMfa$None,
                    zi: _Utils_update(model, {
                        o4: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var partner = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Admin$ToogleOrganizationMfa$PartnerUpdated(partner),
                        zi: _Utils_update(model, {
                            VA: $author$project$Components$Admin$ToogleOrganizationMfa$Partner(partner),
                            ty: response
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Your partner has been updated'),
                            $author$project$OutMsg$PartnerUpdated(response)
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Admin$ToogleOrganizationMfa$None,
                    zi: _Utils_update(model, {
                        ty: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$InviteLink$update = function(msg) {
        var inviteUrl = msg;
        return _Utils_Tuple2($author$project$Ports$Clipboard$copy(inviteUrl), _List_fromArray([
            A2($author$project$OutMsg$ShowToast, 3, 'Copied invite link to clipboard')
        ]));
    };
    var $author$project$Pages$Admin$Team$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Cc: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tl: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    A: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Admin$Team$formFieldsInit(model.afY)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var field = msg.a;
                var _v1 = model.A;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var teamMember = _v2.a;
                    var form = _v2.b;
                    var request = _v2.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Team$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var form = msg.a;
                var teamMember = msg.b;
                var id = msg.c;
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Admin$Team$formFieldsValidator, form);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
                    }), A4($author$project$Pages$Admin$Team$saveTeamMember, model.Ej, model.tT, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var teamMember = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    A: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(teamMember), $author$project$Utils$Form$init($author$project$Pages$Admin$Team$formFieldsFromTeamMember(teamMember)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    A: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        eO: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    eO: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var subMsg = msg.a;
                var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v6.a;
                var searchInputCmd = _v6.b;
                var searchInputEvent = _v6.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v7 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q,
                            eO: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Admin$Team$fetchTeamMembers(qModel),
                            A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                        ])));
                    }
                }();
                var newModel = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 7:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    eO: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$Team$fetchTeamMembers(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 8:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs),
                    eO: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Admin$Team$fetchTeamMembers(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Admin$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 11:
                var response = msg.a;
                var _v9 = model.A;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var teamMember = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Admin$Team$fetchTeamMembers(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var response = msg.a;
                var _v12 = model.A;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var id = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Admin$Team$fetchTeamMembers(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dZ: A2($elm$core$Set$remove, id, model.dZ),
                            eO: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Admin$Team$fetchTeamMembers(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dZ: A2($elm$core$Set$remove, id, model.dZ)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 14:
                var teamMember = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    lV: $elm$core$Maybe$Just(teamMember)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    lV: $elm$core$Maybe$Nothing,
                    dZ: A2($elm$core$Set$insert, id, model.dZ)
                }), A3($author$project$Api$Provider$TeamMember$delete, model.Ej, id, $author$project$Pages$Admin$Team$TeamMemberDeleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    lV: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    iq: $elm$core$Maybe$Just(id)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var id = msg.a;
                var confirmed = msg.b;
                var _v16 = model.A;
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var teamMember = _v17.a;
                    var form = _v17.b;
                    return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                        iq: $elm$core$Maybe$Nothing,
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, form, $author$project$Api$Data$Loading))
                    }), A3($author$project$Api$Provider$TeamMember$disableMfa, model.Ej, id, $author$project$Pages$Admin$Team$TeamMemberMfaDisabled), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        iq: $elm$core$Maybe$Nothing
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var response = msg.a;
                var _v18 = model.A;
                if (!_v18.$) {
                    var _v19 = _v18.a;
                    var teamMember = _v19.a;
                    var form = _v19.b;
                    switch(response.$){
                        case 3:
                            var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Admin$Team$formFieldsUpdate, $author$project$Pages$Admin$Team$MfaStatus('inactive'), form);
                            return _Utils_Tuple3(_Utils_update(model, {
                                A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked)),
                                eO: $author$project$Api$Data$Loading
                            }), $author$project$Pages$Admin$Team$fetchTeamMembers(model), _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Team member mfa successfully disabled')
                            ]));
                        case 2:
                            return _Utils_Tuple3(_Utils_update(model, {
                                A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, form, $author$project$Api$Data$NotAsked))
                            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                        default:
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var teamMember = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$TeamMember$invite, model.Ej, $author$project$Api$Provider$PracticeUser$All$id(teamMember), A2($author$project$Pages$Admin$Team$GotInvitation, $author$project$Api$Provider$PracticeUser$All$email(teamMember), false)), _List_Nil);
            case 20:
                var teamMember = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$TeamMember$invite, model.Ej, $author$project$Api$Provider$PracticeUser$All$id(teamMember), A2($author$project$Pages$Admin$Team$GotInvitation, $author$project$Api$Provider$PracticeUser$All$email(teamMember), true)), _List_Nil);
            case 22:
                var email = msg.a;
                var isReinvite = msg.b;
                var response = msg.c;
                if (response.$ === 3) {
                    var prefix = isReinvite ? 'A new' : 'An';
                    return _Utils_Tuple3(_Utils_update(model, {
                        eO: $author$project$Api$Data$Loading
                    }), $author$project$Pages$Admin$Team$fetchTeamMembers(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, prefix + (' invitation is being sent to ' + email))
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 21:
                var subMsg = msg.a;
                var _v22 = $author$project$Components$InviteLink$update(subMsg);
                var inviteLinkCmd = _v22.a;
                var inviteLinkOutMsg = _v22.b;
                return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$InviteLinkMsg, inviteLinkCmd), inviteLinkOutMsg);
            case 23:
                var subMsg = msg.a;
                var toogleOrganizationMfaResult = A3($author$project$Components$Admin$ToogleOrganizationMfa$update, model.Ej, subMsg, model.ts);
                var newModel = function() {
                    var _v23 = toogleOrganizationMfaResult.adu;
                    switch(_v23.$){
                        case 0:
                            return model;
                        case 1:
                            var practice = _v23.a;
                            return _Utils_update(model, {
                                W1: practice
                            });
                        default:
                            return model;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(newModel, {
                    ts: toogleOrganizationMfaResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$ToogleOrganizationMfa, toogleOrganizationMfaResult.EQ), toogleOrganizationMfaResult.at);
            case 24:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ef: A2($elm$core$Set$insert, id, model.ef)
                }), A3($author$project$Api$Provider$TeamMember$makeSuperAdmin, model.Ej, id, $author$project$Pages$Admin$Team$TeamMemberAdminCompleted(id)), _List_Nil);
            default:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            ef: A2($elm$core$Set$remove, id, model.ef)
                        }), $author$project$Pages$Admin$Team$fetchTeamMembers(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Team member is now an admin')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            ef: A2($elm$core$Set$remove, id, model.ef)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Admin$Team$NewTeamMember = {
        $: 2
    };
    var $author$project$Pages$Admin$Team$PaginationMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$buildIdentityProviderUrl = F2(function(hintEnv, organizationId) {
        var envPath = function() {
            _v0$2: while(true){
                if (!hintEnv.$) switch(hintEnv.a){
                    case 0:
                        var _v1 = hintEnv.a;
                        return 'production';
                    case 1:
                        var _v2 = hintEnv.a;
                        return 'staging';
                    default:
                        break _v0$2;
                }
                else break _v0$2;
            }
            return 'development';
        }();
        return 'https://portal.frontegg.com/' + (envPath + ('/backoffice/accounts/' + organizationId));
    });
    var $author$project$Api$Provider$Practice$One$organizationId = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.afV;
    });
    var $author$project$Components$HiConfirm$TitleizeNoun = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$titleizeNoun = $author$project$Components$HiConfirm$TitleizeNoun;
    var $author$project$Pages$Admin$Team$SortTable = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'),
        A3($author$project$Api$Column$init, 'email', false, 'Email'),
        A3($author$project$Api$Column$init, 'role', true, 'Role'),
        A3($author$project$Api$Column$init, 'notifications', false, 'Notifications'),
        A3($author$project$Api$Column$init, 'mfa', false, 'MFA')
    ]);
    var $author$project$Components$Admin$ToogleOrganizationMfa$ToogleMfa = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Platform$User$Shared$isMfaActive = function(_v0) {
        var record = _v0;
        return record.Sb;
    };
    var $author$project$Api$Partner$Partner$Shared$requiresMfa = function(_v0) {
        var record = _v0;
        return record.YL;
    };
    var $author$project$Api$Partner$Partner$One$requiresMfa = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$requiresMfa(shared);
    };
    var $author$project$Api$Provider$Practice$One$requiresMfa = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.YL;
    });
    var $author$project$Components$Admin$ToogleOrganizationMfa$view = function(_v0) {
        var model = _v0;
        var requiresMfa = function() {
            var _v1 = model.VA;
            if (!_v1.$) {
                var practice = _v1.a;
                return $author$project$Api$Provider$Practice$One$requiresMfa(practice);
            } else {
                var partner = _v1.a;
                return $author$project$Api$Partner$Partner$One$requiresMfa(partner);
            }
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Require Multi-factor authentication (MFA)'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(requiresMfa),
                $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Admin$ToogleOrganizationMfa$ToogleMfa),
                $author$project$Ui$ToggleSwitch$disabled(!$author$project$Api$Platform$User$Shared$isMfaActive(model.E2) || _Utils_eq(model.o4, $author$project$Api$Data$Loading))
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Add an extra layer of security to your account by requiring users to enter a one-time '),
                $elm$html$Html$text('authentication code in addition to their password. Enabling this will require all the '),
                $elm$html$Html$text('users to enable MFA in order to access this application.')
            ])),
            !$author$project$Api$Platform$User$Shared$isMfaActive(model.E2) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('You need to enable MFA before making it required. Enable it '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Mfa, _List_fromArray([
                    $author$project$Ui$Link$routeParams(_List_fromArray([
                        A2($elm$url$Url$Builder$string, 'requiresMfaPrerequisite', 'true')
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                $elm$html$Html$text('.')
            ])) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Pages$Admin$Team$EditTeamMember = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$InviteTeamMember = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$MakeSuperAdmin = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$OpenDeleteConfirm = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$InviteLink$PracticeUser = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$ReInviteTeamMember = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeUser$All$isHinter = function(_v0) {
        var shared = _v0.a;
        return A2($elm$core$String$contains, '@hint.com', $author$project$Api$Provider$PracticeUser$Shared$email(shared));
    };
    var $author$project$Api$Provider$User$Shared$isAdmin = function(_v0) {
        var record = _v0;
        return record.RO;
    };
    var $author$project$Api$Provider$User$One$isAdmin = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$User$Shared$isAdmin(shared);
    };
    var $author$project$Api$Provider$PracticeUser$All$isSuperAdmin = function(practiceUser) {
        var _v0 = $author$project$Api$Provider$PracticeUser$All$user(practiceUser);
        if (_v0.$ === 1) return false;
        else {
            var user_ = _v0.a;
            return $author$project$Api$Provider$PracticeUser$All$isHinter(practiceUser) && $author$project$Api$Provider$User$One$isAdmin(user_);
        }
    };
    var $author$project$Pages$Admin$Team$canMakeSuperAdmin = F2(function(teamMember, isHintAdmin) {
        return isHintAdmin && $author$project$Api$Provider$PracticeUser$All$isHinter(teamMember) && $author$project$Utils$Maybe$toBool($author$project$Api$Provider$PracticeUser$All$user(teamMember)) && !$author$project$Api$Provider$PracticeUser$All$isSuperAdmin(teamMember);
    });
    var $author$project$Api$Provider$PracticeUser$Shared$invitationPending = function(_v0) {
        var record = _v0;
        return record.Ry;
    };
    var $author$project$Api$Provider$PracticeUser$All$invitationPending = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$invitationPending(shared);
    };
    var $author$project$Api$Provider$PracticeUser$Shared$isDestroyable = function(_v0) {
        var record = _v0;
        return record.R1;
    };
    var $author$project$Api$Provider$PracticeUser$All$isDestroyable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$isDestroyable(shared);
    };
    var $author$project$Api$Provider$PracticeUser$Shared$isOwner = function(_v0) {
        var record = _v0;
        return record.Sf;
    };
    var $author$project$Api$Provider$PracticeUser$All$isOwner = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PracticeUser$Shared$isOwner(shared);
    };
    var $author$project$Components$InviteLink$CopyToClipboard = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerUser$Shared$invitationPending = function(_v0) {
        var record = _v0;
        return record.Ry;
    };
    var $author$project$Api$Partner$PartnerUser$All$invitationPending = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerUser$Shared$invitationPending(shared);
    };
    var $author$project$Api$Provider$CompanyAdmin$Shared$invitationPending = function(_v0) {
        var record = _v0;
        return record.Ry;
    };
    var $author$project$Api$Provider$CompanyAdmin$One$invitationPending = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAdmin$Shared$invitationPending(shared);
    };
    var $author$project$Api$Provider$CompanyAdmin$All$invitationPending = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$CompanyAdmin$One$invitationPending(one);
    };
    var $author$project$Api$Partner$PartnerUser$All$invitationUrl = function(_v0) {
        var record = _v0.b;
        return record.Rz;
    };
    var $author$project$Api$Provider$CompanyAdmin$One$invitationUrl = function(_v0) {
        var record = _v0.b;
        return record.Rz;
    };
    var $author$project$Api$Provider$CompanyAdmin$All$invitationUrl = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$CompanyAdmin$One$invitationUrl(one);
    };
    var $author$project$Api$Provider$PracticeUser$All$invitationUrl = function(_v0) {
        var record = _v0.b;
        return record.Rz;
    };
    var $author$project$Components$InviteLink$view = function(admin) {
        var _v0 = function() {
            switch(admin.$){
                case 0:
                    var companyAdmin = admin.a;
                    return _Utils_Tuple2($author$project$Api$Provider$CompanyAdmin$All$invitationPending(companyAdmin), $author$project$Api$Provider$CompanyAdmin$All$invitationUrl(companyAdmin));
                case 1:
                    var practiceUser = admin.a;
                    return _Utils_Tuple2($author$project$Api$Provider$PracticeUser$All$invitationPending(practiceUser), $author$project$Api$Provider$PracticeUser$All$invitationUrl(practiceUser));
                default:
                    var partnerUser = admin.a;
                    return _Utils_Tuple2($author$project$Api$Partner$PartnerUser$All$invitationPending(partnerUser), $author$project$Api$Partner$PartnerUser$All$invitationUrl(partnerUser));
            }
        }();
        var invitationPending = _v0.a;
        var invitationUrl = _v0.b;
        return invitationPending && !_Utils_eq(invitationUrl, $elm$core$Maybe$Nothing) ? A3($author$project$Ui$Button$view, {
            abP: 'Copy invite link'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick(A2($elm$core$Maybe$withDefault, '', invitationUrl)),
            $author$project$Ui$Button$size(0),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
        ]), _List_fromArray([
            $elm$html$Html$text('Copy Invite Link')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Admin$Team$viewTeamMember = F5(function(currentUser, deletingTeamMembers, makingAdminTeamMembers, currentUserIsHintAdmin, teamMember) {
        var notificationsStatus = $author$project$Api$Provider$PracticeUser$All$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
        var memberIsOwner = $author$project$Api$Provider$PracticeUser$All$isOwner(teamMember);
        var isCurrentUser = _Utils_eq($author$project$Api$Provider$PracticeUser$All$email(teamMember), $author$project$Api$Platform$User$Shared$email(currentUser));
        var rowOptions = isCurrentUser ? _List_fromArray([
            $author$project$Ui$Table$styled(2)
        ]) : _List_Nil;
        var id = $author$project$Api$Provider$PracticeUser$All$id(teamMember);
        var loading = A2($elm$core$Set$member, id, deletingTeamMembers) || A2($elm$core$Set$member, id, makingAdminTeamMembers);
        return A2($author$project$Ui$Table$row, rowOptions, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$minWidth('11em')
            ]), function() {
                var _v0 = $author$project$Api$Provider$PracticeUser$All$user(teamMember);
                if (!_v0.$) {
                    var user = _v0.a;
                    var memberIsHintAdmin = $author$project$Api$Provider$PracticeUser$All$isSuperAdmin(teamMember);
                    var isOwnerOrAdminLabel = function() {
                        var _v1 = _Utils_Tuple3(memberIsOwner, memberIsHintAdmin, currentUserIsHintAdmin);
                        if (_v1.a) {
                            if (_v1.b) {
                                if (_v1.c) return $elm$html$Html$text(' (owner | admin)');
                                else return $elm$html$Html$text(' (owner)');
                            } else return $elm$html$Html$text(' (owner)');
                        } else {
                            if (_v1.b && _v1.c) return $elm$html$Html$text(' (admin)');
                            else return $author$project$Utils$Html$empty;
                        }
                    }();
                    return _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$User$One$name(user))
                        ])),
                        isOwnerOrAdminLabel
                    ]);
                } else {
                    var isOwnerLabel = memberIsOwner ? $elm$html$Html$text(' (owner)') : $author$project$Utils$Html$empty;
                    return $author$project$Api$Provider$PracticeUser$All$invitationPending(teamMember) ? _List_fromArray([
                        A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Invitation Pending'),
                            isOwnerLabel
                        ])),
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Resend invite email'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$ReInviteTeamMember(teamMember)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Resend')
                            ])),
                            A2($elm$html$Html$map, $author$project$Pages$Admin$Team$InviteLinkMsg, $author$project$Components$InviteLink$view($author$project$Components$InviteLink$PracticeUser(teamMember)))
                        ]))
                    ]) : _List_fromArray([
                        A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Not Invited'),
                            isOwnerLabel
                        ])),
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Send invite email'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$InviteTeamMember(teamMember)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$send),
                                $author$project$Ui$Button$sm
                            ]), _List_fromArray([
                                $elm$html$Html$text('Send Invite')
                            ])),
                            A2($elm$html$Html$map, $author$project$Pages$Admin$Team$InviteLinkMsg, $author$project$Components$InviteLink$view($author$project$Components$InviteLink$PracticeUser(teamMember)))
                        ]))
                    ]);
                }
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$PracticeUser$All$email(teamMember))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Formatters$String$humanize($author$project$Api$Provider$PracticeUser$All$role(teamMember))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Pages$Admin$Team$mfaStatus($elm$core$Maybe$Just(teamMember)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A2($author$project$Pages$Admin$Team$canMakeSuperAdmin, teamMember, currentUserIsHintAdmin) ? A3($author$project$Ui$HinterOnly$button, {
                        abP: 'Make admin'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$disabled(loading),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$MakeSuperAdmin($author$project$Api$Provider$PracticeUser$All$id(teamMember)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Make admin')
                    ])) : $author$project$Utils$Html$empty,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit team member'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$disabled(loading || memberIsOwner && !$author$project$Api$Platform$User$Shared$isAdmin(currentUser)),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$EditTeamMember(teamMember)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    $author$project$Api$Provider$PracticeUser$All$isDestroyable(teamMember) && !isCurrentUser ? A3($author$project$Ui$Button$view, {
                        abP: 'Delete team member'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$OpenDeleteConfirm(teamMember)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Team$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.eO;
            if (_v1.$ === 3) {
                var teamMembers_ = _v1.a;
                return _Utils_Tuple2(false, teamMembers_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var teamMembers = _v0.b;
        return _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Security')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$Admin$Team$ToogleOrganizationMfa, $author$project$Components$Admin$ToogleOrganizationMfa$view(model.ts)),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Members')
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb2
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$Team$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                    ]))
                ]))
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('There are no team members.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Admin$Team$SortTable)), $author$project$Pages$Admin$Team$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, A4($author$project$Pages$Admin$Team$viewTeamMember, model.E2, model.dZ, model.ef, model.F3), teamMembers), _List_Nil)
        ]);
    };
    var $author$project$Pages$Admin$Team$Email = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$FormUpdated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$Invite = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$NotificationsEnabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$OpenDisableMfaConfirm = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$RestrictedByGroups = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$Role = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$SaveTeamMember = F3(function(a, b, c) {
        return {
            $: 9,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Common$Role$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Common$Role$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Common$Role$Shared$name(shared);
    };
    var $author$project$Api$Common$Role$Shared$permissionSets = function(_v0) {
        var record = _v0;
        return record.WD;
    };
    var $author$project$Api$Common$Role$All$permissionSets = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Common$Role$Shared$permissionSets(shared);
    };
    var $author$project$Pages$Admin$Team$roleOptions = F2(function(adminOnly, roles) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Pick a role'), A2($elm$core$List$map, function(role) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Common$Role$All$name(role)), $author$project$Formatters$String$titleize($author$project$Formatters$String$humanize($author$project$Api$Common$Role$All$name(role))));
        }, A2($elm$core$List$filter, function(role) {
            return !adminOnly || $author$project$Api$Common$Role$All$name(role) === 'admin';
        }, roles)));
    });
    var $author$project$Ui$Element$textCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textCenter);
    var $author$project$Ui$Grid$textCenter = $author$project$Ui$Grid$Element($author$project$Ui$Element$textCenter);
    var $author$project$Pages$Admin$Team$LocationGroups = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Admin$Team$viewLocationGroup = F2(function(locationGroups, locationGroup) {
        var id = $author$project$Api$Provider$LocationGroup$All$id(locationGroup);
        var locationGroupEnabled = A2($elm$core$Set$member, id, locationGroups);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(locationGroupEnabled),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$LocationGroups(id)))
            ]), _List_fromArray([
                $author$project$Utils$Html$noBreakSpace,
                $elm$html$Html$text($author$project$Api$Provider$LocationGroup$All$name(locationGroup))
            ]))
        ]));
    });
    var $author$project$Pages$Admin$Team$viewPermissionSet = F2(function(index, permissionSet) {
        var hasEvenIndex = !A2($elm$core$Basics$modBy, 2, index);
        var gridOptions = hasEvenIndex ? _List_fromArray([
            $author$project$Ui$Grid$offsetSm(2),
            $author$project$Ui$Grid$spanSm(4),
            $author$project$Ui$Grid$span(6)
        ]) : _List_fromArray([
            $author$project$Ui$Grid$spanSm(5),
            $author$project$Ui$Grid$justifyRight
        ]);
        return _List_fromArray([
            A2($author$project$Ui$Grid$column, gridOptions, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Formatters$String$humanize($author$project$Api$Common$PermissionSet$Shared$name(permissionSet)))
                    ])),
                    $author$project$Api$Common$PermissionSet$Shared$enabled(permissionSet) ? $author$project$Ui$Icon$check(_List_fromArray([
                        $author$project$Ui$Icon$success
                    ])) : $author$project$Ui$Icon$cross(_List_fromArray([
                        $author$project$Ui$Icon$danger
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Api$Feature$ReportAccess = 9;
    var $author$project$Pages$Admin$Team$ReportRestricted = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$viewReportAccessSection = F3(function(practice, permissions, fields) {
        var featureIsEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 9, practice);
        var canViewReports = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Common$PermissionSet$Shared$enabled, A2($elm_community$list_extra$List$Extra$find, A2($elm$core$Basics$composeR, $author$project$Api$Common$PermissionSet$Shared$name, $elm$core$Basics$eq('view_reports')), permissions)));
        return featureIsEnabled && fields.ag_ !== 'admin' && canViewReports ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Restrict report access')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(fields.YB),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$ReportRestricted))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Admin$Team$viewTeamMemberModal = F4(function(model, teamMember, request, form) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Team Member',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$id, teamMember),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Admin$Team$CancelTeamMemberEdit,
            Vn: A2($author$project$Pages$Admin$Team$SaveTeamMember, form, teamMember)
        };
        var isNewTeamMember = !$author$project$Utils$Maybe$toBool(teamMember);
        var isCurrentUser = _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$email, teamMember), $elm$core$Maybe$Just($author$project$Api$Platform$User$Shared$email(model.E2)));
        var roleDisabled = isCurrentUser || A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeUser$All$isOwner, teamMember));
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = function() {
            var _v1 = model.Cc;
            if (_v1.$ === 3) {
                var list = _v1.a;
                return _Utils_Tuple2(list, false);
            } else return _Utils_Tuple2(_List_Nil, true);
        }();
        var roles_ = _v0.a;
        var rolesLoading = _v0.b;
        var permissionSets = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Role$All$permissionSets, A2($elm_community$list_extra$List$Extra$find, function(role) {
            return _Utils_eq($author$project$Api$Common$Role$All$name(role), fields.ag_);
        }, roles_)));
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(isNewTeamMember),
                $author$project$Ui$Form$Group$label('Email')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.OH),
                    $author$project$Ui$Form$Input$placeholder('email@example.com'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Email)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form)),
                    $author$project$Ui$Form$Input$disabled(!isNewTeamMember)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Role')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(fields.ag_)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Role)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, form)),
                    $author$project$Ui$Form$Select$loading(rolesLoading),
                    $author$project$Ui$Form$Select$disabled(roleDisabled)
                ]), A2($author$project$Pages$Admin$Team$roleOptions, model.tT, roles_)),
                roleDisabled ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$info
                ]), _List_fromArray([
                    $elm$html$Html$text('You cannot change your own role.')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Notifications')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.U8),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$NotificationsEnabled))
                ]))
            ])),
            isNewTeamMember ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Send invitation')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.aez),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$Invite))
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('MFA')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, fields.Ug),
                    $author$project$Utils$Html$noBreakSpace,
                    function() {
                        if (!teamMember.$) {
                            var teamMember_ = teamMember.a;
                            return fields.Ug === 'active' && !isCurrentUser ? A3($author$project$Ui$Button$view, {
                                abP: 'Reset MFA device'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$OpenDisableMfaConfirm($author$project$Api$Provider$PracticeUser$All$id(teamMember_)))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Reset MFA device')
                            ])) : $author$project$Utils$Html$empty;
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb4,
                $author$project$Ui$Grid$mt4
            ]), $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Pages$Admin$Team$viewPermissionSet, permissionSets))),
            fields.ag_ !== 'admin' ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Restrict by location groups')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.YW),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Admin$Team$FormUpdated, $author$project$Pages$Admin$Team$RestrictedByGroups))
                ]))
            ])) : $author$project$Utils$Html$empty,
            fields.YW ? A2($author$project$Ui$Grid$row, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$offset(4),
                $author$project$Ui$Grid$span(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Which location groups\' patients should they be able to see?')
                ]))
            ])), function() {
                var _v3 = model.Tl;
                if (_v3.$ === 3) {
                    var locationGroups = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$offset(4),
                            $author$project$Ui$Grid$span(8)
                        ]), A2($elm$core$List$map, $author$project$Pages$Admin$Team$viewLocationGroup(fields.Tl), locationGroups))
                    ]);
                } else return _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$offset(4),
                        $author$project$Ui$Grid$span(8),
                        $author$project$Ui$Grid$textCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]))
                ]);
            }())) : $author$project$Utils$Html$empty,
            A3($author$project$Pages$Admin$Team$viewReportAccessSection, model.W1, permissionSets, fields)
        ]));
    });
    var $author$project$Pages$Admin$Team$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.A;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var teamMember = _v1.a;
                        var form = _v1.b;
                        var request = _v1.c;
                        return A4($author$project$Pages$Admin$Team$viewTeamMemberModal, model, teamMember, request, form);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.lV;
                    if (!_v2.$) {
                        var teamMember = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Team$DeleteConfirmClosed($author$project$Api$Provider$PracticeUser$All$id(teamMember)), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('team member'),
                            $author$project$Components$HiConfirm$detail($author$project$Api$Provider$PracticeUser$All$email(teamMember))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v3 = model.iq;
                    if (!_v3.$) {
                        var id = _v3.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Admin$Team$DisableMfaConfirmClosed(id), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('reset'),
                            $author$project$Components$HiConfirm$noun('MFA device'),
                            $author$project$Components$HiConfirm$titleizeNoun(false),
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text('Resetting the MFA device for this user will log them out of all sessions and require them to setup a new MFA device the next time they login.')
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween,
                            $author$project$Ui$Element$itemsCenter
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('Team')
                                ])),
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$small
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Changing settings within the Admin section requires \"Admin\" privileges. Non admin users can\n        view the settings but cannot change them.')
                                ]))
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$gap2
                            ]), _List_fromArray([
                                model.F3 ? A3($author$project$Ui$HinterOnly$linkHref, A2($author$project$Pages$Admin$Team$buildIdentityProviderUrl, model.aea, $author$project$Api$Provider$Practice$One$organizationId(model.W1)), _List_fromArray([
                                    $author$project$Ui$Link$targetBlank,
                                    $author$project$Ui$Link$buttonDefault,
                                    $author$project$Ui$Link$ariaLabel('Open Identity Provider in new tab')
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Identity Provider')
                                ])) : $author$project$Utils$Html$empty,
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Add new member'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$default,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$NewTeamMember),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add')
                                ]))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Admin$Team$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Admin$Team$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.eO))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Team'
        };
    };
    var $author$project$Pages$Admin$Team$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Team$init,
        aeR: $author$project$Pages$Admin$Team$load,
        ag3: $author$project$Pages$Admin$Team$save,
        ahE: $author$project$Pages$Admin$Team$subscriptions,
        aaO: $author$project$Pages$Admin$Team$update,
        aid: $author$project$Pages$Admin$Team$view
    });
    var $author$project$Pages$Admin$Team$New$TeamFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$TeamForm$EmrRoleDropdownMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$TeamForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$TeamForm$DeaStateDropdownMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$MultiDeaExpirationMsg = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$StateLicenseExpirationMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$StateLicenseStateDropdownMsg = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$initLicense = F3(function(usingClinical, dropdownId, toDropdownMsg) {
        if (usingClinical) {
            var _v0 = $author$project$Components$DateInput$init;
            var initialLicenseExpiration = _v0.a;
            var initialLicenseExpirationCmd = _v0.b;
            return _Utils_Tuple2(_List_fromArray([
                {
                    adC: _Utils_Tuple2($elm$core$Maybe$Nothing, initialLicenseExpiration),
                    Gx: $elm$core$Maybe$Nothing,
                    s4: $elm$core$Maybe$Nothing,
                    bk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                        aef: dropdownId,
                        ahX: toDropdownMsg(0)
                    })),
                    bG: ''
                }
            ]), initialLicenseExpirationCmd);
        } else return _Utils_Tuple2(_List_Nil, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$TeamForm$initPhone = F3(function(requirePhone, isOnboarding, maybePhone) {
        var phoneToUse = isOnboarding ? A2($elm$core$Maybe$withDefault, {
            Gx: '',
            agE: 0,
            ah5: $author$project$Api$Common$Phone$Shared$Mobile
        }, A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone)) : {
            Gx: '',
            agE: 0,
            ah5: $author$project$Api$Common$Phone$Shared$Mobile
        };
        return A2($author$project$Components$PhoneInput$require, requirePhone, A3($author$project$Components$PhoneInput$init, 'new-team-member-phone', _List_fromArray([
            phoneToUse
        ]), function(opts) {
            return _Utils_update(opts, {
                abK: false,
                ada: true,
                y_: 1
            });
        }));
    });
    var $author$project$Api$Platform$User$Shared$phones = function(_v0) {
        var record = _v0;
        return record.WG;
    };
    var $author$project$Components$TeamForm$formFieldsFromTeamMember = F3(function(user, usingClinical, isOnboarding) {
        var _v0 = A3($author$project$Components$TeamForm$initLicense, usingClinical, 'state-dropdown-0', $author$project$Components$TeamForm$StateLicenseStateDropdownMsg);
        var initialLicense = _v0.a;
        var initialLicenseExpirationCmd = _v0.b;
        var _v1 = A3($author$project$Components$TeamForm$initLicense, usingClinical, 'dea-dropdown-0', $author$project$Components$TeamForm$DeaStateDropdownMsg);
        var initialDea = _v1.a;
        var initialDeaExpirationCmd = _v1.b;
        return _Utils_Tuple2({
            M7: $elm$core$Maybe$Nothing,
            xa: initialDea,
            NG: $elm$core$Maybe$Nothing,
            OH: isOnboarding ? $author$project$Api$Platform$User$Shared$email(user) : '',
            ado: $elm$core$Maybe$Nothing,
            PN: isOnboarding ? $author$project$Api$Platform$User$Shared$firstName(user) : '',
            SU: isOnboarding ? $author$project$Api$Platform$User$Shared$lastName(user) : '',
            U9: $elm$core$Maybe$Nothing,
            WE: A3($author$project$Components$TeamForm$initPhone, usingClinical, isOnboarding, $elm$core$List$head($author$project$Api$Platform$User$Shared$phones(user))),
            Xm: $elm$core$Maybe$Nothing,
            XK: $elm$core$Maybe$Nothing,
            CI: initialLicense
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$StateLicenseExpirationMsg(0), initialLicenseExpirationCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$MultiDeaExpirationMsg(0), initialDeaExpirationCmd)
        ])));
    });
    var $author$project$Components$TeamForm$init = F4(function(today, session, practice, _v0) {
        var usingClinicalEmr = _v0.dn;
        var isOnboarding = _v0.aK;
        var emrRoleDropdown = $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
            aef: 'emr-role-dropdown',
            ahX: $author$project$Components$TeamForm$EmrRoleDropdownMsg
        }));
        var _v1 = A3($author$project$Components$TeamForm$formFieldsFromTeamMember, $author$project$Api$Platform$Session$One$user(session), usingClinicalEmr, isOnboarding);
        var formFields = _v1.a;
        var formFieldsCmd = _v1.b;
        return _Utils_Tuple2({
            qu: emrRoleDropdown,
            PU: $author$project$Utils$Form$init(formFields),
            aK: isOnboarding,
            W1: practice,
            Z$: session,
            aae: today,
            aaX: $author$project$Api$Platform$Session$One$user(session),
            dn: usingClinicalEmr
        }, formFieldsCmd);
    });
    var $author$project$Pages$Admin$Team$New$init = F4(function(session, practice, shared, _v0) {
        var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice);
        var _v1 = A4($author$project$Components$TeamForm$init, shared.cP, session, practice, {
            aK: false,
            dn: usingClinicalEmr
        });
        var teamFormModel = _v1.a;
        var teamFormCmd = _v1.b;
        return _Utils_Tuple2({
            abC: false,
            Ej: shared.Ej,
            OI: shared.adU.adj,
            PU: teamFormModel,
            W1: practice,
            nH: 0,
            nO: $author$project$Api$Data$NotAsked,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            oq: false
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$New$TeamFormMsg, teamFormCmd));
    });
    var $author$project$Pages$Admin$Team$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Admin$Team$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Admin$Team$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Utils$EmrRole$Admin = 0;
    var $author$project$Pages$Admin$Team$New$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Utils$EmrRole$toString = function(role) {
        switch(role){
            case 0:
                return 'admin';
            case 1:
                return 'provider';
            default:
                return 'employee';
        }
    };
    var $author$project$Api$Provider$TeamMember$encodeEmrRole = function(emrRole) {
        return $author$project$Utils$EmrRole$toString(emrRole);
    };
    var $author$project$Api$Provider$TeamMember$createWithClinicalData = F3(function(apiClient, fields, toMsg) {
        var providerStatusValue = A2($elm$core$Maybe$map, $author$project$Components$TeamForm$providerStatusToString, fields.XK);
        var encodeMaskedDate = function(stringDate) {
            return A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, $elm$core$Result$toMaybe(A2($elm$core$Result$map, $author$project$Utils$Date$encode, $author$project$Utils$Date$fromUsString(A2($agustinrhcp$elm_mask$Mask$mask, $agustinrhcp$elm_mask$Mask$fromString('##/##/####'), stringDate)))));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('team_member', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    _Utils_Tuple2('first_name', $elm$json$Json$Encode$string(fields.PN)),
                    _Utils_Tuple2('last_name', $elm$json$Json$Encode$string(fields.SU)),
                    _Utils_Tuple2('email', $elm$json$Json$Encode$string(fields.OH)),
                    _Utils_Tuple2('emr_role', $elm$json$Json$Encode$string($author$project$Api$Provider$TeamMember$encodeEmrRole(fields.ado))),
                    _Utils_Tuple2('agreed_to_terms', $elm$json$Json$Encode$bool(fields.abC))
                ]),
                A3($author$project$Utils$Encode$optional, 'phone_number', $elm$json$Json$Encode$string, fields.WF),
                A3($author$project$Utils$Encode$optional, 'prescriber_type', $elm$json$Json$Encode$string, fields.Xm),
                A3($author$project$Utils$Encode$optional, 'dob', encodeMaskedDate, fields.M7),
                A3($author$project$Utils$Encode$optional, 'education_degree', $elm$json$Json$Encode$string, fields.NG),
                A3($author$project$Utils$Encode$optional, 'npi', $elm$json$Json$Encode$string, fields.U9),
                A3($author$project$Utils$Encode$optional, 'dea_licenses', $elm$json$Json$Encode$list($author$project$Api$Provider$TeamMember$encodeLicense), $elm$core$List$isEmpty(fields.xa) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.xa)),
                A3($author$project$Utils$Encode$optional, 'provider_status', $elm$json$Json$Encode$string, providerStatusValue),
                A3($author$project$Utils$Encode$optional, 'state_licenses', $elm$json$Json$Encode$list($author$project$Api$Provider$TeamMember$encodeLicense), $elm$core$List$isEmpty(fields.CI) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.CI))
            ]))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeUser$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$TeamMember$teamMembersPath)));
    });
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam = function(prescriberType) {
        switch(prescriberType){
            case 0:
                return 'Provider';
            case 1:
                return 'POBNoReview';
            case 2:
                return 'POBSomeReview';
            default:
                return 'StaffUser';
        }
    };
    var $author$project$Components$TeamForm$teamMemberFormFields = function(fields) {
        var prescriberTypeValue = A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam, fields.Xm);
        var phone = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, A2($elm$core$Maybe$map, function($) {
            return $.Gx;
        }, A2($elm$core$Maybe$map, $author$project$Utils$Phone$toRecord, $elm$core$List$head(A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Components$PhoneInput$getPhones(fields.WE))))));
        return {
            M7: fields.M7,
            xa: fields.xa,
            NG: fields.NG,
            OH: fields.OH,
            ado: fields.ado,
            PN: fields.PN,
            SU: fields.SU,
            U9: fields.U9,
            WF: phone,
            Xm: prescriberTypeValue,
            XK: fields.XK,
            CI: fields.CI
        };
    };
    var $author$project$Pages$Admin$Team$New$createTeamMember = F2(function(model, validFormFields) {
        var fields = $author$project$Components$TeamForm$teamMemberFormFields($rtfeldman$elm_validate$Validate$fromValid(validFormFields));
        return A3($author$project$Api$Provider$TeamMember$createWithClinicalData, model.Ej, {
            abC: model.abC,
            M7: fields.M7,
            xa: fields.xa,
            NG: fields.NG,
            OH: fields.OH,
            ado: A2($elm$core$Maybe$withDefault, 0, fields.ado),
            PN: fields.PN,
            SU: fields.SU,
            U9: fields.U9,
            WF: fields.WF,
            Xm: fields.Xm,
            XK: fields.XK,
            CI: fields.CI
        }, $author$project$Pages$Admin$Team$New$Created);
    });
    var $author$project$Pages$Admin$Team$New$ProductPricingReceived = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticePricing$Product$ProductPricing = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticePricing$Product$Record = F2(function(requiresPayment, priceInCents) {
        return {
            Br: priceInCents,
            YO: requiresPayment
        };
    });
    var $author$project$Api$Provider$PracticePricing$Product$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_payment', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticePricing$Product$Record)));
    var $author$project$Api$Provider$PracticePricing$Product$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PracticePricing$Product$recordDecoder);
    var $author$project$Api$Provider$PracticePricing$Product$productsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice',
        'pricing',
        'products'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PracticePricing$Product$productPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$PracticePricing$Product$productsPath);
    };
    var $author$project$Api$Provider$PracticePricing$Product$retrieve = F3(function(apiClient, productId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PracticePricing$Product$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticePricing$Product$productPath(productId)));
    });
    var $author$project$Pages$Admin$Team$New$fetchProductPricing = function(model) {
        return A3($author$project$Api$Provider$PracticePricing$Product$retrieve, model.Ej, 'clinician', $author$project$Pages$Admin$Team$New$ProductPricingReceived);
    };
    var $author$project$Api$Provider$PracticePricing$Product$priceInCents = function(_v0) {
        var record = _v0;
        return record.Br;
    };
    var $author$project$Api$Provider$PracticePricing$Product$requiresPayment = function(_v0) {
        var record = _v0;
        return record.YO;
    };
    var $author$project$Pages$Admin$Team$New$shouldFetchProductPricing = function(validFormFields) {
        var fields = $author$project$Components$TeamForm$teamMemberFormFields($rtfeldman$elm_validate$Validate$fromValid(validFormFields));
        var _v0 = _Utils_Tuple2(fields.XK, fields.Xm);
        if (!_v0.a.$ && !_v0.a.a && !_v0.b.$ && _v0.b.a === 'Provider') {
            var _v1 = _v0.a.a;
            return true;
        } else return false;
    };
    var $author$project$Components$TeamForm$DeaExpirationAt = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$DeaStateDropdownAt = F2(function(a, b) {
        return {
            $: 15,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$TeamForm$Phone = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$TeamForm$PhoneInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$TeamForm$StateLicenseExpirationAt = F2(function(a, b) {
        return {
            $: 19,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$StateLicenseStateDropdownAt = F2(function(a, b) {
        return {
            $: 22,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$Provider = 0;
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider = function(prescriberType) {
        return !prescriberType;
    };
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$provider = 0;
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$StaffUser = 3;
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff = 3;
    var $author$project$Components$TeamForm$calculateDefaultPrescriberType = F2(function(currentPrescriberType, providerStatus) {
        if (providerStatus === 2) return A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff), A2($elm$core$Maybe$map, function(prescriberType) {
            return $author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider(prescriberType) ? $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$staff) : currentPrescriberType;
        }, currentPrescriberType));
        else return $author$project$Utils$Maybe$isNothing(currentPrescriberType) ? $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$provider) : currentPrescriberType;
    });
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$POBNoReview = 1;
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$POBSomeReview = 2;
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$fromParam = function(stepTypeParam) {
        switch(stepTypeParam){
            case 'Provider':
                return 0;
            case 'POBNoReview':
                return 1;
            case 'POBSomeReview':
                return 2;
            default:
                return 3;
        }
    };
    var $author$project$Utils$EmrRole$Provider = 1;
    var $author$project$Utils$EmrRole$Staff = 2;
    var $author$project$Utils$EmrRole$fromString = function(str) {
        switch(str){
            case 'admin':
                return $elm$core$Maybe$Just(0);
            case 'provider':
                return $elm$core$Maybe$Just(1);
            case 'employee':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$TeamForm$removeAt = F2(function(index, list) {
        return _Utils_ap(A2($elm$core$List$take, index, list), A2($elm$core$List$drop, index + 1, list));
    });
    var $author$project$Components$TeamForm$updateItemAt = F3(function(index, updateFn, items) {
        return A2($elm$core$List$indexedMap, F2(function(i, item) {
            return _Utils_eq(i, index) ? updateFn(item) : item;
        }), items);
    });
    var $author$project$Components$TeamForm$formFieldsUpdate = F3(function(today, field, fields) {
        switch(field.$){
            case 0:
                var firstName = field.a;
                return _Utils_update(fields, {
                    PN: firstName
                });
            case 1:
                var lastName = field.a;
                return _Utils_update(fields, {
                    SU: lastName
                });
            case 2:
                var email = field.a;
                return _Utils_update(fields, {
                    OH: email
                });
            case 3:
                var phone = field.a;
                return _Utils_update(fields, {
                    WE: phone
                });
            case 4:
                var status = field.a;
                var prescriberType = A2($author$project$Components$TeamForm$calculateDefaultPrescriberType, fields.Xm, status);
                return _Utils_update(fields, {
                    Xm: prescriberType,
                    XK: $elm$core$Maybe$Just(status)
                });
            case 5:
                var roleString = field.a;
                return _Utils_update(fields, {
                    ado: $author$project$Utils$EmrRole$fromString(roleString)
                });
            case 6:
                var string = field.a;
                return _Utils_update(fields, {
                    U9: $author$project$Utils$String$toMaybe(string)
                });
            case 7:
                var prescriberTypeValue = field.a;
                var prescriberType = $elm$core$String$isEmpty(prescriberTypeValue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$fromParam(prescriberTypeValue));
                return _Utils_update(fields, {
                    Xm: prescriberType
                });
            case 8:
                var dob = field.a;
                return _Utils_update(fields, {
                    M7: $elm$core$Maybe$Just(dob)
                });
            case 9:
                var string = field.a;
                return _Utils_update(fields, {
                    NG: $author$project$Utils$String$toMaybe(string)
                });
            case 10:
                var index = field.a;
                var value = field.b;
                return _Utils_update(fields, {
                    xa: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            Gx: $author$project$Utils$String$toMaybe(value)
                        });
                    }, fields.xa)
                });
            case 11:
                var index = field.a;
                var value = field.b;
                return _Utils_update(fields, {
                    xa: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            s4: $elm$core$Maybe$Just(value)
                        });
                    }, fields.xa)
                });
            case 12:
                var index = field.a;
                var _v1 = field.b;
                var date = _v1.a;
                var model = _v1.b;
                return _Utils_update(fields, {
                    xa: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            adC: _Utils_Tuple2(date, model)
                        });
                    }, fields.xa)
                });
            case 13:
                var newExpiration = $author$project$Components$DateInput$initFromDate(today);
                return _Utils_update(fields, {
                    xa: _Utils_ap(fields.xa, _List_fromArray([
                        {
                            adC: _Utils_Tuple2($elm$core$Maybe$Nothing, newExpiration),
                            Gx: $elm$core$Maybe$Nothing,
                            s4: $elm$core$Maybe$Nothing,
                            bk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                                aef: 'dea-dropdown-' + $elm$core$String$fromInt($elm$core$List$length(fields.xa)),
                                ahX: $author$project$Components$TeamForm$DeaStateDropdownMsg($elm$core$List$length(fields.xa))
                            })),
                            bG: ''
                        }
                    ]))
                });
            case 14:
                var index = field.a;
                return _Utils_update(fields, {
                    xa: A2($author$project$Components$TeamForm$removeAt, index, fields.xa)
                });
            case 15:
                var index = field.a;
                var dropdown = field.b;
                return _Utils_update(fields, {
                    xa: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            bk: dropdown
                        });
                    }, fields.xa)
                });
            case 16:
                var index = field.a;
                var search = field.b;
                return _Utils_update(fields, {
                    xa: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            bG: search
                        });
                    }, fields.xa)
                });
            case 17:
                var index = field.a;
                var value = field.b;
                return _Utils_update(fields, {
                    CI: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            Gx: $author$project$Utils$String$toMaybe(value)
                        });
                    }, fields.CI)
                });
            case 18:
                var index = field.a;
                var value = field.b;
                return _Utils_update(fields, {
                    CI: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            s4: $elm$core$Maybe$Just(value)
                        });
                    }, fields.CI)
                });
            case 19:
                var index = field.a;
                var _v2 = field.b;
                var date = _v2.a;
                var model = _v2.b;
                return _Utils_update(fields, {
                    CI: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            adC: _Utils_Tuple2(date, model)
                        });
                    }, fields.CI)
                });
            case 20:
                var newExpiration = $author$project$Components$DateInput$initFromDate(today);
                return _Utils_update(fields, {
                    CI: _Utils_ap(fields.CI, _List_fromArray([
                        {
                            adC: _Utils_Tuple2($elm$core$Maybe$Nothing, newExpiration),
                            Gx: $elm$core$Maybe$Nothing,
                            s4: $elm$core$Maybe$Nothing,
                            bk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                                aef: 'state-dropdown-' + $elm$core$String$fromInt($elm$core$List$length(fields.CI)),
                                ahX: $author$project$Components$TeamForm$StateLicenseStateDropdownMsg($elm$core$List$length(fields.CI))
                            })),
                            bG: ''
                        }
                    ]))
                });
            case 21:
                var index = field.a;
                return _Utils_update(fields, {
                    CI: A2($author$project$Components$TeamForm$removeAt, index, fields.CI)
                });
            case 22:
                var index = field.a;
                var dropdown = field.b;
                return _Utils_update(fields, {
                    CI: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            bk: dropdown
                        });
                    }, fields.CI)
                });
            default:
                var index = field.a;
                var search = field.b;
                return _Utils_update(fields, {
                    CI: A3($author$project$Components$TeamForm$updateItemAt, index, function(license) {
                        return _Utils_update(license, {
                            bG: search
                        });
                    }, fields.CI)
                });
        }
    });
    var $author$project$Components$TeamForm$formFieldsUpdateWithCmd = F3(function(today, field, fields) {
        return _Utils_Tuple2(A3($author$project$Components$TeamForm$formFieldsUpdate, today, field, fields), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Utils$Form$updateWithCmd = F3(function(updater, field_, _v0) {
        var originalFields = _v0.a;
        var validated_ = _v0.b;
        var fields_ = _v0.c;
        var errors_ = _v0.d;
        var _v1 = A2(updater, field_, fields_);
        var updated = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple2(A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_), cmd);
    });
    var $author$project$Components$TeamForm$update = F3(function(msg, _v0, _v1) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var _v3 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$TeamForm$formFieldsUpdateWithCmd(model.aae), field, model.PU);
                var newForm = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$FormUpdated, cmd), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v4 = $author$project$Utils$Form$fields(model.PU);
                var phone = _v4.WE;
                var _v5 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
                var phoneInput = _v5.a;
                var phoneCmd = _v5.b;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$TeamForm$formFieldsUpdate(model.aae), $author$project$Components$TeamForm$Phone(phoneInput), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$PhoneInputMsg, phoneCmd), _List_Nil);
            case 2:
                var index = msg.a;
                var subMsg = msg.b;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var license = A2($elm$core$Maybe$withDefault, {
                    adC: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
                    Gx: $elm$core$Maybe$Nothing,
                    s4: $elm$core$Maybe$Nothing,
                    bk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                        aef: 'dea-dropdown-' + $elm$core$String$fromInt(index),
                        ahX: $author$project$Components$TeamForm$DeaStateDropdownMsg(index)
                    })),
                    bG: ''
                }, $elm$core$List$head(A2($elm$core$List$drop, index, fields.xa)));
                var _v6 = license.adC;
                var prevValue = _v6.a;
                var prevInput = _v6.b;
                var _v7 = A2($author$project$Components$DateInput$update, subMsg, prevInput);
                var dateInput = _v7.a;
                var dateInputCmd = _v7.b;
                var event = _v7.c;
                var newValue = function() {
                    if (event.$ === 1) {
                        var date = event.a;
                        return date;
                    } else return prevValue;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$TeamForm$formFieldsUpdate(model.aae), A2($author$project$Components$TeamForm$DeaExpirationAt, index, _Utils_Tuple2(newValue, dateInput)), model.PU)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$MultiDeaExpirationMsg(index), dateInputCmd), _List_Nil);
            case 3:
                var index = msg.a;
                var dropdownMsg = msg.b;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var license = A2($elm$core$Maybe$withDefault, {
                    adC: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
                    Gx: $elm$core$Maybe$Nothing,
                    s4: $elm$core$Maybe$Nothing,
                    bk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                        aef: 'dea-dropdown-' + $elm$core$String$fromInt(index),
                        ahX: $author$project$Components$TeamForm$DeaStateDropdownMsg(index)
                    })),
                    bG: ''
                }, $elm$core$List$head(A2($elm$core$List$drop, index, fields.xa)));
                var _v9 = A2($author$project$Ui$Dropdown$update, dropdownMsg, license.bk);
                var newDropdown = _v9.a;
                var dropdownCmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$TeamForm$formFieldsUpdate(model.aae), A2($author$project$Components$TeamForm$DeaStateDropdownAt, index, newDropdown), model.PU)
                }), dropdownCmd, _List_Nil);
            case 4:
                var index = msg.a;
                var subMsg = msg.b;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var license = A2($elm$core$Maybe$withDefault, {
                    adC: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
                    Gx: $elm$core$Maybe$Nothing,
                    s4: $elm$core$Maybe$Nothing,
                    bk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                        aef: 'state-dropdown-' + $elm$core$String$fromInt(index),
                        ahX: $author$project$Components$TeamForm$StateLicenseStateDropdownMsg(index)
                    })),
                    bG: ''
                }, $elm$core$List$head(A2($elm$core$List$drop, index, fields.CI)));
                var _v10 = license.adC;
                var prevValue = _v10.a;
                var prevInput = _v10.b;
                var _v11 = A2($author$project$Components$DateInput$update, subMsg, prevInput);
                var dateInput = _v11.a;
                var dateInputCmd = _v11.b;
                var event = _v11.c;
                var newValue = function() {
                    if (event.$ === 1) {
                        var date = event.a;
                        return date;
                    } else return prevValue;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$TeamForm$formFieldsUpdate(model.aae), A2($author$project$Components$TeamForm$StateLicenseExpirationAt, index, _Utils_Tuple2(newValue, dateInput)), model.PU)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$TeamForm$StateLicenseExpirationMsg(index), dateInputCmd), _List_Nil);
            case 5:
                var index = msg.a;
                var dropdownMsg = msg.b;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var license = A2($elm$core$Maybe$withDefault, {
                    adC: _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Components$DateInput$init.a),
                    Gx: $elm$core$Maybe$Nothing,
                    s4: $elm$core$Maybe$Nothing,
                    bk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                        aef: 'state-dropdown-' + $elm$core$String$fromInt(index),
                        ahX: $author$project$Components$TeamForm$StateLicenseStateDropdownMsg(index)
                    })),
                    bG: ''
                }, $elm$core$List$head(A2($elm$core$List$drop, index, fields.CI)));
                var _v13 = A2($author$project$Ui$Dropdown$update, dropdownMsg, license.bk);
                var newDropdown = _v13.a;
                var dropdownCmd = _v13.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Components$TeamForm$formFieldsUpdate(model.aae), A2($author$project$Components$TeamForm$StateLicenseStateDropdownAt, index, newDropdown), model.PU)
                }), dropdownCmd, _List_Nil);
            default:
                var dropdownMsg = msg.a;
                var _v14 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.qu);
                var newDropdown = _v14.a;
                var dropdownCmd = _v14.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    qu: newDropdown
                }), dropdownCmd, _List_Nil);
        }
    });
    var $author$project$Components$TeamForm$EmailValidation = 10;
    var $author$project$Components$TeamForm$PhoneValidation = 11;
    var $author$project$Components$TeamForm$DateOfBirthValidation = 2;
    var $author$project$Components$TeamForm$datePattern = $agustinrhcp$elm_mask$Mask$fromString('##/##/####');
    var $author$project$Components$TeamForm$validateDateOfBirth = F2(function(requiresDOB, _v0) {
        var dateOfBirth = _v0.M7;
        if (dateOfBirth.$ === 1) return requiresDOB ? _List_fromArray([
            _Utils_Tuple2(2, 'Please enter a valid date of birth.')
        ]) : _List_Nil;
        else {
            var dob = dateOfBirth.a;
            var _v2 = $author$project$Utils$Date$fromUsString(A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$TeamForm$datePattern, dob));
            if (_v2.$ === 1) return _List_fromArray([
                _Utils_Tuple2(2, '')
            ]);
            else return _List_Nil;
        }
    });
    var $author$project$Components$TeamForm$DeaValidation = 6;
    var $author$project$Components$TeamForm$deaNumberValid = function(deaNumber) {
        var remainingChars = A3($elm$core$String$slice, 2, 9, deaNumber);
        var firstChar = A2($elm$core$String$left, 1, deaNumber);
        var isFirstCharLetter = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Char$isAlpha, $elm$core$List$head($elm$core$String$toList(firstChar))));
        var areRemainingCharsNumbers = A2($elm$core$List$all, $elm$core$Char$isDigit, $elm$core$String$toList(remainingChars));
        return $elm$core$String$length(deaNumber) >= 9 && isFirstCharLetter && areRemainingCharsNumbers;
    };
    var $author$project$Utils$String$isMaybeNotBlank = function(maybeString) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Utils$String$notBlank, maybeString));
    };
    var $author$project$Components$TeamForm$validateLicenseFields = function(_v0) {
        var number = _v0.Gx;
        var state = _v0.s4;
        var expiration = _v0.adC;
        var today = _v0.aae;
        var validationGroup = _v0.$7;
        var numberValidator = _v0.Gy;
        var licenseType = _v0.Ga;
        var skipIfEmpty = _v0.Hu;
        var hasState = $author$project$Utils$String$isMaybeNotBlank(state);
        var hasNumber = $author$project$Utils$String$isMaybeNotBlank(number);
        var hasExpiration = !_Utils_eq(expiration, $elm$core$Maybe$Nothing);
        var anyFieldFilled = hasNumber || hasState || hasExpiration;
        if (skipIfEmpty && !anyFieldFilled) return _List_Nil;
        else {
            var missingFieldErrors = !(hasNumber && hasState && hasExpiration) ? _List_fromArray([
                _Utils_Tuple2(validationGroup, 'Please complete all ' + (licenseType + ' fields.'))
            ]) : _List_Nil;
            var formatErrors = function() {
                if (!number.$) {
                    var licenseNumber = number.a;
                    var _v3 = numberValidator(licenseNumber);
                    if (!_v3.$) {
                        var errorMsg = _v3.a;
                        return _List_fromArray([
                            _Utils_Tuple2(validationGroup, errorMsg)
                        ]);
                    } else return _List_Nil;
                } else return _List_Nil;
            }();
            var expirationErrors = function() {
                if (!expiration.$) {
                    var date = expiration.a;
                    return A2($author$project$Utils$Date$isBefore, date, today) ? _List_fromArray([
                        _Utils_Tuple2(validationGroup, $elm$core$String$toUpper(licenseType) + ' expiration date cannot be in the past.')
                    ]) : _List_Nil;
                } else return _List_Nil;
            }();
            return _Utils_ap(missingFieldErrors, _Utils_ap(formatErrors, expirationErrors));
        }
    };
    var $author$project$Components$TeamForm$validateDeaNumbers = F3(function(allowsDea, today, fields) {
        if (allowsDea && _Utils_eq(fields.Xm, $elm$core$Maybe$Just(0))) {
            var numberValidator = function(deaNumber) {
                return !$author$project$Components$TeamForm$deaNumberValid(deaNumber) ? $elm$core$Maybe$Just('Please enter a valid DEA number in the format AB1234567.') : $elm$core$Maybe$Nothing;
            };
            return A2($elm$core$List$concatMap, function(license) {
                return $author$project$Components$TeamForm$validateLicenseFields({
                    adC: license.adC.a,
                    Ga: 'DEA',
                    Gx: license.Gx,
                    Gy: numberValidator,
                    Hu: true,
                    s4: license.s4,
                    aae: today,
                    $7: 6
                });
            }, fields.xa);
        } else return _List_Nil;
    });
    var $author$project$Components$TeamForm$DegreeValidation = 5;
    var $author$project$Components$TeamForm$validateDegree = F2(function(requiresDegree, fields) {
        if (requiresDegree && _Utils_eq(fields.Xm, $elm$core$Maybe$Just(0))) {
            var _v0 = A2($elm$core$Maybe$withDefault, '', fields.NG);
            if (_v0 === '') return _List_fromArray([
                _Utils_Tuple2(5, 'Please enter your degree.')
            ]);
            else return _List_Nil;
        } else return _List_Nil;
    });
    var $author$project$Components$TeamForm$EmrRoleValidation = 4;
    var $author$project$Components$TeamForm$validateEmrRole = F2(function(requiresEmrRole, fields) {
        return requiresEmrRole && $author$project$Utils$Maybe$isNothing(fields.ado) ? _List_fromArray([
            _Utils_Tuple2(4, 'Please select an EMR role.')
        ]) : _List_Nil;
    });
    var $author$project$Components$TeamForm$FirstNameValidation = 8;
    var $author$project$Components$TeamForm$validateFirstName = function(fields) {
        return $elm$core$String$isEmpty(fields.PN) ? _List_fromArray([
            _Utils_Tuple2(8, 'First name is required.')
        ]) : _List_Nil;
    };
    var $author$project$Components$TeamForm$LastNameValidation = 9;
    var $author$project$Components$TeamForm$validateLastName = function(fields) {
        return $elm$core$String$isEmpty(fields.SU) ? _List_fromArray([
            _Utils_Tuple2(9, 'Last name is required.')
        ]) : _List_Nil;
    };
    var $author$project$Components$TeamForm$NpiValidation = 1;
    var $author$project$Components$TeamForm$npiPrefix = '80840';
    var $author$project$Components$TeamForm$validateNpi = function(fields) {
        var npiValidationMessage = _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a valid NPI number.')
        ]);
        var _v0 = fields.U9;
        if (!_v0.$) {
            var npi = _v0.a;
            return $elm$core$String$length(npi) === 10 && $ahstro$elm_luhn$Luhn$isValid(_Utils_ap($author$project$Components$TeamForm$npiPrefix, npi)) ? _List_Nil : npiValidationMessage;
        } else {
            var requiresNpi = function() {
                var _v1 = fields.XK;
                if (!_v1.$) switch(_v1.a){
                    case 0:
                        var _v2 = _v1.a;
                        return true;
                    case 1:
                        var _v3 = _v1.a;
                        return true;
                    default:
                        var _v4 = _v1.a;
                        return false;
                }
                else return false;
            }();
            return requiresNpi ? npiValidationMessage : _List_Nil;
        }
    };
    var $author$project$Components$TeamForm$PrescriberTypeValidation = 0;
    var $author$project$Components$TeamForm$validatePrescriberType = F2(function(requiresPrescriberType, fields) {
        var _v0 = fields.Xm;
        if (!_v0.$) return _List_Nil;
        else return requiresPrescriberType ? _List_fromArray([
            _Utils_Tuple2(0, 'Please choose a prescriber type.')
        ]) : _List_Nil;
    });
    var $author$project$Components$TeamForm$ProviderStatusValidation = 3;
    var $author$project$Components$TeamForm$validateProviderStatus = function(fields) {
        var _v0 = fields.XK;
        if (_v0.$ === 1) return _List_fromArray([
            _Utils_Tuple2(3, 'Please select a care provider status.')
        ]);
        else return _List_Nil;
    };
    var $author$project$Components$TeamForm$StateLicenseValidation = 7;
    var $author$project$Components$TeamForm$validateStateLicenseFields = function(_v0) {
        var number = _v0.Gx;
        var state = _v0.s4;
        var expiration = _v0.adC;
        var today = _v0.aae;
        var isAlphanumeric = function(str) {
            return A2($elm$core$String$all, function(_char) {
                return $elm$core$Char$isAlphaNum(_char);
            }, str);
        };
        var numberValidator = function(licenseNumber) {
            return !isAlphanumeric(licenseNumber) ? $elm$core$Maybe$Just('State license numbers must contain only letters and numbers.') : $elm$core$Maybe$Nothing;
        };
        return $author$project$Components$TeamForm$validateLicenseFields({
            adC: expiration,
            Ga: 'state license',
            Gx: number,
            Gy: numberValidator,
            Hu: false,
            s4: state,
            aae: today,
            $7: 7
        });
    };
    var $author$project$Components$TeamForm$validateStateLicense = F3(function(requiresLicense, today, fields) {
        return requiresLicense && _Utils_eq(fields.Xm, $elm$core$Maybe$Just(0)) ? $elm$core$List$isEmpty(fields.CI) ? _List_fromArray([
            _Utils_Tuple2(7, 'Please add at least one state license.')
        ]) : A2($elm$core$List$concatMap, function(license) {
            return $author$project$Components$TeamForm$validateStateLicenseFields({
                adC: license.adC.a,
                Gx: license.Gx,
                s4: license.s4,
                aae: today
            });
        }, fields.CI) : _List_Nil;
    });
    var $author$project$Components$TeamForm$formFieldsValidator = F3(function(usingClinicalEmr, isOnboarding, today) {
        var validatePhone = function(_v0) {
            var phone = _v0.WE;
            return $author$project$Components$PhoneInput$hasErrors(phone) && usingClinicalEmr ? _List_fromArray([
                _Utils_Tuple2(11, '')
            ]) : _List_Nil;
        };
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateFirstName),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateLastName),
            A3($author$project$Utils$Validate$ifInvalidEmail, {
                abH: false
            }, A2($elm$core$Basics$composeR, function($) {
                return $.OH;
            }, $elm$core$Maybe$Just), _Utils_Tuple2(10, 'Please enter a valid email')),
            $rtfeldman$elm_validate$Validate$fromErrors(validatePhone),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateDateOfBirth(usingClinicalEmr)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateProviderStatus),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validatePrescriberType(usingClinicalEmr)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateNpi),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateEmrRole(usingClinicalEmr && !isOnboarding)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$TeamForm$validateDegree(usingClinicalEmr)),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$TeamForm$validateDeaNumbers, usingClinicalEmr, today)),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$TeamForm$validateStateLicense, usingClinicalEmr, today))
        ]));
    });
    var $author$project$Components$TeamForm$validate = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        var form_ = A2($author$project$Utils$Form$set, _Utils_update(fields, {
            WE: $author$project$Components$PhoneInput$validate(fields.WE)
        }), model.PU);
        return A2($elm$core$Result$mapError, function(validatedForm) {
            return _Utils_update(model, {
                PU: validatedForm
            });
        }, A2($elm$core$Result$map, function(_v1) {
            var validatedForm = _v1.a;
            var validFormFields = _v1.b;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: validatedForm
            }), validFormFields);
        }, A2($author$project$Utils$Form$validate, A3($author$project$Components$TeamForm$formFieldsValidator, model.dn, model.aK, model.aae), form_)));
    };
    var $author$project$Pages$Admin$Team$New$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$TeamForm$update, subMsg, model.PU, model.Ej);
                var teamFormModel = _v1.a;
                var teamFormCmd = _v1.b;
                var outMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: teamFormModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Admin$Team$New$TeamFormMsg, teamFormCmd), outMsgs);
            case 1:
                var _v2 = $author$project$Components$TeamForm$validate(model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validatedForm = _v3.a;
                    var validFormFields = _v3.b;
                    return $author$project$Pages$Admin$Team$New$shouldFetchProductPricing(validFormFields) ? _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm
                    }), $author$project$Pages$Admin$Team$New$fetchProductPricing(model), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Admin$Team$New$createTeamMember, model, validFormFields), _List_Nil);
                } else {
                    var erroredForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: erroredForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var _v4 = $author$project$Components$TeamForm$validate(model.PU);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var validatedForm = _v5.a;
                    var validFormFields = _v5.b;
                    return model.abC ? _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Admin$Team$New$createTeamMember, model, validFormFields), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else {
                    var erroredForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: erroredForm,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Team member created successfully')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var value = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    abC: value
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var pricing = response.a;
                    if ($author$project$Api$Provider$PracticePricing$Product$requiresPayment(pricing)) return _Utils_Tuple3(_Utils_update(model, {
                        nH: $author$project$Api$Provider$PracticePricing$Product$priceInCents(pricing),
                        nO: response,
                        oq: true
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                    else {
                        var _v8 = $author$project$Components$TeamForm$validate(model.PU);
                        if (!_v8.$) {
                            var _v9 = _v8.a;
                            var validatedForm = _v9.a;
                            var validFormFields = _v9.b;
                            return _Utils_Tuple3(_Utils_update(model, {
                                PU: validatedForm,
                                nH: $author$project$Api$Provider$PracticePricing$Product$priceInCents(pricing),
                                nO: response,
                                j_: $author$project$Api$Data$Loading,
                                oq: false
                            }), A2($author$project$Pages$Admin$Team$New$createTeamMember, model, validFormFields), _List_Nil);
                        } else {
                            var erroredForm = _v8.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                PU: erroredForm,
                                nO: response
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        }
                    }
                } else return _Utils_Tuple3(_Utils_update(model, {
                    nO: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 1, 'New team members cannot be added at this time. Please reach out to our Customer Success team to learn more.')
                ]));
        }
    });
    var $author$project$Pages$Admin$Team$New$CreateTeamMember = {
        $: 2
    };
    var $author$project$Pages$Admin$Team$New$FormSubmitted = {
        $: 1
    };
    var $author$project$Components$TeamForm$Email = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$TeamForm$FirstName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$TeamForm$LastName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$Invalid = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$invalid = $author$project$Ui$Form$Group$Invalid;
    var $author$project$Components$TeamForm$FullTimeProvider = 0;
    var $author$project$Components$TeamForm$NonProvider = 2;
    var $author$project$Components$TeamForm$PartTimeProvider = 1;
    var $author$project$Components$TeamForm$ProviderStatus = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$TeamForm$viewCareProviderStatusSelection = F2(function(form, fields) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(2),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Care Provider Status'),
            $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form))
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(fields.XK, $elm$core$Maybe$Just(0))),
                        $author$project$Ui$Form$Radio$inline,
                        $author$project$Ui$Form$Radio$onCheck(function(_v0) {
                            return $author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$ProviderStatus(0));
                        })
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$margin(0)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Full-Time Provider')
                        ])),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Sees patients 3 or more days a week')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(fields.XK, $elm$core$Maybe$Just(1))),
                        $author$project$Ui$Form$Radio$inline,
                        $author$project$Ui$Form$Radio$onCheck(function(_v1) {
                            return $author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$ProviderStatus(1));
                        })
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$margin(0)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Part-Time Provider')
                        ])),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Sees patients less than 3 days a week')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(_Utils_eq(fields.XK, $elm$core$Maybe$Just(2))),
                        $author$project$Ui$Form$Radio$inline,
                        $author$project$Ui$Form$Radio$onCheck(function(_v2) {
                            return $author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$ProviderStatus(2));
                        })
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Not a Provider')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Utils$Form$hasValidationErrors, 3, form) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$danger
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$String$join, ' ', A2($author$project$Utils$Form$validationErrors, 3, form)))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$TeamForm$AddDea = {
        $: 13
    };
    var $author$project$Components$TeamForm$DeaNumberAt = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$DeaStateAt = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$DeaStateSearchAt = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$RemoveDea = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Utils$State$list = _List_fromArray([
        _Utils_Tuple2('AL', 'Alabama'),
        _Utils_Tuple2('AK', 'Alaska'),
        _Utils_Tuple2('AZ', 'Arizona'),
        _Utils_Tuple2('AR', 'Arkansas'),
        _Utils_Tuple2('CA', 'California'),
        _Utils_Tuple2('CO', 'Colorado'),
        _Utils_Tuple2('CT', 'Connecticut'),
        _Utils_Tuple2('DE', 'Delaware'),
        _Utils_Tuple2('DC', 'District of Columbia'),
        _Utils_Tuple2('FL', 'Florida'),
        _Utils_Tuple2('GA', 'Georgia'),
        _Utils_Tuple2('HI', 'Hawaii'),
        _Utils_Tuple2('ID', 'Idaho'),
        _Utils_Tuple2('IL', 'Illinois'),
        _Utils_Tuple2('IN', 'Indiana'),
        _Utils_Tuple2('IA', 'Iowa'),
        _Utils_Tuple2('KS', 'Kansas'),
        _Utils_Tuple2('KY', 'Kentucky'),
        _Utils_Tuple2('LA', 'Louisiana'),
        _Utils_Tuple2('ME', 'Maine'),
        _Utils_Tuple2('MD', 'Maryland'),
        _Utils_Tuple2('MA', 'Massachusetts'),
        _Utils_Tuple2('MI', 'Michigan'),
        _Utils_Tuple2('MN', 'Minnesota'),
        _Utils_Tuple2('MS', 'Mississippi'),
        _Utils_Tuple2('MO', 'Missouri'),
        _Utils_Tuple2('MT', 'Montana'),
        _Utils_Tuple2('NE', 'Nebraska'),
        _Utils_Tuple2('NV', 'Nevada'),
        _Utils_Tuple2('NH', 'New Hampshire'),
        _Utils_Tuple2('NJ', 'New Jersey'),
        _Utils_Tuple2('NM', 'New Mexico'),
        _Utils_Tuple2('NY', 'New York'),
        _Utils_Tuple2('NC', 'North Carolina'),
        _Utils_Tuple2('ND', 'North Dakota'),
        _Utils_Tuple2('OH', 'Ohio'),
        _Utils_Tuple2('OK', 'Oklahoma'),
        _Utils_Tuple2('OR', 'Oregon'),
        _Utils_Tuple2('PA', 'Pennsylvania'),
        _Utils_Tuple2('PR', 'Puerto Rico'),
        _Utils_Tuple2('RI', 'Rhode Island'),
        _Utils_Tuple2('SC', 'South Carolina'),
        _Utils_Tuple2('SD', 'South Dakota'),
        _Utils_Tuple2('TN', 'Tennessee'),
        _Utils_Tuple2('TX', 'Texas'),
        _Utils_Tuple2('UT', 'Utah'),
        _Utils_Tuple2('VT', 'Vermont'),
        _Utils_Tuple2('VI', 'Virgin Islands'),
        _Utils_Tuple2('VA', 'Virginia'),
        _Utils_Tuple2('WA', 'Washington'),
        _Utils_Tuple2('WV', 'West Virginia'),
        _Utils_Tuple2('WI', 'Wisconsin'),
        _Utils_Tuple2('WY', 'Wyoming')
    ]);
    var $author$project$Utils$State$codes = A2($elm$core$List$map, $elm$core$Tuple$first, $author$project$Utils$State$list);
    var $author$project$Components$DateInput$Position = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$DateInput$above = $author$project$Components$DateInput$Position(1);
    var $author$project$Components$DateInput$Placeholder = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$DateInput$placeholder = $author$project$Components$DateInput$Placeholder;
    var $author$project$Components$TeamForm$viewExpirationDateInput = function(_v0) {
        var placeholder = _v0.r7;
        var value = _v0.aa9;
        var dateInputModel = _v0.E7;
        var today = _v0.aae;
        var hasValidationErrors = _v0.FK;
        var toMsg = _v0.ahX;
        return A2($elm$html$Html$map, toMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
            $author$project$Components$DateInput$placeholder(placeholder),
            $author$project$Components$DateInput$value(value),
            $author$project$Components$DateInput$above,
            $author$project$Components$DateInput$disabledPickerDates(function(date) {
                return A2($author$project$Utils$Date$isBefore, date, today);
            }),
            $author$project$Components$DateInput$invalid(hasValidationErrors)
        ]), dateInputModel));
    };
    var $author$project$Components$TeamForm$viewLicenseRow = F5(function(config, form, today, index, license) {
        var toStateOption = function(abbr) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$TeamForm$FormUpdated(A2(config.z1, index, abbr))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(license.s4, $elm$core$Maybe$Just(abbr)))
            ]), $elm$html$Html$text(abbr));
        };
        var searchInput = $author$project$Ui$Dropdown$input(_List_fromArray([
            $author$project$Ui$Dropdown$onInput(A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, config.z0(index))),
            $author$project$Ui$Dropdown$value(license.bG),
            $author$project$Ui$Dropdown$placeholder('Search states...')
        ]));
        var inputAttributes = A2($elm$core$List$cons, $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', license.Gx)), A2($elm$core$List$cons, $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, config.zY(index))), A2($elm$core$List$cons, $author$project$Ui$Form$Input$placeholder(config.zQ), config.yi ? _List_fromArray([
            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, config.$7, form))
        ]) : _List_Nil)));
        var contains = function(state) {
            return A2($elm$core$String$contains, $elm$core$String$toLower(license.bG), $elm$core$String$toLower(state));
        };
        var filteredStates = A2($elm$core$List$filter, contains, $author$project$Utils$State$codes);
        var dropdownOptions = A2($elm$core$List$cons, searchInput, A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toStateOption, filteredStates)));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(4)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(inputAttributes)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(3)
            ]), _List_fromArray([
                A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                    $author$project$Ui$Dropdown$invalid(A2($author$project$Utils$Form$hasValidationErrors, config.$7, form))
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'State', license.s4))
                ]), dropdownOptions, license.bk)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(5)
            ]), _List_fromArray([
                index > 0 ? A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mr2,
                        $author$project$Ui$Element$flexAuto
                    ]), _List_fromArray([
                        $author$project$Components$TeamForm$viewExpirationDateInput({
                            E7: license.adC.b,
                            FK: A2($author$project$Utils$Form$hasValidationErrors, config.$7, form),
                            r7: 'Expiration Date',
                            ahX: config.qD(index),
                            aae: today,
                            aa9: license.adC.a
                        })
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: config.BI
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$TeamForm$FormUpdated(config.z$(index))),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                        $author$project$Ui$Button$margin(11),
                        $author$project$Ui$Button$link
                    ]), _List_Nil)
                ])) : $author$project$Components$TeamForm$viewExpirationDateInput({
                    E7: license.adC.b,
                    FK: A2($author$project$Utils$Form$hasValidationErrors, config.$7, form),
                    r7: 'Expiration Date',
                    ahX: config.qD(index),
                    aae: today,
                    aa9: license.adC.a
                })
            ]))
        ]));
    });
    var $author$project$Components$TeamForm$viewDeaRow = F4(function(form, today, index, license) {
        return A5($author$project$Components$TeamForm$viewLicenseRow, {
            qD: $author$project$Components$TeamForm$MultiDeaExpirationMsg,
            yi: true,
            zQ: 'AB1234567',
            zY: $author$project$Components$TeamForm$DeaNumberAt,
            z$: $author$project$Components$TeamForm$RemoveDea,
            z0: $author$project$Components$TeamForm$DeaStateSearchAt,
            z1: $author$project$Components$TeamForm$DeaStateAt,
            BI: 'Remove DEA',
            $7: 6
        }, form, today, index, license);
    });
    var $author$project$Components$TeamForm$viewDeaFields = F4(function(usingClinicalEmr, form, fields, today) {
        var showDea = _Utils_eq(fields.Xm, $elm$core$Maybe$Just(0));
        return usingClinicalEmr && showDea ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(2),
            $author$project$Ui$Form$Group$inputSpanSm(10),
            $author$project$Ui$Form$Group$label('DEA Number'),
            $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 6, form))
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$indexedMap, A2($author$project$Components$TeamForm$viewDeaRow, form, today), fields.xa)),
            A2($author$project$Utils$Form$hasValidationErrors, 6, form) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$danger
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$String$join, ' ', A2($author$project$Utils$Form$validationErrors, 6, form)))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$margin(8)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Add another DEA Number'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$AddDea)),
                    $author$project$Ui$Button$link
                ]), _List_fromArray([
                    $elm$html$Html$text('Add another DEA number')
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$TeamForm$Degree = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$TeamForm$viewDegreeField = F3(function(usingClinicalEmr, form, fields) {
        var showDegree = _Utils_eq(fields.Xm, $elm$core$Maybe$Just(0));
        return usingClinicalEmr && showDegree ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(2),
            $author$project$Ui$Form$Group$inputSpanSm(10),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Degree')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.NG)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$Degree)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 5, form))
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$helpText,
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('This information will appear with e-signatures exactly as entered.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$TeamForm$DateOfBirth = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$TeamForm$viewDobField = F3(function(usingClinicalEmr, form, fields) {
        return usingClinicalEmr ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(2),
            $author$project$Ui$Form$Group$inputSpanSm(10),
            $author$project$Ui$Form$Group$label('Date of Birth'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
                A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$TeamForm$datePattern, A2($elm$core$Maybe$withDefault, '', fields.M7)),
                A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Components$TeamForm$datePattern, A2($elm$core$Maybe$withDefault, '', fields.M7), A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$DateOfBirth)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$helpText,
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('Date of birth is required for access to prescription information.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$TeamForm$EmrRole = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Utils$EmrRole$all = _List_fromArray([
        0,
        1,
        2
    ]);
    var $author$project$Utils$EmrRole$toDisplayString = function(role) {
        switch(role){
            case 0:
                return 'Admin';
            case 1:
                return 'Provider';
            default:
                return 'Staff';
        }
    };
    var $author$project$Components$TeamForm$viewEmrRoleField = F4(function(isOnboarding, form, fields, emrRoleDropdown) {
        if (!isOnboarding) {
            var selectedRole = A2($elm$core$Maybe$withDefault, 'Select a role', A2($elm$core$Maybe$map, $author$project$Utils$EmrRole$toDisplayString, fields.ado));
            var roleOptions = A2($elm$core$List$map, function(role) {
                return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$EmrRole($author$project$Utils$EmrRole$toString(role))))
                ]), $elm$html$Html$text($author$project$Utils$EmrRole$toDisplayString(role)));
            }, $author$project$Utils$EmrRole$all);
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(2),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('EMR Role'),
                $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, form))
            ]), _List_fromArray([
                A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                    $author$project$Ui$Dropdown$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, form))
                ]), _List_fromArray([
                    $elm$html$Html$text(selectedRole)
                ]), roleOptions, emrRoleDropdown),
                A2($author$project$Utils$Form$hasValidationErrors, 4, form) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$danger
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$String$join, ' ', A2($author$project$Utils$Form$validationErrors, 4, form)))
                ])) : $author$project$Utils$Html$empty
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$TeamForm$Npi = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$TeamForm$viewNpiField = F2(function(form, fields) {
        var showNpi = function() {
            var _v0 = fields.XK;
            if (!_v0.$) {
                if (_v0.a === 2) {
                    var _v1 = _v0.a;
                    return false;
                } else return true;
            } else return false;
        }();
        return showNpi ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(2),
            $author$project$Ui$Form$Group$inputSpanSm(10),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('NPI')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.U9)),
                $author$project$Ui$Form$Input$placeholder('1234567890'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$Npi)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$TeamForm$PrescriberTypeField = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$list = _List_fromArray([
        0,
        1,
        2,
        3
    ]);
    var $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toString = function(prescriberType) {
        switch(prescriberType){
            case 0:
                return 'Prescriber';
            case 1:
                return 'Prescribe on Behalf of (No Review Required, Non-Controlled Substances Only)';
            case 2:
                return 'Prescribe on Behalf of (Review Required, Non-Controlled Substances Only)';
            default:
                return 'Staff';
        }
    };
    var $author$project$Components$TeamForm$prescriberTypeOptions = function(currentProviderStatus) {
        var options = A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$PracticeOnboarding$PrescriberType$list, A2($elm$core$Maybe$map, function(providerStatus) {
            return providerStatus === 2 ? A2($elm$core$List$filter, function(prescriberType) {
                return !$author$project$Api$Provider$PracticeOnboarding$PrescriberType$isProvider(prescriberType);
            }, $author$project$Api$Provider$PracticeOnboarding$PrescriberType$list) : $author$project$Api$Provider$PracticeOnboarding$PrescriberType$list;
        }, currentProviderStatus));
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Select a Prescriber Type'), A2($elm$core$List$map, function(prescriberType) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam(prescriberType)), $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toString(prescriberType));
        }, options));
    };
    var $author$project$Components$TeamForm$viewPrescriberTypeField = F3(function(usingClinicalEmr, form, fields) {
        var providerStatusSelected = function() {
            var _v0 = fields.XK;
            if (!_v0.$) return true;
            else return false;
        }();
        if (usingClinicalEmr && providerStatusSelected) {
            var prescriberTypeValue = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$PrescriberType$toParam, fields.Xm));
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(2),
                $author$project$Ui$Form$Group$required(usingClinicalEmr),
                $author$project$Ui$Form$Group$label('Prescriber Type')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(prescriberTypeValue)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$TeamForm$FormUpdated, $author$project$Components$TeamForm$PrescriberTypeField)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]), $author$project$Components$TeamForm$prescriberTypeOptions(fields.XK))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$TeamForm$AddStateLicense = {
        $: 20
    };
    var $author$project$Components$TeamForm$RemoveStateLicense = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$TeamForm$StateLicenseNumberAt = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$StateLicenseStateAt = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$StateLicenseStateSearchAt = F2(function(a, b) {
        return {
            $: 23,
            a: a,
            b: b
        };
    });
    var $author$project$Components$TeamForm$viewStateLicenseRow = F4(function(form, today, index, license) {
        return A5($author$project$Components$TeamForm$viewLicenseRow, {
            qD: $author$project$Components$TeamForm$StateLicenseExpirationMsg,
            yi: false,
            zQ: 'A12345',
            zY: $author$project$Components$TeamForm$StateLicenseNumberAt,
            z$: $author$project$Components$TeamForm$RemoveStateLicense,
            z0: $author$project$Components$TeamForm$StateLicenseStateSearchAt,
            z1: $author$project$Components$TeamForm$StateLicenseStateAt,
            BI: 'Remove state license',
            $7: 7
        }, form, today, index, license);
    });
    var $author$project$Components$TeamForm$viewStateLicenseFields = F4(function(usingClinicalEmr, form, fields, today) {
        var showStateLicense = _Utils_eq(fields.Xm, $elm$core$Maybe$Just(0));
        return usingClinicalEmr && showStateLicense ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(2),
            $author$project$Ui$Form$Group$inputSpanSm(10),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('State License'),
            $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 7, form))
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$indexedMap, A2($author$project$Components$TeamForm$viewStateLicenseRow, form, today), fields.CI)),
            A2($author$project$Utils$Form$hasValidationErrors, 7, form) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$danger
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$String$join, ' ', A2($author$project$Utils$Form$validationErrors, 7, form)))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$margin(8)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Add another state license'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$AddStateLicense)),
                    $author$project$Ui$Button$link
                ]), _List_fromArray([
                    $elm$html$Html$text('Add another state license')
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$TeamForm$viewForm = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(2),
                $author$project$Ui$Form$Group$inputSpanSm(10),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 8, model.PU) || A2($author$project$Utils$Form$hasValidationErrors, 9, model.PU))
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(fields.PN),
                            $author$project$Ui$Form$Input$disabled(model.aK),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 8, model.PU)),
                            $author$project$Ui$Form$Input$onInput(function(newFirstName) {
                                return $author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$FirstName(newFirstName));
                            }),
                            $author$project$Ui$Form$Input$placeholder('First Name')
                        ])),
                        A2($author$project$Utils$Form$hasValidationErrors, 8, model.PU) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$danger
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$String$join, ' ', A2($author$project$Utils$Form$validationErrors, 8, model.PU)))
                        ])) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(fields.SU),
                            $author$project$Ui$Form$Input$disabled(model.aK),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 9, model.PU)),
                            $author$project$Ui$Form$Input$onInput(function(newLastName) {
                                return $author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$LastName(newLastName));
                            }),
                            $author$project$Ui$Form$Input$placeholder('Last Name')
                        ])),
                        A2($author$project$Utils$Form$hasValidationErrors, 9, model.PU) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$danger
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$String$join, ' ', A2($author$project$Utils$Form$validationErrors, 9, model.PU)))
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(2),
                $author$project$Ui$Form$Group$inputSpanSm(10),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Email'),
                $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 10, model.PU))
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.OH),
                    $author$project$Ui$Form$Input$disabled(model.aK),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 10, model.PU)),
                    $author$project$Ui$Form$Input$onInput(function(newEmail) {
                        return $author$project$Components$TeamForm$FormUpdated($author$project$Components$TeamForm$Email(newEmail));
                    })
                ])),
                A2($author$project$Utils$Form$hasValidationErrors, 10, model.PU) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$danger
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$String$join, ' ', A2($author$project$Utils$Form$validationErrors, 10, model.PU)))
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(2),
                $author$project$Ui$Form$Group$inputSpanSm(10),
                $author$project$Ui$Form$Group$required(model.dn),
                $author$project$Ui$Form$Group$label('Phone'),
                $author$project$Ui$Form$Group$invalid($author$project$Components$PhoneInput$hasErrors(fields.WE))
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$TeamForm$PhoneInputMsg, $author$project$Components$PhoneInput$view(fields.WE))
            ])),
            A3($author$project$Components$TeamForm$viewDobField, model.dn, model.PU, fields),
            A2($author$project$Components$TeamForm$viewCareProviderStatusSelection, model.PU, fields),
            A4($author$project$Components$TeamForm$viewEmrRoleField, model.aK, model.PU, fields, model.qu),
            A3($author$project$Components$TeamForm$viewPrescriberTypeField, model.dn, model.PU, fields),
            A4($author$project$Components$TeamForm$viewStateLicenseFields, model.dn, model.PU, fields, model.aae),
            A4($author$project$Components$TeamForm$viewDeaFields, model.dn, model.PU, fields, model.aae),
            A3($author$project$Components$TeamForm$viewDegreeField, model.dn, model.PU, fields),
            A2($author$project$Components$TeamForm$viewNpiField, model.PU, fields)
        ]));
    };
    var $author$project$Components$TeamForm$view = function(_v0) {
        var model = _v0;
        return $author$project$Components$TeamForm$viewForm(model);
    };
    var $author$project$Ui$Margin$Bottom_10 = 4;
    var $author$project$Ui$Element$m0 = $author$project$Ui$Element$Margin('m-0');
    var $author$project$Ui$Grid$m0 = $author$project$Ui$Grid$Element($author$project$Ui$Element$m0);
    var $author$project$Ui$HorizontalRule$Separator = 3;
    var $author$project$Ui$HorizontalRule$separator = $author$project$Ui$HorizontalRule$Style(3);
    var $author$project$Pages$Admin$Team$New$AgreedToTerms = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Admin$Team$New$viewAdditionalInfoFooter = A2($author$project$Ui$Typography$p, _List_fromArray([
        $author$project$Ui$Typography$muted
    ]), _List_fromArray([
        $elm$html$Html$text('Have any questions? '),
        A3($author$project$Ui$Link$externalHref, 'mailto:sales@hint.com', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('Contact our sales team')
        ])),
        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text(' or')
        ])),
        A3($author$project$Ui$Link$externalHref, 'https://www.hint.com/clinical/pricing', _List_fromArray([
            $author$project$Ui$Link$margin(11),
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('view our pricing information')
        ])),
        $elm$html$Html$text(' on our website.')
    ]));
    var $author$project$Pages$Admin$Team$New$viewConfirmationCheckbox = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(model.abC),
                $author$project$Ui$Form$Checkbox$required(true),
                $author$project$Ui$Form$Checkbox$onCheck(function(value) {
                    return $author$project$Pages$Admin$Team$New$AgreedToTerms(value);
                })
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flexMd
                ]), _List_fromArray([
                    $elm$html$Html$text('I agree to these changes, subject to the previously agreed upon terms of service.'),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]), _List_fromArray([
                        $elm$html$Html$text('*')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$margin(8)
            ]), _List_fromArray([
                $author$project$Pages$Admin$Team$New$viewAdditionalInfoFooter
            ]))
        ]));
    };
    var $author$project$Pages$Admin$Team$New$viewPricing = function(model) {
        var _v0 = $author$project$Components$TeamForm$validate(model.PU);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var validFormFields = _v1.b;
            var fields = $author$project$Components$TeamForm$teamMemberFormFields($rtfeldman$elm_validate$Validate$fromValid(validFormFields));
            var clinicianName = fields.PN + (' ' + fields.SU);
            return A3($author$project$Ui$Element$custom, 'h-[80vh]', _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$flexCol
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(7)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mb2,
                            $author$project$Ui$Element$mt4
                        ]), _List_fromArray([
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Add ' + clinicianName)
                            ]))
                        ])),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('You are at the clinician limit for your current plan.')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(5),
                        $author$project$Ui$Grid$m0
                    ]), _List_fromArray([
                        A3($author$project$Ui$Alert$view, 1, _List_fromArray([
                            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt2
                            ]), _List_fromArray([
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanSm(9)
                                    ]), _List_fromArray([
                                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                                            $elm$html$Html$text('Additional Clinician')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanSm(3),
                                        $author$project$Ui$Grid$justifyRight
                                    ]), _List_fromArray([
                                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromIntNoDecimals(model.nH) + '/mo')
                                        ]))
                                    ]))
                                ])),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                A2($author$project$Ui$Grid$row, _List_fromArray([
                                    $author$project$Ui$Grid$mb4
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanSm(9)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$black
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Added to your next invoice')
                                        ])),
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$black,
                                            $author$project$Ui$Typography$margin(4)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Due today')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanSm(3)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(model.nH))
                                        ])),
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight),
                                            $author$project$Ui$Typography$margin(4)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(0))
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mt2
                        ]), _List_fromArray([
                            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                                $author$project$Ui$HorizontalRule$margin(19),
                                $author$project$Ui$HorizontalRule$separator
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        $author$project$Pages$Admin$Team$New$viewConfirmationCheckbox(model)
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Admin$Team$New$view = function(model) {
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Add Team Member')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            model.oq ? $author$project$Pages$Admin$Team$New$viewPricing(model) : A2($elm$html$Html$map, $author$project$Pages$Admin$Team$New$TeamFormMsg, $author$project$Components$TeamForm$view(model.PU))
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            model.oq ? A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt4
                            ]), _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Agree and save'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$primary,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$New$CreateTeamMember),
                                    $author$project$Ui$Button$loading(loading),
                                    $author$project$Ui$Button$disabled(!model.abC)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Agree & Save')
                                ]))
                            ])) : A3($author$project$Ui$Button$view, {
                                abP: 'Save new team member'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$loading(loading),
                                $author$project$Ui$Button$onClick($author$project$Pages$Admin$Team$New$FormSubmitted)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Save')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'New Team Member'
        };
    };
    var $author$project$Pages$Admin$Team$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Admin$Team$New$init,
        aeR: $author$project$Pages$Admin$Team$New$load,
        ag3: $author$project$Pages$Admin$Team$New$save,
        ahE: $author$project$Pages$Admin$Team$New$subscriptions,
        aaO: $author$project$Pages$Admin$Team$New$update,
        aid: $author$project$Pages$Admin$Team$New$view
    });
    var $author$project$Pages$AffiliateBills$Top$BillsListMsg = $elm$core$Basics$identity;
    var $author$project$Components$Affiliates$BillsList$DateRangeInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Affiliates$BillsList$GotNetwork = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $justinmimbs$date$Date$Month = 2;
    var $author$project$Utils$DateWithDefault$toDate = F3(function(currentDate, monthOffset, dateWithDefault) {
        var startOfMonth = A3($justinmimbs$date$Date$add, 1, monthOffset, A2($justinmimbs$date$Date$floor, 2, currentDate));
        switch(dateWithDefault.$){
            case 0:
                var date = dateWithDefault.a;
                return date;
            case 1:
                return startOfMonth;
            default:
                return A3($justinmimbs$date$Date$add, 3, -1, A3($justinmimbs$date$Date$add, 1, 1, startOfMonth));
        }
    });
    var $author$project$Utils$DateWithDefault$toQuery = F3(function(currentDate, monthOffset, dateWithDefault) {
        return $author$project$Utils$Date$toQuery(A3($author$project$Utils$DateWithDefault$toDate, currentDate, monthOffset, dateWithDefault));
    });
    var $author$project$Components$Affiliates$BillsList$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn)
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString(model.Gc)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Components$DateRangeInput$defaultSettings = {
        kW: function(_v0) {
            return _List_Nil;
        },
        vt: false,
        w4: _List_fromArray([
            $author$project$Ui$Grid$spanSm(4),
            $author$project$Ui$Grid$span(6)
        ]),
        ad1: $elm$core$Maybe$Nothing,
        FD: false,
        FF: false,
        Gn: 0,
        Go: -11,
        ahV: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$Affiliates$BillsList$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Affiliates$BillsList$GotAffiliateBills = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliate$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Affiliate$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Affiliate$Shared$id(shared);
    };
    var $author$project$Api$Provider$AffiliateBill$affiliateBillsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'affiliate_bills'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$AffiliateBill$All$AffiliateBill = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Invoice$Shared$Invoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Invoice$Min$Invoice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Invoice$Min$Record = F2(function(id, invoiceNumber) {
        return {
            aef: id,
            RK: invoiceNumber
        };
    });
    var $author$project$Api$Provider$Invoice$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Min$Record)));
    var $author$project$Api$Provider$Invoice$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Invoice$Shared$Record = F7(function(invoiceDate, humanStatus, amountInCents, paidAt, paidInCents, dueInCents, dueDate) {
        return {
            Jh: amountInCents,
            Ok: dueDate,
            Ol: dueInCents,
            QX: humanStatus,
            RG: invoiceDate,
            VQ: paidAt,
            VR: paidInCents
        };
    });
    var $author$project$Api$Invoice$Status$BadDebt = {
        $: 4
    };
    var $author$project$Api$Invoice$Status$Cancelled = {
        $: 5
    };
    var $author$project$Api$Invoice$Status$Disputed = {
        $: 3
    };
    var $author$project$Api$Invoice$Status$Draft = {
        $: 0
    };
    var $author$project$Api$Invoice$Status$Issued = {
        $: 1
    };
    var $author$project$Api$Invoice$Status$Other = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Invoice$Status$Overdue = {
        $: 6
    };
    var $author$project$Api$Invoice$Status$Paid = {
        $: 2
    };
    var $author$project$Api$Invoice$Status$Sent = {
        $: 8
    };
    var $author$project$Api$Invoice$Status$Viewed = {
        $: 7
    };
    var $author$project$Api$Invoice$Status$decode = A2($elm$json$Json$Decode$map, function(string) {
        switch(string){
            case 'draft':
                return $author$project$Api$Invoice$Status$Draft;
            case 'issued':
                return $author$project$Api$Invoice$Status$Issued;
            case 'paid':
                return $author$project$Api$Invoice$Status$Paid;
            case 'disputed':
                return $author$project$Api$Invoice$Status$Disputed;
            case 'bad_debt':
                return $author$project$Api$Invoice$Status$BadDebt;
            case 'cancelled':
                return $author$project$Api$Invoice$Status$Cancelled;
            case 'overdue':
                return $author$project$Api$Invoice$Status$Overdue;
            case 'viewed':
                return $author$project$Api$Invoice$Status$Viewed;
            case 'sent':
                return $author$project$Api$Invoice$Status$Sent;
            default:
                return $author$project$Api$Invoice$Status$Other(string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Invoice$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $author$project$Api$Invoice$Status$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Shared$Record))))))));
    var $author$project$Api$Provider$Invoice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$Shared$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Shared$Invoice)));
    var $author$project$Api$Provider$AffiliateBill$All$Record = F4(function(numberOfDependents, numberOfEmployees, affiliate, practice) {
        return {
            Eb: affiliate,
            Vb: numberOfDependents,
            Vc: numberOfEmployees,
            W1: practice
        };
    });
    var $author$project$Api$Provider$Affiliate$Shared$Affiliate = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Affiliate$Shared$Record = F3(function(id, name, status) {
        return {
            aef: id,
            zr: name,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Affiliate$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$Shared$Record))));
    var $author$project$Api$Provider$Affiliate$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliate$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$AffiliateBill$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Provider$Practice$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate', $author$project$Api$Provider$Affiliate$Shared$decoder, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt, _List_fromArray([
        'summary',
        'active_lines',
        'totals',
        'count'
    ]), $elm$json$Json$Decode$int, 0, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt, _List_fromArray([
        'summary',
        'active_lines',
        'totals',
        'number_of_dependents'
    ]), $elm$json$Json$Decode$int, 0, $elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateBill$All$Record)))));
    var $author$project$Api$Provider$AffiliateBill$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$AffiliateBill$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateBill$All$AffiliateBill)));
    var $author$project$Api$Param$Date = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Param$date = $author$project$Api$Param$Date;
    var $author$project$Api$Provider$AffiliateBill$listDefaults = {
        Eb: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$AffiliateBill$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$AffiliateBill$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Eb;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'affiliate', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.HB;
                if (!_v1.$) {
                    var start_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fn;
                if (!_v2.$) {
                    var end_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$AffiliateBill$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateBill$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$AffiliateBill$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$AffiliateBill$affiliateBillsPath)));
    });
    var $author$project$Components$Affiliates$BillsList$fetchAffiliateBills = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$AffiliateBill$list, apiClient, function(d) {
            return _Utils_update(d, {
                Eb: A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliate$One$id, model.Eb),
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af_: model.af_,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        }, $author$project$Components$Affiliates$BillsList$GotAffiliateBills);
    });
    var $author$project$Utils$DateWithDefault$DefaultEnd = {
        $: 2
    };
    var $author$project$Utils$DateWithDefault$Date = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Utils$Date$fromIsoString = function(string) {
        return $elm$core$Result$toMaybe($justinmimbs$date$Date$fromIsoString(string));
    };
    var $author$project$Utils$DateWithDefault$fromString = F2(function(_default, string) {
        if (string === 'default') return $elm$core$Maybe$Just(_default);
        else return A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$Date, $author$project$Utils$Date$fromIsoString(string));
    });
    var $author$project$Utils$DateWithDefault$endFromQuery = function(query) {
        return A2($elm$core$Maybe$andThen, $author$project$Utils$DateWithDefault$fromString($author$project$Utils$DateWithDefault$DefaultEnd), A2($elm$core$Dict$get, 'end', query));
    };
    var $author$project$Utils$DateWithDefault$DefaultStart = {
        $: 1
    };
    var $author$project$Utils$DateWithDefault$startFromQuery = function(query) {
        return A2($elm$core$Maybe$andThen, $author$project$Utils$DateWithDefault$fromString($author$project$Utils$DateWithDefault$DefaultStart), A2($elm$core$Dict$get, 'start', query));
    };
    var $author$project$Utils$DateWithDefault$fromQuery = function(query) {
        return _Utils_Tuple2($author$project$Utils$DateWithDefault$startFromQuery(query), $author$project$Utils$DateWithDefault$endFromQuery(query));
    };
    var $author$project$Components$DateRangeInput$DropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$DateRangeInput$FromDatePickerMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$DateRangeInput$GotCurrentDate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$DateRangeInput$Model = $elm$core$Basics$identity;
    var $author$project$Components$DateRangeInput$ToDatePickerMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$DateRangeInput$init = F2(function(id, settings) {
        var _v0 = $agustinrhcp$elm_datepicker$DatePicker$init;
        var toDatePicker = _v0.a;
        var toDatePickerCmd = _v0.b;
        var _v1 = $agustinrhcp$elm_datepicker$DatePicker$init;
        var fromDatePicker = _v1.a;
        var fromDatePickerCmd = _v1.b;
        return _Utils_Tuple2({
            kW: $elm$core$Dict$empty,
            cP: $elm$core$Maybe$Nothing,
            fD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: id + '-date-range-dropdown',
                ahX: $author$project$Components$DateRangeInput$DropdownMsg
            })),
            ad1: $elm$core$Maybe$Nothing,
            qN: fromDatePicker,
            Gp: $elm$core$Dict$empty,
            z9: _List_Nil,
            gK: $elm$core$Maybe$Nothing,
            cr: settings,
            ahV: $elm$core$Maybe$Nothing,
            tr: toDatePicker
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$DateRangeInput$FromDatePickerMsg, fromDatePickerCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$DateRangeInput$ToDatePickerMsg, toDatePickerCmd),
            A2($elm$core$Task$perform, $author$project$Components$DateRangeInput$GotCurrentDate, $justinmimbs$date$Date$today)
        ])));
    });
    var $author$project$Api$Provider$Network$One$Network = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Network$One$Record = function(defaultSource) {
        return {
            ND: defaultSource
        };
    };
    var $author$project$Api$Provider$Network$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Network$One$Record));
    var $author$project$Api$Provider$Network$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Network$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Network$networkPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'network'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Network$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Network$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Network$networkPath));
    });
    var $author$project$Components$Affiliates$BillsList$init = function(config) {
        var _v0 = $author$project$Utils$DateWithDefault$fromQuery(config.Bz);
        var start = _v0.a;
        var end = _v0.b;
        var _v1 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Affiliates$BillsList$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, config.cP, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, config.cP, 0), end)));
        var dateRangeInput = _v1.a;
        var dateRangeInputCmd = _v1.b;
        var model = {
            Eb: config.Eb,
            hv: $author$project$Api$Data$Loading,
            vU: $author$project$Utils$Maybe$toBool(config.Eb),
            cP: config.cP,
            h6: dateRangeInput,
            Fn: end,
            Gc: config.Gc,
            UK: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(config.Bz),
            ahs: $author$project$Api$Sort$initFromQuery(config.Bz),
            HB: start,
            HO: config.HO
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$BillsList$DateRangeInputMsg, dateRangeInputCmd),
            $author$project$Utils$Maybe$toBool(config.Eb) ? $elm$core$Platform$Cmd$none : A2($author$project$Api$Provider$Network$retrieve, config.Ej, $author$project$Components$Affiliates$BillsList$GotNetwork),
            A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, config.Ej, model),
            $author$project$Ports$Navigation$replaceUrl($author$project$Components$Affiliates$BillsList$buildUrl(model))
        ])));
    };
    var $author$project$Pages$AffiliateBills$Top$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var _v3 = $author$project$Components$Affiliates$BillsList$init({
            Eb: $elm$core$Maybe$Nothing,
            Ej: shared.Ej,
            cP: shared.cP,
            Gc: $author$project$Spa$Generated$Route$AffiliateBills__Top,
            Bz: query,
            HO: shared.HO
        });
        var billsList = _v3.a;
        var billsListCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: billsList
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, billsListCmd));
    });
    var $author$project$Pages$AffiliateBills$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$AffiliateBills$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$DateRangeInput$subscriptions = function(_v0) {
        var model = _v0;
        return $author$project$Ui$Dropdown$subscriptions(model.fD);
    };
    var $author$project$Components$Affiliates$BillsList$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Components$Affiliates$BillsList$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6));
    };
    var $author$project$Pages$AffiliateBills$Top$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Affiliates$BillsList$subscriptions(model.rk));
    };
    var $author$project$Utils$DateWithDefault$fromDate = $author$project$Utils$DateWithDefault$Date;
    var $author$project$Components$DateRangeInput$None = {
        $: 0
    };
    var $author$project$Components$DateRangeInput$buildAdditionalItemOption = function(additionalItem_) {
        return _Utils_Tuple2(additionalItem_.aef, _Utils_Tuple3(additionalItem_.aeI, additionalItem_.HB, additionalItem_.Fn));
    };
    var $author$project$Components$DateRangeInput$buildAdditionalItems = function(additionalItems) {
        return $elm$core$Dict$fromList(A2($elm$core$List$map, $author$project$Components$DateRangeInput$buildAdditionalItemOption, additionalItems));
    };
    var $author$project$Components$DateRangeInput$customId = 'custom';
    var $author$project$Components$DateRangeInput$buildCustomItem = F2(function(startDate, endDate) {
        return {
            Fn: endDate,
            aef: $author$project$Components$DateRangeInput$customId,
            aeI: 'Custom',
            HB: startDate
        };
    });
    var $author$project$Components$DateRangeInput$OptionSelected = F3(function(a, b, c) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$DateRangeInput$buildEvent = F4(function(model, fromDate, toDate, label) {
        return _Utils_eq(model.ad1, fromDate) && _Utils_eq(model.ahV, toDate) ? $author$project$Components$DateRangeInput$None : A3($author$project$Components$DateRangeInput$OptionSelected, fromDate, toDate, label);
    });
    var $author$project$Components$DateRangeInput$buildMonthItem = function(_v0) {
        var id = _v0.a;
        var _v1 = _v0.b;
        var label = _v1.a;
        var monthStart = _v1.b;
        var monthEnd = _v1.c;
        return {
            Fn: monthEnd,
            aef: id,
            aeI: label,
            HB: monthStart
        };
    };
    var $author$project$Components$DateRangeInput$buildMonthOptions = F2(function(monthRanges, additionalItems) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                {
                    Fn: $elm$core$Maybe$Nothing,
                    aef: $author$project$Components$DateRangeInput$customId,
                    aeI: 'Custom',
                    HB: $elm$core$Maybe$Nothing
                }
            ]),
            A2($elm$core$List$map, function(_v0) {
                var id = _v0.a;
                var _v1 = _v0.b;
                var label = _v1.a;
                var start = _v1.b;
                var end = _v1.c;
                return {
                    Fn: end,
                    aef: id,
                    aeI: label,
                    HB: start
                };
            }, $elm$core$Dict$toList(additionalItems)),
            A2($elm$core$List$map, function(_v6) {
                var id = _v6.a;
                var _v7 = _v6.b;
                var label = _v7.a;
                var start = _v7.b;
                var end = _v7.c;
                return {
                    Fn: $elm$core$Maybe$Just(end),
                    aef: id,
                    aeI: label,
                    HB: $elm$core$Maybe$Just(start)
                };
            }, $elm$core$List$reverse(A2($elm$core$List$sortWith, F2(function(_v2, _v4) {
                var _v3 = _v2.b;
                var fromDate = _v3.b;
                var _v5 = _v4.b;
                var otherFromDate = _v5.b;
                return A2($justinmimbs$date$Date$compare, fromDate, otherFromDate);
            }), $elm$core$Dict$toList(monthRanges))))
        ]));
    });
    var $author$project$Components$DateRangeInput$buildMonthRange = F2(function(startMonth, index) {
        var monthStart = A3($justinmimbs$date$Date$add, 1, index, startMonth);
        var monthId = A2($justinmimbs$date$Date$format, 'MMMM yyyy', monthStart);
        var monthEnd = A3($justinmimbs$date$Date$add, 3, -1, A3($justinmimbs$date$Date$add, 1, 1, monthStart));
        return _Utils_Tuple2(monthId, _Utils_Tuple3(monthId, monthStart, monthEnd));
    });
    var $author$project$Components$DateRangeInput$buildMonthRanges = F2(function(currentDate, settings) {
        var startMonth = A2($justinmimbs$date$Date$floor, 2, currentDate);
        var _v0 = settings.FF ? _Utils_Tuple2(0, 12) : _Utils_Tuple2(settings.Go, settings.Gn);
        var rangeStart = _v0.a;
        var rangeEnd = _v0.b;
        return $elm$core$Dict$fromList(A2($elm$core$List$map, $author$project$Components$DateRangeInput$buildMonthRange(startMonth), $elm$core$List$reverse(A2($elm$core$List$range, rangeStart, rangeEnd))));
    });
    var $author$project$Components$DateRangeInput$formatWeekday = function(weekday) {
        switch(weekday){
            case 0:
                return 'Mon';
            case 1:
                return 'Tue';
            case 2:
                return 'Wed';
            case 3:
                return 'Thu';
            case 4:
                return 'Fri';
            case 5:
                return 'Sat';
            default:
                return 'Sun';
        }
    };
    var $author$project$Components$DateRangeInput$datePickerSettings = function() {
        var defaultSettings_ = $agustinrhcp$elm_datepicker$DatePicker$defaultSettings;
        return _Utils_update(defaultSettings_, {
            acN: $justinmimbs$date$Date$format('MM/dd/yyyy'),
            acQ: $author$project$Components$DateRangeInput$formatWeekday,
            FO: _List_fromArray([
                _Utils_Tuple2('form-control', true)
            ]),
            af$: $author$project$Utils$Date$fromUsString,
            r7: 'mm/dd/yyyy'
        });
    }();
    var $author$project$Components$DateRangeInput$isCustomItem = function(maybeOption) {
        if (!maybeOption.$) {
            var item = maybeOption.a;
            return _Utils_eq(item.aef, $author$project$Components$DateRangeInput$customId);
        } else return false;
    };
    var $author$project$Components$DateRangeInput$defaultDateIfCustom = F4(function(model, selectedOption, getter, _default) {
        if ($author$project$Components$DateRangeInput$isCustomItem(selectedOption)) {
            var _v0 = getter(model);
            if (!_v0.$) {
                var currentDate = _v0.a;
                return $elm$core$Maybe$Just(currentDate);
            } else return _default;
        } else return _default;
    });
    var $author$project$Components$DateRangeInput$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var currentDate = msg.a;
                var toDate = model.cr.ahV;
                var monthRanges = A2($author$project$Components$DateRangeInput$buildMonthRanges, currentDate, model.cr);
                var fromDate = model.cr.ad1;
                var additionalItems = $author$project$Components$DateRangeInput$buildAdditionalItems(model.cr.kW(currentDate));
                var selectedOption = function() {
                    var _v2 = _Utils_Tuple2(fromDate, toDate);
                    if (_v2.a.$ === 1 && _v2.b.$ === 1) {
                        var _v3 = _v2.a;
                        var _v4 = _v2.b;
                        return $elm$core$Maybe$Nothing;
                    } else {
                        var selectedItem = A2($elm$core$Maybe$withDefault, A2($elm$core$Maybe$map, function(_v9) {
                            var id = _v9.a;
                            var _v10 = _v9.b;
                            var label = _v10.a;
                            var start = _v10.b;
                            var end = _v10.c;
                            return _Utils_Tuple2(id, _Utils_Tuple3(label, $elm$core$Maybe$Just(start), $elm$core$Maybe$Just(end)));
                        }, A2($elm_community$list_extra$List$Extra$find, function(_v7) {
                            var _v8 = _v7.b;
                            var start = _v8.b;
                            var end = _v8.c;
                            return _Utils_eq($elm$core$Maybe$Just(start), fromDate) && _Utils_eq($elm$core$Maybe$Just(end), toDate);
                        }, $elm$core$Dict$toList(monthRanges))), A2($elm$core$Maybe$map, $elm$core$Maybe$Just, A2($elm_community$list_extra$List$Extra$find, function(_v5) {
                            var _v6 = _v5.b;
                            var start = _v6.b;
                            var end = _v6.c;
                            return _Utils_eq(start, fromDate) && _Utils_eq(end, toDate);
                        }, $elm$core$Dict$toList(additionalItems))));
                        return $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, A2($author$project$Components$DateRangeInput$buildCustomItem, fromDate, toDate), A2($elm$core$Maybe$map, $author$project$Components$DateRangeInput$buildMonthItem, selectedItem)));
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    kW: additionalItems,
                    cP: $elm$core$Maybe$Just(currentDate),
                    ad1: fromDate,
                    Gp: monthRanges,
                    z9: A2($author$project$Components$DateRangeInput$buildMonthOptions, monthRanges, additionalItems),
                    gK: selectedOption,
                    ahV: toDate
                }), $elm$core$Platform$Cmd$none, $author$project$Components$DateRangeInput$None);
            case 1:
                var subMsg = msg.a;
                var _v11 = A3($agustinrhcp$elm_datepicker$DatePicker$update, $author$project$Components$DateRangeInput$datePickerSettings, subMsg, model.qN);
                var fromDatePicker = _v11.a;
                var fromDatePickerEvent = _v11.b;
                var fromDate = function() {
                    _v12$2: while(true)switch(fromDatePickerEvent.$){
                        case 2:
                            var date = fromDatePickerEvent.a;
                            return $elm$core$Maybe$Just(date);
                        case 1:
                            if (fromDatePickerEvent.a.$ === 1) {
                                var _v13 = fromDatePickerEvent.a;
                                return $elm$core$Maybe$Nothing;
                            } else break _v12$2;
                        default:
                            break _v12$2;
                    }
                    return model.ad1;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    ad1: fromDate,
                    qN: fromDatePicker
                }), $elm$core$Platform$Cmd$none, A4($author$project$Components$DateRangeInput$buildEvent, model, fromDate, model.ahV, 'Custom'));
            case 2:
                var subMsg = msg.a;
                var _v14 = A3($agustinrhcp$elm_datepicker$DatePicker$update, $author$project$Components$DateRangeInput$datePickerSettings, subMsg, model.tr);
                var toDatePicker = _v14.a;
                var toDatePickerEvent = _v14.b;
                var toDate = function() {
                    _v15$2: while(true)switch(toDatePickerEvent.$){
                        case 2:
                            var date = toDatePickerEvent.a;
                            return $elm$core$Maybe$Just(date);
                        case 1:
                            if (toDatePickerEvent.a.$ === 1) {
                                var _v16 = toDatePickerEvent.a;
                                return $elm$core$Maybe$Nothing;
                            } else break _v15$2;
                        default:
                            break _v15$2;
                    }
                    return model.ahV;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    ahV: toDate,
                    tr: toDatePicker
                }), $elm$core$Platform$Cmd$none, A4($author$project$Components$DateRangeInput$buildEvent, model, model.ad1, toDate, 'Custom'));
            case 3:
                var subMsg = msg.a;
                var _v17 = A2($author$project$Ui$Dropdown$update, subMsg, model.fD);
                var dropdown = _v17.a;
                var cmd = _v17.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    fD: dropdown
                }), cmd, $author$project$Components$DateRangeInput$None);
            default:
                var maybeItem = msg.a;
                var _v18 = function() {
                    if (!maybeItem.$) {
                        var item = maybeItem.a;
                        return _Utils_Tuple3(item.HB, item.Fn, item.aeI);
                    } else return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, '');
                }();
                var optionFromDate = _v18.a;
                var optionToDate = _v18.b;
                var selectedOptionLabel = _v18.c;
                var fromDate = A4($author$project$Components$DateRangeInput$defaultDateIfCustom, model, maybeItem, function($) {
                    return $.ad1;
                }, optionFromDate);
                var toDate = A4($author$project$Components$DateRangeInput$defaultDateIfCustom, model, maybeItem, function($) {
                    return $.ahV;
                }, optionToDate);
                return _Utils_Tuple3(_Utils_update(model, {
                    ad1: fromDate,
                    gK: maybeItem,
                    ahV: toDate
                }), $elm$core$Platform$Cmd$none, A4($author$project$Components$DateRangeInput$buildEvent, model, fromDate, toDate, selectedOptionLabel));
        }
    });
    var $author$project$Components$Affiliates$BillsList$updateUrl = A2($elm$core$Basics$composeR, $author$project$Components$Affiliates$BillsList$buildUrl, $author$project$Ports$Navigation$pushUrl);
    var $author$project$Components$Affiliates$BillsList$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        hv: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    hv: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    UK: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
                    $author$project$Components$Affiliates$BillsList$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
                    $author$project$Components$Affiliates$BillsList$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v2.a;
                var subCmd = _v2.b;
                var event = _v2.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            hv: $author$project$Api$Data$Loading,
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Affiliates$BillsList$fetchAffiliateBills, apiClient, newModel),
                    $author$project$Components$Affiliates$BillsList$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$BillsList$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
        }
    });
    var $author$project$Pages$AffiliateBills$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Affiliates$BillsList$update, model.Ej, subMsg, model.rk);
        var billsList = _v1.a;
        var billsListCmd = _v1.b;
        var billsListOutMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: billsList
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, billsListCmd), billsListOutMsgs);
    });
    var $author$project$Components$Affiliates$BillsList$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Affiliates$BillsList$SortTable = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Affiliates$BillsList$columns = function(byAffiliate) {
        return $elm$core$List$concat(_List_fromArray([
            !byAffiliate ? _List_fromArray([
                A3($author$project$Api$Column$init, 'name', false, 'Affiliate Name')
            ]) : _List_Nil,
            _List_fromArray([
                A3($author$project$Api$Column$init, 'invoice_date', true, 'Invoice Date'),
                A3($author$project$Api$Column$init, 'invoice_number', false, 'Bill Number'),
                A3($author$project$Api$Column$init, 'active_lives', false, 'Active Lives'),
                A3($author$project$Api$Column$init, 'amount_in_cents', false, 'Bill Amount'),
                A3($author$project$Api$Column$init, 'bill_status', false, 'Status')
            ])
        ]));
    };
    var $author$project$Api$Provider$Affiliate$One$defaultSource = function(_v0) {
        var record = _v0.b;
        return record.ND;
    };
    var $author$project$Api$Provider$Network$One$defaultSource = function(_v0) {
        var record = _v0;
        return record.ND;
    };
    var $author$project$Components$DateRangeInput$ItemSelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$DateRangeInput$dropdownItems = F2(function(options, currentSelection) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$DateRangeInput$ItemSelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentSelection, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All time')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(item) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$DateRangeInput$ItemSelected($elm$core$Maybe$Just(item))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentSelection, $elm$core$Maybe$Just(item)))
            ]), $elm$html$Html$text(item.aeI));
        }, options)));
    });
    var $author$project$Ui$Grid$Sm = 1;
    var $author$project$Ui$Grid$gutterSm = $author$project$Ui$Grid$Gutter(1);
    var $author$project$Components$DateRangeInput$view = function(_v0) {
        var model = _v0;
        var fullWithLength = model.cr.FD ? 12 : 4;
        return A2($author$project$Ui$Grid$row, _List_fromArray([
            $author$project$Ui$Grid$gutterSm
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(fullWithLength)
            ]), _List_fromArray([
                function() {
                    var placeholder = function() {
                        var _v1 = model.gK;
                        if (!_v1.$) {
                            var item = _v1.a;
                            return item.aeI;
                        } else return 'All time';
                    }();
                    return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(placeholder)
                    ]), A2($author$project$Components$DateRangeInput$dropdownItems, model.z9, model.gK), model.fD);
                }()
            ])),
            A2($author$project$Ui$Grid$column, model.cr.w4, model.cr.vt || $author$project$Components$DateRangeInput$isCustomItem(model.gK) ? _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$label, _List_fromArray([
                        $elm$html$Html$Attributes$class('sr-only')
                    ]), _List_fromArray([
                        $elm$html$Html$text('From Date')
                    ])),
                    A2($elm$html$Html$map, $author$project$Components$DateRangeInput$FromDatePickerMsg, A3($agustinrhcp$elm_datepicker$DatePicker$view, model.ad1, $author$project$Components$DateRangeInput$datePickerSettings, model.qN))
                ]))
            ]) : _List_Nil),
            model.cr.vt || $author$project$Components$DateRangeInput$isCustomItem(model.gK) ? A2($author$project$Ui$Grid$column, model.cr.w4, _List_fromArray([
                A2($elm$html$Html$label, _List_fromArray([
                    $elm$html$Html$Attributes$class('sr-only')
                ]), _List_fromArray([
                    $elm$html$Html$text('To Date')
                ])),
                A2($elm$html$Html$map, $author$project$Components$DateRangeInput$ToDatePickerMsg, A3($agustinrhcp$elm_datepicker$DatePicker$view, model.ahV, $author$project$Components$DateRangeInput$datePickerSettings, model.tr))
            ])) : $author$project$Ui$Grid$none
        ]));
    };
    var $author$project$Components$Affiliates$BillsList$viewSource = F2(function(timeFormatter, source) {
        if (!source.$) {
            var source_ = source.a;
            return A2($author$project$Components$PracticeSourceDisplayer$view, timeFormatter, $elm$core$Maybe$Just($author$project$Api$Source$Source(source_)));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$AffiliateBill$All$numberOfDependents = function(_v0) {
        var record = _v0.b;
        return record.Vb;
    };
    var $author$project$Api$Provider$AffiliateBill$All$numberOfEmployees = function(_v0) {
        var record = _v0.b;
        return record.Vc;
    };
    var $author$project$Components$Affiliates$BillsList$activeLives = function(affiliateBill) {
        return $author$project$Api$Provider$AffiliateBill$All$numberOfDependents(affiliateBill) + $author$project$Api$Provider$AffiliateBill$All$numberOfEmployees(affiliateBill);
    };
    var $author$project$Api$Provider$AffiliateBill$All$affiliate = function(_v0) {
        var record = _v0.b;
        return record.Eb;
    };
    var $author$project$Api$Provider$Invoice$Shared$amountInCents = function(_v0) {
        var record = _v0.b;
        return record.Jh;
    };
    var $author$project$Api$Provider$AffiliateBill$All$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$Invoice$Shared$humanStatus = function(_v0) {
        var record = _v0.b;
        return record.QX;
    };
    var $author$project$Api$Provider$AffiliateBill$All$humanStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$humanStatus(shared);
    };
    var $author$project$Api$Provider$AffiliateBill$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$id(shared);
    };
    var $author$project$Api$Provider$Invoice$Shared$invoiceDate = function(_v0) {
        var record = _v0.b;
        return record.RG;
    };
    var $author$project$Api$Provider$AffiliateBill$All$invoiceDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$invoiceDate(shared);
    };
    var $author$project$Api$Provider$Invoice$Min$invoiceNumber = function(_v0) {
        var record = _v0;
        return record.RK;
    };
    var $author$project$Api$Provider$Invoice$Shared$invoiceNumber = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
    };
    var $author$project$Api$Provider$AffiliateBill$All$invoiceNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$invoiceNumber(shared);
    };
    var $author$project$Api$Provider$AffiliateBill$All$practice = function(_v0) {
        var record = _v0.b;
        return record.W1;
    };
    var $author$project$Api$Invoice$Status$toString = function(status_) {
        switch(status_.$){
            case 0:
                return 'draft';
            case 1:
                return 'issued';
            case 2:
                return 'paid';
            case 3:
                return 'disputed';
            case 4:
                return 'bad debt';
            case 5:
                return 'cancelled';
            case 6:
                return 'overdue';
            case 7:
                return 'viewed';
            case 8:
                return 'sent';
            default:
                var string = status_.a;
                return string;
        }
    };
    var $author$project$Api$Invoice$Status$toBadge = function(status_) {
        var badgeOption = function() {
            switch(status_.$){
                case 7:
                    return _List_fromArray([
                        $author$project$Ui$Badge$info
                    ]);
                case 2:
                    return _List_fromArray([
                        $author$project$Ui$Badge$success
                    ]);
                case 6:
                    return _List_fromArray([
                        $author$project$Ui$Badge$danger
                    ]);
                case 1:
                    return _List_fromArray([
                        $author$project$Ui$Badge$warning
                    ]);
                case 8:
                    return _List_fromArray([
                        $author$project$Ui$Badge$warning
                    ]);
                default:
                    return _List_Nil;
            }
        }();
        return A2($author$project$Ui$Badge$view, badgeOption, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Invoice$Status$toString(status_))
        ]));
    };
    var $author$project$Components$Affiliates$BillsList$viewStatement = F2(function(model, affiliateBill) {
        var affiliateId = $author$project$Api$Provider$Affiliate$Shared$id($author$project$Api$Provider$AffiliateBill$All$affiliate(affiliateBill));
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            !model.vU ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Practice$Min$name($author$project$Api$Provider$AffiliateBill$All$practice(affiliateBill)))
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String({
                        pr: affiliateId,
                        aef: $author$project$Api$Provider$AffiliateBill$All$id(affiliateBill)
                    }), _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, $author$project$Api$Provider$AffiliateBill$All$invoiceDate(affiliateBill)))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String({
                        pr: affiliateId,
                        aef: $author$project$Api$Provider$AffiliateBill$All$id(affiliateBill)
                    }), _List_Nil, _List_fromArray([
                        $elm$html$Html$text('#'),
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$AffiliateBill$All$invoiceNumber(affiliateBill)))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt($author$project$Components$Affiliates$BillsList$activeLives(affiliateBill)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$AffiliateBill$All$amountInCents(affiliateBill)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $author$project$Api$Invoice$Status$toBadge($author$project$Api$Provider$AffiliateBill$All$humanStatus(affiliateBill))
                ]))
            ])
        ])));
    });
    var $author$project$Components$Affiliates$BillsList$view = function(model) {
        var _v0 = function() {
            var _v1 = model.hv;
            if (_v1.$ === 3) {
                var affiliateBills_ = _v1.a;
                return _Utils_Tuple2(false, affiliateBills_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var affiliateBills = _v0.b;
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Affiliates$BillsList$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$pull(1)
                        ]), _List_fromArray([
                            function() {
                                var _v2 = _Utils_Tuple2(model.Eb, model.UK);
                                if (!_v2.a.$) {
                                    var affiliate = _v2.a.a;
                                    return A2($author$project$Components$Affiliates$BillsList$viewSource, model.HO, $author$project$Api$Provider$Affiliate$One$defaultSource(affiliate));
                                } else if (_v2.b.$ === 3) {
                                    var _v3 = _v2.a;
                                    var _v4 = _v2.b;
                                    var network = _v4.a;
                                    return A2($author$project$Components$Affiliates$BillsList$viewSource, model.HO, $author$project$Api$Provider$Network$One$defaultSource(network));
                                } else {
                                    var _v5 = _v2.a;
                                    return $author$project$Ui$Spinner$view(_List_fromArray([
                                        $author$project$Ui$Spinner$small
                                    ]));
                                }
                            }()
                        ]))
                    ]))
                ]))
            ])),
            A4($author$project$Ui$Panel$table, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No matching results.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Affiliates$BillsList$SortTable)), $author$project$Components$Affiliates$BillsList$columns(model.vU)),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Components$Affiliates$BillsList$viewStatement(model), affiliateBills), _List_Nil),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Affiliates$BillsList$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.hv)))
                ]), model.af_))
            ]))
        ]));
    };
    var $author$project$Pages$AffiliateBills$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Affiliates$BillsList$view(model.rk))
            ]),
            $2: 'Affiliates | Bills'
        };
    };
    var $author$project$Pages$AffiliateBills$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$AffiliateBills$Top$init,
        aeR: $author$project$Pages$AffiliateBills$Top$load,
        ag3: $author$project$Pages$AffiliateBills$Top$save,
        ahE: $author$project$Pages$AffiliateBills$Top$subscriptions,
        aaO: $author$project$Pages$AffiliateBills$Top$update,
        aid: $author$project$Pages$AffiliateBills$Top$view
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$GotAffiliate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliate$affiliatesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'affiliates'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Affiliate$affiliatePath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Affiliate$affiliatesPath);
    };
    var $author$project$Api$Provider$Affiliate$One$Affiliate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Affiliate$One$Record = F4(function(createdFrom, defaultSource, company, affiliatePractice) {
        return {
            IU: affiliatePractice,
            acy: company,
            acG: createdFrom,
            ND: defaultSource
        };
    });
    var $author$project$Api$Provider$Affiliate$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate_practice', $author$project$Api$Provider$Practice$One$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_from', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$One$Record)))));
    var $author$project$Api$Provider$Affiliate$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliate$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliate$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$One$Affiliate)));
    var $author$project$Api$Provider$Affiliate$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Affiliate$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliate$affiliatePath(id_)));
    });
    var $author$project$Api$Pagination$withPrefix = F2(function(prefix, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            sg: prefix
        });
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$init = F4(function(session, _v0, shared, _v1) {
        var params = _v1.VU;
        var query = _v1.Bz;
        return _Utils_Tuple2({
            k$: $elm$core$Maybe$Nothing,
            pr: params.pr,
            Ej: shared.Ej,
            af_: A2($author$project$Api$Pagination$fromQuery, query, A2($author$project$Api$Pagination$withPrefix, 'affiliate_actions_', $author$project$Api$Pagination$init)),
            Bz: query,
            Z$: session
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Affiliate$retrieve, shared.Ej, params.pr, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$GotAffiliate),
            $author$project$Shared$isHintAdmin(shared) ? $elm$core$Platform$Cmd$none : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
                pr: params.pr
            }))
        ])));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$AffiliateActionsList$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString(model.Gc)
        ]), $author$project$Api$Pagination$toPageQuery(model.af_));
    };
    var $author$project$Components$Affiliates$AffiliateActionsList$GotAffiliateActions = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$AffiliateAction$affiliatePath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'affiliates'
        ]), $author$project$Api$Data$providerPath));
    };
    var $author$project$Api$Provider$AffiliateAction$affiliateActionsPath = function(affiliationId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'affiliate_actions'
        ]), $author$project$Api$Provider$AffiliateAction$affiliatePath(affiliationId));
    };
    var $author$project$Api$Provider$AffiliateAction$All$AffiliateAction = $elm$core$Basics$identity;
    var $author$project$Api$Provider$AffiliateAction$All$Record = F8(function(id, ident, contextMembershipIdent, targetIdent, actionType, actionData, status, errorMessage) {
        return {
            Ip: actionData,
            Iq: actionType,
            L3: contextMembershipIdent,
            O4: errorMessage,
            aef: id,
            aeg: ident,
            ahy: status,
            $M: targetIdent
        };
    });
    var $author$project$Api$Provider$AffiliateAction$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'action_data', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'action_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'target_ident', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'context_membership_ident', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ident', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateAction$All$Record)))))))));
    var $author$project$Api$Provider$AffiliateAction$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$AffiliateAction$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$AffiliateAction$listDefaults = {
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Provider$AffiliateAction$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$AffiliateAction$listDefaults);
        return $author$project$Api$Pagination$toApiParams(options.af_);
    };
    var $author$project$Api$Provider$AffiliateAction$list = F4(function(apiClient, affiliationId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateAction$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$AffiliateAction$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$AffiliateAction$affiliateActionsPath(affiliationId))));
    });
    var $author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions = function(_v0) {
        var apiClient = _v0.Ej;
        var affiliateId = _v0.pr;
        var pagination = _v0.af_;
        return A4($author$project$Api$Provider$AffiliateAction$list, apiClient, affiliateId, function(d) {
            return _Utils_update(d, {
                af_: pagination
            });
        }, $author$project$Components$Affiliates$AffiliateActionsList$GotAffiliateActions);
    };
    var $author$project$Components$Affiliates$AffiliateActionsList$init = function(config) {
        var pagination = $author$project$Api$Pagination$initFromQuery(config.Bz);
        var model = {
            Eb: config.Eb,
            k_: $author$project$Api$Data$Loading,
            pr: config.pr,
            Ej: config.Ej,
            Gc: config.Gc,
            af_: pagination
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions(model),
            $author$project$Ports$Navigation$replaceUrl($author$project$Components$Affiliates$AffiliateActionsList$buildUrl(model))
        ])));
    };
    var $author$project$Components$Affiliates$AffiliateActionsList$updateUrl = A2($elm$core$Basics$composeR, $author$project$Components$Affiliates$AffiliateActionsList$buildUrl, $author$project$Ports$Navigation$pushUrl);
    var $author$project$Components$Affiliates$AffiliateActionsList$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            if (response.$ === 3) {
                var headers = response.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    k_: response,
                    af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            } else return _Utils_Tuple3(_Utils_update(model, {
                k_: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var subMsg = msg.a;
            var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
            var newModel = _Utils_update(model, {
                af_: pagination
            });
            return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                $author$project$Components$Affiliates$AffiliateActionsList$fetchAffiliateActions(newModel),
                $author$project$Components$Affiliates$AffiliateActionsList$updateUrl(newModel)
            ])), _List_Nil);
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            if (response.$ === 3) {
                var affiliate = response.a;
                var _v2 = $author$project$Components$Affiliates$AffiliateActionsList$init({
                    Eb: $elm$core$Maybe$Just(affiliate),
                    pr: model.pr,
                    Ej: model.Ej,
                    Gc: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions({
                        pr: model.pr
                    }),
                    Bz: model.Bz
                });
                var affiliateActionsList = _v2.a;
                var affiliateActionsListCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    k$: $elm$core$Maybe$Just(affiliateActionsList)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg, affiliateActionsListCmd), _List_Nil);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var subMsg = msg.a;
            var _v3 = model.k$;
            if (!_v3.$) {
                var affiliateActionsList = _v3.a;
                var _v4 = A2($author$project$Components$Affiliates$AffiliateActionsList$update, subMsg, affiliateActionsList);
                var affiliateActionsList_ = _v4.a;
                var affiliateActionsListCmd = _v4.b;
                var affiliateActionsListOutMsgs = _v4.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    k$: $elm$core$Maybe$Just(affiliateActionsList_)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg, affiliateActionsListCmd), affiliateActionsListOutMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Affiliates$AffiliateActionsList$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$AffiliateActionsList$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'id', false, 'ID'),
        A3($author$project$Api$Column$init, 'ident', false, 'Ident'),
        A3($author$project$Api$Column$init, 'context_membership_ident', false, 'Context Membership Ident'),
        A3($author$project$Api$Column$init, 'target_ident', false, 'Target Ident'),
        A3($author$project$Api$Column$init, 'action_type', false, 'Action Type'),
        A3($author$project$Api$Column$init, 'action_data', false, 'Action Data'),
        A3($author$project$Api$Column$init, 'status', false, 'Status'),
        A3($author$project$Api$Column$init, 'error_message', false, 'Error Message')
    ]);
    var $author$project$Api$Provider$AffiliateAction$All$actionData = function(_v0) {
        var record = _v0;
        return record.Ip;
    };
    var $author$project$Api$Provider$AffiliateAction$All$actionType = function(_v0) {
        var record = _v0;
        return record.Iq;
    };
    var $author$project$Api$Provider$AffiliateAction$All$contextMembershipIdent = function(_v0) {
        var record = _v0;
        return record.L3;
    };
    var $author$project$Api$Provider$AffiliateAction$All$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$AffiliateAction$All$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$AffiliateAction$All$ident = function(_v0) {
        var record = _v0;
        return record.aeg;
    };
    var $author$project$Api$Provider$AffiliateAction$All$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$AffiliateAction$All$targetIdent = function(_v0) {
        var record = _v0;
        return record.$M;
    };
    var $author$project$Components$Affiliates$AffiliateActionsList$viewAffiliateAction = function(affiliateAction) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$AffiliateAction$All$id(affiliateAction)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$AffiliateAction$All$ident(affiliateAction))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$AffiliateAction$All$contextMembershipIdent(affiliateAction))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$AffiliateAction$All$targetIdent(affiliateAction))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$AffiliateAction$All$actionType(affiliateAction))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$AffiliateAction$All$actionData(affiliateAction))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$AffiliateAction$All$status(affiliateAction))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$AffiliateAction$All$errorMessage(affiliateAction)))
            ]))
        ]));
    };
    var $author$project$Components$Affiliates$AffiliateActionsList$view = function(model) {
        var _v0 = function() {
            var _v1 = model.k_;
            if (_v1.$ === 3) {
                var affiliateActions_ = _v1.a;
                return _Utils_Tuple2(false, affiliateActions_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var affiliateActions = _v0.b;
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Affiliate Actions')
                ]))
            ])),
            A4($author$project$Ui$Panel$table, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No matching results.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Components$Affiliates$AffiliateActionsList$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Components$Affiliates$AffiliateActionsList$viewAffiliateAction, affiliateActions), _List_Nil),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Affiliates$AffiliateActionsList$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.k_)))
                ]), model.af_))
            ]))
        ]));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.k$;
                    if (!_v0.$) {
                        var affiliateActionsList = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$AffiliateActionsListMsg, $author$project$Components$Affiliates$AffiliateActionsList$view(affiliateActionsList));
                    } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]));
                }()
            ]),
            $2: 'Affiliates | Actions'
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$init,
        aeR: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$load,
        ag3: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$save,
        ahE: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$subscriptions,
        aaO: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$update,
        aid: $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$view
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$GotAffiliate = F5(function(a, b, c, d, e) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c,
            d: d,
            e: e
        };
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            fT: $elm$core$Maybe$Nothing
        }, A3($author$project$Api$Provider$Affiliate$retrieve, shared.Ej, params.pr, A4($author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$GotAffiliate, session, practice, shared, params.aef)));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$AuditTrailLogMsg = function(a) {
        return {
            $: 36,
            a: a
        };
    };
    var $author$project$Components$Invoice$CompanyEmailModalMsg = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreatePaymentModalMsg = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Components$Invoice$DeleteHiConfirmClosed = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$DownloadInvoiceMsg = function(a) {
        return {
            $: 34,
            a: a
        };
    };
    var $author$project$Components$Invoice$DownloadUnavailableModalClosed = {
        $: 35
    };
    var $author$project$Components$Invoice$InvoiceLinesTableMsg = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceSummaryMsg = function(a) {
        return {
            $: 27,
            a: a
        };
    };
    var $author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$PaymentsHistoryMsg = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Components$Invoice$ReturnToDraftHiConfirmClosed = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$VoidHiConfirmClosed = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$AuditTrailLog$isOpen = function(model) {
        return $author$project$Ui$Popover$isOpen(model.aN);
    };
    var $author$project$Components$AuditTrailLog$subscriptions = function(model) {
        return $author$project$Ui$Popover$subscriptions(model.aN);
    };
    var $author$project$Components$CompanyEmailModal$Close = {
        $: 0
    };
    var $author$project$Components$CompanyEmailModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CompanyEmailModal$Close);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close = {
        $: 0
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close);
    };
    var $author$project$Components$ResourceFilter$Plan$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$subscriptions, model.ht))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fv))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            $author$project$Ui$Dropdown$subscriptions(model.l5),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Platform$Sub$map($author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg), A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Plan$subscriptions, model.jy))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg, $author$project$Components$ResourceFilter$Category$subscriptions(model.cK))
        ]));
    };
    var $author$project$Components$Invoice$Summary$CloseDeltaModal = {
        $: 5
    };
    var $author$project$Components$Invoice$Summary$subscriptions = function(_v0) {
        var model = _v0;
        var _v1 = model.nm;
        if (!_v1.$) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$Summary$CloseDeltaModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Invoice$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(model.l_),
            function() {
                var _v1 = model.eb;
                if (!_v1.$) {
                    var invoiceLinesTable = _v1.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$InvoiceLinesTableMsg, $author$project$Components$Invoice$InvoiceLinesTable$subscriptions(invoiceLinesTable));
                } else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v2 = model.hQ;
                if (!_v2.$) {
                    var companyEmailModal = _v2.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$CompanyEmailModalMsg, $author$project$Components$CompanyEmailModal$subscriptions(companyEmailModal));
                } else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v3 = model.fU;
                if (!_v3.$) {
                    var invoiceSummary = _v3.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$InvoiceSummaryMsg, $author$project$Components$Invoice$Summary$subscriptions(invoiceSummary));
                } else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$PaymentsHistoryMsg, $author$project$Components$Invoice$PaymentsHistory$subscriptions(model.js)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$CreatePaymentModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.lH))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$DownloadInvoiceMsg, $author$project$Components$Invoice$DownloadFile$subscriptions(model.it)),
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$DownloadUnavailableModalClosed),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$VoidHiConfirmClosed), model.tG)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$ReturnToDraftHiConfirmClosed), model.eC)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed), model.eh)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Invoice$DeleteHiConfirmClosed), model.ib)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$andThen, function(auditTrailLog) {
                return $author$project$Components$AuditTrailLog$isOpen(auditTrailLog) ? $elm$core$Maybe$Just(A2($elm$core$Platform$Sub$map, $author$project$Components$Invoice$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$subscriptions(auditTrailLog))) : $elm$core$Maybe$Nothing;
            }, model.hB))
        ]));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$subscriptions = function(model) {
        var _v0 = model.fT;
        if (!_v0.$) {
            var invoiceComponent = _v0.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg, $author$project$Components$Invoice$subscriptions(invoiceComponent));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Invoice$Affiliate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$ProviderMin = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliate$One$company = function(_v0) {
        var record = _v0.b;
        return record.acy;
    };
    var $author$project$Components$Invoice$DropdownMenuMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Invoice$Model = $elm$core$Basics$identity;
    var $author$project$Api$Feature$VirtualBankAccount = 11;
    var $author$project$Components$Invoice$VirtualBankAccountsComponentMsg = function(a) {
        return {
            $: 37,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$GotVirtualBankAccounts = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$VirtualBankAccount$EmployerAll = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$VirtualBankAccount$ProviderAll = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$VirtualBankAccount$Shared$VirtualBankAccount = $elm$core$Basics$identity;
    var $author$project$Api$Employer$VirtualBankAccount$Shared$Record = function(id) {
        return function(abaBankName) {
            return function(abaAccountNumber) {
                return function(abaRoutingtNumber) {
                    return function(contactEmail) {
                        return function(swiftAccountNumber) {
                            return function(swiftCode) {
                                return function(swiftBankName) {
                                    return function(balanceInCents) {
                                        return function(createdAt) {
                                            return {
                                                H8: abaAccountNumber,
                                                H9: abaBankName,
                                                Ia: abaRoutingtNumber,
                                                abW: balanceInCents,
                                                L0: contactEmail,
                                                Mx: createdAt,
                                                aef: id,
                                                $z: swiftAccountNumber,
                                                $A: swiftBankName,
                                                $B: swiftCode
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$VirtualBankAccount$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'balance_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'swift_bank_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'swift_code', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'swift_account_number', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contact_email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'aba_routing_number', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'aba_account_number', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'aba_bank_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$VirtualBankAccount$Shared$Record)))))))))));
    var $author$project$Api$Employer$VirtualBankAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$VirtualBankAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$VirtualBankAccount$virtualBankAccountsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'virtual_bank_accounts'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$VirtualBankAccount$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$VirtualBankAccount$Shared$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$VirtualBankAccount$virtualBankAccountsPath));
    });
    var $author$project$Api$Provider$VirtualBankAccount$Shared$VirtualBankAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$VirtualBankAccount$Shared$Record = function(id) {
        return function(abaBankName) {
            return function(abaAccountNumber) {
                return function(abaRoutingtNumber) {
                    return function(contactEmail) {
                        return function(swiftAccountNumber) {
                            return function(swiftCode) {
                                return function(swiftBankName) {
                                    return function(balanceInCents) {
                                        return function(createdAt) {
                                            return {
                                                H8: abaAccountNumber,
                                                H9: abaBankName,
                                                Ia: abaRoutingtNumber,
                                                abW: balanceInCents,
                                                L0: contactEmail,
                                                Mx: createdAt,
                                                aef: id,
                                                $z: swiftAccountNumber,
                                                $A: swiftBankName,
                                                $B: swiftCode
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'balance_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'swift_bank_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'swift_code', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'swift_account_number', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contact_email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'aba_routing_number', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'aba_account_number', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'aba_bank_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$VirtualBankAccount$Shared$Record)))))))))));
    var $author$project$Api$Provider$VirtualBankAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$VirtualBankAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'virtual_bank_accounts'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            companyId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'companies'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$VirtualBankAccount$list = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$VirtualBankAccount$Shared$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId)));
    });
    var $author$project$Api$VirtualBankAccount$list = F4(function(session, apiClient, companyId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$Employer$VirtualBankAccount$list, apiClient, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$VirtualBankAccount$EmployerAll)))) : A3($author$project$Api$Provider$VirtualBankAccount$list, apiClient, companyId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$VirtualBankAccount$ProviderAll))));
    });
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$loadData = F3(function(session, apiClient, companyId) {
        return _Utils_Tuple2($author$project$Api$Data$Loading, A4($author$project$Api$VirtualBankAccount$list, session, apiClient, companyId, $author$project$Components$Company$VirtualBankAccounts$Invoice$GotVirtualBankAccounts));
    });
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$init = F4(function(companyId, session, practice, _v0) {
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var _v1 = A3($author$project$Components$Company$VirtualBankAccounts$Invoice$loadData, session, apiClient, companyId);
        var virtualBankAccounts = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple2({
            J7: false,
            fl: companyId,
            aeb: hinterViewOff,
            W1: practice,
            Z$: session,
            DZ: virtualBankAccounts
        }, cmd);
    });
    var $author$project$Components$Invoice$InvoiceDateInputMsg = F2(function(a, b) {
        return {
            $: 30,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceDueDateInputMsg = F2(function(a, b) {
        return {
            $: 32,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$initFormFields = function(today) {
        var _v0 = $author$project$Components$DateInput$init;
        var invoiceDateInput = _v0.a;
        var invoiceDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            RG: today,
            mD: invoiceDateInput,
            iY: today,
            mE: invoiceDateInput
        }, _List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceDateInputMsg(invoiceDateInput), invoiceDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceDueDateInputMsg(invoiceDateInput), invoiceDateInputCmd)
        ]));
    };
    var $author$project$Api$Provider$AffiliateBill$affiliateBillPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$AffiliateBill$affiliateBillsPath);
    };
    var $author$project$Api$Employer$Invoice$invoicesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'invoices'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Invoice$invoicePath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Employer$Invoice$invoicesPath);
    };
    var $author$project$Api$Provider$Company$Invoice$invoicesPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invoices'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$Invoice$invoicePath = F2(function(companyId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Company$Invoice$invoicesPath(companyId));
    });
    var $author$project$Api$Company$Invoice$invoicePath = F3(function(session, companyId, id) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Invoice$invoicePath(id) : A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id);
    });
    var $author$project$Components$Invoice$paymentsBasePath = F2(function(session, invoiceType) {
        if (!invoiceType.$) {
            var id = invoiceType.b;
            return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id);
        } else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A3($author$project$Api$Company$Invoice$invoicePath, session, companyId, id);
        }
    });
    var $author$project$Components$Invoice$GotIntegrationRecords = function(a) {
        return {
            $: 38,
            a: a
        };
    };
    var $author$project$Api$Provider$IntegrationRecord$All$IntegrationRecord = $elm$core$Basics$identity;
    var $author$project$Api$Provider$IntegrationRecord$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$IntegrationRecord$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Company$Invoice$integrationRecords = F5(function(apiClient, session, companyId, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'integration_records'
        ]), A3($author$project$Api$Company$Invoice$invoicePath, session, companyId, id_))));
    });
    var $author$project$Components$Invoice$retrieveIntegrationRecords = F4(function(isHintAdmin, apiClient, session, invoiceType) {
        var _v0 = _Utils_Tuple2(isHintAdmin, invoiceType);
        if (_v0.a && _v0.b.$ === 1) {
            var _v1 = _v0.b;
            var companyId = _v1.a;
            var id = _v1.b;
            return A5($author$project$Api$Company$Invoice$integrationRecords, apiClient, session, companyId, id, $author$project$Components$Invoice$GotIntegrationRecords);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Invoice$GotCompanyInvoice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Invoice$One$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Invoice$One$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$Invoice$One$Invoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$Invoice$Shared$Invoice = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Invoice$Shared$Record = function(id) {
        return function(invoiceDate) {
            return function(invoiceNumber) {
                return function(humanStatus) {
                    return function(amountInCents) {
                        return function(paidAt) {
                            return function(paidInCents) {
                                return function(dueDate) {
                                    return function(dueInCents) {
                                        return function(description) {
                                            return {
                                                Jh: amountInCents,
                                                NQ: description,
                                                Ok: dueDate,
                                                Ol: dueInCents,
                                                QX: humanStatus,
                                                aef: id,
                                                RG: invoiceDate,
                                                RK: invoiceNumber,
                                                VQ: paidAt,
                                                VR: paidInCents
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$Invoice$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $author$project$Api$Invoice$Status$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Shared$Record)))))))))));
    var $author$project$Api$Employer$Invoice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Invoice$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Invoice$One$Record = function(willAutoPay) {
        return function(autoPayDate) {
            return function(isPayable) {
                return function(discountSavingsInCents) {
                    return function(securePdfInlineToken) {
                        return function(securePdfWithChargeDetailsToken) {
                            return function(source) {
                                return function(payments) {
                                    return function(meta) {
                                        return function(recurring) {
                                            return {
                                                JV: autoPayDate,
                                                N3: discountSavingsInCents,
                                                Sh: isPayable,
                                                Ue: meta,
                                                Wt: payments,
                                                Yk: recurring,
                                                ZC: securePdfInlineToken,
                                                ZD: securePdfWithChargeDetailsToken,
                                                Hw: source,
                                                abt: willAutoPay
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$Invoice$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Invoice$Meta$Record = F2(function(actions, reportingPeriodIsLocked) {
        return {
            tM: actions,
            YC: reportingPeriodIsLocked
        };
    });
    var $author$project$Api$Employer$Invoice$Meta$ActionsRecord = F6(function(canCancel, createPayment, markAsPaid, issue, canAdjust, hideChargeDetails) {
        return {
            KE: canAdjust,
            KF: canCancel,
            Mu: createPayment,
            QH: hideChargeDetails,
            SB: issue,
            TE: markAsPaid
        };
    });
    var $author$project$Api$Employer$Invoice$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hide_charge_details', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_adjust', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issue', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mark_as_paid', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'create_payment', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_cancel', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Meta$ActionsRecord)))))));
    var $author$project$Api$Employer$Invoice$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reporting_period_is_locked', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Employer$Invoice$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$Meta$Record)));
    var $author$project$Api$Employer$Invoice$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Invoice$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Invoice$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'recurring', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Employer$Invoice$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payments', $elm$json$Json$Decode$list($author$project$Api$Employer$Payment$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_with_charge_details_token', $author$project$Api$File$Token$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_inline_token', $author$project$Api$File$Token$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discount_savings_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_payable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_pay_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'will_auto_pay', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$One$Record)))))))))));
    var $author$project$Api$Employer$Invoice$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Invoice$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Invoice$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Invoice$One$Invoice)));
    var $author$project$Api$Employer$Invoice$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Invoice$invoicePath(id)));
    });
    var $author$project$Api$Provider$Invoice$One$Invoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Invoice$One$Record = function(willAutoPay) {
        return function(autoPayDate) {
            return function(securePdfInlineToken) {
                return function(securePdfWithChargeDetailsToken) {
                    return function(viewingAsAffiliate) {
                        return function(isUpdating) {
                            return function(isPayable) {
                                return function(periodInMonths) {
                                    return function(discountSavingsInCents) {
                                        return function(source) {
                                            return function(payments) {
                                                return function(meta) {
                                                    return function(recurring) {
                                                        return function(createdAt) {
                                                            return {
                                                                JV: autoPayDate,
                                                                Mx: createdAt,
                                                                N3: discountSavingsInCents,
                                                                Sh: isPayable,
                                                                SA: isUpdating,
                                                                Ue: meta,
                                                                Wt: payments,
                                                                WA: periodInMonths,
                                                                Yk: recurring,
                                                                ZC: securePdfInlineToken,
                                                                ZD: securePdfWithChargeDetailsToken,
                                                                Hw: source,
                                                                abd: viewingAsAffiliate,
                                                                abt: willAutoPay
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Invoice$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Invoice$Meta$Record = F2(function(actions, reportingPeriodIsLocked) {
        return {
            tM: actions,
            YC: reportingPeriodIsLocked
        };
    });
    var $author$project$Api$Provider$Invoice$Meta$ActionsRecord = function(canCancel) {
        return function(canDraftAndDestroyCurrentDraft) {
            return function(canMarkAsBadDebt) {
                return function(canReverseBadDebt) {
                    return function(issue) {
                        return function(canMakeViewable) {
                            return function(canNotify) {
                                return function(createPayment) {
                                    return function(markAsPaid) {
                                        return function(canAdjust) {
                                            return function(canDelete) {
                                                return {
                                                    KE: canAdjust,
                                                    KF: canCancel,
                                                    KG: canDelete,
                                                    KI: canDraftAndDestroyCurrentDraft,
                                                    KO: canMakeViewable,
                                                    KP: canMarkAsBadDebt,
                                                    KQ: canNotify,
                                                    KS: canReverseBadDebt,
                                                    Mu: createPayment,
                                                    SB: issue,
                                                    TE: markAsPaid
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Invoice$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_delete', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_adjust', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mark_as_paid', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'create_payment', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_notify', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_make_viewable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issue', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_reverse_bad_debt', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_mark_as_bad_debt', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_draft_and_destroy_current_draft', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_cancel', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Meta$ActionsRecord))))))))))));
    var $author$project$Api$Provider$Invoice$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reporting_period_is_locked', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$Invoice$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$Meta$Record)));
    var $author$project$Api$Provider$Invoice$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Payment$SharedWithRefunds$Payment = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Payment$SharedWithRefunds$Record = F2(function(refunds, dispute) {
        return {
            N7: dispute,
            Yr: refunds
        };
    });
    var $author$project$Api$Provider$Payment$SharedWithRefunds$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'dispute', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Dispute$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'refunds', $elm$json$Json$Decode$list($author$project$Api$Provider$Refund$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$SharedWithRefunds$Record)));
    var $author$project$Api$Provider$Payment$SharedWithRefunds$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Payment$SharedWithRefunds$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Payment$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Payment$SharedWithRefunds$Payment)));
    var $author$project$Api$Provider$Invoice$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'recurring', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Invoice$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payments', $elm$json$Json$Decode$list($author$project$Api$Provider$Payment$SharedWithRefunds$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discount_savings_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_payable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_updating', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'viewing_as_affiliate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_with_charge_details_token', $author$project$Api$File$Token$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_inline_token', $author$project$Api$File$Token$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_pay_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'will_auto_pay', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$One$Record)))))))))))))));
    var $author$project$Api$Provider$Invoice$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$One$Invoice)));
    var $author$project$Api$Provider$Company$Invoice$retrieve = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id)));
    });
    var $author$project$Api$Company$Invoice$retrieve = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$retrieve, apiClient, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Employer))) : A4($author$project$Api$Provider$Company$Invoice$retrieve, apiClient, companyId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
    });
    var $author$project$Api$Provider$AffiliateBill$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$AffiliateBill$affiliateBillPath(id)));
    });
    var $author$project$Components$Invoice$retrieveInvoice = F3(function(apiClient, session, invoiceType) {
        if (!invoiceType.$) {
            var id = invoiceType.b;
            return A3($author$project$Api$Provider$AffiliateBill$retrieve, apiClient, id, A2($elm$core$Basics$composeL, $author$project$Components$Invoice$GotCompanyInvoice, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
        } else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A5($author$project$Api$Company$Invoice$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$GotCompanyInvoice);
        }
    });
    var $author$project$Ui$Dropdown$TopRight = 4;
    var $author$project$Ui$Dropdown$toTopRight = function(config) {
        return _Utils_update(config, {
            a1: 4
        });
    };
    var $author$project$Components$Invoice$init = function(config) {
        var practice = config.W1;
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(config.acy, A2($author$project$Api$Practice$featureEnabled, 11, practice));
            if (!_v1.a.$ && _v1.b) {
                var company = _v1.a.a;
                var companyId = function() {
                    if (!company.$) {
                        var company_ = company.a;
                        return $author$project$Api$Provider$Company$Min$id(company_);
                    } else {
                        var company_ = company.a;
                        return $author$project$Api$Company$id(company_);
                    }
                }();
                var _v2 = A4($author$project$Components$Company$VirtualBankAccounts$Invoice$init, companyId, config.Z$, practice, config.Cu);
                var model_ = _v2.a;
                var cmd_ = _v2.b;
                return _Utils_Tuple2($elm$core$Maybe$Just(model_), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$VirtualBankAccountsComponentMsg, cmd_));
            } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        }();
        var virtualBankAccountModel = _v0.a;
        var virtualBankAccountCmd = _v0.b;
        var _v4 = $author$project$Components$Invoice$initFormFields(config.Cu.cP);
        var fields = _v4.a;
        return _Utils_Tuple2({
            cw: $author$project$Utils$Form$init(fields),
            k3: config.k3,
            hB: $elm$core$Maybe$Nothing,
            acy: config.acy,
            hQ: $elm$core$Maybe$Nothing,
            lH: $elm$core$Maybe$Nothing,
            cP: config.Cu.cP,
            ib: $elm$core$Maybe$Nothing,
            it: $author$project$Components$Invoice$DownloadFile$init(config.Cu.aaT),
            l_: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toTopRight($author$project$Ui$Dropdown$defaultConfig({
                aef: 'invoice-actions-dropdown-menu',
                ahX: $author$project$Components$Invoice$DropdownMenuMsg
            }))),
            Rr: $author$project$Api$Data$Loading,
            RA: $author$project$Api$Data$Loading,
            yn: $elm$core$Maybe$Nothing,
            eb: $elm$core$Maybe$Nothing,
            fU: $elm$core$Maybe$Nothing,
            RL: config.RL,
            F3: $author$project$Shared$isHintAdmin(config.Cu),
            Gc: config.Gc,
            eh: $elm$core$Maybe$Nothing,
            r2: config.r2,
            js: A4($author$project$Components$Invoice$PaymentsHistory$init, config.Cu.HO, A2($author$project$Components$Invoice$paymentsBasePath, config.Z$, config.RL), config.Z$, true),
            W1: practice,
            sp: config.Cu.sp,
            eC: $elm$core$Maybe$Nothing,
            j_: $author$project$Api$Data$NotAsked,
            Z$: config.Z$,
            om: false,
            on: false,
            oo: false,
            HO: config.Cu.HO,
            aaT: config.Cu.aaT,
            tF: virtualBankAccountModel,
            tG: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Components$Invoice$retrieveInvoice, config.Ej, config.Z$, config.RL),
            virtualBankAccountCmd,
            A4($author$project$Components$Invoice$retrieveIntegrationRecords, $author$project$Shared$isHintAdmin(config.Cu), config.Ej, config.Z$, config.RL)
        ])));
    };
    var $author$project$Components$Invoice$Summary$Affiliate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$Company = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$GotSummary = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceDate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceDueDate = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Invoice$Summary$allLines = function(_v0) {
        var record = _v0;
        return record.I4;
    };
    var $author$project$Api$Common$Invoice$Summary$AllLines$count = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, 0, record.DL.Me);
    };
    var $author$project$Api$Provider$Invoice$One$createdAt = function(_v0) {
        var record = _v0.b;
        return record.Mx;
    };
    var $author$project$Api$Invoice$One$createdAt = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Invoice$One$createdAt(invoice_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Components$Invoice$Deleted = F2(function(a, b) {
        return {
            $: 19,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Company$Invoice$delete = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id)));
    });
    var $author$project$Api$Company$Invoice$delete = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Company$Invoice$delete, apiClient, companyId, id, toMsg);
    });
    var $author$project$Api$Provider$AffiliateBill$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$AffiliateBill$affiliateBillPath(id)));
    });
    var $author$project$Components$Invoice$delete = F4(function(apiClient, session, invoiceType, invoice) {
        if (!invoiceType.$) {
            var id = invoiceType.b;
            return A3($author$project$Api$Provider$AffiliateBill$delete, apiClient, id, $author$project$Components$Invoice$Deleted(invoice));
        } else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A5($author$project$Api$Company$Invoice$delete, apiClient, session, companyId, id, $author$project$Components$Invoice$Deleted(invoice));
        }
    });
    var $author$project$Api$Employer$Invoice$Shared$dueDate = function(_v0) {
        var record = _v0;
        return record.Ok;
    };
    var $author$project$Api$Employer$Invoice$One$dueDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$dueDate(shared);
    };
    var $author$project$Api$Provider$Invoice$Shared$dueDate = function(_v0) {
        var record = _v0.b;
        return record.Ok;
    };
    var $author$project$Api$Provider$Invoice$One$dueDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$dueDate(shared);
    };
    var $author$project$Api$Invoice$One$dueDate = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$dueDate(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$dueDate(invoice_);
        }
    };
    var $author$project$Api$Provider$Invoice$One$date = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$invoiceDate(shared);
    };
    var $author$project$Api$Employer$Invoice$Shared$invoiceDate = function(_v0) {
        var record = _v0;
        return record.RG;
    };
    var $author$project$Api$Employer$Invoice$One$invoiceDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$invoiceDate(shared);
    };
    var $author$project$Api$Invoice$One$invoiceDate = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$date(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$invoiceDate(invoice_);
        }
    };
    var $author$project$Components$Invoice$formFieldsFromInvoice = function(invoice) {
        var _v0 = $author$project$Components$DateInput$init;
        var invoiceDateInput = _v0.a;
        var invoiceDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            RG: $author$project$Api$Invoice$One$invoiceDate(invoice),
            mD: invoiceDateInput,
            iY: $author$project$Api$Invoice$One$dueDate(invoice),
            mE: invoiceDateInput
        }, _List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceDateInputMsg(invoiceDateInput), invoiceDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceDueDateInputMsg(invoiceDateInput), invoiceDateInputCmd)
        ]));
    };
    var $author$project$Components$AuditTrailLog$PopoverMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$AuditTrailLog$init = F7(function(session, url, timeFormatter, resource, resourceId, resourceCreatedAt, filter) {
        return {
            pB: $author$project$Api$Data$Loading,
            Fw: filter,
            af_: $author$project$Api$Pagination$init,
            aN: A3($author$project$Ui$Popover$init, 'audit-history', false, $author$project$Components$AuditTrailLog$PopoverMsg),
            Hg: resource,
            Ca: resourceCreatedAt,
            Hh: resourceId,
            Z$: session,
            cs: _List_Nil,
            HO: timeFormatter,
            DK: 0,
            aaT: url
        };
    });
    var $author$project$Api$Provider$Report$AffiliateBillLine = 5;
    var $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionDropdownMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$GotEmployeeDivisions = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$InvoiceLine = 4;
    var $author$project$Api$Employer$Company$Shared$allowCustomMembershipPlan = function(_v0) {
        var record = _v0;
        return record.I8;
    };
    var $author$project$Api$Employer$Company$One$allowCustomMembershipPlan = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$allowCustomMembershipPlan(shared);
    };
    var $author$project$Api$Provider$Company$Shared$allowCustomMembershipPlan = function(_v0) {
        var record = _v0;
        return record.I8;
    };
    var $author$project$Api$Provider$Company$One$allowCustomMembershipPlan = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$allowCustomMembershipPlan(shared);
    };
    var $author$project$Api$Company$allowCustomMembershipPlan = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$allowCustomMembershipPlan(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$allowCustomMembershipPlan(company_);
        }
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan = function(company) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) return false;
            else {
                var company__ = company_.a;
                return $author$project$Api$Company$allowCustomMembershipPlan(company__);
            }
        }, company));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$companyId = function(company) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Api$Provider$Company$Min$id(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Api$Company$id(company__);
            }
        }, company));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$GotInvoiceLines = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$EmployeeDivision$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$EmployeeDivision$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$EmployeeDivision$Shared$id(shared);
    };
    var $author$project$Api$Provider$EmployeeDivision$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$EmployeeDivision$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$EmployeeDivision$Shared$id(shared);
    };
    var $author$project$Api$EmployeeDivision$All$id = function(employeeDivision) {
        if (!employeeDivision.$) {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Provider$EmployeeDivision$All$id(employeeDivision_);
        } else {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Employer$EmployeeDivision$All$id(employeeDivision_);
        }
    };
    var $author$project$Api$Provider$InvoiceLine$All$InvoiceLine = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$InvoiceLine$Shared$InvoiceLine = $elm$core$Basics$identity;
    var $author$project$Api$Provider$InvoiceLine$Shared$Record = F3(function(id, date, amountInCents) {
        return {
            Jh: amountInCents,
            M4: date,
            aef: id
        };
    });
    var $author$project$Api$Provider$InvoiceLine$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$Shared$Record))));
    var $author$project$Api$Provider$InvoiceLine$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceLine$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$InvoiceLine$All$Record = function(endDate) {
        return function(patientName) {
            return function(dependentCount) {
                return function(chargeDescription) {
                    return function(categoryName) {
                        return function(shouldHideAmount) {
                            return function(shouldShowMoreInfo) {
                                return function(employeeDivision) {
                                    return function(plan) {
                                        return function(charges) {
                                            return function(createdBy) {
                                                return {
                                                    K1: categoryName,
                                                    K5: chargeDescription,
                                                    K9: charges,
                                                    My: createdBy,
                                                    NK: dependentCount,
                                                    Fm: employeeDivision,
                                                    qv: endDate,
                                                    Wc: patientName,
                                                    GW: plan,
                                                    _d: shouldHideAmount,
                                                    _e: shouldShowMoreInfo
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Charge$ForInvoiceLineAll$Charge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Charge$ForInvoiceLineAll$Record = F2(function(isLocked, meta) {
        return {
            R7: isLocked,
            Ue: meta
        };
    });
    var $author$project$Api$Provider$Charge$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Charge$Meta$Record = function(patient) {
        return function(name) {
            return function(quantity) {
                return function(quantityUom) {
                    return function(priceInCents) {
                        return function(category) {
                            return function(description) {
                                return function(practitioner) {
                                    return function(date) {
                                        return function(endDate) {
                                            return function(location1) {
                                                return function(actions) {
                                                    return {
                                                        tM: actions,
                                                        EL: category,
                                                        M4: date,
                                                        NQ: description,
                                                        qv: endDate,
                                                        aeT: location1,
                                                        zr: name,
                                                        V7: patient,
                                                        agi: practitioner,
                                                        Br: priceInCents,
                                                        Bu: quantity,
                                                        Bv: quantityUom
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Charge$Meta$ActionsRecord = F3(function(edit, destroy, revisable) {
        return {
            NT: destroy,
            Op: edit,
            Y7: revisable
        };
    });
    var $author$project$Api$Provider$Charge$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'revisable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'destroy', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'edit', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$ActionsRecord))));
    var $author$project$Api$Provider$Charge$Meta$EditableRecord = function(editable) {
        return {
            Ot: editable
        };
    };
    var $author$project$Api$Provider$Charge$Meta$editableRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$EditableRecord));
    var $author$project$Api$Provider$Charge$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$Charge$Meta$actionsRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity_uom', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Charge$Meta$editableRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Meta$Record)))))))))))));
    var $author$project$Api$Provider$Charge$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Charge$ForInvoiceLineAll$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Charge$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_locked', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForInvoiceLineAll$Record)));
    var $author$project$Api$Provider$Charge$ForInvoiceLineAll$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$ForInvoiceLineAll$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$EmployeeDivision$Shared$EmployeeDivision = $elm$core$Basics$identity;
    var $author$project$Api$Provider$EmployeeDivision$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$EmployeeDivision$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$Shared$Record)));
    var $author$project$Api$Provider$EmployeeDivision$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$EmployeeDivision$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Session$Shared$Session = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Session$Shared$Record = F2(function(user, organization) {
        return {
            VA: organization,
            aaX: user
        };
    });
    var $author$project$Api$Provider$Session$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Organization$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'user', $author$project$Api$Provider$User$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Session$Shared$Record)));
    var $author$project$Api$Provider$Session$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Session$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$InvoiceLine$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_by', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Session$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charges', $elm$json$Json$Decode$list($author$project$Api$Provider$Charge$ForInvoiceLineAll$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'employee_division', $elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'should_show_more_info', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'should_hide_amount', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'dependent_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$All$Record))))))))))));
    var $author$project$Api$Provider$InvoiceLine$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceLine$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceLine$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$All$InvoiceLine)));
    var $author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath = function(invoiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invoice_lines'
        ]), $author$project$Api$Employer$Invoice$invoicePath(invoiceId));
    };
    var $author$project$Api$Common$InvoiceLine$ListOptionals$defaults = {
        EL: $elm$core$Maybe$Nothing,
        Fm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        GW: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Common$InvoiceLine$ListOptionals$toParams = function(optionals) {
        var options = optionals($author$project$Api$Common$InvoiceLine$ListOptionals$defaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.EL;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'category', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.GW;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'plan', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.Fm;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'employee_division', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Pagination$toApiParams(options.af_),
            $author$project$Api$Sort$toParams(options.ahs)
        ]));
    };
    var $author$project$Api$Employer$Invoice$InvoiceLine$list = F4(function(apiClient, invoiceId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath(invoiceId))));
    });
    var $author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath = F2(function(companyId, invoiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invoice_lines'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId));
    });
    var $author$project$Api$Provider$Company$Invoice$InvoiceLine$list = F5(function(apiClient, companyId, invoiceId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath, companyId, invoiceId))));
    });
    var $author$project$Api$Company$Invoice$InvoiceLine$list = F6(function(apiClient, session, companyId, invoiceId, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Invoice$InvoiceLine$list, apiClient, invoiceId, optionals, toMsg) : A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$list, apiClient, companyId, invoiceId, optionals, toMsg);
    });
    var $author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath = function(affiliateBillId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invoice_lines'
        ]), $author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId));
    };
    var $author$project$Api$Provider$AffiliateBill$InvoiceLine$list = F4(function(apiClient, affiliateBillId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceLine$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$InvoiceLine$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath(affiliateBillId))));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines = F2(function(apiClient, model) {
        var list = function() {
            var _v0 = model.RL;
            if (_v0.$ === 1) {
                var companyId_ = _v0.a;
                var id = _v0.b;
                return A4($author$project$Api$Company$Invoice$InvoiceLine$list, apiClient, model.Z$, companyId_, id);
            } else {
                var id = _v0.b;
                return A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$list, apiClient, id);
            }
        }();
        return A2(list, function(d) {
            return _Utils_update(d, {
                EL: model.fg,
                Fm: A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$All$id, model.Fm),
                af_: model.af_,
                GW: model.agd,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Components$Invoice$InvoiceLinesTable$GotInvoiceLines);
    });
    var $author$project$Api$EmployeeDivision$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$EmployeeDivision$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$EmployeeDivision$All$EmployeeDivision = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$EmployeeDivision$Shared$EmployeeDivision = $elm$core$Basics$identity;
    var $author$project$Api$Employer$EmployeeDivision$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Employer$EmployeeDivision$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$Shared$Record)));
    var $author$project$Api$Employer$EmployeeDivision$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$EmployeeDivision$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$EmployeeDivision$All$Record = F3(function(assignedAccounts, eligibleAccounts, enrolledAccounts) {
        return {
            JD: assignedAccounts,
            OF: eligibleAccounts,
            OW: enrolledAccounts
        };
    });
    var $author$project$Api$Employer$EmployeeDivision$All$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'enrolled_accounts_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'eligible_accounts_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'assigned_accounts_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$All$Record))));
    var $author$project$Api$Employer$EmployeeDivision$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$EmployeeDivision$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$EmployeeDivision$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$EmployeeDivision$All$EmployeeDivision)));
    var $author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'employee_divisions'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$EmployeeDivision$expandToString = function(expand) {
        return 'count';
    };
    var $author$project$Api$Employer$EmployeeDivision$listDefaults = {
        Fq: _List_Nil
    };
    var $author$project$Api$Employer$EmployeeDivision$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Employer$EmployeeDivision$listDefaults);
        return _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Employer$EmployeeDivision$expandToString, options.Fq))
        ]);
    };
    var $author$project$Api$Employer$EmployeeDivision$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$EmployeeDivision$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Employer$EmployeeDivision$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
    });
    var $author$project$Api$Provider$EmployeeDivision$All$EmployeeDivision = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$EmployeeDivision$All$Record = F3(function(assignedAccounts, eligibleAccounts, enrolledAccounts) {
        return {
            JD: assignedAccounts,
            OF: eligibleAccounts,
            OW: enrolledAccounts
        };
    });
    var $author$project$Api$Provider$EmployeeDivision$All$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'enrolled_accounts_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'eligible_accounts_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'assigned_accounts_count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$All$Record))));
    var $author$project$Api$Provider$EmployeeDivision$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$EmployeeDivision$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$EmployeeDivision$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$EmployeeDivision$All$EmployeeDivision)));
    var $author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'employee_divisions'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$EmployeeDivision$expandToString = function(expand) {
        return 'count';
    };
    var $author$project$Api$Provider$Company$EmployeeDivision$listDefaults = {
        Fq: _List_Nil
    };
    var $author$project$Api$Provider$Company$EmployeeDivision$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Company$EmployeeDivision$listDefaults);
        return _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Company$EmployeeDivision$expandToString, options.Fq))
        ]);
    };
    var $author$project$Api$Provider$Company$EmployeeDivision$list = F4(function(apiClient, companyId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$EmployeeDivision$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Company$EmployeeDivision$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
    });
    var $author$project$Api$Employer$EmployeeDivision$Count = 0;
    var $author$project$Api$EmployeeDivision$expandToEmployer = function(expand) {
        return 0;
    };
    var $author$project$Api$EmployeeDivision$listDefaults = {
        Fq: _List_Nil
    };
    var $author$project$Api$EmployeeDivision$optionalsToEmployer = function(optionals) {
        var options = optionals($author$project$Api$EmployeeDivision$listDefaults);
        return function(d) {
            return _Utils_update(d, {
                Fq: A2($elm$core$List$map, $author$project$Api$EmployeeDivision$expandToEmployer, options.Fq)
            });
        };
    };
    var $author$project$Api$Provider$Company$EmployeeDivision$Count = 0;
    var $author$project$Api$EmployeeDivision$expandToProvider = function(expand) {
        return 0;
    };
    var $author$project$Api$EmployeeDivision$optionalsToProvider = function(optionals) {
        var options = optionals($author$project$Api$EmployeeDivision$listDefaults);
        return function(d) {
            return _Utils_update(d, {
                Fq: A2($elm$core$List$map, $author$project$Api$EmployeeDivision$expandToProvider, options.Fq)
            });
        };
    };
    var $author$project$Api$EmployeeDivision$list = F5(function(apiClient, session, companyId, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$EmployeeDivision$list, apiClient, $author$project$Api$EmployeeDivision$optionalsToEmployer(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$EmployeeDivision$All$Employer)))) : A4($author$project$Api$Provider$Company$EmployeeDivision$list, apiClient, companyId, $author$project$Api$EmployeeDivision$optionalsToProvider(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$EmployeeDivision$All$Provider))));
    });
    var $author$project$Api$Employer$Invoice$One$recurring = function(_v0) {
        var record = _v0.b;
        return record.Yk;
    };
    var $author$project$Api$Provider$Invoice$One$recurring = function(_v0) {
        var record = _v0.b;
        return record.Yk;
    };
    var $author$project$Api$Invoice$One$recurring = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$recurring(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$recurring(invoice_);
        }
    };
    var $author$project$Api$Employer$Company$Shared$usesEmployeeDivisions = function(_v0) {
        var record = _v0;
        return record.aa1;
    };
    var $author$project$Api$Employer$Company$One$usesEmployeeDivisions = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$usesEmployeeDivisions(shared);
    };
    var $author$project$Api$Provider$Company$One$usesEmployeeDivisions = function(_v0) {
        var record = _v0.b;
        return record.aa1;
    };
    var $author$project$Api$Company$usesEmployeeDivisions = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$usesEmployeeDivisions(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$usesEmployeeDivisions(company_);
        }
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions = function(company) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) return false;
            else {
                var company__ = company_.a;
                return $author$project$Api$Company$usesEmployeeDivisions(company__);
            }
        }, company));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$init = F7(function(currentDate, apiClient, session, practice, company, invoiceType, invoice) {
        var resource = function() {
            if (invoiceType.$ === 1) return 4;
            else return 5;
        }();
        var q = $elm$core$Maybe$Nothing;
        var _v0 = $author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(company) ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                En: $elm$core$Maybe$Just($author$project$Components$Invoice$InvoiceLinesTable$companyId(company))
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'All Plans'
            });
        })) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        var planResourceFilter = _v0.a;
        var planResourceFilterCmd = _v0.b;
        var _v1 = A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'All Categories',
                U5: 'Unassigned',
                afn: true
            });
        });
        var categoryResourceFilter = _v1.a;
        var categoryResourceFilterCmd = _v1.b;
        var model = {
            ht: $elm$core$Maybe$Nothing,
            fg: $elm$core$Maybe$Nothing,
            cK: categoryResourceFilter,
            acy: company,
            cP: currentDate,
            fv: $elm$core$Maybe$Nothing,
            dR: $elm$core$Set$empty,
            Fm: $elm$core$Maybe$Nothing,
            l5: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'employee-division-dropdown-filter',
                ahX: $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionDropdownMsg
            })),
            xv: $author$project$Api$Data$Loading,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: resource
            }),
            RA: invoice,
            ar: $author$project$Api$Data$Loading,
            RL: invoiceType,
            af_: $author$project$Api$Pagination$init,
            en: $elm$core$Dict$empty,
            agd: $elm$core$Maybe$Nothing,
            jy: planResourceFilter,
            W1: practice,
            agq: q,
            BE: $author$project$Api$Invoice$One$recurring(invoice),
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init)
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, model),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg, planResourceFilterCmd),
            $author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(company) ? A5($author$project$Api$EmployeeDivision$list, apiClient, session, $author$project$Components$Invoice$InvoiceLinesTable$companyId(company), function(d) {
                return d;
            }, $author$project$Components$Invoice$InvoiceLinesTable$GotEmployeeDivisions) : $elm$core$Platform$Cmd$none
        ])));
    });
    var $author$project$Components$Invoice$Summary$GotDelta = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$Model = $elm$core$Basics$identity;
    var $author$project$Components$Invoice$Summary$EmployeeDivision = 1;
    var $author$project$Components$Invoice$Summary$Plan = 0;
    var $author$project$Components$Invoice$Summary$Sponsor = 2;
    var $author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan = function(company) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) return false;
            else {
                var company__ = company_.a;
                return $author$project$Api$Company$allowCustomMembershipPlan(company__);
            }
        }, company));
    };
    var $author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions = function(company) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) return false;
            else {
                var company__ = company_.a;
                return $author$project$Api$Company$usesEmployeeDivisions(company__);
            }
        }, company));
    };
    var $author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines = function(_v0) {
        var record = _v0;
        return record._T;
    };
    var $author$project$Components$Invoice$Summary$groupBy = F3(function(company, summary, showSponsor) {
        return showSponsor ? $elm$core$Maybe$Just(2) : $author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(company) ? $elm$core$Maybe$Just(0) : $author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions(company) && $elm$core$List$isEmpty($author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines(summary)) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$Invoice$Summary$OtherChargesSummary$init = function(recurringInvoice) {
        return {
            BE: recurringInvoice,
            gS: false
        };
    };
    var $author$project$Api$Common$Invoice$Delta$Delta = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Delta$Record = F2(function(added, removed) {
        return {
            IA: added,
            Yz: removed
        };
    });
    var $author$project$Api$Provider$InvoicePatient$Shared$InvoicePatient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$InvoicePatient$Shared$Record = F4(function(name, startDate, endDate, owner) {
        return {
            qv: endDate,
            zr: name,
            VM: owner,
            _0: startDate
        };
    });
    var $author$project$Api$Provider$InvoicePatient$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoicePatient$Shared$Record)))));
    var $author$project$Api$Provider$InvoicePatient$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoicePatient$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Delta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'removed', $elm$json$Json$Decode$list($author$project$Api$Provider$InvoicePatient$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'added', $elm$json$Json$Decode$list($author$project$Api$Provider$InvoicePatient$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Delta$Record)));
    var $author$project$Api$Common$Invoice$Delta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Delta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Invoice$Delta$deltaPath = function(invoiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'delta'
        ]), $author$project$Api$Employer$Invoice$invoicePath(invoiceId));
    };
    var $author$project$Api$Employer$Invoice$Delta$retrieve = F3(function(apiClient, invoiceId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$Invoice$Delta$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Invoice$Delta$deltaPath(invoiceId)));
    });
    var $author$project$Api$Provider$Company$Invoice$Delta$deltaPath = F2(function(companyId, invoiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'delta'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId));
    });
    var $author$project$Api$Provider$Company$Invoice$Delta$retrieve = F4(function(apiClient, companyId, invoiceId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$Invoice$Delta$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Invoice$Delta$deltaPath, companyId, invoiceId)));
    });
    var $author$project$Api$Company$Invoice$Delta$retrieve = F5(function(apiClient, session, companyId, invoiceId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$Delta$retrieve, apiClient, invoiceId, toMsg) : A4($author$project$Api$Provider$Company$Invoice$Delta$retrieve, apiClient, companyId, invoiceId, toMsg);
    });
    var $author$project$Api$Provider$AffiliateBill$Delta$deltaPath = function(affiliateBillId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'delta'
        ]), $author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId));
    };
    var $author$project$Api$Provider$AffiliateBill$Delta$retrieve = F3(function(apiClient, affiliateBillId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$Invoice$Delta$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$AffiliateBill$Delta$deltaPath(affiliateBillId)));
    });
    var $author$project$Api$Employer$Company$Shared$companyType = function(_v0) {
        var record = _v0;
        return record.LR;
    };
    var $author$project$Api$Employer$Company$One$companyType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$companyType(shared);
    };
    var $author$project$Api$Provider$Company$Shared$companyType = function(_v0) {
        var record = _v0;
        return record.LR;
    };
    var $author$project$Api$Provider$Company$One$companyType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$companyType(shared);
    };
    var $author$project$Api$Company$companyType = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$companyType(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$companyType(company_);
        }
    };
    var $author$project$Api$Provider$Company$Min$companyType = function(_v0) {
        var record = _v0;
        return record.LR;
    };
    var $author$project$Components$Invoice$Summary$companyType = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Api$Provider$Company$Min$companyType(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Api$Company$companyType(company__);
            }
        }, company);
    };
    var $author$project$Components$Invoice$Summary$companyIsNetwork = function(company) {
        return _Utils_eq($author$project$Components$Invoice$Summary$companyType(company), $elm$core$Maybe$Just(0));
    };
    var $author$project$Components$Invoice$Summary$showSponsorBreakdown = F3(function(invoiceType, session, company) {
        var organizationIsPractice = $author$project$Api$Platform$Session$One$organizationIsAdminPractice(session);
        var isAffiliateBill = function() {
            if (!invoiceType.$) return true;
            else return false;
        }();
        return organizationIsPractice && ($author$project$Components$Invoice$Summary$companyIsNetwork(company) || isAffiliateBill);
    });
    var $author$project$Components$Invoice$Summary$init = F8(function(apiClient, session, timeFormatter, practice, company, invoiceType, invoice, summary) {
        var recurringInvoice = $author$project$Api$Invoice$One$recurring(invoice);
        var organizationIsPractice = $author$project$Api$Platform$Session$One$organizationIsAdminPractice(session);
        var groupBy_ = A3($author$project$Components$Invoice$Summary$groupBy, company, summary, A3($author$project$Components$Invoice$Summary$showSponsorBreakdown, invoiceType, session, company));
        return _Utils_Tuple2({
            acy: company,
            xf: $author$project$Api$Data$Loading,
            fQ: groupBy_,
            RA: invoice,
            RL: invoiceType,
            rN: $author$project$Components$Invoice$Summary$OtherChargesSummary$init(recurringInvoice),
            nm: $elm$core$Maybe$Nothing,
            W1: practice,
            Z$: session,
            gR: false,
            gT: organizationIsPractice && !_Utils_eq(groupBy_, $elm$core$Maybe$Nothing),
            $x: summary,
            HO: timeFormatter
        }, function() {
            if (!invoiceType.$) {
                var id = invoiceType.a;
                return A3($author$project$Api$Provider$AffiliateBill$Delta$retrieve, apiClient, id, $author$project$Components$Invoice$Summary$GotDelta);
            } else {
                var companyId = invoiceType.a;
                var id = invoiceType.b;
                return A5($author$project$Api$Company$Invoice$Delta$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$Summary$GotDelta);
            }
        }());
    });
    var $author$project$Api$Provider$Notification$EmployerInvoiceCreated = 1;
    var $author$project$Components$CompanyEmailModal$Loading = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Notification$Company = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CompanyEmailModal$GotPreview = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Notification$One$Notification = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Notification$Shared$Notification = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Notification$Shared$Record = F9(function(subject, body, attemptedAt, failedAt, recipientEmail, shortDescription, errorMessage, clickedAt, openedAt) {
        return {
            JK: attemptedAt,
            fb: body,
            Lh: clickedAt,
            O4: errorMessage,
            Pp: failedAt,
            Vx: openedAt,
            Yh: recipientEmail,
            Z7: shortDescription,
            HF: subject
        };
    });
    var $author$project$Api$Provider$Notification$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'opened_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'clicked_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'short_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'recipient_email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'failed_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'attempted_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'body', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subject', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$Shared$Record))))))))));
    var $author$project$Api$Provider$Notification$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Notification$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Notification$One$Record = F3(function(subjectHtml, bodyHtml, shortDescriptionHtml) {
        return {
            Kl: bodyHtml,
            Z8: shortDescriptionHtml,
            $p: subjectHtml
        };
    });
    var $author$project$Api$Provider$Notification$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'short_description_html', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'body_html', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subject_html', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$One$Record))));
    var $author$project$Api$Provider$Notification$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Notification$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Notification$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Notification$One$Notification)));
    var $author$project$Api$Provider$Notification$previewNotificationPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'preview'
    ]), $author$project$Api$Provider$Notification$notificationsPath);
    var $author$project$Api$Provider$Notification$typeToString = function(type_) {
        if (!type_) return 'customer_invoice';
        else return 'employer_invoice_created';
    };
    var $author$project$Api$Provider$Notification$preview = F6(function(apiClient, type_, recipient, contextId, fields, toMsg) {
        var body_ = $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                _Utils_Tuple2('context_id', $elm$json$Json$Encode$string(contextId)),
                _Utils_Tuple2('type', $elm$json$Json$Encode$string($author$project$Api$Provider$Notification$typeToString(type_)))
            ]),
            function() {
                if (!recipient.$) {
                    var patientId = recipient.a;
                    return _List_fromArray([
                        _Utils_Tuple2('patient', $elm$json$Json$Encode$string(patientId))
                    ]);
                } else {
                    var companyId = recipient.a;
                    return _List_fromArray([
                        _Utils_Tuple2('company', $elm$json$Json$Encode$string(companyId))
                    ]);
                }
            }(),
            function() {
                var _v1 = fields.HF;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        _Utils_Tuple2('subject', $elm$json$Json$Encode$string(string))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = fields.fb;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        _Utils_Tuple2('body', $elm$json$Json$Encode$string(string))
                    ]);
                } else return _List_Nil;
            }()
        ])));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Notification$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo($author$project$Api$Provider$Notification$previewNotificationPath)));
    });
    var $author$project$Components$CompanyEmailModal$previewNotification = F3(function(apiClient, shared, formFields) {
        var fields = function() {
            var _v1 = A2($elm$core$Maybe$map, $rtfeldman$elm_validate$Validate$fromValid, formFields);
            if (!_v1.$) {
                var fields_ = _v1.a;
                return {
                    fb: fields_.fb,
                    HF: fields_.HF
                };
            } else return {
                fb: $elm$core$Maybe$Nothing,
                HF: $elm$core$Maybe$Nothing
            };
        }();
        var _v0 = shared;
        var type_ = _v0.ah5;
        var contextId = _v0.wU;
        var recipient = _v0.BD;
        return A6($author$project$Api$Provider$Notification$preview, apiClient, type_, $author$project$Api$Provider$Notification$Company($author$project$Api$Provider$Company$One$id(recipient)), contextId, fields, $author$project$Components$CompanyEmailModal$GotPreview);
    });
    var $author$project$Components$CompanyEmailModal$init = F6(function(apiClient, type_, contextId, recipient, header, beforeSend) {
        var shared = {
            Es: beforeSend,
            wU: contextId,
            qQ: header,
            BD: recipient,
            ah5: type_
        };
        return _Utils_Tuple2($author$project$Components$CompanyEmailModal$Loading(shared), A3($author$project$Components$CompanyEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing));
    });
    var $author$project$Api$Provider$Company$Invoice$makeViewable = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_viewable'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
    });
    var $author$project$Api$Company$Invoice$makeViewable = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Company$Invoice$makeViewable, apiClient, companyId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
    });
    var $author$project$Components$Invoice$makeViewable = F3(function(apiClient, session, invoiceType) {
        if (!invoiceType.$) return function(_v1) {
            return $elm$core$Platform$Cmd$none;
        };
        else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A4($author$project$Api$Company$Invoice$makeViewable, apiClient, session, companyId, id);
        }
    });
    var $author$project$Components$Invoice$initCompanyEmailModal = F4(function(apiClient, model, invoice, makeViewable_) {
        var _v0 = model.acy;
        if (!_v0.$ && _v0.a.$ === 1 && !_v0.a.a.$) {
            var company = _v0.a.a.a;
            var _v1 = makeViewable_ ? _Utils_Tuple2($elm$core$Maybe$Just($elm$core$String$concat(_List_fromArray([
                'Sending this invoice to ',
                $author$project$Api$Provider$Company$One$name(company),
                ' will make it available on their employer portal, and will also send them the email below. ',
                'Invoices can be shared while still in draft mode.'
            ]))), $elm$core$Maybe$Just(A3($author$project$Components$Invoice$makeViewable, apiClient, model.Z$, model.RL))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
            var header = _v1.a;
            var cmd = _v1.b;
            var _v2 = A6($author$project$Components$CompanyEmailModal$init, apiClient, 1, $author$project$Api$Invoice$One$id(invoice), company, header, cmd);
            var companyEmailModal = _v2.a;
            var companyEmailModalCmd = _v2.b;
            return _Utils_Tuple2(_Utils_update(model, {
                hQ: $elm$core$Maybe$Just(companyEmailModal)
            }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CompanyEmailModalMsg, companyEmailModalCmd));
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Invoice$CreatePaymentModal$AffiliateBill = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreatePaymentModal$Invoice = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Company$companyPath = F2(function(session, companyId) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(companyId);
    });
    var $author$project$Components$Invoice$sourceBasePath = F2(function(session, invoiceType) {
        if (!invoiceType.$) {
            var affiliateId = invoiceType.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
        } else {
            var companyId = invoiceType.a;
            return $elm$core$Maybe$Just(A2($author$project$Api$Company$companyPath, session, companyId));
        }
    });
    var $author$project$Components$Invoice$initCreatePaymentModal = F4(function(apiClient, model, invoice, external) {
        var createPaymentModalInvoice = function() {
            var _v1 = model.RL;
            if (!_v1.$) {
                var affiliateId = _v1.a;
                return A2($author$project$Components$Invoice$CreatePaymentModal$AffiliateBill, affiliateId, invoice);
            } else {
                var companyId = _v1.a;
                return A2($author$project$Components$Invoice$CreatePaymentModal$Invoice, companyId, invoice);
            }
        }();
        var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.cP)(model.HO)(A2($author$project$Components$Invoice$paymentsBasePath, model.Z$, model.RL))(A2($author$project$Components$Invoice$sourceBasePath, model.Z$, model.RL))(apiClient)(model.Z$)(model.W1)(model.F3)(model.sp)(function(d) {
            return _Utils_update(d, {
                Po: external,
                or: model.F3
            });
        })(createPaymentModalInvoice);
        var createPaymentModal = _v0.a;
        var createPaymentModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            lH: $elm$core$Maybe$Just(createPaymentModal)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModalMsg, createPaymentModalCmd));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$EmployerOrProviderCompany = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$ProviderMin = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$invoiceLinesTableCompany = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Components$Invoice$InvoiceLinesTable$ProviderMin(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Components$Invoice$InvoiceLinesTable$EmployerOrProviderCompany(company__);
            }
        }, company);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$Affiliate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$Company = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$invoiceLinesTableInvoiceType = function(invoiceType) {
        if (!invoiceType.$) {
            var affiliateId = invoiceType.a;
            var id = invoiceType.b;
            return A2($author$project$Components$Invoice$InvoiceLinesTable$Affiliate, affiliateId, id);
        } else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A2($author$project$Components$Invoice$InvoiceLinesTable$Company, companyId, id);
        }
    };
    var $author$project$Components$Invoice$Summary$EmployerOrProviderCompany = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$ProviderMin = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$invoiceSummaryCompany = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Components$Invoice$Summary$ProviderMin(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Components$Invoice$Summary$EmployerOrProviderCompany(company__);
            }
        }, company);
    };
    var $author$project$Api$Provider$Invoice$One$isUpdating = function(_v0) {
        var record = _v0.b;
        return record.SA;
    };
    var $author$project$Api$Invoice$One$isUpdating = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$isUpdating(invoice_);
        } else return false;
    };
    var $author$project$Components$Invoice$Issued = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Api$Employer$Invoice$issue = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'issue'
        ]), $author$project$Api$Employer$Invoice$invoicePath(id))));
    });
    var $author$project$Api$Provider$Company$Invoice$issue = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'issue'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
    });
    var $author$project$Api$Company$Invoice$issue = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$issue, apiClient, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Employer))) : A4($author$project$Api$Provider$Company$Invoice$issue, apiClient, companyId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
    });
    var $author$project$Api$Provider$AffiliateBill$issue = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'issue'
        ]), $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
    });
    var $author$project$Components$Invoice$issue = F3(function(apiClient, session, invoiceType) {
        if (!invoiceType.$) {
            var id = invoiceType.b;
            return A3($author$project$Api$Provider$AffiliateBill$issue, apiClient, id, A2($elm$core$Basics$composeL, $author$project$Components$Invoice$Issued, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
        } else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A5($author$project$Api$Company$Invoice$issue, apiClient, session, companyId, id, $author$project$Components$Invoice$Issued);
        }
    });
    var $author$project$Components$Invoice$MarkedAsBadDebt = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Company$Invoice$markAsBadDebt = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'mark_as_bad_debt'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
    });
    var $author$project$Api$Company$Invoice$markAsBadDebt = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Company$Invoice$markAsBadDebt, apiClient, companyId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
    });
    var $author$project$Components$Invoice$markAsBadDebt = F4(function(apiClient, session, invoiceType, invoice) {
        if (!invoiceType.$) return $elm$core$Platform$Cmd$none;
        else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A5($author$project$Api$Company$Invoice$markAsBadDebt, apiClient, session, companyId, id, $author$project$Components$Invoice$MarkedAsBadDebt(invoice));
        }
    });
    var $author$project$Components$Invoice$PollInvoiceStatus = {
        $: 33
    };
    var $author$project$Components$Invoice$pollInvoiceForStatus = A2($elm$core$Task$perform, function(_v0) {
        return $author$project$Components$Invoice$PollInvoiceStatus;
    }, $elm$core$Process$sleep(2000));
    var $author$project$Api$Common$Invoice$Summary$Summary = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$Record = F9(function(sponsorFeeDealLines, activeLines, allLines, byPlan, byEmployeeDivision, bySponsor, membershipAdjustmentLines, nonMembershipAdjustmentLines, byCategory) {
        return {
            It: activeLines,
            I4: allLines,
            Kz: byCategory,
            KA: byEmployeeDivision,
            KB: byPlan,
            KC: bySponsor,
            TY: membershipAdjustmentLines,
            U4: nonMembershipAdjustmentLines,
            _T: sponsorFeeDealLines
        };
    });
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$ActiveLines = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Record = function(totals) {
        return {
            DL: totals
        };
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$TotalsRecord = F3(function(count, numberOfDependents, amountInCents) {
        return {
            Jh: amountInCents,
            Me: count,
            Vb: numberOfDependents
        };
    });
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_of_dependents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$TotalsRecord))));
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'totals', $author$project$Api$Common$Invoice$Summary$ActiveLines$totalsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$Record));
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$ActiveLines$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$AllLines$AllLines = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$AllLines$Record = function(totals) {
        return {
            DL: totals
        };
    };
    var $author$project$Api$Common$Invoice$Summary$AllLines$TotalsRecord = F2(function(amountInCents, count) {
        return {
            Jh: amountInCents,
            Me: count
        };
    });
    var $author$project$Api$Common$Invoice$Summary$AllLines$totalsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$AllLines$TotalsRecord)));
    var $author$project$Api$Common$Invoice$Summary$AllLines$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'totals', $author$project$Api$Common$Invoice$Summary$AllLines$totalsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$AllLines$Record));
    var $author$project$Api$Common$Invoice$Summary$AllLines$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$AllLines$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$ByCategory$ByCategory = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$ByCategory$Record = function(nonMembershipAdjustmentLines) {
        return {
            U4: nonMembershipAdjustmentLines
        };
    };
    var $author$project$Api$Common$Invoice$Summary$ByCategory$NonMembershipAdjustmentLinesRecord = function(rows) {
        return {
            Zc: rows
        };
    };
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Row = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Record = F3(function(count, amountInCents, categoryName) {
        return {
            Jh: amountInCents,
            K1: categoryName,
            Me: count
        };
    });
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$Record))));
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows', $elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ByCategory$NonMembershipAdjustmentLinesRecord));
    var $author$project$Api$Common$Invoice$Summary$ByCategory$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'non_membership_adjustment_lines', $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ByCategory$Record));
    var $author$project$Api$Common$Invoice$Summary$ByCategory$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$ByCategory$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$Grouped$Grouped = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$Grouped$Record = F2(function(activeLines, membershipAdjustmentLines) {
        return {
            It: activeLines,
            TY: membershipAdjustmentLines
        };
    });
    var $author$project$Api$Common$Invoice$Summary$Grouped$ActiveLinesRecord = function(rows) {
        return {
            Zc: rows
        };
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Row = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Record = F6(function(count, amountInCents, numberOfDependents, planName, divisionName, companyName) {
        return {
            Jh: amountInCents,
            LN: companyName,
            Me: count,
            Oc: divisionName,
            Vb: numberOfDependents,
            WM: planName
        };
    });
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'company_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'division_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'plan_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_of_dependents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$Record)))))));
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows', $elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$ActiveLinesRecord));
    var $author$project$Api$Common$Invoice$Summary$Grouped$MembershipAdjustmentLinesRecord = function(rows) {
        return {
            Zc: rows
        };
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Row = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Record = F7(function(count, amountInCents, planName, divisionName, companyName, numberOfOtherCharges, numberOfMembershipCharges) {
        return {
            Jh: amountInCents,
            LN: companyName,
            Me: count,
            Oc: divisionName,
            Vd: numberOfMembershipCharges,
            Ve: numberOfOtherCharges,
            WM: planName
        };
    });
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_of_membership_charges', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_of_other_charges', $elm$json$Json$Decode$int, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'company_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'division_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'plan_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$Record))))))));
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows', $elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$MembershipAdjustmentLinesRecord));
    var $author$project$Api$Common$Invoice$Summary$Grouped$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_adjustment_lines', $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_lines', $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Grouped$Record)));
    var $author$project$Api$Common$Invoice$Summary$Grouped$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$Grouped$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$MembershipAdjustmentLines = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Record = function(totals) {
        return {
            DL: totals
        };
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$TotalsRecord = F4(function(count, amountInCents, numberOfOtherCharges, numberOfMembershipCharges) {
        return {
            Jh: amountInCents,
            Me: count,
            Vd: numberOfMembershipCharges,
            Ve: numberOfOtherCharges
        };
    });
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_of_membership_charges', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_of_other_charges', $elm$json$Json$Decode$int, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'amount_in_cents', $elm$json$Json$Decode$int, 0, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$TotalsRecord)))));
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'totals', $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Record));
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$NonMembershipAdjustmentLines = $elm$core$Basics$identity;
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Record = function(totals) {
        return {
            DL: totals
        };
    };
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$TotalsRecord = F2(function(count, amountInCents) {
        return {
            Jh: amountInCents,
            Me: count
        };
    });
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$TotalsRecord)));
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'totals', $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Record));
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$SponsorFeeDealLine = 0;
    var $author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Common$Invoice$Summary$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'by_category', $elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$ByCategory$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'non_membership_adjustment_lines', $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_adjustment_lines', $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'by_sponsor', $elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'by_employee_division', $elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'by_plan', $elm$json$Json$Decode$nullable($author$project$Api$Common$Invoice$Summary$Grouped$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'all_lines', $author$project$Api$Common$Invoice$Summary$AllLines$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_lines', $author$project$Api$Common$Invoice$Summary$ActiveLines$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsor_fee_deal_lines', $elm$json$Json$Decode$list($author$project$Api$Common$Invoice$Summary$SponsorFeeDealLine$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Common$Invoice$Summary$Record))))))))));
    var $author$project$Api$Common$Invoice$Summary$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Invoice$Summary$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Invoice$Summary$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$Invoice$Summary$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'summary'
        ]), $author$project$Api$Employer$Invoice$invoicePath(id))));
    });
    var $author$project$Api$Provider$Invoice$Summary$retrieve = F4(function(apiClient, companyId, invoiceId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$Invoice$Summary$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'summary'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, invoiceId))));
    });
    var $author$project$Api$Company$Invoice$Summary$retrieve = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$Summary$retrieve, apiClient, id, toMsg) : A4($author$project$Api$Provider$Invoice$Summary$retrieve, apiClient, companyId, id, toMsg);
    });
    var $author$project$Api$Provider$AffiliateBill$Summary$retrieve = F3(function(apiClient, affiliateBillId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$Invoice$Summary$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'summary'
        ]), $author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId))));
    });
    var $author$project$Components$Invoice$GotCompanyInvoiceStatus = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$retrieveInvoiceStatus = F3(function(apiClient, session, invoiceType) {
        if (!invoiceType.$) {
            var id = invoiceType.b;
            return A3($author$project$Api$Provider$AffiliateBill$retrieve, apiClient, id, A2($elm$core$Basics$composeL, $author$project$Components$Invoice$GotCompanyInvoiceStatus, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
        } else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A5($author$project$Api$Company$Invoice$retrieve, apiClient, session, companyId, id, $author$project$Components$Invoice$GotCompanyInvoiceStatus);
        }
    });
    var $author$project$Components$Invoice$ReturnedToDraft = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Company$Invoice$returnToDraft = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'return_to_draft'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
    });
    var $author$project$Api$Company$Invoice$returnToDraft = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Company$Invoice$returnToDraft, apiClient, companyId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
    });
    var $author$project$Api$Provider$AffiliateBill$returnToDraft = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'return_to_draft'
        ]), $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
    });
    var $author$project$Components$Invoice$returnToDraft = F4(function(apiClient, session, invoiceType, invoice) {
        if (!invoiceType.$) {
            var id = invoiceType.b;
            return A3($author$project$Api$Provider$AffiliateBill$returnToDraft, apiClient, id, A2($elm$core$Basics$composeL, $author$project$Components$Invoice$ReturnedToDraft(invoice), $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
        } else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A5($author$project$Api$Company$Invoice$returnToDraft, apiClient, session, companyId, id, $author$project$Components$Invoice$ReturnedToDraft(invoice));
        }
    });
    var $author$project$Components$Invoice$ReversedBadDebt = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$Invoice$reverseBadDebt = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reverse_bad_debt'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
    });
    var $author$project$Api$Company$Invoice$reverseBadDebt = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Company$Invoice$reverseBadDebt, apiClient, companyId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
    });
    var $author$project$Components$Invoice$reverseBadDebt = F3(function(apiClient, session, invoiceType) {
        if (!invoiceType.$) return $elm$core$Platform$Cmd$none;
        else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A5($author$project$Api$Company$Invoice$reverseBadDebt, apiClient, session, companyId, id, $author$project$Components$Invoice$ReversedBadDebt);
        }
    });
    var $author$project$Components$AuditTrailLog$GotAudits = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Audit$Audit = $elm$core$Basics$identity;
    var $author$project$Api$Audit$AuditRecord = F7(function(id, name, createdAt, whodunnit, crumbs, role, aggregate) {
        return {
            vq: aggregate,
            Mx: createdAt,
            MG: crumbs,
            aef: id,
            zr: name,
            ag_: role,
            abr: whodunnit
        };
    });
    var $author$project$Api$Audit$Crumb$Crumb = F4(function(createdAt, item, diff, verb) {
        return {
            Mx: createdAt,
            NZ: diff,
            F6: item,
            aba: verb
        };
    });
    var $author$project$Api$Audit$Crumb$Plain = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Audit$Crumb$Record = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Audit$Crumb$Linkable = F5(function(id, label, routeParts, type_, extraUrl) {
        return {
            adH: extraUrl,
            aef: id,
            aeI: label,
            ag$: routeParts,
            ah5: type_
        };
    });
    var $elm$json$Json$Decode$map5 = _Json_map5;
    var $author$project$Api$Audit$Crumb$linkableDecoder = A6($elm$json$Json$Decode$map5, $author$project$Api$Audit$Crumb$Linkable, A2($elm$json$Json$Decode$at, _List_fromArray([
        'id'
    ]), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$at, _List_fromArray([
        'label'
    ]), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$at, _List_fromArray([
        'route_parts'
    ]), $elm$json$Json$Decode$list($elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$at, _List_fromArray([
        'type'
    ]), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$at, _List_fromArray([
        'extra_url'
    ]), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
    var $author$project$Api$Audit$Crumb$decodeChange = A2($elm$json$Json$Decode$andThen, function(changesList) {
        if (changesList.b && changesList.b.b && !changesList.b.b.b) {
            var from = changesList.a;
            var _v1 = changesList.b;
            var to = _v1.a;
            return $elm$json$Json$Decode$succeed(_Utils_Tuple2(from, to));
        } else return $elm$json$Json$Decode$fail('Expected changes to be of length 2');
    }, $elm$json$Json$Decode$list($elm$json$Json$Decode$nullable($elm$json$Json$Decode$oneOf(_List_fromArray([
        A2($elm$json$Json$Decode$map, $author$project$Api$Audit$Crumb$Plain, $elm$json$Json$Decode$string),
        A2($elm$json$Json$Decode$map, $author$project$Api$Audit$Crumb$Plain, A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int)),
        A2($elm$json$Json$Decode$map, $author$project$Api$Audit$Crumb$Plain, A2($elm$json$Json$Decode$map, $author$project$Formatters$Bool$toString, $elm$json$Json$Decode$bool)),
        A2($elm$json$Json$Decode$map, $author$project$Api$Audit$Crumb$Record, $author$project$Api$Audit$Crumb$linkableDecoder)
    ])))));
    var $author$project$Api$Audit$Crumb$Create = 0;
    var $author$project$Api$Audit$Crumb$Delete = 2;
    var $author$project$Api$Audit$Crumb$Update = 1;
    var $author$project$Api$Audit$Crumb$decodeEvent = A2($elm$json$Json$Decode$andThen, function(stringEvent) {
        switch(stringEvent){
            case 'create':
                return $elm$json$Json$Decode$succeed(0);
            case 'update':
                return $elm$json$Json$Decode$succeed(1);
            case 'destroy':
                return $elm$json$Json$Decode$succeed(2);
            default:
                var unsupported = stringEvent;
                return $elm$json$Json$Decode$fail('unsupported event type ' + unsupported);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Audit$Crumb$decode = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'event', $author$project$Api$Audit$Crumb$decodeEvent, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'object_changes', $elm$json$Json$Decode$keyValuePairs($author$project$Api$Audit$Crumb$decodeChange), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'item', $author$project$Api$Audit$Crumb$linkableDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, $elm$json$Json$Decode$succeed($author$project$Api$Audit$Crumb$Crumb)))));
    var $author$project$Api$Audit$Whodunnit = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Audit$decodeWhodunnit = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Audit$Whodunnit)));
    var $author$project$Api$Audit$auditRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'aggregate', $elm$json$Json$Decode$maybe($author$project$Api$Audit$Crumb$linkableDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_session_role', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'crumbs', $elm$json$Json$Decode$list($author$project$Api$Audit$Crumb$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'whodunnit', $author$project$Api$Audit$decodeWhodunnit, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Audit$AuditRecord))))))));
    var $author$project$Api$Audit$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Audit$auditRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Audit$listDefaults = {
        Fw: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        Hg: $elm$core$Maybe$Nothing,
        Hh: $elm$core$Maybe$Nothing,
        Hw: $elm$core$Maybe$Just('request')
    };
    var $author$project$Api$Audit$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Audit$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v0 = options.Hw;
                if (!_v0.$) {
                    var source_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'source', source_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Hg;
                if (!_v1.$) {
                    var resource_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'resource', resource_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Hh;
                if (!_v2.$) {
                    var resourceId_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'resource_id', resourceId_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.Fw;
                if (!_v3.$) {
                    var filter_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', filter_)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Audit$list = F3(function(apiClient, query, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Audit$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Audit$listOptionsToParams(query), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'audits'
        ]), $author$project$Api$Data$providerPath))));
    });
    var $author$project$Components$AuditTrailLog$fetchAudits = F2(function(apiClient, optionals) {
        return A3($author$project$Api$Audit$list, apiClient, optionals, $author$project$Components$AuditTrailLog$GotAudits);
    });
    var $author$project$Components$AuditTrailLog$optionalsFromModel = function(_v0) {
        var pagination = _v0.af_;
        var resource = _v0.Hg;
        var resourceId = _v0.Hh;
        var filter = _v0.Fw;
        return function(d) {
            return _Utils_update(d, {
                Fw: filter,
                af_: pagination,
                Hg: resource,
                Hh: resourceId
            });
        };
    };
    var $author$project$Components$AuditTrailLog$setPagination = function(model) {
        var _v0 = model.pB;
        if (_v0.$ === 3) {
            var records = _v0.a;
            var headers = _v0.b;
            return _Utils_update(model, {
                af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                cs: _Utils_ap(model.cs, records)
            });
        } else return model;
    };
    var $author$project$Components$AuditTrailLog$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var showingAuditDetails = $author$project$Ui$Popover$isOpen(model.aN) ? model.cs : _List_Nil;
                var popover = A3($author$project$Ui$Popover$init, 'audit-history', !$author$project$Ui$Popover$isOpen(model.aN), $author$project$Components$AuditTrailLog$PopoverMsg);
                var pagination = $author$project$Ui$Popover$isOpen(model.aN) ? $author$project$Api$Pagination$init : model.af_;
                var auditsCmd = $author$project$Ui$Popover$isOpen(model.aN) ? $elm$core$Platform$Cmd$none : A2($author$project$Components$AuditTrailLog$fetchAudits, apiClient, $author$project$Components$AuditTrailLog$optionalsFromModel(model));
                return {
                    EQ: auditsCmd,
                    zi: _Utils_update(model, {
                        af_: pagination,
                        aN: popover,
                        cs: showingAuditDetails
                    }),
                    at: _List_Nil
                };
            case 1:
                var paginationMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, paginationMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return {
                    EQ: A2($author$project$Components$AuditTrailLog$fetchAudits, apiClient, $author$project$Components$AuditTrailLog$optionalsFromModel(newModel)),
                    zi: newModel,
                    at: _List_Nil
                };
            case 2:
                var audits = msg.a;
                var totalAuditsCount = function() {
                    if (audits.$ === 3) {
                        var headers = audits.b;
                        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
                    } else return 0;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: $author$project$Components$AuditTrailLog$setPagination(_Utils_update(model, {
                        pB: audits,
                        DK: totalAuditsCount
                    })),
                    at: $author$project$OutMsg$handleErrorResponse(audits)
                };
            default:
                var subMsg = msg.a;
                var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aN);
                var pagination = $author$project$Ui$Popover$isOpen(model.aN) ? $author$project$Api$Pagination$init : model.af_;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: _Utils_update(model, {
                        af_: pagination,
                        aN: popoverModel
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$update = F3(function(_v0, msg, _v1) {
        var model = _v1;
        if (!msg.$) {
            var response = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                DZ: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var field = msg.a;
            var copiedText = msg.b;
            return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(copiedText), _List_fromArray([
                A2($author$project$OutMsg$ShowToast, 3, field + ' copied to clipboard')
            ]));
        }
    });
    var $author$project$Components$CompanyEmailModal$BeforeSent = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CompanyEmailModal$Closed = 0;
    var $author$project$Components$CompanyEmailModal$Delivered = 1;
    var $author$project$Components$CompanyEmailModal$Editing = F3(function(a, b, c) {
        return {
            $: 2,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$CompanyEmailModal$None = 2;
    var $author$project$Components$CompanyEmailModal$Open = F3(function(a, b, c) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$CompanyEmailModal$GotDelivery = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Notification$Shared$body = function(_v0) {
        var record = _v0;
        return record.fb;
    };
    var $author$project$Api$Provider$Notification$One$body = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$body(shared);
    };
    var $author$project$Api$Provider$Notification$create = F6(function(apiClient, type_, recipient, contextId, fields, toMsg) {
        var body_ = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('notification', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('context_id', $elm$json$Json$Encode$string(contextId)), A2($elm$core$List$cons, _Utils_Tuple2('type', $elm$json$Json$Encode$string($author$project$Api$Provider$Notification$typeToString(type_))), A2($elm$core$List$cons, _Utils_Tuple2('subject', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.HF)), A2($elm$core$List$cons, _Utils_Tuple2('body', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.fb)), function() {
                if (!recipient.$) {
                    var patientId = recipient.a;
                    return _List_fromArray([
                        _Utils_Tuple2('patient', $elm$json$Json$Encode$string(patientId))
                    ]);
                } else {
                    var companyId = recipient.a;
                    return _List_fromArray([
                        _Utils_Tuple2('company', $elm$json$Json$Encode$string(companyId))
                    ]);
                }
            }()))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Notification$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body_, $author$project$Api$Data$requestTo($author$project$Api$Provider$Notification$notificationsPath)));
    });
    var $author$project$Api$Provider$Notification$Shared$subject = function(_v0) {
        var record = _v0;
        return record.HF;
    };
    var $author$project$Api$Provider$Notification$One$subject = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$subject(shared);
    };
    var $author$project$Components$CompanyEmailModal$createNotification = F3(function(apiClient, _v0, preview) {
        var type_ = _v0.ah5;
        var contextId = _v0.wU;
        var recipient = _v0.BD;
        return A6($author$project$Api$Provider$Notification$create, apiClient, type_, $author$project$Api$Provider$Notification$Company($author$project$Api$Provider$Company$One$id(recipient)), contextId, {
            fb: $author$project$Api$Provider$Notification$One$body(preview),
            HF: $author$project$Api$Provider$Notification$One$subject(preview)
        }, $author$project$Components$CompanyEmailModal$GotDelivery);
    });
    var $author$project$Components$CompanyEmailModal$initNotificationFormFields = function(notification) {
        return {
            fb: $author$project$Api$Provider$Notification$One$body(notification),
            HF: $author$project$Api$Provider$Notification$One$subject(notification)
        };
    };
    var $author$project$Components$CompanyEmailModal$notificationFormFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                HF: $author$project$Utils$String$toMaybe(string)
            });
        } else {
            var string = field.a;
            return _Utils_update(fields, {
                fb: $author$project$Utils$String$toMaybe(string)
            });
        }
    });
    var $author$project$Components$CompanyEmailModal$BodyValidation = 1;
    var $author$project$Components$CompanyEmailModal$SubjectValidation = 0;
    var $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.HF;
        }, _Utils_Tuple2(0, 'Please enter a valid subject')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.fb;
        }, _Utils_Tuple2(1, 'Please enter a valid body'))
    ]));
    var $author$project$Components$CompanyEmailModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                if (model.$ === 2) {
                    var shared = model.a;
                    var notificationForm = model.b;
                    var preview = model.c;
                    var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator, notificationForm);
                    if (!_v2.$) {
                        var _v3 = _v2.a;
                        var newForm = _v3.a;
                        var validFormFields = _v3.b;
                        return {
                            EQ: A3($author$project$Components$CompanyEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Just(validFormFields)),
                            adu: 2,
                            zi: A3($author$project$Components$CompanyEmailModal$Editing, shared, newForm, $author$project$Api$Data$Loading),
                            at: _List_Nil
                        };
                    } else {
                        var newForm = _v2.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 2,
                            zi: A3($author$project$Components$CompanyEmailModal$Editing, shared, newForm, preview),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                if (model.$ === 1) {
                    var shared = model.a;
                    var preview = model.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: A3($author$project$Components$CompanyEmailModal$Editing, shared, $author$project$Utils$Form$init($author$project$Components$CompanyEmailModal$initNotificationFormFields(preview)), $author$project$Api$Data$NotAsked),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
            case 3:
                if (model.$ === 1) {
                    var shared = model.a;
                    var preview = model.b;
                    return {
                        EQ: function() {
                            var _v6 = shared.Es;
                            if (!_v6.$) {
                                var beforeSend = _v6.a;
                                return beforeSend($author$project$Components$CompanyEmailModal$BeforeSent);
                            } else return A3($author$project$Components$CompanyEmailModal$createNotification, apiClient, shared, preview);
                        }(),
                        adu: 2,
                        zi: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$Loading),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                if (model.$ === 1) {
                    var shared = model.a;
                    var preview = model.b;
                    if (response.$ === 3) return {
                        EQ: A3($author$project$Components$CompanyEmailModal$createNotification, apiClient, shared, preview),
                        adu: 2,
                        zi: model,
                        at: _List_Nil
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                var response = msg.a;
                var _v9 = _Utils_Tuple2(model, response);
                switch(_v9.a.$){
                    case 0:
                        if (_v9.b.$ === 3) {
                            var shared = _v9.a.a;
                            var _v10 = _v9.b;
                            var preview = _v10.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 2,
                                zi: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
                                at: _List_Nil
                            };
                        } else {
                            var shared = _v9.a.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$CompanyEmailModal$Loading(shared),
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        }
                    case 2:
                        if (_v9.b.$ === 3) {
                            var _v11 = _v9.a;
                            var shared = _v11.a;
                            var _v12 = _v9.b;
                            var preview = _v12.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 2,
                                zi: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, $author$project$Api$Data$NotAsked),
                                at: _List_Nil
                            };
                        } else {
                            var _v13 = _v9.a;
                            var shared = _v13.a;
                            var notificationForm = _v13.b;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 2,
                                zi: A3($author$project$Components$CompanyEmailModal$Editing, shared, notificationForm, response),
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        }
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 2,
                            zi: model,
                            at: _List_Nil
                        };
                }
            case 6:
                var field = msg.a;
                if (model.$ === 2) {
                    var shared = model.a;
                    var notificationForm = model.b;
                    var preview = model.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CompanyEmailModal$notificationFormFieldsUpdate, field, notificationForm);
                    var validatedForm = function() {
                        var _v15 = A2($author$project$Utils$Form$validate, $author$project$Components$CompanyEmailModal$notificationFormFieldsValidator, newForm);
                        if (!_v15.$) {
                            var _v16 = _v15.a;
                            var form = _v16.a;
                            return form;
                        } else {
                            var form = _v15.a;
                            return form;
                        }
                    }();
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: A3($author$project$Components$CompanyEmailModal$Editing, shared, validatedForm, preview),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (model.$ === 1) {
                    var shared = model.a;
                    var preview = model.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'This email is being sent')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: A3($author$project$Components$CompanyEmailModal$Open, shared, preview, response),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Affiliate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Company = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$InvoiceLinesChanged = 0;
    var $author$project$Components$Invoice$InvoiceLinesTable$None = 1;
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath = F2(function(affiliateBillId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinesPath(affiliateBillId));
    });
    var $author$project$Api$Provider$AffiliateBill$InvoiceLine$delete = F4(function(apiClient, affiliateBillId, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath, affiliateBillId, id)));
    });
    var $author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath = F3(function(companyId, invoiceId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), A2($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinesPath, companyId, invoiceId));
    });
    var $author$project$Api$Provider$Company$Invoice$InvoiceLine$delete = F5(function(apiClient, companyId, invoiceId, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A3($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath, companyId, invoiceId, id)));
    });
    var $author$project$Api$Provider$InvoiceLine$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$InvoiceLine$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$InvoiceLine$Shared$id(shared);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$init = F4(function(session, invoiceType, usesEmployeeDivisions, invoiceLine) {
        return {
            wZ: $author$project$Api$Data$NotAsked,
            q3: invoiceLine,
            fS: $author$project$Api$Data$NotAsked,
            RL: invoiceType,
            Z$: session,
            op: false,
            aa1: usesEmployeeDivisions
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Affiliate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Company = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EmployerOrProviderCompany = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ProviderMin = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$adjustmentModalCompany = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ProviderMin(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EmployerOrProviderCompany(company__);
            }
        }, company);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCategories = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg = F2(function(a, b) {
        return {
            $: 19,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit = F5(function(apiClient, showItemTypeInTitle, session, today, category) {
        var _v0 = $author$project$Components$DateInput$init;
        var startDateInput = _v0.a;
        var startDateInputCmd = _v0.b;
        var _v1 = A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
        var practitionerResourceFilter = _v1.a;
        var practitionerResourceFilterCmd = _v1.b;
        var _v2 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
        var locationResourceFilter = _v2.a;
        var locationResourceFilterCmd = _v2.b;
        var _v3 = $author$project$Components$DateInput$init;
        var endDateInput = _v3.a;
        var endDateInputCmd = _v3.b;
        var _v4 = A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'None',
                I5: false,
                ad$: true,
                ad0: '',
                afn: false
            });
        });
        var chargeItemResourceFilter = _v4.a;
        var chargeItemResourceFilterCmd = _v4.b;
        var _v5 = A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
        var categoryResourceFilter = _v5.a;
        var categoryResourceFilterCmd = _v5.b;
        return _Utils_Tuple2({
            EL: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$All$id, category),
            cK: categoryResourceFilter,
            lv: $elm$core$Maybe$Nothing,
            cL: chargeItemResourceFilter,
            NQ: '',
            N$: 0,
            N0: false,
            qv: $elm$core$Maybe$Nothing,
            qx: endDateInput,
            aef: $elm$core$Maybe$Nothing,
            aeT: $elm$core$Maybe$Nothing,
            ro: locationResourceFilter,
            zr: $elm$core$Maybe$Nothing,
            V7: $elm$core$Maybe$Nothing,
            agi: $elm$core$Maybe$Nothing,
            jE: practitionerResourceFilter,
            Br: $elm$core$Maybe$Nothing,
            Xn: $elm$core$Maybe$Nothing,
            Bu: $elm$core$Maybe$Just(1),
            Bv: $elm$core$Maybe$Nothing,
            _0: $elm$core$Maybe$Just(today),
            kj: startDateInput,
            $S: false
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(startDateInput), startDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(endDateInput), endDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceFilterCmd)
        ])));
    });
    var $author$project$Components$ResourceFilter$CompanyRegistration$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Company$Account$companyAccountsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'accounts'
        ]), basePath);
    };
    var $author$project$Api$Provider$CompanyAccount$All$CompanyAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyAccount$All$Record = function(registrations) {
        return function(subscriber) {
            return function(division) {
                return function(membershipStartDate) {
                    return function(defaultEnrollmentStartDate) {
                        return function(invoicedThroughDate) {
                            return function(membershipEndDate) {
                                return function(status) {
                                    return function(plan) {
                                        return function(meta) {
                                            return {
                                                Np: defaultEnrollmentStartDate,
                                                Oa: division,
                                                RM: invoicedThroughDate,
                                                T_: membershipEndDate,
                                                T4: membershipStartDate,
                                                Ue: meta,
                                                GW: plan,
                                                agG: registrations,
                                                ahy: status,
                                                $r: subscriber
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyAccount$Meta$Record = F2(function(actions, membership) {
        return {
            tM: actions,
            jc: membership
        };
    });
    var $author$project$Api$Provider$CompanyAccount$Meta$ActionsRecord = F3(function(needsApproval, canEnroll, isEligible) {
        return {
            KJ: canEnroll,
            R2: isEligible,
            UI: needsApproval
        };
    });
    var $author$project$Api$Provider$CompanyAccount$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'eligible', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enroll', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'needs_approval', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$ActionsRecord))));
    var $author$project$Api$Provider$CompanyAccount$Meta$MembershipRecord = F3(function(billFromDate, billingStartDate, endDate) {
        return {
            Kc: billFromDate,
            Kg: billingStartDate,
            qv: endDate
        };
    });
    var $author$project$Api$Provider$CompanyAccount$Meta$EndDateRecord = F4(function(defaultValue, maxWithoutBilling, min, minWithoutProration) {
        return {
            NE: defaultValue,
            TP: maxWithoutBilling,
            Uj: min,
            Um: minWithoutProration
        };
    });
    var $author$project$Api$Provider$CompanyAccount$Meta$endDateRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min_without_proration', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_without_billing', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_value', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$EndDateRecord)))));
    var $author$project$Api$Provider$CompanyAccount$Meta$membershipRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $author$project$Api$Provider$CompanyAccount$Meta$endDateRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_from_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$MembershipRecord))));
    var $author$project$Api$Provider$CompanyAccount$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership', $author$project$Api$Provider$CompanyAccount$Meta$membershipRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$CompanyAccount$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$Meta$Record)));
    var $author$project$Api$Provider$CompanyAccount$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$Record = F5(function(patient, account, status, membershipStartDate, meta) {
        return {
            Ij: account,
            T4: membershipStartDate,
            Ue: meta,
            V7: patient,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Meta$CompanyRegistration$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Meta$CompanyRegistration$Record = function(actions) {
        return {
            tM: actions
        };
    };
    var $author$project$Api$Provider$Meta$CompanyRegistration$ActionsRecord = F3(function(enroll, needsApproval, isEligible) {
        return {
            OV: enroll,
            R2: isEligible,
            UI: needsApproval
        };
    });
    var $author$project$Api$Provider$Meta$CompanyRegistration$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'eligible', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'needs_approval', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enroll', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Meta$CompanyRegistration$ActionsRecord))));
    var $author$project$Api$Provider$Meta$CompanyRegistration$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$Meta$CompanyRegistration$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Meta$CompanyRegistration$Record));
    var $author$project$Api$Provider$Meta$CompanyRegistration$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Meta$CompanyRegistration$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Meta$CompanyRegistration$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'account', $author$project$Api$Provider$CompanyAccount$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$Record))))));
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration)));
    var $author$project$Api$Provider$CompanyAccount$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$CompanyAccount$Meta$decoder, A3($author$project$Api$Expandable$expandable, 'plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoiced_through_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_enrollment_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'division', $elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subscriber', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registrations', $elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$All$Record)))))))))));
    var $author$project$Api$Provider$CompanyAccount$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$All$CompanyAccount)));
    var $author$project$Api$Provider$Company$Account$expandToString = function(expand) {
        switch(expand){
            case 2:
                return 'plan';
            case 1:
                return 'registrations';
            default:
                return 'membership_patients';
        }
    };
    var $author$project$Api$Provider$Company$Account$listDefaults = {
        Fq: _List_Nil,
        Fw: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$Company$Account$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Company$Account$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var q = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', q)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fw;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', string)
                    ]);
                } else return _List_Nil;
            }(),
            A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Company$Account$expandToString, options.Fq),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Company$Account$list = F4(function(apiClient, basePath, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAccount$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Company$Account$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$Account$companyAccountsPath(basePath))));
    });
    var $author$project$Api$Provider$CompanyAccount$All$registrations = function(_v0) {
        var record = _v0.b;
        return record.agG;
    };
    var $author$project$Components$ResourceFilter$CompanyRegistration$list = F4(function(apiClient, basePath, optionals, toMsg) {
        return A4($author$project$Api$Provider$Company$Account$list, apiClient, basePath, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$concatMap($author$project$Api$Provider$CompanyAccount$All$registrations))));
    });
    var $author$project$Components$ResourceFilter$CompanyRegistration$fetchResources = F6(function(basePath, listOptionals, toMsg, apiClient, pagination, query) {
        return A4($author$project$Components$ResourceFilter$CompanyRegistration$list, apiClient, basePath, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$CompanyRegistration$retrieveResource = F5(function(basePath, listOptionals, toMsg, apiClient, id) {
        return A4($author$project$Components$ResourceFilter$CompanyRegistration$list, apiClient, basePath, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$CompanyRegistration$selectId = 'company-reigstrations';
    var $author$project$Api$Provider$Patient$Min$name = function(_v0) {
        var min = _v0;
        return min.zr;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Components$ResourceFilter$CompanyRegistration$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$name);
    var $author$project$Components$ResourceFilter$CompanyRegistration$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$CompanyRegistration$toTitle(resource))
        ]);
    };
    var $author$project$Api$Provider$CompanyRegistration$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
    };
    var $author$project$Components$ResourceFilter$CompanyRegistration$toValue = $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id;
    var $author$project$Components$ResourceFilter$CompanyRegistration$init = F4(function(apiClient, basePath, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: A2($author$project$Components$ResourceFilter$CompanyRegistration$fetchResources, basePath, listOptionals),
            aef: $author$project$Components$ResourceFilter$CompanyRegistration$selectId,
            gD: 'Registration',
            sz: A2($author$project$Components$ResourceFilter$CompanyRegistration$retrieveResource, basePath, listOptionals),
            ahW: $author$project$Components$ResourceFilter$CompanyRegistration$toLabel,
            ahZ: $author$project$Components$ResourceFilter$CompanyRegistration$toTitle,
            g4: $author$project$Components$ResourceFilter$CompanyRegistration$toValue
        }, A2($elm$core$Basics$composeL, optionals, function(d) {
            return _Utils_update(d, {
                Cy: false
            });
        }));
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Api$Provider$InvoiceLine$One$InvoiceLine = $elm$core$Basics$identity;
    var $author$project$Api$Provider$InvoiceLine$One$Record = F3(function(status, charges, companyAccount) {
        return {
            K9: charges,
            LI: companyAccount,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Charge$One$Charge = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Charge$Shared$Charge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Charge$Shared$Record = function(id) {
        return function(name) {
            return function(issuedSubtotalInCents) {
                return function(subtotalInCents) {
                    return function(totalInCents) {
                        return function(description) {
                            return function(issuedPriceInCents) {
                                return function(priceInCents) {
                                    return function(issuedQuantity) {
                                        return function(quantity) {
                                            return function(discountOverridden) {
                                                return function(discountInCents) {
                                                    return function(date) {
                                                        return function(endDate) {
                                                            return function(taxable) {
                                                                return function(type_) {
                                                                    return function(isPersisted) {
                                                                        return {
                                                                            M4: date,
                                                                            NQ: description,
                                                                            N$: discountInCents,
                                                                            N0: discountOverridden,
                                                                            qv: endDate,
                                                                            aef: id,
                                                                            Sj: isPersisted,
                                                                            SD: issuedPriceInCents,
                                                                            SE: issuedQuantity,
                                                                            SG: issuedSubtotalInCents,
                                                                            zr: name,
                                                                            Br: priceInCents,
                                                                            Bu: quantity,
                                                                            $v: subtotalInCents,
                                                                            $S: taxable,
                                                                            aam: totalInCents,
                                                                            ah5: type_
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Charge$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_persisted', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'taxable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discount_overridden', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_price_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subtotal_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_subtotal_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Shared$Record))))))))))))))))));
    var $author$project$Api$Provider$Charge$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Charge$One$Record = function(practitioner) {
        return function(location1) {
            return function(priceUom) {
                return function(quantityUom) {
                    return function(issuedQuantityUom) {
                        return function(chargeItem) {
                            return function(category) {
                                return function(patient) {
                                    return function(invoice) {
                                        return function(isLocked) {
                                            return function(rulePayer) {
                                                return function(meta) {
                                                    return function(prepaidCharges) {
                                                        return function(consumedPrepaidCharges) {
                                                            return {
                                                                EL: category,
                                                                lv: chargeItem,
                                                                L_: consumedPrepaidCharges,
                                                                RA: invoice,
                                                                R7: isLocked,
                                                                SF: issuedQuantityUom,
                                                                aeT: location1,
                                                                Ue: meta,
                                                                V7: patient,
                                                                agi: practitioner,
                                                                Xi: prepaidCharges,
                                                                Xn: priceUom,
                                                                Bv: quantityUom,
                                                                Zj: rulePayer
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Charge$RulePayer$Patient = 1;
    var $author$project$Api$Charge$RulePayer$Sponsor = 0;
    var $author$project$Api$Charge$RulePayer$rulePayerDecoder = function(string) {
        switch(string){
            case 'sponsor':
                return $elm$json$Json$Decode$succeed(0);
            case 'patient':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unsupported charge rule payer: ' + string);
        }
    };
    var $author$project$Api$Charge$RulePayer$decoder = A2($elm$json$Json$Decode$andThen, $author$project$Api$Charge$RulePayer$rulePayerDecoder, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$Invoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Payable$Invoice$Min$Invoice = $elm$core$Basics$identity;
    var $author$project$Api$Common$Payable$Invoice$Min$Record = F7(function(type_, id, invoiceNumber, status, date, humanStatus, paymentScheduledOn) {
        return {
            M4: date,
            QX: humanStatus,
            aef: id,
            RK: invoiceNumber,
            Wq: paymentScheduledOn,
            ahy: status,
            ah5: type_
        };
    });
    var $author$project$Api$Common$Payable$Invoice$Type$CompanyInvoice = 0;
    var $author$project$Api$Common$Payable$Invoice$Type$CustomerInvoice = 1;
    var $author$project$Api$Common$Payable$Invoice$Type$PracticeInvoice = 2;
    var $author$project$Api$Common$Payable$Invoice$Type$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'Invoice':
                return $elm$json$Json$Decode$succeed(0);
            case 'CustomerInvoice':
                return $elm$json$Json$Decode$succeed(1);
            case 'PracticeInvoice':
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail('Unsupported invoice type: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Payable$Invoice$Min$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'payment_scheduled_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Common$Payable$Invoice$Type$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$Min$Record))))))));
    var $author$project$Api$Common$Payable$Invoice$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Payable$Invoice$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$Record = function(owner) {
        return {
            VM: owner
        };
    };
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Owner$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$MinWithOwner$Record));
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Payable$Invoice$MinWithOwner$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Payable$Invoice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Payable$Invoice$MinWithOwner$Invoice)));
    var $author$project$Api$Provider$ChargeItem$ForCharge$ChargeItem = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ChargeItem$ForCharge$Record = function(uom) {
        return {
            aaK: uom
        };
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uom', $author$project$Api$Provider$Uom$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForCharge$Record));
    var $author$project$Api$Provider$ChargeItem$ForCharge$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$ForCharge$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForCharge$ChargeItem)));
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Patient = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Record = F2(function(practitioner, location1) {
        return {
            aeT: location1,
            agi: practitioner
        };
    });
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Record)));
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$Patient)));
    var $author$project$Api$Provider$PrepaidCharge$PrepaidCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PrepaidCharge$PrepaidChargeRecord = F6(function(id, originalQuantity, remainingQuantity, priceInCents, chargeItem, charge) {
        return {
            ach: charge,
            lv: chargeItem,
            aef: id,
            VF: originalQuantity,
            Br: priceInCents,
            Yx: remainingQuantity
        };
    });
    var $author$project$Api$Provider$PrepaidCharge$Charge = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$PrepaidCharge$chargeDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PrepaidCharge$Charge)));
    var $author$project$Api$Provider$PrepaidCharge$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'charge', A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Api$Provider$PrepaidCharge$chargeDecoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_item', $author$project$Api$Provider$ChargeItem$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $author$project$Currency$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'remaining_quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'original_quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PrepaidCharge$PrepaidChargeRecord))))))));
    var $author$project$Api$Provider$Charge$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'consumed_prepaid_charges', $elm$json$Json$Decode$list($author$project$Api$Provider$PrepaidCharge$decoder), _List_Nil, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'prepaid_charges', $elm$json$Json$Decode$list($author$project$Api$Provider$PrepaidCharge$decoder), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Charge$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rule_payer', $elm$json$Json$Decode$nullable($author$project$Api$Charge$RulePayer$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_locked', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_item', $elm$json$Json$Decode$nullable($author$project$Api$Provider$ChargeItem$ForCharge$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_quantity_uom', $author$project$Api$Provider$Uom$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity_uom', $author$project$Api$Provider$Uom$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_uom', $author$project$Api$Provider$Uom$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$One$Record)))))))))))))));
    var $author$project$Api$Provider$Charge$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$One$Charge)));
    var $author$project$Api$Provider$CompanyAccount$One$CompanyAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyAccount$One$Record = F6(function(division, subscriber, selectedPlan, memberships, membershipPlan, registrations) {
        return {
            Oa: division,
            T2: membershipPlan,
            T7: memberships,
            agG: registrations,
            ZF: selectedPlan,
            $r: subscriber
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$CompanyRegistration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$Record = function(patient) {
        return {
            V7: patient
        };
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$Record));
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Membership$ForCompanyAccountOne$Membership = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Membership$ForCompanyAccountOne$Record = function(membershipPatients) {
        return {
            T$: membershipPatients
        };
    };
    var $author$project$Api$Provider$MembershipPatient$Min$MembershipPatient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipPatient$Min$Record = F2(function(name, periodRateInCents) {
        return {
            zr: name,
            WB: periodRateInCents
        };
    });
    var $author$project$Api$Provider$MembershipPatient$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_rate_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$Min$Record)));
    var $author$project$Api$Provider$MembershipPatient$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipPatient$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Membership$ForCompanyAccountOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_patients', $elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$ForCompanyAccountOne$Record));
    var $author$project$Api$Provider$Membership$ForCompanyAccountOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Membership$ForCompanyAccountOne$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyAccount$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registrations', $elm$json$Json$Decode$list($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'memberships', $elm$json$Json$Decode$list($author$project$Api$Provider$Membership$ForCompanyAccountOne$decoder), _List_Nil, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'selected_plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subscriber', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'division', $elm$json$Json$Decode$nullable($author$project$Api$Provider$EmployeeDivision$All$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$One$Record)))))));
    var $author$project$Api$Provider$CompanyAccount$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAccount$One$CompanyAccount)));
    var $author$project$Api$Provider$InvoiceLine$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_account', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charges', $elm$json$Json$Decode$list($author$project$Api$Provider$Charge$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceLine$One$Record))));
    var $author$project$Api$Provider$InvoiceLine$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceLine$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve = F4(function(apiClient, affiliateBillId, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$InvoiceLine$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$AffiliateBill$InvoiceLine$invoiceLinePath, affiliateBillId, id)));
    });
    var $author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve = F5(function(apiClient, companyId, invoiceId, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$InvoiceLine$One$decoder, toMsg, $author$project$Api$Data$requestTo(A3($author$project$Api$Provider$Company$Invoice$InvoiceLine$invoiceLinePath, companyId, invoiceId, id)));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$init = F7(function(apiClient, currentDate, session, practice, company, invoiceType, invoiceLineId) {
        var companyRegistrationsBasePath = function() {
            if (invoiceType.$ === 1) {
                var companyId_ = invoiceType.a;
                return $author$project$Api$Provider$Company$companyPath(companyId_);
            } else {
                var affiliateId = invoiceType.a;
                return $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId);
            }
        }();
        var _v0 = A4($author$project$Components$ResourceFilter$CompanyRegistration$init, apiClient, companyRegistrationsBasePath, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'None',
                afn: false
            });
        });
        var companyRegistrationResourceFilter = _v0.a;
        var companyRegistrationResourceFilterCmd = _v0.b;
        var _v1 = function() {
            var _v2 = _Utils_Tuple2(invoiceLineId, invoiceType);
            if (!_v2.a.$) {
                if (_v2.b.$ === 1) {
                    var invoiceLineId_ = _v2.a.a;
                    var _v3 = _v2.b;
                    var companyId_ = _v3.a;
                    var invoiceId = _v3.b;
                    return _Utils_Tuple2($elm$core$Maybe$Nothing, A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve, apiClient, companyId_, invoiceId, invoiceLineId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine));
                } else {
                    var invoiceLineId_ = _v2.a.a;
                    var _v4 = _v2.b;
                    var affiliateBillId = _v4.b;
                    return _Utils_Tuple2($elm$core$Maybe$Nothing, A4($author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve, apiClient, affiliateBillId, invoiceLineId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotInvoiceLine));
                }
            } else if (_v2.b.$ === 1) {
                var _v5 = _v2.a;
                var _v6 = _v2.b;
                return _Utils_Tuple2($elm$core$Maybe$Nothing, A3($author$project$Api$Provider$Category$list, apiClient, function(d) {
                    return _Utils_update(d, {
                        Fd: $elm$core$Maybe$Just(true)
                    });
                }, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCategories));
            } else {
                var _v7 = _v2.a;
                var _v8 = _v2.b;
                var _v9 = A5($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit, apiClient, A2($author$project$Api$Practice$featureEnabled, 22, practice), session, currentDate, $elm$core$Maybe$Nothing);
                var formFields = _v9.a;
                var formFieldsCmd = _v9.b;
                return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Utils$Form$init(formFields)), formFieldsCmd);
            }
        }();
        var form = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple2({
            acy: company,
            LI: $author$project$Api$Data$NotAsked,
            hR: companyRegistrationResourceFilter,
            p2: false,
            cP: currentDate,
            N0: false,
            PU: form,
            qX: false,
            q3: $author$project$Api$Data$NotAsked,
            q4: invoiceLineId,
            RL: invoiceType,
            W1: practice,
            agk: $author$project$Api$Data$NotAsked,
            eq: $jinjor$elm_debounce$Debounce$init,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceFilterCmd)
        ])));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal = F3(function(apiClient, model, id) {
        var invoiceType = function() {
            var _v1 = model.RL;
            if (!_v1.$) {
                var affiliateId = _v1.a;
                var affiliateBillId = _v1.b;
                return A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Affiliate, affiliateId, affiliateBillId);
            } else {
                var companyId_ = _v1.a;
                var invoiceId = _v1.b;
                return A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Company, companyId_, invoiceId);
            }
        }();
        var _v0 = A7($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$init, apiClient, model.cP, model.Z$, model.W1, $author$project$Components$Invoice$InvoiceLinesTable$adjustmentModalCompany(model.acy), invoiceType, id);
        var adjustmentModal = _v0.a;
        var adjustmentModalCmd = _v0.b;
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg, adjustmentModalCmd),
            adu: 1,
            zi: _Utils_update(model, {
                ht: $elm$core$Maybe$Just(adjustmentModal)
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinePath = F2(function(invoiceId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinesPath(invoiceId));
    });
    var $author$project$Api$Employer$Invoice$InvoiceLine$retrieve = F4(function(apiClient, invoiceId, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$InvoiceLine$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$Invoice$InvoiceLine$invoiceLinePath, invoiceId, id)));
    });
    var $author$project$Api$Company$Invoice$InvoiceLine$retrieve = F6(function(apiClient, session, companyId, invoiceId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Invoice$InvoiceLine$retrieve, apiClient, invoiceId, id, toMsg) : A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$retrieve, apiClient, companyId, invoiceId, id, toMsg);
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine = F4(function(apiClient, session, invoiceType, invoiceLine) {
        if (invoiceType.$ === 1) {
            var companyId = invoiceType.a;
            var invoiceId = invoiceType.b;
            return A6($author$project$Api$Company$Invoice$InvoiceLine$retrieve, apiClient, session, companyId, invoiceId, $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine), $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails);
        } else {
            var invoiceId = invoiceType.a;
            return A4($author$project$Api$Provider$AffiliateBill$InvoiceLine$retrieve, apiClient, invoiceId, $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine), $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotInvoiceLineDetails);
        }
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$refresh = F2(function(apiClient, model) {
        var _v0 = model.fS;
        if (_v0.$ === 3) return _Utils_Tuple2(_Utils_update(model, {
            fS: $author$project$Api$Data$Loading
        }), A4($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine, apiClient, model.Z$, model.RL, model.q3));
        else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$refreshPhiMoreInfo = F3(function(apiClient, phiMoreInfos, id) {
        if (!id.$) {
            var id_ = id.a;
            var _v1 = A2($elm$core$Dict$get, id_, phiMoreInfos);
            if (!_v1.$) {
                var phiMoreInfo = _v1.a;
                var _v2 = A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$refresh, apiClient, phiMoreInfo);
                var phiMoreInfo_ = _v2.a;
                var phiMoreInfoCmd = _v2.b;
                return _Utils_Tuple2(A3($elm$core$Dict$insert, id_, phiMoreInfo_, phiMoreInfos), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id_), phiMoreInfoCmd));
            } else return _Utils_Tuple2(phiMoreInfos, $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(phiMoreInfos, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Category = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated = {
        $: 3
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Closed = {
        $: 1
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDate = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotAffiliatePatient = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPatient = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$InvoiceLineUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None = {
        $: 0
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Location$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Practitioner$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDate = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$account = function(_v0) {
        var record = _v0.b;
        return record.Ij;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPreview = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$Charge$Calculate$Charge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Charge$Calculate$Record = F7(function(priceInCents, discountInCents, subtotalInCents, issuedSubtotalInCents, routedInvoice, adjudicatedPayer, coveredCharges) {
        return {
            IP: adjudicatedPayer,
            Mr: coveredCharges,
            N$: discountInCents,
            SG: issuedSubtotalInCents,
            Br: priceInCents,
            Za: routedInvoice,
            $v: subtotalInCents
        };
    });
    var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$AdjudicatedPayer = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$Record = F3(function(id, name, payerType) {
        return {
            aef: id,
            zr: name,
            Wh: payerType
        };
    });
    var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$AdjudicatedPayer$One$Record))));
    var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$AdjudicatedPayer$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Charge$RoutedInvoice$One$RoutedInvoice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Charge$RoutedInvoice$One$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$Charge$RoutedInvoice$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$RoutedInvoice$One$Record));
    var $author$project$Api$Provider$Charge$RoutedInvoice$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$RoutedInvoice$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CoveredCharge$All$CoveredCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoveredCharge$All$Record = function(coverageRule) {
        return {
            Mo: coverageRule
        };
    };
    var $author$project$Api$Provider$CoveredCharge$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'coverage_rule', $author$project$Api$Provider$CoverageRule$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveredCharge$All$Record));
    var $author$project$Api$Provider$CoveredCharge$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoveredCharge$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Charge$Calculate$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'covered_charges', $elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$All$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'adjudicated_payer', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$AdjudicatedPayer$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'routed_invoice', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$RoutedInvoice$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_subtotal_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subtotal_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Calculate$Record))))))));
    var $author$project$Api$Provider$Charge$Calculate$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$Calculate$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Charge$calculate = F4(function(basePath, apiClient, fields, toMsg) {
        var quantityUom = function() {
            var _v5 = fields.Bv;
            if (!_v5.$) {
                var quantityUom_ = _v5.a;
                return _List_fromArray([
                    _Utils_Tuple2('quantity_uom', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('code', $elm$json$Json$Encode$string(quantityUom_))
                    ])))
                ]);
            } else return _List_Nil;
        }();
        var practitioner = function() {
            var _v4 = fields.agi;
            if (!_v4.$) {
                var practitioner_ = _v4.a;
                return _List_fromArray([
                    _Utils_Tuple2('practitioner', $author$project$Utils$Encode$association(practitioner_))
                ]);
            } else return _List_Nil;
        }();
        var patient = function() {
            var _v3 = fields.V7;
            if (!_v3.$) {
                var patient_ = _v3.a;
                return _List_fromArray([
                    _Utils_Tuple2('patient', $author$project$Utils$Encode$association(patient_))
                ]);
            } else return _List_Nil;
        }();
        var location1 = function() {
            var _v2 = fields.aeT;
            if (!_v2.$) {
                var location_ = _v2.a;
                return _List_fromArray([
                    _Utils_Tuple2('location', $author$project$Utils$Encode$association(location_))
                ]);
            } else return _List_Nil;
        }();
        var chargeItem = function() {
            var _v1 = fields.lv;
            if (!_v1.$) {
                var chargeItem_ = _v1.a;
                return _List_fromArray([
                    _Utils_Tuple2('charge_item', $author$project$Utils$Encode$association(chargeItem_))
                ]);
            } else return _List_Nil;
        }();
        var category = function() {
            var _v0 = fields.EL;
            if (!_v0.$) {
                var category_ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('category', $author$project$Utils$Encode$association(category_))
                ]);
            } else return _List_Nil;
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('charge', $elm$json$Json$Encode$object(_Utils_ap(patient, _Utils_ap(practitioner, _Utils_ap(chargeItem, _Utils_ap(category, _Utils_ap(location1, _Utils_ap(quantityUom, _List_fromArray([
                _Utils_Tuple2('payer', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, A2($elm$core$Maybe$andThen, function($) {
                    return $.aef;
                }, fields.GR))),
                _Utils_Tuple2('name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.zr)),
                _Utils_Tuple2('description', $elm$json$Json$Encode$string(fields.NQ)),
                _Utils_Tuple2('charge_item', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.lv)),
                _Utils_Tuple2('quantity', $elm$json$Json$Encode$int(fields.Bu)),
                _Utils_Tuple2('price_in_cents', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Br)),
                _Utils_Tuple2('date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.M4)),
                _Utils_Tuple2('end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qv)),
                _Utils_Tuple2('discount_overridden', $elm$json$Json$Encode$bool(fields.N0))
            ])))))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Charge$Calculate$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'calculate'
        ]), basePath))));
    });
    var $author$project$Api$Provider$Charge$chargesPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'charges'
        ]), basePath);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculateBasePath = function(invoiceType) {
        if (invoiceType.$ === 1) return $author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath);
        else {
            var affiliationId = invoiceType.a;
            return A2($author$project$Api$Data$pathAppend, _List_fromArray([
                'affiliate_charges'
            ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliationId));
        }
    };
    var $author$project$Api$Provider$Charge$Invoice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$companyId = function(company) {
        if (!company.$) {
            var company__ = company.a;
            return $author$project$Api$Provider$Company$Min$id(company__);
        } else {
            var company__ = company.a;
            return $author$project$Api$Company$id(company__);
        }
    };
    var $author$project$Api$Provider$Charge$Calculate$discountInCents = function(_v0) {
        var record = _v0;
        return record.N$;
    };
    var $author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents = function(_v0) {
        var record = _v0;
        return record.SG;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice = F2(function(model, fields) {
        var priceInCents = function() {
            if (!!fields.N$) {
                var _v0 = _Utils_Tuple2(fields.lv, model.agk);
                if (!_v0.a.$) {
                    var chargeItem = _v0.a.a;
                    return $elm$core$Maybe$Just(chargeItem.Br | 0);
                } else if (_v0.b.$ === 3) {
                    var _v1 = _v0.a;
                    var _v2 = _v0.b;
                    var preview = _v2.a;
                    return $elm$core$Maybe$Just($author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
                } else {
                    var _v3 = _v0.a;
                    return $elm$core$Maybe$Just(fields.N$ + A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Br)));
                }
            } else return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Br);
        }();
        return {
            EL: fields.EL,
            lv: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.lv),
            M4: fields._0,
            NQ: fields.NQ,
            N0: fields.N0,
            qv: fields.qv,
            RA: $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing),
            aeT: fields.aeT,
            zr: fields.zr,
            V7: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.V7),
            GR: A2($elm$core$Maybe$map, function(company) {
                return {
                    aef: $elm$core$Maybe$Just($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$companyId(company)),
                    ah5: $elm$core$Maybe$Just('company')
                };
            }, model.acy),
            agi: fields.agi,
            Br: priceInCents,
            Bu: A2($elm$core$Maybe$withDefault, 1, fields.Bu),
            Bv: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Bv)
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebouncedMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebouncedMsg
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview = function(field) {
        switch(field.$){
            case 0:
                return false;
            case 1:
                return true;
            case 2:
                return true;
            case 3:
                return false;
            case 4:
                return false;
            case 5:
                return false;
            case 6:
                return true;
            case 7:
                return true;
            case 8:
                return true;
            case 9:
                return true;
            case 10:
                return true;
            case 11:
                return true;
            case 12:
                return true;
            default:
                return true;
        }
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields = function(fields) {
        return $author$project$Utils$Maybe$toBool(fields.zr) && A2($elm$core$Maybe$withDefault, 0, fields.Bu) > 0;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview = F4(function(apiClient, field, form, model) {
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview(field) && $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields) ? A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig, A4($author$project$Api$Provider$Charge$calculate, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculateBasePath(model.RL), apiClient, A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields), $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPreview), model.eq) : _Utils_Tuple2(model.eq, $elm$core$Platform$Cmd$none);
        var newDebouncer = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$shouldCalculatePreview(field) && $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields) ? _Utils_update(model, {
            agk: $author$project$Api$Data$Loading,
            eq: newDebouncer
        }) : !$author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validPreviewFields(fields) ? _Utils_update(model, {
            agk: $author$project$Api$Data$NotAsked,
            eq: newDebouncer
        }) : _Utils_update(model, {
            eq: newDebouncer
        }), cmd);
    });
    var $author$project$Api$Provider$InvoiceLine$One$charges = function(_v0) {
        var record = _v0;
        return record.K9;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath = function(invoiceType) {
        if (invoiceType.$ === 1) {
            var companyId_ = invoiceType.a;
            var invoiceId = invoiceType.b;
            return A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId_, invoiceId);
        } else {
            var affiliateBillId = invoiceType.b;
            return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(affiliateBillId);
        }
    };
    var $author$project$Api$Provider$InvoiceLine$One$companyAccount = function(_v0) {
        var record = _v0;
        return record.LI;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebounced = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$debouncePreview = function(cmd) {
        return A2($elm$core$Task$perform, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PreviewDebounced, $elm$core$Task$succeed(cmd));
    };
    var $author$project$Api$Provider$Charge$Shared$discountOverridden = function(_v0) {
        var record = _v0;
        return record.N0;
    };
    var $author$project$Api$Provider$Charge$One$discountOverridden = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$discountOverridden(shared);
    };
    var $author$project$Components$ResourceFilter$CompanyRegistration$extraItems = F2(function(list_, model) {
        var extraItems_ = A2($elm$core$List$map, function(item) {
            return {
                aeI: item.zr,
                aa9: item.aef
            };
        }, list_);
        return _Utils_update(model, {
            bf: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bf)
        });
    });
    var $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$alertQuantity(shared);
    };
    var $author$project$Api$Provider$Charge$One$category = function(_v0) {
        var record = _v0.b;
        return record.EL;
    };
    var $author$project$Api$Provider$Charge$One$chargeItem = function(_v0) {
        var record = _v0.b;
        return record.lv;
    };
    var $author$project$Api$Provider$Charge$Shared$date = function(_v0) {
        var record = _v0;
        return record.M4;
    };
    var $author$project$Api$Provider$Charge$One$date = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$date(shared);
    };
    var $author$project$Api$Provider$Charge$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$Charge$One$description = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$description(shared);
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$description = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$description(shared);
    };
    var $author$project$Api$Provider$Charge$Shared$discountInCents = function(_v0) {
        var record = _v0;
        return record.N$;
    };
    var $author$project$Api$Provider$Charge$One$discountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$discountInCents(shared);
    };
    var $author$project$Api$Provider$Charge$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Api$Provider$Charge$One$endDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$endDate(shared);
    };
    var $author$project$Components$ResourceFilter$Location$extraItems = F2(function(list_, model) {
        var extraItems_ = A2($elm$core$List$map, function(item) {
            return {
                aeI: item.zr,
                aa9: item.aef
            };
        }, list_);
        return _Utils_update(model, {
            bf: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bf)
        });
    });
    var $author$project$Components$ResourceFilter$Practitioner$extraItems = F2(function(list_, model) {
        var extraItems_ = A2($elm$core$List$map, function(item) {
            return {
                aeI: item.zr,
                aa9: item.aef
            };
        }, list_);
        return _Utils_update(model, {
            bf: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bf)
        });
    });
    var $author$project$Currency$fromMaybeInt = function(maybeInt) {
        return A2($elm$core$Maybe$map, $author$project$Currency$fromInt, maybeInt);
    };
    var $author$project$Api$Provider$Charge$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Charge$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$id(shared);
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$id(shared);
    };
    var $author$project$Api$Provider$Location$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$id(shared);
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$isPackage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$itemType(shared) === 1;
    };
    var $author$project$Api$Provider$Charge$One$location = function(_v0) {
        var record = _v0.b;
        return record.aeT;
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$manufacturer(shared);
    };
    var $author$project$Api$Provider$Charge$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Charge$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$name(shared);
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$name(shared);
    };
    var $author$project$Api$Provider$Location$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$name(shared);
    };
    var $author$project$Api$Provider$Charge$One$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Api$Provider$Charge$One$practitioner = function(_v0) {
        var record = _v0.b;
        return record.agi;
    };
    var $author$project$Api$Provider$Charge$Shared$priceInCents = function(_v0) {
        var record = _v0;
        return record.Br;
    };
    var $author$project$Api$Provider$Charge$One$priceInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$priceInCents(shared);
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$priceInCents(shared);
    };
    var $author$project$Api$Provider$Charge$One$priceUom = function(_v0) {
        var record = _v0.b;
        return record.Xn;
    };
    var $author$project$Api$Provider$Charge$Shared$quantity = function(_v0) {
        var record = _v0;
        return record.Bu;
    };
    var $author$project$Api$Provider$Charge$One$quantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$quantity(shared);
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$quantityInStock(shared);
    };
    var $author$project$Api$Provider$Charge$One$quantityUom = function(_v0) {
        var record = _v0.b;
        return record.Bv;
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$taxable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$taxable(shared);
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Shared$trackInventory(shared);
    };
    var $author$project$Api$Provider$ChargeItem$ForCharge$uom = function(_v0) {
        var record = _v0.b;
        return record.aaK;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsFromItem = F4(function(apiClient, showItemTypeInTitle, session, charge) {
        var practitioner = $author$project$Api$Provider$Charge$One$practitioner(charge);
        var patient = A2($elm$core$Maybe$map, function(patient_) {
            return {
                aef: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
                zr: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
            };
        }, $author$project$Api$Provider$Charge$One$patient(charge));
        var location1 = $author$project$Api$Provider$Charge$One$location(charge);
        var chargeItem = A2($elm$core$Maybe$map, function(chargeItem_) {
            return {
                I0: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem_),
                EL: $author$project$Api$Provider$Charge$One$category(charge),
                Lk: $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem_),
                Lm: $author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem_),
                NQ: $author$project$Api$Provider$ChargeItem$ForCharge$description(chargeItem_),
                aef: $author$project$Api$Provider$ChargeItem$ForCharge$id(chargeItem_),
                aeE: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_),
                rc: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_) ? 1 : 0,
                TC: $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem_),
                zr: $author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem_),
                Br: $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents(chargeItem_),
                XT: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem_),
                $S: $author$project$Api$Provider$ChargeItem$ForCharge$taxable(chargeItem_),
                aap: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem_),
                aaK: $author$project$Api$Provider$ChargeItem$ForCharge$uom(chargeItem_)
            };
        }, $author$project$Api$Provider$Charge$One$chargeItem(charge));
        var category = $author$project$Api$Provider$Charge$One$category(charge);
        var _v0 = $author$project$Components$DateInput$init;
        var startDateInput = _v0.a;
        var startDateInputCmd = _v0.b;
        var _v1 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Practitioner$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(practitioner_) {
            return _List_fromArray([
                {
                    aef: $author$project$Api$Provider$Practitioner$Shared$id(practitioner_),
                    zr: $author$project$Api$Provider$Practitioner$Shared$name(practitioner_)
                }
            ]);
        }, practitioner))), A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false,
                agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner)
            });
        }));
        var practitionerResourceFilter = _v1.a;
        var practitionerResourceFilterCmd = _v1.b;
        var _v2 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Location$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(location_) {
            return _List_fromArray([
                {
                    aef: $author$project$Api$Provider$Location$Min$id(location_),
                    zr: $author$project$Api$Provider$Location$Min$name(location_)
                }
            ]);
        }, location1))), A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false,
                agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location1)
            });
        }));
        var locationResourceFilter = _v2.a;
        var locationResourceFilterCmd = _v2.b;
        var _v3 = $author$project$Components$DateInput$init;
        var endDateInput = _v3.a;
        var endDateInputCmd = _v3.b;
        var _v4 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$ChargeItem$setValue(A2($elm$core$Maybe$withDefault, $author$project$Components$ResourceFilter$FreeText(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Charge$One$name(charge))), A2($elm$core$Maybe$map, function(chargeItem_) {
            return $author$project$Components$ResourceFilter$One({
                I0: chargeItem_.I0,
                EL: chargeItem_.EL,
                Lk: chargeItem_.Lk,
                Lm: chargeItem_.Lm,
                NQ: chargeItem_.NQ,
                aef: chargeItem_.aef,
                aeE: chargeItem_.aeE,
                rc: chargeItem_.rc,
                TC: chargeItem_.TC,
                zr: chargeItem_.zr,
                Br: chargeItem_.Br,
                XT: chargeItem_.XT,
                $S: chargeItem_.$S,
                aap: chargeItem_.aap,
                aaK: chargeItem_.aaK
            });
        }, chargeItem))), A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'None',
                I5: false,
                ad$: true,
                ad0: '',
                afn: false
            });
        }));
        var chargeItemResourceFilter = _v4.a;
        var chargeItemResourceFilterCmd = _v4.b;
        var _v5 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Category$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(category_) {
            return _List_fromArray([
                {
                    aef: $author$project$Api$Provider$Category$Shared$id(category_),
                    zr: $author$project$Api$Provider$Category$Shared$name(category_)
                }
            ]);
        }, category))), A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false,
                agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category)
            });
        }));
        var categoryResourceFilter = _v5.a;
        var categoryResourceFilterCmd = _v5.b;
        return _Utils_Tuple2({
            EL: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, $author$project$Api$Provider$Charge$One$category(charge)),
            cK: categoryResourceFilter,
            lv: chargeItem,
            cL: chargeItemResourceFilter,
            NQ: $author$project$Api$Provider$Charge$One$description(charge),
            N$: $author$project$Api$Provider$Charge$One$discountInCents(charge),
            N0: $author$project$Api$Provider$Charge$One$discountOverridden(charge),
            qv: $author$project$Api$Provider$Charge$One$endDate(charge),
            qx: endDateInput,
            aef: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$id(charge)),
            aeT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, $author$project$Api$Provider$Charge$One$location(charge)),
            ro: locationResourceFilter,
            zr: $author$project$Api$Provider$Charge$One$name(charge),
            V7: patient,
            agi: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, $author$project$Api$Provider$Charge$One$practitioner(charge)),
            jE: practitionerResourceFilter,
            Br: $author$project$Currency$fromMaybeInt($author$project$Api$Provider$Charge$One$priceInCents(charge)),
            Xn: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$priceUom(charge)),
            Bu: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$quantity(charge)),
            Bv: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$quantityUom(charge)),
            _0: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$date(charge)),
            kj: startDateInput,
            $S: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$ForCharge$taxable, $author$project$Api$Provider$Charge$One$chargeItem(charge)))
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(startDateInput), startDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(endDateInput), endDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceFilterCmd)
        ])));
    });
    var $author$project$Utils$Uom$matchRange = F2(function(fromDate, toDate) {
        var toDate_ = A3($justinmimbs$date$Date$add, 3, 1, toDate);
        var diff = A2($author$project$Utils$Uom$dateDiff, fromDate, toDate_);
        return !!diff.acR ? $author$project$Api$Provider$Uom$Shared$day : !diff.ae7 ? $author$project$Api$Provider$Uom$Shared$year : !A2($elm$core$Basics$modBy, 6, diff.ae7) ? $author$project$Api$Provider$Uom$Shared$halfYear : !A2($elm$core$Basics$modBy, 3, diff.ae7) ? $author$project$Api$Provider$Uom$Shared$quarter : $author$project$Api$Provider$Uom$Shared$month;
    });
    var $author$project$Utils$Uom$dateUnitMultiplier = function(periodUnit) {
        switch(periodUnit){
            case 0:
                return 1;
            case 1:
                return 1;
            case 2:
                return 3;
            case 3:
                return 6;
            default:
                return 1;
        }
    };
    var $author$project$Utils$Uom$toDateUnit = function(periodUnit) {
        switch(periodUnit){
            case 0:
                return 3;
            case 1:
                return 1;
            case 2:
                return 1;
            case 3:
                return 1;
            default:
                return 0;
        }
    };
    var $author$project$Utils$Uom$withInfinityDefault = F2(function(_default, _float) {
        return $elm$core$Basics$isInfinite(_float) ? _default : _float;
    });
    var $author$project$Utils$Uom$quantityBetween = F3(function(uom, fromDate, toDate) {
        var _v0 = _Utils_Tuple3($author$project$Api$Provider$Uom$Shared$periodUnit(uom), $author$project$Api$Provider$Uom$Shared$periodQuantity(uom), toDate);
        if (!_v0.a.$ && !_v0.b.$ && !_v0.c.$) {
            var periodUnit = _v0.a.a;
            var periodQuantity = _v0.b.a;
            var toDate_ = _v0.c.a;
            var quantity = $elm$core$Basics$round(A2($author$project$Utils$Uom$withInfinityDefault, 1, 1 / ($author$project$Utils$Uom$dateUnitMultiplier(periodUnit) * periodQuantity) * A3($justinmimbs$date$Date$diff, $author$project$Utils$Uom$toDateUnit(periodUnit), fromDate, A3($justinmimbs$date$Date$add, 3, 1, toDate_))));
            return A2($elm$core$Maybe$withDefault, 1, $elm$core$List$maximum(_List_fromArray([
                quantity,
                1
            ])));
        } else return 0;
    });
    var $author$project$Utils$Uom$addTo = F3(function(date, uom, quantity) {
        var _v0 = _Utils_Tuple2($author$project$Api$Provider$Uom$Shared$periodUnit(uom), $author$project$Api$Provider$Uom$Shared$periodQuantity(uom));
        if (!_v0.a.$ && !_v0.b.$) {
            var periodUnit = _v0.a.a;
            var periodQuantity = _v0.b.a;
            return A2($elm$core$Maybe$map, A2($justinmimbs$date$Date$add, 3, -1), A2($elm$core$Maybe$map, A2($justinmimbs$date$Date$add, $author$project$Utils$Uom$toDateUnit(periodUnit), periodQuantity * $author$project$Utils$Uom$dateUnitMultiplier(periodUnit) * quantity), date));
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Bu, fields.Bv);
        if (!_v0.a.$ && !_v0.b.$) {
            var quantity = _v0.a.a;
            var quantityUom = _v0.b.a;
            return _Utils_update(fields, {
                qv: A3($author$project$Utils$Uom$addTo, fields._0, quantityUom, quantity)
            });
        } else return fields;
    };
    var $author$project$Components$ResourceFilter$Category$setValue = F2(function(resource, model) {
        return _Utils_update(model, {
            Hg: function() {
                if (!resource.$) {
                    var resource_ = resource.a;
                    return $author$project$Components$ResourceFilter$One(resource_);
                } else return $author$project$Components$ResourceFilter$All;
            }()
        });
    });
    var $author$project$Components$ResourceFilter$Location$setValue = F2(function(resource, model) {
        return _Utils_update(model, {
            Hg: function() {
                if (!resource.$) {
                    var resource_ = resource.a;
                    return $author$project$Components$ResourceFilter$One(resource_);
                } else return $author$project$Components$ResourceFilter$All;
            }()
        });
    });
    var $author$project$Components$ResourceFilter$Practitioner$setValue = F2(function(resource, model) {
        return _Utils_update(model, {
            Hg: function() {
                if (!resource.$) {
                    var resource_ = resource.a;
                    return $author$project$Components$ResourceFilter$One(resource_);
                } else return $author$project$Components$ResourceFilter$All;
            }()
        });
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    lv: $elm$core$Maybe$Nothing,
                    zr: $author$project$Utils$String$toMaybe(string)
                });
            case 1:
                var chargeItem = field.a;
                var category = A2($elm$core$Maybe$andThen, function($) {
                    return $.EL;
                }, chargeItem);
                return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(_Utils_update(fields, {
                    EL: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
                    cK: A2($author$project$Components$ResourceFilter$Category$setValue, A2($elm$core$Maybe$map, function(category_) {
                        return {
                            aef: $author$project$Api$Provider$Category$Shared$id(category_),
                            zr: $author$project$Api$Provider$Category$Shared$name(category_)
                        };
                    }, category), fields.cK),
                    lv: chargeItem,
                    NQ: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, function($) {
                        return $.NQ;
                    }, chargeItem)),
                    zr: A2($elm$core$Maybe$map, function($) {
                        return $.zr;
                    }, chargeItem),
                    Br: A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function($) {
                        return $.Br;
                    }, $author$project$Currency$fromFloat), chargeItem),
                    Xn: A2($elm$core$Maybe$map, function($) {
                        return $.aaK;
                    }, chargeItem),
                    Bu: $elm$core$Maybe$Just(1),
                    Bv: A2($elm$core$Maybe$map, function($) {
                        return $.aaK;
                    }, chargeItem)
                }));
            case 2:
                var maybeString = field.a;
                return _Utils_update(fields, {
                    EL: maybeString
                });
            case 3:
                var practitioner = field.a;
                return _Utils_update(fields, {
                    agi: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, practitioner),
                    jE: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitioner, fields.jE)
                });
            case 4:
                var location1 = field.a;
                return _Utils_update(fields, {
                    aeT: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, location1),
                    ro: A2($author$project$Components$ResourceFilter$Location$setValue, location1, fields.ro)
                });
            case 5:
                var string = field.a;
                return _Utils_update(fields, {
                    NQ: string
                });
            case 6:
                var string = field.a;
                return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(_Utils_update(fields, {
                    Bu: $elm$core$String$toInt(string)
                }));
            case 7:
                var string = field.a;
                var _v1 = $author$project$Utils$Uom$fromCode(string);
                if (!_v1.$) {
                    var quantityUom = _v1.a;
                    var quantity = function() {
                        var _v2 = _Utils_Tuple2(fields._0, fields.qv);
                        if (!_v2.a.$ && !_v2.b.$) {
                            var startDate = _v2.a.a;
                            var endDate = _v2.b.a;
                            return $elm$core$Maybe$Just(A3($author$project$Utils$Uom$quantityBetween, quantityUom, startDate, $elm$core$Maybe$Just(endDate)));
                        } else return fields.Bu;
                    }();
                    return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(_Utils_update(fields, {
                        Bu: quantity,
                        Bv: $elm$core$Maybe$Just(quantityUom)
                    }));
                } else return _Utils_update(fields, {
                    Bv: $elm$core$Maybe$Nothing
                });
            case 8:
                var dateInput = field.a;
                var date = field.b;
                return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$resetEndDate(_Utils_update(fields, {
                    _0: date,
                    kj: dateInput
                }));
            case 9:
                var dateInput = field.a;
                var date = field.b;
                var _v3 = function() {
                    var _v4 = _Utils_Tuple2(fields._0, date);
                    if (!_v4.a.$ && !_v4.b.$) {
                        var startDate_ = _v4.a.a;
                        var endDate = _v4.b.a;
                        var startDate__ = A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2 ? endDate : startDate_;
                        var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
                        return _Utils_Tuple3($elm$core$Maybe$Just(startDate__), $elm$core$Maybe$Just(quantityUom_), $elm$core$Maybe$Just(A3($author$project$Utils$Uom$quantityBetween, quantityUom_, startDate__, $elm$core$Maybe$Just(endDate))));
                    } else return _Utils_Tuple3(fields._0, fields.Bv, fields.Bu);
                }();
                var startDate = _v3.a;
                var quantityUom = _v3.b;
                var quantity = _v3.c;
                return _Utils_update(fields, {
                    qv: date,
                    qx: dateInput,
                    Bu: quantity,
                    Bv: quantityUom,
                    _0: startDate
                });
            case 10:
                var _int = field.a;
                return _Utils_update(fields, {
                    Br: _int
                });
            case 11:
                var companyRegistration = field.a;
                return _Utils_update(fields, {
                    V7: A2($elm$core$Maybe$map, function($) {
                        return $.V7;
                    }, companyRegistration)
                });
            case 12:
                var bool = field.a;
                var priceInCents = bool ? fields.Br : A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function($) {
                    return $.Br;
                }, $author$project$Currency$fromFloat), fields.lv);
                return _Utils_update(fields, {
                    N0: bool,
                    Br: priceInCents
                });
            default:
                var _int = field.a;
                return _Utils_update(fields, {
                    N$: _int
                });
        }
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemValidation = 0;
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCentsValidation = 4;
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateValidation = 2;
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validateChargeItem = function(fields) {
        var _v0 = fields.lv;
        if (!_v0.$) {
            var chargeItem = _v0.a;
            return chargeItem.$S ? _List_fromArray([
                _Utils_Tuple2(0, 'We do not support adding taxable charges to this invoice at this time. Please contact us to learn more.')
            ]) : _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please pick a charge.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Br;
        }, _Utils_Tuple2(4, 'Please enter an amount.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$validateChargeItem),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $._0;
        }, _Utils_Tuple2(2, 'Please pick a date.'))
    ]));
    var $author$project$Api$Provider$CompanyAccount$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CompanyAccount$Shared$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Min$id(min);
    };
    var $author$project$Api$Provider$CompanyAccount$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
    };
    var $author$project$Api$Provider$Patient$Min$id = function(_v0) {
        var min = _v0;
        return min.aef;
    };
    var $author$project$Api$Provider$Patient$One$location = function(_v0) {
        var record = _v0.b;
        return record.aeT;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Api$Provider$Patient$One$practitioner = function(_v0) {
        var record = _v0.b;
        return record.agi;
    };
    var $author$project$Api$Provider$CompanyAccount$One$registrations = function(_v0) {
        var record = _v0.b;
        return record.agG;
    };
    var $author$project$Api$Affiliate$AffiliateMin$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$Location$Shared$affiliation = function(_v0) {
        var record = _v0;
        return record.IY;
    };
    var $author$project$Api$Location$Shared$affiliation = function(location1) {
        if (!location1.$) {
            var location_ = location1.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Provider, $author$project$Api$Provider$Location$Shared$affiliation(location_));
        } else {
            var location_ = location1.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Employer, $author$project$Api$Employer$Location$Shared$affiliation(location_));
        }
    };
    var $author$project$Api$Employer$Location$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Location$Shared$id = function(location1) {
        if (!location1.$) {
            var location_ = location1.a;
            return $author$project$Api$Provider$Location$Shared$id(location_);
        } else {
            var location_ = location1.a;
            return $author$project$Api$Employer$Location$Shared$id(location_);
        }
    };
    var $author$project$Api$Employer$Location$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Location$Shared$name = function(location1) {
        if (!location1.$) {
            var location_ = location1.a;
            return $author$project$Api$Provider$Location$Shared$name(location_);
        } else {
            var location_ = location1.a;
            return $author$project$Api$Employer$Location$Shared$name(location_);
        }
    };
    var $author$project$Components$ResourceFilter$Location$resourceFromShared = $elm$core$Maybe$map(function(location1) {
        return {
            IY: $author$project$Api$Location$Shared$affiliation(location1),
            aef: $author$project$Api$Location$Shared$id(location1),
            R8: false,
            Su: false,
            zr: $author$project$Api$Location$Shared$name(location1)
        };
    });
    var $author$project$Api$Employer$Practitioner$Shared$affiliation = function(_v0) {
        var record = _v0;
        return record.IY;
    };
    var $author$project$Api$Practitioner$Shared$affiliation = function(practitioner) {
        if (!practitioner.$) {
            var practitioner_ = practitioner.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Provider, $author$project$Api$Provider$Practitioner$Shared$affiliation(practitioner_));
        } else {
            var practitioner_ = practitioner.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Employer, $author$project$Api$Employer$Practitioner$Shared$affiliation(practitioner_));
        }
    };
    var $author$project$Api$Employer$Practitioner$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Practitioner$Shared$id = function(practitioner) {
        if (!practitioner.$) {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Provider$Practitioner$Shared$id(practitioner_);
        } else {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Employer$Practitioner$Shared$id(practitioner_);
        }
    };
    var $author$project$Api$Employer$Practitioner$Shared$isMaster = function(_v0) {
        var record = _v0;
        return record.R8;
    };
    var $author$project$Api$Practitioner$Shared$isMaster = function(practitioner) {
        if (!practitioner.$) {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Provider$Practitioner$Shared$isMaster(practitioner_);
        } else {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Employer$Practitioner$Shared$isMaster(practitioner_);
        }
    };
    var $author$project$Api$Employer$Practitioner$Shared$isSynced = function(_v0) {
        var record = _v0;
        return record.Su;
    };
    var $author$project$Api$Practitioner$Shared$isSynced = function(practitioner) {
        if (!practitioner.$) {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Provider$Practitioner$Shared$isSynced(practitioner_);
        } else {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Employer$Practitioner$Shared$isSynced(practitioner_);
        }
    };
    var $author$project$Api$Employer$Practitioner$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Practitioner$Shared$name = function(practitioner) {
        if (!practitioner.$) {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Provider$Practitioner$Shared$name(practitioner_);
        } else {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Employer$Practitioner$Shared$name(practitioner_);
        }
    };
    var $author$project$Api$Employer$Practitioner$Shared$openingsSize = function(_v0) {
        var record = _v0;
        return record.Vy;
    };
    var $author$project$Api$Practitioner$Shared$openingsSize = function(practitioner) {
        if (!practitioner.$) {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Provider$Practitioner$Shared$openingsSize(practitioner_);
        } else {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Employer$Practitioner$Shared$openingsSize(practitioner_);
        }
    };
    var $author$project$Api$Practitioner$Shared$practiceName = function(practitioner) {
        if (!practitioner.$) {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Provider$Practitioner$Shared$practiceName(practitioner_);
        } else return '';
    };
    var $author$project$Api$Practitioner$Shared$practitionerType = function(practitioner) {
        if (!practitioner.$) {
            var practitioner_ = practitioner.a;
            return $author$project$Api$Provider$Practitioner$Shared$practitionerType(practitioner_);
        } else return '';
    };
    var $author$project$Components$ResourceFilter$Practitioner$resourceFromShared = $elm$core$Maybe$map(function(practitioner) {
        return {
            IY: $author$project$Api$Practitioner$Shared$affiliation(practitioner),
            aef: $author$project$Api$Practitioner$Shared$id(practitioner),
            R8: $author$project$Api$Practitioner$Shared$isMaster(practitioner),
            Su: $author$project$Api$Practitioner$Shared$isSynced(practitioner),
            zr: $author$project$Api$Practitioner$Shared$name(practitioner),
            Vy: $author$project$Api$Practitioner$Shared$openingsSize(practitioner),
            agg: $author$project$Api$Practitioner$Shared$practiceName(practitioner),
            Xb: $author$project$Api$Practitioner$Shared$practitionerType(practitioner)
        };
    });
    var $author$project$Api$Provider$Affiliates$AffiliatePatient$patientsPath = function(affiliateId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'affiliate_patients'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
    };
    var $author$project$Api$Provider$Affiliates$AffiliatePatient$patientPath = F2(function(affiliateId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Affiliates$AffiliatePatient$patientsPath(affiliateId));
    });
    var $author$project$Api$Provider$Affiliates$AffiliatePatient$retrieve = F4(function(apiClient, affiliateId, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Patient$Min$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Affiliates$AffiliatePatient$patientPath, affiliateId, patientId)));
    });
    var $author$project$Api$Provider$Patient$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientPath(id_)));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeCreated = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Charge$create = F4(function(basePath, apiClient, fields, toMsg) {
        var quantityUom = function() {
            var _v3 = fields.Bv;
            if (!_v3.$) {
                var quantityUom_ = _v3.a;
                return _List_fromArray([
                    _Utils_Tuple2('quantity_uom', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('code', $elm$json$Json$Encode$string(quantityUom_))
                    ])))
                ]);
            } else return _List_Nil;
        }();
        var patient = function() {
            var _v2 = fields.V7;
            if (!_v2.$) {
                var patient_ = _v2.a;
                return _List_fromArray([
                    _Utils_Tuple2('patient', $author$project$Utils$Encode$association(patient_))
                ]);
            } else return _List_Nil;
        }();
        var invoice = function() {
            var _v1 = fields.RA;
            if (!_v1.$) {
                var invoice_ = _v1.a;
                return A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, invoice_);
            } else return $elm$json$Json$Encode$string('new');
        }();
        var chargeItem = function() {
            var _v0 = fields.lv;
            if (!_v0.$) {
                var chargeItem_ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('charge_item', $author$project$Utils$Encode$association(chargeItem_))
                ]);
            } else return _List_Nil;
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('charge', $elm$json$Json$Encode$object(_Utils_ap(patient, _Utils_ap(chargeItem, _Utils_ap(quantityUom, _List_fromArray([
                _Utils_Tuple2('payer', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, fields.GR)),
                _Utils_Tuple2('invoice', invoice),
                _Utils_Tuple2('name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.zr)),
                _Utils_Tuple2('description', $elm$json$Json$Encode$string(fields.NQ)),
                _Utils_Tuple2('charge_item', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.lv)),
                _Utils_Tuple2('quantity', $elm$json$Json$Encode$int(fields.Bu)),
                _Utils_Tuple2('price_in_cents', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Br)),
                _Utils_Tuple2('date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.M4)),
                _Utils_Tuple2('end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qv)),
                _Utils_Tuple2('practitioner', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.agi)),
                _Utils_Tuple2('location', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aeT)),
                _Utils_Tuple2('category', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.EL))
            ]))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Charge$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Charge$chargesPath(basePath))));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$createCharge = F3(function(apiClient, model, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Charge$create, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.RL), apiClient, A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields), $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeCreated(formFields));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset = F3(function(a, b, c) {
        return {
            $: 8,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Provider$Charge$chargePath = F2(function(basePath, chargeId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            chargeId
        ]), $author$project$Api$Provider$Charge$chargesPath(basePath));
    });
    var $author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath = function(chargeId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'coverage_discounts'
        ]), A2($author$project$Api$Provider$Charge$chargePath, $author$project$Api$Data$providerPath, chargeId));
    };
    var $author$project$Api$Provider$Charge$CoverageDiscount$override = F3(function(apiClient, chargeId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Charge$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'override'
        ]), $author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId))));
    });
    var $author$project$Api$Provider$Charge$CoverageDiscount$reset = F3(function(apiClient, chargeId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Charge$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reset'
        ]), $author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId))));
    });
    var $author$project$Api$Provider$Charge$update = F5(function(basePath, apiClient, id, fields, toMsg) {
        var quantityUom = function() {
            var _v3 = fields.Bv;
            if (!_v3.$) {
                var quantityUom_ = _v3.a;
                return _List_fromArray([
                    _Utils_Tuple2('quantity_uom', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('code', $elm$json$Json$Encode$string(quantityUom_))
                    ])))
                ]);
            } else return _List_Nil;
        }();
        var patient = function() {
            var _v2 = fields.V7;
            if (!_v2.$) {
                var patient_ = _v2.a;
                return _List_fromArray([
                    _Utils_Tuple2('patient', $author$project$Utils$Encode$association(patient_))
                ]);
            } else return _List_Nil;
        }();
        var chargeItem = function() {
            var _v1 = fields.lv;
            if (!_v1.$) {
                var chargeItem_ = _v1.a;
                return _List_fromArray([
                    _Utils_Tuple2('charge_item', $author$project$Utils$Encode$association(chargeItem_))
                ]);
            } else return _List_Nil;
        }();
        var category = function() {
            var _v0 = fields.EL;
            if (!_v0.$) {
                var category_ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('category', $author$project$Utils$Encode$association(category_))
                ]);
            } else return _List_Nil;
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('charge', $elm$json$Json$Encode$object(_Utils_ap(patient, _Utils_ap(chargeItem, _Utils_ap(category, _Utils_ap(quantityUom, _List_fromArray([
                _Utils_Tuple2('name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.zr)),
                _Utils_Tuple2('description', $elm$json$Json$Encode$string(fields.NQ)),
                _Utils_Tuple2('quantity', $elm$json$Json$Encode$int(fields.Bu)),
                _Utils_Tuple2('price_in_cents', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Br)),
                _Utils_Tuple2('date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.M4)),
                _Utils_Tuple2('end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qv)),
                _Utils_Tuple2('practitioner', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.agi)),
                _Utils_Tuple2('location', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aeT))
            ])))))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Charge$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Charge$chargePath, basePath, id))));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge = F4(function(apiClient, model, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$paramsWithPrice, model, fields);
        return fields.N0 && !model.N0 ? A3($author$project$Api$Provider$Charge$CoverageDiscount$override, apiClient, id, A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset, id, apiFields)) : !fields.N0 && model.N0 ? A3($author$project$Api$Provider$Charge$CoverageDiscount$reset, apiClient, id, A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeReset, id, apiFields)) : A5($author$project$Api$Provider$Charge$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.RL), apiClient, id, apiFields, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated);
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$save = F3(function(apiClient, model, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var id = _v0.aef;
        if (!id.$) {
            var id_ = id.a;
            return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge, apiClient, model, id_, formFields);
        } else return A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$createCharge, apiClient, model, formFields);
    });
    var $author$project$Components$ResourceFilter$CompanyRegistration$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Api$Common$Account$RetrieveOptionals$Memberships = 0;
    var $author$project$Api$Provider$Affiliate$Account$companyAccountsPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'accounts'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(companyId));
    };
    var $author$project$Api$Provider$Affiliate$Account$companyAccountPath = F2(function(companyId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Affiliate$Account$companyAccountsPath(companyId));
    });
    var $author$project$Api$Common$Account$RetrieveOptionals$expandToString = function(expand) {
        return 'memberships';
    };
    var $author$project$Api$Common$Account$RetrieveOptionals$retrieveDefaults = {
        Fq: _List_Nil
    };
    var $author$project$Api$Common$Account$RetrieveOptionals$toParams = function(optionals) {
        var options = optionals($author$project$Api$Common$Account$RetrieveOptionals$retrieveDefaults);
        return _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Common$Account$RetrieveOptionals$expandToString, options.Fq))
        ]);
    };
    var $author$project$Api$Provider$Affiliate$Account$retrieve = F5(function(apiClient, companyId, id, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$Account$RetrieveOptionals$toParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Affiliate$Account$companyAccountPath, companyId, id))));
    });
    var $author$project$Api$Provider$Company$Account$companyAccountPath = F2(function(basePath, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Company$Account$companyAccountsPath(basePath));
    });
    var $author$project$Api$Provider$Company$Account$retrieve = F5(function(apiClient, companyId, id, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$Account$RetrieveOptionals$toParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Account$companyAccountPath, $author$project$Api$Provider$Company$companyPath(companyId), id))));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$findRecentMembership = F3(function(apiClient, field, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        var companyRegistrationId = function() {
            if (field.$ === 11) {
                var companyRegistration = field.a;
                return A2($elm$core$Maybe$andThen, function($) {
                    return $.eW;
                }, companyRegistration);
            } else return $elm$core$Maybe$Nothing;
        }();
        return _Utils_Tuple2($author$project$Utils$Maybe$toBool(companyRegistrationId) ? _Utils_update(model, {
            LI: $author$project$Api$Data$Loading
        }) : model, function() {
            if (!companyRegistrationId.$) {
                var companyRegistrationId_ = companyRegistrationId.a;
                return $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    function() {
                        var _v2 = model.RL;
                        if (!_v2.$) {
                            var affiliateId = _v2.a;
                            return A5($author$project$Api$Provider$Affiliate$Account$retrieve, apiClient, affiliateId, companyRegistrationId_, function(d) {
                                return _Utils_update(d, {
                                    Fq: _List_fromArray([
                                        0
                                    ])
                                });
                            }, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount);
                        } else {
                            var companyId_ = _v2.a;
                            return A5($author$project$Api$Provider$Company$Account$retrieve, apiClient, companyId_, companyRegistrationId_, function(d) {
                                return _Utils_update(d, {
                                    Fq: _List_fromArray([
                                        0
                                    ])
                                });
                            }, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotCompanyAccount);
                        }
                    }()
                ]));
            } else return cmd;
        }());
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm = F4(function(apiClient, model, field, form) {
        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field, form);
        return A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$findRecentMembership, apiClient, field, A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview, apiClient, field, newForm, _Utils_update(model, {
            PU: $elm$core$Maybe$Just(newForm)
        })));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField = F7(function(apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = model.PU;
        if (!_v0.$) {
            var form = _v0.a;
            var _v1 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
            var newDateInput = _v1.a;
            var subCmd = _v1.b;
            var event = _v1.c;
            var dateField = function() {
                if (event.$ === 1) {
                    var date = event.a;
                    return A2(field, newDateInput, date);
                } else {
                    var fields = $author$project$Utils$Form$fields(form);
                    return A2(field, newDateInput, fieldGetter(fields));
                }
            }();
            var _v2 = A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, dateField, form);
            var newModel = _v2.a;
            var formCmd = _v2.b;
            return {
                EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                    formCmd,
                    A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd)
                ])),
                adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                zi: newModel,
                at: _List_Nil
            };
        } else return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
            zi: model,
            at: _List_Nil
        };
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountInCents = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$Charge$Calculate$priceInCents = function(_v0) {
        var record = _v0;
        return record.Br;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateFormFromPreview = F2(function(preview, form) {
        return A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountInCents($author$project$Api$Provider$Charge$Calculate$discountInCents(preview)), A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents($elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))), form));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        qX: !model.qX
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        p2: !model.p2
                    }),
                    at: _List_Nil
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoiceLine = response.a;
                    var charge = $elm$core$List$head($author$project$Api$Provider$InvoiceLine$One$charges(invoiceLine));
                    var _v3 = function() {
                        if (!charge.$) {
                            var charge_ = charge.a;
                            var registrations = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$One$registrations, $author$project$Api$Provider$InvoiceLine$One$companyAccount(invoiceLine)));
                            var patient = $author$project$Api$Provider$Charge$One$patient(charge_);
                            var companyRegistrationsBasePath = function() {
                                var _v8 = model.RL;
                                if (_v8.$ === 1) {
                                    var companyId_ = _v8.a;
                                    return $author$project$Api$Provider$Company$companyPath(companyId_);
                                } else {
                                    var affiliateId = _v8.a;
                                    return $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId);
                                }
                            }();
                            var chargePatientId = A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$patient, charge));
                            var selectedRegistration = A2($elm_community$list_extra$List$Extra$find, function(registration) {
                                var registrationPatientId = $author$project$Api$Provider$Patient$Min$id($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient(registration));
                                return _Utils_eq($elm$core$Maybe$Just(registrationPatientId), chargePatientId);
                            }, registrations);
                            var formCompanyRegistration = A2($elm$core$Maybe$map, function(selectedRegistration_) {
                                var accountId = A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$One$id, $author$project$Api$Provider$InvoiceLine$One$companyAccount(invoiceLine));
                                return {
                                    eW: accountId,
                                    V7: {
                                        aef: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient, $author$project$Api$Provider$Patient$Min$id)(selectedRegistration_),
                                        zr: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient, $author$project$Api$Provider$Patient$Min$name)(selectedRegistration_)
                                    }
                                };
                            }, selectedRegistration);
                            var _v5 = A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsFromItem, apiClient, A2($author$project$Api$Practice$featureEnabled, 22, model.W1), model.Z$, charge_);
                            var formFields = _v5.a;
                            var formFieldsCmd = _v5.b;
                            var form = $author$project$Utils$Form$init(formFields);
                            var _v6 = A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration(formCompanyRegistration), form);
                            var modelWithForm = _v6.a;
                            var formCmd_ = _v6.b;
                            var _v7 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$CompanyRegistration$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(patient_) {
                                return _List_fromArray([
                                    {
                                        aef: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
                                        zr: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
                                    }
                                ]);
                            }, patient))), A4($author$project$Components$ResourceFilter$CompanyRegistration$init, apiClient, companyRegistrationsBasePath, $elm$core$Basics$identity, function(d) {
                                return _Utils_update(d, {
                                    Ee: 'None',
                                    afn: false,
                                    agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id, patient)
                                });
                            }));
                            var companyRegistrationResourceFilter = _v7.a;
                            var companyRegistrationResourceFilterCmd = _v7.b;
                            return _Utils_Tuple2(_Utils_update(modelWithForm, {
                                hR: companyRegistrationResourceFilter
                            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                formFieldsCmd,
                                formCmd_,
                                A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceFilterCmd)
                            ])));
                        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v3.a;
                    var formCmd = _v3.b;
                    return {
                        EQ: formCmd,
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: _Utils_update(newModel, {
                            N0: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$discountOverridden, charge)),
                            q3: response
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        q3: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var categories = response.a;
                    var category = $elm$core$List$head(categories);
                    var _v10 = A5($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsInit, apiClient, A2($author$project$Api$Practice$featureEnabled, 22, model.W1), model.Z$, model.cP, category);
                    var formFields = _v10.a;
                    var formFieldsCmd = _v10.b;
                    var _v11 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Category$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(category_) {
                        return _List_fromArray([
                            {
                                aef: $author$project$Api$Provider$Category$All$id(category_),
                                zr: $author$project$Api$Provider$Category$All$name(category_)
                            }
                        ]);
                    }, category))), A2($author$project$Components$ResourceFilter$Category$preSelectedId, A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$All$id, category), formFields.cK));
                    var categoryResourceFilter = _v11.a;
                    var categoryResourceFilterCmd = _v11.b;
                    var form = $elm$core$Maybe$Just($author$project$Utils$Form$init(_Utils_update(formFields, {
                        cK: categoryResourceFilter
                    })));
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            formFieldsCmd,
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceFilterCmd)
                        ])),
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: _Utils_update(model, {
                            PU: form
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 5:
                var field = msg.a;
                var _v12 = model.PU;
                if (!_v12.$) {
                    var form = _v12.a;
                    var _v13 = A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, field, form);
                    var newModel = _v13.a;
                    var formCmd = _v13.b;
                    return {
                        EQ: formCmd,
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: newModel,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 10:
                var debounceMsg = msg.a;
                var _v14 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$previewDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$debouncePreview), debounceMsg, model.eq);
                var newDebouncer = _v14.a;
                var cmd = _v14.b;
                return {
                    EQ: cmd,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        eq: newDebouncer
                    }),
                    at: _List_Nil
                };
            case 11:
                var cmd = msg.a;
                return {
                    EQ: cmd,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 12:
                var response = msg.a;
                if (response.$ === 3) {
                    var preview = response.a;
                    var form = A2($elm$core$Maybe$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateFormFromPreview(preview), model.PU);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: _Utils_update(model, {
                            PU: form,
                            agk: response
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        agk: response
                    }),
                    at: _List_Nil
                };
            case 6:
                var _v16 = model.PU;
                if (!_v16.$) {
                    var form = _v16.a;
                    var _v17 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsValidator, form);
                    if (!_v17.$) {
                        var _v18 = _v17.a;
                        var newForm = _v18.a;
                        var validFormFields = _v18.b;
                        return {
                            EQ: A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$save, apiClient, model, validFormFields),
                            adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                            zi: _Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm),
                                j_: $author$project$Api$Data$Loading
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var newForm = _v17.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                            zi: _Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm)
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var fields = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var charge = response.a;
                    var id = $author$project$Api$Provider$Charge$One$id(charge);
                    var eventName = 'Adjustment Added';
                    return {
                        EQ: A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateCharge, apiClient, model, id, fields),
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated,
                        zi: _Utils_update(model, {
                            j_: $author$project$Api$Data$NotAsked
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, eventName)
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 8:
                var id = msg.a;
                var params = msg.b;
                var response = msg.c;
                if (response.$ === 3) return {
                    EQ: A5($author$project$Api$Provider$Charge$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$chargesBasePath(model.RL), apiClient, id, params, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotChargeUpdated),
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeCreated,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 9:
                var response = msg.a;
                if (response.$ === 3) {
                    var eventName = 'Adjustment Updated';
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$InvoiceLineUpdated(A2($elm$core$Maybe$withDefault, '', model.q4)),
                        zi: _Utils_update(model, {
                            j_: $author$project$Api$Data$NotAsked
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, eventName)
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 13:
                var subMsg = msg.a;
                var _v22 = model.PU;
                if (!_v22.$) {
                    var form = _v22.a;
                    var fields = $author$project$Utils$Form$fields(form);
                    var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, fields.cL);
                    var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                        cL: chargeItemResourceResult.zi
                    }), form);
                    var _v23 = function() {
                        var _v24 = chargeItemResourceResult.adu;
                        _v24$3: while(true){
                            if (!_v24.$ && !_v24.a.$) switch(_v24.a.a.$){
                                case 0:
                                    var chargeItem = _v24.a.a.a;
                                    return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem($elm$core$Maybe$Just({
                                        I0: chargeItem.I0,
                                        EL: chargeItem.EL,
                                        Lk: chargeItem.Lk,
                                        Lm: chargeItem.Lm,
                                        NQ: chargeItem.NQ,
                                        aef: chargeItem.aef,
                                        aeE: chargeItem.aeE,
                                        rc: chargeItem.rc,
                                        TC: chargeItem.TC,
                                        zr: chargeItem.zr,
                                        Br: chargeItem.Br,
                                        XT: chargeItem.XT,
                                        $S: chargeItem.$S,
                                        aap: chargeItem.aap,
                                        aaK: chargeItem.aaK
                                    })), newForm);
                                case 5:
                                    var string = _v24.a.a.a;
                                    return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name(string), newForm);
                                case 2:
                                    var _v25 = _v24.a.a;
                                    return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItem($elm$core$Maybe$Nothing), newForm);
                                default:
                                    break _v24$3;
                            }
                            else break _v24$3;
                        }
                        return _Utils_Tuple2(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v23.a;
                    var formCmd = _v23.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.EQ),
                            formCmd
                        ])),
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: newModel,
                        at: chargeItemResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 14:
                var subMsg = msg.a;
                var _v26 = model.PU;
                if (!_v26.$) {
                    var form = _v26.a;
                    var fields = $author$project$Utils$Form$fields(form);
                    var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.cK);
                    var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                        cK: categoryResourceResult.zi
                    }), form);
                    var _v27 = function() {
                        var _v28 = categoryResourceResult.adu;
                        if (!_v28.$) {
                            if (!_v28.a.$) return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Category($author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi)), newForm);
                            else {
                                var _v29 = _v28.a;
                                return _Utils_Tuple2(_Utils_update(model, {
                                    PU: $elm$core$Maybe$Just(newForm)
                                }), $elm$core$Platform$Cmd$none);
                            }
                        } else return _Utils_Tuple2(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v27.a;
                    var formCmd = _v27.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, categoryResourceResult.EQ),
                            formCmd
                        ])),
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: newModel,
                        at: categoryResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 15:
                var subMsg = msg.a;
                var _v30 = model.PU;
                if (!_v30.$) {
                    var form = _v30.a;
                    var fields = $author$project$Utils$Form$fields(form);
                    var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, fields.jE);
                    var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                        jE: practitionerResourceResult.zi
                    }), form);
                    var _v31 = function() {
                        var _v32 = practitionerResourceResult.adu;
                        _v32$2: while(true){
                            if (!_v32.$ && !_v32.a.$) switch(_v32.a.a.$){
                                case 0:
                                    var practitioner = _v32.a.a.a;
                                    return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner($elm$core$Maybe$Just(practitioner)), newForm);
                                case 2:
                                    var _v33 = _v32.a.a;
                                    return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner($elm$core$Maybe$Nothing), newForm);
                                default:
                                    break _v32$2;
                            }
                            else break _v32$2;
                        }
                        return _Utils_Tuple2(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v31.a;
                    var formCmd = _v31.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, practitionerResourceResult.EQ),
                            formCmd
                        ])),
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: newModel,
                        at: practitionerResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 16:
                var subMsg = msg.a;
                var _v34 = model.PU;
                if (!_v34.$) {
                    var form = _v34.a;
                    var fields = $author$project$Utils$Form$fields(form);
                    var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, fields.ro);
                    var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                        ro: locationResourceResult.zi
                    }), form);
                    var _v35 = function() {
                        var _v36 = locationResourceResult.adu;
                        _v36$2: while(true){
                            if (!_v36.$ && !_v36.a.$) switch(_v36.a.a.$){
                                case 0:
                                    var location1 = _v36.a.a.a;
                                    return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location($elm$core$Maybe$Just(location1)), newForm);
                                case 2:
                                    var _v37 = _v36.a.a;
                                    return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location($elm$core$Maybe$Nothing), newForm);
                                default:
                                    break _v36$2;
                            }
                            else break _v36$2;
                        }
                        return _Utils_Tuple2(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v35.a;
                    var formCmd = _v35.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, locationResourceResult.EQ),
                            formCmd
                        ])),
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: newModel,
                        at: locationResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 17:
                var subMsg = msg.a;
                var companyRegistrationResourceResult = A3($author$project$Components$ResourceFilter$CompanyRegistration$update, apiClient, subMsg, model.hR);
                var _v38 = model.PU;
                if (!_v38.$) {
                    var form = _v38.a;
                    var _v39 = function() {
                        var _v40 = companyRegistrationResourceResult.adu;
                        _v40$2: while(true){
                            if (!_v40.$ && !_v40.a.$) switch(_v40.a.a.$){
                                case 0:
                                    var companyRegistration = _v40.a.a.a;
                                    var patientId_ = A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$id)(companyRegistration);
                                    var formCompanyRegistration = {
                                        eW: $elm$core$Maybe$Just(A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$account, $author$project$Api$Provider$CompanyAccount$Min$id)(companyRegistration)),
                                        V7: {
                                            aef: patientId_,
                                            zr: A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient, $author$project$Api$Provider$Patient$Min$name)(companyRegistration)
                                        }
                                    };
                                    return A2($author$project$Utils$Tuple3$fromTuple2, $elm$core$Maybe$Just(patientId_), A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration($elm$core$Maybe$Just(formCompanyRegistration)), form));
                                case 2:
                                    var _v41 = _v40.a.a;
                                    return A2($author$project$Utils$Tuple3$fromTuple2, $elm$core$Maybe$Nothing, A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateForm, apiClient, model, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistration($elm$core$Maybe$Nothing), form));
                                default:
                                    break _v40$2;
                            }
                            else break _v40$2;
                        }
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                    }();
                    var newModel = _v39.a;
                    var formCmd = _v39.b;
                    var patientId = _v39.c;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceResult.EQ),
                            formCmd,
                            function() {
                                if (!patientId.$) {
                                    var patientId_ = patientId.a;
                                    var _v43 = model.RL;
                                    if (_v43.$ === 1) return A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotPatient);
                                    else {
                                        var affiliateId = _v43.a;
                                        return A4($author$project$Api$Provider$Affiliates$AffiliatePatient$retrieve, apiClient, affiliateId, patientId_, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$GotAffiliatePatient);
                                    }
                                } else return $elm$core$Platform$Cmd$none;
                            }()
                        ])),
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: _Utils_update(newModel, {
                            hR: companyRegistrationResourceResult.zi
                        }),
                        at: companyRegistrationResourceResult.at
                    };
                } else return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, companyRegistrationResourceResult.EQ),
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        hR: companyRegistrationResourceResult.zi
                    }),
                    at: _List_Nil
                };
            case 18:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A7($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField, apiClient, model, dateInput, subMsg, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDate, function($) {
                    return $._0;
                });
            case 19:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A7($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$updateDateInputFormField, apiClient, model, dateInput, subMsg, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDate, function($) {
                    return $.qv;
                });
            case 20:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: _Utils_update(model, {
                        LI: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 21:
                var response = msg.a;
                var _v44 = _Utils_Tuple2(response, model.PU);
                if (_v44.a.$ === 3 && !_v44.b.$) {
                    var _v45 = _v44.a;
                    var patient = _v45.a;
                    var form = _v44.b.a;
                    var _v46 = function() {
                        var _v47 = _Utils_Tuple2($author$project$Api$Provider$Patient$One$location(patient), $author$project$Api$Provider$Patient$One$practitioner(patient));
                        if (!_v47.a.$) {
                            if (!_v47.b.$) {
                                var location1 = _v47.a.a;
                                var practitioner = _v47.b.a;
                                var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location($author$project$Components$ResourceFilter$Location$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Location$Shared$Provider(location1))));
                                return _Utils_Tuple2(A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner($author$project$Components$ResourceFilter$Practitioner$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Practitioner$Shared$Provider(practitioner)))), A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form)), $elm$core$Maybe$Just(field_));
                            } else {
                                var location1 = _v47.a.a;
                                var _v48 = _v47.b;
                                var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Location($author$project$Components$ResourceFilter$Location$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Location$Shared$Provider(location1))));
                                return _Utils_Tuple2(A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form), $elm$core$Maybe$Just(field_));
                            }
                        } else if (!_v47.b.$) {
                            var _v49 = _v47.a;
                            var practitioner = _v47.b.a;
                            var field_ = $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Practitioner($author$project$Components$ResourceFilter$Practitioner$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Practitioner$Shared$Provider(practitioner))));
                            return _Utils_Tuple2(A3($author$project$Utils$Form$update, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$formFieldsUpdate, field_, form), $elm$core$Maybe$Just(field_));
                        } else {
                            var _v50 = _v47.a;
                            var _v51 = _v47.b;
                            return _Utils_Tuple2(form, $elm$core$Maybe$Nothing);
                        }
                    }();
                    var newForm = _v46.a;
                    var field = _v46.b;
                    var _v52 = function() {
                        if (!field.$) {
                            var field_ = field.a;
                            return A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$calculatePreview, apiClient, field_, newForm, model);
                        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v52.a;
                    var calculatePreviewCmd = _v52.b;
                    return {
                        EQ: calculatePreviewCmd,
                        adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                        zi: _Utils_update(newModel, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotCoverageDiscounts = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Charge$CoverageDiscount$list = F3(function(apiClient, chargeId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Charge$CoverageDiscount$coverageDiscountsPath(chargeId)));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    op: !model.op
                }), function() {
                    var _v1 = model.fS;
                    if (_v1.$ === 3) return $elm$core$Platform$Cmd$none;
                    else return A4($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$retrieveInvoiceLine, apiClient, model.Z$, model.RL, model.q3);
                }(), _List_Nil);
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoiceLine = response.a;
                    var charge = $elm$core$List$head($author$project$Api$Provider$InvoiceLine$One$charges(invoiceLine));
                    return _Utils_Tuple3(_Utils_update(model, {
                        fS: response
                    }), function() {
                        var _v3 = _Utils_Tuple3($author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$), charge, model.RL);
                        if (!_v3.a && !_v3.b.$ && _v3.c.$ === 1) {
                            var charge_ = _v3.b.a;
                            var _v4 = _v3.c;
                            return A3($author$project$Api$Provider$Charge$CoverageDiscount$list, apiClient, $author$project$Api$Provider$Charge$One$id(charge_), $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$GotCoverageDiscounts);
                        } else return $elm$core$Platform$Cmd$none;
                    }(), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    fS: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    wZ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoiceLines = response.a;
                    var headers = response.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            ar: response,
                            af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                            en: $elm$core$Dict$fromList(A2($elm$core$List$map, function(invoiceLine) {
                                var invoiceType = function() {
                                    var _v2 = model.RL;
                                    if (!_v2.$) {
                                        var affiliateBillId = _v2.b;
                                        return $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Affiliate(affiliateBillId);
                                    } else {
                                        var companyId_ = _v2.a;
                                        var invoiceId = _v2.b;
                                        return A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$Company, companyId_, invoiceId);
                                    }
                                }();
                                var phiMoreInfo = A4($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$init, model.Z$, invoiceType, $author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(model.acy), invoiceLine);
                                return _Utils_Tuple2($author$project$Api$Provider$InvoiceLine$All$id(invoiceLine), phiMoreInfo);
                            }, invoiceLines))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        ar: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        xv: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 2:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v3.a;
                var searchInputCmd = _v3.b;
                var searchInputEvent = _v3.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v4 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            ar: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, qModel));
                    }
                }();
                var newModel = _v4.a;
                var cmd = _v4.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg, searchInputCmd),
                        cmd
                    ])),
                    adu: 1,
                    zi: _Utils_update(newModel, {
                        sG: searchInput
                    }),
                    at: _List_Nil
                };
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    ar: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return {
                    EQ: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
                    adu: 1,
                    zi: newModel,
                    at: _List_Nil
                };
            case 4:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ar: $author$project$Api$Data$Loading,
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return {
                    EQ: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
                    adu: 1,
                    zi: newModel,
                    at: _List_Nil
                };
            case 5:
                var subMsg = msg.a;
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cK);
                var categoryId = function() {
                    var _v7 = categoryResourceResult.adu;
                    if (!_v7.$) {
                        if (!_v7.a.$) return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi);
                        else {
                            var _v8 = _v7.a;
                            return model.fg;
                        }
                    } else return model.fg;
                }();
                var newModel = _Utils_update(model, {
                    fg: categoryId,
                    cK: categoryResourceResult.zi
                });
                var _v6 = _Utils_eq(model.fg, newModel.fg) ? _Utils_Tuple2(model.ar, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel));
                var invoiceLines = _v6.a;
                var cmd = _v6.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg, categoryResourceResult.EQ),
                        cmd
                    ])),
                    adu: 1,
                    zi: _Utils_update(newModel, {
                        ar: invoiceLines
                    }),
                    at: categoryResourceResult.at
                };
            case 6:
                var subMsg = msg.a;
                var _v9 = model.jy;
                if (!_v9.$) {
                    var planResourceFilter = _v9.a;
                    var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planResourceFilter);
                    var planId = function() {
                        var _v11 = planResourceResult.adu;
                        if (!_v11.$) {
                            if (!_v11.a.$) return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.zi);
                            else {
                                var _v12 = _v11.a;
                                return model.agd;
                            }
                        } else return model.agd;
                    }();
                    var newModel = _Utils_update(model, {
                        agd: planId,
                        jy: $elm$core$Maybe$Just(planResourceResult.zi)
                    });
                    var _v10 = _Utils_eq(model.agd, newModel.agd) ? _Utils_Tuple2(model.ar, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel));
                    var invoiceLines = _v10.a;
                    var cmd = _v10.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg, planResourceResult.EQ),
                            cmd
                        ])),
                        adu: 1,
                        zi: _Utils_update(newModel, {
                            ar: invoiceLines
                        }),
                        at: planResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var subMsg = msg.a;
                var _v13 = A2($author$project$Ui$Dropdown$update, subMsg, model.l5);
                var employeeDivisionDropdown = _v13.a;
                var cmd = _v13.b;
                return {
                    EQ: cmd,
                    adu: 1,
                    zi: _Utils_update(model, {
                        l5: employeeDivisionDropdown
                    }),
                    at: _List_Nil
                };
            case 8:
                var selectedDivision = msg.a;
                var newModel = _Utils_update(model, {
                    Fm: selectedDivision,
                    ar: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                return {
                    EQ: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, newModel),
                    adu: 1,
                    zi: newModel,
                    at: _List_Nil
                };
            case 9:
                return A3($author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal, apiClient, model, $elm$core$Maybe$Nothing);
            case 10:
                var invoiceLine = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        fv: $elm$core$Maybe$Just(_Utils_Tuple2(invoiceLine, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 11:
                var invoiceLine = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
                    return {
                        EQ: function() {
                            var _v14 = model.RL;
                            if (_v14.$ === 1) {
                                var companyId_ = _v14.a;
                                var invoiceId_ = _v14.b;
                                return A5($author$project$Api$Provider$Company$Invoice$InvoiceLine$delete, apiClient, companyId_, invoiceId_, id, $author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted(id));
                            } else {
                                var invoiceId_ = _v14.b;
                                return A4($author$project$Api$Provider$AffiliateBill$InvoiceLine$delete, apiClient, invoiceId_, id, $author$project$Components$Invoice$InvoiceLinesTable$InvoiceLineDeleted(id));
                            }
                        }(),
                        adu: 1,
                        zi: _Utils_update(model, {
                            fv: $elm$core$Maybe$Just(_Utils_Tuple2(invoiceLine, $author$project$Api$Data$Loading)),
                            dR: A2($elm$core$Set$insert, id, model.dR)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        fv: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 12:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return {
                            EQ: A2($author$project$Components$Invoice$InvoiceLinesTable$fetchInvoiceLines, apiClient, model),
                            adu: 0,
                            zi: _Utils_update(model, {
                                fv: $elm$core$Maybe$Nothing,
                                dR: A2($elm$core$Set$remove, id, model.dR),
                                ar: $author$project$Api$Data$Loading
                            }),
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Invoice line removed')
                            ])
                        };
                    case 2:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 1,
                            zi: _Utils_update(model, {
                                dR: A2($elm$core$Set$remove, id, model.dR)
                            }),
                            at: $author$project$OutMsg$handleErrorResponse(response)
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 1,
                            zi: model,
                            at: _List_Nil
                        };
                }
            case 13:
                var invoiceLine = msg.a;
                var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
                return A3($author$project$Components$Invoice$InvoiceLinesTable$openAdjustmentModal, apiClient, model, $elm$core$Maybe$Just(id));
            case 14:
                var id = msg.a;
                var subMsg = msg.b;
                var _v16 = A2($elm$core$Dict$get, id, model.en);
                if (!_v16.$) {
                    var phiMoreInfo = _v16.a;
                    var _v17 = A3($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$update, apiClient, subMsg, phiMoreInfo);
                    var phiMoreInfo_ = _v17.a;
                    var phiMoreInfoCmd = _v17.b;
                    var phiMoreInfoOutMsgs = _v17.c;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id), phiMoreInfoCmd),
                        adu: 1,
                        zi: _Utils_update(model, {
                            en: A3($elm$core$Dict$insert, id, phiMoreInfo_, model.en)
                        }),
                        at: phiMoreInfoOutMsgs
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 15:
                var subMsg = msg.a;
                var _v18 = model.ht;
                if (!_v18.$) {
                    var adjustmentModal = _v18.a;
                    var adjustmentModalResult = A3($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$update, apiClient, subMsg, adjustmentModal);
                    var _v19 = function() {
                        var _v20 = adjustmentModalResult.adu;
                        switch(_v20.$){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(adjustmentModalResult.zi), 1, $elm$core$Maybe$Nothing);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, 1, $elm$core$Maybe$Nothing);
                            case 2:
                                var id = _v20.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, 0, $elm$core$Maybe$Just(id));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, 0, $elm$core$Maybe$Nothing);
                        }
                    }();
                    var adjustmentModal_ = _v19.a;
                    var event = _v19.b;
                    var toUpdateId = _v19.c;
                    var _v21 = A3($author$project$Components$Invoice$InvoiceLinesTable$refreshPhiMoreInfo, apiClient, model.en, toUpdateId);
                    var phiMoreInfos = _v21.a;
                    var phiMoreInfoCmd = _v21.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg, adjustmentModalResult.EQ),
                            phiMoreInfoCmd
                        ])),
                        adu: event,
                        zi: _Utils_update(model, {
                            ht: adjustmentModal_,
                            en: phiMoreInfos
                        }),
                        at: adjustmentModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 17:
                var subMsg = msg.a;
                var _v22 = $author$project$Components$FileLink$update(subMsg);
                var getFileCmdMsg = _v22.a;
                var outMsgs = _v22.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg, getFileCmdMsg),
                    adu: 1,
                    zi: model,
                    at: outMsgs
                };
            default:
                var subMsg = msg.a;
                var _v23 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v23.a;
                var subCmd = _v23.b;
                var subOutMsg = _v23.c;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg, subCmd),
                    adu: 1,
                    zi: _Utils_update(model, {
                        md: exportCsv
                    }),
                    at: subOutMsg
                };
        }
    });
    var $author$project$Components$Invoice$Summary$OtherChargesSummary$update = F2(function(msg, model) {
        return _Utils_update(model, {
            gS: !model.gS
        });
    });
    var $author$project$Components$Invoice$Summary$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var groupBy_ = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    fQ: $elm$core$Maybe$Just(groupBy_)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    gT: !model.gT
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    gR: !model.gR
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    xf: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var delta = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    nm: $elm$core$Maybe$Just(delta)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    nm: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var otherChargesSummary = A2($author$project$Components$Invoice$Summary$OtherChargesSummary$update, subMsg, model.rN);
                return _Utils_Tuple3(_Utils_update(model, {
                    rN: otherChargesSummary
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Invoice$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var dateInput = field.a;
            var date = field.b;
            return _Utils_update(fields, {
                RG: date,
                mD: dateInput
            });
        } else {
            var dateInput = field.a;
            var date = field.b;
            return _Utils_update(fields, {
                iY: date,
                mE: dateInput
            });
        }
    });
    var $author$project$Api$Provider$Company$Invoice$updateDates = F5(function(apiClient, companyId, id, _v0, toMsg) {
        var invoiceDate = _v0.RG;
        var dueDate = _v0.Ok;
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('invoice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('date', $author$project$Utils$Date$encode(invoiceDate)),
                _Utils_Tuple2('due_date', $author$project$Utils$Date$encode(dueDate))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
    });
    var $author$project$Api$Company$Invoice$updateDates = F6(function(apiClient, session, companyId, id, dates, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A5($author$project$Api$Provider$Company$Invoice$updateDates, apiClient, companyId, id, dates, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
    });
    var $author$project$Components$Invoice$updateDateInputFormField = F7(function(apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var cmdInput = A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd);
        if (event.$ === 1) {
            var maybeDate = event.a;
            if (!maybeDate.$) {
                var date = maybeDate.a;
                var form = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$formFieldsUpdate, A2(field, newDateInput, date), model.cw);
                var updateInvoiceCmd = function() {
                    var _v3 = model.RL;
                    if (!_v3.$) return $elm$core$Platform$Cmd$none;
                    else {
                        var companyId = _v3.a;
                        var id = _v3.b;
                        var newFields = $author$project$Utils$Form$fields(form);
                        var dateFields = {
                            Ok: newFields.iY,
                            RG: newFields.RG
                        };
                        return A6($author$project$Api$Company$Invoice$updateDates, apiClient, model.Z$, companyId, id, dateFields, $author$project$Components$Invoice$GotCompanyInvoice);
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    cw: form,
                    om: false,
                    oo: false
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmdInput,
                    updateInvoiceCmd
                ])), _List_Nil);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
            var fields = $author$project$Utils$Form$fields(model.cw);
            var form = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.cw);
            return _Utils_Tuple3(_Utils_update(model, {
                cw: form
            }), cmdInput, _List_Nil);
        }
    });
    var $author$project$Components$Invoice$Voided = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Company$Invoice$void = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'void'
        ]), A2($author$project$Api$Provider$Company$Invoice$invoicePath, companyId, id))));
    });
    var $author$project$Api$Company$Invoice$void = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$Company$Invoice$void, apiClient, companyId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
    });
    var $author$project$Api$Provider$AffiliateBill$void = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'void'
        ]), $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id))));
    });
    var $author$project$Components$Invoice$void = F4(function(apiClient, session, invoiceType, invoice) {
        if (!invoiceType.$) {
            var id = invoiceType.b;
            return A3($author$project$Api$Provider$AffiliateBill$void, apiClient, id, A2($elm$core$Basics$composeL, $author$project$Components$Invoice$Voided(invoice), $author$project$Api$Data$map($author$project$Api$Invoice$One$Provider)));
        } else {
            var companyId = invoiceType.a;
            var id = invoiceType.b;
            return A5($author$project$Api$Company$Invoice$void, apiClient, session, companyId, id, $author$project$Components$Invoice$Voided(invoice));
        }
    });
    var $author$project$Components$Invoice$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoice = response.a;
                    var auditTrailLog = A7($author$project$Components$AuditTrailLog$init, model.Z$, model.aaT, model.HO, $elm$core$Maybe$Just('invoice'), $elm$core$Maybe$Just($author$project$Api$Invoice$One$id(invoice)), $author$project$Api$Invoice$One$createdAt(invoice), $elm$core$Maybe$Nothing);
                    var _v3 = A7($author$project$Components$Invoice$InvoiceLinesTable$init, model.cP, apiClient, model.Z$, model.W1, $author$project$Components$Invoice$invoiceLinesTableCompany(model.acy), $author$project$Components$Invoice$invoiceLinesTableInvoiceType(model.RL), invoice);
                    var invoiceLinesTable = _v3.a;
                    var invoiceLinesTableCmd = _v3.b;
                    var _v4 = $author$project$Components$Invoice$formFieldsFromInvoice(invoice);
                    var fields = _v4.a;
                    var fieldsCmd = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cw: $author$project$Utils$Form$init(fields),
                        hB: $elm$core$Maybe$Just(auditTrailLog),
                        RA: response,
                        eb: $elm$core$Maybe$Just(invoiceLinesTable)
                    }), $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTableMsg, invoiceLinesTableCmd), A2($elm$core$List$cons, function() {
                        var _v5 = model.RL;
                        if (_v5.$ === 1) {
                            var companyId = _v5.a;
                            var invoiceId = _v5.b;
                            return A5($author$project$Api$Company$Invoice$Summary$retrieve, apiClient, model.Z$, companyId, invoiceId, $author$project$Components$Invoice$GotSummary);
                        } else {
                            var invoiceId = _v5.b;
                            return A3($author$project$Api$Provider$AffiliateBill$Summary$retrieve, apiClient, invoiceId, $author$project$Components$Invoice$GotSummary);
                        }
                    }(), A2($elm$core$List$cons, $author$project$Api$Invoice$One$isUpdating(invoice) ? $author$project$Components$Invoice$pollInvoiceForStatus : $elm$core$Platform$Cmd$none, fieldsCmd)))), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    RA: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        RA: response
                    }), $author$project$Api$Invoice$One$isUpdating(invoice) ? $author$project$Components$Invoice$pollInvoiceForStatus : A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.Z$, model.RL), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    RA: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                var _v7 = _Utils_Tuple2(response, model.RA);
                if (_v7.a.$ === 3 && _v7.b.$ === 3) {
                    var _v8 = _v7.a;
                    var summary = _v8.a;
                    var _v9 = _v7.b;
                    var invoice = _v9.a;
                    var totalCount = $author$project$Api$Common$Invoice$Summary$AllLines$count($author$project$Api$Common$Invoice$Summary$allLines(summary));
                    var invoiceSummaryInvoiceType = function() {
                        var _v11 = model.RL;
                        if (!_v11.$) {
                            var id = _v11.b;
                            return $author$project$Components$Invoice$Summary$Affiliate(id);
                        } else {
                            var companyId = _v11.a;
                            var id = _v11.b;
                            return A2($author$project$Components$Invoice$Summary$Company, companyId, id);
                        }
                    }();
                    var _v10 = A8($author$project$Components$Invoice$Summary$init, apiClient, model.Z$, model.HO, model.W1, $author$project$Components$Invoice$invoiceSummaryCompany(model.acy), invoiceSummaryInvoiceType, invoice, summary);
                    var invoiceSummary = _v10.a;
                    var invoiceSummaryCmd = _v10.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        yn: $elm$core$Maybe$Just(totalCount),
                        fU: $elm$core$Maybe$Just(invoiceSummary)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceSummaryMsg, invoiceSummaryCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var subMsg = msg.a;
                var _v12 = A2($author$project$Ui$Dropdown$update, subMsg, model.l_);
                var dropdownMenu = _v12.a;
                var cmd = _v12.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    l_: dropdownMenu
                }), cmd, _List_Nil);
            case 4:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4($author$project$Components$Invoice$initCompanyEmailModal, apiClient, model, invoice, false));
            case 5:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4($author$project$Components$Invoice$initCompanyEmailModal, apiClient, _Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), invoice, true));
            case 6:
                var invoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    tG: $elm$core$Maybe$Just(invoice)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var invoice = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading,
                    tG: $elm$core$Maybe$Just(invoice)
                }), A4($author$project$Components$Invoice$void, apiClient, model.Z$, model.RL, invoice), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    tG: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var invoice = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    RA: response,
                    j_: $author$project$Api$Data$NotAsked,
                    tG: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked,
                    tG: $elm$core$Maybe$Just(invoice)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var invoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    eC: $elm$core$Maybe$Just(invoice)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var invoice = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    eC: $elm$core$Maybe$Just(invoice),
                    j_: $author$project$Api$Data$Loading
                }), A4($author$project$Components$Invoice$returnToDraft, apiClient, model.Z$, model.RL, invoice), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    eC: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var invoice = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    RA: response,
                    eC: $elm$core$Maybe$Nothing,
                    j_: $author$project$Api$Data$NotAsked
                }), $author$project$Components$Invoice$pollInvoiceForStatus, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice returned to draft')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    eC: $elm$core$Maybe$Just(invoice),
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 12:
                var invoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    eh: $elm$core$Maybe$Just(invoice)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var invoice = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    eh: $elm$core$Maybe$Just(invoice),
                    j_: $author$project$Api$Data$Loading
                }), A4($author$project$Components$Invoice$markAsBadDebt, apiClient, model.Z$, model.RL, invoice), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    eh: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var invoice = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    RA: response,
                    eh: $elm$core$Maybe$Nothing,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice marked as bad debt')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    eh: $elm$core$Maybe$Just(invoice),
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 15:
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Components$Invoice$reverseBadDebt, apiClient, model.Z$, model.RL), _List_Nil);
            case 16:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    RA: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice returned to issued')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 17:
                var invoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Just(invoice)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var invoice = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Just(invoice),
                    j_: $author$project$Api$Data$Loading
                }), A4($author$project$Components$Invoice$delete, apiClient, model.Z$, model.RL, invoice), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var invoice = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Nothing,
                    j_: $author$project$Api$Data$NotAsked
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, model.Gc), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice destroyed successfully')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    ib: $elm$core$Maybe$Just(invoice),
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 20:
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Components$Invoice$issue, apiClient, model.Z$, model.RL), _List_Nil);
            case 21:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    RA: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice issued')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 22:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4($author$project$Components$Invoice$initCreatePaymentModal, apiClient, model, invoice, false));
            case 23:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4($author$project$Components$Invoice$initCreatePaymentModal, apiClient, model, invoice, true));
            case 24:
                var subMsg = msg.a;
                var paymentsHistoryResult = A3($author$project$Components$Invoice$PaymentsHistory$update, apiClient, subMsg, model.js);
                var _v19 = function() {
                    var refreshInvoice = _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.Z$, model.RL));
                    var _v20 = paymentsHistoryResult.adu;
                    switch(_v20){
                        case 0:
                            return _Utils_Tuple2(model.RA, $elm$core$Platform$Cmd$none);
                        case 1:
                            return refreshInvoice;
                        case 2:
                            return refreshInvoice;
                        case 3:
                            return refreshInvoice;
                        default:
                            return refreshInvoice;
                    }
                }();
                var invoice = _v19.a;
                var cmd = _v19.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    RA: invoice,
                    js: paymentsHistoryResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$PaymentsHistoryMsg, paymentsHistoryResult.EQ),
                    cmd
                ])), paymentsHistoryResult.at);
            case 25:
                var subMsg = msg.a;
                var _v21 = model.hQ;
                if (!_v21.$) {
                    var companyEmailModal = _v21.a;
                    var companyEmailModalResult = A3($author$project$Components$CompanyEmailModal$update, apiClient, subMsg, companyEmailModal);
                    var _v22 = function() {
                        var _v23 = companyEmailModalResult.adu;
                        switch(_v23){
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Just(companyEmailModalResult.zi), model.RA, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.Z$, model.RL));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var companyEmailModal_ = _v22.a;
                    var invoice = _v22.b;
                    var cmd = _v22.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        hQ: companyEmailModal_,
                        RA: invoice
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CompanyEmailModalMsg, companyEmailModalResult.EQ),
                        cmd
                    ])), companyEmailModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 26:
                var subMsg = msg.a;
                var _v24 = model.lH;
                if (!_v24.$) {
                    var createPaymentModal = _v24.a;
                    var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, apiClient, subMsg, createPaymentModal);
                    var _v25 = function() {
                        var _v26 = createPaymentModalResult.adu;
                        switch(_v26){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createPaymentModalResult.zi), model.RA, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.Z$, model.RL));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var createPaymentModal_ = _v25.a;
                    var invoice = _v25.b;
                    var cmd = _v25.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lH: createPaymentModal_,
                        RA: invoice
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreatePaymentModalMsg, createPaymentModalResult.EQ),
                        cmd
                    ])), createPaymentModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 27:
                var subMsg = msg.a;
                var _v27 = model.fU;
                if (!_v27.$) {
                    var invoiceSummary = _v27.a;
                    var _v28 = A2($author$project$Components$Invoice$Summary$update, subMsg, invoiceSummary);
                    var invoiceSummary_ = _v28.a;
                    var invoiceSummaryCmd = _v28.b;
                    var invoiceSummaryOutMsgs = _v28.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fU: $elm$core$Maybe$Just(invoiceSummary_)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceSummaryMsg, invoiceSummaryCmd), invoiceSummaryOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 28:
                var subMsg = msg.a;
                var _v29 = model.eb;
                if (!_v29.$) {
                    var invoiceLinesTable = _v29.a;
                    var invoiceLinesTableResult = A3($author$project$Components$Invoice$InvoiceLinesTable$update, apiClient, subMsg, invoiceLinesTable);
                    var _v30 = function() {
                        var _v31 = invoiceLinesTableResult.adu;
                        if (_v31 === 1) return _Utils_Tuple2(model.RA, $elm$core$Platform$Cmd$none);
                        else return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Components$Invoice$retrieveInvoice, apiClient, model.Z$, model.RL));
                    }();
                    var invoice = _v30.a;
                    var cmd = _v30.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        RA: invoice,
                        eb: $elm$core$Maybe$Just(invoiceLinesTableResult.zi)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$InvoiceLinesTableMsg, invoiceLinesTableResult.EQ)
                    ])), invoiceLinesTableResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 29:
                return _Utils_Tuple3(_Utils_update(model, {
                    om: !model.om
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 31:
                return _Utils_Tuple3(_Utils_update(model, {
                    oo: !model.oo
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 30:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A7($author$project$Components$Invoice$updateDateInputFormField, apiClient, model, dateInput, subMsg, $author$project$Components$Invoice$InvoiceDateInputMsg, $author$project$Components$Invoice$InvoiceDate, function($) {
                    return $.RG;
                });
            case 32:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A7($author$project$Components$Invoice$updateDateInputFormField, apiClient, model, dateInput, subMsg, $author$project$Components$Invoice$InvoiceDueDateInputMsg, $author$project$Components$Invoice$InvoiceDueDate, function($) {
                    return $.iY;
                });
            case 33:
                return _Utils_Tuple3(model, A3($author$project$Components$Invoice$retrieveInvoiceStatus, apiClient, model.Z$, model.RL), _List_Nil);
            case 34:
                var subMsg = msg.a;
                var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, apiClient, subMsg, model.it);
                var showModal = function() {
                    var _v32 = downloadInvoiceResult.adu;
                    switch(_v32){
                        case 2:
                            return true;
                        case 3:
                            return false;
                        default:
                            return model.on;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    it: downloadInvoiceResult.zi,
                    on: showModal
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$DownloadInvoiceMsg, downloadInvoiceResult.EQ), downloadInvoiceResult.at);
            case 35:
                return _Utils_Tuple3(_Utils_update(model, {
                    on: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 36:
                var subMsg = msg.a;
                var _v33 = model.hB;
                if (!_v33.$) {
                    var auditTrailLog = _v33.a;
                    var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, auditTrailLog);
                    return _Utils_Tuple3(_Utils_update(model, {
                        hB: $elm$core$Maybe$Just(auditTrailLogResult.zi)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$AuditTrailLogMsg, auditTrailLogResult.EQ), auditTrailLogResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 37:
                var subMsg = msg.a;
                var _v34 = function() {
                    var _v35 = model.tF;
                    if (!_v35.$) {
                        var virtualBankAccountsComponent_ = _v35.a;
                        var _v36 = A3($author$project$Components$Company$VirtualBankAccounts$Invoice$update, apiClient, subMsg, virtualBankAccountsComponent_);
                        var virtualModel_ = _v36.a;
                        var virtualCmd_ = _v36.b;
                        var virtualOutMsgs_ = _v36.c;
                        return _Utils_Tuple3($elm$core$Maybe$Just(virtualModel_), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$VirtualBankAccountsComponentMsg, virtualCmd_), virtualOutMsgs_);
                    } else return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
                }();
                var model_ = _v34.a;
                var cmd_ = _v34.b;
                var outMsgs_ = _v34.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    tF: model_
                }), cmd_, outMsgs_);
            default:
                var integrationRecords = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Rr: integrationRecords
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(integrationRecords));
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$update = F2(function(msg, model) {
        if (!msg.$) {
            var session = msg.a;
            var practice = msg.b;
            var shared = msg.c;
            var affiliateBillId = msg.d;
            var response = msg.e;
            if (response.$ === 3) {
                var affiliate = response.a;
                var _v2 = $author$project$Components$Invoice$init({
                    Ej: model.Ej,
                    k3: true,
                    acy: A2($elm$core$Maybe$map, $author$project$Components$Invoice$ProviderMin, $author$project$Api$Provider$Affiliate$One$company(affiliate)),
                    RL: A2($author$project$Components$Invoice$Affiliate, $author$project$Api$Provider$Affiliate$One$id(affiliate), affiliateBillId),
                    Gc: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
                        pr: $author$project$Api$Provider$Affiliate$One$id(affiliate)
                    }),
                    r2: $elm$core$Maybe$Nothing,
                    W1: $author$project$Api$Practice$Provider(practice),
                    Z$: session,
                    Cu: shared
                });
                var invoiceComponent = _v2.a;
                var invoiceComponentCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    fT: $elm$core$Maybe$Just(invoiceComponent)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg, invoiceComponentCmd), _List_Nil);
            } else return _Utils_Tuple3(_Utils_update(model, {
                fT: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var subMsg = msg.a;
            var _v3 = model.fT;
            if (!_v3.$) {
                var invoiceComponent = _v3.a;
                var _v4 = A3($author$project$Components$Invoice$update, model.Ej, subMsg, invoiceComponent);
                var invoiceComponent_ = _v4.a;
                var cmd = _v4.b;
                var outMsgs = _v4.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    fT: $elm$core$Maybe$Just(invoiceComponent_)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg, cmd), outMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Invoice$Delete = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Invoice$Email = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Invoice$MakeViewableAndEmail = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Invoice$MarkAsBadDebt = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Invoice$Pay = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Invoice$RecordPayment = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Components$Invoice$ReturnToDraft = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Invoice$ReverseBadDebt = {
        $: 15
    };
    var $author$project$Components$Invoice$Void = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Employer$Invoice$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Employer$Invoice$One$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$Invoice$One$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$amountInCents(shared);
    };
    var $author$project$Api$Invoice$One$amountInCents = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$amountInCents(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$amountInCents(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$One$autoPayDate = function(_v0) {
        var record = _v0.b;
        return record.JV;
    };
    var $author$project$Api$Provider$Invoice$One$autoPayDate = function(_v0) {
        var record = _v0.b;
        return record.JV;
    };
    var $author$project$Api$Invoice$One$autoPayDate = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$autoPayDate(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$autoPayDate(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$Meta$canCancelAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KF;
    };
    var $author$project$Api$Provider$Invoice$Meta$canCancelAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KF;
    };
    var $author$project$Api$Invoice$Meta$canCancelAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$canCancelAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$Invoice$Meta$canCancelAction(meta_);
        }
    };
    var $author$project$Api$Provider$Invoice$Meta$canDelete = function(_v0) {
        var meta = _v0;
        return meta.tM.KG;
    };
    var $author$project$Api$Invoice$Meta$canDelete = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$canDelete(meta_);
        } else return false;
    };
    var $author$project$Api$Provider$Invoice$Meta$canDraftAndDestroyCurrentDraftAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KI;
    };
    var $author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta_);
        } else return false;
    };
    var $author$project$Api$Provider$Invoice$Meta$canMakeViewableAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KO;
    };
    var $author$project$Api$Invoice$Meta$canMakeViewableAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$canMakeViewableAction(meta_);
        } else return false;
    };
    var $author$project$Api$Provider$Invoice$Meta$canMarkAsBadDebtAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KP;
    };
    var $author$project$Api$Invoice$Meta$canMarkAsBadDebtAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$canMarkAsBadDebtAction(meta_);
        } else return false;
    };
    var $author$project$Api$Provider$Invoice$Meta$canNotifyAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KQ;
    };
    var $author$project$Api$Invoice$Meta$canNotifyAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$canNotifyAction(meta_);
        } else return false;
    };
    var $author$project$Api$Provider$Invoice$Meta$canReverseBadDebtAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KS;
    };
    var $author$project$Api$Invoice$Meta$canReverseBadDebtAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$canReverseBadDebtAction(meta_);
        } else return false;
    };
    var $author$project$Components$Invoice$companyAddress = function(company) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$andThen, function(company_) {
            if (!company_.$) return $elm$core$Maybe$Nothing;
            else {
                var company__ = company_.a;
                return $elm$core$Maybe$Just($author$project$Api$Company$address(company__));
            }
        }, company));
    };
    var $author$project$Api$Employer$Company$One$defaultSource = function(_v0) {
        var record = _v0.b;
        return record.ND;
    };
    var $author$project$Api$Provider$Company$One$defaultSource = function(_v0) {
        var record = _v0.b;
        return record.ND;
    };
    var $author$project$Api$Company$defaultSource = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$defaultSource(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$defaultSource(company_);
        }
    };
    var $author$project$Components$Invoice$companyDefaultSource = function(company) {
        return A2($elm$core$Maybe$andThen, function(company_) {
            if (!company_.$) return $elm$core$Maybe$Nothing;
            else {
                var company__ = company_.a;
                return $author$project$Api$Company$defaultSource(company__);
            }
        }, company);
    };
    var $author$project$Api$Provider$Company$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$Invoice$companyName = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Api$Provider$Company$Min$name(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Api$Company$name(company__);
            }
        }, company);
    };
    var $author$project$Api$Employer$Company$One$phones = function(_v0) {
        var record = _v0.b;
        return record.WG;
    };
    var $author$project$Api$Provider$Company$One$phones = function(_v0) {
        var record = _v0.b;
        return record.WG;
    };
    var $author$project$Api$Company$phones = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$phones(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$phones(company_);
        }
    };
    var $author$project$Components$Invoice$companyPhones = function(company) {
        return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) return _List_Nil;
            else {
                var company__ = company_.a;
                return $author$project$Api$Company$phones(company__);
            }
        }, company));
    };
    var $author$project$Api$Employer$Invoice$Meta$createPaymentAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Mu;
    };
    var $author$project$Api$Provider$Invoice$Meta$createPaymentAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Mu;
    };
    var $author$project$Api$Invoice$Meta$createPaymentAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$createPaymentAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$Invoice$Meta$createPaymentAction(meta_);
        }
    };
    var $author$project$Api$Employer$Invoice$Shared$humanStatus = function(_v0) {
        var record = _v0;
        return record.QX;
    };
    var $author$project$Api$Employer$Invoice$One$humanStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$humanStatus(shared);
    };
    var $author$project$Api$Provider$Invoice$One$humanStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$humanStatus(shared);
    };
    var $author$project$Api$Invoice$One$humanStatus = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$humanStatus(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$humanStatus(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$Shared$invoiceNumber = function(_v0) {
        var record = _v0;
        return record.RK;
    };
    var $author$project$Api$Employer$Invoice$One$invoiceNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$invoiceNumber(shared);
    };
    var $author$project$Api$Provider$Invoice$One$number = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$invoiceNumber(shared);
    };
    var $author$project$Api$Invoice$One$invoiceNumber = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$number(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$invoiceNumber(invoice_);
        }
    };
    var $author$project$Components$Invoice$isAPractice = function(session) {
        return !$author$project$Api$Platform$Session$One$organizationIsCompany(session);
    };
    var $author$project$Components$Invoice$isNetwork = function(company) {
        if (!company.$) {
            if (!company.a.$) {
                var company_ = company.a.a;
                return !$author$project$Api$Provider$Company$Min$companyType(company_);
            } else {
                var company_ = company.a.a;
                return !$author$project$Api$Company$companyType(company_);
            }
        } else return false;
    };
    var $author$project$Api$Employer$Invoice$One$isPayable = function(_v0) {
        var record = _v0.b;
        return record.Sh;
    };
    var $author$project$Api$Provider$Invoice$One$isPayable = function(_v0) {
        var record = _v0.b;
        return record.Sh;
    };
    var $author$project$Api$Invoice$One$isPayable = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$isPayable(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$isPayable(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$Meta$issueAction = function(_v0) {
        var meta = _v0;
        return meta.tM.SB;
    };
    var $author$project$Api$Provider$Invoice$Meta$issueAction = function(_v0) {
        var meta = _v0;
        return meta.tM.SB;
    };
    var $author$project$Api$Invoice$Meta$issueAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$issueAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$Invoice$Meta$issueAction(meta_);
        }
    };
    var $author$project$Api$Employer$Invoice$Meta$markAsPaidAction = function(_v0) {
        var meta = _v0;
        return meta.tM.TE;
    };
    var $author$project$Api$Provider$Invoice$Meta$markAsPaidAction = function(_v0) {
        var meta = _v0;
        return meta.tM.TE;
    };
    var $author$project$Api$Invoice$Meta$markAsPaidAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$markAsPaidAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$Invoice$Meta$markAsPaidAction(meta_);
        }
    };
    var $author$project$Components$Invoice$maxInvoiceLinesForDetailsDownload = 750;
    var $author$project$Api$Invoice$Meta$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Invoice$Meta$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Invoice$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Provider$Invoice$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Invoice$One$meta = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Invoice$Meta$Provider($author$project$Api$Provider$Invoice$One$meta(invoice_));
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Invoice$Meta$Employer($author$project$Api$Employer$Invoice$One$meta(invoice_));
        }
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save = {
        $: 6
    };
    var $author$project$Ui$Modal$Faq = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Modal$faq = function(contents) {
        return $author$project$Ui$Modal$Faq(contents);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ToggleCreditFaqFaq = {
        $: 2
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ToggleIncidentalChargesFaq = {
        $: 1
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaq = F4(function(visible, toogle, title, contents) {
        return _List_fromArray([
            A3($author$project$Ui$Element$custom, 'modal-faq__title', _List_fromArray([
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$textMuted
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Toggle faq visibility'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick(toogle),
                    $author$project$Ui$Button$icon(visible ? $author$project$Ui$Icon$minus : $author$project$Ui$Icon$add)
                ]), _List_Nil),
                A2($author$project$Ui$Typography$titleSm, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('How do I add '),
                    $elm$html$Html$text(title),
                    $elm$html$Html$text('?')
                ]))
            ])),
            visible ? A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt2
            ]), contents) : $elm$html$Html$text('')
        ]);
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaqs = function(model) {
        return _Utils_ap(A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaq, model.qX, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ToggleIncidentalChargesFaq, 'incidental charges', _List_fromArray([
            $elm$html$Html$text('Search for the charge item from your preconfigured list or manually enter the details of the charge. '),
            $elm$html$Html$text('To add more than one, change the quantity field to auto-calculate the amount for a group of charges like flu shots or COVID tests.')
        ])), A4($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaq, model.p2, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ToggleCreditFaqFaq, 'credit', _List_fromArray([
            $elm$html$Html$text('Search for the negative charge item from your preconfigured list or manually enter the details of the credit with a '),
            $elm$html$Html$text('negative (-) minus sign in front of the price (e.g. $-20).')
        ])));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateValidation = 3;
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Quantity = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityUom = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityValidation = 1;
    var $author$project$Api$Charge$PayerType$Sponsor = 1;
    var $author$project$Components$DateInput$Disabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$DateInput$disabled = $author$project$Components$DateInput$Disabled;
    var $author$project$Ui$Typography$Display4 = {
        $: 26
    };
    var $author$project$Ui$Typography$display4 = $author$project$Ui$Typography$Display4;
    var $author$project$Api$Provider$InvoiceLine$One$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Charge$Calculate$subtotalInCents = function(_v0) {
        var record = _v0;
        return record.$v;
    };
    var $author$project$Api$Employer$Practice$One$trackPatientsByLocation = function(_v0) {
        var record = _v0;
        return record.aaq;
    };
    var $author$project$Api$Practice$trackPatientsByLocation = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$trackPatientsByLocation(practice_);
        }
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$uomOptions = A2($elm$core$List$map, function(uom_) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Uom$Shared$code(uom_)), $author$project$Api$Provider$Uom$Shared$name(uom_));
    }, $author$project$Api$Provider$Uom$list(function(d) {
        return _Utils_update(d, {
            HX: $elm$core$Maybe$Just('time')
        });
    }));
    var $author$project$Components$InventoryWarning$LowStock = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$InventoryWarning$NotTracking = {
        $: 3
    };
    var $author$project$Components$InventoryWarning$OutOfStock = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$InventoryWarning$Tracking = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$InventoryWarning$calculateStatus = F2(function(chargeItem, quantity) {
        var _v0 = _Utils_Tuple2(chargeItem, quantity);
        if (!_v0.a.$ && !_v0.b.$) {
            var chargeItem_ = _v0.a.a;
            var quantity_ = _v0.b.a;
            var _v1 = function() {
                var _v2 = chargeItem_.I0;
                if (!_v2.$) {
                    var alertQuantity_ = _v2.a;
                    return _Utils_Tuple2(true, alertQuantity_);
                } else return _Utils_Tuple2(false, 0);
            }();
            var hasAlertQuantity = _v1.a;
            var alertQuantity = _v1.b;
            if (!chargeItem_.aap) return $author$project$Components$InventoryWarning$NotTracking;
            else {
                var existing = A2($elm$core$Maybe$withDefault, 0, chargeItem_.XT);
                var remaining = existing - quantity_;
                return remaining < 0 ? $author$project$Components$InventoryWarning$OutOfStock(existing) : !remaining ? $author$project$Components$InventoryWarning$LowStock(remaining) : hasAlertQuantity && _Utils_cmp(remaining, alertQuantity) < 1 ? $author$project$Components$InventoryWarning$LowStock(remaining) : $author$project$Components$InventoryWarning$Tracking(remaining);
            }
        } else return $author$project$Components$InventoryWarning$NotTracking;
    });
    var $author$project$Components$InventoryWarning$viewLowStock = function(remaining) {
        return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Badge$view, _List_fromArray([
                $author$project$Ui$Badge$warning
            ]), _List_fromArray([
                $elm$html$Html$text('Low Inventory')
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $author$project$Utils$Html$noBreakSpace,
                !remaining ? $author$project$Utils$Html$empty : $elm$html$Html$text('Only '),
                $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'item', remaining)),
                $elm$html$Html$text(' will be left in stock')
            ])),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Manage stock levels')
            ]))
        ]));
    };
    var $author$project$Components$InventoryWarning$viewOutOfStock = function(existing) {
        return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Badge$view, _List_fromArray([
                $author$project$Ui$Badge$danger
            ]), _List_fromArray([
                $elm$html$Html$text('Out of Stock')
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $author$project$Utils$Html$noBreakSpace,
                $elm$html$Html$text('Not enough stock ('),
                $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'item', existing)),
                $elm$html$Html$text(' in stock)')
            ])),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__ChargeItems__Top, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Manage stock levels')
            ]))
        ]));
    };
    var $author$project$Components$InventoryWarning$viewTracking = function(remaining) {
        return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $author$project$Utils$Html$noBreakSpace,
                $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'item', remaining)),
                $elm$html$Html$text(' will be left in stock')
            ]))
        ]));
    };
    var $author$project$Components$InventoryWarning$view = F2(function(chargeItem, quantity) {
        var status = A2($author$project$Components$InventoryWarning$calculateStatus, chargeItem, quantity);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                switch(status.$){
                    case 2:
                        var existing = status.a;
                        return $author$project$Components$InventoryWarning$viewOutOfStock(existing);
                    case 1:
                        var remaining = status.a;
                        return $author$project$Components$InventoryWarning$viewLowStock(remaining);
                    case 0:
                        var remaining = status.a;
                        return $author$project$Components$InventoryWarning$viewTracking(remaining);
                    default:
                        return $author$project$Utils$Html$empty;
                }
            }()
        ]));
    });
    var $author$project$Api$Provider$Charge$Calculate$coveredCharges = function(_v0) {
        var record = _v0;
        return record.Mr;
    };
    var $author$project$Components$CoverageRuleDescription$Shared = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$CoveredCharge$All$coverageRule = function(_v0) {
        var shared = _v0;
        return shared.Mo;
    };
    var $author$project$Components$Invoice$ChargeDiscount$viewCoveredCharge = function(coveredCharge) {
        var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coveredCharge);
        return A2($author$project$Components$CoverageRuleDescription$view, $author$project$Components$CoverageRuleDescription$Shared(coverageRule), false);
    };
    var $author$project$Components$Invoice$ChargeDiscount$view = function(charge) {
        var discountInCents = $author$project$Api$Provider$Charge$Calculate$discountInCents(charge);
        if (!!discountInCents) {
            var issuedSubtotalInCents = $author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(charge);
            var coveredCharges = $author$project$Api$Provider$Charge$Calculate$coveredCharges(charge);
            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                !$elm$core$List$isEmpty(coveredCharges) ? A3($author$project$Ui$Popover$view, _List_fromArray([
                    $author$project$Ui$Popover$lg
                ]), _List_fromArray([
                    $author$project$Ui$Icon$help(_List_Nil)
                ]), _List_fromArray([
                    A2($author$project$Ui$Popover$body, _List_Nil, A2($elm$core$List$map, $author$project$Components$Invoice$ChargeDiscount$viewCoveredCharge, coveredCharges))
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$strike,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(issuedSubtotalInCents + discountInCents))
                ])),
                $author$project$Utils$Html$noBreakSpace
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$ResourceFilter$Style = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$style = $author$project$Components$ResourceFilter$Style;
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewCategoryFormGroup = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var categoryResourceFilter = _v0.cK;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Category'),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0)
            ]), categoryResourceFilter))
        ]));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewChargeFormGroup = F2(function(model, form) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Charge Name'),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), function() {
            var _v0 = model.RL;
            if (!_v0.$) {
                var _v1 = $author$project$Utils$Form$fields(form);
                var name = _v1.zr;
                return _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', name)),
                        $author$project$Ui$Form$Input$placeholder('e.g. Office Visit'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Name)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                    ]))
                ]);
            } else {
                var _v2 = $author$project$Utils$Form$fields(form);
                var chargeItemResourceFilter = _v2.cL;
                return _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$ChargeItemResourceFilterMsg, A2($author$project$Components$ResourceFilter$ChargeItem$view, _List_fromArray([
                        $author$project$Components$ResourceFilter$style(0),
                        $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                        $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                    ]), chargeItemResourceFilter))
                ]);
            }
        }());
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Description = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewDescriptionFormGroup = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var description = _v0.NQ;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Description'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                $author$project$Ui$Form$Textarea$value(description),
                $author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Description))
            ]))
        ]));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewLocationFormGroup = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var locationResourceFilter = _v0.ro;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Location'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0)
            ]), locationResourceFilter))
        ]));
    };
    var $author$project$Api$Provider$Membership$ForCompanyAccountOne$membershipPatients = function(_v0) {
        var record = _v0;
        return record.T$;
    };
    var $author$project$Api$Provider$CompanyAccount$One$memberships = function(_v0) {
        var record = _v0.b;
        return record.T7;
    };
    var $author$project$Components$ResourceFilter$CompanyRegistration$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Api$Provider$MembershipPatient$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$MembershipPatient$Min$periodRateInCents = function(_v0) {
        var record = _v0;
        return record.WB;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewMembershipPatient = function(membershipPatient) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$phi(true)
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$MembershipPatient$Min$name(membershipPatient)),
            $elm$html$Html$text(' - '),
            $elm$html$Html$text($author$project$Utils$Currency$fromInt(A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$MembershipPatient$Min$periodRateInCents(membershipPatient))))
        ]));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewPatientFormGroup = F2(function(model, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var patient = _v0.V7;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Patient'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$CompanyRegistrationResourceFilterMsg, A2($author$project$Components$ResourceFilter$CompanyRegistration$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0)
            ]), model.hR)),
            function() {
                if (!patient.$) {
                    var patient_ = patient.a;
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Most Recent Membership Prices')
                        ])),
                        function() {
                            var _v2 = model.LI;
                            if (_v2.$ === 3) {
                                var companyAccount = _v2.a;
                                var membershipPatients = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$ForCompanyAccountOne$membershipPatients, $elm_community$list_extra$List$Extra$last($author$project$Api$Provider$CompanyAccount$One$memberships(companyAccount))));
                                return $elm$core$List$isEmpty(membershipPatients) ? $elm$html$Html$text('No recent memberships found for ' + patient_.zr) : A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewMembershipPatient, membershipPatients));
                            } else return $author$project$Ui$Spinner$view(_List_fromArray([
                                $author$project$Ui$Spinner$small
                            ]));
                        }()
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewProviderFormGroup = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var practitionerResourceFilter = _v0.jE;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Provider'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0)
            ]), practitionerResourceFilter))
        ]));
    };
    var $author$project$Components$ChargeRoutingWarning$Calculate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Charge$PayerType$Patient = 0;
    var $author$project$Api$Provider$Charge$Calculate$adjudicatedPayer = function(_v0) {
        var record = _v0;
        return record.IP;
    };
    var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$payerType = function(_v0) {
        var record = _v0;
        return record.Wh;
    };
    var $author$project$Api$Charge$PayerType$adjudicatedType = function(preview) {
        return A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$AdjudicatedPayer$One$payerType, $author$project$Api$Provider$Charge$Calculate$adjudicatedPayer(preview));
    };
    var $author$project$Api$Charge$PayerType$toPayerType = function(maybeString) {
        if (!maybeString.$ && maybeString.a === 'company') return 1;
        else return 0;
    };
    var $author$project$Api$Charge$PayerType$adjudicatedToSelectedPayer = F2(function(preview, selectedPayer) {
        return _Utils_eq($author$project$Api$Charge$PayerType$toPayerType($author$project$Api$Charge$PayerType$adjudicatedType(preview)), selectedPayer);
    });
    var $author$project$Api$Provider$Charge$One$rulePayer = function(_v0) {
        var record = _v0.b;
        return record.Zj;
    };
    var $author$project$Api$Charge$PayerType$toString = function(payerType) {
        if (!payerType) return 'Patient';
        else return 'Sponsor';
    };
    var $author$project$Api$Charge$RulePayer$toString = function(gender) {
        if (!gender) return 'sponsor';
        else return 'patient';
    };
    var $author$project$Components$ChargeRoutingWarning$view = F2(function(selectedPayer, charge) {
        var coveredCharges = function() {
            if (!charge.$) {
                var charge_ = charge.a;
                return $author$project$Api$Provider$Charge$Calculate$coveredCharges(charge_);
            } else return _List_Nil;
        }();
        var showWarning = function() {
            var _v1 = _Utils_Tuple2(coveredCharges, charge);
            if (!_v1.b.$) {
                var coveredCharges_ = _v1.a;
                var charge_ = _v1.b.a;
                return !A2($author$project$Api$Charge$PayerType$adjudicatedToSelectedPayer, charge_, selectedPayer) && $elm$core$List$length(coveredCharges_) > 0;
            } else {
                if (!_v1.a.b) {
                    var charge_ = _v1.b.a;
                    var _v2 = $author$project$Api$Provider$Charge$One$rulePayer(charge_);
                    if (!_v2.$) {
                        var rulePayer = _v2.a;
                        return !_Utils_eq($author$project$Api$Charge$RulePayer$toString(rulePayer), $elm$core$String$toLower($author$project$Api$Charge$PayerType$toString(selectedPayer)));
                    } else return false;
                } else return false;
            }
        }();
        if (showWarning) {
            var inverse = function() {
                if (!selectedPayer) return 1;
                else return 0;
            }();
            return $elm$core$Maybe$Just(A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text('This charge is being added to the '),
                $elm$html$Html$text($elm$core$String$toLower($author$project$Api$Charge$PayerType$toString(selectedPayer))),
                $elm$html$Html$text('\'s invoice, but the membership rule specifies it should be paid for by the '),
                $elm$html$Html$text($elm$core$String$toLower($author$project$Api$Charge$PayerType$toString(inverse))),
                $elm$html$Html$text('.')
            ])));
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate = F2(function(selectedPayer, charge) {
        return A2($author$project$Components$ChargeRoutingWarning$view, selectedPayer, $author$project$Components$ChargeRoutingWarning$Calculate(charge));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFormGroups = F2(function(model, form) {
        var fields = $author$project$Utils$Form$fields(form);
        var isTimeBased = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq('time'), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function($) {
            return $.aaK;
        }, $author$project$Api$Provider$Uom$Shared$unitClass), fields.lv)));
        var editingNotInDraft = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$neq('draft'), A2($elm$core$Maybe$map, $author$project$Api$Provider$InvoiceLine$One$status, $author$project$Api$Data$toMaybe(model.q3))));
        var discountNotRemoved = function() {
            var _v9 = $author$project$Api$Data$toMaybe(model.agk);
            if (!_v9.$) {
                var preview = _v9.a;
                return !fields.N0 && !!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview);
            } else return false;
        }();
        return _List_fromArray([
            A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewChargeFormGroup, model, form),
            function() {
                var _v0 = model.RL;
                if (_v0.$ === 1) return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewCategoryFormGroup(form);
                else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v1 = model.RL;
                if (_v1.$ === 1) return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewDescriptionFormGroup(form);
                else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewPatientFormGroup, model, form),
            function() {
                var _v2 = model.RL;
                if (_v2.$ === 1) return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewProviderFormGroup(form);
                else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = _Utils_Tuple2(model.RL, $author$project$Api$Practice$trackPatientsByLocation(model.W1));
                if (_v3.a.$ === 1 && _v3.b) {
                    var _v4 = _v3.a;
                    return $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewLocationFormGroup(form);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.RL;
                if (_v5.$ === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(isTimeBased ? 'Dates' : 'Date'),
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$StartDateInputMsg(fields.kj), A2($author$project$Components$DateInput$view, _List_fromArray([
                                $author$project$Components$DateInput$value(fields._0),
                                $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                                $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 2, form)),
                                $author$project$Components$DateInput$disabled(editingNotInDraft)
                            ]), fields.kj))
                        ])),
                        isTimeBased ? A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$EndDateInputMsg(fields.qx), A2($author$project$Components$DateInput$view, _List_fromArray([
                                $author$project$Components$DateInput$value(fields.qv),
                                $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                                $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 3, form)),
                                $author$project$Components$DateInput$disabled(editingNotInDraft)
                            ]), fields.qx))
                        ])) : $author$project$Ui$Grid$none
                    ]))
                ]));
                else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v6 = model.RL;
                if (_v6.$ === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('QTY'),
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$number,
                                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Bu))),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Quantity)),
                                $author$project$Ui$Form$Input$disabled(editingNotInDraft),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form)),
                                $author$project$Ui$Form$Input$test('company-charge-quantity')
                            ]))
                        ])),
                        isTimeBased ? A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Bv)),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$QuantityUom)),
                                $author$project$Ui$Form$Select$disabled(editingNotInDraft)
                            ]), $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$uomOptions)
                        ])) : $author$project$Ui$Grid$none
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(12)
                        ]), _List_fromArray([
                            A2($author$project$Components$InventoryWarning$view, A2($elm$core$Maybe$map, function(chargeItem) {
                                return {
                                    I0: chargeItem.I0,
                                    XT: chargeItem.XT,
                                    aap: chargeItem.aap
                                };
                            }, fields.lv), fields.Bu)
                        ]))
                    ]))
                ]));
                else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Price'),
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$view(A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$value(fields.Br), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$PriceInCents)), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, form)), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$disabled(editingNotInDraft || discountNotRemoved), function() {
                            var _v7 = _Utils_Tuple2(isTimeBased, A2($elm$core$Maybe$map, $elm$core$String$toLower, A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, fields.Xn)));
                            if (_v7.a && !_v7.b.$) {
                                var name = _v7.b.a;
                                return _List_fromArray([
                                    $author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
                                ]);
                            } else return _List_Nil;
                        }())))))),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 4, form)),
                        !editingNotInDraft && discountNotRemoved ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Remove membership rule'
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden(true)))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Remove membership rule')
                            ]))
                        ])) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Amounts can be negative')
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Total'),
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var _v8 = model.agk;
                        switch(_v8.$){
                            case 3:
                                var preview = _v8.a;
                                if (!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview) && !fields.N0) return $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview)));
                                else {
                                    var discountRemoved = fields.N0 && !$author$project$Api$Provider$Charge$Calculate$discountInCents(preview);
                                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$div, _List_fromArray([
                                            $author$project$Ui$Typography$display4
                                        ]), _List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview)))
                                        ])),
                                        !!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview) ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Total without membership: '),
                                            $author$project$Components$Invoice$ChargeDiscount$view(preview)
                                        ])) : $author$project$Utils$Html$empty,
                                        discountRemoved ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Membership rule was removed')
                                        ])) : $author$project$Utils$Html$empty,
                                        $author$project$Utils$Html$noBreakSpace,
                                        !editingNotInDraft && discountRemoved && $author$project$Utils$Maybe$toBool(fields.lv) ? A3($author$project$Ui$Button$view, {
                                            abP: 'Revert to original'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$link,
                                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                            $author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$FormUpdated($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$DiscountOverridden(false)))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Revert to original')
                                        ])) : $author$project$Utils$Html$empty,
                                        A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, 1, preview))
                                    ]));
                                }
                            case 1:
                                return $author$project$Ui$Spinner$view(_List_fromArray([
                                    $author$project$Ui$Spinner$small
                                ]));
                            default:
                                return $elm$html$Html$text('N/A');
                        }
                    }()
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    function() {
                        var _v1 = model.q4;
                        if (!_v1.$) return $elm$html$Html$text('Update');
                        else return $elm$html$Html$text('Add');
                    }(),
                    $elm$html$Html$text(' Charge')
                ]))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    var _v2 = model.PU;
                    if (!_v2.$) {
                        var form = _v2.a;
                        return A2($author$project$Ui$Form$view, _List_fromArray([
                            $author$project$Ui$Form$onSubmit($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save),
                            $author$project$Ui$Form$horizontal
                        ]), A2($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFormGroups, model, form));
                    } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]));
                }()
            ])),
            $author$project$Ui$Modal$faq($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$viewFaqs(model)),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel and close'
                        }, _List_fromArray([
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Close)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        function() {
                            var verb = function() {
                                var _v3 = model.q4;
                                if (!_v3.$) return 'Update';
                                else return 'Add';
                            }();
                            return A3($author$project$Ui$Button$view, {
                                abP: verb
                            }, _List_fromArray([
                                $author$project$Ui$Button$fullWidth(true),
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$Save),
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                            ]), _List_fromArray([
                                $elm$html$Html$text(verb + ' Charge')
                            ]));
                        }()
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$modal = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.fv;
                if (!_v0.$) {
                    var _v1 = _v0.a;
                    var invoiceLine = _v1.a;
                    var deleteRequest = _v1.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Invoice$InvoiceLinesTable$HiConfirmClosed(invoiceLine), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('invoice line'),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v2 = model.ht;
                if (!_v2.$) {
                    var adjustmentModal = _v2.a;
                    return A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModalMsg, $author$project$Components$Invoice$InvoiceLinesTable$AdjustmentModal$view(adjustmentModal));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Api$Common$Invoice$Delta$added = function(_v0) {
        var record = _v0;
        return record.IA;
    };
    var $author$project$Api$Provider$InvoicePatient$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Api$Common$Invoice$Delta$removed = function(_v0) {
        var record = _v0;
        return record.Yz;
    };
    var $author$project$Api$Provider$InvoicePatient$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$InvoicePatient$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$InvoicePatient$Shared$owner = function(_v0) {
        var record = _v0;
        return record.VM;
    };
    var $author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient = F3(function(timeFormatter, timeGetter, invoicePatient) {
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, timeFormatter(5), timeGetter(invoicePatient))))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$InvoicePatient$Shared$name(invoicePatient))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    function() {
                        var _v0 = $author$project$Api$Provider$InvoicePatient$Shared$owner(invoicePatient);
                        if (!_v0.$) {
                            var owner = _v0.a;
                            return A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$fontWeight(1),
                                $author$project$Ui$Typography$gray
                            ]), _List_fromArray([
                                $elm$html$Html$text('Dependent of '),
                                $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(owner))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$Summary$PatientDeltaModal$view = F3(function(timeFormatter, close, delta) {
        var patientsRemoved = $author$project$Api$Common$Invoice$Delta$removed(delta);
        var patientsAdded = $author$project$Api$Common$Invoice$Delta$added(delta);
        return A3($author$project$Ui$Modal$view, close, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Patient List Changes')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($elm$core$String$fromInt($elm$core$List$length(patientsAdded))),
                            $elm$html$Html$text(' Patients'),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$fontWeight(1)
                            ]), _List_fromArray([
                                $elm$html$Html$text(' - added')
                            ]))
                        ])),
                        $elm$core$List$length(patientsAdded) > 0 ? A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, A2($author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient, timeFormatter, A2($elm$core$Basics$composeR, $author$project$Api$Provider$InvoicePatient$Shared$startDate, $elm$core$Maybe$Just)), patientsAdded)) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($elm$core$String$fromInt($elm$core$List$length(patientsRemoved))),
                            $elm$html$Html$text(' Patients'),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$fontWeight(1)
                            ]), _List_fromArray([
                                $elm$html$Html$text(' - removed')
                            ]))
                        ])),
                        $elm$core$List$length(patientsRemoved) > 0 ? A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, A2($author$project$Components$Invoice$Summary$PatientDeltaModal$viewInvoicePatient, timeFormatter, $author$project$Api$Provider$InvoicePatient$Shared$endDate), patientsRemoved)) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick(close),
                    $author$project$Ui$Button$primary
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$Summary$modal = function(_v0) {
        var model = _v0;
        var _v1 = model.nm;
        if (!_v1.$) {
            var patientDelta = _v1.a;
            return A3($author$project$Components$Invoice$Summary$PatientDeltaModal$view, model.HO, $author$project$Components$Invoice$Summary$CloseDeltaModal, patientDelta);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Employer$Invoice$Shared$paidAt = function(_v0) {
        var record = _v0;
        return record.VQ;
    };
    var $author$project$Api$Employer$Invoice$One$paidAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$paidAt(shared);
    };
    var $author$project$Api$Provider$Invoice$Shared$paidAt = function(_v0) {
        var record = _v0.b;
        return record.VQ;
    };
    var $author$project$Api$Provider$Invoice$One$paidAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$paidAt(shared);
    };
    var $author$project$Api$Invoice$One$paidAt = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$paidAt(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$paidAt(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$Shared$paidInCents = function(_v0) {
        var record = _v0;
        return record.VR;
    };
    var $author$project$Api$Employer$Invoice$One$paidInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Invoice$Shared$paidInCents(shared);
    };
    var $author$project$Api$Provider$Invoice$Shared$paidInCents = function(_v0) {
        var record = _v0.b;
        return record.VR;
    };
    var $author$project$Api$Provider$Invoice$One$paidInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Invoice$Shared$paidInCents(shared);
    };
    var $author$project$Api$Invoice$One$paidInCents = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$paidInCents(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$paidInCents(invoice_);
        }
    };
    var $author$project$Api$Payment$Provider_SharedWithRefunds = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Invoice$One$payments = function(_v0) {
        var record = _v0.b;
        return record.Wt;
    };
    var $author$project$Api$Provider$Invoice$One$payments = function(_v0) {
        var record = _v0.b;
        return record.Wt;
    };
    var $author$project$Api$Invoice$One$payments = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return A2($elm$core$List$map, $author$project$Api$Payment$Provider_SharedWithRefunds, $author$project$Api$Provider$Invoice$One$payments(invoice_));
        } else {
            var invoice_ = invoice.a;
            return A2($elm$core$List$map, $author$project$Api$Payment$Employer_One, $author$project$Api$Employer$Invoice$One$payments(invoice_));
        }
    };
    var $author$project$Api$Employer$Practice$One$phones = function(_v0) {
        var record = _v0;
        return record.WG;
    };
    var $author$project$Api$Practice$phones = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$phones(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$phones(practice_);
        }
    };
    var $author$project$Api$Employer$Invoice$One$securePdfInlineToken = function(_v0) {
        var record = _v0.b;
        return record.ZC;
    };
    var $author$project$Api$Provider$Invoice$One$securePdfInlineToken = function(_v0) {
        var record = _v0.b;
        return record.ZC;
    };
    var $author$project$Api$Invoice$One$securePdfInlineToken = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$securePdfInlineToken(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$securePdfInlineToken(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$One$securePdfWithChargeDetailsToken = function(_v0) {
        var record = _v0.b;
        return record.ZD;
    };
    var $author$project$Api$Provider$Invoice$One$securePdfWithChargeDetailsToken = function(_v0) {
        var record = _v0.b;
        return record.ZD;
    };
    var $author$project$Api$Invoice$One$securePdfInlineWithChargeDetailsToken = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$securePdfWithChargeDetailsToken(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$securePdfWithChargeDetailsToken(invoice_);
        }
    };
    var $author$project$Ui$Icon$Stop = 59;
    var $author$project$Ui$Icon$stop = $author$project$Ui$Icon$viewIcon(59);
    var $author$project$Components$AuditTrailLog$Toggle = {
        $: 0
    };
    var $author$project$Ui$Button$Badge = 10;
    var $author$project$Ui$Button$badge = $author$project$Ui$Button$Styled(10);
    var $author$project$Api$Audit$record_ = function(_v0) {
        var record = _v0;
        return record;
    };
    var $author$project$Api$Audit$createdAt = A2($elm$core$Basics$composeR, $author$project$Api$Audit$record_, function($) {
        return $.Mx;
    });
    var $author$project$Api$Audit$extraUrl = function(audit) {
        var record = audit;
        var _v1 = record.vq;
        if (!_v1.$) {
            var aggregate = _v1.a;
            return aggregate.adH;
        } else return $elm$core$Maybe$Nothing;
    };
    var $elm$core$String$endsWith = _String_endsWith;
    var $author$project$Components$AuditTrailLog$formatWhodunnit = function(email) {
        return A2($elm$core$String$endsWith, '@hint.com', $elm$core$String$toLower(email)) ? 'System Admin' : email;
    };
    var $author$project$Components$AuditTrailLog$isLast = F2(function(audits, audit) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq(audit), $elm$core$List$head($elm$core$List$reverse(audits))));
    });
    var $author$project$Api$Audit$name = A2($elm$core$Basics$composeR, $author$project$Api$Audit$record_, function($) {
        return $.zr;
    });
    var $author$project$Api$Audit$isOnlineSignup = function(trail) {
        return A2($elm$core$String$contains, 'OnlineEnrollment', $author$project$Api$Audit$name(trail));
    };
    var $author$project$Api$Audit$aggregateType = A2($elm$core$Basics$composeR, $author$project$Api$Audit$record_, A2($elm$core$Basics$composeR, function($) {
        return $.vq;
    }, $elm$core$Maybe$map(function($) {
        return $.ah5;
    })));
    var $author$project$Api$Audit$crumbs = A2($elm$core$Basics$composeR, $author$project$Api$Audit$record_, function($) {
        return $.MG;
    });
    var $author$project$Api$Audit$Crumb$label = function(crumb) {
        return crumb.F6.aeI;
    };
    var $author$project$Api$Audit$Crumb$recordType = function(crumb) {
        return crumb.F6.ah5;
    };
    var $author$project$Api$Audit$Crumb$diff = function($) {
        return $.NZ;
    };
    var $author$project$Components$Auditing$Crumb$Helpers$isChangePresent = function(_v0) {
        var from = _v0.a;
        var to = _v0.b;
        var _v1 = _Utils_Tuple2(from, to);
        if (!_v1.a.$) return true;
        else {
            if (!_v1.b.$) return true;
            else return false;
        }
    };
    var $author$project$Components$Auditing$Crumb$Helpers$getFieldName = function(_v0) {
        var field = _v0.a;
        var diff = _v0.b;
        return $author$project$Components$Auditing$Crumb$Helpers$isChangePresent(diff) ? $author$project$Formatters$String$humanize(field) : '';
    };
    var $elm$html$Html$s = _VirtualDom_node('s');
    var $author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue = function(diffValue) {
        if (!diffValue.$) {
            var text = diffValue.a;
            return $elm$html$Html$text(text);
        } else {
            var linkable = diffValue.a;
            return $elm$html$Html$text(linkable.aeI);
        }
    };
    var $author$project$Components$Auditing$Crumb$Helpers$processDiff = function(_v0) {
        var from = _v0.a;
        var to = _v0.b;
        var _v1 = _Utils_Tuple2(from, to);
        if (!_v1.a.$) {
            if (_v1.b.$ === 1) {
                var fromValue = _v1.a.a;
                var _v2 = _v1.b;
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' removed '),
                    A2($elm$html$Html$s, _List_Nil, _List_fromArray([
                        $author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(fromValue)
                    ]))
                ]));
            } else {
                var fromValue = _v1.a.a;
                var toValue = _v1.b.a;
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(' changed from '),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$s, _List_Nil, _List_fromArray([
                            $author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(fromValue)
                        ])),
                        $elm$html$Html$text(' to '),
                        $author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(toValue)
                    ]))
                ]));
            }
        } else if (!_v1.b.$) {
            var _v3 = _v1.a;
            var toValue = _v1.b.a;
            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(' added '),
                $author$project$Components$Auditing$Crumb$Helpers$viewCrumbDiffValue(toValue)
            ]));
        } else {
            var _v4 = _v1.a;
            var _v5 = _v1.b;
            return $elm$html$Html$text('');
        }
    };
    var $author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix = F2(function(prefix, _v0) {
        var field = _v0.a;
        var diff = _v0.b;
        var prefixText = $elm$core$String$isEmpty(prefix) ? $elm$html$Html$text('') : $elm$html$Html$text(prefix + '\'s ');
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            prefixText,
            $elm$core$String$isEmpty(prefix) ? $elm$html$Html$text($author$project$Components$Auditing$Crumb$Helpers$getFieldName(_Utils_Tuple2(field, diff))) : $elm$html$Html$text($elm$core$String$toLower($author$project$Components$Auditing$Crumb$Helpers$getFieldName(_Utils_Tuple2(field, diff)))),
            $author$project$Components$Auditing$Crumb$Helpers$processDiff(diff)
        ]));
    });
    var $author$project$Components$Auditing$Crumb$Helpers$viewChange = $author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix('');
    var $author$project$Components$Auditing$Crumb$Helpers$viewChanges = function(crumb) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('clearfix')
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$Helpers$viewChange, $author$project$Api$Audit$Crumb$diff(crumb)))
        ]));
    };
    var $author$project$Components$Auditing$Crumb$Address$view = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Address added')
                ]));
            case 1:
                return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
            default:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Address deleted')
                ]));
        }
    };
    var $author$project$Components$Auditing$Crumb$Charge$view = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Charge added')
                ]));
            case 1:
                return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
            default:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Charge deleted')
                ]));
        }
    };
    var $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate = function(name) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(name + ' was enrolled')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated = function(name) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(name + ' was terminated')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$Helpers$getDiffValue = F2(function(searchKey, crumb) {
        return A2($elm$core$Maybe$withDefault, _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm_community$list_extra$List$Extra$find, function(_v0) {
            var key = _v0.a;
            return _Utils_eq(key, searchKey);
        }, $author$project$Api$Audit$Crumb$diff(crumb))));
    });
    var $author$project$Components$Auditing$Crumb$Helpers$getDiffValues = F2(function(searchKey, crumb) {
        var _v0 = A2($elm_community$list_extra$List$Extra$find, function(_v1) {
            var key = _v1.a;
            return _Utils_eq(key, searchKey);
        }, $author$project$Api$Audit$Crumb$diff(crumb));
        if (!_v0.$) {
            var _v2 = _v0.a;
            var _v3 = _v2.b;
            var from = _v3.a;
            var to = _v3.b;
            var _v4 = _Utils_Tuple2(from, to);
            _v4$3: while(true)if (!_v4.a.$) {
                if (!_v4.a.a.$) {
                    if (!_v4.b.$) {
                        if (!_v4.b.a.$) {
                            var fromValue = _v4.a.a.a;
                            var toValue = _v4.b.a.a;
                            return _Utils_Tuple2(fromValue, toValue);
                        } else break _v4$3;
                    } else {
                        var fromValue = _v4.a.a.a;
                        var _v5 = _v4.b;
                        return _Utils_Tuple2(fromValue, '');
                    }
                } else break _v4$3;
            } else {
                if (!_v4.b.$ && !_v4.b.a.$) {
                    var _v6 = _v4.a;
                    var toValue = _v4.b.a.a;
                    return _Utils_Tuple2('', toValue);
                } else break _v4$3;
            }
            return _Utils_Tuple2('', '');
        } else return _Utils_Tuple2('', '');
    });
    var $author$project$Components$Auditing$Crumb$MembershipPatient$viewRestarted = function(name) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(name + ' was re-enrolled')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$MembershipPatient$viewUpdate = function(crumb) {
        var name = $author$project$Api$Audit$Crumb$label(crumb);
        var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'status', crumb);
        var oldStatus = _v0.a;
        var newStatus = _v0.b;
        var _v1 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'start_date', crumb);
        var oldStartDate = _v1.a;
        var newStartDate = _v1.b;
        var isEnrolled = oldStartDate === '' && newStartDate !== '';
        var _v2 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'end_date', crumb);
        var oldEndDate = _v2.a;
        var newEndDate = _v2.b;
        if (isEnrolled) return $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate(name);
        else {
            if (oldStatus === 'ended') return $author$project$Components$Auditing$Crumb$MembershipPatient$viewRestarted(name);
            else {
                var isTerminated = oldEndDate === '' && newEndDate !== '';
                if (newStatus === 'ended' || isTerminated) return $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated(name);
                else {
                    var startDateDiff = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValue, 'start_date', crumb);
                    var startDateValue = A2($author$project$Components$Auditing$Crumb$Helpers$viewChangeWithPrefix, name, _Utils_Tuple2('start_date', startDateDiff));
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        startDateValue
                    ]));
                }
            }
        }
    };
    var $author$project$Components$Auditing$Crumb$MembershipPatient$view = function(crumb) {
        var name = $author$project$Api$Audit$Crumb$label(crumb);
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return $author$project$Components$Auditing$Crumb$MembershipPatient$viewCreate(name);
            case 1:
                return $author$project$Components$Auditing$Crumb$MembershipPatient$viewUpdate(crumb);
            default:
                return $author$project$Components$Auditing$Crumb$MembershipPatient$viewTerminated(name);
        }
    };
    var $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeEligible = function(name) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(name + ' was made eligible')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeIneligible = function(name) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(name + ' was removed from the company account')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$CompanyAccount$viewUpdate = function(crumb) {
        var name = $author$project$Api$Audit$Crumb$label(crumb);
        var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'termination_requested_at', crumb);
        var oldTerminationDate = _v0.a;
        var newTerminationDate = _v0.b;
        return oldTerminationDate !== '' && newTerminationDate === '' ? $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeEligible(name) : oldTerminationDate === '' && newTerminationDate !== '' ? $author$project$Components$Auditing$Crumb$CompanyAccount$viewMadeIneligible(name) : A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$CompanyAccount$view = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Membership created')
                ]));
            case 1:
                var _v1 = $author$project$Api$Audit$Crumb$recordType(crumb);
                if (_v1 === 'membership_patient') return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
                else return $author$project$Components$Auditing$Crumb$CompanyAccount$viewUpdate(crumb);
            default:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Membership deleted')
                ]));
        }
    };
    var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeEligible = function(name) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(name + ' was made eligible')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeIneligible = function(name) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(name + ' was removed from the company account')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$CompanyRegistration$viewUpdate = function(crumb) {
        var name = $author$project$Api$Audit$Crumb$label(crumb);
        var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'termination_requested_at', crumb);
        var oldTerminationDate = _v0.a;
        var newTerminationDate = _v0.b;
        return oldTerminationDate !== '' && newTerminationDate === '' ? $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeEligible(name) : oldTerminationDate === '' && newTerminationDate !== '' ? $author$project$Components$Auditing$Crumb$CompanyRegistration$viewMadeIneligible(name) : A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('')
        ]));
    };
    var $author$project$Components$Auditing$Crumb$CompanyRegistration$view = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Audit$Crumb$label(crumb) + ' was enrolled')
                ]));
            case 1:
                return $author$project$Components$Auditing$Crumb$CompanyRegistration$viewUpdate(crumb);
            default:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Audit$Crumb$label(crumb) + ' was unenrolled')
                ]));
        }
    };
    var $author$project$Components$Auditing$Crumb$CustomerInvoice$view = function(crumb) {
        var invoiceNumber = $author$project$Api$Audit$Crumb$label(crumb);
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Invoice ' + (invoiceNumber + ' was issued'))
                ]));
            case 1:
                return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
            default:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Invoice ' + (invoiceNumber + ' was deleted'))
                ]));
        }
    };
    var $author$project$Components$Auditing$Crumb$Membership$viewCreate = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Membership created')
    ]));
    var $author$project$Components$Auditing$Crumb$Membership$viewDelete = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Membership terminated')
    ]));
    var $author$project$Components$Auditing$Crumb$Membership$viewUpdate = function(crumb) {
        var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'end_date', crumb);
        var oldEndDate = _v0.a;
        var newEndDate = _v0.b;
        return oldEndDate !== '' && newEndDate === '' ? $author$project$Components$Auditing$Crumb$Membership$viewCreate : oldEndDate === '' && newEndDate !== '' ? $author$project$Components$Auditing$Crumb$Membership$viewDelete : $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
    };
    var $author$project$Components$Auditing$Crumb$Membership$view = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return $author$project$Components$Auditing$Crumb$Membership$viewCreate;
            case 1:
                return $author$project$Components$Auditing$Crumb$Membership$viewUpdate(crumb);
            default:
                return $author$project$Components$Auditing$Crumb$Membership$viewDelete;
        }
    };
    var $author$project$Components$Auditing$Crumb$Phone$view = function(crumb) {
        var phoneType = $author$project$Api$Audit$Crumb$label(crumb);
        var _v0 = A2($author$project$Components$Auditing$Crumb$Helpers$getDiffValues, 'number', crumb);
        var oldPhoneNumber = _v0.a;
        var newPhoneNumber = _v0.b;
        var _v1 = _Utils_Tuple2(crumb.aba, oldPhoneNumber);
        switch(_v1.a){
            case 0:
                var _v2 = _v1.a;
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(phoneType + (' ' + (newPhoneNumber + ' added')))
                ]));
            case 1:
                if (_v1.b === '') {
                    var _v3 = _v1.a;
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(phoneType + (' ' + (newPhoneNumber + ' added')))
                    ]));
                } else {
                    var _v4 = _v1.a;
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(phoneType),
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(' changed from '),
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$s, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(oldPhoneNumber)
                                ])),
                                $elm$html$Html$text(' to '),
                                $elm$html$Html$text(newPhoneNumber)
                            ]))
                        ]))
                    ]));
                }
            default:
                var _v5 = _v1.a;
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(phoneType + (' ' + (oldPhoneNumber + ' removed')))
                ]));
        }
    };
    var $author$project$Components$Auditing$Crumb$view = function(crumb) {
        var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
        switch(_v0){
            case 'company_registration':
                return $author$project$Components$Auditing$Crumb$CompanyRegistration$view(crumb);
            case 'company_account':
                return $author$project$Components$Auditing$Crumb$CompanyAccount$view(crumb);
            case 'charge':
                return $author$project$Components$Auditing$Crumb$Charge$view(crumb);
            case 'membership':
                return $author$project$Components$Auditing$Crumb$Membership$view(crumb);
            case 'membership_patient':
                return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
            case 'customer_invoice':
                return $author$project$Components$Auditing$Crumb$CustomerInvoice$view(crumb);
            case 'address':
                return $author$project$Components$Auditing$Crumb$Address$view(crumb);
            case 'phone':
                return $author$project$Components$Auditing$Crumb$Phone$view(crumb);
            default:
                return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
        }
    };
    var $author$project$Components$Auditing$Trail$BankAccount$viewAll = function(trail) {
        return A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$view, $author$project$Api$Audit$crumbs(trail));
    };
    var $author$project$Components$Auditing$Trail$BankAccount$view = function(trail) {
        var label = A2($elm$core$Maybe$withDefault, 'Bank Account', A2($elm$core$Maybe$map, $author$project$Api$Audit$Crumb$label, $elm$core$List$head($author$project$Api$Audit$crumbs(trail))));
        var _v0 = $author$project$Api$Audit$name(trail);
        switch(_v0){
            case 'BankAccount Created':
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(label + ' created')
                ]));
            case 'BankAccount Deleted':
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(label + ' deleted')
                ]));
            default:
                return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$BankAccount$viewAll(trail));
        }
    };
    var $author$project$Components$Auditing$Trail$Card$viewAll = function(trail) {
        return A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$view, $author$project$Api$Audit$crumbs(trail));
    };
    var $author$project$Components$Auditing$Trail$Card$view = function(trail) {
        var label = A2($elm$core$Maybe$withDefault, 'Card', A2($elm$core$Maybe$map, $author$project$Api$Audit$Crumb$label, $elm$core$List$head($author$project$Api$Audit$crumbs(trail))));
        var _v0 = $author$project$Api$Audit$name(trail);
        switch(_v0){
            case 'Card Created':
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(label + ' created')
                ]));
            case 'Card Deleted':
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(label + ' deleted')
                ]));
            default:
                return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$Card$viewAll(trail));
        }
    };
    var $author$project$Components$Auditing$Trail$CompanyAccount$getCrumbList = function(trail) {
        return A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$view, $author$project$Api$Audit$crumbs(trail));
    };
    var $author$project$Components$Auditing$Trail$CompanyAccount$viewAll = function(trail) {
        return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$CompanyAccount$getCrumbList(trail));
    };
    var $author$project$Components$Auditing$Trail$CompanyAccount$viewCreated = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Membership created')
    ]));
    var $author$project$Components$Auditing$Trail$CompanyAccount$viewDeleted = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Membership terminated')
    ]));
    var $author$project$Components$Auditing$Trail$CompanyAccount$viewEnrollmentApproved = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Enrollment Approved')
    ]));
    var $author$project$Components$Auditing$Trail$CompanyAccount$view = function(trail) {
        var _v0 = $author$project$Api$Audit$name(trail);
        switch(_v0){
            case 'CompanyAccount Created':
                return $author$project$Components$Auditing$Trail$CompanyAccount$viewCreated;
            case 'CompanyAccount Unenrolled':
                return $author$project$Components$Auditing$Trail$CompanyAccount$viewDeleted;
            case 'CompanyAccount Approved':
                return $author$project$Components$Auditing$Trail$CompanyAccount$viewEnrollmentApproved;
            default:
                return $author$project$Components$Auditing$Trail$CompanyAccount$viewAll(trail);
        }
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList = function(trail) {
        return A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$view, $author$project$Api$Audit$crumbs(trail));
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$viewAll = function(trail) {
        return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList(trail));
    };
    var $author$project$Api$Audit$label = function(audit) {
        var record = audit;
        var _v1 = record.vq;
        if (!_v1.$) {
            var aggregate = _v1.a;
            return aggregate.aeI;
        } else return '';
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated = function(trail) {
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Invoice ' + ($author$project$Api$Audit$label(trail) + ' created'))
        ]));
    };
    var $author$project$Api$Audit$Crumb$diffTypeToString = function(diffType) {
        if (!diffType.$) {
            var string = diffType.a;
            return $elm$core$Maybe$Just(string);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmount = function(trail) {
        return A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm$core$Maybe$andThen, function(crumb) {
            return $elm$core$List$head(A2($elm$core$List$filter, function(_v0) {
                var key = _v0.a;
                return key === 'credit';
            }, $author$project$Api$Audit$Crumb$diff(crumb)));
        }, $elm$core$List$head(A2($elm$core$List$filter, function(crumb) {
            return $author$project$Api$Audit$Crumb$recordType(crumb) === 'credit';
        }, $author$project$Api$Audit$crumbs(trail)))));
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper = F2(function(extractDiffType, trail) {
        var creditAmount = function() {
            var _v0 = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmount(trail);
            if (!_v0.$) {
                var diff = _v0.a;
                return A2($elm$core$Maybe$andThen, $author$project$Api$Audit$Crumb$diffTypeToString, extractDiffType(diff));
            } else return $elm$core$Maybe$Nothing;
        }();
        return A2($elm$core$Maybe$withDefault, '', creditAmount);
    });
    var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountApplied = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper(function(_v0) {
        var maybeDiffType = _v0.b;
        return maybeDiffType;
    });
    var $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit = function(trail) {
        return A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$view, A2($elm$core$List$filter, function(crumb) {
            return $author$project$Api$Audit$Crumb$recordType(crumb) !== 'credit';
        }, $author$project$Api$Audit$crumbs(trail)));
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditApplied = function(trail) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountApplied(trail) + ' credit applied')
            ])),
            A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit(trail))
        ]));
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountRemoved = $author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountHelper(function(_v0) {
        var maybeDiffType = _v0.a;
        return maybeDiffType;
    });
    var $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditRemoved = function(trail) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Auditing$Trail$CustomerInvoice$getCreditAmountRemoved(trail) + ' credit removed')
            ])),
            A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbListWithoutCredit(trail))
        ]));
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$viewIssued = function(trail) {
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Invoice ' + ($author$project$Api$Audit$label(trail) + ' was issued'))
        ]));
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$viewReturnedToDraft = function(trail) {
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Invoice ' + ($author$project$Api$Audit$label(trail) + ' was returned to draft'))
        ]));
    };
    var $author$project$Api$Audit$Crumb$event = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return 'create';
            case 1:
                return 'update';
            default:
                return 'delete';
        }
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$viewUpload = function(trail) {
        var isCustomerInvoiceCreate = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(crumb) {
            return $author$project$Api$Audit$Crumb$event(crumb) === 'create';
        }, $elm$core$List$head(A2($elm$core$List$filter, function(crumb) {
            return $author$project$Api$Audit$Crumb$recordType(crumb) === 'customer_invoice';
        }, $author$project$Api$Audit$crumbs(trail)))));
        return isCustomerInvoiceCreate ? $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated(trail) : A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$CustomerInvoice$getCrumbList(trail));
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$viewVoided = function(trail) {
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Invoice ' + ($author$project$Api$Audit$label(trail) + ' was voided'))
        ]));
    };
    var $author$project$Components$Auditing$Trail$CustomerInvoice$view = function(trail) {
        var _v0 = $author$project$Api$Audit$name(trail);
        switch(_v0){
            case 'CustomerInvoice Returned to draft':
                return $author$project$Components$Auditing$Trail$CustomerInvoice$viewReturnedToDraft(trail);
            case 'CustomerInvoice Issued':
                return $author$project$Components$Auditing$Trail$CustomerInvoice$viewIssued(trail);
            case 'CustomerInvoice Created':
                return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreated(trail);
            case 'CustomerInvoice Voided':
                return $author$project$Components$Auditing$Trail$CustomerInvoice$viewVoided(trail);
            case 'CSV Uploaded':
                return $author$project$Components$Auditing$Trail$CustomerInvoice$viewUpload(trail);
            case 'CustomerInvoice Credits applied':
                return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditApplied(trail);
            case 'CustomerInvoice Credits removed':
                return $author$project$Components$Auditing$Trail$CustomerInvoice$viewCreditRemoved(trail);
            default:
                return $author$project$Components$Auditing$Trail$CustomerInvoice$viewAll(trail);
        }
    };
    var $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Invoice Auto-Issued')
    ]));
    var $author$project$Components$Auditing$Trail$Invoice$viewCreated = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Invoice Created')
    ]));
    var $author$project$Components$Auditing$Trail$Invoice$viewEmpty = $elm$html$Html$text('');
    var $author$project$Components$Auditing$Trail$Invoice$viewIssued = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Invoice Issued')
    ]));
    var $author$project$Components$Auditing$Trail$Invoice$viewMarkedAsBadDebt = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Invoice marked as bad debt')
    ]));
    var $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Invoice Notification Sent')
    ]));
    var $author$project$Components$Auditing$Trail$Invoice$viewReturnedToDraft = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Invoice Returned to Draft')
    ]));
    var $author$project$Components$Auditing$Trail$Invoice$viewVoided = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Invoice Voided')
    ]));
    var $author$project$Components$Auditing$Trail$Invoice$view = function(trail) {
        var _v0 = $author$project$Api$Audit$name(trail);
        switch(_v0){
            case 'Invoice Returned to draft':
                return $author$project$Components$Auditing$Trail$Invoice$viewReturnedToDraft;
            case 'Invoice Issued':
                return $author$project$Components$Auditing$Trail$Invoice$viewIssued;
            case 'Invoice Created':
                return $author$project$Components$Auditing$Trail$Invoice$viewCreated;
            case 'Invoice Voided':
                return $author$project$Components$Auditing$Trail$Invoice$viewVoided;
            case 'Notification Created':
                return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
            case 'Invoice Marked as bad debt':
                return $author$project$Components$Auditing$Trail$Invoice$viewMarkedAsBadDebt;
            case 'Invoice Notify upcoming':
                return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
            case 'Invoice Notify upcoming one worker':
                return $author$project$Components$Auditing$Trail$Invoice$viewNotificationSent;
            case 'Invoice Issue and or autopay':
                return $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued;
            case 'Invoice Issue and or autopay one worker':
                return $author$project$Components$Auditing$Trail$Invoice$viewAutoIssued;
            default:
                return $author$project$Components$Auditing$Trail$Invoice$viewEmpty;
        }
    };
    var $author$project$Components$Auditing$Trail$Membership$getCrumbList = function(trail) {
        return A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$view, $author$project$Api$Audit$crumbs(trail));
    };
    var $author$project$Components$Auditing$Trail$Membership$viewAll = function(trail) {
        return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$Membership$getCrumbList(trail));
    };
    var $author$project$Components$Auditing$Trail$Membership$viewCancelled = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Membership terminated')
    ]));
    var $author$project$Components$Auditing$Trail$Membership$viewCreated = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Membership created')
    ]));
    var $author$project$Components$Auditing$Trail$Membership$viewCreatedViaOnlineSignup = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Created by patient')
    ]));
    var $author$project$Components$Auditing$Trail$Membership$viewEasUpload = function(trail) {
        return A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$CompanyAccount$view, $author$project$Api$Audit$crumbs(trail));
    };
    var $author$project$Components$Auditing$Trail$Membership$viewRestarted = function(trail) {
        var crumbList = A2($elm$core$List$append, _List_fromArray([
            $elm$html$Html$text('Membership restarted')
        ]), $author$project$Components$Auditing$Trail$Membership$getCrumbList(trail));
        return A2($elm$html$Html$div, _List_Nil, crumbList);
    };
    var $author$project$Components$Auditing$Crumb$MembershipUpload$view = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Membership created')
                ]));
            case 1:
                var _v1 = $author$project$Api$Audit$Crumb$recordType(crumb);
                switch(_v1){
                    case 'membership':
                        return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
                    case 'membership_patient':
                        return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
                    default:
                        return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
                }
            default:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Membership deleted')
                ]));
        }
    };
    var $author$project$Components$Auditing$Trail$Membership$viewUpload = function(trail) {
        return A2($elm$core$List$map, function(crumb) {
            var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
            switch(_v0){
                case 'membership':
                    return $author$project$Components$Auditing$Crumb$MembershipUpload$view(crumb);
                case 'membership_patient':
                    return $author$project$Components$Auditing$Crumb$MembershipPatient$view(crumb);
                default:
                    return $elm$html$Html$text('');
            }
        }, $author$project$Api$Audit$crumbs(trail));
    };
    var $author$project$Components$Auditing$Trail$Membership$view = function(trail) {
        var _v0 = $author$project$Api$Audit$name(trail);
        switch(_v0){
            case 'Membership Created':
                return $author$project$Components$Auditing$Trail$Membership$viewCreated;
            case 'Membership Cancelled':
                return $author$project$Components$Auditing$Trail$Membership$viewCancelled;
            case 'CSV Uploaded':
                return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$Membership$viewUpload(trail));
            case 'EAS CSV Uploaded':
                return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$Membership$viewEasUpload(trail));
            case 'Membership Updated':
                return $author$project$Components$Auditing$Trail$Membership$viewAll(trail);
            case 'Membership Restarted':
                return $author$project$Components$Auditing$Trail$Membership$viewRestarted(trail);
            case 'OnlineEnrollments Confirm Created':
                return $author$project$Components$Auditing$Trail$Membership$viewCreatedViaOnlineSignup;
            default:
                return $author$project$Components$Auditing$Trail$Membership$viewAll(trail);
        }
    };
    var $author$project$Components$Auditing$Trail$Patient$viewAll = function(trail) {
        return A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$view, $author$project$Api$Audit$crumbs(trail));
    };
    var $author$project$Components$Auditing$Trail$Patient$viewCreated = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Patient created')
    ]));
    var $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $elm$html$Html$text('Created by patient')
    ]));
    var $author$project$Components$Auditing$Crumb$Patient$view = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patient created')
                ]));
            case 1:
                return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
            default:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patient deleted')
                ]));
        }
    };
    var $author$project$Components$Auditing$Crumb$PatientAffiliation$view = function(crumb) {
        var _v0 = crumb.aba;
        switch(_v0){
            case 0:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patient affiliation created')
                ]));
            case 1:
                return $author$project$Components$Auditing$Crumb$Helpers$viewChanges(crumb);
            default:
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patient affiliation deleted')
                ]));
        }
    };
    var $author$project$Components$Auditing$Trail$Patient$viewUpload = function(trail) {
        var isPatientCreate = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(crumb) {
            return $author$project$Api$Audit$Crumb$event(crumb) === 'create';
        }, $elm$core$List$head(A2($elm$core$List$filter, function(crumb) {
            return $author$project$Api$Audit$Crumb$recordType(crumb) === 'patient';
        }, $author$project$Api$Audit$crumbs(trail)))));
        return isPatientCreate ? $author$project$Components$Auditing$Trail$Patient$viewCreated : A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, function(crumb) {
            var _v0 = $author$project$Api$Audit$Crumb$recordType(crumb);
            switch(_v0){
                case 'patient':
                    return $author$project$Components$Auditing$Crumb$Patient$view(crumb);
                case 'address':
                    return $author$project$Components$Auditing$Crumb$Address$view(crumb);
                case 'phone':
                    return $author$project$Components$Auditing$Crumb$Phone$view(crumb);
                case 'patient_affiliation':
                    return $author$project$Components$Auditing$Crumb$PatientAffiliation$view(crumb);
                default:
                    return $author$project$Components$Auditing$Crumb$view(crumb);
            }
        }, $author$project$Api$Audit$crumbs(trail)));
    };
    var $author$project$Components$Auditing$Trail$Patient$view = function(trail) {
        var _v0 = $author$project$Api$Audit$name(trail);
        switch(_v0){
            case 'Patient Created':
                return $author$project$Components$Auditing$Trail$Patient$viewCreated;
            case 'CSV Uploaded':
                return $author$project$Components$Auditing$Trail$Patient$viewUpload(trail);
            case 'EAS CSV Uploaded':
                return $author$project$Components$Auditing$Trail$Patient$viewUpload(trail);
            case 'CompanyRegistration Created':
                return $author$project$Components$Auditing$Trail$Patient$viewCreated;
            case 'OnlineEnrollment Confirmed':
                return $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup;
            case 'OnlineEnrollments Member Created':
                return $author$project$Components$Auditing$Trail$Patient$viewCreatedViaOnlineSignup;
            case 'CompanyRegistration Updated':
                return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$Patient$viewAll(trail));
            default:
                return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Auditing$Trail$Patient$viewAll(trail));
        }
    };
    var $author$project$Components$Auditing$Trail$viewAll = function(trail) {
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Auditing$Crumb$view, $author$project$Api$Audit$crumbs(trail)));
    };
    var $author$project$Components$Auditing$Trail$view = function(trail) {
        var _v0 = _Utils_Tuple2($author$project$Api$Audit$aggregateType(trail), $author$project$Api$Audit$name(trail));
        _v0$5: while(true){
            _v0$6: while(true){
                _v0$7: while(true)if (!_v0.a.$) switch(_v0.a.a){
                    case 'membership':
                        return $author$project$Components$Auditing$Trail$Membership$view(trail);
                    case 'patient':
                        return $author$project$Components$Auditing$Trail$Patient$view(trail);
                    case 'company_account':
                        return $author$project$Components$Auditing$Trail$CompanyAccount$view(trail);
                    case 'customer_invoice':
                        return $author$project$Components$Auditing$Trail$CustomerInvoice$view(trail);
                    case 'invoice':
                        return $author$project$Components$Auditing$Trail$Invoice$view(trail);
                    default:
                        switch(_v0.b){
                            case 'Card Deleted':
                                break _v0$5;
                            case 'BankAccount Deleted':
                                break _v0$6;
                            default:
                                break _v0$7;
                        }
                }
                else switch(_v0.b){
                    case 'Card Deleted':
                        break _v0$5;
                    case 'BankAccount Deleted':
                        break _v0$6;
                    default:
                        break _v0$7;
                }
                return $author$project$Components$Auditing$Trail$viewAll(trail);
            }
            return $author$project$Components$Auditing$Trail$BankAccount$view(trail);
        }
        return $author$project$Components$Auditing$Trail$Card$view(trail);
    };
    var $author$project$Api$Audit$whodunnit = function(audit) {
        return $author$project$Api$Audit$record_(audit).abr.zr;
    };
    var $author$project$Components$AuditTrailLog$viewAudit = F3(function(timeFormatter, audits, audit) {
        var createdAt = A2(timeFormatter, 0, $author$project$Api$Audit$createdAt(audit));
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Components$Auditing$Trail$view(audit),
            function() {
                if ($author$project$Api$Audit$isOnlineSignup(audit)) return A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(createdAt + ' via online signup')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Audit$extraUrl(audit)))
                    ]))
                ]));
                else {
                    var whodunnit = $author$project$Components$AuditTrailLog$formatWhodunnit($author$project$Api$Audit$whodunnit(audit));
                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text(createdAt + (' by ' + whodunnit))
                    ]));
                }
            }(),
            A2($author$project$Components$AuditTrailLog$isLast, audits, audit) ? $author$project$Utils$Html$empty : $author$project$Ui$HorizontalRule$view(_List_fromArray([
                $author$project$Ui$HorizontalRule$thin
            ]))
        ]));
    });
    var $author$project$Components$AuditTrailLog$changeHistoryView = function(model) {
        return A2($author$project$Ui$Form$Group$view, _List_Nil, A2($elm$core$List$map, A2($author$project$Components$AuditTrailLog$viewAudit, model.HO, model.cs), model.cs));
    };
    var $author$project$Ui$Icon$History = 55;
    var $author$project$Ui$Icon$history = $author$project$Ui$Icon$viewIcon(55);
    var $author$project$Components$AuditTrailLog$loadingView = A2($author$project$Ui$Typography$div, _List_fromArray([
        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
    ]), _List_fromArray([
        $author$project$Ui$Spinner$view(_List_Nil)
    ]));
    var $author$project$Ui$Popover$Medium = 2;
    var $author$project$Ui$Popover$md = $author$project$Ui$Popover$Size(2);
    var $author$project$Components$AuditTrailLog$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$AuditTrailLog$isCreatedBeforeOct2023 = function(resourceCreatedAt) {
        if (!resourceCreatedAt.$) {
            var createdAt = resourceCreatedAt.a;
            var oct1_2023 = $elm$time$Time$millisToPosix(1696118400000);
            return _Utils_cmp($elm$time$Time$posixToMillis(createdAt), $elm$time$Time$posixToMillis(oct1_2023)) < 0;
        } else return false;
    };
    var $author$project$Components$AuditTrailLog$showContactSupport = A2($author$project$Ui$Typography$div, _List_fromArray([
        $author$project$Ui$Typography$muted
    ]), _List_fromArray([
        $elm$html$Html$text('For information on changes prior to 10/1/2023 email '),
        A3($author$project$Ui$Link$mailto, 'support@hint.com', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('support@hint.com')
        ])),
        $elm$html$Html$text('.')
    ]));
    var $author$project$Components$AuditTrailLog$showNoHistory = function(resource) {
        var record = _Utils_eq(resource, $elm$core$Maybe$Just('request')) ? 'the payment methods' : A2($elm$core$String$append, 'this ', A3($elm$core$String$replace, '_', ' ', A2($elm$core$Maybe$withDefault, 'record', resource)));
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$muted
        ]), _List_fromArray([
            $elm$html$Html$text('No changes have been recorded for ' + (record + '.'))
        ]));
    };
    var $author$project$Components$AuditTrailLog$showMoreItem = function(model) {
        if ($elm$core$List$isEmpty(model.cs)) return $author$project$Components$AuditTrailLog$isCreatedBeforeOct2023(model.Ca) ? $author$project$Components$AuditTrailLog$showContactSupport : $author$project$Components$AuditTrailLog$showNoHistory(model.Hg);
        else {
            var totalRemaining = model.DK - $elm$core$List$length(model.cs);
            return !!totalRemaining ? A2($elm$html$Html$map, $author$project$Components$AuditTrailLog$PaginationMsg, A2($author$project$Api$Pagination$viewAsShowMore, _List_Nil, model.af_)) : $author$project$Components$AuditTrailLog$isCreatedBeforeOct2023(model.Ca) ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                $author$project$Components$AuditTrailLog$showContactSupport
            ])) : $author$project$Utils$Html$empty;
        }
    };
    var $author$project$Components$AuditTrailLog$view = function(model) {
        return A4($author$project$Ui$Popover$viewAsClickable, _List_fromArray([
            $author$project$Ui$Popover$md,
            $author$project$Ui$Popover$visible($author$project$Ui$Popover$isOpen(model.aN))
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'See change history'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$AuditTrailLog$Toggle),
                $author$project$Ui$Button$badge,
                $author$project$Ui$Button$icon($author$project$Ui$Icon$history)
            ]), _List_fromArray([
                $elm$html$Html$text('See Change History')
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = model.pB;
                    if (_v0.$ === 3) return $elm$core$List$isEmpty(model.cs) ? $author$project$Utils$Html$empty : $author$project$Components$AuditTrailLog$changeHistoryView(model);
                    else return $author$project$Components$AuditTrailLog$loadingView;
                }(),
                $author$project$Components$AuditTrailLog$showMoreItem(model)
            ]))
        ]), model.aN);
    };
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$loadFromData = function(model) {
        var _v0 = model.DZ;
        if (_v0.$ === 3) {
            var virtualBankAccounts_ = _v0.a;
            return virtualBankAccounts_;
        } else return _List_Nil;
    };
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$VirtualBankAccount$Shared$abaAccountNumber = function(_v0) {
        var record = _v0;
        return record.H8;
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber = function(_v0) {
        var record = _v0;
        return record.H8;
    };
    var $author$project$Api$VirtualBankAccount$abaAccountNumber = function(vba) {
        if (!vba.$) {
            var vba_ = vba.a;
            return $author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber(vba_);
        } else {
            var vba_ = vba.a;
            return $author$project$Api$Employer$VirtualBankAccount$Shared$abaAccountNumber(vba_);
        }
    };
    var $author$project$Api$Employer$VirtualBankAccount$Shared$abaBankName = function(_v0) {
        var record = _v0;
        return record.H9;
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName = function(_v0) {
        var record = _v0;
        return record.H9;
    };
    var $author$project$Api$VirtualBankAccount$abaBankName = function(vba) {
        if (!vba.$) {
            var vba_ = vba.a;
            return $author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(vba_);
        } else {
            var vba_ = vba.a;
            return $author$project$Api$Employer$VirtualBankAccount$Shared$abaBankName(vba_);
        }
    };
    var $author$project$Api$Employer$VirtualBankAccount$Shared$abaRoutingtNumber = function(_v0) {
        var record = _v0;
        return record.Ia;
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber = function(_v0) {
        var record = _v0;
        return record.Ia;
    };
    var $author$project$Api$VirtualBankAccount$abaRoutingtNumber = function(vba) {
        if (!vba.$) {
            var vba_ = vba.a;
            return $author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(vba_);
        } else {
            var vba_ = vba.a;
            return $author$project$Api$Employer$VirtualBankAccount$Shared$abaRoutingtNumber(vba_);
        }
    };
    var $author$project$Api$Employer$VirtualBankAccount$Shared$swiftAccountNumber = function(_v0) {
        var record = _v0;
        return record.$z;
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftAccountNumber = function(_v0) {
        var record = _v0;
        return record.$z;
    };
    var $author$project$Api$VirtualBankAccount$swiftAccountNumber = function(vba) {
        if (!vba.$) {
            var vba_ = vba.a;
            return $author$project$Api$Provider$VirtualBankAccount$Shared$swiftAccountNumber(vba_);
        } else {
            var vba_ = vba.a;
            return $author$project$Api$Employer$VirtualBankAccount$Shared$swiftAccountNumber(vba_);
        }
    };
    var $author$project$Api$Employer$VirtualBankAccount$Shared$swiftBankName = function(_v0) {
        var record = _v0;
        return record.$A;
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftBankName = function(_v0) {
        var record = _v0;
        return record.$A;
    };
    var $author$project$Api$VirtualBankAccount$swiftBankName = function(vba) {
        if (!vba.$) {
            var vba_ = vba.a;
            return $author$project$Api$Provider$VirtualBankAccount$Shared$swiftBankName(vba_);
        } else {
            var vba_ = vba.a;
            return $author$project$Api$Employer$VirtualBankAccount$Shared$swiftBankName(vba_);
        }
    };
    var $author$project$Api$Employer$VirtualBankAccount$Shared$swiftCode = function(_v0) {
        var record = _v0;
        return record.$B;
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode = function(_v0) {
        var record = _v0;
        return record.$B;
    };
    var $author$project$Api$VirtualBankAccount$swiftCode = function(vba) {
        if (!vba.$) {
            var vba_ = vba.a;
            return $author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(vba_);
        } else {
            var vba_ = vba.a;
            return $author$project$Api$Employer$VirtualBankAccount$Shared$swiftCode(vba_);
        }
    };
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccountBox = function(virtualBankAccount) {
        return A3($author$project$Ui$Alert$view, 1, _List_fromArray([
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
            $author$project$Ui$Alert$margin(25)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Bank Name')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$black,
                            $author$project$Ui$Typography$margin(25)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$VirtualBankAccount$abaBankName(virtualBankAccount)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Copy Bank Name'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard, 'Bank Name', $author$project$Api$VirtualBankAccount$swiftBankName(virtualBankAccount)))
                            ]), _List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Routing Number')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$black,
                            $author$project$Ui$Typography$margin(25)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$VirtualBankAccount$abaRoutingtNumber(virtualBankAccount)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Copy Routing Number'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard, 'Routing Number', $author$project$Api$VirtualBankAccount$abaRoutingtNumber(virtualBankAccount)))
                            ]), _List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Account Number')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$black,
                            $author$project$Ui$Typography$margin(25)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$VirtualBankAccount$abaAccountNumber(virtualBankAccount)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Copy Account Number'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard, 'Account Number', $author$project$Api$VirtualBankAccount$swiftAccountNumber(virtualBankAccount)))
                            ]), _List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('SWIFT code')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$black,
                            $author$project$Ui$Typography$margin(25)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$VirtualBankAccount$swiftCode(virtualBankAccount)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Copy SWIFT Code'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$Company$VirtualBankAccounts$Invoice$CopyToClipboard, 'Swift Code', $author$project$Api$VirtualBankAccount$swiftCode(virtualBankAccount)))
                            ]), _List_Nil)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccount = F2(function(payerName, virtualBankAccount) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Transfer Instructions'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('To complete payments to ' + (payerName + ', transfer funds from your banking institution to the bank account provided below. Bank Transfers can take up to five business days.')),
                A2($elm$html$Html$br, _List_Nil, _List_Nil)
            ])),
            $author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccountBox(virtualBankAccount)
        ]));
    });
    var $author$project$Components$Company$VirtualBankAccounts$Invoice$view = F2(function(_v0, payerName) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Company$VirtualBankAccounts$Invoice$viewVirtualBankAccount(payerName), $author$project$Components$Company$VirtualBankAccounts$Invoice$loadFromData(model)));
    });
    var $author$project$Components$CompanyEmailModal$Body = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$CompanyEmailModal$Subject = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Notification$One$bodyHtml = function(_v0) {
        var record = _v0.b;
        return record.Kl;
    };
    var $author$project$Api$Provider$Notification$One$subjectHtml = function(_v0) {
        var record = _v0.b;
        return record.$p;
    };
    var $author$project$Components$CompanyEmailModal$viewPreview = F3(function(header, subject, body) {
        return _List_fromArray([
            function() {
                if (!header.$) {
                    var header_ = header.a;
                    return A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(header_)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('email-preview')
                ]), _List_fromArray([
                    A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Subject')
                    ])),
                    subject,
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    body
                ]))
            ]))
        ]);
    });
    var $author$project$Components$CompanyEmailModal$viewModalBody = function(model) {
        switch(model.$){
            case 0:
                var shared = model.a;
                return A3($author$project$Components$CompanyEmailModal$viewPreview, shared.qQ, $author$project$Ui$Spinner$view(_List_Nil), $author$project$Ui$Spinner$view(_List_Nil));
            case 1:
                var shared = model.a;
                var preview = model.b;
                var delivery = model.c;
                return _Utils_ap(A3($author$project$Components$CompanyEmailModal$viewPreview, shared.qQ, A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('subject')
                ]), $author$project$Utils$Dom$textToHtml(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Notification$One$subjectHtml(preview))))), A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('body'), $author$project$Api$Phi$displayAttr), $author$project$Utils$Dom$textToHtml(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Notification$One$bodyHtml(preview)))))), _List_fromArray([
                    function() {
                        if (delivery.$ === 2) {
                            var error = delivery.a;
                            return A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Error sending email')
                                ])),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                $elm$html$Html$text($author$project$Api$Data$errorToString(error))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]));
            default:
                var shared = model.a;
                var notificationForm = model.b;
                var _v2 = $author$project$Utils$Form$fields(notificationForm);
                var subject = _v2.HF;
                var body = _v2.fb;
                return A3($author$project$Components$CompanyEmailModal$viewPreview, shared.qQ, A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', subject)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated, $author$project$Components$CompanyEmailModal$Subject)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, notificationForm)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, notificationForm))
                    ]))
                ])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Form$Textarea$view(_List_fromArray([
                            $author$project$Ui$Form$Textarea$rows(15),
                            $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', body)),
                            $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CompanyEmailModal$NotificationFormFieldUpdated, $author$project$Components$CompanyEmailModal$Body)),
                            $author$project$Ui$Form$Textarea$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, notificationForm)),
                            $author$project$Ui$Form$Textarea$errors(A2($author$project$Utils$Form$validationErrors, 1, notificationForm))
                        ]))
                    ]))
                ])));
        }
    };
    var $author$project$Components$CompanyEmailModal$Edit = {
        $: 2
    };
    var $author$project$Components$CompanyEmailModal$Preview = {
        $: 1
    };
    var $author$project$Components$CompanyEmailModal$Send = {
        $: 3
    };
    var $author$project$Components$CompanyEmailModal$viewCancelButton = A3($author$project$Ui$Button$view, {
        abP: 'Cancel and close modal'
    }, _List_fromArray([
        $author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Close)
    ]), _List_fromArray([
        $elm$html$Html$text('Cancel')
    ]));
    var $author$project$Components$CompanyEmailModal$viewModalFooter = function(model) {
        switch(model.$){
            case 0:
                return _List_fromArray([
                    $author$project$Components$CompanyEmailModal$viewCancelButton
                ]);
            case 1:
                var delivery = model.c;
                var deliveryLoading = function() {
                    if (delivery.$ === 1) return true;
                    else return false;
                }();
                return _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Customize email'
                    }, _List_fromArray([
                        $author$project$Ui$Button$pull(0),
                        $author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Customize Email')
                    ])),
                    $author$project$Components$CompanyEmailModal$viewCancelButton,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Send email'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Send),
                        $author$project$Ui$Button$loading(deliveryLoading)
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$send(_List_Nil),
                        $elm$html$Html$text(' Send Email')
                    ]))
                ]);
            default:
                var preview = model.c;
                var loading = function() {
                    if (preview.$ === 1) return true;
                    else return false;
                }();
                return _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Preview email'
                    }, _List_fromArray([
                        $author$project$Ui$Button$pull(0),
                        $author$project$Ui$Button$onClick($author$project$Components$CompanyEmailModal$Preview),
                        $author$project$Ui$Button$loading(loading)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Preview Email')
                    ])),
                    $author$project$Components$CompanyEmailModal$viewCancelButton
                ]);
        }
    };
    var $author$project$Components$CompanyEmailModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$CompanyEmailModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Send via Email')
            ])),
            $author$project$Ui$Modal$body($author$project$Components$CompanyEmailModal$viewModalBody(model)),
            $author$project$Ui$Modal$footer($author$project$Components$CompanyEmailModal$viewModalFooter(model))
        ]));
    };
    var $author$project$Api$Employer$Invoice$Meta$hideChargeDetailsAction = function(_v0) {
        var meta = _v0;
        return meta.tM.QH;
    };
    var $author$project$Api$Invoice$Meta$hideChargeDetailsAction = function(meta) {
        if (!meta.$) return false;
        else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$Invoice$Meta$hideChargeDetailsAction(meta_);
        }
    };
    var $author$project$Components$ExportCsv$ReportParams = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ExportCsv$reportParams = $author$project$Components$ExportCsv$ReportParams;
    var $author$project$Components$Invoice$InvoiceLinesTable$reportParams = function(model) {
        var _v0 = model.RL;
        if (!_v0.$) {
            var affiliateBillId = _v0.b;
            return _List_fromArray([
                A2($author$project$Api$Param$string, 'affiliate_bill', affiliateBillId)
            ]);
        } else {
            var companyId_ = _v0.a;
            var invoiceId = _v0.b;
            return _List_fromArray([
                A2($author$project$Api$Param$string, 'invoice', invoiceId),
                A2($author$project$Api$Param$string, 'company', companyId_)
            ]);
        }
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$AddInvoiceLine = {
        $: 9
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$SortTable = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Formatters$String$affiliateMember = F2(function(memberString, companyType) {
        if (_Utils_eq(companyType, $elm$core$Maybe$Just(0))) switch(memberString){
            case 'employee':
                return 'primary member';
            case 'Employee':
                return 'Primary';
            case 'Employees':
                return 'Members';
            case 'Employees & Dependents':
                return 'Members';
            default:
                return memberString;
        }
        else return memberString;
    });
    var $author$project$Api$Employer$Invoice$Meta$canAdjustAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KE;
    };
    var $author$project$Api$Provider$Invoice$Meta$canAdjustAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KE;
    };
    var $author$project$Api$Invoice$Meta$canAdjustAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$canAdjustAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$Invoice$Meta$canAdjustAction(meta_);
        }
    };
    var $author$project$Api$Column$withOption = F2(function(newOption, _v0) {
        var col = _v0;
        var options = col.z9;
        return _Utils_update(col, {
            z9: A2($elm$core$List$cons, newOption, options)
        });
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$columns = function(company) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'date', true, 'Date'),
                A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
                A3($author$project$Api$Column$init, 'description', false, 'Charge')
            ]),
            $author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(company) ? _List_fromArray([
                A3($author$project$Api$Column$init, 'plan', true, 'Plan')
            ]) : _List_Nil,
            _List_fromArray([
                A3($author$project$Api$Column$init, 'category', false, 'Category'),
                A2($author$project$Api$Column$withOption, $author$project$Ui$Table$textRight, A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'))
            ])
        ]));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$companyType = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Api$Provider$Company$Min$companyType(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Api$Company$companyType(company__);
            }
        }, company);
    };
    var $author$project$Ui$SearchInput$Loading = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$loading = $author$project$Ui$SearchInput$Loading;
    var $author$project$Ui$Icon$Lock = 21;
    var $author$project$Ui$Icon$lock = $author$project$Ui$Icon$viewIcon(21);
    var $author$project$Ui$SearchInput$Phi = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$phi = $author$project$Ui$SearchInput$Phi;
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$EmployerOrProviderCompany = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$ProviderMin = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$phiAlertCompany = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$ProviderMin(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$EmployerOrProviderCompany(company__);
            }
        }, company);
    };
    var $author$project$Ui$SearchInput$Placeholder = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$placeholder = $author$project$Ui$SearchInput$Placeholder;
    var $author$project$Api$Employer$Invoice$Meta$reportingPeriodIsLocked = function(_v0) {
        var meta = _v0;
        return meta.YC;
    };
    var $author$project$Api$Provider$Invoice$Meta$reportingPeriodIsLocked = function(_v0) {
        var meta = _v0;
        return meta.YC;
    };
    var $author$project$Api$Invoice$Meta$reportingPeriodIsLocked = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Invoice$Meta$reportingPeriodIsLocked(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$Invoice$Meta$reportingPeriodIsLocked(meta_);
        }
    };
    var $author$project$Ui$Table$Test = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Table$test = $author$project$Ui$Table$Test;
    var $author$project$Api$Employer$Company$One$chargePhiDetailsEnabled = function(_v0) {
        var record = _v0.b;
        return record.K6;
    };
    var $author$project$Api$Provider$Company$One$chargePhiDetailsEnabled = function(_v0) {
        var record = _v0.b;
        return record.K6;
    };
    var $author$project$Api$Company$chargePhiDetailsEnabled = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$chargePhiDetailsEnabled(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$chargePhiDetailsEnabled(company_);
        }
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$chargePhiDetailsEnabled = function(company) {
        if (!company.$) {
            if (!company.a.$) return false;
            else {
                var company_ = company.a.a;
                return $author$project$Api$Company$chargePhiDetailsEnabled(company_);
            }
        } else return false;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyId = function(company) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Api$Provider$Company$Min$id(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Api$Company$id(company__);
            }
        }, company));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName = function(company) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Api$Provider$Company$Min$name(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Api$Company$name(company__);
            }
        }, company));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyType = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            if (!company_.$) {
                var company__ = company_.a;
                return $author$project$Api$Provider$Company$Min$companyType(company__);
            } else {
                var company__ = company_.a;
                return $author$project$Api$Company$companyType(company__);
            }
        }, company);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForCompany = function(company) {
        return _Utils_eq($author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyType(company), $elm$core$Maybe$Just(0)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Non-membership charges are not visible to '),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName(company))
            ])),
            $elm$html$Html$text(' in the line items section. '),
            $elm$html$Html$text('Aggregate details by category are visible to '),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyName(company))
            ])),
            $elm$html$Html$text(' in the summary section. '),
            $elm$html$Html$text('This is configurable in the '),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings({
                fl: $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$companyId(company)
            }), _List_Nil, _List_fromArray([
                $elm$html$Html$text('invoice settings')
            ])),
            $elm$html$Html$text(' tab above.')
        ]));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForPractice = function(practice) {
        return A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    $elm$html$Html$text('In order to protect patient privacy all non-membership charge details are not visible. '),
                    $elm$html$Html$text('Aggregate costs can be viewed in the summary section above by category of charge. '),
                    $elm$html$Html$text('Please contact '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Practice$name(practice))
                    ])),
                    $elm$html$Html$text(' for more info.')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$view = F3(function(session, practice, company) {
        return $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$chargePhiDetailsEnabled(company) ? $author$project$Utils$Html$empty : $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForPractice(practice) : $author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$viewForCompany(company);
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$viewCategoryResourceFilter = function(categoryResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$viewNew, _List_Nil, categoryResourceFilter));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Employer$EmployeeDivision$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$EmployeeDivision$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$EmployeeDivision$Shared$name(shared);
    };
    var $author$project$Api$Provider$EmployeeDivision$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$EmployeeDivision$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$EmployeeDivision$Shared$name(shared);
    };
    var $author$project$Api$EmployeeDivision$All$name = function(employeeDivision) {
        if (!employeeDivision.$) {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Provider$EmployeeDivision$All$name(employeeDivision_);
        } else {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Employer$EmployeeDivision$All$name(employeeDivision_);
        }
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$viewEmployeeDivisionDropdown = function(model) {
        var items = function() {
            var _v1 = model.xv;
            if (_v1.$ === 3) {
                var employeeDivisions = _v1.a;
                return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected($elm$core$Maybe$Nothing))
                ]), $elm$html$Html$text('All Divisions')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(division) {
                    return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$Invoice$InvoiceLinesTable$EmployeeDivisionSelected($elm$core$Maybe$Just(division)))
                    ]), $elm$html$Html$text($author$project$Api$EmployeeDivision$All$name(division)));
                }, employeeDivisions)));
            } else return _List_fromArray([
                A2($author$project$Ui$Dropdown$item, _List_Nil, $elm$html$Html$text('Loading...'))
            ]);
        }();
        var currentLabel = function() {
            var _v0 = model.Fm;
            if (!_v0.$) {
                var division = _v0.a;
                return $author$project$Api$EmployeeDivision$All$name(division);
            } else return 'Division';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentLabel)
        ]), items, model.l5);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$EditInvoiceLine = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$RemoveInvoiceLine = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$InvoiceLine$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$InvoiceLine$All$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$InvoiceLine$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$InvoiceLine$All$categoryName = function(_v0) {
        var record = _v0.b;
        return record.K1;
    };
    var $author$project$Api$Provider$InvoiceLine$All$chargeDescription = function(_v0) {
        var record = _v0.b;
        return record.K5;
    };
    var $author$project$Api$Provider$InvoiceLine$All$charges = function(_v0) {
        var record = _v0.b;
        return record.K9;
    };
    var $author$project$Api$Provider$InvoiceLine$Shared$date = function(_v0) {
        var record = _v0;
        return record.M4;
    };
    var $author$project$Api$Provider$InvoiceLine$All$date = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$InvoiceLine$Shared$date(shared);
    };
    var $author$project$Api$Provider$InvoiceLine$All$dependentCount = function(_v0) {
        var record = _v0.b;
        return record.NK;
    };
    var $author$project$Api$Provider$Charge$Meta$destroyAction = function(_v0) {
        var meta = _v0;
        return meta.tM.NT;
    };
    var $author$project$Api$Provider$Charge$Meta$editAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Op;
    };
    var $author$project$Api$Provider$InvoiceLine$All$endDate = function(_v0) {
        var record = _v0.b;
        return record.qv;
    };
    var $author$project$Api$Invoice$Status$isDraft = function(status) {
        return _Utils_eq(status, $author$project$Api$Invoice$Status$Draft);
    };
    var $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked = function(_v0) {
        var record = _v0;
        return record.R7;
    };
    var $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Ui$Table$NoBorder = {
        $: 1
    };
    var $author$project$Ui$Table$noBorder = $author$project$Ui$Table$NoBorder;
    var $author$project$Api$Provider$InvoiceLine$All$patientName = function(_v0) {
        var record = _v0.b;
        return record.Wc;
    };
    var $author$project$Api$Provider$InvoiceLine$All$plan = function(_v0) {
        var record = _v0.b;
        return record.GW;
    };
    var $author$project$Api$Provider$InvoiceLine$All$shouldHideAmount = function(_v0) {
        var record = _v0.b;
        return record._d;
    };
    var $author$project$Formatters$ChargeItemCode$ChargeItemForCharge = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$ToggleShowMore = {
        $: 0
    };
    var $author$project$Ui$Icon$Chevron = 12;
    var $author$project$Ui$Icon$chevron = $author$project$Ui$Icon$viewIcon(12);
    var $author$project$Api$Provider$InvoiceLine$All$createdBy = function(_v0) {
        var record = _v0.b;
        return record.My;
    };
    var $author$project$Api$Provider$InvoiceLine$All$employeeDivision = function(_v0) {
        var record = _v0.b;
        return record.Fm;
    };
    var $author$project$Api$Provider$Charge$One$issuedQuantityUom = function(_v0) {
        var record = _v0.b;
        return record.SF;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$humanizePriceAndQuantity = function(charge) {
        if (!charge.$) {
            var charge_ = charge.a;
            var priceUom = $author$project$Api$Provider$Charge$One$priceUom(charge_);
            var priceAndQuantity = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$Currency$fromInt, $author$project$Api$Provider$Charge$One$priceInCents(charge_)));
            if ($author$project$Api$Provider$Uom$Shared$type_(priceUom) === 'Time') {
                var priceUomName = $elm$core$String$toLower($author$project$Api$Provider$Uom$Shared$name(priceUom));
                var issuedQuantityUomName = $elm$core$String$toLower($author$project$Api$Provider$Uom$Shared$name($author$project$Api$Provider$Charge$One$issuedQuantityUom(charge_)));
                var issuedUomNameAndQty = A2($author$project$Formatters$String$pluralize, issuedQuantityUomName, $author$project$Api$Provider$Charge$One$quantity(charge_));
                return priceAndQuantity + ('/' + (priceUomName + (' x ' + issuedUomNameAndQty)));
            } else return priceAndQuantity + (' x ' + $elm$core$String$fromInt($author$project$Api$Provider$Charge$One$quantity(charge_)));
        } else return '';
    };
    var $author$project$Api$Provider$Organization$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Session$Shared$organization = function(_v0) {
        var record = _v0;
        return record.VA;
    };
    var $author$project$Ui$Icon$rotate180 = $author$project$Ui$Icon$Rotate(180);
    var $author$project$Api$Provider$InvoiceLine$All$shouldShowMoreInfo = function(_v0) {
        var record = _v0.b;
        return record._e;
    };
    var $author$project$Api$Provider$Session$Shared$user = function(_v0) {
        var record = _v0;
        return record.aaX;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewCoverageDiscount = function(coverageDiscount) {
        var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coverageDiscount);
        return A2($author$project$Components$CoverageRuleDescription$view, $author$project$Components$CoverageRuleDescription$Shared(coverageRule), true);
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField = F2(function(label, value) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$small,
            $author$project$Ui$Typography$muted
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text(label + ': ')
            ])),
            $elm$html$Html$text(value)
        ]));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$view = function(model) {
        return $author$project$Api$Provider$InvoiceLine$All$shouldShowMoreInfo(model.q3) ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.op ? _Utils_Tuple2('Less info ', $author$project$Ui$Icon$chevron(_List_fromArray([
                    $author$project$Ui$Icon$rotate180
                ]))) : _Utils_Tuple2('More info ', $author$project$Ui$Icon$chevronDown(_List_Nil));
                var verb = _v0.a;
                var icon = _v0.b;
                return A3($author$project$Ui$Button$view, {
                    abP: verb
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$ToggleShowMore)
                ]), _List_fromArray([
                    $elm$html$Html$text(verb),
                    icon
                ]));
            }(),
            function() {
                if (model.op) {
                    var _v1 = function() {
                        var _v2 = _Utils_Tuple3($author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$), model.fS, model.wZ);
                        if (_v2.b.$ === 3) {
                            if (!_v2.a && _v2.c.$ === 3) {
                                var _v3 = _v2.b;
                                var invoiceLineDetails_ = _v3.a;
                                var _v4 = _v2.c;
                                var coverageDiscounts_ = _v4.a;
                                return _Utils_Tuple2($elm$core$Maybe$Just(invoiceLineDetails_), coverageDiscounts_);
                            } else {
                                var _v5 = _v2.b;
                                var invoiceLineDetails_ = _v5.a;
                                return _Utils_Tuple2($elm$core$Maybe$Just(invoiceLineDetails_), _List_Nil);
                            }
                        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
                    }();
                    var invoiceLineDetails = _v1.a;
                    var coverageDiscounts = _v1.b;
                    return A2($author$project$Ui$Typography$div, _List_Nil, function() {
                        if (!invoiceLineDetails.$) {
                            var invoiceLineDetails_ = invoiceLineDetails.a;
                            var charge = $elm$core$List$head($author$project$Api$Provider$InvoiceLine$One$charges(invoiceLineDetails_));
                            var _v7 = function() {
                                var _v8 = A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$chargeItem, charge));
                                if (!_v8.$) {
                                    var chargeItem = _v8.a;
                                    var manufacturer_ = $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem);
                                    var code_ = $author$project$Formatters$ChargeItemCode$toString($author$project$Formatters$ChargeItemCode$ChargeItemForCharge(chargeItem));
                                    return _Utils_Tuple2(code_, manufacturer_);
                                } else return _Utils_Tuple2('', '');
                            }();
                            var code = _v7.a;
                            var manufacturer = _v7.b;
                            return _List_fromArray([
                                A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Description', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$description, charge))),
                                A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Code', code),
                                A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Facility/Manufacturer', manufacturer),
                                A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Provider', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$name, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$practitioner, charge)))),
                                A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Location', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$One$location, charge)))),
                                model.aa1 ? A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Division', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$EmployeeDivision$Shared$name, $author$project$Api$Provider$InvoiceLine$All$employeeDivision(model.q3)))) : $author$project$Utils$Html$empty,
                                A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Price & Quantity', $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$humanizePriceAndQuantity(charge)),
                                $elm$core$List$length(coverageDiscounts) > 0 ? A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$small,
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Coverage: ')
                                    ])),
                                    A2($author$project$Ui$Typography$span, _List_Nil, A2($elm$core$List$map, $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewCoverageDiscount, coverageDiscounts))
                                ])) : $author$project$Utils$Html$empty,
                                A2($author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$viewField, 'Added by', function() {
                                    var _v9 = $author$project$Api$Provider$InvoiceLine$All$createdBy(model.q3);
                                    if (!_v9.$) {
                                        var createdBy = _v9.a;
                                        return $author$project$Api$Provider$User$Min$name($author$project$Api$Provider$Session$Shared$user(createdBy)) + (' from ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Organization$Min$name, $author$project$Api$Provider$Session$Shared$organization(createdBy))));
                                    } else return 'a recurring charge on the Plan';
                                }())
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_fromArray([
                                $author$project$Ui$Spinner$extraSmall
                            ]))
                        ]);
                    }());
                } else return $author$project$Utils$Html$empty;
            }()
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLine = F2(function(model, invoiceLine) {
        var maybeCharge = $elm$core$List$head($author$project$Api$Provider$InvoiceLine$All$charges(invoiceLine));
        var id = $author$project$Api$Provider$InvoiceLine$All$id(invoiceLine);
        var loading = A2($elm$core$Set$member, id, model.dR);
        var canEditCharge = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$editAction, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta, maybeCharge)));
        var canDestroyCharge = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$destroyAction, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$meta, maybeCharge)));
        return _List_fromArray([
            A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$InvoiceLine$All$date(invoiceLine))),
                        function() {
                            var _v0 = $author$project$Api$Provider$InvoiceLine$All$endDate(invoiceLine);
                            if (!_v0.$) {
                                var endDate = _v0.a;
                                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(' - '),
                                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate))
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$InvoiceLine$All$patientName(invoiceLine)),
                            $author$project$Api$Provider$InvoiceLine$All$dependentCount(invoiceLine) > 0 ? A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$gray,
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text(' + '),
                                $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'dependent', $author$project$Api$Provider$InvoiceLine$All$dependentCount(invoiceLine)))
                            ])) : $author$project$Utils$Html$empty
                        ]))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$InvoiceLine$All$chargeDescription(invoiceLine))
                    ]))
                ]),
                $author$project$Components$Invoice$InvoiceLinesTable$allowCustomMembershipPlan(model.acy) ? _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$Shared$name, $author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine))))
                    ]))
                ]) : _List_Nil,
                _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Unassigned', $author$project$Api$Provider$InvoiceLine$All$categoryName(invoiceLine)))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$bold,
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                        ]), _List_fromArray([
                            $author$project$Api$Provider$InvoiceLine$All$shouldHideAmount(invoiceLine) ? $author$project$Utils$Html$empty : $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$InvoiceLine$All$amountInCents(invoiceLine)))
                        ]))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_fromArray([
                        $author$project$Ui$Table$textRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$gap2,
                            $author$project$Ui$Element$justifyRight
                        ]), _List_fromArray([
                            !$author$project$Utils$Maybe$toBool($author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine)) && A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked, maybeCharge)) ? A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'This charge\'s reporting period is locked. And admin must unlock it to edit this charge.'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$disabled(true),
                                    $author$project$Ui$Button$size(0),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$lock)
                                ]), _List_Nil)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Popover$heading, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Locked')
                                ])),
                                A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('An admin must unlock this charge\'s reporting period before editing this charge.')
                                ]))
                            ])) : $author$project$Utils$Html$empty,
                            !$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) && !$author$project$Utils$Maybe$toBool($author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine)) && !A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$ForInvoiceLineAll$isLocked, maybeCharge)) && canEditCharge ? A3($author$project$Ui$Button$view, {
                                abP: 'Edit invoice line'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$loading(loading),
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$EditInvoiceLine(invoiceLine)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ])) : $author$project$Utils$Html$empty,
                            !$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) && !$author$project$Utils$Maybe$toBool($author$project$Api$Provider$InvoiceLine$All$plan(invoiceLine)) && $author$project$Api$Invoice$Status$isDraft($author$project$Api$Invoice$One$humanStatus(model.RA)) && canDestroyCharge ? A3($author$project$Ui$Button$view, {
                                abP: 'Delete invoice line'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$size(0),
                                $author$project$Ui$Button$loading(loading),
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$RemoveInvoiceLine(invoiceLine)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Delete')
                            ])) : $author$project$Utils$Html$empty
                        ]))
                    ]))
                ])
            ]))),
            A2($author$project$Ui$Table$row, _List_fromArray([
                $author$project$Ui$Table$noBorder
            ]), _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(5)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfoMsg(id), A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$Invoice$InvoiceLinesTable$PhiMoreInfo$view, A2($elm$core$Dict$get, id, model.en))))
                ]))
            ]))
        ]);
    });
    var $author$project$Components$ResourceFilter$Plan$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$viewPlanResourceFilter = function(planResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$viewNew, _List_Nil, planResourceFilter));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLines = function(model) {
        var invoiceMeta = $author$project$Api$Invoice$One$meta(model.RA);
        var _v0 = function() {
            var _v1 = model.ar;
            if (_v1.$ === 3) {
                var invoiceLines_ = _v1.a;
                return _Utils_Tuple2(false, invoiceLines_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var invoiceLines = _v0.b;
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                function() {
                    if (model.BE) {
                        var companyType_ = $author$project$Components$Invoice$InvoiceLinesTable$companyType(model.acy);
                        return $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text('Enrolled '),
                            $elm$html$Html$text(A2($author$project$Formatters$String$affiliateMember, 'Employees & Dependents', companyType_))
                        ]));
                    } else return $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Line Items')
                    ]));
                }(),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                            $author$project$Ui$SearchInput$phi(true),
                            $author$project$Ui$SearchInput$placeholder('Search by employee name or amount'),
                            $author$project$Ui$SearchInput$loading(loading)
                        ]), model.sG))
                    ])),
                    function() {
                        var _v2 = model.RL;
                        if (!_v2.$) return $author$project$Ui$Grid$none;
                        else return A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            $author$project$Components$Invoice$InvoiceLinesTable$viewCategoryResourceFilter(model.cK)
                        ]));
                    }(),
                    function() {
                        var _v3 = model.jy;
                        if (!_v3.$) {
                            var planResourceFilter = _v3.a;
                            return A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(2)
                            ]), _List_fromArray([
                                $author$project$Components$Invoice$InvoiceLinesTable$viewPlanResourceFilter(planResourceFilter)
                            ]));
                        } else return $author$project$Ui$Grid$none;
                    }(),
                    $author$project$Components$Invoice$InvoiceLinesTable$usesEmployeeDivisions(model.acy) ? A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(2)
                    ]), _List_fromArray([
                        $author$project$Components$Invoice$InvoiceLinesTable$viewEmployeeDivisionDropdown(model)
                    ])) : $author$project$Ui$Grid$none,
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3)
                    ]), _List_fromArray([
                        function() {
                            if (!$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) && $author$project$Api$Invoice$Meta$canAdjustAction(invoiceMeta) && !$author$project$Api$Invoice$Meta$reportingPeriodIsLocked(invoiceMeta)) {
                                var verb = model.BE ? 'Add Charge or Adjustment' : 'Add Charge';
                                return A3($author$project$Ui$Button$view, {
                                    abP: verb
                                }, _List_fromArray([
                                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$InvoiceLinesTable$AddInvoiceLine),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(verb)
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        $author$project$Api$Invoice$Meta$reportingPeriodIsLocked(invoiceMeta) ? A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Add charge or adjustment'
                            }, _List_fromArray([
                                $author$project$Ui$Button$disabled(true),
                                $author$project$Ui$Button$fullWidth(true),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$lock)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Add Charge or Adjustment')
                            ]))
                        ]), _List_fromArray([
                            A2($author$project$Ui$Popover$heading, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Locked')
                            ])),
                            A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('An admin must unlock this invoice\'s reporting period before adding charges or adjustments.')
                            ]))
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A3($author$project$Components$Invoice$InvoiceLinesTable$PhiAlert$view, model.Z$, model.W1, $author$project$Components$Invoice$InvoiceLinesTable$phiAlertCompany(model.acy))
            ])),
            A4($author$project$Ui$Panel$table, _List_fromArray([
                $author$project$Ui$Table$loading(loading),
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No matching results.')
                ])),
                $author$project$Ui$Table$test('invoice-lines')
            ]), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Invoice$InvoiceLinesTable$SortTable)), $author$project$Components$Invoice$InvoiceLinesTable$columns(model.acy)), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $author$project$Utils$Html$empty
                ]))
            ])), A2($elm$core$List$concatMap, $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLine(model), invoiceLines), _List_Nil),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(loading)
                ]), model.af_))
            ]))
        ]));
    };
    var $author$project$Components$Invoice$InvoiceLinesTable$view = F2(function(apiClient, model) {
        var invoiceMeta = $author$project$Api$Invoice$One$meta(model.RA);
        return _List_fromArray([
            $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? $elm$html$Html$text('') : A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.ar)),
                $author$project$Components$ExportCsv$reportParams($author$project$Components$Invoice$InvoiceLinesTable$reportParams(model))
            ]), model.md)),
            $author$project$Api$Invoice$Meta$hideChargeDetailsAction(invoiceMeta) ? $author$project$Utils$Html$empty : $author$project$Components$Invoice$InvoiceLinesTable$viewInvoiceLines(model)
        ]);
    });
    var $author$project$Components$Invoice$Summary$OtherChargesSummaryMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows = function(_v0) {
        var record = _v0;
        return record.It.Zc;
    };
    var $author$project$Api$Common$Invoice$Summary$byEmployeeDivision = function(_v0) {
        var record = _v0;
        return record.KA;
    };
    var $author$project$Api$Common$Invoice$Summary$byPlan = function(_v0) {
        var record = _v0;
        return record.KB;
    };
    var $author$project$Api$Common$Invoice$Summary$bySponsor = function(_v0) {
        var record = _v0;
        return record.KC;
    };
    var $author$project$Components$Invoice$Summary$activeLinesFor = F2(function(summary, groupBy_) {
        switch(groupBy_){
            case 0:
                return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows, $author$project$Api$Common$Invoice$Summary$byPlan(summary)));
            case 1:
                return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows, $author$project$Api$Common$Invoice$Summary$byEmployeeDivision(summary)));
            default:
                return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Invoice$Summary$Grouped$activeLinesRows, $author$project$Api$Common$Invoice$Summary$bySponsor(summary)));
        }
    });
    var $author$project$Api$Employer$Invoice$One$discountSavingsInCents = function(_v0) {
        var record = _v0.b;
        return record.N3;
    };
    var $author$project$Api$Provider$Invoice$One$discountSavingsInCents = function(_v0) {
        var record = _v0.b;
        return record.N3;
    };
    var $author$project$Api$Invoice$One$discountSavingsInCents = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$discountSavingsInCents(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$discountSavingsInCents(invoice_);
        }
    };
    var $author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines = function(_v0) {
        var record = _v0;
        return record.TY;
    };
    var $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows = function(_v0) {
        var record = _v0;
        return record.TY.Zc;
    };
    var $author$project$Components$Invoice$Summary$membershipAdjustmentLinesFor = F2(function(summary, groupBy_) {
        switch(groupBy_){
            case 0:
                return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows, $author$project$Api$Common$Invoice$Summary$byPlan(summary)));
            case 1:
                return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows, $author$project$Api$Common$Invoice$Summary$byEmployeeDivision(summary)));
            default:
                return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Invoice$Summary$Grouped$membershipAdjustmentLinesRows, $author$project$Api$Common$Invoice$Summary$bySponsor(summary)));
        }
    });
    var $author$project$Api$Common$Invoice$Summary$AllLines$totalAmountInCents = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, 0, record.DL.Jh);
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount = function(_v0) {
        var record = _v0;
        return record.DL.Me;
    };
    var $author$project$Api$Common$Invoice$Summary$byCategory = function(_v0) {
        var record = _v0;
        return record.Kz;
    };
    var $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows = function(_v0) {
        var record = _v0;
        return record.U4.Zc;
    };
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName = function(_v0) {
        var record = _v0;
        return record.K1;
    };
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$count = function(_v0) {
        var record = _v0;
        return record.Me;
    };
    var $author$project$Ui$Typography$Subtotal = {
        $: 23
    };
    var $author$project$Ui$Typography$subtotal = $author$project$Ui$Typography$Subtotal;
    var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine = F2(function(model, nonMembershipAdjustmentLineRow) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    model.BE ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$info,
                        $author$project$Ui$Typography$subtotal
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Unassigned', $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName(nonMembershipAdjustmentLineRow)))
                    ])) : A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Unassigned', $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$categoryName(nonMembershipAdjustmentLineRow)))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'charge', $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$count(nonMembershipAdjustmentLineRow)))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$numeric
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$Row$amountInCents(nonMembershipAdjustmentLineRow)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonRecurringSummary = F2(function(summary, model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                var nonMembershipAdjustmentLines = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows, $author$project$Api$Common$Invoice$Summary$byCategory(summary)));
                return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine(model), nonMembershipAdjustmentLines));
            }()
        ]));
    });
    var $author$project$Components$Invoice$Summary$OtherChargesSummary$ToggleShowGroupCharges = 0;
    var $author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines = function(_v0) {
        var record = _v0;
        return record.U4;
    };
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalAmountInCents = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, 0, record.DL.Jh);
    };
    var $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount = function(_v0) {
        var record = _v0;
        return record.DL.Me;
    };
    var $author$project$Components$Invoice$Summary$OtherChargesSummary$viewRecurringSummary = F2(function(summary, model) {
        var _v0 = model.gS ? _Utils_Tuple2($author$project$Ui$Icon$minus, 'Hide group charges') : _Utils_Tuple2($author$project$Ui$Icon$add, 'Show group charges');
        var icon = _v0.a;
        var ariaLabel = _v0.b;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount($author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary)) > 0 ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: ariaLabel
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick(0),
                                $author$project$Ui$Button$icon(icon)
                            ]), _List_Nil),
                            $author$project$Utils$Html$noBreakSpace,
                            A2($author$project$Ui$Typography$strong, _List_fromArray([
                                $author$project$Ui$Typography$info
                            ]), _List_fromArray([
                                $elm$html$Html$text('Other Charges')
                            ]))
                        ]))
                    ])),
                    model.gS ? $author$project$Ui$Grid$none : A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'charge', $author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalCount($author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary))))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$numeric
                        ]), _List_fromArray([
                            model.gS ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Common$Invoice$Summary$NonMembershipAdjustmentLines$totalAmountInCents($author$project$Api$Common$Invoice$Summary$nonMembershipAdjustmentLines(summary))))
                            ]))
                        ]))
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty,
            function() {
                if (model.gS) {
                    var nonMembershipAdjustmentLines = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Invoice$Summary$ByCategory$nonMembershipAdjustmentLinesRows, $author$project$Api$Common$Invoice$Summary$byCategory(summary)));
                    return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonMembershipAdjustmentLine(model), nonMembershipAdjustmentLines));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Invoice$Summary$OtherChargesSummary$view = F2(function(summary, model) {
        return model.BE ? A2($author$project$Components$Invoice$Summary$OtherChargesSummary$viewRecurringSummary, summary, model) : A2($author$project$Components$Invoice$Summary$OtherChargesSummary$viewNonRecurringSummary, summary, model);
    });
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$companyName = function(_v0) {
        var record = _v0;
        return record.LN;
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count = function(_v0) {
        var record = _v0;
        return record.Me;
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$divisionName = function(_v0) {
        var record = _v0;
        return record.Oc;
    };
    var $author$project$Components$Invoice$Summary$groupName = F5(function(groupBy_, activeLineRow, divisionName, planName, companyName) {
        switch(groupBy_){
            case 1:
                return A2($elm$core$Maybe$withDefault, 'No Division', divisionName(activeLineRow));
            case 0:
                return A2($elm$core$Maybe$withDefault, 'No Plan', planName(activeLineRow));
            default:
                return A2($elm$core$Maybe$withDefault, 'No Sponsor', companyName(activeLineRow));
        }
    });
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents = function(_v0) {
        var record = _v0;
        return record.Vb;
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$planName = function(_v0) {
        var record = _v0;
        return record.WM;
    };
    var $author$project$Components$Invoice$Summary$viewActiveLine = F3(function(companyType_, groupBy_, activeLineRow) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$info,
                        $author$project$Ui$Typography$subtotal
                    ]), _List_fromArray([
                        $elm$html$Html$text(A5($author$project$Components$Invoice$Summary$groupName, groupBy_, activeLineRow, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$divisionName, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$planName, $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$companyName))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count(activeLineRow) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, A2($author$project$Formatters$String$affiliateMember, 'employee', companyType_), $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$count(activeLineRow))),
                        $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents(activeLineRow) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(' and '),
                            $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'dependent', $author$project$Api$Common$Invoice$Summary$ActiveLines$Row$numberOfDependents(activeLineRow)))
                        ])) : $author$project$Utils$Html$empty
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$numeric
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Common$Invoice$Summary$ActiveLines$Row$amountInCents(activeLineRow)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$Summary$GroupByUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$viewGroupByButton = F3(function(currentGroupBy, groupBy_, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentGroupBy, groupBy_)),
            $author$project$Ui$Button$onClick($author$project$Components$Invoice$Summary$GroupByUpdated(groupBy_))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Invoice$Summary$viewGroupByButtonGroup = function(model) {
        var summary = model.$x;
        var _v0 = model.fQ;
        if (!_v0.$) {
            var groupBy_ = _v0.a;
            return $author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(model.acy) && $author$project$Components$Invoice$Summary$companyUsesEmployeeDivisions(model.acy) && $elm$core$List$isEmpty($author$project$Api$Common$Invoice$Summary$sponsorFeeDealLines(summary)) ? A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$pull(1)
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 0, 'By Plan'),
                    A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 1, 'By Division')
                ]))
            ])) : $author$project$Components$Invoice$Summary$companyAllowCustomMembershipPlan(model.acy) && A3($author$project$Components$Invoice$Summary$showSponsorBreakdown, model.RL, model.Z$, model.acy) ? A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$pull(1)
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 0, 'By Plan'),
                    A3($author$project$Components$Invoice$Summary$viewGroupByButton, groupBy_, 2, 'By Sponsor')
                ]))
            ])) : $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$companyName = function(_v0) {
        var record = _v0;
        return record.LN;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$count = function(_v0) {
        var record = _v0;
        return record.Me;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$divisionName = function(_v0) {
        var record = _v0;
        return record.Oc;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges = function(_v0) {
        var record = _v0;
        return record.Vd;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges = function(_v0) {
        var record = _v0;
        return record.Ve;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$planName = function(_v0) {
        var record = _v0;
        return record.WM;
    };
    var $author$project$Components$Invoice$Summary$viewMembershipAdjustmentLine = F2(function(groupBy_, membershipAdjustmentLineRow) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$info,
                        $author$project$Ui$Typography$subtotal
                    ]), _List_fromArray([
                        $elm$html$Html$text(A5($author$project$Components$Invoice$Summary$groupName, groupBy_, membershipAdjustmentLineRow, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$divisionName, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$planName, $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$companyName))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow))),
                        $elm$html$Html$text(' manual')
                    ])) : $author$project$Utils$Html$empty,
                    $author$project$Utils$Html$noBreakSpace,
                    $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfOtherCharges(membershipAdjustmentLineRow) > 0 && $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow))),
                        $elm$html$Html$text('and ')
                    ])) : $author$project$Utils$Html$empty,
                    $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$numberOfMembershipCharges(membershipAdjustmentLineRow))),
                        $elm$html$Html$text(' automated')
                    ])) : $author$project$Utils$Html$empty,
                    $author$project$Utils$Html$noBreakSpace,
                    $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$count(membershipAdjustmentLineRow) === 1 ? $elm$html$Html$text('adjustment') : $elm$html$Html$text('adjustments')
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$numeric
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$Row$amountInCents(membershipAdjustmentLineRow)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$Summary$ToggleShowGroupAdjustments = {
        $: 2
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalAmountInCents = function(_v0) {
        var record = _v0;
        return record.DL.Jh;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges = function(_v0) {
        var record = _v0;
        return record.DL.Vd;
    };
    var $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges = function(_v0) {
        var record = _v0;
        return record.DL.Ve;
    };
    var $author$project$Components$Invoice$Summary$viewMembershipAdjustmentSummary = F2(function(model, summary) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        function() {
                            var _v0 = model.fQ;
                            if (!_v0.$) return A3($author$project$Ui$Button$view, {
                                abP: 'Show group adjustments'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$Summary$ToggleShowGroupAdjustments),
                                $author$project$Ui$Button$icon(model.gR ? $author$project$Ui$Icon$minus : $author$project$Ui$Icon$add)
                            ]), _List_Nil);
                            else return $author$project$Utils$Html$empty;
                        }(),
                        A2($author$project$Ui$Typography$strong, _List_fromArray([
                            $author$project$Ui$Typography$info
                        ]), _List_fromArray([
                            $elm$html$Html$text(' Membership Adjustments')
                        ]))
                    ]))
                ])),
                model.gR ? $author$project$Ui$Grid$none : A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)))),
                            $elm$html$Html$text(' manual')
                        ])) : $author$project$Utils$Html$empty,
                        $author$project$Utils$Html$noBreakSpace,
                        $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfOtherCharges($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0 && $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0 ? $elm$html$Html$text('and ') : $author$project$Utils$Html$empty,
                        $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalNumberOfMembershipCharges($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)))),
                            $elm$html$Html$text(' automated')
                        ])) : $author$project$Utils$Html$empty,
                        $author$project$Utils$Html$noBreakSpace,
                        $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) === 1 ? $elm$html$Html$text('adjustment') : $elm$html$Html$text('adjustments')
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$numeric
                    ]), _List_fromArray([
                        model.gR ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalAmountInCents($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary))))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$Summary$ShowDeltaModal = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$ToggleShowGroups = {
        $: 1
    };
    var $author$project$Api$Common$Invoice$Summary$activeLines = function(_v0) {
        var record = _v0;
        return record.It;
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalAmountInCents = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, 0, record.DL.Jh);
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount = function(_v0) {
        var record = _v0;
        return record.DL.Me;
    };
    var $author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, 0, record.DL.Vb);
    };
    var $author$project$Ui$Icon$TrendingDown = 69;
    var $author$project$Ui$Icon$trendingDown = $author$project$Ui$Icon$viewIcon(69);
    var $author$project$Ui$Icon$TrendingUp = 68;
    var $author$project$Ui$Icon$trendingUp = $author$project$Ui$Icon$viewIcon(68);
    var $author$project$Components$Invoice$Summary$viewRecurringSummary = function(model) {
        var summary = model.$x;
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        function() {
                            var _v0 = model.fQ;
                            if (!_v0.$) return A3($author$project$Ui$Button$view, {
                                abP: 'Toggle group visibility'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$Summary$ToggleShowGroups),
                                $author$project$Ui$Button$icon(model.gT ? $author$project$Ui$Icon$minus : $author$project$Ui$Icon$add)
                            ]), _List_Nil);
                            else return $author$project$Utils$Html$empty;
                        }(),
                        A2($author$project$Ui$Typography$strong, _List_fromArray([
                            $author$project$Ui$Typography$info
                        ]), _List_fromArray([
                            $elm$html$Html$text(' Current Period')
                        ]))
                    ]))
                ])),
                model.gT ? $author$project$Ui$Grid$none : A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), function() {
                    if ($author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount($author$project$Api$Common$Invoice$Summary$activeLines(summary)) > 0) {
                        var companyType_ = $author$project$Components$Invoice$Summary$companyType(model.acy);
                        return _List_fromArray([
                            $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, A2($author$project$Formatters$String$affiliateMember, 'employee', companyType_), $author$project$Api$Common$Invoice$Summary$ActiveLines$totalCount($author$project$Api$Common$Invoice$Summary$activeLines(summary)))),
                            $author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents($author$project$Api$Common$Invoice$Summary$activeLines(summary)) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(' and '),
                                $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'dependent', $author$project$Api$Common$Invoice$Summary$ActiveLines$totalNumberOfDependents($author$project$Api$Common$Invoice$Summary$activeLines(summary))))
                            ])) : $author$project$Utils$Html$empty
                        ]);
                    } else return _List_Nil;
                }()),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    function() {
                        var _v1 = model.xf;
                        if (_v1.$ === 3) {
                            var delta = _v1.a;
                            return $elm$core$List$isEmpty($author$project$Api$Common$Invoice$Delta$added(delta)) && $elm$core$List$isEmpty($author$project$Api$Common$Invoice$Delta$removed(delta)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$core$List$isEmpty($author$project$Api$Common$Invoice$Delta$added(delta)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$success
                                ]), _List_fromArray([
                                    $author$project$Ui$Icon$trendingUp(_List_Nil),
                                    $elm$html$Html$text($elm$core$String$fromInt($elm$core$List$length($author$project$Api$Common$Invoice$Delta$added(delta)))),
                                    $elm$html$Html$text(' added')
                                ])),
                                $elm$core$List$isEmpty($author$project$Api$Common$Invoice$Delta$removed(delta)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$danger,
                                    $author$project$Ui$Typography$margin(10)
                                ]), _List_fromArray([
                                    $author$project$Ui$Icon$trendingDown(_List_Nil),
                                    $elm$html$Html$text($elm$core$String$fromInt($elm$core$List$length($author$project$Api$Common$Invoice$Delta$removed(delta)))),
                                    $elm$html$Html$text(' removed')
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'See changes'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$margin(10),
                                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$Summary$ShowDeltaModal(delta))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('See changes')
                                ]))
                            ]));
                        } else return $author$project$Ui$Spinner$view(_List_fromArray([
                            $author$project$Ui$Spinner$small
                        ]));
                    }()
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$numeric
                    ]), _List_fromArray([
                        model.gT ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Common$Invoice$Summary$ActiveLines$totalAmountInCents($author$project$Api$Common$Invoice$Summary$activeLines(summary))))
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Components$Invoice$Summary$viewSummary = function(model) {
        var summary = model.$x;
        var recurring = $author$project$Api$Invoice$One$recurring(model.RA);
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Components$Invoice$Summary$viewGroupByButtonGroup(model),
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Summary')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, recurring ? $author$project$Components$Invoice$Summary$viewRecurringSummary(model) : _List_Nil),
                function() {
                    var _v0 = _Utils_Tuple2(model.fQ, model.gT);
                    if (!_v0.a.$ && _v0.b) {
                        var groupBy_ = _v0.a.a;
                        var companyType_ = $author$project$Components$Invoice$Summary$companyType(model.acy);
                        return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, A2($author$project$Components$Invoice$Summary$viewActiveLine, companyType_, groupBy_), A2($author$project$Components$Invoice$Summary$activeLinesFor, summary, groupBy_)));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Api$Common$Invoice$Summary$MembershipAdjustmentLines$totalCount($author$project$Api$Common$Invoice$Summary$membershipAdjustmentLines(summary)) > 0 ? A2($author$project$Components$Invoice$Summary$viewMembershipAdjustmentSummary, model, summary) : $author$project$Utils$Html$empty,
                function() {
                    var _v1 = _Utils_Tuple2(model.fQ, model.gR);
                    if (!_v1.a.$ && _v1.b) {
                        var groupBy_ = _v1.a.a;
                        return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Invoice$Summary$viewMembershipAdjustmentLine(groupBy_), A2($author$project$Components$Invoice$Summary$membershipAdjustmentLinesFor, summary, groupBy_)));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($elm$html$Html$map, $author$project$Components$Invoice$Summary$OtherChargesSummaryMsg, A2($author$project$Components$Invoice$Summary$OtherChargesSummary$view, summary, model.rN)),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(3)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$strong, _List_fromArray([
                                $author$project$Ui$Typography$info
                            ]), _List_fromArray([
                                $elm$html$Html$text('Total')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(7),
                            $author$project$Ui$Grid$justifyRight
                        ]), $author$project$Api$Invoice$One$discountSavingsInCents(model.RA) > 0 ? _List_fromArray([
                            A2($author$project$Ui$Badge$view, _List_fromArray([
                                $author$project$Ui$Badge$success
                            ]), _List_fromArray([
                                $elm$html$Html$text('Membership Savings: '),
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Invoice$One$discountSavingsInCents(model.RA)))
                            ]))
                        ]) : _List_Nil),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$numeric,
                                $author$project$Ui$Typography$bold
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Common$Invoice$Summary$AllLines$totalAmountInCents($author$project$Api$Common$Invoice$Summary$allLines(summary))))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Invoice$Summary$view = function(_v0) {
        var model = _v0;
        var recurring = $author$project$Api$Invoice$One$recurring(model.RA);
        return recurring ? $author$project$Components$Invoice$Summary$viewSummary(model) : $author$project$Api$Common$Invoice$Summary$AllLines$count($author$project$Api$Common$Invoice$Summary$allLines(model.$x)) > 0 ? $author$project$Components$Invoice$Summary$viewSummary(model) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Invoice$DownloadFile$Label = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$DownloadFile$label = function(str) {
        return $author$project$Components$Invoice$DownloadFile$Label(str);
    };
    var $author$project$Components$Invoice$DownloadFile$Tooltip = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$DownloadFile$tooltip = function(bool) {
        return $author$project$Components$Invoice$DownloadFile$Tooltip(bool);
    };
    var $author$project$Components$Invoice$viewDownloadUnavailableWarningModal = function(_v0) {
        var showDownloadUnavailableWarningModal = _v0.on;
        var invoice = _v0.RA;
        var downloadInvoice = _v0.it;
        var _v1 = _Utils_Tuple2(invoice, showDownloadUnavailableWarningModal);
        if (_v1.a.$ === 3 && _v1.b) {
            var _v2 = _v1.a;
            var invoice_ = _v2.a;
            return A3($author$project$Ui$Modal$view, $author$project$Components$Invoice$DownloadUnavailableModalClosed, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Can not export to PDF')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('The PDF file for this invoice would be more than 50 pages long and cannot be generated. Please download the summary only as a pdf and then export the charge details to excel.')
                    ]))
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel download'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$Invoice$DownloadUnavailableModalClosed)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($elm$html$Html$map, $author$project$Components$Invoice$DownloadInvoiceMsg, A4($author$project$Components$Invoice$DownloadFile$view, downloadInvoice, $author$project$Api$Invoice$One$securePdfInlineToken(invoice_), _List_fromArray([
                        $author$project$Components$Invoice$DownloadFile$label('Download Summary'),
                        $author$project$Components$Invoice$DownloadFile$tooltip(false)
                    ]), _List_fromArray([
                        $author$project$Ui$Button$primary
                    ])))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Invoice$DownloadFile$UnavailableOptionClicked = {
        $: 5
    };
    var $author$project$Components$Invoice$DownloadFile$viewDownloadOption = function(_v0) {
        var token = _v0.a;
        var option = _v0.b;
        var action = option.abS ? $author$project$Components$Invoice$DownloadFile$DownloadFileClicked(token) : $author$project$Components$Invoice$DownloadFile$UnavailableOptionClicked;
        return A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect(action)
        ]), $elm$html$Html$text(option.aeI));
    };
    var $author$project$Components$Invoice$DownloadFile$viewDropdown = F2(function(model, options) {
        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$placement(0)
        ]), 'Download or print PDF', _List_fromArray([
            A4($author$project$Ui$Dropdown$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Export to PDF '),
                $author$project$Ui$Icon$export(_List_Nil)
            ]), A2($elm$core$List$map, $author$project$Components$Invoice$DownloadFile$viewDownloadOption, options), model.fD),
            model.Sk ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$exportCsvPath = F2(function(apiClient, model) {
        var path = A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invoice_lines'
        ]), function() {
            var _v0 = model.RL;
            if (!_v0.$) {
                var id = _v0.b;
                return $author$project$Api$Provider$AffiliateBill$affiliateBillPath(id);
            } else {
                var companyId_ = _v0.a;
                var id = _v0.b;
                return A3($author$project$Api$Company$Invoice$invoicePath, model.Z$, companyId_, id);
            }
        }());
        return A4($author$project$Api$Data$downloadUrl, apiClient, path, 0, _List_Nil);
    });
    var $author$project$Components$Invoice$InvoiceLinesTable$viewExportButton = F3(function(client, label, model) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? A3($author$project$Ui$Tooltip$view, _List_Nil, 'Export to Excel', _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportFileMsg, A3($author$project$Components$FileLink$view, {
                Li: client,
                PX: 0,
                aaT: A2($author$project$Components$Invoice$InvoiceLinesTable$exportCsvPath, client, model)
            }, _List_fromArray([
                $author$project$Ui$Link$buttonDefault,
                $author$project$Ui$Link$icon($author$project$Ui$Icon$export)
            ]), _List_fromArray([
                $elm$html$Html$text('Export to Excel')
            ])))
        ])) : A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTable$ExportCsvMsg, A2($author$project$Components$ExportCsv$customButton, _List_Nil, _List_fromArray([
            $elm$html$Html$text(label)
        ])));
    });
    var $author$project$Api$Provider$IntegrationRecord$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$IntegrationRecord$Shared$errorMessage(shared);
    };
    var $author$project$Api$Provider$IntegrationRecord$All$errorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$errorMessage(one);
    };
    var $author$project$Api$Provider$IntegrationRecord$All$integration = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$integration(one);
    };
    var $author$project$Api$Provider$IntegrationRecord$Shared$integrationLastSyncedAt = function(_v0) {
        var record = _v0;
        return record.Rp;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$integrationLastSyncedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$IntegrationRecord$Shared$integrationLastSyncedAt(shared);
    };
    var $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$integrationLastSyncedAt(one);
    };
    var $author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$integrationSyncStatus(one);
    };
    var $author$project$Api$Provider$IntegrationRecord$Shared$unsyncedReason = function(_v0) {
        var record = _v0;
        return record.aaJ;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$unsyncedReason = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$IntegrationRecord$Shared$unsyncedReason(shared);
    };
    var $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$unsyncedReason(one);
    };
    var $author$project$Components$Invoice$viewIntegrationRecord = F2(function(timeFormatter, record) {
        var unsyncedReason = function() {
            var _v2 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
            if (!_v2.$) {
                var reason = _v2.a;
                return A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('ml-1')
                ]), _List_fromArray([
                    $elm$html$Html$text(reason)
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        var lastSyncedAt = function() {
            var _v1 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
            if (!_v1.$) {
                var time = _v1.a;
                return A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('ml-1')
                ]), _List_fromArray([
                    $elm$html$Html$text('on ' + A2(timeFormatter, 0, time))
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$name($author$project$Api$Provider$IntegrationRecord$All$integration(record));
        var errorMessage = function() {
            var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
            if (!_v0.$) {
                var message = _v0.a;
                return A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('ml-1')
                ]), _List_fromArray([
                    $elm$html$Html$text(message)
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        var additionalInfo = A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('form-control-static'),
            $elm$html$Html$Attributes$class('text-muted')
        ]), _List_fromArray([
            unsyncedReason,
            errorMessage,
            lastSyncedAt
        ]));
        return A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
            $author$project$Ui$Form$Group$label(integrationName),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsStart
                ]), _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$IntegrationRecord$Status$toString($author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record)))
                ])),
                additionalInfo
            ]))
        ]));
    });
    var $author$project$Components$Invoice$viewIntegrationRecords = F2(function(formatter, response) {
        if (response.$ === 3) {
            var integrationRecords = response.a;
            return A2($elm$core$List$map, $author$project$Components$Invoice$viewIntegrationRecord(formatter), integrationRecords);
        } else return _List_Nil;
    });
    var $author$project$Components$Invoice$EditDateButtonClicked = {
        $: 29
    };
    var $author$project$Components$Invoice$editDateButton = F4(function(buttonText, recurring, status, message) {
        return !recurring && $author$project$Api$Invoice$Status$isDraft(status) ? A3($author$project$Ui$Button$view, {
            abP: buttonText
        }, _List_fromArray([
            $author$project$Ui$Button$onClick(message),
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
        ]), _List_fromArray([
            $elm$html$Html$text(buttonText)
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$Invoice$One$periodInMonths = function(_v0) {
        var record = _v0.b;
        return record.WA;
    };
    var $author$project$Api$Invoice$One$periodInMonths = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$periodInMonths(invoice_);
        } else return 0;
    };
    var $author$project$Components$Invoice$formatInvoiceDate = F2(function(invoice, recurring) {
        return _List_fromArray([
            recurring ? $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, $author$project$Api$Invoice$One$invoiceDate(invoice))) : $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Invoice$One$invoiceDate(invoice))),
            $author$project$Api$Invoice$One$periodInMonths(invoice) > 1 && recurring ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(' - '),
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, A3($justinmimbs$date$Date$add, 1, $author$project$Api$Invoice$One$periodInMonths(invoice) - 1, $author$project$Api$Invoice$One$invoiceDate(invoice))))
            ])) : $author$project$Utils$Html$empty
        ]);
    });
    var $author$project$Components$Invoice$viewInvoiceDate = F3(function(invoice, showDateInput, fields) {
        var status = $author$project$Api$Invoice$One$humanStatus(invoice);
        var recurring = $author$project$Api$Invoice$One$recurring(invoice);
        return A2($author$project$Ui$Form$Group$view, recurring ? _List_fromArray([
            $author$project$Ui$Form$Group$label('Invoice Period'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$clearfix
        ]) : _List_fromArray([
            $author$project$Ui$Form$Group$label('Invoice Date'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$clearfix
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                function() {
                    if (showDateInput) return A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceDateInputMsg(fields.mD), A2($author$project$Components$DateInput$view, _List_fromArray([
                            $author$project$Components$DateInput$value($elm$core$Maybe$Just(fields.RG))
                        ]), fields.mD))
                    ]));
                    else {
                        var dateWidth = recurring ? 6 : 3;
                        return A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(dateWidth)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$strong, _List_Nil, A2($author$project$Components$Invoice$formatInvoiceDate, invoice, recurring))
                            ]))
                        ]));
                    }
                }(),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A4($author$project$Components$Invoice$editDateButton, 'Edit Invoice Date', recurring, status, $author$project$Components$Invoice$EditDateButtonClicked)
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$EditDueDateButtonClicked = {
        $: 31
    };
    var $author$project$Components$Invoice$viewInvoiceDueDate = F3(function(invoice, showDueDateInput, fields) {
        var status = $author$project$Api$Invoice$One$humanStatus(invoice);
        var recurring = $author$project$Api$Invoice$One$recurring(invoice);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Due On'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$clearfix
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                showDueDateInput ? A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceDueDateInputMsg(fields.mE), A2($author$project$Components$DateInput$view, _List_fromArray([
                        $author$project$Components$DateInput$value($elm$core$Maybe$Just(fields.iY))
                    ]), fields.mE))
                ])) : A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Invoice$One$dueDate(invoice)))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A4($author$project$Components$Invoice$editDateButton, 'Edit Due Date', recurring, status, $author$project$Components$Invoice$EditDueDateButtonClicked)
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$Issue = {
        $: 20
    };
    var $author$project$Api$Provider$Invoice$One$viewingAsAffiliate = function(_v0) {
        var record = _v0.b;
        return record.abd;
    };
    var $author$project$Api$Invoice$One$viewingAsAffiliate = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$viewingAsAffiliate(invoice_);
        } else return false;
    };
    var $author$project$Components$Invoice$viewIssueButton = F2(function(model, invoice) {
        var meta = $author$project$Api$Invoice$One$meta(invoice);
        return $author$project$Api$Invoice$Meta$issueAction(meta) && !$author$project$Api$Invoice$One$viewingAsAffiliate(invoice) ? A3($author$project$Ui$Button$view, {
            abP: 'Issue invoice'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Components$Invoice$Issue),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
        ]), _List_fromArray([
            $author$project$Components$Invoice$isNetwork(model.acy) ? $elm$html$Html$text('Approve ') : $elm$html$Html$text('Issue '),
            $elm$html$Html$text('Invoice')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Employer$Invoice$One$willAutoPay = function(_v0) {
        var record = _v0.b;
        return record.abt;
    };
    var $author$project$Api$Provider$Invoice$One$willAutoPay = function(_v0) {
        var record = _v0.b;
        return record.abt;
    };
    var $author$project$Api$Invoice$One$willAutoPay = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$One$willAutoPay(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$One$willAutoPay(invoice_);
        }
    };
    var $author$project$Components$Invoice$view = F2(function(apiClient, _v0) {
        var model = _v0;
        return _List_fromArray([
            function() {
                var _v1 = model.tG;
                if (!_v1.$) {
                    var invoice = _v1.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Invoice$VoidHiConfirmClosed(invoice), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('void'),
                        $author$project$Components$HiConfirm$noun('Invoice #' + $elm$core$String$fromInt($author$project$Api$Invoice$One$invoiceNumber(invoice))),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v2 = model.eC;
                if (!_v2.$) {
                    var invoice = _v2.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Invoice$ReturnToDraftHiConfirmClosed(invoice), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('Return to draft'),
                        $author$project$Components$HiConfirm$noun('Invoice #' + $elm$core$String$fromInt($author$project$Api$Invoice$One$invoiceNumber(invoice))),
                        $author$project$Components$HiConfirm$detail('which will also delete the current draft invoice if any'),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.eh;
                if (!_v3.$) {
                    var invoice = _v3.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Invoice$MarkAsBadDebtHiConfirmClosed(invoice), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('Mark'),
                        $author$project$Components$HiConfirm$noun('Invoice #' + $elm$core$String$fromInt($author$project$Api$Invoice$One$invoiceNumber(invoice))),
                        $author$project$Components$HiConfirm$detail('which will remove it from your outstanding invoices report'),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v4 = model.ib;
                if (!_v4.$) {
                    var invoice = _v4.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Invoice$DeleteHiConfirmClosed(invoice), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('Invoice #' + $elm$core$String$fromInt($author$project$Api$Invoice$One$invoiceNumber(invoice))),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.hQ;
                if (!_v5.$) {
                    var companyEmailModal = _v5.a;
                    return A2($elm$html$Html$map, $author$project$Components$Invoice$CompanyEmailModalMsg, $author$project$Components$CompanyEmailModal$view(companyEmailModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v6 = model.lH;
                if (!_v6.$) {
                    var createPaymentModal = _v6.a;
                    return A2($elm$html$Html$map, $author$project$Components$Invoice$CreatePaymentModalMsg, $author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v7 = model.fU;
                if (!_v7.$) {
                    var invoiceSummary = _v7.a;
                    return A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceSummaryMsg, $author$project$Components$Invoice$Summary$modal(invoiceSummary));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v8 = model.eb;
                if (!_v8.$) {
                    var invoiceLinesTable = _v8.a;
                    return A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceLinesTableMsg, $author$project$Components$Invoice$InvoiceLinesTable$modal(invoiceLinesTable));
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Components$Invoice$viewDownloadUnavailableWarningModal(model),
            A2($elm$html$Html$map, $author$project$Components$Invoice$PaymentsHistoryMsg, $author$project$Components$Invoice$PaymentsHistory$modal(model.js)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, function() {
                    var _v9 = model.RA;
                    if (_v9.$ === 3) {
                        var invoice = _v9.a;
                        var meta = $author$project$Api$Invoice$One$meta(invoice);
                        return _List_fromArray([
                            A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                    A3($author$project$Ui$Link$route, model.Gc, _List_Nil, _List_fromArray([
                                        model.k3 ? $elm$html$Html$text('Bills') : $elm$html$Html$text('Invoices')
                                    ]))
                                ])),
                                A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                    $author$project$Ui$Breadcrumb$active(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Invoice$One$invoiceNumber(invoice)))
                                ]))
                            ]))),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            $author$project$Api$Invoice$One$isUpdating(invoice) ? A2($author$project$Ui$Alert$warning, _List_fromArray([
                                $author$project$Ui$Alert$mb2
                            ]), _List_fromArray([
                                $elm$html$Html$text('We are updating the invoice with recent membership changes. The page will reload when the update completes.')
                            ])) : $author$project$Utils$Html$empty,
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween,
                                $author$project$Ui$Element$itemsStart
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$itemsCenter
                                    ]), _List_fromArray([
                                        $author$project$Ui$Typography$heading(_List_fromArray([
                                            $elm$html$Html$text('Invoice #'),
                                            $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Invoice$One$invoiceNumber(invoice)))
                                        ])),
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$ml2
                                        ]), _List_fromArray([
                                            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$AuditTrailLog$view, $elm$html$Html$map($author$project$Components$Invoice$AuditTrailLogMsg)), model.hB))
                                        ]))
                                    ])),
                                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Invoice$One$amountInCents(invoice))),
                                        $author$project$Utils$Html$noBreakSpace,
                                        $author$project$Api$Invoice$Status$toBadge($author$project$Api$Invoice$One$humanStatus(invoice))
                                    ]))
                                ])),
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$gap2,
                                    $author$project$Ui$Element$justifyRight
                                ]), _List_fromArray([
                                    A2($author$project$Components$Invoice$viewIssueButton, model, invoice),
                                    $author$project$Api$Invoice$Meta$canMakeViewableAction(meta) && !$author$project$Api$Invoice$One$viewingAsAffiliate(invoice) ? A3($author$project$Ui$Tooltip$view, _List_Nil, 'Email Invoice', _List_fromArray([
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Send invoice to employer'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$onClick($author$project$Components$Invoice$MakeViewableAndEmail(invoice)),
                                            $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Send to employer')
                                        ]))
                                    ])) : $author$project$Utils$Html$empty,
                                    $author$project$Api$Invoice$Meta$canNotifyAction(meta) ? A3($author$project$Ui$Tooltip$view, _List_Nil, 'Email Invoice', _List_fromArray([
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Email invoice'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$onClick($author$project$Components$Invoice$Email(invoice)),
                                            $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Email')
                                        ]))
                                    ])) : $author$project$Utils$Html$empty,
                                    function() {
                                        var chargesOptionAvailable = function(count) {
                                            return _Utils_cmp(count, $author$project$Components$Invoice$maxInvoiceLinesForDetailsDownload) < 0;
                                        }(A2($elm$core$Maybe$withDefault, 0, model.yn));
                                        return A2($elm$html$Html$map, $author$project$Components$Invoice$DownloadInvoiceMsg, A2($author$project$Components$Invoice$DownloadFile$viewDropdown, model.it, _List_fromArray([
                                            _Utils_Tuple2($author$project$Api$Invoice$One$securePdfInlineToken(invoice), {
                                                abS: true,
                                                M6: {
                                                    FI: '',
                                                    Gg: ''
                                                },
                                                aeI: 'Summary Only'
                                            }),
                                            _Utils_Tuple2($author$project$Api$Invoice$One$securePdfInlineWithChargeDetailsToken(invoice), {
                                                abS: chargesOptionAvailable,
                                                M6: {
                                                    FI: '',
                                                    Gg: ''
                                                },
                                                aeI: 'Summary and Charges'
                                            })
                                        ])));
                                    }(),
                                    A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, $elm$html$Html$map($author$project$Components$Invoice$InvoiceLinesTableMsg), A2($elm$core$Maybe$map, A2($author$project$Components$Invoice$InvoiceLinesTable$viewExportButton, apiClient, 'Export to Excel'), model.eb)))
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(6)
                                ]), _List_fromArray([
                                    $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                        $author$project$Ui$Form$Group$label('Pay To'),
                                        $author$project$Ui$Form$Group$labelSpan(4),
                                        $author$project$Ui$Form$Group$inputSpan(8)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text($author$project$Api$Practice$name(model.W1))
                                            ])),
                                            function() {
                                                var _v10 = A2($elm$core$Maybe$andThen, $author$project$Api$Common$Phone$Shared$number, $elm$core$List$head($author$project$Api$Practice$phones(model.W1)));
                                                if (!_v10.$) {
                                                    var phoneNumber = _v10.a;
                                                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                                                        $author$project$Ui$Typography$phi(true)
                                                    ]), _List_fromArray([
                                                        $elm$html$Html$text($author$project$Formatters$Phone$format(phoneNumber))
                                                    ]));
                                                } else return $author$project$Utils$Html$empty;
                                            }(),
                                            function() {
                                                var _v11 = $author$project$Api$Practice$address(model.W1);
                                                if (!_v11.$) {
                                                    var address = _v11.a;
                                                    return $author$project$Components$AddressDisplay$view(address);
                                                } else return $author$project$Utils$Html$empty;
                                            }()
                                        ]))
                                    ])) : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                        $author$project$Ui$Form$Group$label('Payer'),
                                        $author$project$Ui$Form$Group$labelSpan(4),
                                        $author$project$Ui$Form$Group$inputSpan(8)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Components$Invoice$companyName(model.acy))),
                                                A2($elm$html$Html$br, _List_Nil, _List_Nil)
                                            ])),
                                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                function() {
                                                    var _v12 = A2($elm$core$Maybe$andThen, $author$project$Api$Common$Phone$Shared$number, $elm$core$List$head($author$project$Components$Invoice$companyPhones(model.acy)));
                                                    if (!_v12.$) {
                                                        var phoneNumber = _v12.a;
                                                        return A2($author$project$Ui$Typography$div, _List_fromArray([
                                                            $author$project$Ui$Typography$phi(true)
                                                        ]), _List_fromArray([
                                                            $elm$html$Html$text($author$project$Formatters$Phone$format(phoneNumber))
                                                        ]));
                                                    } else return $author$project$Utils$Html$empty;
                                                }(),
                                                function() {
                                                    var _v13 = $author$project$Components$Invoice$companyAddress(model.acy);
                                                    if (!_v13.$) {
                                                        var address = _v13.a;
                                                        return $author$project$Components$AddressDisplay$view(address);
                                                    } else return $author$project$Utils$Html$empty;
                                                }()
                                            ]))
                                        ]))
                                    ])),
                                    function() {
                                        var hasActiveInvoice = !A2($elm$core$List$member, $author$project$Api$Invoice$Status$toString($author$project$Api$Invoice$One$humanStatus(invoice)), _List_fromArray([
                                            'draft',
                                            'paid',
                                            'cancelled'
                                        ]));
                                        return hasActiveInvoice ? A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(virtualBankAccountsComponent_) {
                                            var payerName = $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? $author$project$Api$Practice$name(model.W1) : A2($elm$core$Maybe$withDefault, '', $author$project$Components$Invoice$companyName(model.acy));
                                            return A2($elm$html$Html$map, $author$project$Components$Invoice$VirtualBankAccountsComponentMsg, A2($author$project$Components$Company$VirtualBankAccounts$Invoice$view, virtualBankAccountsComponent_, payerName));
                                        }, model.tF)) : $author$project$Utils$Html$empty;
                                    }(),
                                    A2($elm$html$Html$br, _List_Nil, _List_Nil)
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(6)
                                ]), A2($elm$core$List$cons, A3($author$project$Components$Invoice$viewInvoiceDate, invoice, model.om, $author$project$Utils$Form$fields(model.cw)), A2($elm$core$List$cons, A3($author$project$Components$Invoice$viewInvoiceDueDate, invoice, model.oo, $author$project$Utils$Form$fields(model.cw)), A2($elm$core$List$cons, $author$project$Api$Invoice$One$recurring(invoice) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Autopay'),
                                    $author$project$Ui$Form$Group$labelSpan(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$clearfix
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                            $author$project$Api$Invoice$One$willAutoPay(invoice) ? $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Invoice$One$willAutoPay(invoice)) + (', on ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Invoice$One$autoPayDate(invoice))))) : $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Invoice$One$willAutoPay(invoice))),
                                            $author$project$Api$Invoice$One$willAutoPay(invoice) ? $author$project$Utils$Html$empty : A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                                $author$project$Ui$Tooltip$wide
                                            ]), 'We will only try to autopay invoices if the company has a default payment source, autopay is enabled (see \"Invoice Settings\"), and no payment attempts have been made', _List_fromArray([
                                                $author$project$Utils$Html$noBreakSpace,
                                                $author$project$Ui$Icon$help(_List_Nil)
                                            ]))
                                        ]))
                                    ]))
                                ])) : $author$project$Utils$Html$empty, A2($elm$core$List$cons, $author$project$Api$Invoice$One$willAutoPay(invoice) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Payment Source'),
                                    $author$project$Ui$Form$Group$labelSpan(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$clearfix
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                        function() {
                                            var _v14 = $author$project$Api$Invoice$One$source(invoice);
                                            if (!_v14.$) {
                                                var source = _v14.a;
                                                return A2($author$project$Components$PaymentSourceDisplayer$view, model.HO, _List_fromArray([
                                                    $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just($author$project$Api$Source$Source(source))),
                                                    $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                                                    $author$project$Components$PaymentSourceDisplayer$limitedView(true)
                                                ]));
                                            } else return A2($author$project$Ui$Badge$view, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text('none')
                                            ]));
                                        }()
                                    ]))
                                ])) : $author$project$Utils$Html$empty, A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Total Paid'),
                                    $author$project$Ui$Form$Group$labelSpan(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$clearfix
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Invoice$One$paidInCents(invoice)))
                                        ])),
                                        function() {
                                            var _v15 = $author$project$Api$Invoice$One$paidAt(invoice);
                                            if (!_v15.$) {
                                                var paidAt = _v15.a;
                                                return A2($author$project$Ui$Typography$span, _List_fromArray([
                                                    $author$project$Ui$Typography$small
                                                ]), _List_fromArray([
                                                    $author$project$Utils$Html$noBreakSpace,
                                                    $author$project$Api$Invoice$Status$toBadge($author$project$Api$Invoice$One$humanStatus(invoice)),
                                                    $elm$html$Html$text(' on ' + A2(model.HO, 2, paidAt))
                                                ]));
                                            } else return $author$project$Utils$Html$empty;
                                        }()
                                    ])),
                                    A2($elm$html$Html$map, $author$project$Components$Invoice$PaymentsHistoryMsg, A2($author$project$Components$Invoice$PaymentsHistory$view, {
                                        abG: model.F3,
                                        abJ: $author$project$Components$Invoice$isAPractice(model.Z$) && !model.k3,
                                        F3: model.F3,
                                        Wt: $author$project$Api$Invoice$One$payments(invoice),
                                        ahp: $author$project$Components$Invoice$isAPractice(model.Z$)
                                    }, model.js))
                                ])), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Total Due'),
                                    $author$project$Ui$Form$Group$labelSpan(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$clearfix
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Invoice$One$dueInCents(invoice)))
                                        ]))
                                    ]))
                                ])), A2($author$project$Components$Invoice$viewIntegrationRecords, model.HO, model.Rr))))))))
                            ])),
                            function() {
                                var _v16 = model.fU;
                                if (!_v16.$) {
                                    var invoiceSummary = _v16.a;
                                    return A2($elm$html$Html$map, $author$project$Components$Invoice$InvoiceSummaryMsg, $author$project$Components$Invoice$Summary$view(invoiceSummary));
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt2
                            ]), function() {
                                var _v17 = model.eb;
                                if (!_v17.$) {
                                    var invoiceLinesTable = _v17.a;
                                    return A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Invoice$InvoiceLinesTableMsg), A2($author$project$Components$Invoice$InvoiceLinesTable$view, apiClient, invoiceLinesTable));
                                } else return _List_Nil;
                            }())
                        ]);
                    } else return _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]))
                    ]);
                }()),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$justifyCenter
                ]), function() {
                    var _v18 = model.RA;
                    if (_v18.$ === 3) {
                        var invoice = _v18.a;
                        var meta = $author$project$Api$Invoice$One$meta(invoice);
                        return _List_fromArray([
                            function() {
                                if (($author$project$Api$Invoice$Meta$canCancelAction(meta) || $author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta) || $author$project$Api$Invoice$Meta$canMarkAsBadDebtAction(meta) || $author$project$Api$Invoice$Meta$canReverseBadDebtAction(meta)) && !$author$project$Api$Invoice$One$viewingAsAffiliate(invoice)) {
                                    var actions = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                                        $author$project$Api$Invoice$Meta$canCancelAction(meta) ? $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Invoice$Void(invoice))
                                        ]), A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                            $author$project$Ui$Icon$eraser(_List_Nil),
                                            $author$project$Utils$Html$noBreakSpace,
                                            $elm$html$Html$text('Void')
                                        ])))) : $elm$core$Maybe$Nothing,
                                        $author$project$Api$Invoice$Meta$canDraftAndDestroyCurrentDraftAction(meta) ? $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Invoice$ReturnToDraft(invoice))
                                        ]), A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                            $author$project$Ui$Icon$arrowLeft(_List_Nil),
                                            $author$project$Utils$Html$noBreakSpace,
                                            $elm$html$Html$text('Return To Draft')
                                        ])))) : $elm$core$Maybe$Nothing,
                                        $author$project$Api$Invoice$Meta$canMarkAsBadDebtAction(meta) ? $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Invoice$MarkAsBadDebt(invoice))
                                        ]), A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                            $author$project$Ui$Icon$stop(_List_Nil),
                                            $author$project$Utils$Html$noBreakSpace,
                                            $elm$html$Html$text('Bad Debt')
                                        ])))) : $elm$core$Maybe$Nothing,
                                        $author$project$Api$Invoice$Meta$canReverseBadDebtAction(meta) ? $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Invoice$ReverseBadDebt)
                                        ]), A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                            $author$project$Ui$Icon$arrowLeft(_List_Nil),
                                            $author$project$Utils$Html$noBreakSpace,
                                            $elm$html$Html$text('Return To Issued')
                                        ])))) : $elm$core$Maybe$Nothing
                                    ]));
                                    return A4($author$project$Ui$Dropdown$view, _List_fromArray([
                                        $author$project$Ui$Dropdown$disabled(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                                        $author$project$Ui$Dropdown$buttonWarning
                                    ]), _List_fromArray([
                                        $author$project$Ui$Icon$edit(_List_Nil),
                                        $author$project$Utils$Html$noBreakSpace,
                                        $elm$html$Html$text('Revise Invoice')
                                    ]), actions, model.l_);
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            function() {
                                if ($author$project$Api$Invoice$One$isPayable(invoice) && !$author$project$Utils$Maybe$toBool($author$project$Components$Invoice$companyDefaultSource(model.acy)) && !$author$project$Components$Invoice$isNetwork(model.acy) && !$author$project$Api$Invoice$One$viewingAsAffiliate(invoice)) {
                                    var _v19 = model.r2;
                                    if (!_v19.$) {
                                        var paymentSourcesRoute = _v19.a;
                                        return A3($author$project$Ui$Link$route, paymentSourcesRoute, _List_fromArray([
                                            $author$project$Ui$Link$buttonDefault
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Add Payment Source')
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            $author$project$Api$Invoice$Meta$markAsPaidAction(meta) ? A3($author$project$Ui$Button$view, {
                                abP: 'Record payment'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$RecordPayment(invoice)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                            ]), _List_fromArray([
                                $author$project$Components$Invoice$isNetwork(model.acy) ? $elm$html$Html$text('Mark As Paid') : $elm$html$Html$text('Record Payment')
                            ])) : $author$project$Utils$Html$empty,
                            $author$project$Api$Invoice$Meta$createPaymentAction(meta) && !$author$project$Api$Invoice$One$viewingAsAffiliate(invoice) ? A3($author$project$Ui$Button$view, {
                                abP: 'Process payment'
                            }, _List_fromArray([
                                $author$project$Ui$Button$success,
                                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$Pay(invoice)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$dollarSign)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Process Payment')
                            ])) : $author$project$Utils$Html$empty,
                            $author$project$Api$Invoice$Meta$issueAction(meta) && !$author$project$Api$Invoice$One$viewingAsAffiliate(invoice) ? A2($author$project$Components$Invoice$viewIssueButton, model, invoice) : $author$project$Utils$Html$empty,
                            $author$project$Api$Invoice$Meta$canDelete(meta) && !$author$project$Api$Invoice$One$viewingAsAffiliate(invoice) ? A3($author$project$Ui$Button$view, {
                                abP: 'Delete invoice'
                            }, _List_fromArray([
                                $author$project$Ui$Button$danger,
                                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                                $author$project$Ui$Button$onClick($author$project$Components$Invoice$Delete(invoice))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Delete')
                            ])) : $author$project$Utils$Html$empty
                        ]);
                    } else return _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]);
                }())
            ]))
        ]);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$view = function(model) {
        return {
            fb: function() {
                var _v0 = model.fT;
                if (!_v0.$) {
                    var invoiceComponent = _v0.a;
                    return A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$InvoiceComponentMsg), A2($author$project$Components$Invoice$view, model.Ej, invoiceComponent));
                } else return $author$project$Components$LoadingPage$view;
            }(),
            $2: 'Affiliates | Bills'
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$init,
        aeR: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$load,
        ag3: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$save,
        ahE: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$subscriptions,
        aaO: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$update,
        aid: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$view
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$GotAffiliate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var params = _v2.VU;
        return _Utils_Tuple2({
            pr: params.pr,
            Ej: shared.Ej,
            hE: $elm$core$Maybe$Nothing,
            cP: shared.cP,
            Bz: query,
            HO: shared.HO
        }, A3($author$project$Api$Provider$Affiliate$retrieve, shared.Ej, params.pr, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$GotAffiliate));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$subscriptions = function(model) {
        var _v0 = model.hE;
        if (!_v0.$) {
            var billsList = _v0.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg, $author$project$Components$Affiliates$BillsList$subscriptions(billsList));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            if (response.$ === 3) {
                var affiliate = response.a;
                var _v2 = $author$project$Components$Affiliates$BillsList$init({
                    Eb: $elm$core$Maybe$Just(affiliate),
                    Ej: model.Ej,
                    cP: model.cP,
                    Gc: $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
                        pr: model.pr
                    }),
                    Bz: model.Bz,
                    HO: model.HO
                });
                var billsList = _v2.a;
                var billsListCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    hE: $elm$core$Maybe$Just(billsList)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg, billsListCmd), _List_Nil);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var subMsg = msg.a;
            var _v3 = model.hE;
            if (!_v3.$) {
                var billsList = _v3.a;
                var _v4 = A3($author$project$Components$Affiliates$BillsList$update, model.Ej, subMsg, billsList);
                var billsList_ = _v4.a;
                var billsListCmd = _v4.b;
                var billsListOutMsgs = _v4.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    hE: $elm$core$Maybe$Just(billsList_)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg, billsListCmd), billsListOutMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.hE;
                    if (!_v0.$) {
                        var billsList = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$BillsListMsg, $author$project$Components$Affiliates$BillsList$view(billsList));
                    } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]));
                }()
            ]),
            $2: 'Affiliates | Bills'
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$init,
        aeR: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$load,
        ag3: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$save,
        ahE: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$subscriptions,
        aaO: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$update,
        aid: $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$view
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotLocations = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$Location$All$Location = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Affiliates$Location$Min$Location = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Affiliates$Location$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Affiliates$Location$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$Min$Record)));
    var $author$project$Api$Provider$Affiliates$Location$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$Location$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Affiliates$Location$All$Record = F2(function(activeLives, affiliateLocation) {
        return {
            Iu: activeLives,
            IS: affiliateLocation
        };
    });
    var $author$project$Api$Provider$Affiliates$Location$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate_location', $author$project$Api$Provider$Location$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_lives', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$All$Record)));
    var $author$project$Api$Provider$Affiliates$Location$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$Location$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$Location$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Location$All$Location)));
    var $author$project$Api$Provider$Affiliates$Location$locationsPath = function(affiliateId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'locations'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
    };
    var $author$project$Api$Provider$Affiliates$Location$list = F3(function(apiClient, affiliateId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Location$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId)));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations = function(model) {
        return A3($author$project$Api$Provider$Affiliates$Location$list, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotLocations);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotPractitioners = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$Practitioner$All$Practitioner = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Affiliates$Practitioner$All$Record = F4(function(id, name, activeLives, affiliatePractitioner) {
        return {
            Iu: activeLives,
            IV: affiliatePractitioner,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Affiliates$Practitioner$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate_practitioner', $author$project$Api$Provider$Practitioner$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_lives', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Practitioner$All$Record)))));
    var $author$project$Api$Provider$Affiliates$Practitioner$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$Practitioner$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Affiliates$Practitioner$practitionersPath = function(affiliateId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'practitioners'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
    };
    var $author$project$Api$Provider$Affiliates$Practitioner$list = F3(function(apiClient, affiliateId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Practitioner$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId)));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners = function(model) {
        return A3($author$project$Api$Provider$Affiliates$Practitioner$list, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$GotPractitioners);
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$Closed = {
        $: 0
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$init = $author$project$Components$Affiliates$LinkRecordsModal$Closed;
    var $author$project$Components$Affiliates$UnlinkRecordsModal$Closed = {
        $: 0
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$init = $author$project$Components$Affiliates$UnlinkRecordsModal$Closed;
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        var model = {
            pr: params.pr,
            Ej: shared.Ej,
            aeb: shared.aeb,
            mU: $author$project$Components$Affiliates$LinkRecordsModal$init,
            Tq: $author$project$Api$Data$Loading,
            W1: practice,
            Xc: $author$project$Api$Data$Loading,
            Z$: session,
            kr: $elm$core$Maybe$Nothing,
            o_: $author$project$Components$Affiliates$UnlinkRecordsModal$init,
            H1: A2($author$project$Utils$User$isViewingAsHinter, session, shared.aeb)
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model),
            $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model)
        ])));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$CloseModal = {
        $: 5
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$subscriptions = function(model) {
        if (model.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$LinkRecordsModal$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Affiliates$SyncPatientsModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Affiliates$SyncPatientsModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$SyncPatientsModal$CloseModal);
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal = {
        $: 1
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions = function(model) {
        if (model.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg, $author$project$Components$Affiliates$LinkRecordsModal$subscriptions(model.mU)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Affiliates$SyncPatientsModal$subscriptions, model.kr))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg, $author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions(model.o_))
        ]));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkedAllProviders = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Affiliates$SyncPatientsModal$Skip = 1;
    var $author$project$Components$Affiliates$SyncPatientsModal$init = function(affiliateId) {
        return {
            D7: 1,
            kR: $author$project$Api$Data$NotAsked,
            pr: affiliateId
        };
    };
    var $author$project$Api$Provider$Affiliate$linkAllProviders = F3(function(apiClient, affiliateId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'link_all_practitioners'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId))));
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliateLocations = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliatePractitioners = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkLocations = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkPractitioners = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$Linked = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$LocationLinked = 2;
    var $author$project$Components$Affiliates$LinkRecordsModal$None = 0;
    var $author$project$Components$Affiliates$LinkRecordsModal$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$PractitionerLinked = 1;
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$id(min);
    };
    var $author$project$Api$Provider$Practitioner$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Practitioner$Affiliate$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Practitioner$Min$id(min);
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$formFieldsUpdate = F3(function(model, field, fields) {
        switch(field.$){
            case 0:
                var id = field.a;
                var affiliatePractitioners = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.pt));
                return _Utils_update(fields, {
                    IV: A2($elm_community$list_extra$List$Extra$find, function(practitioner) {
                        return _Utils_eq($author$project$Api$Provider$Practitioner$Affiliate$id(practitioner), id);
                    }, affiliatePractitioners)
                });
            case 1:
                var id = field.a;
                var affiliateLocations = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.ps));
                return _Utils_update(fields, {
                    IS: A2($elm_community$list_extra$List$Extra$find, function(location1) {
                        return _Utils_eq($author$project$Api$Provider$Affiliates$AffiliateLocation$All$id(location1), id);
                    }, affiliateLocations)
                });
            case 2:
                var id = field.a;
                var networkPractitioners = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.ry));
                return _Utils_update(fields, {
                    rx: A2($elm_community$list_extra$List$Extra$find, function(practitioner) {
                        return _Utils_eq($author$project$Api$Provider$Practitioner$All$id(practitioner), id);
                    }, networkPractitioners)
                });
            case 3:
                var id = field.a;
                var networkLocations = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.rw));
                return _Utils_update(fields, {
                    rv: A2($elm_community$list_extra$List$Extra$find, function(location1) {
                        return _Utils_eq($author$project$Api$Provider$Location$All$id(location1), id);
                    }, networkLocations)
                });
            default:
                var value = field.a;
                return _Utils_update(fields, {
                    th: value
                });
        }
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocationValidation = 1;
    var $author$project$Components$Affiliates$LinkRecordsModal$validateAffiliateLocation = F2(function(resource, fields) {
        var _v0 = _Utils_Tuple2(resource, fields.IS);
        if (_v0.a === 1 && _v0.b.$ === 1) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            return _List_fromArray([
                _Utils_Tuple2(1, 'Please pick a location.')
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitionerValidation = 0;
    var $author$project$Components$Affiliates$LinkRecordsModal$validateAffiliatePractitioner = F2(function(resource, fields) {
        var _v0 = _Utils_Tuple2(resource, fields.IV);
        if (!_v0.a && _v0.b.$ === 1) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            return _List_fromArray([
                _Utils_Tuple2(0, 'Please pick a practitioner.')
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$formFieldsValidator = function(resource) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$LinkRecordsModal$validateAffiliatePractitioner(resource)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$LinkRecordsModal$validateAffiliateLocation(resource))
        ]));
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$initFormFields = function(userIsHinter) {
        return {
            IS: $elm$core$Maybe$Nothing,
            IV: $elm$core$Maybe$Nothing,
            rv: $elm$core$Maybe$Nothing,
            rx: $elm$core$Maybe$Nothing,
            th: userIsHinter
        };
    };
    var $author$project$Api$Provider$Affiliates$Location$link = F5(function(apiClient, affiliateId, affiliateLocationId, networkLocationId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('network_location_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, networkLocationId)),
            _Utils_Tuple2('affiliate_location_id', $elm$json$Json$Encode$string(affiliateLocationId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId))));
    });
    var $author$project$Api$Provider$Affiliates$Practitioner$link = F6(function(apiClient, affiliateId, affiliatePractitionerId, networkPractitionerId, syncToRentalNetworks, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('network_practitioner_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, networkPractitionerId)),
            _Utils_Tuple2('affiliate_practitioner_id', $elm$json$Json$Encode$string(affiliatePractitionerId)),
            _Utils_Tuple2('sync_to_rental_networks', $elm$json$Json$Encode$bool(syncToRentalNetworks))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId))));
    });
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$affiliateLocationsPath = function(affiliateId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'affiliate_locations'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
    };
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$AffiliateLocation = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$AffiliateLocation = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$Min$Record)));
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$Record = function(synced) {
        return {
            $I: synced
        };
    };
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'synced', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$All$Record));
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$AffiliateLocation$All$AffiliateLocation)));
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$list = F3(function(apiClient, affiliateId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$AffiliateLocation$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$AffiliateLocation$affiliateLocationsPath(affiliateId)));
    });
    var $author$project$Api$Provider$Affiliates$AffiliatePractitioner$affiliatePractitionersPath = function(affiliateId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'affiliate_practitioners'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
    };
    var $author$project$Api$Provider$Practitioner$Affiliate$Practitioner = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Practitioner$Affiliate$Record = function(synced) {
        return {
            $I: synced
        };
    };
    var $author$project$Api$Provider$Practitioner$Affiliate$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'synced', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Affiliate$Record));
    var $author$project$Api$Provider$Practitioner$Affiliate$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practitioner$Affiliate$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practitioner$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practitioner$Affiliate$Practitioner)));
    var $author$project$Api$Provider$Affiliates$AffiliatePractitioner$list = F3(function(apiClient, affiliateId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Practitioner$Affiliate$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$AffiliatePractitioner$affiliatePractitionersPath(affiliateId)));
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$update = F4(function(apiClient, msg, model, userIsHinter) {
        switch(msg.$){
            case 0:
                var affiliateId = msg.a;
                var resource = msg.b;
                var form = $author$project$Utils$Form$init($author$project$Components$Affiliates$LinkRecordsModal$initFormFields(userIsHinter));
                return {
                    EQ: function() {
                        if (!resource) return $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A3($author$project$Api$Provider$Affiliates$AffiliatePractitioner$list, apiClient, affiliateId, $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliatePractitioners),
                            A3($author$project$Api$Provider$Practitioner$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkPractitioners)
                        ]));
                        else return $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A3($author$project$Api$Provider$Affiliates$AffiliateLocation$list, apiClient, affiliateId, $author$project$Components$Affiliates$LinkRecordsModal$GotAffiliateLocations),
                            A3($author$project$Api$Provider$Location$list, apiClient, $elm$core$Basics$identity, $author$project$Components$Affiliates$LinkRecordsModal$GotNetworkLocations)
                        ]));
                    }(),
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Open({
                        pr: affiliateId,
                        ps: $author$project$Api$Data$Loading,
                        pt: $author$project$Api$Data$Loading,
                        PU: form,
                        rw: $author$project$Api$Data$Loading,
                        ry: $author$project$Api$Data$Loading,
                        Hg: resource,
                        j_: $author$project$Api$Data$NotAsked,
                        H1: userIsHinter
                    }),
                    at: _List_Nil
                };
            case 1:
                var response = msg.a;
                if (model.$ === 1) {
                    var openModel = model.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: $author$project$Components$Affiliates$LinkRecordsModal$Open(_Utils_update(openModel, {
                            pt: response
                        })),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (model.$ === 1) {
                    var openModel = model.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: $author$project$Components$Affiliates$LinkRecordsModal$Open(_Utils_update(openModel, {
                            ps: response
                        })),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 3:
                var response = msg.a;
                if (model.$ === 1) {
                    var openModel = model.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: $author$project$Components$Affiliates$LinkRecordsModal$Open(_Utils_update(openModel, {
                            ry: response
                        })),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                if (model.$ === 1) {
                    var openModel = model.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: $author$project$Components$Affiliates$LinkRecordsModal$Open(_Utils_update(openModel, {
                            rw: response
                        })),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 5:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 6:
                var field = msg.a;
                if (model.$ === 1) {
                    var openModel = model.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Affiliates$LinkRecordsModal$formFieldsUpdate(openModel), field, openModel.PU);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: $author$project$Components$Affiliates$LinkRecordsModal$Open(_Utils_update(openModel, {
                            PU: newForm
                        })),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 7:
                if (model.$ === 1) {
                    var openModel = model.a;
                    var _v8 = A2($author$project$Utils$Form$validate, $author$project$Components$Affiliates$LinkRecordsModal$formFieldsValidator(openModel.Hg), openModel.PU);
                    if (!_v8.$) {
                        var _v9 = _v8.a;
                        var newForm = _v9.a;
                        var validFormFields = _v9.b;
                        var cmd = function() {
                            var _v10 = openModel.Hg;
                            if (!_v10) {
                                var _v11 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                                var affiliatePractitioner = _v11.IV;
                                var networkPractitioner = _v11.rx;
                                var syncToRentalNetworks = _v11.th;
                                return A6($author$project$Api$Provider$Affiliates$Practitioner$link, apiClient, openModel.pr, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Affiliate$id, affiliatePractitioner)), A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$All$id, networkPractitioner), syncToRentalNetworks, $author$project$Components$Affiliates$LinkRecordsModal$Linked);
                            } else {
                                var _v12 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                                var affiliateLocation = _v12.IS;
                                var networkLocation = _v12.rv;
                                return A5($author$project$Api$Provider$Affiliates$Location$link, apiClient, openModel.pr, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id, affiliateLocation)), A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, networkLocation), $author$project$Components$Affiliates$LinkRecordsModal$Linked);
                            }
                        }();
                        return {
                            EQ: cmd,
                            adu: 0,
                            zi: $author$project$Components$Affiliates$LinkRecordsModal$Open(_Utils_update(openModel, {
                                PU: newForm,
                                j_: $author$project$Api$Data$Loading
                            })),
                            at: _List_Nil
                        };
                    } else {
                        var newForm = _v8.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: $author$project$Components$Affiliates$LinkRecordsModal$Open(_Utils_update(openModel, {
                                PU: newForm
                            })),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (model.$ === 1) {
                    var openModel = model.a;
                    switch(response.$){
                        case 3:
                            var _v15 = function() {
                                var _v16 = openModel.Hg;
                                if (!_v16) return _Utils_Tuple2('Practitioner linked!', 1);
                                else return _Utils_Tuple2('Location linked!', 2);
                            }();
                            var message = _v15.a;
                            var event = _v15.b;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: event,
                                zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, message),
                                    $author$project$OutMsg$RefreshPractice
                                ])
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$Affiliates$LinkRecordsModal$Open(_Utils_update(openModel, {
                                    j_: response
                                })),
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: model,
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$LinkRecordsModal$Closed,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Affiliates$SyncPatientsModal$Activated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Affiliates$SyncPatientsModal$ActivationSkiped = 3;
    var $author$project$Components$Affiliates$SyncPatientsModal$AffiliateActivated = 2;
    var $author$project$Components$Affiliates$SyncPatientsModal$Closed = 1;
    var $author$project$Components$Affiliates$SyncPatientsModal$None = 0;
    var $author$project$Api$Provider$Affiliate$activate = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Affiliate$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'activate'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(id_))));
    });
    var $author$project$Components$Affiliates$SyncPatientsModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var action = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        D7: action
                    }),
                    at: _List_Nil
                };
            case 2:
                var _v1 = function() {
                    var _v2 = model.D7;
                    if (!_v2) return _Utils_Tuple3($author$project$Api$Data$Loading, A3($author$project$Api$Provider$Affiliate$activate, apiClient, model.pr, $author$project$Components$Affiliates$SyncPatientsModal$Activated), 0);
                    else return _Utils_Tuple3(model.kR, $elm$core$Platform$Cmd$none, 3);
                }();
                var activateRequest = _v1.a;
                var cmd = _v1.b;
                var event = _v1.c;
                return {
                    EQ: cmd,
                    adu: event,
                    zi: _Utils_update(model, {
                        kR: activateRequest
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Sync synccessful')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        kR: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$LocationUnlinked = 2;
    var $author$project$Components$Affiliates$UnlinkRecordsModal$None = 0;
    var $author$project$Components$Affiliates$UnlinkRecordsModal$Open = F4(function(a, b, c, d) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$PractitionerUnlinked = 1;
    var $author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation = {
        $: 3
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner = {
        $: 1
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$Location$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Affiliates$Location$All$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Affiliates$Location$Min$id(min);
    };
    var $author$project$Api$Provider$Affiliates$Practitioner$All$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$isValid = function(action) {
        switch(action.$){
            case 0:
                var newPractitioner = action.b;
                return $author$project$Utils$Maybe$toBool(newPractitioner);
            case 2:
                var newLocation = action.b;
                return $author$project$Utils$Maybe$toBool(newLocation);
            case 1:
                return true;
            default:
                return true;
        }
    };
    var $author$project$Api$Provider$Affiliates$Location$locationPath = F2(function(affiliateId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Affiliates$Location$locationsPath(affiliateId));
    });
    var $author$project$Api$Provider$Affiliates$Location$unlink = F5(function(apiClient, affiliateId, id, reassignToId, toMsg) {
        var body = $elm$json$Json$Encode$object(function() {
            if (!reassignToId.$) {
                var reassignToId_ = reassignToId.a;
                return _List_fromArray([
                    _Utils_Tuple2('reassign_to_id', $elm$json$Json$Encode$string(reassignToId_))
                ]);
            } else return _List_Nil;
        }());
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unlink'
        ]), A2($author$project$Api$Provider$Affiliates$Location$locationPath, affiliateId, id)))));
    });
    var $author$project$Api$Provider$Affiliates$Practitioner$practitionerPath = F2(function(affiliateId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Affiliates$Practitioner$practitionersPath(affiliateId));
    });
    var $author$project$Api$Provider$Affiliates$Practitioner$unlink = F5(function(apiClient, affiliateId, id, reassignToId, toMsg) {
        var body = $elm$json$Json$Encode$object(function() {
            if (!reassignToId.$) {
                var reassignToId_ = reassignToId.a;
                return _List_fromArray([
                    _Utils_Tuple2('reassign_to_id', $elm$json$Json$Encode$string(reassignToId_))
                ]);
            } else return _List_Nil;
        }());
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unlink'
        ]), A2($author$project$Api$Provider$Affiliates$Practitioner$practitionerPath, affiliateId, id)))));
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var affiliateId = msg.a;
                var resource = msg.b;
                var action = function() {
                    if (!resource.$) {
                        var remainingPractitioners = resource.b;
                        return $elm$core$List$isEmpty(remainingPractitioners) ? $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner : A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, $elm$core$Maybe$Nothing);
                    } else {
                        var remainingLocations = resource.b;
                        return $elm$core$List$isEmpty(remainingLocations) ? $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation : A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, $elm$core$Maybe$Nothing);
                    }
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$NotAsked),
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 3:
                var action = msg.a;
                if (model.$ === 1) {
                    var practitioner = model.a;
                    var remainingPractitioners = model.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, practitioner, remainingPractitioners, action, $author$project$Api$Data$NotAsked),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 5:
                var id = msg.a;
                if (model.$ === 1) {
                    var affiliateId = model.a;
                    var resource = model.b;
                    var action = model.c;
                    var response = model.d;
                    switch(action.$){
                        case 0:
                            var remainingPractitioners = action.a;
                            var newPractitioner = A2($elm_community$list_extra$List$Extra$find, function(practitioner_) {
                                return _Utils_eq(id, $author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner_));
                            }, remainingPractitioners);
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, newPractitioner), response),
                                at: _List_Nil
                            };
                        case 2:
                            var remainingLocations = action.a;
                            var newLocation = A2($elm_community$list_extra$List$Extra$find, function(location1) {
                                return _Utils_eq(id, $author$project$Api$Provider$Affiliates$Location$All$id(location1));
                            }, remainingLocations);
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, newLocation), response),
                                at: _List_Nil
                            };
                        case 1:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, $author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner, response),
                                at: _List_Nil
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, $author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation, response),
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed,
                    at: _List_Nil
                };
            case 2:
                if (model.$ === 1) {
                    var affiliateId = model.a;
                    var resource = model.b;
                    var action = model.c;
                    if ($author$project$Components$Affiliates$UnlinkRecordsModal$isValid(action)) {
                        var id = function() {
                            if (!resource.$) {
                                var practitioner = resource.a;
                                return $author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner);
                            } else {
                                var location1 = resource.a;
                                return $author$project$Api$Provider$Affiliates$Location$All$id(location1);
                            }
                        }();
                        var cmd = function() {
                            switch(action.$){
                                case 0:
                                    var newPractitioner_ = action.b;
                                    return A5($author$project$Api$Provider$Affiliates$Practitioner$unlink, apiClient, affiliateId, id, A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Practitioner$All$id, newPractitioner_), $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
                                case 2:
                                    var newLocation_ = action.b;
                                    return A5($author$project$Api$Provider$Affiliates$Location$unlink, apiClient, affiliateId, id, A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Location$All$id, newLocation_), $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
                                case 1:
                                    return A5($author$project$Api$Provider$Affiliates$Practitioner$unlink, apiClient, affiliateId, id, $elm$core$Maybe$Nothing, $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
                                default:
                                    return A5($author$project$Api$Provider$Affiliates$Location$unlink, apiClient, affiliateId, id, $elm$core$Maybe$Nothing, $author$project$Components$Affiliates$UnlinkRecordsModal$Unlinked);
                            }
                        }();
                        return {
                            EQ: cmd,
                            adu: 0,
                            zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$Loading),
                            at: _List_Nil
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, $author$project$Api$Data$NotAsked),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (model.$ === 1) {
                    var affiliateId = model.a;
                    var resource = model.b;
                    var action = model.c;
                    switch(response.$){
                        case 3:
                            var _v10 = function() {
                                if (!resource.$) return _Utils_Tuple2('Practitioner unlinked!', 1);
                                else return _Utils_Tuple2('Location unlinked!', 2);
                            }();
                            var message = _v10.a;
                            var event = _v10.b;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: event,
                                zi: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed,
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, message),
                                    $author$project$OutMsg$RefreshPractice
                                ])
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: A4($author$project$Components$Affiliates$UnlinkRecordsModal$Open, affiliateId, resource, action, response),
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: model,
                                at: _List_Nil
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Affiliates$UnlinkRecordsModal$Closed,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Xc: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tq: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var unlinkRecordsModalResutl = A3($author$project$Components$Affiliates$UnlinkRecordsModal$update, model.Ej, subMsg, model.o_);
                var _v1 = function() {
                    var _v2 = unlinkRecordsModalResutl.adu;
                    switch(_v2){
                        case 0:
                            return _Utils_Tuple3(model.Xc, model.Tq, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple3($author$project$Api$Data$Loading, model.Tq, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model));
                        default:
                            return _Utils_Tuple3(model.Xc, $author$project$Api$Data$Loading, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model));
                    }
                }();
                var practitioners = _v1.a;
                var locations = _v1.b;
                var cmd = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tq: locations,
                    Xc: practitioners,
                    o_: unlinkRecordsModalResutl.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg, unlinkRecordsModalResutl.EQ),
                    cmd
                ])), unlinkRecordsModalResutl.at);
            case 3:
                var subMsg = msg.a;
                var linkRecordsModalResutl = A4($author$project$Components$Affiliates$LinkRecordsModal$update, model.Ej, subMsg, model.mU, model.H1);
                var _v3 = function() {
                    var _v4 = linkRecordsModalResutl.adu;
                    switch(_v4){
                        case 0:
                            return _Utils_Tuple3(model.Xc, model.Tq, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple3($author$project$Api$Data$Loading, model.Tq, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchPractitioners(model));
                        default:
                            return _Utils_Tuple3(model.Xc, $author$project$Api$Data$Loading, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$fetchLocations(model));
                    }
                }();
                var practitioners = _v3.a;
                var locations = _v3.b;
                var cmd = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    mU: linkRecordsModalResutl.zi,
                    Tq: locations,
                    Xc: practitioners
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg, linkRecordsModalResutl.EQ),
                    cmd
                ])), linkRecordsModalResutl.at);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    kr: $elm$core$Maybe$Just($author$project$Components$Affiliates$SyncPatientsModal$init(model.pr))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var subMsg = msg.a;
                var _v5 = model.kr;
                if (!_v5.$) {
                    var syncPatientsModal = _v5.a;
                    var syncPatientsModalResutl = A3($author$project$Components$Affiliates$SyncPatientsModal$update, model.Ej, subMsg, syncPatientsModal);
                    var _v6 = function() {
                        var _v7 = syncPatientsModalResutl.adu;
                        switch(_v7){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(syncPatientsModalResutl.zi), $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                            case 3:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
                                    pr: model.pr
                                })));
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
                                    pr: model.pr
                                })));
                        }
                    }();
                    var syncPatientsModal_ = _v6.a;
                    var cmd = _v6.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        kr: syncPatientsModal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg, syncPatientsModalResutl.EQ),
                        cmd
                    ])), syncPatientsModalResutl.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var cmd = A3($author$project$Api$Provider$Affiliate$linkAllProviders, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkedAllProviders);
                return _Utils_Tuple3(model, cmd, _List_Nil);
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'A job has been queued to link all providers, and an email will be sent to you when it\'s complete.'),
                            $author$project$OutMsg$RefreshPractice
                        ]));
                    case 2:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatients = {
        $: 4
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$Link = {
        $: 7
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$SyncToRentalNetworks = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$resourceName = function(resource) {
        if (!resource) return 'provider';
        else return 'location';
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocation = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitioner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Affiliates$AffiliateLocation$Min$name(min);
    };
    var $author$project$Api$Provider$Practitioner$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Practitioner$Affiliate$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Practitioner$Min$name(min);
    };
    var $author$project$Api$Provider$Affiliates$AffiliateLocation$All$synced = function(_v0) {
        var record = _v0.b;
        return record.$I;
    };
    var $author$project$Api$Provider$Practitioner$Affiliate$synced = function(_v0) {
        var record = _v0.b;
        return record.$I;
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$affiliateRecordOptions = F3(function(resource, practitioners, locations) {
        var affiliateRecords = function() {
            if (!resource) return A2($elm$core$List$map, function(practitioner) {
                return {
                    aef: $author$project$Api$Provider$Practitioner$Affiliate$id(practitioner),
                    Su: A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practitioner$Affiliate$synced, $author$project$Utils$Maybe$toBool)(practitioner),
                    zr: $author$project$Api$Provider$Practitioner$Affiliate$name(practitioner)
                };
            }, practitioners);
            else return A2($elm$core$List$map, function(location1) {
                return {
                    aef: $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id(location1),
                    Su: A2($elm$core$Basics$composeR, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$synced, $author$project$Utils$Maybe$toBool)(location1),
                    zr: $author$project$Api$Provider$Affiliates$AffiliateLocation$All$name(location1)
                };
            }, locations);
        }();
        var notSynced = A2($elm_community$list_extra$List$Extra$filterNot, function($) {
            return $.Su;
        }, affiliateRecords);
        var sortedNotSynced = function() {
            if (resource === 1) return A2($elm$core$List$sortBy, function(record) {
                return $elm$core$String$toLower(record.zr);
            }, notSynced);
            else return notSynced;
        }();
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a ' + ($author$project$Components$Affiliates$LinkRecordsModal$resourceName(resource) + '...')), A2($elm$core$List$map, function(affiliateRecord) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(affiliateRecord.aef), affiliateRecord.zr);
        }, sortedNotSynced));
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$viewAffiliateRecordSelect = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var _v0 = function() {
            var _v1 = _Utils_Tuple3(model.Hg, model.pt, model.ps);
            if (!_v1.a) {
                if (_v1.b.$ === 3) {
                    var _v2 = _v1.a;
                    var _v3 = _v1.b;
                    var list = _v3.a;
                    return _Utils_Tuple3(false, list, _List_Nil);
                } else {
                    var _v4 = _v1.a;
                    return _Utils_Tuple3(true, _List_Nil, _List_Nil);
                }
            } else if (_v1.c.$ === 3) {
                var _v5 = _v1.a;
                var _v6 = _v1.c;
                var list = _v6.a;
                return _Utils_Tuple3(false, _List_Nil, list);
            } else {
                var _v7 = _v1.a;
                return _Utils_Tuple3(true, _List_Nil, _List_Nil);
            }
        }();
        var loading = _v0.a;
        var practitioners_ = _v0.b;
        var locations_ = _v0.c;
        var selectOptions = A3($author$project$Components$Affiliates$LinkRecordsModal$affiliateRecordOptions, model.Hg, practitioners_, locations_);
        var _v8 = function() {
            var _v9 = model.Hg;
            if (!_v9) return _Utils_Tuple2(A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Affiliate$id, fields.IV), $author$project$Components$Affiliates$LinkRecordsModal$AffiliatePractitioner);
            else return _Utils_Tuple2(A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$AffiliateLocation$All$id, fields.IS), $author$project$Components$Affiliates$LinkRecordsModal$AffiliateLocation);
        }();
        var id = _v8.a;
        var field = _v8.b;
        var _v10 = function() {
            var _v11 = model.Hg;
            if (!_v11) return _Utils_Tuple2(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU), A2($author$project$Utils$Form$validationErrors, 0, model.PU));
            else return _Utils_Tuple2(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU), A2($author$project$Utils$Form$validationErrors, 1, model.PU));
        }();
        var invalid = _v10.a;
        var errors = _v10.b;
        return !loading && $elm$core$List$length(selectOptions) === 1 ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
            $elm$html$Html$text('No more affiliate '),
            $elm$html$Html$text($author$project$Components$Affiliates$LinkRecordsModal$resourceName(model.Hg)),
            $elm$html$Html$text('s')
        ])) : A2($author$project$Ui$Form$Select$view, _List_fromArray([
            $author$project$Ui$Form$Select$value(id),
            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, field)),
            $author$project$Ui$Form$Select$invalid(invalid),
            $author$project$Ui$Form$Select$errors(errors),
            $author$project$Ui$Form$Select$loading(loading)
        ]), selectOptions);
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$NetworkLocation = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$NetworkLocationValidation = 3;
    var $author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitioner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitionerValidation = 2;
    var $author$project$Components$Affiliates$LinkRecordsModal$networkRecordOptions = F3(function(resource, practitioners, locations) {
        var networkRecords = function() {
            if (!resource) return A2($elm$core$List$map, function(practitioner) {
                return {
                    aef: $author$project$Api$Provider$Practitioner$All$id(practitioner),
                    Su: $author$project$Api$Provider$Practitioner$All$isSynced(practitioner),
                    zr: $author$project$Api$Provider$Practitioner$All$name(practitioner)
                };
            }, practitioners);
            else return A2($elm$core$List$map, function(location1) {
                return {
                    aef: $author$project$Api$Provider$Location$All$id(location1),
                    Su: $author$project$Api$Provider$Location$All$isSynced(location1),
                    zr: $author$project$Api$Provider$Location$All$name(location1)
                };
            }, locations);
        }();
        var notSynced = A2($elm_community$list_extra$List$Extra$filterNot, function($) {
            return $.Su;
        }, networkRecords);
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Create new network ' + $author$project$Components$Affiliates$LinkRecordsModal$resourceName(resource)), A2($elm$core$List$map, function(networkRecord) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(networkRecord.aef), networkRecord.zr);
        }, notSynced));
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$viewNetworkRecordSelect = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var _v0 = function() {
            var _v1 = _Utils_Tuple3(model.Hg, model.ry, model.rw);
            if (!_v1.a) {
                if (_v1.b.$ === 3) {
                    var _v2 = _v1.a;
                    var _v3 = _v1.b;
                    var list = _v3.a;
                    return _Utils_Tuple3(false, list, _List_Nil);
                } else {
                    var _v4 = _v1.a;
                    return _Utils_Tuple3(true, _List_Nil, _List_Nil);
                }
            } else if (_v1.c.$ === 3) {
                var _v5 = _v1.a;
                var _v6 = _v1.c;
                var list = _v6.a;
                return _Utils_Tuple3(false, _List_Nil, list);
            } else {
                var _v7 = _v1.a;
                return _Utils_Tuple3(true, _List_Nil, _List_Nil);
            }
        }();
        var loading = _v0.a;
        var practitioners_ = _v0.b;
        var locations_ = _v0.c;
        var selectOptions = A3($author$project$Components$Affiliates$LinkRecordsModal$networkRecordOptions, model.Hg, practitioners_, locations_);
        var _v8 = function() {
            var _v9 = model.Hg;
            if (!_v9) return _Utils_Tuple2(A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$All$id, fields.rx), $author$project$Components$Affiliates$LinkRecordsModal$NetworkPractitioner);
            else return _Utils_Tuple2(A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$All$id, fields.rv), $author$project$Components$Affiliates$LinkRecordsModal$NetworkLocation);
        }();
        var id = _v8.a;
        var field = _v8.b;
        var _v10 = function() {
            var _v11 = model.Hg;
            if (!_v11) return _Utils_Tuple2(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU), A2($author$project$Utils$Form$validationErrors, 2, model.PU));
            else return _Utils_Tuple2(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU), A2($author$project$Utils$Form$validationErrors, 3, model.PU));
        }();
        var invalid = _v10.a;
        var errors = _v10.b;
        return A2($author$project$Ui$Form$Select$view, _List_fromArray([
            $author$project$Ui$Form$Select$value(id),
            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, field)),
            $author$project$Ui$Form$Select$invalid(invalid),
            $author$project$Ui$Form$Select$errors(errors),
            $author$project$Ui$Form$Select$loading(loading)
        ]), selectOptions);
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$viewModal = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var showNetworkRecordSelect = function() {
            var _v3 = model.Hg;
            if (!_v3) return $author$project$Utils$Maybe$toBool(fields.IV);
            else return $author$project$Utils$Maybe$toBool(fields.IS);
        }();
        return A3($author$project$Ui$Modal$view, $author$project$Components$Affiliates$LinkRecordsModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Link affiliate\'s ' + $author$project$Components$Affiliates$LinkRecordsModal$resourceName(model.Hg))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(function() {
                        var _v0 = model.Hg;
                        if (!_v0) return 'Affiliate Provider\'s Name';
                        else return 'Affiliate Location\'s Name';
                    }()),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    $author$project$Components$Affiliates$LinkRecordsModal$viewAffiliateRecordSelect(model)
                ])),
                showNetworkRecordSelect ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(function() {
                        var _v1 = model.Hg;
                        if (!_v1) return 'Network Provider\'s Name';
                        else return 'Network Location\'s Name';
                    }()),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    $author$project$Components$Affiliates$LinkRecordsModal$viewNetworkRecordSelect(model)
                ])) : $author$project$Utils$Html$empty,
                function() {
                    if (model.H1) {
                        var _v2 = model.Hg;
                        if (!_v2) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$clearfix,
                            $author$project$Ui$Form$Group$label('')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                                $author$project$Ui$Form$Checkbox$value(fields.th),
                                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$LinkRecordsModal$FormUpdated, $author$project$Components$Affiliates$LinkRecordsModal$SyncToRentalNetworks))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Sync to all rental networks')
                            ]))
                        ]));
                        else return $author$project$Utils$Html$empty;
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Affiliates$LinkRecordsModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Affiliates$LinkRecordsModal$Link),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$modal = function(model) {
        if (model.$ === 1) {
            var openModel = model.a;
            return $author$project$Components$Affiliates$LinkRecordsModal$viewModal(openModel);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$Unlink = {
        $: 2
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$Location$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Affiliates$Location$All$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Affiliates$Location$Min$name(min);
    };
    var $author$project$Api$Provider$Affiliates$Practitioner$All$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateNewPractitioner = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$locationOptions = function(locations) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a location...'), A2($elm$core$List$map, function(location1) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Affiliates$Location$All$id(location1)), $author$project$Api$Provider$Affiliates$Location$All$name(location1));
        }, locations));
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$practitionerOptions = function(practitioners) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a practitioner...'), A2($elm$core$List$map, function(practitioner) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner)), $author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner));
        }, practitioners));
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$reassignOptions = function(resource) {
        if (!resource.$) {
            var remainingPractitioners = resource.b;
            return $author$project$Components$Affiliates$UnlinkRecordsModal$practitionerOptions(remainingPractitioners);
        } else {
            var remainingLocations = resource.b;
            return $author$project$Components$Affiliates$UnlinkRecordsModal$locationOptions(remainingLocations);
        }
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect = F3(function(resource, id, invalid) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('pt-05')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(id),
                $author$project$Ui$Form$Select$onChange($author$project$Components$Affiliates$UnlinkRecordsModal$UpdateNewPractitioner),
                $author$project$Ui$Form$Select$invalid(invalid),
                $author$project$Ui$Form$Select$errors(function() {
                    if (invalid) {
                        var resourceName = function() {
                            if (!resource.$) return 'provider';
                            else return 'location';
                        }();
                        return _List_fromArray([
                            'Please pick a ' + (resourceName + ' for reassignment')
                        ]);
                    } else return _List_Nil;
                }())
            ]), $author$project$Components$Affiliates$UnlinkRecordsModal$reassignOptions(resource))
        ]));
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$viewModal = F3(function(resource, action, request) {
        var _v0 = function() {
            switch(action.$){
                case 0:
                    return _Utils_Tuple2(true, false);
                case 2:
                    return _Utils_Tuple2(true, false);
                case 1:
                    return _Utils_Tuple2(false, true);
                default:
                    return _Utils_Tuple2(false, true);
            }
        }();
        var reassignActive = _v0.a;
        var terminateActive = _v0.b;
        var _v2 = function() {
            if (!resource.$) {
                var practitioner = resource.a;
                var remainingPractitioners = resource.b;
                return _Utils_Tuple2($author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner), $elm$core$List$isEmpty(remainingPractitioners));
            } else {
                var location1 = resource.a;
                var remainingLocations = resource.b;
                return _Utils_Tuple2($author$project$Api$Provider$Affiliates$Location$All$name(location1), $elm$core$List$isEmpty(remainingLocations));
            }
        }();
        var name = _v2.a;
        var remainingResourcesEmpty = _v2.b;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('What would you like to do with ' + (name + '\'s patients?'))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(function() {
                        if (!resource.$) return 'Provider';
                        else return 'Location';
                    }()),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(name)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Action'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8)
                ]), _List_fromArray([
                    function() {
                        var terminateAction = function() {
                            if (!resource.$) return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction($author$project$Components$Affiliates$UnlinkRecordsModal$TerminatePractitioner);
                            else return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction($author$project$Components$Affiliates$UnlinkRecordsModal$TerminateLocation);
                        }();
                        var reassignAction = function() {
                            if (!resource.$) {
                                var remainingPractitioners = resource.b;
                                return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction(A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignPractitioner, remainingPractitioners, $elm$core$Maybe$Nothing));
                            } else {
                                var remainingLocations = resource.b;
                                return $author$project$Components$Affiliates$UnlinkRecordsModal$UpdateAction(A2($author$project$Components$Affiliates$UnlinkRecordsModal$ReassignLocation, remainingLocations, $elm$core$Maybe$Nothing));
                            }
                        }();
                        var _v5 = function() {
                            if (!resource.$) return _Utils_Tuple2('Terminate', 'Provider');
                            else return _Utils_Tuple2('Remove', 'Location');
                        }();
                        var terminationVerb = _v5.a;
                        var resourceName = _v5.b;
                        return $author$project$Ui$Button$group(_List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Reassign ' + resourceName
                            }, _List_fromArray([
                                $author$project$Ui$Button$active(reassignActive),
                                $author$project$Ui$Button$disabled(remainingResourcesEmpty),
                                $author$project$Ui$Button$onClick(reassignAction)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Reassign')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: terminationVerb + (' ' + resourceName)
                            }, _List_fromArray([
                                $author$project$Ui$Button$active(terminateActive),
                                $author$project$Ui$Button$onClick(terminateAction)
                            ]), _List_fromArray([
                                $elm$html$Html$text(terminationVerb)
                            ]))
                        ]));
                    }(),
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pt-05')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            function() {
                                switch(action.$){
                                    case 0:
                                        return $elm$html$Html$text('All patients will be switched to a different provider.');
                                    case 1:
                                        return $elm$html$Html$text('All affiliate memberships will be terminated. Your memberships are not affected.');
                                    case 2:
                                        return $elm$html$Html$text('All patients will be switched to a new location.');
                                    default:
                                        return $elm$html$Html$text('This location will be removed from all patients. The primary care clinic will not be removed.');
                                }
                            }()
                        ]))
                    ])),
                    function() {
                        switch(action.$){
                            case 0:
                                var newPractitioner = action.b;
                                var newPractitionerInvalid = !$author$project$Utils$Maybe$toBool(newPractitioner);
                                return A3($author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect, resource, A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Practitioner$All$id, newPractitioner), newPractitionerInvalid);
                            case 2:
                                var newLocation = action.b;
                                var newLocationInvalid = !$author$project$Utils$Maybe$toBool(newLocation);
                                return A3($author$project$Components$Affiliates$UnlinkRecordsModal$viewReassingSelect, resource, A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliates$Location$All$id, newLocation), newLocationInvalid);
                            case 1:
                                return $author$project$Utils$Html$empty;
                            default:
                                return $author$project$Utils$Html$empty;
                        }
                    }()
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Affiliates$UnlinkRecordsModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Unlink'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Affiliates$UnlinkRecordsModal$Unlink),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                ]), _List_fromArray([
                    $elm$html$Html$text(' Unlink')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$modal = function(model) {
        if (model.$ === 1) {
            var resource = model.b;
            var action = model.c;
            var request = model.d;
            return A3($author$project$Components$Affiliates$UnlinkRecordsModal$viewModal, resource, action, request);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$Network$Shared$syncByAffiliation = function(_v0) {
        var record = _v0;
        return record.$D;
    };
    var $author$project$Components$Affiliates$SyncPatientsModal$Activate = 0;
    var $author$project$Components$Affiliates$SyncPatientsModal$Save = {
        $: 2
    };
    var $author$project$Components$Affiliates$SyncPatientsModal$UpdateAction = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$SyncPatientsModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Affiliates$SyncPatientsModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Patients Syncing')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Patients Syncing'),
                    $author$project$Ui$Form$Group$labelSpan(3),
                    $author$project$Ui$Form$Group$inputSpan(9)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                            $author$project$Ui$Form$Radio$value(model.D7 === 1),
                            $author$project$Ui$Form$Radio$onCheck($elm$core$Basics$always($author$project$Components$Affiliates$SyncPatientsModal$UpdateAction(1)))
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Pend the Affiliation (recommended)')
                            ])),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text('Syncing will be turned on at a later date')
                            ]))
                        ]))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                            $author$project$Ui$Form$Radio$value(!model.D7),
                            $author$project$Ui$Form$Radio$onCheck($elm$core$Basics$always($author$project$Components$Affiliates$SyncPatientsModal$UpdateAction(0)))
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Activate the Affiliation')
                            ])),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text('Patients will begin syncing immediately')
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel and close modal'
                        }, _List_fromArray([
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$onClick($author$project$Components$Affiliates$SyncPatientsModal$CloseModal)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Confirm patient sync'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$loading(_Utils_eq(model.kR, $author$project$Api$Data$Loading)),
                            $author$project$Ui$Button$onClick($author$project$Components$Affiliates$SyncPatientsModal$Save),
                            $author$project$Ui$Button$fullWidth(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Confirm')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$Location = 1;
    var $author$project$Components$Affiliates$LinkRecordsModal$OpenModal = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$button_ = F3(function(affiliateId, resource, options) {
        var label = 'Add ' + function() {
            if (!resource) return 'provider';
            else return 'location';
        }();
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _Utils_ap(options, _List_fromArray([
            $author$project$Ui$Button$styled(0),
            $author$project$Ui$Button$onClick(A2($author$project$Components$Affiliates$LinkRecordsModal$OpenModal, affiliateId, resource))
        ])), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$buttonSm = F2(function(affiliateId, resource) {
        return A3($author$project$Components$Affiliates$LinkRecordsModal$button_, affiliateId, resource, _List_fromArray([
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
        ]));
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$Location = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Affiliates$Location$All$affiliateLocation = function(_v0) {
        var record = _v0.b;
        return record.IS;
    };
    var $author$project$Components$Affiliates$UnlinkRecordsModal$OpenModal = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Affiliates$UnlinkRecordsModal$button = F2(function(affiliateId, resource) {
        var resourceName = function() {
            if (!resource.$) return 'provider';
            else return 'location';
        }();
        return A3($author$project$Ui$Button$view, {
            abP: 'Unlink ' + resourceName
        }, _List_fromArray([
            $author$project$Ui$Button$size(0),
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick(A2($author$project$Components$Affiliates$UnlinkRecordsModal$OpenModal, affiliateId, resource)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
        ]), _List_fromArray([
            $elm$html$Html$text('Unlink')
        ]));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocation = F3(function(model, locations, location1) {
        var remainingLocations = A2($elm$core$List$filter, function(remainingLocation) {
            return !_Utils_eq($author$project$Api$Provider$Affiliates$Location$All$id(location1), $author$project$Api$Provider$Affiliates$Location$All$id(remainingLocation));
        }, locations);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$padding(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Network: '),
                    A2($author$project$Ui$Typography$b, _List_fromArray([
                        $author$project$Ui$Typography$padding(2)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Affiliates$Location$All$name(location1))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textMuted
                ]), _List_fromArray([
                    $author$project$Ui$Icon$arrowRight(_List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$padding(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Affiliate: '),
                    A2($author$project$Ui$Typography$b, _List_fromArray([
                        $author$project$Ui$Typography$padding(2)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Location$Min$name($author$project$Api$Provider$Affiliates$Location$All$affiliateLocation(location1)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg, A2($author$project$Components$Affiliates$UnlinkRecordsModal$button, model.pr, A2($author$project$Components$Affiliates$UnlinkRecordsModal$Location, location1, remainingLocations)))
            ]))
        ]));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocationsTable = function(model) {
        var _v0 = function() {
            var _v1 = model.Tq;
            if (_v1.$ === 3) {
                var locations_ = _v1.a;
                return _Utils_Tuple2(false, locations_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var locations = _v0.b;
        return _List_fromArray([
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(5)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Locations')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Create links between affiliate\'s locations and your network.')
                    ]))
                ]))
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$loading(loading),
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No linked locations.')
                ]))
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(5)
                ]), _List_Nil),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(1)
                ]), _List_Nil),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(4)
                ]), _List_Nil),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_Nil)
            ]), A2($elm$core$List$map, A2($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocation, model, locations), locations), _List_Nil),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg, A2($author$project$Components$Affiliates$LinkRecordsModal$buttonSm, model.pr, 1))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text('You can add locations to your network from the affiliate\'s account.')
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkAllProviders = {
        $: 6
    };
    var $author$project$Components$Affiliates$LinkRecordsModal$Practitioner = 0;
    var $author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner = function(_v0) {
        var record = _v0;
        return record.IV;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitioner = F3(function(model, practitioners, practitioner) {
        var remainingPractitioners = A2($elm$core$List$filter, function(remainingPractitioner) {
            return !_Utils_eq($author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner), $author$project$Api$Provider$Affiliates$Practitioner$All$id(remainingPractitioner));
        }, practitioners);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$padding(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Network: '),
                    A2($author$project$Ui$Typography$b, _List_fromArray([
                        $author$project$Ui$Typography$padding(2)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textMuted
                ]), _List_fromArray([
                    $author$project$Ui$Icon$arrowRight(_List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$padding(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Affiliate: '),
                    A2($author$project$Ui$Typography$b, _List_fromArray([
                        $author$project$Ui$Typography$padding(2)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Practitioner$Min$name($author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner(practitioner)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg, A2($author$project$Components$Affiliates$UnlinkRecordsModal$button, model.pr, A2($author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner, practitioner, remainingPractitioners)))
            ]))
        ]));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitionersTable = function(model) {
        var isHinter = A2($author$project$Utils$User$isViewingAsHinter, model.Z$, model.aeb);
        var _v0 = function() {
            var _v1 = model.Xc;
            if (_v1.$ === 3) {
                var practitioners_ = _v1.a;
                return _Utils_Tuple2(false, practitioners_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var practitioners = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(5)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Link Providers')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Create links between affiliate\'s providers and your network.')
                    ]))
                ]))
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$loading(loading),
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No linked providers.')
                ]))
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(5)
                ]), _List_Nil),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(1)
                ]), _List_Nil),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(4)
                ]), _List_Nil),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_Nil)
            ]), A2($elm$core$List$map, A2($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitioner, model, practitioners), practitioners), _List_Nil),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$mb2,
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg, A2($author$project$Components$Affiliates$LinkRecordsModal$buttonSm, model.pr, 0)),
                isHinter ? A3($author$project$Ui$HinterOnly$button, {
                    abP: 'Add all providers'
                }, _List_fromArray([
                    $author$project$Ui$Button$styled(0),
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkAllProviders)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add all providers')
                ])) : $elm$html$Html$text('')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text('You can add providers to your network from the affiliate\'s account.')
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$view = function(model) {
        var network = $author$project$Api$Provider$Practice$One$network(model.W1);
        var syncByAffiliation = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network));
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$UnlinkRecordsModalMsg, $author$project$Components$Affiliates$UnlinkRecordsModal$modal(model.o_)),
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$LinkRecordsModalMsg, $author$project$Components$Affiliates$LinkRecordsModal$modal(model.mU)),
                function() {
                    var _v0 = model.kr;
                    if (!_v0.$) {
                        var syncPatientsModal = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatientsModalMsg, $author$project$Components$Affiliates$SyncPatientsModal$view(syncPatientsModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__Top, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Manage affiliates')
                            ]))
                        ])),
                        A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__New, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Add new affiliate')
                            ]))
                        ])),
                        A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__New, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Create Affiliation')
                            ]))
                        ])),
                        A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                            $author$project$Ui$Breadcrumb$active(true)
                        ]), _List_fromArray([
                            syncByAffiliation ? $elm$html$Html$text('Link Providers & Locations') : $elm$html$Html$text('Link Providers')
                        ]))
                    ]))), _Utils_ap($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewPractitionersTable(model), syncByAffiliation ? $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$viewLocationsTable(model) : _List_Nil))),
                    A2($author$project$Ui$Panel$footer, _List_fromArray([
                        $author$project$Ui$Element$justifyCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        function() {
                            var label = syncByAffiliation ? 'Link providers & locations' : 'Finish';
                            return A3($author$project$Ui$Button$view, {
                                abP: label
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$SyncPatients)
                            ]), _List_fromArray([
                                $elm$html$Html$text(label)
                            ]));
                        }()
                    ]))
                ]))
            ]),
            $2: 'Affiliates'
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$init,
        aeR: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$load,
        ag3: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$save,
        ahE: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$subscriptions,
        aaO: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$update,
        aid: $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$view
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotLocations = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations = function(model) {
        return A3($author$project$Api$Provider$Affiliates$Location$list, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotLocations);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotPractitioners = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners = function(model) {
        return A3($author$project$Api$Provider$Affiliates$Practitioner$list, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$GotPractitioners);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var params = _v1.VU;
        var model = {
            pr: params.pr,
            Ej: apiClient,
            mU: $author$project$Components$Affiliates$LinkRecordsModal$init,
            Tq: $author$project$Api$Data$Loading,
            W1: practice,
            Xc: $author$project$Api$Data$Loading,
            o_: $author$project$Components$Affiliates$UnlinkRecordsModal$init,
            H1: A2($author$project$Utils$User$isViewingAsHinter, session, hinterViewOff)
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model),
            $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model)
        ])));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg, $author$project$Components$Affiliates$LinkRecordsModal$subscriptions(model.mU)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg, $author$project$Components$Affiliates$UnlinkRecordsModal$subscriptions(model.o_))
        ]));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Xc: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tq: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var unlinkRecordsModalResutl = A3($author$project$Components$Affiliates$UnlinkRecordsModal$update, model.Ej, subMsg, model.o_);
                var _v1 = function() {
                    var _v2 = unlinkRecordsModalResutl.adu;
                    switch(_v2){
                        case 0:
                            return _Utils_Tuple3(model.Xc, model.Tq, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple3($author$project$Api$Data$Loading, model.Tq, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model));
                        default:
                            return _Utils_Tuple3(model.Xc, $author$project$Api$Data$Loading, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model));
                    }
                }();
                var practitioners = _v1.a;
                var locations = _v1.b;
                var cmd = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tq: locations,
                    Xc: practitioners,
                    o_: unlinkRecordsModalResutl.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg, unlinkRecordsModalResutl.EQ),
                    cmd
                ])), unlinkRecordsModalResutl.at);
            default:
                var subMsg = msg.a;
                var linkRecordsModalResutl = A4($author$project$Components$Affiliates$LinkRecordsModal$update, model.Ej, subMsg, model.mU, model.H1);
                var _v3 = function() {
                    var _v4 = linkRecordsModalResutl.adu;
                    switch(_v4){
                        case 0:
                            return _Utils_Tuple3(model.Xc, model.Tq, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple3($author$project$Api$Data$Loading, model.Tq, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchPractitioners(model));
                        default:
                            return _Utils_Tuple3(model.Xc, $author$project$Api$Data$Loading, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$fetchLocations(model));
                    }
                }();
                var practitioners = _v3.a;
                var locations = _v3.b;
                var cmd = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    mU: linkRecordsModalResutl.zi,
                    Tq: locations,
                    Xc: practitioners
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg, linkRecordsModalResutl.EQ),
                    cmd
                ])), linkRecordsModalResutl.at);
        }
    });
    var $author$project$Components$Affiliates$LinkRecordsModal$button = F2(function(affiliateId, resource) {
        return A3($author$project$Components$Affiliates$LinkRecordsModal$button_, affiliateId, resource, _List_fromArray([
            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
        ]));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$locationsColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'network_name', false, 'Network Location Name'),
        A3($author$project$Api$Column$init, 'affiliate_name', false, 'Affiliate Location Name'),
        A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
        A3($author$project$Api$Column$init, 'actions', false, '')
    ]);
    var $author$project$Api$Provider$Affiliates$Location$All$activeLives = function(_v0) {
        var record = _v0.b;
        return record.Iu;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocation = F3(function(model, locations, location1) {
        var remainingLocations = A2($elm$core$List$filter, function(remainingLocation) {
            return !_Utils_eq($author$project$Api$Provider$Affiliates$Location$All$id(location1), $author$project$Api$Provider$Affiliates$Location$All$id(remainingLocation));
        }, locations);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Affiliates$Location$All$name(location1))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Location$Min$name($author$project$Api$Provider$Affiliates$Location$All$affiliateLocation(location1)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Affiliates$Location$All$activeLives(location1)))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg, A2($author$project$Components$Affiliates$UnlinkRecordsModal$button, model.pr, A2($author$project$Components$Affiliates$UnlinkRecordsModal$Location, location1, remainingLocations)))
            ]))
        ]));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocationsTable = function(model) {
        var _v0 = function() {
            var _v1 = model.Tq;
            if (_v1.$ === 3) {
                var locations_ = _v1.a;
                return _Utils_Tuple2(false, locations_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var locations = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mt4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(10)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Locations')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(2),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg, A2($author$project$Components$Affiliates$LinkRecordsModal$button, model.pr, 1))
                ]))
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Manage links between affiliate locations and your network.')
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$loading(loading),
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No linked locations.')
                ]))
            ]), A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$locationsColumns), A2($elm$core$List$map, A2($author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocation, model, locations), locations), _List_Nil)
        ]);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$practitionersColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'network_name', false, 'Network Provider Name'),
        A3($author$project$Api$Column$init, 'affiliate_name', false, 'Affiliate Provider Name'),
        A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
        A3($author$project$Api$Column$init, 'active_lives', false, 'Active Synced Patients'),
        A3($author$project$Api$Column$init, 'actions', false, '')
    ]);
    var $author$project$Api$Provider$Affiliates$Practitioner$All$activeLives = function(_v0) {
        var record = _v0;
        return record.Iu;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitioner = F3(function(model, practitioners, practitioner) {
        var remainingPractitioners = A2($elm$core$List$filter, function(remainingPractitioner) {
            return !_Utils_eq($author$project$Api$Provider$Affiliates$Practitioner$All$id(practitioner), $author$project$Api$Provider$Affiliates$Practitioner$All$id(remainingPractitioner));
        }, practitioners);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Affiliates$Practitioner$All$name(practitioner))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Practitioner$Min$name($author$project$Api$Provider$Affiliates$Practitioner$All$affiliatePractitioner(practitioner)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Affiliates$Practitioner$All$activeLives(practitioner)))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg, A2($author$project$Components$Affiliates$UnlinkRecordsModal$button, model.pr, A2($author$project$Components$Affiliates$UnlinkRecordsModal$Practitioner, practitioner, remainingPractitioners)))
            ]))
        ]));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitionersTable = function(model) {
        var network = $author$project$Api$Provider$Practice$One$network(model.W1);
        var _v0 = function() {
            var _v1 = model.Xc;
            if (_v1.$ === 3) {
                var practitioners_ = _v1.a;
                return _Utils_Tuple2(false, practitioners_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var practitioners = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(10)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network)) ? $elm$html$Html$text('Providers') : $elm$html$Html$text('Linked Providers')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(2),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg, A2($author$project$Components$Affiliates$LinkRecordsModal$button, model.pr, 0))
                ]))
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Manage links between affiliate providers and your network.')
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$loading(loading),
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No linked providers.')
                ]))
            ]), A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$practitionersColumns), A2($elm$core$List$map, A2($author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitioner, model, practitioners), practitioners), _List_Nil)
        ]);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$view = function(model) {
        var network = $author$project$Api$Provider$Practice$One$network(model.W1);
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$UnlinkRecordsModalMsg, $author$project$Components$Affiliates$UnlinkRecordsModal$modal(model.o_)),
                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$LinkRecordsModalMsg, $author$project$Components$Affiliates$LinkRecordsModal$modal(model.mU)),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _Utils_ap($author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewPractitionersTable(model), A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, network)) ? $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$viewLocationsTable(model) : _List_Nil))
                ]))
            ]),
            $2: 'Affiliates | Linked Providers'
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$init,
        aeR: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$load,
        ag3: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$save,
        ahE: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$subscriptions,
        aaO: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$update,
        aid: $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$view
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusDropdownMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString = function(statusType) {
        switch(statusType){
            case 0:
                return 'active';
            case 1:
                return 'pending';
            default:
                return 'ended';
        }
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq),
            $elm$core$List$isEmpty(model.g) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'filter', A2($elm$core$String$join, ',', A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, model.g)))),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('company'), model.fl),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('plan'), model.agd),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('practitioner'), model.Xa),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('status'), A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString, model.ahy))
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients({
                pr: model.pr
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$GotAffiliateCoveragePeriods = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                acy: model.fl,
                Fw: model.g,
                af_: model.af_,
                GW: model.agd,
                agi: model.Xa,
                agq: model.agq,
                ahy: A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToString, model.ahy)
            });
        };
    };
    var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath = function(affiliateId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'affiliate_coverage_periods'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$AffiliateCoveragePeriod = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$AffiliateCoveragePeriod = $elm$core$Basics$identity;
    var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$Record = F3(function(status, enrollmentDate, terminationDate) {
        return {
            OZ: enrollmentDate,
            ahy: status,
            $W: terminationDate
        };
    });
    var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enrollment_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$Shared$Record))));
    var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$Record = F8(function(affiliatePeriodInMonths, affiliateRateInCents, networkPeriodInMonths, networkRateInCents, patient, company, practitioner, rateRule) {
        return {
            IT: affiliatePeriodInMonths,
            IW: affiliateRateInCents,
            acy: company,
            UM: networkPeriodInMonths,
            UO: networkRateInCents,
            V7: patient,
            agi: practitioner,
            X7: rateRule
        };
    });
    var $author$project$Api$Provider$RateRule$Min$RateRule = $elm$core$Basics$identity;
    var $author$project$Api$Provider$RateRule$Min$Record = F2(function(type_, name) {
        return {
            zr: name,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$RateRule$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$RateRule$Min$Record)));
    var $author$project$Api$Provider$RateRule$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RateRule$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'network_rate_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'network_period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate_rate_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate_period_in_months', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$All$Record)))))))));
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$AffiliateCoveragePeriod$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateCoveragePeriod$All$AffiliateCoveragePeriod)));
    var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listDefaults = {
        acy: $elm$core$Maybe$Nothing,
        Fw: _List_Nil,
        af_: $author$project$Api$Pagination$init,
        GW: $elm$core$Maybe$Nothing,
        agi: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fw;
                if (!_v1.b) return _List_Nil;
                else {
                    var filters = _v1;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', A2($elm$core$String$join, ',', A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters)))
                    ]);
                }
            }(),
            function() {
                var _v2 = options.acy;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'company', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.GW;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'plan', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.agi;
                if (!_v4.$) {
                    var string = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.ahy;
                if (!_v5.$) {
                    var string = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$list = F4(function(apiClient, affiliateId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$AffiliateCoveragePeriod$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath(affiliateId))));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods = function(model) {
        return A4($author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$list, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams(model), $author$project$Pages$Affiliates$AffiliateId_String$Patients$GotAffiliateCoveragePeriods);
    };
    var $author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo = {
        $: 4
    };
    var $author$project$Api$Provider$Patient$Active = 0;
    var $author$project$Api$Provider$Patient$ActiveMembership = {
        $: 2
    };
    var $author$project$Api$Provider$Patient$Archived = 4;
    var $author$project$Api$Provider$Patient$AutopayEnabled = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$CurrentlyEngaged = 0;
    var $author$project$Api$Provider$Patient$Engaged = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Inactive = 1;
    var $author$project$Api$Provider$Patient$NeverEngaged = 2;
    var $author$project$Api$Provider$Patient$NewActivationsSinceDate = {
        $: 10
    };
    var $author$project$Api$Provider$Patient$NewTerminationsSinceDate = {
        $: 11
    };
    var $author$project$Api$Provider$Patient$PastDueCustomerInvoices = {
        $: 3
    };
    var $author$project$Api$Provider$Patient$Pending = 2;
    var $author$project$Api$Provider$Patient$PreviouslyEngaged = 1;
    var $author$project$Api$Provider$Patient$Status = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Unconfirmed = 3;
    var $author$project$Api$Provider$Patient$WithBouncedEmail = {
        $: 14
    };
    var $author$project$Api$Provider$Patient$WithFailedIntegrations = {
        $: 8
    };
    var $author$project$Api$Provider$Patient$WithFlaggedNotes = {
        $: 7
    };
    var $author$project$Api$Provider$Patient$WithUnsubscribedEmails = {
        $: 15
    };
    var $author$project$Api$Provider$Patient$WithUnsyncedIntegrations = {
        $: 9
    };
    var $author$project$Api$Provider$Patient$WithUpcomingBirthday = {
        $: 12
    };
    var $author$project$Api$Provider$Patient$filterFromString = function(filter) {
        switch(filter){
            case 'current_membership':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Status(0));
            case 'future_membership':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Status(2));
            case 'with_unconfirmed_membership':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Status(3));
            case 'inactive':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Status(1));
            case 'archived':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Status(4));
            case 'with_autopay':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$AutopayEnabled(true));
            case 'without_autopay':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$AutopayEnabled(false));
            case 'active_membership':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$ActiveMembership);
            case 'past_due_customer_invoices':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$PastDueCustomerInvoices);
            case 'account_owner_without_payment_info':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo);
            case 'without_hipaa_authorization':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithoutHipaaAuthorization);
            case 'without_email':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithoutEmail);
            case 'with_flagged_notes':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFlaggedNotes);
            case 'with_failed_sync':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFailedIntegrations);
            case 'with_failed_integrations':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithFailedIntegrations);
            case 'with_unsynced_integrations':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUnsyncedIntegrations);
            case 'new_activations_since_date':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$NewActivationsSinceDate);
            case 'new_terminations_since_date':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$NewTerminationsSinceDate);
            case 'with_upcoming_birthday':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUpcomingBirthday);
            case 'currently_engaged':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Engaged(0));
            case 'previously_engaged':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Engaged(1));
            case 'never_engaged':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Engaged(2));
            case 'with_bounced_emails':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithBouncedEmail);
            case 'with_unsubscribed_emails':
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$WithUnsubscribedEmails);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$PatientFilter$DropdownMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PatientFilter$init = $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
        aef: 'patient-filter',
        ahX: $author$project$Components$PatientFilter$DropdownMsg
    }));
    var $author$project$Api$Practice$sponsorize = F2(function(practice, string) {
        if (!practice.$) {
            var practice_ = practice.a;
            return A2($author$project$Formatters$String$sponsorize, practice_, string);
        } else return string;
    });
    var $author$project$Utils$Report$CompanyResourceFilter$init = F4(function(apiClient, optionals, practice, companyId) {
        return A2($author$project$Components$ResourceFilter$Company$init, apiClient, A2($elm$core$Basics$composeL, optionals, function(d) {
            return _Utils_update(d, {
                Ee: 'All ' + A2($author$project$Api$Practice$sponsorize, practice, 'Companies'),
                agj: companyId
            });
        }));
    });
    var $author$project$Utils$Report$PlanResourceFilter$init = F4(function(apiClient, optionals, session, planId) {
        return A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, $elm$core$Basics$identity, A2($elm$core$Basics$composeL, optionals, function(d) {
            return _Utils_update(d, {
                Ee: 'All Plans',
                agj: planId
            });
        }));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Active = 0;
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Ended = 2;
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$Pending = 1;
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$stringToStatusType = function(str) {
        switch(str){
            case 'active':
                return $elm$core$Maybe$Just(0);
            case 'pending':
                return $elm$core$Maybe$Just(1);
            case 'ended':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var planId = A2($elm$core$Dict$get, 'plan', query);
        var companyId = A2($elm$core$Dict$get, 'company', query);
        var _v1 = A3($author$project$Components$ResourceFilter$Practitioner$init, shared.Ej, function(d) {
            return _Utils_update(d, {
                Eb: $elm$core$Maybe$Just(params.pr)
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'All Providers',
                afn: true
            });
        });
        var practitionerResourceFilter = _v1.a;
        var practitionerResourceFilterCmd = _v1.b;
        var _v2 = A4($author$project$Utils$Report$PlanResourceFilter$init, shared.Ej, function(d) {
            return _Utils_update(d, {
                afn: true
            });
        }, session, planId);
        var planResourceFilter = _v2.a;
        var planResourceFilterCmd = _v2.b;
        var _v3 = A4($author$project$Utils$Report$CompanyResourceFilter$init, shared.Ej, function(d) {
            return _Utils_update(d, {
                afn: true
            });
        }, $author$project$Api$Practice$Provider(practice), companyId);
        var companyResourceFilter = _v3.a;
        var companyResourceFilterCmd = _v3.b;
        var model = {
            cz: $author$project$Api$Data$Loading,
            pr: params.pr,
            Ej: shared.Ej,
            EF: A3($author$project$Permission$canGoTo, session, shared.aeb, 44),
            fl: companyId,
            pY: companyResourceFilter,
            g: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$filterMap($author$project$Api$Provider$Patient$filterFromString), A2($elm$core$Maybe$map, $elm$core$String$split(','), A2($elm$core$Dict$get, 'filter', query)))),
            F3: $author$project$Shared$isHintAdmin(shared),
            af_: $author$project$Api$Pagination$initFromQuery(query),
            jq: $author$project$Components$PatientFilter$init,
            agd: planId,
            jy: planResourceFilter,
            W1: practice,
            Xa: A2($elm$core$Dict$get, 'practitioner', query),
            jE: practitionerResourceFilter,
            agq: q,
            eA: false,
            sG: $author$project$Ui$SearchInput$init(q),
            ahy: A2($elm$core$Maybe$andThen, $author$project$Pages$Affiliates$AffiliateId_String$Patients$stringToStatusType, A2($elm$core$Dict$get, 'status', query)),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'status-dropdown-filter',
                ahX: $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(model),
            A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg, companyResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg, planResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal = {
        $: 12
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PatientFilter$subscriptions = function(model) {
        return $author$project$Ui$Dropdown$subscriptions(model);
    };
    var $author$project$Components$ResourceFilter$Company$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg, $author$project$Components$PatientFilter$subscriptions(model.jq)),
            model.eA ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal) : $elm$core$Platform$Sub$none,
            $author$project$Ui$Dropdown$subscriptions(model.oD),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg, $author$project$Components$ResourceFilter$Plan$subscriptions(model.jy)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg, $author$project$Components$ResourceFilter$Company$subscriptions(model.pY)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg, $author$project$Components$ResourceFilter$Practitioner$subscriptions(model.jE))
        ]));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ResyncTriggered = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliate$syncPlansAndFailedSyncs = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'sync_plans_and_failed_syncs'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(id_))));
    });
    var $author$project$Components$PatientFilter$FilterSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PatientFilter$None = {
        $: 0
    };
    var $author$project$Components$PatientFilter$update = F2(function(msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model);
            var dropdown = _v1.a;
            var cmd = _v1.b;
            return _Utils_Tuple3(dropdown, cmd, $author$project$Components$PatientFilter$None);
        } else {
            var patientFilter = msg.a;
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$PatientFilter$FilterSelected(patientFilter));
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale = F3(function(getter, currentModel, newModel) {
        var updatedModel = _Utils_eq(getter(currentModel), getter(newModel)) ? newModel : _Utils_update(newModel, {
            cz: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$reset(newModel.af_)
        });
        return _Utils_eq(getter(currentModel), getter(newModel)) ? _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(updatedModel),
            A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(updatedModel)
        ])));
    });
    var $author$project$Components$ResourceFilter$Company$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cz: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cz: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            cz: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(qModel),
                            A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v5 = A2($author$project$Components$PatientFilter$update, subMsg, model.jq);
                var patientFilter = _v5.a;
                var cmd = _v5.b;
                var event = _v5.c;
                if (event.$ === 1) {
                    var selectedFilters = event.a;
                    var newModel = _Utils_update(model, {
                        cz: $author$project$Api$Data$Loading,
                        g: selectedFilters,
                        af_: $author$project$Api$Pagination$reset(model.af_),
                        jq: patientFilter
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
                        A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg, cmd)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    jq: patientFilter
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg, cmd), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, model.Ej, subMsg, model.pY);
                var companyId = function() {
                    var _v8 = companyResourceResult.adu;
                    if (!_v8.$) {
                        if (!_v8.a.$) return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.zi);
                        else {
                            var _v9 = _v8.a;
                            return model.fl;
                        }
                    } else return model.fl;
                }();
                var _v7 = A3($author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale, function($) {
                    return $.fl;
                }, model, _Utils_update(model, {
                    fl: companyId,
                    pY: companyResourceResult.zi
                }));
                var newModel = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg, companyResourceResult.EQ),
                    cmd
                ])), companyResourceResult.at);
            case 4:
                var subMsg = msg.a;
                var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.Ej, subMsg, model.jy);
                var planId = function() {
                    var _v11 = planResourceResult.adu;
                    if (!_v11.$) {
                        if (!_v11.a.$) return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.zi);
                        else {
                            var _v12 = _v11.a;
                            return model.agd;
                        }
                    } else return model.agd;
                }();
                var _v10 = A3($author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale, function($) {
                    return $.agd;
                }, model, _Utils_update(model, {
                    agd: planId,
                    jy: planResourceResult.zi
                }));
                var newModel = _v10.a;
                var cmd = _v10.b;
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg, planResourceResult.EQ),
                    cmd
                ])), planResourceResult.at);
            case 5:
                var subMsg = msg.a;
                var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, model.Ej, subMsg, model.jE);
                var practitionerId = function() {
                    var _v14 = practitionerResourceResult.adu;
                    if (!_v14.$) {
                        if (!_v14.a.$) return $author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.zi);
                        else {
                            var _v15 = _v14.a;
                            return model.Xa;
                        }
                    } else return model.Xa;
                }();
                var _v13 = A3($author$project$Pages$Affiliates$AffiliateId_String$Patients$updateIfStale, function($) {
                    return $.Xa;
                }, model, _Utils_update(model, {
                    Xa: practitionerId,
                    jE: practitionerResourceResult.zi
                }));
                var newModel = _v13.a;
                var cmd = _v13.b;
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg, practitionerResourceResult.EQ),
                    cmd
                ])), practitionerResourceResult.at);
            case 6:
                var subMsg = msg.a;
                var _v16 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v16.a;
                var cmd = _v16.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), cmd, _List_Nil);
            case 7:
                var selectedStatus = msg.a;
                var newModel = _Utils_update(model, {
                    cz: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ahy: selectedStatus
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 8:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    cz: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchAffiliateCoveragePeriods(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$AffiliateId_String$Patients$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 9:
                return _Utils_Tuple3(_Utils_update(model, {
                    eA: true
                }), A3($author$project$Api$Provider$Affiliate$syncPlansAndFailedSyncs, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$Patients$ResyncTriggered), _List_Nil);
            case 10:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    eA: false
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Re-sync triggered successfully')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    eA: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                return _Utils_Tuple3(_Utils_update(model, {
                    eA: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                return _Utils_Tuple3(_Utils_update(model, {
                    eA: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v18 = $author$project$Components$FileLink$update(subMsg);
                var getFileCmdMsg = _v18.a;
                var outMsgs = _v18.b;
                return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg, getFileCmdMsg), outMsgs);
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$PaginationMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$ShowResyncWarningModal = {
        $: 11
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$TriggerResync = {
        $: 9
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$columns = function(practice) {
        return _List_fromArray([
            A3($author$project$Api$Column$init, 'name', false, 'Name'),
            A3($author$project$Api$Column$init, 'plan_type', false, 'Plan Type'),
            A3($author$project$Api$Column$init, 'company', false, A2($author$project$Formatters$String$sponsorize, practice, 'Employer')),
            A3($author$project$Api$Column$init, 'practitioner', false, 'Provider'),
            A3($author$project$Api$Column$init, 'affiliate_rate', false, 'Affiliate Rate'),
            A3($author$project$Api$Column$init, 'total_in_cents', false, 'Total Rate'),
            A3($author$project$Api$Column$init, 'status', false, 'Status')
        ]);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$exportCsvPath = function(model) {
        var csvParams = A2($elm$core$List$concatMap, $author$project$Api$Param$toQuery, $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$listOptionsToParams($author$project$Pages$Affiliates$AffiliateId_String$Patients$fetchParams(model)));
        return A4($author$project$Api$Data$downloadUrl, model.Ej, $author$project$Api$Provider$Affiliates$AffiliateCoveragePeriod$affiliateCoveragePeriodsPath(model.pr), 0, csvParams);
    };
    var $author$project$Components$PatientFilter$FilterSelected_ = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PatientFilter$isAutopayFilter = function(filter) {
        if (filter.$ === 1) return true;
        else return false;
    };
    var $author$project$Components$PatientFilter$isEngagedFilter = function(filter) {
        if (filter.$ === 13) return true;
        else return false;
    };
    var $author$project$Components$PatientFilter$isStatusFilter = function(filter) {
        if (!filter.$) return true;
        else return false;
    };
    var $author$project$Components$PatientFilter$checkedItem = F2(function(filter, currentFilters) {
        return A2($elm$core$List$member, filter, currentFilters) ? A2($elm$core$List$filter, function(current) {
            return !_Utils_eq(current, filter);
        }, currentFilters) : A2($elm$core$List$cons, filter, function() {
            switch(filter.$){
                case 0:
                    return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isStatusFilter), currentFilters);
                case 1:
                    return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isAutopayFilter), currentFilters);
                case 13:
                    return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Components$PatientFilter$isEngagedFilter), currentFilters);
                default:
                    return currentFilters;
            }
        }());
    });
    var $author$project$Components$PatientFilter$clearCategoryFilters = F2(function(predicate, currentFilters) {
        return A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$Basics$not, predicate), currentFilters);
    });
    var $author$project$Components$PatientFilter$filterToLabel = function(filter) {
        switch(filter.$){
            case 0:
                switch(filter.a){
                    case 0:
                        var _v1 = filter.a;
                        return 'Active Patients';
                    case 2:
                        var _v2 = filter.a;
                        return 'Pending';
                    case 3:
                        var _v3 = filter.a;
                        return 'Unconfirmed';
                    case 1:
                        var _v4 = filter.a;
                        return 'Inactive';
                    default:
                        var _v5 = filter.a;
                        return 'Archived Patients';
                }
            case 1:
                if (filter.a) return 'Autopay Enabled';
                else return 'Autopay Disabled';
            case 2:
                return 'Active and Paid';
            case 3:
                return 'Has Past Due Invoices';
            case 4:
                return 'No Payment Info';
            case 5:
                return 'No ePHI waiver';
            case 6:
                return 'No Email Address';
            case 7:
                return 'Has Flagged Notes';
            case 15:
                return 'Unsubscribed From Emails';
            case 14:
                return 'Has Bounced Emails';
            case 9:
                return 'Unsynced Integration';
            case 8:
                return 'Failed Sync';
            case 10:
                return 'New Activations';
            case 11:
                return 'New Terminations';
            case 12:
                return 'Upcoming Birthdays';
            default:
                switch(filter.a){
                    case 0:
                        var _v6 = filter.a;
                        return 'Currently Engaged';
                    case 1:
                        var _v7 = filter.a;
                        return 'Previously Engaged';
                    default:
                        var _v8 = filter.a;
                        return 'Never Engaged';
                }
        }
    };
    var $author$project$Ui$Dropdown$Radio = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Dropdown$radio = $author$project$Ui$Dropdown$Radio;
    var $author$project$Components$PatientFilter$dropdownItems = F2(function(practice, currentFilters) {
        var radioItem = function(filter) {
            return A2($author$project$Ui$Dropdown$radio, _List_fromArray([
                $author$project$Ui$Dropdown$onCheck($elm$core$Basics$always($author$project$Components$PatientFilter$FilterSelected_(A2($author$project$Components$PatientFilter$checkedItem, filter, currentFilters)))),
                $author$project$Ui$Dropdown$checked(A2($elm$core$List$member, filter, currentFilters))
            ]), $elm$html$Html$text($author$project$Components$PatientFilter$filterToLabel(filter)));
        };
        var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
        var gateIsAvailable = A2($author$project$Utils$FeatureGate$gateAvailable, 11, $author$project$Api$Practice$Provider(practice));
        var engagementFilters = function() {
            if (gateIsAvailable || practiceIsAffiliateOrNetwork) {
                var anyEngagedItem = A2($author$project$Ui$Dropdown$radio, _List_fromArray([
                    $author$project$Ui$Dropdown$onCheck($elm$core$Basics$always($author$project$Components$PatientFilter$FilterSelected_(A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isEngagedFilter, currentFilters)))),
                    $author$project$Ui$Dropdown$checked(!A2($elm$core$List$any, $author$project$Components$PatientFilter$isEngagedFilter, currentFilters))
                ]), $elm$html$Html$text('Any Engagement'));
                return _List_fromArray([
                    $author$project$Ui$Dropdown$separator,
                    anyEngagedItem,
                    radioItem($author$project$Api$Provider$Patient$Engaged(0)),
                    radioItem($author$project$Api$Provider$Patient$Engaged(1)),
                    radioItem($author$project$Api$Provider$Patient$Engaged(2))
                ]);
            } else return _List_Nil;
        }();
        var checkboxItem = function(filter) {
            return A2($author$project$Ui$Dropdown$checkbox, _List_fromArray([
                $author$project$Ui$Dropdown$onCheck($elm$core$Basics$always($author$project$Components$PatientFilter$FilterSelected_(A2($author$project$Components$PatientFilter$checkedItem, filter, currentFilters)))),
                $author$project$Ui$Dropdown$checked(A2($elm$core$List$member, filter, currentFilters))
            ]), $elm$html$Html$text($author$project$Components$PatientFilter$filterToLabel(filter)));
        };
        var anyStatusItem = A2($author$project$Ui$Dropdown$radio, _List_fromArray([
            $author$project$Ui$Dropdown$onCheck($elm$core$Basics$always($author$project$Components$PatientFilter$FilterSelected_(A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isStatusFilter, currentFilters)))),
            $author$project$Ui$Dropdown$checked(!A2($elm$core$List$any, $author$project$Components$PatientFilter$isStatusFilter, currentFilters))
        ]), $elm$html$Html$text('Any Status'));
        var anyAutopayItem = A2($author$project$Ui$Dropdown$radio, _List_fromArray([
            $author$project$Ui$Dropdown$onCheck($elm$core$Basics$always($author$project$Components$PatientFilter$FilterSelected_(A2($author$project$Components$PatientFilter$clearCategoryFilters, $author$project$Components$PatientFilter$isAutopayFilter, currentFilters)))),
            $author$project$Ui$Dropdown$checked(!A2($elm$core$List$any, $author$project$Components$PatientFilter$isAutopayFilter, currentFilters))
        ]), $elm$html$Html$text('Any Autopay'));
        var baseFilters = _List_fromArray([
            anyStatusItem,
            radioItem($author$project$Api$Provider$Patient$Status(0)),
            radioItem($author$project$Api$Provider$Patient$Status(2)),
            radioItem($author$project$Api$Provider$Patient$Status(3)),
            radioItem($author$project$Api$Provider$Patient$Status(1)),
            radioItem($author$project$Api$Provider$Patient$Status(4)),
            $author$project$Ui$Dropdown$separator,
            anyAutopayItem,
            radioItem($author$project$Api$Provider$Patient$AutopayEnabled(true)),
            radioItem($author$project$Api$Provider$Patient$AutopayEnabled(false)),
            $author$project$Ui$Dropdown$separator,
            checkboxItem($author$project$Api$Provider$Patient$ActiveMembership),
            checkboxItem($author$project$Api$Provider$Patient$PastDueCustomerInvoices),
            checkboxItem($author$project$Api$Provider$Patient$AccountOwnerWithoutPaymentInfo),
            $author$project$Ui$Dropdown$separator,
            checkboxItem($author$project$Api$Provider$Patient$WithoutHipaaAuthorization),
            checkboxItem($author$project$Api$Provider$Patient$WithoutEmail),
            checkboxItem($author$project$Api$Provider$Patient$WithFlaggedNotes),
            checkboxItem($author$project$Api$Provider$Patient$WithUnsubscribedEmails),
            checkboxItem($author$project$Api$Provider$Patient$WithBouncedEmail),
            $author$project$Ui$Dropdown$separator,
            checkboxItem($author$project$Api$Provider$Patient$WithUnsyncedIntegrations),
            checkboxItem($author$project$Api$Provider$Patient$WithFailedIntegrations),
            $author$project$Ui$Dropdown$separator,
            checkboxItem($author$project$Api$Provider$Patient$NewActivationsSinceDate),
            checkboxItem($author$project$Api$Provider$Patient$NewTerminationsSinceDate),
            checkboxItem($author$project$Api$Provider$Patient$WithUpcomingBirthday)
        ]);
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$PatientFilter$FilterSelected_(_List_Nil)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentFilters, _List_Nil))
        ]), $elm$html$Html$text('All Patients')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, _Utils_ap(baseFilters, engagementFilters)));
    });
    var $author$project$Components$PatientFilter$view = F3(function(practice, value, model) {
        var placeholder = function() {
            if (!value.b) return 'All Patients';
            else if (!value.b.b) {
                var single = value.a;
                return $author$project$Components$PatientFilter$filterToLabel(single);
            } else {
                var many = value;
                return $elm$core$String$fromInt($elm$core$List$length(many)) + ' Selected';
            }
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), A2($author$project$Components$PatientFilter$dropdownItems, practice, value), model);
    });
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliatePeriodInMonths = function(_v0) {
        var record = _v0.b;
        return record.IT;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliateRateInCents = function(_v0) {
        var record = _v0.b;
        return record.IW;
    };
    var $author$project$Formatters$Int$asPeriod = function(periodInMonths) {
        switch(periodInMonths){
            case 1:
                return 'Monthly';
            case 3:
                return 'Quarterly';
            case 6:
                return 'Semi-annually';
            case 12:
                return 'Annually';
            default:
                return '/ ' + $elm$core$String$fromInt(periodInMonths);
        }
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$company = function(_v0) {
        var record = _v0.b;
        return record.acy;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$enrollmentDate = function(_v0) {
        var record = _v0;
        return record.OZ;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$enrollmentDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$enrollmentDate(shared);
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$terminationDate = function(_v0) {
        var record = _v0;
        return record.$W;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$terminationDate(shared);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$dateForDisplay = function(affiliateCoveragePeriod) {
        return A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$AffiliateCoveragePeriod$All$enrollmentDate(affiliateCoveragePeriod), $author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate(affiliateCoveragePeriod));
    };
    var $author$project$Api$Provider$RateRule$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkPeriodInMonths = function(_v0) {
        var record = _v0.b;
        return record.UM;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkRateInCents = function(_v0) {
        var record = _v0.b;
        return record.UO;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$practitioner = function(_v0) {
        var record = _v0.b;
        return record.agi;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule = function(_v0) {
        var record = _v0.b;
        return record.X7;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$AffiliateCoveragePeriod$All$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$AffiliateCoveragePeriod$Shared$status(shared);
    };
    var $author$project$Api$Provider$RateRule$Min$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$verbFor = function(affiliateCoveragePeriod) {
        return $author$project$Utils$Maybe$toBool($author$project$Api$Provider$AffiliateCoveragePeriod$All$terminationDate(affiliateCoveragePeriod)) ? $author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod) === 'ended' ? 'ended' : 'ending' : $author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod) === 'pending' ? 'starting' : 'since';
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$viewAffiliateCoveragePeriod = F2(function(canGoToPatients, affiliateCoveragePeriod) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), function() {
                    var _v0 = _Utils_Tuple2($elm$core$Maybe$Just($author$project$Api$Provider$AffiliateCoveragePeriod$All$patient(affiliateCoveragePeriod)), canGoToPatients);
                    if (!_v0.a.$) {
                        if (_v0.b) {
                            var patient = _v0.a.a;
                            return _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: $author$project$Api$Provider$Patient$Min$id(patient)
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(patient))
                                ]))
                            ]);
                        } else {
                            var patient = _v0.a.a;
                            return _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(patient))
                            ]);
                        }
                    } else return _List_Nil;
                }())
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$RateRule$Min$type_, $author$project$Formatters$String$humanize), $author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule(affiliateCoveragePeriod)))),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Min$name, $author$project$Api$Provider$AffiliateCoveragePeriod$All$rateRule(affiliateCoveragePeriod))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Min$name, $author$project$Api$Provider$AffiliateCoveragePeriod$All$company(affiliateCoveragePeriod))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$name, $author$project$Api$Provider$AffiliateCoveragePeriod$All$practitioner(affiliateCoveragePeriod))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v1 = $author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliateRateInCents(affiliateCoveragePeriod);
                if (!_v1.$) {
                    var affiliateRateInCents = _v1.a;
                    return _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(affiliateRateInCents)),
                        $author$project$Utils$Html$noBreakSpace,
                        $elm$html$Html$text($author$project$Formatters$Int$asPeriod($author$project$Api$Provider$AffiliateCoveragePeriod$All$affiliatePeriodInMonths(affiliateCoveragePeriod)))
                    ]);
                } else return _List_Nil;
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v2 = $author$project$Api$Provider$AffiliateCoveragePeriod$All$networkRateInCents(affiliateCoveragePeriod);
                if (!_v2.$) {
                    var networkRateInCents = _v2.a;
                    return _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(networkRateInCents)),
                        $author$project$Utils$Html$noBreakSpace,
                        $elm$html$Html$text($author$project$Formatters$Int$asPeriod($author$project$Api$Provider$AffiliateCoveragePeriod$All$networkPeriodInMonths(affiliateCoveragePeriod)))
                    ]);
                } else return _List_Nil;
            }()),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$colspan(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$AffiliateCoveragePeriod$All$status(affiliateCoveragePeriod)),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Pages$Affiliates$AffiliateId_String$Patients$verbFor(affiliateCoveragePeriod)),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Pages$Affiliates$AffiliateId_String$Patients$dateForDisplay(affiliateCoveragePeriod)))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$ResourceFilter$Company$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel = function(statusType) {
        switch(statusType){
            case 0:
                return 'Active';
            case 1:
                return 'Pending';
            default:
                return 'Ended';
        }
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$viewStatusDropdown = function(model) {
        var currentLabel = function() {
            var _v0 = model.ahy;
            if (!_v0.$) {
                var statusType = _v0.a;
                return $author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel(statusType);
            } else return 'Status';
        }();
        var allStatuses = _List_fromArray([
            0,
            1,
            2
        ]);
        var items = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected($elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Statuses')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(statusType) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Affiliates$AffiliateId_String$Patients$StatusSelected($elm$core$Maybe$Just(statusType)))
            ]), $elm$html$Html$text($author$project$Pages$Affiliates$AffiliateId_String$Patients$statusTypeToLabel(statusType)));
        }, allStatuses)));
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentLabel)
        ]), items, model.oD);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$view = function(model) {
        var _v0 = function() {
            var _v1 = model.cz;
            if (_v1.$ === 3) {
                var affiliateCoveragePeriods_ = _v1.a;
                return _Utils_Tuple2(false, affiliateCoveragePeriods_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var affiliateCoveragePeriods = _v0.b;
        return {
            fb: _List_fromArray([
                model.eA ? A3($author$project$Ui$Modal$view, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal, _List_fromArray([
                    $author$project$Ui$Modal$size(1)
                ]), _List_fromArray([
                    $author$project$Ui$Modal$header(_List_fromArray([
                        $author$project$Ui$Modal$title('Resync mapped plans and failed syncs')
                    ])),
                    $author$project$Ui$Modal$body(_List_fromArray([
                        $elm$html$Html$text('Please don\'t execute the resync more than once an hour. If failures persist after the previous resync, contact the affiliates team instead of running this.')
                    ])),
                    $author$project$Ui$Modal$footer(_List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Close modal'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$CloseResyncWarningModal)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Close')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Resync mapped plans and failed syncs'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$TriggerResync)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Re-sync')
                        ]))
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween,
                            $author$project$Ui$Element$mb2
                        ]), _List_fromArray([
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Patients')
                            ])),
                            model.F3 ? A3($author$project$Ui$HinterOnly$button, {
                                abP: 'Re-sync'
                            }, _List_fromArray([
                                $author$project$Ui$Button$styled(0),
                                $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Patients$ShowResyncWarningModal),
                                $author$project$Ui$Button$sm
                            ]), _List_fromArray([
                                $elm$html$Html$text('Re-sync')
                            ])) : $author$project$Utils$Html$empty
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(12)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6),
                                $author$project$Ui$Grid$spanSm(2)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PatientFilterMsg, A3($author$project$Components$PatientFilter$view, model.W1, model.g, model.jq))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6),
                                $author$project$Ui$Grid$spanSm(2)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$viewNew, _List_Nil, model.pY))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6),
                                $author$project$Ui$Grid$spanSm(2)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$viewNew, _List_Nil, model.jy))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6),
                                $author$project$Ui$Grid$spanSm(2)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$viewNew, _List_Nil, model.jE))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6),
                                $author$project$Ui$Grid$spanSm(2)
                            ]), _List_fromArray([
                                $author$project$Pages$Affiliates$AffiliateId_String$Patients$viewStatusDropdown(model)
                            ]))
                        ]))
                    ])),
                    A4($author$project$Ui$Panel$table, _List_fromArray([
                        $author$project$Ui$Table$loading(loading),
                        $author$project$Ui$Table$zeroState(_List_fromArray([
                            $elm$html$Html$text('No matching results.')
                        ]))
                    ]), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Affiliates$AffiliateId_String$Patients$columns(model.W1)), _List_fromArray([
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$pull(1)
                            ]), _List_fromArray([
                                A3($author$project$Ui$Tooltip$view, _List_Nil, 'Export to CSV', _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$ExportFileMsg, A3($author$project$Components$FileLink$view, {
                                        Li: model.Ej,
                                        PX: 0,
                                        aaT: $author$project$Pages$Affiliates$AffiliateId_String$Patients$exportCsvPath(model)
                                    }, _List_fromArray([
                                        $author$project$Ui$Link$ariaLabel('Export Csv'),
                                        $author$project$Ui$Link$icon($author$project$Ui$Icon$export)
                                    ]), _List_Nil))
                                ]))
                            ]))
                        ]))
                    ])), A2($elm$core$List$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$viewAffiliateCoveragePeriod(model.EF), affiliateCoveragePeriods), _List_Nil),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Patients$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(loading)
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Affiliates | Patients'
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Patients$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$AffiliateId_String$Patients$init,
        aeR: $author$project$Pages$Affiliates$AffiliateId_String$Patients$load,
        ag3: $author$project$Pages$Affiliates$AffiliateId_String$Patients$save,
        ahE: $author$project$Pages$Affiliates$AffiliateId_String$Patients$subscriptions,
        aaO: $author$project$Pages$Affiliates$AffiliateId_String$Patients$update,
        aid: $author$project$Pages$Affiliates$AffiliateId_String$Patients$view
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotAffiliate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotPlans = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$Plan$All$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Affiliates$Plan$One$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Affiliates$Plan$One$Record = F6(function(id, name, billingDate, _default, plan, networkPlans) {
        return {
            Kf: billingDate,
            Nn: _default,
            aef: id,
            zr: name,
            UN: networkPlans,
            GW: plan
        };
    });
    var $author$project$Api$Provider$Affiliates$Plan$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'network_plans', $elm$json$Json$Decode$list($author$project$Api$Provider$Plan$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Plan$One$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_date', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliates$Plan$One$Record)))))));
    var $author$project$Api$Provider$Affiliates$Plan$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$Plan$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Affiliates$Plan$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliates$Plan$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Affiliates$Plan$plansPath = function(affiliateId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'plans'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
    };
    var $author$project$Api$Provider$Affiliates$Plan$list = F3(function(apiClient, affiliateId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Affiliates$Plan$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId)));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans = function(model) {
        return A3($author$project$Api$Provider$Affiliates$Plan$list, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotPlans);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$init = F4(function(session, _v0, shared, _v1) {
        var params = _v1.VU;
        var model = {
            Eb: $author$project$Api$Data$Loading,
            pr: params.pr,
            Ej: shared.Ej,
            dx: false,
            h0: $elm$core$Maybe$Nothing,
            ix: $elm$core$Maybe$Nothing,
            F3: $author$project$Shared$isHintAdmin(shared),
            WO: $author$project$Api$Data$Loading,
            aw: $elm$core$Set$empty,
            Z$: session
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model),
            A3($author$project$Api$Provider$Affiliate$retrieve, shared.Ej, params.pr, $author$project$Pages$Affiliates$AffiliateId_String$Settings$GotAffiliate)
        ])));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal = {
        $: 13
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal);
    };
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$subscriptions, model.h0))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$subscriptions, model.ix))),
            model.dx ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$AffiliationArchived = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Defaulted = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Deleted = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$OutMsg$GoToRouteAction = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliate$One$affiliatePractice = function(_v0) {
        var record = _v0.b;
        return record.IU;
    };
    var $author$project$Api$Provider$Affiliate$archive = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Affiliate$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'archive'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(id_))));
    });
    var $author$project$Api$Provider$Affiliates$Plan$planPath = F2(function(affiliateId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId));
    });
    var $author$project$Api$Provider$Affiliates$Plan$delete = F4(function(apiClient, affiliateId, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)));
    });
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$Model = $elm$core$Basics$identity;
    var $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$Fixed = 0;
    var $author$project$Components$Affiliates$PercentagePlan$initFormFields = {
        adR: $elm$core$Maybe$Nothing,
        zr: $elm$core$Maybe$Nothing,
        af9: $elm$core$Maybe$Nothing,
        agd: $elm$core$Maybe$Nothing,
        agn: 0
    };
    var $author$project$Components$Affiliates$PercentagePlan$initPlanResourceFilter = F2(function(apiClient, session) {
        return A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Plan'
            });
        });
    });
    var $author$project$Components$Affiliates$PercentagePlan$init = F3(function(apiClient, session, affiliatePractice) {
        var _v0 = A2($author$project$Components$Affiliates$PercentagePlan$initPlanResourceFilter, apiClient, session);
        var planResourceFilter = _v0.a;
        var planResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            IU: affiliatePractice,
            PU: $author$project$Utils$Form$init($author$project$Components$Affiliates$PercentagePlan$initFormFields),
            jy: planResourceFilter
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg, planResourceFilterCmd));
    });
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$init = F3(function(apiClient, session, affiliateId) {
        var _v0 = A3($author$project$Components$Affiliates$PercentagePlan$init, apiClient, session, $elm$core$Maybe$Nothing);
        var percentagePlan = _v0.a;
        var percentagePlanCmd = _v0.b;
        return _Utils_Tuple2({
            pr: affiliateId,
            ju: percentagePlan,
            j_: $author$project$Api$Data$NotAsked
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg, percentagePlanCmd));
    });
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$Plan$One$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Affiliates$Plan$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Affiliates$Plan$One$id(one);
    };
    var $author$project$Api$Provider$Affiliates$Plan$One$networkPlans = function(_v0) {
        var record = _v0;
        return record.UN;
    };
    var $author$project$Api$Provider$Affiliates$Plan$All$networkPlans = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(one);
    };
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$init = F4(function(apiClient, session, affiliateId, plan) {
        var _v0 = A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Em: $elm$core$Maybe$Just(affiliateId)
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Plan'
            });
        });
        var planResourceFilter = _v0.a;
        var planResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            kV: false,
            pr: affiliateId,
            aef: $author$project$Api$Provider$Affiliates$Plan$All$id(plan),
            ee: $author$project$Api$Data$NotAsked,
            UN: $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan),
            jy: planResourceFilter,
            eR: $elm$core$Set$empty
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg, planResourceFilterCmd));
    });
    var $author$project$Api$Provider$Affiliates$Plan$makeDefault = F4(function(apiClient, affiliateId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'default'
        ]), A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id))));
    });
    var $author$project$Api$Provider$Affiliates$Plan$One$plan = function(_v0) {
        var record = _v0;
        return record.GW;
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$AffiliatePlanCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Closed = {
        $: 1
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None = {
        $: 0
    };
    var $author$project$Api$Provider$Affiliates$Plan$create = F4(function(apiClient, affiliateId, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('pricing_type', $elm$json$Json$Encode$string(fields.agn)),
            _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
            _Utils_Tuple2('percentage', $elm$json$Json$Encode$float(fields.af9)),
            _Utils_Tuple2('fixed_amount_in_cents', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.adR)),
            _Utils_Tuple2('default_plan', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.Nz))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Affiliates$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$Plan$plansPath(affiliateId))));
    });
    var $author$project$Api$Provider$Affiliates$Plan$One$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$Affiliates$PercentagePlan$Plan = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 1:
                var plan = field.a;
                return _Utils_update(fields, {
                    zr: $elm$core$Maybe$Nothing,
                    agd: A2($elm$core$Maybe$map, $author$project$Api$Plan$id, plan)
                });
            case 0:
                var pricingType = field.a;
                return _Utils_update(fields, {
                    agn: pricingType
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: $author$project$Utils$String$toMaybe(string),
                    agd: $elm$core$Maybe$Nothing
                });
            case 4:
                var _float = field.a;
                return _Utils_update(fields, {
                    af9: _float
                });
            default:
                var _int = field.a;
                return _Utils_update(fields, {
                    adR: _int
                });
        }
    });
    var $author$project$Components$Affiliates$PercentagePlan$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var field = msg.a;
            var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate, field, model.PU);
            return _Utils_Tuple3(_Utils_update(model, {
                PU: newForm
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
            var subMsg = msg.a;
            var planResourceFilterResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jy);
            var modelAfterEvent = function() {
                var _v2 = planResourceFilterResult.adu;
                if (!_v2.$) {
                    if (!_v2.a.$) {
                        if (!_v2.a.a.$) {
                            var plan = _v2.a.a.a;
                            return _Utils_update(model, {
                                PU: A3($author$project$Utils$Form$update, $author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate, $author$project$Components$Affiliates$PercentagePlan$Plan($elm$core$Maybe$Just(plan)), model.PU)
                            });
                        } else return _Utils_update(model, {
                            PU: A3($author$project$Utils$Form$update, $author$project$Components$Affiliates$PercentagePlan$formFieldsUpdate, $author$project$Components$Affiliates$PercentagePlan$Plan($elm$core$Maybe$Nothing), model.PU)
                        });
                    } else {
                        var _v3 = _v2.a;
                        return model;
                    }
                } else return model;
            }();
            return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
                jy: planResourceFilterResult.zi
            }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg, planResourceFilterResult.EQ), planResourceFilterResult.at);
        }
    });
    var $author$project$Components$Affiliates$PercentagePlan$Exising = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$New = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$NameValidation = 1;
    var $author$project$Components$Affiliates$PercentagePlan$validateName = function(fields) {
        var _v0 = _Utils_Tuple2(fields.agn, fields.zr);
        if (_v0.a === 1 && _v0.b.$ === 1) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            return _List_fromArray([
                _Utils_Tuple2(1, 'Please enter a name.')
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Affiliates$PercentagePlan$PercentageValidation = 2;
    var $author$project$Components$Affiliates$PercentagePlan$validatePercentage = function(fields) {
        var _v0 = _Utils_Tuple2(fields.agn, A2($author$project$Utils$Validate$isInvalidPercentage, {
            abI: false,
            y_: $elm$core$Maybe$Nothing,
            Uj: $elm$core$Maybe$Nothing
        }, fields.af9));
        if (_v0.a === 1 && _v0.b) {
            var _v1 = _v0.a;
            return _List_fromArray([
                _Utils_Tuple2(2, 'Please enter a percentage.')
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Affiliates$PercentagePlan$PlanValidation = 0;
    var $author$project$Components$Affiliates$PercentagePlan$validatePlan = F2(function(affiliatePractice, fields) {
        var _v0 = _Utils_Tuple3(affiliatePractice, fields.agn, fields.agd);
        if (!_v0.a.$ && !_v0.b && _v0.c.$ === 1) {
            var _v1 = _v0.b;
            var _v2 = _v0.c;
            return _List_fromArray([
                _Utils_Tuple2(0, 'Please pick a plan.')
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Affiliates$PercentagePlan$formFieldsValidator = function(affiliatePractice) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$PercentagePlan$validatePlan(affiliatePractice)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$PercentagePlan$validateName),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Affiliates$PercentagePlan$validatePercentage)
        ]));
    };
    var $author$project$Components$Affiliates$PercentagePlan$pricingTypeToString = function(pricingType) {
        if (!pricingType) return 'fixed';
        else return 'percentage';
    };
    var $author$project$Components$Affiliates$PercentagePlan$validate = function(_v0) {
        var model = _v0;
        var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Affiliates$PercentagePlan$formFieldsValidator(model.IU), model.PU);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var validatedForm = _v2.a;
            var validFormFields = _v2.b;
            var _v3 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
            var pricingType = _v3.agn;
            var planId = _v3.agd;
            var name = _v3.zr;
            var percentage = _v3.af9;
            var fixedAmountInCents = _v3.adR;
            var percentagePlan = function() {
                if (!planId.$) {
                    var planId_ = planId.a;
                    return $author$project$Components$Affiliates$PercentagePlan$Exising(planId_);
                } else return $author$project$Components$Affiliates$PercentagePlan$New({
                    adR: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fixedAmountInCents),
                    zr: A2($elm$core$Maybe$withDefault, '', name),
                    af9: A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, percentage)),
                    agn: $author$project$Components$Affiliates$PercentagePlan$pricingTypeToString(pricingType)
                });
            }();
            return _Utils_Tuple2(_Utils_update(model, {
                PU: validatedForm
            }), $elm$core$Maybe$Just(percentagePlan));
        } else {
            var validatedForm = _v1.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: validatedForm
            }), $elm$core$Maybe$Nothing);
        }
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$Affiliates$PercentagePlan$update, apiClient, subMsg, model.ju);
                var percentagePlan = _v1.a;
                var percentagePlanCmd = _v1.b;
                var percentagePlanOutMsgs = _v1.c;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg, percentagePlanCmd),
                    adu: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
                    zi: _Utils_update(model, {
                        ju: percentagePlan
                    }),
                    at: percentagePlanOutMsgs
                };
            case 1:
                var _v2 = $author$project$Components$Affiliates$PercentagePlan$validate(model.ju);
                var newPercentagePlan = _v2.a;
                var percentagePlanData = _v2.b;
                var _v3 = function() {
                    if (!percentagePlanData.$) {
                        var percentagePlanData_ = percentagePlanData.a;
                        if (percentagePlanData_.$ === 1) return _Utils_Tuple2(model.j_, $elm$core$Platform$Cmd$none);
                        else {
                            var percentagePlanFields = percentagePlanData_.a;
                            var fields = {
                                Nz: $elm$core$Maybe$Just(true),
                                adR: A2($elm$core$Maybe$map, $elm$core$Basics$negate, percentagePlanFields.adR),
                                zr: percentagePlanFields.zr,
                                af9: percentagePlanFields.af9,
                                agn: percentagePlanFields.agn
                            };
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A4($author$project$Api$Provider$Affiliates$Plan$create, apiClient, model.pr, fields, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Created));
                        }
                    } else return _Utils_Tuple2(model.j_, $elm$core$Platform$Cmd$none);
                }();
                var saveRequest = _v3.a;
                var cmd = _v3.b;
                return {
                    EQ: cmd,
                    adu: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
                    zi: _Utils_update(model, {
                        ju: newPercentagePlan,
                        j_: saveRequest
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var affiliatePlan = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$AffiliatePlanCreated(affiliatePlan),
                        zi: _Utils_update(model, {
                            j_: $author$project$Api$Data$NotAsked
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Affiliates$Plan$One$name(affiliatePlan) + ' plan added!')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AffiliatePlanUpdated = 2;
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Closed = 1;
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Linked = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$None = 0;
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlinked = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Affiliates$Plan$link = F5(function(apiClient, affiliateId, id, networkPlanId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('network_plan_id', $elm$json$Json$Encode$string(networkPlanId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Affiliates$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'link'
        ]), A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)))));
    });
    var $author$project$Api$Provider$Affiliates$Plan$unlink = F5(function(apiClient, affiliateId, id, networkPlanId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('network_plan_id', $elm$json$Json$Encode$string(networkPlanId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Affiliates$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unlink'
        ]), A2($author$project$Api$Provider$Affiliates$Plan$planPath, affiliateId, id)))));
    });
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        kV: true
                    }),
                    at: _List_Nil
                };
            case 2:
                var subMsg = msg.a;
                var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jy);
                var _v1 = function() {
                    var _v2 = planResourceResult.adu;
                    if (!_v2.$ && !_v2.a.$ && !_v2.a.a.$) {
                        var plan = _v2.a.a.a;
                        return _Utils_Tuple2($author$project$Api$Data$Loading, A5($author$project$Api$Provider$Affiliates$Plan$link, apiClient, model.pr, model.aef, $author$project$Api$Plan$id(plan), $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Linked));
                    } else return _Utils_Tuple2(model.ee, $elm$core$Platform$Cmd$none);
                }();
                var linkRequest = _v1.a;
                var cmd = _v1.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg, planResourceResult.EQ)
                    ])),
                    adu: 0,
                    zi: _Utils_update(model, {
                        ee: linkRequest,
                        jy: planResourceResult.zi
                    }),
                    at: planResourceResult.at
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var plan = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: _Utils_update(model, {
                            kV: false,
                            ee: response,
                            UN: $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(plan)
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Network plan linked!')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ee: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var plan = msg.a;
                var id = $author$project$Api$Provider$Plan$One$id(plan);
                return {
                    EQ: A5($author$project$Api$Provider$Affiliates$Plan$unlink, apiClient, model.pr, model.aef, id, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlinked(id)),
                    adu: 0,
                    zi: _Utils_update(model, {
                        eR: A2($elm$core$Set$insert, id, model.eR)
                    }),
                    at: _List_Nil
                };
            default:
                var id = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var plan = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: _Utils_update(model, {
                            ee: response,
                            UN: $author$project$Api$Provider$Affiliates$Plan$One$networkPlans(plan),
                            eR: A2($elm$core$Set$remove, id, model.eR)
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Network plan unlinked!')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ee: response,
                        eR: A2($elm$core$Set$remove, id, model.eR)
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Eb: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    WO: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var _v1 = A3($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$init, model.Ej, model.Z$, model.pr);
                var createNetworkPlanModal = _v1.a;
                var createNetworkPlanModalCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    h0: $elm$core$Maybe$Just(createNetworkPlanModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg, createNetworkPlanModalCmd), _List_Nil);
            case 3:
                var plan = msg.a;
                var _v2 = A4($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$init, model.Ej, model.Z$, model.pr, plan);
                var editNetworkPlanModal = _v2.a;
                var editNetworkPlanModalCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ix: $elm$core$Maybe$Just(editNetworkPlanModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg, editNetworkPlanModalCmd), _List_Nil);
            case 4:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aw: A2($elm$core$Set$insert, id, model.aw)
                }), A4($author$project$Api$Provider$Affiliates$Plan$delete, model.Ej, model.pr, id, $author$project$Pages$Affiliates$AffiliateId_String$Settings$Deleted(id)), _List_Nil);
            case 5:
                var id = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    WO: $author$project$Api$Data$Loading,
                    aw: A2($elm$core$Set$remove, id, model.aw)
                }), $author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Affiliate plan deleted')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    aw: A2($elm$core$Set$remove, id, model.aw)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aw: A2($elm$core$Set$insert, id, model.aw)
                }), A4($author$project$Api$Provider$Affiliates$Plan$makeDefault, model.Ej, model.pr, id, $author$project$Pages$Affiliates$AffiliateId_String$Settings$Defaulted(id)), _List_Nil);
            case 7:
                var id = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    WO: $author$project$Api$Data$Loading,
                    aw: A2($elm$core$Set$remove, id, model.aw)
                }), $author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Affiliate plan is default')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    aw: A2($elm$core$Set$remove, id, model.aw)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var subMsg = msg.a;
                var _v5 = model.h0;
                if (!_v5.$) {
                    var createNetworkPlanModal = _v5.a;
                    var createNetworkPlanModalResult = A3($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$update, model.Ej, subMsg, createNetworkPlanModal);
                    var _v6 = function() {
                        var _v7 = createNetworkPlanModalResult.adu;
                        switch(_v7.$){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createNetworkPlanModalResult.zi), model.WO, $elm$core$Maybe$Nothing);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.WO, $elm$core$Maybe$Nothing);
                            default:
                                var plan = _v7.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, $elm$core$Maybe$Just(plan));
                        }
                    }();
                    var createNetworkPlanModal_ = _v6.a;
                    var plans = _v6.b;
                    var affiliatePlan = _v6.c;
                    var _v8 = function() {
                        if (!affiliatePlan.$) {
                            var affiliatePlan_ = affiliatePlan.a;
                            if ($author$project$Api$Provider$Plan$One$planType($author$project$Api$Provider$Affiliates$Plan$One$plan(affiliatePlan_)) !== 4) {
                                var planId = $author$project$Api$Provider$Plan$One$id($author$project$Api$Provider$Affiliates$Plan$One$plan(affiliatePlan_));
                                var affiliatePracticeId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Affiliate$One$affiliatePractice, $author$project$Api$Provider$Practice$One$organizationId), $author$project$Api$Data$toMaybe(model.Eb)));
                                return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
                                    A3($author$project$OutMsg$SwitchToOrganization, affiliatePracticeId, $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String({
                                        aef: planId
                                    })))
                                ]));
                            } else return _Utils_Tuple2($author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model), _List_Nil);
                        } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
                    }();
                    var cmd = _v8.a;
                    var outMsgs = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        h0: createNetworkPlanModal_,
                        WO: plans
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg, createNetworkPlanModalResult.EQ)
                    ])), _Utils_ap(outMsgs, createNetworkPlanModalResult.at));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v10 = model.ix;
                if (!_v10.$) {
                    var editNetworkPlanModal = _v10.a;
                    var editNetworkPlanModalResult = A3($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$update, model.Ej, subMsg, editNetworkPlanModal);
                    var _v11 = function() {
                        var _v12 = editNetworkPlanModalResult.adu;
                        switch(_v12){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(editNetworkPlanModalResult.zi), model.WO, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.WO, $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Just(editNetworkPlanModalResult.zi), $author$project$Api$Data$Loading, $author$project$Pages$Affiliates$AffiliateId_String$Settings$fetchPlans(model));
                        }
                    }();
                    var editNetworkPlanModal_ = _v11.a;
                    var plans = _v11.b;
                    var cmd = _v11.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ix: editNetworkPlanModal_,
                        WO: plans
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg, editNetworkPlanModalResult.EQ)
                    ])), editNetworkPlanModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                return _Utils_Tuple3(_Utils_update(model, {
                    dx: true
                }), A3($author$project$Api$Provider$Affiliate$archive, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$Settings$AffiliationArchived), _List_Nil);
            case 10:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    Eb: response,
                    dx: false
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
                    pr: model.pr
                })), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Affiliation successfully archived')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    dx: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 12:
                return _Utils_Tuple3(_Utils_update(model, {
                    dx: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    dx: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$AddPlan = {
        $: 2
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$ArchiveAffiliationButtonClicked = {
        $: 11
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$ShowArchiveWarningModal = {
        $: 12
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$columns = function(isHintAdmin) {
        return A2($elm$core$List$cons, A3($author$project$Api$Column$init, '', false, 'Name'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, '', false, 'Billing Cycle'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, '', false, 'Billing Date'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, '', false, 'Affiliate Rate'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, '', false, 'Network Fee Plans'), isHintAdmin ? _List_fromArray([
            A3($author$project$Api$Column$init, '', false, '')
        ]) : _List_Nil)))));
    };
    var $author$project$Api$Provider$Affiliate$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Affiliate$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Affiliate$Shared$status(shared);
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save = {
        $: 1
    };
    var $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCents = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCentsValidation = 3;
    var $author$project$Components$Affiliates$PercentagePlan$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$Name = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$Percentage = 1;
    var $author$project$Components$Affiliates$PercentagePlan$PercentageField = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Platform$Practice$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Platform$Practice$One$name = function(_v0) {
        var min = _v0;
        return $author$project$Api$Platform$Practice$Min$name(min);
    };
    var $author$project$Components$Affiliates$PercentagePlan$PricingType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton = F3(function(currentPricingType, pricingType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentPricingType, pricingType)),
            $author$project$Ui$Button$onClick($author$project$Components$Affiliates$PercentagePlan$FormUpdated($author$project$Components$Affiliates$PercentagePlan$PricingType(pricingType)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Affiliates$PercentagePlan$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            function() {
                var _v1 = model.IU;
                if (!_v1.$) {
                    var affiliatePractice = _v1.a;
                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Account Name'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Platform$Practice$One$name(affiliatePractice))
                            ]))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Payment Type')
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton, fields.agn, 0, '$'),
                    A3($author$project$Components$Affiliates$PercentagePlan$viewPricingTypeButton, fields.agn, 1, '%')
                ]))
            ])),
            function() {
                var _v2 = _Utils_Tuple2(model.IU, fields.agn);
                if (!_v2.a.$ && !_v2.b) {
                    var _v3 = _v2.b;
                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8),
                        $author$project$Ui$Form$Group$label('Affiliate Fee Plan'),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Affiliates$PercentagePlan$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                        ]), model.jy))
                    ]));
                } else return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(6),
                    $author$project$Ui$Form$Group$label('Affiliate Fee Plan Name'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.zr)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$Name)),
                        $author$project$Ui$Form$Input$placeholder('Affiliate Membership'),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                    ]))
                ]));
            }(),
            function() {
                var _v4 = fields.agn;
                if (_v4 === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Amount paid to affiliate'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                        $author$project$Ui$Form$PercentageInput$value(fields.af9),
                        $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$PercentageField)),
                        $author$project$Ui$Form$PercentageInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU)),
                        $author$project$Ui$Form$PercentageInput$placeholder('10')
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
                ]));
                else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = fields.agn;
                if (_v5 === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Amount subtracted per member'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$value(fields.adR),
                        $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Affiliates$PercentagePlan$FormUpdated, $author$project$Components$Affiliates$PercentagePlan$FixedAmountInCents)),
                        $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                        $author$project$Ui$Form$CurrencyInput$errors(A2($author$project$Utils$Form$validationErrors, 3, model.PU)),
                        $author$project$Ui$Form$CurrencyInput$placeholder('10.00')
                    ]))
                ]));
                else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('New Affiliate Fee Plan')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(true),
                    $author$project$Ui$Form$onSubmit($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$PercentagePlanMsg, $author$project$Components$Affiliates$PercentagePlan$view(model.ju))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel and close modal'
                        }, _List_fromArray([
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$CloseModal)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Confirm plan'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                            $author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$Save),
                            $author$project$Ui$Button$fullWidth(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Confirm')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AddNew = {
        $: 1
    };
    var $author$project$Components$ResourceFilter$Loading = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$loading = $author$project$Components$ResourceFilter$Loading;
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlink = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$viewNetworkPlan = F2(function(unlinkingPlans, networkPlan) {
        var loading = A2($elm$core$Set$member, $author$project$Api$Provider$Plan$One$id(networkPlan), unlinkingPlans);
        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Plan$One$name(networkPlan)),
            $author$project$Utils$Html$noBreakSpace,
            A3($author$project$Ui$Button$view, {
                abP: 'Delete plan'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$pull(1),
                $author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$Unlink(networkPlan)),
                $author$project$Ui$Button$loading(loading),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete')
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Edit network fee plans')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(true),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Network fee plans'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(7)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$viewNetworkPlan(model.eR), model.UN)),
                        model.kV ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                                $author$project$Components$ResourceFilter$loading(_Utils_eq(model.ee, $author$project$Api$Data$Loading))
                            ]), model.jy))
                        ])) : $author$project$Utils$Html$empty,
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add network plan'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$AddNew),
                            $author$project$Ui$Button$disabled(model.kV),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add network plan')
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Affiliates$Settings$EditNetworkPlanModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ]))
            ]))
        ]));
    };
    var $author$project$Api$Plan$ProviderOne = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$Plan$One$billingDate = function(_v0) {
        var record = _v0;
        return record.Kf;
    };
    var $author$project$Api$Provider$Affiliates$Plan$All$billingDate = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Affiliates$Plan$One$billingDate(one);
    };
    var $author$project$Api$Provider$Affiliates$Plan$All$name = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Affiliates$Plan$One$name(one);
    };
    var $author$project$Api$Provider$Affiliates$Plan$All$plan = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Affiliates$Plan$One$plan(one);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewNetworkPlan = function(networkPlan) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Plan$One$name(networkPlan))
        ]));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$Delete = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditPlan = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$MakeDefault = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliates$Plan$One$default = function(_v0) {
        var record = _v0;
        return record.Nn;
    };
    var $author$project$Api$Provider$Affiliates$Plan$All$default = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Affiliates$Plan$One$default(one);
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlanButtons = F3(function(isHintAdmin, savingPlans, plan) {
        if (isHintAdmin) {
            var id = $author$project$Api$Provider$Affiliates$Plan$All$id(plan);
            var loading = A2($elm$core$Set$member, id, savingPlans);
            return _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb2
                    ]), _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: 'Edit network fee plans'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$loading(loading),
                            $author$project$Ui$Button$disabled($author$project$Api$Provider$Affiliates$Plan$All$default(plan)),
                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$EditPlan(plan)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Edit network fee plans')
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb2
                    ]), _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: 'Delete network fee plans'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$loading(loading),
                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$Delete(id)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Delete affiliate fee plan')
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Api$Provider$Affiliates$Plan$All$default(plan) ? A2($author$project$Ui$Badge$view, _List_fromArray([
                            $author$project$Ui$Badge$primary
                        ]), _List_fromArray([
                            $elm$html$Html$text('Default')
                        ])) : $author$project$Utils$Html$empty,
                        $author$project$Utils$Html$noBreakSpace,
                        function() {
                            if ($author$project$Api$Provider$Affiliates$Plan$All$default(plan)) return $author$project$Utils$Html$empty;
                            else {
                                var networkPlans = $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan);
                                return $elm$core$List$isEmpty(networkPlans) ? A3($author$project$Ui$HinterOnly$button, {
                                    abP: 'Make default'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$loading(loading),
                                    $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$MakeDefault(id))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Make Default')
                                ])) : $author$project$Utils$Html$empty;
                            }
                        }()
                    ]))
                ]))
            ]);
        } else return _List_Nil;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlan = F3(function(isHintAdmin, savingPlans, plan) {
        var networkPlans = $author$project$Api$Provider$Affiliates$Plan$All$networkPlans(plan);
        return A2($author$project$Ui$Table$row, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Affiliates$Plan$All$name(plan))
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Affiliates$Plan$All$billingDate(plan)),
            $elm$html$Html$text(' day')
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            A3($author$project$Components$Plan$Summary$Pricing$view, $author$project$Api$Plan$ProviderOne($author$project$Api$Provider$Affiliates$Plan$All$plan(plan)), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, $elm$core$List$isEmpty(networkPlans) ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('None')
            ]))
        ]) : A2($elm$core$List$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewNetworkPlan, networkPlans)), A3($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlanButtons, isHintAdmin, savingPlans, plan)))))));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$viewBody = F2(function(model, affiliate) {
        var _v0 = function() {
            var _v1 = model.WO;
            if (_v1.$ === 3) {
                var plans_ = _v1.a;
                return _Utils_Tuple2(false, plans_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var plans = _v0.b;
        return _List_fromArray([
            function() {
                var _v2 = model.h0;
                if (!_v2.$) {
                    var createNetworkPlanModal = _v2.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CreateNetworkPlanModalMsg, $author$project$Components$Affiliates$Settings$CreateNetworkPlanModal$view(createNetworkPlanModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.ix;
                if (!_v3.$) {
                    var editNetworkPlanModal = _v3.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Affiliates$AffiliateId_String$Settings$EditNetworkPlanModalMsg, $author$project$Components$Affiliates$Settings$EditNetworkPlanModal$view(editNetworkPlanModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$rowItemsCenter
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(8)
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Affiliate Fee Plans')
                            ]))
                        ])),
                        function() {
                            if (model.F3) {
                                var isEnded = $author$project$Api$Provider$Affiliate$One$status(affiliate) === 'ended';
                                return A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(4),
                                    $author$project$Ui$Grid$justifyRight
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$gap2
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Archive affiliation'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$danger,
                                            $author$project$Ui$Button$disabled(isEnded),
                                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$ShowArchiveWarningModal),
                                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Archive Affiliation')
                                        ])),
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Add plan'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$AddPlan),
                                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Add Plan')
                                        ]))
                                    ]))
                                ]));
                            } else return $author$project$Ui$Grid$none;
                        }()
                    ]))
                ])),
                A4($author$project$Ui$Panel$table, _List_fromArray([
                    $author$project$Ui$Table$loading(loading),
                    $author$project$Ui$Table$zeroState(_List_fromArray([
                        $elm$html$Html$text('This affiliate does not have any plans.')
                    ]))
                ]), A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Affiliates$AffiliateId_String$Settings$columns(model.F3)), A2($elm$core$List$map, A2($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewPlan, model.F3, model.aw), plans), _List_Nil)
            ])),
            model.dx ? A3($author$project$Ui$Modal$view, $author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal, _List_fromArray([
                $author$project$Ui$Modal$size(1)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Archive affiliation')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    $elm$html$Html$text('Are you sure you want to archive the affiliation?')
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Close warning modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$CloseArchiveWarningModal)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Close')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Archive affiliation'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Settings$ArchiveAffiliationButtonClicked)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Archive')
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty
        ]);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$view = function(model) {
        return {
            fb: function() {
                var _v0 = model.Eb;
                if (_v0.$ === 3) {
                    var affiliate = _v0.a;
                    return A2($author$project$Pages$Affiliates$AffiliateId_String$Settings$viewBody, model, affiliate);
                } else return _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]))
                ]);
            }(),
            $2: 'Affiliates | Fee Plans'
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Settings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$AffiliateId_String$Settings$init,
        aeR: $author$project$Pages$Affiliates$AffiliateId_String$Settings$load,
        ag3: $author$project$Pages$Affiliates$AffiliateId_String$Settings$save,
        ahE: $author$project$Pages$Affiliates$AffiliateId_String$Settings$subscriptions,
        aaO: $author$project$Pages$Affiliates$AffiliateId_String$Settings$update,
        aid: $author$project$Pages$Affiliates$AffiliateId_String$Settings$view
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeUser$Affiliate$PracticeUser = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeUser$Affiliate$Record = F7(function(id, email, role, notificationsEnabled, invitationPending, invitationUrl, user) {
        return {
            OH: email,
            aef: id,
            Ry: invitationPending,
            Rz: invitationUrl,
            U8: notificationsEnabled,
            ag_: role,
            aaX: user
        };
    });
    var $author$project$Api$Provider$PracticeUser$Affiliate$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'user', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_pending', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'notifications_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'role', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeUser$Affiliate$Record))))))));
    var $author$project$Api$Provider$PracticeUser$Affiliate$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeUser$Affiliate$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Affiliates$TeamMember$teamMembersPath = function(affiliateId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'team_members'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId));
    };
    var $author$project$Api$Provider$Affiliates$TeamMember$list = F3(function(apiClient, affiliateId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PracticeUser$Affiliate$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliates$TeamMember$teamMembersPath(affiliateId)));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var params = _v3.VU;
        return _Utils_Tuple2({
            pr: params.pr,
            Ej: apiClient,
            eO: $author$project$Api$Data$Loading
        }, A3($author$project$Api$Provider$Affiliates$TeamMember$list, apiClient, params.pr, $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$GotInvitation = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PracticeUser$Affiliate$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$PracticeUser$Affiliate$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Affiliate$invite = F4(function(apiClient, affiliateId, teamMemberId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('team_member_id', $elm$json$Json$Encode$string(teamMemberId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invite'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId)))));
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    eO: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var url = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(url), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied invite link to clipboard')
                ]));
            case 2:
                var teamMember = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$Affiliate$invite, model.Ej, model.pr, $author$project$Api$Provider$PracticeUser$Affiliate$id(teamMember), $author$project$Pages$Affiliates$AffiliateId_String$Users$GotInvitation($author$project$Api$Provider$PracticeUser$Affiliate$email(teamMember))), _List_Nil);
            default:
                var email = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    eO: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Affiliates$TeamMember$list, model.Ej, model.pr, $author$project$Pages$Affiliates$AffiliateId_String$Users$GotTeamMembers), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'A new invitation is being sent to ' + email)
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', false, 'Name'),
        A3($author$project$Api$Column$init, 'email', false, 'Email'),
        A3($author$project$Api$Column$init, 'role', false, 'role'),
        A3($author$project$Api$Column$init, 'notifications', false, 'Notifications')
    ]);
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeUser$Affiliate$invitationPending = function(_v0) {
        var record = _v0;
        return record.Ry;
    };
    var $author$project$Api$Provider$PracticeUser$Affiliate$notificationsEnabled = function(_v0) {
        var record = _v0;
        return record.U8;
    };
    var $author$project$Api$Provider$PracticeUser$Affiliate$role = function(_v0) {
        var record = _v0;
        return record.ag_;
    };
    var $author$project$Api$Provider$PracticeUser$Affiliate$user = function(_v0) {
        var record = _v0;
        return record.aaX;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$CopyInviteLink = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeUser$Affiliate$invitationUrl = function(_v0) {
        var record = _v0;
        return record.Rz;
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$viewCopyInviteLink = function(teamMember) {
        var _v0 = $author$project$Api$Provider$PracticeUser$Affiliate$invitationUrl(teamMember);
        if (!_v0.$) {
            var url = _v0.a;
            return A3($author$project$Ui$Button$view, {
                abP: 'Copy invite link'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Users$CopyInviteLink(url)),
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
            ]), _List_fromArray([
                $elm$html$Html$text('Copy Invite Link')
            ]));
        } else return $elm$html$Html$text('');
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$viewTeamMember = function(teamMember) {
        var notificationsStatus = $author$project$Api$Provider$PracticeUser$Affiliate$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$minWidth('11em')
            ]), function() {
                var _v0 = $author$project$Api$Provider$PracticeUser$Affiliate$user(teamMember);
                if (!_v0.$) {
                    var user = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$User$One$name(user))
                        ]))
                    ]);
                } else return $author$project$Api$Provider$PracticeUser$Affiliate$invitationPending(teamMember) ? _List_fromArray([
                    A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Invitation Pending ')
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Resend invitation email'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember(teamMember)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Resend')
                        ])),
                        $author$project$Pages$Affiliates$AffiliateId_String$Users$viewCopyInviteLink(teamMember)
                    ]))
                ]) : _List_fromArray([
                    A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Not Invited ')
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Send invitation email'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$AffiliateId_String$Users$ReInviteTeamMember(teamMember)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Invite')
                        ]))
                    ]))
                ]);
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$PracticeUser$Affiliate$email(teamMember))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Formatters$String$humanize($author$project$Api$Provider$PracticeUser$Affiliate$role(teamMember))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
            ]))
        ]));
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$view = function(model) {
        var _v0 = function() {
            var _v1 = model.eO;
            if (_v1.$ === 3) {
                var teamMembers_ = _v1.a;
                return _Utils_Tuple2(false, teamMembers_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var teamMembers = _v0.b;
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Users')
                        ]))
                    ])),
                    A4($author$project$Ui$Panel$table, _List_fromArray([
                        $author$project$Ui$Table$loading(loading),
                        $author$project$Ui$Table$zeroState(_List_fromArray([
                            $elm$html$Html$text('This affiliate does not have any users.')
                        ]))
                    ]), A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Affiliates$AffiliateId_String$Users$columns), A2($elm$core$List$map, $author$project$Pages$Affiliates$AffiliateId_String$Users$viewTeamMember, teamMembers), _List_Nil)
                ]))
            ]),
            $2: 'Affiliates | Users'
        };
    };
    var $author$project$Pages$Affiliates$AffiliateId_String$Users$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$AffiliateId_String$Users$init,
        aeR: $author$project$Pages$Affiliates$AffiliateId_String$Users$load,
        ag3: $author$project$Pages$Affiliates$AffiliateId_String$Users$save,
        ahE: $author$project$Pages$Affiliates$AffiliateId_String$Users$subscriptions,
        aaO: $author$project$Pages$Affiliates$AffiliateId_String$Users$update,
        aid: $author$project$Pages$Affiliates$AffiliateId_String$Users$view
    });
    var $author$project$Pages$Affiliates$Create$GotAffiliatePractice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Platform$Practice$One$Practice = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Practice$Min$Practice = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Practice$Min$Record = F5(function(id, name, isDeactivated, flaggedNotesCount, requiresMfa) {
        return {
            PR: flaggedNotesCount,
            aef: id,
            R$: isDeactivated,
            zr: name,
            YL: requiresMfa
        };
    });
    var $author$project$Api$Platform$Practice$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_mfa', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'flagged_notes_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_deactivated', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$Min$Record))))));
    var $author$project$Api$Platform$Practice$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Practice$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Practice$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Practice$Min$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$User$Practice$practicesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practices'
    ]), $author$project$Api$Platform$User$userPath);
    var $author$project$Api$Platform$User$Practice$practicePath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Platform$User$Practice$practicesPath);
    };
    var $author$project$Api$Platform$User$Practice$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Platform$Practice$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$User$Practice$practicePath(id)));
    });
    var $author$project$Pages$Affiliates$Create$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var query = _v1.Bz;
        var cmd = function() {
            var _v2 = A2($elm$core$Dict$get, 'affiliatePracticeId', query);
            if (!_v2.$) {
                var affiliatePracticeId = _v2.a;
                return A3($author$project$Api$Platform$User$Practice$retrieve, apiClient, affiliatePracticeId, $author$project$Pages$Affiliates$Create$GotAffiliatePractice);
            } else return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__New);
        }();
        return _Utils_Tuple2({
            IU: $author$project$Api$Data$Loading,
            abB: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Dict$get, 'affiliatePracticeId', query)),
            Ej: apiClient,
            ju: $elm$core$Maybe$Nothing,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session
        }, cmd);
    });
    var $author$project$Pages$Affiliates$Create$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$Create$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$Create$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Affiliates$Create$AffiliateCreated = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Affiliates$Create$AffiliatePlanCreated = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Affiliates$Create$PercentagePlanMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliate$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('affiliation', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('affiliate_practice_id', $elm$json$Json$Encode$string(fields.abB)),
                _Utils_Tuple2('plan_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agd))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Affiliate$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliate$affiliatesPath)));
    });
    var $author$project$Pages$Affiliates$Create$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var affiliatePractice = response.a;
                        var _v2 = A3($author$project$Components$Affiliates$PercentagePlan$init, model.Ej, model.Z$, $elm$core$Maybe$Just(affiliatePractice));
                        var percentagePlan = _v2.a;
                        var percentagePlanCmd = _v2.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            IU: response,
                            ju: $elm$core$Maybe$Just(percentagePlan)
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Create$PercentagePlanMsg, percentagePlanCmd), _List_Nil);
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            IU: response
                        }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__New), $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            IU: response
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                var subMsg = msg.a;
                var _v3 = model.ju;
                if (!_v3.$) {
                    var percentagePlan = _v3.a;
                    var _v4 = A3($author$project$Components$Affiliates$PercentagePlan$update, model.Ej, subMsg, percentagePlan);
                    var percentagePlan_ = _v4.a;
                    var percentagePlanCmd = _v4.b;
                    var percentagePlanOutMsgs = _v4.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ju: $elm$core$Maybe$Just(percentagePlan_)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Create$PercentagePlanMsg, percentagePlanCmd), percentagePlanOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var _v5 = model.ju;
                if (!_v5.$) {
                    var percentagePlan = _v5.a;
                    var _v6 = $author$project$Components$Affiliates$PercentagePlan$validate(percentagePlan);
                    var newPercentagePlan = _v6.a;
                    var percentagePlanData = _v6.b;
                    var _v7 = function() {
                        if (!percentagePlanData.$) {
                            var percentagePlanData_ = percentagePlanData.a;
                            var planId = function() {
                                if (percentagePlanData_.$ === 1) {
                                    var planId_ = percentagePlanData_.a;
                                    return $elm$core$Maybe$Just(planId_);
                                } else return $elm$core$Maybe$Nothing;
                            }();
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$Affiliate$create, model.Ej, {
                                abB: model.abB,
                                agd: planId
                            }, $author$project$Pages$Affiliates$Create$AffiliateCreated(percentagePlanData_)));
                        } else return _Utils_Tuple2(model.j_, $elm$core$Platform$Cmd$none);
                    }();
                    var saveRequest = _v7.a;
                    var cmd = _v7.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ju: $elm$core$Maybe$Just(newPercentagePlan),
                        j_: saveRequest
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var percentagePlan = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var affiliate = response.a;
                    var _v11 = function() {
                        if (percentagePlan.$ === 1) return _Utils_Tuple2(response, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders({
                            pr: $author$project$Api$Provider$Affiliate$One$id(affiliate)
                        })));
                        else {
                            var percentagePlanFields = percentagePlan.a;
                            var fields = {
                                Nz: $elm$core$Maybe$Just(true),
                                adR: A2($elm$core$Maybe$map, $elm$core$Basics$negate, percentagePlanFields.adR),
                                zr: percentagePlanFields.zr,
                                af9: percentagePlanFields.af9,
                                agn: percentagePlanFields.agn
                            };
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A4($author$project$Api$Provider$Affiliates$Plan$create, model.Ej, $author$project$Api$Provider$Affiliate$One$id(affiliate), fields, $author$project$Pages$Affiliates$Create$AffiliatePlanCreated(affiliate)));
                        }
                    }();
                    var saveRequest = _v11.a;
                    var cmd = _v11.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: saveRequest
                    }), cmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Affiliate added!')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var affiliate = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var affiliatePlan = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders({
                        pr: $author$project$Api$Provider$Affiliate$One$id(affiliate)
                    })), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Affiliates$Plan$One$name(affiliatePlan) + ' plan added!')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Affiliates$Create$Create = {
        $: 2
    };
    var $author$project$Pages$Affiliates$Create$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__Top, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Manage affiliates')
                                ]))
                            ])),
                            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__New, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Add new affiliate')
                                ]))
                            ])),
                            A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                $author$project$Ui$Breadcrumb$active(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Create Affiliation')
                            ]))
                        ]))),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                                $author$project$Ui$Typography$headingSm(_List_fromArray([
                                    $elm$html$Html$text('Create affiliation')
                                ]))
                            ]))
                        ])),
                        function() {
                            var _v0 = model.ju;
                            if (!_v0.$) {
                                var percentagePlan = _v0.a;
                                return A2($author$project$Ui$Form$view, _List_fromArray([
                                    $author$project$Ui$Form$noValidate(true),
                                    $author$project$Ui$Form$autocomplete(true),
                                    $author$project$Ui$Form$onSubmit($author$project$Pages$Affiliates$Create$Create),
                                    $author$project$Ui$Form$horizontal
                                ]), _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Affiliates$Create$PercentagePlanMsg, $author$project$Components$Affiliates$PercentagePlan$view(percentagePlan))
                                ]));
                            } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]));
                        }()
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_fromArray([
                        $author$project$Ui$Element$justifyCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__New, _List_fromArray([
                            $author$project$Ui$Link$buttonDefault
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Create affiliation'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Pages$Affiliates$Create$Create),
                            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Create Affiliation')
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Affiliates'
        };
    };
    var $author$project$Pages$Affiliates$Create$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$Create$init,
        aeR: $author$project$Pages$Affiliates$Create$load,
        ag3: $author$project$Pages$Affiliates$Create$save,
        ahE: $author$project$Pages$Affiliates$Create$subscriptions,
        aaO: $author$project$Pages$Affiliates$Create$update,
        aid: $author$project$Pages$Affiliates$Create$view
    });
    var $author$project$Api$Platform$User$Practice$Affiliates = 0;
    var $author$project$Pages$Affiliates$New$GotPractices = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Platform$Practice$All$Practice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$Practice$All$Record = F4(function(address, organizationId, owner, productType) {
        return {
            II: address,
            afV: organizationId,
            VM: owner,
            G7: productType
        };
    });
    var $author$project$Api$Platform$User$Min$User = $elm$core$Basics$identity;
    var $author$project$Api$Platform$User$Min$Record = F3(function(id, name, email) {
        return {
            OH: email,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Platform$User$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$User$Min$Record))));
    var $author$project$Api$Platform$User$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$User$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Practice$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'product_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Platform$User$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$All$Record)))));
    var $author$project$Api$Platform$Practice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Practice$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Practice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Practice$All$Practice)));
    var $author$project$Api$Platform$User$Practice$expandToString = function(expand) {
        return 'affiliates';
    };
    var $author$project$Api$Platform$User$Practice$listDefaults = {
        Ec: $elm$core$Maybe$Nothing,
        Fq: _List_Nil,
        Fw: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
        HT: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Platform$User$Practice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$User$Practice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fw;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.HT;
                if (!_v2.$) {
                    var bool = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'unaffiliated', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.Ec;
                if (!_v3.$) {
                    var bool = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'affiliated', bool)
                    ]);
                } else return _List_Nil;
            }(),
            _List_fromArray([
                A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Platform$User$Practice$expandToString, options.Fq))
            ]),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Platform$User$Practice$list = F4(function(apiClient, optionals, maybeTracker, toMsg) {
        var request = function(req) {
            if (!maybeTracker.$) {
                var tracker = maybeTracker.a;
                return A2($author$project$Api$Data$requestWithTracker, tracker, req);
            } else return req;
        }(A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$User$Practice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Platform$User$Practice$practicesPath)));
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$Practice$All$decoder), toMsg, request);
    });
    var $author$project$Pages$Affiliates$New$fetchData = function(model) {
        return A4($author$project$Api$Platform$User$Practice$list, model.Ej, function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ]),
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs,
                HT: $elm$core$Maybe$Just(true)
            });
        }, $elm$core$Maybe$Nothing, $author$project$Pages$Affiliates$New$GotPractices);
    };
    var $author$project$Pages$Affiliates$New$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var query = _v3.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: apiClient,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            jD: $author$project$Api$Data$Loading,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$initFromQuery(query))
        };
        return _Utils_Tuple2(model, $author$project$Pages$Affiliates$New$fetchData(model));
    });
    var $author$project$Pages$Affiliates$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Affiliates$New$SearchInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$New$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Affiliates__New)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Affiliates$New$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        jD: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    jD: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            jD: $author$project$Api$Data$Loading,
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Affiliates$New$fetchData(qModel),
                            $author$project$Pages$Affiliates$New$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$New$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    jD: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Affiliates$New$fetchData(newModel),
                    $author$project$Pages$Affiliates$New$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Affiliates$New$fetchData(newModel),
                    $author$project$Pages$Affiliates$New$updateUrl(newModel)
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Affiliates$New$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$New$SortTable = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$New$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'Affiliate Name'),
        A3($author$project$Api$Column$init, 'address', false, 'Address')
    ]);
    var $author$project$Api$Platform$Practice$All$address = function(_v0) {
        var record = _v0.b;
        return record.II;
    };
    var $author$project$Api$Platform$Practice$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Platform$Practice$All$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Practice$Min$id(min);
    };
    var $author$project$Api$Platform$Practice$All$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Practice$Min$name(min);
    };
    var $author$project$Pages$Affiliates$New$viewPractice = function(practice) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Platform$Practice$All$name(practice))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Platform$Practice$All$address(practice);
                    if (!_v0.$) {
                        var address = _v0.a;
                        return $author$project$Components$AddressDisplay$view(address);
                    } else return $elm$html$Html$text('N/A');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__Create, _List_fromArray([
                    $author$project$Ui$Link$buttonDefault,
                    $author$project$Ui$Link$sm,
                    $author$project$Ui$Link$pull(1),
                    $author$project$Ui$Link$routeParams(_List_fromArray([
                        A2($elm$url$Url$Builder$string, 'affiliatePracticeId', $author$project$Api$Platform$Practice$All$id(practice))
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text('Set up an affiliation')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Affiliates$New$view = function(model) {
        var _v0 = function() {
            var _v1 = model.jD;
            if (_v1.$ === 3) {
                var practices_ = _v1.a;
                return _Utils_Tuple2(false, practices_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var practices = _v0.b;
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__Top, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Manage affiliates')
                                ]))
                            ])),
                            A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                $author$project$Ui$Breadcrumb$active(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Add new affiliate')
                            ]))
                        ]))),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter,
                            $author$project$Ui$Element$spaceBetween,
                            $author$project$Ui$Element$mb2
                        ]), _List_fromArray([
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Find new affiliate on this platform')
                            ])),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Hinter__NewPractice, _List_fromArray([
                                $author$project$Ui$Link$buttonDefault,
                                $author$project$Ui$Link$routeParams(_List_fromArray([
                                    A2($elm$url$Url$Builder$string, 'affiliateWizard', $author$project$Utils$Bool$toString(true))
                                ])),
                                $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Create new account')
                            ]))
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mb2
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Affiliates$New$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                        ])),
                        A4($author$project$Ui$Table$view, _List_fromArray([
                            $author$project$Ui$Table$loading(loading),
                            $author$project$Ui$Table$zeroState(_List_fromArray([
                                $elm$html$Html$text('No matching results.')
                            ]))
                        ]), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Affiliates$New$SortTable)), $author$project$Pages$Affiliates$New$columns), _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                        ])), A2($elm$core$List$map, $author$project$Pages$Affiliates$New$viewPractice, practices), _List_Nil)
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Affiliates$New$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(loading)
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Affiliates'
        };
    };
    var $author$project$Pages$Affiliates$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$New$init,
        aeR: $author$project$Pages$Affiliates$New$load,
        ag3: $author$project$Pages$Affiliates$New$save,
        ahE: $author$project$Pages$Affiliates$New$subscriptions,
        aaO: $author$project$Pages$Affiliates$New$update,
        aid: $author$project$Pages$Affiliates$New$view
    });
    var $author$project$Pages$Affiliates$Top$StatusDropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$Top$GotAffiliates = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Affiliate$All$Affiliate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Affiliate$All$Record = F4(function(activeLives, amountOwed, createdFrom, address) {
        return {
            Iu: activeLives,
            II: address,
            Jj: amountOwed,
            acG: createdFrom
        };
    });
    var $author$project$Api$Provider$Affiliate$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_from', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_owed', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_lives', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$All$Record)))));
    var $author$project$Api$Provider$Affiliate$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliate$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliate$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$All$Affiliate)));
    var $author$project$Api$Provider$Affiliate$listDefaults = {
        aef: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agi: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Affiliate$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Affiliate$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.ahy;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v3 = options.agi;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.aeT;
                if (!_v4.$) {
                    var string = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', string)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Provider$Affiliate$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Affiliate$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Affiliate$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Affiliate$affiliatesPath)));
    });
    var $author$project$Pages$Affiliates$Top$statusToValue = function(status) {
        switch(status){
            case 0:
                return 'active';
            case 1:
                return 'pending';
            default:
                return 'ended';
        }
    };
    var $author$project$Pages$Affiliates$Top$fetchData = function(model) {
        return A3($author$project$Api$Provider$Affiliate$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs,
                ahy: A2($elm$core$Maybe$map, $author$project$Pages$Affiliates$Top$statusToValue, model.ahy)
            });
        }, $author$project$Pages$Affiliates$Top$GotAffiliates);
    };
    var $author$project$Pages$Affiliates$Top$Active = 0;
    var $author$project$Pages$Affiliates$Top$Ended = 2;
    var $author$project$Pages$Affiliates$Top$Pending = 1;
    var $author$project$Pages$Affiliates$Top$statusFromQuery = function(queryString) {
        return A2($elm_community$list_extra$List$Extra$find, function(status) {
            return _Utils_eq($author$project$Pages$Affiliates$Top$statusToValue(status), queryString);
        }, _List_fromArray([
            0,
            1,
            2
        ]));
    };
    var $author$project$Pages$Affiliates$Top$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            e0: $author$project$Api$Data$Loading,
            Ej: shared.Ej,
            F3: $author$project$Shared$isHintAdmin(shared),
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$initFromQuery(query)),
            ahy: A2($elm$core$Maybe$andThen, $author$project$Pages$Affiliates$Top$statusFromQuery, A2($elm$core$Dict$get, 'status', query)),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'status-dropdown-filter',
                ahX: $author$project$Pages$Affiliates$Top$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, $author$project$Pages$Affiliates$Top$fetchData(model));
    });
    var $author$project$Pages$Affiliates$Top$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Affiliates$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Affiliates$Top$subscriptions = function(model) {
        return $author$project$Ui$Dropdown$subscriptions(model.oD);
    };
    var $author$project$Pages$Affiliates$Top$SearchInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Pages$Affiliates$Top$statusToValue, $elm$url$Url$Builder$string('status')), model.ahy)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Affiliates__Top)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Affiliates$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        e0: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    e0: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            e0: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Affiliates$Top$fetchData(qModel),
                            $author$project$Pages$Affiliates$Top$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Affiliates$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    e0: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Affiliates$Top$fetchData(newModel),
                    $author$project$Pages$Affiliates$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var dropdown = _v5.a;
                var dropdownCmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: dropdown
                }), dropdownCmd, _List_Nil);
            case 3:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    e0: $author$project$Api$Data$Loading,
                    ahy: status
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Affiliates$Top$fetchData(newModel),
                    $author$project$Pages$Affiliates$Top$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Affiliates$Top$fetchData(newModel),
                    $author$project$Pages$Affiliates$Top$updateUrl(newModel)
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Affiliates$Top$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$Top$SortTable = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'Affiliate Name'),
        A3($author$project$Api$Column$init, 'address', false, 'Address'),
        A3($author$project$Api$Column$init, 'active_lives', false, 'Active Lives'),
        A3($author$project$Api$Column$init, 'amount_owed', false, 'Amount Owed'),
        A3($author$project$Api$Column$init, 'status', true, 'Status')
    ]);
    var $author$project$Api$Provider$Affiliate$All$activeLives = function(_v0) {
        var record = _v0.b;
        return record.Iu;
    };
    var $author$project$Api$Provider$Affiliate$All$address = function(_v0) {
        var record = _v0.b;
        return record.II;
    };
    var $author$project$Api$Provider$Affiliate$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Affiliate$Shared$id(shared);
    };
    var $author$project$Api$Provider$Affiliate$All$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Affiliate$Shared$status(shared);
    };
    var $author$project$Pages$Affiliates$Top$affiliateRoute = function(affiliate) {
        return $author$project$Api$Provider$Affiliate$All$status(affiliate) === 'pending' ? $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders({
            pr: $author$project$Api$Provider$Affiliate$All$id(affiliate)
        }) : $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
            pr: $author$project$Api$Provider$Affiliate$All$id(affiliate)
        });
    };
    var $author$project$Api$Provider$Affiliate$All$amountOwed = function(_v0) {
        var record = _v0.b;
        return record.Jj;
    };
    var $author$project$Api$Provider$Affiliate$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Affiliate$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Affiliate$Shared$name(shared);
    };
    var $author$project$Pages$Affiliates$Top$viewAffiliate = function(affiliate) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Pages$Affiliates$Top$affiliateRoute(affiliate), _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$Affiliate$All$name(affiliate)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Provider$Affiliate$All$address(affiliate);
                    if (!_v0.$) {
                        var address = _v0.a;
                        return $author$project$Components$AddressDisplay$view(address);
                    } else return $elm$html$Html$text('N/A');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Affiliate$All$activeLives(affiliate)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Affiliate$All$amountOwed(affiliate)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Affiliate$All$status(affiliate))
            ]))
        ]));
    };
    var $author$project$Pages$Affiliates$Top$StatusSelected = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Affiliates$Top$statusToLabel = function(status) {
        if (!status.$) switch(status.a){
            case 0:
                var _v1 = status.a;
                return 'Active';
            case 1:
                var _v2 = status.a;
                return 'Pending';
            default:
                var _v3 = status.a;
                return 'Ended';
        }
        else return 'All Status';
    };
    var $author$project$Pages$Affiliates$Top$statusDropdownOptions = function(currentStatus) {
        var statusToItem = function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Affiliates$Top$StatusSelected(status)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(status, currentStatus))
            ]), $elm$html$Html$text($author$project$Pages$Affiliates$Top$statusToLabel(status)));
        };
        return A2($elm$core$List$cons, statusToItem($elm$core$Maybe$Nothing), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, statusToItem), _List_fromArray([
            0,
            1,
            2
        ]))));
    };
    var $author$project$Pages$Affiliates$Top$viewStatusDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Pages$Affiliates$Top$statusToLabel(model.ahy))
        ]), $author$project$Pages$Affiliates$Top$statusDropdownOptions(model.ahy), model.oD);
    };
    var $author$project$Pages$Affiliates$Top$view = function(model) {
        var _v0 = function() {
            var _v1 = model.e0;
            if (_v1.$ === 3) {
                var affiliates_ = _v1.a;
                return _Utils_Tuple2(false, affiliates_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var affiliates = _v0.b;
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(7)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Affiliates$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(2)
                            ]), _List_fromArray([
                                $author$project$Pages$Affiliates$Top$viewStatusDropdown(model)
                            ])),
                            model.F3 ? A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(3)
                            ]), _List_fromArray([
                                A3($author$project$Ui$HinterOnly$linkRoute, $author$project$Spa$Generated$Route$Affiliates__New, _List_fromArray([
                                    $author$project$Ui$Link$buttonDefault,
                                    $author$project$Ui$Link$pull(1),
                                    $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add new affiliate')
                                ]))
                            ])) : $author$project$Ui$Grid$none
                        ]))
                    ])),
                    A4($author$project$Ui$Panel$table, _List_fromArray([
                        $author$project$Ui$Table$loading(loading),
                        $author$project$Ui$Table$zeroState(_List_fromArray([
                            $elm$html$Html$text('No matching results.')
                        ]))
                    ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Affiliates$Top$SortTable)), $author$project$Pages$Affiliates$Top$columns), A2($elm$core$List$map, $author$project$Pages$Affiliates$Top$viewAffiliate, affiliates), _List_Nil),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Affiliates$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(loading)
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Affiliates | Manage'
        };
    };
    var $author$project$Pages$Affiliates$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Affiliates$Top$init,
        aeR: $author$project$Pages$Affiliates$Top$load,
        ag3: $author$project$Pages$Affiliates$Top$save,
        ahE: $author$project$Pages$Affiliates$Top$subscriptions,
        aaO: $author$project$Pages$Affiliates$Top$update,
        aid: $author$project$Pages$Affiliates$Top$view
    });
    var $author$project$Pages$Apps$Slug_String$GotPartnerApp = $elm$core$Basics$identity;
    var $author$project$Api$Common$PartnerApp$One$PartnerApp = $elm$core$Basics$identity;
    var $author$project$Api$Common$PartnerApp$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$PartnerApp$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PartnerApp$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$PartnerApp$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$PartnerApp$partnerAppsPath)));
    });
    var $author$project$Pages$Apps$Slug_String$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            VY: $author$project$Api$Data$Loading,
            W1: practice,
            Z$: session
        }, A3($author$project$Api$Provider$PartnerApp$retrieve, shared.Ej, params._A, $elm$core$Basics$identity));
    });
    var $author$project$Pages$Apps$Slug_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Apps$Slug_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Apps$Slug_String$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Api$Common$PartnerApp$Anchor$isCorePage = function(_v0) {
        var record = _v0;
        var _v1 = record.ah5;
        if (!_v1) return true;
        else return false;
    };
    var $author$project$Api$Common$PartnerApp$Shared$corePageAnchor = function(_v0) {
        var record = _v0;
        return A2($elm_community$list_extra$List$Extra$find, $author$project$Api$Common$PartnerApp$Anchor$isCorePage, record.Eg);
    };
    var $author$project$Api$Common$PartnerApp$Shared$embedsCorePage = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$Shared$corePageAnchor, $elm$core$Basics$neq($elm$core$Maybe$Nothing));
    var $author$project$Api$Common$PartnerApp$One$shared = function(_v0) {
        var shared_ = _v0;
        return shared_;
    };
    var $author$project$Api$Common$PartnerApp$One$embedsCorePage = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$embedsCorePage);
    var $author$project$Api$Common$PartnerApp$One$id = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$id);
    var $author$project$Pages$Apps$Slug_String$update = F2(function(msg, model) {
        var response = msg;
        if (response.$ === 3) {
            var app = response.a;
            var cmd = $author$project$Api$Common$PartnerApp$One$embedsCorePage(app) ? A2($author$project$Ports$PartnerApps$mount, 'partner-app', {
                abN: $author$project$Api$Common$PartnerApp$One$id(app),
                ah5: 'core_page'
            }) : $elm$core$Platform$Cmd$none;
            return _Utils_Tuple3(_Utils_update(model, {
                VY: response
            }), cmd, $author$project$OutMsg$handleErrorResponse(response));
        } else return _Utils_Tuple3(_Utils_update(model, {
            VY: response
        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
    });
    var $author$project$Api$Common$PartnerApp$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Common$PartnerApp$One$name = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$One$shared, $author$project$Api$Common$PartnerApp$Shared$name);
    var $author$project$Pages$Apps$Slug_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('partner-app-wrapper'),
                    $elm$html$Html$Attributes$id('partner-app')
                ]), _List_Nil)
            ]),
            $2: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Common$PartnerApp$One$name, $author$project$Api$Data$toMaybe(model.VY)))
        };
    };
    var $author$project$Pages$Apps$Slug_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Apps$Slug_String$init,
        aeR: $author$project$Pages$Apps$Slug_String$load,
        ag3: $author$project$Pages$Apps$Slug_String$save,
        ahE: $author$project$Pages$Apps$Slug_String$subscriptions,
        aaO: $author$project$Pages$Apps$Slug_String$update,
        aid: $author$project$Pages$Apps$Slug_String$view
    });
    var $author$project$Spa$Page$ignoreEffect = function(model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    };
    var $author$project$Spa$Page$static = function(view) {
        return {
            aeq: F2(function(_v0, url) {
                return _Utils_Tuple3(url, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aeR: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
            ag3: $elm$core$Basics$always($elm$core$Basics$identity),
            ahE: function(_v1) {
                return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(_v2, model) {
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: view
        };
    };
    var $author$project$Pages$Blank$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: ''
        };
    };
    var $author$project$Pages$Blank$page = $author$project$Spa$Page$static($author$project$Pages$Blank$view);
    var $author$project$Pages$Bookkeeping$GotLayerAccount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Bookkeeping$Loading = {
        $: 0
    };
    var $author$project$Pages$Bookkeeping$NavMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Bookkeeping$Overview = 0;
    var $author$project$Ports$Layer$layerPortLoad = _Platform_outgoingPort('layerPortLoad', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Layer$load = $author$project$Ports$Layer$layerPortLoad(0);
    var $author$project$Api$Provider$LayerAccount$One$LayerAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$LayerAccount$Shared$LayerAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LayerAccount$Shared$Record = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Provider$LayerAccount$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$Shared$Record));
    var $author$project$Api$Provider$LayerAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LayerAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$LayerAccount$One$Record = F7(function(legalName, tin, state, entityType, phone, smsEnabled, bookkeepingEnabled) {
        return {
            Km: bookkeepingEnabled,
            O1: entityType,
            S4: legalName,
            WE: phone,
            _C: smsEnabled,
            s4: state,
            $1: tin
        };
    });
    var $author$project$Api$Provider$LayerAccount$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bookkeeping_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sms_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phone', $elm$json$Json$Decode$nullable($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'entity_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'state', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tin', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'legal_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$One$Record))))))));
    var $author$project$Api$Provider$LayerAccount$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LayerAccount$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LayerAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LayerAccount$One$LayerAccount)));
    var $author$project$Api$Provider$Practice$LayerAccount$layerAccountPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'layer_account'
    ]), $author$project$Api$Provider$Practice$practicePath);
    var $author$project$Api$Provider$Practice$LayerAccount$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$LayerAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$layerAccountPath));
    });
    var $author$project$Pages$Bookkeeping$sectionId = function(section) {
        switch(section){
            case 0:
                return 'overview';
            case 1:
                return 'bank-transactions-and-accounts';
            case 2:
                return 'reports';
            default:
                return 'general-ledger';
        }
    };
    var $author$project$Pages$Bookkeeping$BankTransactionsAndAccounts = 1;
    var $author$project$Pages$Bookkeeping$GeneralLedger = 3;
    var $author$project$Pages$Bookkeeping$Reports = 2;
    var $author$project$Pages$Bookkeeping$sections = function(bookkeepingEnabled) {
        return A2($elm$core$List$cons, 0, A2($elm$core$List$cons, 1, A2($elm$core$List$cons, 2, bookkeepingEnabled ? _List_Nil : _List_fromArray([
            3
        ]))));
    };
    var $author$project$Pages$Bookkeeping$updateUrl = function(section) {
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$core$String$append, A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Bookkeeping)
        ]), _List_Nil), '#' + $author$project$Pages$Bookkeeping$sectionId(section)));
    };
    var $author$project$Pages$Bookkeeping$init = F4(function(_v0, practice, shared, _v1) {
        var rawUrl = _v1.agv;
        var section = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, function(fragment) {
            return A2($elm_community$list_extra$List$Extra$find, function(section_) {
                return _Utils_eq($author$project$Pages$Bookkeeping$sectionId(section_), fragment);
            }, $author$project$Pages$Bookkeeping$sections(false));
        }, rawUrl.adZ));
        var _v2 = A2($author$project$Ui$Nav$init, 'bookkeeping-nav', $author$project$Pages$Bookkeeping$NavMsg);
        var nav = _v2.a;
        var navCmd = _v2.b;
        var model = {
            pl: $author$project$Api$Data$Loading,
            Ej: shared.Ej,
            yE: $author$project$Api$Data$Loading,
            nb: nav,
            W1: practice,
            co: section,
            ahy: $author$project$Pages$Bookkeeping$Loading
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            navCmd,
            $author$project$Pages$Bookkeeping$updateUrl(section),
            A2($author$project$Api$Provider$Practice$LayerAccount$retrieve, shared.Ej, $author$project$Pages$Bookkeeping$GotLayerAccount),
            $author$project$Ports$Layer$load
        ])));
    });
    var $author$project$Pages$Bookkeeping$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Bookkeeping$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Bookkeeping$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Pages$Bookkeeping$CreateAccount = {
        $: 2
    };
    var $author$project$Pages$Bookkeeping$GotAccessToken = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Bookkeeping$HasLayerAccountAccount = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$accessTokenPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'access_token'
    ]), $author$project$Api$Provider$Practice$LayerAccount$layerAccountPath);
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$AccessToken = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$Record = F3(function(token, businessId, env) {
        return {
            Kw: businessId,
            O2: env,
            aaf: token
        };
    });
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'env', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'business_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'token', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Practice$LayerAccount$AccessToken$Record))));
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Practice$LayerAccount$AccessToken$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Practice$LayerAccount$AccessToken$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$AccessToken$accessTokenPath));
    });
    var $author$project$Api$Provider$LayerAccount$Shared$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Provider$LayerAccount$Shared$status = A2($elm$core$Basics$composeR, $author$project$Api$Provider$LayerAccount$Shared$record, function($) {
        return $.ahy;
    });
    var $author$project$Api$Provider$LayerAccount$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$LayerAccount$Shared$status(shared);
    };
    var $author$project$Pages$Bookkeeping$update = F2(function(msg, model) {
        switch(msg.$){
            case 2:
                var navMsg = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Bookkeeping$NavMsg), A2($elm$core$Tuple$mapFirst, function(newNav) {
                    return _Utils_update(model, {
                        nb: newNav
                    });
                }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
            case 0:
                var response = msg.a;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        var layerAccount = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            yE: response,
                            ahy: $author$project$Pages$Bookkeeping$HasLayerAccountAccount(layerAccount)
                        }), $author$project$Api$Provider$LayerAccount$One$status(layerAccount) === 'active' ? A2($author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve, model.Ej, $author$project$Pages$Bookkeeping$GotAccessToken) : $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$RefreshPractice
                        ]));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                ahy: $author$project$Pages$Bookkeeping$CreateAccount
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pl: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var section = msg.a;
                var _v3 = _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Api$Provider$Practice$LayerAccount$AccessToken$retrieve, model.Ej, $author$project$Pages$Bookkeeping$GotAccessToken),
                    $author$project$Pages$Bookkeeping$updateUrl(section)
                ])));
                var accessToken = _v3.a;
                var sectionCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    pl: accessToken,
                    co: section
                }), sectionCmd, _List_Nil);
        }
    });
    var $author$project$Api$Feature$Accounting = 15;
    var $author$project$Api$Feature$AccountingWithoutBookkeeping = 16;
    var $author$project$Pages$Bookkeeping$viewCreateAccountBody = _List_fromArray([
        A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Bookkeeping')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textCenter,
                    $author$project$Ui$Element$mt2,
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Go to '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Slug_String({
                            _A: 'bookkeeping'
                        }), _List_Nil, _List_fromArray([
                            $elm$html$Html$text('marketplace')
                        ])),
                        $elm$html$Html$text(' to install.')
                    ])))
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$Bookkeeping$viewLoadingBody = _List_fromArray([
        A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$helpBlock,
            $author$project$Ui$Typography$muted,
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]), _List_Nil)
    ]);
    var $author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled = function(_v0) {
        var record = _v0.b;
        return record.Km;
    };
    var $author$project$Pages$Bookkeeping$SectionChanged = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Bookkeeping$sectionName = function(section) {
        switch(section){
            case 0:
                return 'Overview';
            case 1:
                return 'Bank Transactions and Accounts';
            case 2:
                return 'Reports';
            default:
                return 'General Ledger';
        }
    };
    var $author$project$Pages$Bookkeeping$sectionToNavItem = F2(function(currentSection, section) {
        return A2($author$project$Ui$Nav$item, _List_fromArray([
            $author$project$Ui$Nav$activeItem(_Utils_eq(section, currentSection)),
            $author$project$Ui$Nav$onItemClick($author$project$Pages$Bookkeeping$SectionChanged(section))
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Pages$Bookkeeping$sectionName(section))
        ]));
    });
    var $author$project$WebComponents$Layer$view = F4(function(component, environment, businessId, accessToken) {
        return A3($elm$html$Html$node, 'layer-' + component, _List_fromArray([
            A2($elm$html$Html$Attributes$attribute, 'business-id', businessId),
            A2($elm$html$Html$Attributes$attribute, 'environment', environment),
            A2($elm$html$Html$Attributes$attribute, 'business-access-token', accessToken)
        ]), _List_Nil);
    });
    var $author$project$WebComponents$Layer$accountingOverview = $author$project$WebComponents$Layer$view('accounting-overview');
    var $author$project$WebComponents$Layer$bankTransactionsWithLinkedAccounts = $author$project$WebComponents$Layer$view('bank-transactions-with-linked-accounts');
    var $author$project$WebComponents$Layer$bookkeepingOverview = $author$project$WebComponents$Layer$view('bookkeeping-overview');
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$businessId = function(_v0) {
        var record = _v0;
        return record.Kw;
    };
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$env = function(_v0) {
        var record = _v0;
        return record.O2;
    };
    var $author$project$WebComponents$Layer$generalLedger = $author$project$WebComponents$Layer$view('general-ledger');
    var $author$project$WebComponents$Layer$reports = $author$project$WebComponents$Layer$view('reports');
    var $author$project$Api$Provider$Practice$LayerAccount$AccessToken$token = function(_v0) {
        var record = _v0;
        return record.aaf;
    };
    var $author$project$Pages$Bookkeeping$sectionToComponent = F3(function(layerAccount, accessToken, section) {
        return function(component) {
            return A3(component, $author$project$Api$Provider$Practice$LayerAccount$AccessToken$env(accessToken), $author$project$Api$Provider$Practice$LayerAccount$AccessToken$businessId(accessToken), $author$project$Api$Provider$Practice$LayerAccount$AccessToken$token(accessToken));
        }(function() {
            switch(section){
                case 0:
                    return $author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount) ? $author$project$WebComponents$Layer$bookkeepingOverview : $author$project$WebComponents$Layer$accountingOverview;
                case 1:
                    return $author$project$WebComponents$Layer$bankTransactionsWithLinkedAccounts;
                case 2:
                    return $author$project$WebComponents$Layer$reports;
                default:
                    return $author$project$WebComponents$Layer$generalLedger;
            }
        }());
    });
    var $author$project$Pages$Bookkeeping$toPane = F3(function(layerAccount, accessToken, section) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = _Utils_Tuple2($author$project$Api$Data$toMaybe(layerAccount), $author$project$Api$Data$toMaybe(accessToken));
                    if (!_v0.a.$ && !_v0.b.$) {
                        var layerAccount_ = _v0.a.a;
                        var accessToken_ = _v0.b.a;
                        return A3($author$project$Pages$Bookkeeping$sectionToComponent, layerAccount_, accessToken_, section);
                    } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]));
                }()
            ]))
        ]));
    });
    var $author$project$Pages$Bookkeeping$viewSections = F2(function(layerAccount, model) {
        var sectionNavItems = A2($elm$core$List$map, $author$project$Pages$Bookkeeping$sectionToNavItem(model.co), $author$project$Pages$Bookkeeping$sections($author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount)));
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Bookkeeping')
                    ]))
                ])),
                A3($author$project$Ui$Nav$view, _List_Nil, sectionNavItems, model.nb)
            ])),
            A3($author$project$Pages$Bookkeeping$toPane, model.yE, model.pl, model.co)
        ]);
    });
    var $author$project$Pages$Bookkeeping$view = function(model) {
        var bookkeepingEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 15, model.W1) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 16, model.W1);
        return {
            fb: function() {
                var _v0 = _Utils_Tuple2(bookkeepingEnabled, model.ahy);
                if (_v0.a) switch(_v0.b.$){
                    case 0:
                        var _v1 = _v0.b;
                        return $author$project$Pages$Bookkeeping$viewLoadingBody;
                    case 1:
                        var layerAccount = _v0.b.a;
                        return A2($author$project$Pages$Bookkeeping$viewSections, layerAccount, model);
                    default:
                        var _v2 = _v0.b;
                        return $author$project$Pages$Bookkeeping$viewCreateAccountBody;
                }
                else return _List_Nil;
            }(),
            $2: 'Bookkeeping'
        };
    };
    var $author$project$Pages$Bookkeeping$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Bookkeeping$init,
        aeR: $author$project$Pages$Bookkeeping$load,
        ag3: $author$project$Pages$Bookkeeping$save,
        ahE: $author$project$Pages$Bookkeeping$subscriptions,
        aaO: $author$project$Pages$Bookkeeping$update,
        aid: $author$project$Pages$Bookkeeping$view
    });
    var $author$project$Pages$Calendar$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Calendar$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Calendar$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Calendar$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Calendar'
        };
    };
    var $author$project$Pages$Calendar$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Calendar$init,
        aeR: $author$project$Pages$Calendar$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Calendar$update,
        aid: $author$project$Pages$Calendar$view
    });
    var $author$project$Pages$Charges$New$ChargeFormMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$CategoryResourceFilterMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$EndDateInputMsg = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Charge$Form$LocationResourceFilterMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Charge$Form$PatientResourceFilterMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFieldsMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$StartDateInputMsg = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Charge$Form$RoutingFields$GotCurrentDate = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$initFields = {
        RI: $elm$core$Maybe$Nothing,
        af6: $elm$core$Maybe$Nothing,
        Wh: 0
    };
    var $author$project$Components$Charge$Form$RoutingFields$init = F2(function(apiClient, practice) {
        var _v0 = A2($author$project$Components$ResourceFilter$Patient$init, apiClient, $elm$core$Basics$identity);
        var patientPayerFilter = _v0.a;
        return _Utils_Tuple2({
            cP: $elm$core$Maybe$Nothing,
            cR: $author$project$Api$Data$NotAsked,
            adM: $author$project$Components$Charge$Form$RoutingFields$initFields,
            af_: A2($author$project$Api$Pagination$withItemsPerPage, 20, $author$project$Api$Pagination$init),
            V7: $author$project$Api$Data$NotAsked,
            V8: '',
            el: patientPayerFilter,
            A_: false,
            W1: practice,
            agk: $author$project$Api$Data$NotAsked,
            jF: $author$project$Api$Data$NotAsked,
            gW: $author$project$Api$Data$NotAsked
        }, A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFields$GotCurrentDate, $justinmimbs$date$Date$today));
    });
    var $author$project$Components$Charge$Form$initCategoryResourceFilter = F3(function(apiClient, session, excludeLabs) {
        var excludedCategoryTitles = excludeLabs ? $elm$core$Maybe$Just(_List_fromArray([
            'Labs'
        ])) : $elm$core$Maybe$Nothing;
        return A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                adx: excludedCategoryTitles
            });
        });
    });
    var $author$project$Components$Charge$Form$initChargeItemResourceFilter = F2(function(apiClient, showItemTypeInTitle) {
        return A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Charge Item',
                I5: false,
                ad$: true,
                ad0: '',
                ad7: true,
                ad8: true,
                afn: false
            });
        });
    });
    var $author$project$Components$Charge$Form$initFormFields = F4(function(today, startDateInput, endDateInput, categoryResourceFilter) {
        return {
            EL: $elm$core$Maybe$Nothing,
            cK: categoryResourceFilter,
            lv: $elm$core$Maybe$Nothing,
            M4: today,
            NQ: '',
            N$: 0,
            N0: false,
            qv: $elm$core$Maybe$Nothing,
            qx: endDateInput,
            RA: $elm$core$Maybe$Nothing,
            aeT: $elm$core$Maybe$Nothing,
            zr: $elm$core$Maybe$Nothing,
            V7: $elm$core$Maybe$Nothing,
            GR: $elm$core$Maybe$Nothing,
            Wh: 0,
            agi: $elm$core$Maybe$Nothing,
            Br: $elm$core$Maybe$Nothing,
            Xn: $elm$core$Maybe$Nothing,
            Bu: $elm$core$Maybe$Just(1),
            Bv: $elm$core$Maybe$Nothing,
            _0: today,
            kj: startDateInput
        };
    });
    var $author$project$Components$Charge$Form$initLocationResourceFilter = function(apiClient) {
        return A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
    };
    var $author$project$Api$Provider$Patient$One$record_ = function(_v0) {
        var record = _v0.b;
        return record;
    };
    var $author$project$Api$Provider$Patient$One$age = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.IZ;
    });
    var $author$project$Components$ResourceFilter$Patient$extraItems = F2(function(list_, model) {
        var extraItems_ = A2($elm$core$List$map, function(item) {
            return {
                aeI: _Utils_ap(item.zr, _Utils_ap(function() {
                    var _v0 = item.IZ;
                    if (!_v0.$) {
                        var age = _v0.a;
                        return ' - ' + $elm$core$String$fromInt(age);
                    } else return '';
                }(), !$elm$core$String$isEmpty(item.T5) ? ' - ' + $author$project$Formatters$String$humanize(item.T5) : '')),
                aa9: item.aef
            };
        }, list_);
        return _Utils_update(model, {
            bf: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bf)
        });
    });
    var $author$project$Api$Provider$Patient$One$membershipStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
    };
    var $author$project$Components$Charge$Form$initPatientResourceFilter = F2(function(apiClient, preselectedPatient) {
        return A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Patient$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(patient_) {
            return _List_fromArray([
                {
                    IZ: $author$project$Api$Provider$Patient$One$age(patient_),
                    aef: $author$project$Api$Provider$Patient$One$id(patient_),
                    T5: $author$project$Api$Provider$Patient$One$membershipStatus(patient_),
                    zr: $author$project$Api$Provider$Patient$One$name(patient_)
                }
            ]);
        }, preselectedPatient))), A3($author$project$Components$ResourceFilter$Patient$initWithId, 'charge-form-patient', apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Patient',
                I5: false,
                agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$One$id, preselectedPatient)
            });
        }));
    });
    var $author$project$Components$Charge$Form$initPractitionerResourceFilter = function(apiClient) {
        return A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned'
            });
        });
    };
    var $author$project$Components$Charge$Form$PreloadedPatient = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$preloadPatient = F2(function(apiClient, preselectedPatientId) {
        return A3($author$project$Api$Provider$Patient$retrieve, apiClient, preselectedPatientId, $author$project$Components$Charge$Form$PreloadedPatient);
    });
    var $author$project$Components$Charge$Form$init = F5(function(apiClient, session, practice, preselectedPatientId, _v0) {
        var currentDate = _v0.cP;
        var packageFeatureEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice);
        var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice);
        var _v1 = $author$project$Components$DateInput$init;
        var startDateInput = _v1.a;
        var startDateInputCmd = _v1.b;
        var _v2 = A2($author$project$Components$Charge$Form$RoutingFields$init, apiClient, practice);
        var routingFields = _v2.a;
        var routingFieldsCmd = _v2.b;
        var _v3 = function() {
            if (!preselectedPatientId.$) {
                var patId = preselectedPatientId.a;
                return _Utils_Tuple2(A2($author$project$Components$Charge$Form$preloadPatient, apiClient, patId), $author$project$Api$Data$Loading);
            } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
        }();
        var preloadPatientCmd = _v3.a;
        var preloadedPatientData = _v3.b;
        var _v5 = $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
        var practitionerResourceFilter = _v5.a;
        var practitionerResourceFilterCmd = _v5.b;
        var _v6 = A2($author$project$Components$Charge$Form$initPatientResourceFilter, apiClient, $elm$core$Maybe$Nothing);
        var patientResourceFilter = _v6.a;
        var patientResourceFilterCmd = _v6.b;
        var _v7 = $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
        var locationResourceFilter = _v7.a;
        var locationResourceFilterCmd = _v7.b;
        var _v8 = $author$project$Components$DateInput$init;
        var endDateInput = _v8.a;
        var endDateInputCmd = _v8.b;
        var _v9 = A2($author$project$Components$Charge$Form$initChargeItemResourceFilter, apiClient, packageFeatureEnabled);
        var chargeItemResourceFilter = _v9.a;
        var chargeItemResourceFilterCmd = _v9.b;
        var _v10 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, session, excludeLabs);
        var categoryResourceFilter = _v10.a;
        var categoryResourceFilterCmd = _v10.b;
        return _Utils_Tuple2({
            ach: $author$project$Api$Data$NotAsked,
            e: $author$project$Utils$Form$init(A4($author$project$Components$Charge$Form$initFormFields, $elm$core$Maybe$Just(currentDate), startDateInput, endDateInput, categoryResourceFilter)),
            cL: chargeItemResourceFilter,
            cP: currentDate,
            ro: locationResourceFilter,
            V7: $elm$core$Maybe$Nothing,
            rV: false,
            rX: patientResourceFilter,
            W1: practice,
            jE: practitionerResourceFilter,
            Bp: preloadedPatientData,
            agk: $author$project$Api$Data$NotAsked,
            eq: $jinjor$elm_debounce$Debounce$init,
            Ya: false,
            n3: routingFields,
            Z$: session,
            gP: false,
            kj: startDateInput,
            hh: true
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFieldsMsg, routingFieldsCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$StartDateInputMsg(startDateInput), startDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$EndDateInputMsg(endDateInput), endDateInputCmd),
            preloadPatientCmd
        ])));
    });
    var $author$project$Components$CustomerEmailModal$Closed = {
        $: 0
    };
    var $author$project$Components$CustomerEmailModal$init = $author$project$Components$CustomerEmailModal$Closed;
    var $author$project$Components$CustomerSchedulePaymentModal$Closed = {
        $: 0
    };
    var $author$project$Components$CustomerSchedulePaymentModal$init = $author$project$Components$CustomerSchedulePaymentModal$Closed;
    var $author$project$Components$Charge$Form$withPatientLocked = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            rV: true
        });
    };
    var $author$project$Pages$Charges$New$initEmbeddedChargeForm = function(model) {
        return $author$project$Components$Charge$Form$withPatientLocked(model);
    };
    var $author$project$Pages$Charges$New$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var preselectedPatientId = A2($elm$core$Dict$get, 'patient', query);
        var _v1 = A5($author$project$Components$Charge$Form$init, shared.Ej, session, practice, preselectedPatientId, shared);
        var chargeForm = _v1.a;
        var chargeFormCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            e: (shared.adU.adj ? $author$project$Pages$Charges$New$initEmbeddedChargeForm : $elm$core$Basics$identity)(chargeForm),
            lH: $elm$core$Maybe$Nothing,
            dF: _List_Nil,
            lM: $author$project$Components$CustomerEmailModal$init,
            q5: _List_Nil,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            sp: shared.sp,
            sx: true,
            gG: $author$project$Components$CustomerSchedulePaymentModal$init,
            Z$: session,
            Cu: shared
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormCmd));
    });
    var $author$project$Pages$Charges$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Charges$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Charges$New$CreatePaymentModalMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Charges$New$CustomerEmailModalMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Charges$New$SchedulePaymentModalMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Patient$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Charge$Form$RoutingFields$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, $author$project$Components$ResourceFilter$Patient$subscriptions(model.el));
    };
    var $author$project$Components$ResourceFilter$ChargeItem$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Charge$Form$subscriptions = function(_v0) {
        var model = _v0;
        var _v1 = $author$project$Utils$Form$fields(model.e);
        var categoryResourceFilter = _v1.cK;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, $author$project$Components$ResourceFilter$Patient$subscriptions(model.rX)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg, $author$project$Components$ResourceFilter$ChargeItem$subscriptions(model.cL)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, $author$project$Components$ResourceFilter$Category$subscriptions(categoryResourceFilter)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, $author$project$Components$ResourceFilter$Practitioner$subscriptions(model.jE)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, $author$project$Components$ResourceFilter$Location$subscriptions(model.ro)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Charge$Form$RoutingFieldsMsg, $author$project$Components$Charge$Form$RoutingFields$subscriptions(model.n3))
        ]));
    };
    var $author$project$Components$CustomerEmailModal$Close = {
        $: 1
    };
    var $author$project$Components$CustomerEmailModal$subscriptions = function(model) {
        if (!model.$) return $elm$core$Platform$Sub$none;
        else return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerEmailModal$Close);
    };
    var $author$project$Components$CustomerSchedulePaymentModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$CustomerSchedulePaymentModal$subscriptions = function(model) {
        if (model.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerSchedulePaymentModal$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Charges$New$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Charges$New$CustomerEmailModalMsg, $author$project$Components$CustomerEmailModal$subscriptions(model.lM)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Charges$New$SchedulePaymentModalMsg, $author$project$Components$CustomerSchedulePaymentModal$subscriptions(model.gG)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Charges$New$CreatePaymentModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.lH)))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$subscriptions(model.e)),
            $elm$core$Platform$Sub$batch(A2($elm$core$List$map, function(invoice) {
                return $author$project$Ui$Dropdown$subscriptions(invoice.l_);
            }, model.q5))
        ]));
    };
    var $author$project$Api$Provider$CustomerInvoice$Charges = 0;
    var $author$project$Api$Provider$Notification$CustomerInvoice = 0;
    var $author$project$Pages$Charges$New$Dropdown = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Charges$New$GotCustomerInvoice = F3(function(a, b, c) {
        return {
            $: 7,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Pages$Charges$New$GotPatient = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Charges$New$Issue = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Charges$New$OpenEmail = 2;
    var $author$project$Pages$Charges$New$OpenPaymentProcessing = 0;
    var $author$project$Pages$Charges$New$OpenPaymentRecording = 1;
    var $author$project$Pages$Charges$New$OpenSchedulePayment = 3;
    var $author$project$Components$CustomerEmailModal$PatientOne = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Charges$New$SaveRequest = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Charges$New$Status = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$charge = function(_v0) {
        var model = _v0;
        return model.ach;
    };
    var $author$project$Pages$Charges$New$findInvoice = F2(function(invoices, invoiceId) {
        return $elm$core$List$head(A2($elm$core$List$filter, function(invoice) {
            return _Utils_eq(invoice.aef, invoiceId);
        }, invoices));
    });
    var $author$project$Pages$Charges$New$findDropdownMenu = F2(function(invoices, invoiceId) {
        return A2($elm$core$Maybe$map, function(invoice) {
            return invoice.l_;
        }, A2($author$project$Pages$Charges$New$findInvoice, invoices, invoiceId));
    });
    var $author$project$Components$Charge$Form$hide = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            hh: false
        });
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$humanStatus = function(_v0) {
        var record = _v0;
        return record.QX;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$humanStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$humanStatus(shared);
    };
    var $author$project$Api$Common$Payable$Invoice$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Common$Payable$Invoice$Min$id(min);
    };
    var $author$project$Api$Provider$Charge$One$invoice = function(_v0) {
        var record = _v0.b;
        return record.RA;
    };
    var $author$project$Pages$Charges$New$isDraft = function(invoice) {
        return invoice.ahy === 'draft';
    };
    var $author$project$Api$Provider$CustomerInvoice$customerInvoicesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'customer_invoices'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$CustomerInvoice$customerInvoicePath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicesPath);
    };
    var $author$project$Api$Provider$CustomerInvoice$One$CustomerInvoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CustomerInvoice$Shared$CustomerInvoice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CustomerInvoice$Shared$Record = function(id) {
        return function(date) {
            return function(invoiceNumber) {
                return function(humanStatus) {
                    return function(estimatedDueInCents) {
                        return function(dueInCents) {
                            return function(securePdfInlineToken) {
                                return function(subtotalInCents) {
                                    return function(issuedTotalInCents) {
                                        return function(totalInCents) {
                                            return function(paidInCents) {
                                                return function(creditInCents) {
                                                    return function(taxInCents) {
                                                        return function(isPaymentScheduled) {
                                                            return function(hasGoodPaymentSource) {
                                                                return function(paymentScheduledOn) {
                                                                    return function(passthroughFeesInCents) {
                                                                        return {
                                                                            MD: creditInCents,
                                                                            M4: date,
                                                                            Ol: dueInCents,
                                                                            O7: estimatedDueInCents,
                                                                            Qq: hasGoodPaymentSource,
                                                                            QX: humanStatus,
                                                                            aef: id,
                                                                            RK: invoiceNumber,
                                                                            Si: isPaymentScheduled,
                                                                            SH: issuedTotalInCents,
                                                                            VR: paidInCents,
                                                                            V5: passthroughFeesInCents,
                                                                            Wq: paymentScheduledOn,
                                                                            ZC: securePdfInlineToken,
                                                                            $v: subtotalInCents,
                                                                            $P: taxInCents,
                                                                            aam: totalInCents
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'passthrough_fees_in_cents', $elm$json$Json$Decode$int, 0, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_scheduled_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_good_payment_source', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_payment_scheduled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tax_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credit_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subtotal_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_inline_token', $elm$json$Json$Decode$nullable($author$project$Api$File$Token$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'estimated_due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Shared$Record))))))))))))))))));
    var $author$project$Api$Provider$CustomerInvoice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CustomerInvoice$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CustomerInvoice$One$Record = function(lastSentAt) {
        return function(chargeGroup) {
            return function(meta) {
                return function(source) {
                    return function(membershipPaymentSource) {
                        return function(owner) {
                            return function(location1) {
                                return function(taxProfile) {
                                    return function(charges) {
                                        return function(creditToAutoApplyInCents) {
                                            return function(transferredToCreditInCents) {
                                                return function(payments) {
                                                    return function(adjustments) {
                                                        return function(revisionNumber) {
                                                            return function(voidReason) {
                                                                return function(voidedAt) {
                                                                    return function(voidedByName) {
                                                                        return function(probablePatients) {
                                                                            return function(createdAt) {
                                                                                return {
                                                                                    IR: adjustments,
                                                                                    aci: chargeGroup,
                                                                                    K9: charges,
                                                                                    Mx: createdAt,
                                                                                    ME: creditToAutoApplyInCents,
                                                                                    SY: lastSentAt,
                                                                                    aeT: location1,
                                                                                    T1: membershipPaymentSource,
                                                                                    Ue: meta,
                                                                                    VM: owner,
                                                                                    Wt: payments,
                                                                                    Xr: probablePatients,
                                                                                    Y8: revisionNumber,
                                                                                    Hw: source,
                                                                                    $R: taxProfile,
                                                                                    aax: transferredToCreditInCents,
                                                                                    aif: voidReason,
                                                                                    abf: voidedAt,
                                                                                    abg: voidedByName
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CustomerInvoice$Meta$Record = F2(function(actions, taxProfile) {
        return {
            tM: actions,
            $R: taxProfile
        };
    });
    var $author$project$Api$Provider$CustomerInvoice$Meta$ActionsRecord = function(paymentProcess) {
        return function(recordPayment) {
            return function(schedulePayment) {
                return function(schedulePartialPayments) {
                    return function(markAsSent) {
                        return function(markAsUnsent) {
                            return function(returnToDraft) {
                                return function(markAsBadDebt) {
                                    return function(reverseBadDebt) {
                                        return function(stopRetrying) {
                                            return function(applyCredits) {
                                                return function(removeCredits) {
                                                    return function(destroy) {
                                                        return function(issue) {
                                                            return function(isRevisable) {
                                                                return function(createAdjustment) {
                                                                    return function(transferToCredit) {
                                                                        return function(reverseCreditTransfer) {
                                                                            return function(update) {
                                                                                return function(cancel) {
                                                                                    return {
                                                                                        Jz: applyCredits,
                                                                                        KW: cancel,
                                                                                        Mt: createAdjustment,
                                                                                        NT: destroy,
                                                                                        aeG: isRevisable,
                                                                                        SB: issue,
                                                                                        TD: markAsBadDebt,
                                                                                        TF: markAsSent,
                                                                                        TG: markAsUnsent,
                                                                                        Wn: paymentProcess,
                                                                                        Yi: recordPayment,
                                                                                        Yy: removeCredits,
                                                                                        Y0: returnToDraft,
                                                                                        Y4: reverseBadDebt,
                                                                                        Y5: reverseCreditTransfer,
                                                                                        Zt: schedulePartialPayments,
                                                                                        Zu: schedulePayment,
                                                                                        $b: stopRetrying,
                                                                                        aav: transferToCredit,
                                                                                        aaO: update
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancel', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'update', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reverse_credit_transfer', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transfer_to_credit', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'create_adjustment', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_revisable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issue', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'destroy', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'remove_credits', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'apply_credits', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stop_retrying', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reverse_bad_debt', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mark_as_bad_debt', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'return_to_draft', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mark_as_unsent', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mark_as_sent', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'schedule_partial_payments', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'schedule_payment', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payments_paid', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payments_process', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$ActionsRecord)))))))))))))))))))));
    var $author$project$Api$Provider$CustomerInvoice$Meta$TaxProfileRecord = F2(function(viewable, editable) {
        return {
            Ot: editable,
            abc: viewable
        };
    });
    var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'viewable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$TaxProfileRecord)));
    var $author$project$Api$Provider$CustomerInvoice$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tax_profile', $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$CustomerInvoice$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$Meta$Record)));
    var $author$project$Api$Provider$CustomerInvoice$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CustomerInvoice$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$InvoiceAdjustment = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$InvoiceAdjustment$Shared$InvoiceAdjustment = $elm$core$Basics$identity;
    var $author$project$Api$Provider$InvoiceAdjustment$Shared$Record = function(totalAdjustmentInCents) {
        return {
            ah$: totalAdjustmentInCents
        };
    };
    var $author$project$Api$Provider$InvoiceAdjustment$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_adjustment_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Shared$Record));
    var $author$project$Api$Provider$InvoiceAdjustment$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceAdjustment$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$Record = F4(function(createdAt, position, reason, user) {
        return {
            Mx: createdAt,
            WX: position,
            Yb: reason,
            aaX: user
        };
    });
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'user', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reason', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'position', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$Record)))));
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceAdjustment$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$InvoiceAdjustment)));
    var $author$project$Api$Provider$CustomerInvoice$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'probable_patients', $elm$json$Json$Decode$list($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'voided_by_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'voided_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'void_reason', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'revision_number', $elm$json$Json$Decode$int, A3($author$project$Api$Expandable$expandable, 'invoice_adjustments', $elm$json$Json$Decode$list($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$decoder), A3($author$project$Api$Expandable$expandable, 'payments', $elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transferred_to_credit_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credit_to_auto_apply_in_cents', $elm$json$Json$Decode$int, A3($author$project$Api$Expandable$expandable, 'charges', $elm$json$Json$Decode$list($author$project$Api$Provider$Charge$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tax_profile', $elm$json$Json$Decode$nullable($author$project$Api$Provider$TaxProfile$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_payment_source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$CustomerInvoice$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_group', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$dict($elm$json$Json$Decode$string)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$One$Record))))))))))))))))))));
    var $author$project$Api$Provider$CustomerInvoice$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CustomerInvoice$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CustomerInvoice$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$One$CustomerInvoice)));
    var $author$project$Api$Provider$CustomerInvoice$expandToString = function(expand) {
        switch(expand){
            case 0:
                return 'charges';
            case 1:
                return 'payments';
            case 2:
                return 'invoice_adjustments';
            case 3:
                return 'owner.phones';
            default:
                return 'membership_payment_source';
        }
    };
    var $author$project$Api$Provider$CustomerInvoice$issue = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'issue'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Components$Charge$Form$NewFormWithPatient = {
        $: 3
    };
    var $author$project$Components$Charge$Form$newFormWithPatient = A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$Components$Charge$Form$NewFormWithPatient), $elm$core$Task$succeed($elm$core$Maybe$Nothing));
    var $author$project$Components$CustomerEmailModal$Loading = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerEmailModal$NoRecipientEmail = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Reports$Patient$oneId = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$CustomerEmailModal$recipientId = function(recipient) {
        switch(recipient.$){
            case 0:
                var patient = recipient.a;
                return $author$project$Api$Provider$Reports$Patient$oneId(patient);
            case 1:
                var patient = recipient.a;
                return $author$project$Api$Provider$Patient$One$id(patient);
            default:
                var patient = recipient.a;
                return $author$project$Api$Provider$Patient$Shared$id(patient);
        }
    };
    var $author$project$Components$CustomerEmailModal$initPatientFormFields = function(patient) {
        return {
            OH: '',
            V8: $author$project$Components$CustomerEmailModal$recipientId(patient)
        };
    };
    var $author$project$Components$CustomerEmailModal$GotPreview = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Notification$Patient = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$previewNotification = F3(function(apiClient, shared, formFields) {
        var fields = function() {
            var _v1 = A2($elm$core$Maybe$map, $rtfeldman$elm_validate$Validate$fromValid, formFields);
            if (!_v1.$) {
                var fields_ = _v1.a;
                return {
                    fb: fields_.fb,
                    HF: fields_.HF
                };
            } else return {
                fb: $elm$core$Maybe$Nothing,
                HF: $elm$core$Maybe$Nothing
            };
        }();
        var _v0 = shared;
        var type_ = _v0.ah5;
        var contextId = _v0.wU;
        var recipient = _v0.BD;
        return A6($author$project$Api$Provider$Notification$preview, apiClient, type_, $author$project$Api$Provider$Notification$Patient($author$project$Components$CustomerEmailModal$recipientId(recipient)), contextId, fields, $author$project$Components$CustomerEmailModal$GotPreview);
    });
    var $author$project$Api$Provider$Patient$One$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$email(shared);
    };
    var $author$project$Api$Provider$Reports$Patient$oneEmail = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Components$CustomerEmailModal$recipientEmail = function(recipient) {
        switch(recipient.$){
            case 0:
                var patient = recipient.a;
                return $author$project$Api$Provider$Reports$Patient$oneEmail(patient);
            case 1:
                var patient = recipient.a;
                return $author$project$Api$Provider$Patient$One$email(patient);
            default:
                var patient = recipient.a;
                return $author$project$Api$Provider$Patient$Shared$email(patient);
        }
    };
    var $author$project$Components$CustomerEmailModal$open = F6(function(apiClient, session, type_, contextId, recipient, _v0) {
        var shared = {
            wU: contextId,
            BD: recipient,
            Z$: session,
            ah5: type_
        };
        var _v1 = $author$project$Components$CustomerEmailModal$recipientEmail(recipient);
        if (_v1.$ === 1) return _Utils_Tuple2(A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, $author$project$Utils$Form$init($author$project$Components$CustomerEmailModal$initPatientFormFields(recipient))), $elm$core$Platform$Cmd$none);
        else {
            if (_v1.a === '') return _Utils_Tuple2(A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, $author$project$Utils$Form$init($author$project$Components$CustomerEmailModal$initPatientFormFields(recipient))), $elm$core$Platform$Cmd$none);
            else {
                var email = _v1.a;
                return _Utils_Tuple2(A2($author$project$Components$CustomerEmailModal$Loading, shared, email), A3($author$project$Components$CustomerEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing));
            }
        }
    });
    var $author$project$Components$CustomerSchedulePaymentModal$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CustomerSchedulePaymentModal$DateInputMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerSchedulePaymentModal$initFormFields = function() {
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2({
            M4: $elm$core$Maybe$Nothing,
            qg: dateInput
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(dateInput), dateInputCmd));
    }();
    var $author$project$Components$CustomerSchedulePaymentModal$open = F2(function(invoiceId, currentDate) {
        var _v0 = $author$project$Components$CustomerSchedulePaymentModal$initFormFields;
        var fields = _v0.a;
        var fieldsCmd = _v0.b;
        var model = {
            cP: currentDate,
            PU: $author$project$Utils$Form$init(fields),
            RI: invoiceId,
            su: $author$project$Api$Data$NotAsked
        };
        return _Utils_Tuple2($author$project$Components$CustomerSchedulePaymentModal$Open(model), fieldsCmd);
    });
    var $author$project$Components$Charge$Form$readOnly = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            Ya: true
        });
    };
    var $author$project$Pages$Charges$New$DropdownMenuMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber = function(_v0) {
        var record = _v0;
        return record.RK;
    };
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(min);
    };
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner = function(_v0) {
        var record = _v0.b;
        return record.VM;
    };
    var $author$project$Api$Common$Payable$Invoice$Min$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$status = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Common$Payable$Invoice$Min$status(min);
    };
    var $author$project$Ui$Dropdown$TopLeft = 3;
    var $author$project$Ui$Dropdown$toTopLeft = function(config) {
        return _Utils_update(config, {
            a1: 3
        });
    };
    var $author$project$Api$Common$Payable$Invoice$Min$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_ = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Common$Payable$Invoice$Min$type_(min);
    };
    var $author$project$Pages$Charges$New$buildInvoiceRecord = function(invoice) {
        return {
            l_: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toTopLeft($author$project$Ui$Dropdown$defaultConfig({
                aef: 'invoice-actions-dropdown-menu-' + $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
                ahX: $author$project$Pages$Charges$New$DropdownMenuMsg($author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice))
            }))),
            aef: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
            RK: $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice),
            VM: $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice),
            j_: $author$project$Api$Data$NotAsked,
            ahy: $author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice),
            ah5: $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice)
        };
    };
    var $author$project$Pages$Charges$New$refreshInvoiceList = F2(function(invoices, maybeInvoice) {
        if (!maybeInvoice.$) {
            var invoice = maybeInvoice.a;
            var member = F2(function(record, i) {
                return _Utils_eq(i.aef, record.aef);
            });
            var invoiceRecord = $author$project$Pages$Charges$New$buildInvoiceRecord(invoice);
            return A2($elm$core$List$any, member(invoiceRecord), invoices) ? A2($elm$core$List$map, function(i) {
                return A2(member, invoiceRecord, i) ? invoiceRecord : i;
            }, invoices) : A2($elm$core$List$cons, invoiceRecord, invoices);
        } else return invoices;
    });
    var $author$project$Components$Charge$Form$ResetForm = {
        $: 2
    };
    var $author$project$Components$Charge$Form$reset = A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$Components$Charge$Form$ResetForm), $elm$core$Task$succeed($elm$core$Maybe$Nothing));
    var $author$project$Api$Provider$CustomerInvoice$retrieve = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))));
    });
    var $author$project$Pages$Charges$New$retrieveInvoice = F2(function(apiClient, invoiceId) {
        return A4($author$project$Api$Provider$CustomerInvoice$retrieve, apiClient, invoiceId, _List_Nil, A2($author$project$Pages$Charges$New$GotCustomerInvoice, invoiceId, $elm$core$Maybe$Nothing));
    });
    var $author$project$Components$Charge$Form$Save = {
        $: 1
    };
    var $author$project$Components$Charge$Form$save = A2($elm$core$Task$perform, $elm$core$Basics$always($author$project$Components$Charge$Form$Save), $elm$core$Task$succeed($elm$core$Maybe$Nothing));
    var $author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Charges$New$initCreatePaymentModal = F4(function(model, external, invoiceId, invoice) {
        var invoiceOwnerId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $elm$core$Maybe$map($author$project$Api$Common$Payable$Owner$Min$id), A2($elm$core$Maybe$map, function($) {
            return $.VM;
        }, A2($author$project$Pages$Charges$New$findInvoice, model.q5, invoiceId))));
        var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.Cu.cP)(model.Cu.HO)($author$project$Api$Provider$CustomerInvoice$customerInvoicePath($author$project$Api$Provider$CustomerInvoice$One$id(invoice)))($elm$core$Maybe$Just($author$project$Api$Provider$Patient$patientPath(invoiceOwnerId)))(model.Cu.Ej)(model.Z$)($author$project$Api$Practice$Provider(model.W1))(model.F3)(model.sp)(function(d) {
            return _Utils_update(d, {
                Po: external,
                or: model.F3
            });
        })(A2($author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice, invoiceOwnerId, invoice));
        var createPaymentModal = _v0.a;
        var createPaymentModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            lH: $elm$core$Maybe$Just(_Utils_Tuple2(createPaymentModal, $author$project$Api$Provider$CustomerInvoice$One$id(invoice)))
        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CreatePaymentModalMsg, createPaymentModalCmd));
    });
    var $author$project$Pages$Charges$New$showPaymentModal = F4(function(model, invoice, external, invoiceId) {
        return A2($elm$core$Maybe$withDefault, _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil), A2($elm$core$Maybe$map, $author$project$Utils$Tuple3$fromTuple2(_List_Nil), A2($elm$core$Maybe$map, A3($author$project$Pages$Charges$New$initCreatePaymentModal, model, external, invoiceId), $author$project$Api$Data$toMaybe(invoice.j_))));
    });
    var $author$project$Components$Charge$Form$toggle = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            hh: !model.hh
        });
    };
    var $author$project$Pages$Charges$New$Email = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Charges$New$Pay = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Charges$New$SchedulePayment = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Charges$New$triggerAfterIssueAction = F2(function(afterIssueMsg, invoice) {
        switch(afterIssueMsg){
            case 0:
                return A2($elm$core$Task$perform, function(_v1) {
                    return A2($author$project$Pages$Charges$New$Pay, invoice, false);
                }, $elm$time$Time$now);
            case 1:
                return A2($elm$core$Task$perform, function(_v2) {
                    return A2($author$project$Pages$Charges$New$Pay, invoice, true);
                }, $elm$time$Time$now);
            case 2:
                var _v3 = invoice.VM;
                if (!_v3.$) {
                    var owner = _v3.a;
                    return A2($elm$core$Task$perform, function(_v4) {
                        return A2($author$project$Pages$Charges$New$Email, $author$project$Api$Common$Payable$Owner$Min$id(owner), invoice);
                    }, $elm$time$Time$now);
                } else return $elm$core$Platform$Cmd$none;
            default:
                return A2($elm$core$Task$perform, function(_v5) {
                    return $author$project$Pages$Charges$New$SchedulePayment(invoice);
                }, $elm$time$Time$now);
        }
    });
    var $author$project$Components$Charge$Form$Category = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$ChargeCreated = 1;
    var $author$project$Components$Charge$Form$ChargeItem = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$EndDate = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Charge$Form$GotPatient = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$GotPreview = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$Location = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$Name = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$None = 0;
    var $author$project$Components$Charge$Form$Patient = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$PatientUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$Practitioner = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$StartDate = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Charge$Form$GotPreviewWithPayer = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$ChargeItemValidation = 1;
    var $author$project$Components$Charge$Form$PatientValidation = 0;
    var $author$project$Components$Charge$Form$PriceInCentsValidation = 3;
    var $author$project$Components$Charge$Form$QuantityValidation = 2;
    var $author$project$Components$Charge$Form$StartDateValidation = 4;
    var $author$project$Components$Charge$Form$validateChargeItem = function(fields) {
        var _v0 = fields.lv;
        if (!_v0.$) {
            var chargeItem = _v0.a;
            var sponsorPayer = fields.Wh === 1;
            return chargeItem.$S && sponsorPayer ? _List_fromArray([
                _Utils_Tuple2(1, '')
            ]) : _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Components$Charge$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.V7;
        }, _Utils_Tuple2(0, 'Please select a patient.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.zr;
        }, _Utils_Tuple2(1, 'Please select a charge item.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Bu;
        }, _Utils_Tuple2(2, 'Please enter a quantity.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Br;
        }, _Utils_Tuple2(3, 'Please enter an amount.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Charge$Form$validateChargeItem),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $._0;
        }, _Utils_Tuple2(4, 'Please pick a date.'))
    ]));
    var $author$project$Components$Charge$Form$paramsWithPrice = F2(function(fields, previewData) {
        var priceInCents = function() {
            if (!!fields.N$) {
                var _v0 = _Utils_Tuple2(fields.lv, previewData);
                if (!_v0.a.$) {
                    var chargeItem = _v0.a.a;
                    return $elm$core$Maybe$Just(chargeItem.Br | 0);
                } else if (_v0.b.$ === 3) {
                    var _v1 = _v0.a;
                    var _v2 = _v0.b;
                    var preview = _v2.a;
                    return $elm$core$Maybe$Just($author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
                } else {
                    var _v3 = _v0.a;
                    return $elm$core$Maybe$Just(fields.N$ + A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Br)));
                }
            } else return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Br);
        }();
        return {
            EL: fields.EL,
            lv: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.lv),
            M4: fields._0,
            NQ: fields.NQ,
            N0: fields.N0,
            qv: fields.qv,
            RA: $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing),
            aeT: fields.aeT,
            zr: fields.zr,
            V7: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.V7),
            GR: $elm$core$Maybe$Nothing,
            agi: fields.agi,
            Br: priceInCents,
            Bu: A2($elm$core$Maybe$withDefault, 1, fields.Bu),
            Bv: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Bv)
        };
    });
    var $author$project$Api$Charge$PayerType$payerTypeParam = function(payerType) {
        if (!payerType) return $elm$core$Maybe$Just('patient');
        else return $elm$core$Maybe$Just('company');
    };
    var $author$project$Components$Charge$Form$calculatePreviewWithPayer = F2(function(apiClient, model) {
        var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Charge$Form$formFieldsValidator, model.e);
        if (!_v0.$) {
            var fields = $author$project$Utils$Form$fields(model.e);
            var params = A2($author$project$Components$Charge$Form$paramsWithPrice, fields, model.agk);
            var paramsWithPayer = _Utils_update(params, {
                GR: $elm$core$Maybe$Just({
                    aef: fields.GR,
                    ah5: $author$project$Api$Charge$PayerType$payerTypeParam(fields.Wh)
                })
            });
            return _List_fromArray([
                A4($author$project$Api$Provider$Charge$calculate, $author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath), apiClient, paramsWithPayer, $author$project$Components$Charge$Form$GotPreviewWithPayer),
                A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer($author$project$Api$Data$Loading)))
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Charge$Form$GotChargeCreated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Charge$NewInvoice = {
        $: 1
    };
    var $author$project$Api$Provider$Charge$RoutedInvoice$One$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Charge$Calculate$routedInvoice = function(_v0) {
        var record = _v0;
        return record.Za;
    };
    var $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId = function(preview) {
        return $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, 'new', A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$RoutedInvoice$One$id, $author$project$Api$Provider$Charge$Calculate$routedInvoice(preview))));
    };
    var $author$project$Components$Charge$Form$invoiceNotChanged = F2(function(previewData, fields) {
        return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(preview_) {
            return _Utils_eq($author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview_), fields.RA);
        }, $author$project$Api$Data$toMaybe(previewData)));
    });
    var $author$project$Components$Charge$Form$invoiceTypeParam = function(payertype) {
        if (!payertype) return $elm$core$Maybe$Just('customer_invoice');
        else return $elm$core$Maybe$Just('company_invoice');
    };
    var $author$project$Api$Provider$Charge$AdjudicatedPayer$One$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId = function(preview) {
        return A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$AdjudicatedPayer$One$id, $author$project$Api$Provider$Charge$Calculate$adjudicatedPayer(preview));
    };
    var $author$project$Components$Charge$Form$payerNotChanged = F2(function(previewData, fields) {
        return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(preview_) {
            return _Utils_eq($author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview_), fields.GR);
        }, $author$project$Api$Data$toMaybe(previewData)));
    });
    var $author$project$Components$Charge$Form$createParams = F2(function(fields, previewData) {
        var newSponsorInvoice = fields.Wh === 1 && _Utils_eq(fields.RA, $elm$core$Maybe$Just('new'));
        var invoice = function() {
            if (A2($author$project$Components$Charge$Form$invoiceNotChanged, previewData, fields)) return $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing);
            else {
                var newPatientInvoice = !fields.Wh && _Utils_eq(fields.RA, $elm$core$Maybe$Just('new'));
                return newSponsorInvoice || newPatientInvoice ? $author$project$Api$Provider$Charge$NewInvoice : $author$project$Api$Provider$Charge$Invoice(A2($elm$core$Maybe$map, $elm$core$Basics$always({
                    aef: fields.RA,
                    ah5: $author$project$Components$Charge$Form$invoiceTypeParam(fields.Wh)
                }), fields.RA));
            }
        }();
        var payer = A2($author$project$Components$Charge$Form$payerNotChanged, previewData, fields) || !_Utils_eq(invoice, $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Nothing)) && !newSponsorInvoice ? $elm$core$Maybe$Nothing : A2($elm$core$Maybe$map, $elm$core$Basics$always({
            aef: fields.GR,
            ah5: $author$project$Api$Charge$PayerType$payerTypeParam(fields.Wh)
        }), fields.GR);
        var baseParams = A2($author$project$Components$Charge$Form$paramsWithPrice, fields, previewData);
        return _Utils_update(baseParams, {
            RA: invoice,
            GR: payer
        });
    });
    var $author$project$Components$Charge$Form$createCharge = F3(function(apiClient, model, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Charge$create, $author$project$Api$Data$providerPath, apiClient, A2($author$project$Components$Charge$Form$createParams, fields, model.agk), $author$project$Components$Charge$Form$GotChargeCreated);
    });
    var $author$project$Components$Charge$Form$PreviewDebounced = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$debouncePreview = function(cmd) {
        return A2($elm$core$Task$perform, $author$project$Components$Charge$Form$PreviewDebounced, $elm$core$Task$succeed(cmd));
    };
    var $author$project$Components$Charge$Form$resetEndDate = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Bu, fields.Bv);
        if (!_v0.a.$ && !_v0.b.$) {
            var quantity = _v0.a.a;
            var quantityUom = _v0.b.a;
            return _Utils_update(fields, {
                qv: A3($author$project$Utils$Uom$addTo, fields._0, quantityUom, quantity)
            });
        } else return fields;
    };
    var $author$project$Components$Charge$Form$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var patient = field.a;
                return _Utils_update(fields, {
                    V7: patient
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    EL: $elm$core$Maybe$Nothing,
                    cK: A2($author$project$Components$ResourceFilter$Category$setValue, $elm$core$Maybe$Nothing, fields.cK),
                    lv: $elm$core$Maybe$Nothing,
                    N$: 0,
                    zr: $elm$core$Maybe$Just(string),
                    Br: $elm$core$Maybe$Nothing
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    NQ: string
                });
            case 3:
                var item = field.a;
                var category = item.EL;
                return $author$project$Components$Charge$Form$resetEndDate(_Utils_update(fields, {
                    EL: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
                    cK: A2($author$project$Components$ResourceFilter$Category$setValue, A2($elm$core$Maybe$map, function(category_) {
                        return {
                            aef: $author$project$Api$Provider$Category$Shared$id(category_),
                            zr: $author$project$Api$Provider$Category$Shared$name(category_)
                        };
                    }, category), fields.cK),
                    lv: $elm$core$Maybe$Just(item),
                    NQ: A2($elm$core$Maybe$withDefault, '', item.NQ),
                    zr: $elm$core$Maybe$Just(item.zr),
                    Br: $elm$core$Maybe$Just($author$project$Currency$fromFloat(item.Br)),
                    Xn: $elm$core$Maybe$Just(item.aaK),
                    Bv: $elm$core$Maybe$Just(item.aaK)
                }));
            case 4:
                var string = field.a;
                return $author$project$Components$Charge$Form$resetEndDate(_Utils_update(fields, {
                    Bu: $elm$core$String$toInt(string)
                }));
            case 5:
                var string = field.a;
                var _v1 = $author$project$Utils$Uom$fromCode(string);
                if (!_v1.$) {
                    var quantityUom = _v1.a;
                    var quantity = function() {
                        var _v2 = _Utils_Tuple2(fields._0, fields.qv);
                        if (!_v2.a.$ && !_v2.b.$) {
                            var startDate = _v2.a.a;
                            var endDate = _v2.b.a;
                            return $elm$core$Maybe$Just(A3($author$project$Utils$Uom$quantityBetween, quantityUom, startDate, $elm$core$Maybe$Just(endDate)));
                        } else return fields.Bu;
                    }();
                    return $author$project$Components$Charge$Form$resetEndDate(_Utils_update(fields, {
                        Bu: quantity,
                        Bv: $elm$core$Maybe$Just(quantityUom)
                    }));
                } else return _Utils_update(fields, {
                    Bv: $elm$core$Maybe$Nothing
                });
            case 6:
                var currency = field.a;
                return _Utils_update(fields, {
                    Br: currency
                });
            case 7:
                var _int = field.a;
                return _Utils_update(fields, {
                    N$: _int
                });
            case 9:
                var routingFields = field.a;
                return _Utils_update(fields, {
                    RA: routingFields.RI,
                    GR: routingFields.af6,
                    Wh: routingFields.Wh
                });
            case 8:
                var bool = field.a;
                var priceInCents = bool ? fields.Br : A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function($) {
                    return $.Br;
                }, $author$project$Currency$fromFloat), fields.lv);
                return _Utils_update(fields, {
                    N0: bool,
                    Br: priceInCents
                });
            case 10:
                var category = field.a;
                return _Utils_update(fields, {
                    EL: category
                });
            case 11:
                var practitioner = field.a;
                return _Utils_update(fields, {
                    agi: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, practitioner)
                });
            case 12:
                var location1 = field.a;
                return _Utils_update(fields, {
                    aeT: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, location1)
                });
            case 13:
                var dateInput = field.a;
                var date = field.b;
                return $author$project$Components$Charge$Form$resetEndDate(_Utils_update(fields, {
                    _0: date,
                    kj: dateInput
                }));
            default:
                var dateInput = field.a;
                var date = field.b;
                var _v3 = function() {
                    var _v4 = _Utils_Tuple2(fields._0, date);
                    if (!_v4.a.$ && !_v4.b.$) {
                        var startDate_ = _v4.a.a;
                        var endDate = _v4.b.a;
                        var startDate__ = A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2 ? endDate : startDate_;
                        var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
                        return _Utils_Tuple3($elm$core$Maybe$Just(startDate__), $elm$core$Maybe$Just(quantityUom_), $elm$core$Maybe$Just(A3($author$project$Utils$Uom$quantityBetween, quantityUom_, startDate__, $elm$core$Maybe$Just(endDate))));
                    } else return _Utils_Tuple3(fields._0, fields.Bv, fields.Bu);
                }();
                var startDate = _v3.a;
                var quantityUom = _v3.b;
                var quantity = _v3.c;
                return _Utils_update(fields, {
                    qv: date,
                    qx: dateInput,
                    Bu: quantity,
                    Bv: quantityUom,
                    _0: startDate
                });
        }
    });
    var $author$project$Components$Charge$Form$GotChargeOverridden = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$overrideChargeDiscount = F3(function(apiClient, id, form) {
        var fields = $author$project$Utils$Form$fields(form);
        return fields.N0 ? _Utils_Tuple2(A3($author$project$Api$Provider$Charge$CoverageDiscount$override, apiClient, id, $author$project$Components$Charge$Form$GotChargeOverridden), 0) : _Utils_Tuple2($elm$core$Platform$Cmd$none, 1);
    });
    var $author$project$Components$Charge$Form$PreviewDebouncedMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$previewDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Charge$Form$PreviewDebouncedMsg
    };
    var $author$project$Components$ResourceFilter$Patient$setValue = F2(function(resource, model) {
        return _Utils_update(model, {
            Hg: function() {
                if (!resource.$) {
                    var resource_ = resource.a;
                    return $author$project$Components$ResourceFilter$One(resource_);
                } else return $author$project$Components$ResourceFilter$All;
            }()
        });
    });
    var $author$project$Components$Charge$Form$RoutingFields$GotPatient = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$None = 0;
    var $author$project$Api$Charge$PayerType$adjudicatedToSponsor = function(preview) {
        return $author$project$Api$Charge$PayerType$toPayerType($author$project$Api$Charge$PayerType$adjudicatedType(preview)) === 1;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId = function(invoices) {
        return $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, 'new', A2($elm$core$Maybe$map, $author$project$Api$Provider$CustomerInvoice$All$id, A2($elm$core$Maybe$andThen, $elm$core$List$head, $author$project$Api$Data$toMaybe(invoices)))));
    };
    var $author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId = F4(function(fields, dataCustomerInvoices, dataPreview, dataPreviewWithPayer) {
        if (dataPreview.$ === 3) {
            var preview = dataPreview.a;
            var _v1 = _Utils_Tuple2(fields.Wh, $author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview));
            if (!_v1.a) {
                if (!_v1.b) {
                    var _v2 = _v1.a;
                    return _Utils_eq(fields.af6, $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview)) ? $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview) : $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId(dataCustomerInvoices);
                } else {
                    var _v3 = _v1.a;
                    return $author$project$Components$Charge$Form$RoutingFields$firstInvoiceOrNewId(dataCustomerInvoices);
                }
            } else if (!_v1.b) {
                var _v4 = _v1.a;
                return A2($elm$core$Maybe$andThen, $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId, $author$project$Api$Data$toMaybe(dataPreviewWithPayer));
            } else {
                var _v5 = _v1.a;
                return $author$project$Components$Charge$Form$RoutingFields$routedInvoiceId(preview);
            }
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Api$Provider$Patient$One$company = function(_v0) {
        var record = _v0.b;
        return record.acy;
    };
    var $author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany = function(patient) {
        return $author$project$Api$Provider$Patient$One$company(patient);
    };
    var $author$project$Api$Provider$Patient$One$payer = function(_v0) {
        var record = _v0.b;
        return record.GR;
    };
    var $author$project$Components$Charge$Form$RoutingFields$patientPayerId = function(patient) {
        var _v0 = $author$project$Api$Provider$Patient$One$payer(patient);
        if (!_v0.$) {
            var payer = _v0.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Min$id(payer));
        } else return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$id(patient));
    };
    var $author$project$Components$Charge$Form$RoutingFields$defaultPayerId = F3(function(payerType, dataPatient, dataPreview) {
        var _v0 = _Utils_Tuple2(dataPatient, dataPreview);
        if (_v0.a.$ === 3 && _v0.b.$ === 3) {
            var _v1 = _v0.a;
            var patient = _v1.a;
            var _v2 = _v0.b;
            var preview = _v2.a;
            var _v3 = _Utils_Tuple2(payerType, $author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview));
            if (!_v3.a) {
                if (!_v3.b) {
                    var _v4 = _v3.a;
                    return $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview);
                } else {
                    var _v5 = _v3.a;
                    return $author$project$Components$Charge$Form$RoutingFields$patientPayerId(patient);
                }
            } else if (!_v3.b) {
                var _v6 = _v3.a;
                return A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Min$id, $author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany(patient));
            } else {
                var _v7 = _v3.a;
                return $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview);
            }
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$Charge$Form$RoutingFields$GotCustomerInvoices = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$GotSponsorInvoices = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Invoice$All$Invoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Invoice$All$Record = F6(function(invoiceDate, humanStatus, amountInCents, paidInCents, dueInCents, description) {
        return {
            Jh: amountInCents,
            NQ: description,
            Ol: dueInCents,
            QX: humanStatus,
            RG: invoiceDate,
            VR: paidInCents
        };
    });
    var $author$project$Api$Provider$Invoice$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $author$project$Api$Invoice$Status$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$All$Record)))))));
    var $author$project$Api$Provider$Invoice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$All$Invoice)));
    var $author$project$Api$Provider$Invoice$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Invoice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Invoice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v0 = options.ahy;
                if (!_v0.$) {
                    var list_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$list, 'status', list_)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Provider$Company$Invoice$list = F4(function(apiClient, companyId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Invoice$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Invoice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$Invoice$invoicesPath(companyId))));
    });
    var $author$project$Api$Provider$CustomerInvoice$All$CustomerInvoice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CustomerInvoice$All$Record = function(id) {
        return function(date) {
            return function(dueInCents) {
                return function(invoiceNumber) {
                    return function(humanStatus) {
                        return function(isPaymentScheduled) {
                            return function(paymentScheduledOn) {
                                return function(status) {
                                    return function(issuedTotalInCents) {
                                        return function(totalInCents) {
                                            return function(lastSentAt) {
                                                return function(paidAt) {
                                                    return function(nextScheduledPaymentDate) {
                                                        return {
                                                            M4: date,
                                                            Ol: dueInCents,
                                                            QX: humanStatus,
                                                            aef: id,
                                                            RK: invoiceNumber,
                                                            Si: isPaymentScheduled,
                                                            SH: issuedTotalInCents,
                                                            SY: lastSentAt,
                                                            U1: nextScheduledPaymentDate,
                                                            VQ: paidAt,
                                                            Wq: paymentScheduledOn,
                                                            ahy: status,
                                                            aam: totalInCents
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_scheduled_payment_date', $elm$json$Json$Decode$maybe($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_scheduled_on', $elm$json$Json$Decode$maybe($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_payment_scheduled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CustomerInvoice$All$Record))))))))))))));
    var $author$project$Api$Provider$CustomerInvoice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CustomerInvoice$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CustomerInvoice$listDefaults = {
        Fn: $elm$core$Maybe$Nothing,
        Fq: _List_Nil,
        VM: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$CustomerInvoice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$CustomerInvoice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v0 = options.ahy;
                if (!_v0.$) {
                    var list_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$list, 'status', list_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.VM;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'owner', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.HB;
                if (!_v2.$) {
                    var start_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.Fn;
                if (!_v3.$) {
                    var end_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Provider$CustomerInvoice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CustomerInvoice$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$CustomerInvoice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicesPath)));
    });
    var $author$project$Components$Charge$Form$RoutingFields$listInvoices = F2(function(apiClient, model) {
        var _v0 = _Utils_Tuple2(model.adM.Wh, model.adM.af6);
        _v0$2: while(true)if (!_v0.a) {
            if (!_v0.b.$) {
                var _v1 = _v0.a;
                var options = function(d) {
                    return _Utils_update(d, {
                        VM: model.adM.af6,
                        af_: model.af_,
                        ahy: $elm$core$Maybe$Just(_List_fromArray([
                            'draft'
                        ]))
                    });
                };
                return A3($author$project$Api$Provider$CustomerInvoice$list, apiClient, options, $author$project$Components$Charge$Form$RoutingFields$GotCustomerInvoices);
            } else break _v0$2;
        } else {
            if (!_v0.b.$) {
                var _v2 = _v0.a;
                var id = _v0.b.a;
                var options = function(d) {
                    return _Utils_update(d, {
                        af_: model.af_,
                        ahy: $elm$core$Maybe$Just(_List_fromArray([
                            'draft'
                        ]))
                    });
                };
                return A4($author$project$Api$Provider$Company$Invoice$list, apiClient, id, options, $author$project$Components$Charge$Form$RoutingFields$GotSponsorInvoices);
            } else break _v0$2;
        }
        return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Charge$Form$RoutingFields$PreviewWithPayerRequested = 1;
    var $author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer = F2(function(payerType, dataPreview) {
        var _v0 = _Utils_Tuple2(payerType, dataPreview);
        if (_v0.a === 1 && _v0.b.$ === 3) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            var preview = _v2.a;
            return $author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview) ? 0 : 1;
        } else return 0;
    });
    var $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading = function(model) {
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(model.adM.Wh, model.adM.af6);
            _v1$2: while(true)if (!_v1.a) {
                if (!_v1.b.$) {
                    var _v2 = _v1.a;
                    return _Utils_Tuple2($author$project$Api$Data$Loading, model.gW);
                } else break _v1$2;
            } else {
                if (!_v1.b.$) {
                    var _v3 = _v1.a;
                    return _Utils_Tuple2(model.cR, $author$project$Api$Data$Loading);
                } else break _v1$2;
            }
            return _Utils_Tuple2(model.cR, model.gW);
        }();
        var customerInvoices = _v0.a;
        var sponsorInvoices = _v0.b;
        return _Utils_update(model, {
            cR: customerInvoices,
            gW: sponsorInvoices
        });
    };
    var $author$project$Components$Charge$Form$RoutingFields$initPatientPayerFilter = F2(function(apiClient, id) {
        return A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Patient',
                I5: false,
                agj: id,
                agq: id
            });
        });
    });
    var $author$project$Components$Charge$Form$RoutingFields$updatePayerId = F2(function(payerId, fields) {
        return _Utils_update(fields, {
            af6: payerId
        });
    });
    var $author$project$Components$Charge$Form$RoutingFields$updatePayerType = F2(function(payerType, fields) {
        return _Utils_eq(fields.Wh, payerType) ? fields : _Utils_update(fields, {
            RI: $elm$core$Maybe$Nothing,
            af6: $elm$core$Maybe$Nothing,
            Wh: payerType
        });
    });
    var $author$project$Components$Charge$Form$RoutingFields$updateFromPreview = F4(function(apiClient, model, dataPreview, preview) {
        var newFields = A2($author$project$Components$Charge$Form$RoutingFields$updatePayerId, $author$project$Components$Charge$Form$RoutingFields$adjudicatedPayerId(preview), A2($author$project$Components$Charge$Form$RoutingFields$updatePayerType, $author$project$Api$Charge$PayerType$toPayerType($author$project$Api$Charge$PayerType$adjudicatedType(preview)), model.adM));
        var _v0 = function() {
            var _v1 = model.V7;
            if (_v1.$ === 3) {
                var patient = _v1.a;
                return A2($author$project$Components$Charge$Form$RoutingFields$initPatientPayerFilter, apiClient, $author$project$Components$Charge$Form$RoutingFields$patientPayerId(patient));
            } else return _Utils_Tuple2(model.el, $elm$core$Platform$Cmd$none);
        }();
        var newPatientPayerFilter = _v0.a;
        var newPatientPayerFilterCmd = _v0.b;
        var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(_Utils_update(model, {
            adM: newFields,
            el: newPatientPayerFilter,
            agk: dataPreview
        }));
        return {
            EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, newPatientPayerFilterCmd),
                A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel)
            ])),
            adu: 0,
            zi: newModel,
            at: _List_Nil
        };
    });
    var $author$project$Components$Charge$Form$RoutingFields$updateInvoiceId = F2(function(invoiceId, fields) {
        return _Utils_update(fields, {
            RI: invoiceId
        });
    });
    var $author$project$Components$Charge$Form$RoutingFields$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var patientId = msg.a;
                return {
                    EQ: A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId, $author$project$Components$Charge$Form$RoutingFields$GotPatient),
                    adu: 0,
                    zi: _Utils_update(model, {
                        V7: $author$project$Api$Data$Loading,
                        V8: patientId
                    }),
                    at: _List_Nil
                };
            case 1:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        V7: response
                    }),
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var preview = response.a;
                    return A4($author$project$Components$Charge$Form$RoutingFields$updateFromPreview, apiClient, model, response, preview);
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        agk: response
                    }),
                    at: _List_Nil
                };
            case 3:
                var response = msg.a;
                var newFields = function() {
                    if (response.$ === 3) return A2($author$project$Components$Charge$Form$RoutingFields$updateInvoiceId, A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.adM, model.cR, model.agk, response), model.adM);
                    else return model.adM;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        adM: newFields,
                        jF: response
                    }),
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                var newFields = A2($author$project$Components$Charge$Form$RoutingFields$updateInvoiceId, A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.adM, model.cR, model.agk, model.jF), model.adM);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        adM: newFields,
                        gW: response
                    }),
                    at: _List_Nil
                };
            case 5:
                var response = msg.a;
                var newFields = A2($author$project$Components$Charge$Form$RoutingFields$updateInvoiceId, A4($author$project$Components$Charge$Form$RoutingFields$defaultInvoiceId, model.adM, response, model.agk, model.jF), model.adM);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        cR: response,
                        adM: newFields
                    }),
                    at: _List_Nil
                };
            case 6:
                var payerType = msg.a;
                var newFields = A2($author$project$Components$Charge$Form$RoutingFields$updatePayerId, A3($author$project$Components$Charge$Form$RoutingFields$defaultPayerId, payerType, model.V7, model.agk), A2($author$project$Components$Charge$Form$RoutingFields$updatePayerType, payerType, model.adM));
                var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(_Utils_update(model, {
                    adM: newFields,
                    A_: true
                }));
                return {
                    EQ: A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel),
                    adu: A2($author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer, payerType, model.agk),
                    zi: newModel,
                    at: _List_Nil
                };
            case 7:
                var subMsg = msg.a;
                var patientPayerFilterResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.el);
                var _v3 = _Utils_Tuple2(patientPayerFilterResult.adu, model.adM.Wh);
                if (!_v3.a.$ && !_v3.a.a.$ && !_v3.a.a.a.$ && !_v3.b) {
                    var patient = _v3.a.a.a.a;
                    var _v4 = _v3.b;
                    var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(_Utils_update(model, {
                        adM: A2($author$project$Components$Charge$Form$RoutingFields$updatePayerId, $elm$core$Maybe$Just($author$project$Api$Provider$Patient$All$id(patient)), model.adM),
                        el: patientPayerFilterResult.zi
                    }));
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, patientPayerFilterResult.EQ),
                            A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel)
                        ])),
                        adu: 0,
                        zi: newModel,
                        at: patientPayerFilterResult.at
                    };
                } else return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, patientPayerFilterResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        el: patientPayerFilterResult.zi
                    }),
                    at: patientPayerFilterResult.at
                };
            case 8:
                var payerId = msg.a;
                var newModel = $author$project$Components$Charge$Form$RoutingFields$setInvoicesAsLoading(_Utils_update(model, {
                    adM: A2($author$project$Components$Charge$Form$RoutingFields$updatePayerId, $elm$core$Maybe$Just(payerId), model.adM)
                }));
                return {
                    EQ: A2($author$project$Components$Charge$Form$RoutingFields$listInvoices, apiClient, newModel),
                    adu: A2($author$project$Components$Charge$Form$RoutingFields$requestPreviewWithPayer, 1, model.agk),
                    zi: newModel,
                    at: _List_Nil
                };
            case 9:
                var invoiceId = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        adM: A2($author$project$Components$Charge$Form$RoutingFields$updateInvoiceId, $elm$core$Maybe$Just(invoiceId), model.adM)
                    }),
                    at: _List_Nil
                };
            case 10:
                var invoiceId = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        adM: A2($author$project$Components$Charge$Form$RoutingFields$updateInvoiceId, $elm$core$Maybe$Just(invoiceId), model.adM)
                    }),
                    at: _List_Nil
                };
            default:
                var currentDate = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        cP: $elm$core$Maybe$Just(currentDate)
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Charge$Form$GotPreview = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$shouldCalculatePreview = function(field) {
        switch(field.$){
            case 0:
                return true;
            case 1:
                return false;
            case 3:
                return true;
            case 4:
                return true;
            case 5:
                return true;
            case 6:
                return true;
            case 7:
                return true;
            case 2:
                return false;
            case 13:
                return true;
            case 14:
                return true;
            case 10:
                return true;
            case 8:
                return true;
            case 9:
                return false;
            case 11:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Components$Charge$Form$validPreviewFields = function(fields) {
        return $author$project$Utils$Maybe$toBool(fields.zr) && A2($elm$core$Maybe$withDefault, 0, fields.Bu) > 0;
    };
    var $author$project$Components$Charge$Form$calculatePreview = F4(function(apiClient, field, form, model) {
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = $author$project$Components$Charge$Form$shouldCalculatePreview(field) && $author$project$Components$Charge$Form$validPreviewFields(fields) ? A2($author$project$Utils$Tuple3$fromTuple2, A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$Loading))), A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Charge$Form$previewDebounceConfig, A4($author$project$Api$Provider$Charge$calculate, $author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath), apiClient, A2($author$project$Components$Charge$Form$paramsWithPrice, fields, model.agk), $author$project$Components$Charge$Form$GotPreview), model.eq)) : _Utils_Tuple3(model.eq, $elm$core$Platform$Cmd$none, $elm$core$Platform$Cmd$none);
        var newDebouncer = _v0.a;
        var cmd = _v0.b;
        var routingFieldsCmd = _v0.c;
        return _Utils_Tuple2($author$project$Components$Charge$Form$shouldCalculatePreview(field) && $author$project$Components$Charge$Form$validPreviewFields(fields) ? _Utils_update(model, {
            agk: $author$project$Api$Data$Loading,
            eq: newDebouncer
        }) : !$author$project$Components$Charge$Form$validPreviewFields(fields) ? _Utils_update(model, {
            agk: $author$project$Api$Data$NotAsked,
            eq: newDebouncer
        }) : _Utils_update(model, {
            eq: newDebouncer
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            routingFieldsCmd
        ])));
    });
    var $author$project$Components$Charge$Form$updateForm = F4(function(apiClient, model, field, form) {
        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, field, form);
        return A4($author$project$Components$Charge$Form$calculatePreview, apiClient, field, newForm, _Utils_update(model, {
            e: newForm
        }));
    });
    var $author$project$Components$Charge$Form$updateDateInputFormField = F7(function(apiClient, model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var fields = $author$project$Utils$Form$fields(model.e);
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var _v1 = function() {
            if (event.$ === 1) {
                var date = event.a;
                return _Utils_Tuple2(A2(field, newDateInput, date), !_Utils_eq(date, fieldGetter(fields)));
            } else return _Utils_Tuple2(A2(field, newDateInput, fieldGetter(fields)), false);
        }();
        var dateField = _v1.a;
        var shouldPreview = _v1.b;
        var _v3 = shouldPreview ? A4($author$project$Components$Charge$Form$updateForm, apiClient, model, dateField, model.e) : _Utils_Tuple2(_Utils_update(model, {
            e: A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, dateField, model.e)
        }), $elm$core$Platform$Cmd$none);
        var newModel = _v3.a;
        var formCmd = _v3.b;
        return {
            EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                formCmd,
                A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd)
            ])),
            adu: 0,
            zi: newModel,
            at: _List_Nil
        };
    });
    var $author$project$Components$Charge$Form$updateFilters = F3(function(apiClient, patient, model) {
        var _v0 = function() {
            var _v1 = _Utils_Tuple2($author$project$Api$Provider$Patient$One$location(patient), $author$project$Api$Provider$Patient$One$practitioner(patient));
            if (!_v1.a.$) {
                if (!_v1.b.$) {
                    var location1 = _v1.a.a;
                    var practitioner = _v1.b.a;
                    var practitionerResourceFilter_ = function(value) {
                        return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, model.jE);
                    }($author$project$Components$ResourceFilter$Practitioner$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Practitioner$Shared$Provider(practitioner))));
                    var locationResourceFilter_ = function(value) {
                        return A2($author$project$Components$ResourceFilter$Location$setValue, value, model.ro);
                    }($author$project$Components$ResourceFilter$Location$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Location$Shared$Provider(location1))));
                    return _Utils_Tuple2($elm$core$Maybe$Just(locationResourceFilter_), $elm$core$Maybe$Just(practitionerResourceFilter_));
                } else {
                    var location1 = _v1.a.a;
                    var _v2 = _v1.b;
                    var locationResourceFilter_ = function(value) {
                        return A2($author$project$Components$ResourceFilter$Location$setValue, value, model.ro);
                    }($author$project$Components$ResourceFilter$Location$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Location$Shared$Provider(location1))));
                    return _Utils_Tuple2($elm$core$Maybe$Just(locationResourceFilter_), $elm$core$Maybe$Nothing);
                }
            } else if (!_v1.b.$) {
                var _v3 = _v1.a;
                var practitioner = _v1.b.a;
                var practitionerResourceFilter_ = function(value) {
                    return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, model.jE);
                }($author$project$Components$ResourceFilter$Practitioner$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Practitioner$Shared$Provider(practitioner))));
                return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(practitionerResourceFilter_));
            } else {
                var _v4 = _v1.a;
                var _v5 = _v1.b;
                return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
            }
        }();
        var locationResourceFilter = _v0.a;
        var practitionerResourceFilter = _v0.b;
        var _v6 = function() {
            if (!practitionerResourceFilter.$) {
                var filter = practitionerResourceFilter.a;
                return _Utils_Tuple2(filter, $elm$core$Platform$Cmd$none);
            } else return $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
        }();
        var newPractitionerResourceFilter = _v6.a;
        var newPractitionerResourceFilterCmd = _v6.b;
        var _v8 = function() {
            if (!locationResourceFilter.$) {
                var filter = locationResourceFilter.a;
                return _Utils_Tuple2(filter, $elm$core$Platform$Cmd$none);
            } else return $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
        }();
        var newLocationResourceFilter = _v8.a;
        var newLocationResourceFilterCmd = _v8.b;
        return _Utils_Tuple2(_Utils_update(model, {
            ro: newLocationResourceFilter,
            jE: newPractitionerResourceFilter
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, newLocationResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, newPractitionerResourceFilterCmd)
        ])));
    });
    var $author$project$Components$Charge$Form$DiscountInCents = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$PriceInCents = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$updateFormFromPreview = F2(function(preview, form) {
        return A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, $author$project$Components$Charge$Form$DiscountInCents($author$project$Api$Provider$Charge$Calculate$discountInCents(preview)), A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, $author$project$Components$Charge$Form$PriceInCents($elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))), form));
    });
    var $author$project$Components$Charge$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var _v2 = A4($author$project$Components$Charge$Form$updateForm, apiClient, model, field, model.e);
                var newModel = _v2.a;
                var formCmd = _v2.b;
                return {
                    EQ: formCmd,
                    adu: 0,
                    zi: newModel,
                    at: _List_Nil
                };
            case 1:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Charge$Form$formFieldsValidator, model.e);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var form = _v4.a;
                    var validFormFields = _v4.b;
                    return {
                        EQ: A3($author$project$Components$Charge$Form$createCharge, apiClient, model, validFormFields),
                        adu: 0,
                        zi: _Utils_update(model, {
                            ach: $author$project$Api$Data$Loading,
                            e: form
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v3.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            e: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var newPatientFilter = A2($author$project$Components$ResourceFilter$Patient$setValue, $elm$core$Maybe$Nothing, model.rX);
                var newChargeItemFilter = A2($author$project$Components$ResourceFilter$ChargeItem$setValue, $author$project$Components$ResourceFilter$All, model.cL);
                var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.W1);
                var _v5 = $author$project$Components$DateInput$init;
                var startDateInput = _v5.a;
                var startDateInputCmd = _v5.b;
                var _v6 = $author$project$Components$Charge$Form$initPractitionerResourceFilter(apiClient);
                var practitionerResourceFilter = _v6.a;
                var practitionerResourceFilterCmd = _v6.b;
                var _v7 = $author$project$Components$Charge$Form$initLocationResourceFilter(apiClient);
                var locationResourceFilter = _v7.a;
                var locationResourceFilterCmd = _v7.b;
                var _v8 = $author$project$Components$DateInput$init;
                var endDateInput = _v8.a;
                var endDateInputCmd = _v8.b;
                var _v9 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, model.Z$, excludeLabs);
                var categoryResourceFilter = _v9.a;
                var categoryResourceFilterCmd = _v9.b;
                var newModel = _Utils_update(model, {
                    e: $author$project$Utils$Form$init(A4($author$project$Components$Charge$Form$initFormFields, $elm$core$Maybe$Just(model.cP), startDateInput, endDateInput, categoryResourceFilter)),
                    cL: newChargeItemFilter,
                    ro: locationResourceFilter,
                    rX: newPatientFilter,
                    jE: practitionerResourceFilter,
                    agk: $author$project$Api$Data$NotAsked
                });
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$StartDateInputMsg(startDateInput), startDateInputCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$EndDateInputMsg(endDateInput), endDateInputCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceFilterCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
                    ])),
                    adu: 0,
                    zi: newModel,
                    at: _List_Nil
                };
            case 3:
                var newChargeItemFilter = A2($author$project$Components$ResourceFilter$ChargeItem$setValue, $author$project$Components$ResourceFilter$All, model.cL);
                var excludeLabs = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.W1);
                var _v10 = $author$project$Components$DateInput$init;
                var startDateInput = _v10.a;
                var startDateInputCmd = _v10.b;
                var _v11 = function() {
                    var _v12 = model.V7;
                    if (!_v12.$) {
                        var patient = _v12.a;
                        return A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, model);
                    } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var filtersMsg = _v11.b;
                var _v13 = $author$project$Components$DateInput$init;
                var endDateInput = _v13.a;
                var endDateInputCmd = _v13.b;
                var _v14 = A3($author$project$Components$Charge$Form$initCategoryResourceFilter, apiClient, model.Z$, excludeLabs);
                var categoryResourceFilter = _v14.a;
                var categoryResourceFilterCmd = _v14.b;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, $author$project$Components$Charge$Form$Patient($author$project$Utils$Form$fields(model.e).V7), $author$project$Utils$Form$init(A4($author$project$Components$Charge$Form$initFormFields, $elm$core$Maybe$Just(model.cP), startDateInput, endDateInput, categoryResourceFilter)));
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$StartDateInputMsg(startDateInput), startDateInputCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$EndDateInputMsg(endDateInput), endDateInputCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceFilterCmd),
                        filtersMsg
                    ])),
                    adu: 0,
                    zi: _Utils_update(model, {
                        e: newForm,
                        cL: newChargeItemFilter,
                        agk: $author$project$Api$Data$NotAsked,
                        Ya: false,
                        gP: false,
                        hh: true
                    }),
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                var newForm = function() {
                    if (response.$ === 3) {
                        var preview = response.a;
                        return A2($author$project$Components$Charge$Form$updateFormFromPreview, preview, model.e);
                    } else return model.e;
                }();
                return {
                    EQ: A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$GotPreview(response))),
                    adu: 0,
                    zi: _Utils_update(model, {
                        e: newForm,
                        agk: response
                    }),
                    at: _List_Nil
                };
            case 15:
                var response = msg.a;
                return {
                    EQ: A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$GotPreviewWithPayer(response))),
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var charge_ = response.a;
                    var _v17 = A3($author$project$Components$Charge$Form$overrideChargeDiscount, apiClient, $author$project$Api$Provider$Charge$One$id(charge_), model.e);
                    var cmd = _v17.a;
                    var event = _v17.b;
                    return {
                        EQ: cmd,
                        adu: event,
                        zi: _Utils_update(model, {
                            ach: response,
                            gP: false
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ach: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 13:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        ach: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 6:
                var subMsg = msg.a;
                var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rX);
                var patientUpdatedCmd = function() {
                    var _v21 = patientResourceResult.adu;
                    if (!_v21.$ && !_v21.a.$ && !_v21.a.a.$) {
                        var patient = _v21.a.a.a;
                        return A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$PatientUpdated($author$project$Api$Provider$Patient$All$id(patient))));
                    } else return $elm$core$Platform$Cmd$none;
                }();
                var patientRequestCmd = function() {
                    var _v20 = patientResourceResult.adu;
                    if (!_v20.$ && !_v20.a.$ && !_v20.a.a.$) {
                        var patient = _v20.a.a.a;
                        var patientId = $author$project$Api$Provider$Patient$All$id(patient);
                        return A3($author$project$Api$Provider$Patient$retrieve, apiClient, patientId, $author$project$Components$Charge$Form$GotPatient);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                var _v18 = function() {
                    var _v19 = patientResourceResult.adu;
                    if (!_v19.$ && !_v19.a.$ && !_v19.a.a.$) {
                        var patient = _v19.a.a.a;
                        var formPatient = {
                            aef: $author$project$Api$Provider$Patient$All$id(patient),
                            zr: $author$project$Api$Provider$Patient$All$name(patient)
                        };
                        return A4($author$project$Components$Charge$Form$updateForm, apiClient, model, $author$project$Components$Charge$Form$Patient($elm$core$Maybe$Just(formPatient)), model.e);
                    } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v18.a;
                var formCmd = _v18.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceResult.EQ),
                        patientUpdatedCmd,
                        patientRequestCmd
                    ])),
                    adu: 0,
                    zi: _Utils_update(newModel, {
                        rX: patientResourceResult.zi
                    }),
                    at: patientResourceResult.at
                };
            case 7:
                var subMsg = msg.a;
                var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cL);
                var _v22 = function() {
                    var _v23 = chargeItemResourceResult.adu;
                    _v23$2: while(true){
                        if (!_v23.$ && !_v23.a.$) switch(_v23.a.a.$){
                            case 0:
                                var chargeItem = _v23.a.a.a;
                                return A4($author$project$Components$Charge$Form$updateForm, apiClient, model, $author$project$Components$Charge$Form$ChargeItem(chargeItem), model.e);
                            case 5:
                                var string = _v23.a.a.a;
                                var _v24 = A4($author$project$Components$Charge$Form$updateForm, apiClient, model, $author$project$Components$Charge$Form$Name(string), model.e);
                                var newModel_ = _v24.a;
                                var formCmd_ = _v24.b;
                                return _Utils_Tuple2(_Utils_update(newModel_, {
                                    agk: $author$project$Api$Data$NotAsked
                                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                    A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$GotPreview($author$project$Api$Data$NotAsked))),
                                    formCmd_
                                ])));
                            default:
                                break _v23$2;
                        }
                        else break _v23$2;
                    }
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v22.a;
                var formCmd = _v22.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg, chargeItemResourceResult.EQ)
                    ])),
                    adu: 0,
                    zi: _Utils_update(newModel, {
                        cL: chargeItemResourceResult.zi
                    }),
                    at: chargeItemResourceResult.at
                };
            case 8:
                var subMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(model.e);
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.cK);
                var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    cK: categoryResourceResult.zi
                }), model.e);
                var _v25 = function() {
                    var _v26 = categoryResourceResult.adu;
                    if (!_v26.$) {
                        if (!_v26.a.$) return A4($author$project$Components$Charge$Form$updateForm, apiClient, model, $author$project$Components$Charge$Form$Category($author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi)), newForm);
                        else {
                            var _v27 = _v26.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                e: newForm
                            }), $elm$core$Platform$Cmd$none);
                        }
                    } else return _Utils_Tuple2(_Utils_update(model, {
                        e: newForm
                    }), $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v25.a;
                var formCmd = _v25.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, categoryResourceResult.EQ),
                        formCmd
                    ])),
                    adu: 0,
                    zi: newModel,
                    at: categoryResourceResult.at
                };
            case 9:
                var subMsg = msg.a;
                var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.jE);
                var _v28 = function() {
                    var _v29 = practitionerResourceResult.adu;
                    _v29$2: while(true){
                        if (!_v29.$ && !_v29.a.$) switch(_v29.a.a.$){
                            case 0:
                                var practitioner = _v29.a.a.a;
                                return A4($author$project$Components$Charge$Form$updateForm, apiClient, model, $author$project$Components$Charge$Form$Practitioner($elm$core$Maybe$Just(practitioner)), model.e);
                            case 2:
                                var _v30 = _v29.a.a;
                                return A4($author$project$Components$Charge$Form$updateForm, apiClient, model, $author$project$Components$Charge$Form$Practitioner($elm$core$Maybe$Nothing), model.e);
                            default:
                                break _v29$2;
                        }
                        else break _v29$2;
                    }
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v28.a;
                var formCmd = _v28.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, practitionerResourceResult.EQ)
                    ])),
                    adu: 0,
                    zi: _Utils_update(newModel, {
                        jE: practitionerResourceResult.zi
                    }),
                    at: practitionerResourceResult.at
                };
            case 10:
                var subMsg = msg.a;
                var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.ro);
                var _v31 = function() {
                    var _v32 = locationResourceResult.adu;
                    _v32$2: while(true){
                        if (!_v32.$ && !_v32.a.$) switch(_v32.a.a.$){
                            case 0:
                                var location1 = _v32.a.a.a;
                                return A4($author$project$Components$Charge$Form$updateForm, apiClient, model, $author$project$Components$Charge$Form$Location($elm$core$Maybe$Just(location1)), model.e);
                            case 2:
                                var _v33 = _v32.a.a;
                                return A4($author$project$Components$Charge$Form$updateForm, apiClient, model, $author$project$Components$Charge$Form$Location($elm$core$Maybe$Nothing), model.e);
                            default:
                                break _v32$2;
                        }
                        else break _v32$2;
                    }
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v31.a;
                var formCmd = _v31.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$LocationResourceFilterMsg, locationResourceResult.EQ)
                    ])),
                    adu: 0,
                    zi: _Utils_update(newModel, {
                        ro: locationResourceResult.zi
                    }),
                    at: locationResourceResult.at
                };
            case 11:
                var debounceMsg = msg.a;
                var _v34 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Charge$Form$previewDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Charge$Form$debouncePreview), debounceMsg, model.eq);
                var newDebouncer = _v34.a;
                var cmd = _v34.b;
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: _Utils_update(model, {
                        eq: newDebouncer
                    }),
                    at: _List_Nil
                };
            case 12:
                var cmd = msg.a;
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 14:
                var subMsg = msg.a;
                var routingFieldsResult = A3($author$project$Components$Charge$Form$RoutingFields$update, apiClient, subMsg, model.n3);
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Charge$Form$formFieldsUpdate, $author$project$Components$Charge$Form$RoutingFields(routingFieldsResult.zi.adM), model.e);
                var newModel = _Utils_update(model, {
                    e: newForm,
                    n3: routingFieldsResult.zi
                });
                var previewWithPayerCmds = function() {
                    var _v35 = routingFieldsResult.adu;
                    if (_v35 === 1) return A2($author$project$Components$Charge$Form$calculatePreviewWithPayer, apiClient, newModel);
                    else return _List_Nil;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$RoutingFieldsMsg, routingFieldsResult.EQ), previewWithPayerCmds)),
                    adu: 0,
                    zi: newModel,
                    at: routingFieldsResult.at
                };
            case 16:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        gP: !model.gP
                    }),
                    at: _List_Nil
                };
            case 17:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A7($author$project$Components$Charge$Form$updateDateInputFormField, apiClient, model, dateInput, subMsg, $author$project$Components$Charge$Form$StartDateInputMsg, $author$project$Components$Charge$Form$StartDate, function($) {
                    return $._0;
                });
            case 18:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A7($author$project$Components$Charge$Form$updateDateInputFormField, apiClient, model, dateInput, subMsg, $author$project$Components$Charge$Form$EndDateInputMsg, $author$project$Components$Charge$Form$EndDate, function($) {
                    return $.qv;
                });
            case 20:
                var response = msg.a;
                if (response.$ === 3) {
                    var patient = response.a;
                    var fields = $author$project$Utils$Form$fields(model.e);
                    var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                        aeT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Shared$id, $author$project$Api$Provider$Patient$One$location(patient)),
                        agi: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, $author$project$Api$Provider$Patient$One$practitioner(patient))
                    }), model.e);
                    var _v37 = A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, model);
                    var newModel = _v37.a;
                    var filtersMsg = _v37.b;
                    return {
                        EQ: filtersMsg,
                        adu: 0,
                        zi: _Utils_update(newModel, {
                            e: newForm,
                            V7: $elm$core$Maybe$Just(patient)
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var response = msg.a;
                var modelWithResponse = _Utils_update(model, {
                    Bp: response
                });
                if (response.$ === 3) {
                    var patient = response.a;
                    var formPatient = {
                        aef: $author$project$Api$Provider$Patient$One$id(patient),
                        zr: $author$project$Api$Provider$Patient$One$name(patient)
                    };
                    var _v39 = A2($author$project$Components$Charge$Form$initPatientResourceFilter, apiClient, $elm$core$Maybe$Just(patient));
                    var patientResourceFilter = _v39.a;
                    var patientResourceFilterCmd = _v39.b;
                    var _v40 = A4($author$project$Components$Charge$Form$updateForm, apiClient, modelWithResponse, $author$project$Components$Charge$Form$Patient($elm$core$Maybe$Just(formPatient)), modelWithResponse.e);
                    var modelWithForm = _v40.a;
                    var formCmd = _v40.b;
                    var _v41 = A3($author$project$Components$Charge$Form$updateFilters, apiClient, patient, modelWithForm);
                    var modelWithFilters = _v41.a;
                    var filtersCmd = _v41.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Charge$Form$PatientResourceFilterMsg, patientResourceFilterCmd),
                            formCmd,
                            filtersCmd,
                            A2($elm$core$Task$perform, $author$project$Components$Charge$Form$RoutingFieldsMsg, $elm$core$Task$succeed($author$project$Components$Charge$Form$RoutingFields$PatientUpdated($author$project$Api$Provider$Patient$One$id(patient))))
                        ])),
                        adu: 0,
                        zi: _Utils_update(modelWithFilters, {
                            V7: $elm$core$Maybe$Just(patient),
                            rX: patientResourceFilter
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: modelWithResponse,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$CustomerEmailModal$Editing = F4(function(a, b, c, d) {
        return {
            $: 4,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Components$CustomerEmailModal$Open = F4(function(a, b, c, d) {
        return {
            $: 3,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Components$CustomerEmailModal$GotDelivery = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$createNotification = F3(function(apiClient, _v0, preview) {
        var type_ = _v0.ah5;
        var contextId = _v0.wU;
        var recipient = _v0.BD;
        return A6($author$project$Api$Provider$Notification$create, apiClient, type_, $author$project$Api$Provider$Notification$Patient($author$project$Components$CustomerEmailModal$recipientId(recipient)), contextId, {
            fb: $author$project$Api$Provider$Notification$One$body(preview),
            HF: $author$project$Api$Provider$Notification$One$subject(preview)
        }, $author$project$Components$CustomerEmailModal$GotDelivery);
    });
    var $author$project$Components$CustomerEmailModal$initNotificationFormFields = function(notification) {
        return {
            fb: $author$project$Api$Provider$Notification$One$body(notification),
            HF: $author$project$Api$Provider$Notification$One$subject(notification)
        };
    };
    var $author$project$Components$CustomerEmailModal$notificationFormFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                HF: $author$project$Utils$String$toMaybe(string)
            });
        } else {
            var string = field.a;
            return _Utils_update(fields, {
                fb: $author$project$Utils$String$toMaybe(string)
            });
        }
    });
    var $author$project$Components$CustomerEmailModal$BodyValidation = 1;
    var $author$project$Components$CustomerEmailModal$SubjectValidation = 0;
    var $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.HF;
        }, _Utils_Tuple2(0, 'Please enter a valid subject')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.fb;
        }, _Utils_Tuple2(1, 'Please enter a valid body'))
    ]));
    var $author$project$Components$CustomerEmailModal$patientFormFieldsUpdate = F2(function(field, fields) {
        var string = field;
        return _Utils_update(fields, {
            OH: string
        });
    });
    var $author$project$Components$CustomerEmailModal$EmailValidation = 0;
    var $author$project$Components$CustomerEmailModal$patientFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: false
        }, A2($elm$core$Basics$composeR, function($) {
            return $.OH;
        }, $elm$core$Maybe$Just), _Utils_Tuple2(0, 'Please enter a valid email'))
    ]));
    var $author$project$Components$CustomerEmailModal$GotPatient = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$updateEmail = F4(function(apiClient, id_, email_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('patient', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('email', $elm$json$Json$Encode$string(email_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Components$CustomerEmailModal$updatePatientEmail = F2(function(apiClient, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var patientId = _v0.V8;
        var email = _v0.OH;
        return A4($author$project$Api$Provider$Patient$updateEmail, apiClient, patientId, email, $author$project$Components$CustomerEmailModal$GotPatient);
    });
    var $author$project$Components$CustomerEmailModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var session = msg.a;
                var type_ = msg.b;
                var contextId = msg.c;
                var recipient = msg.d;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A6($author$project$Components$CustomerEmailModal$open, apiClient, session, type_, contextId, recipient, model));
            case 1:
                return _Utils_Tuple3($author$project$Components$CustomerEmailModal$Closed, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                if (model.$ === 4) {
                    var shared = model.a;
                    var email = model.b;
                    var notificationForm = model.c;
                    var preview = model.d;
                    var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator, notificationForm);
                    if (!_v2.$) {
                        var _v3 = _v2.a;
                        var newForm = _v3.a;
                        var validFormFields = _v3.b;
                        return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Editing, shared, email, newForm, $author$project$Api$Data$Loading), A3($author$project$Components$CustomerEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Just(validFormFields)), _List_Nil);
                    } else {
                        var newForm = _v2.a;
                        return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Editing, shared, email, newForm, preview), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                if (model.$ === 3) {
                    var shared = model.a;
                    var email = model.b;
                    var preview = model.c;
                    return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Editing, shared, email, $author$project$Utils$Form$init($author$project$Components$CustomerEmailModal$initNotificationFormFields(preview)), $author$project$Api$Data$NotAsked), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                if (model.$ === 3) {
                    var shared = model.a;
                    var email = model.b;
                    var preview = model.c;
                    return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$Loading), A3($author$project$Components$CustomerEmailModal$createNotification, apiClient, shared, preview), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                if (model.$ === 1) {
                    var shared = model.a;
                    var patientForm = model.b;
                    var _v7 = function() {
                        var _v8 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$patientFormFieldsValidator, patientForm);
                        if (!_v8.$) {
                            var _v9 = _v8.a;
                            var form = _v9.a;
                            var validFormFields = _v9.b;
                            return _Utils_Tuple2(form, A2($author$project$Components$CustomerEmailModal$updatePatientEmail, apiClient, validFormFields));
                        } else {
                            var form = _v8.a;
                            return _Utils_Tuple2(form, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var validatedForm = _v7.a;
                    var cmd = _v7.b;
                    return _Utils_Tuple3(A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, validatedForm), cmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                var _v10 = _Utils_Tuple2(model, response);
                switch(_v10.a.$){
                    case 2:
                        if (_v10.b.$ === 3) {
                            var _v11 = _v10.a;
                            var shared = _v11.a;
                            var email = _v11.b;
                            var _v12 = _v10.b;
                            var preview = _v12.a;
                            return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$NotAsked), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else {
                            var _v13 = _v10.a;
                            var shared = _v13.a;
                            var email = _v13.b;
                            return _Utils_Tuple3(A2($author$project$Components$CustomerEmailModal$Loading, shared, email), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                        }
                    case 4:
                        if (_v10.b.$ === 3) {
                            var _v14 = _v10.a;
                            var shared = _v14.a;
                            var email = _v14.b;
                            var _v15 = _v10.b;
                            var preview = _v15.a;
                            return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, $author$project$Api$Data$NotAsked), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else {
                            var _v16 = _v10.a;
                            var shared = _v16.a;
                            var email = _v16.b;
                            var notificationForm = _v16.c;
                            return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Editing, shared, email, notificationForm, response), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                        }
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 7:
                var field = msg.a;
                if (model.$ === 4) {
                    var shared = model.a;
                    var email = model.b;
                    var notificationForm = model.c;
                    var preview = model.d;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerEmailModal$notificationFormFieldsUpdate, field, notificationForm);
                    var validatedForm = function() {
                        var _v18 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$notificationFormFieldsValidator, newForm);
                        if (!_v18.$) {
                            var _v19 = _v18.a;
                            var form = _v19.a;
                            return form;
                        } else {
                            var form = _v18.a;
                            return form;
                        }
                    }();
                    return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Editing, shared, email, validatedForm, preview), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var field = msg.a;
                if (model.$ === 1) {
                    var shared = model.a;
                    var patientForm = model.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerEmailModal$patientFormFieldsUpdate, field, patientForm);
                    var validatedForm = function() {
                        var _v21 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerEmailModal$patientFormFieldsValidator, newForm);
                        if (!_v21.$) {
                            var _v22 = _v21.a;
                            var form = _v22.a;
                            return form;
                        } else {
                            var form = _v21.a;
                            return form;
                        }
                    }();
                    return _Utils_Tuple3(A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, validatedForm), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var response = msg.a;
                if (model.$ === 1) {
                    var shared = model.a;
                    var patientForm = model.b;
                    if (response.$ === 3) {
                        var patient = response.a;
                        return _Utils_Tuple3(A2($author$project$Components$CustomerEmailModal$Loading, shared, A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$One$email(patient))), A3($author$project$Components$CustomerEmailModal$previewNotification, apiClient, shared, $elm$core$Maybe$Nothing), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Patient email updated')
                        ]));
                    } else return _Utils_Tuple3(A2($author$project$Components$CustomerEmailModal$NoRecipientEmail, shared, patientForm), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (model.$ === 3) {
                    var shared = model.a;
                    var email = model.b;
                    var preview = model.c;
                    if (response.$ === 3) return _Utils_Tuple3($author$project$Components$CustomerEmailModal$Closed, $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'This email is being sent')
                    ]));
                    else return _Utils_Tuple3(A4($author$project$Components$CustomerEmailModal$Open, shared, email, preview, response), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Api$Provider$CustomerInvoice$Adjustments = 2;
    var $author$project$Components$CustomerSchedulePaymentModal$Date = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerSchedulePaymentModal$None = {
        $: 0
    };
    var $author$project$Api$Provider$CustomerInvoice$OwnerPhones = 3;
    var $author$project$Components$CustomerSchedulePaymentModal$PaymentScheduled = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CustomerInvoice$Payments = 1;
    var $author$project$Components$CustomerSchedulePaymentModal$Scheduled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate = F2(function(field, fields) {
        var dateInput = field.a;
        var date = field.b;
        return _Utils_update(fields, {
            M4: date,
            qg: dateInput
        });
    });
    var $author$project$Components$CustomerSchedulePaymentModal$DateValidation = 0;
    var $author$project$Components$CustomerSchedulePaymentModal$validateStartDate = F2(function(currentDate, fields) {
        var _v0 = fields.M4;
        if (!_v0.$) {
            var date = _v0.a;
            return A2($justinmimbs$date$Date$compare, currentDate, date) !== 2 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a future date')
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$CustomerSchedulePaymentModal$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerSchedulePaymentModal$validateStartDate(currentDate))
        ]));
    };
    var $author$project$Api$Provider$CustomerInvoice$schedulePayment = F5(function(apiClient, id, date, expand, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, date))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'schedule_payment'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))))));
    });
    var $author$project$Components$CustomerSchedulePaymentModal$update = F3(function(apiClient, msg, model) {
        if (model.$ === 1) {
            var model_ = model.a;
            switch(msg.$){
                case 0:
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$CustomerSchedulePaymentModal$None,
                        zi: $author$project$Components$CustomerSchedulePaymentModal$Closed,
                        at: _List_Nil
                    };
                case 1:
                    var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerSchedulePaymentModal$formFieldsValidator(model_.cP), model_.PU);
                    if (!_v2.$) {
                        var _v3 = _v2.a;
                        var newForm = _v3.a;
                        var validFormFields = _v3.b;
                        var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                        var date = _v4.M4;
                        return {
                            EQ: A5($author$project$Api$Provider$CustomerInvoice$schedulePayment, apiClient, model_.RI, date, _List_fromArray([
                                0,
                                1,
                                2,
                                3
                            ]), $author$project$Components$CustomerSchedulePaymentModal$Scheduled),
                            adu: $author$project$Components$CustomerSchedulePaymentModal$None,
                            zi: $author$project$Components$CustomerSchedulePaymentModal$Open(_Utils_update(model_, {
                                PU: newForm,
                                su: $author$project$Api$Data$Loading
                            })),
                            at: _List_Nil
                        };
                    } else {
                        var newForm = _v2.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$CustomerSchedulePaymentModal$None,
                            zi: $author$project$Components$CustomerSchedulePaymentModal$Open(_Utils_update(model_, {
                                PU: newForm
                            })),
                            at: _List_Nil
                        };
                    }
                case 2:
                    var response = msg.a;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: A2($author$project$Components$CustomerSchedulePaymentModal$PaymentScheduled, model_.RI, response),
                        zi: $author$project$Components$CustomerSchedulePaymentModal$Closed,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Payment scheduled!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$CustomerSchedulePaymentModal$None,
                        zi: model,
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                default:
                    var dateInput = msg.a;
                    var subMsg = msg.b;
                    var _v6 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
                    var newDateInput = _v6.a;
                    var subCmd = _v6.b;
                    var event = _v6.c;
                    var newForm = function() {
                        if (event.$ === 1) {
                            var date = event.a;
                            return A3($author$project$Utils$Form$update, $author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate, A2($author$project$Components$CustomerSchedulePaymentModal$Date, newDateInput, date), model_.PU);
                        } else {
                            var fields = $author$project$Utils$Form$fields(model_.PU);
                            return A3($author$project$Utils$Form$update, $author$project$Components$CustomerSchedulePaymentModal$formFieldsUpdate, A2($author$project$Components$CustomerSchedulePaymentModal$Date, newDateInput, fields.M4), model_.PU);
                        }
                    }();
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(newDateInput), subCmd),
                        adu: $author$project$Components$CustomerSchedulePaymentModal$None,
                        zi: $author$project$Components$CustomerSchedulePaymentModal$Open(_Utils_update(model_, {
                            PU: newForm
                        })),
                        at: _List_Nil
                    };
            }
        } else return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: $author$project$Components$CustomerSchedulePaymentModal$None,
            zi: $author$project$Components$CustomerSchedulePaymentModal$Closed,
            at: _List_Nil
        };
    });
    var $author$project$Pages$Charges$New$updateField = F2(function(invoice, field) {
        switch(field.$){
            case 0:
                var status = field.a;
                return _Utils_update(invoice, {
                    ahy: status
                });
            case 1:
                var dropdownMenu = field.a;
                return _Utils_update(invoice, {
                    l_: dropdownMenu
                });
            default:
                var response = field.a;
                return _Utils_update(invoice, {
                    j_: response
                });
        }
    });
    var $author$project$Pages$Charges$New$updateInvoice = F3(function(invoiceId, field, invoices) {
        return A2($elm$core$List$map, function(invoice) {
            return _Utils_eq(invoice.aef, invoiceId) ? A2($author$project$Pages$Charges$New$updateField, invoice, field) : invoice;
        }, invoices);
    });
    var $author$project$Pages$Charges$New$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    sx: true
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$save), _List_Nil);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    sx: false
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$save), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var chargeFormResult = A3($author$project$Components$Charge$Form$update, model.Ej, subMsg, model.e);
                var maybeInvoice = A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$invoice, $author$project$Api$Data$toMaybe($author$project$Components$Charge$Form$charge(chargeFormResult.zi))));
                var invoiceRetrieveCmd = function() {
                    if (!maybeInvoice.$) {
                        var invoice = maybeInvoice.a;
                        var _v7 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
                        switch(_v7){
                            case 1:
                                return A4($author$project$Api$Provider$CustomerInvoice$retrieve, model.Ej, $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice), _List_Nil, A2($author$project$Pages$Charges$New$GotCustomerInvoice, $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice), $elm$core$Maybe$Nothing));
                            case 0:
                                return $elm$core$Platform$Cmd$none;
                            default:
                                return $elm$core$Platform$Cmd$none;
                        }
                    } else return $elm$core$Platform$Cmd$none;
                }();
                var _v1 = function() {
                    var _v2 = chargeFormResult.adu;
                    if (_v2 === 1) {
                        var _v3 = model.sx ? _Utils_Tuple2($author$project$Components$Charge$Form$reset, 'created') : _Utils_Tuple2($author$project$Components$Charge$Form$newFormWithPatient, 'added');
                        var chargeFormCmd = _v3.a;
                        var toastVerb = _v3.b;
                        return _Utils_Tuple2(A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormCmd), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $elm$core$String$concat(_List_fromArray([
                                'Charge ',
                                toastVerb,
                                '!'
                            ])))
                        ]));
                    } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
                }();
                var resetCmd = _v1.a;
                var toastMsgs = _v1.b;
                var _v4 = function() {
                    var _v5 = chargeFormResult.adu;
                    if (_v5 === 1) {
                        var createdChargeForm = $author$project$Components$Charge$Form$readOnly($author$project$Components$Charge$Form$hide(chargeFormResult.zi));
                        return _Utils_Tuple2(_Utils_ap(model.dF, _List_fromArray([
                            createdChargeForm
                        ])), A2($author$project$Pages$Charges$New$refreshInvoiceList, model.q5, maybeInvoice));
                    } else return _Utils_Tuple2(model.dF, model.q5);
                }();
                var createdCharges = _v4.a;
                var invoices = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    e: chargeFormResult.zi,
                    dF: createdCharges,
                    q5: invoices
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$ChargeFormMsg, chargeFormResult.EQ),
                    resetCmd,
                    invoiceRetrieveCmd
                ])), _Utils_ap(chargeFormResult.at, toastMsgs));
            case 3:
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top), _List_Nil);
            case 4:
                var invoiceId = msg.a;
                var subMsg = msg.b;
                var _v8 = A2($author$project$Pages$Charges$New$findDropdownMenu, model.q5, invoiceId);
                if (!_v8.$) {
                    var invoiceDropdownMenu = _v8.a;
                    var _v9 = A2($author$project$Ui$Dropdown$update, subMsg, invoiceDropdownMenu);
                    var dropdownMenu = _v9.a;
                    var cmd = _v9.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        q5: A3($author$project$Pages$Charges$New$updateInvoice, invoiceId, $author$project$Pages$Charges$New$Dropdown(dropdownMenu), model.q5)
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var index = msg.a;
                var _v10 = A2($elm_community$list_extra$List$Extra$getAt, index, model.dF);
                if (!_v10.$) {
                    var createdCharge = _v10.a;
                    var updatedCreatedCharge = $author$project$Components$Charge$Form$toggle(createdCharge);
                    var createdCharges = A3($elm_community$list_extra$List$Extra$setAt, index, updatedCreatedCharge, A2($elm$core$List$map, function(createdCharge_) {
                        return $author$project$Components$Charge$Form$hide(createdCharge_);
                    }, model.dF));
                    return _Utils_Tuple3(_Utils_update(model, {
                        dF: createdCharges
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var invoiceId = msg.a;
                var afterIssueMsg = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    q5: A3($author$project$Pages$Charges$New$updateInvoice, invoiceId, $author$project$Pages$Charges$New$SaveRequest($author$project$Api$Data$Loading), model.q5)
                }), A4($author$project$Api$Provider$CustomerInvoice$issue, model.Ej, invoiceId, _List_fromArray([
                    0
                ]), A2($author$project$Pages$Charges$New$GotCustomerInvoice, invoiceId, $elm$core$Maybe$Just(afterIssueMsg))), _List_Nil);
            case 7:
                var invoiceId = msg.a;
                var maybeAfterIssueMsg = msg.b;
                var response = msg.c;
                if (response.$ === 3) {
                    var invoice = response.a;
                    var invoicesUpdated = A3($author$project$Pages$Charges$New$updateInvoice, invoiceId, $author$project$Pages$Charges$New$SaveRequest(response), A3($author$project$Pages$Charges$New$updateInvoice, invoiceId, $author$project$Pages$Charges$New$Status($author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice)), model.q5));
                    var cmd = function() {
                        var _v12 = _Utils_Tuple2(maybeAfterIssueMsg, A2($author$project$Pages$Charges$New$findInvoice, invoicesUpdated, invoiceId));
                        if (!_v12.a.$ && !_v12.b.$) {
                            var afterIssueMsg = _v12.a.a;
                            var invoice_ = _v12.b.a;
                            return A2($author$project$Pages$Charges$New$triggerAfterIssueAction, afterIssueMsg, invoice_);
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        q5: invoicesUpdated
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    q5: A3($author$project$Pages$Charges$New$updateInvoice, invoiceId, $author$project$Pages$Charges$New$SaveRequest(response), model.q5)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var invoice = msg.a;
                var external = msg.b;
                return $author$project$Pages$Charges$New$isDraft(invoice) ? _Utils_Tuple3(model, A2($elm$core$Task$perform, function(_v13) {
                    var paymentMsgType = external ? 1 : 0;
                    return A2($author$project$Pages$Charges$New$Issue, invoice.aef, paymentMsgType);
                }, $elm$time$Time$now), _List_Nil) : A4($author$project$Pages$Charges$New$showPaymentModal, model, invoice, external, invoice.aef);
            case 9:
                var subMsg = msg.a;
                var _v14 = model.lH;
                if (!_v14.$) {
                    var _v15 = _v14.a;
                    var createPaymentModal = _v15.a;
                    var invoiceId = _v15.b;
                    var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.Ej, subMsg, createPaymentModal);
                    var _v16 = function() {
                        var _v17 = createPaymentModalResult.adu;
                        switch(_v17){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_Tuple2(createPaymentModalResult.zi, invoiceId)), model.q5, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A3($author$project$Pages$Charges$New$updateInvoice, invoiceId, $author$project$Pages$Charges$New$SaveRequest($author$project$Api$Data$Loading), model.q5), A2($author$project$Pages$Charges$New$retrieveInvoice, model.Ej, invoiceId));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.q5, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var createPaymentModal_ = _v16.a;
                    var invoices = _v16.b;
                    var cmd = _v16.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lH: createPaymentModal_,
                        q5: invoices
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CreatePaymentModalMsg, createPaymentModalResult.EQ),
                        cmd
                    ])), createPaymentModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var patientId = msg.a;
                var invoice = msg.b;
                var cmd = $author$project$Pages$Charges$New$isDraft(invoice) ? A2($elm$core$Task$perform, function(_v18) {
                    return A2($author$project$Pages$Charges$New$Issue, invoice.aef, 2);
                }, $elm$time$Time$now) : A3($author$project$Api$Provider$Patient$retrieve, model.Ej, patientId, $author$project$Pages$Charges$New$GotPatient(invoice.aef));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 12:
                var invoiceId = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var patient = response.a;
                    var _v20 = A6($author$project$Components$CustomerEmailModal$open, model.Ej, model.Z$, 0, invoiceId, $author$project$Components$CustomerEmailModal$PatientOne(patient), model.lM);
                    var customerEmailModal = _v20.a;
                    var customerEmailModalCmd = _v20.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lM: customerEmailModal
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CustomerEmailModalMsg, customerEmailModalCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var subMsg = msg.a;
                var _v21 = A3($author$project$Components$CustomerEmailModal$update, model.Ej, subMsg, model.lM);
                var customerEmailModal = _v21.a;
                var subCmd = _v21.b;
                var subOutMsg = _v21.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    lM: customerEmailModal
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$CustomerEmailModalMsg, subCmd), subOutMsg);
            case 13:
                var invoice = msg.a;
                var _v22 = $author$project$Pages$Charges$New$isDraft(invoice) ? _Utils_Tuple2(model.gG, A2($elm$core$Task$perform, function(_v23) {
                    return A2($author$project$Pages$Charges$New$Issue, invoice.aef, 3);
                }, $elm$time$Time$now)) : A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Charges$New$SchedulePaymentModalMsg), A2($author$project$Components$CustomerSchedulePaymentModal$open, invoice.aef, model.Cu.cP));
                var schedulePaymentModal = _v22.a;
                var schedulePaymentModalCmd = _v22.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    gG: schedulePaymentModal
                }), schedulePaymentModalCmd, _List_Nil);
            default:
                var subMsg = msg.a;
                var schedulePaymentResult = A3($author$project$Components$CustomerSchedulePaymentModal$update, model.Ej, subMsg, model.gG);
                var invoices = function() {
                    var _v24 = schedulePaymentResult.adu;
                    if (!_v24.$) return model.q5;
                    else {
                        var invoiceId = _v24.a;
                        var invoice = _v24.b;
                        return A3($author$project$Pages$Charges$New$updateInvoice, invoiceId, $author$project$Pages$Charges$New$SaveRequest(invoice), model.q5);
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    q5: invoices,
                    gG: schedulePaymentResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Charges$New$SchedulePaymentModalMsg, schedulePaymentResult.EQ), schedulePaymentResult.at);
        }
    });
    var $author$project$Components$CustomerEmailModal$Body = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$Email = $elm$core$Basics$identity;
    var $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$PatientFormFieldUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$Subject = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$UpdatePatientEmail = {
        $: 5
    };
    var $author$project$Ui$Form$Inline = {
        $: 4
    };
    var $author$project$Ui$Form$inline = $author$project$Ui$Form$Inline;
    var $author$project$Api$Provider$Reports$Patient$oneName = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$CustomerEmailModal$recipientName = function(recipient) {
        switch(recipient.$){
            case 0:
                var patient = recipient.a;
                return $author$project$Api$Provider$Reports$Patient$oneName(patient);
            case 1:
                var patient = recipient.a;
                return $author$project$Api$Provider$Patient$One$name(patient);
            default:
                var patient = recipient.a;
                return $author$project$Api$Provider$Patient$Shared$name(patient);
        }
    };
    var $author$project$Components$CustomerEmailModal$viewPreview = F4(function(recipient, email, subject, body) {
        return _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('email-preview')
                ]), _List_fromArray([
                    A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('To ' + $author$project$Components$CustomerEmailModal$recipientName(recipient))
                    ])),
                    $elm$html$Html$text('<' + (email + '>')),
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Subject')
                    ])),
                    subject,
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    body
                ]))
            ]))
        ]);
    });
    var $author$project$Components$CustomerEmailModal$viewModalBody = function(model) {
        switch(model.$){
            case 0:
                return _List_Nil;
            case 1:
                var shared = model.a;
                var patientForm = model.b;
                var _v1 = $author$project$Utils$Form$fields(patientForm);
                var email = _v1.OH;
                return _List_fromArray([
                    A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Please add an email address for '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Components$CustomerEmailModal$recipientName(shared.BD))
                        ])),
                        $elm$html$Html$text('.')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('email-preview')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$view, _List_fromArray([
                                $author$project$Ui$Form$inline,
                                $author$project$Ui$Form$noValidate(true),
                                $author$project$Ui$Form$autocomplete(false)
                            ]), _List_fromArray([
                                A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('To ' + $author$project$Components$CustomerEmailModal$recipientName(shared.BD))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('< '),
                                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                        $author$project$Ui$Form$Input$view(_List_fromArray([
                                            $author$project$Ui$Form$Input$placeholder('somebody@example.com'),
                                            $author$project$Ui$Form$Input$value(email),
                                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$PatientFormFieldUpdated, $elm$core$Basics$identity)),
                                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, patientForm))
                                        ]))
                                    ])),
                                    $elm$html$Html$text(' > '),
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Save custom email'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$UpdatePatientEmail)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Save')
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]);
            case 2:
                var shared = model.a;
                var email = model.b;
                return A4($author$project$Components$CustomerEmailModal$viewPreview, shared.BD, email, $author$project$Ui$Spinner$view(_List_Nil), $author$project$Ui$Spinner$view(_List_Nil));
            case 3:
                var shared = model.a;
                var email = model.b;
                var preview = model.c;
                var delivery = model.d;
                return _Utils_ap(A4($author$project$Components$CustomerEmailModal$viewPreview, shared.BD, email, A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('subject')
                ]), $author$project$Utils$Dom$textToHtml(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Notification$One$subjectHtml(preview))))), A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('body'), $author$project$Api$Phi$displayAttr), $author$project$Utils$Dom$textToHtml(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Notification$One$bodyHtml(preview)))))), _List_fromArray([
                    function() {
                        if (delivery.$ === 2) {
                            var error = delivery.a;
                            return A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Error sending email')
                                ])),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                $elm$html$Html$text($author$project$Api$Data$errorToString(error))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]));
            default:
                var shared = model.a;
                var email = model.b;
                var notificationForm = model.c;
                var _v3 = $author$project$Utils$Form$fields(notificationForm);
                var subject = _v3.HF;
                var body = _v3.fb;
                return A4($author$project$Components$CustomerEmailModal$viewPreview, shared.BD, email, A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', subject)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated, $author$project$Components$CustomerEmailModal$Subject)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, notificationForm)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, notificationForm))
                    ]))
                ])), A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Form$Textarea$view(_List_fromArray([
                            $author$project$Ui$Form$Textarea$rows(15),
                            $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', body)),
                            $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CustomerEmailModal$NotificationFormFieldUpdated, $author$project$Components$CustomerEmailModal$Body)),
                            $author$project$Ui$Form$Textarea$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, notificationForm)),
                            $author$project$Ui$Form$Textarea$errors(A2($author$project$Utils$Form$validationErrors, 1, notificationForm))
                        ]))
                    ]))
                ])));
        }
    };
    var $author$project$Components$CustomerEmailModal$Edit = {
        $: 3
    };
    var $author$project$Components$CustomerEmailModal$Preview = {
        $: 2
    };
    var $author$project$Components$CustomerEmailModal$Send = {
        $: 4
    };
    var $author$project$Components$CustomerEmailModal$viewCancelButton = A3($author$project$Ui$Button$view, {
        abP: 'Cancel and close modal'
    }, _List_fromArray([
        $author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Close)
    ]), _List_fromArray([
        $elm$html$Html$text('Cancel')
    ]));
    var $author$project$Components$CustomerEmailModal$viewModalFooter = function(model) {
        return $elm$core$List$singleton(A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap2
        ]), function() {
            switch(model.$){
                case 0:
                    return _List_Nil;
                case 1:
                    return _List_fromArray([
                        $author$project$Components$CustomerEmailModal$viewCancelButton
                    ]);
                case 2:
                    return _List_fromArray([
                        $author$project$Components$CustomerEmailModal$viewCancelButton
                    ]);
                case 3:
                    var delivery = model.d;
                    var deliveryLoading = function() {
                        if (delivery.$ === 1) return true;
                        else return false;
                    }();
                    return _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Customize email'
                        }, _List_fromArray([
                            $author$project$Ui$Button$pull(0),
                            $author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Edit)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Customize Email')
                        ])),
                        $author$project$Components$CustomerEmailModal$viewCancelButton,
                        A3($author$project$Ui$Button$view, {
                            abP: 'Send email'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$submit,
                            $author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Send),
                            $author$project$Ui$Button$loading(deliveryLoading)
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$send(_List_Nil),
                            $elm$html$Html$text('Send Email')
                        ]))
                    ]);
                default:
                    var preview = model.d;
                    var loading = function() {
                        if (preview.$ === 1) return true;
                        else return false;
                    }();
                    return _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Preview email'
                        }, _List_fromArray([
                            $author$project$Ui$Button$pull(0),
                            $author$project$Ui$Button$onClick($author$project$Components$CustomerEmailModal$Preview),
                            $author$project$Ui$Button$loading(loading)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Preview Email')
                        ])),
                        $author$project$Components$CustomerEmailModal$viewCancelButton
                    ]);
            }
        }()));
    };
    var $author$project$Components$CustomerEmailModal$viewModal = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$CustomerEmailModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Send via Email')
            ])),
            $author$project$Ui$Modal$body($author$project$Components$CustomerEmailModal$viewModalBody(model)),
            $author$project$Ui$Modal$footer($author$project$Components$CustomerEmailModal$viewModalFooter(model))
        ]));
    };
    var $author$project$Components$CustomerEmailModal$modal = function(model) {
        if (!model.$) return $author$project$Utils$Html$empty;
        else return $author$project$Components$CustomerEmailModal$viewModal(model);
    };
    var $author$project$Components$CustomerSchedulePaymentModal$Schedule = {
        $: 1
    };
    var $author$project$Components$CustomerSchedulePaymentModal$viewDate = F2(function(fields, form) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(6),
            $author$project$Ui$Form$Group$label('On Date')
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$CustomerSchedulePaymentModal$DateInputMsg(fields.qg), A2($author$project$Components$DateInput$view, _List_fromArray([
                $author$project$Components$DateInput$value(fields.M4),
                $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]), fields.qg))
        ]));
    });
    var $author$project$Components$CustomerSchedulePaymentModal$viewModal = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$CustomerSchedulePaymentModal$CloseModal, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Schedule Payment')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Components$CustomerSchedulePaymentModal$viewDate, fields, model.PU)
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$CustomerSchedulePaymentModal$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Schedule payment'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.su, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$CustomerSchedulePaymentModal$Schedule)
                ]), _List_fromArray([
                    $elm$html$Html$text('Schedule Payment')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CustomerSchedulePaymentModal$view = function(model) {
        if (model.$ === 1) {
            var model_ = model.a;
            return $author$project$Components$CustomerSchedulePaymentModal$viewModal(model_);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Charges$New$Save = {
        $: 0
    };
    var $author$project$Components$Charge$Form$formReady = function(_v0) {
        var model = _v0;
        var _v1 = model.Bp;
        switch(_v1.$){
            case 0:
                return !model.rV;
            case 3:
                return true;
            default:
                return false;
        }
    };
    var $author$project$Ui$Element$Background = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Element$Primary50 = 0;
    var $author$project$Ui$Element$bgPrimary50 = $author$project$Ui$Element$Background(0);
    var $author$project$Api$Provider$Charge$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Components$Charge$Form$RoutingFields$PatientInvoiceSelected = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$SponsorInvoiceSelected = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$Grid = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$labelSpanSm = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$spanSm, $author$project$Ui$Form$Accessible$Grid);
    var $author$project$Api$Provider$CustomerInvoice$All$date = function(_v0) {
        var record = _v0;
        return record.M4;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$humanStatus = function(_v0) {
        var record = _v0;
        return record.QX;
    };
    var $author$project$Components$Charge$Form$RoutingFields$invoiceLabel = F3(function(status, number, date) {
        return $elm_community$string_extra$String$Extra$humanize(status) + (' Invoice #' + ($elm$core$String$fromInt(number) + (' - Date ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date))));
    });
    var $author$project$Api$Provider$CustomerInvoice$All$invoiceNumber = function(_v0) {
        var record = _v0;
        return record.RK;
    };
    var $author$project$Components$Charge$Form$RoutingFields$patientInvoiceSelectItems = F2(function(currentDate, dataCustomerInvoices) {
        if (dataCustomerInvoices.$ === 3) {
            var customerInvoices = dataCustomerInvoices.a;
            var newInvoice = A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('new'), 'Create a new draft invoice');
            var lastInvoice = $elm$core$List$head($elm$core$List$reverse(customerInvoices));
            var lastInvoiceDate = function() {
                if (!lastInvoice.$) {
                    var lastInvoice_ = lastInvoice.a;
                    return $author$project$Api$Provider$CustomerInvoice$All$date(lastInvoice_);
                } else return currentDate;
            }();
            var label = function(invoice) {
                return A3($author$project$Components$Charge$Form$RoutingFields$invoiceLabel, $author$project$Api$Provider$CustomerInvoice$All$humanStatus(invoice), $author$project$Api$Provider$CustomerInvoice$All$invoiceNumber(invoice), $author$project$Api$Provider$CustomerInvoice$All$date(invoice));
            };
            return A3($justinmimbs$date$Date$diff, 3, lastInvoiceDate, currentDate) > 30 ? _List_fromArray([
                newInvoice
            ]) : _Utils_ap(A2($elm$core$List$map, function(invoice) {
                return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$CustomerInvoice$All$id(invoice)), label(invoice));
            }, customerInvoices), _List_fromArray([
                newInvoice
            ]));
        } else return _List_Nil;
    });
    var $author$project$Ui$Form$Accessible$Required = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$required = $author$project$Ui$Form$Accessible$Required;
    var $author$project$Ui$Form$Accessible$Select = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$Accessible$select = $author$project$Ui$Form$Accessible$Select;
    var $author$project$Ui$Form$Accessible$AccessibleInput = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Grid$extractSpanValue = function(option) {
        extractSpanValue: while(true){
            _v0$2: while(true)switch(option.$){
                case 0:
                    var screenSize = option.a;
                    var spanValue = option.b;
                    return $elm$core$Maybe$Just(_Utils_Tuple2(screenSize, spanValue));
                case 2:
                    if (option.a.a) {
                        var _v1 = option.a;
                        var innerOption = _v1.b;
                        var $temp$option = innerOption;
                        option = $temp$option;
                        continue extractSpanValue;
                    } else break _v0$2;
                default:
                    break _v0$2;
            }
            return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Ui$ScreenSize$Xl = 4;
    var $author$project$Ui$Grid$spanXl = $author$project$Ui$Grid$Span(4);
    var $author$project$Ui$Grid$complementSpan = function(labelOptions) {
        var spanValues = A2($elm$core$List$filterMap, $author$project$Ui$Grid$extractSpanValue, labelOptions);
        var createComplementarySpan = function(_v1) {
            var screenSize = _v1.a;
            var spanValue = _v1.b;
            switch(screenSize){
                case 0:
                    return $author$project$Ui$Grid$span(12 - spanValue);
                case 1:
                    return $author$project$Ui$Grid$spanSm(12 - spanValue);
                case 2:
                    return $author$project$Ui$Grid$spanMd(12 - spanValue);
                case 3:
                    return $author$project$Ui$Grid$spanLg(12 - spanValue);
                default:
                    return $author$project$Ui$Grid$spanXl(12 - spanValue);
            }
        };
        return A2($elm$core$List$map, createComplementarySpan, spanValues);
    };
    var $author$project$Ui$Form$Accessible$defaultLabelOptions = {
        a9: _List_Nil,
        agM: false
    };
    var $author$project$Ui$Form$Accessible$labelOptionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(opt, rec) {
            if (!opt.$) {
                var gridOption = opt.a;
                return _Utils_update(rec, {
                    a9: A2($elm$core$List$cons, gridOption, rec.a9)
                });
            } else {
                var bool = opt.a;
                return _Utils_update(rec, {
                    agM: bool
                });
            }
        }), $author$project$Ui$Form$Accessible$defaultLabelOptions, options);
    };
    var $author$project$Ui$Form$Accessible$defaultInputOptions = {
        fK: _List_Nil,
        a9: _List_Nil
    };
    var $author$project$Ui$Form$Accessible$inputOptionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(opt, rec) {
            if (!opt.$) {
                var gridOption = opt.a;
                return _Utils_update(rec, {
                    a9: A2($elm$core$List$cons, gridOption, rec.a9)
                });
            } else {
                var errors_ = opt.a;
                return _Utils_update(rec, {
                    fK: errors_
                });
            }
        }), $author$project$Ui$Form$Accessible$defaultInputOptions, options);
    };
    var $author$project$Components$DateInput$HideErrors = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$DateInput$hideErrors = $author$project$Components$DateInput$HideErrors;
    var $author$project$Ui$Form$CurrencyInput$HideErrors = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$hideErrors = $author$project$Ui$Form$CurrencyInput$HideErrors;
    var $author$project$Ui$Form$Select$HideErrors = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$hideErrors = $author$project$Ui$Form$Select$HideErrors;
    var $author$project$Ui$Form$Textarea$HideErrors = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$hideErrors = $author$project$Ui$Form$Textarea$HideErrors;
    var $author$project$Components$ResourceFilter$AriaLabel = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$ariaLabel = $author$project$Components$ResourceFilter$AriaLabel;
    var $author$project$Ui$Form$Accessible$resourceFilterOptions = F2(function(label_, errors_) {
        return _List_fromArray([
            $author$project$Components$ResourceFilter$errors(errors_),
            $author$project$Components$ResourceFilter$invalid(!$elm$core$List$isEmpty(errors_)),
            $author$project$Components$ResourceFilter$ariaLabel(label_)
        ]);
    });
    var $author$project$Components$ResourceFilter$ChargeItem$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$ResourceFilter$CreditCategory$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$CreditCategory$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$ResourceFilter$Patient$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Ui$Form$Accessible$viewInput = function(accessibleInput) {
        if (accessibleInput.$ === 1) return $elm$html$Html$text('');
        else {
            var labelText = accessibleInput.a;
            var inputOptions = accessibleInput.b;
            var input_ = accessibleInput.c;
            var optionsRecord = $author$project$Ui$Form$Accessible$inputOptionsToRecord(inputOptions);
            return A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('sr-only')
                ]), _List_fromArray([
                    $elm$html$Html$text(labelText)
                ])),
                function() {
                    switch(input_.$){
                        case 0:
                            var options = input_.a;
                            return $author$project$Ui$Form$Input$view(A2($elm$core$List$cons, $author$project$Ui$Form$Input$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)), A2($elm$core$List$cons, $author$project$Ui$Form$Input$hideErrors(true), options))));
                        case 1:
                            var options = input_.a;
                            return $author$project$Ui$Form$Textarea$view(A2($elm$core$List$cons, $author$project$Ui$Form$Textarea$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$Textarea$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)), A2($elm$core$List$cons, $author$project$Ui$Form$Textarea$hideErrors(true), options))));
                        case 2:
                            var options = input_.a;
                            return $author$project$Ui$Form$CurrencyInput$view(A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$hideErrors(true), options))));
                        case 4:
                            var options = input_.a;
                            var items = input_.b;
                            return A2($author$project$Ui$Form$Select$view, A2($elm$core$List$cons, $author$project$Ui$Form$Select$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$Select$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)), A2($elm$core$List$cons, $author$project$Ui$Form$Select$hideErrors(true), options))), items);
                        case 5:
                            var options = input_.a;
                            var trigger = input_.b;
                            var items = input_.c;
                            var model = input_.d;
                            return A4($author$project$Ui$Dropdown$viewSelect, A2($elm$core$List$cons, $author$project$Ui$Dropdown$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Dropdown$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)), options)), trigger, items, model);
                        case 6:
                            var options = input_.a;
                            var content = input_.b;
                            return A2($author$project$Ui$Form$Checkbox$view, options, content);
                        case 7:
                            var mapper = input_.a;
                            var options = input_.b;
                            var model = input_.c;
                            return A2($elm$html$Html$map, mapper, A2($author$project$Components$ResourceFilter$Patient$viewNew, _Utils_ap(A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fK), options), model));
                        case 8:
                            var mapper = input_.a;
                            var options = input_.b;
                            var model = input_.c;
                            return A2($elm$html$Html$map, mapper, A2($author$project$Components$ResourceFilter$ChargeItem$viewNew, _Utils_ap(A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fK), options), model));
                        case 9:
                            var mapper = input_.a;
                            var options = input_.b;
                            var model = input_.c;
                            return A2($elm$html$Html$map, mapper, A2($author$project$Components$ResourceFilter$Category$viewNew, _Utils_ap(A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fK), options), model));
                        case 10:
                            var mapper = input_.a;
                            var options = input_.b;
                            var model = input_.c;
                            return A2($elm$html$Html$map, mapper, A2($author$project$Components$ResourceFilter$Practitioner$viewNew, _Utils_ap(A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fK), options), model));
                        case 12:
                            var mapper = input_.a;
                            var options = input_.b;
                            var model = input_.c;
                            return A2($elm$html$Html$map, mapper, A2($author$project$Components$ResourceFilter$CreditCategory$viewNew, _Utils_ap(A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fK), options), model));
                        case 11:
                            var mapper = input_.a;
                            var options = input_.b;
                            var model = input_.c;
                            return A2($elm$html$Html$map, mapper, A2($author$project$Components$ResourceFilter$Location$viewNew, _Utils_ap(A2($author$project$Ui$Form$Accessible$resourceFilterOptions, labelText, optionsRecord.fK), options), model));
                        case 3:
                            var mapper = input_.a;
                            var options = input_.b;
                            var model = input_.c;
                            return A2($elm$html$Html$map, mapper, A2($author$project$Components$DateInput$view, A2($elm$core$List$cons, $author$project$Components$DateInput$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Components$DateInput$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)), A2($elm$core$List$cons, $author$project$Components$DateInput$hideErrors(true), options))), model));
                        default:
                            var content = input_.a;
                            return A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('new-form-group__static')
                            ]), content);
                    }
                }(),
                function() {
                    var _v2 = optionsRecord.fK;
                    if (!_v2.b) return $elm$html$Html$text('');
                    else {
                        var errors_ = _v2;
                        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, function(err) {
                            return A2($elm$html$Html$span, _List_fromArray([
                                A2($elm$html$Html$Attributes$attribute, 'role', 'alert'),
                                $elm$html$Html$Attributes$class('text-danger')
                            ]), _List_fromArray([
                                $elm$html$Html$text(err)
                            ]));
                        }, errors_));
                    }
                }()
            ]));
        }
    };
    var $author$project$Ui$Form$Accessible$viewGroupInput = function(accessibleInput) {
        if (accessibleInput.$ === 1) return $author$project$Ui$Grid$none;
        else {
            var inputOptions = accessibleInput.b;
            var record = $author$project$Ui$Form$Accessible$inputOptionsToRecord(inputOptions);
            return A2($author$project$Ui$Grid$column, record.a9, _List_fromArray([
                $author$project$Ui$Form$Accessible$viewInput(accessibleInput)
            ]));
        }
    };
    var $author$project$Ui$Form$Accessible$single = F4(function(legend, options, inputOptions, input_) {
        var optionsRecord = $author$project$Ui$Form$Accessible$labelOptionsToRecord(options);
        var complementarySpans = $author$project$Ui$Grid$complementSpan(optionsRecord.a9);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('new-form-group')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, optionsRecord.a9, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('new-form-group__label'),
                        $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('new-form-group__label--required', optionsRecord.agM)
                        ]))
                    ]), _List_fromArray([
                        $elm$html$Html$text(legend)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, complementarySpans, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('new-form-group__content')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            $author$project$Ui$Form$Accessible$viewGroupInput(A3($author$project$Ui$Form$Accessible$AccessibleInput, legend, inputOptions, input_))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Api$Provider$Invoice$All$humanStatus = function(_v0) {
        var record = _v0.b;
        return record.QX;
    };
    var $author$project$Api$Provider$Invoice$All$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Invoice$Min$id(min);
    };
    var $author$project$Api$Provider$Invoice$All$invoiceDate = function(_v0) {
        var record = _v0.b;
        return record.RG;
    };
    var $author$project$Api$Provider$Invoice$All$invoiceNumber = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
    };
    var $author$project$Components$Charge$Form$RoutingFields$sponsorInvoiceSelectItems = function(dataInvoices) {
        if (dataInvoices.$ === 3) {
            var invoices = dataInvoices.a;
            var newInvoice = A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('new'), 'Create a new draft invoice');
            var label = function(invoice) {
                return A3($author$project$Components$Charge$Form$RoutingFields$invoiceLabel, $author$project$Api$Invoice$Status$toString($author$project$Api$Provider$Invoice$All$humanStatus(invoice)), $author$project$Api$Provider$Invoice$All$invoiceNumber(invoice), $author$project$Api$Provider$Invoice$All$invoiceDate(invoice));
            };
            var baseItems = A2($elm$core$List$map, function(invoice) {
                return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Invoice$All$id(invoice)), label(invoice));
            }, invoices);
            return _Utils_ap(baseItems, _List_fromArray([
                newInvoice
            ]));
        } else return _List_Nil;
    };
    var $author$project$Components$Charge$Form$RoutingFields$viewInvoice = F2(function(model, readOnly) {
        var _v0 = _Utils_Tuple2(model.adM.Wh, model.cP);
        _v0$2: while(true)if (!_v0.a) {
            if (!_v0.b.$) {
                var _v1 = _v0.a;
                var currentDate = _v0.b.a;
                return A4($author$project$Ui$Form$Accessible$single, 'Invoice', _List_fromArray([
                    $author$project$Ui$Form$Accessible$labelSpanSm(4),
                    $author$project$Ui$Form$Accessible$required(true)
                ]), _List_Nil, A2($author$project$Ui$Form$Accessible$select, _List_fromArray([
                    $author$project$Ui$Form$Select$value(model.adM.RI),
                    $author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$PatientInvoiceSelected),
                    $author$project$Ui$Form$Select$disabled(readOnly || _Utils_eq(model.cR, $author$project$Api$Data$Loading))
                ]), A2($author$project$Components$Charge$Form$RoutingFields$patientInvoiceSelectItems, currentDate, model.cR)));
            } else break _v0$2;
        } else {
            if (!_v0.b.$) {
                var _v2 = _v0.a;
                return A4($author$project$Ui$Form$Accessible$single, 'Invoice', _List_fromArray([
                    $author$project$Ui$Form$Accessible$labelSpanSm(4),
                    $author$project$Ui$Form$Accessible$required(true)
                ]), _List_Nil, A2($author$project$Ui$Form$Accessible$select, _List_fromArray([
                    $author$project$Ui$Form$Select$value(model.adM.RI),
                    $author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$SponsorInvoiceSelected),
                    $author$project$Ui$Form$Select$disabled(readOnly || _Utils_eq(model.gW, $author$project$Api$Data$Loading) || _Utils_eq(model.jF, $author$project$Api$Data$Loading))
                ]), $author$project$Components$Charge$Form$RoutingFields$sponsorInvoiceSelectItems(model.gW)));
            } else break _v0$2;
        }
        return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Charge$Form$RoutingFields$SponsorPayerSelected = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$group = F3(function(legend, options, inputs) {
        var optionsRecord = $author$project$Ui$Form$Accessible$labelOptionsToRecord(options);
        var complementarySpans = $author$project$Ui$Grid$complementSpan(optionsRecord.a9);
        return A2($elm$html$Html$fieldset, _List_fromArray([
            $elm$html$Html$Attributes$class('new-form-group')
        ]), _List_fromArray([
            A2($elm$html$Html$legend, _List_fromArray([
                $elm$html$Html$Attributes$class('new-form-group__legend')
            ]), _List_fromArray([
                $elm$html$Html$text(legend)
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, optionsRecord.a9, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('new-form-group__label'),
                        $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('new-form-group__label--required', optionsRecord.agM)
                        ]))
                    ]), _List_fromArray([
                        $elm$html$Html$text(legend)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, complementarySpans, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('new-form-group__content')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, A2($elm$core$List$map, $author$project$Ui$Form$Accessible$viewGroupInput, inputs))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Ui$Form$Accessible$input = F3(function(labelText, options, input_) {
        return A3($author$project$Ui$Form$Accessible$AccessibleInput, labelText, options, input_);
    });
    var $author$project$Ui$Form$Accessible$InputGrid = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$inputSpanLg = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$spanLg, $author$project$Ui$Form$Accessible$InputGrid);
    var $author$project$Ui$Form$Accessible$inputSpanMd = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$spanMd, $author$project$Ui$Form$Accessible$InputGrid);
    var $author$project$Ui$Form$Accessible$inputSpanSm = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$spanSm, $author$project$Ui$Form$Accessible$InputGrid);
    var $author$project$Ui$Form$Accessible$None = {
        $: 1
    };
    var $author$project$Ui$Form$Accessible$none = $author$project$Ui$Form$Accessible$None;
    var $author$project$Ui$Form$Accessible$PatientFilter = F3(function(a, b, c) {
        return {
            $: 7,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Accessible$patientFilter = $author$project$Ui$Form$Accessible$PatientFilter;
    var $author$project$Api$Provider$CompanyAccount$ForPatient$company = function(_v0) {
        var record = _v0.b;
        return record.acy;
    };
    var $author$project$Api$Provider$Patient$One$companyAccounts = function(_v0) {
        var record = _v0.b;
        return record.LK;
    };
    var $author$project$Components$Charge$Form$RoutingFields$sponsorPayerSelectItems = function(patientData) {
        if (patientData.$ === 3) {
            var patient = patientData.a;
            var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(patient);
            var companies = A2($elm$core$List$map, $author$project$Api$Provider$CompanyAccount$ForPatient$company, accounts);
            return A2($elm$core$List$map, function(company) {
                return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Company$Min$id(company)), $author$project$Api$Provider$Company$Min$name(company));
            }, companies);
        } else return _List_Nil;
    };
    var $author$project$Ui$Form$Accessible$Static = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$static = function(content) {
        return $author$project$Ui$Form$Accessible$Static(content);
    };
    var $author$project$Components$Charge$Form$RoutingFields$PayerSelected = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$RoutingFields$buttonStyle = F2(function(payer, selectedPayerType) {
        return _Utils_eq(payer, selectedPayerType) ? 1 : 0;
    });
    var $author$project$Components$Charge$Form$RoutingFields$viewPayerButton = F3(function(payerType, selectedPayerType, disabled) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + $author$project$Api$Charge$PayerType$toString(payerType)
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(selectedPayerType, payerType)),
            $author$project$Ui$Button$styled(A2($author$project$Components$Charge$Form$RoutingFields$buttonStyle, payerType, selectedPayerType)),
            $author$project$Ui$Button$onClick($author$project$Components$Charge$Form$RoutingFields$PayerSelected(payerType)),
            $author$project$Ui$Button$disabled(disabled)
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Charge$PayerType$toString(payerType))
        ]));
    });
    var $author$project$Components$Charge$Form$RoutingFields$viewPayer = F4(function(model, readOnly, preview, patient) {
        var warningContent = model.A_ ? A2($elm$core$Maybe$withDefault, $author$project$Ui$Form$Accessible$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, A2($elm$core$Basics$composeR, $author$project$Ui$Form$Accessible$static, A2($author$project$Ui$Form$Accessible$input, '', _List_fromArray([
            $author$project$Ui$Form$Accessible$inputSpanSm(12)
        ])))), A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, model.adM.Wh, preview))) : $author$project$Ui$Form$Accessible$none;
        var sponsorDisabled = _Utils_eq($author$project$Components$Charge$Form$RoutingFields$patientCurrentCompany(patient), $elm$core$Maybe$Nothing);
        var payerFilterInput = function() {
            var _v0 = model.adM.Wh;
            if (!_v0) return A3($author$project$Ui$Form$Accessible$patientFilter, $author$project$Components$Charge$Form$RoutingFields$PatientPayerFilterMsg, _List_fromArray([
                $author$project$Components$ResourceFilter$disabled(readOnly)
            ]), model.el);
            else return A2($author$project$Ui$Form$Accessible$select, _List_fromArray([
                $author$project$Ui$Form$Select$value(model.adM.af6),
                $author$project$Ui$Form$Select$onChange($author$project$Components$Charge$Form$RoutingFields$SponsorPayerSelected),
                $author$project$Ui$Form$Select$disabled($author$project$Api$Charge$PayerType$adjudicatedToSponsor(preview) || _Utils_eq(model.V7, $author$project$Api$Data$Loading))
            ]), $author$project$Components$Charge$Form$RoutingFields$sponsorPayerSelectItems(model.V7));
        }();
        var buttonsDisabled = _Utils_eq(model.jF, $author$project$Api$Data$Loading) || readOnly;
        var payerButtonsContent = _List_fromArray([
            $author$project$Ui$Button$group(_List_fromArray([
                A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 0, model.adM.Wh, buttonsDisabled),
                sponsorDisabled ? A3($author$project$Ui$Tooltip$view, _List_Nil, 'The selected patient does not have any sponsors available.', _List_fromArray([
                    A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 1, model.adM.Wh, true)
                ])) : A3($author$project$Components$Charge$Form$RoutingFields$viewPayerButton, 1, model.adM.Wh, buttonsDisabled)
            ]))
        ]);
        return A3($author$project$Ui$Form$Accessible$group, 'Payer', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4),
            $author$project$Ui$Form$Accessible$required(true)
        ]), _List_fromArray([
            warningContent,
            A3($author$project$Ui$Form$Accessible$input, 'Type', _List_fromArray([
                $author$project$Ui$Form$Accessible$inputSpanMd(4),
                $author$project$Ui$Form$Accessible$inputSpanLg(3)
            ]), $author$project$Ui$Form$Accessible$static(payerButtonsContent)),
            A3($author$project$Ui$Form$Accessible$input, 'Selection', _List_fromArray([
                $author$project$Ui$Form$Accessible$inputSpanMd(8),
                $author$project$Ui$Form$Accessible$inputSpanLg(9)
            ]), payerFilterInput)
        ]));
    });
    var $author$project$Components$Charge$Form$RoutingFields$view = F2(function(model, readOnly) {
        var _v0 = _Utils_Tuple2(model.agk, model.V7);
        if (_v0.a.$ === 3 && _v0.b.$ === 3) {
            var _v1 = _v0.a;
            var preview = _v1.a;
            var _v2 = _v0.b;
            var patient = _v2.a;
            return _List_fromArray([
                A4($author$project$Components$Charge$Form$RoutingFields$viewPayer, model, readOnly, preview, patient),
                A2($author$project$Components$Charge$Form$RoutingFields$viewInvoice, model, readOnly)
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Charge$Form$ToggleAdditionalDetails = {
        $: 16
    };
    var $author$project$Components$Charge$Form$viewAdditionalDetails = function(showAdditionalDetails) {
        return A4($author$project$Ui$Form$Accessible$single, '', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4)
        ]), _List_fromArray([
            $author$project$Ui$Form$Accessible$inputSpanSm(6)
        ]), $author$project$Ui$Form$Accessible$static(_List_fromArray([
            function() {
                var label = showAdditionalDetails ? 'Hide additional charge details ' : 'See additional charge details ';
                return A3($author$project$Ui$Button$view, {
                    abP: label
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Components$Charge$Form$ToggleAdditionalDetails)
                ]), _List_fromArray([
                    $elm$html$Html$text(label),
                    $author$project$Ui$Icon$chevronDown(_List_Nil)
                ]));
            }()
        ])));
    };
    var $author$project$Ui$Form$Accessible$CategoryFilter = F3(function(a, b, c) {
        return {
            $: 9,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Accessible$categoryFilter = $author$project$Ui$Form$Accessible$CategoryFilter;
    var $author$project$Components$Charge$Form$viewCategory = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var categoryResourceFilter = _v0.cK;
        return A4($author$project$Ui$Form$Accessible$single, 'Category', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4)
        ]), _List_Nil, A3($author$project$Ui$Form$Accessible$categoryFilter, $author$project$Components$Charge$Form$CategoryResourceFilterMsg, _List_fromArray([
            $author$project$Components$ResourceFilter$style(0)
        ]), categoryResourceFilter));
    };
    var $author$project$Ui$Form$Accessible$ChargeItemFilter = F3(function(a, b, c) {
        return {
            $: 8,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Accessible$chargeItemFilter = $author$project$Ui$Form$Accessible$ChargeItemFilter;
    var $author$project$Ui$Form$Accessible$Errors = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$errors = $author$project$Ui$Form$Accessible$Errors;
    var $author$project$Components$Charge$Form$viewChargeItemInput = F3(function(chargeItemResourceFilter, readOnly_, form) {
        return A4($author$project$Ui$Form$Accessible$single, 'Charge Item', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4),
            $author$project$Ui$Form$Accessible$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Accessible$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
        ]), A3($author$project$Ui$Form$Accessible$chargeItemFilter, $author$project$Components$Charge$Form$ChargeItemResourceFilterMsg, _List_fromArray([
            $author$project$Components$ResourceFilter$disabled(readOnly_)
        ]), chargeItemResourceFilter));
    });
    var $author$project$Components$Charge$Form$Description = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$Test = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$test = function(dataTest) {
        return $author$project$Ui$Form$Textarea$Test(dataTest);
    };
    var $author$project$Ui$Form$Accessible$Textarea = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$textarea = $author$project$Ui$Form$Accessible$Textarea;
    var $author$project$Components$Charge$Form$viewDescription = function(fields) {
        return A4($author$project$Ui$Form$Accessible$single, 'Description', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4)
        ]), _List_Nil, $author$project$Ui$Form$Accessible$textarea(_List_fromArray([
            $author$project$Ui$Form$Textarea$value(fields.NQ),
            $author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
            $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$Description)),
            $author$project$Ui$Form$Textarea$test('charge-description')
        ])));
    };
    var $author$project$Ui$Form$Accessible$LocationFilter = F3(function(a, b, c) {
        return {
            $: 11,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Accessible$locationFilter = $author$project$Ui$Form$Accessible$LocationFilter;
    var $author$project$Components$Charge$Form$viewLocation = function(locationResourceFilter) {
        return A4($author$project$Ui$Form$Accessible$single, 'Location', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4)
        ]), _List_Nil, A3($author$project$Ui$Form$Accessible$locationFilter, $author$project$Components$Charge$Form$LocationResourceFilterMsg, _List_fromArray([
            $author$project$Components$ResourceFilter$style(0)
        ]), locationResourceFilter));
    };
    var $author$project$Components$Charge$Form$viewPatientInput = F3(function(patientResourceFilter, readOnly_, form) {
        return A4($author$project$Ui$Form$Accessible$single, 'Patient', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4),
            $author$project$Ui$Form$Accessible$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Accessible$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
        ]), A3($author$project$Ui$Form$Accessible$patientFilter, $author$project$Components$Charge$Form$PatientResourceFilterMsg, _List_fromArray([
            $author$project$Components$ResourceFilter$disabled(readOnly_)
        ]), patientResourceFilter));
    });
    var $author$project$Components$Charge$Form$DiscountOverridden = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$CurrencyInput = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$currencyInput = $author$project$Ui$Form$Accessible$CurrencyInput;
    var $author$project$Api$Provider$Charge$Meta$priceInCentsEditable = function(_v0) {
        var meta = _v0;
        return meta.Br.Ot;
    };
    var $author$project$Ui$Form$CurrencyInput$Test = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Form$CurrencyInput$test = function(dataTest) {
        return $author$project$Ui$Form$CurrencyInput$Test(dataTest);
    };
    var $author$project$Components$Charge$Form$viewPriceInput = F6(function(fields, readyOnly, form, meta, preview, isTimeBased) {
        var hasDiscount = function() {
            var _v1 = $author$project$Api$Data$toMaybe(preview);
            if (!_v1.$) {
                var preview_ = _v1.a;
                return !!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview_);
            } else return false;
        }();
        var discountNotRemoved = !fields.N0 && hasDiscount;
        var staticContent = discountNotRemoved && !readyOnly ? A3($author$project$Ui$Form$Accessible$input, '', _List_Nil, $author$project$Ui$Form$Accessible$static(_List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Remove membership rule'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$Charge$Form$FormUpdated($author$project$Components$Charge$Form$DiscountOverridden(true)))
            ]), _List_fromArray([
                $elm$html$Html$text('Remove membership rule')
            ]))
        ]))) : $author$project$Ui$Form$Accessible$none;
        var canEdit = A2($elm$core$Maybe$withDefault, A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Basics$not, function($) {
            return $.aeE;
        }), fields.lv)), A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
        var currencyOptions = A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$value(fields.Br), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$disabled(hasDiscount || readyOnly || !canEdit), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$PriceInCents)), A2($elm$core$List$cons, $author$project$Ui$Form$CurrencyInput$test('charge-price'), function() {
            var _v0 = _Utils_Tuple2(isTimeBased, A2($elm$core$Maybe$map, $elm$core$String$toLower, A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, fields.Xn)));
            if (_v0.a && !_v0.b.$) {
                var name = _v0.b.a;
                return _List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
                ]);
            } else return _List_Nil;
        }())))));
        var priceInput = A3($author$project$Ui$Form$Accessible$input, 'Price', _List_fromArray([
            $author$project$Ui$Form$Accessible$inputSpanSm(4),
            $author$project$Ui$Form$Accessible$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
        ]), $author$project$Ui$Form$Accessible$currencyInput(currencyOptions));
        return A3($author$project$Ui$Form$Accessible$group, 'Price', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4),
            $author$project$Ui$Form$Accessible$required(true)
        ]), _List_fromArray([
            priceInput,
            staticContent
        ]));
    });
    var $author$project$Ui$Form$Accessible$PractitionerFilter = F3(function(a, b, c) {
        return {
            $: 10,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Accessible$practitionerFilter = $author$project$Ui$Form$Accessible$PractitionerFilter;
    var $author$project$Components$Charge$Form$viewProvider = function(practitionerResourceFilter) {
        return A4($author$project$Ui$Form$Accessible$single, 'Provider', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4)
        ]), _List_Nil, A3($author$project$Ui$Form$Accessible$practitionerFilter, $author$project$Components$Charge$Form$PractitionerResourceFilterMsg, _List_fromArray([
            $author$project$Components$ResourceFilter$style(0)
        ]), practitionerResourceFilter));
    };
    var $author$project$Components$Charge$Form$Quantity = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Charge$Form$QuantityUom = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$inputSpan = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$span, $author$project$Ui$Form$Accessible$InputGrid);
    var $author$project$Ui$Form$Accessible$labelSpan = A2($elm$core$Basics$composeR, $author$project$Ui$Grid$span, $author$project$Ui$Form$Accessible$Grid);
    var $author$project$Ui$Form$Accessible$TextInput = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Accessible$textInput = $author$project$Ui$Form$Accessible$TextInput;
    var $author$project$Components$Charge$Form$viewQuantityInput = F4(function(fields, readOnly_, form, isTimeBased) {
        return A3($author$project$Ui$Form$Accessible$group, 'Quantity', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpan(4),
            $author$project$Ui$Form$Accessible$required(true)
        ]), _List_fromArray([
            A3($author$project$Ui$Form$Accessible$input, 'Quantity', _List_fromArray([
                $author$project$Ui$Form$Accessible$inputSpan(4),
                $author$project$Ui$Form$Accessible$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
            ]), $author$project$Ui$Form$Accessible$textInput(_List_fromArray([
                $author$project$Ui$Form$Input$number,
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Bu))),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$Quantity)),
                $author$project$Ui$Form$Input$disabled(readOnly_),
                $author$project$Ui$Form$Input$test('charge-quantity')
            ]))),
            function() {
                if (isTimeBased) {
                    var uomOptions = A2($elm$core$List$map, function(uom_) {
                        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Uom$Shared$code(uom_)), $author$project$Api$Provider$Uom$Shared$name(uom_));
                    }, $author$project$Api$Provider$Uom$list(function(d) {
                        return _Utils_update(d, {
                            HX: $elm$core$Maybe$Just('time')
                        });
                    }));
                    return A3($author$project$Ui$Form$Accessible$input, 'Time unit of measure', _List_fromArray([
                        $author$project$Ui$Form$Accessible$inputSpan(4)
                    ]), A2($author$project$Ui$Form$Accessible$select, _List_fromArray([
                        $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Bv)),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Charge$Form$FormUpdated, $author$project$Components$Charge$Form$QuantityUom)),
                        $author$project$Ui$Form$Select$disabled(readOnly_)
                    ]), uomOptions));
                } else return $author$project$Ui$Form$Accessible$none;
            }()
        ]));
    });
    var $author$project$Ui$Form$Accessible$DateInput = F3(function(a, b, c) {
        return {
            $: 3,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Accessible$dateInput = $author$project$Ui$Form$Accessible$DateInput;
    var $author$project$Components$DateInput$Test = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$DateInput$test = function(dataTest) {
        return $author$project$Components$DateInput$Test(dataTest);
    };
    var $author$project$Components$Charge$Form$viewServiceDate = F4(function(fields, readOnly_, form, isTimeBased) {
        return A3($author$project$Ui$Form$Accessible$group, isTimeBased ? 'Dates' : 'Date', _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4),
            $author$project$Ui$Form$Accessible$required(true)
        ]), _List_fromArray([
            A3($author$project$Ui$Form$Accessible$input, 'Start Date', _List_fromArray([
                $author$project$Ui$Form$Accessible$inputSpan(6),
                $author$project$Ui$Form$Accessible$errors(A2($author$project$Utils$Form$validationErrors, 4, form))
            ]), A3($author$project$Ui$Form$Accessible$dateInput, $author$project$Components$Charge$Form$StartDateInputMsg(fields.kj), _List_fromArray([
                $author$project$Components$DateInput$value(fields._0),
                $author$project$Components$DateInput$disabled(readOnly_),
                $author$project$Components$DateInput$test('charge-date')
            ]), fields.kj)),
            isTimeBased ? A3($author$project$Ui$Form$Accessible$input, 'End Date', _List_fromArray([
                $author$project$Ui$Form$Accessible$inputSpan(6)
            ]), A3($author$project$Ui$Form$Accessible$dateInput, $author$project$Components$Charge$Form$EndDateInputMsg(fields.qx), _List_fromArray([
                $author$project$Components$DateInput$value(fields.qv),
                $author$project$Components$DateInput$disabled(readOnly_)
            ]), fields.qx)) : $author$project$Ui$Form$Accessible$none
        ]));
    });
    var $author$project$Components$ChargeItemTaxableWarning$view = F2(function(selectedPayer, taxable) {
        var sponsorPayer = selectedPayer === 1;
        var showWarning = sponsorPayer && taxable;
        return showWarning ? A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Taxed charge items cannot be billed on a sponsor\'s invoice. Please contact support at support@hint.com to learn more.')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Charge$Form$viewTaxableWarning = function(fields) {
        var _v0 = fields.lv;
        if (!_v0.$) {
            var chargeItem = _v0.a;
            return _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8),
                        $author$project$Ui$Grid$offsetSm(4)
                    ]), _List_fromArray([
                        A2($author$project$Components$ChargeItemTaxableWarning$view, fields.Wh, chargeItem.$S)
                    ]))
                ]))
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Charge$Form$discountDetails = F3(function(fields, readyOnly, preview) {
        var discountRemoved = fields.N0 && !$author$project$Api$Provider$Charge$Calculate$discountInCents(preview);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            !!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview) ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Total without membership: '),
                $author$project$Components$Invoice$ChargeDiscount$view(preview)
            ])) : $author$project$Utils$Html$empty,
            discountRemoved ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Membership rule was removed')
            ])) : $author$project$Utils$Html$empty,
            discountRemoved && $author$project$Utils$Maybe$toBool(fields.lv) && !readyOnly ? A3($author$project$Ui$Button$view, {
                abP: 'Revert to original discount'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Components$Charge$Form$FormUpdated($author$project$Components$Charge$Form$DiscountOverridden(false)))
            ]), _List_fromArray([
                $elm$html$Html$text('Revert to original')
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Charge$Form$viewTotal = F3(function(fields, readyOnly, model) {
        var labelOptions = _List_fromArray([
            $author$project$Ui$Form$Accessible$labelSpanSm(4)
        ]);
        var inputOptions = _List_fromArray([
            $author$project$Ui$Form$Accessible$inputSpanSm(8)
        ]);
        return A4($author$project$Ui$Form$Accessible$single, 'Total', labelOptions, inputOptions, $author$project$Ui$Form$Accessible$static(function() {
            var _v0 = model.agk;
            switch(_v0.$){
                case 3:
                    var preview = _v0.a;
                    var total = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview));
                    return !$author$project$Api$Provider$Charge$Calculate$discountInCents(preview) && !fields.N0 ? _List_fromArray([
                        $elm$html$Html$text(total)
                    ]) : _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(total)
                            ])),
                            A3($author$project$Components$Charge$Form$discountDetails, fields, readyOnly, preview)
                        ]))
                    ]);
                case 1:
                    return _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanFromText('$100.00')
                        ]))
                    ]);
                default:
                    return _List_fromArray([
                        $elm$html$Html$text('N/A')
                    ]);
            }
        }()));
    });
    var $author$project$Components$Charge$Form$view = function(_v0) {
        var model = _v0;
        if (model.hh) {
            var routingFields = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Charge$Form$RoutingFieldsMsg), A2($author$project$Components$Charge$Form$RoutingFields$view, model.n3, model.Ya));
            var meta = A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$meta, $author$project$Api$Data$toMaybe(model.ach));
            var fields = $author$project$Utils$Form$fields(model.e);
            var isTimeBased = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$isTimeBased, fields.Bv));
            var taxWarning = $author$project$Components$Charge$Form$viewTaxableWarning(fields);
            var baseFields = _List_fromArray([
                A3($author$project$Components$Charge$Form$viewPatientInput, model.rX, model.Ya || model.rV, model.e),
                A3($author$project$Components$Charge$Form$viewChargeItemInput, model.cL, model.Ya, model.e),
                A4($author$project$Components$Charge$Form$viewQuantityInput, fields, model.Ya, model.e, isTimeBased),
                A6($author$project$Components$Charge$Form$viewPriceInput, fields, model.Ya, model.e, meta, model.agk, isTimeBased),
                A3($author$project$Components$Charge$Form$viewTotal, fields, model.Ya, model),
                !model.Ya ? $author$project$Components$Charge$Form$viewAdditionalDetails(model.gP) : $author$project$Utils$Html$empty
            ]);
            var additionalFields = model.gP ? _List_fromArray([
                $author$project$Components$Charge$Form$viewCategory(model.e),
                $author$project$Components$Charge$Form$viewDescription(fields),
                A4($author$project$Components$Charge$Form$viewServiceDate, fields, model.Ya, model.e, isTimeBased),
                $author$project$Components$Charge$Form$viewProvider(model.jE),
                $author$project$Components$Charge$Form$viewLocation(model.ro)
            ]) : model.Ya ? _List_fromArray([
                A4($author$project$Components$Charge$Form$viewServiceDate, fields, model.Ya, model.e, isTimeBased)
            ]) : _List_Nil;
            return A2($elm$html$Html$div, _List_Nil, _Utils_ap(baseFields, _Utils_ap(additionalFields, _Utils_ap(routingFields, taxWarning))));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Charges$New$isPaid = function(invoice) {
        return invoice.ahy === 'paid';
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$hasGoodPaymentSource = function(_v0) {
        var record = _v0;
        return record.Qq;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$hasGoodPaymentSource(shared);
    };
    var $author$project$Pages$Charges$New$issueLabel = F2(function(invoice, actionText) {
        return $author$project$Pages$Charges$New$isDraft(invoice) ? ' Issue & ' + actionText : ' ' + actionText;
    });
    var $author$project$Pages$Charges$New$viewPayAction = function(invoice) {
        var canCreatePayment = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource, $author$project$Api$Data$toMaybe(invoice.j_)));
        return canCreatePayment ? _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect(A2($author$project$Pages$Charges$New$Pay, invoice, false))
            ]), A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Icon$bolt(_List_Nil),
                $elm$html$Html$text(A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Pay'))
            ])))
        ]) : _List_Nil;
    };
    var $author$project$Pages$Charges$New$viewRecordPaymentAction = function(invoice) {
        return _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect(A2($author$project$Pages$Charges$New$Pay, invoice, true))
            ]), A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Icon$check(_List_Nil),
                $elm$html$Html$text(A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Record Payment'))
            ])))
        ]);
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$isPaymentScheduled = function(_v0) {
        var record = _v0;
        return record.Si;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$isPaymentScheduled(shared);
    };
    var $author$project$Pages$Charges$New$viewSchedulePaymentAction = function(invoice) {
        var hasScheduledPayment = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled, $author$project$Api$Data$toMaybe(invoice.j_)));
        return !hasScheduledPayment ? _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Charges$New$SchedulePayment(invoice))
            ]), A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Icon$calendar(_List_Nil),
                $elm$html$Html$text(A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Schedule Payment'))
            ])))
        ]) : _List_Nil;
    };
    var $author$project$Pages$Charges$New$viewSendEmailAction = function(invoice) {
        var _v0 = invoice.VM;
        if (!_v0.$) {
            var owner = _v0.a;
            return _List_fromArray([
                A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect(A2($author$project$Pages$Charges$New$Email, $author$project$Api$Common$Payable$Owner$Min$id(owner), invoice))
                ]), A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Icon$send(_List_Nil),
                    $elm$html$Html$text(A2($author$project$Pages$Charges$New$issueLabel, invoice, 'Send email'))
                ])))
            ]);
        } else return _List_Nil;
    };
    var $author$project$Pages$Charges$New$viewInvoiceActions = function(invoice) {
        var _v0 = invoice.ah5;
        switch(_v0){
            case 0:
                return $author$project$Utils$Html$empty;
            case 1:
                var actions = _Utils_ap($author$project$Pages$Charges$New$viewPayAction(invoice), _Utils_ap($author$project$Pages$Charges$New$viewRecordPaymentAction(invoice), _Utils_ap($author$project$Pages$Charges$New$viewSchedulePaymentAction(invoice), $author$project$Pages$Charges$New$viewSendEmailAction(invoice))));
                return $author$project$Pages$Charges$New$isPaid(invoice) || _Utils_eq(actions, _List_Nil) ? $author$project$Utils$Html$empty : A4($author$project$Ui$Dropdown$view, _List_fromArray([
                    $author$project$Ui$Dropdown$disabled(_Utils_eq(invoice.j_, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Invoice Actions')
                ]), actions, invoice.l_);
            default:
                return $author$project$Utils$Html$empty;
        }
    };
    var $author$project$Pages$Charges$New$ToggleChargeDetails = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $elm_community$maybe_extra$Maybe$Extra$join = function(mx) {
        if (!mx.$) {
            var x = mx.a;
            return x;
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Charge$Shared$totalInCents = function(_v0) {
        var record = _v0;
        return record.aam;
    };
    var $author$project$Api$Provider$Charge$One$totalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
    };
    var $author$project$Components$Charge$Form$visible = function(_v0) {
        var model = _v0;
        return model.hh;
    };
    var $author$project$Pages$Charges$New$viewCharge = F2(function(index, createdCharge) {
        var charge = $author$project$Api$Data$toMaybe($author$project$Components$Charge$Form$charge(createdCharge));
        var chargeName = A2($elm$core$Maybe$withDefault, '', $elm_community$maybe_extra$Maybe$Extra$join(A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$name, charge)));
        var patientName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name, A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$patient, charge))));
        var totalInCents = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$Currency$fromInt, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$totalInCents, charge)));
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$primary
                ]), _List_fromArray([
                    $elm$html$Html$text(totalInCents + (" \u2014 " + (chargeName + (' for ' + patientName))))
                ])),
                function() {
                    var _v0 = $author$project$Components$Charge$Form$visible(createdCharge) ? _Utils_Tuple2('Hide charge details ', $author$project$Ui$Icon$chevron(_List_fromArray([
                        $author$project$Ui$Icon$rotate180
                    ]))) : _Utils_Tuple2('See charge details ', $author$project$Ui$Icon$chevronDown(_List_Nil));
                    var buttonLabel = _v0.a;
                    var icon = _v0.b;
                    return A3($author$project$Ui$Button$view, {
                        abP: buttonLabel
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$onClick($author$project$Pages$Charges$New$ToggleChargeDetails(index))
                    ]), _List_fromArray([
                        $elm$html$Html$text(buttonLabel),
                        icon
                    ]));
                }()
            ])),
            A2($elm$html$Html$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$view(createdCharge))
        ]));
    });
    var $author$project$Pages$Charges$New$viewInvoiceCharges = F2(function(invoice, createdChargesWithIndex) {
        var createdChargesForInvoiceWithIndex = A2($elm$core$List$filter, function(_v1) {
            var createdCharge = _v1.b;
            return _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$MinWithOwner$id, A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$invoice, $author$project$Api$Data$toMaybe($author$project$Components$Charge$Form$charge(createdCharge))))), $elm$core$Maybe$Just(invoice.aef));
        }, createdChargesWithIndex);
        return A2($elm$core$List$map, function(_v0) {
            var index = _v0.a;
            var createdCharge = _v0.b;
            return A2($author$project$Pages$Charges$New$viewCharge, index, createdCharge);
        }, createdChargesForInvoiceWithIndex);
    });
    var $author$project$Pages$Charges$New$viewInvoiceLink = F4(function(invoiceId, invoiceType, invoiceNumber, ownerId) {
        var invoiceRoute = function() {
            switch(invoiceType){
                case 0:
                    return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                        fl: ownerId,
                        aef: invoiceId
                    }));
                case 1:
                    return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                        RI: invoiceId,
                        V8: ownerId
                    }));
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }();
        return A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(partialLink) {
            return A2(partialLink, _List_Nil, _List_fromArray([
                $elm$html$Html$text(invoiceNumber)
            ]));
        }, A2($elm$core$Maybe$map, $author$project$Ui$Link$route, invoiceRoute)));
    });
    var $author$project$Pages$Charges$New$viewOwnerLink = F3(function(invoiceType, ownerId, ownerName) {
        var ownerRoute = function() {
            switch(invoiceType){
                case 0:
                    return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                        fl: ownerId
                    }));
                case 1:
                    return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                        V8: ownerId
                    }));
                default:
                    return $elm$core$Maybe$Nothing;
            }
        }();
        return A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(partialLink) {
            return A2(partialLink, _List_Nil, _List_fromArray([
                $elm$html$Html$text(ownerName)
            ]));
        }, A2($elm$core$Maybe$map, $author$project$Ui$Link$route, ownerRoute)));
    });
    var $author$project$Pages$Charges$New$viewInvoiceDetails = function(invoice) {
        var ownerName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, invoice.VM));
        var ownerId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$id, invoice.VM));
        var invoiceType = invoice.ah5;
        var invoiceNumber = A2($elm$core$String$append, '#', $elm$core$String$fromInt(invoice.RK));
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Invoice '),
            A4($author$project$Pages$Charges$New$viewInvoiceLink, invoice.aef, invoiceType, invoiceNumber, ownerId),
            $elm$html$Html$text(' paid for by'),
            A3($author$project$Pages$Charges$New$viewOwnerLink, invoiceType, ownerId, ownerName),
            A2($author$project$Ui$Badge$fromString, _List_Nil, invoice.ahy)
        ]));
    };
    var $author$project$Pages$Charges$New$viewInvoice = F2(function(createdCharges, invoice) {
        var createdChargesWithIndex = A2($elm$core$List$indexedMap, F2(function(index, createdCharge) {
            return _Utils_Tuple2(index, createdCharge);
        }), createdCharges);
        return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Pages$Charges$New$viewInvoiceDetails(invoice),
                $author$project$Pages$Charges$New$viewInvoiceActions(invoice)
            ]))
        ])), A2($author$project$Pages$Charges$New$viewInvoiceCharges, invoice, createdChargesWithIndex)));
    });
    var $author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice = function(model) {
        return $elm$core$List$isEmpty(model.q5) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
            $author$project$Ui$Typography$margin(7)
        ]), A2($elm$core$List$map, $author$project$Pages$Charges$New$viewInvoice(model.dF), model.q5));
    };
    var $author$project$Pages$Charges$New$viewPanelBody = function(model) {
        return A2($elm$core$List$append, _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Charges$New$ChargeFormMsg, $author$project$Components$Charge$Form$view(model.e))
            ]))
        ]), model.Cu.adU.adj && !$elm$core$List$isEmpty(model.q5) ? _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_fromArray([
                $author$project$Ui$Element$bgPrimary50
            ]), _List_fromArray([
                $author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice(model)
            ]))
        ]) : _List_Nil);
    };
    var $author$project$Pages$Charges$New$SaveAndAddAnother = {
        $: 1
    };
    var $author$project$Components$Charge$Form$loading = function(_v0) {
        var model = _v0;
        return _Utils_eq(model.agk, $author$project$Api$Data$Loading);
    };
    var $author$project$Components$Charge$Form$saving = function(_v0) {
        var model = _v0;
        return _Utils_eq(model.ach, $author$project$Api$Data$Loading);
    };
    var $author$project$Pages$Charges$New$viewPanelFooter = function(model) {
        var formSaving = $author$project$Components$Charge$Form$saving(model.e);
        var formLoading = $author$project$Components$Charge$Form$loading(model.e);
        var _v0 = model.Cu.adU.adj ? _Utils_Tuple2('Add Another', 'Create') : _Utils_Tuple2('Save & Add Another', 'Save');
        var saveAndAddButtonLabel = _v0.a;
        var saveButtonLabel = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Panel$footer, _List_fromArray([
                $author$project$Ui$Element$flexCol
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: saveAndAddButtonLabel
                    }, _List_fromArray([
                        $author$project$Ui$Button$styled(0),
                        $author$project$Ui$Button$disabled(formLoading),
                        $author$project$Ui$Button$loading(formSaving),
                        $author$project$Ui$Button$onClick($author$project$Pages$Charges$New$SaveAndAddAnother)
                    ]), _List_fromArray([
                        $elm$html$Html$text(saveAndAddButtonLabel)
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: saveButtonLabel
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$disabled(formLoading),
                        $author$project$Ui$Button$loading(formSaving)
                    ]), _List_fromArray([
                        $elm$html$Html$text(saveButtonLabel)
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    model.Cu.adU.adj ? $author$project$Utils$Html$empty : $author$project$Pages$Charges$New$viewCreatedChargesGroupedByInvoice(model)
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Charges$New$Close = {
        $: 3
    };
    var $author$project$Pages$Charges$New$viewPanelHeading = _List_fromArray([
        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                $elm$html$Html$text('Create New Charges')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close and go back'
                }, _List_fromArray([
                    $author$project$Ui$Button$close,
                    $author$project$Ui$Button$onClick($author$project$Pages$Charges$New$Close)
                ]), _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
                    ]), _List_fromArray([
                        $elm$html$Html$text("\xd7")
                    ]))
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$Charges$New$viewBody = function(model) {
        return $author$project$Components$Charge$Form$formReady(model.e) ? A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$onSubmit($author$project$Pages$Charges$New$Save)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, $elm$core$List$concat(_List_fromArray([
                $author$project$Pages$Charges$New$viewPanelHeading,
                $author$project$Pages$Charges$New$viewPanelBody(model),
                $author$project$Pages$Charges$New$viewPanelFooter(model)
            ])))
        ])) : A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$margin(18)
        ]), $author$project$Components$LoadingPage$view);
    };
    var $author$project$Pages$Charges$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Charges$New$CustomerEmailModalMsg, $author$project$Components$CustomerEmailModal$modal(model.lM)),
                A2($elm$html$Html$map, $author$project$Pages$Charges$New$SchedulePaymentModalMsg, $author$project$Components$CustomerSchedulePaymentModal$view(model.gG)),
                function() {
                    var _v0 = model.lH;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var createPaymentModal = _v1.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Charges$New$CreatePaymentModalMsg, $author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Pages$Charges$New$viewBody(model)
            ]),
            $2: 'Charges'
        };
    };
    var $author$project$Pages$Charges$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Charges$New$init,
        aeR: $author$project$Pages$Charges$New$load,
        ag3: $author$project$Pages$Charges$New$save,
        ahE: $author$project$Pages$Charges$New$subscriptions,
        aaO: $author$project$Pages$Charges$New$update,
        aid: $author$project$Pages$Charges$New$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$BrokerFormMsg = $elm$core$Basics$identity;
    var $author$project$Components$Broker$Form$GotItem = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Broker$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Broker$Form$formFieldsInit = {
        zr: '',
        Ab: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Broker$brokerPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Broker$brokersPath);
    };
    var $author$project$Api$Provider$Broker$One$Broker = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Broker$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Broker$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Broker$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Broker$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Broker$brokerPath(id_)));
    });
    var $author$project$Components$Broker$Form$init = F4(function(apiClient, session, brokerAccountId, id) {
        var _v0 = function() {
            if (!id.$) {
                var id_ = id.a;
                return _Utils_Tuple2($elm$core$Maybe$Nothing, A3($author$project$Api$Provider$Broker$retrieve, apiClient, id_, $author$project$Components$Broker$Form$GotItem));
            } else return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Components$Broker$Form$formFieldsInit), $elm$core$Platform$Cmd$none);
        }();
        var formFields = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2({
            bS: brokerAccountId,
            PU: A2($elm$core$Maybe$map, $author$project$Utils$Form$init, formFields),
            aef: id,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session
        }, cmd);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var params = _v2.VU;
        var _v3 = A4($author$project$Components$Broker$Form$init, apiClient, session, params.bS, $elm$core$Maybe$Just(params.EC));
        var form = _v3.a;
        var cmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Api$Provider$Broker$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Broker$Shared$name(shared);
    };
    var $author$project$Components$Broker$Form$formFieldsFromItem = function(broker) {
        return {
            zr: $author$project$Api$Provider$Broker$One$name(broker),
            Ab: $elm$core$Maybe$Just($author$project$Api$Provider$Broker$One$name(broker))
        };
    };
    var $author$project$Components$Broker$Form$formFieldsUpdate = F2(function(field, fields) {
        var string = field;
        return _Utils_update(fields, {
            zr: string
        });
    });
    var $author$project$Components$Broker$Form$NameValidation = 0;
    var $author$project$Components$Broker$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Components$Broker$Form$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Broker$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('broker_account', $author$project$Utils$Encode$association(fields.vR))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Broker$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Broker$brokersPath)));
    });
    var $author$project$Components$Broker$Form$createItem = F3(function(apiClient, brokerAccountId, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            vR: brokerAccountId,
            zr: fields.zr
        };
        return A3($author$project$Api$Provider$Broker$create, apiClient, apiFields, $author$project$Components$Broker$Form$Created);
    });
    var $author$project$Components$Broker$Form$Updated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Broker$update = F4(function(apiClient, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Broker$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Broker$brokerPath(id_))));
    });
    var $author$project$Components$Broker$Form$updateItem = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            zr: fields.zr
        };
        return A4($author$project$Api$Provider$Broker$update, apiClient, id, apiFields, $author$project$Components$Broker$Form$Updated);
    });
    var $author$project$Components$Broker$Form$saveItem = F4(function(maybeId, apiClient, brokerAccountId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Components$Broker$Form$updateItem, apiClient, id_, formFields);
        } else return A3($author$project$Components$Broker$Form$createItem, apiClient, brokerAccountId, formFields);
    });
    var $author$project$Components$Broker$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var broker = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Components$Broker$Form$formFieldsFromItem(broker)))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var field = msg.a;
                var _v3 = model.PU;
                if (!_v3.$) {
                    var form = _v3.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Broker$Form$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var _v4 = model.PU;
                if (!_v4.$) {
                    var form = _v4.a;
                    var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$Broker$Form$formFieldsValidator, form);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var newForm = _v6.a;
                        var validFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$Loading
                        }), A4($author$project$Components$Broker$Form$saveItem, model.aef, apiClient, model.bS, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v5.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                var _v7 = model.PU;
                if (!_v7.$) {
                    if (response.$ === 3) {
                        var broker = response.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
                            bS: model.bS
                        })), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$Broker$One$name(broker))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                var _v9 = model.PU;
                if (!_v9.$) {
                    if (response.$ === 3) {
                        var broker = response.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
                            bS: model.bS
                        })), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Broker$One$name(broker) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Broker$Form$update, model.Ej, subMsg, model.PU);
        var newModelForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newModelForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Broker$Form$Save = {
        $: 2
    };
    var $author$project$Components$Broker$Form$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Broker$Form$Name = $elm$core$Basics$identity;
    var $author$project$Components$Broker$Form$viewForm = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Name')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$placeholder('e.g. John Doe'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Broker$Form$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ]))
        ]);
    };
    var $author$project$Components$Broker$Form$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$onSubmit($author$project$Components$Broker$Form$Save)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
                                bS: model.bS
                            }), _List_Nil, _List_fromArray([
                                $elm$html$Html$text('All Brokers')
                            ]))
                        ])),
                        A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                            $author$project$Ui$Breadcrumb$active(true)
                        ]), _List_fromArray([
                            function() {
                                var _v1 = model.PU;
                                if (!_v1.$) {
                                    var form = _v1.a;
                                    var _v2 = $author$project$Utils$Form$fields(form);
                                    var originalName = _v2.Ab;
                                    return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Add New Broker', originalName));
                                } else return $author$project$Ui$Spinner$view(_List_fromArray([
                                    $author$project$Ui$Spinner$extraSmall
                                ]));
                            }()
                        ]))
                    ]))),
                    $author$project$Ui$Panel$title(_List_fromArray([
                        function() {
                            var _v3 = model.aef;
                            if (!_v3.$) return $elm$html$Html$text('Edit broker');
                            else return $elm$html$Html$text('Add new broker');
                        }()
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, function() {
                    var _v4 = model.PU;
                    if (!_v4.$) {
                        var form = _v4.a;
                        return $author$project$Components$Broker$Form$viewForm(form);
                    } else return _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]))
                    ]);
                }()),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyCenter,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
                            bS: model.bS
                        }), _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Back')
                        ])),
                        function() {
                            var verb = function() {
                                var _v5 = model.aef;
                                if (!_v5.$) return 'Update';
                                else return 'Create';
                            }();
                            return A3($author$project$Ui$Button$view, {
                                abP: verb + ' broker'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                            ]), _List_fromArray([
                                $elm$html$Html$text(verb)
                            ]));
                        }()
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Broker$Form$view(model.PU))
            ]),
            $2: 'Commissions | Brokers'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$GotBrokers = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers = function(model) {
        return A3($author$project$Api$Provider$Broker$list, model.Ej, function(d) {
            return _Utils_update(d, {
                vR: $elm$core$Maybe$Just(model.bS),
                Q8: $elm$core$Maybe$Just(true),
                af_: model.af_,
                ahs: model.ahs
            });
        }, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$GotBrokers);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var query = _v2.Bz;
        var params = _v2.VU;
        var model = {
            Ej: apiClient,
            bS: params.bS,
            Kr: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            jU: $elm$core$Maybe$Nothing,
            Z$: session,
            ahs: $author$project$Api$Sort$initFromQuery(query)
        };
        return _Utils_Tuple2(model, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(model));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Broker$RestartModal$Close = {
        $: 1
    };
    var $author$project$Components$Broker$RestartModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Broker$RestartModal$Close);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Broker$RestartModal$subscriptions, model.jU)));
    };
    var $author$project$Components$Broker$RestartModal$init = F2(function(session, broker) {
        return {
            vQ: broker,
            Z$: session,
            o2: $author$project$Api$Data$NotAsked
        };
    });
    var $author$project$Components$Broker$RestartModal$BrokerRestarted = 2;
    var $author$project$Components$Broker$RestartModal$Closed = 1;
    var $author$project$Components$Broker$RestartModal$None = 0;
    var $author$project$Components$Broker$RestartModal$Restarted = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Broker$restart = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Broker$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'restart'
        ]), $author$project$Api$Provider$Broker$brokerPath(id_))));
    });
    var $author$project$Components$Broker$RestartModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                return {
                    EQ: A3($author$project$Api$Provider$Broker$restart, apiClient, $author$project$Api$Provider$Broker$All$id(model.vQ), $author$project$Components$Broker$RestartModal$Restarted),
                    adu: 0,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker successfully restarted')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
                bS: model.bS
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), $author$project$Api$Sort$toQuery(model.ahs))));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kr: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Kr: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(newModel),
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(newModel),
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var broker = msg.a;
                var restartModal = A2($author$project$Components$Broker$RestartModal$init, model.Z$, broker);
                return _Utils_Tuple3(_Utils_update(model, {
                    jU: $elm$core$Maybe$Just(restartModal)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v2 = model.jU;
                if (!_v2.$) {
                    var restartModal = _v2.a;
                    var restartModalResult = A3($author$project$Components$Broker$RestartModal$update, model.Ej, subMsg, restartModal);
                    var _v3 = function() {
                        var _v4 = restartModalResult.adu;
                        switch(_v4){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(restartModalResult.zi), model.Kr, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Kr, $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$fetchBrokers(model));
                        }
                    }();
                    var restartModal_ = _v3.a;
                    var brokers = _v3.b;
                    var cmd = _v3.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kr: brokers,
                        jU: restartModal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg, restartModalResult.EQ),
                        cmd
                    ])), restartModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Broker$RestartModal$Restart = {
        $: 0
    };
    var $author$project$Components$Broker$RestartModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Broker$RestartModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Restart Broker')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Restarting this broker will not re-activate any old deals they may have been associated with '),
                    $elm$html$Html$text('but will allow them to be used in new deals.')
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Broker$RestartModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Restart broker'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$loading(_Utils_eq(model.o2, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Broker$RestartModal$Restart)
                ]), _List_fromArray([
                    $elm$html$Html$text('Restart')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', false, 'Name')
    ]);
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$Restart = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Broker$Shared$endedOn = function(_v0) {
        var record = _v0;
        return record.OT;
    };
    var $author$project$Api$Provider$Broker$All$endedOn = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Broker$Shared$endedOn(shared);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewBroker = function(broker) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Broker$All$name(broker)),
                    function() {
                        var _v0 = $author$project$Api$Provider$Broker$All$endedOn(broker);
                        if (!_v0.$) {
                            var endedOn = _v0.a;
                            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(' on '),
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endedOn))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$pull(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Restart broker'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$onClick($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$Restart(broker)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Restart')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.Kr;
            if (_v1.$ === 3) {
                var brokers_ = _v1.a;
                return _Utils_Tuple2(false, brokers_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var brokers = _v0.b;
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No ended brokers.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$SortTable)), $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewBroker, brokers), _List_Nil)
        ]);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.jU;
                    if (!_v0.$) {
                        var restartModal = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$RestartModalMsg, $author$project$Components$Broker$RestartModal$view(restartModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
                                    bS: model.bS
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Active Brokers')
                                ]))
                            ])),
                            A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                $author$project$Ui$Breadcrumb$active(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Ended Brokers')
                            ]))
                        ]))),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Ended Brokers')
                        ])),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil)
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        function() {
                            var _v1 = model.Kr;
                            if (_v1.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_));
                            else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Commissions | Brokers'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$BrokerFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var params = _v2.VU;
        var _v3 = A4($author$project$Components$Broker$Form$init, apiClient, session, params.bS, $elm$core$Maybe$Nothing);
        var form = _v3.a;
        var cmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Broker$Form$update, model.Ej, subMsg, model.PU);
        var newModelForm = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newModelForm
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Broker$Form$view(model.PU))
            ]),
            $2: 'Commissions | Brokers'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$GotBrokers = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers = function(model) {
        return A3($author$project$Api$Provider$Broker$list, model.Ej, function(d) {
            return _Utils_update(d, {
                vR: $elm$core$Maybe$Just(model.bS),
                af_: model.af_,
                ahs: model.ahs
            });
        }, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$GotBrokers);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$init = F4(function(session, _v0, shared, _v1) {
        var query = _v1.Bz;
        var params = _v1.VU;
        var model = {
            Ej: shared.Ej,
            bS: params.bS,
            Kr: $author$project$Api$Data$Loading,
            cP: shared.cP,
            fH: $elm$core$Maybe$Nothing,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            Z$: session,
            ahs: $author$project$Api$Sort$initFromQuery(query)
        };
        return _Utils_Tuple2(model, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(model));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Broker$EndModal$Close = {
        $: 1
    };
    var $author$project$Components$Broker$EndModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Broker$EndModal$Close);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$subscriptions = function(_v0) {
        var endModal = _v0.fH;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Broker$EndModal$subscriptions, endModal)));
    };
    var $author$project$Components$Broker$EndModal$Broker = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Broker$EndModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Broker$EndModal$EndDateDateInputMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Broker$EndModal$initFormFields = function() {
        var _v0 = $author$project$Components$DateInput$init;
        var endDateDateInput = _v0.a;
        var endDateDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            qv: $elm$core$Maybe$Nothing,
            qw: endDateDateInput
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Broker$EndModal$EndDateDateInputMsg(endDateDateInput), endDateDateInputCmd));
    }();
    var $author$project$Components$Broker$EndModal$init = F3(function(session, currentDate, resource) {
        var _v0 = $author$project$Components$Broker$EndModal$initFormFields;
        var fields = _v0.a;
        var fieldsCmd = _v0.b;
        return _Utils_Tuple2({
            cP: currentDate,
            PU: $author$project$Utils$Form$init(fields),
            Hg: resource,
            Z$: session,
            o2: $author$project$Api$Data$NotAsked
        }, fieldsCmd);
    });
    var $author$project$Components$Broker$EndModal$BrokerAccountEnded = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Broker$EndModal$BrokerEnded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Broker$EndModal$Closed = {
        $: 1
    };
    var $author$project$Components$Broker$EndModal$EndDate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Broker$EndModal$EndedBroker = {
        $: 2
    };
    var $author$project$Components$Broker$EndModal$EndedBrokerAccount = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Broker$EndModal$None = {
        $: 0
    };
    var $author$project$Api$Provider$Broker$end = F4(function(apiClient, id_, endDate, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('ended_on', $author$project$Utils$Date$encode(endDate))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Broker$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'end'
        ]), $author$project$Api$Provider$Broker$brokerPath(id_)))));
    });
    var $author$project$Api$Provider$BrokerAccount$brokerAccountsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'broker_accounts'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$BrokerAccount$brokerAccountPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$BrokerAccount$brokerAccountsPath);
    };
    var $author$project$Api$Provider$BrokerAccount$One$BrokerAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$BrokerAccount$One$Record = function(ein) {
        return function(singleBrokerName) {
            return function(addressLine1) {
                return function(addressLine2) {
                    return function(addressCity) {
                        return function(addressState) {
                            return function(addressZip) {
                                return function(addressCountry) {
                                    return function(futureRatePeriodScheduleStartDate) {
                                        return function(futureRatePeriodSchedule) {
                                            return function(meta) {
                                                return {
                                                    IJ: addressCity,
                                                    IK: addressCountry,
                                                    IL: addressLine1,
                                                    IM: addressLine2,
                                                    IN: addressState,
                                                    IO: addressZip,
                                                    Oy: ein,
                                                    P2: futureRatePeriodSchedule,
                                                    P3: futureRatePeriodScheduleStartDate,
                                                    Ue: meta,
                                                    _v: singleBrokerName
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$BrokerAccount$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BrokerAccount$Meta$Record = F3(function(destroyable, currentScheduleEnded, futureScheduleEnded) {
        return {
            MP: currentScheduleEnded,
            NV: destroyable,
            P4: futureScheduleEnded
        };
    });
    var $author$project$Api$Provider$BrokerAccount$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'future_schedule_ended', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'current_schedule_ended', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'destroyable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$Meta$Record))));
    var $author$project$Api$Provider$BrokerAccount$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerAccount$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$BrokerAccount$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$BrokerAccount$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'future_rate_period_schedule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RatePeriodSchedule$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'future_rate_period_schedule_start_date', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_country', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_zip', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_state', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_city', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_line2', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address_line1', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'single_broker_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ein', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$One$Record))))))))))));
    var $author$project$Api$Provider$BrokerAccount$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerAccount$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$One$BrokerAccount)));
    var $author$project$Api$Provider$BrokerAccount$end = F4(function(apiClient, id, endDate, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker_account', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('end_date', $author$project$Utils$Date$encode(endDate))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BrokerAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'end'
        ]), $author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)))));
    });
    var $author$project$Components$Broker$EndModal$EndDateValidation = 0;
    var $author$project$Components$Broker$EndModal$validateEndDate = F2(function(currentDate, fields) {
        var _v0 = fields.qv;
        if (!_v0.$) {
            var endDate = _v0.a;
            var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
            return A2($justinmimbs$date$Date$compare, yesterdayDate, endDate) !== 2 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2(0, 'Please enter a date.')
        ]);
    });
    var $author$project$Components$Broker$EndModal$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Broker$EndModal$validateEndDate(currentDate))
        ]));
    };
    var $author$project$Api$Provider$BrokerAccount$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$BrokerAccount$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerAccount$Shared$id(shared);
    };
    var $author$project$Components$Broker$EndModal$formFieldsUpdate = F2(function(field, fields) {
        var dateInput = field.a;
        var date = field.b;
        return _Utils_update(fields, {
            qv: date,
            qw: dateInput
        });
    });
    var $author$project$Components$Broker$EndModal$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Components$Broker$EndModal$formFieldsUpdate, A2(field, newDateInput, date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Components$Broker$EndModal$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.PU);
            }
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd),
            adu: $author$project$Components$Broker$EndModal$None,
            zi: _Utils_update(model, {
                PU: newForm
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$Broker$EndModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Broker$EndModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Broker$EndModal$formFieldsValidator(model.cP), model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var endDate = A2($elm$core$Maybe$withDefault, model.cP, $rtfeldman$elm_validate$Validate$fromValid(validFormFields).qv);
                    return {
                        EQ: function() {
                            var _v4 = model.Hg;
                            if (!_v4.$) {
                                var broker = _v4.a;
                                return A4($author$project$Api$Provider$Broker$end, apiClient, $author$project$Api$Provider$Broker$All$id(broker), endDate, $author$project$Components$Broker$EndModal$BrokerEnded);
                            } else {
                                var brokerAccount = _v4.a;
                                return A4($author$project$Api$Provider$BrokerAccount$end, apiClient, $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount), endDate, $author$project$Components$Broker$EndModal$BrokerAccountEnded);
                            }
                        }(),
                        adu: $author$project$Components$Broker$EndModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            o2: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Broker$EndModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Broker$EndModal$EndedBroker,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker successfully ended')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Broker$EndModal$None,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: function() {
                        var _v7 = model.Hg;
                        if (_v7.$ === 1) {
                            var brokerAccount = _v7.a;
                            return $author$project$Components$Broker$EndModal$EndedBrokerAccount(brokerAccount);
                        } else return $author$project$Components$Broker$EndModal$None;
                    }(),
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Brokers and deals successfully ended')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Broker$EndModal$None,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Components$Broker$EndModal$updateDateInputFormField, model, dateInput, subMsg, $author$project$Components$Broker$EndModal$EndDateDateInputMsg, $author$project$Components$Broker$EndModal$EndDate, function($) {
                    return $.qv;
                });
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
                bS: model.bS
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), $author$project$Api$Sort$toQuery(model.ahs))));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kr: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Kr: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(newModel),
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(newModel),
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var broker = msg.a;
                var _v2 = A3($author$project$Components$Broker$EndModal$init, model.Z$, model.cP, $author$project$Components$Broker$EndModal$Broker(broker));
                var endModal = _v2.a;
                var endModalCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    fH: $elm$core$Maybe$Just(endModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg, endModalCmd), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v3 = model.fH;
                if (!_v3.$) {
                    var endModal = _v3.a;
                    var endModalResult = A3($author$project$Components$Broker$EndModal$update, model.Ej, subMsg, endModal);
                    var _v4 = function() {
                        var _v5 = endModalResult.adu;
                        switch(_v5.$){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(endModalResult.zi), model.Kr, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Kr, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$fetchBrokers(model));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Kr, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var endModal_ = _v4.a;
                    var brokers = _v4.b;
                    var cmd = _v4.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kr: brokers,
                        fH: endModal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg, endModalResult.EQ),
                        cmd
                    ])), endModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Broker$EndModal$End = {
        $: 0
    };
    var $author$project$Components$Broker$EndModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Broker$EndModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(function() {
                    var _v1 = model.Hg;
                    if (!_v1.$) {
                        var broker = _v1.a;
                        return 'End Broker ' + $author$project$Api$Provider$Broker$All$name(broker);
                    } else return 'End All Deals';
                }())
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Broker$EndModal$End),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Date'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(4),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Broker$EndModal$EndDateDateInputMsg(fields.qw), A2($author$project$Components$DateInput$view, _List_fromArray([
                            $author$project$Components$DateInput$value(fields.qv),
                            $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                        ]), fields.qw)),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            function() {
                                var _v2 = model.Hg;
                                if (!_v2.$) return $elm$html$Html$text('Ending this broker will end all deals on the same date and delete any deals taking effect in the future.');
                                else return $elm$html$Html$text('This will end all brokers and their deals on the same date, and delete any deals taking effect in the future.');
                            }()
                        ]))
                    ]))
                ])),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Broker$EndModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'End broker and their deals'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$loading(_Utils_eq(model.o2, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Broker$EndModal$End)
                ]), _List_fromArray([
                    $elm$html$Html$text('End')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', false, 'Name')
    ]);
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$End = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewBroker = F2(function(brokerAccountId, broker) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Broker$All$name(broker)),
                    function() {
                        var _v0 = $author$project$Api$Provider$Broker$All$endedOn(broker);
                        if (!_v0.$) {
                            var endedOn = _v0.a;
                            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Badge$fromString, _List_Nil, 'deal_ending'),
                                $elm$html$Html$text(' on '),
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endedOn))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top({
                        bS: brokerAccountId,
                        EC: $author$project$Api$Provider$Broker$All$id(broker)
                    }), _List_fromArray([
                        $author$project$Ui$Link$sm,
                        $author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    function() {
                        var _v1 = $author$project$Api$Provider$Broker$All$endedOn(broker);
                        if (_v1.$ === 1) return A3($author$project$Ui$Button$view, {
                            abP: 'End broker'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$size(0),
                            $author$project$Ui$Button$onClick($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$End(broker)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                        ]), _List_fromArray([
                            $elm$html$Html$text('End')
                        ]));
                        else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.Kr;
            if (_v1.$ === 3) {
                var brokers_ = _v1.a;
                return _Utils_Tuple2(false, brokers_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var brokers = _v0.b;
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text("It looks like you haven\u2019t added any brokers yet. "),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New({
                        bS: model.bS
                    }), _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Create one')
                    ])),
                    $elm$html$Html$text('?')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$SortTable)), $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewBroker(model.bS), brokers), _List_Nil)
        ]);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.fH;
                    if (!_v0.$) {
                        var endModal = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$EndModalMsg, $author$project$Components$Broker$EndModal$view(endModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(9)
                            ]), _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('Brokers')
                                ])),
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$textMuted
                                ]), _List_fromArray([
                                    $elm$html$Html$text('A broker represents an individual who brings in deals. We track commissions at the broker level and then group those commissions onto statements at the account level.')
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(3),
                                $author$project$Ui$Grid$justifyRight
                            ]), _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended({
                                    bS: model.bS
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('See Ended Brokers')
                                ])),
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New({
                                    bS: model.bS
                                }), _List_fromArray([
                                    $author$project$Ui$Link$buttonDefault,
                                    $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add Broker')
                                ]))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        function() {
                            var _v1 = model.Kr;
                            if (_v1.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_));
                            else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Commissions | Brokers'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerAccount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$TypeDropdownMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString = function(dealType) {
        if (!dealType) return 'Company';
        else return 'Membership';
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('type'), A2($elm$core$Maybe$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString, model.ah5)),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('broker'), model.EC)
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals({
                bS: model.bS
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerDeals = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$BrokerDeal$brokerDealsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'broker_deals'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$BrokerDeal$All$BrokerDeal = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BrokerDeal$One$BrokerDeal = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$BrokerDeal$Shared$BrokerDeal = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BrokerDeal$Shared$Record = F2(function(id, endDate) {
        return {
            qv: endDate,
            aef: id
        };
    });
    var $author$project$Api$Provider$BrokerDeal$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$Shared$Record)));
    var $author$project$Api$Provider$BrokerDeal$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerDeal$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$BrokerDeal$One$Record = F6(function(dealName, dealType, broker, rates, company, meta) {
        return {
            vQ: broker,
            acy: company,
            Nj: dealName,
            Nk: dealType,
            Ue: meta,
            X8: rates
        };
    });
    var $author$project$Api$Provider$BrokerDeal$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BrokerDeal$Meta$MetaRecord = F8(function(hasEndedRates, hasEndedDeal, dateEditable, restartable, isMembershipType, destroyable, editable, endable) {
        return {
            M5: dateEditable,
            NV: destroyable,
            Ot: editable,
            OS: endable,
            Qn: hasEndedDeal,
            Qo: hasEndedRates,
            Sa: isMembershipType,
            YU: restartable
        };
    });
    var $author$project$Api$Provider$BrokerDeal$Meta$metaRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'endable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_membership_type', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'restartable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date_editable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_ended_deal', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_ended_rates', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$Meta$MetaRecord)))))))));
    var $author$project$Api$Provider$BrokerDeal$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerDeal$Meta$metaRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$BrokerDealRate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$BrokerDealRate$Shared$BrokerDealRate = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BrokerDealRate$Shared$Record = F5(function(id, startDate, endDate, description, pricingStructure) {
        return {
            NQ: description,
            qv: endDate,
            aef: id,
            Xq: pricingStructure,
            _0: startDate
        };
    });
    var $author$project$Api$Provider$BrokerDealRate$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pricing_structure', $author$project$Api$Provider$PricingStructure$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$Shared$Record))))));
    var $author$project$Api$Provider$BrokerDealRate$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerDealRate$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$Record = F2(function(isEnded, isFuture) {
        return {
            R3: isEnded,
            R5: isFuture
        };
    });
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_future', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_ended', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$Record)));
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerDealRate$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$BrokerDealRate)));
    var $author$project$Api$Provider$BrokerDeal$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$BrokerDeal$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rates', $elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'broker', $author$project$Api$Provider$Broker$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deal_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deal_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$One$Record)))))));
    var $author$project$Api$Provider$BrokerDeal$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerDeal$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerDeal$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerDeal$One$BrokerDeal)));
    var $author$project$Api$Provider$BrokerDeal$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerDeal$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$BrokerDeal$listDefaults = {
        vQ: $elm$core$Maybe$Nothing,
        vR: $elm$core$Maybe$Nothing,
        acy: $elm$core$Maybe$Nothing,
        Q8: $elm$core$Maybe$Nothing,
        jc: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        ah5: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$BrokerDeal$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$BrokerDeal$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.acy;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'company', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.vR;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'broker_account', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.vQ;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'broker', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.jc;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'membership', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.ah5;
                if (!_v4.$) {
                    var string = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'type', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.Q8;
                if (!_v5.$) {
                    var bool = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'inactive', bool)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.agq;
                if (!_v6.$) {
                    var string = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$BrokerDeal$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDeal$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$BrokerDeal$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDeal$brokerDealsPath)));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals = function(model) {
        return A3($author$project$Api$Provider$BrokerDeal$list, model.Ej, function(d) {
            return _Utils_update(d, {
                vQ: model.EC,
                vR: $elm$core$Maybe$Just(model.bS),
                af_: model.af_,
                agq: model.agq,
                ah5: A2($elm$core$Maybe$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToString, model.ah5)
            });
        }, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerDeals);
    };
    var $author$project$Components$BrokerDeal$Table$init = F3(function(session, currentDate, options) {
        return {
            Kq: _List_Nil,
            cP: currentDate,
            l8: options.l8,
            qL: options.qL,
            qM: options.qM,
            Z$: session,
            gQ: $elm$core$Set$empty
        };
    });
    var $author$project$Api$Provider$BrokerAccount$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$BrokerAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Company = 0;
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Membership = 1;
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$stringToDealType = function(str) {
        switch(str){
            case 'Company':
                return $elm$core$Maybe$Just(0);
            case 'Membership':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var brokerId = A2($elm$core$Dict$get, 'broker', query);
        var _v1 = A3($author$project$Components$ResourceFilter$Broker$init, shared.Ej, function(d) {
            return _Utils_update(d, {
                vR: $elm$core$Maybe$Just(params.bS)
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'All Brokers',
                agj: brokerId
            });
        });
        var brokerResourceFilter = _v1.a;
        var brokerResourceFilterCmd = _v1.b;
        var model = {
            Ej: shared.Ej,
            vR: $author$project$Api$Data$Loading,
            bS: params.bS,
            Kq: $author$project$Api$Data$Loading,
            dy: A3($author$project$Components$BrokerDeal$Table$init, session, shared.cP, {
                l8: false,
                qL: true,
                qM: false
            }),
            EC: brokerId,
            lj: brokerResourceFilter,
            h$: $elm$core$Maybe$Nothing,
            cP: shared.cP,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            HP: shared.HP,
            oX: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'type-dropdown-filter',
                ahX: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$TypeDropdownMsg
            })),
            ah5: A2($elm$core$Maybe$andThen, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$stringToDealType, A2($elm$core$Dict$get, 'type', query))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg, brokerResourceFilterCmd),
            $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model),
            A3($author$project$Api$Provider$BrokerAccount$retrieve, shared.Ej, params.bS, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$GotBrokerAccount),
            A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Components$BrokerDeal$Table$load = F2(function(currentDate, model) {
        return _Utils_update(model, {
            cP: currentDate
        });
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            dy: A2($author$project$Components$BrokerDeal$Table$load, shared.cP, model.dy)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$Close = {
        $: 1
    };
    var $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$subscriptions = function(model) {
        return $author$project$Ui$Dropdown$subscriptions(model.lZ);
    };
    var $author$project$Components$BrokerDeal$CreateModal$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$CreateModal$Close),
            A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg, $author$project$Components$ResourceFilter$Company$subscriptions(model.pY)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg, $author$project$Components$ResourceFilter$Broker$subscriptions(model.lj)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg, $author$project$Components$ResourceFilter$Patient$subscriptions(model.rX)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg, $author$project$Components$PricingStructureSelect$subscriptions(model.nI))
        ]));
    };
    var $author$project$Components$BrokerDeal$Table$TimelineMsg = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$Timeline$EndModalMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$Timeline$RestartModalMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$EndModal$Close = {
        $: 1
    };
    var $author$project$Components$BrokerDeal$EndModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$EndModal$Close);
    };
    var $author$project$Components$BrokerDeal$RestartModal$Close = {
        $: 1
    };
    var $author$project$Components$BrokerDeal$RestartModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$RestartModal$Close);
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$Close = {
        $: 1
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$BrokerDealRate$CreateUpdateModal$Close),
            A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg, $author$project$Components$PricingStructureSelect$subscriptions(model.nI))
        ]));
    };
    var $author$project$Components$BrokerDeal$Timeline$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v0 = model.fc;
                if (!_v0.$) {
                    var brokerDealRateModal = _v0.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, $author$project$Components$BrokerDealRate$CreateUpdateModal$subscriptions(brokerDealRateModal));
                } else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$EndModal$subscriptions, model.fH))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDeal$Timeline$RestartModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$RestartModal$subscriptions, model.jU))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed)), model.fr)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fd)))
        ]));
    };
    var $author$project$Components$BrokerDeal$Table$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(A2($elm$core$List$indexedMap, F2(function(index, _v0) {
            var timeline = _v0.b;
            return A2($elm$core$Platform$Sub$map, $author$project$Components$BrokerDeal$Table$TimelineMsg(index), $author$project$Components$BrokerDeal$Timeline$subscriptions(timeline));
        }), model.Kq));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$CreateModal$subscriptions, model.h$))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg, $author$project$Components$BrokerDeal$Table$subscriptions(model.dy)),
            $author$project$Ui$Dropdown$subscriptions(model.oX),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg, $author$project$Components$ResourceFilter$Broker$subscriptions(model.lj))
        ]));
    };
    var $author$project$Components$BrokerDeal$CreateModal$Company = 0;
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$BrokerDeal$One$broker = function(_v0) {
        var record = _v0.b;
        return record.vQ;
    };
    var $author$project$Api$Provider$BrokerDeal$All$broker = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BrokerDeal$One$broker(one);
    };
    var $author$project$Api$Provider$BrokerDeal$One$company = function(_v0) {
        var record = _v0.b;
        return record.acy;
    };
    var $author$project$Api$Provider$BrokerDeal$All$company = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BrokerDeal$One$company(one);
    };
    var $author$project$Api$Provider$BrokerDeal$One$dealName = function(_v0) {
        var record = _v0.b;
        return record.Nj;
    };
    var $author$project$Api$Provider$BrokerDeal$All$dealName = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BrokerDeal$One$dealName(one);
    };
    var $author$project$Api$Provider$BrokerDeal$One$dealType = function(_v0) {
        var record = _v0.b;
        return record.Nk;
    };
    var $author$project$Api$Provider$BrokerDeal$All$dealType = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BrokerDeal$One$dealType(one);
    };
    var $author$project$Api$Provider$BrokerDeal$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Api$Provider$BrokerDeal$One$endDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerDeal$Shared$endDate(shared);
    };
    var $author$project$Api$Provider$BrokerDeal$All$endDate = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BrokerDeal$One$endDate(one);
    };
    var $author$project$Api$Provider$BrokerDeal$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$BrokerDeal$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerDeal$Shared$id(shared);
    };
    var $author$project$Api$Provider$BrokerDeal$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BrokerDeal$One$id(one);
    };
    var $author$project$Api$Provider$BrokerDeal$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Provider$BrokerDeal$All$meta = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BrokerDeal$One$meta(one);
    };
    var $author$project$Api$Provider$BrokerDeal$One$rates = function(_v0) {
        var record = _v0.b;
        return record.X8;
    };
    var $author$project$Api$Provider$BrokerDeal$All$rates = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BrokerDeal$One$rates(one);
    };
    var $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll = function(brokerDeal) {
        return {
            vQ: $author$project$Api$Provider$BrokerDeal$All$broker(brokerDeal),
            acy: $author$project$Api$Provider$BrokerDeal$All$company(brokerDeal),
            Nj: $author$project$Api$Provider$BrokerDeal$All$dealName(brokerDeal),
            Nk: $author$project$Api$Provider$BrokerDeal$All$dealType(brokerDeal),
            qv: $author$project$Api$Provider$BrokerDeal$All$endDate(brokerDeal),
            aef: $author$project$Api$Provider$BrokerDeal$All$id(brokerDeal),
            Ue: $author$project$Api$Provider$BrokerDeal$All$meta(brokerDeal),
            X8: $author$project$Api$Provider$BrokerDeal$All$rates(brokerDeal)
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$BrokerDeal$CreateModal$One = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$DropdownMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$GotPricingStructures = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$PricingStructure$All$PricingStructure = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PricingStructure$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PricingStructure$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PricingStructure$pricingStructuresPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'pricing_structures'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PricingStructure$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PricingStructure$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PricingStructure$pricingStructuresPath));
    });
    var $author$project$Components$PricingStructureSelect$init = function(apiClient) {
        return _Utils_Tuple2({
            hp: false,
            lZ: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'pricing-structure-dropdown-filter',
                ahX: $author$project$Components$PricingStructureSelect$DropdownMsg
            })),
            si: $author$project$Api$Data$Loading
        }, A2($author$project$Api$Provider$PricingStructure$list, apiClient, $author$project$Components$PricingStructureSelect$GotPricingStructures));
    };
    var $author$project$Api$Provider$Membership$Shared$id = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, '', record.aef);
    };
    var $author$project$Api$Provider$Membership$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$id(shared);
    };
    var $author$project$Api$Provider$Membership$One$owner = function(_v0) {
        var record = _v0.b;
        return record.VM;
    };
    var $author$project$Components$BrokerDeal$CreateModal$patientFromShared = function(patient) {
        return {
            aef: $author$project$Api$Provider$Patient$Shared$id(patient),
            T5: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient)
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$initFormFields = F4(function(dealType, company, membership, broker) {
        var patient = A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$CreateModal$patientFromShared, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Membership$One$owner, membership));
        return _Utils_Tuple2({
            abY: $elm$core$Maybe$Nothing,
            vQ: broker,
            acy: company,
            Nk: dealType,
            xA: $author$project$Utils$Maybe$toBool(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Membership$One$owner, membership)),
            jc: membership,
            y0: A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$id, membership),
            V7: patient,
            Xq: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$BrokerDeal$CreateModal$init = F5(function(apiClient, session, currentDate, timeZone, options) {
        var company = A2($elm$core$Maybe$map, function(a) {
            return $author$project$Components$BrokerDeal$CreateModal$One(a);
        }, options.acy);
        var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
        var pricingStructureSelect = _v0.a;
        var pricingStructureSelectCmd = _v0.b;
        var _v1 = A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Patient'
            });
        });
        var patientResourceFilter = _v1.a;
        var patientResourceFilterCmd = _v1.b;
        var _v2 = A4($author$project$Components$BrokerDeal$CreateModal$initFormFields, options.Nk, company, options.jc, options.vQ);
        var fields = _v2.a;
        var fieldsCmd = _v2.b;
        var _v3 = A2($author$project$Components$ResourceFilter$Company$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select an Employer'
            });
        });
        var companyResourceFilter = _v3.a;
        var companyResourceFilterCmd = _v3.b;
        var _v4 = A3($author$project$Components$ResourceFilter$Broker$init, apiClient, function(d) {
            return $author$project$Utils$Maybe$toBool(options.vR) ? _Utils_update(d, {
                vR: options.vR,
                Gu: $elm$core$Maybe$Just(true)
            }) : $author$project$Utils$Maybe$toBool(options.jc) ? _Utils_update(d, {
                Hi: $elm$core$Maybe$Just(true)
            }) : d;
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a broker'
            });
        });
        var brokerResourceFilter = _v4.a;
        var brokerResourceFilterCmd = _v4.b;
        return _Utils_Tuple2({
            lj: brokerResourceFilter,
            LG: options.LG,
            acy: company,
            pY: companyResourceFilter,
            cP: currentDate,
            PU: $author$project$Utils$Form$init(fields),
            rX: patientResourceFilter,
            nI: pricingStructureSelect,
            agX: options.agX,
            Z$: session,
            HP: timeZone,
            o2: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            fieldsCmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg, pricingStructureSelectCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg, companyResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg, brokerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg, patientResourceFilterCmd)
        ])));
    });
    var $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled = function(_v0) {
        var record = _v0;
        return record.agX;
    };
    var $author$project$Api$Provider$BrokerAccount$One$retailEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled(shared);
    };
    var $author$project$Components$BrokerDeal$CreateModal$All = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$Broker = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$BrokerDealCreated = 2;
    var $author$project$Components$BrokerDeal$CreateModal$Closed = 1;
    var $author$project$Components$BrokerDeal$CreateModal$CompanyField = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$GotMembership = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$BrokerDeal$CreateModal$MembershipField = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$BrokerDeal$CreateModal$MembershipUpdated = 3;
    var $author$project$Components$BrokerDeal$CreateModal$None = 0;
    var $author$project$Components$BrokerDeal$CreateModal$Patient = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$PricingStructure = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$PricingType$encode = function(pricingType) {
        switch(pricingType.$){
            case 0:
                return $elm$json$Json$Encode$string('percentage');
            case 1:
                return $elm$json$Json$Encode$string('fixed_amount_in_cents');
            case 2:
                return $elm$json$Json$Encode$string('percentage_and_fixed_amount');
            default:
                return $elm$json$Json$Encode$string('tiered');
        }
    };
    var $author$project$Api$SplitType$toString = function(splitType) {
        switch(splitType){
            case 0:
                return 'all_members';
            case 1:
                return 'primary_only';
            default:
                return 'flat';
        }
    };
    var $author$project$Api$SplitType$encode = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$SplitType$toString);
    var $author$project$Api$Provider$BrokerDeal$create = F3(function(apiClient, fields, toMsg) {
        var pricingStructure_ = function() {
            var _v0 = fields.Xq;
            if (_v0.$ === 1) return _List_Nil;
            else {
                var pricingStructure__ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('pricing_structure', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                        function() {
                            var _v1 = pricingStructure__.aef;
                            if (!_v1.$) {
                                var string = _v1.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(string))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v2 = pricingStructure__.NQ;
                            if (!_v2.$) {
                                var string = _v2.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('description', $elm$json$Json$Encode$string(string))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v3 = pricingStructure__.adR;
                            if (!_v3.$) {
                                var _int = _v3.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('fixed_amount_in_cents', $author$project$Currency$encode(_int))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v4 = pricingStructure__.af9;
                            if (!_v4.$) {
                                var percentage = _v4.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('percentage', $author$project$Percentage$encode(percentage))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v5 = pricingStructure__.ahu;
                            if (!_v5.$) {
                                var splitType = _v5.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('split_type', $author$project$Api$SplitType$encode(splitType))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v6 = pricingStructure__.agn;
                            if (!_v6.$) {
                                var pricingType_ = _v6.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('pricing_type', $author$project$Api$PricingType$encode(pricingType_))
                                ]);
                            } else return _List_Nil;
                        }()
                    ]))))
                ]);
            }
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker_deal', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('bill_from', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.abY)), A2($elm$core$List$cons, _Utils_Tuple2('company', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.acy)), A2($elm$core$List$cons, _Utils_Tuple2('membership', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.jc)), A2($elm$core$List$cons, _Utils_Tuple2('broker', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.vQ)), pricingStructure_))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BrokerDeal$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDeal$brokerDealsPath)));
    });
    var $author$project$Components$BrokerDeal$CreateModal$createBrokerDeal = F2(function(apiClient, validFormFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        var companyId = function(company_) {
            if (!company_.$) {
                var company = company_.a;
                return $author$project$Api$Provider$Company$One$id(company);
            } else {
                var company = company_.a;
                return $author$project$Api$Provider$Company$All$id(company);
            }
        };
        return A3($author$project$Api$Provider$BrokerDeal$create, apiClient, {
            abY: fields.abY,
            vQ: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, fields.vQ),
            acy: A2($elm$core$Maybe$map, companyId, fields.acy),
            jc: A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$id, fields.jc),
            Xq: fields.Xq
        }, $author$project$Components$BrokerDeal$CreateModal$Created);
    });
    var $author$project$Components$BrokerDeal$CreateModal$Updated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$One$Membership = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Membership$Shared$Membership = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Membership$Shared$Record = function(id) {
        return function(isSponsored) {
            return function(startDate) {
                return function(endDate) {
                    return function(isConfirmed) {
                        return function(isUpdatable) {
                            return function(isRestartable) {
                                return function(billDate) {
                                    return function(nextBillDate) {
                                        return function(billFromDate) {
                                            return function(fixedPeriodRateInCents) {
                                                return function(fixedRegistrationFeeInCents) {
                                                    return function(minimumEnrollmentPeriodInMonths) {
                                                        return function(minimumEnrollmentStartDate) {
                                                            return function(minimumEnrollmentEndDate) {
                                                                return function(contractType) {
                                                                    return function(contractExpires) {
                                                                        return function(contractEndDate) {
                                                                            return function(billsAtEndOfPeriod) {
                                                                                return function(billingStartDate) {
                                                                                    return function(endDateFarInThePast) {
                                                                                        return {
                                                                                            vN: billDate,
                                                                                            Kc: billFromDate,
                                                                                            Kg: billingStartDate,
                                                                                            Kh: billsAtEndOfPeriod,
                                                                                            wV: contractEndDate,
                                                                                            L5: contractExpires,
                                                                                            EW: contractType,
                                                                                            qv: endDate,
                                                                                            OR: endDateFarInThePast,
                                                                                            PP: fixedPeriodRateInCents,
                                                                                            PQ: fixedRegistrationFeeInCents,
                                                                                            aef: id,
                                                                                            RX: isConfirmed,
                                                                                            Sq: isRestartable,
                                                                                            Sr: isSponsored,
                                                                                            Sz: isUpdatable,
                                                                                            Uo: minimumEnrollmentEndDate,
                                                                                            Up: minimumEnrollmentPeriodInMonths,
                                                                                            Uq: minimumEnrollmentStartDate,
                                                                                            UY: nextBillDate,
                                                                                            _0: startDate
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Membership$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date_far_in_the_past', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bills_at_end_of_period', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_expires', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_type', $elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_enrollment_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_enrollment_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_enrollment_period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_period_rate_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_from_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_restartable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_updatable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_confirmed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_sponsored', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Shared$Record))))))))))))))))))))));
    var $author$project$Api$Provider$Membership$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Membership$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Membership$One$Record = function(status) {
        return function(plan) {
            return function(membershipPatients) {
                return function(billedThroughDate) {
                    return function(periodInMonths) {
                        return function(periodRateInCents) {
                            return function(isDestroyable) {
                                return function(isCancellable) {
                                    return function(isConfirmable) {
                                        return function(shouldBeBilledUpToDate) {
                                            return function(autoRenew) {
                                                return function(revenueInCents) {
                                                    return function(contractPeriodInMonths) {
                                                        return function(finalBillingEndDate) {
                                                            return function(neverBeenBilled) {
                                                                return function(isSynced) {
                                                                    return function(owner) {
                                                                        return function(upcomingAndOutstandingBills) {
                                                                            return function(prepayOptions) {
                                                                                return function(company) {
                                                                                    return function(companyAccount) {
                                                                                        return function(coupon) {
                                                                                            return function(brokerDeals) {
                                                                                                return function(cancellationReason) {
                                                                                                    return function(cancellationReasonOther) {
                                                                                                        return function(scheduledChange) {
                                                                                                            return function(firstContract) {
                                                                                                                return function(lastContract) {
                                                                                                                    return function(recurringCharges) {
                                                                                                                        return function(meta) {
                                                                                                                            return function(createdAt) {
                                                                                                                                return function(source) {
                                                                                                                                    return {
                                                                                                                                        JX: autoRenew,
                                                                                                                                        Kd: billedThroughDate,
                                                                                                                                        Kq: brokerDeals,
                                                                                                                                        ab9: cancellationReason,
                                                                                                                                        aca: cancellationReasonOther,
                                                                                                                                        acy: company,
                                                                                                                                        LI: companyAccount,
                                                                                                                                        L6: contractPeriodInMonths,
                                                                                                                                        Mj: coupon,
                                                                                                                                        Mx: createdAt,
                                                                                                                                        PI: finalBillingEndDate,
                                                                                                                                        PM: firstContract,
                                                                                                                                        RV: isCancellable,
                                                                                                                                        RW: isConfirmable,
                                                                                                                                        R1: isDestroyable,
                                                                                                                                        Su: isSynced,
                                                                                                                                        SQ: lastContract,
                                                                                                                                        T$: membershipPatients,
                                                                                                                                        Ue: meta,
                                                                                                                                        UQ: neverBeenBilled,
                                                                                                                                        VM: owner,
                                                                                                                                        WA: periodInMonths,
                                                                                                                                        WB: periodRateInCents,
                                                                                                                                        GW: plan,
                                                                                                                                        Xk: prepayOptions,
                                                                                                                                        Yl: recurringCharges,
                                                                                                                                        Y1: revenueInCents,
                                                                                                                                        Zv: scheduledChange,
                                                                                                                                        _a: shouldBeBilledUpToDate,
                                                                                                                                        Hw: source,
                                                                                                                                        ahy: status,
                                                                                                                                        aaL: upcomingAndOutstandingBills
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Membership$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Membership$Meta$Record = function(actions) {
        return function(owner) {
            return function(plan) {
                return function(startDate) {
                    return function(billDate) {
                        return function(nextBillDate) {
                            return function(autoRenew) {
                                return function(periodInMonths) {
                                    return function(minimumEnrollmentPeriodInMonths) {
                                        return function(membershipPatients) {
                                            return function(endDate) {
                                                return function(coupon) {
                                                    return function(fixedRegistrationFeeInCents) {
                                                        return function(fixedPeriodRateInCents) {
                                                            return function(contractExpires) {
                                                                return function(contractEndDate) {
                                                                    return function(contractPeriodInMonths) {
                                                                        return function(contractType) {
                                                                            return function(membershipScheduledChange) {
                                                                                return function(membershipPatientsMaxCount) {
                                                                                    return function(recurringCharges) {
                                                                                        return function(paymentSource) {
                                                                                            return {
                                                                                                tM: actions,
                                                                                                JX: autoRenew,
                                                                                                vN: billDate,
                                                                                                wV: contractEndDate,
                                                                                                L5: contractExpires,
                                                                                                L6: contractPeriodInMonths,
                                                                                                EW: contractType,
                                                                                                Mj: coupon,
                                                                                                qv: endDate,
                                                                                                PP: fixedPeriodRateInCents,
                                                                                                PQ: fixedRegistrationFeeInCents,
                                                                                                T$: membershipPatients,
                                                                                                T0: membershipPatientsMaxCount,
                                                                                                T3: membershipScheduledChange,
                                                                                                Up: minimumEnrollmentPeriodInMonths,
                                                                                                UY: nextBillDate,
                                                                                                VM: owner,
                                                                                                Wr: paymentSource,
                                                                                                WA: periodInMonths,
                                                                                                GW: plan,
                                                                                                Yl: recurringCharges,
                                                                                                _0: startDate
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Membership$Meta$ActionsRecord = function(invoiceNow) {
        return {
            RJ: invoiceNow
        };
    };
    var $author$project$Api$Provider$Membership$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_now', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ActionsRecord));
    var $author$project$Api$Provider$Membership$Meta$BillDateRecord = F3(function(editable, min, values) {
        return {
            Ot: editable,
            Uj: min,
            pc: values
        };
    });
    var $author$project$Api$Provider$Membership$Meta$billDateRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'values', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$list($author$project$Utils$Date$decode)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$BillDateRecord))));
    var $author$project$Api$Provider$Membership$Meta$ContractEndDateRecord = F3(function(editable, _default, values) {
        return {
            Nn: _default,
            Ot: editable,
            pc: values
        };
    });
    var $author$project$Api$Provider$Membership$Meta$contractEndDateRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'values', $elm$json$Json$Decode$list($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ContractEndDateRecord))));
    var $author$project$Api$Provider$Membership$Meta$ContractTypeRecord = F2(function(editable, values) {
        return {
            Ot: editable,
            pc: values
        };
    });
    var $author$project$Api$Provider$Membership$Meta$contractTypeRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'values', $elm$json$Json$Decode$list($author$project$Api$ContractType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$ContractTypeRecord)));
    var $author$project$Api$Provider$Membership$Meta$EditableRecord = function(editable) {
        return {
            Ot: editable
        };
    };
    var $author$project$Api$Provider$Membership$Meta$editableRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$EditableRecord));
    var $author$project$Api$Provider$Membership$Meta$EndDateRecord = F5(function(sponsoredMinWithoutProration, sponsoredMaxWithoutBilling, sponsoredMin, defaultValue, retailValues) {
        return {
            NE: defaultValue,
            Y$: retailValues,
            _X: sponsoredMaxWithoutBilling,
            _Y: sponsoredMin,
            _Z: sponsoredMinWithoutProration
        };
    });
    var $author$project$Api$Provider$Membership$Meta$endDateRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'retail_values', $elm$json$Json$Decode$list($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_value', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsored_min', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsored_max_without_billing', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsored_min_without_proration', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$EndDateRecord))))));
    var $author$project$Api$Provider$Membership$Meta$MembershipPatientsRecord = F5(function(patient, enrollmentRequestedOn, startDate, specialRate, fixedPeriodRateInCents) {
        return {
            O_: enrollmentRequestedOn,
            PP: fixedPeriodRateInCents,
            V7: patient,
            _L: specialRate,
            _0: startDate
        };
    });
    var $author$project$Api$Provider$Membership$Meta$membershipPatientsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_period_rate_in_cents', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'special_rate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enrollment_requested_on', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$MembershipPatientsRecord))))));
    var $author$project$Api$Provider$Membership$Meta$NextBillDateRecord = F3(function(editable, min, max) {
        return {
            Ot: editable,
            y_: max,
            Uj: min
        };
    });
    var $author$project$Api$Provider$Membership$Meta$nextBillDateRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$NextBillDateRecord))));
    var $author$project$Api$Provider$Membership$Meta$StartDateRecord = F3(function(editable, min, max) {
        return {
            Ot: editable,
            y_: max,
            Uj: min
        };
    });
    var $author$project$Api$Provider$Membership$Meta$startDateRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'editable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$StartDateRecord))));
    var $author$project$Api$Provider$Membership$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_source', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'recurring_charges', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray([
        'membership_patients',
        'max_count'
    ]), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_scheduled_change', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_type', $author$project$Api$Provider$Membership$Meta$contractTypeRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_period_in_months', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_end_date', $author$project$Api$Provider$Membership$Meta$contractEndDateRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_expires', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_period_rate_in_cents', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_registration_fee_in_cents', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'coupon', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $author$project$Api$Provider$Membership$Meta$endDateRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_patients', $author$project$Api$Provider$Membership$Meta$membershipPatientsRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_enrollment_period_in_months', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_renew', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_bill_date', $author$project$Api$Provider$Membership$Meta$nextBillDateRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_date', $author$project$Api$Provider$Membership$Meta$billDateRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Api$Provider$Membership$Meta$startDateRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $author$project$Api$Provider$Membership$Meta$editableRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Provider$Membership$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Meta$Record)))))))))))))))))))))));
    var $author$project$Api$Provider$Membership$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Membership$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Membership$Source$Record = function(id) {
        return function(type_) {
            return function(name) {
                return function(lastFour) {
                    return function(status) {
                        return function(funding) {
                            return function(expMonth) {
                                return function(expYear) {
                                    return function(zip) {
                                        return function(paymentProcessor) {
                                            return {
                                                adz: expMonth,
                                                adA: expYear,
                                                P1: funding,
                                                aef: id,
                                                ST: lastFour,
                                                zr: name,
                                                Wo: paymentProcessor,
                                                ahy: status,
                                                ah5: type_,
                                                tK: zip
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Membership$Source$Source = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Membership$Source$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'zip', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'exp_year', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'exp_month', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'funding', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_four', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$Source$Record))))))))))));
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$MembershipBill = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$MembershipBill$Shared$MembershipBill = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipBill$Shared$Record = F8(function(startDate, date, amountInCents, registrationFeeInCents, couponDiscountInCents, membershipAmountInCents, periodInMonths, couponDiscountMonths) {
        return {
            Jh: amountInCents,
            Mk: couponDiscountInCents,
            Ml: couponDiscountMonths,
            M4: date,
            TZ: membershipAmountInCents,
            WA: periodInMonths,
            Yt: registrationFeeInCents,
            _0: startDate
        };
    });
    var $author$project$Api$Provider$MembershipBill$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'coupon_discount_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'coupon_discount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registration_fee_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$Shared$Record)))))))));
    var $author$project$Api$Provider$MembershipBill$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipBill$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$Record = F2(function(invoice, charges) {
        return {
            K9: charges,
            RA: invoice
        };
    });
    var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$MembershipBillCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$Record = F3(function(amountInCents, name, quantity) {
        return {
            Jh: amountInCents,
            zr: name,
            Bu: quantity
        };
    });
    var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$Record))));
    var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charges', $elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipOne$Record)));
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipBill$ForMembershipOne$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipBill$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipOne$MembershipBill)));
    var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$MembershipBill = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$Record = function(periodInMonths) {
        return {
            WA: periodInMonths
        };
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$Record));
    var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$MembershipContract$Shared$MembershipContract = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipContract$Shared$Record = F4(function(startDate, endDate, memo, isUpcoming) {
        return {
            qv: endDate,
            Sy: isUpcoming,
            ae0: memo,
            _0: startDate
        };
    });
    var $author$project$Api$Provider$MembershipContract$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_upcoming', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'memo', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipContract$Shared$Record)))));
    var $author$project$Api$Provider$MembershipContract$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipContract$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$MembershipPatient = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$MembershipPatient$Shared$MembershipPatient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipPatient$Shared$Record = F8(function(id, startDate, endDate, effectiveEndDate, enrollmentRequestedOn, firstBillStartDate, status, membership) {
        return {
            Ox: effectiveEndDate,
            qv: endDate,
            O_: enrollmentRequestedOn,
            PL: firstBillStartDate,
            aef: id,
            jc: membership,
            _0: startDate,
            ahy: status
        };
    });
    var $author$project$Api$Provider$MembershipPatient$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership', $author$project$Api$Provider$Membership$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_bill_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enrollment_requested_on', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'effective_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$Shared$Record)))))))));
    var $author$project$Api$Provider$MembershipPatient$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipPatient$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$Record = function(revenueInCents) {
        return function(fixedPeriodRateInCents) {
            return function(memberType) {
                return function(patient) {
                    return function(companyRegistration) {
                        return function(cancellationReason) {
                            return function(cancellationReasonOther) {
                                return function(specialRate) {
                                    return function(rateRule) {
                                        return function(discountRule) {
                                            return {
                                                ab9: cancellationReason,
                                                aca: cancellationReasonOther,
                                                LP: companyRegistration,
                                                N1: discountRule,
                                                PP: fixedPeriodRateInCents,
                                                TX: memberType,
                                                V7: patient,
                                                X7: rateRule,
                                                Y1: revenueInCents,
                                                _L: specialRate
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$MemberRelationship$Child = 2;
    var $author$project$Api$MemberRelationship$Employee = 0;
    var $author$project$Api$MemberRelationship$Other = 3;
    var $author$project$Api$MemberRelationship$Spouse = 1;
    var $author$project$Api$MemberRelationship$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'employee':
                return $elm$json$Json$Decode$succeed(0);
            case 'spouse':
                return $elm$json$Json$Decode$succeed(1);
            case 'child':
                return $elm$json$Json$Decode$succeed(2);
            case 'other':
                return $elm$json$Json$Decode$succeed(3);
            default:
                return $elm$json$Json$Decode$fail('Unsupported member relationship: ' + string);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$CompanyRegistration$Meta$CompanyRegistration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyRegistration$Meta$Record = function(meta) {
        return {
            Ue: meta
        };
    };
    var $author$project$Api$Provider$CompanyRegistration$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Meta$CompanyRegistration$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$Meta$Record));
    var $author$project$Api$Provider$CompanyRegistration$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$DiscountRule$Min$DiscountRule = $elm$core$Basics$identity;
    var $author$project$Api$Provider$DiscountRule$Min$Record = function(name) {
        return {
            zr: name
        };
    };
    var $author$project$Api$Provider$DiscountRule$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$DiscountRule$Min$Record));
    var $author$project$Api$Provider$DiscountRule$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$DiscountRule$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SpecialRate$Min$SpecialRate = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SpecialRate$Min$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$SpecialRate$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SpecialRate$Min$Record));
    var $author$project$Api$Provider$SpecialRate$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SpecialRate$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discount_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$DiscountRule$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rate_rule', $elm$json$Json$Decode$nullable($author$project$Api$Provider$RateRule$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'special_rate', $elm$json$Json$Decode$nullable($author$project$Api$Provider$SpecialRate$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancellation_reason_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancellation_reason', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CancellationReason$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_registration', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyRegistration$Meta$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'member_type', $author$project$Api$MemberRelationship$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_period_rate_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'revenue_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForMembershipOne$Record)))))))))));
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipPatient$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForMembershipOne$MembershipPatient)));
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$MembershipScheduledChange = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$Record = F6(function(type_, id, effectiveDate, changeAfterMonths, changeOnDate, toPlan) {
        return {
            K2: changeAfterMonths,
            K3: changeOnDate,
            Ow: effectiveDate,
            aef: id,
            $5: toPlan,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'change_on_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'change_after_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'effective_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Provider$MembershipScheduledChange$Type$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipScheduledChange$Shared$Record)))))));
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipScheduledChange$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$Plan = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$Record = F3(function(contractExpires, contractPeriodInMonths, contractType) {
        return {
            L5: contractExpires,
            L6: contractPeriodInMonths,
            EW: contractType
        };
    });
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_type', $elm$json$Json$Decode$nullable($author$project$Api$ContractType$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_expires', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$SharedWithContractInfo$Record))));
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$SharedWithContractInfo$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Plan$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Plan$SharedWithContractInfo$Plan)));
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$RecurringCharge = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$RecurringCharge$Shared$RecurringCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$RecurringCharge$Shared$Record = function(id) {
        return function(name) {
            return function(periodsMax) {
                return function(periodInMonths) {
                    return function(periodsRemaining) {
                        return function(quantity) {
                            return function(fixedDescription) {
                                return function(fixedPriceInCents) {
                                    return function(startDate) {
                                        return function(nextBillDate) {
                                            return {
                                                adS: fixedDescription,
                                                adT: fixedPriceInCents,
                                                aef: id,
                                                zr: name,
                                                UY: nextBillDate,
                                                WA: periodInMonths,
                                                WC: periodsMax,
                                                agb: periodsRemaining,
                                                Bu: quantity,
                                                _0: startDate
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_price_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fixed_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'periods_remaining', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'periods_max', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$Shared$Record)))))))))));
    var $author$project$Api$Provider$RecurringCharge$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RecurringCharge$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$Record = F4(function(patient, chargeItem, practitioner, uom) {
        return {
            lv: chargeItem,
            V7: patient,
            agi: practitioner,
            aaK: uom
        };
    });
    var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$ChargeItem = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$Record = F2(function(description, priceInCents) {
        return {
            NQ: description,
            Br: priceInCents
        };
    });
    var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForRecurringCharge$Record)));
    var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$ForRecurringCharge$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeItem$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeItem$ForRecurringCharge$ChargeItem)));
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uom', $author$project$Api$Provider$Uom$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_item', $author$project$Api$Provider$ChargeItem$ForRecurringCharge$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$ForMembershipOne$Record)))));
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RecurringCharge$ForMembershipOne$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$RecurringCharge$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$RecurringCharge$ForMembershipOne$RecurringCharge)));
    var $author$project$Api$Provider$Membership$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'source', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Membership$Source$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Provider$Membership$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'recurring_charges', $elm$json$Json$Decode$list($author$project$Api$Provider$RecurringCharge$ForMembershipOne$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_contract', $elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipContract$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_contract', $elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipContract$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'scheduled_change', $elm$json$Json$Decode$nullable($author$project$Api$Provider$MembershipScheduledChange$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancellation_reason_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancellation_reason', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CancellationReason$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'broker_deals', $elm$json$Json$Decode$list($author$project$Api$Provider$BrokerDeal$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'coupon', $elm$json$Json$Decode$nullable($author$project$Api$Common$Coupon$Shared$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_account', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyAccount$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'prepay_options', $elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'upcoming_and_outstanding_bills', $elm$json$Json$Decode$list($author$project$Api$Provider$MembershipBill$ForMembershipOne$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_synced', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'never_been_billed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'final_billing_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contract_period_in_months', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'revenue_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_renew', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'should_be_billed_up_to_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_confirmable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_cancellable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_rate_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billed_through_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_patients', $elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForMembershipOne$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Plan$SharedWithContractInfo$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$One$Record)))))))))))))))))))))))))))))))));
    var $author$project$Api$Provider$Membership$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Membership$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Membership$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$One$Membership)));
    var $author$project$Api$Provider$Membership$membershipsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'memberships'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Membership$membershipPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Membership$membershipsPath);
    };
    var $author$project$Api$Provider$Membership$addBrokerDeal = F4(function(apiClient, id, brokerDeals, toMsg) {
        var encodeBrokerDeal = function(brokerDeal) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, brokerDeal.aef)),
                _Utils_Tuple2('bill_from', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, brokerDeal.abY)),
                _Utils_Tuple2('broker', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, brokerDeal.vQ))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('membership', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('broker_deals', A2($elm$json$Json$Encode$list, encodeBrokerDeal, brokerDeals))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipPath(id))));
    });
    var $author$project$Api$Provider$Membership$One$brokerDeals = function(_v0) {
        var record = _v0.b;
        return record.Kq;
    };
    var $author$project$Components$BrokerDeal$CreateModal$updateMembership = F3(function(apiClient, membership, validFormFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        var brokerDeals = _Utils_ap(A2($elm$core$List$map, function(brokerDeal) {
            return {
                abY: $elm$core$Maybe$Nothing,
                vQ: $elm$core$Maybe$Just($author$project$Api$Provider$Broker$Shared$id($author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal))),
                aef: $elm$core$Maybe$Just($author$project$Api$Provider$BrokerDeal$One$id(brokerDeal))
            };
        }, $author$project$Api$Provider$Membership$One$brokerDeals(membership)), _List_fromArray([
            {
                abY: fields.abY,
                vQ: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, fields.vQ),
                aef: $elm$core$Maybe$Nothing
            }
        ]));
        return A4($author$project$Api$Provider$Membership$addBrokerDeal, apiClient, $author$project$Api$Provider$Membership$One$id(membership), brokerDeals, $author$project$Components$BrokerDeal$CreateModal$Updated);
    });
    var $author$project$Components$BrokerDeal$CreateModal$create = F2(function(apiClient, validFormFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        var dealType = _v0.Nk;
        var membership = _v0.jc;
        var _v1 = _Utils_Tuple2(dealType, membership);
        if (!_v1.a) {
            var _v2 = _v1.a;
            return A2($author$project$Components$BrokerDeal$CreateModal$createBrokerDeal, apiClient, validFormFields);
        } else if (!_v1.b.$) {
            var _v3 = _v1.a;
            var membership_ = _v1.b.a;
            return A3($author$project$Components$BrokerDeal$CreateModal$updateMembership, apiClient, membership_, validFormFields);
        } else {
            var _v4 = _v1.a;
            var _v5 = _v1.b;
            return $elm$core$Platform$Cmd$none;
        }
    });
    var $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var pricingStructure = field.a;
                return _Utils_update(fields, {
                    Xq: pricingStructure
                });
            case 1:
                var dealType = field.a;
                return _Utils_update(fields, {
                    Nk: dealType
                });
            case 2:
                var company = field.a;
                return _Utils_update(fields, {
                    acy: company
                });
            case 3:
                var broker = field.a;
                return _Utils_update(fields, {
                    vQ: broker
                });
            case 4:
                var patient = field.a;
                return _Utils_update(fields, {
                    V7: patient
                });
            case 5:
                var membershipId = field.a;
                var membership = field.b;
                return _Utils_update(fields, {
                    jc: membership,
                    y0: membershipId
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    abY: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Components$BrokerDeal$CreateModal$BrokerValidation = 2;
    var $author$project$Components$BrokerDeal$CreateModal$CompanyValidation = 1;
    var $author$project$Components$BrokerDeal$CreateModal$validateCompany = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Nk, fields.acy);
        if (!_v0.a) {
            if (_v0.b.$ === 1) {
                var _v1 = _v0.a;
                var _v2 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(1, 'Please select an employer.')
                ]);
            } else {
                var _v3 = _v0.a;
                return _List_Nil;
            }
        } else {
            var _v4 = _v0.a;
            return _List_Nil;
        }
    };
    var $author$project$Components$BrokerDeal$CreateModal$MembershipValidation = 3;
    var $author$project$Api$Provider$Membership$Shared$isSponsored = function(_v0) {
        var record = _v0;
        return record.Sr;
    };
    var $author$project$Api$Provider$Membership$One$isSponsored = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$isSponsored(shared);
    };
    var $author$project$Components$BrokerDeal$CreateModal$validateMembership = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Nk, fields.jc);
        if (_v0.a === 1) {
            if (!_v0.b.$) {
                var _v1 = _v0.a;
                var membership = _v0.b.a;
                return $author$project$Api$Provider$Membership$One$isSponsored(membership) ? _List_fromArray([
                    _Utils_Tuple2(3, 'This is an employer sponsored membership that is not eligible for retail commission tracking. You can assign a broker to an employer by changing the category above to \"Employer\".')
                ]) : _List_Nil;
            } else {
                var _v2 = _v0.a;
                return _List_Nil;
            }
        } else {
            var _v3 = _v0.a;
            return _List_Nil;
        }
    };
    var $author$project$Components$BrokerDeal$CreateModal$PatientValidation = 4;
    var $author$project$Components$BrokerDeal$CreateModal$validatePatient = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Nk, fields.V7);
        if (_v0.a === 1) {
            if (_v0.b.$ === 1) {
                var _v1 = _v0.a;
                var _v2 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(4, 'Please select a patient.')
                ]);
            } else {
                var _v3 = _v0.a;
                var patient = _v0.b.a;
                return patient.T5 === 'inactive' ? _List_fromArray([
                    _Utils_Tuple2(4, 'Inactive membership (You can\'t assign broker to this patient).')
                ]) : _List_Nil;
            }
        } else {
            var _v4 = _v0.a;
            return _List_Nil;
        }
    };
    var $author$project$Components$BrokerDeal$CreateModal$PricingStructureValidation = 0;
    var $author$project$Components$BrokerDeal$CreateModal$validatePricingStructure = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Nk, fields.Xq);
        if (!_v0.a) {
            if (_v0.b.$ === 1) {
                var _v1 = _v0.a;
                var _v2 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(0, 'Please select a broker commission rate.')
                ]);
            } else {
                var _v3 = _v0.a;
                return _List_Nil;
            }
        } else {
            var _v4 = _v0.a;
            return _List_Nil;
        }
    };
    var $author$project$Components$BrokerDeal$CreateModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validatePatient),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validateMembership),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.vQ;
        }, _Utils_Tuple2(2, 'Please select a broker.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validateCompany),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$CreateModal$validatePricingStructure)
    ]));
    var $author$project$Api$Provider$Membership$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientAll$membership = function(_v0) {
        var record = _v0;
        return record.jc;
    };
    var $author$project$Api$Provider$Patient$All$membershipPatients = function(_v0) {
        var record = _v0.b;
        return record.T$;
    };
    var $author$project$Components$BrokerDeal$CreateModal$patientFromAll = function(patient) {
        return {
            aef: $author$project$Api$Provider$Patient$All$id(patient),
            T5: $author$project$Api$Provider$Patient$All$membershipStatus(patient)
        };
    };
    var $author$project$Api$Provider$Membership$expandToString = function(expand) {
        return 'coverage_plan';
    };
    var $author$project$Api$Provider$Membership$retrieve = F4(function(apiClient, id_, expand, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipPath(id_))));
    });
    var $author$project$Api$Provider$MembershipPatient$ForPatientAll$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Components$PricingStructureSelect$None = {
        $: 0
    };
    var $author$project$Components$PricingStructureSelect$Selected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$PricingStructure$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$PricingStructure$All$description = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PricingStructure$Shared$description(shared);
    };
    var $author$project$Api$Provider$PricingStructure$All$fixedAmountInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(shared);
    };
    var $author$project$Api$Provider$PricingStructure$All$percentage = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PricingStructure$Shared$percentage(shared);
    };
    var $author$project$Api$Provider$PricingStructure$All$pricingType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PricingStructure$Shared$pricingType(shared);
    };
    var $author$project$Api$Provider$PricingStructure$Shared$splitType = function(_v0) {
        var record = _v0;
        return record.ahu;
    };
    var $author$project$Api$Provider$PricingStructure$All$splitType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PricingStructure$Shared$splitType(shared);
    };
    var $author$project$Components$PricingStructureSelect$existingPricingStructure = F2(function(pricingStructure, id) {
        return {
            NQ: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$description, pricingStructure),
            adR: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$fixedAmountInCents, pricingStructure)),
            aef: id,
            af9: A2($elm$core$Maybe$map, $author$project$Percentage$fromFloat, A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$percentage, pricingStructure)),
            agn: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$pricingType, pricingStructure),
            ahu: A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$splitType, pricingStructure)
        };
    });
    var $author$project$Api$Provider$PricingStructure$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PricingStructure$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PricingStructure$Shared$id(shared);
    };
    var $author$project$Components$PricingStructureSelect$newPricingStructure = {
        NQ: $elm$core$Maybe$Nothing,
        adR: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        af9: $elm$core$Maybe$Nothing,
        agn: $elm$core$Maybe$Just($author$project$Api$PricingType$Percentage),
        ahu: $elm$core$Maybe$Just(0)
    };
    var $author$project$Components$PricingStructureSelect$updateNewPricingStructureField = F2(function(pricingStructure, field) {
        switch(field.$){
            case 0:
                var pricingType = field.a;
                return _Utils_update(pricingStructure, {
                    agn: $elm$core$Maybe$Just(pricingType)
                });
            case 1:
                var splitType = field.a;
                return _Utils_update(pricingStructure, {
                    ahu: $elm$core$Maybe$Just(splitType)
                });
            case 2:
                var _int = field.a;
                return _Utils_update(pricingStructure, {
                    adR: _int
                });
            default:
                var _float = field.a;
                return _Utils_update(pricingStructure, {
                    af9: _float
                });
        }
    });
    var $author$project$Components$PricingStructureSelect$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.lZ);
                var dropdownFilter = _v1.a;
                var cmd = _v1.b;
                return {
                    EQ: cmd,
                    adu: $author$project$Components$PricingStructureSelect$None,
                    zi: _Utils_update(model, {
                        lZ: dropdownFilter
                    }),
                    at: _List_Nil
                };
            case 1:
                var pricingStructureId = msg.a;
                var _v2 = function() {
                    if (_Utils_eq(pricingStructureId, $elm$core$Maybe$Just(''))) return _Utils_Tuple2(true, $author$project$Components$PricingStructureSelect$Selected($elm$core$Maybe$Just($author$project$Components$PricingStructureSelect$newPricingStructure)));
                    else {
                        var pricingStructure = A2($elm_community$list_extra$List$Extra$find, function(item) {
                            return _Utils_eq($elm$core$Maybe$Just($author$project$Api$Provider$PricingStructure$All$id(item)), pricingStructureId);
                        }, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.si)));
                        return _Utils_Tuple2(false, $author$project$Components$PricingStructureSelect$Selected($elm$core$Maybe$Just(A2($author$project$Components$PricingStructureSelect$existingPricingStructure, pricingStructure, pricingStructureId))));
                    }
                }();
                var addingNew = _v2.a;
                var event = _v2.b;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: event,
                    zi: _Utils_update(model, {
                        hp: addingNew
                    }),
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$PricingStructureSelect$None,
                    zi: _Utils_update(model, {
                        si: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var pricingStructure = msg.a;
                var field = msg.b;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$PricingStructureSelect$Selected($elm$core$Maybe$Just(A2($author$project$Components$PricingStructureSelect$updateNewPricingStructureField, pricingStructure, field))),
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$BrokerDeal$CreateModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$BrokerDeal$CreateModal$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    return {
                        EQ: A2($author$project$Components$BrokerDeal$CreateModal$create, apiClient, validFormFields),
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            o2: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker commission successfully created')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 3,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker commission successfully created')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var subMsg = msg.a;
                var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.nI);
                var form = function() {
                    var _v6 = pricingStructureSelectResult.adu;
                    if (!_v6.$) return model.PU;
                    else {
                        var pricingStructure = _v6.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, $author$project$Components$BrokerDeal$CreateModal$PricingStructure(pricingStructure), model.PU);
                    }
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg, pricingStructureSelectResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: form,
                        nI: pricingStructureSelectResult.zi
                    }),
                    at: pricingStructureSelectResult.at
                };
            case 5:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 6:
                var subMsg = msg.a;
                var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pY);
                var newForm = function() {
                    var _v7 = companyResourceResult.adu;
                    _v7$2: while(true){
                        if (!_v7.$ && !_v7.a.$) switch(_v7.a.a.$){
                            case 0:
                                var company = _v7.a.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, $author$project$Components$BrokerDeal$CreateModal$CompanyField($elm$core$Maybe$Just($author$project$Components$BrokerDeal$CreateModal$All(company))), model.PU);
                            case 2:
                                var _v8 = _v7.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, $author$project$Components$BrokerDeal$CreateModal$CompanyField($elm$core$Maybe$Nothing), model.PU);
                            default:
                                break _v7$2;
                        }
                        else break _v7$2;
                    }
                    return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg, companyResourceResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        pY: companyResourceResult.zi,
                        PU: newForm
                    }),
                    at: companyResourceResult.at
                };
            case 7:
                var subMsg = msg.a;
                var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.lj);
                var newForm = function() {
                    var _v9 = brokerResourceResult.adu;
                    _v9$2: while(true){
                        if (!_v9.$ && !_v9.a.$) switch(_v9.a.a.$){
                            case 0:
                                var broker = _v9.a.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, $author$project$Components$BrokerDeal$CreateModal$Broker($elm$core$Maybe$Just(broker)), model.PU);
                            case 2:
                                var _v10 = _v9.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, $author$project$Components$BrokerDeal$CreateModal$Broker($elm$core$Maybe$Nothing), model.PU);
                            default:
                                break _v9$2;
                        }
                        else break _v9$2;
                    }
                    return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg, brokerResourceResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        lj: brokerResourceResult.zi,
                        PU: newForm
                    }),
                    at: brokerResourceResult.at
                };
            case 8:
                var subMsg = msg.a;
                var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rX);
                var _v11 = function() {
                    var _v12 = patientResourceResult.adu;
                    _v12$2: while(true){
                        if (!_v12.$ && !_v12.a.$) switch(_v12.a.a.$){
                            case 0:
                                var patient = _v12.a.a.a;
                                var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, $author$project$Components$BrokerDeal$CreateModal$Patient($elm$core$Maybe$Just($author$project$Components$BrokerDeal$CreateModal$patientFromAll(patient))), model.PU);
                                var membershipPatients = $author$project$Api$Provider$Patient$All$membershipPatients(patient);
                                var membershipId = A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$Min$id, A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForPatientAll$membership, A2($elm_community$list_extra$List$Extra$find, function(membershipPatient_) {
                                    return _Utils_eq($author$project$Api$Provider$MembershipPatient$ForPatientAll$status(membershipPatient_), $author$project$Api$Provider$Patient$All$membershipStatus(patient));
                                }, membershipPatients)));
                                return _Utils_Tuple2(A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, A2($author$project$Components$BrokerDeal$CreateModal$MembershipField, membershipId, $elm$core$Maybe$Nothing), newForm_), function() {
                                    if (!membershipId.$) {
                                        var id = membershipId.a;
                                        return A4($author$project$Api$Provider$Membership$retrieve, apiClient, id, _List_Nil, $author$project$Components$BrokerDeal$CreateModal$GotMembership(id));
                                    } else return $elm$core$Platform$Cmd$none;
                                }());
                            case 2:
                                var _v14 = _v12.a.a;
                                return _Utils_Tuple2(A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, A2($author$project$Components$BrokerDeal$CreateModal$MembershipField, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, $author$project$Components$BrokerDeal$CreateModal$Patient($elm$core$Maybe$Nothing), model.PU)), $elm$core$Platform$Cmd$none);
                            default:
                                break _v12$2;
                        }
                        else break _v12$2;
                    }
                    return _Utils_Tuple2(model.PU, $elm$core$Platform$Cmd$none);
                }();
                var newForm = _v11.a;
                var cmd = _v11.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg, patientResourceResult.EQ),
                        cmd
                    ])),
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm,
                        rX: patientResourceResult.zi
                    }),
                    at: patientResourceResult.at
                };
            default:
                var membershipId = msg.a;
                var response = msg.b;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$CreateModal$formFieldsUpdate, A2($author$project$Components$BrokerDeal$CreateModal$MembershipField, $elm$core$Maybe$Just(membershipId), $author$project$Api$Data$toMaybe(response)), model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$BrokerDeal$Table$BrokerDealDeleted = 1;
    var $author$project$Components$BrokerDeal$Table$BrokerDealEnded = 3;
    var $author$project$Components$BrokerDeal$Table$BrokerDealRateCanceled = 4;
    var $author$project$Components$BrokerDeal$Table$BrokerDealRateCreated = 5;
    var $author$project$Components$BrokerDeal$Table$BrokerDealRateUpdated = 6;
    var $author$project$Components$BrokerDeal$Table$BrokerDealRestarted = 2;
    var $author$project$Components$BrokerDeal$Table$None = 0;
    var $author$project$Components$BrokerDeal$Timeline$BrokerDealDeleted = 1;
    var $author$project$Components$BrokerDeal$Timeline$BrokerDealEnded = 3;
    var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateCanceled = 4;
    var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateCreated = 5;
    var $author$project$Components$BrokerDeal$Timeline$BrokerDealRateUpdated = 6;
    var $author$project$Components$BrokerDeal$Timeline$BrokerDealRestarted = 2;
    var $author$project$Components$BrokerDeal$Timeline$Canceled = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Components$BrokerDeal$Timeline$Deleted = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$Timeline$None = 0;
    var $author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'broker_deal_rates'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$BrokerDealRate$brokerDealRatePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath);
    };
    var $author$project$Api$Provider$BrokerDealRate$One$BrokerDealRate = 0;
    var $author$project$Api$Provider$BrokerDealRate$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$BrokerDealRate$cancel = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BrokerDealRate$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel'
        ]), $author$project$Api$Provider$BrokerDealRate$brokerDealRatePath(id_))));
    });
    var $author$project$Api$Provider$BrokerDeal$brokerDealPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$BrokerDeal$brokerDealsPath);
    };
    var $author$project$Api$Provider$BrokerDeal$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDeal$brokerDealPath(id_)));
    });
    var $author$project$Api$Provider$BrokerDealRate$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerDealRate$Shared$id(shared);
    };
    var $author$project$Components$BrokerDeal$EndModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$BrokerDealRate$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerDealRate$Shared$endDate(shared);
    };
    var $author$project$Components$BrokerDeal$EndModal$initFormFields = function(brokerDeal) {
        var endDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate, $elm$core$List$head(brokerDeal.X8));
        var _v0 = $author$project$Components$DateInput$init;
        var endDateDateInput = _v0.a;
        var endDateDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            qv: endDate,
            qw: endDateDateInput
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg(endDateDateInput), endDateDateInputCmd));
    };
    var $author$project$Components$BrokerDeal$EndModal$init = F4(function(session, currentDate, options, brokerDeal) {
        var _v0 = $author$project$Components$BrokerDeal$EndModal$initFormFields(brokerDeal);
        var fields = _v0.a;
        var fieldsCmd = _v0.b;
        return _Utils_Tuple2({
            Kp: brokerDeal,
            v4: options.v4,
            cP: currentDate,
            PU: $author$project$Utils$Form$init(fields),
            Z$: session,
            o2: $author$project$Api$Data$NotAsked
        }, fieldsCmd);
    });
    var $author$project$Components$BrokerDeal$RestartModal$init = F2(function(session, brokerDeal) {
        return {
            Kp: brokerDeal,
            sy: $author$project$Api$Data$NotAsked,
            Z$: session
        };
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$BrokerDealRate$Shared$pricingStructure = function(_v0) {
        var record = _v0;
        return record.Xq;
    };
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$pricingStructure = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerDealRate$Shared$pricingStructure(shared);
    };
    var $author$project$Api$Provider$BrokerDealRate$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerDealRate$Shared$startDate(shared);
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$initFormFields = F2(function(brokerDeal, brokerDealRate) {
        var startDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate, $elm$core$List$head(brokerDeal.X8));
        var pricingStructure = $elm$core$Maybe$Just(A2($author$project$Components$PricingStructureSelect$existingPricingStructure, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$Shared$id, A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$pricingStructure, brokerDealRate))));
        var _v0 = $author$project$Components$DateInput$init;
        var startDateDateInput = _v0.a;
        var startDateDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            Xq: pricingStructure,
            _0: startDate,
            s3: startDateDateInput
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg(startDateDateInput), startDateDateInputCmd));
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$init = F5(function(apiClient, session, currentDate, brokerDeal, brokerDealRate) {
        var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
        var pricingStructureSelect = _v0.a;
        var pricingStructureSelectCmd = _v0.b;
        var _v1 = A2($author$project$Components$BrokerDealRate$CreateUpdateModal$initFormFields, brokerDeal, brokerDealRate);
        var fields = _v1.a;
        var fieldsCmd = _v1.b;
        return _Utils_Tuple2({
            Kp: brokerDeal,
            EB: brokerDealRate,
            cP: currentDate,
            PU: $author$project$Utils$Form$init(fields),
            nI: pricingStructureSelect,
            Z$: session,
            o2: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            fieldsCmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg, pricingStructureSelectCmd)
        ])));
    });
    var $author$project$Components$BrokerDeal$EndModal$BrokerDealEnded = 2;
    var $author$project$Components$BrokerDeal$EndModal$Closed = 1;
    var $author$project$Components$BrokerDeal$EndModal$EndDate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$BrokerDeal$EndModal$Ended = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$EndModal$None = 0;
    var $author$project$Api$Provider$BrokerDeal$end = F4(function(apiClient, id_, endDate_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker_deal', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('end_date', $author$project$Utils$Date$encode(endDate_))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BrokerDeal$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'end'
        ]), $author$project$Api$Provider$BrokerDeal$brokerDealPath(id_)))));
    });
    var $author$project$Components$BrokerDeal$EndModal$EndDateValidation = 0;
    var $author$project$Components$BrokerDeal$EndModal$validateEndDate = F2(function(currentDate, fields) {
        var _v0 = fields.qv;
        if (!_v0.$) {
            var endDate = _v0.a;
            var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
            return A2($justinmimbs$date$Date$compare, yesterdayDate, endDate) !== 2 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2(0, 'Please enter a date.')
        ]);
    });
    var $author$project$Components$BrokerDeal$EndModal$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDeal$EndModal$validateEndDate(currentDate))
        ]));
    };
    var $author$project$Components$BrokerDeal$EndModal$formFieldsUpdate = F2(function(field, fields) {
        var dateInput = field.a;
        var date = field.b;
        return _Utils_update(fields, {
            qv: date,
            qw: dateInput
        });
    });
    var $author$project$Components$BrokerDeal$EndModal$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$EndModal$formFieldsUpdate, A2(field, newDateInput, date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDeal$EndModal$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.PU);
            }
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd),
            adu: 0,
            zi: _Utils_update(model, {
                PU: newForm
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$BrokerDeal$EndModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$BrokerDeal$EndModal$formFieldsValidator(model.cP), model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var endDate = _v4.qv;
                    return {
                        EQ: A4($author$project$Api$Provider$BrokerDeal$end, apiClient, model.Kp.aef, A2($elm$core$Maybe$withDefault, model.cP, endDate), $author$project$Components$BrokerDeal$EndModal$Ended),
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            o2: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully ended')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Components$BrokerDeal$EndModal$updateDateInputFormField, model, dateInput, subMsg, $author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg, $author$project$Components$BrokerDeal$EndModal$EndDate, function($) {
                    return $.qv;
                });
        }
    });
    var $author$project$Components$BrokerDeal$RestartModal$BrokerDealRestarted = 2;
    var $author$project$Components$BrokerDeal$RestartModal$Closed = 1;
    var $author$project$Components$BrokerDeal$RestartModal$None = 0;
    var $author$project$Components$BrokerDeal$RestartModal$Restarted = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$BrokerDeal$restart = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BrokerDeal$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'restart'
        ]), $author$project$Api$Provider$BrokerDeal$brokerDealPath(id_))));
    });
    var $author$project$Components$BrokerDeal$RestartModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                return {
                    EQ: A3($author$project$Api$Provider$BrokerDeal$restart, apiClient, model.Kp.aef, $author$project$Components$BrokerDeal$RestartModal$Restarted),
                    adu: 0,
                    zi: _Utils_update(model, {
                        sy: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully restarted')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        sy: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$BrokerDealRateCreated = 3;
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$BrokerDealRateUpdated = 2;
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$Closed = 1;
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$None = 0;
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructure = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var dateInput = field.a;
            var date = field.b;
            return _Utils_update(fields, {
                _0: date,
                s3: dateInput
            });
        } else {
            var pricingStructure = field.a;
            return _Utils_update(fields, {
                Xq: pricingStructure
            });
        }
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureValidation = 1;
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$validatePricingStructure = function(fields) {
        var _v0 = fields.Xq;
        if (!_v0.$) {
            var pricingStructure = _v0.a;
            var _v1 = pricingStructure.aef;
            if (!_v1.$) return _List_Nil;
            else {
                var _v2 = _Utils_Tuple3(pricingStructure.agn, pricingStructure.af9, pricingStructure.adR);
                _v2$2: while(true){
                    if (!_v2.a.$) switch(_v2.a.a.$){
                        case 0:
                            if (_v2.b.$ === 1) {
                                var _v3 = _v2.a.a;
                                var _v4 = _v2.b;
                                return _List_fromArray([
                                    _Utils_Tuple2(1, 'Please enter a number')
                                ]);
                            } else break _v2$2;
                        case 1:
                            if (_v2.c.$ === 1) {
                                var _v5 = _v2.a.a;
                                var _v6 = _v2.c;
                                return _List_fromArray([
                                    _Utils_Tuple2(1, 'Please enter an amount')
                                ]);
                            } else break _v2$2;
                        default:
                            break _v2$2;
                    }
                    else break _v2$2;
                }
                return _List_Nil;
            }
        } else return _List_fromArray([
            _Utils_Tuple2(1, 'Please pick or create a rate.')
        ]);
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateValidation = 0;
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$validateStartDate = F2(function(currentDate, fields) {
        var _v0 = fields._0;
        if (!_v0.$) {
            var startDate = _v0.a;
            var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
            return A2($justinmimbs$date$Date$compare, yesterdayDate, startDate) !== 2 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a date greater or equal than yesterday')
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2(0, 'Please enter a date.')
        ]);
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDealRate$CreateUpdateModal$validateStartDate(currentDate)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$BrokerDealRate$CreateUpdateModal$validatePricingStructure)
        ]));
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$Updated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$apiFields = F2(function(brokerDeal, formFields) {
        return {
            Kp: brokerDeal.aef,
            Xq: formFields.Xq,
            _0: formFields._0
        };
    });
    var $author$project$Api$Provider$BrokerDealRate$create = F3(function(apiClient, fields, toMsg) {
        var pricingStructure_ = function() {
            var _v0 = fields.Xq;
            if (_v0.$ === 1) return _List_Nil;
            else {
                var pricingStructure__ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('pricing_structure', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                        function() {
                            var _v1 = pricingStructure__.aef;
                            if (!_v1.$) {
                                var string = _v1.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(string))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v2 = pricingStructure__.NQ;
                            if (!_v2.$) {
                                var string = _v2.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('description', $elm$json$Json$Encode$string(string))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v3 = pricingStructure__.adR;
                            if (!_v3.$) {
                                var _int = _v3.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('fixed_amount_in_cents', $author$project$Currency$encode(_int))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v4 = pricingStructure__.af9;
                            if (!_v4.$) {
                                var _float = _v4.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('percentage', $author$project$Percentage$encode(_float))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v5 = pricingStructure__.ahu;
                            if (!_v5.$) {
                                var splitType = _v5.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('split_type', $author$project$Api$SplitType$encode(splitType))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v6 = pricingStructure__.agn;
                            if (!_v6.$) {
                                var pricingType_ = _v6.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('pricing_type', $author$project$Api$PricingType$encode(pricingType_))
                                ]);
                            } else return _List_Nil;
                        }()
                    ]))))
                ]);
            }
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('rate', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('broker_deal', $author$project$Utils$Encode$association(fields.Kp)), A2($elm$core$List$cons, _Utils_Tuple2('start_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields._0)), pricingStructure_))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BrokerDealRate$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDealRate$brokerDealRatesPath)));
    });
    var $author$project$Api$Provider$BrokerDealRate$update = F4(function(apiClient, id_, fields, toMsg) {
        var pricingStructure_ = function() {
            var _v0 = fields.Xq;
            if (_v0.$ === 1) return _List_Nil;
            else {
                var pricingStructure__ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('pricing_structure', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                        function() {
                            var _v1 = pricingStructure__.aef;
                            if (!_v1.$) {
                                var string = _v1.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(string))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v2 = pricingStructure__.NQ;
                            if (!_v2.$) {
                                var string = _v2.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('description', $elm$json$Json$Encode$string(string))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v3 = pricingStructure__.adR;
                            if (!_v3.$) {
                                var _int = _v3.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('fixed_amount_in_cents', $author$project$Currency$encode(_int))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v4 = pricingStructure__.af9;
                            if (!_v4.$) {
                                var _float = _v4.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('percentage', $author$project$Percentage$encode(_float))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v5 = pricingStructure__.ahu;
                            if (!_v5.$) {
                                var splitType = _v5.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('split_type', $author$project$Api$SplitType$encode(splitType))
                                ]);
                            } else return _List_Nil;
                        }(),
                        function() {
                            var _v6 = pricingStructure__.agn;
                            if (!_v6.$) {
                                var pricingType_ = _v6.a;
                                return _List_fromArray([
                                    _Utils_Tuple2('pricing_type', $author$project$Api$PricingType$encode(pricingType_))
                                ]);
                            } else return _List_Nil;
                        }()
                    ]))))
                ]);
            }
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('rate', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('broker_deal', $author$project$Utils$Encode$association(fields.Kp)), A2($elm$core$List$cons, _Utils_Tuple2('start_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields._0)), pricingStructure_))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$BrokerDealRate$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerDealRate$brokerDealRatePath(id_))));
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$save = F4(function(apiClient, brokerDeal, brokerDealRate, validFormFields) {
        var apiFields_ = A2($author$project$Components$BrokerDealRate$CreateUpdateModal$apiFields, brokerDeal, $rtfeldman$elm_validate$Validate$fromValid(validFormFields));
        if (!brokerDealRate.$) {
            var brokerDealRate_ = brokerDealRate.a;
            return A4($author$project$Api$Provider$BrokerDealRate$update, apiClient, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id(brokerDealRate_), apiFields_, $author$project$Components$BrokerDealRate$CreateUpdateModal$Updated);
        } else return A3($author$project$Api$Provider$BrokerDealRate$create, apiClient, apiFields_, $author$project$Components$BrokerDealRate$CreateUpdateModal$Created);
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate, A2(field, newDateInput, date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.PU);
            }
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd),
            adu: 0,
            zi: _Utils_update(model, {
                PU: newForm
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsValidator(model.cP), model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    return {
                        EQ: A4($author$project$Components$BrokerDealRate$CreateUpdateModal$save, apiClient, model.Kp, model.EB, validFormFields),
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            o2: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 3,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker deal rate successfully added')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker deal rate successfully updated')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        o2: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Components$BrokerDealRate$CreateUpdateModal$updateDateInputFormField, model, dateInput, subMsg, $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg, $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDate, function($) {
                    return $._0;
                });
            default:
                var subMsg = msg.a;
                var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.nI);
                var form = function() {
                    var _v6 = pricingStructureSelectResult.adu;
                    if (!_v6.$) return model.PU;
                    else {
                        var pricingStructure = _v6.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$BrokerDealRate$CreateUpdateModal$formFieldsUpdate, $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructure(pricingStructure), model.PU);
                    }
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg, pricingStructureSelectResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: form,
                        nI: pricingStructureSelectResult.zi
                    }),
                    at: pricingStructureSelectResult.at
                };
        }
    });
    var $author$project$Components$BrokerDeal$Timeline$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
                    }),
                    at: _List_Nil
                };
            case 1:
                var confirmed = msg.a;
                return confirmed ? {
                    EQ: A3($author$project$Api$Provider$BrokerDeal$delete, apiClient, model.Kp.aef, $author$project$Components$BrokerDeal$Timeline$Deleted),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Nothing
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Broker deal successfully deleted')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just(response)
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var _v2 = A5($author$project$Components$BrokerDealRate$CreateUpdateModal$init, apiClient, model.Z$, model.cP, model.Kp, $elm$core$Maybe$Nothing);
                var brokerDealRateModal = _v2.a;
                var brokerDealRateModalCmd = _v2.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fc: $elm$core$Maybe$Just(brokerDealRateModal)
                    }),
                    at: _List_Nil
                };
            case 4:
                var brokerDealRate = msg.a;
                var _v3 = A5($author$project$Components$BrokerDealRate$CreateUpdateModal$init, apiClient, model.Z$, model.cP, model.Kp, $elm$core$Maybe$Just(brokerDealRate));
                var brokerDealRateModal = _v3.a;
                var brokerDealRateModalCmd = _v3.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fc: $elm$core$Maybe$Just(brokerDealRateModal)
                    }),
                    at: _List_Nil
                };
            case 5:
                var subMsg = msg.a;
                var _v4 = model.fc;
                if (!_v4.$) {
                    var brokerDealRateModal = _v4.a;
                    var brokerDealRateModalResult = A3($author$project$Components$BrokerDealRate$CreateUpdateModal$update, apiClient, subMsg, brokerDealRateModal);
                    var _v5 = function() {
                        var _v6 = brokerDealRateModalResult.adu;
                        switch(_v6){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(brokerDealRateModalResult.zi), 0);
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
                            case 3:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 5);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 6);
                        }
                    }();
                    var brokerDealRateModal_ = _v5.a;
                    var event = _v5.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, brokerDealRateModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            fc: brokerDealRateModal_
                        }),
                        at: brokerDealRateModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var brokerDealRate = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Just(_Utils_Tuple2(brokerDealRate, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 7:
                var brokerDealRate = msg.a;
                var confirmed = msg.b;
                return confirmed ? {
                    EQ: A3($author$project$Api$Provider$BrokerDealRate$cancel, apiClient, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$id(brokerDealRate), $author$project$Components$BrokerDeal$Timeline$Canceled(brokerDealRate)),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Just(_Utils_Tuple2(brokerDealRate, $author$project$Api$Data$Loading))
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 8:
                var brokerDealRate = msg.a;
                var response = msg.b;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 4,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Rate successfully canceled')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Just(_Utils_Tuple2(brokerDealRate, response))
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 9:
                var _v8 = A4($author$project$Components$BrokerDeal$EndModal$init, model.Z$, model.cP, {
                    v4: true
                }, model.Kp);
                var endModal = _v8.a;
                var endModalCmd = _v8.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fH: $elm$core$Maybe$Just(endModal)
                    }),
                    at: _List_Nil
                };
            case 10:
                var _v9 = A4($author$project$Components$BrokerDeal$EndModal$init, model.Z$, model.cP, {
                    v4: false
                }, model.Kp);
                var endModal = _v9.a;
                var endModalCmd = _v9.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fH: $elm$core$Maybe$Just(endModal)
                    }),
                    at: _List_Nil
                };
            case 11:
                var subMsg = msg.a;
                var _v10 = model.fH;
                if (!_v10.$) {
                    var endModal = _v10.a;
                    var endModalResult = A3($author$project$Components$BrokerDeal$EndModal$update, apiClient, subMsg, endModal);
                    var _v11 = function() {
                        var _v12 = endModalResult.adu;
                        switch(_v12){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(endModalResult.zi), 0);
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 3);
                        }
                    }();
                    var endModal_ = _v11.a;
                    var event = _v11.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, endModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            fH: endModal_
                        }),
                        at: endModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 12:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        jU: $elm$core$Maybe$Just(A2($author$project$Components$BrokerDeal$RestartModal$init, model.Z$, model.Kp))
                    }),
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                var _v13 = model.jU;
                if (!_v13.$) {
                    var restartModal = _v13.a;
                    var restartModalResult = A3($author$project$Components$BrokerDeal$RestartModal$update, apiClient, subMsg, restartModal);
                    var _v14 = function() {
                        var _v15 = restartModalResult.adu;
                        switch(_v15){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(restartModalResult.zi), 0);
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 2);
                        }
                    }();
                    var restartModal_ = _v14.a;
                    var event = _v14.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Timeline$RestartModalMsg, restartModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            jU: restartModal_
                        }),
                        at: restartModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$BrokerDeal$Timeline$init = F4(function(session, currentDate, options, brokerDeal) {
        return {
            Kp: brokerDeal,
            fc: $elm$core$Maybe$Nothing,
            fd: $elm$core$Maybe$Nothing,
            cP: currentDate,
            fr: $elm$core$Maybe$Nothing,
            fH: $elm$core$Maybe$Nothing,
            jU: $elm$core$Maybe$Nothing,
            Z$: session,
            ahn: options.ahn
        };
    });
    var $author$project$Components$BrokerDeal$Table$withBrokerDeals = F2(function(brokerDeals, model) {
        return _Utils_update(model, {
            Kq: A2($elm$core$List$indexedMap, F2(function(index, brokerDeal) {
                var showEndedOnTimeline = A2($elm$core$Set$member, index, model.gQ);
                return _Utils_Tuple2(brokerDeal, A4($author$project$Components$BrokerDeal$Timeline$init, model.Z$, model.cP, {
                    ahn: model.l8 || showEndedOnTimeline
                }, brokerDeal));
            }), brokerDeals)
        });
    });
    var $author$project$Components$BrokerDeal$Table$update = F3(function(apiClient, msg, model) {
        if (!msg.$) {
            var index = msg.a;
            return {
                EQ: $elm$core$Platform$Cmd$none,
                adu: 0,
                zi: function(deals) {
                    var showEndedOnTimeline = A2($elm$core$Set$member, index, model.gQ) ? A2($elm$core$Set$remove, index, model.gQ) : A2($elm$core$Set$insert, index, model.gQ);
                    return A2($author$project$Components$BrokerDeal$Table$withBrokerDeals, deals, _Utils_update(model, {
                        gQ: showEndedOnTimeline
                    }));
                }(A2($elm$core$List$map, $elm$core$Tuple$first, model.Kq)),
                at: _List_Nil
            };
        } else {
            var index = msg.a;
            var subMsg = msg.b;
            var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, model.Kq);
            if (!_v1.$) {
                var _v2 = _v1.a;
                var brokerDeal = _v2.a;
                var timeline = _v2.b;
                var timelineResult = A3($author$project$Components$BrokerDeal$Timeline$update, apiClient, subMsg, timeline);
                var event = function() {
                    var _v3 = timelineResult.adu;
                    switch(_v3){
                        case 0:
                            return 0;
                        case 1:
                            return 1;
                        case 2:
                            return 2;
                        case 3:
                            return 3;
                        case 4:
                            return 4;
                        case 5:
                            return 5;
                        default:
                            return 6;
                    }
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$BrokerDeal$Table$TimelineMsg(index), timelineResult.EQ),
                    adu: event,
                    zi: _Utils_update(model, {
                        Kq: A3($elm_community$list_extra$List$Extra$setAt, index, _Utils_Tuple2(brokerDeal, timelineResult.zi), model.Kq)
                    }),
                    at: timelineResult.at
                };
            } else return {
                EQ: $elm$core$Platform$Cmd$none,
                adu: 0,
                zi: model,
                at: _List_Nil
            };
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    vR: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var brokerDeals = response.a;
                    var headers = response.b;
                    var brokerDealsTable = A2($author$project$Components$BrokerDeal$Table$withBrokerDeals, A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals), model.dy);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kq: response,
                        dy: brokerDealsTable,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Kq: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.Ej, subMsg, model.dy);
                var _v2 = function() {
                    var _v3 = brokerDealsTableResult.adu;
                    switch(_v3){
                        case 0:
                            return _Utils_Tuple2(model.Kq, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
                        case 2:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
                        case 3:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
                        case 4:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
                        case 5:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
                        default:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
                    }
                }();
                var brokerDeals = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    Kq: brokerDeals,
                    dy: brokerDealsTableResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg, brokerDealsTableResult.EQ),
                    cmd
                ])), brokerDealsTableResult.at);
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 5:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.oX);
                var typeDropdown = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oX: typeDropdown
                }), cmd, _List_Nil);
            case 6:
                var selectedType = msg.a;
                var newModel = _Utils_update(model, {
                    Kq: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ah5: selectedType
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 7:
                var subMsg = msg.a;
                var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, model.Ej, subMsg, model.lj);
                var brokerId = function() {
                    var _v6 = brokerResourceResult.adu;
                    if (!_v6.$) {
                        if (!_v6.a.$) return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.zi);
                        else {
                            var _v7 = _v6.a;
                            return model.EC;
                        }
                    } else return model.EC;
                }();
                var newModel = _Utils_update(model, {
                    EC: brokerId,
                    lj: brokerResourceResult.zi
                });
                var _v5 = _Utils_eq(model.EC, newModel.EC) ? _Utils_Tuple2(model.Kq, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var brokerDeals = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    Kq: brokerDeals
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg, brokerResourceResult.EQ),
                    cmd
                ])), brokerResourceResult.at);
            case 4:
                var subMsg = msg.a;
                var _v8 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v8.a;
                var searchInputCmd = _v8.b;
                var searchInputEvent = _v8.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v9 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            Kq: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(qModel),
                            A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                        ])));
                    }
                }();
                var newModel = _v9.a;
                var cmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 8:
                var brokerAccount = msg.a;
                var _v11 = A5($author$project$Components$BrokerDeal$CreateModal$init, model.Ej, model.Z$, model.cP, model.HP, {
                    vQ: $elm$core$Maybe$Nothing,
                    vR: $elm$core$Maybe$Just($author$project$Api$Provider$BrokerAccount$One$id(brokerAccount)),
                    LG: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.W1),
                    acy: $elm$core$Maybe$Nothing,
                    Nk: 0,
                    jc: $elm$core$Maybe$Nothing,
                    agX: $author$project$Api$Provider$BrokerAccount$One$retailEnabled(brokerAccount)
                });
                var createModal = _v11.a;
                var createModalCmd = _v11.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    h$: $elm$core$Maybe$Just(createModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg, createModalCmd), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v12 = model.h$;
                if (!_v12.$) {
                    var createModal = _v12.a;
                    var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, model.Ej, subMsg, createModal);
                    var _v13 = function() {
                        var _v14 = createModalResult.adu;
                        switch(_v14){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createModalResult.zi), model.Kq, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Kq, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$fetchBrokerDeals(model));
                        }
                    }();
                    var createModal_ = _v13.a;
                    var brokerDeals = _v13.b;
                    var cmd = _v13.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kq: brokerDeals,
                        h$: createModal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg, createModalResult.EQ),
                        cmd
                    ])), createModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Create = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$PaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$Table$loading = $author$project$Ui$Table$loading;
    var $author$project$Components$BrokerDeal$EndModal$End = {
        $: 0
    };
    var $author$project$Components$BrokerDeal$EndModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$BrokerDeal$EndModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(model.v4 ? 'Edit Employer Deal' : 'End Employer Deal')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$EndModal$End),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Employer name'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.Kp.acy)))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Broker name'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$Broker$Shared$name(model.Kp.vQ))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Date'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$BrokerDeal$EndModal$EndDateDateInputMsg(fields.qw), A2($author$project$Components$DateInput$view, _List_fromArray([
                            $author$project$Components$DateInput$value(fields.qv),
                            $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                        ]), fields.qw)),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            $elm$html$Html$text('Ending this employer deal will stop commissions from being calculated on the date specified.'),
                            $elm$html$Html$text(' If any future calculations exist they will be removed or reversed.')
                        ]))
                    ]))
                ])),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$EndModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'End broker deal'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.o2, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$EndModal$End)
                ]), _List_fromArray([
                    $elm$html$Html$text('End')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$BrokerDeal$RestartModal$Restart = {
        $: 0
    };
    var $author$project$Api$Provider$BrokerDealRate$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerDealRate$Shared$description(shared);
    };
    var $author$project$Components$BrokerDeal$RestartModal$view = function(model) {
        var rateDescription = A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description, $elm$core$List$head(model.Kp.X8));
        return A3($author$project$Ui$Modal$view, $author$project$Components$BrokerDeal$RestartModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Restart employer deal')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$RestartModal$Restart),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Employer name'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.Kp.acy)))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Rate'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', rateDescription))
                        ])),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            $elm$html$Html$text('Restarting this broker on this deal will create all missing commission calculations'),
                            $elm$html$Html$text(' for the entire life of the deal.')
                        ]))
                    ]))
                ])),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$RestartModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Restart broker deal'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.sy, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$RestartModal$Restart)
                ]), _List_fromArray([
                    $elm$html$Html$text('Restart')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$Save = {
        $: 0
    };
    var $author$project$Components$PricingStructureSelect$Errors = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$errors = $author$project$Components$PricingStructureSelect$Errors;
    var $author$project$Components$PricingStructureSelect$Invalid = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$invalid = $author$project$Components$PricingStructureSelect$Invalid;
    var $author$project$Components$PricingStructureSelect$Value = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$value = $author$project$Components$PricingStructureSelect$Value;
    var $author$project$Components$PricingStructureSelect$defaultOptions = {
        fK: _List_Nil,
        mz: 8,
        q2: false,
        mQ: 4,
        aa9: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$PricingStructureSelect$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var span = option.a;
                    return _Utils_update(record, {
                        mQ: span
                    });
                case 1:
                    var span = option.a;
                    return _Utils_update(record, {
                        mz: span
                    });
                case 2:
                    var string = option.a;
                    return _Utils_update(record, {
                        aa9: string
                    });
                case 3:
                    var bool = option.a;
                    return _Utils_update(record, {
                        q2: bool
                    });
                default:
                    var list = option.a;
                    return _Utils_update(record, {
                        fK: list
                    });
            }
        }), $author$project$Components$PricingStructureSelect$defaultOptions, options);
    };
    var $author$project$Components$PricingStructureSelect$NewPricingStructureUpdated = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PricingStructureSelect$SplitType = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$viewSplitTypeButton = F3(function(pricingStructure, splitType, label) {
        var currentSplitType = A2($elm$core$Maybe$withDefault, 0, pricingStructure.ahu);
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentSplitType, splitType)),
            $author$project$Ui$Button$onClick(A2($author$project$Components$PricingStructureSelect$NewPricingStructureUpdated, pricingStructure, $author$project$Components$PricingStructureSelect$SplitType(splitType)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$PricingStructureSelect$viewCommissionType = F3(function(optionsRecord, model, value_) {
        return model.hp ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Commission Type'),
            $author$project$Ui$Form$Group$labelSpan(optionsRecord.mQ),
            $author$project$Ui$Form$Group$inputSpan(optionsRecord.mz)
        ]), _List_fromArray([
            $author$project$Ui$Button$group(_List_fromArray([
                A3($author$project$Components$PricingStructureSelect$viewSplitTypeButton, value_, 0, 'All members'),
                A3($author$project$Components$PricingStructureSelect$viewSplitTypeButton, value_, 1, 'Primary member')
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$PricingStructureSelect$PricingStructureSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$viewRateDropdown = F4(function(optionsRecord, model, loadingPricingStructures, pricingStructures) {
        var currentSelection = model.hp ? $elm$core$Maybe$Just('') : A2($elm$core$Maybe$andThen, function($) {
            return $.aef;
        }, optionsRecord.aa9);
        var items = function() {
            if (loadingPricingStructures) return _List_fromArray([
                A2($author$project$Ui$Dropdown$item, _List_Nil, $elm$html$Html$text('Loading...'))
            ]);
            else {
                var addNewItem = A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$PricingStructureSelect$PricingStructureSelected($elm$core$Maybe$Just(''))),
                    $author$project$Ui$Dropdown$selected(_Utils_eq(currentSelection, $elm$core$Maybe$Just('')))
                ]), $elm$html$Html$text('Add new commission rate'));
                if ($elm$core$List$isEmpty(pricingStructures)) return _List_fromArray([
                    addNewItem
                ]);
                else {
                    var pricingStructureItems = A2($elm$core$List$map, function(ps) {
                        return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$PricingStructureSelect$PricingStructureSelected($elm$core$Maybe$Just($author$project$Api$Provider$PricingStructure$All$id(ps)))),
                            $author$project$Ui$Dropdown$selected(_Utils_eq(currentSelection, $elm$core$Maybe$Just($author$project$Api$Provider$PricingStructure$All$id(ps))))
                        ]), $elm$html$Html$text($author$project$Api$Provider$PricingStructure$All$description(ps)));
                    }, pricingStructures);
                    return A2($elm$core$List$cons, addNewItem, A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, pricingStructureItems));
                }
            }
        }();
        var currentLabel = function() {
            if (!currentSelection.$) {
                if (currentSelection.a === '') return 'Add new commission rate';
                else {
                    var id = currentSelection.a;
                    return A2($elm$core$Maybe$withDefault, 'Choose broker commission rate', A2($elm$core$Maybe$map, $author$project$Api$Provider$PricingStructure$All$description, A2($elm_community$list_extra$List$Extra$find, function(ps) {
                        return _Utils_eq($author$project$Api$Provider$PricingStructure$All$id(ps), id);
                    }, pricingStructures)));
                }
            } else return 'Choose broker commission rate';
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Rate'),
            $author$project$Ui$Form$Group$labelSpan(optionsRecord.mQ),
            $author$project$Ui$Form$Group$inputSpan(optionsRecord.mz),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                $elm$html$Html$text(currentLabel)
            ]), items, model.lZ),
            !model.hp ? $author$project$Utils$FormErrors$view(optionsRecord.fK) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$PricingStructureSelect$FixedAmountInCents = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$Percentage = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$PricingType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$viewPricingTypeButton = F3(function(pricingStructure, pricingType, label) {
        var currentPricingType = A2($elm$core$Maybe$withDefault, $author$project$Api$PricingType$Percentage, pricingStructure.agn);
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$styled(_Utils_eq(currentPricingType, pricingType) ? 1 : 0),
            $author$project$Ui$Button$onClick(A2($author$project$Components$PricingStructureSelect$NewPricingStructureUpdated, pricingStructure, $author$project$Components$PricingStructureSelect$PricingType(pricingType)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$PricingStructureSelect$viewRetailRate = F3(function(optionsRecord, model, value_) {
        return model.hp ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Retail Rate'),
            $author$project$Ui$Form$Group$labelSpan(optionsRecord.mQ),
            $author$project$Ui$Form$Group$inputSpan(optionsRecord.mz),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mr2
                ]), _List_fromArray([
                    $author$project$Ui$Button$group(_List_fromArray([
                        A3($author$project$Components$PricingStructureSelect$viewPricingTypeButton, value_, $author$project$Api$PricingType$FixedAmountInCents, '$'),
                        A3($author$project$Components$PricingStructureSelect$viewPricingTypeButton, value_, $author$project$Api$PricingType$Percentage, '%')
                    ]))
                ])),
                _Utils_eq(value_.agn, $elm$core$Maybe$Just($author$project$Api$PricingType$FixedAmountInCents)) ? $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$value(value_.adR),
                    $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$PricingStructureSelect$NewPricingStructureUpdated(value_), $author$project$Components$PricingStructureSelect$FixedAmountInCents)),
                    $author$project$Ui$Form$CurrencyInput$invalid(optionsRecord.q2),
                    $author$project$Ui$Form$CurrencyInput$placeholder('10.00')
                ])) : $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                    $author$project$Ui$Form$PercentageInput$value(value_.af9),
                    $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$PricingStructureSelect$NewPricingStructureUpdated(value_), $author$project$Components$PricingStructureSelect$Percentage)),
                    $author$project$Ui$Form$PercentageInput$invalid(optionsRecord.q2),
                    $author$project$Ui$Form$PercentageInput$placeholder('10')
                ]))
            ])),
            $author$project$Utils$FormErrors$view(optionsRecord.fK)
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$PricingStructureSelect$view = F2(function(options, model) {
        var optionsRecord = $author$project$Components$PricingStructureSelect$optionsToRecord(options);
        var value_ = A2($elm$core$Maybe$withDefault, $author$project$Components$PricingStructureSelect$newPricingStructure, optionsRecord.aa9);
        var _v0 = function() {
            var _v1 = model.si;
            if (_v1.$ === 3) {
                var pricingStructures_ = _v1.a;
                return _Utils_Tuple2(false, pricingStructures_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loadingPricingStructures = _v0.a;
        var pricingStructures = _v0.b;
        return _List_fromArray([
            A4($author$project$Components$PricingStructureSelect$viewRateDropdown, optionsRecord, model, loadingPricingStructures, pricingStructures),
            A3($author$project$Components$PricingStructureSelect$viewCommissionType, optionsRecord, model, value_),
            A3($author$project$Components$PricingStructureSelect$viewRetailRate, optionsRecord, model, value_)
        ]);
    });
    var $author$project$Components$BrokerDealRate$CreateUpdateModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$BrokerDealRate$CreateUpdateModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Change employer deal')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$BrokerDealRate$CreateUpdateModal$Save),
                    $author$project$Ui$Form$horizontal
                ]), $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Employer name'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, model.Kp.acy)))
                            ]))
                        ]))
                    ]),
                    A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$BrokerDealRate$CreateUpdateModal$PricingStructureSelectMsg), A2($author$project$Components$PricingStructureSelect$view, _List_fromArray([
                        $author$project$Components$PricingStructureSelect$value(fields.Xq),
                        $author$project$Components$PricingStructureSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                        $author$project$Components$PricingStructureSelect$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                    ]), model.nI)),
                    _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Date'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$BrokerDealRate$CreateUpdateModal$StartDateDateInputMsg(fields.s3), A2($author$project$Components$DateInput$view, _List_fromArray([
                                $author$project$Components$DateInput$value(fields._0),
                                $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                                $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                            ]), fields.s3)),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock
                            ]), _List_fromArray([
                                $elm$html$Html$text('Change the broker\'s rate will update all commission calculations starting on the date specified.')
                            ]))
                        ])),
                        $author$project$Ui$Clearfix$view
                    ])
                ])))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDealRate$CreateUpdateModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Change broker deal rate'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.o2, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDealRate$CreateUpdateModal$Save)
                ]), _List_fromArray([
                    $elm$html$Html$text('Change Rate')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$BrokerDeal$Timeline$modal = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.fr;
                if (!_v0.$) {
                    var deleteRequest = _v0.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$BrokerDeal$Timeline$DeleteHiConfirmClosed, _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('broker deal'),
                        $author$project$Components$HiConfirm$detail(model.Kp.Nj + (' - ' + ($author$project$Api$Provider$Broker$Shared$name(model.Kp.vQ) + ' and remove it from all existing invoices'))),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v1 = model.fd;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var brokerDealRate = _v2.a;
                    var cancelRequest = _v2.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$BrokerDeal$Timeline$CancelHiConfirmClosed(brokerDealRate), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('cancel'),
                        $author$project$Components$HiConfirm$noun('broker deal rate'),
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('Are you sure you want to cancel this rate?')
                        ])),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.jU;
                if (!_v3.$) {
                    var restartModal = _v3.a;
                    return A2($elm$html$Html$map, $author$project$Components$BrokerDeal$Timeline$RestartModalMsg, $author$project$Components$BrokerDeal$RestartModal$view(restartModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v4 = model.fH;
                if (!_v4.$) {
                    var endModal = _v4.a;
                    return A2($elm$html$Html$map, $author$project$Components$BrokerDeal$Timeline$EndModalMsg, $author$project$Components$BrokerDeal$EndModal$view(endModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.fc;
                if (!_v5.$) {
                    var brokerDealRateModal = _v5.a;
                    return A2($elm$html$Html$map, $author$project$Components$BrokerDeal$Timeline$BrokerDealRateModalMsg, $author$project$Components$BrokerDealRate$CreateUpdateModal$view(brokerDealRateModal));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$BrokerDeal$Table$modal = function(model) {
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$indexedMap, F2(function(index, _v0) {
            var timeline = _v0.b;
            return A2($elm$html$Html$map, $author$project$Components$BrokerDeal$Table$TimelineMsg(index), $author$project$Components$BrokerDeal$Timeline$modal(timeline));
        }), model.Kq));
    };
    var $author$project$Components$BrokerDeal$CreateModal$BillFrom = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$Create = {
        $: 0
    };
    var $author$project$Components$BrokerDeal$CreateModal$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$Membership = 1;
    var $elm_community$list_extra$List$Extra$maximumBy = F2(function(f, ls) {
        var maxBy = F2(function(x, _v1) {
            var y = _v1.a;
            var fy = _v1.b;
            var fx = f(x);
            return _Utils_cmp(fx, fy) > 0 ? _Utils_Tuple2(x, fx) : _Utils_Tuple2(y, fy);
        });
        if (ls.b) {
            if (!ls.b.b) {
                var l_ = ls.a;
                return $elm$core$Maybe$Just(l_);
            } else {
                var l_ = ls.a;
                var ls_ = ls.b;
                return $elm$core$Maybe$Just(A3($elm$core$List$foldl, maxBy, _Utils_Tuple2(l_, f(l_)), ls_).a);
            }
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$BrokerDeal$CreateModal$billFromDates = F3(function(currentDate, commissionsTrackingFrom, dealStartDate) {
        var startMonth = A2($justinmimbs$date$Date$floor, 2, currentDate);
        var dealDate = A2($elm$core$Maybe$map, $justinmimbs$date$Date$floor(2), dealStartDate);
        var commissionDate = A2($elm$core$Maybe$map, $justinmimbs$date$Date$floor(2), commissionsTrackingFrom);
        var allTimeDate = A2($justinmimbs$date$Date$floor, 2, A3($justinmimbs$date$Date$add, 1, -9, currentDate));
        var maxDate = A2($elm_community$list_extra$List$Extra$maximumBy, $justinmimbs$date$Date$toRataDie, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $elm$core$Maybe$Just(allTimeDate),
            commissionDate,
            dealDate
        ])));
        var dateDuration = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, A2($justinmimbs$date$Date$diff, 1, currentDate), maxDate));
        return A2($elm$core$List$map, function(index) {
            return A3($justinmimbs$date$Date$add, 1, index, startMonth);
        }, $elm$core$List$reverse(A2($elm$core$List$range, dateDuration + 1, 0)));
    });
    var $author$project$Components$BrokerDeal$CreateModal$billFromOptions = F3(function(currentDate, commissionsTrackingFrom, dealStartDate) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Start of the deal'), A2($elm$core$List$map, function(billFrom) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Utils$Date$toIsoString(billFrom)), A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, billFrom));
        }, A3($author$project$Components$BrokerDeal$CreateModal$billFromDates, currentDate, commissionsTrackingFrom, dealStartDate)));
    });
    var $author$project$Api$Provider$Company$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Company$All$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$Company$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$createdAt(shared);
    };
    var $author$project$Components$BrokerDeal$CreateModal$companyCreatedAt = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$createdAt(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$All$createdAt(company_);
        }
    };
    var $author$project$Components$PricingStructureSelect$InputGrid = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$inputSpan = $author$project$Components$PricingStructureSelect$InputGrid;
    var $author$project$Components$PricingStructureSelect$LabelGrid = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PricingStructureSelect$labelSpan = $author$project$Components$PricingStructureSelect$LabelGrid;
    var $author$project$Api$Provider$Membership$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$Membership$One$startDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$startDate(shared);
    };
    var $author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter = F2(function(brokerResourceFilter, form) {
        return A2($elm$html$Html$map, $author$project$Components$BrokerDeal$CreateModal$BrokerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
        ]), brokerResourceFilter));
    });
    var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths = function(_v0) {
        var record = _v0;
        return record.aet;
    };
    var $author$project$Api$Provider$RatePeriodSchedule$Shared$intervals = function(_v0) {
        var record = _v0;
        return record.aeu;
    };
    var $author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule = function(_v0) {
        var record = _v0;
        return record.X6;
    };
    var $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure = function(_v0) {
        var record = _v0;
        return record.Xq;
    };
    var $author$project$Components$BrokerDeal$CreateModal$viewInterval = F3(function(intervals, index, interval) {
        var previous = A2($elm_community$list_extra$List$Extra$getAt, index - 1, intervals);
        return A2($elm$html$Html$li, _List_fromArray([
            $elm$html$Html$Attributes$class('timeline__item')
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$margin(2)
            ]), function() {
                if (previous.$ === 1) return _List_fromArray([
                    $elm$html$Html$text('Start of the deal')
                ]);
                else {
                    var previous_ = previous.a;
                    return _List_fromArray([
                        $elm$html$Html$text('After '),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths(previous_)))),
                        $elm$html$Html$text(' months')
                    ]);
                }
            }()),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$PricingStructure$Shared$description($author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure(interval)))
            ]))
        ]));
    });
    var $author$project$Components$BrokerDeal$CreateModal$viewBrokerTimeline = function(broker) {
        var intervals = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$RatePeriodSchedule$Shared$intervals, $author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule($author$project$Api$Provider$Broker$All$brokerAccount(broker))));
        return A2($elm$html$Html$ul, _List_fromArray([
            $elm$html$Html$Attributes$class('timeline')
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$indexedMap, $author$project$Components$BrokerDeal$CreateModal$viewInterval(intervals), intervals),
            _List_fromArray([
                A2($elm$html$Html$li, _List_fromArray([
                    $elm$html$Html$Attributes$class('timeline__item')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$margin(2)
                    ]), function() {
                        var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths, $elm_community$list_extra$List$Extra$last(intervals));
                        if (_v0.$ === 1) return _List_fromArray([
                            $elm$html$Html$text('Recurring Deal')
                        ]);
                        else {
                            var intervalInMonths = _v0.a;
                            return _List_fromArray([
                                $elm$html$Html$text($elm$core$String$fromInt(intervalInMonths)),
                                $elm$html$Html$text(' months')
                            ]);
                        }
                    }())
                ]))
            ])
        ])));
    };
    var $author$project$Components$BrokerDeal$CreateModal$viewCompanyResourceFilter = F2(function(companyResourceFilter, form) {
        return A2($elm$html$Html$map, $author$project$Components$BrokerDeal$CreateModal$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
        ]), companyResourceFilter));
    });
    var $author$project$Components$BrokerDeal$CreateModal$DealType = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton = F3(function(currentDealType, dealType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select deal type ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentDealType, dealType)),
            $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$CreateModal$FormUpdated($author$project$Components$BrokerDeal$CreateModal$DealType(dealType)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Api$Provider$Membership$One$membershipPatients = function(_v0) {
        var record = _v0.b;
        return record.T$;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Api$Provider$Membership$One$plan = function(_v0) {
        var record = _v0.b;
        return record.GW;
    };
    var $author$project$Components$BrokerDeal$CreateModal$viewMembership = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var membership = _v0.jc;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('Membership ')
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$gray
                ]), _List_fromArray([
                    function() {
                        if (!membership.$) {
                            var membership_ = membership.a;
                            return $elm$html$Html$text($author$project$Api$Provider$Plan$SharedWithContractInfo$name($author$project$Api$Provider$Membership$One$plan(membership_)));
                        } else return $author$project$Ui$Spinner$view(_List_fromArray([
                            $author$project$Ui$Spinner$extraSmall
                        ]));
                    }()
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('Members ')
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$gray
                ]), _List_fromArray([
                    function() {
                        if (!membership.$) {
                            var membership_ = membership.a;
                            return $elm$html$Html$text($author$project$Formatters$String$toSentence(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name), $author$project$Api$Provider$Membership$One$membershipPatients(membership_))));
                        } else return $author$project$Ui$Spinner$view(_List_fromArray([
                            $author$project$Ui$Spinner$extraSmall
                        ]));
                    }()
                ]))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 3, form))
        ]));
    };
    var $author$project$Components$BrokerDeal$CreateModal$viewPatientResourceFilter = F2(function(patientResourceFilter, form) {
        return A2($elm$html$Html$map, $author$project$Components$BrokerDeal$CreateModal$PatientResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 4, form))
        ]), patientResourceFilter));
    });
    var $author$project$Components$BrokerDeal$CreateModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        var dealStartDate = function() {
            var _v6 = _Utils_Tuple3(fields.Nk, fields.acy, fields.jc);
            _v6$2: while(true)if (!_v6.a) {
                if (!_v6.b.$) {
                    var _v7 = _v6.a;
                    var company = _v6.b.a;
                    return $elm$core$Maybe$Just(A2($justinmimbs$date$Date$fromPosix, model.HP, $author$project$Components$BrokerDeal$CreateModal$companyCreatedAt(company)));
                } else break _v6$2;
            } else {
                if (!_v6.c.$) {
                    var _v8 = _v6.a;
                    var membership = _v6.c.a;
                    return $elm$core$Maybe$Just($author$project$Api$Provider$Membership$One$startDate(membership));
                } else break _v6$2;
            }
            return $elm$core$Maybe$Nothing;
        }();
        return A3($author$project$Ui$Modal$view, $author$project$Components$BrokerDeal$CreateModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Create deal')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$BrokerDeal$CreateModal$Create),
                    $author$project$Ui$Form$horizontal
                ]), $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        function() {
                            var _v1 = _Utils_Tuple2(model.agX, model.acy);
                            if (_v1.a && _v1.b.$ === 1) {
                                var _v2 = _v1.b;
                                return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Deal Category'),
                                    $author$project$Ui$Form$Group$labelSpan(3),
                                    $author$project$Ui$Form$Group$inputSpan(9)
                                ]), _List_fromArray([
                                    $author$project$Ui$Button$group(_List_fromArray([
                                        A3($author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton, fields.Nk, 0, 'Employer'),
                                        A3($author$project$Components$BrokerDeal$CreateModal$viewDealTypeButton, fields.Nk, 1, 'Retail')
                                    ]))
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]),
                    function() {
                        var _v3 = fields.Nk;
                        if (!_v3) return $elm$core$List$concat(_List_fromArray([
                            _List_fromArray([
                                function() {
                                    var _v4 = model.acy;
                                    if (!_v4.$) return $author$project$Utils$Html$empty;
                                    else return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                        $author$project$Ui$Form$Group$label('Employer name'),
                                        $author$project$Ui$Form$Group$labelSpan(3),
                                        $author$project$Ui$Form$Group$inputSpan(9),
                                        $author$project$Ui$Form$Group$required(true)
                                    ]), _List_fromArray([
                                        A2($author$project$Components$BrokerDeal$CreateModal$viewCompanyResourceFilter, model.pY, model.PU)
                                    ]));
                                }(),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Broker'),
                                    $author$project$Ui$Form$Group$labelSpan(3),
                                    $author$project$Ui$Form$Group$inputSpan(9),
                                    $author$project$Ui$Form$Group$required(true)
                                ]), _List_fromArray([
                                    A2($author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter, model.lj, model.PU)
                                ]))
                            ]),
                            A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$BrokerDeal$CreateModal$PricingStructureSelectMsg), A2($author$project$Components$PricingStructureSelect$view, _List_fromArray([
                                $author$project$Components$PricingStructureSelect$value(fields.Xq),
                                $author$project$Components$PricingStructureSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                                $author$project$Components$PricingStructureSelect$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU)),
                                $author$project$Components$PricingStructureSelect$labelSpan(3),
                                $author$project$Components$PricingStructureSelect$inputSpan(9)
                            ]), model.nI))
                        ]));
                        else return _List_fromArray([
                            !fields.xA ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Patient Name'),
                                $author$project$Ui$Form$Group$labelSpan(3),
                                $author$project$Ui$Form$Group$inputSpan(9),
                                $author$project$Ui$Form$Group$required(true)
                            ]), _List_fromArray([
                                A2($author$project$Components$BrokerDeal$CreateModal$viewPatientResourceFilter, model.rX, model.PU)
                            ])) : $author$project$Utils$Html$empty,
                            !fields.xA && $author$project$Utils$Maybe$toBool(fields.y0) ? $author$project$Components$BrokerDeal$CreateModal$viewMembership(model.PU) : $author$project$Utils$Html$empty,
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Broker'),
                                $author$project$Ui$Form$Group$labelSpan(3),
                                $author$project$Ui$Form$Group$inputSpan(9),
                                $author$project$Ui$Form$Group$required(true)
                            ]), _List_fromArray([
                                A2($author$project$Components$BrokerDeal$CreateModal$viewBrokerResourceFilter, model.lj, model.PU)
                            ])),
                            function() {
                                var _v5 = fields.vQ;
                                if (!_v5.$) {
                                    var broker = _v5.a;
                                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                        $author$project$Ui$Form$Group$label('Rate'),
                                        $author$project$Ui$Form$Group$labelSpan(3),
                                        $author$project$Ui$Form$Group$inputSpan(9)
                                    ]), _List_fromArray([
                                        $author$project$Components$BrokerDeal$CreateModal$viewBrokerTimeline(broker)
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]);
                    }(),
                    _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Track From'),
                            $author$project$Ui$Form$Group$labelSpan(3),
                            $author$project$Ui$Form$Group$inputSpan(9)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value(fields.abY),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$BrokerDeal$CreateModal$FormUpdated, $author$project$Components$BrokerDeal$CreateModal$BillFrom))
                            ]), A3($author$project$Components$BrokerDeal$CreateModal$billFromOptions, model.cP, model.LG, dealStartDate))
                        ]))
                    ])
                ]))),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$CreateModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add broker deal'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.o2, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$CreateModal$Create)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$BrokerDeal$Table$tableHeaders = F2(function(fromBrokerAccount, fromCompany) {
        return $elm$core$List$concat(_List_fromArray([
            fromBrokerAccount ? _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('Name')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('Category')
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    fromBrokerAccount ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
                ]), _List_fromArray([
                    $elm$html$Html$text('Broker')
                ]))
            ]),
            fromCompany ? _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(3)
                ]), _List_fromArray([
                    $elm$html$Html$text('Account')
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(6)
                ]), _List_fromArray([
                    $elm$html$Html$text('Rate')
                ]))
            ])
        ]));
    });
    var $author$project$Components$BrokerDeal$Table$ToogleEnded = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$BrokerDeal$Meta$hasEndedRates = function(_v0) {
        var meta = _v0;
        return meta.Qo;
    };
    var $author$project$Components$BrokerDeal$Timeline$AddBrokerDealRate = {
        $: 3
    };
    var $author$project$Components$BrokerDeal$Timeline$AddEndDate = {
        $: 10
    };
    var $author$project$Components$BrokerDeal$Timeline$CancelBrokerDealRate = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$Timeline$Delete = {
        $: 0
    };
    var $author$project$Components$BrokerDeal$Timeline$EditBrokerDealRate = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$Timeline$Restart = {
        $: 12
    };
    var $author$project$Components$BrokerDeal$Timeline$UpdateEndDate = {
        $: 9
    };
    var $author$project$Api$Provider$BrokerDeal$Meta$dateEditable = function(_v0) {
        var meta = _v0;
        return meta.M5;
    };
    var $author$project$Api$Provider$BrokerDeal$Meta$destroyable = function(_v0) {
        var meta = _v0;
        return meta.NV;
    };
    var $author$project$Api$Provider$BrokerDeal$Meta$editable = function(_v0) {
        var meta = _v0;
        return meta.Ot;
    };
    var $author$project$Api$Provider$BrokerDeal$Meta$endable = function(_v0) {
        var meta = _v0;
        return meta.OS;
    };
    var $author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal = function(_v0) {
        var meta = _v0;
        return meta.Qn;
    };
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isFuture = function(_v0) {
        var record = _v0.b;
        return record.R5;
    };
    var $author$project$Api$Provider$BrokerDeal$Meta$isMembershipType = function(_v0) {
        var meta = _v0;
        return meta.Sa;
    };
    var $author$project$Api$Provider$BrokerDeal$Meta$restartable = function(_v0) {
        var meta = _v0;
        return meta.YU;
    };
    var $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isEnded = function(_v0) {
        var record = _v0.b;
        return record.R3;
    };
    var $author$project$Components$BrokerDeal$Timeline$viewRate = F2(function(controls, brokerDealRate) {
        return A2($elm$html$Html$li, _List_fromArray([
            $elm$html$Html$Attributes$class('timeline__item')
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$margin(2)
            ]), _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$startDate(brokerDealRate);
                    if (!_v0.$) {
                        var startDate = _v0.a;
                        return $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate));
                    } else return $elm$html$Html$text('Start of the deal');
                }()
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$description(brokerDealRate)),
                controls(brokerDealRate)
            ]))
        ]));
    });
    var $author$project$Components$BrokerDeal$Timeline$view = F5(function(showEnded, brokerDeal, controls1, controls2, brokerDealRateControls) {
        var rates = $elm$core$List$reverse(A2($elm$core$List$filter, function(rate) {
            return !$author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isEnded(rate) || showEnded;
        }, brokerDeal.X8));
        var meta = brokerDeal.Ue;
        var endDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$endDate, $elm$core$List$head(brokerDeal.X8));
        var hasEndDate = $author$project$Utils$Maybe$toBool(endDate);
        return A2($elm$html$Html$ul, _List_fromArray([
            $elm$html$Html$Attributes$class('timeline')
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Components$BrokerDeal$Timeline$viewRate(brokerDealRateControls), rates),
            hasEndDate || $author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal(meta) ? _List_fromArray([
                A2($elm$html$Html$li, _List_fromArray([
                    $elm$html$Html$Attributes$class('timeline__item timeline__item--error')
                ]), _List_fromArray([
                    function() {
                        if (!endDate.$) {
                            var endDate_ = endDate.a;
                            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('End of deal: '),
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate_))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    controls1
                ]))
            ]) : _List_Nil,
            !hasEndDate ? _List_fromArray([
                A2($elm$html$Html$li, _List_fromArray([
                    $elm$html$Html$Attributes$class('timeline__item')
                ]), _List_fromArray([
                    controls2,
                    $author$project$Api$Provider$BrokerDeal$Meta$isMembershipType(meta) ? A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-muted mb-075')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Recurring Deal')
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]) : _List_Nil
        ])));
    });
    var $author$project$Components$BrokerDeal$Timeline$viewWithControls = function(model) {
        var meta = model.Kp.Ue;
        return A5($author$project$Components$BrokerDeal$Timeline$view, model.ahn, model.Kp, A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$justifyRight,
            $author$project$Ui$Element$gap2
        ]), _List_fromArray([
            $author$project$Api$Provider$BrokerDeal$Meta$dateEditable(meta) ? A3($author$project$Ui$Button$view, {
                abP: 'Change broker deal end date'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$UpdateEndDate),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$calendar)
            ]), _List_fromArray([
                $elm$html$Html$text('Change end date')
            ])) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$BrokerDeal$Meta$restartable(meta) ? A3($author$project$Ui$Button$view, {
                abP: 'Restar broker deal'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$Restart),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
            ]), _List_fromArray([
                $elm$html$Html$text('Restart')
            ])) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$BrokerDeal$Meta$hasEndedDeal(meta) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$gray
            ]), _List_fromArray([
                $author$project$Api$Provider$BrokerDeal$Meta$isMembershipType(meta) ? $elm$html$Html$text('Membership has ended') : $elm$html$Html$text('Employer is inactive')
            ])) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$BrokerDeal$Meta$destroyable(meta) ? A3($author$project$Ui$Button$view, {
                abP: 'Delete broker deal'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$Delete),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete')
            ])) : $author$project$Utils$Html$empty
        ])), A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$gap2
        ]), _List_fromArray([
            $author$project$Api$Provider$BrokerDeal$Meta$editable(meta) ? A3($author$project$Ui$Button$view, {
                abP: 'Add deal rate'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$AddBrokerDealRate),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
            ]), _List_fromArray([
                $elm$html$Html$text('Add Rate Change')
            ])) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$BrokerDeal$Meta$endable(meta) ? A3($author$project$Ui$Button$view, {
                abP: 'Add end date'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$AddEndDate),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
            ]), _List_fromArray([
                $elm$html$Html$text('Add End Date')
            ])) : $author$project$Utils$Html$empty
        ])), function(brokerDealRate) {
            return $author$project$Api$Provider$BrokerDealRate$ForBrokerDealOne$isFuture(brokerDealRate) ? A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit rate'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$EditBrokerDealRate(brokerDealRate)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit Rate Change')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel deal rate change'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Timeline$CancelBrokerDealRate(brokerDealRate)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel Rate Change')
                ]))
            ])) : $author$project$Utils$Html$empty;
        });
    };
    var $author$project$Components$BrokerDeal$Table$viewBrokerDeal = F6(function(ended, fromBrokerAccount, fromCompany, model, index, _v0) {
        var brokerDeal = _v0.a;
        var timeline = _v0.b;
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            fromBrokerAccount ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text(brokerDeal.Nj)
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(brokerDeal.Nk)
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Broker$Shared$name(brokerDeal.vQ))
                ]))
            ]),
            fromCompany ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$BrokerAccount$Shared$name($author$project$Api$Provider$Broker$Shared$brokerAccount(brokerDeal.vQ)))
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    function() {
                        if (!ended && $author$project$Api$Provider$BrokerDeal$Meta$hasEndedRates(brokerDeal.Ue)) {
                            var showEndedOnTimeline = A2($elm$core$Set$member, index, model.gQ);
                            var label = showEndedOnTimeline ? 'Hide expired rates' : 'See expired rates';
                            return A3($author$project$Ui$Button$view, {
                                abP: label
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$size(0),
                                $author$project$Ui$Button$onClick($author$project$Components$BrokerDeal$Table$ToogleEnded(index))
                            ]), _List_fromArray([
                                $elm$html$Html$text(label)
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    A2($elm$html$Html$map, $author$project$Components$BrokerDeal$Table$TimelineMsg(index), $author$project$Components$BrokerDeal$Timeline$viewWithControls(timeline))
                ]))
            ])
        ])));
    });
    var $author$project$Components$BrokerDeal$Table$view = F2(function(options, model) {
        return A4($author$project$Ui$Table$view, A2($elm$core$List$cons, $author$project$Ui$Table$zeroState(_List_fromArray([
            model.l8 ? $elm$html$Html$text('No ended deals.') : $elm$html$Html$text('No deals found.')
        ])), options), A2($author$project$Components$BrokerDeal$Table$tableHeaders, model.qL, model.qM), A2($elm$core$List$indexedMap, A4($author$project$Components$BrokerDeal$Table$viewBrokerDeal, model.l8, model.qL, model.qM, model), model.Kq), _List_Nil);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewBrokerResourceFilter = function(brokerResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_Nil, brokerResourceFilter));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel = function(dealType) {
        if (!dealType) return 'Employer';
        else return 'Retail';
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewTypeDropdown = function(model) {
        var currentLabel = function() {
            var _v0 = model.ah5;
            if (!_v0.$) {
                var dealType = _v0.a;
                return $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel(dealType);
            } else return 'Categories';
        }();
        var allTypes = _List_fromArray([
            0,
            1
        ]);
        var items = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected($elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Categories')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(dealType) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$DealTypeSelected($elm$core$Maybe$Just(dealType)))
            ]), $elm$html$Html$text($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$dealTypeToLabel(dealType)));
        }, allTypes)));
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentLabel)
        ]), items, model.oX);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg, $author$project$Components$BrokerDeal$Table$modal(model.dy)),
                function() {
                    var _v0 = model.h$;
                    if (!_v0.$) {
                        var createModal = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$CreateModalMsg, $author$project$Components$BrokerDeal$CreateModal$view(createModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Active Deals')
                            ])),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals({
                                bS: model.bS
                            }), _List_Nil, _List_fromArray([
                                $elm$html$Html$text('See Ended Deals')
                            ]))
                        ])),
                        $author$project$Ui$Clearfix$view,
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(10)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$gray
                                ]), _List_fromArray([
                                    $elm$html$Html$text('A deal represents the relationship between a broker and their commission. If you need to remove a deal, make sure that it is ended first.')
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                                    $author$project$Ui$SearchInput$placeholder('Search deal')
                                ]), model.sG))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(2)
                            ]), _List_fromArray([
                                $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewBrokerResourceFilter(model.lj)
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(2)
                            ]), _List_fromArray([
                                $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$viewTypeDropdown(model)
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(2)
                            ]), _List_fromArray([
                                function() {
                                    var _v1 = model.vR;
                                    if (_v1.$ === 3) {
                                        var brokerAccount = _v1.a;
                                        return A3($author$project$Ui$Button$view, {
                                            abP: 'Create deal'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                                            $author$project$Ui$Button$onClick($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$Create(brokerAccount))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Create Deal')
                                        ]));
                                    } else return $author$project$Ui$Skeleton$input(_List_Nil);
                                }()
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$BrokerDealsTableMsg, A2($author$project$Components$BrokerDeal$Table$view, _List_fromArray([
                            $author$project$Components$BrokerDeal$Table$loading(!$author$project$Api$Data$isSuccess(model.Kq))
                        ]), model.dy))
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.Kq))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Commissions | Broker Deals'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('broker'), model.EC)
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals({
                bS: model.bS
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$GotBrokerDeals = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals = function(model) {
        return A3($author$project$Api$Provider$BrokerDeal$list, model.Ej, function(d) {
            return _Utils_update(d, {
                vQ: model.EC,
                vR: $elm$core$Maybe$Just(model.bS),
                Q8: $elm$core$Maybe$Just(true),
                af_: model.af_,
                agq: model.agq
            });
        }, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$GotBrokerDeals);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var brokerId = A2($elm$core$Dict$get, 'broker', query);
        var _v1 = A3($author$project$Components$ResourceFilter$Broker$init, shared.Ej, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'All Brokers',
                agj: brokerId
            });
        });
        var brokerResourceFilter = _v1.a;
        var brokerResourceFilterCmd = _v1.b;
        var model = {
            Ej: shared.Ej,
            bS: params.bS,
            Kq: $author$project$Api$Data$Loading,
            dy: A3($author$project$Components$BrokerDeal$Table$init, session, shared.cP, {
                l8: true,
                qL: true,
                qM: false
            }),
            EC: brokerId,
            lj: brokerResourceFilter,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q)
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg, brokerResourceFilterCmd),
            $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model),
            A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            dy: A2($author$project$Components$BrokerDeal$Table$load, shared.cP, model.dy)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$subscriptions = function(_v0) {
        var brokerDealsTable = _v0.dy;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg, $author$project$Components$BrokerDeal$Table$subscriptions(brokerDealsTable));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var brokerDeals = response.a;
                    var headers = response.b;
                    var brokerDealsTable = A2($author$project$Components$BrokerDeal$Table$withBrokerDeals, A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals), model.dy);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kq: response,
                        dy: brokerDealsTable,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Kq: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.Ej, subMsg, model.dy);
                var _v2 = function() {
                    var _v3 = brokerDealsTableResult.adu;
                    switch(_v3){
                        case 0:
                            return _Utils_Tuple2(model.Kq, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
                        case 2:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
                        case 3:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
                        case 4:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
                        case 5:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
                        default:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(model));
                    }
                }();
                var brokerDeals = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    Kq: brokerDeals,
                    dy: brokerDealsTableResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg, brokerDealsTableResult.EQ),
                    cmd
                ])), brokerDealsTableResult.at);
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v4.a;
                var searchInputCmd = _v4.b;
                var searchInputEvent = _v4.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v5 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            Kq: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(qModel),
                            A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                        ])));
                    }
                }();
                var newModel = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, model.Ej, subMsg, model.lj);
                var brokerId = function() {
                    var _v8 = brokerResourceResult.adu;
                    if (!_v8.$) {
                        if (!_v8.a.$) return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.zi);
                        else {
                            var _v9 = _v8.a;
                            return model.EC;
                        }
                    } else return model.EC;
                }();
                var newModel = _Utils_update(model, {
                    EC: brokerId,
                    lj: brokerResourceResult.zi
                });
                var _v7 = _Utils_eq(model.EC, newModel.EC) ? _Utils_Tuple2(model.Kq, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$fetchBrokerDeals(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var brokerDeals = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    Kq: brokerDeals
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg, brokerResourceResult.EQ),
                    cmd
                ])), brokerResourceResult.at);
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Button = 1;
    var $author$project$Components$ResourceFilter$Broker$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$viewBrokerResourceFilter = function(brokerResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Broker$view, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1)
        ]), brokerResourceFilter));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg, $author$project$Components$BrokerDeal$Table$modal(model.dy)),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals({
                                    bS: model.bS
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Active Deals')
                                ]))
                            ])),
                            A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                $author$project$Ui$Breadcrumb$active(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Ended Deals')
                            ]))
                        ]))),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Ended Deals')
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                                    $author$project$Ui$SearchInput$placeholder('Search deal')
                                ]), model.sG))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(3)
                            ]), _List_fromArray([
                                $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$viewBrokerResourceFilter(model.lj)
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$BrokerDealsTableMsg, A2($author$project$Components$BrokerDeal$Table$view, _List_fromArray([
                            $author$project$Components$BrokerDeal$Table$loading(!$author$project$Api$Data$isSuccess(model.Kq))
                        ]), model.dy))
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.Kq)))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Commissions | Broker Deals'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Statement$One$Statement = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Statement$Shared$Statement = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Statement$Shared$Record = F7(function(id, number, amountInCents, date, status, dueInCents, brokerAccount) {
        return {
            Jh: amountInCents,
            vR: brokerAccount,
            M4: date,
            Ol: dueInCents,
            aef: id,
            Gx: number,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Statement$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'broker_account', $author$project$Api$Provider$BrokerAccount$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$Shared$Record))))))));
    var $author$project$Api$Provider$Statement$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Statement$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Statement$One$Record = F4(function(brokersCount, dealsCount, securePdfInlineToken, payments) {
        return {
            Ks: brokersCount,
            Nl: dealsCount,
            Wt: payments,
            ZC: securePdfInlineToken
        };
    });
    var $author$project$Api$Provider$Statement$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payments', $elm$json$Json$Decode$list($author$project$Api$Provider$Payment$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_inline_token', $author$project$Api$File$Token$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deals_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'brokers_count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$One$Record)))));
    var $author$project$Api$Provider$Statement$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Statement$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Statement$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$One$Statement)));
    var $author$project$Api$Provider$Statement$statementsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'statements'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Statement$statementPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Statement$statementsPath);
    };
    var $author$project$Api$Provider$Statement$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Statement$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Statement$statementPath(id)));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple2({
            ht: $elm$core$Maybe$Nothing,
            Ej: shared.Ej,
            bS: params.bS,
            lH: $elm$core$Maybe$Nothing,
            cP: shared.cP,
            it: $author$project$Components$Invoice$DownloadFile$init(shared.aaT),
            F3: $author$project$Shared$isHintAdmin(shared),
            mN: $author$project$Api$Data$NotAsked,
            jt: A4($author$project$Components$PaymentsList$init, shared.HO, $author$project$Api$Provider$Statement$statementPath(params.ahx), session, true),
            W1: practice,
            sp: shared.sp,
            Z$: session,
            HC: $author$project$Api$Data$Loading,
            ahx: params.ahx,
            tf: $author$project$Api$Data$Loading,
            kp: $elm$core$Dict$empty,
            HO: shared.HO
        }, A3($author$project$Api$Provider$Statement$retrieve, shared.Ej, params.ahx, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Close = {
        $: 0
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$Statement$AdjustmentModal$Close);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg, $author$project$Components$PaymentsList$subscriptions(model.jt)),
            function() {
                var _v0 = model.lH;
                if (!_v0.$) {
                    var createPaymentModal = _v0.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg, $author$project$Components$Invoice$CreatePaymentModal$subscriptions(createPaymentModal));
                } else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v1 = model.ht;
                if (!_v1.$) {
                    var adjustmentModal = _v1.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg, $author$project$Components$Commissions$Statement$AdjustmentModal$subscriptions(adjustmentModal));
                } else return $elm$core$Platform$Sub$none;
            }()
        ]));
    };
    var $author$project$Api$Provider$Statement$SummaryLine$Broker = 0;
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotSummaryLines = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issued = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Statement$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Statement$One$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$Shared$amountInCents(shared);
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Bonus = 0;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory = 0;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsInit = F2(function(apiClient, brokerAccountId) {
        var _v0 = A3($author$project$Components$ResourceFilter$Broker$init, apiClient, function(d) {
            return _Utils_update(d, {
                vR: $elm$core$Maybe$Just(brokerAccountId),
                Gu: $elm$core$Maybe$Just(true)
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'None',
                afn: false
            });
        });
        var brokerResourceFilter = _v0.a;
        var brokerResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Jh: $elm$core$Maybe$Nothing,
            vQ: $elm$core$Maybe$Nothing,
            lj: brokerResourceFilter,
            EL: $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory,
            ae0: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg, brokerResourceFilterCmd));
    });
    var $author$project$Components$Commissions$Statement$AdjustmentModal$init = F3(function(apiClient, brokerAccountId, statement) {
        var _v0 = A2($author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsInit, apiClient, brokerAccountId);
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            N0: false,
            PU: $author$project$Utils$Form$init(formFields),
            j_: $author$project$Api$Data$NotAsked,
            HC: statement
        }, formFieldsCmd);
    });
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$init = F2(function(statement, summaryLine) {
        return {
            oi: false,
            HC: statement,
            HH: summaryLine,
            tf: $author$project$Api$Data$NotAsked
        };
    });
    var $author$project$Components$Invoice$CreatePaymentModal$ElectronicFundsTransfer = 3;
    var $author$project$Components$Invoice$CreatePaymentModal$Statement = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$initCreatePaymentModal = F2(function(statement, model) {
        var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.cP)(model.HO)($author$project$Api$Provider$Statement$statementPath(model.ahx))($elm$core$Maybe$Nothing)(model.Ej)(model.Z$)($author$project$Api$Practice$Provider(model.W1))(model.F3)(model.sp)(function(d) {
            return _Utils_update(d, {
                Po: true,
                Fs: _List_fromArray([
                    0,
                    3,
                    4
                ]),
                or: model.F3
            });
        })(A2($author$project$Components$Invoice$CreatePaymentModal$Statement, model.bS, statement));
        var createPaymentModal = _v0.a;
        var createPaymentModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            lH: $elm$core$Maybe$Just(createPaymentModal)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg, createPaymentModalCmd));
    });
    var $author$project$Api$Provider$Statement$issue = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('statement', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('amount_in_cents', $elm$json$Json$Encode$int(fields.Jh))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Statement$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'issue'
        ]), $author$project$Api$Provider$Statement$statementPath(id)))));
    });
    var $author$project$Api$Provider$Statement$SummaryLine$All$SummaryLine = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$SummaryLine = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$Record = F6(function(membershipsCount, linesCount, patientsCount, payableAmountInCents, liabilityAmountInCents, totalRateAmountInCents) {
        return {
            S6: liabilityAmountInCents,
            Td: linesCount,
            T8: membershipsCount,
            Wd: patientsCount,
            We: payableAmountInCents,
            aao: totalRateAmountInCents
        };
    });
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_rate_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'liability_amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payable_amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patients_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lines_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'memberships_count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$Shared$Record)))))));
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Statement$SummaryLine$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Statement$SummaryLine$All$Record = F6(function(payable, category, inStatementPeriod, categoryName, invoice, broker) {
        return {
            vQ: broker,
            EL: category,
            K1: categoryName,
            Q7: inStatementPeriod,
            RA: invoice,
            af5: payable
        };
    });
    var $author$project$Api$Provider$Broker$Min$Broker = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Broker$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Broker$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Broker$Min$Record)));
    var $author$project$Api$Provider$Broker$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Broker$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Invoice$MinWithCompany$Invoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Invoice$MinWithCompany$Record = function(company) {
        return {
            acy: company
        };
    };
    var $author$project$Api$Provider$Invoice$MinWithCompany$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $author$project$Api$Provider$Company$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$MinWithCompany$Record));
    var $author$project$Api$Provider$Invoice$MinWithCompany$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$MinWithCompany$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Invoice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Invoice$MinWithCompany$Invoice)));
    var $author$project$Api$Provider$Statement$SummaryLine$All$recordDecoder = A3($author$project$Api$Expandable$expandable, 'broker', $author$project$Api$Provider$Broker$Min$decoder, A3($author$project$Api$Expandable$expandable, 'invoice', $author$project$Api$Provider$Invoice$MinWithCompany$decoder, A3($author$project$Api$Expandable$expandable, 'category_name', $elm$json$Json$Decode$string, A3($author$project$Api$Expandable$expandable, 'in_statement_period', $elm$json$Json$Decode$bool, A3($author$project$Api$Expandable$expandable, 'category', $elm$json$Json$Decode$string, A3($author$project$Api$Expandable$expandable, 'payable', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$All$Record)))))));
    var $author$project$Api$Provider$Statement$SummaryLine$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Statement$SummaryLine$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Statement$SummaryLine$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Statement$SummaryLine$All$SummaryLine)));
    var $author$project$Api$Provider$Statement$SummaryLine$expandToString = function(expand) {
        switch(expand){
            case 0:
                return 'broker';
            case 1:
                return 'category_name';
            case 3:
                return 'period';
            case 4:
                return 'payable';
            default:
                return 'category_type';
        }
    };
    var $author$project$Api$Provider$Statement$SummaryLine$listDefaults = {
        EC: $elm$core$Maybe$Nothing,
        Fq: _List_Nil
    };
    var $author$project$Api$Provider$Statement$SummaryLine$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Statement$SummaryLine$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.EC;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'broker_id', string)
                    ]);
                } else return _List_Nil;
            }(),
            A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$Statement$SummaryLine$expandToString, options.Fq)
        ]));
    };
    var $author$project$Api$Provider$Statement$SummaryLine$summaryLinesPath = function(statementId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'summary_lines'
        ]), $author$project$Api$Provider$Statement$statementPath(statementId));
    };
    var $author$project$Api$Provider$Statement$SummaryLine$list = F4(function(apiClient, statementId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Statement$SummaryLine$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Statement$SummaryLine$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Statement$SummaryLine$summaryLinesPath(statementId))));
    });
    var $author$project$Components$Commissions$Statement$AdjustmentModal$AdjustmentCreated = 2;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Broker = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Closed = 1;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$None = 0;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCentsValidation = 1;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerValidation = 0;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.vQ;
        }, _Utils_Tuple2(0, 'Please pick a broker.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Jh;
        }, _Utils_Tuple2(1, 'Please enter an amount.'))
    ]));
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Statement$Adjustment$adjustmentsPath = function(statementId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'adjustments'
        ]), $author$project$Api$Provider$Statement$statementPath(statementId));
    };
    var $author$project$Api$Provider$StatementAdjustment$One$StatementAdjustment = 0;
    var $author$project$Api$Provider$StatementAdjustment$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Statement$Adjustment$create = F4(function(apiClient, statementId, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('statement_adjustment', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('category', $elm$json$Json$Encode$string(fields.EL)),
                _Utils_Tuple2('broker', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.vQ)),
                _Utils_Tuple2('amount_in_cents', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Jh)),
                _Utils_Tuple2('memo', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ae0))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$StatementAdjustment$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Statement$Adjustment$adjustmentsPath(statementId))));
    });
    var $author$project$Components$Commissions$Statement$AdjustmentModal$createParams = function(fields) {
        var category = function() {
            var _v0 = fields.EL;
            switch(_v0){
                case 0:
                    return 'bonus';
                case 1:
                    return 'correction';
                default:
                    return 'other';
            }
        }();
        return {
            Jh: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Jh),
            vQ: fields.vQ,
            EL: category,
            ae0: fields.ae0
        };
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$save = F3(function(apiClient, model, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Statement$Adjustment$create, apiClient, $author$project$Api$Provider$Statement$One$id(model.HC), $author$project$Components$Commissions$Statement$AdjustmentModal$createParams(fields), $author$project$Components$Commissions$Statement$AdjustmentModal$Created);
    });
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Correction = 1;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Other = 2;
    var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryFromString = function(string) {
        switch(string){
            case 'Bonus':
                return 0;
            case 'Correction':
                return 1;
            case 'Other':
                return 2;
            default:
                return $author$project$Components$Commissions$Statement$AdjustmentModal$defaultCategory;
        }
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    ae0: $author$project$Utils$String$toMaybe(string)
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    EL: $author$project$Components$Commissions$Statement$AdjustmentModal$categoryFromString(string)
                });
            case 2:
                var broker = field.a;
                return _Utils_update(fields, {
                    vQ: A2($elm$core$Maybe$map, $author$project$Api$Provider$Broker$All$id, broker)
                });
            default:
                var _int = field.a;
                return _Utils_update(fields, {
                    Jh: _int
                });
        }
    });
    var $author$project$Components$Commissions$Statement$AdjustmentModal$updateForm = F3(function(model, field, form) {
        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsUpdate, field, form);
        return _Utils_Tuple2(_Utils_update(model, {
            PU: newForm
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Commissions$Statement$AdjustmentModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var field = msg.a;
                var _v2 = A3($author$project$Components$Commissions$Statement$AdjustmentModal$updateForm, model, field, model.PU);
                var newModel = _v2.a;
                var formCmd = _v2.b;
                return {
                    EQ: formCmd,
                    adu: 0,
                    zi: newModel,
                    at: _List_Nil
                };
            case 2:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$Statement$AdjustmentModal$formFieldsValidator, model.PU);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    return {
                        EQ: A3($author$project$Components$Commissions$Statement$AdjustmentModal$save, apiClient, model, validFormFields),
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            j_: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v3.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 3:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Statement Ajusted')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var subMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, fields.lj);
                var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    lj: brokerResourceResult.zi
                }), model.PU);
                var _v6 = function() {
                    var _v7 = brokerResourceResult.adu;
                    _v7$2: while(true){
                        if (!_v7.$ && !_v7.a.$) switch(_v7.a.a.$){
                            case 0:
                                var broker = _v7.a.a.a;
                                return A3($author$project$Components$Commissions$Statement$AdjustmentModal$updateForm, model, $author$project$Components$Commissions$Statement$AdjustmentModal$Broker($elm$core$Maybe$Just(broker)), newForm);
                            case 2:
                                var _v8 = _v7.a.a;
                                return A3($author$project$Components$Commissions$Statement$AdjustmentModal$updateForm, model, $author$project$Components$Commissions$Statement$AdjustmentModal$Broker($elm$core$Maybe$Nothing), newForm);
                            default:
                                break _v7$2;
                        }
                        else break _v7$2;
                    }
                    return _Utils_Tuple2(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v6.a;
                var formCmd = _v6.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg, brokerResourceResult.EQ),
                        formCmd
                    ])),
                    adu: 0,
                    zi: newModel,
                    at: brokerResourceResult.at
                };
        }
    });
    var $author$project$Api$Provider$Statement$SummaryLine$CategoryName = 1;
    var $author$project$Api$Provider$Statement$SummaryLine$CategoryType = 2;
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$GotSummaryLines = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Statement$SummaryLine$Payable = 4;
    var $author$project$Api$Provider$Statement$SummaryLine$Period = 3;
    var $author$project$Api$Provider$Statement$SummaryLine$All$broker = function(_v0) {
        var record = _v0.b;
        return record.vQ;
    };
    var $author$project$Api$Provider$Statement$One$brokersCount = function(_v0) {
        var record = _v0.b;
        return record.Ks;
    };
    var $author$project$Api$Provider$Statement$One$dealsCount = function(_v0) {
        var record = _v0.b;
        return record.Nl;
    };
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView = function(statement) {
        return _Utils_cmp($author$project$Api$Provider$Statement$One$brokersCount(statement) * 10, $author$project$Api$Provider$Statement$One$dealsCount(statement)) > -1;
    };
    var $author$project$Api$Provider$Broker$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$retrieveSummaryLines = F3(function(apiClient, statement, summaryLine) {
        var expand = $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement) ? _List_fromArray([
            1,
            3,
            4
        ]) : _List_fromArray([
            4,
            3,
            2
        ]);
        var brokerId = $author$project$Api$Expandable$toMaybe(A2($author$project$Api$Expandable$map, $author$project$Api$Provider$Broker$Min$id, $author$project$Api$Provider$Statement$SummaryLine$All$broker(summaryLine)));
        return A4($author$project$Api$Provider$Statement$SummaryLine$list, apiClient, $author$project$Api$Provider$Statement$One$id(statement), function(d) {
            return _Utils_update(d, {
                EC: brokerId,
                Fq: expand
            });
        }, $author$project$Components$Commissions$Statement$SummaryLine$Details$GotSummaryLines);
    });
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$update = F3(function(apiClient, msg, model) {
        if (!msg.$) return _Utils_Tuple3(_Utils_update(model, {
            oi: !model.oi
        }), function() {
            var _v1 = model.tf;
            if (_v1.$ === 3) return $elm$core$Platform$Cmd$none;
            else return A3($author$project$Components$Commissions$Statement$SummaryLine$Details$retrieveSummaryLines, apiClient, model.HC, model.HH);
        }(), _List_Nil);
        else {
            var response = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                tf: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var statement = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        HC: response
                    }), A4($author$project$Api$Provider$Statement$SummaryLine$list, model.Ej, model.ahx, function(d) {
                        return _Utils_update(d, {
                            Fq: _List_fromArray([
                                0
                            ])
                        });
                    }, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotSummaryLines(statement)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    HC: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var statement = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var summaryLines = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        tf: response,
                        kp: $elm$core$Dict$fromList(A2($elm$core$List$indexedMap, F2(function(index, summaryLine) {
                            var summaryLineDetails = A2($author$project$Components$Commissions$Statement$SummaryLine$Details$init, statement, summaryLine);
                            return _Utils_Tuple2(index, summaryLineDetails);
                        }), summaryLines))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    tf: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var statement = msg.a;
                var _v3 = A3($author$project$Components$Commissions$Statement$AdjustmentModal$init, model.Ej, model.bS, statement);
                var adjustmentModal = _v3.a;
                var adjustmentModalCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ht: $elm$core$Maybe$Just(adjustmentModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg, adjustmentModalCmd), _List_Nil);
            case 3:
                var statement = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    mN: $author$project$Api$Data$Loading
                }), A4($author$project$Api$Provider$Statement$issue, model.Ej, model.ahx, {
                    Jh: $author$project$Api$Provider$Statement$One$amountInCents(statement)
                }, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issued), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    mN: $author$project$Api$Data$NotAsked,
                    HC: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Statement issued')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    mN: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var statement = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$initCreatePaymentModal, statement, model));
            case 6:
                var subMsg = msg.a;
                var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.Ej, subMsg, model.it);
                return _Utils_Tuple3(_Utils_update(model, {
                    it: downloadInvoiceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg, downloadInvoiceResult.EQ), downloadInvoiceResult.at);
            case 7:
                var subMsg = msg.a;
                var paymentsListResult = A3($author$project$Components$PaymentsList$update, model.Ej, subMsg, model.jt);
                var _v5 = function() {
                    var _v6 = paymentsListResult.adu;
                    switch(_v6){
                        case 0:
                            return _Utils_Tuple2(model.HC, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$Statement$retrieve, model.Ej, model.ahx, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
                        case 2:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$Statement$retrieve, model.Ej, model.ahx, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
                        case 3:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$Statement$retrieve, model.Ej, model.ahx, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
                        default:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$Statement$retrieve, model.Ej, model.ahx, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
                    }
                }();
                var statement = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    jt: paymentsListResult.zi,
                    HC: statement
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg, paymentsListResult.EQ),
                    cmd
                ])), paymentsListResult.at);
            case 8:
                var subMsg = msg.a;
                var _v7 = model.lH;
                if (!_v7.$) {
                    var createPaymentModal = _v7.a;
                    var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.Ej, subMsg, createPaymentModal);
                    var _v8 = function() {
                        var _v9 = createPaymentModalResult.adu;
                        switch(_v9){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createPaymentModalResult.zi), model.HC, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A3($author$project$Api$Provider$Statement$retrieve, model.Ej, model.ahx, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.HC, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var createPaymentModal_ = _v8.a;
                    var statement = _v8.b;
                    var cmd = _v8.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lH: createPaymentModal_,
                        HC: statement
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg, createPaymentModalResult.EQ),
                        cmd
                    ])), createPaymentModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var id = msg.a;
                var subMsg = msg.b;
                var _v10 = A2($elm$core$Dict$get, id, model.kp);
                if (!_v10.$) {
                    var summaryLineDetails = _v10.a;
                    var _v11 = A3($author$project$Components$Commissions$Statement$SummaryLine$Details$update, model.Ej, subMsg, summaryLineDetails);
                    var summaryLineDetails_ = _v11.a;
                    var summaryLineDetailsCmd = _v11.b;
                    var summaryLineDetailsOutMsgs = _v11.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        kp: A3($elm$core$Dict$insert, id, summaryLineDetails_, model.kp)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(id), summaryLineDetailsCmd), summaryLineDetailsOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v12 = model.ht;
                if (!_v12.$) {
                    var adjustmentModal = _v12.a;
                    var adjustmentModalResult = A3($author$project$Components$Commissions$Statement$AdjustmentModal$update, model.Ej, subMsg, adjustmentModal);
                    var _v13 = function() {
                        var _v14 = adjustmentModalResult.adu;
                        switch(_v14){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(adjustmentModalResult.zi), model.HC, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A3($author$project$Api$Provider$Statement$retrieve, model.Ej, model.ahx, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$GotStatement));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.HC, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var adjustmentModal_ = _v13.a;
                    var statement = _v13.b;
                    var cmd = _v13.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ht: adjustmentModal_,
                        HC: statement
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg, adjustmentModalResult.EQ),
                        cmd
                    ])), adjustmentModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Save = {
        $: 2
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCents = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$viewAmountInCentsFormGroup = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var amountInCents = _v0.Jh;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Amount'),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$value(amountInCents),
                        $author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
                        $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$AmountInCents)),
                        $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Amounts can be negative')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$viewBrokerFormGroup = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var brokerResourceFilter = _v0.lj;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Broker'),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Commissions$Statement$AdjustmentModal$BrokerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Broker$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0),
                $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]), brokerResourceFilter))
        ]));
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Category = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$allCategories = _List_fromArray([
        0,
        1,
        2
    ]);
    var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString = function(category) {
        switch(category){
            case 0:
                return 'Bonus';
            case 1:
                return 'Correction';
            default:
                return 'Other';
        }
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$categoryOptions = A2($elm$core$List$map, function(category) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category)), $author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category));
    }, $author$project$Components$Commissions$Statement$AdjustmentModal$allCategories);
    var $author$project$Components$Commissions$Statement$AdjustmentModal$viewCategoryFormGroup = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var category = _v0.EL;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Category'),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Components$Commissions$Statement$AdjustmentModal$categoryToString(category))),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$Category))
            ]), $author$project$Components$Commissions$Statement$AdjustmentModal$categoryOptions)
        ]));
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$Memo = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$viewMemoFormGroup = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var memo = _v0.ae0;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Memo'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', memo)),
                $author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$Statement$AdjustmentModal$FormUpdated, $author$project$Components$Commissions$Statement$AdjustmentModal$Memo))
            ]))
        ]));
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$viewFormGroups = function(form) {
        return _List_fromArray([
            $author$project$Components$Commissions$Statement$AdjustmentModal$viewCategoryFormGroup(form),
            $author$project$Components$Commissions$Statement$AdjustmentModal$viewBrokerFormGroup(form),
            $author$project$Components$Commissions$Statement$AdjustmentModal$viewAmountInCentsFormGroup(form),
            $author$project$Components$Commissions$Statement$AdjustmentModal$viewMemoFormGroup(form)
        ]);
    };
    var $author$project$Components$Commissions$Statement$AdjustmentModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Commissions$Statement$AdjustmentModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Add Adjustment')
                ]))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Commissions$Statement$AdjustmentModal$Save),
                    $author$project$Ui$Form$horizontal
                ]), $author$project$Components$Commissions$Statement$AdjustmentModal$viewFormGroups(model.PU))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel and close modal'
                        }, _List_fromArray([
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$AdjustmentModal$Close)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Confirm adjustment'
                        }, _List_fromArray([
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$AdjustmentModal$Save),
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Confirm Adjustment')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Adjust = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$FontWeight$Medium = 0;
    var $author$project$Api$Provider$Statement$Shared$date = function(_v0) {
        var record = _v0;
        return record.M4;
    };
    var $author$project$Api$Provider$Statement$One$date = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$Shared$date(shared);
    };
    var $author$project$Api$Provider$Statement$Shared$number = function(_v0) {
        var record = _v0;
        return record.Gx;
    };
    var $author$project$Api$Provider$Statement$One$number = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$Shared$number(shared);
    };
    var $author$project$Api$Provider$Statement$One$securePdfInlineToken = function(_v0) {
        var record = _v0.b;
        return record.ZC;
    };
    var $author$project$Api$Provider$Statement$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Statement$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$Shared$status(shared);
    };
    var $author$project$Api$Provider$Statement$One$payments = function(_v0) {
        var record = _v0.b;
        return record.Wt;
    };
    var $author$project$Components$PaymentsList$ShowCreatedBy = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PaymentsList$showCreatedBy = $author$project$Components$PaymentsList$ShowCreatedBy;
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPaymentsList = F3(function(isHintAdmin, statement, paymentsList) {
        var payments = A2($elm$core$List$map, $author$project$Api$Payment$Provider_One, $author$project$Api$Provider$Statement$One$payments(statement));
        return $elm$core$List$isEmpty(payments) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Payment History')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg, A3($author$project$Components$PaymentsList$view, _List_fromArray([
                    $author$project$Components$PaymentsList$isHintAdmin(isHintAdmin),
                    $author$project$Components$PaymentsList$allowRefunds(true),
                    $author$project$Components$PaymentsList$showCreatedBy(true),
                    $author$project$Components$PaymentsList$showRefundMemo(true)
                ]), payments, paymentsList))
            ]))
        ]));
    });
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$ToggleShow = {
        $: 0
    };
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$button = function(model) {
        var icon = model.oi ? $author$project$Ui$Icon$minus : $author$project$Ui$Icon$add;
        return A3($author$project$Ui$Button$view, {
            abP: 'Toggle visibility'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Components$Commissions$Statement$SummaryLine$Details$ToggleShow),
            $author$project$Ui$Button$icon(icon)
        ]), _List_Nil);
    };
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$membershipsCount = function(_v0) {
        var record = _v0;
        return record.T8;
    };
    var $author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$SummaryLine$Shared$membershipsCount(shared);
    };
    var $author$project$Api$Provider$Broker$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$patientsCount = function(_v0) {
        var record = _v0;
        return record.Wd;
    };
    var $author$project$Api$Provider$Statement$SummaryLine$All$patientsCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$SummaryLine$Shared$patientsCount(shared);
    };
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$payableAmountInCents = function(_v0) {
        var record = _v0;
        return record.We;
    };
    var $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$SummaryLine$Shared$payableAmountInCents(shared);
    };
    var $author$project$Ui$Padding$Top_0_5 = 7;
    var $author$project$Api$Provider$Statement$SummaryLine$All$inStatementPeriod = function(_v0) {
        var record = _v0.b;
        return record.Q7;
    };
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod = function(summaryLine) {
        return $author$project$Api$Expandable$toMaybe($author$project$Api$Provider$Statement$SummaryLine$All$inStatementPeriod(summaryLine));
    };
    var $author$project$Ui$Well$NoBorder = {
        $: 3
    };
    var $author$project$Ui$Well$noBorder = $author$project$Ui$Well$NoBorder;
    var $author$project$Api$Provider$Statement$SummaryLine$All$payable = function(_v0) {
        var record = _v0.b;
        return record.af5;
    };
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$payable = function(summaryLine) {
        return $author$project$Api$Expandable$toMaybe($author$project$Api$Provider$Statement$SummaryLine$All$payable(summaryLine));
    };
    var $author$project$Ui$Typography$Capitalized = 4;
    var $author$project$Ui$Typography$capitalized = $author$project$Ui$Typography$Decoration(4);
    var $author$project$Api$Provider$Statement$SummaryLine$All$categoryName = function(_v0) {
        var record = _v0.b;
        return record.K1;
    };
    var $author$project$Api$Provider$Invoice$MinWithCompany$company = function(_v0) {
        var record = _v0.b;
        return record.acy;
    };
    var $author$project$Api$Provider$Invoice$MinWithCompany$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Invoice$Min$id(min);
    };
    var $author$project$Api$Provider$Statement$SummaryLine$All$invoice = function(_v0) {
        var record = _v0.b;
        return record.RA;
    };
    var $author$project$Api$Provider$Invoice$MinWithCompany$invoiceNumber = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$Invoice$Min$invoiceNumber(min);
    };
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$liabilityAmountInCents = function(_v0) {
        var record = _v0;
        return record.S6;
    };
    var $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$SummaryLine$Shared$liabilityAmountInCents(shared);
    };
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$linesCount = function(_v0) {
        var record = _v0;
        return record.Td;
    };
    var $author$project$Api$Provider$Statement$SummaryLine$All$linesCount = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$SummaryLine$Shared$linesCount(shared);
    };
    var $author$project$Api$Provider$Statement$SummaryLine$Shared$totalRateAmountInCents = function(_v0) {
        var record = _v0;
        return record.aao;
    };
    var $author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Statement$SummaryLine$Shared$totalRateAmountInCents(shared);
    };
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTableRow = F2(function(isOutstanding, summaryLine) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
                    _v0$4: while(true){
                        if (!_v0.$) switch(_v0.a){
                            case 'Retail':
                                return $elm$html$Html$text('--');
                            case 'bonus':
                                return $author$project$Utils$Html$empty;
                            case 'correction':
                                return $author$project$Utils$Html$empty;
                            case 'other':
                                return $author$project$Utils$Html$empty;
                            default:
                                break _v0$4;
                        }
                        else break _v0$4;
                    }
                    var _v1 = $author$project$Api$Provider$Statement$SummaryLine$All$invoice(summaryLine);
                    if (!_v1.$) {
                        var invoice = _v1.a;
                        var invoiceNumber = $author$project$Api$Provider$Invoice$MinWithCompany$invoiceNumber(invoice);
                        var invoiceId = $author$project$Api$Provider$Invoice$MinWithCompany$id(invoice);
                        var companyId = $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$Invoice$MinWithCompany$company(invoice));
                        var invoiceRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                            fl: companyId,
                            aef: invoiceId
                        });
                        return A3($author$project$Ui$Link$route, invoiceRoute, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('#' + $elm$core$String$fromInt(invoiceNumber))
                        ]));
                    } else return $elm$html$Html$text('N/A');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$capitalized
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Api$Expandable$withDefault, 'N/A', $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v2 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
                    _v2$3: while(true){
                        if (!_v2.$) switch(_v2.a){
                            case 'bonus':
                                return $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'line', $author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
                            case 'correction':
                                return $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'line', $author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
                            case 'other':
                                return $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'line', $author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
                            default:
                                break _v2$3;
                        }
                        else break _v2$3;
                    }
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
                        $elm$html$Html$text(' primary '),
                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
                    ]));
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v3 = $author$project$Api$Provider$Statement$SummaryLine$All$categoryName(summaryLine);
                    _v3$3: while(true){
                        if (!_v3.$) switch(_v3.a){
                            case 'bonus':
                                return $author$project$Utils$Html$empty;
                            case 'correction':
                                return $author$project$Utils$Html$empty;
                            case 'other':
                                return $author$project$Utils$Html$empty;
                            default:
                                break _v3$3;
                        }
                        else break _v3$3;
                    }
                    return $elm$html$Html$text($author$project$Utils$Currency$fromInt(A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents(summaryLine))));
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var amountInCents = isOutstanding ? $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents(summaryLine) : $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine);
                    return $elm$html$Html$text($author$project$Utils$Currency$fromInt(amountInCents));
                }()
            ]))
        ]));
    });
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTable = F2(function(isOutstanding, summaryLines) {
        return A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(1)
            ]), _List_fromArray([
                $elm$html$Html$text('Invoice')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Employer / Category')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                $elm$html$Html$text('Deal')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                $elm$html$Html$text('Total rate')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                $elm$html$Html$text('Commission')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTableRow(isOutstanding), summaryLines), _List_Nil);
    });
    var $author$project$Api$Provider$Statement$SummaryLine$All$category = function(_v0) {
        var record = _v0.b;
        return record.EL;
    };
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTableRow = F2(function(isOutstanding, summaryLine) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine);
                    _v0$2: while(true){
                        if (!_v0.$) switch(_v0.a){
                            case 'Membership':
                                return $elm$html$Html$text('Retail');
                            case 'Company':
                                return $elm$html$Html$text('Employer');
                            default:
                                break _v0$2;
                        }
                        else break _v0$2;
                    }
                    return $elm$html$Html$text(A2($author$project$Api$Expandable$withDefault, 'N/A', $author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine)));
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v1 = $author$project$Api$Provider$Statement$SummaryLine$All$category(summaryLine);
                    _v1$5: while(true){
                        if (!_v1.$) switch(_v1.a){
                            case 'bonus':
                                return $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'line', $author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
                            case 'correction':
                                return $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'line', $author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
                            case 'other':
                                return $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'line', $author$project$Api$Provider$Statement$SummaryLine$All$linesCount(summaryLine)));
                            case 'Membership':
                                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
                                    $elm$html$Html$text(' primary '),
                                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
                                ]));
                            case 'Company':
                                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
                                    $elm$html$Html$text(' primary '),
                                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
                                ]));
                            default:
                                break _v1$5;
                        }
                        else break _v1$5;
                    }
                    return $author$project$Utils$Html$empty;
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt(A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$Statement$SummaryLine$All$totalRateAmountInCents(summaryLine))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var amountInCents = isOutstanding ? $author$project$Api$Provider$Statement$SummaryLine$All$liabilityAmountInCents(summaryLine) : $author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine);
                    return $elm$html$Html$text($author$project$Utils$Currency$fromInt(amountInCents));
                }()
            ]))
        ]));
    });
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTable = F2(function(isOutstanding, summaryLines) {
        return A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                $elm$html$Html$text('Category')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Deal')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                $elm$html$Html$text('Total rate')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                $elm$html$Html$text('Commission')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTableRow(isOutstanding), summaryLines), _List_Nil);
    });
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable = F3(function(expanded, isOutstanding, summaryLines) {
        return expanded ? A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewExpandedSummaryLineTable, isOutstanding, summaryLines) : A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummarizedSummaryLineTable, isOutstanding, summaryLines);
    });
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTables = F2(function(statement, summaryLines) {
        var previousSummaryLines = A2($elm$core$List$filter, function(summaryLine) {
            return _Utils_eq($author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod(summaryLine), $elm$core$Maybe$Just(false)) && _Utils_eq($author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine), $elm$core$Maybe$Just(true));
        }, summaryLines);
        var outstandingSummaryLines = A2($elm$core$List$filter, function(summaryLine) {
            return _Utils_eq($author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine), $elm$core$Maybe$Just(false));
        }, summaryLines);
        var currentSummaryLines = A2($elm$core$List$filter, function(summaryLine) {
            return _Utils_eq($author$project$Components$Commissions$Statement$SummaryLine$Details$inStatementPeriod(summaryLine), $elm$core$Maybe$Just(true)) && _Utils_eq($author$project$Components$Commissions$Statement$SummaryLine$Details$payable(summaryLine), $elm$core$Maybe$Just(true));
        }, summaryLines);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$core$List$isEmpty(currentSummaryLines) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Current')
                    ])),
                    A3($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable, $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement), false, currentSummaryLines)
                ]))
            ])),
            $elm$core$List$isEmpty(previousSummaryLines) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Previous')
                    ])),
                    A3($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable, $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement), false, previousSummaryLines)
                ]))
            ])),
            $elm$core$List$isEmpty(outstandingSummaryLines) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Well$view, _List_fromArray([
                        $author$project$Ui$Well$small,
                        $author$project$Ui$Well$noBorder
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$padding(7)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Outstanding')
                            ])),
                            $author$project$Utils$Html$noBreakSpace,
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$gray
                            ]), _List_fromArray([
                                $elm$html$Html$text('(not reflected in totals)')
                            ]))
                        ])),
                        A3($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTable, $author$project$Components$Commissions$Statement$SummaryLine$Details$expandedView(statement), true, outstandingSummaryLines)
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Commissions$Statement$SummaryLine$Details$view = function(model) {
        return model.oi ? A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$padding(6)
        ]), _List_fromArray([
            function() {
                var _v0 = model.tf;
                if (_v0.$ === 3) {
                    var summaryLines = _v0.a;
                    return A2($author$project$Components$Commissions$Statement$SummaryLine$Details$viewSummaryLineTables, model.HC, summaryLines);
                } else return $author$project$Ui$Spinner$view(_List_fromArray([
                    $author$project$Ui$Spinner$extraSmall
                ]));
            }()
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewSummaryLine = F3(function(summaryLinesDetails, index, summaryLine) {
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(index), A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$Commissions$Statement$SummaryLine$Details$button, A2($elm$core$Dict$get, index, summaryLinesDetails)))),
                        $author$project$Utils$Html$noBreakSpace,
                        $elm$html$Html$text(A2($author$project$Api$Expandable$withDefault, 'N/A', A2($author$project$Api$Expandable$map, $author$project$Api$Provider$Broker$Min$name, $author$project$Api$Provider$Statement$SummaryLine$All$broker(summaryLine))))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(5)
                ]), _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Statement$SummaryLine$All$membershipsCount(summaryLine))),
                    $elm$html$Html$text(' Primary, '),
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'Patient', $author$project$Api$Provider$Statement$SummaryLine$All$patientsCount(summaryLine)))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Statement$SummaryLine$All$payableAmountInCents(summaryLine)))
                ]))
            ])),
            A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$SummaryLineDetailsMsg(index), A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$Commissions$Statement$SummaryLine$Details$view, A2($elm$core$Dict$get, index, summaryLinesDetails))))
        ]));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelBody = F2(function(statement, model) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top({
                                bS: model.bS
                            }), _List_Nil, _List_fromArray([
                                $elm$html$Html$text('All Statements')
                            ]))
                        ])),
                        A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                            $author$project$Ui$Breadcrumb$active(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Provider$Statement$One$number(statement)))
                        ]))
                    ])))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$DownloadInvoiceMsg, A4($author$project$Components$Invoice$DownloadFile$view, model.it, $author$project$Api$Provider$Statement$One$securePdfInlineToken(statement), _List_Nil, _List_Nil))
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Statement  #'),
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Statement$One$number(statement)))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$offsetSm(4),
                        $author$project$Ui$Grid$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$fontWeight(0)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Statement$One$status(statement))
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$controlLabel
                            ]), _List_fromArray([
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, $author$project$Api$Provider$Statement$One$date(statement)))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$offsetSm(4),
                        $author$project$Ui$Grid$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$controlLabel
                            ]), _List_fromArray([
                                $elm$html$Html$text('TOTAL AMOUNT')
                            ])),
                            $author$project$Utils$Html$noBreakSpace,
                            $author$project$Utils$Html$noBreakSpace,
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Statement$One$amountInCents(statement)))
                            ])),
                            $author$project$Api$Provider$Statement$One$status(statement) !== 'paid' ? A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$label, _List_fromArray([
                                    $author$project$Ui$Typography$controlLabel
                                ]), _List_fromArray([
                                    $elm$html$Html$text('AMOUNT DUE')
                                ])),
                                $author$project$Utils$Html$noBreakSpace,
                                $author$project$Utils$Html$noBreakSpace,
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Statement$One$dueInCents(statement)))
                                ]))
                            ])) : $author$project$Utils$Html$empty
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(4)
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Summary')
                            ]))
                        ])),
                        $author$project$Api$Provider$Statement$One$status(statement) === 'draft' ? A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(4),
                            $author$project$Ui$Grid$offsetSm(4),
                            $author$project$Ui$Grid$justifyRight
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Adjust statement'
                            }, _List_fromArray([
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Adjust(statement)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Adjustment')
                            ]))
                        ])) : $author$project$Ui$Grid$none
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = model.tf;
                        if (_v0.$ === 3) {
                            var summaryLines = _v0.a;
                            return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$indexedMap, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewSummaryLine(model.kp), summaryLines));
                        } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]));
                    }()
                ]))
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Patient Level Calculations')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Commissions calculations for each patient can be viewed in the '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__StatementLines__Top, _List_fromArray([
                            $author$project$Ui$Link$routeParams(_List_fromArray([
                                A2($elm$url$Url$Builder$string, 'statement', $author$project$Api$Provider$Statement$One$id(statement)),
                                A2($elm$url$Url$Builder$string, 'payable', 'true')
                            ]))
                        ]), _List_fromArray([
                            $elm$html$Html$text('statement lines report')
                        ])),
                        $elm$html$Html$text('.')
                    ]))
                ]))
            ])),
            A3($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPaymentsList, model.F3, statement, model.jt)
        ]);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issue = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$RecordPayment = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelFooter = F2(function(issueRequest, statement) {
        return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
            ]), _List_fromArray([
                $author$project$Api$Provider$Statement$One$status(statement) === 'draft' ? A3($author$project$Ui$Button$view, {
                    abP: 'Issue statement'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$Issue(statement)),
                    $author$project$Ui$Button$loading(_Utils_eq(issueRequest, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Issue Statement')
                ])) : $author$project$Utils$Html$empty,
                $author$project$Api$Provider$Statement$One$status(statement) === 'issued' ? A3($author$project$Ui$Button$view, {
                    abP: 'Record payment'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(issueRequest, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$RecordPayment(statement)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                ]), _List_fromArray([
                    $elm$html$Html$text('Record Payment')
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.lH;
                    if (!_v0.$) {
                        var createPaymentModal = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$CreatePaymentModalMsg, $author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v1 = model.ht;
                    if (!_v1.$) {
                        var adjustmentModal = _v1.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$AdjustmentModalMsg, $author$project$Components$Commissions$Statement$AdjustmentModal$view(adjustmentModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$PaymentsListMsg, $author$project$Components$PaymentsList$modal(model.jt)),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, function() {
                        var _v2 = model.HC;
                        if (_v2.$ === 3) {
                            var statement = _v2.a;
                            return A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelBody, statement, model);
                        } else return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]))
                        ]);
                    }()),
                    function() {
                        var _v3 = model.HC;
                        if (_v3.$ === 3) {
                            var statement = _v3.a;
                            return A2($author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$viewPanelFooter, model.mN, statement);
                        } else return $author$project$Ui$Panel$none;
                    }()
                ]))
            ]),
            $2: 'Commissions | Statements'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$StatementsTableMsg = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$List$DateRangeInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$List$StatusDropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$List$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Commissions$Statement$List$GotStatements = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Statement$All$Statement = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Statement$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Statement$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Statement$listDefaults = {
        vQ: $elm$core$Maybe$Nothing,
        vR: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Statement$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Statement$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.vR;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'broker_account', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.agq;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.aef;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.HB;
                if (!_v3.$) {
                    var start_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.Fn;
                if (!_v4.$) {
                    var end_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.ahy;
                if (!_v5.$) {
                    var string = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.vQ;
                if (!_v6.$) {
                    var string = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'broker', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Statement$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Statement$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Statement$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Statement$statementsPath)));
    });
    var $author$project$Components$Commissions$Statement$List$fetchStatements = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Statement$list, apiClient, function(d) {
            return _Utils_update(d, {
                vQ: model.EC,
                vR: model.bS,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af_: model.af_,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ahy: model.ahy
            });
        }, $author$project$Components$Commissions$Statement$List$GotStatements);
    });
    var $author$project$Components$ResourceFilter$BrokerAccount$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$BrokerAccount$All$BrokerAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$BrokerAccount$All$Record = function(brokers) {
        return {
            Kr: brokers
        };
    };
    var $author$project$Api$Provider$BrokerAccount$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'brokers', $elm$json$Json$Decode$list($author$project$Api$Provider$Broker$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$All$Record));
    var $author$project$Api$Provider$BrokerAccount$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerAccount$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$BrokerAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$BrokerAccount$All$BrokerAccount)));
    var $author$project$Api$Provider$BrokerAccount$listDefaults = {
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$BrokerAccount$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$BrokerAccount$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$BrokerAccount$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$BrokerAccount$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$BrokerAccount$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountsPath)));
    });
    var $author$project$Components$ResourceFilter$BrokerAccount$list = $author$project$Api$Provider$BrokerAccount$list;
    var $author$project$Components$ResourceFilter$BrokerAccount$fetchResources = F5(function(listOptionals, toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$BrokerAccount$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$BrokerAccount$retrieveResource = F4(function(listOptionals, toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$BrokerAccount$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$BrokerAccount$selectId = 'broker_accounts';
    var $author$project$Api$Provider$BrokerAccount$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerAccount$Shared$name(shared);
    };
    var $author$project$Components$ResourceFilter$BrokerAccount$toTitle = function(resource) {
        return $author$project$Api$Provider$BrokerAccount$All$name(resource);
    };
    var $author$project$Components$ResourceFilter$BrokerAccount$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$BrokerAccount$toTitle(resource))
        ]);
    };
    var $author$project$Api$Provider$BrokerAccount$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerAccount$Shared$id(shared);
    };
    var $author$project$Components$ResourceFilter$BrokerAccount$toValue = $author$project$Api$Provider$BrokerAccount$All$id;
    var $author$project$Components$ResourceFilter$BrokerAccount$init = F3(function(apiClient, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$BrokerAccount$fetchResources(listOptionals),
            aef: $author$project$Components$ResourceFilter$BrokerAccount$selectId,
            gD: 'Broker Account',
            sz: $author$project$Components$ResourceFilter$BrokerAccount$retrieveResource(listOptionals),
            ahW: $author$project$Components$ResourceFilter$BrokerAccount$toLabel,
            ahZ: $author$project$Components$ResourceFilter$BrokerAccount$toTitle,
            g4: $author$project$Components$ResourceFilter$BrokerAccount$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Commissions$Statement$List$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('status'), model.ahy),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('broker'), model.EC),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('broker_account'), model.bS)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString(model.Gc)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Components$Commissions$Statement$List$init = function(config) {
        var brokerId = A2($elm$core$Dict$get, 'broker', config.Bz);
        var brokerAccountId = function() {
            var _v5 = _Utils_Tuple2(config.bS, A2($elm$core$Dict$get, 'broker_account', config.Bz));
            if (!_v5.a.$) {
                var fromConfig = _v5.a.a;
                return $elm$core$Maybe$Just(fromConfig);
            } else {
                if (!_v5.b.$) {
                    var _v6 = _v5.a;
                    var fromQuery = _v5.b.a;
                    return $elm$core$Maybe$Just(fromQuery);
                } else return $elm$core$Maybe$Nothing;
            }
        }();
        var _v0 = $author$project$Utils$DateWithDefault$fromQuery(config.Bz);
        var start = _v0.a;
        var end = _v0.b;
        var _v1 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Commissions$Statement$List$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, config.cP, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, config.cP, 0), end)));
        var dateRangeInput = _v1.a;
        var dateRangeInputCmd = _v1.b;
        var _v2 = A3($author$project$Components$ResourceFilter$Broker$init, config.Ej, function() {
            var _v3 = config.bS;
            if (!_v3.$) {
                var accountId = _v3.a;
                return function(d) {
                    return _Utils_update(d, {
                        vR: $elm$core$Maybe$Just(accountId)
                    });
                };
            } else return $elm$core$Basics$identity;
        }(), function(d) {
            return _Utils_update(d, {
                Ee: 'All Brokers',
                agj: brokerId
            });
        });
        var brokerResourceFilter = _v2.a;
        var brokerResourceFilterCmd = _v2.b;
        var _v4 = A3($author$project$Components$ResourceFilter$BrokerAccount$init, config.Ej, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'All Broker Accounts',
                agj: brokerAccountId
            });
        });
        var brokerAccountResourceFilter = _v4.a;
        var brokerAccountResourceFilterCmd = _v4.b;
        var model = {
            bS: brokerAccountId,
            li: brokerAccountResourceFilter,
            EC: brokerId,
            lj: brokerResourceFilter,
            pK: config.pK,
            pL: config.pL,
            pM: config.pM,
            cP: config.cP,
            h6: dateRangeInput,
            Fn: end,
            Gc: config.Gc,
            af_: $author$project$Api$Pagination$initFromQuery(config.Bz),
            eK: config.eK,
            ahs: $author$project$Api$Sort$initFromQuery(config.Bz),
            HB: start,
            bH: $author$project$Api$Data$Loading,
            ahy: A2($elm$core$Dict$get, 'status', config.Bz),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'status-dropdown-filter',
                ahX: $author$project$Components$Commissions$Statement$List$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg, brokerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg, brokerAccountResourceFilterCmd),
            A2($author$project$Components$Commissions$Statement$List$fetchStatements, config.Ej, model),
            $author$project$Components$Commissions$Statement$List$updateUrl(model)
        ])));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var params = _v2.VU;
        var _v3 = $author$project$Components$Commissions$Statement$List$init({
            Ej: shared.Ej,
            bS: $elm$core$Maybe$Just(params.bS),
            pK: false,
            pL: true,
            pM: false,
            cP: shared.cP,
            Gc: $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top({
                bS: params.bS
            }),
            Bz: query,
            eK: false
        });
        var statementsTable = _v3.a;
        var statementsTableCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: statementsTable
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$ResourceFilter$BrokerAccount$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Commissions$Statement$List$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$Statement$List$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            $author$project$Ui$Dropdown$subscriptions(model.oD),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg, $author$project$Components$ResourceFilter$Broker$subscriptions(model.lj)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg, $author$project$Components$ResourceFilter$BrokerAccount$subscriptions(model.li))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Commissions$Statement$List$subscriptions(model.rk));
    };
    var $author$project$Components$ResourceFilter$BrokerAccount$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$BrokerAccount$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Commissions$Statement$List$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        bH: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    bH: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
                    $author$project$Components$Commissions$Statement$List$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
                    $author$project$Components$Commissions$Statement$List$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v2.a;
                var subCmd = _v2.b;
                var event = _v2.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
                            bH: $author$project$Api$Data$Loading
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
                    $author$project$Components$Commissions$Statement$List$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), cmd, _List_Nil);
            case 5:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    bH: $author$project$Api$Data$Loading,
                    ahy: status
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
                    $author$project$Components$Commissions$Statement$List$updateUrl(newModel)
                ])), _List_Nil);
            case 6:
                var subMsg = msg.a;
                var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.lj);
                var brokerId = function() {
                    var _v6 = brokerResourceResult.adu;
                    if (!_v6.$) {
                        if (!_v6.a.$) return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.zi);
                        else {
                            var _v7 = _v6.a;
                            return model.EC;
                        }
                    } else return model.EC;
                }();
                var newModel = _Utils_update(model, {
                    EC: brokerId,
                    lj: brokerResourceResult.zi
                });
                var _v5 = _Utils_eq(model.EC, newModel.EC) ? _Utils_Tuple2(model.bH, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
                    $author$project$Components$Commissions$Statement$List$updateUrl(newModel)
                ])));
                var statements = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    bH: statements
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg, brokerResourceResult.EQ),
                    cmd
                ])), brokerResourceResult.at);
            default:
                var subMsg = msg.a;
                var brokerAccountResourceResult = A3($author$project$Components$ResourceFilter$BrokerAccount$update, apiClient, subMsg, model.li);
                var brokerAccountId = function() {
                    var _v9 = brokerAccountResourceResult.adu;
                    if (!_v9.$) {
                        if (!_v9.a.$) return $author$project$Components$ResourceFilter$BrokerAccount$value(brokerAccountResourceResult.zi);
                        else {
                            var _v10 = _v9.a;
                            return model.bS;
                        }
                    } else return model.bS;
                }();
                var newModel = _Utils_update(model, {
                    bS: brokerAccountId,
                    li: brokerAccountResourceResult.zi
                });
                var _v8 = _Utils_eq(model.bS, newModel.bS) ? _Utils_Tuple2(model.bH, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$Statement$List$fetchStatements, apiClient, newModel),
                    $author$project$Components$Commissions$Statement$List$updateUrl(newModel)
                ])));
                var statements = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    bH: statements
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg, brokerAccountResourceResult.EQ),
                    cmd
                ])), brokerAccountResourceResult.at);
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Commissions$Statement$List$update, model.Ej, subMsg, model.rk);
        var statementsTable = _v1.a;
        var statementsTableCmd = _v1.b;
        var statementsTableOutMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: statementsTable
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd), statementsTableOutMsgs);
    });
    var $author$project$Components$Commissions$Statement$List$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$BrokerAccount$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Commissions$Statement$List$viewBrokerAccountResourceFilter = function(brokerAccountResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Commissions$Statement$List$BrokerAccountResourceFilterMsg, A2($author$project$Components$ResourceFilter$BrokerAccount$viewNew, _List_Nil, brokerAccountResourceFilter));
    };
    var $author$project$Components$Commissions$Statement$List$viewBrokerResourceFilter = function(brokerResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Commissions$Statement$List$BrokerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_Nil, brokerResourceFilter));
    };
    var $author$project$Components$Commissions$Statement$List$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$List$columns = function(showAccount) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'number', true, 'Number')
            ]),
            showAccount ? _List_fromArray([
                A3($author$project$Api$Column$init, 'broker_account', false, 'Broker Account')
            ]) : _List_Nil,
            _List_fromArray([
                A3($author$project$Api$Column$init, 'date', true, 'Period'),
                A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Bill Amount'),
                A3($author$project$Api$Column$init, 'status', true, 'Status')
            ])
        ]));
    };
    var $author$project$Api$Provider$Statement$All$amountInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Statement$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$Statement$Shared$brokerAccount = function(_v0) {
        var record = _v0;
        return record.vR;
    };
    var $author$project$Api$Provider$Statement$All$brokerAccount = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Statement$Shared$brokerAccount(shared);
    };
    var $author$project$Api$Provider$Statement$All$date = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Statement$Shared$date(shared);
    };
    var $author$project$Api$Provider$Statement$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Statement$Shared$id(shared);
    };
    var $author$project$Api$Provider$Statement$All$number = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Statement$Shared$number(shared);
    };
    var $author$project$Api$Provider$Statement$All$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Statement$Shared$status(shared);
    };
    var $author$project$Components$Commissions$Statement$List$viewStatement = F2(function(model, statement) {
        var brokerAccount = $author$project$Api$Provider$Statement$All$brokerAccount(statement);
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    model.eK ? $author$project$Ui$Table$cellSpan(1) : $author$project$Ui$Table$cellSpan(2)
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String({
                        bS: $author$project$Api$Provider$BrokerAccount$Shared$id(brokerAccount),
                        ahx: $author$project$Api$Provider$Statement$All$id(statement)
                    }), _List_Nil, _List_fromArray([
                        $elm$html$Html$text('#'),
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Statement$All$number(statement)))
                    ]))
                ]))
            ]),
            model.eK ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(3)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$BrokerAccount$Shared$name(brokerAccount))
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    model.eK ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, $author$project$Api$Provider$Statement$All$date(statement)))
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    model.eK ? $author$project$Ui$Table$cellSpan(2) : $author$project$Ui$Table$cellSpan(3)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Statement$All$amountInCents(statement)))
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Statement$All$status(statement))
                ]))
            ])
        ])));
    });
    var $author$project$Components$Commissions$Statement$List$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.bH;
            if (_v1.$ === 3) {
                var statements_ = _v1.a;
                return _Utils_Tuple2(false, statements_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var statements = _v0.b;
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No statements found.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Commissions$Statement$List$SortTable)), $author$project$Components$Commissions$Statement$List$columns(model.eK)), A2($elm$core$List$map, $author$project$Components$Commissions$Statement$List$viewStatement(model), statements), _List_Nil)
        ]);
    };
    var $author$project$Components$Commissions$Statement$List$StatusOptionSelected = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Commissions$Statement$List$viewStatusDropdown = function(model) {
        var currentText = function() {
            var _v0 = model.ahy;
            _v0$3: while(true){
                if (!_v0.$) switch(_v0.a){
                    case 'draft':
                        return 'Draft';
                    case 'issued':
                        return 'Issued';
                    case 'paid':
                        return 'Paid';
                    default:
                        break _v0$3;
                }
                else break _v0$3;
            }
            return 'Status';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentText)
        ]), _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$Statement$List$StatusOptionSelected($elm$core$Maybe$Nothing)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.ahy, $elm$core$Maybe$Nothing))
            ]), $elm$html$Html$text('All')),
            $author$project$Ui$Dropdown$separator,
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$Statement$List$StatusOptionSelected($elm$core$Maybe$Just('draft'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.ahy, $elm$core$Maybe$Just('draft')))
            ]), $elm$html$Html$text('Draft')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$Statement$List$StatusOptionSelected($elm$core$Maybe$Just('issued'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.ahy, $elm$core$Maybe$Just('issued')))
            ]), $elm$html$Html$text('Issued')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$Statement$List$StatusOptionSelected($elm$core$Maybe$Just('paid'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.ahy, $elm$core$Maybe$Just('paid')))
            ]), $elm$html$Html$text('Paid'))
        ]), model.oD);
    };
    var $author$project$Components$Commissions$Statement$List$view = function(model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('View Statements')
                    ]))
                ])),
                model.pM ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Commissions$Statement$List$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    model.pL ? A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6),
                        $author$project$Ui$Grid$spanMd(3)
                    ]), _List_fromArray([
                        $author$project$Components$Commissions$Statement$List$viewBrokerResourceFilter(model.lj)
                    ])) : $author$project$Ui$Grid$none,
                    model.pK ? A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6),
                        $author$project$Ui$Grid$spanMd(3)
                    ]), _List_fromArray([
                        $author$project$Components$Commissions$Statement$List$viewBrokerAccountResourceFilter(model.li)
                    ])) : $author$project$Ui$Grid$none,
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(2)
                    ]), _List_fromArray([
                        $author$project$Components$Commissions$Statement$List$viewStatusDropdown(model)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Components$Commissions$Statement$List$viewPanelBody(model)),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Commissions$Statement$List$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.bH)))
                ]), model.af_))
            ]))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Commissions$Statement$List$view(model.rk))
            ]),
            $2: 'Commissions | Statements'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$view
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$GotItem = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsInit = function() {
        var _v0 = $author$project$Components$AddressInput$init('broker_account');
        var addressInput = _v0.a;
        var addressInputCmd = _v0.b;
        return _Utils_Tuple2({
            II: addressInput,
            Oy: $elm$core$Maybe$Nothing,
            UG: true,
            zr: '',
            _v: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd));
    }();
    var $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerAccount$Shared$ratePeriodSchedule(shared);
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$pricingStructureFromApi = function(pricingStructure) {
        return {
            NQ: $elm$core$Maybe$Just($author$project$Api$Provider$PricingStructure$Shared$description(pricingStructure)),
            adR: $elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Provider$PricingStructure$Shared$fixedAmountInCents(pricingStructure))),
            aef: $elm$core$Maybe$Just($author$project$Api$Provider$PricingStructure$Shared$id(pricingStructure)),
            af9: $elm$core$Maybe$Just($author$project$Percentage$fromFloat($author$project$Api$Provider$PricingStructure$Shared$percentage(pricingStructure))),
            agn: $elm$core$Maybe$Just($author$project$Api$Provider$PricingStructure$Shared$pricingType(pricingStructure)),
            ahu: $elm$core$Maybe$Just($author$project$Api$Provider$PricingStructure$Shared$splitType(pricingStructure))
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval = function(ratePeriodScheduleInterval) {
        return {
            aet: $author$project$Api$Provider$RatePeriodScheduleInterval$Shared$intervalInMonths(ratePeriodScheduleInterval),
            Xq: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$pricingStructureFromApi($author$project$Api$Provider$RatePeriodScheduleInterval$Shared$pricingStructure(ratePeriodScheduleInterval))
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervalsFromApi = function(brokerAccount) {
        return A2($elm$core$Maybe$map, $elm$core$List$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval), A2($elm$core$Maybe$map, $author$project$Api$Provider$RatePeriodSchedule$Shared$intervals, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule, brokerAccount)));
    };
    var $author$project$Api$Provider$BrokerAccount$Meta$currentScheduleEnded = function(_v0) {
        var record = _v0;
        return record.MP;
    };
    var $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodSchedule = function(_v0) {
        var record = _v0.b;
        return record.P2;
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervalsFromApi = function(brokerAccount) {
        return A2($elm$core$Maybe$map, $elm$core$List$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ratePeriodScheduleIntervalToInterval), A2($elm$core$Maybe$map, $author$project$Api$Provider$RatePeriodSchedule$Shared$intervals, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodSchedule, brokerAccount)));
    };
    var $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodScheduleStartDate = function(_v0) {
        var record = _v0.b;
        return record.P3;
    };
    var $author$project$Api$Provider$BrokerAccount$Meta$futureScheduleEnded = function(_v0) {
        var record = _v0;
        return record.P4;
    };
    var $author$project$Api$Provider$BrokerAccount$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$init = F3(function(timeZone, currentDate, brokerAccount) {
        var futureStartDate_ = A2($elm$core$Maybe$map, $justinmimbs$date$Date$fromPosix(timeZone), A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$futureRatePeriodScheduleStartDate, brokerAccount));
        var futureScheduleEnded = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$Meta$futureScheduleEnded, A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$meta, brokerAccount)));
        var currentScheduleEnded = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$Meta$currentScheduleEnded, A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$meta, brokerAccount)));
        return {
            eZ: $elm$core$Maybe$Nothing,
            e_: $elm$core$Maybe$Nothing,
            ho: $elm$core$Maybe$Nothing,
            vR: brokerAccount,
            cF: $elm$core$Maybe$Nothing,
            cP: currentDate,
            am: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervalsFromApi(brokerAccount),
            MP: currentScheduleEnded,
            iE: $elm$core$Maybe$Nothing,
            Q: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervalsFromApi(brokerAccount),
            P4: futureScheduleEnded,
            fO: futureStartDate_,
            agX: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$retailEnabled, brokerAccount))
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$init = F5(function(apiClient, timeZone, currentDate, session, id) {
        var _v0 = function() {
            if (!id.$) {
                var id_ = id.a;
                return _Utils_Tuple2($elm$core$Maybe$Nothing, A3($author$project$Api$Provider$BrokerAccount$retrieve, apiClient, id_, $author$project$Components$Commissions$BrokerAccount$Form$GotItem));
            } else {
                var _v2 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsInit;
                var formFields = _v2.a;
                var formFieldsCmd = _v2.b;
                return _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$Form$init(formFields), A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$init, timeZone, currentDate, $elm$core$Maybe$Nothing))), formFieldsCmd);
            }
        }();
        var form = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2({
            e4: $elm$core$Maybe$Nothing,
            cP: currentDate,
            fr: $elm$core$Maybe$Nothing,
            fH: $elm$core$Maybe$Nothing,
            PU: form,
            aef: id,
            F6: $elm$core$Maybe$Nothing,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            HP: timeZone,
            o3: $author$project$Api$Data$NotAsked
        }, cmd);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var timeZone = _v1.HP;
        var currentDate = _v1.cP;
        var params = _v2.VU;
        var _v3 = A5($author$project$Components$Commissions$BrokerAccount$Form$init, apiClient, timeZone, currentDate, session, $elm$core$Maybe$Just(params.bS));
        var form = _v3.a;
        var cmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, cmd);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed = F3(function(a, b, c) {
        return {
            $: 11,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close = {
        $: 1
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg, $author$project$Components$PricingStructureSelect$subscriptions(model.nI))
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close = {
        $: 1
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg, $author$project$Components$PricingStructureSelect$subscriptions(model.nI))
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close = {
        $: 1
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close);
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close = {
        $: 1
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close);
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v0) {
                var retailModal = _v0.c;
                return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$subscriptions(retailModal);
            }, model.eZ))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v1) {
                var endDealModal = _v1.b;
                return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$subscriptions(endDealModal);
            }, model.iE))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v2) {
                var changeModal = _v2.c;
                return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$subscriptions(changeModal);
            }, model.e_))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$subscriptions, model.ho))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v3) {
                var isCurrent = _v3.a;
                var index = _v3.b;
                return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed, isCurrent, index));
            }, model.cF))
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$subscriptions = function(_v0) {
        var archiveRequest = _v0.e4;
        var deleteRequest = _v0.fr;
        var endModal = _v0.fH;
        var form = _v0.PU;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                if (!endModal.$) {
                    var justEndModal = endModal.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg, $author$project$Components$Broker$EndModal$subscriptions(justEndModal));
                } else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                if (!form.$) {
                    var _v3 = form.a;
                    var itemForm = _v3.a;
                    var retailSchedule = _v3.b;
                    var _v4 = $author$project$Utils$Form$fields(itemForm);
                    var address = _v4.II;
                    return $elm$core$Platform$Sub$batch(_List_fromArray([
                        A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$subscriptions(retailSchedule)),
                        A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, $author$project$Components$AddressInput$subscriptions(address))
                    ]));
                } else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, archiveRequest))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, deleteRequest)))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$subscriptions = function(model) {
        return $author$project$Components$Commissions$BrokerAccount$Form$subscriptions(model.PU);
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Address = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Archived = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Broker$EndModal$BrokerAccount = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Deleted = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$BrokerAccount$archive = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BrokerAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'archive'
        ]), $author$project$Api$Provider$BrokerAccount$brokerAccountPath(id))));
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$RatePeriodScheduleCreated = F3(function(a, b, c) {
        return {
            $: 6,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Provider$RatePeriodSchedule$One$RatePeriodSchedule = 0;
    var $author$project$Api$Provider$RatePeriodSchedule$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$encodePricingStructure = function(pricingStructure) {
        return $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = pricingStructure.aef;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        _Utils_Tuple2('id', $elm$json$Json$Encode$string(string))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = pricingStructure.NQ;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        _Utils_Tuple2('description', $elm$json$Json$Encode$string(string))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = pricingStructure.adR;
                if (!_v2.$) {
                    var _int = _v2.a;
                    return _List_fromArray([
                        _Utils_Tuple2('fixed_amount_in_cents', $author$project$Currency$encode(_int))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = pricingStructure.af9;
                if (!_v3.$) {
                    var percentage = _v3.a;
                    return _List_fromArray([
                        _Utils_Tuple2('percentage', $author$project$Percentage$encode(percentage))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = pricingStructure.ahu;
                if (!_v4.$) {
                    var splitType = _v4.a;
                    return _List_fromArray([
                        _Utils_Tuple2('split_type', $author$project$Api$SplitType$encode(splitType))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = pricingStructure.agn;
                if (!_v5.$) {
                    var pricingType_ = _v5.a;
                    return _List_fromArray([
                        _Utils_Tuple2('pricing_type', $author$project$Api$PricingType$encode(pricingType_))
                    ]);
                } else return _List_Nil;
            }()
        ])));
    };
    var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$ratePeriodSchedulesPath = function(brokerAccountId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'rate_period_schedules'
        ]), $author$project$Api$Provider$BrokerAccount$brokerAccountPath(brokerAccountId));
    };
    var $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$create = F5(function(apiClient, brokerAccountId, brokerAccountFields, fields, toMsg) {
        var encodeInterval = function(interval) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('interval_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, interval.aet)),
                _Utils_Tuple2('pricing_structure', $author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$encodePricingStructure(interval.Xq))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker_account', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                function() {
                    var _v0 = brokerAccountFields.agX;
                    if (!_v0.$) {
                        var retailEnabled = _v0.a;
                        return _List_fromArray([
                            _Utils_Tuple2('retail_enabled', $elm$json$Json$Encode$bool(retailEnabled))
                        ]);
                    } else return _List_Nil;
                }(),
                function() {
                    var _v1 = brokerAccountFields.P3;
                    if (!_v1.$) {
                        var futureRatePeriodScheduleStartDate = _v1.a;
                        return _List_fromArray([
                            _Utils_Tuple2('future_rate_period_schedule_start_date', $author$project$Utils$Date$encode(futureRatePeriodScheduleStartDate))
                        ]);
                    } else return _List_Nil;
                }()
            ])))),
            _Utils_Tuple2('rate_period_schedule', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('intervals', A2($elm$json$Json$Encode$list, encodeInterval, fields.aeu))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$RatePeriodSchedule$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$ratePeriodSchedulesPath(brokerAccountId))));
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule = F5(function(apiClient, isUpdate, brokerAccount, brokerAccountFields, intervals) {
        return A5($author$project$Api$Provider$BrokerAccount$RatePeriodSchedule$create, apiClient, $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount), brokerAccountFields, {
            aeu: intervals
        }, A2($author$project$Components$Commissions$BrokerAccount$Form$RatePeriodScheduleCreated, isUpdate, brokerAccount));
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals = function($) {
        return $.am;
    };
    var $author$project$Api$Provider$BrokerAccount$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountPath(id)));
    });
    var $author$project$Api$Provider$BrokerAccount$One$addressCity = function(_v0) {
        var record = _v0.b;
        return record.IJ;
    };
    var $author$project$Api$Provider$BrokerAccount$One$addressCountry = function(_v0) {
        var record = _v0.b;
        return record.IK;
    };
    var $author$project$Api$Provider$BrokerAccount$One$addressLine1 = function(_v0) {
        var record = _v0.b;
        return record.IL;
    };
    var $author$project$Api$Provider$BrokerAccount$One$addressLine2 = function(_v0) {
        var record = _v0.b;
        return record.IM;
    };
    var $author$project$Api$Provider$BrokerAccount$One$addressState = function(_v0) {
        var record = _v0.b;
        return record.IN;
    };
    var $author$project$Api$Provider$BrokerAccount$One$addressZip = function(_v0) {
        var record = _v0.b;
        return record.IO;
    };
    var $author$project$Api$Provider$BrokerAccount$One$ein = function(_v0) {
        var record = _v0.b;
        return record.Oy;
    };
    var $author$project$Api$Provider$BrokerAccount$Shared$multipleBrokers = function(_v0) {
        var record = _v0;
        return record.UG;
    };
    var $author$project$Api$Provider$BrokerAccount$One$multipleBrokers = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerAccount$Shared$multipleBrokers(shared);
    };
    var $author$project$Api$Provider$BrokerAccount$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerAccount$Shared$name(shared);
    };
    var $author$project$Api$Provider$BrokerAccount$One$singleBrokerName = function(_v0) {
        var record = _v0.b;
        return record._v;
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem = function(brokerAccount) {
        var _v0 = A2($author$project$Components$AddressInput$initFromFields, 'broker_account', {
            cx: $author$project$Api$Provider$BrokerAccount$One$addressLine1(brokerAccount),
            e$: $author$project$Api$Provider$BrokerAccount$One$addressLine2(brokerAccount),
            pW: $author$project$Api$Provider$BrokerAccount$One$addressCity(brokerAccount),
            p0: $author$project$Api$Provider$BrokerAccount$One$addressCountry(brokerAccount),
            s4: $author$project$Api$Provider$BrokerAccount$One$addressState(brokerAccount),
            tK: $author$project$Api$Provider$BrokerAccount$One$addressZip(brokerAccount)
        });
        var addressInput = _v0.a;
        var addressInputCmd = _v0.b;
        return _Utils_Tuple2({
            II: addressInput,
            Oy: $author$project$Api$Provider$BrokerAccount$One$ein(brokerAccount),
            UG: $author$project$Api$Provider$BrokerAccount$One$multipleBrokers(brokerAccount),
            zr: $author$project$Api$Provider$BrokerAccount$One$name(brokerAccount),
            _v: $author$project$Api$Provider$BrokerAccount$One$singleBrokerName(brokerAccount)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd));
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    Oy: $author$project$Utils$String$toMaybe(string)
                });
            case 2:
                var address = field.a;
                return _Utils_update(fields, {
                    II: address
                });
            case 3:
                var bool = field.a;
                return _Utils_update(fields, {
                    UG: bool
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    _v: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$EinValidation = 1;
    var $author$project$Components$Commissions$BrokerAccount$Form$NameValidation = 0;
    var $author$project$Ui$Form$Ein$ifInvalid = F2(function(subjectToMaybe, error) {
        return A2($rtfeldman$elm_validate$Validate$ifTrue, function(subject) {
            var _v0 = subjectToMaybe(subject);
            if (!_v0.$) {
                var ein = _v0.a;
                return !A2($author$project$Utils$Regex$matches, $author$project$Ui$Form$Ein$einFormat, ein);
            } else return false;
        }, error);
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$AddressValidation = 2;
    var $author$project$Components$Commissions$BrokerAccount$Form$validateAddress = function(fields) {
        return $author$project$Components$AddressInput$isValid(fields.II) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(2, 'Please enter an address')
        ]);
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerNameValidation = 3;
    var $author$project$Components$Commissions$BrokerAccount$Form$validateSingleBrokerName = function(fields) {
        return fields.UG ? _List_Nil : $author$project$Utils$Maybe$toBool(fields._v) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(3, 'Please enter a broker name.')
        ]);
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.')),
        A2($author$project$Ui$Form$Ein$ifInvalid, function($) {
            return $.Oy;
        }, _Utils_Tuple2(1, 'Please enter a valid EIN or leave empty')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$Form$validateAddress),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$Form$validateSingleBrokerName)
    ]));
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals = function($) {
        return $.Q;
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureStartDate = function($) {
        return $.fO;
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate = function(brokerAccount) {
        var id = $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount);
        return $author$project$Api$Provider$BrokerAccount$One$multipleBrokers(brokerAccount) ? _Utils_Tuple2(A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
            bS: id
        })), _List_Nil) : _Utils_Tuple2(A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals({
            bS: id
        })), _List_fromArray([
            $author$project$OutMsg$RefreshPractice
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Created = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$apiFields = function(fields) {
        return {
            II: $author$project$Components$AddressInput$getAddress(fields.II),
            Oy: fields.Oy,
            UG: fields.UG,
            zr: fields.zr,
            _v: fields._v
        };
    };
    var $author$project$Api$Common$Address$Shared$encodePartsWithPrefix = F2(function(prefix, address) {
        return _List_fromArray([
            _Utils_Tuple2(prefix + 'city', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.pW)),
            _Utils_Tuple2(prefix + 'country', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.p0)),
            _Utils_Tuple2(prefix + 'line1', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.ri)),
            _Utils_Tuple2(prefix + 'line2', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.yG)),
            _Utils_Tuple2(prefix + 'state', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.s4)),
            _Utils_Tuple2(prefix + 'zip', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, address.tK))
        ]);
    });
    var $author$project$Api$Common$Address$Shared$encodeParts = $author$project$Api$Common$Address$Shared$encodePartsWithPrefix('address_');
    var $author$project$Api$Provider$BrokerAccount$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker_account', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('ein', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oy)), A2($elm$core$List$cons, _Utils_Tuple2('multiple_brokers', $elm$json$Json$Encode$bool(fields.UG)), A2($elm$core$List$cons, _Utils_Tuple2('single_broker_name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields._v)), $author$project$Api$Common$Address$Shared$encodeParts(fields.II)))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$BrokerAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountsPath)));
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$createItem = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$BrokerAccount$create, apiClient, $author$project$Components$Commissions$BrokerAccount$Form$apiFields(fields), $author$project$Components$Commissions$BrokerAccount$Form$Created);
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$Updated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$BrokerAccount$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('broker_account', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('ein', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oy)), A2($elm$core$List$cons, _Utils_Tuple2('multiple_brokers', $elm$json$Json$Encode$bool(fields.UG)), A2($elm$core$List$cons, _Utils_Tuple2('single_broker_name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields._v)), $author$project$Api$Common$Address$Shared$encodeParts(fields.II)))))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$BrokerAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$BrokerAccount$brokerAccountPath(id))));
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$updateItem = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$BrokerAccount$update, apiClient, id, $author$project$Components$Commissions$BrokerAccount$Form$apiFields(fields), $author$project$Components$Commissions$BrokerAccount$Form$Updated);
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$saveItem = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A3($author$project$Components$Commissions$BrokerAccount$Form$updateItem, apiClient, id_, formFields);
        } else return A2($author$project$Components$Commissions$BrokerAccount$Form$createItem, apiClient, formFields);
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$None = 0;
    var $author$project$Formatters$Percentage$toString = function(currency) {
        var _v0 = $author$project$Percentage$toFloat(currency);
        if (!_v0.$) {
            var _float = _v0.a;
            return $author$project$Formatters$Float$toPercentage(_float);
        } else return 'N/A';
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew = function(pricingStructure) {
        var _v0 = pricingStructure.aef;
        if (!_v0.$) return {
            NQ: pricingStructure.NQ,
            adR: pricingStructure.adR,
            aef: pricingStructure.aef,
            af9: pricingStructure.af9,
            agn: pricingStructure.agn,
            ahu: pricingStructure.ahu
        };
        else {
            var splitType = _Utils_eq(pricingStructure.ahu, $elm$core$Maybe$Just(0)) ? $elm$core$Maybe$Just('for all members') : _Utils_eq(pricingStructure.ahu, $elm$core$Maybe$Just(1)) ? $elm$core$Maybe$Just('for primary member') : $elm$core$Maybe$Nothing;
            var amount = function() {
                var _v2 = _Utils_Tuple3(pricingStructure.agn, pricingStructure.adR, pricingStructure.af9);
                _v2$2: while(true){
                    if (!_v2.a.$) switch(_v2.a.a.$){
                        case 1:
                            if (!_v2.b.$) {
                                var _v3 = _v2.a.a;
                                var fixedAmountInCents = _v2.b.a;
                                return $elm$core$Maybe$Just($author$project$Currency$format(fixedAmountInCents));
                            } else break _v2$2;
                        case 0:
                            if (!_v2.c.$) {
                                var _v4 = _v2.a.a;
                                var percentage = _v2.c.a;
                                return $elm$core$Maybe$Just($author$project$Formatters$Percentage$toString(percentage));
                            } else break _v2$2;
                        default:
                            break _v2$2;
                    }
                    else break _v2$2;
                }
                return $elm$core$Maybe$Nothing;
            }();
            var description = function() {
                var _v1 = _Utils_Tuple2(amount, splitType);
                if (!_v1.a.$ && !_v1.b.$) {
                    var amount_ = _v1.a.a;
                    var splitType_ = _v1.b.a;
                    return $elm$core$Maybe$Just(amount_ + (' ' + splitType_));
                } else return $elm$core$Maybe$Nothing;
            }();
            return _Utils_update(pricingStructure, {
                NQ: description
            });
        }
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval = F3(function(pricingStructure, intervalInMonths, intervals) {
        var interval = {
            aet: $elm$core$Maybe$Nothing,
            Xq: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
        };
        return function(newIntervals) {
            return A2($elm$core$List$append, newIntervals, _List_fromArray([
                interval
            ]));
        }(A3($elm_community$list_extra$List$Extra$updateAt, $elm$core$List$length(intervals) - 1, function(lastInterval) {
            return !$elm$core$List$isEmpty(intervals) ? _Utils_update(lastInterval, {
                aet: intervalInMonths
            }) : lastInterval;
        }, intervals));
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$editFirstSchedule = F2(function(pricingStructure, intervals) {
        return A3($elm_community$list_extra$List$Extra$updateAt, 0, function(interval) {
            return _Utils_update(interval, {
                Xq: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
            });
        }, intervals);
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$editInterval = F4(function(pricingStructure, intervalInMonths, index, intervals) {
        return A3($elm_community$list_extra$List$Extra$updateAt, index, function(interval) {
            return _Utils_update(interval, {
                Xq: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$buildDescriptionIfNew(pricingStructure)
            });
        }, A3($elm_community$list_extra$List$Extra$updateAt, index - 1, function(interval) {
            return _Utils_update(interval, {
                aet: intervalInMonths
            });
        }, intervals));
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$initFormFields = {
        Xq: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init = function(apiClient) {
        var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
        var pricingStructureSelect = _v0.a;
        var pricingStructureSelectCmd = _v0.b;
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$initFormFields),
            nI: pricingStructureSelect
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg, pricingStructureSelectCmd));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$initFormFields = {
        aet: $elm$core$Maybe$Nothing,
        Xq: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init = function(apiClient) {
        var _v0 = $author$project$Components$PricingStructureSelect$init(apiClient);
        var pricingStructureSelect = _v0.a;
        var pricingStructureSelectCmd = _v0.b;
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$initFormFields),
            nI: pricingStructureSelect
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg, pricingStructureSelectCmd));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$initFormFields = function() {
        var _v0 = $author$project$Components$DateInput$init;
        var startDateDateInput = _v0.a;
        var startDateDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            _0: $elm$core$Maybe$Nothing,
            s3: startDateDateInput
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg(startDateDateInput), startDateDateInputCmd));
    }();
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$init = function(currentDate) {
        var _v0 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$initFormFields;
        var fields = _v0.a;
        var fieldsCmd = _v0.b;
        return _Utils_Tuple2({
            cP: currentDate,
            PU: $author$project$Utils$Form$init(fields)
        }, fieldsCmd);
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$initFormFields = {
        aet: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$init = $author$project$Utils$Form$init($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$initFormFields);
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval = F2(function(index, intervals) {
        var currentInterval = A2($elm_community$list_extra$List$Extra$getAt, index, intervals);
        return A2($elm_community$list_extra$List$Extra$removeAt, index, A3($elm_community$list_extra$List$Extra$updateAt, index - 1, function(interval) {
            return _Utils_update(interval, {
                aet: A2($elm$core$Maybe$andThen, function($) {
                    return $.aet;
                }, currentInterval)
            });
        }, intervals));
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed = {
        $: 1
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructure = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$RetailRateAdded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsUpdate = F2(function(field, fields) {
        var pricingStructure = field;
        return _Utils_update(fields, {
            Xq: pricingStructure
        });
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureValidation = 0;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$validatePricingStructure = function(fields) {
        var _v0 = fields.Xq;
        if (!_v0.$) {
            var pricingStructure = _v0.a;
            var _v1 = pricingStructure.aef;
            if (!_v1.$) return _List_Nil;
            else {
                var _v2 = _Utils_Tuple3(pricingStructure.agn, pricingStructure.af9, pricingStructure.adR);
                _v2$3: while(true)if (_v2.a.$ === 1) {
                    var _v3 = _v2.a;
                    return _List_fromArray([
                        _Utils_Tuple2(0, 'Please pick or create a rate.')
                    ]);
                } else switch(_v2.a.a.$){
                    case 0:
                        if (_v2.b.$ === 1) {
                            var _v4 = _v2.a.a;
                            var _v5 = _v2.b;
                            return _List_fromArray([
                                _Utils_Tuple2(0, 'Please enter a number')
                            ]);
                        } else break _v2$3;
                    case 1:
                        if (_v2.c.$ === 1) {
                            var _v6 = _v2.a.a;
                            var _v7 = _v2.c;
                            return _List_fromArray([
                                _Utils_Tuple2(0, 'Please enter an amount')
                            ]);
                        } else break _v2$3;
                    default:
                        break _v2$3;
                }
                return _List_Nil;
            }
        } else return _List_fromArray([
            _Utils_Tuple2(0, 'Please pick or create a rate.')
        ]);
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$validatePricingStructure)
    ]));
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var event = A2($elm$core$Maybe$withDefault, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Closed, A2($elm$core$Maybe$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$RetailRateAdded, $rtfeldman$elm_validate$Validate$fromValid(validFormFields).Xq));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: event,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            default:
                var subMsg = msg.a;
                var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.nI);
                var form = function() {
                    var _v4 = pricingStructureSelectResult.adu;
                    if (!_v4.$) return model.PU;
                    else {
                        var pricingStructure = _v4.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$formFieldsUpdate, pricingStructure, model.PU);
                    }
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg, pricingStructureSelectResult.EQ),
                    adu: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$None,
                    zi: _Utils_update(model, {
                        PU: form,
                        nI: pricingStructureSelectResult.zi
                    }),
                    at: pricingStructureSelectResult.at
                };
        }
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed = {
        $: 1
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructure = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$RetailRateAdded = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                aet: $elm$core$String$toInt(string)
            });
        } else {
            var pricingStructure = field.a;
            return _Utils_update(fields, {
                Xq: pricingStructure
            });
        }
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonthsValidation = 1;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validateIntervalInMonths = function(fields) {
        var validationError = _Utils_Tuple2(1, 'Please enter a number greater than 0');
        var _v0 = fields.aet;
        if (!_v0.$) {
            var intervalInMonths = _v0.a;
            return intervalInMonths > 0 ? _List_Nil : _List_fromArray([
                validationError
            ]);
        } else return _List_fromArray([
            validationError
        ]);
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureValidation = 0;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validatePricingStructure = function(fields) {
        var _v0 = fields.Xq;
        if (!_v0.$) {
            var pricingStructure = _v0.a;
            var _v1 = pricingStructure.aef;
            if (!_v1.$) return _List_Nil;
            else {
                var _v2 = _Utils_Tuple3(pricingStructure.agn, pricingStructure.af9, pricingStructure.adR);
                _v2$3: while(true)if (_v2.a.$ === 1) {
                    var _v3 = _v2.a;
                    return _List_fromArray([
                        _Utils_Tuple2(0, 'Please pick or create a rate.')
                    ]);
                } else switch(_v2.a.a.$){
                    case 0:
                        if (_v2.b.$ === 1) {
                            var _v4 = _v2.a.a;
                            var _v5 = _v2.b;
                            return _List_fromArray([
                                _Utils_Tuple2(0, 'Please enter a number')
                            ]);
                        } else break _v2$3;
                    case 1:
                        if (_v2.c.$ === 1) {
                            var _v6 = _v2.a.a;
                            var _v7 = _v2.c;
                            return _List_fromArray([
                                _Utils_Tuple2(0, 'Please enter an amount')
                            ]);
                        } else break _v2$3;
                    default:
                        break _v2$3;
                }
                return _List_Nil;
            }
        } else return _List_fromArray([
            _Utils_Tuple2(0, 'Please pick or create a rate.')
        ]);
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validateIntervalInMonths),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$validatePricingStructure)
    ]));
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var pricingStructure = _v4.Xq;
                    var intervalInMonths = _v4.aet;
                    var event = A2($elm$core$Maybe$withDefault, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Closed, A2($elm$core$Maybe$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$RetailRateAdded(intervalInMonths), pricingStructure));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: event,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var field = msg.a;
                var form = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
                    zi: _Utils_update(model, {
                        PU: form
                    }),
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                var pricingStructureSelectResult = A2($author$project$Components$PricingStructureSelect$update, subMsg, model.nI);
                var form = function() {
                    var _v5 = pricingStructureSelectResult.adu;
                    if (!_v5.$) return model.PU;
                    else {
                        var pricingStructure = _v5.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$formFieldsUpdate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructure(pricingStructure), model.PU);
                    }
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg, pricingStructureSelectResult.EQ),
                    adu: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$None,
                    zi: _Utils_update(model, {
                        PU: form,
                        nI: pricingStructureSelectResult.zi
                    }),
                    at: pricingStructureSelectResult.at
                };
        }
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Closed = {
        $: 1
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$DatePicked = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDate = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateValidation = 0;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$validateStartDate = F2(function(currentDate, fields) {
        var _v0 = fields._0;
        if (!_v0.$) {
            var startDate = _v0.a;
            return A2($justinmimbs$date$Date$compare, currentDate, startDate) !== 2 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a date greater or equal than today')
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2(0, 'Please enter a date.')
        ]);
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$validateStartDate(currentDate))
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate = F2(function(field, fields) {
        var dateInput = field.a;
        var date = field.b;
        return _Utils_update(fields, {
            _0: date,
            s3: dateInput
        });
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate, A2(field, newDateInput, date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.PU);
            }
        }();
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd), $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None);
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Closed);
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$formFieldsValidator(model.cP), model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var startDate = A2($elm$core$Maybe$withDefault, model.cP, $rtfeldman$elm_validate$Validate$fromValid(validFormFields)._0);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$DatePicked(startDate));
                } else {
                    var newForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$None);
                }
            default:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$updateDateInputFormField, model, dateInput, subMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDate, function($) {
                    return $._0;
                });
        }
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed = {
        $: 1
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$RetailRateAdded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsUpdate = F2(function(field, fields) {
        var string = field;
        return _Utils_update(fields, {
            aet: $elm$core$String$toInt(string)
        });
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$IntervalInMonthsValidation = 0;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$validateIntervalInMonths = function(fields) {
        var validationError = _Utils_Tuple2(0, 'Please enter a number greater than 0');
        var _v0 = fields.aet;
        if (!_v0.$) {
            var intervalInMonths = _v0.a;
            return intervalInMonths > 0 ? _List_Nil : _List_fromArray([
                validationError
            ]);
        } else return _List_fromArray([
            validationError
        ]);
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$validateIntervalInMonths)
    ]));
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$update = F2(function(msg, _v0) {
        var form = _v0;
        switch(msg.$){
            case 1:
                return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed);
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsValidator, form);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var _v4 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var intervalInMonths = _v4.aet;
                    var event = A2($elm$core$Maybe$withDefault, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Closed, A2($elm$core$Maybe$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$RetailRateAdded, intervalInMonths));
                    return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, event);
                } else {
                    var newForm = _v2.a;
                    return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None);
                }
            default:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$formFieldsUpdate, field, form);
                return _Utils_Tuple3(newForm, $elm$core$Platform$Cmd$none, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$None);
        }
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var _v1 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init(apiClient);
                var addRetailModal = _v1.a;
                var addRetailModalCmd = _v1.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        eZ: $elm$core$Maybe$Just(_Utils_Tuple3(true, true, addRetailModal))
                    }),
                    at: _List_Nil
                };
            case 1:
                var subMsg = msg.a;
                var _v2 = model.eZ;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var resetIntervals = _v3.a;
                    var isCurrent = _v3.b;
                    var addRetailModal = _v3.c;
                    var intervals = isCurrent ? model.am : model.Q;
                    var addRetailModalResult = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$update, subMsg, addRetailModal);
                    var _v4 = function() {
                        var _v5 = _Utils_Tuple2(addRetailModalResult.adu, resetIntervals);
                        switch(_v5.a.$){
                            case 0:
                                var _v6 = _v5.a;
                                return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_Tuple3(resetIntervals, isCurrent, addRetailModalResult.zi)), model.agX, intervals);
                            case 1:
                                if (_v5.b) {
                                    var _v7 = _v5.a;
                                    return _Utils_Tuple3($elm$core$Maybe$Nothing, false, intervals);
                                } else {
                                    var _v8 = _v5.a;
                                    return _Utils_Tuple3($elm$core$Maybe$Nothing, model.agX, intervals);
                                }
                            default:
                                if (_v5.b) {
                                    var pricingStructure = _v5.a.a;
                                    return _Utils_Tuple3($elm$core$Maybe$Nothing, true, $elm$core$Maybe$Just(A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval, pricingStructure, $elm$core$Maybe$Nothing, _List_Nil)));
                                } else {
                                    var pricingStructure = _v5.a.a;
                                    return _Utils_Tuple3($elm$core$Maybe$Nothing, model.agX, $elm$core$Maybe$Just(A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$editFirstSchedule, pricingStructure, A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
                                }
                        }
                    }();
                    var addRetailModal_ = _v4.a;
                    var retailEnabled_ = _v4.b;
                    var newIntervals = _v4.c;
                    var newModel = isCurrent ? _Utils_update(model, {
                        am: newIntervals
                    }) : _Utils_update(model, {
                        Q: newIntervals
                    });
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalResult.EQ),
                        adu: 0,
                        zi: _Utils_update(newModel, {
                            eZ: addRetailModal_,
                            agX: retailEnabled_
                        }),
                        at: addRetailModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var isCurrent = msg.a;
                var index = msg.b;
                if (!index) {
                    var _v9 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$init(apiClient);
                    var addRetailModal = _v9.a;
                    var addRetailModalCmd = _v9.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, addRetailModalCmd),
                        adu: 0,
                        zi: _Utils_update(model, {
                            eZ: $elm$core$Maybe$Just(_Utils_Tuple3(false, isCurrent, addRetailModal))
                        }),
                        at: _List_Nil
                    };
                } else {
                    var _v10 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init(apiClient);
                    var addRetailRateChangeModal = _v10.a;
                    var addRetailRateChangeModalCmd = _v10.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalCmd),
                        adu: 0,
                        zi: _Utils_update(model, {
                            e_: $elm$core$Maybe$Just(_Utils_Tuple3(isCurrent, $elm$core$Maybe$Just(index), addRetailRateChangeModal))
                        }),
                        at: _List_Nil
                    };
                }
            case 3:
                var isCurrent = msg.a;
                var intervals = isCurrent ? model.am : model.Q;
                var newIntervals = A2($elm$core$Maybe$map, function(intervals_) {
                    return A3($elm_community$list_extra$List$Extra$updateAt, $elm$core$List$length(intervals_) - 1, function(lastInterval) {
                        return _Utils_update(lastInterval, {
                            aet: $elm$core$Maybe$Nothing
                        });
                    }, intervals_);
                }, intervals);
                var newModel = isCurrent ? _Utils_update(model, {
                    am: newIntervals,
                    MP: false
                }) : _Utils_update(model, {
                    Q: newIntervals,
                    P4: false
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: newModel,
                    at: _List_Nil
                };
            case 4:
                var isCurrent = msg.a;
                var _v11 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$init(apiClient);
                var addRetailRateChangeModal = _v11.a;
                var addRetailRateChangeModalCmd = _v11.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        e_: $elm$core$Maybe$Just(_Utils_Tuple3(isCurrent, $elm$core$Maybe$Nothing, addRetailRateChangeModal))
                    }),
                    at: _List_Nil
                };
            case 5:
                var subMsg = msg.a;
                var _v12 = model.e_;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var isCurrent = _v13.a;
                    var index = _v13.b;
                    var addRetailRateChangeModal = _v13.c;
                    var intervals = isCurrent ? model.am : model.Q;
                    var addRetailRateChangeModalResult = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$update, subMsg, addRetailRateChangeModal);
                    var _v14 = function() {
                        var _v15 = _Utils_Tuple2(addRetailRateChangeModalResult.adu, index);
                        switch(_v15.a.$){
                            case 0:
                                var _v16 = _v15.a;
                                return _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple3(isCurrent, index, addRetailRateChangeModalResult.zi)), intervals);
                            case 1:
                                var _v17 = _v15.a;
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, intervals);
                            default:
                                if (_v15.b.$ === 1) {
                                    var _v18 = _v15.a;
                                    var intervalInMonths = _v18.a;
                                    var pricingStructure = _v18.b;
                                    var _v19 = _v15.b;
                                    return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$addNewInterval, pricingStructure, intervalInMonths, A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
                                } else {
                                    var _v20 = _v15.a;
                                    var intervalInMonths = _v20.a;
                                    var pricingStructure = _v20.b;
                                    var index_ = _v15.b.a;
                                    return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(A4($author$project$Components$Commissions$BrokerAccount$RetailSchedule$editInterval, pricingStructure, intervalInMonths, index_, A2($elm$core$Maybe$withDefault, _List_Nil, intervals))));
                                }
                        }
                    }();
                    var addRetailRateChangeModal_ = _v14.a;
                    var newIntervals = _v14.b;
                    var newModel = isCurrent ? _Utils_update(model, {
                        am: newIntervals
                    }) : _Utils_update(model, {
                        Q: newIntervals
                    });
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, addRetailRateChangeModalResult.EQ),
                        adu: 0,
                        zi: _Utils_update(newModel, {
                            e_: addRetailRateChangeModal_
                        }),
                        at: addRetailRateChangeModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var isCurrent = msg.a;
                var endDealModal = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$init;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        iE: $elm$core$Maybe$Just(_Utils_Tuple2(isCurrent, endDealModal))
                    }),
                    at: _List_Nil
                };
            case 7:
                var subMsg = msg.a;
                var _v21 = model.iE;
                if (!_v21.$) {
                    var _v22 = _v21.a;
                    var isCurrent = _v22.a;
                    var endDealModal = _v22.b;
                    var _v23 = isCurrent ? _Utils_Tuple2(model.MP, model.am) : _Utils_Tuple2(model.MP, model.Q);
                    var scheduleEnded = _v23.a;
                    var intervals = _v23.b;
                    var _v24 = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$update, subMsg, endDealModal);
                    var endDealModal_ = _v24.a;
                    var endDealModalCmd = _v24.b;
                    var endDealModalEvent = _v24.c;
                    var _v25 = function() {
                        switch(endDealModalEvent.$){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_Tuple2(isCurrent, endDealModal_)), scheduleEnded, intervals);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, scheduleEnded, intervals);
                            default:
                                var intervalInMonths = endDealModalEvent.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, true, A2($elm$core$Maybe$map, function(intervals_) {
                                    return A3($elm_community$list_extra$List$Extra$updateAt, $elm$core$List$length(intervals_) - 1, function(lastInterval) {
                                        return _Utils_update(lastInterval, {
                                            aet: $elm$core$Maybe$Just(intervalInMonths)
                                        });
                                    }, intervals_);
                                }, intervals));
                        }
                    }();
                    var newEndDealModal = _v25.a;
                    var scheduleEnded_ = _v25.b;
                    var newIntervals = _v25.c;
                    var newModel = isCurrent ? _Utils_update(model, {
                        am: newIntervals,
                        MP: scheduleEnded_
                    }) : _Utils_update(model, {
                        Q: newIntervals,
                        P4: scheduleEnded_
                    });
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg, endDealModalCmd),
                        adu: 0,
                        zi: _Utils_update(newModel, {
                            iE: newEndDealModal
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 8:
                var _v27 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$init(model.cP);
                var addScheduleModal = _v27.a;
                var addScheduleModalCmd = _v27.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg, addScheduleModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        ho: $elm$core$Maybe$Just(addScheduleModal)
                    }),
                    at: _List_Nil
                };
            case 9:
                var subMsg = msg.a;
                var _v28 = model.ho;
                if (!_v28.$) {
                    var addScheduleModal = _v28.a;
                    var _v29 = A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$update, subMsg, addScheduleModal);
                    var addScheduleModal_ = _v29.a;
                    var addScheduleModalCmd = _v29.b;
                    var addScheduleModalEvent = _v29.c;
                    var _v30 = function() {
                        switch(addScheduleModalEvent.$){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(addScheduleModal_), model.fO, model.Q);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.fO, model.Q);
                            default:
                                var date = addScheduleModalEvent.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(date), model.am);
                        }
                    }();
                    var addScheduleModal__ = _v30.a;
                    var futureStartDate_ = _v30.b;
                    var futureIntervals_ = _v30.c;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg, addScheduleModalCmd),
                        adu: 0,
                        zi: _Utils_update(model, {
                            ho: addScheduleModal__,
                            Q: futureIntervals_,
                            fO: futureStartDate_
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 10:
                var isCurrent = msg.a;
                var index = msg.b;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        cF: $elm$core$Maybe$Just(_Utils_Tuple2(isCurrent, index))
                    }),
                    at: _List_Nil
                };
            default:
                var isCurrent = msg.a;
                var index = msg.b;
                var confirmed = msg.c;
                if (confirmed) {
                    var _v32 = _Utils_Tuple3(isCurrent, model.am, model.Q);
                    _v32$2: while(true)if (_v32.a) {
                        if (!_v32.b.$) {
                            var currentIntervals_ = _v32.b.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: _Utils_update(model, {
                                    cF: $elm$core$Maybe$Nothing,
                                    am: $elm$core$Maybe$Just(A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval, index, currentIntervals_))
                                }),
                                at: _List_Nil
                            };
                        } else break _v32$2;
                    } else {
                        if (!_v32.c.$) {
                            var futureIntervals_ = _v32.c.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: _Utils_update(model, {
                                    cF: $elm$core$Maybe$Nothing,
                                    Q: $elm$core$Maybe$Just(A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$removeInterval, index, futureIntervals_))
                                }),
                                at: _List_Nil
                            };
                        } else break _v32$2;
                    }
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            cF: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        cF: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var brokerAccount = response.a;
                    var retailSchedule = A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$init, model.HP, model.cP, $elm$core$Maybe$Just(brokerAccount));
                    var _v3 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem(brokerAccount);
                    var formFields = _v3.a;
                    var cmd = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$Form$init(formFields), retailSchedule)),
                        F6: $elm$core$Maybe$Just(brokerAccount)
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var field = msg.a;
                var _v4 = model.PU;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var form = _v5.a;
                    var retailSchedule = _v5.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, retailSchedule))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v6 = model.PU;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var form = _v7.a;
                    var retailSchedule = _v7.b;
                    var _v8 = $author$project$Utils$Form$fields(form);
                    var address = _v8.II;
                    var _v9 = A2($author$project$Components$AddressInput$update, subMsg, address);
                    var addressInputModel = _v9.a;
                    var addressInputCmd = _v9.b;
                    var outMsgs = _v9.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Commissions$BrokerAccount$Form$formFieldsUpdate, $author$project$Components$Commissions$BrokerAccount$Form$Address(addressInputModel), form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, retailSchedule))
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, addressInputCmd), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v10 = model.PU;
                if (!_v10.$) {
                    var _v11 = _v10.a;
                    var form = _v11.a;
                    var retailSchedule = _v11.b;
                    var _v12 = A2($author$project$Utils$Form$validate, $author$project$Components$Commissions$BrokerAccount$Form$formFieldsValidator, form);
                    if (!_v12.$) {
                        var _v13 = _v12.a;
                        var newForm = _v13.a;
                        var validFormFields = _v13.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, retailSchedule)),
                            j_: $author$project$Api$Data$Loading
                        }), A3($author$project$Components$Commissions$BrokerAccount$Form$saveItem, apiClient, model.aef, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v12.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, retailSchedule)),
                            j_: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                var _v14 = model.PU;
                if (!_v14.$) {
                    var _v15 = _v14.a;
                    var retailSchedule = _v15.b;
                    if (response.$ === 3) {
                        var brokerAccount = response.a;
                        var _v17 = function() {
                            var _v18 = $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals(retailSchedule);
                            if (!_v18.$) {
                                var currentIntervals = _v18.a;
                                return _Utils_Tuple2(A5($author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule, apiClient, false, brokerAccount, {
                                    P3: $elm$core$Maybe$Nothing,
                                    agX: $elm$core$Maybe$Just(true)
                                }, currentIntervals), _List_Nil);
                            } else return $author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate(brokerAccount);
                        }();
                        var cmd = _v17.a;
                        var outMsgs = _v17.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            j_: response
                        }), cmd, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 3, 'Broker Account successfully created'), outMsgs));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var response = msg.a;
                var _v19 = model.PU;
                if (!_v19.$) {
                    if (response.$ === 3) {
                        var brokerAccount = response.a;
                        var retailSchedule = A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$init, model.HP, model.cP, $elm$core$Maybe$Just(brokerAccount));
                        var _v21 = $author$project$Components$Commissions$BrokerAccount$Form$formFieldsFromItem(brokerAccount);
                        var formFields = _v21.a;
                        var cmd = _v21.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$Form$init(formFields), retailSchedule)),
                            j_: response
                        }), cmd, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Broker Account updated')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var isUpdate = msg.a;
                var brokerAccount = msg.b;
                var response = msg.c;
                var _v22 = model.PU;
                if (!_v22.$) {
                    if (response.$ === 3) {
                        var _v24 = isUpdate ? _Utils_Tuple3($elm$core$Platform$Cmd$none, _List_Nil, 'Retail commission schedule updated') : A2($author$project$Utils$Tuple3$fromTuple2, 'Rate schedule successfully created', $author$project$Components$Commissions$BrokerAccount$Form$redirectAfterCreate(brokerAccount));
                        var cmd = _v24.a;
                        var outMsgs = _v24.b;
                        var messsage = _v24.c;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Nothing,
                            o3: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            cmd,
                            A3($author$project$Api$Provider$BrokerAccount$retrieve, apiClient, $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount), $author$project$Components$Commissions$BrokerAccount$Form$GotItem)
                        ])), A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 3, messsage), outMsgs));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        o3: $author$project$Api$Data$NotAsked
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top({
                        bS: $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount)
                    })), $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var brokerAccount = msg.a;
                var _v25 = model.PU;
                if (!_v25.$) {
                    var _v26 = _v25.a;
                    var retailSchedule = _v26.b;
                    var _v27 = $author$project$Api$Provider$BrokerAccount$One$retailEnabled(brokerAccount) ? _Utils_Tuple2({
                        P3: $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureStartDate(retailSchedule),
                        agX: $elm$core$Maybe$Nothing
                    }, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals(retailSchedule)) : _Utils_Tuple2({
                        P3: $elm$core$Maybe$Nothing,
                        agX: $elm$core$Maybe$Just(true)
                    }, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$currentIntervals(retailSchedule));
                    var brokerAccountFields = _v27.a;
                    var intervals = _v27.b;
                    if (!intervals.$) {
                        var intervals_ = intervals.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            o3: $author$project$Api$Data$Loading
                        }), A5($author$project$Components$Commissions$BrokerAccount$Form$createRetailSchedule, apiClient, true, brokerAccount, brokerAccountFields, intervals_), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var brokerAccount = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    e4: $elm$core$Maybe$Just(_Utils_Tuple2(brokerAccount, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var brokerAccount = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    e4: $elm$core$Maybe$Just(_Utils_Tuple2(brokerAccount, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$BrokerAccount$archive, apiClient, $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount), $author$project$Components$Commissions$BrokerAccount$Form$Archived(brokerAccount)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    e4: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var brokerAccount = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Broker Account archived')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    e4: $elm$core$Maybe$Just(_Utils_Tuple2(brokerAccount, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                var brokerAccount = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(brokerAccount, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var brokerAccount = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(brokerAccount, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$BrokerAccount$delete, apiClient, $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount), $author$project$Components$Commissions$BrokerAccount$Form$Deleted(brokerAccount)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var brokerAccount = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Broker Account deleted')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(brokerAccount, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                var brokerAccount = msg.a;
                var _v31 = A3($author$project$Components$Broker$EndModal$init, model.Z$, model.cP, $author$project$Components$Broker$EndModal$BrokerAccount(brokerAccount));
                var endModal = _v31.a;
                var endModalCmd = _v31.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    fH: $elm$core$Maybe$Just(endModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg, endModalCmd), _List_Nil);
            case 15:
                var subMsg = msg.a;
                var _v32 = model.fH;
                if (!_v32.$) {
                    var endModal = _v32.a;
                    var endModalResult = A3($author$project$Components$Broker$EndModal$update, apiClient, subMsg, endModal);
                    var _v33 = function() {
                        var _v34 = endModalResult.adu;
                        switch(_v34.$){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(endModalResult.zi), model.PU, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.PU, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.PU, $elm$core$Platform$Cmd$none);
                            default:
                                var brokerAccount = _v34.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, A3($author$project$Api$Provider$BrokerAccount$retrieve, apiClient, $author$project$Api$Provider$BrokerAccount$One$id(brokerAccount), $author$project$Components$Commissions$BrokerAccount$Form$GotItem));
                        }
                    }();
                    var endModal_ = _v33.a;
                    var form = _v33.b;
                    var cmd = _v33.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fH: endModal_,
                        PU: form
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg, endModalResult.EQ),
                        cmd
                    ])), endModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v35 = model.PU;
                if (!_v35.$) {
                    var _v36 = _v35.a;
                    var form = _v36.a;
                    var retailSchedule = _v36.b;
                    var retailScheduleResult = A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$update, apiClient, subMsg, retailSchedule);
                    var newForm = function() {
                        var _v37 = retailScheduleResult.adu;
                        return form;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, retailScheduleResult.zi))
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg, retailScheduleResult.EQ), retailScheduleResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$update = F2(function(msg, model) {
        var _v0 = A3($author$project$Components$Commissions$BrokerAccount$Form$update, model.Ej, msg, model.PU);
        var form = _v0.a;
        var cmd = _v0.b;
        var outMsgs = _v0.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), cmd, outMsgs);
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$Save = {
        $: 3
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$button = function(model) {
        var label = function() {
            var _v0 = model.aef;
            if (!_v0.$) return 'Update';
            else return 'Add new account';
        }();
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$Form$Save)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add retail commission')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate),
                    $author$project$Ui$Form$horizontal
                ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$PricingStructureSelectMsg), A2($author$project$Components$PricingStructureSelect$view, _List_fromArray([
                    $author$project$Components$PricingStructureSelect$value(fields.Xq),
                    $author$project$Components$PricingStructureSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Components$PricingStructureSelect$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ]), model.nI))),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancle and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add retail rate'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$AddRetailRate)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonths = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add retail commission')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate),
                    $author$project$Ui$Form$horizontal
                ]), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Number of months'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(4),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.aet))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$FormUpdated, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$IntervalInMonths)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Identify in how many months the rate should be changed')
                    ]))
                ])), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$PricingStructureSelectMsg), A2($author$project$Components$PricingStructureSelect$view, _List_fromArray([
                    $author$project$Components$PricingStructureSelect$value(fields.Xq),
                    $author$project$Components$PricingStructureSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Components$PricingStructureSelect$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ]), model.nI)))),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add retail rate'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$AddRetailRate)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Confirm retail rate change')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('You are about to change the retail commission structure. This will not update the existing deals on this rate.')
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Effective date'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(4),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$StartDateDateInputMsg(fields.s3), A2($author$project$Components$DateInput$view, _List_fromArray([
                            $author$project$Components$DateInput$value(fields._0),
                            $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                        ]), fields.s3))
                    ]))
                ])),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Revert to previous rate'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Revert to previous rate')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Change rate'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$ChangeRate)
                ]), _List_fromArray([
                    $elm$html$Html$text('Change rate')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$IntervalInMonths = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$view = function(_v0) {
        var form = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add retail commission')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Number of months'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(4),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.aet))),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$FormUpdated, $elm$core$Basics$identity)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                        ])),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            $elm$html$Html$text('Identify in how many months the rate should be changed')
                        ]))
                    ]))
                ])),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add retail rate'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$AddRetailRate)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$modal = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.cF;
                if (!_v0.$) {
                    var _v1 = _v0.a;
                    var isCurrent = _v1.a;
                    var index = _v1.b;
                    return A2($author$project$Components$HiConfirm$modal, A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$CancelHiConfirmClosed, isCurrent, index), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('cancel'),
                        $author$project$Components$HiConfirm$noun('interval rate'),
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('Are you sure you want to cancel this rate?')
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v2 = model.ho;
                if (!_v2.$) {
                    var addScheduleModal = _v2.a;
                    return A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModalMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddScheduleModal$view(addScheduleModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.eZ;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var addRetailModal = _v4.c;
                    return A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModalMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailModal$view(addRetailModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.e_;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var addRetailRateChangeModal = _v6.c;
                    return A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModalMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChangeModal$view(addRetailRateChangeModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v7 = model.iE;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var endDealModal = _v8.b;
                    return A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModalMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDealModal$view(endDealModal));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$modal = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.e4;
                if (!_v0.$) {
                    var _v1 = _v0.a;
                    var brokerAccount = _v1.a;
                    var archiveRequest = _v1.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Commissions$BrokerAccount$Form$ArchiveHiConfirmClosed(brokerAccount), _List_fromArray([
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('This will end all brokers effective today and will archive the broker account.')
                        ])),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(archiveRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v2 = model.fr;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var brokerAccount = _v3.a;
                    var deleteRequest = _v3.b;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Commissions$BrokerAccount$Form$DeleteHiConfirmClosed(brokerAccount), _List_fromArray([
                        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                            $elm$html$Html$text('Once deleted this broker account can not be recovered.  All data, historical and current will be deleted.  To hide this broker account from view without deleting data it can be archived.')
                        ])),
                        $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v4 = model.fH;
                if (!_v4.$) {
                    var endModal = _v4.a;
                    return A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$Form$EndModalMsg, $author$project$Components$Broker$EndModal$view(endModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.PU;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var retailSchedule = _v6.b;
                    return A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$modal(retailSchedule));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Archive = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Ein = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$EndAllDeals = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$MultipleBrokers = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerName = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$UpdateRetailCommissionSchedule = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$retailEnabled = function($) {
        return $.agX;
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$ShowAddRetailModal = {
        $: 0
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$Cancel = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EditInterval = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval = F5(function(showControls, intervals, isCurrent, index, interval) {
        var previousInterval = A2($elm_community$list_extra$List$Extra$getAt, index - 1, intervals);
        return A2($elm$html$Html$li, _List_fromArray([
            $elm$html$Html$Attributes$class('timeline__item')
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$margin(2)
            ]), function() {
                if (previousInterval.$ === 1) return _List_fromArray([
                    $elm$html$Html$text('Start of the deal')
                ]);
                else {
                    var previousInterval_ = previousInterval.a;
                    return _List_fromArray([
                        $elm$html$Html$text('After '),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, previousInterval_.aet))),
                        $elm$html$Html$text(' months')
                    ]);
                }
            }()),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', interval.Xq.NQ)),
                showControls ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    function() {
                        var label = !index ? 'Edit Rate' : 'Edit Rate Change';
                        return A3($author$project$Ui$Button$view, {
                            abP: label
                        }, _List_fromArray([
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$margin(11),
                            $author$project$Ui$Button$onClick(A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EditInterval, isCurrent, index)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                        ]), _List_fromArray([
                            $elm$html$Html$text(label)
                        ]));
                    }(),
                    !index ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                        abP: 'Cancel rate change'
                    }, _List_fromArray([
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$margin(11),
                        $author$project$Ui$Button$onClick(A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$Cancel, isCurrent, index)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel Rate Change')
                    ]))
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChange = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDeal = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$RemoveEndDeal = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions = F5(function(showRemoveEndDeal, showControls, scheduleEnded, isCurrent, intervals) {
        return _List_fromArray([
            function() {
                if (scheduleEnded) {
                    var lastInterval = $elm_community$list_extra$List$Extra$last(intervals);
                    return A2($elm$html$Html$li, _List_fromArray([
                        $elm$html$Html$Attributes$class('timeline__item')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(2)
                        ]), _List_fromArray([
                            $elm$html$Html$text('End after '),
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, A2($elm$core$Maybe$andThen, function($) {
                                return $.aet;
                            }, lastInterval)))),
                            $elm$html$Html$text(' months')
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            scheduleEnded && showRemoveEndDeal ? A2($elm$html$Html$li, _List_fromArray([
                $elm$html$Html$Attributes$class('timeline__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Remove end date'
                }, _List_fromArray([
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$RemoveEndDeal(isCurrent)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Remove End Date')
                ]))
            ])) : $author$project$Utils$Html$empty,
            !scheduleEnded && showControls ? A2($elm$html$Html$li, _List_fromArray([
                $elm$html$Html$Attributes$class('timeline__item')
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Add rate change'
                    }, _List_fromArray([
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$margin(11),
                        $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddRetailRateChange(isCurrent)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add Rate Change')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'End the deal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$margin(11),
                        $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$EndDeal(isCurrent)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('End The Deal')
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty
        ]);
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewCurrentRatePeriodSchedule = F2(function(hasSavedSchedule, model) {
        var currentIntervals_ = A2($elm$core$Maybe$withDefault, _List_Nil, model.am);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Current retail schedule')
        ]), _List_fromArray([
            A2($elm$html$Html$ul, _List_fromArray([
                $elm$html$Html$Attributes$class('timeline')
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$indexedMap, A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval, !hasSavedSchedule, currentIntervals_, true), currentIntervals_),
                _List_fromArray([
                    A2($elm$html$Html$li, _List_fromArray([
                        $elm$html$Html$Attributes$class('timeline__item')
                    ]), _List_fromArray([
                        hasSavedSchedule && !model.MP ? A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(2)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Recurring Deal')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]),
                A5($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions, !hasSavedSchedule, !hasSavedSchedule, model.MP, true, currentIntervals_)
            ])))
        ]));
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddNewSchedule = {
        $: 8
    };
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewFutureRatePeriodSchedule = F2(function(futureScheduleEnded, model) {
        var futureIntervals_ = A2($elm$core$Maybe$withDefault, _List_Nil, model.Q);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Future retail schedule')
        ]), _List_fromArray([
            function() {
                var _v0 = model.fO;
                if (!_v0.$) {
                    var futureStartDate_ = _v0.a;
                    return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Updated rate starting from '),
                        $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, futureStartDate_))
                    ]));
                } else return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Add new schedule'
                    }, _List_fromArray([
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$margin(11),
                        $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$RetailSchedule$AddNewSchedule),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add new schedule')
                    ]))
                ]));
            }(),
            A2($elm$html$Html$ul, _List_fromArray([
                $elm$html$Html$Attributes$class('timeline')
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$indexedMap, A3($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewInterval, true, futureIntervals_, false), futureIntervals_),
                A5($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewRatePeriodScheduleActions, true, $author$project$Utils$Maybe$toBool(model.fO), futureScheduleEnded, false, futureIntervals_)
            ])))
        ]));
    });
    var $author$project$Components$Commissions$BrokerAccount$RetailSchedule$view = function(model) {
        var hasSavedSchedule = $author$project$Utils$Maybe$toBool(A2($elm$core$Maybe$andThen, $author$project$Api$Provider$BrokerAccount$One$ratePeriodSchedule, model.vR));
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Retail commission schedule')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Retail Commissions')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Enable commission on retail memberships')
                ])),
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(model.agX),
                    $author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$always($author$project$Components$Commissions$BrokerAccount$RetailSchedule$ShowAddRetailModal)),
                    $author$project$Ui$ToggleSwitch$disabled(model.agX)
                ]))
            ])),
            model.agX ? A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewCurrentRatePeriodSchedule, hasSavedSchedule, model) : $author$project$Utils$Html$empty,
            model.agX && hasSavedSchedule ? A2($author$project$Components$Commissions$BrokerAccount$RetailSchedule$viewFutureRatePeriodSchedule, model.P4, model) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$Delete = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Provider$BrokerAccount$Meta$destroyable = function(_v0) {
        var record = _v0;
        return record.NV;
    };
    var $author$project$Components$Commissions$BrokerAccount$Form$viewDeleteButton = F2(function(brokerAccount, saveRequest) {
        return $author$project$Api$Provider$BrokerAccount$Meta$destroyable($author$project$Api$Provider$BrokerAccount$One$meta(brokerAccount)) ? A3($author$project$Ui$Button$view, {
            abP: 'Delete broker account'
        }, _List_fromArray([
            $author$project$Ui$Button$danger,
            $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$Form$Delete(brokerAccount))
        ]), _List_fromArray([
            $elm$html$Html$text('Delete')
        ])) : A3($author$project$Ui$Tooltip$view, _List_Nil, 'Statements have been issued or paid so this broker account can no longer be deleted.  Archive this account to hide it from view.', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Delete broker account'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$disabled(true)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete')
            ]))
        ]));
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$viewForm = F3(function(model, retailSchedule, form) {
        var fields = $author$project$Utils$Form$fields(form);
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$label('Business Name')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.zr),
                        $author$project$Ui$Form$Input$placeholder('e.g. Heffernan Insurance Brokers'),
                        $author$project$Ui$Form$Input$autofocus(true),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$Name)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('EIN')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Ein$view(_List_fromArray([
                        $author$project$Ui$Form$Ein$value(fields.Oy),
                        $author$project$Ui$Form$Ein$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$Ein)),
                        $author$project$Ui$Form$Ein$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                        $author$project$Ui$Form$Ein$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Legal Address')
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$Form$AddressInputMsg, A2($author$project$Components$AddressInput$view, _List_Nil, fields.II))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Multiple Brokers')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Will this account cover more than one broker?')
                    ])),
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(fields.UG),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$MultipleBrokers))
                    ]))
                ]))
            ]),
            fields.UG ? _List_Nil : _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$label('Broker Name')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields._v)),
                        $author$project$Ui$Form$Input$placeholder('e.g. John Doe'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Commissions$BrokerAccount$Form$FormUpdated, $author$project$Components$Commissions$BrokerAccount$Form$SingleBrokerName)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
                    ]))
                ]))
            ]),
            function() {
                var _v0 = model.aef;
                if (!_v0.$) return _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(2),
                            $author$project$Ui$Grid$offsetSm(6)
                        ]), _List_fromArray([
                            $author$project$Components$Commissions$BrokerAccount$Form$button(model)
                        ]))
                    ]))
                ]);
                else return _List_Nil;
            }(),
            _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                A2($elm$html$Html$map, $author$project$Components$Commissions$BrokerAccount$Form$RetailScheduleMsg, $author$project$Components$Commissions$BrokerAccount$RetailSchedule$view(retailSchedule)),
                function() {
                    var _v1 = model.F6;
                    if (!_v1.$) {
                        var item = _v1.a;
                        return $author$project$Components$Commissions$BrokerAccount$RetailSchedule$retailEnabled(retailSchedule) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(2),
                                $author$project$Ui$Grid$offsetSm(6)
                            ]), _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Update retail schedule'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$primary,
                                    $author$project$Ui$Button$loading(_Utils_eq(model.o3, $author$project$Api$Data$Loading)),
                                    $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$Form$UpdateRetailCommissionSchedule(item)),
                                    $author$project$Ui$Button$disabled($author$project$Api$Provider$BrokerAccount$One$retailEnabled(item) && !$author$project$Utils$Maybe$toBool($author$project$Components$Commissions$BrokerAccount$RetailSchedule$futureIntervals(retailSchedule)))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Update')
                                ]))
                            ]))
                        ])) : $author$project$Utils$Html$empty;
                    } else return $author$project$Utils$Html$empty;
                }()
            ]),
            function() {
                var _v2 = model.F6;
                if (!_v2.$) {
                    var item = _v2.a;
                    return _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text('Archive Broker Account')
                        ])),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$gray
                        ]), _List_fromArray([
                            $elm$html$Html$text('Archive this broker account to hide it from the list. If no statements are paid you may also delete this broker account; deleting an account will also delete all historical commission calculations and date, this cannot be undone.')
                        ])),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$gray
                        ]), _List_fromArray([
                            $elm$html$Html$text('Ending all deals will stop all future commission calculations, but will not archive the account. The end date can be today or in the future.')
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Archive broker account'
                            }, _List_fromArray([
                                $author$project$Ui$Button$danger,
                                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                                $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$Form$Archive(item))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Archive')
                            ])),
                            A2($author$project$Components$Commissions$BrokerAccount$Form$viewDeleteButton, item, model.j_),
                            A3($author$project$Ui$Button$view, {
                                abP: 'End all deals for account'
                            }, _List_fromArray([
                                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                                $author$project$Ui$Button$onClick($author$project$Components$Commissions$BrokerAccount$Form$EndAllDeals(item))
                            ]), _List_fromArray([
                                $elm$html$Html$text('End All Deals')
                            ]))
                        ]))
                    ]);
                } else return _List_Nil;
            }()
        ]));
    });
    var $author$project$Components$Commissions$BrokerAccount$Form$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            $author$project$Components$Commissions$BrokerAccount$Form$modal(model),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        function() {
                            var _v1 = model.aef;
                            if (!_v1.$) return $elm$html$Html$text('Broker Account Information');
                            else return $elm$html$Html$text('Add New Broker Account');
                        }()
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$view, _List_fromArray([
                        $author$project$Ui$Form$horizontal,
                        $author$project$Ui$Form$noValidate(true),
                        $author$project$Ui$Form$autocomplete(false)
                    ]), function() {
                        var _v2 = model.PU;
                        if (!_v2.$) {
                            var _v3 = _v2.a;
                            var form = _v3.a;
                            var retailSchedule = _v3.b;
                            return A3($author$project$Components$Commissions$BrokerAccount$Form$viewForm, model, retailSchedule, form);
                        } else return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]))
                        ]);
                    }())
                ])),
                function() {
                    var _v4 = model.aef;
                    if (!_v4.$) return $author$project$Ui$Panel$none;
                    else return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter,
                            $author$project$Ui$Element$itemsCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            $author$project$Components$Commissions$BrokerAccount$Form$button(model)
                        ]))
                    ]));
                }()
            ]))
        ]);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$view = function(model) {
        return {
            fb: $author$project$Components$Commissions$BrokerAccount$Form$view(model.PU),
            $2: 'Commissions | Broker Accounts'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$New$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var timeZone = _v1.HP;
        var currentDate = _v1.cP;
        var _v3 = A5($author$project$Components$Commissions$BrokerAccount$Form$init, apiClient, timeZone, currentDate, session, $elm$core$Maybe$Nothing);
        var form = _v3.a;
        var cmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, cmd);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$New$subscriptions = function(model) {
        return $author$project$Components$Commissions$BrokerAccount$Form$subscriptions(model.PU);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$New$update = F2(function(msg, model) {
        var _v0 = A3($author$project$Components$Commissions$BrokerAccount$Form$update, model.Ej, msg, model.PU);
        var form = _v0.a;
        var cmd = _v0.b;
        var outMsgs = _v0.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), cmd, outMsgs);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$New$view = function(model) {
        return {
            fb: $author$project$Components$Commissions$BrokerAccount$Form$view(model.PU),
            $2: 'Commissions | Broker Accounts'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$New$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$New$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$New$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$New$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$New$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$New$view
    });
    var $author$project$Pages$Commissions$BrokerAccounts$Top$GotBrokerAccounts = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts = function(model) {
        return A3($author$project$Api$Provider$BrokerAccount$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Pages$Commissions$BrokerAccounts$Top$GotBrokerAccounts);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$init = F4(function(_v0, _v1, _v2, _v3) {
        var apiClient = _v2.Ej;
        var query = _v3.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: apiClient,
            hG: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: $author$project$Api$Sort$initFromQuery(query)
        };
        return _Utils_Tuple2(model, $author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(model));
    });
    var $author$project$Pages$Commissions$BrokerAccounts$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$BrokerAccounts$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$BrokerAccounts$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        hG: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    hG: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(newModel),
                    $author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(newModel),
                    $author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            hG: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Commissions$BrokerAccounts$Top$fetchBrokerAccounts(qModel),
                            $author$project$Pages$Commissions$BrokerAccounts$Top$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Commissions$BrokerAccounts$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', false, 'Name'),
        A3($author$project$Api$Column$init, 'brokers', false, 'Brokers'),
        A3($author$project$Api$Column$init, 'retail_enabled', true, 'Retail Enabled')
    ]);
    var $author$project$Api$Provider$BrokerAccount$All$brokers = function(_v0) {
        var record = _v0.b;
        return record.Kr;
    };
    var $author$project$Api$Provider$BrokerAccount$All$retailEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$BrokerAccount$Shared$retailEnabled(shared);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$viewBrokerAccount = function(brokerAccount) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals({
                    bS: $author$project$Api$Provider$BrokerAccount$All$id(brokerAccount)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$BrokerAccount$All$name(brokerAccount))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$toSentence(A2($elm$core$List$map, $author$project$Api$Provider$Broker$Shared$name, $author$project$Api$Provider$BrokerAccount$All$brokers(brokerAccount))))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Provider$BrokerAccount$All$retailEnabled(brokerAccount)))
            ]))
        ]));
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.hG;
            if (_v1.$ === 3) {
                var brokerAccounts_ = _v1.a;
                return _Utils_Tuple2(false, brokerAccounts_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var brokerAccounts = _v0.b;
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(function() {
                    var _v2 = model.agq;
                    if (!_v2.$) return _List_fromArray([
                        $elm$html$Html$text('No matching results. Please check your search query or '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('create a new broker account')
                        ])),
                        $elm$html$Html$text('.')
                    ]);
                    else return _List_fromArray([
                        $elm$html$Html$text("It looks like you haven\u2019t added any broker accounts yet. "),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Create one')
                        ])),
                        $elm$html$Html$text('?')
                    ]);
                }()),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Commissions$BrokerAccounts$Top$SortTable)), $author$project$Pages$Commissions$BrokerAccounts$Top$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Pages$Commissions$BrokerAccounts$Top$viewBrokerAccount, brokerAccounts), _List_Nil)
        ]);
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Manage Broker Accounts')
                            ])),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New, _List_fromArray([
                                $author$project$Ui$Link$buttonDefault,
                                $author$project$Ui$Link$pull(1),
                                $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Add Account')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(10)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$gray
                                ]), _List_fromArray([
                                    $elm$html$Html$text('A broker account represents the business entity to which you will pay a commission.  You can add more than one broker to each account, but those brokers will not each receive a statement.')
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                                    $author$project$Ui$SearchInput$placeholder('Search for account and broker names')
                                ]), model.sG))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Commissions$BrokerAccounts$Top$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        function() {
                            var _v0 = model.hG;
                            if (_v0.$ === 3) return A2($elm$html$Html$map, $author$project$Pages$Commissions$BrokerAccounts$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_));
                            else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]),
            $2: 'Commissions | Broker Accounts'
        };
    };
    var $author$project$Pages$Commissions$BrokerAccounts$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$BrokerAccounts$Top$init,
        aeR: $author$project$Pages$Commissions$BrokerAccounts$Top$load,
        ag3: $author$project$Pages$Commissions$BrokerAccounts$Top$save,
        ahE: $author$project$Pages$Commissions$BrokerAccounts$Top$subscriptions,
        aaO: $author$project$Pages$Commissions$BrokerAccounts$Top$update,
        aid: $author$project$Pages$Commissions$BrokerAccounts$Top$view
    });
    var $author$project$Pages$Commissions$StatementLines$Summary$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$StatementLines$Summary = 1;
    var $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$ByDropdownMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$PayableDropdownMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$StatementLine = 2;
    var $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Utils$QueryParameter$fromTuple = function(_v0) {
        var key = _v0.a;
        var value = _v0.b;
        return A2($elm$url$Url$Builder$string, key, value);
    };
    var $author$project$Utils$QueryParameter$fromList = function(list) {
        return A2($elm$core$List$map, $author$project$Utils$QueryParameter$fromTuple, list);
    };
    var $author$project$Utils$QueryParameter$fromDict = function(dict) {
        return $author$project$Utils$QueryParameter$fromList($elm$core$Dict$toList(dict));
    };
    var $author$project$Components$Commissions$StatementLines$urlParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('q'), model.agq),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('broker_account'), model.bS),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('statement'), model.ahx),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('broker'), model.EC),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('company'), model.fl),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('payable'), $author$project$Utils$Bool$toString), model.af5),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('by'), model.bT)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Components$Commissions$StatementLines$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            function() {
                var _v0 = model.bT;
                if (!_v0.$) return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__StatementLines__Summary);
                else return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Commissions__StatementLines__Top);
            }()
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), $author$project$Utils$QueryParameter$fromDict($author$project$Components$Commissions$StatementLines$urlParams(model)))));
    };
    var $author$project$Components$Commissions$StatementLines$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Commissions$StatementLines$GotStatementLines = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$fetchStatementLinesParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                vQ: model.EC,
                vR: model.bS,
                acy: model.fl,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af_: model.af_,
                af5: model.af5,
                agq: model.agq,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                HC: model.ahx
            });
        };
    };
    var $author$project$Api$Provider$StatementLine$All$StatementLine = $elm$core$Basics$identity;
    var $author$project$Api$Provider$StatementLine$All$Record = function(type_) {
        return function(dealType) {
            return function(date) {
                return function(statementNumber) {
                    return function(payable) {
                        return function(amountInCents) {
                            return function(description) {
                                return function(patient) {
                                    return function(owner) {
                                        return function(broker) {
                                            return function(statementAdjustment) {
                                                return function(charge) {
                                                    return function(company) {
                                                        return {
                                                            Jh: amountInCents,
                                                            vQ: broker,
                                                            ach: charge,
                                                            acy: company,
                                                            M4: date,
                                                            Nk: dealType,
                                                            NQ: description,
                                                            VM: owner,
                                                            V7: patient,
                                                            af5: payable,
                                                            _4: statementAdjustment,
                                                            _6: statementNumber,
                                                            ah5: type_
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$BrokerDeal$DealType$Company = 0;
    var $author$project$Api$Provider$BrokerDeal$DealType$Membership = 1;
    var $author$project$Api$Provider$BrokerDeal$DealType$decoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'Company':
                return $elm$json$Json$Decode$succeed(0);
            case 'Membership':
                return $elm$json$Json$Decode$succeed(1);
            default:
                var somethingElse = string;
                return $elm$json$Json$Decode$fail('Unknown BrokerDeal.DealType: ' + somethingElse);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$Charge$SharedWithInvoice$Charge = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Charge$SharedWithInvoice$Record = function(invoice) {
        return {
            RA: invoice
        };
    };
    var $author$project$Api$Provider$Charge$SharedWithInvoice$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$SharedWithInvoice$Record));
    var $author$project$Api$Provider$Charge$SharedWithInvoice$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$SharedWithInvoice$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$SharedWithInvoice$Charge)));
    var $author$project$Api$Provider$StatementAdjustment$Min$StatementAdjustment = $elm$core$Basics$identity;
    var $author$project$Api$Provider$StatementAdjustment$Min$Record = F2(function(category, memo) {
        return {
            EL: category,
            ae0: memo
        };
    });
    var $author$project$Api$Provider$StatementAdjustment$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'memo', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementAdjustment$Min$Record)));
    var $author$project$Api$Provider$StatementAdjustment$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$StatementAdjustment$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$StatementLine$All$CommissionBillLine = 0;
    var $author$project$Api$Provider$StatementLine$All$StatementAdjustmentLine = 1;
    var $author$project$Api$Provider$StatementLine$All$typeDecoder = A2($elm$json$Json$Decode$andThen, function(string) {
        switch(string){
            case 'CommissionBillLine':
                return $elm$json$Json$Decode$succeed(0);
            case 'StatementAdjustmentLine':
                return $elm$json$Json$Decode$succeed(1);
            default:
                var somethingElse = string;
                return $elm$json$Json$Decode$fail('Unknown StatementLine.type: ' + somethingElse);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$StatementLine$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $elm$json$Json$Decode$maybe($author$project$Api$Provider$Company$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$SharedWithInvoice$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'statement_adjustment', $elm$json$Json$Decode$nullable($author$project$Api$Provider$StatementAdjustment$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'broker', $author$project$Api$Provider$Broker$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'statement_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deal_type', $elm$json$Json$Decode$nullable($author$project$Api$Provider$BrokerDeal$DealType$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Provider$StatementLine$All$typeDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementLine$All$Record))))))))))))));
    var $author$project$Api$Provider$StatementLine$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$StatementLine$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$StatementLine$listDefaults = {
        vQ: $elm$core$Maybe$Nothing,
        vR: $elm$core$Maybe$Nothing,
        acy: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        af5: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        HC: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$StatementLine$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$StatementLine$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.agq;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.vR;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'broker_account', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.HC;
                if (!_v4.$) {
                    var string = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'statement', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.vQ;
                if (!_v5.$) {
                    var string = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'broker', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.acy;
                if (!_v6.$) {
                    var string = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'company', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v7 = options.af5;
                if (!_v7.$) {
                    var bool = _v7.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$bool, 'payable', bool)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$StatementLine$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'statement_lines'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$StatementLine$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$StatementLine$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$StatementLine$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$StatementLine$listPath)));
    });
    var $author$project$Components$Commissions$StatementLines$fetchStatementLines = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$StatementLine$list, apiClient, $author$project$Components$Commissions$StatementLines$fetchStatementLinesParams(model), $author$project$Components$Commissions$StatementLines$GotStatementLines);
    });
    var $author$project$Components$Commissions$StatementLines$GotSummary = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$fetchSummaryParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                vQ: model.EC,
                vR: model.bS,
                acy: model.fl,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af5: model.af5,
                agq: model.agq,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                HC: model.ahx
            });
        };
    };
    var $author$project$Api$Provider$Reports$Summary$Summary = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Summary$SummaryRecord = F3(function(type_, values, rows) {
        return {
            Zc: rows,
            ah5: type_,
            pc: values
        };
    });
    var $author$project$Api$Provider$Reports$Summary$Row = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Summary$RowRecord = F4(function(type_, name, params, values) {
        return {
            zr: name,
            VU: params,
            ah5: type_,
            pc: values
        };
    });
    var $author$project$Api$Provider$Reports$Summary$SummaryValuesRecord = F5(function(amountInCents, hintFeeInCents, stripeFeeInCents, totalFeeInCents, count) {
        return {
            Jh: amountInCents,
            Me: count,
            QO: hintFeeInCents,
            $h: stripeFeeInCents,
            aak: totalFeeInCents
        };
    });
    var $author$project$Api$Provider$Reports$Summary$summaryValuesDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'count', $elm$json$Json$Decode$int, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'total_fee_in_cents', $elm$json$Json$Decode$int, 0, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'stripe_fee_in_cents', $elm$json$Json$Decode$int, 0, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'hint_fee_in_cents', $elm$json$Json$Decode$int, 0, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$SummaryValuesRecord))))));
    var $author$project$Api$Provider$Reports$Summary$summaryRowRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'values', $author$project$Api$Provider$Reports$Summary$summaryValuesDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'params', $elm$json$Json$Decode$dict($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$RowRecord)))));
    var $author$project$Api$Provider$Reports$Summary$summaryRowDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Summary$summaryRowRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Summary$summaryRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows', $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Summary$summaryRowDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'values', $author$project$Api$Provider$Reports$Summary$summaryValuesDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Summary$SummaryRecord))));
    var $author$project$Api$Provider$Reports$Summary$summaryDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Summary$summaryRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Summary$summaryPath = function(listPath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'summary'
        ]), listPath);
    };
    var $author$project$Api$Provider$Reports$Summary$retrieve = F5(function(apiClient, listPath, by, params, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Reports$Summary$summaryDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, params, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'by', by)
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Summary$summaryPath(listPath)))));
    });
    var $author$project$Api$Provider$StatementLine$summary = F4(function(apiClient, by, optionals, toMsg) {
        return A5($author$project$Api$Provider$Reports$Summary$retrieve, apiClient, $author$project$Api$Provider$StatementLine$listPath, by, $author$project$Api$Provider$StatementLine$listOptionsToParams(optionals), toMsg);
    });
    var $author$project$Components$Commissions$StatementLines$fetchSummary = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$StatementLine$summary, apiClient, A2($elm$core$Maybe$withDefault, '', model.bT), $author$project$Components$Commissions$StatementLines$fetchSummaryParams(model), $author$project$Components$Commissions$StatementLines$GotSummary);
    });
    var $author$project$Components$Commissions$StatementLines$fetchData = F2(function(apiClient, model) {
        var _v0 = model.ah5;
        if (!_v0) return A2($author$project$Components$Commissions$StatementLines$fetchStatementLines, apiClient, model);
        else return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Commissions$StatementLines$fetchSummary, apiClient, model),
            A2($author$project$Components$Commissions$StatementLines$fetchStatementLines, apiClient, model)
        ]));
    });
    var $author$project$Components$Commissions$StatementLines$initBrokerFilter = F3(function(apiClient, brokerAccountId, brokerId) {
        return A3($author$project$Components$ResourceFilter$Broker$init, apiClient, function(d) {
            return _Utils_update(d, {
                vR: brokerAccountId
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'All Brokers',
                agj: brokerId
            });
        });
    });
    var $author$project$Components$ResourceFilter$Statement$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$Statement$list = $author$project$Api$Provider$Statement$list;
    var $author$project$Components$ResourceFilter$Statement$fetchResources = F5(function(listOptionals, toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Statement$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$Statement$retrieveResource = F4(function(listOptionals, toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Statement$list, apiClient, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$Statement$selectId = 'statements';
    var $author$project$Components$ResourceFilter$Statement$toTitle = function(resource) {
        return '#' + $elm$core$String$fromInt($author$project$Api$Provider$Statement$All$number(resource));
    };
    var $author$project$Components$ResourceFilter$Statement$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Statement$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$Statement$toValue = $author$project$Api$Provider$Statement$All$id;
    var $author$project$Components$ResourceFilter$Statement$init = F3(function(apiClient, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Statement$fetchResources(listOptionals),
            aef: $author$project$Components$ResourceFilter$Statement$selectId,
            gD: 'Statements',
            sz: $author$project$Components$ResourceFilter$Statement$retrieveResource(listOptionals),
            ahW: $author$project$Components$ResourceFilter$Statement$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Statement$toTitle,
            g4: $author$project$Components$ResourceFilter$Statement$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Commissions$StatementLines$initStatementFilter = F3(function(apiClient, brokerAccountId, statementId) {
        return A3($author$project$Components$ResourceFilter$Statement$init, apiClient, function(d) {
            return _Utils_update(d, {
                vR: brokerAccountId
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'All Statements',
                agj: statementId
            });
        });
    });
    var $author$project$Components$Commissions$StatementLines$PollStatus = {
        $: 15
    };
    var $author$project$Components$Commissions$StatementLines$pollStatus = A2($elm$core$Task$perform, function(_v0) {
        return $author$project$Components$Commissions$StatementLines$PollStatus;
    }, $elm$core$Process$sleep(2000));
    var $author$project$Components$Commissions$StatementLines$init = F5(function(type_, session, practice, _v0, query) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var statementId = A2($elm$core$Dict$get, 'statement', query);
        var q = A2($elm$core$Dict$get, 'q', query);
        var companyId = A2($elm$core$Dict$get, 'company', query);
        var brokerId = A2($elm$core$Dict$get, 'broker', query);
        var brokerAccountId = A2($elm$core$Dict$get, 'broker_account', query);
        var _v1 = function() {
            if (!type_) return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
            else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
        }();
        var statementLines = _v1.a;
        var summary = _v1.b;
        var _v3 = A3($author$project$Components$Commissions$StatementLines$initStatementFilter, apiClient, brokerAccountId, statementId);
        var statementResourceFilter = _v3.a;
        var statementResourceFilterCmd = _v3.b;
        var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v4.a;
        var end = _v4.b;
        var _v5 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Commissions$StatementLines$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v5.a;
        var dateRangeInputCmd = _v5.b;
        var _v6 = A4($author$project$Utils$Report$CompanyResourceFilter$init, apiClient, $elm$core$Basics$identity, $author$project$Api$Practice$Provider(practice), companyId);
        var companyResourceFilter = _v6.a;
        var companyResourceFilterCmd = _v6.b;
        var _v7 = A3($author$project$Components$Commissions$StatementLines$initBrokerFilter, apiClient, brokerAccountId, brokerId);
        var brokerResourceFilter = _v7.a;
        var brokerResourceFilterCmd = _v7.b;
        var _v8 = A3($author$project$Components$ResourceFilter$BrokerAccount$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'All Broker Accounts',
                agj: brokerAccountId
            });
        });
        var brokerAccountResourceFilter = _v8.a;
        var brokerAccountResourceFilterCmd = _v8.b;
        var model = {
            bS: brokerAccountId,
            li: brokerAccountResourceFilter,
            EC: brokerId,
            lj: brokerResourceFilter,
            bT: A2($elm$core$Dict$get, 'by', query),
            ln: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'by-dropdown-filter',
                ahX: $author$project$Components$Commissions$StatementLines$ByDropdownMsg
            })),
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            fl: companyId,
            pY: companyResourceFilter,
            cP: currentDate,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 2
            }),
            q9: false,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            af5: A2($elm$core$Maybe$andThen, $author$project$Utils$Bool$fromString, A2($elm$core$Dict$get, 'payable', query)),
            nq: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'payable-dropdown-filter',
                ahX: $author$project$Components$Commissions$StatementLines$PayableDropdownMsg
            })),
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: A3($author$project$Api$Sort$withDefault, 'date', 0, A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init)),
            HB: start,
            ahx: statementId,
            p: statementLines,
            eM: statementResourceFilter,
            $x: summary,
            ah5: type_
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg, brokerAccountResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg, companyResourceFilterCmd),
            A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, model),
            A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
            $author$project$Components$Commissions$StatementLines$pollStatus
        ])));
    });
    var $author$project$Pages$Commissions$StatementLines$Summary$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Commissions$StatementLines$init, 1, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Commissions$StatementLines$Summary$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$StatementLines$Summary$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Commissions$StatementLines$ExportCsvMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Statement$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Commissions$StatementLines$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$StatementLines$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$StatementLines$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            $author$project$Ui$Dropdown$subscriptions(model.nq),
            $author$project$Ui$Dropdown$subscriptions(model.ln),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, $author$project$Components$ResourceFilter$Statement$subscriptions(model.eM)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, $author$project$Components$ResourceFilter$Broker$subscriptions(model.lj)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg, $author$project$Components$ResourceFilter$BrokerAccount$subscriptions(model.li)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg, $author$project$Components$ResourceFilter$Company$subscriptions(model.pY))
        ]));
    };
    var $author$project$Pages$Commissions$StatementLines$Summary$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Commissions$StatementLines$subscriptions(model.jQ));
    };
    var $author$project$Api$Provider$StatementLine$Done = 1;
    var $author$project$Components$Commissions$StatementLines$GotStatus = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$SearchInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$StatementLine$Running = 0;
    var $author$project$Api$Provider$StatementLine$StatusRecord = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Provider$StatementLine$statusDecoder = A2($elm$json$Json$Decode$andThen, function(record) {
        var _v0 = record.ahy;
        switch(_v0){
            case 'running':
                return $elm$json$Json$Decode$succeed(0);
            case 'done':
                return $elm$json$Json$Decode$succeed(1);
            default:
                var somethingElse = _v0;
                return $elm$json$Json$Decode$fail('Unsupported StatementLine -> Status: ' + somethingElse);
        }
    }, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$StatementLine$StatusRecord)));
    var $author$project$Api$Provider$StatementLine$statusPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'status'
    ]), $author$project$Api$Provider$StatementLine$listPath);
    var $author$project$Api$Provider$StatementLine$status = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$StatementLine$statusDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$StatementLine$statusPath));
    });
    var $author$project$Components$ResourceFilter$Statement$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$Statement$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Commissions$StatementLines$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 1:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v1.a;
                var searchInputCmd = _v1.b;
                var searchInputEvent = _v1.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v2 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q,
                            p: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, qModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                        ])));
                    }
                }();
                var newModel = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var brokerAccountResourceResult = A3($author$project$Components$ResourceFilter$BrokerAccount$update, apiClient, subMsg, model.li);
                var brokerAccountId = function() {
                    var _v10 = brokerAccountResourceResult.adu;
                    if (!_v10.$) {
                        if (!_v10.a.$) return $author$project$Components$ResourceFilter$BrokerAccount$value(brokerAccountResourceResult.zi);
                        else {
                            var _v11 = _v10.a;
                            return model.bS;
                        }
                    } else return model.bS;
                }();
                var _v4 = function() {
                    var _v5 = brokerAccountResourceResult.adu;
                    if (!_v5.$) {
                        if (!_v5.a.$) return A2($author$project$Utils$Tuple3$fromTuple2, $elm$core$Maybe$Nothing, A3($author$project$Components$Commissions$StatementLines$initStatementFilter, apiClient, brokerAccountId, $elm$core$Maybe$Nothing));
                        else {
                            var _v6 = _v5.a;
                            return _Utils_Tuple3(model.eM, $elm$core$Platform$Cmd$none, model.ahx);
                        }
                    } else return _Utils_Tuple3(model.eM, $elm$core$Platform$Cmd$none, model.ahx);
                }();
                var statementResourceFilter = _v4.a;
                var statementResourceFilterCmd = _v4.b;
                var statementId = _v4.c;
                var _v7 = function() {
                    var _v8 = brokerAccountResourceResult.adu;
                    if (!_v8.$ && !_v8.a.$) return A2($author$project$Utils$Tuple3$fromTuple2, $elm$core$Maybe$Nothing, A3($author$project$Components$Commissions$StatementLines$initBrokerFilter, apiClient, brokerAccountId, $elm$core$Maybe$Nothing));
                    else return _Utils_Tuple3(model.lj, $elm$core$Platform$Cmd$none, model.EC);
                }();
                var brokerResourceFilter = _v7.a;
                var brokerResourceFilterCmd = _v7.b;
                var brokerId = _v7.c;
                var newModel = _Utils_update(model, {
                    bS: brokerAccountId,
                    li: brokerAccountResourceResult.zi,
                    EC: brokerId,
                    lj: brokerResourceFilter,
                    ahx: statementId,
                    eM: statementResourceFilter
                });
                var _v9 = _Utils_eq(model.bS, newModel.bS) && _Utils_eq(model.ahx, newModel.ahx) && _Utils_eq(model.EC, newModel.EC) ? _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var statementLines = _v9.a;
                var cmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    p: statementLines
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg, brokerAccountResourceResult.EQ),
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceFilterCmd),
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceFilterCmd),
                    cmd
                ])), brokerAccountResourceResult.at);
            case 3:
                var subMsg = msg.a;
                var statementResourceResult = A3($author$project$Components$ResourceFilter$Statement$update, apiClient, subMsg, model.eM);
                var statementId = function() {
                    var _v13 = statementResourceResult.adu;
                    if (!_v13.$) {
                        if (!_v13.a.$) return $author$project$Components$ResourceFilter$Statement$value(statementResourceResult.zi);
                        else {
                            var _v14 = _v13.a;
                            return model.ahx;
                        }
                    } else return model.ahx;
                }();
                var newModel = _Utils_update(model, {
                    ahx: statementId,
                    eM: statementResourceResult.zi
                });
                var _v12 = _Utils_eq(model.ahx, newModel.ahx) ? _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var statementLines = _v12.a;
                var cmd = _v12.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    p: statementLines
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, statementResourceResult.EQ),
                    cmd
                ])), statementResourceResult.at);
            case 4:
                var subMsg = msg.a;
                var brokerResourceResult = A3($author$project$Components$ResourceFilter$Broker$update, apiClient, subMsg, model.lj);
                var brokerId = function() {
                    var _v16 = brokerResourceResult.adu;
                    if (!_v16.$) {
                        if (!_v16.a.$) return $author$project$Components$ResourceFilter$Broker$value(brokerResourceResult.zi);
                        else {
                            var _v17 = _v16.a;
                            return model.EC;
                        }
                    } else return model.EC;
                }();
                var newModel = _Utils_update(model, {
                    EC: brokerId,
                    lj: brokerResourceResult.zi
                });
                var _v15 = _Utils_eq(model.EC, newModel.EC) ? _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var statementLines = _v15.a;
                var cmd = _v15.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    p: statementLines
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, brokerResourceResult.EQ),
                    cmd
                ])), brokerResourceResult.at);
            case 5:
                var subMsg = msg.a;
                var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pY);
                var companyId = function() {
                    var _v19 = companyResourceResult.adu;
                    if (!_v19.$) {
                        if (!_v19.a.$) return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.zi);
                        else {
                            var _v20 = _v19.a;
                            return model.fl;
                        }
                    } else return model.fl;
                }();
                var newModel = _Utils_update(model, {
                    fl: companyId,
                    pY: companyResourceResult.zi
                });
                var _v18 = _Utils_eq(model.fl, newModel.fl) ? _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var statementLines = _v18.a;
                var cmd = _v18.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    p: statementLines
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg, companyResourceResult.EQ),
                    cmd
                ])), companyResourceResult.at);
            case 6:
                var subMsg = msg.a;
                var _v21 = A2($author$project$Ui$Dropdown$update, subMsg, model.nq);
                var payableDropdown = _v21.a;
                var cmd = _v21.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    nq: payableDropdown
                }), cmd, _List_Nil);
            case 7:
                var subMsg = msg.a;
                var _v22 = A2($author$project$Ui$Dropdown$update, subMsg, model.ln);
                var byDropdown = _v22.a;
                var cmd = _v22.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ln: byDropdown
                }), cmd, _List_Nil);
            case 8:
                var payable = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    af5: payable,
                    p: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 9:
                var by = msg.a;
                var newModel = _Utils_update(model, {
                    bT: by,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    p: $author$project$Api$Data$Loading
                });
                var cmds = function() {
                    var _v23 = _Utils_Tuple2(model.ah5, newModel.bT);
                    if (!_v23.a) {
                        if (!_v23.b.$) {
                            var _v24 = _v23.a;
                            return _List_fromArray([
                                A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                            ]);
                        } else {
                            var _v25 = _v23.a;
                            var _v26 = _v23.b;
                            return _List_fromArray([
                                $elm$core$Platform$Cmd$none
                            ]);
                        }
                    } else if (_v23.b.$ === 1) {
                        var _v27 = _v23.a;
                        var _v28 = _v23.b;
                        return _List_fromArray([
                            A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ]);
                    } else {
                        var _v29 = _v23.a;
                        return _List_fromArray([
                            A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ]);
                    }
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(cmds), _List_Nil);
            case 0:
                var subMsg = msg.a;
                var _v30 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v30.a;
                var subCmd = _v30.b;
                var event = _v30.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
                            p: $author$project$Api$Data$Loading
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 10:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        p: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    p: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $x: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 12:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    p: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 13:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs),
                    p: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Commissions$StatementLines$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 14:
                var subMsg = msg.a;
                var _v33 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v33.a;
                var subCmd = _v33.b;
                var subOutMsg = _v33.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Commissions$StatementLines$ExportCsvMsg, subCmd), subOutMsg);
            case 15:
                return _Utils_Tuple3(model, A2($author$project$Api$Provider$StatementLine$status, apiClient, $author$project$Components$Commissions$StatementLines$GotStatus), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var status = response.a;
                    var isRunnningBackgroundJobs = status !== 1;
                    var _v35 = model.q9 && !isRunnningBackgroundJobs ? _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Commissions$StatementLines$fetchData, apiClient, model)) : _Utils_Tuple2(model.p, $elm$core$Platform$Cmd$none);
                    var statementLines = _v35.a;
                    var cmd = _v35.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        q9: isRunnningBackgroundJobs,
                        p: statementLines
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Components$Commissions$StatementLines$pollStatus,
                        cmd
                    ])), _List_Nil);
                } else return _Utils_Tuple3(model, $author$project$Components$Commissions$StatementLines$pollStatus, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Commissions$StatementLines$Summary$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Commissions$StatementLines$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Commissions$StatementLines$PaginationMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$amountFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Commissions$StatementLines$viewBrokerAccountResourceFilter = function(brokerAccountResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$BrokerAccountResourceFilterMsg, A2($author$project$Components$ResourceFilter$BrokerAccount$viewNew, _List_Nil, brokerAccountResourceFilter));
    };
    var $author$project$Components$Commissions$StatementLines$viewBrokerResourceFilter = function(brokerResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$BrokerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Broker$viewNew, _List_Nil, brokerResourceFilter));
    };
    var $author$project$Components$Commissions$StatementLines$ByOptionSelected = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$viewByDropdown = function(model) {
        var currentText = function() {
            var _v0 = model.bT;
            _v0$2: while(true){
                if (!_v0.$) switch(_v0.a){
                    case 'broker_account':
                        return 'Broker Account';
                    case 'broker':
                        return 'Broker';
                    default:
                        break _v0$2;
                }
                else break _v0$2;
            }
            return 'Summarize by';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentText)
        ]), _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$StatementLines$ByOptionSelected($elm$core$Maybe$Nothing)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.bT, $elm$core$Maybe$Nothing))
            ]), $elm$html$Html$text('No Summary')),
            $author$project$Ui$Dropdown$separator,
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$StatementLines$ByOptionSelected($elm$core$Maybe$Just('broker_account'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.bT, $elm$core$Maybe$Just('broker_account')))
            ]), $elm$html$Html$text('Broker Account')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$StatementLines$ByOptionSelected($elm$core$Maybe$Just('broker'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.bT, $elm$core$Maybe$Just('broker')))
            ]), $elm$html$Html$text('Broker'))
        ]), model.ln);
    };
    var $author$project$Components$Commissions$StatementLines$viewCompanyResourceFilter = function(companyResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$viewNew, _List_Nil, companyResourceFilter));
    };
    var $author$project$Components$Commissions$StatementLines$PayableOptionSelected = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$viewPayableDropdown = function(model) {
        var currentText = function() {
            var _v0 = model.af5;
            if (!_v0.$) {
                if (_v0.a) return 'Payable';
                else return 'Pending';
            } else return 'Status';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentText)
        ]), _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$StatementLines$PayableOptionSelected($elm$core$Maybe$Nothing)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.af5, $elm$core$Maybe$Nothing))
            ]), $elm$html$Html$text('All')),
            $author$project$Ui$Dropdown$separator,
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$StatementLines$PayableOptionSelected($elm$core$Maybe$Just(true))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.af5, $elm$core$Maybe$Just(true)))
            ]), $elm$html$Html$text('Payable')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Commissions$StatementLines$PayableOptionSelected($elm$core$Maybe$Just(false))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.af5, $elm$core$Maybe$Just(false)))
            ]), $elm$html$Html$text('Pending'))
        ]), model.nq);
    };
    var $author$project$Components$ResourceFilter$Statement$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Commissions$StatementLines$viewStatementResourceFilter = function(statementResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$StatementResourceFilterMsg, A2($author$project$Components$ResourceFilter$Statement$viewNew, _List_Nil, statementResourceFilter));
    };
    var $author$project$Api$Provider$Reports$Summary$summaryRows = function(_v0) {
        var record = _v0;
        return record.Zc;
    };
    var $author$project$Api$Provider$Reports$Summary$summaryType = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents = function(_v0) {
        var record = _v0;
        return record.pc.Jh;
    };
    var $author$project$Api$Provider$Reports$Summary$summaryRowCount = function(_v0) {
        var record = _v0;
        return record.pc.Me;
    };
    var $author$project$Api$Provider$Reports$Summary$summaryRowName = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $elm$core$Dict$filter = F2(function(isGood, dict) {
        return A3($elm$core$Dict$foldl, F3(function(k, v, d) {
            return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
        }), $elm$core$Dict$empty, dict);
    });
    var $author$project$Api$Provider$Reports$Summary$summaryRowParams = function(_v0) {
        var record = _v0;
        return record.VU;
    };
    var $author$project$Api$Provider$Reports$Summary$summaryRowType = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Utils$Report$summaryRowTableParams = F2(function(urlParams, summaryRow) {
        return $author$project$Utils$QueryParameter$fromDict(A2($elm$core$Dict$filter, F2(function(key, _v0) {
            return $author$project$Api$Provider$Reports$Summary$summaryRowType(summaryRow) !== 'deposit' || key !== 'start' && key !== 'end';
        }), A2($elm$core$Dict$remove, 'by', A2($elm$core$Dict$union, urlParams, $author$project$Api$Provider$Reports$Summary$summaryRowParams(summaryRow)))));
    });
    var $author$project$Components$Commissions$StatementLines$viewSummaryRow = F2(function(model, summaryRow) {
        var routeParams = _List_fromArray([
            $author$project$Ui$Link$routeParams(A2($author$project$Utils$Report$summaryRowTableParams, $author$project$Components$Commissions$StatementLines$urlParams(model), summaryRow))
        ]);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$info,
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__StatementLines__Top, routeParams, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Unassigned', $author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__StatementLines__Top, routeParams, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'charge', $author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__StatementLines__Top, routeParams, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Commissions$StatementLines$viewSummaryTable = function(model) {
        var summaryType = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize), $author$project$Api$Data$toMaybe(model.$x)));
        var summaryRows = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Summary$summaryRows, $author$project$Api$Data$toMaybe(model.$x)));
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.$x)),
            $author$project$Ui$Table$zeroState(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text(summaryType)
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Commission Lines')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Commissions$StatementLines$viewSummaryRow(model), summaryRows), _List_Nil);
    };
    var $author$project$Components$Commissions$StatementLines$SortTable = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Commissions$StatementLines$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'date', true, 'Date'),
        A3($author$project$Api$Column$init, 'statement', true, 'Statement'),
        A3($author$project$Api$Column$init, 'broker', false, 'Broker'),
        A3($author$project$Api$Column$init, 'reference', false, 'Reference'),
        A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
        A3($author$project$Api$Column$init, 'payable', true, 'Status'),
        A3($author$project$Api$Column$init, 'commission', false, 'Commission')
    ]);
    var $author$project$Api$Provider$StatementLine$All$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$StatementLine$All$broker = function(_v0) {
        var record = _v0;
        return record.vQ;
    };
    var $author$project$Api$Provider$StatementAdjustment$Min$category = function(_v0) {
        var record = _v0;
        return record.EL;
    };
    var $author$project$Api$Provider$StatementLine$All$charge = function(_v0) {
        var record = _v0;
        return record.ach;
    };
    var $author$project$Api$Provider$StatementLine$All$company = function(_v0) {
        var record = _v0;
        return record.acy;
    };
    var $author$project$Api$Common$Payable$Invoice$Min$date = function(_v0) {
        var record = _v0;
        return record.M4;
    };
    var $author$project$Api$Common$Payable$Invoice$MinWithOwner$date = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Common$Payable$Invoice$Min$date(min);
    };
    var $author$project$Api$Provider$StatementLine$All$date = function(_v0) {
        var record = _v0;
        return record.M4;
    };
    var $author$project$Api$Provider$StatementLine$All$dealType = function(_v0) {
        var record = _v0;
        return record.Nk;
    };
    var $author$project$Api$Provider$StatementLine$All$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$Charge$SharedWithInvoice$invoice = function(_v0) {
        var record = _v0.b;
        return record.RA;
    };
    var $author$project$Api$Provider$StatementAdjustment$Min$memo = function(_v0) {
        var record = _v0;
        return record.ae0;
    };
    var $author$project$Api$Provider$StatementLine$All$owner = function(_v0) {
        var record = _v0;
        return record.VM;
    };
    var $author$project$Api$Provider$StatementLine$All$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Api$Provider$StatementLine$All$payable = function(_v0) {
        var record = _v0;
        return record.af5;
    };
    var $author$project$Api$Provider$StatementLine$All$statementAdjustment = function(_v0) {
        var record = _v0;
        return record._4;
    };
    var $author$project$Api$Provider$StatementLine$All$statementNumber = function(_v0) {
        var record = _v0;
        return record._6;
    };
    var $author$project$Api$Provider$Charge$SharedWithInvoice$totalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
    };
    var $author$project$Api$Provider$StatementLine$All$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Components$Commissions$StatementLines$viewRow = F2(function(canGoToPatients, statementLine) {
        var patientName = function(patient_) {
            return A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(patient_))
            ]));
        };
        var patient = $author$project$Api$Provider$StatementLine$All$patient(statementLine);
        var broker = $author$project$Api$Provider$StatementLine$All$broker(statementLine);
        var brokerAccount = $author$project$Api$Provider$Broker$Shared$brokerAccount(broker);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$StatementLine$All$date(statementLine)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Provider$StatementLine$All$statementNumber(statementLine);
                    if (!_v0.$) {
                        var statementNumber = _v0.a;
                        return A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                        ]), _List_fromArray([
                            $elm$html$Html$text('#' + $elm$core$String$fromInt(statementNumber))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top({
                    bS: $author$project$Api$Provider$BrokerAccount$Shared$id(brokerAccount),
                    EC: $author$project$Api$Provider$Broker$Shared$id(broker)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Broker$Shared$name(broker))
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$BrokerAccount$Shared$name(brokerAccount))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v1 = $author$project$Api$Provider$StatementLine$All$type_(statementLine);
                if (!_v1) {
                    var owner = $author$project$Api$Provider$StatementLine$All$owner(statementLine);
                    return _List_fromArray([
                        function() {
                            var _v2 = _Utils_Tuple2(patient, canGoToPatients);
                            if (!_v2.a.$) {
                                if (_v2.b) {
                                    var patient_ = _v2.a.a;
                                    return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                        V8: $author$project$Api$Provider$Patient$Min$id(patient_)
                                    }), _List_Nil, _List_fromArray([
                                        patientName(patient_)
                                    ]));
                                } else {
                                    var patient_ = _v2.a.a;
                                    return patientName(patient_);
                                }
                            } else {
                                var _v3 = _v2.a;
                                return $elm$html$Html$text('N/A');
                            }
                        }(),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, owner), A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, patient)) ? $elm$html$Html$text('Owns the membership') : $elm$html$Html$text('Membership owner: ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, owner)))
                        ]))
                    ]);
                } else return _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$StatementAdjustment$Min$category, $author$project$Formatters$String$titleize), $author$project$Api$Provider$StatementLine$All$statementAdjustment(statementLine)))),
                    $elm$html$Html$text(' Adjustment'),
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 30, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Provider$StatementAdjustment$Min$memo, $author$project$Api$Provider$StatementLine$All$statementAdjustment(statementLine)))))
                    ]))
                ]);
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v4 = $author$project$Api$Provider$StatementLine$All$type_(statementLine);
                if (!_v4) {
                    var invoiceRoute = function(invoice_) {
                        return A2($elm$core$Maybe$andThen, function(dealType) {
                            if (!dealType) return A2($elm$core$Maybe$map, function(invoiceOwner) {
                                return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                                    fl: $author$project$Api$Common$Payable$Owner$Min$id(invoiceOwner),
                                    aef: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice_)
                                });
                            }, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice_));
                            else {
                                var _v11 = _Utils_Tuple2(patient, canGoToPatients);
                                if (!_v11.a.$ && _v11.b) {
                                    var patient_ = _v11.a.a;
                                    return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                        RI: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice_),
                                        V8: $author$project$Api$Provider$Patient$Min$id(patient_)
                                    }));
                                } else return $elm$core$Maybe$Nothing;
                            }
                        }, $author$project$Api$Provider$StatementLine$All$dealType(statementLine));
                    };
                    var invoice = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$SharedWithInvoice$invoice, $author$project$Api$Provider$StatementLine$All$charge(statementLine));
                    return _List_fromArray([
                        function() {
                            if (!invoice.$) {
                                var invoice_ = invoice.a;
                                var _v6 = invoiceRoute(invoice_);
                                if (!_v6.$) {
                                    var invoiceRoute_ = _v6.a;
                                    return A3($author$project$Ui$Link$route, invoiceRoute_, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice_)))
                                    ]));
                                } else return $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice_)));
                            } else return $elm$html$Html$text('N/A');
                        }(),
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(' on '),
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Common$Payable$Invoice$MinWithOwner$date, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full)), invoice))),
                            $elm$html$Html$text(' for '),
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Charge$SharedWithInvoice$totalInCents, $author$project$Utils$Currency$fromInt), $author$project$Api$Provider$StatementLine$All$charge(statementLine))))
                        ])),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            function() {
                                var _v7 = $author$project$Api$Provider$StatementLine$All$dealType(statementLine);
                                if (_v7.$ === 1) return $elm$html$Html$text('N/A');
                                else if (!_v7.a) {
                                    var _v8 = _v7.a;
                                    return $elm$html$Html$text('For Employer: ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Min$name, $author$project$Api$Provider$StatementLine$All$company(statementLine))));
                                } else {
                                    var _v9 = _v7.a;
                                    return $elm$html$Html$text('Retail Deal');
                                }
                            }()
                        ]))
                    ]);
                } else return _List_Nil;
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$StatementLine$All$payable(statementLine) ? 'payable' : 'pending')
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$colspan(2)
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$StatementLine$All$amountInCents(statementLine))),
                $author$project$Utils$Html$noBreakSpace,
                !$author$project$Api$Provider$StatementLine$All$type_(statementLine) ? A3($author$project$Ui$Tooltip$view, _List_fromArray([
                    $author$project$Ui$Tooltip$placement(2)
                ]), A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$StatementLine$All$description(statementLine)), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$help(_List_Nil)
                    ]))
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Components$Commissions$StatementLines$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.p;
            if (_v1.$ === 3) {
                var statementLines_ = _v1.a;
                return _Utils_Tuple2(false, statementLines_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var statementLines = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Commissions$StatementLines$SortTable)), $author$project$Components$Commissions$StatementLines$columns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, $author$project$Components$Commissions$StatementLines$viewRow(model.EF), statementLines), _List_Nil);
    };
    var $author$project$Components$Commissions$StatementLines$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$path($author$project$Api$Provider$StatementLine$listPath),
                $author$project$Components$ExportCsv$params(A2($elm$core$Basics$composeL, $author$project$Api$Provider$StatementLine$listOptionsToParams, $author$project$Components$Commissions$StatementLines$fetchStatementLinesParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.p;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Commissions$StatementLines$amountFromHeader, headers, 'x-total-amount')))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Total amount of statement lines generated for brokers')
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(12)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(12)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                                $author$project$Ui$SearchInput$placeholder('Search for patient or membership owner name')
                            ]), model.sG))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Commissions$StatementLines$viewBrokerAccountResourceFilter(model.li)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Commissions$StatementLines$viewStatementResourceFilter(model.eM)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Commissions$StatementLines$viewBrokerResourceFilter(model.lj)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Commissions$StatementLines$viewCompanyResourceFilter(model.pY)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Commissions$StatementLines$viewPayableDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Commissions$StatementLines$viewByDropdown(model)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    model.q9 ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('We are updating this report with recent invoice changes. The page will reload when the update completes.')
                    ])) : $author$project$Utils$Html$empty
                ])),
                function() {
                    var _v1 = model.ah5;
                    if (!_v1) return $author$project$Components$Commissions$StatementLines$viewTable(model);
                    else return $author$project$Components$Commissions$StatementLines$viewSummaryTable(model);
                }(),
                function() {
                    var _v2 = model.ah5;
                    if (!_v2) return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Commissions$StatementLines$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.p)))
                        ]), model.af_))
                    ]));
                    else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]);
    });
    var $author$project$Pages$Commissions$StatementLines$Summary$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Commissions$StatementLines$view, model.Ej, model.jQ)),
            $2: 'Commissions | Statements'
        };
    };
    var $author$project$Pages$Commissions$StatementLines$Summary$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$StatementLines$Summary$init,
        aeR: $author$project$Pages$Commissions$StatementLines$Summary$load,
        ag3: $author$project$Pages$Commissions$StatementLines$Summary$save,
        ahE: $author$project$Pages$Commissions$StatementLines$Summary$subscriptions,
        aaO: $author$project$Pages$Commissions$StatementLines$Summary$update,
        aid: $author$project$Pages$Commissions$StatementLines$Summary$view
    });
    var $author$project$Pages$Commissions$StatementLines$Top$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Commissions$StatementLines$Table = 0;
    var $author$project$Pages$Commissions$StatementLines$Top$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Commissions$StatementLines$init, 0, session, practice, shared, query);
        var report = _v1.a;
        var reportTaxCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
    });
    var $author$project$Pages$Commissions$StatementLines$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$StatementLines$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$StatementLines$Top$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Commissions$StatementLines$subscriptions(model.jQ));
    };
    var $author$project$Pages$Commissions$StatementLines$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Commissions$StatementLines$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Commissions$StatementLines$Top$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Commissions$StatementLines$view, model.Ej, model.jQ)),
            $2: 'Commissions | Statements'
        };
    };
    var $author$project$Pages$Commissions$StatementLines$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$StatementLines$Top$init,
        aeR: $author$project$Pages$Commissions$StatementLines$Top$load,
        ag3: $author$project$Pages$Commissions$StatementLines$Top$save,
        ahE: $author$project$Pages$Commissions$StatementLines$Top$subscriptions,
        aaO: $author$project$Pages$Commissions$StatementLines$Top$update,
        aid: $author$project$Pages$Commissions$StatementLines$Top$view
    });
    var $author$project$Pages$Commissions$Statements$StatementsTableMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Commissions$Statements$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var _v3 = $author$project$Components$Commissions$Statement$List$init({
            Ej: shared.Ej,
            bS: $elm$core$Maybe$Nothing,
            pK: true,
            pL: false,
            pM: true,
            cP: shared.cP,
            Gc: $author$project$Spa$Generated$Route$Commissions__Statements,
            Bz: query,
            eK: true
        });
        var statementsTable = _v3.a;
        var statementsTableCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: statementsTable
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd));
    });
    var $author$project$Pages$Commissions$Statements$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Commissions$Statements$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Commissions$Statements$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Commissions$Statement$List$subscriptions(model.rk));
    };
    var $author$project$Pages$Commissions$Statements$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Commissions$Statement$List$update, model.Ej, subMsg, model.rk);
        var statementsTable = _v1.a;
        var statementsTableCmd = _v1.b;
        var statementsTableOutMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: statementsTable
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, statementsTableCmd), statementsTableOutMsgs);
    });
    var $author$project$Pages$Commissions$Statements$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Commissions$Statement$List$view(model.rk))
            ]),
            $2: 'Commissions | Statements'
        };
    };
    var $author$project$Pages$Commissions$Statements$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Commissions$Statements$init,
        aeR: $author$project$Pages$Commissions$Statements$load,
        ag3: $author$project$Pages$Commissions$Statements$save,
        ahE: $author$project$Pages$Commissions$Statements$subscriptions,
        aaO: $author$project$Pages$Commissions$Statements$update,
        aid: $author$project$Pages$Commissions$Statements$view
    });
    var $author$project$OutMsg$RetrieveCompany = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Spa$Page$applicationCompanyOrEmployer = function(page) {
        return {
            aeq: F2(function(shared, url) {
                var _v0 = _Utils_Tuple3(shared.Z$, shared.W1, shared.acy);
                _v0$3: while(true){
                    _v0$4: while(true){
                        _v0$5: while(true)switch(_v0.a.$){
                            case 3:
                                switch(_v0.b.$){
                                    case 3:
                                        switch(_v0.c.$){
                                            case 3:
                                                var _v1 = _v0.a;
                                                var session = _v1.a;
                                                var _v2 = _v0.b;
                                                var practice = _v2.a;
                                                var _v3 = _v0.c;
                                                var company = _v3.a;
                                                return !A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil) : !_Utils_eq(url.VU.fl, $author$project$Api$Company$id(company)) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_fromArray([
                                                    $author$project$OutMsg$RetrieveCompany(url.VU.fl)
                                                ])) : A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A5(page.aeq, session, practice, company, shared, url)));
                                            case 2:
                                                break _v0$4;
                                            default:
                                                break _v0$5;
                                        }
                                    case 2:
                                        break _v0$3;
                                    default:
                                        if (_v0.c.$ === 2) break _v0$4;
                                        else break _v0$5;
                                }
                            case 2:
                                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                            case 0:
                                var _v4 = _v0.a;
                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $author$project$Ports$Session$authorize({
                                    agy: true
                                }), _List_Nil);
                            default:
                                if (_v0.b.$ === 2) break _v0$3;
                                else {
                                    if (_v0.c.$ === 2) break _v0$4;
                                    else break _v0$5;
                                }
                        }
                        var _v5 = url;
                        var params = _v5.VU;
                        return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$RetrieveCompany(params.fl)
                        ]));
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aeR: F2(function(shared, model) {
                var _v6 = _Utils_Tuple3(shared.Z$, shared.W1, shared.acy);
                _v6$1: while(true){
                    _v6$3: while(true){
                        _v6$4: while(true)switch(_v6.a.$){
                            case 3:
                                switch(_v6.b.$){
                                    case 3:
                                        switch(_v6.c.$){
                                            case 3:
                                                var _v7 = _v6.a;
                                                var session = _v7.a;
                                                var _v8 = _v6.b;
                                                var practice = _v8.a;
                                                var _v9 = _v6.c;
                                                var company = _v9.a;
                                                switch(model.$){
                                                    case 0:
                                                        var url = model.a;
                                                        if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT)) return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                                        else {
                                                            var _v11 = A5(page.aeq, session, practice, company, shared, url);
                                                            var pageModel = _v11.a;
                                                            var cmd = _v11.b;
                                                            return _Utils_Tuple3($author$project$Spa$Page$SessionLoaded(pageModel), cmd, _List_Nil);
                                                        }
                                                    case 1:
                                                        var modelWithSession = model.a;
                                                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aeR, shared, _Utils_update(modelWithSession, {
                                                            Ej: shared.Ej
                                                        }))));
                                                    default:
                                                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                                                }
                                            case 0:
                                                break _v6$1;
                                            default:
                                                break _v6$4;
                                        }
                                    case 2:
                                        if (!_v6.c.$) break _v6$1;
                                        else break _v6$3;
                                    default:
                                        if (!_v6.c.$) break _v6$1;
                                        else break _v6$4;
                                }
                            case 2:
                                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                            default:
                                if (_v6.b.$ === 2) break _v6$3;
                                else break _v6$4;
                        }
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                var _v12 = _v6.a;
                var _v13 = _v6.c;
                if (!model.$) {
                    var url = model.a;
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                        $author$project$OutMsg$RetrieveCompany(url.VU.fl)
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            ag3: F2(function(model, shared) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2(page.ag3, modelWithSession, shared);
                } else return shared;
            }),
            ahE: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.ahE(modelWithSession);
                } else return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(msg, model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aaO, msg, modelWithSession));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.aid(modelWithSession);
                } else return {
                    fb: $author$project$Components$BlankPage$view,
                    $2: 'Loading...'
                };
            }
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$GotCompanyPlans = $elm$core$Basics$identity;
    var $author$project$Api$CompanyPlan$Pricing = 0;
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$init = F5(function(session, practice, company, _v0, _v1) {
        var apiClient = _v0.Ej;
        var params = _v1.VU;
        return _Utils_Tuple2({
            Ej: apiClient,
            acy: company,
            al: $author$project$Api$Data$Loading,
            W1: practice
        }, A5($author$project$Api$CompanyPlan$list, apiClient, session, params.fl, function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ])
            });
        }, $elm$core$Basics$identity));
    });
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$update = F2(function(msg, model) {
        var response = msg;
        return _Utils_Tuple3(_Utils_update(model, {
            al: response
        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
    });
    var $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths = function(_v0) {
        var record = _v0;
        return record.Ny;
    };
    var $author$project$Api$Employer$Plan$All$defaultPeriodInMonths = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(shared);
    };
    var $author$project$Api$Employer$Plan$One$defaultPeriodInMonths = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(shared);
    };
    var $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths = function(_v0) {
        var record = _v0;
        return record.Ny;
    };
    var $author$project$Api$Provider$Plan$All$defaultPeriodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
    };
    var $author$project$Api$Provider$Plan$One$defaultPeriodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$defaultPeriodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(shared);
    };
    var $author$project$Api$Plan$defaultPeriodInMonths = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$defaultPeriodInMonths(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$defaultPeriodInMonths(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$defaultPeriodInMonths(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$defaultPeriodInMonths(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$defaultPeriodInMonths(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$defaultPeriodInMonths(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$defaultPeriodInMonths(plan_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$viewCompanyPlan = function(companyPlan) {
        var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Plan$name(plan))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $elm$core$List$head($author$project$Api$Plan$allowedBillingPeriodCodes(plan));
                    if (!_v0.$) {
                        var allowedBillingPeriodCode = _v0.a;
                        return $elm$html$Html$text($author$project$Formatters$String$titleize(allowedBillingPeriodCode) + 'ly');
                    } else return $elm$html$Html$text('N/A');
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$Int$ordinal($author$project$Api$Plan$defaultPeriodInMonths(plan))),
                $elm$html$Html$text(' day')
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Components$Plan$Summary$Pricing$view, plan, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$view = function(model) {
        var _v0 = function() {
            var _v1 = model.al;
            if (_v1.$ === 3) {
                var list = _v1.a;
                return _Utils_Tuple2(false, list);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var companyPlans = _v0.b;
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Affiliate Fee Plans')
                        ]))
                    ])),
                    A4($author$project$Ui$Panel$table, _List_fromArray([
                        $author$project$Ui$Table$loading(loading)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Name')
                        ])),
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Billing cycle')
                        ])),
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Billing date')
                        ])),
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Rate')
                        ]))
                    ]), A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$viewCompanyPlan, companyPlans), _List_Nil)
                ]))
            ]),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Affiliate Fee Plans'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$update,
        aid: $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$view
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$GotData = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$UploadHeader$All$UploadHeader = $elm$core$Basics$identity;
    var $author$project$Api$Provider$UploadHeader$Shared$UploadHeader = $elm$core$Basics$identity;
    var $author$project$Api$Provider$UploadHeader$Shared$Record = F5(function(id, columnName, destination, required, ignored) {
        return {
            LB: columnName,
            NS: destination,
            aef: id,
            aei: ignored,
            agM: required
        };
    });
    var $author$project$Api$Provider$UploadHeader$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ignored', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'required', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'destination', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'column_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadHeader$Shared$Record))))));
    var $author$project$Api$Provider$UploadHeader$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadHeader$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$UploadHeader$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadHeader$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'upload_headers'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$UploadHeader$list = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$UploadHeader$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders = function(model) {
        return A3($author$project$Api$Provider$Company$UploadHeader$list, model.Ej, $author$project$Api$Company$id(model.acy), $author$project$Pages$Companies$CompanyId_String$Eas$GotData);
    };
    var $author$project$Api$FeedEnroller$EmployerAll = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$FeedEnroller$ProviderAll = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$FeedEnroller$All$FeedEnroller = $elm$core$Basics$identity;
    var $author$project$Api$Employer$FeedEnroller$Shared$FeedEnroller = $elm$core$Basics$identity;
    var $author$project$Api$Employer$FeedEnroller$Shared$Record = F9(function(id, publicSshKey, fileMatch, enabled, contactName, contactEmail, server, path, username) {
        return {
            L0: contactEmail,
            L1: contactName,
            OM: enabled,
            PE: fileMatch,
            aef: id,
            V6: path,
            XL: publicSshKey,
            ZX: server,
            aaY: username
        };
    });
    var $author$project$Api$Employer$FeedEnroller$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'username', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'path', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'server', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contact_email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contact_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_match', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'public_ssh_key', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$FeedEnroller$Shared$Record))))))))));
    var $author$project$Api$Employer$FeedEnroller$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$FeedEnroller$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$FeedEnroller$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$FeedEnroller$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$FeedEnroller$feedEnrollersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'feed_enrollers'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$FeedEnroller$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$FeedEnroller$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$FeedEnroller$feedEnrollersPath));
    });
    var $author$project$Api$Provider$FeedEnroller$All$FeedEnroller = $elm$core$Basics$identity;
    var $author$project$Api$Provider$FeedEnroller$Shared$FeedEnroller = $elm$core$Basics$identity;
    var $author$project$Api$Provider$FeedEnroller$Shared$Record = F9(function(id, publicSshKey, fileMatch, enabled, contactName, contactEmail, server, path, username) {
        return {
            L0: contactEmail,
            L1: contactName,
            OM: enabled,
            PE: fileMatch,
            aef: id,
            V6: path,
            XL: publicSshKey,
            ZX: server,
            aaY: username
        };
    });
    var $author$project$Api$Provider$FeedEnroller$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'username', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'path', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'server', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contact_email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'contact_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_match', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'public_ssh_key', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$FeedEnroller$Shared$Record))))))))));
    var $author$project$Api$Provider$FeedEnroller$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$FeedEnroller$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$FeedEnroller$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$FeedEnroller$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$FeedEnroller$feedEnrollersPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'feed_enrollers'
        ]), basePath);
    };
    var $author$project$Api$Provider$FeedEnroller$list = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$FeedEnroller$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$FeedEnroller$feedEnrollersPath($author$project$Api$Provider$Company$companyPath(companyId))));
    });
    var $author$project$Api$FeedEnroller$list = F4(function(apiClient, session, companyId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$Employer$FeedEnroller$list, apiClient, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$FeedEnroller$EmployerAll)))) : A3($author$project$Api$Provider$FeedEnroller$list, apiClient, companyId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$FeedEnroller$ProviderAll))));
    });
    var $author$project$Api$FeedEnroller$retrieve = F4(function(apiClient, session, companyId, toMsg) {
        return A4($author$project$Api$FeedEnroller$list, apiClient, session, companyId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$head)));
    });
    var $author$project$Api$Provider$UploadSetting$One$UploadSetting = $elm$core$Basics$identity;
    var $author$project$Api$Provider$UploadSetting$One$Record = function(adoptCompanies) {
        return function(autoProcessTimer) {
            return function(createChildCompanies) {
                return function(createDivisions) {
                    return function(endDateBuffer) {
                        return function(fileGrowthThreshold) {
                            return function(fileGrowthThresholdPct) {
                                return function(inheritPlans) {
                                    return function(mapUnknownPlanValuesToCompanyDefaultPlan) {
                                        return function(nameMatch) {
                                            return function(restrictTerminationByOmissionToEmployees) {
                                                return function(restrictTerminationByOmissionToFeedPatients) {
                                                    return function(terminateMembersByOmission) {
                                                        return function(terminateMembersPct) {
                                                            return function(terminateEligibilityByOmission) {
                                                                return function(useUploadCreationDateAsEnrollmentDate) {
                                                                    return {
                                                                        abA: adoptCompanies,
                                                                        abR: autoProcessTimer,
                                                                        acE: createChildCompanies,
                                                                        acF: createDivisions,
                                                                        adq: endDateBuffer,
                                                                        adO: fileGrowthThreshold,
                                                                        adP: fileGrowthThresholdPct,
                                                                        aep: inheritPlans,
                                                                        aeW: mapUnknownPlanValuesToCompanyDefaultPlan,
                                                                        ae9: nameMatch,
                                                                        agU: restrictTerminationByOmissionToEmployees,
                                                                        agV: restrictTerminationByOmissionToFeedPatients,
                                                                        ahN: terminateEligibilityByOmission,
                                                                        ahO: terminateMembersByOmission,
                                                                        ahP: terminateMembersPct,
                                                                        ah9: useUploadCreationDateAsEnrollmentDate
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$UploadSetting$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'use_upload_creation_date_as_enrollment_date', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'terminate_eligibility_by_omission', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'terminate_members_pct', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'terminate_members_by_omission', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'restrict_termination_by_omission_to_feed_patients', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'restrict_termination_by_omission_to_employees', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name_match', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'map_unknown_plan_values_to_company_default_plan', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'inherit_plans', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_growth_threshold_pct', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_growth_threshold', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date_buffer', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'create_divisions', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'create_child_companies', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'auto_process_timer', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'adopt_companies', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadSetting$One$Record)))))))))))))))));
    var $author$project$Api$Provider$UploadSetting$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadSetting$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$UploadSetting$uploadSettingPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'upload_setting'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$UploadSetting$retrieve = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$UploadSetting$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$UploadSetting$uploadSettingPath(companyId)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var model = {
            Ej: shared.Ej,
            acy: company,
            acU: shared.adU.acU,
            dQ: $elm$core$Maybe$Nothing,
            iJ: $author$project$Api$Data$Loading,
            d5: $elm$core$Maybe$Nothing,
            d6: $author$project$Api$Data$NotAsked,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            Z$: session,
            U: $elm$core$Maybe$Nothing,
            kH: $author$project$Api$Data$Loading,
            kJ: $author$project$Api$Data$Loading,
            bJ: $elm$core$Maybe$Nothing
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
            A4($author$project$Api$FeedEnroller$retrieve, shared.Ej, session, params.fl, $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller),
            A3($author$project$Api$Provider$Company$UploadSetting$retrieve, shared.Ej, params.fl, $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting)
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit = {
        $: 16
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit)), model.U)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.dQ)))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerCreated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerDeleted = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Api$FeedEnroller$ProviderOne = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$FeedEnroller$One$FeedEnroller = $elm$core$Basics$identity;
    var $author$project$Api$Provider$FeedEnroller$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$FeedEnroller$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$FeedEnroller$create = F4(function(apiClient, companyId, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('skip_sftp_server', $elm$json$Json$Encode$bool(params.ahr)),
            _Utils_Tuple2('feed_enroller', $elm$json$Json$Encode$object(_List_Nil))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$FeedEnroller$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$FeedEnroller$feedEnrollersPath($author$project$Api$Provider$Company$companyPath(companyId)))));
    });
    var $author$project$Api$FeedEnroller$create = F5(function(apiClient, session, companyId, params, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$FeedEnroller$create, apiClient, companyId, params, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$FeedEnroller$ProviderOne)));
    });
    var $author$project$Api$Provider$FeedEnroller$feedEnrollerPath = F2(function(basePath, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$FeedEnroller$feedEnrollersPath(basePath));
    });
    var $author$project$Api$Provider$FeedEnroller$delete = F4(function(apiClient, companyId, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$FeedEnroller$feedEnrollerPath, $author$project$Api$Provider$Company$companyPath(companyId), id)));
    });
    var $author$project$Api$FeedEnroller$delete = F5(function(apiClient, session, companyId, id_, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$FeedEnroller$delete, apiClient, companyId, id_, toMsg);
    });
    var $author$project$Api$Employer$FeedEnroller$Shared$contactEmail = function(_v0) {
        var record = _v0;
        return record.L0;
    };
    var $author$project$Api$Employer$FeedEnroller$All$contactEmail = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$contactEmail(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$contactEmail = function(_v0) {
        var record = _v0;
        return record.L0;
    };
    var $author$project$Api$Provider$FeedEnroller$All$contactEmail = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$contactEmail(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$contactEmail = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$contactEmail(shared);
    };
    var $author$project$Api$FeedEnroller$contactEmail = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$contactEmail(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$contactEmail(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$contactEmail(feedEnroller_);
        }
    };
    var $author$project$Api$Employer$FeedEnroller$Shared$contactName = function(_v0) {
        var record = _v0;
        return record.L1;
    };
    var $author$project$Api$Employer$FeedEnroller$All$contactName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$contactName(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$contactName = function(_v0) {
        var record = _v0;
        return record.L1;
    };
    var $author$project$Api$Provider$FeedEnroller$All$contactName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$contactName(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$contactName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$contactName(shared);
    };
    var $author$project$Api$FeedEnroller$contactName = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$contactName(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$contactName(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$contactName(feedEnroller_);
        }
    };
    var $author$project$Api$Employer$FeedEnroller$Shared$enabled = function(_v0) {
        var record = _v0;
        return record.OM;
    };
    var $author$project$Api$Employer$FeedEnroller$All$enabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$enabled(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$enabled = function(_v0) {
        var record = _v0;
        return record.OM;
    };
    var $author$project$Api$Provider$FeedEnroller$All$enabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$enabled(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$enabled = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$enabled(shared);
    };
    var $author$project$Api$FeedEnroller$enabled = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$enabled(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$enabled(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$enabled(feedEnroller_);
        }
    };
    var $author$project$Api$Employer$FeedEnroller$Shared$fileMatch = function(_v0) {
        var record = _v0;
        return record.PE;
    };
    var $author$project$Api$Employer$FeedEnroller$All$fileMatch = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$fileMatch(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$fileMatch = function(_v0) {
        var record = _v0;
        return record.PE;
    };
    var $author$project$Api$Provider$FeedEnroller$All$fileMatch = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$fileMatch(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$fileMatch = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$fileMatch(shared);
    };
    var $author$project$Api$FeedEnroller$fileMatch = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$fileMatch(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$fileMatch(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$fileMatch(feedEnroller_);
        }
    };
    var $author$project$Api$Employer$FeedEnroller$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$FeedEnroller$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$id(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$FeedEnroller$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$id(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$id(shared);
    };
    var $author$project$Api$FeedEnroller$id = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$id(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$id(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$id(feedEnroller_);
        }
    };
    var $author$project$Api$Employer$FeedEnroller$Shared$path = function(_v0) {
        var record = _v0;
        return record.V6;
    };
    var $author$project$Api$Employer$FeedEnroller$All$path = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$path(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$path = function(_v0) {
        var record = _v0;
        return record.V6;
    };
    var $author$project$Api$Provider$FeedEnroller$All$path = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$path(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$path = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$path(shared);
    };
    var $author$project$Api$FeedEnroller$path = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$path(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$path(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$path(feedEnroller_);
        }
    };
    var $author$project$Api$Employer$FeedEnroller$Shared$publicSshKey = function(_v0) {
        var record = _v0;
        return record.XL;
    };
    var $author$project$Api$Employer$FeedEnroller$All$publicSshKey = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$publicSshKey(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey = function(_v0) {
        var record = _v0;
        return record.XL;
    };
    var $author$project$Api$Provider$FeedEnroller$All$publicSshKey = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$publicSshKey = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$publicSshKey(shared);
    };
    var $author$project$Api$FeedEnroller$publicSshKey = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$publicSshKey(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$publicSshKey(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$publicSshKey(feedEnroller_);
        }
    };
    var $author$project$Api$Employer$FeedEnroller$Shared$server = function(_v0) {
        var record = _v0;
        return record.ZX;
    };
    var $author$project$Api$Employer$FeedEnroller$All$server = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$server(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$server = function(_v0) {
        var record = _v0;
        return record.ZX;
    };
    var $author$project$Api$Provider$FeedEnroller$All$server = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$server(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$server = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$server(shared);
    };
    var $author$project$Api$FeedEnroller$server = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$server(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$server(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$server(feedEnroller_);
        }
    };
    var $author$project$Api$Employer$FeedEnroller$Shared$username = function(_v0) {
        var record = _v0;
        return record.aaY;
    };
    var $author$project$Api$Employer$FeedEnroller$All$username = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$FeedEnroller$Shared$username(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$Shared$username = function(_v0) {
        var record = _v0;
        return record.aaY;
    };
    var $author$project$Api$Provider$FeedEnroller$All$username = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$username(shared);
    };
    var $author$project$Api$Provider$FeedEnroller$One$username = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$FeedEnroller$Shared$username(shared);
    };
    var $author$project$Api$FeedEnroller$username = function(feedEnroller) {
        switch(feedEnroller.$){
            case 0:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$All$username(feedEnroller_);
            case 1:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Employer$FeedEnroller$All$username(feedEnroller_);
            default:
                var feedEnroller_ = feedEnroller.a;
                return $author$project$Api$Provider$FeedEnroller$One$username(feedEnroller_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsFromFeedEnroller = function(feedEnroller) {
        return {
            L0: $author$project$Api$FeedEnroller$contactEmail(feedEnroller),
            L1: $author$project$Api$FeedEnroller$contactName(feedEnroller),
            OM: $author$project$Api$FeedEnroller$enabled(feedEnroller),
            PE: $author$project$Api$FeedEnroller$fileMatch(feedEnroller),
            aef: $author$project$Api$FeedEnroller$id(feedEnroller),
            V6: $author$project$Api$FeedEnroller$path(feedEnroller),
            XL: $author$project$Api$FeedEnroller$publicSshKey(feedEnroller),
            ZX: $author$project$Api$FeedEnroller$server(feedEnroller),
            aaY: $author$project$Api$FeedEnroller$username(feedEnroller)
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    XL: $author$project$Utils$String$toMaybe(string)
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    PE: string
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    OM: bool
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    L1: $author$project$Utils$String$toMaybe(string)
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    L0: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$FileMatchValidation = 0;
    var $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.PE;
        }, _Utils_Tuple2(0, 'Please enter a file match.'))
    ]));
    var $author$project$Api$Provider$UploadHeader$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$UploadHeader$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$UploadHeader$Shared$id(shared);
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderCreated = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Api$Provider$UploadHeader$One$UploadHeader = 0;
    var $author$project$Api$Provider$UploadHeader$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Company$UploadHeader$create = F4(function(apiClient, companyId, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('upload_header', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('column_name', $elm$json$Json$Encode$string(fields.LB))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$UploadHeader$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId))));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$createUploadHeader = F3(function(apiClient, company, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            LB: fields.LB
        };
        return A4($author$project$Api$Provider$Company$UploadHeader$create, apiClient, $author$project$Api$Company$id(company), apiFields, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderCreated);
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderUpdated = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$UploadHeader$uploadHeaderPath = F2(function(companyId, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Company$UploadHeader$uploadHeadersPath(companyId));
    });
    var $author$project$Api$Provider$Company$UploadHeader$update = F5(function(apiClient, companyId, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('upload_header', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('column_name', $elm$json$Json$Encode$string(fields.LB)),
                _Utils_Tuple2('required', $elm$json$Json$Encode$bool(fields.agM)),
                _Utils_Tuple2('ignored', $elm$json$Json$Encode$bool(fields.aei))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$UploadHeader$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$UploadHeader$uploadHeaderPath, companyId, id))));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$updateUploadHeader = F4(function(apiClient, company, id, formFields) {
        return A5($author$project$Api$Provider$Company$UploadHeader$update, apiClient, $author$project$Api$Company$id(company), id, $rtfeldman$elm_validate$Validate$fromValid(formFields), $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderUpdated);
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$saveUploadHeader = F4(function(apiClient, maybeId, company, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A4($author$project$Pages$Companies$CompanyId_String$Eas$updateUploadHeader, apiClient, company, id_, formFields);
        } else return A3($author$project$Pages$Companies$CompanyId_String$Eas$createUploadHeader, apiClient, company, formFields);
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$FeedEnroller$update = F5(function(apiClient, companyId, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('feed_enroller', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('enabled', $elm$json$Json$Encode$bool(params.OM)),
                _Utils_Tuple2('file_match', $elm$json$Json$Encode$string(params.PE)),
                _Utils_Tuple2('public_ssh_key', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.XL)),
                _Utils_Tuple2('contact_name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.L1)),
                _Utils_Tuple2('contact_email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.L0))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$FeedEnroller$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$FeedEnroller$feedEnrollerPath, $author$project$Api$Provider$Company$companyPath(companyId), id))));
    });
    var $author$project$Api$FeedEnroller$update = F6(function(apiClient, session, companyId, id_, params, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : A5($author$project$Api$Provider$FeedEnroller$update, apiClient, companyId, id_, params, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$FeedEnroller$ProviderOne)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$updateFeedEnroller = F5(function(apiClient, session, company, id, formFields) {
        var validFields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A6($author$project$Api$FeedEnroller$update, apiClient, session, $author$project$Api$Company$id(company), id, {
            L0: validFields.L0,
            L1: validFields.L1,
            OM: validFields.OM,
            PE: validFields.PE,
            XL: validFields.XL
        }, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerUpdated);
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingUpdated = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$defaultAutoProcessTimer = 0;
    var $author$project$Pages$Companies$CompanyId_String$Eas$defaultEndDateBuffer = 0;
    var $author$project$Pages$Companies$CompanyId_String$Eas$defaultFileGrowthThresholdPct = $author$project$Percentage$fromFloat(0.5);
    var $author$project$Pages$Companies$CompanyId_String$Eas$defaultTerminateMembersPct = $author$project$Percentage$fromFloat(0.05);
    var $author$project$Api$Provider$Company$UploadSetting$update = F4(function(apiClient, companyId, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('upload_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('adopt_companies', $elm$json$Json$Encode$bool(fields.abA)),
                _Utils_Tuple2('auto_process_timer', $elm$json$Json$Encode$int(fields.abR)),
                _Utils_Tuple2('create_child_companies', $elm$json$Json$Encode$bool(fields.acE)),
                _Utils_Tuple2('create_divisions', $elm$json$Json$Encode$bool(fields.acF)),
                _Utils_Tuple2('end_date_buffer', $elm$json$Json$Encode$int(fields.adq)),
                _Utils_Tuple2('file_growth_threshold', $elm$json$Json$Encode$bool(fields.adO)),
                _Utils_Tuple2('file_growth_threshold_pct', $author$project$Percentage$encode(fields.adP)),
                _Utils_Tuple2('inherit_plans', $elm$json$Json$Encode$bool(fields.aep)),
                _Utils_Tuple2('map_unknown_plan_values_to_company_default_plan', $elm$json$Json$Encode$bool(fields.aeW)),
                _Utils_Tuple2('name_match', $elm$json$Json$Encode$bool(fields.ae9)),
                _Utils_Tuple2('restrict_termination_by_omission_to_employees', $elm$json$Json$Encode$bool(fields.agU)),
                _Utils_Tuple2('restrict_termination_by_omission_to_feed_patients', $elm$json$Json$Encode$bool(fields.agV)),
                _Utils_Tuple2('terminate_members_by_omission', $elm$json$Json$Encode$bool(fields.ahO)),
                _Utils_Tuple2('terminate_eligibility_by_omission', $elm$json$Json$Encode$bool(fields.ahN)),
                _Utils_Tuple2('terminate_members_pct', $author$project$Percentage$encode(fields.ahP)),
                _Utils_Tuple2('use_upload_creation_date_as_enrollment_date', $elm$json$Json$Encode$bool(fields.ah9))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$UploadSetting$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$UploadSetting$uploadSettingPath(companyId))));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$updateUploadSetting = F3(function(apiClient, company, formFields) {
        var validFields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Company$UploadSetting$update, apiClient, $author$project$Api$Company$id(company), {
            abA: validFields.abA,
            abR: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultAutoProcessTimer, validFields.abR),
            acE: validFields.acE,
            acF: validFields.acF,
            adq: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultEndDateBuffer, validFields.adq),
            adO: validFields.adO,
            adP: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultFileGrowthThresholdPct, validFields.adP),
            aep: validFields.aep,
            aeW: validFields.aeW,
            ae9: validFields.ae9,
            agU: validFields.agU,
            agV: validFields.agV,
            ahN: validFields.ahN,
            ahO: validFields.ahO,
            ahP: A2($elm$core$Maybe$withDefault, $author$project$Pages$Companies$CompanyId_String$Eas$defaultTerminateMembersPct, validFields.ahP),
            ah9: validFields.ah9
        }, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingUpdated);
    });
    var $author$project$Api$Provider$UploadHeader$Shared$columnName = function(_v0) {
        var record = _v0;
        return record.LB;
    };
    var $author$project$Api$Provider$UploadHeader$All$columnName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$UploadHeader$Shared$columnName(shared);
    };
    var $author$project$Api$Provider$UploadHeader$Shared$destination = function(_v0) {
        var record = _v0;
        return record.NS;
    };
    var $author$project$Api$Provider$UploadHeader$All$destination = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$UploadHeader$Shared$destination(shared);
    };
    var $author$project$Api$Provider$UploadHeader$Shared$ignored = function(_v0) {
        var record = _v0;
        return record.aei;
    };
    var $author$project$Api$Provider$UploadHeader$All$ignored = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$UploadHeader$Shared$ignored(shared);
    };
    var $author$project$Api$Provider$UploadHeader$Shared$required = function(_v0) {
        var record = _v0;
        return record.agM;
    };
    var $author$project$Api$Provider$UploadHeader$All$required = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$UploadHeader$Shared$required(shared);
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsFromUploadHeader = function(uploadHeader) {
        return {
            LB: $author$project$Api$Provider$UploadHeader$All$columnName(uploadHeader),
            NS: $author$project$Api$Provider$UploadHeader$All$destination(uploadHeader),
            aei: $author$project$Api$Provider$UploadHeader$All$ignored(uploadHeader),
            agM: $author$project$Api$Provider$UploadHeader$All$required(uploadHeader)
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsInit = {
        LB: '',
        NS: '',
        aei: true,
        agM: false
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    LB: string
                });
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    agM: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    aei: bool
                });
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$ColumnNameValidation = 0;
    var $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.LB;
        }, _Utils_Tuple2(0, 'Please enter a column name.'))
    ]));
    var $author$project$Api$Provider$UploadSetting$One$adoptCompanies = function(_v0) {
        var record = _v0;
        return record.abA;
    };
    var $author$project$Api$Provider$UploadSetting$One$autoProcessTimer = function(_v0) {
        var record = _v0;
        return record.abR;
    };
    var $author$project$Api$Provider$UploadSetting$One$createChildCompanies = function(_v0) {
        var record = _v0;
        return record.acE;
    };
    var $author$project$Api$Provider$UploadSetting$One$createDivisions = function(_v0) {
        var record = _v0;
        return record.acF;
    };
    var $author$project$Api$Provider$UploadSetting$One$endDateBuffer = function(_v0) {
        var record = _v0;
        return record.adq;
    };
    var $author$project$Api$Provider$UploadSetting$One$fileGrowthThreshold = function(_v0) {
        var record = _v0;
        return record.adO;
    };
    var $author$project$Api$Provider$UploadSetting$One$fileGrowthThresholdPct = function(_v0) {
        var record = _v0;
        return record.adP;
    };
    var $author$project$Api$Provider$UploadSetting$One$inheritPlans = function(_v0) {
        var record = _v0;
        return record.aep;
    };
    var $author$project$Api$Provider$UploadSetting$One$mapUnknownPlanValuesToCompanyDefaultPlan = function(_v0) {
        var record = _v0;
        return record.aeW;
    };
    var $author$project$Api$Provider$UploadSetting$One$nameMatch = function(_v0) {
        var record = _v0;
        return record.ae9;
    };
    var $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToEmployees = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, false, record.agU);
    };
    var $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToFeedPatients = function(_v0) {
        var record = _v0;
        return record.agV;
    };
    var $author$project$Api$Provider$UploadSetting$One$terminateEligibilityByOmission = function(_v0) {
        var record = _v0;
        return record.ahN;
    };
    var $author$project$Api$Provider$UploadSetting$One$terminateMembersByOmission = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, false, record.ahO);
    };
    var $author$project$Api$Provider$UploadSetting$One$terminateMembersPct = function(_v0) {
        var record = _v0;
        return record.ahP;
    };
    var $author$project$Api$Provider$UploadSetting$One$useUploadCreationDateAsEnrollmentDate = function(_v0) {
        var record = _v0;
        return record.ah9;
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsFromUploadSetting = function(uploadSetting) {
        return {
            abA: $author$project$Api$Provider$UploadSetting$One$adoptCompanies(uploadSetting),
            abR: $elm$core$Maybe$Just($author$project$Api$Provider$UploadSetting$One$autoProcessTimer(uploadSetting)),
            acE: $author$project$Api$Provider$UploadSetting$One$createChildCompanies(uploadSetting),
            acF: $author$project$Api$Provider$UploadSetting$One$createDivisions(uploadSetting),
            adq: $elm$core$Maybe$Just($author$project$Api$Provider$UploadSetting$One$endDateBuffer(uploadSetting)),
            adO: $author$project$Api$Provider$UploadSetting$One$fileGrowthThreshold(uploadSetting),
            adP: $elm$core$Maybe$Just($author$project$Percentage$fromFloat($author$project$Api$Provider$UploadSetting$One$fileGrowthThresholdPct(uploadSetting))),
            aep: $author$project$Api$Provider$UploadSetting$One$inheritPlans(uploadSetting),
            aeW: $author$project$Api$Provider$UploadSetting$One$mapUnknownPlanValuesToCompanyDefaultPlan(uploadSetting),
            ae9: $author$project$Api$Provider$UploadSetting$One$nameMatch(uploadSetting),
            agU: $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToEmployees(uploadSetting),
            agV: $author$project$Api$Provider$UploadSetting$One$restrictTerminationByOmissionToFeedPatients(uploadSetting),
            ahN: $author$project$Api$Provider$UploadSetting$One$terminateEligibilityByOmission(uploadSetting),
            ahO: $author$project$Api$Provider$UploadSetting$One$terminateMembersByOmission(uploadSetting),
            ahP: $elm$core$Maybe$Just($author$project$Percentage$fromFloat($author$project$Api$Provider$UploadSetting$One$terminateMembersPct(uploadSetting))),
            ah9: $author$project$Api$Provider$UploadSetting$One$useUploadCreationDateAsEnrollmentDate(uploadSetting)
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    abA: bool
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    acE: bool
                });
            case 3:
                var bool = field.a;
                return _Utils_update(fields, {
                    acF: bool
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    adq: $elm$core$String$toInt(string)
                });
            case 7:
                var bool = field.a;
                return _Utils_update(fields, {
                    aep: bool
                });
            case 9:
                var bool = field.a;
                return _Utils_update(fields, {
                    ae9: bool
                });
            case 12:
                var bool = field.a;
                return _Utils_update(fields, {
                    ahO: bool
                });
            case 13:
                var bool = field.a;
                return _Utils_update(fields, {
                    ahN: bool
                });
            case 11:
                var bool = field.a;
                return _Utils_update(fields, {
                    agV: bool
                });
            case 10:
                var bool = field.a;
                return _Utils_update(fields, {
                    agU: bool
                });
            case 5:
                var bool = field.a;
                return _Utils_update(fields, {
                    adO: bool
                });
            case 8:
                var bool = field.a;
                return _Utils_update(fields, {
                    aeW: bool
                });
            case 14:
                var _float = field.a;
                return _Utils_update(fields, {
                    ahP: _float
                });
            case 6:
                var _float = field.a;
                return _Utils_update(fields, {
                    adP: _float
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    abR: $elm$core$String$toInt(string)
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    ah9: bool
                });
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBufferValidation = 1;
    var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPctValidation = 2;
    var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPctValidation = 3;
    var $author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage = F3(function(getter, validationGroup, fields) {
        var _v0 = getter(fields);
        if (!_v0.$) {
            var percentage = _v0.a;
            return A2($author$project$Percentage$isValid, {
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Nothing
            }, percentage) ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(validationGroup, 'Please enter a valid percentage.')
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2(validationGroup, 'Please enter a valid percentage.')
        ]);
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$validatePositive = F3(function(getter, validationGroup, fields) {
        var _v0 = getter(fields);
        if (!_v0.$) {
            var integer = _v0.a;
            return integer >= 0 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(validationGroup, 'Please enter a valid number.')
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2(validationGroup, 'Please enter a valid number.')
        ]);
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage, function($) {
            return $.ahP;
        }, 3)),
        $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Pages$Companies$CompanyId_String$Eas$validatePercentage, function($) {
            return $.adP;
        }, 2)),
        $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Pages$Companies$CompanyId_String$Eas$validatePositive, function($) {
            return $.adq;
        }, 1))
    ]));
    var $author$project$Pages$Companies$CompanyId_String$Eas$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var feedEnroller = response.a;
                    var form = A2($elm$core$Maybe$map, function(feedEnroller_) {
                        return _Utils_Tuple2($author$project$Api$FeedEnroller$id(feedEnroller_), $author$project$Utils$Form$init($author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsFromFeedEnroller(feedEnroller_)));
                    }, feedEnroller);
                    return _Utils_Tuple3(_Utils_update(model, {
                        iJ: response,
                        d5: form
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    iJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                _v2$2: while(true)switch(response.$){
                    case 3:
                        var uploadSetting = response.a;
                        var form = $author$project$Utils$Form$init($author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsFromUploadSetting(uploadSetting));
                        return _Utils_Tuple3(_Utils_update(model, {
                            kJ: response,
                            bJ: $elm$core$Maybe$Just(_Utils_Tuple2(form, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        if (response.a.$ === 5) {
                            var _v3 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                kJ: response
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v2$2;
                    default:
                        break _v2$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    kJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    kH: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 3:
                var field = msg.a;
                var _v4 = model.d5;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var id = _v5.a;
                    var form = _v5.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        d5: $elm$core$Maybe$Just(_Utils_Tuple2(id, newForm))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    d6: $author$project$Api$Data$Loading
                }), A5($author$project$Api$FeedEnroller$create, model.Ej, model.Z$, $author$project$Api$Company$id(model.acy), {
                    ahr: model.acU
                }, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerCreated), _List_Nil);
            case 5:
                var _v6 = model.d5;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var id = _v7.a;
                    var form = _v7.b;
                    var _v8 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$feedEnrollerFormFieldsValidator, form);
                    if (!_v8.$) {
                        var _v9 = _v8.a;
                        var newForm = _v9.a;
                        var validFormFields = _v9.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            d5: $elm$core$Maybe$Just(_Utils_Tuple2(id, newForm)),
                            d6: $author$project$Api$Data$Loading
                        }), A5($author$project$Pages$Companies$CompanyId_String$Eas$updateFeedEnroller, model.Ej, model.Z$, model.acy, id, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v8.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            d5: $elm$core$Maybe$Just(_Utils_Tuple2(id, newForm))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                if (response.$ === 3) {
                    var companyId = $author$project$Api$Company$id(model.acy);
                    return _Utils_Tuple3(_Utils_update(model, {
                        iJ: $author$project$Api$Data$Loading,
                        d6: response,
                        kH: $author$project$Api$Data$Loading,
                        kJ: $author$project$Api$Data$Loading
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model),
                        A4($author$project$Api$FeedEnroller$retrieve, model.Ej, model.Z$, companyId, $author$project$Pages$Companies$CompanyId_String$Eas$GotFeedEnroller),
                        A3($author$project$Api$Provider$Company$UploadSetting$retrieve, model.Ej, companyId, $author$project$Pages$Companies$CompanyId_String$Eas$GotUploadSetting)
                    ])), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'SFTP Server created.')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    d6: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    d6: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'SFTP Server updated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    d6: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    dQ: $elm$core$Maybe$Just(_Utils_Tuple2(id, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    dQ: $elm$core$Maybe$Just(_Utils_Tuple2(id, $author$project$Api$Data$Loading))
                }), A5($author$project$Api$FeedEnroller$delete, model.Ej, model.Z$, $author$project$Api$Company$id(model.acy), id, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerDeleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    dQ: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var id = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    dQ: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'SFTP server is being removed.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    dQ: $elm$core$Maybe$Just(_Utils_Tuple2(id, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                var field = msg.a;
                var _v13 = model.bJ;
                if (!_v13.$) {
                    var _v14 = _v13.a;
                    var form = _v14.a;
                    var saveRequest = _v14.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        bJ: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, saveRequest))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var _v15 = model.bJ;
                if (!_v15.$) {
                    var _v16 = _v15.a;
                    var form = _v16.a;
                    var _v17 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$uploadSettingFormFieldsValidator, form);
                    if (!_v17.$) {
                        var _v18 = _v17.a;
                        var newForm = _v18.a;
                        var validFormFields = _v18.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bJ: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, $author$project$Api$Data$Loading))
                        }), A3($author$project$Pages$Companies$CompanyId_String$Eas$updateUploadSetting, model.Ej, model.acy, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v17.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bJ: $elm$core$Maybe$Just(_Utils_Tuple2(newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var response = msg.a;
                var _v19 = model.bJ;
                if (!_v19.$) {
                    var _v20 = _v19.a;
                    var form = _v20.a;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        bJ: $elm$core$Maybe$Just(_Utils_Tuple2(form, response))
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Upload settings updated.')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        bJ: $elm$core$Maybe$Just(_Utils_Tuple2(form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                return _Utils_Tuple3(_Utils_update(model, {
                    U: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var uploadHeader = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    U: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$UploadHeader$All$id(uploadHeader)), $author$project$Utils$Form$init($author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsFromUploadHeader(uploadHeader)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                return _Utils_Tuple3(_Utils_update(model, {
                    U: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var field = msg.a;
                var _v22 = model.U;
                if (!_v22.$) {
                    var _v23 = _v22.a;
                    var id = _v23.a;
                    var form = _v23.b;
                    var uploadHeader = _v23.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        U: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, uploadHeader))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var form = msg.a;
                var id = msg.b;
                var _v24 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$Eas$uploadHeaderFormFieldsValidator, form);
                if (!_v24.$) {
                    var _v25 = _v24.a;
                    var newForm = _v25.a;
                    var validFormFields = _v25.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        U: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A4($author$project$Pages$Companies$CompanyId_String$Eas$saveUploadHeader, model.Ej, id, model.acy, validFormFields), _List_Nil);
                } else {
                    var newForm = _v24.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        U: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 19:
                var response = msg.a;
                var _v26 = model.U;
                if (!_v26.$) {
                    var _v27 = _v26.a;
                    var id = _v27.a;
                    var form = _v27.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        U: $elm$core$Maybe$Nothing,
                        kH: $author$project$Api$Data$Loading
                    }), $author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Upload header created.')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        U: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                var _v29 = model.U;
                if (!_v29.$) {
                    var _v30 = _v29.a;
                    var id = _v30.a;
                    var form = _v30.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        U: $elm$core$Maybe$Nothing,
                        kH: $author$project$Api$Data$Loading
                    }), $author$project$Pages$Companies$CompanyId_String$Eas$fetchUploadHeaders(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Upload settings updated.')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        U: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Layouts$Company$Uploads$companyIsChild = function(company) {
        return $author$project$Api$Company$companyType(company) === 1;
    };
    var $author$project$Api$Employer$Company$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Company$Min$id = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$Min$id(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$Min$id(company_);
        }
    };
    var $author$project$Api$Employer$Company$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Company$Min$name = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$Min$name(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$Min$name(company_);
        }
    };
    var $author$project$Api$Company$Min$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Company$Min$fromEmployer = $author$project$Api$Company$Min$Employer;
    var $author$project$Api$Company$Min$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Company$Min$fromProvider = $author$project$Api$Company$Min$Provider;
    var $author$project$Api$Employer$Company$One$parent = function(_v0) {
        var record = _v0.b;
        return record.VV;
    };
    var $author$project$Api$Provider$Company$One$parent = function(_v0) {
        var record = _v0.b;
        return record.VV;
    };
    var $author$project$Api$Company$parent = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Company$Min$fromProvider, $author$project$Api$Provider$Company$One$parent(company_));
        } else {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Company$Min$fromEmployer, $author$project$Api$Employer$Company$One$parent(company_));
        }
    };
    var $author$project$Layouts$Company$Uploads$companyIsParent = function(company) {
        return $author$project$Api$Company$companyType(company) === 2;
    };
    var $author$project$Layouts$Company$Uploads$companyIsStandalone = function(company) {
        return $author$project$Api$Company$companyType(company) === 3;
    };
    var $author$project$Layouts$Company$Uploads$betaPageMessage = F2(function(feedEnroller, company) {
        return $author$project$Utils$Maybe$toBool(feedEnroller) || $author$project$Layouts$Company$Uploads$companyIsParent(company) ? 'This company is on an AutoSync. Any questions/concerns? Reach out to autosync@hint.com today!' : $author$project$Layouts$Company$Uploads$companyIsStandalone(company) ? 'Interested in automating and unlocking more advanced features and support for your employee uploads? Reach out to support@hint.com today!' : '';
    });
    var $author$project$Layouts$Company$Uploads$viewBetaPagePopover = F2(function(feedEnroller, company) {
        var betaPageMessage_ = function() {
            if (feedEnroller.$ === 3) {
                var feedEnroller_ = feedEnroller.a;
                return A2($author$project$Layouts$Company$Uploads$betaPageMessage, feedEnroller_, company);
            } else return '';
        }();
        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$wide
        ]), betaPageMessage_, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$warning
            ]), _List_fromArray([
                $author$project$Ui$Icon$alert(_List_Nil)
            ]))
        ]));
    });
    var $author$project$Layouts$Company$Uploads$view = F6(function(session, practice, company, feedEnroller, contents, footer) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Employee Uploads'),
                        $author$project$Utils$Html$noBreakSpace,
                        !$author$project$Layouts$Company$Uploads$companyIsChild(company) ? A2($author$project$Layouts$Company$Uploads$viewBetaPagePopover, feedEnroller, company) : $author$project$Utils$Html$empty
                    ])),
                    function() {
                        var _v0 = $author$project$Api$Company$parent(company);
                        if (!_v0.$) {
                            var parent = _v0.a;
                            return A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('This '),
                                $elm$html$Html$text(A2($author$project$Api$Practice$sponsorize, practice, 'employer')),
                                $elm$html$Html$text('\'s eligibility and enrollment information is administered by '),
                                $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$html$Html$text($author$project$Api$Company$Min$name(parent)) : A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top({
                                    fl: $author$project$Api$Company$Min$id(parent)
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Company$Min$name(parent))
                                ])),
                                $elm$html$Html$text(' please go to their account to view '),
                                $elm$html$Html$text(A2($author$project$Api$Practice$sponsorize, practice, 'employee')),
                                $elm$html$Html$text(' upload files.')
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]),
                contents
            ]))),
            $elm$core$List$isEmpty(footer) ? $author$project$Ui$Panel$none : A2($author$project$Ui$Panel$footer, _List_Nil, footer)
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$ContactEmail = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$ContactName = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$CreateFeedEnroller = {
        $: 4
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnroller = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$Enabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$FileMatch = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$PublicSshKey = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$SaveFeedEnroller = {
        $: 5
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$viewFeedEnroller = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('SFTP Server')
            ])),
            function() {
                var _v0 = model.iJ;
                if (_v0.$ === 3) {
                    var _v1 = model.d5;
                    if (!_v1.$) {
                        var _v2 = _v1.a;
                        var form = _v2.b;
                        var fields = $author$project$Utils$Form$fields(form);
                        return A2($author$project$Ui$Form$view, _List_fromArray([
                            $author$project$Ui$Form$horizontal,
                            $author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Eas$SaveFeedEnroller),
                            $author$project$Ui$Form$noValidate(true),
                            $author$project$Ui$Form$autocomplete(false)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label('SSH Key')
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                                    $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', fields.XL)),
                                    $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$PublicSshKey)),
                                    $author$project$Ui$Form$Textarea$placeholder('Begins with \'ssh-rsa\', \'ssh-dss\', \'ssh-ed25519\', \'ecdsa-sha2-nistp256\', \'ecdsa-sha2-nistp384\', or \'ecdsa-sha2-nistp521\''),
                                    $author$project$Ui$Form$Textarea$disabled(model.acU)
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label('File Regex Match'),
                                $author$project$Ui$Form$Group$required(true)
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value(fields.PE),
                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$FileMatch)),
                                    $author$project$Ui$Form$Input$placeholder('Regular Expression to match files'),
                                    $author$project$Ui$Form$Input$disabled(model.acU),
                                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label('SFTP Server Address:Port')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(fields.ZX),
                                    $elm$html$Html$text(':22')
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label('Path')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(fields.V6)
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label('Username')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(fields.aaY)
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label('Autoprocess')
                            ]), _List_fromArray([
                                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                    $author$project$Ui$ToggleSwitch$on(fields.OM),
                                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Enabled))
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(3),
                                $author$project$Ui$Form$Group$label('Contact name')
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.L1)),
                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ContactName))
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(3),
                                $author$project$Ui$Form$Group$label('Contact email')
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.L0)),
                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$FeedEnrollerFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ContactEmail))
                                ]))
                            ])),
                            model.F3 ? A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textCenter,
                                $author$project$Ui$Element$mt4
                            ]), _List_fromArray([
                                A3($author$project$Ui$HinterOnly$button, {
                                    abP: 'Update SFTP server'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$primary,
                                    $author$project$Ui$Button$submit
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Update')
                                ])),
                                A3($author$project$Ui$HinterOnly$button, {
                                    abP: 'Remove SFTP server'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$danger,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnroller(fields.aef))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Remove SFTP Server')
                                ]))
                            ])) : $author$project$Utils$Html$empty
                        ]));
                    } else return model.F3 ? A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyCenter
                    ]), _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: 'Create SFTP Server'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$CreateFeedEnroller),
                            $author$project$Ui$Button$loading(_Utils_eq(model.d6, $author$project$Api$Data$Loading))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Create SFTP Server')
                        ]))
                    ])) : $author$project$Utils$Html$empty;
                } else return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter
                ]), _List_fromArray([
                    $author$project$Ui$Spinner$view(_List_Nil)
                ]));
            }()
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$ColumnName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$Ignored = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$Required = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadHeader = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$viewModal = F3(function(id, form, uploadHeader) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Upload Header',
            Tk: _Utils_eq(uploadHeader, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Companies$CompanyId_String$Eas$CancelUploadHeaderEdit,
            Vn: $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadHeader(form)
        };
        var fields = $author$project$Utils$Form$fields(form);
        var hasDestination = !$elm$core$String$isEmpty(fields.NS);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Column Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.LB),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$ColumnName)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Destination')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    hasDestination ? $elm$html$Html$text($author$project$Formatters$String$titleize(fields.NS)) : $elm$html$Html$text('N/A')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Required')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.agM),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Required)),
                    $author$project$Ui$ToggleSwitch$disabled(!$author$project$Utils$Maybe$toBool(id) || !hasDestination)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Ignored')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.aei),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadHeaderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Eas$Ignored)),
                    $author$project$Ui$ToggleSwitch$disabled(!$author$project$Utils$Maybe$toBool(id) || !hasDestination)
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$NewUploadHeader = {
        $: 14
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$EditUploadHeader = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$viewuUploadHeader = function(uploadHeader) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$UploadHeader$All$columnName(uploadHeader))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Api$Provider$UploadHeader$All$destination(uploadHeader)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Provider$UploadHeader$All$required(uploadHeader)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Provider$UploadHeader$All$ignored(uploadHeader)))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit upload header'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$EditUploadHeader(uploadHeader)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadHeaders = function(model) {
        var _v0 = function() {
            var _v1 = model.kH;
            if (_v1.$ === 3) {
                var uploadHeaders_ = _v1.a;
                return _Utils_Tuple2(false, A2($elm$core$List$sortBy, $author$project$Api$Provider$UploadHeader$All$destination, uploadHeaders_));
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var uploadHeaders = _v0.b;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Upload Headers')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'New upload header'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$NewUploadHeader),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                ]), _List_fromArray([
                    $elm$html$Html$text('New Upload Header')
                ]))
            ])),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('None')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('Column name')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('Destination')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('Required')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('Ignored')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2)
                ]), _List_Nil)
            ]), A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$Eas$viewuUploadHeader, uploadHeaders), _List_Nil)
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$AdoptCompanies = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimerValidation = 0;
    var $author$project$Pages$Companies$CompanyId_String$Eas$CreateChildCompanies = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$CreateDivisions = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBuffer = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThreshold = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPct = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$InheritPlans = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$MapUnknownPlanValuesToCompanyDefaultPlan = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$NameMatch = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToEmployees = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToFeedPatients = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting = {
        $: 12
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateEligibilityByOmission = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersByOmission = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPct = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$UseUploadCreationDateAsEnrollmentDate = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField = F4(function(title, description, value, field) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(7),
            $author$project$Ui$Form$Group$inputSpan(4),
            $author$project$Ui$Form$Group$label(title),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text(description))
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(value),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField = F8(function(title, description, placeholder, value, field, validationGroup, form, fieldLabel) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(7),
            $author$project$Ui$Form$Group$inputSpan(4),
            $author$project$Ui$Form$Group$label(title),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text(description))
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, value))),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field)),
                        $author$project$Ui$Form$Input$number,
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, validationGroup, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
                        $author$project$Ui$Form$Input$placeholder(placeholder)
                    ])),
                    $author$project$Ui$Form$Input$addon(_List_fromArray([
                        $elm$html$Html$text(fieldLabel)
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField = F7(function(title, description, placeholder, value, field, validationGroup, form) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(7),
            $author$project$Ui$Form$Group$inputSpan(4),
            $author$project$Ui$Form$Group$label(title),
            $author$project$Ui$Form$Group$labelClass(''),
            $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text(description))
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                    $author$project$Ui$Form$PercentageInput$value(value),
                    $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Eas$UploadSettingFormUpdated, field)),
                    $author$project$Ui$Form$PercentageInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, validationGroup, form)),
                    $author$project$Ui$Form$PercentageInput$errors(A2($author$project$Utils$Form$validationErrors, validationGroup, form)),
                    $author$project$Ui$Form$PercentageInput$placeholder(placeholder)
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSetting = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Upload Settings')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt4
            ]), function() {
                var _v0 = model.bJ;
                if (!_v0.$) {
                    var _v1 = _v0.a;
                    var form = _v1.a;
                    var saveRequest = _v1.b;
                    var fields = $author$project$Utils$Form$fields(form);
                    return _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(11),
                                $author$project$Ui$Grid$offset(1)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$view, _List_fromArray([
                                    $author$project$Ui$Form$horizontal,
                                    $author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting),
                                    $author$project$Ui$Form$noValidate(true),
                                    $author$project$Ui$Form$autocomplete(false)
                                ]), _List_fromArray([
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Adopt Companies', 'When enabled, any companies that appear in the file that we were able to match by Name to an existing company, will automatically be adopted as a Child Company.', fields.abA, $author$project$Pages$Companies$CompanyId_String$Eas$AdoptCompanies),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Create Child Companies', 'When enabled, any new companies that appear in the file that we are unable to match to an existing Company, will be created as a Child Company (and support the same plan as the parent).', fields.acE, $author$project$Pages$Companies$CompanyId_String$Eas$CreateChildCompanies),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Create Divisions', 'When enabled, any new divisions that appear in the file that we are unable to match to an existing Division will be created as a Division for that Company.', fields.acF, $author$project$Pages$Companies$CompanyId_String$Eas$CreateDivisions),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Inherit Plans', 'When enabled, any plan names that appear in the file that are not supported by the Child Company but do match a plan supported by the Parent Company, will be adopted by the Child Company. If disabled, then those plans would map to the Company\'s default plan.', fields.aep, $author$project$Pages$Companies$CompanyId_String$Eas$InheritPlans),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Name Match', 'When enabled, system will try to match patients on First Name, Last Name, and DOB when we cannot match based on external_id, nor SSN.', fields.ae9, $author$project$Pages$Companies$CompanyId_String$Eas$NameMatch),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Terminate Members By Omission', 'When enabled, we will terminate the memberships from the \'Missing Patients\' List as long as it does not exceed the TERMINATE MEMBERS PCT.', fields.ahO, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersByOmission),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Terminate Eligibility By Omission', 'When enabled, we will terminate patients\' eligibility from the \'Missing Patients\' List', fields.ahN, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateEligibilityByOmission),
                                    A7($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField, 'Terminate Members Pct', 'Default 5%. This percent is meant as a validation to ensure the Missing Patients list is not greater than expected. Specifically, when the percent of missing patients (out of total active members) is higher than this threshold, the system will Fail to Terminate and notify users to review the file for accuracy.', '0.01', fields.ahP, $author$project$Pages$Companies$CompanyId_String$Eas$TerminateMembersPct, 3, form),
                                    A8($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField, 'End Date Buffer', 'Default 0. A number of days to add to the end of a membership when that member is terminated', '0', fields.adq, $author$project$Pages$Companies$CompanyId_String$Eas$EndDateBuffer, 1, form, 'days'),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Restrict Termination By Omission To Feed Patients', 'When enabled, patients will only be terminated by omission if they previously appeared on an employee file (i.e. they have ea File System Import Identifier). When disabled, patients will be terminated by omission, regardless of whether or not they have ever appeared on an employee file.', fields.agV, $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToFeedPatients),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Restrict Termination By Omission To Employees', 'When enabled, the system will only check to see if employees are absent from the file. When disabled, the system will check if employees or dependents are absent from the file.', fields.agU, $author$project$Pages$Companies$CompanyId_String$Eas$RestrictTerminationByOmissionToEmployees),
                                    A8($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingIntField, 'Auto Process Timer', 'This determines how long the system will hold off on processing a file if there are unmapped data values found. The idea here is that when it is >0, you have time to review the unmapped values and resolve them.', '4000', fields.abR, $author$project$Pages$Companies$CompanyId_String$Eas$AutoProcessTimer, 0, form, 'min'),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Review File Size Increases', 'When enabled, a new upload will be paused if it is larger than the previous processed upload by REVIEW FILE SIZE PCT.', fields.adO, $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThreshold),
                                    A7($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingPercentageField, 'Review File Size Pct', 'Default 50%. When a new upload exceeds the previous completed upload by this threshold, the upload will be paused so the user can verify this increase was intended.', '0.5', fields.adP, $author$project$Pages$Companies$CompanyId_String$Eas$FileGrowthThresholdPct, 2, form),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Map Unknown Plan Values To Company Default Plan', 'If enabled, unknown plan values in the file will be mapped to the Company\'s default plan.', fields.aeW, $author$project$Pages$Companies$CompanyId_String$Eas$MapUnknownPlanValuesToCompanyDefaultPlan),
                                    A4($author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSettingBoolField, 'Enroll By Presence', 'When enabled we will enroll patients that do not have start dates indicated in the file. Their start date will be determined using the company enrollment cutoff date. If a start date is included on any rows, we will use that date', fields.ah9, $author$project$Pages$Companies$CompanyId_String$Eas$UseUploadCreationDateAsEnrollmentDate)
                                ]))
                            ]))
                        ])),
                        model.F3 ? A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$HinterOnly$button, {
                                abP: 'Update upload settings'
                            }, _List_fromArray([
                                $author$project$Ui$Button$styled(1),
                                $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Eas$SaveUploadSetting),
                                $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Update')
                            ]))
                        ])) : $author$project$Utils$Html$empty
                    ]);
                } else return _List_Nil;
            }())
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.dQ;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        var deleteRequest = _v1.b;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Companies$CompanyId_String$Eas$DeleteFeedEnrollerHiConfirmClosed(id), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('sftp server'),
                            $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.U;
                    if (!_v2.$) {
                        var _v3 = _v2.a;
                        var id = _v3.a;
                        var form = _v3.b;
                        var uploadHeader = _v3.c;
                        return A3($author$project$Pages$Companies$CompanyId_String$Eas$viewModal, id, form, uploadHeader);
                    } else return $author$project$Utils$Html$empty;
                }(),
                A6($author$project$Layouts$Company$Uploads$view, model.Z$, model.W1, model.acy, model.iJ, _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    $author$project$Pages$Companies$CompanyId_String$Eas$viewFeedEnroller(model),
                    function() {
                        var _v4 = model.kJ;
                        switch(_v4.$){
                            case 3:
                                return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                    $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadSetting(model),
                                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                    $author$project$Pages$Companies$CompanyId_String$Eas$viewUploadHeaders(model)
                                ]));
                            case 2:
                                return $author$project$Utils$Html$empty;
                            default:
                                return A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$itemsCenter,
                                    $author$project$Ui$Element$mt2
                                ]), _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_Nil)
                                ]));
                        }
                    }()
                ]), _List_Nil)
            ]),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Upload Settings'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Eas$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Eas$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Eas$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Eas$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Eas$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Eas$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Eas$view
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Feature$ManuallyDisableElationSync = 3;
    var $author$project$Components$Employee$Form$Division = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$EligibilityDate = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$EmployeeForm = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Employee$Form$FieldUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$PatientFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$Plan = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$Type = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$defaultEmployeeSettings = {
        YJ: false,
        B9: true,
        aa1: false
    };
    var $author$project$Components$Patient$Form$defaultSettings = F3(function(currentDate, isNew, isEmployeeForm) {
        return {
            ab1: false,
            ab8: false,
            cP: currentDate,
            Qr: false,
            Qx: false,
            q6: isEmployeeForm,
            iZ: isNew,
            ae_: false,
            Ue: $elm$core$Maybe$Nothing,
            ru: false,
            B8: false,
            agQ: false,
            YK: false,
            agR: false,
            YP: false,
            YQ: false,
            _$: false,
            $D: false,
            ah_: false,
            aaq: false,
            aas: false,
            DT: false
        };
    });
    var $author$project$Components$Employee$Form$defaultSettings = F3(function(currentDate, isNew, employeeSettings) {
        return {
            xt: employeeSettings,
            V7: A3($author$project$Components$Patient$Form$defaultSettings, currentDate, isNew, true)
        };
    });
    var $author$project$Components$EmployeeDependentTypeInput$empty = F2(function(session, company) {
        return _Utils_Tuple2({
            acy: company,
            fx: $elm$core$Maybe$Nothing,
            d_: $elm$core$Maybe$Nothing,
            Z$: session,
            ah5: 'employee'
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$EmployeeDivisionInput$empty = F3(function(session, companyId, apiClient) {
        return _Utils_Tuple2({
            Ej: apiClient,
            Oa: $elm$core$Maybe$Nothing,
            xv: $author$project$Api$Data$Loading,
            agM: false,
            Z$: session
        }, A5($author$project$Api$EmployeeDivision$list, apiClient, session, companyId, function(d) {
            return d;
        }, $author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions));
    });
    var $author$project$Components$Patient$Form$Address = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$Affiliate = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$FieldUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$HealthInsurance = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$JoinedPractice = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$KnownPractice = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$LeadSource = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$Location = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$PatientForm = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Practitioner$PracticeExtras = 1;
    var $author$project$Components$Patient$Form$Practitioner = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$affiliateOptionals = F2(function(practitioner, location1) {
        return function(d) {
            return _Utils_update(d, {
                aeT: location1,
                agi: practitioner
            });
        };
    });
    var $author$project$Api$Employer$Company$One$defaultAffiliation = function(_v0) {
        var record = _v0.b;
        return record.No;
    };
    var $author$project$Api$Provider$Company$One$defaultAffiliation = function(_v0) {
        var record = _v0.b;
        return record.No;
    };
    var $author$project$Api$Company$defaultAffiliation = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Provider, $author$project$Api$Provider$Company$One$defaultAffiliation(company_));
        } else {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Employer, $author$project$Api$Employer$Company$One$defaultAffiliation(company_));
        }
    };
    var $author$project$Api$Location$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$Company$One$defaultLocation = function(_v0) {
        var record = _v0.b;
        return record.Nr;
    };
    var $author$project$Api$Provider$Company$One$defaultLocation = function(_v0) {
        var record = _v0.b;
        return record.Nr;
    };
    var $author$project$Api$Company$defaultLocation = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Location$Shared$Provider, $author$project$Api$Provider$Company$One$defaultLocation(company_));
        } else {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Location$Shared$Employer, $author$project$Api$Employer$Company$One$defaultLocation(company_));
        }
    };
    var $author$project$Api$Practitioner$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$Company$One$defaultPractitioner = function(_v0) {
        var record = _v0.b;
        return record.NB;
    };
    var $author$project$Api$Provider$Company$One$defaultPractitioner = function(_v0) {
        var record = _v0.b;
        return record.NB;
    };
    var $author$project$Api$Company$defaultPractitioner = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Practitioner$Shared$Provider, $author$project$Api$Provider$Company$One$defaultPractitioner(company_));
        } else {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Practitioner$Shared$Employer, $author$project$Api$Employer$Company$One$defaultPractitioner(company_));
        }
    };
    var $author$project$Components$AffiliateInput$FilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$Affiliate$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Affiliate$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Affiliate$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Affiliate$affiliatesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'affiliates'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Affiliate$All$Affiliate = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Affiliate$Shared$Affiliate = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Affiliate$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Employer$Affiliate$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Affiliate$Shared$Record)));
    var $author$project$Api$Employer$Affiliate$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Affiliate$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Affiliate$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Affiliate$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Affiliate$listDefaults = {
        aef: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agi: $elm$core$Maybe$Nothing,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Employer$Affiliate$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Employer$Affiliate$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.ahy;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Employer$Affiliate$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$Affiliate$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Employer$Affiliate$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$Affiliate$affiliatesPath)));
    });
    var $author$project$Api$Affiliate$list = F4(function(apiClient, session, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Affiliate$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Affiliate$All$Employer)))) : A3($author$project$Api$Provider$Affiliate$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Affiliate$All$Provider))));
    });
    var $author$project$Components$ResourceFilter$Affiliate$list = $author$project$Api$Affiliate$list;
    var $author$project$Api$Employer$Affiliate$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$Affiliate$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Affiliate$Shared$id(shared);
    };
    var $author$project$Api$Affiliate$All$id = function(affiliate) {
        if (!affiliate.$) {
            var affiliate_ = affiliate.a;
            return $author$project$Api$Provider$Affiliate$All$id(affiliate_);
        } else {
            var affiliate_ = affiliate.a;
            return $author$project$Api$Employer$Affiliate$All$id(affiliate_);
        }
    };
    var $author$project$Api$Employer$Affiliate$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$Affiliate$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Affiliate$Shared$name(shared);
    };
    var $author$project$Api$Affiliate$All$name = function(affiliate) {
        if (!affiliate.$) {
            var affiliate_ = affiliate.a;
            return $author$project$Api$Provider$Affiliate$All$name(affiliate_);
        } else {
            var affiliate_ = affiliate.a;
            return $author$project$Api$Employer$Affiliate$All$name(affiliate_);
        }
    };
    var $author$project$Components$ResourceFilter$Affiliate$resourceFromAll = function(affiliate) {
        return {
            aef: $author$project$Api$Affiliate$All$id(affiliate),
            zr: $author$project$Api$Affiliate$All$name(affiliate)
        };
    };
    var $author$project$Components$ResourceFilter$Affiliate$fetchResources = F6(function(session, listOptionals, toMsg, apiClient, pagination, query) {
        return A4($author$project$Components$ResourceFilter$Affiliate$list, apiClient, session, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$Affiliate$retrieveResource = F5(function(session, listOptionals, toMsg, apiClient, id) {
        return A4($author$project$Components$ResourceFilter$Affiliate$list, apiClient, session, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$Affiliate$selectId = 'affiliates';
    var $author$project$Components$ResourceFilter$Affiliate$toTitle = A2($elm$core$Basics$composeR, function($) {
        return $.zr;
    }, $elm$core$Maybe$withDefault('N/A'));
    var $author$project$Components$ResourceFilter$Affiliate$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Affiliate$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$Affiliate$toValue = function($) {
        return $.aef;
    };
    var $author$project$Components$ResourceFilter$Affiliate$init = F4(function(apiClient, session, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: A2($author$project$Components$ResourceFilter$Affiliate$fetchResources, session, listOptionals),
            aef: $author$project$Components$ResourceFilter$Affiliate$selectId,
            gD: 'Affiliate',
            sz: A2($author$project$Components$ResourceFilter$Affiliate$retrieveResource, session, listOptionals),
            ahW: $author$project$Components$ResourceFilter$Affiliate$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Affiliate$toTitle,
            g4: $author$project$Components$ResourceFilter$Affiliate$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$AffiliateInput$empty = F3(function(apiClient, session, listOptionals) {
        var _v0 = A4($author$project$Components$ResourceFilter$Affiliate$init, apiClient, session, listOptionals, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
        var filter = _v0.a;
        var filterCmd = _v0.b;
        return _Utils_Tuple2({
            Fw: filter,
            aa9: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
    });
    var $author$project$Components$HealthInsuranceInput$FilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$HealthInsuranceInput$Model = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$InsuranceCarrierAlias$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$InsuranceCarrierAlias$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$InsuranceCarrierAlias$All$InsuranceCarrierAlias = $elm$core$Basics$identity;
    var $author$project$Api$Employer$InsuranceCarrierAlias$One$InsuranceCarrierAlias = $elm$core$Basics$identity;
    var $author$project$Api$Employer$InsuranceCarrierAlias$One$Record = F2(function(name, carrier) {
        return {
            K_: carrier,
            zr: name
        };
    });
    var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$HealthInsuranceCarrier = $elm$core$Basics$identity;
    var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$Record = F4(function(id, collectGroupId, collectHighDeductible, collectMemberId) {
        return {
            Lr: collectGroupId,
            Ls: collectHighDeductible,
            Lv: collectMemberId,
            aef: id
        };
    });
    var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_member_id', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_high_deductible', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_group_id', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$HealthInsuranceCarrier$Shared$Record)))));
    var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$HealthInsuranceCarrier$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$InsuranceCarrierAlias$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'carrier', $author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$InsuranceCarrierAlias$One$Record)));
    var $author$project$Api$Employer$InsuranceCarrierAlias$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$InsuranceCarrierAlias$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$InsuranceCarrierAlias$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$InsuranceCarrierAlias$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$InsuranceCarrierAlias$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$InsuranceCarrierAlias$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, optionals, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'health_insurance_carrier_aliases'
        ]), $author$project$Api$Data$employerPath))));
    });
    var $author$project$Api$Provider$InsuranceCarrierAlias$All$InsuranceCarrierAlias = $elm$core$Basics$identity;
    var $author$project$Api$Provider$InsuranceCarrierAlias$One$InsuranceCarrierAlias = $elm$core$Basics$identity;
    var $author$project$Api$Provider$InsuranceCarrierAlias$One$Record = F2(function(name, carrier) {
        return {
            K_: carrier,
            zr: name
        };
    });
    var $author$project$Api$Provider$InsuranceCarrierAlias$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'carrier', $author$project$Api$Provider$HealthInsuranceCarrier$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InsuranceCarrierAlias$One$Record)));
    var $author$project$Api$Provider$InsuranceCarrierAlias$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InsuranceCarrierAlias$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$InsuranceCarrierAlias$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InsuranceCarrierAlias$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$InsuranceCarrierAlias$list = F3(function(apiClient, params, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$InsuranceCarrierAlias$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, params, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'health_insurance_carrier_aliases'
        ]), $author$project$Api$Data$providerPath))));
    });
    var $author$project$Api$InsuranceCarrierAlias$defaults = {
        aef: $elm$core$Maybe$Nothing,
        zr: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$InsuranceCarrierAlias$optionalsToParams = function(optionals) {
        var options = optionals($author$project$Api$InsuranceCarrierAlias$defaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.aef;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.zr;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'name', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$InsuranceCarrierAlias$list = F4(function(apiClient, session, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$InsuranceCarrierAlias$list, apiClient, $author$project$Api$InsuranceCarrierAlias$optionalsToParams(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$InsuranceCarrierAlias$All$Employer)))) : A3($author$project$Api$Provider$InsuranceCarrierAlias$list, apiClient, $author$project$Api$InsuranceCarrierAlias$optionalsToParams(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$InsuranceCarrierAlias$All$Provider))));
    });
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$list = $author$project$Api$InsuranceCarrierAlias$list;
    var $author$project$Api$HealthInsuranceCarrier$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$HealthInsuranceCarrier$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$InsuranceCarrierAlias$One$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Employer$InsuranceCarrierAlias$One$carrier = A2($elm$core$Basics$composeR, $author$project$Api$Employer$InsuranceCarrierAlias$One$record, function($) {
        return $.K_;
    });
    var $author$project$Api$Employer$InsuranceCarrierAlias$All$one = function(_v0) {
        var one_ = _v0;
        return one_;
    };
    var $author$project$Api$Employer$InsuranceCarrierAlias$All$carrier = A2($elm$core$Basics$composeR, $author$project$Api$Employer$InsuranceCarrierAlias$All$one, $author$project$Api$Employer$InsuranceCarrierAlias$One$carrier);
    var $author$project$Api$Provider$InsuranceCarrierAlias$One$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Provider$InsuranceCarrierAlias$One$carrier = A2($elm$core$Basics$composeR, $author$project$Api$Provider$InsuranceCarrierAlias$One$record, function($) {
        return $.K_;
    });
    var $author$project$Api$Provider$InsuranceCarrierAlias$All$one = function(_v0) {
        var one_ = _v0;
        return one_;
    };
    var $author$project$Api$Provider$InsuranceCarrierAlias$All$carrier = A2($elm$core$Basics$composeR, $author$project$Api$Provider$InsuranceCarrierAlias$All$one, $author$project$Api$Provider$InsuranceCarrierAlias$One$carrier);
    var $author$project$Api$InsuranceCarrierAlias$All$carrier = function(carrierAlias) {
        if (!carrierAlias.$) {
            var carrierAlias_ = carrierAlias.a;
            return $author$project$Api$HealthInsuranceCarrier$Shared$Provider($author$project$Api$Provider$InsuranceCarrierAlias$All$carrier(carrierAlias_));
        } else {
            var carrierAlias_ = carrierAlias.a;
            return $author$project$Api$HealthInsuranceCarrier$Shared$Employer($author$project$Api$Employer$InsuranceCarrierAlias$All$carrier(carrierAlias_));
        }
    };
    var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectGroupId = function(_v0) {
        var shared = _v0;
        return shared.Lr;
    };
    var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectGroupId = function(_v0) {
        var shared = _v0;
        return shared.Lr;
    };
    var $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId = function(carrier) {
        if (!carrier.$) {
            var carrier_ = carrier.a;
            return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectGroupId(carrier_);
        } else {
            var carrier_ = carrier.a;
            return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectGroupId(carrier_);
        }
    };
    var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectHighDeductible = function(_v0) {
        var shared = _v0;
        return shared.Ls;
    };
    var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectHighDeductible = function(_v0) {
        var shared = _v0;
        return shared.Ls;
    };
    var $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible = function(carrier) {
        if (!carrier.$) {
            var carrier_ = carrier.a;
            return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier_);
        } else {
            var carrier_ = carrier.a;
            return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier_);
        }
    };
    var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectMemberId = function(_v0) {
        var shared = _v0;
        return shared.Lv;
    };
    var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectMemberId = function(_v0) {
        var shared = _v0;
        return shared.Lv;
    };
    var $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId = function(carrier) {
        if (!carrier.$) {
            var carrier_ = carrier.a;
            return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$collectMemberId(carrier_);
        } else {
            var carrier_ = carrier.a;
            return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$collectMemberId(carrier_);
        }
    };
    var $author$project$Api$Employer$HealthInsuranceCarrier$Shared$id = function(_v0) {
        var shared = _v0;
        return shared.aef;
    };
    var $author$project$Api$Provider$HealthInsuranceCarrier$Shared$id = function(_v0) {
        var shared = _v0;
        return shared.aef;
    };
    var $author$project$Api$HealthInsuranceCarrier$Shared$id = function(carrier) {
        if (!carrier.$) {
            var carrier_ = carrier.a;
            return $author$project$Api$Provider$HealthInsuranceCarrier$Shared$id(carrier_);
        } else {
            var carrier_ = carrier.a;
            return $author$project$Api$Employer$HealthInsuranceCarrier$Shared$id(carrier_);
        }
    };
    var $author$project$Api$Employer$InsuranceCarrierAlias$One$name = A2($elm$core$Basics$composeR, $author$project$Api$Employer$InsuranceCarrierAlias$One$record, function($) {
        return $.zr;
    });
    var $author$project$Api$Employer$InsuranceCarrierAlias$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Employer$InsuranceCarrierAlias$All$one, $author$project$Api$Employer$InsuranceCarrierAlias$One$name);
    var $author$project$Api$Provider$InsuranceCarrierAlias$One$name = A2($elm$core$Basics$composeR, $author$project$Api$Provider$InsuranceCarrierAlias$One$record, function($) {
        return $.zr;
    });
    var $author$project$Api$Provider$InsuranceCarrierAlias$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Provider$InsuranceCarrierAlias$All$one, $author$project$Api$Provider$InsuranceCarrierAlias$One$name);
    var $author$project$Api$InsuranceCarrierAlias$All$name = function(carrierAlias) {
        if (!carrierAlias.$) {
            var carrierAlias_ = carrierAlias.a;
            return $author$project$Api$Provider$InsuranceCarrierAlias$All$name(carrierAlias_);
        } else {
            var carrierAlias_ = carrierAlias.a;
            return $author$project$Api$Employer$InsuranceCarrierAlias$All$name(carrierAlias_);
        }
    };
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll = function(insuranceCarrierAlias) {
        var carrient = $author$project$Api$InsuranceCarrierAlias$All$carrier(insuranceCarrierAlias);
        return {
            EI: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrient),
            K$: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrient),
            EJ: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrient),
            EK: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrient),
            zr: $author$project$Api$InsuranceCarrierAlias$All$name(insuranceCarrierAlias)
        };
    };
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$fetchResources = F5(function(session, toMsg, apiClient, pagination, query) {
        return A4($author$project$Components$ResourceFilter$InsuranceCarrierAlias$list, apiClient, session, function(d) {
            return _Utils_update(d, {
                zr: query,
                af_: pagination
            });
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$retrieveResource = F4(function(session, toMsg, apiClient, id) {
        return A4($author$project$Components$ResourceFilter$InsuranceCarrierAlias$list, apiClient, session, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$InsuranceCarrierAlias$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$selectId = 'insurance-carrier-alias';
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle = function($) {
        return $.zr;
    };
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toValue = function($) {
        return $.zr;
    };
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$init = F3(function(apiClient, session, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$fetchResources(session),
            aef: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$selectId,
            gD: 'Insurance Carrier',
            sz: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$retrieveResource(session),
            ahW: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toLabel,
            ahZ: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toTitle,
            g4: $author$project$Components$ResourceFilter$InsuranceCarrierAlias$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$HealthInsuranceInput$empty = F2(function(apiClient, session) {
        var _v0 = A3($author$project$Components$ResourceFilter$InsuranceCarrierAlias$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a health insurance carrier',
                U5: 'Other (Enter insurance carrier name manually)',
                afn: true
            });
        });
        var insuranceCarrierAliasFilter = _v0.a;
        var insuranceCarrierAliasCmd = _v0.b;
        return _Utils_Tuple2(A3($author$project$Components$HealthInsuranceInput$Model, insuranceCarrierAliasFilter, {
            d$: false
        }, $elm$core$Maybe$Nothing), A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, insuranceCarrierAliasCmd));
    });
    var $author$project$Components$KnownPracticeInput$FilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$KnownPracticeInput$Model = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ResourceFilter$KnownPractice$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$KnownPractice$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$KnownPractice$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$KnownPractice$All$KnownPractice = $elm$core$Basics$identity;
    var $author$project$Api$Employer$KnownPractice$Shared$KnownPractice = $elm$core$Basics$identity;
    var $author$project$Api$Employer$KnownPractice$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Employer$KnownPractice$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$KnownPractice$Shared$Record)));
    var $author$project$Api$Employer$KnownPractice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$KnownPractice$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$KnownPractice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$KnownPractice$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$KnownPractice$defaults = {
        aef: $elm$core$Maybe$Nothing,
        zr: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Employer$KnownPractice$optionalsToParams = function(optionals) {
        var options = optionals($author$project$Api$Employer$KnownPractice$defaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.aef;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.zr;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'name', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Employer$KnownPractice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$KnownPractice$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Employer$KnownPractice$optionalsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'known_practices'
        ]), $author$project$Api$Data$employerPath))));
    });
    var $author$project$Api$Provider$KnownPractice$All$KnownPractice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$KnownPractice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$KnownPractice$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$KnownPractice$defaults = {
        aef: $elm$core$Maybe$Nothing,
        zr: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Provider$KnownPractice$optionalsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$KnownPractice$defaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.aef;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.zr;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'name', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$KnownPractice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$KnownPractice$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$KnownPractice$optionalsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'known_practices'
        ]), $author$project$Api$Data$providerPath))));
    });
    var $author$project$Api$KnownPractice$list = F4(function(apiClient, session, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$KnownPractice$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$KnownPractice$All$Employer)))) : A3($author$project$Api$Provider$KnownPractice$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$KnownPractice$All$Provider))));
    });
    var $author$project$Components$ResourceFilter$KnownPractice$list = $author$project$Api$KnownPractice$list;
    var $author$project$Api$Employer$KnownPractice$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$KnownPractice$All$shared = function(_v0) {
        var shared_ = _v0;
        return shared_;
    };
    var $author$project$Api$Employer$KnownPractice$All$id = A2($elm$core$Basics$composeR, $author$project$Api$Employer$KnownPractice$All$shared, $author$project$Api$Employer$KnownPractice$Shared$id);
    var $author$project$Api$Provider$KnownPractice$Shared$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Provider$KnownPractice$Shared$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$KnownPractice$Shared$record, function($) {
        return $.aef;
    });
    var $author$project$Api$Provider$KnownPractice$All$shared = function(_v0) {
        var shared_ = _v0;
        return shared_;
    };
    var $author$project$Api$Provider$KnownPractice$All$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$KnownPractice$All$shared, $author$project$Api$Provider$KnownPractice$Shared$id);
    var $author$project$Api$KnownPractice$All$id = function(knownPractice) {
        if (!knownPractice.$) {
            var knownPractice_ = knownPractice.a;
            return $author$project$Api$Provider$KnownPractice$All$id(knownPractice_);
        } else {
            var knownPractice_ = knownPractice.a;
            return $author$project$Api$Employer$KnownPractice$All$id(knownPractice_);
        }
    };
    var $author$project$Api$Employer$KnownPractice$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Employer$KnownPractice$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Employer$KnownPractice$All$shared, $author$project$Api$Employer$KnownPractice$Shared$name);
    var $author$project$Api$Provider$KnownPractice$Shared$name = A2($elm$core$Basics$composeR, $author$project$Api$Provider$KnownPractice$Shared$record, function($) {
        return $.zr;
    });
    var $author$project$Api$Provider$KnownPractice$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Provider$KnownPractice$All$shared, $author$project$Api$Provider$KnownPractice$Shared$name);
    var $author$project$Api$KnownPractice$All$name = function(knownPractice) {
        if (!knownPractice.$) {
            var knownPractice_ = knownPractice.a;
            return $author$project$Api$Provider$KnownPractice$All$name(knownPractice_);
        } else {
            var knownPractice_ = knownPractice.a;
            return $author$project$Api$Employer$KnownPractice$All$name(knownPractice_);
        }
    };
    var $author$project$Components$ResourceFilter$KnownPractice$resourceFromAll = function(knownPractice) {
        return {
            aef: $author$project$Api$KnownPractice$All$id(knownPractice),
            zr: $author$project$Api$KnownPractice$All$name(knownPractice)
        };
    };
    var $author$project$Components$ResourceFilter$KnownPractice$fetchResources = F5(function(session, toMsg, apiClient, pagination, query) {
        return A4($author$project$Components$ResourceFilter$KnownPractice$list, apiClient, session, function(d) {
            return _Utils_update(d, {
                zr: query,
                af_: pagination
            });
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$KnownPractice$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$KnownPractice$retrieveResource = F4(function(session, toMsg, apiClient, id) {
        return A4($author$project$Components$ResourceFilter$KnownPractice$list, apiClient, session, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$KnownPractice$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$KnownPractice$selectId = 'known-practices';
    var $author$project$Components$ResourceFilter$KnownPractice$toTitle = function($) {
        return $.zr;
    };
    var $author$project$Components$ResourceFilter$KnownPractice$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$KnownPractice$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$KnownPractice$toValue = function($) {
        return $.aef;
    };
    var $author$project$Components$ResourceFilter$KnownPractice$init = F3(function(apiClient, session, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$KnownPractice$fetchResources(session),
            aef: $author$project$Components$ResourceFilter$KnownPractice$selectId,
            gD: 'Known Practice',
            sz: $author$project$Components$ResourceFilter$KnownPractice$retrieveResource(session),
            ahW: $author$project$Components$ResourceFilter$KnownPractice$toLabel,
            ahZ: $author$project$Components$ResourceFilter$KnownPractice$toTitle,
            g4: $author$project$Components$ResourceFilter$KnownPractice$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$KnownPracticeInput$empty = F2(function(apiClient, session) {
        var _v0 = A3($author$project$Components$ResourceFilter$KnownPractice$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a DPC practice',
                U5: 'Other (Enter your DPC manually)',
                afn: true
            });
        });
        var knownPracticeFilter = _v0.a;
        var knownPracticeCmd = _v0.b;
        return _Utils_Tuple2(A2($author$project$Components$KnownPracticeInput$Model, knownPracticeFilter, $elm$core$Maybe$Nothing), A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, knownPracticeCmd));
    });
    var $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$LeadSourceInput$initLeadSourceResourceFilter = F2(function(apiClient, preSelectedId) {
        return A3($author$project$Components$ResourceFilter$LeadSource$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                agj: preSelectedId
            });
        });
    });
    var $author$project$Components$LeadSourceInput$empty = function(apiClient) {
        var _v0 = A2($author$project$Components$LeadSourceInput$initLeadSourceResourceFilter, apiClient, $elm$core$Maybe$Nothing);
        var leadSourceResourceFilter = _v0.a;
        var leadSourceResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            d$: false,
            mT: leadSourceResourceFilter,
            c6: $elm$core$Maybe$Nothing,
            ah: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd));
    };
    var $author$project$Components$LocationInput$FilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$LocationInput$empty = F2(function(apiClient, listOptionals) {
        var _v0 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, listOptionals, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
        var filter = _v0.a;
        var filterCmd = _v0.b;
        return _Utils_Tuple2({
            d$: false,
            Fw: filter,
            agM: false,
            aa9: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
    });
    var $author$project$Components$NameInput$Model = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$NameInput$empty = A3($author$project$Components$NameInput$Model, _List_Nil, {
        d$: false,
        tp: ''
    }, {
        PN: '',
        SU: '',
        Uh: '',
        $w: $elm$core$Maybe$Nothing,
        $2: ''
    });
    var $author$project$Components$PractitionerInput$FilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$PractitionerInput$empty = F2(function(apiClient, listOptionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, listOptionals, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
        var filter = _v0.a;
        var filterCmd = _v0.b;
        return _Utils_Tuple2({
            d$: false,
            Fw: filter,
            agM: false,
            aa9: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
    });
    var $author$project$Components$EmergencyContactInput$RelationshipDropdownMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Common$EmergencyContact$Shared$record = function(_v0) {
        var r = _v0;
        return r;
    };
    var $author$project$Api$Common$EmergencyContact$Shared$email = A2($elm$core$Basics$composeR, $author$project$Api$Common$EmergencyContact$Shared$record, function($) {
        return $.OH;
    });
    var $author$project$Components$EmergencyContactInput$initPhone = function(maybePhone) {
        return A3($author$project$Components$PhoneInput$init, 'emergency-contact-phone', _List_fromArray([
            A2($elm$core$Maybe$withDefault, {
                Gx: '',
                agE: 0,
                ah5: $author$project$Api$Common$Phone$Shared$Mobile
            }, A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone))
        ]), function(opts) {
            return _Utils_update(opts, {
                abK: false,
                y_: 1
            });
        });
    };
    var $author$project$Components$EmergencyContactInput$empty = {
        OH: '',
        PN: '',
        SU: '',
        WE: $author$project$Components$EmergencyContactInput$initPhone($elm$core$Maybe$Nothing),
        Yu: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Common$EmergencyContact$Shared$firstName = A2($elm$core$Basics$composeR, $author$project$Api$Common$EmergencyContact$Shared$record, function($) {
        return $.PN;
    });
    var $author$project$Api$Common$EmergencyContact$Shared$lastName = A2($elm$core$Basics$composeR, $author$project$Api$Common$EmergencyContact$Shared$record, function($) {
        return $.SU;
    });
    var $author$project$Api$Common$EmergencyContact$Shared$phone = A2($elm$core$Basics$composeR, $author$project$Api$Common$EmergencyContact$Shared$record, function($) {
        return $.WE;
    });
    var $author$project$Api$Common$EmergencyContact$Shared$relationship = A2($elm$core$Basics$composeR, $author$project$Api$Common$EmergencyContact$Shared$record, function($) {
        return $.Yu;
    });
    var $author$project$Components$EmergencyContactInput$Child = {
        $: 2
    };
    var $author$project$Components$EmergencyContactInput$Grandparent = {
        $: 4
    };
    var $author$project$Components$EmergencyContactInput$Guardian = {
        $: 5
    };
    var $author$project$Components$EmergencyContactInput$Other = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$EmergencyContactInput$Parent = {
        $: 1
    };
    var $author$project$Components$EmergencyContactInput$Sibling = {
        $: 3
    };
    var $author$project$Components$EmergencyContactInput$Spouse = {
        $: 0
    };
    var $author$project$Components$EmergencyContactInput$relationshipFromString = function(rel) {
        switch(rel){
            case 'spouse':
                return $author$project$Components$EmergencyContactInput$Spouse;
            case 'parent':
                return $author$project$Components$EmergencyContactInput$Parent;
            case 'child':
                return $author$project$Components$EmergencyContactInput$Child;
            case 'sibling':
                return $author$project$Components$EmergencyContactInput$Sibling;
            case 'grandparent':
                return $author$project$Components$EmergencyContactInput$Grandparent;
            case 'guardian':
                return $author$project$Components$EmergencyContactInput$Guardian;
            default:
                return $author$project$Components$EmergencyContactInput$Other(rel);
        }
    };
    var $author$project$Components$EmergencyContactInput$init = function(patientEmergencyContact) {
        var relationshipDropdown = $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
            aef: 'emergency-contact-relationship-dropdown',
            ahX: $author$project$Components$EmergencyContactInput$RelationshipDropdownMsg
        }));
        var form = A2($elm$core$Maybe$withDefault, $author$project$Utils$Form$init($author$project$Components$EmergencyContactInput$empty), A2($elm$core$Maybe$map, $author$project$Utils$Form$init, A2($elm$core$Maybe$map, function(ec) {
            return {
                OH: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$EmergencyContact$Shared$email(ec)),
                PN: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$EmergencyContact$Shared$firstName(ec)),
                SU: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$EmergencyContact$Shared$lastName(ec)),
                WE: $author$project$Components$EmergencyContactInput$initPhone($author$project$Api$Common$EmergencyContact$Shared$phone(ec)),
                Yu: A2($elm$core$Maybe$map, $author$project$Components$EmergencyContactInput$relationshipFromString, $author$project$Api$Common$EmergencyContact$Shared$relationship(ec))
            };
        }, patientEmergencyContact)));
        return {
            PU: form,
            nW: relationshipDropdown
        };
    };
    var $author$project$Components$LocationInput$setValueWithResource = F2(function(resource, model) {
        return _Utils_update(model, {
            Fw: A2($author$project$Components$ResourceFilter$Location$setValue, resource, model.Fw),
            aa9: resource
        });
    });
    var $author$project$Components$LocationInput$setValue = F2(function(location1, model) {
        var resource = $author$project$Components$ResourceFilter$Location$resourceFromShared(location1);
        return A2($author$project$Components$LocationInput$setValueWithResource, resource, model);
    });
    var $author$project$Components$LocationInput$init = F3(function(apiClient, listOptionals, location1) {
        return A2($elm$core$Tuple$mapFirst, $author$project$Components$LocationInput$setValue(location1), A2($author$project$Components$LocationInput$empty, apiClient, listOptionals));
    });
    var $author$project$Components$PractitionerInput$setValueWithResource = F2(function(resource, model) {
        return _Utils_update(model, {
            Fw: A2($author$project$Components$ResourceFilter$Practitioner$setValue, resource, model.Fw),
            aa9: resource
        });
    });
    var $author$project$Components$PractitionerInput$setValue = F2(function(practitioner, model) {
        var resource = $author$project$Components$ResourceFilter$Practitioner$resourceFromShared(practitioner);
        return A2($author$project$Components$PractitionerInput$setValueWithResource, resource, model);
    });
    var $author$project$Components$PractitionerInput$init = F3(function(apiClient, listOptionals, practitioner) {
        return A2($elm$core$Tuple$mapFirst, $author$project$Components$PractitionerInput$setValue(practitioner), A2($author$project$Components$PractitionerInput$empty, apiClient, listOptionals));
    });
    var $author$project$Api$SignupPage$Min$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$SignupPage$Min$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Company$One$defaultSignupPage = function(_v0) {
        var record = _v0.b;
        return record.NC;
    };
    var $author$project$Api$Provider$Company$One$defaultSignupPage = function(_v0) {
        var record = _v0.b;
        return record.NC;
    };
    var $author$project$Api$Company$defaultSignupPage = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$SignupPage$Min$Provider, $author$project$Api$Provider$Company$One$defaultSignupPage(company_));
        } else {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$SignupPage$Min$Employer, $author$project$Api$Employer$Company$One$defaultSignupPage(company_));
        }
    };
    var $author$project$Api$Employer$SignupPage$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$SignupPage$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$SignupPage$Min$id = function(signupPage) {
        if (!signupPage.$) {
            var sponsorFeeDeal_ = signupPage.a;
            return $author$project$Api$Provider$SignupPage$Min$id(sponsorFeeDeal_);
        } else {
            var sponsorFeeDeal_ = signupPage.a;
            return $author$project$Api$Employer$SignupPage$Min$id(sponsorFeeDeal_);
        }
    };
    var $author$project$Components$Patient$Form$practitionerSignupOptionals = F2(function(isEmployeeForm, company) {
        var page = isEmployeeForm ? A2($elm$core$Maybe$map, function(pg) {
            return $author$project$Api$SignupPage$Min$id(pg);
        }, A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
        var _v0 = function() {
            if (!company.$) return _Utils_Tuple2($elm$core$Maybe$Just(true), $elm$core$Maybe$Nothing);
            else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(true));
        }();
        var acceptsEnrollmentsFromEmployer = _v0.a;
        var acceptsEnrollmentsFromRetail = _v0.b;
        return function(d) {
            return _Utils_update(d, {
                pj: acceptsEnrollmentsFromEmployer,
                pk: acceptsEnrollmentsFromRetail,
                Hs: page
            });
        };
    });
    var $author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras = F5(function(isEmployeeForm, company, location1, affiliate, expand) {
        var page = isEmployeeForm ? A2($elm$core$Maybe$map, function(pg) {
            return $author$project$Api$SignupPage$Min$id(pg);
        }, A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
        var _v0 = function() {
            if (!company.$) return _Utils_Tuple2($elm$core$Maybe$Just(true), $elm$core$Maybe$Nothing);
            else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(true));
        }();
        var acceptsEnrollmentsFromEmployer = _v0.a;
        var acceptsEnrollmentsFromRetail = _v0.b;
        return function(d) {
            return _Utils_update(d, {
                pj: acceptsEnrollmentsFromEmployer,
                pk: acceptsEnrollmentsFromRetail,
                Eb: affiliate,
                Fq: expand,
                aeT: location1,
                Hs: page
            });
        };
    });
    var $author$project$Components$LocationInput$require = F2(function(required, input) {
        return _Utils_update(input, {
            agM: required
        });
    });
    var $author$project$Components$PractitionerInput$require = F2(function(required, input) {
        return _Utils_update(input, {
            agM: required
        });
    });
    var $author$project$Api$Employer$Affiliate$AffiliateMin$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Affiliate$AffiliateMin$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Affiliate$AffiliateMin$id = function(affiliate) {
        if (!affiliate.$) {
            var affiliate_ = affiliate.a;
            return $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliate_);
        } else {
            var affiliate_ = affiliate.a;
            return $author$project$Api$Employer$Affiliate$AffiliateMin$id(affiliate_);
        }
    };
    var $author$project$Api$Employer$Affiliate$AffiliateMin$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Affiliate$AffiliateMin$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Affiliate$AffiliateMin$name = function(affiliate) {
        if (!affiliate.$) {
            var affiliate_ = affiliate.a;
            return $author$project$Api$Provider$Affiliate$AffiliateMin$name(affiliate_);
        } else {
            var affiliate_ = affiliate.a;
            return $author$project$Api$Employer$Affiliate$AffiliateMin$name(affiliate_);
        }
    };
    var $author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin = function(affiliate) {
        return {
            aef: $author$project$Api$Affiliate$AffiliateMin$id(affiliate),
            zr: $author$project$Api$Affiliate$AffiliateMin$name(affiliate)
        };
    };
    var $author$project$Components$ResourceFilter$Affiliate$setValue = F2(function(resource, model) {
        return _Utils_update(model, {
            Hg: function() {
                if (!resource.$) {
                    var resource_ = resource.a;
                    return $author$project$Components$ResourceFilter$One(resource_);
                } else return $author$project$Components$ResourceFilter$All;
            }()
        });
    });
    var $author$project$Components$AffiliateInput$setValueWithResource = F2(function(resource, model) {
        return _Utils_update(model, {
            Fw: A2($author$project$Components$ResourceFilter$Affiliate$setValue, resource, model.Fw),
            aa9: resource
        });
    });
    var $author$project$Components$AffiliateInput$setValue = F2(function(maybeAffiliate, model) {
        var resource = A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin, maybeAffiliate);
        return A2($author$project$Components$AffiliateInput$setValueWithResource, resource, model);
    });
    var $author$project$Components$Patient$Form$signupOptionals = F2(function(isEmployeeForm, company) {
        return isEmployeeForm ? A2($elm$core$Maybe$withDefault, $elm$core$Basics$identity, A2($elm$core$Maybe$map, function(page) {
            return function(d) {
                return _Utils_update(d, {
                    Hs: $elm$core$Maybe$Just($author$project$Api$SignupPage$Min$id(page))
                });
            };
        }, A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company))) : $elm$core$Basics$identity;
    });
    var $author$project$Components$Patient$Form$empty = F6(function(apiClient, session, currentDate, company, isEmployeeForm, settingsMapper) {
        var settings = settingsMapper(A3($author$project$Components$Patient$Form$defaultSettings, currentDate, true, isEmployeeForm));
        var practitionerOptionals = isEmployeeForm ? A2($author$project$Components$Patient$Form$practitionerSignupOptionals, isEmployeeForm, company) : A5($author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras, isEmployeeForm, company, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _List_fromArray([
            1
        ]));
        var phonesInput = A3($author$project$Components$PhoneInput$init, 'patient-phones', _List_Nil, function(d) {
            return _Utils_update(d, {
                Iz: true
            });
        });
        var optionals = A2($author$project$Components$Patient$Form$signupOptionals, isEmployeeForm, company);
        var _v0 = function() {
            var _v1 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultPractitioner, company);
            if (!_v1.$) {
                var companyPractitioner = _v1.a;
                return A3($author$project$Components$PractitionerInput$init, apiClient, practitionerOptionals, $elm$core$Maybe$Just(companyPractitioner));
            } else return A2($author$project$Components$PractitionerInput$empty, apiClient, practitionerOptionals);
        }();
        var practitioner = _v0.a;
        var practitionerCmd = _v0.b;
        var _v2 = function() {
            var _v3 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultLocation, company);
            if (!_v3.$) {
                var companyLocation = _v3.a;
                return A3($author$project$Components$LocationInput$init, apiClient, optionals, $elm$core$Maybe$Just(companyLocation));
            } else return A2($author$project$Components$LocationInput$empty, apiClient, optionals);
        }();
        var location1 = _v2.a;
        var locationCmd = _v2.b;
        var _v4 = $author$project$Components$LeadSourceInput$empty(apiClient);
        var leadSource = _v4.a;
        var leadSourceCmd = _v4.b;
        var _v5 = A2($author$project$Components$KnownPracticeInput$empty, apiClient, session);
        var knownPractice = _v5.a;
        var knownPracticeCmd = _v5.b;
        var _v6 = A2($author$project$Components$HealthInsuranceInput$empty, apiClient, session);
        var healthInsurance = _v6.a;
        var healthInsuranceCmd = _v6.b;
        var _v7 = $author$project$Components$DateInput$init;
        var dateInput = _v7.a;
        var dateInputCmd = _v7.b;
        var _v8 = function() {
            var _v9 = A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultAffiliation, company);
            if (!_v9.$) {
                var companyAffiliation = _v9.a;
                return A2($elm$core$Tuple$mapFirst, $author$project$Components$AffiliateInput$setValue($elm$core$Maybe$Just(companyAffiliation)), A3($author$project$Components$AffiliateInput$empty, apiClient, session, A2($author$project$Components$Patient$Form$affiliateOptionals, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing)));
            } else return A3($author$project$Components$AffiliateInput$empty, apiClient, session, A2($author$project$Components$Patient$Form$affiliateOptionals, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
        }();
        var affiliate = _v8.a;
        var affiliateCmd = _v8.b;
        var _v10 = $author$project$Components$AddressInput$init('patient-address');
        var address = _v10.a;
        var addressCmd = _v10.b;
        return _Utils_Tuple2(A2($author$project$Components$Patient$Form$PatientForm, settings, $author$project$Utils$Form$init({
            II: address,
            Eb: affiliate,
            Ke: $elm$core$Maybe$Nothing,
            br: $elm$core$Maybe$Nothing,
            qa: $elm$core$Maybe$Nothing,
            M7: '',
            OH: $elm$core$Maybe$Nothing,
            OJ: $author$project$Components$EmergencyContactInput$init($elm$core$Maybe$Nothing),
            P5: $elm$core$Maybe$Nothing,
            P6: $elm$core$Maybe$Nothing,
            P7: $elm$core$Maybe$Nothing,
            QC: healthInsurance,
            i0: _Utils_Tuple2($elm$core$Maybe$Nothing, dateInput),
            SM: knownPractice,
            S1: leadSource,
            S4: $author$project$Components$NameInput$empty,
            aeT: A2($author$project$Components$LocationInput$require, settings.YK, location1),
            WG: A2($author$project$Components$PhoneInput$require, settings.agR, phonesInput),
            agi: A2($author$project$Components$PractitionerInput$require, settings.YP, practitioner),
            Xh: $author$project$Language$english,
            sl: 0,
            XE: $elm$core$Maybe$Nothing,
            XF: $elm$core$Maybe$Nothing,
            Z3: $elm$core$Maybe$Nothing,
            __: '',
            $H: true,
            oO: $elm$core$Maybe$Nothing,
            aa_: false
        })), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address), addressCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice), knownPracticeCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner), practitionerCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location), locationCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate), affiliateCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource), leadSourceCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance), healthInsuranceCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice), dateInputCmd)
        ])));
    });
    var $author$project$Components$SponsorPlanInput$FilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Company$One$defaultPlan = function(_v0) {
        var record = _v0.b;
        return record.Nz;
    };
    var $author$project$Api$Provider$Company$One$defaultPlan = function(_v0) {
        var record = _v0.b;
        return record.Nz;
    };
    var $author$project$Api$Company$defaultPlan = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Plan$ProviderShared, $author$project$Api$Provider$Company$One$defaultPlan(company_));
        } else {
            var company_ = company.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Plan$EmployerShared, $author$project$Api$Employer$Company$One$defaultPlan(company_));
        }
    };
    var $author$project$Components$SponsorPlanInput$filterInit = F4(function(session, company, apiClient, planId) {
        return A4($author$project$Components$ResourceFilter$CompanyPlan$init, apiClient, session, $author$project$Api$Company$id(company), function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Plan',
                I5: false,
                afn: false,
                agj: planId
            });
        });
    });
    var $author$project$Components$SponsorPlanInput$init = F3(function(session, company, apiClient) {
        var defaultPlanId = A2($elm$core$Maybe$map, $author$project$Api$Plan$id, $author$project$Api$Company$defaultPlan(company));
        var _v0 = A4($author$project$Components$SponsorPlanInput$filterInit, session, company, apiClient, defaultPlanId);
        var filter = _v0.a;
        var filterCmd = _v0.b;
        return _Utils_Tuple2({
            d$: false,
            Fw: filter,
            agM: false,
            aa9: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
    });
    var $author$project$Components$Employee$Form$nextFirstOfMonth = function(currentDate) {
        return $author$project$Utils$Date$toIsoString(A2($justinmimbs$date$Date$ceiling, 2, currentDate));
    };
    var $author$project$Components$EmployeeDivisionInput$require = F2(function(required, input) {
        return _Utils_update(input, {
            agM: required
        });
    });
    var $author$project$Components$SponsorPlanInput$require = F2(function(required, input) {
        return _Utils_update(input, {
            agM: required
        });
    });
    var $author$project$Components$Employee$Form$empty = F6(function(session, company, apiClient, currentDate, employeeMapper, patientMapper) {
        var isNew = true;
        var employeeSettings = employeeMapper($author$project$Components$Employee$Form$defaultEmployeeSettings);
        var _v0 = A2($author$project$Components$EmployeeDependentTypeInput$empty, session, company);
        var typeInput = _v0.a;
        var typeInputCmd = _v0.b;
        var _v1 = $author$project$Components$DateInput$init;
        var startDateInput = _v1.a;
        var startDateInputCmd = _v1.b;
        var _v2 = A2($elm$core$Tuple$mapFirst, $author$project$Components$SponsorPlanInput$require(true), A3($author$project$Components$SponsorPlanInput$init, session, company, apiClient));
        var sponsorPlan = _v2.a;
        var sponsorPlanCmd = _v2.b;
        var _v3 = A6($author$project$Components$Patient$Form$empty, apiClient, session, currentDate, $elm$core$Maybe$Just(company), true, patientMapper);
        var patientForm = _v3.a;
        var patientFormCmd = _v3.b;
        var _v4 = A3($author$project$Components$EmployeeDivisionInput$empty, session, $author$project$Api$Company$id(company), apiClient);
        var divisionInput = _v4.a;
        var divisionInputCmd = _v4.b;
        var form = $author$project$Utils$Form$init({
            Oa: A2($author$project$Components$EmployeeDivisionInput$require, employeeSettings.YJ, divisionInput),
            cU: _Utils_Tuple2($elm$core$Maybe$Just(currentDate), startDateInput),
            OV: $elm$core$Maybe$Just(true),
            adE: $elm$core$Maybe$Nothing,
            aef: $elm$core$Maybe$Nothing,
            iZ: isNew,
            T4: $author$project$Components$Employee$Form$nextFirstOfMonth(currentDate),
            V7: patientForm,
            GW: A2($author$project$Components$SponsorPlanInput$require, employeeSettings.B9, sponsorPlan),
            ah5: typeInput
        });
        return _Utils_Tuple2(A2($author$project$Components$Employee$Form$EmployeeForm, A3($author$project$Components$Employee$Form$defaultSettings, currentDate, isNew, employeeSettings), form), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, patientFormCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type), typeInputCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan), sponsorPlanCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate), startDateInputCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division), divisionInputCmd)
        ])));
    });
    var $author$project$Api$Employer$Practice$One$hasLocations = function(_v0) {
        var record = _v0;
        return record.Ue.Qr;
    };
    var $author$project$Api$Practice$hasLocations = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$hasLocations(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$hasLocations(practice_);
        }
    };
    var $author$project$Api$Employer$Practice$One$hasPractitioners = function(_v0) {
        var record = _v0;
        return record.Ue.Qx;
    };
    var $author$project$Api$Practice$hasPractitioners = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$hasPractitioners(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$hasPractitioners(practice_);
        }
    };
    var $author$project$Api$Provider$Practice$One$labelBillingAsShipping = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.SN;
    });
    var $author$project$Api$Practice$labelBillingAsShipping = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice_);
        } else return false;
    };
    var $author$project$Api$Employer$Company$Shared$requiresEmployeeDivisions = function(_v0) {
        var record = _v0;
        return record.YJ;
    };
    var $author$project$Api$Employer$Company$One$requiresEmployeeDivisions = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$requiresEmployeeDivisions(shared);
    };
    var $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions = function(_v0) {
        var record = _v0;
        return record.YJ;
    };
    var $author$project$Api$Provider$Company$One$requiresEmployeeDivisions = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions(shared);
    };
    var $author$project$Api$Company$requiresEmployeeDivisions = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$requiresEmployeeDivisions(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$requiresEmployeeDivisions(company_);
        }
    };
    var $author$project$Api$Employer$Practice$One$requiresLocation = function(_v0) {
        var record = _v0;
        return record.YK;
    };
    var $author$project$Api$Practice$requiresLocation = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$requiresLocation(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$requiresLocation(practice_);
        }
    };
    var $author$project$Api$Employer$Practice$One$requiresPatientEmail = function(_v0) {
        var record = _v0;
        return record.YM;
    };
    var $author$project$Api$Practice$requiresPatientEmail = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$requiresPatientEmail(practice_);
        }
    };
    var $author$project$Api$Employer$Practice$One$requiresPatientMobile = function(_v0) {
        var record = _v0;
        return record.YN;
    };
    var $author$project$Api$Practice$requiresPatientMobile = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$requiresPatientMobile(practice_);
        }
    };
    var $author$project$Api$Employer$Practice$One$requiresPractitioner = function(_v0) {
        var record = _v0;
        return record.YP;
    };
    var $author$project$Api$Practice$requiresPractitioner = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$requiresPractitioner(practice_);
        } else {
            var practice_ = practice.a;
            return A2($elm$core$Maybe$withDefault, false, $author$project$Api$Employer$Practice$One$requiresPractitioner(practice_));
        }
    };
    var $author$project$Api$Employer$Practice$One$requiresSSN = function(_v0) {
        var record = _v0;
        return record.YQ;
    };
    var $author$project$Api$Practice$requiresSSN = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$requiresSSN(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$requiresSSN(practice_);
        }
    };
    var $author$project$Api$Employer$Practice$One$ssnEnabled = function(_v0) {
        var record = _v0;
        return record._$;
    };
    var $author$project$Api$Practice$ssnEnabled = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$ssnEnabled(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$ssnEnabled(practice_);
        }
    };
    var $author$project$Api$Employer$Network$Shared$syncByAffiliation = function(_v0) {
        var record = _v0;
        return record.$D;
    };
    var $author$project$Api$Network$Shared$syncByAffiliation = function(network) {
        if (!network.$) {
            var network_ = network.a;
            return $author$project$Api$Provider$Network$Shared$syncByAffiliation(network_);
        } else {
            var network_ = network.a;
            return $author$project$Api$Employer$Network$Shared$syncByAffiliation(network_);
        }
    };
    var $author$project$Api$Employer$Practice$One$transInclusivity = function(_v0) {
        var record = _v0;
        return record.aas;
    };
    var $author$project$Api$Provider$Practice$One$transInclusivity = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.aas;
    });
    var $author$project$Api$Practice$transInclusivity = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$transInclusivity(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$transInclusivity(practice_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var _v1 = A6($author$project$Components$Employee$Form$empty, session, company, shared.Ej, shared.cP, function(employeeSettings) {
            return _Utils_update(employeeSettings, {
                YJ: $author$project$Api$Company$requiresEmployeeDivisions(company),
                aa1: $author$project$Api$Company$usesEmployeeDivisions(company)
            });
        }, function(patientSettings) {
            return _Utils_update(patientSettings, {
                ab1: $author$project$Api$Practice$labelBillingAsShipping(practice),
                ab8: A2($author$project$Api$Practice$featureEnabled, 3, practice),
                Qr: $author$project$Api$Practice$hasLocations(practice),
                Qx: $author$project$Api$Practice$hasPractitioners(practice),
                B8: true,
                agQ: $author$project$Api$Practice$requiresPatientEmail(practice),
                YK: $author$project$Api$Practice$requiresLocation(practice),
                agR: $author$project$Api$Practice$requiresPatientMobile(practice),
                YP: $author$project$Api$Practice$requiresPractitioner(practice),
                YQ: $author$project$Api$Practice$requiresSSN(practice),
                _$: $author$project$Api$Practice$ssnEnabled(practice),
                $D: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$syncByAffiliation, $author$project$Api$Practice$network(practice))),
                ah_: A2($author$project$Api$Practice$featureEnabled, 2, practice),
                aaq: $author$project$Api$Practice$trackPatientsByLocation(practice),
                aas: $author$project$Api$Practice$transInclusivity(practice),
                DT: A3($author$project$Permission$canGoTo, session, shared.aeb, 0)
            });
        });
        var form = _v1.a;
        var formCmd = _v1.b;
        var model = {
            Ij: $author$project$Api$Data$NotAsked,
            Ej: shared.Ej,
            acy: company,
            ao: form,
            aef: params.fl,
            afW: shared.afW,
            W1: practice,
            Z$: session,
            km: false
        };
        return _Utils_Tuple2(model, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg, formCmd));
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Employee$Form$Patient = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$BillingAddress = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$EmergencyContact = function(a) {
        return {
            $: 27,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$Phones = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$EmergencyContactInput$FieldChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$EmergencyContactInput$Phone = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$EmergencyContactInput$subscriptions = function(_v0) {
        var form = _v0.PU;
        var relationshipDropdown = _v0.nW;
        var emergencyContact = $author$project$Utils$Form$fields(form);
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(relationshipDropdown),
            A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone), $author$project$Components$PhoneInput$subscriptions(emergencyContact.WE))
        ]));
    };
    var $author$project$Components$Patient$Form$subscriptions = function(_v0) {
        var form = _v0.b;
        var _v1 = $author$project$Utils$Form$fields(form);
        var emergencyContact = _v1.OJ;
        var address = _v1.II;
        var billingAddress = _v1.Ke;
        var phones = _v1.WG;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address), $author$project$Components$AddressInput$subscriptions(address)),
            A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress), A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$AddressInput$subscriptions, billingAddress))),
            A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$EmergencyContact), $author$project$Components$EmergencyContactInput$subscriptions(emergencyContact)),
            A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones), $author$project$Components$PhoneInput$subscriptions(phones))
        ]));
    };
    var $author$project$Components$Employee$Form$subscriptions = function(_v0) {
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Patient), $author$project$Components$Patient$Form$subscriptions(fields.V7));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg, $author$project$Components$Employee$Form$subscriptions(model.ao));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyAccountCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$RegistrationEnrolled = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$CompanyAccount$One$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$CompanyAccount$One$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$companyAccountsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'accounts'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$CompanyAccount$One$CompanyAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$CompanyAccount$Shared$CompanyAccount = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CompanyAccount$Shared$Record = F5(function(id, isEligible, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate) {
        return {
            OD: eligibilityEndDate,
            OE: eligibilityStartDate,
            aef: id,
            R2: isEligible,
            ahQ: terminationRequestedAt
        };
    });
    var $author$project$Api$Employer$CompanyAccount$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'eligibility_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'eligibility_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_requested_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_eligible', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Shared$Record))))));
    var $author$project$Api$Employer$CompanyAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$CompanyAccount$One$Record = F5(function(division, subscriber, selectedPlan, membershipPlan, registrations) {
        return {
            Oa: division,
            T2: membershipPlan,
            agG: registrations,
            ZF: selectedPlan,
            $r: subscriber
        };
    });
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$CompanyRegistration = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$Record = function(patient) {
        return {
            V7: patient
        };
    };
    var $author$project$Api$Employer$Patient$Min$Patient = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Patient$Min$Record = F5(function(id, name, email, dob, age) {
        return {
            IZ: age,
            add: dob,
            OH: email,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Employer$Patient$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'dob', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$Min$Record))))));
    var $author$project$Api$Employer$Patient$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Patient$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Employer$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$Record));
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Patient$Shared$Patient = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Patient$Shared$Record = function(id) {
        return function(name) {
            return function(firstName) {
                return function(middleName) {
                    return function(lastName) {
                        return function(email) {
                            return function(dob) {
                                return function(sex) {
                                    return function(gender) {
                                        return function(genderIdentity) {
                                            return function(genderOther) {
                                                return function(pronoun) {
                                                    return function(leadSourceOther) {
                                                        return function(syncToEmr) {
                                                            return function(joinedPracticeDate) {
                                                                return function(usesTobacco) {
                                                                    return {
                                                                        add: dob,
                                                                        OH: email,
                                                                        PN: firstName,
                                                                        P5: gender,
                                                                        P6: genderIdentity,
                                                                        P7: genderOther,
                                                                        aef: id,
                                                                        SK: joinedPracticeDate,
                                                                        SU: lastName,
                                                                        S3: leadSourceOther,
                                                                        Uh: middleName,
                                                                        zr: name,
                                                                        XF: pronoun,
                                                                        Z3: sex,
                                                                        $H: syncToEmr,
                                                                        aa4: usesTobacco
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$Patient$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_tobacco', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'joined_practice_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sync_to_emr', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lead_source_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pronoun', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender_identity', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sex', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'dob', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'middle_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$Shared$Record)))))))))))))))));
    var $author$project$Api$Employer$Patient$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Patient$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Plan$Min$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Plan$Min$Record = F5(function(id, name, maximumAge, minimumAge, tobaccoSurchargeType) {
        return {
            aef: id,
            TQ: maximumAge,
            Un: minimumAge,
            zr: name,
            aad: tobaccoSurchargeType
        };
    });
    var $author$project$Api$Employer$Plan$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tobacco_surcharge_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'minimum_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'maximum_age', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Plan$Min$Record))))));
    var $author$project$Api$Employer$Plan$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Employer$Plan$Min$recordDecoder);
    var $author$project$Api$Employer$CompanyAccount$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registrations', $elm$json$Json$Decode$list($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_plan', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'selected_plan', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subscriber', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Patient$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'division', $elm$json$Json$Decode$nullable($author$project$Api$Employer$EmployeeDivision$All$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$One$Record))))));
    var $author$project$Api$Employer$CompanyAccount$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyAccount$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$One$CompanyAccount)));
    var $author$project$Api$Employer$CompanyAccount$create = F3(function(apiClient, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyAccount$companyAccountsPath)));
    });
    var $author$project$Api$Provider$Company$Account$create = F4(function(apiClient, basePath, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$Account$companyAccountsPath(basePath))));
    });
    var $author$project$Api$CompanyAccount$create = F5(function(apiClient, session, companyId, jsonBody, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$CompanyAccount$create, apiClient, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4($author$project$Api$Provider$Company$Account$create, apiClient, $author$project$Api$Provider$Company$companyPath(companyId), jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Api$CompanyRegistration$One$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$CompanyRegistration$One$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$companyAccountPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Employer$CompanyAccount$companyAccountsPath);
    };
    var $author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath = function(accountId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'registrations'
        ]), $author$project$Api$Employer$CompanyAccount$companyAccountPath(accountId));
    };
    var $author$project$Api$Employer$CompanyRegistration$One$CompanyRegistration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$CompanyRegistration$Shared$CompanyRegistration = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CompanyRegistration$Shared$Record = F8(function(id, type_, isSubscriber, externalId, terminationRequestedAt, eligibilityStartDate, eligibilityEndDate, membershipEndDate) {
        return {
            OD: eligibilityEndDate,
            OE: eligibilityStartDate,
            adE: externalId,
            aef: id,
            Ss: isSubscriber,
            T_: membershipEndDate,
            ahQ: terminationRequestedAt,
            ah5: type_
        };
    });
    var $author$project$Api$Employer$CompanyRegistration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'eligibility_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'eligibility_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_requested_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'external_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_subscriber', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Shared$Record)))))))));
    var $author$project$Api$Employer$CompanyRegistration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyRegistration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$CompanyRegistration$One$Record = function(patient) {
        return {
            V7: patient
        };
    };
    var $author$project$Api$Employer$CompanyRegistration$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Employer$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$One$Record));
    var $author$project$Api$Employer$CompanyRegistration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyRegistration$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyRegistration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$One$CompanyRegistration)));
    var $author$project$Api$Employer$CompanyRegistration$create = F4(function(apiClient, accountId, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyRegistration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath(accountId))));
    });
    var $author$project$Api$Provider$Company$Registration$companyRegistrationsPath = F2(function(companyId, companyAccountId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'registrations'
        ]), A2($author$project$Api$Provider$Company$Account$companyAccountPath, $author$project$Api$Provider$Company$companyPath(companyId), companyAccountId));
    });
    var $author$project$Api$Provider$CompanyRegistration$One$CompanyRegistration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyRegistration$One$Record = function(patient) {
        return {
            V7: patient
        };
    };
    var $author$project$Api$Provider$CompanyRegistration$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$One$Record));
    var $author$project$Api$Provider$CompanyRegistration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyRegistration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyRegistration$One$CompanyRegistration)));
    var $author$project$Api$Provider$Company$Registration$create = F5(function(apiClient, companyId, companyAccountId, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyRegistration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Registration$companyRegistrationsPath, companyId, companyAccountId))));
    });
    var $author$project$Api$CompanyRegistration$create = F6(function(apiClient, session, companyId, accountId, jsonBody, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyRegistration$create, apiClient, accountId, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5($author$project$Api$Provider$Company$Registration$create, apiClient, companyId, accountId, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
    });
    var $author$project$Components$Patient$Form$PatientLinked = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$AffiliateInput$affiliateId = function(_v0) {
        var value = _v0.aa9;
        return A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, value);
    };
    var $author$project$Api$Employer$Affiliate$affiliatePath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Employer$Affiliate$affiliatesPath);
    };
    var $author$project$Api$Employer$Affiliates$Patient$create = F4(function(apiClient, affiliateId, patientId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('patient_id', $elm$json$Json$Encode$string(patientId))
        ])), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients'
        ]), $author$project$Api$Employer$Affiliate$affiliatePath(affiliateId)))));
    });
    var $author$project$Api$Provider$Affiliates$Patient$create = F4(function(apiClient, affiliateId, patientId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('patient_id', $elm$json$Json$Encode$string(patientId))
        ])), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients'
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId)))));
    });
    var $author$project$Api$Affiliates$Patient$create = F5(function(apiClient, session, affiliateId, patientId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Affiliates$Patient$create, apiClient, affiliateId, patientId, toMsg) : A4($author$project$Api$Provider$Affiliates$Patient$create, apiClient, affiliateId, patientId, toMsg);
    });
    var $author$project$Api$Employer$Affiliates$Patient$delete = F4(function(apiClient, affiliateId, patientId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients',
            patientId
        ]), $author$project$Api$Employer$Affiliate$affiliatePath(affiliateId))));
    });
    var $author$project$Api$Provider$Affiliates$Patient$delete = F4(function(apiClient, affiliateId, patientId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients',
            patientId
        ]), $author$project$Api$Provider$Affiliate$affiliatePath(affiliateId))));
    });
    var $author$project$Api$Affiliates$Patient$delete = F5(function(apiClient, session, affiliateId, patientId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$Affiliates$Patient$delete, apiClient, affiliateId, patientId, toMsg) : A4($author$project$Api$Provider$Affiliates$Patient$delete, apiClient, affiliateId, patientId, toMsg);
    });
    var $author$project$Components$Patient$Form$createAffiliation = F5(function(authToken, session, patientId, affiliationId, _v0) {
        var settings = _v0.a;
        var form = _v0.b;
        return settings.$D ? A2($elm$core$Maybe$withDefault, function() {
            if (affiliationId.$ === 1) return {
                v6: false,
                EQ: $elm$core$Platform$Cmd$none
            };
            else {
                var affiliationId_ = affiliationId.a;
                return {
                    v6: true,
                    EQ: A5($author$project$Api$Affiliates$Patient$delete, authToken, session, affiliationId_, patientId, $author$project$Components$Patient$Form$PatientLinked)
                };
            }
        }(), A2($elm$core$Maybe$map, function(affiliateId) {
            return {
                v6: true,
                EQ: A5($author$project$Api$Affiliates$Patient$create, authToken, session, affiliateId, patientId, $author$project$Components$Patient$Form$PatientLinked)
            };
        }, $author$project$Components$AffiliateInput$affiliateId($author$project$Utils$Form$fields(form).Eb))) : {
            v6: false,
            EQ: $elm$core$Platform$Cmd$none
        };
    });
    var $author$project$Api$Employer$Patient$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Patient$Min$id = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$Min$id(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$Min$id(patient_);
        }
    };
    var $author$project$Api$Patient$Min$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Patient$Min$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyRegistration$One$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Api$Provider$CompanyRegistration$One$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Api$CompanyRegistration$One$patient = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Patient$Min$Provider($author$project$Api$Provider$CompanyRegistration$One$patient(companyRegistration_));
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Patient$Min$Employer($author$project$Api$Employer$CompanyRegistration$One$patient(companyRegistration_));
        }
    };
    var $author$project$Components$Employee$Form$createEmployeeAffiliation = F4(function(authToken, session, registration, _v0) {
        var settings = _v0.a;
        var form = _v0.b;
        if (settings.V7.$D) {
            var patientId = $author$project$Api$Patient$Min$id($author$project$Api$CompanyRegistration$One$patient(registration));
            var fields = $author$project$Utils$Form$fields(form);
            return A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, A5($author$project$Components$Patient$Form$createAffiliation, authToken, session, patientId, $elm$core$Maybe$Nothing, fields.V7).EQ);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$EmployeeDependentTypeInput$account = function(_v0) {
        var dependentOf = _v0.fx;
        return dependentOf;
    };
    var $author$project$Components$Employee$Form$dependentOf = function(_v0) {
        var form = _v0.b;
        return $author$project$Components$EmployeeDependentTypeInput$account($author$project$Utils$Form$fields(form).ah5);
    };
    var $author$project$Components$EmployeeDivisionInput$encodeDivision = function(_v0) {
        var division = _v0.Oa;
        if (!division.$) {
            var divisionId = division.a;
            return _List_fromArray([
                _Utils_Tuple2('division', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(divisionId))
                ])))
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2('division', $elm$json$Json$Encode$null)
        ]);
    };
    var $author$project$Components$Employee$Form$encodeAccount = F2(function(validFields, _v0) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
        return function(encodedFields) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('account', $elm$json$Json$Encode$object(encodedFields))
            ]));
        }(A2($elm$core$List$append, $author$project$Components$EmployeeDivisionInput$encodeDivision(fields.Oa), function() {
            var _v1 = fields.cU.a;
            if (!_v1.$) {
                var date = _v1.a;
                return _List_fromArray([
                    _Utils_Tuple2('eligibility_start_date', $elm$json$Json$Encode$string($author$project$Utils$Date$toIsoString(date)))
                ]);
            } else return _List_Nil;
        }()));
    });
    var $author$project$Components$SponsorPlanInput$encode = function(_v0) {
        var value = _v0.aa9;
        if (value.$ === 1) return $elm$json$Json$Encode$null;
        else {
            var companyPlan = value.a;
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string($author$project$Api$Plan$id($author$project$Api$CompanyPlan$plan(companyPlan))))
            ]));
        }
    };
    var $author$project$Components$EmployeeDependentTypeInput$selectedType = function(_v0) {
        var type_ = _v0.ah5;
        return type_;
    };
    var $author$project$Components$Employee$Form$encodeEnroll = F2(function(validFields, _v0) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
        var encodedPlan = fields.iZ && $author$project$Components$EmployeeDependentTypeInput$selectedType(fields.ah5) === 'employee' ? _List_fromArray([
            _Utils_Tuple2('plan', $author$project$Components$SponsorPlanInput$encode(fields.GW))
        ]) : _List_Nil;
        return $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('membership_start_date', $elm$json$Json$Encode$string(fields.T4)), encodedPlan));
    });
    var $author$project$Components$Patient$Form$datePattern = $agustinrhcp$elm_mask$Mask$fromString('##/##/####');
    var $author$project$Components$AddressInput$encodeWithPrefix = F2(function(prefix, _v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return _List_fromArray([
            _Utils_Tuple2(prefix + 'city', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.pW)),
            _Utils_Tuple2(prefix + 'country', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.p0)),
            _Utils_Tuple2(prefix + 'line1', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.cx)),
            _Utils_Tuple2(prefix + 'line2', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.e$)),
            _Utils_Tuple2(prefix + 'state', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.s4)),
            _Utils_Tuple2(prefix + 'zip', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.tK))
        ]);
    });
    var $author$project$Components$AddressInput$encode = $author$project$Components$AddressInput$encodeWithPrefix('address_');
    var $author$project$Components$EmergencyContactInput$relationshipToValue = function(rel) {
        switch(rel.$){
            case 0:
                return 'spouse';
            case 1:
                return 'parent';
            case 2:
                return 'child';
            case 3:
                return 'sibling';
            case 4:
                return 'grandparent';
            case 5:
                return 'guardian';
            default:
                return 'other';
        }
    };
    var $author$project$Components$EmergencyContactInput$encode = function(_v0) {
        var form = _v0.PU;
        var encodeEmptyAsNull = function(value) {
            return A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value)));
        };
        var emergencyContact = $author$project$Utils$Form$fields(form);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('first_name', encodeEmptyAsNull(emergencyContact.PN)),
            _Utils_Tuple2('last_name', encodeEmptyAsNull(emergencyContact.SU)),
            _Utils_Tuple2('relationship', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$EmergencyContactInput$relationshipToValue, $elm$json$Json$Encode$string), emergencyContact.Yu))),
            _Utils_Tuple2('relationship_other', function(rel) {
                if (!rel.$ && rel.a.$ === 6) {
                    var other = rel.a.a;
                    return $elm$json$Json$Encode$string(other);
                } else return $elm$json$Json$Encode$null;
            }(emergencyContact.Yu)),
            _Utils_Tuple2('phone', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, function(phone) {
                return $elm$core$String$isEmpty(phone.Gx) ? $elm$json$Json$Encode$null : $author$project$Api$Common$Phone$Shared$encode(phone);
            }, A2($elm$core$Maybe$map, $author$project$Utils$Phone$toRecord, A2($elm$core$Maybe$andThen, $elm$core$List$head, $author$project$Components$PhoneInput$getPhones(emergencyContact.WE)))))),
            _Utils_Tuple2('email', encodeEmptyAsNull(emergencyContact.OH))
        ]));
    };
    var $author$project$Components$HealthInsuranceInput$encode = function(_v0) {
        var maybeCarrierAndInsurance = _v0.c;
        if (maybeCarrierAndInsurance.$ === 1) return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('group_id', $elm$json$Json$Encode$null),
            _Utils_Tuple2('member_id', $elm$json$Json$Encode$null),
            _Utils_Tuple2('high_deductible', $elm$json$Json$Encode$null),
            _Utils_Tuple2('carrier', $elm$json$Json$Encode$null),
            _Utils_Tuple2('payer_name', $elm$json$Json$Encode$null)
        ]));
        else {
            var _v2 = maybeCarrierAndInsurance.a;
            var insuranceCarrier = _v2.a;
            var record = _v2.b;
            return $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('group_id', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.Qf))), A2($elm$core$List$cons, _Utils_Tuple2('member_id', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.TV))), A2($elm$core$List$cons, _Utils_Tuple2('high_deductible', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$bool, record.QJ))), function() {
                if (!insuranceCarrier.$) {
                    var carrierAlias = insuranceCarrier.a;
                    return _List_fromArray([
                        _Utils_Tuple2('carrier', $elm$json$Json$Encode$object(_List_fromArray([
                            _Utils_Tuple2('id', $elm$json$Json$Encode$string(carrierAlias.EK))
                        ]))),
                        _Utils_Tuple2('payer_name', $elm$json$Json$Encode$string(carrierAlias.zr))
                    ]);
                } else {
                    var name = insuranceCarrier.a.zr;
                    return _List_fromArray([
                        _Utils_Tuple2('carrier', $elm$json$Json$Encode$null),
                        _Utils_Tuple2('payer_name', $elm$json$Json$Encode$string(name))
                    ]);
                }
            }()))));
        }
    };
    var $author$project$Components$KnownPracticeInput$encode = function(_v0) {
        var knowPractice = _v0.b;
        if (!knowPractice.$) {
            if (!knowPractice.a.$) {
                var knownPractice_ = knowPractice.a.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(knownPractice_.aef))
                ]));
            } else {
                var name = knowPractice.a.a.zr;
                var website = knowPractice.a.a.D0;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('other', $elm$json$Json$Encode$string(name)),
                    _Utils_Tuple2('website', $elm$core$String$isEmpty(website) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string(website))
                ]));
            }
        } else return $elm$json$Json$Encode$null;
    };
    var $author$project$Components$LeadSourceInput$encode = function(_v0) {
        var selected = _v0.ah;
        var other = _v0.c6;
        var strSelected = A2($elm$core$Maybe$withDefault, '', selected);
        return $elm$core$String$length(strSelected) > 0 ? _List_fromArray([
            _Utils_Tuple2('lead_source', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(strSelected))
            ]))),
            _Utils_Tuple2('lead_source_other', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, other)))
        ]) : _List_fromArray([
            _Utils_Tuple2('lead_source', $elm$json$Json$Encode$null),
            _Utils_Tuple2('lead_source_other', $elm$json$Json$Encode$null)
        ]);
    };
    var $author$project$Components$LocationInput$encode = function(_v0) {
        var value = _v0.aa9;
        if (value.$ === 1) return $elm$json$Json$Encode$null;
        else {
            var location1 = value.a;
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(location1.aef))
            ]));
        }
    };
    var $author$project$Components$NameInput$encodeString = function(string) {
        if (string === '') return $elm$json$Json$Encode$null;
        else return $elm$json$Json$Encode$string(string);
    };
    var $author$project$Components$NameInput$encodeWithPrefix = F2(function(prefix, _v0) {
        var fields = _v0.c;
        var _v1 = fields;
        var title = _v1.$2;
        var firstName = _v1.PN;
        var middleName = _v1.Uh;
        var lastName = _v1.SU;
        var suffix = _v1.$w;
        return A2($elm$core$List$cons, _Utils_Tuple2(prefix + 'title', $author$project$Components$NameInput$encodeString(title)), A2($elm$core$List$cons, _Utils_Tuple2(prefix + 'first_name', $author$project$Components$NameInput$encodeString(firstName)), A2($elm$core$List$cons, _Utils_Tuple2(prefix + 'middle_name', $author$project$Components$NameInput$encodeString(middleName)), A2($elm$core$List$cons, _Utils_Tuple2(prefix + 'last_name', $author$project$Components$NameInput$encodeString(lastName)), function() {
            if (!suffix.$) {
                var s = suffix.a;
                return _List_fromArray([
                    _Utils_Tuple2(prefix + 'suffix', $author$project$Components$NameInput$encodeString(s))
                ]);
            } else return _List_Nil;
        }()))));
    });
    var $author$project$Components$NameInput$encode = $author$project$Components$NameInput$encodeWithPrefix('');
    var $author$project$Components$PractitionerInput$encode = function(_v0) {
        var value = _v0.aa9;
        if (value.$ === 1) return $elm$json$Json$Encode$null;
        else {
            var practitioner = value.a;
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(practitioner.aef))
            ]));
        }
    };
    var $author$project$Components$Patient$Form$encodeBillingAddress = function(maybeBillingAddress) {
        if (!maybeBillingAddress.$) {
            var billingAddress = maybeBillingAddress.a;
            return A2($author$project$Components$AddressInput$encodeWithPrefix, 'billing_address_', billingAddress);
        } else return _List_Nil;
    };
    var $author$project$Components$Patient$Form$encodeGender = F2(function(maybeGender, genderOther) {
        if (!maybeGender.$) {
            if (maybeGender.a === 3) {
                var _v1 = maybeGender.a;
                return _List_fromArray([
                    _Utils_Tuple2('gender', $elm$json$Json$Encode$string('other')),
                    _Utils_Tuple2('gender_other', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, genderOther)))
                ]);
            } else {
                var rest = maybeGender.a;
                return _List_fromArray([
                    _Utils_Tuple2('gender', $elm$json$Json$Encode$string($author$project$Api$Gender$toString(rest))),
                    _Utils_Tuple2('gender_other', $elm$json$Json$Encode$null)
                ]);
            }
        } else return _List_Nil;
    });
    var $author$project$Api$GenderIdentity$toString = function(genderIdentity) {
        switch(genderIdentity.$){
            case 0:
                return 'man';
            case 1:
                return 'woman';
            case 2:
                return 'non-binary';
            case 3:
                return 'trans man';
            case 4:
                return 'trans woman';
            default:
                return 'not listed';
        }
    };
    var $author$project$Components$Patient$Form$encodeGenderIdentity = function(maybeGenderIdentity) {
        if (maybeGenderIdentity.$ === 1) return _List_fromArray([
            _Utils_Tuple2('gender_identity', $elm$json$Json$Encode$null)
        ]);
        else if (maybeGenderIdentity.a.$ === 5) {
            var other = maybeGenderIdentity.a.a;
            return _List_fromArray([
                _Utils_Tuple2('gender_identity', $elm$json$Json$Encode$string('not listed')),
                _Utils_Tuple2('gender_other', $elm$json$Json$Encode$string(other))
            ]);
        } else {
            var genderIdentity = maybeGenderIdentity.a;
            return _List_fromArray([
                _Utils_Tuple2('gender_identity', $elm$json$Json$Encode$string($author$project$Api$GenderIdentity$toString(genderIdentity))),
                _Utils_Tuple2('gender_other', $elm$json$Json$Encode$null)
            ]);
        }
    };
    var $author$project$Components$Patient$Form$encodePhones = function(phones) {
        return A2($elm$json$Json$Encode$list, A2($elm$core$Basics$composeR, $author$project$Utils$Phone$toRecord, $author$project$Api$Common$Phone$Shared$encode), A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Components$PhoneInput$getPhones(phones)));
    };
    var $author$project$Api$Pronoun$toString = function(pronoun) {
        switch(pronoun.$){
            case 0:
                return 'He/Him/His';
            case 1:
                return 'She/Her/Hers';
            case 2:
                return 'They/Them/Theirs';
            default:
                return 'Not Listed';
        }
    };
    var $author$project$Components$Patient$Form$encodePronoun = function(maybePronoun) {
        if (maybePronoun.$ === 1) return _Utils_Tuple2('pronoun', $elm$json$Json$Encode$null);
        else if (maybePronoun.a.$ === 3) {
            var other = maybePronoun.a.a;
            return _Utils_Tuple2('pronoun', $elm$json$Json$Encode$string(other));
        } else {
            var pronoun = maybePronoun.a;
            return _Utils_Tuple2('pronoun', $elm$json$Json$Encode$string($author$project$Api$Pronoun$toString(pronoun)));
        }
    };
    var $author$project$Components$Patient$Form$encodeSex = function(maybeSex) {
        if (!maybeSex.$) {
            var sex = maybeSex.a;
            return _List_fromArray([
                _Utils_Tuple2('sex', $elm$json$Json$Encode$string($author$project$Api$Gender$toString(sex)))
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$Patient$Form$encodePatient = F2(function(validFields, _v0) {
        var settings = _v0.a;
        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
        var encodeMaskedDate = function(stringDate) {
            return A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, $elm$core$Result$toMaybe(A2($elm$core$Result$map, $author$project$Utils$Date$encode, $author$project$Utils$Date$fromUsString(A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$Patient$Form$datePattern, stringDate)))));
        };
        var appendIfSetting = F3(function(getter, appending, original) {
            return getter(settings) ? A2($elm$core$List$append, appending, original) : original;
        });
        var add = F2(function(item, list) {
            return _Utils_ap(list, _List_fromArray([
                item
            ]));
        });
        var addIfSetting = F3(function(getter, item, list) {
            return getter(settings) ? A2(add, item, list) : list;
        });
        var _v1 = fields;
        var billingAddress = _v1.Ke;
        var usesBillingAddress = _v1.aa_;
        var healthInsurance = _v1.QC;
        var syncToEmr = _v1.$H;
        var profilePictureUrl = _v1.XE;
        var profilePicture = function() {
            if (!profilePictureUrl.$) {
                var base64 = profilePictureUrl.a;
                return _List_fromArray([
                    _Utils_Tuple2('profile_picture', $elm$json$Json$Encode$string(base64))
                ]);
            } else return _List_Nil;
        }();
        var _v2 = fields;
        var genderIdentity = _v2.P6;
        var sex = _v2.Z3;
        var address = _v2.II;
        var ssn = _v2.__;
        var knownPractice = _v2.SM;
        var tobaccoUse = _v2.oO;
        var practitioner = _v2.agi;
        var location1 = _v2.aeT;
        var _v3 = fields;
        var legalName = _v3.S4;
        var chosenName = _v3.br;
        var email = _v3.OH;
        var pronoun = _v3.XF;
        var phones = _v3.WG;
        var dateOfBirth = _v3.M7;
        var joinedPractice = _v3.i0;
        var leadSource = _v3.S1;
        var _v4 = fields;
        var preferredLanguage = _v4.Xh;
        var emergencyContact = _v4.OJ;
        return function(encodedFields) {
            return _Utils_Tuple2('patient', $elm$json$Json$Encode$object(encodedFields));
        }(A2(add, _Utils_Tuple2('emergency_contact', $author$project$Components$EmergencyContactInput$encode(emergencyContact)), A3(addIfSetting, function($) {
            return $.ru;
        }, _Utils_Tuple2('preferred_language', $elm$json$Json$Encode$string($author$project$Language$toValue(preferredLanguage))), A2($elm$core$List$append, profilePicture, A2($elm$core$List$append, $author$project$Components$Patient$Form$encodeBillingAddress(billingAddress), A2(add, _Utils_Tuple2('uses_billing_address', $elm$json$Json$Encode$bool(usesBillingAddress)), A2($elm$core$List$append, $author$project$Components$AddressInput$encode(address), A3(addIfSetting, function($) {
            return $.ab8;
        }, _Utils_Tuple2('sync_to_emr', $elm$json$Json$Encode$bool(syncToEmr)), A2(add, _Utils_Tuple2('phones', $author$project$Components$Patient$Form$encodePhones(phones)), A3(appendIfSetting, function($) {
            return $.aas;
        }, $author$project$Components$Patient$Form$encodeGenderIdentity(genderIdentity), A3(addIfSetting, function($) {
            return $.aas;
        }, $author$project$Components$Patient$Form$encodePronoun(pronoun), A3(appendIfSetting, function($) {
            return $.aas;
        }, $author$project$Components$Patient$Form$encodeSex(sex), A3(appendIfSetting, A2($elm$core$Basics$composeR, function($) {
            return $.aas;
        }, $elm$core$Basics$not), A2($author$project$Components$Patient$Form$encodeGender, fields.P5, fields.P7), A2(add, _Utils_Tuple2('health_insurance', $author$project$Components$HealthInsuranceInput$encode(healthInsurance)), A3(addIfSetting, function($) {
            return $.ae_;
        }, _Utils_Tuple2('known_practice', $author$project$Components$KnownPracticeInput$encode(knownPractice)), A2($elm$core$List$append, $author$project$Components$LeadSourceInput$encode(leadSource), A2(add, _Utils_Tuple2('joined_practice_date', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $author$project$Utils$Date$encode, joinedPractice.a))), A3(addIfSetting, function(_v6) {
            var hasLocations = _v6.Qr;
            var trackPatientsByLocation = _v6.aaq;
            return hasLocations && trackPatientsByLocation;
        }, _Utils_Tuple2('location', $author$project$Components$LocationInput$encode(location1)), A3(addIfSetting, function($) {
            return $.Qx;
        }, _Utils_Tuple2('practitioner', $author$project$Components$PractitionerInput$encode(practitioner)), A3(addIfSetting, function($) {
            return $.ah_;
        }, _Utils_Tuple2('uses_tobacco', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$bool, tobaccoUse))), A3(addIfSetting, function(_v5) {
            var ssnEnabled = _v5._$;
            var userIsAdmin = _v5.DT;
            var isNew = _v5.iZ;
            return ssnEnabled && (userIsAdmin || isNew);
        }, _Utils_Tuple2('ssn', $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('number', $elm$json$Json$Encode$string(ssn))
        ]))), A2(add, _Utils_Tuple2('dob', encodeMaskedDate(dateOfBirth)), A2(add, _Utils_Tuple2('email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, email)), A2($elm$core$List$append, A2($author$project$Components$NameInput$encodeWithPrefix, 'chosen_', A2($elm$core$Maybe$withDefault, $author$project$Components$NameInput$empty, chosenName)), $author$project$Components$NameInput$encode(legalName)))))))))))))))))))))))));
    });
    var $author$project$Components$EmployeeDependentTypeInput$encodeType = function(_v0) {
        var type_ = _v0.ah5;
        return _Utils_Tuple2('type', $elm$json$Json$Encode$string(type_));
    };
    var $author$project$Components$EmergencyContactInput$ContactIdentificationValidation = 0;
    var $author$project$Components$EmergencyContactInput$EmailValidation = 2;
    var $author$project$Components$EmergencyContactInput$PhoneValidation = 1;
    var $author$project$Components$EmergencyContactInput$RelationshipOtherValidation = 3;
    var $author$project$Components$EmergencyContactInput$formFieldsValidator = function() {
        var validatePhone = function(_v7) {
            var phone = _v7.WE;
            return $author$project$Components$PhoneInput$hasErrors(phone) ? _List_fromArray([
                _Utils_Tuple2(1, '')
            ]) : _List_Nil;
        };
        var validateContact = function(_v6) {
            var firstName = _v6.PN;
            var lastName = _v6.SU;
            var relationship = _v6.Yu;
            var email = _v6.OH;
            var phone = _v6.WE;
            var relationshipIsNone = function() {
                if (relationship.$ === 1) return true;
                else return false;
            }();
            var nameIsEmpty = A2($elm$core$List$all, $elm$core$String$isEmpty, _List_fromArray([
                firstName,
                lastName
            ]));
            var contactIsEmpty = function() {
                var number = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Utils$Phone$toRecord, function($) {
                    return $.Gx;
                }), A2($elm$core$Maybe$andThen, $elm$core$List$head, $author$project$Components$PhoneInput$getPhones(phone)));
                var _v4 = _Utils_Tuple2(number, email);
                if (!_v4.a.$ && _v4.a.a === '' && _v4.b === '') return true;
                else return false;
            }();
            var _v3 = _Utils_Tuple2(nameIsEmpty && relationshipIsNone, contactIsEmpty);
            if (_v3.a) {
                if (_v3.b) return _List_Nil;
                else return _List_fromArray([
                    _Utils_Tuple2(0, 'Please enter at least one of first name, last name or relationship.')
                ]);
            } else {
                if (!_v3.b) return _List_Nil;
                else return _List_Nil;
            }
        };
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors(validateContact),
            $rtfeldman$elm_validate$Validate$fromErrors(validatePhone),
            A2($rtfeldman$elm_validate$Validate$ifFalse, function(_v0) {
                var email = _v0.OH;
                return $rtfeldman$elm_validate$Validate$isBlank(email) || $rtfeldman$elm_validate$Validate$isValidEmail(email);
            }, _Utils_Tuple2(2, 'Please enter a valid email.')),
            A2($rtfeldman$elm_validate$Validate$ifFalse, function(_v1) {
                var relationship = _v1.Yu;
                if (!relationship.$ && relationship.a.$ === 6 && relationship.a.a === '') return false;
                else return true;
            }, _Utils_Tuple2(3, 'Please enter relationship.'))
        ]));
    }();
    var $author$project$Components$EmergencyContactInput$validateForm = function(form) {
        var emergencyContact = $author$project$Utils$Form$fields(form);
        var form_ = A2($author$project$Utils$Form$set, _Utils_update(emergencyContact, {
            WE: $author$project$Components$PhoneInput$validate(emergencyContact.WE)
        }), form);
        var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$EmergencyContactInput$formFieldsValidator, form_);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var f = _v1.a;
            return _Utils_Tuple2(f, true);
        } else {
            var f = _v0.a;
            return _Utils_Tuple2(f, false);
        }
    };
    var $author$project$Components$EmergencyContactInput$validate = function(model) {
        return function(f) {
            return _Utils_update(model, {
                PU: f
            });
        }($author$project$Components$EmergencyContactInput$validateForm(model.PU).a);
    };
    var $author$project$Components$NameInput$FirstNameValidation = 0;
    var $author$project$Components$NameInput$validateFirstName = function(_v0) {
        var firstName = _v0.c.PN;
        return $author$project$Utils$String$isBlank(firstName) ? _List_fromArray([
            _Utils_Tuple2(0, 'Please enter first name')
        ]) : _List_Nil;
    };
    var $author$project$Components$NameInput$LastNameValidation = 1;
    var $author$project$Components$NameInput$validateLastName = function(_v0) {
        var lastName = _v0.c.SU;
        return $author$project$Utils$String$isBlank(lastName) ? _List_fromArray([
            _Utils_Tuple2(1, 'Please enter last name')
        ]) : _List_Nil;
    };
    var $author$project$Components$NameInput$validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$NameInput$validateFirstName),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$NameInput$validateLastName)
    ]));
    var $author$project$Components$NameInput$validate = function(_v0) {
        var options = _v0.b;
        var fields = _v0.c;
        return $author$project$Utils$Result$merge(A2($elm$core$Result$mapError, function(errors) {
            return A3($author$project$Components$NameInput$Model, errors, options, fields);
        }, A2($elm$core$Result$map, $rtfeldman$elm_validate$Validate$fromValid, A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$NameInput$validator, A3($author$project$Components$NameInput$Model, _List_Nil, options, fields)))));
    };
    var $author$project$Components$Patient$Form$KnownPracticeValidation = 7;
    var $author$project$Components$Patient$Form$LocationValidation = 9;
    var $author$project$Components$Patient$Form$PractitionerValidation = 8;
    var $author$project$Components$Patient$Form$SSNValidation = 6;
    var $author$project$Components$Patient$Form$EmailValidation = 2;
    var $author$project$Components$Patient$Form$emailValidator = function(requiresEmail) {
        return A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: !requiresEmail
        }, function($) {
            return $.OH;
        }, _Utils_Tuple2(2, 'Please enter a valid email.'));
    };
    var $author$project$Components$Patient$Form$ProfilePictureValidation = 11;
    var $author$project$Components$Patient$Form$computeMaxPictureBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Patient$Form$profilePictureValidator = A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
        return $.sl;
    }, $author$project$Components$Patient$Form$computeMaxPictureBytesSize, _Utils_Tuple2(11, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'));
    var $author$project$Components$KnownPracticeInput$validate = F2(function(getter, formatter) {
        return A2($rtfeldman$elm_validate$Validate$ifTrue, function(model) {
            var _v0 = getter(model);
            if (!_v0.b.$ && _v0.b.a.$ === 1) {
                var name = _v0.b.a.a.zr;
                return $rtfeldman$elm_validate$Validate$isBlank(name);
            } else return false;
        }, formatter('DPC name cannot be blank'));
    });
    var $author$project$Components$LocationInput$validate = F3(function(isRequired, getter, formatter) {
        return A2($rtfeldman$elm_validate$Validate$ifFalse, function(model) {
            var _v0 = getter(model);
            var value = _v0.aa9;
            var _v1 = _Utils_Tuple2(isRequired, value);
            if (_v1.a && _v1.b.$ === 1) {
                var _v2 = _v1.b;
                return false;
            } else return true;
        }, formatter('Please select a location.'));
    });
    var $author$project$Components$PractitionerInput$validate = F3(function(isRequired, getter, formatter) {
        return A2($rtfeldman$elm_validate$Validate$ifFalse, function(model) {
            var _v0 = getter(model);
            var value = _v0.aa9;
            var _v1 = _Utils_Tuple2(isRequired, value);
            if (_v1.a && _v1.b.$ === 1) {
                var _v2 = _v1.b;
                return false;
            } else return true;
        }, formatter('Please select a practitioner'));
    });
    var $author$project$Utils$Validate$alwaysValid = $rtfeldman$elm_validate$Validate$all(_List_Nil);
    var $author$project$Components$SocialSecurityNumberInput$isComplete = function(ssn) {
        return $elm$core$String$length(ssn) === 9;
    };
    var $author$project$Components$SocialSecurityNumberInput$validate = F3(function(isRequired, getter, formatter) {
        var isRequired_ = isRequired ? A2($rtfeldman$elm_validate$Validate$ifBlank, function(model) {
            return getter(model);
        }, formatter('Please enter SSN.')) : $author$project$Utils$Validate$alwaysValid;
        var containsNineDigits = A2($rtfeldman$elm_validate$Validate$ifFalse, function(model) {
            var ssn = getter(model);
            return $elm$core$String$isEmpty(ssn) || $author$project$Components$SocialSecurityNumberInput$isComplete(ssn);
        }, formatter('SSN must contain 9 digits.'));
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            isRequired_,
            containsNineDigits
        ]));
    });
    var $author$project$Components$Patient$Form$AddressValidation = 4;
    var $author$project$Components$Patient$Form$validateAddress = function(_v0) {
        var address = _v0.II;
        return $author$project$Components$AddressInput$isValid(address) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(4, '')
        ]);
    };
    var $author$project$Components$Patient$Form$BillingAddressValidation = 5;
    var $author$project$Components$Patient$Form$validateBillingAddress = function(_v0) {
        var billingAddress = _v0.Ke;
        return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(address) {
            return $author$project$Components$AddressInput$isValid(address) ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(5, '')
            ]);
        }, billingAddress));
    };
    var $author$project$Components$Patient$Form$ChosenNameValidation = 1;
    var $author$project$Components$NameInput$hasErrors = function(_v0) {
        var errors = _v0.a;
        return !$elm$core$List$isEmpty(errors);
    };
    var $author$project$Components$Patient$Form$validateChosenName = function(_v0) {
        var chosenName = _v0.br;
        var nameHasErrors = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Components$NameInput$hasErrors, chosenName));
        return nameHasErrors ? _List_fromArray([
            _Utils_Tuple2(1, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Patient$Form$DateOfBirthValidation = 10;
    var $author$project$Components$Patient$Form$validateDateOfBirth = F2(function(requiresDOB, _v0) {
        var dateOfBirth = _v0.M7;
        if (!$elm$core$String$length(dateOfBirth)) return requiresDOB ? _List_fromArray([
            _Utils_Tuple2(10, 'Please enter a date of birth.')
        ]) : _List_Nil;
        else {
            var _v1 = $author$project$Utils$Date$fromUsString(A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Components$Patient$Form$datePattern, dateOfBirth));
            if (_v1.$ === 1) return _List_fromArray([
                _Utils_Tuple2(10, '')
            ]);
            else return _List_Nil;
        }
    });
    var $author$project$Components$Patient$Form$EmergencyContactValidation = 12;
    var $author$project$Components$EmergencyContactInput$isValid = function(_v0) {
        var form = _v0.PU;
        return $author$project$Components$EmergencyContactInput$validateForm(form).b;
    };
    var $author$project$Components$Patient$Form$validateEmergencyContact = function(_v0) {
        var emergencyContact = _v0.OJ;
        return $author$project$Components$EmergencyContactInput$isValid(emergencyContact) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(12, '')
        ]);
    };
    var $author$project$Components$Patient$Form$LegalNameValidation = 0;
    var $author$project$Components$Patient$Form$validateLegalName = function(_v0) {
        var legalName = _v0.S4;
        return $author$project$Components$NameInput$hasErrors(legalName) ? _List_fromArray([
            _Utils_Tuple2(0, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Patient$Form$PhonesValidation = 3;
    var $author$project$Components$Patient$Form$validatePhones = function(_v0) {
        var phones = _v0.WG;
        return $author$project$Components$PhoneInput$hasErrors(phones) ? _List_fromArray([
            _Utils_Tuple2(3, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Patient$Form$validator = function(_v0) {
        var requiresEmail = _v0.agQ;
        var requiresDOB = _v0.B8;
        var ssnEnabled = _v0._$;
        var requiresSSN = _v0.YQ;
        var userIsAdmin = _v0.DT;
        var isNew = _v0.iZ;
        var requiresPractitioner = _v0.YP;
        var requiresLocation = _v0.YK;
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $author$project$Components$Patient$Form$emailValidator(requiresEmail),
            A3($author$project$Components$SocialSecurityNumberInput$validate, ssnEnabled && requiresSSN && (userIsAdmin || isNew), function($) {
                return $.__;
            }, function(error) {
                return _Utils_Tuple2(6, error);
            }),
            A2($author$project$Components$KnownPracticeInput$validate, function($) {
                return $.SM;
            }, function(error) {
                return _Utils_Tuple2(7, error);
            }),
            A3($author$project$Components$PractitionerInput$validate, requiresPractitioner, function($) {
                return $.agi;
            }, function(error) {
                return _Utils_Tuple2(8, error);
            }),
            A3($author$project$Components$LocationInput$validate, requiresLocation, function($) {
                return $.aeT;
            }, function(error) {
                return _Utils_Tuple2(9, error);
            }),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateLegalName),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateChosenName),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validatePhones),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateAddress),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateBillingAddress),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateEmergencyContact),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Patient$Form$validateDateOfBirth(requiresDOB)),
            $author$project$Components$Patient$Form$profilePictureValidator
        ]));
    };
    var $author$project$Components$Patient$Form$validate = function(_v0) {
        var settings = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$core$Result$mapError, $author$project$Components$Patient$Form$PatientForm(settings), A2($elm$core$Result$map, $elm$core$Tuple$mapFirst($author$project$Components$Patient$Form$PatientForm(settings)), A2($author$project$Utils$Form$validate, $author$project$Components$Patient$Form$validator(settings), A2($author$project$Utils$Form$set, _Utils_update(fields, {
            II: $author$project$Components$AddressInput$validate(fields.II),
            Ke: A2($elm$core$Maybe$map, $author$project$Components$AddressInput$validate, fields.Ke),
            br: A2($elm$core$Maybe$map, $author$project$Components$NameInput$validate, fields.br),
            OJ: $author$project$Components$EmergencyContactInput$validate(fields.OJ),
            S4: $author$project$Components$NameInput$validate(fields.S4),
            WG: $author$project$Components$PhoneInput$validate(fields.WG)
        }), form))));
    };
    var $author$project$Components$Employee$Form$encodeRegistration = F2(function(validFields, _v0) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
        var add = F2(function(item, list) {
            return _Utils_ap(list, _List_fromArray([
                item
            ]));
        });
        return function(encodedFields) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('registration', $elm$json$Json$Encode$object(encodedFields))
            ]));
        }(A2($elm$core$List$append, function() {
            var _v4 = fields.adE;
            if (!_v4.$) {
                var externalId = _v4.a;
                return _List_fromArray([
                    _Utils_Tuple2('external_id', $elm$json$Json$Encode$string(externalId))
                ]);
            } else return _List_Nil;
        }(), A2($elm$core$List$append, function() {
            var _v3 = fields.cU.a;
            if (!_v3.$) {
                var date = _v3.a;
                return _List_fromArray([
                    _Utils_Tuple2('eligibility_start_date', $elm$json$Json$Encode$string($author$project$Utils$Date$toIsoString(date)))
                ]);
            } else return _List_Nil;
        }(), A2(add, $author$project$Components$EmployeeDependentTypeInput$encodeType(fields.ah5), function() {
            var _v1 = $author$project$Components$Patient$Form$validate(fields.V7);
            if (!_v1.$) {
                var _v2 = _v1.a;
                var patientFields = _v2.b;
                return _List_fromArray([
                    A2($author$project$Components$Patient$Form$encodePatient, patientFields, fields.V7)
                ]);
            } else return _List_Nil;
        }()))));
    });
    var $author$project$Api$Employer$CompanyRegistration$companyRegistrationPath = F2(function(accountId, registrationId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            registrationId
        ]), $author$project$Api$Employer$CompanyRegistration$companyRegistrationsPath(accountId));
    });
    var $author$project$Api$Employer$CompanyRegistration$enroll = F5(function(apiClient, accountId, registrationId, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyRegistration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enroll'
        ]), A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)))));
    });
    var $author$project$Api$Provider$Company$Registration$companyRegistrationPath = F3(function(companyId, companyAccountId, registrationId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            registrationId
        ]), A2($author$project$Api$Provider$Company$Registration$companyRegistrationsPath, companyId, companyAccountId));
    });
    var $author$project$Api$Provider$Company$Registration$enroll = F6(function(apiClient, companyId, companyAccountId, registrationId, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyRegistration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enroll'
        ]), A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)))));
    });
    var $author$project$Api$CompanyRegistration$enroll = F5(function(apiClient, session, _v0, jsonBody, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var registrationId = _v0.nV;
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5($author$project$Api$Employer$CompanyRegistration$enroll, apiClient, accountId, registrationId, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6($author$project$Api$Provider$Company$Registration$enroll, apiClient, companyId, accountId, registrationId, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyAccount$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$CompanyAccount$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyAccount$Shared$id(shared);
    };
    var $author$project$Api$Provider$CompanyAccount$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
    };
    var $author$project$Api$CompanyAccount$All$id = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$id(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$id(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyAccount$Shared$id(shared);
    };
    var $author$project$Api$CompanyAccount$One$id = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$One$id(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$One$id(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$CompanyRegistration$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$id(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
    };
    var $author$project$Api$CompanyRegistration$One$id = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$One$id(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$One$id(companyRegistration_);
        }
    };
    var $author$project$Components$Employee$Form$shouldEnroll = function(_v0) {
        var form = _v0.b;
        return A2($elm$core$Maybe$withDefault, false, $author$project$Utils$Form$fields(form).OV);
    };
    var $author$project$Api$Employer$CompanyAccount$All$defaultEnrollmentStartDate = function(_v0) {
        var record = _v0.b;
        return record.Np;
    };
    var $author$project$Api$Provider$CompanyAccount$All$defaultEnrollmentStartDate = function(_v0) {
        var record = _v0.b;
        return record.Np;
    };
    var $author$project$Api$CompanyAccount$All$defaultEnrollmentStartDate = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$defaultEnrollmentStartDate(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$defaultEnrollmentStartDate(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$All$invoicedThroughDate = function(_v0) {
        var record = _v0.b;
        return record.RM;
    };
    var $author$project$Api$Provider$CompanyAccount$All$invoicedThroughDate = function(_v0) {
        var record = _v0.b;
        return record.RM;
    };
    var $author$project$Api$CompanyAccount$All$invoicedThroughDate = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$invoicedThroughDate(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$invoicedThroughDate(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$All$membershipStartDate = function(_v0) {
        var record = _v0.b;
        return record.T4;
    };
    var $author$project$Api$Provider$CompanyAccount$All$membershipStartDate = function(_v0) {
        var record = _v0.b;
        return record.T4;
    };
    var $author$project$Api$CompanyAccount$All$membershipStartDate = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$membershipStartDate(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$membershipStartDate(companyAccount_);
        }
    };
    var $elm_community$maybe_extra$Maybe$Extra$orList = function(maybes) {
        orList: while(true){
            if (!maybes.b) return $elm$core$Maybe$Nothing;
            else if (maybes.a.$ === 1) {
                var _v1 = maybes.a;
                var rest = maybes.b;
                var $temp$maybes = rest;
                maybes = $temp$maybes;
                continue orList;
            } else {
                var answer = maybes.a.a;
                return $elm$core$Maybe$Just(answer);
            }
        }
    };
    var $author$project$Components$Employee$Form$dependentStartDate = function(account) {
        return $elm_community$maybe_extra$Maybe$Extra$orList(_List_fromArray([
            $author$project$Api$CompanyAccount$All$defaultEnrollmentStartDate(account),
            $author$project$Api$CompanyAccount$All$invoicedThroughDate(account),
            $author$project$Api$CompanyAccount$All$membershipStartDate(account)
        ]));
    };
    var $author$project$Api$Employer$CompanyAccount$All$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Api$Provider$CompanyAccount$All$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Api$CompanyAccount$All$status = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$status(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$status(companyAccount_);
        }
    };
    var $author$project$Components$EmployeeDependentTypeInput$AccountSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$EmployeeDependentTypeInput$None = {
        $: 2
    };
    var $author$project$Components$EmployeeDependentTypeInput$TypeSelected = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$CompanyAccount$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$CompanyAccount$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$CompanyAccount$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$All$CompanyAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$CompanyAccount$All$Record = function(registrations) {
        return function(subscriber) {
            return function(division) {
                return function(membershipStartDate) {
                    return function(defaultEnrollmentStartDate) {
                        return function(invoicedThroughDate) {
                            return function(membershipEndDate) {
                                return function(status) {
                                    return function(plan) {
                                        return function(meta) {
                                            return {
                                                Np: defaultEnrollmentStartDate,
                                                Oa: division,
                                                RM: invoicedThroughDate,
                                                T_: membershipEndDate,
                                                T4: membershipStartDate,
                                                Ue: meta,
                                                GW: plan,
                                                agG: registrations,
                                                ahy: status,
                                                $r: subscriber
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$CompanyAccount$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CompanyAccount$Meta$Record = F2(function(actions, membership) {
        return {
            tM: actions,
            jc: membership
        };
    });
    var $author$project$Api$Employer$CompanyAccount$Meta$ActionsRecord = F3(function(needsApproval, canEnroll, isEligible) {
        return {
            KJ: canEnroll,
            R2: isEligible,
            UI: needsApproval
        };
    });
    var $author$project$Api$Employer$CompanyAccount$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'eligible', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enroll', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'needs_approval', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$ActionsRecord))));
    var $author$project$Api$Employer$CompanyAccount$Meta$MembershipRecord = F3(function(billFromDate, billingStartDate, endDate) {
        return {
            Kc: billFromDate,
            Kg: billingStartDate,
            qv: endDate
        };
    });
    var $author$project$Api$Employer$CompanyAccount$Meta$EndDateRecord = F4(function(defaultValue, maxWithoutBilling, min, minWithoutProration) {
        return {
            NE: defaultValue,
            TP: maxWithoutBilling,
            Uj: min,
            Um: minWithoutProration
        };
    });
    var $author$project$Api$Employer$CompanyAccount$Meta$endDateRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min_without_proration', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'min', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'max_without_billing', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_value', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$EndDateRecord)))));
    var $author$project$Api$Employer$CompanyAccount$Meta$membershipRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $author$project$Api$Employer$CompanyAccount$Meta$endDateRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_from_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$MembershipRecord))));
    var $author$project$Api$Employer$CompanyAccount$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership', $author$project$Api$Employer$CompanyAccount$Meta$membershipRecordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Employer$CompanyAccount$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$Meta$Record)));
    var $author$project$Api$Employer$CompanyAccount$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyAccount$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$Record = F4(function(patient, status, membershipStartDate, meta) {
        return {
            T4: membershipStartDate,
            Ue: meta,
            V7: patient,
            ahy: status
        };
    });
    var $author$project$Api$Employer$CompanyRegistration$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CompanyRegistration$Meta$Record = function(actions) {
        return {
            tM: actions
        };
    };
    var $author$project$Api$Employer$CompanyRegistration$Meta$ActionsRecord = F2(function(canEnroll, isEligible) {
        return {
            KJ: canEnroll,
            R2: isEligible
        };
    });
    var $author$project$Api$Employer$CompanyRegistration$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'eligible', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enroll', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Meta$ActionsRecord)));
    var $author$project$Api$Employer$CompanyRegistration$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Employer$CompanyRegistration$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$Meta$Record));
    var $author$project$Api$Employer$CompanyRegistration$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyRegistration$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Employer$CompanyRegistration$Meta$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Employer$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$Record)))));
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyRegistration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$CompanyRegistration)));
    var $author$project$Api$Employer$CompanyAccount$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Employer$CompanyAccount$Meta$decoder, A3($author$project$Api$Expandable$expandable, 'plan', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoiced_through_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_enrollment_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'division', $elm$json$Json$Decode$nullable($author$project$Api$Employer$EmployeeDivision$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subscriber', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Patient$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'registrations', $elm$json$Json$Decode$list($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$All$Record)))))))))));
    var $author$project$Api$Employer$CompanyAccount$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyAccount$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CompanyAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CompanyAccount$All$CompanyAccount)));
    var $author$project$Api$Employer$CompanyAccount$expandToString = function(expand) {
        if (expand === 1) return 'plan';
        else return 'registrations';
    };
    var $author$project$Api$Employer$CompanyAccount$listDefaults = {
        Fq: _List_Nil,
        Fw: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Employer$CompanyAccount$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Employer$CompanyAccount$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var q = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', q)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.aef;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fw;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', string)
                    ]);
                } else return _List_Nil;
            }(),
            A2($author$project$Api$Expandable$toParam, $author$project$Api$Employer$CompanyAccount$expandToString, options.Fq),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Employer$CompanyAccount$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$CompanyAccount$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Employer$CompanyAccount$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyAccount$companyAccountsPath)));
    });
    var $author$project$Api$Employer$CompanyAccount$Plan = 1;
    var $author$project$Api$Employer$CompanyAccount$Registrations = 0;
    var $author$project$Api$CompanyAccount$expandToEmployer = function(expand) {
        switch(expand){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Just(0);
            default:
                return $elm$core$Maybe$Just(1);
        }
    };
    var $author$project$Api$CompanyAccount$listDefaults = {
        Fq: _List_Nil,
        Fw: $elm$core$Maybe$Nothing,
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$CompanyAccount$optionalsToEmployer = function(optionals) {
        var options = optionals($author$project$Api$CompanyAccount$listDefaults);
        return function(d) {
            return _Utils_update(d, {
                Fq: A2($elm$core$List$filterMap, $author$project$Api$CompanyAccount$expandToEmployer, options.Fq),
                Fw: options.Fw,
                aef: options.aef,
                af_: options.af_,
                agq: options.agq,
                ahs: options.ahs
            });
        };
    };
    var $author$project$Api$Provider$Company$Account$MembershipPatients = 0;
    var $author$project$Api$Provider$Company$Account$Plan = 2;
    var $author$project$Api$Provider$Company$Account$Registrations = 1;
    var $author$project$Api$CompanyAccount$expandToProvider = function(expand) {
        switch(expand){
            case 0:
                return 0;
            case 1:
                return 1;
            default:
                return 2;
        }
    };
    var $author$project$Api$CompanyAccount$optionalsToProvider = function(optionals) {
        var options = optionals($author$project$Api$CompanyAccount$listDefaults);
        return function(d) {
            return _Utils_update(d, {
                Fq: A2($elm$core$List$map, $author$project$Api$CompanyAccount$expandToProvider, options.Fq),
                Fw: options.Fw,
                aef: options.aef,
                af_: options.af_,
                agq: options.agq,
                ahs: options.ahs
            });
        };
    };
    var $author$project$Api$CompanyAccount$list = F5(function(apiClient, session, companyId, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$CompanyAccount$list, apiClient, $author$project$Api$CompanyAccount$optionalsToEmployer(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$CompanyAccount$All$Employer)))) : A4($author$project$Api$Provider$Company$Account$list, apiClient, $author$project$Api$Provider$Company$companyPath(companyId), $author$project$Api$CompanyAccount$optionalsToProvider(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$CompanyAccount$All$Provider))));
    });
    var $author$project$Components$ResourceFilter$CompanyAccount$list = $author$project$Api$CompanyAccount$list;
    var $author$project$Components$ResourceFilter$CompanyAccount$fetchResources = F7(function(session, companyId, listOptionals, toMsg, apiClient, pagination, query) {
        return A5($author$project$Components$ResourceFilter$CompanyAccount$list, apiClient, session, companyId, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$CompanyAccount$retrieveResource = F6(function(session, companyId, listOptionals, toMsg, apiClient, id) {
        return A5($author$project$Components$ResourceFilter$CompanyAccount$list, apiClient, session, companyId, A2($elm$core$Basics$composeL, listOptionals, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }), toMsg);
    });
    var $author$project$Components$ResourceFilter$CompanyAccount$selectId = 'accounts';
    var $author$project$Api$Employer$Patient$Shared$name = function(_v0) {
        var shared = _v0;
        return shared.zr;
    };
    var $author$project$Api$Employer$CompanyAccount$All$subscriber = function(_v0) {
        var record = _v0.b;
        return record.$r;
    };
    var $author$project$Api$Provider$CompanyAccount$All$subscriber = function(_v0) {
        var record = _v0.b;
        return record.$r;
    };
    var $author$project$Api$CompanyAccount$All$subscriberName = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$name, $author$project$Api$Provider$CompanyAccount$All$subscriber(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Employer$Patient$Shared$name, $author$project$Api$Employer$CompanyAccount$All$subscriber(companyAccount_));
        }
    };
    var $author$project$Components$ResourceFilter$CompanyAccount$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$CompanyAccount$All$subscriberName, $elm$core$Maybe$withDefault(''));
    var $author$project$Components$ResourceFilter$CompanyAccount$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$CompanyAccount$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$CompanyAccount$toValue = $author$project$Api$CompanyAccount$All$id;
    var $author$project$Components$ResourceFilter$CompanyAccount$init = F5(function(apiClient, session, companyId, listOptionals, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: A3($author$project$Components$ResourceFilter$CompanyAccount$fetchResources, session, companyId, listOptionals),
            aef: $author$project$Components$ResourceFilter$CompanyAccount$selectId,
            gD: 'Company Account',
            sz: A3($author$project$Components$ResourceFilter$CompanyAccount$retrieveResource, session, companyId, listOptionals),
            ahW: $author$project$Components$ResourceFilter$CompanyAccount$toLabel,
            ahZ: $author$project$Components$ResourceFilter$CompanyAccount$toTitle,
            g4: $author$project$Components$ResourceFilter$CompanyAccount$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$CompanyAccount$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$EmployeeDependentTypeInput$update = F3(function(apiClient, msg, model) {
        if (!msg.$) {
            var type_ = msg.a;
            if (type_ === 'employee') return _Utils_Tuple3(_Utils_update(model, {
                fx: $elm$core$Maybe$Nothing,
                d_: $elm$core$Maybe$Nothing,
                ah5: type_
            }), $elm$core$Platform$Cmd$none, $author$project$Components$EmployeeDependentTypeInput$TypeSelected(type_));
            else {
                var _v1 = A5($author$project$Components$ResourceFilter$CompanyAccount$init, apiClient, model.Z$, $author$project$Api$Company$id(model.acy), $elm$core$Basics$identity, function(d) {
                    return _Utils_update(d, {
                        Ee: 'Select an Employee',
                        I5: false,
                        afn: false
                    });
                });
                var dependentOfFilter = _v1.a;
                var dependentOfFilterCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    d_: $elm$core$Maybe$Just(dependentOfFilter),
                    ah5: type_
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg, dependentOfFilterCmd), $author$project$Components$EmployeeDependentTypeInput$TypeSelected(type_));
            }
        } else {
            var filterMsg = msg.a;
            var _v2 = model.d_;
            if (!_v2.$) {
                var dependentOfFilter_ = _v2.a;
                var newDependentOfResult = A3($author$project$Components$ResourceFilter$CompanyAccount$update, apiClient, filterMsg, dependentOfFilter_);
                var _v3 = function() {
                    var _v4 = newDependentOfResult.adu;
                    if (!_v4.$ && !_v4.a.$ && !_v4.a.a.$) {
                        var dependentOf = _v4.a.a.a;
                        return _Utils_Tuple2(_Utils_update(model, {
                            fx: $elm$core$Maybe$Just(dependentOf),
                            d_: $elm$core$Maybe$Just(newDependentOfResult.zi)
                        }), $author$project$Components$EmployeeDependentTypeInput$AccountSelected(dependentOf));
                    } else return _Utils_Tuple2(_Utils_update(model, {
                        d_: $elm$core$Maybe$Just(newDependentOfResult.zi)
                    }), $author$project$Components$EmployeeDependentTypeInput$None);
                }();
                var newModel = _v3.a;
                var event = _v3.b;
                return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg, newDependentOfResult.EQ), event);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$EmployeeDependentTypeInput$None);
        }
    });
    var $author$project$Components$EmployeeDivisionInput$DivisionSelected = 0;
    var $author$project$Components$EmployeeDivisionInput$None = 1;
    var $author$project$Components$EmployeeDivisionInput$update = F2(function(msg, model) {
        if (!msg.$) {
            var division = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                Oa: $elm$core$String$length(division) > 0 ? $elm$core$Maybe$Just(division) : $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, 0);
        } else {
            var response = msg.a;
            var requiresDivisions = function() {
                if (response.$ === 3) {
                    var divisions = response.a;
                    return !$elm$core$List$isEmpty(divisions);
                } else return model.agM;
            }();
            return _Utils_Tuple3(_Utils_update(model, {
                xv: response,
                agM: requiresDivisions
            }), $elm$core$Platform$Cmd$none, 1);
        }
    });
    var $author$project$Components$Patient$Form$DateOfBirth = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$ProfilePicture = F2(function(a, b) {
        return {
            $: 25,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$Form$SSN = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$clearFieldErrors = F2(function(field, form) {
        switch(field.$){
            case 18:
                return A2($author$project$Utils$Form$clearGroupErrors, 8, form);
            case 19:
                return A2($author$project$Utils$Form$clearGroupErrors, 9, form);
            default:
                return form;
        }
    });
    var $author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber = function(_v0) {
        var record = _v0;
        return record.PY;
    };
    var $author$project$Components$Patient$Form$sixToEightDigitDate = F2(function(currentDate, inputValue) {
        var nextTwoDigitsYear = A2($elm$core$String$right, 2, $elm$core$String$fromInt($justinmimbs$date$Date$year(currentDate) + 1));
        var _v0 = _Utils_Tuple2(A2($elm$core$String$left, 4, inputValue), A2($elm$core$String$right, 2, inputValue));
        var dayAndMonth = _v0.a;
        var twoDigitYear = _v0.b;
        var newYear = _Utils_cmp(nextTwoDigitsYear, twoDigitYear) < 0 ? $elm$core$String$concat(_List_fromArray([
            '19',
            twoDigitYear
        ])) : $elm$core$String$concat(_List_fromArray([
            '20',
            twoDigitYear
        ]));
        return $elm$core$String$concat(_List_fromArray([
            dayAndMonth,
            newYear
        ]));
    });
    var $author$project$Components$SocialSecurityNumberInput$ssnPattern = $agustinrhcp$elm_mask$Mask$fromString('###-##-####');
    var $author$project$Api$GenderIdentity$NotListed = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Pronoun$Other = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$AffiliateInput$initWithResource = F4(function(apiClient, session, listOptionals, resource) {
        return A2($elm$core$Tuple$mapFirst, $author$project$Components$AffiliateInput$setValueWithResource(resource), A3($author$project$Components$AffiliateInput$empty, apiClient, session, listOptionals));
    });
    var $author$project$Components$Patient$Form$buildAffiliateInput = F5(function(apiClient, session, currentResource, _v0, _v1) {
        var locationEnabledSetting = _v0.a;
        var practitionersEnabledSetting = _v0.b;
        var practitionerResource = _v1.a;
        var locationResource = _v1.b;
        var practitionerId = practitionersEnabledSetting ? A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, practitionerResource) : $elm$core$Maybe$Nothing;
        var locationId = locationEnabledSetting ? A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, locationResource) : $elm$core$Maybe$Nothing;
        var filteredAffiliateOptionals = A2($author$project$Components$Patient$Form$affiliateOptionals, practitionerId, locationId);
        return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, currentResource);
    });
    var $author$project$Components$LocationInput$initWithResource = F3(function(apiClient, listOptionals, resource) {
        return A2($elm$core$Tuple$mapFirst, $author$project$Components$LocationInput$setValueWithResource(resource), A2($author$project$Components$LocationInput$empty, apiClient, listOptionals));
    });
    var $author$project$Components$Patient$Form$locationOptionals = F4(function(isEmployeeForm, company, practitioner, affiliate) {
        var signupPageValue = isEmployeeForm ? A2($elm$core$Maybe$map, $author$project$Api$SignupPage$Min$id, A2($elm$core$Maybe$andThen, $author$project$Api$Company$defaultSignupPage, company)) : $elm$core$Maybe$Nothing;
        return function(d) {
            return _Utils_update(d, {
                Eb: affiliate,
                agi: practitioner,
                Hs: signupPageValue
            });
        };
    });
    var $author$project$Components$Patient$Form$buildLocationInput = F6(function(apiClient, isEmployeeForm, company, currentResource, _v0, _v1) {
        var affiliateEnabledSetting = _v0.a;
        var practitionersEnabledSetting = _v0.b;
        var practitionerResource = _v1.a;
        var affiliateResource = _v1.b;
        var practitionerId = practitionersEnabledSetting ? A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, practitionerResource) : $elm$core$Maybe$Nothing;
        var affiliateId = affiliateEnabledSetting ? A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, affiliateResource) : $elm$core$Maybe$Nothing;
        var filteredLocationOptionals = A4($author$project$Components$Patient$Form$locationOptionals, isEmployeeForm, company, practitionerId, affiliateId);
        return A3($author$project$Components$LocationInput$initWithResource, apiClient, filteredLocationOptionals, currentResource);
    });
    var $author$project$Components$PractitionerInput$initWithResource = F3(function(apiClient, listOptionals, resource) {
        return A2($elm$core$Tuple$mapFirst, $author$project$Components$PractitionerInput$setValueWithResource(resource), A2($author$project$Components$PractitionerInput$empty, apiClient, listOptionals));
    });
    var $author$project$Components$Patient$Form$buildPractitionerInput = F6(function(apiClient, isEmployeeForm, company, currentResource, _v0, _v1) {
        var affiliateEnabledSetting = _v0.a;
        var locationEnabledSetting = _v0.b;
        var locationResource = _v1.a;
        var affiliateResource = _v1.b;
        var locationId = locationEnabledSetting ? A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, locationResource) : $elm$core$Maybe$Nothing;
        var affiliateId = affiliateEnabledSetting ? A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, affiliateResource) : $elm$core$Maybe$Nothing;
        var filteredPractitionerOptionals = A5($author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras, isEmployeeForm, company, locationId, affiliateId, _List_fromArray([
            1
        ]));
        return A3($author$project$Components$PractitionerInput$initWithResource, apiClient, filteredPractitionerOptionals, currentResource);
    });
    var $author$project$Components$Patient$Form$selectSelectedAffiliation = F5(function(apiClient, session, affiliationResource, practitionerResource, locationResource) {
        var filteredAffiliateOptionals = A2($author$project$Components$Patient$Form$affiliateOptionals, A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, practitionerResource), A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, locationResource));
        return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, affiliationResource);
    });
    var $author$project$Components$Patient$Form$handleAffiliateSelect = F8(function(apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
        var affiliateEnabledSetting = _v0.a;
        var locationEnabledSetting = _v0.b;
        var practitionersEnabledSetting = _v0.c;
        var affiliate = _v1.a;
        var affiliateCmd = _v1.b;
        var filterPractitionerDropdown = F2(function(locationResource, affiliateResource) {
            return A6($author$project$Components$Patient$Form$buildPractitionerInput, apiClient, isEmployeeForm, company, $elm$core$Maybe$Nothing, _Utils_Tuple2(affiliateEnabledSetting, locationEnabledSetting), _Utils_Tuple2(locationResource, affiliateResource));
        });
        var filterLocationDropdown = F2(function(practitionerResource, affiliateResource) {
            return A6($author$project$Components$Patient$Form$buildLocationInput, apiClient, isEmployeeForm, company, $elm$core$Maybe$Nothing, _Utils_Tuple2(affiliateEnabledSetting, practitionersEnabledSetting), _Utils_Tuple2(practitionerResource, affiliateResource));
        });
        _v2$2: while(true){
            if (!event.$ && !event.a.$) switch(event.a.a.$){
                case 2:
                    var _v3 = event.a.a;
                    var _v4 = A5($author$project$Components$Patient$Form$buildAffiliateInput, apiClient, session, $elm$core$Maybe$Nothing, _Utils_Tuple2(locationEnabledSetting, practitionersEnabledSetting), _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
                    var initAffiliate = _v4.a;
                    var initAffiliateCmd = _v4.b;
                    return _Utils_Tuple3(A2(filterPractitionerDropdown, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), A2(filterLocationDropdown, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), _Utils_Tuple2(initAffiliate, initAffiliateCmd));
                case 0:
                    return _Utils_eq(affiliate.aa9, form.Eb.aa9) ? _Utils_Tuple3(_Utils_Tuple2(form.agi, $elm$core$Platform$Cmd$none), _Utils_Tuple2(form.aeT, $elm$core$Platform$Cmd$none), _Utils_Tuple2(affiliate, affiliateCmd)) : _Utils_Tuple3(A2(filterPractitionerDropdown, form.aeT.aa9, affiliate.aa9), A2(filterLocationDropdown, form.agi.aa9, affiliate.aa9), A5($author$project$Components$Patient$Form$selectSelectedAffiliation, apiClient, session, affiliate.aa9, form.agi.aa9, form.aeT.aa9));
                default:
                    break _v2$2;
            }
            else break _v2$2;
        }
        return _Utils_Tuple3(_Utils_Tuple2(form.agi, $elm$core$Platform$Cmd$none), _Utils_Tuple2(form.aeT, $elm$core$Platform$Cmd$none), _Utils_Tuple2(affiliate, affiliateCmd));
    });
    var $author$project$Components$Patient$Form$selectAffiliationFromOtherResource = F4(function(apiClient, session, practitionerResource, locationResource) {
        var filteredAffiliateOptionals = A2($author$project$Components$Patient$Form$affiliateOptionals, A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, practitionerResource), A2($elm$core$Maybe$map, function($) {
            return $.aef;
        }, locationResource));
        var affiliationResource = function() {
            var _v0 = _Utils_Tuple2(practitionerResource, locationResource);
            if (!_v0.a.$) {
                if (!_v0.b.$) return A2($elm$core$Maybe$andThen, $elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin), A2($elm$core$Maybe$map, function($) {
                    return $.IY;
                }, practitionerResource));
                else {
                    var _v1 = _v0.b;
                    return A2($elm$core$Maybe$andThen, $elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin), A2($elm$core$Maybe$map, function($) {
                        return $.IY;
                    }, practitionerResource));
                }
            } else {
                if (!_v0.b.$) {
                    var _v2 = _v0.a;
                    return A2($elm$core$Maybe$andThen, $elm$core$Maybe$map($author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin), A2($elm$core$Maybe$map, function($) {
                        return $.IY;
                    }, locationResource));
                } else return $elm$core$Maybe$Nothing;
            }
        }();
        return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, affiliationResource);
    });
    var $author$project$Components$Patient$Form$handleLocationSelect = F8(function(apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
        var affiliateEnabledSetting = _v0.a;
        var locationEnabledSetting = _v0.b;
        var hasPractitioners = _v0.c;
        var location1 = _v1.a;
        var locationCmd = _v1.b;
        var filterPractitionerDropdown = A6($author$project$Components$Patient$Form$buildPractitionerInput, apiClient, isEmployeeForm, company, form.agi.aa9, _Utils_Tuple2(affiliateEnabledSetting, locationEnabledSetting), _Utils_Tuple2(location1.aa9, form.Eb.aa9));
        _v2$2: while(true){
            if (!event.$ && !event.a.$) switch(event.a.a.$){
                case 2:
                    var _v3 = event.a.a;
                    var filterAffiliateDropdown = A5($author$project$Components$Patient$Form$buildAffiliateInput, apiClient, session, form.Eb.aa9, _Utils_Tuple2(locationEnabledSetting, hasPractitioners), _Utils_Tuple2(form.agi.aa9, location1.aa9));
                    var _v4 = A6($author$project$Components$Patient$Form$buildLocationInput, apiClient, isEmployeeForm, company, $elm$core$Maybe$Nothing, _Utils_Tuple2(affiliateEnabledSetting, hasPractitioners), _Utils_Tuple2(form.agi.aa9, form.Eb.aa9));
                    var initLocation = _v4.a;
                    var initLocationCmd = _v4.b;
                    return _Utils_Tuple3(filterPractitionerDropdown, _Utils_Tuple2(initLocation, initLocationCmd), filterAffiliateDropdown);
                case 0:
                    return _Utils_eq(location1.aa9, form.aeT.aa9) ? _Utils_Tuple3(_Utils_Tuple2(form.agi, $elm$core$Platform$Cmd$none), _Utils_Tuple2(location1, locationCmd), _Utils_Tuple2(form.Eb, $elm$core$Platform$Cmd$none)) : _Utils_Tuple3(filterPractitionerDropdown, _Utils_Tuple2(location1, locationCmd), A4($author$project$Components$Patient$Form$selectAffiliationFromOtherResource, apiClient, session, form.agi.aa9, location1.aa9));
                default:
                    break _v2$2;
            }
            else break _v2$2;
        }
        return _Utils_Tuple3(_Utils_Tuple2(form.agi, $elm$core$Platform$Cmd$none), _Utils_Tuple2(location1, locationCmd), _Utils_Tuple2(form.Eb, $elm$core$Platform$Cmd$none));
    });
    var $author$project$Components$Patient$Form$handlePractitionerSelect = F8(function(apiClient, session, company, form, event, _v0, isEmployeeForm, _v1) {
        var syncByAffiliation = _v0.a;
        var locationEnabledSetting = _v0.b;
        var hasPractitioners = _v0.c;
        var practitioner = _v1.a;
        var practitionerCmd = _v1.b;
        var filterLocationDropDown = A6($author$project$Components$Patient$Form$buildLocationInput, apiClient, isEmployeeForm, company, form.aeT.aa9, _Utils_Tuple2(syncByAffiliation, hasPractitioners), _Utils_Tuple2(practitioner.aa9, form.Eb.aa9));
        _v2$2: while(true){
            if (!event.$ && !event.a.$) switch(event.a.a.$){
                case 2:
                    var _v3 = event.a.a;
                    var filterAffiliateDropdown = A5($author$project$Components$Patient$Form$buildAffiliateInput, apiClient, session, form.Eb.aa9, _Utils_Tuple2(locationEnabledSetting, hasPractitioners), _Utils_Tuple2(practitioner.aa9, form.aeT.aa9));
                    var _v4 = A6($author$project$Components$Patient$Form$buildPractitionerInput, apiClient, isEmployeeForm, company, $elm$core$Maybe$Nothing, _Utils_Tuple2(syncByAffiliation, locationEnabledSetting), _Utils_Tuple2(form.aeT.aa9, form.Eb.aa9));
                    var initPractitioner = _v4.a;
                    var initPractitionerCmd = _v4.b;
                    return _Utils_Tuple3(_Utils_Tuple2(initPractitioner, initPractitionerCmd), filterLocationDropDown, filterAffiliateDropdown);
                case 0:
                    return _Utils_eq(practitioner.aa9, form.agi.aa9) ? _Utils_Tuple3(_Utils_Tuple2(practitioner, practitionerCmd), _Utils_Tuple2(form.aeT, $elm$core$Platform$Cmd$none), _Utils_Tuple2(form.Eb, $elm$core$Platform$Cmd$none)) : _Utils_Tuple3(_Utils_Tuple2(practitioner, practitionerCmd), filterLocationDropDown, A4($author$project$Components$Patient$Form$selectAffiliationFromOtherResource, apiClient, session, practitioner.aa9, form.aeT.aa9));
                default:
                    break _v2$2;
            }
            else break _v2$2;
        }
        return _Utils_Tuple3(_Utils_Tuple2(practitioner, practitionerCmd), _Utils_Tuple2(form.aeT, $elm$core$Platform$Cmd$none), _Utils_Tuple2(form.Eb, $elm$core$Platform$Cmd$none));
    });
    var $author$project$Components$ResourceFilter$Affiliate$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$AffiliateInput$update = F3(function(apiClient, msg, input) {
        var filterMsg = msg;
        var _v1 = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, filterMsg, input.Fw);
        var model = _v1.zi;
        var cmd = _v1.EQ;
        var event = _v1.adu;
        return _Utils_Tuple3(function() {
            _v2$2: while(true){
                if (!event.$ && !event.a.$) switch(event.a.a.$){
                    case 0:
                        var affiliate = event.a.a.a;
                        return _Utils_update(input, {
                            Fw: model,
                            aa9: $elm$core$Maybe$Just(affiliate)
                        });
                    case 2:
                        var _v3 = event.a.a;
                        return _Utils_update(input, {
                            Fw: model,
                            aa9: $elm$core$Maybe$Nothing
                        });
                    default:
                        break _v2$2;
                }
                else break _v2$2;
            }
            return _Utils_update(input, {
                Fw: model
            });
        }(), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), event);
    });
    var $author$project$Components$EmergencyContactInput$fieldChanged = F2(function(field, emergencyContact) {
        switch(field.$){
            case 0:
                var firstName = field.a;
                return _Utils_Tuple2(_Utils_update(emergencyContact, {
                    PN: firstName
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var lastName = field.a;
                return _Utils_Tuple2(_Utils_update(emergencyContact, {
                    SU: lastName
                }), $elm$core$Platform$Cmd$none);
            case 2:
                var relationship = field.a;
                return _Utils_Tuple2(_Utils_update(emergencyContact, {
                    Yu: relationship
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var email = field.a;
                return _Utils_Tuple2(_Utils_update(emergencyContact, {
                    OH: email
                }), $elm$core$Platform$Cmd$none);
            default:
                var phoneMsg = field.a;
                var _v1 = A2($author$project$Components$PhoneInput$update, phoneMsg, emergencyContact.WE);
                var phone = _v1.a;
                var phoneCmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(emergencyContact, {
                    WE: phone
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone), phoneCmd));
        }
    });
    var $author$project$Components$EmergencyContactInput$update = F2(function(msg, model) {
        if (msg.$ === 1) {
            var subMsg = msg.a;
            var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.nW);
            var dropdown = _v1.a;
            var dropdownCmd = _v1.b;
            return _Utils_Tuple2(_Utils_update(model, {
                nW: dropdown
            }), dropdownCmd);
        } else {
            var field = msg.a;
            var _v2 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$EmergencyContactInput$fieldChanged, field, model.PU);
            var newForm = _v2.a;
            var formCmd = _v2.b;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), formCmd);
        }
    });
    var $author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$HealthInsuranceInput$Other = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$HealthInsuranceInput$ifElse = F3(function(ifVal, elseVal, bool) {
        return bool ? ifVal : elseVal;
    });
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$HealthInsuranceInput$updateRecord = F2(function(updateFn, model) {
        var filter = model.a;
        var options = model.b;
        var maybeCarrierAndInsurance = model.c;
        if (!maybeCarrierAndInsurance.$) {
            var _v1 = maybeCarrierAndInsurance.a;
            var carrier = _v1.a;
            var record = _v1.b;
            return A3($author$project$Components$HealthInsuranceInput$Model, filter, options, $elm$core$Maybe$Just(_Utils_Tuple2(carrier, updateFn(record))));
        } else return model;
    });
    var $author$project$Components$HealthInsuranceInput$update = F3(function(apiClient, msg, model) {
        var filter = model.a;
        var options = model.b;
        var healthInsurance = model.c;
        switch(msg.$){
            case 0:
                var filterMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$InsuranceCarrierAlias$update, apiClient, filterMsg, filter);
                var event = result.adu;
                var cmd = result.EQ;
                var newFilter = result.zi;
                return _Utils_Tuple2(function() {
                    if (!event.$) {
                        if (!event.a.$) switch(event.a.a.$){
                            case 0:
                                var carrierAlias = event.a.a.a;
                                var sameAlias = function() {
                                    if (!healthInsurance.$ && !healthInsurance.a.a.$) {
                                        var _v3 = healthInsurance.a;
                                        var alias_ = _v3.a.a;
                                        return _Utils_eq(alias_.zr, carrierAlias.zr);
                                    } else return false;
                                }();
                                return sameAlias ? A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance) : A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias(carrierAlias), {
                                    Qf: A3($author$project$Components$HealthInsuranceInput$ifElse, $elm$core$Maybe$Just(''), $elm$core$Maybe$Nothing, carrierAlias.EI),
                                    QJ: $elm$core$Maybe$Nothing,
                                    TV: A3($author$project$Components$HealthInsuranceInput$ifElse, $elm$core$Maybe$Just(''), $elm$core$Maybe$Nothing, carrierAlias.EJ),
                                    Wg: $elm$core$Maybe$Nothing
                                })));
                            case 3:
                                var _v4 = event.a.a;
                                if (!healthInsurance.$ && healthInsurance.a.a.$ === 1) {
                                    var _v6 = healthInsurance.a;
                                    return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance);
                                } else return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Components$HealthInsuranceInput$Other({
                                    zr: ''
                                }), {
                                    Qf: $elm$core$Maybe$Just(''),
                                    QJ: $elm$core$Maybe$Nothing,
                                    TV: $elm$core$Maybe$Just(''),
                                    Wg: $elm$core$Maybe$Just('')
                                })));
                            case 2:
                                var _v7 = event.a.a;
                                return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, $elm$core$Maybe$Nothing);
                            default:
                                return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, $elm$core$Maybe$Nothing);
                        }
                        else {
                            var _v8 = event.a;
                            return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance);
                        }
                    } else return A3($author$project$Components$HealthInsuranceInput$Model, newFilter, options, healthInsurance);
                }(), A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, cmd));
            case 1:
                var name = msg.a;
                if (!healthInsurance.$ && healthInsurance.a.a.$ === 1) {
                    var _v10 = healthInsurance.a;
                    var other = _v10.a.a;
                    var record = _v10.b;
                    return _Utils_Tuple2(A3($author$project$Components$HealthInsuranceInput$Model, filter, options, $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Components$HealthInsuranceInput$Other(_Utils_update(other, {
                        zr: name
                    })), record))), $elm$core$Platform$Cmd$none);
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 3:
                var memberId = msg.a;
                return _Utils_Tuple2(A2($author$project$Components$HealthInsuranceInput$updateRecord, function(record) {
                    return _Utils_update(record, {
                        TV: $elm$core$Maybe$Just(memberId)
                    });
                }, model), $elm$core$Platform$Cmd$none);
            case 4:
                var groupId = msg.a;
                return _Utils_Tuple2(A2($author$project$Components$HealthInsuranceInput$updateRecord, function(record) {
                    return _Utils_update(record, {
                        Qf: $elm$core$Maybe$Just(groupId)
                    });
                }, model), $elm$core$Platform$Cmd$none);
            default:
                var highDeductible = msg.a;
                return _Utils_Tuple2(A2($author$project$Components$HealthInsuranceInput$updateRecord, function(record) {
                    return _Utils_update(record, {
                        QJ: $elm$core$Maybe$Just(highDeductible)
                    });
                }, model), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$KnownPracticeInput$KnownPractice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$KnownPracticeInput$Other = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$KnownPractice$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$KnownPracticeInput$update = F3(function(apiClient, msg, _v0) {
        var filter = _v0.a;
        var knownPractice = _v0.b;
        switch(msg.$){
            case 0:
                var filterMsg = msg.a;
                var _v2 = A3($author$project$Components$ResourceFilter$KnownPractice$update, apiClient, filterMsg, filter);
                var model = _v2.zi;
                var event = _v2.adu;
                var cmd = _v2.EQ;
                return _Utils_Tuple2(function() {
                    _v3$3: while(true){
                        if (!event.$) {
                            if (!event.a.$) switch(event.a.a.$){
                                case 0:
                                    var knownPractice_ = event.a.a.a;
                                    return A2($author$project$Components$KnownPracticeInput$Model, model, $elm$core$Maybe$Just($author$project$Components$KnownPracticeInput$KnownPractice(knownPractice_)));
                                case 3:
                                    var _v4 = event.a.a;
                                    return A2($author$project$Components$KnownPracticeInput$Model, model, $elm$core$Maybe$Just($author$project$Components$KnownPracticeInput$Other({
                                        zr: '',
                                        D0: ''
                                    })));
                                default:
                                    break _v3$3;
                            }
                            else break _v3$3;
                        } else return A2($author$project$Components$KnownPracticeInput$Model, model, knownPractice);
                    }
                    return A2($author$project$Components$KnownPracticeInput$Model, model, $elm$core$Maybe$Nothing);
                }(), A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, cmd));
            case 1:
                var name = msg.a;
                if (!knownPractice.$ && knownPractice.a.$ === 1) {
                    var other = knownPractice.a.a;
                    return _Utils_Tuple2(A2($author$project$Components$KnownPracticeInput$Model, filter, $elm$core$Maybe$Just($author$project$Components$KnownPracticeInput$Other(_Utils_update(other, {
                        zr: name
                    })))), $elm$core$Platform$Cmd$none);
                } else return _Utils_Tuple2(A2($author$project$Components$KnownPracticeInput$Model, filter, knownPractice), $elm$core$Platform$Cmd$none);
            default:
                var website = msg.a;
                if (!knownPractice.$ && knownPractice.a.$ === 1) {
                    var other = knownPractice.a.a;
                    return _Utils_Tuple2(A2($author$project$Components$KnownPracticeInput$Model, filter, $elm$core$Maybe$Just($author$project$Components$KnownPracticeInput$Other(_Utils_update(other, {
                        D0: website
                    })))), $elm$core$Platform$Cmd$none);
                } else return _Utils_Tuple2(A2($author$project$Components$KnownPracticeInput$Model, filter, knownPractice), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$LeadSourceInput$isOther = function(leadSource) {
        return $author$project$Api$Provider$LeadSource$All$name(leadSource) === 'Other';
    };
    var $author$project$Components$LeadSourceInput$update = F3(function(apiClient, msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, model.mT);
            var _v1 = function() {
                var _v2 = leadSourceResourceResult.adu;
                _v2$2: while(true){
                    if (!_v2.$ && !_v2.a.$) switch(_v2.a.a.$){
                        case 0:
                            var leadSource = _v2.a.a.a;
                            return _Utils_Tuple2($elm$core$Maybe$Just($author$project$Api$Provider$LeadSource$All$id(leadSource)), function() {
                                var _v3 = _Utils_Tuple2($author$project$Components$LeadSourceInput$isOther(leadSource), model.c6);
                                if (_v3.a) {
                                    if (!_v3.b.$) return model.c6;
                                    else {
                                        var _v4 = _v3.b;
                                        return $elm$core$Maybe$Just('');
                                    }
                                } else return $elm$core$Maybe$Nothing;
                            }());
                        case 2:
                            var _v5 = _v2.a.a;
                            return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
                        default:
                            break _v2$2;
                    }
                    else break _v2$2;
                }
                return _Utils_Tuple2(model.ah, model.c6);
            }();
            var selected = _v1.a;
            var other = _v1.b;
            return _Utils_Tuple3(_Utils_update(model, {
                mT: leadSourceResourceResult.zi,
                c6: other,
                ah: selected
            }), A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceResult.EQ), leadSourceResourceResult.at);
        } else {
            var other = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                c6: $elm$core$Maybe$Just(other)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$LocationInput$update = F3(function(apiClient, msg, input) {
        var filterMsg = msg;
        var _v1 = A3($author$project$Components$ResourceFilter$Location$update, apiClient, filterMsg, input.Fw);
        var model = _v1.zi;
        var cmd = _v1.EQ;
        var event = _v1.adu;
        return _Utils_Tuple3(function() {
            _v2$2: while(true){
                if (!event.$ && !event.a.$) switch(event.a.a.$){
                    case 0:
                        var location1 = event.a.a.a;
                        return _Utils_update(input, {
                            Fw: model,
                            aa9: $elm$core$Maybe$Just(location1)
                        });
                    case 2:
                        var _v3 = event.a.a;
                        return _Utils_update(input, {
                            Fw: model,
                            aa9: $elm$core$Maybe$Nothing
                        });
                    default:
                        break _v2$2;
                }
                else break _v2$2;
            }
            return _Utils_update(input, {
                Fw: model
            });
        }(), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), event);
    });
    var $author$project$Components$NameInput$updateField = F2(function(field, _v0) {
        var errors = _v0.a;
        var options = _v0.b;
        var fields = _v0.c;
        return A3($author$project$Components$NameInput$Model, errors, options, function() {
            switch(field.$){
                case 0:
                    var title = field.a;
                    return _Utils_update(fields, {
                        $2: title
                    });
                case 1:
                    var firstName = field.a;
                    return _Utils_update(fields, {
                        PN: firstName
                    });
                case 2:
                    var middleName = field.a;
                    return _Utils_update(fields, {
                        Uh: middleName
                    });
                case 3:
                    var lastName = field.a;
                    return _Utils_update(fields, {
                        SU: lastName
                    });
                default:
                    var suffix = field.a;
                    return _Utils_update(fields, {
                        $w: suffix
                    });
            }
        }());
    });
    var $author$project$Components$NameInput$update = F2(function(msg, model) {
        var field = msg;
        return A2($author$project$Components$NameInput$updateField, field, model);
    });
    var $author$project$Components$PractitionerInput$update = F3(function(apiClient, msg, input) {
        var filterMsg = msg;
        var _v1 = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, filterMsg, input.Fw);
        var model = _v1.zi;
        var cmd = _v1.EQ;
        var event = _v1.adu;
        return _Utils_Tuple3(function() {
            _v2$2: while(true){
                if (!event.$ && !event.a.$) switch(event.a.a.$){
                    case 0:
                        var practitioner = event.a.a.a;
                        return _Utils_update(input, {
                            Fw: model,
                            aa9: $elm$core$Maybe$Just(practitioner)
                        });
                    case 2:
                        var _v3 = event.a.a;
                        return _Utils_update(input, {
                            Fw: model,
                            aa9: $elm$core$Maybe$Nothing
                        });
                    default:
                        break _v2$2;
                }
                else break _v2$2;
            }
            return _Utils_update(input, {
                Fw: model
            });
        }(), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), event);
    });
    var $author$project$Components$Patient$Form$updateField = F6(function(apiClient, session, company, settings, field, form) {
        switch(field.$){
            case 0:
                var nameInputMsg = field.a;
                var newName = A2($author$project$Components$NameInput$update, nameInputMsg, form.S4);
                return _Utils_Tuple3(_Utils_update(form, {
                    S4: newName
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var nameInputMsg = field.a;
                var _v1 = form.br;
                if (!_v1.$) {
                    var chosenName = _v1.a;
                    var newName = A2($author$project$Components$NameInput$update, nameInputMsg, chosenName);
                    return _Utils_Tuple3(_Utils_update(form, {
                        br: $elm$core$Maybe$Just(newName)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var gender = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Z3: $elm$core$Maybe$Just(gender)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var gender = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    P5: $elm$core$Maybe$Just(gender)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var genderOther = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    P7: $elm$core$Maybe$Just(genderOther)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var dob = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    M7: dob
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var email = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    OH: email
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var genderIdentity = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    P6: genderIdentity
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var other = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    P6: $elm$core$Maybe$Just($author$project$Api$GenderIdentity$NotListed(other))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var pronoun = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    XF: pronoun
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var other = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    XF: $elm$core$Maybe$Just($author$project$Api$Pronoun$Other(other))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var phoneMsg = field.a;
                var _v2 = A2($author$project$Components$PhoneInput$update, phoneMsg, form.WG);
                var updatedPhones = _v2.a;
                var phoneCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    WG: updatedPhones
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones), phoneCmd), _List_Nil);
            case 12:
                var addressMsg = field.a;
                var _v3 = A2($author$project$Components$AddressInput$update, addressMsg, form.II);
                var address = _v3.a;
                var addressCmd = _v3.b;
                var outMsgs = _v3.c;
                return _Utils_Tuple3(_Utils_update(form, {
                    II: address
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address), addressCmd), outMsgs);
            case 13:
                var usesBillingAddress = field.a;
                if (usesBillingAddress) {
                    var _v4 = A2($elm$core$Maybe$withDefault, $author$project$Components$AddressInput$init('patient-billing-address'), A2($elm$core$Maybe$map, function(address_) {
                        return _Utils_Tuple2(address_, $elm$core$Platform$Cmd$none);
                    }, form.Ke));
                    var address = _v4.a;
                    var addressCmd = _v4.b;
                    return _Utils_Tuple3(_Utils_update(form, {
                        Ke: $elm$core$Maybe$Just(address),
                        aa_: usesBillingAddress
                    }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress), addressCmd), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(form, {
                    aa_: usesBillingAddress
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var addressMsg = field.a;
                var _v5 = form.Ke;
                if (_v5.$ === 1) return _Utils_Tuple3(form, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    var billingAddress = _v5.a;
                    var _v6 = A2($author$project$Components$AddressInput$update, addressMsg, billingAddress);
                    var address = _v6.a;
                    var addressCmd = _v6.b;
                    var outMsgs = _v6.c;
                    return _Utils_Tuple3(_Utils_update(form, {
                        Ke: $elm$core$Maybe$Just(address)
                    }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress), addressCmd), outMsgs);
                }
            case 15:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    __: string
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var msg = field.a;
                var _v7 = A3($author$project$Components$KnownPracticeInput$update, apiClient, msg, form.SM);
                var knownPractice = _v7.a;
                var knownPracticeCmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    SM: knownPractice
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice), knownPracticeCmd), _List_Nil);
            case 17:
                var tobaccoUse = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    oO: tobaccoUse
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var msg = field.a;
                var _v8 = A3($author$project$Components$PractitionerInput$update, apiClient, msg, form.agi);
                var selectedPractitioner = _v8.a;
                var selectedPractitionerCmd = _v8.b;
                var event = _v8.c;
                var _v9 = function() {
                    var locationEnabledSetting = settings.Qr && settings.aaq;
                    return A8($author$project$Components$Patient$Form$handlePractitionerSelect, apiClient, session, company, form, event, _Utils_Tuple3(settings.$D, locationEnabledSetting, settings.Qx), settings.q6, _Utils_Tuple2(selectedPractitioner, selectedPractitionerCmd));
                }();
                var _v10 = _v9.a;
                var practitioner = _v10.a;
                var practitionerCmd = _v10.b;
                var _v11 = _v9.b;
                var location1 = _v11.a;
                var locationCmd = _v11.b;
                var _v12 = _v9.c;
                var affiliate = _v12.a;
                var affiliateCmd = _v12.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    Eb: affiliate,
                    aeT: location1,
                    agi: practitioner
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner), practitionerCmd),
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location), locationCmd),
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate), affiliateCmd)
                ])), _List_Nil);
            case 19:
                var msg = field.a;
                var _v13 = A3($author$project$Components$LocationInput$update, apiClient, msg, form.aeT);
                var selectedLocation = _v13.a;
                var selectedLocationCmd = _v13.b;
                var event = _v13.c;
                var _v14 = function() {
                    var locationEnabledSetting = settings.Qr && settings.aaq;
                    return A8($author$project$Components$Patient$Form$handleLocationSelect, apiClient, session, company, form, event, _Utils_Tuple3(settings.$D, locationEnabledSetting, settings.Qx), settings.q6, _Utils_Tuple2(selectedLocation, selectedLocationCmd));
                }();
                var _v15 = _v14.a;
                var practitioner = _v15.a;
                var practitionerCmd = _v15.b;
                var _v16 = _v14.b;
                var location1 = _v16.a;
                var locationCmd = _v16.b;
                var _v17 = _v14.c;
                var affiliate = _v17.a;
                var affiliateCmd = _v17.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    Eb: affiliate,
                    aeT: location1,
                    agi: practitioner
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner), practitionerCmd),
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location), locationCmd),
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate), affiliateCmd)
                ])), _List_Nil);
            case 24:
                var msg = field.a;
                var _v18 = A3($author$project$Components$AffiliateInput$update, apiClient, msg, form.Eb);
                var selectedAffiliate = _v18.a;
                var selectedAffiliateCmd = _v18.b;
                var event = _v18.c;
                var _v19 = function() {
                    var locationEnabledSetting = settings.Qr && settings.aaq;
                    return A8($author$project$Components$Patient$Form$handleAffiliateSelect, apiClient, session, company, form, event, _Utils_Tuple3(settings.$D, locationEnabledSetting, settings.Qx), settings.q6, _Utils_Tuple2(selectedAffiliate, selectedAffiliateCmd));
                }();
                var _v20 = _v19.a;
                var practitioner = _v20.a;
                var practitionerCmd = _v20.b;
                var _v21 = _v19.b;
                var location1 = _v21.a;
                var locationCmd = _v21.b;
                var _v22 = _v19.c;
                var affiliate = _v22.a;
                var affiliateCmd = _v22.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    Eb: affiliate,
                    aeT: location1,
                    agi: practitioner
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate), affiliateCmd),
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner), practitionerCmd),
                    A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location), locationCmd)
                ])), _List_Nil);
            case 20:
                var dateInputMsg = field.a;
                var _v23 = form.i0;
                var prevValue = _v23.a;
                var prevInput = _v23.b;
                var _v24 = A2($author$project$Components$DateInput$update, dateInputMsg, prevInput);
                var dateInput = _v24.a;
                var dateInputCmd = _v24.b;
                var event = _v24.c;
                var newValue = function() {
                    if (event.$ === 1) {
                        var date = event.a;
                        return date;
                    } else return prevValue;
                }();
                return _Utils_Tuple3(_Utils_update(form, {
                    i0: _Utils_Tuple2(newValue, dateInput)
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice), dateInputCmd), _List_Nil);
            case 21:
                var msg = field.a;
                var _v26 = A3($author$project$Components$LeadSourceInput$update, apiClient, msg, form.S1);
                var leadSource = _v26.a;
                var leadSourceCmd = _v26.b;
                var leadSourceOutMsgs = _v26.c;
                return _Utils_Tuple3(_Utils_update(form, {
                    S1: leadSource
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource), leadSourceCmd), leadSourceOutMsgs);
            case 22:
                var msg = field.a;
                var _v27 = A3($author$project$Components$HealthInsuranceInput$update, apiClient, msg, form.QC);
                var healthInsurance = _v27.a;
                var healthInsuranceCmd = _v27.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    QC: healthInsurance
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance), healthInsuranceCmd), _List_Nil);
            case 23:
                var sync = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    $H: sync
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 25:
                var _int = field.a;
                var string = field.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    qa: $elm$core$Maybe$Just(string),
                    sl: _int,
                    XE: $elm$core$Maybe$Just(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 26:
                var lang = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    Xh: lang
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var emergencyContactMsg = field.a;
                var _v28 = A2($author$project$Components$EmergencyContactInput$update, emergencyContactMsg, form.OJ);
                var emergencyContact = _v28.a;
                var emergencyContactCmd = _v28.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    OJ: emergencyContact
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$EmergencyContact, $author$project$Components$Patient$Form$FieldUpdated), emergencyContactCmd), _List_Nil);
        }
    });
    var $author$project$Utils$Form$updateWithCmdAndOutMsgs = F3(function(updater, field_, _v0) {
        var originalFields = _v0.a;
        var validated_ = _v0.b;
        var fields_ = _v0.c;
        var errors_ = _v0.d;
        var _v1 = A2(updater, field_, fields_);
        var updated = _v1.a;
        var cmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(A4($author$project$Utils$Form$Form, originalFields, validated_, updated, errors_), cmd, outMsgs);
    });
    var $author$project$Components$Patient$Form$update = F5(function(apiClient, session, company, msg, model) {
        var settings = model.a;
        var form = model.b;
        switch(msg.$){
            case 1:
                var enable = msg.a;
                var fields = $author$project$Utils$Form$fields(form);
                var newFields = _Utils_update(fields, {
                    br: enable ? $elm$core$Maybe$Just($author$project$Components$NameInput$empty) : $elm$core$Maybe$Nothing
                });
                return _Utils_Tuple3(A2($author$project$Components$Patient$Form$PatientForm, settings, A2($author$project$Utils$Form$set, newFields, form)), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var ssn = response.a;
                    var ssnString = A2($agustinrhcp$elm_mask$Mask$unMask, $author$project$Components$SocialSecurityNumberInput$ssnPattern, A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber(ssn)));
                    return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Components$Patient$Form$PatientForm(settings), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Components$Patient$Form$clearFieldErrors($author$project$Components$Patient$Form$SSN(ssnString)), A3($author$project$Utils$Form$updateWithCmdAndOutMsgs, A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings), $author$project$Components$Patient$Form$SSN(ssnString), form)));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 0:
                var field = msg.a;
                return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Components$Patient$Form$PatientForm(settings), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Components$Patient$Form$clearFieldErrors(field), A3($author$project$Utils$Form$updateWithCmdAndOutMsgs, A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings), field, form)));
            case 3:
                var response = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var inputValue = $author$project$Utils$Form$fields(form).M7;
                var newValue = $elm$core$String$length(inputValue) === 6 ? A2($author$project$Components$Patient$Form$sixToEightDigitDate, settings.cP, inputValue) : inputValue;
                return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Components$Patient$Form$PatientForm(settings), A3($author$project$Utils$Form$updateWithCmdAndOutMsgs, A4($author$project$Components$Patient$Form$updateField, apiClient, session, company, settings), $author$project$Components$Patient$Form$DateOfBirth(newValue), form));
            default:
                var pictures = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v2) {
                    var task = _v2.a;
                    var size = _v2.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$ProfilePicture(size)), task);
                }, A2($elm$core$Maybe$map, function(picture) {
                    return _Utils_Tuple2($elm$file$File$toUrl(picture), $elm$file$File$size(picture));
                }, $elm$core$List$head(pictures))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
        }
    });
    var $author$project$Components$SponsorPlanInput$update = F3(function(apiClient, msg, input) {
        var filterMsg = msg;
        var _v1 = A3($author$project$Components$ResourceFilter$CompanyPlan$update, apiClient, filterMsg, input.Fw);
        var model = _v1.zi;
        var cmd = _v1.EQ;
        var event = _v1.adu;
        return _Utils_Tuple3(function() {
            _v2$2: while(true){
                if (!event.$ && !event.a.$) switch(event.a.a.$){
                    case 0:
                        var companyPlan = event.a.a.a;
                        return _Utils_update(input, {
                            Fw: model,
                            aa9: $elm$core$Maybe$Just(companyPlan)
                        });
                    case 2:
                        var _v3 = event.a.a;
                        return _Utils_update(input, {
                            Fw: model,
                            aa9: $elm$core$Maybe$Nothing
                        });
                    default:
                        break _v2$2;
                }
                else break _v2$2;
            }
            return _Utils_update(input, {
                Fw: model
            });
        }(), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), event);
    });
    var $author$project$Components$Employee$Form$updateField = F6(function(apiClient, session, company, settings, field, form) {
        switch(field.$){
            case 0:
                var typeMsg = field.a;
                var _v1 = A3($author$project$Components$EmployeeDependentTypeInput$update, apiClient, typeMsg, form.ah5);
                var newTypeInput = _v1.a;
                var newTypeInputCmd = _v1.b;
                var newTypeEvent = _v1.c;
                var _v2 = function() {
                    switch(newTypeEvent.$){
                        case 1:
                            var account = newTypeEvent.a;
                            return _Utils_Tuple2(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$Date$toIsoString, $author$project$Components$Employee$Form$dependentStartDate(account))), $author$project$Api$CompanyAccount$All$status(account) === 'enrolled' ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing);
                        case 0:
                            var type_ = newTypeEvent.a;
                            return type_ === 'employee' ? _Utils_Tuple2($author$project$Components$Employee$Form$nextFirstOfMonth(settings.V7.cP), $elm$core$Maybe$Just(true)) : _Utils_Tuple2('', $elm$core$Maybe$Nothing);
                        default:
                            return _Utils_Tuple2(form.T4, form.OV);
                    }
                }();
                var membershipStartDate = _v2.a;
                var enroll = _v2.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    OV: enroll,
                    T4: membershipStartDate,
                    ah5: newTypeInput
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type), newTypeInputCmd), _List_Nil);
            case 1:
                var patientFormMsg = field.a;
                var _v4 = A5($author$project$Components$Patient$Form$update, apiClient, session, company, patientFormMsg, form.V7);
                var newPatientForm = _v4.a;
                var newPatientFormCmd = _v4.b;
                var newPatientFormOutMsgs = _v4.c;
                return _Utils_Tuple3(_Utils_update(form, {
                    V7: newPatientForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, newPatientFormCmd), newPatientFormOutMsgs);
            case 2:
                var sponsorPlanMsg = field.a;
                var _v5 = A3($author$project$Components$SponsorPlanInput$update, apiClient, sponsorPlanMsg, form.GW);
                var newPlanInput = _v5.a;
                var newPlanInputCmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    GW: newPlanInput
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan), newPlanInputCmd), _List_Nil);
            case 3:
                var startDate = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    T4: startDate
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var dateInputMsg = field.a;
                var _v6 = form.cU;
                var prevValue = _v6.a;
                var prevInput = _v6.b;
                var _v7 = A2($author$project$Components$DateInput$update, dateInputMsg, prevInput);
                var dateInput = _v7.a;
                var dateInputCmd = _v7.b;
                var event = _v7.c;
                var newValue = function() {
                    if (event.$ === 1) {
                        var date = event.a;
                        return date;
                    } else return prevValue;
                }();
                return _Utils_Tuple3(_Utils_update(form, {
                    cU: _Utils_Tuple2(newValue, dateInput)
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate), dateInputCmd), _List_Nil);
            case 5:
                var maybeBool = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    OV: maybeBool
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var externalId = field.a;
                return _Utils_Tuple3(_Utils_update(form, {
                    adE: $elm$core$Maybe$Just(externalId)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var divisionMsg = field.a;
                var _v9 = A2($author$project$Components$EmployeeDivisionInput$update, divisionMsg, form.Oa);
                var divisionInput = _v9.a;
                var divisionInputCmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(form, {
                    Oa: divisionInput
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division), divisionInputCmd), _List_Nil);
        }
    });
    var $author$project$Components$Employee$Form$update = F5(function(apiClient, session, company, msg, _v0) {
        var settings = _v0.a;
        var form = _v0.b;
        if (!msg.$) {
            var subMsg = msg.a;
            return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Components$Employee$Form$EmployeeForm(settings), A3($author$project$Utils$Form$updateWithCmdAndOutMsgs, A4($author$project$Components$Employee$Form$updateField, apiClient, session, company, settings), $author$project$Components$Employee$Form$Patient(subMsg), form));
        } else {
            var field = msg.a;
            return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Components$Employee$Form$EmployeeForm(settings), A3($author$project$Utils$Form$updateWithCmdAndOutMsgs, A4($author$project$Components$Employee$Form$updateField, apiClient, session, company, settings), field, form));
        }
    });
    var $author$project$Components$Employee$Form$EmployeeDivisionValidation = 4;
    var $author$project$Components$Employee$Form$PlanFieldValidation = 2;
    var $author$project$Components$Employee$Form$TypeFieldValidation = 0;
    var $author$project$Components$EmployeeDependentTypeInput$validate = F2(function(getter, formatter) {
        return A2($rtfeldman$elm_validate$Validate$ifFalse, function(model) {
            var _v0 = getter(model);
            var type_ = _v0.ah5;
            var dependentOf = _v0.fx;
            var _v1 = _Utils_Tuple2(type_, dependentOf);
            _v1$2: while(true){
                if (_v1.b.$ === 1) switch(_v1.a){
                    case 'spouse':
                        var _v2 = _v1.b;
                        return false;
                    case 'child':
                        var _v3 = _v1.b;
                        return false;
                    default:
                        break _v1$2;
                }
                else break _v1$2;
            }
            return true;
        }, formatter('Please select an employee'));
    });
    var $author$project$Components$EmployeeDivisionInput$validate = F2(function(getter, formatter) {
        return A2($rtfeldman$elm_validate$Validate$ifFalse, function(model) {
            var _v0 = getter(model);
            var required = _v0.agM;
            var division = _v0.Oa;
            var _v1 = _Utils_Tuple2(required, division);
            if (_v1.a && _v1.b.$ === 1) {
                var _v2 = _v1.b;
                return false;
            } else return true;
        }, formatter('Please select an employee division.'));
    });
    var $author$project$Components$SponsorPlanInput$validate = F2(function(getter, formatter) {
        return A2($rtfeldman$elm_validate$Validate$ifFalse, function(model) {
            var _v0 = getter(model);
            var required = _v0.agM;
            var value = _v0.aa9;
            var _v1 = _Utils_Tuple2(required, value);
            if (_v1.a && _v1.b.$ === 1) {
                var _v2 = _v1.b;
                return false;
            } else return true;
        }, formatter('Please select a plan.'));
    });
    var $author$project$Components$Employee$Form$EligibilityDateValidation = 3;
    var $elm_community$maybe_extra$Maybe$Extra$isJust = function(m) {
        if (m.$ === 1) return false;
        else return true;
    };
    var $author$project$Components$Employee$Form$validateEligibilityDate = F2(function(isNew, _v0) {
        var eligibilityDate = _v0.cU;
        var hasDate = $elm_community$maybe_extra$Maybe$Extra$isJust(eligibilityDate.a);
        return hasDate ? _List_Nil : isNew ? _List_fromArray([
            _Utils_Tuple2(3, 'Please select an eligibility date.')
        ]) : _List_Nil;
    });
    var $author$project$Components$Employee$Form$PatientFieldValidation = 1;
    var $author$project$Components$Patient$Form$hasErrors = function(_v0) {
        var form = _v0.b;
        return $author$project$Utils$Form$hasAnyValidationError(form);
    };
    var $author$project$Components$Employee$Form$validatePatientFields = function(_v0) {
        var patient = _v0.V7;
        var hasErrors = $author$project$Components$Patient$Form$hasErrors(patient);
        return hasErrors ? _List_fromArray([
            _Utils_Tuple2(1, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Employee$Form$validator = F3(function(requiresDivisions, isNew, type_) {
        var typeValidator = isNew ? _List_fromArray([
            A2($author$project$Components$EmployeeDependentTypeInput$validate, function($) {
                return $.ah5;
            }, function(error) {
                return _Utils_Tuple2(0, error);
            })
        ]) : _List_Nil;
        var planValidator = isNew && type_ === 'employee' ? _List_fromArray([
            A2($author$project$Components$SponsorPlanInput$validate, function($) {
                return $.GW;
            }, function(error) {
                return _Utils_Tuple2(2, error);
            })
        ]) : _List_Nil;
        var eligibilityDateValidator = isNew ? _List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Employee$Form$validateEligibilityDate(isNew))
        ]) : _List_Nil;
        var divisionValidator = requiresDivisions ? _List_fromArray([
            A2($author$project$Components$EmployeeDivisionInput$validate, function($) {
                return $.Oa;
            }, function(error) {
                return _Utils_Tuple2(4, error);
            })
        ]) : _List_Nil;
        var validators = A2($elm$core$List$cons, $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Employee$Form$validatePatientFields), _Utils_ap(typeValidator, _Utils_ap(planValidator, _Utils_ap(divisionValidator, eligibilityDateValidator))));
        return $rtfeldman$elm_validate$Validate$all(validators);
    });
    var $author$project$Components$Employee$Form$validate = function(_v0) {
        var settings = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        var patientForm = function() {
            var _v1 = $author$project$Components$Patient$Form$validate(fields.V7);
            if (!_v1.$) {
                var _v2 = _v1.a;
                var newForm = _v2.a;
                return newForm;
            } else {
                var newForm = _v1.a;
                return newForm;
            }
        }();
        return A2($elm$core$Result$mapError, $author$project$Components$Employee$Form$EmployeeForm(settings), A2($elm$core$Result$map, $elm$core$Tuple$mapFirst($author$project$Components$Employee$Form$EmployeeForm(settings)), A2($author$project$Utils$Form$validate, A3($author$project$Components$Employee$Form$validator, settings.xt.YJ, fields.iZ, $author$project$Components$EmployeeDependentTypeInput$selectedType(fields.ah5)), A2($author$project$Utils$Form$set, _Utils_update(fields, {
            V7: patientForm
        }), form))));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A5($author$project$Components$Employee$Form$update, model.Ej, model.Z$, $elm$core$Maybe$Just(model.acy), subMsg, model.ao);
                var form = _v1.a;
                var formCmd = _v1.b;
                var formOutMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    ao: form
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg, formCmd), formOutMsgs);
            case 1:
                var _v2 = $author$project$Components$Employee$Form$validate(model.ao);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validForm = _v3.a;
                    var validFields = _v3.b;
                    var cmd = function() {
                        var _v4 = $author$project$Components$Employee$Form$dependentOf(model.ao);
                        if (!_v4.$) {
                            var account = _v4.a;
                            return A6($author$project$Api$CompanyRegistration$create, model.Ej, model.Z$, model.aef, $author$project$Api$CompanyAccount$All$id(account), A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm), $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated($author$project$Api$CompanyAccount$All$id(account)));
                        } else return A5($author$project$Api$CompanyAccount$create, model.Ej, model.Z$, model.aef, A2($author$project$Components$Employee$Form$encodeAccount, validFields, validForm), $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyAccountCreated);
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        km: true
                    }), cmd, _List_Nil);
                } else {
                    var erroredForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ao: erroredForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                var _v5 = _Utils_Tuple2($author$project$Components$Employee$Form$validate(model.ao), response);
                _v5$2: while(true)switch(_v5.b.$){
                    case 3:
                        if (!_v5.a.$) {
                            var _v6 = _v5.a.a;
                            var validForm = _v6.a;
                            var validFields = _v6.b;
                            var _v7 = _v5.b;
                            var account = _v7.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                Ij: response
                            }), A6($author$project$Api$CompanyRegistration$create, model.Ej, model.Z$, model.aef, $author$project$Api$CompanyAccount$One$id(account), A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm), $author$project$Pages$Companies$CompanyId_String$Employees$Create$CompanyRegistrationCreated($author$project$Api$CompanyAccount$One$id(account))), _List_Nil);
                        } else break _v5$2;
                    case 2:
                        var error = _v5.b.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Ij: response,
                            km: false
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        break _v5$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    Ij: response,
                    km: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var accountId = msg.a;
                var response = msg.b;
                var _v8 = _Utils_Tuple2($author$project$Components$Employee$Form$validate(model.ao), response);
                _v8$2: while(true)switch(_v8.b.$){
                    case 3:
                        if (!_v8.a.$) {
                            var _v9 = _v8.a.a;
                            var validForm = _v9.a;
                            var validFields = _v9.b;
                            var _v10 = _v8.b;
                            var registration = _v10.a;
                            var _v11 = $author$project$Components$Employee$Form$shouldEnroll(model.ao) ? _Utils_Tuple2(A5($author$project$Api$CompanyRegistration$enroll, model.Ej, model.Z$, {
                                eW: accountId,
                                fl: model.aef,
                                nV: $author$project$Api$CompanyRegistration$One$id(registration)
                            }, A2($author$project$Components$Employee$Form$encodeEnroll, validFields, validForm), $author$project$Pages$Companies$CompanyId_String$Employees$Create$RegistrationEnrolled), _List_Nil) : _Utils_Tuple2(A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                fl: model.aef
                            })), _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Patient created!')
                            ]));
                            var cmd = _v11.a;
                            var outMsg = _v11.b;
                            return _Utils_Tuple3(model, cmd, outMsg);
                        } else break _v8$2;
                    case 2:
                        var error = _v8.b.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        break _v8$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    km: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var registration = response.a;
                        var createAffiliationCmd = A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg, A4($author$project$Components$Employee$Form$createEmployeeAffiliation, model.Ej, model.Z$, registration, model.ao));
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                fl: model.aef
                            })),
                            createAffiliationCmd
                        ])), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Patient created!')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$FormSubmitted = {
        $: 1
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText = function(form) {
        var _v0 = _Utils_Tuple2($author$project$Components$Employee$Form$dependentOf(form), $author$project$Components$Employee$Form$shouldEnroll(form));
        if (_v0.a.$ === 1) {
            if (_v0.b) {
                var _v1 = _v0.a;
                return 'Create and Enroll Employee';
            } else {
                var _v2 = _v0.a;
                return 'Create Employee';
            }
        } else {
            if (_v0.b) return 'Create and Enroll Dependent';
            else return 'Create Dependent';
        }
    };
    var $elm_community$list_extra$List$Extra$splitAt = F2(function(n, xs) {
        return _Utils_Tuple2(A2($elm$core$List$take, n, xs), A2($elm$core$List$drop, n, xs));
    });
    var $author$project$Api$Patient$Meta$chosenFirstName = function(_v0) {
        var fields = _v0.a;
        return fields.Lc;
    };
    var $author$project$Api$Patient$Meta$dob = function(_v0) {
        var fields = _v0.a;
        return fields.add;
    };
    var $author$project$Api$Patient$Meta$firstName = function(_v0) {
        var fields = _v0.a;
        return fields.PN;
    };
    var $author$project$Api$Patient$Meta$gender = function(_v0) {
        var fields = _v0.a;
        return fields.P5;
    };
    var $author$project$Api$Patient$Meta$genderIdentity = function(_v0) {
        var fields = _v0.a;
        return fields.P6;
    };
    var $author$project$Api$Patient$Meta$healthInsuranceCarrier = function(_v0) {
        var fields = _v0.a;
        return fields.QD;
    };
    var $author$project$Api$Patient$Meta$joinedPracticeDate = function(_v0) {
        var fields = _v0.a;
        return fields.SK;
    };
    var $author$project$Api$Patient$Meta$leadSourceId = function(_v0) {
        var fields = _v0.a;
        return fields.S2;
    };
    var $author$project$Api$Patient$Meta$locationId = function(_v0) {
        var fields = _v0.a;
        return fields.Tp;
    };
    var $author$project$Api$Patient$Meta$practitionerId = function(_v0) {
        var fields = _v0.a;
        return fields.Xa;
    };
    var $author$project$Api$Patient$Meta$pronouns = function(_v0) {
        var fields = _v0.a;
        return fields.XG;
    };
    var $author$project$Api$Patient$Meta$sex = function(_v0) {
        var fields = _v0.a;
        return fields.Z3;
    };
    var $author$project$Api$Patient$Meta$usesTobacco = function(_v0) {
        var fields = _v0.a;
        return fields.aa4;
    };
    var $author$project$Ui$Form$Group$Test = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$test = function(dataTest) {
        return $author$project$Ui$Form$Group$Test(dataTest);
    };
    var $author$project$Components$Patient$Form$viewAddressField = function(address) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Address'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$margin(0),
            $author$project$Ui$Form$Group$test('address')
        ]), _List_fromArray([
            A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address), A2($author$project$Components$AddressInput$view, _List_Nil, address))
        ]));
    };
    var $author$project$Components$ResourceFilter$Affiliate$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$AffiliateInput$view = function(_v0) {
        var filter = _v0.Fw;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$Affiliate$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0)
            ]), filter))
        ]));
    };
    var $author$project$Components$Patient$Form$viewAffiliateField = function(affiliate) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Primary Care Clinic'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('affiliate')
        ]), _List_fromArray([
            A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate), $author$project$Components$AffiliateInput$view(affiliate))
        ]));
    };
    var $author$project$Components$Patient$Form$viewBillingAddressField = F3(function(_v0, usesBillingAddress, billingAddress) {
        var billingAsShipping = _v0.ab1;
        var _v1 = _Utils_Tuple2(usesBillingAddress, billingAddress);
        if (_v1.a && !_v1.b.$) {
            var address = _v1.b.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label((billingAsShipping ? 'Shipping' : 'Billing') + ' Address'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpanMd(8),
                $author$project$Ui$Form$Group$test('billing-address')
            ]), _List_fromArray([
                A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress), A2($author$project$Components$AddressInput$view, _List_Nil, address))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Patient$Form$ChosenName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$NameInput$disable = F2(function(disable_, _v0) {
        var errors = _v0.a;
        var options = _v0.b;
        var fields = _v0.c;
        return A3($author$project$Components$NameInput$Model, errors, _Utils_update(options, {
            d$: disable_
        }), fields);
    });
    var $author$project$Components$NameInput$test = F2(function(string, _v0) {
        var errors = _v0.a;
        var options = _v0.b;
        var fields = _v0.c;
        return A3($author$project$Components$NameInput$Model, errors, _Utils_update(options, {
            tp: string
        }), fields);
    });
    var $author$project$Components$NameInput$FieldUpdated = $elm$core$Basics$identity;
    var $author$project$Components$NameInput$FirstName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$NameInput$LastName = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$NameInput$MiddleName = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$NameInput$Suffix = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$NameInput$Title = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$NameInput$errorsForGroup = F2(function(validation, errors) {
        return A2($elm$core$List$filterMap, function(_v0) {
            var errValidation = _v0.a;
            var errMessage = _v0.b;
            return _Utils_eq(validation, errValidation) ? $elm$core$Maybe$Just(errMessage) : $elm$core$Maybe$Nothing;
        }, errors);
    });
    var $author$project$Components$NameInput$groupHasErrors = F2(function(validationGroup, errors) {
        return !$elm$core$List$isEmpty(A2($author$project$Components$NameInput$errorsForGroup, validationGroup, errors));
    });
    var $author$project$Components$NameInput$titleOptions = _List_fromArray([
        'Ms.',
        'Mrs.',
        'Miss',
        'Mr.',
        'Dr.',
        'Mx.'
    ]);
    var $author$project$Components$NameInput$view = function(_v0) {
        var errors = _v0.a;
        var disabled = _v0.b.d$;
        var testStr = _v0.b.tp;
        var fields = _v0.c;
        var _v1 = fields;
        var title = _v1.$2;
        var firstName = _v1.PN;
        var middleName = _v1.Uh;
        var lastName = _v1.SU;
        var suffix = _v1.$w;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(title)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$Title)),
                    $author$project$Ui$Form$Select$disabled(disabled)
                ]), A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), ''), A2($elm$core$List$map, function(option) {
                    return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(option), option);
                }, $author$project$Components$NameInput$titleOptions)))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(3),
                $author$project$Ui$Grid$spanSm(6)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(firstName),
                    $author$project$Ui$Form$Input$placeholder('First'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$FirstName)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Components$NameInput$errorsForGroup, 0, errors)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Components$NameInput$groupHasErrors, 0, errors)),
                    $author$project$Ui$Form$Input$disabled(disabled),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$test(testStr + '-first-name')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2),
                $author$project$Ui$Grid$spanSm(4)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(middleName),
                    $author$project$Ui$Form$Input$placeholder('M'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$MiddleName)),
                    $author$project$Ui$Form$Input$disabled(disabled),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$test(testStr + '-middle-name')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(3),
                $author$project$Ui$Grid$spanSm(7)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(lastName),
                    $author$project$Ui$Form$Input$placeholder('Last'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$LastName)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Components$NameInput$errorsForGroup, 1, errors)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Components$NameInput$groupHasErrors, 1, errors)),
                    $author$project$Ui$Form$Input$disabled(disabled),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$ariaLabel('Last Name'),
                    $author$project$Ui$Form$Input$test(testStr + '-last-name')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2),
                $author$project$Ui$Grid$spanSm(5)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', suffix)),
                    $author$project$Ui$Form$Input$placeholder('Suffix'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$NameInput$Suffix), $elm$core$Maybe$Just)),
                    $author$project$Ui$Form$Input$disabled(disabled),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$ariaLabel('Suffix'),
                    $author$project$Ui$Form$Input$test(testStr + '-suffix')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Patient$Form$withinTooltipIf = F2(function(maybeExplanation, content) {
        if (!maybeExplanation.$) {
            var explanation = maybeExplanation.a;
            return A3($author$project$Ui$Tooltip$view, _List_Nil, explanation, _List_fromArray([
                content
            ]));
        } else return content;
    });
    var $author$project$Components$Patient$Form$viewChosenNameField = F2(function(metaField, maybeChosenName) {
        if (!maybeChosenName.$) {
            var chosenName = maybeChosenName.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Chosen Name'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpanMd(8),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$test('chosen-name')
            ]), _List_fromArray([
                A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$ChosenName), $author$project$Components$NameInput$view(A2($author$project$Components$NameInput$test, 'chosen-name', A2($author$project$Components$NameInput$disable, $author$project$Utils$MetaFields$isUneditable(metaField), chosenName)))))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Patient$Form$DateOfBirthBlur = {
        $: 4
    };
    var $author$project$Components$Patient$Form$viewDateOfBirthField = F4(function(metaField, _v0, errors, dateOfBirth) {
        var requiresDOB = _v0.B8;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Date of Birth'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$required(requiresDOB),
            $author$project$Ui$Form$Group$test('date-of-birth')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$phi(true),
                $author$project$Ui$Form$Input$placeholder('mm/dd/yyyy'),
                A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$Patient$Form$datePattern, dateOfBirth),
                A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Components$Patient$Form$datePattern, dateOfBirth, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$DateOfBirth)),
                $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(metaField)),
                $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(errors)),
                $author$project$Ui$Form$Input$onBlur($author$project$Components$Patient$Form$DateOfBirthBlur)
            ])))
        ]));
    });
    var $author$project$Components$Patient$Form$Email = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$viewEmailField = F3(function(_v0, errors, email) {
        var requiresEmail = _v0.agQ;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Email'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$required(requiresEmail),
            $author$project$Ui$Form$Group$test('email')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$phi(true),
                $author$project$Ui$Form$Input$placeholder('joe@example.com'),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', email)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Email), $author$project$Utils$String$toMaybe)),
                $author$project$Ui$Form$Input$errors(errors),
                $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(errors))
            ]))
        ]));
    });
    var $author$project$Components$EmergencyContactInput$Email = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$EmergencyContactInput$FirstName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$EmergencyContactInput$LastName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$EmergencyContactInput$Relationship = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$EmergencyContactInput$relationshipToLabel = function(rel) {
        if (rel.$ === 1) return 'None';
        else switch(rel.a.$){
            case 0:
                var _v1 = rel.a;
                return 'Spouse';
            case 1:
                var _v2 = rel.a;
                return 'Parent';
            case 2:
                var _v3 = rel.a;
                return 'Child';
            case 3:
                var _v4 = rel.a;
                return 'Sibling';
            case 4:
                var _v5 = rel.a;
                return 'Grandparent';
            case 5:
                var _v6 = rel.a;
                return 'Guardian';
            default:
                return 'Other';
        }
    };
    var $author$project$Components$EmergencyContactInput$relationshipOptions = function(selected) {
        var relationshipToItem = function(rel) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(selected, rel)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$EmergencyContactInput$FieldChanged($author$project$Components$EmergencyContactInput$Relationship(rel)))
            ]), $elm$html$Html$text($author$project$Components$EmergencyContactInput$relationshipToLabel(rel)));
        };
        return A2($elm$core$List$map, relationshipToItem, function(someOptions) {
            return A2($elm$core$List$cons, $elm$core$Maybe$Nothing, someOptions);
        }(A2($elm$core$List$map, $elm$core$Maybe$Just, _List_fromArray([
            $author$project$Components$EmergencyContactInput$Spouse,
            $author$project$Components$EmergencyContactInput$Parent,
            $author$project$Components$EmergencyContactInput$Child,
            $author$project$Components$EmergencyContactInput$Sibling,
            $author$project$Components$EmergencyContactInput$Grandparent,
            $author$project$Components$EmergencyContactInput$Guardian,
            $author$project$Components$EmergencyContactInput$Other('')
        ]))));
    };
    var $author$project$Components$EmergencyContactInput$view = function(_v0) {
        var form = _v0.PU;
        var relationshipDropdown = _v0.nW;
        var emergencyContact = $author$project$Utils$Form$fields(form);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(4)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$placeholder('First Name'),
                        $author$project$Ui$Form$Input$phi(true),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$FirstName)),
                        $author$project$Ui$Form$Input$value(emergencyContact.PN),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(4)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$placeholder('Last Name'),
                        $author$project$Ui$Form$Input$phi(true),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$LastName)),
                        $author$project$Ui$Form$Input$value(emergencyContact.SU),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(4)
                ]), _List_fromArray([
                    A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                        $author$project$Ui$Dropdown$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                    ]), _List_fromArray([
                        $elm$html$Html$text(function() {
                            var _v1 = emergencyContact.Yu;
                            if (!_v1.$) {
                                var rel = _v1.a;
                                return $author$project$Components$EmergencyContactInput$relationshipToLabel($elm$core$Maybe$Just(rel));
                            } else return 'Select a relationship';
                        }())
                    ]), $author$project$Components$EmergencyContactInput$relationshipOptions(emergencyContact.Yu), relationshipDropdown)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            function() {
                var _v2 = emergencyContact.Yu;
                if (!_v2.$ && _v2.a.$ === 6) {
                    var other = _v2.a.a;
                    return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(12)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$placeholder('Relationship'),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Relationship), $elm$core$Maybe$Just), $author$project$Components$EmergencyContactInput$Other)),
                                $author$project$Ui$Form$Input$value(other),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form))
                            ]))
                        ]))
                    ]));
                } else return $elm$html$Html$text('');
            }(),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Phone), $author$project$Components$PhoneInput$view(emergencyContact.WE))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$phi(true),
                        $author$project$Ui$Form$Input$placeholder('Email'),
                        $author$project$Ui$Form$Input$value(emergencyContact.OH),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$EmergencyContactInput$FieldChanged, $author$project$Components$EmergencyContactInput$Email)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form))
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, form))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Patient$Form$viewEmergencyContact = function(emergencyContact) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Emergency Contact'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('emergency-contacts')
        ]), _List_fromArray([
            A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$EmergencyContact), $author$project$Components$EmergencyContactInput$view(emergencyContact))
        ]));
    };
    var $author$project$Components$Patient$Form$Gender = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$GenderOther = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$viewGenderField = F3(function(metaField, gender, genderOther) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Sex'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('gender')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), $author$project$Ui$Form$Gender$view(_List_fromArray([
                $author$project$Ui$Form$Gender$gender(gender),
                $author$project$Ui$Form$Gender$genderOther(genderOther),
                $author$project$Ui$Form$Gender$onGenderChange(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Gender)),
                $author$project$Ui$Form$Gender$onGenderOtherChange(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$GenderOther)),
                $author$project$Ui$Form$Gender$disabled($author$project$Utils$MetaFields$isUneditable(metaField))
            ])))
        ]));
    });
    var $author$project$Components$Patient$Form$GenderIdentity = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$GenderIdentityOther = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$GenderIdentity$Man = {
        $: 0
    };
    var $author$project$Api$GenderIdentity$NonBinary = {
        $: 2
    };
    var $author$project$Api$GenderIdentity$TransMan = {
        $: 3
    };
    var $author$project$Api$GenderIdentity$TransWoman = {
        $: 4
    };
    var $author$project$Api$GenderIdentity$Woman = {
        $: 1
    };
    var $author$project$Api$GenderIdentity$all = _List_fromArray([
        $author$project$Api$GenderIdentity$Man,
        $author$project$Api$GenderIdentity$Woman,
        $author$project$Api$GenderIdentity$NonBinary,
        $author$project$Api$GenderIdentity$TransMan,
        $author$project$Api$GenderIdentity$TransWoman,
        $author$project$Api$GenderIdentity$NotListed('')
    ]);
    var $author$project$Api$GenderIdentity$fromString = F2(function(notListedString, genderIdentity) {
        var _v0 = $elm$core$String$toLower(genderIdentity);
        switch(_v0){
            case 'man':
                return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$Man);
            case 'woman':
                return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$Woman);
            case 'non-binary':
                return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$NonBinary);
            case 'trans man':
                return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$TransMan);
            case 'trans woman':
                return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$TransWoman);
            case 'not listed':
                return $elm$core$Maybe$Just($author$project$Api$GenderIdentity$NotListed(notListedString));
            default:
                return $elm$core$Maybe$Nothing;
        }
    });
    var $author$project$Components$Patient$Form$viewGenderIdentityField = F3(function(metaField, maybeGenderOther, genderIdentity) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Gender Identity'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('gender-identity')
        ]), A2($elm$core$List$cons, A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($author$project$Ui$Form$Select$view, _List_fromArray([
            $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$GenderIdentity$toString, genderIdentity)),
            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeR, $author$project$Api$GenderIdentity$fromString(A2($elm$core$Maybe$withDefault, '', maybeGenderOther)), A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$GenderIdentity, $author$project$Components$Patient$Form$FieldUpdated))),
            $author$project$Ui$Form$Select$disabled($author$project$Utils$MetaFields$isUneditable(metaField))
        ]), A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), ''), A2($elm$core$List$map, function(option) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(option), $elm_community$string_extra$String$Extra$toTitleCase(option));
        }, A2($elm$core$List$map, $author$project$Api$GenderIdentity$toString, $author$project$Api$GenderIdentity$all))))), function() {
            if (!genderIdentity.$ && genderIdentity.a.$ === 5) {
                var other = genderIdentity.a.a;
                return _List_fromArray([
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(other),
                        $author$project$Ui$Form$Input$placeholder('Description'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$GenderIdentityOther)),
                        $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(metaField))
                    ])))
                ]);
            } else return _List_fromArray([
                $author$project$Utils$Html$empty
            ]);
        }()));
    });
    var $author$project$Components$HealthInsuranceInput$disable = F2(function(disabled, _v0) {
        var filter = _v0.a;
        var options = _v0.b;
        var healthInsurance = _v0.c;
        return A3($author$project$Components$HealthInsuranceInput$Model, filter, _Utils_update(options, {
            d$: disabled
        }), healthInsurance);
    });
    var $author$project$Components$HealthInsuranceInput$OtherNameUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$HealthInsuranceInput$GroupIdUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$HealthInsuranceInput$viewGroupIdField = F2(function(options, maybeValue) {
        if (!maybeValue.$) {
            var value = maybeValue.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Group Id')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(value),
                    $author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$GroupIdUpdated),
                    $author$project$Ui$Form$Input$placeholder('3207524'),
                    $author$project$Ui$Form$Input$disabled(options.d$),
                    $author$project$Ui$Form$Input$phi(true)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$HealthInsuranceInput$DeductibleUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$HealthInsuranceInput$viewHighDeductibleField = F2(function(options, maybeValue) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('High deductible')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Is this a high-deductible plan?')
            ])),
            function() {
                if (!maybeValue.$) {
                    var deductible = maybeValue.a;
                    return $author$project$Ui$Button$group(_List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Yes, this is a high-deductible plan'
                        }, _List_fromArray([
                            $author$project$Ui$Button$active(deductible),
                            $author$project$Ui$Button$onClick($author$project$Components$HealthInsuranceInput$DeductibleUpdated(true)),
                            $author$project$Ui$Button$disabled(options.d$)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Yes')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'No, this is not a high-deductible plan'
                        }, _List_fromArray([
                            $author$project$Ui$Button$active(!deductible),
                            $author$project$Ui$Button$onClick($author$project$Components$HealthInsuranceInput$DeductibleUpdated(false)),
                            $author$project$Ui$Button$disabled(options.d$)
                        ]), _List_fromArray([
                            $elm$html$Html$text('No')
                        ]))
                    ]));
                } else return $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Yes, this is a high-deductible plan'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$HealthInsuranceInput$DeductibleUpdated(true)),
                        $author$project$Ui$Button$disabled(options.d$)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Yes')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'No, this is not a high-deductible plan'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$HealthInsuranceInput$DeductibleUpdated(false)),
                        $author$project$Ui$Button$disabled(options.d$)
                    ]), _List_fromArray([
                        $elm$html$Html$text('No')
                    ]))
                ]));
            }()
        ]));
    });
    var $author$project$Components$HealthInsuranceInput$MemberIdUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$HealthInsuranceInput$viewMemberIdField = F2(function(options, maybeValue) {
        if (!maybeValue.$) {
            var value = maybeValue.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Member Id')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(value),
                    $author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$MemberIdUpdated),
                    $author$project$Ui$Form$Input$placeholder('A22222222'),
                    $author$project$Ui$Form$Input$disabled(options.d$),
                    $author$project$Ui$Form$Input$phi(true)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$HealthInsuranceInput$view = function(_v0) {
        var filter = _v0.a;
        var options = _v0.b;
        var maybeCarrierAndInsurance = _v0.c;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$HealthInsuranceInput$FilterMsg, A2($author$project$Components$ResourceFilter$InsuranceCarrierAlias$view, _List_fromArray([
                $author$project$Components$ResourceFilter$disabled(options.d$)
            ]), filter)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$core$Basics$always(A2($elm$html$Html$br, _List_Nil, _List_Nil)), maybeCarrierAndInsurance)),
            function() {
                if (!maybeCarrierAndInsurance.$ && maybeCarrierAndInsurance.a.a.$ === 1) {
                    var _v2 = maybeCarrierAndInsurance.a;
                    var name = _v2.a.a.zr;
                    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Carrier\'s Name'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(name),
                                $author$project$Ui$Form$Input$onInput($author$project$Components$HealthInsuranceInput$OtherNameUpdated),
                                $author$project$Ui$Form$Input$disabled(options.d$)
                            ]))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                if (!maybeCarrierAndInsurance.$) {
                    var _v4 = maybeCarrierAndInsurance.a;
                    var groupId = _v4.b.Qf;
                    var memberId = _v4.b.TV;
                    var highDeductible = _v4.b.QJ;
                    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Components$HealthInsuranceInput$viewGroupIdField, options, groupId),
                        A2($author$project$Components$HealthInsuranceInput$viewMemberIdField, options, memberId),
                        A2($author$project$Components$HealthInsuranceInput$viewHighDeductibleField, options, highDeductible)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Patient$Form$viewHealthInsuranceField = F2(function(metaField, healthInsurance) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Health Insurance'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('health-insurance')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance), $author$project$Components$HealthInsuranceInput$view(A2($author$project$Components$HealthInsuranceInput$disable, $author$project$Utils$MetaFields$isUneditable(metaField), healthInsurance))))
        ]));
    });
    var $author$project$Components$Patient$Form$viewJoinedPracticeField = F2(function(metaField, _v0) {
        var joinedPractice = _v0.a;
        var dateInput = _v0.b;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Joined Practice'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('joined-practice')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice), A2($author$project$Components$DateInput$view, _List_fromArray([
                $author$project$Components$DateInput$value(joinedPractice),
                $author$project$Components$DateInput$disabled($author$project$Utils$MetaFields$isUneditable(metaField))
            ]), dateInput)))
        ]));
    });
    var $author$project$Components$KnownPracticeInput$Errors = $elm$core$Basics$identity;
    var $author$project$Components$KnownPracticeInput$errors = $elm$core$Basics$identity;
    var $author$project$Components$KnownPracticeInput$OtherNameUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$KnownPracticeInput$OtherWebsiteUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$KnownPracticeInput$optionToRecord = F2(function(option, acc) {
        var errors_ = option;
        return _Utils_update(acc, {
            fK: errors_
        });
    });
    var $author$project$Components$ResourceFilter$KnownPractice$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$KnownPracticeInput$view = F2(function(options, _v0) {
        var filter = _v0.a;
        var knownPractice = _v0.b;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$KnownPracticeInput$FilterMsg, A2($author$project$Components$ResourceFilter$KnownPractice$view, _List_Nil, filter)),
            function() {
                if (!knownPractice.$ && knownPractice.a.$ === 1) {
                    var name = knownPractice.a.a.zr;
                    var website = knownPractice.a.a.D0;
                    var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$KnownPracticeInput$optionToRecord, {
                        fK: _List_Nil
                    }, options);
                    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Your DPC Name'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(name),
                                $author$project$Ui$Form$Input$onInput($author$project$Components$KnownPracticeInput$OtherNameUpdated),
                                $author$project$Ui$Form$Input$errors(optionsRecord.fK),
                                $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(optionsRecord.fK))
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('DPC Website'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(website),
                                $author$project$Ui$Form$Input$onInput($author$project$Components$KnownPracticeInput$OtherWebsiteUpdated)
                            ]))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Patient$Form$viewKnownPracticeField = F2(function(errors, knownPractice) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('DPC Practice'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('known-practice')
        ]), _List_fromArray([
            A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice), A2($author$project$Components$KnownPracticeInput$view, _List_fromArray([
                $author$project$Components$KnownPracticeInput$errors(errors)
            ]), knownPractice))
        ]));
    });
    var $author$project$Components$LeadSourceInput$disable = F2(function(disabled, model) {
        return _Utils_update(model, {
            d$: disabled
        });
    });
    var $author$project$Components$LeadSourceInput$OtherChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$LeadSource$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$LeadSourceInput$view = function(_v0) {
        var other = _v0.c6;
        var disabled = _v0.d$;
        var leadSourceResourceFilter = _v0.mT;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, A2($author$project$Components$ResourceFilter$LeadSource$view, _List_fromArray([
                $author$project$Components$ResourceFilter$disabled(disabled)
            ]), leadSourceResourceFilter)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $elm$core$Basics$always(A2($elm$html$Html$br, _List_Nil, _List_Nil)), other)),
            function() {
                if (!other.$) {
                    var otherText = other.a;
                    return $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(otherText),
                        $author$project$Ui$Form$Input$onInput($author$project$Components$LeadSourceInput$OtherChanged)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Patient$Form$viewLeadSourceField = F2(function(metaField, leadSource) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Lead Source'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('lead-source')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource), $author$project$Components$LeadSourceInput$view(A2($author$project$Components$LeadSourceInput$disable, $author$project$Utils$MetaFields$isUneditable(metaField), leadSource))))
        ]));
    });
    var $author$project$Components$Patient$Form$DifferentChosenNameClicked = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$LegalName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$viewLegalNameField = F3(function(metaField, chosenNameIsDifferent, legalName) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Legal Name'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$test('legal-name')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LegalName), $author$project$Components$NameInput$view(A2($author$project$Components$NameInput$test, 'legal-name', A2($author$project$Components$NameInput$disable, $author$project$Utils$MetaFields$isUneditable(metaField), legalName))))),
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(chosenNameIsDifferent),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Patient$Form$DifferentChosenNameClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Chosen name is different')
            ]))
        ]));
    });
    var $author$project$Components$LocationInput$disable = F2(function(disabled, input) {
        return _Utils_update(input, {
            d$: disabled
        });
    });
    var $author$project$Components$LocationInput$Errors = $elm$core$Basics$identity;
    var $author$project$Components$LocationInput$errors = $elm$core$Basics$identity;
    var $author$project$Components$LocationInput$optionToRecord = F2(function(option, acc) {
        var errors_ = option;
        return _Utils_update(acc, {
            fK: errors_
        });
    });
    var $author$project$Components$LocationInput$view = F2(function(options, _v0) {
        var filter = _v0.Fw;
        var disabled = _v0.d$;
        var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$LocationInput$optionToRecord, {
            fK: _List_Nil
        }, options);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0),
                $author$project$Components$ResourceFilter$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)),
                $author$project$Components$ResourceFilter$disabled(disabled)
            ]), filter)),
            $author$project$Utils$FormErrors$view(optionsRecord.fK)
        ]));
    });
    var $author$project$Components$Patient$Form$viewLocationField = F4(function(metaField, required, errors, location1) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Location'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$required(required),
            $author$project$Ui$Form$Group$test('location')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location), A2($author$project$Components$LocationInput$view, _List_fromArray([
                $author$project$Components$LocationInput$errors(errors)
            ]), A2($author$project$Components$LocationInput$disable, $author$project$Utils$MetaFields$isUneditable(metaField), location1))))
        ]));
    });
    var $author$project$Components$Patient$Form$viewPhonesField = F2(function(_v0, phones) {
        var requiresPhone = _v0.agR;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Phones'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$required(requiresPhone),
            $author$project$Ui$Form$Group$test('phones')
        ]), _List_fromArray([
            A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Phones), $author$project$Components$PhoneInput$view(phones))
        ]));
    });
    var $author$project$Components$PractitionerInput$disable = F2(function(disabled, input) {
        return _Utils_update(input, {
            d$: disabled
        });
    });
    var $author$project$Components$PractitionerInput$Errors = $elm$core$Basics$identity;
    var $author$project$Components$PractitionerInput$errors = $elm$core$Basics$identity;
    var $author$project$Components$PractitionerInput$optionToRecord = F2(function(option, acc) {
        var errors_ = option;
        return _Utils_update(acc, {
            fK: errors_
        });
    });
    var $author$project$Components$PractitionerInput$view = F2(function(options, _v0) {
        var filter = _v0.Fw;
        var disabled = _v0.d$;
        var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$PractitionerInput$optionToRecord, {
            fK: _List_Nil
        }, options);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$Practitioner$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0),
                $author$project$Components$ResourceFilter$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)),
                $author$project$Components$ResourceFilter$disabled(disabled)
            ]), filter)),
            $author$project$Utils$FormErrors$view(optionsRecord.fK)
        ]));
    });
    var $author$project$Components$Patient$Form$viewPractitionerField = F4(function(metaField, required, errors, practitioner) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Provider'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$required(required),
            $author$project$Ui$Form$Group$test('provider')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner), A2($author$project$Components$PractitionerInput$view, _List_fromArray([
                $author$project$Components$PractitionerInput$errors(errors)
            ]), A2($author$project$Components$PractitionerInput$disable, $author$project$Utils$MetaFields$isUneditable(metaField), practitioner))))
        ]));
    });
    var $author$project$Components$Patient$Form$PreferredLanguage = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$viewPreferredLanguageField = function(preferredLanguage) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Preferred Language'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('preferred-language')
        ]), _List_fromArray([
            $author$project$Components$LanguageInput$view(_List_fromArray([
                $author$project$Components$LanguageInput$value(preferredLanguage),
                $author$project$Components$LanguageInput$onChange(A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$PreferredLanguage, $author$project$Components$Patient$Form$FieldUpdated))
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('This language will be used on the patient portal and all patient notifications')
            ]))
        ]));
    };
    var $author$project$Components$Patient$Form$ProfilePictureUploaded = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$viewProfilePictureField = F2(function(errors, currentProfilePictureUrl) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Profile Picture'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('profilePicture')
        ]), _List_fromArray([
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$accept(0),
                $author$project$Ui$Form$File$onInput($author$project$Components$Patient$Form$ProfilePictureUploaded),
                $author$project$Ui$Form$File$empty(false)
            ])),
            function() {
                if (!currentProfilePictureUrl.$) {
                    if (currentProfilePictureUrl.a === '') return $author$project$Utils$Html$empty;
                    else {
                        var url = currentProfilePictureUrl.a;
                        return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mt4
                        ]), _List_fromArray([
                            A3($author$project$Ui$Image$fromSrc, {
                                Jg: 'Profile picture'
                            }, url, _List_fromArray([
                                $author$project$Ui$Image$height(50)
                            ])),
                            $author$project$Utils$FormErrors$view(errors)
                        ]));
                    }
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Profile picture will be shown on patient profile.'),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                $elm$html$Html$text('Recommended size: 200x200 px or larger.'),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                $elm$html$Html$text('Supported image files: JPG, PNG.')
            ]))
        ]));
    });
    var $author$project$Components$Patient$Form$Pronoun = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$PronounOther = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Pronoun$HeHimHis = {
        $: 0
    };
    var $author$project$Api$Pronoun$SheHerHers = {
        $: 1
    };
    var $author$project$Api$Pronoun$TheyThemTheirs = {
        $: 2
    };
    var $author$project$Api$Pronoun$all = _List_fromArray([
        $author$project$Api$Pronoun$HeHimHis,
        $author$project$Api$Pronoun$SheHerHers,
        $author$project$Api$Pronoun$TheyThemTheirs,
        $author$project$Api$Pronoun$Other('')
    ]);
    var $author$project$Api$Pronoun$fromString = function(string) {
        switch(string){
            case 'He/Him/His':
                return $elm$core$Maybe$Just($author$project$Api$Pronoun$HeHimHis);
            case 'She/Her/Hers':
                return $elm$core$Maybe$Just($author$project$Api$Pronoun$SheHerHers);
            case 'They/Them/Theirs':
                return $elm$core$Maybe$Just($author$project$Api$Pronoun$TheyThemTheirs);
            case 'Not Listed':
                return $elm$core$Maybe$Just($author$project$Api$Pronoun$Other(''));
            default:
                return $elm$core$Maybe$Just($author$project$Api$Pronoun$Other(string));
        }
    };
    var $author$project$Components$Patient$Form$viewPronounField = F2(function(metaField, pronoun) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Pronoun'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(6),
            $author$project$Ui$Form$Group$test('pronoun')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Pronoun$toString, pronoun)),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Pronoun), $author$project$Api$Pronoun$fromString)),
                $author$project$Ui$Form$Select$disabled($author$project$Utils$MetaFields$isUneditable(metaField))
            ]), A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), ''), A2($elm$core$List$map, function(option) {
                return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(option), option);
            }, A2($elm$core$List$map, $author$project$Api$Pronoun$toString, $author$project$Api$Pronoun$all)))), function() {
                if (!pronoun.$ && pronoun.a.$ === 3) {
                    var other = pronoun.a.a;
                    return _List_fromArray([
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(other),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$PronounOther)),
                            $author$project$Ui$Form$Input$placeholder('Pronoun'),
                            $author$project$Ui$Form$Input$disabled($author$project$Utils$MetaFields$isUneditable(metaField))
                        ]))
                    ]);
                } else return _List_fromArray([
                    $author$project$Utils$Html$empty
                ]);
            }())))
        ]));
    });
    var $author$project$Components$Patient$Form$Sex = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Gender$allWithoutOther = _List_fromArray([
        0,
        1,
        2
    ]);
    var $author$project$Components$Patient$Form$viewSexField = F2(function(metaField, sex) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Sex'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('sex')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($elm$html$Html$span, _List_Nil, A2($elm$core$List$map, function(genderOption) {
                return A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                    $author$project$Ui$Form$Radio$value(A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq(genderOption), sex))),
                    $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Sex), $elm$core$Basics$always(genderOption))),
                    $author$project$Ui$Form$Radio$disabled($author$project$Utils$MetaFields$isUneditable(metaField))
                ]), _List_fromArray([
                    $elm$html$Html$text($elm_community$string_extra$String$Extra$toTitleCase($author$project$Api$Gender$toString(genderOption)))
                ]));
            }, $author$project$Api$Gender$allWithoutOther)))
        ]));
    });
    var $author$project$Components$SocialSecurityNumberInput$Errors = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$SocialSecurityNumberInput$errors = $author$project$Components$SocialSecurityNumberInput$Errors;
    var $author$project$Components$SocialSecurityNumberInput$Invalid = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$SocialSecurityNumberInput$invalid = $author$project$Components$SocialSecurityNumberInput$Invalid;
    var $author$project$Components$SocialSecurityNumberInput$OnInput = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$SocialSecurityNumberInput$onInput = $author$project$Components$SocialSecurityNumberInput$OnInput;
    var $author$project$Components$SocialSecurityNumberInput$Value = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$SocialSecurityNumberInput$value = $author$project$Components$SocialSecurityNumberInput$Value;
    var $author$project$Components$SocialSecurityNumberInput$defaultOptionRecord = {
        fK: _List_Nil,
        q2: false,
        afE: $elm$core$Maybe$Nothing,
        aa9: ''
    };
    var $author$project$Components$SocialSecurityNumberInput$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 1:
                    var handler = option.a;
                    return _Utils_update(record, {
                        afE: $elm$core$Maybe$Just(handler)
                    });
                case 0:
                    var val = option.a;
                    return _Utils_update(record, {
                        aa9: val
                    });
                case 2:
                    var errors_ = option.a;
                    return _Utils_update(record, {
                        fK: errors_
                    });
                default:
                    var invalid_ = option.a;
                    return _Utils_update(record, {
                        q2: invalid_
                    });
            }
        }), $author$project$Components$SocialSecurityNumberInput$defaultOptionRecord, options);
    };
    var $author$project$Components$SocialSecurityNumberInput$view = function(options) {
        var optionsRecord = $author$project$Components$SocialSecurityNumberInput$optionsToRecord(options);
        var onInputAttr = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(handler) {
            return _List_fromArray([
                A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Components$SocialSecurityNumberInput$ssnPattern, optionsRecord.aa9, handler)
            ]);
        }, optionsRecord.afE));
        return $author$project$Ui$Form$Input$view(A2($elm$core$List$cons, A2($author$project$Ui$Form$Input$maskedValue, $author$project$Components$SocialSecurityNumberInput$ssnPattern, optionsRecord.aa9), A2($elm$core$List$cons, $author$project$Ui$Form$Input$placeholder('123-45-6789'), A2($elm$core$List$cons, $author$project$Ui$Form$Input$errors(optionsRecord.fK), A2($elm$core$List$cons, $author$project$Ui$Form$Input$invalid(optionsRecord.q2), A2($elm$core$List$cons, $author$project$Ui$Form$Input$phi(true), onInputAttr))))));
    };
    var $author$project$Components$Patient$Form$viewSsnField = F3(function(errors, requiresSSN, ssn) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('SSN'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(4),
            $author$project$Ui$Form$Group$required(requiresSSN),
            $author$project$Ui$Form$Group$test('ssn')
        ]), _List_fromArray([
            $author$project$Components$SocialSecurityNumberInput$view(_List_fromArray([
                $author$project$Components$SocialSecurityNumberInput$value(ssn),
                $author$project$Components$SocialSecurityNumberInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$SSN)),
                $author$project$Components$SocialSecurityNumberInput$errors(errors),
                $author$project$Components$SocialSecurityNumberInput$invalid(!$elm$core$List$isEmpty(errors))
            ]))
        ]));
    });
    var $author$project$Components$Patient$Form$SyncToEmr = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$viewSyncToEmrField = function(syncToEmr) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Sync to emr'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('sync-to-emr')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(syncToEmr),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$SyncToEmr))
            ]))
        ]));
    };
    var $author$project$Components$Patient$Form$TobaccoUse = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$tobaccoUseFromMaybeString = function(string) {
        switch(string){
            case 'true':
                return $elm$core$Maybe$Just(true);
            case 'false':
                return $elm$core$Maybe$Just(false);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Patient$Form$tobaccoUseToMaybeString = function(maybeBool) {
        return A2($elm$core$Maybe$map, function(bool) {
            return bool ? 'true' : 'false';
        }, maybeBool);
    };
    var $author$project$Components$Patient$Form$viewTobaccoUseField = F2(function(metaField, tobaccoUse) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Tobacco Use'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('tobacco-use')
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Form$withinTooltipIf, $author$project$Utils$MetaFields$explanation(metaField), A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value($author$project$Components$Patient$Form$tobaccoUseToMaybeString(tobaccoUse)),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$TobaccoUse), $author$project$Components$Patient$Form$tobaccoUseFromMaybeString)),
                $author$project$Ui$Form$Select$disabled($author$project$Utils$MetaFields$isUneditable(metaField))
            ]), _List_fromArray([
                A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, ''),
                A3($author$project$Ui$Form$Select$option, _List_Nil, $author$project$Components$Patient$Form$tobaccoUseToMaybeString($elm$core$Maybe$Just(true)), 'Uses tobacco'),
                A3($author$project$Ui$Form$Select$option, _List_Nil, $author$project$Components$Patient$Form$tobaccoUseToMaybeString($elm$core$Maybe$Just(false)), 'Does not use tobacco')
            ])))
        ]));
    });
    var $author$project$Components$Patient$Form$UsesBillingAddress = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Patient$Form$viewUsesBillingAddressField = F2(function(_v0, usesBillingAddress) {
        var billingAsShipping = _v0.ab1;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$test('uses-billing-address')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(usesBillingAddress),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$UsesBillingAddress))
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Use a different address for billing')
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text('This ' + ((billingAsShipping ? 'shipping' : 'billing') + ' address will be shown on all invoices and used for payment processing.'))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Patient$Form$view = function(_v0) {
        var settings = _v0.a;
        var form = _v0.b;
        var ifSetting = F2(function(getter, field) {
            return getter(settings) ? field : $author$project$Utils$Html$empty;
        });
        var fields = $author$project$Utils$Form$fields(form);
        var errorsFor = function(group) {
            return A2($author$project$Utils$Form$validationErrors, group, form);
        };
        var editableField = function(accessor) {
            return A2($elm$core$Maybe$withDefault, $author$project$Utils$MetaFields$alwaysEditable, A2($elm$core$Maybe$map, accessor, settings.Ue));
        };
        return _List_fromArray([
            A3($author$project$Components$Patient$Form$viewLegalNameField, editableField($author$project$Api$Patient$Meta$firstName), $author$project$Utils$Maybe$toBool(fields.br), fields.S4),
            A2($author$project$Components$Patient$Form$viewChosenNameField, editableField($author$project$Api$Patient$Meta$chosenFirstName), fields.br),
            A4($author$project$Components$Patient$Form$viewDateOfBirthField, editableField($author$project$Api$Patient$Meta$dob), settings, errorsFor(10), fields.M7),
            A2(ifSetting, A2($elm$core$Basics$composeR, function($) {
                return $.aas;
            }, $elm$core$Basics$not), A3($author$project$Components$Patient$Form$viewGenderField, editableField($author$project$Api$Patient$Meta$gender), fields.P5, fields.P7)),
            A2(ifSetting, function($) {
                return $.aas;
            }, A2($author$project$Components$Patient$Form$viewSexField, editableField($author$project$Api$Patient$Meta$sex), fields.Z3)),
            A2(ifSetting, function($) {
                return $.aas;
            }, A3($author$project$Components$Patient$Form$viewGenderIdentityField, editableField($author$project$Api$Patient$Meta$genderIdentity), fields.P7, fields.P6)),
            A2(ifSetting, function($) {
                return $.aas;
            }, A2($author$project$Components$Patient$Form$viewPronounField, editableField($author$project$Api$Patient$Meta$pronouns), fields.XF)),
            A3($author$project$Components$Patient$Form$viewEmailField, settings, errorsFor(2), fields.OH),
            A2(ifSetting, function($) {
                return $.ru;
            }, $author$project$Components$Patient$Form$viewPreferredLanguageField(fields.Xh)),
            A2($author$project$Components$Patient$Form$viewProfilePictureField, errorsFor(11), fields.qa),
            A2($author$project$Components$Patient$Form$viewPhonesField, settings, fields.WG),
            $author$project$Components$Patient$Form$viewAddressField(fields.II),
            A2($author$project$Components$Patient$Form$viewUsesBillingAddressField, settings, fields.aa_),
            A3($author$project$Components$Patient$Form$viewBillingAddressField, settings, fields.aa_, fields.Ke),
            $author$project$Components$Patient$Form$viewEmergencyContact(fields.OJ),
            A2(ifSetting, function(_v1) {
                var ssnEnabled = _v1._$;
                var userIsAdmin = _v1.DT;
                var isNew = _v1.iZ;
                return ssnEnabled && (userIsAdmin || isNew);
            }, A3($author$project$Components$Patient$Form$viewSsnField, errorsFor(6), settings.YQ, fields.__)),
            A2(ifSetting, function($) {
                return $.ae_;
            }, A2($author$project$Components$Patient$Form$viewKnownPracticeField, errorsFor(7), fields.SM)),
            A2(ifSetting, function($) {
                return $.ah_;
            }, A2($author$project$Components$Patient$Form$viewTobaccoUseField, editableField($author$project$Api$Patient$Meta$usesTobacco), fields.oO)),
            A2(ifSetting, function($) {
                return $.Qx;
            }, A4($author$project$Components$Patient$Form$viewPractitionerField, editableField($author$project$Api$Patient$Meta$practitionerId), settings.YP, errorsFor(8), fields.agi)),
            A2(ifSetting, function(_v2) {
                var hasLocations = _v2.Qr;
                var trackPatientsByLocation = _v2.aaq;
                return hasLocations && trackPatientsByLocation;
            }, A4($author$project$Components$Patient$Form$viewLocationField, editableField($author$project$Api$Patient$Meta$locationId), settings.YK, errorsFor(9), fields.aeT)),
            A2(ifSetting, function($) {
                return $.$D;
            }, $author$project$Components$Patient$Form$viewAffiliateField(fields.Eb)),
            A2($author$project$Components$Patient$Form$viewJoinedPracticeField, editableField($author$project$Api$Patient$Meta$joinedPracticeDate), fields.i0),
            A2($author$project$Components$Patient$Form$viewHealthInsuranceField, editableField($author$project$Api$Patient$Meta$healthInsuranceCarrier), fields.QC),
            A2($author$project$Components$Patient$Form$viewLeadSourceField, editableField($author$project$Api$Patient$Meta$leadSourceId), fields.S1),
            A2(ifSetting, function($) {
                return $.ab8;
            }, $author$project$Components$Patient$Form$viewSyncToEmrField(fields.$H))
        ]);
    };
    var $author$project$Components$Employee$Form$viewEligibilityDate = F2(function(errors, _v0) {
        var eligibilityDate = _v0.a;
        var dateInput = _v0.b;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Eligibility Date'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$test('eligibility-date')
        ]), _List_fromArray([
            A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate), A2($author$project$Components$DateInput$view, _List_fromArray([
                $author$project$Components$DateInput$value(eligibilityDate),
                $author$project$Components$DateInput$errors(errors)
            ]), dateInput))
        ]));
    });
    var $author$project$Components$EmployeeDivisionInput$Errors = $elm$core$Basics$identity;
    var $author$project$Components$EmployeeDivisionInput$errors = $elm$core$Basics$identity;
    var $author$project$Components$EmployeeDivisionInput$DivisionChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$EmployeeDivisionInput$divisionOptions = function(divisions) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Unassigned'), A2($elm$core$List$map, function(division) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$EmployeeDivision$All$id(division)), $author$project$Api$EmployeeDivision$All$name(division));
        }, divisions));
    };
    var $author$project$Components$EmployeeDivisionInput$optionToRecord = F2(function(option, acc) {
        var errors_ = option;
        return _Utils_update(acc, {
            fK: errors_
        });
    });
    var $author$project$Components$EmployeeDivisionInput$view = F2(function(options, _v0) {
        var employeeDivisions = _v0.xv;
        var division = _v0.Oa;
        if (employeeDivisions.$ === 3) {
            var divisions = employeeDivisions.a;
            var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$EmployeeDivisionInput$optionToRecord, {
                fK: _List_Nil
            }, options);
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(division),
                    $author$project$Ui$Form$Select$onChange($author$project$Components$EmployeeDivisionInput$DivisionChanged),
                    $author$project$Ui$Form$Select$invalid(!$elm$core$List$isEmpty(optionsRecord.fK))
                ]), $author$project$Components$EmployeeDivisionInput$divisionOptions(divisions)),
                $author$project$Utils$FormErrors$view(optionsRecord.fK)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$EmployeeDivisionInput$visible = function(_v0) {
        var employeeDivisions = _v0.xv;
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty), $author$project$Api$Data$toMaybe(employeeDivisions)));
    };
    var $author$project$Components$Employee$Form$viewEmployeeDivision = F3(function(errors, settings, division) {
        return settings.aa1 && $author$project$Components$EmployeeDivisionInput$visible(division) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Division'),
            $author$project$Ui$Form$Group$labelSpanMd(4),
            $author$project$Ui$Form$Group$inputSpanMd(8),
            $author$project$Ui$Form$Group$required(settings.YJ)
        ]), _List_fromArray([
            A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division), A2($author$project$Components$EmployeeDivisionInput$view, _List_fromArray([
                $author$project$Components$EmployeeDivisionInput$errors(errors)
            ]), division))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Employee$Form$viewEmployeeId = F2(function(type_, id) {
        if (!id.$) {
            var id_ = id.a;
            return _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label($author$project$Components$EmployeeDependentTypeInput$selectedType(type_) === 'employee' ? 'Employee ID' : 'Dependent ID'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$required(false),
                    $author$project$Ui$Form$Group$test('registration-id')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(id_)
                    ]))
                ]))
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Employee$Form$ExternalId = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$viewExternalId = function(externalId) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('External ID'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$test('externalId')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', externalId)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$ExternalId))
            ]))
        ]));
    };
    var $author$project$Components$Employee$Form$Enroll = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$MembershipStartDate = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Employee$Form$viewMembershipStartDate = F3(function(currentDate, startDate, maybeEnroll) {
        if (!maybeEnroll.$) {
            var enroll = maybeEnroll.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Membership Start Date'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$test('membership-start-date')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        function() {
                            if (enroll) {
                                var dateOption = function(date) {
                                    return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($justinmimbs$date$Date$toIsoString(date)), A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
                                };
                                var options = A2($elm$core$List$map, dateOption, A4($justinmimbs$date$Date$range, 2, 1, A3($justinmimbs$date$Date$add, 1, -6, currentDate), A3($justinmimbs$date$Date$add, 1, 6, currentDate)));
                                return A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(startDate)),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$MembershipStartDate))
                                ]), options);
                            } else return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Will not be enrolled')
                            ]));
                        }()
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            enroll ? A3($author$project$Ui$Button$view, {
                                abP: 'Do not enroll yet'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Components$Employee$Form$FieldUpdated($author$project$Components$Employee$Form$Enroll($elm$core$Maybe$Just(false))))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Do Not Enroll Yet')
                            ])) : A3($author$project$Ui$Button$view, {
                                abP: 'Set membership start date'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Components$Employee$Form$FieldUpdated($author$project$Components$Employee$Form$Enroll($elm$core$Maybe$Just(true))))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Set membership start date')
                            ]))
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$SponsorPlanInput$Errors = $elm$core$Basics$identity;
    var $author$project$Components$SponsorPlanInput$errors = $elm$core$Basics$identity;
    var $author$project$Components$SponsorPlanInput$optionToRecord = F2(function(option, acc) {
        var errors_ = option;
        return _Utils_update(acc, {
            fK: errors_
        });
    });
    var $author$project$Components$SponsorPlanInput$view = F2(function(options, _v0) {
        var filter = _v0.Fw;
        var disabled = _v0.d$;
        var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$SponsorPlanInput$optionToRecord, {
            fK: _List_Nil
        }, options);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$CompanyPlan$view, _List_fromArray([
                $author$project$Components$ResourceFilter$style(0),
                $author$project$Components$ResourceFilter$invalid(!$elm$core$List$isEmpty(optionsRecord.fK)),
                $author$project$Components$ResourceFilter$disabled(disabled)
            ]), filter)),
            $author$project$Utils$FormErrors$view(optionsRecord.fK)
        ]));
    });
    var $author$project$Components$Employee$Form$viewPlanField = F5(function(required, errors, type_, sponsorPlan, id) {
        var _v0 = _Utils_Tuple2(id, $author$project$Components$EmployeeDependentTypeInput$selectedType(type_));
        if (_v0.a.$ === 1 && _v0.b === 'employee') {
            var _v1 = _v0.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Membership Plan'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(required),
                $author$project$Ui$Form$Group$test('membership-plan')
            ]), _List_fromArray([
                A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan), A2($author$project$Components$SponsorPlanInput$view, _List_fromArray([
                    $author$project$Components$SponsorPlanInput$errors(errors)
                ]), sponsorPlan))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$EmployeeDependentTypeInput$Errors = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$EmployeeDependentTypeInput$errors = $author$project$Components$EmployeeDependentTypeInput$Errors;
    var $author$project$Components$EmployeeDependentTypeInput$Readonly = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$EmployeeDependentTypeInput$readonly = $author$project$Components$EmployeeDependentTypeInput$Readonly;
    var $author$project$Components$EmployeeDependentTypeInput$TypeChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$EmployeeDependentTypeInput$defaultOptions = {
        fK: _List_Nil,
        sq: false
    };
    var $author$project$Components$EmployeeDependentTypeInput$optionToRecord = F2(function(option, acc) {
        if (!option.$) {
            var errors_ = option.a;
            return _Utils_update(acc, {
                fK: errors_
            });
        } else {
            var bool = option.a;
            return _Utils_update(acc, {
                sq: bool
            });
        }
    });
    var $author$project$Components$EmployeeDependentTypeInput$typeLabel = function(type_) {
        switch(type_){
            case 'employee':
                return 'Employee';
            case 'spouse':
                return 'Adult';
            case 'child':
                return 'Child';
            default:
                var somethingElse = type_;
                return somethingElse;
        }
    };
    var $author$project$Components$EmployeeDependentTypeInput$typeOptions = A2($elm$core$List$map, function(type_) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(type_), $author$project$Components$EmployeeDependentTypeInput$typeLabel(type_));
    }, _List_fromArray([
        'employee',
        'spouse',
        'child'
    ]));
    var $author$project$Components$ResourceFilter$CompanyAccount$view = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$view, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$EmployeeDependentTypeInput$view = F2(function(options, _v0) {
        var type_ = _v0.ah5;
        var dependentOfFilter = _v0.d_;
        var dependentOf = _v0.fx;
        var optionsRecord = A3($elm$core$List$foldl, $author$project$Components$EmployeeDependentTypeInput$optionToRecord, $author$project$Components$EmployeeDependentTypeInput$defaultOptions, options);
        return _Utils_Tuple2(optionsRecord.sq ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Components$EmployeeDependentTypeInput$typeLabel(type_))
        ])) : A2($author$project$Ui$Form$Select$view, _List_fromArray([
            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(type_)),
            $author$project$Ui$Form$Select$onChange($author$project$Components$EmployeeDependentTypeInput$TypeChanged)
        ]), $author$project$Components$EmployeeDependentTypeInput$typeOptions), type_ === 'employee' ? $elm$core$Maybe$Nothing : A2($elm$core$Maybe$map, function(filter) {
            return A2($elm$html$Html$div, _List_Nil, optionsRecord.sq ? _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$CompanyAccount$All$subscriberName, dependentOf)))
                ]))
            ]) : _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$EmployeeDependentTypeInput$CompanyAccountFilterMsg, A2($author$project$Components$ResourceFilter$CompanyAccount$view, _List_Nil, filter)),
                $author$project$Utils$FormErrors$view(optionsRecord.fK)
            ]));
        }, dependentOfFilter));
    });
    var $author$project$Components$Employee$Form$viewTypeField = F3(function(isNew, errors, typeInput) {
        var _v0 = A2($author$project$Components$EmployeeDependentTypeInput$view, _List_fromArray([
            $author$project$Components$EmployeeDependentTypeInput$readonly(!isNew),
            $author$project$Components$EmployeeDependentTypeInput$errors(errors)
        ]), typeInput);
        var type_ = _v0.a;
        var maybeDependentOf = _v0.b;
        return A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Type'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$required(!isNew),
            $author$project$Ui$Form$Group$test('registration-type')
        ]), _List_fromArray([
            A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type), type_)
        ])), function() {
            if (!maybeDependentOf.$) {
                var dependentOf_ = maybeDependentOf.a;
                return _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Dependent Of'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$required(!isNew)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type), dependentOf_)
                    ]))
                ]);
            } else return _List_Nil;
        }());
    });
    var $author$project$Components$Employee$Form$view = function(_v0) {
        var settings = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        var patientFields = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Employee$Form$PatientFormMsg), $author$project$Components$Patient$Form$view(fields.V7));
        var externalIdField = _List_fromArray([
            $author$project$Components$Employee$Form$viewExternalId(fields.adE)
        ]);
        var errorsFor = function(group) {
            return A2($author$project$Utils$Form$validationErrors, group, form);
        };
        var otherEmployeeFields = fields.iZ ? _List_fromArray([
            A5($author$project$Components$Employee$Form$viewPlanField, true, errorsFor(2), fields.ah5, fields.GW, fields.aef),
            A3($author$project$Components$Employee$Form$viewMembershipStartDate, settings.V7.cP, fields.T4, fields.OV),
            A2($author$project$Components$Employee$Form$viewEligibilityDate, errorsFor(3), fields.cU)
        ]) : _List_fromArray([
            A3($author$project$Components$Employee$Form$viewMembershipStartDate, settings.V7.cP, fields.T4, fields.OV),
            A2($author$project$Components$Employee$Form$viewEligibilityDate, errorsFor(3), fields.cU)
        ]);
        var divisionField = _List_fromArray([
            A3($author$project$Components$Employee$Form$viewEmployeeDivision, errorsFor(4), settings.xt, fields.Oa)
        ]);
        var _v1 = A2($elm_community$list_extra$List$Extra$splitAt, 2, patientFields);
        var nameFields = _v1.a;
        var otherPatientFields = _v1.b;
        return _Utils_ap(A2($author$project$Components$Employee$Form$viewEmployeeId, fields.ah5, fields.aef), _Utils_ap(externalIdField, _Utils_ap(nameFields, _Utils_ap(A3($author$project$Components$Employee$Form$viewTypeField, fields.iZ, errorsFor(0), fields.ah5), _Utils_ap(divisionField, _Utils_ap(otherPatientFields, otherEmployeeFields))))));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Employees$Create$FormSubmitted)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                    fl: model.aef
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('All Employees & Dependents')
                                ])),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$gray
                                ]), _List_fromArray([
                                    $elm$html$Html$text('  /  New Employee or Dependent')
                                ]))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                                $author$project$Ui$HorizontalRule$thin
                            ])),
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('New Employee or Dependent')
                            ])),
                            A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Companies$CompanyId_String$Employees$Create$FormMsg), $author$project$Components$Employee$Form$view(model.ao)))
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                fl: model.aef
                            }), _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: $author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText(model.ao)
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(model.km)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Pages$Companies$CompanyId_String$Employees$Create$buttonText(model.ao))
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + (' | ' + model.aef)
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Create$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Employees$Create$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Employees$Create$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Employees$Create$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Employees$Create$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Employees$Create$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Employees$Create$view
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyAccount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyRegistration = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$retrieve = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyAccount$companyAccountPath(id)));
    });
    var $author$project$Api$CompanyAccount$retrieve = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$CompanyAccount$retrieve, apiClient, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A5($author$project$Api$Provider$Company$Account$retrieve, apiClient, companyId, id, $elm$core$Basics$identity, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyRegistration$retrieve = F4(function(apiClient, accountId, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$CompanyRegistration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, id)));
    });
    var $author$project$Api$Provider$Company$Registration$retrieve = F5(function(apiClient, companyId, companyAccountId, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CompanyRegistration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, id)));
    });
    var $author$project$Api$CompanyRegistration$retrieve = F6(function(apiClient, session, companyId, companyAccoutId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyRegistration$retrieve, apiClient, companyAccoutId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5($author$project$Api$Provider$Company$Registration$retrieve, apiClient, companyId, companyAccoutId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var model = {
            Ej: shared.Ej,
            acy: company,
            LI: $author$project$Api$Data$Loading,
            LJ: params.adk,
            fl: params.fl,
            LP: $author$project$Api$Data$Loading,
            ER: params.ac2,
            cP: shared.cP,
            ao: $elm$core$Maybe$Nothing,
            aeb: shared.aeb,
            Ue: $author$project$Api$Data$Loading,
            afW: shared.afW,
            V7: $author$project$Api$Data$Loading,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            km: false
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A5($author$project$Api$CompanyAccount$retrieve, shared.Ej, session, params.fl, params.adk, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyAccount),
            A6($author$project$Api$CompanyRegistration$retrieve, shared.Ej, session, params.fl, params.adk, params.ac2, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotCompanyRegistration)
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$subscriptions = function(model) {
        var _v0 = model.ao;
        if (!_v0.$) {
            var employeeForm = _v0.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg, $author$project$Components$Employee$Form$subscriptions(employeeForm));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyAccountUpdated = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyRegistrationUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotMeta = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotPatient = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$One$division = function(_v0) {
        var record = _v0.b;
        return record.Oa;
    };
    var $author$project$Api$Provider$CompanyAccount$One$division = function(_v0) {
        var record = _v0.b;
        return record.Oa;
    };
    var $author$project$Api$CompanyAccount$One$division = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$All$Provider, $author$project$Api$Provider$CompanyAccount$One$division(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$All$Employer, $author$project$Api$Employer$CompanyAccount$One$division(companyAccount_));
        }
    };
    var $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate = function(_v0) {
        var record = _v0;
        return record.OE;
    };
    var $author$project$Api$Employer$CompanyAccount$One$eligibilityStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate(shared);
    };
    var $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate = function(_v0) {
        var record = _v0.b;
        return record.OE;
    };
    var $author$project$Api$Provider$CompanyAccount$One$eligibilityStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(shared);
    };
    var $author$project$Api$CompanyAccount$One$eligibilityStartDate = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$One$eligibilityStartDate(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$One$eligibilityStartDate(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$Shared$externalId = function(_v0) {
        var record = _v0;
        return record.adE;
    };
    var $author$project$Api$Employer$CompanyRegistration$One$externalId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$externalId(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$Shared$externalId = function(_v0) {
        var record = _v0;
        return record.adE;
    };
    var $author$project$Api$Provider$CompanyRegistration$One$externalId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$externalId(shared);
    };
    var $author$project$Api$CompanyRegistration$One$externalId = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$One$externalId(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$One$externalId(companyRegistration_);
        }
    };
    var $author$project$Components$EmployeeDependentTypeInput$fill = F3(function(session, company, type_) {
        return _Utils_Tuple2({
            acy: company,
            fx: $elm$core$Maybe$Nothing,
            d_: $elm$core$Maybe$Nothing,
            Z$: session,
            ah5: type_
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$EmployeeDivisionInput$fill = F4(function(session, companyId, apiClient, division) {
        return _Utils_Tuple2({
            Ej: apiClient,
            Oa: division,
            xv: $author$project$Api$Data$Loading,
            agM: false,
            Z$: session
        }, A5($author$project$Api$EmployeeDivision$list, apiClient, session, companyId, function(d) {
            return d;
        }, $author$project$Components$EmployeeDivisionInput$GotEmployeeDivisions));
    });
    var $author$project$Api$Employer$Patient$One$address = function(_v0) {
        var record = _v0.b;
        return record.II;
    };
    var $author$project$Api$Patient$One$address = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$address(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$address(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$assignedAffiliation = function(_v0) {
        var record = _v0.b;
        return record.JE;
    };
    var $author$project$Api$Provider$Patient$One$assignedAffiliation = function(_v0) {
        var record = _v0.b;
        return record.JE;
    };
    var $author$project$Api$Patient$One$assignedAffiliation = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Provider, $author$project$Api$Provider$Patient$One$assignedAffiliation(patient_));
        } else {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$Employer, $author$project$Api$Employer$Patient$One$assignedAffiliation(patient_));
        }
    };
    var $author$project$Api$Employer$Patient$One$billingAddress = function(_v0) {
        var record = _v0.b;
        return record.Ke;
    };
    var $author$project$Api$Patient$One$billingAddress = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$billingAddress(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$billingAddress(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$chosenFirstName = function(_v0) {
        var record = _v0.b;
        return record.Lc;
    };
    var $author$project$Api$Provider$Patient$Shared$chosenFirstName = function(_v0) {
        var shared = _v0;
        return shared.Lc;
    };
    var $author$project$Api$Provider$Patient$One$chosenFirstName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$chosenFirstName(shared);
    };
    var $author$project$Api$Patient$One$chosenFirstName = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$chosenFirstName(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$chosenFirstName(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$chosenLastName = function(_v0) {
        var record = _v0.b;
        return record.Ld;
    };
    var $author$project$Api$Provider$Patient$Shared$chosenLastName = function(_v0) {
        var shared = _v0;
        return shared.Ld;
    };
    var $author$project$Api$Provider$Patient$One$chosenLastName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$chosenLastName(shared);
    };
    var $author$project$Api$Patient$One$chosenLastName = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$chosenLastName(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$chosenLastName(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$chosenMiddleName = function(_v0) {
        var record = _v0.b;
        return record.Le;
    };
    var $author$project$Api$Provider$Patient$Shared$chosenMiddleName = function(_v0) {
        var shared = _v0;
        return shared.Le;
    };
    var $author$project$Api$Provider$Patient$One$chosenMiddleName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$chosenMiddleName(shared);
    };
    var $author$project$Api$Patient$One$chosenMiddleName = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$chosenMiddleName(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$chosenMiddleName(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$chosenTitle = function(_v0) {
        var record = _v0.b;
        return record.Lg;
    };
    var $author$project$Api$Provider$Patient$Shared$chosenTitle = function(_v0) {
        var shared = _v0;
        return shared.Lg;
    };
    var $author$project$Api$Provider$Patient$One$chosenTitle = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$chosenTitle(shared);
    };
    var $author$project$Api$Patient$One$chosenTitle = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$chosenTitle(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$chosenTitle(patient_);
        }
    };
    var $author$project$Components$Patient$Form$chosenNamePresent = function(patient) {
        return $author$project$Utils$Maybe$toBool($author$project$Api$Patient$One$chosenTitle(patient)) || $author$project$Utils$Maybe$toBool($author$project$Api$Patient$One$chosenFirstName(patient)) || $author$project$Utils$Maybe$toBool($author$project$Api$Patient$One$chosenMiddleName(patient)) || $author$project$Utils$Maybe$toBool($author$project$Api$Patient$One$chosenLastName(patient));
    };
    var $author$project$Api$Employer$Patient$One$chosenSuffix = function(_v0) {
        var record = _v0.b;
        return record.Lf;
    };
    var $author$project$Api$Provider$Patient$Shared$chosenSuffix = function(_v0) {
        var shared = _v0;
        return shared.Lf;
    };
    var $author$project$Api$Provider$Patient$One$chosenSuffix = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$chosenSuffix(shared);
    };
    var $author$project$Api$Patient$One$chosenSuffix = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$chosenSuffix(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$chosenSuffix(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$Shared$dob = function(_v0) {
        var record = _v0;
        return record.add;
    };
    var $author$project$Api$Employer$Patient$One$dob = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$dob(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$dob = function(_v0) {
        var shared = _v0;
        return shared.add;
    };
    var $author$project$Api$Provider$Patient$One$dob = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$dob(shared);
    };
    var $author$project$Api$Patient$One$dob = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$dob(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$dob(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Employer$Patient$One$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$email(shared);
    };
    var $author$project$Api$Patient$One$email = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$email(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$email(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$emergencyContact = function(_v0) {
        var record = _v0.b;
        return record.OJ;
    };
    var $author$project$Api$Provider$Patient$One$emergencyContact = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.OJ;
    });
    var $author$project$Api$Patient$One$emergencyContact = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$emergencyContact(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$emergencyContact(patient_);
        }
    };
    var $author$project$Components$Patient$Form$GotPlainSSN = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Employer$Patient$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$Patient$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$id(shared);
    };
    var $author$project$Api$Patient$One$id = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$id(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$id(patient_);
        }
    };
    var $author$project$Api$Provider$SocialSecurityNumber$One$SocialSecurityNumber = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SocialSecurityNumber$One$Record = function(formattedNumber) {
        return {
            PY: formattedNumber
        };
    };
    var $author$project$Api$Provider$SocialSecurityNumber$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'formatted_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$SocialSecurityNumber$One$Record));
    var $author$project$Api$Provider$SocialSecurityNumber$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SocialSecurityNumber$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$SocialSecurityNumber$ssnPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'social_security_number'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            patientId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$SocialSecurityNumber$retrieve = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$SocialSecurityNumber$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$SocialSecurityNumber$ssnPath(patientId)));
    });
    var $author$project$Components$Patient$Form$fetchPlainSSN = F3(function(apiClient, session, patient) {
        var _v0 = $author$project$Api$Platform$Session$One$role(session);
        if (_v0 === 'practice_admin') return A3($author$project$Api$Provider$SocialSecurityNumber$retrieve, apiClient, $author$project$Api$Patient$One$id(patient), $author$project$Components$Patient$Form$GotPlainSSN);
        else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Api$Employer$Patient$Shared$firstName = function(_v0) {
        var shared = _v0;
        return shared.PN;
    };
    var $author$project$Api$Employer$Patient$One$firstName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$firstName(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$firstName = function(_v0) {
        var shared = _v0;
        return shared.PN;
    };
    var $author$project$Api$Provider$Patient$One$firstName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$firstName(shared);
    };
    var $author$project$Api$Patient$One$firstName = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$firstName(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$firstName(patient_);
        }
    };
    var $author$project$Api$Gender$fromString = function(gender) {
        switch(gender){
            case 'male':
                return $elm$core$Maybe$Just(0);
            case 'female':
                return $elm$core$Maybe$Just(1);
            case 'intersex':
                return $elm$core$Maybe$Just(2);
            case 'other':
                return $elm$core$Maybe$Just(3);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Employer$Patient$Shared$gender = function(_v0) {
        var shared = _v0;
        return shared.P5;
    };
    var $author$project$Api$Employer$Patient$One$gender = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$gender(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$gender = function(_v0) {
        var shared = _v0;
        return shared.P5;
    };
    var $author$project$Api$Provider$Patient$One$gender = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$gender(shared);
    };
    var $author$project$Api$Patient$One$gender = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$gender(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$gender(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$Shared$genderIdentity = function(_v0) {
        var shared = _v0;
        return shared.P6;
    };
    var $author$project$Api$Employer$Patient$One$genderIdentity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$genderIdentity(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$genderIdentity = function(_v0) {
        var shared = _v0;
        return shared.P6;
    };
    var $author$project$Api$Provider$Patient$One$genderIdentity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$genderIdentity(shared);
    };
    var $author$project$Api$Patient$One$genderIdentity = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$genderIdentity(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$genderIdentity(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$Shared$genderOther = function(_v0) {
        var shared = _v0;
        return shared.P7;
    };
    var $author$project$Api$Employer$Patient$One$genderOther = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$genderOther(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$genderOther = function(_v0) {
        var shared = _v0;
        return shared.P7;
    };
    var $author$project$Api$Provider$Patient$One$genderOther = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$genderOther(shared);
    };
    var $author$project$Api$Patient$One$genderOther = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$genderOther(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$genderOther(patient_);
        }
    };
    var $author$project$Api$HealthInsurance$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$HealthInsurance$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Patient$One$healthInsurance = function(_v0) {
        var record = _v0.b;
        return record.QC;
    };
    var $author$project$Api$Provider$Patient$One$healthInsurance = function(_v0) {
        var record = _v0.b;
        return record.QC;
    };
    var $author$project$Api$Patient$One$healthInsurance = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$HealthInsurance$Shared$Provider, $author$project$Api$Provider$Patient$One$healthInsurance(patient_));
        } else {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$HealthInsurance$Shared$Employer, $author$project$Api$Employer$Patient$One$healthInsurance(patient_));
        }
    };
    var $author$project$Api$Employer$LeadSource$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$LeadSource$Shared$id = function(leadSource) {
        if (!leadSource.$) {
            var leadSource_ = leadSource.a;
            return $author$project$Api$Provider$LeadSource$Shared$id(leadSource_);
        } else {
            var leadSource_ = leadSource.a;
            return $author$project$Api$Employer$LeadSource$Shared$id(leadSource_);
        }
    };
    var $author$project$Api$Employer$HealthInsurance$Shared$carrier = function(_v0) {
        var record = _v0;
        return record.K_;
    };
    var $author$project$Api$Provider$HealthInsurance$Shared$carrier = function(_v0) {
        var shared = _v0;
        return shared.K_;
    };
    var $author$project$Api$HealthInsurance$Shared$carrier = function(insurance) {
        if (!insurance.$) {
            var insurance_ = insurance.a;
            return A2($elm$core$Maybe$map, function(carrier_) {
                return $author$project$Api$HealthInsuranceCarrier$Shared$Provider(carrier_);
            }, $author$project$Api$Provider$HealthInsurance$Shared$carrier(insurance_));
        } else {
            var insurance_ = insurance.a;
            return A2($elm$core$Maybe$map, function(carrier_) {
                return $author$project$Api$HealthInsuranceCarrier$Shared$Employer(carrier_);
            }, $author$project$Api$Employer$HealthInsurance$Shared$carrier(insurance_));
        }
    };
    var $author$project$Api$Employer$HealthInsurance$Shared$groupId = function(_v0) {
        var record = _v0;
        return record.Qf;
    };
    var $author$project$Api$Provider$HealthInsurance$Shared$groupId = function(_v0) {
        var shared = _v0;
        return shared.Qf;
    };
    var $author$project$Api$HealthInsurance$Shared$groupId = function(insurance) {
        if (!insurance.$) {
            var insurance_ = insurance.a;
            return $author$project$Api$Provider$HealthInsurance$Shared$groupId(insurance_);
        } else {
            var insurance_ = insurance.a;
            return $author$project$Api$Employer$HealthInsurance$Shared$groupId(insurance_);
        }
    };
    var $author$project$Api$Employer$HealthInsurance$Shared$highDeductible = function(_v0) {
        var record = _v0;
        return record.QJ;
    };
    var $author$project$Api$Provider$HealthInsurance$Shared$highDeductible = function(_v0) {
        var shared = _v0;
        return shared.QJ;
    };
    var $author$project$Api$HealthInsurance$Shared$highDeductible = function(insurance) {
        if (!insurance.$) {
            var insurance_ = insurance.a;
            return $author$project$Api$Provider$HealthInsurance$Shared$highDeductible(insurance_);
        } else {
            var insurance_ = insurance.a;
            return $author$project$Api$Employer$HealthInsurance$Shared$highDeductible(insurance_);
        }
    };
    var $author$project$Api$Employer$HealthInsurance$Shared$memberId = function(_v0) {
        var record = _v0;
        return record.TV;
    };
    var $author$project$Api$Provider$HealthInsurance$Shared$memberId = function(_v0) {
        var shared = _v0;
        return shared.TV;
    };
    var $author$project$Api$HealthInsurance$Shared$memberId = function(insurance) {
        if (!insurance.$) {
            var insurance_ = insurance.a;
            return $author$project$Api$Provider$HealthInsurance$Shared$memberId(insurance_);
        } else {
            var insurance_ = insurance.a;
            return $author$project$Api$Employer$HealthInsurance$Shared$memberId(insurance_);
        }
    };
    var $author$project$Api$Employer$HealthInsurance$Shared$payerName = function(_v0) {
        var record = _v0;
        return record.Wg;
    };
    var $author$project$Api$Provider$HealthInsurance$Shared$payerName = function(_v0) {
        var shared = _v0;
        return shared.Wg;
    };
    var $author$project$Api$HealthInsurance$Shared$payerName = function(insurance) {
        if (!insurance.$) {
            var insurance_ = insurance.a;
            return $author$project$Api$Provider$HealthInsurance$Shared$payerName(insurance_);
        } else {
            var insurance_ = insurance.a;
            return $author$project$Api$Employer$HealthInsurance$Shared$payerName(insurance_);
        }
    };
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$InsuranceCarrierAlias$setValue = F2(function(resource, model) {
        return _Utils_update(model, {
            Hg: function() {
                if (!resource.$) {
                    var resource_ = resource.a;
                    return $author$project$Components$ResourceFilter$One(resource_);
                } else return $author$project$Components$ResourceFilter$All;
            }()
        });
    });
    var $author$project$Components$HealthInsuranceInput$init = F3(function(apiClient, session, healthInsurance) {
        var insuranceCarrier = function() {
            var _v3 = $author$project$Api$HealthInsurance$Shared$carrier(healthInsurance);
            if (!_v3.$) {
                var carrier = _v3.a;
                return $author$project$Components$HealthInsuranceInput$InsuranceCarrierAlias({
                    EI: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrier),
                    K$: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier),
                    EJ: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrier),
                    EK: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrier),
                    zr: A2($elm$core$Maybe$withDefault, '', $author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
                });
            } else return $author$project$Components$HealthInsuranceInput$Other({
                zr: A2($elm$core$Maybe$withDefault, '', $author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
            });
        }();
        var healthInsuranceRecord = {
            Qf: $author$project$Api$HealthInsurance$Shared$groupId(healthInsurance),
            QJ: $author$project$Api$HealthInsurance$Shared$highDeductible(healthInsurance),
            TV: $author$project$Api$HealthInsurance$Shared$memberId(healthInsurance),
            Wg: $author$project$Api$HealthInsurance$Shared$payerName(healthInsurance)
        };
        var _v0 = function(_v1) {
            var filter = _v1.a;
            var filterCmd = _v1.b;
            var _v2 = $author$project$Api$HealthInsurance$Shared$carrier(healthInsurance);
            if (!_v2.$) {
                var carrier = _v2.a;
                var insuranceAlias = {
                    EI: $author$project$Api$HealthInsuranceCarrier$Shared$collectGroupId(carrier),
                    K$: $author$project$Api$HealthInsuranceCarrier$Shared$collectHighDeductible(carrier),
                    EJ: $author$project$Api$HealthInsuranceCarrier$Shared$collectMemberId(carrier),
                    EK: $author$project$Api$HealthInsuranceCarrier$Shared$id(carrier),
                    zr: A2($elm$core$Maybe$withDefault, '', $author$project$Api$HealthInsurance$Shared$payerName(healthInsurance))
                };
                return _Utils_Tuple2(A2($author$project$Components$ResourceFilter$InsuranceCarrierAlias$setValue, $elm$core$Maybe$Just(insuranceAlias), filter), filterCmd);
            } else return A2($elm$core$Tuple$mapSecond, function(preSelectedIdCmd) {
                return $elm$core$Platform$Cmd$batch(_List_fromArray([
                    filterCmd,
                    preSelectedIdCmd
                ]));
            }, A2($author$project$Components$ResourceFilter$InsuranceCarrierAlias$preSelectedId, $elm$core$Maybe$Just(''), filter));
        }(A3($author$project$Components$ResourceFilter$InsuranceCarrierAlias$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'None',
                U5: 'Other (Enter insurance carrier name manually)',
                afn: true
            });
        }));
        var insuranceCarrierAliasFilter = _v0.a;
        var insuranceCarrierAliasCmd = _v0.b;
        return _Utils_Tuple2(A3($author$project$Components$HealthInsuranceInput$Model, insuranceCarrierAliasFilter, {
            d$: false
        }, $elm$core$Maybe$Just(_Utils_Tuple2(insuranceCarrier, healthInsuranceRecord))), A2($elm$core$Platform$Cmd$map, $author$project$Components$HealthInsuranceInput$FilterMsg, insuranceCarrierAliasCmd));
    });
    var $author$project$Api$KnownPractice$Shared$id = function(knownPractice) {
        if (!knownPractice.$) {
            var knownPractice_ = knownPractice.a;
            return $author$project$Api$Provider$KnownPractice$Shared$id(knownPractice_);
        } else {
            var knownPractice_ = knownPractice.a;
            return $author$project$Api$Employer$KnownPractice$Shared$id(knownPractice_);
        }
    };
    var $author$project$Api$KnownPractice$Shared$name = function(knownPractice) {
        if (!knownPractice.$) {
            var knownPractice_ = knownPractice.a;
            return $author$project$Api$Provider$KnownPractice$Shared$name(knownPractice_);
        } else {
            var knownPractice_ = knownPractice.a;
            return $author$project$Api$Employer$KnownPractice$Shared$name(knownPractice_);
        }
    };
    var $author$project$Components$ResourceFilter$KnownPractice$setValue = F2(function(resource, model) {
        return _Utils_update(model, {
            Hg: function() {
                if (!resource.$) {
                    var resource_ = resource.a;
                    return $author$project$Components$ResourceFilter$One(resource_);
                } else return $author$project$Components$ResourceFilter$All;
            }()
        });
    });
    var $author$project$Components$KnownPracticeInput$init = F3(function(apiClient, session, knownPractice) {
        var knownPractice_ = {
            aef: $author$project$Api$KnownPractice$Shared$id(knownPractice),
            zr: $author$project$Api$KnownPractice$Shared$name(knownPractice)
        };
        var _v0 = A2($elm$core$Tuple$mapFirst, function(filter) {
            return A2($author$project$Components$ResourceFilter$KnownPractice$setValue, $elm$core$Maybe$Just(knownPractice_), filter);
        }, A3($author$project$Components$ResourceFilter$KnownPractice$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a DPC practice',
                U5: 'Other (Enter your DPC manually)',
                afn: true
            });
        }));
        var knownPracticeFilter = _v0.a;
        var knownPracticeCmd = _v0.b;
        return _Utils_Tuple2(A2($author$project$Components$KnownPracticeInput$Model, knownPracticeFilter, $elm$core$Maybe$Just($author$project$Components$KnownPracticeInput$KnownPractice(knownPractice_))), A2($elm$core$Platform$Cmd$map, $author$project$Components$KnownPracticeInput$FilterMsg, knownPracticeCmd));
    });
    var $author$project$Components$LeadSourceInput$init = F3(function(apiClient, selected, other) {
        var _v0 = A2($author$project$Components$LeadSourceInput$initLeadSourceResourceFilter, apiClient, selected);
        var leadSourceResourceFilter = _v0.a;
        var leadSourceResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            d$: false,
            mT: leadSourceResourceFilter,
            c6: other,
            ah: selected
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$LeadSourceInput$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd));
    });
    var $author$project$Components$NameInput$init = function(fields) {
        return A3($author$project$Components$NameInput$Model, _List_Nil, {
            d$: false,
            tp: ''
        }, fields);
    };
    var $author$project$Api$Employer$Patient$Shared$joinedPracticeDate = function(_v0) {
        var shared = _v0;
        return shared.SK;
    };
    var $author$project$Api$Employer$Patient$One$joinedPracticeDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$joinedPracticeDate(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$joinedPracticeDate = function(_v0) {
        var shared = _v0;
        return shared.SK;
    };
    var $author$project$Api$Provider$Patient$One$joinedPracticeDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$joinedPracticeDate(shared);
    };
    var $author$project$Api$Patient$One$joinedPracticeDate = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$joinedPracticeDate(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$joinedPracticeDate(patient_);
        }
    };
    var $author$project$Api$KnownPractice$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$KnownPractice$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Patient$One$knownPractice = function(_v0) {
        var record = _v0.b;
        return record.SM;
    };
    var $author$project$Api$Provider$Patient$One$knownPractice = function(_v0) {
        var record = _v0.b;
        return record.SM;
    };
    var $author$project$Api$Patient$One$knownPractice = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$KnownPractice$Shared$Provider, $author$project$Api$Provider$Patient$One$knownPractice(patient_));
        } else {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$KnownPractice$Shared$Employer, $author$project$Api$Employer$Patient$One$knownPractice(patient_));
        }
    };
    var $author$project$Api$Employer$Patient$Shared$lastName = function(_v0) {
        var shared = _v0;
        return shared.SU;
    };
    var $author$project$Api$Employer$Patient$One$lastName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$lastName(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$lastName = function(_v0) {
        var shared = _v0;
        return shared.SU;
    };
    var $author$project$Api$Provider$Patient$One$lastName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$lastName(shared);
    };
    var $author$project$Api$Patient$One$lastName = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$lastName(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$lastName(patient_);
        }
    };
    var $author$project$Api$LeadSource$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$LeadSource$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Patient$One$leadSource = function(_v0) {
        var record = _v0.b;
        return record.S1;
    };
    var $author$project$Api$Provider$Patient$One$leadSource = function(_v0) {
        var record = _v0.b;
        return record.S1;
    };
    var $author$project$Api$Patient$One$leadSource = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$LeadSource$Shared$Provider, $author$project$Api$Provider$Patient$One$leadSource(patient_));
        } else {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$LeadSource$Shared$Employer, $author$project$Api$Employer$Patient$One$leadSource(patient_));
        }
    };
    var $author$project$Api$Employer$Patient$Shared$leadSourceOther = function(_v0) {
        var shared = _v0;
        return shared.S3;
    };
    var $author$project$Api$Employer$Patient$One$leadSourceOther = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$leadSourceOther(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$leadSourceOther = function(_v0) {
        var shared = _v0;
        return shared.S3;
    };
    var $author$project$Api$Provider$Patient$One$leadSourceOther = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$leadSourceOther(shared);
    };
    var $author$project$Api$Patient$One$leadSourceOther = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$leadSourceOther(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$leadSourceOther(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$location = function(_v0) {
        var record = _v0.b;
        return record.aeT;
    };
    var $author$project$Api$Patient$One$location = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Location$Shared$Provider, $author$project$Api$Provider$Patient$One$location(patient_));
        } else {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Location$Shared$Employer, $author$project$Api$Employer$Patient$One$location(patient_));
        }
    };
    var $author$project$Api$Employer$Patient$Shared$middleName = function(_v0) {
        var shared = _v0;
        return shared.Uh;
    };
    var $author$project$Api$Employer$Patient$One$middleName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$middleName(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$middleName = function(_v0) {
        var shared = _v0;
        return shared.Uh;
    };
    var $author$project$Api$Provider$Patient$One$middleName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$middleName(shared);
    };
    var $author$project$Api$Patient$One$middleName = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$middleName(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$middleName(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$phones = function(_v0) {
        var record = _v0.b;
        return record.WG;
    };
    var $author$project$Api$Provider$Patient$One$phones = function(_v0) {
        var record = _v0.b;
        return record.WG;
    };
    var $author$project$Api$Patient$One$phones = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$phones(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$phones(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$practitioner = function(_v0) {
        var record = _v0.b;
        return record.agi;
    };
    var $author$project$Api$Patient$One$practitioner = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Practitioner$Shared$Provider, $author$project$Api$Provider$Patient$One$practitioner(patient_));
        } else {
            var patient_ = patient.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Practitioner$Shared$Employer, $author$project$Api$Employer$Patient$One$practitioner(patient_));
        }
    };
    var $author$project$Api$Employer$Patient$One$preferredLanguage = function(_v0) {
        var record = _v0.b;
        return record.Xh;
    };
    var $author$project$Api$Provider$Patient$One$preferredLanguage = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.Xh;
    });
    var $author$project$Api$Patient$One$preferredLanguage = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$preferredLanguage(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$preferredLanguage(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$profilePictureUrl = function(_v0) {
        var record = _v0.b;
        return record.XE;
    };
    var $author$project$Api$Provider$Patient$One$profilePictureUrl = function(_v0) {
        var record = _v0.b;
        return record.XE;
    };
    var $author$project$Api$Patient$One$profilePictureUrl = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$profilePictureUrl(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$profilePictureUrl(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$Shared$pronoun = function(_v0) {
        var shared = _v0;
        return shared.XF;
    };
    var $author$project$Api$Employer$Patient$One$pronoun = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$pronoun(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$pronoun = function(_v0) {
        var shared = _v0;
        return shared.XF;
    };
    var $author$project$Api$Provider$Patient$One$pronoun = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$pronoun(shared);
    };
    var $author$project$Api$Patient$One$pronoun = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$pronoun(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$pronoun(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$Shared$sex = function(_v0) {
        var shared = _v0;
        return shared.Z3;
    };
    var $author$project$Api$Employer$Patient$One$sex = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$sex(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$sex = function(_v0) {
        var shared = _v0;
        return shared.Z3;
    };
    var $author$project$Api$Provider$Patient$One$sex = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$sex(shared);
    };
    var $author$project$Api$Patient$One$sex = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$sex(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$sex(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$suffix = function(_v0) {
        var record = _v0.b;
        return record.$w;
    };
    var $author$project$Api$Provider$Patient$One$suffix = function(_v0) {
        var record = _v0.b;
        return record.$w;
    };
    var $author$project$Api$Patient$One$suffix = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$suffix(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$suffix(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$Shared$syncToEmr = function(_v0) {
        var shared = _v0;
        return shared.$H;
    };
    var $author$project$Api$Employer$Patient$One$syncToEmr = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$syncToEmr(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$syncToEmr = function(_v0) {
        var shared = _v0;
        return shared.$H;
    };
    var $author$project$Api$Provider$Patient$One$syncToEmr = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$syncToEmr(shared);
    };
    var $author$project$Api$Patient$One$syncToEmr = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$syncToEmr(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$syncToEmr(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$title = function(_v0) {
        var record = _v0.b;
        return record.$2;
    };
    var $author$project$Api$Provider$Patient$One$title = function(_v0) {
        var record = _v0.b;
        return record.$2;
    };
    var $author$project$Api$Patient$One$title = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$title(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$title(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$One$usesBillingAddress = function(_v0) {
        var record = _v0.b;
        return record.aa_;
    };
    var $author$project$Api$Provider$Patient$One$usesBillingAddress = function(_v0) {
        var record = _v0.b;
        return record.aa_;
    };
    var $author$project$Api$Patient$One$usesBillingAddress = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$usesBillingAddress(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$usesBillingAddress(patient_);
        }
    };
    var $author$project$Api$Employer$Patient$Shared$usesTobacco = function(_v0) {
        var shared = _v0;
        return shared.aa4;
    };
    var $author$project$Api$Employer$Patient$One$usesTobacco = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Patient$Shared$usesTobacco(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$usesTobacco = function(_v0) {
        var shared = _v0;
        return shared.aa4;
    };
    var $author$project$Api$Provider$Patient$One$usesTobacco = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
    };
    var $author$project$Api$Patient$One$usesTobacco = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$One$usesTobacco(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$One$usesTobacco(patient_);
        }
    };
    var $author$project$Components$Patient$Form$fill = F8(function(apiClient, session, currentDate, company, isEmployeeForm, patient, meta, settingsMapper) {
        var settings = function() {
            var defaultSettings_ = A3($author$project$Components$Patient$Form$defaultSettings, currentDate, false, isEmployeeForm);
            return settingsMapper(_Utils_update(defaultSettings_, {
                Ue: $elm$core$Maybe$Just(meta)
            }));
        }();
        var practitionerOptionals = function() {
            var locationId = settings.Qr && settings.aaq ? A2($elm$core$Maybe$map, $author$project$Api$Location$Shared$id, $author$project$Api$Patient$One$location(patient)) : $elm$core$Maybe$Nothing;
            var affiliateId = settings.$D ? A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$id, $author$project$Api$Patient$One$assignedAffiliation(patient)) : $elm$core$Maybe$Nothing;
            return A5($author$project$Components$Patient$Form$practitionerSignupOptionalsWithExtras, isEmployeeForm, company, locationId, affiliateId, _List_fromArray([
                1
            ]));
        }();
        var phones = A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, $author$project$Api$Patient$One$phones(patient));
        var phonesInput = A3($author$project$Components$PhoneInput$init, 'patient-phones', phones, function(d) {
            return _Utils_update(d, {
                Iz: true
            });
        });
        var optionals = function() {
            var practitionerId = settings.Qx ? A2($elm$core$Maybe$map, $author$project$Api$Practitioner$Shared$id, $author$project$Api$Patient$One$practitioner(patient)) : $elm$core$Maybe$Nothing;
            var affiliateId = settings.$D ? A2($elm$core$Maybe$map, $author$project$Api$Affiliate$AffiliateMin$id, $author$project$Api$Patient$One$assignedAffiliation(patient)) : $elm$core$Maybe$Nothing;
            return A4($author$project$Components$Patient$Form$locationOptionals, isEmployeeForm, company, practitionerId, affiliateId);
        }();
        var legalNameFields = {
            PN: $author$project$Api$Patient$One$firstName(patient),
            SU: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$One$lastName(patient)),
            Uh: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$One$middleName(patient)),
            $w: $author$project$Api$Patient$One$suffix(patient),
            $2: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$One$title(patient))
        };
        var currentProfilePictureUrl = $author$project$Api$Patient$One$profilePictureUrl(patient);
        var chosenNameFields = $author$project$Components$Patient$Form$chosenNamePresent(patient) ? $elm$core$Maybe$Just($author$project$Components$NameInput$init({
            PN: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$One$chosenFirstName(patient)),
            SU: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$One$chosenLastName(patient)),
            Uh: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$One$chosenMiddleName(patient)),
            $w: $author$project$Api$Patient$One$chosenSuffix(patient),
            $2: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$One$chosenTitle(patient))
        })) : $elm$core$Maybe$Nothing;
        var _v0 = A3($author$project$Components$PractitionerInput$init, apiClient, practitionerOptionals, $author$project$Api$Patient$One$practitioner(patient));
        var practitioner = _v0.a;
        var practitionerCmd = _v0.b;
        var _v1 = A3($author$project$Components$LocationInput$init, apiClient, optionals, $author$project$Api$Patient$One$location(patient));
        var location1 = _v1.a;
        var locationCmd = _v1.b;
        var _v2 = function() {
            var maybeLeadSourceId = A2($elm$core$Maybe$map, $author$project$Api$LeadSource$Shared$id, $author$project$Api$Patient$One$leadSource(patient));
            return A3($author$project$Components$LeadSourceInput$init, apiClient, maybeLeadSourceId, $author$project$Api$Patient$One$leadSourceOther(patient));
        }();
        var leadSource = _v2.a;
        var leadSourceCmd = _v2.b;
        var _v3 = function() {
            var _v4 = $author$project$Api$Patient$One$knownPractice(patient);
            if (!_v4.$) {
                var knownPractice_ = _v4.a;
                return A3($author$project$Components$KnownPracticeInput$init, apiClient, session, knownPractice_);
            } else return A2($author$project$Components$KnownPracticeInput$empty, apiClient, session);
        }();
        var knownPractice = _v3.a;
        var knownPracticeCmd = _v3.b;
        var _v5 = function() {
            var _v6 = $author$project$Api$Patient$One$healthInsurance(patient);
            if (!_v6.$) {
                var insurance_ = _v6.a;
                return A3($author$project$Components$HealthInsuranceInput$init, apiClient, session, insurance_);
            } else return A2($author$project$Components$HealthInsuranceInput$empty, apiClient, session);
        }();
        var healthInsurance = _v5.a;
        var healthInsuranceCmd = _v5.b;
        var _v7 = $author$project$Components$DateInput$init;
        var dateInput = _v7.a;
        var dateInputCmd = _v7.b;
        var _v8 = A2($author$project$Components$AddressInput$initFromApi, 'patient-billing-address', $author$project$Api$Patient$One$billingAddress(patient));
        var billingAddress = _v8.a;
        var billingAddressCmd = _v8.b;
        var _v9 = function() {
            var resource = A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Affiliate$resourceFromAffiliateMin, $author$project$Api$Patient$One$assignedAffiliation(patient));
            var practitionerId = settings.Qx ? A2($elm$core$Maybe$map, $author$project$Api$Practitioner$Shared$id, $author$project$Api$Patient$One$practitioner(patient)) : $elm$core$Maybe$Nothing;
            var locationId = settings.Qr && settings.aaq ? A2($elm$core$Maybe$map, $author$project$Api$Location$Shared$id, $author$project$Api$Patient$One$location(patient)) : $elm$core$Maybe$Nothing;
            var filteredAffiliateOptionals = A2($author$project$Components$Patient$Form$affiliateOptionals, practitionerId, locationId);
            return A4($author$project$Components$AffiliateInput$initWithResource, apiClient, session, filteredAffiliateOptionals, resource);
        }();
        var affiliate = _v9.a;
        var affiliateCmd = _v9.b;
        var _v10 = A2($author$project$Components$AddressInput$initFromApi, 'patient-address', $author$project$Api$Patient$One$address(patient));
        var address = _v10.a;
        var addressCmd = _v10.b;
        return _Utils_Tuple2(A2($author$project$Components$Patient$Form$PatientForm, settings, $author$project$Utils$Form$init({
            II: address,
            Eb: affiliate,
            Ke: $elm$core$Maybe$Just(billingAddress),
            br: chosenNameFields,
            qa: currentProfilePictureUrl,
            M7: A2($agustinrhcp$elm_mask$Mask$unMask, $author$project$Components$Patient$Form$datePattern, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Patient$One$dob(patient)))),
            OH: $author$project$Api$Patient$One$email(patient),
            OJ: $author$project$Components$EmergencyContactInput$init($author$project$Api$Patient$One$emergencyContact(patient)),
            P5: A2($elm$core$Maybe$andThen, $author$project$Api$Gender$fromString, $author$project$Api$Patient$One$gender(patient)),
            P6: A2($elm$core$Maybe$andThen, $author$project$Api$GenderIdentity$fromString(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$One$genderOther(patient))), $author$project$Api$Patient$One$genderIdentity(patient)),
            P7: $author$project$Api$Patient$One$genderOther(patient),
            QC: healthInsurance,
            i0: _Utils_Tuple2($author$project$Api$Patient$One$joinedPracticeDate(patient), dateInput),
            SM: knownPractice,
            S1: leadSource,
            S4: $author$project$Components$NameInput$init(legalNameFields),
            aeT: A2($author$project$Components$LocationInput$require, settings.YK, location1),
            WG: A2($author$project$Components$PhoneInput$require, settings.agR, phonesInput),
            agi: A2($author$project$Components$PractitionerInput$require, settings.YP, practitioner),
            Xh: $author$project$Api$Patient$One$preferredLanguage(patient),
            sl: 0,
            XE: $elm$core$Maybe$Nothing,
            XF: A2($elm$core$Maybe$andThen, $author$project$Api$Pronoun$fromString, $author$project$Api$Patient$One$pronoun(patient)),
            Z3: A2($elm$core$Maybe$andThen, $author$project$Api$Gender$fromString, $author$project$Api$Patient$One$sex(patient)),
            __: '',
            $H: $author$project$Api$Patient$One$syncToEmr(patient),
            oO: $author$project$Api$Patient$One$usesTobacco(patient),
            aa_: $author$project$Api$Patient$One$usesBillingAddress(patient)
        })), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address), addressCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$BillingAddress), billingAddressCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$KnownPractice), knownPracticeCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner), practitionerCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Location), locationCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource), leadSourceCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$HealthInsurance), healthInsuranceCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$JoinedPractice), dateInputCmd),
            A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Affiliate), affiliateCmd),
            A3($author$project$Components$Patient$Form$fetchPlainSSN, apiClient, session, patient)
        ])));
    });
    var $author$project$Api$Employer$Plan$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Plan$Min$id = function(plan) {
        if (!plan.$) {
            var plan_ = plan.a;
            return $author$project$Api$Provider$Plan$Min$id(plan_);
        } else {
            var plan_ = plan.a;
            return $author$project$Api$Employer$Plan$Min$id(plan_);
        }
    };
    var $author$project$Api$Plan$Min$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Plan$Min$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$One$membershipPlan = function(_v0) {
        var record = _v0.b;
        return record.T2;
    };
    var $author$project$Api$Provider$CompanyAccount$One$membershipPlan = function(_v0) {
        var record = _v0.b;
        return record.T2;
    };
    var $author$project$Api$CompanyAccount$One$membershipPlan = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Plan$Min$Provider, $author$project$Api$Provider$CompanyAccount$One$membershipPlan(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Plan$Min$Employer, $author$project$Api$Employer$CompanyAccount$One$membershipPlan(companyAccount_));
        }
    };
    var $author$project$Components$SponsorPlanInput$fill = F4(function(session, company, apiClient, companyAccount) {
        var planId = A2($elm$core$Maybe$map, $author$project$Api$Plan$Min$id, $author$project$Api$CompanyAccount$One$membershipPlan(companyAccount));
        var _v0 = A4($author$project$Components$SponsorPlanInput$filterInit, session, company, apiClient, planId);
        var filter = _v0.a;
        var filterCmd = _v0.b;
        return _Utils_Tuple2({
            d$: false,
            Fw: filter,
            agM: false,
            aa9: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, filterCmd));
    });
    var $author$project$Api$Employer$CompanyRegistration$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Employer$CompanyRegistration$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$type_(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$CompanyRegistration$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
    };
    var $author$project$Api$CompanyRegistration$One$type_ = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$One$type_(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$One$type_(companyRegistration_);
        }
    };
    var $author$project$Components$Employee$Form$fill = function(session) {
        return function(company) {
            return function(apiClient) {
                return function(currentDate) {
                    return function(companyAccount) {
                        return function(companyRegistration) {
                            return function(patient) {
                                return function(meta) {
                                    return function(employeeMapper) {
                                        return function(patientMapper) {
                                            var isNew = false;
                                            var employeeSettings = employeeMapper($author$project$Components$Employee$Form$defaultEmployeeSettings);
                                            var division = $author$project$Api$CompanyAccount$One$division(companyAccount);
                                            var divisionId = A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$All$id, division);
                                            var _v0 = A3($author$project$Components$EmployeeDependentTypeInput$fill, session, company, $author$project$Api$CompanyRegistration$One$type_(companyRegistration));
                                            var typeInput = _v0.a;
                                            var typeInputCmd = _v0.b;
                                            var _v1 = $author$project$Components$DateInput$init;
                                            var startDateInput = _v1.a;
                                            var startDateInputCmd = _v1.b;
                                            var _v2 = A2($elm$core$Tuple$mapFirst, $author$project$Components$SponsorPlanInput$require(true), A4($author$project$Components$SponsorPlanInput$fill, session, company, apiClient, companyAccount));
                                            var sponsorPlan = _v2.a;
                                            var sponsorPlanCmd = _v2.b;
                                            var _v3 = A8($author$project$Components$Patient$Form$fill, apiClient, session, currentDate, $elm$core$Maybe$Just(company), true, patient, meta, patientMapper);
                                            var patientForm = _v3.a;
                                            var patientFormCmd = _v3.b;
                                            var _v4 = A4($author$project$Components$EmployeeDivisionInput$fill, session, $author$project$Api$Company$id(company), apiClient, divisionId);
                                            var divisionInput = _v4.a;
                                            var divisionInputCmd = _v4.b;
                                            var form = $author$project$Utils$Form$init({
                                                Oa: A2($author$project$Components$EmployeeDivisionInput$require, employeeSettings.YJ, divisionInput),
                                                cU: _Utils_Tuple2($author$project$Api$CompanyAccount$One$eligibilityStartDate(companyAccount), startDateInput),
                                                OV: $elm$core$Maybe$Nothing,
                                                adE: $author$project$Api$CompanyRegistration$One$externalId(companyRegistration),
                                                aef: $elm$core$Maybe$Just($author$project$Api$CompanyRegistration$One$id(companyRegistration)),
                                                iZ: isNew,
                                                T4: $author$project$Components$Employee$Form$nextFirstOfMonth(currentDate),
                                                V7: patientForm,
                                                GW: A2($author$project$Components$SponsorPlanInput$require, employeeSettings.B9, sponsorPlan),
                                                ah5: typeInput
                                            });
                                            return _Utils_Tuple2(A2($author$project$Components$Employee$Form$EmployeeForm, A3($author$project$Components$Employee$Form$defaultSettings, currentDate, isNew, employeeSettings), form), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                A2($elm$core$Platform$Cmd$map, $author$project$Components$Employee$Form$PatientFormMsg, patientFormCmd),
                                                A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Type), typeInputCmd),
                                                A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Plan), sponsorPlanCmd),
                                                A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$EligibilityDate), startDateInputCmd),
                                                A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Employee$Form$FieldUpdated, $author$project$Components$Employee$Form$Division), divisionInputCmd)
                                            ])));
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm = function(model) {
        var _v0 = model.Ue;
        if (_v0.$ === 3) {
            var meta = _v0.a;
            var _v1 = _Utils_Tuple3(model.LI, model.LP, model.V7);
            if (_v1.a.$ === 3 && _v1.b.$ === 3 && _v1.c.$ === 3) {
                var _v2 = _v1.a;
                var companyAccount = _v2.a;
                var _v3 = _v1.b;
                var companyRegistration = _v3.a;
                var _v4 = _v1.c;
                var patient = _v4.a;
                var _v5 = $author$project$Components$Employee$Form$fill(model.Z$)(model.acy)(model.Ej)(model.cP)(companyAccount)(companyRegistration)(patient)(meta)(function(es) {
                    return _Utils_update(es, {
                        YJ: $author$project$Api$Company$requiresEmployeeDivisions(model.acy),
                        aa1: $author$project$Api$Company$usesEmployeeDivisions(model.acy)
                    });
                })(function(ps) {
                    return _Utils_update(ps, {
                        ab1: $author$project$Api$Practice$labelBillingAsShipping(model.W1),
                        ab8: A2($author$project$Api$Practice$featureEnabled, 3, model.W1),
                        Qr: $author$project$Api$Practice$hasPractitioners(model.W1),
                        Qx: $author$project$Api$Practice$hasPractitioners(model.W1),
                        B8: true,
                        agQ: $author$project$Api$Practice$requiresPatientEmail(model.W1),
                        YK: $author$project$Api$Practice$requiresLocation(model.W1),
                        agR: $author$project$Api$Practice$requiresPatientMobile(model.W1),
                        YP: $author$project$Api$Practice$requiresPractitioner(model.W1),
                        YQ: $author$project$Api$Practice$requiresSSN(model.W1),
                        _$: $author$project$Api$Practice$ssnEnabled(model.W1),
                        $D: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$syncByAffiliation, $author$project$Api$Practice$network(model.W1))),
                        ah_: A2($author$project$Api$Practice$featureEnabled, 2, model.W1),
                        aaq: $author$project$Api$Practice$trackPatientsByLocation(model.W1),
                        aas: $author$project$Api$Practice$transInclusivity(model.W1),
                        DT: A3($author$project$Permission$canGoTo, model.Z$, model.aeb, 0)
                    });
                });
                var form = _v5.a;
                var formCmd = _v5.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ao: $elm$core$Maybe$Just(form)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg, formCmd));
            } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Api$Employer$Patient$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Patient$Min$name = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$Min$name(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$Min$name(patient_);
        }
    };
    var $author$project$Api$Patient$One$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Patient$One$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Patient$One$Patient = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$Patient$One$Record = function(chosenTitle) {
        return function(chosenFirstName) {
            return function(chosenMiddleName) {
                return function(chosenLastName) {
                    return function(chosenSuffix) {
                        return function(title) {
                            return function(suffix) {
                                return function(usesBillingAddress) {
                                    return function(address) {
                                        return function(billingAddress) {
                                            return function(phones) {
                                                return function(location1) {
                                                    return function(practitioner) {
                                                        return function(preferredLanguage) {
                                                            return function(leadSource) {
                                                                return function(healthInsurance) {
                                                                    return function(knownPractice) {
                                                                        return function(assignedAffiliation) {
                                                                            return function(profilePictureUrl) {
                                                                                return function(emergencyContact) {
                                                                                    return {
                                                                                        II: address,
                                                                                        JE: assignedAffiliation,
                                                                                        Ke: billingAddress,
                                                                                        Lc: chosenFirstName,
                                                                                        Ld: chosenLastName,
                                                                                        Le: chosenMiddleName,
                                                                                        Lf: chosenSuffix,
                                                                                        Lg: chosenTitle,
                                                                                        OJ: emergencyContact,
                                                                                        QC: healthInsurance,
                                                                                        SM: knownPractice,
                                                                                        S1: leadSource,
                                                                                        aeT: location1,
                                                                                        WG: phones,
                                                                                        agi: practitioner,
                                                                                        Xh: preferredLanguage,
                                                                                        XE: profilePictureUrl,
                                                                                        $w: suffix,
                                                                                        $2: title,
                                                                                        aa_: usesBillingAddress
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$Affiliate$AffiliateMin$Affiliate = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Affiliate$AffiliateMin$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Employer$Affiliate$AffiliateMin$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Affiliate$AffiliateMin$Record)));
    var $author$project$Api$Employer$Affiliate$AffiliateMin$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Affiliate$AffiliateMin$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$HealthInsurance$Shared$HealthInsurance = $elm$core$Basics$identity;
    var $author$project$Api$Employer$HealthInsurance$Shared$Record = F5(function(memberId, groupId, payerName, highDeductible, carrier) {
        return {
            K_: carrier,
            Qf: groupId,
            QJ: highDeductible,
            TV: memberId,
            Wg: payerName
        };
    });
    var $author$project$Api$Employer$HealthInsurance$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'carrier', $elm$json$Json$Decode$nullable($author$project$Api$Employer$HealthInsuranceCarrier$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'high_deductible', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payer_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'group_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'member_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Employer$HealthInsurance$Shared$Record))))));
    var $author$project$Api$Employer$HealthInsurance$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$HealthInsurance$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$LeadSource$Shared$LeadSource = $elm$core$Basics$identity;
    var $author$project$Api$Employer$LeadSource$Shared$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Employer$LeadSource$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$LeadSource$Shared$Record));
    var $author$project$Api$Employer$LeadSource$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$LeadSource$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Location$Shared$Location = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Location$Shared$Record = F3(function(id, name, affiliation) {
        return {
            IY: affiliation,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Employer$Location$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'affiliation', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Location$Shared$Record))));
    var $author$project$Api$Employer$Location$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Location$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Practitioner$Shared$Practitioner = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Practitioner$Shared$Record = F6(function(id, name, isMaster, isSynced, openingsSize, affiliation) {
        return {
            IY: affiliation,
            aef: id,
            R8: isMaster,
            Su: isSynced,
            zr: name,
            Vy: openingsSize
        };
    });
    var $author$project$Api$Employer$Practitioner$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'affiliation', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'openings_size', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_synced', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_master', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Practitioner$Shared$Record)))))));
    var $author$project$Api$Employer$Practitioner$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Practitioner$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Patient$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'emergency_contact', $elm$json$Json$Decode$nullable($author$project$Api$Common$EmergencyContact$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'profile_picture_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'assigned_affiliation', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'known_practice', $elm$json$Json$Decode$nullable($author$project$Api$Employer$KnownPractice$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'health_insurance', $elm$json$Json$Decode$nullable($author$project$Api$Employer$HealthInsurance$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lead_source', $elm$json$Json$Decode$nullable($author$project$Api$Employer$LeadSource$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'preferred_language', $author$project$Language$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Practitioner$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Location$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phones', $elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_billing_address', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'suffix', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_suffix', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_last_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_middle_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_first_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_title', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$One$Record)))))))))))))))))))));
    var $author$project$Api$Employer$Patient$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Patient$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Patient$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Patient$One$Patient)));
    var $author$project$Api$Employer$Patient$patientsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'patients'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Patient$patientPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Employer$Patient$patientsPath);
    };
    var $author$project$Api$Employer$Patient$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$Patient$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Patient$patientPath(id_)));
    });
    var $author$project$Api$Patient$retrieve = F4(function(apiClient, session, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Patient$retrieve, apiClient, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Patient$One$Employer))) : A3($author$project$Api$Provider$Patient$retrieve, apiClient, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Patient$One$Provider)));
    });
    var $author$project$Api$Patient$Meta$Meta = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Patient$Meta$MetaActions = function(archive) {
        return {
            JB: archive
        };
    };
    var $author$project$Utils$MetaFields$decodeActionable = $elm$json$Json$Decode$bool;
    var $author$project$Api$Patient$Meta$decodeMetaActions = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray([
        'actions',
        'archive'
    ]), $author$project$Utils$MetaFields$decodeActionable, $elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$MetaActions));
    var $author$project$Api$Patient$Meta$MetaFields = function(firstName) {
        return function(chosenFirstName) {
            return function(dob) {
                return function(gender) {
                    return function(sex) {
                        return function(genderIdentity) {
                            return function(pronouns) {
                                return function(usesTobacco) {
                                    return function(practitionerId) {
                                        return function(locationId) {
                                            return function(joinedPracticeDate) {
                                                return function(healthInsuranceCarrier) {
                                                    return function(leadSourceId) {
                                                        return {
                                                            Lc: chosenFirstName,
                                                            add: dob,
                                                            PN: firstName,
                                                            P5: gender,
                                                            P6: genderIdentity,
                                                            QD: healthInsuranceCarrier,
                                                            SK: joinedPracticeDate,
                                                            S2: leadSourceId,
                                                            Tp: locationId,
                                                            Xa: practitionerId,
                                                            XG: pronouns,
                                                            Z3: sex,
                                                            aa4: usesTobacco
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Patient$Meta$decodeMetaFields = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lead_source_id', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'health_insurance_carrier', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'joined_practice_date', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location_id', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner_id', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_tobacco', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pronouns', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender_identity', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sex', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'gender', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'dob', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'chosen_first_name', $author$project$Utils$MetaFields$decodeEditable, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_name', $author$project$Utils$MetaFields$decodeEditable, $elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$MetaFields))))))))))))));
    var $author$project$Api$Patient$Meta$decode = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Patient$Meta$decodeMetaActions, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Patient$Meta$decodeMetaFields, $elm$json$Json$Decode$succeed($author$project$Api$Patient$Meta$Meta)));
    var $author$project$Api$Employer$Patient$Meta$metaPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'meta'
        ]), $author$project$Api$Employer$Patient$patientPath(patientId));
    };
    var $author$project$Api$Provider$Patient$Meta$metaPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'meta'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId));
    };
    var $author$project$Api$Patient$Meta$retrieve = F4(function(apiClient, session, id, toMsg) {
        var metaPath = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Patient$Meta$metaPath : $author$project$Api$Provider$Patient$Meta$metaPath;
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Patient$Meta$decode, toMsg, $author$project$Api$Data$requestTo(metaPath(id)));
    });
    var $author$project$Api$Employer$CompanyAccount$update = F4(function(apiClient, id, jsonBody, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo($author$project$Api$Employer$CompanyAccount$companyAccountPath(id))));
    });
    var $author$project$Api$Provider$Company$Account$update = F5(function(apiClient, basePath, id, jsonBody, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Account$companyAccountPath, basePath, id))));
    });
    var $author$project$Api$CompanyAccount$update = F6(function(apiClient, session, companyId, id, jsonBody, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyAccount$update, apiClient, id, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A5($author$project$Api$Provider$Company$Account$update, apiClient, $author$project$Api$Provider$Company$companyPath(companyId), id, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyRegistration$update = F5(function(apiClient, accountId, id, jsonBody, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Employer$CompanyRegistration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, id))));
    });
    var $author$project$Api$Provider$Company$Registration$update = F6(function(apiClient, companyId, companyAccountId, id, jsonBody, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$CompanyRegistration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, id))));
    });
    var $author$project$Api$CompanyRegistration$update = F7(function(apiClient, session, companyId, accountId, id, jsonBody, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5($author$project$Api$Employer$CompanyRegistration$update, apiClient, accountId, id, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6($author$project$Api$Provider$Company$Registration$update, apiClient, companyId, accountId, id, jsonBody, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, $author$project$OutMsg$handleErrorResponse(response), $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(_Utils_update(model, {
                    LI: response
                })));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var companyRegistration = response.a;
                    var patientId = $author$project$Api$Patient$Min$id($author$project$Api$CompanyRegistration$One$patient(companyRegistration));
                    return _Utils_Tuple3(_Utils_update(model, {
                        LP: response
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A4($author$project$Api$Patient$retrieve, model.Ej, model.Z$, patientId, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotPatient),
                        A4($author$project$Api$Patient$Meta$retrieve, model.Ej, model.Z$, patientId, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$GotMeta)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    LP: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, $author$project$OutMsg$handleErrorResponse(response), $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(_Utils_update(model, {
                    V7: response
                })));
            case 3:
                var response = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, $author$project$OutMsg$handleErrorResponse(response), $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$initForm(_Utils_update(model, {
                    Ue: response
                })));
            case 4:
                var subMsg = msg.a;
                var _v2 = model.ao;
                if (!_v2.$) {
                    var employeeForm = _v2.a;
                    var _v3 = A5($author$project$Components$Employee$Form$update, model.Ej, model.Z$, $elm$core$Maybe$Just(model.acy), subMsg, employeeForm);
                    var form = _v3.a;
                    var formCmd = _v3.b;
                    var formOutMsgs = _v3.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ao: $elm$core$Maybe$Just(form)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg, formCmd), formOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var _v4 = model.ao;
                if (!_v4.$) {
                    var employeeForm = _v4.a;
                    var _v5 = $author$project$Components$Employee$Form$validate(employeeForm);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var validForm = _v6.a;
                        var validFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: true
                        }), A7($author$project$Api$CompanyRegistration$update, model.Ej, model.Z$, model.fl, model.LJ, model.ER, A2($author$project$Components$Employee$Form$encodeRegistration, validFields, validForm), $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyRegistrationUpdated), _List_Nil);
                    } else {
                        var erroredForm = _v5.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ao: $elm$core$Maybe$Just(erroredForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                var _v7 = model.ao;
                if (!_v7.$) {
                    var employeeForm = _v7.a;
                    var _v8 = _Utils_Tuple2($author$project$Components$Employee$Form$validate(employeeForm), response);
                    if (!_v8.a.$ && _v8.b.$ === 3) {
                        var _v9 = _v8.a.a;
                        var validForm = _v9.a;
                        var validFields = _v9.b;
                        var _v10 = _v8.b;
                        var registration = _v10.a;
                        var createAffiliationCmd = A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg, A4($author$project$Components$Employee$Form$createEmployeeAffiliation, model.Ej, model.Z$, registration, employeeForm));
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A6($author$project$Api$CompanyAccount$update, model.Ej, model.Z$, model.fl, model.LJ, A2($author$project$Components$Employee$Form$encodeAccount, validFields, validForm), $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$CompanyAccountUpdated(registration)),
                            createAffiliationCmd
                        ])), _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        km: false
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var registration = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var patientName = $author$project$Api$Patient$Min$name($author$project$Api$CompanyRegistration$One$patient(registration));
                    return _Utils_Tuple3(_Utils_update(model, {
                        LI: $author$project$Api$Data$Loading,
                        LP: $author$project$Api$Data$Loading,
                        V7: $author$project$Api$Data$Loading,
                        km: false
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                        fl: model.fl
                    })), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated ' + patientName)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    km: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormSubmitted = {
        $: 5
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormSubmitted)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                    fl: model.fl
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('All Employees & Dependents')
                                ])),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$gray
                                ]), _List_fromArray([
                                    $elm$html$Html$text('  /  Edit Employee')
                                ]))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                                $author$project$Ui$HorizontalRule$thin
                            ])),
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Edit Employee')
                            ])),
                            function() {
                                var _v0 = model.ao;
                                if (!_v0.$) {
                                    var employeeForm = _v0.a;
                                    return A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$FormMsg), $author$project$Components$Employee$Form$view(employeeForm)));
                                } else return A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$itemsCenter
                                ]), _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_Nil)
                                ]));
                            }()
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                fl: model.fl
                            }), _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Update employee'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(model.km)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Update')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + (' | ' + model.fl)
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$view
    });
    var $author$project$Api$Provider$Report$CompanyRegistrations = 23;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterDropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCancellationReasons = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$CancellationReason$Employer = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$CancellationReason$Provider = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$CancellationReason$cancellationReasonsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'cancellation_reasons'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$CancellationReason$All$CancellationReason = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CancellationReason$Shared$CancellationReason = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CancellationReason$Shared$SharedRecord = F2(function(id, description) {
        return {
            NQ: description,
            aef: id
        };
    });
    var $author$project$Api$Employer$CancellationReason$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$CancellationReason$Shared$SharedRecord)));
    var $author$project$Api$Employer$CancellationReason$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CancellationReason$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$CancellationReason$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$CancellationReason$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$CancellationReason$listDefaults = {
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Employer$CancellationReason$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Employer$CancellationReason$listDefaults);
        return $author$project$Api$Pagination$toApiParams(options.af_);
    };
    var $author$project$Api$Employer$CancellationReason$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$CancellationReason$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Employer$CancellationReason$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$CancellationReason$cancellationReasonsPath)));
    });
    var $author$project$Api$CancellationReason$listDefaults = {
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$CancellationReason$optionalsToEmployer = function(optionals) {
        var options = optionals($author$project$Api$CancellationReason$listDefaults);
        return function(d) {
            return _Utils_update(d, {
                af_: options.af_
            });
        };
    };
    var $author$project$Api$CancellationReason$optionalsToProvider = function(optionals) {
        var options = optionals($author$project$Api$CancellationReason$listDefaults);
        return function(d) {
            return _Utils_update(d, {
                af_: options.af_
            });
        };
    };
    var $author$project$Api$CancellationReason$list = F4(function(apiClient, session, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$CancellationReason$list, apiClient, $author$project$Api$CancellationReason$optionalsToEmployer(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$CancellationReason$Employer)))) : A3($author$project$Api$Provider$CancellationReason$list, apiClient, $author$project$Api$CancellationReason$optionalsToProvider(optionals), A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$CancellationReason$Provider))));
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCancellationReasons = function(model) {
        return A4($author$project$Api$CancellationReason$list, model.Ej, model.Z$, function(d) {
            return _Utils_update(d, {
                af_: A2($author$project$Api$Pagination$withItemsPerPage, 100, model.af_)
            });
        }, $author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCancellationReasons);
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCompanyAccounts = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$CompanyAccount$MembershipPatients = 0;
    var $author$project$Api$CompanyAccount$Plan = 2;
    var $author$project$Api$CompanyAccount$Registrations = 1;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue = function(filter) {
        switch(filter){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Just('needs_approval');
            case 2:
                return $elm$core$Maybe$Just('denied');
            case 3:
                return $elm$core$Maybe$Just('active_members');
            case 4:
                return $elm$core$Maybe$Just('not_active_members');
            case 5:
                return $elm$core$Maybe$Just('eligible');
            default:
                return $elm$core$Maybe$Just('not_eligible');
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    2,
                    1,
                    0
                ]),
                Fw: $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(model.Fw),
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts = function(model) {
        return A5($author$project$Api$CompanyAccount$list, model.Ej, model.Z$, model.aef, $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams(model), $author$project$Pages$Companies$CompanyId_String$Employees$Top$GotCompanyAccounts);
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$All = 0;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$DeniedApproval = 2;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Eligible = 5;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Enrolled = 3;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$NeedsApproval = 1;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$NotEligible = 6;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$Unenrolled = 4;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterFromQuery = function(queryString) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm_community$list_extra$List$Extra$find, function(filter) {
            return _Utils_eq($author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(filter), queryString);
        }, _List_fromArray([
            1,
            2,
            3,
            4,
            5,
            6
        ])));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: shared.Ej,
            acb: $author$project$Api$Data$Loading,
            acy: company,
            LK: $author$project$Api$Data$Loading,
            cP: shared.cP,
            NK: $elm$core$Maybe$Nothing,
            xu: $elm$core$Maybe$Nothing,
            md: $author$project$Components$ExportCsv$init({
                adW: shared.afW,
                Hg: 23
            }),
            Fw: $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterFromQuery(A2($elm$core$Dict$get, 'filter', query)),
            mk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'employee-filter-dropdown',
                ahX: $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterDropdownMsg
            })),
            adV: $elm$core$Maybe$Nothing,
            aef: params.fl,
            afW: shared.afW,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            ahs: $author$project$Api$Sort$initFromQuery(query),
            eN: _List_Nil,
            HO: shared.HO
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(model),
            $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCancellationReasons(model)
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            afW: shared.afW
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$Close = {
        $: 1
    };
    var $author$project$Components$Employee$EnrollmentModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Employee$EnrollmentModal$Close);
    };
    var $author$project$Components$Company$EmployeeRow$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(model.fD),
            function() {
                var _v0 = model.fJ;
                if (!_v0.$) {
                    var enrollmentModal = _v0.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, $author$project$Components$Employee$EnrollmentModal$subscriptions(enrollmentModal));
                } else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed), model.ib)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed), model.ik))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$tableRowSubscriptions = function(tableRows) {
        return A2($elm$core$List$map, function(_v0) {
            var id = _v0.a;
            var row = _v0.b;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(id), $author$project$Components$Company$EmployeeRow$subscriptions(row));
        }, tableRows);
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $elm$core$Platform$Sub$batch($author$project$Pages$Companies$CompanyId_String$Employees$Top$tableRowSubscriptions(model.eN)),
            $author$project$Ui$Dropdown$subscriptions(model.mk),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$findTableRow = F2(function(tableRows, companyRegistrationId) {
        return $elm$core$List$head(A2($elm$core$List$filter, function(_v0) {
            var id = _v0.a;
            return _Utils_eq(id, companyRegistrationId);
        }, tableRows));
    });
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$id(shared);
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$id(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$id(companyRegistration_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$DropdownMenuMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$DownLeft = 2;
    var $author$project$Ui$Dropdown$toDownLeft = function(config) {
        return _Utils_update(config, {
            a1: 2
        });
    };
    var $author$project$Components$Company$EmployeeRow$init = F8(function(practice, session, company, currentDate, timeFormatter, cancellationReasons, companyAccount, registration) {
        return {
            acb: cancellationReasons,
            acy: company,
            LI: companyAccount,
            LP: registration,
            cP: currentDate,
            ib: $elm$core$Maybe$Nothing,
            ik: $elm$core$Maybe$Nothing,
            fD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toDownLeft($author$project$Ui$Dropdown$defaultConfig({
                aef: 'employee-actions-dropdown-' + $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(registration),
                ahX: $author$project$Components$Company$EmployeeRow$DropdownMenuMsg
            }))),
            fJ: $elm$core$Maybe$Nothing,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            HO: timeFormatter,
            ha: $elm$core$Maybe$Nothing,
            aaF: $elm$core$Maybe$Nothing
        };
    });
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$All$registrations = function(_v0) {
        var record = _v0.b;
        return record.agG;
    };
    var $author$project$Api$CompanyAccount$All$registrations = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$List$map, $author$project$Api$CompanyRegistration$ForCompanyAccountAll$Provider, $author$project$Api$Provider$CompanyAccount$All$registrations(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$List$map, $author$project$Api$CompanyRegistration$ForCompanyAccountAll$Employer, $author$project$Api$Employer$CompanyAccount$All$registrations(companyAccount_));
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$type_(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_ = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$type_(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$type_(companyRegistration_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$AccountOrRegistrationUpdated = 1;
    var $author$project$Components$Employee$EnrollmentModal$Approve = 1;
    var $author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$DependentEnrolled = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$EmployeeDenied = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$Enroll = 0;
    var $author$project$Components$Company$EmployeeRow$GotCompanyAccount = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Company$EmployeeRow$GotCompanyRegistration = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Company$EmployeeRow$None = 0;
    var $author$project$Components$Company$EmployeeRow$UnenrollModalMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$CompanyAccount$companyAccountPath = F3(function(session, companyId, accountId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            accountId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'accounts'
        ]), A2($author$project$Api$Company$companyPath, session, companyId)));
    });
    var $author$project$Api$Employer$CompanyAccount$delete = F3(function(apiClient, basePath, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(basePath));
    });
    var $author$project$Api$Provider$Company$Account$delete = F4(function(apiClient, companyId, accountId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Company$Account$companyAccountPath, $author$project$Api$Provider$Company$companyPath(companyId), accountId)));
    });
    var $author$project$Api$CompanyAccount$delete = F4(function(apiClient, session, _v0, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        if ($author$project$Api$Platform$Session$One$organizationIsCompany(session)) {
            var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
            return A3($author$project$Api$Employer$CompanyAccount$delete, apiClient, basePath, toMsg);
        } else return A4($author$project$Api$Provider$Company$Account$delete, apiClient, companyId, accountId, toMsg);
    });
    var $author$project$Api$Employer$CompanyRegistration$delete = F4(function(apiClient, accountId, registrationId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)));
    });
    var $author$project$Api$Provider$Company$Registration$delete = F5(function(apiClient, companyId, companyAccountId, registrationId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)));
    });
    var $author$project$Api$CompanyRegistration$delete = F4(function(apiClient, session, _v0, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var registrationId = _v0.nV;
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyRegistration$delete, apiClient, accountId, registrationId, toMsg) : A5($author$project$Api$Provider$Company$Registration$delete, apiClient, companyId, accountId, registrationId, toMsg);
    });
    var $author$project$Api$Employer$CompanyAccount$deny = F3(function(apiClient, basePath, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'deny'
        ]), basePath)));
    });
    var $author$project$Api$Provider$Company$Account$deny = F3(function(apiClient, basePath, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'deny'
        ]), basePath)));
    });
    var $author$project$Api$CompanyAccount$deny = F4(function(apiClient, session, _v0, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$CompanyAccount$deny, apiClient, basePath, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3($author$project$Api$Provider$Company$Account$deny, apiClient, basePath, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Components$Company$UnenrollModal$EndDateInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$Meta$defaultValue = function(_v0) {
        var meta = _v0;
        return meta.jc.qv.NE;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$defaultValue = function(_v0) {
        var meta = _v0;
        return meta.jc.qv.NE;
    };
    var $author$project$Api$CompanyAccount$Meta$defaultValue = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$defaultValue(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$defaultValue(meta_);
        }
    };
    var $author$project$Components$Company$UnenrollModal$initFormFields = function(companyAccount) {
        return {
            ab9: $elm$core$Maybe$Nothing,
            aca: $elm$core$Maybe$Nothing,
            agK: $author$project$Api$CompanyAccount$Meta$defaultValue(companyAccount)
        };
    };
    var $author$project$Api$CompanyAccount$Meta$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$CompanyAccount$Meta$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$All$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Provider$CompanyAccount$All$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$CompanyAccount$All$meta = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$CompanyAccount$Meta$Provider($author$project$Api$Provider$CompanyAccount$All$meta(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$CompanyAccount$Meta$Employer($author$project$Api$Employer$CompanyAccount$All$meta(companyAccount_));
        }
    };
    var $author$project$Components$Company$UnenrollModal$init = F6(function(session, _v0, companyAccount, registration, currentDate, minDate) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var registrationId = _v0.nV;
        var accountMeta = $author$project$Api$CompanyAccount$All$meta(companyAccount);
        var fields = $author$project$Components$Company$UnenrollModal$initFormFields(accountMeta);
        var _v1 = $author$project$Components$DateInput$init;
        var endDateInput = _v1.a;
        var endDateInputCmd = _v1.b;
        return _Utils_Tuple2({
            eW: accountId,
            LI: companyAccount,
            fl: companyId,
            LP: registration,
            cP: currentDate,
            qx: endDateInput,
            PU: $author$project$Utils$Form$init(fields),
            zg: minDate,
            nV: registrationId,
            Z$: session
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$UnenrollModal$EndDateInputMsg, endDateInputCmd));
    });
    var $author$project$Components$Employee$EnrollmentModal$GotCompanyAccount = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$GotCompanyPlans = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$Model = $elm$core$Basics$identity;
    var $author$project$Utils$Date$alignTo = F2(function(date, cutoffDay) {
        var alignedDate = A2($justinmimbs$date$Date$floor, 2, date);
        return _Utils_cmp($justinmimbs$date$Date$day(date), cutoffDay) > 0 ? A3($justinmimbs$date$Date$add, 1, 1, alignedDate) : alignedDate;
    });
    var $author$project$Api$Employer$Company$Shared$enrollmentCutOffDayOfMonth = function(_v0) {
        var record = _v0;
        return record.OY;
    };
    var $author$project$Api$Employer$Company$One$enrollmentCutOffDayOfMonth = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$enrollmentCutOffDayOfMonth(shared);
    };
    var $author$project$Api$Provider$Company$One$enrollmentCutOffDayOfMonth = function(_v0) {
        var record = _v0.b;
        return record.OY;
    };
    var $author$project$Api$Company$enrollmentCutOffDayOfMonth = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$enrollmentCutOffDayOfMonth(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$enrollmentCutOffDayOfMonth(company_);
        }
    };
    var $author$project$Api$Employer$Company$One$nextInvoiceDate = function(_v0) {
        var record = _v0.b;
        return record.U$;
    };
    var $author$project$Api$Provider$Company$Shared$nextInvoiceDate = function(_v0) {
        var record = _v0;
        return record.U$;
    };
    var $author$project$Api$Provider$Company$One$nextInvoiceDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$nextInvoiceDate(shared);
    };
    var $author$project$Api$Company$nextInvoiceDate = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$nextInvoiceDate(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$nextInvoiceDate(company_);
        }
    };
    var $author$project$Components$Employee$EnrollmentModal$init = F6(function(apiClient, currentDate, session, action, company, companyAccountId) {
        var enrollmentCutOffDayOfMonth = $author$project$Api$Company$enrollmentCutOffDayOfMonth(company);
        var alignToCutoff = function(date) {
            return A2($author$project$Utils$Date$alignTo, date, enrollmentCutOffDayOfMonth);
        };
        var defaultStart = alignToCutoff(currentDate);
        return _Utils_Tuple2({
            D7: action,
            I3: alignToCutoff,
            acy: company,
            LI: $author$project$Api$Data$Loading,
            LJ: companyAccountId,
            al: $author$project$Api$Data$Loading,
            cP: currentDate,
            xe: defaultStart,
            PU: $elm$core$Maybe$Nothing,
            U$: $author$project$Api$Company$nextInvoiceDate(company),
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            kn: ''
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A5($author$project$Api$CompanyPlan$list, apiClient, session, $author$project$Api$Company$id(company), $elm$core$Basics$identity, $author$project$Components$Employee$EnrollmentModal$GotCompanyPlans),
            A5($author$project$Api$CompanyAccount$retrieve, apiClient, session, $author$project$Api$Company$id(company), companyAccountId, $author$project$Components$Employee$EnrollmentModal$GotCompanyAccount)
        ])));
    });
    var $author$project$Api$Employer$CompanyAccount$makeEligible = F3(function(apiClient, basePath, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_eligible'
        ]), basePath)));
    });
    var $author$project$Api$Provider$Company$Account$makeEligible = F3(function(apiClient, basePath, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_eligible'
        ]), basePath)));
    });
    var $author$project$Api$CompanyAccount$makeEligible = F4(function(apiClient, session, _v0, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$CompanyAccount$makeEligible, apiClient, basePath, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3($author$project$Api$Provider$Company$Account$makeEligible, apiClient, basePath, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyRegistration$makeEligible = F4(function(apiClient, accountId, registrationId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyRegistration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_eligible'
        ]), A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId))));
    });
    var $author$project$Api$Provider$Company$Registration$makeEligible = F5(function(apiClient, companyId, companyAccountId, registrationId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyRegistration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_eligible'
        ]), A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId))));
    });
    var $author$project$Api$CompanyRegistration$makeEligible = F4(function(apiClient, session, _v0, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var registrationId = _v0.nV;
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyRegistration$makeEligible, apiClient, accountId, registrationId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5($author$project$Api$Provider$Company$Registration$makeEligible, apiClient, companyId, accountId, registrationId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyAccount$makeIneligible = F3(function(apiClient, basePath, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_ineligible'
        ]), basePath)));
    });
    var $author$project$Api$Provider$Company$Account$makeIneligible = F3(function(apiClient, basePath, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_ineligible'
        ]), basePath)));
    });
    var $author$project$Api$CompanyAccount$makeIneligible = F4(function(apiClient, session, _v0, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$CompanyAccount$makeIneligible, apiClient, basePath, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A3($author$project$Api$Provider$Company$Account$makeIneligible, apiClient, basePath, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyRegistration$makeIneligible = F4(function(apiClient, accountId, registrationId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyRegistration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_ineligible'
        ]), A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId))));
    });
    var $author$project$Api$Provider$Company$Registration$makeIneligible = F5(function(apiClient, companyId, companyAccountId, registrationId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyRegistration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'make_ineligible'
        ]), A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId))));
    });
    var $author$project$Api$CompanyRegistration$makeIneligible = F4(function(apiClient, session, _v0, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var registrationId = _v0.nV;
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyRegistration$makeIneligible, apiClient, accountId, registrationId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A5($author$project$Api$Provider$Company$Registration$makeIneligible, apiClient, companyId, accountId, registrationId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function(_v0) {
        var record = _v0.b;
        return record.T4;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function(_v0) {
        var record = _v0.b;
        return record.T4;
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(companyRegistration_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$Meta$min = function(_v0) {
        var meta = _v0;
        return meta.jc.qv.Uj;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$min = function(_v0) {
        var meta = _v0;
        return meta.jc.qv.Uj;
    };
    var $author$project$Api$CompanyAccount$Meta$min = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$min(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$min(meta_);
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Patient$Min$Provider($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration_));
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Patient$Min$Employer($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration_));
        }
    };
    var $author$project$Api$Employer$Patient$Min$age = function(_v0) {
        var record = _v0;
        return record.IZ;
    };
    var $author$project$Api$Provider$Patient$Min$age = function(_v0) {
        var min = _v0;
        return min.IZ;
    };
    var $author$project$Api$Patient$Min$age = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$Min$age(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$Min$age(patient_);
        }
    };
    var $author$project$Api$Employer$Plan$Min$maximumAge = function(_v0) {
        var record = _v0;
        return record.TQ;
    };
    var $author$project$Api$Provider$Plan$Min$maximumAge = function(_v0) {
        var record = _v0;
        return record.TQ;
    };
    var $author$project$Api$Plan$Min$maximumAge = function(plan) {
        if (!plan.$) {
            var plan_ = plan.a;
            return $author$project$Api$Provider$Plan$Min$maximumAge(plan_);
        } else {
            var plan_ = plan.a;
            return $author$project$Api$Employer$Plan$Min$maximumAge(plan_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$patientIsAboveAge = F2(function(plan, patient) {
        var _v0 = _Utils_Tuple2($author$project$Api$Plan$Min$maximumAge(plan), $author$project$Api$Patient$Min$age(patient));
        if (!_v0.a.$ && !_v0.b.$) {
            var maximumAge = _v0.a.a;
            var age = _v0.b.a;
            return _Utils_cmp(age, maximumAge) > 0;
        } else return false;
    });
    var $author$project$Api$Employer$Plan$Min$minimumAge = function(_v0) {
        var record = _v0;
        return record.Un;
    };
    var $author$project$Api$Provider$Plan$Min$minimumAge = function(_v0) {
        var record = _v0;
        return record.Un;
    };
    var $author$project$Api$Plan$Min$minimumAge = function(plan) {
        if (!plan.$) {
            var plan_ = plan.a;
            return $author$project$Api$Provider$Plan$Min$minimumAge(plan_);
        } else {
            var plan_ = plan.a;
            return $author$project$Api$Employer$Plan$Min$minimumAge(plan_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$patientIsBelowAge = F2(function(plan, patient) {
        var _v0 = _Utils_Tuple2($author$project$Api$Plan$Min$minimumAge(plan), $author$project$Api$Patient$Min$age(patient));
        if (!_v0.a.$ && !_v0.b.$) {
            var minimumAge = _v0.a.a;
            var age = _v0.b.a;
            return _Utils_cmp(age, minimumAge) < 0;
        } else return false;
    });
    var $author$project$Components$Company$EmployeeRow$patientOutsideAgeRange = F2(function(plan, companyRegistration) {
        if (!plan.$ && !plan.a.$) {
            var plan_ = plan.a.a;
            var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(companyRegistration);
            return A2($author$project$Components$Company$EmployeeRow$patientIsBelowAge, plan_, patient) || A2($author$project$Components$Company$EmployeeRow$patientIsAboveAge, plan_, patient);
        } else return false;
    });
    var $author$project$Api$Employer$CompanyAccount$All$plan = function(_v0) {
        var record = _v0.b;
        return record.GW;
    };
    var $author$project$Api$Provider$CompanyAccount$All$plan = function(_v0) {
        var record = _v0.b;
        return record.GW;
    };
    var $author$project$Api$CompanyAccount$All$plan = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2(A2($elm$core$Basics$composeR, $elm$core$Maybe$map, $author$project$Api$Expandable$map), $author$project$Api$Plan$Min$Provider, $author$project$Api$Provider$CompanyAccount$All$plan(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2(A2($elm$core$Basics$composeR, $elm$core$Maybe$map, $author$project$Api$Expandable$map), $author$project$Api$Plan$Min$Employer, $author$project$Api$Employer$CompanyAccount$All$plan(companyAccount_));
        }
    };
    var $author$project$Components$Company$UnenrollModal$CancellationReasonOtherValidation = 1;
    var $author$project$Components$Company$UnenrollModal$CancellationReasonValidation = 0;
    var $author$project$Components$Company$UnenrollModal$Closed = 1;
    var $author$project$Components$Company$UnenrollModal$EndDate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$UnenrollModal$GotCompanyAccount = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$UnenrollModal$GotCompanyRegistration = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Company$UnenrollModal$None = 0;
    var $author$project$Components$Company$UnenrollModal$Unenrolled = 2;
    var $author$project$Components$Company$UnenrollModal$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var date = field.a;
            return _Utils_update(fields, {
                agK: date
            });
        } else {
            var _v1 = field.a;
            var cancellationReason = _v1.a;
            var cancellationReasonOther = _v1.b;
            return _Utils_update(fields, {
                ab9: cancellationReason,
                aca: cancellationReasonOther
            });
        }
    });
    var $author$project$Components$CancellationReason$Input$validate = F3(function(cancellationReasonValidationGroup, cancellationReasonOtherValidationGroup, fields) {
        var _v0 = _Utils_Tuple2(A2($elm$core$Maybe$map, function($) {
            return $.NQ;
        }, fields.ab9), fields.aca);
        if (_v0.a.$ === 1) {
            var _v1 = _v0.a;
            return _List_fromArray([
                _Utils_Tuple2(cancellationReasonValidationGroup, 'Please select a reason.')
            ]);
        } else {
            if (_v0.a.a === 'Other' && _v0.b.$ === 1) {
                var _v2 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(cancellationReasonOtherValidationGroup, 'Please enter a reason')
                ]);
            } else return _List_Nil;
        }
    });
    var $author$project$Components$Company$UnenrollModal$EndDateValidation = 2;
    var $author$project$Components$Company$UnenrollModal$validateEndDate = F2(function(model, fields) {
        var _v0 = fields.agK;
        if (!_v0.$) {
            var endDate = _v0.a;
            var yesterdayDate = A3($justinmimbs$date$Date$add, 3, -1, model.cP);
            var minDate = A2($elm$core$Maybe$withDefault, yesterdayDate, model.zg);
            return A2($justinmimbs$date$Date$compare, minDate, endDate) !== 2 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(2, 'End date is invalid')
            ]);
        } else return _List_fromArray([
            _Utils_Tuple2(2, 'Please enter a date.')
        ]);
    });
    var $author$project$Components$Company$UnenrollModal$formFieldsValidator = function(model) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$UnenrollModal$validateEndDate(model)),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$CancellationReason$Input$validate, 0, 1))
        ]));
    };
    var $author$project$Api$Employer$CompanyAccount$unenroll = F4(function(apiClient, basePath, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unenroll'
        ]), basePath))));
    });
    var $author$project$Api$Provider$Company$Account$unenroll = F4(function(apiClient, basePath, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unenroll'
        ]), basePath))));
    });
    var $author$project$Api$CompanyAccount$unenroll = F5(function(apiClient, session, _v0, fields, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('requested_end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.agK)),
            _Utils_Tuple2('cancellation_reason', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ab9)),
            _Utils_Tuple2('cancellation_reason_other', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aca))
        ]));
        var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyAccount$unenroll, apiClient, basePath, body, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4($author$project$Api$Provider$Company$Account$unenroll, apiClient, basePath, body, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyRegistration$unenroll = F5(function(apiClient, accountId, registrationId, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyRegistration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unenroll'
        ]), A2($author$project$Api$Employer$CompanyRegistration$companyRegistrationPath, accountId, registrationId)))));
    });
    var $author$project$Api$Provider$Company$Registration$unenroll = F6(function(apiClient, companyId, companyAccountId, registrationId, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyRegistration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unenroll'
        ]), A3($author$project$Api$Provider$Company$Registration$companyRegistrationPath, companyId, companyAccountId, registrationId)))));
    });
    var $author$project$Api$CompanyRegistration$unenroll = F5(function(apiClient, session, _v0, fields, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var registrationId = _v0.nV;
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('requested_end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.agK)),
            _Utils_Tuple2('cancellation_reason', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ab9)),
            _Utils_Tuple2('cancellation_reason_other', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aca))
        ]));
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5($author$project$Api$Employer$CompanyRegistration$unenroll, apiClient, accountId, registrationId, body, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Employer))) : A6($author$project$Api$Provider$Company$Registration$unenroll, apiClient, companyId, accountId, registrationId, body, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyRegistration$One$Provider)));
    });
    var $author$project$Components$Company$UnenrollModal$updateDateInputFormField = F6(function(model, dateInputGetter, dateInputSetter, subMsg, toMsg, field) {
        var dateInput = dateInputGetter(model);
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return $author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$UnenrollModal$validateEndDate(model)), A3($author$project$Utils$Form$update, $author$project$Components$Company$UnenrollModal$formFieldsUpdate, field(date), model.PU)));
            } else return model.PU;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
            adu: 0,
            zi: A2(dateInputSetter, newDateInput, _Utils_update(model, {
                PU: newForm
            })),
            at: _List_Nil
        };
    });
    var $author$project$Components$Company$UnenrollModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$UnenrollModal$formFieldsValidator(model), model.PU);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var newForm = _v2.a;
                    var validFormFields = _v2.b;
                    var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var apiFields = {
                        ab9: A2($elm$core$Maybe$map, function($) {
                            return $.aef;
                        }, validFields.ab9),
                        aca: validFields.aca,
                        agK: validFields.agK
                    };
                    var unenrollCmd = function() {
                        var _v3 = model.nV;
                        if (!_v3.$) {
                            var registrationId = _v3.a;
                            return A5($author$project$Api$CompanyRegistration$unenroll, apiClient, model.Z$, {
                                eW: model.eW,
                                fl: model.fl,
                                nV: registrationId
                            }, apiFields, $author$project$Components$Company$UnenrollModal$GotCompanyRegistration);
                        } else return A5($author$project$Api$CompanyAccount$unenroll, apiClient, model.Z$, {
                            eW: model.eW,
                            fl: model.fl
                        }, apiFields, $author$project$Components$Company$UnenrollModal$GotCompanyAccount);
                    }();
                    return {
                        EQ: unenrollCmd,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v1.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var patientName = $author$project$Api$Patient$Min$name($author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.LP));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, patientName + ' is now unenrolled.')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var patientName = $author$project$Api$Patient$Min$name($author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.LP));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, patientName + ' is now unenrolled.')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var subMsg = msg.a;
                return A6($author$project$Components$Company$UnenrollModal$updateDateInputFormField, model, function($) {
                    return $.qx;
                }, F2(function(newDateInput, model_) {
                    return _Utils_update(model_, {
                        qx: newDateInput
                    });
                }), subMsg, $author$project$Components$Company$UnenrollModal$EndDateInputMsg, $author$project$Components$Company$UnenrollModal$EndDate);
            default:
                var field = msg.a;
                var newForm = $author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$CancellationReason$Input$validate, 0, 1)), A3($author$project$Utils$Form$update, $author$project$Components$Company$UnenrollModal$formFieldsUpdate, field, model.PU)));
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Employee$EnrollmentModal$Approved = 3;
    var $author$project$Components$Employee$EnrollmentModal$Closed = 1;
    var $author$project$Components$Employee$EnrollmentModal$CompanyAccountApproved = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$CompanyAccountEnrolled = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$Enrolled = 2;
    var $author$project$Components$Employee$EnrollmentModal$None = 0;
    var $author$project$Api$Employer$CompanyAccount$approve = F4(function(apiClient, basePath, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('membership_start_date', $author$project$Utils$Date$encode(fields.T4))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'approve'
        ]), basePath))));
    });
    var $author$project$Api$Provider$Company$Account$approve = F4(function(apiClient, basePath, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('membership_start_date', $author$project$Utils$Date$encode(fields.T4)),
            _Utils_Tuple2('plan', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GW))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'approve'
        ]), basePath))));
    });
    var $author$project$Api$CompanyAccount$approve = F5(function(apiClient, session, _v0, fields, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyAccount$approve, apiClient, basePath, {
            T4: fields.T4
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4($author$project$Api$Provider$Company$Account$approve, apiClient, basePath, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Api$Employer$CompanyAccount$enroll = F4(function(apiClient, basePath, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('membership_start_date', $author$project$Utils$Date$encode(fields.T4)),
            _Utils_Tuple2('plan', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GW))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enroll'
        ]), basePath))));
    });
    var $author$project$Api$Provider$Company$Account$enroll = F4(function(apiClient, basePath, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('membership_start_date', $author$project$Utils$Date$encode(fields.T4)),
            _Utils_Tuple2('plan', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.GW))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enroll'
        ]), basePath))));
    });
    var $author$project$Api$CompanyAccount$enroll = F5(function(apiClient, session, _v0, fields, toMsg) {
        var companyId = _v0.fl;
        var accountId = _v0.eW;
        var basePath = A3($author$project$Api$CompanyAccount$companyAccountPath, session, companyId, accountId);
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$CompanyAccount$enroll, apiClient, basePath, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Employer))) : A4($author$project$Api$Provider$Company$Account$enroll, apiClient, basePath, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$CompanyAccount$One$Provider)));
    });
    var $author$project$Api$Employer$Plan$Shared$maximumAge = function(_v0) {
        var record = _v0;
        return record.TQ;
    };
    var $author$project$Api$Employer$Plan$All$maximumAge = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$maximumAge(shared);
    };
    var $author$project$Api$Employer$Plan$One$maximumAge = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$maximumAge(shared);
    };
    var $author$project$Api$Provider$Plan$All$maximumAge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$maximumAge(shared);
    };
    var $author$project$Api$Plan$maximumAge = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$maximumAge(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$maximumAge(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$maximumAge(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$maximumAge(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$maximumAge(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$maximumAge(plan_);
        }
    };
    var $author$project$Api$Employer$Plan$Shared$minimumAge = function(_v0) {
        var record = _v0;
        return record.Un;
    };
    var $author$project$Api$Employer$Plan$All$minimumAge = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$minimumAge(shared);
    };
    var $author$project$Api$Employer$Plan$One$minimumAge = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$minimumAge(shared);
    };
    var $author$project$Api$Provider$Plan$All$minimumAge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$minimumAge(shared);
    };
    var $author$project$Api$Plan$minimumAge = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$minimumAge(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$minimumAge(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$minimumAge(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$minimumAge(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$minimumAge(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$minimumAge(plan_);
        }
    };
    var $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType = function(_v0) {
        var record = _v0;
        return record.aad;
    };
    var $author$project$Api$Employer$Plan$All$tobaccoSurchargeType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(shared);
    };
    var $author$project$Api$Employer$Plan$One$tobaccoSurchargeType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(shared);
    };
    var $author$project$Api$Provider$Plan$All$tobaccoSurchargeType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(shared);
    };
    var $author$project$Api$Plan$tobaccoSurchargeType = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$tobaccoSurchargeType(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$tobaccoSurchargeType(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$tobaccoSurchargeType(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$tobaccoSurchargeType(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$tobaccoSurchargeType(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$tobaccoSurchargeType(plan_);
        }
    };
    var $author$project$Components$Employee$EnrollmentModal$planFieldFromApi = function(plan) {
        return {
            aef: $author$project$Api$Plan$id(plan),
            TQ: $author$project$Api$Plan$maximumAge(plan),
            Un: $author$project$Api$Plan$minimumAge(plan),
            zr: $author$project$Api$Plan$name(plan),
            aad: $author$project$Api$Plan$tobaccoSurchargeType(plan)
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$formFieldsUpdate = F3(function(_v0, field, fields) {
        var model = _v0;
        if (!field.$) {
            var planId = field.a;
            var plans = A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, fields.al);
            var plan = A2($elm_community$list_extra$List$Extra$find, function(plan_) {
                return _Utils_eq($author$project$Api$Plan$id(plan_), planId);
            }, plans);
            return _Utils_update(fields, {
                GW: A2($elm$core$Maybe$map, $author$project$Components$Employee$EnrollmentModal$planFieldFromApi, plan)
            });
        } else {
            var date = field.a;
            return _Utils_update(fields, {
                T4: A2($elm$core$Maybe$withDefault, model.xe, date)
            });
        }
    });
    var $author$project$Components$Employee$EnrollmentModal$PlanValidation = 0;
    var $author$project$Components$Employee$EnrollmentModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.GW;
        }, _Utils_Tuple2(0, 'Please pick a plan'))
    ]));
    var $author$project$Api$Employer$CompanyPlan$Shared$isDefault = function(_v0) {
        var record = _v0;
        return record.R0;
    };
    var $author$project$Api$Employer$CompanyPlan$All$isDefault = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyPlan$Shared$isDefault(shared);
    };
    var $author$project$Api$Provider$CompanyPlan$Shared$isDefault = function(_v0) {
        var record = _v0;
        return record.R0;
    };
    var $author$project$Api$Provider$CompanyPlan$One$isDefault = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyPlan$Shared$isDefault(shared);
    };
    var $author$project$Api$Provider$CompanyPlan$All$isDefault = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$CompanyPlan$One$isDefault(one);
    };
    var $author$project$Api$CompanyPlan$isDefault = function(companyPlan) {
        switch(companyPlan.$){
            case 0:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Provider$CompanyPlan$One$isDefault(companyPlan_);
            case 1:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Provider$CompanyPlan$All$isDefault(companyPlan_);
            default:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Employer$CompanyPlan$All$isDefault(companyPlan_);
        }
    };
    var $author$project$Api$Employer$Plan$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Plan$Min$name = function(plan) {
        if (!plan.$) {
            var plan_ = plan.a;
            return $author$project$Api$Provider$Plan$Min$name(plan_);
        } else {
            var plan_ = plan.a;
            return $author$project$Api$Employer$Plan$Min$name(plan_);
        }
    };
    var $author$project$Api$Employer$Plan$Min$tobaccoSurchargeType = function(_v0) {
        var record = _v0;
        return record.aad;
    };
    var $author$project$Api$Provider$Plan$Min$tobaccoSurchargeType = function(_v0) {
        var record = _v0;
        return record.aad;
    };
    var $author$project$Api$Plan$Min$tobaccoSurchargeType = function(plan) {
        if (!plan.$) {
            var plan_ = plan.a;
            return $author$project$Api$Provider$Plan$Min$tobaccoSurchargeType(plan_);
        } else {
            var plan_ = plan.a;
            return $author$project$Api$Employer$Plan$Min$tobaccoSurchargeType(plan_);
        }
    };
    var $author$project$Components$Employee$EnrollmentModal$planFieldFromApiMin = function(plan) {
        return {
            aef: $author$project$Api$Plan$Min$id(plan),
            TQ: $author$project$Api$Plan$Min$maximumAge(plan),
            Un: $author$project$Api$Plan$Min$minimumAge(plan),
            zr: $author$project$Api$Plan$Min$name(plan),
            aad: $author$project$Api$Plan$Min$tobaccoSurchargeType(plan)
        };
    };
    var $author$project$Api$Employer$CompanyAccount$One$selectedPlan = function(_v0) {
        var record = _v0.b;
        return record.ZF;
    };
    var $author$project$Api$Provider$CompanyAccount$One$selectedPlan = function(_v0) {
        var record = _v0.b;
        return record.ZF;
    };
    var $author$project$Api$CompanyAccount$One$selectedPlan = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Plan$Min$Provider, $author$project$Api$Provider$CompanyAccount$One$selectedPlan(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Plan$Min$Employer, $author$project$Api$Employer$CompanyAccount$One$selectedPlan(companyAccount_));
        }
    };
    var $author$project$Components$Employee$EnrollmentModal$initFormFields = F3(function(defaultStart, companyAccount, companyPlans) {
        var plans = A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, companyPlans);
        var plan = function() {
            if ($elm$core$List$length(plans) === 1) return A2($elm$core$Maybe$map, $author$project$Components$Employee$EnrollmentModal$planFieldFromApi, $elm$core$List$head(plans));
            else {
                var defaultCompanyPlan = A2($elm_community$list_extra$List$Extra$find, function(companyPlan) {
                    return $author$project$Api$CompanyPlan$isDefault(companyPlan);
                }, companyPlans);
                var _v0 = _Utils_Tuple2($author$project$Api$CompanyAccount$One$selectedPlan(companyAccount), A2($elm$core$Maybe$map, $author$project$Api$CompanyPlan$plan, defaultCompanyPlan));
                if (!_v0.a.$) {
                    var selectedPlan = _v0.a.a;
                    return $elm$core$Maybe$Just($author$project$Components$Employee$EnrollmentModal$planFieldFromApiMin(selectedPlan));
                } else if (!_v0.b.$) {
                    var _v1 = _v0.a;
                    var defaultPlan = _v0.b.a;
                    return $elm$core$Maybe$Just($author$project$Components$Employee$EnrollmentModal$planFieldFromApi(defaultPlan));
                } else {
                    var _v2 = _v0.a;
                    var _v3 = _v0.b;
                    return A2($elm$core$Maybe$map, $author$project$Components$Employee$EnrollmentModal$planFieldFromApi, $elm$core$List$head(plans));
                }
            }
        }();
        return {
            LI: companyAccount,
            al: companyPlans,
            T4: defaultStart,
            GW: plan
        };
    });
    var $author$project$Components$Employee$EnrollmentModal$initForm = F3(function(companyAccount, companyPlans, defaultStart) {
        var fields = function() {
            var _v0 = _Utils_Tuple2(companyAccount, companyPlans);
            if (_v0.a.$ === 3 && _v0.b.$ === 3) {
                var _v1 = _v0.a;
                var companyAccount_ = _v1.a;
                var _v2 = _v0.b;
                var companyPlans_ = _v2.a;
                return $elm$core$Maybe$Just(A3($author$project$Components$Employee$EnrollmentModal$initFormFields, defaultStart, companyAccount_, companyPlans_));
            } else return $elm$core$Maybe$Nothing;
        }();
        return A2($elm$core$Maybe$map, $author$project$Utils$Form$init, fields);
    });
    var $author$project$Api$Employer$CompanyAccount$One$subscriber = function(_v0) {
        var record = _v0.b;
        return record.$r;
    };
    var $author$project$Api$Provider$CompanyAccount$One$subscriber = function(_v0) {
        var record = _v0.b;
        return record.$r;
    };
    var $author$project$Api$CompanyAccount$One$subscriberName = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$name, $author$project$Api$Provider$CompanyAccount$One$subscriber(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$Employer$Patient$Shared$name, $author$project$Api$Employer$CompanyAccount$One$subscriber(companyAccount_));
        }
    };
    var $author$project$Components$Employee$EnrollmentModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = model.PU;
                if (!_v2.$) {
                    var form = _v2.a;
                    var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Employee$EnrollmentModal$formFieldsValidator, form);
                    if (!_v3.$) {
                        var _v4 = _v3.a;
                        var newForm = _v4.a;
                        var validFormFields = _v4.b;
                        var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                        var employeeParams = {
                            eW: model.LJ,
                            fl: $author$project$Api$Company$id(model.acy)
                        };
                        var apiFields = {
                            T4: validFields.T4,
                            GW: A2($elm$core$Maybe$map, function($) {
                                return $.aef;
                            }, validFields.GW)
                        };
                        return {
                            EQ: function() {
                                var _v5 = model.D7;
                                if (!_v5) return A5($author$project$Api$CompanyAccount$enroll, apiClient, model.Z$, employeeParams, apiFields, $author$project$Components$Employee$EnrollmentModal$CompanyAccountEnrolled);
                                else return A5($author$project$Api$CompanyAccount$approve, apiClient, model.Z$, employeeParams, apiFields, $author$project$Components$Employee$EnrollmentModal$CompanyAccountApproved);
                            }(),
                            adu: 0,
                            zi: _Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm),
                                j_: $author$project$Api$Data$Loading
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var newForm = _v3.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                PU: $elm$core$Maybe$Just(newForm)
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var companyAccount = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            LI: response,
                            PU: A3($author$project$Components$Employee$EnrollmentModal$initForm, response, model.al, model.xe),
                            kn: A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$CompanyAccount$One$subscriberName(companyAccount))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        al: response,
                        PU: A3($author$project$Components$Employee$EnrollmentModal$initForm, model.LI, response, model.xe)
                    }),
                    at: _List_Nil
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, model.kn + ' was enrolled')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 5:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 3,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, model.kn + ' was enrolled')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var field = msg.a;
                var _v10 = model.PU;
                if (!_v10.$) {
                    var form = _v10.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Employee$EnrollmentModal$formFieldsUpdate(model), field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Company$EmployeeRow$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.fD);
                var dropdown = _v1.a;
                var cmd = _v1.b;
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fD: dropdown
                    }),
                    at: _List_Nil
                };
            case 1:
                var employeeOrDependent_ = msg.a;
                var madeEligibleCmd = function() {
                    if (!employeeOrDependent_.$) {
                        var employee = employeeOrDependent_.a;
                        return A4($author$project$Api$CompanyAccount$makeEligible, apiClient, model.Z$, {
                            eW: $author$project$Api$CompanyAccount$All$id(employee),
                            fl: $author$project$Api$Company$id(model.acy)
                        }, $author$project$Components$Company$EmployeeRow$GotCompanyAccount('eligible'));
                    } else {
                        var dependent = employeeOrDependent_.a;
                        return A4($author$project$Api$CompanyRegistration$makeEligible, apiClient, model.Z$, {
                            eW: $author$project$Api$CompanyAccount$All$id(model.LI),
                            fl: $author$project$Api$Company$id(model.acy),
                            nV: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
                        }, $author$project$Components$Company$EmployeeRow$GotCompanyRegistration('eligible'));
                    }
                }();
                return {
                    EQ: madeEligibleCmd,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var employeeOrDependent_ = msg.a;
                var madeIneligibleCmd = function() {
                    if (!employeeOrDependent_.$) {
                        var employee = employeeOrDependent_.a;
                        return A4($author$project$Api$CompanyAccount$makeIneligible, apiClient, model.Z$, {
                            eW: $author$project$Api$CompanyAccount$All$id(employee),
                            fl: $author$project$Api$Company$id(model.acy)
                        }, $author$project$Components$Company$EmployeeRow$GotCompanyAccount('ineligible'));
                    } else {
                        var dependent = employeeOrDependent_.a;
                        return A4($author$project$Api$CompanyRegistration$makeIneligible, apiClient, model.Z$, {
                            eW: $author$project$Api$CompanyAccount$All$id(model.LI),
                            fl: $author$project$Api$Company$id(model.acy),
                            nV: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
                        }, $author$project$Components$Company$EmployeeRow$GotCompanyRegistration('ineligible'));
                    }
                }();
                return {
                    EQ: madeIneligibleCmd,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 3:
                var actionString = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var patientName = $author$project$Api$Patient$Min$name($author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.LP));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, patientName + (' was made ' + actionString))
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                var actionString = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var patientName = $author$project$Api$Patient$Min$name($author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.LP));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, patientName + (' was made ' + actionString))
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var patientName = $author$project$Api$Patient$Min$name($author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.LP));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, patientName + ' was deleted.')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 6:
                var employeeOrDependent_ = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ib: employeeOrDependent_
                    }),
                    at: _List_Nil
                };
            case 7:
                var employeeOrDependent_ = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var deleteCmd = function() {
                        if (!employeeOrDependent_.$) {
                            var employee = employeeOrDependent_.a;
                            return A4($author$project$Api$CompanyAccount$delete, apiClient, model.Z$, {
                                eW: $author$project$Api$CompanyAccount$All$id(employee),
                                fl: $author$project$Api$Company$id(model.acy)
                            }, $author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved);
                        } else {
                            var dependent = employeeOrDependent_.a;
                            return A4($author$project$Api$CompanyRegistration$delete, apiClient, model.Z$, {
                                eW: $author$project$Api$CompanyAccount$All$id(model.LI),
                                fl: $author$project$Api$Company$id(model.acy),
                                nV: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
                            }, $author$project$Components$Company$EmployeeRow$CompanyAccountOrRegistrationRemoved);
                        }
                    }();
                    return {
                        EQ: deleteCmd,
                        adu: 0,
                        zi: _Utils_update(model, {
                            ib: $elm$core$Maybe$Just(employeeOrDependent_)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ib: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 15:
                var employeeOrDependent_ = msg.a;
                var _v8 = function() {
                    if (!employeeOrDependent_.$) {
                        var employee = employeeOrDependent_.a;
                        var accountMeta = $author$project$Api$CompanyAccount$All$meta(model.LI);
                        return _Utils_Tuple3($author$project$Api$CompanyAccount$All$id(employee), $elm$core$Maybe$Nothing, $author$project$Api$CompanyAccount$Meta$min(accountMeta));
                    } else {
                        var dependent = employeeOrDependent_.a;
                        return _Utils_Tuple3($author$project$Api$CompanyAccount$All$id(model.LI), $elm$core$Maybe$Just($author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)), $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(dependent));
                    }
                }();
                var accountId = _v8.a;
                var registrationId = _v8.b;
                var minDate = _v8.c;
                var _v10 = A6($author$project$Components$Company$UnenrollModal$init, model.Z$, {
                    eW: accountId,
                    fl: $author$project$Api$Company$id(model.acy),
                    nV: registrationId
                }, model.LI, model.LP, model.cP, minDate);
                var unenrollModal = _v10.a;
                var unenrollModalCmd = _v10.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$UnenrollModalMsg, unenrollModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        ha: $elm$core$Maybe$Just(unenrollModal)
                    }),
                    at: _List_Nil
                };
            case 8:
                var employeeOrDependent_ = msg.a;
                if (!employeeOrDependent_.$) {
                    var companyAccount = employeeOrDependent_.a;
                    var _v12 = A6($author$project$Components$Employee$EnrollmentModal$init, apiClient, model.cP, model.Z$, 0, model.acy, $author$project$Api$CompanyAccount$All$id(companyAccount));
                    var enrollmentModal = _v12.a;
                    var enrollmentModalCmd = _v12.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalCmd),
                        adu: 0,
                        zi: _Utils_update(model, {
                            fJ: $elm$core$Maybe$Just(enrollmentModal)
                        }),
                        at: _List_Nil
                    };
                } else {
                    var dependent = employeeOrDependent_.a;
                    var showPlanAgeWarning = A2($author$project$Components$Company$EmployeeRow$patientOutsideAgeRange, $author$project$Api$CompanyAccount$All$plan(model.LI), dependent);
                    return {
                        EQ: showPlanAgeWarning ? $elm$core$Platform$Cmd$none : A5($author$project$Api$CompanyRegistration$enroll, apiClient, model.Z$, {
                            eW: $author$project$Api$CompanyAccount$All$id(model.LI),
                            fl: $author$project$Api$Company$id(model.acy),
                            nV: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
                        }, $elm$json$Json$Encode$object(_List_Nil), $author$project$Components$Company$EmployeeRow$DependentEnrolled),
                        adu: 0,
                        zi: showPlanAgeWarning ? _Utils_update(model, {
                            ik: $elm$core$Maybe$Just(dependent)
                        }) : _Utils_update(model, {
                            j_: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                }
            case 10:
                var dependent = msg.a;
                var confirmed = msg.b;
                return confirmed ? {
                    EQ: A5($author$project$Api$CompanyRegistration$enroll, apiClient, model.Z$, {
                        eW: $author$project$Api$CompanyAccount$All$id(model.LI),
                        fl: $author$project$Api$Company$id(model.acy),
                        nV: $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(dependent)
                    }, $elm$json$Json$Encode$object(_List_Nil), $author$project$Components$Company$EmployeeRow$DependentEnrolled),
                    adu: 0,
                    zi: _Utils_update(model, {
                        ik: $elm$core$Maybe$Nothing,
                        j_: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ik: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 9:
                var response = msg.a;
                if (response.$ === 3) {
                    var patientName = $author$project$Api$Patient$Min$name($author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.LP));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            j_: $author$project$Api$Data$NotAsked
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, patientName + ' was successfully enrolled.')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 16:
                var subMsg = msg.a;
                var _v14 = model.ha;
                if (!_v14.$) {
                    var unenrollModal = _v14.a;
                    var unenrollModalResult = A3($author$project$Components$Company$UnenrollModal$update, apiClient, subMsg, unenrollModal);
                    var event = function() {
                        var _v17 = unenrollModalResult.adu;
                        if (_v17 === 2) return 1;
                        else return 0;
                    }();
                    var _v15 = function() {
                        var _v16 = unenrollModalResult.adu;
                        switch(_v16){
                            case 0:
                                return _Utils_Tuple3(_Utils_update(model, {
                                    ha: $elm$core$Maybe$Just(unenrollModalResult.zi)
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            case 1:
                                return _Utils_Tuple3(_Utils_update(model, {
                                    ha: $elm$core$Maybe$Nothing
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            default:
                                return _Utils_Tuple3(_Utils_update(model, {
                                    ha: $elm$core$Maybe$Nothing
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                        }
                    }();
                    var newModel = _v15.a;
                    var cmd = _v15.b;
                    var outMsgs = _v15.c;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$UnenrollModalMsg, unenrollModalResult.EQ),
                            cmd
                        ])),
                        adu: event,
                        zi: newModel,
                        at: _Utils_ap(unenrollModalResult.at, outMsgs)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 11:
                var _v18 = A6($author$project$Components$Employee$EnrollmentModal$init, apiClient, model.cP, model.Z$, 1, model.acy, $author$project$Api$CompanyAccount$All$id(model.LI));
                var enrollmentModal = _v18.a;
                var enrollmentModalCmd = _v18.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fJ: $elm$core$Maybe$Just(enrollmentModal)
                    }),
                    at: _List_Nil
                };
            case 12:
                var subMsg = msg.a;
                var _v19 = model.fJ;
                if (!_v19.$) {
                    var enrollmentModal = _v19.a;
                    var enrollmentModalResult = A3($author$project$Components$Employee$EnrollmentModal$update, apiClient, subMsg, enrollmentModal);
                    var _v20 = function() {
                        var _v21 = enrollmentModalResult.adu;
                        switch(_v21){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(enrollmentModalResult.zi), 0);
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 0);
                            case 2:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, 1);
                        }
                    }();
                    var newEnrollmentModal = _v20.a;
                    var event = _v20.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, enrollmentModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            fJ: newEnrollmentModal
                        }),
                        at: enrollmentModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 13:
                return {
                    EQ: A4($author$project$Api$CompanyAccount$deny, apiClient, model.Z$, {
                        eW: $author$project$Api$CompanyAccount$All$id(model.LI),
                        fl: $author$project$Api$Company$id(model.acy)
                    }, $author$project$Components$Company$EmployeeRow$EmployeeDenied),
                    adu: 0,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            case 14:
                var response = msg.a;
                if (response.$ === 3) {
                    var patientName = A2($elm$core$Maybe$withDefault, '', $author$project$Api$CompanyAccount$All$subscriberName(model.LI));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            j_: $author$project$Api$Data$NotAsked
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, patientName + ' is denied and they will no longer be eligible.')
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var registrationId = msg.a;
                return {
                    EQ: A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top({
                        fl: $author$project$Api$Company$id(model.acy),
                        ac2: registrationId,
                        adk: $author$project$Api$CompanyAccount$All$id(model.LI)
                    })),
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateTableRows = F2(function(tableRows, _v0) {
        var registrationId = _v0.a;
        var rowToUpdate = _v0.b;
        return A2($elm$core$List$map, function(_v1) {
            var id = _v1.a;
            var row = _v1.b;
            return _Utils_eq(id, registrationId) ? _Utils_Tuple2(registrationId, rowToUpdate) : _Utils_Tuple2(id, row);
        }, tableRows);
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('filter'), $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToValue(model.Fw))
        ]);
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                fl: model.aef
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var companyAccounts = response.a;
                    var headers = response.b;
                    var intFromHeader = F2(function(key, headers_) {
                        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, key, headers_)));
                    });
                    var totalAmount = A2(intFromHeader, 'x-total-amount', headers);
                    var totalDueAmount = A2(intFromHeader, 'x-total-due-amount', headers);
                    var employeePrioritized = function(registration) {
                        return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(registration) === 'employee' ? 0 : 1;
                    };
                    var orderedRegistrations = function(account) {
                        return A2($elm$core$List$sortBy, employeePrioritized, $author$project$Api$CompanyAccount$All$registrations(account));
                    };
                    var tableRows = A3($elm$core$List$foldr, $elm$core$Basics$append, _List_Nil, A2($elm$core$List$map, function(account) {
                        return A2($elm$core$List$map, function(reg) {
                            return _Utils_Tuple2($author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(reg), A8($author$project$Components$Company$EmployeeRow$init, model.W1, model.Z$, model.acy, model.cP, model.HO, model.acb, account, reg));
                        }, orderedRegistrations(account));
                    }, companyAccounts));
                    var employeeCount = A2(intFromHeader, 'x-employee-count', headers);
                    var dependentCount = A2(intFromHeader, 'x-dependent-count', headers);
                    return _Utils_Tuple3(_Utils_update(model, {
                        LK: response,
                        NK: $elm$core$Maybe$Just(dependentCount),
                        xu: $elm$core$Maybe$Just(employeeCount),
                        adV: $elm$core$Maybe$Just(_Utils_Tuple2(totalAmount, totalDueAmount)),
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        eN: tableRows
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    LK: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    LK: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(newModel),
                    $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var registrationId = msg.a;
                var subMsg = msg.b;
                var _v2 = A2($author$project$Pages$Companies$CompanyId_String$Employees$Top$findTableRow, model.eN, registrationId);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var employeeRow = _v3.b;
                    var employeeRowResult = A3($author$project$Components$Company$EmployeeRow$update, model.Ej, subMsg, employeeRow);
                    var refreshCmd = function() {
                        var _v5 = employeeRowResult.adu;
                        if (!_v5) return $elm$core$Platform$Cmd$none;
                        else return $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(model);
                    }();
                    var _v4 = _Utils_Tuple3(employeeRowResult.zi, employeeRowResult.EQ, employeeRowResult.at);
                    var newEmployeeRow = _v4.a;
                    var employeeRowCmd = _v4.b;
                    var employeeRowOutMsgs = _v4.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        eN: A2($author$project$Pages$Companies$CompanyId_String$Employees$Top$updateTableRows, model.eN, _Utils_Tuple2(id, newEmployeeRow))
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        refreshCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId), employeeRowCmd)
                    ])), employeeRowOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v6.a;
                var searchInputCmd = _v6.b;
                var searchInputEvent = _v6.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v7 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            LK: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(qModel),
                            $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v9 = A2($author$project$Ui$Dropdown$update, subMsg, model.mk);
                var dropdown = _v9.a;
                var dropdownCmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mk: dropdown
                }), dropdownCmd, _List_Nil);
            case 5:
                var option = msg.a;
                var newModel = _Utils_update(model, {
                    LK: $author$project$Api$Data$Loading,
                    Fw: option
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchCompanyAccounts(newModel),
                    $author$project$Pages$Companies$CompanyId_String$Employees$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 6:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    acb: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v10 = A3($author$project$Components$ExportCsv$update, model.Ej, subMsg, model.md);
                var exportCsv = _v10.a;
                var subCmd = _v10.b;
                var subOutMsg = _v10.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployerOrProviderCompany = $elm$core$Basics$identity;
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$companyType = function(company) {
        return A2($elm$core$Maybe$map, function(company_) {
            var company__ = company_;
            return $author$project$Api$Company$companyType(company__);
        }, company);
    };
    var $author$project$Api$CompanyRegistration$exportPath = F2(function(session, companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'export'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'accounts'
        ]), A2($author$project$Api$Company$companyPath, session, companyId)));
    });
    var $author$project$Components$ExportCsv$link = A3($author$project$Ui$Button$view, {
        abP: 'Export to csv'
    }, _List_fromArray([
        $author$project$Ui$Button$link,
        $author$project$Ui$Button$onClick($author$project$Components$ExportCsv$OpenModal),
        $author$project$Ui$Button$icon($author$project$Ui$Icon$export)
    ]), _List_fromArray([
        $elm$html$Html$text('Export to CSV')
    ]));
    var $author$project$Api$CompanyAccount$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$CompanyAccount$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Fw;
                if (!_v0.$) {
                    var filter = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', filter)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.agq;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.aef;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Components$Company$EmployeeRow$deleteModal = function(model) {
        var _v0 = model.ib;
        if (!_v0.$) {
            var employee = _v0.a;
            var patientName = $author$project$Api$Patient$Min$name($author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.LP));
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Company$EmployeeRow$DeleteHiConfirmClosed(employee), _List_fromArray([
                $author$project$Components$HiConfirm$verb('remove'),
                $author$project$Components$HiConfirm$noun(patientName),
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    $elm$html$Html$text('Removing this relationship will delete the patient history with this company. Are you sure you want to remove?')
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$EmployeeRow$viewEnrollDependentModal = function(model) {
        var _v0 = model.ik;
        if (!_v0.$) {
            var dependent = _v0.a;
            var customMessage = function() {
                var _v1 = $author$project$Api$CompanyAccount$All$plan(model.LI);
                if (!_v1.$ && !_v1.a.$) {
                    var plan = _v1.a.a;
                    var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(dependent);
                    var _v2 = A2($author$project$Components$Company$EmployeeRow$patientIsBelowAge, plan, patient) ? _Utils_Tuple2(A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Plan$Min$minimumAge(plan)), 'minimum') : A2($author$project$Components$Company$EmployeeRow$patientIsAboveAge, plan, patient) ? _Utils_Tuple2(A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Plan$Min$maximumAge(plan)), 'maximum') : _Utils_Tuple2(0, '');
                    var ageLimit = _v2.a;
                    var ageLimitType = _v2.b;
                    return _List_fromArray([
                        $elm$html$Html$text('The ' + (ageLimitType + (' age defined for this plan is ' + ($elm$core$String$fromInt(ageLimit) + ('. ' + ($author$project$Api$Patient$Min$name(patient) + (' is ' + (A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Patient$Min$age(patient))) + ' years old. Do you want to proceed anyway?'))))))))
                    ]);
                } else return _List_Nil;
            }();
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Company$EmployeeRow$DependentPlanAgeWarningHiConfirmClosed(dependent), _List_fromArray([
                $author$project$Components$HiConfirm$verb('enroll'),
                $author$project$Components$HiConfirm$noun($author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(dependent) === 'spouse' ? 'adult' : $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(dependent)),
                $author$project$Components$HiConfirm$customMessage(customMessage)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Employee$EnrollmentModal$Save = {
        $: 0
    };
    var $author$project$Ui$Modal$htmlTitle = function(contents) {
        return A2($elm$html$Html$h4, _List_fromArray([
            $elm$html$Html$Attributes$class('modal-title')
        ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), contents));
    };
    var $author$project$Components$Employee$EnrollmentModal$FormUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$MembershipStartDate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Employee$EnrollmentModal$MembershipStartDateValidation = 1;
    var $author$project$Components$Employee$EnrollmentModal$Plan = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Utils$Date$isBeforeOrEqual = F2(function(date, otherDate) {
        return A2($author$project$Utils$Date$isBefore, date, otherDate) || _Utils_eq(date, otherDate);
    });
    var $author$project$Ui$Form$Select$dateOptions = function(dates) {
        return A2($elm$core$List$map, function(date) {
            var dateString = $justinmimbs$date$Date$toIsoString(date);
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(dateString), A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
        }, dates);
    };
    var $author$project$Utils$Date$nextTwelveMonths = function(referenceDate) {
        return A2($elm$core$List$map, function(offset) {
            return A3($justinmimbs$date$Date$add, 1, offset, referenceDate);
        }, A2($elm$core$List$range, 0, 11));
    };
    var $author$project$Components$Employee$EnrollmentModal$membershipStartDateOptions = F2(function(currentDate, alignToCutoff) {
        var startDate = A3($justinmimbs$date$Date$add, 1, -6, alignToCutoff(currentDate));
        return $author$project$Ui$Form$Select$dateOptions($author$project$Utils$Date$nextTwelveMonths(startDate));
    });
    var $author$project$Api$Employer$CompanyPlan$Shared$availableForEnrollment = function(_v0) {
        var record = _v0;
        return record.JZ;
    };
    var $author$project$Api$Employer$CompanyPlan$All$availableForEnrollment = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyPlan$Shared$availableForEnrollment(shared);
    };
    var $author$project$Api$Provider$CompanyPlan$Shared$availableForEnrollment = function(_v0) {
        var record = _v0;
        return record.JZ;
    };
    var $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyPlan$Shared$availableForEnrollment(shared);
    };
    var $author$project$Api$Provider$CompanyPlan$All$availableForEnrollment = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment(one);
    };
    var $author$project$Api$CompanyPlan$availableForEnrollment = function(companyPlan) {
        switch(companyPlan.$){
            case 0:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Provider$CompanyPlan$One$availableForEnrollment(companyPlan_);
            case 1:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Provider$CompanyPlan$All$availableForEnrollment(companyPlan_);
            default:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Employer$CompanyPlan$All$availableForEnrollment(companyPlan_);
        }
    };
    var $author$project$Components$Employee$EnrollmentModal$planOptions = function(companyPlans) {
        return A2($elm$core$List$map, function(companyPlan) {
            var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
            var label = !$author$project$Api$CompanyPlan$availableForEnrollment(companyPlan) ? $author$project$Api$Plan$name(plan) + ' (Hidden for new enrollments)' : $author$project$Api$Plan$name(plan);
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Plan$id(plan)), label);
        }, companyPlans);
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$patient = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Patient$Min$Provider($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOne$patient(companyRegistration_));
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Patient$Min$Employer($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountOne$patient(companyRegistration_));
        }
    };
    var $author$project$Components$Employee$EnrollmentModal$patientsOutsideAgeRange = F2(function(plan, companyRegistrations) {
        var patients = A2($elm$core$List$map, $author$project$Api$CompanyRegistration$ForCompanyAccountOne$patient, companyRegistrations);
        var belowAgePatients = A2($elm$core$List$filter, function(patient) {
            var _v1 = _Utils_Tuple2(plan.Un, $author$project$Api$Patient$Min$age(patient));
            if (!_v1.a.$ && !_v1.b.$) {
                var minimumAge = _v1.a.a;
                var age = _v1.b.a;
                return _Utils_cmp(age, minimumAge) < 0;
            } else return false;
        }, patients);
        var aboveAgePatients = A2($elm$core$List$filter, function(patient) {
            var _v0 = _Utils_Tuple2(plan.TQ, $author$project$Api$Patient$Min$age(patient));
            if (!_v0.a.$ && !_v0.b.$) {
                var maximumAge = _v0.a.a;
                var age = _v0.b.a;
                return _Utils_cmp(age, maximumAge) > 0;
            } else return false;
        }, patients);
        return _Utils_Tuple2(belowAgePatients, aboveAgePatients);
    });
    var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountOne$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$One$registrations = function(_v0) {
        var record = _v0.b;
        return record.agG;
    };
    var $author$project$Api$CompanyAccount$One$registrations = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$List$map, $author$project$Api$CompanyRegistration$ForCompanyAccountOne$Provider, $author$project$Api$Provider$CompanyAccount$One$registrations(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$List$map, $author$project$Api$CompanyRegistration$ForCompanyAccountOne$Employer, $author$project$Api$Employer$CompanyAccount$One$registrations(companyAccount_));
        }
    };
    var $author$project$Components$Employee$EnrollmentModal$viewPatient = function(patient) {
        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Api$Patient$Min$name(patient))
            ])),
            $elm$html$Html$text(' is '),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Patient$Min$age(patient))))
            ])),
            $elm$html$Html$text(' years old.')
        ]));
    };
    var $author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange = F3(function(range, limit, patients) {
        return A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
            $elm$html$Html$text('The '),
            $elm$html$Html$text(range),
            $elm$html$Html$text(' age defined for this plan is '),
            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, limit))),
            $elm$html$Html$text('.'),
            A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, $author$project$Components$Employee$EnrollmentModal$viewPatient, patients))
        ]));
    });
    var $author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRangeWarning = F2(function(plan, companyAccount) {
        var _v0 = A2($author$project$Components$Employee$EnrollmentModal$patientsOutsideAgeRange, plan, $author$project$Api$CompanyAccount$One$registrations(companyAccount));
        var belowAgePatients = _v0.a;
        var aboveAgePatients = _v0.b;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $elm$core$List$length(belowAgePatients) >= 1 ? A3($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange, 'minimum', plan.Un, belowAgePatients) : $author$project$Utils$Html$empty,
            $elm$core$List$length(aboveAgePatients) >= 1 ? A3($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRange, 'maximum', plan.TQ, aboveAgePatients) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Employee$EnrollmentModal$viewForm = F2(function(form, _v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(form);
        var membershipStartsAfterEligibility = function() {
            var _v2 = $author$project$Api$CompanyAccount$One$eligibilityStartDate(fields.LI);
            if (!_v2.$) {
                var eligibilityStartDate = _v2.a;
                return A2($author$project$Utils$Date$isBeforeOrEqual, eligibilityStartDate, fields.T4);
            } else return true;
        }();
        var chargesOnNextInvoice = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, function(nextInvoiceDate) {
            var monthsUntilBill = A3($justinmimbs$date$Date$diff, 1, fields.T4, nextInvoiceDate) + 1;
            return A2($elm$core$Basics$max, monthsUntilBill, 0);
        }, model.U$));
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$onSubmit($author$project$Components$Employee$EnrollmentModal$Save),
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Plan'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $elm$core$List$length(fields.al) > 1 ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, fields.GW)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Employee$EnrollmentModal$FormUpdated, $author$project$Components$Employee$EnrollmentModal$Plan)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]), $author$project$Components$Employee$EnrollmentModal$planOptions(fields.al)) : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, function($) {
                        return $.zr;
                    }, fields.GW)))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Start Membership'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($justinmimbs$date$Date$toIsoString(fields.T4))),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Employee$EnrollmentModal$FormUpdated, $author$project$Components$Employee$EnrollmentModal$MembershipStartDate), $elm$core$Result$toMaybe), $justinmimbs$date$Date$fromIsoString)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]), A2($author$project$Components$Employee$EnrollmentModal$membershipStartDateOptions, model.cP, model.I3))
            ])),
            chargesOnNextInvoice <= 1 ? A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                $elm$html$Html$text('We will charge for this employee starting on the draft '),
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, fields.T4)),
                $elm$html$Html$text(' invoice.')
            ])) : $author$project$Utils$Html$empty,
            !_Utils_eq(A2($elm$core$Maybe$andThen, function($) {
                return $.aad;
            }, fields.GW), $elm$core$Maybe$Nothing) ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text("This plan includes a tobacco surcharge. Please review each member\u2019s tobacco use to ensure pricing is accurate.")
            ])) : $author$project$Utils$Html$empty,
            chargesOnNextInvoice > 1 || !membershipStartsAfterEligibility ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                chargesOnNextInvoice > 1 ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('We will back bill this enrollee starting from '),
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, fields.T4)),
                    $elm$html$Html$text('. '),
                    $elm$html$Html$text('All charges will be added to the draft '),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), model.U$))),
                    $elm$html$Html$text(' invoice.')
                ])) : $author$project$Utils$Html$empty,
                !membershipStartsAfterEligibility ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('You are enrolling this person before their eligibility start date.')
                ])) : $author$project$Utils$Html$empty
            ])) : $author$project$Utils$Html$empty,
            function() {
                var _v1 = fields.GW;
                if (!_v1.$) {
                    var plan = _v1.a;
                    return A2($author$project$Components$Employee$EnrollmentModal$viewPatientsOutsideRangeWarning, plan, fields.LI);
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Employee$EnrollmentModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Employee$EnrollmentModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$htmlTitle(_List_fromArray([
                    function() {
                        var _v1 = model.D7;
                        if (_v1 === 1) return $elm$html$Html$text('Approve');
                        else return $elm$html$Html$text('Enroll');
                    }(),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text(model.kn)
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    var _v2 = model.PU;
                    if (!_v2.$) {
                        var form = _v2.a;
                        return A2($author$project$Components$Employee$EnrollmentModal$viewForm, form, model);
                    } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]));
                }(),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Employee$EnrollmentModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                function() {
                    var verb = function() {
                        var _v3 = model.D7;
                        if (!_v3) return 'Enroll';
                        else return 'Approve and Enroll';
                    }();
                    return A3($author$project$Ui$Button$view, {
                        abP: verb + (' ' + model.kn)
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                        $author$project$Ui$Button$onClick($author$project$Components$Employee$EnrollmentModal$Save),
                        $author$project$Ui$Button$disabled(_Utils_eq(model.PU, $elm$core$Maybe$Nothing))
                    ]), _List_fromArray([
                        $elm$html$Html$text(verb),
                        $author$project$Utils$Html$noBreakSpace,
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(model.kn)
                        ]))
                    ]));
                }()
            ]))
        ]));
    };
    var $author$project$Components$Company$EmployeeRow$viewEnrollModal = function(model) {
        var _v0 = model.fJ;
        if (!_v0.$) {
            var enrollmentModal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Components$Company$EmployeeRow$EnrollmentModalMsg, $author$project$Components$Employee$EnrollmentModal$view(enrollmentModal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$UnenrollModal$CancellationReason = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$UnenrollModal$Close = {
        $: 0
    };
    var $author$project$Components$Company$UnenrollModal$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Company$UnenrollModal$Unenroll = {
        $: 1
    };
    var $author$project$Api$Employer$CancellationReason$Shared$description = function(_v0) {
        var shared = _v0;
        return shared.NQ;
    };
    var $author$project$Api$Employer$CancellationReason$All$description = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$CancellationReason$Shared$description(shared);
    };
    var $author$project$Api$CancellationReason$description = function(cancellationReason) {
        if (cancellationReason.$ === 1) {
            var cancellationReason_ = cancellationReason.a;
            return $author$project$Api$Provider$CancellationReason$All$description(cancellationReason_);
        } else {
            var cancellationReason_ = cancellationReason.a;
            return $author$project$Api$Employer$CancellationReason$All$description(cancellationReason_);
        }
    };
    var $author$project$Api$Employer$CancellationReason$Shared$id = function(_v0) {
        var shared = _v0;
        return shared.aef;
    };
    var $author$project$Api$Employer$CancellationReason$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$CancellationReason$Shared$id(shared);
    };
    var $author$project$Api$CancellationReason$id = function(cancellationReason) {
        if (cancellationReason.$ === 1) {
            var cancellationReason_ = cancellationReason.a;
            return $author$project$Api$Provider$CancellationReason$All$id(cancellationReason_);
        } else {
            var cancellationReason_ = cancellationReason.a;
            return $author$project$Api$Employer$CancellationReason$All$id(cancellationReason_);
        }
    };
    var $author$project$Components$CancellationReason$Input$cancellationReasonOptions = function(cancellationReasons) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a reason'), A2($elm$core$List$map, function(cancellationReason) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$CancellationReason$id(cancellationReason)), $author$project$Api$CancellationReason$description(cancellationReason));
        }, A2($elm$core$List$filter, function(cancellationReason) {
            return $author$project$Api$CancellationReason$description(cancellationReason) !== 'Termination by Patient';
        }, cancellationReasons)));
    };
    var $author$project$Components$CancellationReason$CancellationReasonRecord$fromAll = function(cancellationReason) {
        return {
            NQ: $author$project$Api$CancellationReason$description(cancellationReason),
            aef: $author$project$Api$CancellationReason$id(cancellationReason)
        };
    };
    var $author$project$Components$CancellationReason$Input$findCancellationReason = F2(function(cancellationReasons, id) {
        return A2($elm$core$Maybe$map, $author$project$Components$CancellationReason$CancellationReasonRecord$fromAll, A2($elm_community$list_extra$List$Extra$find, function(cancellationReason) {
            return _Utils_eq($author$project$Api$CancellationReason$id(cancellationReason), id);
        }, cancellationReasons));
    });
    var $author$project$Components$CancellationReason$Input$view = function(options) {
        var labelWidth = A2($elm$core$Maybe$withDefault, 4, options.aeJ);
        var _v0 = function() {
            var _v1 = options.acb;
            if (_v1.$ === 3) {
                var cancellationReasons_ = _v1.a;
                return _Utils_Tuple2(cancellationReasons_, false);
            } else return _Utils_Tuple2(_List_Nil, true);
        }();
        var cancellationReasons = _v0.a;
        var cancellationReasonsLoading = _v0.b;
        var _v2 = options.aa9;
        var cancellationReason = _v2.a;
        var cancellationReasonOther = _v2.b;
        var isOther = _Utils_eq(A2($elm$core$Maybe$map, function($) {
            return $.NQ;
        }, cancellationReason), $elm$core$Maybe$Just('Other'));
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(labelWidth),
                $author$project$Ui$Form$Group$inputSpan(12 - labelWidth),
                $author$project$Ui$Form$Group$label('Cancellation Reason'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, cancellationReason)),
                    $author$project$Ui$Form$Select$onChange(function(id) {
                        return options.afv(_Utils_Tuple2(A2($author$project$Components$CancellationReason$Input$findCancellationReason, cancellationReasons, id), $elm$core$Maybe$Nothing));
                    }),
                    $author$project$Ui$Form$Select$invalid(!$elm$core$List$isEmpty(options.fK)),
                    $author$project$Ui$Form$Select$errors(options.fK),
                    $author$project$Ui$Form$Select$loading(cancellationReasonsLoading)
                ]), $author$project$Components$CancellationReason$Input$cancellationReasonOptions(cancellationReasons))
            ])),
            isOther ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(labelWidth),
                $author$project$Ui$Form$Group$inputSpan(12 - labelWidth),
                $author$project$Ui$Form$Group$label('Cancellation Reason Description'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$placeholder('Cancellation Reason Description Required'),
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', cancellationReasonOther)),
                    $author$project$Ui$Form$Input$onInput(function(string) {
                        return options.afv(_Utils_Tuple2(cancellationReason, $author$project$Utils$String$toMaybe(string)));
                    }),
                    $author$project$Ui$Form$Input$invalid(!$elm$core$List$isEmpty(options.O6)),
                    $author$project$Ui$Form$Input$errors(options.O6)
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Api$Employer$CompanyAccount$Meta$billFromDate = function(_v0) {
        var meta = _v0;
        return meta.jc.Kc;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$billFromDate = function(_v0) {
        var meta = _v0;
        return meta.jc.Kc;
    };
    var $author$project$Api$CompanyAccount$Meta$billFromDate = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$billFromDate(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$billFromDate(meta_);
        }
    };
    var $justinmimbs$date$Date$isBetween = F3(function(_v0, _v1, _v2) {
        var a = _v0;
        var b = _v1;
        var x = _v2;
        return A3($justinmimbs$date$Date$isBetweenInt, a, b, x);
    });
    var $author$project$Api$Employer$CompanyAccount$Meta$minWithoutProration = function(_v0) {
        var meta = _v0;
        return meta.jc.qv.Um;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$minWithoutProration = function(_v0) {
        var meta = _v0;
        return meta.jc.qv.Um;
    };
    var $author$project$Api$CompanyAccount$Meta$minWithoutProration = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$minWithoutProration(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$minWithoutProration(meta_);
        }
    };
    var $author$project$Components$Company$UnenrollModal$mayHaveCancellableInvoice = F2(function(companyAccountMeta, endDate) {
        var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
        var billFromDate = $author$project$Api$CompanyAccount$Meta$billFromDate(companyAccountMeta);
        var _v0 = _Utils_Tuple3(endDate, minWithoutProration, billFromDate);
        if (!_v0.a.$ && !_v0.b.$ && !_v0.c.$) {
            var endDate_ = _v0.a.a;
            var minWithoutProration_ = _v0.b.a;
            var billFromDate_ = _v0.c.a;
            return A3($justinmimbs$date$Date$isBetween, minWithoutProration_, billFromDate_, endDate_) && !_Utils_eq(endDate_, billFromDate_);
        } else return false;
    });
    var $author$project$Components$Company$UnenrollModal$viewCancellableInvoiceMessage = F2(function(companyAccountMeta, endDate) {
        return A2($author$project$Components$Company$UnenrollModal$mayHaveCancellableInvoice, companyAccountMeta, endDate) ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Patient will not appear on invoices after this date.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Employer$CompanyAccount$Meta$billingStartDate = function(_v0) {
        var meta = _v0;
        return meta.jc.Kg;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$billingStartDate = function(_v0) {
        var meta = _v0;
        return meta.jc.Kg;
    };
    var $author$project$Api$CompanyAccount$Meta$billingStartDate = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$billingStartDate(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$billingStartDate(meta_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$Meta$maxWithoutBilling = function(_v0) {
        var meta = _v0;
        return meta.jc.qv.TP;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$maxWithoutBilling = function(_v0) {
        var meta = _v0;
        return meta.jc.qv.TP;
    };
    var $author$project$Api$CompanyAccount$Meta$maxWithoutBilling = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$maxWithoutBilling(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$maxWithoutBilling(meta_);
        }
    };
    var $author$project$Components$Company$UnenrollModal$mayNeedProration = F2(function(companyAccountMeta, endDate) {
        var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
        var maxWithoutBilling = $author$project$Api$CompanyAccount$Meta$maxWithoutBilling(companyAccountMeta);
        var _v0 = _Utils_Tuple3(minWithoutProration, maxWithoutBilling, endDate);
        if (!_v0.a.$ && !_v0.b.$ && !_v0.c.$) {
            var minWithoutProration_ = _v0.a.a;
            var maxWithoutBilling_ = _v0.b.a;
            var endDate_ = _v0.c.a;
            return A3($justinmimbs$date$Date$isBetween, maxWithoutBilling_, minWithoutProration_, endDate_) && !_Utils_eq(endDate_, minWithoutProration_);
        } else return false;
    });
    var $author$project$Components$Company$UnenrollModal$prorationWarning = F3(function(supportUrl, minWithoutProration, billedFromDate) {
        var format = function(maybeDate) {
            return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), maybeDate));
        };
        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text('We have billed this membership through ' + (format(minWithoutProration) + (". If you\u2019d like to credit the period of " + (format(billedFromDate) + (' through ' + (format(minWithoutProration) + ', you can learn how to do that ')))))),
                A3($author$project$Ui$Link$externalHref, supportUrl, _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                $elm$html$Html$text('.')
            ]))
        ]));
    });
    var $author$project$Components$Company$UnenrollModal$viewProrationWarning = F2(function(companyAccountMeta, endDate) {
        if (A2($author$project$Components$Company$UnenrollModal$mayNeedProration, companyAccountMeta, endDate)) {
            var minWithoutProration = $author$project$Api$CompanyAccount$Meta$minWithoutProration(companyAccountMeta);
            var billingStartDate = $author$project$Api$CompanyAccount$Meta$billingStartDate(companyAccountMeta);
            var billedFromDate = A2($elm_community$list_extra$List$Extra$maximumBy, $justinmimbs$date$Date$toRataDie, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                endDate,
                billingStartDate
            ])));
            return A3($author$project$Components$Company$UnenrollModal$prorationWarning, 'https://support.hint.com/en/articles/4622730-adding-an-employer-credit-or-one-off-charge', minWithoutProration, billedFromDate);
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Company$UnenrollModal$view = F2(function(cancellationReasons, model) {
        var minDate = A2($elm$core$Maybe$withDefault, model.cP, model.zg);
        var isDisabled = function(date) {
            return !!A2($justinmimbs$date$Date$compare, minDate, date);
        };
        var fields = $author$project$Utils$Form$fields(model.PU);
        var accountMeta = $author$project$Api$CompanyAccount$All$meta(model.LI);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Company$UnenrollModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Unenroll Employee')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Company$UnenrollModal$Unenroll),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('End Date'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(4),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Company$UnenrollModal$EndDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                            $author$project$Components$DateInput$value(fields.agK),
                            $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU)),
                            $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 2, model.PU)),
                            $author$project$Components$DateInput$disabledPickerDates(isDisabled)
                        ]), model.qx)),
                        A2($author$project$Components$Company$UnenrollModal$viewCancellableInvoiceMessage, accountMeta, fields.agK),
                        A2($author$project$Components$Company$UnenrollModal$viewProrationWarning, accountMeta, fields.agK)
                    ])),
                    $author$project$Components$CancellationReason$Input$view({
                        acb: cancellationReasons,
                        fK: A2($author$project$Utils$Form$validationErrors, 0, model.PU),
                        O6: A2($author$project$Utils$Form$validationErrors, 1, model.PU),
                        aeJ: $elm$core$Maybe$Nothing,
                        afv: A2($elm$core$Basics$composeL, $author$project$Components$Company$UnenrollModal$FormUpdated, $author$project$Components$Company$UnenrollModal$CancellationReason),
                        aa9: _Utils_Tuple2(fields.ab9, fields.aca)
                    })
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Components$Company$UnenrollModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'End employee enrollment'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$onClick($author$project$Components$Company$UnenrollModal$Unenroll),
                    $author$project$Ui$Button$disabled($author$project$Utils$Form$hasAnyValidationError(model.PU))
                ]), _List_fromArray([
                    $elm$html$Html$text('End')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Company$EmployeeRow$viewUnenrollModal = function(model) {
        var _v0 = model.ha;
        if (!_v0.$) {
            var unenrollModal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Components$Company$EmployeeRow$UnenrollModalMsg, A2($author$project$Components$Company$UnenrollModal$view, model.acb, unenrollModal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$EmployeeRow$modal = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Components$Company$EmployeeRow$deleteModal(model),
            $author$project$Components$Company$EmployeeRow$viewUnenrollModal(model),
            $author$project$Components$Company$EmployeeRow$viewEnrollModal(model),
            $author$project$Components$Company$EmployeeRow$viewEnrollDependentModal(model)
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewEmployeesStats = F3(function(companyType_, employeeCount, dependentCount) {
        var totalCount = A2($elm$core$Maybe$withDefault, 0, employeeCount) + A2($elm$core$Maybe$withDefault, 0, dependentCount);
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flex,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$String$affiliateMember, 'Employees', companyType_) + ': ')
                    ])),
                    A2($author$project$Ui$Typography$title, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, employeeCount)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flex,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Dependents: ')
                    ])),
                    A2($author$project$Ui$Typography$title, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, dependentCount)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flex,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Total: ')
                    ])),
                    A2($author$project$Ui$Typography$title, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt(totalCount))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewNewEmployeeDependentButton = function(company) {
        return !!$author$project$Api$Company$companyType(company) ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create({
            fl: $author$project$Api$Company$id(company)
        }), _List_fromArray([
            $author$project$Ui$Link$buttonDefault,
            $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
        ]), _List_fromArray([
            $elm$html$Html$text('New Employee or Dependent')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterSelected = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel = function(filter) {
        switch(filter){
            case 0:
                return 'All Status';
            case 1:
                return 'Needs Approval';
            case 2:
                return 'Denied Approval';
            case 3:
                return 'Enrolled';
            case 4:
                return 'Unenrolled';
            case 5:
                return 'Eligible';
            default:
                return 'Not Eligible';
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterItems = function(currentFilter) {
        var filterToItem = function(filter) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentFilter, filter)),
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Companies$CompanyId_String$Employees$Top$FilterSelected(filter))
            ]), $elm$html$Html$text($author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel(filter)));
        };
        return A2($elm$core$List$cons, filterToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, filterToItem, _List_fromArray([
            1,
            2,
            3,
            4,
            5,
            6
        ]))));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewSearchAndFilters = function(model) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb2,
            $author$project$Ui$Element$mt2
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(8),
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4),
                    $author$project$Ui$Grid$spanMd(2)
                ]), _List_fromArray([
                    A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Pages$Companies$CompanyId_String$Employees$Top$filterToLabel(model.Fw))
                    ]), $author$project$Pages$Companies$CompanyId_String$Employees$Top$filterItems(model.Fw), model.mk)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$usesEmployeeDivisions = function(company) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(company_) {
            var company__ = company_;
            return $author$project$Api$Company$usesEmployeeDivisions(company__);
        }, company));
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$columns = function(model) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'name', true, 'Name'),
                A3($author$project$Api$Column$init, 'type', true, 'Type'),
                A3($author$project$Api$Column$init, 'email', false, 'Email'),
                A3($author$project$Api$Column$init, 'date_of_birth', true, 'Date of Birth'),
                A3($author$project$Api$Column$init, 'plan', true, 'Plan'),
                A3($author$project$Api$Column$init, 'status', true, 'Status')
            ]),
            $author$project$Pages$Companies$CompanyId_String$Employees$Top$usesEmployeeDivisions($elm$core$Maybe$Just(model.acy)) ? _List_fromArray([
                A3($author$project$Api$Column$init, 'divisions', true, 'Divisions')
            ]) : _List_Nil,
            _List_fromArray([
                A3($author$project$Api$Column$init, 'actions', false, 'Actions')
            ])
        ]));
    };
    var $author$project$Ui$Table$Attribute = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Table$CellActive = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Table$Display = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Table$Hidden = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Table$Nested = {
        $: 8
    };
    var $author$project$Ui$Table$NoWrap = {
        $: 9
    };
    var $author$project$Ui$Table$Rowspan = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Table$VerticalAlignedBottom = {
        $: 14
    };
    var $author$project$Ui$Table$VerticalCenteredCell = {
        $: 15
    };
    var $author$project$Ui$Table$mapCellOption = F2(function(f, cellOption) {
        switch(cellOption.$){
            case 0:
                var attributes = cellOption.a;
                return $author$project$Ui$Table$Attribute(attributes);
            case 1:
                var value = cellOption.a;
                return $author$project$Ui$Table$CellActive(value);
            case 2:
                var alignment = cellOption.a;
                return $author$project$Ui$Table$CellAlignment(alignment);
            case 3:
                var _int = cellOption.a;
                return $author$project$Ui$Table$Colspan(_int);
            case 4:
                var display = cellOption.a;
                return $author$project$Ui$Table$Display(display);
            case 5:
                var screenSize = cellOption.a;
                var _int = cellOption.b;
                return A2($author$project$Ui$Table$Grid, screenSize, _int);
            case 6:
                var screenSize = cellOption.a;
                return $author$project$Ui$Table$Hidden(screenSize);
            case 7:
                var string = cellOption.a;
                return $author$project$Ui$Table$MinWidth(string);
            case 8:
                return $author$project$Ui$Table$Nested;
            case 9:
                return $author$project$Ui$Table$NoWrap;
            case 11:
                var _int = cellOption.a;
                return $author$project$Ui$Table$Rowspan(_int);
            case 10:
                var msg = cellOption.a;
                return $author$project$Ui$Table$OnClick(f(msg));
            case 12:
                var bool = cellOption.a;
                return $author$project$Ui$Table$Sortable(bool);
            case 13:
                var direction = cellOption.a;
                return $author$project$Ui$Table$SortDirection(direction);
            case 14:
                return $author$project$Ui$Table$VerticalAlignedBottom;
            default:
                return $author$project$Ui$Table$VerticalCenteredCell;
        }
    });
    var $author$project$Ui$Table$mapCell = F2(function(f, _v0) {
        var _v1 = _v0;
        var options = _v1.a;
        var contents = _v1.b;
        return _Utils_Tuple2(A2($elm$core$List$map, $author$project$Ui$Table$mapCellOption(f), options), A2($elm$core$List$map, $elm$html$Html$map(f), contents));
    });
    var $author$project$Ui$Table$mapRowOption = F2(function(_v0, rowOption) {
        if (!rowOption.$) {
            var style = rowOption.a;
            return $author$project$Ui$Table$Styled(style);
        } else return $author$project$Ui$Table$NoBorder;
    });
    var $author$project$Ui$Table$mapRow = F2(function(f, row_) {
        if (row_.$ === 1) {
            var _v1 = row_.a;
            var options = _v1.a;
            var cells = _v1.b;
            return $author$project$Ui$Table$Row(_Utils_Tuple2(A2($elm$core$List$map, $author$project$Ui$Table$mapRowOption(f), options), A2($elm$core$List$map, $author$project$Ui$Table$mapCell(f), cells)));
        } else return $author$project$Ui$Table$None;
    });
    var $author$project$Components$Company$EmployeeRow$EmployerOrProviderCompany = $elm$core$Basics$identity;
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$status = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$status(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$status(companyRegistration_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus = function(employee) {
        if (!employee.$) {
            var employee_ = employee.a;
            return $author$project$Api$CompanyAccount$All$status(employee_);
        } else {
            var employee_ = employee.a;
            return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$status(employee_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$endingStatus = F3(function(endDate, currentDate, endDateString) {
        if (!endDate.$) {
            var date = endDate.a;
            return A2($justinmimbs$date$Date$compare, currentDate, date) === 2 || A2($justinmimbs$date$Date$compare, currentDate, date) === 1 ? 'Ended on ' + endDateString : 'Member through ' + endDateString;
        } else return 'Eligible';
    });
    var $author$project$Api$Employer$CompanyAccount$All$membershipEndDate = function(_v0) {
        var record = _v0.b;
        return record.T_;
    };
    var $author$project$Api$Provider$CompanyAccount$All$membershipEndDate = function(_v0) {
        var record = _v0.b;
        return record.T_;
    };
    var $author$project$Api$CompanyAccount$All$membershipEndDate = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$membershipEndDate(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$membershipEndDate(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$Shared$membershipEndDate = function(_v0) {
        var record = _v0;
        return record.T_;
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$membershipEndDate(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$Shared$membershipEndDate = function(_v0) {
        var record = _v0;
        return record.T_;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$membershipEndDate(shared);
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipEndDate = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(companyRegistration_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$accountStatus = F2(function(currentDate, employee) {
        var status = $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus(employee);
        var membershipEndDate = function() {
            if (!employee.$) {
                var employee_ = employee.a;
                return $author$project$Api$CompanyAccount$All$membershipEndDate(employee_);
            } else {
                var employee_ = employee.a;
                return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipEndDate(employee_);
            }
        }();
        var membershipEndDateString = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), membershipEndDate));
        switch(status){
            case 'ending':
                return A3($author$project$Components$Company$EmployeeRow$endingStatus, membershipEndDate, currentDate, membershipEndDateString);
            case 'needs_approval':
                return 'Needs Approval';
            case 'eligible':
                return A3($author$project$Components$Company$EmployeeRow$endingStatus, membershipEndDate, currentDate, membershipEndDateString);
            case 'enrolled':
                var membershipStartDateString = function() {
                    if (!employee.$) {
                        var employee_ = employee.a;
                        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$CompanyAccount$All$membershipStartDate(employee_)));
                    } else {
                        var employee_ = employee.a;
                        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$CompanyRegistration$ForCompanyAccountAll$membershipStartDate(employee_)));
                    }
                }();
                return 'Enrolled' + (' as of ' + membershipStartDateString);
            default:
                return $author$project$Formatters$String$humanize(status);
        }
    });
    var $author$project$Api$EmployeeDivision$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$EmployeeDivision$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyAccount$All$division = function(_v0) {
        var record = _v0.b;
        return record.Oa;
    };
    var $author$project$Api$Provider$CompanyAccount$All$division = function(_v0) {
        var record = _v0.b;
        return record.Oa;
    };
    var $author$project$Api$CompanyAccount$All$division = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$Shared$Provider, $author$project$Api$Provider$CompanyAccount$All$division(companyAccount_));
        } else {
            var companyAccount_ = companyAccount.a;
            return A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$Shared$Employer, $author$project$Api$Employer$CompanyAccount$All$division(companyAccount_));
        }
    };
    var $author$project$Api$Employer$Patient$Min$dob = function(_v0) {
        var record = _v0;
        return record.add;
    };
    var $author$project$Api$Provider$Patient$Min$dob = function(_v0) {
        var min = _v0;
        return min.add;
    };
    var $author$project$Api$Patient$Min$dob = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$Min$dob(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$Min$dob(patient_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$Shared$eligibilityEndDate = function(_v0) {
        var record = _v0;
        return record.OD;
    };
    var $author$project$Api$Employer$CompanyAccount$All$eligibilityEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityEndDate(shared);
    };
    var $author$project$Api$Provider$CompanyAccount$Shared$eligibilityEndDate = function(_v0) {
        var record = _v0.b;
        return record.OD;
    };
    var $author$project$Api$Provider$CompanyAccount$All$eligibilityEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityEndDate(shared);
    };
    var $author$project$Api$CompanyAccount$All$eligibilityEndDate = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$eligibilityEndDate(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$eligibilityEndDate(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityEndDate = function(_v0) {
        var record = _v0;
        return record.OD;
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityEndDate(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityEndDate = function(_v0) {
        var record = _v0;
        return record.OD;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityEndDate(shared);
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(companyRegistration_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$All$eligibilityStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyAccount$Shared$eligibilityStartDate(shared);
    };
    var $author$project$Api$Provider$CompanyAccount$All$eligibilityStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(shared);
    };
    var $author$project$Api$CompanyAccount$All$eligibilityStartDate = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$eligibilityStartDate(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$eligibilityStartDate(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityStartDate = function(_v0) {
        var record = _v0;
        return record.OE;
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$eligibilityStartDate(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityStartDate = function(_v0) {
        var record = _v0;
        return record.OE;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$eligibilityStartDate(shared);
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(companyRegistration_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo = function(employee) {
        var eligibilityStartDate = function() {
            if (!employee.$) {
                var employee_ = employee.a;
                return $author$project$Api$CompanyAccount$All$eligibilityStartDate(employee_);
            } else {
                var employee_ = employee.a;
                return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityStartDate(employee_);
            }
        }();
        var eligibilityEndDate = function() {
            if (!employee.$) {
                var employee_ = employee.a;
                return $author$project$Api$CompanyAccount$All$eligibilityEndDate(employee_);
            } else {
                var employee_ = employee.a;
                return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(employee_);
            }
        }();
        var _v0 = _Utils_Tuple2(eligibilityStartDate, eligibilityEndDate);
        if (!_v0.a.$) {
            if (_v0.b.$ === 1) {
                var eligibilityDate = _v0.a.a;
                var _v1 = _v0.b;
                return 'Eligible from ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityDate);
            } else {
                var eligibilityDate = _v0.a.a;
                var eligibilityEndDate_ = _v0.b.a;
                return 'Eligible from ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityDate) + (' to ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityEndDate_)));
            }
        } else return '';
    };
    var $author$project$Components$Company$EmployeeRow$eligibilityStatus = F2(function(model, employee) {
        var eligibilityEndDate = function() {
            if (!employee.$) {
                var employee_ = employee.a;
                return $author$project$Api$CompanyAccount$All$eligibilityEndDate(employee_);
            } else {
                var employee_ = employee.a;
                return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$eligibilityEndDate(employee_);
            }
        }();
        if (!eligibilityEndDate.$) {
            var eligibilityEndDate_ = eligibilityEndDate.a;
            return A2($author$project$Utils$Date$isBefore, eligibilityEndDate_, model.cP) ? 'Ineligible since ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, eligibilityEndDate_) : $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo(employee);
        } else return $author$project$Components$Company$EmployeeRow$eligibleFromAndOrTo(employee);
    });
    var $author$project$Api$Employer$Patient$Min$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$Patient$Min$email = function(_v0) {
        var min = _v0;
        return min.OH;
    };
    var $author$project$Api$Patient$Min$email = function(patient) {
        if (!patient.$) {
            var patient_ = patient.a;
            return $author$project$Api$Provider$Patient$Min$email(patient_);
        } else {
            var patient_ = patient.a;
            return $author$project$Api$Employer$Patient$Min$email(patient_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$Dependent = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$Employee = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$employeeOrDependent = function(model) {
        var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.LP);
        if (_v0 === 'employee') return $author$project$Components$Company$EmployeeRow$Employee(model.LI);
        else return $author$project$Components$Company$EmployeeRow$Dependent(model.LP);
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$externalId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$externalId(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$externalId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$externalId(shared);
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$externalId = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$externalId(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$externalId(companyRegistration_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$isNetwork = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return !$author$project$Api$Company$companyType(company_);
        } else return false;
    };
    var $author$project$Api$Employer$CompanyRegistration$Shared$isSubscriber = function(_v0) {
        var record = _v0;
        return record.Ss;
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyRegistration$Shared$isSubscriber(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber = function(_v0) {
        var record = _v0;
        return record.Ss;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber(shared);
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$isSubscriber = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$isSubscriber(companyRegistration_);
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$isSubscriber(companyRegistration_);
        }
    };
    var $author$project$Api$EmployeeDivision$Shared$name = function(employeeDivision) {
        if (!employeeDivision.$) {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Provider$EmployeeDivision$Shared$name(employeeDivision_);
        } else {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Employer$EmployeeDivision$Shared$name(employeeDivision_);
        }
    };
    var $author$project$Ui$Table$nested = $author$project$Ui$Table$Nested;
    var $author$project$Components$Company$EmployeeRow$usesEmployeeDivisions = function(company) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(company_) {
            var company__ = company_;
            return $author$project$Api$Company$usesEmployeeDivisions(company__);
        }, company));
    };
    var $author$project$Components$Company$EmployeeRow$Approve = 0;
    var $author$project$Components$Company$EmployeeRow$ApproveEmployee = {
        $: 11
    };
    var $author$project$Components$Company$EmployeeRow$DeleteEmployeeOrDependent = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$Deny = 1;
    var $author$project$Components$Company$EmployeeRow$DenyEmployee = {
        $: 13
    };
    var $author$project$Components$Company$EmployeeRow$DependentMeta = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$EditEmployeeOrDependent = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$EmployeeMeta = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$Enroll = 2;
    var $author$project$Components$Company$EmployeeRow$EnrollEmployeeOrDependent = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentEligible = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentIneligible = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeRow$MakeEligible = 5;
    var $author$project$Components$Company$EmployeeRow$MakeIneligible = 4;
    var $author$project$Components$Company$EmployeeRow$Remove = 6;
    var $author$project$Components$Company$EmployeeRow$Unenroll = 3;
    var $author$project$Components$Company$EmployeeRow$UnenrollEmployeeOrDependent = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$ButtonSize = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$Sm = 0;
    var $author$project$Ui$Dropdown$buttonSm = $author$project$Ui$Dropdown$ButtonSize(0);
    var $author$project$Api$Employer$CompanyAccount$Meta$canEnrollAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KJ;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$canEnrollAction = function(_v0) {
        var record = _v0;
        return record.tM.KJ;
    };
    var $author$project$Api$CompanyAccount$Meta$canEnrollAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$canEnrollAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$canEnrollAction(meta_);
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$Meta$canEnrollAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KJ;
    };
    var $author$project$Api$Provider$Meta$CompanyRegistration$enrollAction = function(_v0) {
        var record = _v0;
        return record.tM.OV;
    };
    var $author$project$Api$CompanyRegistration$Meta$canEnrollAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Meta$CompanyRegistration$enrollAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyRegistration$Meta$canEnrollAction(meta_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$Shared$isEligible = function(_v0) {
        var record = _v0;
        return record.R2;
    };
    var $author$project$Api$Employer$CompanyAccount$All$isEligible = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyAccount$Shared$isEligible(shared);
    };
    var $author$project$Api$Provider$CompanyAccount$Shared$isEligible = function(_v0) {
        var record = _v0.b;
        return record.R2;
    };
    var $author$project$Api$Provider$CompanyAccount$All$isEligible = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$isEligible(shared);
    };
    var $author$project$Api$CompanyAccount$All$isEligible = function(companyAccount) {
        if (!companyAccount.$) {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Provider$CompanyAccount$All$isEligible(companyAccount_);
        } else {
            var companyAccount_ = companyAccount.a;
            return $author$project$Api$Employer$CompanyAccount$All$isEligible(companyAccount_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$Meta$isEligibleAction = function(_v0) {
        var meta = _v0;
        return meta.tM.R2;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$isEligibleAction = function(_v0) {
        var meta = _v0;
        return meta.tM.R2;
    };
    var $author$project$Api$CompanyAccount$Meta$isEligibleAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$isEligibleAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$isEligibleAction(meta_);
        }
    };
    var $author$project$Api$Employer$CompanyRegistration$Meta$isEligibleAction = function(_v0) {
        var meta = _v0;
        return meta.tM.R2;
    };
    var $author$project$Api$Provider$Meta$CompanyRegistration$isEligibleAction = function(_v0) {
        var meta = _v0;
        return meta.tM.R2;
    };
    var $author$project$Api$CompanyRegistration$Meta$isEligibleAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$Meta$CompanyRegistration$isEligibleAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyRegistration$Meta$isEligibleAction(meta_);
        }
    };
    var $author$project$Api$Employer$CompanyAccount$Meta$needsApprovalAction = function(_v0) {
        var meta = _v0;
        return meta.tM.UI;
    };
    var $author$project$Api$Provider$CompanyAccount$Meta$needsApprovalAction = function(_v0) {
        var meta = _v0;
        return meta.tM.UI;
    };
    var $author$project$Api$CompanyAccount$Meta$needsApprovalAction = function(meta) {
        if (!meta.$) {
            var meta_ = meta.a;
            return $author$project$Api$Provider$CompanyAccount$Meta$needsApprovalAction(meta_);
        } else {
            var meta_ = meta.a;
            return $author$project$Api$Employer$CompanyAccount$Meta$needsApprovalAction(meta_);
        }
    };
    var $author$project$Components$Company$EmployeeRow$canTakeAction = F4(function(actions, employee, meta, model) {
        var status = $author$project$Components$Company$EmployeeRow$employeeOrDependentStatus(employee);
        switch(actions){
            case 0:
                if (!meta.$) {
                    var meta_ = meta.a;
                    return $author$project$Api$CompanyAccount$Meta$needsApprovalAction(meta_) || status === 'needs_approval' || status === 'denied';
                } else return false;
            case 1:
                if (!employee.$) return status === 'needs_approval';
                else return false;
            case 2:
                var enrollMeta = function() {
                    if (!meta.$) {
                        var meta_ = meta.a;
                        return $author$project$Api$CompanyAccount$Meta$canEnrollAction(meta_);
                    } else {
                        var meta_ = meta.a;
                        return $author$project$Api$CompanyRegistration$Meta$canEnrollAction(meta_);
                    }
                }();
                return enrollMeta || enrollMeta && status === 'eligible' && !$author$project$Components$Company$EmployeeRow$isNetwork($elm$core$Maybe$Just(model.acy));
            case 3:
                return status === 'enrolled' && !$author$project$Components$Company$EmployeeRow$isNetwork($elm$core$Maybe$Just(model.acy));
            case 4:
                return status === 'eligible';
            case 5:
                if (!meta.$) {
                    var meta_ = meta.a;
                    return $author$project$Api$CompanyAccount$Meta$isEligibleAction(meta_);
                } else {
                    var meta_ = meta.a;
                    return $author$project$Api$CompanyRegistration$Meta$isEligibleAction(meta_);
                }
            default:
                if (!employee.$) {
                    var employee_ = employee.a;
                    return !$author$project$Api$CompanyAccount$All$isEligible(employee_);
                } else return status === 'ineligible';
        }
    });
    var $author$project$Api$CompanyRegistration$Meta$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$CompanyRegistration$Meta$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$CompanyRegistration$ForCompanyAccountAll$meta = function(companyRegistration) {
        if (!companyRegistration.$) {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$CompanyRegistration$Meta$Provider($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountAll$meta(companyRegistration_));
        } else {
            var companyRegistration_ = companyRegistration.a;
            return $author$project$Api$CompanyRegistration$Meta$Employer($author$project$Api$Employer$CompanyRegistration$ForCompanyAccountAll$meta(companyRegistration_));
        }
    };
    var $author$project$Components$Company$EmployeeRow$viewActionsDropdown = function(model) {
        var canManageAccount = !$author$project$Components$Company$EmployeeRow$isNetwork($elm$core$Maybe$Just(model.acy));
        return _List_fromArray([
            function() {
                if (canManageAccount) {
                    var registrationId = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$id(model.LP);
                    var employeeOrDependentMeta = function() {
                        var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.LP);
                        if (_v0 === 'employee') return $author$project$Components$Company$EmployeeRow$EmployeeMeta($author$project$Api$CompanyAccount$All$meta(model.LI));
                        else return $author$project$Components$Company$EmployeeRow$DependentMeta($author$project$Api$CompanyRegistration$ForCompanyAccountAll$meta(model.LP));
                    }();
                    var items = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$EditEmployeeOrDependent(registrationId))
                    ]), $elm$html$Html$text('Edit')), _Utils_ap(A4($author$project$Components$Company$EmployeeRow$canTakeAction, 0, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model), employeeOrDependentMeta, model) ? _List_fromArray([
                        A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$ApproveEmployee)
                        ]), $elm$html$Html$text('Approve'))
                    ]) : _List_Nil, _Utils_ap(A4($author$project$Components$Company$EmployeeRow$canTakeAction, 1, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model), employeeOrDependentMeta, model) ? _List_fromArray([
                        A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$DenyEmployee)
                        ]), $elm$html$Html$text('Deny'))
                    ]) : _List_Nil, _Utils_ap(A4($author$project$Components$Company$EmployeeRow$canTakeAction, 2, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model), employeeOrDependentMeta, model) ? _List_fromArray([
                        A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$EnrollEmployeeOrDependent($author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
                        ]), $elm$html$Html$text('Enroll'))
                    ]) : _List_Nil, _Utils_ap(A4($author$project$Components$Company$EmployeeRow$canTakeAction, 3, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model), employeeOrDependentMeta, model) ? _List_fromArray([
                        A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$UnenrollEmployeeOrDependent($author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
                        ]), $elm$html$Html$text('Unenroll'))
                    ]) : _List_Nil, _Utils_ap(A4($author$project$Components$Company$EmployeeRow$canTakeAction, 5, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model), employeeOrDependentMeta, model) ? _List_fromArray([
                        A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentEligible($author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
                        ]), $elm$html$Html$text('Make Eligible'))
                    ]) : _List_Nil, _Utils_ap(A4($author$project$Components$Company$EmployeeRow$canTakeAction, 4, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model), employeeOrDependentMeta, model) ? _List_fromArray([
                        A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$MadeEmployeeOrDependentIneligible($author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
                        ]), $elm$html$Html$text('Make Ineligible'))
                    ]) : _List_Nil, A4($author$project$Components$Company$EmployeeRow$canTakeAction, 6, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model), employeeOrDependentMeta, model) ? _List_fromArray([
                        A2($author$project$Ui$Dropdown$item, _List_fromArray([
                            $author$project$Ui$Dropdown$onSelect($author$project$Components$Company$EmployeeRow$DeleteEmployeeOrDependent($elm$core$Maybe$Just($author$project$Components$Company$EmployeeRow$employeeOrDependent(model))))
                        ]), $elm$html$Html$text('Remove'))
                    ]) : _List_Nil)))))));
                    return A4($author$project$Ui$Dropdown$view, _List_fromArray([
                        $author$project$Ui$Dropdown$buttonSm
                    ]), _List_fromArray([
                        $elm$html$Html$text('Manage')
                    ]), items, model.fD);
                } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('You can\'t take any actions on this account')
                ]));
            }()
        ]);
    };
    var $author$project$Components$Company$EmployeeRow$viewRow = function(model) {
        var patient = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$patient(model.LP);
        var membershipPlanName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Plan$Min$name, A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, $author$project$Api$Expandable$toMaybe($author$project$Api$CompanyAccount$All$plan(model.LI)))));
        var memberType = function() {
            if ($author$project$Components$Company$EmployeeRow$isNetwork($elm$core$Maybe$Just(model.acy)) && $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.LP) !== 'employee') return 'Dependent';
            else {
                var _v0 = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.LP);
                if (_v0 === 'spouse') return 'Adult';
                else return $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.LP);
            }
        }();
        var isSubscriber = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$isSubscriber(model.LP);
        var isEmployee = $author$project$Api$CompanyRegistration$ForCompanyAccountAll$type_(model.LP) === 'employee';
        var nestedCellClass = isSubscriber && isEmployee ? _List_Nil : _List_fromArray([
            $author$project$Ui$Table$nested
        ]);
        var tableClass = isSubscriber && isEmployee ? $author$project$Ui$Table$row(_List_Nil) : $author$project$Ui$Table$row(_List_fromArray([
            $author$project$Ui$Table$noBorder
        ]));
        var externalId = A2($elm$core$Maybe$withDefault, '', $author$project$Api$CompanyRegistration$ForCompanyAccountAll$externalId(model.LP));
        var patientName = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Patient$Min$name(patient))
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text(' ' + externalId)
            ]))
        ]));
        var patientNameCellContent = $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? patientName : A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
            V8: $author$project$Api$Patient$Min$id(patient)
        }), _List_Nil, _List_fromArray([
            patientName
        ]));
        var email = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Patient$Min$email(patient));
        var dob = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Patient$Min$dob(patient)));
        return tableClass(A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, nestedCellClass, _List_fromArray([
            patientNameCellContent
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Formatters$String$titleize(memberType))
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text(email)
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text(dob)
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text(membershipPlanName)
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Components$Company$EmployeeRow$accountStatus, model.cP, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Components$Company$EmployeeRow$eligibilityStatus, model, $author$project$Components$Company$EmployeeRow$employeeOrDependent(model)))
                ]))
            ]))
        ])), _Utils_ap(function() {
            if ($author$project$Components$Company$EmployeeRow$usesEmployeeDivisions($elm$core$Maybe$Just(model.acy))) {
                var division = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$EmployeeDivision$Shared$name, $author$project$Api$CompanyAccount$All$division(model.LI)));
                return _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(division)
                    ]))
                ]);
            } else return _List_Nil;
        }(), _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, $author$project$Components$Company$EmployeeRow$viewActionsDropdown(model))
        ])))))))));
    };
    var $author$project$Components$Company$EmployeeRow$view = function(model) {
        return $author$project$Components$Company$EmployeeRow$viewRow(model);
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewTable = function(model) {
        var tableRows = A2($elm$core$List$map, function(_v2) {
            var registrationId = _v2.a;
            var row = _v2.b;
            return A2($author$project$Ui$Table$mapRow, $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId), $author$project$Components$Company$EmployeeRow$view(row));
        }, model.eN);
        var _v0 = function() {
            var _v1 = model.LK;
            if (_v1.$ === 3) {
                var companyAccounts_ = _v1.a;
                return _Utils_Tuple2(false, companyAccounts_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any employees')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Companies$CompanyId_String$Employees$Top$columns(model)), tableRows, _List_Nil);
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$view = function(model) {
        return {
            fb: function() {
                var tableRowModals = A2($elm$core$List$map, function(_v1) {
                    var registrationId = _v1.a;
                    var row = _v1.b;
                    return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$EmployeeRowMsg(registrationId), $author$project$Components$Company$EmployeeRow$modal(row));
                }, model.eN);
                var loading = function() {
                    var _v0 = model.LK;
                    if (_v0.$ === 3) return false;
                    else return true;
                }();
                var companyType_ = $author$project$Pages$Companies$CompanyId_String$Employees$Top$companyType($elm$core$Maybe$Just(model.acy));
                return _Utils_ap(tableRowModals, _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween
                            ]), _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('All ' + A2($author$project$Formatters$String$affiliateMember, 'Employees & Dependents', companyType_))
                                ])),
                                $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewNewEmployeeDependentButton(model.acy)
                            ])),
                            $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewSearchAndFilters(model),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween,
                                $author$project$Ui$Element$itemsCenter
                            ]), _List_fromArray([
                                A3($author$project$Pages$Companies$CompanyId_String$Employees$Top$viewEmployeesStats, companyType_, model.xu, model.NK),
                                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg, $author$project$Components$ExportCsv$link),
                                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, model.Ej, _List_fromArray([
                                        $author$project$Components$ExportCsv$path(A2($author$project$Api$CompanyRegistration$exportPath, model.Z$, model.aef)),
                                        $author$project$Components$ExportCsv$params(A2($elm$core$Basics$composeL, $author$project$Api$CompanyAccount$listOptionsToParams, $author$project$Pages$Companies$CompanyId_String$Employees$Top$fetchParams)(model))
                                    ]), model.md))
                                ]))
                            ]))
                        ])),
                        $author$project$Pages$Companies$CompanyId_String$Employees$Top$viewTable(model),
                        A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Employees$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                                $author$project$Ui$Pagination$List$loading(loading)
                            ]), model.af_))
                        ]))
                    ]))
                ]));
            }(),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + (' | ' + model.aef)
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Employees$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Employees$Top$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Employees$Top$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Employees$Top$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Employees$Top$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Employees$Top$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Employees$Top$view
    });
    var $author$project$Spa$Page$applicationCompany = function(page) {
        return {
            aeq: F2(function(shared, url) {
                var _v0 = _Utils_Tuple3(shared.Z$, shared.W1, shared.acy);
                _v0$4: while(true){
                    _v0$5: while(true){
                        _v0$6: while(true)switch(_v0.a.$){
                            case 3:
                                switch(_v0.b.$){
                                    case 3:
                                        if (!_v0.b.a.$) switch(_v0.c.$){
                                            case 3:
                                                if (!_v0.c.a.$) {
                                                    var _v1 = _v0.a;
                                                    var session = _v1.a;
                                                    var _v2 = _v0.b;
                                                    var practice = _v2.a.a;
                                                    var _v3 = _v0.c;
                                                    var company = _v3.a.a;
                                                    return !A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil) : !_Utils_eq(url.VU.fl, $author$project$Api$Provider$Company$One$id(company)) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_fromArray([
                                                        $author$project$OutMsg$RetrieveCompany(url.VU.fl)
                                                    ])) : A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A5(page.aeq, session, practice, company, shared, url)));
                                                } else break _v0$6;
                                            case 2:
                                                break _v0$5;
                                            default:
                                                break _v0$6;
                                        }
                                        else {
                                            var _v4 = _v0.a;
                                            var session = _v4.a;
                                            var _v5 = _v0.b;
                                            return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                        }
                                    case 2:
                                        break _v0$4;
                                    default:
                                        if (_v0.c.$ === 2) break _v0$5;
                                        else break _v0$6;
                                }
                            case 2:
                                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                            case 0:
                                var _v6 = _v0.a;
                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $author$project$Ports$Session$authorize({
                                    agy: true
                                }), _List_Nil);
                            default:
                                if (_v0.b.$ === 2) break _v0$4;
                                else {
                                    if (_v0.c.$ === 2) break _v0$5;
                                    else break _v0$6;
                                }
                        }
                        var _v7 = url;
                        var params = _v7.VU;
                        return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$RetrieveCompany(params.fl)
                        ]));
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aeR: F2(function(shared, model) {
                var _v8 = _Utils_Tuple3(shared.Z$, shared.W1, shared.acy);
                _v8$2: while(true){
                    _v8$4: while(true){
                        _v8$5: while(true)switch(_v8.a.$){
                            case 3:
                                switch(_v8.b.$){
                                    case 3:
                                        if (!_v8.b.a.$) switch(_v8.c.$){
                                            case 3:
                                                if (!_v8.c.a.$) {
                                                    var _v9 = _v8.a;
                                                    var session = _v9.a;
                                                    var _v10 = _v8.b;
                                                    var practice = _v10.a.a;
                                                    var _v11 = _v8.c;
                                                    var company = _v11.a.a;
                                                    switch(model.$){
                                                        case 0:
                                                            var url = model.a;
                                                            if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT)) return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                                            else {
                                                                var _v13 = A5(page.aeq, session, practice, company, shared, url);
                                                                var pageModel = _v13.a;
                                                                var cmd = _v13.b;
                                                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoaded(pageModel), cmd, _List_Nil);
                                                            }
                                                        case 1:
                                                            var modelWithSession = model.a;
                                                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aeR, shared, _Utils_update(modelWithSession, {
                                                                Ej: shared.Ej
                                                            }))));
                                                        default:
                                                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                                                    }
                                                } else break _v8$5;
                                            case 0:
                                                break _v8$2;
                                            default:
                                                break _v8$5;
                                        }
                                        else {
                                            var _v14 = _v8.a;
                                            var session = _v14.a;
                                            var _v15 = _v8.b;
                                            return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                        }
                                    case 2:
                                        if (!_v8.c.$) break _v8$2;
                                        else break _v8$4;
                                    default:
                                        if (!_v8.c.$) break _v8$2;
                                        else break _v8$5;
                                }
                            case 2:
                                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                            default:
                                if (_v8.b.$ === 2) break _v8$4;
                                else break _v8$5;
                        }
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                var _v16 = _v8.a;
                var _v17 = _v8.c;
                if (!model.$) {
                    var url = model.a;
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                        $author$project$OutMsg$RetrieveCompany(url.VU.fl)
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            ag3: F2(function(model, shared) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2(page.ag3, modelWithSession, shared);
                } else return shared;
            }),
            ahE: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.ahE(modelWithSession);
                } else return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(msg, model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aaO, msg, modelWithSession));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.aid(modelWithSession);
                } else return {
                    fb: $author$project$Components$BlankPage$view,
                    $2: 'Loading...'
                };
            }
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$GotBrokerDeals = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals = function(model) {
        return A3($author$project$Api$Provider$BrokerDeal$list, model.Ej, function(d) {
            return _Utils_update(d, {
                acy: $elm$core$Maybe$Just(model.fl),
                Q8: $elm$core$Maybe$Just(true)
            });
        }, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$GotBrokerDeals);
    };
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$init = F5(function(session, practice, _v0, shared, _v1) {
        var params = _v1.VU;
        var model = {
            Ej: shared.Ej,
            Kq: $author$project$Api$Data$Loading,
            dy: A3($author$project$Components$BrokerDeal$Table$init, session, shared.cP, {
                l8: true,
                qL: false,
                qM: true
            }),
            fl: params.fl,
            W1: practice
        };
        return _Utils_Tuple2(model, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
    });
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            dy: A2($author$project$Components$BrokerDeal$Table$load, shared.cP, model.dy)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$subscriptions = function(_v0) {
        var brokerDealsTable = _v0.dy;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg, $author$project$Components$BrokerDeal$Table$subscriptions(brokerDealsTable));
    };
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            if (response.$ === 3) {
                var brokerDeals = response.a;
                var brokerDealsTable = A2($author$project$Components$BrokerDeal$Table$withBrokerDeals, A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals), model.dy);
                return _Utils_Tuple3(_Utils_update(model, {
                    Kq: response,
                    dy: brokerDealsTable
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            } else return _Utils_Tuple3(_Utils_update(model, {
                Kq: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var subMsg = msg.a;
            var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, model.Ej, subMsg, model.dy);
            var _v2 = function() {
                var _v3 = brokerDealsTableResult.adu;
                switch(_v3){
                    case 0:
                        return _Utils_Tuple2(model.Kq, $elm$core$Platform$Cmd$none);
                    case 1:
                        return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
                    case 2:
                        return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
                    case 3:
                        return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
                    case 4:
                        return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
                    case 5:
                        return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
                    default:
                        return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$fetchBrokerDeals(model));
                }
            }();
            var brokerDeals = _v2.a;
            var cmd = _v2.b;
            return _Utils_Tuple3(_Utils_update(model, {
                Kq: brokerDeals,
                dy: brokerDealsTableResult.zi
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg, brokerDealsTableResult.EQ),
                cmd
            ])), brokerDealsTableResult.at);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg, $author$project$Components$BrokerDeal$Table$modal(model.dy)),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top({
                                    fl: model.fl
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Account & Pricing')
                                ]))
                            ])),
                            A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                $author$project$Ui$Breadcrumb$active(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Ended Deals')
                            ]))
                        ]))),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Ended Deals')
                        ])),
                        A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$BrokerDealsTableMsg, A2($author$project$Components$BrokerDeal$Table$view, _List_fromArray([
                            $author$project$Components$BrokerDeal$Table$loading(!$author$project$Api$Data$isSuccess(model.Kq))
                        ]), model.dy))
                    ]))
                ]))
            ]),
            $2: A2($author$project$Formatters$String$sponsorize, model.W1, 'Companies') + ' | Commissions'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$EndedCommissions$page = $author$project$Spa$Page$applicationCompany({
        aeq: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$update,
        aid: $author$project$Pages$Companies$CompanyId_String$EndedCommissions$view
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotCompanyInvoiceSetting = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPaymentSourceSetting = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticeCompanyInvoiceSetting = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticePaymentSourceSetting = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$One$companyInvoiceSettingId = function(_v0) {
        var record = _v0.b;
        return record.LM;
    };
    var $author$project$Api$Provider$Company$One$companyPaymentSourceSettingId = function(_v0) {
        var record = _v0.b;
        return record.LO;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$ForCompany = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$Record = function(invoiceUpcomingAutoSend) {
        return function(invoiceAutoSend) {
            return function(invoiceAutoSendDay) {
                return function(invoiceAutoSendMonth) {
                    return function(invoiceAutoIssue) {
                        return function(invoiceAutoIssueDay) {
                            return function(invoiceAutoIssueMonth) {
                                return function(invoiceDueDay) {
                                    return function(invoiceDueMonth) {
                                        return function(invoiceAutoPay) {
                                            return function(invoiceAutoPayDay) {
                                                return function(invoiceAutoPayMonth) {
                                                    return function(invoiceGracePeriodDays) {
                                                        return function(chargePhiDetailsEnabled) {
                                                            return function(chargePhiDetailsUpdatedAt) {
                                                                return function(chargePhiDetailsUpdatedBy) {
                                                                    return function(chargeRouteToRecurringInvoice) {
                                                                        return function(billingEnabled) {
                                                                            return function(billingStartDate) {
                                                                                return function(hideSponsorInvoices) {
                                                                                    return {
                                                                                        Eu: billingEnabled,
                                                                                        Kg: billingStartDate,
                                                                                        K6: chargePhiDetailsEnabled,
                                                                                        K7: chargePhiDetailsUpdatedAt,
                                                                                        K8: chargePhiDetailsUpdatedBy,
                                                                                        EM: chargeRouteToRecurringInvoice,
                                                                                        QI: hideSponsorInvoices,
                                                                                        RB: invoiceAutoIssue,
                                                                                        RC: invoiceAutoIssueDay,
                                                                                        FY: invoiceAutoIssueMonth,
                                                                                        RD: invoiceAutoPay,
                                                                                        FZ: invoiceAutoPayDay,
                                                                                        F_: invoiceAutoPayMonth,
                                                                                        RE: invoiceAutoSend,
                                                                                        RF: invoiceAutoSendDay,
                                                                                        F$: invoiceAutoSendMonth,
                                                                                        RH: invoiceDueDay,
                                                                                        F0: invoiceDueMonth,
                                                                                        F1: invoiceGracePeriodDays,
                                                                                        F2: invoiceUpcomingAutoSend
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hide_sponsor_invoices', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billing_enabled', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_route_to_recurring_invoice', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_phi_details_updated_by', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_phi_details_updated_at', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_phi_details_enabled', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_grace_period_days', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_pay_month', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_pay_day', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_pay', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_due_month', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_due_day', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue_month', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue_day', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send_month', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send_day', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_upcoming_auto_send', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$Record)))))))))))))))))))));
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id_)));
    });
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$ForCompany = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$Record = F3(function(acceptsAch, acceptsCards, acceptsAmex) {
        return {
            Ie: acceptsAch,
            If: acceptsAmex,
            Ig: acceptsCards
        };
    });
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_amex', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_cards', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_ach', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), $elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentSourceSetting$ForCompany$Record))));
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PaymentSourceSetting$ForCompany$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id_)));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$init = F5(function(_v0, practice, company, shared, _v1) {
        var practiceId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id($author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
        var paymentSettingId = $author$project$Api$Provider$PaymentSourceSetting$Shared$id($author$project$Api$Provider$Practice$One$paymentSourceSetting(practice));
        return _Utils_Tuple2({
            Ej: shared.Ej,
            acy: company,
            cP: shared.cP,
            PU: $elm$core$Maybe$Nothing,
            aef: $author$project$Api$Provider$Company$One$companyInvoiceSettingId(company),
            F3: $author$project$Shared$isHintAdmin(shared),
            aM: $elm$core$Maybe$Nothing,
            r$: $author$project$Api$Provider$Company$One$companyPaymentSourceSettingId(company),
            Ws: $author$project$Api$Data$Loading,
            W1: practice,
            nD: $author$project$Api$Data$Loading,
            sd: $author$project$Api$Data$Loading,
            cr: $author$project$Api$Data$Loading,
            dp: $elm$core$Maybe$Nothing,
            eU: $elm$core$Maybe$Nothing,
            DZ: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, shared.Ej, practiceId, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticeCompanyInvoiceSetting),
            A3($author$project$Api$Provider$PaymentSourceSetting$ForPractice$retrieve, shared.Ej, paymentSettingId, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPracticePaymentSourceSetting),
            A3($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$retrieve, shared.Ej, $author$project$Api$Provider$Company$One$companyInvoiceSettingId(company), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotCompanyInvoiceSetting),
            A3($author$project$Api$Provider$PaymentSourceSetting$ForCompany$retrieve, shared.Ej, $author$project$Api$Provider$Company$One$companyPaymentSourceSettingId(company), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotPaymentSourceSetting),
            A2($author$project$Api$Provider$Practice$One$featureEnabled, 11, practice) ? A3($author$project$Api$Provider$VirtualBankAccount$list, shared.Ej, $author$project$Api$Provider$Company$One$id(company), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount) : $elm$core$Platform$Cmd$none
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            cP: shared.cP
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Close = 3;
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(3);
    };
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Close = 1;
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(1);
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(virtualBankAccountEnableModal) {
                return A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg, $author$project$Components$Company$VirtualBankAccounts$EnableModal$subscriptions(virtualBankAccountEnableModal));
            }, model.eU)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(virtualBankAccountAuthorizeModal) {
                return A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$subscriptions(virtualBankAccountAuthorizeModal));
            }, model.dp))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizedAndConfirmed = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountCreated = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Provider$VirtualBankAccount$authorizeAndCreate = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'authorize_and_create'
        ]), $author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId))));
    });
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            ys: false
        });
    };
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            ys: false
        });
    };
    var $author$project$Api$Provider$VirtualBankAccount$create = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$VirtualBankAccount$virtualBankAccountsPath(companyId)));
    });
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingEnabled = function(_v0) {
        var forCompany = _v0;
        return forCompany.Eu;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate = function(_v0) {
        var forCompany = _v0;
        return forCompany.Kg;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsEnabled = function(_v0) {
        var forCompany = _v0;
        return forCompany.K6;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargeRouteToRecurringInvoice = function(_v0) {
        var forCompany = _v0;
        return forCompany.EM;
    };
    var $author$project$Utils$Overridable$Defaulted = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Utils$Overridable$Overriden = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Utils$Overridable$fromMaybe = F2(function(maybe, default_) {
        if (!maybe.$) {
            var override_ = maybe.a;
            return A2($author$project$Utils$Overridable$Overriden, override_, default_);
        } else return $author$project$Utils$Overridable$Defaulted(default_);
    });
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$hideSponsorInvoices = function(_v0) {
        var forCompany = _v0;
        return forCompany.QI;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssue = function(_v0) {
        var forCompany = _v0;
        return forCompany.RB;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueDay = function(_v0) {
        var forCompany = _v0;
        return forCompany.RC;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueMonth = function(_v0) {
        var forCompany = _v0;
        return forCompany.FY;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPay = function(_v0) {
        var forCompany = _v0;
        return forCompany.RD;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayDay = function(_v0) {
        var forCompany = _v0;
        return forCompany.FZ;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayMonth = function(_v0) {
        var forCompany = _v0;
        return forCompany.F_;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSend = function(_v0) {
        var forCompany = _v0;
        return forCompany.RE;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendDay = function(_v0) {
        var forCompany = _v0;
        return forCompany.RF;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendMonth = function(_v0) {
        var forCompany = _v0;
        return forCompany.F$;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueDay = function(_v0) {
        var forCompany = _v0;
        return forCompany.RH;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueMonth = function(_v0) {
        var forCompany = _v0;
        return forCompany.F0;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceGracePeriodDays = function(_v0) {
        var forCompany = _v0;
        return forCompany.F1;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceUpcomingAutoSend = function(_v0) {
        var forCompany = _v0;
        return forCompany.F2;
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm = F3(function(companySettings, practiceSettings, currentDate) {
        var billingStartDate = function() {
            var _v1 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate(companySettings);
            if (!_v1.$) {
                var date = _v1.a;
                return A2($justinmimbs$date$Date$compare, currentDate, date) === 2 || A2($justinmimbs$date$Date$compare, currentDate, date) === 1 ? $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, 1, currentDate)) : $elm$core$Maybe$Just(date);
            } else return $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, 1, currentDate));
        }();
        var billingEnabledDateToggle = function() {
            var _v0 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingStartDate(companySettings);
            if (!_v0.$) {
                var date = _v0.a;
                return $elm$core$Maybe$Just(!(A2($justinmimbs$date$Date$compare, currentDate, date) === 2 || A2($justinmimbs$date$Date$compare, currentDate, date) === 1));
            } else return $elm$core$Maybe$Just(false);
        }();
        return _Utils_Tuple2({
            Eu: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$billingEnabled(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings)),
            fa: A2($author$project$Utils$Overridable$fromMaybe, billingEnabledDateToggle, $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings)),
            Kg: billingStartDate,
            K6: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsEnabled(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargePhiDetailsEnabled(practiceSettings)),
            EM: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargeRouteToRecurringInvoice(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$chargeRouteToRecurringInvoice(practiceSettings)),
            QI: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$hideSponsorInvoices(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$hideSponsorInvoices(practiceSettings)),
            RB: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssue(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssue(practiceSettings)),
            RC: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueDay(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueDay(practiceSettings)),
            FY: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoIssueMonth(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoIssueMonth(practiceSettings)),
            RD: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPay(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPay(practiceSettings)),
            FZ: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayDay(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayDay(practiceSettings)),
            F_: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoPayMonth(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoPayMonth(practiceSettings)),
            RE: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSend(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSend(practiceSettings)),
            RF: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendDay(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendDay(practiceSettings)),
            F$: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceAutoSendMonth(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceAutoSendMonth(practiceSettings)),
            RH: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueDay(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueDay(practiceSettings)),
            F0: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceDueMonth(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceDueMonth(practiceSettings)),
            F1: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceGracePeriodDays(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceGracePeriodDays(practiceSettings)),
            F2: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$invoiceUpcomingAutoSend(companySettings), $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$invoiceUpcomingAutoSend(practiceSettings))
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPayIssueDateValidation = 4;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter = F2(function(_v0, _v1) {
        var firstDay = _v0.a;
        var firstMonth = _v0.b;
        var secondDay = _v1.a;
        var secondMonth = _v1.b;
        var secondMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(secondMonth);
        var firstMonthInt = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toInt(firstMonth);
        return _Utils_eq(firstMonthInt, secondMonthInt) ? _Utils_cmp(firstDay, secondDay) < 1 : _Utils_cmp(firstMonthInt, secondMonthInt) < 0;
    });
    var $author$project$Utils$Overridable$value = function(overridable) {
        if (!overridable.$) {
            var override_ = overridable.a;
            return override_;
        } else {
            var default_ = overridable.a;
            return default_;
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate = function(form) {
        return $author$project$Utils$Overridable$value(form.RD) && $author$project$Utils$Overridable$value(form.RB) ? A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter, _Utils_Tuple2($author$project$Utils$Overridable$value(form.RC), $author$project$Utils$Overridable$value(form.FY)), _Utils_Tuple2($author$project$Utils$Overridable$value(form.FZ), $author$project$Utils$Overridable$value(form.F_))) : true;
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoIssueDateIsBeforeOrOnAutoPayDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate, _Utils_Tuple2(4, 'The autopay date must be on or after the scheduled issue date'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$IssueDateValidation = 5;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDate, _Utils_Tuple2(5, 'The scheduled issue date must be before or on the autopay date'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPayDateValidation = 3;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate = function(form) {
        return $author$project$Utils$Overridable$value(form.RE) && $author$project$Utils$Overridable$value(form.RD) ? A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter, _Utils_Tuple2($author$project$Utils$Overridable$value(form.RF), $author$project$Utils$Overridable$value(form.F$)), _Utils_Tuple2($author$project$Utils$Overridable$value(form.FZ), $author$project$Utils$Overridable$value(form.F_))) : true;
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate, _Utils_Tuple2(3, 'The autopay date must be on or after the Invoice Created notification date'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate = function(form) {
        return $author$project$Utils$Overridable$value(form.RD) ? A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter, _Utils_Tuple2($author$project$Utils$Overridable$value(form.FZ), $author$project$Utils$Overridable$value(form.F_)), _Utils_Tuple2($author$project$Utils$Overridable$value(form.RH), $author$project$Utils$Overridable$value(form.F0))) : true;
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayIsOnOrBeforeDueDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate, _Utils_Tuple2(3, 'The autopay date must be before the invoice is due'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoSendDateValidation = 1;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsBeforeOrOnPayDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDate, _Utils_Tuple2(1, 'The Invoice Created notification date must be before or on the autopay date'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate = function(form) {
        return $author$project$Utils$Overridable$value(form.RD) || !$author$project$Utils$Overridable$value(form.RE) ? true : A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$isOnOrAfter, _Utils_Tuple2($author$project$Utils$Overridable$value(form.RF), $author$project$Utils$Overridable$value(form.F$)), _Utils_Tuple2($author$project$Utils$Overridable$value(form.RH), $author$project$Utils$Overridable$value(form.F0)));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsOnOrBeforeDueDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate, _Utils_Tuple2(1, 'The Invoice Created notification date must be before the invoice is due'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$DueDateValidation = 6;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDate, _Utils_Tuple2(6, 'The invoice must be due on or after the autopay date'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDate, _Utils_Tuple2(6, 'The invoice must be due on or after the Invoice Created notification date'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$EnableBillingDateValidation = 2;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$enableBillingIsInFutureValidator = function(currentDate) {
        return A2($rtfeldman$elm_validate$Validate$ifFalse, function(_v0) {
            var billingStartDate = _v0.Kg;
            var billingEnabledDateToggle = _v0.fa;
            if (!$author$project$Utils$Overridable$value(billingEnabledDateToggle)) return true;
            else {
                var billingDate = function() {
                    if (!billingStartDate.$) {
                        var date = billingStartDate.a;
                        return date;
                    } else return currentDate;
                }();
                return !(A2($justinmimbs$date$Date$compare, currentDate, billingDate) === 2 || A2($justinmimbs$date$Date$compare, currentDate, billingDate) === 1);
            }
        }, _Utils_Tuple2(2, 'The date must be in the future'));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingValidation = 0;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, function(_v0) {
        var invoiceUpcomingAutoSend = _v0.F2;
        var invoiceAutoSend = _v0.RE;
        return $author$project$Utils$Overridable$value(invoiceUpcomingAutoSend) ? $author$project$Utils$Overridable$value(invoiceAutoSend) : true;
    }, _Utils_Tuple2(0, 'This notification can only be enabled if the Invoice Created notification is also enabled'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceUpcomingIsEnabledIfInvoiceCreatedIsEnabledValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, function(_v0) {
        var invoiceUpcomingAutoSend = _v0.F2;
        var invoiceAutoSend = _v0.RE;
        return $author$project$Utils$Overridable$value(invoiceUpcomingAutoSend) ? $author$project$Utils$Overridable$value(invoiceAutoSend) : true;
    }, _Utils_Tuple2(1, 'This notification cannot be disabled if the Invoice Upcoming notification is enabled'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceCreatedIsEnabledIfInvoiceUpcomingIsEnabledValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceUpcomingIsEnabledIfInvoiceCreatedIsEnabledValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoIssueDateIsBeforeOrOnAutoPayDateValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoSendDateValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayDateIsOnOrAfterAutoIssueDateValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsBeforeOrOnPayDateValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoPayDateValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoPayIsOnOrBeforeDueDateValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$dueDateIsOnOrAfterAutoSendDateValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$autoSendDateIsOnOrBeforeDueDateValidator,
            $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$enableBillingIsInFutureValidator(currentDate)
        ]));
    };
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$init = function(companyName) {
        return {
            LN: companyName,
            q7: false,
            ys: true,
            j_: $author$project$Api$Data$NotAsked
        };
    };
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$init = function(companyName) {
        return {
            LN: companyName,
            ys: true,
            j_: $author$project$Api$Data$NotAsked
        };
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAch = function(_v0) {
        var forCompany = _v0;
        return forCompany.Ie;
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAmex = function(_v0) {
        var forCompany = _v0;
        return forCompany.If;
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsCards = function(_v0) {
        var forCompany = _v0;
        return forCompany.Ig;
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields = F2(function(practicePaymentSourceSetting, paymentSourceSetting) {
        return {
            Ie: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAch(paymentSourceSetting), $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAch(practicePaymentSourceSetting)),
            If: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsAmex(paymentSourceSetting), $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsAmex(practicePaymentSourceSetting)),
            Ig: A2($author$project$Utils$Overridable$fromMaybe, $author$project$Api$Provider$PaymentSourceSetting$ForCompany$acceptsCards(paymentSourceSetting), $author$project$Api$Provider$PaymentSourceSetting$ForPractice$acceptsCards(practicePaymentSourceSetting))
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var overridableBool = field.a;
                return _Utils_update(fields, {
                    Ie: overridableBool
                });
            case 1:
                var overridableBool = field.a;
                return _Utils_update(fields, {
                    If: overridableBool,
                    Ig: overridableBool
                });
            default:
                var overridableBool = field.a;
                return _Utils_update(fields, {
                    If: overridableBool
                });
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmexValidation = 0;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$sponsorAcceptsAllCards = function(form) {
        return !(!$author$project$Utils$Overridable$value(form.Ig) && $author$project$Utils$Overridable$value(form.If));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$acceptsAmexValidator = A2($rtfeldman$elm_validate$Validate$ifFalse, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$sponsorAcceptsAllCards, _Utils_Tuple2(0, 'If the sponsor does not accept cards they cannot accept Amex'));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$acceptsAmexValidator
    ]));
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingStartDate = function(_v0) {
        var forPractice = _v0;
        return forPractice.Kg;
    };
    var $author$project$Utils$Overridable$toMaybe = function(overridable) {
        if (!overridable.$) {
            var override_ = overridable.a;
            return $elm$core$Maybe$Just(override_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable = F2(function(encoder, maybeA) {
        return A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, encoder, maybeA));
    });
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company_invoice_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('invoice_upcoming_auto_send', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.F2)),
                _Utils_Tuple2('invoice_auto_send', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.RE)),
                _Utils_Tuple2('invoice_auto_send_day', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.RF)),
                _Utils_Tuple2('invoice_auto_send_month', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.F$)),
                _Utils_Tuple2('invoice_auto_issue', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.RB)),
                _Utils_Tuple2('invoice_auto_issue_day', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.RC)),
                _Utils_Tuple2('invoice_auto_issue_month', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.FY)),
                _Utils_Tuple2('invoice_due_day', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.RH)),
                _Utils_Tuple2('invoice_due_month', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.F0)),
                _Utils_Tuple2('invoice_auto_pay', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.RD)),
                _Utils_Tuple2('invoice_auto_pay_day', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.FZ)),
                _Utils_Tuple2('invoice_auto_pay_month', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$encoder, fields.F_)),
                _Utils_Tuple2('invoice_grace_period_days', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$int, fields.F1)),
                _Utils_Tuple2('charge_phi_details_enabled', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.K6)),
                _Utils_Tuple2('charge_route_to_recurring_invoice', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.EM)),
                _Utils_Tuple2('billing_enabled', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Eu)),
                _Utils_Tuple2('billing_start_date', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $author$project$Utils$Date$encode, fields.Kg)),
                _Utils_Tuple2('hide_sponsor_invoices', A2($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.QI))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CompanyInvoiceSetting$Shared$companyInvoiceSettingPath(id))));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings = F5(function(apiClient, id, formFields, practiceSettings, currentDate) {
        var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var billingStartDate = function() {
            var _v0 = $author$project$Utils$Overridable$toMaybe(validated.Eu);
            if (!_v0.$) {
                var billingEnabled = _v0.a;
                return !billingEnabled ? $elm$core$Maybe$Nothing : !$author$project$Utils$Overridable$value(validated.fa) ? $elm$core$Maybe$Just(currentDate) : validated.Kg;
            } else {
                if (practiceSettings.$ === 3) {
                    var settings = practiceSettings.a;
                    return $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingStartDate(settings);
                } else return validated.Kg;
            }
        }();
        var flattenedForm = {
            Eu: $author$project$Utils$Overridable$toMaybe(validated.Eu),
            Kg: billingStartDate,
            K6: $author$project$Utils$Overridable$toMaybe(validated.K6),
            EM: $author$project$Utils$Overridable$toMaybe(validated.EM),
            QI: $author$project$Utils$Overridable$toMaybe(validated.QI),
            RB: $author$project$Utils$Overridable$toMaybe(validated.RB),
            RC: $author$project$Utils$Overridable$toMaybe(validated.RC),
            FY: $author$project$Utils$Overridable$toMaybe(validated.FY),
            RD: $author$project$Utils$Overridable$toMaybe(validated.RD),
            FZ: $author$project$Utils$Overridable$toMaybe(validated.FZ),
            F_: $author$project$Utils$Overridable$toMaybe(validated.F_),
            RE: $author$project$Utils$Overridable$toMaybe(validated.RE),
            RF: $author$project$Utils$Overridable$toMaybe(validated.RF),
            F$: $author$project$Utils$Overridable$toMaybe(validated.F$),
            RH: $author$project$Utils$Overridable$toMaybe(validated.RH),
            F0: $author$project$Utils$Overridable$toMaybe(validated.F0),
            F1: $author$project$Utils$Overridable$toMaybe(validated.F1),
            F2: $author$project$Utils$Overridable$toMaybe(validated.F2)
        };
        return A4($author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$update, apiClient, id, flattenedForm, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsUpdated);
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentSourceSettingUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable = F2(function(encoder, maybeA) {
        return A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, encoder, maybeA));
    });
    var $author$project$Api$Provider$PaymentSourceSetting$ForCompany$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment_source_setting', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('accepts_ach', A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Ie)),
                _Utils_Tuple2('accepts_cards', A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.Ig)),
                _Utils_Tuple2('accepts_amex', A2($author$project$Api$Provider$PaymentSourceSetting$ForCompany$encodeNullable, $elm$json$Json$Encode$bool, fields.If))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$PaymentSourceSetting$ForCompany$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PaymentSourceSetting$Shared$paymentSourceSettingPath(id))));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting = F3(function(apiClient, id, formFields) {
        var validated = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var flattenedForm = {
            Ie: $author$project$Utils$Overridable$toMaybe(validated.Ie),
            If: $author$project$Utils$Overridable$toMaybe(validated.If),
            Ig: $author$project$Utils$Overridable$toMaybe(validated.Ig)
        };
        return A4($author$project$Api$Provider$PaymentSourceSetting$ForCompany$update, apiClient, id, flattenedForm, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentSourceSettingUpdated);
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting = function(model) {
        var _v0 = _Utils_Tuple2(model.PU, model.aM);
        if (!_v0.a.$) {
            if (_v0.b.$ === 1) {
                var form = _v0.a.a;
                var _v1 = _v0.b;
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.cP), form);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        cr: $author$project$Api$Data$Loading
                    }), A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.Ej, model.aef, validFormFields, model.sd, model.cP), _List_Nil);
                } else {
                    var newForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            } else {
                var form = _v0.a.a;
                var paymentForm = _v0.b.a;
                var _v4 = _Utils_Tuple2(A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.cP), form), A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator, paymentForm));
                if (!_v4.a.$) {
                    if (!_v4.b.$) {
                        var _v5 = _v4.a.a;
                        var newForm = _v5.a;
                        var validFormFields = _v5.b;
                        var _v6 = _v4.b.a;
                        var newPaymentForm = _v6.a;
                        var validPaymentFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            aM: $elm$core$Maybe$Just(newPaymentForm),
                            Ws: $author$project$Api$Data$Loading,
                            cr: $author$project$Api$Data$Loading
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.Ej, model.aef, validFormFields, model.sd, model.cP),
                            A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.Ej, model.r$, validPaymentFormFields)
                        ])), _List_Nil);
                    } else {
                        var _v7 = _v4.a.a;
                        var newForm = _v7.a;
                        var validFormFields = _v7.b;
                        var newPaymentForm = _v4.b.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            aM: $elm$core$Maybe$Just(newPaymentForm),
                            cr: $author$project$Api$Data$Loading
                        }), A5($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceSettings, model.Ej, model.aef, validFormFields, model.sd, model.cP), _List_Nil);
                    }
                } else if (!_v4.b.$) {
                    var newForm = _v4.a.a;
                    var _v8 = _v4.b.a;
                    var newPaymentForm = _v8.a;
                    var validPaymentFormFields = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        aM: $elm$core$Maybe$Just(newPaymentForm),
                        Ws: $author$project$Api$Data$Loading
                    }), A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.Ej, model.r$, validPaymentFormFields), _List_Nil);
                } else {
                    var newForm = _v4.a.a;
                    var newPaymentForm = _v4.b.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        aM: $elm$core$Maybe$Just(newPaymentForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            }
        } else if (!_v0.b.$) {
            var _v9 = _v0.a;
            var paymentForm = _v0.b.a;
            var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator, paymentForm);
            if (!_v10.$) {
                var _v11 = _v10.a;
                var newForm = _v11.a;
                var validFormFields = _v11.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    aM: $elm$core$Maybe$Just(newForm),
                    Ws: $author$project$Api$Data$Loading
                }), A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updatePaymentSourceSetting, model.Ej, model.r$, validFormFields), _List_Nil);
            } else {
                var newForm = _v10.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aM: $elm$core$Maybe$Just(newForm)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            }
        } else {
            var _v12 = _v0.a;
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    };
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Closed = 2;
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$Confirm = 1;
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$None = 0;
    var $author$project$Ports$NewTab$open = _Platform_outgoingPort('open', $elm$json$Json$Encode$string);
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$StripeTimerDone = 1;
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$stripeButtonClicked = A2($elm$core$Task$perform, function(_v0) {
        return 1;
    }, $elm$core$Process$sleep(3000));
    var $author$project$Utils$HintUrls$stripePaymentMethodsUrl = 'https://dashboard.stripe.com/settings/payment_methods';
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg){
            case 0:
                var cmd = model.q7 ? $author$project$Ports$NewTab$open($author$project$Utils$HintUrls$stripePaymentMethodsUrl) : $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Ports$NewTab$open($author$project$Utils$HintUrls$stripePaymentMethodsUrl),
                    $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$stripeButtonClicked
                ]));
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        q7: true
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(model),
                    at: _List_Nil
                };
            default:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(model),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Closed = 1;
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Confirmed = 0;
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$update = F2(function(msg, _v0) {
        var model = _v0;
        if (!msg) return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 0,
            zi: $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(model),
            at: _List_Nil
        };
        else return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 1,
            zi: $author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(model),
            at: _List_Nil
        };
    });
    var $author$project$Utils$Overridable$default = function(overridable) {
        if (!overridable.$) {
            var default_ = overridable.b;
            return default_;
        } else {
            var default_ = overridable.a;
            return default_;
        }
    };
    var $author$project$Utils$Overridable$makeDefault = function(overridable) {
        if (!overridable.$) {
            var default_ = overridable.b;
            return $author$project$Utils$Overridable$Defaulted(default_);
        } else return overridable;
    };
    var $author$project$Utils$Overridable$overriden = F2(function(override_, default_) {
        return A2($author$project$Utils$Overridable$Overriden, override_, default_);
    });
    var $author$project$Utils$Overridable$switch = function(overridable) {
        if (!overridable.$) {
            var default_ = overridable.b;
            return $author$project$Utils$Overridable$Defaulted(default_);
        } else {
            var default_ = overridable.a;
            return A2($author$project$Utils$Overridable$Overriden, default_, default_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updateFormField = F2(function(formField, form) {
        switch(formField.$){
            case 0:
                var overridableBool = formField.a;
                return _Utils_update(form, {
                    F2: overridableBool
                });
            case 15:
                var settingGroup = formField.a;
                var isDefault = formField.b;
                switch(settingGroup){
                    case 0:
                        return isDefault ? _Utils_update(form, {
                            RE: $author$project$Utils$Overridable$makeDefault(form.RE),
                            RF: $author$project$Utils$Overridable$makeDefault(form.RF),
                            F$: $author$project$Utils$Overridable$makeDefault(form.F$)
                        }) : _Utils_update(form, {
                            RE: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.RE), $author$project$Utils$Overridable$default(form.RE)),
                            RF: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.RF), $author$project$Utils$Overridable$default(form.RF)),
                            F$: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.F$), $author$project$Utils$Overridable$default(form.F$))
                        });
                    case 1:
                        return isDefault ? _Utils_update(form, {
                            RB: $author$project$Utils$Overridable$makeDefault(form.RB),
                            RC: $author$project$Utils$Overridable$makeDefault(form.RC),
                            FY: $author$project$Utils$Overridable$makeDefault(form.FY)
                        }) : _Utils_update(form, {
                            RB: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.RB), $author$project$Utils$Overridable$default(form.RB)),
                            RC: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.RC), $author$project$Utils$Overridable$default(form.RC)),
                            FY: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.FY), $author$project$Utils$Overridable$default(form.FY))
                        });
                    case 5:
                        return isDefault ? _Utils_update(form, {
                            Eu: $author$project$Utils$Overridable$makeDefault(form.Eu)
                        }) : _Utils_update(form, {
                            Eu: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.Eu), $author$project$Utils$Overridable$default(form.Eu))
                        });
                    case 2:
                        return isDefault ? _Utils_update(form, {
                            RD: $author$project$Utils$Overridable$makeDefault(form.RD),
                            FZ: $author$project$Utils$Overridable$makeDefault(form.FZ),
                            F_: $author$project$Utils$Overridable$makeDefault(form.F_)
                        }) : _Utils_update(form, {
                            RD: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.RD), $author$project$Utils$Overridable$default(form.RD)),
                            FZ: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.FZ), $author$project$Utils$Overridable$default(form.FZ)),
                            F_: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.F_), $author$project$Utils$Overridable$default(form.F_))
                        });
                    case 3:
                        return isDefault ? _Utils_update(form, {
                            RH: $author$project$Utils$Overridable$makeDefault(form.RH),
                            F0: $author$project$Utils$Overridable$makeDefault(form.F0)
                        }) : _Utils_update(form, {
                            RH: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.RH), $author$project$Utils$Overridable$default(form.RH)),
                            F0: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$default(form.F0), $author$project$Utils$Overridable$default(form.F0))
                        });
                    default:
                        return _Utils_update(form, {
                            F1: $author$project$Utils$Overridable$switch(form.F1)
                        });
                }
            case 1:
                var overridableBool = formField.a;
                return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(form, {
                    RE: overridableBool,
                    RF: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$value(form.RF), $author$project$Utils$Overridable$default(form.RF)),
                    F$: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$value(form.F$), $author$project$Utils$Overridable$default(form.F$))
                }) : _Utils_update(form, {
                    RE: overridableBool,
                    RF: $author$project$Utils$Overridable$makeDefault(form.RF),
                    F$: $author$project$Utils$Overridable$makeDefault(form.F$)
                });
            case 2:
                var string = formField.a;
                var autosendDay = $elm$core$String$toInt(string);
                if (!autosendDay.$) {
                    var day = autosendDay.a;
                    return _Utils_update(form, {
                        RF: A2($author$project$Utils$Overridable$overriden, day, $author$project$Utils$Overridable$default(form.RF))
                    });
                } else return form;
            case 3:
                var string = formField.a;
                var maybeAutoSendMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
                if (!maybeAutoSendMonth.$) {
                    var autosendMonth = maybeAutoSendMonth.a;
                    return _Utils_update(form, {
                        F$: A2($author$project$Utils$Overridable$overriden, autosendMonth, $author$project$Utils$Overridable$default(form.F$))
                    });
                } else return form;
            case 4:
                var overridableBool = formField.a;
                return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(form, {
                    RB: overridableBool,
                    RC: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$value(form.RC), $author$project$Utils$Overridable$default(form.RC)),
                    FY: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$value(form.FY), $author$project$Utils$Overridable$default(form.FY))
                }) : _Utils_update(form, {
                    RB: overridableBool,
                    RC: $author$project$Utils$Overridable$makeDefault(form.RC),
                    FY: $author$project$Utils$Overridable$makeDefault(form.FY)
                });
            case 5:
                var string = formField.a;
                var autoIssueDay = $elm$core$String$toInt(string);
                if (!autoIssueDay.$) {
                    var day = autoIssueDay.a;
                    return _Utils_update(form, {
                        RC: A2($author$project$Utils$Overridable$overriden, day, $author$project$Utils$Overridable$default(form.RC))
                    });
                } else return form;
            case 6:
                var string = formField.a;
                var maybeAutoIssueMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
                if (!maybeAutoIssueMonth.$) {
                    var autoIssueMonth = maybeAutoIssueMonth.a;
                    return _Utils_update(form, {
                        FY: A2($author$project$Utils$Overridable$overriden, autoIssueMonth, $author$project$Utils$Overridable$default(form.FY))
                    });
                } else return form;
            case 7:
                var overridableBool = formField.a;
                return $author$project$Utils$Overridable$value(overridableBool) ? _Utils_update(form, {
                    RD: overridableBool,
                    FZ: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$value(form.FZ), $author$project$Utils$Overridable$default(form.FZ)),
                    F_: A2($author$project$Utils$Overridable$overriden, $author$project$Utils$Overridable$value(form.F_), $author$project$Utils$Overridable$default(form.F_))
                }) : _Utils_update(form, {
                    RD: overridableBool,
                    FZ: $author$project$Utils$Overridable$makeDefault(form.FZ),
                    F_: $author$project$Utils$Overridable$makeDefault(form.F_)
                });
            case 8:
                var string = formField.a;
                var autoPayDay = $elm$core$String$toInt(string);
                if (!autoPayDay.$) {
                    var day = autoPayDay.a;
                    return _Utils_update(form, {
                        FZ: A2($author$project$Utils$Overridable$overriden, day, $author$project$Utils$Overridable$default(form.FZ))
                    });
                } else return form;
            case 9:
                var string = formField.a;
                var maybeAutoPayMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
                if (!maybeAutoPayMonth.$) {
                    var autoPayMonth = maybeAutoPayMonth.a;
                    return _Utils_update(form, {
                        F_: A2($author$project$Utils$Overridable$overriden, autoPayMonth, $author$project$Utils$Overridable$default(form.F_))
                    });
                } else return form;
            case 10:
                var string = formField.a;
                var dueDay = $elm$core$String$toInt(string);
                if (!dueDay.$) {
                    var day = dueDay.a;
                    return _Utils_update(form, {
                        RH: A2($author$project$Utils$Overridable$overriden, day, $author$project$Utils$Overridable$default(form.RH))
                    });
                } else return form;
            case 11:
                var string = formField.a;
                var maybeDueMonth = $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$fromString(string);
                if (!maybeDueMonth.$) {
                    var month = maybeDueMonth.a;
                    return _Utils_update(form, {
                        F0: A2($author$project$Utils$Overridable$overriden, month, $author$project$Utils$Overridable$default(form.F0))
                    });
                } else return form;
            case 16:
                var overridableBool = formField.a;
                return _Utils_update(form, {
                    fa: overridableBool
                });
            case 17:
                var overridableBool = formField.a;
                return _Utils_update(form, {
                    Eu: overridableBool
                });
            case 18:
                var overridableBool = formField.a;
                return _Utils_update(form, {
                    QI: overridableBool
                });
            case 19:
                var selectedDateOption = formField.a;
                return _Utils_update(form, {
                    Kg: $elm$core$Result$toMaybe($justinmimbs$date$Date$fromIsoString(selectedDateOption))
                });
            case 12:
                var string = formField.a;
                var days = A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(string));
                return _Utils_update(form, {
                    F1: A2($author$project$Utils$Overridable$overriden, days, $author$project$Utils$Overridable$default(form.F1))
                });
            case 13:
                var overridableBool = formField.a;
                return _Utils_update(form, {
                    K6: overridableBool
                });
            default:
                var overridableBool = formField.a;
                return _Utils_update(form, {
                    EM: overridableBool
                });
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                var _v1 = _Utils_Tuple2(response, model.sd);
                if (_v1.a.$ === 3 && _v1.b.$ === 3) {
                    var _v2 = _v1.a;
                    var companySettings = _v2.a;
                    var _v3 = _v1.b;
                    var practiceSettings = _v3.a;
                    var _v4 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companySettings, practiceSettings, model.cP);
                    var fields = _v4.a;
                    var cmd = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.cP), $author$project$Utils$Form$init(fields)))),
                        cr: response
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cr: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                var _v5 = _Utils_Tuple2(response, model.nD);
                if (_v5.a.$ === 3 && _v5.b.$ === 3) {
                    var _v6 = _v5.a;
                    var paymentSourceSetting = _v6.a;
                    var _v7 = _v5.b;
                    var practicePaymentSourceSetting = _v7.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aM: $elm$core$Maybe$Just($author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsValidator, $author$project$Utils$Form$init(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))))),
                        Ws: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Ws: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                var _v8 = _Utils_Tuple2(response, model.Ws);
                if (_v8.a.$ === 3 && _v8.b.$ === 3) {
                    var _v9 = _v8.a;
                    var practicePaymentSourceSetting = _v9.a;
                    var _v10 = _v8.b;
                    var paymentSourceSetting = _v10.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aM: $elm$core$Maybe$Just($author$project$Utils$Form$init(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))),
                        nD: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    nD: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                var _v11 = _Utils_Tuple2(response, model.cr);
                if (_v11.a.$ === 3 && _v11.b.$ === 3) {
                    var _v12 = _v11.a;
                    var practiceSettings = _v12.a;
                    var _v13 = _v11.b;
                    var companySettings = _v13.a;
                    var _v14 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companySettings, practiceSettings, model.cP);
                    var fields = _v14.a;
                    var cmd = _v14.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init(fields)),
                        sd: response
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    sd: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var formField = msg.a;
                var _v15 = model.PU;
                if (!_v15.$) {
                    var form = _v15.a;
                    return function(newForm) {
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }($author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$formFieldsValidator(model.cP), A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$updateFormField, formField, form))));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var field = msg.a;
                var _v16 = model.aM;
                if (!_v16.$) {
                    var form = _v16.a;
                    return function(newForm) {
                        return _Utils_Tuple3(_Utils_update(model, {
                            aM: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }(A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$paymentFormFieldsUpdate, field, form));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$submitCompanyInvoiceAndPaymentSetting(model);
            case 7:
                var response = msg.a;
                var _v17 = _Utils_Tuple2(response, model.sd);
                if (_v17.a.$ === 3 && _v17.b.$ === 3) {
                    var _v18 = _v17.a;
                    var companyInvoiceSettings = _v18.a;
                    var _v19 = _v17.b;
                    var practiceSettings = _v19.a;
                    var _v20 = A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createForm, companyInvoiceSettings, practiceSettings, model.cP);
                    var fields = _v20.a;
                    var cmd = _v20.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init(fields)),
                        cr: response
                    }), cmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Invoice settings updated')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cr: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var response = msg.a;
                var _v21 = _Utils_Tuple2(response, model.nD);
                if (_v21.a.$ === 3 && _v21.b.$ === 3) {
                    var _v22 = _v21.a;
                    var paymentSourceSetting = _v22.a;
                    var _v23 = _v21.b;
                    var practicePaymentSourceSetting = _v23.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aM: $elm$core$Maybe$Just($author$project$Utils$Form$init(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$initPaymentFormFields, practicePaymentSourceSetting, paymentSourceSetting))),
                        Ws: response
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Payment options settings updated')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Ws: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var acceptsSourceBankTransfers = msg.a;
                return acceptsSourceBankTransfers ? _Utils_Tuple3(_Utils_update(model, {
                    eU: $elm$core$Maybe$Just($author$project$Components$Company$VirtualBankAccounts$EnableModal$init($author$project$Api$Provider$Company$One$name(model.acy)))
                }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    dp: $elm$core$Maybe$Just($author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$init($author$project$Api$Provider$Company$One$name(model.acy)))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var subMsg = msg.a;
                var _v24 = model.eU;
                if (!_v24.$) {
                    var virtualBankAccountEnableModal = _v24.a;
                    var modalResult = A2($author$project$Components$Company$VirtualBankAccounts$EnableModal$update, subMsg, virtualBankAccountEnableModal);
                    var _v25 = modalResult.adu;
                    if (_v25 === 1) return _Utils_Tuple3(_Utils_update(model, {
                        eU: $elm$core$Maybe$Just($author$project$Components$Company$VirtualBankAccounts$EnableModal$closeModal(virtualBankAccountEnableModal))
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg, modalResult.EQ), modalResult.at);
                    else {
                        var createCmd = A3($author$project$Api$Provider$VirtualBankAccount$create, model.Ej, $author$project$Api$Provider$Company$One$id(model.acy), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountCreated);
                        return _Utils_Tuple3(_Utils_update(model, {
                            eU: $elm$core$Maybe$Just(modalResult.zi)
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            createCmd,
                            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg, modalResult.EQ)
                        ])), modalResult.at);
                    }
                } else return _Utils_Tuple3(_Utils_update(model, {
                    eU: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A3($author$project$Api$Provider$VirtualBankAccount$list, model.Ej, $author$project$Api$Provider$Company$One$id(model.acy), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Bank Transfer account enabled')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 12:
                var response = msg.a;
                if (response.$ === 3) {
                    var virtualBankAccounts = response.a;
                    return $elm$core$List$isEmpty(virtualBankAccounts) ? _Utils_Tuple3(_Utils_update(model, {
                        DZ: $elm$core$Maybe$Nothing
                    }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        DZ: $elm$core$Maybe$Just(virtualBankAccounts)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    DZ: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 13:
                var subMsg = msg.a;
                var _v28 = model.dp;
                if (!_v28.$) {
                    var virtualBankAccountAuthorizeModal = _v28.a;
                    var modalResult = A2($author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$update, subMsg, virtualBankAccountAuthorizeModal);
                    var _v29 = modalResult.adu;
                    switch(_v29){
                        case 0:
                            return _Utils_Tuple3(_Utils_update(model, {
                                dp: $elm$core$Maybe$Just(modalResult.zi)
                            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.EQ), modalResult.at);
                        case 2:
                            return _Utils_Tuple3(_Utils_update(model, {
                                dp: $elm$core$Maybe$Just($author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(virtualBankAccountAuthorizeModal))
                            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.EQ), modalResult.at);
                        default:
                            var createCmd = A3($author$project$Api$Provider$VirtualBankAccount$authorizeAndCreate, model.Ej, $author$project$Api$Provider$Company$One$id(model.acy), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizedAndConfirmed);
                            return _Utils_Tuple3(_Utils_update(model, {
                                dp: $elm$core$Maybe$Just($author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$closeModal(virtualBankAccountAuthorizeModal))
                            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, modalResult.EQ),
                                createCmd
                            ])), modalResult.at);
                    }
                } else return _Utils_Tuple3(_Utils_update(model, {
                    dp: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A3($author$project$Api$Provider$VirtualBankAccount$list, model.Ej, $author$project$Api$Provider$Company$One$id(model.acy), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GotVirtualBankAccount), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Authorization confirmed and transfer details created for ' + $author$project$Api$Provider$Company$One$name(model.acy))
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsSubmitted = {
        $: 6
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedAt = function(_v0) {
        var forCompany = _v0;
        return forCompany.K7;
    };
    var $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedBy = function(_v0) {
        var forCompany = _v0;
        return forCompany.K8;
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting = F2(function(func, maybeForm) {
        if (!maybeForm.$) {
            var form = maybeForm.a;
            return func(form);
        } else return _List_Nil;
    });
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$ConfirmAndEnable = 2;
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$GoToStripeClicked = 0;
    var $author$project$Utils$HintUrls$stripeBankTransfersUrl = 'https://docs.stripe.com/payments/bank-transfers';
    var $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$modal = function(_v0) {
        var model = _v0;
        return model.ys ? A3($author$project$Ui$Modal$view, 3, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Stripe Authorization Needed')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit(2),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$fontWeight(1)
                    ]), _List_fromArray([
                        $elm$html$Html$text("To activate bank transfers for employers, you will first need to turn on bank transfer payments in Stripe. Click \u201CGo to Stripe\u201D to complete the setup."),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$stripeBankTransfersUrl, _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('Learn More')
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$justifyCenter)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick(3)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    model.q7 ? A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter),
                        $author$project$Ui$Typography$margin(12)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Go to stripe'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick(0)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Go to Stripe')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Confirm and enable bank transfers'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick(2),
                            $author$project$Ui$Button$submit
                        ]), _List_fromArray([
                            $elm$html$Html$text('Confirm and Enable')
                        ]))
                    ])) : A3($author$project$Ui$Button$view, {
                        abP: 'Go to stripe'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick(0)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Go to Stripe')
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$Confirm = 0;
    var $author$project$Components$Company$VirtualBankAccounts$EnableModal$modal = function(_v0) {
        var model = _v0;
        return model.ys ? A3($author$project$Ui$Modal$view, 1, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Enable Bank Transfers for ' + model.LN)
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit(0),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock,
                        $author$project$Ui$Typography$fontWeight(1)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Clicking Confirm will allow the employer to transfer funds directly to that account to pay invoices. This setting will apply to all future invoices for this employer.')
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick(1)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Confirm'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick(0),
                        $author$project$Ui$Button$submit
                    ]), _List_fromArray([
                        $elm$html$Html$text('Confirm')
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Utils$Overridable$isOverriden = function(overridable) {
        if (!overridable.$) return true;
        else return false;
    };
    var $author$project$Utils$Overridable$override = F2(function(override_, overridable) {
        return A2($author$project$Utils$Overridable$Overriden, override_, $author$project$Utils$Overridable$default(overridable));
    });
    var $author$project$Formatters$Bool$toOnOff = function(bool) {
        return bool ? 'On' : 'Off';
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargePhiDetailsEnabled = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var overrideText = $author$project$Utils$Overridable$isOverriden(fields.K6) ? 'Remove override' : 'Override';
        var value = $author$project$Utils$Overridable$value(fields.K6);
        return _Utils_ap($author$project$Utils$Overridable$isOverriden(fields.K6) ? _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(value),
                $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                    return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled(A2($author$project$Utils$Overridable$override, bool, fields.K6)));
                })
            ]))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toOnOff(value))
                ]))
            ]))
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: overrideText
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargePhiDetailsEnabled($author$project$Utils$Overridable$switch(fields.K6))))
            ]), _List_fromArray([
                $elm$html$Html$text(overrideText)
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargeRouteToRecurringInvoice = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var overrideText = $author$project$Utils$Overridable$isOverriden(fields.EM) ? 'Remove override' : 'Override';
        var value = $author$project$Utils$Overridable$value(fields.EM);
        return _Utils_ap($author$project$Utils$Overridable$isOverriden(fields.EM) ? _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(value),
                    $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                        return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice(A2($author$project$Utils$Overridable$override, bool, fields.EM)));
                    })
                ]))
            ]))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toOnOff(value))
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: overrideText
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$ChargeRouteToRecurringInvoice($author$project$Utils$Overridable$switch(fields.EM))))
                ]), _List_fromArray([
                    $elm$html$Html$text(overrideText)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabled = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle = F2(function(a, b) {
        return {
            $: 15,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$StartDateToggleBilling = 5;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingToggle = F2(function(isHintAdmin, form) {
        var fields = $author$project$Utils$Form$fields(form);
        return _Utils_ap($author$project$Utils$Overridable$isOverriden(fields.Eu) ? _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on($author$project$Utils$Overridable$value(fields.Eu)),
                    $author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
                    $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                        return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabled(A2($author$project$Utils$Overridable$override, bool, fields.Eu)));
                    })
                ]))
            ]))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toOnOff($author$project$Utils$Overridable$value(fields.Eu)))
                ]))
            ]))
        ]), _List_fromArray([
            function() {
                if (isHintAdmin) {
                    var overrideText = $author$project$Utils$Overridable$isOverriden(fields.Eu) ? 'Remove override' : 'Override';
                    return A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: overrideText
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle, 5, $author$project$Utils$Overridable$isOverriden(fields.Eu))))
                        ]), _List_fromArray([
                            $elm$html$Html$text(overrideText)
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBilling = F2(function(isHintAdmin, form) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Billing (Hinter only)')
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('We will bill sponsors when this setting is enabled. When this setting is disabled, we will not bill sponsors, but are still tracking employee eligibility.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingToggle, isHintAdmin, form))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabledDateToggle = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingStartDateSelected = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingSelectedDropdownDate = F2(function(billingStartDate, currentDate) {
        if (!billingStartDate.$) {
            var date = billingStartDate.a;
            return date;
        } else return currentDate;
    });
    var $author$project$Utils$Date$changeDay = F2(function(day, date) {
        var year = $justinmimbs$date$Date$year(date);
        var month = $justinmimbs$date$Date$month(date);
        return A3($justinmimbs$date$Date$fromCalendarDate, year, month, day);
    });
    var $author$project$Utils$Date$toBeginningOfMonth = function(date) {
        return A2($author$project$Utils$Date$changeDay, 1, date);
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingStartDateOptions = function(startDate) {
        return $author$project$Ui$Form$Select$dateOptions($author$project$Utils$Date$nextTwelveMonths($author$project$Utils$Date$toBeginningOfMonth(startDate)));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingDate = F2(function(form, currentDate) {
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mr-2')
                ]), _List_fromArray([
                    $author$project$Utils$Overridable$value(fields.fa) ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Utils$Date$toIsoString(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingSelectedDropdownDate, fields.Kg, currentDate)))),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingStartDateSelected))
                    ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnabledBillingStartDateOptions(currentDate)) : $author$project$Utils$Html$empty
                ])),
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on($author$project$Utils$Overridable$value(fields.fa)),
                    $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                        return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$BillingEnabledDateToggle(A2($author$project$Utils$Overridable$override, bool, fields.fa)));
                    })
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate = F2(function(form, currentDate) {
        var fields = $author$project$Utils$Form$fields(form);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Utils$Overridable$value(fields.Eu) && $author$project$Utils$Overridable$isOverriden(fields.Eu) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Start billing in the future')
                ])),
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mb4
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Select a date when sponsor billing will start. Changing this date will cause all draft and outstanding invoices to be CANCELLED.')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingDate, form, currentDate))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_Nil)
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoicesToggle = F2(function(isHintAdmin, form) {
        var fields = $author$project$Utils$Form$fields(form);
        return _Utils_ap($author$project$Utils$Overridable$isOverriden(fields.QI) ? _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on($author$project$Utils$Overridable$value(fields.QI)),
                    $author$project$Ui$ToggleSwitch$disabled(!isHintAdmin),
                    $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                        return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices(A2($author$project$Utils$Overridable$override, bool, fields.QI)));
                    })
                ]))
            ]))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toOnOff($author$project$Utils$Overridable$value(fields.QI)))
                ]))
            ]))
        ]), _List_fromArray([
            function() {
                if (isHintAdmin) {
                    var overrideText = $author$project$Utils$Overridable$isOverriden(fields.QI) ? 'Remove override' : 'Override';
                    return A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A3($author$project$Ui$HinterOnly$button, {
                            abP: overrideText
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$HideSponsorInvoices($author$project$Utils$Overridable$switch(fields.QI))))
                        ]), _List_fromArray([
                            $elm$html$Html$text(overrideText)
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoices = F2(function(isHintAdmin, form) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Hide Sponsor Invoice Tab (Hinter only)')
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('When billing is disabled for sponsors, the Invoices tab will be hidden in the employer portal.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoicesToggle, isHintAdmin, form))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoIssue = 1;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssue = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueDay = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueMonth = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$daysOfMonth = A2($elm$core$List$range, 1, 31);
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions = A2($elm$core$List$map, function(day) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(day)), $author$project$Formatters$Int$ordinal(day));
    }, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$daysOfMonth);
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions = A2($elm$core$List$map, function(option) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)), $author$project$Formatters$String$humanize($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(option)));
    }, $author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$enumerate);
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow = function(message) {
        return A2($elm$html$Html$div, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'padding-top', '10px')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$danger,
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text(message)
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoIssue = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var invoiceAutoIssue = $author$project$Utils$Overridable$value(fields.RB);
        var invoiceAutoIssueDay = $author$project$Utils$Overridable$value(fields.RC);
        var invoiceAutoIssueMonth = $author$project$Utils$Overridable$value(fields.FY);
        var overrideText = $author$project$Utils$Overridable$isOverriden(fields.RB) ? 'Remove override' : 'Override';
        return _Utils_ap(function() {
            if ($author$project$Utils$Overridable$isOverriden(fields.RB)) return _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$offset(1),
                        $author$project$Ui$Grid$spanMd(5)
                    ]), _List_fromArray([
                        invoiceAutoIssue ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoIssueMonth))),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueMonth)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, form))
                        ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(3)
                    ]), _List_fromArray([
                        invoiceAutoIssue ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(invoiceAutoIssueDay))),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssueDay)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, form))
                        ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(3)
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(invoiceAutoIssue),
                            $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                                return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoIssue(A2($author$project$Utils$Overridable$override, bool, fields.RB)));
                            })
                        ]))
                    ]))
                ])),
                A2($author$project$Utils$Form$hasValidationErrors, 5, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 5, form))) : $author$project$Utils$Html$empty
            ]);
            else {
                var settingsText = invoiceAutoIssue ? $author$project$Formatters$String$humanize($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoIssueMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoIssueDay)) : $author$project$Formatters$Bool$toOnOff(invoiceAutoIssue);
                return _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(settingsText)
                        ]))
                    ]))
                ]);
            }
        }(), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: overrideText
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle, 1, $author$project$Utils$Overridable$isOverriden(fields.RB))))
                ]), _List_fromArray([
                    $elm$html$Html$text(overrideText)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoPay = 2;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPay = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayDay = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayMonth = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoPay = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var invoiceAutoPay = $author$project$Utils$Overridable$value(fields.RD);
        var invoiceAutoPayDay = $author$project$Utils$Overridable$value(fields.FZ);
        var invoiceAutoPayMonth = $author$project$Utils$Overridable$value(fields.F_);
        var overrideText = $author$project$Utils$Overridable$isOverriden(fields.RD) ? 'Remove override' : 'Override';
        return _Utils_ap(function() {
            if ($author$project$Utils$Overridable$isOverriden(fields.RD)) {
                var hasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 3, form) || A2($author$project$Utils$Form$hasValidationErrors, 4, form);
                return _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$offsetMd(1),
                            $author$project$Ui$Grid$spanMd(5)
                        ]), _List_fromArray([
                            invoiceAutoPay ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoPayMonth))),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayMonth)),
                                $author$project$Ui$Form$Select$invalid(hasValidationErrors)
                            ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(3)
                        ]), _List_fromArray([
                            invoiceAutoPay ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(invoiceAutoPayDay))),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPayDay)),
                                $author$project$Ui$Form$Select$invalid(hasValidationErrors)
                            ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(3)
                        ]), _List_fromArray([
                            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                $author$project$Ui$ToggleSwitch$on(invoiceAutoPay),
                                $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                                    return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoPay(A2($author$project$Utils$Overridable$override, bool, fields.RD)));
                                })
                            ]))
                        ]))
                    ])),
                    hasValidationErrors ? A2($elm$html$Html$div, _List_Nil, _Utils_ap(A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 3, form)), A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 4, form)))) : $author$project$Utils$Html$empty
                ]);
            } else {
                var settingsText = invoiceAutoPay ? $author$project$Formatters$String$humanize($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoPayMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoPayDay)) : $author$project$Formatters$Bool$toOnOff(invoiceAutoPay);
                return _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(settingsText)
                        ]))
                    ]))
                ]);
            }
        }(), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: overrideText
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle, 2, $author$project$Utils$Overridable$isOverriden(fields.RD))))
                ]), _List_fromArray([
                    $elm$html$Html$text(overrideText)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AutoSend = 0;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSend = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendDay = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendMonth = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoSend = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var invoiceAutoSend = $author$project$Utils$Overridable$value(fields.RE);
        var invoiceAutoSendDay = $author$project$Utils$Overridable$value(fields.RF);
        var invoiceAutoSendMonth = $author$project$Utils$Overridable$value(fields.F$);
        var overrideText = $author$project$Utils$Overridable$isOverriden(fields.RE) ? 'Remove override' : 'Override';
        return _Utils_ap(function() {
            if ($author$project$Utils$Overridable$isOverriden(fields.RE)) return _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$offset(1),
                        $author$project$Ui$Grid$spanMd(5)
                    ]), _List_fromArray([
                        invoiceAutoSend ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoSendMonth))),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendMonth)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                        ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(3)
                    ]), _List_fromArray([
                        invoiceAutoSend ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(invoiceAutoSendDay))),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSendDay)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                        ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(3)
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(invoiceAutoSend),
                            $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                                return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceAutoSend(A2($author$project$Utils$Overridable$override, bool, fields.RE)));
                            })
                        ]))
                    ]))
                ])),
                A2($author$project$Utils$Form$hasValidationErrors, 1, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 1, form))) : $author$project$Utils$Html$empty
            ]);
            else {
                var settingsText = invoiceAutoSend ? $author$project$Formatters$String$humanize($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceAutoSendMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceAutoSendDay)) : $author$project$Formatters$Bool$toOnOff(invoiceAutoSend);
                return _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(settingsText)
                        ]))
                    ]))
                ]);
            }
        }(), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: overrideText
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle, 0, $author$project$Utils$Overridable$isOverriden(fields.RE))))
                ]), _List_fromArray([
                    $elm$html$Html$text(overrideText)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$DueDate = 3;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueDay = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueMonth = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceDueDay = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var invoiceDueDay = $author$project$Utils$Overridable$value(fields.RH);
        var invoiceDueMonth = $author$project$Utils$Overridable$value(fields.F0);
        var overrideText = $author$project$Utils$Overridable$isOverriden(fields.RH) ? 'Remove override' : 'Override';
        return _Utils_ap(function() {
            if ($author$project$Utils$Overridable$isOverriden(fields.RH)) return _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$offsetMd(4),
                        $author$project$Ui$Grid$spanMd(5)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceDueMonth))),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueMonth)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 6, form))
                        ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$monthOptions)
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(3)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(invoiceDueDay))),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceDueDay)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 6, form))
                        ]), $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$invoiceDayOptions)
                    ]))
                ])),
                A2($author$project$Utils$Form$hasValidationErrors, 6, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 6, form))) : $author$project$Utils$Html$empty
            ]);
            else {
                var settingsText = $author$project$Formatters$String$humanize($author$project$Api$Provider$CompanyInvoiceSetting$MonthOption$toString(invoiceDueMonth)) + (', on the ' + $author$project$Formatters$Int$ordinal(invoiceDueDay));
                return _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(settingsText)
                        ]))
                    ]))
                ]);
            }
        }(), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: overrideText
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle, 3, $author$project$Utils$Overridable$isOverriden(fields.RH))))
                ]), _List_fromArray([
                    $elm$html$Html$text(overrideText)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$GracePeriod = 4;
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceGracePeriodDays = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceGracePeriodDays = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var invoiceGracePeriodDays = $author$project$Utils$Overridable$value(fields.F1);
        var overrideText = $author$project$Utils$Overridable$isOverriden(fields.F1) ? 'Remove override' : 'Override';
        return _Utils_ap($author$project$Utils$Overridable$isOverriden(fields.F1) ? _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offset(6),
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPreAddon, '# of days', _List_fromArray([
                        $author$project$Ui$Form$Input$value($elm$core$String$fromInt(invoiceGracePeriodDays)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceGracePeriodDays))
                    ])))
                ]))
            ]))
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'day', invoiceGracePeriodDays))
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: overrideText
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$OverrideToggle, 4, $author$project$Utils$Overridable$isOverriden(fields.F1))))
                ]), _List_fromArray([
                    $elm$html$Html$text(overrideText)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceUpcomingAutoSend = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        var invoiceUpcomingAutoSend = $author$project$Utils$Overridable$value(fields.F2);
        var overrideText = $author$project$Utils$Overridable$isOverriden(fields.F2) ? 'Remove override' : 'Override';
        return _Utils_ap($author$project$Utils$Overridable$isOverriden(fields.F2) ? _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight,
                $author$project$Ui$Element$flexCol
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(invoiceUpcomingAutoSend),
                    $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                        return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend(A2($author$project$Utils$Overridable$override, bool, fields.F2)));
                    })
                ]))
            ])),
            A2($author$project$Utils$Form$hasValidationErrors, 0, form) ? A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewErrorRow, A2($author$project$Utils$Form$validationErrors, 0, form))) : $author$project$Utils$Html$empty
        ]) : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toOnOff(invoiceUpcomingAutoSend))
                ]))
            ]))
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: overrideText
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$FormChanged($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$InvoiceUpcomingAutoSend($author$project$Utils$Overridable$switch(fields.F2))))
            ]), _List_fromArray([
                $elm$html$Html$text(overrideText)
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource = F3(function(acceptsSource, acceptsSourceField, label) {
        var acceptsSourceBool = $author$project$Utils$Overridable$value(acceptsSource);
        var acceptsFieldType = function() {
            switch(acceptsSourceField.$){
                case 0:
                    return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch;
                case 1:
                    return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards;
                default:
                    return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex;
            }
        }();
        var overrideBtn = A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$justifyRight
        ]), _List_fromArray([
            function() {
                var buttonLabel = $author$project$Utils$Overridable$isOverriden(acceptsSource) ? 'Remove override' : 'Override';
                return A3($author$project$Ui$Button$view, {
                    abP: label
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated(acceptsFieldType($author$project$Utils$Overridable$switch(acceptsSource))))
                ]), _List_fromArray([
                    $elm$html$Html$text(buttonLabel)
                ]));
            }()
        ]));
        return $author$project$Utils$Overridable$isOverriden(acceptsSource) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(label)
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(acceptsSourceBool),
                        $author$project$Ui$ToggleSwitch$onChange(function(bool) {
                            return $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$PaymentFormFieldUpdated(acceptsFieldType(A2($author$project$Utils$Overridable$override, bool, acceptsSource)));
                        })
                    ]))
                ])),
                overrideBtn
            ]))
        ])) : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(label)
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Bool$toOnOff(acceptsSourceBool))
                ])),
                overrideBtn
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalClicked = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$Shared$hasBankTransfersCapability = function(_v0) {
        var record = _v0;
        return record.Qk;
    };
    var $author$project$Api$Provider$Practice$One$hasBankTransfersCapability = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$hasBankTransfersCapability(shared);
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewVirtualBankAccountsActions = F2(function(model, label) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($elm$html$Html$h5, _List_fromArray([
                    $elm$html$Html$Attributes$class('m-0')
                ]), _List_fromArray([
                    $elm$html$Html$text(label)
                ]))
            ])),
            function() {
                var _v0 = model.DZ;
                if (!_v0.$) {
                    var companyId = $author$project$Api$Provider$Company$One$id(model.acy);
                    var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources({
                        fl: companyId
                    });
                    return A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6),
                        $author$project$Ui$Grid$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Formatters$Bool$toOnOff(true))
                        ])),
                        A3($author$project$Ui$Link$route, route, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('View Transfer Details')
                        ]))
                    ]));
                } else return A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        function() {
                            var acceptsSourceBankTransfers = $author$project$Api$Provider$Practice$One$hasBankTransfersCapability(model.W1);
                            var verb = acceptsSourceBankTransfers ? 'Enable' : 'Authorize';
                            return A3($author$project$Ui$Button$view, {
                                abP: verb + ' transfer details'
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalClicked(acceptsSourceBankTransfers))
                            ]), _List_fromArray([
                                $elm$html$Html$text(verb)
                            ]));
                        }()
                    ]))
                ]));
            }()
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentOptions = F3(function(model, fields, sponsorized) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Payment Options')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Choose payment options available to  ' + (sponsorized + 's.'))
                    ]))
                ]))
            ])),
            A2($author$project$Api$Provider$Practice$One$featureEnabled, 11, model.W1) ? A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewVirtualBankAccountsActions, model, 'Accept Bank Transfers') : $author$project$Utils$Html$empty,
            A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource, fields.Ie, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAch(fields.Ie), 'Accept Bank Accounts'),
            A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource, fields.Ig, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsCards(fields.Ig), 'Accept Credit Cards'),
            A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewAcceptsSource, fields.If, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$AcceptsAmex(fields.If), 'Accept American Express')
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentSettingsForm = F2(function(model, form) {
        var sponsorized = A2($author$project$Formatters$String$sponsorize, model.W1, 'employer');
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A3($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentOptions, model, fields, sponsorized)
        ]);
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createTimelineEventAttributes = F2(function(fields, today) {
        var createTimelineDate = $author$project$Components$InvoiceSetting$Timeline$createTimelineDate(today);
        var dueDate = A2(createTimelineDate, $author$project$Utils$Overridable$value(fields.F0), $author$project$Utils$Overridable$value(fields.RH));
        var unpaidDate = A3($justinmimbs$date$Date$add, 3, $author$project$Utils$Overridable$value(fields.F1), A2(createTimelineDate, $author$project$Utils$Overridable$value(fields.F0), $author$project$Utils$Overridable$value(fields.RH)));
        var upcomingDate = A3($justinmimbs$date$Date$add, 2, -1, A2(createTimelineDate, $author$project$Utils$Overridable$value(fields.F$), $author$project$Utils$Overridable$value(fields.RF)));
        var autopayDate = A2(createTimelineDate, $author$project$Utils$Overridable$value(fields.F_), $author$project$Utils$Overridable$value(fields.FZ));
        var autoSendDate = A2(createTimelineDate, $author$project$Utils$Overridable$value(fields.F$), $author$project$Utils$Overridable$value(fields.RF));
        var autoIssueDate = A2(createTimelineDate, $author$project$Utils$Overridable$value(fields.FY), $author$project$Utils$Overridable$value(fields.RC));
        return _List_fromArray([
            _Utils_Tuple3($author$project$Utils$Overridable$value(fields.F2) && $author$project$Utils$Overridable$value(fields.RE), upcomingDate, 'Send \"Upcoming\" email'),
            _Utils_Tuple3($author$project$Utils$Overridable$value(fields.RE), autoSendDate, 'Send \"Created\" email'),
            _Utils_Tuple3($author$project$Utils$Overridable$value(fields.RB), autoIssueDate, 'Issue Invoice'),
            _Utils_Tuple3($author$project$Utils$Overridable$value(fields.RD), autopayDate, 'Autopay Invoice'),
            _Utils_Tuple3(true, dueDate, 'Due Date'),
            _Utils_Tuple3(true, unpaidDate, 'Employees show as unpaid')
        ]);
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewTimeline = F2(function(currentDate, form) {
        if (!form.$) {
            var settingsForm = form.a;
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Timeline$view, 0, $author$project$Components$InvoiceSetting$Timeline$createTimelineEvents(A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$createTimelineEventAttributes, $author$project$Utils$Form$fields(settingsForm), currentDate)))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__InvoiceSettings, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Update global sponsor invoice settings')
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$view = function(model) {
        var sponsorizedPl = A2($author$project$Formatters$String$sponsorize, model.W1, 'employers');
        var sponsorized = A2($author$project$Formatters$String$sponsorize, model.W1, 'employer');
        var hideSponsorInvoicesSection = function() {
            var _v7 = model.PU;
            if (!_v7.$) {
                var form = _v7.a;
                return model.F3 && !$author$project$Utils$Overridable$value($author$project$Utils$Form$fields(form).Eu) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewHideSponsorInvoices, model.F3, form)
                ])) : $author$project$Utils$Html$empty;
            } else return $author$project$Utils$Html$empty;
        }();
        var enableBillingSection = function() {
            var _v6 = model.PU;
            if (!_v6.$) {
                var form = _v6.a;
                return A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.W1) ? !model.F3 && $author$project$Utils$Overridable$value($author$project$Utils$Form$fields(form).Eu) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate, form, A3($justinmimbs$date$Date$add, 1, 1, model.cP))
                ])) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBilling, model.F3, form),
                    A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewEnableBillingStartDate, form, A3($justinmimbs$date$Date$add, 1, 1, model.cP))
                ])) : $author$project$Utils$Html$empty;
            } else return $author$project$Utils$Html$empty;
        }();
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.eU;
                    if (!_v0.$) {
                        var virtualBankAccountEnableModal = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountEnableModalMsg, $author$project$Components$Company$VirtualBankAccounts$EnableModal$modal(virtualBankAccountEnableModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v1 = model.dp;
                    if (!_v1.$) {
                        var virtualBankAccountAuthorizeModal = _v1.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$VirtualBankAccountAuthorizeModalMsg, $author$project$Components$Company$VirtualBankAccounts$AuthorizeModal$modal(virtualBankAccountAuthorizeModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Example of Upcoming Month')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewTimeline, model.cP, model.PU),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            enableBillingSection,
                            hideSponsorInvoicesSection,
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Notification: Invoice Upcoming')
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Sent to '),
                                        $elm$html$Html$text(sponsorizedPl),
                                        $elm$html$Html$text(' to let them know when to expect an invoice. '),
                                        $elm$html$Html$text("This notification is sent 1 week prior to the \u201CInvoice Created\u201D notification")
                                    ])),
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Notifications__Company, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('View and customize the notification')
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6),
                                    $author$project$Ui$Grid$justifyRight
                                ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceUpcomingAutoSend, model.PU))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Notification: Invoice Created')
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Sent to '),
                                        $elm$html$Html$text(sponsorizedPl),
                                        $elm$html$Html$text(' on the specified day. Invoices can be sent regardless'),
                                        $elm$html$Html$text(' of whether they are still in draft or have been issued.')
                                    ])),
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Notifications__Company, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('View and customize the notification')
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoSend, model.PU))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Scheduled Issue Date')
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Invoices will be automatically issued on the specified date, locking charges in place and preventing ' + ($author$project$Formatters$String$pluralOf(sponsorized) + (' from making any changes. Once issued, ' + (sponsorized + ' can pay invoices manually, or invoices will be automatically processed based on the Scheduled Autopay Date settings.'))))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoIssue, model.PU))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Scheduled Autopay Date')
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Payment for the full amount of all issued invoices will be automatically attempted on the specified date. ' + ('Payments will not be processed for non-issued invoices. This date is visible to the  ' + (sponsorized + '.')))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceAutoPay, model.PU))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Due Date')
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text("The day when the invoice is considered \u201Ddue\u201D. This date is visible to the " + (sponsorized + ' and printed on the invoice.'))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceDueDay, model.PU))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Grace Period')
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text("If the invoice is not yet paid after the grace period passes, each employee's membership status will be set to \u201Cunpaid\u201D and the invoice will be considered \u201Coverdue\u201D. The grace period starts after the due date.")
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewInvoiceGracePeriodDays, model.PU))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Include Full Charge Details')
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Allow the ' + (sponsorized + ' to see full charge details and patient names when viewing or downloading the invoice. Since these details may contain protected health information, this setting is off by default.'))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6),
                                    $author$project$Ui$Grid$justifyRight
                                ]), _List_fromArray([
                                    function() {
                                        var _v2 = $author$project$Api$Data$toMaybe(model.cr);
                                        if (!_v2.$) {
                                            var companyInvoiceSetting = _v2.a;
                                            var _v3 = $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedAt(companyInvoiceSetting);
                                            if (!_v3.$) {
                                                var chargePhiDetailsUpdatedAt = _v3.a;
                                                return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                                        $author$project$Ui$Grid$spanMd(12)
                                                    ]), _List_fromArray([
                                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                                            $author$project$Ui$Typography$muted,
                                                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                                                        ]), _List_fromArray([
                                                            $elm$html$Html$text('Updated by '),
                                                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$User$Min$name, $author$project$Api$Provider$CompanyInvoiceSetting$ForCompany$chargePhiDetailsUpdatedBy(companyInvoiceSetting)))),
                                                            $elm$html$Html$text(' on '),
                                                            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargePhiDetailsUpdatedAt))
                                                        ]))
                                                    ]))
                                                ]));
                                            } else return $author$project$Utils$Html$empty;
                                        } else return $author$project$Utils$Html$empty;
                                    }(),
                                    A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$justifyRight,
                                        $author$project$Ui$Element$flexCol
                                    ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargePhiDetailsEnabled, model.PU))
                                ]))
                            ])),
                            A3($author$project$Utils$FeatureGate$gate, 3, $author$project$Api$Practice$Provider(model.W1), A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                $author$project$Ui$HorizontalRule$view(_List_Nil),
                                $author$project$Ui$Typography$headingSm(_List_fromArray([
                                    $elm$html$Html$text('Add Service Charges to Membership Invoices')
                                ])),
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanMd(6)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('When point-of-care service charges are paid for by the employer, '),
                                            $elm$html$Html$text('automatically add these charges to the employer\'s next draft membership invoice. If this setting is disabled, '),
                                            $elm$html$Html$text('service charges will be added to a separate service invoice.')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanMd(6)
                                    ]), A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$justFormAndSuccessfulSetting, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewChargeRouteToRecurringInvoice, model.PU))
                                ])),
                                A2($elm$html$Html$div, _List_Nil, function() {
                                    var _v4 = model.aM;
                                    if (!_v4.$) {
                                        var form = _v4.a;
                                        return A2($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$viewPaymentSettingsForm, model, form);
                                    } else return _List_fromArray([
                                        $author$project$Utils$Html$empty
                                    ]);
                                }())
                            ])))
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter,
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            function() {
                                if ($author$project$Utils$Maybe$toBool(model.PU)) {
                                    var nonSubmittable = function() {
                                        var _v5 = model.PU;
                                        if (!_v5.$) {
                                            var form = _v5.a;
                                            return $author$project$Utils$Form$hasAnyValidationError(form);
                                        } else return true;
                                    }();
                                    return A3($author$project$Ui$Button$view, {
                                        abP: 'Update company invoice settings'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$primary,
                                        $author$project$Ui$Button$loading(_Utils_eq(model.cr, $author$project$Api$Data$Loading)),
                                        $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$InvoiceSettings$CompanyInvoiceSettingsSubmitted),
                                        $author$project$Ui$Button$disabled(nonSubmittable)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Update')
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]))
                    ]))
                ]))
            ]),
            $2: A2($author$project$Formatters$String$sponsorize, model.W1, 'Companies') + ' | Invoice Settings'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$page = $author$project$Spa$Page$applicationCompany({
        aeq: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$update,
        aid: $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$view
    });
    var $author$project$Components$Invoice$Company = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$EmployerOrProviderCompany = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$InvoiceComponentMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var _v1 = $author$project$Components$Invoice$init({
            Ej: shared.Ej,
            k3: false,
            acy: $elm$core$Maybe$Just($author$project$Components$Invoice$EmployerOrProviderCompany(company)),
            RL: A2($author$project$Components$Invoice$Company, params.fl, params.aef),
            Gc: $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top({
                fl: params.fl
            }),
            r2: $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources({
                fl: params.fl
            })),
            W1: practice,
            Z$: session,
            Cu: shared
        });
        var invoiceComponent = _v1.a;
        var invoiceComponentCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            RA: invoiceComponent,
            W1: practice
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, invoiceComponentCmd));
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Invoice$subscriptions(model.RA));
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Invoice$update, model.Ej, subMsg, model.RA);
        var invoiceComponent = _v1.a;
        var cmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            RA: invoiceComponent
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), outMsgs);
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Invoice$view, model.Ej, model.RA)),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Invoices'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$view
    });
    var $author$project$Api$Provider$Report$Invoice = 3;
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$GotInvoices = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                ahs: model.ahs
            });
        };
    };
    var $author$project$Api$Invoice$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Invoice$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Invoice$All$Invoice = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Invoice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Invoice$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Invoice$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Employer$Invoice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Employer$Invoice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Employer$Invoice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$Invoice$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Employer$Invoice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$Invoice$invoicesPath)));
    });
    var $author$project$Api$Invoice$list = F5(function(apiClient, session, companyId, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Invoice$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Invoice$All$Employer)))) : A4($author$project$Api$Provider$Company$Invoice$list, apiClient, companyId, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Invoice$All$Provider))));
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices = function(model) {
        return A5($author$project$Api$Invoice$list, model.Ej, model.Z$, model.aef, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams(model), $author$project$Pages$Companies$CompanyId_String$Invoices$Top$GotInvoices);
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var query = _v0.Bz;
        var model = {
            Ej: shared.Ej,
            acy: company,
            md: $author$project$Components$ExportCsv$init({
                adW: shared.afW,
                Hg: 3
            }),
            adV: $elm$core$Maybe$Nothing,
            aef: params.fl,
            q5: $author$project$Api$Data$Loading,
            nd: $author$project$Api$Data$NotAsked,
            afW: shared.afW,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'invoice_date', 1, $author$project$Api$Sort$initFromQuery(query))
        };
        return _Utils_Tuple2(model, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(model));
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            afW: shared.afW
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md));
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$InvoiceCreated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$Invoice$create = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Invoice$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$Invoice$invoicesPath(companyId)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top({
                fl: model.aef
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), $author$project$Api$Sort$toQuery(model.ahs))));
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    var intFromHeader = F2(function(key, headers_) {
                        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, key, headers_)));
                    });
                    var totalAmount = A2(intFromHeader, 'x-total-amount', headers);
                    var totalDueAmount = A2(intFromHeader, 'x-total-due-amount', headers);
                    return _Utils_Tuple3(_Utils_update(model, {
                        adV: $elm$core$Maybe$Just(_Utils_Tuple2(totalAmount, totalDueAmount)),
                        q5: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    q5: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
                    $author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    q5: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
                    $author$project$Pages$Companies$CompanyId_String$Invoices$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    nd: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Company$Invoice$create, model.Ej, model.aef, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$InvoiceCreated), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoice = response.a;
                    var newModel = _Utils_update(model, {
                        q5: $author$project$Api$Data$Loading,
                        nd: response
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchInvoices(newModel),
                        A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                            fl: model.aef,
                            aef: $author$project$Api$Provider$Invoice$One$id(invoice)
                        }))
                    ])), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'New invoice created!')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    nd: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v3 = A3($author$project$Components$ExportCsv$update, model.Ej, subMsg, model.md);
                var exportCsv = _v3.a;
                var subCmd = _v3.b;
                var subOutMsg = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Invoice$invoicesPath = F2(function(session, id_) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Invoice$invoicesPath : $author$project$Api$Provider$Company$Invoice$invoicesPath(id_);
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$CreateInvoice = {
        $: 3
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$newInvoiceButton = F2(function(practiceOrganization, newInvoice) {
        if (!practiceOrganization.$) return A2($author$project$Utils$FeatureGate$gateAvailable, 3, practiceOrganization) ? A3($author$project$Ui$Button$view, {
            abP: 'Create new invoice'
        }, _List_fromArray([
            $author$project$Ui$Button$styled(0),
            $author$project$Ui$Button$loading(_Utils_eq(newInvoice, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Invoices$Top$CreateInvoice),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
        ]), _List_fromArray([
            $elm$html$Html$text('New Invoice')
        ])) : $author$project$Utils$Html$empty;
        else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$SortTable = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'invoice_date', true, 'Date'),
        A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
        A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
        A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Total'),
        A3($author$project$Api$Column$init, 'description', false, 'Description')
    ]);
    var $author$project$Api$Employer$Invoice$All$amountInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Invoice$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$Invoice$All$amountInCents = function(_v0) {
        var record = _v0.b;
        return record.Jh;
    };
    var $author$project$Api$Invoice$All$amountInCents = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$All$amountInCents(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$All$amountInCents(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Employer$Invoice$All$description = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Invoice$Shared$description(shared);
    };
    var $author$project$Api$Provider$Invoice$All$description = function(_v0) {
        var record = _v0.b;
        return record.NQ;
    };
    var $author$project$Api$Invoice$All$description = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$All$description(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$All$description(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$All$dueInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Invoice$Shared$dueInCents(shared);
    };
    var $author$project$Api$Provider$Invoice$All$dueInCents = function(_v0) {
        var record = _v0.b;
        return record.Ol;
    };
    var $author$project$Api$Invoice$All$dueInCents = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$All$dueInCents(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$All$dueInCents(invoice_);
        }
    };
    var $author$project$Ui$Typography$Ellipsis = {
        $: 16
    };
    var $author$project$Ui$Typography$ellipsis = $author$project$Ui$Typography$Ellipsis;
    var $author$project$Api$Employer$Invoice$All$humanStatus = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Invoice$Shared$humanStatus(shared);
    };
    var $author$project$Api$Invoice$All$humanStatus = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$All$humanStatus(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$All$humanStatus(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Invoice$Shared$id(shared);
    };
    var $author$project$Api$Invoice$All$id = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$All$id(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$All$id(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$All$invoiceDate = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Invoice$Shared$invoiceDate(shared);
    };
    var $author$project$Api$Invoice$All$invoiceDate = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$All$invoiceDate(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$All$invoiceDate(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$All$invoiceNumber = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Invoice$Shared$invoiceNumber(shared);
    };
    var $author$project$Api$Invoice$All$invoiceNumber = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$All$invoiceNumber(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$All$invoiceNumber(invoice_);
        }
    };
    var $author$project$Api$Employer$Invoice$All$paidInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Invoice$Shared$paidInCents(shared);
    };
    var $author$project$Api$Provider$Invoice$All$paidInCents = function(_v0) {
        var record = _v0.b;
        return record.VR;
    };
    var $author$project$Api$Invoice$All$paidInCents = function(invoice) {
        if (!invoice.$) {
            var invoice_ = invoice.a;
            return $author$project$Api$Provider$Invoice$All$paidInCents(invoice_);
        } else {
            var invoice_ = invoice.a;
            return $author$project$Api$Employer$Invoice$All$paidInCents(invoice_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewRow = F2(function(companyId, invoice) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                    fl: companyId,
                    aef: $author$project$Api$Invoice$All$id(invoice)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Invoice$All$invoiceDate(invoice)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                    fl: companyId,
                    aef: $author$project$Api$Invoice$All$id(invoice)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Invoice$All$invoiceNumber(invoice)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Api$Invoice$Status$toBadge($author$project$Api$Invoice$All$humanStatus(invoice))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Invoice$All$amountInCents(invoice))),
                $author$project$Utils$Html$noBreakSpace,
                $author$project$Api$Invoice$All$dueInCents(invoice) > 0 && $author$project$Api$Invoice$All$paidInCents(invoice) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('('),
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Invoice$All$dueInCents(invoice))),
                    $elm$html$Html$text(' due)')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$ellipsis
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Invoice$All$description(invoice))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.q5;
            if (_v1.$ === 3) {
                var invoices_ = _v1.a;
                return _Utils_Tuple2(false, invoices_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var invoices = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any charges for '),
                $elm$html$Html$text($author$project$Api$Company$name(model.acy)),
                $elm$html$Html$text(' yet. An invoice will be created on the 1st of the month for any '),
                $elm$html$Html$text(A2($author$project$Api$Practice$sponsorize, model.W1, 'employees')),
                $elm$html$Html$text(' who have signed up.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$SortTable)), $author$project$Pages$Companies$CompanyId_String$Invoices$Top$columns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                ]))
            ])
        ])), A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewRow(model.aef), invoices), _List_Nil);
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$view = function(model) {
        return {
            fb: function() {
                var loading = function() {
                    var _v0 = model.q5;
                    if (_v0.$ === 3) return false;
                    else return true;
                }();
                return _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween,
                                $author$project$Ui$Element$itemsCenter
                            ]), _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('Invoices')
                                ])),
                                A2($author$project$Pages$Companies$CompanyId_String$Invoices$Top$newInvoiceButton, model.W1, model.nd)
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            $author$project$Pages$Companies$CompanyId_String$Invoices$Top$viewTable(model)
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                                $author$project$Ui$Pagination$List$loading(loading)
                            ]), model.af_))
                        ]))
                    ])),
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, model.Ej, _List_fromArray([
                        $author$project$Components$ExportCsv$path(A2($author$project$Api$Invoice$invoicesPath, model.Z$, model.aef)),
                        $author$project$Components$ExportCsv$params($author$project$Api$Provider$Invoice$listOptionsToParams($author$project$Pages$Companies$CompanyId_String$Invoices$Top$fetchParams(model)))
                    ]), model.md))
                ]);
            }(),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Invoices'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Invoices$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Invoices$Top$view
    });
    var $author$project$Api$Provider$Note$Company = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Notes$NotesMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Companies$CompanyId_String$Notes$init = F5(function(session, practice, _v0, shared, _v1) {
        var query = _v1.Bz;
        var params = _v1.VU;
        var _v2 = A6($author$project$Components$Notes$init, shared.Ej, shared.HO, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes({
            fl: params.fl
        }), query, $author$project$Api$Provider$Note$Company(params.fl), $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
        var notes = _v2.a;
        var notesCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: notes,
            W1: practice
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
    });
    var $author$project$Pages$Companies$CompanyId_String$Notes$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Notes$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Notes$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Notes$subscriptions(model.rk));
    };
    var $author$project$Pages$Companies$CompanyId_String$Notes$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Notes$update, model.Ej, subMsg, model.rk);
        var notes = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: notes
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Companies$CompanyId_String$Notes$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Notes$view(model.rk)),
            $2: A2($author$project$Formatters$String$sponsorize, model.W1, 'Companies') + ' | Notes'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Notes$page = $author$project$Spa$Page$applicationCompany({
        aeq: $author$project$Pages$Companies$CompanyId_String$Notes$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Notes$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Notes$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Notes$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Notes$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Notes$view
    });
    var $author$project$Pages$Companies$CompanyId_String$Notifications$AdminTableMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Notification$CompanyContext = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Notifications$init = F5(function(session, practice, _v0, shared, _v1) {
        var params = _v1.VU;
        var multilanguageEnabled = A2($author$project$Api$Practice$featureEnabled, 10, $author$project$Api$Practice$Provider(practice));
        var _v2 = A2($elm$core$Tuple$mapFirst, $author$project$Components$Admin$NotificationSetting$AdminTable$withMultiLanguageFeature(multilanguageEnabled), A4($author$project$Components$Admin$NotificationSetting$AdminTable$init, shared.Ej, session, $author$project$Api$Provider$Notification$CompanyContext(params.fl), 0));
        var adminTable = _v2.a;
        var adminTableCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: adminTable,
            W1: practice
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, adminTableCmd));
    });
    var $author$project$Pages$Companies$CompanyId_String$Notifications$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Notifications$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Notifications$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$NotificationSetting$AdminTable$subscriptions(model.rk));
    };
    var $author$project$Pages$Companies$CompanyId_String$Notifications$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$NotificationSetting$AdminTable$update, model.Ej, subMsg, model.rk);
        var adminTable = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: adminTable
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Companies$CompanyId_String$Notifications$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Employee Notifications')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('These are emails that will be sent to any patients who are being sponsored by their employers. '),
                        $elm$html$Html$text('They will also receive any patient emails that don\'t relate to payment of their memberships.')
                    ])), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Admin$NotificationSetting$AdminTable$view(model.rk))))
                ]))
            ]),
            $2: A2($author$project$Formatters$String$sponsorize, model.W1, 'Companies') + ' | Notifications'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Notifications$page = $author$project$Spa$Page$applicationCompany({
        aeq: $author$project$Pages$Companies$CompanyId_String$Notifications$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Notifications$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Notifications$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Notifications$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Notifications$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Notifications$view
    });
    var $author$project$Components$PaymentSources$Company = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$PaymentSources$PaymentSourcesMsg = $elm$core$Basics$identity;
    var $author$project$Components$PaymentSources$DropdownMenuMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$Model = $elm$core$Basics$identity;
    var $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$One$createdAt = function(_v0) {
        var record = _v0.b;
        return record.Mx;
    };
    var $author$project$Components$MovePaymentMethodsModal$Closed = {
        $: 0
    };
    var $author$project$Components$MovePaymentMethodsModal$init = $author$project$Components$MovePaymentMethodsModal$Closed;
    var $author$project$Components$VirtualBankAccounts$Model = $elm$core$Basics$identity;
    var $author$project$Components$VirtualBankAccounts$GotVirtualBankAccounts = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$VirtualBankAccounts$loadData = F2(function(apiClient, companyId) {
        return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$VirtualBankAccount$list, apiClient, companyId, $author$project$Components$VirtualBankAccounts$GotVirtualBankAccounts));
    });
    var $author$project$Components$VirtualBankAccounts$init = F3(function(companyId, practice, _v0) {
        var timeFormatter = _v0.HO;
        var apiClient = _v0.Ej;
        var _v1 = A2($author$project$Components$VirtualBankAccounts$loadData, apiClient, companyId);
        var virtualBankAccounts = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple2({
            J7: false,
            W1: practice,
            HO: timeFormatter,
            DZ: virtualBankAccounts
        }, cmd);
    });
    var $author$project$Components$PaymentSources$GotBankAccounts = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$GotCards = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$GotPaymentSourcesMigratable = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$PaymentMethod$canMigrateDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'can_migrate'
    ]), $elm$json$Json$Decode$bool);
    var $author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'payment_methods'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId));
    };
    var $author$project$Api$Provider$Patient$PaymentMethod$canMigratePath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'can_migrate'
        ]), $author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId));
    };
    var $author$project$Api$Provider$Patient$PaymentMethod$canMigrate = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Patient$PaymentMethod$canMigrateDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$PaymentMethod$canMigratePath(patientId)));
    });
    var $author$project$Components$PaymentSources$loadData = F4(function(basePath, apiClient, session, resource) {
        return _Utils_Tuple3($author$project$Api$Data$Loading, $author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A4($author$project$Api$Card$list, basePath, apiClient, session, $author$project$Components$PaymentSources$GotCards),
            A4($author$project$Api$BankAccount$list, basePath, apiClient, session, $author$project$Components$PaymentSources$GotBankAccounts),
            function() {
                if (resource.$ === 1) {
                    var patient = resource.a;
                    return A3($author$project$Api$Provider$Patient$PaymentMethod$canMigrate, apiClient, $author$project$Api$Provider$Patient$One$id(patient), $author$project$Components$PaymentSources$GotPaymentSourcesMigratable);
                } else return $elm$core$Platform$Cmd$none;
            }()
        ])));
    });
    var $author$project$Components$PaymentSources$init = F4(function(resource, session, practice, shared) {
        var patientId = function() {
            if (resource.$ === 1) {
                var patient = resource.a;
                return $author$project$Api$Provider$Patient$One$id(patient);
            } else return '';
        }();
        var patientCreatedAt = function() {
            if (resource.$ === 1) {
                var patient = resource.a;
                return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$createdAt(patient));
            } else return $elm$core$Maybe$Nothing;
        }();
        var basePath = function() {
            if (!resource.$) {
                var company = resource.a;
                if (!company.$) {
                    var company_ = company.a;
                    return $author$project$Api$Provider$Company$companyPath($author$project$Api$Provider$Company$One$id(company_));
                } else return $author$project$Api$Data$employerPath;
            } else {
                var patient = resource.a;
                return A2($author$project$Api$Data$pathAppend, _List_fromArray([
                    $author$project$Api$Provider$Patient$One$id(patient)
                ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
                    'patients'
                ]), $author$project$Api$Data$providerPath));
            }
        }();
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(resource, A2($author$project$Api$Practice$featureEnabled, 11, practice));
            if (!_v1.a.$ && _v1.b) {
                var company = _v1.a.a;
                var _v2 = A3($author$project$Components$VirtualBankAccounts$init, $author$project$Api$Company$id(company), practice, {
                    Ej: shared.Ej,
                    HO: shared.HO
                });
                var model_ = _v2.a;
                var cmd_ = _v2.b;
                return _Utils_Tuple2($elm$core$Maybe$Just(model_), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg, cmd_));
            } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        }();
        var virtualBankAccountModel = _v0.a;
        var virtualBankAccountCmd = _v0.b;
        var _v3 = A4($author$project$Components$PaymentSources$loadData, basePath, shared.Ej, session, resource);
        var cards = _v3.a;
        var bankAccounts = _v3.b;
        var cmd = _v3.c;
        return _Utils_Tuple2({
            hB: A7($author$project$Components$AuditTrailLog$init, session, shared.aaT, shared.HO, $elm$core$Maybe$Just('patient'), $elm$core$Maybe$Just(patientId), patientCreatedAt, $elm$core$Maybe$Just('payment_methods')),
            pF: bankAccounts,
            vK: basePath,
            pQ: cards,
            lG: $author$project$Components$CreatePaymentMethodModal$init,
            cP: shared.cP,
            fw: $elm$core$Maybe$Nothing,
            qW: shared.qW,
            F3: $author$project$Shared$isHintAdmin(shared),
            rs: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'payment-methods-other-actions-dropdown-menu',
                ahX: $author$project$Components$PaymentSources$DropdownMenuMsg
            })),
            gc: $author$project$Components$MovePaymentMethodsModal$init,
            A1: $author$project$Api$Data$Loading,
            W1: practice,
            sp: shared.sp,
            Hg: resource,
            Z$: session,
            Hw: $elm$core$Maybe$Nothing,
            HO: shared.HO,
            ax: $elm$core$Set$empty,
            tF: virtualBankAccountModel
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            virtualBankAccountCmd
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$PaymentSources$init = F5(function(session, practice, company, shared, _v0) {
        var _v1 = A4($author$project$Components$PaymentSources$init, $author$project$Components$PaymentSources$Company(company), session, practice, shared);
        var paymentSources = _v1.a;
        var paymentSourcesCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: paymentSources,
            W1: practice
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSourcesCmd));
    });
    var $author$project$Components$PaymentSources$setPractice = F2(function(practice, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            W1: practice
        });
    });
    var $author$project$Pages$Companies$CompanyId_String$PaymentSources$load = F2(function(shared, model) {
        var _v0 = shared.W1;
        if (_v0.$ === 3) {
            var practice = _v0.a;
            return _Utils_Tuple2(_Utils_update(model, {
                rk: A2($author$project$Components$PaymentSources$setPractice, practice, model.rk),
                W1: practice
            }), $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$PaymentSources$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$PaymentSources$AuditTrailLogMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$CloseMovePaymentMethodsModal = {
        $: 22
    };
    var $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$MovePaymentMethodsModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress;
    var $author$project$Components$PaymentSources$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg, $author$project$Components$CreatePaymentMethodModal$subscriptions(model.lG)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$PaymentSources$HiConfirmClosed), model.fw)),
            $author$project$Components$AuditTrailLog$isOpen(model.hB) ? A2($elm$core$Platform$Sub$map, $author$project$Components$PaymentSources$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$subscriptions(model.hB)) : $elm$core$Platform$Sub$none,
            $author$project$Components$MovePaymentMethodsModal$subscriptions($author$project$Components$PaymentSources$CloseMovePaymentMethodsModal)
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$PaymentSources$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$PaymentSources$subscriptions(model.rk));
    };
    var $author$project$Components$PaymentSources$Deleted = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentSources$MadeDefault = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$Patient = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$PatientUpdated = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$OutMsg$RetrievePatient = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$MovePaymentMethodsModal$close = function(_v0) {
        return $author$project$Components$MovePaymentMethodsModal$Closed;
    };
    var $author$project$Components$PaymentSources$formFieldsFromSource = function(source) {
        var cardFields = function() {
            if (!source.$) return $elm$core$Maybe$Just({
                adz: $author$project$Api$Source$expMonth(source),
                adA: $author$project$Api$Source$expYear(source),
                tK: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Source$zip(source))
            });
            else return $elm$core$Maybe$Nothing;
        }();
        return {
            EH: cardFields,
            aeI: $author$project$Api$Source$label(source)
        };
    };
    var $author$project$Components$PaymentSources$cardFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 1:
                var month = field.a;
                return _Utils_update(fields, {
                    adz: $elm$core$String$toInt(month)
                });
            case 2:
                var year = field.a;
                return _Utils_update(fields, {
                    adA: $elm$core$String$toInt(year)
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    tK: string
                });
            default:
                return fields;
        }
    });
    var $author$project$Components$PaymentSources$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                aeI: $author$project$Utils$String$toMaybe(string)
            });
        } else {
            var _v1 = fields.EH;
            if (_v1.$ === 1) return fields;
            else {
                var cardFields = _v1.a;
                return _Utils_update(fields, {
                    EH: $elm$core$Maybe$Just(A2($author$project$Components$PaymentSources$cardFormFieldsUpdate, field, cardFields))
                });
            }
        }
    });
    var $author$project$Components$PaymentSources$ExpirationDateValidation = 1;
    var $author$project$Components$PaymentSources$expDateValidator = F2(function(currentDate, fields) {
        var _v0 = fields.EH;
        if (_v0.$ === 1) return _List_Nil;
        else {
            var cardFields = _v0.a;
            var invalid = _Utils_Tuple2(1, 'Please enter a future expiration date.');
            var _v1 = _Utils_Tuple2(cardFields.adA, cardFields.adz);
            if (!_v1.a.$ && !_v1.b.$) {
                var expYear = _v1.a.a;
                var expMonth = _v1.b.a;
                var currentYear = $justinmimbs$date$Date$year(currentDate);
                var currentMonth = $justinmimbs$date$Date$monthNumber(currentDate);
                return _Utils_eq(currentYear, expYear) && _Utils_cmp(expMonth, currentMonth) < 0 ? _List_fromArray([
                    invalid
                ]) : _List_Nil;
            } else return _List_fromArray([
                invalid
            ]);
        }
    });
    var $author$project$Components$PaymentSources$ZipValidation = 0;
    var $author$project$Components$PaymentSources$zipValidator = function(fields) {
        var _v0 = fields.EH;
        if (_v0.$ === 1) return _List_Nil;
        else {
            var cardFields = _v0.a;
            var zipLenght = $elm$core$String$length(cardFields.tK);
            return zipLenght === 5 || zipLenght === 9 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a valid zip code.')
            ]);
        }
    };
    var $author$project$Components$PaymentSources$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$PaymentSources$zipValidator),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$PaymentSources$expDateValidator(currentDate))
        ]));
    };
    var $author$project$Components$MovePaymentMethodsModal$None = 1;
    var $author$project$Components$MovePaymentMethodsModal$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$MovePaymentMethodsModal$GotPaymentSources = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$PaymentMethod$Min$PaymentMethod = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PaymentMethod$Min$Record = F5(function(id, sourceBrand, lastFour, label, isDefault) {
        return {
            aef: id,
            R0: isDefault,
            aeI: label,
            ST: lastFour,
            _D: sourceBrand
        };
    });
    var $author$project$Api$Provider$PaymentMethod$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_default', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_four', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_method_brand', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PaymentMethod$Min$Record))))));
    var $author$project$Api$Provider$PaymentMethod$Min$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$PaymentMethod$Min$recordDecoder);
    var $author$project$Api$Provider$Patient$PaymentMethod$list = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$maybe($elm$json$Json$Decode$list($author$project$Api$Provider$PaymentMethod$Min$decoder)), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId)));
    });
    var $author$project$Components$MovePaymentMethodsModal$getPaymentSources = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$Patient$PaymentMethod$list, apiClient, patientId, $author$project$Components$MovePaymentMethodsModal$GotPaymentSources);
    });
    var $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Patient$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$LimitedPatientSelector$initPatientResourceFilter = F3(function(apiClient, optionals, patient) {
        return function(_v0) {
            var patientResourceFilter = _v0.a;
            var patientResourceFilterCmd = _v0.b;
            return A2($elm$core$Maybe$withDefault, _Utils_Tuple2(patientResourceFilter, patientResourceFilterCmd), A2($elm$core$Maybe$map, function(patient_) {
                var _v1 = A2($author$project$Components$ResourceFilter$Patient$preSelectedId, $elm$core$Maybe$Just(patient_.aef), patientResourceFilter);
                var withPreSelectedModel = _v1.a;
                var withPreSelectedCmd = _v1.b;
                return _Utils_Tuple2(A2($author$project$Components$ResourceFilter$Patient$extraItems, _List_fromArray([
                    {
                        IZ: patient_.IZ,
                        aef: patient_.aef,
                        T5: patient_.T5,
                        zr: patient_.zr
                    }
                ]), withPreSelectedModel), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    withPreSelectedCmd,
                    patientResourceFilterCmd
                ])));
            }, patient));
        }(A2($author$project$Components$ResourceFilter$Patient$init, apiClient, optionals));
    });
    var $author$project$Components$LimitedPatientSelector$init = F4(function(apiClient, patientResourceFilterOptionals, patients, patient) {
        var _v0 = A2($elm$core$List$any, function(patient_) {
            return _Utils_eq($elm$core$Maybe$Just(patient_.aef), A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, patient));
        }, patients) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A3($author$project$Components$LimitedPatientSelector$initPatientResourceFilter, apiClient, patientResourceFilterOptionals, patient));
        var patientResourceFilter = _v0.a;
        var patientResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            V7: patient,
            rX: patientResourceFilter,
            GQ: patientResourceFilterOptionals,
            AD: patients,
            aa9: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, patient)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceFilterCmd));
    });
    var $author$project$Components$MovePaymentMethodsModal$mapPatientAttributes = function(patient) {
        return A2($elm$core$Maybe$map, function(patient_) {
            return {
                IZ: $author$project$Api$Provider$Patient$One$age(patient_),
                aef: $author$project$Api$Provider$Patient$One$id(patient_),
                aeT: $elm$core$Maybe$Nothing,
                T5: $author$project$Api$Provider$Patient$One$membershipStatus(patient_),
                zr: $author$project$Api$Provider$Patient$One$name(patient_),
                agi: $elm$core$Maybe$Nothing,
                aa4: $author$project$Api$Provider$Patient$One$usesTobacco(patient_)
            };
        }, patient);
    };
    var $author$project$Components$MovePaymentMethodsModal$initLimitedPatientSelector = F3(function(apiClient, patients, patient) {
        return A4($author$project$Components$LimitedPatientSelector$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Patient',
                I5: true
            });
        }, patients, $author$project$Components$MovePaymentMethodsModal$mapPatientAttributes(patient));
    });
    var $author$project$Api$Provider$Patient$One$payees = function(_v0) {
        var record = _v0.b;
        return record.Wf;
    };
    var $author$project$Components$MovePaymentMethodsModal$initFormFields = F2(function(apiClient, patient) {
        var patients = A2($elm$core$List$map, function(patient_) {
            return {
                IZ: $author$project$Api$Provider$Patient$Shared$age(patient_),
                aef: $author$project$Api$Provider$Patient$Shared$id(patient_),
                aeT: $elm$core$Maybe$Nothing,
                T5: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient_),
                zr: $author$project$Api$Provider$Patient$Shared$name(patient_),
                agi: $elm$core$Maybe$Nothing,
                aa4: $author$project$Api$Provider$Patient$Shared$usesTobacco(patient_)
            };
        }, $author$project$Api$Provider$Patient$One$payees(patient));
        var _v0 = A3($author$project$Components$MovePaymentMethodsModal$initLimitedPatientSelector, apiClient, patients, $elm$core$Maybe$Just(patient));
        var limitedPatientSelector = _v0.a;
        var limitedPatientSelectorCmd = _v0.b;
        return _Utils_Tuple2({
            lw: true,
            rg: limitedPatientSelector,
            V7: $author$project$Components$MovePaymentMethodsModal$mapPatientAttributes($elm$core$Maybe$Just(patient))
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd));
    });
    var $author$project$Components$MovePaymentMethodsModal$openAndInit = F4(function(apiClient, basePath, session, patient) {
        var _v0 = A2($author$project$Components$MovePaymentMethodsModal$initFormFields, apiClient, patient);
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        var open = {
            vK: basePath,
            PU: $author$project$Utils$Form$init(formFields),
            yp: true,
            rt: $author$project$Api$Data$NotAsked,
            V7: patient,
            em: $elm$core$Maybe$Nothing,
            jr: $elm$core$Maybe$Nothing,
            Cl: $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$id(patient)),
            Cm: $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$name(patient)),
            Z$: session
        };
        return {
            EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                formFieldsCmd,
                A2($author$project$Components$MovePaymentMethodsModal$getPaymentSources, apiClient, $author$project$Api$Provider$Patient$One$id(patient))
            ])),
            adu: 1,
            zi: $author$project$Components$MovePaymentMethodsModal$Open(open),
            at: _List_Nil
        };
    });
    var $author$project$Components$MovePaymentMethodsModal$Patient = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$MovePaymentMethodsModal$PaymentMethodsMigrated = 0;
    var $author$project$Components$MovePaymentMethodsModal$moveDefaultToOtherSource = function(paymentSources) {
        return A2($elm$core$List$map, function(paymentSource) {
            return _Utils_update(paymentSource, {
                R0: false
            });
        }, paymentSources);
    };
    var $author$project$Components$MovePaymentMethodsModal$appendPaymentsources = F2(function(sourcePaymentSources, destinationpaymentSources) {
        return A2($elm$core$Maybe$map, function(sourcePaymentSources_) {
            return A2($elm$core$Maybe$withDefault, sourcePaymentSources_, A2($elm$core$Maybe$map, function(destinationpaymentSources_) {
                return A2($elm$core$List$append, sourcePaymentSources_, $author$project$Components$MovePaymentMethodsModal$moveDefaultToOtherSource(destinationpaymentSources_));
            }, destinationpaymentSources));
        }, sourcePaymentSources);
    });
    var $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var patient = field.a;
            return _Utils_update(fields, {
                V7: patient
            });
        } else {
            var bool = field.a;
            return _Utils_update(fields, {
                lw: bool
            });
        }
    });
    var $author$project$Components$MovePaymentMethodsModal$PatientValidation = 0;
    var $author$project$Components$MovePaymentMethodsModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.V7;
        }, _Utils_Tuple2(0, 'Please pick a patient.'))
    ]));
    var $author$project$Api$Provider$PaymentMethod$Min$isDefault = function(_v0) {
        var record = _v0;
        return record.R0;
    };
    var $author$project$Api$Provider$PaymentMethod$Min$lastFour = function(_v0) {
        var record = _v0;
        return record.ST;
    };
    var $author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand = function(_v0) {
        var record = _v0;
        return record._D;
    };
    var $author$project$Components$MovePaymentMethodsModal$mapPaymentSourceAttributes = function(sources) {
        return A2($elm$core$Maybe$map, function(sources_) {
            return A2($elm$core$List$map, function(source_) {
                return {
                    R0: $author$project$Api$Provider$PaymentMethod$Min$isDefault(source_),
                    ST: A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$PaymentMethod$Min$lastFour(source_)),
                    A$: $author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(source_)
                };
            }, sources_);
        }, sources);
    };
    var $author$project$Components$MovePaymentMethodsModal$PaymentMethodsMoved = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$PaymentMethod$movePath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'migrate'
        ]), $author$project$Api$Provider$Patient$PaymentMethod$paymentMethodsPath(patientId));
    };
    var $author$project$Api$Provider$Patient$PaymentMethod$migrate = F4(function(apiClient, patientId, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('to_patient_id', $elm$json$Json$Encode$string(params.ahY)),
            _Utils_Tuple2('remove_sources_from_patient', $elm$json$Json$Encode$bool(params.agI))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$PaymentMethod$movePath(patientId))));
    });
    var $author$project$Components$MovePaymentMethodsModal$movePaymentMethods = F3(function(apiClient, fromPatient, fields) {
        return A4($author$project$Api$Provider$Patient$PaymentMethod$migrate, apiClient, $author$project$Api$Provider$Patient$One$id(fromPatient), {
            agI: fields.lw,
            ahY: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.V7))
        }, $author$project$Components$MovePaymentMethodsModal$PaymentMethodsMoved);
    });
    var $author$project$Components$LimitedPatientSelector$Closed = {
        $: 2
    };
    var $author$project$Components$LimitedPatientSelector$ItemSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$LimitedPatientSelector$None = {
        $: 0
    };
    var $author$project$Api$Provider$Patient$All$location = function(_v0) {
        var record = _v0.b;
        return record.aeT;
    };
    var $author$project$Api$Provider$Patient$All$practitioner = function(_v0) {
        var record = _v0.b;
        return record.agi;
    };
    var $author$project$Api$Provider$Patient$All$usesTobacco = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
    };
    var $author$project$Components$LimitedPatientSelector$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var _v1 = A3($author$project$Components$LimitedPatientSelector$initPatientResourceFilter, apiClient, model.GQ, model.V7);
                var patientResourceFilter = _v1.a;
                var patientResourceFilterCmd = _v1.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceFilterCmd),
                    adu: $author$project$Components$LimitedPatientSelector$None,
                    zi: _Utils_update(model, {
                        rX: $elm$core$Maybe$Just(patientResourceFilter)
                    }),
                    at: _List_Nil
                };
            case 1:
                var patientId = msg.a;
                var patient = A2($elm_community$list_extra$List$Extra$find, function(patient_) {
                    return _Utils_eq(patient_.aef, patientId);
                }, model.AD);
                var event = A2($elm$core$Maybe$withDefault, $author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$LimitedPatientSelector$ItemSelected, $author$project$Components$ResourceFilter$One), patient));
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: event,
                    zi: _Utils_update(model, {
                        V7: patient,
                        aa9: A2($elm$core$Maybe$map, function($) {
                            return $.aef;
                        }, patient)
                    }),
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                var _v2 = model.rX;
                if (!_v2.$) {
                    var patientResourceFilter = _v2.a;
                    var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, patientResourceFilter);
                    var event = function() {
                        var _v3 = patientResourceResult.adu;
                        if (_v3.$ === 1) return $author$project$Components$LimitedPatientSelector$None;
                        else if (_v3.a.$ === 1) {
                            var _v4 = _v3.a;
                            return $author$project$Components$LimitedPatientSelector$Closed;
                        } else switch(_v3.a.a.$){
                            case 0:
                                var patient = _v3.a.a.a;
                                var practitioner = A2($elm$core$Maybe$map, function(practitioner_) {
                                    return {
                                        aef: $author$project$Api$Provider$Practitioner$Min$id(practitioner_),
                                        zr: $author$project$Api$Provider$Practitioner$Min$name(practitioner_)
                                    };
                                }, $author$project$Api$Provider$Patient$All$practitioner(patient));
                                var location1 = A2($elm$core$Maybe$map, function(location_) {
                                    return {
                                        aef: $author$project$Api$Provider$Location$Min$id(location_),
                                        zr: $author$project$Api$Provider$Location$Min$name(location_)
                                    };
                                }, $author$project$Api$Provider$Patient$All$location(patient));
                                var resource = {
                                    IZ: $author$project$Api$Provider$Patient$All$age(patient),
                                    aef: $author$project$Api$Provider$Patient$All$id(patient),
                                    aeT: location1,
                                    T5: $author$project$Api$Provider$Patient$All$membershipStatus(patient),
                                    zr: $author$project$Api$Provider$Patient$All$name(patient),
                                    agi: practitioner,
                                    aa4: $author$project$Api$Provider$Patient$All$usesTobacco(patient)
                                };
                                return $author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$One(resource));
                            case 2:
                                var _v5 = _v3.a.a;
                                return $author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None);
                            case 3:
                                var _v6 = _v3.a.a;
                                return $author$project$Components$LimitedPatientSelector$ItemSelected($author$project$Components$ResourceFilter$None);
                            default:
                                return $author$project$Components$LimitedPatientSelector$None;
                        }
                    }();
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, patientResourceResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            rX: $elm$core$Maybe$Just(patientResourceResult.zi)
                        }),
                        at: patientResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$LimitedPatientSelector$None,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$MovePaymentMethodsModal$updateForm = F4(function(model, apiClient, field, form) {
        var selectedPatientName = function() {
            if (!field.$ && !field.a.$) {
                var patient = field.a.a;
                return $elm$core$Maybe$Just(patient.zr);
            } else return $elm$core$Maybe$Nothing;
        }();
        var selectedPatientId = function() {
            if (!field.$ && !field.a.$) {
                var patient = field.a.a;
                return $elm$core$Maybe$Just(patient.aef);
            } else return $elm$core$Maybe$Nothing;
        }();
        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate, field, form);
        var cmd = function() {
            if (!selectedPatientId.$) {
                var patientId = selectedPatientId.a;
                return A2($author$project$Components$MovePaymentMethodsModal$getPaymentSources, apiClient, patientId);
            } else return $elm$core$Platform$Cmd$none;
        }();
        return _Utils_Tuple2(_Utils_update(model, {
            PU: newForm,
            Cl: selectedPatientId,
            Cm: selectedPatientName
        }), cmd);
    });
    var $author$project$Components$MovePaymentMethodsModal$update = F3(function(apiClient, msg, model) {
        if (model.$ === 1) {
            var open = model.a;
            switch(msg.$){
                case 0:
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: $author$project$Components$MovePaymentMethodsModal$Closed,
                        at: _List_Nil
                    };
                case 2:
                    var field = msg.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$MovePaymentMethodsModal$formFieldsUpdate, field, open.PU);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: $author$project$Components$MovePaymentMethodsModal$Open(_Utils_update(open, {
                            PU: newForm
                        })),
                        at: _List_Nil
                    };
                case 1:
                    var subMsg = msg.a;
                    var fields = $author$project$Utils$Form$fields(open.PU);
                    var limitedPatientSelectorResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, fields.rg);
                    var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                        rg: limitedPatientSelectorResult.zi
                    }), open.PU);
                    var _v2 = function() {
                        var _v3 = limitedPatientSelectorResult.adu;
                        _v3$2: while(true){
                            if (_v3.$ === 1) switch(_v3.a.$){
                                case 0:
                                    var patient = _v3.a.a;
                                    return A4($author$project$Components$MovePaymentMethodsModal$updateForm, open, apiClient, $author$project$Components$MovePaymentMethodsModal$Patient($elm$core$Maybe$Just(patient)), newForm);
                                case 3:
                                    var _v4 = _v3.a;
                                    return A4($author$project$Components$MovePaymentMethodsModal$updateForm, open, apiClient, $author$project$Components$MovePaymentMethodsModal$Patient($elm$core$Maybe$Nothing), newForm);
                                default:
                                    break _v3$2;
                            }
                            else break _v3$2;
                        }
                        return _Utils_Tuple2(_Utils_update(open, {
                            PU: newForm
                        }), $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v2.a;
                    var formCmd = _v2.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg, limitedPatientSelectorResult.EQ),
                            formCmd
                        ])),
                        adu: 1,
                        zi: $author$project$Components$MovePaymentMethodsModal$Open(newModel),
                        at: limitedPatientSelectorResult.at
                    };
                case 3:
                    var _v5 = A2($author$project$Utils$Form$validate, $author$project$Components$MovePaymentMethodsModal$formFieldsValidator, open.PU);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var newForm = _v6.a;
                        var validFormFields = _v6.b;
                        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                        return {
                            EQ: A3($author$project$Components$MovePaymentMethodsModal$movePaymentMethods, apiClient, open.V7, fields),
                            adu: 1,
                            zi: $author$project$Components$MovePaymentMethodsModal$Open(_Utils_update(open, {
                                PU: newForm,
                                rt: $author$project$Api$Data$Loading
                            })),
                            at: _List_Nil
                        };
                    } else {
                        var newForm = _v5.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 1,
                            zi: $author$project$Components$MovePaymentMethodsModal$Open(_Utils_update(open, {
                                PU: newForm
                            })),
                            at: _List_Nil
                        };
                    }
                case 4:
                    var response = msg.a;
                    switch(response.$){
                        case 3:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$MovePaymentMethodsModal$Closed,
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, 'Payment sources migrated to new patient.')
                                ])
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                zi: $author$project$Components$MovePaymentMethodsModal$Open(_Utils_update(open, {
                                    rt: response
                                })),
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                zi: $author$project$Components$MovePaymentMethodsModal$Closed,
                                at: _List_Nil
                            };
                    }
                default:
                    var response = msg.a;
                    switch(response.$){
                        case 3:
                            var paymentSources = response.a;
                            var maybePaymentMethods = $author$project$Components$MovePaymentMethodsModal$mapPaymentSourceAttributes(paymentSources);
                            var paymentMethodsList = A2($author$project$Components$MovePaymentMethodsModal$appendPaymentsources, open.em, maybePaymentMethods);
                            var currentOwnerPaymentMethods = open.yp ? maybePaymentMethods : open.em;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                zi: $author$project$Components$MovePaymentMethodsModal$Open(_Utils_update(open, {
                                    yp: false,
                                    em: currentOwnerPaymentMethods,
                                    jr: paymentMethodsList
                                })),
                                at: _List_Nil
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                zi: $author$project$Components$MovePaymentMethodsModal$Open(open),
                                at: _List_Nil
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 1,
                                zi: $author$project$Components$MovePaymentMethodsModal$Closed,
                                at: _List_Nil
                            };
                    }
            }
        } else return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 1,
            zi: model,
            at: _List_Nil
        };
    });
    var $author$project$Api$Provider$VirtualBankAccount$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$VirtualBankAccounts$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    DZ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var field = msg.a;
                var copiedText = msg.b;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(copiedText), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, field + ' copied to clipboard')
                ]));
            default:
                var virtualBankAccount = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 1, 'Unimplemented action ' + $author$project$Api$Provider$VirtualBankAccount$Shared$id(virtualBankAccount))
                ]));
        }
    });
    var $author$project$Api$Provider$Patient$updateAutopay = F4(function(apiClient, id_, autopay_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('patient', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('autopay', $elm$json$Json$Encode$bool(autopay_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Api$Provider$Patient$updateExemptFromCreditCardFees = F4(function(apiClient, id_, autopay_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('patient', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('exempt_from_credit_card_fees', $elm$json$Json$Encode$bool(autopay_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Components$PaymentSources$Updated = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Api$Employer$BankAccount$update = F5(function(basePath, apiClient, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('bank_account', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Employer$BankAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$BankAccount$bankAccountPath, basePath, id_))));
    });
    var $author$project$Api$Provider$BankAccount$update = F5(function(basePath, apiClient, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('bank_account', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$BankAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$BankAccount$bankAccountPath, basePath, id_))));
    });
    var $author$project$Api$BankAccount$update = F6(function(basePath, apiClient, session, bankAccount, fields, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5($author$project$Api$Employer$BankAccount$update, basePath, apiClient, $author$project$Api$BankAccount$id(bankAccount), fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$BankAccount$EmployerOne))) : A5($author$project$Api$Provider$BankAccount$update, basePath, apiClient, $author$project$Api$BankAccount$id(bankAccount), fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$BankAccount$ProviderOne)));
    });
    var $author$project$Api$Employer$Card$update = F5(function(basePath, apiClient, id_, fields, toMsg) {
        var zipCode = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, A2($elm$core$Basics$composeR, $elm$core$Tuple$pair('zip'), $elm$core$List$singleton)), fields.tK));
        var label = _List_fromArray([
            _Utils_Tuple2('label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aeI))
        ]);
        var expYear = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$String$fromInt, A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, A2($elm$core$Basics$composeR, $elm$core$Tuple$pair('exp_year'), $elm$core$List$singleton))), fields.adA));
        var expMonth = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$String$fromInt, A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, A2($elm$core$Basics$composeR, $elm$core$Tuple$pair('exp_month'), $elm$core$List$singleton))), fields.adz));
        var cardObject = $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            label,
            expMonth,
            expYear,
            zipCode
        ])));
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('card', cardObject)
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Employer$Card$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$Card$cardPath, basePath, id_))));
    });
    var $author$project$Api$Provider$Card$update = F5(function(basePath, apiClient, id_, fields, toMsg) {
        var zipCode = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, A2($elm$core$Basics$composeR, $elm$core$Tuple$pair('zip'), $elm$core$List$singleton)), fields.tK));
        var label = _List_fromArray([
            _Utils_Tuple2('label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aeI))
        ]);
        var expYear = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$String$fromInt, A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, A2($elm$core$Basics$composeR, $elm$core$Tuple$pair('exp_year'), $elm$core$List$singleton))), fields.adA));
        var expMonth = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$String$fromInt, A2($elm$core$Basics$composeR, $elm$json$Json$Encode$string, A2($elm$core$Basics$composeR, $elm$core$Tuple$pair('exp_month'), $elm$core$List$singleton))), fields.adz));
        var cardObject = $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            label,
            expMonth,
            expYear,
            zipCode
        ])));
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('card', cardObject)
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Card$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Card$cardPath, basePath, id_))));
    });
    var $author$project$Api$Card$update = F6(function(basePath, apiClient, session, card, fields, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5($author$project$Api$Employer$Card$update, basePath, apiClient, $author$project$Api$Card$id(card), fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Card$EmployerOne))) : A5($author$project$Api$Provider$Card$update, basePath, apiClient, $author$project$Api$Card$id(card), fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Card$ProviderOne)));
    });
    var $author$project$Api$Source$update = F6(function(basePath, apiClient, session, source, fields, toMsg) {
        switch(source.$){
            case 0:
                var card = source.a;
                var cardFields = {
                    adz: A2($elm$core$Maybe$andThen, function($) {
                        return $.adz;
                    }, fields.EH),
                    adA: A2($elm$core$Maybe$andThen, function($) {
                        return $.adA;
                    }, fields.EH),
                    aeI: fields.aeI,
                    tK: A2($elm$core$Maybe$map, function($) {
                        return $.tK;
                    }, fields.EH)
                };
                return A6($author$project$Api$Card$update, basePath, apiClient, session, card, cardFields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Source$Card)));
            case 1:
                var bankAccount = source.a;
                var onlyLabel = function(f) {
                    return {
                        aeI: f.aeI
                    };
                }(fields);
                return A6($author$project$Api$BankAccount$update, basePath, apiClient, session, bankAccount, onlyLabel, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Source$BankAccount)));
            default:
                return $elm$core$Platform$Cmd$none;
        }
    });
    var $author$project$Components$PaymentSources$updateSource = F5(function(basePath, apiClient, session, source, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A6($author$project$Api$Source$update, basePath, apiClient, session, source, fields, $author$project$Components$PaymentSources$Updated);
    });
    var $author$project$Components$PaymentSources$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 9:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pQ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pF: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 10:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    A1: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 17:
                var patientId = msg.a;
                var toggle = msg.b;
                var cmd = A4($author$project$Api$Provider$Patient$updateExemptFromCreditCardFees, apiClient, patientId, toggle, $author$project$Components$PaymentSources$PatientUpdated);
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 16:
                var patientId = msg.a;
                var toggle = msg.b;
                var cmd = A4($author$project$Api$Provider$Patient$updateAutopay, apiClient, patientId, toggle, $author$project$Components$PaymentSources$PatientUpdated);
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 15:
                var response = msg.a;
                switch(response.$){
                    case 2:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    case 3:
                        var patient = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Hg: $author$project$Components$PaymentSources$Patient(patient)
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(patient))
                        ]));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 6:
                var source = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Hw: $elm$core$Maybe$Just(_Utils_Tuple3(source, $author$project$Utils$Form$init($author$project$Components$PaymentSources$formFieldsFromSource(source)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var field = msg.a;
                var _v3 = model.Hw;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var source = _v4.a;
                    var form = _v4.b;
                    var saveRequest = _v4.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$PaymentSources$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Hw: $elm$core$Maybe$Just(_Utils_Tuple3(source, newForm, saveRequest))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    Hw: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var _v5 = model.Hw;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var source = _v6.a;
                    var form = _v6.b;
                    var formValidator = $author$project$Components$PaymentSources$formFieldsValidator(model.cP);
                    var _v7 = A2($author$project$Utils$Form$validate, formValidator, form);
                    if (!_v7.$) {
                        var _v8 = _v7.a;
                        var newForm = _v8.a;
                        var validFormFields = _v8.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Hw: $elm$core$Maybe$Just(_Utils_Tuple3(source, newForm, $author$project$Api$Data$Loading))
                        }), A5($author$project$Components$PaymentSources$updateSource, model.vK, apiClient, model.Z$, source, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v7.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Hw: $elm$core$Maybe$Just(_Utils_Tuple3(source, newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var response = msg.a;
                var _v9 = model.Hw;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var source = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) {
                        var _v12 = A4($author$project$Components$PaymentSources$loadData, model.vK, apiClient, model.Z$, model.Hg);
                        var cards = _v12.a;
                        var bankAccounts = _v12.b;
                        var cmd = _v12.c;
                        return _Utils_Tuple3(_Utils_update(model, {
                            pF: bankAccounts,
                            pQ: cards,
                            Hw: $elm$core$Maybe$Nothing
                        }), cmd, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Source successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        Hw: $elm$core$Maybe$Just(_Utils_Tuple3(source, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var source = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    fw: $elm$core$Maybe$Nothing,
                    ax: A2($elm$core$Set$insert, $author$project$Api$Source$id(source), model.ax)
                }), A6($author$project$Api$Source$updateDefault, model.vK, apiClient, model.Z$, source, $elm$core$Maybe$Nothing, $author$project$Components$PaymentSources$MadeDefault($author$project$Api$Source$id(source))), _List_Nil);
            case 12:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        var _v14 = A4($author$project$Components$PaymentSources$loadData, model.vK, apiClient, model.Z$, model.Hg);
                        var cards = _v14.a;
                        var bankAccounts = _v14.b;
                        var cmd = _v14.c;
                        return _Utils_Tuple3(_Utils_update(model, {
                            pF: bankAccounts,
                            pQ: cards,
                            ax: A2($elm$core$Set$remove, id, model.ax)
                        }), cmd, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Default source successfully updated.')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            ax: A2($elm$core$Set$remove, id, model.ax)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var source = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    fw: $elm$core$Maybe$Just(source)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var source = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    fw: $elm$core$Maybe$Nothing,
                    ax: A2($elm$core$Set$insert, $author$project$Api$Source$id(source), model.ax)
                }), A5($author$project$Api$Source$delete, model.vK, apiClient, model.Z$, source, $author$project$Components$PaymentSources$Deleted(source)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    fw: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var source = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        var retrieveOutMsg = function() {
                            var _v17 = model.Hg;
                            if (_v17.$ === 1) {
                                var patient = _v17.a;
                                return _List_fromArray([
                                    $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(patient))
                                ]);
                            } else return _List_Nil;
                        }();
                        var _v16 = A4($author$project$Components$PaymentSources$loadData, model.vK, apiClient, model.Z$, model.Hg);
                        var cards = _v16.a;
                        var bankAccounts = _v16.b;
                        var cmd = _v16.c;
                        return _Utils_Tuple3(_Utils_update(model, {
                            pF: bankAccounts,
                            pQ: cards,
                            ax: A2($elm$core$Set$remove, $author$project$Api$Source$id(source), model.ax)
                        }), cmd, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 3, 'Source successfully deleted'), retrieveOutMsg));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            ax: A2($elm$core$Set$remove, $author$project$Api$Source$id(source), model.ax)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var subMsg = msg.a;
                var createPaymentMethodModalResult = A3($author$project$Components$CreatePaymentMethodModal$update, apiClient, subMsg, model.lG);
                var _v18 = function() {
                    var _v19 = createPaymentMethodModalResult.adu;
                    if (!_v19) return A4($author$project$Components$PaymentSources$loadData, model.vK, apiClient, model.Z$, model.Hg);
                    else return _Utils_Tuple3(model.pQ, model.pF, $elm$core$Platform$Cmd$none);
                }();
                var cards = _v18.a;
                var bankAccounts = _v18.b;
                var cmd = _v18.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    pF: bankAccounts,
                    pQ: cards,
                    lG: createPaymentMethodModalResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg, createPaymentMethodModalResult.EQ),
                    cmd
                ])), createPaymentMethodModalResult.at);
            case 5:
                var subMsg = msg.a;
                var _v20 = A2($author$project$Ui$Dropdown$update, subMsg, model.rs);
                var dropdownMenu = _v20.a;
                var cmd = _v20.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    rs: dropdownMenu
                }), cmd, _List_Nil);
            case 14:
                var subMsg = msg.a;
                var movePaymentMethodsModalResult = A3($author$project$Components$MovePaymentMethodsModal$update, apiClient, subMsg, model.gc);
                var _v21 = function() {
                    var _v22 = movePaymentMethodsModalResult.adu;
                    if (!_v22) return A4($author$project$Components$PaymentSources$loadData, model.vK, apiClient, model.Z$, model.Hg);
                    else return _Utils_Tuple3(model.pQ, model.pF, $elm$core$Platform$Cmd$none);
                }();
                var cards = _v21.a;
                var bankAccounts = _v21.b;
                var cmd = _v21.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    pF: bankAccounts,
                    pQ: cards,
                    gc: movePaymentMethodsModalResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg, movePaymentMethodsModalResult.EQ),
                    cmd
                ])), movePaymentMethodsModalResult.at);
            case 0:
                var subMsg = msg.a;
                var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, model.hB);
                return _Utils_Tuple3(_Utils_update(model, {
                    hB: auditTrailLogResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$AuditTrailLogMsg, auditTrailLogResult.EQ), auditTrailLogResult.at);
            case 20:
                var subMsg = msg.a;
                var _v23 = function() {
                    var _v24 = model.tF;
                    if (!_v24.$) {
                        var virtualBankAccountsComponent_ = _v24.a;
                        var _v25 = A2($author$project$Components$VirtualBankAccounts$update, subMsg, virtualBankAccountsComponent_);
                        var virtualModel_ = _v25.a;
                        var virtualCmd_ = _v25.b;
                        var virtualOutMsgs_ = _v25.c;
                        return _Utils_Tuple3($elm$core$Maybe$Just(virtualModel_), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg, virtualCmd_), virtualOutMsgs_);
                    } else return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
                }();
                var model_ = _v23.a;
                var cmd_ = _v23.b;
                var outMsgs_ = _v23.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    tF: model_
                }), cmd_, outMsgs_);
            case 21:
                var patient = msg.a;
                var result = A4($author$project$Components$MovePaymentMethodsModal$openAndInit, apiClient, model.vK, model.Z$, patient);
                return _Utils_Tuple3(_Utils_update(model, {
                    gc: result.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg, result.EQ), result.at);
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    gc: $author$project$Components$MovePaymentMethodsModal$close(model.gc)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$PaymentSources$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$PaymentSources$update, model.Ej, subMsg, model.rk);
        var paymentSources = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: paymentSources
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$MovePaymentMethodsModal$Checkbox = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$MovePaymentMethodsModal$Close = {
        $: 0
    };
    var $author$project$Components$MovePaymentMethodsModal$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$MovePaymentMethodsModal$MovePaymentMethods = {
        $: 3
    };
    var $author$project$Components$MovePaymentMethodsModal$countPaymentSources = F2(function(model, patientId) {
        var paymentSources = _Utils_eq(patientId, $author$project$Api$Provider$Patient$One$id(model.V7)) ? model.em : model.jr;
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $elm$core$List$length, paymentSources));
    });
    var $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource = function(paymentSources) {
        return A2($elm$core$List$filter, function(paymentSource_) {
            return paymentSource_.R0;
        }, paymentSources);
    };
    var $author$project$Components$MovePaymentMethodsModal$displayDefaultSource = F2(function(model, patientId) {
        var defaultSource = function() {
            if (_Utils_eq(patientId, $author$project$Api$Provider$Patient$One$id(model.V7))) {
                var _v0 = model.em;
                if (!_v0.$) {
                    var paymentSource_ = _v0.a;
                    return $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource(paymentSource_);
                } else return _List_Nil;
            } else {
                var _v1 = model.jr;
                if (!_v1.$) {
                    var paymentSource_ = _v1.a;
                    return $author$project$Components$MovePaymentMethodsModal$defaultPaymentSource(paymentSource_);
                } else return _List_Nil;
            }
        }();
        return A2($elm$html$Html$ul, _List_fromArray([
            $elm$html$Html$Attributes$class('list-align-left')
        ]), A2($elm$core$List$map, function(source_) {
            return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text(source_.A$ + ' ')
                ])),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(source_.ST)
                ]))
            ]));
        }, defaultSource));
    });
    var $author$project$Components$MovePaymentMethodsModal$displayNoBulletSources = F2(function(model, patientId) {
        var paymentSources = _Utils_eq(patientId, $author$project$Api$Provider$Patient$One$id(model.V7)) ? model.em : model.jr;
        var paymentSource = A2($elm$core$Maybe$andThen, function(sources) {
            return $elm$core$List$head(sources);
        }, paymentSources);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                if (!paymentSource.$) {
                    var paymentSource_ = paymentSource.a;
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$bold
                        ]), _List_fromArray([
                            $elm$html$Html$text(paymentSource_.A$ + ' ')
                        ])),
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(paymentSource_.ST)
                        ]))
                    ]));
                } else return $elm$html$Html$text('');
            }()
        ]));
    });
    var $author$project$Components$MovePaymentMethodsModal$otherPaymentSources = function(paymentSources) {
        return A2($elm$core$List$filter, function(paymentSource_) {
            return !paymentSource_.R0;
        }, paymentSources);
    };
    var $author$project$Components$MovePaymentMethodsModal$displayOtherSources = F2(function(model, patientId) {
        var otherSources = function() {
            if (_Utils_eq(patientId, $author$project$Api$Provider$Patient$One$id(model.V7))) {
                var _v0 = model.em;
                if (!_v0.$) {
                    var paymentSource_ = _v0.a;
                    return $author$project$Components$MovePaymentMethodsModal$otherPaymentSources(paymentSource_);
                } else return _List_Nil;
            } else {
                var _v1 = model.jr;
                if (!_v1.$) {
                    var paymentSource_ = _v1.a;
                    return $author$project$Components$MovePaymentMethodsModal$otherPaymentSources(paymentSource_);
                } else return _List_Nil;
            }
        }();
        return A2($elm$html$Html$ul, _List_fromArray([
            $elm$html$Html$Attributes$class('list-align-left')
        ]), A2($elm$core$List$map, function(source_) {
            return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text(source_.A$ + ' ')
                ])),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(source_.ST)
                ]))
            ]));
        }, otherSources));
    });
    var $author$project$Components$MovePaymentMethodsModal$showTextIf = F2(function(isTrue, htmlMsg) {
        return isTrue ? htmlMsg : $elm$html$Html$text('');
    });
    var $author$project$Components$MovePaymentMethodsModal$displayPaymentSources = F2(function(model, patientId) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Components$MovePaymentMethodsModal$showTextIf, A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1, $elm$html$Html$text('Default Source:')),
            A2($author$project$Components$MovePaymentMethodsModal$showTextIf, A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1, A2($author$project$Components$MovePaymentMethodsModal$displayDefaultSource, model, patientId)),
            A2($author$project$Components$MovePaymentMethodsModal$showTextIf, A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) === 1, A2($author$project$Components$MovePaymentMethodsModal$displayNoBulletSources, model, patientId)),
            A2($author$project$Components$MovePaymentMethodsModal$showTextIf, A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1, $elm$html$Html$text('Payment Sources:')),
            A2($author$project$Components$MovePaymentMethodsModal$showTextIf, A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, model, patientId) > 1, A2($author$project$Components$MovePaymentMethodsModal$displayOtherSources, model, patientId))
        ]));
    });
    var $author$project$Components$LimitedPatientSelector$Errors = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$LimitedPatientSelector$errors = $author$project$Components$LimitedPatientSelector$Errors;
    var $author$project$Components$LimitedPatientSelector$Invalid = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$LimitedPatientSelector$invalid = $author$project$Components$LimitedPatientSelector$Invalid;
    var $author$project$Components$LimitedPatientSelector$FindAnotherPatient = {
        $: 0
    };
    var $author$project$Components$LimitedPatientSelector$PatientSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$LimitedPatientSelector$defaultOptions = {
        fK: _List_Nil,
        q2: false
    };
    var $author$project$Components$LimitedPatientSelector$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            if (!option.$) {
                var bool = option.a;
                return _Utils_update(record, {
                    q2: bool
                });
            } else {
                var list = option.a;
                return _Utils_update(record, {
                    fK: list
                });
            }
        }), $author$project$Components$LimitedPatientSelector$defaultOptions, options);
    };
    var $author$project$Components$LimitedPatientSelector$patientOptions = function(patients) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a patient'), A2($elm$core$List$map, function(patient) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(patient.aef), patient.zr);
        }, patients));
    };
    var $author$project$Components$LimitedPatientSelector$view = F2(function(options, model) {
        var optionsRecord = $author$project$Components$LimitedPatientSelector$optionsToRecord(options);
        var _v0 = model.rX;
        if (!_v0.$) {
            var patientResourceFilter = _v0.a;
            return A2($elm$html$Html$map, $author$project$Components$LimitedPatientSelector$PatientResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$view, _List_fromArray([
                $author$project$Components$ResourceFilter$invalid(optionsRecord.q2),
                $author$project$Components$ResourceFilter$errors(optionsRecord.fK)
            ]), patientResourceFilter));
        } else return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(model.aa9),
                $author$project$Ui$Form$Select$onChange($author$project$Components$LimitedPatientSelector$PatientSelected),
                $author$project$Ui$Form$Select$invalid(optionsRecord.q2),
                $author$project$Ui$Form$Select$errors(optionsRecord.fK)
            ]), $author$project$Components$LimitedPatientSelector$patientOptions(model.AD)),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text(' or '),
                A3($author$project$Ui$Button$view, {
                    abP: 'Find another patient'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Components$LimitedPatientSelector$FindAnotherPatient)
                ]), _List_fromArray([
                    $elm$html$Html$text('Find another patient')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$MovePaymentMethodsModal$viewMovePaymentMethodsModal = function(open) {
        var selectedPatientId = A2($elm$core$Maybe$withDefault, '', open.Cl);
        var fields = $author$project$Utils$Form$fields(open.PU);
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(true),
            $author$project$Ui$Form$onSubmit($author$project$Components$MovePaymentMethodsModal$MovePaymentMethods)
        ]), _List_fromArray([
            A3($author$project$Ui$Modal$view, $author$project$Components$MovePaymentMethodsModal$Close, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Move Payment Methods to Another Patient')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpanSm(3),
                            $author$project$Ui$Form$Group$inputSpanSm(9),
                            $author$project$Ui$Form$Group$label('New Owner'),
                            $author$project$Ui$Form$Group$required(true)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$MovePaymentMethodsModal$LimitedPatientSelectorMsg, A2($author$project$Components$LimitedPatientSelector$view, _List_fromArray([
                                $author$project$Components$LimitedPatientSelector$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, open.PU)),
                                $author$project$Components$LimitedPatientSelector$errors(A2($author$project$Utils$Form$validationErrors, 0, open.PU))
                            ]), fields.rg)),
                            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                                $author$project$Ui$Form$Checkbox$value(fields.lw),
                                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$MovePaymentMethodsModal$FormUpdated, $author$project$Components$MovePaymentMethodsModal$Checkbox))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Remove payment methods from current patient')
                            ]))
                        ])),
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('ml-50')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(6)
                                ]), _List_fromArray([
                                    A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, open, $author$project$Api$Provider$Patient$One$id(open.V7)) > 0 ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$gray
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('From ')
                                        ])),
                                        A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$gray,
                                            $author$project$Ui$Typography$bold
                                        ]), _List_fromArray([
                                            $elm$html$Html$text($author$project$Api$Provider$Patient$One$name(open.V7))
                                        ]))
                                    ])) : $elm$html$Html$text(''),
                                    fields.lw ? A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$danger,
                                        $author$project$Ui$Typography$strike
                                    ]), _List_fromArray([
                                        A2($author$project$Components$MovePaymentMethodsModal$displayPaymentSources, open, $author$project$Api$Provider$Patient$One$id(open.V7))
                                    ])) : A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$danger
                                    ]), _List_fromArray([
                                        A2($author$project$Components$MovePaymentMethodsModal$displayPaymentSources, open, $author$project$Api$Provider$Patient$One$id(open.V7))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(6)
                                ]), _List_fromArray([
                                    !$elm$core$String$isEmpty(selectedPatientId) && A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, open, $author$project$Api$Provider$Patient$One$id(open.V7)) > 0 && A2($author$project$Components$MovePaymentMethodsModal$countPaymentSources, open, selectedPatientId) > 0 ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$gray
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('To ')
                                        ])),
                                        function() {
                                            var selectedPatientName = A2($elm$core$Maybe$withDefault, '', open.Cm);
                                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                                $author$project$Ui$Typography$gray,
                                                $author$project$Ui$Typography$bold
                                            ]), _List_fromArray([
                                                $elm$html$Html$text(selectedPatientName)
                                            ]));
                                        }()
                                    ])) : $author$project$Utils$Html$empty,
                                    $elm$core$String$isEmpty(selectedPatientId) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$success
                                    ]), _List_fromArray([
                                        A2($author$project$Components$MovePaymentMethodsModal$displayPaymentSources, open, selectedPatientId)
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$MovePaymentMethodsModal$Close)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Confirm'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$loading(_Utils_eq(open.rt, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Confirm')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$MovePaymentMethodsModal$modal = function(model) {
        if (model.$ === 1) {
            var open = model.a;
            return $author$project$Components$MovePaymentMethodsModal$viewMovePaymentMethodsModal(open);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Element$mt1 = $author$project$Ui$Element$Margin('mt-1');
    var $author$project$Components$PaymentSourceDisplayer$skeleton = A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('VISA *4242')
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$textSm
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Added mm/dd/YYYY, expires mm/dd/YYYY')
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$textSm
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Maually added by someone')
            ]))
        ]))
    ]));
    var $author$project$Components$VirtualBankAccounts$loadFromData = function(model) {
        var _v0 = model.DZ;
        if (_v0.$ === 3) {
            var virtualBankAccounts_ = _v0.a;
            return virtualBankAccounts_;
        } else return _List_Nil;
    };
    var $author$project$Components$VirtualBankAccounts$TransactionHistory = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$balanceInCents = function(_v0) {
        var record = _v0;
        return record.abW;
    };
    var $author$project$Api$Provider$VirtualBankAccount$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Components$VirtualBankAccounts$CopyToClipboard = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$VirtualBankAccounts$viewVirtualBankAccountBox = function(virtualBankAccount) {
        return A3($author$project$Ui$Alert$view, 1, _List_fromArray([
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft),
            $author$project$Ui$Alert$margin(25)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(2)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Bank Name')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(10)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$black,
                            $author$project$Ui$Typography$margin(25)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(virtualBankAccount)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Copy Bank Name'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$VirtualBankAccounts$CopyToClipboard, 'Bank Name', $author$project$Api$Provider$VirtualBankAccount$Shared$swiftBankName(virtualBankAccount)))
                            ]), _List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(2)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Routing Number')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(10)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$black,
                            $author$project$Ui$Typography$margin(25)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(virtualBankAccount)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Copy Routing Number'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$VirtualBankAccounts$CopyToClipboard, 'Routing Number', $author$project$Api$Provider$VirtualBankAccount$Shared$abaRoutingtNumber(virtualBankAccount)))
                            ]), _List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(2)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Account Number')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(10)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$black,
                            $author$project$Ui$Typography$margin(25)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$VirtualBankAccount$Shared$abaAccountNumber(virtualBankAccount)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Copy Account Number'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$VirtualBankAccounts$CopyToClipboard, 'Account Number', $author$project$Api$Provider$VirtualBankAccount$Shared$swiftAccountNumber(virtualBankAccount)))
                            ]), _List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(2)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('SWIFT code')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(10)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$black,
                            $author$project$Ui$Typography$margin(25)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(virtualBankAccount)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Copy SWIFT Code'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                                $author$project$Ui$Button$onClick(A2($author$project$Components$VirtualBankAccounts$CopyToClipboard, 'Swift Code', $author$project$Api$Provider$VirtualBankAccount$Shared$swiftCode(virtualBankAccount)))
                            ]), _List_Nil)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$VirtualBankAccounts$viewVirtualBankAccount = F2(function(timeFormatter, virtualBankAccount) {
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$strong, _List_fromArray([
                            $elm$html$Html$Attributes$class('inline')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Api$Provider$VirtualBankAccount$Shared$abaBankName(virtualBankAccount)))
                            ]))
                        ])),
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(' (Account Balance: ' + ($author$project$Utils$Currency$fromInt($author$project$Api$Provider$VirtualBankAccount$Shared$balanceInCents(virtualBankAccount)) + ')'))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'View transaction history'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$VirtualBankAccounts$TransactionHistory(virtualBankAccount))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Transaction History')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Added ' + A2(timeFormatter, 5, $author$project$Api$Provider$VirtualBankAccount$Shared$createdAt(virtualBankAccount)))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('TRANSFER INSTRUCTIONS')
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$black
                        ]), _List_fromArray([
                            $elm$html$Html$text('To pay via Bank Transfer, transer funds using the following bank information. Bank Transfers can take up to five business days.')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    $author$project$Components$VirtualBankAccounts$viewVirtualBankAccountBox(virtualBankAccount)
                ]))
            ]))
        ]));
    });
    var $author$project$Components$VirtualBankAccounts$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, $author$project$Components$VirtualBankAccounts$viewVirtualBankAccount(model.HO), $author$project$Components$VirtualBankAccounts$loadFromData(model)));
    };
    var $author$project$Components$PaymentSources$viewAuditTrailLog = function(model) {
        var _v0 = model.Hg;
        if (_v0.$ === 1) return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$ml2
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$PaymentSources$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$view(model.hB))
            ]))
        ]);
        else return _List_fromArray([
            $author$project$Utils$Html$empty
        ]);
    };
    var $author$project$Api$Employer$Company$One$invoiceAutoPay = function(_v0) {
        var record = _v0.b;
        return record.RD;
    };
    var $author$project$Api$Provider$Company$One$invoiceAutoPay = function(_v0) {
        var record = _v0.b;
        return record.RD;
    };
    var $author$project$Api$Company$invoiceAutoPay = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$invoiceAutoPay(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$invoiceAutoPay(company_);
        }
    };
    var $author$project$Components$PaymentSources$viewCompanyAutopay = F3(function(model, company, organizationIsCompany) {
        var _v0 = $author$project$Api$Company$invoiceAutoPay(company) ? _Utils_Tuple2('On', ' Disable Autopay to stop automated payment collection on upcoming invoices.') : _Utils_Tuple2('Off', '');
        var disableAutoPayToggleText = _v0.a;
        var disableAutoPayText = _v0.b;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(10)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Autopay')
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? $elm$html$Html$text($elm$core$String$concat(_List_fromArray([
                        'Automatically process payment for issued invoices on their due date.',
                        disableAutoPayText
                    ]))) : $elm$html$Html$text('If set, we will automatically try to process a payment for the invoice on its due date.')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(2),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(disableAutoPayToggleText)
                    ]))
                ])),
                organizationIsCompany ? $author$project$Utils$Html$empty : A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings({
                    fl: $author$project$Api$Company$id(company)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Manage invoice settings')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$PaymentSources$TogglePatientAutopay = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$Shared$autopay = function(_v0) {
        var shared = _v0;
        return shared.JY;
    };
    var $author$project$Api$Provider$Patient$One$autopay = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$autopay(shared);
    };
    var $author$project$Components$PaymentSources$viewPatientAutopay = F2(function(practice, patient) {
        var _v0 = function() {
            if ($author$project$Api$Provider$Patient$One$autopay(patient)) {
                var multipleMembershipsText = $author$project$Api$Practice$allowMultipleRetailMemberships(practice) ? ' To set a different payment method for a specific membership, update it from the Memberships tab under Pricing.' : '';
                return _Utils_Tuple2('Automated payments collection will be attempted.', 'Disable Autopay to stop automated payment collection on upcoming invoices.' + multipleMembershipsText);
            } else return _Utils_Tuple2('No automated payments collection will be attempted.', 'Enable Autopay to start automated payment collection on upcoming invoices.');
        }();
        var autoPayText = _v0.a;
        var toggleAutoPayText = _v0.b;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(10)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Autopay')
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text($elm$core$String$concat(_List_fromArray([
                        autoPayText,
                        ' ',
                        toggleAutoPayText
                    ])))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(2),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on($author$project$Api$Provider$Patient$One$autopay(patient)),
                    $author$project$Ui$ToggleSwitch$onChange($author$project$Components$PaymentSources$TogglePatientAutopay($author$project$Api$Provider$Patient$One$id(patient)))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$PaymentSources$viewAutopay = function(model) {
        var _v0 = model.Hg;
        if (!_v0.$) {
            var company = _v0.a;
            return _List_fromArray([
                A3($author$project$Components$PaymentSources$viewCompanyAutopay, model, company, $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$))
            ]);
        } else {
            var patient = _v0.a;
            return _List_fromArray([
                A2($author$project$Components$PaymentSources$viewPatientAutopay, model.W1, patient)
            ]);
        }
    };
    var $author$project$Components$PaymentSources$TogglePatientExemptFromCreditCardFees = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$One$exemptFromCreditCardFees = function(_v0) {
        var record = _v0.b;
        return record.Pa;
    };
    var $author$project$Components$PaymentSources$viewExemptFromCreditCardFees = function(model) {
        var showToggle = function() {
            var _v1 = model.W1;
            if (!_v1.$) {
                var practice = _v1.a;
                return $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice);
            } else return false;
        }();
        var _v0 = _Utils_Tuple2(model.Hg, showToggle);
        if (_v0.a.$ === 1 && _v0.b) {
            var patient = _v0.a.a;
            var exemptText = 'When enabled, this patient will not be charged credit card fees, even if they pay with a credit card.';
            return _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(10)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Exclude this patient from credit card surcharge')
                        ])),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text($elm$core$String$concat(_List_fromArray([
                                exemptText,
                                ' '
                            ])))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(2),
                        $author$project$Ui$Grid$justifyRight
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on($author$project$Api$Provider$Patient$One$exemptFromCreditCardFees(patient)),
                            $author$project$Ui$ToggleSwitch$onChange($author$project$Components$PaymentSources$TogglePatientExemptFromCreditCardFees($author$project$Api$Provider$Patient$One$id(patient)))
                        ]))
                    ]))
                ]))
            ]);
        } else return _List_Nil;
    };
    var $author$project$Components$PaymentSources$OpenMovePaymentMethodsModal = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$viewMoreActionsDowndown = F2(function(model, sources) {
        var _v0 = model.Hg;
        if (!_v0.$) return _List_Nil;
        else {
            var patient = _v0.a;
            var canMigrate = function() {
                var _v1 = model.A1;
                if (_v1.$ === 3) {
                    var paymentSourcesMigratable = _v1.a;
                    return paymentSourcesMigratable;
                } else return false;
            }();
            return !$elm$core$List$isEmpty(sources) && canMigrate ? $elm$core$List$singleton(A4($author$project$Ui$Dropdown$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Other Actions')
            ]), _List_fromArray([
                A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$PaymentSources$OpenMovePaymentMethodsModal(patient))
                ]), A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $author$project$Ui$Icon$copy(_List_Nil),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text('Move All Payment Methods to Another Patient')
                ])))
            ]), model.rs)) : _List_Nil;
        }
    });
    var $author$project$Api$Employer$BankAccount$One$default = function(_v0) {
        var record = _v0.b;
        return record.Nn;
    };
    var $author$project$Api$Employer$BankAccount$All$default = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$BankAccount$One$default(one);
    };
    var $author$project$Api$Provider$BankAccount$One$default = function(_v0) {
        var record = _v0.b;
        return record.Nn;
    };
    var $author$project$Api$Provider$BankAccount$All$default = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$BankAccount$One$default(one);
    };
    var $author$project$Api$BankAccount$default = function(bankAccount) {
        switch(bankAccount.$){
            case 0:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$One$default(bankAccount_);
            case 1:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Provider$BankAccount$All$default(bankAccount_);
            case 2:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$One$default(bankAccount_);
            default:
                var bankAccount_ = bankAccount.a;
                return $author$project$Api$Employer$BankAccount$All$default(bankAccount_);
        }
    };
    var $author$project$Api$Employer$Card$One$default = function(_v0) {
        var record = _v0.b;
        return record.Nn;
    };
    var $author$project$Api$Employer$Card$All$default = function(_v0) {
        var one = _v0;
        return $author$project$Api$Employer$Card$One$default(one);
    };
    var $author$project$Api$Provider$Card$One$default = function(_v0) {
        var record = _v0.b;
        return record.Nn;
    };
    var $author$project$Api$Provider$Card$All$default = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Card$One$default(one);
    };
    var $author$project$Api$Card$default = function(card) {
        switch(card.$){
            case 0:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$One$default(card_);
            case 1:
                var card_ = card.a;
                return $author$project$Api$Provider$Card$All$default(card_);
            case 2:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$One$default(card_);
            default:
                var card_ = card.a;
                return $author$project$Api$Employer$Card$All$default(card_);
        }
    };
    var $author$project$Api$Source$default = function(source) {
        switch(source.$){
            case 0:
                var card = source.a;
                return $author$project$Api$Card$default(card);
            case 1:
                var bankAccount = source.a;
                return $author$project$Api$BankAccount$default(bankAccount);
            default:
                return false;
        }
    };
    var $author$project$Components$PaymentSources$viewNoDefaultSourceWarning = F2(function(resource, sources) {
        if (resource.$ === 1) {
            var patient = resource.a;
            var hasNoDefaultSource = !$elm$core$List$isEmpty(sources) && $elm$core$List$isEmpty(A2($elm$core$List$filter, function(source) {
                return $author$project$Api$Source$default(source);
            }, sources));
            return $author$project$Api$Provider$Patient$One$autopay(patient) && hasNoDefaultSource ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb4
                    ]), _List_fromArray([
                        A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('There is no default payment source on file. '),
                            $elm$html$Html$text('Please select a default payment method or turn off auto pay.')
                        ]))
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$PaymentSources$Delete = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$Edit = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$MakeDefault = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$PatientId = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$patientId = $author$project$Components$PaymentSourceDisplayer$PatientId;
    var $author$project$Components$PaymentSourceDisplayer$ShowAssignedMemberships = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$PaymentSourceDisplayer$showAssignedMemberships = $author$project$Components$PaymentSourceDisplayer$ShowAssignedMemberships;
    var $author$project$Components$PaymentSources$viewSource = F6(function(timeFormatter, isHintAdmin, updatingSources, practice, maybePatientId, source) {
        var loading = A2($elm$core$Set$member, $author$project$Api$Source$id(source), updatingSources);
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                        $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just(source)),
                        $author$project$Components$PaymentSourceDisplayer$showProcessor(isHintAdmin),
                        $author$project$Components$PaymentSourceDisplayer$showAssignedMemberships($author$project$Api$Practice$allowMultipleRetailMemberships(practice)),
                        $author$project$Components$PaymentSourceDisplayer$patientId(maybePatientId)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight,
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        $author$project$Api$Source$default(source) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : A3($author$project$Ui$Button$view, {
                            abP: 'Make this payment source the default for the payer'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$PaymentSources$MakeDefault(source))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Make Default')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Edit payment source'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$PaymentSources$Edit(source)),
                            $author$project$Ui$Button$disabled(loading)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Edit')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Delete payment source'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$loading(loading),
                            $author$project$Ui$Button$onClick($author$project$Components$PaymentSources$Delete(source))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Delete')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$PaymentSources$viewPaymentSourcesList = F2(function(model, sources) {
        if ($elm$core$List$isEmpty(sources)) return _List_fromArray([
            A2($author$project$Ui$ListGroup$item, _List_Nil, $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? _List_fromArray([
                $elm$html$Html$text('You have not added any credit cards or bank accounts.')
            ]) : _List_fromArray([
                !$author$project$Api$Practice$hasPaymentProcessorAccount(model.W1) ? A2($author$project$Utils$PaymentProcessor$toSetupAlert, model.W1, $elm$core$Maybe$Just('In order to add payment options')) : A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = model.Hg;
                        if (!_v0.$) return $elm$html$Html$text('This employer has no payment sources set up.');
                        else return $elm$html$Html$text('This patient has no payment sources set up.');
                    }()
                ]))
            ]))
        ]);
        else {
            var maybePatientId = function() {
                var _v1 = model.Hg;
                if (_v1.$ === 1) {
                    var patient = _v1.a;
                    return $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$id(patient));
                } else return $elm$core$Maybe$Nothing;
            }();
            return A2($elm$core$List$map, A5($author$project$Components$PaymentSources$viewSource, model.HO, model.F3, model.ax, model.W1, maybePatientId), sources);
        }
    });
    var $author$project$Api$Employer$Company$One$invoiceAutoIssue = function(_v0) {
        var record = _v0.b;
        return record.RB;
    };
    var $author$project$Api$Provider$Company$One$invoiceAutoIssue = function(_v0) {
        var record = _v0.b;
        return record.RB;
    };
    var $author$project$Api$Company$invoiceAutoIssue = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$invoiceAutoIssue(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$invoiceAutoIssue(company_);
        }
    };
    var $author$project$Api$Employer$Company$One$invoiceAutoIssueDay = function(_v0) {
        var record = _v0.b;
        return record.RC;
    };
    var $author$project$Api$Provider$Company$One$invoiceAutoIssueDay = function(_v0) {
        var record = _v0.b;
        return record.RC;
    };
    var $author$project$Api$Company$invoiceAutoIssueDay = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$invoiceAutoIssueDay(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$invoiceAutoIssueDay(company_);
        }
    };
    var $author$project$Api$Employer$Company$One$invoiceAutoSend = function(_v0) {
        var record = _v0.b;
        return record.RE;
    };
    var $author$project$Api$Provider$Company$One$invoiceAutoSend = function(_v0) {
        var record = _v0.b;
        return record.RE;
    };
    var $author$project$Api$Company$invoiceAutoSend = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$invoiceAutoSend(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$invoiceAutoSend(company_);
        }
    };
    var $author$project$Api$Employer$Company$One$invoiceAutoSendDay = function(_v0) {
        var record = _v0.b;
        return record.RF;
    };
    var $author$project$Api$Provider$Company$One$invoiceAutoSendDay = function(_v0) {
        var record = _v0.b;
        return record.RF;
    };
    var $author$project$Api$Company$invoiceAutoSendDay = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$invoiceAutoSendDay(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$invoiceAutoSendDay(company_);
        }
    };
    var $author$project$Api$Employer$Company$One$invoiceDueDay = function(_v0) {
        var record = _v0.b;
        return record.RH;
    };
    var $author$project$Api$Provider$Company$One$invoiceDueDay = function(_v0) {
        var record = _v0.b;
        return record.RH;
    };
    var $author$project$Api$Company$invoiceDueDay = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$invoiceDueDay(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$invoiceDueDay(company_);
        }
    };
    var $author$project$Components$PaymentSources$viewPaymentTerms = function(model) {
        return !$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Payment Terms')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    function() {
                        var _v0 = model.Hg;
                        if (!_v0.$) {
                            var company = _v0.a;
                            return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                function() {
                                    var _v1 = _Utils_Tuple2($author$project$Api$Company$invoiceAutoSend(company), $author$project$Api$Company$invoiceAutoSendDay(company));
                                    if (_v1.a && !_v1.b.$) {
                                        var invoiceAutoSendDay = _v1.b.a;
                                        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('You will receive the invoice on the '),
                                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text($author$project$Formatters$Int$ordinal(invoiceAutoSendDay))
                                            ])),
                                            $elm$html$Html$text(' and can make changes until '),
                                            function() {
                                                var _v2 = _Utils_Tuple2($author$project$Api$Company$invoiceAutoIssue(company), $author$project$Api$Company$invoiceAutoIssueDay(company));
                                                if (_v2.a && !_v2.b.$) {
                                                    var invoiceAutoIssueDay = _v2.b.a;
                                                    return _Utils_cmp(invoiceAutoIssueDay, invoiceAutoSendDay) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                                        $elm$html$Html$text('the '),
                                                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                            $elm$html$Html$text($author$project$Formatters$Int$ordinal(invoiceAutoIssueDay))
                                                        ])),
                                                        $elm$html$Html$text('.')
                                                    ])) : $elm$html$Html$text('it gets issued by the Practice.');
                                                } else return $elm$html$Html$text('it gets issued by the Practice.');
                                            }()
                                        ]));
                                    } else return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('You will receive the invoice once it gets issued.')
                                    ]));
                                }(),
                                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Payment will be due on the '),
                                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text($author$project$Formatters$Int$ordinal($author$project$Api$Company$invoiceDueDay(company)))
                                    ])),
                                    $elm$html$Html$text(' if autopay is '),
                                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('on')
                                    ])),
                                    $elm$html$Html$text(' then it will process.')
                                ]))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Components$PaymentSources$CancelEdit = {
        $: 1
    };
    var $author$project$Components$PaymentSources$FormUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$Label = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$Update = {
        $: 18
    };
    var $author$project$Components$PaymentSources$ExpMonth = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$ExpYear = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$Zip = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$monthOptions = A2($elm$core$List$map, function(month) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(month)), $elm$core$String$fromInt(month));
    }, A2($elm$core$List$range, 1, 12));
    var $author$project$Components$PaymentSources$yearOptions = function(currentDate) {
        var fromYear = $justinmimbs$date$Date$year(currentDate);
        var toYear = fromYear + 10;
        return A2($elm$core$List$map, function(year) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(year)), $elm$core$String$fromInt(year));
        }, A2($elm$core$List$range, fromYear, toYear));
    };
    var $author$project$Components$PaymentSources$viewCardFields = F3(function(currentDate, form, cardFields) {
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Expiration Date'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, cardFields.adz)),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$ExpMonth)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                        ]), $author$project$Components$PaymentSources$monthOptions)
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, cardFields.adA)),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$ExpYear)),
                            $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                        ]), $author$project$Components$PaymentSources$yearOptions(currentDate))
                    ]))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Zip Code'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(cardFields.tK),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$Zip)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]);
    });
    var $author$project$Components$PaymentSources$viewSourceModal = F3(function(currentDate, form, updateRequest) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Payment Source',
            Tk: _Utils_eq(updateRequest, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just(''),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$PaymentSources$CancelEdit,
            Vn: $elm$core$Basics$always($author$project$Components$PaymentSources$Update)
        };
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Description')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('HSA card for incidental charges'),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.aeI)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$PaymentSources$FormUpdated, $author$project$Components$PaymentSources$Label))
            ]))
        ])), function() {
            var _v0 = fields.EH;
            if (_v0.$ === 1) return _List_Nil;
            else {
                var cardFields = _v0.a;
                return A3($author$project$Components$PaymentSources$viewCardFields, currentDate, form, cardFields);
            }
        }()));
    });
    var $author$project$Components$CreatePaymentMethodModal$Company = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CreatePaymentMethodModal$Patient = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$PaymentSources$viewSourcesActions = function(model) {
        var paymentMethodOwner = function() {
            var _v0 = model.Hg;
            if (!_v0.$) {
                var company = _v0.a;
                return $author$project$Components$CreatePaymentMethodModal$Company(company);
            } else {
                var patient = _v0.a;
                return $author$project$Components$CreatePaymentMethodModal$Patient(patient);
            }
        }();
        var openOptions = {
            vK: model.vK,
            qW: model.qW,
            F3: model.F3,
            VM: paymentMethodOwner,
            W1: model.W1,
            sp: model.sp,
            Z$: model.Z$,
            HO: model.HO,
            tD: true
        };
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg, $author$project$Components$CreatePaymentMethodModal$button(openOptions))
        ]);
    };
    var $author$project$Api$Employer$Company$One$stripeLink = function(_v0) {
        var record = _v0.b;
        return record.$j;
    };
    var $author$project$Api$Provider$Company$Shared$stripeLink = function(_v0) {
        var record = _v0;
        return record.$j;
    };
    var $author$project$Api$Provider$Company$One$stripeLink = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$stripeLink(shared);
    };
    var $author$project$Api$Company$stripeLink = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$stripeLink(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$stripeLink(company_);
        }
    };
    var $author$project$Api$Provider$Patient$One$stripeLink = function(_v0) {
        var record = _v0.b;
        return record.$j;
    };
    var $author$project$Components$PaymentSources$viewStripeLink = function(model) {
        var maybeStripeLink = function() {
            var _v2 = model.Hg;
            if (!_v2.$) {
                var company = _v2.a;
                return $author$project$Api$Company$stripeLink(company);
            } else {
                var patient = _v2.a;
                return $author$project$Api$Provider$Patient$One$stripeLink(patient);
            }
        }();
        if (!maybeStripeLink.$) {
            var stripeLink_ = maybeStripeLink.a;
            var viewOnStripeLink = A3($author$project$Ui$HinterOnly$linkHref, stripeLink_, _List_fromArray([
                $author$project$Ui$Link$targetBlank
            ]), _List_fromArray([
                $elm$html$Html$text(' View on Stripe')
            ]));
            var _v1 = model.Hg;
            if (!_v1.$) return model.F3 ? _List_fromArray([
                viewOnStripeLink
            ]) : _List_Nil;
            else return model.F3 ? _List_fromArray([
                viewOnStripeLink
            ]) : _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Ui$Element$FlexWrap = {
        $: 8
    };
    var $author$project$Ui$Element$wrap = $author$project$Ui$Element$FlexWrap;
    var $author$project$Components$PaymentSources$view = function(_v0) {
        var model = _v0;
        var _v1 = function() {
            var _v2 = _Utils_Tuple2(model.pQ, model.pF);
            _v2$2: while(true)switch(_v2.a.$){
                case 3:
                    if (_v2.b.$ === 3) {
                        var _v3 = _v2.a;
                        var cards = _v3.a;
                        var _v4 = _v2.b;
                        var bankAccounts = _v4.a;
                        return _Utils_Tuple2(false, $elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, $author$project$Api$Source$createdAt, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$time$Time$posixToMillis), $elm$core$Maybe$withDefault(0))), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Source$Card, cards), A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts)))));
                    } else break _v2$2;
                case 2:
                    if (_v2.b.$ === 2) return _Utils_Tuple2(false, _List_Nil);
                    else break _v2$2;
                default:
                    break _v2$2;
            }
            return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v1.a;
        var sources = _v1.b;
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$PaymentSources$CreatePaymentMethodModalMsg, $author$project$Components$CreatePaymentMethodModal$modal(model.lG)),
            A2($elm$html$Html$map, $author$project$Components$PaymentSources$MovePaymentMethodsModalMsg, $author$project$Components$MovePaymentMethodsModal$modal(model.gc)),
            function() {
                var _v5 = model.Hw;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var form = _v6.b;
                    var updateRequest = _v6.c;
                    return A3($author$project$Components$PaymentSources$viewSourceModal, model.cP, form, updateRequest);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v7 = model.fw;
                if (!_v7.$) {
                    var source = _v7.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$PaymentSources$HiConfirmClosed(source), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun($author$project$Api$Source$noun(source)),
                        $author$project$Components$HiConfirm$detail($author$project$Api$Source$detail(source))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$rowItemsCenter
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(5)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$wrap,
                                $author$project$Ui$Element$mb2,
                                $author$project$Ui$Element$itemsStart
                            ]), _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('Payment Methods')
                                ])),
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$wrap,
                                    $author$project$Ui$Element$mt1
                                ]), $author$project$Components$PaymentSources$viewAuditTrailLog(model))
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(7)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$gap2,
                                $author$project$Ui$Element$itemsCenter,
                                $author$project$Ui$Element$mb2,
                                $author$project$Ui$Element$justifyRight
                            ]), _Utils_ap($author$project$Components$PaymentSources$viewStripeLink(model), _Utils_ap(A2($author$project$Components$PaymentSources$viewMoreActionsDowndown, model, sources), $author$project$Components$PaymentSources$viewSourcesActions(model))))
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb4
                    ]), $author$project$Components$PaymentSources$viewExemptFromCreditCardFees(model)),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(12)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mb4
                            ]), $author$project$Components$PaymentSources$viewAutopay(model))
                        ]))
                    ])),
                    A2($author$project$Components$PaymentSources$viewNoDefaultSourceWarning, model.Hg, sources),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(12)
                        ]), _List_fromArray([
                            $author$project$Components$PaymentSources$viewPaymentTerms(model)
                        ]))
                    ])),
                    loading ? A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$repeat, 2, A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
                        $author$project$Components$PaymentSourceDisplayer$skeleton
                    ])))) : A2($author$project$Ui$ListGroup$view, _List_Nil, A2($author$project$Components$PaymentSources$viewPaymentSourcesList, model, sources)),
                    A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(virtualBankAccountsComponent_) {
                        return A2($elm$html$Html$map, $author$project$Components$PaymentSources$VirtualBankAccountsComponentMsg, $author$project$Components$VirtualBankAccounts$view(virtualBankAccountsComponent_));
                    }, model.tF))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Companies$CompanyId_String$PaymentSources$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$PaymentSources$view(model.rk)),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Payment Options'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$PaymentSources$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$PaymentSources$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$PaymentSources$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$PaymentSources$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$PaymentSources$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$PaymentSources$update,
        aid: $author$project$Pages$Companies$CompanyId_String$PaymentSources$view
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$GotSignupPages = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages = F2(function(apiClient, company) {
        return A3($author$project$Api$Provider$SignupPage$list, apiClient, function(d) {
            return _Utils_update(d, {
                fl: $elm$core$Maybe$Just($author$project$Api$Company$id(company)),
                af_: $elm$core$Maybe$Nothing
            });
        }, $author$project$Pages$Companies$CompanyId_String$Signup$GotSignupPages);
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$One$collectPaymentSourceOnSignup = function(_v0) {
        var record = _v0.b;
        return record.Lw;
    };
    var $author$project$Api$Company$collectPaymentSourceOnSignup = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Company$One$collectPaymentSourceOnSignup(company_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$One$collectPractitionerOnSignup = function(_v0) {
        var record = _v0.b;
        return record.Lx;
    };
    var $author$project$Api$Company$collectPractitionerOnSignup = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$collectPractitionerOnSignup(company_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Employer$Company$One$collectSSNOnSignup = function(_v0) {
        var record = _v0.b;
        return record.Ly;
    };
    var $author$project$Api$Provider$Company$One$collectSSNOnSignup = function(_v0) {
        var record = _v0.b;
        return record.Ly;
    };
    var $author$project$Api$Company$collectSSNOnSignup = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$collectSSNOnSignup(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$collectSSNOnSignup(company_);
        }
    };
    var $author$project$Api$Provider$Company$Shared$customPostSignupPage = function(_v0) {
        var record = _v0;
        return record.MZ;
    };
    var $author$project$Api$Provider$Company$One$customPostSignupPage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$customPostSignupPage(shared);
    };
    var $author$project$Api$Company$customPostSignupPage = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Company$One$customPostSignupPage(company_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields = function(params) {
        return $author$project$Pages$Companies$CompanyId_String$Signup$Provider({
            Lw: params.Lw,
            Lx: params.Lx,
            Ly: params.Ly,
            MZ: A2($elm$core$Maybe$withDefault, false, params.MZ),
            WZ: A2($elm$core$Maybe$withDefault, '', params.WZ),
            W_: A2($elm$core$Maybe$withDefault, '', params.W_),
            W$: A2($elm$core$Maybe$withDefault, '', params.W$),
            Yp: A2($elm$core$Maybe$withDefault, false, params.Yp),
            _j: A2($elm$core$Maybe$withDefault, false, params._j)
        });
    };
    var $author$project$Api$Provider$Company$Shared$postSignupButtonLabel = function(_v0) {
        var record = _v0;
        return record.WZ;
    };
    var $author$project$Api$Provider$Company$One$postSignupButtonLabel = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$postSignupButtonLabel(shared);
    };
    var $author$project$Api$Company$postSignupButtonLabel = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$postSignupButtonLabel(company_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$Shared$postSignupMessage = function(_v0) {
        var record = _v0;
        return record.W_;
    };
    var $author$project$Api$Provider$Company$One$postSignupMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$postSignupMessage(shared);
    };
    var $author$project$Api$Company$postSignupMessage = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$postSignupMessage(company_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$Shared$postSignupRedirectUrl = function(_v0) {
        var record = _v0;
        return record.W$;
    };
    var $author$project$Api$Provider$Company$One$postSignupRedirectUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$postSignupRedirectUrl(shared);
    };
    var $author$project$Api$Company$postSignupRedirectUrl = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$postSignupRedirectUrl(company_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$Shared$redirectsPostSignup = function(_v0) {
        var record = _v0;
        return record.Yp;
    };
    var $author$project$Api$Provider$Company$One$redirectsPostSignup = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$redirectsPostSignup(shared);
    };
    var $author$project$Api$Company$redirectsPostSignup = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Company$One$redirectsPostSignup(company_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$Shared$showPostSignupFooterButton = function(_v0) {
        var record = _v0;
        return record._j;
    };
    var $author$project$Api$Provider$Company$One$showPostSignupFooterButton = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$showPostSignupFooterButton(shared);
    };
    var $author$project$Api$Company$showPostSignupFooterButton = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Company$One$showPostSignupFooterButton(company_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromCompany = F2(function(organizationIsCompany, company) {
        return organizationIsCompany ? $author$project$Pages$Companies$CompanyId_String$Signup$Employer({
            Ly: $author$project$Api$Company$collectSSNOnSignup(company)
        }) : $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields({
            Lw: $author$project$Api$Company$collectPaymentSourceOnSignup(company),
            Lx: $author$project$Api$Company$collectPractitionerOnSignup(company),
            Ly: $author$project$Api$Company$collectSSNOnSignup(company),
            MZ: $author$project$Api$Company$customPostSignupPage(company),
            WZ: $author$project$Api$Company$postSignupButtonLabel(company),
            W_: $author$project$Api$Company$postSignupMessage(company),
            W$: $author$project$Api$Company$postSignupRedirectUrl(company),
            Yp: $author$project$Api$Company$redirectsPostSignup(company),
            _j: $author$project$Api$Company$showPostSignupFooterButton(company)
        });
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$init = F5(function(session, practice, company, shared, _v0) {
        var model = {
            Ej: shared.Ej,
            acy: company,
            acU: shared.adU.acU,
            NC: $elm$core$Maybe$Nothing,
            mH: false,
            F3: $author$project$Shared$isHintAdmin(shared),
            c4: $author$project$Utils$Form$init(A2($author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromCompany, shared.afW, company)),
            W1: practice,
            n7: $jinjor$elm_debounce$Debounce$init,
            Z$: session,
            ol: false,
            s_: _List_Nil
        };
        var fetchSignupPagesCmd = $author$project$Api$Platform$Session$One$role(session) === 'practice_admin' ? A2($author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages, shared.Ej, company) : $elm$core$Platform$Cmd$none;
        return _Utils_Tuple2(model, fetchSignupPagesCmd);
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$subscriptions = function(model) {
        return model.ol ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageUpdated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings = {
        $: 5
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$debounceSave = function(field) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings;
        }, $elm$core$Task$succeed(field));
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$employerFormFieldsUpdate = F2(function(field, fields) {
        if (fields.$ === 1) {
            var fields_ = fields.a;
            if (field.$ === 6) {
                var collectSSN = field.a;
                return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(_Utils_update(fields_, {
                    Ly: collectSSN
                }));
            } else return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(fields_);
        } else {
            var fields_ = fields.a;
            return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(fields_);
        }
    });
    var $author$project$Api$Provider$Company$SignupSetting$collectPaymentSourceOnSignup = function(_v0) {
        var record = _v0;
        return record.Lw;
    };
    var $author$project$Api$Company$SignupSetting$collectPaymentSourceOnSignup = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Company$SignupSetting$collectPaymentSourceOnSignup(signupSetting_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$SignupSetting$collectPractitionerOnSignup = function(_v0) {
        var record = _v0;
        return record.Lx;
    };
    var $author$project$Api$Company$SignupSetting$collectPractitionerOnSignup = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$SignupSetting$collectPractitionerOnSignup(signupSetting_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Employer$Company$SignupSetting$collectSSNOnSignup = function(_v0) {
        var record = _v0;
        return record.Ly;
    };
    var $author$project$Api$Provider$Company$SignupSetting$collectSSNOnSignup = function(_v0) {
        var record = _v0;
        return record.Ly;
    };
    var $author$project$Api$Company$SignupSetting$collectSSNOnSignup = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$SignupSetting$collectSSNOnSignup(signupSetting_);
        } else {
            var signupSetting_ = signupSetting.a;
            return $author$project$Api$Employer$Company$SignupSetting$collectSSNOnSignup(signupSetting_);
        }
    };
    var $author$project$Api$Provider$Company$SignupSetting$customPostSignupPage = function(_v0) {
        var record = _v0;
        return record.MZ;
    };
    var $author$project$Api$Company$SignupSetting$customPostSignupPage = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Company$SignupSetting$customPostSignupPage(signupSetting_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$SignupSetting$postSignupButtonLabel = function(_v0) {
        var record = _v0;
        return record.WZ;
    };
    var $author$project$Api$Company$SignupSetting$postSignupButtonLabel = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$SignupSetting$postSignupButtonLabel(signupSetting_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$SignupSetting$postSignupMessage = function(_v0) {
        var record = _v0;
        return record.W_;
    };
    var $author$project$Api$Company$SignupSetting$postSignupMessage = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$SignupSetting$postSignupMessage(signupSetting_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$SignupSetting$postSignupRedirectUrl = function(_v0) {
        var record = _v0;
        return record.W$;
    };
    var $author$project$Api$Company$SignupSetting$postSignupRedirectUrl = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$SignupSetting$postSignupRedirectUrl(signupSetting_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$SignupSetting$redirectsPostSignup = function(_v0) {
        var record = _v0;
        return record.Yp;
    };
    var $author$project$Api$Company$SignupSetting$redirectsPostSignup = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Company$SignupSetting$redirectsPostSignup(signupSetting_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Company$SignupSetting$showPostSignupFooterButton = function(_v0) {
        var record = _v0;
        return record._j;
    };
    var $author$project$Api$Company$SignupSetting$showPostSignupFooterButton = function(signupSetting) {
        if (!signupSetting.$) {
            var signupSetting_ = signupSetting.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Company$SignupSetting$showPostSignupFooterButton(signupSetting_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromSignupSetting = F2(function(organizationIsCompany, signupSetting) {
        return organizationIsCompany ? $author$project$Pages$Companies$CompanyId_String$Signup$Employer({
            Ly: $author$project$Api$Company$SignupSetting$collectSSNOnSignup(signupSetting)
        }) : $author$project$Pages$Companies$CompanyId_String$Signup$initProviderFields({
            Lw: $author$project$Api$Company$SignupSetting$collectPaymentSourceOnSignup(signupSetting),
            Lx: $author$project$Api$Company$SignupSetting$collectPractitionerOnSignup(signupSetting),
            Ly: $author$project$Api$Company$SignupSetting$collectSSNOnSignup(signupSetting),
            MZ: $author$project$Api$Company$SignupSetting$customPostSignupPage(signupSetting),
            WZ: $author$project$Api$Company$SignupSetting$postSignupButtonLabel(signupSetting),
            W_: $author$project$Api$Company$SignupSetting$postSignupMessage(signupSetting),
            W$: $author$project$Api$Company$SignupSetting$postSignupRedirectUrl(signupSetting),
            Yp: $author$project$Api$Company$SignupSetting$redirectsPostSignup(signupSetting),
            _j: $author$project$Api$Company$SignupSetting$showPostSignupFooterButton(signupSetting)
        });
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate = F2(function(field, fields) {
        if (!fields.$) {
            var fields_ = fields.a;
            switch(field.$){
                case 0:
                    var bool = field.a;
                    return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(_Utils_update(fields_, {
                        MZ: bool
                    }));
                case 1:
                    var bool = field.a;
                    return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(_Utils_update(fields_, {
                        Yp: bool
                    }));
                case 2:
                    var bool = field.a;
                    return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(_Utils_update(fields_, {
                        _j: bool
                    }));
                case 3:
                    var string = field.a;
                    return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(_Utils_update(fields_, {
                        W_: string
                    }));
                case 4:
                    var string = field.a;
                    return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(_Utils_update(fields_, {
                        WZ: string
                    }));
                case 5:
                    var string = field.a;
                    return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(_Utils_update(fields_, {
                        W$: string
                    }));
                case 6:
                    var collectSSN = field.a;
                    return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(_Utils_update(fields_, {
                        Ly: collectSSN
                    }));
                default:
                    var collectPractitioner = field.a;
                    return $author$project$Pages$Companies$CompanyId_String$Signup$Provider(_Utils_update(fields_, {
                        Lx: collectPractitioner
                    }));
            }
        } else {
            var fields_ = fields.a;
            return $author$project$Pages$Companies$CompanyId_String$Signup$Employer(fields_);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$debounceSaveForField = function(field) {
        switch(field.$){
            case 0:
                return false;
            case 1:
                return false;
            case 2:
                return false;
            case 3:
                return true;
            case 4:
                return true;
            case 5:
                return true;
            case 6:
                return false;
            default:
                return false;
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$SaveDebounceMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Pages$Companies$CompanyId_String$Signup$SaveDebounceMsg
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$SignupSettingUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Utils$String$encode = function(str) {
        return $author$project$Utils$String$isBlank(str) ? $elm$json$Json$Encode$null : $elm$json$Json$Encode$string($elm$core$String$trim(str));
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$encodeForm = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        if (!fields.$) {
            var fields_ = fields.a;
            return _List_fromArray([
                _Utils_Tuple2('custom_post_signup_page', $elm$json$Json$Encode$bool(fields_.MZ)),
                _Utils_Tuple2('redirects_post_signup', $elm$json$Json$Encode$bool(fields_.Yp)),
                _Utils_Tuple2('show_post_signup_footer_button', $elm$json$Json$Encode$bool(fields_._j)),
                _Utils_Tuple2('post_signup_message', $author$project$Utils$String$encode(fields_.W_)),
                _Utils_Tuple2('post_signup_button_label', $author$project$Utils$String$encode(fields_.WZ)),
                _Utils_Tuple2('post_signup_redirect_url', $author$project$Utils$String$encode(fields_.W$)),
                _Utils_Tuple2('collect_practitioner_on_signup', $author$project$Api$CollectOnSignup$encoderMaybe(fields_.Lx)),
                _Utils_Tuple2('collect_ssn_on_signup', $author$project$Api$CollectOnSignup$encoderMaybe(fields_.Ly)),
                _Utils_Tuple2('collect_payment_source_on_signup', $author$project$Api$CollectOnSignup$encoderMaybe(fields_.Lw))
            ]);
        } else {
            var fields_ = fields.a;
            return _List_fromArray([
                _Utils_Tuple2('collect_ssn_on_signup', $author$project$Api$CollectOnSignup$encoderMaybe(fields_.Ly))
            ]);
        }
    };
    var $author$project$Api$Company$SignupSetting$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Company$SignupSetting$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Company$SignupSetting$SignupSetting = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Company$SignupSetting$Record = function(collectSSNOnSignup) {
        return {
            Ly: collectSSNOnSignup
        };
    };
    var $author$project$Api$Employer$Company$SignupSetting$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_ssn_on_signup', $elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$SignupSetting$Record));
    var $author$project$Api$Employer$Company$SignupSetting$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Company$SignupSetting$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Company$SignupSetting$path = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'signup_settings'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Company$SignupSetting$update = F3(function(apiClient, params, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Employer$Company$SignupSetting$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, params, $author$project$Api$Data$requestTo($author$project$Api$Employer$Company$SignupSetting$path)));
    });
    var $author$project$Api$Provider$Company$SignupSetting$SignupSetting = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Company$SignupSetting$Record = F9(function(collectSSNOnSignup, collectPractitionerOnSignup, postSignupButtonLabel, postSignupMessage, postSignupRedirectUrl, redirectsPostSignup, showPostSignupFooterButton, customPostSignupPage, collectPaymentSourceOnSignup) {
        return {
            Lw: collectPaymentSourceOnSignup,
            Lx: collectPractitionerOnSignup,
            Ly: collectSSNOnSignup,
            MZ: customPostSignupPage,
            WZ: postSignupButtonLabel,
            W_: postSignupMessage,
            W$: postSignupRedirectUrl,
            Yp: redirectsPostSignup,
            _j: showPostSignupFooterButton
        };
    });
    var $author$project$Api$Provider$Company$SignupSetting$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_payment_source_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'custom_post_signup_page', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'show_post_signup_footer_button', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redirects_post_signup', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_redirect_url', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_message', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'post_signup_button_label', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_practitioner_on_signup', $elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_ssn_on_signup', $elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$SignupSetting$Record))))))))));
    var $author$project$Api$Provider$Company$SignupSetting$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Company$SignupSetting$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$SignupSetting$path = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signup_settings'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$SignupSetting$update = F4(function(apiClient, companyId, params, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$SignupSetting$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, params, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$SignupSetting$path(companyId))));
    });
    var $author$project$Api$Company$SignupSetting$update = F5(function(apiClient, session, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('signup_settings', $elm$json$Json$Encode$object(params))
        ]));
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Company$SignupSetting$update, apiClient, body, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$SignupSetting$Employer))) : A4($author$project$Api$Provider$Company$SignupSetting$update, apiClient, id, body, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$SignupSetting$Provider)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty = function(model) {
        return model.mH ? A5($author$project$Api$Company$SignupSetting$update, model.Ej, model.Z$, $author$project$Api$Company$id(model.acy), $author$project$Pages$Companies$CompanyId_String$Signup$encodeForm(model.c4), $author$project$Pages$Companies$CompanyId_String$Signup$SignupSettingUpdated) : $elm$core$Platform$Cmd$none;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$saveChanges = F3(function(field, model, updater) {
        var newModel = _Utils_update(model, {
            mH: true,
            c4: A3($author$project$Utils$Form$update, updater, field, model.c4)
        });
        if ($author$project$Pages$Companies$CompanyId_String$Signup$debounceSaveForField(field)) {
            var _v0 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig, field, newModel.n7);
            var debounceModel = _v0.a;
            var debounceCmd = _v0.b;
            return _Utils_Tuple2(_Utils_update(newModel, {
                n7: debounceModel
            }), debounceCmd);
        } else return _Utils_Tuple2(newModel, $author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty(newModel));
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$update = F2(function(msg, model) {
        switch(msg.$){
            case 8:
                var dataSignupPages = msg.a;
                if (dataSignupPages.$ === 3) {
                    var signupPages = dataSignupPages.a;
                    var defaultSignupPage = $elm$core$List$head(A2($elm$core$List$filter, function(page_) {
                        return $author$project$Api$Provider$SignupPage$All$default(page_);
                    }, signupPages));
                    return _Utils_Tuple3(_Utils_update(model, {
                        NC: defaultSignupPage,
                        s_: signupPages
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    s_: _List_Nil
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataSignupPages));
            case 0:
                var field = msg.a;
                if (!field.$ && !field.a) return _Utils_Tuple3(_Utils_update(model, {
                    ol: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    var _v3 = A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, field, model, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate);
                    var newModel = _v3.a;
                    var debounceCmd = _v3.b;
                    return _Utils_Tuple3(newModel, debounceCmd, _List_Nil);
                }
            case 1:
                var field = msg.a;
                var _v4 = A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, field, model, $author$project$Pages$Companies$CompanyId_String$Signup$employerFormFieldsUpdate);
                var newModel = _v4.a;
                var debounceCmd = _v4.b;
                return _Utils_Tuple3(newModel, debounceCmd, _List_Nil);
            case 2:
                var value = msg.a;
                var newField = $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage(!value);
                var _v5 = value ? A3($author$project$Pages$Companies$CompanyId_String$Signup$saveChanges, newField, model, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate) : _Utils_Tuple2(_Utils_update(model, {
                    mH: false,
                    c4: A3($author$project$Utils$Form$update, $author$project$Pages$Companies$CompanyId_String$Signup$providerFormFieldsUpdate, newField, model.c4)
                }), $elm$core$Platform$Cmd$none);
                var newModel = _v5.a;
                var debounceCmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    ol: false
                }), debounceCmd, _List_Nil);
            case 3:
                var signupSettingData = msg.a;
                if (signupSettingData.$ === 3) {
                    var signupSetting = signupSettingData.a;
                    var fields = $author$project$Utils$Form$fields(model.c4);
                    var isEmployer = function() {
                        if (fields.$ === 1) return true;
                        else return false;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        mH: false,
                        c4: $author$project$Utils$Form$init(A2($author$project$Pages$Companies$CompanyId_String$Signup$formFieldsInitFromSignupSetting, isEmployer, signupSetting))
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(signupSettingData));
            case 4:
                var debounceMsg = msg.a;
                var _v8 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Pages$Companies$CompanyId_String$Signup$saveDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Pages$Companies$CompanyId_String$Signup$debounceSave), debounceMsg, model.n7);
                var newDebouncer = _v8.a;
                var debounceCmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    n7: newDebouncer
                }), debounceCmd, _List_Nil);
            case 5:
                return _Utils_Tuple3(model, $author$project$Pages$Companies$CompanyId_String$Signup$saveIfDirty(model), _List_Nil);
            case 6:
                var url = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(url), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
                ]));
            case 7:
                var id = msg.a;
                var selectedPage = A2($elm_community$list_extra$List$Extra$find, function(signupPage_) {
                    return _Utils_eq(id, $author$project$Api$Provider$SignupPage$All$id(signupPage_));
                }, model.s_);
                return _Utils_Tuple3(_Utils_update(model, {
                    NC: selectedPage
                }), A3($author$project$Api$Provider$SignupPage$makeDefault, model.Ej, id, $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageUpdated), _List_Nil);
            default:
                var signupPageData = msg.a;
                if (signupPageData.$ === 3) return _Utils_Tuple3(model, A2($author$project$Pages$Companies$CompanyId_String$Signup$fetchSignupPages, model.Ej, model.acy), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Company\'s default signup page was updated')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(signupPageData));
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$EmployerFormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$CollectSSNOnSignup = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Employer$Practice$One$collectSSNOnSignup = function(_v0) {
        var record = _v0;
        return record.Ly;
    };
    var $author$project$Api$Practice$collectSSNOnSignup = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$collectSSNOnSignup(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$collectSSNOnSignup(practice_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton = F5(function(currentCollectOnSignup, selectedCollectOnSignup, toMsg, toFieldMsg, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentCollectOnSignup, selectedCollectOnSignup)),
            $author$project$Ui$Button$onClick(toMsg(toFieldMsg(selectedCollectOnSignup)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup = F7(function(collectOnSignup, label, labelHelp, viewPracticeDefault, childrenContent, toMsg, toFieldMsg) {
        var extraCollectOption = viewPracticeDefault ? _List_fromArray([
            A5($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton, collectOnSignup, $elm$core$Maybe$Nothing, toMsg, toFieldMsg, 'Practice Default')
        ]) : _List_Nil;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(label),
                $author$project$Ui$Form$Group$labelHelp(labelHelp),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$labelClass(''),
                $author$project$Ui$Form$Group$clearfix
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    $author$project$Ui$Button$group(A2($elm$core$List$cons, A5($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton, collectOnSignup, $elm$core$Maybe$Just(0), toMsg, toFieldMsg, 'No'), A2($elm$core$List$cons, A5($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton, collectOnSignup, $elm$core$Maybe$Just(1), toMsg, toFieldMsg, 'Optional'), A2($elm$core$List$cons, A5($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignupButton, collectOnSignup, $elm$core$Maybe$Just(2), toMsg, toFieldMsg, 'Require'), extraCollectOption))))
                ]))
            ])), childrenContent))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN = F3(function(collectSSNOnSignup, practice, toMsg) {
        var labelHelpText = function() {
            if (!collectSSNOnSignup.$) switch(collectSSNOnSignup.a){
                case 0:
                    var _v1 = collectSSNOnSignup.a;
                    return 'SSN will not be collected.';
                case 1:
                    var _v2 = collectSSNOnSignup.a;
                    return 'SSN are optional and can be left blank.';
                case 2:
                    var _v3 = collectSSNOnSignup.a;
                    return 'A SSN is required for each member. This will prevent people without SSNs from signing up.';
                case 3:
                    var _v4 = collectSSNOnSignup.a;
                    return '';
                default:
                    var _v5 = collectSSNOnSignup.a;
                    return '';
            }
            else return 'Will use the practice setting. Currently set to \'' + ($author$project$Api$CollectOnSignup$label($author$project$Api$Practice$collectSSNOnSignup(practice)) + '\'');
        }();
        return A7($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup, collectSSNOnSignup, 'Collect SSN', $elm$html$Html$text(labelHelpText), true, _List_Nil, toMsg, $author$project$Pages$Companies$CompanyId_String$Signup$CollectSSNOnSignup);
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$Copy = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Employer$Company$One$employeeSignupUrl = function(_v0) {
        var record = _v0.b;
        return record.OL;
    };
    var $author$project$Api$Provider$Company$One$employeeSignupUrl = function(_v0) {
        var record = _v0.b;
        return record.OL;
    };
    var $author$project$Api$Company$employeeSignupUrl = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$employeeSignupUrl(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$employeeSignupUrl(company_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl = function(company) {
        var url = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Company$employeeSignupUrl(company));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Global Employee Sign-Up Link'),
                    $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Leads to the default sign-up page.')),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix,
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpan(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$group(_List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(url),
                            $author$project$Ui$Form$Input$disabled(true)
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy link to clipboard'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Signup$Copy(url))
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$copy(_List_Nil),
                            $elm$html$Html$text(' Copy Link')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Ui$Tooltip$Right = 3;
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewTitle = A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(6)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Employee Sign-Up Settings')
                ])),
                A3($author$project$Ui$Tooltip$view, _List_fromArray([
                    $author$project$Ui$Tooltip$placement(3)
                ]), 'Click to Learn More', _List_fromArray([
                    A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/employers/employer-account-setup', _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$help(_List_Nil)
                    ]))
                ]))
            ]))
        ]))
    ]));
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewEmployerForm = F3(function(employerFormFields, company, practice) {
        return _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Pages$Companies$CompanyId_String$Signup$viewTitle
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                $author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl(company),
                A3($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN, employerFormFields.Ly, practice, $author$project$Pages$Companies$CompanyId_String$Signup$EmployerFormUpdated)
            ]))
        ]);
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$CollectPractitionerOnSignup = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Practice$collectPractitionerOnSignup = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$collectPractitionerOnSignup(practice_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCollectPractitioner = F2(function(collectPractitionerOnSignup, practice) {
        var labelHelpText = function() {
            if (!collectPractitionerOnSignup.$) switch(collectPractitionerOnSignup.a){
                case 0:
                    var _v1 = collectPractitionerOnSignup.a;
                    return 'Providers will not be collected.';
                case 1:
                    var _v2 = collectPractitionerOnSignup.a;
                    return 'Providers are optional and can be left blank.';
                case 2:
                    var _v3 = collectPractitionerOnSignup.a;
                    return 'A provider is required for each member.';
                case 3:
                    var _v4 = collectPractitionerOnSignup.a;
                    return '';
                default:
                    var _v5 = collectPractitionerOnSignup.a;
                    return '';
            }
            else {
                var _v6 = $author$project$Api$Practice$collectPractitionerOnSignup(practice);
                if (!_v6.$) {
                    var collectPractitioner = _v6.a;
                    return 'Will use the practice setting. Currently set to \'' + ($author$project$Api$CollectOnSignup$label(collectPractitioner) + '\'');
                } else return 'Will use the practice setting.';
            }
        }();
        return A7($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectOnSignup, collectPractitionerOnSignup, 'Collect Provider', $elm$html$Html$text(labelHelpText), true, _List_Nil, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$CollectPractitionerOnSignup);
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewConfirmModal = function(showConfirmModal) {
        return showConfirmModal ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Companies$CompanyId_String$Signup$ConfirmModalClosed, _List_fromArray([
            $author$project$Components$HiConfirm$verb('clear'),
            $author$project$Components$HiConfirm$noun('company settings'),
            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                $elm$html$Html$text('Confirmation page settings specific to this company will be reverted to the practice defaults. This action cannot be undone.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$RedirectsPostSignup = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle = F3(function(label, labelHelp, toggleSwitch) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(label),
                    $author$project$Ui$Form$Group$labelHelp(labelHelp),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix,
                    $author$project$Ui$Form$Group$labelSpan(8),
                    $author$project$Ui$Form$Group$inputSpan(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        toggleSwitch
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewAutoRedirectToggle = function(redirectsPostSignup) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(redirectsPostSignup),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$RedirectsPostSignup))
        ]));
        return A3($author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle, 'Auto Redirect to External Site', $elm$html$Html$text(''), toggleSwitch);
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupButtonLabel = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonText = F4(function(postSignupButtonLabel, redirectsPostSignup, showPostSignupFooterButton, practice) {
        if (!redirectsPostSignup && showPostSignupFooterButton) {
            var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If left blank, button will read Go to ' + ($author$project$Api$Practice$name(practice) + ' Website (under '))
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Signup, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Online Signup')
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(').')
                ]))
            ]));
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(11),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Custom Button Text'),
                        $author$project$Ui$Form$Group$labelHelp(labelHelp),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$clearfix,
                        $author$project$Ui$Form$Group$labelSpanSm(5),
                        $author$project$Ui$Form$Group$inputSpanSm(7)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(postSignupButtonLabel),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupButtonLabel)),
                            $author$project$Ui$Form$Input$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupRedirectUrl = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Practice$url = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$url(practice_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonUrl = F4(function(postSignupRedirectUrl, redirectsPostSignup, showPostSignupFooterButton, practice) {
        if (!redirectsPostSignup && !showPostSignupFooterButton) return $author$project$Utils$Html$empty;
        else {
            var title = redirectsPostSignup ? 'Redirect URL' : 'Custom Button URL';
            var labelHelp = redirectsPostSignup ? $elm$html$Html$text('') : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If left blank, clicking the button will redirect to your practice website (under ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Practice, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Account')
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(').')
                ]))
            ]));
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(11),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label(title),
                        $author$project$Ui$Form$Group$labelHelp(labelHelp),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$clearfix,
                        $author$project$Ui$Form$Group$labelSpanSm(5),
                        $author$project$Ui$Form$Group$inputSpanSm(7)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(postSignupRedirectUrl),
                            $author$project$Ui$Form$Input$placeholder(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Practice$url(practice))),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupRedirectUrl)),
                            $author$project$Ui$Form$Input$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
                        ]))
                    ]))
                ]))
            ]));
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupMessage = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomMessage = F2(function(customMessage, redirectsPostSignup) {
        return redirectsPostSignup ? $author$project$Utils$Html$empty : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Custom Message'),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix,
                    $author$project$Ui$Form$Group$labelSpanSm(5),
                    $author$project$Ui$Form$Group$inputSpanSm(7)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Textarea$view(_List_fromArray([
                        $author$project$Ui$Form$Textarea$placeholder('Add your custom message here.'),
                        $author$project$Ui$Form$Textarea$value(customMessage),
                        $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$PostSignupMessage)),
                        $author$project$Ui$Form$Textarea$onBlur($author$project$Pages$Companies$CompanyId_String$Signup$SaveSettings)
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$ShowPostSignupFooterButton = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewPostSignupButtonToggle = F2(function(showPostSignupFooterButton, redirectsPostSignup) {
        if (redirectsPostSignup) return $author$project$Utils$Html$empty;
        else {
            var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(showPostSignupFooterButton),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$ShowPostSignupFooterButton))
            ]));
            var labelHelpText = showPostSignupFooterButton ? 'A button is displayed that can be configured below with a custom text and URL.' : 'No button will be shown, and employee should be instructed to close their current signup tab.';
            var labelHelp = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text(labelHelpText)
            ]));
            return A3($author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle, 'Show Redirect Button on Confirmation', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupFields = F2(function(providerFormFields, practice) {
        return providerFormFields.MZ ? _List_fromArray([
            $author$project$Pages$Companies$CompanyId_String$Signup$viewAutoRedirectToggle(providerFormFields.Yp),
            A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomMessage, providerFormFields.W_, providerFormFields.Yp),
            A2($author$project$Pages$Companies$CompanyId_String$Signup$viewPostSignupButtonToggle, providerFormFields._j, providerFormFields.Yp),
            A4($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonText, providerFormFields.WZ, providerFormFields.Yp, providerFormFields._j, practice),
            A4($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomButtonUrl, providerFormFields.W$, providerFormFields.Yp, providerFormFields._j, practice)
        ]) : _List_Nil;
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupToggle = function(customPostSignupPage) {
        var toggleSwitch = $author$project$Ui$ToggleSwitch$view(_List_fromArray([
            $author$project$Ui$ToggleSwitch$on(customPostSignupPage),
            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated, $author$project$Pages$Companies$CompanyId_String$Signup$CustomPostSignupPage))
        ]));
        var labelHelp = customPostSignupPage ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Employee will be redirected or see a confirmation page specific to this company')
        ])) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Employee will be redirected or see the default confirmation page based on the '),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Signup, _List_Nil, _List_fromArray([
                $elm$html$Html$text('global practice settings')
            ]))
        ]));
        return A3($author$project$Pages$Companies$CompanyId_String$Signup$viewSettingToggle, 'Custom Confirmation Page after Signup', A2($elm$html$Html$map, $elm$core$Basics$never, labelHelp), toggleSwitch);
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewProviderForm = F3(function(showConfirmModal, providerFormFields, practice) {
        return _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Pages$Companies$CompanyId_String$Signup$viewTitle
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, $author$project$Pages$Companies$CompanyId_String$Signup$viewConfirmModal(showConfirmModal), A2($elm$core$List$cons, A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectPractitioner, providerFormFields.Lx, practice), A2($elm$core$List$cons, A3($author$project$Pages$Companies$CompanyId_String$Signup$viewCollectSSN, providerFormFields.Ly, practice, $author$project$Pages$Companies$CompanyId_String$Signup$ProviderFormUpdated), A2($elm$core$List$cons, $author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupToggle(providerFormFields.MZ), A2($author$project$Pages$Companies$CompanyId_String$Signup$viewCustomPostSignupFields, providerFormFields, practice))))))
        ]);
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$SignupPageSelectMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewDefaultSignupPage = function(model) {
        var _v0 = model.NC;
        if (!_v0.$) {
            var signupPage = _v0.a;
            var signupPageItems = A2($elm$core$List$map, function(signupPage_) {
                return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$SignupPage$All$id(signupPage_)), $author$project$Api$Provider$SignupPage$All$displayName(signupPage_));
            }, model.s_);
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(11),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Default Sign-Up Page'),
                        $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('This is the page that will open when the global link is clicked by an employee.')),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$labelClass(''),
                        $author$project$Ui$Form$Group$clearfix
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$SignupPage$All$id(signupPage))),
                            $author$project$Ui$Form$Select$onChange($author$project$Pages$Companies$CompanyId_String$Signup$SignupPageSelectMsg)
                        ]), signupPageItems)
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewNewSignupPageButton = function(company) {
        return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New({
            fl: $author$project$Api$Company$id(company)
        }), _List_fromArray([
            $author$project$Ui$Link$buttonDefault,
            $author$project$Ui$Link$pull(0),
            $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
        ]), _List_fromArray([
            $elm$html$Html$text('New Page')
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPage = F2(function(model, item) {
        var status = $author$project$Api$Practice$hasPaymentProcessorAccount(model.W1) && $author$project$Api$Provider$SignupPage$All$active(item) ? 'live' : 'inactive';
        var signupPageId = $author$project$Api$Provider$SignupPage$All$id(item);
        var companyId = $author$project$Api$Company$id(model.acy);
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                            $author$project$Api$Provider$SignupPage$All$type_(item) === 'checkout' ? $author$project$Ui$Icon$cart(_List_Nil) : $author$project$Ui$Icon$onlineSignup(_List_Nil)
                        ])),
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$SignupPage$All$displayName(item))
                        ])),
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, status)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$justifyRight,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy link to clipboard'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$size(0),
                            $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Signup$Copy($author$project$Api$Provider$SignupPage$All$url(item)))
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$copy(_List_Nil),
                            $author$project$Utils$Html$noBreakSpace,
                            $elm$html$Html$text('Copy Link')
                        ])),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String({
                            fl: companyId,
                            aef: signupPageId
                        }), _List_fromArray([
                            $author$project$Ui$Link$sm,
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Edit')
                        ])),
                        $author$project$Api$Provider$SignupPage$All$isDestroyable(item) ? A3($author$project$Ui$Button$view, {
                            abP: 'Delete signup page'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$size(0),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Delete')
                        ])) : $author$project$Utils$Html$empty,
                        $author$project$Api$Provider$SignupPage$All$default(item) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'default') : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPages = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Sign-Up Pages'),
                    $author$project$Ui$Form$Group$labelHelp($elm$html$Html$text('Custom sign-up pages for plans and checkout items.')),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$labelClass(''),
                    $author$project$Ui$Form$Group$clearfix
                ]), _List_fromArray([
                    A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPage(model), model.s_)),
                    $author$project$Pages$Companies$CompanyId_String$Signup$viewNewSignupPageButton(model.acy)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesTitle = $author$project$Ui$Typography$headingSm(_List_fromArray([
        $elm$html$Html$text('Employee Sign-Up Pages')
    ]));
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesSection = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesTitle
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                $author$project$Pages$Companies$CompanyId_String$Signup$viewEmployeeSignupUrl(model.acy),
                $author$project$Pages$Companies$CompanyId_String$Signup$viewDefaultSignupPage(model),
                $author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPages(model)
            ]))
        ]);
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewSections = function(model) {
        var fields = $author$project$Utils$Form$fields(model.c4);
        if (!fields.$) {
            var providerFormFields = fields.a;
            return _Utils_ap($author$project$Pages$Companies$CompanyId_String$Signup$viewSignupPagesSection(model), A3($author$project$Pages$Companies$CompanyId_String$Signup$viewProviderForm, model.ol, providerFormFields, model.W1));
        } else {
            var employerFormFields = fields.a;
            return A3($author$project$Pages$Companies$CompanyId_String$Signup$viewEmployerForm, employerFormFields, model.acy, model.W1);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$viewBody = function(model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, $author$project$Pages$Companies$CompanyId_String$Signup$viewSections(model));
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Companies$CompanyId_String$Signup$viewBody(model)
            ]),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Online Signup'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Signup$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Signup$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Signup$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Signup$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Signup$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Signup$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Signup$view
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$FormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$init = F5(function(session, practice, _v0, shared, _v1) {
        var params = _v1.VU;
        var id = params.aef;
        var companyId = params.fl;
        var _v2 = A6($author$project$Components$Admin$SignupPages$Form$init, shared.Ej, session, practice, $elm$core$Maybe$Just(id), $elm$core$Maybe$Just(companyId), $elm$core$Maybe$Nothing);
        var form = _v2.a;
        var formCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            fl: companyId,
            acU: shared.adU.acU,
            PU: form,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            Z$: session
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var formCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd), outMsgs);
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$SignupPages$Form$view(model.PU))
            ]),
            $2: A2($author$project$Formatters$String$sponsorize, model.W1, 'Companies') + ' | Online Signup'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$page = $author$project$Spa$Page$applicationCompany({
        aeq: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$update,
        aid: $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$view
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$FormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$init = F5(function(session, practice, _v0, shared, _v1) {
        var params = _v1.VU;
        var companyId = params.fl;
        var _v2 = A6($author$project$Components$Admin$SignupPages$Form$init, shared.Ej, session, practice, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(companyId), $elm$core$Maybe$Nothing);
        var form = _v2.a;
        var formCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            fl: companyId,
            acU: shared.adU.acU,
            PU: form,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            Z$: session
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd));
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$SignupPages$Form$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var formCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, formCmd), outMsgs);
    });
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$SignupPages$Form$view(model.PU))
            ]),
            $2: A2($author$project$Formatters$String$sponsorize, model.W1, 'Companies') + ' | Online Signup'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$SignupPages$New$page = $author$project$Spa$Page$applicationCompany({
        aeq: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$update,
        aid: $author$project$Pages$Companies$CompanyId_String$SignupPages$New$view
    });
    var $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$GotCompany = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Company$Admins$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$Admins$formFieldsInit = {
        OH: ''
    };
    var $author$project$Components$Company$Admins$GotCompanyAdmins = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyAdmin$companyAdminsPath = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'admins'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            companyId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'companies'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$CompanyAdmin$All$CompanyAdmin = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyAdmin$One$CompanyAdmin = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyAdmin$Shared$CompanyAdmin = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CompanyAdmin$Shared$Record = F5(function(id, email, invitationPending, isDestroyable, user) {
        return {
            OH: email,
            aef: id,
            Ry: invitationPending,
            R1: isDestroyable,
            aaX: user
        };
    });
    var $author$project$Api$Provider$CompanyAdmin$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'user', $elm$json$Json$Decode$nullable($author$project$Api$Provider$User$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_pending', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$Shared$Record))))));
    var $author$project$Api$Provider$CompanyAdmin$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAdmin$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyAdmin$One$Record = function(invitationUrl) {
        return {
            Rz: invitationUrl
        };
    };
    var $author$project$Api$Provider$CompanyAdmin$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$One$Record));
    var $author$project$Api$Provider$CompanyAdmin$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAdmin$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAdmin$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CompanyAdmin$One$CompanyAdmin)));
    var $author$project$Api$Provider$CompanyAdmin$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CompanyAdmin$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CompanyAdmin$list = F3(function(apiClient, companyId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CompanyAdmin$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId)));
    });
    var $author$project$Components$Company$Admins$listCompanyAdmins = F2(function(apiClient, company) {
        return A3($author$project$Api$Provider$CompanyAdmin$list, apiClient, $author$project$Api$Provider$Company$One$id(company), $author$project$Components$Company$Admins$GotCompanyAdmins);
    });
    var $author$project$Components$Company$Admins$init = F3(function(apiClient, company, practice) {
        return _Utils_Tuple2({
            dv: false,
            bo: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit),
            pq: $author$project$Api$Data$Loading,
            acy: company,
            W1: practice,
            Xv: false
        }, A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, company));
    });
    var $author$project$Components$Company$CommissionDeals$GotBrokerDeals = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$CommissionDeals$fetchBrokerDeals = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$BrokerDeal$list, apiClient, function(d) {
            return _Utils_update(d, {
                acy: $elm$core$Maybe$Just($author$project$Api$Provider$Company$One$id(model.acy)),
                af_: model.af_
            });
        }, $author$project$Components$Company$CommissionDeals$GotBrokerDeals);
    });
    var $author$project$Components$Company$CommissionDeals$init = F6(function(session, company, practice, apiClient, currentDate, timeZone) {
        var model = {
            Kq: $author$project$Api$Data$Loading,
            dy: A3($author$project$Components$BrokerDeal$Table$init, session, currentDate, {
                l8: false,
                qL: false,
                qM: true
            }),
            acy: company,
            h$: $elm$core$Maybe$Nothing,
            cP: currentDate,
            af_: $author$project$Api$Pagination$init,
            W1: practice,
            Z$: session,
            HP: timeZone
        };
        return _Utils_Tuple2(model, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
    });
    var $author$project$Components$Company$ContactForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$ContactForm$AddressInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$ContactForm$initPhoneInput = function(phones) {
        return A3($author$project$Components$PhoneInput$init, 'company-phone-input', A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones), function(d) {
            return _Utils_update(d, {
                ac_: $author$project$Api$Common$Phone$Shared$Office
            });
        });
    };
    var $author$project$Components$Company$ContactForm$initFormFields = function(company) {
        var _v0 = A2($author$project$Components$AddressInput$initFromApi, 'company', $author$project$Api$Company$address(company));
        var addressInput = _v0.a;
        var addressInputCmd = _v0.b;
        var fields = {
            II: addressInput,
            zr: $author$project$Api$Company$name(company),
            WE: $author$project$Components$Company$ContactForm$initPhoneInput($author$project$Api$Company$phones(company))
        };
        return _Utils_Tuple2(fields, A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$AddressInputMsg, addressInputCmd));
    };
    var $author$project$Components$Company$ContactForm$init = F3(function(company, practice, session) {
        var _v0 = $author$project$Components$Company$ContactForm$initFormFields(company);
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            acy: company,
            PU: $author$project$Utils$Form$init(formFields),
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session
        }, formFieldsCmd);
    });
    var $author$project$Api$Provider$Company$Shared$inactive = function(_v0) {
        var record = _v0;
        return record.Q8;
    };
    var $author$project$Api$Provider$Company$One$isInactive = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$inactive(shared);
    };
    var $author$project$Api$Provider$Company$One$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Components$Company$DeactivateSponsor$init = F2(function(company, practice) {
        var status = $author$project$Api$Provider$Company$One$status(company);
        var inactive = $author$project$Api$Provider$Company$One$isInactive(company);
        var archived = status === 'archived';
        return _Utils_Tuple2({
            JC: archived,
            acy: company,
            iN: false,
            Q8: inactive,
            W1: practice,
            Xv: false,
            j_: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Company$EmployeeDivisions$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$EmployeeDivisions$initFormFields = function() {
        var fields = {
            zr: ''
        };
        return _Utils_Tuple2(fields, $elm$core$Platform$Cmd$none);
    }();
    var $author$project$Api$EmployeeDivision$Count = 0;
    var $author$project$Components$Company$EmployeeDivisions$GotEmployeeDivisions = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions = F3(function(apiClient, session, company) {
        return A5($author$project$Api$EmployeeDivision$list, apiClient, session, $author$project$Api$Company$id(company), function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ])
            });
        }, $author$project$Components$Company$EmployeeDivisions$GotEmployeeDivisions);
    });
    var $author$project$Components$Company$EmployeeDivisions$init = F4(function(apiClient, company, practice, session) {
        var usesDivisions = $author$project$Api$Company$usesEmployeeDivisions(company);
        var requireDivisions = $author$project$Api$Company$requiresEmployeeDivisions(company);
        var _v0 = $author$project$Components$Company$EmployeeDivisions$initFormFields;
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            acy: company,
            xv: $author$project$Api$Data$Loading,
            PU: $author$project$Utils$Form$init(formFields),
            W1: practice,
            YH: requireDivisions,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            aa0: usesDivisions
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            formFieldsCmd,
            usesDivisions ? A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, session, company) : $elm$core$Platform$Cmd$none
        ])));
    });
    var $author$project$Components$Company$Enrollment$GotNotificationSetting = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$Model = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Company$One$backBillPeriods = function(_v0) {
        var record = _v0.b;
        return record.J3;
    };
    var $author$project$Api$Provider$Company$Shared$backBillPeriods = function(_v0) {
        var record = _v0;
        return record.J3;
    };
    var $author$project$Api$Provider$Company$One$backBillPeriods = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$backBillPeriods(shared);
    };
    var $author$project$Api$Company$backBillPeriods = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$backBillPeriods(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$backBillPeriods(company_);
        }
    };
    var $author$project$Api$Provider$Company$One$employeeInviteNotification = function(_v0) {
        var record = _v0.b;
        return record.OK;
    };
    var $author$project$Api$Company$employeeInviteNotification = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$employeeInviteNotification(company_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Employer$Company$One$limitBackBill = function(_v0) {
        var record = _v0.b;
        return record.Tc;
    };
    var $author$project$Api$Provider$Company$Shared$limitBackBill = function(_v0) {
        var record = _v0;
        return record.Tc;
    };
    var $author$project$Api$Provider$Company$One$limitBackBill = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$limitBackBill(shared);
    };
    var $author$project$Api$Company$limitBackBill = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$limitBackBill(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$limitBackBill(company_);
        }
    };
    var $author$project$Api$Employer$Company$One$numberDependentsAllowed = function(_v0) {
        var record = _v0.b;
        return record.Va;
    };
    var $author$project$Api$Provider$Company$One$numberDependentsAllowed = function(_v0) {
        var record = _v0.b;
        return record.Va;
    };
    var $author$project$Api$Company$numberDependentsAllowed = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$numberDependentsAllowed(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$numberDependentsAllowed(company_);
        }
    };
    var $author$project$Api$Employer$Company$One$terminationCutOffDayOfMonth = function(_v0) {
        var record = _v0.b;
        return record.$V;
    };
    var $author$project$Api$Provider$Company$One$terminationCutOffDayOfMonth = function(_v0) {
        var record = _v0.b;
        return record.$V;
    };
    var $author$project$Api$Company$terminationCutOffDayOfMonth = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$terminationCutOffDayOfMonth(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$terminationCutOffDayOfMonth(company_);
        }
    };
    var $author$project$Api$Employer$Company$One$useTerminationCutOffDate = function(_v0) {
        var record = _v0.b;
        return record.aaV;
    };
    var $author$project$Api$Provider$Company$One$useTerminationCutOffDate = function(_v0) {
        var record = _v0.b;
        return record.aaV;
    };
    var $author$project$Api$Company$useTerminationCutOffDate = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$useTerminationCutOffDate(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$useTerminationCutOffDate(company_);
        }
    };
    var $author$project$Components$Company$Enrollment$formFieldsInit = function(company) {
        return {
            J3: $elm$core$String$fromInt($author$project$Api$Company$backBillPeriods(company)),
            OK: A2($elm$core$Maybe$withDefault, 'practice_default', $author$project$Api$Company$employeeInviteNotification(company)),
            OY: $author$project$Api$Company$enrollmentCutOffDayOfMonth(company),
            Tc: $author$project$Api$Company$limitBackBill(company),
            Va: $author$project$Api$Company$numberDependentsAllowed(company),
            $V: $author$project$Api$Company$terminationCutOffDayOfMonth(company),
            o9: $author$project$Api$Company$useTerminationCutOffDate(company)
        };
    };
    var $author$project$Components$Company$Enrollment$init = F5(function(apiClient, company, practice, session, hinterViewOff) {
        var _v0 = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked) : _Utils_Tuple2(A4($author$project$Api$Provider$NotificationSetting$retrieve, apiClient, 'employee_invite', $elm$core$Maybe$Nothing, $author$project$Components$Company$Enrollment$GotNotificationSetting), $author$project$Api$Data$Loading);
        var cmd = _v0.a;
        var notificationSetting = _v0.b;
        return _Utils_Tuple2({
            pq: $author$project$Api$Data$Loading,
            EG: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0),
            acy: company,
            h7: $jinjor$elm_debounce$Debounce$init,
            b7: $author$project$Utils$Form$init($author$project$Components$Company$Enrollment$formFieldsInit(company)),
            U7: notificationSetting,
            W1: practice,
            Xv: false,
            Z$: session
        }, cmd);
    });
    var $author$project$Components$Company$Plans$GotDefaultPlan = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$PlanResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$GotCompanyPlans = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$listCompanyPlans = F3(function(apiClient, session, company) {
        return A5($author$project$Api$CompanyPlan$list, apiClient, session, $author$project$Api$Company$id(company), function(d) {
            return d;
        }, $author$project$Components$Company$Plans$GotCompanyPlans);
    });
    var $author$project$Api$Plan$EmployerOne = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Employer$Plan$One$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Plan$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Plan$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Plan$planPath = function(planId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            planId
        ]), $author$project$Api$Employer$Plan$plansPath);
    };
    var $author$project$Api$Employer$Plan$retrieve = F3(function(apiClient, planId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$Plan$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Plan$planPath(planId)));
    });
    var $author$project$Api$Plan$retrieve = F5(function(apiClient, session, planId, expand, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Plan$retrieve, apiClient, planId, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Plan$EmployerOne))) : A4($author$project$Api$Provider$Plan$retrieve, apiClient, planId, expand, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Plan$ProviderOne)));
    });
    var $author$project$Components$Company$Plans$retrievePlan = F4(function(apiClient, session, planId, toMsg) {
        return A5($author$project$Api$Plan$retrieve, apiClient, session, planId, _List_fromArray([
            1
        ]), toMsg);
    });
    var $author$project$Components$Company$Plans$init = F4(function(apiClient, company, practice, session) {
        var retrieveDefaultPlan = function() {
            var _v1 = $author$project$Api$Company$defaultPlan(company);
            if (!_v1.$) {
                var defaultPlan = _v1.a;
                return A4($author$project$Components$Company$Plans$retrievePlan, apiClient, session, $author$project$Api$Plan$id(defaultPlan), $author$project$Components$Company$Plans$GotDefaultPlan);
            } else return $elm$core$Platform$Cmd$none;
        }();
        var _v0 = A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                A8: _List_fromArray([
                    0,
                    1,
                    3
                ])
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Plan'
            });
        });
        var planResourceFilter = _v0.a;
        var planResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            du: false,
            acy: company,
            al: _List_Nil,
            Mn: $elm$core$Maybe$Nothing,
            Nz: $elm$core$Maybe$Nothing,
            qo: false,
            gd: $author$project$Api$Company$allowCustomMembershipPlan(company),
            by: $elm$core$Maybe$Nothing,
            ej: $elm$core$Maybe$Nothing,
            jy: planResourceFilter,
            W1: practice,
            j2: $elm$core$Maybe$Nothing,
            Z$: session,
            oj: false,
            hi: false
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, session, company),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$PlanResourceFilterMsg, planResourceFilterCmd),
            retrieveDefaultPlan
        ])));
    });
    var $author$project$Api$Company$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Company$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Company$companyPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'company'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Company$One$Company = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$Company$Shared$Company = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Company$Shared$Record = function(id) {
        return function(name) {
            return function(companyType) {
                return function(periodInMonths) {
                    return function(allowCustomMembershipPlan) {
                        return function(usesEmployeeDivisions) {
                            return function(requiresEmployeeDivisions) {
                                return function(enrollmentCutOffDayOfMonth) {
                                    return function(inactive) {
                                        return function(status) {
                                            return {
                                                I8: allowCustomMembershipPlan,
                                                LR: companyType,
                                                OY: enrollmentCutOffDayOfMonth,
                                                aef: id,
                                                Q8: inactive,
                                                zr: name,
                                                WA: periodInMonths,
                                                YJ: requiresEmployeeDivisions,
                                                ahy: status,
                                                aa1: usesEmployeeDivisions
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$Company$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'inactive', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enrollment_cutoff_day_of_month', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_employee_divisions', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_employee_divisions', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allow_custom_membership_plan', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company_type', $author$project$Api$Company$CompanyType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$Shared$Record)))))))))));
    var $author$project$Api$Employer$Company$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Company$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Company$One$Record = function(invoiceAutoIssue) {
        return function(invoiceAutoIssueDay) {
            return function(invoiceAutoSend) {
                return function(invoiceAutoSendDay) {
                    return function(invoiceDueDay) {
                        return function(invoiceAutoPay) {
                            return function(nextInvoiceDate) {
                                return function(parent) {
                                    return function(acceptsAch) {
                                        return function(acceptsAmex) {
                                            return function(acceptsCards) {
                                                return function(chargePhiDetailsEnabled) {
                                                    return function(address) {
                                                        return function(phones) {
                                                            return function(defaultSource) {
                                                                return function(activeMembershipsCount) {
                                                                    return function(defaultPlan) {
                                                                        return function(collectSSNOnSignup) {
                                                                            return function(employeeSignupUrl) {
                                                                                return function(limitBackBill) {
                                                                                    return function(backBillPeriods) {
                                                                                        return function(numberDependentsAllowed) {
                                                                                            return function(useTerminationCutOffDate) {
                                                                                                return function(terminationCutOffDayOfMonth) {
                                                                                                    return function(stripeLink) {
                                                                                                        return function(defaultLocation) {
                                                                                                            return function(defaultPractitioner) {
                                                                                                                return function(defaultAffiliation) {
                                                                                                                    return function(defaultSignupPage) {
                                                                                                                        return function(billAffiliateRate) {
                                                                                                                            return function(hideSponsorInvoices) {
                                                                                                                                return {
                                                                                                                                    Ie: acceptsAch,
                                                                                                                                    If: acceptsAmex,
                                                                                                                                    Ig: acceptsCards,
                                                                                                                                    Iw: activeMembershipsCount,
                                                                                                                                    II: address,
                                                                                                                                    J3: backBillPeriods,
                                                                                                                                    Kb: billAffiliateRate,
                                                                                                                                    K6: chargePhiDetailsEnabled,
                                                                                                                                    Ly: collectSSNOnSignup,
                                                                                                                                    No: defaultAffiliation,
                                                                                                                                    Nr: defaultLocation,
                                                                                                                                    Nz: defaultPlan,
                                                                                                                                    NB: defaultPractitioner,
                                                                                                                                    NC: defaultSignupPage,
                                                                                                                                    ND: defaultSource,
                                                                                                                                    OL: employeeSignupUrl,
                                                                                                                                    QI: hideSponsorInvoices,
                                                                                                                                    RB: invoiceAutoIssue,
                                                                                                                                    RC: invoiceAutoIssueDay,
                                                                                                                                    RD: invoiceAutoPay,
                                                                                                                                    RE: invoiceAutoSend,
                                                                                                                                    RF: invoiceAutoSendDay,
                                                                                                                                    RH: invoiceDueDay,
                                                                                                                                    Tc: limitBackBill,
                                                                                                                                    U$: nextInvoiceDate,
                                                                                                                                    Va: numberDependentsAllowed,
                                                                                                                                    VV: parent,
                                                                                                                                    WG: phones,
                                                                                                                                    $j: stripeLink,
                                                                                                                                    $V: terminationCutOffDayOfMonth,
                                                                                                                                    aaV: useTerminationCutOffDate
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$Company$Min$Company = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Company$Min$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Employer$Company$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$Min$Record)));
    var $author$project$Api$Employer$Company$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Company$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$SignupPage$Min$SignupPage = $elm$core$Basics$identity;
    var $author$project$Api$Employer$SignupPage$Min$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Employer$SignupPage$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$SignupPage$Min$Record));
    var $author$project$Api$Employer$SignupPage$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$SignupPage$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Company$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hide_sponsor_invoices', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_affiliate_rate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_signup_page', $elm$json$Json$Decode$nullable($author$project$Api$Employer$SignupPage$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_affiliation', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Affiliate$AffiliateMin$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Practitioner$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_location', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Location$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_link', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_cutoff_day_of_month', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'use_termination_cutoff_date', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_dependents_allowed', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'back_bill_periods', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'limit_back_bill', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'employee_signup_url', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_ssn_on_signup', $elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_plan', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Plan$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'memberships_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phones', $elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_phi_details_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_cards', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_amex', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_ach', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'parent', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Company$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_invoice_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_pay', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_due_day', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send_day', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue_day', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$One$Record))))))))))))))))))))))))))))))));
    var $author$project$Api$Employer$Company$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Company$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Company$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$One$Company)));
    var $author$project$Api$Employer$Company$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$Company$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath));
    });
    var $author$project$Api$Provider$Company$One$Company = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Company$One$Record = function(companyInvoiceSettingId) {
        return function(companyPaymentSourceSettingId) {
            return function(invoiceAutoIssue) {
                return function(invoiceAutoIssueDay) {
                    return function(invoiceAutoSend) {
                        return function(invoiceAutoSendDay) {
                            return function(invoiceDueDay) {
                                return function(invoiceAutoPay) {
                                    return function(parent) {
                                        return function(acceptsAch) {
                                            return function(acceptsAmex) {
                                                return function(acceptsCards) {
                                                    return function(usesEmployeeDivisions) {
                                                        return function(chargePhiDetailsEnabled) {
                                                            return function(address) {
                                                                return function(phones) {
                                                                    return function(defaultSource) {
                                                                        return function(activeMembershipsCount) {
                                                                            return function(defaultPlan) {
                                                                                return function(defaultPractitioner) {
                                                                                    return function(defaultLocation) {
                                                                                        return function(defaultAffiliation) {
                                                                                            return function(collectSSNOnSignup) {
                                                                                                return function(collectPractitionerOnSignup) {
                                                                                                    return function(collectPaymentSourceOnSignup) {
                                                                                                        return function(employeeSignupUrl) {
                                                                                                            return function(status) {
                                                                                                                return function(numberDependentsAllowed) {
                                                                                                                    return function(enrollmentCutOffDayOfMonth) {
                                                                                                                        return function(useTerminationCutOffDate) {
                                                                                                                            return function(terminationCutOffDayOfMonth) {
                                                                                                                                return function(employeeInviteNotification) {
                                                                                                                                    return function(flaggedNotesCount) {
                                                                                                                                        return function(invitationPending) {
                                                                                                                                            return function(defaultSignupPage) {
                                                                                                                                                return function(billAffiliateRate) {
                                                                                                                                                    return {
                                                                                                                                                        Ie: acceptsAch,
                                                                                                                                                        If: acceptsAmex,
                                                                                                                                                        Ig: acceptsCards,
                                                                                                                                                        Iw: activeMembershipsCount,
                                                                                                                                                        II: address,
                                                                                                                                                        Kb: billAffiliateRate,
                                                                                                                                                        K6: chargePhiDetailsEnabled,
                                                                                                                                                        Lw: collectPaymentSourceOnSignup,
                                                                                                                                                        Lx: collectPractitionerOnSignup,
                                                                                                                                                        Ly: collectSSNOnSignup,
                                                                                                                                                        LM: companyInvoiceSettingId,
                                                                                                                                                        LO: companyPaymentSourceSettingId,
                                                                                                                                                        No: defaultAffiliation,
                                                                                                                                                        Nr: defaultLocation,
                                                                                                                                                        Nz: defaultPlan,
                                                                                                                                                        NB: defaultPractitioner,
                                                                                                                                                        NC: defaultSignupPage,
                                                                                                                                                        ND: defaultSource,
                                                                                                                                                        OK: employeeInviteNotification,
                                                                                                                                                        OL: employeeSignupUrl,
                                                                                                                                                        OY: enrollmentCutOffDayOfMonth,
                                                                                                                                                        PR: flaggedNotesCount,
                                                                                                                                                        Ry: invitationPending,
                                                                                                                                                        RB: invoiceAutoIssue,
                                                                                                                                                        RC: invoiceAutoIssueDay,
                                                                                                                                                        RD: invoiceAutoPay,
                                                                                                                                                        RE: invoiceAutoSend,
                                                                                                                                                        RF: invoiceAutoSendDay,
                                                                                                                                                        RH: invoiceDueDay,
                                                                                                                                                        Va: numberDependentsAllowed,
                                                                                                                                                        VV: parent,
                                                                                                                                                        WG: phones,
                                                                                                                                                        ahy: status,
                                                                                                                                                        $V: terminationCutOffDayOfMonth,
                                                                                                                                                        aaV: useTerminationCutOffDate,
                                                                                                                                                        aa1: usesEmployeeDivisions
                                                                                                                                                    };
                                                                                                                                                };
                                                                                                                                            };
                                                                                                                                        };
                                                                                                                                    };
                                                                                                                                };
                                                                                                                            };
                                                                                                                        };
                                                                                                                    };
                                                                                                                };
                                                                                                            };
                                                                                                        };
                                                                                                    };
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$SignupPage$Min$SignupPage = $elm$core$Basics$identity;
    var $author$project$Api$Provider$SignupPage$Min$Record = F2(function(id, slug) {
        return {
            aef: id,
            _A: slug
        };
    });
    var $author$project$Api$Provider$SignupPage$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'slug', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$SignupPage$Min$Record)));
    var $author$project$Api$Provider$SignupPage$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$SignupPage$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'bill_affiliate_rate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_signup_page', $elm$json$Json$Decode$nullable($author$project$Api$Provider$SignupPage$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_pending', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'flagged_notes_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'employee_invite_notification', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_cutoff_day_of_month', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'use_termination_cutoff_date', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enrollment_cutoff_day_of_month', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_dependents_allowed', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'employee_signup_url', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_payment_source_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_practitioner_on_signup', $elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_ssn_on_signup', $elm$json$Json$Decode$maybe($author$project$Api$CollectOnSignup$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_affiliation', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Affiliate$AffiliateMin$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'memberships_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phones', $elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_phi_details_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uses_employee_divisions', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_cards', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_amex', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepts_ach', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'parent', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_pay', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_due_day', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send_day', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_send', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue_day', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_auto_issue', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray([
        'payment_source_setting',
        'id'
    ]), $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray([
        'company_invoice_setting',
        'id'
    ]), $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$One$Record)))))))))))))))))))))))))))))))))))));
    var $author$project$Api$Provider$Company$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Company$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Company$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$One$Company)));
    var $author$project$Api$Provider$Company$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_)));
    });
    var $author$project$Api$Company$retrieve = F4(function(apiClient, session, id_, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$Employer$Company$retrieve, apiClient, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$Employer))) : A3($author$project$Api$Provider$Company$retrieve, apiClient, id_, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$Provider)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Top$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var _v1 = A5($author$project$Components$Company$Enrollment$init, shared.Ej, company, practice, session, shared.aeb);
        var enrollment = _v1.a;
        var enrollmentCmd = _v1.b;
        var _v2 = A4($author$project$Components$Company$EmployeeDivisions$init, shared.Ej, company, practice, session);
        var employeeDivisions = _v2.a;
        var employeeDivisionsCmd = _v2.b;
        var _v3 = function() {
            var _v4 = _Utils_Tuple2(company, practice);
            if (!_v4.a.$ && !_v4.b.$) {
                var company_ = _v4.a.a;
                var practice_ = _v4.b.a;
                return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$Company$DeactivateSponsor$init, company_, practice_));
            } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        }();
        var deactivateSponsor = _v3.a;
        var deactivateSponsorCmd = _v3.b;
        var _v5 = A3($author$project$Components$Company$ContactForm$init, company, practice, session);
        var contactForm = _v5.a;
        var contactFormCmd = _v5.b;
        var _v6 = A4($author$project$Components$Company$Plans$init, shared.Ej, company, practice, session);
        var companyPlans = _v6.a;
        var companyPlansCmd = _v6.b;
        var _v7 = function() {
            var _v8 = _Utils_Tuple2(company, practice);
            if (!_v8.a.$ && !_v8.b.$) {
                var company_ = _v8.a.a;
                var practice_ = _v8.b.a;
                return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A3($author$project$Components$Company$Admins$init, shared.Ej, company_, practice_));
            } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        }();
        var companyAdmins = _v7.a;
        var companyAdminsCmd = _v7.b;
        var _v9 = function() {
            var _v10 = _Utils_Tuple2(company, practice);
            if (!_v10.a.$ && !_v10.b.$) {
                var company_ = _v10.a.a;
                var practice_ = _v10.b.a;
                return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A6($author$project$Components$Company$CommissionDeals$init, session, company_, practice_, shared.Ej, shared.cP, shared.HP));
            } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        }();
        var commissionDeals = _v9.a;
        var commissionDealsCmd = _v9.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            lD: commissionDeals,
            lE: companyAdmins,
            al: companyPlans,
            hX: contactForm,
            cP: shared.cP,
            lS: deactivateSponsor,
            No: $elm$core$Maybe$Nothing,
            Nr: $elm$core$Maybe$Nothing,
            h8: $elm$core$Maybe$Nothing,
            xv: employeeDivisions,
            ma: enrollment,
            aef: params.fl,
            W1: practice,
            Z$: session,
            HP: shared.HP
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A4($author$project$Api$Company$retrieve, shared.Ej, session, params.fl, $author$project$Pages$Companies$CompanyId_String$Top$GotCompany),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg, commissionDealsCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg, companyAdminsCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg, deactivateSponsorCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg, enrollmentCmd)
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Company$Admins$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$CommissionDeals$CreateModalMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$CommissionDeals$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Company$CommissionDeals$CreateModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$BrokerDeal$CreateModal$subscriptions, model.h$))),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg, $author$project$Components$BrokerDeal$Table$subscriptions(model.dy))
        ]));
    };
    var $author$project$Components$Company$ContactForm$GotPhoneInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Company$ContactForm$subscriptions = function(_v0) {
        var model = _v0;
        var _v1 = $author$project$Utils$Form$fields(model.PU);
        var phone = _v1.WE;
        var address = _v1.II;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Company$ContactForm$AddressInputMsg, $author$project$Components$AddressInput$subscriptions(address)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Company$ContactForm$GotPhoneInputMsg, $author$project$Components$PhoneInput$subscriptions(phone))
        ]));
    };
    var $author$project$Components$Company$DeactivateSponsor$HiConfirmClosed = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$DeactivateSponsor$subscriptions = function(model) {
        return model.iN ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$DeactivateSponsor$HiConfirmClosed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Company$DefaultAffiliation$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Company$DefaultLocation$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Company$DefaultProvider$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Company$Enrollment$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Company$Plans$ClosePricingDetailsModal = {
        $: 19
    };
    var $author$project$Components$Company$Plans$CoveragePlanMsg = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$HiConfirmPlanAddClosed = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$HiConfirmPlanChangedClosed = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$ClosePricingDetailsModal)), model.j2)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Company$Plans$CoveragePlanMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.Mn))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed)), model.by)),
            function() {
                var _v0 = _Utils_Tuple2(model.Nz, model.hi);
                if (!_v0.a.$ && _v0.b) return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmPlanChangedClosed);
                else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Company$Plans$HiConfirmPlanAddClosed)), model.ej))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, $author$project$Components$Company$ContactForm$subscriptions(model.hX)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, $author$project$Components$Company$Plans$subscriptions(model.al)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg, $author$project$Components$Company$Enrollment$subscriptions(model.ma)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Company$Admins$subscriptions, model.lE))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultProvider$subscriptions, model.h8))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultLocation$subscriptions, model.Nr))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Company$DefaultAffiliation$subscriptions, model.No))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Company$CommissionDeals$subscriptions, model.lD))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Company$DeactivateSponsor$subscriptions, model.lS)))
        ]));
    };
    var $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$DefaultAffiliation$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$DefaultAffiliation$GotAffiliations = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$DefaultAffiliation$fetchAffiliations = function(apiClient) {
        return A3($author$project$Api$Provider$Affiliate$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: $author$project$Api$Pagination$init,
                agq: $elm$core$Maybe$Nothing,
                ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
                ahy: $elm$core$Maybe$Nothing
            });
        }, $author$project$Components$Company$DefaultAffiliation$GotAffiliations);
    };
    var $author$project$Components$Company$DefaultAffiliation$initAffiliateResourceFilter = F3(function(apiClient, session, company) {
        var _v0 = A4($author$project$Components$ResourceFilter$Affiliate$init, apiClient, session, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Clinic',
                I5: false,
                afn: false
            });
        });
        var newResourceFilterModel = _v0.a;
        var cmd = _v0.b;
        var filterModelWithDefaults = function() {
            var _v1 = $author$project$Api$Provider$Company$One$defaultAffiliation(company);
            if (!_v1.$) {
                var affiliation = _v1.a;
                return A2($author$project$Components$ResourceFilter$Affiliate$setValue, $elm$core$Maybe$Just({
                    aef: $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliation),
                    zr: $author$project$Api$Provider$Affiliate$AffiliateMin$name(affiliation)
                }), newResourceFilterModel);
            } else return newResourceFilterModel;
        }();
        return _Utils_Tuple2(filterModelWithDefaults, cmd);
    });
    var $author$project$Components$Company$DefaultAffiliation$initFormFields = function(company) {
        var defaultAffiliation = A2($elm$core$Maybe$map, function(affiliation) {
            return $author$project$Api$Provider$Affiliate$AffiliateMin$id(affiliation);
        }, $author$project$Api$Provider$Company$One$defaultAffiliation(company));
        return {
            IY: defaultAffiliation
        };
    };
    var $author$project$Components$Company$DefaultAffiliation$init = F4(function(session, company, practice, apiClient) {
        var affiliationForm = $author$project$Components$Company$DefaultAffiliation$initFormFields(company);
        var _v0 = A3($author$project$Components$Company$DefaultAffiliation$initAffiliateResourceFilter, apiClient, session, company);
        var affiliateResourceFilter = _v0.a;
        var affiliateResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            pu: affiliateResourceFilter,
            e1: $author$project$Utils$Form$init(affiliationForm),
            pv: _List_Nil,
            acy: company,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg, affiliateResourceFilterCmd),
            $author$project$Components$Company$DefaultAffiliation$fetchAffiliations(apiClient)
        ])));
    });
    var $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$DefaultLocation$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$DefaultLocation$initFormFields = function(company) {
        var defaultLocation = A2($elm$core$Maybe$map, function(location1) {
            return $author$project$Api$Provider$Location$Shared$id(location1);
        }, $author$project$Api$Provider$Company$One$defaultLocation(company));
        return {
            aeT: defaultLocation
        };
    };
    var $author$project$Components$Company$DefaultLocation$initLocationResourceFilter = F2(function(apiClient, company) {
        var _v0 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Location',
                afn: false
            });
        });
        var newResourceFilterModel = _v0.a;
        var cmd = _v0.b;
        var filterModelWithDefaults = function() {
            var _v1 = $author$project$Api$Provider$Company$One$defaultLocation(company);
            if (!_v1.$) {
                var location1 = _v1.a;
                return function(value) {
                    return A2($author$project$Components$ResourceFilter$Location$setValue, value, newResourceFilterModel);
                }($author$project$Components$ResourceFilter$Location$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Location$Shared$Provider(location1))));
            } else return newResourceFilterModel;
        }();
        return _Utils_Tuple2(filterModelWithDefaults, cmd);
    });
    var $author$project$Components$Company$DefaultLocation$init = F3(function(company, practice, apiClient) {
        var locationForm = $author$project$Components$Company$DefaultLocation$initFormFields(company);
        var _v0 = A2($author$project$Components$Company$DefaultLocation$initLocationResourceFilter, apiClient, company);
        var locationResourceFilter = _v0.a;
        var locationResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            acy: company,
            f$: $author$project$Utils$Form$init(locationForm),
            ro: locationResourceFilter,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg, locationResourceFilterCmd));
    });
    var $author$project$Components$Company$DefaultProvider$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$DefaultProvider$initFormFields = function(company) {
        var defaultPractitioner = A2($elm$core$Maybe$map, function(practitioner) {
            return $author$project$Api$Provider$Practitioner$Shared$id(practitioner);
        }, $author$project$Api$Provider$Company$One$defaultPractitioner(company));
        return {
            agi: defaultPractitioner
        };
    };
    var $author$project$Components$Company$DefaultProvider$initPractitionerResourceFilter = F2(function(apiClient, company) {
        var _v0 = A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Provider',
                afn: false
            });
        });
        var newResourceFilterModel = _v0.a;
        var cmd = _v0.b;
        var filterModelWithDefaults = function() {
            var _v1 = $author$project$Api$Provider$Company$One$defaultPractitioner(company);
            if (!_v1.$) {
                var practitioner = _v1.a;
                return function(value) {
                    return A2($author$project$Components$ResourceFilter$Practitioner$setValue, value, newResourceFilterModel);
                }($author$project$Components$ResourceFilter$Practitioner$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Practitioner$Shared$Provider(practitioner))));
            } else return newResourceFilterModel;
        }();
        return _Utils_Tuple2(filterModelWithDefaults, cmd);
    });
    var $author$project$Components$Company$DefaultProvider$init = F3(function(company, practice, apiClient) {
        var providerForm = $author$project$Components$Company$DefaultProvider$initFormFields(company);
        var _v0 = A2($author$project$Components$Company$DefaultProvider$initPractitionerResourceFilter, apiClient, company);
        var practitionerResourceFilter = _v0.a;
        var practitionerResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            acy: company,
            W1: practice,
            jE: practitionerResourceFilter,
            gw: $author$project$Utils$Form$init(providerForm),
            j_: $author$project$Api$Data$NotAsked
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg, practitionerResourceFilterCmd));
    });
    var $author$project$Components$Company$Admins$CompanyAdminDeleted = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Company$Admins$GotInvitation = F3(function(a, b, c) {
        return {
            $: 5,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Company$Admins$InviteLinkMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyAdmin$companyAdminPath = F2(function(companyId, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId));
    });
    var $author$project$Api$Provider$CompanyAdmin$delete = F4(function(apiClient, companyId, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$CompanyAdmin$companyAdminPath, companyId, id_)));
    });
    var $author$project$Api$Provider$CompanyAdmin$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$CompanyAdmin$One$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAdmin$Shared$email(shared);
    };
    var $author$project$Api$Provider$CompanyAdmin$All$email = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CompanyAdmin$One$email(shared);
    };
    var $author$project$Components$Company$Admins$formFieldsUpdate = F2(function(field, fields) {
        var string = field;
        return _Utils_update(fields, {
            OH: string
        });
    });
    var $author$project$Components$Company$Admins$EmailValidation = 0;
    var $author$project$Components$Company$Admins$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: false
        }, A2($elm$core$Basics$composeR, function($) {
            return $.OH;
        }, $elm$core$Maybe$Just), _Utils_Tuple2(0, 'Please enter a valid email.'))
    ]));
    var $author$project$Api$Provider$CompanyAdmin$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CompanyAdmin$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAdmin$Shared$id(shared);
    };
    var $author$project$Api$Provider$CompanyAdmin$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$CompanyAdmin$One$id(shared);
    };
    var $author$project$Api$Provider$CompanyAdmin$invite = F4(function(apiClient, companyId, email_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('admin', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('email', $elm$json$Json$Encode$string(email_))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CompanyAdmin$companyAdminsPath(companyId))));
    });
    var $author$project$Api$Provider$CompanyAdmin$reinvite = F4(function(apiClient, companyId, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reinvite'
        ]), A2($author$project$Api$Provider$CompanyAdmin$companyAdminPath, companyId, id_))));
    });
    var $author$project$Components$Company$Admins$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var admins = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        dv: $elm$core$List$isEmpty(admins),
                        pq: response,
                        Xv: false
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Xv: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var admin = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Xv: true
                }), A4($author$project$Api$Provider$CompanyAdmin$delete, apiClient, $author$project$Api$Provider$Company$One$id(model.acy), $author$project$Api$Provider$CompanyAdmin$All$id(admin), $author$project$Components$Company$Admins$CompanyAdminDeleted(admin)), _List_Nil);
            case 2:
                var admin = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, model.acy), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$CompanyAdmin$All$email(admin) + ' was successfully removed from this company')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            Xv: false
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            Xv: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$Admins$formFieldsValidator, model.bo);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var validatedForm = _v5.a;
                    var validFormFields = _v5.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    return _Utils_Tuple3(_Utils_update(model, {
                        dv: false,
                        bo: validatedForm
                    }), A4($author$project$Api$Provider$CompanyAdmin$invite, apiClient, $author$project$Api$Provider$Company$One$id(model.acy), fields.OH, A2($author$project$Components$Company$Admins$GotInvitation, fields.OH, false)), _List_Nil);
                } else {
                    var erroredForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bo: erroredForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 4:
                var admin = msg.a;
                var adminId = $author$project$Api$Provider$CompanyAdmin$All$id(admin);
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CompanyAdmin$reinvite, apiClient, $author$project$Api$Provider$Company$One$id(model.acy), adminId, A2($author$project$Components$Company$Admins$GotInvitation, $author$project$Api$Provider$CompanyAdmin$All$email(admin), true)), _List_Nil);
            case 5:
                var email = msg.a;
                var isReinvite = msg.b;
                var response = msg.c;
                if (response.$ === 3) {
                    var sentText = isReinvite ? 'resent' : 'sent';
                    return _Utils_Tuple3(_Utils_update(model, {
                        bo: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit),
                        pq: $author$project$Api$Data$Loading
                    }), A2($author$project$Components$Company$Admins$listCompanyAdmins, apiClient, model.acy), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Invitation was successfully ' + (sentText + (' to ' + email)))
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    dv: true
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    dv: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    dv: false,
                    bo: $author$project$Utils$Form$init($author$project$Components$Company$Admins$formFieldsInit)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$Admins$formFieldsUpdate, field, model.bo);
                return _Utils_Tuple3(_Utils_update(model, {
                    bo: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v7 = $author$project$Components$InviteLink$update(subMsg);
                var inviteLinkCmd = _v7.a;
                var inviteLinkOutMsg = _v7.b;
                return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Admins$InviteLinkMsg, inviteLinkCmd), inviteLinkOutMsg);
        }
    });
    var $author$project$Components$Company$CommissionDeals$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = model.h$;
                if (!_v1.$) {
                    var createModal = _v1.a;
                    var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, apiClient, subMsg, createModal);
                    var _v2 = function() {
                        var _v3 = createModalResult.adu;
                        switch(_v3){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createModalResult.zi), model.Kq, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.Kq, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
                        }
                    }();
                    var createModal_ = _v2.a;
                    var brokerDeals = _v2.b;
                    var cmd = _v2.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kq: brokerDeals,
                        h$: createModal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$CreateModalMsg, createModalResult.EQ),
                        cmd
                    ])), createModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v4 = A5($author$project$Components$BrokerDeal$CreateModal$init, apiClient, model.Z$, model.cP, model.HP, {
                    vQ: $elm$core$Maybe$Nothing,
                    vR: $elm$core$Maybe$Nothing,
                    LG: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.W1),
                    acy: $elm$core$Maybe$Just(model.acy),
                    Nk: 0,
                    jc: $elm$core$Maybe$Nothing,
                    agX: false
                });
                var createModal = _v4.a;
                var createModalCmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    h$: $elm$core$Maybe$Just(createModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$CreateModalMsg, createModalCmd), _List_Nil);
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var brokerDeals = response.a;
                    var headers = response.b;
                    var brokerDealsTable = A2($author$project$Components$BrokerDeal$Table$withBrokerDeals, A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals), model.dy);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Kq: response,
                        dy: brokerDealsTable,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Kq: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var brokerDealsTableResult = A3($author$project$Components$BrokerDeal$Table$update, apiClient, subMsg, model.dy);
                var _v6 = function() {
                    var _v7 = brokerDealsTableResult.adu;
                    switch(_v7){
                        case 0:
                            return _Utils_Tuple2(model.Kq, $elm$core$Platform$Cmd$none);
                        case 1:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
                        case 2:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
                        case 3:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
                        case 4:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
                        case 5:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
                        default:
                            return _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Components$Company$CommissionDeals$fetchBrokerDeals, apiClient, model));
                    }
                }();
                var brokerDeals = _v6.a;
                var cmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    Kq: brokerDeals,
                    dy: brokerDealsTableResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg, brokerDealsTableResult.EQ),
                    cmd
                ])), brokerDealsTableResult.at);
        }
    });
    var $author$project$Components$Company$ContactForm$Address = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$ContactForm$Phone = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$ContactForm$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var address = field.a;
                return _Utils_update(fields, {
                    II: address
                });
            default:
                var phone = field.a;
                return _Utils_update(fields, {
                    WE: phone
                });
        }
    });
    var $author$project$Components$Company$ContactForm$NameValidation = 0;
    var $author$project$Components$Company$ContactForm$AddressValidation = 1;
    var $author$project$Components$Company$ContactForm$validateAddress = function(fields) {
        return $author$project$Components$AddressInput$isValid(fields.II) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(1, 'Please enter an address')
        ]);
    };
    var $author$project$Components$Company$ContactForm$PhoneValidation = 2;
    var $author$project$Components$Company$ContactForm$validatePhone = function(fields) {
        var _v0 = $author$project$Components$PhoneInput$getPhones(fields.WE);
        if (!_v0.$) return _List_Nil;
        else return _List_fromArray([
            _Utils_Tuple2(2, 'Please enter a valid phone')
        ]);
    };
    var $author$project$Components$Company$ContactForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$ContactForm$validateAddress),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$ContactForm$validatePhone)
    ]));
    var $author$project$Components$Company$ContactForm$CompanyUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Company$ContactForm$apiFormFields = function(fields) {
        var phones = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Components$PhoneInput$getPhones(fields.WE));
        var address = $author$project$Components$AddressInput$getAddress(fields.II);
        return {
            II: address,
            zr: fields.zr,
            WG: A2($elm$core$List$map, $author$project$Utils$Phone$toRecord, phones)
        };
    };
    var $author$project$Api$Company$Shared$encodeUpdate = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('address', $author$project$Api$Common$Address$Shared$encode(fields.II)),
                _Utils_Tuple2('phones', A2($elm$json$Json$Encode$list, $author$project$Api$Common$Phone$Shared$encode, fields.WG))
            ])))
        ]));
    };
    var $author$project$Api$Employer$Company$update = F3(function(apiClient, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Employer$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdate(fields), $author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
    });
    var $author$project$Api$Provider$Company$update = F4(function(apiClient, id_, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdate(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Api$Company$update = F5(function(apiClient, session, id_, fields, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Company$update, apiClient, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4($author$project$Api$Provider$Company$update, apiClient, id_, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$Provider)));
    });
    var $author$project$Components$Company$ContactForm$updateContactInformation = F4(function(apiClient, session, id_, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A5($author$project$Api$Company$update, apiClient, session, id_, $author$project$Components$Company$ContactForm$apiFormFields(fields), $author$project$Components$Company$ContactForm$CompanyUpdated);
    });
    var $author$project$Components$Company$ContactForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$ContactForm$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var fields = $author$project$Utils$Form$fields(model.PU);
                var address = $author$project$Components$AddressInput$validate(fields.II);
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$ContactForm$formFieldsUpdate, $author$project$Components$Company$ContactForm$Address(address), model.PU);
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$ContactForm$formFieldsValidator, newForm);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validatedForm = _v3.a;
                    var validFormFields = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$Loading
                    }), A4($author$project$Components$Company$ContactForm$updateContactInformation, apiClient, model.Z$, $author$project$Api$Company$id(model.acy), validFormFields), _List_Nil);
                } else {
                    var validatedForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var subMsg = msg.a;
                var _v4 = $author$project$Utils$Form$fields(model.PU);
                var address = _v4.II;
                var _v5 = A2($author$project$Components$AddressInput$update, subMsg, address);
                var addressInputModel = _v5.a;
                var addressInputCmd = _v5.b;
                var outMsgs = _v5.c;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$ContactForm$formFieldsUpdate, $author$project$Components$Company$ContactForm$Address(addressInputModel), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$AddressInputMsg, addressInputCmd), outMsgs);
            case 4:
                var subMsg = msg.a;
                var _v6 = $author$project$Utils$Form$fields(model.PU);
                var phone = _v6.WE;
                var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
                var phoneInput = _v7.a;
                var phoneCmd = _v7.b;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$ContactForm$formFieldsUpdate, $author$project$Components$Company$ContactForm$Phone(phoneInput), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$ContactForm$GotPhoneInputMsg, phoneCmd), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var company = response.a;
                    var _v9 = $author$project$Components$Company$ContactForm$initFormFields(company);
                    var formFields = _v9.a;
                    var formFieldsCmd = _v9.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $author$project$Utils$Form$init(formFields),
                        j_: response
                    }), formFieldsCmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Company$DeactivateSponsor$SponsorArchived = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$archive = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'archive'
        ]), $author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$DeactivateSponsor$archiveSponsor = F2(function(apiClient, id) {
        return A3($author$project$Api$Provider$Company$archive, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorArchived);
    });
    var $author$project$Components$Company$DeactivateSponsor$SponsorDeactivated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$deactivate = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'deactivate'
        ]), $author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$DeactivateSponsor$deactivateSponsor = F2(function(apiClient, id) {
        return A3($author$project$Api$Provider$Company$deactivate, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorDeactivated);
    });
    var $author$project$Components$Company$DeactivateSponsor$SponsorReactivated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$reactivate = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reactivate'
        ]), $author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$DeactivateSponsor$reactivateSponsor = F2(function(apiClient, id) {
        return A3($author$project$Api$Provider$Company$reactivate, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorReactivated);
    });
    var $author$project$Components$Company$DeactivateSponsor$SponsorUnArchived = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$unArchive = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unarchive'
        ]), $author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$DeactivateSponsor$unArchiveSponsor = F2(function(apiClient, id) {
        return A3($author$project$Api$Provider$Company$unArchive, apiClient, id, $author$project$Components$Company$DeactivateSponsor$SponsorUnArchived);
    });
    var $author$project$Components$Company$DeactivateSponsor$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    iN: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    iN: false,
                    Xv: true
                }), A2($author$project$Components$Company$DeactivateSponsor$deactivateSponsor, apiClient, $author$project$Api$Provider$Company$One$id(model.acy)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    iN: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    Xv: true
                }), A2($author$project$Components$Company$DeactivateSponsor$reactivateSponsor, apiClient, $author$project$Api$Provider$Company$One$id(model.acy)), _List_Nil);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    Xv: true
                }), A2($author$project$Components$Company$DeactivateSponsor$archiveSponsor, apiClient, $author$project$Api$Provider$Company$One$id(model.acy)), _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    Xv: true
                }), A2($author$project$Components$Company$DeactivateSponsor$unArchiveSponsor, apiClient, $author$project$Api$Provider$Company$One$id(model.acy)), _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    Q8: true,
                    Xv: false,
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been deactivated. The employees will be unenrolled soon')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    Q8: false,
                    Xv: false,
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been reactivated')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    JC: true,
                    Xv: false,
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been archived. They will not show up in your employer list.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    JC: false,
                    Xv: false,
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Employer account has been unarchived.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Company$DefaultAffiliation$Affiliation = $elm$core$Basics$identity;
    var $author$project$Components$Company$DefaultAffiliation$formFieldsUpdate = F2(function(field, fields) {
        var affiliation = field;
        return _Utils_update(fields, {
            IY: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, affiliation)
        });
    });
    var $author$project$Components$Company$DefaultAffiliation$AffiliationValidation = 0;
    var $author$project$Components$Company$DefaultAffiliation$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.IY;
        }, _Utils_Tuple2(0, ''))
    ]));
    var $author$project$Components$Company$DefaultAffiliation$CompanyUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Company$Shared$encodeUpdateAffiliation = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('default_affiliation', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.IY))
            ])))
        ]));
    };
    var $author$project$Api$Provider$Company$updateAffiliation = F4(function(apiClient, id_, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdateAffiliation(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$DefaultAffiliation$updateDefaultAffiliation = F3(function(apiClient, id_, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Company$updateAffiliation, apiClient, id_, fields, $author$project$Components$Company$DefaultAffiliation$CompanyUpdated);
    });
    var $author$project$Components$Company$DefaultAffiliation$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var affiliateResourceResult = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, subMsg, model.pu);
                var _v2 = function() {
                    var _v3 = affiliateResourceResult.adu;
                    _v3$2: while(true){
                        if (!_v3.$ && !_v3.a.$) switch(_v3.a.a.$){
                            case 0:
                                var affiliate = _v3.a.a.a;
                                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultAffiliation$formFieldsUpdate, $elm$core$Maybe$Just(affiliate), model.e1);
                                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultAffiliation$formFieldsValidator, newForm);
                                if (!_v4.$) {
                                    var _v5 = _v4.a;
                                    var validatedForm = _v5.a;
                                    var validFormFields = _v5.b;
                                    return _Utils_Tuple2(_Utils_update(model, {
                                        e1: validatedForm,
                                        j_: $author$project$Api$Data$Loading
                                    }), A3($author$project$Components$Company$DefaultAffiliation$updateDefaultAffiliation, apiClient, $author$project$Api$Provider$Company$One$id(model.acy), validFormFields));
                                } else {
                                    var validatedForm = _v4.a;
                                    return _Utils_Tuple2(_Utils_update(model, {
                                        e1: validatedForm,
                                        j_: $author$project$Api$Data$NotAsked
                                    }), $elm$core$Platform$Cmd$none);
                                }
                            case 2:
                                var _v6 = _v3.a.a;
                                var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultAffiliation$formFieldsUpdate, $elm$core$Maybe$Nothing, model.e1);
                                return _Utils_Tuple2(_Utils_update(model, {
                                    e1: form
                                }), $elm$core$Platform$Cmd$none);
                            default:
                                break _v3$2;
                        }
                        else break _v3$2;
                    }
                    return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    pu: affiliateResourceResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg, affiliateResourceResult.EQ),
                    cmd
                ])), affiliateResourceResult.at);
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var company = response.a;
                    var formFields = $author$project$Components$Company$DefaultAffiliation$initFormFields(company);
                    return _Utils_Tuple3(_Utils_update(model, {
                        e1: $author$project$Utils$Form$init(formFields),
                        acy: company,
                        j_: response
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        $author$project$OutMsg$RetrieveCompany($author$project$Api$Provider$Company$One$id(model.acy)),
                        A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var affiliations = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        pv: affiliations
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    pv: _List_Nil
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Company$DefaultLocation$Location = $elm$core$Basics$identity;
    var $author$project$Components$Company$DefaultLocation$formFieldsUpdate = F2(function(field, fields) {
        var location1 = field;
        return _Utils_update(fields, {
            aeT: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, location1)
        });
    });
    var $author$project$Components$Company$DefaultLocation$LocationValidation = 0;
    var $author$project$Components$Company$DefaultLocation$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.aeT;
        }, _Utils_Tuple2(0, ''))
    ]));
    var $author$project$Components$Company$DefaultLocation$CompanyUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Company$Shared$encodeUpdateLocation = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('default_location', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.aeT))
            ])))
        ]));
    };
    var $author$project$Api$Provider$Company$updateLocation = F4(function(apiClient, id_, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdateLocation(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$DefaultLocation$updateDefaultLocation = F3(function(apiClient, id_, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Company$updateLocation, apiClient, id_, fields, $author$project$Components$Company$DefaultLocation$CompanyUpdated);
    });
    var $author$project$Components$Company$DefaultLocation$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var subMsg = msg.a;
            var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, model.ro);
            var _v2 = function() {
                var _v3 = locationResourceResult.adu;
                _v3$2: while(true){
                    if (!_v3.$ && !_v3.a.$) switch(_v3.a.a.$){
                        case 0:
                            var location1 = _v3.a.a.a;
                            var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultLocation$formFieldsUpdate, $elm$core$Maybe$Just(location1), model.f$);
                            var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultLocation$formFieldsValidator, newForm);
                            if (!_v4.$) {
                                var _v5 = _v4.a;
                                var validatedForm = _v5.a;
                                var validFormFields = _v5.b;
                                return _Utils_Tuple2(_Utils_update(model, {
                                    f$: validatedForm,
                                    j_: $author$project$Api$Data$Loading
                                }), A3($author$project$Components$Company$DefaultLocation$updateDefaultLocation, apiClient, $author$project$Api$Provider$Company$One$id(model.acy), validFormFields));
                            } else {
                                var validatedForm = _v4.a;
                                return _Utils_Tuple2(_Utils_update(model, {
                                    f$: validatedForm,
                                    j_: $author$project$Api$Data$NotAsked
                                }), $elm$core$Platform$Cmd$none);
                            }
                        case 2:
                            var _v6 = _v3.a.a;
                            var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultLocation$formFieldsUpdate, $elm$core$Maybe$Nothing, model.f$);
                            return _Utils_Tuple2(_Utils_update(model, {
                                f$: form
                            }), $elm$core$Platform$Cmd$none);
                        default:
                            break _v3$2;
                    }
                    else break _v3$2;
                }
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            }();
            var newModel = _v2.a;
            var cmd = _v2.b;
            return _Utils_Tuple3(_Utils_update(newModel, {
                ro: locationResourceResult.zi
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg, locationResourceResult.EQ),
                cmd
            ])), locationResourceResult.at);
        } else {
            var response = msg.a;
            if (response.$ === 3) {
                var company = response.a;
                var formFields = $author$project$Components$Company$DefaultLocation$initFormFields(company);
                return _Utils_Tuple3(_Utils_update(model, {
                    acy: company,
                    f$: $author$project$Utils$Form$init(formFields),
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$RetrieveCompany($author$project$Api$Provider$Company$One$id(model.acy)),
                    A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
                ]));
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Company$DefaultProvider$Practitioner = $elm$core$Basics$identity;
    var $author$project$Components$Company$DefaultProvider$formFieldsUpdate = F2(function(field, fields) {
        var practitioner = field;
        return _Utils_update(fields, {
            agi: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, practitioner)
        });
    });
    var $author$project$Components$Company$DefaultProvider$PractitionerValidation = 0;
    var $author$project$Components$Company$DefaultProvider$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.agi;
        }, _Utils_Tuple2(0, ''))
    ]));
    var $author$project$Components$Company$DefaultProvider$CompanyUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Company$Shared$encodeUpdatePractitioner = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('default_practitioner', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.agi))
            ])))
        ]));
    };
    var $author$project$Api$Provider$Company$updateProvider = F4(function(apiClient, id_, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdatePractitioner(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$DefaultProvider$updateDefaultProvider = F3(function(apiClient, id_, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Company$updateProvider, apiClient, id_, fields, $author$project$Components$Company$DefaultProvider$CompanyUpdated);
    });
    var $author$project$Components$Company$DefaultProvider$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var subMsg = msg.a;
            var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.jE);
            var _v2 = function() {
                var _v3 = practitionerResourceResult.adu;
                _v3$2: while(true){
                    if (!_v3.$ && !_v3.a.$) switch(_v3.a.a.$){
                        case 0:
                            var practitioner = _v3.a.a.a;
                            var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultProvider$formFieldsUpdate, $elm$core$Maybe$Just(practitioner), model.gw);
                            var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$DefaultProvider$formFieldsValidator, newForm);
                            if (!_v4.$) {
                                var _v5 = _v4.a;
                                var validatedForm = _v5.a;
                                var validFormFields = _v5.b;
                                return _Utils_Tuple2(_Utils_update(model, {
                                    gw: validatedForm,
                                    j_: $author$project$Api$Data$Loading
                                }), A3($author$project$Components$Company$DefaultProvider$updateDefaultProvider, apiClient, $author$project$Api$Provider$Company$One$id(model.acy), validFormFields));
                            } else {
                                var validatedForm = _v4.a;
                                return _Utils_Tuple2(_Utils_update(model, {
                                    gw: validatedForm,
                                    j_: $author$project$Api$Data$NotAsked
                                }), $elm$core$Platform$Cmd$none);
                            }
                        case 2:
                            var _v6 = _v3.a.a;
                            var form = A3($author$project$Utils$Form$update, $author$project$Components$Company$DefaultProvider$formFieldsUpdate, $elm$core$Maybe$Nothing, model.gw);
                            return _Utils_Tuple2(_Utils_update(model, {
                                gw: form
                            }), $elm$core$Platform$Cmd$none);
                        default:
                            break _v3$2;
                    }
                    else break _v3$2;
                }
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            }();
            var newModel = _v2.a;
            var cmd = _v2.b;
            return _Utils_Tuple3(_Utils_update(newModel, {
                jE: practitionerResourceResult.zi
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg, practitionerResourceResult.EQ),
                cmd
            ])), practitionerResourceResult.at);
        } else {
            var response = msg.a;
            if (response.$ === 3) {
                var company = response.a;
                var formFields = $author$project$Components$Company$DefaultProvider$initFormFields(company);
                return _Utils_Tuple3(_Utils_update(model, {
                    acy: company,
                    gw: $author$project$Utils$Form$init(formFields),
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$RetrieveCompany($author$project$Api$Provider$Company$One$id(model.acy)),
                    A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
                ]));
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Company$EmployeeDivisions$EmployeeDivisionDeleted = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Company$EmployeeDivisions$EmployeeDivisionAdded = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$EmployeeDivision$Shared$encodeAddDivision = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('employee_division', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr))
            ])))
        ]));
    };
    var $author$project$Api$Employer$EmployeeDivision$create = F3(function(apiClient, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$EmployeeDivision$All$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$EmployeeDivision$Shared$encodeAddDivision(fields), $author$project$Api$Data$requestTo($author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
    });
    var $author$project$Api$Provider$Company$EmployeeDivision$create = F4(function(apiClient, companyId, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$EmployeeDivision$All$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$EmployeeDivision$Shared$encodeAddDivision(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
    });
    var $author$project$Api$EmployeeDivision$create = F5(function(apiClient, session, companyId, fields, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$EmployeeDivision$create, apiClient, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$EmployeeDivision$All$Employer))) : A4($author$project$Api$Provider$Company$EmployeeDivision$create, apiClient, companyId, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$EmployeeDivision$All$Provider)));
    });
    var $author$project$Components$Company$EmployeeDivisions$addEmployeeDivision = F4(function(apiClient, session, company, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A5($author$project$Api$EmployeeDivision$create, apiClient, session, $author$project$Api$Company$id(company), fields, $author$project$Components$Company$EmployeeDivisions$EmployeeDivisionAdded);
    });
    var $author$project$Api$Employer$EmployeeDivision$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Employer$EmployeeDivision$employeeDivisionsPath)));
    });
    var $author$project$Api$Provider$Company$EmployeeDivision$delete = F4(function(apiClient, companyId, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Company$EmployeeDivision$employeeDivisionsPath(companyId))));
    });
    var $author$project$Api$EmployeeDivision$delete = F5(function(apiClient, session, companyId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$EmployeeDivision$delete, apiClient, id, toMsg) : A4($author$project$Api$Provider$Company$EmployeeDivision$delete, apiClient, companyId, id, toMsg);
    });
    var $author$project$Components$Company$EmployeeDivisions$formFieldsUpdate = F2(function(field, fields) {
        var string = field;
        return _Utils_update(fields, {
            zr: string
        });
    });
    var $author$project$Components$Company$EmployeeDivisions$NameValidation = 0;
    var $author$project$Components$Company$EmployeeDivisions$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a division name.'))
    ]));
    var $author$project$Components$Company$EmployeeDivisions$CompanyUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Company$Shared$encodeUpdateRequireDivisions = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('requires_employee_divisions', $elm$json$Json$Encode$bool(fields.YH))
            ])))
        ]));
    };
    var $author$project$Api$Employer$Company$updateRequireDivisions = F3(function(apiClient, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Employer$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdateRequireDivisions(fields), $author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
    });
    var $author$project$Api$Provider$Company$updateRequireDivisions = F4(function(apiClient, id_, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdateRequireDivisions(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Api$Company$updateRequireDivisions = F5(function(apiClient, session, id_, fields, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Company$updateRequireDivisions, apiClient, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4($author$project$Api$Provider$Company$updateRequireDivisions, apiClient, id_, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$Provider)));
    });
    var $author$project$Components$Company$EmployeeDivisions$updateCompanyRequireDivisions = F4(function(apiClient, session, id_, requireDivisions) {
        var fields = {
            YH: requireDivisions
        };
        return A5($author$project$Api$Company$updateRequireDivisions, apiClient, session, id_, fields, $author$project$Components$Company$EmployeeDivisions$CompanyUpdated);
    });
    var $author$project$Api$Company$Shared$encodeUpdateUsesDivisions = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('uses_employee_divisions', $elm$json$Json$Encode$bool(fields.aa0))
            ])))
        ]));
    };
    var $author$project$Api$Employer$Company$updateUsesDivisions = F3(function(apiClient, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Employer$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdateUsesDivisions(fields), $author$project$Api$Data$requestTo($author$project$Api$Employer$Company$companyPath)));
    });
    var $author$project$Api$Provider$Company$updateUsesDivisions = F4(function(apiClient, id_, fields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Company$Shared$encodeUpdateUsesDivisions(fields), $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Api$Company$updateUsesDivisions = F5(function(apiClient, session, id_, fields, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Company$updateUsesDivisions, apiClient, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$Employer))) : A4($author$project$Api$Provider$Company$updateUsesDivisions, apiClient, id_, fields, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$Provider)));
    });
    var $author$project$Components$Company$EmployeeDivisions$updateCompanyUsesDivisions = F4(function(apiClient, session, id_, usesDivisions) {
        var fields = {
            aa0: usesDivisions
        };
        return A5($author$project$Api$Company$updateUsesDivisions, apiClient, session, id_, fields, $author$project$Components$Company$EmployeeDivisions$CompanyUpdated);
    });
    var $author$project$Components$Company$EmployeeDivisions$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$EmployeeDivisions$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var bool = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    YH: bool
                }), A4($author$project$Components$Company$EmployeeDivisions$updateCompanyRequireDivisions, apiClient, model.Z$, $author$project$Api$Company$id(model.acy), bool), _List_Nil);
            case 2:
                var bool = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    YH: model.YH && bool,
                    aa0: bool
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A4($author$project$Components$Company$EmployeeDivisions$updateCompanyUsesDivisions, apiClient, model.Z$, $author$project$Api$Company$id(model.acy), bool),
                    A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.Z$, model.acy)
                ])), _List_Nil);
            case 3:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    xv: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var _v2 = function() {
                    var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$EmployeeDivisions$formFieldsValidator, model.PU);
                    if (!_v3.$) {
                        var _v4 = _v3.a;
                        var validatedForm = _v4.a;
                        var validFormFields = _v4.b;
                        return _Utils_Tuple2(_Utils_update(model, {
                            PU: validatedForm,
                            j_: $author$project$Api$Data$Loading
                        }), A4($author$project$Components$Company$EmployeeDivisions$addEmployeeDivision, apiClient, model.Z$, model.acy, validFormFields));
                    } else {
                        var validatedForm = _v3.a;
                        return _Utils_Tuple2(_Utils_update(model, {
                            PU: validatedForm,
                            j_: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none);
                    }
                }();
                var newModel = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(newModel, cmd, _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$RetrieveCompany($author$project$Api$Company$id(model.acy)),
                    A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var division = msg.a;
                return _Utils_Tuple3(model, A5($author$project$Api$EmployeeDivision$delete, apiClient, model.Z$, $author$project$Api$Company$id(model.acy), $author$project$Api$EmployeeDivision$All$id(division), $author$project$Components$Company$EmployeeDivisions$EmployeeDivisionDeleted(division)), _List_Nil);
            case 7:
                var division = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.Z$, model.acy), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$EmployeeDivision$All$name(division) + ' was successfully removed from this company')
                        ]));
                    case 2:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                var _v7 = $author$project$Components$Company$EmployeeDivisions$initFormFields;
                var formFields = _v7.a;
                var formFieldsCmd = _v7.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $author$project$Utils$Form$init(formFields)
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A3($author$project$Components$Company$EmployeeDivisions$listEmployeeDivisions, apiClient, model.Z$, model.acy),
                            formFieldsCmd
                        ])), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, ' A new division was successfully added to this company')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $author$project$Utils$Form$init(formFields)
                        }), formFieldsCmd, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Components$Company$Enrollment$AttemptedSave = {
        $: 1
    };
    var $author$project$Components$Company$Enrollment$BackBillPeriods = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$debounceBackBillingPeriod = function(_v0) {
        return A2($elm$core$Task$perform, $elm$core$Basics$identity, $elm$core$Task$succeed($author$project$Components$Company$Enrollment$AttemptedSave));
    };
    var $author$project$Components$Company$Enrollment$DebounceMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$debounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Company$Enrollment$DebounceMsg
    };
    var $author$project$Api$Employer$Company$EnrollmentSetting$backBillPeriods = function(_v0) {
        var record = _v0;
        return record.J3;
    };
    var $author$project$Api$Provider$Company$EnrollmentSetting$backBillPeriods = function(_v0) {
        var record = _v0;
        return record.J3;
    };
    var $author$project$Api$Company$EnrollmentSetting$backBillPeriods = function(signupSetting) {
        if (!signupSetting.$) {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting_);
        } else {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Employer$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting_);
        }
    };
    var $author$project$Api$Provider$Company$EnrollmentSetting$employeeInviteNotification = function(_v0) {
        var record = _v0;
        return record.OK;
    };
    var $author$project$Api$Company$EnrollmentSetting$employeeInviteNotification = function(signupSetting) {
        if (!signupSetting.$) {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$EnrollmentSetting$employeeInviteNotification(enrollmentSetting_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Employer$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function(_v0) {
        var record = _v0;
        return record.OY;
    };
    var $author$project$Api$Provider$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function(_v0) {
        var record = _v0;
        return record.OY;
    };
    var $author$project$Api$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth = function(signupSetting) {
        if (!signupSetting.$) {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting_);
        } else {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Employer$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting_);
        }
    };
    var $author$project$Api$Employer$Company$EnrollmentSetting$limitBackBill = function(_v0) {
        var record = _v0;
        return record.Tc;
    };
    var $author$project$Api$Provider$Company$EnrollmentSetting$limitBackBill = function(_v0) {
        var record = _v0;
        return record.Tc;
    };
    var $author$project$Api$Company$EnrollmentSetting$limitBackBill = function(signupSetting) {
        if (!signupSetting.$) {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$EnrollmentSetting$limitBackBill(enrollmentSetting_);
        } else {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Employer$Company$EnrollmentSetting$limitBackBill(enrollmentSetting_);
        }
    };
    var $author$project$Api$Employer$Company$EnrollmentSetting$numberDependentsAllowed = function(_v0) {
        var record = _v0;
        return record.Va;
    };
    var $author$project$Api$Provider$Company$EnrollmentSetting$numberDependentsAllowed = function(_v0) {
        var record = _v0;
        return record.Va;
    };
    var $author$project$Api$Company$EnrollmentSetting$numberDependentsAllowed = function(signupSetting) {
        if (!signupSetting.$) {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting_);
        } else {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Employer$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting_);
        }
    };
    var $author$project$Api$Employer$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function(_v0) {
        var record = _v0;
        return record.$V;
    };
    var $author$project$Api$Provider$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function(_v0) {
        var record = _v0;
        return record.$V;
    };
    var $author$project$Api$Company$EnrollmentSetting$terminationCutOffDayOfMonth = function(signupSetting) {
        if (!signupSetting.$) {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting_);
        } else {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Employer$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting_);
        }
    };
    var $author$project$Api$Employer$Company$EnrollmentSetting$useTerminationCutOffDate = function(_v0) {
        var record = _v0;
        return record.aaV;
    };
    var $author$project$Api$Provider$Company$EnrollmentSetting$useTerminationCutOffDate = function(_v0) {
        var record = _v0;
        return record.aaV;
    };
    var $author$project$Api$Company$EnrollmentSetting$useTerminationCutOffDate = function(signupSetting) {
        if (!signupSetting.$) {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Provider$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting_);
        } else {
            var enrollmentSetting_ = signupSetting.a;
            return $author$project$Api$Employer$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting_);
        }
    };
    var $author$project$Components$Company$Enrollment$formFieldsInitFromEnrollmentSetting = function(enrollmentSetting) {
        return {
            J3: $elm$core$String$fromInt($author$project$Api$Company$EnrollmentSetting$backBillPeriods(enrollmentSetting)),
            OK: A2($elm$core$Maybe$withDefault, 'practice_default', $author$project$Api$Company$EnrollmentSetting$employeeInviteNotification(enrollmentSetting)),
            OY: $author$project$Api$Company$EnrollmentSetting$enrollmentCutOffDayOfMonth(enrollmentSetting),
            Tc: $author$project$Api$Company$EnrollmentSetting$limitBackBill(enrollmentSetting),
            Va: $author$project$Api$Company$EnrollmentSetting$numberDependentsAllowed(enrollmentSetting),
            $V: $author$project$Api$Company$EnrollmentSetting$terminationCutOffDayOfMonth(enrollmentSetting),
            o9: $author$project$Api$Company$EnrollmentSetting$useTerminationCutOffDate(enrollmentSetting)
        };
    };
    var $author$project$Components$Company$Enrollment$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    Tc: bool
                });
            case 1:
                var value = field.a;
                return _Utils_update(fields, {
                    J3: value
                });
            case 2:
                var value = field.a;
                return _Utils_update(fields, {
                    Va: A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(value))
                });
            case 3:
                var value = field.a;
                return _Utils_update(fields, {
                    OY: A2($elm$core$Maybe$withDefault, 1, $elm$core$String$toInt(value))
                });
            case 4:
                var bool = field.a;
                return _Utils_update(fields, {
                    o9: bool
                });
            case 5:
                var value = field.a;
                return _Utils_update(fields, {
                    $V: A2($elm$core$Maybe$withDefault, 1, $elm$core$String$toInt(value))
                });
            default:
                var value = field.a;
                return _Utils_update(fields, {
                    OK: value
                });
        }
    });
    var $author$project$Components$Company$Enrollment$EnrollmentSettingUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$encodeBackBillPeriods = function(backBillPeriods) {
        var _v0 = $elm$core$String$toInt(backBillPeriods);
        if (!_v0.$) {
            var value = _v0.a;
            return _Utils_Tuple2('back_bill_periods', $elm$json$Json$Encode$int(value));
        } else return _Utils_Tuple2('back_bill_periods', $elm$json$Json$Encode$null);
    };
    var $author$project$Components$Company$Enrollment$encodeForm = F2(function(form, session) {
        var fields = $author$project$Utils$Form$fields(form);
        var encodedFields = _List_fromArray([
            _Utils_Tuple2('limit_back_bill', $elm$json$Json$Encode$bool(fields.Tc)),
            $author$project$Components$Company$Enrollment$encodeBackBillPeriods(fields.J3),
            _Utils_Tuple2('number_dependents_allowed', $elm$json$Json$Encode$int(fields.Va)),
            _Utils_Tuple2('enrollment_cutoff_day_of_month', $elm$json$Json$Encode$int(fields.OY)),
            _Utils_Tuple2('use_termination_cutoff_date', $elm$json$Json$Encode$bool(fields.o9)),
            _Utils_Tuple2('termination_cutoff_day_of_month', $elm$json$Json$Encode$int(fields.$V))
        ]);
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? encodedFields : A2($elm$core$List$cons, _Utils_Tuple2('employee_invite_notification', $author$project$Utils$String$encode(fields.OK)), encodedFields);
    });
    var $author$project$Api$Company$EnrollmentSetting$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Company$EnrollmentSetting$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Employer$Company$EnrollmentSetting$EnrollmentSetting = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Company$EnrollmentSetting$Record = F6(function(limitBackBill, backBillPeriods, numberDependentsAllowed, enrollmentCutOffDayOfMonth, useTerminationCutOffDate, terminationCutOffDayOfMonth) {
        return {
            J3: backBillPeriods,
            OY: enrollmentCutOffDayOfMonth,
            Tc: limitBackBill,
            Va: numberDependentsAllowed,
            $V: terminationCutOffDayOfMonth,
            aaV: useTerminationCutOffDate
        };
    });
    var $author$project$Api$Employer$Company$EnrollmentSetting$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_cutoff_day_of_month', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'use_termination_cutoff_date', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enrollment_cutoff_day_of_month', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_dependents_allowed', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'back_bill_periods', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'limit_back_bill', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Company$EnrollmentSetting$Record)))))));
    var $author$project$Api$Employer$Company$EnrollmentSetting$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Company$EnrollmentSetting$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Company$EnrollmentSetting$path = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'enrollment_settings'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Company$EnrollmentSetting$update = F3(function(apiClient, params, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Employer$Company$EnrollmentSetting$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, params, $author$project$Api$Data$requestTo($author$project$Api$Employer$Company$EnrollmentSetting$path)));
    });
    var $author$project$Api$Provider$Company$EnrollmentSetting$EnrollmentSetting = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Company$EnrollmentSetting$Record = F7(function(limitBackBill, backBillPeriods, numberDependentsAllowed, enrollmentCutOffDayOfMonth, useTerminationCutOffDate, terminationCutOffDayOfMonth, employeeInviteNotification) {
        return {
            J3: backBillPeriods,
            OK: employeeInviteNotification,
            OY: enrollmentCutOffDayOfMonth,
            Tc: limitBackBill,
            Va: numberDependentsAllowed,
            $V: terminationCutOffDayOfMonth,
            aaV: useTerminationCutOffDate
        };
    });
    var $author$project$Api$Provider$Company$EnrollmentSetting$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'employee_invite_notification', $elm$json$Json$Decode$maybe($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'termination_cutoff_day_of_month', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'use_termination_cutoff_date', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enrollment_cutoff_day_of_month', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'number_dependents_allowed', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'back_bill_periods', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'limit_back_bill', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Company$EnrollmentSetting$Record))))))));
    var $author$project$Api$Provider$Company$EnrollmentSetting$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Company$EnrollmentSetting$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Company$EnrollmentSetting$path = function(companyId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enrollment_settings'
        ]), $author$project$Api$Provider$Company$companyPath(companyId));
    };
    var $author$project$Api$Provider$Company$EnrollmentSetting$update = F4(function(apiClient, companyId, params, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$EnrollmentSetting$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, params, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$EnrollmentSetting$path(companyId))));
    });
    var $author$project$Api$Company$EnrollmentSetting$update = F5(function(apiClient, session, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('enrollment_settings', $elm$json$Json$Encode$object(params))
        ]));
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Company$EnrollmentSetting$update, apiClient, body, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$EnrollmentSetting$Employer))) : A4($author$project$Api$Provider$Company$EnrollmentSetting$update, apiClient, id, body, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Company$EnrollmentSetting$Provider)));
    });
    var $author$project$Components$Company$Enrollment$updateEnrollmentSetting = F4(function(form, apiClient, session, company) {
        return A5($author$project$Api$Company$EnrollmentSetting$update, apiClient, session, $author$project$Api$Company$id(company), A2($author$project$Components$Company$Enrollment$encodeForm, form, session), $author$project$Components$Company$Enrollment$EnrollmentSettingUpdated);
    });
    var $author$project$Components$Company$Enrollment$BackBillPeriodsValidation = 0;
    var $author$project$Components$Company$Enrollment$validateBackBillPeriods = function(_v0) {
        var backBillPeriods = _v0.J3;
        var _v1 = $elm$core$String$toInt(backBillPeriods);
        if (!_v1.$) return _List_Nil;
        else return _List_fromArray([
            _Utils_Tuple2(0, 'Please enter a backbilling period.')
        ]);
    };
    var $author$project$Components$Company$Enrollment$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Company$Enrollment$validateBackBillPeriods)
    ]));
    var $author$project$Components$Company$Enrollment$validateForm = function(enrollmentForm) {
        var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$Enrollment$formFieldsValidator, enrollmentForm);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var form = _v1.a;
            return _Utils_Tuple2(form, true);
        } else {
            var form = _v0.a;
            return _Utils_Tuple2(form, false);
        }
    };
    var $author$project$Components$Company$Enrollment$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$Enrollment$formFieldsUpdate, field, model.b7);
                return _Utils_Tuple3(_Utils_update(model, {
                    b7: newForm
                }), A2($elm$core$Task$perform, $elm$core$Basics$identity, $elm$core$Task$succeed($author$project$Components$Company$Enrollment$AttemptedSave)), _List_Nil);
            case 1:
                var _v2 = $author$project$Components$Company$Enrollment$validateForm(model.b7);
                var newForm = _v2.a;
                var isValid = _v2.b;
                return isValid ? _Utils_Tuple3(_Utils_update(model, {
                    b7: newForm,
                    Xv: true
                }), A4($author$project$Components$Company$Enrollment$updateEnrollmentSetting, newForm, apiClient, model.Z$, model.acy), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    b7: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var value = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$Enrollment$formFieldsUpdate, $author$project$Components$Company$Enrollment$BackBillPeriods(value), model.b7);
                var _v3 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Company$Enrollment$debounceConfig, value, model.h7);
                var debounce = _v3.a;
                var debounceCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    h7: debounce,
                    b7: newForm
                }), debounceCmd, _List_Nil);
            case 3:
                var dMsg = msg.a;
                var _v4 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Company$Enrollment$debounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Company$Enrollment$debounceBackBillingPeriod), dMsg, model.h7);
                var debounce = _v4.a;
                var debounceCmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    h7: debounce
                }), debounceCmd, _List_Nil);
            case 4:
                var enrollmentSettingData = msg.a;
                var newModel = _Utils_update(model, {
                    Xv: false
                });
                if (enrollmentSettingData.$ === 3) {
                    var enrollmentSetting = enrollmentSettingData.a;
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        b7: $author$project$Utils$Form$init($author$project$Components$Company$Enrollment$formFieldsInitFromEnrollmentSetting(enrollmentSetting))
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Company successfully updated')
                    ]));
                } else return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(enrollmentSettingData));
            default:
                var notificationSettingData = msg.a;
                var newModel = _Utils_update(model, {
                    U7: notificationSettingData
                });
                if (notificationSettingData.$ === 2) return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(notificationSettingData));
                else return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Company$Plans$CompanyPlanUpdated = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$GotPricingDetailsPlan = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$NewPlanSelected = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$CompanyPlan$ProviderOne = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$PlanAdded = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyPlan$create = F4(function(apiClient, companyId, planId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company_plan', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('plan', $author$project$Utils$Encode$association(planId))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CompanyPlan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId))));
    });
    var $author$project$Components$Company$Plans$createCompanyPlan = F3(function(apiClient, company, plan) {
        return A4($author$project$Api$Provider$CompanyPlan$create, apiClient, $author$project$Api$Company$id(company), $author$project$Api$Plan$id(plan), $author$project$Components$Company$Plans$PlanAdded);
    });
    var $author$project$Components$Company$Plans$defaultBillingFields = {
        I8: $elm$core$Maybe$Nothing,
        Nz: $elm$core$Maybe$Nothing,
        WA: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$Company$Plans$doesSupportPeriod = F2(function(plan, period) {
        return A2($elm$core$List$member, period, $author$project$Api$Plan$periods(plan));
    });
    var $author$project$Api$Employer$CompanyPlan$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$CompanyPlan$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$CompanyPlan$Shared$id(shared);
    };
    var $author$project$Api$Provider$CompanyPlan$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CompanyPlan$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyPlan$Shared$id(shared);
    };
    var $author$project$Api$Provider$CompanyPlan$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$CompanyPlan$One$id(one);
    };
    var $author$project$Api$CompanyPlan$id = function(companyPlan) {
        switch(companyPlan.$){
            case 0:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Provider$CompanyPlan$One$id(companyPlan_);
            case 1:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Provider$CompanyPlan$All$id(companyPlan_);
            default:
                var companyPlan_ = companyPlan.a;
                return $author$project$Api$Employer$CompanyPlan$All$id(companyPlan_);
        }
    };
    var $author$project$Api$Plan$coveragePlan = function(plan) {
        switch(plan.$){
            case 0:
                return $author$project$Api$Expandable$NotExpanded;
            case 1:
                return $author$project$Api$Expandable$NotExpanded;
            case 4:
                return $author$project$Api$Expandable$NotExpanded;
            case 2:
                return $author$project$Api$Expandable$NotExpanded;
            case 6:
                return $author$project$Api$Expandable$NotExpanded;
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$coveragePlan(plan_);
            default:
                return $author$project$Api$Expandable$NotExpanded;
        }
    };
    var $author$project$Components$Company$Plans$initCoveragePlanRules = F3(function(apiClient, model, plan) {
        var _v0 = A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Plan$coveragePlan(plan));
        if (!_v0.$) {
            var coveragePlan = _v0.a;
            return A3($elm$core$Tuple$mapBoth, $elm$core$Maybe$Just, $elm$core$Platform$Cmd$map($author$project$Components$Company$Plans$CoveragePlanMsg), A6($author$project$Components$Admin$CoveragePlans$Rules$init, apiClient, model.Z$, $elm$core$Maybe$Just($author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)), $author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan), $elm$core$Maybe$Nothing, {
                Ya: true
            }));
        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Api$Employer$Company$One$activeMembershipsCount = function(_v0) {
        var record = _v0.b;
        return record.Iw;
    };
    var $author$project$Api$Provider$Company$One$activeMembershipsCount = function(_v0) {
        var record = _v0.b;
        return record.Iw;
    };
    var $author$project$Api$Company$activeMembershipsCount = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$activeMembershipsCount(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$activeMembershipsCount(company_);
        }
    };
    var $author$project$Components$Company$Plans$hasActiveMemberships = function(company) {
        return $author$project$Api$Company$activeMembershipsCount(company) > 0;
    };
    var $author$project$Api$Period$retrieveByNumberOfMonths = function(number) {
        return A2($elm_community$list_extra$List$Extra$find, function(_v0) {
            var period = _v0;
            return _Utils_eq(period.jk, number);
        }, $author$project$Api$Period$list);
    };
    var $author$project$Components$Company$Plans$plansWithoutPeriod = F2(function(newBillingPeriod, companyPlans) {
        var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths(newBillingPeriod);
        if (!maybePeriod.$) {
            var period = maybePeriod.a;
            return A2($elm$core$List$filter, function(plan) {
                return !A2($elm$core$List$member, period, $author$project$Api$Plan$periods(plan));
            }, A2($elm$core$List$map, $author$project$Api$CompanyPlan$plan, companyPlans));
        } else return _List_Nil;
    });
    var $author$project$Components$Company$Plans$needsBillingChangeConfirmation = F3(function(company, newBillingPeriod, companyPlans) {
        return $author$project$Components$Company$Plans$hasActiveMemberships(company) || $elm$core$List$length(A2($author$project$Components$Company$Plans$plansWithoutPeriod, newBillingPeriod, companyPlans)) > 0;
    });
    var $author$project$Api$Employer$Company$Shared$periodInMonths = function(_v0) {
        var record = _v0;
        return record.WA;
    };
    var $author$project$Api$Employer$Company$One$periodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$periodInMonths(shared);
    };
    var $author$project$Api$Provider$Company$Shared$periodInMonths = function(_v0) {
        var record = _v0;
        return record.WA;
    };
    var $author$project$Api$Provider$Company$One$periodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$periodInMonths(shared);
    };
    var $author$project$Api$Company$periodInMonths = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$periodInMonths(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$periodInMonths(company_);
        }
    };
    var $author$project$Components$Company$Plans$PlanDeleted = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CompanyPlan$companyPlanPath = F2(function(companyId, companyPlanId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            companyPlanId
        ]), $author$project$Api$Provider$CompanyPlan$companyPlansPath(companyId));
    });
    var $author$project$Api$Provider$CompanyPlan$delete = F4(function(apiClient, companyId, companyPlanId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$CompanyPlan$companyPlanPath, companyId, companyPlanId)));
    });
    var $author$project$Components$Company$Plans$removeCompanyPlan = F3(function(apiClient, company, companyPlan) {
        var companyPlanId = $author$project$Api$CompanyPlan$id(companyPlan);
        return A4($author$project$Api$Provider$CompanyPlan$delete, apiClient, $author$project$Api$Company$id(company), companyPlanId, $author$project$Components$Company$Plans$PlanDeleted(companyPlanId));
    });
    var $author$project$Components$Company$Plans$resetCompanyPlansOnToggleChange = function(model) {
        var _v0 = _Utils_Tuple2(model.Nz, model.gd);
        if (!_v0.a.$ && !_v0.b) {
            var defaultPlan = _v0.a.a;
            return A2($elm$core$List$filter, function(c) {
                return _Utils_eq($author$project$Api$Plan$id($author$project$Api$CompanyPlan$plan(c)), $author$project$Api$Plan$id(defaultPlan));
            }, model.al);
        } else return model.al;
    };
    var $author$project$Components$Company$Plans$showResponseMessage = F2(function(response, successMessage) {
        if (response.$ === 3) return _List_fromArray([
            A2($author$project$OutMsg$ShowToast, 3, successMessage)
        ]);
        else return $author$project$OutMsg$handleErrorResponse(response);
    });
    var $author$project$Api$Provider$CompanyPlan$update = F5(function(apiClient, companyId, companyPlanId, availableForEnrollment_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company_plan', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('available_for_enrollment', $elm$json$Json$Encode$bool(availableForEnrollment_))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$CompanyPlan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$CompanyPlan$companyPlanPath, companyId, companyPlanId))));
    });
    var $author$project$Components$Company$Plans$CompanyUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$updateAffiliateBilling = F4(function(apiClient, id_, billAffiliateRate, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('bill_affiliate_rate', $elm$json$Json$Encode$bool(billAffiliateRate))
            ])))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$Plans$updateCompanyAffiliateBilling = F3(function(apiClient, company, billAffiliateRate) {
        var companyId = $author$project$Api$Company$id(company);
        return A4($author$project$Api$Provider$Company$updateAffiliateBilling, apiClient, companyId, billAffiliateRate, A2($elm$core$Basics$composeL, $author$project$Components$Company$Plans$CompanyUpdated, $author$project$Api$Data$map($author$project$Api$Company$Provider)));
    });
    var $author$project$Api$Provider$Company$updateBilling = F6(function(apiClient, id_, periodInMonths, allowCustomMembershipPlan, defaultPlanId, toMsg) {
        var defaultPlanAssociation = function(defaultPlanId_) {
            return $elm$core$Maybe$Just({
                aef: $elm$core$Maybe$Just(defaultPlanId_),
                ah5: $elm$core$Maybe$Nothing
            });
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object(_Utils_ap(A3($author$project$Utils$Encode$optional, 'period_in_months', $elm$json$Json$Encode$int, periodInMonths), _Utils_ap(A3($author$project$Utils$Encode$optional, 'allow_custom_membership_plan', $elm$json$Json$Encode$bool, allowCustomMembershipPlan), A3($author$project$Utils$Encode$optional, 'default_plan', $author$project$Utils$Encode$typedAssociation, A2($elm$core$Maybe$andThen, defaultPlanAssociation, defaultPlanId))))))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companyPath(id_))));
    });
    var $author$project$Components$Company$Plans$updateCompanyBilling = F3(function(apiClient, company, fields) {
        var defaultPlanId = A2($elm$core$Maybe$map, $author$project$Api$Plan$id, fields.Nz);
        var companyId = $author$project$Api$Company$id(company);
        return A6($author$project$Api$Provider$Company$updateBilling, apiClient, companyId, fields.WA, fields.I8, defaultPlanId, A2($elm$core$Basics$composeL, $author$project$Components$Company$Plans$CompanyUpdated, $author$project$Api$Data$map($author$project$Api$Company$Provider)));
    });
    var $author$project$Components$Company$Plans$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var text = msg.a;
                var newBillingPeriod = $elm$core$String$toInt(text);
                if (!newBillingPeriod.$) {
                    var newBillingPeriod_ = newBillingPeriod.a;
                    return A3($author$project$Components$Company$Plans$needsBillingChangeConfirmation, model.acy, newBillingPeriod_, model.al) ? _Utils_Tuple3(_Utils_update(model, {
                        by: newBillingPeriod,
                        oj: false
                    }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        by: newBillingPeriod,
                        oj: false
                    }), A3($author$project$Components$Company$Plans$updateCompanyBilling, apiClient, model.acy, _Utils_update($author$project$Components$Company$Plans$defaultBillingFields, {
                        WA: newBillingPeriod
                    })), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    oj: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var enabled = msg.a;
                if (enabled) return _Utils_Tuple3(_Utils_update(model, {
                    gd: true
                }), A3($author$project$Components$Company$Plans$updateCompanyBilling, apiClient, model.acy, _Utils_update($author$project$Components$Company$Plans$defaultBillingFields, {
                    I8: $elm$core$Maybe$Just(true)
                })), _List_Nil);
                else {
                    if ($elm$core$List$length(model.al) > 1) return _Utils_Tuple3(_Utils_update(model, {
                        hi: true
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                    else {
                        var cmds = $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A3($author$project$Components$Company$Plans$updateCompanyBilling, apiClient, model.acy, _Utils_update($author$project$Components$Company$Plans$defaultBillingFields, {
                                I8: $elm$core$Maybe$Just(false)
                            })),
                            A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, model.Z$, model.acy)
                        ]));
                        return _Utils_Tuple3(_Utils_update(model, {
                            gd: false
                        }), cmds, _List_Nil);
                    }
                }
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var companyPlans = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        al: companyPlans
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var company = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        acy: company,
                        al: $author$project$Components$Company$Plans$resetCompanyPlansOnToggleChange(model)
                    }), $elm$core$Platform$Cmd$none, A2($author$project$Components$Company$Plans$showResponseMessage, response, 'Company successfully updated'));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var confirmed = msg.a;
                if (confirmed) {
                    var _v4 = model.by;
                    if (!_v4.$) return _Utils_Tuple3(_Utils_update(model, {
                        by: $elm$core$Maybe$Nothing
                    }), A3($author$project$Components$Company$Plans$updateCompanyBilling, apiClient, model.acy, _Utils_update($author$project$Components$Company$Plans$defaultBillingFields, {
                        WA: model.by
                    })), _List_Nil);
                    else return _Utils_Tuple3(_Utils_update(model, {
                        by: $elm$core$Maybe$Nothing
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    by: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var confirmed = msg.a;
                if (confirmed) {
                    var defaultPlanChanged = function(plan) {
                        var _v5 = $author$project$Api$Company$defaultPlan(model.acy);
                        if (!_v5.$) {
                            var defaultPlan = _v5.a;
                            return !_Utils_eq($author$project$Api$Plan$id(plan), $author$project$Api$Plan$id(defaultPlan));
                        } else return false;
                    };
                    var newDefaultPlan = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, defaultPlanChanged, model.Nz)) ? model.Nz : $elm$core$Maybe$Nothing;
                    return _Utils_Tuple3(_Utils_update(model, {
                        qo: false,
                        gd: false,
                        hi: false
                    }), A3($author$project$Components$Company$Plans$updateCompanyBilling, apiClient, model.acy, {
                        I8: $elm$core$Maybe$Just(false),
                        Nz: newDefaultPlan,
                        WA: model.by
                    }), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    hi: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var enabled = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    qo: enabled
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var subMsg = msg.a;
                var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jy);
                var _v6 = function() {
                    var _v7 = planResourceResult.adu;
                    if (!_v7.$) {
                        if (!_v7.a.$) {
                            var _v8 = $author$project$Components$ResourceFilter$Plan$value(planResourceResult.zi);
                            if (!_v8.$) {
                                var selectedPlanId = _v8.a;
                                return model.du ? _Utils_Tuple2(model, A4($author$project$Components$Company$Plans$retrievePlan, apiClient, model.Z$, selectedPlanId, $author$project$Components$Company$Plans$NewPlanSelected)) : _Utils_Tuple2(_Utils_update(model, {
                                    hi: true
                                }), A4($author$project$Components$Company$Plans$retrievePlan, apiClient, model.Z$, selectedPlanId, $author$project$Components$Company$Plans$GotDefaultPlan));
                            } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                        } else {
                            var _v9 = _v7.a;
                            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                        }
                    } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }();
                var modelAfterEvent = _v6.a;
                var resourceEvent = _v6.b;
                return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
                    jy: planResourceResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$PlanResourceFilterMsg, planResourceResult.EQ),
                    resourceEvent
                ])), planResourceResult.at);
            case 9:
                var response = msg.a;
                if (response.$ === 3) {
                    var plan = response.a;
                    var _v11 = A3($author$project$Components$Company$Plans$initCoveragePlanRules, apiClient, model, plan);
                    var coveragePlanRules = _v11.a;
                    var coveragePlanRulesCmd = _v11.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mn: coveragePlanRules,
                        Nz: $elm$core$Maybe$Just(plan)
                    }), coveragePlanRulesCmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 10:
                return _Utils_Tuple3(_Utils_update(model, {
                    du: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var maybePlan = msg.a;
                if (!maybePlan.$) {
                    var plan = maybePlan.a;
                    return _Utils_Tuple3(model, A3($author$project$Components$Company$Plans$removeCompanyPlan, apiClient, model.acy, plan), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    du: false,
                    ej: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var response = msg.a;
                var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths($author$project$Api$Company$periodInMonths(model.acy));
                var _v13 = _Utils_Tuple2(response, maybePeriod);
                if (_v13.a.$ === 3 && !_v13.b.$) {
                    var _v14 = _v13.a;
                    var plan = _v14.a;
                    var period = _v13.b.a;
                    return A2($author$project$Components$Company$Plans$doesSupportPeriod, plan, period) ? _Utils_Tuple3(_Utils_update(model, {
                        du: false
                    }), A3($author$project$Components$Company$Plans$createCompanyPlan, apiClient, model.acy, plan), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        ej: $elm$core$Maybe$Just(plan)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 13:
                var companyPlanId = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    al: A2($elm$core$List$filter, function(c) {
                        return !_Utils_eq($author$project$Api$CompanyPlan$id(c), companyPlanId);
                    }, model.al)
                }), $elm$core$Platform$Cmd$none, A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully removed from this company'));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                var response = msg.a;
                var _v16 = A2($author$project$Api$Data$map, $author$project$Api$CompanyPlan$ProviderOne, response);
                if (_v16.$ === 3) {
                    var plan = _v16.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        al: A2($elm$core$List$cons, plan, model.al)
                    }), $elm$core$Platform$Cmd$none, A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully added to this company'));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 15:
                var plan = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A3($author$project$Components$Company$Plans$updateCompanyBilling, apiClient, model.acy, _Utils_update($author$project$Components$Company$Plans$defaultBillingFields, {
                        Nz: $elm$core$Maybe$Just(plan)
                    })),
                    A4($author$project$Components$Company$Plans$retrievePlan, apiClient, model.Z$, $author$project$Api$Plan$id(plan), $author$project$Components$Company$Plans$GotDefaultPlan)
                ])), _List_Nil);
            case 16:
                var plan = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Mn: $elm$core$Maybe$Nothing,
                    j2: $elm$core$Maybe$Nothing
                }), A4($author$project$Components$Company$Plans$retrievePlan, apiClient, model.Z$, $author$project$Api$Plan$id(plan), $author$project$Components$Company$Plans$GotPricingDetailsPlan), _List_Nil);
            case 17:
                var companyPlan = msg.a;
                var availableForEnrollment = msg.b;
                return _Utils_Tuple3(model, A5($author$project$Api$Provider$CompanyPlan$update, apiClient, $author$project$Api$Company$id(model.acy), $author$project$Api$CompanyPlan$id(companyPlan), availableForEnrollment, $author$project$Components$Company$Plans$CompanyPlanUpdated), _List_Nil);
            case 20:
                var response = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Components$Company$Plans$listCompanyPlans, apiClient, model.Z$, model.acy), A2($author$project$Components$Company$Plans$showResponseMessage, response, 'The plan was successfully update'));
            case 18:
                var confirmed = msg.a;
                var _v17 = _Utils_Tuple2(confirmed, model.ej);
                if (_v17.a && !_v17.b.$) {
                    var newPlanRow = _v17.b.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        du: false,
                        ej: $elm$core$Maybe$Nothing
                    }), A3($author$project$Components$Company$Plans$createCompanyPlan, apiClient, model.acy, newPlanRow), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    du: false,
                    ej: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                return _Utils_Tuple3(_Utils_update(model, {
                    j2: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 21:
                var response = msg.a;
                if (response.$ === 3) {
                    var plan = response.a;
                    var _v19 = A3($author$project$Components$Company$Plans$initCoveragePlanRules, apiClient, model, plan);
                    var coveragePlanRules = _v19.a;
                    var coveragePlanRulesCmd = _v19.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mn: coveragePlanRules,
                        j2: $elm$core$Maybe$Just(plan)
                    }), coveragePlanRulesCmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 22:
                var subMsg = msg.a;
                var _v20 = model.Mn;
                if (!_v20.$) {
                    var coveragePlan = _v20.a;
                    var _v21 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, coveragePlan);
                    var newCoveragePlan = _v21.a;
                    var coveragePlanCmd = _v21.b;
                    var coveragePlanOutMsgs = _v21.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mn: $elm$core$Maybe$Just(newCoveragePlan)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Company$Plans$CoveragePlanMsg, coveragePlanCmd), coveragePlanOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var billAffiliateRate = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Components$Company$Plans$updateCompanyAffiliateBilling, apiClient, model.acy, billAffiliateRate), _List_Nil);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$Company$ContactForm$update, model.Ej, subMsg, model.hX);
                var newContactForm = _v1.a;
                var contactFormCmd = _v1.b;
                var contactFormOutMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    hX: newContactForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd), contactFormOutMsgs);
            case 1:
                var subMsg = msg.a;
                var _v2 = model.lD;
                if (!_v2.$) {
                    var companyDeals = _v2.a;
                    var _v3 = A3($author$project$Components$Company$CommissionDeals$update, model.Ej, subMsg, companyDeals);
                    var newCommissionDeals = _v3.a;
                    var commissionDealsCmd = _v3.b;
                    var commissionDealsOutMsgs = _v3.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lD: $elm$core$Maybe$Just(newCommissionDeals)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg, commissionDealsCmd), commissionDealsOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v4 = A3($author$project$Components$Company$Plans$update, model.Ej, subMsg, model.al);
                var newCompanyPlans = _v4.a;
                var companyPlansCmd = _v4.b;
                var companyPlansOutMsgs = _v4.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    al: newCompanyPlans
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd), companyPlansOutMsgs);
            case 3:
                var subMsg = msg.a;
                var _v5 = model.lE;
                if (!_v5.$) {
                    var companyAdmins = _v5.a;
                    var _v6 = A3($author$project$Components$Company$Admins$update, model.Ej, subMsg, companyAdmins);
                    var newCompanyAdmins = _v6.a;
                    var companyAdminsCmd = _v6.b;
                    var companyAdminsOutMsgs = _v6.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lE: $elm$core$Maybe$Just(newCompanyAdmins)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg, companyAdminsCmd), companyAdminsOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v7 = model.h8;
                if (!_v7.$) {
                    var defaultProvider = _v7.a;
                    var _v8 = A3($author$project$Components$Company$DefaultProvider$update, model.Ej, subMsg, defaultProvider);
                    var newProvider = _v8.a;
                    var defaultProviderCmd = _v8.b;
                    var defaultProviderOutMsgs = _v8.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        h8: $elm$core$Maybe$Just(newProvider)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg, defaultProviderCmd), defaultProviderOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var subMsg = msg.a;
                var _v9 = model.Nr;
                if (!_v9.$) {
                    var defaultLocation = _v9.a;
                    var _v10 = A3($author$project$Components$Company$DefaultLocation$update, model.Ej, subMsg, defaultLocation);
                    var newLocation = _v10.a;
                    var defaultLocationCmd = _v10.b;
                    var defaultLocationOutMsgs = _v10.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Nr: $elm$core$Maybe$Just(newLocation)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg, defaultLocationCmd), defaultLocationOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var subMsg = msg.a;
                var _v11 = model.No;
                if (!_v11.$) {
                    var defaultAffiliation = _v11.a;
                    var _v12 = A3($author$project$Components$Company$DefaultAffiliation$update, model.Ej, subMsg, defaultAffiliation);
                    var newAffiliation = _v12.a;
                    var defaultAffiliationCmd = _v12.b;
                    var defaultAffiliationOutMsgs = _v12.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        No: $elm$core$Maybe$Just(newAffiliation)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, defaultAffiliationCmd), defaultAffiliationOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var subMsg = msg.a;
                var _v13 = A3($author$project$Components$Company$EmployeeDivisions$update, model.Ej, subMsg, model.xv);
                var newDivision = _v13.a;
                var employeeDivisionsCmd = _v13.b;
                var employeeDivisionsOutMsgs = _v13.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    xv: newDivision
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd), employeeDivisionsOutMsgs);
            case 8:
                var subMsg = msg.a;
                var _v14 = model.lS;
                if (!_v14.$) {
                    var deactivateSponsor = _v14.a;
                    var _v15 = A3($author$project$Components$Company$DeactivateSponsor$update, model.Ej, subMsg, deactivateSponsor);
                    var sponsor = _v15.a;
                    var deactivateSponsorCmd = _v15.b;
                    var deactivateSponsorOutMsgs = _v15.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lS: $elm$core$Maybe$Just(sponsor)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg, deactivateSponsorCmd), deactivateSponsorOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v16 = A3($author$project$Components$Company$Enrollment$update, model.Ej, subMsg, model.ma);
                var enrollmentModel = _v16.a;
                var enrollmentCmd = _v16.b;
                var enrollmentOutMsgs = _v16.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    ma: enrollmentModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg, enrollmentCmd), enrollmentOutMsgs);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var company = response.a;
                    var _v18 = A4($author$project$Components$Company$EmployeeDivisions$init, model.Ej, company, model.W1, model.Z$);
                    var employeeDivisions = _v18.a;
                    var employeeDivisionsCmd = _v18.b;
                    var _v19 = function() {
                        var _v20 = _Utils_Tuple2(company, model.W1);
                        if (!_v20.a.$ && !_v20.b.$) {
                            var company_ = _v20.a.a;
                            var practice_ = _v20.b.a;
                            return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A3($author$project$Components$Company$DefaultProvider$init, company_, practice_, model.Ej));
                        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                    }();
                    var defaultProvider = _v19.a;
                    var defaultProviderCmd = _v19.b;
                    var _v21 = function() {
                        var _v22 = _Utils_Tuple2(company, model.W1);
                        if (!_v22.a.$ && !_v22.b.$) {
                            var company_ = _v22.a.a;
                            var practice_ = _v22.b.a;
                            return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A3($author$project$Components$Company$DefaultLocation$init, company_, practice_, model.Ej));
                        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                    }();
                    var defaultLocation = _v21.a;
                    var defaultLocationCmd = _v21.b;
                    var _v23 = function() {
                        var _v24 = _Utils_Tuple2(company, model.W1);
                        if (!_v24.a.$ && !_v24.b.$) {
                            var company_ = _v24.a.a;
                            var practice_ = _v24.b.a;
                            return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Components$Company$DefaultAffiliation$init, model.Z$, company_, practice_, model.Ej));
                        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                    }();
                    var defaultAffiliation = _v23.a;
                    var defaultAffiliationCmd = _v23.b;
                    var _v25 = A3($author$project$Components$Company$ContactForm$init, company, model.W1, model.Z$);
                    var contactForm = _v25.a;
                    var contactFormCmd = _v25.b;
                    var _v26 = A4($author$project$Components$Company$Plans$init, model.Ej, company, model.W1, model.Z$);
                    var companyPlans = _v26.a;
                    var companyPlansCmd = _v26.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        al: companyPlans,
                        hX: contactForm,
                        No: defaultAffiliation,
                        Nr: defaultLocation,
                        h8: defaultProvider,
                        xv: employeeDivisions
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg, defaultLocationCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg, defaultProviderCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, defaultAffiliationCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, employeeDivisionsCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, contactFormCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, companyPlansCmd)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Permission$disallowForRoles = F2(function(session, roles) {
        return A2($elm$core$List$member, $author$project$Api$Platform$Session$One$role(session), roles);
    });
    var $author$project$Ui$Panel$Hr = {
        $: 4
    };
    var $author$project$Ui$Panel$hr = $author$project$Ui$Panel$Hr;
    var $author$project$Components$Company$CommissionDeals$Create = {
        $: 3
    };
    var $author$project$Components$Company$CommissionDeals$view = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg, $author$project$Components$BrokerDeal$Table$modal(model.dy)),
            function() {
                var _v0 = model.h$;
                if (!_v0.$) {
                    var createModal = _v0.a;
                    return A2($elm$html$Html$map, $author$project$Components$Company$CommissionDeals$CreateModalMsg, $author$project$Components$BrokerDeal$CreateModal$view(createModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsStart
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Allocate a share of revenue from the employer to a broker. You can manage broker accounts ')
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('here')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('. ')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('If you need to remove a deal, make sure that it is ended first.')
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textRight,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions({
                        fl: $author$project$Api$Provider$Company$One$id(model.acy)
                    }), _List_Nil, _List_fromArray([
                        $elm$html$Html$text('See Ended Deals')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Add broker deal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$Company$CommissionDeals$Create),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add Broker Deal')
                    ]))
                ]))
            ])),
            A2($elm$html$Html$map, $author$project$Components$Company$CommissionDeals$BrokerDealsTableMsg, A2($author$project$Components$BrokerDeal$Table$view, _List_fromArray([
                $author$project$Components$BrokerDeal$Table$loading(!$author$project$Api$Data$isSuccess(model.Kq))
            ]), model.dy))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewComissionedDeals = function(model) {
        var _v0 = model.W1;
        if (!_v0.$) {
            var practice_ = _v0.a;
            var _v1 = _Utils_Tuple3(model.lD, $author$project$Api$Provider$Practice$One$commissionsEnabled(practice_), !A2($author$project$Permission$disallowForRoles, model.Z$, _List_fromArray([
                'practice_staff_limited'
            ])));
            if (!_v1.a.$ && _v1.b && _v1.c) {
                var commissionDeals = _v1.a.a;
                return _List_fromArray([
                    $author$project$Ui$Panel$hr,
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Commission Deals')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$CommissionDealsMsg, $author$project$Components$Company$CommissionDeals$view(commissionDeals))
                    ]))
                ]);
            } else return _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Components$Company$Admins$CancelNewAdmin = {
        $: 7
    };
    var $author$project$Components$Company$Admins$Email = $elm$core$Basics$identity;
    var $author$project$Components$Company$Admins$FormUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Company$Admins$Invite = {
        $: 3
    };
    var $author$project$Components$Company$Admins$addingUserRow = function(model) {
        if (model.dv) {
            var fields = $author$project$Utils$Form$fields(model.bo);
            return _List_fromArray([
                A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_fromArray([
                        $author$project$Ui$Table$cellSpan(3)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(fields.OH),
                            $author$project$Ui$Form$Input$placeholder('gsumner@example.com'),
                            $author$project$Ui$Form$Input$autofocus(true),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Company$Admins$FormUpdated, $elm$core$Basics$identity)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.bo)),
                            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.bo))
                        ]))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_fromArray([
                        $author$project$Ui$Table$cellSpan(3)
                    ]), _List_Nil),
                    A2($author$project$Ui$Table$cell, _List_fromArray([
                        $author$project$Ui$Table$cellSpan(3)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Create and invite adminisitrator'
                            }, _List_fromArray([
                                $author$project$Ui$Button$size(0),
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$onClick($author$project$Components$Company$Admins$Invite),
                                $author$project$Ui$Button$disabled($author$project$Api$Provider$Company$One$isInactive(model.acy))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Create and Invite')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Cancel'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$size(0),
                                $author$project$Ui$Button$onClick($author$project$Components$Company$Admins$CancelNewAdmin),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ]))
                        ]))
                    ]))
                ]))
            ]);
        } else return _List_Nil;
    };
    var $author$project$Api$Provider$CompanyAdmin$Shared$user = function(_v0) {
        var record = _v0;
        return record.aaX;
    };
    var $author$project$Api$Provider$CompanyAdmin$One$user = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAdmin$Shared$user(shared);
    };
    var $author$project$Api$Provider$CompanyAdmin$All$user = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$CompanyAdmin$One$user(one);
    };
    var $author$project$Components$InviteLink$CompanyAdmin = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$Admins$Delete = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyAdmin$Shared$isDestroyable = function(_v0) {
        var record = _v0;
        return record.R1;
    };
    var $author$project$Api$Provider$CompanyAdmin$One$isDestroyable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAdmin$Shared$isDestroyable(shared);
    };
    var $author$project$Api$Provider$CompanyAdmin$All$isDestroyable = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$CompanyAdmin$One$isDestroyable(one);
    };
    var $author$project$Components$Company$Admins$deleteLink = F2(function(processing, admin) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Remove administrator'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$size(0),
            $author$project$Ui$Button$onClick($author$project$Components$Company$Admins$Delete(admin)),
            $author$project$Ui$Button$disabled(!$author$project$Api$Provider$CompanyAdmin$All$isDestroyable(admin) || processing),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
        ]), _List_fromArray([
            $elm$html$Html$text('Remove')
        ]));
    });
    var $author$project$Components$Company$Admins$ReInvite = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Company$Admins$resendInvite = function(admin) {
        return $author$project$Api$Provider$CompanyAdmin$All$invitationPending(admin) ? A3($author$project$Ui$Button$view, {
            abP: 'Resend invite'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$size(0),
            $author$project$Ui$Button$onClick($author$project$Components$Company$Admins$ReInvite(admin)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
        ]), _List_fromArray([
            $elm$html$Html$text('Resend invite')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$Admins$userActions = F2(function(processing, admin) {
        return _List_fromArray([
            $author$project$Components$Company$Admins$resendInvite(admin),
            A2($elm$html$Html$map, $author$project$Components$Company$Admins$InviteLinkMsg, $author$project$Components$InviteLink$view($author$project$Components$InviteLink$CompanyAdmin(admin))),
            A2($author$project$Components$Company$Admins$deleteLink, processing, admin)
        ]);
    });
    var $author$project$Components$Company$Admins$viewAdmin = F2(function(processing, admin) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$CompanyAdmin$All$email(admin))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$User$Shared$name, $author$project$Api$Provider$CompanyAdmin$All$user(admin))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$justifyRight
                ]), A2($author$project$Components$Company$Admins$userActions, processing, admin))
            ]))
        ]));
    });
    var $author$project$Components$Company$Admins$viewAdminsList = function(model) {
        var _v0 = function() {
            var _v1 = model.pq;
            if (_v1.$ === 3) {
                var admins_ = _v1.a;
                return _Utils_Tuple2(false, admins_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var admins = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Email')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Name')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), _Utils_ap($author$project$Components$Company$Admins$addingUserRow(model), A2($elm$core$List$map, $author$project$Components$Company$Admins$viewAdmin(model.Xv), admins)), _List_Nil);
    };
    var $author$project$Components$Company$Admins$AddAdminClicked = {
        $: 6
    };
    var $author$project$Components$Company$Admins$viewNewAdminButton = function(cannotAddUser) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Add new administrator'
        }, _List_fromArray([
            $author$project$Ui$Button$onClick($author$project$Components$Company$Admins$AddAdminClicked),
            $author$project$Ui$Button$pull(1),
            $author$project$Ui$Button$disabled(cannotAddUser),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
        ]), _List_fromArray([
            $elm$html$Html$text('New Administrator')
        ]));
    };
    var $author$project$Components$Company$Admins$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsStart,
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('These individuals will receive all emails.')
                ])),
                $author$project$Components$Company$Admins$viewNewAdminButton(model.dv || $author$project$Api$Provider$Company$One$isInactive(model.acy))
            ])),
            $author$project$Components$Company$Admins$viewAdminsList(model)
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewCompanyAdmins = function(model) {
        var _v0 = model.W1;
        if (!_v0.$) {
            var _v1 = model.lE;
            if (!_v1.$) {
                var companyAdmins = _v1.a;
                return _List_fromArray([
                    $author$project$Ui$Panel$hr,
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text(A2($author$project$Api$Practice$sponsorize, model.W1, 'Company') + ' Administrators')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyAdminsMsg, $author$project$Components$Company$Admins$view(companyAdmins))
                    ]))
                ]);
            } else return _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Components$Company$Plans$periodName = function(periodInMonths) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Period$billName, $author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)));
    };
    var $author$project$Components$Company$Plans$planWithoutPeriodMessage = F2(function(period, plan) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Icon$cross(_List_fromArray([
                $author$project$Ui$Icon$danger
            ])),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(' The plan ')
            ])),
            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Plan$name(plan))
            ])),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(' does not have ' + ($author$project$Components$Company$Plans$periodName(period) + ' pricing enabled'))
            ])),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(' so rates will be calculated based on ' + ($author$project$Components$Company$Plans$periodName($author$project$Api$Plan$defaultPeriodInMonths(plan)) + ' rates.'))
            ]))
        ]));
    });
    var $author$project$Components$Company$Plans$addPlanConfirmModal = function(model) {
        var _v0 = model.ej;
        if (!_v0.$) {
            var newPlanRow = _v0.a;
            var companyPeriod = $author$project$Api$Company$periodInMonths(model.acy);
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Company$Plans$HiConfirmPlanAddClosed, _List_fromArray([
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        A2($author$project$Components$Company$Plans$planWithoutPeriodMessage, companyPeriod, newPlanRow)
                    ]))
                ])),
                $author$project$Components$HiConfirm$noun('Plan'),
                $author$project$Components$HiConfirm$verb('Add')
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$Plans$allowBillingPeriodChangeModal = function(model) {
        var _v0 = model.by;
        if (!_v0.$) {
            var newBillingPeriod = _v0.a;
            var plansWithoutPeriod_ = A2($author$project$Components$Company$Plans$plansWithoutPeriod, newBillingPeriod, model.al);
            var plansMessage = $elm$core$List$length(plansWithoutPeriod_) > 0 ? A2($author$project$Ui$Alert$warning, _List_Nil, A2($elm$core$List$map, $author$project$Components$Company$Plans$planWithoutPeriodMessage(newBillingPeriod), plansWithoutPeriod_)) : $author$project$Utils$Html$empty;
            var membershipsMessage = $author$project$Components$Company$Plans$hasActiveMemberships(model.acy) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This will change ' + (A2($author$project$Formatters$String$pluralize, 'membership', $author$project$Api$Company$activeMembershipsCount(model.acy)) + (' from billing ' + ($author$project$Components$Company$Plans$periodName($author$project$Api$Company$periodInMonths(model.acy)) + (' to billing ' + ($author$project$Components$Company$Plans$periodName(newBillingPeriod) + ' on each monthly invoice.'))))))
                ])),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Regenerating the invoice draft may take a few moments.')
                ])),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($elm$html$Html$br, _List_Nil, _List_Nil)
            ])) : $author$project$Utils$Html$empty;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Company$Plans$HiConfirmBillingPeriodClosed, _List_fromArray([
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
                    ]), _List_fromArray([
                        membershipsMessage,
                        plansMessage
                    ]))
                ])),
                $author$project$Components$HiConfirm$noun('Billing Period'),
                $author$project$Components$HiConfirm$verb('Change')
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$Plans$viewPricingDetails = F2(function(plan, model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(10),
                $author$project$Ui$Grid$offset(1)
            ]), _List_fromArray([
                function() {
                    if (!plan.$) {
                        var plan_ = plan.a;
                        return A3($author$project$Components$Plan$Summary$Pricing$view, plan_, $elm$core$Maybe$Just(model.W1), $elm$core$Maybe$Just(model.acy));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    });
    var $author$project$Components$Company$Plans$allowMultiplePlanChangeModal = function(model) {
        var _v0 = _Utils_Tuple2(model.Nz, model.hi);
        if (!_v0.a.$ && _v0.b) {
            var plan = _v0.a.a;
            var newPricingMessage = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('New Pricing')
                ])),
                A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Components$Company$Plans$viewPricingDetails, $elm$core$Maybe$Just(plan), model))
            ]));
            var membershipMessage = $author$project$Components$Company$Plans$hasActiveMemberships(model.acy) ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text('All memberships in this company will be moved to ' + ($author$project$Api$Plan$name(plan) + ' effective on the current draft invoice.'))
            ])) : $author$project$Utils$Html$empty;
            var maybePeriod = $author$project$Api$Period$retrieveByNumberOfMonths($author$project$Api$Company$periodInMonths(model.acy));
            var planMessage = function() {
                if (!maybePeriod.$) {
                    var period = maybePeriod.a;
                    return !A2($author$project$Components$Company$Plans$doesSupportPeriod, plan, period) ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $author$project$Ui$Icon$cross(_List_fromArray([
                            $author$project$Ui$Icon$danger
                        ])),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('The plan ')
                        ])),
                        A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Plan$name(plan))
                        ])),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(' does not have ' + ($author$project$Api$Period$billName(period) + (' pricing enabled so rates will be calculated based on ' + ($author$project$Components$Company$Plans$periodName($author$project$Api$Plan$defaultPeriodInMonths(plan)) + ' rates.'))))
                        ]))
                    ])) : $author$project$Utils$Html$empty;
                } else return $author$project$Utils$Html$empty;
            }();
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Company$Plans$HiConfirmPlanChangedClosed, _List_fromArray([
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
                    ]), _List_fromArray([
                        planMessage,
                        membershipMessage,
                        newPricingMessage
                    ]))
                ])),
                $author$project$Components$HiConfirm$noun('Pricing'),
                $author$project$Components$HiConfirm$verb('Update')
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$Plans$AffiliateBillRateChanged = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$billAffiliateRateToggle = function(model) {
        var network = $author$project$Api$Practice$network(model.W1);
        var ratesFromAffiliate = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$ratesFromAffiliate, network));
        return ratesFromAffiliate ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(2),
                    $author$project$Ui$Form$Group$inputSpan(10),
                    $author$project$Ui$Form$Group$label('Bill Affiliate Rate')
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on($author$project$Api$Company$billAffiliateRate(model.acy)),
                        $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Company$Plans$AffiliateBillRateChanged)
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$Plans$BillingPeriodChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$ShowBillingPeriodSelect = {
        $: 1
    };
    var $author$project$Components$Company$Plans$billingPeriodOptions = A2($elm$core$List$map, function(period) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt($author$project$Api$Period$numberOfMonths(period))), $elm_community$string_extra$String$Extra$toSentenceCase($author$project$Api$Period$billName(period)));
    }, $author$project$Api$Period$list);
    var $author$project$Components$Company$Plans$billingPeriod = function(model) {
        var periodInMonths = $author$project$Api$Company$periodInMonths(model.acy);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(2),
            $author$project$Ui$Form$Group$inputSpan(6),
            $author$project$Ui$Form$Group$label('Billed')
        ]), _List_fromArray([
            model.oj ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(periodInMonths))),
                $author$project$Ui$Form$Select$onChange($author$project$Components$Company$Plans$BillingPeriodChanged)
            ]), $author$project$Components$Company$Plans$billingPeriodOptions) : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm_community$string_extra$String$Extra$toSentenceCase(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Period$billName, $author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)))))
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit Billing Period'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ShowBillingPeriodSelect),
                    $author$project$Ui$Button$pull(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit Billing Period')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Company$Plans$AttemptMultiplePlanChange = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$multiplePlansToggle = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(2),
                    $author$project$Ui$Form$Group$inputSpan(10),
                    $author$project$Ui$Form$Group$label('Multiple Plans')
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(model.gd),
                        $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Company$Plans$AttemptMultiplePlanChange)
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Company$Plans$viewAsPractice = function(practice) {
        if (!practice.$) return true;
        else return false;
    };
    var $author$project$Components$Company$Plans$pricingSettings = function(model) {
        return $author$project$Components$Company$Plans$viewAsPractice(model.W1) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Company$Plans$billingPeriod(model),
            $author$project$Components$Company$Plans$billAffiliateRateToggle(model),
            $author$project$Components$Company$Plans$multiplePlansToggle(model)
        ])) : $elm$html$Html$text('');
    };
    var $author$project$Components$Company$Plans$ShowDefaultPlanSelect = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$editSuggestionLink = function(id_) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$small,
            $author$project$Ui$Typography$muted
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('You can edit the plan configuration ')
            ])),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Plans__Id_String({
                aef: id_
            }), _List_Nil, _List_fromArray([
                $elm$html$Html$text('here')
            ]))
        ]));
    };
    var $author$project$Components$Company$Plans$viewCoveragePlan = function(model) {
        var _v0 = _Utils_Tuple2(model.Mn, A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Expandable$withDefault($elm$core$Maybe$Nothing), A2($elm$core$Maybe$map, $author$project$Api$Plan$coveragePlan, model.Nz))));
        if (!_v0.a.$ && !_v0.b.$) {
            var coveragePlanRulesModel = _v0.a.a;
            var coveragePlan = _v0.b.a;
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Covered Charge Categories & Items')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(2),
                    $author$project$Ui$Form$Group$inputSpan(6),
                    $author$project$Ui$Form$Group$label('Coverage Plan')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Permission$disallowForRoles, model.Z$, _List_fromArray([
                            'practice_manager',
                            'practice_staff',
                            'practice_staff_limited',
                            'practice_staff_limited_and_reports'
                        ])) ? A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$CoveragePlan$One$name(coveragePlan))
                        ])) : A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String({
                            aef: $author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)
                        }), _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$CoveragePlan$One$name(coveragePlan))
                        ]))
                    ]))
                ])),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($elm$html$Html$map, $author$project$Components$Company$Plans$CoveragePlanMsg, $author$project$Components$Admin$CoveragePlans$Rules$view(coveragePlanRulesModel))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$Plans$showDefaultPlan = function(model) {
        var _v0 = model.Nz;
        if (!_v0.$) {
            var defaultPlan = _v0.a;
            return $author$project$Components$Company$Plans$viewAsPractice(model.W1) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(2),
                    $author$project$Ui$Form$Group$inputSpan(6),
                    $author$project$Ui$Form$Group$label('Default Plan')
                ]), _List_fromArray([
                    model.qo ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(10)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Company$Plans$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.jy))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Cancel'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ShowDefaultPlanSelect(false)),
                                $author$project$Ui$Button$pull(1)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ]))
                        ]))
                    ])) : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween,
                            $author$project$Ui$Element$itemsStart
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Plan$name(defaultPlan))
                                ])),
                                $author$project$Components$Company$Plans$editSuggestionLink($author$project$Api$Plan$id(defaultPlan))
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Change default plan'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ShowDefaultPlanSelect(true))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Change Default Plan')
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(10),
                        $author$project$Ui$Grid$offset(1)
                    ]), _List_fromArray([
                        A2($elm$html$Html$hr, _List_Nil, _List_Nil)
                    ]))
                ])),
                A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Components$Company$Plans$viewPricingDetails, model.Nz, model)),
                $author$project$Components$Company$Plans$viewCoveragePlan(model)
            ])) : A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Components$Company$Plans$viewPricingDetails, model.Nz, model));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$CoverageDocuments$Form$viewAsList = function(coverageDocuments) {
        return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, function(coverageDocument) {
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                $author$project$Components$Admin$CoverageDocuments$Form$viewListItems(coverageDocument)
            ]));
        }, coverageDocuments));
    };
    var $author$project$Components$Company$Plans$showPricingModal = function(model) {
        var _v0 = model.j2;
        if (!_v0.$) {
            var selectedForPricingExpanding = _v0.a;
            return A3($author$project$Ui$Modal$view, $author$project$Components$Company$Plans$ClosePricingDetailsModal, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Plan Pricing')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Components$Company$Plans$viewPricingDetails, $elm$core$Maybe$Just(selectedForPricingExpanding), model)),
                    function() {
                        var _v1 = model.Mn;
                        if (!_v1.$) {
                            var modelCoveragePlanRules = _v1.a;
                            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9),
                                $author$project$Ui$Form$Group$clearfix,
                                $author$project$Ui$Form$Group$label('Coverage Plan')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    function() {
                                        var coverageDocuments_ = A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$coverageDocuments, A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Plan$coveragePlan(selectedForPricingExpanding)));
                                        return $author$project$Components$Admin$CoverageDocuments$Form$viewAsList(A2($elm$core$Maybe$withDefault, _List_Nil, coverageDocuments_));
                                    }(),
                                    A2($elm$html$Html$map, $author$project$Components$Company$Plans$CoveragePlanMsg, $author$project$Components$Admin$CoveragePlans$Rules$view(modelCoveragePlanRules))
                                ]))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ClosePricingDetailsModal)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Close')
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Company$Plans$AddPlanClicked = {
        $: 10
    };
    var $author$project$Components$Company$Plans$RemovePlanClicked = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$removeLink = function(plan) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Remove plan'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$onClick($author$project$Components$Company$Plans$RemovePlanClicked(plan)),
            $author$project$Ui$Button$size(0),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
        ]), _List_fromArray([
            $elm$html$Html$text('Remove')
        ]));
    };
    var $author$project$Components$Company$Plans$addingPlan = function(model) {
        return model.du ? _List_fromArray([
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Company$Plans$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.jy))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $author$project$Components$Company$Plans$removeLink($elm$core$Maybe$Nothing)
                ]))
            ]))
        ]) : _List_Nil;
    };
    var $author$project$Components$Company$Plans$AvailableForEnrollmentToggleChanged = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Company$Plans$ShowPricingClicked = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$hiddenForEmployer = F2(function(practice, html) {
        return $author$project$Components$Company$Plans$viewAsPractice(practice) ? html : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Company$Plans$MakeDefaultPlanClicked = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Company$Plans$makeDefaultLink = function(plan) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Make default'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$onClick($author$project$Components$Company$Plans$MakeDefaultPlanClicked(plan)),
            $author$project$Ui$Button$size(0)
        ]), _List_fromArray([
            $elm$html$Html$text('Make Default')
        ]));
    };
    var $author$project$Components$Company$Plans$viewPlan = F3(function(maybeDefaultPlan, practice, companyPlan) {
        var plan = $author$project$Api$CompanyPlan$plan(companyPlan);
        var availableForEnrollment = $author$project$Api$CompanyPlan$availableForEnrollment(companyPlan);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Plan$name(plan)),
                    $author$project$Utils$Html$noBreakSpace,
                    A3($author$project$Ui$Button$view, {
                        abP: 'see plan details'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$Company$Plans$ShowPricingClicked(plan))
                    ]), _List_fromArray([
                        $elm$html$Html$text('(see plan details)')
                    ])),
                    A2($author$project$Components$Company$Plans$hiddenForEmployer, practice, $author$project$Components$Company$Plans$editSuggestionLink($author$project$Api$Plan$id(plan)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Components$Company$Plans$viewAsPractice(practice) ? $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(availableForEnrollment),
                    $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Company$Plans$AvailableForEnrollmentToggleChanged(companyPlan))
                ])) : availableForEnrollment ? $elm$html$Html$text('Yes') : $elm$html$Html$text('No')
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v0 = _Utils_Tuple2(maybeDefaultPlan, $author$project$Components$Company$Plans$viewAsPractice(practice));
                if (!_v0.a.$ && _v0.b) {
                    var defaultPlan = _v0.a.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$justifyRight,
                            $author$project$Ui$Element$gap2
                        ]), !_Utils_eq($author$project$Api$Plan$id(plan), $author$project$Api$Plan$id(defaultPlan)) ? _List_fromArray([
                            $author$project$Components$Company$Plans$makeDefaultLink(plan),
                            $author$project$Components$Company$Plans$removeLink($elm$core$Maybe$Just(companyPlan))
                        ]) : _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$helpBlock,
                                $author$project$Ui$Typography$pull(1)
                            ]), _List_fromArray([
                                $elm$html$Html$text('This will be the default for new memberships')
                            ]))
                        ]))
                    ]);
                } else return _List_Nil;
            }())
        ]));
    });
    var $author$project$Components$Company$Plans$viewPlanList = function(model) {
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$loading($elm$core$List$isEmpty(model.al))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Name')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Available For Enrollment')
            ])),
            $author$project$Components$Company$Plans$viewAsPractice(model.W1) ? A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Add plan'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Company$Plans$AddPlanClicked),
                    $author$project$Ui$Button$pull(1),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Plan')
                ]))
            ])) : A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ]), _Utils_ap($author$project$Components$Company$Plans$addingPlan(model), A2($elm$core$List$map, A2($author$project$Components$Company$Plans$viewPlan, model.Nz, model.W1), model.al)), _List_Nil);
    };
    var $author$project$Components$Company$Plans$view = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Components$Company$Plans$allowBillingPeriodChangeModal(model),
            $author$project$Components$Company$Plans$allowMultiplePlanChangeModal(model),
            $author$project$Components$Company$Plans$showPricingModal(model),
            $author$project$Components$Company$Plans$addPlanConfirmModal(model),
            $author$project$Components$Company$Plans$pricingSettings(model),
            !model.gd ? $author$project$Components$Company$Plans$showDefaultPlan(model) : $author$project$Components$Company$Plans$viewPlanList(model)
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewCompanyPlans = function(model) {
        return _List_fromArray([
            $author$project$Ui$Panel$hr,
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Employee Pricing')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$CompanyPlansMsg, $author$project$Components$Company$Plans$view(model.al))
            ]))
        ]);
    };
    var $author$project$Components$Company$ContactForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$ContactForm$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$ContactForm$Save = {
        $: 1
    };
    var $author$project$Components$Company$ContactForm$view = function(_v0) {
        var model = _v0;
        var sponsorString = A2($author$project$Api$Practice$sponsorize, model.W1, 'Employer');
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$onSubmit($author$project$Components$Company$ContactForm$Save)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(2),
                $author$project$Ui$Form$Group$inputSpan(10),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label(sponsorString + ' Name')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$placeholder(sponsorString),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Company$ContactForm$FormUpdated, $author$project$Components$Company$ContactForm$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(2),
                $author$project$Ui$Form$Group$inputSpan(10),
                $author$project$Ui$Form$Group$label('Address')
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Company$ContactForm$AddressInputMsg, A2($author$project$Components$AddressInput$view, _List_Nil, fields.II))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Phone'),
                $author$project$Ui$Form$Group$labelSpan(2),
                $author$project$Ui$Form$Group$inputSpan(10)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Company$ContactForm$GotPhoneInputMsg, $author$project$Components$PhoneInput$view(fields.WE))
            ])),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Upate contact information'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit,
                    $author$project$Ui$Button$loading(loading)
                ]), _List_fromArray([
                    $elm$html$Html$text('Update')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewContactInformation = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Contact Information')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$ContactFormMsg, $author$project$Components$Company$ContactForm$view(model.hX))
            ]))
        ]);
    };
    var $author$project$Components$Company$DeactivateSponsor$ArchiveClicked = {
        $: 3
    };
    var $author$project$Components$Company$DeactivateSponsor$UnArchiveClicked = {
        $: 4
    };
    var $author$project$Components$Company$DeactivateSponsor$viewArchive = F3(function(sponsorString, archived, processing) {
        return A2($author$project$Ui$Typography$div, _List_Nil, archived ? _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Unarchive ' + sponsorString)
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Unarchiving a sponsor shows them on your main employer list. ')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Unarchive sponsor'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$submit,
                $author$project$Ui$Button$disabled(processing),
                $author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$UnArchiveClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Unarchive')
            ]))
        ]) : _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Archive ' + sponsorString)
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Archiving a sponsor simply hides them from your main employer list. ')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Archive sponsor'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$submit,
                $author$project$Ui$Button$disabled(processing),
                $author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$ArchiveClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Archive')
            ]))
        ]));
    });
    var $author$project$Components$Company$DeactivateSponsor$HiConfirmOpened = {
        $: 0
    };
    var $author$project$Components$Company$DeactivateSponsor$viewDeactivate = F2(function(sponsorString, processing) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$margin(2)
        ]), _List_fromArray([
            A2($elm$html$Html$hr, _List_Nil, _List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Deactivate ' + sponsorString)
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Deactivate this sponsor account. This will end all employee memberships and stop billing invoices to this employer. ')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Deactivate sponsor'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$submit,
                $author$project$Ui$Button$disabled(processing),
                $author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$HiConfirmOpened)
            ]), _List_fromArray([
                $elm$html$Html$text('Deactivate')
            ]))
        ]));
    });
    var $author$project$Components$Company$DeactivateSponsor$ReactivateClicked = {
        $: 2
    };
    var $author$project$Components$Company$DeactivateSponsor$viewReactivate = F3(function(sponsorString, archived, processing) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Reactivate ' + sponsorString)
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('This has no immediate effect except to make it possible to enroll and bill for employees again. ')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Reactivate sponsor'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$submit,
                $author$project$Ui$Button$disabled(archived || processing),
                $author$project$Ui$Button$onClick($author$project$Components$Company$DeactivateSponsor$ReactivateClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Reactivate')
            ]))
        ]));
    });
    var $author$project$Components$Company$DeactivateSponsor$view = function(model) {
        var sponsorString = A2($author$project$Formatters$String$sponsorize, model.W1, 'Employer');
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            model.Q8 ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A3($author$project$Components$Company$DeactivateSponsor$viewReactivate, sponsorString, model.JC, model.Xv),
                A2($elm$html$Html$hr, _List_Nil, _List_Nil),
                A3($author$project$Components$Company$DeactivateSponsor$viewArchive, sponsorString, model.JC, model.Xv)
            ])) : A2($author$project$Components$Company$DeactivateSponsor$viewDeactivate, sponsorString, model.Xv),
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                function() {
                    if (model.iN) {
                        var sponsorName = $author$project$Api$Provider$Company$One$name(model.acy);
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Company$DeactivateSponsor$HiConfirmClosed, _List_fromArray([
                            $author$project$Components$HiConfirm$verb('deactivate'),
                            $author$project$Components$HiConfirm$noun(sponsorName),
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text('You\'re about to deactivate ' + (sponsorName + ' which will cancel their memberships and disable emails and invoicing. This action cannot be undone.'))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewDeactivateSponsor = function(model) {
        var _v0 = model.W1;
        if (!_v0.$) {
            var _v1 = model.lS;
            if (!_v1.$) {
                var deactivateSponsor = _v1.a;
                return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$DeactivateSponsorMsg, $author$project$Components$Company$DeactivateSponsor$view(deactivateSponsor));
            } else return $elm$html$Html$text('');
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Company$DefaultAffiliation$viewDefaultAffiliation = function(practitionerResourceFilter) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$hr, _List_Nil, _List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Default Primary Care Clinic')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Choose a default primary care clinic to be assigned to all covered employees.')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(7),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Company$DefaultAffiliation$AffiliateResourceFilterMsg, A2($author$project$Components$ResourceFilter$Affiliate$view, _List_fromArray([
                        $author$project$Components$ResourceFilter$style(0)
                    ]), practitionerResourceFilter))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Company$DefaultAffiliation$view = function(_v0) {
        var model = _v0;
        return $elm$core$List$isEmpty(model.pv) ? $author$project$Utils$Html$empty : $author$project$Components$Company$DefaultAffiliation$viewDefaultAffiliation(model.pu);
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultAffiliation = function(model) {
        var _v0 = model.W1;
        if (!_v0.$) {
            var _v1 = model.No;
            if (!_v1.$) {
                var defaultAffiliation = _v1.a;
                return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultAffiliationMsg, $author$project$Components$Company$DefaultAffiliation$view(defaultAffiliation));
            } else return $elm$html$Html$text('');
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Company$DefaultLocation$viewDefaultLocation = function(practitionerResourceFilter) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$hr, _List_Nil, _List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Default Location')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Choose a location to be assigned to all covered employees.')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(7),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Company$DefaultLocation$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                        $author$project$Components$ResourceFilter$style(0)
                    ]), practitionerResourceFilter))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Company$DefaultLocation$view = function(_v0) {
        var model = _v0;
        return $author$project$Api$Provider$Practice$One$hasLocations(model.W1) ? $author$project$Components$Company$DefaultLocation$viewDefaultLocation(model.ro) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultLocation = function(model) {
        var _v0 = model.W1;
        if (!_v0.$) {
            var _v1 = model.Nr;
            if (!_v1.$) {
                var defaultLocation = _v1.a;
                return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultLocationMsg, $author$project$Components$Company$DefaultLocation$view(defaultLocation));
            } else return $elm$html$Html$text('');
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Company$DefaultProvider$viewDefaultProvider = function(practitionerResourceFilter) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$hr, _List_Nil, _List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Default Provider')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Choose a provider to be assigned to all covered employees.')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(7),
                    $author$project$Ui$Grid$offsetSm(1)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Company$DefaultProvider$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$view, _List_fromArray([
                        $author$project$Components$ResourceFilter$style(0)
                    ]), practitionerResourceFilter))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Company$DefaultProvider$view = function(_v0) {
        var model = _v0;
        return $author$project$Api$Provider$Practice$One$hasPractitioners(model.W1) ? $author$project$Components$Company$DefaultProvider$viewDefaultProvider(model.jE) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultProvider = function(model) {
        var _v0 = model.W1;
        if (!_v0.$) {
            var _v1 = model.h8;
            if (!_v1.$) {
                var defaultProvider = _v1.a;
                return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$DefaultProviderMsg, $author$project$Components$Company$DefaultProvider$view(defaultProvider));
            } else return $elm$html$Html$text('');
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Company$EmployeeDivisions$SelectedRequireDivisions = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeDivisions$SelectedUsesDivisions = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeDivisions$CreateDivisionClicked = {
        $: 5
    };
    var $author$project$Components$Company$EmployeeDivisions$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeDivisions$Name = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Company$Shared$isInactive = function(_v0) {
        var record = _v0;
        return record.Q8;
    };
    var $author$project$Api$Employer$Company$One$isInactive = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$isInactive(shared);
    };
    var $author$project$Api$Company$isInactive = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$isInactive(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$isInactive(company_);
        }
    };
    var $author$project$Components$Company$EmployeeDivisions$addingDivision = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$group(_List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(fields.zr),
                            $author$project$Ui$Form$Input$placeholder('Human Resources'),
                            $author$project$Ui$Form$Input$autofocus(true),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Company$EmployeeDivisions$FormUpdated, $elm$core$Basics$identity)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Create division'
                        }, _List_fromArray([
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Company$EmployeeDivisions$CreateDivisionClicked),
                            $author$project$Ui$Button$disabled($author$project$Api$Company$isInactive(model.acy)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Create Division')
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Api$Employer$EmployeeDivision$All$assignedAccounts = function(_v0) {
        var record = _v0.b;
        return record.JD;
    };
    var $author$project$Api$Provider$EmployeeDivision$All$assignedAccounts = function(_v0) {
        var record = _v0.b;
        return record.JD;
    };
    var $author$project$Api$EmployeeDivision$All$assignedAccounts = function(employeeDivision) {
        if (!employeeDivision.$) {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Provider$EmployeeDivision$All$assignedAccounts(employeeDivision_);
        } else {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Employer$EmployeeDivision$All$assignedAccounts(employeeDivision_);
        }
    };
    var $author$project$Components$Company$EmployeeDivisions$Delete = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Company$EmployeeDivisions$deleteDivision = function(division) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Remove division'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$size(0),
            $author$project$Ui$Button$onClick($author$project$Components$Company$EmployeeDivisions$Delete(division)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
        ]), _List_fromArray([
            $elm$html$Html$text('Remove')
        ]));
    };
    var $author$project$Api$Employer$EmployeeDivision$All$eligibleAccounts = function(_v0) {
        var record = _v0.b;
        return record.OF;
    };
    var $author$project$Api$Provider$EmployeeDivision$All$eligibleAccounts = function(_v0) {
        var record = _v0.b;
        return record.OF;
    };
    var $author$project$Api$EmployeeDivision$All$eligibleAccounts = function(employeeDivision) {
        if (!employeeDivision.$) {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Provider$EmployeeDivision$All$eligibleAccounts(employeeDivision_);
        } else {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Employer$EmployeeDivision$All$eligibleAccounts(employeeDivision_);
        }
    };
    var $author$project$Api$Employer$EmployeeDivision$All$enrolledAccounts = function(_v0) {
        var record = _v0.b;
        return record.OW;
    };
    var $author$project$Api$Provider$EmployeeDivision$All$enrolledAccounts = function(_v0) {
        var record = _v0.b;
        return record.OW;
    };
    var $author$project$Api$EmployeeDivision$All$enrolledAccounts = function(employeeDivision) {
        if (!employeeDivision.$) {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Provider$EmployeeDivision$All$enrolledAccounts(employeeDivision_);
        } else {
            var employeeDivision_ = employeeDivision.a;
            return $author$project$Api$Employer$EmployeeDivision$All$enrolledAccounts(employeeDivision_);
        }
    };
    var $author$project$Components$Company$EmployeeDivisions$viewDivision = function(division) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$EmployeeDivision$All$name(division))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(A2($elm$core$Maybe$withDefault, 0, $author$project$Api$EmployeeDivision$All$assignedAccounts(division))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(A2($elm$core$Maybe$withDefault, 0, $author$project$Api$EmployeeDivision$All$eligibleAccounts(division))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(A2($elm$core$Maybe$withDefault, 0, $author$project$Api$EmployeeDivision$All$enrolledAccounts(division))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $author$project$Components$Company$EmployeeDivisions$deleteDivision(division)
            ]))
        ]));
    };
    var $author$project$Components$Company$EmployeeDivisions$viewDivisionsList = function(model) {
        var _v0 = function() {
            var _v1 = model.xv;
            if (_v1.$ === 3) {
                var employeeDivisions_ = _v1.a;
                return _Utils_Tuple2(false, employeeDivisions_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var employeeDivisions = _v0.b;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A4($author$project$Ui$Table$view, _List_fromArray([
                    $author$project$Ui$Table$loading(loading)
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Name')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Assigned')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Eligible')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Enrolled')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ]), A2($elm$core$List$map, $author$project$Components$Company$EmployeeDivisions$viewDivision, employeeDivisions), _List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_Nil, $author$project$Components$Company$EmployeeDivisions$addingDivision(model))
        ]));
    };
    var $author$project$Components$Company$EmployeeDivisions$viewEmployeeDivisions = function(model) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$margin(2)
        ]), _List_fromArray([
            A2($elm$html$Html$hr, _List_Nil, _List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Employee Divisions')
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$helpBlock
            ]), _List_fromArray([
                $elm$html$Html$text('Allows you to set a division on each employee. Invoices and reporting can then be grouped by each division. ')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(model.aa0),
                        $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Company$EmployeeDivisions$SelectedUsesDivisions)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Use Employee Divisions')
                    ]))
                ]))
            ])),
            model.aa0 ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(model.YH),
                        $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Company$EmployeeDivisions$SelectedRequireDivisions)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Require a division on each employee ')
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    model.aa0 ? $author$project$Components$Company$EmployeeDivisions$viewDivisionsList(model) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Company$EmployeeDivisions$view = function(_v0) {
        var model = _v0;
        return $author$project$Components$Company$EmployeeDivisions$viewEmployeeDivisions(model);
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewEmployeeDivisions = function(model) {
        return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$EmployeeDivisionsMsg, $author$project$Components$Company$EmployeeDivisions$view(model.xv));
    };
    var $author$project$Components$Company$Enrollment$title = $author$project$Ui$Typography$headingSm(_List_fromArray([
        $elm$html$Html$text('Enrollment and Termination '),
        A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$small
        ]), _List_fromArray([
            A3($author$project$Ui$Tooltip$view, _List_fromArray([
                $author$project$Ui$Tooltip$placement(3)
            ]), 'Click to Learn More', _List_fromArray([
                A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/employers/employer-account-setup', _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $author$project$Ui$Icon$help(_List_Nil)
                ]))
            ]))
        ]))
    ]));
    var $author$project$Components$Company$Enrollment$BackBillingPeriodChanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Feature$NonMonthlySponsorBilling = 1;
    var $author$project$Ui$Form$Input$withPostAddon = F2(function(addonText, options) {
        var optionsRecord = $author$project$Ui$Form$Input$optionsToRecord(options);
        var onInputHandler = $author$project$Ui$Form$Input$optionsToInputHandler(optionsRecord);
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Ui$Form$Input$viewFeedback(optionsRecord),
                A2($elm$html$Html$input, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('form-control'), A2($elm$core$List$cons, $elm$html$Html$Attributes$value(optionsRecord.aa9), _Utils_ap($author$project$Ui$Form$Input$inputTypeToAttributes(optionsRecord.ah5), _Utils_ap(optionsRecord.vD, onInputHandler)))), _List_Nil),
                $elm$core$String$isEmpty(addonText) ? $elm$html$Html$text('') : $author$project$Ui$Form$Input$addon(_List_fromArray([
                    $elm$html$Html$text(addonText)
                ]))
            ]),
            A2($elm$core$List$map, $author$project$Ui$Form$Input$viewErrors, options)
        ]));
    });
    var $author$project$Components$Company$Enrollment$viewBackBillPeriods = F5(function(practice, backBillPeriods, limitBackBill, form, processing) {
        return limitBackBill ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Allowed Backbilling Period')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPostAddon, A2($author$project$Api$Practice$featureEnabled, 1, practice) ? 'periods' : 'months', _List_fromArray([
                            $author$project$Ui$Form$Input$value(backBillPeriods),
                            $author$project$Ui$Form$Input$onInput($author$project$Components$Company$Enrollment$BackBillingPeriodChanged),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                            $author$project$Ui$Form$Input$disabled(processing)
                        ])))
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Company$Enrollment$notificationSettingPracticeValue = function(notificationSetting) {
        if (notificationSetting.$ === 3) {
            var notificationSetting_ = notificationSetting.a;
            return $author$project$Api$Provider$NotificationSetting$One$enabled(notificationSetting_) ? 'On' : 'Off';
        } else return 'Off';
    };
    var $author$project$Components$Company$Enrollment$EmployeeInviteNotification = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$viewEmployeeInviteButton = F4(function(currentValue, buttonValue, label, processing) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentValue, buttonValue)),
            $author$project$Ui$Button$onClick($author$project$Components$Company$Enrollment$FormUpdated($author$project$Components$Company$Enrollment$EmployeeInviteNotification(buttonValue))),
            $author$project$Ui$Button$disabled(processing)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Company$Enrollment$viewEmployeeInviteHelpText = F2(function(employeeInviteValue, practiceValue) {
        switch(employeeInviteValue){
            case 'practice_default':
                return 'Will use the practice setting. Curently set to \'' + (practiceValue + '\'.');
            case 'on':
                return 'Employee invite notification will be sent.';
            default:
                return 'Employee invite notification will not be sent.';
        }
    });
    var $author$project$Components$Company$Enrollment$viewEmployeeInvite = F4(function(employeeInviteValue, processing, canManageInvitations, notificationSetting) {
        return canManageInvitations ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Send Employee Invite Notification')
                ])),
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$Button$group(_List_fromArray([
                        A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'on', 'On', processing),
                        A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'off', 'Off', processing),
                        A4($author$project$Components$Company$Enrollment$viewEmployeeInviteButton, employeeInviteValue, 'practice_default', 'Practice Default', processing)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Components$Company$Enrollment$viewEmployeeInviteHelpText, employeeInviteValue, $author$project$Components$Company$Enrollment$notificationSettingPracticeValue(notificationSetting)))
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Company$Enrollment$EnrollmentCutOffDay = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$Class = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$Select$class = $author$project$Ui$Form$Select$Class;
    var $author$project$Components$Company$Enrollment$cutOffDayOptions = A2($elm$core$List$map, $elm$core$String$fromInt, A2($elm$core$List$range, 1, 31));
    var $author$project$Components$Company$Enrollment$viewEnrollmentCutOffDay = F2(function(enrollmentCutOffDayOfMonth, processing) {
        var infoText = '\n            If an employee self enrolls before the cutoff day,\n            they will be enrolled and billed from the 1st of the current month.\n            If they enroll after the cutoff day,\n            their membership will be billed and started on the first of next month.\n            ';
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Enrollment Cutoff Day')
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    $elm$html$Html$text(infoText)
                ])),
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Day of Month ')
                    ])),
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$class('select--between-text'),
                        $author$project$Ui$Form$Select$inline,
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(enrollmentCutOffDayOfMonth))),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$EnrollmentCutOffDay)),
                        $author$project$Ui$Form$Select$disabled(processing)
                    ]), A2($elm$core$List$map, function(option) {
                        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(option), option);
                    }, $author$project$Components$Company$Enrollment$cutOffDayOptions))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Company$Enrollment$LimitBackbill = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$viewLimitBackbillToggle = F2(function(limitBackBill, processing) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1),
                $author$project$Ui$Grid$span(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Limit Backbilling')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(limitBackBill),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$LimitBackbill)),
                            $author$project$Ui$ToggleSwitch$disabled(processing)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Company$Enrollment$NumberDependentsAllowed = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$numberDependentsOptions = A2($elm$core$List$map, $elm$core$String$fromInt, A2($elm$core$List$range, 0, 10));
    var $author$project$Components$Company$Enrollment$viewNumberDependentsAllowed = F2(function(numberDependentsAllowed, processing) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Dependent Information')
                ])),
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Employer will pay for up to ')
                    ])),
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$class('select--between-text'),
                        $author$project$Ui$Form$Select$inline,
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(numberDependentsAllowed))),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$NumberDependentsAllowed)),
                        $author$project$Ui$Form$Select$disabled(processing)
                    ]), A2($elm$core$List$map, function(option) {
                        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(option), option);
                    }, $author$project$Components$Company$Enrollment$numberDependentsOptions)),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' dependents for each of its employees.')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Company$Enrollment$TerminationCutOffDay = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$UseTerminationCutOffDay = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Company$Enrollment$viewTerminationCutOffDay = F3(function(useTerminationCutOffDay, terminationCutOffDayOfMonth, processing) {
        var infoText = useTerminationCutOffDay ? '\n              If a patient terminates before the cutoff day, the patient\'s end date\n              will be set to the 1st of the indicated month. If they terminate after\n              the cutoff day, the patient\'s end date will be the 1st of the following month.\n              Memberships with an end date prior to the current month will be ended on the\n              1st of the current month.\n              ' : '\n              Memberships can be ended on any day of the month.\n              Memberships with an end date prior to the current month will be ended \'today\'.\n              ';
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11),
                $author$project$Ui$Grid$offsetSm(1)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Termination Cutoff Day')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(useTerminationCutOffDay),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$UseTerminationCutOffDay)),
                            $author$project$Ui$ToggleSwitch$disabled(processing)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(infoText)
                ])),
                useTerminationCutOffDay ? A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Day of Month ')
                    ])),
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$class('select--between-text'),
                        $author$project$Ui$Form$Select$inline,
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(terminationCutOffDayOfMonth))),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Company$Enrollment$FormUpdated, $author$project$Components$Company$Enrollment$TerminationCutOffDay)),
                        $author$project$Ui$Form$Select$disabled(processing)
                    ]), A2($elm$core$List$map, function(option) {
                        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(option), option);
                    }, $author$project$Components$Company$Enrollment$cutOffDayOptions))
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Components$Company$Enrollment$viewForm = F5(function(practice, form, processing, canManageInvitations, notificationSetting) {
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Components$Company$Enrollment$viewLimitBackbillToggle, fields.Tc, processing),
            A5($author$project$Components$Company$Enrollment$viewBackBillPeriods, practice, fields.J3, fields.Tc, form, processing),
            A2($author$project$Components$Company$Enrollment$viewNumberDependentsAllowed, fields.Va, processing),
            A2($author$project$Components$Company$Enrollment$viewEnrollmentCutOffDay, fields.OY, processing),
            A3($author$project$Components$Company$Enrollment$viewTerminationCutOffDay, fields.o9, fields.$V, processing),
            A4($author$project$Components$Company$Enrollment$viewEmployeeInvite, fields.OK, processing, canManageInvitations, notificationSetting)
        ]));
    });
    var $author$project$Components$Company$Enrollment$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A5($author$project$Components$Company$Enrollment$viewForm, model.W1, model.b7, model.Xv, model.EG, model.U7)
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$viewEnrollment = function(model) {
        return _List_fromArray([
            $author$project$Ui$Panel$hr,
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Components$Company$Enrollment$title
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Top$EnrollmentMsg, $author$project$Components$Company$Enrollment$view(model.ma))
            ]))
        ]);
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _Utils_ap($author$project$Pages$Companies$CompanyId_String$Top$viewContactInformation(model), _Utils_ap($author$project$Pages$Companies$CompanyId_String$Top$viewComissionedDeals(model), _Utils_ap($author$project$Pages$Companies$CompanyId_String$Top$viewCompanyPlans(model), _Utils_ap($author$project$Pages$Companies$CompanyId_String$Top$viewCompanyAdmins(model), _Utils_ap($author$project$Pages$Companies$CompanyId_String$Top$viewEnrollment(model), _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultProvider(model),
                        $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultLocation(model),
                        $author$project$Pages$Companies$CompanyId_String$Top$viewDefaultAffiliation(model),
                        $author$project$Pages$Companies$CompanyId_String$Top$viewEmployeeDivisions(model),
                        $author$project$Pages$Companies$CompanyId_String$Top$viewDeactivateSponsor(model)
                    ]))
                ])))))))
            ]),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Account & Pricing'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Top$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Top$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Top$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Top$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Top$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Top$view
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotFeedEnroller = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotUploads = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath = function(model) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(model.aef);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq
            });
        };
    };
    var $author$project$Api$Upload$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Upload$All$fromEmployer = $author$project$Api$Upload$All$Employer;
    var $author$project$Api$Upload$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Upload$All$fromProvider = $author$project$Api$Upload$All$Provider;
    var $author$project$Api$Employer$Upload$All$Upload = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$Upload$All$Record = function(meta) {
        return {
            Ue: meta
        };
    };
    var $author$project$Api$Employer$Upload$Meta$Meta = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Upload$Meta$Record = function(actions) {
        return {
            tM: actions
        };
    };
    var $author$project$Api$Employer$Upload$Meta$ActionsRecord = F4(function(preprocess, process, duplicate, cancel) {
        return {
            KW: cancel,
            Om: duplicate,
            Xl: preprocess,
            Xt: process
        };
    });
    var $author$project$Api$Employer$Upload$Meta$actionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cancel', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'duplicate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'process', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'preprocess', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$Meta$ActionsRecord)))));
    var $author$project$Api$Employer$Upload$Meta$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'actions', $author$project$Api$Employer$Upload$Meta$actionsRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$Meta$Record));
    var $author$project$Api$Employer$Upload$Meta$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Upload$Meta$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Upload$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Employer$Upload$Meta$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$All$Record));
    var $author$project$Api$Employer$Upload$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Upload$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Upload$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$All$Upload)));
    var $author$project$Api$Employer$Upload$uploadsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'uploads'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Upload$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$Upload$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$Upload$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$Upload$uploadsPath)));
    });
    var $author$project$Api$Upload$list = F5(function(basePath, apiClient, session, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$list, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Upload$All$fromEmployer)))) : A4($author$project$Api$Provider$Upload$list, basePath, apiClient, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$Upload$All$fromProvider))));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads = function(model) {
        return A5($author$project$Api$Upload$list, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model), model.Ej, model.Z$, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchParams(model), $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotUploads);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: shared.Ej,
            cH: $elm$core$Maybe$Nothing,
            lp: false,
            acy: company,
            cT: $elm$core$Maybe$Nothing,
            iJ: $author$project$Api$Data$Loading,
            aef: params.fl,
            F3: $author$project$Shared$isHintAdmin(shared),
            afW: shared.afW,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            jJ: $elm$core$Maybe$Nothing,
            nM: $author$project$Api$Data$NotAsked,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            HO: shared.HO,
            kI: $elm$core$Maybe$Nothing,
            o8: $author$project$Api$Data$Loading
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model),
            A4($author$project$Api$FeedEnroller$retrieve, shared.Ej, session, params.fl, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotFeedEnroller)
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared),
            afW: shared.afW
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed = {
        $: 9
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Company$UploadModal$Close = {
        $: 0
    };
    var $author$project$Components$Company$UploadModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Company$UploadModal$Close);
    };
    var $author$project$Components$Upload$ProcessUploadModal$Close = {
        $: 0
    };
    var $author$project$Components$Upload$ProcessUploadModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$ProcessUploadModal$Close);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Upload$ProcessUploadModal$subscriptions, model.jJ))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Company$UploadModal$subscriptions, model.kI))),
            model.lp ? $author$project$Components$Upload$CannotUploadModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed) : $elm$core$Platform$Sub$none,
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed)), model.cH)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed)), model.cT))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Canceled = F2(function(a, b) {
        return {
            $: 15,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicated = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotProcessingStatus = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Employer$Upload$uploadPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Employer$Upload$uploadsPath);
    };
    var $author$project$Api$Employer$Upload$cancel = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel'
        ]), $author$project$Api$Employer$Upload$uploadPath(id))));
    });
    var $author$project$Api$Provider$Upload$cancel = F4(function(basePath, apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel'
        ]), A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
    });
    var $author$project$Api$Upload$cancel = F5(function(basePath, apiClient, session, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$cancel, apiClient, id, toMsg) : A4($author$project$Api$Provider$Upload$cancel, basePath, apiClient, id, toMsg);
    });
    var $author$project$Api$Employer$Upload$One$Upload = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$Upload$One$Record = function(results) {
        return {
            Y_: results
        };
    };
    var $author$project$Api$Employer$Upload$One$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'results', $author$project$Api$Common$Upload$Results$decoder, _List_Nil, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$One$Record));
    var $author$project$Api$Employer$Upload$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Upload$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Upload$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Upload$One$Upload)));
    var $author$project$Api$Employer$Upload$duplicate = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$Upload$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'duplicate'
        ]), $author$project$Api$Employer$Upload$uploadPath(id))));
    });
    var $author$project$Api$Provider$Upload$duplicate = F4(function(basePath, apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Upload$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'duplicate'
        ]), A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
    });
    var $author$project$Api$Upload$One$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Upload$One$fromEmployer = $author$project$Api$Upload$One$Employer;
    var $author$project$Api$Upload$One$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Upload$One$fromProvider = $author$project$Api$Upload$One$Provider;
    var $author$project$Api$Upload$duplicate = F5(function(basePath, apiClient, session, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$duplicate, apiClient, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Upload$One$fromEmployer))) : A4($author$project$Api$Provider$Upload$duplicate, basePath, apiClient, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Upload$One$fromProvider)));
    });
    var $author$project$Api$Employer$Upload$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$id(shared);
    };
    var $author$project$Api$Upload$All$id = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$id(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$id(upload_);
        }
    };
    var $author$project$Components$Company$UploadModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Company$UploadModal$initFormFields = {
        adN: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$Company$UploadModal$init = F2(function(basePath, session) {
        var fields = $author$project$Components$Company$UploadModal$initFormFields;
        return {
            vK: basePath,
            PU: $author$project$Utils$Form$init(fields),
            j_: $author$project$Api$Data$NotAsked,
            Z$: session
        };
    });
    var $author$project$Components$Upload$ProcessUploadModal$init = F3(function(basePath, session, id) {
        return {
            vK: basePath,
            aef: id,
            nL: $author$project$Api$Data$NotAsked,
            Z$: session
        };
    });
    var $author$project$Api$Common$Upload$ProcessingStatus$isProcessing = function(_v0) {
        var record = _v0;
        return record.Sk;
    };
    var $author$project$Api$Common$Upload$ProcessingStatus$ProcessingStatus = $elm$core$Basics$identity;
    var $author$project$Api$Common$Upload$ProcessingStatus$Record = function(isProcessing) {
        return {
            Sk: isProcessing
        };
    };
    var $author$project$Api$Common$Upload$ProcessingStatus$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_processing', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Common$Upload$ProcessingStatus$Record));
    var $author$project$Api$Common$Upload$ProcessingStatus$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Upload$ProcessingStatus$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Upload$processingStatus = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$Upload$ProcessingStatus$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'is_processing'
        ]), $author$project$Api$Employer$Upload$uploadsPath)));
    });
    var $author$project$Api$Provider$Upload$processingStatus = F3(function(basePath, apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Common$Upload$ProcessingStatus$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'is_processing'
        ]), $author$project$Api$Provider$Upload$uploadsPath(basePath))));
    });
    var $author$project$Api$Upload$processingStatus = F4(function(basePath, apiClient, session, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$Employer$Upload$processingStatus, apiClient, toMsg) : A3($author$project$Api$Provider$Upload$processingStatus, basePath, apiClient, toMsg);
    });
    var $author$project$Components$Company$UploadModal$Closed = 0;
    var $author$project$Components$Company$UploadModal$File = $elm$core$Basics$identity;
    var $author$project$Components$Company$UploadModal$FileValidation = 0;
    var $author$project$Components$Company$UploadModal$None = 1;
    var $author$project$Components$Company$UploadModal$UploadCreated = 2;
    var $author$project$Components$Company$UploadModal$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Employer$FeedEnroller$createUpload = F3(function(apiClient, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestMultipartBody, function() {
            var _v0 = fields.adN;
            if (!_v0.$) {
                var file = _v0.a;
                return _List_fromArray([
                    A2($elm$http$Http$filePart, 'file', file)
                ]);
            } else return _List_Nil;
        }(), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'upload'
        ]), $author$project$Api$Employer$FeedEnroller$feedEnrollersPath))));
    });
    var $author$project$Api$Provider$FeedEnroller$createUpload = F4(function(basePath, apiClient, fields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestMultipartBody, function() {
            var _v0 = fields.adN;
            if (!_v0.$) {
                var file = _v0.a;
                return _List_fromArray([
                    A2($elm$http$Http$filePart, 'file', file)
                ]);
            } else return _List_Nil;
        }(), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'upload'
        ]), $author$project$Api$Provider$FeedEnroller$feedEnrollersPath(basePath)))));
    });
    var $author$project$Api$FeedEnroller$createUpload = F5(function(basePath, apiClient, session, fields, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$FeedEnroller$createUpload, apiClient, fields, toMsg) : A4($author$project$Api$Provider$FeedEnroller$createUpload, basePath, apiClient, fields, toMsg);
    });
    var $author$project$Components$Company$UploadModal$createUpload = F4(function(basePath, apiClient, session, validFormFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        var file = _v0.adN;
        return A5($author$project$Api$FeedEnroller$createUpload, basePath, apiClient, session, {
            adN: file
        }, $author$project$Components$Company$UploadModal$Created);
    });
    var $author$project$Components$Company$UploadModal$formFieldsUpdate = F2(function(field, fields) {
        var file = field;
        return _Utils_update(fields, {
            adN: file
        });
    });
    var $author$project$Components$Company$UploadModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.adN;
        }, _Utils_Tuple2(0, 'Please select a file.'))
    ]));
    var $author$project$Components$Company$UploadModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var files = msg.a;
                var file = $elm$core$List$head(files);
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Company$UploadModal$formFieldsUpdate, file, model.PU);
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$UploadModal$formFieldsValidator, newForm);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validatedForm = _v3.a;
                    var validFormFields = _v3.b;
                    return {
                        EQ: A4($author$project$Components$Company$UploadModal$createUpload, model.vK, apiClient, model.Z$, validFormFields),
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: validatedForm,
                            j_: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var validatedForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: validatedForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Components$Company$UploadModal$formFieldsValidator, model.PU);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return {
                        EQ: A4($author$project$Components$Company$UploadModal$createUpload, model.vK, apiClient, model.Z$, validFormFields),
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            j_: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v4.a;
                    var errorMsg = A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(A2($author$project$Utils$Form$validationErrors, 0, newForm)));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, errorMsg)
                        ])
                    };
                }
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'File successfully uploaded.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        j_: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Upload$ProcessUploadModal$Closed = 1;
    var $author$project$Components$Upload$ProcessUploadModal$None = 0;
    var $author$project$Components$Upload$ProcessUploadModal$Processed = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Upload$ProcessUploadModal$UploadProcessing = 2;
    var $author$project$Api$Employer$Upload$asyncProcess = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'async_process'
        ]), $author$project$Api$Employer$Upload$uploadPath(id))));
    });
    var $author$project$Api$Provider$Upload$asyncProcess = F4(function(basePath, apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'async_process'
        ]), A2($author$project$Api$Provider$Upload$uploadPath, basePath, id))));
    });
    var $author$project$Api$Upload$asyncProcess = F5(function(basePath, apiClient, session, id_, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$asyncProcess, apiClient, id_, toMsg) : A4($author$project$Api$Provider$Upload$asyncProcess, basePath, apiClient, id_, toMsg);
    });
    var $author$project$Components$Upload$ProcessUploadModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: A5($author$project$Api$Upload$asyncProcess, model.vK, apiClient, model.Z$, model.aef, $author$project$Components$Upload$ProcessUploadModal$Processed),
                    adu: 0,
                    zi: _Utils_update(model, {
                        nL: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        nL: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'The file will be processed soon.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        nL: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top({
                fl: model.aef
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Api$Employer$Upload$All$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$status(shared);
    };
    var $author$project$Api$Provider$Upload$All$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$status(shared);
    };
    var $author$project$Api$Upload$All$status = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$status(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$status(upload_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$uploadFinishedPreprocessing = function(upload) {
        return $author$project$Api$Upload$All$status(upload) === 5 || $author$project$Api$Upload$All$status(upload) === 6;
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        o8: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    o8: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    iJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q,
                            o8: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(qModel),
                            $author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    o8: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(newModel),
                    $author$project$Pages$Companies$CompanyId_String$Uploads$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 4:
                var uploadModal = A2($author$project$Components$Company$UploadModal$init, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model), model.Z$);
                return _Utils_Tuple3(_Utils_update(model, {
                    kI: $elm$core$Maybe$Just(uploadModal)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var subMsg = msg.a;
                var _v5 = model.kI;
                if (!_v5.$) {
                    var uploadModal = _v5.a;
                    var uploadModalResult = A3($author$project$Components$Company$UploadModal$update, model.Ej, subMsg, uploadModal);
                    var _v6 = function() {
                        var _v7 = uploadModalResult.adu;
                        switch(_v7){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.o8, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Just(uploadModalResult.zi), model.o8, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var uploadModal_ = _v6.a;
                    var uploads = _v6.b;
                    var cmd = _v6.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        kI: uploadModal_,
                        o8: uploads
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg, uploadModalResult.EQ),
                        cmd
                    ])), uploadModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var upload = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    nM: $author$project$Api$Data$Loading
                }), A4($author$project$Api$Upload$processingStatus, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model), model.Ej, model.Z$, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$GotProcessingStatus(upload)), _List_Nil);
            case 7:
                var upload = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var processingStatus = response.a;
                    var _v9 = !$author$project$Api$Common$Upload$ProcessingStatus$isProcessing(processingStatus) || $author$project$Pages$Companies$CompanyId_String$Uploads$Top$uploadFinishedPreprocessing(upload) ? _Utils_Tuple2($elm$core$Maybe$Just(A3($author$project$Components$Upload$ProcessUploadModal$init, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model), model.Z$, $author$project$Api$Upload$All$id(upload))), false) : _Utils_Tuple2($elm$core$Maybe$Nothing, true);
                    var processUploadModal = _v9.a;
                    var cannotUploadModal = _v9.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lp: cannotUploadModal,
                        jJ: processUploadModal,
                        nM: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    nM: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var subMsg = msg.a;
                var _v10 = model.jJ;
                if (!_v10.$) {
                    var processUploadModal = _v10.a;
                    var processUploadModalResult = A3($author$project$Components$Upload$ProcessUploadModal$update, model.Ej, subMsg, processUploadModal);
                    var _v11 = function() {
                        var _v12 = processUploadModalResult.adu;
                        switch(_v12){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(processUploadModalResult.zi), model.o8, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.o8, $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model));
                        }
                    }();
                    var processUploadModal_ = _v11.a;
                    var uploads = _v11.b;
                    var cmd = _v11.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        jJ: processUploadModal_,
                        o8: uploads
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg, processUploadModalResult.EQ),
                        cmd
                    ])), processUploadModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                return _Utils_Tuple3(_Utils_update(model, {
                    lp: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var upload = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    cT: $elm$core$Maybe$Just(_Utils_Tuple2(upload, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var confirmed = msg.a;
                var _v13 = _Utils_Tuple2(model.cT, confirmed);
                if (!_v13.a.$ && _v13.b) {
                    var _v14 = _v13.a.a;
                    var upload = _v14.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cT: $elm$core$Maybe$Just(_Utils_Tuple2(upload, $author$project$Api$Data$Loading))
                    }), A5($author$project$Api$Upload$duplicate, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model), model.Ej, model.Z$, $author$project$Api$Upload$All$id(upload), $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicated(upload)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cT: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var upload = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    cT: $elm$core$Maybe$Nothing,
                    o8: $author$project$Api$Data$Loading
                }), $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Upload successfully duplicated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    cT: $elm$core$Maybe$Just(_Utils_Tuple2(upload, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 13:
                var upload = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    cH: $elm$core$Maybe$Just(_Utils_Tuple2(upload, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var confirmed = msg.a;
                var _v16 = _Utils_Tuple2(model.cH, confirmed);
                if (!_v16.a.$ && _v16.b) {
                    var _v17 = _v16.a.a;
                    var upload = _v17.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cH: $elm$core$Maybe$Just(_Utils_Tuple2(upload, $author$project$Api$Data$Loading))
                    }), A5($author$project$Api$Upload$cancel, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model), model.Ej, model.Z$, $author$project$Api$Upload$All$id(upload), $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Canceled(upload)), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cH: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var upload = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    cH: $elm$core$Maybe$Nothing,
                    o8: $author$project$Api$Data$Loading
                }), $author$project$Pages$Companies$CompanyId_String$Uploads$Top$fetchUploads(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Upload successfully canceled.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    cH: $elm$core$Maybe$Just(_Utils_Tuple2(upload, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v19 = $author$project$Components$FileLink$update(subMsg);
                var getFileCmdMsg = _v19.a;
                var outMsgs = _v19.b;
                return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg, getFileCmdMsg), outMsgs);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$PaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Upload = {
        $: 4
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild = function(company) {
        return $author$project$Api$Company$companyType(company) === 1;
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$canUploadFile = A2($elm$core$Basics$composeL, $elm$core$Basics$not, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild);
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsParent = function(company) {
        return $author$project$Api$Company$companyType(company) === 2;
    };
    var $author$project$Api$Employer$Upload$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$name(shared);
    };
    var $author$project$Api$Upload$All$name = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$name(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$name(upload_);
        }
    };
    var $author$project$Components$Company$UploadModal$FileUploaded = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Company$UploadModal$Save = {
        $: 2
    };
    var $author$project$Components$Company$UploadModal$view = function(_v0) {
        var model = _v0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Company$UploadModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Upload File')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Company$UploadModal$Save),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('File'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(4)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$File$view(_List_fromArray([
                            $author$project$Ui$Form$File$accept(1),
                            $author$project$Ui$Form$File$onInput($author$project$Components$Company$UploadModal$FileUploaded)
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Company$UploadModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Upload'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Company$UploadModal$Save),
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Upload')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Upload$ProcessUploadModal$Process = {
        $: 1
    };
    var $author$project$Components$Upload$ProcessUploadModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Upload$ProcessUploadModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Process Upload')
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel and close modal'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Components$Upload$ProcessUploadModal$Close),
                            $author$project$Ui$Button$fullWidth(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Process upload'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Components$Upload$ProcessUploadModal$Process),
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$loading(_Utils_eq(model.nL, $author$project$Api$Data$Loading))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Process Upload')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'File'),
        A3($author$project$Api$Column$init, 'uploader_type', true, 'Type'),
        A3($author$project$Api$Column$init, 'status', true, 'Status'),
        A3($author$project$Api$Column$init, 'started_at', true, 'Started'),
        A3($author$project$Api$Column$init, 'finished_at', true, 'Finished'),
        A3($author$project$Api$Column$init, 'rows_total', true, 'Total Rows'),
        A3($author$project$Api$Column$init, 'rows_processed_or_ignored', true, 'Processed'),
        A3($author$project$Api$Column$init, 'rows_failed', true, 'Failed'),
        A3($author$project$Api$Column$init, '', false, 'Actions')
    ]);
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Cancel = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicate = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$Process = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Employer$Upload$Meta$preprocessAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Xl;
    };
    var $author$project$Api$Provider$Upload$Meta$preprocessAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Xl;
    };
    var $author$project$Api$Upload$Meta$preprocessAction = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$Meta$preprocessAction(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$Meta$preprocessAction(upload_);
        }
    };
    var $author$project$Api$Employer$Upload$Meta$processAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Xt;
    };
    var $author$project$Api$Provider$Upload$Meta$processAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Xt;
    };
    var $author$project$Api$Upload$Meta$processAction = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$Meta$processAction(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$Meta$processAction(upload_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$canProcessUpload = function(meta) {
        return $author$project$Api$Upload$Meta$preprocessAction(meta) || $author$project$Api$Upload$Meta$processAction(meta);
    };
    var $author$project$Api$Employer$Upload$Meta$cancelAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KW;
    };
    var $author$project$Api$Provider$Upload$Meta$cancelAction = function(_v0) {
        var meta = _v0;
        return meta.tM.KW;
    };
    var $author$project$Api$Upload$Meta$cancelAction = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$Meta$cancelAction(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$Meta$cancelAction(upload_);
        }
    };
    var $author$project$Api$Employer$Upload$Meta$duplicateAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Om;
    };
    var $author$project$Api$Provider$Upload$Meta$duplicateAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Om;
    };
    var $author$project$Api$Upload$Meta$duplicateAction = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$Meta$duplicateAction(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$Meta$duplicateAction(upload_);
        }
    };
    var $author$project$Api$Upload$uploadPath = F3(function(basePath, session, id_) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Api$Employer$Upload$uploadPath(id_) : A2($author$project$Api$Provider$Upload$uploadPath, basePath, id_);
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$exportCsvPath = F2(function(model, upload) {
        return A4($author$project$Api$Data$downloadUrl, model.Ej, A3($author$project$Api$Upload$uploadPath, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$basePath(model), model.Z$, $author$project$Api$Upload$All$id(upload)), 0, _List_Nil);
    });
    var $author$project$Api$Common$Upload$Shared$rowsFailed = function(_v0) {
        var record = _v0;
        return record.Zd;
    };
    var $author$project$Api$Employer$Upload$All$rowsFailed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsFailed(shared);
    };
    var $author$project$Api$Provider$Upload$All$rowsFailed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsFailed(shared);
    };
    var $author$project$Api$Upload$All$rowsFailed = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$rowsFailed(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$rowsFailed(upload_);
        }
    };
    var $author$project$Api$Common$Upload$Shared$rowsSupressed = function(_v0) {
        var record = _v0;
        return record.Zg;
    };
    var $author$project$Api$Employer$Upload$All$rowsSupressed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsSupressed(shared);
    };
    var $author$project$Api$Provider$Upload$All$rowsSupressed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsSupressed(shared);
    };
    var $author$project$Api$Upload$All$rowsSupressed = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$rowsSupressed(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$rowsSupressed(upload_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$failedRowsCountWithoutSupressed = function(upload) {
        return $elm$core$List$maximum(_List_fromArray([
            $author$project$Api$Upload$All$rowsFailed(upload) - $author$project$Api$Upload$All$rowsSupressed(upload),
            0
        ]));
    };
    var $author$project$Api$Common$Upload$Shared$finishedAt = function(_v0) {
        var record = _v0;
        return record.PK;
    };
    var $author$project$Api$Employer$Upload$All$finishedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$finishedAt(shared);
    };
    var $author$project$Api$Provider$Upload$All$finishedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$finishedAt(shared);
    };
    var $author$project$Api$Upload$All$finishedAt = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$finishedAt(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$finishedAt(upload_);
        }
    };
    var $author$project$Ui$Typography$LongText = {
        $: 22
    };
    var $author$project$Ui$Typography$longText = $author$project$Ui$Typography$LongText;
    var $author$project$Api$Upload$Meta$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Upload$Meta$fromEmployer = $author$project$Api$Upload$Meta$Employer;
    var $author$project$Api$Upload$Meta$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Upload$Meta$fromProvider = $author$project$Api$Upload$Meta$Provider;
    var $author$project$Api$Employer$Upload$All$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Provider$Upload$All$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Api$Upload$All$meta = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Upload$Meta$fromProvider($author$project$Api$Provider$Upload$All$meta(upload_));
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Upload$Meta$fromEmployer($author$project$Api$Employer$Upload$All$meta(upload_));
        }
    };
    var $author$project$Ui$Table$noWrap = $author$project$Ui$Table$NoWrap;
    var $author$project$Api$Employer$Upload$All$rowsProcessedOrIgnored = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
    };
    var $author$project$Api$Provider$Upload$All$rowsProcessedOrIgnored = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsProcessedOrIgnored(shared);
    };
    var $author$project$Api$Upload$All$rowsProcessedOrIgnored = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$rowsProcessedOrIgnored(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$rowsProcessedOrIgnored(upload_);
        }
    };
    var $author$project$Api$Employer$Upload$All$rowsTotal = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
    };
    var $author$project$Api$Provider$Upload$All$rowsTotal = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$rowsTotal(shared);
    };
    var $author$project$Api$Upload$All$rowsTotal = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$rowsTotal(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$rowsTotal(upload_);
        }
    };
    var $author$project$Api$Common$Upload$Shared$startedAt = function(_v0) {
        var record = _v0;
        return record._3;
    };
    var $author$project$Api$Employer$Upload$All$startedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$startedAt(shared);
    };
    var $author$project$Api$Provider$Upload$All$startedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$startedAt(shared);
    };
    var $author$project$Api$Upload$All$startedAt = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$startedAt(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$startedAt(upload_);
        }
    };
    var $author$project$Api$Upload$Status$toString = function(status) {
        switch(status){
            case 0:
                return 'unattempted';
            case 1:
                return 'downloading';
            case 2:
                return 'enqueued_for_preprocessing';
            case 3:
                return 'ready_to_preprocess';
            case 4:
                return 'preprocessing';
            case 5:
                return 'review_data_matches';
            case 6:
                return 'review_file_size';
            case 7:
                return 'enqueued_for_processing';
            case 8:
                return 'ready_to_process';
            case 9:
                return 'processing';
            case 10:
                return 'postprocessing';
            case 11:
                return 'processed';
            case 12:
                return 'failed';
            default:
                return 'cancelled';
        }
    };
    var $author$project$Api$Employer$Upload$All$uploaderType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
    };
    var $author$project$Api$Provider$Upload$All$uploaderType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$uploaderType(shared);
    };
    var $author$project$Api$Upload$All$uploaderType = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$All$uploaderType(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$All$uploaderType(upload_);
        }
    };
    var $author$project$Ui$Link$Xs = 1;
    var $author$project$Ui$Link$xs = $author$project$Ui$Link$Size(1);
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewRow = F2(function(model, upload) {
        var meta = $author$project$Api$Upload$All$meta(upload);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$longText
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top({
                        fl: model.aef,
                        H_: $author$project$Api$Upload$All$id(upload)
                    }), _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Upload$All$name(upload)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Upload$All$uploaderType(upload);
                    switch(_v0.$){
                        case 0:
                            return $elm$html$Html$text('AutoSync');
                        case 1:
                            return $elm$html$Html$text('Manual');
                        case 2:
                            return $elm$html$Html$text('Manual');
                        default:
                            var string = _v0.a;
                            return $elm$html$Html$text(string);
                    }
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Upload$Status$toString($author$project$Api$Upload$All$status(upload)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, model.HO(0), $author$project$Api$Upload$All$startedAt(upload))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, model.HO(0), $author$project$Api$Upload$All$finishedAt(upload))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Upload$All$rowsTotal(upload)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Upload$All$rowsProcessedOrIgnored(upload)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt(A2($elm$core$Maybe$withDefault, 0, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$failedRowsCountWithoutSupressed(upload))))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$noWrap
            ]), _List_fromArray([
                A3($author$project$Ui$Tooltip$view, _List_Nil, 'Download file', _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ExportFileMsg, A3($author$project$Components$FileLink$view, {
                        Li: model.Ej,
                        PX: 0,
                        aaT: A2($author$project$Pages$Companies$CompanyId_String$Uploads$Top$exportCsvPath, model, upload)
                    }, _List_fromArray([
                        $author$project$Ui$Link$ariaLabel('Download file'),
                        $author$project$Ui$Link$xs,
                        $author$project$Ui$Link$buttonDefault,
                        $author$project$Ui$Link$icon($author$project$Ui$Icon$export)
                    ]), _List_Nil))
                ])),
                $author$project$Utils$Html$noBreakSpace,
                $author$project$Pages$Companies$CompanyId_String$Uploads$Top$canProcessUpload(meta) ? A3($author$project$Ui$Button$view, {
                    abP: 'Process upload'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$Top$Process(upload)),
                    $author$project$Ui$Button$loading(_Utils_eq(model.nM, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Process Upload')
                ])) : $author$project$Utils$Html$empty,
                $author$project$Utils$Html$noBreakSpace,
                $author$project$Api$Upload$Meta$duplicateAction(meta) ? A3($author$project$Ui$Button$view, {
                    abP: 'Duplicate upload'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$Top$Duplicate(upload))
                ]), _List_fromArray([
                    $elm$html$Html$text('Duplicate Upload')
                ])) : $author$project$Utils$Html$empty,
                $author$project$Utils$Html$noBreakSpace,
                $author$project$Api$Upload$Meta$cancelAction(meta) ? A3($author$project$Ui$Button$view, {
                    abP: 'Cancel upload'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$Top$Cancel(upload))
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel Upload')
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.o8;
            if (_v1.$ === 3) {
                var uploads_ = _v1.a;
                return _Utils_Tuple2(false, uploads_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var uploads = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You have no uploads yet!')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Companies$CompanyId_String$Uploads$Top$columns), A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewRow(model), uploads), _List_Nil);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$view = function(model) {
        return {
            fb: function() {
                var loading = function() {
                    var _v7 = model.o8;
                    if (_v7.$ === 3) return false;
                    else return true;
                }();
                return _List_fromArray([
                    function() {
                        var _v0 = model.kI;
                        if (!_v0.$) {
                            var uploadModal = _v0.a;
                            return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$UploadModalMsg, $author$project$Components$Company$UploadModal$view(uploadModal));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v1 = model.cH;
                        if (!_v1.$) {
                            var _v2 = _v1.a;
                            var upload = _v2.a;
                            var saveRequest = _v2.b;
                            return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$CancelHiConfirmClosed, _List_fromArray([
                                $author$project$Components$HiConfirm$verb('cancel'),
                                $author$project$Components$HiConfirm$noun('Upload'),
                                $author$project$Components$HiConfirm$detail('\"' + (A2($elm$core$Maybe$withDefault, '', $author$project$Api$Upload$All$name(upload)) + '\"')),
                                $author$project$Components$HiConfirm$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v3 = model.cT;
                        if (!_v3.$) {
                            var _v4 = _v3.a;
                            var upload = _v4.a;
                            var saveRequest = _v4.b;
                            return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$DuplicateHiConfirmClosed, _List_fromArray([
                                $author$project$Components$HiConfirm$verb('duplicate'),
                                $author$project$Components$HiConfirm$noun('Upload'),
                                $author$project$Components$HiConfirm$detail('\"' + (A2($elm$core$Maybe$withDefault, '', $author$project$Api$Upload$All$name(upload)) + '\"')),
                                $author$project$Components$HiConfirm$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v5 = model.jJ;
                        if (!_v5.$) {
                            var processUploadModal = _v5.a;
                            return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$ProcessUploadModalMsg, $author$project$Components$Upload$ProcessUploadModal$view(processUploadModal));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    model.lp ? $author$project$Components$Upload$CannotUploadModal$view($author$project$Pages$Companies$CompanyId_String$Uploads$Top$CannotUploadModalClosed) : $author$project$Utils$Html$empty,
                    A6($author$project$Layouts$Company$Uploads$view, model.Z$, model.W1, model.acy, model.iJ, _List_fromArray([
                        function() {
                            if (!$author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild(model.acy)) {
                                var fileUrl = 'https://docs.google.com/spreadsheets/d/1pJagUUuUftzqL8n4y_uzZLWuiQUaor7-59RLSAtPfPo/edit?gid=0';
                                return A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$helpBlock
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Employee Uploads following the '),
                                    A3($author$project$Ui$Link$externalHref, fileUrl, _List_fromArray([
                                        $author$project$Ui$Link$targetBlank
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('default CSV Template')
                                    ]))
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        A2($author$project$Ui$Grid$row, _List_fromArray([
                            $author$project$Ui$Grid$mb2
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(8)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                                        $author$project$Ui$SearchInput$phi(true),
                                        $author$project$Ui$SearchInput$placeholder('Search by file name or upload identificator')
                                    ]), model.sG))
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(4),
                                $author$project$Ui$Grid$justifyRight
                            ]), function() {
                                var _v6 = model.iJ;
                                if (_v6.$ === 3) {
                                    var feedEnroller = _v6.a;
                                    return _List_fromArray([
                                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                            function() {
                                                if ($author$project$Pages$Companies$CompanyId_String$Uploads$Top$canUploadFile(model.acy)) {
                                                    var buttonLabel = $author$project$Utils$Maybe$toBool(feedEnroller) || $author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsParent(model.acy) ? 'Upload AutoSync file' : 'Upload file';
                                                    return A3($author$project$Ui$Button$view, {
                                                        abP: buttonLabel
                                                    }, _List_fromArray([
                                                        $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$Top$Upload),
                                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                                    ]), _List_fromArray([
                                                        $elm$html$Html$text(buttonLabel)
                                                    ]));
                                                } else return $author$project$Utils$Html$empty;
                                            }(),
                                            model.F3 && !$author$project$Utils$Maybe$toBool(feedEnroller) && !$author$project$Pages$Companies$CompanyId_String$Uploads$Top$companyIsChild(model.acy) && !$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? A3($author$project$Ui$HinterOnly$linkRoute, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas({
                                                fl: model.aef
                                            }), _List_fromArray([
                                                $author$project$Ui$Link$buttonDefault
                                            ]), _List_fromArray([
                                                $elm$html$Html$text(' Configure EAS')
                                            ])) : $author$project$Utils$Html$empty
                                        ]))
                                    ]);
                                } else return _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_fromArray([
                                        $author$project$Ui$Spinner$small
                                    ]))
                                ]);
                            }())
                        ])),
                        $author$project$Pages$Companies$CompanyId_String$Uploads$Top$viewTable(model)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(loading)
                        ]), model.af_))
                    ]))
                ]);
            }(),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Employee Uploads'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Uploads$Top$view
    });
    var $author$project$Components$Upload$UploadRowList$Failed = 0;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotFeedEnroller = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None = {
        $: 0
    };
    var $author$project$Components$Upload$UploadRowList$Processed = 2;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Upload$UploadRowList$Warning = 1;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotUpload = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$basePath = function(model) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? $author$project$Api$Data$employerPath : $author$project$Api$Provider$Company$companyPath(model.fl);
    };
    var $author$project$Api$Employer$Upload$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$Upload$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Upload$uploadPath(id_)));
    });
    var $author$project$Api$Upload$retrieve = F5(function(basePath, apiClient, session, id_, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A3($author$project$Api$Employer$Upload$retrieve, apiClient, id_, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Upload$One$fromEmployer))) : A4($author$project$Api$Provider$Upload$retrieve, basePath, apiClient, id_, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Upload$One$fromProvider)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$fetchUpload = function(model) {
        return A5($author$project$Api$Upload$retrieve, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$basePath(model), model.Ej, model.Z$, model.aef, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotUpload);
    };
    var $author$project$Components$Upload$UploadRowList$GotUploadRows = $elm$core$Basics$identity;
    var $author$project$Api$UploadRow$All$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$UploadRow$All$fromEmployer = $author$project$Api$UploadRow$All$Employer;
    var $author$project$Api$UploadRow$All$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$UploadRow$All$fromProvider = $author$project$Api$UploadRow$All$Provider;
    var $author$project$Api$Employer$UploadRow$All$UploadRow = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$UploadRow$Shared$UploadRow = $elm$core$Basics$identity;
    var $author$project$Api$Employer$UploadRow$Shared$Record = F5(function(id, rowNumber, reviewed, isSupressed, csvRow) {
        return {
            MH: csvRow,
            aef: id,
            St: isSupressed,
            Y6: reviewed,
            Zb: rowNumber
        };
    });
    var $author$project$Api$Employer$UploadRow$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'csv_row', $elm$json$Json$Decode$dict($elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_supressed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reviewed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'row_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$Shared$Record))))));
    var $author$project$Api$Employer$UploadRow$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$UploadRow$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$UploadRow$All$Record = F2(function(resultData, uploadRowResults) {
        return {
            YY: resultData,
            aaP: uploadRowResults
        };
    });
    var $author$project$Api$Employer$UploadRowResult$Shared$UploadRowResult = $elm$core$Basics$identity;
    var $author$project$Api$Employer$UploadRowResult$Shared$Record = F2(function(message, resultType) {
        return {
            ae1: message,
            YZ: resultType
        };
    });
    var $author$project$Api$Employer$UploadRowResult$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'result_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRowResult$Shared$Record)));
    var $author$project$Api$Employer$UploadRowResult$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$UploadRowResult$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$UploadRow$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'upload_row_results', $elm$json$Json$Decode$list($author$project$Api$Employer$UploadRowResult$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'result_data', $elm$json$Json$Decode$nullable($author$project$Api$Common$UploadRowResult$Data$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$All$Record)));
    var $author$project$Api$Employer$UploadRow$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$UploadRow$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$UploadRow$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$All$UploadRow)));
    var $author$project$Api$Employer$UploadRow$uploadRowsPath = function(uploadId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'upload_rows'
        ]), $author$project$Api$Employer$Upload$uploadPath(uploadId));
    };
    var $author$project$Api$Employer$UploadRow$list = F4(function(apiClient, uploadId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Employer$UploadRow$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Common$UploadRow$ListOptionals$toParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Employer$UploadRow$uploadRowsPath(uploadId))));
    });
    var $author$project$Api$UploadRow$list = F5(function(apiClient, session, uploadId, optionals, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$UploadRow$list, apiClient, uploadId, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$UploadRow$All$fromEmployer)))) : A4($author$project$Api$Provider$UploadRow$list, apiClient, uploadId, optionals, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Api$UploadRow$All$fromProvider))));
    });
    var $author$project$Api$Common$UploadRow$ListOptionals$Processed = 2;
    var $author$project$Api$Common$UploadRow$ListOptionals$Warning = 1;
    var $author$project$Components$Upload$UploadRowList$resultTypeFilter = function(resultType) {
        switch(resultType){
            case 0:
                return 0;
            case 1:
                return 1;
            default:
                return 2;
        }
    };
    var $author$project$Components$Upload$UploadRowList$fetchUploadRows = F2(function(apiClient, model) {
        var resultTypeListOptionals = function(listOptionals) {
            var _v0 = model.YZ;
            switch(_v0){
                case 0:
                    return _Utils_update(listOptionals, {
                        HI: $elm$core$Maybe$Just('not_supressed')
                    });
                case 1:
                    return listOptionals;
                default:
                    return listOptionals;
            }
        };
        return A5($author$project$Api$UploadRow$list, apiClient, model.Z$, model.H_, A2($elm$core$Basics$composeR, function(d) {
            return _Utils_update(d, {
                Fw: $elm$core$Maybe$Just($author$project$Components$Upload$UploadRowList$resultTypeFilter(model.YZ))
            });
        }, resultTypeListOptionals), $elm$core$Basics$identity);
    });
    var $author$project$Components$Upload$UploadRowList$init = F5(function(apiClient, session, companyId, uploadId, resultType) {
        var model = {
            fl: companyId,
            YZ: resultType,
            Z$: session,
            H_: uploadId,
            tC: $author$project$Api$Data$Loading
        };
        return _Utils_Tuple2(model, A2($author$project$Components$Upload$UploadRowList$fetchUploadRows, apiClient, model));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$init = F5(function(session, practice, company, shared, _v0) {
        var params = _v0.VU;
        var _v1 = A5($author$project$Components$Upload$UploadRowList$init, shared.Ej, session, params.fl, params.H_, 1);
        var warningUploadRowList = _v1.a;
        var warningUploadRowListCmd = _v1.b;
        var _v2 = A5($author$project$Components$Upload$UploadRowList$init, shared.Ej, session, params.fl, params.H_, 2);
        var processedUploadRowList = _v2.a;
        var processedUploadRowListCmd = _v2.b;
        var _v3 = A5($author$project$Components$Upload$UploadRowList$init, shared.Ej, session, params.fl, params.H_, 0);
        var failedUploadRowList = _v3.a;
        var failedUploadRowListCmd = _v3.b;
        var model = {
            Ej: shared.Ej,
            acy: company,
            fl: params.fl,
            qG: failedUploadRowList,
            iJ: $author$project$Api$Data$Loading,
            aef: params.H_,
            W1: practice,
            sj: processedUploadRowList,
            Z$: session,
            HO: shared.HO,
            DP: $author$project$Api$Data$Loading,
            eS: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None,
            tH: warningUploadRowList
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$fetchUpload(model),
            A4($author$project$Api$FeedEnroller$retrieve, shared.Ej, session, params.fl, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$GotFeedEnroller),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg, failedUploadRowListCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg, warningUploadRowListCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg, processedUploadRowListCmd)
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed = {
        $: 7
    };
    var $author$project$Components$Upload$WarningDetailsModal$subscribeToEscapeKeyPress = function(msg) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(msg);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$subscriptions = function(model) {
        var _v0 = model.eS;
        if (_v0.$ === 1) return $author$project$Components$Upload$WarningDetailsModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$core$Dict$map = F2(function(func, dict) {
        if (dict.$ === -2) return $elm$core$Dict$RBEmpty_elm_builtin;
        else {
            var color = dict.a;
            var key = dict.b;
            var value = dict.c;
            var left = dict.d;
            var right = dict.e;
            return A5($elm$core$Dict$RBNode_elm_builtin, color, key, A2(func, key, value), A2($elm$core$Dict$map, func, left), A2($elm$core$Dict$map, func, right));
        }
    });
    var $BrianHicks$elm_csv$Csv$Encode$encodeItems = F2(function(encoder, rows) {
        if (!encoder.$) {
            var convert = encoder.a;
            var _v1 = A3($elm$core$List$foldr, F2(function(row, _v2) {
                var converted_ = _v2.a;
                var names = _v2.b;
                var convertedRow = convert(row);
                return _Utils_Tuple2(A2($elm$core$List$cons, $elm$core$Dict$fromList(convertedRow), converted_), A3($elm$core$List$foldl, F2(function(_v3, _v4) {
                    var name = _v3.a;
                    var soFar = _v4.a;
                    var column = _v4.b;
                    return _Utils_Tuple2(A3($elm$core$Dict$update, name, function(value) {
                        if (!value.$) {
                            var columns = value.a;
                            return $elm$core$Maybe$Just(A2($elm$core$List$cons, column, columns));
                        } else return $elm$core$Maybe$Just(_List_fromArray([
                            column
                        ]));
                    }, soFar), column + 1);
                }), _Utils_Tuple2(names, 0), convertedRow).a);
            }), _Utils_Tuple2(_List_Nil, $elm$core$Dict$empty), rows);
            var converted = _v1.a;
            var namePositions = _v1.b;
            var ordering = A2($elm$core$List$map, $elm$core$Tuple$first, A2($elm$core$List$sortBy, $elm$core$Tuple$second, $elm$core$Dict$toList(A2($elm$core$Dict$map, F2(function(_v6, positions) {
                return $elm$core$List$sum(positions) / $elm$core$List$length(positions);
            }), namePositions))));
            return A2($elm$core$List$cons, ordering, A2($elm$core$List$map, function(row) {
                return A2($elm$core$List$map, function(field) {
                    return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Dict$get, field, row));
                }, ordering);
            }, converted));
        } else {
            var convert = encoder.a;
            return A2($elm$core$List$map, convert, rows);
        }
    });
    var $BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary = F2(function(fieldSeparator, value) {
        return A2($elm$core$String$contains, '\"', value) || A2($elm$core$String$contains, fieldSeparator, value) || A2($elm$core$String$contains, '\u000D\n', value) || A2($elm$core$String$contains, '\n', value) ? '\"' + (A3($elm$core$String$replace, '\"', '\"\"', value) + '\"') : value;
    });
    var $BrianHicks$elm_csv$Csv$Encode$encode = F2(function(_v0, items) {
        var encoder = _v0.adp;
        var fieldSeparator = _v0.adL;
        var fieldSeparatorString = $elm$core$String$fromChar(fieldSeparator);
        return A2($elm$core$String$join, '\u000D\n', A2($elm$core$List$map, A2($elm$core$Basics$composeL, $elm$core$String$join(fieldSeparatorString), $elm$core$List$map($BrianHicks$elm_csv$Csv$Encode$quoteIfNecessary(fieldSeparatorString))), A2($BrianHicks$elm_csv$Csv$Encode$encodeItems, encoder, items)));
    });
    var $elm$file$File$Download$string = F3(function(name, mime, content) {
        return A2($elm$core$Task$perform, $elm$core$Basics$never, A3(_File_download, name, mime, content));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$warningRowEncoder = function(record) {
        return _List_fromArray([
            _Utils_Tuple2('Ident', record.aeg),
            _Utils_Tuple2('First Name', record.PN),
            _Utils_Tuple2('Last Name', record.SU),
            _Utils_Tuple2('DOB', record.add),
            _Utils_Tuple2('Company Name', record.LN),
            _Utils_Tuple2('External ID', record.adE)
        ]);
    };
    var $BrianHicks$elm_csv$Csv$Encode$WithFieldNames = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $BrianHicks$elm_csv$Csv$Encode$withFieldNames = $BrianHicks$elm_csv$Csv$Encode$WithFieldNames;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$downloadWarnings = function(warnings) {
        var warningsList = function() {
            if (warnings.$ === 1) {
                var _v1 = warnings.a;
                var warnings_ = _v1.b;
                return warnings_;
            } else return _List_Nil;
        }();
        return A3($elm$file$File$Download$string, 'warnings.csv', 'text/csv', A2($BrianHicks$elm_csv$Csv$Encode$encode, {
            adp: $BrianHicks$elm_csv$Csv$Encode$withFieldNames($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$warningRowEncoder),
            adL: ','
        }, warningsList));
    };
    var $author$project$Components$Upload$UploadRowList$update = F2(function(msg, model) {
        var response = msg;
        return _Utils_Tuple3(_Utils_update(model, {
            tC: response
        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    DP: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    iJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.qG);
                var failedUploadRowList_ = _v1.a;
                var failedUploadRowListCmd = _v1.b;
                var failedUploadRowListOutMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    qG: failedUploadRowList_
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg, failedUploadRowListCmd), failedUploadRowListOutMsgs);
            case 3:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.tH);
                var warningUploadRowList_ = _v2.a;
                var warningUploadRowListCmd = _v2.b;
                var warningUploadRowListOutMsgs = _v2.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    tH: warningUploadRowList_
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg, warningUploadRowListCmd), warningUploadRowListOutMsgs);
            case 4:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Components$Upload$UploadRowList$update, subMsg, model.sj);
                var processedUploadRowList_ = _v3.a;
                var processedUploadRowListCmd = _v3.b;
                var processedUploadRowListOutMsgs = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    sj: processedUploadRowList_
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg, processedUploadRowListCmd), processedUploadRowListOutMsgs);
            case 5:
                var type_ = msg.a;
                var warnings = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    eS: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings(_Utils_Tuple2($author$project$Formatters$String$titleize(type_), warnings))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var registration = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    eS: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$Warnings(_Utils_Tuple2('Too many unenrollments', registration.aeh))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    eS: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    eS: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$None
                }), $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$downloadWarnings(model.eS), _List_Nil);
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalDownload = {
        $: 8
    };
    var $author$project$Components$Upload$WarningDetailsModal$button = function(onClick) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Export to csv'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick(onClick),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$export)
        ]), _List_fromArray([
            A3($author$project$Ui$Tooltip$view, _List_fromArray([
                $author$project$Ui$Tooltip$placement(2)
            ]), 'Export to CSV', _List_Nil)
        ]));
    };
    var $author$project$Components$Upload$WarningDetailsModal$viewWarning = function(warning) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(warning.aeg)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(warning.PN)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(warning.SU)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(warning.add)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(warning.LN)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(warning.adE)
            ]))
        ]));
    };
    var $author$project$Components$Upload$WarningDetailsModal$view = F4(function(title, warnings, onClose, onDownload) {
        return A3($author$project$Ui$Modal$view, onClose, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(title)
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('ID')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('First Name')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Last Name')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('DOB')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Company Name')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('External ID')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $author$project$Components$Upload$WarningDetailsModal$button(onDownload)
                    ]))
                ]), A2($elm$core$List$map, $author$project$Components$Upload$WarningDetailsModal$viewWarning, warnings), _List_Nil)
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick(onClose)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewTooManyUnenrollmentsWarning = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewUploadWarnings = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$Upload$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$Upload$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$createdAt(shared);
    };
    var $author$project$Api$Upload$One$createdAt = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$One$createdAt(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$One$createdAt(upload_);
        }
    };
    var $author$project$Api$Employer$Upload$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$errorMessage(shared);
    };
    var $author$project$Api$Upload$One$errorMessage = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$One$errorMessage(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$One$errorMessage(upload_);
        }
    };
    var $elm$core$String$lines = _String_lines;
    var $author$project$Api$Employer$Upload$One$results = function(_v0) {
        var record = _v0.b;
        return record.Y_;
    };
    var $author$project$Api$Provider$Upload$One$results = function(_v0) {
        var record = _v0.b;
        return record.Y_;
    };
    var $author$project$Api$Upload$One$results = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$One$results(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$One$results(upload_);
        }
    };
    var $author$project$Api$Employer$Upload$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Upload$Shared$status(shared);
    };
    var $author$project$Api$Upload$One$status = function(upload) {
        if (!upload.$) {
            var upload_ = upload.a;
            return $author$project$Api$Provider$Upload$One$status(upload_);
        } else {
            var upload_ = upload.a;
            return $author$project$Api$Employer$Upload$One$status(upload_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$uploadStatusLabel = function(upload) {
        var status = $author$project$Api$Upload$One$status(upload);
        return status === 2 || status === 7 ? 'enqueued' : $author$project$Api$Upload$Status$toString(status);
    };
    var $author$project$Ui$ListGroup$Danger = 3;
    var $author$project$Ui$ListGroup$Success = 0;
    var $author$project$Ui$ListGroup$Warning = 2;
    var $author$project$Ui$ListGroup$Background = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$ListGroup$background = $author$project$Ui$ListGroup$Background;
    var $author$project$Components$Upload$UploadRowList$backgroundStyle = function(resultType) {
        switch(resultType){
            case 0:
                return $author$project$Ui$ListGroup$background(3);
            case 1:
                return $author$project$Ui$ListGroup$background(2);
            default:
                return $author$project$Ui$ListGroup$background(0);
        }
    };
    var $author$project$Components$Upload$UploadRowList$resultTypeToString = function(resultType) {
        switch(resultType){
            case 0:
                return 'failed';
            case 1:
                return 'warning';
            default:
                return 'processed';
        }
    };
    var $author$project$Components$Upload$UploadRowList$resultTypeToTitle = function(resultType) {
        switch(resultType){
            case 0:
                return 'Failed';
            case 1:
                return 'Warning';
            default:
                return 'Processed';
        }
    };
    var $author$project$Components$Upload$UploadRowList$textStyle = function(resultType) {
        switch(resultType){
            case 0:
                return $author$project$Ui$Typography$danger;
            case 1:
                return $author$project$Ui$Typography$warning;
            default:
                return $author$project$Ui$Typography$success;
        }
    };
    var $author$project$Components$Upload$UploadRowList$isErrorsOrWarnings = function(resultType) {
        return !resultType || resultType === 1;
    };
    var $author$project$Api$Employer$UploadRow$Shared$rowNumber = function(_v0) {
        var record = _v0;
        return record.Zb;
    };
    var $author$project$Api$Employer$UploadRow$All$rowNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$UploadRow$Shared$rowNumber(shared);
    };
    var $author$project$Api$Provider$UploadRow$Shared$rowNumber = function(_v0) {
        var record = _v0;
        return record.Zb;
    };
    var $author$project$Api$Provider$UploadRow$All$rowNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$UploadRow$Shared$rowNumber(shared);
    };
    var $author$project$Api$UploadRow$All$rowNumber = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$All$rowNumber(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$All$rowNumber(uploadRow_);
        }
    };
    var $author$project$Api$Employer$UploadRowResult$Shared$message = function(_v0) {
        var record = _v0;
        return record.ae1;
    };
    var $author$project$Api$UploadRowResult$Shared$message = function(uploadRowResult) {
        if (!uploadRowResult.$) {
            var uploadRowResult_ = uploadRowResult.a;
            return $author$project$Api$Provider$UploadRowResult$Shared$message(uploadRowResult_);
        } else {
            var uploadRowResult_ = uploadRowResult.a;
            return $author$project$Api$Employer$UploadRowResult$Shared$message(uploadRowResult_);
        }
    };
    var $author$project$Api$Employer$UploadRowResult$Shared$resultType = function(_v0) {
        var record = _v0;
        return record.YZ;
    };
    var $author$project$Api$Provider$UploadRowResult$Shared$resultType = function(_v0) {
        var record = _v0;
        return record.YZ;
    };
    var $author$project$Api$UploadRowResult$Shared$resultType = function(uploadRowResult) {
        if (!uploadRowResult.$) {
            var uploadRowResult_ = uploadRowResult.a;
            return $author$project$Api$Provider$UploadRowResult$Shared$resultType(uploadRowResult_);
        } else {
            var uploadRowResult_ = uploadRowResult.a;
            return $author$project$Api$Employer$UploadRowResult$Shared$resultType(uploadRowResult_);
        }
    };
    var $author$project$Api$UploadRowResult$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$UploadRowResult$Shared$fromEmployer = $author$project$Api$UploadRowResult$Shared$Employer;
    var $author$project$Api$UploadRowResult$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$UploadRowResult$Shared$fromProvider = $author$project$Api$UploadRowResult$Shared$Provider;
    var $author$project$Api$Employer$UploadRow$All$uploadRowResults = function(_v0) {
        var record = _v0.b;
        return record.aaP;
    };
    var $author$project$Api$UploadRow$All$uploadRowResults = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return A2($elm$core$List$map, $author$project$Api$UploadRowResult$Shared$fromProvider, $author$project$Api$Provider$UploadRow$All$uploadRowResults(uploadRow_));
        } else {
            var uploadRow_ = uploadRow.a;
            return A2($elm$core$List$map, $author$project$Api$UploadRowResult$Shared$fromEmployer, $author$project$Api$Employer$UploadRow$All$uploadRowResults(uploadRow_));
        }
    };
    var $author$project$Components$Upload$UploadRowList$viewUploadRowMessage = F2(function(messageTypes, uploadRow) {
        var messages = A2($elm$core$List$filterMap, function(uploadRowResult) {
            return A2($elm$core$Maybe$andThen, function(resultType) {
                return A2($elm$core$List$member, resultType, messageTypes) ? $author$project$Api$UploadRowResult$Shared$message(uploadRowResult) : $elm$core$Maybe$Nothing;
            }, $author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
        }, $author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
        var messagesString = A2($elm$core$String$join, ' - ', $elm_community$list_extra$List$Extra$unique(messages));
        var _v0 = $author$project$Utils$String$toMaybe(messagesString);
        if (!_v0.$) {
            var messagesString_ = _v0.a;
            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 100, messagesString_))
            ]));
        } else return A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Blank')
        ]));
    });
    var $author$project$Components$Upload$UploadRowList$viewUploadRowResult = function(uploadRow) {
        var ignoredTypes = _List_fromArray([
            'warning'
        ]);
        var resultsWithoutWarnings = A2($elm$core$List$filterMap, function(uploadRowResult) {
            return A2($elm$core$Maybe$andThen, function(resultType) {
                return !A2($elm$core$List$member, resultType, ignoredTypes) ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
            }, $author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
        }, $author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
        var uniqSortedResults = $elm_community$list_extra$List$Extra$unique(resultsWithoutWarnings);
        var humanizedResults = A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize), uniqSortedResults);
        var resultsString = $elm$core$List$isEmpty(humanizedResults) ? 'No Account Change' : A2($elm$core$String$join, ' - ', humanizedResults);
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 100, resultsString))
        ]));
    };
    var $author$project$Components$Upload$UploadRowList$viewUploadRow = F2(function(resultType, uploadRow) {
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(10)
                ]), _List_fromArray([
                    function() {
                        if ($author$project$Components$Upload$UploadRowList$isErrorsOrWarnings(resultType)) {
                            var messageTypes = function() {
                                switch(resultType){
                                    case 0:
                                        return _List_fromArray([
                                            'error'
                                        ]);
                                    case 1:
                                        return _List_fromArray([
                                            'warning',
                                            'duplicate_ignored'
                                        ]);
                                    default:
                                        return _List_Nil;
                                }
                            }();
                            return A2($author$project$Components$Upload$UploadRowList$viewUploadRowMessage, messageTypes, uploadRow);
                        } else return $author$project$Components$Upload$UploadRowList$viewUploadRowResult(uploadRow);
                    }()
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(2),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Row #'),
                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$UploadRow$All$rowNumber(uploadRow)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Upload$UploadRowList$zeroState = function(resultType) {
        switch(resultType){
            case 0:
                return 'No failed rows';
            case 1:
                return 'No rows with warnings';
            default:
                return 'No rows processed';
        }
    };
    var $author$project$Components$Upload$UploadRowList$view = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A2($elm$html$Html$h5, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = model.tC;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            var totalCount = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Components$Upload$UploadRowList$textStyle(model.YZ)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Components$Upload$UploadRowList$resultTypeToTitle(model.YZ)),
                                $elm$html$Html$text(' - '),
                                $elm$html$Html$text($elm$core$String$fromInt(totalCount)),
                                $elm$html$Html$text(' rows ')
                            ]));
                        } else return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_fromArray([
                                $author$project$Ui$Spinner$small
                            ]))
                        ]));
                    }()
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults({
                    fl: model.fl,
                    H_: model.H_
                }), _List_fromArray([
                    $author$project$Ui$Link$routeParams(_List_fromArray([
                        A2($elm$url$Url$Builder$string, 'resultType', $author$project$Components$Upload$UploadRowList$resultTypeToString(model.YZ))
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text('See all rows >')
                ]))
            ])),
            function() {
                var _v1 = model.tC;
                if (_v1.$ === 3) {
                    var uploadRows = _v1.a;
                    var listGroupOptions = A2($elm$core$List$cons, $author$project$Ui$ListGroup$zeroState($author$project$Components$Upload$UploadRowList$zeroState(model.YZ)), $elm$core$List$isEmpty(uploadRows) ? _List_Nil : _List_fromArray([
                        $author$project$Components$Upload$UploadRowList$backgroundStyle(model.YZ)
                    ]));
                    return A2($author$project$Ui$ListGroup$view, listGroupOptions, A2($elm$core$List$map, $author$project$Components$Upload$UploadRowList$viewUploadRow(model.YZ), uploadRows));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$viewUpload = F2(function(model, upload) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$uploadStatusLabel(upload)))
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('File received on '),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text(A2(model.HO, 0, $author$project$Api$Upload$One$createdAt(upload)))
                ]))
            ])),
            function() {
                var _v0 = $author$project$Api$Upload$One$errorMessage(upload);
                if (!_v0.$) {
                    var errorMessage = _v0.a;
                    var errorMessages = $elm$core$String$lines(errorMessage);
                    return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, function(message) {
                        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, 'error'),
                            $author$project$Utils$Html$noBreakSpace,
                            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(message)
                            ]))
                        ]));
                    }, errorMessages));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Typography$p, _List_Nil, A2($elm$core$List$map, function(result) {
                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    function() {
                        switch(result.$){
                            case 0:
                                var value = result.a;
                                return A2($author$project$Ui$Typography$span, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Badge$fromString, _List_Nil, 'warning'), A2($elm$core$List$cons, $author$project$Utils$Html$noBreakSpace, A2($elm$core$List$cons, $elm$html$Html$text(value.ae1), A2($elm$core$List$indexedMap, F2(function(index, registration) {
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(registration.acy),
                                        $elm$html$Html$text(' ('),
                                        $elm$html$Html$text($elm$core$String$fromInt(registration.Me)),
                                        $elm$html$Html$text(') '),
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'View unenrollment warnings'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$link,
                                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                            $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewTooManyUnenrollmentsWarning(registration))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('View >')
                                        ])),
                                        _Utils_eq(index, $elm$core$List$length(value.agG) - 1) ? $author$project$Utils$Html$empty : $elm$html$Html$text(', ')
                                    ]));
                                }), value.agG)))));
                            case 1:
                                var key = result.a;
                                var value = result.b;
                                return $elm$core$List$isEmpty(value) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'warning'),
                                    $author$project$Utils$Html$noBreakSpace,
                                    $elm$html$Html$text($author$project$Formatters$String$humanize(key)),
                                    $elm$html$Html$text(' ('),
                                    $elm$html$Html$text($elm$core$String$fromInt($elm$core$List$length(value))),
                                    $elm$html$Html$text(') '),
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'View upload warnings'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                        $author$project$Ui$Button$onClick(A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ViewUploadWarnings, key, value))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('View >')
                                    ]))
                                ]));
                            default:
                                return $author$project$Utils$Html$empty;
                        }
                    }()
                ]));
            }, $author$project$Api$Upload$One$results(upload))),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$FailedUploadRowListMsg, $author$project$Components$Upload$UploadRowList$view(model.qG))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningUploadRowListMsg, $author$project$Components$Upload$UploadRowList$view(model.tH))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(12)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$ProcessedUploadRowListMsg, $author$project$Components$Upload$UploadRowList$view(model.sj))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.eS;
                    if (_v0.$ === 1) {
                        var _v1 = _v0.a;
                        var title = _v1.a;
                        var warnings = _v1.b;
                        return A4($author$project$Components$Upload$WarningDetailsModal$view, title, warnings, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalClosed, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$WarningDetailsModalDownload);
                    } else return $author$project$Utils$Html$empty;
                }(),
                A6($author$project$Layouts$Company$Uploads$view, model.Z$, model.W1, model.acy, model.iJ, _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top({
                                        fl: model.fl
                                    }), _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Uploads')
                                    ]))
                                ])),
                                A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                    $author$project$Ui$Breadcrumb$active(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(model.aef)
                                ]))
                            ]))),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            function() {
                                var _v2 = model.DP;
                                if (_v2.$ === 3) {
                                    var upload = _v2.a;
                                    return A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$viewUpload, model, upload);
                                } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                                ]), _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_Nil)
                                ]));
                            }()
                        ]))
                    ]))
                ]), _List_Nil)
            ]),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Employee Uploads'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$view
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotFeedEnroller = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NotSupressed = 1;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Processed = 2;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressFilterDropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Supressed = 0;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UploadRowResultsActionDropdownMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$UploadRowSponsor = 18;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$DobUpdated = 1;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$EndDateUpdated = 7;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Enrolled = 3;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$MembershipChanged = 6;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NewCompany = 8;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NewPatient = 2;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$NoAccountChange = 0;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PlanChanged = 9;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Restarted = 4;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$TerminatedByEndDate = 5;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue = function(action) {
        switch(action){
            case 0:
                return 'no_account_change';
            case 1:
                return 'dob_updated';
            case 2:
                return 'new_patient';
            case 3:
                return 'enrolled';
            case 4:
                return 'restarted';
            case 5:
                return 'terminated_by_end_date';
            case 7:
                return 'end_date_updated';
            case 6:
                return 'membership_changed';
            case 8:
                return 'new_company';
            default:
                return 'plan_changed';
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionFromQuery = function(queryString) {
        return A2($elm_community$list_extra$List$Extra$find, function(status) {
            return _Utils_eq($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue(status), queryString);
        }, _List_fromArray([
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            6,
            8,
            9
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString = function(resultType) {
        switch(resultType){
            case 0:
                return 'failed';
            case 1:
                return 'warning';
            default:
                return 'processed';
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue = function(supress) {
        if (!supress) return 'supressed';
        else return 'not_supressed';
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$urlParams = function(model) {
        var queryParams = _List_fromArray([
            $elm$core$Maybe$Just(_Utils_Tuple2('resultType', $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString(model.YZ))),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue, $elm$core$Tuple$pair('upload_row_results_result_type')), model.hf),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue, $elm$core$Tuple$pair('supress_filter')), model.HI),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('q'), model.agq)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults({
                fl: model.fl,
                H_: model.H_
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), $author$project$Utils$QueryParameter$fromDict($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$urlParams(model)))));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotUploadRows = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFilter = function(resultType) {
        switch(resultType){
            case 0:
                return 0;
            case 1:
                return 1;
            default:
                return 2;
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRowsParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fw: $elm$core$Maybe$Just($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFilter(model.YZ)),
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs,
                HI: A2($elm$core$Maybe$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue, model.HI),
                H$: A2($elm$core$Maybe$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue, model.hf)
            });
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows = function(model) {
        return A5($author$project$Api$UploadRow$list, model.Ej, model.Z$, model.H_, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRowsParams(model), $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotUploadRows);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Failed = 0;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Warning = 1;
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFromString = function(string) {
        switch(string){
            case 'failed':
                return $elm$core$Maybe$Just(0);
            case 'warning':
                return $elm$core$Maybe$Just(1);
            case 'processed':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$init = F5(function(session, practice, company, _v0, _v1) {
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var params = _v1.VU;
        var query = _v1.Bz;
        var resultType = A2($elm$core$Maybe$withDefault, 2, A2($elm$core$Maybe$andThen, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeFromString, A2($elm$core$Dict$get, 'resultType', query)));
        var q = A2($elm$core$Dict$get, 'q', query);
        var exportCsv = $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$ExportCsv$init({
            adW: false,
            Hg: 18
        }));
        var _v2 = function() {
            switch(resultType){
                case 0:
                    return _Utils_Tuple2($elm$core$Maybe$Just(function(supressQuery) {
                        if (!supressQuery.$ && supressQuery.a === 'supressed') return 0;
                        else return 1;
                    }(A2($elm$core$Dict$get, 'supress_filter', query))), $elm$core$Maybe$Nothing);
                case 1:
                    return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
                default:
                    return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($elm$core$Maybe$andThen, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionFromQuery, A2($elm$core$Dict$get, 'upload_row_results_result_type', query)));
            }
        }();
        var supressFilter = _v2.a;
        var uploadRowResultsResultType = _v2.b;
        var model = {
            Ej: apiClient,
            acy: company,
            fl: params.fl,
            md: exportCsv,
            iJ: $author$project$Api$Data$Loading,
            aeb: hinterViewOff,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            agq: q,
            jK: $elm$core$Maybe$Nothing,
            YZ: resultType,
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'row_number', 0, $author$project$Api$Sort$initFromQuery(query)),
            HI: supressFilter,
            oH: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'supress-filter-dropdown-filter',
                ahX: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressFilterDropdownMsg
            })),
            bm: $elm$core$Set$empty,
            H_: params.H_,
            o6: $elm$core$Maybe$Nothing,
            hf: uploadRowResultsResultType,
            o7: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'upload-row-results-result-type-dropdown-filter',
                ahX: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UploadRowResultsActionDropdownMsg
            })),
            tC: $author$project$Api$Data$Loading
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A4($author$project$Api$FeedEnroller$retrieve, apiClient, session, params.fl, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$GotFeedEnroller),
            A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model),
            $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(model)
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed = {
        $: 11
    };
    var $author$project$Components$Upload$RowDescriptionDetailsModal$subscribeToEscapeKeyPress = function(onClose) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
    };
    var $author$project$Components$Upload$RawRowModal$Close = {
        $: 2
    };
    var $author$project$Components$Upload$RawRowModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Upload$RawRowModal$Close);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$ExportCsv$subscriptions, model.md))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Upload$RawRowModal$subscriptions, model.jK))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Upload$RowDescriptionDetailsModal$subscribeToEscapeKeyPress($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed)), model.o6)),
            $author$project$Ui$Dropdown$subscriptions(model.o7),
            $author$project$Ui$Dropdown$subscriptions(model.oH)
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated = F3(function(a, b, c) {
        return {
            $: 17,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Employer$UploadRow$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Employer$UploadRow$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$UploadRow$Shared$id(shared);
    };
    var $author$project$Api$Provider$UploadRow$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$UploadRow$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$UploadRow$Shared$id(shared);
    };
    var $author$project$Api$UploadRow$All$id = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$All$id(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$All$id(uploadRow_);
        }
    };
    var $author$project$Components$Upload$RawRowModal$GotUploadRow = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$UploadRow$One$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$UploadRow$One$fromEmployer = $author$project$Api$UploadRow$One$Employer;
    var $author$project$Api$UploadRow$One$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$UploadRow$One$fromProvider = $author$project$Api$UploadRow$One$Provider;
    var $author$project$Api$Employer$UploadRow$One$UploadRow = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Employer$UploadRow$One$Record = function(rowsInMyGroup) {
        return {
            Ze: rowsInMyGroup
        };
    };
    var $author$project$Api$Employer$UploadRow$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows_in_my_group', $elm$json$Json$Decode$list($author$project$Api$Employer$UploadRow$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$One$Record));
    var $author$project$Api$Employer$UploadRow$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$UploadRow$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$UploadRow$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Employer$UploadRow$One$UploadRow)));
    var $author$project$Api$Employer$UploadRow$uploadRowPath = F2(function(uploadId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Employer$UploadRow$uploadRowsPath(uploadId));
    });
    var $author$project$Api$Employer$UploadRow$retrieve = F4(function(apiClient, uploadId, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$UploadRow$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id_)));
    });
    var $author$project$Api$Provider$UploadRow$One$UploadRow = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$UploadRow$One$Record = function(rowsInMyGroup) {
        return {
            Ze: rowsInMyGroup
        };
    };
    var $author$project$Api$Provider$UploadRow$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rows_in_my_group', $elm$json$Json$Decode$list($author$project$Api$Provider$UploadRow$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$One$Record));
    var $author$project$Api$Provider$UploadRow$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadRow$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$UploadRow$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$UploadRow$One$UploadRow)));
    var $author$project$Api$Provider$UploadRow$uploadRowPath = F2(function(uploadId, id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$UploadRow$uploadRowsPath(uploadId));
    });
    var $author$project$Api$Provider$UploadRow$retrieve = F4(function(apiClient, uploadId, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$UploadRow$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id_)));
    });
    var $author$project$Api$UploadRow$retrieve = F5(function(apiClient, session, uploadId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$UploadRow$retrieve, apiClient, uploadId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4($author$project$Api$Provider$UploadRow$retrieve, apiClient, uploadId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
    });
    var $author$project$Components$Upload$RawRowModal$init = F4(function(apiClient, session, uploadId, uploadRowId) {
        return _Utils_Tuple2({
            kb: false,
            tB: $author$project$Api$Data$Loading
        }, A5($author$project$Api$UploadRow$retrieve, apiClient, session, uploadId, uploadRowId, $author$project$Components$Upload$RawRowModal$GotUploadRow));
    });
    var $author$project$Api$Employer$UploadRow$supress = F4(function(apiClient, uploadId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$UploadRow$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'supress'
        ]), A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
    });
    var $author$project$Api$Provider$UploadRow$supress = F4(function(apiClient, uploadId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$UploadRow$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'supress'
        ]), A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
    });
    var $author$project$Api$UploadRow$supress = F5(function(apiClient, session, uploadId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$UploadRow$supress, apiClient, uploadId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4($author$project$Api$Provider$UploadRow$supress, apiClient, uploadId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
    });
    var $author$project$Api$Employer$UploadRow$unsupress = F4(function(apiClient, uploadId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Employer$UploadRow$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unsupress'
        ]), A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
    });
    var $author$project$Api$Provider$UploadRow$unsupress = F4(function(apiClient, uploadId, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$UploadRow$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unsupress'
        ]), A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
    });
    var $author$project$Api$UploadRow$unsupress = F5(function(apiClient, session, uploadId, id, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A4($author$project$Api$Employer$UploadRow$unsupress, apiClient, uploadId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A4($author$project$Api$Provider$UploadRow$unsupress, apiClient, uploadId, id, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
    });
    var $author$project$Components$Upload$RawRowModal$Closed = 1;
    var $author$project$Components$Upload$RawRowModal$None = 0;
    var $author$project$Components$Upload$RawRowModal$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    tB: response
                }), $author$project$OutMsg$handleErrorResponse(response), 0);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    kb: !model.kb
                }), _List_Nil, 0);
            default:
                return _Utils_Tuple3(model, _List_Nil, 1);
        }
    });
    var $author$project$Api$Employer$UploadRow$updateReviewed = F5(function(apiClient, uploadId, id, reviewed, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('reviewed', $elm$json$Json$Encode$bool(reviewed))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Employer$UploadRow$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Employer$UploadRow$uploadRowPath, uploadId, id))));
    });
    var $author$project$Api$Provider$UploadRow$updateReviewed = F5(function(apiClient, uploadId, id, reviewed, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('reviewed', $elm$json$Json$Encode$bool(reviewed))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$UploadRow$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$UploadRow$uploadRowPath, uploadId, id))));
    });
    var $author$project$Api$UploadRow$updateReviewed = F6(function(apiClient, session, uploadId, id, reviewed, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A5($author$project$Api$Employer$UploadRow$updateReviewed, apiClient, uploadId, id, reviewed, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$UploadRow$One$fromEmployer))) : A5($author$project$Api$Provider$UploadRow$updateReviewed, apiClient, uploadId, id, reviewed, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$UploadRow$One$fromProvider)));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    iJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        tC: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    tC: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var selectedOption = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    hf: selectedOption,
                    tC: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.o7);
                var dropdown = _v2.a;
                var dropdownCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    o7: dropdown
                }), dropdownCmd, _List_Nil);
            case 5:
                var selectedOption = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    HI: selectedOption,
                    tC: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.oH);
                var dropdown = _v3.a;
                var dropdownCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oH: dropdown
                }), dropdownCmd, _List_Nil);
            case 6:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v4.a;
                var searchInputCmd = _v4.b;
                var searchInputEvent = _v4.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v5 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q,
                            tC: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(qModel),
                            A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                        ])));
                    }
                }();
                var newModel = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 7:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs),
                    tC: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 8:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    tC: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v7 = model.md;
                if (!_v7.$) {
                    var exportCsv = _v7.a;
                    var _v8 = A3($author$project$Components$ExportCsv$update, model.Ej, subMsg, exportCsv);
                    var exportCsv_ = _v8.a;
                    var subCmd = _v8.b;
                    var subOutMsg = _v8.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        md: $elm$core$Maybe$Just(exportCsv_)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg, subCmd), subOutMsg);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var rowNumber = msg.a;
                var messages = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    o6: $elm$core$Maybe$Just(_Utils_Tuple2(rowNumber, messages))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                return _Utils_Tuple3(_Utils_update(model, {
                    o6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var uploadRow = msg.a;
                var _v9 = A4($author$project$Components$Upload$RawRowModal$init, model.Ej, model.Z$, model.H_, $author$project$Api$UploadRow$All$id(uploadRow));
                var rawRowModal = _v9.a;
                var rawRowModalCmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    jK: $elm$core$Maybe$Just(rawRowModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg, rawRowModalCmd), _List_Nil);
            case 13:
                var subMsg = msg.a;
                var _v10 = model.jK;
                if (!_v10.$) {
                    var rawRowModal = _v10.a;
                    var _v11 = A2($author$project$Components$Upload$RawRowModal$update, subMsg, rawRowModal);
                    var rawRowModal_ = _v11.a;
                    var subOutMsg = _v11.b;
                    var rawRowModalEvent = _v11.c;
                    var newRawRowModal = function() {
                        if (!rawRowModalEvent) return $elm$core$Maybe$Just(rawRowModal_);
                        else return $elm$core$Maybe$Nothing;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        jK: newRawRowModal
                    }), $elm$core$Platform$Cmd$none, subOutMsg);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var uploadRow = msg.a;
                var id = $author$project$Api$UploadRow$All$id(uploadRow);
                return _Utils_Tuple3(_Utils_update(model, {
                    bm: A2($elm$core$Set$insert, id, model.bm)
                }), A5($author$project$Api$UploadRow$unsupress, model.Ej, model.Z$, model.H_, id, A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'unmuted')), _List_Nil);
            case 15:
                var uploadRow = msg.a;
                var id = $author$project$Api$UploadRow$All$id(uploadRow);
                return _Utils_Tuple3(_Utils_update(model, {
                    bm: A2($elm$core$Set$insert, id, model.bm)
                }), A5($author$project$Api$UploadRow$supress, model.Ej, model.Z$, model.H_, id, A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'muted')), _List_Nil);
            case 16:
                var uploadRow = msg.a;
                var bool = msg.b;
                var id = $author$project$Api$UploadRow$All$id(uploadRow);
                return _Utils_Tuple3(_Utils_update(model, {
                    bm: A2($elm$core$Set$insert, id, model.bm)
                }), A6($author$project$Api$UploadRow$updateReviewed, model.Ej, model.Z$, model.H_, id, bool, A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$Updated, uploadRow, 'updated')), _List_Nil);
            default:
                var uploadRow = msg.a;
                var action = msg.b;
                var response = msg.c;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bm: A2($elm$core$Set$remove, $author$project$Api$UploadRow$All$id(uploadRow), model.bm),
                    tC: $author$project$Api$Data$Loading
                }), $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$fetchUploadRows(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Row #' + ($elm$core$String$fromInt($author$project$Api$UploadRow$All$rowNumber(uploadRow)) + (' was successfully ' + (action + '.'))))
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    bm: A2($elm$core$Set$remove, $author$project$Api$UploadRow$All$id(uploadRow), model.bm)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PaginationMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$exportUploadRowsParams = function(model) {
        var queryParams = _List_fromArray([
            $elm$core$Maybe$Just(A2($author$project$Api$Param$string, 'filter', $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToString(model.YZ))),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToValue, $author$project$Api$Param$string('upload_row_results_result_type')), model.hf),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToValue, $author$project$Api$Param$string('supress_filter')), model.HI),
            A2($elm$core$Maybe$map, $author$project$Api$Param$string('q'), model.agq)
        ]);
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToTitle = function(resultType) {
        switch(resultType){
            case 0:
                return 'Failed';
            case 1:
                return 'Warning';
            default:
                return 'Processed';
        }
    };
    var $author$project$Api$Employer$UploadRow$One$rowNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$UploadRow$Shared$rowNumber(shared);
    };
    var $author$project$Api$Provider$UploadRow$One$rowNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$UploadRow$Shared$rowNumber(shared);
    };
    var $author$project$Api$UploadRow$One$rowNumber = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$One$rowNumber(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$One$rowNumber(uploadRow_);
        }
    };
    var $author$project$Components$Upload$RawRowModal$ToggleRowsInGroup = {
        $: 1
    };
    var $author$project$Api$Employer$UploadRow$Shared$csvRow = function(_v0) {
        var record = _v0;
        return record.MH;
    };
    var $author$project$Api$Employer$UploadRow$One$csvRow = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$UploadRow$Shared$csvRow(shared);
    };
    var $author$project$Api$Provider$UploadRow$Shared$csvRow = function(_v0) {
        var record = _v0;
        return record.MH;
    };
    var $author$project$Api$Provider$UploadRow$One$csvRow = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$UploadRow$Shared$csvRow(shared);
    };
    var $author$project$Api$UploadRow$One$csvRow = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$One$csvRow(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$One$csvRow(uploadRow_);
        }
    };
    var $author$project$Api$UploadRow$Shared$rowNumber = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$Shared$rowNumber(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$Shared$rowNumber(uploadRow_);
        }
    };
    var $author$project$Api$UploadRow$Shared$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$UploadRow$Shared$fromEmployer = $author$project$Api$UploadRow$Shared$Employer;
    var $author$project$Api$UploadRow$Shared$Provider = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$UploadRow$Shared$fromProvider = $author$project$Api$UploadRow$Shared$Provider;
    var $author$project$Api$Employer$UploadRow$One$rowsInMyGroup = function(_v0) {
        var record = _v0.b;
        return record.Ze;
    };
    var $author$project$Api$Provider$UploadRow$One$rowsInMyGroup = function(_v0) {
        var record = _v0.b;
        return record.Ze;
    };
    var $author$project$Api$UploadRow$One$rowsInMyGroup = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return A2($elm$core$List$map, $author$project$Api$UploadRow$Shared$fromProvider, $author$project$Api$Provider$UploadRow$One$rowsInMyGroup(uploadRow_));
        } else {
            var uploadRow_ = uploadRow.a;
            return A2($elm$core$List$map, $author$project$Api$UploadRow$Shared$fromEmployer, $author$project$Api$Employer$UploadRow$One$rowsInMyGroup(uploadRow_));
        }
    };
    var $author$project$Api$UploadRow$Shared$csvRow = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$Shared$csvRow(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$Shared$csvRow(uploadRow_);
        }
    };
    var $author$project$Components$Upload$RawRowModal$viewCsvValue = function(value) {
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', value))
            ]))
        ]));
    };
    var $author$project$Components$Upload$RawRowModal$viewRowInGroupValue = F2(function(key, csv) {
        var value = A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Dict$get, key, csv));
        return $author$project$Components$Upload$RawRowModal$viewCsvValue(value);
    });
    var $author$project$Components$Upload$RawRowModal$viewCsvField = F3(function(showRowsInGroup, rowsInMyGroup, _v0) {
        var key = _v0.a;
        var value = _v0.b;
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(key)
                    ]))
                ])),
                $author$project$Components$Upload$RawRowModal$viewCsvValue(value)
            ]),
            showRowsInGroup ? A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Api$UploadRow$Shared$csvRow, $author$project$Components$Upload$RawRowModal$viewRowInGroupValue(key)), rowsInMyGroup) : _List_Nil
        ])));
    });
    var $author$project$Components$Upload$RawRowModal$viewRowNumber = function(rowNumber) {
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text($elm$core$String$fromInt(rowNumber))
        ]));
    };
    var $author$project$Components$Upload$RawRowModal$viewModalBody = F2(function(uploadRow, model) {
        var rowsInMyGroup = $author$project$Api$UploadRow$One$rowsInMyGroup(uploadRow);
        var rowsInMyGroupLength = $elm$core$List$length(rowsInMyGroup);
        var rowNumber = $author$project$Api$UploadRow$One$rowNumber(uploadRow);
        return _List_fromArray([
            rowsInMyGroupLength > 0 ? A2($author$project$Ui$Typography$p, _List_Nil, _Utils_ap(rowsInMyGroupLength === 1 ? _List_fromArray([
                $elm$html$Html$text('* There is one more row in this group. ')
            ]) : _List_fromArray([
                $elm$html$Html$text('* There are '),
                $elm$html$Html$text($elm$core$String$fromInt(rowsInMyGroupLength)),
                $elm$html$Html$text(' more rows in this group. ')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Toggle rows visibility'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Components$Upload$RawRowModal$ToggleRowsInGroup)
                ]), _List_fromArray([
                    model.kb ? $elm$html$Html$text('Hide') : $elm$html$Html$text('Show'),
                    $elm$html$Html$text(' Rows')
                ]))
            ]))) : $author$project$Utils$Html$empty,
            A4($author$project$Ui$Table$view, _List_Nil, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Row #')
                        ]))
                    ])),
                    $author$project$Components$Upload$RawRowModal$viewRowNumber(rowNumber)
                ]),
                model.kb ? A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Api$UploadRow$Shared$rowNumber, $author$project$Components$Upload$RawRowModal$viewRowNumber), rowsInMyGroup) : _List_Nil
            ]))), A2($elm$core$List$map, A2($author$project$Components$Upload$RawRowModal$viewCsvField, model.kb, rowsInMyGroup), $elm$core$Dict$toList($author$project$Api$UploadRow$One$csvRow(uploadRow)))), _List_Nil)
        ]);
    });
    var $author$project$Components$Upload$RawRowModal$view = function(model) {
        var rowNumber = A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, A2($elm$core$Maybe$map, $author$project$Api$UploadRow$One$rowNumber, $author$project$Api$Data$toMaybe(model.tB))));
        return A3($author$project$Ui$Modal$view, $author$project$Components$Upload$RawRowModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Raw CSV Row #' + rowNumber)
            ])),
            $author$project$Ui$Modal$body(function() {
                var _v0 = model.tB;
                if (_v0.$ === 3) {
                    var uploadRow = _v0.a;
                    return A2($author$project$Components$Upload$RawRowModal$viewModalBody, uploadRow, model);
                } else return _List_fromArray([
                    $author$project$Ui$Spinner$view(_List_Nil)
                ]);
            }()),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Upload$RawRowModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Upload$RowDescriptionDetailsModal$viewWarning = function(warning) {
        return A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
            $elm$html$Html$text(warning)
        ]));
    };
    var $author$project$Components$Upload$RowDescriptionDetailsModal$view = F3(function(title, warnings, onClose) {
        return A3($author$project$Ui$Modal$view, onClose, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(title)
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, $author$project$Components$Upload$RowDescriptionDetailsModal$viewWarning, warnings))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick(onClose)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressSelected = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel = function(supress) {
        if (supress.$ === 1) return 'All Rows';
        else if (!supress.a) {
            var _v1 = supress.a;
            return 'Muted rows';
        } else {
            var _v2 = supress.a;
            return 'Umuted rows';
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressFilterDropdownOptions = function(currentSupress) {
        var supressToItem = function(supress) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressSelected(supress)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentSupress, supress))
            ]), $elm$html$Html$text($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel(supress)));
        };
        return _List_fromArray([
            supressToItem($elm$core$Maybe$Nothing),
            $author$project$Ui$Dropdown$separator,
            supressToItem($elm$core$Maybe$Just(0)),
            supressToItem($elm$core$Maybe$Just(1))
        ]);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewSupressFilterDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressToLabel(model.HI))
        ]), $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$supressFilterDropdownOptions(model.HI), model.oH);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SortTable = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow = function(resultType) {
        return !resultType;
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$columns = function(resultType) {
        var reviewedColumn = A3($author$project$Api$Column$init, 'reviewed', false, 'Reviewed');
        var messagesColumnId = $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow(resultType) ? 'upload_row_results_error_code' : 'upload_row_results_message';
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'row_number', true, 'Row #'),
                A3($author$project$Api$Column$init, 'patient_ident', false, 'Platform Patient'),
                A3($author$project$Api$Column$init, 'external_id', false, 'External ID'),
                A3($author$project$Api$Column$init, 'first_name', false, 'First Name'),
                A3($author$project$Api$Column$init, 'last_name', false, 'Last Name'),
                A3($author$project$Api$Column$init, 'current_dob', false, 'Dob')
            ]),
            function() {
                switch(resultType){
                    case 0:
                        return _List_Nil;
                    case 1:
                        return _List_Nil;
                    default:
                        return _List_fromArray([
                            A3($author$project$Api$Column$init, 'actions', false, 'Processing Result')
                        ]);
                }
            }(),
            _List_fromArray([
                A3($author$project$Api$Column$init, messagesColumnId, false, 'Processing Desc.')
            ]),
            function() {
                switch(resultType){
                    case 0:
                        return _List_fromArray([
                            A3($author$project$Api$Column$init, 'supress_status', false, 'Status')
                        ]);
                    case 1:
                        return _List_Nil;
                    default:
                        return _List_Nil;
                }
            }(),
            function() {
                switch(resultType){
                    case 0:
                        return _List_fromArray([
                            reviewedColumn
                        ]);
                    case 1:
                        return _List_fromArray([
                            reviewedColumn
                        ]);
                    default:
                        return _List_Nil;
                }
            }(),
            _List_fromArray([
                A3($author$project$Api$Column$init, 'controls', false, 'Actions')
            ])
        ]));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressRow = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UnsupressRow = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UpdateRowReviewed = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRawRow = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRowMessages = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$UploadRowResult$Data$currentDob = function(_v0) {
        var record = _v0;
        return record.ML;
    };
    var $author$project$Api$Common$UploadRowResult$Data$externalId = function(_v0) {
        var record = _v0;
        return record.adE;
    };
    var $author$project$Api$Common$UploadRowResult$Data$firstName = function(_v0) {
        var record = _v0;
        return record.PN;
    };
    var $author$project$Api$Employer$UploadRow$Shared$isSupressed = function(_v0) {
        var record = _v0;
        return record.St;
    };
    var $author$project$Api$Employer$UploadRow$All$isSupressed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$UploadRow$Shared$isSupressed(shared);
    };
    var $author$project$Api$Provider$UploadRow$Shared$isSupressed = function(_v0) {
        var record = _v0;
        return record.St;
    };
    var $author$project$Api$Provider$UploadRow$All$isSupressed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$UploadRow$Shared$isSupressed(shared);
    };
    var $author$project$Api$UploadRow$All$isSupressed = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$All$isSupressed(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$All$isSupressed(uploadRow_);
        }
    };
    var $author$project$Api$Common$UploadRowResult$Data$lastName = function(_v0) {
        var record = _v0;
        return record.SU;
    };
    var $author$project$Api$Common$UploadRowResult$Data$patientIdent = function(_v0) {
        var record = _v0;
        return record.V9;
    };
    var $author$project$Ui$Element$Phi = {
        $: 16
    };
    var $author$project$Ui$Element$phi = $author$project$Ui$Element$Phi;
    var $author$project$Api$Employer$UploadRow$All$resultData = function(_v0) {
        var record = _v0.b;
        return record.YY;
    };
    var $author$project$Api$Provider$UploadRow$All$resultData = function(_v0) {
        var record = _v0.b;
        return record.YY;
    };
    var $author$project$Api$UploadRow$All$resultData = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$All$resultData(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$All$resultData(uploadRow_);
        }
    };
    var $author$project$Api$Employer$UploadRow$Shared$reviewed = function(_v0) {
        var record = _v0;
        return record.Y6;
    };
    var $author$project$Api$Employer$UploadRow$All$reviewed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$UploadRow$Shared$reviewed(shared);
    };
    var $author$project$Api$Provider$UploadRow$Shared$reviewed = function(_v0) {
        var record = _v0;
        return record.Y6;
    };
    var $author$project$Api$Provider$UploadRow$All$reviewed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$UploadRow$Shared$reviewed(shared);
    };
    var $author$project$Api$UploadRow$All$reviewed = function(uploadRow) {
        if (!uploadRow.$) {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Provider$UploadRow$All$reviewed(uploadRow_);
        } else {
            var uploadRow_ = uploadRow.a;
            return $author$project$Api$Employer$UploadRow$All$reviewed(uploadRow_);
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowMessages = function(uploadRowResults) {
        return $elm_community$list_extra$List$Extra$unique($elm$core$List$concat(A2($elm$core$List$filterMap, function(uploadRowResult) {
            return A2($elm$core$Maybe$map, $elm$core$String$split('|'), $author$project$Api$UploadRowResult$Shared$message(uploadRowResult));
        }, uploadRowResults)));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewRow = F2(function(model, uploadRow) {
        var uploadRowResults = A2($elm$core$List$filterMap, function(uploadRowResult) {
            return A2($elm$core$Maybe$andThen, function(resultType) {
                var _v7 = model.YZ;
                switch(_v7){
                    case 1:
                        return A2($elm$core$List$member, resultType, _List_fromArray([
                            'warning',
                            'duplicate_ignored'
                        ])) ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
                    case 0:
                        return resultType === 'error' ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
                    default:
                        return resultType !== 'warning' ? $elm$core$Maybe$Just(uploadRowResult) : $elm$core$Maybe$Nothing;
                }
            }, $author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
        }, $author$project$Api$UploadRow$All$uploadRowResults(uploadRow));
        var uploadRowResultData = $author$project$Api$UploadRow$All$resultData(uploadRow);
        var rowNumber = $author$project$Api$UploadRow$All$rowNumber(uploadRow);
        var patientIdent = A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$patientIdent, uploadRowResultData);
        var messages = $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowMessages(uploadRowResults);
        var loading = A2($elm$core$Set$member, $author$project$Api$UploadRow$All$id(uploadRow), model.bm);
        var reviewedColumn = A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value($author$project$Api$UploadRow$All$reviewed(uploadRow)),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UpdateRowReviewed(uploadRow)),
                $author$project$Ui$Form$Checkbox$loading(loading)
            ]), _List_Nil)
        ]));
        var canGoToPatients = A3($author$project$Permission$canGoTo, model.Z$, model.aeb, 44);
        var blank = A2($author$project$Ui$Typography$em, _List_fromArray([
            $author$project$Ui$Typography$muted
        ]), _List_fromArray([
            $elm$html$Html$text('Blank')
        ]));
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(rowNumber))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = _Utils_Tuple2(patientIdent, canGoToPatients);
                        if (!_v0.a.$) {
                            if (_v0.b) {
                                var patientIdent_ = _v0.a.a;
                                return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: patientIdent_
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(patientIdent_)
                                ]));
                            } else {
                                var patientIdent_ = _v0.a.a;
                                return $elm$html$Html$text(patientIdent_);
                            }
                        } else {
                            var _v1 = _v0.a;
                            return blank;
                        }
                    }()
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$phi
                    ]), _List_fromArray([
                        A2($elm$core$Maybe$withDefault, blank, A2($elm$core$Maybe$map, $elm$html$Html$text, A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$externalId, uploadRowResultData)))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$phi
                    ]), _List_fromArray([
                        A2($elm$core$Maybe$withDefault, blank, A2($elm$core$Maybe$map, $elm$html$Html$text, A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$firstName, uploadRowResultData)))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$phi
                    ]), _List_fromArray([
                        A2($elm$core$Maybe$withDefault, blank, A2($elm$core$Maybe$map, $elm$html$Html$text, A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$lastName, uploadRowResultData)))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$phi
                    ]), _List_fromArray([
                        A2($elm$core$Maybe$withDefault, blank, A2($elm$core$Maybe$map, $elm$html$Html$text, A2($elm$core$Maybe$andThen, $author$project$Api$Common$UploadRowResult$Data$currentDob, uploadRowResultData)))
                    ]))
                ]))
            ]),
            function() {
                var _v2 = model.YZ;
                switch(_v2){
                    case 0:
                        return _List_Nil;
                    case 1:
                        return _List_Nil;
                    default:
                        var results = A2($elm$core$List$map, A2($elm$core$Basics$composeR, $author$project$Formatters$String$humanize, $author$project$Formatters$String$titleize), $elm_community$list_extra$List$Extra$unique(A2($elm$core$List$filterMap, function(uploadRowResult) {
                            return A2($elm$core$Maybe$andThen, function(resultType) {
                                var _v3 = model.YZ;
                                switch(_v3){
                                    case 1:
                                        return A2($elm$core$List$member, resultType, _List_fromArray([
                                            'warning',
                                            'duplicate_ignored'
                                        ])) ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
                                    case 0:
                                        return resultType === 'error' ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
                                    default:
                                        return resultType !== 'warning' ? $elm$core$Maybe$Just(resultType) : $elm$core$Maybe$Nothing;
                                }
                            }, $author$project$Api$UploadRowResult$Shared$resultType(uploadRowResult));
                        }, uploadRowResults)));
                        var resultsString = $elm$core$List$isEmpty(results) ? 'No Account Change' : A2($elm$core$String$join, ' - ', results);
                        return _List_fromArray([
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(resultsString)
                                ]))
                            ]))
                        ]);
                }
            }(),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), $elm$core$List$length(messages) > 1 ? _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 100, A2($elm$core$String$join, ', ', messages))),
                        $author$project$Utils$Html$noBreakSpace,
                        A3($author$project$Ui$Button$view, {
                            abP: 'View all row messages'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick(A2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRowMessages, rowNumber, messages))
                        ]), _List_fromArray([
                            $elm$html$Html$text('View all >')
                        ]))
                    ]) : _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$String$join, ', ', messages))
                    ]))
                ]))
            ]),
            function() {
                var _v4 = model.YZ;
                switch(_v4){
                    case 0:
                        return _List_fromArray([
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                                $author$project$Api$UploadRow$All$isSupressed(uploadRow) ? $elm$html$Html$text('Muted') : $elm$html$Html$text('Unmuted')
                            ]))
                        ]);
                    case 1:
                        return _List_Nil;
                    default:
                        return _List_Nil;
                }
            }(),
            function() {
                var _v5 = model.YZ;
                switch(_v5){
                    case 0:
                        return _List_fromArray([
                            reviewedColumn
                        ]);
                    case 1:
                        return _List_fromArray([
                            reviewedColumn
                        ]);
                    default:
                        return _List_Nil;
                }
            }(),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(2)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'View raw row details'
                    }, _List_fromArray([
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ViewRawRow(uploadRow))
                    ]), _List_fromArray([
                        $elm$html$Html$text('CSV Data')
                    ])),
                    $author$project$Utils$Html$noBreakSpace,
                    function() {
                        var _v6 = _Utils_Tuple2($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$isFailedRow(model.YZ), $author$project$Api$UploadRow$All$isSupressed(uploadRow));
                        if (_v6.a) {
                            if (_v6.b) return A3($author$project$Ui$Button$view, {
                                abP: 'Unmute'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$UnsupressRow(uploadRow)),
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Unmute')
                            ]));
                            else return A3($author$project$Ui$Button$view, {
                                abP: 'Mute'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SupressRow(uploadRow)),
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Mute')
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])
        ])));
    });
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.tC;
            if (_v1.$ === 3) {
                var uploadRows_ = _v1.a;
                return _Utils_Tuple2(false, uploadRows_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var uploadRows = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the filters selected.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SortTable)), $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$columns(model.YZ)),
            $author$project$Utils$Maybe$toBool(model.md) ? _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$textRight
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                ]))
            ]) : _List_Nil
        ])), A2($elm$core$List$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewRow(model), uploadRows), _List_Nil);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel = function(maybeAction) {
        if (maybeAction.$ === 1) return 'All Actions';
        else {
            var action = maybeAction.a;
            switch(action){
                case 0:
                    return 'No Account Change';
                case 1:
                    return 'Dob Updated';
                case 2:
                    return 'New Patient';
                case 3:
                    return 'Enrolled';
                case 4:
                    return 'Restarted';
                case 5:
                    return 'Terminated by End Date';
                case 7:
                    return 'End Date Updated';
                case 6:
                    return 'Membership Changed';
                case 8:
                    return 'New Company';
                default:
                    return 'Plan Changed';
            }
        }
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ResultActionSelected = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowResultsResultTypeDropdownOptions = function(currentType) {
        var actionToItem = function(action) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ResultActionSelected(action)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentType, action))
            ]), $elm$html$Html$text($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel(action)));
        };
        return A2($elm$core$List$cons, actionToItem($elm$core$Maybe$Nothing), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, actionToItem), _List_fromArray([
            0,
            1,
            2,
            3,
            4,
            5,
            7,
            6,
            8,
            9
        ]))));
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewUploadRowResultsResultTypeDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$actionToLabel(model.hf))
        ]), $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$uploadRowResultsResultTypeDropdownOptions(model.hf), model.o7);
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.o6;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var rowNumber = _v1.a;
                        var messages = _v1.b;
                        var title = 'Row #' + ($elm$core$String$fromInt(rowNumber) + ' Processing Description');
                        return A3($author$project$Components$Upload$RowDescriptionDetailsModal$view, title, messages, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RowMessagesModalClosed);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.jK;
                    if (!_v2.$) {
                        var rawRowModal = _v2.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$RawRowModalMsg, $author$project$Components$Upload$RawRowModal$view(rawRowModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v3 = model.md;
                    if (!_v3.$) {
                        var exportCsv = _v3.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, model.Ej, _List_fromArray([
                            $author$project$Components$ExportCsv$params($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$exportUploadRowsParams(model)),
                            $author$project$Components$ExportCsv$path($author$project$Api$Provider$UploadRow$uploadRowsPath(model.H_))
                        ]), exportCsv));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A6($author$project$Layouts$Company$Uploads$view, model.Z$, model.W1, model.acy, model.iJ, _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top({
                                        fl: model.fl
                                    }), _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Uploads')
                                    ]))
                                ])),
                                A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top({
                                        fl: model.fl,
                                        H_: model.H_
                                    }), _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(model.H_)
                                    ]))
                                ])),
                                A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                                    $author$project$Ui$Breadcrumb$active(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text($author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$resultTypeToTitle(model.YZ))
                                ]))
                            ]))),
                            $author$project$Ui$HorizontalRule$view(_List_Nil),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$offset(6),
                                    $author$project$Ui$Grid$span(6),
                                    $author$project$Ui$Grid$spanSm(3),
                                    $author$project$Ui$Grid$offsetSm(9)
                                ]), _List_fromArray([
                                    function() {
                                        var _v4 = model.YZ;
                                        switch(_v4){
                                            case 0:
                                                return $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewSupressFilterDropdown(model);
                                            case 1:
                                                return $author$project$Utils$Html$empty;
                                            default:
                                                return $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewUploadRowResultsResultTypeDropdown(model);
                                        }
                                    }()
                                ]))
                            ])),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            A2($author$project$Ui$Grid$row, _List_fromArray([
                                $author$project$Ui$Grid$mb2
                            ]), _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$span(12)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                        A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                                            $author$project$Ui$SearchInput$placeholder('Search by first or last name')
                                        ]), model.sG))
                                    ]))
                                ]))
                            ])),
                            $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$viewTable(model)
                        ]))
                    ]))
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.tC)))
                    ]), model.af_))
                ]))
            ]),
            $2: A2($author$project$Api$Practice$sponsorize, model.W1, 'Companies') + ' | Employee Uploads'
        };
    };
    var $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$page = $author$project$Spa$Page$applicationCompanyOrEmployer({
        aeq: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$init,
        aeR: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$load,
        ag3: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$save,
        ahE: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$subscriptions,
        aaO: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$update,
        aid: $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$view
    });
    var $author$project$Pages$Companies$New$GotPracticeCompanyInvoiceSetting = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$New$LocationResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$New$PlanResourceFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$New$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var currentDate = _v0.cP;
        var practiceCompanyInvoiceSettingId = $author$project$Api$Provider$CompanyInvoiceSetting$Shared$id($author$project$Api$Provider$Practice$One$companyInvoiceSetting(practice));
        var _v2 = A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                A8: _List_fromArray([
                    0,
                    1,
                    3
                ])
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Plan'
            });
        });
        var planResourceFilter = _v2.a;
        var planResourceFilterCmd = _v2.b;
        var _v3 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'All Locations'
            });
        });
        var locationResourceFilter = _v3.a;
        var locationResourceFilterCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            Eu: false,
            acy: $author$project$Api$Data$NotAsked,
            a_: $elm$core$Maybe$Nothing,
            cP: currentDate,
            ro: locationResourceFilter,
            jy: planResourceFilter,
            W1: practice,
            B6: $author$project$Api$Provider$Practice$One$requiresDefaultLocationForCompanies(practice)
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$retrieve, apiClient, practiceCompanyInvoiceSettingId, $author$project$Pages$Companies$New$GotPracticeCompanyInvoiceSetting),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$PlanResourceFilterMsg, planResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$LocationResourceFilterMsg, locationResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$Companies$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Companies$New$DefaultLocation = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$New$DefaultPlan = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$New$companyFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    Nz: string
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    Nr: string
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    Kg: $elm$core$Maybe$Just(string)
                });
        }
    });
    var $author$project$Pages$Companies$New$DefaultPlanValidation = 1;
    var $author$project$Pages$Companies$New$NameValidation = 0;
    var $author$project$Pages$Companies$New$DefaultLocationValidation = 2;
    var $author$project$Pages$Companies$New$validateDefaultLocation = F2(function(requireDefaultLocationForCompanies, form) {
        var _v0 = _Utils_Tuple2(requireDefaultLocationForCompanies, form.Nr);
        if (_v0.a && _v0.b.$ === 1) {
            var _v1 = _v0.b;
            return _List_fromArray([
                _Utils_Tuple2(2, 'Please select a location.')
            ]);
        } else return _List_Nil;
    });
    var $author$project$Pages$Companies$New$companyFormFieldsValidator = function(requireDefaultLocationForCompanies) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.zr;
            }, _Utils_Tuple2(0, 'Please enter a company name.')),
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.Nz;
            }, _Utils_Tuple2(1, 'Please select a plan.')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Companies$New$validateDefaultLocation(requireDefaultLocationForCompanies))
        ]));
    };
    var $author$project$Pages$Companies$New$GotCompany = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('company', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                    _Utils_Tuple2('default_plan', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('id', $elm$json$Json$Encode$string(fields.NA))
                    ]))),
                    _Utils_Tuple2('billing_start_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Kg))
                ]),
                function() {
                    var _v0 = fields.Ns;
                    if (!_v0.$) {
                        var string = _v0.a;
                        return _List_fromArray([
                            _Utils_Tuple2('default_location', $elm$json$Json$Encode$object(_List_fromArray([
                                _Utils_Tuple2('id', $elm$json$Json$Encode$string(string))
                            ])))
                        ]);
                    } else return _List_Nil;
                }()
            ]))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Company$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Company$companiesPath)));
    });
    var $author$project$Pages$Companies$New$createCompany = F3(function(practice, apiClient, companyFormFields) {
        var validFields = $rtfeldman$elm_validate$Validate$fromValid(companyFormFields);
        var defaultPlanId = validFields.Nz;
        var defaultLocationId = validFields.Nr;
        var billingStartDate = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, practice) ? A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm$core$Result$toMaybe), validFields.Kg) : $elm$core$Maybe$Nothing;
        return A3($author$project$Api$Provider$Company$create, apiClient, {
            Kg: billingStartDate,
            Ns: defaultLocationId,
            NA: defaultPlanId,
            zr: validFields.zr
        }, $author$project$Pages$Companies$New$GotCompany);
    });
    var $author$project$Pages$Companies$New$initCompanyFormFields = function(billingStartDate) {
        return {
            Kg: billingStartDate,
            Nr: $elm$core$Maybe$Nothing,
            Nz: '',
            zr: ''
        };
    };
    var $author$project$Pages$Companies$New$createCompanyForm = F2(function(billingEnabled, billingStartDate) {
        var billingStartDateDefaultSelectedValue = billingEnabled ? $author$project$Utils$Date$toIsoString(billingStartDate) : '';
        return $author$project$Utils$Form$init($author$project$Pages$Companies$New$initCompanyFormFields($author$project$Utils$String$toMaybe(billingStartDateDefaultSelectedValue)));
    });
    var $author$project$Pages$Companies$New$viewBillingStartDateOptions = function(currentDate) {
        var billingStartDate = $author$project$Utils$Date$toBeginningOfMonth(currentDate);
        return _Utils_Tuple2(billingStartDate, $author$project$Ui$Form$Select$dateOptions($author$project$Utils$Date$nextTwelveMonths(billingStartDate)));
    };
    var $author$project$Pages$Companies$New$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                var _v1 = model.a_;
                if (!_v1.$) {
                    var newCompanyForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        a_: $elm$core$Maybe$Just(A3($author$project$Utils$Form$update, $author$project$Pages$Companies$New$companyFormFieldsUpdate, field, newCompanyForm))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v2 = model.a_;
                if (!_v2.$) {
                    var newCompanyForm = _v2.a;
                    var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.Ej, subMsg, model.jy);
                    var modelAfterEvent = function() {
                        var _v3 = planResourceResult.adu;
                        if (!_v3.$) {
                            if (!_v3.a.$) return _Utils_update(model, {
                                a_: $elm$core$Maybe$Just(A3($author$project$Utils$Form$update, $author$project$Pages$Companies$New$companyFormFieldsUpdate, $author$project$Pages$Companies$New$DefaultPlan(A2($elm$core$Maybe$withDefault, '', $author$project$Components$ResourceFilter$Plan$value(planResourceResult.zi))), newCompanyForm))
                            });
                            else {
                                var _v4 = _v3.a;
                                return model;
                            }
                        } else return model;
                    }();
                    return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
                        jy: planResourceResult.zi
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$PlanResourceFilterMsg, planResourceResult.EQ), planResourceResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v5 = model.a_;
                if (!_v5.$) {
                    var newCompanyForm = _v5.a;
                    var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, model.Ej, subMsg, model.ro);
                    var modelAfterEvent = function() {
                        var _v6 = locationResourceResult.adu;
                        if (!_v6.$) {
                            if (!_v6.a.$) return _Utils_update(model, {
                                a_: $elm$core$Maybe$Just(A3($author$project$Utils$Form$update, $author$project$Pages$Companies$New$companyFormFieldsUpdate, $author$project$Pages$Companies$New$DefaultLocation($author$project$Components$ResourceFilter$Location$value(locationResourceResult.zi)), newCompanyForm))
                            });
                            else {
                                var _v7 = _v6.a;
                                return model;
                            }
                        } else return model;
                    }();
                    return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
                        ro: locationResourceResult.zi
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$New$LocationResourceFilterMsg, locationResourceResult.EQ), locationResourceResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v8 = model.a_;
                if (!_v8.$) {
                    var newCompanyForm = _v8.a;
                    var _v9 = A2($author$project$Utils$Form$validate, $author$project$Pages$Companies$New$companyFormFieldsValidator(model.B6), newCompanyForm);
                    if (!_v9.$) {
                        var _v10 = _v9.a;
                        var newForm = _v10.a;
                        var validFormFields = _v10.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            acy: $author$project$Api$Data$Loading,
                            a_: $elm$core$Maybe$Just(newForm)
                        }), A3($author$project$Pages$Companies$New$createCompany, model.W1, model.Ej, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v9.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            a_: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var company = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        acy: response
                    }), $author$project$Ports$Navigation$pushUrl('/companies/' + $author$project$Api$Provider$Company$One$id(company)), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Company$One$name(company) + ' created')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    acy: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var practiceSettings = response.a;
                    var billingEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 7, model.W1) ? $author$project$Api$Provider$CompanyInvoiceSetting$ForPractice$billingEnabled(practiceSettings) : false;
                    var _v13 = $author$project$Pages$Companies$New$viewBillingStartDateOptions(model.cP);
                    var billingStartDate = _v13.a;
                    var newForm = A2($author$project$Pages$Companies$New$createCompanyForm, billingEnabled, billingStartDate);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Eu: billingEnabled,
                        a_: $elm$core$Maybe$Just(newForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Companies$New$CreateCompany = {
        $: 3
    };
    var $author$project$Pages$Companies$New$BillingStartDate = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Companies$New$CompanyFormFieldUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Companies$New$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$notRetailPlansCount = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.U6;
    });
    var $author$project$Pages$Companies$New$viewPanelBody = function(model) {
        var _v0 = model.a_;
        if (!_v0.$) {
            var newCompanyForm = _v0.a;
            if ($author$project$Api$Provider$Practice$One$notRetailPlansCount(model.W1) > 0) {
                var _v1 = $author$project$Utils$Form$fields(newCompanyForm);
                var name = _v1.zr;
                var _v2 = $author$project$Pages$Companies$New$viewBillingStartDateOptions(model.cP);
                var billingStartDate = _v2.a;
                var billingStartDateOptions = _v2.b;
                return $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Name the ' + A2($author$project$Formatters$String$sponsorize, model.W1, 'Employer')),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$autofocus(true),
                                $author$project$Ui$Form$Input$value(name),
                                $author$project$Ui$Form$Input$placeholder('New ' + (A2($author$project$Formatters$String$sponsorize, model.W1, 'Employer') + ' Name')),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$New$CompanyFormFieldUpdated, $author$project$Pages$Companies$New$Name)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, newCompanyForm)),
                                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, newCompanyForm))
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Default Plan'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Companies$New$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                                $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, newCompanyForm)),
                                $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, newCompanyForm))
                            ]), model.jy))
                        ])),
                        model.Eu ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Billing Start Date'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Utils$Date$toIsoString(billingStartDate))),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Companies$New$CompanyFormFieldUpdated, $author$project$Pages$Companies$New$BillingStartDate))
                            ]), billingStartDateOptions)
                        ])) : $author$project$Utils$Html$empty
                    ]),
                    model.B6 ? _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Default Location'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Companies$New$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                                $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, newCompanyForm)),
                                $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 2, newCompanyForm))
                            ]), model.ro))
                        ]))
                    ]) : _List_Nil
                ]));
            } else return _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsEnd,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('It looks like you haven\'t added any '),
                        $elm$html$Html$text(A2($author$project$Formatters$String$sponsorize, model.W1, 'employer')),
                        $elm$html$Html$text(' plan yet.')
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CompanyPlans__New, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Create one?')
                    ]))
                ]))
            ]);
        } else return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSkeleton('Name the ' + A2($author$project$Formatters$String$sponsorize, model.W1, 'Employer')),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSkeleton('Default Plan'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])),
            model.Eu ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Billing Start Date'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])) : $author$project$Utils$Html$empty
        ]);
    };
    var $author$project$Pages$Companies$New$viewPanelFooter = function(_v0) {
        var practice = _v0.W1;
        var company = _v0.acy;
        return $author$project$Api$Provider$Practice$One$notRetailPlansCount(practice) > 0 ? _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__Top, _List_fromArray([
                $author$project$Ui$Link$buttonSecondary
            ]), _List_fromArray([
                $elm$html$Html$text('Cancel')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Create New ' + A2($author$project$Formatters$String$sponsorize, practice, 'Employer')
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$submit,
                $author$project$Ui$Button$loading(_Utils_eq(company, $author$project$Api$Data$Loading))
            ]), _List_fromArray([
                $elm$html$Html$text('Create New ' + A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))
            ]))
        ]) : _List_Nil;
    };
    var $author$project$Pages$Companies$New$viewBody = function(model) {
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$onSubmit($author$project$Pages$Companies$New$CreateCompany),
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Create New ' + A2($author$project$Formatters$String$sponsorize, model.W1, 'Employer'))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Companies$New$viewPanelBody(model)),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter
                ]), $author$project$Pages$Companies$New$viewPanelFooter(model))
            ]))
        ]));
    };
    var $author$project$Pages$Companies$New$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Companies$New$viewBody(model)
            ]),
            $2: A2($author$project$Formatters$String$sponsorize, model.W1, 'Employers')
        };
    };
    var $author$project$Pages$Companies$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Companies$New$init,
        aeR: $author$project$Pages$Companies$New$load,
        ag3: $author$project$Pages$Companies$New$save,
        ahE: $author$project$Pages$Companies$New$subscriptions,
        aaO: $author$project$Pages$Companies$New$update,
        aid: $author$project$Pages$Companies$New$view
    });
    var $author$project$Pages$Companies$Top$FilterDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$FeatureGate$ManageEmployers = 9;
    var $author$project$Pages$Companies$Top$PlanResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Companies$Top$SponsorTypeDropdownMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$EligibleCount = 1;
    var $author$project$Api$Provider$Company$EnrolledCount = 2;
    var $author$project$Pages$Companies$Top$GotCompanies = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$NeedsApprovalCount = 3;
    var $author$project$Api$Provider$Company$OwedInCents = 4;
    var $author$project$Api$Provider$Company$Plans = 0;
    var $author$project$Pages$Companies$Top$filterToValue = function(filter) {
        switch(filter){
            case 0:
                return '';
            case 1:
                return 'with_flagged_notes';
            case 2:
                return 'without_default_location';
            case 3:
                return 'without_broker_deals';
            case 4:
                return 'needs_approval_review';
            default:
                return 'archived';
        }
    };
    var $author$project$Pages$Companies$Top$sponsorTypeToValue = function(sponsorType) {
        switch(sponsorType){
            case 0:
                return '';
            case 1:
                return 'network';
            default:
                return 'employer';
        }
    };
    var $author$project$Pages$Companies$Top$fetchCompanies = function(model) {
        return A3($author$project$Api$Provider$Company$list, model.Ej, function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0,
                    1,
                    2,
                    3,
                    4
                ]),
                Fw: function() {
                    var _v0 = model.Fw;
                    if (!_v0) return $elm$core$Maybe$Nothing;
                    else return $elm$core$Maybe$Just($author$project$Pages$Companies$Top$filterToValue(model.Fw));
                }(),
                af_: model.af_,
                GW: model.agd,
                agq: model.agq,
                ahs: model.ahs,
                Hz: function() {
                    var _v1 = model.Hz;
                    if (!_v1) return $elm$core$Maybe$Nothing;
                    else return $elm$core$Maybe$Just($author$project$Pages$Companies$Top$sponsorTypeToValue(model.Hz));
                }()
            });
        }, $author$project$Pages$Companies$Top$GotCompanies);
    };
    var $author$project$Pages$Companies$Top$GotUpgradePricing = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Companies$Top$fetchUpgradePricing = function(apiClient) {
        return A2($author$project$Api$Provider$PracticePricing$Upgrade$retrieve, apiClient, $author$project$Pages$Companies$Top$GotUpgradePricing);
    };
    var $author$project$Pages$Companies$Top$All = 0;
    var $author$project$Pages$Companies$Top$Archived = 5;
    var $author$project$Pages$Companies$Top$NeedsApprovalReview = 4;
    var $author$project$Pages$Companies$Top$WithFlaggedNotes = 1;
    var $author$project$Pages$Companies$Top$WithoutBrokerDeals = 3;
    var $author$project$Pages$Companies$Top$WithoutDefaultLocation = 2;
    var $author$project$Pages$Companies$Top$filterFromQuery = function(queryString) {
        _v0$5: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'with_flagged_notes':
                    return 1;
                case 'without_default_location':
                    return 2;
                case 'without_broker_deals':
                    return 3;
                case 'needs_approval_review':
                    return 4;
                case 'archived':
                    return 5;
                default:
                    break _v0$5;
            }
            else break _v0$5;
        }
        return 0;
    };
    var $author$project$Pages$Companies$Top$AllSponsorTypes = 0;
    var $author$project$Pages$Companies$Top$Employer = 2;
    var $author$project$Pages$Companies$Top$Network = 1;
    var $author$project$Pages$Companies$Top$sponsorTypeFromQuery = function(queryString) {
        _v0$2: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'network':
                    return 1;
                case 'employer':
                    return 2;
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return 0;
    };
    var $author$project$Pages$Companies$Top$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var query = _v1.Bz;
        var selfUpgradeEnabled = !A2($author$project$Utils$FeatureGate$gateAvailable, 9, $author$project$Api$Practice$Provider(practice));
        var q = A2($elm$core$Dict$get, 'q', query);
        var planId = A2($elm$core$Dict$get, 'plan', query);
        var _v2 = A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                A8: _List_fromArray([
                    0,
                    1
                ])
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'All Plans',
                agj: planId
            });
        });
        var planResourceFilter = _v2.a;
        var planResourceFilterCmd = _v2.b;
        var model = {
            Ej: apiClient,
            bV: $author$project$Api$Data$Loading,
            Fw: $author$project$Pages$Companies$Top$filterFromQuery(A2($elm$core$Dict$get, 'filter', query)),
            mk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'filter-dropdown-filter',
                ahX: $author$project$Pages$Companies$Top$FilterDropdownMsg
            })),
            af_: $author$project$Api$Pagination$initFromQuery(query),
            agd: planId,
            jy: planResourceFilter,
            W1: practice,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            Hn: selfUpgradeEnabled,
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$initFromQuery(query)),
            Hz: $author$project$Pages$Companies$Top$sponsorTypeFromQuery(A2($elm$core$Dict$get, 'sponsor_type', query)),
            oC: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'sponsor-type-dropdown-filter',
                ahX: $author$project$Pages$Companies$Top$SponsorTypeDropdownMsg
            })),
            o5: $elm$core$Maybe$Nothing,
            kF: $elm$core$Maybe$Nothing
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$PlanResourceFilterMsg, planResourceFilterCmd),
            $author$project$Pages$Companies$Top$fetchCompanies(model),
            selfUpgradeEnabled && $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session) ? $author$project$Pages$Companies$Top$fetchUpgradePricing(apiClient) : $elm$core$Platform$Cmd$none
        ])));
    });
    var $author$project$Pages$Companies$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Companies$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Companies$Top$UpgradePracticeModalMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Companies$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(model.mk),
            $author$project$Ui$Dropdown$subscriptions(model.oC),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$Top$UpgradePracticeModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$UpgradePracticeModal$subscriptions, model.kF))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Companies$Top$PlanResourceFilterMsg, $author$project$Components$ResourceFilter$Plan$subscriptions(model.jy))
        ]));
    };
    var $author$project$Pages$Companies$Top$SearchInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Companies$Top$updateUrl = F2(function(model, customPath) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq),
            function() {
                var _v0 = model.Fw;
                if (!_v0) return $elm$core$Maybe$Nothing;
                else return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'filter', $author$project$Pages$Companies$Top$filterToValue(model.Fw)));
            }(),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('plan'), model.agd),
            function() {
                var _v1 = model.Hz;
                if (!_v1) return $elm$core$Maybe$Nothing;
                else return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'sponsor_type', $author$project$Pages$Companies$Top$sponsorTypeToValue(model.Hz)));
            }()
        ]);
        var urlParams = A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
        return $author$project$Ports$Navigation$replaceUrl(A4($elm$url$Url$Builder$custom, $elm$url$Url$Builder$Relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Companies__Top)
        ]), urlParams, customPath));
    });
    var $author$project$Pages$Companies$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bV: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    bV: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            bV: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Companies$Top$fetchCompanies(qModel),
                            A2($author$project$Pages$Companies$Top$updateUrl, qModel, $elm$core$Maybe$Nothing)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    bV: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$Top$fetchCompanies(newModel),
                    A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.mk);
                var dropdown = _v5.a;
                var dropdownCmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mk: dropdown
                }), dropdownCmd, _List_Nil);
            case 4:
                var filter = msg.a;
                var newModel = _Utils_update(model, {
                    bV: $author$project$Api$Data$Loading,
                    Fw: filter
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$Top$fetchCompanies(newModel),
                    A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
                ])), _List_Nil);
            case 5:
                var subMsg = msg.a;
                var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.Ej, subMsg, model.jy);
                var planId = function() {
                    var _v7 = planResourceResult.adu;
                    if (!_v7.$) {
                        if (!_v7.a.$) return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.zi);
                        else {
                            var _v8 = _v7.a;
                            return model.agd;
                        }
                    } else return model.agd;
                }();
                var newModel = _Utils_update(model, {
                    agd: planId,
                    jy: planResourceResult.zi
                });
                var _v6 = _Utils_eq(model.agd, newModel.agd) ? _Utils_Tuple2(model.bV, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$Top$fetchCompanies(newModel),
                    A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
                ])));
                var companies = _v6.a;
                var cmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    bV: companies
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$PlanResourceFilterMsg, planResourceResult.EQ),
                    cmd
                ])), planResourceResult.at);
            case 6:
                var subMsg = msg.a;
                var _v9 = A2($author$project$Ui$Dropdown$update, subMsg, model.oC);
                var dropdown = _v9.a;
                var dropdownCmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oC: dropdown
                }), dropdownCmd, _List_Nil);
            case 7:
                var option = msg.a;
                var newModel = _Utils_update(model, {
                    bV: $author$project$Api$Data$Loading,
                    Hz: option
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$Top$fetchCompanies(newModel),
                    A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
                ])), _List_Nil);
            case 8:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Companies$Top$fetchCompanies(newModel),
                    A2($author$project$Pages$Companies$Top$updateUrl, newModel, $elm$core$Maybe$Nothing)
                ])), _List_Nil);
            case 9:
                var response = msg.a;
                _v10$2: while(true)switch(response.$){
                    case 3:
                        var upgrade = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            o5: $elm$core$Maybe$Just(upgrade)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        if (response.a.$ === 5) {
                            var _v11 = response.a;
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v10$2;
                    default:
                        break _v10$2;
                }
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 10:
                var _v12 = A3($author$project$Components$UpgradePracticeModal$init, model.o5, model.Z$, $author$project$Api$Provider$Practice$One$hasClinicalAccount(model.W1));
                var upgradePracticeModal = _v12.a;
                var upgradePracticeModalCmd = _v12.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    kF: $elm$core$Maybe$Just(upgradePracticeModal)
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$UpgradePracticeModalMsg, upgradePracticeModalCmd),
                    A2($author$project$Pages$Companies$Top$updateUrl, model, $author$project$Components$UpgradePracticeModal$urlParam(upgradePracticeModal))
                ])), _List_Nil);
            case 11:
                var subMsg = msg.a;
                var _v13 = model.kF;
                if (!_v13.$) {
                    var upgradePracticeModal = _v13.a;
                    var result = A3($author$project$Components$UpgradePracticeModal$update, model.Ej, subMsg, upgradePracticeModal);
                    var _v14 = function() {
                        var _v15 = result.adu;
                        switch(_v15.$){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A2($author$project$Pages$Companies$Top$updateUrl, model, $elm$core$Maybe$Nothing), _List_Nil);
                            case 2:
                                var successMsg = _v15.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Companies__Top), _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, successMsg)
                                ]));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Just(result.zi), $elm$core$Platform$Cmd$none, _List_Nil);
                        }
                    }();
                    var modal_ = _v14.a;
                    var cmd_ = _v14.b;
                    var outMsgs_ = _v14.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        kF: modal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Companies$Top$UpgradePracticeModalMsg, result.EQ),
                        cmd_
                    ])), outMsgs_);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var text = msg.a;
                var href = msg.b;
                return _Utils_Tuple3(model, A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.Z$, text, href), _List_Nil);
        }
    });
    var $author$project$Pages$Companies$Top$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Companies$Top$SortTable = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Companies$Top$columns = function(practice) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'name', true, A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))
            ]),
            $author$project$Api$Provider$Practice$One$usesSponsors(practice) ? _List_fromArray([
                A3($author$project$Api$Column$init, 'company_type', true, 'Type')
            ]) : _List_Nil,
            _List_fromArray([
                A3($author$project$Api$Column$init, 'plans', false, 'Plan(s)'),
                A3($author$project$Api$Column$init, 'status', false, 'Status'),
                A3($author$project$Api$Column$init, 'enrolled', false, 'Enrolled'),
                A3($author$project$Api$Column$init, 'eligible', false, 'Eligible'),
                A3($author$project$Api$Column$init, 'needs_approval', false, 'Needs Approval'),
                A3($author$project$Api$Column$init, 'account_balance', false, 'Account Balance')
            ])
        ]));
    };
    var $author$project$Pages$Companies$Top$Filtered = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Companies$Top$filterToLabel = F2(function(practice, filter) {
        switch(filter){
            case 0:
                return 'All ' + A2($author$project$Formatters$String$sponsorize, practice, 'Companies');
            case 1:
                return 'Has Flagged Notes';
            case 2:
                return 'Has No Default Location';
            case 3:
                return 'Has No Broker Deals';
            case 4:
                return 'Needs Approval Review';
            default:
                return 'Archived';
        }
    });
    var $author$project$Pages$Companies$Top$filterItems = F2(function(currentFilter, practice) {
        var filterToItem = function(filter) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentFilter, filter)),
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Companies$Top$Filtered(filter))
            ]), $elm$html$Html$text(A2($author$project$Pages$Companies$Top$filterToLabel, practice, filter)));
        };
        return A2($elm$core$List$cons, filterToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, filterToItem, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                1,
                2
            ]),
            $author$project$Api$Provider$Practice$One$commissionsEnabled(practice) ? _List_fromArray([
                3
            ]) : _List_Nil,
            _List_fromArray([
                4,
                5
            ])
        ])))));
    });
    var $author$project$Pages$Companies$Top$SponsorTypeSelected = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Companies$Top$sponsorTypeToLabel = F2(function(practice, filter) {
        switch(filter){
            case 0:
                return 'All ' + (A2($author$project$Formatters$String$sponsorize, practice, 'Companies') + ' Types');
            case 1:
                return 'Network';
            default:
                return 'Employer';
        }
    });
    var $author$project$Pages$Companies$Top$sponsorTypeItems = F2(function(currentSponsorType, practice) {
        var sponsorTypeToItem = function(sponsorType) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentSponsorType, sponsorType)),
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Companies$Top$SponsorTypeSelected(sponsorType))
            ]), $elm$html$Html$text(A2($author$project$Pages$Companies$Top$sponsorTypeToLabel, practice, sponsorType)));
        };
        return A2($elm$core$List$cons, sponsorTypeToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, sponsorTypeToItem, _List_fromArray([
            1,
            2
        ]))));
    });
    var $author$project$Api$Provider$Company$All$companyType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$companyType(shared);
    };
    var $author$project$Api$Provider$Company$All$eligibleCount = function(_v0) {
        var record = _v0.b;
        return record.OG;
    };
    var $author$project$Api$Provider$Company$All$enrolledCount = function(_v0) {
        var record = _v0.b;
        return record.OX;
    };
    var $author$project$Api$Provider$Company$All$flaggedNotesCount = function(_v0) {
        var record = _v0.b;
        return record.PR;
    };
    var $author$project$Api$Provider$Company$All$needsApprovalCount = function(_v0) {
        var record = _v0.b;
        return record.UJ;
    };
    var $author$project$Api$Provider$Company$All$owedInCents = function(_v0) {
        var record = _v0.b;
        return record.VL;
    };
    var $author$project$Api$Provider$Company$All$plans = function(_v0) {
        var record = _v0.b;
        return record.WO;
    };
    var $author$project$Api$Provider$Company$All$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Pages$Companies$Top$viewCompany = F2(function(practice, company) {
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                        fl: $author$project$Api$Provider$Company$All$id(company)
                    }), _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Company$All$name(company)),
                        $author$project$Utils$Html$noBreakSpace,
                        $author$project$Api$Provider$Company$All$flaggedNotesCount(company) > 0 ? $author$project$Ui$Icon$flag(_List_Nil) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]),
            $author$project$Api$Provider$Practice$One$usesSponsors(practice) ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    !$author$project$Api$Provider$Company$All$companyType(company) ? $elm$html$Html$text('Network') : $elm$html$Html$text('Employer')
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$toSentence(A2($elm$core$List$map, $author$project$Api$Provider$Plan$Shared$name, A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$Company$All$plans(company)))))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Api$Provider$Company$All$status(company)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(A2($author$project$Api$Expandable$withDefault, 0, $author$project$Api$Provider$Company$All$enrolledCount(company))))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(A2($author$project$Api$Expandable$withDefault, 0, $author$project$Api$Provider$Company$All$eligibleCount(company))))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(A2($author$project$Api$Expandable$withDefault, 0, $author$project$Api$Provider$Company$All$needsApprovalCount(company))))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(A2($author$project$Api$Expandable$withDefault, 0, $author$project$Api$Provider$Company$All$owedInCents(company))))
                ]))
            ])
        ])));
    });
    var $author$project$Pages$Companies$Top$AnalyticsLinkClicked = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Panel$ExtraPadding = {
        $: 2
    };
    var $author$project$Ui$Panel$extraPadding = $author$project$Ui$Panel$ExtraPadding;
    var $author$project$Ui$Element$mr4 = $author$project$Ui$Element$Margin('mr-4');
    var $author$project$Pages$Companies$Top$userCanSeeCard = F2(function(session, upgradeAvailable) {
        var userIsAdmin = $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session);
        return !userIsAdmin || userIsAdmin && $elm_community$maybe_extra$Maybe$Extra$isJust(upgradeAvailable);
    });
    var $author$project$Pages$Companies$Top$UpgradePracticeClicked = {
        $: 10
    };
    var $author$project$Pages$Companies$Top$viewUpgradeButton = F3(function(selfUpgradeEnabled, upgradeAvailable, canUserUpgrade) {
        if (selfUpgradeEnabled) {
            var buttonText = function() {
                if (!upgradeAvailable.$) {
                    var upgrade = upgradeAvailable.a;
                    return 'Upgrade to ' + $author$project$Api$Provider$PracticePricing$Upgrade$tierName(upgrade);
                } else return 'Upgrade';
            }();
            return A3($author$project$Ui$Button$view, {
                abP: buttonText
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick($author$project$Pages$Companies$Top$UpgradePracticeClicked),
                $author$project$Ui$Button$disabled(!canUserUpgrade)
            ]), _List_fromArray([
                $elm$html$Html$text(buttonText)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Companies$Top$viewSelfUpgradeCard = F3(function(session, selfUpgradeEnabled, upgradeAvailable) {
        if (selfUpgradeEnabled && A2($author$project$Pages$Companies$Top$userCanSeeCard, session, upgradeAvailable)) {
            var learnMoreLink = 'https://www.hint.com/core#Employer-Direct-Contracting';
            var canUserUpgrade = $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session);
            return A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$extraPadding
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Typography$heading(_List_fromArray([
                            $elm$html$Html$text('Help Employers Rethink Primary Care, Your Way')
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Employers are ready for a better way to offer healthcare. Partnering with them can grow your revenue by up to 40% while keeping your practice sustainable, patient-focused, and independent. ')
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$flexMd
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mr4
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$externalHref, learnMoreLink, _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary,
                                $author$project$Ui$Link$targetBlank,
                                $author$project$Ui$Link$onClick(A2($author$project$Pages$Companies$Top$AnalyticsLinkClicked, 'Learn More', learnMoreLink))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Learn More')
                            ]))
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A3($author$project$Pages$Companies$Top$viewUpgradeButton, selfUpgradeEnabled, upgradeAvailable, canUserUpgrade),
                            !canUserUpgrade ? A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textMuted,
                                $author$project$Ui$Element$mt2
                            ]), _List_fromArray([
                                $elm$html$Html$text('Must be an admin to upgrade')
                            ])) : $author$project$Utils$Html$empty
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Companies$Top$view = function(model) {
        var _v0 = function() {
            var _v1 = model.bV;
            if (_v1.$ === 3) {
                var companies_ = _v1.a;
                return _Utils_Tuple2(false, companies_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var companies = _v0.b;
        return {
            fb: _List_fromArray([
                function() {
                    var _v2 = model.kF;
                    if (!_v2.$) {
                        var modal = _v2.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Companies$Top$UpgradePracticeModalMsg, $author$project$Components$UpgradePracticeModal$view(modal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4,
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$String$sponsorize, model.W1, 'Employers'))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        A2($author$project$Utils$FeatureGate$gateAvailable, 9, $author$project$Api$Practice$Provider(model.W1)) ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__New, _List_fromArray([
                            $author$project$Ui$Link$buttonDefault,
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$add),
                            $author$project$Ui$Link$buttonPrimary
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add '),
                            $elm$html$Html$text(A2($author$project$Formatters$String$sponsorize, model.W1, 'Employer'))
                        ])) : $elm$html$Html$text('')
                    ]))
                ])),
                A3($author$project$Pages$Companies$Top$viewSelfUpgradeCard, model.Z$, model.Hn, model.o5),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Companies$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(2),
                                $author$project$Ui$Grid$span(6)
                            ]), _List_fromArray([
                                A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(A2($author$project$Pages$Companies$Top$filterToLabel, model.W1, model.Fw))
                                ]), A2($author$project$Pages$Companies$Top$filterItems, model.Fw, model.W1), model.mk)
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(2),
                                $author$project$Ui$Grid$span(6)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Companies$Top$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$viewNew, _List_Nil, model.jy))
                            ])),
                            $author$project$Api$Provider$Practice$One$usesSponsors(model.W1) ? A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(2),
                                $author$project$Ui$Grid$span(6)
                            ]), _List_fromArray([
                                A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(A2($author$project$Pages$Companies$Top$sponsorTypeToLabel, model.W1, model.Hz))
                                ]), A2($author$project$Pages$Companies$Top$sponsorTypeItems, model.Hz, model.W1), model.oC)
                            ])) : $author$project$Ui$Grid$none
                        ]))
                    ])),
                    A4($author$project$Ui$Panel$table, _List_fromArray([
                        $author$project$Ui$Table$loading(loading),
                        $author$project$Ui$Table$zeroState(_List_fromArray([
                            A2($elm$html$Html$h4, _List_Nil, _List_fromArray([
                                function() {
                                    var _v3 = model.agq;
                                    if (!_v3.$) return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('No '),
                                        $elm$html$Html$text(A2($author$project$Formatters$String$sponsorize, model.W1, 'employers')),
                                        $elm$html$Html$text(' found for your search criteria.')
                                    ]));
                                    else return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('It looks like you haven\'t added any '),
                                        $elm$html$Html$text(A2($author$project$Formatters$String$sponsorize, model.W1, 'employers')),
                                        $elm$html$Html$text(' yet.')
                                    ]));
                                }(),
                                $author$project$Utils$Html$noBreakSpace,
                                A2($author$project$Utils$FeatureGate$gateAvailable, 9, $author$project$Api$Practice$Provider(model.W1)) ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__New, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Would you like to create one?')
                                ])) : $author$project$Utils$Html$empty
                            ]))
                        ]))
                    ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Companies$Top$SortTable)), $author$project$Pages$Companies$Top$columns(model.W1)), A2($elm$core$List$map, $author$project$Pages$Companies$Top$viewCompany(model.W1), companies), _List_Nil),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Companies$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(loading)
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: A2($author$project$Formatters$String$sponsorize, model.W1, 'Employers')
        };
    };
    var $author$project$Pages$Companies$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Companies$Top$init,
        aeR: $author$project$Pages$Companies$Top$load,
        ag3: $author$project$Pages$Companies$Top$save,
        ahE: $author$project$Pages$Companies$Top$subscriptions,
        aaO: $author$project$Pages$Companies$Top$update,
        aid: $author$project$Pages$Companies$Top$view
    });
    var $author$project$Pages$Contacts$ContactId_String$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Contacts$ContactId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Contacts$ContactId_String$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Contacts$ContactId_String$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Contact'
        };
    };
    var $author$project$Pages$Contacts$ContactId_String$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Contacts$ContactId_String$Top$init,
        aeR: $author$project$Pages$Contacts$ContactId_String$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Contacts$ContactId_String$Top$update,
        aid: $author$project$Pages$Contacts$ContactId_String$Top$view
    });
    var $author$project$Pages$Contacts$List$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Contacts$List$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Contacts$List$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Contacts$List$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Contacts'
        };
    };
    var $author$project$Pages$Contacts$List$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Contacts$List$init,
        aeR: $author$project$Pages$Contacts$List$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Contacts$List$update,
        aid: $author$project$Pages$Contacts$List$view
    });
    var $author$project$Pages$Contacts$New$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Contacts$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Contacts$New$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Contacts$New$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'New Contact'
        };
    };
    var $author$project$Pages$Contacts$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Contacts$New$init,
        aeR: $author$project$Pages$Contacts$New$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Contacts$New$update,
        aid: $author$project$Pages$Contacts$New$view
    });
    var $author$project$Spa$Page$application = function(page) {
        return page;
    };
    var $author$project$Pages$Error$Status_String$init = F2(function(_v0, _v1) {
        var params = _v1.VU;
        var query = _v1.Bz;
        return _Utils_Tuple3({
            ae1: A2($elm$core$Dict$get, 'message', query),
            ahy: params.ahy
        }, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Error$Status_String$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Error$Status_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Error$Status_String$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Error$Status_String$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Error$Status_String$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Error '),
                    $elm$html$Html$text(model.ahy)
                ])),
                function() {
                    var _v0 = model.ae1;
                    if (!_v0.$) {
                        var message = _v0.a;
                        return A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            $elm$html$Html$text(message)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Typography$p, _List_Nil, function() {
                    var _v1 = model.ahy;
                    switch(_v1){
                        case '401':
                            return _List_fromArray([
                                $elm$html$Html$text('You need to login first to see that page.'),
                                $elm$html$Html$text(' You can do that '),
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Login, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('here')
                                ])),
                                $elm$html$Html$text('.')
                            ]);
                        case '403':
                            return _List_fromArray([
                                $elm$html$Html$text('You\'re not authorized to do that. Please check your permissions and try agian.')
                            ]);
                        case '404':
                            return _List_fromArray([
                                $elm$html$Html$text('This page doesn\'t exist anymore. Please let us know (email '),
                                A3($author$project$Ui$Link$mailto, 'support@hint.com', _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('support@hint.com')
                                ])),
                                $elm$html$Html$text(') how you got here so we can update any outdated or expired links.')
                            ]);
                        case '418':
                            return _List_fromArray([
                                $elm$html$Html$text('I\'m a teapot')
                            ]);
                        case '422':
                            return _List_fromArray([
                                $elm$html$Html$text('Your request was missing some required information or didn\'t validate properly. Please try again.')
                            ]);
                        case '428':
                            return _List_fromArray([
                                $elm$html$Html$text('You aren\'t able to do that until you further set up your account.')
                            ]);
                        case '500':
                            return _List_fromArray([
                                $elm$html$Html$text('Our servers didn\'t like that. We\'ve been notified about this error and are looking into it.')
                            ]);
                        case '503':
                            return _List_fromArray([
                                $elm$html$Html$text('Our servers are currently undergoing maintenance. Please try again soon.')
                            ]);
                        default:
                            return _List_fromArray([
                                $elm$html$Html$text('Something bad happened. Please let us know (email '),
                                A3($author$project$Ui$Link$mailto, 'support@hint.com', _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('support@hint.com')
                                ])),
                                $elm$html$Html$text(') how you did this and we\'ll take a look.')
                            ]);
                    }
                }()),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Take me '),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Top, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('home')
                    ])),
                    $elm$html$Html$text('.')
                ]))
            ]),
            $2: 'Error'
        };
    };
    var $author$project$Pages$Error$Status_String$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$Error$Status_String$init,
        aeR: $author$project$Pages$Error$Status_String$load,
        ag3: $author$project$Pages$Error$Status_String$save,
        ahE: $author$project$Pages$Error$Status_String$subscriptions,
        aaO: $author$project$Pages$Error$Status_String$update,
        aid: $author$project$Pages$Error$Status_String$view
    });
    var $author$project$Pages$Files$Public$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Files$Public$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Files$Public$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Files$Public$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'File Drive'
        };
    };
    var $author$project$Pages$Files$Public$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Files$Public$init,
        aeR: $author$project$Pages$Files$Public$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Files$Public$update,
        aid: $author$project$Pages$Files$Public$view
    });
    var $author$project$Pages$Files$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Files$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Files$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Files$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'File Drive'
        };
    };
    var $author$project$Pages$Files$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Files$Top$init,
        aeR: $author$project$Pages$Files$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Files$Top$update,
        aid: $author$project$Pages$Files$Top$view
    });
    var $author$project$Pages$Forms$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Forms$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Forms$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Forms$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Forms'
        };
    };
    var $author$project$Pages$Forms$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Forms$init,
        aeR: $author$project$Pages$Forms$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Forms$update,
        aid: $author$project$Pages$Forms$view
    });
    var $author$project$Pages$GoogleCallback$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$GoogleCallback$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$GoogleCallback$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$GoogleCallback$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Google Callback'
        };
    };
    var $author$project$Pages$GoogleCallback$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$GoogleCallback$init,
        aeR: $author$project$Pages$GoogleCallback$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$GoogleCallback$update,
        aid: $author$project$Pages$GoogleCallback$view
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroup = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'admin_users_groups'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath);
    };
    var $author$project$Api$Platform$AdminUsersGroup$One$AdminUsersGroup = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$AdminUsersGroup$Shared$AdminUsersGroup = $elm$core$Basics$identity;
    var $author$project$Api$Platform$AdminUsersGroup$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Platform$AdminUsersGroup$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$Shared$Record)));
    var $author$project$Api$Platform$AdminUsersGroup$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$AdminUsersGroup$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$AdminUsersGroup$One$Record = F2(function(usersCount, practicesCount) {
        return {
            W8: practicesCount,
            aaZ: usersCount
        };
    });
    var $author$project$Api$Platform$AdminUsersGroup$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practices_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'users_count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$One$Record)));
    var $author$project$Api$Platform$AdminUsersGroup$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$AdminUsersGroup$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$AdminUsersGroup$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$One$AdminUsersGroup)));
    var $author$project$Api$Platform$AdminUsersGroup$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Platform$AdminUsersGroup$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_)));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroup = function(model) {
        return A3($author$project$Api$Platform$AdminUsersGroup$retrieve, model.Ej, model.aef, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroup);
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupPractices = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath = function(adminUsersGroupId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'practices'
        ]), $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(adminUsersGroupId));
    };
    var $author$project$Api$Platform$AdminUsersGroup$Practice$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Platform$AdminUsersGroup$Practice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$AdminUsersGroup$Practice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Platform$AdminUsersGroup$Practice$list = F4(function(apiClient, adminUsersGroupId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$Practice$Min$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$AdminUsersGroup$Practice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId))));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices = function(model) {
        return A4($author$project$Api$Platform$AdminUsersGroup$Practice$list, model.Ej, model.aef, function(d) {
            return _Utils_update(d, {
                af_: model.bB,
                agq: model.nF,
                ahs: model.nG
            });
        }, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupPractices);
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupUsers = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath = function(adminUsersGroupId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'users'
        ]), $author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(adminUsersGroupId));
    };
    var $author$project$Api$Platform$AdminUsersGroup$User$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'first_name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Platform$AdminUsersGroup$User$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$AdminUsersGroup$User$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Platform$AdminUsersGroup$User$list = F4(function(apiClient, adminUsersGroupId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$User$Min$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$AdminUsersGroup$User$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId))));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers = function(model) {
        return A4($author$project$Api$Platform$AdminUsersGroup$User$list, model.Ej, model.aef, function(d) {
            return _Utils_update(d, {
                af_: model.bK,
                agq: model.pa,
                ahs: model.pb
            });
        }, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$GotAdminUsersGroupUsers);
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$init = F3(function(_v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var query = _v2.Bz;
        var params = _v2.VU;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            X: $elm$core$Maybe$Nothing,
            ay: $elm$core$Maybe$Nothing,
            bP: $author$project$Api$Data$Loading,
            az: $elm$core$Maybe$Nothing,
            cy: $author$project$Api$Data$Loading,
            Ea: $author$project$Api$Data$Loading,
            Ej: apiClient,
            cS: $elm$core$Maybe$Nothing,
            dL: $elm$core$Set$empty,
            dM: $elm$core$Set$empty,
            aef: params.aef,
            bB: $author$project$Api$Pagination$init,
            nF: q,
            sf: $author$project$Ui$SearchInput$init(q),
            nG: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init),
            bK: $author$project$Api$Pagination$init,
            pa: q,
            tE: $author$project$Ui$SearchInput$init(q),
            pb: A3($author$project$Api$Sort$withDefault, 'first_name', 0, $author$project$Api$Sort$init)
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroup(model),
            $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model),
            $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model)
        ])));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice = {
        $: 23
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser = {
        $: 12
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed)), model.cS)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser)), model.az)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice)), model.ay))
        ]));
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupDeleted = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeAdded = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeDeleted = F2(function(a, b) {
        return {
            $: 28,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserAdded = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserDeleted = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Platform$AdminUsersGroup$Practice$add = F4(function(apiClient, adminUsersGroupId, practiceId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(practiceId))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$Practice$Min$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId))));
    });
    var $author$project$Api$Platform$AdminUsersGroup$User$add = F4(function(apiClient, adminUsersGroupId, userId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('user', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(userId))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$User$Min$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId))));
    });
    var $author$project$Api$Platform$AdminUsersGroup$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_)));
    });
    var $author$project$Api$Platform$AdminUsersGroup$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Platform$AdminUsersGroup$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$AdminUsersGroup$Shared$name(shared);
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup = function(adminUsersGroup) {
        return $author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup);
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsUpdate = F2(function(field, _v0) {
        var name = field;
        return name;
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$NameValidation = 0;
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Api$Platform$AdminUsersGroup$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Platform$AdminUsersGroup$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$AdminUsersGroup$Shared$id(shared);
    };
    var $author$project$Api$Platform$User$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Platform$User$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsUpdate = F2(function(field, _v0) {
        var practiceId = field;
        return $author$project$Utils$String$toMaybe(practiceId);
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeIdValidation = 0;
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter a practice ID.'))
    ]));
    var $author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticePath = F2(function(adminUsersGroupId, practiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            practiceId
        ]), $author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticesPath(adminUsersGroupId));
    });
    var $author$project$Api$Platform$AdminUsersGroup$Practice$remove = F4(function(apiClient, adminUsersGroupId, practiceId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Platform$AdminUsersGroup$Practice$adminUsersGroupPracticePath, adminUsersGroupId, practiceId)));
    });
    var $author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUserPath = F2(function(adminUsersGroupId, userId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            userId
        ]), $author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUsersPath(adminUsersGroupId));
    });
    var $author$project$Api$Platform$AdminUsersGroup$User$remove = F4(function(apiClient, adminUsersGroupId, userId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Platform$AdminUsersGroup$User$adminUsersGroupUserPath, adminUsersGroupId, userId)));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Platform$AdminUsersGroup$update = F4(function(apiClient, id_, name_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('admin_users_group', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(name_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Platform$AdminUsersGroup$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupPath(id_))));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$updateAdminUsersGroup = F3(function(apiClient, id, formFields) {
        var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Platform$AdminUsersGroup$update, apiClient, id, name, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUpdated);
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsUpdate = F2(function(field, _v0) {
        var userId = field;
        return $author$project$Utils$String$toMaybe(userId);
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserIdValidation = 0;
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter a user ID.'))
    ]));
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$update = F2(function(msg, model) {
        switch(msg.$){
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    cS: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var confirmed = msg.a;
                var _v1 = model.X;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var adminUsersGroup = _v2.a;
                    return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                        cS: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
                    }), A3($author$project$Api$Platform$AdminUsersGroup$delete, model.Ej, $author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupDeleted(adminUsersGroup)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        cS: $elm$core$Maybe$Nothing
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var adminUsersGroup = msg.a;
                var dataAdminUsersGroup = msg.b;
                switch(dataAdminUsersGroup.$){
                    case 3:
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup) + ' was successfully removed.')
                        ]));
                    case 2:
                        var error = dataAdminUsersGroup.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            cS: $elm$core$Maybe$Nothing
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(dataAdminUsersGroup)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                var _v4 = model.X;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var adminUsersGroup = _v5.a;
                    var form = _v5.b;
                    var _v6 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsValidator, form);
                    if (!_v6.$) {
                        var _v7 = _v6.a;
                        var newForm = _v7.a;
                        var validFormFields = _v7.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            X: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$Loading))
                        }), A3($author$project$Pages$Hinter$AdminUsersGroups$Id_String$updateAdminUsersGroup, model.Ej, $author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup), validFormFields), _List_Nil);
                    } else {
                        var newForm = _v6.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            X: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var adminUsersGroup = response.a;
                    var form = $author$project$Utils$Form$init($author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup(adminUsersGroup));
                    return _Utils_Tuple3(_Utils_update(model, {
                        X: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroup, form, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    X: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var field = msg.a;
                var _v9 = model.X;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    var adminUsersGroup = _v10.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        X: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, adminUsersGroup))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var dataAdminUsersGroup = msg.a;
                var _v11 = model.X;
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var adminUsersGroup = _v12.a;
                    var form = _v12.b;
                    if (dataAdminUsersGroup.$ === 3) {
                        var newAdminUsersGroup = dataAdminUsersGroup.a;
                        var newForm = $author$project$Utils$Form$init($author$project$Pages$Hinter$AdminUsersGroups$Id_String$formFieldsFromAdminUsersGroup(newAdminUsersGroup));
                        return _Utils_Tuple3(_Utils_update(model, {
                            X: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroup, newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup) + ' was successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        X: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroup, form, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataAdminUsersGroup));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cy: response,
                        bK: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.bK)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cy: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.bK);
                var newModel = _Utils_update(model, {
                    Ea: $author$project$Api$Data$Loading,
                    bK: pagination
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(newModel), _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v15 = A2($author$project$Ui$SearchInput$update, subMsg, model.tE);
                var searchInput = _v15.a;
                var searchInputCmd = _v15.b;
                var searchInputEvent = _v15.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.pa;
                }();
                var _v16 = function() {
                    if (_Utils_eq(q, model.pa)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            cy: $author$project$Api$Data$Loading,
                            bK: $author$project$Api$Pagination$reset(model.bK),
                            pa: q
                        });
                        return _Utils_Tuple2(qModel, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(qModel));
                    }
                }();
                var newModel = _v16.a;
                var cmd = _v16.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    tE: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 10:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    cy: $author$project$Api$Data$Loading,
                    bK: $author$project$Api$Pagination$reset(model.bK),
                    pb: A2($author$project$Api$Sort$update, columnId, model.pb)
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(newModel), _List_Nil);
            case 11:
                var _v18 = model.X;
                if (!_v18.$) {
                    var _v19 = _v18.a;
                    var adminUsersGroup = _v19.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        az: $elm$core$Maybe$Just(_Utils_Tuple3($author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup), $author$project$Utils$Form$init($elm$core$Maybe$Nothing), $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                return _Utils_Tuple3(_Utils_update(model, {
                    az: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var field = msg.a;
                var _v20 = model.az;
                if (!_v20.$) {
                    var _v21 = _v20.a;
                    var adminUsersGroupId = _v21.a;
                    var form = _v21.b;
                    var request = _v21.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        az: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroupId, newForm, request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var _v22 = model.az;
                if (!_v22.$) {
                    var _v23 = _v22.a;
                    var adminUsersGroupId = _v23.a;
                    var form = _v23.b;
                    var _v24 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$userFormFieldsValidator, form);
                    if (!_v24.$) {
                        var _v25 = _v24.a;
                        var newForm = _v25.a;
                        var validFormFields = _v25.b;
                        var userId = A2($elm$core$Maybe$withDefault, '', $rtfeldman$elm_validate$Validate$fromValid(validFormFields));
                        return _Utils_Tuple3(_Utils_update(model, {
                            az: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$Loading))
                        }), A4($author$project$Api$Platform$AdminUsersGroup$User$add, model.Ej, adminUsersGroupId, userId, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserAdded), _List_Nil);
                    } else {
                        var newForm = _v24.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            az: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var response = msg.a;
                var _v26 = model.az;
                if (!_v26.$) {
                    var _v27 = _v26.a;
                    var adminUsersGroupId = _v27.a;
                    var form = _v27.b;
                    if (response.$ === 3) {
                        var user = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            az: $elm$core$Maybe$Nothing,
                            cy: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Platform$User$Min$name(user) + ' was successfully added.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        az: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroupId, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var adminUsersGroupId = msg.a;
                var user = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    cS: $elm$core$Maybe$Nothing,
                    dM: A2($elm$core$Set$insert, $author$project$Api$Platform$User$Min$id(user), model.dM)
                }), A4($author$project$Api$Platform$AdminUsersGroup$User$remove, model.Ej, adminUsersGroupId, $author$project$Api$Platform$User$Min$id(user), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupUserDeleted(user)), _List_Nil);
            case 17:
                var user = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            cy: $author$project$Api$Data$Loading,
                            dM: A2($elm$core$Set$remove, $author$project$Api$Platform$User$Min$id(user), model.dM)
                        }), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupUsers(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Platform$User$Min$name(user) + ' was successfully removed.')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            dM: A2($elm$core$Set$remove, $author$project$Api$Platform$User$Min$id(user), model.dM)
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 18:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bP: response,
                        bB: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.bB)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    bP: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 19:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.bB);
                var newModel = _Utils_update(model, {
                    bP: $author$project$Api$Data$Loading,
                    bB: pagination
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(newModel), _List_Nil);
            case 20:
                var subMsg = msg.a;
                var _v31 = A2($author$project$Ui$SearchInput$update, subMsg, model.sf);
                var searchInput = _v31.a;
                var searchInputCmd = _v31.b;
                var searchInputEvent = _v31.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.nF;
                }();
                var _v32 = function() {
                    if (_Utils_eq(q, model.nF)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            bP: $author$project$Api$Data$Loading,
                            bB: $author$project$Api$Pagination$reset(model.bB),
                            nF: q
                        });
                        return _Utils_Tuple2(qModel, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(qModel));
                    }
                }();
                var newModel = _v32.a;
                var cmd = _v32.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sf: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 21:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    bP: $author$project$Api$Data$Loading,
                    bB: $author$project$Api$Pagination$reset(model.bB),
                    nG: A2($author$project$Api$Sort$update, columnId, model.nG)
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(newModel), _List_Nil);
            case 22:
                var _v34 = model.X;
                if (!_v34.$) {
                    var _v35 = _v34.a;
                    var adminUsersGroup = _v35.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ay: $elm$core$Maybe$Just(_Utils_Tuple3($author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup), $author$project$Utils$Form$init($elm$core$Maybe$Nothing), $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 23:
                return _Utils_Tuple3(_Utils_update(model, {
                    ay: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 24:
                var field = msg.a;
                var _v36 = model.ay;
                if (!_v36.$) {
                    var _v37 = _v36.a;
                    var adminUsersGroupId = _v37.a;
                    var form = _v37.b;
                    var request = _v37.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        ay: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroupId, newForm, request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 25:
                var _v38 = model.ay;
                if (!_v38.$) {
                    var _v39 = _v38.a;
                    var adminUsersGroupId = _v39.a;
                    var form = _v39.b;
                    var _v40 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practiceFormFieldsValidator, form);
                    if (!_v40.$) {
                        var _v41 = _v40.a;
                        var newForm = _v41.a;
                        var validFormFields = _v41.b;
                        var practiceId = A2($elm$core$Maybe$withDefault, '', $rtfeldman$elm_validate$Validate$fromValid(validFormFields));
                        return _Utils_Tuple3(_Utils_update(model, {
                            ay: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$Loading))
                        }), A4($author$project$Api$Platform$AdminUsersGroup$Practice$add, model.Ej, adminUsersGroupId, practiceId, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeAdded), _List_Nil);
                    } else {
                        var newForm = _v40.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ay: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroupId, newForm, $author$project$Api$Data$NotAsked))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 26:
                var response = msg.a;
                var _v42 = model.ay;
                if (!_v42.$) {
                    var _v43 = _v42.a;
                    var adminUsersGroupId = _v43.a;
                    var form = _v43.b;
                    if (response.$ === 3) {
                        var practice = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ay: $elm$core$Maybe$Nothing,
                            bP: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Platform$Practice$Min$name(practice) + ' was successfully added.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        ay: $elm$core$Maybe$Just(_Utils_Tuple3(adminUsersGroupId, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 27:
                var adminUsersGroupId = msg.a;
                var practice = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    cS: $elm$core$Maybe$Nothing,
                    dL: A2($elm$core$Set$insert, $author$project$Api$Platform$Practice$Min$id(practice), model.dL)
                }), A4($author$project$Api$Platform$AdminUsersGroup$Practice$remove, model.Ej, adminUsersGroupId, $author$project$Api$Platform$Practice$Min$id(practice), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AdminUsersGroupPracticeDeleted(practice)), _List_Nil);
            default:
                var practice = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            bP: $author$project$Api$Data$Loading,
                            dL: A2($elm$core$Set$remove, $author$project$Api$Platform$Practice$Min$id(practice), model.dL)
                        }), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$fetchAdminUsersGroupPractices(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Platform$Practice$Min$name(practice) + ' was successfully removed.')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            dL: A2($elm$core$Set$remove, $author$project$Api$Platform$Practice$Min$id(practice), model.dL)
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeFormUpdated = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeId = $elm$core$Basics$identity;
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupPractice = {
        $: 25
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddPracticeModal = F2(function(form, request) {
        var practiceId = $author$project$Utils$Form$fields(form);
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Add Practice',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Nothing,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddPractice,
            Vn: $elm$core$Basics$always($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupPractice)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$label('Practice ID'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', practiceId)),
                    $author$project$Ui$Form$Input$placeholder('pra-abcdef1234567890'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticeFormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupUser = {
        $: 14
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserFormUpdated = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserId = $elm$core$Basics$identity;
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddUserModal = F2(function(form, request) {
        var userId = $author$project$Utils$Form$fields(form);
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Add User',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Nothing,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$CancelAddUser,
            Vn: $elm$core$Basics$always($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroupUser)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$label('User ID'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', userId)),
                    $author$project$Ui$Form$Input$placeholder('user-abcdef1234567890'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UserFormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddPractice = {
        $: 22
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesPaginationMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSortTable = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practicesTableColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'id', true, 'ID'),
        A3($author$project$Api$Column$init, 'name', true, 'Name')
    ]);
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupPractice = F2(function(a, b) {
        return {
            $: 27,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractice = F3(function(adminUsersGroupId, model, practice) {
        var id = $author$project$Api$Platform$Practice$Min$id(practice);
        var loading = A2($elm$core$Set$member, id, model.dL);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Platform$Practice$Min$id(practice))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Platform$Practice$Min$name(practice))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Remove practice from admin users group'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$onClick(A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupPractice, adminUsersGroupId, practice)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Remove')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPracticesTable = F2(function(adminUsersGroupId, model) {
        var _v0 = function() {
            var _v1 = model.bP;
            if (_v1.$ === 3) {
                var adminUsersGroupPractices_ = _v1.a;
                return _Utils_Tuple2(false, adminUsersGroupPractices_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var adminUsersGroupPractices = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('There are no practices in this group')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.nG, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSortTable)), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$practicesTableColumns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ])
        ])), A2($elm$core$List$map, A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractice, adminUsersGroupId, model), adminUsersGroupPractices), _List_Nil);
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractices = F2(function(adminUsersGroupId, model) {
        var loading = function() {
            var _v0 = model.bP;
            if (_v0.$ === 3) return false;
            else return true;
        }();
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Practices')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add practice'
                        }, _List_fromArray([
                            $author$project$Ui$Button$default,
                            $author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddPractice)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add Practice')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mt2
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesSearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sf))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPracticesTable, adminUsersGroupId, model),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$PracticesPaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(loading)
                ]), model.bB))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddUser = {
        $: 11
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersPaginationMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSortTable = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$usersTableColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'id', true, 'ID'),
        A3($author$project$Api$Column$init, 'first_name', true, 'Name'),
        A3($author$project$Api$Column$init, 'email', true, 'Email')
    ]);
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupUser = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$User$Min$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewUser = F3(function(adminUsersGroupId, model, user) {
        var id = $author$project$Api$Platform$User$Min$id(user);
        var loading = A2($elm$core$Set$member, id, model.dM);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Platform$User$Min$id(user))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Platform$User$Min$name(user))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Platform$User$Min$email(user))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Remove user from admin users group'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$onClick(A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupUser, adminUsersGroupId, user)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Remove')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsersTable = F2(function(adminUsersGroupId, model) {
        var _v0 = function() {
            var _v1 = model.cy;
            if (_v1.$ === 3) {
                var adminUsersGroupUsers_ = _v1.a;
                return _Utils_Tuple2(false, adminUsersGroupUsers_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var adminUsersGroupUsers = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('There are no users in this group')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.pb, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSortTable)), $author$project$Pages$Hinter$AdminUsersGroups$Id_String$usersTableColumns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ])
        ])), A2($elm$core$List$map, A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewUser, adminUsersGroupId, model), adminUsersGroupUsers), _List_Nil);
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsers = F2(function(adminUsersGroupId, model) {
        var loading = function() {
            var _v0 = model.cy;
            if (_v0.$ === 3) return false;
            else return true;
        }();
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Users')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add user'
                        }, _List_fromArray([
                            $author$project$Ui$Button$default,
                            $author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$AddUser)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add User')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mt2
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(12)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersSearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.tE))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsersTable, adminUsersGroupId, model),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$UsersPaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(loading)
                ]), model.bK))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroup = {
        $: 4
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$Name = $elm$core$Basics$identity;
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroup = {
        $: 1
    };
    var $author$project$Api$Platform$AdminUsersGroup$One$practicesCount = function(_v0) {
        var record = _v0.b;
        return record.W8;
    };
    var $author$project$Api$Platform$AdminUsersGroup$One$usersCount = function(_v0) {
        var record = _v0.b;
        return record.aaZ;
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewForm = F3(function(adminUsersGroup, form, saveRequest) {
        var preventDelete = $author$project$Api$Platform$AdminUsersGroup$One$usersCount(adminUsersGroup) > 0 || $author$project$Api$Platform$AdminUsersGroup$One$practicesCount(adminUsersGroup) > 0;
        var name = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(name),
                    $author$project$Ui$Form$Input$placeholder('Group Name'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textCenter,
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Update admin users group'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit,
                    $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$SaveAdminUsersGroup)
                ]), _List_fromArray([
                    $elm$html$Html$text('Update')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete admin users group'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$disabled(preventDelete),
                    $author$project$Ui$Button$loading(_Utils_eq(saveRequest, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroup),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroup = F4(function(adminUsersGroup, form, saveRequest, model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                                $elm$html$Html$text('Admin Users Group - '),
                                $elm$html$Html$text($author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup))
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$pull(1)
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top, _List_Nil, _List_fromArray([
                                        $author$project$Ui$Icon$cross(_List_Nil)
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A3($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewForm, adminUsersGroup, form, saveRequest),
                            $author$project$Ui$HorizontalRule$view(_List_Nil)
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupUsers, $author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup), model)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroupPractices, $author$project$Api$Platform$AdminUsersGroup$One$id(adminUsersGroup), model)
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.cS;
                    if (!_v0.$) {
                        var deleteRequest = _v0.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$DeleteAdminUsersGroupClosed, _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('admin users group'),
                            $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v1 = model.az;
                    if (!_v1.$) {
                        var _v2 = _v1.a;
                        var form = _v2.b;
                        var user = _v2.c;
                        return A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddUserModal, form, user);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v3 = model.ay;
                    if (!_v3.$) {
                        var _v4 = _v3.a;
                        var form = _v4.b;
                        var practice = _v4.c;
                        return A2($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAddPracticeModal, form, practice);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v5 = model.X;
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var adminUsersGroup = _v6.a;
                        var form = _v6.b;
                        var saveRequest = _v6.c;
                        return A4($author$project$Pages$Hinter$AdminUsersGroups$Id_String$viewAdminUsersGroup, adminUsersGroup, form, saveRequest, model);
                    } else return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]));
                }()
            ]),
            $2: 'Admin | Admin Users Groups'
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Id_String$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$init,
        aeR: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$load,
        ag3: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$save,
        ahE: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$subscriptions,
        aaO: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$update,
        aid: $author$project$Pages$Hinter$AdminUsersGroups$Id_String$view
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$GotAdminUsersGroups = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Platform$AdminUsersGroup$All$AdminUsersGroup = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$AdminUsersGroup$All$AllRecord = F2(function(usersCount, practicesCount) {
        return {
            W8: practicesCount,
            aaZ: usersCount
        };
    });
    var $author$project$Api$Platform$AdminUsersGroup$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practices_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'users_count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$All$AllRecord)));
    var $author$project$Api$Platform$AdminUsersGroup$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$AdminUsersGroup$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$AdminUsersGroup$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$AdminUsersGroup$All$AdminUsersGroup)));
    var $author$project$Api$Platform$AdminUsersGroup$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Platform$AdminUsersGroup$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$AdminUsersGroup$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Platform$AdminUsersGroup$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$AdminUsersGroup$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$AdminUsersGroup$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath)));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups = function(model) {
        return A3($author$project$Api$Platform$AdminUsersGroup$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Pages$Hinter$AdminUsersGroups$Top$GotAdminUsersGroups);
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$init = F3(function(_v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var query = _v2.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            X: $elm$core$Maybe$Nothing,
            Ea: $author$project$Api$Data$Loading,
            Ej: apiClient,
            af_: $author$project$Api$Pagination$init,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
        };
        return _Utils_Tuple2(model, $author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(model));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit = {
        $: 4
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$subscriptions = function(model) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit)), model.X));
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$AdminUsersGroupCreated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Platform$AdminUsersGroup$create = F3(function(apiClient, name_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('admin_users_group', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(name_))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$AdminUsersGroup$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$AdminUsersGroup$adminUsersGroupsPath)));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$createAdminUsersGroup = F2(function(apiClient, formFields) {
        var name = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Platform$AdminUsersGroup$create, apiClient, name, $author$project$Pages$Hinter$AdminUsersGroups$Top$AdminUsersGroupCreated);
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsInit = '';
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsUpdate = F2(function(field, _v0) {
        var name = field;
        return name;
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$NameValidation = 0;
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, $elm$core$Basics$identity, _Utils_Tuple2(0, 'Please enter a name.'))
    ]));
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    X: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsInit), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    Ea: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(newModel), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v1.a;
                var searchInputCmd = _v1.b;
                var searchInputEvent = _v1.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v2 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            Ea: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(qModel));
                    }
                }();
                var newModel = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 3:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    Ea: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(newModel), _List_Nil);
            case 6:
                var form = msg.a;
                var id = msg.b;
                var _v4 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsValidator, form);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newForm = _v5.a;
                    var validFormFields = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        X: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$Loading))
                    }), A2($author$project$Pages$Hinter$AdminUsersGroups$Top$createAdminUsersGroup, model.Ej, validFormFields), _List_Nil);
                } else {
                    var newForm = _v4.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        X: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    X: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Ea: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Ea: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var field = msg.a;
                var _v7 = model.X;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var id = _v8.a;
                    var form = _v8.b;
                    var adminUsersGroup = _v8.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$AdminUsersGroups$Top$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        X: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, adminUsersGroup))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var dataAdminUsersGroup = msg.a;
                var _v9 = model.X;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (dataAdminUsersGroup.$ === 3) {
                        var adminUsersGroup = dataAdminUsersGroup.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            X: $elm$core$Maybe$Nothing,
                            Ea: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Hinter$AdminUsersGroups$Top$fetchAdminUsersGroups(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Platform$AdminUsersGroup$One$name(adminUsersGroup))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        X: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, dataAdminUsersGroup))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataAdminUsersGroup));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup = {
        $: 0
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$FormUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$Name = $elm$core$Basics$identity;
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$SaveAdminUsersGroup = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroupModal = F3(function(id, form, adminUsersGroup) {
        var name = $author$project$Utils$Form$fields(form);
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Admin Users Group',
            Tk: _Utils_eq(adminUsersGroup, $author$project$Api$Data$Loading),
            TR: id,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Hinter$AdminUsersGroups$Top$CancelAdminUsersGroupEdit,
            Vn: $author$project$Pages$Hinter$AdminUsersGroups$Top$SaveAdminUsersGroup(form)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(name),
                    $author$project$Ui$Form$Input$placeholder('Group Name'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$AdminUsersGroups$Top$FormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                ])),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$SortTable = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$tableColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'Name'),
        A3($author$project$Api$Column$init, 'users_count', false, 'Users Count'),
        A3($author$project$Api$Column$init, 'practices_count', false, 'Practices Count')
    ]);
    var $author$project$Api$Platform$AdminUsersGroup$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$AdminUsersGroup$Shared$id(shared);
    };
    var $author$project$Api$Platform$AdminUsersGroup$All$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$AdminUsersGroup$Shared$name(shared);
    };
    var $author$project$Api$Platform$AdminUsersGroup$All$practicesCount = function(_v0) {
        var record = _v0.b;
        return record.W8;
    };
    var $author$project$Api$Platform$AdminUsersGroup$All$usersCount = function(_v0) {
        var record = _v0.b;
        return record.aaZ;
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroup = function(adminUsersGroup) {
        var id = $author$project$Api$Platform$AdminUsersGroup$All$id(adminUsersGroup);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String({
                    aef: id
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Platform$AdminUsersGroup$All$name(adminUsersGroup))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Platform$AdminUsersGroup$All$usersCount(adminUsersGroup)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Platform$AdminUsersGroup$All$practicesCount(adminUsersGroup)))
            ]))
        ]));
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.Ea;
            if (_v1.$ === 3) {
                var adminUsersGroups_ = _v1.a;
                return _Utils_Tuple2(false, adminUsersGroups_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var adminUsersGroups = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You have no Admin Users Groups.'),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                function() {
                    var label = 'Add a Admin Users Group here';
                    return A3($author$project$Ui$Button$view, {
                        abP: label
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup)
                    ]), _List_fromArray([
                        $elm$html$Html$text(label)
                    ]));
                }()
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Hinter$AdminUsersGroups$Top$SortTable)), $author$project$Pages$Hinter$AdminUsersGroups$Top$tableColumns), A2($elm$core$List$map, $author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroup, adminUsersGroups), _List_Nil);
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.X;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var id = _v1.a;
                        var form = _v1.b;
                        var adminUsersGroup = _v1.c;
                        return A3($author$project$Pages$Hinter$AdminUsersGroups$Top$viewAdminUsersGroupModal, id, form, adminUsersGroup);
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            $elm$html$Html$text('Admin Users Groups')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$pull(1)
                            ]), _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Add new admin users group'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$default,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Hinter$AdminUsersGroups$Top$NewAdminUsersGroup),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('New Admin Users Group')
                                ])),
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Organizations__Top, _List_Nil, _List_fromArray([
                                    $author$project$Ui$Icon$cross(_List_Nil)
                                ]))
                            ]))
                        ])),
                        A2($elm$html$Html$em, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Lets you assign multiple users to multiple practices')
                        ])),
                        A2($author$project$Ui$Grid$row, _List_fromArray([
                            $author$project$Ui$Grid$mt2
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(12)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Hinter$AdminUsersGroups$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                                ]))
                            ]))
                        ]))
                    ])),
                    $author$project$Pages$Hinter$AdminUsersGroups$Top$viewPanelBody(model),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Hinter$AdminUsersGroups$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.Ea))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Admin Users Groups'
        };
    };
    var $author$project$Pages$Hinter$AdminUsersGroups$Top$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Hinter$AdminUsersGroups$Top$init,
        aeR: $author$project$Pages$Hinter$AdminUsersGroups$Top$load,
        ag3: $author$project$Pages$Hinter$AdminUsersGroups$Top$save,
        ahE: $author$project$Pages$Hinter$AdminUsersGroups$Top$subscriptions,
        aaO: $author$project$Pages$Hinter$AdminUsersGroups$Top$update,
        aid: $author$project$Pages$Hinter$AdminUsersGroups$Top$view
    });
    var $author$project$Pages$Hinter$ClonePractice$GotPracticeUsers = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$fetchTeamMembers = function(apiClient) {
        return A3($author$project$Api$Provider$TeamMember$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: A2($author$project$Api$Pagination$withItemsPerPage, 50, $author$project$Api$Pagination$init),
                ahs: A3($author$project$Api$Sort$withDefault, 'role', 0, $author$project$Api$Sort$init)
            });
        }, $author$project$Pages$Hinter$ClonePractice$GotPracticeUsers);
    };
    var $author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$ClonePractice$initFormFields = function(practice) {
        var _v0 = $author$project$Components$DateInput$init;
        var launchDateDateInput = _v0.a;
        var launchDateDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            acs: false,
            act: false,
            acu: false,
            acv: false,
            acT: true,
            OH: $author$project$Api$Provider$Practice$One$email(practice),
            FC: practice,
            QT: $elm$core$Maybe$Nothing,
            S0: $elm$core$Maybe$Nothing,
            re: launchDateDateInput,
            zr: '',
            Vs: false,
            agh: _List_Nil
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg(launchDateDateInput), launchDateDateInputCmd));
    };
    var $author$project$Pages$Hinter$ClonePractice$init = F4(function(_v0, practice, shared, _v1) {
        var _v2 = $author$project$Pages$Hinter$ClonePractice$initFormFields(practice);
        var formFields = _v2.a;
        var formFieldsCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            cP: shared.cP,
            PU: $author$project$Utils$Form$init(formFields),
            agh: $author$project$Api$Data$Loading,
            j_: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            formFieldsCmd,
            $author$project$Pages$Hinter$ClonePractice$fetchTeamMembers(shared.Ej)
        ])));
    });
    var $author$project$Pages$Hinter$ClonePractice$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            cP: shared.cP
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$ClonePractice$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Hinter$ClonePractice$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Hinter$ClonePractice$LaunchDate = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$ClonePractice$PracticeCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$clone = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
                _Utils_Tuple2('launch_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.S0)),
                _Utils_Tuple2('onboarded', $elm$json$Json$Encode$bool(fields.Vs)),
                _Utils_Tuple2('practice_users', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, fields.agh)),
                _Utils_Tuple2('hubspot_deal_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.QT)),
                _Utils_Tuple2('clone_embedded_reports', $elm$json$Json$Encode$bool(fields.act)),
                _Utils_Tuple2('deal_reporting_only', $elm$json$Json$Encode$bool(fields.acT)),
                _Utils_Tuple2('clone_lead_sources', $elm$json$Json$Encode$bool(fields.acv)),
                _Utils_Tuple2('clone_coupons', $elm$json$Json$Encode$bool(fields.acs)),
                _Utils_Tuple2('clone_feature_flags', $elm$json$Json$Encode$bool(fields.acu)),
                _Utils_Tuple2('email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OH))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'clone'
        ]), $author$project$Api$Provider$Practice$practicePath))));
    });
    var $author$project$Pages$Hinter$ClonePractice$practiceFormFields = function(fields) {
        return {
            acs: fields.acs,
            act: fields.act,
            acu: fields.acu,
            acv: fields.acv,
            acT: fields.acT,
            OH: fields.OH,
            QT: fields.QT,
            S0: fields.S0,
            zr: fields.zr,
            Vs: fields.Vs,
            agh: A2($elm$core$List$map, function(pu) {
                return pu.aef;
            }, A2($elm$core$List$filter, function(pu) {
                return pu.hO;
            }, fields.agh))
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$clonePractice = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Practice$clone, apiClient, $author$project$Pages$Hinter$ClonePractice$practiceFormFields(fields), $author$project$Pages$Hinter$ClonePractice$PracticeCreated);
    });
    var $author$project$Pages$Hinter$ClonePractice$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 1:
                var dateInput = field.a;
                var date = field.b;
                return _Utils_update(fields, {
                    S0: date,
                    re: dateInput
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    Vs: bool
                });
            case 3:
                var practiceUserId = field.a;
                var checked = field.b;
                return _Utils_update(fields, {
                    agh: A3($elm_community$list_extra$List$Extra$updateIf, function(practiceUserField) {
                        return _Utils_eq(practiceUserField.aef, practiceUserId);
                    }, function(practiceUserField) {
                        return _Utils_update(practiceUserField, {
                            hO: checked
                        });
                    }, fields.agh)
                });
            case 4:
                return _Utils_update(fields, {
                    agh: A2($elm$core$List$map, function(practiceUserField) {
                        return _Utils_update(practiceUserField, {
                            hO: true
                        });
                    }, fields.agh)
                });
            case 5:
                return _Utils_update(fields, {
                    agh: A2($elm$core$List$map, function(practiceUserField) {
                        return _Utils_update(practiceUserField, {
                            hO: false
                        });
                    }, fields.agh)
                });
            case 6:
                var string = field.a;
                return _Utils_update(fields, {
                    QT: $author$project$Utils$String$toMaybe(string)
                });
            case 7:
                var bool = field.a;
                return _Utils_update(fields, {
                    act: bool
                });
            case 8:
                var bool = field.a;
                return _Utils_update(fields, {
                    acT: bool
                });
            case 9:
                var string = field.a;
                return _Utils_update(fields, {
                    OH: $author$project$Utils$String$toMaybe(string)
                });
            case 10:
                var bool = field.a;
                return _Utils_update(fields, {
                    acv: bool
                });
            case 11:
                var bool = field.a;
                return _Utils_update(fields, {
                    acs: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    acu: bool
                });
        }
    });
    var $author$project$Pages$Hinter$ClonePractice$EmailValidation = 2;
    var $author$project$Pages$Hinter$ClonePractice$NameValidation = 0;
    var $author$project$Pages$Hinter$ClonePractice$LaunchDateValidation = 1;
    var $author$project$Pages$Hinter$ClonePractice$validateLaunchDate = F2(function(currentDate, fields) {
        var invalid = _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a date greater or equal than today')
        ]);
        var _v0 = fields.S0;
        if (!_v0.$) {
            var launchDate = _v0.a;
            return A2($justinmimbs$date$Date$compare, currentDate, launchDate) !== 2 ? _List_Nil : invalid;
        } else return invalid;
    });
    var $author$project$Pages$Hinter$ClonePractice$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.zr;
            }, _Utils_Tuple2(0, 'Please enter a name.')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$ClonePractice$validateLaunchDate(currentDate)),
            A3($author$project$Utils$Validate$ifInvalidEmail, {
                abH: true
            }, function($) {
                return $.OH;
            }, _Utils_Tuple2(2, 'Please enter a valid email.'))
        ]));
    };
    var $author$project$Pages$Hinter$ClonePractice$initPracticeUserField = function(practiceUser) {
        return {
            hO: false,
            OH: $author$project$Api$Provider$PracticeUser$All$email(practiceUser),
            aef: $author$project$Api$Provider$PracticeUser$All$id(practiceUser),
            ag_: $author$project$Api$Provider$PracticeUser$All$role(practiceUser)
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$formFieldsWithUsers = F2(function(users, formFields) {
        return _Utils_update(formFields, {
            agh: A2($elm$core$List$map, $author$project$Pages$Hinter$ClonePractice$initPracticeUserField, users)
        });
    });
    var $author$project$Pages$Hinter$ClonePractice$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$ClonePractice$formFieldsUpdate, A2(field, newDateInput, date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$ClonePractice$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.PU);
            }
        }();
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd), _List_Nil);
    });
    var $author$project$Pages$Hinter$ClonePractice$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$ClonePractice$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$ClonePractice$formFieldsValidator(model.cP), model.PU);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var validatedForm = _v2.a;
                    var validFormFields = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Hinter$ClonePractice$clonePractice, model.Ej, validFormFields), _List_Nil);
                } else {
                    var validatedForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    var _v4 = _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
                        A3($author$project$OutMsg$SwitchToOrganization, $author$project$Api$Provider$Practice$One$organizationId(practice), $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Admin__Billing))
                    ]));
                    var cmd = _v4.a;
                    var outMsgs = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), cmd, _Utils_ap(outMsgs, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Practice cloned'),
                        $author$project$OutMsg$PracticeUpdated(response)
                    ])));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Pages$Hinter$ClonePractice$updateDateInputFormField, model, dateInput, subMsg, $author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg, $author$project$Pages$Hinter$ClonePractice$LaunchDate, function($) {
                    return $.S0;
                });
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var practiceUsers = response.a;
                    var fields = $author$project$Utils$Form$fields(model.PU);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $author$project$Utils$Form$init(A2($author$project$Pages$Hinter$ClonePractice$formFieldsWithUsers, practiceUsers, fields)),
                        agh: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    agh: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Hinter$ClonePractice$Save = {
        $: 1
    };
    var $author$project$Pages$Hinter$ClonePractice$CloneCoupons = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$CloneEmbeddedReports = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$CloneFeatureFlags = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$CloneLeadSources = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$DealReportingOnly = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$Email = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$HubspotDealId = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$Onboarded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$PracticeUserChecked = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$ClonePractice$viewPracticeUser = function(practiceUserField) {
        return A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
            $author$project$Ui$Form$Checkbox$value(practiceUserField.hO),
            $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$PracticeUserChecked(practiceUserField.aef)))
        ]), _List_fromArray([
            $author$project$Utils$Html$noBreakSpace,
            $elm$html$Html$text(practiceUserField.OH + (' (' + (practiceUserField.ag_ + ')')))
        ]));
    };
    var $author$project$Pages$Hinter$ClonePractice$PracticeUserAllChecked = {
        $: 4
    };
    var $author$project$Pages$Hinter$ClonePractice$PracticeUserAllUnChecked = {
        $: 5
    };
    var $author$project$Pages$Hinter$ClonePractice$viewSelectAllButton = A2($author$project$Ui$Typography$div, _List_fromArray([
        $author$project$Ui$Typography$attrs(_List_fromArray([
            $elm$html$Html$Attributes$class('pt-1.5')
        ]))
    ]), _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Select all'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Pages$Hinter$ClonePractice$FormUpdated($author$project$Pages$Hinter$ClonePractice$PracticeUserAllChecked))
        ]), _List_fromArray([
            $elm$html$Html$text('Select All')
        ])),
        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text(' | ')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Unselect all'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Pages$Hinter$ClonePractice$FormUpdated($author$project$Pages$Hinter$ClonePractice$PracticeUserAllUnChecked))
        ]), _List_fromArray([
            $elm$html$Html$text('Unselect All')
        ]))
    ]));
    var $author$project$Pages$Hinter$ClonePractice$viewUsers = F2(function(practiceUsersData, practiceUserFields) {
        if (practiceUsersData.$ === 3) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Practice Users')
        ]), $elm$core$List$isEmpty(practiceUserFields) ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$padding(6)
            ]), _List_fromArray([
                $elm$html$Html$text('No users to clone')
            ]))
        ]) : A2($elm$core$List$cons, $author$project$Pages$Hinter$ClonePractice$viewSelectAllButton, A2($elm$core$List$map, $author$project$Pages$Hinter$ClonePractice$viewPracticeUser, practiceUserFields)));
        else return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Practice Users'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ]));
    });
    var $author$project$Pages$Hinter$ClonePractice$viewForm = F2(function(form, practiceUsers) {
        var fields = $author$project$Utils$Form$fields(form);
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Cloning from')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Practice$One$name(fields.FC))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Don\'t Require Payment Method')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.Vs),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$Onboarded))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Clone Embedded Reports')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.act),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneEmbeddedReports))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Clone Lead Sources')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.acv),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneLeadSources))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Clone Coupons')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.acs),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneCoupons))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Clone Feature Flags')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.acu),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$CloneFeatureFlags))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Business Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Business Email')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.OH)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$Email)),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Hubspot Deal ID')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.QT)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$HubspotDealId))
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('If Hubspot Deal ID is not provided then pricing will by cloned from the Practice.')
                ])),
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(fields.acT),
                    $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$ClonePractice$FormUpdated, $author$project$Pages$Hinter$ClonePractice$DealReportingOnly))
                ]), _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text('Deal ID is used for reporting only. Clone the pricing, do not import anything from Hubspot')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Launch Date'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Hinter$ClonePractice$LaunchDateDateInputMsg(fields.re), A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(fields.S0),
                    $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]), fields.re))
            ])),
            A2($author$project$Pages$Hinter$ClonePractice$viewUsers, practiceUsers, fields.agh)
        ]);
    });
    var $author$project$Pages$Hinter$ClonePractice$view = function(model) {
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$ClonePractice$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Clone Practice')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, A2($author$project$Pages$Hinter$ClonePractice$viewForm, model.PU, model.agh)),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Create practice'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Create')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Clone Practice'
        };
    };
    var $author$project$Pages$Hinter$ClonePractice$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Hinter$ClonePractice$init,
        aeR: $author$project$Pages$Hinter$ClonePractice$load,
        ag3: $author$project$Pages$Hinter$ClonePractice$save,
        ahE: $author$project$Pages$Hinter$ClonePractice$subscriptions,
        aaO: $author$project$Pages$Hinter$ClonePractice$update,
        aid: $author$project$Pages$Hinter$ClonePractice$view
    });
    var $author$project$Pages$Hinter$Disputes$StatusDropdownMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Hinter$Disputes$GotDisputes = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Platform$Dispute$All$Dispute = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Dispute$All$Record = F8(function(id, dueDate, amountInCents, status, reasonCode, reasonDescription, invoice, practice) {
        return {
            Jh: amountInCents,
            Ok: dueDate,
            aef: id,
            RA: invoice,
            W1: practice,
            Yc: reasonCode,
            Yd: reasonDescription,
            ahy: status
        };
    });
    var $author$project$Api$Platform$Dispute$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Platform$Practice$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reason_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reason_code', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Dispute$All$Record)))))))));
    var $author$project$Api$Platform$Dispute$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Dispute$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Dispute$disputesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'disputes'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$Dispute$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Platform$Dispute$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$Dispute$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Param$string('status'), $elm$core$List$singleton), options.ahy))
        ]));
    };
    var $author$project$Api$Platform$Dispute$list = F3(function(apiClient, query, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$Dispute$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$Dispute$listOptionsToParams(query), $author$project$Api$Data$requestTo($author$project$Api$Platform$Dispute$disputesPath)));
    });
    var $author$project$Pages$Hinter$Disputes$fetchDisputes = function(model) {
        return A3($author$project$Api$Platform$Dispute$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                ahs: model.ahs,
                ahy: model.ahy
            });
        }, $author$project$Pages$Hinter$Disputes$GotDisputes);
    };
    var $author$project$Pages$Hinter$Disputes$init = F3(function(_v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var query = _v2.Bz;
        var model = {
            Ej: apiClient,
            fB: $elm$core$Maybe$Nothing,
            b3: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$init,
            ahs: A3($author$project$Api$Sort$withDefault, 'due_date', 1, $author$project$Api$Sort$initFromQuery(query)),
            ahy: A2($elm$core$Dict$get, 'status', query),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'disputes-status-dropdown',
                ahX: $author$project$Pages$Hinter$Disputes$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, $author$project$Pages$Hinter$Disputes$fetchDisputes(model));
    });
    var $author$project$Pages$Hinter$Disputes$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$Disputes$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Hinter$Disputes$CloseDisputeModal = {
        $: 5
    };
    var $author$project$Pages$Hinter$Disputes$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$DisputeModal$subscriptions($author$project$Pages$Hinter$Disputes$CloseDisputeModal)), model.fB)),
            $author$project$Ui$Dropdown$subscriptions(model.oD)
        ]));
    };
    var $author$project$Pages$Hinter$Disputes$DisputeModalMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Platform$Dispute$All$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Pages$Hinter$Disputes$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('status'), model.ahy)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__Disputes)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Hinter$Disputes$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        b3: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    b3: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v2.a;
                var statusDropdownCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), statusDropdownCmd, _List_Nil);
            case 2:
                var selectedOption = msg.a;
                var newModel = _Utils_update(model, {
                    b3: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ahy: function() {
                        if (selectedOption.$ === 1) return $elm$core$Maybe$Nothing;
                        else {
                            var status = selectedOption.a;
                            return $elm$core$Maybe$Just(status);
                        }
                    }()
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
                    $author$project$Pages$Hinter$Disputes$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
                    $author$project$Pages$Hinter$Disputes$updateUrl(newModel)
                ])), _List_Nil);
            case 7:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Hinter$Disputes$fetchDisputes(newModel),
                    $author$project$Pages$Hinter$Disputes$updateUrl(newModel)
                ])), _List_Nil);
            case 4:
                var dispute = msg.a;
                var _v4 = A3($author$project$Components$DisputeModal$init, $author$project$Api$Data$platformPath, model.Ej, $author$project$Api$Platform$Dispute$All$id(dispute));
                var disputeModal = _v4.a;
                var disputeModalCmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    fB: $elm$core$Maybe$Just(disputeModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$Disputes$DisputeModalMsg, disputeModalCmd), _List_Nil);
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    fB: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v5 = model.fB;
                if (!_v5.$) {
                    var disputeModal = _v5.a;
                    var _v6 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
                    var newDisputeModal = _v6.a;
                    var disputeModalCmd = _v6.b;
                    var disputeModalOutMsgs = _v6.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fB: $elm$core$Maybe$Just(newDisputeModal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$Disputes$DisputeModalMsg, disputeModalCmd), disputeModalOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Hinter$Disputes$PaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Hinter$Disputes$SortTable = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Hinter$Disputes$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'practice', false, 'Practice'),
        A3($author$project$Api$Column$init, 'due_date', true, 'Due Date'),
        A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
        A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
        A3($author$project$Api$Column$init, 'reason_code', true, 'Reason Code'),
        A3($author$project$Api$Column$init, 'status', true, 'Status')
    ]);
    var $author$project$Pages$Hinter$Disputes$OpenDisputeModal = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Platform$Dispute$All$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Platform$Dispute$All$dueDate = function(_v0) {
        var record = _v0;
        return record.Ok;
    };
    var $author$project$Api$Platform$Dispute$All$invoice = function(_v0) {
        var record = _v0;
        return record.RA;
    };
    var $author$project$Api$Platform$Dispute$All$practice = function(_v0) {
        var record = _v0;
        return record.W1;
    };
    var $author$project$Api$Platform$Dispute$All$reasonCode = function(_v0) {
        var record = _v0;
        return record.Yc;
    };
    var $author$project$Api$Platform$Dispute$All$reasonDescription = function(_v0) {
        var record = _v0;
        return record.Yd;
    };
    var $author$project$Api$Platform$Dispute$All$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Pages$Hinter$Disputes$viewItem = function(dispute) {
        var invoice = $author$project$Api$Platform$Dispute$All$invoice(dispute);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Platform$Practice$Min$name($author$project$Api$Platform$Dispute$All$practice(dispute)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Platform$Dispute$All$dueDate(dispute)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Platform$Dispute$All$amountInCents(dispute)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Platform$Dispute$All$reasonDescription(dispute);
                    if (!_v0.$) {
                        var reasonDescription = _v0.a;
                        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
                            $author$project$Ui$Tooltip$placement(0)
                        ]), reasonDescription, _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Platform$Dispute$All$reasonCode(dispute))
                        ]));
                    } else return A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Platform$Dispute$All$reasonCode(dispute));
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Platform$Dispute$All$status(dispute))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight,
                $author$project$Ui$Table$colspan(2)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'View dispute'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Pages$Hinter$Disputes$OpenDisputeModal(dispute))
                ]), _List_fromArray([
                    $elm$html$Html$text('View Dispute')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Hinter$Disputes$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.b3;
            if (_v1.$ === 3) {
                var disputes_ = _v1.a;
                return _Utils_Tuple2(false, disputes_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var disputes = _v0.b;
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('There are no disputes.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Hinter$Disputes$SortTable)), $author$project$Pages$Hinter$Disputes$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Pages$Hinter$Disputes$viewItem, disputes), _List_Nil)
        ]);
    };
    var $author$project$Pages$Hinter$Disputes$None = {
        $: 1
    };
    var $author$project$Pages$Hinter$Disputes$Status = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Hinter$Disputes$StatusFiltered = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Hinter$Disputes$statusDropdownOptions = function(currentStatus) {
        var statusOptions = A2($elm$core$List$map, function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Hinter$Disputes$StatusFiltered($author$project$Pages$Hinter$Disputes$Status(status))),
                $author$project$Ui$Dropdown$selected(_Utils_eq($elm$core$Maybe$Just(status), currentStatus))
            ]), $elm$html$Html$text($author$project$Formatters$String$humanize(status)));
        }, _List_fromArray([
            'created',
            'action_required',
            'processing',
            'won',
            'lost'
        ]));
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Hinter$Disputes$StatusFiltered($author$project$Pages$Hinter$Disputes$None)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Filter')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
    };
    var $author$project$Pages$Hinter$Disputes$viewStatusDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'All Status', A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, model.ahy)))
        ]), $author$project$Pages$Hinter$Disputes$statusDropdownOptions(model.ahy), model.oD);
    };
    var $author$project$Pages$Hinter$Disputes$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$DisputeModal$view($author$project$Pages$Hinter$Disputes$CloseDisputeModal), model.fB)),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Disputes')
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(5),
                                $author$project$Ui$Grid$spanSm(3),
                                $author$project$Ui$Grid$spanMd(4)
                            ]), _List_fromArray([
                                $author$project$Pages$Hinter$Disputes$viewStatusDropdown(model)
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Hinter$Disputes$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Hinter$Disputes$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.b3))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Manage Disputes'
        };
    };
    var $author$project$Pages$Hinter$Disputes$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Hinter$Disputes$init,
        aeR: $author$project$Pages$Hinter$Disputes$load,
        ag3: $author$project$Pages$Hinter$Disputes$save,
        ahE: $author$project$Pages$Hinter$Disputes$subscriptions,
        aaO: $author$project$Pages$Hinter$Disputes$update,
        aid: $author$project$Pages$Hinter$Disputes$view
    });
    var $author$project$Pages$Hinter$FeatureFlags$GotFeatureFlags = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Platform$BulkFeature$bulkFeaturesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'bulk_features'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$BulkFeature$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$BulkFeature$bulkFeaturesPath));
    });
    var $author$project$Pages$Hinter$FeatureFlags$init = F3(function(_v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var model = {
            eX: $elm$core$Maybe$Nothing,
            Ej: apiClient,
            qH: $author$project$Api$Data$Loading,
            sG: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
            sH: ''
        };
        return _Utils_Tuple2(model, A2($author$project$Api$Platform$BulkFeature$list, apiClient, $author$project$Pages$Hinter$FeatureFlags$GotFeatureFlags));
    });
    var $author$project$Pages$Hinter$FeatureFlags$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$FeatureFlags$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Hinter$FeatureFlags$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Hinter$FeatureFlags$ActionCompleted = F3(function(a, b, c) {
        return {
            $: 5,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Pages$Hinter$FeatureFlags$DisableAll = 2;
    var $author$project$Pages$Hinter$FeatureFlags$EnableAll = 1;
    var $author$project$Pages$Hinter$FeatureFlags$EnableClinical = 0;
    var $author$project$Pages$Hinter$FeatureFlags$SearchInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Hinter$FeatureFlags$actionLabel = function(actionType) {
        switch(actionType){
            case 0:
                return 'Enable Clinical';
            case 1:
                return 'Enable All';
            default:
                return 'Disable All';
        }
    };
    var $author$project$Api$Platform$BulkFeature$bulkFeaturePath = function(featureName) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            featureName
        ]), $author$project$Api$Platform$BulkFeature$bulkFeaturesPath);
    };
    var $author$project$Api$Platform$BulkFeature$disableAll = F3(function(apiClient, featureName, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'disable_all'
        ]), $author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
    });
    var $author$project$Api$Platform$BulkFeature$enableAll = F3(function(apiClient, featureName, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enable_all'
        ]), $author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
    });
    var $author$project$Api$Platform$BulkFeature$enableClinical = F3(function(apiClient, featureName, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enable_clinical'
        ]), $author$project$Api$Platform$BulkFeature$bulkFeaturePath(featureName))));
    });
    var $author$project$Pages$Hinter$FeatureFlags$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    qH: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    qH: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var searchQuery = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return A2($elm$core$Maybe$withDefault, '', query);
                    } else return model.sH;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    sG: searchInput,
                    sH: searchQuery
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$FeatureFlags$SearchInputMsg, searchInputCmd), _List_Nil);
            case 2:
                var featureName = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    eX: $elm$core$Maybe$Just(_Utils_Tuple2(featureName, 0))
                }), A3($author$project$Api$Platform$BulkFeature$enableClinical, model.Ej, featureName, A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 0)), _List_Nil);
            case 3:
                var featureName = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    eX: $elm$core$Maybe$Just(_Utils_Tuple2(featureName, 1))
                }), A3($author$project$Api$Platform$BulkFeature$enableAll, model.Ej, featureName, A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 1)), _List_Nil);
            case 4:
                var featureName = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    eX: $elm$core$Maybe$Just(_Utils_Tuple2(featureName, 2))
                }), A3($author$project$Api$Platform$BulkFeature$disableAll, model.Ej, featureName, A2($author$project$Pages$Hinter$FeatureFlags$ActionCompleted, featureName, 2)), _List_Nil);
            default:
                var featureName = msg.a;
                var actionType = msg.b;
                var response = msg.c;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    eX: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, $author$project$Pages$Hinter$FeatureFlags$actionLabel(actionType) + (' job enqueued for ' + featureName))
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    eX: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Ui$SearchInput$Immediate = {
        $: 5
    };
    var $author$project$Ui$SearchInput$immediate = $author$project$Ui$SearchInput$Immediate;
    var $author$project$Pages$Hinter$FeatureFlags$ClickDisableAll = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Hinter$FeatureFlags$ClickEnableAll = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Hinter$FeatureFlags$ClickEnableClinical = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Hinter$FeatureFlags$viewFeatureFlag = F2(function(actionInProgress, featureName) {
        var isLoading = function(actionType) {
            if (!actionInProgress.$) {
                var _v1 = actionInProgress.a;
                var name = _v1.a;
                var at = _v1.b;
                return _Utils_eq(name, featureName) && _Utils_eq(at, actionType);
            } else return false;
        };
        var anyLoading = !_Utils_eq(actionInProgress, $elm$core$Maybe$Nothing);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(featureName)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Enable ' + (featureName + ' for clinical practices')
                }, _List_fromArray([
                    $author$project$Ui$Button$success,
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Pages$Hinter$FeatureFlags$ClickEnableClinical(featureName)),
                    $author$project$Ui$Button$loading(isLoading(0)),
                    $author$project$Ui$Button$disabled(anyLoading)
                ]), _List_fromArray([
                    $elm$html$Html$text('Clinical')
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Enable ' + (featureName + ' for all practices')
                }, _List_fromArray([
                    $author$project$Ui$Button$default,
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Pages$Hinter$FeatureFlags$ClickEnableAll(featureName)),
                    $author$project$Ui$Button$loading(isLoading(1)),
                    $author$project$Ui$Button$disabled(anyLoading)
                ]), _List_fromArray([
                    $elm$html$Html$text('All')
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Disable ' + (featureName + ' for all practices')
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Pages$Hinter$FeatureFlags$ClickDisableAll(featureName)),
                    $author$project$Ui$Button$loading(isLoading(2)),
                    $author$project$Ui$Button$disabled(anyLoading)
                ]), _List_fromArray([
                    $elm$html$Html$text('Disable')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Hinter$FeatureFlags$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.qH;
            if (_v1.$ === 3) {
                var flags_ = _v1.a;
                return _Utils_Tuple2(false, flags_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var flags = _v0.b;
        var filteredFlags = $elm$core$String$isEmpty(model.sH) ? flags : A2($elm$core$List$filter, A2($elm$core$Basics$composeL, $elm$core$String$contains($elm$core$String$toLower(model.sH)), $elm$core$String$toLower), flags);
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('No feature flags found.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Flag Name')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Enable Clinical')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Enable All')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Disable All')
            ]))
        ]), A2($elm$core$List$map, $author$project$Pages$Hinter$FeatureFlags$viewFeatureFlag(model.eX), filteredFlags), _List_Nil);
    };
    var $author$project$Pages$Hinter$FeatureFlags$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                            $elm$html$Html$text('Feature Flags')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Organizations__Top, _List_Nil, _List_fromArray([
                                $author$project$Ui$Icon$cross(_List_Nil)
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_fromArray([
                            $author$project$Ui$Grid$mt2
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(12)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Hinter$FeatureFlags$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                                        $author$project$Ui$SearchInput$placeholder('Search feature flags...'),
                                        $author$project$Ui$SearchInput$immediate
                                    ]), model.sG))
                                ]))
                            ]))
                        ]))
                    ])),
                    $author$project$Pages$Hinter$FeatureFlags$viewPanelBody(model)
                ]))
            ]),
            $2: 'Admin | Feature Flags'
        };
    };
    var $author$project$Pages$Hinter$FeatureFlags$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Hinter$FeatureFlags$init,
        aeR: $author$project$Pages$Hinter$FeatureFlags$load,
        ag3: $author$project$Pages$Hinter$FeatureFlags$save,
        ahE: $author$project$Pages$Hinter$FeatureFlags$subscriptions,
        aaO: $author$project$Pages$Hinter$FeatureFlags$update,
        aid: $author$project$Pages$Hinter$FeatureFlags$view
    });
    var $author$project$Pages$Hinter$NewGroup$init = F3(function(_v0, shared, _v1) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            zr: '',
            na: $elm$core$Maybe$Nothing,
            j_: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$NewGroup$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$NewGroup$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Hinter$NewGroup$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Hinter$NewGroup$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$ManagementGroup$create = F3(function(apiClient, name_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('management_group', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(name_))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$ManagementGroup$Shared$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ManagementGroup$resourcePath)));
    });
    var $author$project$Pages$Hinter$NewGroup$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var name = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    zr: name,
                    na: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var trimmedName = $elm$core$String$trim(model.zr);
                return $elm$core$String$isEmpty(trimmedName) ? _Utils_Tuple3(_Utils_update(model, {
                    na: $elm$core$Maybe$Just('Name is required')
                }), $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$ManagementGroup$create, model.Ej, trimmedName, $author$project$Pages$Hinter$NewGroup$Created), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var group = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Organizations__Top), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Group \"' + ($author$project$Api$Provider$ManagementGroup$Shared$name(group) + '\" created'))
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Hinter$NewGroup$Save = {
        $: 1
    };
    var $author$project$Pages$Hinter$NewGroup$UpdateName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewGroup$view = function(model) {
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewGroup$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Create New Group')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Name'),
                                $author$project$Ui$Form$Group$required(true)
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value(model.zr),
                                    $author$project$Ui$Form$Input$onInput($author$project$Pages$Hinter$NewGroup$UpdateName),
                                    $author$project$Ui$Form$Input$placeholder('Enter group name'),
                                    $author$project$Ui$Form$Input$disabled(loading),
                                    $author$project$Ui$Form$Input$invalid(!_Utils_eq(model.na, $elm$core$Maybe$Nothing)),
                                    $author$project$Ui$Form$Input$errors(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$singleton, model.na)))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter,
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Organizations__Top, _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Create new group'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Create')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Group Setup'
        };
    };
    var $author$project$Pages$Hinter$NewGroup$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Hinter$NewGroup$init,
        aeR: $author$project$Pages$Hinter$NewGroup$load,
        ag3: $author$project$Pages$Hinter$NewGroup$save,
        ahE: $author$project$Pages$Hinter$NewGroup$subscriptions,
        aaO: $author$project$Pages$Hinter$NewGroup$update,
        aid: $author$project$Pages$Hinter$NewGroup$view
    });
    var $author$project$Pages$Hinter$NewPartner$FormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Hinter$NewPartnerForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$Hinter$NewPartnerForm$FormUpdated = $elm$core$Basics$identity;
    var $author$project$Components$Hinter$NewPartnerForm$ManagedBy = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeManagementGroup = 2;
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeNone = 0;
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypePractice = 1;
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$User$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$User$Practice$list = $author$project$Api$Platform$User$Practice$list;
    var $author$project$Components$ResourceFilter$User$Practice$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A4($author$project$Components$ResourceFilter$User$Practice$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, $elm$core$Maybe$Nothing, toMsg);
    });
    var $author$project$Components$ResourceFilter$User$Practice$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A4($author$project$Components$ResourceFilter$User$Practice$list, apiClient, function(d) {
            return _Utils_update(d, {
                agq: $elm$core$Maybe$Just(id)
            });
        }, $elm$core$Maybe$Nothing, toMsg);
    });
    var $author$project$Components$ResourceFilter$User$Practice$selectId = 'practices';
    var $author$project$Components$ResourceFilter$User$Practice$toTitle = $author$project$Api$Platform$Practice$All$name;
    var $author$project$Components$ResourceFilter$User$Practice$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$User$Practice$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$User$Practice$toValue = $author$project$Api$Platform$Practice$All$id;
    var $author$project$Components$ResourceFilter$User$Practice$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$User$Practice$fetchResources,
            aef: $author$project$Components$ResourceFilter$User$Practice$selectId,
            gD: 'Practices',
            sz: $author$project$Components$ResourceFilter$User$Practice$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$User$Practice$toLabel,
            ahZ: $author$project$Components$ResourceFilter$User$Practice$toTitle,
            g4: $author$project$Components$ResourceFilter$User$Practice$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$init = F2(function(apiClient, maybeInitialValue) {
        var managedByType = function() {
            if (maybeInitialValue.$ === 1) return 0;
            else {
                if (!maybeInitialValue.a.$) return 1;
                else return 2;
            }
        }();
        var _v0 = A2($author$project$Components$ResourceFilter$User$Practice$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Practice'
            });
        });
        var practiceResourceFilter = _v0.a;
        var practiceResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            f7: managedByType,
            jC: practiceResourceFilter
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg, practiceResourceFilterCmd));
    });
    var $author$project$Components$Hinter$NewPartnerForm$initFormFields = function(apiClient) {
        var _v0 = A2($author$project$Components$Partner$AdminSettings$ManagedByInput$init, apiClient, $elm$core$Maybe$Nothing);
        var managedByInput = _v0.a;
        var managedByInputCmd = _v0.b;
        return _Utils_Tuple2({
            Ir: false,
            JO: 'manual',
            MM: $elm$core$Maybe$Nothing,
            OH: $elm$core$Maybe$Nothing,
            Ro: $elm$core$Maybe$Nothing,
            Ti: _List_Nil,
            Ge: 0,
            Tu: $elm$core$Maybe$Nothing,
            ja: managedByInput,
            TH: $elm$core$Maybe$Nothing,
            TO: $elm$core$Maybe$Nothing,
            zr: '',
            W9: false,
            Xz: $elm$core$Maybe$Nothing,
            Yo: $elm$core$Maybe$Nothing,
            Zo: false,
            _u: $elm$core$Maybe$Nothing,
            _A: $elm$core$Maybe$Nothing,
            ahy: 'beta',
            $y: $elm$core$Maybe$Nothing,
            $U: $elm$core$Maybe$Nothing,
            aa2: true,
            hh: false,
            abk: false,
            abl: false
        }, A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy), managedByInputCmd));
    };
    var $author$project$Components$Hinter$NewPartnerForm$init = function(apiClient) {
        var _v0 = $author$project$Components$Hinter$NewPartnerForm$initFormFields(apiClient);
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init(formFields)
        }, formFieldsCmd);
    };
    var $author$project$Pages$Hinter$NewPartner$init = F3(function(_v0, shared, _v1) {
        var _v2 = $author$project$Components$Hinter$NewPartnerForm$init(shared.Ej);
        var form = _v2.a;
        var formCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form,
            j_: $author$project$Api$Data$NotAsked
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPartner$FormMsg, formCmd));
    });
    var $author$project$Pages$Hinter$NewPartner$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$NewPartner$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$ResourceFilter$User$Practice$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions = function(_v0) {
        var model = _v0;
        return A2($elm$core$Platform$Sub$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg, $author$project$Components$ResourceFilter$User$Practice$subscriptions(model.jC));
    };
    var $author$project$Components$Hinter$NewPartnerForm$subscriptions = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy), $author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions(fields.ja));
    };
    var $author$project$Pages$Hinter$NewPartner$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Hinter$NewPartner$FormMsg, $author$project$Components$Hinter$NewPartnerForm$subscriptions(model.PU));
    };
    var $author$project$Pages$Hinter$NewPartner$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Partner$BaaType$toString = function(baaType) {
        if (!baaType) return 'contractor';
        else return 'independent';
    };
    var $author$project$Api$Partner$BaaType$encode = A2($elm$core$Basics$composeR, $author$project$Api$Partner$BaaType$toString, $elm$json$Json$Encode$string);
    var $author$project$Api$Partner$Partner$encodeProductOverviewField = function(field) {
        return _Utils_Tuple2('product_overview', $elm$json$Json$Encode$object(_List_fromArray([
            field
        ])));
    };
    var $author$project$Api$Partner$Partner$encodePermittedFields = function(permittedFields) {
        var encodedFields = A3($elm$core$List$foldl, F2(function(field, acc) {
            switch(field.$){
                case 0:
                    var name = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(name)), acc);
                case 1:
                    var slug = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('slug', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, slug)), acc);
                case 2:
                    var maybeUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('website_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)), acc);
                case 3:
                    var maybeUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('marketing_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)), acc);
                case 4:
                    var maybeUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('signup_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)), acc);
                case 5:
                    var maybeUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('support_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)), acc);
                case 6:
                    var maybeUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('redirect_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)), acc);
                case 8:
                    var maybeDesc = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('product_description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeDesc)), acc);
                case 9:
                    var maybeDesc = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('integration_description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeDesc)), acc);
                case 10:
                    var addressParts = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('address', $elm$json$Json$Encode$object(addressParts)), acc);
                case 11:
                    var authType = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('auth_type', $elm$json$Json$Encode$string(authType)), acc);
                case 12:
                    var maybeEmail = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeEmail)), acc);
                case 13:
                    var email = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('technical_email', $elm$json$Json$Encode$string(email)), acc);
                case 14:
                    var uses = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('uses_integration_records', $elm$json$Json$Encode$bool(uses)), acc);
                case 15:
                    var active = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('active', $elm$json$Json$Encode$bool(active)), acc);
                case 16:
                    var disabled = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('webhooks_disabled', $elm$json$Json$Encode$bool(disabled)), acc);
                case 17:
                    var paused = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('webhooks_paused', $elm$json$Json$Encode$bool(paused)), acc);
                case 18:
                    var unmute = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('unmute_self_webhooks', $elm$json$Json$Encode$bool(unmute)), acc);
                case 19:
                    var maybeMax = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('max_requests_per_minute', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, maybeMax)), acc);
                case 20:
                    var readOnly = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('practices_read_only', $elm$json$Json$Encode$bool(readOnly)), acc);
                case 21:
                    var logo = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('logo', $elm$json$Json$Encode$string(logo)), acc);
                case 22:
                    var events = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('listened_events', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, events)), acc);
                case 23:
                    var status = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('status', $elm$json$Json$Encode$string(status)), acc);
                case 24:
                    var sandboxEnabled = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('sandbox_enabled', $elm$json$Json$Encode$bool(sandboxEnabled)), acc);
                case 7:
                    var maybeUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('post_activation_redirect_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)), acc);
                case 25:
                    var maybeDesc = field.a;
                    return A2($elm$core$List$cons, $author$project$Api$Partner$Partner$encodeProductOverviewField(_Utils_Tuple2('description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeDesc))), acc);
                case 26:
                    var images = field.a;
                    return A2($elm$core$List$cons, $author$project$Api$Partner$Partner$encodeProductOverviewField(_Utils_Tuple2('images', A2($elm$json$Json$Encode$list, function(image) {
                        if (!image.$) {
                            var url = image.a;
                            return $elm$json$Json$Encode$object(_List_fromArray([
                                _Utils_Tuple2('url', $elm$json$Json$Encode$string(url))
                            ]));
                        } else {
                            var id = image.a.aef;
                            var alt = image.a.Jg;
                            return $elm$json$Json$Encode$object(_List_fromArray([
                                _Utils_Tuple2('id', $elm$json$Json$Encode$string(id)),
                                _Utils_Tuple2('alt', $elm$json$Json$Encode$string(alt))
                            ]));
                        }
                    }, images))), acc);
                case 27:
                    var maybeManagedBy = field.a;
                    var managedBy = A2($elm$core$Maybe$map, function(managedBy_) {
                        if (!managedBy_.$) {
                            var id = managedBy_.a;
                            return {
                                aef: $elm$core$Maybe$Just(id),
                                ah5: $elm$core$Maybe$Just('Practice')
                            };
                        } else {
                            var id = managedBy_.a;
                            return {
                                aef: $elm$core$Maybe$Just(id),
                                ah5: $elm$core$Maybe$Just('ManagementGroup')
                            };
                        }
                    }, maybeManagedBy);
                    return A2($elm$core$List$cons, _Utils_Tuple2('managed_by', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$typedAssociation, managedBy)), acc);
                case 28:
                    var partnerAgreementAccepted = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('partner_agreement_accepted', $elm$json$Json$Encode$bool(partnerAgreementAccepted)), acc);
                case 29:
                    var addendumAgreementAccepted = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('addendum_agreement_accepted', $elm$json$Json$Encode$bool(addendumAgreementAccepted)), acc);
                case 30:
                    var file = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('custom_partner_agreement', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)), acc);
                case 31:
                    var file = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('addendum_agreement', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)), acc);
                case 32:
                    var file = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('custom_api_access_agreement', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)), acc);
                case 33:
                    var file = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('custom_baa_agreement', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, file)), acc);
                case 34:
                    var baaType = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('baa_type', A2($author$project$Utils$Encode$nullable, $author$project$Api$Partner$BaaType$encode, baaType)), acc);
                case 35:
                    var baaAgreementAccepted = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('baa_agreement_accepted', $elm$json$Json$Encode$bool(baaAgreementAccepted)), acc);
                default:
                    var apiAccessAgreementAccepted = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('api_access_agreement_accepted', $elm$json$Json$Encode$bool(apiAccessAgreementAccepted)), acc);
            }
        }), _List_Nil, permittedFields);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner', $elm$json$Json$Encode$object(encodedFields))
        ]));
    };
    var $author$project$Api$Partner$Partner$create = F3(function(apiClient, permittedFields, toMsg) {
        var body = $author$project$Api$Partner$Partner$encodePermittedFields(permittedFields);
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Partner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
    });
    var $author$project$Pages$Hinter$NewPartner$createPartner = F2(function(apiClient, permittedFields) {
        return A3($author$project$Api$Partner$Partner$create, apiClient, permittedFields, $author$project$Pages$Hinter$NewPartner$Created);
    });
    var $author$project$Api$Partner$Partner$Shared$organizationId = function(_v0) {
        var record = _v0;
        return record.afV;
    };
    var $author$project$Api$Partner$Partner$One$organizationId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$organizationId(shared);
    };
    var $author$project$Components$ResourceFilter$User$Practice$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$ && !_v1.a.$) {
                var selected = _v1.a.a;
                return _Utils_update(model, {
                    Hg: selected
                });
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var subMsg = msg.a;
            var practiceResourceResult = A3($author$project$Components$ResourceFilter$User$Practice$update, apiClient, subMsg, model.jC);
            return _Utils_Tuple3(_Utils_update(model, {
                jC: practiceResourceResult.zi
            }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg, practiceResourceResult.EQ), practiceResourceResult.at);
        } else {
            var managedByType = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                f7: managedByType
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Hinter$NewPartnerForm$formFieldsUpdate = F3(function(apiClient, field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    zr: string
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    _A: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var bool = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    Zo: bool
                }), $elm$core$Platform$Cmd$none);
            default:
                var subMsg = field.a;
                var _v1 = A3($author$project$Components$Partner$AdminSettings$ManagedByInput$update, apiClient, subMsg, fields.ja);
                var managedByInput = _v1.a;
                var managedByInputCmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(fields, {
                    ja: managedByInput
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy), managedByInputCmd));
        }
    });
    var $author$project$Components$Hinter$NewPartnerForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        var field = msg;
        var _v2 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Hinter$NewPartnerForm$formFieldsUpdate(apiClient), field, model.PU);
        var newForm = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), cmd, _List_Nil);
    });
    var $author$project$Components$Hinter$NewPartnerForm$EmailValidation = 6;
    var $author$project$Components$Hinter$NewPartnerForm$LogoValidation = 5;
    var $author$project$Components$Hinter$NewPartnerForm$MarketingUrlValidation = 1;
    var $author$project$Components$Hinter$NewPartnerForm$NameValidation = 0;
    var $author$project$Components$Hinter$NewPartnerForm$RedirectUrlValidation = 4;
    var $author$project$Components$Hinter$NewPartnerForm$SignupUrlValidation = 2;
    var $author$project$Components$Hinter$NewPartnerForm$SupportUrlValidation = 3;
    var $author$project$Components$Hinter$NewPartnerForm$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Hinter$NewPartnerForm$validateUrl = F3(function(getter, validationGroup, fields) {
        var _v0 = getter(fields);
        if (_v0.$ === 1) return _List_Nil;
        else {
            var url = _v0.a;
            return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray([
                _Utils_Tuple2(validationGroup, 'URL must start with http:// or https://')
            ]) : _List_Nil;
        }
    });
    var $author$project$Components$Hinter$NewPartnerForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.')),
        A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
            return $.Ge;
        }, $author$project$Components$Hinter$NewPartnerForm$maxLogoBytesSize, _Utils_Tuple2(5, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
        $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Hinter$NewPartnerForm$validateUrl, function($) {
            return $.TH;
        }, 1)),
        $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Hinter$NewPartnerForm$validateUrl, function($) {
            return $._u;
        }, 2)),
        $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Hinter$NewPartnerForm$validateUrl, function($) {
            return $.$y;
        }, 3)),
        $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Hinter$NewPartnerForm$validateUrl, function($) {
            return $.Yo;
        }, 4)),
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: true
        }, function($) {
            return $.OH;
        }, _Utils_Tuple2(6, 'Please enter a valid email'))
    ]));
    var $author$project$Api$Partner$Partner$Active = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$AuthType = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$Email = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$IntegrationDescription = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ListenedEvents = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$Logo = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ManagedBy = function(a) {
        return {
            $: 27,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ManagedByManagementGroup = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ManagedByPractice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$MarketingUrl = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$MaxRequestPerMinute = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$PracticesReadOnly = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ProductDescription = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$RedirectUrl = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$SandboxEnabled = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$SignupUrl = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$Slug = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$Status = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$SupportUrl = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$TechnicalEmail = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$UsesIntegrationRecords = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$WebhooksDisabled = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$WebhooksPaused = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$User$Practice$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$value = function(_v0) {
        var model = _v0;
        var _v1 = model.f7;
        switch(_v1){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                return A2($elm$core$Maybe$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice, $author$project$Components$ResourceFilter$User$Practice$value(model.jC));
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Hinter$NewPartnerForm$toPermittedFields = function(fields) {
        var managedByField = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, A2($elm$core$Basics$composeR, $author$project$Api$Partner$Partner$ManagedBy, $elm$core$List$singleton)), A2($elm$core$Maybe$map, function(v) {
            if (!v.$) {
                var practiceId = v.a;
                return $author$project$Api$Partner$Partner$ManagedByPractice(practiceId);
            } else {
                var managementGroupId = v.a;
                return $author$project$Api$Partner$Partner$ManagedByManagementGroup(managementGroupId);
            }
        }, $author$project$Components$Partner$AdminSettings$ManagedByInput$value(fields.ja))));
        return A2($elm$core$List$cons, $author$project$Api$Partner$Partner$Name(fields.zr), _Utils_ap(function() {
            var _v0 = fields._A;
            if (!_v0.$) {
                var slug = _v0.a;
                return _List_fromArray([
                    $author$project$Api$Partner$Partner$Slug($elm$core$Maybe$Just(slug))
                ]);
            } else return _List_Nil;
        }(), _Utils_ap(function() {
            var _v1 = fields.Tu;
            if (!_v1.$) {
                var logoUrl = _v1.a;
                return _List_fromArray([
                    $author$project$Api$Partner$Partner$Logo(logoUrl)
                ]);
            } else return _List_Nil;
        }(), _Utils_ap(managedByField, _List_fromArray([
            $author$project$Api$Partner$Partner$Status(fields.ahy),
            $author$project$Api$Partner$Partner$MarketingUrl(fields.TH),
            $author$project$Api$Partner$Partner$SignupUrl(fields._u),
            $author$project$Api$Partner$Partner$SupportUrl(fields.$y),
            $author$project$Api$Partner$Partner$RedirectUrl(fields.Yo),
            $author$project$Api$Partner$Partner$ProductDescription(fields.Xz),
            $author$project$Api$Partner$Partner$IntegrationDescription(fields.Ro),
            $author$project$Api$Partner$Partner$AuthType(fields.JO),
            $author$project$Api$Partner$Partner$Email(fields.OH),
            $author$project$Api$Partner$Partner$TechnicalEmail(A2($elm$core$Maybe$withDefault, '', fields.$U)),
            $author$project$Api$Partner$Partner$UsesIntegrationRecords(fields.aa2),
            $author$project$Api$Partner$Partner$Active(fields.Ir),
            $author$project$Api$Partner$Partner$WebhooksDisabled(fields.abk),
            $author$project$Api$Partner$Partner$WebhooksPaused(fields.abl),
            $author$project$Api$Partner$Partner$ListenedEvents(fields.Ti),
            $author$project$Api$Partner$Partner$PracticesReadOnly(fields.W9),
            $author$project$Api$Partner$Partner$MaxRequestPerMinute(fields.TO),
            $author$project$Api$Partner$Partner$SandboxEnabled(fields.Zo)
        ])))));
    };
    var $author$project$Components$Hinter$NewPartnerForm$validate = function(_v0) {
        var model = _v0;
        var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$NewPartnerForm$formFieldsValidator, model.PU);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var validFormFields = _v2.b;
            var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
            return $elm$core$Result$Ok($author$project$Components$Hinter$NewPartnerForm$toPermittedFields(fields));
        } else {
            var validatedForm = _v1.a;
            return $elm$core$Result$Err(_Utils_update(model, {
                PU: validatedForm
            }));
        }
    };
    var $author$project$Pages$Hinter$NewPartner$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$Hinter$NewPartnerForm$update, model.Ej, subMsg, model.PU);
                var form = _v1.a;
                var cmd = _v1.b;
                var outMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: form
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPartner$FormMsg, cmd), outMsgs);
            case 1:
                var _v2 = $author$project$Components$Hinter$NewPartnerForm$validate(model.PU);
                if (!_v2.$) {
                    var permittedFields = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Hinter$NewPartner$createPartner, model.Ej, permittedFields), _List_Nil);
                } else {
                    var updatedForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: updatedForm,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var partner = response.a;
                    var _v4 = _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
                        A3($author$project$OutMsg$SwitchToOrganization, $author$project$Api$Partner$Partner$One$organizationId(partner), $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Partner__Dashboard__Top))
                    ]));
                    var cmd = _v4.a;
                    var outMsgs = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), cmd, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 3, 'Partner created'), outMsgs));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Hinter$NewPartner$Save = {
        $: 1
    };
    var $author$project$Components$Hinter$NewPartnerForm$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Hinter$NewPartnerForm$SandboxEnabled = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Hinter$NewPartnerForm$Slug = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton = F3(function(currentManagedByType, managedByType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentManagedByType, managedByType)),
            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByTypeSelected(managedByType))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$ResourceFilter$User$Practice$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$view = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Managed By Type')
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.f7, 0, 'None'),
                    A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.f7, 1, 'Practice'),
                    A3($author$project$Components$Partner$AdminSettings$ManagedByInput$viewManagedByTypeButton, model.f7, 2, 'Management Group')
                ]))
            ])),
            function() {
                var _v1 = model.f7;
                switch(_v1){
                    case 0:
                        return $author$project$Utils$Html$empty;
                    case 1:
                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true),
                            $author$project$Ui$Form$Group$label('Practice')
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Partner$AdminSettings$ManagedByInput$PracticeResourceFilterMsg, A2($author$project$Components$ResourceFilter$User$Practice$viewNew, _List_Nil, model.jC))
                        ]));
                    default:
                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true),
                            $author$project$Ui$Form$Group$label('Management Group')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Not implemented')
                            ]))
                        ]));
                }
            }()
        ]));
    };
    var $author$project$Components$Hinter$NewPartnerForm$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Name'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.zr),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$Name)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Slug')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields._A)),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$Slug))
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt4,
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$ManagedBy), $author$project$Components$Partner$AdminSettings$ManagedByInput$view(fields.ja))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Sandbox Enabled')
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$on(fields.Zo),
                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$Hinter$NewPartnerForm$SandboxEnabled))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Hinter$NewPartner$view = function(model) {
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewPartner$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Create New Partner')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Hinter$NewPartner$FormMsg, $author$project$Components$Hinter$NewPartnerForm$view(model.PU))
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Create new partner'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Create')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Partner Setup'
        };
    };
    var $author$project$Pages$Hinter$NewPartner$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Hinter$NewPartner$init,
        aeR: $author$project$Pages$Hinter$NewPartner$load,
        ag3: $author$project$Pages$Hinter$NewPartner$save,
        ahE: $author$project$Pages$Hinter$NewPartner$subscriptions,
        aaO: $author$project$Pages$Hinter$NewPartner$update,
        aid: $author$project$Pages$Hinter$NewPartner$view
    });
    var $author$project$Pages$Hinter$NewPractice$AddressInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$NewPractice$initPhoneInput = A3($author$project$Components$PhoneInput$init, 'new-practice-phone-input', _List_Nil, function(d) {
        return _Utils_update(d, {
            Iz: true,
            abK: false,
            ac_: $author$project$Api$Common$Phone$Shared$Office,
            y_: 1,
            agM: false
        });
    });
    var $author$project$Pages$Hinter$NewPractice$initFormFields = F2(function(origin, defaultHubspotDeal) {
        var _v0 = $author$project$Components$DateInput$init;
        var launchDateDateInput = _v0.a;
        var launchDateDateInputCmd = _v0.b;
        var _v1 = $author$project$Components$AddressInput$init('new-practice');
        var addressInput = _v1.a;
        var addressInputCmd = _v1.b;
        return _Utils_Tuple2({
            In: 0,
            II: A2($author$project$Components$AddressInput$withHiddenCountry, true, A2($author$project$Components$AddressInput$withRequired, true, addressInput)),
            abX: origin + '/join/',
            MM: $elm$core$Maybe$Nothing,
            Oy: $elm$core$Maybe$Nothing,
            OH: $elm$core$Maybe$Nothing,
            adt: $elm$core$Maybe$Nothing,
            ad9: $elm$core$Maybe$Just('rainforest'),
            QT: defaultHubspotDeal,
            aex: $elm$core$Maybe$Nothing,
            S0: $elm$core$Maybe$Nothing,
            re: launchDateDateInput,
            Ge: 0,
            Tu: $elm$core$Maybe$Nothing,
            zr: '',
            Vs: false,
            GE: false,
            Wo: $elm$core$Maybe$Just('rainforest'),
            WE: $author$project$Pages$Hinter$NewPractice$initPhoneInput,
            agp: true,
            ag1: $elm$core$Maybe$Nothing,
            ahb: $elm$core$Maybe$Nothing,
            ahf: true,
            ahC: $elm$core$Maybe$Nothing,
            aaT: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg(launchDateDateInput), launchDateDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$AddressInputMsg, addressInputCmd)
        ])));
    });
    var $author$project$Pages$Hinter$NewPractice$init = F3(function(_v0, shared, _v1) {
        var _v2 = A2($author$project$Pages$Hinter$NewPractice$initFormFields, shared.adU.afY, shared.adU.acY);
        var formFields = _v2.a;
        var formFieldsCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            cP: shared.cP,
            PU: $author$project$Utils$Form$init(formFields),
            j_: $author$project$Api$Data$NotAsked
        }, formFieldsCmd);
    });
    var $author$project$Pages$Hinter$NewPractice$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            cP: shared.cP
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Hinter$NewPractice$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Hinter$NewPractice$PhoneInputMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$subscriptions = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var phone = _v0.WE;
        var address = _v0.II;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Hinter$NewPractice$AddressInputMsg, $author$project$Components$AddressInput$subscriptions(address)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Hinter$NewPractice$PhoneInputMsg, $author$project$Components$PhoneInput$subscriptions(phone))
        ]));
    };
    var $author$project$Pages$Hinter$NewPractice$Address = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$LaunchDate = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$NewPractice$Logo = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Hinter$NewPractice$Phone = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$AccountType$toString = function(accountType) {
        switch(accountType){
            case 0:
                return 'standard';
            case 1:
                return 'affiliate';
            default:
                return 'mce';
        }
    };
    var $author$project$Api$AccountType$encode = A2($elm$core$Basics$composeR, $author$project$Api$AccountType$toString, $elm$json$Json$Encode$string);
    var $author$project$Api$Provider$Practice$create = F3(function(apiClient, fields, toMsg) {
        var phones_ = A2($elm$json$Json$Encode$list, function(phone) {
            return $author$project$Api$Common$Phone$Shared$encode(phone);
        }, fields.WG);
        var logo_ = function() {
            var _v0 = fields.Tt;
            if (!_v0.$) {
                var base64 = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('logo', $elm$json$Json$Encode$string(base64))
                ]);
            } else return _List_Nil;
        }();
        var address_ = $author$project$Api$Common$Address$Shared$encode(fields.II);
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('account_type', $author$project$Api$AccountType$encode(fields.In)), A2($elm$core$List$cons, _Utils_Tuple2('sales_owner', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ag1)), A2($elm$core$List$cons, _Utils_Tuple2('primary_care', $elm$json$Json$Encode$bool(fields.agp)), A2($elm$core$List$cons, _Utils_Tuple2('segment', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahb)), A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)), A2($elm$core$List$cons, _Utils_Tuple2('url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aaT)), A2($elm$core$List$cons, _Utils_Tuple2('email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.OH)), A2($elm$core$List$cons, _Utils_Tuple2('ein', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oy)), A2($elm$core$List$cons, _Utils_Tuple2('address', address_), A2($elm$core$List$cons, _Utils_Tuple2('phones', phones_), A2($elm$core$List$cons, _Utils_Tuple2('estimated_memberships_count', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.adt)), A2($elm$core$List$cons, _Utils_Tuple2('launch_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.S0)), A2($elm$core$List$cons, _Utils_Tuple2('hubspot_deal_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.QT)), A2($elm$core$List$cons, _Utils_Tuple2('payment_processor', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Wo)), A2($elm$core$List$cons, _Utils_Tuple2('hint_customer_payment_processor', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ad9)), A2($elm$core$List$cons, _Utils_Tuple2('stripe_platform_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ahC)), A2($elm$core$List$cons, _Utils_Tuple2('invitation_email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aex)), A2($elm$core$List$cons, _Utils_Tuple2('send_invitation', $elm$json$Json$Encode$bool(fields.ahf)), A2($elm$core$List$cons, _Utils_Tuple2('ein', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Oy)), A2($elm$core$List$cons, _Utils_Tuple2('invitation_base_url', $elm$json$Json$Encode$string(fields.aew)), A2($elm$core$List$cons, _Utils_Tuple2('onboarded', $elm$json$Json$Encode$bool(fields.Vs)), logo_)))))))))))))))))))))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Hinter$NewPractice$practiceFormFields = function(fields) {
        var phones = A2($elm$core$List$map, $author$project$Utils$Phone$toRecord, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Components$PhoneInput$getPhones(fields.WE)));
        var address = $author$project$Components$AddressInput$getAddress(fields.II);
        return {
            In: fields.In,
            II: address,
            Oy: fields.Oy,
            OH: fields.OH,
            adt: fields.adt,
            ad9: fields.ad9,
            QT: fields.QT,
            aew: fields.abX,
            aex: fields.aex,
            S0: fields.S0,
            Tt: fields.Tu,
            zr: fields.zr,
            Vs: fields.Vs,
            Wo: fields.Wo,
            WG: phones,
            agp: fields.agp,
            ag1: fields.ag1,
            ahb: fields.ahb,
            ahf: fields.ahf,
            ahC: fields.ahC,
            aaT: fields.aaT
        };
    };
    var $author$project$Pages$Hinter$NewPractice$createPractice = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Practice$create, apiClient, $author$project$Pages$Hinter$NewPractice$practiceFormFields(fields), $author$project$Pages$Hinter$NewPractice$Created);
    });
    var $author$project$Pages$Hinter$NewPractice$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    agp: bool
                });
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    ag1: $author$project$Utils$String$toMaybe(string)
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    ahb: $author$project$Utils$String$toMaybe(string)
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    aaT: $author$project$Utils$String$toMaybe(string)
                });
            case 5:
                var _int = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    MM: $elm$core$Maybe$Just(string),
                    Ge: _int,
                    Tu: $elm$core$Maybe$Just(string)
                });
            case 6:
                var string = field.a;
                return _Utils_update(fields, {
                    OH: $author$project$Utils$String$toMaybe(string)
                });
            case 7:
                var string = field.a;
                return _Utils_update(fields, {
                    Oy: $author$project$Utils$String$toMaybe(string)
                });
            case 8:
                var phone = field.a;
                return _Utils_update(fields, {
                    WE: phone
                });
            case 9:
                var address = field.a;
                return _Utils_update(fields, {
                    II: address
                });
            case 10:
                var string = field.a;
                return _Utils_update(fields, {
                    adt: $elm$core$String$toInt(string)
                });
            case 11:
                var dateInput = field.a;
                var date = field.b;
                return _Utils_update(fields, {
                    S0: date,
                    re: dateInput
                });
            case 12:
                var string = field.a;
                return _Utils_update(fields, {
                    QT: $author$project$Utils$String$toMaybe(string)
                });
            case 13:
                var string = field.a;
                return _Utils_update(fields, {
                    Wo: $author$project$Utils$String$toMaybe(string)
                });
            case 14:
                var string = field.a;
                return _Utils_update(fields, {
                    ad9: $author$project$Utils$String$toMaybe(string)
                });
            case 15:
                var string = field.a;
                return _Utils_update(fields, {
                    ahC: $author$project$Utils$String$toMaybe(string)
                });
            case 16:
                var string = field.a;
                return _Utils_update(fields, {
                    aex: $author$project$Utils$String$toMaybe(string)
                });
            case 17:
                var bool = field.a;
                return _Utils_update(fields, {
                    ahf: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    Vs: bool
                });
        }
    });
    var $author$project$Pages$Hinter$NewPractice$EinValidation = 5;
    var $author$project$Pages$Hinter$NewPractice$EmailValidation = 3;
    var $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessorValidation = 11;
    var $author$project$Pages$Hinter$NewPractice$InvitationEmailValidation = 8;
    var $author$project$Pages$Hinter$NewPractice$LogoValidation = 2;
    var $author$project$Pages$Hinter$NewPractice$NameValidation = 0;
    var $author$project$Pages$Hinter$NewPractice$PaymentProcessorValidation = 10;
    var $author$project$Pages$Hinter$NewPractice$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Pages$Hinter$NewPractice$AddressValidation = 6;
    var $author$project$Pages$Hinter$NewPractice$validateAddress = function(fields) {
        return !$author$project$Components$AddressInput$isValid(fields.II) ? _List_fromArray([
            _Utils_Tuple2(6, 'Please enter a valid address.')
        ]) : _List_Nil;
    };
    var $author$project$Pages$Hinter$NewPractice$HubspotDealValidation = 9;
    var $author$project$Pages$Hinter$NewPractice$validateHubspotDealId = function(fields) {
        return _Utils_eq(fields.QT, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(9, 'Please set a Hubspot Deal Id')
        ]) : _List_Nil;
    };
    var $author$project$Pages$Hinter$NewPractice$LaunchDateValidation = 7;
    var $author$project$Pages$Hinter$NewPractice$validateLaunchDate = F2(function(currentDate, fields) {
        var _v0 = fields.S0;
        if (_v0.$ === 1) return _List_Nil;
        else {
            var launchDate = _v0.a;
            return A2($justinmimbs$date$Date$compare, currentDate, launchDate) !== 2 ? _List_Nil : _List_fromArray([
                _Utils_Tuple2(7, 'Please enter a date greater or equal than today')
            ]);
        }
    });
    var $author$project$Pages$Hinter$NewPractice$PhoneValidation = 4;
    var $author$project$Pages$Hinter$NewPractice$validatePhone = function(fields) {
        var _v0 = $author$project$Components$PhoneInput$getPhones(fields.WE);
        if (!_v0.$) return _List_Nil;
        else return _List_fromArray([
            _Utils_Tuple2(4, 'Please enter a valid phone')
        ]);
    };
    var $author$project$Pages$Hinter$NewPractice$StripePlatformIdValidation = 12;
    var $author$project$Pages$Hinter$NewPractice$validateStripePlatformId = function(fields) {
        return _Utils_eq(fields.ad9, $elm$core$Maybe$Just('stripe')) && _Utils_eq(fields.ahC, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(12, 'Please set a Stripe Customer ID or select rainforest as Pay Hint Via')
        ]) : _List_Nil;
    };
    var $author$project$Pages$Hinter$NewPractice$UrlValidation = 1;
    var $author$project$Pages$Hinter$NewPractice$validateUrl = function(fields) {
        var _v0 = fields.aaT;
        if (_v0.$ === 1) return _List_Nil;
        else {
            var url = _v0.a;
            return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray([
                _Utils_Tuple2(1, 'URL must start with http:// or https://')
            ]) : _List_Nil;
        }
    };
    var $author$project$Pages$Hinter$NewPractice$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.zr;
            }, _Utils_Tuple2(0, 'Please enter a name.')),
            A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
                return $.Ge;
            }, $author$project$Pages$Hinter$NewPractice$maxLogoBytesSize, _Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateUrl),
            A3($author$project$Utils$Validate$ifInvalidEmail, {
                abH: true
            }, function($) {
                return $.OH;
            }, _Utils_Tuple2(3, 'Please enter a valid email')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validatePhone),
            A2($author$project$Ui$Form$Ein$ifInvalid, function($) {
                return $.Oy;
            }, _Utils_Tuple2(5, 'Please enter a valid EIN or leave empty')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateAddress),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateLaunchDate(currentDate)),
            A3($author$project$Utils$Validate$ifInvalidEmail, {
                abH: true
            }, function($) {
                return $.aex;
            }, _Utils_Tuple2(8, 'Please enter a valid email')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateHubspotDealId),
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.Wo;
            }, _Utils_Tuple2(10, 'Please select a payment processor')),
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.ad9;
            }, _Utils_Tuple2(11, 'Please select a payment processor to pay hint via')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Hinter$NewPractice$validateStripePlatformId)
        ]));
    };
    var $author$project$Pages$Hinter$NewPractice$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$NewPractice$formFieldsUpdate, A2(field, newDateInput, date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$NewPractice$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.PU);
            }
        }();
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd), _List_Nil);
    });
    var $author$project$Pages$Hinter$NewPractice$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$NewPractice$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var fields = $author$project$Utils$Form$fields(model.PU);
                var address = $author$project$Components$AddressInput$validate(fields.II);
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$NewPractice$formFieldsUpdate, $author$project$Pages$Hinter$NewPractice$Address(address), model.PU);
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$Hinter$NewPractice$formFieldsValidator(model.cP), newForm);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var validatedForm = _v2.a;
                    var validFormFields = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Hinter$NewPractice$createPractice, model.Ej, validFormFields), _List_Nil);
                } else {
                    var validatedForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: validatedForm,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    var _v4 = _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
                        A3($author$project$OutMsg$SwitchToOrganization, $author$project$Api$Provider$Practice$One$organizationId(practice), $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToRouteAction($author$project$Spa$Generated$Route$Admin__Billing))
                    ]));
                    var cmd = _v4.a;
                    var outMsgs = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), cmd, _Utils_ap(outMsgs, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Practice created'),
                        $author$project$OutMsg$PracticeUpdated(response)
                    ])));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var logos = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v5) {
                    var task = _v5.a;
                    var size = _v5.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Logo(size)), task);
                }, A2($elm$core$Maybe$map, function(logo) {
                    return _Utils_Tuple2($elm$file$File$toUrl(logo), $elm$file$File$size(logo));
                }, $elm$core$List$head(logos))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v6 = $author$project$Utils$Form$fields(model.PU);
                var address = _v6.II;
                var _v7 = A2($author$project$Components$AddressInput$update, subMsg, address);
                var addressInputModel = _v7.a;
                var addressInputCmd = _v7.b;
                var outMsgs = _v7.c;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$NewPractice$formFieldsUpdate, $author$project$Pages$Hinter$NewPractice$Address(addressInputModel), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$AddressInputMsg, addressInputCmd), outMsgs);
            case 5:
                var subMsg = msg.a;
                var _v8 = $author$project$Utils$Form$fields(model.PU);
                var phone = _v8.WE;
                var _v9 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
                var phoneInput = _v9.a;
                var phoneCmd = _v9.b;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Hinter$NewPractice$formFieldsUpdate, $author$project$Pages$Hinter$NewPractice$Phone(phoneInput), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Hinter$NewPractice$PhoneInputMsg, phoneCmd), _List_Nil);
            default:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Pages$Hinter$NewPractice$updateDateInputFormField, model, dateInput, subMsg, $author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg, $author$project$Pages$Hinter$NewPractice$LaunchDate, function($) {
                    return $.S0;
                });
        }
    });
    var $author$project$Pages$Hinter$NewPractice$Save = {
        $: 1
    };
    var $author$project$Pages$Hinter$NewPractice$Ein = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$Email = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$EstimatedMembershipsCount = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessor = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$HubspotDealId = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$InvitationEmail = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$LogoUploaded = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$Name = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$Onboarded = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$PaymentProcessor = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$PrimaryCare = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$SalesOwner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$Segment = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$SendInvitation = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$StripePlatformId = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$Url = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Hinter$NewPractice$paymentProcessors = _List_fromArray([
        _Utils_Tuple2('stripe', 'Stripe'),
        _Utils_Tuple2('rainforest', 'Rainforest')
    ]);
    var $author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions = A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Select an option'), A2($elm$core$List$map, function(_v0) {
        var value = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(value), label);
    }, $author$project$Pages$Hinter$NewPractice$paymentProcessors));
    var $author$project$Pages$Hinter$NewPractice$segments = _List_fromArray([
        'Direct care',
        'Fee for service',
        'Hybrid',
        'Concierge'
    ]);
    var $author$project$Pages$Hinter$NewPractice$segmentOptions = A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Select an option'), A2($elm$core$List$map, function(segment) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(segment), segment);
    }, $author$project$Pages$Hinter$NewPractice$segments));
    var $author$project$Pages$Hinter$NewPractice$viewForm = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Don\'t Require Payment Method')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.Vs),
                    $author$project$Ui$ToggleSwitch$disabled(fields.GE),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Onboarded))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Sales owner')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.ag1)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$SalesOwner))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Primary care')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.agp),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$PrimaryCare))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Segment')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(fields.ahb),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Segment))
                ]), $author$project$Pages$Hinter$NewPractice$segmentOptions)
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Business Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Website')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.aaT)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Url)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Practice Logo')
            ]), _List_fromArray([
                $author$project$Ui$Form$File$view(_List_fromArray([
                    $author$project$Ui$Form$File$accept(0),
                    $author$project$Ui$Form$File$onInput($author$project$Pages$Hinter$NewPractice$LogoUploaded),
                    $author$project$Ui$Form$File$empty(true)
                ]))
            ])),
            function() {
                var _v0 = fields.MM;
                if (!_v0.$) {
                    var url = _v0.a;
                    return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$label('')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Image$fromSrc, {
                            Jg: 'Logo'
                        }, url, _List_fromArray([
                            $author$project$Ui$Image$height(50)
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Phone')
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Hinter$NewPractice$PhoneInputMsg, $author$project$Components$PhoneInput$view(fields.WE)),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 4, model.PU))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Email')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.OH)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Email)),
                    $author$project$Ui$Form$Input$placeholder('contact@mypractice.com'),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 3, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Business Address'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Hinter$NewPractice$AddressInputMsg, A2($author$project$Components$AddressInput$view, _List_Nil, fields.II))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Employer Identification Number (EIN)')
            ]), _List_fromArray([
                $author$project$Ui$Form$Ein$view(_List_fromArray([
                    $author$project$Ui$Form$Ein$value(fields.Oy),
                    $author$project$Ui$Form$Ein$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$Ein)),
                    $author$project$Ui$Form$Ein$invalid(A2($author$project$Utils$Form$hasValidationErrors, 5, model.PU)),
                    $author$project$Ui$Form$Ein$errors(A2($author$project$Utils$Form$validationErrors, 5, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$label('Launch & Billing Start')
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Hinter$NewPractice$LaunchDateDateInputMsg(fields.re), A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(fields.S0),
                    $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 7, model.PU)),
                    $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 7, model.PU))
                ]), fields.re))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Current Members')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$number,
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.adt))),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$EstimatedMembershipsCount))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Hubspot Deal ID'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.QT)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$HubspotDealId)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 9, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 9, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Payment Processor'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(fields.Wo),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$PaymentProcessor)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 10, model.PU)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 10, model.PU))
                ]), $author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions)
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Pay Hint Via'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(fields.ad9),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$HintCustomerPaymentProcessor)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 11, model.PU)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 11, model.PU))
                ]), $author$project$Pages$Hinter$NewPractice$paymentProcessorsOptions),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Use rainforest unless a stripe customer id is provided.')
                ]))
            ])),
            _Utils_eq(fields.ad9, $elm$core$Maybe$Just('stripe')) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Stripe Customer ID')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.ahC)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$StripePlatformId)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 12, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 12, model.PU))
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('This is for the payment info they gave us, allowing us to charge the customer a minimum/pmpm fee.')
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Owner email')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.aex)),
                    $author$project$Ui$Form$Input$placeholder('email@example.com'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$InvitationEmail)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 8, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 8, model.PU))
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Leave this blank for clinical accounts.')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Invitation to owners')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Do you want to send an invitation to practice owners?')
                ])),
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.ahf),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Hinter$NewPractice$FormUpdated, $author$project$Pages$Hinter$NewPractice$SendInvitation))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Hinter$NewPractice$view = function(model) {
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Hinter$NewPractice$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Create New Practice')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _Utils_ap($author$project$Pages$Hinter$NewPractice$viewForm(model), _List_fromArray([
                            function() {
                                var _v0 = model.j_;
                                if (_v0.$ === 2) {
                                    var error = _v0.a;
                                    return A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$mt4
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text($author$project$Api$Data$errorToString(error))
                                        ]))
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ]))),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Create new practice'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Create')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$Hinter$NewPractice$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Hinter$NewPractice$init,
        aeR: $author$project$Pages$Hinter$NewPractice$load,
        ag3: $author$project$Pages$Hinter$NewPractice$save,
        ahE: $author$project$Pages$Hinter$NewPractice$subscriptions,
        aaO: $author$project$Pages$Hinter$NewPractice$update,
        aid: $author$project$Pages$Hinter$NewPractice$view
    });
    var $author$project$Pages$Home$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Home$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Home$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Home$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Home'
        };
    };
    var $author$project$Pages$Home$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Home$init,
        aeR: $author$project$Pages$Home$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Home$update,
        aid: $author$project$Pages$Home$view
    });
    var $author$project$Pages$Inventory$InventoryId_String$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Inventory$InventoryId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Inventory$InventoryId_String$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Inventory$InventoryId_String$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Medication'
        };
    };
    var $author$project$Pages$Inventory$InventoryId_String$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Inventory$InventoryId_String$Top$init,
        aeR: $author$project$Pages$Inventory$InventoryId_String$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Inventory$InventoryId_String$Top$update,
        aid: $author$project$Pages$Inventory$InventoryId_String$Top$view
    });
    var $author$project$Pages$Inventory$List$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Inventory$List$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Inventory$List$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Inventory$List$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Medications'
        };
    };
    var $author$project$Pages$Inventory$List$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Inventory$List$init,
        aeR: $author$project$Pages$Inventory$List$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Inventory$List$update,
        aid: $author$project$Pages$Inventory$List$view
    });
    var $author$project$Pages$Inventory$New$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Inventory$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Inventory$New$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Inventory$New$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'New Medication'
        };
    };
    var $author$project$Pages$Inventory$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Inventory$New$init,
        aeR: $author$project$Pages$Inventory$New$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Inventory$New$update,
        aid: $author$project$Pages$Inventory$New$view
    });
    var $author$project$Pages$Inventory$Settings$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Inventory$Settings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Inventory$Settings$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Inventory$Settings$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Inventory Settings'
        };
    };
    var $author$project$Pages$Inventory$Settings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Inventory$Settings$init,
        aeR: $author$project$Pages$Inventory$Settings$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Inventory$Settings$update,
        aid: $author$project$Pages$Inventory$Settings$view
    });
    var $author$project$Pages$Join$Token_String$GotInvitation = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Join$Token_String$GotSession = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Platform$Invitation$One$Invitation = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$Invitation$Shared$Invitation = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Invitation$Shared$Record = F2(function(role, email) {
        return {
            OH: email,
            ag_: role
        };
    });
    var $author$project$Api$Platform$Invitation$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'role', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$Shared$Record)));
    var $author$project$Api$Platform$Invitation$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Invitation$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Invitation$One$Record = F2(function(accepted, organization) {
        return {
            Id: accepted,
            VA: organization
        };
    });
    var $author$project$Api$Platform$Invitation$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization', $author$project$Api$Platform$Organization$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accepted', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$One$Record)));
    var $author$project$Api$Platform$Invitation$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Invitation$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Invitation$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Invitation$One$Invitation)));
    var $author$project$Api$Platform$Invitation$invitationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'invitations'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$Invitation$invitationPath = function(token) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            token
        ]), $author$project$Api$Platform$Invitation$invitationsPath);
    };
    var $author$project$Api$Platform$Invitation$retrieve = F3(function(apiClient, token, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Platform$Invitation$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$Invitation$invitationPath(token)));
    });
    var $author$project$Pages$Join$Token_String$init = F2(function(shared, _v0) {
        var params = _v0.VU;
        var _v1 = $author$project$Api$Data$clientHasAuthToken(shared.Ej) ? _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Api$Platform$Session$retrieve, shared.Ej, $author$project$Pages$Join$Token_String$GotSession)) : _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
        var session = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple3({
            Ej: shared.Ej,
            PU: $elm$core$Maybe$Nothing,
            mC: $author$project$Api$Data$Loading,
            aeT: shared.aaT,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            aaf: params.aaf,
            abq: $author$project$Api$Data$Loading
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Platform$Invitation$retrieve, shared.Ej, params.aaf, $author$project$Pages$Join$Token_String$GotInvitation),
            cmd
        ])), _List_Nil);
    });
    var $author$project$Pages$Join$Token_String$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Join$Token_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Join$Token_String$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Join$Token_String$PasswordStrengthCheck = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Utils$PasswordStrength$PasswordStrength = $elm$core$Basics$identity;
    var $author$project$Utils$PasswordStrength$init = $elm$core$Basics$identity;
    var $author$project$Ports$PasswordStrength$passwordStrengthChecked = _Platform_incomingPort('passwordStrengthChecked', A2($elm$json$Json$Decode$andThen, function(suggestions) {
        return A2($elm$json$Json$Decode$andThen, function(strength) {
            return $elm$json$Json$Decode$succeed({
                ahB: strength,
                ahF: suggestions
            });
        }, A2($elm$json$Json$Decode$field, 'strength', $elm$json$Json$Decode$int));
    }, A2($elm$json$Json$Decode$field, 'suggestions', $elm$json$Json$Decode$list($elm$json$Json$Decode$string))));
    var $author$project$Ports$PasswordStrength$checked = function(toMsg) {
        return $author$project$Ports$PasswordStrength$passwordStrengthChecked(A2($elm$core$Basics$composeR, $author$project$Utils$PasswordStrength$init, toMsg));
    };
    var $author$project$Pages$Join$Token_String$subscriptions = function(_v0) {
        return $author$project$Ports$PasswordStrength$checked(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$PasswordStrengthCheck), $elm$core$Maybe$Just));
    };
    var $author$project$Pages$Join$Token_String$InvitationAccepted = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Join$Token_String$UserCreated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Platform$Invitation$accept = F3(function(apiClient, token, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$Invitation$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'accept'
        ]), $author$project$Api$Platform$Invitation$invitationPath(token))));
    });
    var $author$project$Api$Platform$Invitation$One$accepted = function(_v0) {
        var record = _v0.b;
        return record.Id;
    };
    var $author$project$Api$Data$clientWithAuthToken = F2(function(authToken, _v0) {
        var client = _v0;
        return _Utils_update(client, {
            e7: authToken
        });
    });
    var $author$project$Api$Data$clientDisableAuth = function(_v0) {
        var client = _v0;
        return _Utils_update(client, {
            Cq: false
        });
    };
    var $author$project$Api$Platform$User$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('user', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('first_name', $elm$json$Json$Encode$string(fields.PN)),
                _Utils_Tuple2('last_name', $elm$json$Json$Encode$string(fields.SU)),
                _Utils_Tuple2('email', $elm$json$Json$Encode$string(fields.OH)),
                _Utils_Tuple2('password', $elm$json$Json$Encode$string(fields.af2)),
                _Utils_Tuple2('terms_accepted', $elm$json$Json$Encode$bool(fields.HM))
            ]))),
            _Utils_Tuple2('invitation_id', $elm$json$Json$Encode$string(fields.aey))
        ]));
        return A4($author$project$Api$Data$post, $author$project$Api$Data$clientDisableAuth(apiClient), $author$project$Api$Platform$User$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
    });
    var $author$project$Api$Platform$User$One$defaultOrganization = function(_v0) {
        var record = _v0.b;
        return record.Nv;
    };
    var $author$project$Ports$PasswordStrength$checkPasswordStrength = _Platform_outgoingPort('checkPasswordStrength', $elm$json$Json$Encode$string);
    var $author$project$Ports$PasswordStrength$check = $author$project$Ports$PasswordStrength$checkPasswordStrength;
    var $author$project$Pages$Join$Token_String$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    PN: string
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    SU: string
                }), $elm$core$Platform$Cmd$none);
            case 2:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    OH: string
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    af2: string,
                    nk: $elm$core$Maybe$Nothing
                }), $author$project$Ports$PasswordStrength$check(string));
            case 4:
                var bool = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    HM: bool
                }), $elm$core$Platform$Cmd$none);
            default:
                var check = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    nk: check
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Pages$Join$Token_String$EmailValidation = 2;
    var $author$project$Pages$Join$Token_String$FirstNameValidation = 0;
    var $author$project$Pages$Join$Token_String$LastNameValidation = 1;
    var $author$project$Pages$Join$Token_String$PasswordValidation = 3;
    var $author$project$Pages$Join$Token_String$TermsAcceptedValidation = 4;
    var $author$project$Utils$PasswordStrength$isUnguessable = function(_v0) {
        var record = _v0;
        return record.ahB >= 3;
    };
    var $author$project$Pages$Join$Token_String$formFieldsValidator = function(existingUser) {
        return $rtfeldman$elm_validate$Validate$all(existingUser ? _List_Nil : _List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.PN;
            }, _Utils_Tuple2(0, 'Please enter a first name.')),
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.SU;
            }, _Utils_Tuple2(1, 'Please enter a last name.')),
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.OH;
            }, _Utils_Tuple2(2, 'Please enter an email.')),
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.af2;
            }, _Utils_Tuple2(3, 'Please enter a password.')),
            A2($rtfeldman$elm_validate$Validate$ifFalse, function($) {
                return $.HM;
            }, _Utils_Tuple2(4, 'You must accept our Terms of Service when creating your account.')),
            A2($rtfeldman$elm_validate$Validate$ifFalse, function(subject) {
                return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.nk));
            }, _Utils_Tuple2(3, 'Please enter a secure password.'))
        ]));
    };
    var $author$project$Api$Platform$Invitation$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Platform$Invitation$One$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$Invitation$Shared$email(shared);
    };
    var $author$project$Pages$Join$Token_String$initFormFields = F2(function(invitation, user) {
        return {
            OH: A2($elm$core$Maybe$withDefault, $author$project$Api$Platform$Invitation$One$email(invitation), A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$email, user)),
            PN: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$firstName, user)),
            SU: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Shared$lastName, user)),
            af2: '',
            nk: $elm$core$Maybe$Nothing,
            HM: false,
            aaX: user
        };
    });
    var $author$project$Pages$Join$Token_String$initInvitationForm = F2(function(session, invitation) {
        var _v0 = _Utils_Tuple2(session, invitation);
        _v0$3: while(true){
            if (_v0.b.$ === 3) switch(_v0.a.$){
                case 3:
                    var _v1 = _v0.a;
                    var session_ = _v1.a;
                    var _v2 = _v0.b;
                    var invitation_ = _v2.a;
                    var form = $author$project$Utils$Form$init(A2($author$project$Pages$Join$Token_String$initFormFields, invitation_, $elm$core$Maybe$Just($author$project$Api$Platform$Session$One$user(session_))));
                    return $elm$core$Maybe$Just(form);
                case 2:
                    var _v3 = _v0.b;
                    var invitation_ = _v3.a;
                    var form = $author$project$Utils$Form$init(A2($author$project$Pages$Join$Token_String$initFormFields, invitation_, $elm$core$Maybe$Nothing));
                    return $elm$core$Maybe$Just(form);
                case 0:
                    var _v4 = _v0.a;
                    var _v5 = _v0.b;
                    var invitation_ = _v5.a;
                    var form = $author$project$Utils$Form$init(A2($author$project$Pages$Join$Token_String$initFormFields, invitation_, $elm$core$Maybe$Nothing));
                    return $elm$core$Maybe$Just(form);
                default:
                    break _v0$3;
            }
            else break _v0$3;
        }
        return $elm$core$Maybe$Nothing;
    });
    var $author$project$OutMsg$GoToDefaultStateAction = {
        $: 0
    };
    var $author$project$Api$Platform$Organization$Shared$requiresMfa = function(_v0) {
        var record = _v0.b;
        return record.YL;
    };
    var $author$project$Pages$Join$Token_String$navigateToAcceptedOrganization = function(organization) {
        return $author$project$Api$Platform$Organization$Shared$requiresMfa(organization) ? _Utils_Tuple2(A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Mfa), _List_Nil) : _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
            A3($author$project$OutMsg$SwitchToOrganization, $author$project$Api$Platform$Organization$Shared$id(organization), $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToDefaultStateAction)
        ]));
    };
    var $author$project$Api$Platform$Invitation$One$organization = function(_v0) {
        var record = _v0.b;
        return record.VA;
    };
    var $author$project$Ports$Session$sessionPersistRedirectPort = _Platform_outgoingPort('sessionPersistRedirectPort', $elm$json$Json$Encode$string);
    var $author$project$Ports$Session$persistRedirect = function(url) {
        return $author$project$Ports$Session$sessionPersistRedirectPort(url);
    };
    var $author$project$Pages$Join$Token_String$GotWhitelabelSetting = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$WhitelabelSetting$platformWhitelabelSettingsPath = function(practiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'whitelabel_settings'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            practiceId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'practices'
        ]), $author$project$Api$Data$platformPath)));
    };
    var $author$project$Api$WhitelabelSetting$platformRetrieve = F3(function(apiClient, practiceId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$WhitelabelSetting$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$WhitelabelSetting$platformWhitelabelSettingsPath(practiceId)));
    });
    var $author$project$Pages$Join$Token_String$retrieveWhitelabelSettings = F2(function(apiClient, practiceId) {
        return A3($author$project$Api$WhitelabelSetting$platformRetrieve, apiClient, practiceId, $author$project$Pages$Join$Token_String$GotWhitelabelSetting);
    });
    var $elm$url$Url$addPort = F2(function(maybePort, starter) {
        if (maybePort.$ === 1) return starter;
        else {
            var port_ = maybePort.a;
            return starter + (':' + $elm$core$String$fromInt(port_));
        }
    });
    var $elm$url$Url$addPrefixed = F3(function(prefix, maybeSegment, starter) {
        if (maybeSegment.$ === 1) return starter;
        else {
            var segment = maybeSegment.a;
            return _Utils_ap(starter, _Utils_ap(prefix, segment));
        }
    });
    var $elm$url$Url$toString = function(url) {
        var http = function() {
            var _v0 = url.XH;
            if (!_v0) return 'http://';
            else return 'https://';
        }();
        return A3($elm$url$Url$addPrefixed, '#', url.adZ, A3($elm$url$Url$addPrefixed, '?', url.Bz, _Utils_ap(A2($elm$url$Url$addPort, url.WV, _Utils_ap(http, url.aec)), url.V6)));
    };
    var $author$project$Pages$Join$Token_String$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                var cmd = function() {
                    if (response.$ === 3) {
                        var invitation = response.a;
                        return A2($author$project$Pages$Join$Token_String$retrieveWhitelabelSettings, model.Ej, $author$project$Api$Platform$Organization$Shared$id($author$project$Api$Platform$Invitation$One$organization(invitation)));
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: A2($author$project$Pages$Join$Token_String$initInvitationForm, model.Z$, response),
                    mC: response
                }), cmd, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: A2($author$project$Pages$Join$Token_String$initInvitationForm, response, model.mC),
                    Z$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    abq: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var field = msg.a;
                var _v2 = model.PU;
                if (!_v2.$) {
                    var form = _v2.a;
                    var _v3 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Pages$Join$Token_String$formFieldsUpdate, field, form);
                    var newForm = _v3.a;
                    var cmd = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Join$Token_String$FormUpdated, cmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var _v4 = model.PU;
                if (!_v4.$) {
                    var form = _v4.a;
                    var session = $author$project$Api$Data$toMaybe(model.Z$);
                    var existingUser = $author$project$Utils$Maybe$toBool(session);
                    var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Join$Token_String$formFieldsValidator(existingUser), form);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var newForm = _v6.a;
                        var validFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$Loading
                        }), function() {
                            if (!session.$) {
                                var accessToken = $author$project$Api$Data$clientAuthToken(model.Ej);
                                var apiClient = A2($author$project$Api$Data$clientWithAuthToken, accessToken, model.Ej);
                                return A3($author$project$Api$Platform$Invitation$accept, apiClient, model.aaf, $author$project$Pages$Join$Token_String$InvitationAccepted);
                            } else {
                                var _v8 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                                var firstName = _v8.PN;
                                var lastName = _v8.SU;
                                var email = _v8.OH;
                                var termsAccepted = _v8.HM;
                                var password = _v8.af2;
                                return A3($author$project$Api$Platform$User$create, model.Ej, {
                                    OH: email,
                                    PN: firstName,
                                    aey: model.aaf,
                                    SU: lastName,
                                    af2: password,
                                    HM: termsAccepted
                                }, $author$project$Pages$Join$Token_String$UserCreated);
                            }
                        }(), _List_Nil);
                    } else {
                        var newForm = _v5.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var invitation = response.a;
                    var organization = $author$project$Api$Platform$Invitation$One$organization(invitation);
                    var _v10 = $author$project$Pages$Join$Token_String$navigateToAcceptedOrganization(organization);
                    var cmd = _v10.a;
                    var outMsgs = _v10.b;
                    return _Utils_Tuple3(model, cmd, _Utils_ap(outMsgs, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Invitation accepted')
                    ])));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var response = msg.a;
                if (response.$ === 3) {
                    var user = response.a;
                    var _v12 = $author$project$Api$Platform$User$One$defaultOrganization(user);
                    if (!_v12.$) return _Utils_Tuple3(model, $author$project$Ports$Session$logout({
                        agy: true
                    }), _List_Nil);
                    else return _Utils_Tuple3(_Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var cmd = function() {
                    var _v13 = model.mC;
                    if (_v13.$ === 3) {
                        var invitation_ = _v13.a;
                        return $author$project$Api$Platform$Invitation$One$accepted(invitation_) ? $author$project$Ports$Session$logout({
                            agy: true
                        }) : $author$project$Ports$Session$logout({
                            agy: false
                        });
                    } else return $author$project$Ports$Session$logout({
                        agy: false
                    });
                }();
                return _Utils_Tuple3(model, cmd, _List_Nil);
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Ports$Session$persistRedirect($elm$url$Url$toString(model.aeT)),
                    $author$project$Ports$Session$authorize({
                        agy: true
                    })
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Join$Token_String$Logout = {
        $: 7
    };
    var $author$project$Pages$Join$Token_String$Email = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Join$Token_String$FirstName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Join$Token_String$LastName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Join$Token_String$Password = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Join$Token_String$Save = {
        $: 4
    };
    var $author$project$Pages$Join$Token_String$SignInClicked = {
        $: 8
    };
    var $author$project$Pages$Join$Token_String$TermsAccepted = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$WhitelabelSetting$brandName = function(_v0) {
        var record = _v0;
        return record.Ey;
    };
    var $author$project$Ui$Button$Lg = 2;
    var $author$project$Ui$Button$lg = $author$project$Ui$Button$Size(2);
    var $author$project$Api$Platform$Organization$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Platform$Organization$Shared$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Organization$Min$name(min);
    };
    var $author$project$Api$Platform$User$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Ui$Form$PasswordInput$Placeholder = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$PasswordInput$placeholder = $author$project$Ui$Form$PasswordInput$Placeholder;
    var $author$project$Api$Platform$Invitation$Shared$role = function(_v0) {
        var record = _v0;
        return record.ag_;
    };
    var $author$project$Api$Platform$Invitation$One$role = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$Invitation$Shared$role(shared);
    };
    var $author$project$Ui$Well$Signin = {
        $: 1
    };
    var $author$project$Ui$Well$signin = $author$project$Ui$Well$Signin;
    var $author$project$Ui$Form$Signup = {
        $: 5
    };
    var $author$project$Ui$Form$signup = $author$project$Ui$Form$Signup;
    var $author$project$Ui$Form$PasswordInput$StrengthCheck = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$PasswordInput$strengthCheck = $author$project$Ui$Form$PasswordInput$StrengthCheck;
    var $author$project$Utils$HintUrls$termsUrl = 'http://www.hint.com/terms/';
    var $author$project$Ui$Form$PasswordInput$WithFeedback = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Form$PasswordInput$withFeedback = $author$project$Ui$Form$PasswordInput$WithFeedback;
    var $author$project$Pages$Join$Token_String$viewAcceptInvitationForm = F3(function(model, form, invitation) {
        var organization = $author$project$Api$Platform$Invitation$One$organization(invitation);
        var invitedAs = $author$project$Api$Platform$Invitation$One$role(invitation) === 'admin' ? 'an administrator' : 'a user';
        var fields = $author$project$Utils$Form$fields(form);
        var existingUser = $author$project$Utils$Maybe$toBool(fields.aaX);
        return A2($author$project$Ui$Well$view, _List_fromArray([
            $author$project$Ui$Well$signin
        ]), _List_fromArray([
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$signup,
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$autocomplete(false),
                $author$project$Ui$Form$onSubmit($author$project$Pages$Join$Token_String$Save)
            ]), _List_fromArray([
                $author$project$Ui$Typography$heading(_List_fromArray([
                    function() {
                        if (existingUser) return $elm$html$Html$text('Accept Invitation');
                        else {
                            var brandName = function() {
                                var _v0 = model.abq;
                                if (_v0.$ === 3) {
                                    var whitelabelSetting = _v0.a;
                                    return $author$project$Api$WhitelabelSetting$brandName(whitelabelSetting) + ' ';
                                } else return '';
                            }();
                            return $elm$html$Html$text($elm$core$String$concat(_List_fromArray([
                                'Create your ',
                                brandName,
                                'Account'
                            ])));
                        }
                    }()
                ])),
                function() {
                    var _v1 = fields.aaX;
                    if (!_v1.$) {
                        var user = _v1.a;
                        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock
                            ]), _Utils_eq($author$project$Api$Platform$User$Shared$email(user), $author$project$Api$Platform$Invitation$One$email(invitation)) ? _List_fromArray([
                                $elm$html$Html$text('You\'re logged in as '),
                                $elm$html$Html$text($author$project$Api$Platform$User$Shared$name(user)),
                                $elm$html$Html$text('.')
                            ]) : _List_fromArray([
                                $elm$html$Html$text('You\'re logged in as '),
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Platform$User$Shared$email(user))
                                ])),
                                $elm$html$Html$text(' but are accepting an invitation sent to '),
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Platform$Invitation$One$email(invitation))
                                ]))
                            ])),
                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Want to create a new account? '),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Sign out'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$Logout)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Sign Out')
                                ])),
                                $elm$html$Html$text('.')
                            ]))
                        ]));
                    } else return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Already have an account? '),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Sign In'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$SignInClicked)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Sign In')
                        ]))
                    ]));
                }(),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form) || A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$placeholder('First'),
                                $author$project$Ui$Form$Input$value(fields.PN),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$FirstName)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                                $author$project$Ui$Form$Input$disabled(existingUser)
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$placeholder('Last'),
                                $author$project$Ui$Form$Input$value(fields.SU),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$LastName)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                                $author$project$Ui$Form$Input$disabled(existingUser)
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form))
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$placeholder('Email address'),
                        $author$project$Ui$Form$Input$email,
                        $author$project$Ui$Form$Input$value(fields.OH),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$Email)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                        $author$project$Ui$Form$Input$disabled(existingUser)
                    ]))
                ])),
                !existingUser ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form))
                ]), _List_fromArray([
                    $author$project$Ui$Form$PasswordInput$view(_List_fromArray([
                        $author$project$Ui$Form$PasswordInput$placeholder('Password'),
                        $author$project$Ui$Form$PasswordInput$value(fields.af2),
                        $author$project$Ui$Form$PasswordInput$strengthCheck(fields.nk),
                        $author$project$Ui$Form$PasswordInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$Password)),
                        $author$project$Ui$Form$PasswordInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                        $author$project$Ui$Form$PasswordInput$withFeedback($author$project$Utils$Form$validated(form))
                    ]))
                ])) : $author$project$Utils$Html$empty,
                !existingUser ? A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(fields.HM),
                        $author$project$Ui$Form$Checkbox$required(true),
                        $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Join$Token_String$FormUpdated, $author$project$Pages$Join$Token_String$TermsAccepted)),
                        $author$project$Ui$Form$Checkbox$errors(A2($author$project$Utils$Form$validationErrors, 4, form))
                    ]), _List_fromArray([
                        $elm$html$Html$text('I agree to this software platform\'s '),
                        A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$termsUrl, _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('Terms of Service')
                        ])),
                        $elm$html$Html$text('.')
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Accept invitation'
                    }, _List_fromArray([
                        $author$project$Ui$Button$lg,
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$fullWidth(true),
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        existingUser ? $elm$html$Html$text('Accept Invitation') : $elm$html$Html$text('Sign Up')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock,
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        $elm$html$Html$text('as '),
                        $elm$html$Html$text(invitedAs),
                        $elm$html$Html$text(' for '),
                        $elm$html$Html$text($author$project$Api$Platform$Organization$Shared$name(organization))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Join$Token_String$viewInvitation = F3(function(model, form, invitation) {
        return $author$project$Api$Platform$Invitation$One$accepted(invitation) ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text('It looks like you have already accepted our invitation. Please use your new credentials to access your account '),
            A3($author$project$Ui$Button$view, {
                abP: 'Sign In'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Pages$Join$Token_String$Logout)
            ]), _List_fromArray([
                $elm$html$Html$text('here')
            ])),
            $elm$html$Html$text('.')
        ])) : A3($author$project$Pages$Join$Token_String$viewAcceptInvitationForm, model, form, invitation);
    });
    var $author$project$Pages$Join$Token_String$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = _Utils_Tuple2(model.mC, model.PU);
                    _v0$2: while(true)switch(_v0.a.$){
                        case 3:
                            if (!_v0.b.$) {
                                var _v1 = _v0.a;
                                var invitation = _v1.a;
                                var form = _v0.b.a;
                                return A3($author$project$Pages$Join$Token_String$viewInvitation, model, form, invitation);
                            } else break _v0$2;
                        case 2:
                            return A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('The invitation is invalid or has expired')
                            ]));
                        default:
                            break _v0$2;
                    }
                    return A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]));
                }()
            ]),
            $2: 'Login'
        };
    };
    var $author$project$Pages$Join$Token_String$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$Join$Token_String$init,
        aeR: $author$project$Pages$Join$Token_String$load,
        ag3: $author$project$Pages$Join$Token_String$save,
        ahE: $author$project$Pages$Join$Token_String$subscriptions,
        aaO: $author$project$Pages$Join$Token_String$update,
        aid: $author$project$Pages$Join$Token_String$view
    });
    var $author$project$Components$Auth$RequestCode$formFieldsInit = {
        OH: ''
    };
    var $author$project$Components$Auth$RequestCode$init = {
        b5: $author$project$Utils$Form$init($author$project$Components$Auth$RequestCode$formFieldsInit)
    };
    var $author$project$Components$Auth$VerifyCode$formFieldsInit = {
        Lk: ''
    };
    var $author$project$Components$Auth$VerifyCode$init = {
        bs: $author$project$Utils$Form$init($author$project$Components$Auth$VerifyCode$formFieldsInit),
        Ll: false,
        ly: 0,
        OH: $elm$core$Maybe$Nothing,
        O4: $elm$core$Maybe$Nothing,
        Xv: false,
        sC: $elm$core$Maybe$Nothing,
        sR: false
    };
    var $author$project$Pages$Login$redirectBasedOnSession = F2(function(model, shared) {
        var _v0 = shared.Z$;
        switch(_v0.$){
            case 3:
                var session = _v0.a;
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
            case 1:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var cmd = shared.adU.abT ? $elm$core$Platform$Cmd$none : $author$project$Ports$Session$authorize({
                    agy: true
                });
                return _Utils_Tuple3(model, cmd, _List_Nil);
        }
    });
    var $author$project$Pages$Login$init = F2(function(shared, _v0) {
        var query = _v0.Bz;
        var model = {
            Ej: shared.Ej,
            abT: shared.adU.abT,
            OH: $elm$core$Maybe$Nothing,
            qW: shared.qW,
            Xv: false,
            sv: $author$project$Components$Auth$RequestCode$init,
            sC: $elm$core$Maybe$Nothing,
            eT: $author$project$Components$Auth$VerifyCode$init
        };
        if (shared.adU.abT) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        else {
            if (A2($author$project$Api$Data$clientHasTokenExpired, shared.Ej, shared.acJ)) {
                var returnUrlCmd = function() {
                    var _v1 = A2($elm$core$Dict$get, 'returnUrl', query);
                    if (!_v1.$) {
                        var returnUrl = _v1.a;
                        return $author$project$Ports$Session$persistRedirect(returnUrl);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    returnUrlCmd,
                    $author$project$Ports$Session$authorize({
                        agy: true
                    })
                ])), _List_Nil);
            } else return A2($author$project$Pages$Login$redirectBasedOnSession, model, shared);
        }
    });
    var $author$project$Pages$Login$load = F2(function(shared, model) {
        return A2($author$project$Pages$Login$redirectBasedOnSession, model, shared);
    });
    var $author$project$Pages$Login$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Login$GotRecaptchaToken = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ports$GoogleRecaptcha$gotRecaptchaTokenPort = _Platform_incomingPort('gotRecaptchaTokenPort', A2($elm$json$Json$Decode$andThen, function(token) {
        return A2($elm$json$Json$Decode$andThen, function(result) {
            return $elm$json$Json$Decode$succeed({
                YX: result,
                aaf: token
            });
        }, A2($elm$json$Json$Decode$field, 'result', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string)));
    var $author$project$Ports$GoogleRecaptcha$GoogleRecaptchaNotDefined = 0;
    var $author$project$Ports$GoogleRecaptcha$GoogleRequestError = 1;
    var $author$project$Ports$GoogleRecaptcha$localStorageResultFromPort = F2(function(msg, _v0) {
        var token = _v0.aaf;
        var result = _v0.YX;
        switch(result){
            case 'ok':
                return msg($elm$core$Result$Ok(token));
            case 'recaptcha-not-defined':
                return msg($elm$core$Result$Err(0));
            default:
                return msg($elm$core$Result$Err(1));
        }
    });
    var $author$project$Ports$GoogleRecaptcha$gotRecaptchaToken = function(msg) {
        return $author$project$Ports$GoogleRecaptcha$gotRecaptchaTokenPort($author$project$Ports$GoogleRecaptcha$localStorageResultFromPort(msg));
    };
    var $author$project$Pages$Login$subscriptions = function(_v0) {
        return $author$project$Ports$GoogleRecaptcha$gotRecaptchaToken($author$project$Pages$Login$GotRecaptchaToken);
    };
    var $author$project$OutMsg$BackupAuthCodeValidated = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Login$GotCodeCreated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ports$GoogleRecaptcha$Login = 1;
    var $author$project$Pages$Login$VerifyCodeMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ports$GoogleRecaptcha$actionToString = function(action) {
        if (!action) return 'onboard';
        else return 'login';
    };
    var $author$project$Ports$GoogleRecaptcha$getRecaptchaTokenPort = _Platform_outgoingPort('getRecaptchaTokenPort', $elm$json$Json$Encode$string);
    var $author$project$Ports$GoogleRecaptcha$getRecaptchaToken = function(action) {
        return $author$project$Ports$GoogleRecaptcha$getRecaptchaTokenPort($author$project$Ports$GoogleRecaptcha$actionToString(action));
    };
    var $author$project$Api$Auth$authSaltDecoder = A2($elm$json$Json$Decode$field, 'salt', $elm$json$Json$Decode$string);
    var $author$project$Api$Auth$requestCode = F4(function(client, email, recaptchaToken, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('email', $elm$json$Json$Encode$string(email)),
            _Utils_Tuple2('google_recaptcha_token', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, recaptchaToken))
        ]));
        return A4($author$project$Api$Data$post, $author$project$Api$Data$clientDisableAuth(client), $author$project$Api$Auth$authSaltDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'request_code'
        ]), $author$project$Api$Auth$authPath))));
    });
    var $author$project$Components$Auth$RequestCode$EmailSubmitted = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Auth$RequestCode$NoEvent = {
        $: 0
    };
    var $author$project$Components$Auth$RequestCode$formFieldsUpdate = F2(function(field, form) {
        var email = field;
        return _Utils_update(form, {
            OH: email
        });
    });
    var $author$project$Components$Auth$RequestCode$EmailValidation = 0;
    var $author$project$Utils$String$strip = function(string) {
        return A3($elm$core$String$replace, ' ', '', string);
    };
    var $author$project$Components$Auth$RequestCode$validateEmail = function(_v0) {
        var email = _v0.OH;
        var emailText = $author$project$Utils$String$strip(email);
        return !$rtfeldman$elm_validate$Validate$isBlank(emailText) && !$rtfeldman$elm_validate$Validate$isValidEmail(emailText) ? _List_fromArray([
            _Utils_Tuple2(0, 'Please enter a valid email.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Auth$RequestCode$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Auth$RequestCode$validateEmail)
    ]));
    var $author$project$Components$Auth$RequestCode$validateForm = function(model) {
        var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$RequestCode$formFieldsValidator, model.b5);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var form = _v1.a;
            return _Utils_Tuple2(form, true);
        } else {
            var form = _v0.a;
            return _Utils_Tuple2(form, false);
        }
    };
    var $author$project$Components$Auth$RequestCode$validate = function(model) {
        return _Utils_update(model, {
            b5: $author$project$Components$Auth$RequestCode$validateForm(model).a
        });
    };
    var $author$project$Components$Auth$RequestCode$update = F2(function(msg, model) {
        switch(msg.$){
            case 2:
                var field = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    b5: A3($author$project$Utils$Form$update, $author$project$Components$Auth$RequestCode$formFieldsUpdate, field, model.b5)
                }), $author$project$Components$Auth$RequestCode$NoEvent);
            case 0:
                var _v1 = $author$project$Components$Auth$RequestCode$validateForm(model);
                var newForm = _v1.a;
                var isFormValid = _v1.b;
                var newModel = _Utils_update(model, {
                    b5: newForm
                });
                if (isFormValid) {
                    var _v2 = $author$project$Utils$Form$fields(model.b5);
                    var email = _v2.OH;
                    return _Utils_Tuple2(newModel, $author$project$Components$Auth$RequestCode$EmailSubmitted(email));
                } else return _Utils_Tuple2(newModel, $author$project$Components$Auth$RequestCode$NoEvent);
            default:
                return _Utils_Tuple2($author$project$Components$Auth$RequestCode$validate(model), $author$project$Components$Auth$RequestCode$NoEvent);
        }
    });
    var $author$project$Components$Auth$VerifyCode$JWT = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Auth$VerifyCode$NoEvent = {
        $: 0
    };
    var $author$project$Components$Auth$VerifyCode$ResendCode = {
        $: 1
    };
    var $author$project$Components$Auth$VerifyCode$ResponseError = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Auth$VerifyCode$formFieldsUpdate = F2(function(field, form) {
        var code = field;
        return _Utils_update(form, {
            Lk: code
        });
    });
    var $author$project$Components$Auth$VerifyCode$CodeValidation = 0;
    var $rtfeldman$elm_validate$Validate$isInt = function(str) {
        var _v0 = $elm$core$String$toInt(str);
        if (_v0.$ === 1) return false;
        else return true;
    };
    var $author$project$Components$Auth$VerifyCode$validateCode = function(_v0) {
        var code = _v0.Lk;
        return !$rtfeldman$elm_validate$Validate$isInt(code) || $elm$core$String$length(code) !== 6 ? _List_fromArray([
            _Utils_Tuple2(0, 'Code format is not valid.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Auth$VerifyCode$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Auth$VerifyCode$validateCode)
    ]));
    var $author$project$Components$Auth$VerifyCode$validateForm = function(model) {
        var _v0 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$VerifyCode$formFieldsValidator, model.bs);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var form = _v1.a;
            return _Utils_Tuple2(form, true);
        } else {
            var form = _v0.a;
            return _Utils_Tuple2(form, false);
        }
    };
    var $author$project$Components$Auth$VerifyCode$validate = function(model) {
        return _Utils_update(model, {
            bs: $author$project$Components$Auth$VerifyCode$validateForm(model).a
        });
    };
    var $author$project$Components$Auth$VerifyCode$GotCodeValidated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Auth$verifyCode = F5(function(client, email, salt, code, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('email', $elm$json$Json$Encode$string(email)),
            _Utils_Tuple2('code', $elm$json$Json$Encode$string(code)),
            _Utils_Tuple2('salt', $elm$json$Json$Encode$string(salt))
        ]));
        return A4($author$project$Api$Data$post, $author$project$Api$Data$clientDisableAuth(client), $author$project$Api$Auth$authTokenDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Auth$authPath)));
    });
    var $author$project$Components$Auth$VerifyCode$verifyCode = F4(function(apiClient, maybeEmail, maybeSalt, code) {
        var _v0 = _Utils_Tuple2(maybeEmail, maybeSalt);
        if (!_v0.a.$ && !_v0.b.$) {
            var email = _v0.a.a;
            var salt = _v0.b.a;
            return A5($author$project$Api$Auth$verifyCode, apiClient, email, salt, code, $author$project$Components$Auth$VerifyCode$GotCodeValidated);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Auth$VerifyCode$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 2:
                var field = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    bs: A3($author$project$Utils$Form$update, $author$project$Components$Auth$VerifyCode$formFieldsUpdate, field, model.bs)
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$NoEvent);
            case 0:
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Auth$VerifyCode$formFieldsValidator, model.bs);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var newForm = _v2.a;
                    var _v3 = $author$project$Utils$Form$fields(model.bs);
                    var code = _v3.Lk;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bs: newForm,
                        ly: model.ly + 1,
                        O4: $elm$core$Maybe$Nothing,
                        Xv: true,
                        sR: false
                    }), A4($author$project$Components$Auth$VerifyCode$verifyCode, apiClient, model.OH, model.sC, code), $author$project$Components$Auth$VerifyCode$NoEvent);
                } else {
                    var newForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bs: newForm
                    }), $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$NoEvent);
                }
            case 1:
                return _Utils_Tuple3($author$project$Components$Auth$VerifyCode$validate(model), $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$NoEvent);
            case 3:
                return model.Xv ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$NoEvent) : _Utils_Tuple3(_Utils_update(model, {
                    bs: $author$project$Utils$Form$init($author$project$Components$Auth$VerifyCode$formFieldsInit),
                    ly: 0,
                    O4: $elm$core$Maybe$Nothing,
                    sR: true
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$ResendCode);
            default:
                var response = msg.a;
                _v4$2: while(true)switch(response.$){
                    case 3:
                        var token = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$JWT(token));
                    case 2:
                        if (response.a.$ === 6) {
                            var _v5 = response.a;
                            var errorMessage = _v5.b;
                            return _Utils_Tuple3(_Utils_update(model, {
                                O4: $elm$core$Maybe$Just(errorMessage),
                                Xv: false
                            }), $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$NoEvent);
                        } else break _v4$2;
                    default:
                        break _v4$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    Xv: false
                }), $elm$core$Platform$Cmd$none, $author$project$Components$Auth$VerifyCode$ResponseError(response));
        }
    });
    var $author$project$Components$Auth$VerifyCode$withEmail = F2(function(email, model) {
        return _Utils_update(model, {
            OH: $elm$core$Maybe$Just(email)
        });
    });
    var $author$project$Components$Auth$VerifyCode$withSalt = F2(function(salt, model) {
        return _Utils_update(model, {
            sC: $elm$core$Maybe$Just(salt)
        });
    });
    var $author$project$Pages$Login$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var requestCodeMsg = msg.a;
                var _v1 = A2($author$project$Components$Auth$RequestCode$update, requestCodeMsg, model.sv);
                var requestCodeModel = _v1.a;
                var event = _v1.b;
                var newModel = _Utils_update(model, {
                    sv: requestCodeModel
                });
                if (!event.$) return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    var newEmail = event.a;
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        OH: $elm$core$Maybe$Just(newEmail),
                        Xv: true,
                        eT: A2($author$project$Components$Auth$VerifyCode$withEmail, newEmail, model.eT)
                    }), $author$project$Ports$GoogleRecaptcha$getRecaptchaToken(1), _List_Nil);
                }
            case 1:
                var verifyCodeMsg = msg.a;
                var _v3 = A3($author$project$Components$Auth$VerifyCode$update, model.Ej, verifyCodeMsg, model.eT);
                var verifyCodeModel = _v3.a;
                var verifyCmd = _v3.b;
                var event = _v3.c;
                var newModel = _Utils_update(model, {
                    eT: verifyCodeModel
                });
                switch(event.$){
                    case 1:
                        return _Utils_Tuple3(newModel, $author$project$Ports$GoogleRecaptcha$getRecaptchaToken(1), _List_Nil);
                    case 3:
                        var response = event.a;
                        return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd), $author$project$OutMsg$handleErrorResponse(response));
                    case 2:
                        var token = event.a;
                        return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd), _List_fromArray([
                            $author$project$OutMsg$BackupAuthCodeValidated(token)
                        ]));
                    default:
                        return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Login$VerifyCodeMsg, verifyCmd), _List_Nil);
                }
            case 2:
                var result = msg.a;
                var recaptchaToken = $elm$core$Result$toMaybe(result);
                var email = A2($elm$core$Maybe$withDefault, '', model.OH);
                return _Utils_Tuple3(model, A4($author$project$Api$Auth$requestCode, model.Ej, email, recaptchaToken, $author$project$Pages$Login$GotCodeCreated), _List_Nil);
            default:
                var authData = msg.a;
                var newModel = _Utils_update(model, {
                    Xv: false
                });
                _v5$2: while(true)switch(authData.$){
                    case 3:
                        var salt = authData.a;
                        return _Utils_Tuple3(_Utils_update(newModel, {
                            sC: $elm$core$Maybe$Just(salt),
                            eT: A2($author$project$Components$Auth$VerifyCode$withSalt, salt, model.eT)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        if (authData.a.$ === 9) return _Utils_Tuple3(newModel, $elm$browser$Browser$Navigation$reload, _List_Nil);
                        else break _v5$2;
                    default:
                        break _v5$2;
                }
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Ui$Image$HintFullLogo = 12;
    var $author$project$Pages$Login$RequestCodeMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Login$canShowVerifyCode = F2(function(maybeEmail, maybeSalt) {
        return !($author$project$Utils$Maybe$isNothing(maybeEmail) || $author$project$Utils$Maybe$isNothing(maybeSalt));
    });
    var $author$project$Components$Auth$RequestCode$EmailBlurred = {
        $: 1
    };
    var $author$project$Components$Auth$RequestCode$EmailField = $elm$core$Basics$identity;
    var $author$project$Components$Auth$RequestCode$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Auth$RequestCode$SubmitForm = {
        $: 0
    };
    var $author$project$Components$Auth$RequestCode$isSubmitDisabled = F3(function(email, formHasValidationErrors, processingAction) {
        return $author$project$Utils$String$isBlank(email) || formHasValidationErrors || processingAction;
    });
    var $author$project$Ui$Form$Group$LabelAbove = {
        $: 13
    };
    var $author$project$Ui$Form$Group$labelAbove = $author$project$Ui$Form$Group$LabelAbove;
    var $author$project$Utils$HintUrls$statusPageUrl = 'https://status.hint.com/';
    var $author$project$Components$BackupAuthAlert$viewAlertText = _List_fromArray([
        $elm$html$Html$text('Our main sign in system is currently down. Please save your work frequently as you will be signed out automatically when the main system comes back online.'),
        A2($elm$html$Html$br, _List_Nil, _List_Nil),
        $elm$html$Html$text('Thank you for your patience.'),
        $author$project$Utils$Html$noBreakSpace,
        A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$statusPageUrl, _List_Nil, _List_fromArray([
            $elm$html$Html$text('See status page for real-time updates.')
        ]))
    ]);
    var $author$project$Components$Auth$RequestCode$viewBackupAuthAlert = A2($author$project$Ui$Alert$warning, _List_fromArray([
        $author$project$Ui$Alert$margin(25),
        $author$project$Ui$Alert$icon(64),
        $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
    ]), $author$project$Components$BackupAuthAlert$viewAlertText);
    var $author$project$Components$Auth$RequestCode$viewForm = F2(function(model, processingAction) {
        var formHasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 0, model.b5);
        var _v0 = $author$project$Utils$Form$fields(model.b5);
        var email = _v0.OH;
        return A2($elm$html$Html$form, _List_fromArray([
            $elm$html$Html$Events$onSubmit($author$project$Components$Auth$RequestCode$SubmitForm)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Components$Auth$RequestCode$viewBackupAuthAlert,
                    A2($elm$html$Html$br, _List_Nil, _List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Your email'),
                        $author$project$Ui$Form$Group$required(true),
                        $author$project$Ui$Form$Group$labelAbove
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$placeholder('e.g. name@example.com'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Auth$RequestCode$FormUpdated, $elm$core$Basics$identity)),
                            $author$project$Ui$Form$Input$invalid(formHasValidationErrors),
                            $author$project$Ui$Form$Input$value(email),
                            $author$project$Ui$Form$Input$email,
                            $author$project$Ui$Form$Input$onBlur($author$project$Components$Auth$RequestCode$EmailBlurred)
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, model.b5))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Send authentication code'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$fullWidth(true),
                        $author$project$Ui$Button$disabled(A3($author$project$Components$Auth$RequestCode$isSubmitDisabled, email, formHasValidationErrors, processingAction)),
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$loading(processingAction)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Send code')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Auth$RequestCode$viewTermsText = A2($author$project$Ui$Typography$span, _List_fromArray([
        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
    ]), _List_fromArray([
        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('I agree with the ')
        ])),
        A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$termsUrl, _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('Terms')
        ]))
    ]));
    var $author$project$Components$Auth$RequestCode$view = F2(function(model, processingAction) {
        return A2($author$project$Ui$Panel$view, _List_fromArray([
            $author$project$Ui$Panel$extraPadding
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mt4
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        $author$project$Ui$Typography$heading(_List_fromArray([
                            $elm$html$Html$text('Sign in with email')
                        ])),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        A2($author$project$Components$Auth$RequestCode$viewForm, model, processingAction),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $author$project$Components$Auth$RequestCode$viewTermsText
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Auth$VerifyCode$CodeBlurred = {
        $: 1
    };
    var $author$project$Components$Auth$VerifyCode$CodeField = $elm$core$Basics$identity;
    var $author$project$Components$Auth$VerifyCode$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Auth$VerifyCode$ResendCodeMsg = {
        $: 3
    };
    var $author$project$Components$Auth$VerifyCode$SubmitForm = {
        $: 0
    };
    var $author$project$Components$Auth$VerifyCode$codeExhausted = function(codeSubmitAttempts) {
        return codeSubmitAttempts >= 3;
    };
    var $author$project$Components$Auth$VerifyCode$isSubmitDisabled = F3(function(hasValidationErros, processing, codeSubmitAttempts) {
        return hasValidationErros || processing || $author$project$Components$Auth$VerifyCode$codeExhausted(codeSubmitAttempts);
    });
    var $author$project$Components$Auth$VerifyCode$viewCodeError = function(errorMessage) {
        if (!errorMessage.$) {
            var message = errorMessage.a;
            return A2($author$project$Ui$Alert$danger, _List_fromArray([
                $author$project$Ui$Alert$icon(65),
                $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
            ]), _List_fromArray([
                $elm$html$Html$text(message)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Auth$VerifyCode$viewCodeResendMessage = function() {
        var supportEmail = 'support@hint.com';
        var infoText = '\n            If we have an account matching your email address, you will receive\n            an email with a code. If you do not receive an email, please contact\n            us at\n            ';
        return A2($author$project$Ui$Alert$info, _List_fromArray([
            $author$project$Ui$Alert$margin(25),
            $author$project$Ui$Alert$icon(5),
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Code has been resent')
                ]))
            ])),
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(infoText)
            ])),
            A3($author$project$Ui$Link$mailto, supportEmail, _List_Nil, _List_fromArray([
                $elm$html$Html$text(supportEmail)
            ]))
        ]));
    }();
    var $author$project$Components$Auth$VerifyCode$viewEmailSentText = function(email) {
        return A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]), _List_fromArray([
            $elm$html$Html$text('An email with a code has been sent to ' + (email + '. Please enter the code within 15 minutes.'))
        ]));
    };
    var $author$project$Components$Auth$VerifyCode$viewForm = F6(function(email, processing, showCodeResend, codeForm, errorMessage, codeSubmitAttempts) {
        var hasValidationErrors = A2($author$project$Utils$Form$hasValidationErrors, 0, codeForm);
        var _v0 = $author$project$Utils$Form$fields(codeForm);
        var code = _v0.Lk;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Components$Auth$VerifyCode$viewEmailSentText(email),
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Resend verification code'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$Auth$VerifyCode$ResendCodeMsg),
                            $author$project$Ui$Button$disabled(processing)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Resend code')
                        ]))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    showCodeResend ? $author$project$Components$Auth$VerifyCode$viewCodeResendMessage : $author$project$Utils$Html$empty,
                    $author$project$Components$Auth$VerifyCode$viewCodeError(errorMessage)
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Your code'),
                        $author$project$Ui$Form$Group$required(true),
                        $author$project$Ui$Form$Group$labelAbove
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$placeholder('e.g. 123456'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Auth$VerifyCode$FormUpdated, $elm$core$Basics$identity)),
                            $author$project$Ui$Form$Input$invalid(hasValidationErrors),
                            $author$project$Ui$Form$Input$value(code),
                            $author$project$Ui$Form$Input$onBlur($author$project$Components$Auth$VerifyCode$CodeBlurred)
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, codeForm))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Sign in'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$fullWidth(true),
                        $author$project$Ui$Button$disabled(A3($author$project$Components$Auth$VerifyCode$isSubmitDisabled, hasValidationErrors, processing, codeSubmitAttempts)),
                        $author$project$Ui$Button$onClick($author$project$Components$Auth$VerifyCode$SubmitForm),
                        $author$project$Ui$Button$loading(processing)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Sign In')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Auth$VerifyCode$viewTermsText = A2($author$project$Ui$Typography$span, _List_fromArray([
        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
    ]), _List_fromArray([
        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('I agree with the ')
        ])),
        A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$termsUrl, _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('Terms')
        ]))
    ]));
    var $author$project$Components$Auth$VerifyCode$view = function(model) {
        var _v0 = _Utils_Tuple2(model.OH, model.sC);
        if (!_v0.a.$ && !_v0.b.$) {
            var email = _v0.a.a;
            return A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$extraPadding
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$mt4
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                            $author$project$Ui$Typography$heading(_List_fromArray([
                                $elm$html$Html$text('Enter your code')
                            ])),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            A6($author$project$Components$Auth$VerifyCode$viewForm, email, model.Xv, model.sR, model.bs, model.O4, model.ly),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            $author$project$Components$Auth$VerifyCode$viewTermsText
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Login$viewComponents = F5(function(maybeEmail, maybeSalt, processingAction, requestCodeModel, verifyCodeModel) {
        return A2($author$project$Pages$Login$canShowVerifyCode, maybeEmail, maybeSalt) ? A2($elm$html$Html$map, $author$project$Pages$Login$VerifyCodeMsg, $author$project$Components$Auth$VerifyCode$view(verifyCodeModel)) : A2($elm$html$Html$map, $author$project$Pages$Login$RequestCodeMsg, A2($author$project$Components$Auth$RequestCode$view, requestCodeModel, processingAction));
    });
    var $author$project$Ui$Link$CurrentColor = {
        $: 18
    };
    var $author$project$Ui$Link$currentColor = $author$project$Ui$Link$CurrentColor;
    var $author$project$Pages$Login$viewReCaptcha = A2($author$project$Ui$Typography$p, _List_fromArray([
        $author$project$Ui$Typography$muted,
        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
    ]), _List_fromArray([
        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('This site is protected by reCAPTCHA and the Google ')
        ])),
        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Link$externalHref, 'https://policies.google.com/privacy', _List_fromArray([
                $author$project$Ui$Link$targetBlank,
                $author$project$Ui$Link$currentColor
            ]), _List_fromArray([
                $elm$html$Html$text('Privacy Policy')
            ]))
        ])),
        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text(' and ')
        ])),
        A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$attrs(_List_fromArray([
                $elm$html$Html$Attributes$class('inline-block')
            ]))
        ]), _List_fromArray([
            A3($author$project$Ui$Link$externalHref, 'https://policies.google.com/terms', _List_fromArray([
                $author$project$Ui$Link$targetBlank,
                $author$project$Ui$Link$currentColor
            ]), _List_fromArray([
                $elm$html$Html$text('Terms of Service')
            ]))
        ]))
    ]));
    var $author$project$Pages$Login$viewBody = function(model) {
        return model.abT ? A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6),
                    $author$project$Ui$Grid$offset(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$mb4
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$textCenter
                        ]), _List_fromArray([
                            A4($author$project$Ui$Image$view, model.qW, {
                                Jg: 'Hint Logo'
                            }, _List_fromArray([
                                $author$project$Ui$Image$height(55)
                            ]), 12)
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                            A5($author$project$Pages$Login$viewComponents, model.OH, model.sC, model.Xv, model.sv, model.eT)
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            $author$project$Pages$Login$viewReCaptcha
                        ]))
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Login$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Login$viewBody(model)
            ]),
            $2: 'Login'
        };
    };
    var $author$project$Pages$Login$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$Login$init,
        aeR: $author$project$Pages$Login$load,
        ag3: $author$project$Pages$Login$save,
        ahE: $author$project$Pages$Login$subscriptions,
        aaO: $author$project$Pages$Login$update,
        aid: $author$project$Pages$Login$view
    });
    var $author$project$Spa$Page$element = function(page) {
        return {
            aeq: F2(function(_v0, params) {
                var _v1 = page.aeq(params);
                var model = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(model, cmd, _List_Nil);
            }),
            aeR: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
            ag3: $elm$core$Basics$always($elm$core$Basics$identity),
            ahE: page.ahE,
            aaO: F2(function(msg, model) {
                var _v2 = A2(page.aaO, msg, model);
                var newModel = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(newModel, cmd, _List_Nil);
            }),
            aid: page.aid
        };
    };
    var $author$project$Pages$Logout$init = function(_v0) {
        return _Utils_Tuple2({}, $author$project$Ports$Session$logout({
            agy: true
        }));
    };
    var $author$project$Pages$Logout$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Logout$update = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Logout$view = function(_v0) {
        return {
            fb: $author$project$Components$LoadingPage$view,
            $2: 'Logout'
        };
    };
    var $author$project$Pages$Logout$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$Logout$init,
        ahE: $author$project$Pages$Logout$subscriptions,
        aaO: $author$project$Pages$Logout$update,
        aid: $author$project$Pages$Logout$view
    });
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$GotLayerAccount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$init = F4(function(session, practice, shared, _v0) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            l$: $elm$core$Maybe$Nothing,
            yE: $author$project$Api$Data$Loading,
            W1: practice,
            Z$: session
        }, A2($author$project$Api$Provider$Practice$LayerAccount$retrieve, shared.Ej, $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$GotLayerAccount));
    });
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$EditFormMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LayerAccount$One$entityType = function(_v0) {
        var record = _v0.b;
        return record.O1;
    };
    var $author$project$Components$Layer$EditForm$initPhone = function(maybePhone) {
        var phoneToUse = A2($elm$core$Maybe$withDefault, {
            Gx: '',
            agE: 0,
            ah5: $author$project$Api$Common$Phone$Shared$Mobile
        }, A2($elm$core$Maybe$map, $author$project$Utils$Phone$fromApi, maybePhone));
        return A3($author$project$Components$PhoneInput$init, 'layer-account-phone', _List_fromArray([
            phoneToUse
        ]), function(opts) {
            return _Utils_update(opts, {
                abK: false,
                ada: true,
                y_: 1
            });
        });
    };
    var $author$project$Api$Provider$LayerAccount$One$legalName = function(_v0) {
        var record = _v0.b;
        return record.S4;
    };
    var $author$project$Api$Provider$LayerAccount$One$phone = function(_v0) {
        var record = _v0.b;
        return record.WE;
    };
    var $author$project$Api$Provider$LayerAccount$One$smsEnabled = function(_v0) {
        var record = _v0.b;
        return record._C;
    };
    var $author$project$Api$Provider$LayerAccount$One$state = function(_v0) {
        var record = _v0.b;
        return record.s4;
    };
    var $author$project$Api$Provider$LayerAccount$One$tin = function(_v0) {
        var record = _v0.b;
        return record.$1;
    };
    var $author$project$Components$Layer$EditForm$formFieldsInit = function(layerAccount) {
        return {
            O1: $author$project$Api$Provider$LayerAccount$One$entityType(layerAccount),
            S4: $author$project$Api$Provider$LayerAccount$One$legalName(layerAccount),
            WE: $author$project$Components$Layer$EditForm$initPhone($author$project$Api$Provider$LayerAccount$One$phone(layerAccount)),
            _C: $author$project$Api$Provider$LayerAccount$One$smsEnabled(layerAccount),
            s4: $author$project$Api$Provider$LayerAccount$One$state(layerAccount),
            $1: $author$project$Api$Provider$LayerAccount$One$tin(layerAccount)
        };
    };
    var $author$project$Components$Layer$EditForm$init = function(layerAccount) {
        var model = {
            Km: $author$project$Api$Provider$LayerAccount$One$bookkeepingEnabled(layerAccount),
            PU: $author$project$Utils$Form$init($author$project$Components$Layer$EditForm$formFieldsInit(layerAccount)),
            j_: $author$project$Api$Data$NotAsked
        };
        return model;
    };
    var $author$project$Components$Layer$EditForm$GotLayerAccountUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$Phone = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$PhoneInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    S4: $author$project$Utils$String$toMaybe(string)
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    $1: $author$project$Utils$String$toMaybe(string)
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    s4: $author$project$Utils$String$toMaybe(string)
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    O1: $author$project$Utils$String$toMaybe(string)
                });
            case 4:
                var phone = field.a;
                return _Utils_update(fields, {
                    WE: phone
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    _C: bool
                });
        }
    });
    var $author$project$Api$Provider$Practice$LayerAccount$update = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('layer_account', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('legal_name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.S4)),
                _Utils_Tuple2('tin', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.$1)),
                _Utils_Tuple2('state', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.s4)),
                _Utils_Tuple2('entity_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.O1)),
                _Utils_Tuple2('phone_number', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.WF)),
                _Utils_Tuple2('sms_enabled', $elm$json$Json$Encode$bool(fields._C))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$LayerAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$LayerAccount$layerAccountPath)));
    });
    var $author$project$Components$Layer$EditForm$EntityTypeValidation = 3;
    var $author$project$Components$Layer$EditForm$LegalNameValidation = 0;
    var $author$project$Components$Layer$EditForm$PhoneValidation = 4;
    var $author$project$Components$Layer$EditForm$StateValidation = 2;
    var $author$project$Components$Layer$EditForm$formFieldsValidator = function() {
        var validatePhone = function(_v0) {
            var phone = _v0.WE;
            return $author$project$Components$PhoneInput$hasErrors(phone) ? _List_fromArray([
                _Utils_Tuple2(4, '')
            ]) : _List_Nil;
        };
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.S4;
            }, _Utils_Tuple2(0, 'Please enter a legal name.')),
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.s4;
            }, _Utils_Tuple2(2, 'Please select a state.')),
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.O1;
            }, _Utils_Tuple2(3, 'Please enter an entity type.')),
            $rtfeldman$elm_validate$Validate$fromErrors(validatePhone)
        ]));
    }();
    var $author$project$Components$Layer$EditForm$validate = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var form_ = A2($author$project$Utils$Form$set, _Utils_update(fields, {
            WE: $author$project$Components$PhoneInput$validate(fields.WE)
        }), model.PU);
        return A2($elm$core$Result$mapError, function(validatedForm) {
            return _Utils_update(model, {
                PU: validatedForm
            });
        }, A2($elm$core$Result$map, function(_v0) {
            var validatedForm = _v0.a;
            var validFormFields = _v0.b;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: validatedForm
            }), validFormFields);
        }, A2($author$project$Utils$Form$validate, $author$project$Components$Layer$EditForm$formFieldsValidator, form_)));
    };
    var $author$project$Components$Layer$EditForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Layer$EditForm$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v2 = $author$project$Utils$Form$fields(model.PU);
                var phone = _v2.WE;
                var _v3 = A2($author$project$Components$PhoneInput$update, subMsg, phone);
                var phoneInput = _v3.a;
                var phoneCmd = _v3.b;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Layer$EditForm$formFieldsUpdate, $author$project$Components$Layer$EditForm$Phone(phoneInput), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Layer$EditForm$PhoneInputMsg, phoneCmd), _List_Nil);
            case 2:
                var _v4 = $author$project$Components$Layer$EditForm$validate(model);
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var newModel = _v5.a;
                    var validFormFields = _v5.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var phoneNumber = A2($elm$core$Maybe$map, function($) {
                        return $.Gx;
                    }, A2($elm$core$Maybe$map, $author$project$Utils$Phone$toRecord, $elm$core$List$head(A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Components$PhoneInput$getPhones(fields.WE)))));
                    var apiFields = {
                        O1: fields.O1,
                        S4: fields.S4,
                        WF: phoneNumber,
                        _C: fields._C,
                        s4: fields.s4,
                        $1: fields.$1
                    };
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        j_: $author$project$Api$Data$Loading
                    }), A3($author$project$Api$Provider$Practice$LayerAccount$update, apiClient, apiFields, $author$project$Components$Layer$EditForm$GotLayerAccountUpdated), _List_Nil);
                } else {
                    var newModel = _v4.a;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Account updated successfully')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            if (response.$ === 3) {
                var layerAccount = response.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    l$: $elm$core$Maybe$Just($author$project$Components$Layer$EditForm$init(layerAccount)),
                    yE: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            } else return _Utils_Tuple3(_Utils_update(model, {
                yE: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var editFormMsg = msg.a;
            var _v2 = model.l$;
            if (!_v2.$) {
                var editForm = _v2.a;
                var _v3 = A3($author$project$Components$Layer$EditForm$update, model.Ej, editFormMsg, editForm);
                var newEditForm = _v3.a;
                var editFormCmd = _v3.b;
                var outMsgs = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    l$: $elm$core$Maybe$Just(newEditForm)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$EditFormMsg, editFormCmd), outMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Layer$EditForm$UpdateLayerAccount = {
        $: 2
    };
    var $author$project$Components$Layer$EditForm$viewCountryInput = A2($author$project$Ui$Form$Group$view, _List_fromArray([
        $author$project$Ui$Form$Group$labelSpan(4),
        $author$project$Ui$Form$Group$inputSpan(8),
        $author$project$Ui$Form$Group$label('Country')
    ]), _List_fromArray([
        $author$project$Ui$Form$Input$view(_List_fromArray([
            $author$project$Ui$Form$Input$value('United States'),
            $author$project$Ui$Form$Input$disabled(true)
        ]))
    ]));
    var $author$project$Components$Layer$EditForm$EntityType = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$entityTypeOptions = A2($elm$core$List$map, function(_v0) {
        var type_ = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(type_), label);
    }, _List_fromArray([
        _Utils_Tuple2('', 'Select an entity type'),
        _Utils_Tuple2('SOLE_PROP', 'Sole Proprietor'),
        _Utils_Tuple2('C_CORP', 'C Corp'),
        _Utils_Tuple2('LLC', 'LLC'),
        _Utils_Tuple2('S_CORP', 'S Corp'),
        _Utils_Tuple2('PARTNERSHIP', 'Partnership')
    ]));
    var $author$project$Components$Layer$EditForm$viewEntityTypeInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var entityType = _v0.O1;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Entity Type'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(entityType),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$EntityType)),
                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
            ]), $author$project$Components$Layer$EditForm$entityTypeOptions)
        ]));
    };
    var $author$project$Components$Layer$EditForm$LegalName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$viewLegalNameInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var legalName = _v0.S4;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Legal Name')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', legalName)),
                $author$project$Ui$Form$Input$placeholder('Legal Name'),
                $author$project$Ui$Form$Input$autofocus(true),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$LegalName)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    };
    var $author$project$Components$Layer$EditForm$viewPhoneNumberInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var phone = _v0.WE;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Phone Number')
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Layer$EditForm$PhoneInputMsg, $author$project$Components$PhoneInput$view(phone))
        ]));
    };
    var $author$project$Components$Layer$EditForm$SmsEnabled = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$viewSmsEnabledInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var smsEnabled = _v0._C;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(smsEnabled),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$SmsEnabled))
            ]), _List_fromArray([
                $elm$html$Html$text('I agree to receive SMS messages at the phone number provided above')
            ]))
        ]));
    };
    var $author$project$Components$Layer$EditForm$State = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$stateOptions = A2($elm$core$List$map, function(_v0) {
        var code = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(code), label);
    }, A2($elm$core$List$cons, _Utils_Tuple2('', 'Select a state'), $author$project$Utils$State$list));
    var $author$project$Components$Layer$EditForm$viewStateInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var state = _v0.s4;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('State'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(state),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$State)),
                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
            ]), $author$project$Components$Layer$EditForm$stateOptions)
        ]));
    };
    var $author$project$Components$Layer$EditForm$Tin = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Layer$EditForm$TinValidation = 1;
    var $author$project$Components$Layer$EditForm$viewTinInput = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var tin = _v0.$1;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('TIN')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', tin)),
                $author$project$Ui$Form$Input$placeholder('123456789'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Layer$EditForm$FormUpdated, $author$project$Components$Layer$EditForm$Tin)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
            ]))
        ]));
    };
    var $author$project$Components$Layer$EditForm$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$onSubmit($author$project$Components$Layer$EditForm$UpdateLayerAccount),
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            $author$project$Components$Layer$EditForm$viewLegalNameInput(model.PU),
            $author$project$Components$Layer$EditForm$viewTinInput(model.PU),
            $author$project$Components$Layer$EditForm$viewStateInput(model.PU),
            $author$project$Components$Layer$EditForm$viewCountryInput,
            $author$project$Components$Layer$EditForm$viewEntityTypeInput(model.PU),
            model.Km ? $author$project$Components$Layer$EditForm$viewPhoneNumberInput(model.PU) : $elm$html$Html$text(''),
            model.Km ? $author$project$Components$Layer$EditForm$viewSmsEnabledInput(model.PU) : $elm$html$Html$text(''),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyCenter,
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Save account'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit,
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.l$;
                    if (!_v0.$) {
                        var editForm = _v0.a;
                        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$EditFormMsg, $author$project$Components$Layer$EditForm$view(editForm))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]),
            $2: 'Layer Settings'
        };
    };
    var $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$init,
        aeR: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$load,
        ag3: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$save,
        ahE: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$subscriptions,
        aaO: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$update,
        aid: $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$view
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElation = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$Initial = 0;
    var $author$project$Api$Provider$ElationConfiguration$One$ElationConfiguration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ElationConfiguration$Shared$ElationConfiguration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ElationConfiguration$Shared$Record = F5(function(status, allowNewPatientCreation, sendEligibilityStatusTag, elationPracticeName, elationPracticeId) {
        return {
            Ja: allowNewPatientCreation,
            OB: elationPracticeId,
            OC: elationPracticeName,
            ZR: sendEligibilityStatusTag,
            ahy: status
        };
    });
    var $author$project$Api$Provider$ElationConfiguration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'elation_practice_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'elation_practice_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'send_eligibility_status_tag', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'allow_new_patient_creation', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$Shared$Record))))));
    var $author$project$Api$Provider$ElationConfiguration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ElationConfiguration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ElationConfiguration$One$Record = function(practitionersCount) {
        return {
            Xd: practitionersCount
        };
    };
    var $author$project$Api$Provider$ElationConfiguration$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioners_count', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$One$Record));
    var $author$project$Api$Provider$ElationConfiguration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ElationConfiguration$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ElationConfiguration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ElationConfiguration$One$ElationConfiguration)));
    var $author$project$Api$Provider$Integration$Elation$elationPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'elation_configuration'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Integration$Elation$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$ElationConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath));
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            d0: $elm$core$Maybe$Nothing,
            iA: $elm$core$Set$empty,
            _: $author$project$Api$Data$Loading,
            l2: $author$project$Api$Data$NotAsked,
            l3: $author$project$Api$Data$NotAsked,
            PU: $elm$core$Maybe$Nothing,
            qW: shared.qW,
            j_: $author$project$Api$Data$NotAsked,
            _8: 0
        }, A2($author$project$Api$Provider$Integration$Elation$retrieve, shared.Ej, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElation));
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$DisableConfirmed = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$subscriptions = function(model) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Marketplace$Elation$Manage$Settings$DisableConfirmed)), model.d0));
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$Activated = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$Disabled = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviderMappings = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviders = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$GotProviderMapping = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$LinkStep = 1;
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$OverviewStep = 3;
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$ProvidersStep = 2;
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$Updated = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Elation$activate = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$ElationConfiguration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'activate'
        ]), $author$project$Api$Provider$Integration$Elation$elationPath)));
    });
    var $author$project$Api$Provider$ElationConfiguration$Shared$allowNewPatientCreation = function(_v0) {
        var record = _v0;
        return record.Ja;
    };
    var $author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ElationConfiguration$Shared$allowNewPatientCreation(shared);
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$Created = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Elation$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('elation_configuration', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('username', $elm$json$Json$Encode$string(fields.aib)),
                _Utils_Tuple2('password', $elm$json$Json$Encode$string(fields.af2)),
                _Utils_Tuple2('client_id', $elm$json$Json$Encode$string(fields.acq)),
                _Utils_Tuple2('client_secret', $elm$json$Json$Encode$string(fields.acr))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$ElationConfiguration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath)));
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$createElation = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Integration$Elation$create, apiClient, fields, $author$project$Pages$Marketplace$Elation$Manage$Settings$Created);
    });
    var $author$project$Api$Provider$Integration$Elation$delete = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath));
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsInit = {
        acq: '',
        acr: '',
        af2: '',
        aib: ''
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    aib: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    af2: string
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    acq: string
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    acr: string
                });
        }
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientIdValidation = 2;
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientSecretValidation = 3;
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$PasswordValidation = 1;
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$UserNameValidation = 0;
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.aib;
        }, _Utils_Tuple2(0, 'Please enter a username')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.af2;
        }, _Utils_Tuple2(1, 'Please enter a password')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.acq;
        }, _Utils_Tuple2(2, 'Please enter a client id')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.acr;
        }, _Utils_Tuple2(3, 'Please enter a client secret'))
    ]));
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$id(shared);
    };
    var $author$project$Api$Provider$Integration$Elation$Provider$All$Provider = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Elation$Provider$Shared$Provider = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Elation$Provider$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Integration$Elation$Provider$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Elation$Provider$Shared$Record)));
    var $author$project$Api$Provider$Integration$Elation$Provider$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Elation$Provider$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Elation$Provider$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Elation$Provider$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Elation$Provider$providersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'providers'
    ]), $author$project$Api$Provider$Integration$Elation$elationPath);
    var $author$project$Api$Provider$Integration$Elation$Provider$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Elation$Provider$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$Provider$providersPath));
    });
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$ProviderMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$ProviderMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$Record = F3(function(id, name, externalId) {
        return {
            adE: externalId,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$Record))));
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'provider_mappings'
    ]), $author$project$Api$Provider$Integration$Elation$elationPath);
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Integration$Elation$ProviderMapping$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath));
    });
    var $author$project$Api$Provider$ElationConfiguration$Shared$sendEligibilityStatusTag = function(_v0) {
        var record = _v0;
        return record.ZR;
    };
    var $author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ElationConfiguration$Shared$sendEligibilityStatusTag(shared);
    };
    var $author$project$Api$Provider$Integration$Elation$update = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('elation_configuration', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('allow_new_patient_creation', $elm$json$Json$Encode$bool(fields.Ja)),
                _Utils_Tuple2('send_eligibility_status_tag', $elm$json$Json$Encode$bool(fields.ZR))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$ElationConfiguration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$elationPath)));
    });
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$One$ProviderMapping = 0;
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingsPath);
    };
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('provider_mapping', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('external_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adE))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Integration$Elation$ProviderMapping$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Elation$ProviderMapping$providerMappingPath(id))));
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            _: response,
                            _8: 3
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                _: response,
                                PU: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsInit)),
                                _8: 0
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    _: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsInit)),
                    _8: 1
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var field = msg.a;
                var _v3 = model.PU;
                if (!_v3.$) {
                    var form = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(A3($author$project$Utils$Form$update, $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsUpdate, field, form))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v4 = model.PU;
                if (!_v4.$) {
                    var form = _v4.a;
                    var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsValidator, form);
                    if (!_v5.$) {
                        var _v6 = _v5.a;
                        var newForm = _v6.a;
                        var validFormFields = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$Loading
                        }), A2($author$project$Pages$Marketplace$Elation$Manage$Settings$createElation, model.Ej, validFormFields), _List_Nil);
                    } else {
                        var newForm = _v5.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    _: response,
                    PU: $elm$core$Maybe$Nothing,
                    j_: $author$project$Api$Data$NotAsked,
                    _8: 3
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your elation credentials have been saved.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    l2: $author$project$Api$Data$Loading,
                    l3: $author$project$Api$Data$Loading,
                    _8: 2
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Api$Provider$Integration$Elation$Provider$list, model.Ej, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviders),
                    A2($author$project$Api$Provider$Integration$Elation$ProviderMapping$list, model.Ej, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviderMappings)
                ])), _List_Nil);
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    _8: 3
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    l3: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    iA: $elm$core$Set$empty,
                    l2: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(_Utils_update(model, {
                    l2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                return _Utils_Tuple3(_Utils_update(model, {
                    l3: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Elation$Provider$list, model.Ej, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviders), _List_Nil);
            case 10:
                var elationProviderMapping = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    iA: A2($elm$core$Set$insert, $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping), model.iA)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var elationProviderMapping = msg.a;
                var elationProviderId = msg.b;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$Integration$Elation$ProviderMapping$update, model.Ej, $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping), {
                    adE: $author$project$Utils$String$toMaybe(elationProviderId)
                }, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotProviderMapping), _List_Nil);
            case 12:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Api$Provider$Integration$Elation$ProviderMapping$list, model.Ej, $author$project$Pages$Marketplace$Elation$Manage$Settings$GotElationProviderMappings), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your elation provider has been updated.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 13:
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Provider$Integration$Elation$activate, model.Ej, $author$project$Pages$Marketplace$Elation$Manage$Settings$Activated), _List_Nil);
            case 14:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    _: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been activated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 15:
                var allowNewPatientCreation = msg.a;
                var sendEligibilityStatusTag = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag, $author$project$Api$Data$toMaybe(model._)));
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Integration$Elation$update, model.Ej, {
                    Ja: allowNewPatientCreation,
                    ZR: sendEligibilityStatusTag
                }, $author$project$Pages$Marketplace$Elation$Manage$Settings$Updated), _List_Nil);
            case 16:
                var sendEligibilityStatusTag = msg.a;
                var allowNewPatientCreation = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation, $author$project$Api$Data$toMaybe(model._)));
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Integration$Elation$update, model.Ej, {
                    Ja: allowNewPatientCreation,
                    ZR: sendEligibilityStatusTag
                }, $author$project$Pages$Marketplace$Elation$Manage$Settings$Updated), _List_Nil);
            case 17:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    _: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been updated.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 18:
                return _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
                }), A2($author$project$Api$Provider$Integration$Elation$delete, model.Ej, $author$project$Pages$Marketplace$Elation$Manage$Settings$Disabled), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Nothing,
                    _: $author$project$Api$Data$Failure($author$project$Api$Data$NotFound),
                    PU: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Pages$Marketplace$Elation$Manage$Settings$formFieldsInit)),
                    _8: 0
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your elation integration has been disabled.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    d0: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$SaveCredentials = {
        $: 3
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewDisableModal = function(model) {
        var _v0 = model.d0;
        if (!_v0.$) {
            var disablingRequest = _v0.a;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Marketplace$Elation$Manage$Settings$DisableConfirmed, _List_fromArray([
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    $elm$html$Html$text('Please confirm you would like to deactivate the Elation integration.')
                ])),
                $author$project$Components$HiConfirm$loading(_Utils_eq(disablingRequest, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Image$ElationEMRBlueLogo = 7;
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$Activate = {
        $: 13
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToOverview = {
        $: 6
    };
    var $author$project$Api$Provider$ElationConfiguration$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$ElationConfiguration$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ElationConfiguration$Shared$status(shared);
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewFooter = function(model) {
        var _v0 = model._8;
        switch(_v0){
            case 0:
                return $author$project$Ui$Panel$none;
            case 1:
                return A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Go to next step'
                    }, _List_fromArray([
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Next')
                    ]))
                ]));
            case 2:
                return A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Go to next step'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$GoToOverview),
                        $author$project$Ui$Button$primary
                    ]), _List_fromArray([
                        $elm$html$Html$text('Next')
                    ]))
                ]));
            default:
                var status = A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$status, $author$project$Api$Data$toMaybe(model._));
                return !_Utils_eq(status, $elm$core$Maybe$Just('active')) ? A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Activate integration'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$Activate),
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Activate')
                    ]))
                ])) : $author$project$Ui$Panel$none;
        }
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToLink = {
        $: 1
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewConfigureInfo = A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
        $elm$html$Html$text('To configure this integration, contact the Elation Integrations team  at '),
        A3($author$project$Ui$Link$mailto, 'integrations@elationhealth.com', _List_fromArray([
            $author$project$Ui$Link$targetBlank
        ]), _List_fromArray([
            $elm$html$Html$text('integrations@elationhealth.com')
        ])),
        $elm$html$Html$text(' and request an Elation-Hint API integration.')
    ]));
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatus = F2(function(status, content) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Status'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Badge$fromString, _List_Nil, status), content))
        ]));
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewInitialStep = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        A2($author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatus, 'inactive', _List_Nil),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Enable Elation Integration'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$GoToLink),
                $author$project$Ui$Button$primary
            ]), _List_fromArray([
                $elm$html$Html$text('Enable Elation Integration')
            ]))
        ])),
        $author$project$Ui$HorizontalRule$view(_List_Nil),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('About'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Used by physicians to manage every aspects of patient care, '),
                    A3($author$project$Ui$Link$externalHref, 'https://www.elationhealth.com/', _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $elm$html$Html$text('Elation')
                    ])),
                    $elm$html$Html$text(' is an intuitive, easy to use solution that helps you quickly find, digest, '),
                    $elm$html$Html$text('and act upon relevant clinical information to care for your patients. ')
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Our integration with Elation will automatically create and synchronize patient contact, '),
                    $elm$html$Html$text('demographic and membership information between Hint and Elation.')
                ])),
                $author$project$Pages$Marketplace$Elation$Manage$Settings$viewConfigureInfo,
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Hint provides this integration only as a convenience to you. '),
                    $elm$html$Html$text('Elation is solely responsible for its service, content and policies, '),
                    $elm$html$Html$text('including those related to privacy and security. '),
                    $elm$html$Html$text('Please review Elation\'s Terms of Service and Privacy Policy '),
                    $elm$html$Html$text('to ensure they meet your business and legal requirements.')
                ]))
            ]))
        ]))
    ]));
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewInitialStepSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Status'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('inactive')
                ]))
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Enable Elation Integration')
            ]))
        ])),
        $author$project$Ui$HorizontalRule$view(_List_Nil),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('About'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(8)
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(7)
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(8)
                ]))
            ]))
        ]))
    ]));
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$integrationExists = function(model) {
        var _v0 = model._;
        if (_v0.$ === 3) return true;
        else return false;
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientId = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientSecret = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$Password = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$UserName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewLinkForm = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Connect Elation Account')
            ])),
            $author$project$Pages$Marketplace$Elation$Manage$Settings$viewConfigureInfo,
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Username'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.aib),
                    $author$project$Ui$Form$Input$autoComplete(false),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Elation$Manage$Settings$UserName)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Password'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$PasswordInput$view(_List_fromArray([
                    $author$project$Ui$Form$PasswordInput$value(fields.af2),
                    $author$project$Ui$Form$PasswordInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Elation$Manage$Settings$Password)),
                    $author$project$Ui$Form$PasswordInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$PasswordInput$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Client Id'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.acq),
                    $author$project$Ui$Form$Input$autoComplete(false),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientId)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Client Secret'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$PasswordInput$view(_List_fromArray([
                    $author$project$Ui$Form$PasswordInput$value(fields.acr),
                    $author$project$Ui$Form$PasswordInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Marketplace$Elation$Manage$Settings$FormUpdated, $author$project$Pages$Marketplace$Elation$Manage$Settings$ClientSecret)),
                    $author$project$Ui$Form$PasswordInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                    $author$project$Ui$Form$PasswordInput$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$Disable = {
        $: 18
    };
    var $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeId = function(_v0) {
        var record = _v0;
        return record.OB;
    };
    var $author$project$Api$Provider$ElationConfiguration$One$elationPracticeId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeId(shared);
    };
    var $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeName = function(_v0) {
        var record = _v0;
        return record.OC;
    };
    var $author$project$Api$Provider$ElationConfiguration$One$elationPracticeName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ElationConfiguration$Shared$elationPracticeName(shared);
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatusWithDeactivate = function(model) {
        var elationConfiguration_ = $author$project$Api$Data$toMaybe(model._);
        var status = A2($elm$core$Maybe$withDefault, 'pending', A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$status, elationConfiguration_));
        return A2($author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatus, status, _List_fromArray([
            function() {
                var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ElationConfiguration$One$elationPracticeName, elationConfiguration_);
                if (!_v0.$) {
                    var elationPracticeName = _v0.a;
                    return A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$margin(11)
                    ]), _List_fromArray([
                        $elm$html$Html$text('at '),
                        $elm$html$Html$text(elationPracticeName),
                        $elm$html$Html$text(' (Practice ID: '),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ElationConfiguration$One$elationPracticeId, elationConfiguration_))),
                        $elm$html$Html$text(')')
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                if (!elationConfiguration_.$) return A3($author$project$Ui$Button$view, {
                    abP: 'Deactivate integration'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$Disable),
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$pull(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Deactivate the integration')
                ]));
                else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToProviders = {
        $: 5
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStepBreadcrumbs = F2(function(hasIntegration, currentStep) {
        var steps = _List_fromArray([
            _Utils_Tuple2(1, 'Connect Account'),
            _Utils_Tuple2(2, 'Link Providers'),
            _Utils_Tuple2(3, 'Overview')
        ]);
        var stepMsg = function(step) {
            switch(step){
                case 1:
                    return $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToLink;
                case 2:
                    return $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToProviders;
                case 3:
                    return $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToOverview;
                default:
                    return $author$project$Pages$Marketplace$Elation$Manage$Settings$GoToLink;
            }
        };
        var isClickable = function(step) {
            return !_Utils_eq(step, currentStep) && (step === 1 || hasIntegration);
        };
        return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$intersperse, A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$muted
        ]), _List_fromArray([
            $elm$html$Html$text(' > ')
        ])), A2($elm$core$List$map, function(_v0) {
            var step = _v0.a;
            var label = _v0.b;
            return _Utils_eq(step, currentStep) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$bold
            ]), _List_fromArray([
                $elm$html$Html$text(label)
            ])) : isClickable(step) ? A3($author$project$Ui$Button$view, {
                abP: label
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$onClick(stepMsg(step))
            ]), _List_fromArray([
                $elm$html$Html$text(label)
            ])) : A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text(label)
            ]));
        }, steps)));
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewLinkStep = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatusWithDeactivate(model),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Pages$Marketplace$Elation$Manage$Settings$viewStepBreadcrumbs, $author$project$Pages$Marketplace$Elation$Manage$Settings$integrationExists(model), 1),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            function() {
                var _v0 = model.PU;
                if (!_v0.$) {
                    var form = _v0.a;
                    return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewLinkForm(form);
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$ToggleEligibilityStatusTag = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$ToggleNewPatientCreation = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Api$Provider$ElationConfiguration$One$practitionersCount = function(_v0) {
        var record = _v0.b;
        return record.Xd;
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewOverviewStep = function(model) {
        var elationConfiguration = $author$project$Api$Data$toMaybe(model._);
        var practitionersCount = A2($elm$core$Maybe$withDefault, $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$spanFromText('100')
        ])), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$ElationConfiguration$One$practitionersCount, A2($elm$core$Basics$composeR, $elm$core$String$fromInt, $elm$html$Html$text)), elationConfiguration));
        var sendEligibilityStatusTag = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$sendEligibilityStatusTag, elationConfiguration));
        var allowNewPatientCreation = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$ElationConfiguration$One$allowNewPatientCreation, elationConfiguration));
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatusWithDeactivate(model),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Pages$Marketplace$Elation$Manage$Settings$viewStepBreadcrumbs, $author$project$Pages$Marketplace$Elation$Manage$Settings$integrationExists(model), 3),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Number of Providers Linked'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    practitionersCount
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Create patients from Elation'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(allowNewPatientCreation),
                    $author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Marketplace$Elation$Manage$Settings$ToggleNewPatientCreation),
                    $author$project$Ui$ToggleSwitch$disabled(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                ])),
                allowNewPatientCreation ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Update linked patients with changes from Elation Health. If a patient is '),
                        $elm$html$Html$text('not found, create a new record in Hint. This is suggested for direct '),
                        $elm$html$Html$text('care practices.')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Note: Only patients assigned to Elation physicians linked to Hint '),
                        $elm$html$Html$text('will be created in Hint.')
                    ]))
                ])) : A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Update linked patients with changes from Elation Health. If a patient is '),
                    $elm$html$Html$text('not found, '),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text('do not create')
                    ])),
                    $elm$html$Html$text(' a record in Hint. This is suggested for hybrid practices '),
                    $elm$html$Html$text('that have both fee-for-service as well as direct care patients.')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Send Eligibility Status tag'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(sendEligibilityStatusTag),
                    $author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Marketplace$Elation$Manage$Settings$ToggleEligibilityStatusTag),
                    $author$project$Ui$ToggleSwitch$disabled(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('When enabled, the Eligibility Status tag will be sent to Elation Health '),
                    $elm$html$Html$text('during patient synchronization.')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$RefreshElationProviders = {
        $: 9
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$EditElationProviderMapping = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$UpdateProviderMapping = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Integration$Elation$Provider$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Integration$Elation$Provider$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Elation$Provider$Shared$id(shared);
    };
    var $author$project$Api$Provider$Integration$Elation$Provider$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Integration$Elation$Provider$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Elation$Provider$Shared$name(shared);
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$elationProvidersOptions = function(elationProviders) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_fromArray([
            $author$project$Ui$Form$Select$itemDisabled(true)
        ]), $elm$core$Maybe$Nothing, 'Choose Elation Provider'), A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Unlink this Provider'), A2($elm$core$List$map, function(elationProvider) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt($author$project$Api$Provider$Integration$Elation$Provider$All$id(elationProvider))), $author$project$Api$Provider$Integration$Elation$Provider$All$name(elationProvider));
        }, elationProviders)));
    };
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$externalId = function(_v0) {
        var record = _v0;
        return record.adE;
    };
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$externalId(shared);
    };
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Integration$Elation$ProviderMapping$Shared$name(shared);
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewElationProviderMapping = F3(function(editingProviderMappings, elationProviders, elationProviderMapping) {
        var isEditingElationProviderMapping = A2($elm$core$Set$member, $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$id(elationProviderMapping), editingProviderMappings);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    $elm$html$Html$text('Hint provider: '),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Integration$Elation$ProviderMapping$All$name(elationProviderMapping))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(1)
                ]), _List_fromArray([
                    $author$project$Ui$Icon$arrowRight(_List_Nil)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('Elation provider: ')
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3)
                ]), _List_fromArray([
                    function() {
                        if (isEditingElationProviderMapping) return A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$value($author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId(elationProviderMapping)),
                            $author$project$Ui$Form$Select$onChange($author$project$Pages$Marketplace$Elation$Manage$Settings$UpdateProviderMapping(elationProviderMapping))
                        ]), $author$project$Pages$Marketplace$Elation$Manage$Settings$elationProvidersOptions(elationProviders));
                        else {
                            var elationProvider = A2($elm_community$list_extra$List$Extra$find, function(elationProvider_) {
                                return _Utils_eq($elm$core$Maybe$Just($elm$core$String$fromInt($author$project$Api$Provider$Integration$Elation$Provider$All$id(elationProvider_))), $author$project$Api$Provider$Integration$Elation$ProviderMapping$All$externalId(elationProviderMapping));
                            }, elationProviders);
                            return A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Not linked', A2($elm$core$Maybe$map, $author$project$Api$Provider$Integration$Elation$Provider$All$name, elationProvider)))
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Edit provider mapping'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$sm,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$EditElationProviderMapping(elationProviderMapping)),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Edit')
                                ]))
                            ]));
                        }
                    }()
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersListSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$repeat, 10, A2($author$project$Ui$Grid$row, _List_fromArray([
        $author$project$Ui$Grid$rowItemsCenter
    ]), _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(6)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Hint Provider: ')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(8),
                    $author$project$Ui$Skeleton$spanMd(4)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(1)
        ]), _List_Nil),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(2)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Elation provider: ')
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(3)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ]))
    ]))));
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersStepSkeleton = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(9),
                $author$project$Ui$Grid$spanMd(8),
                $author$project$Ui$Grid$spanSm(7)
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Link Providers')
                    ]))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Link providers in Hint with their records in Elation Health.')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(3),
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$spanSm(5),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Refresh Elation Providers')
                ]))
            ]))
        ])),
        $author$project$Ui$HorizontalRule$view(_List_Nil),
        $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersListSkeleton
    ]));
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersContent = function(model) {
        var _v0 = _Utils_Tuple2(model.l3, model.l2);
        _v0$2: while(true){
            _v0$3: while(true)switch(_v0.a.$){
                case 3:
                    switch(_v0.b.$){
                        case 3:
                            var _v1 = _v0.a;
                            var elationProviders = _v1.a;
                            var _v2 = _v0.b;
                            var elationProviderMappings = _v2.a;
                            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanLg(9),
                                        $author$project$Ui$Grid$spanMd(8),
                                        $author$project$Ui$Grid$spanSm(7)
                                    ]), _List_fromArray([
                                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                                            $elm$html$Html$text('Link Providers')
                                        ])),
                                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Link providers in Hint with their records in Elation Health. '),
                                            $elm$html$Html$text('A patient is required to have a linked provider assigned in Hint for a new chart to be created in Elation. '),
                                            $elm$html$Html$text('If a patient does not have a linked provider assigned in Hint, they will not sync to elation.')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$spanLg(3),
                                        $author$project$Ui$Grid$spanMd(4),
                                        $author$project$Ui$Grid$spanSm(5),
                                        $author$project$Ui$Grid$justifyRight
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Refresh Elation Providers'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Elation$Manage$Settings$RefreshElationProviders),
                                            $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Refresh Elation Providers')
                                        ]))
                                    ]))
                                ])),
                                $author$project$Ui$HorizontalRule$view(_List_Nil),
                                A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, A2($author$project$Pages$Marketplace$Elation$Manage$Settings$viewElationProviderMapping, model.iA, elationProviders), elationProviderMappings))
                            ]));
                        case 2:
                            break _v0$2;
                        default:
                            break _v0$3;
                    }
                case 2:
                    return A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]), _List_fromArray([
                        $elm$html$Html$text('Failed to load Elation providers. Please try refreshing.')
                    ]));
                default:
                    if (_v0.b.$ === 2) break _v0$2;
                    else break _v0$3;
            }
            return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersStepSkeleton;
        }
        return A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$danger
        ]), _List_fromArray([
            $elm$html$Html$text('Failed to load provider mappings. Please try refreshing.')
        ]));
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersStep = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Pages$Marketplace$Elation$Manage$Settings$viewStatusWithDeactivate(model),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Pages$Marketplace$Elation$Manage$Settings$viewStepBreadcrumbs, $author$project$Pages$Marketplace$Elation$Manage$Settings$integrationExists(model), 2),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersContent(model)
        ]));
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$viewPanel = function(model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A4($author$project$Ui$Image$view, model.qW, {
                    Jg: 'ElationEMR Logo'
                }, _List_fromArray([
                    $author$project$Ui$Image$width(200)
                ]), 7)
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, function() {
                var _v0 = model._;
                if (_v0.$ === 1) return _List_fromArray([
                    $author$project$Pages$Marketplace$Elation$Manage$Settings$viewInitialStepSkeleton
                ]);
                else return _List_fromArray([
                    function() {
                        var _v1 = model._8;
                        switch(_v1){
                            case 0:
                                return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewInitialStep;
                            case 1:
                                return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewLinkStep(model);
                            case 2:
                                return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewProvidersStep(model);
                            default:
                                return $author$project$Pages$Marketplace$Elation$Manage$Settings$viewOverviewStep(model);
                        }
                    }()
                ]);
            }()),
            $author$project$Pages$Marketplace$Elation$Manage$Settings$viewFooter(model)
        ]));
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Marketplace$Elation$Manage$Settings$viewDisableModal(model),
                function() {
                    var _v0 = model._8;
                    if (_v0 === 1) return A2($author$project$Ui$Form$view, _List_fromArray([
                        $author$project$Ui$Form$horizontal,
                        $author$project$Ui$Form$noValidate(true),
                        $author$project$Ui$Form$autocomplete(false),
                        $author$project$Ui$Form$onSubmit($author$project$Pages$Marketplace$Elation$Manage$Settings$SaveCredentials)
                    ]), _List_fromArray([
                        $author$project$Pages$Marketplace$Elation$Manage$Settings$viewPanel(model)
                    ]));
                    else return A2($author$project$Ui$Form$view, _List_fromArray([
                        $author$project$Ui$Form$horizontal,
                        $author$project$Ui$Form$noValidate(true),
                        $author$project$Ui$Form$autocomplete(false)
                    ]), _List_fromArray([
                        $author$project$Pages$Marketplace$Elation$Manage$Settings$viewPanel(model)
                    ]));
                }()
            ]),
            $2: 'Marketplace | Elation Settings'
        };
    };
    var $author$project$Pages$Marketplace$Elation$Manage$Settings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Marketplace$Elation$Manage$Settings$init,
        aeR: $author$project$Pages$Marketplace$Elation$Manage$Settings$load,
        ag3: $author$project$Pages$Marketplace$Elation$Manage$Settings$save,
        ahE: $author$project$Pages$Marketplace$Elation$Manage$Settings$subscriptions,
        aaO: $author$project$Pages$Marketplace$Elation$Manage$Settings$update,
        aid: $author$project$Pages$Marketplace$Elation$Manage$Settings$view
    });
    var $author$project$Pages$Marketplace$Manage$GotProducts = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Marketplace$Product$All$Product = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Marketplace$Product$All$Product = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Marketplace$Product$All$Record = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Provider$Marketplace$Product$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Marketplace$Product$All$Record));
    var $author$project$Api$Provider$Marketplace$Product$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Marketplace$Product$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$All$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Marketplace$Product$All$Product)));
    var $author$project$Api$Provider$Marketplace$Product$productsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'marketplace',
        'products'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Marketplace$Product$listManageable = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Marketplace$Product$All$decoder), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'managed'
        ]), $author$project$Api$Provider$Marketplace$Product$productsPath)));
    });
    var $author$project$Pages$Marketplace$Manage$init = F4(function(session, practice, shared, _v0) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            yO: $author$project$Api$Data$Loading,
            W1: practice,
            Z$: session
        }, A2($author$project$Api$Provider$Marketplace$Product$listManageable, shared.Ej, $elm$core$Basics$identity));
    });
    var $author$project$Pages$Marketplace$Manage$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Manage$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Marketplace$Manage$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Marketplace$Manage$update = F2(function(msg, model) {
        var response = msg;
        return _Utils_Tuple3(_Utils_update(model, {
            yO: response
        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
    });
    var $author$project$Ui$Element$mb6 = $author$project$Ui$Element$Margin('mb-6');
    var $author$project$Pages$Marketplace$Manage$productsColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', false, 'Product Name'),
        A3($author$project$Api$Column$init, 'type', false, 'Type'),
        A3($author$project$Api$Column$init, 'status', false, 'Status')
    ]);
    var $author$project$Ui$Table$alignCenter = $author$project$Ui$Table$VerticalCenteredCell;
    var $author$project$Api$Common$Marketplace$Product$Shared$iconUrl = function(_v0) {
        var record = _v0;
        return record.Q_;
    };
    var $author$project$Api$Common$Marketplace$Product$All$iconUrl = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(shared);
    };
    var $author$project$Api$Provider$Marketplace$Product$All$iconUrl = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$All$iconUrl(common);
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$slug = function(_v0) {
        var record = _v0;
        return record._A;
    };
    var $author$project$Api$Common$Marketplace$Product$All$slug = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Common$Marketplace$Product$Shared$slug(shared);
    };
    var $author$project$Api$Provider$Marketplace$Product$All$slug = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$All$slug(common);
    };
    var $author$project$Api$Provider$Marketplace$Product$All$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Common$Marketplace$Product$All$type_ = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Common$Marketplace$Product$Shared$type_(shared);
    };
    var $author$project$Api$Provider$Marketplace$Product$All$type_ = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$All$type_(common);
    };
    var $author$project$Pages$Marketplace$Manage$manageRoute = function(product) {
        return A2($elm$core$Maybe$andThen, function(status) {
            switch(status){
                case 'inactive':
                    return $elm$core$Maybe$Nothing;
                case 'pending':
                    var _v1 = $author$project$Api$Provider$Marketplace$Product$All$slug(product);
                    switch(_v1){
                        case 'quickbooks':
                            return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings);
                        case 'elation':
                            return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings);
                        default:
                            return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding({
                                _A: $author$project$Api$Provider$Marketplace$Product$All$slug(product)
                            }));
                    }
                default:
                    var _v2 = _Utils_Tuple2($author$project$Api$Provider$Marketplace$Product$All$type_(product), $author$project$Api$Provider$Marketplace$Product$All$slug(product));
                    _v2$0: while(true)switch(_v2.b){
                        case 'bookkeeping':
                            if (!_v2.a) break _v2$0;
                            else return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings);
                        case 'quickbooks':
                            if (!_v2.a) break _v2$0;
                            else return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings);
                        case 'elation':
                            if (!_v2.a) break _v2$0;
                            else return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings);
                        default:
                            if (!_v2.a) break _v2$0;
                            else return $elm$core$Maybe$Nothing;
                    }
                    var _v3 = _v2.a;
                    return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users({
                        _A: $author$project$Api$Provider$Marketplace$Product$All$slug(product)
                    }));
            }
        }, $author$project$Api$Provider$Marketplace$Product$All$status(product));
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Common$Marketplace$Product$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Common$Marketplace$Product$Shared$name(shared);
    };
    var $author$project$Api$Provider$Marketplace$Product$All$name = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$All$name(common);
    };
    var $author$project$Api$Common$Marketplace$Product$ProductType$toLabel = function(type_) {
        switch(type_){
            case 0:
                return 'App';
            case 1:
                return 'Integration';
            default:
                return 'Solution';
        }
    };
    var $author$project$Pages$Marketplace$Manage$viewProductRow = function(product) {
        var productName = $author$project$Api$Provider$Marketplace$Product$All$name(product);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$alignCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    function() {
                        var _v0 = $author$project$Api$Provider$Marketplace$Product$All$iconUrl(product);
                        if (!_v0.$) {
                            var url = _v0.a;
                            return A3($author$project$Ui$Image$fromSrc, {
                                Jg: productName + ' icon'
                            }, url, _List_fromArray([
                                $author$project$Ui$Image$height(32)
                            ]));
                        } else return $elm$html$Html$text('');
                    }(),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Slug_String({
                        _A: $author$project$Api$Provider$Marketplace$Product$All$slug(product)
                    }), _List_Nil, _List_fromArray([
                        $elm$html$Html$text(productName)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$alignCenter
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$ProductType$toLabel($author$project$Api$Provider$Marketplace$Product$All$type_(product)))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$alignCenter
            ]), _List_fromArray([
                A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, $author$project$Ui$Badge$fromString(_List_Nil), $author$project$Api$Provider$Marketplace$Product$All$status(product)))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                function() {
                    var _v1 = $author$project$Pages$Marketplace$Manage$manageRoute(product);
                    if (!_v1.$) {
                        var route = _v1.a;
                        return A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$buttonDefault,
                            $author$project$Ui$Link$sm,
                            $author$project$Ui$Link$ariaLabel('Manage ' + productName)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Manage')
                        ]));
                    } else return $elm$html$Html$text('');
                }()
            ]))
        ]));
    };
    var $author$project$Pages$Marketplace$Manage$viewPartners = function(model) {
        var _v0 = function() {
            var _v1 = model.yO;
            if (_v1.$ === 3) {
                var products_ = _v1.a;
                return _Utils_Tuple2(false, products_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var products = _v0.b;
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A4($author$project$Ui$Panel$table, _List_fromArray([
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('There are no installed partners')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Pages$Marketplace$Manage$productsColumns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, $author$project$Pages$Marketplace$Manage$viewProductRow, products), _List_Nil)
        ]));
    };
    var $author$project$Pages$Marketplace$Manage$viewBody = function(model) {
        return _List_fromArray([
            A3($author$project$Ui$Element$custom, 'layout-header h-24', _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$mb6
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Manage Partners')
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Top, _List_fromArray([
                        $author$project$Ui$Link$buttonDefault
                    ]), _List_fromArray([
                        $elm$html$Html$text('View Marketplace')
                    ]))
                ]))
            ])),
            $author$project$Pages$Marketplace$Manage$viewPartners(model)
        ]);
    };
    var $author$project$Pages$Marketplace$Manage$view = function(model) {
        return {
            fb: $author$project$Pages$Marketplace$Manage$viewBody(model),
            $2: 'Marketplace | Manage'
        };
    };
    var $author$project$Pages$Marketplace$Manage$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Marketplace$Manage$init,
        aeR: $author$project$Pages$Marketplace$Manage$load,
        ag3: $author$project$Pages$Marketplace$Manage$save,
        ahE: $author$project$Pages$Marketplace$Manage$subscriptions,
        aaO: $author$project$Pages$Marketplace$Manage$update,
        aid: $author$project$Pages$Marketplace$Manage$view
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotQuickbooksIntegration = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial = {
        $: 0
    };
    var $author$project$Api$Feature$QuickbooksBypassPmpmCheck = 4;
    var $author$project$Api$Provider$Practice$One$feePlanType = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.PA;
    });
    var $author$project$Api$Provider$QuickbooksIntegration$One$QuickbooksIntegration = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$QuickbooksIntegration$Shared$QuickbooksIntegration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$QuickbooksIntegration$Shared$Record = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Provider$QuickbooksIntegration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$Shared$Record));
    var $author$project$Api$Provider$QuickbooksIntegration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$QuickbooksIntegration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$QuickbooksIntegration$One$Record = F7(function(oauthConnectionUrl, errorsCount, syncDepositsAvailableOnOrAfter, depositAccountExtid, discrepancyAccountExtid, feeAccountExtid, uncategorizedAccountExtid) {
        return {
            ac3: depositAccountExtid,
            adb: discrepancyAccountExtid,
            O5: errorsCount,
            adK: feeAccountExtid,
            Vf: oauthConnectionUrl,
            $E: syncDepositsAvailableOnOrAfter,
            ah7: uncategorizedAccountExtid
        };
    });
    var $author$project$Api$Provider$QuickbooksIntegration$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'uncategorized_account_extid', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fee_account_extid', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discrepancy_account_extid', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_extid', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sync_deposits_available_on_or_after', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'errors_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'oauth_connection_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$One$Record))))))));
    var $author$project$Api$Provider$QuickbooksIntegration$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$QuickbooksIntegration$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$QuickbooksIntegration$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksIntegration$One$QuickbooksIntegration)));
    var $author$project$Api$Provider$Integration$Quickbooks$quickbooksPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'quickbooks_integration'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Integration$Quickbooks$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$QuickbooksIntegration$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath));
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            hC: $elm$core$Maybe$Nothing,
            vY: $author$project$Api$Provider$Practice$One$feePlanType(practice) === 1 || A2($author$project$Api$Provider$Practice$One$featureEnabled, 4, practice),
            fq: $elm$core$Maybe$Nothing,
            PU: $elm$core$Maybe$Nothing,
            qW: shared.qW,
            W1: practice,
            Bz: query,
            dd: $author$project$Api$Data$Loading,
            gy: $elm$core$Maybe$Nothing,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            _8: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial
        }, A2($author$project$Api$Provider$Integration$Quickbooks$retrieve, shared.Ej, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotQuickbooksIntegration));
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooksHiConfirmClosed = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DeactivateHiConfirmClosed = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$CancelEdit = {
        $: 4
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$subscriptions = function(_v0) {
        var model = _v0;
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Quickbooks$Mappings$CancelEdit)), model.w));
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Admin$Quickbooks$Mappings$subscriptions, model.gy))),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooksHiConfirmClosed)), model.hC)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DeactivateHiConfirmClosed)), model.fq))
        ]));
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Activated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Date = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DateInputMsg = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Deactivated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Overview = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Quickbooks$activate = F3(function(apiClient, syncDepositsAvailableOnOrAfter, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('sync_deposits_available_on_or_after', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, syncDepositsAvailableOnOrAfter))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$QuickbooksIntegration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'activate'
        ]), $author$project$Api$Provider$Integration$Quickbooks$quickbooksPath))));
    });
    var $author$project$Api$Provider$Integration$Quickbooks$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$QuickbooksIntegration$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath));
    });
    var $author$project$Api$Provider$Integration$Quickbooks$deactivate = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$QuickbooksIntegration$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'deactivate'
        ]), $author$project$Api$Provider$Integration$Quickbooks$quickbooksPath)));
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsUpdate = F2(function(field, fields) {
        var dateInput = field.a;
        var date = field.b;
        return _Utils_update(fields, {
            qg: dateInput,
            $E: date
        });
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
    var $author$project$Api$Provider$Integration$Quickbooks$Account$CategoryMatching = 0;
    var $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$Model = $elm$core$Basics$identity;
    var $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading = {
        $: 0
    };
    var $author$project$Api$Provider$Integration$Quickbooks$Account$accountssPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'accounts'
    ]), $author$project$Api$Provider$Integration$Quickbooks$quickbooksPath);
    var $author$project$Api$Provider$QuickbooksAccount$All$QuickbooksAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$QuickbooksAccount$Min$QuickbooksAccount = $elm$core$Basics$identity;
    var $author$project$Api$Provider$QuickbooksAccount$Min$Record = F2(function(extid, name) {
        return {
            adF: extid,
            zr: name
        };
    });
    var $author$project$Api$Provider$QuickbooksAccount$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'extid', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksAccount$Min$Record)));
    var $author$project$Api$Provider$QuickbooksAccount$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$QuickbooksAccount$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$QuickbooksAccount$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$QuickbooksAccount$Min$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Quickbooks$Account$defaults = {
        ah5: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Integration$Quickbooks$Account$typeToString = function(type_) {
        switch(type_){
            case 0:
                return 'category_matching';
            case 1:
                return 'deposit_matching';
            default:
                return 'fee_matching';
        }
    };
    var $author$project$Api$Provider$Integration$Quickbooks$Account$optionalsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Integration$Quickbooks$Account$defaults);
        var _v0 = options.ah5;
        if (!_v0.$) {
            var type_ = _v0.a;
            return _List_fromArray([
                A2($author$project$Api$Param$string, 'type', $author$project$Api$Provider$Integration$Quickbooks$Account$typeToString(type_))
            ]);
        } else return _List_Nil;
    };
    var $author$project$Api$Provider$Integration$Quickbooks$Account$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$QuickbooksAccount$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Integration$Quickbooks$Account$optionalsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$Account$accountssPath)));
    });
    var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'category_mappings'
    ]), $author$project$Api$Provider$Integration$Quickbooks$quickbooksPath);
    var $author$project$Api$Provider$QuickbooksCategoryMapping$All$QuickbooksCategoryMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$QuickbooksCategoryMapping = $elm$core$Basics$identity;
    var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$Record = F2(function(category, quickbooksAccount) {
        return {
            EL: category,
            X2: quickbooksAccount
        };
    });
    var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quickbooks_account', $author$project$Api$Provider$QuickbooksAccount$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $author$project$Api$Provider$Category$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$QuickbooksCategoryMapping$Shared$Record)));
    var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$QuickbooksCategoryMapping$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$QuickbooksCategoryMapping$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath));
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$init = F4(function(apiClient, session, practice, quickbooksIntegration) {
        return _Utils_Tuple2({
            hK: $author$project$Api$Data$Loading,
            lt: _List_Nil,
            lX: $author$project$Api$Data$Loading,
            w: $elm$core$Maybe$Nothing,
            mh: $author$project$Api$Data$Loading,
            gh: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading,
            W1: practice,
            nP: $author$project$Api$Data$Loading,
            dd: quickbooksIntegration,
            Z$: session
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Integration$Quickbooks$Account$list, apiClient, function(d) {
                return _Utils_update(d, {
                    ah5: $elm$core$Maybe$Just(0)
                });
            }, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(0)),
            A2($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list, apiClient, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings)
        ])));
    });
    var $author$project$Api$Provider$QuickbooksIntegration$One$syncDepositsAvailableOnOrAfter = function(_v0) {
        var record = _v0.b;
        return record.$E;
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$initFormFields = function(quickbooksIntegration) {
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2({
            qg: dateInput,
            $E: $author$project$Api$Provider$QuickbooksIntegration$One$syncDepositsAvailableOnOrAfter(quickbooksIntegration)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DateInputMsg(dateInput), dateInputCmd));
    };
    var $author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl = function(_v0) {
        var record = _v0.b;
        return record.Vf;
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Downloading = {
        $: 1
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotAuthorization = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Quickbooks$authorize = F5(function(apiClient, code, state, realmId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('code', $elm$json$Json$Encode$string(code)),
            _Utils_Tuple2('state', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, state)),
            _Utils_Tuple2('realmId', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, realmId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$QuickbooksIntegration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'authorize'
        ]), $author$project$Api$Provider$Integration$Quickbooks$quickbooksPath))));
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$sendOauthSuccessDataToBackend = function(model) {
        var _v0 = A2($elm$core$Dict$get, 'code', model.Bz);
        if (!_v0.$) {
            var code = _v0.a;
            var state = A2($elm$core$Dict$get, 'state', model.Bz);
            var realmId = A2($elm$core$Dict$get, 'realmId', model.Bz);
            return _Utils_Tuple2(_Utils_update(model, {
                j_: $author$project$Api$Data$Loading,
                _8: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Downloading
            }), A5($author$project$Api$Provider$Integration$Quickbooks$authorize, model.Ej, code, state, realmId, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotAuthorization));
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Api$Provider$QuickbooksIntegration$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$QuickbooksIntegration$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$QuickbooksIntegration$Shared$status(shared);
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$AccountSaved = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Integration$Quickbooks$Account$DepositMatching = 1;
    var $author$project$Components$Admin$Quickbooks$Mappings$EditingAccount = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$EditingMapping = F3(function(a, b, c) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Api$Provider$Integration$Quickbooks$Account$FeeMatching = 2;
    var $author$project$Components$Admin$Quickbooks$Mappings$QuickbooksCategoryMappingSaved = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid = function(_v0) {
        var record = _v0.b;
        return record.ac3;
    };
    var $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid = function(_v0) {
        var record = _v0.b;
        return record.adb;
    };
    var $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid = function(_v0) {
        var record = _v0.b;
        return record.adK;
    };
    var $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid = function(_v0) {
        var record = _v0.b;
        return record.ah7;
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$accountToParam = F2(function(account, quickbooksIntegration) {
        switch(account){
            case 2:
                return $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid(quickbooksIntegration);
            case 1:
                return $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid(quickbooksIntegration);
            case 0:
                return $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid(quickbooksIntegration);
            default:
                return $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid(quickbooksIntegration);
        }
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsInit = F2(function(account, quickbooksIntegration) {
        return {
            adF: A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, account, quickbooksIntegration),
            zr: $elm$core$Maybe$Nothing,
            BB: _List_Nil
        };
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate = F2(function(field, fields) {
        var string = field;
        var extid = $author$project$Utils$String$toMaybe(string);
        var quickbooksAccount = A2($elm_community$list_extra$List$Extra$find, function(quickbooksAccount_) {
            return _Utils_eq(quickbooksAccount_.adF, extid);
        }, fields.BB);
        return _Utils_update(fields, {
            adF: extid,
            zr: A2($elm$core$Maybe$andThen, function($) {
                return $.zr;
            }, quickbooksAccount)
        });
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid = '__blank';
    var $author$project$Components$Admin$Quickbooks$Mappings$blankAccountData = {
        adF: $elm$core$Maybe$Just($author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid),
        zr: $elm$core$Maybe$Just('Not assigned - will not sync')
    };
    var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$category = function(_v0) {
        var record = _v0;
        return record.EL;
    };
    var $author$project$Api$Provider$QuickbooksCategoryMapping$All$category = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$category(shared);
    };
    var $author$project$Api$Provider$QuickbooksAccount$Min$extid = function(_v0) {
        var record = _v0;
        return record.adF;
    };
    var $author$project$Api$Provider$QuickbooksAccount$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$quickbooksAccount = function(_v0) {
        var record = _v0;
        return record.X2;
    };
    var $author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$QuickbooksCategoryMapping$Shared$quickbooksAccount(shared);
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$mappingFormFieldsInit = F2(function(quickbooksCategoryMapping, quickbooksAccounts) {
        var name = $author$project$Api$Provider$QuickbooksAccount$Min$name($author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
        var extid = $author$project$Api$Provider$QuickbooksAccount$Min$extid($author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
        return {
            adF: extid,
            zr: name,
            BB: quickbooksAccounts
        };
    });
    var $author$project$Api$Provider$QuickbooksAccount$All$extid = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$QuickbooksAccount$Min$extid(min);
    };
    var $author$project$Api$Provider$QuickbooksAccount$All$name = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$QuickbooksAccount$Min$name(min);
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountToAccountData = function(quickbooksAccount) {
        return {
            adF: $author$project$Api$Provider$QuickbooksAccount$All$extid(quickbooksAccount),
            zr: $author$project$Api$Provider$QuickbooksAccount$All$name(quickbooksAccount)
        };
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData = function(quickbooksAccounts) {
        return A2($elm$core$List$map, $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountToAccountData, quickbooksAccounts);
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksCategoryMappingFields = function(formFields) {
        return {
            adF: formFields.adF,
            zr: formFields.zr
        };
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$quickbooksFields = F3(function(account, formFields, quickbooksIntegration) {
        var fields = {
            ac3: $author$project$Api$Provider$QuickbooksIntegration$One$depositAccountExtid(quickbooksIntegration),
            adb: $author$project$Api$Provider$QuickbooksIntegration$One$discrepancyAccountExtid(quickbooksIntegration),
            adK: $author$project$Api$Provider$QuickbooksIntegration$One$feeAccountExtid(quickbooksIntegration),
            ah7: $author$project$Api$Provider$QuickbooksIntegration$One$uncategorizedAccountExtid(quickbooksIntegration)
        };
        switch(account){
            case 2:
                return _Utils_update(fields, {
                    adb: formFields.adF
                });
            case 1:
                return _Utils_update(fields, {
                    adK: formFields.adF
                });
            case 0:
                return _Utils_update(fields, {
                    ac3: formFields.adF
                });
            default:
                return _Utils_update(fields, {
                    ah7: formFields.adF
                });
        }
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$ExtidValidation = 0;
    var $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.adF;
        }, _Utils_Tuple2(0, 'Please pick a quickbooks account.'))
    ]));
    var $author$project$Components$Admin$Quickbooks$Mappings$saveForm = F6(function(currentExtid, _v0, form, toCmd, toEditing, model) {
        var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsValidator, form);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var newForm = _v2.a;
            var validFormFields = _v2.b;
            var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
            var extid = _Utils_eq(formFields.adF, $elm$core$Maybe$Just($author$project$Components$Admin$Quickbooks$Mappings$blankAccountDataExtid)) ? $elm$core$Maybe$Nothing : formFields.adF;
            var _v3 = _Utils_eq(extid, currentExtid) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2(toCmd, newForm, _Utils_update(formFields, {
                adF: extid
            }));
            var editing = _v3.a;
            var cmd = _v3.b;
            return _Utils_Tuple3(_Utils_update(model, {
                w: editing
            }), cmd, _List_Nil);
        } else {
            var newForm = _v1.a;
            return _Utils_Tuple3(_Utils_update(model, {
                w: $elm$core$Maybe$Just(A2(toEditing, newForm, $author$project$Api$Data$NotAsked))
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$DepositAccount = 0;
    var $author$project$Components$Admin$Quickbooks$Mappings$DiscrepancyAccount = 2;
    var $author$project$Components$Admin$Quickbooks$Mappings$FeeAccount = 1;
    var $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoaded = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$UncategorizedAccount = 3;
    var $author$project$Components$Admin$Quickbooks$Mappings$accountNameFromId = F2(function(model, id) {
        return A2($elm$core$Maybe$andThen, function(id_) {
            var feeMatchingAccounts = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.mh));
            var depositMatchingAccounts = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.lX));
            var categoryMatchingAccounts = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.hK));
            var quickbooksAccount = A2($elm_community$list_extra$List$Extra$find, function(quickbooksAccount_) {
                return _Utils_eq($author$project$Api$Provider$QuickbooksAccount$All$extid(quickbooksAccount_), $elm$core$Maybe$Just(id_));
            }, A2($elm$core$List$append, categoryMatchingAccounts, A2($elm$core$List$append, feeMatchingAccounts, depositMatchingAccounts)));
            return A2($elm$core$Maybe$andThen, $author$project$Api$Provider$QuickbooksAccount$All$name, quickbooksAccount);
        }, id);
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId = F2(function(model, id) {
        if (!id.$) {
            var id_ = id.a;
            return {
                adF: $elm$core$Maybe$Just(id_),
                zr: A2($author$project$Components$Admin$Quickbooks$Mappings$accountNameFromId, model, id)
            };
        } else return $author$project$Components$Admin$Quickbooks$Mappings$blankAccountData;
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings = function(model) {
        var _v0 = _Utils_Tuple3(model.lX, model.mh, model.hK);
        if (_v0.a.$ === 3 && _v0.b.$ === 3 && _v0.c.$ === 3) {
            var _v1 = _v0.a;
            var _v2 = _v0.b;
            var _v3 = _v0.c;
            var otherMappings = {
                NL: A2($author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId, model, A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 0, model.dd)),
                N4: A2($author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId, model, A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 2, model.dd)),
                Py: A2($author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId, model, A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 1, model.dd)),
                aaE: A2($author$project$Components$Admin$Quickbooks$Mappings$buildAccountFromId, model, A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, 3, model.dd))
            };
            return _Utils_update(model, {
                gh: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoaded(otherMappings)
            });
        } else return _Utils_update(model, {
            gh: $author$project$Components$Admin$Quickbooks$Mappings$OtherMappingsLoading
        });
    };
    var $author$project$Api$Provider$Integration$Quickbooks$update = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('discrepancy_account_extid', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adb)),
            _Utils_Tuple2('deposit_account_extid', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ac3)),
            _Utils_Tuple2('fee_account_extid', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adK)),
            _Utils_Tuple2('uncategorized_account_extid', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.ah7))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$QuickbooksIntegration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$quickbooksPath)));
    });
    var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingsPath);
    };
    var $author$project$Api$Provider$QuickbooksCategoryMapping$One$QuickbooksCategoryMapping = 0;
    var $author$project$Api$Provider$QuickbooksCategoryMapping$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$update = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('quickbooks_account', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('extid', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adF)),
                _Utils_Tuple2('name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.zr))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$QuickbooksCategoryMapping$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$categoryMappingPath(id))));
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    nP: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var type_ = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var quickbooksAccounts = response.a;
                    switch(type_){
                        case 0:
                            return _Utils_Tuple3(_Utils_update(model, {
                                hK: response,
                                lt: A2($elm$core$List$cons, $author$project$Components$Admin$Quickbooks$Mappings$blankAccountData, $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(quickbooksAccounts))
                            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                A3($author$project$Api$Provider$Integration$Quickbooks$Account$list, apiClient, function(d) {
                                    return _Utils_update(d, {
                                        ah5: $elm$core$Maybe$Just(1)
                                    });
                                }, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(1)),
                                A3($author$project$Api$Provider$Integration$Quickbooks$Account$list, apiClient, function(d) {
                                    return _Utils_update(d, {
                                        ah5: $elm$core$Maybe$Just(2)
                                    });
                                }, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksAccounts(2))
                            ])), _List_Nil);
                        case 1:
                            return _Utils_Tuple3($author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(_Utils_update(model, {
                                lX: response
                            })), $elm$core$Platform$Cmd$none, _List_Nil);
                        default:
                            return _Utils_Tuple3($author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(_Utils_update(model, {
                                mh: response
                            })), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var account = msg.a;
                var form = $author$project$Utils$Form$init(A2($author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsInit, account, model.dd));
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Just(A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, form, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var field = msg.a;
                var _v4 = model.w;
                if (!_v4.$) {
                    if (!_v4.a.$) {
                        var _v5 = _v4.a;
                        var account = _v5.a;
                        var form = _v5.b;
                        var saveRequest = _v5.c;
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate, field, form);
                        return _Utils_Tuple3(_Utils_update(model, {
                            w: $elm$core$Maybe$Just(A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, newForm, saveRequest))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else {
                        var _v6 = _v4.a;
                        var quickbooksCategoryMapping = _v6.a;
                        var form = _v6.b;
                        var saveRequest = _v6.c;
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Admin$Quickbooks$Mappings$accountFormFieldsUpdate, field, form);
                        return _Utils_Tuple3(_Utils_update(model, {
                            w: $elm$core$Maybe$Just(A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, newForm, saveRequest))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var _v7 = model.w;
                if (!_v7.$) {
                    if (!_v7.a.$) {
                        var _v8 = _v7.a;
                        var account = _v8.a;
                        var form = _v8.b;
                        var currentExtid = A2($author$project$Components$Admin$Quickbooks$Mappings$accountToParam, account, model.dd);
                        var accountName = function() {
                            switch(account){
                                case 2:
                                    return 'discrepancy';
                                case 1:
                                    return 'fee';
                                case 0:
                                    return 'deposit';
                                default:
                                    return 'uncategorize';
                            }
                        }();
                        return A6($author$project$Components$Admin$Quickbooks$Mappings$saveForm, currentExtid, accountName, form, F2(function(newForm, formFields) {
                            var fields = A3($author$project$Components$Admin$Quickbooks$Mappings$quickbooksFields, account, formFields, model.dd);
                            return _Utils_Tuple2($elm$core$Maybe$Just(A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, newForm, $author$project$Api$Data$Loading)), A3($author$project$Api$Provider$Integration$Quickbooks$update, apiClient, fields, $author$project$Components$Admin$Quickbooks$Mappings$AccountSaved));
                        }), $author$project$Components$Admin$Quickbooks$Mappings$EditingAccount(account), model);
                    } else {
                        var _v10 = _v7.a;
                        var quickbooksCategoryMapping = _v10.a;
                        var form = _v10.b;
                        var currentExtid = $author$project$Api$Provider$QuickbooksAccount$Min$extid($author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping));
                        return A6($author$project$Components$Admin$Quickbooks$Mappings$saveForm, currentExtid, 'revenue', form, F2(function(newForm, formFields) {
                            var id = $author$project$Api$Provider$Category$Min$id($author$project$Api$Provider$QuickbooksCategoryMapping$All$category(quickbooksCategoryMapping));
                            var fields = $author$project$Components$Admin$Quickbooks$Mappings$quickbooksCategoryMappingFields(formFields);
                            return _Utils_Tuple2($elm$core$Maybe$Just(A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, newForm, $author$project$Api$Data$Loading)), A4($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$update, apiClient, id, fields, $author$project$Components$Admin$Quickbooks$Mappings$QuickbooksCategoryMappingSaved));
                        }), $author$project$Components$Admin$Quickbooks$Mappings$EditingMapping(quickbooksCategoryMapping), model);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                var _v11 = model.w;
                if (!_v11.$ && !_v11.a.$) {
                    var _v12 = _v11.a;
                    var account = _v12.a;
                    var form = _v12.b;
                    if (response.$ === 3) {
                        var quickbooksIntegration = response.a;
                        return _Utils_Tuple3($author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(_Utils_update(model, {
                            w: $elm$core$Maybe$Nothing,
                            dd: quickbooksIntegration
                        })), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Quickbooks account successfully updated.')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        w: $elm$core$Maybe$Just(A3($author$project$Components$Admin$Quickbooks$Mappings$EditingAccount, account, form, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var quickbooksCategoryMapping = msg.a;
                var form = $author$project$Utils$Form$init(A2($author$project$Components$Admin$Quickbooks$Mappings$mappingFormFieldsInit, quickbooksCategoryMapping, model.lt));
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Just(A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, form, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                var _v14 = model.w;
                if (!_v14.$ && _v14.a.$ === 1) {
                    var _v15 = _v14.a;
                    var quickbooksCategoryMapping = _v15.a;
                    var form = _v15.b;
                    if (response.$ === 3) return _Utils_Tuple3($author$project$Components$Admin$Quickbooks$Mappings$setOtherMappings(_Utils_update(model, {
                        w: $elm$core$Maybe$Nothing,
                        nP: $author$project$Api$Data$Loading
                    })), A2($author$project$Api$Provider$Integration$Quickbooks$CategoryMapping$list, apiClient, $author$project$Components$Admin$Quickbooks$Mappings$GotQuickbooksCategoryMappings), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Quickbooks account successfully updated.')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        w: $elm$core$Maybe$Just(A3($author$project$Components$Admin$Quickbooks$Mappings$EditingMapping, quickbooksCategoryMapping, form, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        var quickbooksIntegration = response.a;
                        var status = $author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration);
                        var step = status === 'pending' || status === 'active' ? $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Overview(quickbooksIntegration) : $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial;
                        var _v2 = status === 'pending' || status === 'active' ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Components$Admin$Quickbooks$Mappings$init, model.Ej, model.Z$, model.W1, quickbooksIntegration)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                        var quickbooksMappings = _v2.a;
                        var quickbooksMappingsCmd = _v2.b;
                        var _v3 = status === 'pending' ? A2($elm$core$Tuple$mapFirst, A2($elm$core$Basics$composeL, $elm$core$Maybe$Just, $author$project$Utils$Form$init), $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$initFormFields(quickbooksIntegration)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                        var form = _v3.a;
                        var formCmd = _v3.b;
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, function(cmd) {
                            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                formCmd,
                                cmd,
                                A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg, quickbooksMappingsCmd)
                            ]));
                        }, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$sendOauthSuccessDataToBackend(_Utils_update(model, {
                            PU: form,
                            dd: response,
                            gy: quickbooksMappings,
                            _8: step
                        }))));
                    case 2:
                        if (response.a.$ === 5) {
                            var _v4 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                dd: response,
                                _8: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    dd: response,
                    _8: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    hC: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var confirmed = msg.a;
                if (confirmed) {
                    var oauthConnectionUrl = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl, $author$project$Api$Data$toMaybe(model.dd));
                    return _Utils_Tuple3(_Utils_update(model, {
                        hC: $elm$core$Maybe$Just($author$project$Api$Data$Loading),
                        j_: $author$project$Api$Data$Loading
                    }), function() {
                        if (!oauthConnectionUrl.$) {
                            var oauthConnectionUrl_ = oauthConnectionUrl.a;
                            return $author$project$Ports$Navigation$openInNewWindow(oauthConnectionUrl_);
                        } else return A2($author$project$Api$Provider$Integration$Quickbooks$create, model.Ej, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Created);
                    }(), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    hC: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var quickbooksIntegration = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        dd: response
                    }), function() {
                        var _v7 = $author$project$Api$Provider$QuickbooksIntegration$One$oauthConnectionUrl(quickbooksIntegration);
                        if (!_v7.$) {
                            var oauthConnectionUrl = _v7.a;
                            return $author$project$Ports$Navigation$openInNewWindow(oauthConnectionUrl);
                        } else return $elm$core$Platform$Cmd$none;
                    }(), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    dd: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var query = A2($elm$core$Dict$remove, 'realmId', A2($elm$core$Dict$remove, 'state', A2($elm$core$Dict$remove, 'code', model.Bz)));
                    return _Utils_Tuple3(_Utils_update(model, {
                        Bz: query,
                        dd: $author$project$Api$Data$Loading,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($author$project$Utils$Route$navigate, query, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings),
                        A2($author$project$Api$Provider$Integration$Quickbooks$retrieve, model.Ej, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$GotQuickbooksIntegration)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    dd: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var _v9 = model.PU;
                if (!_v9.$) {
                    var form = _v9.a;
                    var _v10 = A2($author$project$Utils$Form$validate, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsValidator, form);
                    if (!_v10.$) {
                        var _v11 = _v10.a;
                        var newForm = _v11.a;
                        var validFields = _v11.b;
                        var _v12 = $rtfeldman$elm_validate$Validate$fromValid(validFields);
                        var syncDepositsAvailableOnOrAfter = _v12.$E;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm),
                            j_: $author$project$Api$Data$Loading
                        }), A3($author$project$Api$Provider$Integration$Quickbooks$activate, model.Ej, syncDepositsAvailableOnOrAfter, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Activated), _List_Nil);
                    } else {
                        var newForm = _v10.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                var outMsgs = function() {
                    if (response.$ === 3) return _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your quickbooks integration has been activated')
                    ]);
                    else return $author$project$OutMsg$handleErrorResponse(response);
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    dd: response,
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, outMsgs);
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    fq: $elm$core$Maybe$Just($author$project$Api$Data$NotAsked)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var confirm = msg.a;
                return confirm ? _Utils_Tuple3(_Utils_update(model, {
                    fq: $elm$core$Maybe$Just($author$project$Api$Data$Loading)
                }), A2($author$project$Api$Provider$Integration$Quickbooks$deactivate, model.Ej, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Deactivated), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    fq: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var response = msg.a;
                var outMsgs = function() {
                    if (response.$ === 3) return _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your quickbooks integration has been deactivated')
                    ]);
                    else return $author$project$OutMsg$handleErrorResponse(response);
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    fq: $elm$core$Maybe$Nothing,
                    dd: response,
                    _8: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Initial
                }), $elm$core$Platform$Cmd$none, outMsgs);
            case 10:
                var dateInput = msg.a;
                var subMsg = msg.b;
                var _v15 = model.PU;
                if (!_v15.$) {
                    var form = _v15.a;
                    var _v16 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
                    var newDateInput = _v16.a;
                    var subCmd = _v16.b;
                    var event = _v16.c;
                    var newForm = function() {
                        if (event.$ === 1) {
                            var date = event.a;
                            return A3($author$project$Utils$Form$update, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsUpdate, A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Date, newDateInput, date), form);
                        } else {
                            var _v18 = $author$project$Utils$Form$fields(form);
                            var syncDepositsAvailableOnOrAfter = _v18.$E;
                            return A3($author$project$Utils$Form$update, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$formFieldsUpdate, A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Date, newDateInput, syncDepositsAvailableOnOrAfter), form);
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DateInputMsg(newDateInput), subCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v19 = model.gy;
                if (!_v19.$) {
                    var quickbooksMappings = _v19.a;
                    var _v20 = A3($author$project$Components$Admin$Quickbooks$Mappings$update, model.Ej, subMsg, quickbooksMappings);
                    var quickbooksMappings_ = _v20.a;
                    var quickbooksMappingsCmd = _v20.b;
                    var quickbooksMappingsOutMsgs = _v20.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        gy: $elm$core$Maybe$Just(quickbooksMappings_)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg, quickbooksMappingsCmd), quickbooksMappingsOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Ui$Image$QuickBooksLogo = 8;
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$initialStepSkeleton = _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('inactive')
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_fromArray([
                $author$project$Ui$Skeleton$span(4)
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('About'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(10)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('How it works'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(6)
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(7)
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(10)
                ]))
            ]))
        ]))
    ]);
    var $author$project$Components$Admin$Quickbooks$Mappings$AccountFormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$Extid = $elm$core$Basics$identity;
    var $author$project$Components$Admin$Quickbooks$Mappings$Save = {
        $: 5
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$quickBooksAccountOptions = function(quickbooksAccounts) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Select a QuickBooks Account'), A2($elm$core$List$map, function(quickbooksAccount) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, quickbooksAccount.adF, A2($elm$core$Maybe$withDefault, 'N/A', quickbooksAccount.zr));
        }, quickbooksAccounts));
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$viewForm = F3(function(form, quickbooksAccounts, saveRequest) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Account',
            Tk: _Utils_eq(saveRequest, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just(''),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Admin$Quickbooks$Mappings$CancelEdit,
            Vn: $elm$core$Basics$always($author$project$Components$Admin$Quickbooks$Mappings$Save)
        };
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(4),
                $author$project$Ui$Form$Group$label('QuickBooks account'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(fields.adF),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Quickbooks$Mappings$AccountFormUpdated, $elm$core$Basics$identity)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]), $author$project$Components$Admin$Quickbooks$Mappings$quickBooksAccountOptions(quickbooksAccounts))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$modal = function(_v0) {
        var model = _v0;
        var _v1 = model.w;
        if (!_v1.$) {
            if (!_v1.a.$) {
                var _v2 = _v1.a;
                var account = _v2.a;
                var form = _v2.b;
                var saveRequest = _v2.c;
                var quickbooksAccounts = function() {
                    switch(account){
                        case 0:
                            return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.lX)));
                        case 1:
                            return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.mh)));
                        case 2:
                            return $author$project$Components$Admin$Quickbooks$Mappings$quickbooksAccountsToAccountData(A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.hK)));
                        default:
                            return model.lt;
                    }
                }();
                return A3($author$project$Components$Admin$Quickbooks$Mappings$viewForm, form, quickbooksAccounts, saveRequest);
            } else {
                var _v4 = _v1.a;
                var form = _v4.b;
                var saveRequest = _v4.c;
                return A3($author$project$Components$Admin$Quickbooks$Mappings$viewForm, form, model.lt, saveRequest);
            }
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatus = function(status) {
        return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatusLeft = F2(function(status, content) {
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$label, _List_fromArray([
            $author$project$Ui$Typography$controlLabel
        ]), _List_fromArray([
            $elm$html$Html$text('Status ')
        ])), A2($elm$core$List$cons, $author$project$Utils$Html$noBreakSpace, A2($elm$core$List$cons, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatus(status), A2($elm$core$List$cons, $author$project$Utils$Html$noBreakSpace, content)))));
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewDownloadingStep = A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
        A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatusLeft, 'downloading', _List_Nil),
        $elm$html$Html$text('We are loading your accounts from QuickBooks. After that, you\'ll be able to connect those with Hint categories.'),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt2
        ]), _List_fromArray([
            $author$project$Ui$Spinner$view(_List_Nil)
        ]))
    ]));
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooks = {
        $: 1
    };
    var $author$project$Ui$Button$Background = 9;
    var $author$project$Ui$Image$QuickBooksConnectButton = 9;
    var $author$project$Ui$Padding$X_1 = 10;
    var $author$project$Ui$Image$Class = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Image$class = $author$project$Ui$Image$Class;
    var $author$project$Ui$OrderedList$Margin = $elm$core$Basics$identity;
    var $author$project$Ui$OrderedList$margin = $elm$core$Basics$identity;
    var $author$project$Ui$OrderedList$Padding = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$OrderedList$padding = $author$project$Ui$OrderedList$Padding;
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewInitialStep = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            !model.vY ? A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Your current plan does not support this integration')
                        ])),
                        A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Contact our customer success team to learn more about the required pricing scheme and update your plan.')
                        ]))
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatus('inactive')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Connect to quickbooks online'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooks),
                    $author$project$Ui$Button$disabled(!model.vY),
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$styled(9)
                ]), _List_fromArray([
                    A4($author$project$Ui$Image$view, model.qW, {
                        Jg: 'Connect to QuickBooks Online button'
                    }, _List_fromArray([
                        $author$project$Ui$Image$class('w-72')
                    ]), 9)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('About'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Save time allocating your revenue and expenses to the correct QuickBooks accounts by connecting Hint to QuickBooks Online.')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('How it works'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$OrderedList$view, _List_fromArray([
                        $author$project$Ui$OrderedList$padding(10)
                    ]), _List_fromArray([
                        A2($author$project$Ui$OrderedList$item, _List_fromArray([
                            $author$project$Ui$OrderedList$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Log in to QuickBooks Online and give Hint permission to access your account.')
                        ])),
                        A2($author$project$Ui$OrderedList$item, _List_fromArray([
                            $author$project$Ui$OrderedList$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Match your Hint revenue and expense categories to the appropriate accounts in QuickBooks.')
                        ])),
                        A2($author$project$Ui$OrderedList$item, _List_fromArray([
                            $author$project$Ui$OrderedList$margin(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Hint starts syncing, which means Hint will automatically split your deposits into the appropriate accounts in QuickBooks. All you need to do is reconcile your transactions as usual!')
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Need help? '),
                        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/integrations/quickbooks-online-integration', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('Read the Knowledge Base article.')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Activate = {
        $: 5
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewOverviewFooter = F2(function(model, quickbooksIntegration) {
        return $author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration) === 'pending' ? A2($author$project$Ui$Panel$footer, _List_fromArray([
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$justifyCenter
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Activate integration'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Activate),
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
            ]), _List_fromArray([
                $elm$html$Html$text('Activate')
            ]))
        ])) : $author$project$Ui$Panel$none;
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Deactivate = {
        $: 7
    };
    var $author$project$Api$Provider$QuickbooksIntegration$One$errorsCount = function(_v0) {
        var record = _v0.b;
        return record.O5;
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$hasUnmappedCategories = function(quickbooksCategoryMappings) {
        return A2($elm$core$List$any, function(quickbooksCategoryMapping) {
            return !$author$project$Utils$Maybe$toBool($author$project$Api$Provider$QuickbooksAccount$Min$extid($author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping)));
        }, quickbooksCategoryMappings);
    };
    var $author$project$Ui$Form$Group$LabelInsideControl = {
        $: 11
    };
    var $author$project$Ui$Form$Group$labelInsideControl = $author$project$Ui$Form$Group$LabelInsideControl;
    var $elm$html$Html$u = _VirtualDom_node('u');
    var $author$project$Ui$Typography$u = F2(function(options, content) {
        return A2($elm$html$Html$u, $author$project$Ui$Typography$optionsToAttributes(options), content);
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$EditAccount = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$viewAccount = F2(function(account, otherMappings) {
        var label = function() {
            switch(account){
                case 0:
                    return _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Deposit Amounts')
                        ]))
                    ]);
                case 1:
                    return _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Transaction Fees')
                        ]))
                    ]);
                case 2:
                    return _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Discrepancy Amounts')
                        ]))
                    ]);
                default:
                    return _List_fromArray([
                        $elm$html$Html$text('Hint category: '),
                        $author$project$Ui$Icon$minus(_List_Nil)
                    ]);
            }
        }();
        var info = function() {
            switch(account){
                case 0:
                    return 'Map this to your \"Undeposited Funds\" account.';
                case 1:
                    return 'The cost to you to process transactions through this platform and its partners.';
                case 2:
                    return "We\u2019ll use this account to balance out discrepancies between this platform and your bank deposits, usually caused by payment disputes.";
                default:
                    return 'Includes charges that haven\'t been assigned to a category in this platform. You can leave this unmatched in order to stop deposits with uncategorized charges from syncing.';
            }
        }();
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _Utils_ap(label, _List_fromArray([
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text(info)
                    ]))
                ])))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Icon$arrowRight(_List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text('QuickBooks account:')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                function() {
                    if (otherMappings.$ === 1) {
                        var discrepancyAccount = otherMappings.a.N4;
                        var feeAccount = otherMappings.a.Py;
                        var depositAccount = otherMappings.a.NL;
                        var uncategorizedAccount = otherMappings.a.aaE;
                        var otherMapping = function() {
                            switch(account){
                                case 2:
                                    return discrepancyAccount;
                                case 1:
                                    return feeAccount;
                                case 0:
                                    return depositAccount;
                                default:
                                    return uncategorizedAccount;
                            }
                        }();
                        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', otherMapping.zr)),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Eddit account'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Components$Admin$Quickbooks$Mappings$EditAccount(account)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ]))
                        ]));
                    } else return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$span(4)
                        ]))
                    ]));
                }()
            ]))
        ]));
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$EditQuickbooksCategoryMapping = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccount = F2(function(loading, quickbooksCategoryMapping) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Hint category: '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Category$Min$name($author$project$Api$Provider$QuickbooksCategoryMapping$All$category(quickbooksCategoryMapping)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Icon$arrowRight(_List_Nil)
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text('QuickBooks account:')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                function() {
                    if (loading) return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$span(4)
                        ]))
                    ]));
                    else {
                        var quickbooksAccount = $author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping);
                        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$span, $author$project$Utils$Maybe$toBool($author$project$Api$Provider$QuickbooksAccount$Min$extid(quickbooksAccount)) ? _List_Nil : _List_fromArray([
                                $author$project$Ui$Typography$italic
                            ]), _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Not assigned - will not sync', $author$project$Api$Provider$QuickbooksAccount$Min$name($author$project$Api$Provider$QuickbooksCategoryMapping$All$quickbooksAccount(quickbooksCategoryMapping))))
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit category mapping'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Components$Admin$Quickbooks$Mappings$EditQuickbooksCategoryMapping(quickbooksCategoryMapping)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ]))
                        ]));
                    }
                }()
            ]))
        ]));
    });
    var $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccountSkeleton = A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(4)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(4)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(2)
        ]), _List_Nil),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(2)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                ]), _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(8)
                    ]))
                ]))
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(4)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(3)
                ]))
            ]))
        ]))
    ]));
    var $author$project$Components$Admin$Quickbooks$Mappings$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Other Accounts'),
                $author$project$Ui$Form$Group$labelInsideControl
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('The below accounts allow us to ensure we can correctly auto-match revenue from this platform with deposits in QuickBooks.')
                ]))
            ])),
            A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 0, model.gh),
            A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 1, model.gh),
            A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 2, model.gh),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Income Accounts'),
                $author$project$Ui$Form$Group$labelInsideControl
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Match each revenue category from this platform (on the left) to the desired income account in QuickBooks (on the right). '),
                    A2($author$project$Ui$Typography$u, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You must create your desired income accounts in QuickBooks prior to the matching process.')
                    ])),
                    $elm$html$Html$text(' Every category on the left must be matched in order to activate the integration.')
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_Nil, function() {
                var _v1 = model.nP;
                if (_v1.$ === 3) {
                    var quickbooksCategoryMappings = _v1.a;
                    var loadingQuickbooksAccounts = !$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.hK));
                    return A2($elm$core$List$map, $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccount(loadingQuickbooksAccounts), quickbooksCategoryMappings);
                } else return A2($elm$core$List$repeat, 10, $author$project$Components$Admin$Quickbooks$Mappings$viewIncomeAccountSkeleton);
            }()),
            A2($author$project$Components$Admin$Quickbooks$Mappings$viewAccount, 3, model.gh),
            function() {
                var _v2 = model.nP;
                if (_v2.$ === 3) {
                    var quickbooksCategoryMappings = _v2.a;
                    return $author$project$Components$Admin$Quickbooks$Mappings$hasUnmappedCategories(quickbooksCategoryMappings) ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Deposits with transactions in unmatched platform categories won\'t appear on QuickBooks.')
                    ])) : $author$project$Utils$Html$empty;
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewSyncForm = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Start syncing on'),
                $author$project$Ui$Form$Group$labelInsideControl,
                $author$project$Ui$Form$Group$inputSpanMd(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Hint will begin syncing transaction information for deposits made on or after this date. '),
                    $elm$html$Html$text('We recommend selecting a date in the future to prevent the integration from affecting past '),
                    $elm$html$Html$text('deposits that had already been reconciled in QuickBooks.')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$inputSpanMd(4)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DateInputMsg(fields.qg), A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(fields.$E)
                ]), fields.qg))
            ]))
        ]));
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewOverviewStep = F2(function(model, quickbooksIntegration) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewStatusLeft, $author$project$Api$Provider$QuickbooksIntegration$One$status(quickbooksIntegration), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Deactivate QuickBooks integration'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$Deactivate),
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$pull(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Deactivate the integration')
                ])),
                $author$project$Api$Provider$QuickbooksIntegration$One$errorsCount(quickbooksIntegration) > 0 ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$danger
                ]), _List_fromArray([
                    $author$project$Ui$Icon$cross(_List_fromArray([
                        $author$project$Ui$Icon$danger
                    ])),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'deposit', $author$project$Api$Provider$QuickbooksIntegration$One$errorsCount(quickbooksIntegration))),
                        $elm$html$Html$text(' failed to sync in the last 180 days. '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Custom__Id_String({
                            aef: 'rpt-xrMXbiUetHe1'
                        }), _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('View errors on the report.')
                        ]))
                    ]))
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('')
            ]), _List_fromArray([
                function() {
                    var _v0 = model.gy;
                    if (!_v0.$) {
                        var quickbooksMappings = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg, $author$project$Components$Admin$Quickbooks$Mappings$view(quickbooksMappings));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            function() {
                var _v1 = model.PU;
                if (!_v1.$) {
                    var form = _v1.a;
                    return $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewSyncForm(form);
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.hC;
                    if (!_v0.$) {
                        var autorizeRequest = _v0.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$AuthorizeOnQuickbooksHiConfirmClosed, _List_fromArray([
                            $author$project$Components$HiConfirm$verb('connect'),
                            $author$project$Components$HiConfirm$titleizeNoun(false),
                            $author$project$Components$HiConfirm$noun('to QuickBooks Online'),
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text('Hint provides this integration only as a convenience to you. QuickBooks is solely responsible for its service, content and policies, including those related to privacy and security. Please review QuickBooks\' Terms of Service, and Privacy Policy to ensure they meet your business and legal requirements.')
                            ])),
                            $author$project$Components$HiConfirm$loading(_Utils_eq(autorizeRequest, $author$project$Api$Data$Loading))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v1 = model.gy;
                    if (!_v1.$) {
                        var quickbooksMappings = _v1.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$QuickbooksMappingsMsg, $author$project$Components$Admin$Quickbooks$Mappings$modal(quickbooksMappings));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.fq;
                    if (!_v2.$) {
                        var deactivate = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$DeactivateHiConfirmClosed, _List_fromArray([
                            $author$project$Components$HiConfirm$verb('disconnect'),
                            $author$project$Components$HiConfirm$noun('Quickbooks'),
                            $author$project$Components$HiConfirm$loading(_Utils_eq(deactivate, $author$project$Api$Data$Loading))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A4($author$project$Ui$Image$view, model.qW, {
                            Jg: 'QuickBooks Online Logo'
                        }, _List_fromArray([
                            $author$project$Ui$Image$width(200)
                        ]), 8)
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, function() {
                        var _v3 = model.dd;
                        if (_v3.$ === 1) return $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$initialStepSkeleton;
                        else return _List_fromArray([
                            function() {
                                var _v4 = model._8;
                                switch(_v4.$){
                                    case 0:
                                        return $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewInitialStep(model);
                                    case 1:
                                        return $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewDownloadingStep;
                                    default:
                                        var quickbooksIntegration = _v4.a;
                                        return A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewOverviewStep, model, quickbooksIntegration);
                                }
                            }()
                        ]);
                    }()),
                    function() {
                        var _v5 = model._8;
                        switch(_v5.$){
                            case 0:
                                return $author$project$Ui$Panel$none;
                            case 1:
                                return $author$project$Ui$Panel$none;
                            default:
                                var quickbooksIntegration = _v5.a;
                                return A2($author$project$Pages$Marketplace$Quickbooks$Manage$Settings$viewOverviewFooter, model, quickbooksIntegration);
                        }
                    }()
                ]))
            ]),
            $2: 'Marketplace | Quickbooks Settings'
        };
    };
    var $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$init,
        aeR: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$load,
        ag3: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$save,
        ahE: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$subscriptions,
        aaO: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$update,
        aid: $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$view
    });
    var $author$project$Pages$Marketplace$Slug_String$CallToActionMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$ProductMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Platform$Session$One$organizationIsPartner = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq(2), A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, record.VA)));
    };
    var $author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner_product_documents'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath);
    };
    var $author$project$Api$Partner$PartnerProductDocument$signedFileUrl = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_file_url'
        ]), $author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath(id))));
    });
    var $author$project$Api$Provider$Marketplace$Product$productPath = function(slug) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            slug
        ]), $author$project$Api$Provider$Marketplace$Product$productsPath);
    };
    var $author$project$Api$Provider$Marketplace$Product$Document$documentsPath = function(slug) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'documents'
        ]), $author$project$Api$Provider$Marketplace$Product$productPath(slug));
    };
    var $author$project$Api$Provider$Marketplace$Product$Document$documentPath = F2(function(slug, documentId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            documentId
        ]), $author$project$Api$Provider$Marketplace$Product$Document$documentsPath(slug));
    });
    var $author$project$Api$Provider$Marketplace$Product$Document$signedUrl = F4(function(apiClient, slug, documentId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_url'
        ]), A2($author$project$Api$Provider$Marketplace$Product$Document$documentPath, slug, documentId))));
    });
    var $author$project$Pages$Marketplace$Slug_String$fetchDocumentSignedUrl = F5(function(session, apiClient, slug, documentId, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? A3($author$project$Api$Partner$PartnerProductDocument$signedFileUrl, apiClient, documentId, toMsg) : A4($author$project$Api$Provider$Marketplace$Product$Document$signedUrl, apiClient, slug, documentId, toMsg);
    });
    var $author$project$Pages$Marketplace$Slug_String$GotProviderPractice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$fetchPractice = F2(function(apiClient, session) {
        return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$Marketplace$Slug_String$GotProviderPractice);
    });
    var $author$project$Pages$Marketplace$Slug_String$GotPartnerMarketplaceProduct = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$GotProviderMarketplaceProduct = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Marketplace$Product$One$Product = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$One$Product = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Marketplace$Product$One$Record = function(partnerId) {
        return function(overview) {
            return function(highlights) {
                return function(quotes) {
                    return function(links) {
                        return function(dataFlows) {
                            return function(categories) {
                                return function(composedCtaUrl) {
                                    return function(partnerProductDocuments) {
                                        return function(preconditions) {
                                            return {
                                                K0: categories,
                                                LW: composedCtaUrl,
                                                M3: dataFlows,
                                                QK: highlights,
                                                Th: links,
                                                VK: overview,
                                                V_: partnerId,
                                                V0: partnerProductDocuments,
                                                Xf: preconditions,
                                                X4: quotes
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Common$Marketplace$Product$DataFlow$DataFlow = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$DataFlow$Record = F3(function(hintName, partnerName, syncDirection) {
        return {
            QQ: hintName,
            V$: partnerName,
            $F: syncDirection
        };
    });
    var $author$project$Api$Common$Marketplace$Product$DataFlow$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sync_direction', $author$project$Api$Common$Marketplace$Product$SyncDirection$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hint_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$DataFlow$Record)))));
    var $author$project$Api$Common$Marketplace$Product$Document$Document = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$Document$Record = F4(function(id, title, documentType, url) {
        return {
            Og: documentType,
            aef: id,
            $2: title,
            aaT: url
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Document$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'document_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Document$Record)))));
    var $author$project$Api$Common$Marketplace$Product$Document$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Document$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Marketplace$Product$Highlight$Highlight = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$Highlight$Record = F3(function(title, description, imageUrl) {
        return {
            NQ: description,
            Q4: imageUrl,
            $2: title
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Highlight$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'image_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Highlight$Record))));
    var $author$project$Api$Common$Marketplace$Product$Highlight$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Highlight$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Marketplace$Product$Link$Link = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$Link$Record = F4(function(title, linkType, value, composedUrl) {
        return {
            LX: composedUrl,
            Tf: linkType,
            $2: title,
            aa9: value
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Link$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'composed_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'value', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'link_type', $author$project$Api$Common$Marketplace$Product$LinkType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Link$Record)))));
    var $author$project$Api$Common$Marketplace$Product$Link$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Link$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Marketplace$Product$Overview$Overview = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$Overview$Record = F2(function(description, images) {
        return {
            NQ: description,
            Q5: images
        };
    });
    var $author$project$Api$Common$Marketplace$Product$ProductImage$ProductImage = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$ProductImage$Record = F2(function(fileUrl, alt) {
        return {
            Jg: alt,
            PH: fileUrl
        };
    });
    var $author$project$Api$Common$Marketplace$Product$ProductImage$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'alt', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_url', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$ProductImage$Record)));
    var $author$project$Api$Common$Marketplace$Product$ProductImage$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$ProductImage$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Marketplace$Product$Overview$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'images', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$ProductImage$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Overview$Record)));
    var $author$project$Api$Common$Marketplace$Product$Overview$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Overview$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Marketplace$Product$Precondition$Precondition = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$Precondition$Record = F3(function(id, type_, url) {
        return {
            aef: id,
            ah5: type_,
            aaT: url
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Precondition$Type$ExternalAccount = 1;
    var $author$project$Api$Common$Marketplace$Product$Precondition$Type$ExternalInstall = 0;
    var $author$project$Api$Common$Marketplace$Product$Precondition$Type$decoder = A2($elm$json$Json$Decode$andThen, function(s) {
        switch(s){
            case 'external_install':
                return $elm$json$Json$Decode$succeed(0);
            case 'external_account':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unknown precondition type: ' + s);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Marketplace$Product$Precondition$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Common$Marketplace$Product$Precondition$Type$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Precondition$Record)))));
    var $author$project$Api$Common$Marketplace$Product$Quote$Quote = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$Quote$Record = F4(function(text, author, authorTitle, authorImageUrl) {
        return {
            JP: author,
            JQ: authorImageUrl,
            JR: authorTitle,
            $Y: text
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Quote$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'author_image_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'author_title', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'author', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'text', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$Quote$Record)))));
    var $author$project$Api$Common$Marketplace$Product$Quote$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Quote$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Common$Marketplace$Product$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'preconditions', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Precondition$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_product_documents', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Document$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'composed_cta_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'categories', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'data_flows', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$DataFlow$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'links', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Link$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quotes', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Quote$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'highlights', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Highlight$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'overview', $elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Overview$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$One$Record)))))))))));
    var $author$project$Api$Common$Marketplace$Product$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$One$Product)));
    var $author$project$Api$Partner$Marketplace$Product$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Marketplace$Product$productsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'marketplace',
        'products'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Marketplace$Product$productPath = function(slug) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            slug
        ]), $author$project$Api$Partner$Marketplace$Product$productsPath);
    };
    var $author$project$Api$Partner$Marketplace$Product$retrieve = F3(function(apiClient, slug, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Partner$Marketplace$Product$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$Marketplace$Product$productPath(slug)));
    });
    var $author$project$Api$Provider$Marketplace$Product$One$Product = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Marketplace$Product$One$Record = F4(function(status, engagementStatus, betaAccess, installMeta) {
        return {
            J9: betaAccess,
            OU: engagementStatus,
            Rk: installMeta,
            ahy: status
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Other = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted = {
        $: 2
    };
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallAttempted = {
        $: 3
    };
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested = {
        $: 4
    };
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested = {
        $: 1
    };
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted = {
        $: 0
    };
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString = function(string) {
        switch(string){
            case 'waitlisted':
                return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted);
            case 'interested':
                return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested);
            case 'beta_access_granted':
                return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted);
            case 'install_attempted':
                return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallAttempted);
            case 'install_requested':
                return $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$InstallRequested);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder = A2($elm$json$Json$Decode$map, function(string) {
        return A2($elm$core$Maybe$withDefault, $author$project$Api$Common$Marketplace$Product$Engagement$Status$Other(string), $author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString(string));
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$InstallMeta = $elm$core$Basics$identity;
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$Record = F3(function(enabled, reason, missingRequirements) {
        return {
            OM: enabled,
            Us: missingRequirements,
            Yb: reason
        };
    });
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingFeature = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingTier = {
        $: 1
    };
    var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr = {
        $: 0
    };
    var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Other = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString = function(string) {
        if (string === 'emr') return $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr;
        else return $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Other(string);
    };
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirementDecoder = A2($elm$json$Json$Decode$andThen, function(type_) {
        if (type_ === 'feature') return A2($elm$json$Json$Decode$map, A2($elm$core$Basics$composeL, $author$project$Api$Common$Marketplace$Product$InstallMeta$MissingFeature, $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString), A2($elm$json$Json$Decode$field, 'feature', $elm$json$Json$Decode$string));
        else return A2($elm$json$Json$Decode$map, $elm$core$Basics$always($author$project$Api$Common$Marketplace$Product$InstallMeta$MissingTier), A2($elm$json$Json$Decode$field, 'starting_tier', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'missing_requirements', $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirementDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reason', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enabled', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Common$Marketplace$Product$InstallMeta$Record)))));
    var $author$project$Api$Provider$Marketplace$Product$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $elm$json$Json$Decode$nullable(A2($elm$json$Json$Decode$field, 'install', $author$project$Api$Common$Marketplace$Product$InstallMeta$decoder)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'beta_access', A2($elm$json$Json$Decode$map, $elm$core$Maybe$withDefault(false), $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool)), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'engagement_status', $elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Marketplace$Product$One$Record)))));
    var $author$project$Api$Provider$Marketplace$Product$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Marketplace$Product$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$One$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Marketplace$Product$One$Product)));
    var $author$project$Api$Provider$Marketplace$Product$retrieve = F3(function(apiClient, slug, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Marketplace$Product$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Marketplace$Product$productPath(slug)));
    });
    var $author$project$Pages$Marketplace$Slug_String$fetchProduct = F3(function(apiClient, session, slug) {
        return $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? A3($author$project$Api$Partner$Marketplace$Product$retrieve, apiClient, slug, $author$project$Pages$Marketplace$Slug_String$GotPartnerMarketplaceProduct) : A3($author$project$Api$Provider$Marketplace$Product$retrieve, apiClient, slug, $author$project$Pages$Marketplace$Slug_String$GotProviderMarketplaceProduct);
    });
    var $author$project$Components$Marketplace$Product$Overview$CarouselMsg = $elm$core$Basics$identity;
    var $author$project$Components$Marketplace$Product$Overview$Model = $elm$core$Basics$identity;
    var $author$project$Components$Carousel$Model = F2(function(index, toMsg) {
        return {
            yc: index,
            ahX: toMsg
        };
    });
    var $author$project$Components$Carousel$init = $author$project$Components$Carousel$Model(0);
    var $author$project$Components$Marketplace$Product$Overview$init = function(overview) {
        return {
            pR: $author$project$Components$Carousel$init($elm$core$Basics$identity),
            VK: overview
        };
    };
    var $author$project$Components$Marketplace$Product$Quotes$CarouselMsg = $elm$core$Basics$identity;
    var $author$project$Components$Marketplace$Product$Quotes$Model = $elm$core$Basics$identity;
    var $author$project$Components$Marketplace$Product$Quotes$init = function(quotes) {
        return {
            pR: $author$project$Components$Carousel$init($elm$core$Basics$identity),
            X4: quotes
        };
    };
    var $author$project$Components$Marketplace$Product$init = function(_v0) {
        var imageStore = _v0.qW;
        return _Utils_Tuple2({
            qW: imageStore,
            VK: $author$project$Components$Marketplace$Product$Overview$init($elm$core$Maybe$Nothing),
            Xw: $elm$core$Maybe$Nothing,
            X4: $author$project$Components$Marketplace$Product$Quotes$init(_List_Nil)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Components$Marketplace$Product$CallToAction$AgreementsStep = 1;
    var $author$project$Components$Marketplace$Product$CallToAction$init = function(_v0) {
        var isAdmin = _v0.RO;
        var toMsg = _v0.ahX;
        var fetchDocumentSignedUrl = _v0.xJ;
        return {
            dr: $elm$core$Set$empty,
            ds: $elm$core$Set$empty,
            aV: $elm$core$Maybe$Nothing,
            dI: $elm$core$Maybe$Nothing,
            cX: $elm$core$Maybe$Just(1),
            xJ: fetchDocumentSignedUrl,
            RO: isAdmin,
            Tk: false,
            W1: $elm$core$Maybe$Nothing,
            Xw: $elm$core$Maybe$Nothing,
            ahX: toMsg
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$init = F3(function(session, shared, _v0) {
        var params = _v0.VU;
        var callToAction = $author$project$Components$Marketplace$Product$CallToAction$init({
            xJ: $author$project$Pages$Marketplace$Slug_String$fetchDocumentSignedUrl(session),
            RO: $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session),
            ahX: $author$project$Pages$Marketplace$Slug_String$CallToActionMsg
        });
        var _v1 = $author$project$Components$Marketplace$Product$init({
            qW: shared.qW
        });
        var product = _v1.a;
        var productCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aZ: callToAction,
            F3: $author$project$Shared$isHintAdmin(shared),
            rD: false,
            V_: $elm$core$Maybe$Nothing,
            Xw: product,
            sk: $elm$core$Maybe$Nothing,
            Z$: session,
            _A: params._A
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$ProductMsg, productCmd),
            A3($author$project$Pages$Marketplace$Slug_String$fetchProduct, shared.Ej, session, params._A),
            A2($author$project$Pages$Marketplace$Slug_String$fetchPractice, shared.Ej, session)
        ])));
    });
    var $author$project$Pages$Marketplace$Slug_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Slug_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Marketplace$Product$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled = {
        $: 3
    };
    var $author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled = {
        $: 10
    };
    var $author$project$Components$Marketplace$Product$CallToAction$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled)), model.aV)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled)), model.dI))
        ]));
    };
    var $author$project$Pages$Marketplace$Slug_String$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Marketplace$Slug_String$ProductMsg, $author$project$Components$Marketplace$Product$subscriptions(model.Xw)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Marketplace$Slug_String$CallToActionMsg, $author$project$Components$Marketplace$Product$CallToAction$subscriptions(model.aZ))
        ]));
    };
    var $author$project$Api$Common$Marketplace$Product$One$partnerId = function(_v0) {
        var record = _v0.b;
        return record.V_;
    };
    var $author$project$Api$Partner$Marketplace$Product$One$partnerId = function(_v0) {
        var common = _v0;
        return $author$project$Api$Common$Marketplace$Product$One$partnerId(common);
    };
    var $author$project$Api$Provider$Marketplace$Product$One$partnerId = function(_v0) {
        var common = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$One$partnerId(common);
    };
    var $author$project$Api$Common$Marketplace$Product$ProductImage$alt = function(_v0) {
        var record = _v0;
        return record.Jg;
    };
    var $author$project$Api$Common$Marketplace$Product$Quote$author = function(_v0) {
        var record = _v0;
        return record.JP;
    };
    var $author$project$Api$Common$Marketplace$Product$Quote$authorImageUrl = function(_v0) {
        var record = _v0;
        return record.JQ;
    };
    var $author$project$Api$Common$Marketplace$Product$Quote$authorTitle = function(_v0) {
        var record = _v0;
        return record.JR;
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$builtByName = function(_v0) {
        var record = _v0;
        return record.Ku;
    };
    var $author$project$Api$Common$Marketplace$Product$One$builtByName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$builtByName(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$builtByUrl = function(_v0) {
        var record = _v0;
        return record.Kv;
    };
    var $author$project$Api$Common$Marketplace$Product$One$builtByUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$builtByUrl(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$One$categories = function(_v0) {
        var record = _v0.b;
        return record.K0;
    };
    var $author$project$Api$Common$Marketplace$Product$One$composedCtaUrl = function(_v0) {
        var record = _v0.b;
        return record.LW;
    };
    var $author$project$Api$Common$Marketplace$Product$Link$composedUrl = function(_v0) {
        var record = _v0;
        return record.LX;
    };
    var $author$project$Api$Common$Marketplace$Product$One$dataFlows = function(_v0) {
        var record = _v0.b;
        return record.M3;
    };
    var $author$project$Api$Common$Marketplace$Product$Highlight$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Common$Marketplace$Product$Overview$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$distributionType = function(_v0) {
        var record = _v0;
        return record.N9;
    };
    var $author$project$Api$Common$Marketplace$Product$One$distributionType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$distributionType(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$Document$documentType = function(_v0) {
        var record = _v0;
        return record.Og;
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$featured = function(_v0) {
        var record = _v0;
        return record.Pw;
    };
    var $author$project$Api$Common$Marketplace$Product$One$featured = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$featured(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$ProductImage$fileUrl = function(_v0) {
        var record = _v0;
        return record.PH;
    };
    var $author$project$Api$Common$Marketplace$Product$One$highlights = function(_v0) {
        var record = _v0.b;
        return record.QK;
    };
    var $author$project$Api$Common$Marketplace$Product$DataFlow$hintName = function(_v0) {
        var record = _v0;
        return record.QQ;
    };
    var $author$project$Api$Common$Marketplace$Product$One$iconUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$Document$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Common$Marketplace$Product$Highlight$imageUrl = function(_v0) {
        var record = _v0;
        return record.Q4;
    };
    var $author$project$Api$Common$Marketplace$Product$Overview$images = function(_v0) {
        var record = _v0;
        return record.Q5;
    };
    var $author$project$Api$Common$Marketplace$Product$Link$linkType = function(_v0) {
        var record = _v0;
        return record.Tf;
    };
    var $author$project$Api$Common$Marketplace$Product$One$links = function(_v0) {
        var record = _v0.b;
        return record.Th;
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$listingStatus = function(_v0) {
        var record = _v0;
        return record.Tj;
    };
    var $author$project$Api$Common$Marketplace$Product$One$listingStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$listingStatus(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$Category$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Common$Marketplace$Product$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$name(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$One$overview = function(_v0) {
        var record = _v0.b;
        return record.VK;
    };
    var $author$project$Api$Common$Marketplace$Product$DataFlow$partnerName = function(_v0) {
        var record = _v0;
        return record.V$;
    };
    var $author$project$Api$Common$Marketplace$Product$One$partnerProductDocuments = function(_v0) {
        var record = _v0.b;
        return record.V0;
    };
    var $author$project$Api$Common$Marketplace$Product$One$preconditions = function(_v0) {
        var record = _v0.b;
        return record.Xf;
    };
    var $author$project$Api$Common$Marketplace$Product$One$quotes = function(_v0) {
        var record = _v0.b;
        return record.X4;
    };
    var $author$project$Api$Common$Marketplace$Product$One$slug = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$slug(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$Shared$summary = function(_v0) {
        var record = _v0;
        return record.$x;
    };
    var $author$project$Api$Common$Marketplace$Product$One$summary = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$summary(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$DataFlow$syncDirection = function(_v0) {
        var record = _v0;
        return record.$F;
    };
    var $author$project$Api$Common$Marketplace$Product$Quote$text = function(_v0) {
        var record = _v0;
        return record.$Y;
    };
    var $author$project$Api$Common$Marketplace$Product$Document$title = function(_v0) {
        var record = _v0;
        return record.$2;
    };
    var $author$project$Api$Common$Marketplace$Product$Highlight$title = function(_v0) {
        var record = _v0;
        return record.$2;
    };
    var $author$project$Api$Common$Marketplace$Product$Link$title = function(_v0) {
        var record = _v0;
        return record.$2;
    };
    var $author$project$Api$Common$Marketplace$Product$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Common$Marketplace$Product$Shared$type_(shared);
    };
    var $author$project$Api$Common$Marketplace$Product$Document$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Api$Common$Marketplace$Product$Link$value = function(_v0) {
        var record = _v0;
        return record.aa9;
    };
    var $author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded = function(marketplaceProduct) {
        return {
            J9: false,
            Ku: $author$project$Api$Common$Marketplace$Product$One$builtByName(marketplaceProduct),
            Kv: $author$project$Api$Common$Marketplace$Product$One$builtByUrl(marketplaceProduct),
            K0: A2($elm$core$List$map, function(cat) {
                return {
                    zr: $author$project$Api$Common$Marketplace$Product$Category$name(cat)
                };
            }, $author$project$Api$Common$Marketplace$Product$One$categories(marketplaceProduct)),
            LW: $author$project$Api$Common$Marketplace$Product$One$composedCtaUrl(marketplaceProduct),
            M3: A2($elm$core$List$map, function(df) {
                return {
                    QQ: $author$project$Api$Common$Marketplace$Product$DataFlow$hintName(df),
                    V$: $author$project$Api$Common$Marketplace$Product$DataFlow$partnerName(df),
                    $F: $author$project$Api$Common$Marketplace$Product$DataFlow$syncDirection(df)
                };
            }, $author$project$Api$Common$Marketplace$Product$One$dataFlows(marketplaceProduct)),
            N9: $author$project$Api$Common$Marketplace$Product$One$distributionType(marketplaceProduct),
            OU: $elm$core$Maybe$Nothing,
            Pw: $author$project$Api$Common$Marketplace$Product$One$featured(marketplaceProduct),
            QK: A2($elm$core$List$map, function(hl) {
                return {
                    NQ: $author$project$Api$Common$Marketplace$Product$Highlight$description(hl),
                    Q4: $author$project$Api$Common$Marketplace$Product$Highlight$imageUrl(hl),
                    $2: $author$project$Api$Common$Marketplace$Product$Highlight$title(hl)
                };
            }, $author$project$Api$Common$Marketplace$Product$One$highlights(marketplaceProduct)),
            Q_: $author$project$Api$Common$Marketplace$Product$One$iconUrl(marketplaceProduct),
            Rk: $elm$core$Maybe$Nothing,
            Th: A2($elm$core$List$map, function(l) {
                return {
                    LX: $author$project$Api$Common$Marketplace$Product$Link$composedUrl(l),
                    Tf: $author$project$Api$Common$Marketplace$Product$Link$linkType(l),
                    $2: $author$project$Api$Common$Marketplace$Product$Link$title(l),
                    aa9: $author$project$Api$Common$Marketplace$Product$Link$value(l)
                };
            }, $author$project$Api$Common$Marketplace$Product$One$links(marketplaceProduct)),
            Tj: $author$project$Api$Common$Marketplace$Product$One$listingStatus(marketplaceProduct),
            zr: $author$project$Api$Common$Marketplace$Product$One$name(marketplaceProduct),
            VK: A2($elm$core$Maybe$map, function(overview) {
                return {
                    NQ: $author$project$Api$Common$Marketplace$Product$Overview$description(overview),
                    Q5: A2($elm$core$List$map, function(img) {
                        return {
                            Jg: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$Marketplace$Product$ProductImage$alt(img)),
                            aaT: $author$project$Api$Common$Marketplace$Product$ProductImage$fileUrl(img)
                        };
                    }, $author$project$Api$Common$Marketplace$Product$Overview$images(overview))
                };
            }, $author$project$Api$Common$Marketplace$Product$One$overview(marketplaceProduct)),
            V0: A2($elm$core$List$map, function(doc) {
                return {
                    Og: $author$project$Api$Common$Marketplace$Product$Document$documentType(doc),
                    aef: $author$project$Api$Common$Marketplace$Product$Document$id(doc),
                    $2: $author$project$Api$Common$Marketplace$Product$Document$title(doc),
                    aaT: $author$project$Api$Common$Marketplace$Product$Document$url(doc)
                };
            }, $author$project$Api$Common$Marketplace$Product$One$partnerProductDocuments(marketplaceProduct)),
            Xf: $author$project$Api$Common$Marketplace$Product$One$preconditions(marketplaceProduct),
            X4: A2($elm$core$List$map, function(q) {
                return {
                    JP: $author$project$Api$Common$Marketplace$Product$Quote$author(q),
                    JQ: $author$project$Api$Common$Marketplace$Product$Quote$authorImageUrl(q),
                    JR: $author$project$Api$Common$Marketplace$Product$Quote$authorTitle(q),
                    $Y: $author$project$Api$Common$Marketplace$Product$Quote$text(q)
                };
            }, $author$project$Api$Common$Marketplace$Product$One$quotes(marketplaceProduct)),
            _A: $author$project$Api$Common$Marketplace$Product$One$slug(marketplaceProduct),
            ahy: $elm$core$Maybe$Nothing,
            $x: $author$project$Api$Common$Marketplace$Product$One$summary(marketplaceProduct),
            ah5: $author$project$Api$Common$Marketplace$Product$One$type_(marketplaceProduct)
        };
    };
    var $author$project$Api$Partner$Marketplace$Product$One$toCommon = function(_v0) {
        var common = _v0;
        return common;
    };
    var $author$project$Pages$Marketplace$Slug_String$partnerMarketplaceProductToProductExpanded = function(marketplaceProduct) {
        return $author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded($author$project$Api$Partner$Marketplace$Product$One$toCommon(marketplaceProduct));
    };
    var $author$project$Api$Provider$Marketplace$Product$One$betaAccess = function(_v0) {
        var record = _v0.b;
        return record.J9;
    };
    var $author$project$Api$Provider$Marketplace$Product$One$engagementStatus = function(_v0) {
        var record = _v0.b;
        return record.OU;
    };
    var $author$project$Api$Provider$Marketplace$Product$One$installMeta = function(_v0) {
        var record = _v0.b;
        return record.Rk;
    };
    var $author$project$Api$Provider$Marketplace$Product$One$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Api$Provider$Marketplace$Product$One$toCommon = function(_v0) {
        var common = _v0.a;
        return common;
    };
    var $author$project$Pages$Marketplace$Slug_String$providerMarketplaceProductToProductExpanded = function(marketplaceProduct) {
        return function(expanded) {
            return _Utils_update(expanded, {
                J9: $author$project$Api$Provider$Marketplace$Product$One$betaAccess(marketplaceProduct),
                OU: $author$project$Api$Provider$Marketplace$Product$One$engagementStatus(marketplaceProduct),
                Rk: $author$project$Api$Provider$Marketplace$Product$One$installMeta(marketplaceProduct),
                ahy: $author$project$Api$Provider$Marketplace$Product$One$status(marketplaceProduct)
            });
        }($author$project$Pages$Marketplace$Slug_String$commonMarketplaceProductToProductExpanded($author$project$Api$Provider$Marketplace$Product$One$toCommon(marketplaceProduct)));
    };
    var $author$project$Components$Marketplace$Product$CallToAction$setPractice = F2(function(practice, model) {
        return _Utils_update(model, {
            W1: $elm$core$Maybe$Just(practice)
        });
    });
    var $author$project$Components$Marketplace$Product$setProduct = F2(function(product, model) {
        return _Utils_update(model, {
            VK: $author$project$Components$Marketplace$Product$Overview$init(product.VK),
            Xw: $elm$core$Maybe$Just(product),
            X4: $author$project$Components$Marketplace$Product$Quotes$init(product.X4)
        });
    });
    var $author$project$Components$Marketplace$Product$CallToAction$setProduct = F2(function(product, model) {
        return _Utils_update(model, {
            Xw: $elm$core$Maybe$Just(product)
        });
    });
    var $author$project$Pages$Marketplace$Slug_String$toCallToActionProduct = function(product) {
        return {
            J9: product.J9,
            LW: product.LW,
            N9: product.N9,
            OU: product.OU,
            Rk: product.Rk,
            Tj: product.Tj,
            zr: product.zr,
            V0: product.V0,
            Xf: product.Xf,
            _A: product._A,
            ahy: product.ahy,
            ah5: product.ah5
        };
    };
    var $author$project$Components$Marketplace$Product$OverviewMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$QuotesMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Carousel$update = F2(function(msg, model) {
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map(model.ahX), function() {
            var index = msg;
            return _Utils_Tuple2(_Utils_update(model, {
                yc: index
            }), $elm$core$Platform$Cmd$none);
        }());
    });
    var $author$project$Components$Marketplace$Product$Overview$update = F2(function(msg, _v0) {
        var model = _v0;
        var carouselMsg = msg;
        return A2($elm$core$Tuple$mapFirst, function(carousel) {
            return _Utils_update(model, {
                pR: carousel
            });
        }, A2($author$project$Components$Carousel$update, carouselMsg, model.pR));
    });
    var $author$project$Components$Marketplace$Product$Quotes$update = F2(function(msg, _v0) {
        var model = _v0;
        var carouselMsg = msg;
        return A2($elm$core$Tuple$mapFirst, function(carousel) {
            return _Utils_update(model, {
                pR: carousel
            });
        }, A2($author$project$Components$Carousel$update, carouselMsg, model.pR));
    });
    var $author$project$Components$Marketplace$Product$update = F2(function(msg, model) {
        if (!msg.$) {
            var overviewMsg = msg.a;
            return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Marketplace$Product$OverviewMsg), A2($elm$core$Tuple$mapFirst, function(overview) {
                return _Utils_update(model, {
                    VK: overview
                });
            }, A2($author$project$Components$Marketplace$Product$Overview$update, overviewMsg, model.VK)));
        } else {
            var quotesMsg = msg.a;
            return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Marketplace$Product$QuotesMsg), A2($elm$core$Tuple$mapFirst, function(quotes) {
                return _Utils_update(model, {
                    X4: quotes
                });
            }, A2($author$project$Components$Marketplace$Product$Quotes$update, quotesMsg, model.X4)));
        }
    });
    var $author$project$Components$Marketplace$Product$CallToAction$Activated = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Marketplace$Product$CallToAction$BetaAccessRequested = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$Deactivated = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Marketplace$Product$CallToAction$GotPdfDocumentSignedUrl = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$InstallAttempted = {
        $: 1
    };
    var $author$project$Components$Marketplace$Product$CallToAction$InstallRequested = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$InterestExpressed = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$None = 0;
    var $author$project$Components$Marketplace$Product$CallToAction$PartnerActivated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ProductActivated = 1;
    var $author$project$Components$Marketplace$Product$CallToAction$ProductDeactivated = 3;
    var $author$project$Components$Marketplace$Product$CallToAction$ProductEngagementUpdated = 4;
    var $author$project$Components$Marketplace$Product$CallToAction$ProductInstallRequested = 5;
    var $author$project$Components$Marketplace$Product$CallToAction$ProductPartnerActivated = 2;
    var $author$project$Components$Marketplace$Product$CallToAction$RequirementsStep = 0;
    var $author$project$Api$Provider$Marketplace$Product$expressInterest = F3(function(apiClient, slug, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Marketplace$Product$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'express_interest'
        ]), $author$project$Api$Provider$Marketplace$Product$productPath(slug))));
    });
    var $author$project$Api$Common$Marketplace$Product$Precondition$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$Product = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration', $author$project$Api$Provider$Integration$One$decoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Marketplace$Product$One$decoder, $elm$json$Json$Decode$succeed(F2(function(_v0, inte) {
        return inte;
    }))));
    var $author$project$Api$Provider$Marketplace$Product$install = F4(function(apiClient, slug, partnerProductDocumentIds, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_document_ids', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, partnerProductDocumentIds))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'install'
        ]), $author$project$Api$Provider$Marketplace$Product$productPath(slug)))));
    });
    var $author$project$Api$Provider$Marketplace$Product$installAttempted = F3(function(apiClient, slug, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Marketplace$Product$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'attempt_install'
        ]), $author$project$Api$Provider$Marketplace$Product$productPath(slug))));
    });
    var $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$integration = function(_v0) {
        var i = _v0;
        return i;
    };
    var $author$project$Api$Provider$Marketplace$Product$requestBeta = F3(function(apiClient, slug, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Marketplace$Product$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'request_beta_access'
        ]), $author$project$Api$Provider$Marketplace$Product$productPath(slug))));
    });
    var $author$project$Api$Provider$Marketplace$Product$requestInstall = F3(function(apiClient, slug, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Marketplace$Product$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'request_install'
        ]), $author$project$Api$Provider$Marketplace$Product$productPath(slug))));
    });
    var $author$project$Api$Provider$Marketplace$Product$uninstall = F3(function(apiClient, slug, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'uninstall'
        ]), $author$project$Api$Provider$Marketplace$Product$productPath(slug))));
    });
    var $author$project$Components$Marketplace$Product$CallToAction$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var product = msg.a;
                var initialStep = $elm$core$List$isEmpty(product.V0) ? $elm$core$Maybe$Just(0) : $elm$core$Maybe$Just(1);
                return _Utils_Tuple3(_Utils_update(model, {
                    dr: $elm$core$Set$empty,
                    ds: $elm$core$Set$empty,
                    aV: $elm$core$Maybe$Just(_Utils_Tuple2(product, $author$project$Api$Data$NotAsked)),
                    cX: initialStep
                }), A3($author$project$Api$Provider$Marketplace$Product$installAttempted, apiClient, product._A, $elm$core$Basics$always($author$project$Components$Marketplace$Product$CallToAction$InstallAttempted)), 0);
            case 1:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 0);
            case 2:
                var product = msg.a;
                var documentIds = A2($elm$core$List$map, function($) {
                    return $.aef;
                }, product.V0);
                return _Utils_Tuple3(_Utils_update(model, {
                    aV: $elm$core$Maybe$Just(_Utils_Tuple2(product, $author$project$Api$Data$Loading))
                }), A4($author$project$Api$Provider$Marketplace$Product$install, apiClient, product._A, documentIds, $author$project$Components$Marketplace$Product$CallToAction$Activated(product)), 0);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    dr: $elm$core$Set$empty,
                    ds: $elm$core$Set$empty,
                    aV: $elm$core$Maybe$Nothing,
                    cX: $elm$core$Maybe$Just(1)
                }), $elm$core$Platform$Cmd$none, 0);
            case 4:
                var documentId = msg.a;
                var checked = msg.b;
                var acceptedDocumentIds = checked ? A2($elm$core$Set$insert, documentId, model.dr) : A2($elm$core$Set$remove, documentId, model.dr);
                var allAccepted = function() {
                    var _v1 = model.aV;
                    if (!_v1.$) {
                        var _v2 = _v1.a;
                        var product = _v2.a;
                        return A2($elm$core$List$all, function(doc) {
                            return A2($elm$core$Set$member, doc.aef, acceptedDocumentIds);
                        }, product.V0);
                    } else return false;
                }();
                var expandedModalStep = allAccepted ? $elm$core$Maybe$Just(0) : model.cX;
                return _Utils_Tuple3(_Utils_update(model, {
                    dr: acceptedDocumentIds,
                    cX: expandedModalStep
                }), $elm$core$Platform$Cmd$none, 0);
            case 5:
                var preconditionId = msg.a;
                var checked = msg.b;
                var acceptedPreconditionIds = checked ? A2($elm$core$Set$insert, preconditionId, model.ds) : A2($elm$core$Set$remove, preconditionId, model.ds);
                var allAccepted = function() {
                    var _v3 = model.aV;
                    if (!_v3.$) {
                        var _v4 = _v3.a;
                        var product = _v4.a;
                        return A2($elm$core$List$all, function(p) {
                            return A2($elm$core$Set$member, $author$project$Api$Common$Marketplace$Product$Precondition$id(p), acceptedPreconditionIds);
                        }, product.Xf);
                    } else return false;
                }();
                var expandedModalStep = allAccepted ? $elm$core$Maybe$Nothing : model.cX;
                return _Utils_Tuple3(_Utils_update(model, {
                    ds: acceptedPreconditionIds,
                    cX: expandedModalStep
                }), $elm$core$Platform$Cmd$none, 0);
            case 6:
                var product = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var installedProduct = response.a;
                    var integration = $author$project$Api$Provider$Marketplace$Product$OneWithIntegration$integration(installedProduct);
                    var cmd = function() {
                        var _v6 = _Utils_Tuple3($author$project$Api$Provider$Integration$One$authType(integration), $author$project$Api$Provider$Integration$One$connectionUrl(integration), $author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
                        _v6$0: while(true){
                            _v6$3: while(true){
                                _v6$4: while(true)switch(_v6.a){
                                    case 'automatic_redirect':
                                        if (!_v6.c.$) {
                                            if (!_v6.b.$) break _v6$0;
                                            else break _v6$3;
                                        } else {
                                            if (!_v6.b.$) break _v6$0;
                                            else break _v6$4;
                                        }
                                    case 'automatic_headless':
                                        return A3($author$project$Api$Provider$Integration$connect, apiClient, $author$project$Api$Provider$Integration$One$id(integration), $author$project$Components$Marketplace$Product$CallToAction$PartnerActivated);
                                    case 'manual':
                                        if (A2($elm$core$List$member, $author$project$Api$Provider$Integration$One$status(integration), _List_fromArray([
                                            'pending',
                                            'inactive'
                                        ]))) {
                                            var _v7 = product._A;
                                            switch(_v7){
                                                case 'quickbooks':
                                                    return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings);
                                                case 'elation':
                                                    return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings);
                                                default:
                                                    return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding({
                                                        _A: product._A
                                                    }));
                                            }
                                        } else return $elm$core$Platform$Cmd$none;
                                    default:
                                        if (!_v6.c.$) break _v6$3;
                                        else break _v6$4;
                                }
                                var _v8 = _v6.c;
                                return $elm$core$Platform$Cmd$none;
                            }
                            var postActivationRedirectUrl = _v6.c.a;
                            return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
                        }
                        var connectionUrl = _v6.b.a;
                        return $author$project$Ports$Navigation$openInNewWindow(connectionUrl);
                    }();
                    var activatingProduct = $author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless' ? $elm$core$Maybe$Just(_Utils_Tuple2(product, response)) : $elm$core$Maybe$Nothing;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aV: activatingProduct
                    }), cmd, 1);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    aV: $elm$core$Maybe$Just(_Utils_Tuple2(product, response))
                }), $elm$core$Platform$Cmd$none, 0);
            case 7:
                var response = msg.a;
                if (response.$ === 3) {
                    var integration = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aV: $elm$core$Maybe$Nothing
                    }), function() {
                        var _v10 = _Utils_Tuple2($author$project$Api$Provider$Integration$One$authType(integration), $author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
                        if (_v10.a === 'automatic_headless' && !_v10.b.$) {
                            var postActivationRedirectUrl = _v10.b.a;
                            return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
                        } else return $elm$core$Platform$Cmd$none;
                    }(), 2);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    aV: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, 0);
            case 8:
                var product = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    dI: $elm$core$Maybe$Just(_Utils_Tuple2(product, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, 0);
            case 9:
                var product = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    dI: $elm$core$Maybe$Just(_Utils_Tuple2(product, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$Marketplace$Product$uninstall, apiClient, product._A, $author$project$Components$Marketplace$Product$CallToAction$Deactivated(product)), 0);
            case 10:
                return _Utils_Tuple3(_Utils_update(model, {
                    dI: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, 0);
            case 11:
                var product = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    dI: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, 3);
                else return _Utils_Tuple3(_Utils_update(model, {
                    dI: $elm$core$Maybe$Just(_Utils_Tuple2(product, response))
                }), $elm$core$Platform$Cmd$none, 0);
            case 12:
                var product = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tk: true
                }), A3($author$project$Api$Provider$Marketplace$Product$requestBeta, apiClient, product._A, $author$project$Components$Marketplace$Product$CallToAction$BetaAccessRequested), 0);
            case 13:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false
                }), $elm$core$Platform$Cmd$none, 4);
                else return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false
                }), $elm$core$Platform$Cmd$none, 0);
            case 14:
                var product = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tk: true
                }), A3($author$project$Api$Provider$Marketplace$Product$expressInterest, apiClient, product._A, $author$project$Components$Marketplace$Product$CallToAction$InterestExpressed), 0);
            case 15:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false
                }), $elm$core$Platform$Cmd$none, 4);
                else return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false
                }), $elm$core$Platform$Cmd$none, 0);
            case 16:
                var product = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tk: true
                }), A3($author$project$Api$Provider$Marketplace$Product$requestInstall, apiClient, product._A, $author$project$Components$Marketplace$Product$CallToAction$InstallRequested), 0);
            case 17:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false
                }), $elm$core$Platform$Cmd$none, 5);
                else return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false
                }), $elm$core$Platform$Cmd$none, 0);
            case 18:
                var document1 = msg.a;
                var _v15 = model.Xw;
                if (!_v15.$) {
                    var product = _v15.a;
                    return _Utils_Tuple3(model, A4(model.xJ, apiClient, product._A, document1.aef, $author$project$Components$Marketplace$Product$CallToAction$GotPdfDocumentSignedUrl), 0);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 0);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(url), 0);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, 0);
        }
    });
    var $author$project$Pages$Marketplace$Slug_String$update = F2(function(msg, model) {
        switch(msg.$){
            case 3:
                var prodMsg = msg.a;
                var _v1 = A2($author$project$Components$Marketplace$Product$update, prodMsg, model.Xw);
                var product = _v1.a;
                var productCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    Xw: product
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$ProductMsg, productCmd), _List_Nil);
            case 4:
                var ctaMsg = msg.a;
                var fetchProductCmd = A3($author$project$Pages$Marketplace$Slug_String$fetchProduct, model.Ej, model.Z$, model._A);
                var _v2 = A3($author$project$Components$Marketplace$Product$CallToAction$update, model.Ej, ctaMsg, model.aZ);
                var callToAction = _v2.a;
                var ctaCmd = _v2.b;
                var ctaEvent = _v2.c;
                var cmd = function() {
                    switch(ctaEvent){
                        case 0:
                            return $elm$core$Platform$Cmd$none;
                        case 1:
                            return fetchProductCmd;
                        case 2:
                            return fetchProductCmd;
                        case 3:
                            return fetchProductCmd;
                        case 4:
                            return fetchProductCmd;
                        default:
                            return fetchProductCmd;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    aZ: callToAction
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$CallToActionMsg, ctaCmd),
                    cmd
                ])), _List_Nil);
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aZ: A2($author$project$Components$Marketplace$Product$CallToAction$setPractice, {
                            zr: $author$project$Api$Provider$Practice$One$name(practice)
                        }, model.aZ)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                _v5$2: while(true)switch(response.$){
                    case 3:
                        var marketplaceProduct = response.a;
                        var productExpanded = $author$project$Pages$Marketplace$Slug_String$providerMarketplaceProductToProductExpanded(marketplaceProduct);
                        return _Utils_Tuple3(_Utils_update(model, {
                            aZ: A2($author$project$Components$Marketplace$Product$CallToAction$setProduct, $author$project$Pages$Marketplace$Slug_String$toCallToActionProduct(productExpanded), model.aZ),
                            V_: $elm$core$Maybe$Just($author$project$Api$Provider$Marketplace$Product$One$partnerId(marketplaceProduct)),
                            Xw: A2($author$project$Components$Marketplace$Product$setProduct, productExpanded, model.Xw),
                            sk: $elm$core$Maybe$Just(productExpanded)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        if (response.a.$ === 5) {
                            var _v6 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                rD: true
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v5$2;
                    default:
                        break _v5$2;
                }
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                _v7$2: while(true)switch(response.$){
                    case 3:
                        var marketplaceProduct = response.a;
                        var productExpanded = $author$project$Pages$Marketplace$Slug_String$partnerMarketplaceProductToProductExpanded(marketplaceProduct);
                        return _Utils_Tuple3(_Utils_update(model, {
                            aZ: A2($author$project$Components$Marketplace$Product$CallToAction$setProduct, $author$project$Pages$Marketplace$Slug_String$toCallToActionProduct(productExpanded), model.aZ),
                            V_: $elm$core$Maybe$Just($author$project$Api$Partner$Marketplace$Product$One$partnerId(marketplaceProduct)),
                            Xw: A2($author$project$Components$Marketplace$Product$setProduct, productExpanded, model.Xw),
                            sk: $elm$core$Maybe$Just(productExpanded)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        if (response.a.$ === 5) {
                            var _v8 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                rD: true
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v7$2;
                    default:
                        break _v7$2;
                }
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Marketplace$Product$CallToAction$Activate = {
        $: 2
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ActivateProduct = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$DeactivateProduct = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$Disabled = 0;
    var $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest = {
        $: 1
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ExpressInterestClicked = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$RequestBeta = {
        $: 0
    };
    var $author$project$Components$Marketplace$Product$CallToAction$RequestBetaAccess = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$RequestInstallClicked = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$activateVerb = function(product) {
        var _v0 = product.ah5;
        switch(_v0){
            case 0:
                return 'Install App';
            case 1:
                return 'Connect Integration';
            default:
                return '';
        }
    };
    var $author$project$Components$Marketplace$Product$CallToAction$NoAction = {
        $: 5
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ExternalCta = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$Deactivate = {
        $: 3
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantFromEngagement = F2(function(product, variant) {
        if (product.J9) return $author$project$Components$Marketplace$Product$CallToAction$Activate;
        else {
            var _v0 = product.OU;
            _v0$3: while(true){
                if (!_v0.$) switch(_v0.a.$){
                    case 2:
                        var _v1 = _v0.a;
                        return $author$project$Components$Marketplace$Product$CallToAction$Activate;
                    case 3:
                        var _v2 = _v0.a;
                        return $author$project$Components$Marketplace$Product$CallToAction$Activate;
                    case 4:
                        var _v3 = _v0.a;
                        return $author$project$Components$Marketplace$Product$CallToAction$Activate;
                    default:
                        break _v0$3;
                }
                else break _v0$3;
            }
            return variant;
        }
    });
    var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive = F2(function(product, variant) {
        var _v0 = product.ahy;
        if (!_v0.$) {
            if (_v0.a === 'inactive') return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantFromEngagement, product, variant);
            else return $author$project$Components$Marketplace$Product$CallToAction$Deactivate;
        } else return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantFromEngagement, product, variant);
    });
    var $author$project$Components$Marketplace$Product$CallToAction$ctaVariantForLive = function(product) {
        var _v0 = product.ah5;
        if (_v0 === 2) return A2($elm$core$Maybe$withDefault, $author$project$Components$Marketplace$Product$CallToAction$NoAction, A2($elm$core$Maybe$map, $author$project$Components$Marketplace$Product$CallToAction$ExternalCta, product.LW));
        else return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$Activate);
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ctaVariant = function(product) {
        var _v0 = product.Tj;
        switch(_v0){
            case 1:
                return $author$project$Components$Marketplace$Product$CallToAction$NoAction;
            case 0:
                return $author$project$Components$Marketplace$Product$CallToAction$NoAction;
            case 5:
                return $author$project$Components$Marketplace$Product$CallToAction$ctaVariantForLive(product);
            case 4:
                return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$RequestBeta);
            case 3:
                return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest);
            case 2:
                return A2($author$project$Components$Marketplace$Product$CallToAction$ctaVariantWhenNotActive, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest);
            default:
                return $author$project$Components$Marketplace$Product$CallToAction$NoAction;
        }
    };
    var $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb = function(product) {
        var _v0 = product.ah5;
        switch(_v0){
            case 0:
                return 'Uninstall App';
            case 1:
                return 'Disconnect Integration';
            default:
                return '';
        }
    };
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$enabled = function(_v0) {
        var record = _v0;
        return record.OM;
    };
    var $author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled = F2(function(product, variant) {
        var _v0 = _Utils_Tuple2(variant, product.OU);
        _v0$3: while(true){
            if (!_v0.b.$) switch(_v0.a.$){
                case 0:
                    if (!_v0.b.a.$) {
                        var _v1 = _v0.a;
                        var _v2 = _v0.b.a;
                        return true;
                    } else break _v0$3;
                case 1:
                    if (_v0.b.a.$ === 1) {
                        var _v3 = _v0.a;
                        var _v4 = _v0.b.a;
                        return true;
                    } else break _v0$3;
                case 2:
                    if (_v0.b.a.$ === 4) {
                        var _v5 = _v0.a;
                        var _v6 = _v0.b.a;
                        return true;
                    } else break _v0$3;
                default:
                    break _v0$3;
            }
            else break _v0$3;
        }
        return false;
    });
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirements = function(_v0) {
        var record = _v0;
        return record.Us;
    };
    var $author$project$Api$Common$Marketplace$Product$InstallMeta$reason = function(_v0) {
        var record = _v0;
        return record.Yb;
    };
    var $author$project$Components$Marketplace$Product$CallToAction$requestInstallVerb = function(product) {
        var _v0 = product.ah5;
        switch(_v0){
            case 0:
                return 'Request Install';
            case 1:
                return 'Request Connection';
            default:
                return '';
        }
    };
    var $author$project$Components$Marketplace$Product$CallToAction$requestedVerb = function(product) {
        var _v0 = product.ah5;
        switch(_v0){
            case 0:
                return 'Install Requested';
            case 1:
                return 'Connection Requested';
            default:
                return '';
        }
    };
    var $author$project$Components$Marketplace$Product$CallToAction$withMarketplaceUtmParams = function(url) {
        return A2($author$project$Utils$Url$addParams, url, _List_fromArray([
            A2($elm$url$Url$Builder$string, 'utm_source', 'hint'),
            A2($elm$url$Url$Builder$string, 'utm_medium', 'marketplace'),
            A2($elm$url$Url$Builder$string, 'utm_campaign', 'hint_marketplace')
        ]));
    };
    var $author$project$Components$Marketplace$Product$CallToAction$viewMissingRequirement = function(requirement) {
        if (!requirement.$ && !requirement.a.$) {
            var _v1 = requirement.a;
            return $elm$core$Maybe$Just(A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$externalHref, $author$project$Components$Marketplace$Product$CallToAction$withMarketplaceUtmParams('https://www.hint.com/clinical-upgrade'), _List_fromArray([
                    $author$project$Ui$Link$fullWidth,
                    $author$project$Ui$Link$buttonPrimary,
                    $author$project$Ui$Link$fullWidth,
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('Get a Demo')
                ]))
            ])));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Components$Marketplace$Product$CallToAction$button = F2(function(options, model) {
        return A2($elm$html$Html$map, model.ahX, function() {
            var _v0 = model.Xw;
            if (!_v0.$) {
                var product = _v0.a;
                var isDisabled = A2($elm$core$List$member, 0, options);
                var commonButtonOptions = _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(model.Tk),
                    $author$project$Ui$Button$fullWidth(true)
                ]);
                var _v1 = $author$project$Components$Marketplace$Product$CallToAction$ctaVariant(product);
                switch(_v1.$){
                    case 0:
                        var isButtonDisabled = isDisabled || model.Tk || A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$RequestBeta);
                        return A3($author$project$Ui$Button$view, {
                            abP: 'Request beta access'
                        }, A2($elm$core$List$cons, $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$RequestBetaAccess(product)), A2($elm$core$List$cons, $author$project$Ui$Button$disabled(isButtonDisabled), commonButtonOptions)), _List_fromArray([
                            $elm$html$Html$text(_Utils_eq(product.OU, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted)) ? 'On Waitlist' : 'Request beta access')
                        ]));
                    case 1:
                        var isButtonDisabled = isDisabled || model.Tk || A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$ExpressInterest);
                        return A3($author$project$Ui$Button$view, {
                            abP: 'Express interest'
                        }, A2($elm$core$List$cons, $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$ExpressInterestClicked(product)), A2($elm$core$List$cons, $author$project$Ui$Button$disabled(isButtonDisabled), commonButtonOptions)), _List_fromArray([
                            $elm$html$Html$text(_Utils_eq(product.OU, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested)) ? 'Interest expressed' : 'Express interest')
                        ]));
                    case 2:
                        if (model.RO) {
                            var installMeta = product.Rk;
                            var missingReqs = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$InstallMeta$missingRequirements, installMeta));
                            var reasonText = A2($elm$core$Maybe$andThen, $author$project$Api$Common$Marketplace$Product$InstallMeta$reason, installMeta);
                            var installEnabled = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$InstallMeta$enabled, installMeta));
                            return A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$gap2,
                                $author$project$Ui$Element$flexCol
                            ]), A2($elm$core$List$cons, A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: $author$project$Components$Marketplace$Product$CallToAction$activateVerb(product)
                                }, A2($elm$core$List$cons, $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$ActivateProduct(product)), A2($elm$core$List$cons, $author$project$Ui$Button$disabled(isDisabled || !installEnabled), commonButtonOptions)), _List_fromArray([
                                    $elm$html$Html$text($author$project$Components$Marketplace$Product$CallToAction$activateVerb(product))
                                ])),
                                function() {
                                    if (!reasonText.$) {
                                        var reason = reasonText.a;
                                        return A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$textCenter,
                                            $author$project$Ui$Element$textMuted,
                                            $author$project$Ui$Element$textSm
                                        ]), _List_fromArray([
                                            $elm$html$Html$text(reason)
                                        ]));
                                    } else return $elm$html$Html$text('');
                                }()
                            ])), A2($elm$core$List$filterMap, $author$project$Components$Marketplace$Product$CallToAction$viewMissingRequirement, missingReqs)));
                        } else {
                            var alreadyRequested = A2($author$project$Components$Marketplace$Product$CallToAction$isEngagementDisabled, product, $author$project$Components$Marketplace$Product$CallToAction$Activate);
                            var requestLabel = alreadyRequested ? $author$project$Components$Marketplace$Product$CallToAction$requestedVerb(product) : $author$project$Components$Marketplace$Product$CallToAction$requestInstallVerb(product);
                            return A3($author$project$Ui$Button$view, {
                                abP: requestLabel
                            }, A2($elm$core$List$cons, $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$RequestInstallClicked(product)), A2($elm$core$List$cons, $author$project$Ui$Button$disabled(isDisabled || alreadyRequested || model.Tk), commonButtonOptions)), _List_fromArray([
                                $elm$html$Html$text(requestLabel)
                            ]));
                        }
                    case 3:
                        return model.RO ? A3($author$project$Ui$Button$view, {
                            abP: $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product)
                        }, _List_fromArray([
                            $author$project$Ui$Button$danger,
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$loading(model.Tk),
                            $author$project$Ui$Button$disabled(isDisabled),
                            $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$DeactivateProduct(product))
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product))
                        ])) : A3($author$project$Ui$Button$view, {
                            abP: $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product)
                        }, _List_fromArray([
                            $author$project$Ui$Button$danger,
                            $author$project$Ui$Button$fullWidth(true),
                            $author$project$Ui$Button$disabled(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product))
                        ]));
                    case 4:
                        var url = _v1.a;
                        return isDisabled ? A3($author$project$Ui$Button$view, {
                            abP: 'Contact Partner'
                        }, A2($elm$core$List$cons, $author$project$Ui$Button$disabled(true), commonButtonOptions), _List_fromArray([
                            $elm$html$Html$text('Contact Partner')
                        ])) : A3($author$project$Ui$Link$externalHref, A2($author$project$Utils$Url$addParams, url, _List_fromArray([
                            A2($elm$url$Url$Builder$string, 'utm_source', 'hint'),
                            A2($elm$url$Url$Builder$string, 'utm_medium', 'marketplace'),
                            A2($elm$url$Url$Builder$string, 'utm_campaign', 'hint_marketplace')
                        ])), _List_fromArray([
                            $author$project$Ui$Link$fullWidth,
                            $author$project$Ui$Link$buttonPrimary,
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('Contact Partner')
                        ]));
                    default:
                        return $elm$html$Html$text('');
                }
            } else return $elm$html$Html$text('');
        }());
    });
    var $elm$html$Html$h1 = _VirtualDom_node('h1');
    var $author$project$Ui$Typography$headingXl = function(content) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$h1, _List_fromArray([
            $elm$html$Html$Attributes$class('text-heading-xl text-main')
        ]), content));
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ActivateConfirmed = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Panel$Collapsed = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Panel$collapsed = $author$project$Ui$Panel$Collapsed;
    var $author$project$Ui$Icon$Circle = 46;
    var $author$project$Ui$Icon$circle = $author$project$Ui$Icon$viewIcon(46);
    var $author$project$Ui$Icon$Xl = 4;
    var $author$project$Ui$Icon$xl = $author$project$Ui$Icon$Size(4);
    var $author$project$Components$Marketplace$Product$CallToAction$modalStepIcon = function(complete) {
        return complete ? $author$project$Ui$Icon$check(_List_fromArray([
            $author$project$Ui$Icon$circled,
            $author$project$Ui$Icon$success
        ])) : $author$project$Ui$Icon$circle(_List_fromArray([
            $author$project$Ui$Icon$info,
            $author$project$Ui$Icon$xl
        ]));
    };
    var $author$project$Components$Marketplace$Product$CallToAction$OpenPdfDocument = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$ToggleDocumentAccepted = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Marketplace$Product$CallToAction$viewDocumentCheckbox = F2(function(acceptedIds, document1) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flex,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$gap2
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(A2($elm$core$Set$member, document1.aef, acceptedIds)),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Marketplace$Product$CallToAction$ToggleDocumentAccepted(document1.aef))
            ]), _List_fromArray([
                $elm$html$Html$text('I have read and agree to')
            ])),
            function() {
                var _v0 = _Utils_Tuple2(document1.Og, document1.aaT);
                _v0$2: while(true)switch(_v0.a){
                    case 'url':
                        if (!_v0.b.$) {
                            var url = _v0.b.a;
                            return A3($author$project$Ui$Link$externalHref, url, _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text(document1.$2)
                            ]));
                        } else break _v0$2;
                    case 'pdf':
                        return A3($author$project$Ui$Button$view, {
                            abP: 'Open ' + document1.$2
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$OpenPdfDocument(document1))
                        ]), _List_fromArray([
                            $elm$html$Html$text(document1.$2)
                        ]));
                    default:
                        break _v0$2;
                }
                return $elm$html$Html$text(document1.$2);
            }()
        ]));
    });
    var $author$project$Components$Marketplace$Product$CallToAction$viewDocumentAgreements = F5(function(expandedStep, practice, productName, acceptedIds, documents) {
        if ($elm$core$List$isEmpty(documents)) return $elm$html$Html$text('');
        else {
            var practiceName = A2($elm$core$Maybe$withDefault, '<practice name>', A2($elm$core$Maybe$map, function($) {
                return $.zr;
            }, practice));
            var allAccepted = A2($elm$core$List$all, function(doc) {
                return A2($elm$core$Set$member, doc.aef, acceptedIds);
            }, documents);
            return A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$collapsed(!_Utils_eq(expandedStep, $elm$core$Maybe$Just(1)))
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap4
                ]), _List_fromArray([
                    $author$project$Components$Marketplace$Product$CallToAction$modalStepIcon(allAccepted),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Agreements')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$flexCol,
                        $author$project$Ui$Element$gap4
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('By checking the boxes below, you:'),
                            A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('pl-6')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('i. confirm that you have read and agree to the documents listed below;')
                                ])),
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('ii. represent and warrant that you are an authorized representative of '),
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(practiceName)
                                    ])),
                                    $elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
                                ])),
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('iii. agree that this electronic acceptance constitutes a legally binding agreement between '),
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(productName)
                                    ])),
                                    $elm$html$Html$text(' and '),
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(practiceName)
                                    ])),
                                    $elm$html$Html$text(', effective as of the date of acceptance.')
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$bold
                            ]), _List_fromArray([
                                $elm$html$Html$text(practiceName)
                            ])),
                            $elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$flexCol,
                            $author$project$Ui$Element$gap2
                        ]), A2($elm$core$List$map, $author$project$Components$Marketplace$Product$CallToAction$viewDocumentCheckbox(acceptedIds), documents))
                    ]))
                ]))
            ]));
        }
    });
    var $author$project$Components$Marketplace$Product$CallToAction$TogglePreconditionAccepted = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Precondition$Type$labels = function(t) {
        if (!t) return {
            Ed: ' before connecting.',
            Er: 'This app requires ',
            EN: 'Package Installed',
            Gb: 'installing a package'
        };
        else return {
            Ed: ' before connecting.',
            Er: 'You\'ll need an ',
            EN: 'Account Created',
            Gb: 'account with this partner'
        };
    };
    var $author$project$Api$Common$Marketplace$Product$Precondition$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Common$Marketplace$Product$Precondition$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Components$Marketplace$Product$CallToAction$viewPrecondition = F2(function(acceptedIds, precondition) {
        var l = $author$project$Api$Common$Marketplace$Product$Precondition$Type$labels($author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition));
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flexCol,
            $author$project$Ui$Element$gap2
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text(l.Er),
                A3($author$project$Ui$Link$externalHref, $author$project$Api$Common$Marketplace$Product$Precondition$url(precondition), _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text(l.Gb)
                ])),
                $elm$html$Html$text(l.Ed)
            ])),
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(A2($elm$core$Set$member, $author$project$Api$Common$Marketplace$Product$Precondition$id(precondition), acceptedIds)),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$Marketplace$Product$CallToAction$TogglePreconditionAccepted($author$project$Api$Common$Marketplace$Product$Precondition$id(precondition)))
            ]), _List_fromArray([
                $elm$html$Html$text(l.EN)
            ]))
        ]));
    });
    var $author$project$Components$Marketplace$Product$CallToAction$viewPreconditions = F3(function(expandedStep, acceptedIds, preconditions_) {
        if ($elm$core$List$isEmpty(preconditions_)) return $elm$html$Html$text('');
        else {
            var allAccepted = A2($elm$core$List$all, function(p) {
                return A2($elm$core$Set$member, $author$project$Api$Common$Marketplace$Product$Precondition$id(p), acceptedIds);
            }, preconditions_);
            return A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$collapsed(!_Utils_eq(expandedStep, $elm$core$Maybe$Just(0)))
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap4
                ]), _List_fromArray([
                    $author$project$Components$Marketplace$Product$CallToAction$modalStepIcon(allAccepted),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Requirements')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$flexCol,
                        $author$project$Ui$Element$gap4
                    ]), A2($elm$core$List$map, $author$project$Components$Marketplace$Product$CallToAction$viewPrecondition(acceptedIds), preconditions_))
                ]))
            ]));
        }
    });
    var $author$project$Components$Marketplace$Product$CallToAction$viewActivateModal = function(model) {
        var _v0 = model.aV;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var product = _v1.a;
            var request = _v1.b;
            var verb = $author$project$Components$Marketplace$Product$CallToAction$activateVerb(product);
            var isLoading = _Utils_eq(request, $author$project$Api$Data$Loading);
            var errorMessage = function() {
                if (request.$ === 2) {
                    var error = request.a;
                    return $elm$core$Maybe$Just($author$project$Ui$Toast$serverError(error));
                } else return $elm$core$Maybe$Nothing;
            }();
            var documents = product.V0;
            var allPreconditionsAccepted = A2($elm$core$List$all, function(p) {
                return A2($elm$core$Set$member, $author$project$Api$Common$Marketplace$Product$Precondition$id(p), model.ds);
            }, product.Xf);
            var allDocumentsAccepted = A2($elm$core$List$all, function(doc) {
                return A2($elm$core$Set$member, doc.aef, model.dr);
            }, documents);
            var installDisabled = isLoading || !$elm$core$List$isEmpty(documents) && !allDocumentsAccepted || !allPreconditionsAccepted;
            return A3($author$project$Ui$Modal$view, $author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title(verb + (' ' + (product.zr + '?')))
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    function() {
                        if (!errorMessage.$) {
                            var message = errorMessage.a;
                            return A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(message)
                            ]));
                        } else return $elm$html$Html$text('');
                    }(),
                    A5($author$project$Components$Marketplace$Product$CallToAction$viewDocumentAgreements, model.cX, model.W1, product.zr, model.dr, documents),
                    A3($author$project$Components$Marketplace$Product$CallToAction$viewPreconditions, model.cX, model.ds, product.Xf)
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel'
                    }, _List_fromArray([
                        $author$project$Ui$Button$default,
                        $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$ActivateCanceled)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: verb
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$ActivateConfirmed(product)),
                        $author$project$Ui$Button$disabled(installDisabled),
                        $author$project$Ui$Button$loading(isLoading)
                    ]), _List_fromArray([
                        $elm$html$Html$text(verb)
                    ]))
                ]))
            ]));
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Marketplace$Product$CallToAction$DeactivateConfirmed = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Marketplace$Product$CallToAction$viewDeactivateModal = function(model) {
        var _v0 = model.dI;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var product = _v1.a;
            var request = _v1.b;
            var verb = $author$project$Components$Marketplace$Product$CallToAction$deactivateVerb(product);
            var errorMessage = function() {
                if (request.$ === 2) {
                    var error = request.a;
                    return $elm$core$Maybe$Just($author$project$Ui$Toast$serverError(error));
                } else return $elm$core$Maybe$Nothing;
            }();
            return A3($author$project$Ui$Modal$view, $author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title(verb + (' ' + (product.zr + '?')))
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    function() {
                        if (!errorMessage.$) {
                            var message = errorMessage.a;
                            return A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(message)
                            ]));
                        } else return $elm$html$Html$text('');
                    }(),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Are you sure you want to ' + ($elm$core$String$toLower(verb) + ' ')),
                        $elm$html$Html$text(product.zr),
                        $elm$html$Html$text('? This will remove the integration and all its settings.')
                    ]))
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel'
                    }, _List_fromArray([
                        $author$project$Ui$Button$default,
                        $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$DeactivateCanceled)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: verb
                    }, _List_fromArray([
                        $author$project$Ui$Button$danger,
                        $author$project$Ui$Button$onClick($author$project$Components$Marketplace$Product$CallToAction$DeactivateConfirmed(product)),
                        $author$project$Ui$Button$disabled(_Utils_eq(request, $author$project$Api$Data$Loading)),
                        $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        $elm$html$Html$text(verb)
                    ]))
                ]))
            ]));
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Marketplace$Product$CallToAction$modal = function(model) {
        return A2($elm$html$Html$map, model.ahX, A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Components$Marketplace$Product$CallToAction$viewActivateModal(model),
            $author$project$Components$Marketplace$Product$CallToAction$viewDeactivateModal(model)
        ])));
    };
    var $author$project$Pages$Marketplace$Slug_String$settingsUrl = function(product) {
        return A2($elm$core$Maybe$andThen, function(status) {
            switch(status){
                case 'inactive':
                    return $elm$core$Maybe$Nothing;
                case 'pending':
                    var _v1 = product._A;
                    switch(_v1){
                        case 'quickbooks':
                            return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings));
                        case 'elation':
                            return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
                        default:
                            return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding({
                                _A: product._A
                            })));
                    }
                default:
                    var _v2 = _Utils_Tuple2(product.ah5, product._A);
                    _v2$0: while(true)switch(_v2.b){
                        case 'bookkeeping':
                            if (!_v2.a) break _v2$0;
                            else return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings));
                        case 'quickbooks':
                            if (!_v2.a) break _v2$0;
                            else return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings));
                        case 'elation':
                            if (!_v2.a) break _v2$0;
                            else return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings));
                        default:
                            if (!_v2.a) break _v2$0;
                            else return $elm$core$Maybe$Nothing;
                    }
                    var _v3 = _v2.a;
                    return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users({
                        _A: product._A
                    })));
            }
        }, product.ahy);
    };
    var $author$project$Pages$Marketplace$Slug_String$viewManageButton = function(model) {
        var _v0 = A2($elm$core$Maybe$andThen, $author$project$Pages$Marketplace$Slug_String$settingsUrl, model.sk);
        if (!_v0.$) {
            var url = _v0.a;
            return A3($author$project$Ui$Link$externalHref, url, _List_fromArray([
                $author$project$Ui$Link$fullWidth,
                $author$project$Ui$Link$buttonPrimary
            ]), _List_fromArray([
                $elm$html$Html$text('Manage')
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Marketplace$Slug_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4,
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Top, _List_fromArray([
                        $author$project$Ui$Link$icon($author$project$Ui$Icon$arrowLeft)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Back to Marketplace')
                    ])),
                    function() {
                        var _v0 = _Utils_Tuple2(model.F3, model.V_);
                        if (_v0.a && !_v0.b.$) {
                            var partnerId = _v0.b.a;
                            return A3($author$project$Ui$HinterOnly$linkRoute, $author$project$Spa$Generated$Route$Partner__Product, _List_fromArray([
                                $author$project$Ui$Link$buttonDefault,
                                $author$project$Ui$Link$routeParams(_List_fromArray([
                                    A2($elm$url$Url$Builder$string, 'switch-to-partner', partnerId)
                                ])),
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                $author$project$Components$Marketplace$Product$CallToAction$modal(model.aZ),
                model.rD ? A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textCenter,
                    $author$project$Ui$Element$mt2,
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$Typography$headingXl(_List_fromArray([
                        $elm$html$Html$text('Product not found.')
                    ])))
                ])) : A3($elm$html$Html$node, 'hint-marketplace-product', _List_fromArray([
                    A2($elm$html$Html$Attributes$attribute, 'slug', model._A)
                ]), _List_fromArray([
                    $author$project$Pages$Marketplace$Slug_String$viewManageButton(model),
                    A2($author$project$Components$Marketplace$Product$CallToAction$button, _List_Nil, model.aZ)
                ]))
            ]),
            $2: 'Marketplace | ' + model._A
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Marketplace$Slug_String$init,
        aeR: $author$project$Pages$Marketplace$Slug_String$load,
        ag3: $author$project$Pages$Marketplace$Slug_String$save,
        ahE: $author$project$Pages$Marketplace$Slug_String$subscriptions,
        aaO: $author$project$Pages$Marketplace$Slug_String$update,
        aid: $author$project$Pages$Marketplace$Slug_String$view
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$GotIntegration = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple2({
            kT: $author$project$Api$Data$NotAsked,
            Ej: shared.Ej,
            Rn: $author$project$Api$Data$Loading,
            W1: practice,
            Z$: session,
            _A: params._A
        }, A3($author$project$Api$Provider$Integration$retrieve, shared.Ej, params._A, $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$GotIntegration));
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$PartnerActivated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$OutMsg$RefreshLayout = {
        $: 20
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Rn: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var integration = msg.a;
                var cmd = function() {
                    var _v1 = _Utils_Tuple3($author$project$Api$Provider$Integration$One$authType(integration), $author$project$Api$Provider$Integration$One$connectionUrl(integration), $author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
                    _v1$0: while(true){
                        _v1$3: while(true){
                            _v1$4: while(true)switch(_v1.a){
                                case 'automatic_redirect':
                                    if (!_v1.c.$) {
                                        if (!_v1.b.$) break _v1$0;
                                        else break _v1$3;
                                    } else {
                                        if (!_v1.b.$) break _v1$0;
                                        else break _v1$4;
                                    }
                                case 'automatic_headless':
                                    return A3($author$project$Api$Provider$Integration$connect, model.Ej, $author$project$Api$Provider$Integration$One$id(integration), $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$PartnerActivated);
                                case 'manual':
                                    return $elm$core$Platform$Cmd$none;
                                default:
                                    if (!_v1.c.$) break _v1$3;
                                    else break _v1$4;
                            }
                            var _v2 = _v1.c;
                            return $elm$core$Platform$Cmd$none;
                        }
                        var postActivationRedirectUrl = _v1.c.a;
                        return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
                    }
                    var connectionUrl = _v1.b.a;
                    return $author$project$Ports$Navigation$openInNewWindow(connectionUrl);
                }();
                var activationRequest = $author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless' ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked;
                return _Utils_Tuple3(_Utils_update(model, {
                    kT: activationRequest
                }), cmd, $author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless' ? _List_Nil : _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Integration$One$name(integration) + ' activated')
                ]));
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var integration = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        kT: response,
                        Rn: response
                    }), function() {
                        var _v4 = _Utils_Tuple2($author$project$Api$Provider$Integration$One$authType(integration), $author$project$Api$Provider$Integration$One$postActivationRedirectUrl(integration));
                        if (_v4.a === 'automatic_headless' && !_v4.b.$) {
                            var postActivationRedirectUrl = _v4.b.a;
                            return $author$project$Ports$Navigation$pushUrl(postActivationRedirectUrl);
                        } else return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users({
                            _A: model._A
                        }));
                    }(), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Integration$One$name(integration) + ' activated'),
                        $author$project$OutMsg$RefreshLayout
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    kT: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$Activate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate = function(integration) {
        return $author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_redirect' || $author$project$Api$Provider$Integration$One$authType(integration) === 'automatic_headless';
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.Rn;
                    if (_v0.$ === 3) {
                        var integration = _v0.a;
                        var status = $author$project$Api$Provider$Integration$One$status(integration);
                        var name = $author$project$Api$Provider$Integration$One$name(integration);
                        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                                status === 'pending' && $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate(integration) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$labelSpan(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$label('')
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                                A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text('If you haven\'t been contacted by '),
                                                    $elm$html$Html$text(name),
                                                    $elm$html$Html$text(' about next steps for this integration, then something probably went wrong.')
                                                ]))
                                            ])),
                                            A3($author$project$Ui$Button$view, {
                                                abP: 'Try again'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$Activate(integration)),
                                                $author$project$Ui$Button$primary,
                                                $author$project$Ui$Button$loading(_Utils_eq(model.kT, $author$project$Api$Data$Loading))
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Try again')
                                            ]))
                                        ]))
                                    ]))
                                ])) : $author$project$Utils$Html$empty,
                                function() {
                                    if (status === 'pending' && $author$project$Api$Provider$Integration$One$active(integration) && !$author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$canAutomaticallyIntegrate(integration)) {
                                        var email = $author$project$Api$Provider$Integration$One$email(integration);
                                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Authorization Code'),
                                            $author$project$Ui$Form$Group$labelSpanSm(4),
                                            $author$project$Ui$Form$Group$inputSpanSm(8)
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                A2($author$project$Ui$Typography$pre, _List_fromArray([
                                                    $author$project$Ui$Typography$authorizationCode
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Provider$Integration$One$authorizationCode(integration)))
                                                ])),
                                                A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                                                    A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                                                        $elm$html$Html$text(name),
                                                        $elm$html$Html$text(' does not support automatic integrations yet. Please email them at'),
                                                        A3($author$project$Ui$Link$mailto, A2($elm$core$Maybe$withDefault, '', email), _List_Nil, _List_fromArray([
                                                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', email))
                                                        ])),
                                                        $elm$html$Html$text(' and they can provide you with next steps.')
                                                    ]))
                                                ]))
                                            ]))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ]))
                        ]));
                    } else return $elm$html$Html$text('');
                }()
            ]),
            $2: 'Onboarding'
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$init,
        aeR: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$load,
        ag3: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$save,
        ahE: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$subscriptions,
        aaO: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$update,
        aid: $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$view
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$GotIntegration = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            Rn: $author$project$Api$Data$Loading,
            W1: practice,
            Z$: session,
            cr: $elm$core$Maybe$Nothing,
            _A: params._A
        }, A3($author$project$Api$Provider$Integration$retrieve, shared.Ej, params._A, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$GotIntegration));
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            if (response.$ === 3) {
                var integration = response.a;
                var _v2 = $author$project$Api$Provider$Integration$One$partnerApp(integration);
                if (!_v2.$) {
                    var partnerApp = _v2.a;
                    var settingsAnchor = $author$project$Api$Common$PartnerApp$Shared$settingsAnchor(partnerApp);
                    if (!settingsAnchor.$) {
                        var _v4 = $author$project$Components$Admin$PartnerApp$Settings$init(partnerApp);
                        var settings = _v4.a;
                        var settingsCmd = _v4.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Rn: response,
                            cr: $elm$core$Maybe$Just(settings)
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg, settingsCmd), _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        Rn: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Rn: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            } else return _Utils_Tuple3(_Utils_update(model, {
                Rn: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var settingsMsg = msg.a;
            var _v5 = model.cr;
            if (!_v5.$) {
                var settings = _v5.a;
                var _v6 = A2($author$project$Components$Admin$PartnerApp$Settings$update, settingsMsg, settings);
                var newSettings = _v6.a;
                var settingsCmd = _v6.b;
                var outMsgs = _v6.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    cr: $elm$core$Maybe$Just(newSettings)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg, settingsCmd), outMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.cr;
                    if (!_v0.$) {
                        var settings = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$SettingsMsg, $author$project$Components$Admin$PartnerApp$Settings$view(settings));
                    } else return $elm$html$Html$text('');
                }()
            ]),
            $2: 'Settings'
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Settings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$init,
        aeR: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$load,
        ag3: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$save,
        ahE: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$subscriptions,
        aaO: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$update,
        aid: $author$project$Pages$Marketplace$Slug_String$Manage$Settings$view
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$GotIntegration = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            Rn: $author$project$Api$Data$Loading,
            jn: $elm$core$Maybe$Nothing,
            W1: practice,
            Z$: session,
            _A: params._A
        }, A3($author$project$Api$Provider$Integration$retrieve, shared.Ej, params._A, $author$project$Pages$Marketplace$Slug_String$Manage$Users$GotIntegration));
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$subscriptions = function(model) {
        var _v0 = model.jn;
        if (!_v0.$) {
            var partnerAppTeam = _v0.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg, $author$project$Components$Admin$PartnerApp$Team$subscriptions(partnerAppTeam));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            if (response.$ === 3) {
                var integration = response.a;
                var _v2 = $author$project$Api$Provider$Integration$One$partnerApp(integration);
                if (!_v2.$) {
                    var partnerApp = _v2.a;
                    var _v3 = A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Components$Admin$PartnerApp$Team$init, model.Ej, integration, partnerApp, $author$project$Api$Platform$Session$One$user(model.Z$))));
                    var partnerAppTeam = _v3.a;
                    var partnerAppTeamCmd = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Rn: response,
                        jn: partnerAppTeam
                    }), partnerAppTeamCmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Rn: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            } else return _Utils_Tuple3(_Utils_update(model, {
                Rn: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var subMsg = msg.a;
            var _v4 = model.jn;
            if (!_v4.$) {
                var partnerAppTeam = _v4.a;
                var result = A3($author$project$Components$Admin$PartnerApp$Team$update, model.Ej, subMsg, partnerAppTeam);
                return _Utils_Tuple3(_Utils_update(model, {
                    jn: $elm$core$Maybe$Just(result.zi)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg, result.EQ), result.at);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$viewBody = function(model) {
        var _v0 = model.jn;
        if (!_v0.$) {
            var partnerAppTeam = _v0.a;
            return _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg), $author$project$Components$Admin$PartnerApp$Team$modal(partnerAppTeam)), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Marketplace$Slug_String$Manage$Users$PartnerAppTeamMsg, $author$project$Components$Admin$PartnerApp$Team$view(partnerAppTeam))
            ]));
        } else {
            var _v1 = model.Rn;
            if (_v1.$ === 1) return _List_fromArray([
                $author$project$Ui$Spinner$view(_List_Nil)
            ]);
            else return _List_Nil;
        }
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$view = function(model) {
        return {
            fb: $author$project$Pages$Marketplace$Slug_String$Manage$Users$viewBody(model),
            $2: 'Manage Users'
        };
    };
    var $author$project$Pages$Marketplace$Slug_String$Manage$Users$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Marketplace$Slug_String$Manage$Users$init,
        aeR: $author$project$Pages$Marketplace$Slug_String$Manage$Users$load,
        ag3: $author$project$Pages$Marketplace$Slug_String$Manage$Users$save,
        ahE: $author$project$Pages$Marketplace$Slug_String$Manage$Users$subscriptions,
        aaO: $author$project$Pages$Marketplace$Slug_String$Manage$Users$update,
        aid: $author$project$Pages$Marketplace$Slug_String$Manage$Users$view
    });
    var $author$project$Pages$Marketplace$Top$CategoryDropdownMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Top$GotCategories = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Feature$MarketplaceViewTiles = 25;
    var $author$project$Pages$Marketplace$Top$determineCanViewTiles = function(shared) {
        return $author$project$Shared$isHintAdmin(shared) || A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Practice$featureEnabled(25), $author$project$Api$Data$toMaybe(shared.W1)));
    };
    var $author$project$Api$Platform$Marketplace$ProductCategory$productCategoriesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'marketplace',
        'product_categories'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$Marketplace$ProductCategory$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Category$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$Marketplace$ProductCategory$productCategoriesPath));
    });
    var $author$project$Pages$Marketplace$Top$productTypeFromQuery = function(queryString) {
        _v0$3: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'app':
                    return $elm$core$Maybe$Just(0);
                case 'integration':
                    return $elm$core$Maybe$Just(1);
                case 'solution':
                    return $elm$core$Maybe$Just(2);
                default:
                    break _v0$3;
            }
            else break _v0$3;
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Pages$Marketplace$Top$init = F3(function(session, shared, _v0) {
        var query = _v0.Bz;
        var selectedCategories = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$String$split(','), A2($elm$core$Dict$get, 'category', query)));
        var q = A2($elm$core$Dict$get, 'q', query);
        var productTypeQuery = A2($elm$core$Dict$get, 'type', query);
        var productType = $author$project$Pages$Marketplace$Top$productTypeFromQuery(productTypeQuery);
        return _Utils_Tuple2({
            Ej: shared.Ej,
            lo: $author$project$Pages$Marketplace$Top$determineCanViewTiles(shared),
            K0: $author$project$Api$Data$Loading,
            ls: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'category-dropdown',
                ahX: $author$project$Pages$Marketplace$Top$CategoryDropdownMsg
            })),
            FM: false,
            F3: $author$project$Shared$isHintAdmin(shared),
            G7: productType,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            cp: selectedCategories,
            Z$: session
        }, A2($author$project$Api$Platform$Marketplace$ProductCategory$list, shared.Ej, $author$project$Pages$Marketplace$Top$GotCategories));
    });
    var $author$project$Pages$Marketplace$Top$load = F2(function(shared, model) {
        return model.lo ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : _Utils_Tuple2(_Utils_update(model, {
            lo: $author$project$Pages$Marketplace$Top$determineCanViewTiles(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Marketplace$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Marketplace$Top$subscriptions = function(model) {
        return $author$project$Ui$Dropdown$subscriptions(model.ls);
    };
    var $author$project$Pages$Marketplace$Top$SearchInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Top$productTypeToValue = function(productType) {
        switch(productType){
            case 0:
                return 'app';
            case 1:
                return 'integration';
            default:
                return 'solution';
        }
    };
    var $author$project$Pages$Marketplace$Top$updateUrl = function(model) {
        var categoryParam = $elm$core$List$isEmpty(model.cp) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'category', A2($elm$core$String$join, ',', model.cp)));
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Pages$Marketplace$Top$productTypeToValue, $elm$url$Url$Builder$string('type')), model.G7),
            categoryParam
        ]);
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Marketplace__Top)
        ]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    };
    var $author$project$Pages$Marketplace$Top$andUpdateUrl = function(_v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        var outMsgs = _v0.c;
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            $author$project$Pages$Marketplace$Top$updateUrl(model)
        ])), outMsgs);
    };
    var $author$project$Pages$Marketplace$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v1.a;
                var searchInputCmd = _v1.b;
                var searchInputEvent = _v1.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                return $author$project$Pages$Marketplace$Top$andUpdateUrl(_Utils_Tuple3(_Utils_update(model, {
                    agq: q,
                    sG: searchInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Marketplace$Top$SearchInputMsg, searchInputCmd), _List_Nil));
            case 1:
                var productType = msg.a;
                return $author$project$Pages$Marketplace$Top$andUpdateUrl(_Utils_Tuple3(_Utils_update(model, {
                    G7: productType
                }), $elm$core$Platform$Cmd$none, _List_Nil));
            case 2:
                var dropdownMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.ls);
                var categoryDropdown = _v3.a;
                var dropdownCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ls: categoryDropdown
                }), dropdownCmd, _List_Nil);
            case 3:
                var category = msg.a;
                var checked = msg.b;
                var selectedCategories = checked ? A2($elm$core$List$cons, category, model.cp) : A2($elm$core$List$filter, $elm$core$Basics$neq(category), model.cp);
                return $author$project$Pages$Marketplace$Top$andUpdateUrl(_Utils_Tuple3(_Utils_update(model, {
                    cp: selectedCategories
                }), $elm$core$Platform$Cmd$none, _List_Nil));
            case 4:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    K0: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var hinterMode = msg.a;
                var newModel = _Utils_update(model, {
                    FM: hinterMode
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Marketplace$Top$HinterModeToggled = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Marketplace$Top$categoriesToLabel = function(selectedCategories) {
        if (!selectedCategories.b) return 'Categories';
        else if (!selectedCategories.b.b) {
            var single = selectedCategories.a;
            return single;
        } else {
            var multiple = selectedCategories;
            return 'Categories (' + ($elm$core$String$fromInt($elm$core$List$length(multiple)) + ')');
        }
    };
    var $author$project$Pages$Marketplace$Top$CategoryToggled = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Marketplace$Top$categoryItems = F2(function(selectedCategories, categories) {
        return A2($elm$core$List$map, function(cat) {
            var categoryName = $author$project$Api$Common$Marketplace$Product$Category$name(cat);
            var isChecked = A2($elm$core$List$member, categoryName, selectedCategories);
            return A2($author$project$Ui$Dropdown$checkbox, _List_fromArray([
                $author$project$Ui$Dropdown$onCheck($author$project$Pages$Marketplace$Top$CategoryToggled(categoryName)),
                $author$project$Ui$Dropdown$checked(isChecked)
            ]), $elm$html$Html$text(categoryName));
        }, categories);
    });
    var $author$project$Pages$Marketplace$Top$viewBody = function(model) {
        var isPartner = $author$project$Api$Platform$Session$One$organizationIsPartner(model.Z$);
        var categoryAttribute = $elm$core$List$isEmpty(model.cp) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$html$Html$Attributes$attribute, 'category', A2($elm$core$String$join, ',', model.cp)));
        var attributes = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $elm$html$Html$Attributes$attribute('q'), model.agq),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Pages$Marketplace$Top$productTypeToValue, $elm$html$Html$Attributes$attribute('type')), model.G7),
            categoryAttribute,
            $elm$core$Maybe$Just(A2($elm$html$Html$Attributes$attribute, 'is-partner', $author$project$Utils$Bool$toString(isPartner))),
            $elm$core$Maybe$Just($elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('hidden', !model.lo)
            ]))),
            $elm$core$Maybe$Just(A2($elm$html$Html$Attributes$attribute, 'hinter-mode', $author$project$Utils$Bool$toString(model.FM)))
        ]));
        return A3($elm$html$Html$node, 'hint-marketplace', attributes, _List_Nil);
    };
    var $author$project$Pages$Marketplace$Top$ProductTypeSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Element$Hidden = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Element$hidden = $author$project$Ui$Element$Hidden(0);
    var $author$project$Ui$Element$inlineBlockMd = A2($author$project$Ui$Element$Display, 2, 1);
    var $author$project$Pages$Marketplace$Top$viewProductTypeButtons = function(currentProductType) {
        return $author$project$Ui$Button$group(_List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'All Partners'
            }, _List_fromArray([
                $author$project$Ui$Button$active(_Utils_eq(currentProductType, $elm$core$Maybe$Nothing)),
                $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Top$ProductTypeSelected($elm$core$Maybe$Nothing))
            ]), _List_fromArray([
                $elm$html$Html$text('All'),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$hidden,
                    $author$project$Ui$Element$inlineBlockMd,
                    $author$project$Ui$Element$ml1
                ]), _List_fromArray([
                    $elm$html$Html$text('Partners')
                ]))
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Apps'
            }, _List_fromArray([
                $author$project$Ui$Button$active(_Utils_eq(currentProductType, $elm$core$Maybe$Just(0))),
                $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Top$ProductTypeSelected($elm$core$Maybe$Just(0)))
            ]), _List_fromArray([
                $elm$html$Html$text('Apps')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Integrations'
            }, _List_fromArray([
                $author$project$Ui$Button$active(_Utils_eq(currentProductType, $elm$core$Maybe$Just(1))),
                $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Top$ProductTypeSelected($elm$core$Maybe$Just(1)))
            ]), _List_fromArray([
                $elm$html$Html$text('Integrations')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Solutions'
            }, _List_fromArray([
                $author$project$Ui$Button$active(_Utils_eq(currentProductType, $elm$core$Maybe$Just(2))),
                $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Top$ProductTypeSelected($elm$core$Maybe$Just(2)))
            ]), _List_fromArray([
                $elm$html$Html$text('Solutions')
            ]))
        ]));
    };
    var $author$project$Pages$Marketplace$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A3($author$project$Ui$Element$custom, 'layout-header', _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$heading(_List_fromArray([
                            $elm$html$Html$text('Marketplace')
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$flex,
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            model.F3 ? A3($author$project$Ui$HinterOnly$button, {
                                abP: 'Admin Mode'
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Pages$Marketplace$Top$HinterModeToggled(!model.FM)),
                                $author$project$Ui$Button$active(model.FM),
                                $author$project$Ui$Button$secondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Admin Mode')
                            ])) : $author$project$Utils$Html$empty,
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Manage, _List_fromArray([
                                $author$project$Ui$Link$buttonDefault
                            ]), _List_fromArray([
                                $elm$html$Html$text('Manage partners')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted,
                        $author$project$Ui$Element$mt2,
                        $author$project$Ui$Element$mb4
                    ]), _List_fromArray([
                        $elm$html$Html$text('Discover apps, integrations and solutions to extend your Hint experience')
                    ])),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_fromArray([
                            $author$project$Ui$Grid$mb4
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(4),
                                $author$project$Ui$Grid$spanLg(6)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Marketplace$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                                    $author$project$Ui$SearchInput$placeholder('Search Partners...'),
                                    $author$project$Ui$SearchInput$immediate
                                ]), model.sG))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(8),
                                $author$project$Ui$Grid$spanLg(6)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$gap2,
                                    $author$project$Ui$Element$flex
                                ]), _List_fromArray([
                                    $author$project$Pages$Marketplace$Top$viewProductTypeButtons(model.G7),
                                    function() {
                                        var _v0 = model.K0;
                                        if (_v0.$ === 3) {
                                            var categories = _v0.a;
                                            return A2($author$project$Ui$Element$view, _List_fromArray([
                                                $author$project$Ui$Element$flexAuto
                                            ]), _List_fromArray([
                                                A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text($author$project$Pages$Marketplace$Top$categoriesToLabel(model.cp))
                                                ]), A2($author$project$Pages$Marketplace$Top$categoryItems, model.cp, categories), model.ls)
                                            ]));
                                        } else return $author$project$Utils$Html$empty;
                                    }()
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                $author$project$Pages$Marketplace$Top$viewBody(model),
                !model.lo ? A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textCenter,
                    $author$project$Ui$Element$mt2,
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$Typography$headingXl(_List_fromArray([
                        $elm$html$Html$text('Launching at '),
                        A3($author$project$Ui$Link$externalHref, 'https://summit.hint.com', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('Hint Summit.')
                        ]))
                    ])))
                ])) : $author$project$Utils$Html$empty
            ]),
            $2: 'Marketplace'
        };
    };
    var $author$project$Pages$Marketplace$Top$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Marketplace$Top$init,
        aeR: $author$project$Pages$Marketplace$Top$load,
        ag3: $author$project$Pages$Marketplace$Top$save,
        ahE: $author$project$Pages$Marketplace$Top$subscriptions,
        aaO: $author$project$Pages$Marketplace$Top$update,
        aid: $author$project$Pages$Marketplace$Top$view
    });
    var $author$project$Pages$Messages$Calls$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Calls$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Calls$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Calls$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Phone Calls'
        };
    };
    var $author$project$Pages$Messages$Calls$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Calls$init,
        aeR: $author$project$Pages$Messages$Calls$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Calls$update,
        aid: $author$project$Pages$Messages$Calls$view
    });
    var $author$project$Pages$Messages$Chat$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Chat$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Chat$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Chat$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Messages'
        };
    };
    var $author$project$Pages$Messages$Chat$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Chat$init,
        aeR: $author$project$Pages$Messages$Chat$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Chat$update,
        aid: $author$project$Pages$Messages$Chat$view
    });
    var $author$project$Pages$Messages$Drafts$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Drafts$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Drafts$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Drafts$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'My Drafts'
        };
    };
    var $author$project$Pages$Messages$Drafts$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Drafts$init,
        aeR: $author$project$Pages$Messages$Drafts$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Drafts$update,
        aid: $author$project$Pages$Messages$Drafts$view
    });
    var $author$project$Pages$Messages$Faxes$New$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Faxes$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Faxes$New$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Faxes$New$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'New Fax'
        };
    };
    var $author$project$Pages$Messages$Faxes$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Faxes$New$init,
        aeR: $author$project$Pages$Messages$Faxes$New$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Faxes$New$update,
        aid: $author$project$Pages$Messages$Faxes$New$view
    });
    var $author$project$Pages$Messages$Faxes$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Faxes$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Faxes$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Faxes$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Faxes'
        };
    };
    var $author$project$Pages$Messages$Faxes$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Faxes$Top$init,
        aeR: $author$project$Pages$Messages$Faxes$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Faxes$Top$update,
        aid: $author$project$Pages$Messages$Faxes$Top$view
    });
    var $author$project$Pages$Messages$Forms$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Forms$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Forms$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Forms$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Forms'
        };
    };
    var $author$project$Pages$Messages$Forms$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Forms$init,
        aeR: $author$project$Pages$Messages$Forms$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Forms$update,
        aid: $author$project$Pages$Messages$Forms$view
    });
    var $author$project$Pages$Messages$Labs$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Labs$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Labs$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Labs$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Lab Results'
        };
    };
    var $author$project$Pages$Messages$Labs$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Labs$init,
        aeR: $author$project$Pages$Messages$Labs$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Labs$update,
        aid: $author$project$Pages$Messages$Labs$view
    });
    var $author$project$Pages$Messages$Scheduled$New$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Scheduled$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Scheduled$New$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Scheduled$New$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'New Scheduled Event'
        };
    };
    var $author$project$Pages$Messages$Scheduled$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Scheduled$New$init,
        aeR: $author$project$Pages$Messages$Scheduled$New$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Scheduled$New$update,
        aid: $author$project$Pages$Messages$Scheduled$New$view
    });
    var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Edut Scheduled Event'
        };
    };
    var $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$init,
        aeR: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$update,
        aid: $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$view
    });
    var $author$project$Pages$Messages$Scheduled$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Scheduled$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Scheduled$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Scheduled$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Scheduled'
        };
    };
    var $author$project$Pages$Messages$Scheduled$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Scheduled$Top$init,
        aeR: $author$project$Pages$Messages$Scheduled$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Scheduled$Top$update,
        aid: $author$project$Pages$Messages$Scheduled$Top$view
    });
    var $author$project$Pages$Messages$Sms$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Sms$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Messages$Sms$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Messages$Sms$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Inbox'
        };
    };
    var $author$project$Pages$Messages$Sms$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Messages$Sms$init,
        aeR: $author$project$Pages$Messages$Sms$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Messages$Sms$update,
        aid: $author$project$Pages$Messages$Sms$view
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Edit Appointment Type'
        };
    };
    var $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$init,
        aeR: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$update,
        aid: $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$view
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$New$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$New$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$New$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'New Appointment Type'
        };
    };
    var $author$project$Pages$NewSettings$AppointmentTypes$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$AppointmentTypes$New$init,
        aeR: $author$project$Pages$NewSettings$AppointmentTypes$New$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$AppointmentTypes$New$update,
        aid: $author$project$Pages$NewSettings$AppointmentTypes$New$view
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$AppointmentTypes$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Appointment Types'
        };
    };
    var $author$project$Pages$NewSettings$AppointmentTypes$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$AppointmentTypes$Top$init,
        aeR: $author$project$Pages$NewSettings$AppointmentTypes$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$AppointmentTypes$Top$update,
        aid: $author$project$Pages$NewSettings$AppointmentTypes$Top$view
    });
    var $author$project$Pages$NewSettings$BlockedPhoneNumbers$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$BlockedPhoneNumbers$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$BlockedPhoneNumbers$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$BlockedPhoneNumbers$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Blocked Phone Numbers'
        };
    };
    var $author$project$Pages$NewSettings$BlockedPhoneNumbers$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$BlockedPhoneNumbers$init,
        aeR: $author$project$Pages$NewSettings$BlockedPhoneNumbers$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$BlockedPhoneNumbers$update,
        aid: $author$project$Pages$NewSettings$BlockedPhoneNumbers$view
    });
    var $author$project$Pages$NewSettings$BookingOverview$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$BookingOverview$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$BookingOverview$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$BookingOverview$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Booking Overview'
        };
    };
    var $author$project$Pages$NewSettings$BookingOverview$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$BookingOverview$init,
        aeR: $author$project$Pages$NewSettings$BookingOverview$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$BookingOverview$update,
        aid: $author$project$Pages$NewSettings$BookingOverview$view
    });
    var $author$project$Pages$NewSettings$Erx$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Erx$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Erx$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Erx$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'eRx'
        };
    };
    var $author$project$Pages$NewSettings$Erx$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Erx$init,
        aeR: $author$project$Pages$NewSettings$Erx$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Erx$update,
        aid: $author$project$Pages$NewSettings$Erx$view
    });
    var $author$project$Pages$NewSettings$Export$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Export$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Export$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Export$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Export'
        };
    };
    var $author$project$Pages$NewSettings$Export$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Export$init,
        aeR: $author$project$Pages$NewSettings$Export$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Export$update,
        aid: $author$project$Pages$NewSettings$Export$view
    });
    var $author$project$Pages$NewSettings$HinterSettings$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$HinterSettings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$HinterSettings$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$HinterSettings$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Hinter Settings'
        };
    };
    var $author$project$Pages$NewSettings$HinterSettings$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$HinterSettings$init,
        aeR: $author$project$Pages$NewSettings$HinterSettings$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$HinterSettings$update,
        aid: $author$project$Pages$NewSettings$HinterSettings$view
    });
    var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Edit Location'
        };
    };
    var $author$project$Pages$NewSettings$Locations$BookingLocationId_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$init,
        aeR: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$update,
        aid: $author$project$Pages$NewSettings$Locations$BookingLocationId_String$view
    });
    var $author$project$Pages$NewSettings$Locations$New$LocationId_String$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Locations$New$LocationId_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Locations$New$LocationId_String$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Locations$New$LocationId_String$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'New Location'
        };
    };
    var $author$project$Pages$NewSettings$Locations$New$LocationId_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Locations$New$LocationId_String$init,
        aeR: $author$project$Pages$NewSettings$Locations$New$LocationId_String$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Locations$New$LocationId_String$update,
        aid: $author$project$Pages$NewSettings$Locations$New$LocationId_String$view
    });
    var $author$project$Pages$NewSettings$Locations$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Locations$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Locations$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Locations$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Calendar Locations'
        };
    };
    var $author$project$Pages$NewSettings$Locations$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Locations$Top$init,
        aeR: $author$project$Pages$NewSettings$Locations$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Locations$Top$update,
        aid: $author$project$Pages$NewSettings$Locations$Top$view
    });
    var $author$project$Pages$NewSettings$PracticeInfo$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$PracticeInfo$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$PracticeInfo$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$PracticeInfo$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Practice Info'
        };
    };
    var $author$project$Pages$NewSettings$PracticeInfo$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$PracticeInfo$init,
        aeR: $author$project$Pages$NewSettings$PracticeInfo$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$PracticeInfo$update,
        aid: $author$project$Pages$NewSettings$PracticeInfo$view
    });
    var $author$project$Pages$NewSettings$Team$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Team$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Team$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Team$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Team'
        };
    };
    var $author$project$Pages$NewSettings$Team$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Team$init,
        aeR: $author$project$Pages$NewSettings$Team$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Team$update,
        aid: $author$project$Pages$NewSettings$Team$view
    });
    var $author$project$Pages$NewSettings$Team$TeamId_String$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Team$TeamId_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Team$TeamId_String$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Team$TeamId_String$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Team Member'
        };
    };
    var $author$project$Pages$NewSettings$Team$TeamId_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Team$TeamId_String$init,
        aeR: $author$project$Pages$NewSettings$Team$TeamId_String$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Team$TeamId_String$update,
        aid: $author$project$Pages$NewSettings$Team$TeamId_String$view
    });
    var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Team Member - Basic Info'
        };
    };
    var $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$init,
        aeR: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$update,
        aid: $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$view
    });
    var $author$project$Pages$NewSettings$Templates$New$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Templates$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Templates$New$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Templates$New$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'New Template'
        };
    };
    var $author$project$Pages$NewSettings$Templates$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Templates$New$init,
        aeR: $author$project$Pages$NewSettings$Templates$New$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Templates$New$update,
        aid: $author$project$Pages$NewSettings$Templates$New$view
    });
    var $author$project$Pages$NewSettings$Templates$TemplateId_String$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Templates$TemplateId_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Templates$TemplateId_String$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Templates$TemplateId_String$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Edit Template'
        };
    };
    var $author$project$Pages$NewSettings$Templates$TemplateId_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Templates$TemplateId_String$init,
        aeR: $author$project$Pages$NewSettings$Templates$TemplateId_String$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Templates$TemplateId_String$update,
        aid: $author$project$Pages$NewSettings$Templates$TemplateId_String$view
    });
    var $author$project$Pages$NewSettings$Templates$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Templates$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$NewSettings$Templates$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NewSettings$Templates$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Templates'
        };
    };
    var $author$project$Pages$NewSettings$Templates$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$NewSettings$Templates$Top$init,
        aeR: $author$project$Pages$NewSettings$Templates$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$NewSettings$Templates$Top$update,
        aid: $author$project$Pages$NewSettings$Templates$Top$view
    });
    var $author$project$Pages$NotFound$init = F2(function(shared, _v0) {
        var route = function() {
            var _v1 = shared.Z$;
            if (_v1.$ === 3) {
                var session = _v1.a;
                return A2($author$project$Permission$homeStateFor, session, shared.aeb);
            } else return $author$project$Spa$Generated$Route$Login;
        }();
        return _Utils_Tuple3({
            d: route,
            abq: shared.abq
        }, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NotFound$load = F2(function(shared, model) {
        var _v0 = _Utils_Tuple2(shared.Z$, shared.abq);
        if (_v0.a.$ === 3 && _v0.b.$ === 3) {
            var _v1 = _v0.a;
            var session = _v1.a;
            var _v2 = _v0.b;
            return _Utils_Tuple3(_Utils_update(model, {
                d: A2($author$project$Permission$homeStateFor, session, shared.aeb),
                abq: shared.abq
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$NotFound$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$NotFound$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$NotFound$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Api$WhitelabelSetting$branded = function(_v0) {
        var record = _v0;
        return record.Ez;
    };
    var $author$project$Ui$Icon$Hint404 = 31;
    var $author$project$Ui$Icon$hint404 = $author$project$Ui$Icon$viewIcon(31);
    var $author$project$Ui$Icon$SpacedBottom = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Icon$mb4 = $author$project$Ui$Icon$SpacedBottom(4);
    var $author$project$Api$WhitelabelSetting$practiceFacingLogoUrl = function(_v0) {
        var record = _v0;
        return record.G0;
    };
    var $author$project$Pages$NotFound$viewBody = F2(function(route, dataWhitelabelSetting) {
        var loading = function() {
            if (dataWhitelabelSetting.$ === 3) return false;
            else return true;
        }();
        var _v0 = function() {
            if (dataWhitelabelSetting.$ === 3) {
                var whitelabelSetting = dataWhitelabelSetting.a;
                return _Utils_Tuple2($author$project$Api$WhitelabelSetting$branded(whitelabelSetting), $author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
            } else return _Utils_Tuple2(false, $elm$core$Maybe$Nothing);
        }();
        var showCustomLogo = _v0.a;
        var imgUrl = _v0.b;
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$justifyCenter,
                $author$project$Ui$Element$flexCol,
                $author$project$Ui$Element$mt8
            ]), _List_fromArray([
                loading ? $author$project$Ui$Skeleton$card(_List_fromArray([
                    $author$project$Ui$Skeleton$span(2)
                ])) : showCustomLogo ? A3($author$project$Ui$Image$fromSrc, {
                    Jg: 'App Logo'
                }, A2($elm$core$Maybe$withDefault, '', imgUrl), _List_Nil) : $author$project$Ui$Icon$hint404(_List_fromArray([
                    $author$project$Ui$Icon$mb4
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    A2($elm$html$Html$h3, _List_Nil, _List_fromArray([
                        $elm$html$Html$text("We couldn\u2019t find this page...")
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textMuted,
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    $elm$html$Html$text("Sorry, the page you\u2019re looking for doesn\u2019t exist or has been moved")
                ])),
                A3($author$project$Ui$Link$route, route, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Take me Home')
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$NotFound$view = function(_v0) {
        var route = _v0.d;
        var whitelabelSetting = _v0.abq;
        return {
            fb: A2($author$project$Pages$NotFound$viewBody, route, whitelabelSetting),
            $2: 'Page Not Found'
        };
    };
    var $author$project$Pages$NotFound$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$NotFound$init,
        aeR: $author$project$Pages$NotFound$load,
        ag3: $author$project$Pages$NotFound$save,
        ahE: $author$project$Pages$NotFound$subscriptions,
        aaO: $author$project$Pages$NotFound$update,
        aid: $author$project$Pages$NotFound$view
    });
    var $author$project$Pages$Oauth$Callback$init = F2(function(shared, _v0) {
        var query = _v0.Bz;
        if ($elm$core$Dict$isEmpty(query)) return _Utils_Tuple3({}, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Login), _List_Nil);
        else {
            var _v1 = shared.Z$;
            switch(_v1.$){
                case 3:
                    var session = _v1.a;
                    return _Utils_Tuple3({}, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                case 1:
                    return _Utils_Tuple3({}, $elm$core$Platform$Cmd$none, _List_Nil);
                default:
                    return _Utils_Tuple3({}, $author$project$Ports$Session$authorize({
                        agy: true
                    }), _List_Nil);
            }
        }
    });
    var $author$project$Pages$Oauth$Callback$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Oauth$Callback$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Oauth$Callback$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Oauth$Callback$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Oauth$Callback$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Login'
        };
    };
    var $author$project$Pages$Oauth$Callback$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$Oauth$Callback$init,
        aeR: $author$project$Pages$Oauth$Callback$load,
        ag3: $author$project$Pages$Oauth$Callback$save,
        ahE: $author$project$Pages$Oauth$Callback$subscriptions,
        aaO: $author$project$Pages$Oauth$Callback$update,
        aid: $author$project$Pages$Oauth$Callback$view
    });
    var $author$project$Spa$Page$applicationOnlyPublic = function(page) {
        return {
            aeq: F2(function(shared, url) {
                var _v0 = shared.Z$;
                switch(_v0.$){
                    case 3:
                        return A2(page.aeq, shared, url);
                    case 0:
                        var _v1 = A2(page.aeq, shared, url);
                        var model = _v1.a;
                        var cmd = _v1.b;
                        var outMsgs = _v1.c;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            cmd,
                            $author$project$Ports$Session$authorize({
                                agy: false
                            })
                        ])), outMsgs);
                    default:
                        return A2(page.aeq, shared, url);
                }
            }),
            aeR: F2(function(shared, model) {
                return A2(page.aeR, shared, model);
            }),
            ag3: page.ag3,
            ahE: page.ahE,
            aaO: page.aaO,
            aid: page.aid
        };
    };
    var $author$project$Pages$Onboard$DealId_String$Top$GotPracticeOnboarding = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$OnboardingStepper$PracticeInfo = 0;
    var $author$project$Components$OnboardingStepper$defaultStepId = 0;
    var $author$project$Components$OnboardingStepper$InternalStep = F3(function(id, index, label) {
        return {
            aef: id,
            yc: index,
            aeI: label
        };
    });
    var $elm_community$list_extra$List$Extra$elemIndex = function(x) {
        return $elm_community$list_extra$List$Extra$findIndex($elm$core$Basics$eq(x));
    };
    var $author$project$Components$OnboardingStepper$Completed = 3;
    var $author$project$Components$OnboardingStepper$PaymentSetup = 2;
    var $author$project$Components$OnboardingStepper$UserCreation = 1;
    var $author$project$Components$OnboardingStepper$stepIds = _List_fromArray([
        0,
        1,
        2,
        3
    ]);
    var $author$project$Components$OnboardingStepper$stepIndex = function(stepId) {
        return A2($elm$core$Maybe$withDefault, -1, A2($elm_community$list_extra$List$Extra$elemIndex, stepId, $author$project$Components$OnboardingStepper$stepIds));
    };
    var $author$project$Components$OnboardingStepper$stepLabel = function(stepId) {
        switch(stepId){
            case 0:
                return 'Account Information';
            case 1:
                return 'Account Owner Setup';
            case 2:
                return 'Billing Setup';
            default:
                return '';
        }
    };
    var $author$project$Components$OnboardingStepper$buildInternalStep = function(stepId) {
        return A3($author$project$Components$OnboardingStepper$InternalStep, stepId, $author$project$Components$OnboardingStepper$stepIndex(stepId), $author$project$Components$OnboardingStepper$stepLabel(stepId));
    };
    var $author$project$Components$OnboardingStepper$internalSteps = A2($elm$core$List$map, $author$project$Components$OnboardingStepper$buildInternalStep, $author$project$Components$OnboardingStepper$stepIds);
    var $author$project$Components$OnboardingStepper$init = function(stepId) {
        return {
            E1: $author$project$Components$OnboardingStepper$buildInternalStep(stepId),
            $a: $author$project$Components$OnboardingStepper$internalSteps
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$One$PracticeOnboarding = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeOnboarding$One$Record = F5(function(ident, practiceName, step, emr, dealId) {
        return {
            acS: dealId,
            adl: emr,
            aeg: ident,
            agg: practiceName,
            _8: step
        };
    });
    var $author$project$Api$Provider$PracticeOnboarding$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deal_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'emr', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practice$Emr$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'step', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ident', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PracticeOnboarding$One$Record))))));
    var $author$project$Api$Provider$PracticeOnboarding$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PracticeOnboarding$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PracticeOnboarding$retrieve = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PracticeOnboarding$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id_)));
    });
    var $author$project$Pages$Onboard$DealId_String$Top$init = F2(function(shared, _v0) {
        var params = _v0.VU;
        var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
        var currentStep = stepperModel.E1;
        return _Utils_Tuple3({
            E1: currentStep,
            acS: params.acS,
            jA: $elm$core$Maybe$Nothing,
            W5: $author$project$Api$Data$NotAsked,
            Cu: shared,
            _9: stepperModel
        }, A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.Ej, params.acS, $author$project$Pages$Onboard$DealId_String$Top$GotPracticeOnboarding), _List_Nil);
    });
    var $author$project$Pages$Onboard$DealId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Onboard$DealId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Onboard$PracticeInfo$GotRecaptchaToken = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeInfo$subscriptions = function(_v0) {
        var model = _v0;
        return $author$project$Ui$Dropdown$subscriptions(model.l6);
    };
    var $author$project$Pages$Onboard$DealId_String$Top$subscriptions = function(_v0) {
        var practiceForm = _v0.jA;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ports$GoogleRecaptcha$gotRecaptchaToken(A2($elm$core$Basics$composeL, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, $author$project$Components$Onboard$PracticeInfo$GotRecaptchaToken)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Onboard$PracticeInfo$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg)), practiceForm))
        ]));
    };
    var $author$project$Pages$Onboard$DealId_String$Top$GotNewPracticeOnboarding = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$One$dealId = function(_v0) {
        var record = _v0;
        return record.acS;
    };
    var $author$project$Api$Provider$PracticeOnboarding$One$ident = function(_v0) {
        var record = _v0;
        return record.aeg;
    };
    var $author$project$Components$Onboard$PracticeInfo$DateInputMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Onboard$PracticeInfo$EmrDropdownMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeInfo$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeOnboarding$One$emr = function(_v0) {
        var record = _v0;
        return record.adl;
    };
    var $author$project$Api$Provider$PracticeOnboarding$One$practiceName = function(_v0) {
        var record = _v0;
        return record.agg;
    };
    var $author$project$Components$Onboard$PracticeInfo$init = F3(function(dealId, shared, practiceOnboarding) {
        var emr = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        var inittedForm = $author$project$Utils$Form$init({
            kU: $elm$core$Maybe$Nothing,
            qg: dateInput,
            acS: dealId,
            adl: emr,
            adn: $elm$core$Maybe$Nothing,
            S0: $elm$core$Maybe$Nothing,
            zr: $author$project$Api$Provider$PracticeOnboarding$One$practiceName(practiceOnboarding)
        });
        return _Utils_Tuple2({
            l6: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'emr',
                ahX: $author$project$Components$Onboard$PracticeInfo$EmrDropdownMsg
            })),
            PU: inittedForm,
            Cu: shared,
            km: false
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Onboard$PracticeInfo$DateInputMsg(dateInput), dateInputCmd));
    });
    var $author$project$Api$Provider$PracticeOnboarding$new = F3(function(apiClient, dealId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PracticeOnboarding$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'deal_id', dealId)
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'new'
        ]), $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath))));
    });
    var $author$project$Components$OnboardingStepper$redirectToLastStep = F2(function(step, onboardId) {
        switch(step){
            case 0:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__User({
                    afS: onboardId
                }));
            case 1:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment({
                    afS: onboardId
                }));
            case 2:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing({
                    afS: onboardId
                }));
            default:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Practice);
        }
    });
    var $author$project$Api$Provider$PracticeOnboarding$One$step = function(_v0) {
        var record = _v0;
        return record._8;
    };
    var $author$project$Components$OnboardingStepper$stepToType = function(string) {
        switch(string){
            case 'practice_info':
                return 0;
            case 'user_creation':
                return 1;
            case 'payment_setup':
                return 2;
            case 'completed':
                return 3;
            default:
                return 0;
        }
    };
    var $author$project$Components$Onboard$PracticeInfo$Emr = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeInfo$EmrOther = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeInfo$LaunchDate = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Ports$GoogleRecaptcha$Onboard = 0;
    var $author$project$Components$Onboard$PracticeInfo$PracticeOnboardingCreated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_onboarding', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('deal_id', $elm$json$Json$Encode$string(fields.acS)),
                _Utils_Tuple2('emr', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$Emr$toValue, $elm$json$Json$Encode$string), fields.adl)),
                _Utils_Tuple2('estimated_memberships_count', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.adt)),
                _Utils_Tuple2('launch_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.S0)),
                _Utils_Tuple2('practice_name', $elm$json$Json$Encode$string(fields.agg))
            ]))),
            _Utils_Tuple2('google_recaptcha_token', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.agw))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeOnboarding$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeOnboarding$practiceOnboardingsPath)));
    });
    var $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var name = field.a;
                return _Utils_update(fields, {
                    zr: name
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    kU: $elm$core$String$toInt(string)
                });
            case 1:
                var maybeEmr = field.a;
                return _Utils_update(fields, {
                    adl: maybeEmr
                });
            case 2:
                var maybeString = field.a;
                return _Utils_update(fields, {
                    adn: maybeString
                });
            default:
                var dateInput = field.a;
                var date = field.b;
                return _Utils_update(fields, {
                    qg: dateInput,
                    S0: date
                });
        }
    });
    var $author$project$Components$Onboard$PracticeInfo$ActiveMembersCountValidation = 1;
    var $author$project$Components$Onboard$PracticeInfo$NameValidation = 0;
    var $author$project$Components$Onboard$PracticeInfo$LaunchDateValidation = 2;
    var $author$project$Components$Onboard$PracticeInfo$validateLaunchDate = function(fields) {
        var _v0 = fields.S0;
        if (_v0.$ === 1) return _List_fromArray([
            _Utils_Tuple2(2, 'Please enter an estimated launch date.')
        ]);
        else return _List_Nil;
    };
    var $author$project$Components$Onboard$PracticeInfo$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a practice name.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function(fields) {
            return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.kU));
        }, _Utils_Tuple2(1, 'Please enter an active members count.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Onboard$PracticeInfo$validateLaunchDate)
    ]));
    var $author$project$Components$Onboard$PracticeInfo$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Onboard$PracticeInfo$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: validForm,
                        km: true
                    }), $author$project$Ports$GoogleRecaptcha$getRecaptchaToken(0), _List_Nil);
                } else {
                    var erroredForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: erroredForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 6:
                var result = msg.a;
                var recaptchaToken = $elm$core$Result$toMaybe(result);
                var fields = $author$project$Utils$Form$fields(model.PU);
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$PracticeOnboarding$create, model.Cu.Ej, {
                    acS: fields.acS,
                    adl: fields.adl,
                    adt: fields.kU,
                    S0: fields.S0,
                    agg: fields.zr,
                    agw: recaptchaToken
                }, $author$project$Components$Onboard$PracticeInfo$PracticeOnboardingCreated), _List_Nil);
            case 5:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var practiceOnboarding = response.a;
                        var onboardId = $author$project$Api$Provider$PracticeOnboarding$One$ident(practiceOnboarding);
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__User({
                            afS: onboardId
                        })), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                var subMsg = msg.a;
                var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.l6);
                var newDropdown = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    l6: newDropdown
                }), cmd, _List_Nil);
            case 2:
                var emrOption = msg.a;
                var newForm = function() {
                    if (!emrOption.$) {
                        var emr = emrOption.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate, $author$project$Components$Onboard$PracticeInfo$EmrOther($elm$core$Maybe$Nothing), A3($author$project$Utils$Form$update, $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate, $author$project$Components$Onboard$PracticeInfo$Emr($elm$core$Maybe$Just(emr)), model.PU));
                    } else return A3($author$project$Utils$Form$update, $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate, $author$project$Components$Onboard$PracticeInfo$Emr($elm$core$Maybe$Nothing), model.PU);
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var dateInput = msg.a;
                var subMsg = msg.b;
                var _v7 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
                var newDateInput = _v7.a;
                var subCmd = _v7.b;
                var event = _v7.c;
                var newForm = function() {
                    if (event.$ === 1) {
                        var date = event.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate, A2($author$project$Components$Onboard$PracticeInfo$LaunchDate, newDateInput, date), model.PU);
                    } else {
                        var fields = $author$project$Utils$Form$fields(model.PU);
                        return A3($author$project$Utils$Form$update, $author$project$Components$Onboard$PracticeInfo$formFieldsUpdate, A2($author$project$Components$Onboard$PracticeInfo$LaunchDate, newDateInput, fields.S0), model.PU);
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Onboard$PracticeInfo$DateInputMsg(newDateInput), subCmd), _List_Nil);
        }
    });
    var $author$project$Pages$Onboard$DealId_String$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = model.jA;
                if (_v1.$ === 1) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    var practiceForm = _v1.a;
                    var _v2 = A2($author$project$Components$Onboard$PracticeInfo$update, subMsg, practiceForm);
                    var practiceInfoFormModel = _v2.a;
                    var practiceInfoFormCmd = _v2.b;
                    var practiceInfoMsg = _v2.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        jA: $elm$core$Maybe$Just(practiceInfoFormModel)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, practiceInfoFormCmd), practiceInfoMsg);
                }
            case 1:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var practiceOnboarding = response.a;
                        var onboardId = $author$project$Api$Provider$PracticeOnboarding$One$ident(practiceOnboarding);
                        var currentOnboardingStep = $author$project$Api$Provider$PracticeOnboarding$One$step(practiceOnboarding);
                        var currentStepType = $author$project$Components$OnboardingStepper$stepToType(currentOnboardingStep);
                        var stepperModel = $author$project$Components$OnboardingStepper$init(currentStepType);
                        var currentStep = stepperModel.E1;
                        return _Utils_Tuple3(_Utils_update(model, {
                            E1: currentStep,
                            W5: response
                        }), A2($author$project$Components$OnboardingStepper$redirectToLastStep, currentStepType, onboardId), $author$project$OutMsg$handleErrorResponse(response));
                    case 2:
                        return _Utils_Tuple3(model, A3($author$project$Api$Provider$PracticeOnboarding$new, model.Cu.Ej, model.acS, $author$project$Pages$Onboard$DealId_String$Top$GotNewPracticeOnboarding), _List_Nil);
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var practiceOnboarding = response.a;
                    var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
                    var currentStep = stepperModel.E1;
                    var _v5 = A3($author$project$Components$Onboard$PracticeInfo$init, $author$project$Api$Provider$PracticeOnboarding$One$dealId(practiceOnboarding), model.Cu, practiceOnboarding);
                    var practiceInfoFormModel = _v5.a;
                    var practiceInfoFormCmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        E1: currentStep,
                        jA: $elm$core$Maybe$Just(practiceInfoFormModel)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, practiceInfoFormCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Onboard$PracticeInfo$FormSubmitted = {
        $: 4
    };
    var $author$project$Components$Onboard$PracticeInfo$ActiveMembersCount = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeInfo$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Utils$Form$field = function(getter) {
        return A2($elm$core$Basics$composeR, $author$project$Utils$Form$fields, getter);
    };
    var $author$project$Components$Onboard$PracticeInfo$viewActiveMembersCount = function(form) {
        var activeMembersCount = A2($author$project$Utils$Form$field, function($) {
            return $.kU;
        }, form);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(12),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$label('How many active members do you currently have?'),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$test('active-members-count')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$number,
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, activeMembersCount))),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$ActiveMembersCount)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeInfo$EmrSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$Emr$isHintClinical = function(_v0) {
        var option = _v0.af;
        return !option;
    };
    var $author$project$Components$Onboard$PracticeInfo$emrIsHintClinical = function(emr) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$isHintClinical, emr));
    };
    var $author$project$Components$Onboard$PracticeInfo$viewEmr = F2(function(form, emrDropdown) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(5),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$label('EMR')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    function() {
                        var emr = A2($author$project$Utils$Form$field, function($) {
                            return $.adl;
                        }, form);
                        var currentLabel = function() {
                            if (!emr.$) {
                                var emrValue = emr.a;
                                return $author$project$Api$Provider$Practice$Emr$toLabel(emrValue);
                            } else return 'Select an EMR';
                        }();
                        var availableOptions = $author$project$Components$Onboard$PracticeInfo$emrIsHintClinical(emr) ? $author$project$Api$Provider$Practice$Emr$options : A2($elm$core$List$filter, function(emrOption) {
                            return !$author$project$Api$Provider$Practice$Emr$isHintClinical(emrOption);
                        }, $author$project$Api$Provider$Practice$Emr$options);
                        var items = A2($elm$core$List$map, function(emrOption) {
                            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                $author$project$Ui$Dropdown$onSelect($author$project$Components$Onboard$PracticeInfo$EmrSelected($elm$core$Maybe$Just(emrOption))),
                                $author$project$Ui$Dropdown$selected(_Utils_eq(emr, $elm$core$Maybe$Just(emrOption)))
                            ]), $elm$html$Html$text($author$project$Api$Provider$Practice$Emr$toLabel(emrOption)));
                        }, availableOptions);
                        return A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                            $author$project$Ui$Dropdown$disabled($author$project$Components$Onboard$PracticeInfo$emrIsHintClinical(emr))
                        ]), _List_fromArray([
                            $elm$html$Html$text(currentLabel)
                        ]), items, emrDropdown);
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Onboard$PracticeInfo$viewEmrOther = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        return _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$toOption, fields.adl), $elm$core$Maybe$Just(13)) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$label('')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.adn)),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$EmrOther), $author$project$Utils$String$toMaybe))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Onboard$PracticeInfo$viewInfoHeader = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $author$project$Ui$Typography$heading(_List_fromArray([
            $elm$html$Html$text('Welcome to Hint!')
        ])),
        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text(' We\'re excited to walk you through setting up your account. This form should be completed by the business owner or an authorized delegate and should take you about 5 minutes.')
        ]))
    ]));
    var $author$project$Components$Onboard$PracticeInfo$viewPracticeLaunchDate = function(form) {
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(12),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$label('What is your estimated launch / go-live date?'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Onboard$PracticeInfo$DateInputMsg(fields.qg), A2($author$project$Components$DateInput$view, _List_fromArray([
                $author$project$Components$DateInput$value(fields.S0),
                $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
            ]), fields.qg)),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('This is when you can start billing patients through Hint.')
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeInfo$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeInfo$viewPracticeName = function(form) {
        var name = A2($author$project$Utils$Form$field, function($) {
            return $.zr;
        }, form);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Practice Name'),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(name),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeInfo$FormUpdated, $author$project$Components$Onboard$PracticeInfo$Name)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeInfo$viewForm = F3(function(form, emrDropdown, submitting) {
        return _List_fromArray([
            $author$project$Components$Onboard$PracticeInfo$viewInfoHeader,
            $author$project$Components$Onboard$PracticeInfo$viewPracticeName(form),
            A2($author$project$Components$Onboard$PracticeInfo$viewEmr, form, emrDropdown),
            $author$project$Components$Onboard$PracticeInfo$viewEmrOther(form),
            $author$project$Components$Onboard$PracticeInfo$viewPracticeLaunchDate(form),
            $author$project$Components$Onboard$PracticeInfo$viewActiveMembersCount(form),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textRight,
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Submit pratice information'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit,
                    $author$project$Ui$Button$loading(submitting)
                ]), _List_fromArray([
                    $elm$html$Html$text('Next')
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Onboard$PracticeInfo$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$onSubmit($author$project$Components$Onboard$PracticeInfo$FormSubmitted)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$extraPadding
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, A3($author$project$Components$Onboard$PracticeInfo$viewForm, model.PU, model.l6, model.km))
            ]))
        ]));
    };
    var $author$project$Pages$Onboard$DealId_String$Top$view = function(model) {
        return {
            fb: function() {
                var _v0 = model.jA;
                if (_v0.$ === 1) return _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Spinner$view(_List_Nil)
                    ]))
                ]);
                else {
                    var practiceForm = _v0.a;
                    return _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Onboard$DealId_String$Top$PracticeInfoMsg, $author$project$Components$Onboard$PracticeInfo$view(practiceForm))
                    ]);
                }
            }(),
            $2: 'Onboard'
        };
    };
    var $author$project$Pages$Onboard$DealId_String$Top$page = $author$project$Spa$Page$applicationOnlyPublic({
        aeq: $author$project$Pages$Onboard$DealId_String$Top$init,
        aeR: $author$project$Pages$Onboard$DealId_String$Top$load,
        ag3: $author$project$Pages$Onboard$DealId_String$Top$save,
        ahE: $author$project$Pages$Onboard$DealId_String$Top$subscriptions,
        aaO: $author$project$Pages$Onboard$DealId_String$Top$update,
        aid: $author$project$Pages$Onboard$DealId_String$Top$view
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completed$init = F2(function(_v0, _v1) {
        var params = _v1.VU;
        return _Utils_Tuple3({
            afS: params.afS
        }, A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Account), _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completed$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completed$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completed$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Onboard$OnboardId_String$Completed$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completed$view = function(_v0) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                ]), _List_fromArray([
                    $author$project$Ui$Spinner$view(_List_Nil)
                ]))
            ]),
            $2: 'Onboard'
        };
    };
    var $author$project$Pages$Onboard$OnboardId_String$Completed$page = $author$project$Spa$Page$applicationOnlyPublic({
        aeq: $author$project$Pages$Onboard$OnboardId_String$Completed$init,
        aeR: $author$project$Pages$Onboard$OnboardId_String$Completed$load,
        ag3: $author$project$Pages$Onboard$OnboardId_String$Completed$save,
        ahE: $author$project$Pages$Onboard$OnboardId_String$Completed$subscriptions,
        aaO: $author$project$Pages$Onboard$OnboardId_String$Completed$update,
        aid: $author$project$Pages$Onboard$OnboardId_String$Completed$view
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completing$PracticeOnboardingCompleted = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PracticeOnboarding$setupPractice = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'setup_practice'
        ]), $author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completing$init = F2(function(shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple3({
            afS: params.afS
        }, A3($author$project$Api$Provider$PracticeOnboarding$setupPractice, shared.Ej, params.afS, $elm$core$Basics$identity), _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completing$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completing$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completing$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Api$Data$errorToStatus = function(errorResponse) {
        switch(errorResponse.$){
            case 0:
                return '401';
            case 1:
                return '404';
            case 2:
                return '503';
            case 4:
                return '502';
            case 3:
                return '503';
            case 5:
                return '404';
            case 8:
                return '500';
            case 6:
                var code = errorResponse.a;
                return $elm$core$String$fromInt(code);
            case 7:
                return '417';
            case 9:
                return '403';
            default:
                return '409';
        }
    };
    var $author$project$Pages$Onboard$OnboardId_String$Completing$update = F2(function(msg, model) {
        var response = msg;
        switch(response.$){
            case 3:
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed({
                    afS: model.afS
                })), _List_Nil);
            case 2:
                if (response.a.$ === 6 && response.a.a === 422) {
                    var _v2 = response.a;
                    return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed({
                        afS: model.afS
                    })), _List_Nil);
                } else {
                    var error = response.a;
                    return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Error__Status_String({
                        ahy: $author$project$Api$Data$errorToStatus(error)
                    })), _List_Nil);
                }
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Onboard$OnboardId_String$Completing$view = function(_v0) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textCenter
                ]), _List_fromArray([
                    $author$project$Ui$Spinner$view(_List_Nil),
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Please wait while we create your account.')
                    ])),
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('You will be able to sign in shortly to continue onboarding.')
                    ]))
                ]))
            ]),
            $2: 'Onboard'
        };
    };
    var $author$project$Pages$Onboard$OnboardId_String$Completing$page = $author$project$Spa$Page$applicationOnlyPublic({
        aeq: $author$project$Pages$Onboard$OnboardId_String$Completing$init,
        aeR: $author$project$Pages$Onboard$OnboardId_String$Completing$load,
        ag3: $author$project$Pages$Onboard$OnboardId_String$Completing$save,
        ahE: $author$project$Pages$Onboard$OnboardId_String$Completing$subscriptions,
        aaO: $author$project$Pages$Onboard$OnboardId_String$Completing$update,
        aid: $author$project$Pages$Onboard$OnboardId_String$Completing$view
    });
    var $author$project$Pages$Onboard$OnboardId_String$Payment$PaymentSetupMsg = $elm$core$Basics$identity;
    var $author$project$Components$Onboard$PaymentSetup$GotPracticeOnboarding = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Onboard$PaymentSetup$GotSetupConfig = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Rainforest$Live = 0;
    var $author$project$Components$Onboard$PaymentSetup$Loading = {
        $: 0
    };
    var $author$project$Components$Onboard$PaymentSetup$Model = $elm$core$Basics$identity;
    var $author$project$Rainforest$Sandbox = 1;
    var $author$project$Ports$Rainforest$rainforestPortLoad = _Platform_outgoingPort('rainforestPortLoad', $elm$json$Json$Encode$string);
    var $author$project$Rainforest$toString = function(env) {
        if (!env) return 'production';
        else return 'sandbox';
    };
    var $author$project$Ports$Rainforest$load = A2($elm$core$Basics$composeR, $author$project$Rainforest$toString, $author$project$Ports$Rainforest$rainforestPortLoad);
    var $author$project$Components$Onboard$PaymentSetup$init = F2(function(onboardId, shared) {
        var rainforestEnv = _Utils_eq(shared.adU.aea, $elm$core$Maybe$Just('production')) ? 0 : 1;
        return _Utils_Tuple2({
            cE: false,
            qW: shared.qW,
            c_: true,
            afS: onboardId,
            W5: $author$project$Api$Data$Loading,
            au: $author$project$Components$Onboard$PaymentSetup$Loading
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.Ej, onboardId, $author$project$Components$Onboard$PaymentSetup$GotPracticeOnboarding),
            A3($author$project$Api$PaymentMethod$getClientSecret, A2($author$project$Api$Data$pathAppend, _List_fromArray([
                'practice_onboardings',
                onboardId
            ]), $author$project$Api$Data$providerPath), shared.Ej, $author$project$Components$Onboard$PaymentSetup$GotSetupConfig),
            $author$project$Ports$Rainforest$load(rainforestEnv)
        ])));
    });
    var $author$project$Pages$Onboard$OnboardId_String$Payment$init = F2(function(shared, _v0) {
        var params = _v0.VU;
        var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
        var currentStep = stepperModel.E1;
        var _v1 = A2($author$project$Components$Onboard$PaymentSetup$init, params.afS, shared);
        var paymentSetupFormModel = _v1.a;
        var paymentSetupFormCmd = _v1.b;
        return _Utils_Tuple3({
            Ej: shared.Ej,
            E1: currentStep,
            nu: paymentSetupFormModel,
            _9: stepperModel
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSetupFormCmd), _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$Payment$load = F2(function(shared, model) {
        return _Utils_Tuple3(_Utils_update(model, {
            Ej: shared.Ej
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$Payment$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Onboard$PaymentSetup$GotStripePaymentMethod = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Onboard$PaymentSetup$subscriptions = function(_v0) {
        return $author$project$Ports$Stripe$onSetupIntentConfirmed($author$project$Components$Onboard$PaymentSetup$GotStripePaymentMethod);
    };
    var $author$project$Pages$Onboard$OnboardId_String$Payment$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Onboard$PaymentSetup$subscriptions(model.nu));
    };
    var $author$project$Components$Onboard$PaymentSetup$Failed = {
        $: 3
    };
    var $author$project$Components$Onboard$PaymentSetup$Rainforest = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Onboard$PaymentSetup$Stripe = {
        $: 1
    };
    var $author$project$Components$Onboard$PaymentSetup$andNoop = function(model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    };
    var $author$project$Components$Onboard$PaymentSetup$stripeElementId = 'card-element';
    var $author$project$Components$Onboard$PaymentSetup$buildStripeElement = function(clientSecret) {
        return A6($author$project$Ports$Stripe$buildAndMountElementWithSetupIntent, $elm$core$Maybe$Nothing, clientSecret, '#' + $author$project$Components$Onboard$PaymentSetup$stripeElementId, false, '', '');
    };
    var $author$project$Components$Onboard$PaymentSetup$PracticeOnboardingUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$updateProcessorConfig = F4(function(apiClient, paymentProcessorParams, id, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_onboarding', $elm$json$Json$Encode$object($author$project$Api$PaymentProcessorParams$encode(paymentProcessorParams)))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeOnboarding$practiceOnboardingPath(id))));
    });
    var $author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding = F3(function(apiClient, paymentProcessorParams, onboardId) {
        return A4($author$project$Api$Provider$PracticeOnboarding$updateProcessorConfig, apiClient, paymentProcessorParams, onboardId, $author$project$Components$Onboard$PaymentSetup$PracticeOnboardingUpdated);
    });
    var $author$project$Components$Onboard$PaymentSetup$updateRainforest = F4(function(apiClient, msg, config, model) {
        switch(msg.$){
            case 0:
                var rainforestId = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    au: $author$project$Components$Onboard$PaymentSetup$Rainforest(config)
                }), A3($author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding, apiClient, $author$project$Api$PaymentProcessorParams$rainforestParams(rainforestId), model.afS), _List_Nil);
            case 1:
                var isValid = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    au: $author$project$Components$Onboard$PaymentSetup$Rainforest(_Utils_update(config, {
                        yt: isValid
                    }))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    au: $author$project$Components$Onboard$PaymentSetup$Rainforest(_Utils_update(config, {
                        c_: false
                    }))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Onboard$PaymentSetup$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var setup = response.a;
                    var _v3 = function() {
                        if (!setup.$) {
                            var secret = setup.a;
                            return _Utils_Tuple2($author$project$Components$Onboard$PaymentSetup$Stripe, $author$project$Components$Onboard$PaymentSetup$buildStripeElement(secret));
                        } else {
                            var sessionKey = setup.a.ahi;
                            var paymentMethodConfigId = setup.a.af7;
                            var allowedMethods = setup.a.abL;
                            return _Utils_Tuple2($author$project$Components$Onboard$PaymentSetup$Rainforest({
                                abL: allowedMethods,
                                c_: true,
                                yt: false,
                                af7: paymentMethodConfigId,
                                ahi: sessionKey
                            }), $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var config = _v3.a;
                    var processorElement = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        c_: false,
                        au: config
                    }), processorElement, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    c_: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var portCall = function() {
                    var _v5 = model.au;
                    switch(_v5.$){
                        case 1:
                            return A2($author$project$Ports$Stripe$confirmSetupIntent, '#' + $author$project$Components$Onboard$PaymentSetup$stripeElementId, {
                                ab2: $elm$core$Maybe$Nothing
                            });
                        case 2:
                            return $author$project$Ports$Rainforest$submitPaymentMethod;
                        default:
                            return $elm$core$Platform$Cmd$none;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    cE: true
                }), portCall, _List_Nil);
            case 2:
                var cardPaymentMethodResult = msg.a;
                if (!cardPaymentMethodResult.$) {
                    var stripeCardPaymentMethod = cardPaymentMethodResult.a;
                    var params = $author$project$Api$PaymentProcessorParams$stripeParams(stripeCardPaymentMethod.aef);
                    return _Utils_Tuple3(_Utils_update(model, {
                        cE: true
                    }), A3($author$project$Components$Onboard$PaymentSetup$updatePracticeOnboarding, apiClient, params, model.afS), _List_Nil);
                } else {
                    var _v7 = model.au;
                    if (!_v7.$) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    else return _Utils_Tuple3(_Utils_update(model, {
                        cE: false,
                        au: $author$project$Components$Onboard$PaymentSetup$Failed
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            cE: false
                        }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing({
                            afS: model.afS
                        })), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            cE: false
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            cE: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 4:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            W5: response
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            W5: $author$project$Api$Data$Failure(error)
                        }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Error__Status_String({
                            ahy: $author$project$Api$Data$errorToStatus(error)
                        })), $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            W5: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            default:
                var rainforestMsg = msg.a;
                var _v10 = model.au;
                if (_v10.$ === 2) {
                    var config = _v10.a;
                    return A4($author$project$Components$Onboard$PaymentSetup$updateRainforest, apiClient, rainforestMsg, config, model);
                } else return $author$project$Components$Onboard$PaymentSetup$andNoop(model);
        }
    });
    var $author$project$Pages$Onboard$OnboardId_String$Payment$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Onboard$PaymentSetup$update, model.Ej, subMsg, model.nu);
        var paymentSetupModel = _v1.a;
        var paymentSetupFormCmd = _v1.b;
        return _Utils_Tuple3(_Utils_update(model, {
            nu: paymentSetupModel
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSetupFormCmd), _List_Nil);
    });
    var $author$project$Components$Onboard$PaymentSetup$viewInfoHeader = A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
        $author$project$Ui$Typography$heading(_List_fromArray([
            $elm$html$Html$text('Add your payment method')
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb4
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$margin(18)
            ]), _List_fromArray([
                $elm$html$Html$text('You will not be billed immediately for your application software fees. You can view your billing start date after you complete onboarding.')
            ]))
        ]))
    ]));
    var $author$project$Components$Onboard$PaymentSetup$Approved = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Onboard$PaymentSetup$Loaded = {
        $: 2
    };
    var $author$project$Components$Onboard$PaymentSetup$Noop = {
        $: 3
    };
    var $author$project$Components$Onboard$PaymentSetup$RainforestMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Onboard$PaymentSetup$Save = {
        $: 1
    };
    var $author$project$Components$Onboard$PaymentSetup$ValidityChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Button$Test = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Ui$Button$test = $author$project$Ui$Button$Test;
    var $author$project$Components$Onboard$PaymentSetup$viewPaymentElementsForm = function(_v0) {
        var model = _v0;
        var valid = function() {
            var _v4 = model.au;
            if (_v4.$ === 2) {
                var conf = _v4.a;
                return conf.yt;
            } else return true;
        }();
        var disabled = !valid;
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4,
            $author$project$Ui$Element$mb4
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('stripe-card')
            ]), _List_fromArray([
                function() {
                    var _v1 = _Utils_Tuple2(model.c_, model.au);
                    _v1$2: while(true){
                        if (!_v1.a) switch(_v1.b.$){
                            case 1:
                                var _v2 = _v1.b;
                                return A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$id($author$project$Components$Onboard$PaymentSetup$stripeElementId)
                                ]), _List_Nil);
                            case 2:
                                var config = _v1.b.a;
                                var _v3 = config;
                                var sessionKey = _v3.ahi;
                                var paymentMethodConfigId = _v3.af7;
                                var allowedMethods = _v3.abL;
                                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    A2($author$project$WebComponents$Rainforest$Payment$view, {
                                        afs: A2($elm$core$Basics$composeR, $author$project$Components$Onboard$PaymentSetup$Approved, $author$project$Components$Onboard$PaymentSetup$RainforestMsg),
                                        afu: A2($elm$core$Basics$composeR, $elm$core$Basics$always($author$project$Components$Onboard$PaymentSetup$Noop), $author$project$Components$Onboard$PaymentSetup$RainforestMsg),
                                        afF: $author$project$Components$Onboard$PaymentSetup$RainforestMsg($author$project$Components$Onboard$PaymentSetup$ValidityChanged(false)),
                                        afH: $author$project$Components$Onboard$PaymentSetup$RainforestMsg($author$project$Components$Onboard$PaymentSetup$Loaded),
                                        afI: A2($elm$core$Basics$composeR, $elm$core$Basics$always($author$project$Components$Onboard$PaymentSetup$Noop), $author$project$Components$Onboard$PaymentSetup$RainforestMsg),
                                        afR: $author$project$Components$Onboard$PaymentSetup$RainforestMsg($author$project$Components$Onboard$PaymentSetup$ValidityChanged(true))
                                    }, {
                                        abL: allowedMethods,
                                        af7: paymentMethodConfigId,
                                        ahi: sessionKey
                                    }),
                                    config.c_ ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Grid$column, _List_fromArray([
                                            $author$project$Ui$Grid$spanSm(8),
                                            $author$project$Ui$Grid$justifyCenter
                                        ]), _List_fromArray([
                                            $author$project$Ui$Spinner$view(_List_fromArray([
                                                $author$project$Ui$Spinner$large
                                            ]))
                                        ]))
                                    ])) : $author$project$Utils$Html$empty
                                ]));
                            default:
                                break _v1$2;
                        }
                        else break _v1$2;
                    }
                    return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(8),
                            $author$project$Ui$Grid$justifyCenter
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_fromArray([
                                $author$project$Ui$Spinner$large
                            ]))
                        ]))
                    ]));
                }()
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mt4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Submit payment method'
                    }, _List_fromArray([
                        $author$project$Ui$Button$styled(1),
                        $author$project$Ui$Button$loading(model.cE),
                        $author$project$Ui$Button$disabled(model.cE || disabled),
                        $author$project$Ui$Button$onClick($author$project$Components$Onboard$PaymentSetup$Save),
                        $author$project$Ui$Button$test('submit-payment-method')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Next')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PaymentSetup$viewForm = function(_v0) {
        var model = _v0;
        return _Utils_eq(model.W5, $author$project$Api$Data$Loading) ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
            ]), _List_fromArray([
                $author$project$Ui$Spinner$view(_List_Nil)
            ]))
        ]) : _List_fromArray([
            $author$project$Components$Onboard$PaymentSetup$viewInfoHeader,
            $author$project$Components$Onboard$PaymentSetup$viewPaymentElementsForm(model)
        ]);
    };
    var $author$project$Components$Onboard$PaymentSetup$view = function(model) {
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$noValidate(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$extraPadding
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Components$Onboard$PaymentSetup$viewForm(model))
            ]))
        ]));
    };
    var $author$project$Pages$Onboard$OnboardId_String$Payment$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Onboard$PaymentSetup$view(model.nu))
            ]),
            $2: 'Onboard'
        };
    };
    var $author$project$Pages$Onboard$OnboardId_String$Payment$page = $author$project$Spa$Page$applicationOnlyPublic({
        aeq: $author$project$Pages$Onboard$OnboardId_String$Payment$init,
        aeR: $author$project$Pages$Onboard$OnboardId_String$Payment$load,
        ag3: $author$project$Pages$Onboard$OnboardId_String$Payment$save,
        ahE: $author$project$Pages$Onboard$OnboardId_String$Payment$subscriptions,
        aaO: $author$project$Pages$Onboard$OnboardId_String$Payment$update,
        aid: $author$project$Pages$Onboard$OnboardId_String$Payment$view
    });
    var $author$project$Pages$Onboard$OnboardId_String$User$GotPracticeOnboarding = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Onboard$OnboardId_String$User$ShowingCreateForm = 0;
    var $author$project$Pages$Onboard$OnboardId_String$User$ShowingExistingUser = 1;
    var $author$project$Components$Onboard$PracticeUser$Model = $elm$core$Basics$identity;
    var $author$project$Components$Onboard$PracticeUser$init = F2(function(onboardId, shared) {
        var inittedForm = $author$project$Utils$Form$init({
            OH: '',
            PN: '',
            SU: '',
            af2: '',
            rU: '',
            nk: $elm$core$Maybe$Nothing,
            HM: false
        });
        return _Utils_Tuple2({
            PU: inittedForm,
            afS: onboardId,
            Cu: shared
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Onboard$OnboardId_String$User$init = F2(function(shared, _v0) {
        var params = _v0.VU;
        var stepperModel = $author$project$Components$OnboardingStepper$init($author$project$Components$OnboardingStepper$defaultStepId);
        var maybeSession = function() {
            var _v3 = shared.Z$;
            if (_v3.$ === 3) {
                var session = _v3.a;
                return $elm$core$Maybe$Just(session);
            } else return $elm$core$Maybe$Nothing;
        }();
        var initialViewMode = function() {
            if (!maybeSession.$) return 1;
            else return 0;
        }();
        var currentStep = stepperModel.E1;
        var _v1 = A2($author$project$Components$Onboard$PracticeUser$init, params.afS, shared);
        var practiceUserFormModel = _v1.a;
        var practiceUserFormCmd = _v1.b;
        return _Utils_Tuple3({
            E1: currentStep,
            fW: false,
            m3: maybeSession,
            afS: params.afS,
            W5: $author$project$Api$Data$Loading,
            Cu: shared,
            _9: stepperModel,
            kL: practiceUserFormModel,
            kM: initialViewMode
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, practiceUserFormCmd),
            A3($author$project$Api$Provider$PracticeOnboarding$retrieve, shared.Ej, params.afS, $author$project$Pages$Onboard$OnboardId_String$User$GotPracticeOnboarding)
        ])), _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$User$determineViewMode = F3(function(maybeSession, practiceOnboardingData, currentViewMode) {
        var _v0 = _Utils_Tuple2(practiceOnboardingData, maybeSession);
        if (!_v0.b.$) {
            if (_v0.a.$ === 3) {
                var _v1 = _v0.a;
                var practiceOnboarding = _v1.a;
                var _v2 = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
                if (!_v2.$) {
                    var emr = _v2.a;
                    return $author$project$Api$Provider$Practice$Emr$isHintClinical(emr) ? 0 : 1;
                } else return 1;
            } else return 1;
        } else return currentViewMode;
    });
    var $author$project$Pages$Onboard$OnboardId_String$User$load = F2(function(shared, model) {
        var updatedMaybeSession = function() {
            var _v0 = shared.Z$;
            if (_v0.$ === 3) {
                var session = _v0.a;
                return $elm$core$Maybe$Just(session);
            } else return $elm$core$Maybe$Nothing;
        }();
        var updatedViewMode = A3($author$project$Pages$Onboard$OnboardId_String$User$determineViewMode, updatedMaybeSession, model.W5, model.kM);
        return _Utils_Tuple3(_Utils_update(model, {
            m3: updatedMaybeSession,
            Cu: shared,
            kM: updatedViewMode
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Onboard$OnboardId_String$User$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Onboard$PracticeUser$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeUser$PasswordStrengthCheck = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeUser$subscriptions = function(_v0) {
        return $author$project$Ports$PasswordStrength$checked(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$PasswordStrengthCheck), $elm$core$Maybe$Just));
    };
    var $author$project$Pages$Onboard$OnboardId_String$User$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, $author$project$Components$Onboard$PracticeUser$subscriptions(model.kL));
    };
    var $author$project$Ui$Toast$Info = 0;
    var $author$project$Pages$Onboard$OnboardId_String$User$UserLinked = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath = F2(function(basePath, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), basePath);
    });
    var $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice_onboardings'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PracticeOnboarding$User$userPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'user'
        ]), basePath);
    };
    var $author$project$Api$Provider$PracticeOnboarding$User$linkExistingPath = function(onboardId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'link'
        ]), $author$project$Api$Provider$PracticeOnboarding$User$userPath(A2($author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath, $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath, onboardId)));
    };
    var $author$project$Api$Provider$PracticeOnboarding$User$linkExisting = F3(function(apiClient, onboardId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PracticeOnboarding$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeOnboarding$User$linkExistingPath(onboardId)));
    });
    var $author$project$Components$Onboard$PracticeUser$OnboardingUserCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeOnboarding$User$onboardingUserPath = function(onboardId) {
        return $author$project$Api$Provider$PracticeOnboarding$User$userPath(A2($author$project$Api$Provider$PracticeOnboarding$User$onboardIdPath, $author$project$Api$Provider$PracticeOnboarding$User$practiceOnboardingsPath, onboardId));
    };
    var $author$project$Api$Provider$PracticeOnboarding$User$create = F3(function(apiClient, fields, toMsg) {
        var createOnboardingUserPath = $author$project$Api$Provider$PracticeOnboarding$User$onboardingUserPath(fields.afS);
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_onboarding_user', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('first_name', $elm$json$Json$Encode$string(fields.PN)),
                _Utils_Tuple2('last_name', $elm$json$Json$Encode$string(fields.SU)),
                _Utils_Tuple2('terms_accepted', $elm$json$Json$Encode$bool(fields.HM)),
                _Utils_Tuple2('email', $elm$json$Json$Encode$string(fields.OH)),
                _Utils_Tuple2('password', $elm$json$Json$Encode$string(fields.af2))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(createOnboardingUserPath)));
    });
    var $author$project$Components$Onboard$PracticeUser$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    PN: string
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    SU: string
                }), $elm$core$Platform$Cmd$none);
            case 2:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    OH: string
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    af2: string,
                    nk: $elm$core$Maybe$Nothing
                }), $author$project$Ports$PasswordStrength$check(string));
            case 4:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    rU: string
                }), $elm$core$Platform$Cmd$none);
            case 6:
                var bool = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    HM: bool
                }), $elm$core$Platform$Cmd$none);
            default:
                var check = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    nk: check
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$Onboard$PracticeUser$EmailValidation = 2;
    var $author$project$Components$Onboard$PracticeUser$FirstNameValidation = 0;
    var $author$project$Components$Onboard$PracticeUser$LastNameValidation = 1;
    var $author$project$Components$Onboard$PracticeUser$PasswordValidation = 3;
    var $author$project$Components$Onboard$PracticeUser$TermsAcceptedValidation = 5;
    var $author$project$Components$Onboard$PracticeUser$PasswordConfirmationValidation = 4;
    var $author$project$Components$Onboard$PracticeUser$validatePasswordConfirmation = function(fields) {
        return $author$project$Utils$String$isBlank(fields.af2) ? _List_Nil : _Utils_eq(fields.af2, fields.rU) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(4, 'The password and its confirmation don\'t match.')
        ]);
    };
    var $author$project$Components$Onboard$PracticeUser$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.PN;
        }, _Utils_Tuple2(0, 'Please enter a first name.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.SU;
        }, _Utils_Tuple2(1, 'Please enter a last name.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.af2;
        }, _Utils_Tuple2(3, 'Please enter a password.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Onboard$PracticeUser$validatePasswordConfirmation),
        A2($rtfeldman$elm_validate$Validate$ifFalse, function($) {
            return $.HM;
        }, _Utils_Tuple2(5, 'You must accept our Terms of Service when creating your account.')),
        A2($rtfeldman$elm_validate$Validate$ifFalse, function(subject) {
            return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.nk));
        }, _Utils_Tuple2(3, 'Please enter a secure password.')),
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: false
        }, A2($elm$core$Basics$composeR, function($) {
            return $.OH;
        }, $elm$core$Maybe$Just), _Utils_Tuple2(2, 'Please enter a valid email.'))
    ]));
    var $author$project$Components$Onboard$PracticeUser$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var _v2 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Onboard$PracticeUser$formFieldsUpdate, field, model.PU);
                var newForm = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Onboard$PracticeUser$FormUpdated, cmd), _List_Nil);
            case 1:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Onboard$PracticeUser$formFieldsValidator, model.PU);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var fields = $author$project$Utils$Form$fields(newForm);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A3($author$project$Api$Provider$PracticeOnboarding$User$create, model.Cu.Ej, {
                            OH: fields.OH,
                            PN: fields.PN,
                            SU: fields.SU,
                            afS: model.afS,
                            af2: fields.af2,
                            HM: fields.HM
                        }, $author$project$Components$Onboard$PracticeUser$OnboardingUserCreated),
                        A2($author$project$Ports$LocalStorage$setItem, 'login-email', fields.OH)
                    ])), _List_Nil);
                } else {
                    var newForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment({
                            afS: model.afS
                        })), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Ports$Session$persistRedirect($elm$url$Url$toString(model.Cu.aaT)),
                    $author$project$Ports$Session$authorize({
                        agy: true
                    })
                ])), _List_Nil);
        }
    });
    var $author$project$Pages$Onboard$OnboardId_String$User$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$Onboard$PracticeUser$update, subMsg, model.kL);
                var practiceUserFormModel = _v1.a;
                var practiceUserFormCmd = _v1.b;
                var practiceUserMsg = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    kL: practiceUserFormModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, practiceUserFormCmd), practiceUserMsg);
            case 1:
                var response = msg.a;
                var updatedViewMode = A3($author$project$Pages$Onboard$OnboardId_String$User$determineViewMode, model.m3, response, 0);
                return _Utils_Tuple3(_Utils_update(model, {
                    W5: response,
                    kM: updatedViewMode
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var _v2 = model.W5;
                switch(_v2.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            fW: true
                        }), A3($author$project$Api$Provider$PracticeOnboarding$User$linkExisting, model.Cu.Ej, model.afS, $author$project$Pages$Onboard$OnboardId_String$User$UserLinked), _List_Nil);
                    case 1:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 0, 'Please wait while we load your practice information...')
                        ]));
                    case 2:
                        var error = _v2.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, 'Unable to continue. Please refresh the page and try again.')
                        ]));
                }
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    kM: 0
                }), $author$project$Ports$Session$logout({
                    agy: false
                }), _List_Nil);
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            fW: false
                        }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment({
                            afS: model.afS
                        })), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            fW: false
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            fW: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Components$Onboard$PracticeUser$Save = {
        $: 1
    };
    var $author$project$Components$Onboard$PracticeUser$SignInClicked = {
        $: 3
    };
    var $author$project$Components$Onboard$PracticeUser$Email = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeUser$viewEmail = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$margin(7),
            $author$project$Ui$Form$Group$label('Email'),
            $author$project$Ui$Form$Group$test('email')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(fields.OH),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$Email)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeUser$FirstName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeUser$viewFirstName = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('First Name'),
            $author$project$Ui$Form$Group$test('first-name')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(fields.PN),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$FirstName)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeUser$LastName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeUser$viewLastName = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Last Name'),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$margin(2),
            $author$project$Ui$Form$Group$test('last-name')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(fields.SU),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$LastName)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeUser$Password = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeUser$viewPassword = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Password'),
            $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU))
        ]), _List_fromArray([
            $author$project$Ui$Form$PasswordInput$view(_List_fromArray([
                $author$project$Ui$Form$PasswordInput$placeholder('Password'),
                $author$project$Ui$Form$PasswordInput$value(fields.af2),
                $author$project$Ui$Form$PasswordInput$strengthCheck(fields.nk),
                $author$project$Ui$Form$PasswordInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$Password)),
                $author$project$Ui$Form$PasswordInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                $author$project$Ui$Form$PasswordInput$withFeedback($author$project$Utils$Form$validated(model.PU))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeUser$PasswordConfirmation = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeUser$viewPasswordConfirm = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$labelAbove,
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Password Confirmation'),
            $author$project$Ui$Form$Group$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU))
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('Password Confirmation'),
                $author$project$Ui$Form$Input$password,
                $author$project$Ui$Form$Input$value(fields.rU),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$PasswordConfirmation)),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, model.PU)),
                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 4, model.PU))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeUser$TermsAccepted = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Onboard$PracticeUser$viewTermsAccepted = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(12),
                $author$project$Ui$Form$Group$inputSpanSm(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(fields.HM),
                    $author$project$Ui$Form$Checkbox$required(true),
                    $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Onboard$PracticeUser$FormUpdated, $author$project$Components$Onboard$PracticeUser$TermsAccepted)),
                    $author$project$Ui$Form$Checkbox$errors(A2($author$project$Utils$Form$validationErrors, 5, model.PU))
                ]), _List_fromArray([
                    $elm$html$Html$text('I have read and agree to the '),
                    A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$termsUrl, _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $elm$html$Html$text('Terms of Service')
                    ])),
                    $elm$html$Html$text('.')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Onboard$PracticeUser$viewForm = function(model) {
        return _List_fromArray([
            $author$project$Components$Onboard$PracticeUser$viewFirstName(model),
            $author$project$Components$Onboard$PracticeUser$viewLastName(model),
            $author$project$Components$Onboard$PracticeUser$viewEmail(model),
            $author$project$Components$Onboard$PracticeUser$viewPassword(model),
            $author$project$Components$Onboard$PracticeUser$viewPasswordConfirm(model),
            $author$project$Components$Onboard$PracticeUser$viewTermsAccepted(model),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Submit user'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit,
                    $author$project$Ui$Button$loading(false)
                ]), _List_fromArray([
                    $elm$html$Html$text('Next')
                ]))
            ]))
        ]);
    };
    var $author$project$Components$Onboard$PracticeUser$view = F2(function(_v0, showSignInPrompt) {
        var model = _v0;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$onSubmit($author$project$Components$Onboard$PracticeUser$Save)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$extraPadding
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Create your account')
                    ])),
                    showSignInPrompt ? A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$margin(21),
                        $author$project$Ui$Typography$margin(5)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Already have an account? '),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Sign in to continue'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$Onboard$PracticeUser$SignInClicked)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Sign in to continue')
                        ]))
                    ])) : $elm$html$Html$text('')
                ])), $author$project$Components$Onboard$PracticeUser$viewForm(model)))
            ]))
        ]));
    });
    var $author$project$Pages$Onboard$OnboardId_String$User$ContinueWithExistingUser = {
        $: 2
    };
    var $author$project$Pages$Onboard$OnboardId_String$User$CreateNewUserInstead = {
        $: 3
    };
    var $author$project$Pages$Onboard$OnboardId_String$User$viewExistingUserCard = function(model) {
        return A2($author$project$Ui$Panel$view, _List_fromArray([
            $author$project$Ui$Panel$extraPadding
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = model.m3;
                    if (!_v0.$) {
                        var session = _v0.a;
                        var user = $author$project$Api$Platform$Session$One$user(session);
                        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $author$project$Ui$Typography$heading(_List_fromArray([
                                    $elm$html$Html$text('Confirm the account owner')
                                ])),
                                A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$margin(8)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Account Owner: '),
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$fontWeight(0)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text($author$project$Api$Platform$User$Shared$email(user))
                                    ]))
                                ]))
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textRight,
                                $author$project$Ui$Element$mt4
                            ]), _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Create new owner'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$secondary,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Onboard$OnboardId_String$User$CreateNewUserInstead),
                                    $author$project$Ui$Button$disabled(model.fW)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Create new owner')
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Next'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$primary,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Onboard$OnboardId_String$User$ContinueWithExistingUser),
                                    $author$project$Ui$Button$loading(model.fW),
                                    $author$project$Ui$Button$margin(12)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Next')
                                ]))
                            ]))
                        ]));
                    } else return $elm$html$Html$text('');
                }()
            ]))
        ]));
    };
    var $author$project$Pages$Onboard$OnboardId_String$User$view = function(model) {
        return {
            fb: function() {
                var _v0 = _Utils_Tuple2(model.kM, model.W5);
                _v0$3: while(true)if (!_v0.a) {
                    if (_v0.b.$ === 3) {
                        var _v3 = _v0.a;
                        var _v4 = _v0.b;
                        var practiceOnboarding = _v4.a;
                        var emr = $author$project$Api$Provider$PracticeOnboarding$One$emr(practiceOnboarding);
                        var isClinical = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$isHintClinical, emr));
                        var showSignInPrompt = !isClinical && _Utils_eq(model.m3, $elm$core$Maybe$Nothing);
                        return _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, A2($author$project$Components$Onboard$PracticeUser$view, model.kL, showSignInPrompt))
                        ]);
                    } else break _v0$3;
                } else switch(_v0.b.$){
                    case 3:
                        var _v1 = _v0.a;
                        var _v2 = _v0.b;
                        return _List_fromArray([
                            $author$project$Pages$Onboard$OnboardId_String$User$viewExistingUserCard(model)
                        ]);
                    case 1:
                        var _v5 = _v0.a;
                        var _v6 = _v0.b;
                        return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]))
                        ]);
                    default:
                        break _v0$3;
                }
                return _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Onboard$OnboardId_String$User$PracticeUserMsg, A2($author$project$Components$Onboard$PracticeUser$view, model.kL, false))
                ]);
            }(),
            $2: 'Onboard'
        };
    };
    var $author$project$Pages$Onboard$OnboardId_String$User$page = $author$project$Spa$Page$applicationOnlyPublic({
        aeq: $author$project$Pages$Onboard$OnboardId_String$User$init,
        aeR: $author$project$Pages$Onboard$OnboardId_String$User$load,
        ag3: $author$project$Pages$Onboard$OnboardId_String$User$save,
        ahE: $author$project$Pages$Onboard$OnboardId_String$User$subscriptions,
        aaO: $author$project$Pages$Onboard$OnboardId_String$User$update,
        aid: $author$project$Pages$Onboard$OnboardId_String$User$view
    });
    var $author$project$Pages$Onboarding$PracticePaymentSourcesMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Onboarding$GotApplicationFeePlan = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Onboarding$fetchApplicationFeePlan = function(apiClient) {
        return A2($author$project$Api$Provider$Practice$ApplicationFeePlan$retrieve, apiClient, $author$project$Pages$Onboarding$GotApplicationFeePlan);
    };
    var $author$project$Pages$Onboarding$GotPracticePricing = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Onboarding$fetchPracticePricing = function(apiClient) {
        return A2($author$project$Api$Provider$PracticePricing$retrieve, apiClient, $author$project$Pages$Onboarding$GotPracticePricing);
    };
    var $author$project$Pages$Onboarding$GotBankAccounts = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Onboarding$GotCards = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Onboarding$fetchSources = function(apiClient) {
        return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Onboarding$GotCards),
            A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Pages$Onboarding$GotBankAccounts)
        ]));
    };
    var $author$project$Pages$Onboarding$init = F4(function(session, practice, shared, _v0) {
        var _v1 = A6($author$project$Components$Practice$PaymentSources$init, session, practice, shared.qW, shared.HO, $author$project$Shared$isHintAdmin(shared), shared.sp);
        var practicePaymentSources = _v1.a;
        var practicePaymentSourcesCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            cP: shared.cP,
            mi: $author$project$Api$Data$Loading,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            ck: practicePaymentSources,
            cl: $author$project$Api$Data$Loading,
            Z$: session
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Onboarding$fetchSources(shared.Ej),
            $author$project$Pages$Onboarding$fetchApplicationFeePlan(shared.Ej),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, practicePaymentSourcesCmd),
            $author$project$Pages$Onboarding$fetchPracticePricing(shared.Ej)
        ])));
    });
    var $author$project$Pages$Onboarding$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Onboarding$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Onboarding$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, $author$project$Components$Practice$PaymentSources$subscriptions(model.ck));
    };
    var $author$project$Pages$Onboarding$OnboardingCompleted = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Onboarding$GotPractice = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Onboarding$fetchPractice = function(apiClient) {
        return A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$Onboarding$GotPractice);
    };
    var $author$project$Api$Provider$Practice$onboard = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'onboard'
        ]), $author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Api$Provider$Practice$skipPaymentRequirement = F2(function(apiClient, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('onboarded', $elm$json$Json$Encode$bool(true))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Practice$practicePath)));
    });
    var $author$project$Pages$Onboarding$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    mi: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var dataResponse = msg.a;
                if (dataResponse.$ === 3) {
                    var practice = dataResponse.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        W1: practice
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataResponse));
            case 2:
                var subMsg = msg.a;
                var practicePaymentSourcesResult = A3($author$project$Components$Practice$PaymentSources$update, model.Ej, subMsg, model.ck);
                var cmds = function() {
                    var _v2 = practicePaymentSourcesResult.adu;
                    switch(_v2){
                        case 0:
                            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                $author$project$Pages$Onboarding$fetchSources(model.Ej),
                                $author$project$Pages$Onboarding$fetchPractice(model.Ej)
                            ]));
                        case 2:
                            return $elm$core$Platform$Cmd$none;
                        default:
                            return $elm$core$Platform$Cmd$none;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    ck: practicePaymentSourcesResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, practicePaymentSourcesResult.EQ),
                    cmds
                ])), practicePaymentSourcesResult.at);
            case 3:
                return _Utils_Tuple3(model, function(fn) {
                    return fn($author$project$Pages$Onboarding$OnboardingCompleted);
                }($author$project$Api$Provider$Practice$onboard(model.Ej)), _List_Nil);
            case 4:
                return _Utils_Tuple3(model, A2($author$project$Api$Provider$Practice$skipPaymentRequirement, model.Ej, $author$project$Pages$Onboarding$OnboardingCompleted), _List_Nil);
            case 5:
                var dataResponse = msg.a;
                if (dataResponse.$ === 3) {
                    var practice = dataResponse.a;
                    var paymentProcessingRoute = $author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe' && !A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice) ? $author$project$Spa$Generated$Route$Admin__Stripe : $author$project$Spa$Generated$Route$Admin__PaymentProcessing;
                    return _Utils_Tuple3(_Utils_update(model, {
                        W1: practice
                    }), A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, paymentProcessingRoute), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataResponse));
            case 6:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    cl: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ck: A2($author$project$Components$Practice$PaymentSources$initCards, response, model.ck)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ck: A2($author$project$Components$Practice$PaymentSources$initBankAccounts, response, model.ck)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var label = msg.a;
                var url = msg.b;
                return _Utils_Tuple3(model, A3($author$project$Utils$Analytics$HintBilling$logLinkClickedEvent, model.Z$, label, url), _List_Nil);
        }
    });
    var $author$project$Pages$Onboarding$AnalyticsLinkClicked = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Onboarding$CompleteOnboardingClicked = {
        $: 3
    };
    var $author$project$Pages$Onboarding$SkipPaymentRequirementClicked = {
        $: 4
    };
    var $author$project$Pages$Onboarding$hasAnyPaymentSource = function(model) {
        var _v0 = _Utils_Tuple2(model.pF, model.pQ);
        if (_v0.a.$ === 3 && _v0.b.$ === 3) {
            var _v1 = _v0.a;
            var bankAccounts = _v1.a;
            var _v2 = _v0.b;
            var cards = _v2.a;
            return $elm$core$List$length(bankAccounts) + $elm$core$List$length(cards) > 0;
        } else return false;
    };
    var $author$project$Pages$Onboarding$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, $author$project$Components$Practice$PaymentSources$modal(model.ck)),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Welcome to Hint!')
                ])),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$bold
                        ]), _List_fromArray([
                            $elm$html$Html$text('Payment Sources')
                        ])),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add payment source that will be used for Hint fees')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        function() {
                            var _v0 = _Utils_Tuple2(model.mi, model.cl);
                            _v0$1: while(true){
                                _v0$3: while(true)switch(_v0.a.$){
                                    case 1:
                                        var _v1 = _v0.a;
                                        return $author$project$Components$HintBilling$NextBill$skeleton;
                                    case 3:
                                        switch(_v0.b.$){
                                            case 1:
                                                break _v0$1;
                                            case 3:
                                                var _v3 = _v0.a;
                                                var feePlan_ = _v3.a;
                                                var _v4 = _v0.b;
                                                var practicePricing_ = _v4.a;
                                                return $author$project$Api$Provider$PracticePricing$One$isLegacyPricing(practicePricing_) ? A4($author$project$Components$HintBilling$LegacyPricing$view, model.cP, feePlan_, $author$project$Api$Provider$PracticePricing$One$pmpmFeeInCents(practicePricing_), $author$project$Api$Provider$PracticePricing$One$billableProducts(practicePricing_)) : A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                                    A2($author$project$Components$HintBilling$NextBill$view, practicePricing_, $author$project$Utils$Html$empty),
                                                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                                    A5($author$project$Components$HintBilling$Pricing$view, model.mi, model.cP, $author$project$Api$Provider$Practice$One$hasClinicalAccount(model.W1), $author$project$Pages$Onboarding$AnalyticsLinkClicked, practicePricing_)
                                                ]));
                                            default:
                                                break _v0$3;
                                        }
                                    default:
                                        if (_v0.b.$ === 1) break _v0$1;
                                        else break _v0$3;
                                }
                                return $author$project$Components$HintBilling$NextBill$skeleton;
                            }
                            var _v2 = _v0.b;
                            return $author$project$Components$HintBilling$NextBill$skeleton;
                        }(),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A2($elm$html$Html$map, $author$project$Pages$Onboarding$PracticePaymentSourcesMsg, A2($author$project$Components$Practice$PaymentSources$view, model.ck, false))
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_fromArray([
                        $author$project$Ui$Element$justifyCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Continue to next step'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$disabled(!$author$project$Pages$Onboarding$hasAnyPaymentSource(model.ck)),
                            $author$project$Ui$Button$onClick($author$project$Pages$Onboarding$CompleteOnboardingClicked)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Continue')
                        ])),
                        model.F3 ? A3($author$project$Ui$HinterOnly$button, {
                            abP: 'Skip payment requirement'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Pages$Onboarding$SkipPaymentRequirementClicked)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Skip payment requirement')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]),
            $2: 'Onboarding'
        };
    };
    var $author$project$Pages$Onboarding$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Onboarding$init,
        aeR: $author$project$Pages$Onboarding$load,
        ag3: $author$project$Pages$Onboarding$save,
        ahE: $author$project$Pages$Onboarding$subscriptions,
        aaO: $author$project$Pages$Onboarding$update,
        aid: $author$project$Pages$Onboarding$view
    });
    var $author$project$Spa$Page$applicationPartner = function(page) {
        return {
            aeq: F2(function(shared, url) {
                var _v0 = _Utils_Tuple2(shared.Z$, shared.VW);
                _v0$2: while(true){
                    _v0$4: while(true)switch(_v0.a.$){
                        case 3:
                            switch(_v0.b.$){
                                case 3:
                                    var _v1 = _v0.a;
                                    var session = _v1.a;
                                    var _v2 = _v0.b;
                                    var partner = _v2.a;
                                    return !A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil) : A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4(page.aeq, session, partner, shared, url)));
                                case 2:
                                    break _v0$2;
                                default:
                                    break _v0$4;
                            }
                        case 2:
                            return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                        case 0:
                            if (_v0.b.$ === 2) break _v0$2;
                            else {
                                var _v3 = _v0.a;
                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $author$project$Ports$Session$authorize({
                                    agy: true
                                }), _List_Nil);
                            }
                        default:
                            if (_v0.b.$ === 2) break _v0$2;
                            else break _v0$4;
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aeR: F2(function(shared, model) {
                var _v4 = _Utils_Tuple3(shared.Z$, shared.VW, model);
                _v4$2: while(true){
                    _v4$3: while(true){
                        if (!_v4.c.$) switch(_v4.a.$){
                            case 3:
                                switch(_v4.b.$){
                                    case 3:
                                        var _v5 = _v4.a;
                                        var session = _v5.a;
                                        var _v6 = _v4.b;
                                        var partner = _v6.a;
                                        var url = _v4.c.a;
                                        if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT)) return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                        else {
                                            var _v7 = A4(page.aeq, session, partner, shared, url);
                                            var pageModel = _v7.a;
                                            var cmd = _v7.b;
                                            return _Utils_Tuple3($author$project$Spa$Page$SessionLoaded(pageModel), cmd, _List_Nil);
                                        }
                                    case 2:
                                        break _v4$2;
                                    default:
                                        break _v4$3;
                                }
                            case 2:
                                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                            default:
                                if (_v4.b.$ === 2) break _v4$2;
                                else break _v4$3;
                        }
                        else break _v4$3;
                    }
                    if (model.$ === 1) {
                        var modelWithSession = model.a;
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aeR, shared, _Utils_update(modelWithSession, {
                            Ej: shared.Ej
                        }))));
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            ag3: F2(function(model, shared) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2(page.ag3, modelWithSession, shared);
                } else return shared;
            }),
            ahE: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.ahE(modelWithSession);
                } else return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(msg, model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aaO, msg, modelWithSession));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.aid(modelWithSession);
                } else return {
                    fb: $author$project$Components$BlankPage$view,
                    $2: 'Loading...'
                };
            }
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$Integrations = {
        $: 1
    };
    var $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$Partner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$ManageApiKeys$GotApiKeys = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        };
    };
    var $author$project$Api$Partner$ApiKey$apiKeysPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'api_keys'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$ApiKey$All$ApiKey = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$ApiKey$All$Record = function(integration) {
        return {
            Rn: integration
        };
    };
    var $author$project$Api$Partner$Integration$Shared$Integration = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Integration$Shared$Record = F5(function(id, status, practiceActive, partnerActive, practice) {
        return {
            aef: id,
            VX: partnerActive,
            W1: practice,
            W2: practiceActive,
            ahy: status
        };
    });
    var $author$project$Api$Partner$Practice$Shared$Practice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$Practice$Shared$Record = F2(function(organizationId, hasClinicalAccount) {
        return {
            Ql: hasClinicalAccount,
            afV: organizationId
        };
    });
    var $author$project$Api$Partner$Practice$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_clinical_account', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Shared$Record)));
    var $author$project$Api$Partner$Practice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Practice$Shared$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Practice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Practice$Shared$Practice)));
    var $author$project$Api$Partner$Integration$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Partner$Practice$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_active', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_active', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Integration$Shared$Record))))));
    var $author$project$Api$Partner$Integration$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Integration$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$ApiKey$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration', $elm$json$Json$Decode$nullable($author$project$Api$Partner$Integration$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$All$Record));
    var $author$project$Api$Partner$ApiKey$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$ApiKey$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$ApiKey$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$ApiKey$All$ApiKey)));
    var $author$project$Api$Partner$Common$ApiKey$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Partner$Common$ApiKey$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$Common$ApiKey$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(q) {
                return _List_fromArray([
                    A2($author$project$Api$Param$string, 'q', q)
                ]);
            }, options.agq))
        ]));
    };
    var $author$project$Api$Partner$ApiKey$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$ApiKey$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Common$ApiKey$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$ApiKey$apiKeysPath)));
    });
    var $author$project$Api$Partner$Integration$integrationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'integrations'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Integration$ApiKey$apiKeysPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'api_keys'
    ]), $author$project$Api$Partner$Integration$integrationsPath);
    var $author$project$Api$Partner$Integration$ApiKey$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$ApiKey$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Common$ApiKey$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$ApiKey$apiKeysPath)));
    });
    var $author$project$Components$Partner$ManageApiKeys$fetchApiKeys = F2(function(apiClient, model) {
        var _v0 = model.VM;
        if (!_v0.$) return A3($author$project$Api$Partner$ApiKey$list, apiClient, $author$project$Components$Partner$ManageApiKeys$fetchParams(model), $author$project$Components$Partner$ManageApiKeys$GotApiKeys);
        else return A3($author$project$Api$Partner$Integration$ApiKey$list, apiClient, $author$project$Components$Partner$ManageApiKeys$fetchParams(model), $author$project$Components$Partner$ManageApiKeys$GotApiKeys);
    });
    var $author$project$Components$ResourceFilter$Partner$Integration$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Integration$All$Integration = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Integration$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Integration$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Integration$listDefaults = {
        aef: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Partner$Integration$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$Integration$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v0 = options.aef;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'id', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.agq;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Partner$Integration$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$Integration$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Integration$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$integrationsPath)));
    });
    var $author$project$Components$ResourceFilter$Partner$Integration$list = F3(function(apiClient, optionals, toMsg) {
        return A3($author$project$Api$Partner$Integration$list, apiClient, optionals, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$Integration$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Partner$Integration$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$Integration$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Partner$Integration$list, apiClient, function(d) {
            return _Utils_update(d, {
                agq: $elm$core$Maybe$Just(id)
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$Integration$selectId = 'partner-integrations';
    var $author$project$Api$Partner$Practice$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Partner$Practice$Shared$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Partner$Practice$Min$name(min);
    };
    var $author$project$Api$Partner$Integration$Shared$practice = function(_v0) {
        var record = _v0;
        return record.W1;
    };
    var $author$project$Api$Partner$Integration$All$practice = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Integration$Shared$practice(shared);
    };
    var $author$project$Components$ResourceFilter$Partner$Integration$toTitle = A2($elm$core$Basics$composeR, $author$project$Api$Partner$Integration$All$practice, $author$project$Api$Partner$Practice$Shared$name);
    var $author$project$Components$ResourceFilter$Partner$Integration$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Partner$Integration$toTitle(resource))
        ]);
    };
    var $author$project$Api$Partner$Integration$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$Integration$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Integration$Shared$id(shared);
    };
    var $author$project$Components$ResourceFilter$Partner$Integration$toValue = $author$project$Api$Partner$Integration$All$id;
    var $author$project$Components$ResourceFilter$Partner$Integration$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Partner$Integration$fetchResources,
            aef: $author$project$Components$ResourceFilter$Partner$Integration$selectId,
            gD: 'Integrations',
            sz: $author$project$Components$ResourceFilter$Partner$Integration$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$Partner$Integration$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Partner$Integration$toTitle,
            g4: $author$project$Components$ResourceFilter$Partner$Integration$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Api$Sort$withPrefix = F2(function(prefix, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            sg: prefix
        });
    });
    var $author$project$Components$Partner$ManageApiKeys$init = F4(function(apiClient, timeFormatter, owner, query) {
        var prefix = function() {
            if (!owner.$) return 'partner_';
            else return 'integrations_';
        }();
        var q = A2($elm$core$Dict$get, prefix + 'q', query);
        var _v0 = A2($author$project$Components$ResourceFilter$Partner$Integration$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Practice'
            });
        });
        var integrationResourceFilter = _v0.a;
        var integrationResourceFilterCmd = _v0.b;
        var model = {
            bQ: $author$project$Api$Data$Loading,
            $8: $elm$core$Maybe$Nothing,
            mA: integrationResourceFilter,
            F6: $elm$core$Maybe$Nothing,
            VM: owner,
            af_: A2($author$project$Api$Pagination$fromQuery, query, A2($author$project$Api$Pagination$withPrefix, prefix, $author$project$Api$Pagination$init)),
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 1, A2($author$project$Api$Sort$fromQuery, query, A2($author$project$Api$Sort$withPrefix, prefix, $author$project$Api$Sort$init))),
            HO: timeFormatter,
            bI: $elm$core$Set$empty,
            dq: $elm$core$Set$empty
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg, integrationResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$Partner$ApiKeys$init = F4(function(_v0, partner, shared, _v1) {
        var query = _v1.Bz;
        var _v2 = A4($author$project$Components$Partner$ManageApiKeys$init, shared.Ej, shared.HO, $author$project$Components$Partner$ManageApiKeys$Integrations, query);
        var manageIntegrationsApiKeys = _v2.a;
        var manageIntegrationsApiKeysCmd = _v2.b;
        var _v3 = A4($author$project$Components$Partner$ManageApiKeys$init, shared.Ej, shared.HO, $author$project$Components$Partner$ManageApiKeys$Partner(partner), query);
        var manageGlobalApiKeys = _v3.a;
        var manageGlobalApiKeysCmd = _v3.b;
        var model = {
            Ej: shared.Ej,
            mZ: manageGlobalApiKeys,
            m$: manageIntegrationsApiKeys
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg, manageGlobalApiKeysCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg, manageIntegrationsApiKeysCmd)
        ])));
    });
    var $author$project$Pages$Partner$ApiKeys$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$ApiKeys$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Partner$ManageApiKeys$CancelEdit = {
        $: 6
    };
    var $author$project$Components$ResourceFilter$Partner$Integration$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Partner$ManageApiKeys$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManageApiKeys$CancelEdit)), model.F6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg, $author$project$Components$ResourceFilter$Partner$Integration$subscriptions(model.mA))
        ]));
    };
    var $author$project$Pages$Partner$ApiKeys$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg, $author$project$Components$Partner$ManageApiKeys$subscriptions(model.mZ)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg, $author$project$Components$Partner$ManageApiKeys$subscriptions(model.m$))
        ]));
    };
    var $author$project$Components$Partner$ManageApiKeys$IntegrationField = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$OutMsg$RefreshPartner = {
        $: 3
    };
    var $author$project$Components$Partner$ManageApiKeys$SearchInputMsg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$WebhooksSignatureApiKeyUpdated = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$ManageApiKeys$Deleted = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$ApiKey$apiKeyPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Partner$ApiKey$apiKeysPath);
    };
    var $author$project$Api$Partner$ApiKey$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$ApiKey$apiKeyPath(id)));
    });
    var $author$project$Api$Partner$Integration$ApiKey$apiKeyPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Partner$Integration$ApiKey$apiKeysPath);
    };
    var $author$project$Api$Partner$Integration$ApiKey$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$ApiKey$apiKeyPath(id)));
    });
    var $author$project$Api$Partner$ApiKey$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$ApiKey$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$ApiKey$Shared$id(shared);
    };
    var $author$project$Components$Partner$ManageApiKeys$deleteItem = F3(function(apiClient, owner, item) {
        if (!owner.$) return A3($author$project$Api$Partner$ApiKey$delete, apiClient, $author$project$Api$Partner$ApiKey$All$id(item), $author$project$Components$Partner$ManageApiKeys$Deleted(item));
        else return A3($author$project$Api$Partner$Integration$ApiKey$delete, apiClient, $author$project$Api$Partner$ApiKey$All$id(item), $author$project$Components$Partner$ManageApiKeys$Deleted(item));
    });
    var $author$project$Api$Partner$ApiKey$All$integration = function(_v0) {
        var record = _v0.b;
        return record.Rn;
    };
    var $author$project$Api$Partner$ApiKey$Shared$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Partner$ApiKey$All$label = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$ApiKey$Shared$label(shared);
    };
    var $author$project$Components$Partner$ManageApiKeys$formFieldsFromItem = function(apiKey) {
        return _Utils_Tuple2({
            Rn: A2($elm$core$Maybe$map, $author$project$Api$Partner$Integration$Shared$id, $author$project$Api$Partner$ApiKey$All$integration(apiKey)),
            aeI: $author$project$Api$Partner$ApiKey$All$label(apiKey)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Components$Partner$ManageApiKeys$formFieldsInit = _Utils_Tuple2({
        Rn: $elm$core$Maybe$Nothing,
        aeI: $elm$core$Maybe$Nothing
    }, $elm$core$Platform$Cmd$none);
    var $author$project$Components$Partner$ManageApiKeys$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                aeI: $author$project$Utils$String$toMaybe(string)
            });
        } else {
            var integration = field.a;
            return _Utils_update(fields, {
                Rn: integration
            });
        }
    });
    var $author$project$Components$Partner$ManageApiKeys$IntegrationValidation = 0;
    var $author$project$Components$Partner$ManageApiKeys$validateIntegration = F2(function(owner, fields) {
        if (!owner.$) return _List_Nil;
        else return _Utils_eq(fields.Rn, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(0, 'Practice is required')
        ]) : _List_Nil;
    });
    var $author$project$Components$Partner$ManageApiKeys$formFieldsValidator = function(owner) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManageApiKeys$validateIntegration(owner))
        ]));
    };
    var $author$project$Components$Partner$ManageApiKeys$Created = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Partner$ApiKey$One$ApiKey = 0;
    var $author$project$Api$Partner$ApiKey$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Partner$ApiKey$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('api_key', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$ApiKey$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$ApiKey$apiKeysPath)));
    });
    var $author$project$Api$Partner$Integration$ApiKey$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('api_key', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aeI)),
                _Utils_Tuple2('integration', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.Rn))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$ApiKey$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$ApiKey$apiKeysPath)));
    });
    var $author$project$Components$Partner$ManageApiKeys$integrationApiKeyApiFields = function(fields) {
        return {
            Rn: fields.Rn,
            aeI: fields.aeI
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$partnerApiKeyApiFields = function(fields) {
        return {
            aeI: fields.aeI
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$createItem = F3(function(apiClient, owner, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        if (!owner.$) return A3($author$project$Api$Partner$ApiKey$create, apiClient, $author$project$Components$Partner$ManageApiKeys$partnerApiKeyApiFields(fields), $author$project$Components$Partner$ManageApiKeys$Created);
        else return A3($author$project$Api$Partner$Integration$ApiKey$create, apiClient, $author$project$Components$Partner$ManageApiKeys$integrationApiKeyApiFields(fields), $author$project$Components$Partner$ManageApiKeys$Created);
    });
    var $author$project$Components$Partner$ManageApiKeys$Updated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Partner$ApiKey$update = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('api_key', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$ApiKey$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$ApiKey$apiKeyPath(id))));
    });
    var $author$project$Api$Partner$Integration$ApiKey$update = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('api_key', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aeI))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$ApiKey$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$ApiKey$apiKeyPath(id))));
    });
    var $author$project$Components$Partner$ManageApiKeys$updateItem = F4(function(apiClient, owner, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        if (!owner.$) return A4($author$project$Api$Partner$ApiKey$update, apiClient, id, {
            aeI: fields.aeI
        }, $author$project$Components$Partner$ManageApiKeys$Updated);
        else return A4($author$project$Api$Partner$Integration$ApiKey$update, apiClient, id, {
            aeI: fields.aeI
        }, $author$project$Components$Partner$ManageApiKeys$Updated);
    });
    var $author$project$Components$Partner$ManageApiKeys$saveItem = F4(function(apiClient, owner, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A4($author$project$Components$Partner$ManageApiKeys$updateItem, apiClient, owner, id_, formFields);
        } else return A3($author$project$Components$Partner$ManageApiKeys$createItem, apiClient, owner, formFields);
    });
    var $author$project$Components$ResourceFilter$Partner$Integration$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$ && !_v1.a.$) {
                var selected = _v1.a.a;
                return _Utils_update(model, {
                    Hg: selected
                });
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Partner$ManageApiKeys$qKey = function(owner) {
        if (!owner.$) return 'partner_q';
        else return 'integrations_q';
    };
    var $author$project$Components$Partner$ManageApiKeys$updateUrl = function(model) {
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__ApiKeys)
        ]), _Utils_ap(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string($author$project$Components$Partner$ManageApiKeys$qKey(model.VM)), model.agq)
        ])), _Utils_ap($author$project$Api$Sort$toQuery(model.ahs), $author$project$Api$Pagination$toPageQuery(model.af_)))));
    };
    var $author$project$Api$Partner$Partner$updateWebhooksSignatureApiKey = F3(function(apiClient, id, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhooks_signature_api_key', $author$project$Utils$Encode$association(id))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$Partner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'webhooks_signature_api_key'
        ]), $author$project$Api$Partner$Partner$partnerPath))));
    });
    var $author$project$Components$ResourceFilter$Partner$Integration$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Partner$ManageApiKeys$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bQ: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    bQ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    bQ: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, newModel),
                    $author$project$Components$Partner$ManageApiKeys$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    bQ: $author$project$Api$Data$Loading,
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, newModel),
                    $author$project$Components$Partner$ManageApiKeys$updateUrl(newModel)
                ])), _List_Nil);
            case 14:
                var tokenStr = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(tokenStr), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard.')
                ]));
            case 3:
                var id = msg.a;
                var visibleApiKeyTokens = A2($elm$core$Set$member, id, model.dq) ? A2($elm$core$Set$remove, id, model.dq) : A2($elm$core$Set$insert, id, model.dq);
                return _Utils_Tuple3(_Utils_update(model, {
                    dq: visibleApiKeyTokens
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var _v3 = $author$project$Components$Partner$ManageApiKeys$formFieldsInit;
                var formFields = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 5:
                var item = msg.a;
                var _v4 = $author$project$Components$Partner$ManageApiKeys$formFieldsFromItem(item);
                var formFields = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(item), $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var field = msg.a;
                var _v5 = model.F6;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var id = _v6.a;
                    var form = _v6.b;
                    var request = _v6.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManageApiKeys$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var item = msg.a;
                var form = msg.b;
                var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManageApiKeys$formFieldsValidator(model.VM), form);
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var validatedForm = _v8.a;
                    var validFormFields = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
                    }), A4($author$project$Components$Partner$ManageApiKeys$saveItem, apiClient, model.VM, A2($elm$core$Maybe$map, $author$project$Api$Partner$ApiKey$All$id, item), validFormFields), _List_Nil);
                } else {
                    var validatedForm = _v7.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 9:
                var response = msg.a;
                var _v9 = model.F6;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        bQ: $author$project$Api$Data$Loading,
                        F6: $elm$core$Maybe$Nothing
                    }), A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Successfully created api key'),
                        $author$project$OutMsg$RefreshPartner
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var response = msg.a;
                var _v12 = model.F6;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var id = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        bQ: $author$project$Api$Data$Loading,
                        F6: $elm$core$Maybe$Nothing
                    }), A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated api key')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var item = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Just(item)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var item = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Partner$ApiKey$All$id(item);
                    return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Nothing,
                        bI: A2($elm$core$Set$insert, id, model.bI)
                    }), A3($author$project$Components$Partner$ManageApiKeys$deleteItem, apiClient, model.VM, item), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var item = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            bQ: $author$project$Api$Data$Loading,
                            bI: A2($elm$core$Set$remove, $author$project$Api$Partner$ApiKey$All$id(item), model.bI)
                        }), A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Api key was successfully removed.'),
                            $author$project$OutMsg$RefreshPartner
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            bI: A2($elm$core$Set$remove, $author$project$Api$Partner$ApiKey$All$id(item), model.bI)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 15:
                var item = msg.a;
                var _v16 = model.VM;
                if (!_v16.$) return _Utils_Tuple3(_Utils_update(model, {
                    bI: A2($elm$core$Set$insert, $author$project$Api$Partner$ApiKey$All$id(item), model.bI)
                }), A3($author$project$Api$Partner$Partner$updateWebhooksSignatureApiKey, apiClient, $author$project$Api$Partner$ApiKey$All$id(item), $author$project$Components$Partner$ManageApiKeys$WebhooksSignatureApiKeyUpdated(item)), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var item = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        var partner = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bQ: $author$project$Api$Data$Loading,
                            VM: $author$project$Components$Partner$ManageApiKeys$Partner(partner),
                            bI: A2($elm$core$Set$remove, $author$project$Api$Partner$ApiKey$All$id(item), model.bI)
                        }), A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated webhooks signature api key')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            bI: A2($elm$core$Set$remove, $author$project$Api$Partner$ApiKey$All$id(item), model.bI)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 17:
                var subMsg = msg.a;
                var integrationResourceResult = A3($author$project$Components$ResourceFilter$Partner$Integration$update, apiClient, subMsg, model.mA);
                var item = function() {
                    var _v18 = _Utils_Tuple2(model.F6, integrationResourceResult.adu);
                    if (!_v18.a.$) {
                        if (!_v18.b.$ && !_v18.b.a.$) {
                            var _v19 = _v18.a.a;
                            var id = _v19.a;
                            var form = _v19.b;
                            var request = _v19.c;
                            var updatedForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManageApiKeys$formFieldsUpdate, $author$project$Components$Partner$ManageApiKeys$IntegrationField($author$project$Components$ResourceFilter$Partner$Integration$value(integrationResourceResult.zi)), form);
                            return $elm$core$Maybe$Just(_Utils_Tuple3(id, updatedForm, request));
                        } else {
                            var item_ = _v18.a.a;
                            return $elm$core$Maybe$Just(item_);
                        }
                    } else {
                        var _v20 = _v18.a;
                        return $elm$core$Maybe$Nothing;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    mA: integrationResourceResult.zi,
                    F6: item
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg, integrationResourceResult.EQ), integrationResourceResult.at);
            default:
                var subMsg = msg.a;
                var _v21 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v21.a;
                var searchInputCmd = _v21.b;
                var searchInputEvent = _v21.c;
                if (searchInputEvent.$ === 1) {
                    var q = searchInputEvent.a;
                    var newModel = _Utils_update(model, {
                        bQ: $author$project$Api$Data$Loading,
                        af_: $author$project$Api$Pagination$reset(model.af_),
                        agq: q,
                        sG: searchInput
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$SearchInputMsg, searchInputCmd),
                        A2($author$project$Components$Partner$ManageApiKeys$fetchApiKeys, apiClient, newModel),
                        $author$project$Components$Partner$ManageApiKeys$updateUrl(newModel)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    sG: searchInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageApiKeys$SearchInputMsg, searchInputCmd), _List_Nil);
        }
    });
    var $author$project$Pages$Partner$ApiKeys$update = F2(function(msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var _v1 = A3($author$project$Components$Partner$ManageApiKeys$update, model.Ej, subMsg, model.mZ);
            var manageGlobalApiKeys = _v1.a;
            var manageGlobalApiKeysCmd = _v1.b;
            var manageGlobalApiKeysOutMsgs = _v1.c;
            return _Utils_Tuple3(_Utils_update(model, {
                mZ: manageGlobalApiKeys
            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg, manageGlobalApiKeysCmd), manageGlobalApiKeysOutMsgs);
        } else {
            var subMsg = msg.a;
            var _v2 = A3($author$project$Components$Partner$ManageApiKeys$update, model.Ej, subMsg, model.m$);
            var manageIntegrationsApiKeys = _v2.a;
            var manageIntegrationsApiKeysCmd = _v2.b;
            var manageIntegrationsApiKeysOutMsgs = _v2.c;
            return _Utils_Tuple3(_Utils_update(model, {
                m$: manageIntegrationsApiKeys
            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg, manageIntegrationsApiKeysCmd), manageIntegrationsApiKeysOutMsgs);
        }
    });
    var $author$project$Components$Partner$ManageApiKeys$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$ManageApiKeys$New = {
        $: 4
    };
    var $author$project$Components$Partner$ManageApiKeys$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$FormUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$Label = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$Save = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Components$ResourceFilter$Partner$Integration$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Partner$ManageApiKeys$viewCreateEditModal = F5(function(owner, integrationResourceFilter, item, form, request) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Api Key',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: A2($elm$core$Maybe$map, $author$project$Api$Partner$ApiKey$All$id, item),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Partner$ManageApiKeys$CancelEdit,
            Vn: $elm$core$Basics$always(A2($author$project$Components$Partner$ManageApiKeys$Save, item, form))
        };
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            function() {
                if (!owner.$) return $author$project$Utils$Html$empty;
                else return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Practice')
                ]), _List_fromArray([
                    function() {
                        if (!item.$) {
                            var item_ = item.a;
                            return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Partner$Practice$Shared$name, A2($elm$core$Maybe$map, $author$project$Api$Partner$Integration$Shared$practice, $author$project$Api$Partner$ApiKey$All$integration(item_)))))
                            ]));
                        } else return A2($elm$html$Html$map, $author$project$Components$Partner$ManageApiKeys$IntegrationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Partner$Integration$viewNew, _List_fromArray([
                            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                        ]), integrationResourceFilter));
                    }()
                ]));
            }(),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Label')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.aeI)),
                    $author$project$Ui$Form$Input$placeholder('Optional label'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManageApiKeys$FormUpdated, $author$project$Components$Partner$ManageApiKeys$Label))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Partner$ManageApiKeys$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$columns = function(owner) {
        return _Utils_ap(function() {
            if (!owner.$) return _List_Nil;
            else return _List_fromArray([
                A3($author$project$Api$Column$init, 'name', true, 'Practice')
            ]);
        }(), _List_fromArray([
            A3($author$project$Api$Column$init, 'label', true, 'Label'),
            A3($author$project$Api$Column$init, 'token', true, 'Token'),
            A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
            A3($author$project$Api$Column$init, 'last_used_at', true, 'Last Used At'),
            A3($author$project$Api$Column$init, 'deactivated_at', true, 'Deactivated At')
        ]));
    };
    var $author$project$Components$Partner$ManageApiKeys$CopyToken = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$ToggleApiKey = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$UseForWebhooksSignature = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Api$Partner$ApiKey$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Partner$ApiKey$All$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$ApiKey$Shared$createdAt(shared);
    };
    var $author$project$Api$Partner$ApiKey$Shared$deactivatedAt = function(_v0) {
        var record = _v0;
        return record.Ni;
    };
    var $author$project$Api$Partner$ApiKey$All$deactivatedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$ApiKey$Shared$deactivatedAt(shared);
    };
    var $author$project$Api$Partner$ApiKey$Shared$lastUsedAt = function(_v0) {
        var record = _v0;
        return record.S$;
    };
    var $author$project$Api$Partner$ApiKey$All$lastUsedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$ApiKey$Shared$lastUsedAt(shared);
    };
    var $author$project$Api$Partner$ApiKey$Shared$token = function(_v0) {
        var record = _v0;
        return record.aaf;
    };
    var $author$project$Api$Partner$ApiKey$All$token = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$ApiKey$Shared$token(shared);
    };
    var $author$project$Components$Partner$ManageApiKeys$Delete = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$viewDeleteButton = F3(function(disabled, loading, apiKey) {
        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$active(disabled),
            $author$project$Ui$Tooltip$padding(2)
        ]), "Can\u2019t remove the api key being used for the webhooks signature.", _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Delete api key'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$loading(loading),
                $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageApiKeys$Delete(apiKey)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                $author$project$Ui$Button$disabled(disabled)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete')
            ]))
        ]));
    });
    var $author$project$Components$Partner$ManageApiKeys$Edit = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageApiKeys$viewEditButton = F2(function(loading, apiKey) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Edit api key'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageApiKeys$Edit(apiKey)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
            $author$project$Ui$Button$loading(loading)
        ]), _List_fromArray([
            $elm$html$Html$text('Edit')
        ]));
    });
    var $author$project$Api$Partner$Partner$One$webhooksSignatureApiKey = function(_v0) {
        var record = _v0.b;
        return record.abm;
    };
    var $author$project$Components$Partner$ManageApiKeys$viewApiKey = F5(function(timeFormatter, owner, updatingItems, visibleApiKeyTokens, apiKey) {
        var id = $author$project$Api$Partner$ApiKey$All$id(apiKey);
        var loading = A2($elm$core$Set$member, id, updatingItems);
        var visible = A2($elm$core$Set$member, id, visibleApiKeyTokens);
        var _v0 = visible ? _Utils_Tuple2($author$project$Ui$Icon$visibilityOff, 'Hide api key') : _Utils_Tuple2($author$project$Ui$Icon$visibility, 'Show api key');
        var visibleIcon = _v0.a;
        var ariaLabel = _v0.b;
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            function() {
                if (!owner.$) return _List_Nil;
                else return _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Partner$Practice$Shared$name, A2($elm$core$Maybe$map, $author$project$Api$Partner$Integration$Shared$practice, $author$project$Api$Partner$ApiKey$All$integration(apiKey)))))
                    ]))
                ]);
            }(),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Partner$ApiKey$All$label(apiKey)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), visible ? _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Partner$ApiKey$All$token(apiKey))
                    ]) : _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$String$repeat, $elm$core$String$length($author$project$Api$Partner$ApiKey$All$token(apiKey)) - 4, '*')),
                        $elm$html$Html$text(A2($elm$core$String$right, 4, $author$project$Api$Partner$ApiKey$All$token(apiKey)))
                    ])),
                    $author$project$Utils$Html$noBreakSpace,
                    A3($author$project$Ui$Button$view, {
                        abP: ariaLabel
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageApiKeys$ToggleApiKey(id)),
                        $author$project$Ui$Button$icon(visibleIcon)
                    ]), _List_Nil),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Copy api key'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageApiKeys$CopyToken($author$project$Api$Partner$ApiKey$All$token(apiKey))),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                    ]), _List_Nil)
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Partner$ApiKey$All$createdAt(apiKey)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, timeFormatter(0), $author$project$Api$Partner$ApiKey$All$lastUsedAt(apiKey))))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, timeFormatter(0), $author$project$Api$Partner$ApiKey$All$deactivatedAt(apiKey))))
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$textRight
                ]), function() {
                    if (!owner.$) {
                        var partner = owner.a;
                        var isWebhooksSignatureApiKey = _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Partner$ApiKey$Shared$id, $author$project$Api$Partner$Partner$One$webhooksSignatureApiKey(partner)), $elm$core$Maybe$Just(id));
                        return isWebhooksSignatureApiKey ? _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$padding(2)
                            ]), _List_fromArray([
                                $author$project$Utils$Html$noBreakSpace,
                                A2($author$project$Ui$Badge$view, _List_fromArray([
                                    $author$project$Ui$Badge$info
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Webhooks Signature')
                                ]))
                            ])),
                            A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
                            A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, true, loading, apiKey)
                        ]) : _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Use api key for webhooks signature'
                            }, _List_fromArray([
                                $author$project$Ui$Button$secondary,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageApiKeys$UseForWebhooksSignature(apiKey)),
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Use for webhooks signature')
                            ])),
                            A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
                            A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, false, loading, apiKey)
                        ]);
                    } else return _List_fromArray([
                        A2($author$project$Components$Partner$ManageApiKeys$viewEditButton, loading, apiKey),
                        A3($author$project$Components$Partner$ManageApiKeys$viewDeleteButton, false, loading, apiKey)
                    ]);
                }())
            ])
        ])));
    });
    var $author$project$Components$Partner$ManageApiKeys$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.bQ;
            if (_v1.$ === 3) {
                var apiKeys_ = _v1.a;
                return _Utils_Tuple2(false, apiKeys_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var apiKeys = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any api keys')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Partner$ManageApiKeys$SortTable)), $author$project$Components$Partner$ManageApiKeys$columns(model.VM)), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ])), A2($elm$core$List$map, A4($author$project$Components$Partner$ManageApiKeys$viewApiKey, model.HO, model.VM, model.bI, model.dq), apiKeys), _List_Nil);
    };
    var $author$project$Components$Partner$ManageApiKeys$view = function(_v0) {
        var model = _v0;
        var loading = function() {
            var _v6 = model.bQ;
            if (_v6.$ === 3) return false;
            else return true;
        }();
        return _List_fromArray([
            function() {
                var _v1 = model.F6;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var item = _v2.a;
                    var form = _v2.b;
                    var request = _v2.c;
                    return A5($author$project$Components$Partner$ManageApiKeys$viewCreateEditModal, model.VM, model.mA, item, form, request);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.$8;
                if (!_v3.$) {
                    var item = _v3.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManageApiKeys$HiConfirmClosed(item), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('api key')
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        function() {
                            var _v4 = model.VM;
                            if (!_v4.$) return $elm$html$Html$text('Partner Api Keys');
                            else return $elm$html$Html$text('Practices Api Keys');
                        }()
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add new api key'
                        }, _List_fromArray([
                            $author$project$Ui$Button$default,
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageApiKeys$New),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('New Api Key')
                        ]))
                    ])),
                    function() {
                        var _v5 = model.VM;
                        if (!_v5.$) return $author$project$Utils$Html$empty;
                        else return A2($elm$html$Html$map, $author$project$Components$Partner$ManageApiKeys$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                            $author$project$Ui$SearchInput$placeholder('Search by practice name')
                        ]), model.sG));
                    }()
                ])),
                $author$project$Components$Partner$ManageApiKeys$viewTable(model),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Partner$ManageApiKeys$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(loading)
                    ]), model.af_))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Partner$ApiKeys$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$ApiKeys$ManageGlobalApiKeysMsg), $author$project$Components$Partner$ManageApiKeys$view(model.mZ))),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$ApiKeys$ManageIntegrationsApiKeysMsg), $author$project$Components$Partner$ManageApiKeys$view(model.m$)))
                ]))
            ]),
            $2: 'Partner | Api Keys'
        };
    };
    var $author$project$Pages$Partner$ApiKeys$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$ApiKeys$init,
        aeR: $author$project$Pages$Partner$ApiKeys$load,
        ag3: $author$project$Pages$Partner$ApiKeys$save,
        ahE: $author$project$Pages$Partner$ApiKeys$subscriptions,
        aaO: $author$project$Pages$Partner$ApiKeys$update,
        aid: $author$project$Pages$Partner$ApiKeys$view
    });
    var $author$project$Pages$Partner$Billing$GotAccount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$RainforestAccount$One$RainforestAccount = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$RainforestAccount$Shared$RainforestAccount = $elm$core$Basics$identity;
    var $author$project$Api$Partner$RainforestAccount$Shared$Record = function(status) {
        return {
            ahy: status
        };
    };
    var $author$project$Api$Partner$RainforestAccount$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$Shared$Record));
    var $author$project$Api$Partner$RainforestAccount$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$RainforestAccount$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$RainforestAccount$One$Record = F8(function(merchantId, merchantApplicationId, merchantApplicationStatus, statementDescriptor, depositAccountLast4, depositAccountRoutingNumber, depositAccountBankName, depositAccountAccountType) {
        return {
            NM: depositAccountAccountType,
            NN: depositAccountBankName,
            NO: depositAccountLast4,
            NP: depositAccountRoutingNumber,
            T9: merchantApplicationId,
            Ua: merchantApplicationStatus,
            Ub: merchantId,
            _5: statementDescriptor
        };
    });
    var $author$project$Api$Partner$RainforestAccount$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_account_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_bank_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_routing_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit_account_last_4', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'statement_descriptor', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'merchant_application_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'merchant_application_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'merchant_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$One$Record)))))))));
    var $author$project$Api$Partner$RainforestAccount$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$RainforestAccount$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$RainforestAccount$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$RainforestAccount$One$RainforestAccount)));
    var $author$project$Api$Partner$RainforestAccount$rainforestAccountPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'rainforest_account'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$RainforestAccount$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Partner$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
    });
    var $author$project$Pages$Partner$Billing$init = F4(function(_v0, partner, shared, _v1) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            fr: $author$project$Api$Data$NotAsked,
            F3: $author$project$Shared$isHintAdmin(shared),
            y4: false,
            VW: partner,
            cn: $author$project$Api$Data$Loading,
            BC: $author$project$Rainforest$isSandbox(shared.sp),
            jT: $elm$core$Maybe$Nothing,
            Ct: $elm$core$Maybe$Nothing,
            kd: $elm$core$Maybe$Nothing,
            oJ: $author$project$Api$Data$NotAsked
        }, A2($author$project$Api$Partner$RainforestAccount$retrieve, shared.Ej, $author$project$Pages$Partner$Billing$GotAccount));
    });
    var $author$project$Pages$Partner$Billing$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Billing$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Billing$ResetAccountModalMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$SimulateApplicationEventModal$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg)), model.kd)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$ResetAccountModal$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Partner$Billing$ResetAccountModalMsg)), model.jT))
        ]));
    };
    var $author$project$Pages$Partner$Billing$GotCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$GotDeleteRainforestAccount = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$GotSetupSessionKey = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$PrefilledWithFakeData = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Synced = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Partner$RainforestAccount$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
    });
    var $author$project$Api$Partner$RainforestAccount$delete = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$RainforestAccount$rainforestAccountPath));
    });
    var $author$project$Api$Partner$RainforestAccount$fakePrefill = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'fake_prefill'
        ]), $author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Api$Partner$RainforestAccount$reset = F3(function(apiClient, merchantName, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('merchant_name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, merchantName))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$RainforestAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reset'
        ]), $author$project$Api$Partner$RainforestAccount$rainforestAccountPath))));
    });
    var $author$project$Api$Partner$RainforestAccount$One$record = function(_v0) {
        var record_ = _v0.b;
        return record_;
    };
    var $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$One$record, function($) {
        return $.Ua;
    });
    var $author$project$Api$Partner$RainforestAccount$setup = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, A2($elm$json$Json$Decode$field, 'session_key', $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'setup'
        ]), $author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Pages$Partner$Billing$retrieveSetupSessionKey = F2(function(apiClient, rainforestAccount) {
        return $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount) !== 'completed' ? A2($author$project$Api$Partner$RainforestAccount$setup, apiClient, $author$project$Pages$Partner$Billing$GotSetupSessionKey) : $elm$core$Platform$Cmd$none;
    });
    var $author$project$Api$Partner$RainforestAccount$simulateStatusChange = F4(function(apiClient, status, reviewTypes, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('status', $elm$json$Json$Encode$string(status)),
            _Utils_Tuple2('review_types', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, reviewTypes))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$RainforestAccount$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'simulate_status_change'
        ]), $author$project$Api$Partner$RainforestAccount$rainforestAccountPath))));
    });
    var $author$project$Api$Partner$RainforestAccount$sync = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$RainforestAccount$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'sync'
        ]), $author$project$Api$Partner$RainforestAccount$rainforestAccountPath)));
    });
    var $author$project$Pages$Partner$Billing$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        var rainforestAccount = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            cn: response
                        }), A2($author$project$Pages$Partner$Billing$retrieveSetupSessionKey, model.Ej, rainforestAccount), _List_Nil);
                    case 2:
                        if (response.a.$ === 5) {
                            var _v2 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                cn: response
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    cn: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(model, A2($author$project$Api$Partner$RainforestAccount$create, model.Ej, $author$project$Pages$Partner$Billing$GotCreated), _List_Nil);
            case 2:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    cn: response
                }), A2($author$project$Api$Partner$RainforestAccount$setup, model.Ej, $author$project$Pages$Partner$Billing$GotSetupSessionKey), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var sessionKey = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Ct: $elm$core$Maybe$Just(sessionKey)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    y4: true
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Payment Processing Application submitted')
                ]));
            case 7:
                var _v5 = $author$project$Components$Rainforest$SimulateApplicationEventModal$init($author$project$Api$Partner$RainforestAccount$simulateStatusChange);
                var simulateApplicationEventModal = _v5.a;
                var simulateApplicationEventModalCmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    kd: $elm$core$Maybe$Just(simulateApplicationEventModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg, simulateApplicationEventModalCmd), _List_Nil);
            case 8:
                var simulateApplicationEventModalMsg = msg.a;
                var _v6 = model.kd;
                if (!_v6.$) {
                    var simulateApplicationEventModal = _v6.a;
                    var simulateApplicationEventModalResult = A3($author$project$Components$Rainforest$SimulateApplicationEventModal$update, model.Ej, simulateApplicationEventModalMsg, simulateApplicationEventModal);
                    var simulateApplicationEventModal_ = function() {
                        var _v7 = simulateApplicationEventModalResult.adu;
                        switch(_v7){
                            case 1:
                                return $elm$core$Maybe$Nothing;
                            case 2:
                                return $elm$core$Maybe$Just(simulateApplicationEventModalResult.zi);
                            default:
                                return $elm$core$Maybe$Just(simulateApplicationEventModalResult.zi);
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        kd: simulateApplicationEventModal_
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg, simulateApplicationEventModalResult.EQ), simulateApplicationEventModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var _v8 = $author$project$Components$Rainforest$ResetAccountModal$init($author$project$Api$Partner$RainforestAccount$reset);
                var resetAccountModal = _v8.a;
                var resetAccountModalCmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    jT: $elm$core$Maybe$Just(resetAccountModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$ResetAccountModalMsg, resetAccountModalCmd), _List_Nil);
            case 6:
                var resetAccountModalMsg = msg.a;
                var _v9 = model.jT;
                if (!_v9.$) {
                    var resetAccountModal = _v9.a;
                    var resetAccountModalResult = A3($author$project$Components$Rainforest$ResetAccountModal$update, model.Ej, resetAccountModalMsg, resetAccountModal);
                    var _v10 = function() {
                        var _v11 = resetAccountModalResult.adu;
                        switch(_v11.$){
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, model.cn);
                            case 2:
                                var rainforestAccountResponse = _v11.b;
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, rainforestAccountResponse);
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Just(resetAccountModalResult.zi), model.cn);
                        }
                    }();
                    var resetAccountModal_ = _v10.a;
                    var rainforestAccount = _v10.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cn: rainforestAccount,
                        jT: resetAccountModal_
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$ResetAccountModalMsg, resetAccountModalResult.EQ), resetAccountModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                return _Utils_Tuple3(_Utils_update(model, {
                    oJ: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Partner$RainforestAccount$sync, model.Ej, $author$project$Pages$Partner$Billing$Synced), _List_Nil);
            case 10:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    cn: response,
                    oJ: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Sync with Rainforest was successful.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    oJ: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                return _Utils_Tuple3(_Utils_update(model, {
                    fr: $author$project$Api$Data$Loading
                }), A2($author$project$Api$Partner$RainforestAccount$delete, model.Ej, $author$project$Pages$Partner$Billing$GotDeleteRainforestAccount), _List_Nil);
            case 12:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    fr: $author$project$Api$Data$NotAsked,
                    cn: $author$project$Api$Data$Failure($author$project$Api$Data$NotFound)
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Rainforest account was successfully deleted.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    fr: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 13:
                return _Utils_Tuple3(model, A2($author$project$Api$Partner$RainforestAccount$fakePrefill, model.Ej, $author$project$Pages$Partner$Billing$PrefilledWithFakeData), _List_Nil);
            default:
                var response = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Partner$Billing$DeleteRainforestAccount = {
        $: 11
    };
    var $author$project$Pages$Partner$Billing$OpenResetAccountModal = {
        $: 5
    };
    var $author$project$Pages$Partner$Billing$OpenSimulateModal = {
        $: 7
    };
    var $author$project$Pages$Partner$Billing$PrefillWithFakeDataClicked = {
        $: 13
    };
    var $author$project$Pages$Partner$Billing$Sync = {
        $: 9
    };
    var $author$project$Pages$Partner$Billing$applicationIsProcessing = F2(function(rainforestAccount, _v0) {
        var merchantOnboardingSubmitted = _v0.y4;
        return merchantOnboardingSubmitted || 'processing' === $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
    });
    var $author$project$Api$Partner$RainforestAccount$Shared$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Partner$RainforestAccount$Shared$status = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$Shared$record, function($) {
        return $.ahy;
    });
    var $author$project$Api$Partner$RainforestAccount$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$RainforestAccount$Shared$status(shared);
    };
    var $author$project$Pages$Partner$Billing$MerchantOnboardingSubmitted = {
        $: 4
    };
    var $author$project$Api$Partner$RainforestAccount$One$merchantApplicationId = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$One$record, function($) {
        return $.T9;
    });
    var $author$project$Api$Partner$RainforestAccount$One$merchantId = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$One$record, function($) {
        return $.Ub;
    });
    var $author$project$Api$Partner$RainforestAccount$One$depositAccountAccountType = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$One$record, function($) {
        return $.NM;
    });
    var $author$project$Api$Partner$RainforestAccount$One$depositAccountBankName = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$One$record, function($) {
        return $.NN;
    });
    var $author$project$Api$Partner$RainforestAccount$One$depositAccountLast4 = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$One$record, function($) {
        return $.NO;
    });
    var $author$project$Api$Partner$RainforestAccount$One$depositAccountRoutingNumber = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$One$record, function($) {
        return $.NP;
    });
    var $author$project$Api$Partner$RainforestAccount$One$statementDescriptor = A2($elm$core$Basics$composeR, $author$project$Api$Partner$RainforestAccount$One$record, function($) {
        return $._5;
    });
    var $author$project$Pages$Partner$Billing$viewActive = function(rainforestAccount) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Statement Descriptor'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Partner$RainforestAccount$One$statementDescriptor(rainforestAccount)))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Deposit Account'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text('Bank Name: ')
                    ])),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Partner$RainforestAccount$One$depositAccountBankName(rainforestAccount)))
                ])),
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text('Last 4: ')
                    ])),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Partner$RainforestAccount$One$depositAccountLast4(rainforestAccount)))
                ])),
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text('Routing Number: ')
                    ])),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Partner$RainforestAccount$One$depositAccountRoutingNumber(rainforestAccount)))
                ])),
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text('Account Type: ')
                    ])),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Partner$RainforestAccount$One$depositAccountAccountType(rainforestAccount)))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Billing$viewInProgressAlert = A2($author$project$Ui$Alert$info, _List_fromArray([
        $author$project$Ui$Alert$mb2,
        $author$project$Ui$Alert$textLeft
    ]), _List_fromArray([
        A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Setup Hint Payments')
        ])),
        A2($elm$html$Html$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text("To start processing payments in Hint, please complete the form below. It takes about 5\u201310 minutes and requires key details like your account\u2019s contact info, tax ID, bank details, and ownership info (including SSN).")
        ]))
    ]));
    var $author$project$Pages$Partner$Billing$viewInReviewAlert = A2($author$project$Ui$Alert$info, _List_fromArray([
        $author$project$Ui$Alert$mb2,
        $author$project$Ui$Alert$textLeft
    ]), _List_fromArray([
        A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
            $elm$html$Html$text("Application Submitted \u2014 Under Review")
        ])),
        A2($elm$html$Html$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text("Thank you for submitting your payment setup form! We\u2019re currently reviewing your details \u2014 this usually takes a few business days. No action is needed right now.")
        ]))
    ]));
    var $author$project$Pages$Partner$Billing$viewAccount = F2(function(rainforestAccount, model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            function() {
                var _v0 = $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount);
                switch(_v0){
                    case 'created':
                        return $author$project$Pages$Partner$Billing$viewInProgressAlert;
                    case 'in_progress':
                        return $author$project$Pages$Partner$Billing$viewInProgressAlert;
                    case 'processing':
                        return $author$project$Pages$Partner$Billing$viewInReviewAlert;
                    case 'in_review':
                        return $author$project$Pages$Partner$Billing$viewInReviewAlert;
                    case 'needs_information':
                        return A2($author$project$Ui$Alert$info, _List_fromArray([
                            $author$project$Ui$Alert$mb2,
                            $author$project$Ui$Alert$textLeft
                        ]), _List_fromArray([
                            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text("Action Needed \u2014 More Info Required")
                            ])),
                            A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                                $elm$html$Html$text("To finish setting up Hint Payments, we need a bit more information. Please use the form below to provide the missing details. Once submitted, we\u2019ll review and confirm your setup \u2014 usually within a few business days. We\u2019ll notify you by email when it's complete.")
                            ]))
                        ]));
                    case 'completed':
                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Status'),
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Partner$RainforestAccount$One$status(rainforestAccount))
                            ]))
                        ]));
                    default:
                        return $elm$html$Html$text('');
                }
            }(),
            function() {
                var _v1 = _Utils_Tuple3(A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model), $author$project$Api$Partner$RainforestAccount$One$merchantApplicationStatus(rainforestAccount), model.Ct);
                _v1$1: while(true){
                    if (_v1.a) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label(''),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanMd(12),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Your payment processing account is under review, we will notify you when it\'s approved or if more information is needed.')
                            ]))
                        ]))
                    ]));
                    else if (!_v1.c.$) {
                        if (_v1.b === 'completed') break _v1$1;
                        else {
                            var setupSessionKey = _v1.c.a;
                            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label(''),
                                $author$project$Ui$Form$Group$labelSpanSm(4),
                                $author$project$Ui$Form$Group$inputSpanMd(8)
                            ]), _List_fromArray([
                                A2($author$project$WebComponents$Rainforest$MerchantOnboarding$view, $author$project$Pages$Partner$Billing$MerchantOnboardingSubmitted, {
                                    T9: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$RainforestAccount$One$merchantApplicationId(rainforestAccount)),
                                    Ub: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$RainforestAccount$One$merchantId(rainforestAccount)),
                                    ahi: setupSessionKey
                                })
                            ]));
                        }
                    } else {
                        if (_v1.b === 'completed') break _v1$1;
                        else {
                            var _v2 = _v1.c;
                            return $author$project$Utils$Html$empty;
                        }
                    }
                }
                return $author$project$Pages$Partner$Billing$viewActive(rainforestAccount);
            }()
        ]));
    });
    var $author$project$Pages$Partner$Billing$CreateClicked = {
        $: 1
    };
    var $author$project$Pages$Partner$Billing$viewSetup = A2($author$project$Ui$Element$view, _List_fromArray([
        $author$project$Ui$Element$textCenter
    ]), _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt2
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Set up your Payment Processing account to start accepting payments.')
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Get Started'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$CreateClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Get Started')
            ]))
        ]))
    ]));
    var $author$project$Pages$Partner$Billing$viewBody = function(model) {
        return _List_fromArray([
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$SimulateApplicationEventModal$view, $elm$html$Html$map($author$project$Pages$Partner$Billing$SimulateApplicationEventModalMsg)), model.kd)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Rainforest$ResetAccountModal$view, $elm$html$Html$map($author$project$Pages$Partner$Billing$ResetAccountModalMsg)), model.jT)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Payment Processing')
                        ])),
                        function() {
                            if (model.F3) {
                                var _v0 = model.cn;
                                if (_v0.$ === 3) {
                                    var rainforestAccount = _v0.a;
                                    return A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$gap2,
                                        $author$project$Ui$Element$justifyRight
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$HinterOnly$button, {
                                            abP: 'Sync with Rainforest'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$secondary,
                                            $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Sync),
                                            $author$project$Ui$Button$loading(_Utils_eq(model.oJ, $author$project$Api$Data$Loading))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Sync with Rainforest')
                                        ])),
                                        model.BC && A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model) ? A3($author$project$Ui$HinterOnly$button, {
                                            abP: 'Simulate status change'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$secondary,
                                            $author$project$Ui$Button$sm,
                                            $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$OpenSimulateModal)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Simulate Status Change')
                                        ])) : $author$project$Utils$Html$empty,
                                        A3($author$project$Ui$HinterOnly$button, {
                                            abP: 'Reset Rainforest account'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$secondary,
                                            $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$OpenResetAccountModal)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Reset Rainforest account')
                                        ])),
                                        $author$project$Api$Partner$RainforestAccount$One$status(rainforestAccount) === 'canceled' ? A3($author$project$Ui$HinterOnly$button, {
                                            abP: 'Delete Rainforest account'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$danger,
                                            $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$DeleteRainforestAccount),
                                            $author$project$Ui$Button$loading(_Utils_eq(model.fr, $author$project$Api$Data$Loading))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Delete Rainforest account')
                                        ])) : $author$project$Utils$Html$empty
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    function() {
                        var _v1 = model.cn;
                        _v1$3: while(true)switch(_v1.$){
                            case 3:
                                var rainforestAccount = _v1.a;
                                return A2($author$project$Pages$Partner$Billing$viewAccount, rainforestAccount, model);
                            case 2:
                                if (_v1.a.$ === 5) {
                                    var _v2 = _v1.a;
                                    return $author$project$Pages$Partner$Billing$viewSetup;
                                } else break _v1$3;
                            case 1:
                                return $elm$html$Html$text('');
                            default:
                                break _v1$3;
                        }
                        return $elm$html$Html$text('');
                    }()
                ])),
                function() {
                    var _v3 = model.cn;
                    if (_v3.$ === 3) {
                        var rainforestAccount = _v3.a;
                        return A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter,
                            $author$project$Ui$Element$gap4
                        ]), _List_fromArray([
                            model.F3 && model.BC && A2($author$project$Pages$Partner$Billing$applicationIsProcessing, rainforestAccount, model) ? A3($author$project$Ui$HinterOnly$button, {
                                abP: 'Prefill with fake data'
                            }, _List_fromArray([
                                $author$project$Ui$Button$secondary,
                                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$PrefillWithFakeDataClicked)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Prefill')
                            ])) : $author$project$Utils$Html$empty
                        ]));
                    } else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]);
    };
    var $author$project$Pages$Partner$Billing$view = function(model) {
        return {
            fb: $author$project$Pages$Partner$Billing$viewBody(model),
            $2: 'Partner | Payment Processing'
        };
    };
    var $author$project$Pages$Partner$Billing$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Billing$init,
        aeR: $author$project$Pages$Partner$Billing$load,
        ag3: $author$project$Pages$Partner$Billing$save,
        ahE: $author$project$Pages$Partner$Billing$subscriptions,
        aaO: $author$project$Pages$Partner$Billing$update,
        aid: $author$project$Pages$Partner$Billing$view
    });
    var $author$project$Pages$Partner$Billing$Hinter$GotBilling = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$PartnerCharges$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$PartnerCharges$GotPartnerCharges = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$PartnerCharges$fetchPartnerChargesParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af_: model.af_,
                W1: model.G1,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$PartnerCharge = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Reports$PartnerCharge$Record = F7(function(id, practice, description, amountInCents, feeInCents, invoice, practiceInvoice) {
        return {
            Jh: amountInCents,
            NQ: description,
            Pz: feeInCents,
            aef: id,
            RA: invoice,
            W1: practice,
            W3: practiceInvoice
        };
    });
    var $author$project$Api$Partner$Reports$PartnerCharge$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice_invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Partner$Practice$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Reports$PartnerCharge$Record))))))));
    var $author$project$Api$Partner$Reports$PartnerCharge$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Reports$PartnerCharge$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Reports$PartnerCharge$listDefaults = {
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        W1: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$Reports$PartnerCharge$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.W1;
                if (!_v2.$) {
                    var practice_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practice', practice_)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'partner_charges'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Reports$PartnerCharge$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$Reports$PartnerCharge$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Reports$PartnerCharge$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$Reports$PartnerCharge$listPath)));
    });
    var $author$project$Components$Reports$PartnerCharges$fetchPartnerCharges = F2(function(apiClient, model) {
        return A3($author$project$Api$Partner$Reports$PartnerCharge$list, apiClient, $author$project$Components$Reports$PartnerCharges$fetchPartnerChargesParams(model), $author$project$Components$Reports$PartnerCharges$GotPartnerCharges);
    });
    var $author$project$Components$ResourceFilter$Partner$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Practice$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Partner$Practice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$Practice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var query = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', query)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Partner$Practice$practicesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practices'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Practice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$Practice$Min$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Practice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$Practice$practicesPath)));
    });
    var $author$project$Components$ResourceFilter$Partner$Practice$list = F3(function(apiClient, optionals, toMsg) {
        return A3($author$project$Api$Partner$Practice$list, apiClient, optionals, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$Practice$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Partner$Practice$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$Practice$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Partner$Practice$list, apiClient, function(d) {
            return _Utils_update(d, {
                agq: $elm$core$Maybe$Just(id)
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$Practice$selectId = 'partner-practices';
    var $author$project$Components$ResourceFilter$Partner$Practice$toTitle = $author$project$Api$Partner$Practice$Min$name;
    var $author$project$Components$ResourceFilter$Partner$Practice$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Partner$Practice$toTitle(resource))
        ]);
    };
    var $author$project$Api$Partner$Practice$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$ResourceFilter$Partner$Practice$toValue = $author$project$Api$Partner$Practice$Min$id;
    var $author$project$Components$ResourceFilter$Partner$Practice$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Partner$Practice$fetchResources,
            aef: $author$project$Components$ResourceFilter$Partner$Practice$selectId,
            gD: 'Practices',
            sz: $author$project$Components$ResourceFilter$Partner$Practice$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$Partner$Practice$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Partner$Practice$toTitle,
            g4: $author$project$Components$ResourceFilter$Partner$Practice$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Reports$PartnerCharges$initColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'practice_name', false, 'Practice'),
        A3($author$project$Api$Column$init, 'description', false, 'Description'),
        A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
        A3($author$project$Api$Column$init, 'fee_in_cents', true, 'Fee'),
        A3($author$project$Api$Column$init, 'invoice_number', false, 'Invoice'),
        A3($author$project$Api$Column$init, 'practice_invoice_number', false, 'Practice Invoice')
    ]);
    var $author$project$Components$Reports$PartnerCharges$init = function(_v0) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var _v1 = A2($author$project$Components$ResourceFilter$Partner$Practice$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'All Practices'
            });
        });
        var practiceResourceFilter = _v1.a;
        var practiceResourceFilterCmd = _v1.b;
        var _v2 = A2($author$project$Components$DateRangeInput$init, 'partner-charges-date-range', A2($author$project$Components$Reports$PartnerCharges$dateRangeInputSettings, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
        var dateRangeInput = _v2.a;
        var dateRangeInputCmd = _v2.b;
        var model = {
            LC: $author$project$Components$Reports$PartnerCharges$initColumns,
            cP: currentDate,
            h6: dateRangeInput,
            Fn: $elm$core$Maybe$Nothing,
            af_: $author$project$Api$Pagination$init,
            ch: $author$project$Api$Data$Loading,
            G1: $elm$core$Maybe$Nothing,
            jC: practiceResourceFilter,
            ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
            HB: $elm$core$Maybe$Nothing
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg, practiceResourceFilterCmd),
            A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, model)
        ])));
    };
    var $author$project$Api$Partner$Billing$billingPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'billing'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Billing$Billing = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Billing$Record = function(rules) {
        return {
            Zk: rules
        };
    };
    var $author$project$Api$Partner$Billing$Rule = F2(function(id, billsBy) {
        return {
            ab3: billsBy,
            aef: id
        };
    });
    var $author$project$Api$Partner$Billing$Gross = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$Billing$Margin = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Billing$Transaction = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Partner$Billing$billsByDecoder = A2($elm$json$Json$Decode$andThen, function(ruleType) {
        switch(ruleType){
            case 'gross':
                return A2($elm$json$Json$Decode$map, $author$project$Api$Partner$Billing$Gross, A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
            case 'margin':
                return A2($elm$json$Json$Decode$map, $author$project$Api$Partner$Billing$Margin, A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
            case 'transaction':
                return A2($elm$json$Json$Decode$map, $author$project$Api$Partner$Billing$Transaction, A2($elm$json$Json$Decode$field, 'fee_percent', $elm$json$Json$Decode$float));
            default:
                return $elm$json$Json$Decode$fail('Unknown rule type: ' + ruleType);
        }
    }, A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
    var $author$project$Api$Partner$Billing$ruleDecoder = A3($elm$json$Json$Decode$map2, $author$project$Api$Partner$Billing$Rule, A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string), $author$project$Api$Partner$Billing$billsByDecoder);
    var $author$project$Api$Partner$Billing$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rules', $elm$json$Json$Decode$list($author$project$Api$Partner$Billing$ruleDecoder), $elm$json$Json$Decode$succeed($author$project$Api$Partner$Billing$Record)));
    var $author$project$Api$Partner$Billing$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Partner$Billing$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$Billing$billingPath));
    });
    var $author$project$Pages$Partner$Billing$Hinter$init = F4(function(_v0, partner, shared, _v1) {
        var _v2 = $author$project$Components$Reports$PartnerCharges$init(shared);
        var partnerCharges = _v2.a;
        var partnerChargesCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            pG: $author$project$Api$Data$Loading,
            VW: partner,
            ch: partnerCharges,
            bD: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Partner$Billing$retrieve, shared.Ej, $author$project$Pages$Partner$Billing$Hinter$GotBilling),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg, partnerChargesCmd)
        ])));
    });
    var $author$project$Pages$Partner$Billing$Hinter$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Billing$Hinter$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Billing$Hinter$RuleModalClosed = {
        $: 7
    };
    var $author$project$Components$ResourceFilter$Partner$Practice$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Reports$PartnerCharges$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg, $author$project$Components$ResourceFilter$Partner$Practice$subscriptions(model.jC))
        ]));
    };
    var $author$project$Pages$Partner$Billing$Hinter$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Billing$Hinter$RuleModalClosed),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg, $author$project$Components$Reports$PartnerCharges$subscriptions(model.ch))
        ]));
    };
    var $author$project$Pages$Partner$Billing$Hinter$GotCreatedBilling = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$GotCreatedRule = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$GotDeletedRule = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$GotUpdatedRule = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Partner$Billing$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Billing$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$Billing$billingPath));
    });
    var $author$project$Api$Partner$Billing$encodePermittedFields = function(permittedFields) {
        var encodedFields = A3($elm$core$List$foldl, F2(function(field, acc) {
            if (!field.$) {
                var ruleType = field.a;
                return A2($elm$core$List$cons, _Utils_Tuple2('type', $elm$json$Json$Encode$string(ruleType)), acc);
            } else {
                var percent = field.a;
                return A2($elm$core$List$cons, _Utils_Tuple2('fee_percent', $elm$json$Json$Encode$float(percent)), acc);
            }
        }), _List_Nil, permittedFields);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('rule', $elm$json$Json$Encode$object(encodedFields))
        ]));
    };
    var $author$project$Api$Partner$Billing$createRule = F3(function(apiClient, permittedFields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Billing$ruleDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Partner$Billing$encodePermittedFields(permittedFields), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'rules'
        ]), $author$project$Api$Partner$Billing$billingPath))));
    });
    var $author$project$Api$Partner$Billing$deleteRule = F3(function(apiClient, ruleId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'rules',
            ruleId
        ]), $author$project$Api$Partner$Billing$billingPath)));
    });
    var $author$project$Api$Partner$Billing$RuleFeePercent = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Billing$RuleType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$formFieldsToPermittedFields = function(fields) {
        return _List_fromArray([
            $author$project$Api$Partner$Billing$RuleType(fields.ag0),
            $author$project$Api$Partner$Billing$RuleFeePercent(A2($elm$core$Maybe$withDefault, 0.0, A2($elm$core$Maybe$andThen, $author$project$Percentage$toFloat, fields.iI)))
        ]);
    };
    var $author$project$Pages$Partner$Billing$Hinter$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var ruleType = field.a;
            return _Utils_update(fields, {
                ag0: ruleType
            });
        } else {
            var percentage = field.a;
            return _Utils_update(fields, {
                iI: percentage
            });
        }
    });
    var $author$project$Pages$Partner$Billing$Hinter$ruleToFormFields = function(rule) {
        var _v0 = function() {
            var _v1 = rule.ab3;
            switch(_v1.$){
                case 0:
                    var percent = _v1.a;
                    return _Utils_Tuple2('gross', $elm$core$Maybe$Just($author$project$Percentage$fromFloat(percent)));
                case 1:
                    var percent = _v1.a;
                    return _Utils_Tuple2('margin', $elm$core$Maybe$Just($author$project$Percentage$fromFloat(percent)));
                default:
                    var percent = _v1.a;
                    return _Utils_Tuple2('transaction', $elm$core$Maybe$Just($author$project$Percentage$fromFloat(percent)));
            }
        }();
        var ruleType = _v0.a;
        var feePercentage = _v0.b;
        return {
            iI: feePercentage,
            ag0: ruleType
        };
    };
    var $author$project$Components$ResourceFilter$Partner$Practice$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$ && !_v1.a.$) {
                var selected = _v1.a.a;
                return _Utils_update(model, {
                    Hg: selected
                });
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$Reports$PartnerCharges$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Billing__Hinter)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Components$ResourceFilter$Partner$Practice$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Reports$PartnerCharges$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v1.a;
                var subCmd = _v1.b;
                var event = _v1.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            ch: $author$project$Api$Data$Loading,
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel),
                    $author$project$Components$Reports$PartnerCharges$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        ch: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ch: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var practiceResourceResult = A3($author$project$Components$ResourceFilter$Partner$Practice$update, apiClient, subMsg, model.jC);
                var practiceId = function() {
                    var _v5 = practiceResourceResult.adu;
                    if (!_v5.$ && !_v5.a.$) return $author$project$Components$ResourceFilter$Partner$Practice$value(practiceResourceResult.zi);
                    else return model.G1;
                }();
                var newModel = _Utils_update(model, {
                    G1: practiceId,
                    jC: practiceResourceResult.zi
                });
                var _v4 = function() {
                    if (_Utils_eq(model.G1, newModel.G1)) return _Utils_Tuple3(model.ch, $elm$core$Platform$Cmd$none, model.af_);
                    else {
                        var paginationReset = $author$project$Api$Pagination$reset(model.af_);
                        return _Utils_Tuple3($author$project$Api$Data$Loading, A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel), paginationReset);
                    }
                }();
                var partnerCharges = _v4.a;
                var cmd = _v4.b;
                var pagination = _v4.c;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    af_: pagination,
                    ch: partnerCharges
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg, practiceResourceResult.EQ),
                    cmd
                ])), practiceResourceResult.at);
            case 3:
                var subMsg = msg.a;
                var newPagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: newPagination,
                    ch: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel), _List_Nil);
            default:
                var columnKey = msg.a;
                var newSort = A2($author$project$Api$Sort$update, columnKey, model.ahs);
                var newModel = _Utils_update(model, {
                    ch: $author$project$Api$Data$Loading,
                    ahs: newSort
                });
                return _Utils_Tuple3(newModel, A2($author$project$Components$Reports$PartnerCharges$fetchPartnerCharges, apiClient, newModel), _List_Nil);
        }
    });
    var $author$project$Api$Partner$Billing$updateRule = F4(function(apiClient, ruleId, permittedFields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Partner$Billing$ruleDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Partner$Billing$encodePermittedFields(permittedFields), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'rules',
            ruleId
        ]), $author$project$Api$Partner$Billing$billingPath))));
    });
    var $author$project$Pages$Partner$Billing$Hinter$FeePercentageValidation = 1;
    var $author$project$Pages$Partner$Billing$Hinter$RuleTypeValidation = 0;
    var $author$project$Pages$Partner$Billing$Hinter$validate = function(form) {
        var validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.ag0;
            }, _Utils_Tuple2(0, 'Rule type is required')),
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.iI;
            }, _Utils_Tuple2(1, 'Fee percentage is required'))
        ]));
        return A2($author$project$Utils$Form$validate, validator, form);
    };
    var $author$project$Pages$Partner$Billing$Hinter$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pG: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(model, A2($author$project$Api$Partner$Billing$create, model.Ej, $author$project$Pages$Partner$Billing$Hinter$GotCreatedBilling), _List_Nil);
            case 2:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    pG: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var form = $author$project$Utils$Form$init({
                    iI: $elm$core$Maybe$Nothing,
                    ag0: 'gross'
                });
                return _Utils_Tuple3(_Utils_update(model, {
                    bD: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Nothing, form))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var ruleId = msg.a;
                var rule = msg.b;
                var form = $author$project$Utils$Form$init($author$project$Pages$Partner$Billing$Hinter$ruleToFormFields(rule));
                return _Utils_Tuple3(_Utils_update(model, {
                    bD: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(ruleId), form))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var ruleId = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Partner$Billing$deleteRule, model.Ej, ruleId, $author$project$Pages$Partner$Billing$Hinter$GotDeletedRule), _List_Nil);
            case 6:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Api$Partner$Billing$retrieve, model.Ej, $author$project$Pages$Partner$Billing$Hinter$GotBilling), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    bD: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var field = msg.a;
                var _v3 = model.bD;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var ruleId = _v4.a;
                    var form = _v4.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Billing$Hinter$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        bD: $elm$core$Maybe$Just(_Utils_Tuple2(ruleId, newForm))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var _v5 = model.bD;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var ruleId = _v6.a;
                    var form = _v6.b;
                    var _v7 = $author$project$Pages$Partner$Billing$Hinter$validate(form);
                    if (!_v7.$) {
                        var _v8 = _v7.a;
                        var validFields = _v8.b;
                        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
                        var permittedFields = $author$project$Pages$Partner$Billing$Hinter$formFieldsToPermittedFields(fields);
                        var cmd = function() {
                            if (!ruleId.$) {
                                var id = ruleId.a;
                                return A4($author$project$Api$Partner$Billing$updateRule, model.Ej, id, permittedFields, $author$project$Pages$Partner$Billing$Hinter$GotUpdatedRule);
                            } else return A3($author$project$Api$Partner$Billing$createRule, model.Ej, permittedFields, $author$project$Pages$Partner$Billing$Hinter$GotCreatedRule);
                        }();
                        return _Utils_Tuple3(model, cmd, _List_Nil);
                    } else {
                        var formWithErrors = _v7.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bD: $elm$core$Maybe$Just(_Utils_Tuple2(ruleId, formWithErrors))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bD: $elm$core$Maybe$Nothing
                }), A2($author$project$Api$Partner$Billing$retrieve, model.Ej, $author$project$Pages$Partner$Billing$Hinter$GotBilling), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bD: $elm$core$Maybe$Nothing
                }), A2($author$project$Api$Partner$Billing$retrieve, model.Ej, $author$project$Pages$Partner$Billing$Hinter$GotBilling), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v12 = A3($author$project$Components$Reports$PartnerCharges$update, model.Ej, subMsg, model.ch);
                var partnerCharges = _v12.a;
                var cmd = _v12.b;
                var outMsgs = _v12.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    ch: partnerCharges
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg, cmd), outMsgs);
        }
    });
    var $author$project$Components$Reports$PartnerCharges$PaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Partner$Practice$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$ResourceFilter$Partner$Practice$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Reports$PartnerCharges$viewPracticeResourceFilter = function(practiceResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg, A2($author$project$Components$ResourceFilter$Partner$Practice$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), practiceResourceFilter));
    };
    var $author$project$Components$Reports$PartnerCharges$SortTable = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$feeInCents = function(_v0) {
        var record = _v0;
        return record.Pz;
    };
    var $author$project$Api$Common$Payable$Invoice$Min$humanStatus = function(_v0) {
        var record = _v0;
        return record.QX;
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$invoice = function(_v0) {
        var record = _v0;
        return record.RA;
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$practiceInvoice = function(_v0) {
        var record = _v0;
        return record.W3;
    };
    var $author$project$Api$Partner$Reports$PartnerCharge$practiceName = function(_v0) {
        var record = _v0;
        return $author$project$Api$Partner$Practice$Min$name(record.W1);
    };
    var $author$project$Components$Reports$PartnerCharges$viewTableRow = function(partnerCharge) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$Reports$PartnerCharge$practiceName(partnerCharge))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$Reports$PartnerCharge$description(partnerCharge))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Partner$Reports$PartnerCharge$amountInCents(partnerCharge)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Partner$Reports$PartnerCharge$feeInCents(partnerCharge)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v0 = $author$project$Api$Partner$Reports$PartnerCharge$invoice(partnerCharge);
                if (!_v0.$) {
                    var invoice = _v0.a;
                    return _List_fromArray([
                        $elm$html$Html$text(function(n) {
                            return '#' + n;
                        }($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice)))),
                        $author$project$Utils$Html$noBreakSpace,
                        A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice))
                    ]);
                } else return _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted
                    ]), _List_fromArray([
                        $elm$html$Html$text('N/A')
                    ]))
                ]);
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v1 = $author$project$Api$Partner$Reports$PartnerCharge$practiceInvoice(partnerCharge);
                if (!_v1.$) {
                    var invoice = _v1.a;
                    return _List_fromArray([
                        $elm$html$Html$text(function(n) {
                            return '#' + n;
                        }($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice)))),
                        $author$project$Utils$Html$noBreakSpace,
                        A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice))
                    ]);
                } else return _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted
                    ]), _List_fromArray([
                        $elm$html$Html$text('N/A')
                    ]))
                ]);
            }())
        ]));
    };
    var $author$project$Components$Reports$PartnerCharges$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.ch;
            if (_v1.$ === 3) {
                var partnerCharges_ = _v1.a;
                return _Utils_Tuple2(false, partnerCharges_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var partnerCharges = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$PartnerCharges$SortTable)), model.LC), A2($elm$core$List$map, $author$project$Components$Reports$PartnerCharges$viewTableRow, partnerCharges), _List_Nil);
    };
    var $author$project$Components$Reports$PartnerCharges$view = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Partner Charges')
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$mt4
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(12)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Reports$PartnerCharges$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$PartnerCharges$viewPracticeResourceFilter(model.jC)
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$PartnerCharges$PracticeResourceFilterMsg), $author$project$Components$ResourceFilter$Partner$Practice$viewMultiSelected(model.jC));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$PartnerCharges$viewTable(model)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$PartnerCharges$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.ch)))
                    ]), model.af_))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Partner$Billing$Hinter$AddRuleClicked = {
        $: 3
    };
    var $author$project$Api$Partner$Billing$rules = function(_v0) {
        var record = _v0;
        return record.Zk;
    };
    var $author$project$Pages$Partner$Billing$Hinter$DeleteRuleClicked = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$EditRuleClicked = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Billing$Hinter$viewRule = function(rule) {
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$span(6),
            $author$project$Ui$Grid$spanMd(3)
        ]), _List_fromArray([
            function() {
                var _v0 = rule.ab3;
                switch(_v0.$){
                    case 0:
                        var percentage = _v0.a;
                        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Gross')
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt2
                            ]), _List_fromArray([
                                A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Fee: ')
                                ])),
                                $elm$html$Html$text($author$project$Formatters$Float$toPercentage(percentage))
                            ]))
                        ]));
                    case 1:
                        var percentage = _v0.a;
                        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Margin')
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt2
                            ]), _List_fromArray([
                                A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Fee: ')
                                ])),
                                $elm$html$Html$text($author$project$Formatters$Float$toPercentage(percentage))
                            ]))
                        ]));
                    default:
                        var percentage = _v0.a;
                        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Transaction')
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt2
                            ]), _List_fromArray([
                                A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Fee: ')
                                ])),
                                $elm$html$Html$text($author$project$Formatters$Float$toPercentage(percentage))
                            ]))
                        ]));
                }
            }(),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt4,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit rule'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                    $author$project$Ui$Button$onClick(A2($author$project$Pages$Partner$Billing$Hinter$EditRuleClicked, rule.aef, rule)),
                    $author$project$Ui$Button$sm
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete rule'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$DeleteRuleClicked(rule.aef)),
                    $author$project$Ui$Button$sm
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Billing$Hinter$viewBilling = function(billing) {
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Billing Details')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add rule'
                }, _List_fromArray([
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$AddRuleClicked)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Rule')
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Partner$Billing$Hinter$viewRule, $author$project$Api$Partner$Billing$rules(billing)))
        ]);
    };
    var $author$project$Pages$Partner$Billing$Hinter$CreateClicked = {
        $: 1
    };
    var $author$project$Pages$Partner$Billing$Hinter$viewBuildBilling = _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$justifyCenter,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$flexCol
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $elm$html$Html$text('There\'s no billing yet')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Set up billing'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$CreateClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Set up billing')
            ]))
        ]))
    ]);
    var $author$project$Pages$Partner$Billing$Hinter$FeePercentage = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$FormUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$SaveRuleClicked = {
        $: 9
    };
    var $author$project$Pages$Partner$Billing$Hinter$RuleType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton = F3(function(fields, ruleType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$styled(_Utils_eq(fields.ag0, ruleType) ? 1 : 0),
            $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$FormUpdated($author$project$Pages$Partner$Billing$Hinter$RuleType(ruleType)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Pages$Partner$Billing$Hinter$viewRuleModal = F2(function(ruleId, form) {
        var modalTitle = function() {
            if (!ruleId.$) return 'Edit Rule';
            else return 'Add Rule';
        }();
        var fields = $author$project$Utils$Form$fields(form);
        var errorsFor = function(group) {
            return A2($author$project$Utils$Form$validationErrors, group, form);
        };
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Billing$Hinter$RuleModalClosed, _List_fromArray([
            $author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Billing$Hinter$SaveRuleClicked)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(modalTitle)
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Rule Type'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Button$group(_List_fromArray([
                        A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'gross', 'Gross'),
                        A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'margin', 'Margin'),
                        A3($author$project$Pages$Partner$Billing$Hinter$viewRuleTypeButton, fields, 'transaction', 'Transaction')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Fee Percentage'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$PercentageInput$view(_List_fromArray([
                        $author$project$Ui$Form$PercentageInput$value(fields.iI),
                        $author$project$Ui$Form$PercentageInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Billing$Hinter$FormUpdated, $author$project$Pages$Partner$Billing$Hinter$FeePercentage)),
                        $author$project$Ui$Form$PercentageInput$errors(errorsFor(1)),
                        $author$project$Ui$Form$PercentageInput$placeholder('10')
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Billing$Hinter$RuleModalClosed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save rule'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Billing$Hinter$viewBody = function(model) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                function() {
                    var _v0 = model.bD;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var ruleId = _v1.a;
                        var form = _v1.b;
                        return A2($author$project$Pages$Partner$Billing$Hinter$viewRuleModal, ruleId, form);
                    } else return $elm$html$Html$text('');
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, $elm$core$List$singleton(A2($author$project$Ui$Panel$body, _List_Nil, function() {
                    var _v2 = model.pG;
                    _v2$2: while(true)switch(_v2.$){
                        case 3:
                            var billing = _v2.a;
                            return $author$project$Pages$Partner$Billing$Hinter$viewBilling(billing);
                        case 2:
                            if (_v2.a.$ === 5) {
                                var _v3 = _v2.a;
                                return $author$project$Pages$Partner$Billing$Hinter$viewBuildBilling;
                            } else break _v2$2;
                        default:
                            break _v2$2;
                    }
                    return _List_Nil;
                }())))
            ]),
            A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$Billing$Hinter$PartnerChargesMsg), $author$project$Components$Reports$PartnerCharges$view(model.ch))
        ]));
    };
    var $author$project$Pages$Partner$Billing$Hinter$view = function(model) {
        return {
            fb: $author$project$Pages$Partner$Billing$Hinter$viewBody(model),
            $2: 'Partner | Billing'
        };
    };
    var $author$project$Pages$Partner$Billing$Hinter$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Billing$Hinter$init,
        aeR: $author$project$Pages$Partner$Billing$Hinter$load,
        ag3: $author$project$Pages$Partner$Billing$Hinter$save,
        ahE: $author$project$Pages$Partner$Billing$Hinter$subscriptions,
        aaO: $author$project$Pages$Partner$Billing$Hinter$update,
        aid: $author$project$Pages$Partner$Billing$Hinter$view
    });
    var $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$backlinkUrl = function(_v0) {
        var record = _v0;
        return record.J5;
    };
    var $author$project$Pages$Partner$Dashboard$Top$Agreements = 1;
    var $author$project$Pages$Partner$Dashboard$Top$CompanyDetails = 0;
    var $author$project$Pages$Partner$Dashboard$Top$ProductListing = 2;
    var $author$project$Pages$Partner$Dashboard$Top$SandboxSetup = 3;
    var $author$project$Pages$Partner$Dashboard$Top$WebsiteBacklink = 4;
    var $author$project$Api$Partner$Partner$One$managedBy = function(_v0) {
        var record = _v0.b;
        return record.Tz;
    };
    var $author$project$Api$Partner$Partner$Shared$sandboxEnabled = function(_v0) {
        var record = _v0;
        return record.Zo;
    };
    var $author$project$Api$Partner$Partner$One$sandboxEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$sandboxEnabled(shared);
    };
    var $author$project$Pages$Partner$Dashboard$Top$allSteps = function(partner) {
        var isManaged = !_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(partner), $elm$core$Maybe$Nothing);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Partner$Partner$One$sandboxEnabled(partner) ? _List_fromArray([
                3
            ]) : _List_Nil,
            _List_fromArray([
                0,
                1
            ]),
            isManaged ? _List_Nil : _List_fromArray([
                2,
                4
            ])
        ]));
    };
    var $author$project$Api$Partner$Partner$One$addendumAgreementFileName = function(_v0) {
        var record = _v0.b;
        return record.IB;
    };
    var $author$project$Api$Partner$Partner$One$addendumDocumentAgreement = function(_v0) {
        var record = _v0.b;
        return record.IC;
    };
    var $author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement = function(_v0) {
        var record = _v0.b;
        return record.Jw;
    };
    var $author$project$Api$Partner$Partner$One$baaDocumentAgreement = function(_v0) {
        var record = _v0.b;
        return record.J1;
    };
    var $author$project$Api$Partner$Partner$One$baaType = function(_v0) {
        var record = _v0.b;
        return record.J2;
    };
    var $author$project$Api$Partner$Partner$One$partnerDocumentAgreement = function(_v0) {
        var record = _v0.b;
        return record.VZ;
    };
    var $author$project$Pages$Partner$Dashboard$Top$isAgreementsComplete = function(partner) {
        var isManaged = !_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(partner), $elm$core$Maybe$Nothing);
        var partnerAgreementDone = isManaged || !_Utils_eq($author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner), $elm$core$Maybe$Nothing);
        var baaDone = function() {
            var _v0 = $author$project$Api$Partner$Partner$One$baaType(partner);
            if (!_v0.$) {
                if (!_v0.a) {
                    var _v1 = _v0.a;
                    return !_Utils_eq($author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner), $elm$core$Maybe$Nothing);
                } else {
                    var _v2 = _v0.a;
                    return true;
                }
            } else return isManaged;
        }();
        var apiAccessDone = !isManaged || !_Utils_eq($author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner), $elm$core$Maybe$Nothing);
        var addendumDone = isManaged || _Utils_eq($author$project$Api$Partner$Partner$One$addendumAgreementFileName(partner), $elm$core$Maybe$Nothing) || !_Utils_eq($author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner), $elm$core$Maybe$Nothing);
        return partnerAgreementDone && addendumDone && apiAccessDone && baaDone;
    };
    var $author$project$Api$Partner$Partner$One$address = function(_v0) {
        var record = _v0.b;
        return record.II;
    };
    var $author$project$Api$Partner$Partner$Shared$technicalEmail = function(_v0) {
        var record = _v0;
        return record.$U;
    };
    var $author$project$Api$Partner$Partner$One$technicalEmail = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$technicalEmail(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$websiteUrl = function(_v0) {
        var record = _v0;
        return record.abn;
    };
    var $author$project$Api$Partner$Partner$One$websiteUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$websiteUrl(shared);
    };
    var $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete = function(partner) {
        var _v0 = _Utils_Tuple3($author$project$Api$Partner$Partner$One$websiteUrl(partner), $author$project$Api$Partner$Partner$One$technicalEmail(partner), $author$project$Api$Partner$Partner$One$address(partner));
        if (!_v0.a.$ && !_v0.b.$ && !_v0.c.$) {
            var technicalEmail = _v0.b.a;
            var address = _v0.c.a;
            return !$author$project$Api$Common$Address$Shared$isAddressIncomplete(address) && !$elm$core$String$isEmpty(technicalEmail);
        } else return false;
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$distributionType = function(_v0) {
        var record = _v0;
        return record.N9;
    };
    var $author$project$Api$Partner$Partner$Shared$marketplaceIconUrl = function(_v0) {
        var record = _v0;
        return record.TI;
    };
    var $author$project$Api$Partner$Partner$One$marketplaceIconUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$marketplaceIconUrl(shared);
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$summary = function(_v0) {
        var record = _v0;
        return record.$x;
    };
    var $author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete = F2(function(partner, product) {
        return !_Utils_eq($author$project$Api$Partner$PartnerProduct$Shared$summary(product), $elm$core$Maybe$Nothing) && !_Utils_eq($author$project$Api$Partner$Partner$One$marketplaceIconUrl(partner), $elm$core$Maybe$Nothing);
    });
    var $author$project$Api$Partner$Partner$One$product = function(_v0) {
        var record = _v0.b;
        return record.Xw;
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished = function(partner) {
        var _v0 = $author$project$Api$Partner$Partner$One$product(partner);
        if (!_v0.$) {
            var product = _v0.a;
            return !$author$project$Api$Partner$PartnerProduct$Shared$distributionType(product) && !A2($elm$core$List$member, $author$project$Api$Partner$PartnerProduct$Shared$status(product), _List_fromArray([
                1,
                8
            ])) && A2($author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete, partner, product);
        } else return false;
    };
    var $author$project$Api$Partner$Partner$One$hasSandboxPartners = function(_v0) {
        var record = _v0.b;
        return record.Qy;
    };
    var $author$project$Api$Partner$Partner$One$hasSandboxPractices = function(_v0) {
        var record = _v0.b;
        return record.Qz;
    };
    var $author$project$Pages$Partner$Dashboard$Top$isSandboxSetupComplete = function(partner) {
        return $author$project$Api$Partner$Partner$One$hasSandboxPartners(partner) && $author$project$Api$Partner$Partner$One$hasSandboxPractices(partner);
    };
    var $author$project$Pages$Partner$Dashboard$Top$isWebsiteBacklinkComplete = function(partner) {
        return $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished(partner) && function() {
            var _v0 = $author$project$Api$Partner$Partner$One$product(partner);
            if (!_v0.$) {
                var product = _v0.a;
                return !_Utils_eq($author$project$Api$Partner$PartnerProduct$Shared$backlinkUrl(product), $elm$core$Maybe$Nothing);
            } else return false;
        }();
    };
    var $author$project$Pages$Partner$Dashboard$Top$isStepComplete = F2(function(partner, step) {
        switch(step){
            case 0:
                return $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete(partner);
            case 1:
                return $author$project$Pages$Partner$Dashboard$Top$isAgreementsComplete(partner);
            case 2:
                return $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished(partner);
            case 3:
                return $author$project$Pages$Partner$Dashboard$Top$isSandboxSetupComplete(partner);
            default:
                return $author$project$Pages$Partner$Dashboard$Top$isWebsiteBacklinkComplete(partner);
        }
    });
    var $author$project$Pages$Partner$Dashboard$Top$firstIncompleteStep = function(partner) {
        return $elm$core$List$head(A2($elm$core$List$filter, function(step) {
            return !A2($author$project$Pages$Partner$Dashboard$Top$isStepComplete, partner, step);
        }, $author$project$Pages$Partner$Dashboard$Top$allSteps(partner)));
    };
    var $author$project$Components$Partner$BaaForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$BaaForm$initFormFields = function(partner) {
        return {
            pD: !_Utils_eq($author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner), $elm$core$Maybe$Nothing),
            J2: $author$project$Api$Partner$Partner$One$baaType(partner)
        };
    };
    var $author$project$Components$Partner$BaaForm$init = F2(function(timeFormatter, partner) {
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init($author$project$Components$Partner$BaaForm$initFormFields(partner)),
            VW: partner,
            HO: timeFormatter,
            o2: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$DocumentsAgreementsForm$initFormFields = function(partner) {
        return {
            tP: !_Utils_eq($author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner), $elm$core$Maybe$Nothing),
            vx: !_Utils_eq($author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner), $elm$core$Maybe$Nothing),
            Ai: !_Utils_eq($author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner), $elm$core$Maybe$Nothing)
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$init = F2(function(timeFormatter, partner) {
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init($author$project$Components$Partner$DocumentsAgreementsForm$initFormFields(partner)),
            VW: partner,
            HO: timeFormatter,
            o2: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Partner$Form$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$Form$Address = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Partner$Partner$One$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$email(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$integrationDescription = function(_v0) {
        var record = _v0;
        return record.Ro;
    };
    var $author$project$Api$Partner$Partner$One$integrationDescription = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$integrationDescription(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$logoUrl = function(_v0) {
        var record = _v0;
        return record.Tu;
    };
    var $author$project$Api$Partner$Partner$One$logoUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$logoUrl(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$marketingUrl = function(_v0) {
        var record = _v0;
        return record.TH;
    };
    var $author$project$Api$Partner$Partner$One$marketingUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$marketingUrl(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Partner$Partner$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$name(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$productDescription = function(_v0) {
        var record = _v0;
        return record.Xz;
    };
    var $author$project$Api$Partner$Partner$One$productDescription = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$productDescription(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$signupUrl = function(_v0) {
        var record = _v0;
        return record._u;
    };
    var $author$project$Api$Partner$Partner$One$signupUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$signupUrl(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$supportUrl = function(_v0) {
        var record = _v0;
        return record.$y;
    };
    var $author$project$Api$Partner$Partner$One$supportUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$supportUrl(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$usesIntegrationRecords = function(_v0) {
        var record = _v0;
        return record.aa2;
    };
    var $author$project$Api$Partner$Partner$One$usesIntegrationRecords = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$usesIntegrationRecords(shared);
    };
    var $author$project$Components$Partner$Form$initFormFields = function(partner) {
        var _v0 = A2($author$project$Components$AddressInput$initFromApi, 'partner-address', $author$project$Api$Partner$Partner$One$address(partner));
        var address = _v0.a;
        var addressCmd = _v0.b;
        return _Utils_Tuple2({
            II: address,
            MM: $author$project$Api$Partner$Partner$One$logoUrl(partner),
            OH: $author$project$Api$Partner$Partner$One$email(partner),
            Ro: $author$project$Api$Partner$Partner$One$integrationDescription(partner),
            Ge: 0,
            Tu: $elm$core$Maybe$Nothing,
            TH: $author$project$Api$Partner$Partner$One$marketingUrl(partner),
            zr: $author$project$Api$Partner$Partner$One$name(partner),
            Xz: $author$project$Api$Partner$Partner$One$productDescription(partner),
            _u: $author$project$Api$Partner$Partner$One$signupUrl(partner),
            $y: $author$project$Api$Partner$Partner$One$supportUrl(partner),
            $U: $author$project$Api$Partner$Partner$One$technicalEmail(partner),
            aa2: $author$project$Api$Partner$Partner$One$usesIntegrationRecords(partner),
            abn: $author$project$Api$Partner$Partner$One$websiteUrl(partner)
        }, A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address), addressCmd));
    };
    var $author$project$Components$Partner$Form$init = function(partner) {
        var _v0 = $author$project$Components$Partner$Form$initFormFields(partner);
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init(formFields),
            VW: partner
        }, formFieldsCmd);
    };
    var $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded = function(partner) {
        return $author$project$Pages$Partner$Dashboard$Top$isCompanyDetailsComplete(partner);
    };
    var $author$project$Api$Platform$Session$One$sandbox = function(_v0) {
        var record = _v0;
        return record.Zn;
    };
    var $author$project$Pages$Partner$Dashboard$Top$init = F4(function(session, partner, shared, _v0) {
        var onboarded = $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded(partner);
        var initialExpanded = function() {
            var _v4 = $author$project$Pages$Partner$Dashboard$Top$firstIncompleteStep(partner);
            if (!_v4.$) {
                var step = _v4.a;
                return _List_fromArray([
                    step
                ]);
            } else return _List_Nil;
        }();
        var _v1 = onboarded ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, $author$project$Components$Partner$Form$init(partner)));
        var partnerForm = _v1.a;
        var partnerFormCmd = _v1.b;
        var _v2 = A2($author$project$Components$Partner$DocumentsAgreementsForm$init, shared.HO, partner);
        var documentsAgreementsForm = _v2.a;
        var documentsAgreementsFormCmd = _v2.b;
        var _v3 = A2($author$project$Components$Partner$BaaForm$init, shared.HO, partner);
        var baaForm = _v3.a;
        var baaFormCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            bR: baaForm,
            e8: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Partner$PartnerProduct$Shared$backlinkUrl, $author$project$Api$Partner$Partner$One$product(partner))),
            lc: $author$project$Api$Data$NotAsked,
            b4: documentsAgreementsForm,
            mb: initialExpanded,
            F5: $author$project$Api$Platform$Session$One$sandbox(session),
            Vs: onboarded,
            VW: partner,
            be: partnerForm,
            jW: $author$project$Api$Data$NotAsked,
            HO: shared.HO,
            o2: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            partnerFormCmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
        ])));
    });
    var $author$project$Pages$Partner$Dashboard$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Dashboard$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Partner$BaaForm$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Partner$Form$subscriptions = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($elm$core$Platform$Sub$map, A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address), $author$project$Components$AddressInput$subscriptions(fields.II));
    };
    var $author$project$Pages$Partner$Dashboard$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Partner$Form$subscriptions, model.be))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, $author$project$Components$Partner$BaaForm$subscriptions(model.bR)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, $author$project$Components$Partner$DocumentsAgreementsForm$subscriptions(model.b4))
        ]));
    };
    var $author$project$Api$Partner$PartnerProduct$BacklinkUrl = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$GotBacklinkUrlResponse = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$GotReviewResponse = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$GotUpdatedPartner = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections = function(partner) {
        var _v0 = $author$project$Pages$Partner$Dashboard$Top$firstIncompleteStep(partner);
        if (!_v0.$) {
            var step = _v0.a;
            return _List_fromArray([
                step
            ]);
        } else return _List_Nil;
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$PartnerProduct$One$PartnerProduct = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$PartnerProduct$One$Record = F4(function(ctaUrl, utmCampaign, utmContent, requirement) {
        return {
            MI: ctaUrl,
            YI: requirement,
            aa5: utmCampaign,
            aa6: utmContent
        };
    });
    var $author$project$Api$Common$Marketplace$Product$Requirement$FeatureRequirement = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Common$Marketplace$Product$Requirement$TierRequirement = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$decoder = A2($elm$json$Json$Decode$map, $author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString, $elm$json$Json$Decode$string);
    var $author$project$Api$Common$Marketplace$Product$Requirement$decoder = A2($elm$json$Json$Decode$andThen, function(type_) {
        if (type_ === 'feature') return A2($elm$json$Json$Decode$map, $author$project$Api$Common$Marketplace$Product$Requirement$FeatureRequirement, A2($elm$json$Json$Decode$field, 'feature', $author$project$Api$Common$Marketplace$Product$Requirement$Feature$decoder));
        else return A2($elm$json$Json$Decode$map, $author$project$Api$Common$Marketplace$Product$Requirement$TierRequirement, A2($elm$json$Json$Decode$field, 'starting_tier', $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string));
    var $author$project$Api$Partner$PartnerProduct$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requirement', $elm$json$Json$Decode$nullable($author$project$Api$Common$Marketplace$Product$Requirement$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'utm_content', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'utm_campaign', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cta_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$One$Record)))));
    var $author$project$Api$Partner$PartnerProduct$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProduct$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProduct$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProduct$One$PartnerProduct)));
    var $author$project$Api$Partner$PartnerProduct$productPathWithId = function(productId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'partner_products',
            productId
        ]), $author$project$Api$Data$partnerPath);
    };
    var $author$project$Api$Partner$PartnerProduct$requestReview = F3(function(apiClient, productId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProduct$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'request_review'
        ]), $author$project$Api$Partner$PartnerProduct$productPathWithId(productId))));
    });
    var $author$project$Components$Partner$BaaForm$Save = {
        $: 1
    };
    var $author$project$Components$Partner$BaaForm$saveMsg = $author$project$Components$Partner$BaaForm$Save;
    var $author$project$Components$Partner$DocumentsAgreementsForm$Save = {
        $: 1
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$saveMsg = $author$project$Components$Partner$DocumentsAgreementsForm$Save;
    var $author$project$Api$Partner$Partner$update = F3(function(apiClient, permittedFields, toMsg) {
        var body = $author$project$Api$Partner$Partner$encodePermittedFields(permittedFields);
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$Partner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath)));
    });
    var $author$project$Api$Common$Marketplace$Product$DistributionType$toString = function(distributionType) {
        if (!distributionType) return 'public';
        else return 'unlisted';
    };
    var $author$project$Api$Common$Marketplace$Product$DistributionType$encode = function(distributionType) {
        return $elm$json$Json$Encode$string($author$project$Api$Common$Marketplace$Product$DistributionType$toString(distributionType));
    };
    var $author$project$Api$Common$Marketplace$Product$ProductType$toString = function(type_) {
        switch(type_){
            case 0:
                return 'app';
            case 1:
                return 'integration';
            default:
                return 'solution';
        }
    };
    var $author$project$Api$Common$Marketplace$Product$ProductType$encode = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Api$Common$Marketplace$Product$ProductType$toString);
    var $author$project$Api$Common$Marketplace$Product$Status$toString = function(status) {
        switch(status){
            case 0:
                return 'hidden';
            case 1:
                return 'unpublished';
            case 2:
                return 'researching';
            case 3:
                return 'coming_soon';
            case 4:
                return 'beta';
            case 5:
                return 'live';
            case 6:
                return 'sunsetting';
            case 7:
                return 'deprecated';
            default:
                return 'decommissioned';
        }
    };
    var $author$project$Api$Common$Marketplace$Product$Status$encode = function(status) {
        return $elm$json$Json$Encode$string($author$project$Api$Common$Marketplace$Product$Status$toString(status));
    };
    var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString = function(feature) {
        if (!feature.$) return 'emr';
        else {
            var string = feature.a;
            return string;
        }
    };
    var $author$project$Api$Partner$PartnerProduct$encodePermittedFields = function(permittedFields) {
        var encodedFields = A3($elm$core$List$foldl, F2(function(field, acc) {
            switch(field.$){
                case 0:
                    var slug = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('slug', $elm$json$Json$Encode$string(slug)), acc);
                case 1:
                    var productType = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('product_type', $author$project$Api$Common$Marketplace$Product$ProductType$encode(productType)), acc);
                case 2:
                    var name = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(name)), acc);
                case 3:
                    var icon = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('marketplace_icon', $elm$json$Json$Encode$string(icon)), acc);
                case 4:
                    var summary = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('summary', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, summary)), acc);
                case 5:
                    var builtByName = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('built_by_name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, builtByName)), acc);
                case 6:
                    var builtByUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('built_by_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, builtByUrl)), acc);
                case 7:
                    var distributionType = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('distribution_type', $author$project$Api$Common$Marketplace$Product$DistributionType$encode(distributionType)), acc);
                case 8:
                    var featured = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('featured', $elm$json$Json$Encode$bool(featured)), acc);
                case 9:
                    var status = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('status', $author$project$Api$Common$Marketplace$Product$Status$encode(status)), acc);
                case 10:
                    var ctaUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('cta_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, ctaUrl)), acc);
                case 11:
                    var utmCampaign = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('utm_campaign', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, utmCampaign)), acc);
                case 12:
                    var utmContent = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('utm_content', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, utmContent)), acc);
                case 13:
                    var req = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('requirement', function() {
                        if (!req.$) {
                            if (!req.a.$) {
                                var feature = req.a.a;
                                return $elm$json$Json$Encode$object(_List_fromArray([
                                    _Utils_Tuple2('type', $elm$json$Json$Encode$string('feature')),
                                    _Utils_Tuple2('feature', $elm$json$Json$Encode$string($author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(feature)))
                                ]));
                            } else {
                                var value = req.a.a;
                                return $elm$json$Json$Encode$object(_List_fromArray([
                                    _Utils_Tuple2('type', $elm$json$Json$Encode$string('tier')),
                                    _Utils_Tuple2('starting_tier', $elm$json$Json$Encode$string(value))
                                ]));
                            }
                        } else return $elm$json$Json$Encode$null;
                    }()), acc);
                default:
                    var backlinkUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('backlink_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, backlinkUrl)), acc);
            }
        }), _List_Nil, permittedFields);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product', $elm$json$Json$Encode$object(encodedFields))
        ]));
    };
    var $author$project$Api$Partner$PartnerProduct$update = F4(function(apiClient, productId, permittedFields, toMsg) {
        var body = $author$project$Api$Partner$PartnerProduct$encodePermittedFields(permittedFields);
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$PartnerProduct$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProduct$productPathWithId(productId))));
    });
    var $author$project$Components$Partner$BaaForm$BaaAccepted = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$BaaAgreementAccepted = function(a) {
        return {
            $: 35,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$BaaType = function(a) {
        return {
            $: 34,
            a: a
        };
    };
    var $author$project$Components$Partner$BaaForm$GotCustomBaaAgreementUrl = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$BaaForm$GotUpdatedPartner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$BaaForm$None = {
        $: 0
    };
    var $author$project$Components$Partner$BaaForm$PartnerUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$BaaForm$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var baaType = field.a;
            return _Utils_update(fields, {
                J2: $elm$core$Maybe$Just(baaType)
            });
        } else {
            var bool = field.a;
            return _Utils_update(fields, {
                pD: bool
            });
        }
    });
    var $author$project$Components$Partner$BaaForm$BaaTypeValidation = 0;
    var $author$project$Components$Partner$BaaForm$BaaAcceptedValidation = 1;
    var $author$project$Components$Partner$BaaForm$validateBaaAccepted = function(fields) {
        return _Utils_eq(fields.J2, $elm$core$Maybe$Just(0)) && !fields.pD ? _List_fromArray([
            _Utils_Tuple2(1, 'Please agree to the BAA.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Partner$BaaForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.J2;
        }, _Utils_Tuple2(0, 'Please select a BAA type.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$BaaForm$validateBaaAccepted)
    ]));
    var $author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_custom_baa_agreement_url'
        ]), $author$project$Api$Partner$Partner$partnerPath)));
    });
    var $author$project$Components$Partner$BaaForm$toPermittedFields = F2(function(partner, fields) {
        return A2($elm$core$List$cons, $author$project$Api$Partner$Partner$BaaType(fields.J2), _Utils_eq($author$project$Api$Partner$Partner$One$baaDocumentAgreement(partner), $elm$core$Maybe$Nothing) && _Utils_eq(fields.J2, $elm$core$Maybe$Just(0)) ? _List_fromArray([
            $author$project$Api$Partner$Partner$BaaAgreementAccepted(fields.pD)
        ]) : _List_Nil);
    });
    var $author$project$Components$Partner$BaaForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                if (field.$ === 1 && field.a) {
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$BaaForm$formFieldsUpdate, $author$project$Components$Partner$BaaForm$BaaAccepted(true), model.PU);
                    var fields = $author$project$Utils$Form$fields(model.PU);
                    return {
                        EQ: A3($author$project$Api$Partner$Partner$update, apiClient, _List_fromArray([
                            $author$project$Api$Partner$Partner$BaaType(fields.J2),
                            $author$project$Api$Partner$Partner$BaaAgreementAccepted(true)
                        ]), $author$project$Components$Partner$BaaForm$GotUpdatedPartner),
                        adu: $author$project$Components$Partner$BaaForm$None,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            o2: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$BaaForm$formFieldsUpdate, field, model.PU);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Partner$BaaForm$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 1:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$BaaForm$formFieldsValidator, model.PU);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var updatedForm = _v4.a;
                    var validFormFields = _v4.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var permittedFields = A2($author$project$Components$Partner$BaaForm$toPermittedFields, model.VW, fields);
                    return {
                        EQ: A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$BaaForm$GotUpdatedPartner),
                        adu: $author$project$Components$Partner$BaaForm$None,
                        zi: _Utils_update(model, {
                            PU: updatedForm,
                            o2: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var updatedForm = _v3.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Partner$BaaForm$None,
                        zi: _Utils_update(model, {
                            PU: updatedForm,
                            o2: $author$project$Api$Data$NotAsked
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var partner = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Partner$BaaForm$PartnerUpdated(partner),
                        zi: _Utils_update(model, {
                            PU: $author$project$Utils$Form$init($author$project$Components$Partner$BaaForm$initFormFields(partner)),
                            VW: partner,
                            o2: response
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                            $author$project$OutMsg$RefreshPartner
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Partner$BaaForm$None,
                    zi: _Utils_update(model, {
                        o2: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                return {
                    EQ: A2($author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl, apiClient, $author$project$Components$Partner$BaaForm$GotCustomBaaAgreementUrl),
                    adu: $author$project$Components$Partner$BaaForm$None,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return {
                        EQ: $author$project$Ports$Navigation$openInNewWindow(url),
                        adu: $author$project$Components$Partner$BaaForm$None,
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Partner$BaaForm$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Api$Partner$Partner$AddendumAgreementAccepted = function(a) {
        return {
            $: 29,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ApiAccessAgreementAccepted = function(a) {
        return {
            $: 36,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$GotAddendumAgreementUrl = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$GotApiAccessAgreementUrl = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$GotCustomPartnerAgreementUrl = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$None = {
        $: 0
    };
    var $author$project$Api$Partner$Partner$PartnerAgreementAccepted = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$PartnerUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ai: bool
                });
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    tP: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    vx: bool
                });
        }
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
    var $author$project$Api$Partner$Partner$signedAddendumAgreementUrl = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_addendum_agreement_url'
        ]), $author$project$Api$Partner$Partner$partnerPath)));
    });
    var $author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_custom_api_access_agreement_url'
        ]), $author$project$Api$Partner$Partner$partnerPath)));
    });
    var $author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, A2($elm$json$Json$Decode$field, 'url', $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_custom_partner_agreement_url'
        ]), $author$project$Api$Partner$Partner$partnerPath)));
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$toPermittedFields = F2(function(partner, fields) {
        return _Utils_ap(_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(partner), $elm$core$Maybe$Nothing) && _Utils_eq($author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner), $elm$core$Maybe$Nothing) ? _List_fromArray([
            $author$project$Api$Partner$Partner$PartnerAgreementAccepted(fields.Ai)
        ]) : _List_Nil, _Utils_ap(_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(partner), $elm$core$Maybe$Nothing) && _Utils_eq($author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner), $elm$core$Maybe$Nothing) ? _List_fromArray([
            $author$project$Api$Partner$Partner$AddendumAgreementAccepted(fields.tP)
        ]) : _List_Nil, !_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(partner), $elm$core$Maybe$Nothing) && _Utils_eq($author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner), $elm$core$Maybe$Nothing) ? _List_fromArray([
            $author$project$Api$Partner$Partner$ApiAccessAgreementAccepted(fields.vx)
        ]) : _List_Nil));
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                _v2$3: while(true)switch(field.$){
                    case 0:
                        if (field.a) return {
                            EQ: A3($author$project$Api$Partner$Partner$update, apiClient, _List_fromArray([
                                $author$project$Api$Partner$Partner$PartnerAgreementAccepted(true)
                            ]), $author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
                            adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                            zi: _Utils_update(model, {
                                PU: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.PU),
                                o2: $author$project$Api$Data$Loading
                            }),
                            at: _List_Nil
                        };
                        else break _v2$3;
                    case 1:
                        if (field.a) return {
                            EQ: A3($author$project$Api$Partner$Partner$update, apiClient, _List_fromArray([
                                $author$project$Api$Partner$Partner$AddendumAgreementAccepted(true)
                            ]), $author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
                            adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                            zi: _Utils_update(model, {
                                PU: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.PU),
                                o2: $author$project$Api$Data$Loading
                            }),
                            at: _List_Nil
                        };
                        else break _v2$3;
                    default:
                        if (field.a) return {
                            EQ: A3($author$project$Api$Partner$Partner$update, apiClient, _List_fromArray([
                                $author$project$Api$Partner$Partner$ApiAccessAgreementAccepted(true)
                            ]), $author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
                            adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                            zi: _Utils_update(model, {
                                PU: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.PU),
                                o2: $author$project$Api$Data$Loading
                            }),
                            at: _List_Nil
                        };
                        else break _v2$3;
                }
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                    zi: _Utils_update(model, {
                        PU: A3($author$project$Utils$Form$update, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsUpdate, field, model.PU)
                    }),
                    at: _List_Nil
                };
            case 1:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$DocumentsAgreementsForm$formFieldsValidator, model.PU);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var updatedForm = _v4.a;
                    var validFormFields = _v4.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var permittedFields = A2($author$project$Components$Partner$DocumentsAgreementsForm$toPermittedFields, model.VW, fields);
                    return {
                        EQ: A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$DocumentsAgreementsForm$GotUpdatedPartner),
                        adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                        zi: _Utils_update(model, {
                            PU: updatedForm,
                            o2: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var updatedForm = _v3.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                        zi: _Utils_update(model, {
                            PU: updatedForm,
                            o2: $author$project$Api$Data$NotAsked
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var partner = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Partner$DocumentsAgreementsForm$PartnerUpdated(partner),
                        zi: _Utils_update(model, {
                            PU: $author$project$Utils$Form$init($author$project$Components$Partner$DocumentsAgreementsForm$initFormFields(partner)),
                            VW: partner,
                            o2: response
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                            $author$project$OutMsg$RefreshPartner
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                    zi: _Utils_update(model, {
                        o2: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                return {
                    EQ: A2($author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotCustomPartnerAgreementUrl),
                    adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return {
                        EQ: $author$project$Ports$Navigation$openInNewWindow(url),
                        adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 5:
                return {
                    EQ: A2($author$project$Api$Partner$Partner$signedAddendumAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotAddendumAgreementUrl),
                    adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return {
                        EQ: $author$project$Ports$Navigation$openInNewWindow(url),
                        adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 4:
                return {
                    EQ: A2($author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl, apiClient, $author$project$Components$Partner$DocumentsAgreementsForm$GotApiAccessAgreementUrl),
                    adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return {
                        EQ: $author$project$Ports$Navigation$openInNewWindow(url),
                        adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Partner$DocumentsAgreementsForm$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Partner$Form$Logo = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$Form$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    zr: string
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    abn: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    TH: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    _u: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    $y: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Xz: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    Ro: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var _int = field.a;
                var string = field.b;
                return _Utils_Tuple3(_Utils_update(fields, {
                    MM: $elm$core$Maybe$Just(string),
                    Ge: _int,
                    Tu: $elm$core$Maybe$Just(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    OH: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var string = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    $U: $author$project$Utils$String$toMaybe(string)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var bool = field.a;
                return _Utils_Tuple3(_Utils_update(fields, {
                    aa2: bool
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var addressMsg = field.a;
                var _v1 = A2($author$project$Components$AddressInput$update, addressMsg, fields.II);
                var addressInput = _v1.a;
                var cmd = _v1.b;
                var outMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(fields, {
                    II: addressInput
                }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address), cmd), outMsgs);
        }
    });
    var $author$project$Components$Partner$Form$update = F2(function(msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var field = msg.a;
            var _v2 = A3($author$project$Utils$Form$updateWithCmdAndOutMsgs, $author$project$Components$Partner$Form$formFieldsUpdate, field, model.PU);
            var newForm = _v2.a;
            var cmd = _v2.b;
            var outMsgs = _v2.c;
            return _Utils_Tuple3(_Utils_update(model, {
                PU: newForm
            }), cmd, outMsgs);
        } else {
            var logos = msg.a;
            var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v3) {
                var task = _v3.a;
                var size = _v3.b;
                return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Logo(size)), task);
            }, A2($elm$core$Maybe$map, function(logo) {
                return _Utils_Tuple2($elm$file$File$toUrl(logo), $elm$file$File$size(logo));
            }, $elm$core$List$head(logos))));
            return _Utils_Tuple3(model, cmd, _List_Nil);
        }
    });
    var $author$project$Components$Partner$Form$LogoValidation = 5;
    var $author$project$Components$Partner$Form$NameValidation = 0;
    var $author$project$Components$Partner$Form$TechnicalEmailValidation = 7;
    var $author$project$Components$Partner$Form$WebsiteUrlValidation = 1;
    var $author$project$Components$Partner$Form$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Partner$Form$AddressValidation = 8;
    var $author$project$Components$Partner$Form$validateAddress = function(fields) {
        return $author$project$Components$AddressInput$isValid(fields.II) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(8, 'Please enter an address')
        ]);
    };
    var $author$project$Components$Partner$Form$validateRequiredMaybeString = F4(function(getter, validationGroup, errorMsg, fields) {
        var _v0 = getter(fields);
        if (_v0.$ === 1) return _List_fromArray([
            _Utils_Tuple2(validationGroup, errorMsg)
        ]);
        else {
            var value = _v0.a;
            return $elm$core$String$isEmpty(value) ? _List_fromArray([
                _Utils_Tuple2(validationGroup, errorMsg)
            ]) : _List_Nil;
        }
    });
    var $author$project$Components$Partner$Form$validateUrlRequired = F4(function(getter, validationGroup, errorMsg, fields) {
        var _v0 = getter(fields);
        if (_v0.$ === 1) return _List_fromArray([
            _Utils_Tuple2(validationGroup, errorMsg)
        ]);
        else {
            var url = _v0.a;
            return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray([
                _Utils_Tuple2(validationGroup, 'URL must start with http:// or https://')
            ]) : _List_Nil;
        }
    });
    var $author$project$Components$Partner$Form$formFieldsValidatorAll = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a name.')),
        A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
            return $.Ge;
        }, $author$project$Components$Partner$Form$maxLogoBytesSize, _Utils_Tuple2(5, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')),
        $rtfeldman$elm_validate$Validate$fromErrors(A3($author$project$Components$Partner$Form$validateUrlRequired, function($) {
            return $.abn;
        }, 1, 'Please enter a website URL.')),
        $rtfeldman$elm_validate$Validate$fromErrors(A3($author$project$Components$Partner$Form$validateRequiredMaybeString, function($) {
            return $.$U;
        }, 7, 'Please enter a technical email.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$Form$validateAddress)
    ]));
    var $author$project$Api$Partner$Partner$Address = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$WebsiteUrl = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$toPermittedFields = function(fields) {
        return A2($elm$core$List$cons, $author$project$Api$Partner$Partner$Name(fields.zr), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$WebsiteUrl(fields.abn), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$MarketingUrl(fields.TH), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$SignupUrl(fields._u), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$SupportUrl(fields.$y), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$ProductDescription(fields.Xz), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$IntegrationDescription(fields.Ro), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$Email(fields.OH), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$TechnicalEmail(A2($elm$core$Maybe$withDefault, '', fields.$U)), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$UsesIntegrationRecords(fields.aa2), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$Address(A2($author$project$Components$AddressInput$encodeWithPrefix, '', fields.II)), function() {
            var _v0 = fields.Tu;
            if (!_v0.$) {
                var logoUrl = _v0.a;
                return _List_fromArray([
                    $author$project$Api$Partner$Partner$Logo(logoUrl)
                ]);
            } else return _List_Nil;
        }())))))))))));
    };
    var $author$project$Components$Partner$Form$validate = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        var validatedAddress = $author$project$Components$AddressInput$validate(fields.II);
        var updatedFields = _Utils_update(fields, {
            II: validatedAddress
        });
        var updatedForm = A2($author$project$Utils$Form$set, updatedFields, model.PU);
        var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$Form$formFieldsValidatorAll, updatedForm);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var validFormFields = _v2.b;
            var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
            return $elm$core$Result$Ok($author$project$Components$Partner$Form$toPermittedFields(validFields));
        } else {
            var validatedForm = _v1.a;
            return $elm$core$Result$Err(_Utils_update(model, {
                PU: validatedForm
            }));
        }
    };
    var $author$project$Pages$Partner$Dashboard$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = model.be;
                if (!_v1.$) {
                    var partnerForm = _v1.a;
                    var _v2 = A2($author$project$Components$Partner$Form$update, subMsg, partnerForm);
                    var updatedForm = _v2.a;
                    var cmd = _v2.b;
                    var outMsgs = _v2.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        be: $elm$core$Maybe$Just(updatedForm)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg, cmd), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var subMsg = msg.a;
                var baaFormResult = A3($author$project$Components$Partner$BaaForm$update, model.Ej, subMsg, model.bR);
                var _v3 = baaFormResult.adu;
                if (!_v3.$) return _Utils_Tuple3(_Utils_update(model, {
                    bR: baaFormResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormResult.EQ), baaFormResult.at);
                else {
                    var partner = _v3.a;
                    var _v4 = A2($author$project$Components$Partner$DocumentsAgreementsForm$init, model.HO, partner);
                    var documentsAgreementsForm = _v4.a;
                    var documentsAgreementsFormCmd = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bR: baaFormResult.zi,
                        b4: documentsAgreementsForm,
                        mb: $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(partner),
                        VW: partner
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormResult.EQ),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
                    ])), baaFormResult.at);
                }
            case 2:
                var subMsg = msg.a;
                var documentsAgreementsFormResult = A3($author$project$Components$Partner$DocumentsAgreementsForm$update, model.Ej, subMsg, model.b4);
                var _v5 = documentsAgreementsFormResult.adu;
                if (!_v5.$) return _Utils_Tuple3(_Utils_update(model, {
                    b4: documentsAgreementsFormResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormResult.EQ), documentsAgreementsFormResult.at);
                else {
                    var partner = _v5.a;
                    var _v6 = A2($author$project$Components$Partner$BaaForm$init, model.HO, partner);
                    var baaForm = _v6.a;
                    var baaFormCmd = _v6.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bR: baaForm,
                        b4: documentsAgreementsFormResult.zi,
                        mb: $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(partner),
                        VW: partner
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormResult.EQ),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd)
                    ])), documentsAgreementsFormResult.at);
                }
            case 3:
                var _v7 = model.be;
                if (!_v7.$) {
                    var partnerForm = _v7.a;
                    var _v8 = $author$project$Components$Partner$Form$validate(partnerForm);
                    if (!_v8.$) {
                        var permittedFields = _v8.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            o2: $author$project$Api$Data$Loading
                        }), A3($author$project$Api$Partner$Partner$update, model.Ej, permittedFields, $author$project$Pages$Partner$Dashboard$Top$GotUpdatedPartner), _List_Nil);
                    } else {
                        var updatedForm = _v8.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            be: $elm$core$Maybe$Just(updatedForm),
                            o2: $author$project$Api$Data$NotAsked
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var partner = response.a;
                    var onboarded = $author$project$Pages$Partner$Dashboard$Top$isPartnerOnboarded(partner);
                    var partnerForm = onboarded ? $elm$core$Maybe$Nothing : model.be;
                    var expandedSections = $author$project$Pages$Partner$Dashboard$Top$autoAdvanceSections(partner);
                    var _v10 = A2($author$project$Components$Partner$DocumentsAgreementsForm$init, model.HO, partner);
                    var documentsAgreementsForm = _v10.a;
                    var documentsAgreementsFormCmd = _v10.b;
                    var _v11 = A2($author$project$Components$Partner$BaaForm$init, model.HO, partner);
                    var baaForm = _v11.a;
                    var baaFormCmd = _v11.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bR: baaForm,
                        e8: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Partner$PartnerProduct$Shared$backlinkUrl, $author$project$Api$Partner$Partner$One$product(partner))),
                        b4: documentsAgreementsForm,
                        mb: expandedSections,
                        Vs: onboarded,
                        VW: partner,
                        be: partnerForm,
                        o2: response
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaFormCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, documentsAgreementsFormCmd)
                    ])), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                        $author$project$OutMsg$RefreshPartner
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    o2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var _v12 = $author$project$Components$Partner$Form$init(model.VW);
                var partnerForm = _v12.a;
                var partnerFormCmd = _v12.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    be: $elm$core$Maybe$Just(partnerForm)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg, partnerFormCmd), _List_Nil);
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    be: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var docResult = A3($author$project$Components$Partner$DocumentsAgreementsForm$update, model.Ej, $author$project$Components$Partner$DocumentsAgreementsForm$saveMsg, model.b4);
                var baaResult = A3($author$project$Components$Partner$BaaForm$update, model.Ej, $author$project$Components$Partner$BaaForm$saveMsg, model.bR);
                return _Utils_Tuple3(_Utils_update(model, {
                    bR: baaResult.zi,
                    b4: docResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg, docResult.EQ),
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, baaResult.EQ)
                ])), _Utils_ap(docResult.at, baaResult.at));
            case 8:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    jW: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Partner$PartnerProduct$requestReview, model.Ej, id, $author$project$Pages$Partner$Dashboard$Top$GotReviewResponse), _List_Nil);
            case 9:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    jW: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Review requested! The Hint team will review your listing shortly.')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    jW: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 10:
                var url = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    e8: url
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var _v14 = $author$project$Api$Partner$Partner$One$product(model.VW);
                if (!_v14.$) {
                    var product = _v14.a;
                    var url = $elm$core$String$isEmpty($elm$core$String$trim(model.e8)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($elm$core$String$trim(model.e8));
                    return _Utils_Tuple3(_Utils_update(model, {
                        lc: $author$project$Api$Data$Loading
                    }), A4($author$project$Api$Partner$PartnerProduct$update, model.Ej, $author$project$Api$Partner$PartnerProduct$Shared$id(product), _List_fromArray([
                        $author$project$Api$Partner$PartnerProduct$BacklinkUrl(url)
                    ]), $author$project$Pages$Partner$Dashboard$Top$GotBacklinkUrlResponse), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    lc: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Backlink URL saved!'),
                    $author$project$OutMsg$RefreshPartner
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    lc: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var url = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(url), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Listing URL copied to clipboard!')
                ]));
        }
    });
    var $author$project$Pages$Partner$Dashboard$Top$SaveAgreements = {
        $: 7
    };
    var $author$project$Components$Partner$BaaForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$BaaForm$OpenCustomBaaAgreement = {
        $: 3
    };
    var $author$project$Api$Partner$Partner$One$customBaaAgreementFileName = function(_v0) {
        var record = _v0.b;
        return record.MS;
    };
    var $author$project$Api$Partner$User$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Utils$HintUrls$partnerBaaUrl = 'https://www.hint.com/partnerbaa';
    var $author$project$Ui$OrderedList$Roman = {
        $: 1
    };
    var $author$project$Ui$OrderedList$roman = $author$project$Ui$OrderedList$Roman;
    var $author$project$Api$Partner$DocumentAgreement$Shared$signedAt = function(_v0) {
        var record = _v0;
        return record._n;
    };
    var $author$project$Api$Partner$DocumentAgreement$Shared$user = function(_v0) {
        var record = _v0;
        return record.aaX;
    };
    var $author$project$Components$Partner$BaaForm$BaaType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Radio$Card = {
        $: 6
    };
    var $author$project$Ui$Form$Radio$card = $author$project$Ui$Form$Radio$Card;
    var $author$project$Ui$Typography$FullWidth = {
        $: 37
    };
    var $author$project$Ui$Typography$fullWidth = $author$project$Ui$Typography$FullWidth;
    var $author$project$Components$Partner$BaaForm$viewBaaTypeButton = F2(function(currentBaaType, baaType) {
        var _v0 = function() {
            if (!baaType) return _Utils_Tuple2("Subcontractor Business Associate (Under Hint\u2019s BAA)", _List_fromArray([
                'You will enter into a Business Associate Agreement with Hint as a subcontractor business associate. This BAA will govern your access to and use of Protected Health Information (PHI) in connection with joint customers.',
                "Under this model, Hint maintains BAAs with Covered Entities, and you operate as Hint\u2019s subcontractor."
            ]));
            else return _Utils_Tuple2('Independent Business Associate (Direct BAAs with Covered Entities)', _List_fromArray([
                'You will not enter into a BAA with Hint. If you create, receive, maintain, or transmit Protected Health Information on behalf of your customers, you are responsible for determining whether you are a Business Associate and for entering into any required Business Associate Agreements directly with those Covered Entities.',
                'Hint will not be a party to, or responsible for, any such agreements.',
                'If your product is made available through the Hint Marketplace, Hint can facilitate the presentation and execution of your BAA (or other required terms) directly between you and participating practices during the onboarding and installation process.'
            ]));
        }();
        var label = _v0.a;
        var notes = _v0.b;
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$span(6)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                $author$project$Ui$Form$Radio$card,
                $author$project$Ui$Form$Radio$value(_Utils_eq(currentBaaType, $elm$core$Maybe$Just(baaType))),
                $author$project$Ui$Form$Radio$onCheck($elm$core$Basics$always($author$project$Components$Partner$BaaForm$FormUpdated($author$project$Components$Partner$BaaForm$BaaType(baaType))))
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$titleSm, _List_fromArray([
                    $author$project$Ui$Typography$fullWidth,
                    $author$project$Ui$Typography$margin(5)
                ]), _List_fromArray([
                    $elm$html$Html$text(label)
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, function(note) {
                        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(note)
                        ]));
                    }, notes))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Partner$BaaForm$panelBody = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var baaAgreementLink = function() {
            var _v4 = $author$project$Api$Partner$Partner$One$customBaaAgreementFileName(model.VW);
            if (!_v4.$) return A3($author$project$Ui$Button$view, {
                abP: 'View Business Associate Agreement'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Components$Partner$BaaForm$OpenCustomBaaAgreement)
            ]), _List_fromArray([
                $elm$html$Html$text('Business Associate Agreement')
            ]));
            else return A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$partnerBaaUrl, _List_fromArray([
                $author$project$Ui$Link$targetBlank
            ]), _List_fromArray([
                $elm$html$Html$text('Business Associate Agreement')
            ]));
        }();
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Business Associate Agreement')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Components$Partner$BaaForm$viewBaaTypeButton, fields.J2, 0),
                        A2($author$project$Components$Partner$BaaForm$viewBaaTypeButton, fields.J2, 1)
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(12)
                        ]), _List_fromArray([
                            function() {
                                var _v0 = _Utils_Tuple2(fields.J2, $author$project$Api$Partner$Partner$One$baaDocumentAgreement(model.VW));
                                if (!_v0.a.$ && !_v0.a.a) {
                                    if (!_v0.b.$) {
                                        var _v1 = _v0.a.a;
                                        var baaDocumentAgreement = _v0.b.a;
                                        return A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$itemsCenter,
                                            $author$project$Ui$Element$gap2,
                                            $author$project$Ui$Element$mt2
                                        ]), _List_fromArray([
                                            $author$project$Ui$Icon$check(_List_fromArray([
                                                $author$project$Ui$Icon$success
                                            ])),
                                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text($author$project$Api$Partner$User$Shared$name($author$project$Api$Partner$DocumentAgreement$Shared$user(baaDocumentAgreement))),
                                                $elm$html$Html$text(' agreed to the '),
                                                baaAgreementLink,
                                                $elm$html$Html$text(' on '),
                                                $elm$html$Html$text(A2(model.HO, 6, $author$project$Api$Partner$DocumentAgreement$Shared$signedAt(baaDocumentAgreement)))
                                            ]))
                                        ]));
                                    } else {
                                        var _v2 = _v0.a.a;
                                        var _v3 = _v0.b;
                                        return A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$flexCol,
                                            $author$project$Ui$Element$gap4,
                                            $author$project$Ui$Element$mt2
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                                $author$project$Ui$Typography$small
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('By selecting \"I Agree,\" you:'),
                                                A2($author$project$Ui$OrderedList$view, _List_fromArray([
                                                    $author$project$Ui$OrderedList$roman
                                                ]), _List_fromArray([
                                                    A2($author$project$Ui$OrderedList$item, _List_Nil, _List_fromArray([
                                                        $elm$html$Html$text('confirm that you have read and agree to Hint\'s '),
                                                        baaAgreementLink
                                                    ])),
                                                    A2($author$project$Ui$OrderedList$item, _List_Nil, _List_fromArray([
                                                        $elm$html$Html$text('represent and warrant that you are an authorized representative of '),
                                                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                            $elm$html$Html$text($author$project$Api$Partner$Partner$One$name(model.VW))
                                                        ])),
                                                        $elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
                                                    ])),
                                                    A2($author$project$Ui$OrderedList$item, _List_Nil, _List_fromArray([
                                                        $elm$html$Html$text('agree that this electronic acceptance constitutes a legally binding agreement between Hint Health, Inc. and '),
                                                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                            $elm$html$Html$text($author$project$Api$Partner$Partner$One$name(model.VW))
                                                        ])),
                                                        $elm$html$Html$text(', effective as of the date of acceptance.')
                                                    ]))
                                                ])),
                                                $elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
                                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                                    $elm$html$Html$text($author$project$Api$Partner$Partner$One$name(model.VW))
                                                ])),
                                                $elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
                                            ])),
                                            A3($author$project$Ui$Button$view, {
                                                abP: 'I Agree to Business Associate Agreement'
                                            }, _List_fromArray([
                                                $author$project$Ui$Button$primary,
                                                $author$project$Ui$Button$onClick($author$project$Components$Partner$BaaForm$FormUpdated($author$project$Components$Partner$BaaForm$BaaAccepted(true)))
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('I Agree')
                                            ]))
                                        ]));
                                    }
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, model.PU)),
                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Partner$BaaForm$viewBody = function(_v0) {
        var model = _v0;
        return $author$project$Components$Partner$BaaForm$panelBody(model);
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$AddendumAgreementAccepted = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$OpenAddendumAgreement = {
        $: 5
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$viewAgreedLine = F3(function(timeFormatter, agreementLink, documentAgreement) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$gap2
        ]), _List_fromArray([
            $author$project$Ui$Icon$check(_List_fromArray([
                $author$project$Ui$Icon$success
            ])),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$User$Shared$name($author$project$Api$Partner$DocumentAgreement$Shared$user(documentAgreement))),
                $elm$html$Html$text(' agreed to the '),
                agreementLink,
                $elm$html$Html$text(' on '),
                $elm$html$Html$text(A2(timeFormatter, 6, $author$project$Api$Partner$DocumentAgreement$Shared$signedAt(documentAgreement)))
            ]))
        ]));
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$viewAgreementTerms = F2(function(partner, agreementLink) {
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$small
        ]), _List_fromArray([
            $elm$html$Html$text('By selecting \"I Agree,\" you:'),
            A2($author$project$Ui$OrderedList$view, _List_fromArray([
                $author$project$Ui$OrderedList$roman
            ]), _List_fromArray([
                A2($author$project$Ui$OrderedList$item, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('confirm that you have read and agree to Hint\'s '),
                    agreementLink
                ])),
                A2($author$project$Ui$OrderedList$item, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('represent and warrant that you are an authorized representative of '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Partner$Partner$One$name(partner))
                    ])),
                    $elm$html$Html$text(' with full authority to legally bind the entity to this Agreement; and')
                ])),
                A2($author$project$Ui$OrderedList$item, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('agree that this electronic acceptance constitutes a legally binding agreement between Hint Health, Inc. and '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Partner$Partner$One$name(partner))
                    ])),
                    $elm$html$Html$text(', effective as of the date of acceptance.')
                ]))
            ])),
            $elm$html$Html$text('You further agree that your electronic acceptance on behalf of '),
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$Partner$One$name(partner))
            ])),
            $elm$html$Html$text(' has the same legal effect as a handwritten signature and satisfies any requirement that the Agreement be in writing.')
        ]));
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement = F3(function(partner, agreementLink, agreeMsg) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flexCol,
            $author$project$Ui$Element$gap4
        ]), _List_fromArray([
            A2($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreementTerms, partner, agreementLink),
            A3($author$project$Ui$Button$view, {
                abP: 'I Agree'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick(agreeMsg)
            ]), _List_fromArray([
                $elm$html$Html$text('I Agree')
            ]))
        ]));
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$viewAddendumAgreement = F2(function(timeFormatter, partner) {
        var _v0 = $author$project$Api$Partner$Partner$One$addendumAgreementFileName(partner);
        if (!_v0.$) {
            var agreementLink = A3($author$project$Ui$Button$view, {
                abP: 'View addendum agreement'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenAddendumAgreement)
            ]), _List_fromArray([
                $elm$html$Html$text('Addendum Agreement')
            ]));
            return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Addendum Agreement')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    function() {
                        var _v1 = $author$project$Api$Partner$Partner$One$addendumDocumentAgreement(partner);
                        if (!_v1.$) {
                            var documentAgreement = _v1.a;
                            return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreedLine, timeFormatter, agreementLink, documentAgreement);
                        } else return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement, partner, agreementLink, $author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated($author$project$Components$Partner$DocumentsAgreementsForm$AddendumAgreementAccepted(true)));
                    }()
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$ApiAccessAgreementAccepted = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomApiAccessAgreement = {
        $: 4
    };
    var $author$project$Utils$HintUrls$apiAccessAgreementUrl = 'https://www.hint.com/api-access-agreement';
    var $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName = function(_v0) {
        var record = _v0.b;
        return record.MR;
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$viewApiAccessAgreement = F2(function(timeFormatter, partner) {
        var agreementLink = function() {
            var _v1 = $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName(partner);
            if (!_v1.$) return A3($author$project$Ui$Button$view, {
                abP: 'View API access agreement'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomApiAccessAgreement)
            ]), _List_fromArray([
                $elm$html$Html$text('API Access Agreement')
            ]));
            else return A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$apiAccessAgreementUrl, _List_fromArray([
                $author$project$Ui$Link$targetBlank
            ]), _List_fromArray([
                $elm$html$Html$text('API Access Agreement')
            ]));
        }();
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('API Access Agreement')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Partner$Partner$One$apiAccessDocumentAgreement(partner);
                    if (!_v0.$) {
                        var documentAgreement = _v0.a;
                        return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreedLine, timeFormatter, agreementLink, documentAgreement);
                    } else return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement, partner, agreementLink, $author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated($author$project$Components$Partner$DocumentsAgreementsForm$ApiAccessAgreementAccepted(true)));
                }()
            ]))
        ]));
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomPartnerAgreement = {
        $: 3
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$PartnerAgreementAccepted = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName = function(_v0) {
        var record = _v0.b;
        return record.MY;
    };
    var $author$project$Utils$HintUrls$partnerAgreementUrl = 'http://www.hint.com/partner-agreement';
    var $author$project$Components$Partner$DocumentsAgreementsForm$viewPartnerAgreement = F2(function(timeFormatter, partner) {
        var agreementLink = function() {
            var _v1 = $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName(partner);
            if (!_v1.$) return A3($author$project$Ui$Button$view, {
                abP: 'View partner agreement'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Components$Partner$DocumentsAgreementsForm$OpenCustomPartnerAgreement)
            ]), _List_fromArray([
                $elm$html$Html$text('Partner Agreement')
            ]));
            else return A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$partnerAgreementUrl, _List_fromArray([
                $author$project$Ui$Link$targetBlank
            ]), _List_fromArray([
                $elm$html$Html$text('Partner Agreement')
            ]));
        }();
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Partner Agreement')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Partner$Partner$One$partnerDocumentAgreement(partner);
                    if (!_v0.$) {
                        var documentAgreement = _v0.a;
                        return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewAgreedLine, timeFormatter, agreementLink, documentAgreement);
                    } else return A3($author$project$Components$Partner$DocumentsAgreementsForm$viewUnsignedAgreement, partner, agreementLink, $author$project$Components$Partner$DocumentsAgreementsForm$FormUpdated($author$project$Components$Partner$DocumentsAgreementsForm$PartnerAgreementAccepted(true)));
                }()
            ]))
        ]));
    });
    var $author$project$Components$Partner$DocumentsAgreementsForm$panelList = function(model) {
        return _List_fromArray([
            _Utils_eq($author$project$Api$Partner$Partner$One$managedBy(model.VW), $elm$core$Maybe$Nothing) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewPartnerAgreement, model.HO, model.VW) : $author$project$Utils$Html$empty,
            _Utils_eq($author$project$Api$Partner$Partner$One$managedBy(model.VW), $elm$core$Maybe$Nothing) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewAddendumAgreement, model.HO, model.VW) : $author$project$Utils$Html$empty,
            !_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(model.VW), $elm$core$Maybe$Nothing) ? A2($author$project$Components$Partner$DocumentsAgreementsForm$viewApiAccessAgreement, model.HO, model.VW) : $author$project$Utils$Html$empty
        ]);
    };
    var $author$project$Components$Partner$DocumentsAgreementsForm$viewPanels = function(_v0) {
        var model = _v0;
        return $author$project$Components$Partner$DocumentsAgreementsForm$panelList(model);
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewAgreementsContent = function(model) {
        var baaSection = function() {
            var _v0 = $author$project$Api$Partner$Partner$One$managedBy(model.VW);
            if (!_v0.$) return _List_Nil;
            else return _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Partner$Dashboard$Top$BaaFormMsg, $author$project$Components$Partner$BaaForm$viewBody(model.bR))
            ]);
        }();
        return A2($elm$html$Html$div, _List_Nil, _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$Dashboard$Top$DocumentsAgreementsFormMsg), $author$project$Components$Partner$DocumentsAgreementsForm$viewPanels(model.b4)), _Utils_ap(baaSection, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyCenter,
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Save agreements'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$SaveAgreements)
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]))));
    };
    var $author$project$Pages$Partner$Dashboard$Top$CancelEdit = {
        $: 6
    };
    var $author$project$Pages$Partner$Dashboard$Top$EditClicked = {
        $: 5
    };
    var $author$project$Pages$Partner$Dashboard$Top$Save = {
        $: 3
    };
    var $author$project$Components$Partner$Form$Minimal = 0;
    var $author$project$Components$Partner$Form$minimal = 0;
    var $author$project$Components$Partner$Form$Email = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$EmailValidation = 6;
    var $author$project$Components$Partner$Form$IntegrationDescription = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$LogoUploaded = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$MarketingUrl = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$MarketingUrlValidation = 2;
    var $author$project$Components$Partner$Form$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$ProductDescription = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$SignupUrl = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$SignupUrlValidation = 3;
    var $author$project$Components$Partner$Form$SupportUrl = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$SupportUrlValidation = 4;
    var $author$project$Components$Partner$Form$TechnicalEmail = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$UsesIntegrationRecords = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$WebsiteUrl = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$Form$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, acc) {
            return _Utils_update(acc, {
                ga: true
            });
        }), {
            ga: false
        }, options);
    };
    var $author$project$Components$Partner$Form$view = F2(function(options, _v0) {
        var model = _v0;
        var optionsRecord = $author$project$Components$Partner$Form$optionsToRecord(options);
        var unlessMinimal = function(field) {
            return optionsRecord.ga ? $elm$html$Html$text('') : field;
        };
        var isManaged = !_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(model.VW), $elm$core$Maybe$Nothing);
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Legal Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Legal Address'),
                $author$project$Ui$Form$Group$required(!optionsRecord.ga)
            ]), _List_fromArray([
                A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Address), A2($author$project$Components$AddressInput$view, _List_Nil, fields.II)),
                $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 8, model.PU))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Website URL'),
                $author$project$Ui$Form$Group$required(!optionsRecord.ga)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.abn)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$WebsiteUrl)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                ]))
            ])),
            isManaged ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Logo (Horizontal)')
                ]), _List_fromArray([
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(0),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Partner$Form$LogoUploaded),
                        $author$project$Ui$Form$File$empty(true)
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted,
                        $author$project$Ui$Element$textSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Preferred format: SVG or PNG')
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Aspect ratio: Horizontal (aproximately 3:1)')
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Minimum width: 300px')
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Content: May include your company name or wordmark')
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mt2
                        ]), _List_fromArray([
                            $elm$html$Html$text('This asset may be used in larger layouts or future branding surfaces.')
                        ]))
                    ]))
                ])),
                function() {
                    var _v1 = fields.MM;
                    if (!_v1.$) {
                        var url = _v1.a;
                        return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpanSm(4),
                            $author$project$Ui$Form$Group$inputSpanSm(8),
                            $author$project$Ui$Form$Group$label('')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Image$fromSrc, {
                                Jg: 'Logo'
                            }, url, _List_fromArray([
                                $author$project$Ui$Image$height(50)
                            ])),
                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 5, model.PU))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Technical Notifications'),
                $author$project$Ui$Form$Group$required(!optionsRecord.ga)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.$U)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$TechnicalEmail)),
                    $author$project$Ui$Form$Input$placeholder('contact@mypartner.com'),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 7, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 7, model.PU))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt2,
                    $author$project$Ui$Element$textSm,
                    $author$project$Ui$Element$textMuted
                ]), _List_fromArray([
                    $elm$html$Html$text('Email for technical alerts (e.g., webhook failures, outages, planned downtime); use a shared mailing list to avoid a single point of failure.')
                ]))
            ])),
            unlessMinimal(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Email'),
                $author$project$Ui$Form$Group$required(!optionsRecord.ga)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.OH)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$Email)),
                    $author$project$Ui$Form$Input$placeholder('contact@mypartner.com'),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 6, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 6, model.PU))
                ]))
            ]))),
            unlessMinimal(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Product Description')
            ]), _List_fromArray([
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', fields.Xz)),
                    $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$ProductDescription))
                ]))
            ]))),
            unlessMinimal(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Integration Description')
            ]), _List_fromArray([
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', fields.Ro)),
                    $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$IntegrationDescription))
                ]))
            ]))),
            unlessMinimal(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Marketing URL')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.TH)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$MarketingUrl)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
                ]))
            ]))),
            unlessMinimal(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Signup URL')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields._u)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$SignupUrl)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 3, model.PU))
                ]))
            ]))),
            unlessMinimal(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Support URL')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.$y)),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$SupportUrl)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 4, model.PU))
                ]))
            ]))),
            unlessMinimal(A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Uses Integration Records')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.aa2),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Partner$Form$FormUpdated, $author$project$Components$Partner$Form$UsesIntegrationRecords))
                ]))
            ])))
        ]));
    });
    var $author$project$Ui$Icon$Location = 14;
    var $author$project$Ui$Icon$location = $author$project$Ui$Icon$viewIcon(14);
    var $author$project$Ui$Icon$Mail = 95;
    var $author$project$Ui$Icon$mail = $author$project$Ui$Icon$viewIcon(95);
    var $author$project$Pages$Partner$Dashboard$Top$viewAccount = function(partner) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$flexCol
        ]), _List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function(logoUrl) {
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Image$fromSrc, {
                        Jg: $author$project$Api$Partner$Partner$One$name(partner) + ' logo'
                    }, logoUrl, _List_fromArray([
                        $author$project$Ui$Image$height(100)
                    ]))
                ]));
            }, $author$project$Api$Partner$Partner$One$logoUrl(partner))),
            A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function(address) {
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Icon$location(_List_Nil),
                    $author$project$Components$AddressDisplay$view(address)
                ]));
            }, $author$project$Api$Partner$Partner$One$address(partner))),
            A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function(url) {
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Icon$translate(_List_Nil),
                    A3($author$project$Ui$Link$externalHref, url, _List_fromArray([
                        $author$project$Ui$Link$targetBlank
                    ]), _List_fromArray([
                        $elm$html$Html$text(url)
                    ]))
                ]));
            }, $author$project$Api$Partner$Partner$One$websiteUrl(partner))),
            A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function(email) {
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Icon$mail(_List_Nil),
                    A3($author$project$Ui$Link$mailto, email, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(email)
                    ]))
                ]));
            }, $author$project$Api$Partner$Partner$One$technicalEmail(partner)))
        ]));
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent = function(model) {
        var editing = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$always(true), model.be));
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Dashboard$Top$Save)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), editing ? _List_Nil : _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text($author$project$Api$Partner$Partner$One$name(model.VW))
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit account'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$EditClicked),
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = model.be;
                        if (!_v0.$) {
                            var partnerForm = _v0.a;
                            return A2($elm$html$Html$map, $author$project$Pages$Partner$Dashboard$Top$PartnerFormMsg, A2($author$project$Components$Partner$Form$view, _List_fromArray([
                                $author$project$Components$Partner$Form$minimal
                            ]), partnerForm));
                        } else return $author$project$Pages$Partner$Dashboard$Top$viewAccount(model.VW);
                    }()
                ])),
                function() {
                    if (editing) {
                        var loading = _Utils_eq(model.o2, $author$project$Api$Data$Loading);
                        return A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter,
                            $author$project$Ui$Element$mt2
                        ]), _List_fromArray([
                            model.Vs ? A3($author$project$Ui$Button$view, {
                                abP: 'Cancel editing'
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$CancelEdit)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])) : $elm$html$Html$text(''),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Save partner changes'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Save')
                            ]))
                        ]));
                    } else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]));
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$builtByName = function(_v0) {
        var record = _v0;
        return record.Ku;
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl = function(_v0) {
        var record = _v0;
        return record.Kv;
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$featured = function(_v0) {
        var record = _v0;
        return record.Pw;
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$slug = function(_v0) {
        var record = _v0;
        return record._A;
    };
    var $author$project$Api$Partner$PartnerProduct$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Ui$Card$Highlighted = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Card$highlighted = $author$project$Ui$Card$Highlighted;
    var $author$project$Ui$Grid$itemsCenter = $author$project$Ui$Grid$Element($author$project$Ui$Element$itemsCenter);
    var $author$project$Ui$Card$Link = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Card$linkTo = $author$project$Ui$Card$Link;
    var $author$project$Ui$Card$Muted = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Card$muted = $author$project$Ui$Card$Muted;
    var $author$project$Ui$Badge$AccentPrimary = 6;
    var $author$project$Ui$Badge$accentPrimary = $author$project$Ui$Badge$Color(6);
    var $author$project$Ui$Badge$AccentSecondary = 7;
    var $author$project$Ui$Badge$accentSecondary = $author$project$Ui$Badge$Color(7);
    var $author$project$Ui$Badge$Neutral = 5;
    var $author$project$Ui$Badge$neutral = $author$project$Ui$Badge$Color(5);
    var $author$project$Components$Marketplace$Product$Status$listingStatusOptions = function(status) {
        switch(status){
            case 0:
                return _List_Nil;
            case 1:
                return _List_fromArray([
                    $author$project$Ui$Badge$neutral
                ]);
            case 2:
                return _List_Nil;
            case 3:
                return _List_fromArray([
                    $author$project$Ui$Badge$accentPrimary
                ]);
            case 4:
                return _List_fromArray([
                    $author$project$Ui$Badge$accentSecondary
                ]);
            case 5:
                return _List_fromArray([
                    $author$project$Ui$Badge$success
                ]);
            case 6:
                return _List_fromArray([
                    $author$project$Ui$Badge$warning
                ]);
            case 7:
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
            default:
                return _List_fromArray([
                    $author$project$Ui$Badge$danger
                ]);
        }
    };
    var $author$project$Api$Common$Marketplace$Product$Status$toLabel = function(status) {
        switch(status){
            case 0:
                return 'Hidden';
            case 1:
                return 'Unpublished';
            case 2:
                return 'Researching';
            case 3:
                return 'Coming Soon';
            case 4:
                return 'Beta';
            case 5:
                return 'Live';
            case 6:
                return 'Sunsetting';
            case 7:
                return 'Deprecated';
            default:
                return 'Decommissioned';
        }
    };
    var $author$project$Components$Marketplace$Product$Status$view = function(listingStatus) {
        return A2($author$project$Ui$Badge$view, $author$project$Components$Marketplace$Product$Status$listingStatusOptions(listingStatus), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$Status$toLabel(listingStatus))
        ]));
    };
    var $author$project$Ui$Card$optionsToRecord = A2($elm$core$List$foldl, F2(function(option, acc) {
        switch(option.$){
            case 0:
                var bool = option.a;
                return _Utils_update(acc, {
                    x_: bool
                });
            case 3:
                var bool = option.a;
                return _Utils_update(acc, {
                    zq: bool
                });
            case 1:
                var href = option.a;
                return _Utils_update(acc, {
                    Te: $elm$core$Maybe$Just(href)
                });
            default:
                var bool = option.a;
                return _Utils_update(acc, {
                    d$: bool
                });
        }
    }), {
        d$: false,
        x_: false,
        Te: $elm$core$Maybe$Nothing,
        zq: false
    });
    var $author$project$Ui$Card$view = F2(function(options, content) {
        var optionsRecord = $author$project$Ui$Card$optionsToRecord(options);
        var node = A2($elm$core$Maybe$withDefault, $elm$html$Html$div, A2($elm$core$Maybe$map, $elm$core$Basics$always($elm$html$Html$a), optionsRecord.Te));
        return A2(node, _List_fromArray([
            $elm$html$Html$Attributes$class('card'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('card--highlighted', optionsRecord.x_),
                _Utils_Tuple2('card--clickable', A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$always(true), optionsRecord.Te))),
                _Utils_Tuple2('card--muted', optionsRecord.zq),
                _Utils_Tuple2('disabled', optionsRecord.d$)
            ])),
            A2($elm$core$Maybe$withDefault, $elm$html$Html$Attributes$class(''), A2($elm$core$Maybe$map, $elm$html$Html$Attributes$href, optionsRecord.Te))
        ]), content);
    });
    var $author$project$Components$Marketplace$ProductCard$viewIntegrationChip = function(product) {
        var _v0 = product.ahy;
        if (!_v0.$) switch(_v0.a){
            case 'inactive':
                return A2($author$project$Ui$Badge$view, _List_fromArray([
                    $author$project$Ui$Badge$neutral
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$ProductType$toString(product.ah5))
                ]));
            case 'active':
                return A2($author$project$Ui$Badge$view, _List_fromArray([
                    $author$project$Ui$Badge$success
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$ProductType$toString(product.ah5)),
                    $author$project$Ui$Icon$check(_List_Nil)
                ]));
            default:
                var status = _v0.a;
                return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
        }
        else return A2($author$project$Ui$Badge$view, _List_fromArray([
            $author$project$Ui$Badge$neutral
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$ProductType$toString(product.ah5))
        ]));
    };
    var $author$project$Components$Marketplace$ProductCard$view = F3(function(hinterMode, productRoute, product) {
        var listed = !product.N9 && !A2($elm$core$List$member, product.Tj, _List_fromArray([
            1,
            8
        ]));
        return A2($author$project$Ui$Card$view, _List_fromArray([
            $author$project$Ui$Card$highlighted(product.Pw),
            $author$project$Ui$Card$muted(hinterMode && !listed),
            $author$project$Ui$Card$linkTo($author$project$Spa$Generated$Route$toString(productRoute))
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4),
                    $author$project$Ui$Grid$itemsCenter,
                    $author$project$Ui$Grid$justifyCenter
                ]), _List_fromArray([
                    function() {
                        var _v0 = product.Q_;
                        if (!_v0.$) {
                            var url = _v0.a;
                            return A3($author$project$Ui$Image$fromSrc, {
                                Jg: product.zr + '\'s icon'
                            }, url, _List_fromArray([
                                $author$project$Ui$Image$width(64)
                            ]));
                        } else return $elm$html$Html$text('');
                    }()
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb4
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsStart,
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text(product.zr)
                            ])),
                            $author$project$Components$Marketplace$ProductCard$viewIntegrationChip(product)
                        ]))
                    ])),
                    A3($author$project$Ui$Element$custom, 'max-h-24', _List_fromArray([
                        $author$project$Ui$Element$mb4
                    ]), _List_fromArray([
                        function() {
                            var clampClass = function() {
                                var _v1 = product.Tj;
                                if (_v1 === 5) return 'line-clamp-3';
                                else return 'line-clamp-2';
                            }();
                            return A3($author$project$Ui$Element$custom, clampClass, _List_fromArray([
                                $author$project$Ui$Element$textMuted,
                                $author$project$Ui$Element$mb2
                            ]), $elm$core$List$singleton($elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', product.$x))));
                        }(),
                        function() {
                            var _v2 = _Utils_Tuple2(hinterMode, product.Tj);
                            if (!_v2.a && _v2.b === 5) {
                                var _v3 = _v2.b;
                                return $elm$html$Html$text('');
                            } else return $author$project$Components$Marketplace$Product$Status$view(product.Tj);
                        }()
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Ui$Margin$Top_0_50 = 6;
    var $author$project$Ui$Card$Disabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Card$disabled = $author$project$Ui$Card$Disabled;
    var $author$project$Ui$Icon$mb3 = $author$project$Ui$Icon$SpacedBottom(3);
    var $author$project$Pages$Partner$Dashboard$Top$viewNewProduct = function(model) {
        return A2($author$project$Ui$Card$view, _List_fromArray([
            $author$project$Ui$Card$linkTo($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Product__New)),
            $author$project$Ui$Card$disabled(!_Utils_eq($author$project$Api$Partner$Partner$One$product(model.VW), $elm$core$Maybe$Nothing))
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12),
                    $author$project$Ui$Grid$itemsCenter,
                    $author$project$Ui$Grid$justifyCenter
                ]), _List_fromArray([
                    $author$project$Ui$Icon$add(_List_fromArray([
                        $author$project$Ui$Icon$mb3,
                        $author$project$Ui$Icon$xl
                    ])),
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Add Product')
                    ])),
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$margin(6)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Create a new product listing for the marketplace')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard = function(model) {
        var _v0 = $author$project$Api$Partner$Partner$One$product(model.VW);
        if (!_v0.$) {
            var product = _v0.a;
            var marketplaceProduct = {
                Ku: $author$project$Api$Partner$PartnerProduct$Shared$builtByName(product),
                Kv: $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(product),
                N9: $author$project$Api$Partner$PartnerProduct$Shared$distributionType(product),
                Pw: $author$project$Api$Partner$PartnerProduct$Shared$featured(product),
                Q_: $author$project$Api$Partner$Partner$One$marketplaceIconUrl(model.VW),
                Tj: $author$project$Api$Partner$PartnerProduct$Shared$status(product),
                zr: $author$project$Api$Partner$PartnerProduct$Shared$name(product),
                _A: $author$project$Api$Partner$PartnerProduct$Shared$slug(product),
                ahy: $elm$core$Maybe$Nothing,
                $x: $author$project$Api$Partner$PartnerProduct$Shared$summary(product),
                ah5: $author$project$Api$Partner$PartnerProduct$Shared$type_(product)
            };
            return A3($author$project$Ui$Element$custom, 'marketplace-cards', _List_Nil, _List_fromArray([
                A3($author$project$Components$Marketplace$ProductCard$view, false, $author$project$Spa$Generated$Route$Partner__Product, marketplaceProduct)
            ]));
        } else return $author$project$Pages$Partner$Dashboard$Top$viewNewProduct(model);
    };
    var $author$project$Pages$Partner$Dashboard$Top$completedStepCount = function(partner) {
        return $elm$core$List$length(A2($elm$core$List$filter, $author$project$Pages$Partner$Dashboard$Top$isStepComplete(partner), $author$project$Pages$Partner$Dashboard$Top$allSteps(partner)));
    };
    var $author$project$Pages$Partner$Dashboard$Top$totalSteps = function(partner) {
        return $elm$core$List$length($author$project$Pages$Partner$Dashboard$Top$allSteps(partner));
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewProgressHeader = function(partner) {
        var total = $author$project$Pages$Partner$Dashboard$Top$totalSteps(partner);
        var completed = $author$project$Pages$Partner$Dashboard$Top$completedStepCount(partner);
        var percentage = !total ? 0 : completed * 100 / total | 0;
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Go Live in Marketplace')
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted,
                        $author$project$Ui$Element$textSm
                    ]), _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt(completed) + (' of ' + ($elm$core$String$fromInt(total) + ' complete')))
                    ]))
                ])),
                $author$project$Ui$ProgressBar$view(_List_fromArray([
                    $author$project$Ui$ProgressBar$width(percentage)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textMuted,
                    $author$project$Ui$Element$mt4
                ]), _List_fromArray([
                    $elm$html$Html$text('Complete the steps below, then submit your listing for review.')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader = function(model) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb4,
            $author$project$Ui$Element$gap4
        ]), _List_fromArray([
            $author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard(model),
            $author$project$Pages$Partner$Dashboard$Top$viewProgressHeader(model.VW)
        ]));
    };
    var $author$project$Pages$Partner$Dashboard$Top$RequestReview = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$statusIcon = function(complete) {
        return complete ? $author$project$Ui$Icon$check(_List_fromArray([
            $author$project$Ui$Icon$circled,
            $author$project$Ui$Icon$success
        ])) : $author$project$Ui$Icon$circle(_List_fromArray([
            $author$project$Ui$Icon$info,
            $author$project$Ui$Icon$xl
        ]));
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewProductChecklist = F2(function(partner, product) {
        var tileComplete = A2($author$project$Pages$Partner$Dashboard$Top$isMarketplaceCardComplete, partner, product);
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    $author$project$Pages$Partner$Dashboard$Top$statusIcon(tileComplete),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Marketplace card')
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textMuted,
                            $author$project$Ui$Element$textSm
                        ]), _List_fromArray([
                            $elm$html$Html$text('Name, summary, and icon')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$mt4
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$edit(_List_fromArray([
                            $author$project$Ui$Icon$circled,
                            $author$project$Ui$Icon$info
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Detail page')
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textMuted,
                                $author$project$Ui$Element$textSm
                            ]), _List_fromArray([
                                $elm$html$Html$text('Overview, highlights, and details')
                            ]))
                        ]))
                    ])),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Partner__Product, _List_fromArray([
                        $author$project$Ui$Link$icon($author$project$Ui$Icon$edit),
                        $author$project$Ui$Link$sm
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Dashboard$Top$viewProductListingContent = function(model) {
        var _v0 = $author$project$Api$Partner$Partner$One$product(model.VW);
        if (!_v0.$) {
            var product = _v0.a;
            var published = $author$project$Pages$Partner$Dashboard$Top$isProductListingPublished(model.VW);
            return A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flexCol,
                $author$project$Ui$Element$gap4
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flexCol,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Ui$Element$custom, 'marketplace-cards', _List_Nil, _List_fromArray([
                        function() {
                            var marketplaceProduct = {
                                Ku: $author$project$Api$Partner$PartnerProduct$Shared$builtByName(product),
                                Kv: $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(product),
                                N9: $author$project$Api$Partner$PartnerProduct$Shared$distributionType(product),
                                Pw: $author$project$Api$Partner$PartnerProduct$Shared$featured(product),
                                Q_: $author$project$Api$Partner$Partner$One$marketplaceIconUrl(model.VW),
                                Tj: $author$project$Api$Partner$PartnerProduct$Shared$status(product),
                                zr: $author$project$Api$Partner$PartnerProduct$Shared$name(product),
                                _A: $author$project$Api$Partner$PartnerProduct$Shared$slug(product),
                                ahy: $elm$core$Maybe$Nothing,
                                $x: $author$project$Api$Partner$PartnerProduct$Shared$summary(product),
                                ah5: $author$project$Api$Partner$PartnerProduct$Shared$type_(product)
                            };
                            return A3($author$project$Components$Marketplace$ProductCard$view, false, $author$project$Spa$Generated$Route$Partner__Product, marketplaceProduct);
                        }()
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted,
                        $author$project$Ui$Element$textSm,
                        $author$project$Ui$Element$mt2
                    ]), _List_fromArray([
                        $elm$html$Html$text('This is how your listing will appear in the marketplace. Click to edit.')
                    ]))
                ])),
                A2($author$project$Pages$Partner$Dashboard$Top$viewProductChecklist, model.VW, product),
                function() {
                    if (published) return $author$project$Utils$Html$empty;
                    else {
                        var reviewReady = A2($elm$core$List$all, $author$project$Pages$Partner$Dashboard$Top$isStepComplete(model.VW), A2($elm$core$List$filter, function(s) {
                            return s !== 2;
                        }, $author$project$Pages$Partner$Dashboard$Top$allSteps(model.VW)));
                        var loading = _Utils_eq(model.jW, $author$project$Api$Data$Loading);
                        var alreadyRequested = function() {
                            var _v1 = model.jW;
                            if (_v1.$ === 3) return true;
                            else return false;
                        }();
                        return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Request listing review'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$disabled(!reviewReady || alreadyRequested),
                                $author$project$Ui$Button$loading(loading),
                                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$RequestReview($author$project$Api$Partner$PartnerProduct$Shared$id(product)))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Request Listing Review')
                            ]))
                        ]));
                    }
                }()
            ]));
        } else return $author$project$Pages$Partner$Dashboard$Top$viewNewProduct(model);
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewSandboxSetupContent = function(_v0) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$justifyCenter
        ]), _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Partner__Sandboxes__Top, _List_fromArray([
                $author$project$Ui$Link$buttonPrimary
            ]), _List_fromArray([
                $elm$html$Html$text('Go to Sandboxes')
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Dashboard$Top$stepDescription = function(step) {
        switch(step){
            case 0:
                return 'Legal business name, address, logo, and technical contact';
            case 1:
                return 'Review and sign required agreements';
            case 2:
                return 'Create and configure your marketplace product listing';
            case 3:
                return 'Create and configure a sandbox partner and sandbox practice for testing';
            default:
                return 'Add a link to your marketplace listing on your website';
        }
    };
    var $author$project$Pages$Partner$Dashboard$Top$stepTitle = function(step) {
        switch(step){
            case 0:
                return 'Company Details';
            case 1:
                return 'Agreements';
            case 2:
                return 'Product Listing';
            case 3:
                return 'Sandbox Setup';
            default:
                return 'Website Backlink';
        }
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewSetupSection = F3(function(model, step, content) {
        var expanded = A2($elm$core$List$member, step, model.mb);
        var complete = A2($author$project$Pages$Partner$Dashboard$Top$isStepComplete, model.VW, step);
        return A2($author$project$Ui$Panel$view, _List_fromArray([
            $author$project$Ui$Panel$collapsed(!expanded)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_fromArray([
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap4
            ]), _List_fromArray([
                $author$project$Pages$Partner$Dashboard$Top$statusIcon(complete),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Pages$Partner$Dashboard$Top$stepTitle(step))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Pages$Partner$Dashboard$Top$stepDescription(step))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                content
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Dashboard$Top$BacklinkUrlChanged = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$CopyListingUrl = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$SaveBacklinkUrl = {
        $: 11
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewWebsiteBacklinkContent = function(model) {
        var _v0 = $author$project$Api$Partner$Partner$One$product(model.VW);
        if (!_v0.$) {
            var product = _v0.a;
            var loading = _Utils_eq(model.lc, $author$project$Api$Data$Loading);
            var listingUrl = 'https://www.hint.com/marketplace/' + $author$project$Api$Partner$PartnerProduct$Shared$slug(product);
            return A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$autocomplete(false),
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Dashboard$Top$SaveBacklinkUrl)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Listing URL')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$externalHref, listingUrl, _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text(listingUrl)
                        ])),
                        $elm$html$Html$text(' '),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy listing URL'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Pages$Partner$Dashboard$Top$CopyListingUrl(listingUrl)),
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                        ]), _List_Nil)
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Backlink URL')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$url,
                        $author$project$Ui$Form$Input$value(model.e8),
                        $author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Dashboard$Top$BacklinkUrlChanged),
                        $author$project$Ui$Form$Input$placeholder('https://yoursite.com/integrations'),
                        $author$project$Ui$Form$Input$ariaLabel('Backlink URL')
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$mt2
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Save backlink URL'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$disabled($elm$core$String$isEmpty($elm$core$String$trim(model.e8)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Save')
                    ]))
                ]))
            ]));
        } else return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$textMuted
        ]), _List_fromArray([
            $elm$html$Html$text('Create a product listing first to get your marketplace URL.')
        ]));
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboard = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, $elm$core$List$concat(_List_fromArray([
                    $author$project$Api$Partner$Partner$One$sandboxEnabled(model.VW) ? _List_fromArray([
                        $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader(model),
                        A3($author$project$Pages$Partner$Dashboard$Top$viewSetupSection, model, 3, $author$project$Pages$Partner$Dashboard$Top$viewSandboxSetupContent(model))
                    ]) : _List_fromArray([
                        $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboardHeader(model)
                    ]),
                    _List_fromArray([
                        A3($author$project$Pages$Partner$Dashboard$Top$viewSetupSection, model, 0, $author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent(model)),
                        A3($author$project$Pages$Partner$Dashboard$Top$viewSetupSection, model, 1, $author$project$Pages$Partner$Dashboard$Top$viewAgreementsContent(model))
                    ]),
                    !_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(model.VW), $elm$core$Maybe$Nothing) ? _List_Nil : _List_fromArray([
                        A3($author$project$Pages$Partner$Dashboard$Top$viewSetupSection, model, 2, $author$project$Pages$Partner$Dashboard$Top$viewProductListingContent(model)),
                        A3($author$project$Pages$Partner$Dashboard$Top$viewSetupSection, model, 4, $author$project$Pages$Partner$Dashboard$Top$viewWebsiteBacklinkContent(model))
                    ])
                ])))
            ]),
            $2: 'Partner | Dashboard'
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$viewGuideStep = F3(function(number, title, description) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$gap4
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textMuted
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text(number)
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(title)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textMuted,
                    $author$project$Ui$Element$textSm
                ]), _List_fromArray([
                    $elm$html$Html$text(description)
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Dashboard$Top$viewIntegrationGuidePanel = A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
            $author$project$Ui$Panel$title(_List_fromArray([
                $elm$html$Html$text('Building Your Integration')
            ]))
        ])),
        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flexCol,
                $author$project$Ui$Element$gap4
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textMuted
                ]), _List_fromArray([
                    $elm$html$Html$text('Follow the steps in the developer documentation to build and test your integration with Hint.')
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flexCol,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '1', 'Define data sync', 'Determine sync direction and source of truth'),
                    A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '2', 'Implement activation', 'Set up the practice activation flow'),
                    A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '3', 'Initial data sync', 'Backfill existing data safely'),
                    A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '4', 'Keep data current', 'Use webhooks to stay in sync'),
                    A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '5', 'Integration records', 'Make sync status observable'),
                    A3($author$project$Pages$Partner$Dashboard$Top$viewGuideStep, '6', 'Surface key fields', 'Show high-value data in your UI')
                ])),
                A3($author$project$Ui$Link$externalHref, 'https://developers.hint.com/docs/building-an-integration', _List_fromArray([
                    $author$project$Ui$Link$buttonPrimary,
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('View Developer Docs')
                ]))
            ]))
        ]))
    ]));
    var $author$project$Pages$Partner$Dashboard$Top$viewSandboxDashboard = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb4
                    ]), _List_fromArray([
                        $author$project$Pages$Partner$Dashboard$Top$viewProductSummaryCard(model)
                    ])),
                    $author$project$Pages$Partner$Dashboard$Top$viewIntegrationGuidePanel,
                    A3($author$project$Pages$Partner$Dashboard$Top$viewSetupSection, model, 0, $author$project$Pages$Partner$Dashboard$Top$viewCompanyDetailsContent(model))
                ]))
            ]),
            $2: 'Partner | Dashboard'
        };
    };
    var $author$project$Pages$Partner$Dashboard$Top$view = function(model) {
        return model.F5 ? $author$project$Pages$Partner$Dashboard$Top$viewSandboxDashboard(model) : $author$project$Pages$Partner$Dashboard$Top$viewLiveDashboard(model);
    };
    var $author$project$Pages$Partner$Dashboard$Top$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Dashboard$Top$init,
        aeR: $author$project$Pages$Partner$Dashboard$Top$load,
        ag3: $author$project$Pages$Partner$Dashboard$Top$save,
        ahE: $author$project$Pages$Partner$Dashboard$Top$subscriptions,
        aaO: $author$project$Pages$Partner$Dashboard$Top$update,
        aid: $author$project$Pages$Partner$Dashboard$Top$view
    });
    var $author$project$Pages$Partner$Engagements$StatusDropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Partner$Engagements$GotInstalledCount = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Partner$EngagementEvent$Installed = 2;
    var $author$project$Api$Partner$EngagementEvent$All$EngagementEvent = 0;
    var $author$project$Api$Partner$EngagementEvent$All$Record = F4(function(id, practice, action, createdAt) {
        return {
            D7: action,
            Mx: createdAt,
            aef: id,
            W1: practice
        };
    });
    var $author$project$Api$Partner$EngagementEvent$All$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$always(0), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'action', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Partner$Practice$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$EngagementEvent$All$Record))))));
    var $author$project$Api$Partner$EngagementEvent$engagementEventsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'engagement_events'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$EngagementEvent$actionToString = function(action) {
        switch(action){
            case 0:
                return 'expressed_interest';
            case 1:
                return 'joined_waitlist';
            case 2:
                return 'installed';
            default:
                return 'uninstalled';
        }
    };
    var $author$project$Api$Partner$EngagementEvent$listOptionsToParams = function(optionals) {
        var options = optionals({
            D7: $elm$core$Maybe$Nothing,
            GM: $elm$core$Maybe$Nothing
        });
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Partner$EngagementEvent$actionToString, $author$project$Api$Param$string('action')), options.D7),
            A2($elm$core$Maybe$map, function(p) {
                return A2($author$project$Api$Param$string, 'page', $elm$core$String$fromInt(p));
            }, options.GM)
        ]));
    };
    var $author$project$Api$Partner$EngagementEvent$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$EngagementEvent$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$EngagementEvent$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$EngagementEvent$engagementEventsPath)));
    });
    var $author$project$Pages$Partner$Engagements$fetchInstalledCount = function(apiClient) {
        return A3($author$project$Api$Partner$EngagementEvent$list, apiClient, function(o) {
            return _Utils_update(o, {
                D7: $elm$core$Maybe$Just(2),
                GM: $elm$core$Maybe$Just(0)
            });
        }, $author$project$Pages$Partner$Engagements$GotInstalledCount);
    };
    var $author$project$Api$Partner$EngagementEvent$ExpressedInterest = 0;
    var $author$project$Pages$Partner$Engagements$GotInterestedCount = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Partner$Engagements$fetchInterestedCount = function(apiClient) {
        return A3($author$project$Api$Partner$EngagementEvent$list, apiClient, function(o) {
            return _Utils_update(o, {
                D7: $elm$core$Maybe$Just(0),
                GM: $elm$core$Maybe$Just(0)
            });
        }, $author$project$Pages$Partner$Engagements$GotInterestedCount);
    };
    var $author$project$Pages$Partner$Engagements$GotUninstalledCount = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Partner$EngagementEvent$Uninstalled = 3;
    var $author$project$Pages$Partner$Engagements$fetchUninstalledCount = function(apiClient) {
        return A3($author$project$Api$Partner$EngagementEvent$list, apiClient, function(o) {
            return _Utils_update(o, {
                D7: $elm$core$Maybe$Just(3),
                GM: $elm$core$Maybe$Just(0)
            });
        }, $author$project$Pages$Partner$Engagements$GotUninstalledCount);
    };
    var $author$project$Pages$Partner$Engagements$GotWaitlistedCount = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Partner$EngagementEvent$JoinedWaitlist = 1;
    var $author$project$Pages$Partner$Engagements$fetchWaitlistedCount = function(apiClient) {
        return A3($author$project$Api$Partner$EngagementEvent$list, apiClient, function(o) {
            return _Utils_update(o, {
                D7: $elm$core$Maybe$Just(1),
                GM: $elm$core$Maybe$Just(0)
            });
        }, $author$project$Pages$Partner$Engagements$GotWaitlistedCount);
    };
    var $author$project$Pages$Partner$Engagements$fetchCountCmds = F2(function(apiClient, maybeListingStatus) {
        _v0$4: while(true){
            if (!maybeListingStatus.$) switch(maybeListingStatus.a){
                case 3:
                    var _v1 = maybeListingStatus.a;
                    return _List_fromArray([
                        $author$project$Pages$Partner$Engagements$fetchInterestedCount(apiClient)
                    ]);
                case 2:
                    var _v2 = maybeListingStatus.a;
                    return _List_fromArray([
                        $author$project$Pages$Partner$Engagements$fetchInterestedCount(apiClient)
                    ]);
                case 4:
                    var _v3 = maybeListingStatus.a;
                    return _List_fromArray([
                        $author$project$Pages$Partner$Engagements$fetchWaitlistedCount(apiClient),
                        $author$project$Pages$Partner$Engagements$fetchInstalledCount(apiClient),
                        $author$project$Pages$Partner$Engagements$fetchUninstalledCount(apiClient)
                    ]);
                case 5:
                    var _v4 = maybeListingStatus.a;
                    return _List_fromArray([
                        $author$project$Pages$Partner$Engagements$fetchInstalledCount(apiClient),
                        $author$project$Pages$Partner$Engagements$fetchUninstalledCount(apiClient)
                    ]);
                default:
                    break _v0$4;
            }
            else break _v0$4;
        }
        return _List_Nil;
    });
    var $author$project$Pages$Partner$Engagements$GotEngagements = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$Engagement$All$Engagement = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Engagement$All$Record = F5(function(id, practice, status, createdAt, betaAccessGranted) {
        return {
            Ka: betaAccessGranted,
            Mx: createdAt,
            aef: id,
            W1: practice,
            ahy: status
        };
    });
    var $author$project$Api$Partner$Engagement$All$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'beta_access_granted', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$Api$Common$Marketplace$Product$Engagement$Status$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Partner$Practice$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$Engagement$All$Record)))))));
    var $author$project$Api$Partner$Engagement$engagementsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'engagements'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString = function(status) {
        switch(status.$){
            case 0:
                return 'waitlisted';
            case 1:
                return 'interested';
            case 2:
                return 'beta_access_granted';
            case 3:
                return 'install_attempted';
            case 4:
                return 'install_requested';
            default:
                var string = status.a;
                return string;
        }
    };
    var $author$project$Api$Partner$Engagement$listOptionsToParams = function(optionals) {
        var options = optionals({
            af_: $author$project$Api$Pagination$init,
            ahs: $author$project$Api$Sort$init,
            HD: _List_Nil
        });
        var statusParams = function() {
            var _v0 = options.HD;
            if (!_v0.b) return _List_Nil;
            else {
                var statuses = _v0;
                return _List_fromArray([
                    A2($author$project$Api$Param$list, 'status', A2($elm$core$List$map, $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString, statuses))
                ]);
            }
        }();
        return _Utils_ap(statusParams, _Utils_ap($author$project$Api$Pagination$toApiParams(options.af_), $author$project$Api$Sort$toParams(options.ahs)));
    };
    var $author$project$Api$Partner$Engagement$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$Engagement$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Engagement$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$Engagement$engagementsPath)));
    });
    var $author$project$Pages$Partner$Engagements$fetchEngagements = function(model) {
        return A3($author$project$Api$Partner$Engagement$list, model.Ej, function(o) {
            return _Utils_update(o, {
                af_: model.af_,
                ahs: model.ahs,
                HD: model.ct
            });
        }, $author$project$Pages$Partner$Engagements$GotEngagements);
    };
    var $author$project$Api$Partner$Partner$Shared$productType = function(_v0) {
        var record = _v0;
        return record.G7;
    };
    var $author$project$Api$Partner$Partner$One$productType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$productType(shared);
    };
    var $author$project$Pages$Partner$Engagements$init = F4(function(_v0, partner, shared, _v1) {
        var query = _v1.Bz;
        var statusFilter = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$String$split(','), $elm$core$List$filterMap($author$project$Api$Common$Marketplace$Product$Engagement$Status$fromString)), A2($elm$core$Dict$get, 'status', query)));
        var sort = A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$initFromQuery(query));
        var productType = $author$project$Api$Partner$Partner$One$productType(partner);
        var pagination = $author$project$Api$Pagination$initFromQuery(query);
        var listingStatus = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProduct$Shared$status, $author$project$Api$Partner$Partner$One$product(partner));
        var initModel = {
            Ej: shared.Ej,
            b6: $author$project$Api$Data$Loading,
            q_: $author$project$Api$Data$NotAsked,
            q1: $author$project$Api$Data$NotAsked,
            Tj: listingStatus,
            af_: pagination,
            G7: productType,
            ahs: sort,
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'status-filter',
                ahX: $author$project$Pages$Partner$Engagements$StatusDropdownMsg
            })),
            ct: statusFilter,
            HO: shared.HO,
            tw: $author$project$Api$Data$NotAsked,
            D$: $author$project$Api$Data$NotAsked
        };
        var countCmds = A2($author$project$Pages$Partner$Engagements$fetchCountCmds, shared.Ej, listingStatus);
        return _Utils_Tuple2(initModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, $author$project$Pages$Partner$Engagements$fetchEngagements(initModel), countCmds)));
    });
    var $author$project$Pages$Partner$Engagements$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Engagements$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Engagements$subscriptions = function(model) {
        return $author$project$Ui$Dropdown$subscriptions(model.oD);
    };
    var $author$project$Pages$Partner$Engagements$AccessGranted = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Engagements$buildUrl = function(model) {
        var params = _Utils_ap(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $elm$core$List$isEmpty(model.ct) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'status', A2($elm$core$String$join, ',', A2($elm$core$List$map, $author$project$Api$Common$Marketplace$Product$Engagement$Status$toString, model.ct))))
        ])), _Utils_ap($author$project$Api$Pagination$toPageQuery(model.af_), $author$project$Api$Sort$toQuery(model.ahs)));
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Engagements)
        ]), params);
    };
    var $author$project$Api$Partner$Engagement$grantAccess = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Engagement$All$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id,
            'grant_access'
        ]), $author$project$Api$Partner$Engagement$engagementsPath)));
    });
    var $author$project$Api$Partner$Engagement$All$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Pages$Partner$Engagements$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                var pagination = function() {
                    if (response.$ === 3) {
                        var headers = response.b;
                        return A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_);
                    } else return model.af_;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    b6: response,
                    af_: pagination
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var engagement = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Partner$Engagement$grantAccess, model.Ej, $author$project$Api$Partner$Engagement$All$id(engagement), $author$project$Pages$Partner$Engagements$AccessGranted(engagement)), _List_Nil);
            case 2:
                var engagement = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var updated = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        b6: A2($author$project$Api$Data$map, $elm$core$List$map(function(e) {
                            return _Utils_eq($author$project$Api$Partner$Engagement$All$id(e), $author$project$Api$Partner$Engagement$All$id(engagement)) ? updated : e;
                        }), model.b6)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var status = msg.a;
                var newFilter = A2($elm$core$List$member, status, model.ct) ? A2($elm$core$List$filter, $elm$core$Basics$neq(status), model.ct) : _Utils_ap(model.ct, _List_fromArray([
                    status
                ]));
                var newModel = _Utils_update(model, {
                    b6: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ct: newFilter
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
                    $author$project$Ports$Navigation$replaceUrl($author$project$Pages$Partner$Engagements$buildUrl(newModel))
                ])), _List_Nil);
            case 4:
                var dropdownMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.oD);
                var dropdown = _v3.a;
                var dropdownCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: dropdown
                }), dropdownCmd, _List_Nil);
            case 5:
                var paginationMsg = msg.a;
                var newModel = _Utils_update(model, {
                    b6: $author$project$Api$Data$Loading,
                    af_: A2($author$project$Api$Pagination$update, paginationMsg, model.af_)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
                    $author$project$Ports$Navigation$replaceUrl($author$project$Pages$Partner$Engagements$buildUrl(newModel))
                ])), _List_Nil);
            case 7:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    q1: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    D$: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    b6: $author$project$Api$Data$Loading,
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Engagements$fetchEngagements(newModel),
                    $author$project$Ports$Navigation$replaceUrl($author$project$Pages$Partner$Engagements$buildUrl(newModel))
                ])), _List_Nil);
            case 9:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    q_: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    tw: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Partner$Engagements$PaginationMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Partner$Engagements$viewNetInstalledStatItem = F3(function(label, installedData, uninstalledData) {
        var count = A2($elm$core$Maybe$withDefault, "\u2014", A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Basics$max(0), $elm$core$String$fromInt), A3($elm$core$Maybe$map2, $elm$core$Basics$sub, $author$project$Api$Data$totalCount(installedData), $author$project$Api$Data$totalCount(uninstalledData))));
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text(count)
            ])),
            A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                $elm$html$Html$text(label)
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Engagements$viewStatItem = F2(function(label, data) {
        var count = A2($elm$core$Maybe$withDefault, "\u2014", A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Data$totalCount(data)));
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text(count)
            ])),
            A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                $elm$html$Html$text(label)
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Engagements$viewStatItems = function(items) {
        return $elm$core$List$isEmpty(items) ? $elm$html$Html$text('') : A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$mb4
        ]), items);
    };
    var $author$project$Pages$Partner$Engagements$viewStats = function(model) {
        var installedLabel = function() {
            var _v5 = model.G7;
            if (_v5 === 1) return 'Connected';
            else return 'Installed';
        }();
        var _v0 = model.Tj;
        _v0$4: while(true){
            if (!_v0.$) switch(_v0.a){
                case 3:
                    var _v1 = _v0.a;
                    return $author$project$Pages$Partner$Engagements$viewStatItems(_List_fromArray([
                        A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Interested', model.q1)
                    ]));
                case 2:
                    var _v2 = _v0.a;
                    return $author$project$Pages$Partner$Engagements$viewStatItems(_List_fromArray([
                        A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Interested', model.q1)
                    ]));
                case 4:
                    var _v3 = _v0.a;
                    return $author$project$Pages$Partner$Engagements$viewStatItems(_List_fromArray([
                        A2($author$project$Pages$Partner$Engagements$viewStatItem, 'Waitlisted', model.D$),
                        A3($author$project$Pages$Partner$Engagements$viewNetInstalledStatItem, installedLabel, model.q_, model.tw)
                    ]));
                case 5:
                    var _v4 = _v0.a;
                    return $author$project$Pages$Partner$Engagements$viewStatItems(_List_fromArray([
                        A3($author$project$Pages$Partner$Engagements$viewNetInstalledStatItem, installedLabel, model.q_, model.tw)
                    ]));
                default:
                    break _v0$4;
            }
            else break _v0$4;
        }
        return $elm$html$Html$text('');
    };
    var $author$project$Pages$Partner$Engagements$isLiveOrAbove = function(maybeStatus) {
        _v0$4: while(true){
            if (!maybeStatus.$) switch(maybeStatus.a){
                case 5:
                    var _v1 = maybeStatus.a;
                    return true;
                case 6:
                    var _v2 = maybeStatus.a;
                    return true;
                case 7:
                    var _v3 = maybeStatus.a;
                    return true;
                case 8:
                    var _v4 = maybeStatus.a;
                    return true;
                default:
                    break _v0$4;
            }
            else break _v0$4;
        }
        return false;
    };
    var $author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel = function(status) {
        switch(status.$){
            case 0:
                return 'Waitlisted';
            case 1:
                return 'Interest Expressed';
            case 2:
                return 'Beta Access Granted';
            case 3:
                return 'Install Attempted';
            case 4:
                return 'Install Requested';
            default:
                var string = status.a;
                return string;
        }
    };
    var $author$project$Pages$Partner$Engagements$ToggleStatusFilter = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Partner$Engagements$viewStatusFilterItem = F2(function(activeStatuses, status) {
        return A2($author$project$Ui$Dropdown$checkbox, _List_fromArray([
            $author$project$Ui$Dropdown$checked(A2($elm$core$List$member, status, activeStatuses)),
            $author$project$Ui$Dropdown$onCheck(function(_v0) {
                return $author$project$Pages$Partner$Engagements$ToggleStatusFilter(status);
            }),
            $author$project$Ui$Dropdown$onSelectKeepOpen
        ]), $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel(status)));
    });
    var $author$project$Pages$Partner$Engagements$viewStatusFilter = function(model) {
        var triggerLabel = function() {
            var _v0 = model.ct;
            if (!_v0.b) return 'Status';
            else {
                var statuses = _v0;
                return A2($elm$core$String$join, ', ', A2($elm$core$List$map, $author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel, statuses));
            }
        }();
        var availableStatuses = $author$project$Pages$Partner$Engagements$isLiveOrAbove(model.Tj) ? _List_fromArray([
            $author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted,
            $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested
        ]) : _List_fromArray([
            $author$project$Api$Common$Marketplace$Product$Engagement$Status$Waitlisted,
            $author$project$Api$Common$Marketplace$Product$Engagement$Status$Interested,
            $author$project$Api$Common$Marketplace$Product$Engagement$Status$BetaAccessGranted
        ]);
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(triggerLabel)
        ]), A2($elm$core$List$map, $author$project$Pages$Partner$Engagements$viewStatusFilterItem(model.ct), availableStatuses), model.oD);
    };
    var $author$project$Pages$Partner$Engagements$SortTable = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Partner$Engagements$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'practice', true, 'Practice'),
        A3($author$project$Api$Column$init, 'status', true, 'Status'),
        A3($author$project$Api$Column$init, 'created_at', true, 'First Engaged'),
        A3($author$project$Api$Column$init, '', false, 'Beta Access'),
        A3($author$project$Api$Column$init, '', false, '')
    ]);
    var $author$project$Pages$Partner$Engagements$GrantAccess = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Engagement$All$betaAccessGranted = function(_v0) {
        var record = _v0;
        return record.Ka;
    };
    var $author$project$Api$Partner$Engagement$All$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Partner$Engagement$All$practice = function(_v0) {
        var record = _v0;
        return record.W1;
    };
    var $author$project$Api$Partner$Engagement$All$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Pages$Partner$Engagements$viewRow = F3(function(showBetaColumns, timeFormatter, engagement) {
        var baseCells = _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$Practice$Min$name($author$project$Api$Partner$Engagement$All$practice(engagement)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$Engagement$Status$toLabel($author$project$Api$Partner$Engagement$All$status(engagement)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2(timeFormatter, 5, $author$project$Api$Partner$Engagement$All$createdAt(engagement)))
            ]))
        ]);
        return A2($author$project$Ui$Table$row, _List_Nil, _Utils_ap(baseCells, showBetaColumns ? _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Api$Partner$Engagement$All$betaAccessGranted(engagement) ? A2($author$project$Ui$Badge$view, _List_fromArray([
                    $author$project$Ui$Badge$success
                ]), _List_fromArray([
                    $elm$html$Html$text('Granted')
                ])) : $elm$html$Html$text('')
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                !$author$project$Api$Partner$Engagement$All$betaAccessGranted(engagement) ? A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Grant access'
                    }, _List_fromArray([
                        $author$project$Ui$Button$default,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Partner$Engagements$GrantAccess(engagement))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Grant access')
                    ]))
                ])) : $elm$html$Html$text('')
            ]))
        ]) : _List_Nil));
    });
    var $author$project$Pages$Partner$Engagements$viewTable = function(model) {
        var showBetaColumns = !$author$project$Pages$Partner$Engagements$isLiveOrAbove(model.Tj);
        var visibleColumns = showBetaColumns ? $author$project$Pages$Partner$Engagements$columns : A2($elm$core$List$take, 3, $author$project$Pages$Partner$Engagements$columns);
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$loading(_Utils_eq(model.b6, $author$project$Api$Data$Loading))
        ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Partner$Engagements$SortTable)), visibleColumns), A2($elm$core$List$map, A2($author$project$Pages$Partner$Engagements$viewRow, showBetaColumns, model.HO), A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.b6))), _List_Nil);
    };
    var $author$project$Pages$Partner$Engagements$viewBody = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb4
                    ]), _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Engagements')
                        ]))
                    ])),
                    $author$project$Pages$Partner$Engagements$viewStats(model),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(4)
                        ]), _List_fromArray([
                            $author$project$Pages$Partner$Engagements$viewStatusFilter(model)
                        ]))
                    ]))
                ])),
                $author$project$Pages$Partner$Engagements$viewTable(model),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Partner$Engagements$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(_Utils_eq(model.b6, $author$project$Api$Data$Loading))
                    ]), model.af_))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Partner$Engagements$view = function(model) {
        return {
            fb: $author$project$Pages$Partner$Engagements$viewBody(model),
            $2: 'Partner | Engagements'
        };
    };
    var $author$project$Pages$Partner$Engagements$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Engagements$init,
        aeR: $author$project$Pages$Partner$Engagements$load,
        ag3: $author$project$Pages$Partner$Engagements$save,
        ahE: $author$project$Pages$Partner$Engagements$subscriptions,
        aaO: $author$project$Pages$Partner$Engagements$update,
        aid: $author$project$Pages$Partner$Engagements$view
    });
    var $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Hinter$PartnerFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerForm$Model = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Partner$Shared$active = function(_v0) {
        var record = _v0;
        return record.Ir;
    };
    var $author$project$Api$Partner$Partner$One$active = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$active(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$practicesReadOnly = function(_v0) {
        var record = _v0;
        return record.W9;
    };
    var $author$project$Api$Partner$Partner$One$practicesReadOnly = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$practicesReadOnly(shared);
    };
    var $author$project$Components$Hinter$EditPartnerForm$initFormFields = function(partner) {
        return _Utils_Tuple2({
            Ir: $author$project$Api$Partner$Partner$One$active(partner),
            W9: $author$project$Api$Partner$Partner$One$practicesReadOnly(partner),
            Zo: $author$project$Api$Partner$Partner$One$sandboxEnabled(partner)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Components$Hinter$EditPartnerForm$init = function(partner) {
        var _v0 = $author$project$Components$Hinter$EditPartnerForm$initFormFields(partner);
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init(formFields),
            o2: $author$project$Api$Data$NotAsked
        }, formFieldsCmd);
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$init = F2(function(_v0, partner) {
        return {
            aH: $elm$core$Maybe$Nothing,
            VW: partner
        };
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$init = function(partner) {
        return _Utils_Tuple2({
            a2: $elm$core$Maybe$Nothing,
            a3: $elm$core$Maybe$Nothing,
            a4: $elm$core$Maybe$Nothing,
            a5: $elm$core$Maybe$Nothing,
            VW: partner
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$Partner$Hinter$init = F4(function(_v0, partner, shared, _v1) {
        var managedByForm = A2($author$project$Components$Partner$AdminSettings$ManagedByForm$init, shared.Ej, partner);
        var _v2 = $author$project$Components$Hinter$EditPartnerForm$init(partner);
        var partnerForm = _v2.a;
        var partnerFormCmd = _v2.b;
        var _v3 = $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$init(partner);
        var partnerDocumentsForm = _v3.a;
        var partnerDocumentsFormCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            i9: managedByForm,
            VW: partner,
            jo: partnerDocumentsForm,
            be: partnerForm,
            j8: false
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerFormMsg, partnerFormCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, partnerDocumentsFormCmd)
        ])));
    });
    var $author$project$Pages$Partner$Hinter$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Hinter$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Hinter$ArchiveConfirmClosed = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Partner$Hinter$ManagedByFormMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerForm$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy = {
        $: 2
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = model.aH;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var managedByInput = _v2.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg, $author$project$Components$Partner$AdminSettings$ManagedByInput$subscriptions(managedByInput));
                } else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy)), model.aH))
        ]));
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit = {
        $: 4
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)), model.a5)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)), model.a2)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)), model.a3)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit)), model.a4))
        ]));
    };
    var $author$project$Pages$Partner$Hinter$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Hinter$PartnerFormMsg, $author$project$Components$Hinter$EditPartnerForm$subscriptions(model.be)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Hinter$ManagedByFormMsg, $author$project$Components$Partner$AdminSettings$ManagedByForm$subscriptions(model.i9)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$subscriptions(model.jo)),
            model.j8 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Partner$Hinter$ArchiveConfirmClosed) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Pages$Partner$Hinter$PartnerArchived = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$archive = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Partner$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'archive'
        ]), $author$project$Api$Partner$Partner$partnerPath)));
    });
    var $author$project$Components$Hinter$EditPartnerForm$GotUpdatedPartner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerForm$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    W9: bool
                });
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    Ir: bool
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    Zo: bool
                });
        }
    });
    var $author$project$Components$Hinter$EditPartnerForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
    var $author$project$Components$Hinter$EditPartnerForm$toPermittedFields = function(fields) {
        return _List_fromArray([
            $author$project$Api$Partner$Partner$Active(fields.Ir),
            $author$project$Api$Partner$Partner$PracticesReadOnly(fields.W9),
            $author$project$Api$Partner$Partner$SandboxEnabled(fields.Zo)
        ]);
    };
    var $author$project$Components$Hinter$EditPartnerForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Hinter$EditPartnerForm$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$EditPartnerForm$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validFormFields = _v3.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    return _Utils_Tuple3(_Utils_update(model, {
                        o2: $author$project$Api$Data$Loading
                    }), A3($author$project$Api$Partner$Partner$update, apiClient, $author$project$Components$Hinter$EditPartnerForm$toPermittedFields(fields), $author$project$Components$Hinter$EditPartnerForm$GotUpdatedPartner), _List_Nil);
                } else {
                    var updatedForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: updatedForm,
                        o2: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    o2: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                    $author$project$OutMsg$RefreshPartner
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    o2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByManagementGroup = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedBySaved = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Partner$ManagementGroup$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v2 = model.aH;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var managedByInput = _v3.a;
                    var request = _v3.b;
                    var _v4 = A3($author$project$Components$Partner$AdminSettings$ManagedByInput$update, apiClient, subMsg, managedByInput);
                    var newManagedByInput = _v4.a;
                    var managedByInputCmd = _v4.b;
                    var outMsgs = _v4.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aH: $elm$core$Maybe$Just(_Utils_Tuple2(newManagedByInput, request))
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg, managedByInputCmd), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var initialValue = A2($elm$core$Maybe$map, function(managedBy) {
                    if (!managedBy.$) {
                        var practice = managedBy.a;
                        return $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByPractice($author$project$Api$Partner$Practice$Min$id(practice));
                    } else {
                        var managementGroup = managedBy.a;
                        return $author$project$Components$Partner$AdminSettings$ManagedByInput$ManagedByManagementGroup($author$project$Api$Partner$ManagementGroup$Min$id(managementGroup));
                    }
                }, $author$project$Api$Partner$Partner$One$managedBy(model.VW));
                var _v5 = A2($author$project$Components$Partner$AdminSettings$ManagedByInput$init, apiClient, initialValue);
                var managedByInput = _v5.a;
                var managedByInputCmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    aH: $elm$core$Maybe$Just(_Utils_Tuple2(managedByInput, $author$project$Api$Data$NotAsked))
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg, managedByInputCmd), _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    aH: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v7 = model.aH;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var managedByInput = _v8.a;
                    var managedByValue = A2($elm$core$Maybe$map, function(v) {
                        if (!v.$) {
                            var practiceId = v.a;
                            return $author$project$Api$Partner$Partner$ManagedByPractice(practiceId);
                        } else {
                            var managementGroupId = v.a;
                            return $author$project$Api$Partner$Partner$ManagedByManagementGroup(managementGroupId);
                        }
                    }, $author$project$Components$Partner$AdminSettings$ManagedByInput$value(managedByInput));
                    var permittedFields = _List_fromArray([
                        $author$project$Api$Partner$Partner$ManagedBy(managedByValue)
                    ]);
                    return _Utils_Tuple3(_Utils_update(model, {
                        aH: $elm$core$Maybe$Just(_Utils_Tuple2(managedByInput, $author$project$Api$Data$Loading))
                    }), A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedBySaved), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                var _v10 = model.aH;
                if (!_v10.$) {
                    var _v11 = _v10.a;
                    var managedByInput = _v11.a;
                    if (response.$ === 3) {
                        var partner = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            aH: $elm$core$Maybe$Nothing,
                            VW: partner
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                            $author$project$OutMsg$RefreshPartner
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        aH: $elm$core$Maybe$Just(_Utils_Tuple2(managedByInput, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Api$Partner$Partner$AddendumAgreement = function(a) {
        return {
            $: 31,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementProcessed = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementSaved = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$CustomApiAccessAgreement = function(a) {
        return {
            $: 32,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementProcessed = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementSaved = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$CustomBaaAgreement = function(a) {
        return {
            $: 33,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementProcessed = F2(function(a, b) {
        return {
            $: 20,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementSaved = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$CustomPartnerAgreement = function(a) {
        return {
            $: 30,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementProcessed = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementSaved = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotAddendumAgreementUrl = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomApiAccessAgreementUrl = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomBaaAgreementUrl = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomPartnerAgreementUrl = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation = F2(function(addendumAgreementType, fileSizeAndUrl) {
        if (addendumAgreementType === 1) {
            if (!fileSizeAndUrl.$) {
                var _v2 = fileSizeAndUrl.a;
                var fileSize = _v2.a;
                return _Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0 ? _List_fromArray([
                    'That file is too large! Our maximum file size is 5 mb.'
                ]) : _List_Nil;
            } else return _List_fromArray([
                'Please upload a file'
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidAddendumAgreement = F2(function(addendumAgreementType, fileSizeAndUrl) {
        return $elm$core$List$isEmpty(A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation, addendumAgreementType, fileSizeAndUrl));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation = F2(function(customApiAccessAgreementType, fileSizeAndUrl) {
        if (customApiAccessAgreementType === 1) {
            if (!fileSizeAndUrl.$) {
                var _v2 = fileSizeAndUrl.a;
                var fileSize = _v2.a;
                return _Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0 ? _List_fromArray([
                    'That file is too large! Our maximum file size is 5 mb.'
                ]) : _List_Nil;
            } else return _List_fromArray([
                'Please upload a file'
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomApiAccessAgreement = F2(function(customApiAccessAgreementType, fileSizeAndUrl) {
        return $elm$core$List$isEmpty(A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation, customApiAccessAgreementType, fileSizeAndUrl));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation = F2(function(customBaaAgreementType, fileSizeAndUrl) {
        if (customBaaAgreementType === 1) {
            if (!fileSizeAndUrl.$) {
                var _v2 = fileSizeAndUrl.a;
                var fileSize = _v2.a;
                return _Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0 ? _List_fromArray([
                    'That file is too large! Our maximum file size is 5 mb.'
                ]) : _List_Nil;
            } else return _List_fromArray([
                'Please upload a file'
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomBaaAgreement = F2(function(customBaaAgreementType, fileSizeAndUrl) {
        return $elm$core$List$isEmpty(A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation, customBaaAgreementType, fileSizeAndUrl));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation = F2(function(customPartnerAgreementType, fileSizeAndUrl) {
        if (customPartnerAgreementType === 1) {
            if (!fileSizeAndUrl.$) {
                var _v2 = fileSizeAndUrl.a;
                var fileSize = _v2.a;
                return _Utils_cmp(fileSize, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$maxFileBytesSize) > 0 ? _List_fromArray([
                    'That file is too large! Our maximum file size is 5 mb.'
                ]) : _List_Nil;
            } else return _List_fromArray([
                'Please upload a file'
            ]);
        } else return _List_Nil;
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomPartnerAgreement = F2(function(customPartnerAgreementType, fileSizeAndUrl) {
        return $elm$core$List$isEmpty(A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation, customPartnerAgreementType, fileSizeAndUrl));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var customPartnerAgreementType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    a5: $elm$core$Maybe$Just(_Utils_Tuple3(customPartnerAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var addendumAgreementType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    a2: $elm$core$Maybe$Just(_Utils_Tuple3(addendumAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var customApiAccessAgreementType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    a3: $elm$core$Maybe$Just(_Utils_Tuple3(customApiAccessAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var customBaaAgreementType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    a4: $elm$core$Maybe$Just(_Utils_Tuple3(customBaaAgreementType, $elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    a2: $elm$core$Maybe$Nothing,
                    a3: $elm$core$Maybe$Nothing,
                    a4: $elm$core$Maybe$Nothing,
                    a5: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var _v2 = model.a5;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var customPartnerAgreementType = _v3.a;
                    var fileSizeAndUrl = _v3.b;
                    if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomPartnerAgreement, customPartnerAgreementType, fileSizeAndUrl)) {
                        var permittedFields = _List_fromArray([
                            $author$project$Api$Partner$Partner$CustomPartnerAgreement(function() {
                                if (customPartnerAgreementType === 1) return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
                                else return $elm$core$Maybe$Nothing;
                            }())
                        ]);
                        return _Utils_Tuple3(_Utils_update(model, {
                            a5: $elm$core$Maybe$Just(_Utils_Tuple3(customPartnerAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
                        }), A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementSaved), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var _v5 = model.a2;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var addendumAgreementType = _v6.a;
                    var fileSizeAndUrl = _v6.b;
                    if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidAddendumAgreement, addendumAgreementType, fileSizeAndUrl)) {
                        var permittedFields = _List_fromArray([
                            $author$project$Api$Partner$Partner$AddendumAgreement(function() {
                                if (addendumAgreementType === 1) return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
                                else return $elm$core$Maybe$Nothing;
                            }())
                        ]);
                        return _Utils_Tuple3(_Utils_update(model, {
                            a2: $elm$core$Maybe$Just(_Utils_Tuple3(addendumAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
                        }), A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementSaved), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var _v8 = model.a3;
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var customApiAccessAgreementType = _v9.a;
                    var fileSizeAndUrl = _v9.b;
                    if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomApiAccessAgreement, customApiAccessAgreementType, fileSizeAndUrl)) {
                        var permittedFields = _List_fromArray([
                            $author$project$Api$Partner$Partner$CustomApiAccessAgreement(function() {
                                if (customApiAccessAgreementType === 1) return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
                                else return $elm$core$Maybe$Nothing;
                            }())
                        ]);
                        return _Utils_Tuple3(_Utils_update(model, {
                            a3: $elm$core$Maybe$Just(_Utils_Tuple3(customApiAccessAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
                        }), A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementSaved), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var _v11 = model.a4;
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var customBaaAgreementType = _v12.a;
                    var fileSizeAndUrl = _v12.b;
                    if (A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$isValidCustomBaaAgreement, customBaaAgreementType, fileSizeAndUrl)) {
                        var permittedFields = _List_fromArray([
                            $author$project$Api$Partner$Partner$CustomBaaAgreement(function() {
                                if (customBaaAgreementType === 1) return A2($elm$core$Maybe$map, $elm$core$Tuple$second, fileSizeAndUrl);
                                else return $elm$core$Maybe$Nothing;
                            }())
                        ]);
                        return _Utils_Tuple3(_Utils_update(model, {
                            a4: $elm$core$Maybe$Just(_Utils_Tuple3(customBaaAgreementType, fileSizeAndUrl, $author$project$Api$Data$Loading))
                        }), A3($author$project$Api$Partner$Partner$update, apiClient, permittedFields, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementSaved), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var response = msg.a;
                var _v14 = model.a5;
                if (!_v14.$) {
                    var _v15 = _v14.a;
                    var customPartnerAgreementType = _v15.a;
                    var customPartnerAgreementFile = _v15.b;
                    if (response.$ === 3) {
                        var partner = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            a5: $elm$core$Maybe$Nothing,
                            VW: partner
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                            $author$project$OutMsg$RefreshPartner
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        a5: $elm$core$Maybe$Just(_Utils_Tuple3(customPartnerAgreementType, customPartnerAgreementFile, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var response = msg.a;
                var _v17 = model.a2;
                if (!_v17.$) {
                    var _v18 = _v17.a;
                    var addendumAgreementType = _v18.a;
                    var addendumAgreementFile = _v18.b;
                    if (response.$ === 3) {
                        var partner = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            a2: $elm$core$Maybe$Nothing,
                            VW: partner
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                            $author$project$OutMsg$RefreshPartner
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        a2: $elm$core$Maybe$Just(_Utils_Tuple3(addendumAgreementType, addendumAgreementFile, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var response = msg.a;
                var _v20 = model.a3;
                if (!_v20.$) {
                    var _v21 = _v20.a;
                    var customApiAccessAgreementType = _v21.a;
                    var customApiAccessAgreementFile = _v21.b;
                    if (response.$ === 3) {
                        var partner = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            a3: $elm$core$Maybe$Nothing,
                            VW: partner
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                            $author$project$OutMsg$RefreshPartner
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        a3: $elm$core$Maybe$Just(_Utils_Tuple3(customApiAccessAgreementType, customApiAccessAgreementFile, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var response = msg.a;
                var _v23 = model.a4;
                if (!_v23.$) {
                    var _v24 = _v23.a;
                    var customBaaAgreementType = _v24.a;
                    var customBaaAgreementFile = _v24.b;
                    if (response.$ === 3) {
                        var partner = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            a4: $elm$core$Maybe$Nothing,
                            VW: partner
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                            $author$project$OutMsg$RefreshPartner
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        a4: $elm$core$Maybe$Just(_Utils_Tuple3(customBaaAgreementType, customBaaAgreementFile, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var files = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v26) {
                    var task = _v26.a;
                    var size = _v26.b;
                    return A2($elm$core$Task$perform, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementProcessed(size), task);
                }, A2($elm$core$Maybe$map, function(file) {
                    return _Utils_Tuple2($elm$file$File$toUrl(file), $elm$file$File$size(file));
                }, $elm$core$List$head(files))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 14:
                var size = msg.a;
                var url = msg.b;
                var _v27 = model.a5;
                if (!_v27.$) {
                    var _v28 = _v27.a;
                    var customPartnerAgreementType = _v28.a;
                    var request = _v28.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        a5: $elm$core$Maybe$Just(_Utils_Tuple3(customPartnerAgreementType, $elm$core$Maybe$Just(_Utils_Tuple2(size, url)), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var files = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v29) {
                    var task = _v29.a;
                    var size = _v29.b;
                    return A2($elm$core$Task$perform, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementProcessed(size), task);
                }, A2($elm$core$Maybe$map, function(file) {
                    return _Utils_Tuple2($elm$file$File$toUrl(file), $elm$file$File$size(file));
                }, $elm$core$List$head(files))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 16:
                var size = msg.a;
                var url = msg.b;
                var _v30 = model.a2;
                if (!_v30.$) {
                    var _v31 = _v30.a;
                    var addendumAgreementType = _v31.a;
                    var request = _v31.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        a2: $elm$core$Maybe$Just(_Utils_Tuple3(addendumAgreementType, $elm$core$Maybe$Just(_Utils_Tuple2(size, url)), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var files = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v32) {
                    var task = _v32.a;
                    var size = _v32.b;
                    return A2($elm$core$Task$perform, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementProcessed(size), task);
                }, A2($elm$core$Maybe$map, function(file) {
                    return _Utils_Tuple2($elm$file$File$toUrl(file), $elm$file$File$size(file));
                }, $elm$core$List$head(files))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 18:
                var size = msg.a;
                var url = msg.b;
                var _v33 = model.a3;
                if (!_v33.$) {
                    var _v34 = _v33.a;
                    var customApiAccessAgreementType = _v34.a;
                    var request = _v34.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        a3: $elm$core$Maybe$Just(_Utils_Tuple3(customApiAccessAgreementType, $elm$core$Maybe$Just(_Utils_Tuple2(size, url)), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var files = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v35) {
                    var task = _v35.a;
                    var size = _v35.b;
                    return A2($elm$core$Task$perform, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementProcessed(size), task);
                }, A2($elm$core$Maybe$map, function(file) {
                    return _Utils_Tuple2($elm$file$File$toUrl(file), $elm$file$File$size(file));
                }, $elm$core$List$head(files))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 20:
                var size = msg.a;
                var url = msg.b;
                var _v36 = model.a4;
                if (!_v36.$) {
                    var _v37 = _v36.a;
                    var customBaaAgreementType = _v37.a;
                    var request = _v37.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        a4: $elm$core$Maybe$Just(_Utils_Tuple3(customBaaAgreementType, $elm$core$Maybe$Just(_Utils_Tuple2(size, url)), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 21:
                return _Utils_Tuple3(model, A2($author$project$Api$Partner$Partner$signedCustomPartnerAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomPartnerAgreementUrl), _List_Nil);
            case 22:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(url), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 23:
                return _Utils_Tuple3(model, A2($author$project$Api$Partner$Partner$signedAddendumAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotAddendumAgreementUrl), _List_Nil);
            case 24:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(url), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 25:
                return _Utils_Tuple3(model, A2($author$project$Api$Partner$Partner$signedCustomApiAccessAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomApiAccessAgreementUrl), _List_Nil);
            case 26:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(url), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 27:
                return _Utils_Tuple3(model, A2($author$project$Api$Partner$Partner$signedCustomBaaAgreementUrl, apiClient, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$GotCustomBaaAgreementUrl), _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(url), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Partner$Hinter$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$Hinter$EditPartnerForm$update, model.Ej, subMsg, model.be);
                var partnerForm = _v1.a;
                var cmd = _v1.b;
                var outMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    be: partnerForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerFormMsg, cmd), outMsgs);
            case 1:
                var subMsg = msg.a;
                var _v2 = A3($author$project$Components$Partner$AdminSettings$ManagedByForm$update, model.Ej, subMsg, model.i9);
                var managedByForm = _v2.a;
                var managedByFormCmd = _v2.b;
                var managedByForOutMsgs = _v2.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    i9: managedByForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$ManagedByFormMsg, managedByFormCmd), managedByForOutMsgs);
            case 2:
                var subMsg = msg.a;
                var _v3 = A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$update, model.Ej, subMsg, model.jo);
                var partnerDocumentsForm = _v3.a;
                var partnerDocumentsFormCmd = _v3.b;
                var partnerDocumentsFormOutMsgs = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    jo: partnerDocumentsForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, partnerDocumentsFormCmd), partnerDocumentsFormOutMsgs);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    j8: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    j8: false
                }), A2($author$project$Api$Partner$Partner$archive, model.Ej, $author$project$Pages$Partner$Hinter$PartnerArchived), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    j8: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var partner = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        VW: partner
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        $author$project$OutMsg$RefreshPartner
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$SaveManagedBy = {
        $: 3
    };
    var $author$project$Api$Partner$Partner$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$Partner$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$id(shared);
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$viewEditManagedByModal = F3(function(managedByInput, request, model) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Managed By',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just($author$project$Api$Partner$Partner$One$id(model.VW)),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Partner$AdminSettings$ManagedByForm$CancelEditManagedBy,
            Vn: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$ManagedByForm$SaveManagedBy)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Partner$AdminSettings$ManagedByForm$ManagedByInputMsg, $author$project$Components$Partner$AdminSettings$ManagedByInput$view(managedByInput))
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$modal = function(_v0) {
        var model = _v0;
        var _v1 = model.aH;
        if (!_v1.$) {
            var _v2 = _v1.a;
            var managedByInput = _v2.a;
            var request = _v2.b;
            return A3($author$project$Components$Partner$AdminSettings$ManagedByForm$viewEditManagedByModal, managedByInput, request, model);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementTypeNone = 0;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementTypePdf = 1;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementUploaded = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveAddendumAgreement = {
        $: 6
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton = F3(function(currentAddendumAgreementType, addendumAgreementType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentAddendumAgreementType, addendumAgreementType)),
            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement(addendumAgreementType))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditAddendumAgreementModal = F4(function(addendumAgreementType, fileSizeAndUrl, request, model) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Addendum Agreement',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just($author$project$Api$Partner$Partner$One$id(model.VW)),
            TS: $elm$core$Maybe$Just('Updating the addendum agreement will remove the acceptance of the addendum agreement.'),
            Vl: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
            Vn: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveAddendumAgreement)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Addendum Agreement')
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton, addendumAgreementType, 0, 'None'),
                    A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewAddendumAgreementTypeButton, addendumAgreementType, 1, 'PDF')
                ]))
            ])),
            function() {
                if (addendumAgreementType === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('PDF')
                ]), _List_fromArray([
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(2),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$AddendumAgreementUploaded)
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$addendumAgreementValidation, addendumAgreementType, fileSizeAndUrl))
                ]));
                else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementTypeNone = 0;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementTypePdf = 1;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementUploaded = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomApiAccessAgreement = {
        $: 7
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton = F3(function(currentCustomApiAccessAgreementType, customApiAccessAgreementType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentCustomApiAccessAgreementType, customApiAccessAgreementType)),
            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement(customApiAccessAgreementType))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomApiAccessAgreementModal = F4(function(customApiAccessAgreementType, fileSizeAndUrl, request, model) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Custom Api Access Agreement',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just($author$project$Api$Partner$Partner$One$id(model.VW)),
            TS: $elm$core$Maybe$Just('Updating the custom api access agreement will remove the acceptance of the api access agreement.'),
            Vl: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
            Vn: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomApiAccessAgreement)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Custom Api Access Agreement')
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton, customApiAccessAgreementType, 0, 'None'),
                    A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomApiAccessAgreementTypeButton, customApiAccessAgreementType, 1, 'PDF')
                ]))
            ])),
            function() {
                if (customApiAccessAgreementType === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('PDF')
                ]), _List_fromArray([
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(2),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomApiAccessAgreementUploaded)
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customApiAccessAgreementValidation, customApiAccessAgreementType, fileSizeAndUrl))
                ]));
                else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementTypeNone = 0;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementTypePdf = 1;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementUploaded = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomBaaAgreement = {
        $: 8
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton = F3(function(currentCustomBaaAgreementType, customBaaAgreementType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentCustomBaaAgreementType, customBaaAgreementType)),
            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement(customBaaAgreementType))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomBaaAgreementModal = F4(function(customBaaAgreementType, fileSizeAndUrl, request, model) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Custom BAA Agreement',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just($author$project$Api$Partner$Partner$One$id(model.VW)),
            TS: $elm$core$Maybe$Just('Updating the custom BAA agreement will remove the acceptance of the BAA agreement.'),
            Vl: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
            Vn: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomBaaAgreement)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Custom BAA Agreement')
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton, customBaaAgreementType, 0, 'None'),
                    A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomBaaAgreementTypeButton, customBaaAgreementType, 1, 'PDF')
                ]))
            ])),
            function() {
                if (customBaaAgreementType === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('PDF')
                ]), _List_fromArray([
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(2),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomBaaAgreementUploaded)
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customBaaAgreementValidation, customBaaAgreementType, fileSizeAndUrl))
                ]));
                else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementTypeNone = 0;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementTypePdf = 1;
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementUploaded = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomPartnerAgreement = {
        $: 5
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton = F3(function(currentCustomPartnerAgreementType, customPartnerAgreementType, label) {
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentCustomPartnerAgreementType, customPartnerAgreementType)),
            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement(customPartnerAgreementType))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomPartnerAgreementModal = F4(function(customPartnerAgreementType, fileSizeAndUrl, request, model) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Custom Partner Agreement',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: $elm$core$Maybe$Just($author$project$Api$Partner$Partner$One$id(model.VW)),
            TS: $elm$core$Maybe$Just('Updating the custom partner agreement will remove the acceptance of the partner agreement.'),
            Vl: $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CancelEdit,
            Vn: $elm$core$Basics$always($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$SaveCustomPartnerAgreement)
        };
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Custom Partner Agreement')
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton, customPartnerAgreementType, 0, 'None'),
                    A3($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewCustomPartnerAgreementTypeButton, customPartnerAgreementType, 1, 'PDF')
                ]))
            ])),
            function() {
                if (customPartnerAgreementType === 1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('PDF')
                ]), _List_fromArray([
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(2),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$CustomPartnerAgreementUploaded)
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$customPartnerAgreementValidation, customPartnerAgreementType, fileSizeAndUrl))
                ]));
                else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$modal = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            function() {
                var _v1 = model.a5;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var customPartnerAgreementType = _v2.a;
                    var fileSizeAndUrl = _v2.b;
                    var request = _v2.c;
                    return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomPartnerAgreementModal, customPartnerAgreementType, fileSizeAndUrl, request, model);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.a2;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var addendumAgreementType = _v4.a;
                    var fileSizeAndUrl = _v4.b;
                    var request = _v4.c;
                    return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditAddendumAgreementModal, addendumAgreementType, fileSizeAndUrl, request, model);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.a3;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var customApiAccessAgreementType = _v6.a;
                    var fileSizeAndUrl = _v6.b;
                    var request = _v6.c;
                    return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomApiAccessAgreementModal, customApiAccessAgreementType, fileSizeAndUrl, request, model);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v7 = model.a4;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var customBaaAgreementType = _v8.a;
                    var fileSizeAndUrl = _v8.b;
                    var request = _v8.c;
                    return A4($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$viewEditCustomBaaAgreementModal, customBaaAgreementType, fileSizeAndUrl, request, model);
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Hinter$EditPartnerForm$Active = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerForm$PracticesReadOnly = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerForm$SandboxEnabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerForm$Save = {
        $: 1
    };
    var $author$project$Components$Hinter$EditPartnerForm$view = function(_v0) {
        var model = _v0;
        var loading = _Utils_eq(model.o2, $author$project$Api$Data$Loading);
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Live API Enabled')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.Ir),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$Active))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Sandbox Enabled')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.Zo),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$SandboxEnabled))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Practices Read Only')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.W9),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerForm$FormUpdated, $author$project$Components$Hinter$EditPartnerForm$PracticesReadOnly))
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textCenter,
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Save partner changes'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit,
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$onClick($author$project$Components$Hinter$EditPartnerForm$Save)
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$EditManagedBy = {
        $: 1
    };
    var $author$project$Api$Partner$ManagementGroup$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$Partner$AdminSettings$ManagedByForm$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('Managed By')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    function() {
                        var _v1 = $author$project$Api$Partner$Partner$One$managedBy(model.VW);
                        if (!_v1.$) {
                            if (!_v1.a.$) {
                                var practice = _v1.a.a;
                                return $elm$html$Html$text($author$project$Api$Partner$Practice$Min$name(practice) + (' (' + ($author$project$Api$Partner$Practice$Min$id(practice) + ')')));
                            } else {
                                var managementGroup = _v1.a.a;
                                return $elm$html$Html$text($author$project$Api$Partner$ManagementGroup$Min$name(managementGroup) + (' (' + ($author$project$Api$Partner$ManagementGroup$Min$id(managementGroup) + ')')));
                            }
                        } else return $elm$html$Html$text('None');
                    }(),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Change managed by'
                    }, _List_fromArray([
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$ManagedByForm$EditManagedBy)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Change')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenAddendumAgreement = {
        $: 23
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomApiAccessAgreement = {
        $: 25
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomBaaAgreement = {
        $: 27
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomPartnerAgreement = {
        $: 21
    };
    var $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$view = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Custom Partner Agreement')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        function() {
                            var _v1 = $author$project$Api$Partner$Partner$One$customPartnerAgreementFileName(model.VW);
                            if (!_v1.$) return A3($author$project$Ui$Button$view, {
                                abP: 'View custom partner agreement'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomPartnerAgreement)
                            ]), _List_fromArray([
                                $elm$html$Html$text('View custom partner agreement')
                            ]));
                            else return $elm$html$Html$text('None');
                        }(),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Manage custom partner agreement'
                        }, _List_fromArray([
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomPartnerAgreement(0))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Manage')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Addendum Agreement')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        function() {
                            var _v2 = $author$project$Api$Partner$Partner$One$addendumAgreementFileName(model.VW);
                            if (!_v2.$) return A3($author$project$Ui$Button$view, {
                                abP: 'View addendum agreement'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenAddendumAgreement)
                            ]), _List_fromArray([
                                $elm$html$Html$text('View addendum agreement')
                            ]));
                            else return $elm$html$Html$text('None');
                        }(),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Manage addendum agreement'
                        }, _List_fromArray([
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditAddendumAgreement(0))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Manage')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Custom Api Access Agreement')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        function() {
                            var _v3 = $author$project$Api$Partner$Partner$One$customApiAccessAgreementFileName(model.VW);
                            if (!_v3.$) return A3($author$project$Ui$Button$view, {
                                abP: 'View custom api access agreement'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomApiAccessAgreement)
                            ]), _List_fromArray([
                                $elm$html$Html$text('View custom api access agreement')
                            ]));
                            else return $elm$html$Html$text('None');
                        }(),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Manage custom api access agreement'
                        }, _List_fromArray([
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomApiAccessAgreement(0))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Manage')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Custom BAA Agreement')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        function() {
                            var _v4 = $author$project$Api$Partner$Partner$One$customBaaAgreementFileName(model.VW);
                            if (!_v4.$) return A3($author$project$Ui$Button$view, {
                                abP: 'View custom BAA agreement'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$OpenCustomBaaAgreement)
                            ]), _List_fromArray([
                                $elm$html$Html$text('View custom BAA agreement')
                            ]));
                            else return $elm$html$Html$text('None');
                        }(),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Manage custom BAA agreement'
                        }, _List_fromArray([
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick($author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$EditCustomBaaAgreement(0))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Manage')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Hinter$ArchiveClicked = {
        $: 3
    };
    var $author$project$Api$Partner$Partner$Shared$archived = function(_v0) {
        var record = _v0;
        return record.JC;
    };
    var $author$project$Api$Partner$Partner$One$archived = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$archived(shared);
    };
    var $author$project$Pages$Partner$Hinter$viewArchive = function(partner) {
        return $author$project$Api$Partner$Partner$One$archived(partner) ? $elm$html$Html$text('') : A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Archive')
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textMuted,
                $author$project$Ui$Element$textSm,
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                $elm$html$Html$text('Archive this partner account. This will decommission all products, revoke api keys, deactivate integrations and remove access entirely.')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Archive Partner'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Hinter$ArchiveClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Archive')
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Hinter$view = function(model) {
        return {
            fb: _List_fromArray([
                model.j8 ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Partner$Hinter$ArchiveConfirmClosed, _List_fromArray([
                    $author$project$Components$HiConfirm$verb('archive'),
                    $author$project$Components$HiConfirm$noun('partner')
                ])) : $elm$html$Html$text(''),
                A2($elm$html$Html$map, $author$project$Pages$Partner$Hinter$ManagedByFormMsg, $author$project$Components$Partner$AdminSettings$ManagedByForm$modal(model.i9)),
                A2($elm$html$Html$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$modal(model.jo)),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Admin Actions')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Hinter$PartnerFormMsg, $author$project$Components$Hinter$EditPartnerForm$view(model.be)),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Hinter$ManagedByFormMsg, $author$project$Components$Partner$AdminSettings$ManagedByForm$view(model.i9)),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Hinter$PartnerDocumentsFormMsg, $author$project$Components$Partner$AdminSettings$PartnerDocumentsForm$view(model.jo)),
                        $author$project$Pages$Partner$Hinter$viewArchive(model.VW)
                    ]))
                ]))
            ]),
            $2: 'Partner | Admin Settings'
        };
    };
    var $author$project$Pages$Partner$Hinter$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Hinter$init,
        aeR: $author$project$Pages$Partner$Hinter$load,
        ag3: $author$project$Pages$Partner$Hinter$save,
        ahE: $author$project$Pages$Partner$Hinter$subscriptions,
        aaO: $author$project$Pages$Partner$Hinter$update,
        aid: $author$project$Pages$Partner$Hinter$view
    });
    var $author$project$Pages$Partner$Practices$Top$GotIntegrations = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Practices$Top$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        };
    };
    var $author$project$Pages$Partner$Practices$Top$fetchIntegrations = function(model) {
        return A3($author$project$Api$Partner$Integration$list, model.Ej, $author$project$Pages$Partner$Practices$Top$fetchParams(model), $author$project$Pages$Partner$Practices$Top$GotIntegrations);
    };
    var $author$project$Pages$Partner$Practices$Top$init = F4(function(_v0, partner, shared, _v1) {
        var query = _v1.Bz;
        var model = {
            bL: $elm$core$Maybe$Nothing,
            bM: $elm$core$Maybe$Nothing,
            Ej: shared.Ej,
            Rt: $author$project$Api$Data$Loading,
            F3: $author$project$Shared$isHintAdmin(shared),
            af_: $author$project$Api$Pagination$initFromQuery(query),
            VW: partner,
            agq: A2($elm$core$Dict$get, 'q', query),
            sG: $author$project$Ui$SearchInput$init(A2($elm$core$Dict$get, 'q', query)),
            ahs: A3($author$project$Api$Sort$withDefault, 'status', 1, $author$project$Api$Sort$initFromQuery(query))
        };
        return _Utils_Tuple2(model, $author$project$Pages$Partner$Practices$Top$fetchIntegrations(model));
    });
    var $author$project$Pages$Partner$Practices$Top$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Practices$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Practices$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Partner$Practices$Top$IntegrationActivated = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Practices$Top$IntegrationCreated = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Practices$Top$SearchInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Partner$Integration$One$Integration = 0;
    var $author$project$Api$Partner$Integration$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Partner$Integration$integrationPath = function(integrationId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            integrationId
        ]), $author$project$Api$Partner$Integration$integrationsPath);
    };
    var $author$project$Api$Partner$Integration$activate = F4(function(apiClient, integrationId, code, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('code', $elm$json$Json$Encode$string(code))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Integration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'activate'
        ]), $author$project$Api$Partner$Integration$integrationPath(integrationId)))));
    });
    var $author$project$Api$Partner$Integration$create = F3(function(apiClient, practiceId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('integration', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('practice', $author$project$Utils$Encode$association(practiceId))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Integration$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$integrationsPath)));
    });
    var $author$project$Pages$Partner$Practices$Top$updateUrl = function(model) {
        var params = _Utils_ap(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ])), _Utils_ap($author$project$Api$Sort$toQuery(model.ahs), $author$project$Api$Pagination$toPageQuery(model.af_)));
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Practices__Top)
        ]), params));
    };
    var $author$project$Pages$Partner$Practices$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Rt: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Rt: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    Rt: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
                    $author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    Rt: $author$project$Api$Data$Loading,
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
                    $author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                if (searchInputEvent.$ === 1) {
                    var q = searchInputEvent.a;
                    var newModel = _Utils_update(model, {
                        Rt: $author$project$Api$Data$Loading,
                        af_: $author$project$Api$Pagination$reset(model.af_),
                        agq: q,
                        sG: searchInput
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Practices$Top$SearchInputMsg, searchInputCmd),
                        $author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel),
                        $author$project$Pages$Partner$Practices$Top$updateUrl(newModel)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    sG: searchInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Practices$Top$SearchInputMsg, searchInputCmd), _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    bM: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    bM: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var _v4 = model.bM;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var practiceId = _v5.a;
                    if (!practiceId.$) {
                        var practiceId_ = practiceId.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bM: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(practiceId_), $author$project$Api$Data$Loading))
                        }), A3($author$project$Api$Partner$Integration$create, model.Ej, practiceId_, $author$project$Pages$Partner$Practices$Top$IntegrationCreated(practiceId_)), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var practiceId = msg.a;
                var _v7 = model.bM;
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var request = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bM: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$String$toMaybe(practiceId), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var practiceId = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bM: $elm$core$Maybe$Nothing,
                    Rt: $author$project$Api$Data$Loading
                }), $author$project$Pages$Partner$Practices$Top$fetchIntegrations(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Practice added')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    bM: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(practiceId), response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var integration = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    bL: $elm$core$Maybe$Just({
                        vC: false,
                        Lk: '',
                        Rn: integration,
                        su: $author$project$Api$Data$NotAsked
                    })
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                return _Utils_Tuple3(_Utils_update(model, {
                    bL: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var code = msg.a;
                var _v10 = model.bL;
                if (!_v10.$) {
                    var activation = _v10.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bL: $elm$core$Maybe$Just(_Utils_update(activation, {
                            Lk: code,
                            su: $author$project$Api$Data$NotAsked
                        }))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var _v11 = model.bL;
                if (!_v11.$) {
                    var activation = _v11.a;
                    var trimmedCode = $elm$core$String$trim(activation.Lk);
                    var updatedActivation = _Utils_update(activation, {
                        vC: true,
                        Lk: trimmedCode,
                        su: $author$project$Api$Data$NotAsked
                    });
                    if ($elm$core$String$isEmpty(trimmedCode)) return _Utils_Tuple3(_Utils_update(model, {
                        bL: $elm$core$Maybe$Just(updatedActivation)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                    else {
                        var integrationId = $author$project$Api$Partner$Integration$All$id(activation.Rn);
                        return _Utils_Tuple3(_Utils_update(model, {
                            bL: $elm$core$Maybe$Just(_Utils_update(updatedActivation, {
                                su: $author$project$Api$Data$Loading
                            }))
                        }), A4($author$project$Api$Partner$Integration$activate, model.Ej, integrationId, trimmedCode, $author$project$Pages$Partner$Practices$Top$IntegrationActivated(integrationId)), _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var integrationId = msg.a;
                var response = msg.b;
                var _v12 = model.bL;
                if (!_v12.$) {
                    var activation = _v12.a;
                    if (_Utils_eq($author$project$Api$Partner$Integration$All$id(activation.Rn), integrationId)) {
                        if (response.$ === 3) {
                            var newModel = _Utils_update(model, {
                                bL: $elm$core$Maybe$Nothing,
                                Rt: $author$project$Api$Data$Loading
                            });
                            return _Utils_Tuple3(newModel, $author$project$Pages$Partner$Practices$Top$fetchIntegrations(newModel), _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Practice activated')
                            ]));
                        } else return _Utils_Tuple3(_Utils_update(model, {
                            bL: $elm$core$Maybe$Just(_Utils_update(activation, {
                                su: response
                            }))
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Partner$Practices$Top$New = {
        $: 4
    };
    var $author$project$Pages$Partner$Practices$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed = {
        $: 10
    };
    var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationCodeChanged = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted = {
        $: 12
    };
    var $author$project$Pages$Partner$Practices$Top$viewActivateIntegrationModal = function(activation) {
        var showCodeError = activation.vC && $elm$core$String$isEmpty($elm$core$String$trim(activation.Lk));
        var practiceName = $author$project$Api$Partner$Practice$Shared$name($author$project$Api$Partner$Integration$All$practice(activation.Rn));
        var isLoading = _Utils_eq(activation.su, $author$project$Api$Data$Loading);
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed, _List_fromArray([
            $author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Activate Practice Integration')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceY4
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Enter the authorization code ' + (practiceName + ' shared with you to complete the connection.'))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Authorization Code'),
                        $author$project$Ui$Form$Group$required(true),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(activation.Lk),
                            $author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Practices$Top$ActivateIntegrationCodeChanged),
                            $author$project$Ui$Form$Input$invalid(showCodeError),
                            $author$project$Ui$Form$Input$errors(showCodeError ? _List_fromArray([
                                'Authorization code is required'
                            ]) : _List_Nil),
                            $author$project$Ui$Form$Input$disabled(isLoading)
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$ActivateIntegrationClosed),
                    $author$project$Ui$Button$disabled(isLoading)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Activate practice integration'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$ActivateIntegrationSubmitted),
                    $author$project$Ui$Button$loading(isLoading),
                    $author$project$Ui$Button$disabled(isLoading)
                ]), _List_fromArray([
                    $elm$html$Html$text('Activate')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Practices$Top$NewIntegrationClosed = {
        $: 5
    };
    var $author$project$Pages$Partner$Practices$Top$NewIntegrationPracticeIdUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Partner$Practices$Top$SaveIntegration = {
        $: 6
    };
    var $author$project$Pages$Partner$Practices$Top$viewAddIntegrationModal = F2(function(practiceId, request) {
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Practices$Top$NewIntegrationClosed, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add Practice')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Practice ID'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', practiceId)),
                        $author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Practices$Top$NewIntegrationPracticeIdUpdated),
                        $author$project$Ui$Form$Input$invalid(_Utils_eq(practiceId, $elm$core$Maybe$Nothing)),
                        $author$project$Ui$Form$Input$errors(_Utils_eq(practiceId, $elm$core$Maybe$Nothing) ? _List_fromArray([
                            'Practice is required'
                        ]) : _List_Nil)
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$NewIntegrationClosed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add Practice'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$SaveIntegration),
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Practice')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Practices$Top$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Practices$Top$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'practice', true, 'Name'),
        A3($author$project$Api$Column$init, 'status', true, 'Status'),
        A3($author$project$Api$Column$init, 'practice_active', true, 'Practice Active'),
        A3($author$project$Api$Column$init, 'partner_active', true, 'Partner Active')
    ]);
    var $author$project$Pages$Partner$Practices$Top$ActivateIntegrationClicked = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Partner$Integration$Shared$partnerActive = function(_v0) {
        var record = _v0;
        return record.VX;
    };
    var $author$project$Api$Partner$Integration$All$partnerActive = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Integration$Shared$partnerActive(shared);
    };
    var $author$project$Api$Partner$Integration$Shared$practiceActive = function(_v0) {
        var record = _v0;
        return record.W2;
    };
    var $author$project$Api$Partner$Integration$All$practiceActive = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Integration$Shared$practiceActive(shared);
    };
    var $author$project$Pages$Partner$Practices$Top$canActivateIntegration = function(integration) {
        return $author$project$Api$Partner$Integration$All$practiceActive(integration) && !$author$project$Api$Partner$Integration$All$partnerActive(integration);
    };
    var $author$project$Api$Partner$Practice$Shared$hasClinicalAccount = function(_v0) {
        var record = _v0.b;
        return record.Ql;
    };
    var $author$project$Api$Partner$Integration$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Partner$Integration$All$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Integration$Shared$status(shared);
    };
    var $author$project$Pages$Partner$Practices$Top$viewIntegration = function(integration) {
        var practice = $author$project$Api$Partner$Integration$All$practice(integration);
        var practiceName = $author$project$Api$Partner$Practice$Shared$name(practice);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(practiceName),
                $author$project$Api$Partner$Practice$Shared$hasClinicalAccount(practice) ? A2($author$project$Ui$Badge$view, _List_fromArray([
                    $author$project$Ui$Badge$info
                ]), _List_fromArray([
                    $elm$html$Html$text('Clinical')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Partner$Integration$All$status(integration))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Partner$Integration$All$practiceActive(integration)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$Bool$toString($author$project$Api$Partner$Integration$All$partnerActive(integration)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Pages$Partner$Practices$Top$canActivateIntegration(integration) ? A3($author$project$Ui$Button$view, {
                    abP: 'Activate ' + (practiceName + ' integration')
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$ActivateIntegrationClicked(integration))
                ]), _List_fromArray([
                    $elm$html$Html$text('Activate')
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Practices$Top$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.Rt;
            if (_v1.$ === 3) {
                var integrations_ = _v1.a;
                return _Utils_Tuple2(false, integrations_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var integrations = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any practices')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Partner$Practices$Top$SortTable)), $author$project$Pages$Partner$Practices$Top$columns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ])
        ])), A2($elm$core$List$map, $author$project$Pages$Partner$Practices$Top$viewIntegration, integrations), _List_Nil);
    };
    var $author$project$Pages$Partner$Practices$Top$view = function(model) {
        return {
            fb: function() {
                var loading = function() {
                    var _v3 = model.Rt;
                    if (_v3.$ === 3) return false;
                    else return true;
                }();
                return _List_fromArray([
                    function() {
                        var _v0 = model.bM;
                        if (!_v0.$) {
                            var _v1 = _v0.a;
                            var item = _v1.a;
                            var request = _v1.b;
                            return A2($author$project$Pages$Partner$Practices$Top$viewAddIntegrationModal, item, request);
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v2 = model.bL;
                        if (!_v2.$) {
                            var activation = _v2.a;
                            return $author$project$Pages$Partner$Practices$Top$viewActivateIntegrationModal(activation);
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween,
                                $author$project$Ui$Element$mb2
                            ]), _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('Practices')
                                ])),
                                model.F3 ? A3($author$project$Ui$HinterOnly$button, {
                                    abP: 'Add practice'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$default,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Practices$Top$New)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add Practice')
                                ])) : $author$project$Utils$Html$empty
                            ])),
                            A2($elm$html$Html$map, $author$project$Pages$Partner$Practices$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                        ])),
                        $author$project$Pages$Partner$Practices$Top$viewTable(model),
                        A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Partner$Practices$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                                $author$project$Ui$Pagination$List$loading(loading)
                            ]), model.af_))
                        ]))
                    ]))
                ]);
            }(),
            $2: 'Partner | Practices'
        };
    };
    var $author$project$Pages$Partner$Practices$Top$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Practices$Top$init,
        aeR: $author$project$Pages$Partner$Practices$Top$load,
        ag3: $author$project$Pages$Partner$Practices$Top$save,
        ahE: $author$project$Pages$Partner$Practices$Top$subscriptions,
        aaO: $author$project$Pages$Partner$Practices$Top$update,
        aid: $author$project$Pages$Partner$Practices$Top$view
    });
    var $author$project$Pages$Partner$Product$CallToActionMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$CarouselMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDropdownMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$GotCategories = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$ManagePartnerProductCategories$init = F2(function(apiClient, partner) {
        return _Utils_Tuple2({
            K0: $author$project$Api$Data$Loading,
            ls: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'category-dropdown',
                ahX: $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDropdownMsg
            })),
            bX: $elm$core$Maybe$Nothing,
            VW: partner,
            C: $elm$core$Maybe$Nothing
        }, A2($author$project$Api$Platform$Marketplace$ProductCategory$list, apiClient, $author$project$Components$Partner$ManagePartnerProductCategories$GotCategories));
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$init = F2(function(partner, imageStore) {
        return _Utils_Tuple2({
            b0: $elm$core$Maybe$Nothing,
            qW: imageStore,
            VW: partner,
            D: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$ManagePartnerProductHighlights$init = F2(function(partner, imageStore) {
        return _Utils_Tuple2({
            bZ: $elm$core$Maybe$Nothing,
            qW: imageStore,
            VW: partner,
            F: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$ManagePartnerProductLinks$init = F2(function(partner, imageStore) {
        return _Utils_Tuple2({
            b_: $elm$core$Maybe$Nothing,
            qW: imageStore,
            VW: partner,
            G: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$init = F2(function(partner, imageStore) {
        return _Utils_Tuple2({
            b1: $elm$core$Maybe$Nothing,
            qW: imageStore,
            VW: partner,
            H: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Product$GotPartnerProduct = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$retrieve = F3(function(apiClient, productId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Partner$PartnerProduct$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProduct$productPathWithId(productId)));
    });
    var $author$project$Pages$Partner$Product$retrieveProduct = F2(function(apiClient, product) {
        if (!product.$) {
            var sharedProduct = product.a;
            return A3($author$project$Api$Partner$PartnerProduct$retrieve, apiClient, $author$project$Api$Partner$PartnerProduct$Shared$id(sharedProduct), $author$project$Pages$Partner$Product$GotPartnerProduct);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Pages$Partner$Product$init = F4(function(_v0, partner, shared, _v1) {
        var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
        var _v2 = A2($author$project$Components$Partner$ManagePartnerProductQuotes$init, partner, shared.qW);
        var managePartnerProductQuotes = _v2.a;
        var managePartnerProductQuotesCmd = _v2.b;
        var _v3 = A2($author$project$Components$Partner$ManagePartnerProductLinks$init, partner, shared.qW);
        var managePartnerProductLinks = _v3.a;
        var managePartnerProductLinksCmd = _v3.b;
        var _v4 = A2($author$project$Components$Partner$ManagePartnerProductHighlights$init, partner, shared.qW);
        var managePartnerProductHighlights = _v4.a;
        var managePartnerProductHighlightsCmd = _v4.b;
        var _v5 = A2($author$project$Components$Partner$ManagePartnerProductDataFlows$init, partner, shared.qW);
        var managePartnerProductDataFlows = _v5.a;
        var managePartnerProductDataFlowsCmd = _v5.b;
        var _v6 = A2($author$project$Components$Partner$ManagePartnerProductCategories$init, shared.Ej, partner);
        var manageCategories = _v6.a;
        var manageCategoriesCmd = _v6.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aZ: $author$project$Components$Marketplace$Product$CallToAction$init({
                xJ: F4(function(apiClient, _v7, documentId, toMsg) {
                    return A3($author$project$Api$Partner$PartnerProductDocument$signedFileUrl, apiClient, documentId, toMsg);
                }),
                RO: true,
                ahX: $author$project$Pages$Partner$Product$CallToActionMsg
            }),
            pR: $author$project$Components$Carousel$init($author$project$Pages$Partner$Product$CarouselMsg),
            fu: $elm$core$Maybe$Nothing,
            w: $elm$core$Maybe$Nothing,
            qI: 0,
            qW: shared.qW,
            F3: isHintAdmin,
            Tk: false,
            f2: manageCategories,
            f3: managePartnerProductDataFlows,
            f4: managePartnerProductHighlights,
            f5: managePartnerProductLinks,
            f6: managePartnerProductQuotes,
            VW: partner,
            Xw: $author$project$Api$Data$Loading
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Pages$Partner$Product$retrieveProduct, shared.Ej, $author$project$Api$Partner$Partner$One$product(partner)),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg, managePartnerProductLinksCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, managePartnerProductHighlightsCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, managePartnerProductDataFlowsCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg, manageCategoriesCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, managePartnerProductQuotesCmd)
        ])));
    });
    var $author$project$Pages$Partner$Product$load = F2(function(shared, model) {
        var hasProduct = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$always(true), $author$project$Api$Partner$Partner$One$product(model.VW)));
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(hasProduct, $author$project$Api$Data$toMaybe(shared.VW));
            if (!_v1.a && !_v1.b.$) {
                var part = _v1.b.a;
                var _v2 = $author$project$Api$Partner$Partner$One$product(part);
                if (!_v2.$) {
                    var product = _v2.a;
                    return _Utils_Tuple2(part, A2($author$project$Pages$Partner$Product$retrieveProduct, shared.Ej, $elm$core$Maybe$Just(product)));
                } else return _Utils_Tuple2(model.VW, $elm$core$Platform$Cmd$none);
            } else return _Utils_Tuple2(model.VW, $elm$core$Platform$Cmd$none);
        }();
        var partner = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared),
            VW: partner
        }), cmd);
    });
    var $author$project$Pages$Partner$Product$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Product$CancelEdit = {
        $: 2
    };
    var $author$project$Pages$Partner$Product$DeleteConfirmClosed = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd = {
        $: 1
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = model.C;
                if (!_v1.$) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd);
                else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v2 = model.bX;
                if (!_v2.$) return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed);
                else return $elm$core$Platform$Sub$none;
            }(),
            $author$project$Ui$Dropdown$subscriptions(model.ls)
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd = {
        $: 1
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd)), model.D)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed)), model.b0))
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit = {
        $: 1
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit)), model.F)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed)), model.bZ))
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd = {
        $: 1
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd)), model.G)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed)), model.b_))
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit = {
        $: 1
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit)), model.H)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed)), model.b1))
        ]));
    };
    var $author$project$Pages$Partner$Product$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Product$CancelEdit),
            function() {
                var _v0 = model.fu;
                if (!_v0.$) return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Partner$Product$DeleteConfirmClosed);
                else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg, $author$project$Components$Partner$ManagePartnerProductLinks$subscriptions(model.f5)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, $author$project$Components$Partner$ManagePartnerProductHighlights$subscriptions(model.f4)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, $author$project$Components$Partner$ManagePartnerProductDataFlows$subscriptions(model.f3)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg, $author$project$Components$Partner$ManagePartnerProductCategories$subscriptions(model.f2)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, $author$project$Components$Partner$ManagePartnerProductQuotes$subscriptions(model.f6))
        ]));
    };
    var $author$project$Pages$Partner$Product$Edited = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$GotPartnerUpdated = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Product$Icon = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ProductOverviewImages = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Product$Saved = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$ProductImage$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$PartnerProductOverview$Shared$images = function(_v0) {
        var record = _v0;
        return record.Q5;
    };
    var $author$project$Api$Partner$Partner$One$productOverview = function(_v0) {
        var record = _v0.b;
        return record.XC;
    };
    var $author$project$Components$Carousel$reset = function(model) {
        return _Utils_update(model, {
            yc: 0
        });
    };
    var $author$project$Api$Partner$Partner$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Partner$Partner$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$Partner$partnerPath));
    });
    var $author$project$Api$Partner$PartnerProduct$BuiltByName = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$BuiltByUrl = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$CtaUrl = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$GotPartnerProductUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Icon = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Name = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ProductOverviewDescription = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ProductOverviewImage = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ProductOverviewImageUrl = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$ProductOverviewImages = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Summary = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$UtmCampaign = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$UtmContent = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Partner$ProductImage$Shared$alt = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, '', record.Jg);
    };
    var $author$project$Utils$Maybe$fromString = function(string) {
        return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
    };
    var $author$project$Api$Partner$PartnerProduct$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$id(shared);
    };
    var $author$project$Pages$Partner$Product$CtaUrlValidation = 2;
    var $author$project$Pages$Partner$Product$IconValidation = 1;
    var $author$project$Pages$Partner$Product$NameValidation = 0;
    var $author$project$Pages$Partner$Product$maxIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Pages$Partner$Product$validator = function(field) {
        switch(field.$){
            case 0:
                var name = field.a;
                return A2($rtfeldman$elm_validate$Validate$ifBlank, $elm$core$Basics$always(name), _Utils_Tuple2(0, 'Please enter a name.'));
            case 2:
                var maybeIcon = field.a;
                return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
                    A2($rtfeldman$elm_validate$Validate$ifNothing, $elm$core$Basics$always(maybeIcon), _Utils_Tuple2(1, 'Please select an icon to upload.')),
                    function() {
                        if (!maybeIcon.$) {
                            var _v2 = maybeIcon.a;
                            var iconSize = _v2.a;
                            return A3($author$project$Utils$Validate$ifIntGreaterThan, $elm$core$Basics$always(iconSize), $author$project$Pages$Partner$Product$maxIconBytesSize, _Utils_Tuple2(1, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'));
                        } else return $rtfeldman$elm_validate$Validate$all(_List_Nil);
                    }()
                ]));
            case 5:
                return $rtfeldman$elm_validate$Validate$all(_List_Nil);
            case 6:
                var cta = field.a;
                return A2($rtfeldman$elm_validate$Validate$ifTrue, $elm$core$Basics$always($author$project$Utils$Validate$isInvalidUrlStricter(cta.aaT)), _Utils_Tuple2(2, 'Please enter a valid URL (e.g. https://partner.example.com).'));
            default:
                return $rtfeldman$elm_validate$Validate$all(_List_Nil);
        }
    };
    var $author$project$Pages$Partner$Product$validate = function(form) {
        return A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Product$validator($author$project$Utils$Form$fields(form)), form);
    };
    var $author$project$Pages$Partner$Product$submit = F2(function(model, form) {
        var _v0 = $author$project$Pages$Partner$Product$validate(form);
        if (_v0.$ === 1) {
            var invalidForm = _v0.a;
            return _Utils_Tuple3(_Utils_update(model, {
                w: $elm$core$Maybe$Just(invalidForm)
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
            var _v1 = _v0.a;
            var validField = _v1.b;
            var _v2 = model.Xw;
            if (_v2.$ === 3) {
                var product = _v2.a;
                var field = $rtfeldman$elm_validate$Validate$fromValid(validField);
                var productFields = function() {
                    switch(field.$){
                        case 5:
                            var maybeName = field.a;
                            var maybeUrl = field.b;
                            return _List_fromArray([
                                $author$project$Api$Partner$PartnerProduct$BuiltByName(maybeName),
                                $author$project$Api$Partner$PartnerProduct$BuiltByUrl(maybeUrl)
                            ]);
                        case 0:
                            var name = field.a;
                            return _List_fromArray([
                                $author$project$Api$Partner$PartnerProduct$Name(name)
                            ]);
                        case 1:
                            var description = field.a;
                            return _List_fromArray([
                                $author$project$Api$Partner$PartnerProduct$Summary($author$project$Utils$Maybe$fromString(description))
                            ]);
                        case 2:
                            if (!field.a.$) {
                                var _v5 = field.a.a;
                                var url = _v5.b;
                                return _List_fromArray([
                                    $author$project$Api$Partner$PartnerProduct$Icon(url)
                                ]);
                            } else {
                                var _v6 = field.a;
                                return _List_Nil;
                            }
                        case 6:
                            var cta = field.a;
                            return _List_fromArray([
                                $author$project$Api$Partner$PartnerProduct$CtaUrl($author$project$Utils$Maybe$fromString(cta.aaT)),
                                $author$project$Api$Partner$PartnerProduct$UtmCampaign($author$project$Utils$Maybe$fromString(cta.aa5)),
                                $author$project$Api$Partner$PartnerProduct$UtmContent($author$project$Utils$Maybe$fromString(cta.aa6))
                            ]);
                        default:
                            return _List_Nil;
                    }
                }();
                if ($elm$core$List$isEmpty(productFields)) switch(field.$){
                    case 3:
                        var description = field.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            w: $elm$core$Maybe$Nothing,
                            Tk: true
                        }), A3($author$project$Api$Partner$Partner$update, model.Ej, _List_fromArray([
                            $author$project$Api$Partner$Partner$ProductOverviewDescription($author$project$Utils$Maybe$fromString(description))
                        ]), $author$project$Pages$Partner$Product$GotPartnerUpdated(true)), _List_Nil);
                    case 4:
                        var existingImages = field.a;
                        var newUrls = field.b;
                        var newImageParams = A2($elm$core$List$map, $author$project$Api$Partner$Partner$ProductOverviewImageUrl, newUrls);
                        var existingImageParams = A2($elm$core$List$map, function(img) {
                            return $author$project$Api$Partner$Partner$ProductOverviewImage({
                                Jg: $author$project$Api$Partner$ProductImage$Shared$alt(img),
                                aef: $author$project$Api$Partner$ProductImage$Shared$id(img)
                            });
                        }, existingImages);
                        return _Utils_Tuple3(_Utils_update(model, {
                            w: $elm$core$Maybe$Nothing,
                            Tk: true
                        }), A3($author$project$Api$Partner$Partner$update, model.Ej, _List_fromArray([
                            $author$project$Api$Partner$Partner$ProductOverviewImages(_Utils_ap(existingImageParams, newImageParams))
                        ]), $author$project$Pages$Partner$Product$GotPartnerUpdated(true)), _List_Nil);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            w: $elm$core$Maybe$Nothing
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
                else {
                    var productId = $author$project$Api$Partner$PartnerProduct$One$id(product);
                    return _Utils_Tuple3(_Utils_update(model, {
                        w: $elm$core$Maybe$Nothing,
                        Tk: true
                    }), A4($author$project$Api$Partner$PartnerProduct$update, model.Ej, productId, productFields, $author$project$Pages$Partner$Product$GotPartnerProductUpdated), _List_Nil);
                }
            } else return _Utils_Tuple3(_Utils_update(model, {
                w: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Api$Partner$PartnerProduct$One$ctaUrl = function(_v0) {
        var record = _v0.b;
        return record.MI;
    };
    var $author$project$Api$Partner$PartnerProduct$One$distributionType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$distributionType(shared);
    };
    var $author$project$Api$Partner$PartnerProduct$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$name(shared);
    };
    var $author$project$Api$Partner$PartnerProduct$One$slug = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$slug(shared);
    };
    var $author$project$Api$Partner$PartnerProduct$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$status(shared);
    };
    var $author$project$Api$Partner$PartnerProduct$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$type_(shared);
    };
    var $author$project$Pages$Partner$Product$toCallToActionProduct = function(product) {
        return {
            J9: false,
            LW: $author$project$Api$Partner$PartnerProduct$One$ctaUrl(product),
            N9: $author$project$Api$Partner$PartnerProduct$One$distributionType(product),
            OU: $elm$core$Maybe$Nothing,
            Rk: $elm$core$Maybe$Nothing,
            Tj: $author$project$Api$Partner$PartnerProduct$One$status(product),
            zr: $author$project$Api$Partner$PartnerProduct$One$name(product),
            V0: _List_Nil,
            Xf: _List_Nil,
            _A: $author$project$Api$Partner$PartnerProduct$One$slug(product),
            ahy: $elm$core$Maybe$Nothing,
            ah5: $author$project$Api$Partner$PartnerProduct$One$type_(product)
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryCreated = 1;
    var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryDeleted = 3;
    var $author$project$Components$Partner$ManagePartnerProductCategories$CategoryUpdated = 2;
    var $author$project$Components$Partner$ManagePartnerProductCategories$Created = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$Deleted = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$None = 0;
    var $author$project$Components$Partner$ManagePartnerProductCategories$Updated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Common$Marketplace$Product$Category$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$categoryFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var name = field.a;
            return _Utils_update(fields, {
                zr: name,
                ob: $elm$core$Maybe$Nothing
            });
        } else {
            var category = field.a;
            return _Utils_update(fields, {
                zr: $author$project$Api$Common$Marketplace$Product$Category$name(category),
                ob: $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Category$id(category))
            });
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductCategories$NameValidation = 0;
    var $author$project$Components$Partner$ManagePartnerProductCategories$categoryValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(0, 'Please enter a category name.'))
    ]));
    var $author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner_product_categories'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$PartnerProductCategory$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_category', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', $elm$json$Json$Encode$string(params.zr))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProductCategory$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath)));
    });
    var $author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Partner$PartnerProductCategory$partnerProductCategoriesPath);
    };
    var $author$project$Api$Partner$PartnerProductCategory$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath(id)));
    });
    var $author$project$Components$Partner$ManagePartnerProductCategories$initCategoryFields = {
        zr: '',
        ob: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Partner$PartnerProductCategory$update = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Partner$PartnerProductCategory$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductCategory$partnerProductCategoryPath(id)));
    });
    var $author$project$Components$Partner$ManagePartnerProductCategories$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        var noOp = {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 0,
            zi: model,
            at: _List_Nil
        };
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        C: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductCategories$initCategoryFields), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        C: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 2:
                var field = msg.a;
                var _v2 = model.C;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var request = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductCategories$categoryFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            C: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, request))
                        }),
                        at: _List_Nil
                    };
                } else return noOp;
            case 3:
                var _v4 = model.C;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var maybeCategory = _v5.a;
                    var form = _v5.b;
                    var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductCategories$categoryValidator, form);
                    if (!_v6.$) {
                        var _v7 = _v6.a;
                        var validatedForm = _v7.a;
                        var validFormFields = _v7.b;
                        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                        var _v8 = fields.ob;
                        if (!_v8.$) {
                            var categoryId = _v8.a;
                            return {
                                EQ: A3($author$project$Api$Partner$PartnerProductCategory$update, apiClient, categoryId, $author$project$Components$Partner$ManagePartnerProductCategories$Updated),
                                adu: 0,
                                zi: _Utils_update(model, {
                                    C: $elm$core$Maybe$Just(_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$Loading))
                                }),
                                at: _List_Nil
                            };
                        } else return {
                            EQ: A3($author$project$Api$Partner$PartnerProductCategory$create, apiClient, {
                                zr: fields.zr
                            }, $author$project$Components$Partner$ManagePartnerProductCategories$Created),
                            adu: 0,
                            zi: _Utils_update(model, {
                                C: $elm$core$Maybe$Just(_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$Loading))
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var validatedForm = _v6.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                C: $elm$core$Maybe$Just(_Utils_Tuple3(maybeCategory, validatedForm, $author$project$Api$Data$NotAsked))
                            }),
                            at: _List_Nil
                        };
                    }
                } else return noOp;
            case 4:
                var response = msg.a;
                var _v9 = model.C;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var maybeCategory = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            C: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Category added successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            C: $elm$core$Maybe$Just(_Utils_Tuple3(maybeCategory, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return noOp;
            case 5:
                var response = msg.a;
                var _v12 = model.C;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var maybeCategory = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: _Utils_update(model, {
                            C: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Category added successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            C: $elm$core$Maybe$Just(_Utils_Tuple3(maybeCategory, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return noOp;
            case 7:
                var id = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        bX: $elm$core$Maybe$Just(_Utils_Tuple2(id, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 8:
                var confirmed = msg.a;
                var _v15 = model.bX;
                if (!_v15.$) {
                    var _v16 = _v15.a;
                    var id = _v16.a;
                    return confirmed ? {
                        EQ: A3($author$project$Api$Partner$PartnerProductCategory$delete, apiClient, id, $author$project$Components$Partner$ManagePartnerProductCategories$Deleted),
                        adu: 0,
                        zi: _Utils_update(model, {
                            bX: $elm$core$Maybe$Just(_Utils_Tuple2(id, $author$project$Api$Data$Loading))
                        }),
                        at: _List_Nil
                    } : {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            bX: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                } else return noOp;
            case 9:
                var response = msg.a;
                var _v17 = model.bX;
                if (!_v17.$) {
                    var _v18 = _v17.a;
                    var id = _v18.a;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 3,
                        zi: _Utils_update(model, {
                            bX: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Category removed successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            bX: $elm$core$Maybe$Just(_Utils_Tuple2(id, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return noOp;
            case 6:
                var subMsg = msg.a;
                var _v20 = A2($author$project$Ui$Dropdown$update, subMsg, model.ls);
                var updatedDropdown = _v20.a;
                var dropdownCmd = _v20.b;
                return {
                    EQ: dropdownCmd,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ls: updatedDropdown
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        K0: response
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowCreated = 1;
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowDeleted = 3;
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$DataFlowUpdated = 2;
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$Deleted = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$None = 0;
    var $author$project$Api$Common$Marketplace$Product$SyncDirection$default = 0;
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var hintName = field.a;
                return _Utils_update(fields, {
                    QQ: hintName
                });
            case 1:
                var partnerName = field.a;
                return _Utils_update(fields, {
                    V$: partnerName
                });
            default:
                var syncDirection = field.a;
                return _Utils_update(fields, {
                    $F: A2($elm$core$Maybe$withDefault, $author$project$Api$Common$Marketplace$Product$SyncDirection$default, $author$project$Api$Common$Marketplace$Product$SyncDirection$fromString(syncDirection))
                });
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$HintNameValidation = 0;
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerNameValidation = 1;
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.QQ;
        }, _Utils_Tuple2(0, 'Please enter a hint name.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.V$;
        }, _Utils_Tuple2(1, 'Please enter a partner name.'))
    ]));
    var $author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner_product_data_flows'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath);
    };
    var $author$project$Api$Partner$PartnerProductDataFlow$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath(id)));
    });
    var $author$project$Api$Partner$PartnerProductDataFlow$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFields = {
        QQ: '',
        V$: '',
        $F: 1
    };
    var $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName = function(_v0) {
        var record = _v0;
        return record.QQ;
    };
    var $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName = function(_v0) {
        var record = _v0;
        return record.V$;
    };
    var $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection = function(_v0) {
        var record = _v0;
        return record.$F;
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFieldsForEdit = function(productDataFlow) {
        return {
            QQ: $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName(productDataFlow),
            V$: $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName(productDataFlow),
            $F: $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection(productDataFlow)
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$Created = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductDataFlow$One$PartnerProductDataFlow = 0;
    var $author$project$Api$Partner$PartnerProductDataFlow$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Common$Marketplace$Product$SyncDirection$toString = function(syncDirection) {
        switch(syncDirection){
            case 0:
                return 'from_hint';
            case 1:
                return 'to_hint';
            default:
                return 'bidirectional';
        }
    };
    var $author$project$Api$Common$Marketplace$Product$SyncDirection$encode = function(syncDirection) {
        return $elm$json$Json$Encode$string($author$project$Api$Common$Marketplace$Product$SyncDirection$toString(syncDirection));
    };
    var $author$project$Api$Partner$PartnerProductDataFlow$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_data_flow', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('hint_name', $elm$json$Json$Encode$string(params.QQ)),
                _Utils_Tuple2('partner_name', $elm$json$Json$Encode$string(params.V$)),
                _Utils_Tuple2('sync_direction', $author$project$Api$Common$Marketplace$Product$SyncDirection$encode(params.$F))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProductDataFlow$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowsPath)));
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$createLink = F2(function(apiClient, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var hintName = _v0.QQ;
        var partnerName = _v0.V$;
        var syncDirection = _v0.$F;
        return A3($author$project$Api$Partner$PartnerProductDataFlow$create, apiClient, {
            QQ: hintName,
            V$: partnerName,
            $F: syncDirection
        }, $author$project$Components$Partner$ManagePartnerProductDataFlows$Created);
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$Updated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductDataFlow$update = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_data_flow', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('hint_name', $elm$json$Json$Encode$string(params.QQ)),
                _Utils_Tuple2('partner_name', $elm$json$Json$Encode$string(params.V$)),
                _Utils_Tuple2('sync_direction', $author$project$Api$Common$Marketplace$Product$SyncDirection$encode(params.$F))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$PartnerProductDataFlow$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDataFlow$partnerProductDataFlowPath(id))));
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$updateLink = F3(function(apiClient, id, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var hintName = _v0.QQ;
        var partnerName = _v0.V$;
        var syncDirection = _v0.$F;
        return A4($author$project$Api$Partner$PartnerProductDataFlow$update, apiClient, id, {
            QQ: hintName,
            V$: partnerName,
            $F: syncDirection
        }, $author$project$Components$Partner$ManagePartnerProductDataFlows$Updated);
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$save = F3(function(apiClient, id, formFields) {
        if (!id.$) {
            var id_ = id.a;
            return A3($author$project$Components$Partner$ManagePartnerProductDataFlows$updateLink, apiClient, id_, formFields);
        } else return A2($author$project$Components$Partner$ManagePartnerProductDataFlows$createLink, apiClient, formFields);
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        D: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFields), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 2:
                var productDataFlow = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        D: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(productDataFlow), $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductDataFlows$initDataFlowFieldsForEdit(productDataFlow)), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        D: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 3:
                var field = msg.a;
                var _v2 = model.D;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var request = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            D: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, request))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var _v4 = model.D;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var productDataFlow = _v5.a;
                    var form = _v5.b;
                    var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductDataFlows$dataFlowValidator, form);
                    if (!_v6.$) {
                        var _v7 = _v6.a;
                        var validatedForm = _v7.a;
                        var validFormFields = _v7.b;
                        var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDataFlow$Shared$id, productDataFlow);
                        return {
                            EQ: A3($author$project$Components$Partner$ManagePartnerProductDataFlows$save, apiClient, id, validFormFields),
                            adu: 0,
                            zi: _Utils_update(model, {
                                D: $elm$core$Maybe$Just(_Utils_Tuple3(productDataFlow, validatedForm, $author$project$Api$Data$Loading))
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var validatedForm = _v6.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                D: $elm$core$Maybe$Just(_Utils_Tuple3(productDataFlow, validatedForm, $author$project$Api$Data$NotAsked))
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                var response = msg.a;
                var _v8 = model.D;
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var productDataFlow = _v9.a;
                    var form = _v9.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            D: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Synced field created successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            D: $elm$core$Maybe$Just(_Utils_Tuple3(productDataFlow, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var response = msg.a;
                var _v11 = model.D;
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var productDataFlow = _v12.a;
                    var form = _v12.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: _Utils_update(model, {
                            D: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Synced field updated successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            D: $elm$core$Maybe$Just(_Utils_Tuple3(productDataFlow, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var productDataFlow = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        b0: $elm$core$Maybe$Just(_Utils_Tuple2(productDataFlow, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 8:
                var confirmed = msg.a;
                var _v14 = model.b0;
                if (!_v14.$) {
                    var _v15 = _v14.a;
                    var productDataFlow = _v15.a;
                    return confirmed ? {
                        EQ: A3($author$project$Api$Partner$PartnerProductDataFlow$delete, apiClient, $author$project$Api$Partner$PartnerProductDataFlow$Shared$id(productDataFlow), $author$project$Components$Partner$ManagePartnerProductDataFlows$Deleted),
                        adu: 0,
                        zi: _Utils_update(model, {
                            b0: $elm$core$Maybe$Just(_Utils_Tuple2(productDataFlow, $author$project$Api$Data$Loading))
                        }),
                        at: _List_Nil
                    } : {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            b0: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                var _v16 = model.b0;
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var productDataFlow = _v17.a;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 3,
                        zi: _Utils_update(model, {
                            b0: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Synced field deleted successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            b0: $elm$core$Maybe$Just(_Utils_Tuple2(productDataFlow, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Deleted = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightCreated = 1;
    var $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightDeleted = 3;
    var $author$project$Components$Partner$ManagePartnerProductHighlights$HighlightUpdated = 2;
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Image = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$None = 0;
    var $author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner_product_highlights'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath);
    };
    var $author$project$Api$Partner$PartnerProductHighlight$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath(id)));
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$highlightFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var title = field.a;
                return _Utils_update(fields, {
                    $2: title
                });
            case 1:
                var description = field.a;
                return _Utils_update(fields, {
                    NQ: description
                });
            default:
                var imageSize = field.a;
                var imageUrl = field.b;
                return _Utils_update(fields, {
                    p7: $elm$core$Maybe$Just(imageUrl),
                    aej: $elm$core$Maybe$Just(imageUrl),
                    mw: imageSize
                });
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$DescriptionValidation = 1;
    var $author$project$Components$Partner$ManagePartnerProductHighlights$ImageValidation = 2;
    var $author$project$Components$Partner$ManagePartnerProductHighlights$TitleValidation = 0;
    var $author$project$Components$Partner$ManagePartnerProductHighlights$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Partner$ManagePartnerProductHighlights$highlightValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.$2;
        }, _Utils_Tuple2(0, 'Please enter a title.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.NQ;
        }, _Utils_Tuple2(1, 'Please enter a description.')),
        A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
            return $.mw;
        }, $author$project$Components$Partner$ManagePartnerProductHighlights$maxLogoBytesSize, _Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
    ]));
    var $author$project$Api$Partner$PartnerProductHighlight$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFields = {
        p7: $elm$core$Maybe$Nothing,
        NQ: '',
        aej: $elm$core$Maybe$Nothing,
        mw: 0,
        $2: ''
    };
    var $author$project$Api$Partner$PartnerProductHighlight$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl = function(_v0) {
        var record = _v0;
        return record.Q4;
    };
    var $author$project$Api$Partner$PartnerProductHighlight$Shared$title = function(_v0) {
        var record = _v0;
        return record.$2;
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFieldsForEdit = function(productHighlight) {
        return {
            p7: $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl(productHighlight),
            NQ: $author$project$Api$Partner$PartnerProductHighlight$Shared$description(productHighlight),
            aej: $elm$core$Maybe$Nothing,
            mw: 0,
            $2: $author$project$Api$Partner$PartnerProductHighlight$Shared$title(productHighlight)
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Created = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductHighlight$One$PartnerProductHighlight = 0;
    var $author$project$Api$Partner$PartnerProductHighlight$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Partner$PartnerProductHighlight$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_highlight', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('title', $elm$json$Json$Encode$string(params.$2)),
                _Utils_Tuple2('description', $elm$json$Json$Encode$string(params.NQ)),
                _Utils_Tuple2('image', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aej))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProductHighlight$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightsPath)));
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$createProductHighlight = F2(function(apiClient, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var title = _v0.$2;
        var description = _v0.NQ;
        var image = _v0.aej;
        return A3($author$project$Api$Partner$PartnerProductHighlight$create, apiClient, {
            NQ: description,
            aej: image,
            $2: title
        }, $author$project$Components$Partner$ManagePartnerProductHighlights$Created);
    });
    var $author$project$Api$Partner$PartnerProductHighlight$Description = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductHighlight$Image = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductHighlight$Title = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Updated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductHighlight$encodePermittedFields = function(permittedFields) {
        var encodedFields = A3($elm$core$List$foldl, F2(function(field, acc) {
            switch(field.$){
                case 0:
                    var title = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('title', $elm$json$Json$Encode$string(title)), acc);
                case 1:
                    var description = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('description', $elm$json$Json$Encode$string(description)), acc);
                default:
                    var image = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('image', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, image)), acc);
            }
        }), _List_Nil, permittedFields);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_highlight', $elm$json$Json$Encode$object(encodedFields))
        ]));
    };
    var $author$project$Api$Partner$PartnerProductHighlight$update = F4(function(apiClient, id, permittedFields, toMsg) {
        var body = $author$project$Api$Partner$PartnerProductHighlight$encodePermittedFields(permittedFields);
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$PartnerProductHighlight$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductHighlight$partnerProductHighlightPath(id))));
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$updateProductHighlight = F3(function(apiClient, id, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var title = _v0.$2;
        var description = _v0.NQ;
        var image = _v0.aej;
        return A4($author$project$Api$Partner$PartnerProductHighlight$update, apiClient, id, A2($elm$core$List$cons, $author$project$Api$Partner$PartnerProductHighlight$Title(title), A2($elm$core$List$cons, $author$project$Api$Partner$PartnerProductHighlight$Description(description), function() {
            if (!image.$) {
                var imageUrl = image.a;
                return _List_fromArray([
                    $author$project$Api$Partner$PartnerProductHighlight$Image($elm$core$Maybe$Just(imageUrl))
                ]);
            } else return _List_Nil;
        }())), $author$project$Components$Partner$ManagePartnerProductHighlights$Updated);
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$saveProductHighlight = F3(function(apiClient, id, formFields) {
        if (!id.$) {
            var id_ = id.a;
            return A3($author$project$Components$Partner$ManagePartnerProductHighlights$updateProductHighlight, apiClient, id_, formFields);
        } else return A2($author$project$Components$Partner$ManagePartnerProductHighlights$createProductHighlight, apiClient, formFields);
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        F: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFields), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        F: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 3:
                var logos = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v2) {
                    var task = _v2.a;
                    var size = _v2.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated, $author$project$Components$Partner$ManagePartnerProductHighlights$Image(size)), task);
                }, A2($elm$core$Maybe$map, function(logo) {
                    return _Utils_Tuple2($elm$file$File$toUrl(logo), $elm$file$File$size(logo));
                }, $elm$core$List$head(logos))));
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var field = msg.a;
                var _v3 = model.F;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var id = _v4.a;
                    var form = _v4.b;
                    var request = _v4.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductHighlights$highlightFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            F: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, request))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var productHighlight = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        F: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(productHighlight), $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductHighlights$initHighlightFieldsForEdit(productHighlight)), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 5:
                var _v5 = model.F;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var item = _v6.a;
                    var form = _v6.b;
                    var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductHighlights$highlightValidator, form);
                    if (!_v7.$) {
                        var _v8 = _v7.a;
                        var validatedForm = _v8.a;
                        var validFormFields = _v8.b;
                        var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductHighlight$Shared$id, item);
                        return {
                            EQ: A3($author$project$Components$Partner$ManagePartnerProductHighlights$saveProductHighlight, apiClient, id, validFormFields),
                            adu: 0,
                            zi: _Utils_update(model, {
                                F: $elm$core$Maybe$Just(_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var validatedForm = _v7.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                F: $elm$core$Maybe$Just(_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var response = msg.a;
                var _v9 = model.F;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var productHighlight = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            F: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product highlight created successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            F: $elm$core$Maybe$Just(_Utils_Tuple3(productHighlight, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var response = msg.a;
                var _v12 = model.F;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var item = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: _Utils_update(model, {
                            F: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product highlight updated successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            F: $elm$core$Maybe$Just(_Utils_Tuple3(item, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 8:
                var productHighlight = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        bZ: $elm$core$Maybe$Just(_Utils_Tuple2(productHighlight, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 9:
                var confirmed = msg.a;
                var _v15 = model.bZ;
                if (!_v15.$) {
                    var _v16 = _v15.a;
                    var productHighlight = _v16.a;
                    return confirmed ? {
                        EQ: A3($author$project$Api$Partner$PartnerProductHighlight$delete, apiClient, $author$project$Api$Partner$PartnerProductHighlight$Shared$id(productHighlight), $author$project$Components$Partner$ManagePartnerProductHighlights$Deleted),
                        adu: 0,
                        zi: _Utils_update(model, {
                            bZ: $elm$core$Maybe$Just(_Utils_Tuple2(productHighlight, $author$project$Api$Data$Loading))
                        }),
                        at: _List_Nil
                    } : {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            bZ: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                var _v17 = model.bZ;
                if (!_v17.$) {
                    var _v18 = _v17.a;
                    var productHighlight = _v18.a;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 3,
                        zi: _Utils_update(model, {
                            bZ: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product highlight deleted successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            bZ: $elm$core$Maybe$Just(_Utils_Tuple2(productHighlight, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$Deleted = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$LinkCreated = 1;
    var $author$project$Components$Partner$ManagePartnerProductLinks$LinkDeleted = 3;
    var $author$project$Components$Partner$ManagePartnerProductLinks$LinkUpdated = 2;
    var $author$project$Components$Partner$ManagePartnerProductLinks$None = 0;
    var $author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner_product_links'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath);
    };
    var $author$project$Api$Partner$PartnerProductLink$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath(id)));
    });
    var $author$project$Api$Partner$PartnerProductLink$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$initLinkFields = {
        Tf: 0,
        $2: '',
        aa5: '',
        aa6: '',
        aa9: ''
    };
    var $author$project$Api$Partner$PartnerProductLink$Shared$linkType = function(_v0) {
        var record = _v0;
        return record.Tf;
    };
    var $author$project$Api$Partner$PartnerProductLink$Shared$title = function(_v0) {
        var record = _v0;
        return record.$2;
    };
    var $author$project$Api$Partner$PartnerProductLink$Shared$utmCampaign = function(_v0) {
        var record = _v0;
        return record.aa5;
    };
    var $author$project$Api$Partner$PartnerProductLink$Shared$utmContent = function(_v0) {
        var record = _v0;
        return record.aa6;
    };
    var $author$project$Api$Partner$PartnerProductLink$Shared$value = function(_v0) {
        var record = _v0;
        return record.aa9;
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$initLinkFieldsForEdit = function(productLink) {
        return {
            Tf: $author$project$Api$Partner$PartnerProductLink$Shared$linkType(productLink),
            $2: $author$project$Api$Partner$PartnerProductLink$Shared$title(productLink),
            aa5: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$PartnerProductLink$Shared$utmCampaign(productLink)),
            aa6: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$PartnerProductLink$Shared$utmContent(productLink)),
            aa9: $author$project$Api$Partner$PartnerProductLink$Shared$value(productLink)
        };
    };
    var $author$project$Api$Common$Marketplace$Product$LinkType$default = 0;
    var $author$project$Components$Partner$ManagePartnerProductLinks$linkFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var title = field.a;
                return _Utils_update(fields, {
                    $2: title
                });
            case 1:
                var value = field.a;
                return _Utils_update(fields, {
                    aa9: value
                });
            case 2:
                var linkType = field.a;
                return _Utils_update(fields, {
                    Tf: A2($elm$core$Maybe$withDefault, $author$project$Api$Common$Marketplace$Product$LinkType$default, $author$project$Api$Common$Marketplace$Product$LinkType$fromString(linkType))
                });
            case 3:
                var campaign = field.a;
                return _Utils_update(fields, {
                    aa5: campaign
                });
            default:
                var content = field.a;
                return _Utils_update(fields, {
                    aa6: content
                });
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$TitleValidation = 0;
    var $author$project$Components$Partner$ManagePartnerProductLinks$ValueValidation = 1;
    var $author$project$Components$Partner$ManagePartnerProductLinks$valueLabel = function(linkType) {
        switch(linkType){
            case 0:
                return 'URL';
            case 1:
                return 'Email address';
            default:
                return 'Phone number';
        }
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$validateValue = function(fields) {
        if ($elm$core$String$isEmpty(fields.aa9)) return _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a ' + ($author$project$Components$Partner$ManagePartnerProductLinks$valueLabel(fields.Tf) + '.'))
        ]);
        else {
            var _v0 = fields.Tf;
            switch(_v0){
                case 0:
                    return $author$project$Utils$Validate$isInvalidUrl(fields.aa9) ? _List_fromArray([
                        _Utils_Tuple2(1, 'Please enter a valid URL.')
                    ]) : _List_Nil;
                case 1:
                    return A2($author$project$Utils$Validate$isInvalidEmail, {
                        abH: true
                    }, $elm$core$Maybe$Just(fields.aa9)) ? _List_fromArray([
                        _Utils_Tuple2(1, 'Please enter a valid email address.')
                    ]) : _List_Nil;
                default:
                    return A2($author$project$Utils$Validate$doesNotMatchRegex, fields.aa9, '^\\d+$') ? _List_fromArray([
                        _Utils_Tuple2(1, 'Please enter a valid phone number.')
                    ]) : _List_Nil;
            }
        }
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$linkValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.$2;
        }, _Utils_Tuple2(0, 'Please enter a title.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManagePartnerProductLinks$validateValue)
    ]));
    var $author$project$Components$Partner$ManagePartnerProductLinks$Created = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductLink$One$PartnerProductLink = 0;
    var $author$project$Api$Partner$PartnerProductLink$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Common$Marketplace$Product$LinkType$toString = function(linkType) {
        switch(linkType){
            case 0:
                return 'url';
            case 1:
                return 'email';
            default:
                return 'phone';
        }
    };
    var $author$project$Api$Partner$PartnerProductLink$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_link', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('title', $elm$json$Json$Encode$string(params.$2)),
                _Utils_Tuple2('value', $elm$json$Json$Encode$string(params.aa9)),
                _Utils_Tuple2('link_type', $elm$json$Json$Encode$string($author$project$Api$Common$Marketplace$Product$LinkType$toString(params.Tf))),
                _Utils_Tuple2('utm_campaign', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aa5)),
                _Utils_Tuple2('utm_content', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aa6))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProductLink$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductLink$partnerProductLinksPath)));
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$createLink = F2(function(apiClient, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var title = _v0.$2;
        var linkType = _v0.Tf;
        var value = _v0.aa9;
        var utmCampaign = _v0.aa5;
        var utmContent = _v0.aa6;
        return A3($author$project$Api$Partner$PartnerProductLink$create, apiClient, {
            Tf: linkType,
            $2: title,
            aa5: $author$project$Utils$Maybe$fromString(utmCampaign),
            aa6: $author$project$Utils$Maybe$fromString(utmContent),
            aa9: value
        }, $author$project$Components$Partner$ManagePartnerProductLinks$Created);
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$Updated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductLink$update = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_link', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('title', $elm$json$Json$Encode$string(params.$2)),
                _Utils_Tuple2('value', $elm$json$Json$Encode$string(params.aa9)),
                _Utils_Tuple2('link_type', $elm$json$Json$Encode$string($author$project$Api$Common$Marketplace$Product$LinkType$toString(params.Tf))),
                _Utils_Tuple2('utm_campaign', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aa5)),
                _Utils_Tuple2('utm_content', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aa6))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$PartnerProductLink$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductLink$partnerProductLinkPath(id))));
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$updateLink = F3(function(apiClient, id, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var title = _v0.$2;
        var linkType = _v0.Tf;
        var value = _v0.aa9;
        var utmCampaign = _v0.aa5;
        var utmContent = _v0.aa6;
        return A4($author$project$Api$Partner$PartnerProductLink$update, apiClient, id, {
            Tf: linkType,
            $2: title,
            aa5: $author$project$Utils$Maybe$fromString(utmCampaign),
            aa6: $author$project$Utils$Maybe$fromString(utmContent),
            aa9: value
        }, $author$project$Components$Partner$ManagePartnerProductLinks$Updated);
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$save = F3(function(apiClient, id, formFields) {
        if (!id.$) {
            var id_ = id.a;
            return A3($author$project$Components$Partner$ManagePartnerProductLinks$updateLink, apiClient, id_, formFields);
        } else return A2($author$project$Components$Partner$ManagePartnerProductLinks$createLink, apiClient, formFields);
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        G: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductLinks$initLinkFields), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 2:
                var productLink = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        G: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(productLink), $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductLinks$initLinkFieldsForEdit(productLink)), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        G: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 3:
                var field = msg.a;
                var _v2 = model.G;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var request = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductLinks$linkFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            G: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, request))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var _v4 = model.G;
                if (!_v4.$) {
                    var _v5 = _v4.a;
                    var productLink = _v5.a;
                    var form = _v5.b;
                    var _v6 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductLinks$linkValidator, form);
                    if (!_v6.$) {
                        var _v7 = _v6.a;
                        var validatedForm = _v7.a;
                        var validFormFields = _v7.b;
                        var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductLink$Shared$id, productLink);
                        return {
                            EQ: A3($author$project$Components$Partner$ManagePartnerProductLinks$save, apiClient, id, validFormFields),
                            adu: 0,
                            zi: _Utils_update(model, {
                                G: $elm$core$Maybe$Just(_Utils_Tuple3(productLink, validatedForm, $author$project$Api$Data$Loading))
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var validatedForm = _v6.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                G: $elm$core$Maybe$Just(_Utils_Tuple3(productLink, validatedForm, $author$project$Api$Data$NotAsked))
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                var response = msg.a;
                var _v8 = model.G;
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var productLink = _v9.a;
                    var form = _v9.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            G: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product link created successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            G: $elm$core$Maybe$Just(_Utils_Tuple3(productLink, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var response = msg.a;
                var _v11 = model.G;
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var productLink = _v12.a;
                    var form = _v12.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: _Utils_update(model, {
                            G: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product link updated successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            G: $elm$core$Maybe$Just(_Utils_Tuple3(productLink, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var productLink = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        b_: $elm$core$Maybe$Just(_Utils_Tuple2(productLink, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 8:
                var confirmed = msg.a;
                var _v14 = model.b_;
                if (!_v14.$) {
                    var _v15 = _v14.a;
                    var productLink = _v15.a;
                    return confirmed ? {
                        EQ: A3($author$project$Api$Partner$PartnerProductLink$delete, apiClient, $author$project$Api$Partner$PartnerProductLink$Shared$id(productLink), $author$project$Components$Partner$ManagePartnerProductLinks$Deleted),
                        adu: 0,
                        zi: _Utils_update(model, {
                            b_: $elm$core$Maybe$Just(_Utils_Tuple2(productLink, $author$project$Api$Data$Loading))
                        }),
                        at: _List_Nil
                    } : {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            b_: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 10:
                var url = msg.a;
                return {
                    EQ: $author$project$Ports$Clipboard$copy(url),
                    adu: 0,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
                    ])
                };
            default:
                var response = msg.a;
                var _v16 = model.b_;
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var productLink = _v17.a;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 3,
                        zi: _Utils_update(model, {
                            b_: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product link deleted successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            b_: $elm$core$Maybe$Just(_Utils_Tuple2(productLink, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImage = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Deleted = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$None = 0;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteCreated = 1;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteDeleted = 3;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$QuoteUpdated = 2;
    var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner_product_quotes'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath);
    };
    var $author$project$Api$Partner$PartnerProductQuote$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath(id)));
    });
    var $author$project$Api$Partner$PartnerProductQuote$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFields = {
        JP: '',
        k9: $elm$core$Maybe$Nothing,
        pC: 0,
        JR: '',
        p5: $elm$core$Maybe$Nothing,
        $Y: ''
    };
    var $author$project$Api$Partner$PartnerProductQuote$Shared$author = function(_v0) {
        var record = _v0;
        return record.JP;
    };
    var $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl = function(_v0) {
        var record = _v0;
        return record.JQ;
    };
    var $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle = function(_v0) {
        var record = _v0;
        return record.JR;
    };
    var $author$project$Api$Partner$PartnerProductQuote$Shared$text = function(_v0) {
        var record = _v0;
        return record.$Y;
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFieldsForEdit = function(productQuote) {
        return {
            JP: $author$project$Api$Partner$PartnerProductQuote$Shared$author(productQuote),
            k9: $elm$core$Maybe$Nothing,
            pC: 0,
            JR: $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle(productQuote),
            p5: $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl(productQuote),
            $Y: $author$project$Api$Partner$PartnerProductQuote$Shared$text(productQuote)
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$quoteFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var text = field.a;
                return _Utils_update(fields, {
                    $Y: text
                });
            case 1:
                var author = field.a;
                return _Utils_update(fields, {
                    JP: author
                });
            case 2:
                var authorTitle = field.a;
                return _Utils_update(fields, {
                    JR: authorTitle
                });
            default:
                var imageSize = field.a;
                var imageUrl = field.b;
                return _Utils_update(fields, {
                    k9: $elm$core$Maybe$Just(imageUrl),
                    pC: imageSize,
                    p5: $elm$core$Maybe$Just(imageUrl)
                });
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageValidation = 3;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitleValidation = 2;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorValidation = 1;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$TextValidation = 0;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$maxLogoBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$quoteValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.$Y;
        }, _Utils_Tuple2(0, 'Please enter a text.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.JP;
        }, _Utils_Tuple2(1, 'Please enter an author.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.JR;
        }, _Utils_Tuple2(2, 'Please enter an author title.')),
        A3($author$project$Utils$Validate$ifIntGreaterThan, function($) {
            return $.pC;
        }, $author$project$Components$Partner$ManagePartnerProductQuotes$maxLogoBytesSize, _Utils_Tuple2(3, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.'))
    ]));
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Created = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductQuote$One$PartnerProductQuote = 0;
    var $author$project$Api$Partner$PartnerProductQuote$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams = function(params) {
        var authorImageUrl = function() {
            var _v0 = params.JQ;
            if (!_v0.$) {
                var base64 = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('author_image', $elm$json$Json$Encode$string(base64))
                ]);
            } else return _List_Nil;
        }();
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_quote', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('text', $elm$json$Json$Encode$string(params.$Y)), A2($elm$core$List$cons, _Utils_Tuple2('author', $elm$json$Json$Encode$string(params.JP)), A2($elm$core$List$cons, _Utils_Tuple2('author_title', $elm$json$Json$Encode$string(params.JR)), authorImageUrl)))))
        ]));
    };
    var $author$project$Api$Partner$PartnerProductQuote$create = F3(function(apiClient, params, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProductQuote$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams(params), $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductQuote$partnerProductQuotesPath)));
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$createProductQuote = F2(function(apiClient, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var text = _v0.$Y;
        var author = _v0.JP;
        var authorTitle = _v0.JR;
        var authorImage = _v0.k9;
        return A3($author$project$Api$Partner$PartnerProductQuote$create, apiClient, {
            JP: author,
            JQ: authorImage,
            JR: authorTitle,
            $Y: text
        }, $author$project$Components$Partner$ManagePartnerProductQuotes$Created);
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Updated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductQuote$update = F4(function(apiClient, id, params, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$PartnerProductQuote$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Partner$PartnerProductQuote$partnerProductQuoteParams(params), $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductQuote$partnerProductQuotePath(id))));
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$updateProductQuote = F3(function(apiClient, id, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var text = _v0.$Y;
        var author = _v0.JP;
        var authorTitle = _v0.JR;
        var authorImage = _v0.k9;
        return A4($author$project$Api$Partner$PartnerProductQuote$update, apiClient, id, {
            JP: author,
            JQ: authorImage,
            JR: authorTitle,
            $Y: text
        }, $author$project$Components$Partner$ManagePartnerProductQuotes$Updated);
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$save = F3(function(apiClient, id, formFields) {
        if (!id.$) {
            var id_ = id.a;
            return A3($author$project$Components$Partner$ManagePartnerProductQuotes$updateProductQuote, apiClient, id_, formFields);
        } else return A2($author$project$Components$Partner$ManagePartnerProductQuotes$createProductQuote, apiClient, formFields);
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        H: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFields), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        H: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 3:
                var logos = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v2) {
                    var task = _v2.a;
                    var size = _v2.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated, $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImage(size)), task);
                }, A2($elm$core$Maybe$map, function(logo) {
                    return _Utils_Tuple2($elm$file$File$toUrl(logo), $elm$file$File$size(logo));
                }, $elm$core$List$head(logos))));
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var field = msg.a;
                var _v3 = model.H;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var id = _v4.a;
                    var form = _v4.b;
                    var request = _v4.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductQuotes$quoteFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            H: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, request))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var productQuote = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        H: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(productQuote), $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductQuotes$initQuoteFieldsForEdit(productQuote)), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 5:
                var _v5 = model.H;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var item = _v6.a;
                    var form = _v6.b;
                    var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductQuotes$quoteValidator, form);
                    if (!_v7.$) {
                        var _v8 = _v7.a;
                        var validatedForm = _v8.a;
                        var validFormFields = _v8.b;
                        var id = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductQuote$Shared$id, item);
                        return {
                            EQ: A3($author$project$Components$Partner$ManagePartnerProductQuotes$save, apiClient, id, validFormFields),
                            adu: 0,
                            zi: _Utils_update(model, {
                                H: $elm$core$Maybe$Just(_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var validatedForm = _v7.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                H: $elm$core$Maybe$Just(_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var response = msg.a;
                var _v9 = model.H;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var productQuote = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            H: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product quote created successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            H: $elm$core$Maybe$Just(_Utils_Tuple3(productQuote, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var response = msg.a;
                var _v12 = model.H;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var item = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 2,
                        zi: _Utils_update(model, {
                            H: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product quote updated successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            H: $elm$core$Maybe$Just(_Utils_Tuple3(item, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 8:
                var productQuote = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        b1: $elm$core$Maybe$Just(_Utils_Tuple2(productQuote, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 9:
                var confirmed = msg.a;
                var _v15 = model.b1;
                if (!_v15.$) {
                    var _v16 = _v15.a;
                    var productQuote = _v16.a;
                    return confirmed ? {
                        EQ: A3($author$project$Api$Partner$PartnerProductQuote$delete, apiClient, $author$project$Api$Partner$PartnerProductQuote$Shared$id(productQuote), $author$project$Components$Partner$ManagePartnerProductQuotes$Deleted),
                        adu: 0,
                        zi: _Utils_update(model, {
                            b1: $elm$core$Maybe$Just(_Utils_Tuple2(productQuote, $author$project$Api$Data$Loading))
                        }),
                        at: _List_Nil
                    } : {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            b1: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                var _v17 = model.b1;
                if (!_v17.$) {
                    var _v18 = _v17.a;
                    var productQuote = _v18.a;
                    if (response.$ === 3) return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 3,
                        zi: _Utils_update(model, {
                            b1: $elm$core$Maybe$Nothing
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Product quote deleted successfully!')
                        ])
                    };
                    else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            b1: $elm$core$Maybe$Just(_Utils_Tuple2(productQuote, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Pages$Partner$Product$update = F2(function(msg, model) {
        switch(msg.$){
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Just($author$project$Utils$Form$init($author$project$Pages$Partner$Product$Icon($elm$core$Maybe$Nothing)))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var icons = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v1) {
                    var task = _v1.a;
                    var size = _v1.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$Edited, $author$project$Pages$Partner$Product$Icon), $elm$core$Maybe$Just), $elm$core$Tuple$pair(size)), task);
                }, A2($elm$core$Maybe$map, function(icon) {
                    return _Utils_Tuple2($elm$file$File$toUrl(icon), $elm$file$File$size(icon));
                }, $elm$core$List$head(icons))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 0:
                var field = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Just($author$project$Utils$Form$init(field))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var form = msg.a;
                return A2($author$project$Pages$Partner$Product$submit, model, form);
            case 3:
                var field = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Just($author$project$Utils$Form$init(field))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var ctaMsg = msg.a;
                var _v2 = A3($author$project$Components$Marketplace$Product$CallToAction$update, model.Ej, ctaMsg, model.aZ);
                var callToAction = _v2.a;
                var ctaCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    aZ: callToAction
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$CallToActionMsg, ctaCmd), _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var product = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aZ: A2($author$project$Components$Marketplace$Product$CallToAction$setProduct, $author$project$Pages$Partner$Product$toCallToActionProduct(product), model.aZ),
                        Xw: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Xw: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    w: $elm$core$Maybe$Nothing,
                    Tk: false,
                    Xw: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Product updated successfully!'),
                    $author$project$OutMsg$RefreshPartner
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var showAlert = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var partner = response.a;
                    var _v6 = A2($author$project$Components$Partner$ManagePartnerProductQuotes$init, partner, model.qW);
                    var managePartnerProductQuotes = _v6.a;
                    var managePartnerProductQuotesCmd = _v6.b;
                    var _v7 = A2($author$project$Components$Partner$ManagePartnerProductLinks$init, partner, model.qW);
                    var managePartnerProductLinks = _v7.a;
                    var managePartnerProductLinksCmd = _v7.b;
                    var _v8 = A2($author$project$Components$Partner$ManagePartnerProductHighlights$init, partner, model.qW);
                    var managePartnerProductHighlights = _v8.a;
                    var managePartnerProductHighlightsCmd = _v8.b;
                    var _v9 = A2($author$project$Components$Partner$ManagePartnerProductDataFlows$init, partner, model.qW);
                    var managePartnerProductDataFlows = _v9.a;
                    var managePartnerProductDataFlowsCmd = _v9.b;
                    var _v10 = A2($author$project$Components$Partner$ManagePartnerProductCategories$init, model.Ej, partner);
                    var manageCategories = _v10.a;
                    var manageCategoriesCmd = _v10.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        pR: $author$project$Components$Carousel$reset(model.pR),
                        Tk: false,
                        f2: manageCategories,
                        f3: managePartnerProductDataFlows,
                        f4: managePartnerProductHighlights,
                        f5: managePartnerProductLinks,
                        f6: managePartnerProductQuotes,
                        VW: partner
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, managePartnerProductHighlightsCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg, managePartnerProductLinksCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, managePartnerProductDataFlowsCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg, manageCategoriesCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, managePartnerProductQuotesCmd)
                    ])), A2($elm$core$List$cons, $author$project$OutMsg$RefreshPartner, showAlert ? _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!')
                    ]) : _List_Nil));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Tk: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var subMsg = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapFirst, function(carousel) {
                    return _Utils_update(model, {
                        pR: carousel
                    });
                }, A2($author$project$Components$Carousel$update, subMsg, model.pR)));
            case 10:
                var images = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    qI: model.qI + 1,
                    Tk: true
                }), A2($elm$core$Task$perform, function(urls) {
                    var existingImages = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductOverview$Shared$images, $author$project$Api$Partner$Partner$One$productOverview(model.VW)));
                    return $author$project$Pages$Partner$Product$Saved($author$project$Utils$Form$init(A2($author$project$Pages$Partner$Product$ProductOverviewImages, existingImages, urls)));
                }, $elm$core$Task$sequence(A2($elm$core$List$map, $elm$file$File$toUrl, images))), _List_Nil);
            case 11:
                var imageId = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    fu: $elm$core$Maybe$Just(imageId)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var confirmed = msg.a;
                var _v11 = _Utils_Tuple2(confirmed, model.fu);
                if (_v11.a && !_v11.b.$) {
                    var imageId = _v11.b.a;
                    var remainingImages = A2($elm$core$List$filter, function(img) {
                        return !_Utils_eq($author$project$Api$Partner$ProductImage$Shared$id(img), imageId);
                    }, A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductOverview$Shared$images, $author$project$Api$Partner$Partner$One$productOverview(model.VW))));
                    return A2($author$project$Pages$Partner$Product$submit, _Utils_update(model, {
                        fu: $elm$core$Maybe$Nothing
                    }), $author$project$Utils$Form$init(A2($author$project$Pages$Partner$Product$ProductOverviewImages, remainingImages, _List_Nil)));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    fu: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Partner$ManagePartnerProductLinks$update, model.Ej, subMsg, model.f5);
                var extraCmd = function() {
                    var _v12 = result.adu;
                    switch(_v12){
                        case 0:
                            return $elm$core$Platform$Cmd$none;
                        case 1:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        case 2:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        default:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    f5: result.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg, result.EQ),
                    extraCmd
                ])), result.at);
            case 14:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Partner$ManagePartnerProductHighlights$update, model.Ej, subMsg, model.f4);
                var extraCmd = function() {
                    var _v13 = result.adu;
                    switch(_v13){
                        case 0:
                            return $elm$core$Platform$Cmd$none;
                        case 1:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        case 2:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        default:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    f4: result.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, result.EQ),
                    extraCmd
                ])), result.at);
            case 15:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Partner$ManagePartnerProductDataFlows$update, model.Ej, subMsg, model.f3);
                var extraCmd = function() {
                    var _v14 = result.adu;
                    switch(_v14){
                        case 0:
                            return $elm$core$Platform$Cmd$none;
                        case 1:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        case 2:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        default:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    f3: result.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, result.EQ),
                    extraCmd
                ])), result.at);
            case 16:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Partner$ManagePartnerProductCategories$update, model.Ej, subMsg, model.f2);
                var extraCmd = function() {
                    var _v15 = result.adu;
                    switch(_v15){
                        case 0:
                            return $elm$core$Platform$Cmd$none;
                        case 1:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        case 2:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        default:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    f2: result.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg, result.EQ),
                    extraCmd
                ])), result.at);
            case 17:
                var subMsg = msg.a;
                var result = A3($author$project$Components$Partner$ManagePartnerProductQuotes$update, model.Ej, subMsg, model.f6);
                var extraCmd = function() {
                    var _v16 = result.adu;
                    switch(_v16){
                        case 0:
                            return $elm$core$Platform$Cmd$none;
                        case 1:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        case 2:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                        default:
                            return A2($author$project$Api$Partner$Partner$retrieve, model.Ej, $author$project$Pages$Partner$Product$GotPartnerUpdated(false));
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    f6: result.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, result.EQ),
                    extraCmd
                ])), result.at);
            default:
                var value = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(value), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
                ]));
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductCategories$viewDeleteConfirmModal = function(model) {
        var _v0 = model.bX;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var request = _v1.b;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManagePartnerProductCategories$DeleteConfirmationClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('remove'),
                $author$project$Components$HiConfirm$noun('category'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
            ]));
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$Save = {
        $: 3
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$SelectedCategory = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$viewEditModal = function(model) {
        var _v0 = model.C;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var form = _v1.b;
            var request = _v1.c;
            var modalConfig = {
                QG: $elm$core$Maybe$Nothing,
                aeI: 'Category',
                Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
                TR: $elm$core$Maybe$Nothing,
                TS: $elm$core$Maybe$Nothing,
                Vl: $author$project$Components$Partner$ManagePartnerProductCategories$CancelAdd,
                Vn: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductCategories$Save)
            };
            var fields = $author$project$Utils$Form$fields(form);
            var categories = function() {
                var _v2 = model.K0;
                if (_v2.$ === 3) {
                    var cats = _v2.a;
                    return cats;
                } else return _List_Nil;
            }();
            var options = A2($elm$core$List$map, function(cat) {
                return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated($author$project$Components$Partner$ManagePartnerProductCategories$SelectedCategory(cat))),
                    $author$project$Ui$Dropdown$selected(_Utils_eq(fields.ob, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Category$id(cat))))
                ]), $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$Category$name(cat)));
            }, categories);
            return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Name'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    A4($author$project$Ui$Dropdown$viewCombobox, _List_Nil, {
                        afA: $elm$core$Maybe$Nothing,
                        afE: A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductCategories$Name, $author$project$Components$Partner$ManagePartnerProductCategories$FormUpdated),
                        aa9: fields.zr
                    }, options, model.ls)
                ]))
            ]));
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$modal = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Partner$ManagePartnerProductCategories$viewDeleteConfirmModal(model),
            $author$project$Components$Partner$ManagePartnerProductCategories$viewEditModal(model)
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowDeleteConfirmModal = function(model) {
        var _v0 = model.b0;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var request = _v1.b;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManagePartnerProductDataFlows$DeleteConfirmationClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('delete'),
                $author$project$Components$HiConfirm$noun('synced field'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$HintName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$Save = {
        $: 4
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$SyncDirection = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$linkTypeOptions = A2($elm$core$List$map, function(_v0) {
        var syncDirection = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$SyncDirection$toString(syncDirection)), label);
    }, _List_fromArray([
        _Utils_Tuple2(1, 'To Hint'),
        _Utils_Tuple2(0, 'From Hint'),
        _Utils_Tuple2(2, 'Two-way')
    ]));
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowEditModal = function(_v0) {
        var productDataFlow = _v0.D;
        if (!productDataFlow.$) {
            var _v2 = productDataFlow.a;
            var item = _v2.a;
            var form = _v2.b;
            var request = _v2.c;
            var modalConfig = {
                QG: $elm$core$Maybe$Nothing,
                aeI: 'Synced field',
                Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
                TR: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDataFlow$Shared$id, item),
                TS: $elm$core$Maybe$Nothing,
                Vl: $author$project$Components$Partner$ManagePartnerProductDataFlows$CancelAdd,
                Vn: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductDataFlows$Save)
            };
            var fields = $author$project$Utils$Form$fields(form);
            return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Hint name'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.QQ),
                        $author$project$Ui$Form$Input$placeholder('Invoice'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDataFlows$HintName, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Partner name'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.V$),
                        $author$project$Ui$Form$Input$placeholder('Expense'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDataFlows$PartnerName, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8),
                    $author$project$Ui$Form$Group$label('Sync Direction')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$SyncDirection$toString(fields.$F))),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductDataFlows$FormUpdated, $author$project$Components$Partner$ManagePartnerProductDataFlows$SyncDirection))
                    ]), $author$project$Components$Partner$ManagePartnerProductDataFlows$linkTypeOptions)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$modal = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowDeleteConfirmModal(model),
            $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlowEditModal(model)
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightDeleteConfirmModal = function(model) {
        var _v0 = model.bZ;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var request = _v1.b;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManagePartnerProductHighlights$DeleteConfirmationClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('delete'),
                $author$project$Components$HiConfirm$noun('highlight'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Description = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$ImageUploaded = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$SaveHighlight = {
        $: 5
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Title = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightModal = function(_v0) {
        var productHighlight = _v0.F;
        if (!productHighlight.$) {
            var _v2 = productHighlight.a;
            var item = _v2.a;
            var form = _v2.b;
            var request = _v2.c;
            var modalConfig = {
                QG: $elm$core$Maybe$Nothing,
                aeI: 'Highlight',
                Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
                TR: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductHighlight$Shared$id, item),
                TS: $elm$core$Maybe$Nothing,
                Vl: $author$project$Components$Partner$ManagePartnerProductHighlights$CancelAddOrEdit,
                Vn: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductHighlights$SaveHighlight)
            };
            var fields = $author$project$Utils$Form$fields(form);
            return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Title')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.$2),
                        $author$project$Ui$Form$Input$placeholder('Highlight title'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductHighlights$Title, $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Description')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Textarea$view(_List_fromArray([
                        $author$project$Ui$Form$Textarea$value(fields.NQ),
                        $author$project$Ui$Form$Textarea$placeholder('Highlight description'),
                        $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductHighlights$Description, $author$project$Components$Partner$ManagePartnerProductHighlights$FormUpdated)),
                        $author$project$Ui$Form$Textarea$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                        $author$project$Ui$Form$Textarea$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Image')
                ]), _List_fromArray([
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(0),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductHighlights$ImageUploaded),
                        $author$project$Ui$Form$File$empty(true)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Recommended size: 256x160 px or larger.'),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $elm$html$Html$text('Supported image file: JPG, PNG')
                    ])),
                    function() {
                        var _v3 = fields.p7;
                        if (!_v3.$) {
                            if (_v3.a === '') return $author$project$Utils$Html$empty;
                            else {
                                var url = _v3.a;
                                return A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt4
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Image$fromSrc, {
                                        Jg: 'Uploaded image'
                                    }, url, _List_fromArray([
                                        $author$project$Ui$Image$height(50)
                                    ])),
                                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, form))
                                ]));
                            }
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$modal = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightDeleteConfirmModal(model),
            $author$project$Components$Partner$ManagePartnerProductHighlights$viewHighlightModal(model)
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$viewLinkDeleteConfirmModal = function(model) {
        var _v0 = model.b_;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var request = _v1.b;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManagePartnerProductLinks$DeleteConfirmationClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('delete'),
                $author$project$Components$HiConfirm$noun('link'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$CopyUrl = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$LinkType = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$Save = {
        $: 4
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$Title = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$UtmCampaign = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$UtmContent = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$Value = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$linkTypeOptions = A2($elm$core$List$map, function(_v0) {
        var linkType = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$LinkType$toString(linkType)), label);
    }, _List_fromArray([
        _Utils_Tuple2(0, 'URL'),
        _Utils_Tuple2(1, 'Email'),
        _Utils_Tuple2(2, 'Phone')
    ]));
    var $author$project$Components$Partner$UtmLinkPreview$buildPreviewUrl = function(params) {
        if ($elm$core$String$isEmpty(params.aaT)) return $elm$core$Maybe$Nothing;
        else {
            var separator = A2($elm$core$String$contains, '?', params.aaT) ? '&' : '?';
            var campaign = $elm$core$String$isEmpty(params.aa5) ? 'hint_marketplace' : params.aa5;
            var utmParams = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'utm_source', 'hint')),
                $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'utm_medium', 'marketplace')),
                $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'utm_campaign', campaign)),
                $elm$core$String$isEmpty(params.aa6) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'utm_content', params.aa6))
            ]));
            return $elm$core$Maybe$Just(function(query) {
                return _Utils_ap(params.aaT, _Utils_ap(separator, query));
            }(A2($elm$core$String$dropLeft, 1, $elm$url$Url$Builder$toQuery(utmParams))));
        }
    };
    var $elm$html$Html$code = _VirtualDom_node('code');
    var $author$project$Components$Partner$UtmLinkPreview$view = F2(function(params, onCopy) {
        var _v0 = $author$project$Components$Partner$UtmLinkPreview$buildPreviewUrl(params);
        if (_v0.$ === 1) return $elm$html$Html$text('');
        else {
            var previewUrl = _v0.a;
            return A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                A2($elm$html$Html$pre, _List_fromArray([
                    $elm$html$Html$Attributes$class('text-xs text-muted bg-gray-50 rounded p-2 whitespace-pre-wrap break-all flex-1 m-0')
                ]), _List_fromArray([
                    A2($elm$html$Html$code, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(previewUrl)
                    ]))
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Copy URL'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick(onCopy(previewUrl))
                ]), _List_Nil)
            ]));
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$viewLinkEditModal = function(_v0) {
        var productLink = _v0.G;
        if (!productLink.$) {
            var _v2 = productLink.a;
            var item = _v2.a;
            var form = _v2.b;
            var request = _v2.c;
            var modalConfig = {
                QG: $elm$core$Maybe$Just('Add a link to your product that will be displayed on the product page.'),
                aeI: 'Link',
                Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
                TR: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductLink$Shared$id, item),
                TS: $elm$core$Maybe$Nothing,
                Vl: $author$project$Components$Partner$ManagePartnerProductLinks$CancelAdd,
                Vn: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductLinks$Save)
            };
            var fields = $author$project$Utils$Form$fields(form);
            var valuePlaceholder = function() {
                var _v3 = fields.Tf;
                switch(_v3){
                    case 0:
                        return 'https://example.com';
                    case 1:
                        return 'example@example.com';
                    default:
                        return '(123) 456-7890';
                }
            }();
            return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Title'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.$2),
                    $author$project$Ui$Form$Input$placeholder('Link title'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$Title, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Type')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$LinkType$toString(fields.Tf))),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated, $author$project$Components$Partner$ManagePartnerProductLinks$LinkType))
                ]), $author$project$Components$Partner$ManagePartnerProductLinks$linkTypeOptions)
            ])), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label($author$project$Components$Partner$ManagePartnerProductLinks$valueLabel(fields.Tf)),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.aa9),
                    $author$project$Ui$Form$Input$placeholder(valuePlaceholder),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$Value, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]))
            ])), !fields.Tf ? _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('UTM Campaign')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.aa5),
                        $author$project$Ui$Form$Input$placeholder('hint_marketplace'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$UtmCampaign, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('UTM Content')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.aa6),
                        $author$project$Ui$Form$Input$placeholder('Optional'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductLinks$UtmContent, $author$project$Components$Partner$ManagePartnerProductLinks$FormUpdated))
                    ]))
                ])),
                A2($author$project$Components$Partner$UtmLinkPreview$view, {
                    aaT: fields.aa9,
                    aa5: fields.aa5,
                    aa6: fields.aa6
                }, $author$project$Components$Partner$ManagePartnerProductLinks$CopyUrl)
            ]) : _List_Nil))));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$modal = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Partner$ManagePartnerProductLinks$viewLinkDeleteConfirmModal(model),
            $author$project$Components$Partner$ManagePartnerProductLinks$viewLinkEditModal(model)
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteDeleteConfirmModal = function(model) {
        var _v0 = model.b1;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var request = _v1.b;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManagePartnerProductQuotes$DeleteConfirmationClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('delete'),
                $author$project$Components$HiConfirm$noun('quote'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Author = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageUploaded = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitle = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Save = {
        $: 5
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Text = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteModal = function(_v0) {
        var productQuote = _v0.H;
        if (!productQuote.$) {
            var _v2 = productQuote.a;
            var item = _v2.a;
            var form = _v2.b;
            var request = _v2.c;
            var modalConfig = {
                QG: $elm$core$Maybe$Nothing,
                aeI: 'Quote',
                Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
                TR: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductQuote$Shared$id, item),
                TS: $elm$core$Maybe$Nothing,
                Vl: $author$project$Components$Partner$ManagePartnerProductQuotes$CancelAddOrEdit,
                Vn: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductQuotes$Save)
            };
            var fields = $author$project$Utils$Form$fields(form);
            return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Quote'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Textarea$view(_List_fromArray([
                        $author$project$Ui$Form$Textarea$value(fields.$Y),
                        $author$project$Ui$Form$Textarea$placeholder('Quote'),
                        $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$Text, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
                        $author$project$Ui$Form$Textarea$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                        $author$project$Ui$Form$Textarea$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Author'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.JP),
                        $author$project$Ui$Form$Input$placeholder('Author'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$Author, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Author Title'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.JR),
                        $author$project$Ui$Form$Input$placeholder('Author Title'),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductQuotes$AuthorTitle, $author$project$Components$Partner$ManagePartnerProductQuotes$FormUpdated)),
                        $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                        $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Author Image')
                ]), _List_fromArray([
                    $author$project$Ui$Form$File$view(_List_fromArray([
                        $author$project$Ui$Form$File$accept(0),
                        $author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductQuotes$AuthorImageUploaded),
                        $author$project$Ui$Form$File$empty(true)
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Recommended size: 256x160 px or larger.'),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        $elm$html$Html$text('Supported image file: JPG, PNG')
                    ])),
                    function() {
                        var _v3 = fields.p5;
                        if (!_v3.$) {
                            if (_v3.a === '') return $author$project$Utils$Html$empty;
                            else {
                                var url = _v3.a;
                                return A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt4
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Image$fromSrc, {
                                        Jg: 'Uploaded image'
                                    }, url, _List_fromArray([
                                        $author$project$Ui$Image$height(50)
                                    ])),
                                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 3, form))
                                ]));
                            }
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$modal = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteDeleteConfirmModal(model),
            $author$project$Components$Partner$ManagePartnerProductQuotes$viewQuoteModal(model)
        ]));
    };
    var $author$project$Pages$Partner$Product$Attribution = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Product$Edit = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$EditIconClicked = {
        $: 7
    };
    var $author$project$Ui$Image$MarketplaceIconPlaceholder = 16;
    var $author$project$Pages$Partner$Product$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ProductDescription = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$One$builtByName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$builtByName(shared);
    };
    var $author$project$Api$Partner$PartnerProduct$One$builtByUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$builtByUrl(shared);
    };
    var $author$project$Api$Partner$PartnerProduct$One$featured = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$featured(shared);
    };
    var $author$project$Api$Partner$PartnerProduct$One$summary = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerProduct$Shared$summary(shared);
    };
    var $author$project$Components$Marketplace$Product$CallToAction$disabled = 0;
    var $author$project$Pages$Partner$Product$ExternalCta = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$One$utmCampaign = function(_v0) {
        var record = _v0.b;
        return record.aa5;
    };
    var $author$project$Api$Partner$PartnerProduct$One$utmContent = function(_v0) {
        var record = _v0.b;
        return record.aa6;
    };
    var $author$project$Pages$Partner$Product$externalCtaEditField = function(product) {
        return $author$project$Pages$Partner$Product$ExternalCta({
            aaT: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$PartnerProduct$One$ctaUrl(product)),
            aa5: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$PartnerProduct$One$utmCampaign(product)),
            aa6: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$PartnerProduct$One$utmContent(product))
        });
    };
    var $author$project$Pages$Partner$Product$viewCtaButton = F2(function(callToAction, product) {
        var _v0 = $author$project$Api$Partner$PartnerProduct$One$type_(product);
        if (_v0 === 2) return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4
        ]), _List_fromArray([
            A2($elm$html$Html$button, _List_fromArray([
                $elm$html$Html$Attributes$class('inline-edit w-full'),
                $elm$html$Html$Events$onClick($author$project$Pages$Partner$Product$Edit($author$project$Pages$Partner$Product$externalCtaEditField(product)))
            ]), _List_fromArray([
                A2($author$project$Components$Marketplace$Product$CallToAction$button, _List_fromArray([
                    $author$project$Components$Marketplace$Product$CallToAction$disabled
                ]), callToAction),
                $author$project$Ui$Icon$edit(_List_fromArray([
                    $author$project$Ui$Icon$xs
                ]))
            ]))
        ]));
        else return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4
        ]), _List_fromArray([
            A2($author$project$Components$Marketplace$Product$CallToAction$button, _List_fromArray([
                $author$project$Components$Marketplace$Product$CallToAction$disabled
            ]), callToAction)
        ]));
    });
    var $author$project$Pages$Partner$Product$viewInlineEdit = F2(function(msg, viewView) {
        return A2($elm$html$Html$button, _List_fromArray([
            $elm$html$Html$Attributes$class('inline-edit'),
            $elm$html$Html$Events$onClick(msg)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$never, viewView),
            $author$project$Ui$Icon$edit(_List_fromArray([
                $author$project$Ui$Icon$xs
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Product$productCard = F4(function(imageStore, partner, product, callToAction) {
        var productSummary = $author$project$Api$Partner$PartnerProduct$One$summary(product);
        var productName = $author$project$Api$Partner$PartnerProduct$One$name(product);
        var builtByUrl = $author$project$Api$Partner$PartnerProduct$One$builtByUrl(product);
        var builtByName = $author$project$Api$Partner$PartnerProduct$One$builtByName(product);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('card'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('card--highlighted', $author$project$Api$Partner$PartnerProduct$One$featured(product))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap4,
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                A2($author$project$Pages$Partner$Product$viewInlineEdit, $author$project$Pages$Partner$Product$EditIconClicked, function() {
                    var _v0 = $author$project$Api$Partner$Partner$One$marketplaceIconUrl(partner);
                    if (!_v0.$) {
                        var icon = _v0.a;
                        return A3($author$project$Ui$Image$fromSrc, {
                            Jg: productName + ' icon'
                        }, icon, _List_fromArray([
                            $author$project$Ui$Image$height(64)
                        ]));
                    } else return A4($author$project$Ui$Image$view, imageStore, {
                        Jg: 'Product icon placeholder'
                    }, _List_fromArray([
                        $author$project$Ui$Image$height(64)
                    ]), 16);
                }()),
                A2($author$project$Pages$Partner$Product$viewInlineEdit, $author$project$Pages$Partner$Product$Edit($author$project$Pages$Partner$Product$Name(productName)), $author$project$Ui$Typography$headingSm($elm$core$List$singleton($elm$html$Html$text(productName))))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                A2($author$project$Ui$Badge$view, _List_fromArray([
                    $author$project$Ui$Badge$neutral
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Common$Marketplace$Product$ProductType$toString($author$project$Api$Partner$PartnerProduct$One$type_(product)))
                ])),
                function() {
                    var _v1 = $author$project$Api$Partner$PartnerProduct$One$status(product);
                    if (_v1 === 5) return $author$project$Utils$Html$empty;
                    else return $author$project$Components$Marketplace$Product$Status$view($author$project$Api$Partner$PartnerProduct$One$status(product));
                }()
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A2($author$project$Pages$Partner$Product$viewInlineEdit, $author$project$Pages$Partner$Product$Edit($author$project$Pages$Partner$Product$ProductDescription(A2($elm$core$Maybe$withDefault, '', productSummary))), function() {
                    if (!productSummary.$) {
                        var description = productSummary.a;
                        return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textMuted
                        ]), _List_fromArray([
                            $elm$html$Html$text(description)
                        ]));
                    } else return A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-muted')
                    ]), _List_fromArray([
                        $elm$html$Html$text('N/A')
                    ]));
                }())
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt4,
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Built by ')
                ])),
                A2($author$project$Pages$Partner$Product$viewInlineEdit, $author$project$Pages$Partner$Product$Edit(A2($author$project$Pages$Partner$Product$Attribution, builtByName, builtByUrl)), function() {
                    var _v3 = _Utils_Tuple2(builtByName, builtByUrl);
                    if (!_v3.a.$) {
                        if (!_v3.b.$) {
                            var name = _v3.a.a;
                            var url = _v3.b.a;
                            return A3($author$project$Ui$Link$externalHref, url, _List_fromArray([
                                $author$project$Ui$Link$icon($author$project$Ui$Icon$launch),
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text(name)
                            ]));
                        } else {
                            var name = _v3.a.a;
                            var _v4 = _v3.b;
                            return $elm$html$Html$text(name);
                        }
                    } else return A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-muted')
                    ]), _List_fromArray([
                        $elm$html$Html$text('N/A')
                    ]));
                }())
            ])),
            A2($author$project$Pages$Partner$Product$viewCtaButton, callToAction, product)
        ]));
    });
    var $author$project$Components$Partner$ManagePartnerProductCategories$Add = {
        $: 0
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$Remove = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductCategory$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$PartnerProductCategory$One$id = $author$project$Api$Partner$PartnerProductCategory$Shared$id;
    var $author$project$Api$Partner$PartnerProductCategory$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Partner$PartnerProductCategory$One$name = $author$project$Api$Partner$PartnerProductCategory$Shared$name;
    var $author$project$Api$Partner$Partner$One$productCategories = function(_v0) {
        var record = _v0.b;
        return record.Xx;
    };
    var $author$project$Components$Partner$ManagePartnerProductCategories$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2,
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Categories')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add category'
                }, _List_fromArray([
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductCategories$Add)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Category')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$wrap
            ]), A2($elm$core$List$map, function(cat) {
                return A3($author$project$Ui$Button$view, {
                    abP: 'Remove category'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductCategories$Remove($author$project$Api$Partner$PartnerProductCategory$One$id(cat)))
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$inlineBlock,
                        $author$project$Ui$Element$mr2
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Partner$PartnerProductCategory$One$name(cat))
                    ])),
                    $author$project$Ui$Icon$cross(_List_fromArray([
                        $author$project$Ui$Icon$xs
                    ]))
                ]));
            }, $author$project$Api$Partner$Partner$One$productCategories(model.VW)))
        ]);
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$Add = {
        $: 0
    };
    var $author$project$Api$Partner$Partner$One$productDataFlows = function(_v0) {
        var record = _v0.b;
        return record.Xy;
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$Delete = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$Edit = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Icon$Package = 93;
    var $author$project$Ui$Icon$package = $author$project$Ui$Icon$viewIcon(93);
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlow = F2(function(maybeIcon, productDataFlow) {
        var syncDirection = $author$project$Api$Partner$PartnerProductDataFlow$Shared$syncDirection(productDataFlow);
        var partnerName = $author$project$Api$Partner$PartnerProductDataFlow$Shared$partnerName(productDataFlow);
        var hintName = $author$project$Api$Partner$PartnerProductDataFlow$Shared$hintName(productDataFlow);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    function() {
                        if (!maybeIcon.$) {
                            var iconUrl = maybeIcon.a;
                            return A3($author$project$Ui$Image$fromSrc, {
                                Jg: 'icon'
                            }, iconUrl, _List_fromArray([
                                $author$project$Ui$Image$height(20)
                            ]));
                        } else return $author$project$Ui$Icon$package(_List_fromArray([
                            $author$project$Ui$Icon$xl
                        ]));
                    }(),
                    $elm$html$Html$text(partnerName)
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textCenter
            ]), _List_fromArray([
                function() {
                    switch(syncDirection){
                        case 0:
                            return $author$project$Ui$Icon$arrowLeft(_List_Nil);
                        case 1:
                            return $author$project$Ui$Icon$arrowRight(_List_Nil);
                        default:
                            return $author$project$Ui$Icon$transfer(_List_fromArray([
                                $author$project$Ui$Icon$xl
                            ]));
                    }
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Ui$Icon$hintHeart(_List_fromArray([
                    $author$project$Ui$Icon$xl
                ])),
                $author$project$Utils$Html$noBreakSpace,
                $elm$html$Html$text(hintName)
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit synced field'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDataFlows$Edit(productDataFlow))
                ]), _List_Nil),
                $author$project$Utils$Html$noBreakSpace,
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete synced field'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDataFlows$Delete(productDataFlow))
                ]), _List_Nil)
            ]))
        ]));
    });
    var $author$project$Components$Partner$ManagePartnerProductDataFlows$view = function(_v0) {
        var model = _v0;
        var productDataFlows = $author$project$Api$Partner$Partner$One$productDataFlows(model.VW);
        var iconUrl = $author$project$Api$Partner$Partner$One$marketplaceIconUrl(model.VW);
        return A3($author$project$Ui$Element$custom, 'card', _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Data Syncing')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add field'
                }, _List_fromArray([
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDataFlows$Add)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Field')
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                $author$project$Ui$HorizontalRule$thin
            ])),
            A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('In ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProduct$Shared$name, $author$project$Api$Partner$Partner$One$product(model.VW))))
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$textCenter
                ]), _List_fromArray([
                    $elm$html$Html$text('Sync Direction')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('In Hint')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$textRight
                ]), _List_fromArray([
                    $elm$html$Html$text('Actions')
                ]))
            ]), A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductDataFlows$viewProductDataFlow(iconUrl), productDataFlows), _List_Nil)
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Add = {
        $: 0
    };
    var $author$project$Api$Partner$Partner$One$productHighlights = function(_v0) {
        var record = _v0.b;
        return record.XA;
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Delete = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$Edit = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Image$ProductHighlightImagePlaceholder = 15;
    var $author$project$Ui$Image$FullWidth = {
        $: 4
    };
    var $author$project$Ui$Image$fullWidth = $author$project$Ui$Image$FullWidth;
    var $author$project$Ui$Image$HeightAuto = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Image$heightAuto = $author$project$Ui$Image$HeightAuto(0);
    var $author$project$Ui$Image$Rounded = {
        $: 5
    };
    var $author$project$Ui$Image$rounded = $author$project$Ui$Image$Rounded;
    var $author$project$Utils$Html$ulFromString = function(string) {
        return function(_v2) {
            var acc = _v2.a;
            var ils = _v2.b;
            if (!ils.b) return acc;
            else {
                var items = ils;
                return _Utils_ap(acc, _List_fromArray([
                    A2($elm$html$Html$ul, _List_fromArray([
                        $elm$html$Html$Attributes$class('m-0')
                    ]), items)
                ]));
            }
        }(A3($elm$core$List$foldl, F2(function(line, _v0) {
            var acc = _v0.a;
            var ils = _v0.b;
            if (A2($elm$core$String$startsWith, '- ', line) || A2($elm$core$String$startsWith, '* ', line)) return _Utils_Tuple2(acc, _Utils_ap(ils, _List_fromArray([
                A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$String$dropLeft, 2, line))
                ]))
            ])));
            else {
                if (!ils.b) return _Utils_Tuple2(_Utils_ap(acc, _List_fromArray([
                    $elm$html$Html$text(line),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil)
                ])), _List_Nil);
                else return _Utils_Tuple2(_Utils_ap(acc, _List_fromArray([
                    A2($elm$html$Html$ul, _List_fromArray([
                        $elm$html$Html$Attributes$class('m-0')
                    ]), ils),
                    $elm$html$Html$text(line),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil)
                ])), _List_Nil);
            }
        }), _Utils_Tuple2(_List_Nil, _List_Nil), $elm$core$String$lines(string)));
    };
    var $author$project$Components$Partner$ManagePartnerProductHighlights$viewProductHighlight = F2(function(model, productHighlight) {
        var title = $author$project$Api$Partner$PartnerProductHighlight$Shared$title(productHighlight);
        var description = $author$project$Api$Partner$PartnerProductHighlight$Shared$description(productHighlight);
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(3)
            ]), _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Partner$PartnerProductHighlight$Shared$imageUrl(productHighlight);
                    if (!_v0.$) {
                        var imageUrl = _v0.a;
                        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Image$fromSrc, {
                                Jg: 'Highlight image'
                            }, imageUrl, _List_fromArray([
                                $author$project$Ui$Image$rounded,
                                $author$project$Ui$Image$fullWidth,
                                $author$project$Ui$Image$heightAuto,
                                $author$project$Ui$Image$class('object-contain')
                            ]))
                        ]));
                    } else return A4($author$project$Ui$Image$view, model.qW, {
                        Jg: title + ' image'
                    }, _List_fromArray([
                        $author$project$Ui$Image$rounded,
                        $author$project$Ui$Image$height(160),
                        $author$project$Ui$Image$width(256)
                    ]), 15);
                }()
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flexCol,
                    $author$project$Ui$Element$fullWidth
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text(title)
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$justifyRight,
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit highlight'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductHighlights$Edit(productHighlight))
                            ]), _List_Nil),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Delete highlight'
                            }, _List_fromArray([
                                $author$project$Ui$Button$danger,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductHighlights$Delete(productHighlight))
                            ]), _List_Nil)
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mt4
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$preWrap,
                            $author$project$Ui$Typography$muted
                        ]), $author$project$Utils$Html$ulFromString(description)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Partner$ManagePartnerProductHighlights$view = function(_v0) {
        var model = _v0;
        var productHighlights = $author$project$Api$Partner$Partner$One$productHighlights(model.VW);
        return A3($author$project$Ui$Element$custom, 'card', _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Highlights')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Add highlight'
                    }, _List_fromArray([
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductHighlights$Add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add Highlight')
                    ]))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt4,
                    $author$project$Ui$Element$flexCol,
                    $author$project$Ui$Element$gap4
                ]), A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductHighlights$viewProductHighlight(model), productHighlights))
            ]))
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$Add = {
        $: 0
    };
    var $author$project$Api$Partner$Partner$One$productLinks = function(_v0) {
        var record = _v0.b;
        return record.XB;
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$Delete = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$Edit = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Icon$Call = 94;
    var $author$project$Ui$Icon$call = $author$project$Ui$Icon$viewIcon(94);
    var $author$project$Api$Partner$PartnerProductLink$Shared$composedUrl = function(_v0) {
        var record = _v0;
        return record.LX;
    };
    var $author$project$Ui$Link$Tabindex = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Ui$Link$preventFocus = $author$project$Ui$Link$Tabindex(-1);
    var $author$project$Ui$Link$Tel = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Link$tel = F3(function(tel_, options, content) {
        return A2($author$project$Ui$Link$view, A2($elm$core$List$cons, $author$project$Ui$Link$Tel(tel_), options), content);
    });
    var $author$project$Components$Partner$ManagePartnerProductLinks$viewProductLink = function(productLink) {
        var value = $author$project$Api$Partner$PartnerProductLink$Shared$value(productLink);
        var title = $author$project$Api$Partner$PartnerProductLink$Shared$title(productLink);
        var linkType = $author$project$Api$Partner$PartnerProductLink$Shared$linkType(productLink);
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt2,
            $author$project$Ui$Element$spaceBetween,
            $author$project$Ui$Element$itemsCenter
        ]), _List_fromArray([
            function() {
                switch(linkType){
                    case 0:
                        var href = A2($elm$core$Maybe$withDefault, value, $author$project$Api$Partner$PartnerProductLink$Shared$composedUrl(productLink));
                        return A3($author$project$Ui$Link$externalHref, href, _List_fromArray([
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$launch),
                            $author$project$Ui$Link$preventFocus,
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text(title)
                        ]));
                    case 1:
                        return A3($author$project$Ui$Link$mailto, value, _List_fromArray([
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$mail),
                            $author$project$Ui$Link$preventFocus
                        ]), _List_fromArray([
                            $elm$html$Html$text(title)
                        ]));
                    default:
                        return A3($author$project$Ui$Link$tel, value, _List_fromArray([
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$call),
                            $author$project$Ui$Link$preventFocus
                        ]), _List_fromArray([
                            $elm$html$Html$text(title)
                        ]));
                }
            }(),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit link'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductLinks$Edit(productLink))
                ]), _List_Nil),
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete link'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductLinks$Delete(productLink))
                ]), _List_Nil)
            ]))
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductLinks$view = function(_v0) {
        var model = _v0;
        var productLinks = $author$project$Api$Partner$Partner$One$productLinks(model.VW);
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Learn More & Support')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add link'
                }, _List_fromArray([
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductLinks$Add)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Link')
                ]))
            ])), A2($elm$core$List$cons, $author$project$Ui$HorizontalRule$view(_List_fromArray([
                $author$project$Ui$HorizontalRule$thin
            ])), A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductLinks$viewProductLink, productLinks))))
        ]);
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Add = {
        $: 0
    };
    var $author$project$Api$Partner$Partner$One$productQuotes = function(_v0) {
        var record = _v0.b;
        return record.XD;
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Delete = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductQuotes$Edit = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Icon$Quote = 101;
    var $author$project$Components$Partner$ManagePartnerProductQuotes$viewProductQuote = F2(function(model, productQuote) {
        var text_ = $author$project$Api$Partner$PartnerProductQuote$Shared$text(productQuote);
        var authorTitle = $author$project$Api$Partner$PartnerProductQuote$Shared$authorTitle(productQuote);
        var author = $author$project$Api$Partner$PartnerProductQuote$Shared$author(productQuote);
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap4
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Icon$view, _List_fromArray([
                        $author$project$Ui$Icon$width('50px'),
                        $author$project$Ui$Icon$class('icon--primary')
                    ]), 101)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flexCol,
                    $author$project$Ui$Element$fullWidth
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text(text_)
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$justifyRight,
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit quote'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductQuotes$Edit(productQuote))
                            ]), _List_Nil),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Delete quote'
                            }, _List_fromArray([
                                $author$project$Ui$Button$danger,
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                                $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductQuotes$Delete(productQuote))
                            ]), _List_Nil)
                        ]))
                    ])),
                    $author$project$Ui$HorizontalRule$view(_List_fromArray([
                        $author$project$Ui$HorizontalRule$thin
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mt4
                    ]), _List_fromArray([
                        function() {
                            var _v0 = $author$project$Api$Partner$PartnerProductQuote$Shared$authorImageUrl(productQuote);
                            if (!_v0.$) {
                                var imageUrl = _v0.a;
                                return A3($author$project$Ui$Image$fromSrc, {
                                    Jg: author + ' image'
                                }, imageUrl, _List_fromArray([
                                    $author$project$Ui$Image$rounded,
                                    $author$project$Ui$Image$height(100),
                                    $author$project$Ui$Image$width(100)
                                ]));
                            } else return A4($author$project$Ui$Image$view, model.qW, {
                                Jg: author + ' image'
                            }, _List_fromArray([
                                $author$project$Ui$Image$fullWidth
                            ]), 15);
                        }(),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$inlineBlock,
                            $author$project$Ui$Element$ml2
                        ]), _List_fromArray([
                            $elm$html$Html$text(author),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text(authorTitle)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Partner$ManagePartnerProductQuotes$view = function(_v0) {
        var model = _v0;
        var productQuotes = $author$project$Api$Partner$Partner$One$productQuotes(model.VW);
        return A3($author$project$Ui$Element$custom, 'card', _List_fromArray([
            $author$project$Ui$Element$mt4
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Quotes')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Add quote'
                    }, _List_fromArray([
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductQuotes$Add)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Add Quote')
                    ]))
                ])),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt4
                ]), A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductQuotes$viewProductQuote(model), productQuotes))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Product$viewDeleteConfirmModal = function(model) {
        var _v0 = model.fu;
        if (!_v0.$) return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Partner$Product$DeleteConfirmClosed, _List_fromArray([
            $author$project$Components$HiConfirm$verb('delete'),
            $author$project$Components$HiConfirm$noun('image'),
            $author$project$Components$HiConfirm$loading(model.Tk)
        ]));
        else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Partner$Product$IconUploaded = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ProductOverviewDescription = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Form$Group$static = $author$project$Ui$Form$Static$view(_List_Nil);
    var $author$project$Components$Partner$ProductIconInstructions$view = A2($author$project$Ui$Element$view, _List_fromArray([
        $author$project$Ui$Element$gap2,
        $author$project$Ui$Element$flexCol
    ]), _List_fromArray([
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Preferred format: SVG (vector)')
        ])),
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Aspect ratio: 1:1 (square)')
        ])),
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $elm$html$Html$text("PNG fallback: 800\xd7800 px recommended, transparent background")
        ])),
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $elm$html$Html$text("Content: Icon or symbol only \u2014 no text or wordmarks")
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$textMuted
        ]), _List_fromArray([
            $elm$html$Html$text('This icon is designed for dense UI areas where clarity at small sizes is important.')
        ]))
    ]));
    var $author$project$Pages$Partner$Product$CopyToClipboard = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$viewExternalCtaForm = F2(function(form, cta) {
        var fieldOpts = function(label) {
            return _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$label(label)
            ]);
        };
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap2,
            $author$project$Ui$Element$flexCol
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, fieldOpts('CTA URL'), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(cta.aaT),
                    $author$project$Ui$Form$Input$onInput(function(url) {
                        return $author$project$Pages$Partner$Product$Edited($author$project$Pages$Partner$Product$ExternalCta(_Utils_update(cta, {
                            aaT: url
                        })));
                    }),
                    $author$project$Ui$Form$Input$placeholder('https://partner.example.com/signup'),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, fieldOpts('Campaign'), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(cta.aa5),
                    $author$project$Ui$Form$Input$onInput(function(campaign) {
                        return $author$project$Pages$Partner$Product$Edited($author$project$Pages$Partner$Product$ExternalCta(_Utils_update(cta, {
                            aa5: campaign
                        })));
                    }),
                    $author$project$Ui$Form$Input$placeholder('hint_marketplace')
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt1,
                    $author$project$Ui$Element$textMuted,
                    $author$project$Ui$Element$textSm
                ]), _List_fromArray([
                    $elm$html$Html$text('Defaults to \"hint_marketplace\" if left blank. Used as utm_campaign.')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, fieldOpts('Content'), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(cta.aa6),
                    $author$project$Ui$Form$Input$onInput(function(content) {
                        return $author$project$Pages$Partner$Product$Edited($author$project$Pages$Partner$Product$ExternalCta(_Utils_update(cta, {
                            aa6: content
                        })));
                    }),
                    $author$project$Ui$Form$Input$placeholder('Optional')
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt1,
                    $author$project$Ui$Element$textMuted,
                    $author$project$Ui$Element$textSm
                ]), _List_fromArray([
                    $elm$html$Html$text('Optional. Used as utm_content to differentiate placements.')
                ]))
            ])),
            A2($author$project$Components$Partner$UtmLinkPreview$view, cta, $author$project$Pages$Partner$Product$CopyToClipboard)
        ]));
    });
    var $author$project$Pages$Partner$Product$viewEditModalInput = function(form) {
        var field = $author$project$Utils$Form$fields(form);
        if (field.$ === 6) {
            var cta = field.a;
            return A2($author$project$Pages$Partner$Product$viewExternalCtaForm, form, cta);
        } else {
            var formGroupOptions = A2($elm$core$List$cons, $author$project$Ui$Form$Group$labelSpanSm(4), A2($elm$core$List$cons, $author$project$Ui$Form$Group$inputSpanSm(8), function() {
                switch(field.$){
                    case 0:
                        return _List_fromArray([
                            $author$project$Ui$Form$Group$label('Name'),
                            $author$project$Ui$Form$Group$required(true)
                        ]);
                    case 1:
                        return _List_fromArray([
                            $author$project$Ui$Form$Group$label('Summary')
                        ]);
                    case 3:
                        return _List_fromArray([
                            $author$project$Ui$Form$Group$label('Product overview')
                        ]);
                    case 5:
                        return _List_fromArray([
                            $author$project$Ui$Form$Group$label('Built by')
                        ]);
                    case 2:
                        return _List_fromArray([
                            $author$project$Ui$Form$Group$label('Icon')
                        ]);
                    default:
                        return _List_Nil;
                }
            }()));
            return A2($author$project$Ui$Form$Group$view, formGroupOptions, function() {
                switch(field.$){
                    case 0:
                        var name = field.a;
                        return _List_fromArray([
                            $author$project$Ui$Form$Input$view(_List_fromArray([
                                $author$project$Ui$Form$Input$value(name),
                                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Product$Name, $author$project$Pages$Partner$Product$Edited)),
                                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                                $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                            ]))
                        ]);
                    case 1:
                        var description = field.a;
                        return _List_fromArray([
                            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                                $author$project$Ui$Form$Textarea$value(description),
                                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Product$ProductDescription, $author$project$Pages$Partner$Product$Edited))
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt2,
                                $author$project$Ui$Element$textMuted,
                                $author$project$Ui$Element$textSm
                            ]), _List_fromArray([
                                $elm$html$Html$text('One sentence that describes your product without repeating the product name shown above.')
                            ]))
                        ]);
                    case 3:
                        var description = field.a;
                        return _List_fromArray([
                            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                                $author$project$Ui$Form$Textarea$value(description),
                                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Product$ProductOverviewDescription, $author$project$Pages$Partner$Product$Edited))
                            ]))
                        ]);
                    case 5:
                        var maybeName = field.a;
                        var maybeUrl = field.b;
                        return _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$gap2,
                                $author$project$Ui$Element$flexCol
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Name')
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$Input$view(_List_fromArray([
                                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', maybeName)),
                                        $author$project$Ui$Form$Input$onInput(function(name) {
                                            return $author$project$Pages$Partner$Product$Edited(A2($author$project$Pages$Partner$Product$Attribution, $author$project$Utils$Maybe$fromString(name), maybeUrl));
                                        }),
                                        $author$project$Ui$Form$Input$placeholder('Example')
                                    ]))
                                ])),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('URL')
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$Input$view(_List_fromArray([
                                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', maybeUrl)),
                                        $author$project$Ui$Form$Input$onInput(function(url) {
                                            return $author$project$Pages$Partner$Product$Edited(A2($author$project$Pages$Partner$Product$Attribution, maybeName, $author$project$Utils$Maybe$fromString(url)));
                                        }),
                                        $author$project$Ui$Form$Input$placeholder('https://example.com')
                                    ]))
                                ]))
                            ]))
                        ]);
                    case 2:
                        return _List_fromArray([
                            $author$project$Ui$Form$Group$static(_List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$gap4,
                                    $author$project$Ui$Element$flexCol
                                ]), _List_fromArray([
                                    $author$project$Components$Partner$ProductIconInstructions$view,
                                    A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$flexCol
                                    ]), _List_fromArray([
                                        $author$project$Ui$Form$File$view(_List_fromArray([
                                            $author$project$Ui$Form$File$onInput($author$project$Pages$Partner$Product$IconUploaded)
                                        ])),
                                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form))
                                    ]))
                                ]))
                            ]))
                        ]);
                    default:
                        return _List_Nil;
                }
            }());
        }
    };
    var $author$project$Pages$Partner$Product$viewEditModal = function(model) {
        var _v0 = model.w;
        if (!_v0.$) {
            var form = _v0.a;
            var field = $author$project$Utils$Form$fields(form);
            var saveDisabled = function() {
                if (field.$ === 2) {
                    var maybeIcon = field.a;
                    return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $elm$core$Basics$always(false), maybeIcon));
                } else return false;
            }();
            return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Product$CancelEdit, _List_fromArray([
                $author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Product$Saved(form))
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Editing Product')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    $author$project$Pages$Partner$Product$viewEditModalInput(form)
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel'
                    }, _List_fromArray([
                        $author$project$Ui$Button$default,
                        $author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$CancelEdit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Save product changes'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$disabled(saveDisabled)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Save')
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Partner$Product$ProductOverviewImageDeleted = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ProductOverviewImagesUploaded = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Carousel$AspectVideo = {
        $: 2
    };
    var $author$project$Components$Carousel$aspectVideo = $author$project$Components$Carousel$AspectVideo;
    var $author$project$Ui$Link$ButtonWarning = 4;
    var $author$project$Ui$Link$buttonWarning = $author$project$Ui$Link$Style(4);
    var $author$project$Api$Partner$PartnerProductOverview$Shared$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Ui$Form$File$Key = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Form$File$key = $author$project$Ui$Form$File$Key;
    var $author$project$Components$Carousel$OverlayAction = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Carousel$overlay = $author$project$Components$Carousel$OverlayAction;
    var $author$project$Components$Carousel$Image = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Carousel$image = F3(function(id, src, alt) {
        return $author$project$Components$Carousel$Image({
            Jg: alt,
            aef: id,
            s2: src
        });
    });
    var $author$project$Api$Partner$ProductImage$Shared$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Pages$Partner$Product$productImageToCarouselImage = function(productImage) {
        return A3($author$project$Components$Carousel$image, $author$project$Api$Partner$ProductImage$Shared$id(productImage), $author$project$Api$Partner$ProductImage$Shared$url(productImage), $author$project$Api$Partner$ProductImage$Shared$alt(productImage));
    };
    var $author$project$Components$Carousel$Thumbnails = {
        $: 0
    };
    var $author$project$Components$Carousel$thumbnails = $author$project$Components$Carousel$Thumbnails;
    var $author$project$Components$Carousel$JumpTo = $elm$core$Basics$identity;
    var $author$project$Components$Carousel$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, acc) {
            switch(option.$){
                case 0:
                    return _Utils_update(acc, {
                        DF: true
                    });
                case 1:
                    var action = option.a;
                    return _Utils_update(acc, {
                        Ag: $elm$core$Maybe$Just(action)
                    });
                default:
                    return _Utils_update(acc, {
                        vB: true
                    });
            }
        }), {
            vB: false,
            Ag: $elm$core$Maybe$Nothing,
            DF: false
        }, options);
    };
    var $author$project$Components$Carousel$viewImage = function(img) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('carousel__image')
        ]), _List_fromArray([
            A2($elm$html$Html$img, _List_fromArray([
                $elm$html$Html$Attributes$src(img.s2),
                $elm$html$Html$Attributes$alt(''),
                $elm$html$Html$Attributes$class('carousel__image__bg')
            ]), _List_Nil),
            A3($author$project$Ui$Image$fromSrc, {
                Jg: img.Jg
            }, img.s2, _List_Nil)
        ]));
    };
    var $author$project$Components$Carousel$viewItem = function(item) {
        if (!item.$) {
            var img = item.a;
            return $author$project$Components$Carousel$viewImage(img);
        } else {
            var content = item.b;
            return A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('carousel__image')
            ]), _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$never, content)
            ]));
        }
    };
    var $author$project$Components$Carousel$viewImageThumb = function(img) {
        return A3($author$project$Ui$Image$fromSrc, {
            Jg: img.Jg
        }, img.s2, _List_fromArray([
            $author$project$Ui$Image$class('rounded'),
            $author$project$Ui$Image$width(68),
            $author$project$Ui$Image$height(68)
        ]));
    };
    var $author$project$Components$Carousel$viewThumb = F4(function(itemsCount, selectedIndex, index, item) {
        return A2($elm$html$Html$button, _List_fromArray([
            $elm$html$Html$Attributes$class('carousel__thumbnail-button'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('carousel__thumbnail-button--active', _Utils_eq(index, selectedIndex))
            ])),
            $elm$html$Html$Events$onClick(A2($elm$core$Basics$modBy, itemsCount, index))
        ]), _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$never, function() {
                if (!item.$) {
                    var img = item.a;
                    return $author$project$Components$Carousel$viewImageThumb(img);
                } else {
                    var content = item.b;
                    return content;
                }
            }())
        ]));
    });
    var $author$project$Components$Carousel$view = F3(function(options, _v0, items) {
        var index = _v0.yc;
        var toMsg = _v0.ahX;
        if ($elm$core$List$isEmpty(items)) return $elm$html$Html$text('');
        else {
            var optionsRecord = $author$project$Components$Carousel$optionsToRecord(options);
            var itemsCount = $elm$core$List$length(items);
            var nextIndex = A2($elm$core$Basics$modBy, itemsCount, index + 1);
            var prevIndex = A2($elm$core$Basics$modBy, itemsCount, index - 1);
            var currentItem = A2($elm$core$Array$get, index, $elm$core$Array$fromList(items));
            var itemId = A2($elm$core$Maybe$map, function(item) {
                if (!item.$) {
                    var img = item.a;
                    return img.aef;
                } else {
                    var id = item.a;
                    return id;
                }
            }, currentItem);
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('carousel'),
                    A2($elm$html$Html$Attributes$attribute, 'style', '--carousel-index:' + $elm$core$String$fromInt(index)),
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('aspect-video', optionsRecord.vB)
                    ]))
                ]), _List_fromArray([
                    A2($elm$html$Html$map, toMsg, A2($elm$html$Html$button, _List_fromArray([
                        $elm$html$Html$Events$onClick(prevIndex),
                        $elm$html$Html$Attributes$class('carousel__control carousel__control--left')
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$chevron(_List_fromArray([
                            $author$project$Ui$Icon$rotate180
                        ]))
                    ]))),
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('carousel__track')
                    ]), A2($elm$core$List$map, $author$project$Components$Carousel$viewItem, items)),
                    A2($elm$html$Html$map, toMsg, A2($elm$html$Html$button, _List_fromArray([
                        $elm$html$Html$Events$onClick(nextIndex),
                        $elm$html$Html$Attributes$class('carousel__control carousel__control--right')
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$chevron(_List_Nil)
                    ]))),
                    function() {
                        var _v1 = _Utils_Tuple2(optionsRecord.Ag, itemId);
                        if (!_v1.a.$ && !_v1.b.$) {
                            var action = _v1.a.a;
                            var itemId_ = _v1.b.a;
                            return A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('carousel__overlay')
                            ]), _List_fromArray([
                                action(itemId_)
                            ]));
                        } else return $elm$html$Html$text('');
                    }()
                ])),
                optionsRecord.DF ? A2($elm$html$Html$map, toMsg, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('carousel__thumbnails')
                ]), A2($elm$core$List$indexedMap, A2($author$project$Components$Carousel$viewThumb, itemsCount, index), items))) : $elm$html$Html$text('')
            ]));
        }
    });
    var $author$project$Ui$Form$File$SrOnly = {
        $: 6
    };
    var $author$project$Ui$Form$File$viewWithContent = F2(function(options, content) {
        var optionsRecord = $author$project$Ui$Form$File$optionsToRecord(options);
        return A2($elm$html$Html$label, _List_fromArray([
            $elm$html$Html$Attributes$class('cursor-pointer m-0'),
            $elm$html$Html$Attributes$tabindex(0),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('inline-edit inline-edit--overlay', optionsRecord.qZ)
            ])),
            A2($elm$html$Html$Attributes$style, 'overflow', 'auto')
        ]), _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$never, content),
            $author$project$Ui$Form$File$view(A2($elm$core$List$cons, $author$project$Ui$Form$File$SrOnly, options)),
            optionsRecord.qZ ? $author$project$Ui$Icon$edit(_List_fromArray([
                $author$project$Ui$Icon$xs
            ])) : $elm$html$Html$text('')
        ]));
    });
    var $author$project$Pages$Partner$Product$viewProductOverview = function(model) {
        var carousel = model.pR;
        var fileKey = model.qI;
        var loading = model.Tk;
        var partner = model.VW;
        var productOverviewDescription = A2($elm$core$Maybe$andThen, $author$project$Api$Partner$PartnerProductOverview$Shared$description, $author$project$Api$Partner$Partner$One$productOverview(partner));
        var deleteButton = function(imageId) {
            return A3($author$project$Ui$Button$view, {
                abP: 'Delete image'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$ProductOverviewImageDeleted(imageId))
            ]), _List_Nil);
        };
        var customElementClasses = 'button button--default [&>*:first-child]:mt-0' + (loading ? 'button--disabled' : '');
        var carouselItems = A2($elm$core$List$map, $author$project$Pages$Partner$Product$productImageToCarouselImage, A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductOverview$Shared$images, $author$project$Api$Partner$Partner$One$productOverview(partner))));
        return A2($author$project$Ui$Card$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Overview')
                    ])),
                    function() {
                        var _v0 = model.Xw;
                        if (_v0.$ === 3) {
                            var product = _v0.a;
                            return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Slug_String({
                                _A: $author$project$Api$Partner$PartnerProduct$One$slug(product)
                            }), _List_fromArray([
                                $author$project$Ui$Link$buttonWarning,
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text('View in Marketplace')
                            ]));
                        } else return $elm$html$Html$text('');
                    }()
                ])),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                A3($author$project$Components$Carousel$view, _List_fromArray([
                    $author$project$Components$Carousel$thumbnails,
                    $author$project$Components$Carousel$overlay(deleteButton),
                    $author$project$Components$Carousel$aspectVideo
                ]), carousel, carouselItems),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$File$viewWithContent, _List_fromArray([
                        $author$project$Ui$Form$File$disabled(loading),
                        $author$project$Ui$Form$File$key($elm$core$String$fromInt(fileKey)),
                        $author$project$Ui$Form$File$onInput($author$project$Pages$Partner$Product$ProductOverviewImagesUploaded)
                    ]), A3($author$project$Ui$Element$custom, customElementClasses, _List_fromArray([
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$flex,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$upload(_List_Nil),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Upload content')
                        ]))
                    ])))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt4
                ]), _List_fromArray([
                    A2($author$project$Pages$Partner$Product$viewInlineEdit, $author$project$Pages$Partner$Product$Edit($author$project$Pages$Partner$Product$ProductOverviewDescription(A2($elm$core$Maybe$withDefault, '', productOverviewDescription))), function() {
                        if (!productOverviewDescription.$) {
                            var description = productOverviewDescription.a;
                            return A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$preWrap,
                                $author$project$Ui$Typography$muted
                            ]), $author$project$Utils$Html$ulFromString(description)));
                        } else return A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('text-muted')
                        ]), _List_fromArray([
                            $elm$html$Html$text('N/A')
                        ]));
                    }())
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Product$viewBody = function(model) {
        var _v0 = model.Xw;
        if (_v0.$ === 3) {
            var product = _v0.a;
            return _List_fromArray([
                $author$project$Pages$Partner$Product$viewEditModal(model),
                $author$project$Pages$Partner$Product$viewDeleteConfirmModal(model),
                A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg, $author$project$Components$Partner$ManagePartnerProductLinks$modal(model.f5)),
                A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, $author$project$Components$Partner$ManagePartnerProductHighlights$modal(model.f4)),
                A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, $author$project$Components$Partner$ManagePartnerProductDataFlows$modal(model.f3)),
                A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg, $author$project$Components$Partner$ManagePartnerProductCategories$modal(model.f2)),
                A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, $author$project$Components$Partner$ManagePartnerProductQuotes$modal(model.f6)),
                A3($author$project$Ui$Element$custom, 'marketplace-landing', _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Element$custom, 'marketplace-landing__aside', _List_Nil, _List_fromArray([
                        A4($author$project$Pages$Partner$Product$productCard, model.qW, model.VW, product, model.aZ),
                        A2($author$project$Ui$Card$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mb2
                            ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$Product$ManagePartnerProductLinksMsg), $author$project$Components$Partner$ManagePartnerProductLinks$view(model.f5))),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt2
                            ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$Product$ManagePartnerProductCategoriesMsg), $author$project$Components$Partner$ManagePartnerProductCategories$view(model.f2)))
                        ]))
                    ])),
                    A3($author$project$Ui$Element$custom, 'marketplace-landing__main', _List_Nil, _List_fromArray([
                        $author$project$Pages$Partner$Product$viewProductOverview(model),
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ManagePartnerProductHighlightsMsg, $author$project$Components$Partner$ManagePartnerProductHighlights$view(model.f4)),
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ManagePartnerProductDataFlowsMsg, $author$project$Components$Partner$ManagePartnerProductDataFlows$view(model.f3)),
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ManagePartnerProductQuotesMsg, $author$project$Components$Partner$ManagePartnerProductQuotes$view(model.f6))
                    ]))
                ]))
            ]);
        } else return _List_Nil;
    };
    var $author$project$Pages$Partner$Product$view = function(model) {
        return {
            fb: $author$project$Pages$Partner$Product$viewBody(model),
            $2: 'Partner | Product'
        };
    };
    var $author$project$Pages$Partner$Product$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Product$init,
        aeR: $author$project$Pages$Partner$Product$load,
        ag3: $author$project$Pages$Partner$Product$save,
        ahE: $author$project$Pages$Partner$Product$subscriptions,
        aaO: $author$project$Pages$Partner$Product$update,
        aid: $author$project$Pages$Partner$Product$view
    });
    var $author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$GotDocuments = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductDocument$All$PartnerProductDocument = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProductDocument$Shared$PartnerProductDocument = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProductDocument$Shared$Record = F5(function(id, title, documentType, url, pdfName) {
        return {
            Og: documentType,
            aef: id,
            Ww: pdfName,
            $2: title,
            aaT: url
        };
    });
    var $author$project$Api$Partner$PartnerProductDocument$Shared$PdfDocument = 0;
    var $author$project$Api$Partner$PartnerProductDocument$Shared$UrlDocument = 1;
    var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString = function(string) {
        switch(string){
            case 'pdf':
                return $elm$core$Maybe$Just(0);
            case 'url':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDecoder = A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$json$Json$Decode$succeed), $elm$core$Maybe$withDefault($elm$json$Json$Decode$fail('Unsupported document type')))), $elm$json$Json$Decode$string);
    var $author$project$Api$Partner$PartnerProductDocument$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'pdf_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'document_type', $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'title', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerProductDocument$Shared$Record))))));
    var $author$project$Api$Partner$PartnerProductDocument$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProductDocument$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProductDocument$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerProductDocument$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerProductDocument$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Partner$PartnerProductDocument$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$PartnerProductDocument$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var q = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', q)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Partner$PartnerProductDocument$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$PartnerProductDocument$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$PartnerProductDocument$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath)));
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments = F2(function(apiClient, model) {
        return A3($author$project$Api$Partner$PartnerProductDocument$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Components$Partner$ManagePartnerProductDocuments$GotDocuments);
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$init = F2(function(apiClient, query) {
        var q = A2($elm$core$Dict$get, 'q', query);
        var initialModel = {
            bY: $elm$core$Maybe$Nothing,
            bu: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            E: $elm$core$Maybe$Nothing,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: $author$project$Api$Sort$initFromQuery(query)
        };
        return _Utils_Tuple2(initialModel, A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, initialModel));
    });
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$Model = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath = function(productId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'partner_products',
            productId,
            'preconditions'
        ]), $author$project$Api$Data$partnerPath);
    };
    var $author$project$Api$Partner$PartnerProduct$Precondition$list = F3(function(apiClient, productId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Common$Marketplace$Product$Precondition$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId)));
    });
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$init = F2(function(apiClient, productId) {
        return _Utils_Tuple2({
            ai: $elm$core$Maybe$Nothing,
            b$: $elm$core$Maybe$Nothing,
            Xf: $author$project$Api$Data$Loading,
            G6: productId
        }, A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, productId, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions));
    });
    var $author$project$Api$Partner$Partner$Shared$authType = function(_v0) {
        var record = _v0;
        return record.JO;
    };
    var $author$project$Api$Partner$Partner$One$authType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$authType(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$postActivationRedirectUrl = function(_v0) {
        var record = _v0;
        return record.WY;
    };
    var $author$project$Api$Partner$Partner$One$postActivationRedirectUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$postActivationRedirectUrl(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$redirectUrl = function(_v0) {
        var record = _v0;
        return record.Yo;
    };
    var $author$project$Api$Partner$Partner$One$redirectUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$redirectUrl(shared);
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$initFormFields = function(partner) {
        return _Utils_Tuple2({
            JO: $author$project$Api$Partner$Partner$One$authType(partner),
            WY: $author$project$Api$Partner$Partner$One$postActivationRedirectUrl(partner),
            Yo: $author$project$Api$Partner$Partner$One$redirectUrl(partner)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$init = F4(function(_v0, partner, shared, _v1) {
        var query = _v1.Bz;
        var productId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProduct$Shared$id, $author$project$Api$Partner$Partner$One$product(partner)));
        var _v2 = A2($author$project$Components$Partner$ManagePartnerProductPreconditions$init, shared.Ej, productId);
        var preconditionsModel = _v2.a;
        var preconditionsCmd = _v2.b;
        var _v3 = $author$project$Pages$Partner$Product$ActivationSettings$initFormFields(partner);
        var formFields = _v3.a;
        var formFieldsCmd = _v3.b;
        var _v4 = A2($author$project$Components$Partner$ManagePartnerProductDocuments$init, shared.Ej, query);
        var documentsModel = _v4.a;
        var documentsCmd = _v4.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: $author$project$Utils$Form$init(formFields),
            i6: documentsModel,
            i8: preconditionsModel,
            VW: partner,
            o2: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            formFieldsCmd,
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg, documentsCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg, preconditionsCmd)
        ])));
    });
    var $author$project$Pages$Partner$Product$ActivationSettings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Product$ActivationSettings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd = {
        $: 5
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd)), model.E)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed)), model.bY))
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm = {
        $: 3
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = model.ai;
                if (!_v1.$) return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm);
                else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v2 = model.b$;
                if (!_v2.$) return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed);
                else return $elm$core$Platform$Sub$none;
            }()
        ]));
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg, $author$project$Components$Partner$ManagePartnerProductDocuments$subscriptions(model.i6)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg, $author$project$Components$Partner$ManagePartnerProductPreconditions$subscriptions(model.i8))
        ]));
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$GotUpdatedPartner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    Yo: $author$project$Utils$String$toMaybe(string)
                });
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    JO: string
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    WY: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Deleted = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentCreated = 1;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentDeleted = 3;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentUpdated = 2;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$File = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$GotSignedPdfUrl = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$None = 0;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductDocument$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath(id)));
    });
    var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDefault = 1;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$documentFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var title = field.a;
                return _Utils_update(fields, {
                    $2: title
                });
            case 1:
                var docType = field.a;
                return _Utils_update(fields, {
                    Og: A2($elm$core$Maybe$withDefault, $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeDefault, $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeFromString(docType)),
                    qJ: 0,
                    Wv: $elm$core$Maybe$Nothing,
                    aaT: ''
                });
            case 2:
                var url = field.a;
                return _Utils_update(fields, {
                    aaT: url
                });
            default:
                var size = field.a;
                var dataUrl = field.b;
                return _Utils_update(fields, {
                    qJ: size,
                    Wv: $elm$core$Maybe$Just(_Utils_Tuple2(size, dataUrl))
                });
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$TitleValidation = 0;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$FileValidation = 2;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$UrlValidation = 1;
    var $author$project$Utils$FileSize$twentyFiveMegabytes = 26214400;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$maxFileBytesSize = $author$project$Utils$FileSize$twentyFiveMegabytes;
    var $author$project$Components$Partner$ManagePartnerProductDocuments$validateUrlOrFile = function(fields) {
        var _v0 = fields.Og;
        if (_v0 === 1) return $elm$core$String$isEmpty(fields.aaT) ? _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a URL.')
        ]) : $author$project$Utils$Validate$isInvalidUrl(fields.aaT) ? _List_fromArray([
            _Utils_Tuple2(1, 'Please enter a valid URL.')
        ]) : _List_Nil;
        else return _Utils_eq(fields.Wv, $elm$core$Maybe$Nothing) && _Utils_eq(fields.xB, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(2, 'Please attach a PDF file.')
        ]) : _Utils_cmp(fields.qJ, $author$project$Components$Partner$ManagePartnerProductDocuments$maxFileBytesSize) > 0 ? _List_fromArray([
            _Utils_Tuple2(2, 'That file is too large! Maximum file size is 25 MB.')
        ]) : _List_Nil;
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$documentValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.$2;
        }, _Utils_Tuple2(0, 'Please enter a title.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManagePartnerProductDocuments$validateUrlOrFile)
    ]));
    var $author$project$Api$Partner$PartnerProductDocument$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$PartnerProductDocument$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$PartnerProductDocument$Shared$id(shared);
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFields = {
        Og: 1,
        xB: $elm$core$Maybe$Nothing,
        qJ: 0,
        Wv: $elm$core$Maybe$Nothing,
        $2: '',
        aaT: ''
    };
    var $author$project$Api$Partner$PartnerProductDocument$Shared$documentType = function(_v0) {
        var record = _v0;
        return record.Og;
    };
    var $author$project$Api$Partner$PartnerProductDocument$All$documentType = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$PartnerProductDocument$Shared$documentType(shared);
    };
    var $author$project$Api$Partner$PartnerProductDocument$Shared$pdfName = function(_v0) {
        var record = _v0;
        return record.Ww;
    };
    var $author$project$Api$Partner$PartnerProductDocument$All$pdfName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$PartnerProductDocument$Shared$pdfName(shared);
    };
    var $author$project$Api$Partner$PartnerProductDocument$Shared$title = function(_v0) {
        var record = _v0;
        return record.$2;
    };
    var $author$project$Api$Partner$PartnerProductDocument$All$title = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$PartnerProductDocument$Shared$title(shared);
    };
    var $author$project$Api$Partner$PartnerProductDocument$Shared$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Api$Partner$PartnerProductDocument$All$url = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$PartnerProductDocument$Shared$url(shared);
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFieldsForEdit = function(doc) {
        return {
            Og: $author$project$Api$Partner$PartnerProductDocument$All$documentType(doc),
            xB: $author$project$Api$Partner$PartnerProductDocument$All$pdfName(doc),
            qJ: 0,
            Wv: $elm$core$Maybe$Nothing,
            $2: $author$project$Api$Partner$PartnerProductDocument$All$title(doc),
            aaT: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$PartnerProductDocument$All$url(doc))
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Created = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductDocument$One$PartnerProductDocument = 0;
    var $author$project$Api$Partner$PartnerProductDocument$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString = function(docType) {
        if (!docType) return 'pdf';
        else return 'url';
    };
    var $author$project$Api$Partner$PartnerProductDocument$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_document', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('document_type', $elm$json$Json$Encode$string($author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(params.Og))),
                _Utils_Tuple2('title', $elm$json$Json$Encode$string(params.$2)),
                _Utils_Tuple2('url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aaT)),
                _Utils_Tuple2('pdf', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.Wv))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProductDocument$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentsPath)));
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$createDocument = F2(function(apiClient, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var title = _v0.$2;
        var documentType = _v0.Og;
        var url = _v0.aaT;
        var pdf = _v0.Wv;
        return A3($author$project$Api$Partner$PartnerProductDocument$create, apiClient, {
            Og: documentType,
            Wv: A2($elm$core$Maybe$map, $elm$core$Tuple$second, pdf),
            $2: title,
            aaT: $author$project$Utils$Maybe$fromString(url)
        }, $author$project$Components$Partner$ManagePartnerProductDocuments$Created);
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Updated = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProductDocument$update = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner_product_document', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('title', $elm$json$Json$Encode$string(params.$2)), A2($elm$core$List$cons, _Utils_Tuple2('url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.aaT)), function() {
                var _v0 = params.Wv;
                if (!_v0.$) {
                    var pdf = _v0.a;
                    return _List_fromArray([
                        _Utils_Tuple2('pdf', $elm$json$Json$Encode$string(pdf))
                    ]);
                } else return _List_Nil;
            }()))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$PartnerProductDocument$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProductDocument$partnerProductDocumentPath(id))));
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$updateDocument = F3(function(apiClient, id, formFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var title = _v0.$2;
        var url = _v0.aaT;
        var pdf = _v0.Wv;
        return A4($author$project$Api$Partner$PartnerProductDocument$update, apiClient, id, {
            Wv: A2($elm$core$Maybe$map, $elm$core$Tuple$second, pdf),
            $2: title,
            aaT: $author$project$Utils$Maybe$fromString(url)
        }, $author$project$Components$Partner$ManagePartnerProductDocuments$Updated);
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$save = F3(function(apiClient, docId, formFields) {
        if (!docId.$) {
            var id_ = docId.a;
            return A3($author$project$Components$Partner$ManagePartnerProductDocuments$updateDocument, apiClient, id_, formFields);
        } else return A2($author$project$Components$Partner$ManagePartnerProductDocuments$createDocument, apiClient, formFields);
    });
    var $author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl = function(model) {
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Product__ActivationSettings)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]))))));
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            bu: response,
                            af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        bu: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    bu: $author$project$Api$Data$Loading,
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
                        $author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(newModel)
                    ])),
                    adu: 0,
                    zi: newModel,
                    at: _List_Nil
                };
            case 2:
                var subMsg = msg.a;
                var newModel = _Utils_update(model, {
                    bu: $author$project$Api$Data$Loading,
                    af_: A2($author$project$Api$Pagination$update, subMsg, model.af_)
                });
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
                        $author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(newModel)
                    ])),
                    adu: 0,
                    zi: newModel,
                    at: _List_Nil
                };
            case 3:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v3.a;
                var searchInputCmd = _v3.b;
                var searchInputEvent = _v3.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v4 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            bu: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, qModel),
                            $author$project$Components$Partner$ManagePartnerProductDocuments$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v4.a;
                var fetchCmd = _v4.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg, searchInputCmd),
                        fetchCmd
                    ])),
                    adu: 0,
                    zi: _Utils_update(newModel, {
                        sG: searchInput
                    }),
                    at: _List_Nil
                };
            case 4:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        E: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFields), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 5:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        E: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 6:
                var productDocument = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        E: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(productDocument), $author$project$Utils$Form$init($author$project$Components$Partner$ManagePartnerProductDocuments$initDocumentFieldsForEdit(productDocument)), $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 7:
                var field = msg.a;
                var _v6 = model.E;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var id = _v7.a;
                    var form = _v7.b;
                    var request = _v7.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManagePartnerProductDocuments$documentFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            E: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, request))
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 8:
                var files = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v8) {
                    var task = _v8.a;
                    var size = _v8.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated, $author$project$Components$Partner$ManagePartnerProductDocuments$File(size)), task);
                }, A2($elm$core$Maybe$map, function(f) {
                    return _Utils_Tuple2($elm$file$File$toUrl(f), $elm$file$File$size(f));
                }, $elm$core$List$head(files))));
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 9:
                var _v9 = model.E;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var productDocument = _v10.a;
                    var form = _v10.b;
                    var _v11 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManagePartnerProductDocuments$documentValidator, form);
                    if (!_v11.$) {
                        var _v12 = _v11.a;
                        var validatedForm = _v12.a;
                        var validFormFields = _v12.b;
                        var docId = A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDocument$All$id, productDocument);
                        return {
                            EQ: A3($author$project$Components$Partner$ManagePartnerProductDocuments$save, apiClient, docId, validFormFields),
                            adu: 0,
                            zi: _Utils_update(model, {
                                E: $elm$core$Maybe$Just(_Utils_Tuple3(productDocument, validatedForm, $author$project$Api$Data$Loading))
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var validatedForm = _v11.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 0,
                            zi: _Utils_update(model, {
                                E: $elm$core$Maybe$Just(_Utils_Tuple3(productDocument, validatedForm, $author$project$Api$Data$NotAsked))
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 10:
                var response = msg.a;
                var _v13 = model.E;
                if (!_v13.$) {
                    var _v14 = _v13.a;
                    var productDocument = _v14.a;
                    var form = _v14.b;
                    if (response.$ === 3) {
                        var newModel = _Utils_update(model, {
                            bu: $author$project$Api$Data$Loading,
                            E: $elm$core$Maybe$Nothing
                        });
                        return {
                            EQ: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
                            adu: 1,
                            zi: newModel,
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Document created successfully!')
                            ])
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            E: $elm$core$Maybe$Just(_Utils_Tuple3(productDocument, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 11:
                var response = msg.a;
                var _v16 = model.E;
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var productDocument = _v17.a;
                    var form = _v17.b;
                    if (response.$ === 3) {
                        var newModel = _Utils_update(model, {
                            bu: $author$project$Api$Data$Loading,
                            E: $elm$core$Maybe$Nothing
                        });
                        return {
                            EQ: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
                            adu: 2,
                            zi: newModel,
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Document updated successfully!')
                            ])
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            E: $elm$core$Maybe$Just(_Utils_Tuple3(productDocument, form, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 12:
                var doc = msg.a;
                return {
                    EQ: A3($author$project$Api$Partner$PartnerProductDocument$signedFileUrl, apiClient, $author$project$Api$Partner$PartnerProductDocument$All$id(doc), $author$project$Components$Partner$ManagePartnerProductDocuments$GotSignedPdfUrl),
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 13:
                var response = msg.a;
                if (response.$ === 3) {
                    var url = response.a;
                    return {
                        EQ: $author$project$Ports$Navigation$openInNewWindow(url),
                        adu: 0,
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 14:
                var productDocument = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        bY: $elm$core$Maybe$Just(_Utils_Tuple2(productDocument, $author$project$Api$Data$NotAsked))
                    }),
                    at: _List_Nil
                };
            case 15:
                var confirmed = msg.a;
                var _v20 = model.bY;
                if (!_v20.$) {
                    var _v21 = _v20.a;
                    var productDocument = _v21.a;
                    return confirmed ? {
                        EQ: A3($author$project$Api$Partner$PartnerProductDocument$delete, apiClient, $author$project$Api$Partner$PartnerProductDocument$All$id(productDocument), $author$project$Components$Partner$ManagePartnerProductDocuments$Deleted),
                        adu: 0,
                        zi: _Utils_update(model, {
                            bY: $elm$core$Maybe$Just(_Utils_Tuple2(productDocument, $author$project$Api$Data$Loading))
                        }),
                        at: _List_Nil
                    } : {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            bY: $elm$core$Maybe$Nothing
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                var _v22 = model.bY;
                if (!_v22.$) {
                    var _v23 = _v22.a;
                    var productDocument = _v23.a;
                    if (response.$ === 3) {
                        var newModel = _Utils_update(model, {
                            bY: $elm$core$Maybe$Nothing,
                            bu: $author$project$Api$Data$Loading
                        });
                        return {
                            EQ: A2($author$project$Components$Partner$ManagePartnerProductDocuments$fetchDocuments, apiClient, newModel),
                            adu: 3,
                            zi: newModel,
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Document deleted successfully!')
                            ])
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            bY: $elm$core$Maybe$Just(_Utils_Tuple2(productDocument, response))
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotDeleted = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Precondition$Type_ = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Precondition$Url = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Precondition$One$Precondition = 0;
    var $author$project$Api$Partner$PartnerProduct$Precondition$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$Marketplace$Product$Precondition$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$always(0)));
    var $author$project$Api$Common$Marketplace$Product$Precondition$Type$toString = function(t) {
        if (!t) return 'external_install';
        else return 'external_account';
    };
    var $author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields = function(permittedFields) {
        var encodedFields = A3($elm$core$List$foldl, F2(function(field, acc) {
            if (!field.$) {
                var t = field.a;
                return A2($elm$core$List$cons, _Utils_Tuple2('type', $elm$json$Json$Encode$string($author$project$Api$Common$Marketplace$Product$Precondition$Type$toString(t))), acc);
            } else {
                var u = field.a;
                return A2($elm$core$List$cons, _Utils_Tuple2('url', $elm$json$Json$Encode$string(u)), acc);
            }
        }), _List_Nil, permittedFields);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('precondition', $elm$json$Json$Encode$object(encodedFields))
        ]));
    };
    var $author$project$Api$Partner$PartnerProduct$Precondition$create = F4(function(apiClient, productId, permittedFields, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProduct$Precondition$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields(permittedFields), $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId))));
    });
    var $author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath = F2(function(productId, preconditionId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            preconditionId
        ]), $author$project$Api$Partner$PartnerProduct$Precondition$preconditionsPath(productId));
    });
    var $author$project$Api$Partner$PartnerProduct$Precondition$destroy = F4(function(apiClient, productId, preconditionId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath, productId, preconditionId)));
    });
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$emptyForm = {
        ah5: 0,
        aaT: ''
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$formFromPrecondition = function(precondition) {
        return {
            ah5: $author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition),
            aaT: $author$project$Api$Common$Marketplace$Product$Precondition$url(precondition)
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Precondition$update = F5(function(apiClient, productId, preconditionId, permittedFields, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$PartnerProduct$Precondition$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Partner$PartnerProduct$Precondition$encodePermittedFields(permittedFields), $author$project$Api$Data$requestTo(A2($author$project$Api$Partner$PartnerProduct$Precondition$preconditionPath, productId, preconditionId))));
    });
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$updateForm = F2(function(field, form) {
        if (!field.$) {
            var t = field.a;
            return _Utils_update(form, {
                ah5: t
            });
        } else {
            var string = field.a;
            return _Utils_update(form, {
                aaT: string
            });
        }
    });
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Xf: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    ai: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Components$Partner$ManagePartnerProductPreconditions$emptyForm, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var precondition = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ai: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(precondition), $author$project$Components$Partner$ManagePartnerProductPreconditions$formFromPrecondition(precondition), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    ai: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var field = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    ai: A2($elm$core$Maybe$map, function(_v2) {
                        var p = _v2.a;
                        var f = _v2.b;
                        var r = _v2.c;
                        return _Utils_Tuple3(p, A2($author$project$Components$Partner$ManagePartnerProductPreconditions$updateForm, field, f), r);
                    }, model.ai)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var maybeId = msg.a;
                var _v3 = model.ai;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var maybePrecondition = _v4.a;
                    var form = _v4.b;
                    if ($elm$core$String$isEmpty($elm$core$String$trim(form.aaT))) return _Utils_Tuple3(_Utils_update(model, {
                        ai: $elm$core$Maybe$Just(_Utils_Tuple3(maybePrecondition, form, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 1, 'URL is required.')
                    ]));
                    else {
                        var permittedFields = _List_fromArray([
                            $author$project$Api$Partner$PartnerProduct$Precondition$Type_(form.ah5),
                            $author$project$Api$Partner$PartnerProduct$Precondition$Url(form.aaT)
                        ]);
                        var cmd = function() {
                            if (!maybeId.$) {
                                var id = maybeId.a;
                                return A5($author$project$Api$Partner$PartnerProduct$Precondition$update, apiClient, model.G6, id, permittedFields, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved);
                            } else return A4($author$project$Api$Partner$PartnerProduct$Precondition$create, apiClient, model.G6, permittedFields, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotSaved);
                        }();
                        return _Utils_Tuple3(_Utils_update(model, {
                            ai: $elm$core$Maybe$Just(_Utils_Tuple3(maybePrecondition, form, $author$project$Api$Data$Loading))
                        }), cmd, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    ai: $elm$core$Maybe$Nothing,
                    Xf: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, model.G6, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Precondition saved successfully!')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    ai: A2($elm$core$Maybe$map, function(_v7) {
                        var p = _v7.a;
                        var f = _v7.b;
                        return _Utils_Tuple3(p, f, response);
                    }, model.ai)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var precondition = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    b$: $elm$core$Maybe$Just(_Utils_Tuple2(precondition, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var confirmed = msg.a;
                var _v8 = model.b$;
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var precondition = _v9.a;
                    return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                        b$: $elm$core$Maybe$Just(_Utils_Tuple2(precondition, $author$project$Api$Data$Loading))
                    }), A4($author$project$Api$Partner$PartnerProduct$Precondition$destroy, apiClient, model.G6, $author$project$Api$Common$Marketplace$Product$Precondition$id(precondition), $author$project$Components$Partner$ManagePartnerProductPreconditions$GotDeleted), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        b$: $elm$core$Maybe$Nothing
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    b$: $elm$core$Maybe$Nothing,
                    Xf: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Partner$PartnerProduct$Precondition$list, apiClient, model.G6, $author$project$Components$Partner$ManagePartnerProductPreconditions$GotPreconditions), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Precondition deleted successfully!')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    b$: A2($elm$core$Maybe$map, function(_v11) {
                        var p = _v11.a;
                        return _Utils_Tuple2(p, response);
                    }, model.b$)
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Partner$Product$ActivationSettings$PostActivationRedirectUrlValidation = 1;
    var $author$project$Pages$Partner$Product$ActivationSettings$validatePostActivationRedirectUrl = function(fields) {
        var _v0 = fields.WY;
        if (_v0.$ === 1) return _List_Nil;
        else {
            var url = _v0.a;
            return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray([
                _Utils_Tuple2(1, 'URL must start with http:// or https://')
            ]) : _List_Nil;
        }
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$RedirectUrlValidation = 0;
    var $author$project$Pages$Partner$Product$ActivationSettings$validateRedirectUrl = function(fields) {
        var _v0 = _Utils_Tuple2(fields.JO !== 'manual', fields.Yo);
        if (_v0.a) {
            if (_v0.b.$ === 1) {
                var _v1 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(0, 'Redirect URL is required')
                ]);
            } else {
                var url = _v0.b.a;
                return $author$project$Utils$Validate$isInvalidUrl(url) ? _List_fromArray([
                    _Utils_Tuple2(0, 'URL must start with http:// or https://')
                ]) : _List_Nil;
            }
        } else return _List_Nil;
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Partner$Product$ActivationSettings$validateRedirectUrl),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$Partner$Product$ActivationSettings$validatePostActivationRedirectUrl)
    ]));
    var $author$project$Api$Partner$Partner$PostActivationRedirectUrl = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$toPermittedFields = function(fields) {
        return A2($elm$core$List$cons, $author$project$Api$Partner$Partner$AuthType(fields.JO), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$RedirectUrl(fields.Yo), fields.JO === 'automatic_headless' ? _List_fromArray([
            $author$project$Api$Partner$Partner$PostActivationRedirectUrl(fields.WY)
        ]) : _List_Nil));
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$validate = function(model) {
        var _v0 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Product$ActivationSettings$formFieldsValidator, model.PU);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var validFormFields = _v1.b;
            var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
            return $elm$core$Result$Ok($author$project$Pages$Partner$Product$ActivationSettings$toPermittedFields(fields));
        } else {
            var validatedForm = _v0.a;
            return $elm$core$Result$Err(validatedForm);
        }
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Product$ActivationSettings$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var _v1 = $author$project$Pages$Partner$Product$ActivationSettings$validate(model);
                if (!_v1.$) {
                    var permittedFields = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        o2: $author$project$Api$Data$Loading
                    }), A3($author$project$Api$Partner$Partner$update, model.Ej, permittedFields, $author$project$Pages$Partner$Product$ActivationSettings$GotUpdatedPartner), _List_Nil);
                } else {
                    var updatedForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: updatedForm,
                        o2: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var partner = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        VW: partner,
                        o2: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                        $author$project$OutMsg$RefreshPartner
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    o2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var documentsMsg = msg.a;
                var result = A3($author$project$Components$Partner$ManagePartnerProductDocuments$update, model.Ej, documentsMsg, model.i6);
                return _Utils_Tuple3(_Utils_update(model, {
                    i6: result.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg, result.EQ), result.at);
            default:
                var preconditionsMsg = msg.a;
                var _v3 = A3($author$project$Components$Partner$ManagePartnerProductPreconditions$update, model.Ej, preconditionsMsg, model.i8);
                var preconditionsModel = _v3.a;
                var preconditionsCmd = _v3.b;
                var outMsgs = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    i8: preconditionsModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg, preconditionsCmd), outMsgs);
        }
    });
    var $author$project$Pages$Partner$Product$ActivationSettings$AuthType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$PostActivationRedirectUrl = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$RedirectUrl = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$Save = {
        $: 1
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentDeleteConfirmModal = function(model) {
        var _v0 = model.bY;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var request = _v1.b;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManagePartnerProductDocuments$DeleteConfirmationClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('delete'),
                $author$project$Components$HiConfirm$noun('document'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentType = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$FileUploaded = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Save = {
        $: 9
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Title = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Url = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$documentTypeOptions = A2($elm$core$List$map, function(_v0) {
        var docType = _v0.a;
        var label = _v0.b;
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(docType)), label);
    }, _List_fromArray([
        _Utils_Tuple2(1, 'Link to URL'),
        _Utils_Tuple2(0, 'Upload PDF')
    ]));
    var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentEditModal = function(_v0) {
        var productDocument = _v0.E;
        if (!productDocument.$) {
            var _v2 = productDocument.a;
            var item = _v2.a;
            var form = _v2.b;
            var request = _v2.c;
            var fields = $author$project$Utils$Form$fields(form);
            var updateWarning = function() {
                var _v7 = fields.Og;
                if (!_v7) return 'Uploading a new PDF';
                else return 'Updating the URL';
            }() + ' will invalidate any existing document agreements.';
            var modalConfig = {
                QG: $elm$core$Maybe$Just('Attach a document or link to your product listing.'),
                aeI: 'Document',
                Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
                TR: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerProductDocument$All$id, item),
                TS: $elm$core$Maybe$Just(updateWarning),
                Vl: $author$project$Components$Partner$ManagePartnerProductDocuments$CancelAdd,
                Vn: $elm$core$Basics$always($author$project$Components$Partner$ManagePartnerProductDocuments$Save)
            };
            return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Title'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.$2),
                    $author$project$Ui$Form$Input$placeholder('Document title'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDocuments$Title, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ])), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Type')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Partner$PartnerProductDocument$Shared$documentTypeToString(fields.Og))),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated, $author$project$Components$Partner$ManagePartnerProductDocuments$DocumentType)),
                    $author$project$Ui$Form$Select$disabled(!_Utils_eq(item, $elm$core$Maybe$Nothing))
                ]), $author$project$Components$Partner$ManagePartnerProductDocuments$documentTypeOptions)
            ])), function() {
                var _v3 = fields.Og;
                if (_v3 === 1) return _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$label('URL'),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(fields.aaT),
                            $author$project$Ui$Form$Input$placeholder('https://example.com/docs'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeR, $author$project$Components$Partner$ManagePartnerProductDocuments$Url, $author$project$Components$Partner$ManagePartnerProductDocuments$FormUpdated)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                        ]))
                    ]))
                ]);
                else return _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$label('PDF File'),
                        $author$project$Ui$Form$Group$required(_Utils_eq(item, $elm$core$Maybe$Nothing))
                    ]), _List_fromArray([
                        $author$project$Ui$Form$File$view(_List_fromArray([
                            $author$project$Ui$Form$File$accept(2),
                            $author$project$Ui$Form$File$onInput($author$project$Components$Partner$ManagePartnerProductDocuments$FileUploaded)
                        ])),
                        function() {
                            var _v4 = fields.Wv;
                            if (!_v4.$) return A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('File selected.')
                            ]));
                            else {
                                if (!item.$) {
                                    var doc = item.a;
                                    var _v6 = $author$project$Api$Partner$PartnerProductDocument$All$pdfName(doc);
                                    if (!_v6.$) return A2($author$project$Ui$Typography$p, _List_fromArray([
                                        $author$project$Ui$Typography$muted
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('A file is already uploaded. Select a new file to replace it.')
                                    ]));
                                    else return $author$project$Utils$Html$empty;
                                } else return $author$project$Utils$Html$empty;
                            }
                        }(),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, form))
                    ]))
                ]);
            }())));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$modal = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentDeleteConfirmModal(model),
            $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentEditModal(model)
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewDeleteConfirmModal = function(model) {
        var _v0 = model.b$;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var request = _v1.b;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManagePartnerProductPreconditions$DeleteConfirmationClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('delete'),
                $author$project$Components$HiConfirm$noun('precondition'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$Save = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$Type_ = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$Url = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewFormModal = function(model) {
        var _v0 = model.ai;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var maybePrecondition = _v1.a;
            var form = _v1.b;
            var request = _v1.c;
            var modalConfig = {
                QG: $elm$core$Maybe$Nothing,
                aeI: 'Precondition',
                Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
                TR: A2($elm$core$Maybe$map, $author$project$Api$Common$Marketplace$Product$Precondition$id, maybePrecondition),
                TS: $elm$core$Maybe$Nothing,
                Vl: $author$project$Components$Partner$ManagePartnerProductPreconditions$CloseForm,
                Vn: $author$project$Components$Partner$ManagePartnerProductPreconditions$Save
            };
            return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Type'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Precondition$Type$toString(form.ah5))),
                        $author$project$Ui$Form$Select$onChange(function(val) {
                            if (val === 'external_account') return $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm($author$project$Components$Partner$ManagePartnerProductPreconditions$Type_(1));
                            else return $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm($author$project$Components$Partner$ManagePartnerProductPreconditions$Type_(0));
                        })
                    ]), _List_fromArray([
                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('external_install'), 'External Install'),
                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('external_account'), 'External Account')
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('URL'),
                    $author$project$Ui$Form$Group$required(true)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(form.aaT),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManagePartnerProductPreconditions$UpdateForm, $author$project$Components$Partner$ManagePartnerProductPreconditions$Url))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$modal = function(_v0) {
        var model = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Components$Partner$ManagePartnerProductPreconditions$viewDeleteConfirmModal(model),
            $author$project$Components$Partner$ManagePartnerProductPreconditions$viewFormModal(model)
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Add = {
        $: 4
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$PaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$SortTable = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'title', true, 'Name'),
        A3($author$project$Api$Column$init, 'document_type', true, 'Type'),
        A3($author$project$Api$Column$init, 'content', false, 'Content'),
        A3($author$project$Api$Column$init, 'actions', false, '')
    ]);
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Delete = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$Edit = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$OpenPdf = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentRow = function(doc) {
        var docType = $author$project$Api$Partner$PartnerProductDocument$All$documentType(doc);
        var typeLabel = function() {
            if (!docType) return 'PDF';
            else return 'URL';
        }();
        var contentCell = function() {
            if (docType === 1) {
                var _v1 = $author$project$Api$Partner$PartnerProductDocument$All$url(doc);
                if (!_v1.$) {
                    var url = _v1.a;
                    return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$a, _List_fromArray([
                            $elm$html$Html$Attributes$href(url),
                            $elm$html$Html$Attributes$target('_blank')
                        ]), _List_fromArray([
                            $elm$html$Html$text(url)
                        ]))
                    ]));
                } else return A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil);
            } else return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Open PDF'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDocuments$OpenPdf(doc))
                ]), _List_fromArray([
                    $elm$html$Html$text('Open PDF')
                ]))
            ]));
        }();
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$PartnerProductDocument$All$title(doc))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(typeLabel)
            ])),
            contentCell,
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit document'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDocuments$Edit(doc))
                ]), _List_Nil),
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete document'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDocuments$Delete(doc))
                ]), _List_Nil)
            ]))
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentTable = function(model) {
        var _v0 = function() {
            var _v1 = model.bu;
            if (_v1.$ === 3) {
                var docs = _v1.a;
                return _Utils_Tuple2(false, docs);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var documents = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('No documents added yet.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Partner$ManagePartnerProductDocuments$SortTable)), $author$project$Components$Partner$ManagePartnerProductDocuments$columns), A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentRow, documents), _List_Nil);
    };
    var $author$project$Components$Partner$ManagePartnerProductDocuments$view = function(_v0) {
        var model = _v0;
        var loading = _Utils_eq(model.bu, $author$project$Api$Data$Loading);
        return _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        $elm$html$Html$text('Documents')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add document'
                        }, _List_fromArray([
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                            $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductDocuments$Add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add Document')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Partner$ManagePartnerProductDocuments$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                        $author$project$Ui$SearchInput$placeholder('Filter by title')
                    ]), model.sG))
                ])),
                $author$project$Components$Partner$ManagePartnerProductDocuments$viewDocumentTable(model),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Partner$ManagePartnerProductDocuments$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(loading)
                    ]), model.af_))
                ]))
            ]))
        ]);
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$OpenAdd = {
        $: 1
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$Delete = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$OpenEdit = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Element$gap = $author$project$Ui$Element$Gap(1);
    var $author$project$Ui$Alignment$Self = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Alignment$selfCenter = $author$project$Ui$Alignment$Self(1);
    var $author$project$Ui$Element$selfCenter = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$selfCenter);
    var $author$project$Ui$Well$FullWidth = {
        $: 4
    };
    var $author$project$Ui$Well$wFull = $author$project$Ui$Well$FullWidth;
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$viewPreview = function(precondition) {
        var l = $author$project$Api$Common$Marketplace$Product$Precondition$Type$labels($author$project$Api$Common$Marketplace$Product$Precondition$type_(precondition));
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$span(5)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                A2($author$project$Ui$Well$view, _List_fromArray([
                    $author$project$Ui$Well$wFull
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$flexCol,
                        $author$project$Ui$Element$gap
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(l.Er),
                            A3($author$project$Ui$Link$externalHref, $author$project$Api$Common$Marketplace$Product$Precondition$url(precondition), _List_Nil, _List_fromArray([
                                $elm$html$Html$text(l.Gb)
                            ])),
                            $elm$html$Html$text(l.Ed)
                        ])),
                        A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                            $author$project$Ui$Form$Checkbox$disabled(true)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textMuted
                            ]), _List_fromArray([
                                $elm$html$Html$text(l.EN)
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$selfCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit precondition'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductPreconditions$OpenEdit(precondition)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete precondition'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductPreconditions$Delete(precondition))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Remove')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Partner$ManagePartnerProductPreconditions$view = function(_v0) {
        var model = _v0;
        return _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Preconditions')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    function() {
                        var _v1 = model.Xf;
                        if (_v1.$ === 3) {
                            if (!_v1.a.b) return A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textMuted
                            ]), _List_fromArray([
                                $elm$html$Html$text('No preconditions added yet.')
                            ]));
                            else {
                                var preconditions = _v1.a;
                                return A2($author$project$Ui$Grid$row, _List_Nil, A2($elm$core$List$map, $author$project$Components$Partner$ManagePartnerProductPreconditions$viewPreview, preconditions));
                            }
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mt4
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add precondition'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
                            $author$project$Ui$Button$onClick($author$project$Components$Partner$ManagePartnerProductPreconditions$OpenAdd)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add Precondition')
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$view = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg, $author$project$Components$Partner$ManagePartnerProductDocuments$modal(model.i6)),
                A2($elm$html$Html$map, $author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg, $author$project$Components$Partner$ManagePartnerProductPreconditions$modal(model.i8)),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Product$ActivationSettings$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Activation Settings')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label('Activation Type')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$gap4
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                                        $author$project$Ui$Form$Radio$card,
                                        $author$project$Ui$Form$Radio$value(fields.JO === 'automatic_headless'),
                                        $author$project$Ui$Form$Radio$onCheck(function(_v0) {
                                            return $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated($author$project$Pages$Partner$Product$ActivationSettings$AuthType('automatic_headless'));
                                        })
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Headless')
                                        ])),
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$helpBlock
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('We post information about a new practice to your server, you can provision or link and them complete the activation. We can redirect the user to a specific location once completed such as an embedded app page within the Hint app.')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                                        $author$project$Ui$Form$Radio$card,
                                        $author$project$Ui$Form$Radio$value(fields.JO === 'automatic_redirect'),
                                        $author$project$Ui$Form$Radio$onCheck(function(_v1) {
                                            return $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated($author$project$Pages$Partner$Product$ActivationSettings$AuthType('automatic_redirect'));
                                        })
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Automatic')
                                        ])),
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$helpBlock
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('A user will be directed to your app\'s sign in or sign up page with a connection code in the url to use with our api to complete the activation process.')
                                        ]))
                                    ])),
                                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                                        $author$project$Ui$Form$Radio$card,
                                        $author$project$Ui$Form$Radio$value(fields.JO === 'manual'),
                                        $author$project$Ui$Form$Radio$onCheck(function(_v2) {
                                            return $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated($author$project$Pages$Partner$Product$ActivationSettings$AuthType('manual'));
                                        }),
                                        $author$project$Ui$Form$Radio$disabled(true)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Manual (Not Recommended)')
                                        ])),
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$helpBlock
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('When installed the user is shown an authorization code they provide to your team. You exchange that via the api to complete the activation process and acquire a practice api key.')
                                        ]))
                                    ]))
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label(fields.JO === 'automatic_headless' ? 'Connect URL' : 'Redirect URL'),
                                $author$project$Ui$Form$Group$required(fields.JO !== 'manual')
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.Yo)),
                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated, $author$project$Pages$Partner$Product$ActivationSettings$RedirectUrl)),
                                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU)),
                                    $author$project$Ui$Form$Input$disabled(fields.JO === 'manual'),
                                    $author$project$Ui$Form$Input$placeholder('https://some.example.com/signup?code=')
                                ])),
                                A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$helpBlock
                                ]), _List_fromArray([
                                    $elm$html$Html$text('We\'ll append an authorization code to this url, like this: '),
                                    A2($author$project$Ui$Typography$b, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'https://some.example.com/signup?code=', fields.Yo) + '2jK3jlOOOpejk7xnKEl')
                                    ]))
                                ]))
                            ])),
                            fields.JO === 'automatic_headless' ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(2),
                                $author$project$Ui$Form$Group$inputSpan(10),
                                $author$project$Ui$Form$Group$label('Post Activation Redirect URL')
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.WY)),
                                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$ActivationSettings$FormUpdated, $author$project$Pages$Partner$Product$ActivationSettings$PostActivationRedirectUrl)),
                                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                                ]))
                            ])) : $author$project$Utils$Html$empty
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Save partner changes'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(_Utils_eq(model.o2, $author$project$Api$Data$Loading))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Save')
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt4
                ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$Product$ActivationSettings$DocumentsMsg), $author$project$Components$Partner$ManagePartnerProductDocuments$view(model.i6))),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt4
                ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$Product$ActivationSettings$PreconditionsMsg), $author$project$Components$Partner$ManagePartnerProductPreconditions$view(model.i8)))
            ]),
            $2: 'Partner | Product | ActivationSettings'
        };
    };
    var $author$project$Pages$Partner$Product$ActivationSettings$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Product$ActivationSettings$init,
        aeR: $author$project$Pages$Partner$Product$ActivationSettings$load,
        ag3: $author$project$Pages$Partner$Product$ActivationSettings$save,
        ahE: $author$project$Pages$Partner$Product$ActivationSettings$subscriptions,
        aaO: $author$project$Pages$Partner$Product$ActivationSettings$update,
        aid: $author$project$Pages$Partner$Product$ActivationSettings$view
    });
    var $author$project$Pages$Partner$Product$AppSettings$GotApp = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$NavMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$TypeDropdownMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Partner$AppAnchors$init = F2(function(isHintAdmin, anchors) {
        var _v0 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
        var navModel = _v0.a;
        var navCmd = _v0.b;
        return _Utils_Tuple2({
            Z: $elm$core$Maybe$Nothing,
            hx: $author$project$Api$Data$NotAsked,
            Eg: anchors,
            qi: $author$project$Api$Data$NotAsked,
            lT: false,
            F3: isHintAdmin,
            nb: navModel,
            bg: A2($elm$core$Maybe$map, $author$project$Api$Partner$AppAnchor$id, $elm$core$List$head(anchors)),
            oX: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'anchor-type-dropdown',
                ahX: $author$project$Components$Partner$AppAnchors$TypeDropdownMsg
            }))
        }, navCmd);
    });
    var $author$project$Api$Partner$App$appPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'app'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$App$App = $elm$core$Basics$identity;
    var $author$project$Api$Partner$App$Record = F5(function(name, status, handshakeUrl, partnerRoles, anchors) {
        return {
            Eg: anchors,
            Qi: handshakeUrl,
            zr: name,
            V1: partnerRoles,
            ahy: status
        };
    });
    var $author$project$Api$Partner$AppAnchor$AppAnchor = $elm$core$Basics$identity;
    var $author$project$Api$Partner$AppAnchor$Record = function(id) {
        return function(type_) {
            return function(sourceUrl) {
                return function(interactionTitle) {
                    return function(interactionDescription) {
                        return function(interactionType) {
                            return function(corePageIconUrl) {
                                return function(corePageIconLabel) {
                                    return function(corePageAutoAdjustHeight) {
                                        return function(settingsLabel) {
                                            return {
                                                Mb: corePageAutoAdjustHeight,
                                                Mc: corePageIconLabel,
                                                Md: corePageIconUrl,
                                                aef: id,
                                                Ru: interactionDescription,
                                                Rv: interactionTitle,
                                                Rw: interactionType,
                                                Z0: settingsLabel,
                                                _H: sourceUrl,
                                                ah5: type_
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Partner$AppAnchor$ClinicalInteraction = 1;
    var $author$project$Api$Partner$AppAnchor$CorePage = 0;
    var $author$project$Api$Partner$AppAnchor$Settings = 2;
    var $author$project$Api$Partner$AppAnchor$decodeAnchorType = A2($elm$json$Json$Decode$andThen, function(typeString) {
        switch(typeString){
            case 'core_page':
                return $elm$json$Json$Decode$succeed(0);
            case 'clinical_interaction':
                return $elm$json$Json$Decode$succeed(1);
            case 'settings':
                return $elm$json$Json$Decode$succeed(2);
            default:
                return $elm$json$Json$Decode$fail('Invalid anchor type ' + typeString);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Partner$AppAnchor$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'settings_label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'core_page_auto_adjust_height', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'core_page_icon_label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'core_page_icon_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'interaction_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'interaction_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'interaction_title', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$Partner$AppAnchor$decodeAnchorType, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$AppAnchor$Record))))))))))), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$App$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'anchors', $elm$json$Json$Decode$list($author$project$Api$Partner$AppAnchor$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner_roles', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'handshake_url', $elm$json$Json$Decode$string, '', A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$App$Record)))))), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$App$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Partner$App$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath));
    });
    var $author$project$Pages$Partner$Product$AppSettings$init = F4(function(_v0, partner, shared, _v1) {
        var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
        return _Utils_Tuple2({
            Ej: shared.Ej,
            cA: $author$project$Api$Data$Loading,
            hy: A2($author$project$Components$Partner$AppAnchors$init, isHintAdmin, _List_Nil).a,
            a6: $elm$core$Maybe$Nothing,
            F3: isHintAdmin,
            VW: partner,
            tj: $author$project$Ui$TagsInput$init('partner-roles'),
            tn: false,
            oM: $author$project$Api$Data$NotAsked,
            o2: $author$project$Api$Data$NotAsked
        }, A2($author$project$Api$Partner$App$retrieve, shared.Ej, $author$project$Pages$Partner$Product$AppSettings$GotApp));
    });
    var $author$project$Pages$Partner$Product$AppSettings$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Product$AppSettings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$EditModalClosed = {
        $: 4
    };
    var $author$project$Pages$Partner$Product$AppSettings$TestHandshakeModalClosed = {
        $: 9
    };
    var $author$project$Components$Partner$AppAnchors$AnchorModalClosed = {
        $: 7
    };
    var $author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed = {
        $: 4
    };
    var $author$project$Components$Partner$AppAnchors$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$AppAnchors$AnchorModalClosed),
            $author$project$Ui$Nav$subscriptions(model.nb),
            $author$project$Ui$Dropdown$subscriptions(model.oX),
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed)
        ]));
    };
    var $author$project$Pages$Partner$Product$AppSettings$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg, $author$project$Components$Partner$AppAnchors$subscriptions(model.hy)),
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Product$AppSettings$TestHandshakeModalClosed),
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Product$AppSettings$EditModalClosed)
        ]));
    };
    var $author$project$Pages$Partner$Product$AppSettings$GotCreatedApp = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$GotTestHandshakeResult = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$GotUpdatedApp = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Partner$App$HandshakeUrl = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$App$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$App$PartnerRoles = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$PartnerRoles = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$TagsInputMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Partner$App$anchors = function(_v0) {
        var record = _v0;
        return record.Eg;
    };
    var $author$project$Api$Partner$App$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$App$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath));
    });
    var $author$project$Pages$Partner$Product$AppSettings$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var name = field.a;
                return _Utils_update(fields, {
                    zr: name
                });
            case 1:
                var url = field.a;
                return _Utils_update(fields, {
                    Qi: url
                });
            default:
                var roles = field.a;
                return _Utils_update(fields, {
                    V1: roles
                });
        }
    });
    var $author$project$Api$Partner$App$handshakeTest = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'handshake_test'
        ]), $author$project$Api$Partner$App$appPath)));
    });
    var $author$project$Api$Partner$App$handshakeUrl = function(_v0) {
        var record = _v0;
        return record.Qi;
    };
    var $author$project$Api$Partner$App$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Partner$App$partnerRoles = function(_v0) {
        var record = _v0;
        return record.V1;
    };
    var $author$project$Api$Partner$App$encodePermittedFields = function(permittedFields) {
        var encodedFields = A3($elm$core$List$foldl, F2(function(field, acc) {
            switch(field.$){
                case 0:
                    var name_ = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('name', $elm$json$Json$Encode$string(name_)), acc);
                case 1:
                    var maybeUrl = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('handshake_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, maybeUrl)), acc);
                default:
                    var roles = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('partner_roles', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, roles)), acc);
            }
        }), _List_Nil, permittedFields);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('app', $elm$json$Json$Encode$object(encodedFields))
        ]));
    };
    var $author$project$Api$Partner$App$update = F3(function(apiClient, permittedFields, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Partner$App$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Partner$App$encodePermittedFields(permittedFields), $author$project$Api$Data$requestTo($author$project$Api$Partner$App$appPath)));
    });
    var $author$project$Components$Partner$AppAnchors$AnchorFormUpdated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$AnchorType = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$CorePageAutoAdjustHeight = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$CorePageIcon = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$CorePageIcon = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$AppAnchor$CorePageIconLabel = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$GotAnchorResult = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$GotDeletedAnchor = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$InteractionDescription = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$InteractionTitle = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$InteractionType = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$SettingsLabel = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$SourceUrl = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$Type = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$CorePageCustomization = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$General = 0;
    var $author$project$Components$Partner$AppAnchors$SettingsCustomization = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$initCustomizationFromType = function(type_) {
        switch(type_){
            case 0:
                return $author$project$Components$Partner$AppAnchors$CorePageCustomization({
                    Mb: true,
                    Mc: $elm$core$Maybe$Nothing,
                    wW: 0,
                    Md: $elm$core$Maybe$Nothing,
                    w1: $elm$core$Maybe$Nothing
                });
            case 1:
                return $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization({
                    Ru: '',
                    Rv: '',
                    Rw: 0
                });
            default:
                return $author$project$Components$Partner$AppAnchors$SettingsCustomization({
                    Z0: $elm$core$Maybe$Nothing
                });
        }
    };
    var $author$project$Components$Partner$AppAnchors$Lab = 1;
    var $author$project$Components$Partner$AppAnchors$interactionTypeFromString = function(s) {
        switch(s){
            case 'general':
                return $elm$core$Maybe$Just(0);
            case 'lab':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var type_ = field.a;
                return _Utils_update(fields, {
                    s: $author$project$Components$Partner$AppAnchors$initCustomizationFromType(type_),
                    ah5: type_
                });
            case 1:
                var url = field.a;
                return _Utils_update(fields, {
                    _H: url
                });
            case 5:
                var _int = field.a;
                var string = field.b;
                var _v1 = fields.s;
                switch(_v1.$){
                    case 0:
                        var config = _v1.a;
                        return _Utils_update(fields, {
                            s: $author$project$Components$Partner$AppAnchors$CorePageCustomization(_Utils_update(config, {
                                wW: _int,
                                Md: $elm$core$Maybe$Just(string),
                                w1: $elm$core$Maybe$Just(string)
                            }))
                        });
                    case 1:
                        return fields;
                    default:
                        return fields;
                }
            case 6:
                var label = field.a;
                var _v2 = fields.s;
                switch(_v2.$){
                    case 0:
                        var config = _v2.a;
                        return _Utils_update(fields, {
                            s: $author$project$Components$Partner$AppAnchors$CorePageCustomization(_Utils_update(config, {
                                Mc: $author$project$Utils$String$toMaybe(label)
                            }))
                        });
                    case 1:
                        return fields;
                    default:
                        return fields;
                }
            case 7:
                var autoAdjust = field.a;
                var _v3 = fields.s;
                switch(_v3.$){
                    case 0:
                        var config = _v3.a;
                        return _Utils_update(fields, {
                            s: $author$project$Components$Partner$AppAnchors$CorePageCustomization(_Utils_update(config, {
                                Mb: autoAdjust
                            }))
                        });
                    case 1:
                        return fields;
                    default:
                        return fields;
                }
            case 2:
                var title = field.a;
                var _v4 = fields.s;
                switch(_v4.$){
                    case 1:
                        var config = _v4.a;
                        return _Utils_update(fields, {
                            s: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(_Utils_update(config, {
                                Rv: title
                            }))
                        });
                    case 0:
                        return fields;
                    default:
                        return fields;
                }
            case 3:
                var description = field.a;
                var _v5 = fields.s;
                switch(_v5.$){
                    case 1:
                        var config = _v5.a;
                        return _Utils_update(fields, {
                            s: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(_Utils_update(config, {
                                Ru: description
                            }))
                        });
                    case 0:
                        return fields;
                    default:
                        return fields;
                }
            case 4:
                var string = field.a;
                var _v6 = fields.s;
                switch(_v6.$){
                    case 1:
                        var config = _v6.a;
                        return _Utils_update(fields, {
                            s: $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization(_Utils_update(config, {
                                Rw: A2($elm$core$Maybe$withDefault, 0, $author$project$Components$Partner$AppAnchors$interactionTypeFromString(string))
                            }))
                        });
                    case 0:
                        return fields;
                    default:
                        return fields;
                }
            default:
                var label = field.a;
                var _v7 = fields.s;
                switch(_v7.$){
                    case 2:
                        var config = _v7.a;
                        return _Utils_update(fields, {
                            s: $author$project$Components$Partner$AppAnchors$SettingsCustomization(_Utils_update(config, {
                                Z0: $author$project$Utils$String$toMaybe(label)
                            }))
                        });
                    case 0:
                        return fields;
                    default:
                        return fields;
                }
        }
    });
    var $author$project$Api$Partner$AppAnchor$appAnchorsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'app',
        'anchors'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$AppAnchor$typeToValue = function(anchorType) {
        switch(anchorType){
            case 0:
                return 'core_page';
            case 1:
                return 'clinical_interaction';
            default:
                return 'settings';
        }
    };
    var $author$project$Api$Partner$AppAnchor$encodePermittedFields = function(permittedFields) {
        var encodedFields = A3($elm$core$List$foldl, F2(function(field, acc) {
            switch(field.$){
                case 0:
                    var anchorType = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('type', $elm$json$Json$Encode$string($author$project$Api$Partner$AppAnchor$typeToValue(anchorType))), acc);
                case 1:
                    var url = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('source_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, url)), acc);
                case 3:
                    var description = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('interaction_description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, description)), acc);
                case 2:
                    var title = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('interaction_title', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, title)), acc);
                case 4:
                    var interactionType_ = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('interaction_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, interactionType_)), acc);
                case 5:
                    var icon = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('core_page_icon', $elm$json$Json$Encode$string(icon)), acc);
                case 6:
                    var label = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('core_page_icon_label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, label)), acc);
                case 7:
                    var autoAdjustHeight = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('core_page_auto_adjust_height', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, autoAdjustHeight)), acc);
                default:
                    var label = field.a;
                    return A2($elm$core$List$cons, _Utils_Tuple2('settings_label', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, label)), acc);
            }
        }), _List_Nil, permittedFields);
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('anchor', $elm$json$Json$Encode$object(encodedFields))
        ]));
    };
    var $author$project$Api$Partner$AppAnchor$create = F3(function(apiClient, permittedFields, toMsg) {
        var body = $author$project$Api$Partner$AppAnchor$encodePermittedFields(permittedFields);
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$AppAnchor$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$AppAnchor$appAnchorsPath)));
    });
    var $author$project$Api$Partner$AppAnchor$appAnchorPath = function(anchorId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            anchorId
        ]), $author$project$Api$Partner$AppAnchor$appAnchorsPath);
    };
    var $author$project$Api$Partner$AppAnchor$delete = F3(function(apiClient, anchorId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$AppAnchor$appAnchorPath(anchorId)));
    });
    var $author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight = function(_v0) {
        var record = _v0;
        return record.Mb;
    };
    var $author$project$Api$Partner$AppAnchor$corePageIconLabel = function(_v0) {
        var record = _v0;
        return record.Mc;
    };
    var $author$project$Api$Partner$AppAnchor$corePageIconUrl = function(_v0) {
        var record = _v0;
        return record.Md;
    };
    var $author$project$Api$Partner$AppAnchor$interactionDescription = function(_v0) {
        var record = _v0;
        return record.Ru;
    };
    var $author$project$Api$Partner$AppAnchor$interactionTitle = function(_v0) {
        var record = _v0;
        return record.Rv;
    };
    var $author$project$Api$Partner$AppAnchor$interactionType = function(_v0) {
        var record = _v0;
        return record.Rw;
    };
    var $author$project$Api$Partner$AppAnchor$settingsLabel = function(_v0) {
        var record = _v0;
        return record.Z0;
    };
    var $author$project$Api$Partner$AppAnchor$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Components$Partner$AppAnchors$initCustomizationFromAnchor = function(anchor) {
        var _v0 = $author$project$Api$Partner$AppAnchor$type_(anchor);
        switch(_v0){
            case 0:
                return $author$project$Components$Partner$AppAnchors$CorePageCustomization({
                    Mb: A2($elm$core$Maybe$withDefault, true, $author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight(anchor)),
                    Mc: $author$project$Api$Partner$AppAnchor$corePageIconLabel(anchor),
                    wW: 0,
                    Md: $elm$core$Maybe$Nothing,
                    w1: $author$project$Api$Partner$AppAnchor$corePageIconUrl(anchor)
                });
            case 1:
                return $author$project$Components$Partner$AppAnchors$ClinicalInteractionCustomization({
                    Ru: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$AppAnchor$interactionDescription(anchor)),
                    Rv: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Partner$AppAnchor$interactionTitle(anchor)),
                    Rw: A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Components$Partner$AppAnchors$interactionTypeFromString, $author$project$Api$Partner$AppAnchor$interactionType(anchor)))
                });
            default:
                return $author$project$Components$Partner$AppAnchors$SettingsCustomization({
                    Z0: $author$project$Api$Partner$AppAnchor$settingsLabel(anchor)
                });
        }
    };
    var $author$project$Components$Partner$AppAnchors$interactionTypeToString = function(type_) {
        if (!type_) return 'general';
        else return 'lab';
    };
    var $author$project$Api$Partner$AppAnchor$sourceUrl = function(_v0) {
        var record = _v0;
        return record._H;
    };
    var $author$project$Api$Partner$AppAnchor$update = F4(function(apiClient, anchorId, permittedFields, toMsg) {
        var body = $author$project$Api$Partner$AppAnchor$encodePermittedFields(permittedFields);
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$AppAnchor$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$AppAnchor$appAnchorPath(anchorId))));
    });
    var $author$project$Components$Partner$AppAnchors$SourceUrlValidation = 0;
    var $author$project$Components$Partner$AppAnchors$CorePageIconValidation = 1;
    var $author$project$Components$Partner$AppAnchors$maxCorePageIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Partner$AppAnchors$validaCorePageIconSize = function(fields) {
        var _v0 = fields.s;
        switch(_v0.$){
            case 0:
                var config = _v0.a;
                return _Utils_cmp(config.wW, $author$project$Components$Partner$AppAnchors$maxCorePageIconBytesSize) > 0 ? _List_fromArray([
                    _Utils_Tuple2(1, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')
                ]) : _List_Nil;
            case 1:
                return _List_Nil;
            default:
                return _List_Nil;
        }
    };
    var $author$project$Components$Partner$AppAnchors$validateAnchor = function(form) {
        var validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $._H;
            }, _Utils_Tuple2(0, 'Source URL is required')),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$AppAnchors$validaCorePageIconSize)
        ]));
        return A2($author$project$Utils$Form$validate, validator, form);
    };
    var $author$project$Components$Partner$AppAnchors$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var form = $author$project$Utils$Form$init({
                    s: $author$project$Components$Partner$AppAnchors$initCustomizationFromType(0),
                    _H: '',
                    ah5: 0
                });
                return _Utils_Tuple3(_Utils_update(model, {
                    Z: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Nothing, form))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var id = msg.a;
                var _v1 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
                var navModel = _v1.a;
                var navCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    nb: navModel,
                    bg: $elm$core$Maybe$Just(id)
                }), navCmd, _List_Nil);
            case 2:
                var _v2 = _Utils_Tuple2(model.bg, $elm$core$List$head(A2($elm$core$List$filter, function(anchor) {
                    return _Utils_eq($elm$core$Maybe$Just($author$project$Api$Partner$AppAnchor$id(anchor)), model.bg);
                }, model.Eg)));
                if (!_v2.a.$ && !_v2.b.$) {
                    var anchorId = _v2.a.a;
                    var selectedAnchor = _v2.b.a;
                    var form = $author$project$Utils$Form$init({
                        s: $author$project$Components$Partner$AppAnchors$initCustomizationFromAnchor(selectedAnchor),
                        _H: $author$project$Api$Partner$AppAnchor$sourceUrl(selectedAnchor),
                        ah5: $author$project$Api$Partner$AppAnchor$type_(selectedAnchor)
                    });
                    return _Utils_Tuple3(_Utils_update(model, {
                        Z: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(anchorId), form))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    lT: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    lT: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var _v3 = model.bg;
                if (!_v3.$) {
                    var anchorId = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        qi: $author$project$Api$Data$Loading
                    }), A3($author$project$Api$Partner$AppAnchor$delete, apiClient, anchorId, $author$project$Components$Partner$AppAnchors$GotDeletedAnchor), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var response = msg.a;
                if (response.$ === 3) {
                    var updatedAnchors = A2($elm$core$List$filter, function(anchor) {
                        return !_Utils_eq($elm$core$Maybe$Just($author$project$Api$Partner$AppAnchor$id(anchor)), model.bg);
                    }, model.Eg);
                    var newSelectedId = A2($elm$core$Maybe$map, $author$project$Api$Partner$AppAnchor$id, $elm$core$List$head(updatedAnchors));
                    var _v5 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
                    var navModel = _v5.a;
                    var navCmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Eg: updatedAnchors,
                        qi: $author$project$Api$Data$NotAsked,
                        lT: false,
                        nb: navModel,
                        bg: newSelectedId
                    }), navCmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Surface deleted successfully!')
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    qi: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    Z: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var field = msg.a;
                var _v6 = model.Z;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var maybeId = _v7.a;
                    var form = _v7.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Z: $elm$core$Maybe$Just(_Utils_Tuple2(maybeId, newForm))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var _v8 = model.Z;
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var maybeId = _v9.a;
                    var form = _v9.b;
                    var _v10 = $author$project$Components$Partner$AppAnchors$validateAnchor(form);
                    if (!_v10.$) {
                        var _v11 = _v10.a;
                        var anchorForm = _v11.a;
                        var validFields = _v11.b;
                        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
                        var permittedFields = A2($elm$core$List$cons, $author$project$Api$Partner$AppAnchor$Type(fields.ah5), A2($elm$core$List$cons, $author$project$Api$Partner$AppAnchor$SourceUrl($elm$core$Maybe$Just(fields._H)), function() {
                            var _v14 = fields.s;
                            switch(_v14.$){
                                case 1:
                                    var config = _v14.a;
                                    return _List_fromArray([
                                        $author$project$Api$Partner$AppAnchor$InteractionTitle($author$project$Utils$Maybe$fromString(config.Rv)),
                                        $author$project$Api$Partner$AppAnchor$InteractionDescription($author$project$Utils$Maybe$fromString(config.Ru)),
                                        $author$project$Api$Partner$AppAnchor$InteractionType($elm$core$Maybe$Just($author$project$Components$Partner$AppAnchors$interactionTypeToString(config.Rw)))
                                    ]);
                                case 0:
                                    var config = _v14.a;
                                    return A2($elm$core$List$cons, $author$project$Api$Partner$AppAnchor$CorePageIconLabel(config.Mc), A2($elm$core$List$cons, $author$project$Api$Partner$AppAnchor$CorePageAutoAdjustHeight($elm$core$Maybe$Just(config.Mb)), function() {
                                        var _v15 = config.Md;
                                        if (!_v15.$) {
                                            var iconUrl = _v15.a;
                                            return _List_fromArray([
                                                $author$project$Api$Partner$AppAnchor$CorePageIcon(iconUrl)
                                            ]);
                                        } else return _List_Nil;
                                    }()));
                                default:
                                    var config = _v14.a;
                                    return _List_fromArray([
                                        $author$project$Api$Partner$AppAnchor$SettingsLabel(config.Z0)
                                    ]);
                            }
                        }()));
                        var _v12 = function() {
                            if (maybeId.$ === 1) return _Utils_Tuple2(A3($author$project$Api$Partner$AppAnchor$create, apiClient, permittedFields, $author$project$Components$Partner$AppAnchors$GotAnchorResult), _Utils_update(model, {
                                Z: $elm$core$Maybe$Just(_Utils_Tuple2(maybeId, anchorForm)),
                                hx: $author$project$Api$Data$Loading
                            }));
                            else {
                                var anchorId = maybeId.a;
                                return _Utils_Tuple2(A4($author$project$Api$Partner$AppAnchor$update, apiClient, anchorId, permittedFields, $author$project$Components$Partner$AppAnchors$GotAnchorResult), _Utils_update(model, {
                                    Z: $elm$core$Maybe$Just(_Utils_Tuple2(maybeId, anchorForm)),
                                    hx: $author$project$Api$Data$Loading
                                }));
                            }
                        }();
                        var cmd = _v12.a;
                        var updatedModel = _v12.b;
                        return _Utils_Tuple3(updatedModel, cmd, _List_Nil);
                    } else {
                        var formWithErrors = _v10.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Z: $elm$core$Maybe$Just(_Utils_Tuple2(maybeId, formWithErrors))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var response = msg.a;
                if (response.$ === 3) {
                    var anchor = response.a;
                    var _v17 = function() {
                        var _v18 = model.Z;
                        if (!_v18.$) {
                            if (_v18.a.a.$ === 1) {
                                var _v19 = _v18.a;
                                var _v20 = _v19.a;
                                return _Utils_Tuple3(_Utils_ap(model.Eg, _List_fromArray([
                                    anchor
                                ])), 'Surface created successfully!', $elm$core$Maybe$Just($author$project$Api$Partner$AppAnchor$id(anchor)));
                            } else {
                                var _v21 = _v18.a;
                                var anchorId = _v21.a.a;
                                return _Utils_Tuple3(A2($elm$core$List$map, function(a) {
                                    return _Utils_eq($author$project$Api$Partner$AppAnchor$id(a), anchorId) ? anchor : a;
                                }, model.Eg), 'Surface updated successfully!', model.bg);
                            }
                        } else return _Utils_Tuple3(model.Eg, 'Surface saved successfully!', model.bg);
                    }();
                    var updatedAnchors = _v17.a;
                    var toastMessage = _v17.b;
                    var newSelectedId = _v17.c;
                    var _v22 = A2($author$project$Ui$Nav$init, 'app-anchors-nav', $author$project$Components$Partner$AppAnchors$NavMsg);
                    var navModel = _v22.a;
                    var navCmd = _v22.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Z: $elm$core$Maybe$Nothing,
                        hx: $author$project$Api$Data$NotAsked,
                        Eg: updatedAnchors,
                        nb: navModel,
                        bg: newSelectedId
                    }), navCmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, toastMessage)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    hx: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                var subMsg = msg.a;
                var _v23 = A2($author$project$Ui$Nav$update, subMsg, model.nb);
                var navModel = _v23.a;
                var navCmd = _v23.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    nb: navModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$AppAnchors$NavMsg, navCmd), _List_Nil);
            case 12:
                var subMsg = msg.a;
                var _v24 = A2($author$project$Ui$Dropdown$update, subMsg, model.oX);
                var typeDropdown = _v24.a;
                var cmd = _v24.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oX: typeDropdown
                }), cmd, _List_Nil);
            case 13:
                var selectedType = msg.a;
                var _v25 = model.Z;
                if (!_v25.$) {
                    var _v26 = _v25.a;
                    var maybeId = _v26.a;
                    var form = _v26.b;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$AppAnchors$anchorFormFieldsUpdate, $author$project$Components$Partner$AppAnchors$AnchorType(selectedType), form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        Z: $elm$core$Maybe$Just(_Utils_Tuple2(maybeId, newForm))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var logos = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v27) {
                    var task = _v27.a;
                    var size = _v27.b;
                    return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$CorePageIcon(size)), task);
                }, A2($elm$core$Maybe$map, function(logo) {
                    return _Utils_Tuple2($elm$file$File$toUrl(logo), $elm$file$File$size(logo));
                }, $elm$core$List$head(logos))));
                return _Utils_Tuple3(model, cmd, _List_Nil);
        }
    });
    var $author$project$Pages$Partner$Product$AppSettings$NameValidation = 0;
    var $author$project$Pages$Partner$Product$AppSettings$validate = function(form) {
        var validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
                return $.zr;
            }, _Utils_Tuple2(0, 'Name is required'))
        ]));
        return A2($author$project$Utils$Form$validate, validator, form);
    };
    var $author$project$Pages$Partner$Product$AppSettings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                _v1$2: while(true)switch(response.$){
                    case 3:
                        var app = response.a;
                        var _v2 = A2($author$project$Components$Partner$AppAnchors$init, model.F3, $author$project$Api$Partner$App$anchors(app));
                        var appAnchors = _v2.a;
                        var appAnchorsCmd = _v2.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            cA: response,
                            hy: appAnchors
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg, appAnchorsCmd), _List_Nil);
                    case 2:
                        if (response.a.$ === 5) {
                            var _v3 = response.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                cA: response
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    cA: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(model, A2($author$project$Api$Partner$App$create, model.Ej, $author$project$Pages$Partner$Product$AppSettings$GotCreatedApp), _List_Nil);
            case 2:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    cA: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var _v5 = model.cA;
                if (_v5.$ === 3) {
                    var app = _v5.a;
                    var form = $author$project$Utils$Form$init({
                        Qi: $author$project$Api$Partner$App$handshakeUrl(app),
                        zr: $author$project$Api$Partner$App$name(app),
                        V1: $author$project$Api$Partner$App$partnerRoles(app)
                    });
                    return _Utils_Tuple3(_Utils_update(model, {
                        a6: $elm$core$Maybe$Just(form)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    a6: $elm$core$Maybe$Nothing,
                    o2: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var subMsg = msg.a;
                var _v6 = model.a6;
                if (!_v6.$) {
                    var form = _v6.a;
                    var _v7 = A2($author$project$Ui$TagsInput$update, subMsg, model.tj);
                    var newTagsInput = _v7.a;
                    var tagsInputMsg = _v7.b;
                    var maybeEvent = _v7.c;
                    var newForm = A2($elm$core$Maybe$withDefault, form, A2($elm$core$Maybe$map, function(event) {
                        var _v8 = $author$project$Utils$Form$fields(form);
                        var partnerRoles = _v8.V1;
                        var newPartnerRoles = function() {
                            if (!event.$) {
                                var tag = event.a;
                                return _Utils_ap(partnerRoles, _List_fromArray([
                                    tag
                                ]));
                            } else {
                                var tag = event.a;
                                return A2($elm_community$list_extra$List$Extra$remove, tag, partnerRoles);
                            }
                        }();
                        return A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Product$AppSettings$formFieldsUpdate, $author$project$Pages$Partner$Product$AppSettings$PartnerRoles(newPartnerRoles), form);
                    }, maybeEvent));
                    return _Utils_Tuple3(_Utils_update(model, {
                        a6: $elm$core$Maybe$Just(newForm),
                        tj: newTagsInput
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$AppSettings$TagsInputMsg, tagsInputMsg), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var field = msg.a;
                var _v10 = model.a6;
                if (!_v10.$) {
                    var form = _v10.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Product$AppSettings$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        a6: $elm$core$Maybe$Just(newForm)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var _v11 = model.a6;
                if (!_v11.$) {
                    var form = _v11.a;
                    var _v12 = $author$project$Pages$Partner$Product$AppSettings$validate(form);
                    if (!_v12.$) {
                        var _v13 = _v12.a;
                        var appForm = _v13.a;
                        var validFields = _v13.b;
                        var fields = $rtfeldman$elm_validate$Validate$fromValid(validFields);
                        var permittedFields = _List_fromArray([
                            $author$project$Api$Partner$App$Name(fields.zr),
                            $author$project$Api$Partner$App$HandshakeUrl($elm$core$String$isEmpty(fields.Qi) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.Qi)),
                            $author$project$Api$Partner$App$PartnerRoles(A2($elm_community$list_extra$List$Extra$filterNot, $elm$core$String$isEmpty, fields.V1))
                        ]);
                        return _Utils_Tuple3(_Utils_update(model, {
                            a6: $elm$core$Maybe$Just(appForm),
                            o2: $author$project$Api$Data$Loading
                        }), A3($author$project$Api$Partner$App$update, model.Ej, permittedFields, $author$project$Pages$Partner$Product$AppSettings$GotUpdatedApp), _List_Nil);
                    } else {
                        var formWithErrors = _v12.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            a6: $elm$core$Maybe$Just(formWithErrors)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    cA: response,
                    a6: $elm$core$Maybe$Nothing,
                    o2: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'App updated successfully!')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    o2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var _v15 = model.cA;
                if (_v15.$ === 3) {
                    var app = _v15.a;
                    return $elm$core$String$isEmpty($author$project$Api$Partner$App$handshakeUrl(app)) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        tn: true,
                        oM: $author$project$Api$Data$Loading
                    }), A2($author$project$Api$Partner$App$handshakeTest, model.Ej, $author$project$Pages$Partner$Product$AppSettings$GotTestHandshakeResult), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                return _Utils_Tuple3(_Utils_update(model, {
                    tn: false,
                    oM: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    oM: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v16 = A3($author$project$Components$Partner$AppAnchors$update, model.Ej, subMsg, model.hy);
                var appAnchors = _v16.a;
                var cmd = _v16.b;
                var outMsgs = _v16.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    hy: appAnchors
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg, cmd), outMsgs);
        }
    });
    var $author$project$Pages$Partner$Product$AppSettings$EditClicked = {
        $: 3
    };
    var $author$project$Pages$Partner$Product$AppSettings$TestHandshakeClicked = {
        $: 8
    };
    var $author$project$Api$Partner$App$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Components$Partner$AppAnchors$CorePageAutoAdjustHeight = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$CorePageIconLabel = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$CorePageIconUploaded = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$InteractionDescription = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$InteractionTitle = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$InteractionType = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$SaveAnchorClicked = {
        $: 9
    };
    var $author$project$Components$Partner$AppAnchors$SettingsLabel = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$SourceUrl = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$AppAnchors$TypeSelected = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Partner$AppAnchor$typeToLabel = function(anchorType) {
        switch(anchorType){
            case 0:
                return 'Full Page in Core';
            case 1:
                return 'Interaction on Clinical';
            default:
                return 'Settings';
        }
    };
    var $author$project$Components$Partner$AppAnchors$viewAnchorModal = F5(function(isHintAdmin, maybeId, form, anchorRequest, typeDropdown) {
        var isLoading = function() {
            if (anchorRequest.$ === 1) return true;
            else return false;
        }();
        var isEditing = !_Utils_eq(maybeId, $elm$core$Maybe$Nothing);
        var modalTitle = isEditing ? 'Edit Surface' : 'Add Surface';
        var fields = $author$project$Utils$Form$fields(form);
        var errorsFor = function(group) {
            return A2($author$project$Utils$Form$validationErrors, group, form);
        };
        return A3($author$project$Ui$Modal$view, $author$project$Components$Partner$AppAnchors$AnchorModalClosed, _List_fromArray([
            $author$project$Ui$Modal$onSubmit($author$project$Components$Partner$AppAnchors$SaveAnchorClicked)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(modalTitle)
            ])),
            $author$project$Ui$Modal$body(A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Type'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                isEditing ? $author$project$Ui$Form$Group$static(_List_fromArray([
                    $elm$html$Html$text($author$project$Api$Partner$AppAnchor$typeToLabel(fields.ah5))
                ])) : A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Partner$AppAnchor$typeToLabel(fields.ah5))
                ]), A2($elm$core$List$map, function(type_) {
                    return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Components$Partner$AppAnchors$TypeSelected(type_)),
                        $author$project$Ui$Dropdown$selected(_Utils_eq(fields.ah5, type_))
                    ]), $elm$html$Html$text($author$project$Api$Partner$AppAnchor$typeToLabel(type_)));
                }, _List_fromArray([
                    0,
                    1,
                    2
                ])), typeDropdown)
            ])), A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Source URL'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields._H),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$SourceUrl)),
                    $author$project$Ui$Form$Input$errors(errorsFor(0)),
                    $author$project$Ui$Form$Input$placeholder('https://your-app.com/widget')
                ]))
            ])), function() {
                var _v0 = _Utils_Tuple2(fields.ah5, fields.s);
                _v0$3: while(true)switch(_v0.a){
                    case 0:
                        if (!_v0.b.$) {
                            var _v1 = _v0.a;
                            var config = _v0.b.a;
                            return _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$labelSpanSm(4),
                                    $author$project$Ui$Form$Group$inputSpan(8),
                                    $author$project$Ui$Form$Group$label('Icon')
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$File$view(_List_fromArray([
                                        $author$project$Ui$Form$File$accept(0),
                                        $author$project$Ui$Form$File$onInput($author$project$Components$Partner$AppAnchors$CorePageIconUploaded),
                                        $author$project$Ui$Form$File$empty(true)
                                    ]))
                                ])),
                                function() {
                                    var _v2 = config.w1;
                                    if (!_v2.$) {
                                        var url = _v2.a;
                                        return $elm$core$String$isEmpty(url) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$labelSpanSm(4),
                                            $author$project$Ui$Form$Group$inputSpan(8),
                                            $author$project$Ui$Form$Group$label('')
                                        ]), _List_fromArray([
                                            A3($author$project$Ui$Image$fromSrc, {
                                                Jg: 'Logo'
                                            }, url, _List_fromArray([
                                                $author$project$Ui$Image$height(50)
                                            ])),
                                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }(),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Icon Label'),
                                    $author$project$Ui$Form$Group$labelSpanSm(4),
                                    $author$project$Ui$Form$Group$inputSpanSm(8)
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$Input$view(_List_fromArray([
                                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', config.Mc)),
                                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$CorePageIconLabel)),
                                        $author$project$Ui$Form$Input$placeholder('Enter icon label'),
                                        $author$project$Ui$Form$Input$disabled(!isHintAdmin)
                                    ]))
                                ])),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$labelSpanSm(4),
                                    $author$project$Ui$Form$Group$inputSpanSm(8),
                                    $author$project$Ui$Form$Group$label('Auto adjust height')
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$Group$static(_List_fromArray([
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$textMuted,
                                            $author$project$Ui$Element$textSm,
                                            $author$project$Ui$Element$mb2
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('When enabled, the iframe height adapts to the embedded app\'s content for a seamless layout without inner scrollbars.'),
                                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                            $elm$html$Html$text('When disabled, the app stays boxed with its own scroll area, allowing sticky elements.')
                                        ])),
                                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                            $author$project$Ui$ToggleSwitch$on(config.Mb),
                                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$CorePageAutoAdjustHeight))
                                        ]))
                                    ]))
                                ]))
                            ]);
                        } else break _v0$3;
                    case 1:
                        if (_v0.b.$ === 1) {
                            var _v3 = _v0.a;
                            var config = _v0.b.a;
                            return _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Interaction Title'),
                                    $author$project$Ui$Form$Group$labelSpanSm(4),
                                    $author$project$Ui$Form$Group$inputSpanSm(8)
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$Input$view(_List_fromArray([
                                        $author$project$Ui$Form$Input$value(config.Rv),
                                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionTitle)),
                                        $author$project$Ui$Form$Input$placeholder('Enter interaction title')
                                    ]))
                                ])),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Interaction Description'),
                                    $author$project$Ui$Form$Group$labelSpanSm(4),
                                    $author$project$Ui$Form$Group$inputSpanSm(8)
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$Input$view(_List_fromArray([
                                        $author$project$Ui$Form$Input$value(config.Ru),
                                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionDescription)),
                                        $author$project$Ui$Form$Input$placeholder('Enter interaction description')
                                    ]))
                                ])),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Interaction Type'),
                                    $author$project$Ui$Form$Group$labelSpanSm(4),
                                    $author$project$Ui$Form$Group$inputSpanSm(8)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Components$Partner$AppAnchors$interactionTypeToString(config.Rw))),
                                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$InteractionType))
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Components$Partner$AppAnchors$interactionTypeToString(0)), 'General'),
                                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Components$Partner$AppAnchors$interactionTypeToString(1)), 'Lab')
                                    ]))
                                ]))
                            ]);
                        } else break _v0$3;
                    default:
                        if (_v0.b.$ === 2) {
                            var _v4 = _v0.a;
                            var config = _v0.b.a;
                            return _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Settings Label'),
                                    $author$project$Ui$Form$Group$labelSpanSm(4),
                                    $author$project$Ui$Form$Group$inputSpanSm(8)
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$Input$view(_List_fromArray([
                                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', config.Z0)),
                                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$AppAnchors$AnchorFormUpdated, $author$project$Components$Partner$AppAnchors$SettingsLabel)),
                                        $author$project$Ui$Form$Input$placeholder('Enter settings label')
                                    ]))
                                ]))
                            ]);
                        } else break _v0$3;
                }
                return _List_Nil;
            }()))),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$AnchorModalClosed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save surface'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(isLoading),
                    $author$project$Ui$Button$submit
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Partner$AppAnchors$AddAnchorClicked = {
        $: 0
    };
    var $author$project$Components$Partner$AppAnchors$AnchorClicked = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Nav$CustomItem = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Nav$customItem = $author$project$Ui$Nav$CustomItem;
    var $author$project$Ui$Nav$Id = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Nav$itemId = $author$project$Ui$Nav$Id;
    var $author$project$Ui$Nav$Slim = 0;
    var $author$project$Ui$Nav$slim = 0;
    var $author$project$Api$Partner$AppAnchor$typeLabel = function(_v0) {
        var record = _v0;
        return $author$project$Api$Partner$AppAnchor$typeToLabel(record.ah5);
    };
    var $author$project$Components$Partner$AppAnchors$viewAnchorsAsNavs = function(model) {
        var anchorItems = A2($elm$core$List$indexedMap, F2(function(index, anchor) {
            return A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$itemId($author$project$Api$Partner$AppAnchor$id(anchor)),
                $author$project$Ui$Nav$activeItem(A2($elm$core$Maybe$withDefault, !index, A2($elm$core$Maybe$map, $elm$core$Basics$eq($author$project$Api$Partner$AppAnchor$id(anchor)), model.bg))),
                $author$project$Ui$Nav$onItemClick($author$project$Components$Partner$AppAnchors$AnchorClicked($author$project$Api$Partner$AppAnchor$id(anchor)))
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$AppAnchor$typeLabel(anchor))
            ]));
        }), model.Eg);
        var addItem = A2($author$project$Ui$Nav$customItem, _List_fromArray([
            $author$project$Ui$Nav$onItemClick($author$project$Components$Partner$AppAnchors$AddAnchorClicked)
        ]), A3($author$project$Ui$Button$view, {
            abP: 'Add surface'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
        ]), _List_fromArray([
            $elm$html$Html$text('Add surface')
        ])));
        return A3($author$project$Ui$Nav$view, _List_fromArray([
            $author$project$Ui$Nav$slim
        ]), _Utils_ap(anchorItems, _List_fromArray([
            addItem
        ])), model.nb);
    };
    var $author$project$Components$Partner$AppAnchors$ConfirmDeleteAnchor = {
        $: 5
    };
    var $author$project$Components$Partner$AppAnchors$viewDeleteConfirmModal = A3($author$project$Ui$Modal$view, $author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed, _List_Nil, _List_fromArray([
        $author$project$Ui$Modal$header(_List_fromArray([
            $author$project$Ui$Modal$title('Delete Surface')
        ])),
        $author$project$Ui$Modal$body(_List_fromArray([
            $elm$html$Html$text('Are you sure you want to delete this surface? This action cannot be undone.')
        ])),
        $author$project$Ui$Modal$footer(_List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Cancel delete'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$DeleteConfirmModalClosed)
            ]), _List_fromArray([
                $elm$html$Html$text('Cancel')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Confirm delete'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$ConfirmDeleteAnchor)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete')
            ]))
        ]))
    ]));
    var $author$project$Components$Partner$AppAnchors$DeleteAnchorClicked = {
        $: 3
    };
    var $author$project$Components$Partner$AppAnchors$EditAnchorClicked = {
        $: 2
    };
    var $author$project$Components$Partner$AppAnchors$interactionTypeLabel = function(type_) {
        if (!type_) return 'General';
        else return 'Lab';
    };
    var $author$project$Components$Partner$AppAnchors$viewSelectedAnchorInfo = function(model) {
        var selectedAnchor = A2($elm$core$Maybe$andThen, $elm$core$List$head, A2($elm$core$Maybe$map, function(anchorId) {
            return A2($elm$core$List$filter, function(anchor) {
                return _Utils_eq($author$project$Api$Partner$AppAnchor$id(anchor), anchorId);
            }, model.Eg);
        }, model.bg));
        if (!selectedAnchor.$) {
            var anchor = selectedAnchor.a;
            return A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2,
                $author$project$Ui$Element$mt2,
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsStart
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Source URL')
                ]), _List_fromArray([
                    $author$project$Ui$Form$Group$static(_List_fromArray([
                        $elm$html$Html$text($author$project$Api$Partner$AppAnchor$sourceUrl(anchor))
                    ]))
                ])), function() {
                    var _v1 = $author$project$Api$Partner$AppAnchor$type_(anchor);
                    switch(_v1){
                        case 0:
                            return _List_fromArray([
                                function() {
                                    var _v2 = $author$project$Api$Partner$AppAnchor$corePageIconUrl(anchor);
                                    if (!_v2.$) {
                                        var url = _v2.a;
                                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Icon')
                                        ]), _List_fromArray([
                                            A3($author$project$Ui$Image$fromSrc, {
                                                Jg: 'App icon'
                                            }, url, _List_fromArray([
                                                $author$project$Ui$Image$height(50)
                                            ]))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }(),
                                function() {
                                    var _v3 = $author$project$Api$Partner$AppAnchor$corePageIconLabel(anchor);
                                    if (!_v3.$) {
                                        var corePageIconLabel = _v3.a;
                                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Icon Label')
                                        ]), _List_fromArray([
                                            $author$project$Ui$Form$Group$static(_List_fromArray([
                                                $elm$html$Html$text(corePageIconLabel)
                                            ]))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }(),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Auto Adjust Height')
                                ]), _List_fromArray([
                                    $author$project$Ui$Form$Group$static(_List_fromArray([
                                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, true, $author$project$Api$Partner$AppAnchor$corePageAutoAdjustHeight(anchor)) ? 'Enabled' : 'Disabled')
                                    ]))
                                ]))
                            ]);
                        case 1:
                            return _List_fromArray([
                                function() {
                                    var _v4 = $author$project$Api$Partner$AppAnchor$interactionTitle(anchor);
                                    if (!_v4.$) {
                                        var title = _v4.a;
                                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Interaction Title')
                                        ]), _List_fromArray([
                                            $author$project$Ui$Form$Group$static(_List_fromArray([
                                                $elm$html$Html$text(title)
                                            ]))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }(),
                                function() {
                                    var _v5 = $author$project$Api$Partner$AppAnchor$interactionDescription(anchor);
                                    if (!_v5.$) {
                                        var description = _v5.a;
                                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Interaction Description')
                                        ]), _List_fromArray([
                                            $author$project$Ui$Form$Group$static(_List_fromArray([
                                                $elm$html$Html$text(description)
                                            ]))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }(),
                                function() {
                                    var _v6 = $author$project$Api$Partner$AppAnchor$interactionType(anchor);
                                    if (!_v6.$) {
                                        var interactionType_ = _v6.a;
                                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Interaction Type')
                                        ]), _List_fromArray([
                                            $author$project$Ui$Form$Group$static(_List_fromArray([
                                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, interactionType_, A2($elm$core$Maybe$map, $author$project$Components$Partner$AppAnchors$interactionTypeLabel, $author$project$Components$Partner$AppAnchors$interactionTypeFromString(interactionType_))))
                                            ]))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ]);
                        default:
                            return _List_fromArray([
                                function() {
                                    var _v7 = $author$project$Api$Partner$AppAnchor$settingsLabel(anchor);
                                    if (!_v7.$) {
                                        var settingsLabel = _v7.a;
                                        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Settings Label')
                                        ]), _List_fromArray([
                                            $author$project$Ui$Form$Group$static(_List_fromArray([
                                                $elm$html$Html$text(settingsLabel)
                                            ]))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ]);
                    }
                }())),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt2
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit surface'
                    }, _List_fromArray([
                        $author$project$Ui$Button$secondary,
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$EditAnchorClicked),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                        $author$project$Ui$Button$sm
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete surface'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$AppAnchors$DeleteAnchorClicked),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete),
                        $author$project$Ui$Button$sm
                    ]), _List_fromArray([
                        $elm$html$Html$text('Remove')
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Partner$AppAnchors$view = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.Z;
                if (!_v0.$) {
                    var _v1 = _v0.a;
                    var maybeId = _v1.a;
                    var form = _v1.b;
                    return A5($author$project$Components$Partner$AppAnchors$viewAnchorModal, model.F3, maybeId, form, model.hx, model.oX);
                } else return $author$project$Utils$Html$empty;
            }(),
            model.lT ? $author$project$Components$Partner$AppAnchors$viewDeleteConfirmModal : $author$project$Utils$Html$empty,
            $author$project$Components$Partner$AppAnchors$viewAnchorsAsNavs(model),
            $author$project$Components$Partner$AppAnchors$viewSelectedAnchorInfo(model)
        ]));
    };
    var $author$project$Pages$Partner$Product$AppSettings$viewApp = F2(function(model, app) {
        return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$mb4
            ]), _List_fromArray([
                A2($elm$html$Html$h3, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('App Settings')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit app'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$EditClicked),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Group$static(_List_fromArray([
                    $elm$html$Html$text($author$project$Api$Partner$App$name(app)),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted
                    ]), _List_fromArray([
                        $elm$html$Html$text('The display name users will see when searching for or browsing the app.')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Group$static(_List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Partner$App$status(app))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Partner Roles'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Group$static(_List_fromArray([
                    $elm$core$List$isEmpty($author$project$Api$Partner$App$partnerRoles(app)) ? $elm$html$Html$text('No partner roles defined') : A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, function(role) {
                        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(role)
                        ]));
                    }, $author$project$Api$Partner$App$partnerRoles(app)))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Handshake url'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Group$static(_List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsStart
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(function(handshakeUrl) {
                                return $elm$core$String$isEmpty(handshakeUrl) ? 'None' : handshakeUrl;
                            }($author$project$Api$Partner$App$handshakeUrl(app))),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textMuted
                            ]), _List_fromArray([
                                $elm$html$Html$text('The endpoint where we send a signed request to establish trust. The request includes:'),
                                A2($elm$html$Html$ul, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('user: { id, email, name, first_name, last_name, partner_roles }')
                                    ])),
                                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('practice: { id }')
                                    ])),
                                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('patient: { id } | null')
                                    ])),
                                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('integration: { id } | null')
                                    ])),
                                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('access_token: string')
                                    ]))
                                ])),
                                $elm$html$Html$text('Your endpoint must return a session_key, which we will pass into the iframe for authentication.')
                            ]))
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Test handshake endpoint'
                        }, _List_fromArray([
                            $author$project$Ui$Button$secondary,
                            $author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$TestHandshakeClicked),
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$disabled($elm$core$String$isEmpty($author$project$Api$Partner$App$handshakeUrl(app)))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Test')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Surfaces'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Group$static(_List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Partner$Product$AppSettings$AppAnchorsMsg, $author$project$Components$Partner$AppAnchors$view(model.hy))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Partner$Product$AppSettings$CreateClicked = {
        $: 1
    };
    var $author$project$Pages$Partner$Product$AppSettings$viewBuildApp = _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$justifyCenter,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$flexCol
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $elm$html$Html$text('There\'s no APP yet')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Build your app'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$CreateClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('Start building')
            ]))
        ]))
    ]);
    var $author$project$Pages$Partner$Product$AppSettings$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$HandshakeUrl = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$SaveClicked = {
        $: 6
    };
    var $author$project$Pages$Partner$Product$AppSettings$viewEditModal = F3(function(tagsInput, form, updateRequest) {
        var isLoading = function() {
            if (updateRequest.$ === 1) return true;
            else return false;
        }();
        var fields = $author$project$Utils$Form$fields(form);
        var errorsFor = function(group) {
            return A2($author$project$Utils$Form$validationErrors, group, form);
        };
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Product$AppSettings$EditModalClosed, _List_fromArray([
            $author$project$Ui$Modal$onSubmit($author$project$Pages$Partner$Product$AppSettings$SaveClicked)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Edit App')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Name'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.zr),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$AppSettings$FormUpdated, $author$project$Pages$Partner$Product$AppSettings$Name)),
                        $author$project$Ui$Form$Input$disabled(isLoading),
                        $author$project$Ui$Form$Input$errors(errorsFor(0))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Handshake URL'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(fields.Qi),
                        $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Product$AppSettings$FormUpdated, $author$project$Pages$Partner$Product$AppSettings$HandshakeUrl)),
                        $author$project$Ui$Form$Input$placeholder('https://your-app.com/handshake'),
                        $author$project$Ui$Form$Input$disabled(isLoading)
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Partner Roles'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Pages$Partner$Product$AppSettings$TagsInputMsg, A2($author$project$Ui$TagsInput$view, _List_fromArray([
                        $author$project$Ui$TagsInput$tags(fields.V1)
                    ]), tagsInput)),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('Roles can be copy/pasted into this field as long as they are separated by commas.')
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel edit'
                }, _List_fromArray([
                    $author$project$Ui$Button$secondary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$EditModalClosed),
                    $author$project$Ui$Button$disabled(isLoading)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save changes'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$disabled(isLoading),
                    $author$project$Ui$Button$loading(isLoading),
                    $author$project$Ui$Button$submit
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Product$AppSettings$viewTestHandshakeModal = function(testRequest) {
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Product$AppSettings$TestHandshakeModalClosed, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Test Handshake Endpoint')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                function() {
                    switch(testRequest.$){
                        case 1:
                            return $elm$html$Html$text('Testing handshake endpoint...');
                        case 3:
                            return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Handshake successful!'),
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$textMuted,
                                    $author$project$Ui$Element$mt2
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Your endpoint responded correctly to the test request.')
                                ]))
                            ]));
                        case 2:
                            return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Handshake failed'),
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$textMuted,
                                    $author$project$Ui$Element$mt2
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Please check your endpoint URL and try again.')
                                ]))
                            ]));
                        default:
                            return $elm$html$Html$text('Ready to test handshake endpoint');
                    }
                }()
            ])),
            $author$project$Ui$Modal$footer(A2($elm$core$List$cons, A3($author$project$Ui$Button$view, {
                abP: 'Close test modal'
            }, _List_fromArray([
                $author$project$Ui$Button$secondary,
                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$TestHandshakeModalClosed)
            ]), _List_fromArray([
                $elm$html$Html$text('Close')
            ])), function() {
                if (testRequest.$ === 2) return _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Retry handshake test'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Pages$Partner$Product$AppSettings$TestHandshakeClicked)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Retry')
                    ]))
                ]);
                else return _List_Nil;
            }()))
        ]));
    };
    var $author$project$Pages$Partner$Product$AppSettings$viewBody = function(model) {
        return _List_fromArray([
            function() {
                var _v0 = model.a6;
                if (!_v0.$) {
                    var form = _v0.a;
                    return A3($author$project$Pages$Partner$Product$AppSettings$viewEditModal, model.tj, form, model.o2);
                } else return $author$project$Utils$Html$empty;
            }(),
            model.tn ? $author$project$Pages$Partner$Product$AppSettings$viewTestHandshakeModal(model.oM) : $elm$html$Html$text(''),
            A2($author$project$Ui$Panel$view, _List_Nil, $elm$core$List$singleton(A2($author$project$Ui$Panel$body, _List_Nil, function() {
                var _v1 = model.cA;
                _v1$2: while(true)switch(_v1.$){
                    case 3:
                        var app = _v1.a;
                        return A2($author$project$Pages$Partner$Product$AppSettings$viewApp, model, app);
                    case 2:
                        if (_v1.a.$ === 5) {
                            var _v2 = _v1.a;
                            return $author$project$Pages$Partner$Product$AppSettings$viewBuildApp;
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _List_Nil;
            }())))
        ]);
    };
    var $author$project$Pages$Partner$Product$AppSettings$view = function(model) {
        return {
            fb: $author$project$Pages$Partner$Product$AppSettings$viewBody(model),
            $2: 'Partner | Product | AppSettings'
        };
    };
    var $author$project$Pages$Partner$Product$AppSettings$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Product$AppSettings$init,
        aeR: $author$project$Pages$Partner$Product$AppSettings$load,
        ag3: $author$project$Pages$Partner$Product$AppSettings$save,
        ahE: $author$project$Pages$Partner$Product$AppSettings$subscriptions,
        aaO: $author$project$Pages$Partner$Product$AppSettings$update,
        aid: $author$project$Pages$Partner$Product$AppSettings$view
    });
    var $author$project$Pages$Partner$Product$Hinter$GotPartnerProduct = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Product$Hinter$init = F4(function(_v0, partner, shared, _v1) {
        var _v2 = $author$project$Api$Partner$Partner$One$product(partner);
        if (!_v2.$) {
            var product = _v2.a;
            var productId = $author$project$Api$Partner$PartnerProduct$Shared$id(product);
            return _Utils_Tuple2({
                Ej: shared.Ej,
                VW: partner,
                gj: $elm$core$Maybe$Nothing,
                Xw: $author$project$Api$Data$Loading
            }, A3($author$project$Api$Partner$PartnerProduct$retrieve, shared.Ej, productId, $author$project$Pages$Partner$Product$Hinter$GotPartnerProduct));
        } else return _Utils_Tuple2({
            Ej: shared.Ej,
            VW: partner,
            gj: $elm$core$Maybe$Nothing,
            Xw: $author$project$Api$Data$NotAsked
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Product$Hinter$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Product$Hinter$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Partner$Product$Hinter$subscriptions = function(model) {
        var _v0 = model.gj;
        if (!_v0.$) {
            var partnerProductForm = _v0.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg, $author$project$Components$Hinter$EditPartnerProductForm$subscriptions(partnerProductForm));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$Hinter$EditPartnerProductForm$FeatureType = 0;
    var $author$project$Components$Hinter$EditPartnerProductForm$TierType = 1;
    var $author$project$Api$Partner$PartnerProduct$One$requirement = function(_v0) {
        var record = _v0.b;
        return record.YI;
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$initFormFields = function(product) {
        var _v0 = function() {
            var _v1 = $author$project$Api$Partner$PartnerProduct$One$requirement(product);
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var f = _v1.a.a;
                    return _Utils_Tuple3(true, 0, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(f)));
                } else {
                    var tier = _v1.a.a;
                    return _Utils_Tuple3(true, 1, $elm$core$Maybe$Just(tier));
                }
            } else return _Utils_Tuple3(false, 0, $elm$core$Maybe$Nothing);
        }();
        var requirementEnabled = _v0.a;
        var requirementType = _v0.b;
        var requirementValue = _v0.c;
        return _Utils_Tuple2({
            N9: $author$project$Api$Partner$PartnerProduct$One$distributionType(product),
            Pw: $author$project$Api$Partner$PartnerProduct$One$featured(product),
            G7: $author$project$Api$Partner$PartnerProduct$One$type_(product),
            jS: requirementEnabled,
            n0: requirementType,
            gC: requirementValue,
            _A: $author$project$Api$Partner$PartnerProduct$One$slug(product),
            ahy: $author$project$Api$Partner$PartnerProduct$One$status(product)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$init = function(product) {
        var _v0 = $author$project$Components$Hinter$EditPartnerProductForm$initFormFields(product);
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init(formFields),
            G6: $author$project$Api$Partner$PartnerProduct$One$id(product),
            o2: $author$project$Api$Data$NotAsked
        }, formFieldsCmd);
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$GotUpdatedPartnerProduct = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    _A: string
                });
            case 1:
                var productType = field.a;
                return _Utils_update(fields, {
                    G7: productType
                });
            case 2:
                var distributionType = field.a;
                return _Utils_update(fields, {
                    N9: distributionType
                });
            case 3:
                var status = field.a;
                return _Utils_update(fields, {
                    ahy: status
                });
            case 4:
                var bool = field.a;
                return _Utils_update(fields, {
                    Pw: bool
                });
            case 5:
                var bool = field.a;
                return _Utils_update(fields, {
                    jS: bool,
                    gC: $elm$core$Maybe$Nothing
                });
            case 6:
                var requirementType = field.a;
                return _Utils_update(fields, {
                    n0: requirementType,
                    gC: $elm$core$Maybe$Nothing
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    gC: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Components$Hinter$EditPartnerProductForm$RequirementValueValidation = 0;
    var $author$project$Components$Hinter$EditPartnerProductForm$validateRequirementValue = function(fields) {
        return fields.jS && _Utils_eq(fields.gC, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(0, 'A value is required')
        ]) : _List_Nil;
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Hinter$EditPartnerProductForm$validateRequirementValue)
    ]));
    var $author$project$Api$Partner$PartnerProduct$DistributionType = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$FeatureRequirement = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Featured = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$InstallationRequirement = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$ProductType = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Slug = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$Status = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$TierRequirement = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$toPermittedFields = function(fields) {
        var installationRequirement = fields.jS ? A2($elm$core$Maybe$map, function(value) {
            var _v0 = fields.n0;
            if (!_v0) return $author$project$Api$Partner$PartnerProduct$FeatureRequirement($author$project$Api$Common$Marketplace$Product$Requirement$Feature$fromString(value));
            else return $author$project$Api$Partner$PartnerProduct$TierRequirement(value);
        }, fields.gC) : $elm$core$Maybe$Nothing;
        return _List_fromArray([
            $author$project$Api$Partner$PartnerProduct$Slug(fields._A),
            $author$project$Api$Partner$PartnerProduct$ProductType(fields.G7),
            $author$project$Api$Partner$PartnerProduct$DistributionType(fields.N9),
            $author$project$Api$Partner$PartnerProduct$Status(fields.ahy),
            $author$project$Api$Partner$PartnerProduct$Featured(fields.Pw),
            $author$project$Api$Partner$PartnerProduct$InstallationRequirement(installationRequirement)
        ]);
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Hinter$EditPartnerProductForm$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Hinter$EditPartnerProductForm$formFieldsValidator, model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validFormFields = _v3.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    return _Utils_Tuple3(_Utils_update(model, {
                        o2: $author$project$Api$Data$Loading
                    }), A4($author$project$Api$Partner$PartnerProduct$update, apiClient, model.G6, $author$project$Components$Hinter$EditPartnerProductForm$toPermittedFields(fields), $author$project$Components$Hinter$EditPartnerProductForm$GotUpdatedPartnerProduct), _List_Nil);
                } else {
                    var updatedForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: updatedForm,
                        o2: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var updatedProduct = response.a;
                    var _v5 = $author$project$Components$Hinter$EditPartnerProductForm$initFormFields(updatedProduct);
                    var updatedFormFields = _v5.a;
                    var formFieldsCmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $author$project$Utils$Form$init(updatedFormFields),
                        o2: $author$project$Api$Data$NotAsked
                    }), formFieldsCmd, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Settings saved!'),
                        $author$project$OutMsg$RefreshPartner
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    o2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Partner$Product$Hinter$update = F2(function(msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var _v1 = model.gj;
            if (!_v1.$) {
                var partnerProductForm = _v1.a;
                var _v2 = A3($author$project$Components$Hinter$EditPartnerProductForm$update, model.Ej, subMsg, partnerProductForm);
                var newPartnerProductForm = _v2.a;
                var cmd = _v2.b;
                var outMsgs = _v2.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    gj: $elm$core$Maybe$Just(newPartnerProductForm)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg, cmd), outMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
            var response = msg.a;
            if (response.$ === 3) {
                var product = response.a;
                var _v4 = $author$project$Components$Hinter$EditPartnerProductForm$init(product);
                var partnerProductForm = _v4.a;
                var partnerProductFormCmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    gj: $elm$core$Maybe$Just(partnerProductForm),
                    Xw: response
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg, partnerProductFormCmd), _List_Nil);
            } else return _Utils_Tuple3(_Utils_update(model, {
                Xw: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Hinter$EditPartnerProductForm$DistributionType = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$Featured = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$ProductType = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$RequirementEnabled = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$RequirementType = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$RequirementValue = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$Save = {
        $: 1
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$Slug = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$Status = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Common$Marketplace$Product$ProductType$all = _List_fromArray([
        0,
        1,
        2
    ]);
    var $author$project$Api$Common$Marketplace$Product$Status$all = _List_fromArray([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]);
    var $author$project$Api$Common$Marketplace$Product$ProductType$fromString = function(str) {
        switch(str){
            case 'app':
                return $elm$core$Maybe$Just(0);
            case 'integration':
                return $elm$core$Maybe$Just(1);
            case 'solution':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$all = _List_fromArray([
        $author$project$Api$Common$Marketplace$Product$Requirement$Feature$Emr
    ]);
    var $author$project$Api$Common$Marketplace$Product$Requirement$Feature$toLabel = function(feature) {
        if (!feature.$) return 'EMR - Clinical';
        else {
            var string = feature.a;
            return string;
        }
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$requirementValueOptions = function(requirementType) {
        if (!requirementType) return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a feature...'), A2($elm$core$List$map, function(f) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Requirement$Feature$toString(f)), $author$project$Api$Common$Marketplace$Product$Requirement$Feature$toLabel(f));
        }, $author$project$Api$Common$Marketplace$Product$Requirement$Feature$all));
        else return _List_fromArray([
            A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Select a tier...')
        ]);
    };
    var $author$project$Components$Hinter$EditPartnerProductForm$view = function(_v0) {
        var model = _v0;
        var loading = _Utils_eq(model.o2, $author$project$Api$Data$Loading);
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Slug')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields._A),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Slug))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Product Type')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$ProductType$toString(fields.G7))),
                    $author$project$Ui$Form$Select$onChange(function(str) {
                        return A2($elm$core$Maybe$withDefault, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated($author$project$Components$Hinter$EditPartnerProductForm$ProductType(fields.G7)), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$ProductType), $author$project$Api$Common$Marketplace$Product$ProductType$fromString(str)));
                    })
                ]), A2($elm$core$List$map, function(type_) {
                    return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$ProductType$toString(type_)), $author$project$Api$Common$Marketplace$Product$ProductType$toLabel(type_));
                }, $author$project$Api$Common$Marketplace$Product$ProductType$all))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Distribution Type')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$DistributionType$toString(fields.N9))),
                    $author$project$Ui$Form$Select$onChange(function(str) {
                        return A2($elm$core$Maybe$withDefault, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated($author$project$Components$Hinter$EditPartnerProductForm$DistributionType(fields.N9)), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$DistributionType), $author$project$Api$Common$Marketplace$Product$DistributionType$fromString(str)));
                    })
                ]), _List_fromArray([
                    A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('public'), 'Public'),
                    A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('unlisted'), 'Unlisted')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Featured')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.Pw),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Featured))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Status')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Status$toString(fields.ahy))),
                    $author$project$Ui$Form$Select$onChange(function(str) {
                        return A2($elm$core$Maybe$withDefault, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated($author$project$Components$Hinter$EditPartnerProductForm$Status(fields.ahy)), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$Status), $author$project$Api$Common$Marketplace$Product$Status$fromString(str)));
                    })
                ]), A2($elm$core$List$map, function(status) {
                    return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$Status$toString(status)), $author$project$Api$Common$Marketplace$Product$Status$toLabel(status));
                }, $author$project$Api$Common$Marketplace$Product$Status$all))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Has a requirement?')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.jS),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$RequirementEnabled))
                ]))
            ])),
            fields.jS ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$labelSpanSm(4)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(function() {
                            var _v1 = fields.n0;
                            if (!_v1) return 'feature';
                            else return 'tier';
                        }())),
                        $author$project$Ui$Form$Select$onChange(function(str) {
                            if (str === 'feature') return $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated($author$project$Components$Hinter$EditPartnerProductForm$RequirementType(0));
                            else return $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated($author$project$Components$Hinter$EditPartnerProductForm$RequirementType(1));
                        })
                    ]), _List_fromArray([
                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('feature'), 'Feature'),
                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('tier'), 'Tier')
                    ])),
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value(fields.gC),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Hinter$EditPartnerProductForm$FormUpdated, $author$project$Components$Hinter$EditPartnerProductForm$RequirementValue)),
                        $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                        $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                    ]), $author$project$Components$Hinter$EditPartnerProductForm$requirementValueOptions(fields.n0))
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textCenter,
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Save product changes'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$submit,
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$onClick($author$project$Components$Hinter$EditPartnerProductForm$Save)
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Product$Hinter$view = function(model) {
        return {
            fb: function() {
                var _v0 = model.gj;
                if (!_v0.$) {
                    var partnerProductForm = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('Admin Settings')
                                ]))
                            ])),
                            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Partner$Product$Hinter$PartnerProductFormMsg, $author$project$Components$Hinter$EditPartnerProductForm$view(partnerProductForm))
                            ]))
                        ]))
                    ]);
                } else return _List_Nil;
            }(),
            $2: 'Partner | Product | Admin Settings'
        };
    };
    var $author$project$Pages$Partner$Product$Hinter$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Product$Hinter$init,
        aeR: $author$project$Pages$Partner$Product$Hinter$load,
        ag3: $author$project$Pages$Partner$Product$Hinter$save,
        ahE: $author$project$Pages$Partner$Product$Hinter$subscriptions,
        aaO: $author$project$Pages$Partner$Product$Hinter$update,
        aid: $author$project$Pages$Partner$Product$Hinter$view
    });
    var $author$project$Pages$Partner$Product$New$FormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$NewProduct$Model = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Partner$Shared$slug = function(_v0) {
        var record = _v0;
        return record._A;
    };
    var $author$project$Api$Partner$Partner$One$slug = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$slug(shared);
    };
    var $author$project$Components$Partner$NewProduct$initFormFields = function(partner) {
        return _Utils_Tuple2({
            NQ: $elm$core$Maybe$Nothing,
            QZ: $elm$core$Maybe$Nothing,
            zr: $author$project$Api$Partner$Partner$One$name(partner),
            G7: $author$project$Api$Partner$Partner$One$productType(partner),
            _A: $author$project$Api$Partner$Partner$One$slug(partner)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Components$Partner$NewProduct$init = F2(function(partner, imageStore) {
        var _v0 = $author$project$Components$Partner$NewProduct$initFormFields(partner);
        var formFields = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init(formFields),
            qW: imageStore
        }, formFieldsCmd);
    });
    var $author$project$Pages$Partner$Product$New$init = F4(function(_v0, partner, shared, _v1) {
        var _v2 = A2($author$project$Components$Partner$NewProduct$init, partner, shared.qW);
        var form = _v2.a;
        var formCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form,
            j_: $author$project$Api$Data$NotAsked
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$New$FormMsg, formCmd));
    });
    var $author$project$Pages$Partner$Product$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Product$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Partner$NewProduct$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Partner$Product$New$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Product$New$FormMsg, $author$project$Components$Partner$NewProduct$subscriptions(model.PU));
    };
    var $author$project$Pages$Partner$Product$New$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerProduct$partnerProductPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partner_products'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$PartnerProduct$create = F3(function(apiClient, permittedFields, toMsg) {
        var body = $author$project$Api$Partner$PartnerProduct$encodePermittedFields(permittedFields);
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerProduct$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$PartnerProduct$partnerProductPath)));
    });
    var $author$project$Pages$Partner$Product$New$createProduct = F2(function(apiClient, permittedFields) {
        return A3($author$project$Api$Partner$PartnerProduct$create, apiClient, permittedFields, $author$project$Pages$Partner$Product$New$Created);
    });
    var $author$project$Components$Partner$NewProduct$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$NewProduct$Icon = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Common$Marketplace$Product$ProductType$default = 0;
    var $author$project$Components$Partner$NewProduct$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    _A: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    G7: A2($elm$core$Maybe$withDefault, $author$project$Api$Common$Marketplace$Product$ProductType$default, $author$project$Api$Common$Marketplace$Product$ProductType$fromString(string))
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    zr: string
                });
            case 3:
                var _int = field.a;
                var string = field.b;
                return _Utils_update(fields, {
                    QZ: $elm$core$Maybe$Just(_Utils_Tuple2(_int, string))
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    NQ: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Components$Partner$NewProduct$update = F2(function(msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var field = msg.a;
            var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$NewProduct$formFieldsUpdate, field, model.PU);
            return _Utils_Tuple3(_Utils_update(model, {
                PU: newForm
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
            var icons = msg.a;
            var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v2) {
                var task = _v2.a;
                var size = _v2.b;
                return A2($elm$core$Task$perform, A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Icon(size)), task);
            }, A2($elm$core$Maybe$map, function(icon) {
                return _Utils_Tuple2($elm$file$File$toUrl(icon), $elm$file$File$size(icon));
            }, $elm$core$List$head(icons))));
            return _Utils_Tuple3(model, cmd, _List_Nil);
        }
    });
    var $author$project$Components$Partner$NewProduct$IconValidation = 2;
    var $author$project$Components$Partner$NewProduct$NameValidation = 1;
    var $author$project$Components$Partner$NewProduct$SlugValidation = 0;
    var $author$project$Components$Partner$NewProduct$maxIconBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
    var $author$project$Components$Partner$NewProduct$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $._A;
        }, _Utils_Tuple2(0, 'Please enter a slug.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.zr;
        }, _Utils_Tuple2(1, 'Please enter a name.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.QZ;
        }, _Utils_Tuple2(2, 'Please select an icon to upload.')),
        $rtfeldman$elm_validate$Validate$fromErrors(function(fields) {
            var _v0 = fields.QZ;
            if (!_v0.$) {
                var _v1 = _v0.a;
                var iconSize = _v1.a;
                return _Utils_cmp(iconSize, $author$project$Components$Partner$NewProduct$maxIconBytesSize) > 0 ? _List_fromArray([
                    _Utils_Tuple2(2, 'That image is too large! Our maximum image size is 5 mb, please choose a smaller image.')
                ]) : _List_Nil;
            } else return _List_Nil;
        })
    ]));
    var $author$project$Components$Partner$NewProduct$validate = function(_v0) {
        var model = _v0;
        var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$NewProduct$formFieldsValidator, model.PU);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var validFormFields = _v2.b;
            var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
            var iconUrl = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$Tuple$second, fields.QZ));
            return $elm$core$Result$Ok(_List_fromArray([
                $author$project$Api$Partner$PartnerProduct$Slug(fields._A),
                $author$project$Api$Partner$PartnerProduct$ProductType(fields.G7),
                $author$project$Api$Partner$PartnerProduct$Name(fields.zr),
                $author$project$Api$Partner$PartnerProduct$Icon(iconUrl),
                $author$project$Api$Partner$PartnerProduct$Summary(fields.NQ)
            ]));
        } else {
            var validatedForm = _v1.a;
            return $elm$core$Result$Err(_Utils_update(model, {
                PU: validatedForm
            }));
        }
    };
    var $author$project$Pages$Partner$Product$New$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$Partner$NewProduct$update, subMsg, model.PU);
                var form = _v1.a;
                var cmd = _v1.b;
                var outMsgs = _v1.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: form
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Product$New$FormMsg, cmd), outMsgs);
            case 1:
                var _v2 = $author$project$Components$Partner$NewProduct$validate(model.PU);
                if (!_v2.$) {
                    var permittedFields = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$Partner$Product$New$createProduct, model.Ej, permittedFields), _List_Nil);
                } else {
                    var updatedForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: updatedForm,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Partner__Product), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Product created'),
                    $author$project$OutMsg$RefreshPartner
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$Partner$Product$New$Save = {
        $: 1
    };
    var $author$project$Components$Partner$NewProduct$Description = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$NewProduct$IconUploaded = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$NewProduct$Name = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$NewProduct$ProductType = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$NewProduct$Slug = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$NewProduct$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Icon'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap4,
                    $author$project$Ui$Element$flexCol
                ]), _List_fromArray([
                    $author$project$Components$Partner$ProductIconInstructions$view,
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$flexCol
                    ]), _List_fromArray([
                        function() {
                            var _v1 = fields.QZ;
                            if (!_v1.$) {
                                var _v2 = _v1.a;
                                var url = _v2.b;
                                return A3($author$project$Ui$Image$fromSrc, {
                                    Jg: 'Product icon'
                                }, url, _List_fromArray([
                                    $author$project$Ui$Image$height(64),
                                    $author$project$Ui$Image$width(64)
                                ]));
                            } else return $elm$html$Html$text('');
                        }(),
                        $author$project$Ui$Form$File$view(_List_fromArray([
                            $author$project$Ui$Form$File$accept(0),
                            $author$project$Ui$Form$File$onInput($author$project$Components$Partner$NewProduct$IconUploaded),
                            $author$project$Ui$Form$File$empty(!_Utils_eq(fields.QZ, $elm$core$Maybe$Nothing))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.zr),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Name)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Slug'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields._A),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Slug)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Product Type'),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$ProductType$toString(fields.G7))),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$ProductType))
                ]), A2($elm$core$List$map, function(type_) {
                    return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Common$Marketplace$Product$ProductType$toString(type_)), $author$project$Api$Common$Marketplace$Product$ProductType$toLabel(type_));
                }, $author$project$Api$Common$Marketplace$Product$ProductType$all)),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textSm,
                    $author$project$Ui$Element$textMuted,
                    $author$project$Ui$Element$mt2
                ]), _List_fromArray([
                    $elm$html$Html$text('Integration partners sync data between systems, application partners embed partner-powered workflows directly inside Hint, and solutions partners offer strategic or commercial benefits without any technical integration. Learn more '),
                    A3($author$project$Ui$Link$externalHref, 'https://developers.hint.com/docs/marketplace', _List_Nil, _List_fromArray([
                        $elm$html$Html$text('here')
                    ])),
                    $elm$html$Html$text('.')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8),
                $author$project$Ui$Form$Group$label('Summary')
            ]), _List_fromArray([
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', fields.NQ)),
                    $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$NewProduct$FormUpdated, $author$project$Components$Partner$NewProduct$Description))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt2,
                    $author$project$Ui$Element$textMuted,
                    $author$project$Ui$Element$textSm
                ]), _List_fromArray([
                    $elm$html$Html$text('One sentence that describes your product without repeating the product name shown above.')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Product$New$view = function(model) {
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Product$New$Save)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('New Product')
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$Partner$Product$New$FormMsg, $author$project$Components$Partner$NewProduct$view(model.PU))
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter
                        ]), _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Partner__Dashboard__Top, _List_fromArray([
                                $author$project$Ui$Link$buttonSecondary
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Create new product'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Create')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'New Product'
        };
    };
    var $author$project$Pages$Partner$Product$New$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Product$New$init,
        aeR: $author$project$Pages$Partner$Product$New$load,
        ag3: $author$project$Pages$Partner$Product$New$save,
        ahE: $author$project$Pages$Partner$Product$New$subscriptions,
        aaO: $author$project$Pages$Partner$Product$New$update,
        aid: $author$project$Pages$Partner$Product$New$view
    });
    var $author$project$Pages$Partner$Sandboxes$Top$GotSandboxPartners = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartnersParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                af_: model.eE,
                ahs: model.jX
            });
        };
    };
    var $author$project$Api$Partner$Partner$All$Partner = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Partner$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Partner$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Sandbox$Partner$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Partner$Sandbox$Partner$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$Sandbox$Partner$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Partner$Sandbox$Partner$sandboxesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'sandboxes',
        'partners'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Sandbox$Partner$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$Partner$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Sandbox$Partner$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Partner$sandboxesPath)));
    });
    var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners = function(model) {
        return A3($author$project$Api$Partner$Sandbox$Partner$list, model.Ej, $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartnersParams(model), $author$project$Pages$Partner$Sandboxes$Top$GotSandboxPartners);
    };
    var $author$project$Pages$Partner$Sandboxes$Top$GotSandboxPractices = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPracticesParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                af_: model.eF,
                ahs: model.jY
            });
        };
    };
    var $author$project$Api$Partner$Practice$All$Practice = $elm$core$Basics$identity;
    var $author$project$Api$Partner$Practice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$Practice$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$Sandbox$Practice$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Partner$Sandbox$Practice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$Sandbox$Practice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Partner$Sandbox$Practice$sandboxesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'sandboxes',
        'practices'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Sandbox$Practice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$Practice$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Sandbox$Practice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Practice$sandboxesPath)));
    });
    var $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices = function(model) {
        return A3($author$project$Api$Partner$Sandbox$Practice$list, model.Ej, $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPracticesParams(model), $author$project$Pages$Partner$Sandboxes$Top$GotSandboxPractices);
    };
    var $author$project$Pages$Partner$Sandboxes$Top$init = F4(function(_v0, partner, shared, _v1) {
        var query = _v1.Bz;
        var model = {
            bN: $elm$core$Maybe$Nothing,
            bO: $elm$core$Maybe$Nothing,
            Ej: shared.Ej,
            Mv: $author$project$Api$Data$NotAsked,
            dG: $elm$core$Set$empty,
            F3: $author$project$Shared$isHintAdmin(shared),
            VW: partner,
            sD: $author$project$Api$Data$Loading,
            eE: A2($author$project$Api$Pagination$fromQuery, query, A2($author$project$Api$Pagination$withPrefix, 'sandbox_partners', $author$project$Api$Pagination$init)),
            jX: A3($author$project$Api$Sort$withDefault, 'name', 1, A2($author$project$Api$Sort$fromQuery, query, A2($author$project$Api$Sort$withPrefix, 'sandbox_partners', $author$project$Api$Sort$init))),
            sE: $author$project$Api$Data$Loading,
            eF: A2($author$project$Api$Pagination$fromQuery, query, A2($author$project$Api$Pagination$withPrefix, 'sandbox_practices', $author$project$Api$Pagination$init)),
            jY: A3($author$project$Api$Sort$withDefault, 'name', 1, A2($author$project$Api$Sort$fromQuery, query, A2($author$project$Api$Sort$withPrefix, 'sandbox_practices', $author$project$Api$Sort$init)))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(model),
            $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model)
        ])));
    });
    var $author$project$Pages$Partner$Sandboxes$Top$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Sandboxes$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Sandboxes$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Partner$Sandboxes$Top$ClinicalAccountCreated = F2(function(a, b) {
        return {
            $: 18,
            a: a,
            b: b
        };
    });
    var $author$project$OutMsg$GoToDefaultStateAndReloadAction = {
        $: 3
    };
    var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnerCreated = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticeCreated = F2(function(a, b) {
        return {
            $: 15,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$Sandbox$Partner$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('partner', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.zr))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Partner$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Partner$sandboxesPath)));
    });
    var $author$project$Api$Partner$Practice$One$Practice = 0;
    var $author$project$Api$Partner$Practice$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Partner$Sandbox$Practice$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('name', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, params.zr))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$Practice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Sandbox$Practice$sandboxesPath)));
    });
    var $author$project$Api$Partner$Sandbox$Practice$sandboxePath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Partner$Sandbox$Practice$sandboxesPath);
    };
    var $author$project$Api$Partner$Sandbox$Practice$createClinicalAccount = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'create_clinical_account'
        ]), $author$project$Api$Partner$Sandbox$Practice$sandboxePath(id))));
    });
    var $author$project$Api$Partner$Partner$One$sandboxOf = function(_v0) {
        var record = _v0.b;
        return record.Zp;
    };
    var $author$project$Pages$Partner$Sandboxes$Top$updateUrl = function(model) {
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Sandboxes__Top)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.eF), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.jY), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.eE), $author$project$Api$Sort$toQuery(model.jX))))));
    };
    var $author$project$Pages$Partner$Sandboxes$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        sD: response,
                        eE: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.eE)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    sD: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        sE: response,
                        eF: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.eF)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    sE: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.eE);
                var newModel = _Utils_update(model, {
                    sD: $author$project$Api$Data$Loading,
                    eE: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(newModel),
                    $author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.eF);
                var newModel = _Utils_update(model, {
                    sE: $author$project$Api$Data$Loading,
                    eF: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(newModel),
                    $author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 4:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    sD: $author$project$Api$Data$Loading,
                    jX: A2($author$project$Api$Sort$update, columnId, model.jX)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(newModel),
                    $author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 5:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    sE: $author$project$Api$Data$Loading,
                    jY: A2($author$project$Api$Sort$update, columnId, model.jY)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(newModel),
                    $author$project$Pages$Partner$Sandboxes$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 6:
                var name = $author$project$Api$Partner$Partner$One$name(model.VW) + ' Sandbox';
                return _Utils_Tuple3(_Utils_update(model, {
                    bN: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                return _Utils_Tuple3(_Utils_update(model, {
                    bN: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var _v3 = model.bN;
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var name = _v4.a;
                    if (!name.$) {
                        var name_ = name.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bN: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name_), $author$project$Api$Data$Loading))
                        }), A3($author$project$Api$Partner$Sandbox$Partner$create, model.Ej, {
                            zr: $elm$core$Maybe$Just(name_)
                        }, $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnerCreated(name_)), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var name = msg.a;
                var _v6 = model.bN;
                if (!_v6.$) {
                    var _v7 = _v6.a;
                    var request = _v7.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bN: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$String$toMaybe(name), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var name = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bN: $elm$core$Maybe$Nothing,
                    sD: $author$project$Api$Data$Loading
                }), $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPartners(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Sandbox added')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    bN: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name), response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                var name = $author$project$Api$Partner$Partner$One$name(model.VW) + ' Sandbox Practice';
                return _Utils_Tuple3(_Utils_update(model, {
                    bO: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                return _Utils_Tuple3(_Utils_update(model, {
                    bO: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var _v9 = model.bO;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var name = _v10.a;
                    if (!name.$) {
                        var name_ = name.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bO: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name_), $author$project$Api$Data$Loading))
                        }), A3($author$project$Api$Partner$Sandbox$Practice$create, model.Ej, {
                            zr: $elm$core$Maybe$Just(name_)
                        }, $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticeCreated(name_)), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var name = msg.a;
                var _v12 = model.bO;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var request = _v13.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bO: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Utils$String$toMaybe(name), request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var name = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    bO: $elm$core$Maybe$Nothing,
                    sE: $author$project$Api$Data$Loading
                }), $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Sandbox practice added')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    bO: $elm$core$Maybe$Just(_Utils_Tuple2($elm$core$Maybe$Just(name), response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 16:
                var organizationId = msg.a;
                var postOrganizationSwitchedAction = _Utils_eq($author$project$Api$Partner$Partner$One$sandboxOf(model.VW), $elm$core$Maybe$Nothing) ? $author$project$OutMsg$GoToDefaultStateAndReloadAction : $author$project$OutMsg$GoToDefaultStateAction;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, postOrganizationSwitchedAction)
                ]));
            case 17:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    dG: A2($elm$core$Set$insert, id, model.dG)
                }), A3($author$project$Api$Partner$Sandbox$Practice$createClinicalAccount, model.Ej, id, $author$project$Pages$Partner$Sandboxes$Top$ClinicalAccountCreated(id)), _List_Nil);
            default:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dG: A2($elm$core$Set$remove, id, model.dG),
                            sE: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Partner$Sandboxes$Top$fetchSandboxPractices(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Clinical account successfully created')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dG: A2($elm$core$Set$remove, id, model.dG)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed = {
        $: 7
    };
    var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerNameUpdated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPartner = {
        $: 8
    };
    var $author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPartnerModal = F2(function(name, request) {
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add Sandbox')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Name'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', name)),
                        $author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerNameUpdated),
                        $author$project$Ui$Form$Input$invalid(_Utils_eq(name, $elm$core$Maybe$Nothing)),
                        $author$project$Ui$Form$Input$errors(_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray([
                            'Name is required'
                        ]) : _List_Nil)
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartnerClosed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add Sandbox'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPartner),
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Sandbox')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed = {
        $: 12
    };
    var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeNameUpdated = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPractice = {
        $: 13
    };
    var $author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPracticeModal = F2(function(name, request) {
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Add Sandbox')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Name'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', name)),
                        $author$project$Ui$Form$Input$onInput($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeNameUpdated),
                        $author$project$Ui$Form$Input$invalid(_Utils_eq(name, $elm$core$Maybe$Nothing)),
                        $author$project$Ui$Form$Input$errors(_Utils_eq(name, $elm$core$Maybe$Nothing) ? _List_fromArray([
                            'Name is required'
                        ]) : _List_Nil)
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPracticeClosed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add Sandbox'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$SaveSandboxPractice),
                    $author$project$Ui$Button$loading(_Utils_eq(request, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Sandbox')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartner = {
        $: 6
    };
    var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersPaginationMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersSortTable = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$sandboxPartnersColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'Name')
    ]);
    var $author$project$Ui$Table$Success = 1;
    var $author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$Partner$Partner$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Partner$Shared$id(shared);
    };
    var $author$project$Api$Partner$Partner$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Partner$Shared$name(shared);
    };
    var $author$project$Api$Partner$Partner$All$organizationId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Partner$Shared$organizationId(shared);
    };
    var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartner = F2(function(model, sandboxPartner) {
        var sandboxName = $author$project$Api$Partner$Partner$All$name(sandboxPartner);
        var isCurrentSandbox = _Utils_eq($author$project$Api$Partner$Partner$All$id(sandboxPartner), $author$project$Api$Partner$Partner$One$id(model.VW));
        var rowOptions = isCurrentSandbox ? _List_fromArray([
            $author$project$Ui$Table$styled(1)
        ]) : _List_Nil;
        return A2($author$project$Ui$Table$row, rowOptions, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(sandboxName)
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                isCurrentSandbox ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                    abP: 'Switch' + sandboxName
                }, _List_fromArray([
                    $author$project$Ui$Button$default,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox($author$project$Api$Partner$Partner$All$organizationId(sandboxPartner)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Switch')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartnersTable = function(model) {
        var _v0 = function() {
            var _v1 = model.sD;
            if (_v1.$ === 3) {
                var sandboxPartners_ = _v1.a;
                return _Utils_Tuple2(false, sandboxPartners_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var sandboxPartners = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any sandbox partners')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.jX, $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersSortTable)), $author$project$Pages$Partner$Sandboxes$Top$sandboxPartnersColumns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ])
        ])), A2($elm$core$List$map, $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartner(model), sandboxPartners), _List_Nil);
    };
    var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartners = function(model) {
        var loading = function() {
            var _v2 = model.sD;
            if (_v2.$ === 3) return false;
            else return true;
        }();
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Sandbox Partners')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        function() {
                            var _v0 = _Utils_Tuple2($author$project$Api$Partner$Partner$One$sandboxOf(model.VW), $author$project$Api$Partner$Partner$One$sandboxEnabled(model.VW));
                            if (_v0.a.$ === 1 && _v0.b) {
                                var _v1 = _v0.a;
                                return A3($author$project$Ui$Button$view, {
                                    abP: 'Add sandbox partner'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$default,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPartner)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add Sandbox Partner')
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ])),
            $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartnersTable(model),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Partner$Sandboxes$Top$SandboxPartnersPaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(loading)
                ]), model.eE))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Sandboxes$Top$NewSandboxPractice = {
        $: 11
    };
    var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesPaginationMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesSortTable = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$sandboxPracticesColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'name', true, 'Name')
    ]);
    var $author$project$Pages$Partner$Sandboxes$Top$CreateClinicalAccount = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Api$Partner$Practice$All$hasClinicalAccount = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Practice$Shared$hasClinicalAccount(shared);
    };
    var $author$project$Api$Partner$Practice$Shared$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Partner$Practice$Min$id(min);
    };
    var $author$project$Api$Partner$Practice$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Practice$Shared$id(shared);
    };
    var $author$project$Api$Partner$Practice$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Practice$Shared$name(shared);
    };
    var $author$project$Api$Partner$Practice$Shared$organizationId = function(_v0) {
        var record = _v0.b;
        return record.afV;
    };
    var $author$project$Api$Partner$Practice$All$organizationId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Partner$Practice$Shared$organizationId(shared);
    };
    var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractice = F2(function(model, sandboxPractice) {
        var sandboxName = $author$project$Api$Partner$Practice$All$name(sandboxPractice);
        var sandboxId = $author$project$Api$Partner$Practice$All$id(sandboxPractice);
        var loading = A2($elm$core$Set$member, sandboxId, model.dG);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(sandboxName)
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $author$project$Api$Partner$Practice$All$hasClinicalAccount(sandboxPractice) || !$author$project$Api$Partner$Partner$One$sandboxEnabled(model.VW) ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                    abP: 'Create Clinical Account'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$CreateClinicalAccount(sandboxId))
                ]), _List_fromArray([
                    $elm$html$Html$text('Create Clinical Account')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Switch ' + sandboxName
                }, _List_fromArray([
                    $author$project$Ui$Button$default,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$SwitchToSandbox($author$project$Api$Partner$Practice$All$organizationId(sandboxPractice)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Switch')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPracticesTable = function(model) {
        var _v0 = function() {
            var _v1 = model.sE;
            if (_v1.$ === 3) {
                var sandboxPractices_ = _v1.a;
                return _Utils_Tuple2(false, sandboxPractices_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var sandboxPractices = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any sandbox practices')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.jY, $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesSortTable)), $author$project$Pages$Partner$Sandboxes$Top$sandboxPracticesColumns),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
            ])
        ])), A2($elm$core$List$map, $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractice(model), sandboxPractices), _List_Nil);
    };
    var $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractices = function(model) {
        var loading = function() {
            var _v2 = model.sE;
            if (_v2.$ === 3) return false;
            else return true;
        }();
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Sandbox Practices')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        function() {
                            var _v0 = _Utils_Tuple2($author$project$Api$Partner$Partner$One$sandboxOf(model.VW), $author$project$Api$Partner$Partner$One$sandboxEnabled(model.VW));
                            if (_v0.a.$ === 1 && _v0.b) {
                                var _v1 = _v0.a;
                                return A3($author$project$Ui$Button$view, {
                                    abP: 'Add sandbox practice'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$default,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Sandboxes$Top$NewSandboxPractice)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add Sandbox Practice')
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ])),
            $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPracticesTable(model),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Partner$Sandboxes$Top$SandboxPracticesPaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(loading)
                ]), model.eF))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Sandboxes$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.bN;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var name = _v1.a;
                        var request = _v1.b;
                        return A2($author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPartnerModal, name, request);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.bO;
                    if (!_v2.$) {
                        var _v3 = _v2.a;
                        var name = _v3.a;
                        var request = _v3.b;
                        return A2($author$project$Pages$Partner$Sandboxes$Top$viewAddSandboxPracticeModal, name, request);
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPartners(model)
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        $author$project$Pages$Partner$Sandboxes$Top$viewSandboxPractices(model)
                    ]))
                ]))
            ]),
            $2: 'Partner | Sandboxes'
        };
    };
    var $author$project$Pages$Partner$Sandboxes$Top$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Sandboxes$Top$init,
        aeR: $author$project$Pages$Partner$Sandboxes$Top$load,
        ag3: $author$project$Pages$Partner$Sandboxes$Top$save,
        ahE: $author$project$Pages$Partner$Sandboxes$Top$subscriptions,
        aaO: $author$project$Pages$Partner$Sandboxes$Top$update,
        aid: $author$project$Pages$Partner$Sandboxes$Top$view
    });
    var $author$project$Pages$Partner$Team$GotRoles = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('q'), model.agq)
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Team)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Pages$Partner$Team$GotTeamMembers = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerUser$All$PartnerUser = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$PartnerUser$Shared$PartnerUser = $elm$core$Basics$identity;
    var $author$project$Api$Partner$PartnerUser$Shared$Record = F8(function(id, email, role, notificationsEnabled, invitationPending, isOwner, isDestroyable, user) {
        return {
            OH: email,
            aef: id,
            Ry: invitationPending,
            R1: isDestroyable,
            Sf: isOwner,
            U8: notificationsEnabled,
            ag_: role,
            aaX: user
        };
    });
    var $author$project$Api$Partner$User$One$User = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$User$One$Record = function(mfaStatus) {
        return {
            Ug: mfaStatus
        };
    };
    var $author$project$Api$Partner$User$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'mfa_status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$User$One$Record));
    var $author$project$Api$Partner$User$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$User$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$User$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$User$One$User)));
    var $author$project$Api$Partner$PartnerUser$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'user', $elm$json$Json$Decode$nullable($author$project$Api$Partner$User$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_destroyable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_owner', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_pending', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'notifications_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'role', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$Shared$Record)))))))));
    var $author$project$Api$Partner$PartnerUser$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerUser$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$PartnerUser$All$Record = function(invitationUrl) {
        return {
            Rz: invitationUrl
        };
    };
    var $author$project$Api$Partner$PartnerUser$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invitation_url', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$All$Record));
    var $author$project$Api$Partner$PartnerUser$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerUser$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$PartnerUser$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$PartnerUser$All$PartnerUser)));
    var $author$project$Api$Partner$TeamMember$listOptionalsDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Partner$TeamMember$listOptionalsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$TeamMember$listOptionalsDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Partner$TeamMember$teamMembersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'team_members'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$TeamMember$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$PartnerUser$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$TeamMember$listOptionalsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$TeamMember$teamMembersPath)));
    });
    var $author$project$Pages$Partner$Team$fetchTeamMembers = function(model) {
        return A3($author$project$Api$Partner$TeamMember$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        }, $author$project$Pages$Partner$Team$GotTeamMembers);
    };
    var $author$project$Api$Partner$Role$rolesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'roles'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$Role$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$Role$rolesPath));
    });
    var $author$project$Pages$Partner$Team$init = F4(function(session, partner, shared, _v0) {
        var query = _v0.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            Ej: shared.Ej,
            E2: $author$project$Api$Platform$Session$One$user(session),
            lV: $elm$core$Maybe$Nothing,
            dZ: $elm$core$Set$empty,
            iq: $elm$core$Maybe$Nothing,
            F3: $author$project$Shared$isHintAdmin(shared),
            ef: $elm$core$Set$empty,
            afY: shared.adU.afY,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            VW: partner,
            agq: q,
            Cc: $author$project$Api$Data$Loading,
            sG: $author$project$Ui$SearchInput$init(q),
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'user_first_name', 0, $author$project$Api$Sort$initFromQuery(query)),
            A: $elm$core$Maybe$Nothing,
            eO: $author$project$Api$Data$Loading,
            ts: A2($author$project$Components$Admin$ToogleOrganizationMfa$init, session, $author$project$Components$Admin$ToogleOrganizationMfa$Partner(partner))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Partner$Team$fetchTeamMembers(model),
            A2($author$project$Api$Partner$Role$list, shared.Ej, $author$project$Pages$Partner$Team$GotRoles),
            A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Partner$Team$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Team$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Team$CancelTeamMemberEdit = {
        $: 3
    };
    var $author$project$Pages$Partner$Team$DeleteConfirmClosed = F2(function(a, b) {
        return {
            $: 14,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Team$DisableMfaConfirmClosed = F2(function(a, b) {
        return {
            $: 16,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$PartnerUser$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$PartnerUser$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerUser$Shared$id(shared);
    };
    var $author$project$Pages$Partner$Team$subscriptions = function(_v0) {
        var teamMember = _v0.A;
        var deletingTeamMember = _v0.lV;
        var disablingMfaTeamMember = _v0.iq;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Team$CancelTeamMemberEdit)), teamMember)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Partner$Team$DeleteConfirmClosed), $author$project$Api$Partner$PartnerUser$All$id), deletingTeamMember)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Partner$Team$DisableMfaConfirmClosed), disablingMfaTeamMember))
        ]));
    };
    var $author$project$Pages$Partner$Team$GotInvitation = F3(function(a, b, c) {
        return {
            $: 21,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Pages$Partner$Team$InviteLinkMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$MfaStatus = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$SearchInputMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$TeamMemberDeleted = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Team$TeamMemberMfaDisabled = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$ToogleOrganizationMfa = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Api$Partner$TeamMember$teamMemberPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Partner$TeamMember$teamMembersPath);
    };
    var $author$project$Api$Partner$TeamMember$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$TeamMember$teamMemberPath(id_)));
    });
    var $author$project$Api$Partner$TeamMember$disableMfa = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'mfa'
        ]), $author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
    });
    var $author$project$Api$Partner$PartnerUser$Shared$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Partner$PartnerUser$All$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerUser$Shared$email(shared);
    };
    var $author$project$Api$Partner$User$One$mfaStatus = function(_v0) {
        var record = _v0.b;
        return record.Ug;
    };
    var $author$project$Api$Partner$PartnerUser$Shared$user = function(_v0) {
        var record = _v0;
        return record.aaX;
    };
    var $author$project$Api$Partner$PartnerUser$All$user = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerUser$Shared$user(shared);
    };
    var $author$project$Pages$Partner$Team$mfaStatus = function(teamMember) {
        var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Partner$PartnerUser$All$user, teamMember);
        if (!_v0.$) {
            var user = _v0.a;
            return $author$project$Api$Partner$User$One$mfaStatus(user);
        } else return 'invite pending';
    };
    var $author$project$Api$Partner$PartnerUser$Shared$notificationsEnabled = function(_v0) {
        var record = _v0;
        return record.U8;
    };
    var $author$project$Api$Partner$PartnerUser$All$notificationsEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerUser$Shared$notificationsEnabled(shared);
    };
    var $author$project$Api$Partner$PartnerUser$Shared$role = function(_v0) {
        var record = _v0;
        return record.ag_;
    };
    var $author$project$Api$Partner$PartnerUser$All$role = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerUser$Shared$role(shared);
    };
    var $author$project$Pages$Partner$Team$formFieldsFromTeamMember = function(teamMember) {
        return {
            abX: '',
            OH: $author$project$Api$Partner$PartnerUser$All$email(teamMember),
            aez: false,
            Ug: $author$project$Pages$Partner$Team$mfaStatus($elm$core$Maybe$Just(teamMember)),
            U8: $author$project$Api$Partner$PartnerUser$All$notificationsEnabled(teamMember),
            ag_: $author$project$Api$Partner$PartnerUser$All$role(teamMember)
        };
    };
    var $author$project$Pages$Partner$Team$formFieldsInit = function(origin) {
        return {
            abX: origin + '/join/',
            OH: '',
            aez: true,
            Ug: $author$project$Pages$Partner$Team$mfaStatus($elm$core$Maybe$Nothing),
            U8: true,
            ag_: ''
        };
    };
    var $author$project$Pages$Partner$Team$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    OH: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    ag_: string
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    U8: bool
                });
            case 3:
                var string = field.a;
                return _Utils_update(fields, {
                    Ug: string
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    aez: bool
                });
        }
    });
    var $author$project$Pages$Partner$Team$EmailValidation = 0;
    var $author$project$Pages$Partner$Team$RoleValidation = 1;
    var $author$project$Pages$Partner$Team$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: false
        }, A2($elm$core$Basics$composeR, function($) {
            return $.OH;
        }, $elm$core$Maybe$Just), _Utils_Tuple2(0, 'Please enter a valid email.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.ag_;
        }, _Utils_Tuple2(1, 'Please pick a role.'))
    ]));
    var $author$project$Api$Partner$PartnerUser$One$PartnerUser = 0;
    var $author$project$Api$Partner$PartnerUser$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Partner$TeamMember$invite = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerUser$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invite'
        ]), $author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
    });
    var $author$project$Pages$Partner$Team$TeamMemberCreated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Partner$TeamMember$create = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('team_member', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('base_url', $elm$json$Json$Encode$string(fields.abX)),
                _Utils_Tuple2('email', $elm$json$Json$Encode$string(fields.OH)),
                _Utils_Tuple2('role', $elm$json$Json$Encode$string(fields.ag_)),
                _Utils_Tuple2('notifications_enabled', $elm$json$Json$Encode$bool(fields.U8))
            ]))),
            _Utils_Tuple2('invite', $elm$json$Json$Encode$bool(fields.aez))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$PartnerUser$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$TeamMember$teamMembersPath)));
    });
    var $author$project$Pages$Partner$Team$createTeamMember = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Partner$TeamMember$create, apiClient, {
            abX: fields.abX,
            OH: fields.OH,
            aez: fields.aez,
            U8: fields.U8,
            ag_: fields.ag_
        }, $author$project$Pages$Partner$Team$TeamMemberCreated);
    });
    var $author$project$Pages$Partner$Team$TeamMemberUpdated = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Partner$TeamMember$update = F4(function(apiClient, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('team_member', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                A3($author$project$Utils$Encode$optional, 'role', $elm$json$Json$Encode$string, fields.ag_),
                A3($author$project$Utils$Encode$optional, 'notifications_enabled', $elm$json$Json$Encode$bool, fields.U8)
            ]))))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$PartnerUser$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$TeamMember$teamMemberPath(id_))));
    });
    var $author$project$Pages$Partner$Team$updateTeamMember = F3(function(apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Partner$TeamMember$update, apiClient, id, {
            U8: $elm$core$Maybe$Just(fields.U8),
            ag_: $elm$core$Maybe$Just(fields.ag_)
        }, $author$project$Pages$Partner$Team$TeamMemberUpdated);
    });
    var $author$project$Pages$Partner$Team$saveTeamMember = F3(function(apiClient, maybeId, formFields) {
        if (!maybeId.$) {
            var id = maybeId.a;
            return A3($author$project$Pages$Partner$Team$updateTeamMember, apiClient, id, formFields);
        } else return A2($author$project$Pages$Partner$Team$createTeamMember, apiClient, formFields);
    });
    var $author$project$Pages$Partner$Team$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Cc: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    A: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init($author$project$Pages$Partner$Team$formFieldsInit(model.afY)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var field = msg.a;
                var _v1 = model.A;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var teamMember = _v2.a;
                    var form = _v2.b;
                    var request = _v2.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Team$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, request))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var form = msg.a;
                var teamMember = msg.b;
                var id = msg.c;
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Team$formFieldsValidator, form);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$Loading))
                    }), A3($author$project$Pages$Partner$Team$saveTeamMember, model.Ej, id, validFormFields), _List_Nil);
                } else {
                    var newForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var teamMember = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    A: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(teamMember), $author$project$Utils$Form$init($author$project$Pages$Partner$Team$formFieldsFromTeamMember(teamMember)), $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    A: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        eO: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    eO: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var subMsg = msg.a;
                var _v6 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v6.a;
                var searchInputCmd = _v6.b;
                var searchInputEvent = _v6.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v7 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            agq: q,
                            eO: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$Partner$Team$fetchTeamMembers(qModel),
                            A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                        ])));
                    }
                }();
                var newModel = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 6:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    eO: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Team$fetchTeamMembers(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 7:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs),
                    eO: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Team$fetchTeamMembers(newModel),
                    A2($elm$core$Basics$composeR, $author$project$Pages$Partner$Team$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 10:
                var response = msg.a;
                var _v9 = model.A;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var teamMember = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Partner$Team$fetchTeamMembers(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully added')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var response = msg.a;
                var _v12 = model.A;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var id = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Nothing
                    }), $author$project$Pages$Partner$Team$fetchTeamMembers(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully updated')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dZ: A2($elm$core$Set$remove, id, model.dZ),
                            eO: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Partner$Team$fetchTeamMembers(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Team member successfully removed')
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dZ: A2($elm$core$Set$remove, id, model.dZ)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 13:
                var teamMember = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    lV: $elm$core$Maybe$Just(teamMember)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var id = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    lV: $elm$core$Maybe$Nothing,
                    dZ: A2($elm$core$Set$insert, id, model.dZ)
                }), A3($author$project$Api$Partner$TeamMember$delete, model.Ej, id, $author$project$Pages$Partner$Team$TeamMemberDeleted(id)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    lV: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    iq: $elm$core$Maybe$Just(id)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var id = msg.a;
                var confirmed = msg.b;
                var _v16 = model.A;
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var teamMember = _v17.a;
                    var form = _v17.b;
                    return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                        iq: $elm$core$Maybe$Nothing,
                        A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, form, $author$project$Api$Data$Loading))
                    }), A3($author$project$Api$Partner$TeamMember$disableMfa, model.Ej, id, $author$project$Pages$Partner$Team$TeamMemberMfaDisabled), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        iq: $elm$core$Maybe$Nothing
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var response = msg.a;
                var _v18 = model.A;
                if (!_v18.$) {
                    var _v19 = _v18.a;
                    var teamMember = _v19.a;
                    var form = _v19.b;
                    switch(response.$){
                        case 3:
                            var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Team$formFieldsUpdate, $author$project$Pages$Partner$Team$MfaStatus('inactive'), form);
                            return _Utils_Tuple3(_Utils_update(model, {
                                A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, newForm, $author$project$Api$Data$NotAsked)),
                                eO: $author$project$Api$Data$Loading
                            }), $author$project$Pages$Partner$Team$fetchTeamMembers(model), _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Team member mfa successfully disabled')
                            ]));
                        case 2:
                            return _Utils_Tuple3(_Utils_update(model, {
                                A: $elm$core$Maybe$Just(_Utils_Tuple3(teamMember, form, $author$project$Api$Data$NotAsked))
                            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                        default:
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var teamMember = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Partner$TeamMember$invite, model.Ej, $author$project$Api$Partner$PartnerUser$All$id(teamMember), A2($author$project$Pages$Partner$Team$GotInvitation, $author$project$Api$Partner$PartnerUser$All$email(teamMember), false)), _List_Nil);
            case 19:
                var teamMember = msg.a;
                return _Utils_Tuple3(model, A3($author$project$Api$Partner$TeamMember$invite, model.Ej, $author$project$Api$Partner$PartnerUser$All$id(teamMember), A2($author$project$Pages$Partner$Team$GotInvitation, $author$project$Api$Partner$PartnerUser$All$email(teamMember), true)), _List_Nil);
            case 21:
                var email = msg.a;
                var isReinvite = msg.b;
                var response = msg.c;
                if (response.$ === 3) {
                    var prefix = isReinvite ? 'A new' : 'An';
                    return _Utils_Tuple3(_Utils_update(model, {
                        eO: $author$project$Api$Data$Loading
                    }), $author$project$Pages$Partner$Team$fetchTeamMembers(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, prefix + (' invitation is being sent to ' + email))
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 20:
                var subMsg = msg.a;
                var _v22 = $author$project$Components$InviteLink$update(subMsg);
                var inviteLinkCmd = _v22.a;
                var inviteLinkOutMsg = _v22.b;
                return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$InviteLinkMsg, inviteLinkCmd), inviteLinkOutMsg);
            default:
                var subMsg = msg.a;
                var toogleOrganizationMfaResult = A3($author$project$Components$Admin$ToogleOrganizationMfa$update, model.Ej, subMsg, model.ts);
                var newModel = function() {
                    var _v23 = toogleOrganizationMfaResult.adu;
                    switch(_v23.$){
                        case 0:
                            return model;
                        case 1:
                            return model;
                        default:
                            var partner = _v23.a;
                            return _Utils_update(model, {
                                VW: partner
                            });
                    }
                }();
                return _Utils_Tuple3(_Utils_update(newModel, {
                    ts: toogleOrganizationMfaResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Team$ToogleOrganizationMfa, toogleOrganizationMfaResult.EQ), toogleOrganizationMfaResult.at);
        }
    });
    var $author$project$Pages$Partner$Team$NewTeamMember = {
        $: 1
    };
    var $author$project$Pages$Partner$Team$PaginationMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$SortTable = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'user_first_name', true, 'Name'),
        A3($author$project$Api$Column$init, 'email', false, 'Email'),
        A3($author$project$Api$Column$init, 'role', true, 'Role'),
        A3($author$project$Api$Column$init, 'notifications', false, 'Notifications'),
        A3($author$project$Api$Column$init, 'mfa', false, 'MFA')
    ]);
    var $author$project$Pages$Partner$Team$EditTeamMember = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$InviteTeamMember = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$OpenDeleteConfirm = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$InviteLink$PartnerUser = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$ReInviteTeamMember = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Api$Partner$PartnerUser$Shared$isDestroyable = function(_v0) {
        var record = _v0;
        return record.R1;
    };
    var $author$project$Api$Partner$PartnerUser$All$isDestroyable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerUser$Shared$isDestroyable(shared);
    };
    var $author$project$Api$Partner$PartnerUser$Shared$isOwner = function(_v0) {
        var record = _v0;
        return record.Sf;
    };
    var $author$project$Api$Partner$PartnerUser$All$isOwner = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$PartnerUser$Shared$isOwner(shared);
    };
    var $author$project$Api$Partner$User$Shared$isAdmin = function(_v0) {
        var record = _v0;
        return record.RO;
    };
    var $author$project$Api$Partner$User$One$isAdmin = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$User$Shared$isAdmin(shared);
    };
    var $author$project$Api$Partner$PartnerUser$All$isHinter = function(_v0) {
        var shared = _v0.a;
        return A2($elm$core$String$contains, '@hint.com', $author$project$Api$Partner$PartnerUser$Shared$email(shared));
    };
    var $author$project$Api$Partner$PartnerUser$All$isSuperAdmin = function(partnerUser) {
        var _v0 = $author$project$Api$Partner$PartnerUser$All$user(partnerUser);
        if (_v0.$ === 1) return false;
        else {
            var user_ = _v0.a;
            return $author$project$Api$Partner$PartnerUser$All$isHinter(partnerUser) && $author$project$Api$Partner$User$One$isAdmin(user_);
        }
    };
    var $author$project$Api$Partner$User$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$User$Shared$name(shared);
    };
    var $author$project$Pages$Partner$Team$viewTeamMember = F5(function(currentUser, deletingTeamMembers, makingAdminTeamMembers, currentUserIsHintAdmin, teamMember) {
        var notificationsStatus = $author$project$Api$Partner$PartnerUser$All$notificationsEnabled(teamMember) ? 'enabled' : 'disabled';
        var memberIsOwner = $author$project$Api$Partner$PartnerUser$All$isOwner(teamMember);
        var isCurrentUser = _Utils_eq($author$project$Api$Partner$PartnerUser$All$email(teamMember), $author$project$Api$Platform$User$Shared$email(currentUser));
        var rowOptions = isCurrentUser ? _List_fromArray([
            $author$project$Ui$Table$styled(2)
        ]) : _List_Nil;
        var id = $author$project$Api$Partner$PartnerUser$All$id(teamMember);
        var loading = A2($elm$core$Set$member, id, deletingTeamMembers) || A2($elm$core$Set$member, id, makingAdminTeamMembers);
        return A2($author$project$Ui$Table$row, rowOptions, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$minWidth('11em')
            ]), function() {
                var _v0 = $author$project$Api$Partner$PartnerUser$All$user(teamMember);
                if (!_v0.$) {
                    var user = _v0.a;
                    var memberIsHintAdmin = $author$project$Api$Partner$PartnerUser$All$isSuperAdmin(teamMember);
                    var isOwnerOrAdminLabel = function() {
                        var _v1 = _Utils_Tuple3(memberIsOwner, memberIsHintAdmin, currentUserIsHintAdmin);
                        if (_v1.a) {
                            if (_v1.b) {
                                if (_v1.c) return $elm$html$Html$text(' (owner | admin)');
                                else return $elm$html$Html$text(' (owner)');
                            } else return $elm$html$Html$text(' (owner)');
                        } else {
                            if (_v1.b && _v1.c) return $elm$html$Html$text(' (admin)');
                            else return $author$project$Utils$Html$empty;
                        }
                    }();
                    return _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Partner$User$One$name(user))
                        ])),
                        isOwnerOrAdminLabel
                    ]);
                } else {
                    var isOwnerLabel = memberIsOwner ? $elm$html$Html$text(' (owner)') : $author$project$Utils$Html$empty;
                    return $author$project$Api$Partner$PartnerUser$All$invitationPending(teamMember) ? _List_fromArray([
                        A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Invitation Pending'),
                            isOwnerLabel
                        ])),
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Resend invite email'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$ReInviteTeamMember(teamMember)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Resend')
                            ])),
                            A2($elm$html$Html$map, $author$project$Pages$Partner$Team$InviteLinkMsg, $author$project$Components$InviteLink$view($author$project$Components$InviteLink$PartnerUser(teamMember)))
                        ]))
                    ]) : _List_fromArray([
                        A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Not Invited'),
                            isOwnerLabel
                        ])),
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Send invite email'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$InviteTeamMember(teamMember)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$send),
                                $author$project$Ui$Button$sm
                            ]), _List_fromArray([
                                $elm$html$Html$text('Send Invite')
                            ])),
                            A2($elm$html$Html$map, $author$project$Pages$Partner$Team$InviteLinkMsg, $author$project$Components$InviteLink$view($author$project$Components$InviteLink$PartnerUser(teamMember)))
                        ]))
                    ]);
                }
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$PartnerUser$All$email(teamMember))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Formatters$String$humanize($author$project$Api$Partner$PartnerUser$All$role(teamMember))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, notificationsStatus)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Pages$Partner$Team$mfaStatus($elm$core$Maybe$Just(teamMember)))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Edit team member'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$disabled(loading || memberIsOwner && !$author$project$Api$Platform$User$Shared$isAdmin(currentUser)),
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$EditTeamMember(teamMember)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ])),
                $author$project$Api$Partner$PartnerUser$All$isDestroyable(teamMember) && !isCurrentUser ? A3($author$project$Ui$Button$view, {
                    abP: 'Delete team member'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$loading(loading),
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$OpenDeleteConfirm(teamMember)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_fromArray([
                    $elm$html$Html$text('Delete')
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Team$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.eO;
            if (_v1.$ === 3) {
                var teamMembers_ = _v1.a;
                return _Utils_Tuple2(false, teamMembers_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var teamMembers = _v0.b;
        return _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Security')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$Partner$Team$ToogleOrganizationMfa, $author$project$Components$Admin$ToogleOrganizationMfa$view(model.ts)),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Members')
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb2
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Team$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_Nil, model.sG))
                    ]))
                ]))
            ])),
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('There are no team members.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Partner$Team$SortTable)), $author$project$Pages$Partner$Team$columns),
                _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                ])
            ])), A2($elm$core$List$map, A4($author$project$Pages$Partner$Team$viewTeamMember, model.E2, model.dZ, model.ef, model.F3), teamMembers), _List_Nil)
        ]);
    };
    var $author$project$Pages$Partner$Team$Email = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$FormUpdated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$Invite = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$NotificationsEnabled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$OpenDisableMfaConfirm = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$Role = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Team$SaveTeamMember = F3(function(a, b, c) {
        return {
            $: 8,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Pages$Partner$Team$roleOptions = function(roles) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Pick a role'), A2($elm$core$List$map, function(role) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Common$Role$All$name(role)), $author$project$Formatters$String$titleize($author$project$Formatters$String$humanize($author$project$Api$Common$Role$All$name(role))));
        }, roles));
    };
    var $author$project$Pages$Partner$Team$viewPermissionSet = F2(function(index, permissionSet) {
        var hasEvenIndex = !A2($elm$core$Basics$modBy, 2, index);
        var offset = hasEvenIndex ? $author$project$Ui$Grid$offsetSm(2) : $author$project$Ui$Grid$offset(1);
        return _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                offset,
                $author$project$Ui$Grid$span(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Formatters$String$humanize($author$project$Api$Common$PermissionSet$Shared$name(permissionSet)))
                        ])),
                        $author$project$Api$Common$PermissionSet$Shared$enabled(permissionSet) ? $author$project$Ui$Icon$check(_List_fromArray([
                            $author$project$Ui$Icon$success
                        ])) : $author$project$Ui$Icon$cross(_List_fromArray([
                            $author$project$Ui$Icon$danger
                        ]))
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Partner$Team$viewTeamMemberModal = F4(function(model, teamMember, request, form) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Team Member',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$id, teamMember),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Partner$Team$CancelTeamMemberEdit,
            Vn: A2($author$project$Pages$Partner$Team$SaveTeamMember, form, teamMember)
        };
        var isNewTeamMember = !$author$project$Utils$Maybe$toBool(teamMember);
        var isCurrentUser = _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$email, teamMember), $elm$core$Maybe$Just($author$project$Api$Platform$User$Shared$email(model.E2)));
        var roleDisabled = isCurrentUser || A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Partner$PartnerUser$All$isOwner, teamMember));
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = function() {
            var _v1 = model.Cc;
            if (_v1.$ === 3) {
                var list = _v1.a;
                return _Utils_Tuple2(list, false);
            } else return _Utils_Tuple2(_List_Nil, true);
        }();
        var roles_ = _v0.a;
        var rolesLoading = _v0.b;
        var permissionSets = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Common$Role$All$permissionSets, A2($elm_community$list_extra$List$Extra$find, function(role) {
            return _Utils_eq($author$project$Api$Common$Role$All$name(role), fields.ag_);
        }, roles_)));
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(isNewTeamMember),
                $author$project$Ui$Form$Group$label('Email')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.OH),
                    $author$project$Ui$Form$Input$placeholder('email@example.com'),
                    $author$project$Ui$Form$Input$autofocus(true),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Email)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form)),
                    $author$project$Ui$Form$Input$disabled(!isNewTeamMember)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$label('Role')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(fields.ag_)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Role)),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, form)),
                    $author$project$Ui$Form$Select$loading(rolesLoading),
                    $author$project$Ui$Form$Select$disabled(roleDisabled)
                ]), $author$project$Pages$Partner$Team$roleOptions(roles_)),
                roleDisabled ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$info
                ]), _List_fromArray([
                    $elm$html$Html$text('You cannot change your own role.')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Notifications')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.U8),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$NotificationsEnabled))
                ]))
            ])),
            isNewTeamMember ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Send invitation')
            ]), _List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on(fields.aez),
                    $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Team$FormUpdated, $author$project$Pages$Partner$Team$Invite))
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('MFA')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, fields.Ug),
                    $author$project$Utils$Html$noBreakSpace,
                    function() {
                        if (!teamMember.$) {
                            var teamMember_ = teamMember.a;
                            return fields.Ug === 'active' && !isCurrentUser ? A3($author$project$Ui$Button$view, {
                                abP: 'Reset MFA device'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$OpenDisableMfaConfirm($author$project$Api$Partner$PartnerUser$All$id(teamMember_)))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Reset MFA device')
                            ])) : $author$project$Utils$Html$empty;
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb2
            ]), $elm$core$List$concat(A2($elm$core$List$indexedMap, $author$project$Pages$Partner$Team$viewPermissionSet, permissionSets)))
        ]));
    });
    var $author$project$Pages$Partner$Team$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.A;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var teamMember = _v1.a;
                        var form = _v1.b;
                        var request = _v1.c;
                        return A4($author$project$Pages$Partner$Team$viewTeamMemberModal, model, teamMember, request, form);
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.lV;
                    if (!_v2.$) {
                        var teamMember = _v2.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Partner$Team$DeleteConfirmClosed($author$project$Api$Partner$PartnerUser$All$id(teamMember)), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$noun('team member'),
                            $author$project$Components$HiConfirm$detail($author$project$Api$Partner$PartnerUser$All$email(teamMember))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v3 = model.iq;
                    if (!_v3.$) {
                        var id = _v3.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Partner$Team$DisableMfaConfirmClosed(id), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('reset'),
                            $author$project$Components$HiConfirm$noun('MFA device'),
                            $author$project$Components$HiConfirm$titleizeNoun(false),
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text('Resetting the MFA device for this user will log them out of all sessions and require them to setup a new MFA device the next time they login.')
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween,
                            $author$project$Ui$Element$itemsCenter
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('Team')
                                ])),
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$small
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Changing settings within the Admin section requires \"Admin\" privileges. Non admin users can\n        view the settings but cannot change them.')
                                ]))
                            ])),
                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Add new member'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$default,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Team$NewTeamMember),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add')
                                ]))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Partner$Team$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Team$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.eO))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Admin | Team'
        };
    };
    var $author$project$Pages$Partner$Team$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Team$init,
        aeR: $author$project$Pages$Partner$Team$load,
        ag3: $author$project$Pages$Partner$Team$save,
        ahE: $author$project$Pages$Partner$Team$subscriptions,
        aaO: $author$project$Pages$Partner$Team$update,
        aid: $author$project$Pages$Partner$Team$view
    });
    var $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Requests$StatusDropdownMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Requests$GotWebhookRequests = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Partner$WebhookRequest$All$WebhookRequest = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$WebhookRequest$Shared$WebhookRequest = $elm$core$Basics$identity;
    var $author$project$Api$Partner$WebhookRequest$Shared$Record = F9(function(status, eventType, attempts, createdAt, deliveredAt, lastAttemptedAt, lastStatusCode, payload, lastResponse) {
        return {
            JM: attempts,
            Mx: createdAt,
            NJ: deliveredAt,
            O8: eventType,
            aeK: lastAttemptedAt,
            SX: lastResponse,
            S_: lastStatusCode,
            Wj: payload,
            ahy: status
        };
    });
    var $author$project$Api$Partner$WebhookRequest$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_response', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payload', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$value), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_status_code', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_attempted_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'delivered_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'attempts', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'event_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookRequest$Shared$Record))))))))));
    var $author$project$Api$Partner$WebhookRequest$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$WebhookRequest$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$WebhookRequest$All$Record = F2(function(webhookEndpoint, practice) {
        return {
            W1: practice,
            abi: webhookEndpoint
        };
    });
    var $author$project$Api$Partner$WebhookEndpoint$Min$WebhookEndpoint = $elm$core$Basics$identity;
    var $author$project$Api$Partner$WebhookEndpoint$Min$Record = F2(function(id, webhookUrl) {
        return {
            aef: id,
            abj: webhookUrl
        };
    });
    var $author$project$Api$Partner$WebhookEndpoint$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'webhook_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$Min$Record)));
    var $author$project$Api$Partner$WebhookEndpoint$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$WebhookEndpoint$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$WebhookRequest$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Partner$Practice$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'webhook_endpoint', $author$project$Api$Partner$WebhookEndpoint$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookRequest$All$Record)));
    var $author$project$Api$Partner$WebhookRequest$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$WebhookRequest$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$WebhookRequest$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookRequest$All$WebhookRequest)));
    var $author$project$Api$Partner$WebhookRequest$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        G1: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        ahy: $elm$core$Maybe$Nothing,
        H4: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Partner$WebhookRequest$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$WebhookRequest$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            function() {
                var _v0 = options.ahy;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.H4;
                if (!_v1.$) {
                    var string = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'webhook_endpoint', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.G1;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practice', string)
                    ]);
                } else return _List_Nil;
            }()
        ]));
    };
    var $author$project$Api$Partner$WebhookRequest$webhookRequestsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'webhook_requests'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$WebhookRequest$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$WebhookRequest$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$WebhookRequest$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookRequest$webhookRequestsPath)));
    });
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests = function(model) {
        return A3($author$project$Api$Partner$WebhookRequest$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                G1: $author$project$Components$ResourceFilter$Partner$Practice$value(model.jC),
                ahs: model.ahs,
                ahy: model.j4,
                H4: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$value(model.fI)
            });
        }, $author$project$Pages$Partner$Webhooks$Requests$GotWebhookRequests);
    };
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Api$Partner$WebhookEndpoint$All$WebhookEndpoint = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$WebhookEndpoint$Shared$WebhookEndpoint = $elm$core$Basics$identity;
    var $author$project$Api$Partner$WebhookEndpoint$Shared$Record = F4(function(id, webhookUrl, createdAt, lastDeliveredAt) {
        return {
            Mx: createdAt,
            aef: id,
            SR: lastDeliveredAt,
            abj: webhookUrl
        };
    });
    var $author$project$Api$Partner$WebhookEndpoint$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_delivered_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'webhook_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$Shared$Record)))));
    var $author$project$Api$Partner$WebhookEndpoint$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$WebhookEndpoint$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Partner$WebhookEndpoint$All$Record = function(integration) {
        return {
            Rn: integration
        };
    };
    var $author$project$Api$Partner$WebhookEndpoint$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration', $elm$json$Json$Decode$nullable($author$project$Api$Partner$Integration$Shared$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$All$Record));
    var $author$project$Api$Partner$WebhookEndpoint$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$WebhookEndpoint$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Partner$WebhookEndpoint$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Partner$WebhookEndpoint$All$WebhookEndpoint)));
    var $author$project$Api$Partner$Common$WebhookEndpoint$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Partner$Common$WebhookEndpoint$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_),
            A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(q) {
                return _List_fromArray([
                    A2($author$project$Api$Param$string, 'q', q)
                ]);
            }, options.agq))
        ]));
    };
    var $author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'webhook_endpoints'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$WebhookEndpoint$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$WebhookEndpoint$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath)));
    });
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$list = F3(function(apiClient, optionals, toMsg) {
        return A3($author$project$Api$Partner$WebhookEndpoint$list, apiClient, optionals, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$fetchResources = F4(function(toMsg, apiClient, pagination, _v0) {
        return A3($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$retrieveResource = F3(function(toMsg, apiClient, _v0) {
        return A3($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$list, apiClient, $elm$core$Basics$identity, toMsg);
    });
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$selectId = 'partner-webhook-endpoints';
    var $author$project$Api$Partner$WebhookEndpoint$Shared$webhookUrl = function(_v0) {
        var record = _v0;
        return record.abj;
    };
    var $author$project$Api$Partner$WebhookEndpoint$All$webhookUrl = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookEndpoint$Shared$webhookUrl(shared);
    };
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toTitle = $author$project$Api$Partner$WebhookEndpoint$All$webhookUrl;
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toTitle(resource))
        ]);
    };
    var $author$project$Api$Partner$WebhookEndpoint$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Partner$WebhookEndpoint$All$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookEndpoint$Shared$id(shared);
    };
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toValue = $author$project$Api$Partner$WebhookEndpoint$All$id;
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$fetchResources,
            aef: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$selectId,
            gD: 'Webhook Endpoints',
            sz: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toTitle,
            g4: $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$Partner$Practice$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Pages$Partner$Webhooks$Requests$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var _v3 = A2($author$project$Components$ResourceFilter$Partner$Practice$init, shared.Ej, function(d) {
            return _Utils_update(d, {
                Ee: 'All Practices'
            });
        });
        var practiceResourceFilter = _v3.a;
        var practiceResourceFilterCmd = _v3.b;
        var _v4 = A2($author$project$Components$ResourceFilter$Partner$Practice$preSelectedId, A2($elm$core$Dict$get, 'practice', query), practiceResourceFilter);
        var practiceResourceFilter2 = _v4.a;
        var practiceResourceFilterPreSelectCmd = _v4.b;
        var _v5 = A2($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$init, shared.Ej, function(d) {
            return _Utils_update(d, {
                Ee: 'All Endpoints'
            });
        });
        var endpointResourceFilter = _v5.a;
        var endpointResourceFilterCmd = _v5.b;
        var _v6 = A2($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$preSelectedId, A2($elm$core$Dict$get, 'webhook_endpoint', query), endpointResourceFilter);
        var endpointResourceFilter2 = _v6.a;
        var endpointResourceFilterPreSelectCmd = _v6.b;
        var model = {
            Ej: shared.Ej,
            fI: endpointResourceFilter2,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            jC: practiceResourceFilter2,
            od: $elm$core$Maybe$Nothing,
            j4: A2($elm$core$Dict$get, 'status', query),
            ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$initFromQuery(query)),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'webhook-requests-status-dropdown',
                ahX: $author$project$Pages$Partner$Webhooks$Requests$StatusDropdownMsg
            })),
            HO: shared.HO,
            eV: $author$project$Api$Data$Loading
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(model),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, endpointResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, endpointResourceFilterPreSelectCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, practiceResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, practiceResourceFilterPreSelectCmd)
        ])));
    });
    var $author$project$Pages$Partner$Webhooks$Requests$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Webhooks$Requests$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Partner$Webhooks$Requests$CloseDetails = {
        $: 8
    };
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Pages$Partner$Webhooks$Requests$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(model.oD),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$subscriptions(model.fI)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, $author$project$Components$ResourceFilter$Partner$Practice$subscriptions(model.jC)),
            function() {
                var _v0 = model.od;
                if (!_v0.$) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Partner$Webhooks$Requests$CloseDetails);
                else return $elm$core$Platform$Sub$none;
            }()
        ]));
    };
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$ && !_v1.a.$) {
                var selected = _v1.a.a;
                return _Utils_update(model, {
                    Hg: selected
                });
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Pages$Partner$Webhooks$Requests$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('status'), model.j4),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('webhook_endpoint'), $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$value(model.fI)),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('practice'), $author$project$Components$ResourceFilter$Partner$Practice$value(model.jC))
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Webhooks__Requests)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Partner$Webhooks$Requests$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        eV: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    eV: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v2.a;
                var statusDropdownCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), statusDropdownCmd, _List_Nil);
            case 2:
                var selectedOption = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    j4: function() {
                        if (selectedOption.$ === 1) return $elm$core$Maybe$Nothing;
                        else {
                            var status = selectedOption.a;
                            return $elm$core$Maybe$Just(status);
                        }
                    }(),
                    eV: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(newModel),
                    $author$project$Pages$Partner$Webhooks$Requests$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$update, model.Ej, subMsg, model.fI);
                var newModel = _Utils_update(model, {
                    fI: result.zi
                });
                var _v4 = result.adu;
                if (!_v4.$ && !_v4.a.$) {
                    var refreshModel = _Utils_update(newModel, {
                        af_: $author$project$Api$Pagination$reset(newModel.af_),
                        eV: $author$project$Api$Data$Loading
                    });
                    return _Utils_Tuple3(refreshModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, result.EQ),
                        $author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(refreshModel),
                        $author$project$Pages$Partner$Webhooks$Requests$updateUrl(refreshModel)
                    ])), result.at);
                } else return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, result.EQ), result.at);
            case 4:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$Partner$Practice$update, model.Ej, subMsg, model.jC);
                var newModel = _Utils_update(model, {
                    jC: result.zi
                });
                var _v5 = result.adu;
                if (!_v5.$ && !_v5.a.$) {
                    var refreshModel = _Utils_update(newModel, {
                        af_: $author$project$Api$Pagination$reset(newModel.af_),
                        eV: $author$project$Api$Data$Loading
                    });
                    return _Utils_Tuple3(refreshModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, result.EQ),
                        $author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(refreshModel),
                        $author$project$Pages$Partner$Webhooks$Requests$updateUrl(refreshModel)
                    ])), result.at);
                } else return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, result.EQ), result.at);
            case 5:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(newModel),
                    $author$project$Pages$Partner$Webhooks$Requests$updateUrl(newModel)
                ])), _List_Nil);
            case 6:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Partner$Webhooks$Requests$fetchWebhookRequests(newModel),
                    $author$project$Pages$Partner$Webhooks$Requests$updateUrl(newModel)
                ])), _List_Nil);
            case 7:
                var webhookRequest = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    od: $elm$core$Maybe$Just(webhookRequest)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    od: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Partner$Webhooks$Requests$PaginationMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Partner$WebhookRequest$Shared$eventType = function(_v0) {
        var record = _v0;
        return record.O8;
    };
    var $author$project$Api$Partner$WebhookRequest$All$eventType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookRequest$Shared$eventType(shared);
    };
    var $author$project$Api$Partner$WebhookRequest$Shared$lastResponse = function(_v0) {
        var record = _v0;
        return record.SX;
    };
    var $author$project$Api$Partner$WebhookRequest$All$lastResponse = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookRequest$Shared$lastResponse(shared);
    };
    var $author$project$Api$Partner$WebhookRequest$Shared$lastStatusCode = function(_v0) {
        var record = _v0;
        return record.S_;
    };
    var $author$project$Api$Partner$WebhookRequest$All$lastStatusCode = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookRequest$Shared$lastStatusCode(shared);
    };
    var $author$project$Api$Partner$WebhookRequest$Shared$payload = function(_v0) {
        var record = _v0;
        return record.Wj;
    };
    var $author$project$Api$Partner$WebhookRequest$All$payload = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookRequest$Shared$payload(shared);
    };
    var $author$project$Pages$Partner$Webhooks$Requests$viewDetailSection = F2(function(label, content) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(label),
            $author$project$Ui$Form$Group$labelAbove
        ]), _List_fromArray([
            $author$project$Ui$Form$Group$static(_List_fromArray([
                A2($author$project$Ui$Typography$pre, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$preWrap
                ]), _List_fromArray([
                    $elm$html$Html$text(content)
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Webhooks$Requests$viewDetailsModal = function(model) {
        var _v0 = model.od;
        if (!_v0.$) {
            var webhookRequest = _v0.a;
            return A3($author$project$Ui$Modal$view, $author$project$Pages$Partner$Webhooks$Requests$CloseDetails, _List_fromArray([
                $author$project$Ui$Modal$size(2)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title(A2($elm$core$Maybe$withDefault, 'Webhook Request Details', $author$project$Api$Partner$WebhookRequest$All$eventType(webhookRequest)))
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    A2($author$project$Pages$Partner$Webhooks$Requests$viewDetailSection, 'Last Status Code', A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, $author$project$Api$Partner$WebhookRequest$All$lastStatusCode(webhookRequest)))),
                    A2($author$project$Pages$Partner$Webhooks$Requests$viewDetailSection, 'Last Response', A2($elm$core$Maybe$withDefault, 'No response', $author$project$Api$Partner$WebhookRequest$All$lastResponse(webhookRequest))),
                    A2($author$project$Pages$Partner$Webhooks$Requests$viewDetailSection, 'Payload', A2($elm$core$Maybe$withDefault, 'No payload', A2($elm$core$Maybe$map, $elm$json$Json$Encode$encode(2), $author$project$Api$Partner$WebhookRequest$All$payload(webhookRequest))))
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Close'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$Partner$Webhooks$Requests$CloseDetails)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Close')
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$ResourceFilter$Partner$WebhookEndpoint$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Pages$Partner$Webhooks$Requests$SortTable = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Requests$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'event_type', true, 'Event Type'),
        A3($author$project$Api$Column$init, 'status', true, 'Status'),
        A3($author$project$Api$Column$init, 'webhook_endpoint', true, 'Endpoint'),
        A3($author$project$Api$Column$init, 'practice', true, 'Practice'),
        A3($author$project$Api$Column$init, 'attempts', true, 'Attempts'),
        A3($author$project$Api$Column$init, 'created_at', true, 'Created'),
        A3($author$project$Api$Column$init, 'delivered_at', true, 'Delivered'),
        A3($author$project$Api$Column$init, 'details', false, '')
    ]);
    var $author$project$Pages$Partner$Webhooks$Requests$ViewDetails = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Partner$WebhookRequest$Shared$attempts = function(_v0) {
        var record = _v0;
        return record.JM;
    };
    var $author$project$Api$Partner$WebhookRequest$All$attempts = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookRequest$Shared$attempts(shared);
    };
    var $author$project$Api$Partner$WebhookRequest$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Partner$WebhookRequest$All$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookRequest$Shared$createdAt(shared);
    };
    var $author$project$Api$Partner$WebhookRequest$Shared$deliveredAt = function(_v0) {
        var record = _v0;
        return record.NJ;
    };
    var $author$project$Api$Partner$WebhookRequest$All$deliveredAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookRequest$Shared$deliveredAt(shared);
    };
    var $author$project$Api$Partner$WebhookRequest$All$practice = function(_v0) {
        var record = _v0.b;
        return record.W1;
    };
    var $author$project$Api$Partner$WebhookRequest$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Partner$WebhookRequest$All$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookRequest$Shared$status(shared);
    };
    var $author$project$Pages$Partner$Webhooks$Requests$viewStatusBadge = function(status) {
        var badgeOption = function() {
            switch(status){
                case 'delivered':
                    return $author$project$Ui$Badge$success;
                case 'failed':
                    return $author$project$Ui$Badge$danger;
                case 'pending':
                    return $author$project$Ui$Badge$neutral;
                case 'retrying':
                    return $author$project$Ui$Badge$warning;
                case 'attempted':
                    return $author$project$Ui$Badge$info;
                default:
                    return $author$project$Ui$Badge$neutral;
            }
        }();
        return A2($author$project$Ui$Badge$fromString, _List_fromArray([
            badgeOption
        ]), $author$project$Formatters$String$humanize(status));
    };
    var $author$project$Api$Partner$WebhookRequest$All$webhookEndpoint = function(_v0) {
        var record = _v0.b;
        return record.abi;
    };
    var $author$project$Api$Partner$WebhookEndpoint$Min$webhookUrl = function(_v0) {
        var record = _v0;
        return record.abj;
    };
    var $author$project$Pages$Partner$Webhooks$Requests$viewItem = F2(function(timeFormatter, webhookRequest) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Partner$WebhookRequest$All$eventType(webhookRequest)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Pages$Partner$Webhooks$Requests$viewStatusBadge($author$project$Api$Partner$WebhookRequest$All$status(webhookRequest))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$WebhookEndpoint$Min$webhookUrl($author$project$Api$Partner$WebhookRequest$All$webhookEndpoint(webhookRequest)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Partner$Practice$Min$name($author$project$Api$Partner$WebhookRequest$All$practice(webhookRequest)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Partner$WebhookRequest$All$attempts(webhookRequest)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2(timeFormatter, 4, $author$project$Api$Partner$WebhookRequest$All$createdAt(webhookRequest)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, "\u2014", A2($elm$core$Maybe$map, timeFormatter(4), $author$project$Api$Partner$WebhookRequest$All$deliveredAt(webhookRequest))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'View webhook request details'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Pages$Partner$Webhooks$Requests$ViewDetails(webhookRequest))
                ]), _List_fromArray([
                    $elm$html$Html$text('Details')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Partner$Webhooks$Requests$viewPanelBody = function(model) {
        var _v0 = function() {
            var _v1 = model.eV;
            if (_v1.$ === 3) {
                var webhookRequests_ = _v1.a;
                return _Utils_Tuple2(false, webhookRequests_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var webhookRequests = _v0.b;
        return _List_fromArray([
            A4($author$project$Ui$Table$view, _List_fromArray([
                $author$project$Ui$Table$verticalCentered,
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('There are no webhook requests.')
                ])),
                $author$project$Ui$Table$loading(loading)
            ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Partner$Webhooks$Requests$SortTable)), $author$project$Pages$Partner$Webhooks$Requests$columns), A2($elm$core$List$map, $author$project$Pages$Partner$Webhooks$Requests$viewItem(model.HO), webhookRequests), _List_Nil)
        ]);
    };
    var $author$project$Pages$Partner$Webhooks$Requests$NoStatus = {
        $: 1
    };
    var $author$project$Pages$Partner$Webhooks$Requests$Status = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Requests$StatusFiltered = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Requests$statusDropdownOptions = function(currentStatus) {
        var statusOptions = A2($elm$core$List$map, function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Partner$Webhooks$Requests$StatusFiltered($author$project$Pages$Partner$Webhooks$Requests$Status(status))),
                $author$project$Ui$Dropdown$selected(_Utils_eq($elm$core$Maybe$Just(status), currentStatus))
            ]), $elm$html$Html$text($author$project$Formatters$String$humanize(status)));
        }, _List_fromArray([
            'pending',
            'attempted',
            'delivered',
            'retrying',
            'failed',
            'duplicate',
            'non_requestable',
            'integration_endpoint_failing'
        ]));
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Partner$Webhooks$Requests$StatusFiltered($author$project$Pages$Partner$Webhooks$Requests$NoStatus)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Filter')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
    };
    var $author$project$Pages$Partner$Webhooks$Requests$viewStatusDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'All Status', A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, model.j4)))
        ]), $author$project$Pages$Partner$Webhooks$Requests$statusDropdownOptions(model.j4), model.oD);
    };
    var $author$project$Pages$Partner$Webhooks$Requests$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Partner$Webhooks$Requests$viewDetailsModal(model),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Webhook Requests')
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(4),
                                $author$project$Ui$Grid$spanSm(3),
                                $author$project$Ui$Grid$spanMd(4)
                            ]), _List_fromArray([
                                $author$project$Pages$Partner$Webhooks$Requests$viewStatusDropdown(model)
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(4),
                                $author$project$Ui$Grid$spanSm(3),
                                $author$project$Ui$Grid$spanMd(4)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Partner$Webhooks$Requests$EndpointResourceFilterMsg, A2($author$project$Components$ResourceFilter$Partner$WebhookEndpoint$viewNew, _List_Nil, model.fI))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(4),
                                $author$project$Ui$Grid$spanSm(3),
                                $author$project$Ui$Grid$spanMd(4)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Partner$Webhooks$Requests$PracticeResourceFilterMsg, A2($author$project$Components$ResourceFilter$Partner$Practice$viewNew, _List_Nil, model.jC))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Partner$Webhooks$Requests$viewPanelBody(model)),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Partner$Webhooks$Requests$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.eV))
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Partner | Webhook Requests'
        };
    };
    var $author$project$Pages$Partner$Webhooks$Requests$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Webhooks$Requests$init,
        aeR: $author$project$Pages$Partner$Webhooks$Requests$load,
        ag3: $author$project$Pages$Partner$Webhooks$Requests$save,
        ahE: $author$project$Pages$Partner$Webhooks$Requests$subscriptions,
        aaO: $author$project$Pages$Partner$Webhooks$Requests$update,
        aid: $author$project$Pages$Partner$Webhooks$Requests$view
    });
    var $author$project$Pages$Partner$Webhooks$Settings$GotIntegrationEvents = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$Integrations = 1;
    var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventsDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$Partner = 0;
    var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$Model = $elm$core$Basics$identity;
    var $author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                agq: model.agq,
                ahs: model.ahs
            });
        };
    };
    var $author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'webhook_endpoints'
    ]), $author$project$Api$Partner$Integration$integrationsPath);
    var $author$project$Api$Partner$Integration$WebhookEndpoint$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Partner$WebhookEndpoint$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Partner$Common$WebhookEndpoint$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath)));
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints = F2(function(apiClient, model) {
        var _v0 = model.VM;
        if (!_v0) return A3($author$project$Api$Partner$WebhookEndpoint$list, apiClient, $author$project$Components$Partner$ManageWebhookEndpoints$fetchParams(model), $author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints);
        else return A3($author$project$Api$Partner$Integration$WebhookEndpoint$list, apiClient, $author$project$Components$Partner$ManageWebhookEndpoints$fetchParams(model), $author$project$Components$Partner$ManageWebhookEndpoints$GotWebhookEndpoints);
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$init = F4(function(apiClient, timeFormatter, owner, query) {
        var prefix = function() {
            if (!owner) return 'partner_';
            else return 'integrations_';
        }();
        var q = A2($elm$core$Dict$get, prefix + 'q', query);
        var _v0 = A2($author$project$Components$ResourceFilter$Partner$Integration$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Practice'
            });
        });
        var integrationResourceFilter = _v0.a;
        var integrationResourceFilterCmd = _v0.b;
        var model = {
            $8: $elm$core$Maybe$Nothing,
            dS: $elm$core$Set$empty,
            mA: integrationResourceFilter,
            F6: $elm$core$Maybe$Nothing,
            VM: owner,
            af_: A2($author$project$Api$Pagination$fromQuery, query, A2($author$project$Api$Pagination$withPrefix, prefix, $author$project$Api$Pagination$init)),
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q),
            ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 1, A2($author$project$Api$Sort$fromQuery, query, A2($author$project$Api$Sort$withPrefix, prefix, $author$project$Api$Sort$init))),
            HO: timeFormatter,
            hj: $author$project$Api$Data$Loading
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg, integrationResourceFilterCmd)
        ])));
    });
    var $author$project$Api$Partner$Partner$Shared$listenedEvents = function(_v0) {
        var record = _v0;
        return record.Ti;
    };
    var $author$project$Api$Partner$Partner$One$listenedEvents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$listenedEvents(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$maxRequestsPperMinute = function(_v0) {
        var record = _v0;
        return record.TO;
    };
    var $author$project$Api$Partner$Partner$One$maxRequestsPperMinute = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$maxRequestsPperMinute(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$unmuteSelfWebhooks = function(_v0) {
        var record = _v0;
        return record.aaI;
    };
    var $author$project$Api$Partner$Partner$One$unmuteSelfWebhooks = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$unmuteSelfWebhooks(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$webhooksDisabled = function(_v0) {
        var record = _v0;
        return record.abk;
    };
    var $author$project$Api$Partner$Partner$One$webhooksDisabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$webhooksDisabled(shared);
    };
    var $author$project$Api$Partner$Partner$Shared$webhooksPaused = function(_v0) {
        var record = _v0;
        return record.abl;
    };
    var $author$project$Api$Partner$Partner$One$webhooksPaused = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$webhooksPaused(shared);
    };
    var $author$project$Pages$Partner$Webhooks$Settings$initFormFields = function(partner) {
        return _Utils_Tuple2({
            Ti: $author$project$Api$Partner$Partner$One$listenedEvents(partner),
            TO: $author$project$Api$Partner$Partner$One$maxRequestsPperMinute(partner),
            aaI: $author$project$Api$Partner$Partner$One$unmuteSelfWebhooks(partner),
            abk: $author$project$Api$Partner$Partner$One$webhooksDisabled(partner),
            abl: $author$project$Api$Partner$Partner$One$webhooksPaused(partner)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Api$Partner$IntegrationEvent$integrationEventsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'integration_events'
    ]), $author$project$Api$Data$partnerPath);
    var $author$project$Api$Partner$IntegrationEvent$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$IntegrationEvent$integrationEventsPath));
    });
    var $author$project$Pages$Partner$Webhooks$Settings$init = F4(function(_v0, partner, shared, _v1) {
        var query = _v1.Bz;
        var _v2 = A4($author$project$Components$Partner$ManageWebhookEndpoints$init, shared.Ej, shared.HO, 1, query);
        var manageIntegrationsWebhookEndpoints = _v2.a;
        var manageIntegrationsWebhookEndpointsCmd = _v2.b;
        var _v3 = A4($author$project$Components$Partner$ManageWebhookEndpoints$init, shared.Ej, shared.HO, 0, query);
        var manageGlobalWebhookEndpoints = _v3.a;
        var manageGlobalWebhookEndpointsCmd = _v3.b;
        var _v4 = $author$project$Pages$Partner$Webhooks$Settings$initFormFields(partner);
        var formFields = _v4.a;
        var formFieldsCmd = _v4.b;
        var model = {
            Ej: shared.Ej,
            PU: $author$project$Utils$Form$init(formFields),
            yg: $author$project$Api$Data$Loading,
            F3: $author$project$Shared$isHintAdmin(shared),
            mX: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'listened-events-dropdown',
                ahX: $author$project$Pages$Partner$Webhooks$Settings$ListenedEventsDropdownMsg
            })),
            yK: '',
            m_: manageGlobalWebhookEndpoints,
            m0: manageIntegrationsWebhookEndpoints,
            o2: $author$project$Api$Data$NotAsked
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            formFieldsCmd,
            A2($author$project$Api$Partner$IntegrationEvent$list, shared.Ej, $author$project$Pages$Partner$Webhooks$Settings$GotIntegrationEvents),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg, manageGlobalWebhookEndpointsCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg, manageIntegrationsWebhookEndpointsCmd)
        ])));
    });
    var $author$project$Pages$Partner$Webhooks$Settings$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Partner$Webhooks$Settings$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit = {
        $: 5
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit)), model.F6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg, $author$project$Components$ResourceFilter$Partner$Integration$subscriptions(model.mA))
        ]));
    };
    var $author$project$Pages$Partner$Webhooks$Settings$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg, $author$project$Components$Partner$ManageWebhookEndpoints$subscriptions(model.m_)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg, $author$project$Components$Partner$ManageWebhookEndpoints$subscriptions(model.m0)),
            $author$project$Ui$Dropdown$subscriptions(model.mX)
        ]));
    };
    var $author$project$Pages$Partner$Webhooks$Settings$GotUpdatedPartner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    abk: bool
                });
            case 1:
                var bool = field.a;
                return _Utils_update(fields, {
                    abl: bool
                });
            case 2:
                var bool = field.a;
                return _Utils_update(fields, {
                    aaI: bool
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    TO: $elm$core$String$toInt(string)
                });
            default:
                var listenedEventField = field.a;
                var checked = field.b;
                return _Utils_update(fields, {
                    Ti: function() {
                        var _v1 = _Utils_Tuple2(listenedEventField, checked);
                        if (_v1.b) switch(_v1.a.$){
                            case 0:
                                var avaialbleListenedEvents = _v1.a.a;
                                return avaialbleListenedEvents;
                            case 1:
                                return _List_Nil;
                            default:
                                var listenedEvents = _v1.a.a;
                                return $elm$core$List$isEmpty(listenedEvents) ? _List_Nil : $elm_community$list_extra$List$Extra$unique(_Utils_ap(listenedEvents, fields.Ti));
                        }
                        else switch(_v1.a.$){
                            case 0:
                                return _List_Nil;
                            case 1:
                                var avaialbleListenedEvents = _v1.a.a;
                                return avaialbleListenedEvents;
                            default:
                                var listenedEvents = _v1.a.a;
                                return $elm_community$list_extra$List$Extra$unique(A2($elm$core$List$filter, function(selectedEvent) {
                                    return !A2($elm$core$List$member, selectedEvent, listenedEvents);
                                }, fields.Ti));
                        }
                    }()
                });
        }
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationField = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$SearchInputMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$Deleted = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath);
    };
    var $author$project$Api$Partner$Integration$WebhookEndpoint$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath(id)));
    });
    var $author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath = function(id) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id
        ]), $author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath);
    };
    var $author$project$Api$Partner$WebhookEndpoint$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath(id)));
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$deleteItem = F3(function(apiClient, owner, item) {
        if (!owner) return A3($author$project$Api$Partner$WebhookEndpoint$delete, apiClient, $author$project$Api$Partner$WebhookEndpoint$All$id(item), $author$project$Components$Partner$ManageWebhookEndpoints$Deleted(item));
        else return A3($author$project$Api$Partner$Integration$WebhookEndpoint$delete, apiClient, $author$project$Api$Partner$WebhookEndpoint$All$id(item), $author$project$Components$Partner$ManageWebhookEndpoints$Deleted(item));
    });
    var $author$project$Api$Partner$WebhookEndpoint$All$integration = function(_v0) {
        var record = _v0.b;
        return record.Rn;
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsFromItem = function(webhookEndpoint) {
        return _Utils_Tuple2({
            Rn: A2($elm$core$Maybe$map, $author$project$Api$Partner$Integration$Shared$id, $author$project$Api$Partner$WebhookEndpoint$All$integration(webhookEndpoint)),
            abj: $author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(webhookEndpoint)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsInit = _Utils_Tuple2({
        Rn: $elm$core$Maybe$Nothing,
        abj: ''
    }, $elm$core$Platform$Cmd$none);
    var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var string = field.a;
            return _Utils_update(fields, {
                abj: string
            });
        } else {
            var integration = field.a;
            return _Utils_update(fields, {
                Rn: integration
            });
        }
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationValidation = 1;
    var $author$project$Components$Partner$ManageWebhookEndpoints$validateIntegration = F2(function(owner, fields) {
        if (!owner) return _List_Nil;
        else return _Utils_eq(fields.Rn, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(1, 'Practice is required')
        ]) : _List_Nil;
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrlValidation = 0;
    var $author$project$Components$Partner$ManageWebhookEndpoints$validateWebhookUrl = function(fields) {
        return A2($elm$core$String$startsWith, 'https://', fields.abj) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(0, 'URL must start with https://')
        ]);
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsValidator = function(owner) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManageWebhookEndpoints$validateWebhookUrl),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Partner$ManageWebhookEndpoints$validateIntegration(owner))
        ]));
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$Created = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Partner$WebhookEndpoint$One$WebhookEndpoint = 0;
    var $author$project$Api$Partner$WebhookEndpoint$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Partner$Integration$WebhookEndpoint$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhook_endpoint', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('webhook_url', $elm$json$Json$Encode$string(params.abj)),
                _Utils_Tuple2('integration', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.Rn))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$WebhookEndpoint$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointsPath)));
    });
    var $author$project$Api$Partner$WebhookEndpoint$create = F3(function(apiClient, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhook_endpoint', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('webhook_url', $elm$json$Json$Encode$string(params.abj))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Partner$WebhookEndpoint$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookEndpoint$webhookEndpointsPath)));
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$integrationWebhookEndpointApiFields = function(fields) {
        return {
            Rn: fields.Rn,
            abj: fields.abj
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$partnerWebhookEndpointApiFields = function(fields) {
        return {
            abj: fields.abj
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$createItem = F3(function(apiClient, owner, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        if (!owner) return A3($author$project$Api$Partner$WebhookEndpoint$create, apiClient, $author$project$Components$Partner$ManageWebhookEndpoints$partnerWebhookEndpointApiFields(fields), $author$project$Components$Partner$ManageWebhookEndpoints$Created);
        else return A3($author$project$Api$Partner$Integration$WebhookEndpoint$create, apiClient, $author$project$Components$Partner$ManageWebhookEndpoints$integrationWebhookEndpointApiFields(fields), $author$project$Components$Partner$ManageWebhookEndpoints$Created);
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$Updated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Partner$Integration$WebhookEndpoint$update = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhook_endpoint', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('webhook_url', $elm$json$Json$Encode$string(params.abj))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$WebhookEndpoint$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$Integration$WebhookEndpoint$webhookEndpointPath(id))));
    });
    var $author$project$Api$Partner$WebhookEndpoint$update = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('webhook_endpoint', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('webhook_url', $elm$json$Json$Encode$string(params.abj))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Partner$WebhookEndpoint$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Partner$WebhookEndpoint$webhookEndpointPath(id))));
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$updateItem = F4(function(apiClient, owner, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        if (!owner) return A4($author$project$Api$Partner$WebhookEndpoint$update, apiClient, id, {
            abj: fields.abj
        }, $author$project$Components$Partner$ManageWebhookEndpoints$Updated);
        else return A4($author$project$Api$Partner$Integration$WebhookEndpoint$update, apiClient, id, {
            abj: fields.abj
        }, $author$project$Components$Partner$ManageWebhookEndpoints$Updated);
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$saveItem = F4(function(apiClient, owner, maybeId, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A4($author$project$Components$Partner$ManageWebhookEndpoints$updateItem, apiClient, owner, id_, formFields);
        } else return A3($author$project$Components$Partner$ManageWebhookEndpoints$createItem, apiClient, owner, formFields);
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$qKey = function(owner) {
        if (!owner) return 'partner_q';
        else return 'integrations_q';
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$updateUrl = function(model) {
        return $author$project$Ports$Navigation$replaceUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Partner__Webhooks__Settings)
        ]), _Utils_ap(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string($author$project$Components$Partner$ManageWebhookEndpoints$qKey(model.VM)), model.agq)
        ])), _Utils_ap($author$project$Api$Sort$toQuery(model.ahs), $author$project$Api$Pagination$toPageQuery(model.af_)))));
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        hj: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    hj: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    hj: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, newModel),
                    $author$project$Components$Partner$ManageWebhookEndpoints$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs),
                    hj: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, newModel),
                    $author$project$Components$Partner$ManageWebhookEndpoints$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var _v3 = $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsInit;
                var formFields = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 4:
                var item = msg.a;
                var _v4 = $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsFromItem(item);
                var formFields = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just(item), $author$project$Utils$Form$init(formFields), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    F6: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var field = msg.a;
                var _v5 = model.F6;
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var id = _v6.a;
                    var form = _v6.b;
                    var item = _v6.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate, field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, item))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var item = msg.a;
                var form = msg.b;
                var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsValidator(model.VM), form);
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var validatedForm = _v8.a;
                    var validFormFields = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$Loading))
                    }), A4($author$project$Components$Partner$ManageWebhookEndpoints$saveItem, apiClient, model.VM, A2($elm$core$Maybe$map, $author$project$Api$Partner$WebhookEndpoint$All$id, item), validFormFields), _List_Nil);
                } else {
                    var validatedForm = _v7.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(item, validatedForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 8:
                var response = msg.a;
                var _v9 = model.F6;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Nothing,
                        hj: $author$project$Api$Data$Loading
                    }), A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Successfully created webhook endpoint'),
                        $author$project$OutMsg$RefreshPractice
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var response = msg.a;
                var _v12 = model.F6;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var id = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Nothing,
                        hj: $author$project$Api$Data$Loading
                    }), A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated webhook endpoint')
                    ]));
                    else return _Utils_Tuple3(_Utils_update(model, {
                        F6: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var item = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Just(item)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var item = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var id = $author$project$Api$Partner$WebhookEndpoint$All$id(item);
                    return _Utils_Tuple3(_Utils_update(model, {
                        $8: $elm$core$Maybe$Nothing,
                        dS: A2($elm$core$Set$insert, id, model.dS)
                    }), A3($author$project$Components$Partner$ManageWebhookEndpoints$deleteItem, apiClient, model.VM, item), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    $8: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var item = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Partner$WebhookEndpoint$All$id(item), model.dS),
                            hj: $author$project$Api$Data$Loading
                        }), A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Webhook endpoint was successfully removed.'),
                            $author$project$OutMsg$RefreshPractice
                        ]));
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            dS: A2($elm$core$Set$remove, $author$project$Api$Partner$WebhookEndpoint$All$id(item), model.dS)
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 13:
                var subMsg = msg.a;
                var integrationResourceResult = A3($author$project$Components$ResourceFilter$Partner$Integration$update, apiClient, subMsg, model.mA);
                var item = function() {
                    var _v16 = _Utils_Tuple2(model.F6, integrationResourceResult.adu);
                    if (!_v16.a.$) {
                        if (!_v16.b.$ && !_v16.b.a.$) {
                            var _v17 = _v16.a.a;
                            var id = _v17.a;
                            var form = _v17.b;
                            var request = _v17.c;
                            var updatedForm = A3($author$project$Utils$Form$update, $author$project$Components$Partner$ManageWebhookEndpoints$formFieldsUpdate, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationField($author$project$Components$ResourceFilter$Partner$Integration$value(integrationResourceResult.zi)), form);
                            return $elm$core$Maybe$Just(_Utils_Tuple3(id, updatedForm, request));
                        } else {
                            var item_ = _v16.a.a;
                            return $elm$core$Maybe$Just(item_);
                        }
                    } else {
                        var _v18 = _v16.a;
                        return $elm$core$Maybe$Nothing;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    mA: integrationResourceResult.zi,
                    F6: item
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg, integrationResourceResult.EQ), integrationResourceResult.at);
            default:
                var subMsg = msg.a;
                var _v19 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v19.a;
                var searchInputCmd = _v19.b;
                var searchInputEvent = _v19.c;
                if (searchInputEvent.$ === 1) {
                    var q = searchInputEvent.a;
                    var newModel = _Utils_update(model, {
                        af_: $author$project$Api$Pagination$reset(model.af_),
                        agq: q,
                        sG: searchInput,
                        hj: $author$project$Api$Data$Loading
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$SearchInputMsg, searchInputCmd),
                        A2($author$project$Components$Partner$ManageWebhookEndpoints$fetchWebhookEndpoints, apiClient, newModel),
                        $author$project$Components$Partner$ManageWebhookEndpoints$updateUrl(newModel)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    sG: searchInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Partner$ManageWebhookEndpoints$SearchInputMsg, searchInputCmd), _List_Nil);
        }
    });
    var $author$project$Pages$Partner$Webhooks$Settings$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
    var $author$project$Api$Partner$Partner$UnmuteSelfWebhooks = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$toPermittedFields = F2(function(isHintAdmin, fields) {
        return A2($elm$core$List$cons, $author$project$Api$Partner$Partner$ListenedEvents(fields.Ti), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$WebhooksPaused(fields.abl), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$UnmuteSelfWebhooks(fields.aaI), A2($elm$core$List$cons, $author$project$Api$Partner$Partner$MaxRequestPerMinute(fields.TO), isHintAdmin ? _List_fromArray([
            $author$project$Api$Partner$Partner$WebhooksDisabled(fields.abk)
        ]) : _List_Nil))));
    });
    var $author$project$Pages$Partner$Webhooks$Settings$validate = function(model) {
        var _v0 = A2($author$project$Utils$Form$validate, $author$project$Pages$Partner$Webhooks$Settings$formFieldsValidator, model.PU);
        if (!_v0.$) {
            var _v1 = _v0.a;
            var validFormFields = _v1.b;
            var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
            return $elm$core$Result$Ok(A2($author$project$Pages$Partner$Webhooks$Settings$toPermittedFields, model.F3, fields));
        } else {
            var validatedForm = _v0.a;
            return $elm$core$Result$Err(validatedForm);
        }
    };
    var $author$project$Pages$Partner$Webhooks$Settings$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Partner$Webhooks$Settings$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var _v1 = $author$project$Pages$Partner$Webhooks$Settings$validate(model);
                if (!_v1.$) {
                    var permittedFields = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        o2: $author$project$Api$Data$Loading
                    }), A3($author$project$Api$Partner$Partner$update, model.Ej, permittedFields, $author$project$Pages$Partner$Webhooks$Settings$GotUpdatedPartner), _List_Nil);
                } else {
                    var updatedForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: updatedForm,
                        o2: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    o2: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Partner updated successfully!'),
                    $author$project$OutMsg$RefreshPartner
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    o2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.mX);
                var listenedEventsDropdown = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mX: listenedEventsDropdown
                }), cmd, _List_Nil);
            case 4:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    yg: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var text = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    yK: text
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var subMsg = msg.a;
                var _v4 = A3($author$project$Components$Partner$ManageWebhookEndpoints$update, model.Ej, subMsg, model.m_);
                var manageGlobalWebhookEndpoints = _v4.a;
                var manageGlobalWebhookEndpointsCmd = _v4.b;
                var manageGlobalWebhookEndpointsOutMsgs = _v4.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    m_: manageGlobalWebhookEndpoints
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg, manageGlobalWebhookEndpointsCmd), manageGlobalWebhookEndpointsOutMsgs);
            default:
                var subMsg = msg.a;
                var _v5 = A3($author$project$Components$Partner$ManageWebhookEndpoints$update, model.Ej, subMsg, model.m0);
                var manageIntegrationsWebhookEndpoints = _v5.a;
                var manageIntegrationsWebhookEndpointsCmd = _v5.b;
                var manageIntegrationsWebhookEndpointsOutMsgs = _v5.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    m0: manageIntegrationsWebhookEndpoints
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg, manageIntegrationsWebhookEndpointsCmd), manageIntegrationsWebhookEndpointsOutMsgs);
        }
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$HiConfirmClosed = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$New = {
        $: 3
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$FormUpdated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$Save = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrl = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$viewCreateEditModal = F5(function(owner, integrationResourceFilter, item, form, request) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Webhook Endpoint',
            Tk: _Utils_eq(request, $author$project$Api$Data$Loading),
            TR: A2($elm$core$Maybe$map, $author$project$Api$Partner$WebhookEndpoint$All$id, item),
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Components$Partner$ManageWebhookEndpoints$CancelEdit,
            Vn: $elm$core$Basics$always(A2($author$project$Components$Partner$ManageWebhookEndpoints$Save, item, form))
        };
        var fields = $author$project$Utils$Form$fields(form);
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            function() {
                if (!owner) return $author$project$Utils$Html$empty;
                else return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8),
                    $author$project$Ui$Form$Group$label('Practice')
                ]), _List_fromArray([
                    function() {
                        if (!item.$) {
                            var item_ = item.a;
                            return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Partner$Practice$Shared$name, A2($elm$core$Maybe$map, $author$project$Api$Partner$Integration$Shared$practice, $author$project$Api$Partner$WebhookEndpoint$All$integration(item_)))))
                            ]));
                        } else return A2($elm$html$Html$map, $author$project$Components$Partner$ManageWebhookEndpoints$IntegrationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Partner$Integration$viewNew, _List_fromArray([
                            $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                            $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                        ]), integrationResourceFilter));
                    }()
                ]));
            }(),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8),
                $author$project$Ui$Form$Group$label('Webhook URL')
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(fields.abj),
                    $author$project$Ui$Form$Input$placeholder('https://your-webhook-url.com'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Partner$ManageWebhookEndpoints$FormUpdated, $author$project$Components$Partner$ManageWebhookEndpoints$WebhookUrl)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$SortTable = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$columns = function(owner) {
        return _Utils_ap(function() {
            if (!owner) return _List_Nil;
            else return _List_fromArray([
                A3($author$project$Api$Column$init, 'name', true, 'Practice')
            ]);
        }(), _List_fromArray([
            A3($author$project$Api$Column$init, 'webhook_url', true, 'Webhook URL'),
            A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
            A3($author$project$Api$Column$init, 'last_delivered_at', true, 'Last Delivered At')
        ]));
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$Delete = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$Edit = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Partner$WebhookEndpoint$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Partner$WebhookEndpoint$All$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookEndpoint$Shared$createdAt(shared);
    };
    var $author$project$Api$Partner$WebhookEndpoint$Shared$lastDeliveredAt = function(_v0) {
        var record = _v0;
        return record.SR;
    };
    var $author$project$Api$Partner$WebhookEndpoint$All$lastDeliveredAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$WebhookEndpoint$Shared$lastDeliveredAt(shared);
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$viewWebhookEndpoint = F4(function(timeFormatter, owner, deletingItems, webhookEndpoint) {
        var id = $author$project$Api$Partner$WebhookEndpoint$All$id(webhookEndpoint);
        var loading = A2($elm$core$Set$member, id, deletingItems);
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            function() {
                if (!owner) return _List_Nil;
                else return _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Partner$Practice$Shared$name, A2($elm$core$Maybe$map, $author$project$Api$Partner$Integration$Shared$practice, $author$project$Api$Partner$WebhookEndpoint$All$integration(webhookEndpoint)))))
                    ]))
                ]);
            }(),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(webhookEndpoint))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Partner$WebhookEndpoint$All$createdAt(webhookEndpoint)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, timeFormatter(0), $author$project$Api$Partner$WebhookEndpoint$All$lastDeliveredAt(webhookEndpoint))))
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$textRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit webhook endpoint'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageWebhookEndpoints$Edit(webhookEndpoint)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete location'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$loading(loading),
                        $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageWebhookEndpoints$Delete(webhookEndpoint)),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete')
                    ]))
                ]))
            ])
        ])));
    });
    var $author$project$Components$Partner$ManageWebhookEndpoints$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.hj;
            if (_v1.$ === 3) {
                var webhookEndpoints_ = _v1.a;
                return _Utils_Tuple2(false, webhookEndpoints_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var webhookEndpoints = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any webhook endpoints')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Partner$ManageWebhookEndpoints$SortTable)), $author$project$Components$Partner$ManageWebhookEndpoints$columns(model.VM)), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
        ])), A2($elm$core$List$map, A3($author$project$Components$Partner$ManageWebhookEndpoints$viewWebhookEndpoint, model.HO, model.VM, model.dS), webhookEndpoints), _List_Nil);
    };
    var $author$project$Components$Partner$ManageWebhookEndpoints$view = function(_v0) {
        var model = _v0;
        var loading = function() {
            var _v6 = model.hj;
            if (_v6.$ === 3) return false;
            else return true;
        }();
        return _List_fromArray([
            function() {
                var _v1 = model.F6;
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var item = _v2.a;
                    var form = _v2.b;
                    var request = _v2.c;
                    return A5($author$project$Components$Partner$ManageWebhookEndpoints$viewCreateEditModal, model.VM, model.mA, item, form, request);
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v3 = model.$8;
                if (!_v3.$) {
                    var item = _v3.a;
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Partner$ManageWebhookEndpoints$HiConfirmClosed(item), _List_fromArray([
                        $author$project$Components$HiConfirm$verb('delete'),
                        $author$project$Components$HiConfirm$noun('webhook endpoint'),
                        $author$project$Components$HiConfirm$detail($author$project$Api$Partner$WebhookEndpoint$All$webhookUrl(item))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        function() {
                            var _v4 = model.VM;
                            if (!_v4) return $elm$html$Html$text('Partner Webhook Endpoints');
                            else return $elm$html$Html$text('Practices Webhook Endpoints');
                        }()
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add new webhook endpoint'
                        }, _List_fromArray([
                            $author$project$Ui$Button$default,
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Partner$ManageWebhookEndpoints$New),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                        ]), _List_fromArray([
                            $elm$html$Html$text('New Webhook Endpoint')
                        ]))
                    ])),
                    function() {
                        var _v5 = model.VM;
                        if (!_v5) return $author$project$Utils$Html$empty;
                        else return A2($elm$html$Html$map, $author$project$Components$Partner$ManageWebhookEndpoints$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                            $author$project$Ui$SearchInput$placeholder('Search by practice name')
                        ]), model.sG));
                    }()
                ])),
                $author$project$Components$Partner$ManageWebhookEndpoints$viewTable(model),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Partner$ManageWebhookEndpoints$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(loading)
                    ]), model.af_))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Partner$Webhooks$Settings$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$MaxRequestsPperMinute = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$Save = {
        $: 1
    };
    var $author$project$Pages$Partner$Webhooks$Settings$UnmuteSelfWebhooks = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$WebhooksDisabled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$WebhooksPaused = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$Secondary = 0;
    var $author$project$Ui$Dropdown$buttonSecondary = $author$project$Ui$Dropdown$Button(0);
    var $elm_community$list_extra$List$Extra$isSubsequenceOf = F2(function(subseq, list) {
        isSubsequenceOf: while(true){
            var _v0 = _Utils_Tuple2(subseq, list);
            if (!_v0.a.b) return true;
            else {
                if (!_v0.b.b) return false;
                else {
                    var _v1 = _v0.a;
                    var x = _v1.a;
                    var xs = _v1.b;
                    var _v2 = _v0.b;
                    var y = _v2.a;
                    var ys = _v2.b;
                    if (_Utils_eq(x, y)) {
                        var $temp$subseq = xs, $temp$list = ys;
                        subseq = $temp$subseq;
                        list = $temp$list;
                        continue isSubsequenceOf;
                    } else {
                        var $temp$subseq = subseq, $temp$list = ys;
                        subseq = $temp$subseq;
                        list = $temp$list;
                        continue isSubsequenceOf;
                    }
                }
            }
        }
    });
    var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldAll = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldNone = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldOne = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$ListenedEvents = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Partner$Webhooks$Settings$ListenedEventsSearched = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$Item$Indented = {
        $: 13
    };
    var $author$project$Ui$Dropdown$indented = $author$project$Ui$Dropdown$Item$Indented;
    var $elm$core$List$sort = function(xs) {
        return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
    };
    var $author$project$Pages$Partner$Webhooks$Settings$listenedEventsOptions = F3(function(availableListenedEvents, listenedEventsSearch, checkedListenedEvents) {
        var contains = function(availableListenedEvent) {
            return A2($elm$core$String$contains, $elm$core$String$toLower(listenedEventsSearch), $elm$core$String$toLower(availableListenedEvent));
        };
        var filteredAvailableListenedEvents = A2($elm$core$List$filter, contains, availableListenedEvents);
        var resources = $elm$core$List$sort($elm_community$list_extra$List$Extra$unique(A2($elm$core$List$filterMap, $elm$core$List$head, A2($elm$core$List$map, $elm$core$String$split('.'), filteredAvailableListenedEvents))));
        return A2($elm$core$List$cons, $author$project$Ui$Dropdown$input(_List_fromArray([
            $author$project$Ui$Dropdown$onInput($author$project$Pages$Partner$Webhooks$Settings$ListenedEventsSearched),
            $author$project$Ui$Dropdown$value(listenedEventsSearch),
            $author$project$Ui$Dropdown$placeholder('Search...')
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$checkbox, _List_fromArray([
            $author$project$Ui$Dropdown$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$ListenedEvents($author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldAll(availableListenedEvents)))),
            $author$project$Ui$Dropdown$checked(_Utils_eq($elm$core$List$length(checkedListenedEvents), $elm$core$List$length(availableListenedEvents)))
        ]), $elm$html$Html$text('All')), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$checkbox, _List_fromArray([
            $author$project$Ui$Dropdown$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$ListenedEvents($author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldNone(availableListenedEvents)))),
            $author$project$Ui$Dropdown$checked($elm$core$List$isEmpty(checkedListenedEvents))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$concatMap, function(resource) {
            var resourceEvents = A2($elm$core$List$filter, $elm$core$String$startsWith(resource), filteredAvailableListenedEvents);
            return A2($elm$core$List$map, function(listenedEvent) {
                var formFieldValue = A2($elm$core$String$endsWith, '*', listenedEvent) ? $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldOne(resourceEvents) : $author$project$Pages$Partner$Webhooks$Settings$ListenedEventFieldOne(_List_fromArray([
                    listenedEvent
                ]));
                var checked = A2($elm$core$String$endsWith, '*', listenedEvent) ? A2($elm_community$list_extra$List$Extra$isSubsequenceOf, resourceEvents, checkedListenedEvents) : A2($elm$core$List$member, listenedEvent, checkedListenedEvents);
                var checkboxOptions = A2($elm$core$List$cons, $author$project$Ui$Dropdown$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$ListenedEvents(formFieldValue))), A2($elm$core$List$cons, $author$project$Ui$Dropdown$checked(checked), A2($elm$core$String$endsWith, '*', listenedEvent) ? _List_Nil : _List_fromArray([
                    $author$project$Ui$Dropdown$indented
                ])));
                return A2($author$project$Ui$Dropdown$checkbox, checkboxOptions, $elm$html$Html$text(listenedEvent));
            }, A2($elm$core$List$cons, resource + '.*', resourceEvents));
        }, resources)))));
    });
    var $author$project$Ui$Dropdown$Loading = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$loading = $author$project$Ui$Dropdown$Loading;
    var $author$project$Pages$Partner$Webhooks$Settings$viewSettings = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var _v0 = function() {
            var _v1 = model.yg;
            if (_v1.$ === 3) {
                var avaialbleListenedEvents_ = _v1.a;
                return _Utils_Tuple2(false, avaialbleListenedEvents_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var avaialbleListenedEventsLoading = _v0.a;
        var avaialbleListenedEvents = _v0.b;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$onSubmit($author$project$Pages$Partner$Webhooks$Settings$Save)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Settings')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    model.F3 ? A2($author$project$Ui$HinterOnly$formGroup, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$label('Webhooks Disabled')
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(fields.abk),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$WebhooksDisabled))
                        ]))
                    ])) : $author$project$Utils$Html$empty,
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$label('Webhooks Paused')
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(fields.abl),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$WebhooksPaused))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$label('Unmute Self Webhooks')
                    ]), _List_fromArray([
                        $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                            $author$project$Ui$ToggleSwitch$on(fields.aaI),
                            $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$UnmuteSelfWebhooks))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$label('Max Requests per Minute')
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.TO))),
                            $author$project$Ui$Form$Input$number,
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Partner$Webhooks$Settings$FormUpdated, $author$project$Pages$Partner$Webhooks$Settings$MaxRequestsPperMinute))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpan(8),
                        $author$project$Ui$Form$Group$label('Listened Events')
                    ]), _List_fromArray([
                        A4($author$project$Ui$Dropdown$view, _List_fromArray([
                            $author$project$Ui$Dropdown$buttonSecondary,
                            $author$project$Ui$Dropdown$loading(avaialbleListenedEventsLoading)
                        ]), _List_fromArray([
                            function() {
                                if ($elm$core$List$isEmpty(fields.Ti)) return $elm$html$Html$text('None');
                                else {
                                    if (_Utils_eq($elm$core$List$length(avaialbleListenedEvents), $elm$core$List$length(fields.Ti))) return $elm$html$Html$text('All');
                                    else {
                                        var selectedResources = $elm$core$List$sort(A2($elm$core$List$filter, function(resource) {
                                            var selectedResourceEvents = $elm$core$List$sort(A2($elm$core$List$filter, $elm$core$String$startsWith(resource), fields.Ti));
                                            var avaialbleResourceEvents = $elm$core$List$sort(A2($elm$core$List$filter, $elm$core$String$startsWith(resource), avaialbleListenedEvents));
                                            return A2($elm_community$list_extra$List$Extra$isSubsequenceOf, avaialbleResourceEvents, selectedResourceEvents);
                                        }, $elm_community$list_extra$List$Extra$unique(A2($elm$core$List$filterMap, $elm$core$List$head, A2($elm$core$List$map, $elm$core$String$split('.'), avaialbleListenedEvents)))));
                                        var selectedListenedEvents = $elm$core$List$sort($elm$core$List$concat(_List_fromArray([
                                            A2($elm$core$List$map, function(resource) {
                                                return resource + '.*';
                                            }, selectedResources),
                                            A2($elm_community$list_extra$List$Extra$filterNot, function(listenedEvent) {
                                                return A2($elm$core$List$any, function(resource) {
                                                    return A2($elm$core$String$startsWith, resource, listenedEvent);
                                                }, selectedResources);
                                            }, fields.Ti)
                                        ])));
                                        return $elm$html$Html$text(A2($elm$core$String$join, ', ', selectedListenedEvents));
                                    }
                                }
                            }()
                        ]), A3($author$project$Pages$Partner$Webhooks$Settings$listenedEventsOptions, avaialbleListenedEvents, model.yK, fields.Ti), model.mX)
                    ]))
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$textCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Save partner changes'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$loading(_Utils_eq(model.o2, $author$project$Api$Data$Loading))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Save')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Partner$Webhooks$Settings$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), _List_fromArray([
                        $author$project$Pages$Partner$Webhooks$Settings$viewSettings(model)
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$Webhooks$Settings$ManageGlobalWebhookEndpointsMsg), $author$project$Components$Partner$ManageWebhookEndpoints$view(model.m_))),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Partner$Webhooks$Settings$ManageIntegrationWebhookEndpointsMsg), $author$project$Components$Partner$ManageWebhookEndpoints$view(model.m0)))
                ]))
            ]),
            $2: 'Partner | Webhook Settings'
        };
    };
    var $author$project$Pages$Partner$Webhooks$Settings$page = $author$project$Spa$Page$applicationPartner({
        aeq: $author$project$Pages$Partner$Webhooks$Settings$init,
        aeR: $author$project$Pages$Partner$Webhooks$Settings$load,
        ag3: $author$project$Pages$Partner$Webhooks$Settings$save,
        ahE: $author$project$Pages$Partner$Webhooks$Settings$subscriptions,
        aaO: $author$project$Pages$Partner$Webhooks$Settings$update,
        aid: $author$project$Pages$Partner$Webhooks$Settings$view
    });
    var $author$project$Pages$Patients$Create$FormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$accountType = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.In;
    });
    var $author$project$Api$Provider$Practice$One$isMce = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$accountType, $elm$core$Basics$eq(2));
    var $author$project$Pages$Patients$Create$init = F4(function(session, practice, shared, _v0) {
        var _v1 = A6($author$project$Components$Patient$Form$empty, shared.Ej, session, shared.cP, $elm$core$Maybe$Nothing, false, function(settings) {
            return _Utils_update(settings, {
                ab1: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
                ab8: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
                Qr: $author$project$Api$Provider$Practice$One$hasLocations(practice),
                Qx: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
                ae_: $author$project$Api$Provider$Practice$One$isMce(practice),
                ru: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
                agQ: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
                YK: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
                agR: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
                YP: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
                YQ: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
                _$: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
                $D: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, $author$project$Api$Provider$Practice$One$network(practice))),
                ah_: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
                aaq: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
                aas: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
                DT: A3($author$project$Permission$canGoTo, session, shared.aeb, 0)
            });
        });
        var form = _v1.a;
        var formCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form,
            W1: practice,
            Z$: session,
            km: false
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Create$FormMsg, formCmd));
    });
    var $author$project$Pages$Patients$Create$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$Create$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$Create$subscriptions = function(_v0) {
        var form = _v0.PU;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$Create$FormMsg, $author$project$Components$Patient$Form$subscriptions(form));
    };
    var $author$project$Pages$Patients$Create$PatientCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$create = F3(function(apiClient, jsonBody, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath)));
    });
    var $author$project$Components$Patient$Form$encode = F2(function(validFields, form) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            A2($author$project$Components$Patient$Form$encodePatient, validFields, form)
        ]));
    });
    var $author$project$Pages$Patients$Create$update = F2(function(msg, model) {
        switch(msg.$){
            case 1:
                var _v1 = $author$project$Components$Patient$Form$validate(model.PU);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var validForm = _v2.a;
                    var validFields = _v2.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        km: true
                    }), A3($author$project$Api$Provider$Patient$create, model.Ej, A2($author$project$Components$Patient$Form$encode, validFields, validForm), $author$project$Pages$Patients$Create$PatientCreated), _List_Nil);
                } else {
                    var erroredForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: erroredForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 0:
                var formMsg = msg.a;
                var _v3 = A5($author$project$Components$Patient$Form$update, model.Ej, model.Z$, $elm$core$Maybe$Nothing, formMsg, model.PU);
                var form = _v3.a;
                var formCmd = _v3.b;
                var formOutMsgs = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: form
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Create$FormMsg, formCmd), formOutMsgs);
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var patient = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                V8: $author$project$Api$Provider$Patient$One$id(patient)
                            })),
                            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Create$FormMsg, A5($author$project$Components$Patient$Form$createAffiliation, model.Ej, model.Z$, $author$project$Api$Provider$Patient$One$id(patient), $elm$core$Maybe$Nothing, model.PU).EQ)
                        ])), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Patients$Create$FormSubmitted = {
        $: 1
    };
    var $author$project$Pages$Patients$Create$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('md:ml-8')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$view, _List_fromArray([
                        $author$project$Ui$Form$noValidate(true),
                        $author$project$Ui$Form$autocomplete(false),
                        $author$project$Ui$Form$horizontal,
                        $author$project$Ui$Form$onSubmit($author$project$Pages$Patients$Create$FormSubmitted)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                                $author$project$Ui$Panel$title(_List_fromArray([
                                    $elm$html$Html$text('Create New Patient')
                                ]))
                            ])),
                            A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Patients$Create$FormMsg), $author$project$Components$Patient$Form$view(model.PU))),
                            A2($author$project$Ui$Panel$footer, _List_fromArray([
                                $author$project$Ui$Element$justifyCenter,
                                $author$project$Ui$Element$gap2
                            ]), _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Cancel')
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Create new patient'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$primary,
                                    $author$project$Ui$Button$submit,
                                    $author$project$Ui$Button$loading(model.km)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Create')
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Patients'
        };
    };
    var $author$project$Pages$Patients$Create$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Patients$Create$init,
        aeR: $author$project$Pages$Patients$Create$load,
        ag3: $author$project$Pages$Patients$Create$save,
        ahE: $author$project$Pages$Patients$Create$subscriptions,
        aaO: $author$project$Pages$Patients$Create$update,
        aid: $author$project$Pages$Patients$Create$view
    });
    var $author$project$OutMsg$InitializePatientsList = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Spa$Page$applicationPatient = function(page) {
        return {
            aeq: F2(function(shared, url) {
                var _v0 = _Utils_Tuple3(shared.Z$, shared.W1, shared.MO);
                _v0$5: while(true){
                    _v0$6: while(true){
                        _v0$7: while(true)switch(_v0.a.$){
                            case 3:
                                switch(_v0.b.$){
                                    case 3:
                                        if (!_v0.b.a.$) switch(_v0.c.$){
                                            case 0:
                                                var _v1 = _v0.a;
                                                var _v2 = _v0.b;
                                                var _v3 = _v0.c;
                                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_fromArray([
                                                    $author$project$OutMsg$RetrievePatient(url.VU.V8),
                                                    $author$project$OutMsg$InitializePatientsList(url.Bz)
                                                ]));
                                            case 3:
                                                var _v4 = _v0.a;
                                                var session = _v4.a;
                                                var _v5 = _v0.b;
                                                var practice = _v5.a.a;
                                                var _v6 = _v0.c;
                                                var patient = _v6.a;
                                                return !A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil) : !_Utils_eq(url.VU.V8, $author$project$Api$Provider$Patient$One$id(patient)) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_fromArray([
                                                    $author$project$OutMsg$RetrievePatient(url.VU.V8),
                                                    $author$project$OutMsg$InitializePatientsList(url.Bz)
                                                ])) : A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A5(page.aeq, session, practice, patient, shared, url)));
                                            case 2:
                                                break _v0$6;
                                            default:
                                                break _v0$7;
                                        }
                                        else {
                                            var _v7 = _v0.a;
                                            var session = _v7.a;
                                            var _v8 = _v0.b;
                                            return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                        }
                                    case 2:
                                        break _v0$5;
                                    default:
                                        if (_v0.c.$ === 2) break _v0$6;
                                        else break _v0$7;
                                }
                            case 2:
                                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                            case 0:
                                var _v9 = _v0.a;
                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $author$project$Ports$Session$authorize({
                                    agy: true
                                }), _List_Nil);
                            default:
                                if (_v0.b.$ === 2) break _v0$5;
                                else {
                                    if (_v0.c.$ === 2) break _v0$6;
                                    else break _v0$7;
                                }
                        }
                        return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aeR: F2(function(shared, model) {
                var _v10 = _Utils_Tuple3(shared.Z$, shared.W1, shared.MO);
                _v10$4: while(true){
                    _v10$5: while(true)switch(_v10.a.$){
                        case 3:
                            switch(_v10.b.$){
                                case 3:
                                    if (!_v10.b.a.$) switch(_v10.c.$){
                                        case 0:
                                            var _v11 = _v10.a;
                                            var _v12 = _v10.b;
                                            var _v13 = _v10.c;
                                            if (!model.$) {
                                                var url = model.a;
                                                var _v15 = url;
                                                var params = _v15.VU;
                                                var query = _v15.Bz;
                                                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                                                    $author$project$OutMsg$RetrievePatient(params.V8),
                                                    $author$project$OutMsg$InitializePatientsList(query)
                                                ]));
                                            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                                        case 3:
                                            var _v16 = _v10.a;
                                            var session = _v16.a;
                                            var _v17 = _v10.b;
                                            var practice = _v17.a.a;
                                            var _v18 = _v10.c;
                                            var patient = _v18.a;
                                            switch(model.$){
                                                case 0:
                                                    var url = model.a;
                                                    if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT)) return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                                    else {
                                                        var _v20 = A5(page.aeq, session, practice, patient, shared, url);
                                                        var pageModel = _v20.a;
                                                        var cmd = _v20.b;
                                                        return _Utils_Tuple3($author$project$Spa$Page$SessionLoaded(pageModel), cmd, _List_Nil);
                                                    }
                                                case 1:
                                                    var modelWithSession = model.a;
                                                    return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aeR, shared, _Utils_update(modelWithSession, {
                                                        Ej: shared.Ej
                                                    }))));
                                                default:
                                                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                                            }
                                        default:
                                            break _v10$5;
                                    }
                                    else {
                                        var _v21 = _v10.a;
                                        var session = _v21.a;
                                        var _v22 = _v10.b;
                                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                    }
                                case 2:
                                    break _v10$4;
                                default:
                                    break _v10$5;
                            }
                        case 2:
                            return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                        default:
                            if (_v10.b.$ === 2) break _v10$4;
                            else break _v10$5;
                    }
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            ag3: F2(function(model, shared) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2(page.ag3, modelWithSession, shared);
                } else return shared;
            }),
            ahE: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.ahE(modelWithSession);
                } else return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(msg, model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aaO, msg, modelWithSession));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.aid(modelWithSession);
                } else return {
                    fb: $author$project$Components$BlankPage$view,
                    $2: 'Loading...'
                };
            }
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Accounts$Top$PaymentSourcesMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Patients$PatientId_String$Accounts$Top$init = F5(function(session, practice, patient, shared, _v0) {
        var _v1 = A4($author$project$Components$PaymentSources$init, $author$project$Components$PaymentSources$Patient(patient), session, $author$project$Api$Practice$Provider(practice), shared);
        var paymentSources = _v1.a;
        var paymentSourcesCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            V7: patient,
            go: paymentSources,
            W1: practice,
            Z$: session
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, paymentSourcesCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$Accounts$Top$load = F2(function(shared, model) {
        var _v0 = shared.W1;
        if (_v0.$ === 3 && !_v0.a.$) {
            var practice = _v0.a.a;
            return _Utils_Tuple2(_Utils_update(model, {
                go: A2($author$project$Components$PaymentSources$setPractice, $author$project$Api$Practice$Provider(practice), model.go),
                W1: practice
            }), $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Accounts$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Accounts$Top$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$PaymentSources$subscriptions(model.go));
    };
    var $author$project$Pages$Patients$PatientId_String$Accounts$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$PaymentSources$update, model.Ej, subMsg, model.go);
        var paymentSources = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            go: paymentSources
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Patients$PatientId_String$Accounts$Top$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$PaymentSources$view(model.go)),
            $2: 'Patient | Payment Methods'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Accounts$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Accounts$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Accounts$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Accounts$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Accounts$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Accounts$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Accounts$Top$view
    });
    var $author$project$Api$Provider$SyncDetail$AdditionalDetails = 0;
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$GotAffiliateSyncDetail = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$SyncDetail$Affiliate = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$SyncDetail$Record = function(enrollmentStatus) {
        return function(syncStatus) {
            return function(completedAt) {
                return function(startedAt) {
                    return function(errorMessage) {
                        return function(coveragePlan) {
                            return function(coverageType) {
                                return function(enrollmentDate) {
                                    return function(memberType) {
                                        return function(terminationDate) {
                                            return function(companyName) {
                                                return function(membership) {
                                                    return function(plan) {
                                                        return {
                                                            LN: companyName,
                                                            LS: completedAt,
                                                            Mn: coveragePlan,
                                                            Mq: coverageType,
                                                            OZ: enrollmentDate,
                                                            O$: enrollmentStatus,
                                                            O4: errorMessage,
                                                            TX: memberType,
                                                            jc: membership,
                                                            GW: plan,
                                                            _3: startedAt,
                                                            $G: syncStatus,
                                                            $W: terminationDate
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Patient$SyncDetail$recordDecoder = A3($author$project$Api$Expandable$expandable, 'plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Plan$Min$decoder), A3($author$project$Api$Expandable$expandable, 'membership', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Membership$Min$decoder), A3($author$project$Api$Expandable$expandable, 'company_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($author$project$Api$Expandable$expandable, 'termination_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($author$project$Api$Expandable$expandable, 'member_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($author$project$Api$Expandable$expandable, 'enrollment_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($author$project$Api$Expandable$expandable, 'coverage_type', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($author$project$Api$Expandable$expandable, 'coverage_plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'started_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'completed_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sync_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'enrollment_status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Record))))))))))))));
    var $author$project$Api$Provider$Patient$SyncDetail$affiliateDecoder = $elm$json$Json$Decode$nullable(A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$SyncDetail$recordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray([
        'network',
        'name'
    ]), $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Affiliate))));
    var $author$project$Api$Provider$SyncDetail$expandToString = function(expand) {
        if (!expand) return 'additional_details';
        else return 'coverage_plan';
    };
    var $author$project$Api$Provider$SyncDetail$listDefaults = {
        Fq: _List_Nil
    };
    var $author$project$Api$Provider$SyncDetail$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$SyncDetail$listDefaults);
        return A2($author$project$Api$Expandable$toParam, $author$project$Api$Provider$SyncDetail$expandToString, options.Fq);
    };
    var $author$project$Api$Provider$SyncDetail$retrieveAffiliate = F4(function(apiClient, patientId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Patient$SyncDetail$affiliateDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$SyncDetail$listOptionsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'sync_details',
            'affiliate'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId)))));
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$init = F5(function(_v0, practice, patient, shared, _v1) {
        return _Utils_Tuple2({
            ve: $author$project$Api$Data$Loading,
            Ej: shared.Ej,
            V7: patient,
            W1: practice,
            HO: shared.HO
        }, A4($author$project$Api$Provider$SyncDetail$retrieveAffiliate, shared.Ej, $author$project$Api$Provider$Patient$One$id(patient), function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0
                ])
            });
        }, $elm$core$Basics$identity));
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$update = F2(function(msg, model) {
        var data = msg;
        return _Utils_Tuple3(_Utils_update(model, {
            ve: data
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Api$Provider$Patient$SyncDetail$record_ = function(detail) {
        if (!detail.$) {
            var r = detail.b;
            return r;
        } else {
            var r = detail.b;
            return r;
        }
    };
    var $author$project$Api$Provider$Patient$SyncDetail$companyName = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.LN;
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageSponsor = function(syncDetails) {
        var companyName = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$companyName(details));
            } else return $elm$core$Maybe$Nothing;
        }();
        if (!companyName.$) {
            var name = companyName.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Coverage Sponsor'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(name)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$Patient$SyncDetail$coverageType = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.Mq;
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageType = function(syncDetails) {
        var coverageType = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$coverageType(details))));
            } else return $elm$html$Html$text('N/A');
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Coverage Type'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                coverageType
            ]))
        ]));
    };
    var $author$project$Api$Provider$Patient$SyncDetail$terminationDate = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.$W;
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewEndDate = function(syncDetails) {
        var endDate = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '-', A2($elm$core$Maybe$map, $justinmimbs$date$Date$format('MM/dd/yyyy'), A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$terminationDate(details)))));
            } else return $elm$html$Html$text('-');
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('End Date'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                endDate
            ]))
        ]));
    };
    var $author$project$Api$Provider$Patient$SyncDetail$completedAt = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.LS;
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewLastSyncDate = F2(function(syncDetails, timeFormatter) {
        var lastSyncDate = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '-', A2($elm$core$Maybe$map, timeFormatter(5), $author$project$Api$Provider$Patient$SyncDetail$completedAt(details))));
            } else return $elm$html$Html$text('-');
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Last Sync Date'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                lastSyncDate
            ]))
        ]));
    });
    var $author$project$Api$Provider$Patient$SyncDetail$memberType = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.TX;
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewMemberType = function(syncDetails) {
        var memberType = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$memberType(details))));
            } else return $elm$html$Html$text('N/A');
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Member Type'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                memberType
            ]))
        ]));
    };
    var $author$project$Api$Provider$Patient$SyncDetail$membership = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.jc;
    });
    var $author$project$Api$Provider$Membership$Min$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewNetworkPaymentStatus = function(syncDetails) {
        var paymentStatus = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$Min$status, A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$membership(details)));
            } else return $elm$core$Maybe$Nothing;
        }();
        var coverageType = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$coverageType(details));
            } else return $elm$core$Maybe$Nothing;
        }();
        var _v0 = _Utils_Tuple2(paymentStatus, !_Utils_eq(coverageType, $elm$core$Maybe$Just('Employer')));
        if (!_v0.a.$ && _v0.b) {
            var status = _v0.a.a;
            var statuses = $elm$core$Dict$fromList(_List_fromArray([
                _Utils_Tuple2('active', 'paid'),
                _Utils_Tuple2('unpaid', 'unpaid')
            ]));
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Network Payment Status'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Dict$get, status, statuses)))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSkeleton = A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, function(label) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton(label),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(4),
                    $author$project$Ui$Skeleton$spanMd(3)
                ]))
            ]))
        ]));
    }, _List_fromArray([
        'Coverage Type',
        'Member Type',
        'Sponsor Membership Plan',
        'Start date',
        'End Date',
        'Last sync date'
    ])));
    var $author$project$Api$Provider$Patient$SyncDetail$plan = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.GW;
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSponsorMembershipPlan = function(syncDetails) {
        var plan = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$Min$name, A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$plan(details)))));
            } else return $elm$html$Html$text('N/A');
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Sponsor Membership Plan'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                plan
            ]))
        ]));
    };
    var $author$project$Api$Provider$Patient$SyncDetail$enrollmentDate = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.OZ;
    });
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewStartDate = function(syncDetails) {
        var startDate = function() {
            if (!syncDetails.$) {
                var details = syncDetails.a;
                return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '-', A2($elm$core$Maybe$map, $justinmimbs$date$Date$format('MM/dd/yyyy'), A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$enrollmentDate(details)))));
            } else return $elm$html$Html$text('-');
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Start Date'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                startDate
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$view = function(_v0) {
        var affiliateSyncDetails = _v0.ve;
        var timeFormatter = _v0.HO;
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Affiliation')
                        ])),
                        function() {
                            switch(affiliateSyncDetails.$){
                                case 3:
                                    var syncDetails = affiliateSyncDetails.a;
                                    return A2($author$project$Ui$Form$view, _List_fromArray([
                                        $author$project$Ui$Form$horizontal
                                    ]), _List_fromArray([
                                        $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageType(syncDetails),
                                        $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewCoverageSponsor(syncDetails),
                                        $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewMemberType(syncDetails),
                                        $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSponsorMembershipPlan(syncDetails),
                                        $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewStartDate(syncDetails),
                                        $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewEndDate(syncDetails),
                                        A2($author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewLastSyncDate, syncDetails, timeFormatter),
                                        $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewNetworkPaymentStatus(syncDetails)
                                    ]));
                                case 1:
                                    return $author$project$Pages$Patients$PatientId_String$Affiliation$Top$viewSkeleton;
                                default:
                                    return $author$project$Utils$Html$empty;
                            }
                        }()
                    ]))
                ]))
            ]),
            $2: 'Patient | Affiliations'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Affiliation$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Affiliation$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientDocument$One$PatientDocument = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$PatientDocument$Shared$PatientDocument = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientDocument$Shared$Record = F8(function(id, agreementId, name, status, signedAt, signedFrom, signature, hasSignedDocument) {
        return {
            I$: agreementId,
            QA: hasSignedDocument,
            aef: id,
            zr: name,
            _m: signature,
            _n: signedAt,
            _q: signedFrom,
            ahy: status
        };
    });
    var $author$project$Api$Provider$PatientDocument$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_signed_document', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signature', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signed_from', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signed_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'agreement_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'document_id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$Shared$Record)))))))));
    var $author$project$Api$Provider$PatientDocument$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientDocument$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientDocument$One$Record = F4(function(currentDocumentVersion, signedDocumentVersion, requestDetail, signedByName) {
        return {
            acH: currentDocumentVersion,
            YE: requestDetail,
            _o: signedByName,
            _p: signedDocumentVersion
        };
    });
    var $author$project$Api$Provider$PatientDocument$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signed_by_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_detail', $elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signed_document_version', $elm$json$Json$Decode$maybe($author$project$Api$Provider$DocumentVersion$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'current_document_version', $author$project$Api$Provider$DocumentVersion$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$One$Record)))));
    var $author$project$Api$Provider$PatientDocument$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientDocument$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientDocument$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientDocument$One$PatientDocument)));
    var $author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patient_documents'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId));
    };
    var $author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath = F2(function(patientId, documentId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            documentId
        ]), $author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId));
    });
    var $author$project$Api$Provider$Patient$PatientDocument$retrieve = F4(function(apiClient, id_, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PatientDocument$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)));
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$init = F5(function(_v0, practice, patient, shared, _v1) {
        var params = _v1.VU;
        return _Utils_Tuple2({
            e2: $author$project$Api$Data$Loading,
            dw: $elm$core$Maybe$Nothing,
            Ej: shared.Ej,
            p4: true,
            rP: true,
            Ac: $author$project$Api$Data$NotAsked,
            V7: patient,
            W1: practice,
            CC: $author$project$Api$Data$NotAsked,
            HO: shared.HO
        }, A4($author$project$Api$Provider$Patient$PatientDocument$retrieve, shared.Ej, params.I$, params.V8, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement));
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed = {
        $: 0
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$subscriptions = function(model) {
        return model.Vw ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$subscriptions, model.dw)));
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotUploadedSignedDocument = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientDocument$One$currentDocumentVersion = function(_v0) {
        var record = _v0.b;
        return record.acH;
    };
    var $author$project$Api$Provider$PatientDocument$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PatientDocument$One$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PatientDocument$Shared$id(shared);
    };
    var $author$project$Api$Provider$PatientDocument$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$PatientDocument$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PatientDocument$Shared$status(shared);
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementAccepted = function(agreement) {
        var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
        switch(_v0){
            case 'accepted':
                return true;
            case 'accepted_and_outdated':
                return true;
            case 'not_accepted':
                return false;
            default:
                return false;
        }
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel = F4(function(practice, patient, agreement, open_) {
        return _Utils_Tuple2({
            Id: $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementAccepted(agreement),
            e2: agreement,
            qJ: 0,
            PH: $elm$core$Maybe$Nothing,
            c_: false,
            Vw: open_,
            V7: patient,
            W1: practice
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$init = F4(function(practice, patient, agreement, open_) {
        return A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, practice, patient, agreement, open_);
    });
    var $author$project$Api$Provider$PatientDocument$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$PatientDocument$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PatientDocument$Shared$name(shared);
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$open = function(model) {
        return _Utils_update(model, {
            Vw: true
        });
    };
    var $author$project$Api$Provider$Patient$PatientDocument$signedDocument = F4(function(apiClient, id_, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, A2($elm$json$Json$Decode$at, _List_fromArray([
            'uri'
        ]), $elm$json$Json$Decode$string), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'signed_document'
        ]), A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_))));
    });
    var $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion = function(_v0) {
        var record = _v0.b;
        return record._p;
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$File = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateFailed = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateSucceeded = {
        $: 1
    };
    var $author$project$Api$Provider$Patient$PatientDocument$acceptDocument = F5(function(apiClient, id_, patientId, fileUrl, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('signed_document', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fileUrl))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PatientDocument$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'accept'
        ]), A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)))));
    });
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$acceptAgreement = F5(function(token, documentId, patientId, fileUrl, agreement) {
        return A5($author$project$Api$Provider$Patient$PatientDocument$acceptDocument, token, documentId, patientId, fileUrl, agreement);
    });
    var $author$project$Api$Provider$PatientDocument$Shared$agreementId = function(_v0) {
        var record = _v0;
        return record.I$;
    };
    var $author$project$Api$Provider$PatientDocument$One$agreementId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PatientDocument$Shared$agreementId(shared);
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate = function(agreement) {
        var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
        if (_v0 === 'accepted_and_outdated') return true;
        else return false;
    };
    var $author$project$Api$Provider$Patient$PatientDocument$removeDocumentAcceptance = F5(function(apiClient, id_, patientId, agreementId_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('document_agreement_id', $elm$json$Json$Encode$string(agreementId_))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PatientDocument$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'remove_acceptance'
        ]), A2($author$project$Api$Provider$Patient$PatientDocument$patientDocumentPath, patientId, id_)))));
    });
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$removeAcceptance = F5(function(token, documentId, patientId, agreementId, agreement) {
        return A5($author$project$Api$Provider$Patient$PatientDocument$removeDocumentAcceptance, token, documentId, patientId, agreementId, agreement);
    });
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 1:
                var response = msg.a;
                switch(response.$){
                    case 2:
                        var error = response.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $elm$core$Maybe$Just($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateFailed(error)),
                            zi: _Utils_update(model, {
                                c_: false
                            })
                        };
                    case 3:
                        var agreement = response.a;
                        var _v2 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, model.W1, model.V7, agreement, false);
                        var newModel = _v2.a;
                        var cmd = _v2.b;
                        return {
                            EQ: cmd,
                            adu: $elm$core$Maybe$Just($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$UpdateSucceeded),
                            zi: _Utils_update(newModel, {
                                c_: false
                            })
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $elm$core$Maybe$Nothing,
                            zi: _Utils_update(model, {
                                c_: false
                            })
                        };
                }
            case 0:
                var _v3 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$resetModel, model.W1, model.V7, model.e2, false);
                var newModel = _v3.a;
                var cmd = _v3.b;
                return {
                    EQ: cmd,
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(newModel, {
                        c_: false
                    })
                };
            case 3:
                var _int = msg.a;
                var string = msg.b;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(model, {
                        qJ: _int,
                        PH: $elm$core$Maybe$Just(string)
                    })
                };
            case 4:
                var files = msg.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(_v4) {
                    var task = _v4.a;
                    var size = _v4.b;
                    return A2($elm$core$Task$perform, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$File(size), task);
                }, A2($elm$core$Maybe$map, function(file) {
                    return _Utils_Tuple2($elm$file$File$toUrl(file), $elm$file$File$size(file));
                }, $elm$core$List$head(files))));
                return {
                    EQ: cmd,
                    adu: $elm$core$Maybe$Nothing,
                    zi: model
                };
            default:
                var patientId = $author$project$Api$Provider$Patient$One$id(model.V7);
                var outOfDate = $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate(model.e2);
                var documentId = $author$project$Api$Provider$PatientDocument$One$id(model.e2);
                var cmd = function() {
                    if (model.Id && !outOfDate) {
                        var agreementId = function() {
                            var _v5 = $author$project$Api$Provider$PatientDocument$One$agreementId(model.e2);
                            if (!_v5.$) {
                                var id = _v5.a;
                                return id;
                            } else return '';
                        }();
                        return A5($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$removeAcceptance, apiClient, documentId, patientId, agreementId, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement);
                    } else return A5($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$acceptAgreement, apiClient, documentId, patientId, model.PH, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$GotAgreement);
                }();
                return {
                    EQ: cmd,
                    adu: $elm$core$Maybe$Nothing,
                    zi: _Utils_update(model, {
                        c_: true
                    })
                };
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                switch(response.$){
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            e2: response
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    case 3:
                        var agreement = response.a;
                        var outdatedFileCmd = function() {
                            var _v2 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
                            if (_v2 === 'accepted_and_outdated') {
                                var _v3 = $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion(agreement);
                                if (_v3.$ === 1) return $elm$core$Platform$Cmd$none;
                                else {
                                    var outdatedDoc = _v3.a;
                                    return A4($author$project$Api$Provider$DocumentVersion$signedFileUrl, model.Ej, $author$project$Api$Provider$PatientDocument$One$id(agreement), $author$project$Api$Provider$DocumentVersion$Shared$id(outdatedDoc), $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl(false));
                                }
                            } else return $elm$core$Platform$Cmd$none;
                        }();
                        var currentFileCmd = A4($author$project$Api$Provider$DocumentVersion$signedFileUrl, model.Ej, $author$project$Api$Provider$PatientDocument$One$id(agreement), $author$project$Api$Provider$DocumentVersion$Shared$id($author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement)), $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotSignedFileUrl(true));
                        return _Utils_Tuple3(_Utils_update(model, {
                            e2: response
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            currentFileCmd,
                            outdatedFileCmd
                        ])), _List_Nil);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            e2: response
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    p4: !model.p4
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    rP: !model.rP
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var isCurrent = msg.a;
                var response = msg.b;
                var newModel = isCurrent ? _Utils_update(model, {
                    CC: response
                }) : _Utils_update(model, {
                    Ac: response
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, function() {
                    if (response.$ === 2) {
                        var error = response.a;
                        return _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]);
                    } else return _List_Nil;
                }());
            case 2:
                var agreement = msg.a;
                var _v5 = model.dw;
                if (_v5.$ === 1) {
                    var _v6 = A4($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$init, model.W1, model.V7, agreement, true);
                    var modal = _v6.a;
                    var cmd = _v6.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        dw: $elm$core$Maybe$Just(modal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg, cmd), _List_Nil);
                } else {
                    var modal = _v5.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        dw: $elm$core$Maybe$Just($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$open(modal))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var modalMsg = msg.a;
                var _v7 = model.dw;
                if (!_v7.$) {
                    var modal = _v7.a;
                    var result = A3($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$update, model.Ej, modalMsg, modal);
                    var _v8 = function() {
                        var _v9 = result.adu;
                        if (!_v9.$) {
                            if (!_v9.a.$) {
                                var error = _v9.a.a;
                                return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                                ]));
                            } else {
                                var _v10 = _v9.a;
                                var successText = $author$project$Api$Provider$PatientDocument$One$name(modal.e2) + ' marked as accepted';
                                return _Utils_Tuple2(A4($author$project$Api$Provider$Patient$PatientDocument$retrieve, model.Ej, $author$project$Api$Provider$PatientDocument$One$id(modal.e2), $author$project$Api$Provider$Patient$One$id(modal.V7), $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotAgreement), _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, successText)
                                ]));
                            }
                        } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_Nil);
                    }();
                    var command = _v8.a;
                    var outMsg = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        dw: $elm$core$Maybe$Just(result.zi)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg, result.EQ),
                        command
                    ])), outMsg);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var id = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$Patient$PatientDocument$signedDocument, model.Ej, id, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$GotUploadedSignedDocument), _List_Nil);
            default:
                var response = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Data$toMaybe(response))), $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted = {
        $: 2
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$FileUploaded = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$viewFileUploader = function(model) {
        var maxFileBytesSize = $author$project$Utils$FileSize$fiveMegabytes;
        var fileSizeError = _Utils_cmp(model.qJ, maxFileBytesSize) > 0 ? 'That file is too large! Our maximum file size is 5 mb.' : '';
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('border-light')
        ]), _List_fromArray([
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$accept(2),
                $author$project$Ui$Form$File$onInput($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$FileUploaded)
            ])),
            $author$project$Utils$FormErrors$viewError(fileSizeError)
        ]));
    };
    var $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$view = function(model) {
        if (model.Vw) {
            var patientName = $author$project$Api$Provider$Patient$One$name(model.V7);
            var outOfDate = $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$isAgreementOutOfDate(model.e2);
            var buttonText = function() {
                if (model.Id && !outOfDate) return 'Confirm';
                else {
                    var _v0 = model.qJ;
                    if (!_v0) return 'Confirm without Uploading';
                    else return 'Confirm';
                }
            }();
            var footer = _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Confirm'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(model.c_),
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted)
                ]), _List_fromArray([
                    $elm$html$Html$text(buttonText)
                ]))
            ]);
            var agreementName = $author$project$Api$Provider$PatientDocument$One$name(model.e2);
            var bodyText = model.Id && !outOfDate ? 'Are you sure you want to remove the acceptance of the ' + (agreementName + (' for ' + (patientName + '?'))) : 'Do you have a signed copy from ' + (patientName + (' of the ' + (agreementName + '?')));
            var body = model.Id && !outOfDate ? A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$onSubmit($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted),
                $author$project$Ui$Form$horizontal
            ]), _List_fromArray([
                A2($elm$html$Html$p, _List_fromArray([
                    $elm$html$Html$Attributes$class('mb-075')
                ]), _List_fromArray([
                    $elm$html$Html$text(bodyText)
                ]))
            ])) : A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$onSubmit($author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Submitted),
                $author$project$Ui$Form$horizontal
            ]), _List_fromArray([
                A2($elm$html$Html$p, _List_fromArray([
                    $elm$html$Html$Attributes$class('mb-075')
                ]), _List_fromArray([
                    $elm$html$Html$text(bodyText)
                ])),
                $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$viewFileUploader(model)
            ]));
            var titleText = model.Id && !outOfDate ? 'Remove ' + agreementName : 'Accept ' + agreementName;
            return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$Closed, _List_fromArray([
                $author$project$Ui$Modal$size(1)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title(titleText)
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    body
                ])),
                $author$project$Ui$Modal$footer(footer)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreementAcceptanceModal = function(model) {
        var _v0 = model.dw;
        if (!_v0.$) {
            var modal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$AgreementAcceptanceModalMsg, $author$project$Components$Patient$Agreements$AgreementAcceptanceModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Button$GreyLink = 8;
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible = {
        $: 1
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleOutdatedAgreementVisible = {
        $: 4
    };
    var $author$project$Api$Provider$DocumentVersion$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $elm$html$Html$iframe = _VirtualDom_node('iframe');
    var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewFromUrl = F2(function(patientDocumentName, signedFileUrl) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = $author$project$Api$Data$toMaybe(signedFileUrl);
                if (!_v0.$) {
                    var url_ = _v0.a;
                    var pdfUrl = 'https://docs.google.com/gview?url=' + ($elm$url$Url$percentEncode(url_) + '&embedded=true');
                    return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('embed-responsive embed-responsive-full')
                        ]), _List_fromArray([
                            A2($elm$html$Html$iframe, _List_fromArray([
                                $elm$html$Html$Attributes$src(pdfUrl),
                                $elm$html$Html$Attributes$title(patientDocumentName),
                                A2($elm$html$Html$Attributes$property, 'frameborder', $elm$json$Json$Encode$string('0')),
                                A2($elm$html$Html$Attributes$property, 'allowfullscreen', $elm$json$Json$Encode$string('false')),
                                $elm$html$Html$Attributes$class('embed-responsive-item ng-scope')
                            ]), _List_Nil)
                        ]))
                    ]));
                } else return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$card(_List_Nil)
                ]));
            }()
        ]));
    });
    var $author$project$Ui$Well$Clearfix = {
        $: 2
    };
    var $author$project$Ui$Well$clearfix = $author$project$Ui$Well$Clearfix;
    var $author$project$Api$Provider$PatientDocument$Shared$hasSignedDocument = function(_v0) {
        var record = _v0;
        return record.QA;
    };
    var $author$project$Api$Provider$PatientDocument$One$hasSignedDocument = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PatientDocument$Shared$hasSignedDocument(shared);
    };
    var $author$project$Api$Provider$PatientDocument$One$requestDetail = function(_v0) {
        var record = _v0.b;
        return record.YE;
    };
    var $author$project$Api$Provider$PatientDocument$Shared$signature = function(_v0) {
        var record = _v0;
        return record._m;
    };
    var $author$project$Api$Provider$PatientDocument$One$signature = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PatientDocument$Shared$signature(shared);
    };
    var $author$project$Api$Provider$PatientDocument$Shared$signedAt = function(_v0) {
        var record = _v0;
        return record._n;
    };
    var $author$project$Api$Provider$PatientDocument$One$signedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PatientDocument$Shared$signedAt(shared);
    };
    var $author$project$Api$Provider$PatientDocument$One$signedByName = function(_v0) {
        var record = _v0.b;
        return record._o;
    };
    var $author$project$Api$Provider$PatientDocument$Shared$signedFrom = function(_v0) {
        var record = _v0;
        return record._q;
    };
    var $author$project$Api$Provider$PatientDocument$One$signedFrom = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$PatientDocument$Shared$signedFrom(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel = F2(function(atOrBy, signedFrom) {
        return (signedFrom === 'provider_portal' ? 'Marked as accepted' : 'Accepted') + (' ' + atOrBy);
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAcceptedBySection = F2(function(maybeSignedFrom, maybeSignedByName) {
        var label = A2($elm$core$Maybe$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel('by'), maybeSignedFrom);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(A2($elm$core$Maybe$withDefault, '', label)),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', maybeSignedByName))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAceeptedAtSection = F3(function(timeFormatter, maybeSignedFrom, maybeSignedAt) {
        var signedAt = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, timeFormatter(2), maybeSignedAt));
        var label = A2($elm$core$Maybe$map, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$markAsAcceptedLabel('at'), maybeSignedFrom);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(A2($elm$core$Maybe$withDefault, '', label)),
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(signedAt)
                ]))
            ]))
        ]));
    });
    var $author$project$Api$Common$RequestDetail$Shared$clientName = function(_v0) {
        var record = _v0;
        return record.Lj;
    };
    var $author$project$Api$Common$RequestDetail$Shared$deviceBrand = function(_v0) {
        var record = _v0;
        return record.NW;
    };
    var $author$project$Api$Common$RequestDetail$Shared$deviceName = function(_v0) {
        var record = _v0;
        return record.NX;
    };
    var $author$project$Api$Common$RequestDetail$Shared$deviceType = function(_v0) {
        var record = _v0;
        return record.NY;
    };
    var $author$project$Api$Common$RequestDetail$Shared$osName = function(_v0) {
        var record = _v0;
        return record.VG;
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewDetailsSection = F2(function(maybeSignedFrom, maybeRequestDetails) {
        if (maybeRequestDetails.$ === 1) return $author$project$Utils$Html$empty;
        else {
            var requestDetails = maybeRequestDetails.a;
            var _v1 = _Utils_Tuple2($author$project$Api$Common$RequestDetail$Shared$clientName(requestDetails), maybeSignedFrom);
            if (_v1.a.$ === 1) {
                var _v2 = _v1.a;
                return $author$project$Utils$Html$empty;
            } else if (_v1.b.$ === 1) {
                var _v3 = _v1.b;
                return $author$project$Utils$Html$empty;
            } else {
                var clientName = _v1.a.a;
                var signedFrom = _v1.b.a;
                return signedFrom === 'provider_portal' ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Details'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, function() {
                            var _v4 = $author$project$Api$Common$RequestDetail$Shared$deviceType(requestDetails);
                            if (_v4.$ === 1) return _List_Nil;
                            else {
                                var deviceType = _v4.a;
                                return deviceType === 'desktop' ? _List_fromArray([
                                    $elm$html$Html$text('Using ' + (clientName + (' on ' + (A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$RequestDetail$Shared$osName(requestDetails)) + ' Desktop'))))
                                ]) : _List_fromArray([
                                    $elm$html$Html$text('Using ' + (clientName + (' on ' + (A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$RequestDetail$Shared$deviceBrand(requestDetails)) + (' ' + A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$RequestDetail$Shared$deviceName(requestDetails)))))))
                                ]);
                            }
                        }())
                    ]))
                ]));
            }
        }
    });
    var $author$project$Api$Common$RequestDetail$Shared$ip = function(_v0) {
        var record = _v0;
        return record.RN;
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewIpSection = F2(function(maybeSignedFrom, maybeRequestDetails) {
        if (maybeRequestDetails.$ === 1) return $author$project$Utils$Html$empty;
        else {
            var requestDetails = maybeRequestDetails.a;
            var _v1 = _Utils_Tuple2($author$project$Api$Common$RequestDetail$Shared$ip(requestDetails), maybeSignedFrom);
            if (_v1.a.$ === 1) {
                var _v2 = _v1.a;
                return $author$project$Utils$Html$empty;
            } else if (_v1.b.$ === 1) {
                var _v3 = _v1.b;
                return $author$project$Utils$Html$empty;
            } else {
                var ip = _v1.a.a;
                var signedFrom = _v1.b.a;
                return signedFrom === 'provider_portal' ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('IP Address'),
                    $author$project$Ui$Form$Group$labelSpanSm(4),
                    $author$project$Ui$Form$Group$inputSpanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(ip)
                        ]))
                    ]))
                ]));
            }
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedHeaderSection = F2(function(viaSectionText, notSignedElectronically) {
        return notSignedElectronically ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Signed electronically '),
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(viaSectionText)
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenFileDocument = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewUploadedDocumentSection = F3(function(id, maybeSignedFrom, hasSignedDocument) {
        if (!maybeSignedFrom.$) {
            var signedFrom = maybeSignedFrom.a;
            return signedFrom === 'provider_portal' && hasSignedDocument ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'View uploaded document'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenFileDocument(id))
                    ]), _List_fromArray([
                        $elm$html$Html$text('View uploaded document')
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedAgreementDetails = F3(function(timeFormatter, showSignatureDetails, agreement) {
        if ($author$project$Api$Provider$PatientDocument$One$status(agreement) === 'not_accepted' || !showSignatureDetails) return $author$project$Utils$Html$empty;
        else {
            var maybeSignedFrom = $author$project$Api$Provider$PatientDocument$One$signedFrom(agreement);
            var notSignedElectronically = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(signedFrom) {
                return signedFrom !== 'provider_portal' && signedFrom !== 'public_api';
            }, maybeSignedFrom));
            var viaSectionText = function() {
                var _v0 = _Utils_Tuple2($author$project$Api$Provider$PatientDocument$One$signature(agreement), maybeSignedFrom);
                if (_v0.a.$ === 1) {
                    var _v1 = _v0.a;
                    return 'by typing their name';
                } else if (!_v0.b.$) {
                    var signedFrom = _v0.b.a;
                    return signedFrom === 'online_signup' ? 'via checkbox on online signup.' : 'via checkbox';
                } else {
                    var _v2 = _v0.b;
                    return 'via checkbox';
                }
            }();
            var maybeSignedByName = $author$project$Api$Provider$PatientDocument$One$signedByName(agreement);
            var maybeSignedAt = $author$project$Api$Provider$PatientDocument$One$signedAt(agreement);
            var maybeRequestDetails = $author$project$Api$Provider$PatientDocument$One$requestDetail(agreement);
            var hasSignedDocument = $author$project$Api$Provider$PatientDocument$One$hasSignedDocument(agreement);
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(8),
                    $author$project$Ui$Grid$offset(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Well$view, _List_fromArray([
                        $author$project$Ui$Well$small,
                        $author$project$Ui$Well$clearfix
                    ]), _List_fromArray([
                        A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedHeaderSection, viaSectionText, notSignedElectronically),
                        A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAcceptedBySection, maybeSignedFrom, maybeSignedByName),
                        A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAceeptedAtSection, timeFormatter, maybeSignedFrom, maybeSignedAt),
                        A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewUploadedDocumentSection, $author$project$Api$Provider$PatientDocument$One$id(agreement), maybeSignedFrom, hasSignedDocument),
                        A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewDetailsSection, maybeSignedFrom, maybeRequestDetails),
                        A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewIpSection, maybeSignedFrom, maybeRequestDetails)
                    ]))
                ]))
            ]));
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement = F5(function(timeFormatter, showSignatureDetails, agreementVisibilityRecord, agreement, document1) {
        if (agreementVisibilityRecord.mM) {
            var documentBody = function() {
                var _v0 = $author$project$Api$Provider$DocumentVersion$Shared$documentVersionType(document1);
                switch(_v0){
                    case 1:
                        return _List_fromArray([
                            A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewFromUrl, 'name', agreementVisibilityRecord.PH)
                        ]);
                    case 0:
                        return _List_fromArray([
                            A3($author$project$Ui$Link$externalHref, A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$DocumentVersion$Shared$linkUrl(document1)), _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$DocumentVersion$Shared$linkUrl(document1)))
                            ]))
                        ]);
                    default:
                        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), $author$project$Utils$Dom$textToHtml(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$DocumentVersion$Shared$content(document1))));
                }
            }();
            return A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$cons, A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSignedAgreementDetails, timeFormatter, showSignatureDetails, agreement), documentBody));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreements = F4(function(timeFormatter, agreement, current, outdated) {
        var isOutdated = function() {
            var _v3 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
            if (_v3 === 'accepted_and_outdated') return true;
            else return false;
        }();
        var agreementVisibleName = function() {
            var _v2 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
            if (_v2 === 'accepted') return 'Signed Agreement';
            else return 'Current Agreement';
        }();
        var _v0 = _Utils_Tuple2(current.mM, outdated.mM);
        var currentAgreementVisible = _v0.a;
        var outdatedAgreementVisible = _v0.b;
        var agreementIcon = currentAgreementVisible ? $author$project$Ui$Icon$chevron(_List_fromArray([
            $author$project$Ui$Icon$rotate180
        ])) : $author$project$Ui$Icon$chevronDown(_List_Nil);
        return A2($elm$html$Html$div, _List_Nil, function() {
            if (isOutdated) {
                var _v1 = $author$project$Api$Provider$PatientDocument$One$signedDocumentVersion(agreement);
                if (_v1.$ === 1) return _List_Nil;
                else {
                    var signedDocumentVersion = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'View ' + agreementVisibleName
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible),
                                $author$project$Ui$Button$styled(8)
                            ]), _List_fromArray([
                                $elm$html$Html$text(agreementVisibleName),
                                $author$project$Utils$Html$noBreakSpace,
                                agreementIcon
                            ])),
                            A5($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement, timeFormatter, false, current, agreement, $author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement))
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Signed Out Of Date Agreement'
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleOutdatedAgreementVisible),
                                $author$project$Ui$Button$styled(8)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Signed Out Of Date Agreement'),
                                $author$project$Utils$Html$noBreakSpace,
                                outdatedAgreementVisible ? $author$project$Ui$Icon$chevron(_List_fromArray([
                                    $author$project$Ui$Icon$rotate180
                                ])) : $author$project$Ui$Icon$chevronDown(_List_Nil)
                            ])),
                            function() {
                                if (outdatedAgreementVisible) {
                                    var currentDocumentVersionDate = A2(timeFormatter, 2, $author$project$Api$Provider$DocumentVersion$Shared$createdAt($author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement)));
                                    return A2($author$project$Ui$Typography$p, _List_fromArray([
                                        $author$project$Ui$Typography$small
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Agreement was later updated, the most recent version was added on ' + currentDocumentVersionDate)
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            A5($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement, timeFormatter, true, outdated, agreement, signedDocumentVersion)
                        ]))
                    ]);
                }
            } else return _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'View ' + agreementVisibleName
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$ToggleCurrentAgreementVisible),
                    $author$project$Ui$Button$styled(8),
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none)
                ]), _List_fromArray([
                    $elm$html$Html$text(agreementVisibleName),
                    $author$project$Utils$Html$noBreakSpace,
                    agreementIcon
                ])),
                A5($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreement, timeFormatter, true, current, agreement, $author$project$Api$Provider$PatientDocument$One$currentDocumentVersion(agreement))
            ]);
        }());
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewBreadcrumbs = F2(function(patientId, agreementName) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                V8: patientId
            }), _List_Nil, _List_fromArray([
                $elm$html$Html$text('Patient')
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$gray
            ]), _List_fromArray([
                $elm$html$Html$text('  /  ' + agreementName)
            ])),
            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                $author$project$Ui$HorizontalRule$thin
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenAgreementAcceptanceModal = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Badge$Inline = {
        $: 0
    };
    var $author$project$Ui$Badge$inline = $author$project$Ui$Badge$Inline;
    var $author$project$Ui$Typography$p0 = $author$project$Ui$Typography$Padding(0);
    var $author$project$Ui$Typography$textLeft = $author$project$Ui$Typography$Aligned($author$project$Ui$Alignment$textLeft);
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewHeader = F3(function(agreement, patient, practice) {
        var practiceAddress = function() {
            var _v2 = $author$project$Api$Provider$Practice$One$address(practice);
            if (!_v2.$) {
                var practiceAddress_ = _v2.a;
                return $author$project$Components$AddressDisplay$view(practiceAddress_);
            } else return $author$project$Utils$Html$empty;
        }();
        var patientAddress = function() {
            var _v1 = $author$project$Api$Provider$Patient$One$address(patient);
            if (!_v1.$) {
                var address = _v1.a;
                return $author$project$Components$AddressDisplay$view(address);
            } else return $author$project$Utils$Html$empty;
        }();
        var buttonText = function() {
            var _v0 = $author$project$Api$Provider$PatientDocument$One$status(agreement);
            switch(_v0){
                case 'accepted':
                    return 'Mark as Not Accepted';
                case 'not_accepted':
                    return 'Mark as Accepted';
                default:
                    return 'Mark Current Agreement as Accepted';
            }
        }();
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsStart
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$PatientDocument$One$name(agreement))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mr2
                    ]), _List_Nil),
                    A2($author$project$Ui$Badge$fromString, _List_fromArray([
                        $author$project$Ui$Badge$inline
                    ]), $author$project$Api$Provider$PatientDocument$One$status(agreement))
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: buttonText
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$OpenAgreementAcceptanceModal(agreement))
                ]), _List_fromArray([
                    $elm$html$Html$text(buttonText)
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$textLeft,
                        $author$project$Ui$Typography$p0
                    ]), _List_fromArray([
                        $elm$html$Html$text('Member')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(10)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Patient$One$name(patient))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        patientAddress
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$textLeft,
                        $author$project$Ui$Typography$p0
                    ]), _List_fromArray([
                        $elm$html$Html$text('Business')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(10)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Practice$One$name(practice))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        practiceAddress
                    ]))
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil)
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSkeleton = _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$itemsStart
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Patient')
            ])),
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('  /  ')
            ])),
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$span(2)
            ]))
        ])),
        $author$project$Ui$HorizontalRule$view(_List_fromArray([
            $author$project$Ui$HorizontalRule$thin
        ])),
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsStart
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$block,
                        $author$project$Ui$Skeleton$spanFromText('Some Agreement')
                    ]))
                ])),
                $author$project$Ui$Skeleton$input(_List_fromArray([
                    $author$project$Ui$Skeleton$span(2)
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_Nil)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(10)
                ]), _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(3)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_Nil)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(10)
                ]), _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(4)
                    ]))
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$itemsStart,
                $author$project$Ui$Element$spaceX2
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Signed Agreement')
                ])),
                $author$project$Ui$Skeleton$card(_List_fromArray([
                    $author$project$Ui$Skeleton$span(8)
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$view = function(model) {
        var _v0 = model;
        var timeFormatter = _v0.HO;
        var practice = _v0.W1;
        var patient = _v0.V7;
        var agreement = _v0.e2;
        var signedFileUrl = _v0.CC;
        var currentAgreementVisible = _v0.p4;
        var outdatedSignedFileUrl = _v0.Ac;
        var outdatedAgreementVisible = _v0.rP;
        return {
            fb: function() {
                if (agreement.$ === 3) {
                    var agreement_ = agreement.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                                A2($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewBreadcrumbs, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Api$Provider$PatientDocument$One$name(agreement_)),
                                $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreementAcceptanceModal(model),
                                A3($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewHeader, agreement_, patient, practice),
                                A4($author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewAgreements, timeFormatter, agreement_, {
                                    PH: signedFileUrl,
                                    mM: currentAgreementVisible
                                }, {
                                    PH: outdatedSignedFileUrl,
                                    mM: outdatedAgreementVisible
                                })
                            ]))
                        ]))
                    ]);
                } else return _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$viewSkeleton)
                    ]))
                ]);
            }(),
            $2: 'Patient | Agreements'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotIntegrationRecords = function(a) {
        return {
            $: 55,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotTaxProfiles = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$OtherActionsDropdownMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileDropdownMsg = function(a) {
        return {
            $: 43,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$integrationRecords = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'integration_records'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id))));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$MembershipPaymentSource = 4;
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands = _List_fromArray([
        0,
        1,
        2,
        3,
        4
    ]);
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice = F2(function(apiClient, invoiceId) {
        return A4($author$project$Api$Provider$CustomerInvoice$retrieve, apiClient, invoiceId, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice);
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$init = F5(function(session, practice, patient, shared, _v0) {
        var params = _v0.VU;
        return _Utils_Tuple2({
            hs: $elm$core$Maybe$Nothing,
            Ej: shared.Ej,
            hB: $elm$core$Maybe$Nothing,
            hD: false,
            pF: $author$project$Api$Data$Loading,
            pQ: $author$project$Api$Data$Loading,
            hM: _List_Nil,
            fj: $elm$core$Maybe$Nothing,
            wZ: $elm$core$Dict$empty,
            h1: $elm$core$Maybe$Nothing,
            lH: $elm$core$Maybe$Nothing,
            h3: $elm$core$Maybe$Nothing,
            cP: shared.cP,
            lM: $author$project$Components$CustomerEmailModal$init,
            h9: false,
            it: $author$project$Components$Invoice$DownloadFile$init(shared.aaT),
            iw: $elm$core$Maybe$Nothing,
            aeb: shared.aeb,
            Rr: $author$project$Api$Data$Loading,
            RA: $author$project$Api$Data$NotAsked,
            RI: params.RI,
            F3: $author$project$Shared$isHintAdmin(shared),
            mO: false,
            Gc: $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top({
                V8: params.V8
            }),
            ng: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'other-actions-dropdown-menu',
                ahX: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$OtherActionsDropdownMsg
            })),
            V4: $author$project$Api$Data$NotAsked,
            V7: patient,
            V8: params.V8,
            jt: A4($author$project$Components$PaymentsList$init, shared.HO, $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(params.RI), session, false),
            W1: practice,
            jI: $elm$core$Maybe$Nothing,
            sp: shared.sp,
            gG: $author$project$Components$CustomerSchedulePaymentModal$init,
            j$: _List_Nil,
            Z$: session,
            Cu: shared,
            ku: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'tax-profiles-dropdown',
                ahX: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileDropdownMsg
            })),
            g2: $author$project$Api$Data$NotAsked,
            HO: shared.HO,
            aaT: shared.aaT
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, shared.Ej, params.RI),
            A2($author$project$Api$Provider$TaxProfile$list, shared.Ej, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotTaxProfiles),
            $author$project$Shared$isHintAdmin(shared) ? A3($author$project$Api$Provider$CustomerInvoice$integrationRecords, shared.Ej, params.RI, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotIntegrationRecords) : $elm$core$Platform$Cmd$none
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg = function(a) {
        return {
            $: 48,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg = function(a) {
        return {
            $: 40,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg = function(a) {
        return {
            $: 46,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg = function(a) {
        return {
            $: 45,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg = function(a) {
        return {
            $: 35,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg = function(a) {
        return {
            $: 47,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg = function(a) {
        return {
            $: 42,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$Close = {
        $: 1
    };
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerInvoice$AdjustVoidModal$Close);
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Close = {
        $: 0
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotLocalStorageItem = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = _Utils_Tuple2(model.hI, model.bU);
                if (!_v1.a.$) {
                    var _v2 = _v1.a.a;
                    var cardReaderConnectingModal = _v2.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg, $author$project$Components$CardReader$ConnectingModal$subscriptions(cardReaderConnectingModal));
                } else if (!_v1.b.$) {
                    var _v3 = _v1.b.a;
                    var cardReaderPaymentModal = _v3.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, $author$project$Components$CardReader$PaymentModal$subscriptions(cardReaderPaymentModal));
                } else {
                    var _v4 = _v1.a;
                    var _v5 = _v1.b;
                    return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Close);
                }
            }(),
            $author$project$Ports$LocalStorage$gotItem($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotLocalStorageItem)
        ]));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$Close = {
        $: 1
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CustomerInvoice$ProcessRefundModal$Close);
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$Close = {
        $: 0
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Invoice$CreateScheduledPaymentModal$Close);
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit = {
        $: 2
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$subscriptions = function(model) {
        var _v0 = model.aa;
        if (!_v0.$) return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$CloseClicked = {
        $: 0
    };
    var $author$project$Components$Patient$Charges$ChargeModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$Charges$ChargeModal$CloseClicked);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg, $author$project$Components$CustomerSchedulePaymentModal$subscriptions(model.gG)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreatePaymentModal$subscriptions, model.lH))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Invoice$CreateScheduledPaymentModal$subscriptions, model.h3))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$subscriptions, model.h1))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$subscriptions, model.fj))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$subscriptions, model.iw))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$subscriptions, model.hs))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$subscriptions, model.jI))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg, $author$project$Components$Invoice$DownloadFile$subscriptions(model.it)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg, $author$project$Components$CustomerEmailModal$subscriptions(model.lM)),
            model.h9 ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed) : $elm$core$Platform$Sub$none,
            model.hD ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed) : $elm$core$Platform$Sub$none,
            function() {
                var _v0 = model.hB;
                if (!_v0.$) {
                    var auditTrailLog = _v0.a;
                    return $author$project$Components$AuditTrailLog$isOpen(auditTrailLog) ? A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$subscriptions(auditTrailLog)) : $elm$core$Platform$Sub$none;
                } else return $elm$core$Platform$Sub$none;
            }(),
            $author$project$Ui$Dropdown$subscriptions(model.ku),
            $author$project$Ui$Dropdown$subscriptions(model.ng),
            $elm$core$Platform$Sub$batch(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Ui$Dropdown$subscriptions), model.hM)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg, $author$project$Components$PaymentsList$subscriptions(model.jt))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDeleted = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotBankAccounts = function(a) {
        return {
            $: 51,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards = function(a) {
        return {
            $: 52,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCoverageDiscounts = F2(function(a, b) {
        return {
            $: 37,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotScheduledPayments = function(a) {
        return {
            $: 50,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceIssued = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Api$FeatureGate$ScheduledPartialPayments = 12;
    var $author$project$Api$Provider$CustomerInvoice$applyCredits = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'apply_credits'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$cancelPayment = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel_payment'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$One$createdAt = function(_v0) {
        var record = _v0.b;
        return record.Mx;
    };
    var $author$project$Api$Provider$CustomerInvoice$Charge$chargesPath = function(customerInvoiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'charges'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            customerInvoiceId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'customer_invoices'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$CustomerInvoice$Charge$chargePath = F2(function(customerInvoiceId, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$CustomerInvoice$Charge$chargesPath(customerInvoiceId));
    });
    var $author$project$Api$Provider$CustomerInvoice$Charge$delete = F4(function(apiClient, customerInvoiceId, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$CustomerInvoice$Charge$chargePath, customerInvoiceId, id_)));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceDeleted = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$deleteInvoice = function(model) {
        var _v0 = model.RA;
        if (_v0.$ === 3) {
            var invoice = _v0.a;
            return _Utils_Tuple3(model, A3($author$project$Api$Provider$CustomerInvoice$delete, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceDeleted), _List_Nil);
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    };
    var $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource = function(_v0) {
        var record = _v0;
        return record.Wr;
    };
    var $author$project$Api$Provider$ScheduledPayment$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard = function(scheduledPayments) {
        var scheduled = A2($elm$core$List$filter, function(sp) {
            return $author$project$Api$Provider$ScheduledPayment$Shared$status(sp) === 'scheduled';
        }, scheduledPayments);
        return !$elm$core$List$isEmpty(scheduled) && A2($elm$core$List$all, function(sp) {
            var _v0 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(sp);
            if (!_v0.$) {
                var source = _v0.a;
                return !_Utils_eq($author$project$Api$Common$Source$Shared$type_(source), $elm$core$Maybe$Just('Card'));
            } else return false;
        }, scheduled);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard = function(cards) {
        if (cards.$ === 3) {
            var cards_ = cards.a;
            return $elm$core$List$head(A2($elm$core$List$filter, $author$project$Api$Source$default, A2($elm$core$List$map, $author$project$Api$Source$Card, cards_)));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource = F4(function(practice, invoice, cards, scheduledPayments) {
        if ($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard(scheduledPayments)) return $elm$core$Maybe$Nothing;
        else {
            var _v0 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
            if (!_v0.$) {
                var source = _v0.a;
                return _Utils_eq($author$project$Api$Common$Source$Shared$type_(source), $elm$core$Maybe$Just('Card')) ? $elm$core$Maybe$Just($author$project$Api$Source$Source(source)) : $elm$core$Maybe$Nothing;
            } else return $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard(cards);
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotPassthroughFees = function(a) {
        return {
            $: 54,
            a: a
        };
    };
    var $author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFeesPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'calculate'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'passthroughs'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId)));
    };
    var $author$project$Api$Provider$PassthroughFee$One$PassthroughFee = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PassthroughFee$Shared$PassthroughFee = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PassthroughFee$Shared$InternalRecord = F2(function(passthroughFeeInCents, totalInCents) {
        return {
            V3: passthroughFeeInCents,
            aam: totalInCents
        };
    });
    var $author$project$Api$Provider$PassthroughFee$Shared$internalRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'passthrough_fees_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PassthroughFee$Shared$InternalRecord)));
    var $author$project$Api$Provider$PassthroughFee$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PassthroughFee$Shared$internalRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PassthroughFee$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PassthroughFee$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees = F6(function(apiClient, patientId, paymentMethodId, type_, amountInCents, toMsg) {
        var _v0 = function() {
            _v1$3: while(true){
                if (!type_.$) switch(type_.a){
                    case 'credit':
                        return _Utils_Tuple2($elm$core$Maybe$Just('card'), $elm$core$Maybe$Just('credit'));
                    case 'amex':
                        return _Utils_Tuple2($elm$core$Maybe$Just('amex'), $elm$core$Maybe$Just('credit'));
                    case 'debit':
                        return _Utils_Tuple2($elm$core$Maybe$Just('card'), $elm$core$Maybe$Just('debit'));
                    default:
                        break _v1$3;
                }
                else break _v1$3;
            }
            return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
        }();
        var cardType = _v0.a;
        var cardFunding = _v0.b;
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('passthrough', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('amount_in_cents', $elm$json$Json$Encode$int(amountInCents)),
                _Utils_Tuple2('payment_method_id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, paymentMethodId)),
                _Utils_Tuple2('card_type', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, cardType)),
                _Utils_Tuple2('card_funding', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, cardFunding))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PassthroughFee$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFeesPath(patientId))));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd = F4(function(apiClient, amount, sourceChoice, patientId) {
        var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Source$id, sourceChoice);
        if (!_v0.$) {
            var sourceId = _v0.a;
            return A6($author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees, apiClient, patientId, $elm$core$Maybe$Just(sourceId), $elm$core$Maybe$Nothing, amount, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotPassthroughFees);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$CustomerInvoice$Shared$date = function(_v0) {
        var record = _v0;
        return record.M4;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$date = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$date(shared);
    };
    var $author$project$Api$Provider$CustomerInvoice$One$location = function(_v0) {
        var record = _v0.b;
        return record.aeT;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$owner = function(_v0) {
        var record = _v0.b;
        return record.VM;
    };
    var $author$project$Components$Membership$Form$Records$patientFromShared = function(patient) {
        return {
            IZ: $author$project$Api$Provider$Patient$Shared$age(patient),
            aef: $author$project$Api$Provider$Patient$Shared$id(patient),
            aeT: $elm$core$Maybe$Nothing,
            T5: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient),
            zr: $author$project$Api$Provider$Patient$Shared$name(patient),
            agi: $elm$core$Maybe$Nothing,
            aa4: $author$project$Api$Provider$Patient$Shared$usesTobacco(patient)
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsFromInvoice = function(invoice) {
        var payer = function() {
            var _v2 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
            if (!_v2.$) {
                var patient = _v2.a;
                return $author$project$Components$Membership$Form$Records$patientFromShared(patient);
            } else return {
                IZ: $elm$core$Maybe$Nothing,
                aef: '',
                aeT: $elm$core$Maybe$Nothing,
                T5: '',
                zr: '',
                agi: $elm$core$Maybe$Nothing,
                aa4: $elm$core$Maybe$Nothing
            };
        }();
        var locationId = function() {
            var _v1 = $author$project$Api$Provider$CustomerInvoice$One$location(invoice);
            if (!_v1.$) {
                var location1 = _v1.a;
                return $author$project$Api$Provider$Location$Min$id(location1);
            } else return '';
        }();
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2({
            qg: dateInput,
            RG: $elm$core$Maybe$Just($author$project$Api$Provider$CustomerInvoice$One$date(invoice)),
            Tp: $elm$core$Maybe$Just(locationId),
            GR: $elm$core$Maybe$Just(payer)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg(dateInput), dateInputCmd));
    };
    var $author$project$Components$ResourceFilter$Location$resourceFromMin = $elm$core$Maybe$map(function(location1) {
        return {
            IY: $elm$core$Maybe$Nothing,
            aef: $author$project$Api$Provider$Location$Min$id(location1),
            R8: false,
            Su: false,
            zr: $author$project$Api$Provider$Location$Min$name(location1)
        };
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter = F2(function(apiClient, invoice) {
        var invoiceLocation = $author$project$Api$Provider$CustomerInvoice$One$location(invoice);
        var _v0 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a location',
                I5: false
            });
        });
        var locationResourceFilterModel = _v0.a;
        var locationResourceFilterCmd = _v0.b;
        var locationResourceFilter = function() {
            if (!invoiceLocation.$) {
                var location1 = invoiceLocation.a;
                return function(value) {
                    return A2($author$project$Components$ResourceFilter$Location$setValue, value, locationResourceFilterModel);
                }($author$project$Components$ResourceFilter$Location$resourceFromMin($elm$core$Maybe$Just(location1)));
            } else return locationResourceFilterModel;
        }();
        return _Utils_Tuple2(locationResourceFilter, locationResourceFilterCmd);
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initPatientResourceFilter = F2(function(apiClient, preselectedPatient) {
        return A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Patient$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(patient_) {
            return _List_fromArray([
                {
                    IZ: $author$project$Api$Provider$Patient$Shared$age(patient_),
                    aef: $author$project$Api$Provider$Patient$Shared$id(patient_),
                    T5: $author$project$Api$Provider$Patient$Shared$membershipStatus(patient_),
                    zr: $author$project$Api$Provider$Patient$Shared$name(patient_)
                }
            ]);
        }, preselectedPatient))), A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Payer',
                I5: false,
                agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$id, preselectedPatient)
            });
        }));
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$init = F2(function(apiClient, invoice) {
        var invoicePayer = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
        var _v0 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initPatientResourceFilter, apiClient, invoicePayer);
        var patientResourceFilter = _v0.a;
        var patientResourceFilterCmd = _v0.b;
        var _v1 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter, apiClient, invoice);
        var locationResourceFilter = _v1.a;
        var locationResourceFilterCmd = _v1.b;
        var _v2 = $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsFromInvoice(invoice);
        var form = _v2.a;
        var formCmd = _v2.b;
        return _Utils_Tuple2({
            ye: true,
            aa: $elm$core$Maybe$Just(_Utils_Tuple3($author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Utils$Form$init(form), invoice)),
            Tk: false,
            ro: $elm$core$Maybe$Just(locationResourceFilter),
            rX: $elm$core$Maybe$Just(patientResourceFilter)
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceFilterCmd),
            formCmd
        ])));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$age(shared);
    };
    var $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig = function(d) {
        return _Utils_update(d, {
            Ee: 'None',
            I5: false,
            ad$: true,
            ad0: '',
            ad7: true,
            ad8: true,
            afn: false
        });
    };
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location = function(_v0) {
        var record = _v0.b;
        return record.aeT;
    };
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$membershipStatus(shared);
    };
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner = function(_v0) {
        var record = _v0.b;
        return record.agi;
    };
    var $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$usesTobacco(shared);
    };
    var $author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector = F3(function(apiClient, probablePatients, patient) {
        return A4($author$project$Components$LimitedPatientSelector$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Patient',
                I5: false
            });
        }, A2($elm$core$List$map, function(patient_) {
            return {
                IZ: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient_),
                aef: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
                aeT: A2($elm$core$Maybe$map, function(location1) {
                    return {
                        aef: $author$project$Api$Provider$Location$Min$id(location1),
                        zr: $author$project$Api$Provider$Location$Min$name(location1)
                    };
                }, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient_)),
                T5: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient_),
                zr: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_),
                agi: A2($elm$core$Maybe$map, function(practitioner) {
                    return {
                        aef: $author$project$Api$Provider$Practitioner$Min$id(practitioner),
                        zr: $author$project$Api$Provider$Practitioner$Min$name(practitioner)
                    };
                }, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient_)),
                aa4: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient_)
            };
        }, probablePatients), patient);
    });
    var $author$project$Components$Patient$Charges$ChargeModal$formFieldsFromItem = F5(function(apiClient, showItemTypeInTitle, session, probablePatients, charge) {
        var practitioner = $author$project$Api$Provider$Charge$One$practitioner(charge);
        var patient = $author$project$Api$Provider$Charge$One$patient(charge);
        var location1 = $author$project$Api$Provider$Charge$One$location(charge);
        var formPatient = A2($elm$core$Maybe$map, function(patient_) {
            return {
                aef: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
                zr: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_)
            };
        }, patient);
        var chargeItem = A2($elm$core$Maybe$map, function(chargeItem_) {
            return {
                I0: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem_),
                EL: $author$project$Api$Provider$Charge$One$category(charge),
                Lk: $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem_),
                Lm: $author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem_),
                NQ: $author$project$Api$Provider$ChargeItem$ForCharge$description(chargeItem_),
                aef: $author$project$Api$Provider$ChargeItem$ForCharge$id(chargeItem_),
                aeE: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_),
                rc: $author$project$Api$Provider$ChargeItem$ForCharge$isPackage(chargeItem_) ? 1 : 0,
                TC: $author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem_),
                zr: $author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem_),
                Br: $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents(chargeItem_),
                XT: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem_),
                $S: $author$project$Api$Provider$ChargeItem$ForCharge$taxable(chargeItem_),
                aap: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem_),
                aaK: $author$project$Api$Provider$ChargeItem$ForCharge$uom(chargeItem_)
            };
        }, $author$project$Api$Provider$Charge$One$chargeItem(charge));
        var category = $author$project$Api$Provider$Charge$One$category(charge);
        var _v0 = $author$project$Components$DateInput$init;
        var startDateInput = _v0.a;
        var startDateInputCmd = _v0.b;
        var _v1 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Practitioner$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(practitioner_) {
            return _List_fromArray([
                {
                    aef: $author$project$Api$Provider$Practitioner$Shared$id(practitioner_),
                    zr: $author$project$Api$Provider$Practitioner$Shared$name(practitioner_)
                }
            ]);
        }, practitioner))), A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false,
                agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner)
            });
        }));
        var practitionerResourceFilter = _v1.a;
        var practitionerResourceFilterCmd = _v1.b;
        var _v2 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Location$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(location_) {
            return _List_fromArray([
                {
                    aef: $author$project$Api$Provider$Location$Min$id(location_),
                    zr: $author$project$Api$Provider$Location$Min$name(location_)
                }
            ]);
        }, location1))), A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false,
                agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location1)
            });
        }));
        var locationResourceFilter = _v2.a;
        var locationResourceFilterCmd = _v2.b;
        var _v3 = A3($author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector, apiClient, probablePatients, A2($elm$core$Maybe$map, function(patient_) {
            return {
                IZ: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient_),
                aef: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient_),
                aeT: A2($elm$core$Maybe$map, function(location_) {
                    return {
                        aef: $author$project$Api$Provider$Location$Min$id(location_),
                        zr: $author$project$Api$Provider$Location$Min$name(location_)
                    };
                }, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient_)),
                T5: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient_),
                zr: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient_),
                agi: A2($elm$core$Maybe$map, function(practitioner_) {
                    return {
                        aef: $author$project$Api$Provider$Practitioner$Min$id(practitioner_),
                        zr: $author$project$Api$Provider$Practitioner$Min$name(practitioner_)
                    };
                }, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient_)),
                aa4: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient_)
            };
        }, patient));
        var limitedPatientSelector = _v3.a;
        var limitedPatientSelectorCmd = _v3.b;
        var _v4 = $author$project$Components$DateInput$init;
        var endDateInput = _v4.a;
        var endDateInputCmd = _v4.b;
        var _v5 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$ChargeItem$setValue(A2($elm$core$Maybe$withDefault, $author$project$Components$ResourceFilter$FreeText(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Charge$One$name(charge))), A2($elm$core$Maybe$map, function(chargeItem_) {
            return $author$project$Components$ResourceFilter$One({
                I0: chargeItem_.I0,
                EL: chargeItem_.EL,
                Lk: chargeItem_.Lk,
                Lm: chargeItem_.Lm,
                NQ: chargeItem_.NQ,
                aef: chargeItem_.aef,
                aeE: chargeItem_.aeE,
                rc: chargeItem_.rc,
                TC: chargeItem_.TC,
                zr: chargeItem_.zr,
                Br: chargeItem_.Br,
                XT: chargeItem_.XT,
                $S: chargeItem_.$S,
                aap: chargeItem_.aap,
                aaK: chargeItem_.aaK
            });
        }, chargeItem))), A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig));
        var chargeItemResourceFilter = _v5.a;
        var chargeItemResourceFilterCmd = _v5.b;
        var _v6 = A2($elm$core$Tuple$mapFirst, $author$project$Components$ResourceFilter$Category$extraItems(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(category_) {
            return _List_fromArray([
                {
                    aef: $author$project$Api$Provider$Category$Shared$id(category_),
                    zr: $author$project$Api$Provider$Category$Shared$name(category_)
                }
            ]);
        }, category))), A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false,
                agj: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category)
            });
        }));
        var categoryResourceFilter = _v6.a;
        var categoryResourceFilterCmd = _v6.b;
        return _Utils_Tuple2({
            EL: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, $author$project$Api$Provider$Charge$One$category(charge)),
            cK: categoryResourceFilter,
            lv: chargeItem,
            cL: chargeItemResourceFilter,
            NQ: $author$project$Api$Provider$Charge$One$description(charge),
            N$: $author$project$Api$Provider$Charge$One$discountInCents(charge),
            N0: $author$project$Api$Provider$Charge$One$discountOverridden(charge),
            qv: $author$project$Api$Provider$Charge$One$endDate(charge),
            qx: endDateInput,
            aef: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$id(charge)),
            rg: limitedPatientSelector,
            aeT: A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$id, location1),
            ro: locationResourceFilter,
            zr: $author$project$Api$Provider$Charge$One$name(charge),
            V7: formPatient,
            agi: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$id, practitioner),
            jE: practitionerResourceFilter,
            Br: $author$project$Currency$fromMaybeInt($author$project$Api$Provider$Charge$One$priceInCents(charge)),
            Xn: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$priceUom(charge)),
            Bu: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$quantity(charge)),
            Bv: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$quantityUom(charge)),
            _0: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$date(charge)),
            kj: startDateInput,
            $S: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$ForCharge$taxable, $author$project$Api$Provider$Charge$One$chargeItem(charge)))
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput), startDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput), endDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceFilterCmd)
        ])));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$initFormFields = F6(function(apiClient, showItemTypeInTitle, session, date, probablePatients, patient) {
        var maybePractitioner = A2($elm$core$Maybe$map, function(prac) {
            return {
                IY: $elm$core$Maybe$Nothing,
                aef: $author$project$Api$Provider$Practitioner$Shared$id(prac),
                R8: $author$project$Api$Provider$Practitioner$Shared$isMaster(prac),
                Su: $author$project$Api$Provider$Practitioner$Shared$isSynced(prac),
                zr: $author$project$Api$Provider$Practitioner$Shared$name(prac),
                Vy: $author$project$Api$Provider$Practitioner$Shared$openingsSize(prac),
                agg: '',
                Xb: ''
            };
        }, $author$project$Api$Provider$Patient$One$practitioner(patient));
        var maybeLocation = A2($elm$core$Maybe$map, function(loc) {
            return {
                IY: $elm$core$Maybe$Nothing,
                aef: $author$project$Api$Provider$Location$Shared$id(loc),
                R8: false,
                Su: false,
                zr: $author$project$Api$Provider$Location$Shared$name(loc)
            };
        }, $author$project$Api$Provider$Patient$One$location(patient));
        var _v0 = $author$project$Components$DateInput$init;
        var startDateInput = _v0.a;
        var startDateInputCmd = _v0.b;
        var _v1 = A2($elm$core$Tuple$mapFirst, function(filter) {
            return A2($author$project$Components$ResourceFilter$Practitioner$setValue, maybePractitioner, filter);
        }, A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        }));
        var practitionerResourceFilter = _v1.a;
        var practitionerResourceFilterCmd = _v1.b;
        var _v2 = A2($elm$core$Tuple$mapFirst, function(filter) {
            return A2($author$project$Components$ResourceFilter$Location$setValue, maybeLocation, filter);
        }, A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        }));
        var locationResourceFilter = _v2.a;
        var locationResourceFilterCmd = _v2.b;
        var _v3 = A3($author$project$Components$Patient$Charges$ChargeModal$initLimitedPatientSelector, apiClient, probablePatients, $elm$core$Maybe$Just({
            IZ: $author$project$Api$Provider$Patient$One$age(patient),
            aef: $author$project$Api$Provider$Patient$One$id(patient),
            aeT: A2($elm$core$Maybe$map, function(location1) {
                return {
                    aef: $author$project$Api$Provider$Location$Shared$id(location1),
                    zr: $author$project$Api$Provider$Location$Shared$name(location1)
                };
            }, $author$project$Api$Provider$Patient$One$location(patient)),
            T5: $author$project$Api$Provider$Patient$One$membershipStatus(patient),
            zr: $author$project$Api$Provider$Patient$One$name(patient),
            agi: A2($elm$core$Maybe$map, function(practitioner) {
                return {
                    aef: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
                    zr: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
                };
            }, $author$project$Api$Provider$Patient$One$practitioner(patient)),
            aa4: $author$project$Api$Provider$Patient$One$usesTobacco(patient)
        }));
        var limitedPatientSelector = _v3.a;
        var limitedPatientSelectorCmd = _v3.b;
        var _v4 = $author$project$Components$DateInput$init;
        var endDateInput = _v4.a;
        var endDateInputCmd = _v4.b;
        var _v5 = A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig);
        var chargeItemResourceFilter = _v5.a;
        var chargeItemResourceFilterCmd = _v5.b;
        var _v6 = A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
        var categoryResourceFilter = _v6.a;
        var categoryResourceFilterCmd = _v6.b;
        return _Utils_Tuple2({
            EL: $elm$core$Maybe$Nothing,
            cK: categoryResourceFilter,
            lv: $elm$core$Maybe$Nothing,
            cL: chargeItemResourceFilter,
            NQ: '',
            N$: 0,
            N0: false,
            qv: $elm$core$Maybe$Nothing,
            qx: endDateInput,
            aef: $elm$core$Maybe$Nothing,
            rg: limitedPatientSelector,
            aeT: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, maybeLocation),
            ro: locationResourceFilter,
            zr: $elm$core$Maybe$Nothing,
            V7: $elm$core$Maybe$Just({
                aef: $author$project$Api$Provider$Patient$One$id(patient),
                zr: $author$project$Api$Provider$Patient$One$name(patient)
            }),
            agi: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, maybePractitioner),
            jE: practitionerResourceFilter,
            Br: $elm$core$Maybe$Nothing,
            Xn: $elm$core$Maybe$Nothing,
            Bu: $elm$core$Maybe$Just(1),
            Bv: $elm$core$Maybe$Nothing,
            _0: $elm$core$Maybe$Just(date),
            kj: startDateInput,
            $S: false
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput), startDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput), endDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceFilterCmd)
        ])));
    });
    var $author$project$Api$Provider$CustomerInvoice$One$probablePatients = function(_v0) {
        var record = _v0.b;
        return record.Xr;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$init = F6(function(apiClient, session, practice, patient, invoice, charge) {
        var showItemTypeInTitle = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice);
        var _v0 = function() {
            if (!charge.$) {
                var charge_ = charge.a;
                return A5($author$project$Components$Patient$Charges$ChargeModal$formFieldsFromItem, apiClient, showItemTypeInTitle, session, $author$project$Api$Provider$CustomerInvoice$One$probablePatients(invoice), charge_);
            } else {
                var date = $author$project$Api$Provider$CustomerInvoice$One$date(invoice);
                return A6($author$project$Components$Patient$Charges$ChargeModal$initFormFields, apiClient, showItemTypeInTitle, session, date, $author$project$Api$Provider$CustomerInvoice$One$probablePatients(invoice), patient);
            }
        }();
        var formFields = _v0.a;
        var formCmd = _v0.b;
        return _Utils_Tuple2({
            vX: A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$meta, charge))),
            ach: charge,
            PU: $author$project$Utils$Form$init(formFields),
            RA: invoice,
            V7: patient,
            W1: practice,
            agk: $author$project$Api$Data$NotAsked,
            eq: $jinjor$elm_debounce$Debounce$init,
            n8: false,
            Z$: session,
            gP: false
        }, formCmd);
    });
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$One$charges = function(_v0) {
        var record = _v0.b;
        return record.K9;
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields = F2(function(charge, voidOnly) {
        return {
            ach: charge,
            lv: $author$project$Api$Provider$Charge$One$chargeItem(charge),
            M4: $author$project$Api$Provider$Charge$One$date(charge),
            xl: false,
            qv: $author$project$Api$Provider$Charge$One$endDate(charge),
            qx: A2($elm$core$Maybe$map, $author$project$Components$DateInput$initFromDate, $author$project$Api$Provider$Charge$One$endDate(charge)),
            Br: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$Charge$One$priceInCents(charge)),
            Bu: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$quantity(charge)),
            Bv: $author$project$Api$Provider$Charge$One$quantityUom(charge),
            eB: false,
            M: !$author$project$Api$Provider$Charge$One$quantity(charge) || voidOnly,
            H3: false
        };
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$init = F2(function(charge, voidOnly) {
        var form = $author$project$Utils$Form$init(A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields, charge, voidOnly));
        return _Utils_Tuple2({
            tS: $elm$core$Maybe$Nothing,
            PU: form,
            D_: voidOnly
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$init = F2(function(invoice, _v0) {
        var voidOnly = _v0.D_;
        var refunding = _v0.agD;
        var voidCmd = voidOnly ? A2($elm$core$Task$perform, $author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll, $elm$core$Task$succeed(true)) : $elm$core$Platform$Cmd$none;
        var adjustments = A2($elm$core$List$map, function(charge) {
            return _Utils_Tuple2($author$project$Api$Provider$Charge$One$id(charge), A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$init, charge, voidOnly));
        }, A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$CustomerInvoice$One$charges(invoice)));
        var adjustmentsCmds = A2($elm$core$List$map, function(_v2) {
            var chargeId = _v2.a;
            var adjustment = _v2.b;
            return A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId), adjustment.b);
        }, adjustments);
        var forms = A2($elm$core$List$map, function(_v1) {
            var chargeId = _v1.a;
            var adjustment = _v1.b;
            return _Utils_Tuple2(chargeId, adjustment.a);
        }, adjustments);
        return _Utils_Tuple2({
            W: forms,
            fK: _List_Nil,
            RA: invoice,
            ae0: $elm$core$Maybe$Nothing,
            agk: $author$project$Api$Data$NotAsked,
            agD: refunding,
            oS: 0,
            D_: voidOnly
        }, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, voidCmd, adjustmentsCmds)));
    });
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$init = F2(function(invoice, voidOnly) {
        var _v0 = A2($author$project$Components$CustomerInvoice$AdjustmentsForm$init, invoice, {
            agD: false,
            D_: voidOnly
        });
        var adjustmentsFormModel = _v0.a;
        var adjustmentsFormCmd = _v0.b;
        return _Utils_Tuple2({
            bn: adjustmentsFormModel,
            RA: invoice,
            km: false,
            D_: voidOnly
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg, adjustmentsFormCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal = F3(function(model, invoice, voidOnly) {
        var _v0 = A2($author$project$Components$CustomerInvoice$AdjustVoidModal$init, invoice, voidOnly);
        var adjustVoidModal = _v0.a;
        var adjustVoidModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            hs: $elm$core$Maybe$Just(adjustVoidModal)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg, adjustVoidModalCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDropdownsMsg = F2(function(a, b) {
        return {
            $: 49,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Charge$Shared$isPersisted = function(_v0) {
        var record = _v0;
        return record.Sj;
    };
    var $author$project$Api$Provider$Charge$One$isPersisted = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$isPersisted(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initChargeDropdowns = function(invoice) {
        return A2($elm$core$List$map, function(charge) {
            return _Utils_Tuple2($author$project$Api$Provider$Charge$One$id(charge), $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toDownLeft($author$project$Ui$Dropdown$defaultConfig({
                aef: 'charge-dropdown-' + $author$project$Api$Provider$Charge$One$id(charge),
                ahX: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDropdownsMsg(charge)
            }))));
        }, A2($elm$core$List$filter, $author$project$Api$Provider$Charge$One$isPersisted, A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$CustomerInvoice$One$charges(invoice))));
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotBankAccounts = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotCards = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderLabel = F2(function(showProcessor, cardReader) {
        return A2($elm$core$String$join, ' ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A3($author$project$Utils$PaymentProcessor$toLabel, showProcessor, cardReader, A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just)),
            $elm$core$Maybe$Just($author$project$Api$Provider$CardReader$All$label(cardReader))
        ])));
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderToValue = function(cardReader) {
        return $elm$core$Maybe$Just($author$project$Api$Provider$CardReader$All$id(cardReader));
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$defaultOptions = {
        or: false
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotPassthroughFees = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard = F2(function(useExistingSources, _v0) {
        var source = _v0.Hw;
        var cardType = _v0.KZ;
        var _v1 = _Utils_Tuple3(useExistingSources, A2($elm$core$Maybe$andThen, $author$project$Api$Source$type_, source), cardType);
        _v1$3: while(true)if (_v1.a) {
            if (!_v1.b.$ && _v1.b.a === 'Card') return true;
            else break _v1$3;
        } else {
            if (!_v1.c.$) switch(_v1.c.a){
                case 'credit':
                    return true;
                case 'amex':
                    return true;
                default:
                    break _v1$3;
            }
            else break _v1$3;
        }
        return false;
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd = F5(function(apiClient, useExistingSources, amount, fields, patientId) {
        return A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, useExistingSources, fields) ? A6($author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees, apiClient, patientId, A2($elm$core$Maybe$map, $author$project$Api$Source$id, fields.Hw), fields.KZ, amount, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotPassthroughFees) : $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Manual = 0;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAtDateInputMsg = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsFromPayable = F3(function(today, allowMultipleMemberships, payable) {
        var dueInCents = $author$project$Api$Provider$CustomerInvoice$One$dueInCents(payable);
        var defaultSource = allowMultipleMemberships ? A2($elm_community$maybe_extra$Maybe$Extra$orElse, A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$CustomerInvoice$One$source(payable)), A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(payable))) : A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$CustomerInvoice$One$source(payable));
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2({
            Jh: $elm$core$Maybe$Just($author$project$Currency$fromInt(dueInCents)),
            cI: 0,
            ace: $elm$core$Maybe$Nothing,
            KZ: $elm$core$Maybe$Nothing,
            mF: dueInCents,
            ae0: $elm$core$Maybe$Nothing,
            VQ: $elm$core$Maybe$Just(today),
            GN: dateInput,
            Hw: defaultSource,
            CK: false
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAtDateInputMsg(dateInput), dateInputCmd));
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$paymentSourceToValue = function(source) {
        return $elm$core$Maybe$Just($author$project$Api$Source$id(source));
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceName = function(source_) {
        var _v0 = $author$project$Api$Source$name(source_);
        if (!_v0.$) {
            var name = _v0.a;
            return $elm$core$Maybe$Just(name);
        } else return $author$project$Api$Source$type_(source_);
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceLabel = F2(function(showProcessor, source) {
        var paymentProcessorLabel = function(source_) {
            var _v0 = _Utils_Tuple2(showProcessor, A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, $author$project$Api$Source$paymentProcessor(source_)));
            if (_v0.a && !_v0.b.$) {
                var paymentProcessor_ = _v0.b.a;
                return $elm$core$Maybe$Just('[' + (paymentProcessor_ + ']'));
            } else return $elm$core$Maybe$Nothing;
        };
        return A2($elm$core$String$join, ' ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            paymentProcessorLabel(source),
            A2($elm$core$Maybe$map, $author$project$Formatters$String$titleize, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceName(source)),
            A2($elm$core$Maybe$map, function(lastFour) {
                return ' * ' + lastFour;
            }, $author$project$Api$Source$lastFour(source)),
            A2($elm$core$Maybe$map, function(funding) {
                return ' (' + (funding + ')');
            }, $author$project$Api$Source$funding(source))
        ])));
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCardReader = F2(function(showProcessor, cardReader) {
        return _List_fromArray([
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, showProcessor, showProcessor, cardReader, A2($elm$core$Basics$composeR, $author$project$Api$Provider$CardReader$All$paymentProcessor, $elm$core$Maybe$Just))),
            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderLabel, showProcessor, cardReader))
            ]))
        ]);
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$paymentProcessor = F2(function(showProcessor, source_) {
        var badge = F2(function(style, processor) {
            return $elm$core$Maybe$Just(A2($author$project$Ui$Badge$fromString, _List_fromArray([
                $author$project$Ui$Badge$spacedRight,
                style
            ]), processor));
        });
        var _v0 = _Utils_Tuple2(showProcessor, A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, $author$project$Api$Source$paymentProcessor(source_)));
        _v0$2: while(true){
            if (_v0.a && !_v0.b.$) switch(_v0.b.a){
                case 'stripe':
                    return A2(badge, $author$project$Ui$Badge$primary, 'stripe');
                case 'rainforest':
                    return A2(badge, $author$project$Ui$Badge$success, 'rainforest');
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentSource = F2(function(showProcessor, source) {
        return _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$paymentProcessor, showProcessor, source)),
                function() {
                    var _v0 = $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceName(source);
                    if (!_v0.$) {
                        var name = _v0.a;
                        return A2($elm$html$Html$strong, _List_fromArray([
                            $elm$html$Html$Attributes$class('inline')
                        ]), _List_fromArray([
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Formatters$String$titleize(name))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v1 = $author$project$Api$Source$lastFour(source);
                    if (!_v1.$) {
                        var lastFour = _v1.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('*' + lastFour)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v2 = $author$project$Api$Source$funding(source);
                    if (!_v2.$) {
                        var funding = _v2.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('(' + (funding + ')'))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                A2($author$project$Ui$Badge$fromString, _List_Nil, A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Source$status(source))),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v3 = $author$project$Api$Source$label(source);
                    if (!_v3.$) {
                        var label = _v3.a;
                        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$em, _List_fromArray([
                                $elm$html$Html$Attributes$class('text-muted')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true),
                                    $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(label)
                                ]))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]);
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$init = function(today) {
        return function(timeFormatter) {
            return function(paymentPath) {
                return function(sourcePath) {
                    return function(apiClient) {
                        return function(session) {
                            return function(practice) {
                                return function(isHintAdmin) {
                                    return function(rainforestEnv) {
                                        return function(optionsBuilder) {
                                            return function(payable) {
                                                return function(patientId) {
                                                    var useExistingSources = true;
                                                    var options = optionsBuilder($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$defaultOptions);
                                                    var _v0 = function() {
                                                        if (!sourcePath.$) {
                                                            var sourcePath_ = sourcePath.a;
                                                            return _Utils_Tuple2($elm$core$Platform$Cmd$batch(_List_fromArray([
                                                                A4($author$project$Api$Card$list, sourcePath_, apiClient, session, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotCards),
                                                                A4($author$project$Api$BankAccount$list, sourcePath_, apiClient, session, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotBankAccounts)
                                                            ])), $author$project$Api$Data$Loading);
                                                        } else return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked);
                                                    }();
                                                    var sourceCmd = _v0.a;
                                                    var sourceStatus = _v0.b;
                                                    var _v2 = A3($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsFromPayable, today, $author$project$Api$Practice$allowMultipleRetailMemberships(practice), payable);
                                                    var fields = _v2.a;
                                                    var fieldsCmd = _v2.b;
                                                    var amountInCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Jh)));
                                                    var passthroughFeesCmd = A5($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd, apiClient, useExistingSources, amountInCents, fields, patientId);
                                                    return _Utils_Tuple2({
                                                        pF: sourceStatus,
                                                        hI: $elm$core$Maybe$Nothing,
                                                        bU: $elm$core$Maybe$Nothing,
                                                        pO: $author$project$Ui$Form$SearchableSelect$init({
                                                            aef: 'card-reader-select',
                                                            ahW: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCardReader(options.or),
                                                            ahZ: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderLabel(options.or),
                                                            g4: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardReaderToValue
                                                        }),
                                                        hJ: $author$project$Api$Data$NotAsked,
                                                        pQ: sourceStatus,
                                                        PU: $author$project$Utils$Form$init(fields),
                                                        F3: isHintAdmin,
                                                        V4: $author$project$Api$Data$NotAsked,
                                                        V8: patientId,
                                                        af5: payable,
                                                        ag: $author$project$Api$Data$NotAsked,
                                                        r_: paymentPath,
                                                        r1: $author$project$Ui$Form$SearchableSelect$init({
                                                            aef: 'source-select',
                                                            ahW: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentSource(options.or),
                                                            ahZ: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceLabel(options.or),
                                                            g4: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$paymentSourceToValue
                                                        }),
                                                        W1: practice,
                                                        sp: rainforestEnv,
                                                        Z$: session,
                                                        Hx: sourcePath,
                                                        te: $author$project$Api$Provider$CustomerInvoice$One$dueInCents(payable),
                                                        HO: timeFormatter,
                                                        aae: today,
                                                        V: useExistingSources
                                                    }, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                        fieldsCmd,
                                                        sourceCmd,
                                                        passthroughFeesCmd
                                                    ])));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath = function(invoice) {
        return A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$patientPath, A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$id, $author$project$Api$Provider$CustomerInvoice$One$owner(invoice)));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePassthroughFeesPaymentModal = F2(function(model, invoice) {
        var _v0 = $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$init(model.cP)(model.HO)($author$project$Api$Provider$CustomerInvoice$customerInvoicePath($author$project$Api$Provider$CustomerInvoice$One$id(invoice)))($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice))(model.Ej)(model.Z$)($author$project$Api$Practice$Provider(model.W1))(model.F3)(model.sp)(function(d) {
            return _Utils_update(d, {
                or: model.F3
            });
        })(invoice)(model.V8);
        var createPassthroughFeesPaymentModal = _v0.a;
        var createPassthroughFeesPaymentModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            h1: $elm$core$Maybe$Just(createPassthroughFeesPaymentModal)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg, createPassthroughFeesPaymentModalCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal = F4(function(model, invoice, external, displayModal) {
        var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.cP)(model.HO)($author$project$Api$Provider$CustomerInvoice$customerInvoicePath($author$project$Api$Provider$CustomerInvoice$One$id(invoice)))($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice))(model.Ej)(model.Z$)($author$project$Api$Practice$Provider(model.W1))(model.F3)(model.sp)(function(d) {
            return _Utils_update(d, {
                qn: displayModal,
                Po: external,
                or: model.F3
            });
        })(A2($author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice, model.V8, invoice));
        var createPaymentModal = _v0.a;
        var createPaymentModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            lH: $elm$core$Maybe$Just(createPaymentModal)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg, createPaymentModalCmd));
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotBankAccounts = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotCards = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPaymentSources = F3(function(apiClient, session, sourcePath) {
        if (!sourcePath.$) {
            var sourcePath_ = sourcePath.a;
            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                A4($author$project$Api$Card$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreateScheduledPaymentModal$GotCards),
                A4($author$project$Api$BankAccount$list, sourcePath_, apiClient, session, $author$project$Components$Invoice$CreateScheduledPaymentModal$GotBankAccounts)
            ]));
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected = F3(function(a, b, c) {
        return {
            $: 8,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsFromPayable = function(customerInvoice) {
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2({
            mF: $author$project$Api$Provider$CustomerInvoice$One$dueInCents(customerInvoice),
            j: _List_Nil
        }, A2($elm$core$Platform$Cmd$map, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, 0, dateInput), dateInputCmd));
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$init = F9(function(today, timeFormatter, sourcePath, apiClient, session, practice, customerInvoice, patientId, shouldChargeCreditCardFees) {
        var _v0 = $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsFromPayable(customerInvoice);
        var fields = _v0.a;
        var fieldsCmd = _v0.b;
        return _Utils_Tuple2({
            pF: $author$project$Api$Data$Loading,
            pQ: $author$project$Api$Data$Loading,
            lN: customerInvoice,
            PU: $author$project$Utils$Form$init(fields),
            c_: true,
            V8: patientId,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            _c: shouldChargeCreditCardFees,
            Hx: sourcePath,
            HO: timeFormatter,
            aae: today
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            fieldsCmd,
            A3($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPaymentSources, apiClient, session, sourcePath)
        ])));
    });
    var $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees = function(_v0) {
        var record = _v0.b;
        return record._c;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreateScheduledPaymentModal = F2(function(model, invoice) {
        var _v0 = A9($author$project$Components$Invoice$CreateScheduledPaymentModal$init, model.cP, model.HO, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice), model.Ej, model.Z$, model.W1, invoice, model.V8, $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.V7));
        var createScheduledPaymentModal = _v0.a;
        var createScheduledPaymentModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            h3: $elm$core$Maybe$Just(createScheduledPaymentModal)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg, createScheduledPaymentModalCmd));
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$Check = 1;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$Model = $elm$core$Basics$identity;
    var $author$project$Components$CustomerInvoice$RefundsForm$init = F3(function(refunds, timeFormatter, invoice) {
        var forms = A2($elm$core$List$map, function(payment) {
            return _Utils_Tuple2($author$project$Api$Payment$id(payment), $author$project$Utils$Form$init({
                Jh: $elm$core$Maybe$Nothing,
                Wk: payment
            }));
        }, refunds);
        return _Utils_Tuple2({
            pp: 0,
            fK: _List_Nil,
            ap: forms,
            RA: invoice,
            Yr: refunds,
            HO: timeFormatter
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$AmountInCentsValidation = 0;
    var $author$project$Components$CustomerInvoice$RefundsForm$validateAmountInCents = function(fields) {
        var paymentAmount = $author$project$Api$Payment$amountInCents(fields.Wk);
        var isInvalidCurrency = function(amount) {
            return A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(paymentAmount),
                Uj: $elm$core$Maybe$Just(0)
            }, amount);
        };
        return !_Utils_eq(fields.Jh, $elm$core$Maybe$Nothing) && isInvalidCurrency(fields.Jh) ? _List_fromArray([
            _Utils_Tuple2(0, 'Enter a positive amount below or equal to ' + ($author$project$Utils$Currency$fromInt(paymentAmount) + '.'))
        ]) : _List_Nil;
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$refundValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$RefundsForm$validateAmountInCents)
    ]));
    var $author$project$Components$CustomerInvoice$RefundsForm$TotalRefundValidation = 1;
    var $author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount = function(forms) {
        return $elm$core$List$sum(A2($elm$core$List$map, $elm$core$Maybe$withDefault(0), A2($elm$core$List$map, $elm$core$Maybe$andThen($author$project$Currency$toInt), A2($elm$core$List$map, function($) {
            return $.Jh;
        }, A2($elm$core$List$map, $author$project$Utils$Form$fields, A2($elm$core$List$map, $elm$core$Tuple$second, forms))))));
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$RefundsValidation = 0;
    var $author$project$Components$CustomerInvoice$RefundsForm$validateRefunds = function(model) {
        var anyRefundError = A2($elm$core$List$any, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Utils$Form$hasAnyValidationError), model.ap);
        return anyRefundError ? _List_fromArray([
            0
        ]) : _List_Nil;
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$RefundsForm$validateRefunds),
        A2($rtfeldman$elm_validate$Validate$ifTrue, A2($elm$core$Basics$composeR, function($) {
            return $.ap;
        }, A2($elm$core$Basics$composeR, $author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount, function(_int) {
            return _int <= 0;
        })), 1)
    ]));
    var $author$project$Components$CustomerInvoice$RefundsForm$validate = function(_v0) {
        var model = _v0;
        var newForms = A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$mapSecond($author$project$Utils$Form$validate($author$project$Components$CustomerInvoice$RefundsForm$refundValidator)), $elm$core$Tuple$mapSecond($author$project$Utils$Form$fromValidateResult)), model.ap);
        var newModel = _Utils_update(model, {
            fK: _List_Nil,
            ap: newForms
        });
        return $author$project$Utils$Result$merge(A2($elm$core$Result$mapError, function(errors) {
            return _Utils_update(newModel, {
                fK: errors
            });
        }, A2($elm$core$Result$map, $rtfeldman$elm_validate$Validate$fromValid, A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$CustomerInvoice$RefundsForm$validator, newModel))));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$init = function(basePath) {
        return function(payments) {
            return function(invoice) {
                return function(patient) {
                    return function(shared) {
                        return function(session) {
                            return function(practice) {
                                return function(voidOnly) {
                                    return function(timeFormatter) {
                                        return function(isHintAdmin) {
                                            return function(rainforestEnv) {
                                                var paymentProcessorRefundablePayments = A2($elm$core$List$filter, $author$project$Api$Payment$isRefundableOnPaymentProcessor, payments);
                                                var refundType = $elm$core$List$isEmpty(paymentProcessorRefundablePayments) ? $elm$core$Maybe$Just(1) : $elm$core$Maybe$Nothing;
                                                var _v0 = A2($elm$core$Tuple$mapFirst, $author$project$Components$CustomerInvoice$RefundsForm$validate, A3($author$project$Components$CustomerInvoice$RefundsForm$init, payments, timeFormatter, invoice));
                                                var refundsFormModel = _v0.a;
                                                var refundsFormCmd = _v0.b;
                                                var _v1 = A2($author$project$Components$CustomerInvoice$AdjustmentsForm$init, invoice, {
                                                    agD: true,
                                                    D_: voidOnly
                                                });
                                                var adjustmentsFormModel = _v1.a;
                                                var adjustmentsFormCmd = _v1.b;
                                                return _Utils_Tuple2({
                                                    bn: adjustmentsFormModel,
                                                    vK: basePath,
                                                    lH: $elm$core$Maybe$Nothing,
                                                    PU: $author$project$Utils$Form$init({
                                                        ae0: $elm$core$Maybe$Nothing
                                                    }),
                                                    RA: invoice,
                                                    fV: true,
                                                    F3: isHintAdmin,
                                                    rL: false,
                                                    V7: patient,
                                                    Wt: payments,
                                                    W1: practice,
                                                    sp: rainforestEnv,
                                                    ev: $author$project$Api$Data$NotAsked,
                                                    gB: refundType,
                                                    ew: refundsFormModel,
                                                    Z$: session,
                                                    Cu: shared,
                                                    HO: timeFormatter,
                                                    tG: false
                                                }, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                    A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg, adjustmentsFormCmd),
                                                    A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg, refundsFormCmd)
                                                ])));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$One$payments = function(_v0) {
        var record = _v0.b;
        return record.Wt;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments = function(invoice) {
        return A2($elm$core$List$map, $author$project$Api$Payment$Provider_One, A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$CustomerInvoice$One$payments(invoice)));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initProcessRefundModal = F2(function(model, invoice) {
        var _v0 = $author$project$Components$CustomerInvoice$ProcessRefundModal$init($author$project$Api$Data$providerPath)($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments(invoice))(invoice)(model.V7)(model.Cu)(model.Z$)(model.W1)(false)(model.HO)(model.F3)(model.sp);
        var processRefundModal = _v0.a;
        var processRefundModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            jI: $elm$core$Maybe$Just(processRefundModal)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg, processRefundModalCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceRedirect = F2(function(patientId, invoiceId) {
        return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
            RI: invoiceId,
            V8: patientId
        }));
    });
    var $author$project$Api$Provider$ScheduledPayment$Shared$ScheduledPayment = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ScheduledPayment$Shared$Record = F9(function(id, amountInCents, passthroughFeesInCents, payable, payment, paymentSource, scheduledOn, status, memo) {
        return {
            Jh: amountInCents,
            aef: id,
            ae0: memo,
            V5: passthroughFeesInCents,
            af5: payable,
            Wk: payment,
            Wr: paymentSource,
            ag7: scheduledOn,
            ahy: status
        };
    });
    var $author$project$Api$Provider$ScheduledPayment$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'memo', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'scheduled_on', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_source', $elm$json$Json$Decode$nullable($author$project$Api$Common$Source$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Payment$One$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payable', $author$project$Api$Common$Payable$Invoice$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'passthrough_fees_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ScheduledPayment$Shared$Record))))))))));
    var $author$project$Api$Provider$ScheduledPayment$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ScheduledPayment$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath = function(payableId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'scheduled_payments'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'customer_invoices',
            payableId
        ]), $author$project$Api$Data$providerPath));
    };
    var $author$project$Api$Provider$ScheduledPayment$list = F3(function(apiClient, payableId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ScheduledPayment$Shared$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath(payableId)));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkedAsBadDebt = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$markAsBadDebt = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'mark_as_bad_debt'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$markAsBadDebt = function(model) {
        var _v0 = model.RA;
        if (_v0.$ === 3) {
            var invoice = _v0.a;
            return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$markAsBadDebt, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkedAsBadDebt), _List_Nil);
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    };
    var $author$project$Api$Provider$CustomerInvoice$markAsSent = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'mark_as_sent'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$markAsUnsent = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'mark_as_unsent'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$removeCredits = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'remove_credits'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$returnToDraft = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'return_to_draft'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$reverseBadDebt = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reverse_bad_debt'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$reverseCreditTransfer = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reverse_credit_transfer'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$stopRetrying = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'stop_retrying'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$transferToCredit = F4(function(apiClient, id, expand, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'transfer_to_credit'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Api$Provider$CustomerInvoice$update = F5(function(apiClient, invoiceId, fields, expand, toMsg) {
        var taxProfile = function() {
            var _v3 = fields.$R;
            if (!_v3.$) {
                var profile = _v3.a;
                return _List_fromArray([
                    _Utils_Tuple2('tax_profile', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('id', $elm$json$Json$Encode$string(profile))
                    ])))
                ]);
            } else return _List_Nil;
        }();
        var owner = function() {
            var _v2 = fields.VM;
            if (!_v2.$) {
                var owner_ = _v2.a;
                return _List_fromArray([
                    _Utils_Tuple2('owner', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('id', $elm$json$Json$Encode$string(owner_))
                    ])))
                ]);
            } else return _List_Nil;
        }();
        var location1 = function() {
            var _v1 = fields.aeT;
            if (!_v1.$) {
                var location_ = _v1.a;
                return _List_fromArray([
                    _Utils_Tuple2('location', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('id', $elm$json$Json$Encode$string(location_))
                    ])))
                ]);
            } else return _List_Nil;
        }();
        var date = function() {
            var _v0 = fields.M4;
            if (!_v0.$) {
                var date_ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('date', $author$project$Utils$Date$encode(date_))
                ]);
            } else return _List_Nil;
        }();
        var body = $elm$json$Json$Encode$object(_Utils_ap(owner, _Utils_ap(location1, _Utils_ap(date, taxProfile))));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$CustomerInvoice$expandToString, expand))
        ]), A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicePath(invoiceId)))));
    });
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$Closed = 1;
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$None = 0;
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$Revised = 2;
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse = F3(function(model, data, successMsg) {
        if (data.$ === 3) return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 2,
            zi: _Utils_update(model, {
                km: false
            }),
            at: _List_fromArray([
                A2($author$project$OutMsg$ShowToast, 3, successMsg)
            ])
        };
        else return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 1,
            zi: _Utils_update(model, {
                km: false
            }),
            at: $author$project$OutMsg$handleErrorResponse(data)
        };
    });
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$Created = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$Voided = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voided = function(_v0) {
        var form = _v0.PU;
        return $author$project$Utils$Form$fields(form).M;
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided = function(_v0) {
        var model = _v0;
        return model.D_ || A2($elm$core$List$all, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voided, A2($elm$core$List$map, $elm$core$Tuple$second, model.W));
    };
    var $author$project$Api$Provider$InvoiceAdjustment$One$InvoiceAdjustment = 0;
    var $author$project$Api$Provider$InvoiceAdjustment$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath = function(customerInvoiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'invoice_adjustments'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(customerInvoiceId));
    };
    var $author$project$Api$Provider$InvoiceAdjustment$create = F4(function(apiClient, customerInvoiceId, body, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$InvoiceAdjustment$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath(customerInvoiceId))));
    });
    var $author$project$Api$Provider$Uom$Shared$encode = function(uom) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('code', $elm$json$Json$Encode$string($author$project$Api$Provider$Uom$Shared$code(uom))),
            _Utils_Tuple2('name', $elm$json$Json$Encode$string($author$project$Api$Provider$Uom$Shared$name(uom))),
            _Utils_Tuple2('period_quantity', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, $author$project$Api$Provider$Uom$Shared$periodQuantity(uom))),
            _Utils_Tuple2('period_unit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$PeriodUnit$toString, $author$project$Api$Provider$Uom$Shared$periodUnit(uom)))),
            _Utils_Tuple2('type', $elm$json$Json$Encode$string($author$project$Api$Provider$Uom$Shared$type_(uom))),
            _Utils_Tuple2('unit_class', $elm$json$Json$Encode$string($author$project$Api$Provider$Uom$Shared$unitClass(uom)))
        ]));
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory = function(charge) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory, $author$project$Api$Provider$Charge$One$chargeItem(charge)));
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$encodedForm = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        var quantity = fields.M ? $elm$core$Maybe$Just(0) : fields.Bu;
        var returnToInventory = $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory(fields.ach) && fields.M ? $elm$core$Maybe$Just(fields.eB) : $elm$core$Maybe$Nothing;
        var encodedCharge = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string($author$project$Api$Provider$Charge$One$id(fields.ach)))
        ]));
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('date', $author$project$Utils$Date$encode($author$project$Api$Provider$Charge$One$date(fields.ach))),
            _Utils_Tuple2('end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qv)),
            _Utils_Tuple2('charge', encodedCharge),
            _Utils_Tuple2('price_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Br)),
            _Utils_Tuple2('return_to_inventory', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, returnToInventory)),
            _Utils_Tuple2('void', $elm$json$Json$Encode$bool(fields.M)),
            _Utils_Tuple2('quantity_uom', $author$project$Api$Provider$Uom$Shared$encode(fields.Bv)),
            _Utils_Tuple2('quantity', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, quantity))
        ]));
    };
    var $author$project$Api$Provider$CustomerInvoice$One$revisionNumber = function(_v0) {
        var record = _v0.b;
        return record.Y8;
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm = function(_v0) {
        var model = _v0;
        var encodedAdjustments = A2($elm$json$Json$Encode$list, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$encodedForm, A2($elm$core$List$map, $elm$core$Tuple$second, model.W));
        return _List_fromArray([
            _Utils_Tuple2('charge_adjustments', encodedAdjustments),
            _Utils_Tuple2('reason', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, model.ae0)),
            _Utils_Tuple2('revision_number', $elm$json$Json$Encode$int($author$project$Api$Provider$CustomerInvoice$One$revisionNumber(model.RA)))
        ]);
    };
    var $author$project$Api$Provider$CustomerInvoice$void = F4(function(apiClient, id, _v0, toMsg) {
        var voidReason = _v0.aif;
        var refundPayments = _v0.agC;
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('refund_payments', $elm$json$Json$Encode$bool(refundPayments)),
            _Utils_Tuple2('void_reason', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, voidReason))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'void'
        ]), $author$project$Api$Provider$CustomerInvoice$customerInvoicePath(id)))));
    });
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$voidParams = function(_v0) {
        var model = _v0;
        return {
            agC: false,
            aif: model.ae0
        };
    };
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$submitCmd = F2(function(model, apiClient) {
        return $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model.bn) ? A4($author$project$Api$Provider$CustomerInvoice$void, apiClient, $author$project$Api$Provider$CustomerInvoice$One$id(model.RA), $author$project$Components$CustomerInvoice$AdjustmentsForm$voidParams(model.bn), $author$project$Components$CustomerInvoice$AdjustVoidModal$Voided) : A4($author$project$Api$Provider$InvoiceAdjustment$create, apiClient, $author$project$Api$Provider$CustomerInvoice$One$id(model.RA), $elm$json$Json$Encode$object($author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model.bn)), $author$project$Components$CustomerInvoice$AdjustVoidModal$Created);
    });
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentCreated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$None = {
        $: 0
    };
    var $author$project$Api$Provider$ChargeAdjustment$Preview$endDate = function(_v0) {
        var record = _v0.b;
        return record.qv;
    };
    var $author$project$Api$Provider$ChargeAdjustment$Shared$quantityAdjustment = function(_v0) {
        var record = _v0;
        return record.XS;
    };
    var $author$project$Api$Provider$ChargeAdjustment$Preview$quantityAdjustment = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeAdjustment$Shared$quantityAdjustment(shared);
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$adjustmentPreviewed = F2(function(preview, _v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        var quantity = A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Api$Provider$Charge$One$quantity(fields.ach) + $author$project$Api$Provider$ChargeAdjustment$Preview$quantityAdjustment(preview)), fields.Bu);
        var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
            qv: $author$project$Api$Provider$ChargeAdjustment$Preview$endDate(preview),
            Bu: quantity
        }), model.PU);
        return _Utils_update(model, {
            tS: $elm$core$Maybe$Just(preview),
            PU: newForm
        });
    });
    var $author$project$Api$Provider$ChargeAdjustment$Shared$charge = function(_v0) {
        var record = _v0;
        return record.ach;
    };
    var $author$project$Api$Provider$ChargeAdjustment$Preview$charge = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeAdjustment$Shared$charge(shared);
    };
    var $author$project$Api$Provider$InvoiceAdjustment$Preview$chargeAdjustments = function(_v0) {
        var record = _v0.b;
        return record.K4;
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$chargeForm = F2(function(chargeId, adjustmentsForms) {
        return A2($elm$core$Maybe$map, $elm$core$Tuple$second, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$eq(chargeId)), adjustmentsForms)));
    });
    var $author$project$Utils$Tuple3$first = function(_v0) {
        var first_ = _v0.a;
        return first_;
    };
    var $author$project$Api$Provider$Charge$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$paidInCents = function(_v0) {
        var record = _v0;
        return record.VR;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$paidInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$paidInCents(shared);
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$GotPreview = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError = function(_v0) {
        var errors = _v0.fK;
        return !$elm$core$List$isEmpty(errors);
    };
    var $author$project$Api$Provider$InvoiceAdjustment$Preview$InvoiceAdjustment = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$InvoiceAdjustment$Preview$Record = function(chargeAdjustments) {
        return {
            K4: chargeAdjustments
        };
    };
    var $author$project$Api$Provider$ChargeAdjustment$Preview$ChargeAdjustment = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ChargeAdjustment$Shared$ChargeAdjustment = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ChargeAdjustment$Shared$Record = F6(function(priceAdjustmentInCents, quantityAdjustment, subtotalAdjustmentInCents, taxAdjustmentInCents, totalAdjustmentInCents, charge) {
        return {
            ach: charge,
            agl: priceAdjustmentInCents,
            XS: quantityAdjustment,
            $u: subtotalAdjustmentInCents,
            ahK: taxAdjustmentInCents,
            ah$: totalAdjustmentInCents
        };
    });
    var $author$project$Api$Provider$Charge$Min$Charge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Charge$Min$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$Charge$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$Min$Record));
    var $author$project$Api$Provider$Charge$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ChargeAdjustment$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge', $author$project$Api$Provider$Charge$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_adjustment_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tax_adjustment_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'subtotal_adjustment_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity_adjustment', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_adjustment_in_cents', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Shared$Record)))))));
    var $author$project$Api$Provider$ChargeAdjustment$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeAdjustment$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ChargeAdjustment$Preview$Record = F2(function(date, endDate) {
        return {
            M4: date,
            qv: endDate
        };
    });
    var $author$project$Api$Provider$ChargeAdjustment$Preview$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Preview$Record)));
    var $author$project$Api$Provider$ChargeAdjustment$Preview$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeAdjustment$Preview$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ChargeAdjustment$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ChargeAdjustment$Preview$ChargeAdjustment)));
    var $author$project$Api$Provider$InvoiceAdjustment$Preview$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_adjustments', $elm$json$Json$Decode$list($author$project$Api$Provider$ChargeAdjustment$Preview$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Preview$Record));
    var $author$project$Api$Provider$InvoiceAdjustment$Preview$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceAdjustment$Preview$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$InvoiceAdjustment$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$InvoiceAdjustment$Preview$InvoiceAdjustment)));
    var $author$project$Api$Provider$InvoiceAdjustment$previewPath = function(customerInvoiceId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'preview'
        ]), $author$project$Api$Provider$InvoiceAdjustment$invoiceAdjustmentsPath(customerInvoiceId));
    };
    var $author$project$Api$Provider$InvoiceAdjustment$preview = F4(function(apiClient, customerInvoiceId, body, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$InvoiceAdjustment$Preview$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$InvoiceAdjustment$previewPath(customerInvoiceId))));
    });
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd = F2(function(apiClient, model) {
        var modelRecord = model;
        return $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError(model) ? $elm$core$Platform$Cmd$none : A4($author$project$Api$Provider$InvoiceAdjustment$preview, apiClient, $author$project$Api$Provider$CustomerInvoice$One$id(modelRecord.RA), $elm$json$Json$Encode$object($author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model)), $author$project$Components$CustomerInvoice$AdjustmentsForm$GotPreview);
    });
    var $author$project$Utils$Tuple3$second = function(_v0) {
        var second_ = _v0.b;
        return second_;
    };
    var $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents = function(_v0) {
        var record = _v0;
        return record.ah$;
    };
    var $author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents(shared);
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount = function(dataPreview) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents, $author$project$Api$Data$toMaybe(dataPreview)));
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$FieldUpdated = $elm$core$Basics$identity;
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$InputChanged = 1;
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$None = 0;
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateField = F2(function(field, formFields) {
        switch(field.$){
            case 0:
                var dateInputMsg = field.a;
                var _v1 = formFields.qx;
                if (!_v1.$) {
                    var endDateInput = _v1.a;
                    var _v2 = A2($author$project$Components$DateInput$update, dateInputMsg, endDateInput);
                    var dateInput = _v2.a;
                    var dateInputCmd = _v2.b;
                    var inputEvent = _v2.c;
                    var _v3 = function() {
                        if (inputEvent.$ === 1) {
                            var date = inputEvent.a;
                            return _Utils_Tuple2(date, 1);
                        } else return _Utils_Tuple2(formFields.qv, 0);
                    }();
                    var newValue = _v3.a;
                    var event = _v3.b;
                    var quantityUom = A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Uom$Shared$day, A2($elm$core$Maybe$map, $author$project$Utils$Uom$matchRange(formFields.M4), newValue));
                    var quantity = $elm$core$Maybe$Just(A3($author$project$Utils$Uom$quantityBetween, quantityUom, formFields.M4, newValue));
                    return _Utils_Tuple3(_Utils_update(formFields, {
                        qv: newValue,
                        qx: $elm$core$Maybe$Just(dateInput),
                        Bu: quantity,
                        Bv: quantityUom
                    }), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate), dateInputCmd), event);
                } else return _Utils_Tuple3(formFields, $elm$core$Platform$Cmd$none, 0);
            case 1:
                var bool = field.a;
                return _Utils_Tuple3(_Utils_update(formFields, {
                    Bu: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$quantity(formFields.ach)),
                    eB: bool,
                    M: bool
                }), $elm$core$Platform$Cmd$none, 1);
            case 2:
                var bool = field.a;
                var returnToInventory = bool ? false : formFields.eB;
                return _Utils_Tuple3(_Utils_update(formFields, {
                    Bu: $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$quantity(formFields.ach)),
                    eB: returnToInventory,
                    M: bool,
                    H3: bool
                }), $elm$core$Platform$Cmd$none, 1);
            case 3:
                var str = field.a;
                var quantity = $elm$core$String$toInt(str);
                var returnToInventory = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(quantity_) {
                    return _Utils_cmp($author$project$Api$Provider$Charge$One$quantity(formFields.ach), quantity_) > 0;
                }, quantity));
                var endDate = A3($author$project$Utils$Uom$addTo, $elm$core$Maybe$Just(formFields.M4), formFields.Bv, A2($elm$core$Maybe$withDefault, 0, quantity));
                return _Utils_Tuple3(_Utils_update(formFields, {
                    qv: endDate,
                    Bu: quantity,
                    eB: returnToInventory
                }), $elm$core$Platform$Cmd$none, 1);
            case 4:
                var str = field.a;
                return _Utils_Tuple3(_Utils_update(formFields, {
                    Bv: A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Uom$Shared$day, $author$project$Utils$Uom$fromCode(str))
                }), $elm$core$Platform$Cmd$none, 1);
            case 5:
                var currency = field.a;
                return _Utils_Tuple3(_Utils_update(formFields, {
                    Br: currency
                }), $elm$core$Platform$Cmd$none, 1);
            case 6:
                var bool = field.a;
                return _Utils_Tuple3(_Utils_update(formFields, {
                    eB: bool
                }), $elm$core$Platform$Cmd$none, 1);
            default:
                var itemPriceInCents = A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$ChargeItem$ForCharge$priceInCents, $author$project$Currency$fromFloat), formFields.lv);
                return _Utils_Tuple3(_Utils_update(formFields, {
                    xl: true,
                    Br: itemPriceInCents
                }), $elm$core$Platform$Cmd$none, 1);
        }
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update = F2(function(msg, _v0) {
        var model = _v0;
        var form = model.PU;
        var field = msg;
        var _v2 = A3($author$project$Utils$Form$updateWithCmdAndEvent, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateField, field, form);
        var newForm = _v2.a;
        var newFormCmd = _v2.b;
        var event = _v2.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: newForm
        }), newFormCmd, event);
    });
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$updateChargeForm = F3(function(chargeId, newForm, adjustmentsForms) {
        return A2($elm$core$List$map, function(_v0) {
            var id = _v0.a;
            var form = _v0.b;
            return _Utils_eq(id, chargeId) ? _Utils_Tuple2(id, newForm) : _Utils_Tuple2(id, form);
        }, adjustmentsForms);
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$formFromResult = function(result) {
        if (!result.$) {
            var _v1 = result.a;
            var form = _v1.a;
            return form;
        } else {
            var form = result.a;
            return form;
        }
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm = F2(function(model, form) {
        return _Utils_update(model, {
            PU: form
        });
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCentsValidation = 0;
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityValidation = 1;
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validator = function() {
        var negativeQuantity = function(fields) {
            return !fields.M && A2($elm$core$Maybe$withDefault, 0, fields.Bu) < 0;
        };
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.Br;
            }, _Utils_Tuple2(0, 'Please enter a price.')),
            A2($rtfeldman$elm_validate$Validate$ifTrue, negativeQuantity, _Utils_Tuple2(1, 'Please enter a valid quantity.'))
        ]));
    }();
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validate = function(_v0) {
        var model = _v0;
        return A2($elm$core$Result$mapError, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm(model), A2($elm$core$Result$map, $elm$core$Tuple$mapFirst($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$updateForm(model)), A2($author$project$Utils$Form$validate, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validator, model.PU)));
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentsValidation = 0;
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyValidationError = function(_v0) {
        var model = _v0;
        return $author$project$Utils$Form$hasAnyValidationError(model.PU);
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$validateAdjustments = function(model) {
        var anyAdjustmentError = A2($elm$core$List$any, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyValidationError), model.W);
        return anyAdjustmentError ? _List_fromArray([
            0
        ]) : _List_Nil;
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$NewDueValidation = 1;
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount = F3(function(totalInCents, totalPayments, totalAdjustment) {
        return totalInCents + totalAdjustment - totalPayments;
    });
    var $author$project$Api$Provider$CustomerInvoice$Shared$totalInCents = function(_v0) {
        var record = _v0;
        return record.aam;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$totalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$totalInCents(shared);
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount = function(invoice) {
        return $elm$core$List$sum(A2($elm$core$List$map, $author$project$Api$Provider$Payment$One$amountInCents, A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$CustomerInvoice$One$payments(invoice))));
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$validateNewDue = function(model) {
        var _v0 = model.agk;
        if (_v0.$ === 3) {
            var preview = _v0.a;
            var totalPayments = $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount(model.RA);
            var totalInCents = $author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.RA);
            var totalAdjustment = $author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents(preview);
            var newDue = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount, totalInCents, totalPayments, totalAdjustment);
            return newDue < 0 ? _List_fromArray([
                1
            ]) : _List_Nil;
        } else return _List_Nil;
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$validator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$AdjustmentsForm$validateAdjustments),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$AdjustmentsForm$validateNewDue)
    ]));
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$validate = function(_v0) {
        var model = _v0;
        var newForms = A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$mapSecond($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$validate), $elm$core$Tuple$mapSecond($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$formFromResult)), model.W);
        var newModel = _Utils_update(model, {
            W: newForms,
            fK: _List_Nil
        });
        return $author$project$Utils$Result$merge(A2($elm$core$Result$mapError, function(errors) {
            return _Utils_update(newModel, {
                fK: errors
            });
        }, A2($elm$core$Result$map, $rtfeldman$elm_validate$Validate$fromValid, A2($rtfeldman$elm_validate$Validate$validate, $author$project$Components$CustomerInvoice$AdjustmentsForm$validator, newModel))));
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$VoidAll = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voidAll = F2(function(bool, model) {
        return A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$VoidAll(bool), model);
    });
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var chargeId = msg.a;
                var subMsg = msg.b;
                var _v2 = A2($author$project$Components$CustomerInvoice$AdjustmentsForm$chargeForm, chargeId, model.W);
                if (!_v2.$) {
                    var form = _v2.a;
                    var _v3 = A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$update, subMsg, form);
                    var newForm = _v3.a;
                    var newFormCmd = _v3.b;
                    var event = _v3.c;
                    var newPreview = function() {
                        if (event === 1) return $author$project$Api$Data$NotAsked;
                        else return model.agk;
                    }();
                    var newModel = $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(_Utils_update(model, {
                        W: A3($author$project$Components$CustomerInvoice$AdjustmentsForm$updateChargeForm, chargeId, newForm, model.W),
                        agk: newPreview
                    }));
                    var previewCmd = function() {
                        if (event === 1) return A2($author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd, apiClient, newModel);
                        else return $elm$core$Platform$Cmd$none;
                    }();
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId), newFormCmd),
                            previewCmd
                        ])),
                        adu: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
                        zi: newModel,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var bool = msg.a;
                var voidedForms = A2($elm$core$List$map, $elm$core$Tuple$mapSecond($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$voidAll(bool)), model.W);
                var newForms = A2($elm$core$List$map, $elm$core$Tuple$mapSecond($author$project$Utils$Tuple3$first), voidedForms);
                var newModel = $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(_Utils_update(model, {
                    W: newForms,
                    agk: $author$project$Api$Data$NotAsked
                }));
                var cmds = A2($elm$core$List$map, function(_v6) {
                    var chargeId = _v6.a;
                    var cmd = _v6.b;
                    return A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId), cmd);
                }, A2($elm$core$List$map, $elm$core$Tuple$mapSecond($author$project$Utils$Tuple3$second), voidedForms));
                return {
                    EQ: $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($author$project$Components$CustomerInvoice$AdjustmentsForm$previewAdjustmentCmd, apiClient, newModel), cmds)),
                    adu: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
                    zi: newModel,
                    at: _List_Nil
                };
            case 2:
                var dataPreview = msg.a;
                if (dataPreview.$ === 3) {
                    var preview = dataPreview.a;
                    var totalRefundedAmount = model.agD ? A2($elm$core$Basics$min, $author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.RA), A2($elm$core$Basics$max, -$author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount(dataPreview), 0)) : 0;
                    var adjustmentPreview = function(chargeId) {
                        return $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, $author$project$Api$Provider$ChargeAdjustment$Preview$charge, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Charge$Min$id, $elm$core$Basics$eq(chargeId))), $author$project$Api$Provider$InvoiceAdjustment$Preview$chargeAdjustments(preview)));
                    };
                    var newForms = A2($elm$core$List$map, function(_v8) {
                        var chargeId = _v8.a;
                        var form = _v8.b;
                        return _Utils_Tuple2(chargeId, function() {
                            var _v9 = adjustmentPreview(chargeId);
                            if (!_v9.$) {
                                var adjustmentPreview_ = _v9.a;
                                return A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$adjustmentPreviewed, adjustmentPreview_, form);
                            } else return form;
                        }());
                    }, model.W);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$CustomerInvoice$AdjustmentsForm$AdjustmentCreated(A2($elm$core$Basics$max, -$author$project$Components$CustomerInvoice$AdjustmentsForm$totalAdjustmentAmount(dataPreview), 0)),
                        zi: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(_Utils_update(model, {
                            W: newForms,
                            agk: dataPreview,
                            oS: totalRefundedAmount
                        })),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
                    zi: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(_Utils_update(model, {
                        agk: dataPreview
                    })),
                    at: _List_Nil
                };
            default:
                var string = msg.a;
                var memo = $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CustomerInvoice$AdjustmentsForm$None,
                    zi: _Utils_update(model, {
                        ae0: memo
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var newModel = _Utils_update(model, {
                    bn: $author$project$Components$CustomerInvoice$AdjustmentsForm$validate(model.bn),
                    km: true
                });
                return {
                    EQ: A2($author$project$Components$CustomerInvoice$AdjustVoidModal$submitCmd, newModel, apiClient),
                    adu: 0,
                    zi: newModel,
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var subMsg = msg.a;
                var adjustmentsFormResult = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$update, apiClient, subMsg, model.bn);
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg, adjustmentsFormResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        bn: adjustmentsFormResult.zi
                    }),
                    at: adjustmentsFormResult.at
                };
            case 3:
                var dataAdjustments = msg.a;
                return A3($author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse, model, dataAdjustments, 'Revision created!');
            default:
                var dataVoid = msg.a;
                return A3($author$project$Components$CustomerInvoice$AdjustVoidModal$handleResponse, model, dataVoid, 'Invoice voided!');
        }
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReader = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderSelectMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Closed = 0;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$None = 1;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAt = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaymentCreated = 2;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaymentSourceSelectMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Source = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardCreated = F2(function(a, b) {
        return {
            $: 15,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createCard = F5(function(basePath, apiClient, session, formFields, readCard) {
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(basePath_) {
            return A5($author$project$Api$Card$create, basePath_, apiClient, session, {
                KZ: $elm$core$Maybe$Nothing,
                MA: $elm$core$Maybe$Just(readCard.MA),
                ST: $elm$core$Maybe$Nothing,
                Vu: $elm$core$Maybe$Just(readCard.Vu),
                Wp: readCard.Wp
            }, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardCreated(formFields));
        }, basePath));
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Created = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$payableIdAndKey = function(payable) {
        return _Utils_Tuple2('customer_invoice_id', $author$project$Api$Provider$CustomerInvoice$One$id(payable));
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createPayment = F7(function(basePath, apiClient, session, payable, formFields, cardReaderCard, cardReader) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var selectedSource = function() {
            var _v3 = _Utils_Tuple2(cardReaderCard, cardReader);
            if (_v3.a.$ === 1) {
                if (_v3.b.$ === 1) {
                    var _v4 = _v3.a;
                    var _v5 = _v3.b;
                    return A2($elm$core$Maybe$map, function(source) {
                        return {
                            aef: $elm$core$Maybe$Just($author$project$Api$Source$id(source)),
                            ah5: $author$project$Api$Source$type_(source)
                        };
                    }, fields.Hw);
                } else return $elm$core$Maybe$Nothing;
            } else {
                var cardReaderCard_ = _v3.a.a;
                return $elm$core$Maybe$Just({
                    aef: $elm$core$Maybe$Just($author$project$Api$Card$id(cardReaderCard_)),
                    ah5: $author$project$Api$Card$type_(cardReaderCard_)
                });
            }
        }();
        var _v0 = function() {
            var _v1 = fields.KZ;
            _v1$3: while(true){
                if (!_v1.$) switch(_v1.a){
                    case 'credit':
                        return _Utils_Tuple2($elm$core$Maybe$Just('card'), $elm$core$Maybe$Just('credit'));
                    case 'amex':
                        return _Utils_Tuple2($elm$core$Maybe$Just('amex'), $elm$core$Maybe$Just('credit'));
                    case 'debit':
                        return _Utils_Tuple2($elm$core$Maybe$Just('card'), $elm$core$Maybe$Just('debit'));
                    default:
                        break _v1$3;
                }
                else break _v1$3;
            }
            return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
        }();
        var selectedCardType = _v0.a;
        var selectedCardFunding = _v0.b;
        var _v2 = $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$payableIdAndKey(payable);
        var payableKey = _v2.a;
        var payableId = _v2.b;
        return A7($author$project$Api$Payment$create, basePath, apiClient, session, payableKey, payableId, {
            Jh: A2($elm$core$Maybe$withDefault, $author$project$Currency$fromInt(fields.mF), fields.Jh),
            ace: A2($elm$core$Maybe$map, $author$project$Api$Provider$CardReader$All$id, cardReader),
            Po: false,
            ae0: fields.ae0,
            VQ: fields.VQ,
            ahd: selectedCardFunding,
            ahe: selectedCardType,
            Hw: selectedSource,
            aht: $elm$core$Maybe$Just(!fields.CK)
        }, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Created(formFields));
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotCardReaders = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchCardReaders = function(apiClient) {
        return A3($author$project$Api$Provider$CardReader$list, apiClient, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$GotCardReaders);
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var _int = field.a;
                return _Utils_update(fields, {
                    Jh: _int
                });
            case 1:
                var dateInput = field.a;
                var date = field.b;
                return _Utils_update(fields, {
                    VQ: date,
                    GN: dateInput
                });
            case 3:
                var source = field.a;
                return _Utils_update(fields, {
                    Hw: source
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    ae0: $author$project$Utils$String$toMaybe(string)
                });
            case 4:
                var cardReader = field.a;
                return _Utils_update(fields, {
                    ace: cardReader
                });
            case 5:
                var bool = field.a;
                return _Utils_update(fields, {
                    CK: bool
                });
            default:
                var cardType = field.a;
                return _Utils_update(fields, {
                    KZ: $elm$core$Maybe$Just(cardType)
                });
        }
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderValidation = 1;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardTypeValidation = 3;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$SourceValidation = 2;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCentsValidation = 0;
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$validateAmountInCents = function(fields) {
        var min = 50;
        var max = fields.mF;
        return A2($author$project$Utils$Validate$isInvalidCurrency, {
            abI: false,
            y_: $elm$core$Maybe$Just(max),
            Uj: $elm$core$Maybe$Just(min)
        }, fields.Jh) ? _List_fromArray([
            _Utils_Tuple2(0, 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + ($author$project$Utils$Currency$fromInt(max) + '.'))))
        ]) : _List_Nil;
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsValidator = function(useExistingSources) {
        return $rtfeldman$elm_validate$Validate$all($elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$validateAmountInCents)
            ]),
            useExistingSources ? _List_fromArray([
                A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                    return $.Hw;
                }, _Utils_Tuple2(2, 'Please pick a source.'))
            ]) : _List_fromArray([
                A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                    return $.ace;
                }, _Utils_Tuple2(1, 'Please pick a card reader.')),
                A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                    return $.KZ;
                }, _Utils_Tuple2(3, 'Please pick a card type.'))
            ])
        ])));
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$shouldDefaultCardReaderSwitch = F3(function(apiClient, response, model) {
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(model.pQ, model.pF);
            if (_v1.a.$ === 3 && _v1.b.$ === 3) {
                var _v2 = _v1.a;
                var cards = _v2.a;
                var _v3 = _v1.b;
                var bankAccounts = _v3.a;
                var useCardReader = $elm$core$List$isEmpty(cards) && $elm$core$List$isEmpty(bankAccounts) && $author$project$Api$Practice$usesCardReaders(model.W1) && !$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$);
                return _Utils_Tuple3(!useCardReader, useCardReader ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked, useCardReader ? $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchCardReaders(apiClient) : $elm$core$Platform$Cmd$none);
            } else return _Utils_Tuple3(model.V, model.hJ, $elm$core$Platform$Cmd$none);
        }();
        var useExistingSources = _v0.a;
        var cardReaders = _v0.b;
        var cmd = _v0.c;
        return {
            EQ: cmd,
            adu: 1,
            zi: _Utils_update(model, {
                hJ: cardReaders,
                V: useExistingSources
            }),
            at: $author$project$OutMsg$handleErrorResponse(response)
        };
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate, A2(field, newDateInput, date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), model.PU);
            }
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd),
            adu: 1,
            zi: _Utils_update(model, {
                PU: newForm
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 8:
                var response = msg.a;
                return A3($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$shouldDefaultCardReaderSwitch, apiClient, response, _Utils_update(model, {
                    pQ: response
                }));
            case 9:
                var response = msg.a;
                return A3($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$shouldDefaultCardReaderSwitch, apiClient, response, _Utils_update(model, {
                    pF: response
                }));
            case 10:
                var response = msg.a;
                return {
                    EQ: $author$project$Ports$LocalStorage$getItem('last-used-card-reader'),
                    adu: 1,
                    zi: _Utils_update(model, {
                        hJ: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 11:
                var _v2 = msg.a;
                var key = _v2.a;
                var value = _v2.b;
                var _v3 = _Utils_Tuple2(key, value);
                if (_v3.a === 'last-used-card-reader' && !_v3.b.$) {
                    var lastUsedCardReaderId = _v3.b.a;
                    var cardReader = A2($elm_community$list_extra$List$Extra$find, function(cardReader_) {
                        return _Utils_eq($author$project$Api$Provider$CardReader$All$id(cardReader_), lastUsedCardReaderId);
                    }, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.hJ)));
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReader(cardReader), model.PU);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 12:
                var useExistingSources = msg.a;
                var _v4 = !useExistingSources && _Utils_eq(model.hJ, $author$project$Api$Data$NotAsked) ? _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchCardReaders(apiClient)) : _Utils_Tuple2(model.hJ, $elm$core$Platform$Cmd$none);
                var cardReaders = _v4.a;
                var fetchCardReadersCmd = _v4.b;
                return {
                    EQ: fetchCardReadersCmd,
                    adu: 1,
                    zi: _Utils_update(model, {
                        hJ: cardReaders,
                        V: useExistingSources
                    }),
                    at: _List_Nil
                };
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate, field, model.PU);
                var passthroughFeesCmd = function() {
                    if (field.$ === 6) {
                        var amountInCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, $author$project$Utils$Form$fields(model.PU).Jh)));
                        return A5($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd, apiClient, model.V, amountInCents, $author$project$Utils$Form$fields(newForm), model.V8);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return {
                    EQ: passthroughFeesCmd,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 2:
                var amountInCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, $author$project$Utils$Form$fields(model.PU).Jh)));
                var passthroughFeesCmd = A5($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd, apiClient, model.V, amountInCents, $author$project$Utils$Form$fields(model.PU), model.V8);
                return {
                    EQ: passthroughFeesCmd,
                    adu: 1,
                    zi: _Utils_update(model, {
                        te: amountInCents
                    }),
                    at: _List_Nil
                };
            case 3:
                var paymentSourceSelectMsg = msg.a;
                var amountInCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, $author$project$Utils$Form$fields(model.PU).Jh)));
                var _v6 = A2($author$project$Ui$Form$SearchableSelect$update, paymentSourceSelectMsg, model.r1);
                var selectModel = _v6.a;
                var selectCmd = _v6.b;
                var event = _v6.c;
                var newForm = function() {
                    if (!event.$ && !event.a.$) {
                        var maybeSource = event.a.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Source(maybeSource), model.PU);
                    } else return model.PU;
                }();
                var passthroughFeesCmd = function() {
                    if (!event.$ && !event.a.$) return A5($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$fetchPassthroughFeesCmd, apiClient, model.V, amountInCents, $author$project$Utils$Form$fields(newForm), model.V8);
                    else return $elm$core$Platform$Cmd$none;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaymentSourceSelectMsg, selectCmd),
                        passthroughFeesCmd
                    ])),
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm,
                        r1: selectModel,
                        te: amountInCents
                    }),
                    at: _List_Nil
                };
            case 4:
                var cardReaderSelectMsg = msg.a;
                var _v9 = A2($author$project$Ui$Form$SearchableSelect$update, cardReaderSelectMsg, model.pO);
                var selectModel = _v9.a;
                var selectCmd = _v9.b;
                var event = _v9.c;
                var newForm = function() {
                    if (!event.$ && !event.a.$) {
                        var maybeCardReader = event.a.a;
                        return A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsUpdate, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReader(maybeCardReader), model.PU);
                    } else return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderSelectMsg, selectCmd),
                    adu: 1,
                    zi: _Utils_update(model, {
                        pO: selectModel,
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 5:
                var _v11 = A2($author$project$Utils$Form$validate, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$formFieldsValidator(model.V), model.PU);
                if (!_v11.$) {
                    var _v12 = _v11.a;
                    var newForm = _v12.a;
                    var validFormFields = _v12.b;
                    var _v13 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var cardReader = _v13.ace;
                    var storeCard = _v13.CK;
                    var _v14 = function() {
                        var _v15 = _Utils_Tuple3(model.V, cardReader, $author$project$Api$Practice$paymentProcessor(model.W1));
                        if (_v15.a) return _Utils_Tuple3($elm$core$Maybe$Nothing, A7($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createPayment, model.r_, apiClient, model.Z$, model.af5, validFormFields, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing), $author$project$Api$Data$Loading);
                        else if (!_v15.b.$) {
                            if (_v15.c === 'rainforest') {
                                var cardReader_ = _v15.b.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A7($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createPayment, model.r_, apiClient, model.Z$, model.af5, validFormFields, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(cardReader_)), $author$project$Api$Data$Loading);
                            } else {
                                var cardReader_ = _v15.b.a;
                                return A2($author$project$Utils$Tuple3$fromTuple2, model.ag, A3($elm$core$Tuple$mapBoth, function(m) {
                                    return $elm$core$Maybe$Just(_Utils_Tuple2(m, validFormFields));
                                }, $elm$core$Platform$Cmd$map($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg), A7($author$project$Components$CardReader$ConnectingModal$init, apiClient, model.Z$, model.F3, model.sp, cardReader_, $author$project$Components$CardReader$ConnectingModal$Patient(model.V8), storeCard)));
                            }
                        } else {
                            var _v16 = _v15.b;
                            return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, model.ag);
                        }
                    }();
                    var cardReaderConnectingModal = _v14.a;
                    var cmd = _v14.b;
                    var paymentCreatedSaveRequest = _v14.c;
                    return {
                        EQ: cmd,
                        adu: 1,
                        zi: _Utils_update(model, {
                            hI: cardReaderConnectingModal,
                            PU: newForm,
                            ag: paymentCreatedSaveRequest
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v11.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 6:
                var validFormFields = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var payment = response.a;
                    var _v18 = function() {
                        var _v19 = _Utils_Tuple2($author$project$Api$Payment$cardReader(payment), $author$project$Api$Payment$status(payment));
                        if (!_v19.a.$) {
                            var cardReader = _v19.a.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, $elm$core$Maybe$Nothing, A3($elm$core$Tuple$mapBoth, function(m) {
                                return $elm$core$Maybe$Just(_Utils_Tuple2(m, validFormFields));
                            }, $elm$core$Platform$Cmd$map($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg), A6($author$project$Components$CardReader$PaymentModal$init, apiClient, model.Z$, model.F3, model.sp, $author$project$Api$Provider$CardReader$Shared$id(cardReader), payment)));
                        } else if (_v19.b === 'failed') {
                            var _v20 = _v19.a;
                            return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(_Utils_Tuple2('Payment failed', 1)));
                        } else {
                            var _v21 = _v19.a;
                            return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just(_Utils_Tuple2('Payment processed successfully', 3)));
                        }
                    }();
                    var cardReaderPaymentModal = _v18.a;
                    var cardReaderPaymentModalCmd = _v18.b;
                    var message = _v18.c;
                    return {
                        EQ: cardReaderPaymentModalCmd,
                        adu: _Utils_eq(cardReaderPaymentModal, $elm$core$Maybe$Nothing) ? 2 : 1,
                        zi: _Utils_update(model, {
                            bU: cardReaderPaymentModal,
                            ag: $author$project$Api$Data$NotAsked
                        }),
                        at: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(_v22) {
                            var toastMessage_ = _v22.a;
                            var toastLevel_ = _v22.b;
                            return _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, toastLevel_, toastMessage_)
                            ]);
                        }, message))
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        ag: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 7:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$updateDateInputFormField, model, dateInput, subMsg, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAtDateInputMsg, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaidAt, function($) {
                    return $.VQ;
                });
            case 13:
                var subMsg = msg.a;
                var _v23 = model.hI;
                if (!_v23.$) {
                    var _v24 = _v23.a;
                    var cardReaderConnectingModal = _v24.a;
                    var validFormFields = _v24.b;
                    var cardReaderConnectingModalResult = A3($author$project$Components$CardReader$ConnectingModal$update, apiClient, subMsg, cardReaderConnectingModal);
                    var _v25 = function() {
                        var _v26 = cardReaderConnectingModalResult.adu;
                        switch(_v26.$){
                            case 1:
                                var card = _v26.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A5($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createCard, model.Hx, apiClient, model.Z$, validFormFields, card));
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.ag, $elm$core$Platform$Cmd$none);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Just(_Utils_Tuple2(cardReaderConnectingModalResult.zi, validFormFields)), model.ag, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var cardReaderConnectingModal_ = _v25.a;
                    var paymentCreatedSaveRequest = _v25.b;
                    var cmd = _v25.c;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg, cardReaderConnectingModalResult.EQ),
                            cmd
                        ])),
                        adu: 1,
                        zi: _Utils_update(model, {
                            hI: cardReaderConnectingModal_,
                            ag: paymentCreatedSaveRequest
                        }),
                        at: cardReaderConnectingModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 14:
                var subMsg = msg.a;
                var _v27 = model.bU;
                if (!_v27.$) {
                    var _v28 = _v27.a;
                    var cardReaderPaymentModal = _v28.a;
                    var validFormFields = _v28.b;
                    var cardReaderPaymentModalResult = A3($author$project$Components$CardReader$PaymentModal$update, apiClient, subMsg, cardReaderPaymentModal);
                    var _v29 = cardReaderPaymentModalResult.adu;
                    switch(_v29){
                        case 1:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 2,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Nothing,
                                    ag: $author$project$Api$Data$NotAsked
                                }),
                                at: _Utils_ap(cardReaderPaymentModalResult.at, _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, 'Payment processed successfully')
                                ]))
                            };
                        case 3:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 2,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Nothing,
                                    ag: $author$project$Api$Data$NotAsked
                                }),
                                at: cardReaderPaymentModalResult.at
                            };
                        case 2:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 2,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Nothing,
                                    ag: $author$project$Api$Data$NotAsked
                                }),
                                at: _Utils_ap(cardReaderPaymentModalResult.at, _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, 'Payment failed')
                                ]))
                            };
                        case 0:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 1,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Nothing,
                                    ag: $author$project$Api$Data$NotAsked
                                }),
                                at: cardReaderPaymentModalResult.at
                            };
                        default:
                            return {
                                EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, cardReaderPaymentModalResult.EQ),
                                adu: 1,
                                zi: _Utils_update(model, {
                                    bU: $elm$core$Maybe$Just(_Utils_Tuple2(cardReaderPaymentModalResult.zi, validFormFields))
                                }),
                                at: cardReaderPaymentModalResult.at
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 15:
                var validFormFields = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var card = response.a;
                    return {
                        EQ: A7($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$createPayment, model.r_, apiClient, model.Z$, model.af5, validFormFields, $elm$core$Maybe$Just(card), $elm$core$Maybe$Nothing),
                        adu: 1,
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        ag: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var fees = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        V4: fees
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$Closed = 1;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$None = 0;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForPartialRefund = 3;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForPaymentOrVoid = 4;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$ReloadInvoiceForRefund = 2;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$FullRefundCreated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund = function(refundType) {
        _v0$2: while(true){
            if (!refundType.$) switch(refundType.a){
                case 1:
                    var _v1 = refundType.a;
                    return true;
                case 2:
                    var _v2 = refundType.a;
                    return true;
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return false;
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund = F6(function(apiClient, model, fields, payment, amountInCents, toMsg) {
        if ($author$project$Api$Payment$amountInCents(payment) > 0) {
            var paymentPath = A2($author$project$Api$Payment$paymentPath, model.vK, $author$project$Api$Payment$id(payment));
            return A4($author$project$Api$Provider$Refund$create, paymentPath, apiClient, {
                Jh: amountInCents,
                Po: $author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund(model.gB) || !$author$project$Api$Payment$isRefundableOnPaymentProcessor(payment),
                ae0: fields.ae0
            }, toMsg);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$createFullRefund = F3(function(model, apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A2($elm$core$List$map, function(payment) {
            return A6($author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund, apiClient, model, fields, payment, $author$project$Currency$fromInt($author$project$Api$Payment$amountInCents(payment)), $author$project$Components$CustomerInvoice$ProcessRefundModal$FullRefundCreated);
        }, model.Wt);
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceAdjustmentCreated = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$PartialRefundCreated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$encodedForm = F2(function(external, form) {
        var fields = $author$project$Utils$Form$fields(form);
        var encodedRefund = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string($author$project$Api$Payment$id(fields.Wk)))
        ]));
        var encodedExternal = $elm$json$Json$Encode$bool(external || !$author$project$Api$Payment$isRefundableOnPaymentProcessor(fields.Wk));
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('payment', encodedRefund),
            _Utils_Tuple2('amount_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Jh)),
            _Utils_Tuple2('external', encodedExternal)
        ]));
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$positiveAmountInCents = function(form) {
        var amountInCents = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, $author$project$Utils$Form$fields(form).Jh));
        return amountInCents > 0;
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$validRefundForms = function(forms) {
        return A2($elm$core$List$filter, $author$project$Components$CustomerInvoice$RefundsForm$positiveAmountInCents, A2($elm$core$List$map, $elm$core$Tuple$second, forms));
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$encodedForms = F2(function(_v0, external) {
        var model = _v0;
        var encodedRefunds = A2($elm$json$Json$Encode$list, $author$project$Components$CustomerInvoice$RefundsForm$encodedForm(external), $author$project$Components$CustomerInvoice$RefundsForm$validRefundForms(model.ap));
        return _List_fromArray([
            _Utils_Tuple2('refunds', encodedRefunds)
        ]);
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyChange = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        return !_Utils_eq(fields, A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$initFormFields, fields.ach, false));
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyChange = function(_v0) {
        var model = _v0;
        return A2($elm$core$List$any, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$hasAnyChange), model.W);
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError = function(_v0) {
        var errors = _v0.fK;
        return !$elm$core$List$isEmpty(errors);
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$paymentsRefundAmounts = function(_v0) {
        var model = _v0;
        return A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, A2($elm$core$Basics$composeR, $author$project$Utils$Form$fields, function(fields) {
            return _Utils_Tuple2(fields.Wk, fields.Jh);
        })), model.ap);
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$createPartialRefund = F2(function(apiClient, model) {
        if ($author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError(model.ew)) return $elm$core$Platform$Cmd$none;
        else {
            if ($author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyChange(model.bn)) {
                var encodedBody = $elm$json$Json$Encode$object(_Utils_ap($author$project$Components$CustomerInvoice$AdjustmentsForm$encodedForm(model.bn), A2($author$project$Components$CustomerInvoice$RefundsForm$encodedForms, model.ew, $author$project$Components$CustomerInvoice$ProcessRefundModal$isAnExternalRefund(model.gB))));
                return A4($author$project$Api$Provider$InvoiceAdjustment$create, apiClient, $author$project$Api$Provider$CustomerInvoice$One$id(model.RA), encodedBody, $author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceAdjustmentCreated);
            } else return $elm$core$Platform$Cmd$batch(A2($elm$core$List$map, function(_v0) {
                var payment = _v0.a;
                var amountInCents = _v0.b;
                if (!amountInCents.$) {
                    var amountInCents_ = amountInCents.a;
                    return A6($author$project$Components$CustomerInvoice$ProcessRefundModal$createRefund, apiClient, model, $author$project$Utils$Form$fields(model.PU), payment, amountInCents_, $author$project$Components$CustomerInvoice$ProcessRefundModal$PartialRefundCreated);
                } else return $elm$core$Platform$Cmd$none;
            }, $author$project$Components$CustomerInvoice$RefundsForm$paymentsRefundAmounts(model.ew)));
        }
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$formFieldsUpdate = F2(function(field, fields) {
        var string = field;
        return _Utils_update(fields, {
            ae0: $author$project$Utils$String$toMaybe(string)
        });
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$GotInvoice = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$invoiceExpands = _List_fromArray([
        0,
        1,
        2,
        3
    ]);
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$retrieveInvoice = F2(function(apiClient, invoiceId) {
        return A4($author$project$Api$Provider$CustomerInvoice$retrieve, apiClient, invoiceId, $author$project$Components$CustomerInvoice$ProcessRefundModal$invoiceExpands, $author$project$Components$CustomerInvoice$ProcessRefundModal$GotInvoice);
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$initCreatePaymentModal = F4(function(apiClient, model, external, invoice) {
        var patientPath = A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$patientPath, A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$id, $author$project$Api$Provider$CustomerInvoice$One$owner(model.RA)));
        var _v0 = $author$project$Components$Invoice$CreatePaymentModal$init(model.Cu.cP)(model.Cu.HO)($author$project$Api$Provider$CustomerInvoice$customerInvoicePath($author$project$Api$Provider$CustomerInvoice$One$id(invoice)))(patientPath)(apiClient)(model.Z$)($author$project$Api$Practice$Provider(model.W1))(model.F3)(model.sp)(function(d) {
            return _Utils_update(d, {
                Po: external,
                or: model.F3
            });
        })(A2($author$project$Components$Invoice$CreatePaymentModal$CustomerInvoice, $author$project$Api$Provider$Patient$One$id(model.V7), invoice));
        var createPaymentModal = _v0.a;
        var createPaymentModalCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            lH: $elm$core$Maybe$Just(createPaymentModal)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg, createPaymentModalCmd));
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$showPaymentModal = F3(function(apiClient, model, external) {
        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4($author$project$Components$CustomerInvoice$ProcessRefundModal$initCreatePaymentModal, apiClient, model, external, model.RA));
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$None = {
        $: 0
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$TotalRefundAmountChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$PartialRefundAmountInCents = $elm$core$Basics$identity;
    var $author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate = F2(function(field, fields) {
        var currency = field;
        return _Utils_update(fields, {
            Jh: currency
        });
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$assignMaxiumumRefund = F2(function(remainingAmount, _v0) {
        var paymentId = _v0.a;
        var form = _v0.b;
        var refundAmount = A2($elm$core$Basics$min, remainingAmount, $author$project$Api$Payment$amountInCents($author$project$Utils$Form$fields(form).Wk));
        var newRemainingAmount = remainingAmount - refundAmount;
        var newForm = $author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Components$CustomerInvoice$RefundsForm$refundValidator, A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate, $elm$core$Maybe$Just($author$project$Currency$fromInt(refundAmount)), form)));
        return _Utils_Tuple2(newRemainingAmount, _Utils_Tuple2(paymentId, newForm));
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$findRefundForm = F2(function(paymentId, forms) {
        return A2($elm$core$Maybe$map, $elm$core$Tuple$second, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$eq(paymentId)), forms)));
    });
    var $elm_community$list_extra$List$Extra$mapAccuml = F3(function(f, acc0, list) {
        var _v0 = A3($elm$core$List$foldl, F2(function(x, _v1) {
            var acc1 = _v1.a;
            var ys = _v1.b;
            var _v2 = A2(f, acc1, x);
            var acc2 = _v2.a;
            var y = _v2.b;
            return _Utils_Tuple2(acc2, A2($elm$core$List$cons, y, ys));
        }), _Utils_Tuple2(acc0, _List_Nil), list);
        var accFinal = _v0.a;
        var generatedList = _v0.b;
        return _Utils_Tuple2(accFinal, $elm$core$List$reverse(generatedList));
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$updateRefundForm = F3(function(paymentId, newForm, forms) {
        return A2($elm$core$List$map, function(_v0) {
            var id = _v0.a;
            var form = _v0.b;
            return _Utils_eq(id, paymentId) ? _Utils_Tuple2(id, newForm) : _Utils_Tuple2(id, form);
        }, forms);
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$update = F2(function(msg, _v0) {
        var model = _v0;
        if (!msg.$) {
            var adjustmentAmount = msg.a;
            var _v2 = A3($elm_community$list_extra$List$Extra$mapAccuml, $author$project$Components$CustomerInvoice$RefundsForm$assignMaxiumumRefund, adjustmentAmount, model.ap);
            var newForms = _v2.b;
            return _Utils_Tuple3(_Utils_update(model, {
                pp: adjustmentAmount,
                ap: newForms
            }), $elm$core$Platform$Cmd$none, $author$project$Components$CustomerInvoice$RefundsForm$None);
        } else {
            var paymentId = msg.a;
            var field = msg.b;
            var _v3 = A2($author$project$Components$CustomerInvoice$RefundsForm$findRefundForm, paymentId, model.ap);
            if (!_v3.$) {
                var form = _v3.a;
                var newForm = $author$project$Utils$Form$fromValidateResult(A2($author$project$Utils$Form$validate, $author$project$Components$CustomerInvoice$RefundsForm$refundValidator, A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$RefundsForm$formFieldsUpdate, field, form)));
                var newForms = A3($author$project$Components$CustomerInvoice$RefundsForm$updateRefundForm, paymentId, newForm, model.ap);
                return _Utils_Tuple3(_Utils_update(model, {
                    ap: newForms
                }), $elm$core$Platform$Cmd$none, $author$project$Components$CustomerInvoice$RefundsForm$TotalRefundAmountChanged($author$project$Components$CustomerInvoice$RefundsForm$totalRefundAmount(newForms)));
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Components$CustomerInvoice$RefundsForm$None);
        }
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$GotAdjustmentAmount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$RefundsForm$updateAdjustmentAmount = function(adjustmentAmount) {
        return A2($elm$core$Task$perform, $elm$core$Basics$identity, $elm$core$Task$succeed($author$project$Components$CustomerInvoice$RefundsForm$GotAdjustmentAmount(adjustmentAmount)));
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$updateRefundAmount = F2(function(amount, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            oS: amount
        });
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceVoided = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$voidInvoice = F2(function(model, apiClient) {
        return A4($author$project$Api$Provider$CustomerInvoice$void, apiClient, $author$project$Api$Provider$CustomerInvoice$One$id(model.RA), {
            agC: false,
            aif: $elm$core$Maybe$Just('')
        }, $author$project$Components$CustomerInvoice$ProcessRefundModal$InvoiceVoided);
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var _v1 = A2($author$project$Utils$Form$validate, $rtfeldman$elm_validate$Validate$all(_List_Nil), model.PU);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var newForm = _v2.a;
                    var validFormFields = _v2.b;
                    var cmd = model.fV ? $elm$core$Platform$Cmd$batch(A3($author$project$Components$CustomerInvoice$ProcessRefundModal$createFullRefund, model, apiClient, validFormFields)) : A2($author$project$Components$CustomerInvoice$ProcessRefundModal$createPartialRefund, apiClient, model);
                    return {
                        EQ: cmd,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            ev: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v1.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var toggle = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fV: toggle
                    }),
                    at: _List_Nil
                };
            case 14:
                var toggle = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        gB: $elm$core$Maybe$Just(toggle)
                    }),
                    at: _List_Nil
                };
            case 3:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$CustomerInvoice$ProcessRefundModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoiceId = $author$project$Api$Provider$CustomerInvoice$One$id(model.RA);
                    return {
                        EQ: A2($author$project$Components$CustomerInvoice$ProcessRefundModal$retrieveInvoice, apiClient, invoiceId),
                        adu: 2,
                        zi: _Utils_update(model, {
                            ev: response
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        ev: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 5:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 3,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 8:
                var _v4 = A3($author$project$Components$CustomerInvoice$ProcessRefundModal$showPaymentModal, apiClient, model, false);
                var newModel = _v4.a;
                var cmd = _v4.b;
                var outMsgs = _v4.c;
                return {
                    EQ: cmd,
                    adu: 0,
                    zi: _Utils_update(newModel, {
                        rL: true
                    }),
                    at: outMsgs
                };
            case 11:
                var subMsg = msg.a;
                var _v5 = model.lH;
                if (!_v5.$) {
                    var createPaymentModal = _v5.a;
                    var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, apiClient, subMsg, createPaymentModal);
                    var _v6 = function() {
                        var _v7 = createPaymentModalResult.adu;
                        switch(_v7){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createPaymentModalResult.zi), model.RA, 0);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, 4);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, 0);
                        }
                    }();
                    var createPaymentModal_ = _v6.a;
                    var invoice = _v6.b;
                    var event = _v6.c;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg, createPaymentModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            lH: createPaymentModal_,
                            RA: invoice,
                            rL: false
                        }),
                        at: createPaymentModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var subMsg = msg.a;
                var adjustmentsFormResult = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$update, apiClient, subMsg, model.bn);
                var _v8 = function() {
                    var _v9 = adjustmentsFormResult.adu;
                    if (!_v9.$) return _Utils_Tuple3(adjustmentsFormResult.zi, 0, $elm$core$Platform$Cmd$none);
                    else {
                        var adjustmentAmount = _v9.a;
                        var refundsFormCmd = A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg, $author$project$Components$CustomerInvoice$RefundsForm$updateAdjustmentAmount(adjustmentAmount));
                        return _Utils_Tuple3(adjustmentsFormResult.zi, 0, refundsFormCmd);
                    }
                }();
                var adjustmentsForm_ = _v8.a;
                var event = _v8.b;
                var cmd = _v8.c;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg, adjustmentsFormResult.EQ)
                    ])),
                    adu: event,
                    zi: _Utils_update(model, {
                        bn: adjustmentsForm_
                    }),
                    at: adjustmentsFormResult.at
                };
            case 12:
                var response = msg.a;
                var newModel = function() {
                    if (response.$ === 3) {
                        var invoice_ = response.a;
                        return _Utils_update(model, {
                            RA: invoice_
                        });
                    } else return model;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: newModel,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 9:
                return {
                    EQ: A2($author$project$Components$CustomerInvoice$ProcessRefundModal$voidInvoice, model, apiClient),
                    adu: 0,
                    zi: _Utils_update(model, {
                        tG: true
                    }),
                    at: _List_Nil
                };
            case 7:
                var subMsg = msg.a;
                var _v11 = A2($author$project$Utils$Tuple3$mapFirst, $author$project$Components$CustomerInvoice$RefundsForm$validate, A2($author$project$Components$CustomerInvoice$RefundsForm$update, subMsg, model.ew));
                var newRefundsFormModel = _v11.a;
                var newRefundsFormCmd = _v11.b;
                var refundEvent = _v11.c;
                var newAdjustmentForms = function() {
                    if (refundEvent.$ === 1) {
                        var amount = refundEvent.a;
                        return A2($author$project$Components$CustomerInvoice$AdjustmentsForm$updateRefundAmount, amount, model.bn);
                    } else return model.bn;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg, newRefundsFormCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        bn: newAdjustmentForms,
                        ew: newRefundsFormModel
                    }),
                    at: _List_Nil
                };
            case 10:
                var response = msg.a;
                var newModel = function() {
                    if (response.$ === 3) {
                        var invoice_ = response.a;
                        return _Utils_update(model, {
                            RA: invoice_
                        });
                    } else return model;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 4,
                    zi: _Utils_update(newModel, {
                        tG: false
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Invoice voided')
                    ])
                };
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 4,
                            zi: model,
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Invoice adjustment created')
                            ])
                        };
                    case 2:
                        var error = response.a;
                        var errorString = $author$project$Api$Data$errorToString(error);
                        var errorMessage = $elm$core$String$isEmpty(errorString) ? 'Unexpected error processing your invoice adjustment' : errorString;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 4,
                            zi: model,
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 1, errorMessage)
                            ])
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 4,
                            zi: model,
                            at: _List_Nil
                        };
                }
        }
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$Closed = 0;
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$None = 1;
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentCreated = 2;
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceFieldUpdated = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelectFieldUpdated = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelected = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents = F3(function(invoiceDueInCents, index, scheduledPayment) {
        return A2($author$project$Utils$Validate$isInvalidCurrency, {
            abI: false,
            y_: $elm$core$Maybe$Nothing,
            Uj: $elm$core$Maybe$Just(50)
        }, scheduledPayment.Jh) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(index), 'Must be more than $0.50')
        ]) : A2($author$project$Utils$Validate$isInvalidCurrency, {
            abI: false,
            y_: $elm$core$Maybe$Just(invoiceDueInCents),
            Uj: $elm$core$Maybe$Just(50)
        }, scheduledPayment.Jh) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(index), 'Invalid number.')
        ]) : _List_Nil;
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$amountInCentsFormValidation = F2(function(invoiceDueInCents, scheduledPayment) {
        return $rtfeldman$elm_validate$Validate$fromErrors(function(_v0) {
            return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents, invoiceDueInCents, scheduledPayment.yc, scheduledPayment);
        });
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledPaymentsCreated = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$ScheduledPayment$create = F4(function(apiClient, payableId, scheduledPaymentsList, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('scheduled_payments', A2($elm$json$Json$Encode$list, function(fieldMap) {
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMap.aef)),
                    _Utils_Tuple2('scheduled_on', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fieldMap.ag7)),
                    _Utils_Tuple2('payment_source_id', $elm$json$Json$Encode$string(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Source$id, fieldMap.Wr)))),
                    _Utils_Tuple2('amount_in_cents', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fieldMap.Jh)),
                    _Utils_Tuple2('memo', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fieldMap.ae0))
                ]));
            }, scheduledPaymentsList))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ScheduledPayment$Shared$decoder), toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$ScheduledPayment$schedulePaymentsPath(payableId))));
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields = function(formFields) {
        return A2($elm$core$List$filter, function(scheduledPaymentField) {
            return !scheduledPaymentField.Yz;
        }, formFields);
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$createScheduledPayment = F3(function(apiClient, customerInvoice, formFields) {
        var scheduledPaymentsList = A2($elm$core$List$map, function(scheduledPaymentField) {
            return {
                Jh: A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Just(0), A2($elm$core$Maybe$map, $author$project$Currency$toInt, scheduledPaymentField.Jh)),
                aef: scheduledPaymentField.aef,
                ae0: scheduledPaymentField.ae0,
                Wr: scheduledPaymentField.Wr,
                ag7: scheduledPaymentField.ag7
            };
        }, $author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(formFields));
        return A4($author$project$Api$Provider$ScheduledPayment$create, apiClient, $author$project$Api$Provider$CustomerInvoice$One$id(customerInvoice), scheduledPaymentsList, $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledPaymentsCreated);
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotPassthroughFees = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard = function(source) {
        return _Utils_eq(A2($elm$core$Maybe$andThen, $author$project$Api$Source$type_, source), $elm$core$Maybe$Just('Card'));
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd = F6(function(shouldChargeCreditCardFees, apiClient, amount, sourceChoice, patientId, index) {
        if (shouldChargeCreditCardFees && $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard(sourceChoice)) {
            var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Source$id, sourceChoice);
            if (!_v0.$) {
                var sourceId = _v0.a;
                return A6($author$project$Api$Provider$PassthroughFee$One$calculatePassthroughFees, apiClient, patientId, $elm$core$Maybe$Just(sourceId), $elm$core$Maybe$Nothing, amount, $author$project$Components$Invoice$CreateScheduledPaymentModal$GotPassthroughFees(index));
            } else return $elm$core$Platform$Cmd$none;
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$GotScheduledPayments = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments = F2(function(apiClient, customerInvoice) {
        return A3($author$project$Api$Provider$ScheduledPayment$list, apiClient, $author$project$Api$Provider$CustomerInvoice$One$id(customerInvoice), $author$project$Components$Invoice$CreateScheduledPaymentModal$GotScheduledPayments);
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 1:
                var index = field.a;
                var amountInCents = field.b;
                var updatedScheduledPayment = A3($elm_community$list_extra$List$Extra$updateAt, index, function(scheduledPaymentForm) {
                    return _Utils_update(scheduledPaymentForm, {
                        Jh: amountInCents,
                        fy: true
                    });
                }, fields.j);
                return _Utils_update(fields, {
                    j: updatedScheduledPayment
                });
            case 4:
                var index = field.a;
                var source = field.b;
                var updatedPassthroughFees = $author$project$Components$Invoice$CreateScheduledPaymentModal$sourceIsACreditCard(source) ? A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, function(scheduledPaymentForm) {
                    return scheduledPaymentForm.V5;
                }, A2($elm_community$list_extra$List$Extra$getAt, index, fields.j))) : $elm$core$Maybe$Nothing;
                var updatedScheduledPayment = A3($elm_community$list_extra$List$Extra$updateAt, index, function(scheduledPaymentForm) {
                    return _Utils_update(scheduledPaymentForm, {
                        V5: updatedPassthroughFees,
                        Wr: source
                    });
                }, fields.j);
                return _Utils_update(fields, {
                    j: updatedScheduledPayment
                });
            case 5:
                var index = field.a;
                var sourceSelect = field.b;
                var updatedScheduledPayment = A3($elm_community$list_extra$List$Extra$updateAt, index, function(scheduledPaymentForm) {
                    return _Utils_update(scheduledPaymentForm, {
                        fy: true,
                        r1: sourceSelect
                    });
                }, fields.j);
                return _Utils_update(fields, {
                    j: updatedScheduledPayment
                });
            case 3:
                var index = field.a;
                var memo = field.b;
                var updatedScheduledPayment = A3($elm_community$list_extra$List$Extra$updateAt, index, function(scheduledPaymentForm) {
                    return _Utils_update(scheduledPaymentForm, {
                        fy: true,
                        ae0: $elm$core$Maybe$Just(memo)
                    });
                }, fields.j);
                return _Utils_update(fields, {
                    j: updatedScheduledPayment
                });
            case 6:
                var index = field.a;
                var date = field.b;
                var updatedScheduledPayment = A3($elm_community$list_extra$List$Extra$updateAt, index, function(scheduledPaymentForm) {
                    return _Utils_update(scheduledPaymentForm, {
                        fy: true,
                        ag7: date
                    });
                }, fields.j);
                return _Utils_update(fields, {
                    j: updatedScheduledPayment
                });
            case 7:
                var index = field.a;
                var dateInput = field.b;
                var updatedScheduledPayment = A3($elm_community$list_extra$List$Extra$updateAt, index, function(scheduledPaymentForm) {
                    return _Utils_update(scheduledPaymentForm, {
                        n9: dateInput
                    });
                }, fields.j);
                return _Utils_update(fields, {
                    j: updatedScheduledPayment
                });
            case 2:
                var index = field.a;
                var updatedScheduledPayment = A3($elm_community$list_extra$List$Extra$updateAt, index, function(scheduledPaymentForm) {
                    return _Utils_update(scheduledPaymentForm, {
                        Yz: true
                    });
                }, fields.j);
                return _Utils_update(fields, {
                    j: updatedScheduledPayment
                });
            default:
                var updatedScheduledPaymentsList = field.a;
                return _Utils_update(fields, {
                    j: updatedScheduledPaymentsList
                });
        }
    });
    var $author$project$Api$Provider$ScheduledPayment$Shared$payment = function(_v0) {
        var record = _v0;
        return record.Wk;
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment = function(scheduledPayment) {
        return A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ScheduledPayment$Shared$payment, scheduledPayment.nf);
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled = function(scheduledPayment) {
        var _v0 = _Utils_Tuple2(scheduledPayment.nf, $author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment));
        if (!_v0.a.$ && !_v0.b.$) {
            var originalScheduledPayment = _v0.a.a;
            return $author$project$Api$Provider$ScheduledPayment$Shared$status(originalScheduledPayment) === 'processed';
        } else return _Utils_eq(scheduledPayment.aef, $elm$core$Maybe$Nothing) || scheduledPayment.fy ? false : scheduledPayment.ahy === 'processed';
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields = function(formFields) {
        return A2($elm$core$List$filter, function(scheduledPaymentField) {
            return !$author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPaymentField);
        }, $author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(formFields));
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$validatePaymentSource = F2(function(index, scheduledPayment) {
        return _Utils_eq(scheduledPayment.Wr, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(index), 'Please pick a source.')
        ]) : _List_Nil;
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOn = F3(function(index, today, scheduledPayment) {
        var _v0 = scheduledPayment.ag7;
        if (!_v0.$) {
            var scheduledOn = _v0.a;
            return A2($author$project$Utils$Date$isBeforeOrEqual, scheduledOn, today) ? _List_fromArray([
                _Utils_Tuple2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(index), 'Select a future date.')
            ]) : _List_Nil;
        } else return _List_fromArray([
            _Utils_Tuple2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(index), 'Select a future date.')
        ]);
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateForm = F3(function(invoiceDueInCents, today, formFields) {
        var scheduledPaymentsToValidate = $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields(formFields.j);
        var sourceValidations = A2($elm$core$List$concatMap, function(scheduledPayment) {
            return A2($author$project$Components$Invoice$CreateScheduledPaymentModal$validatePaymentSource, scheduledPayment.yc, scheduledPayment);
        }, scheduledPaymentsToValidate);
        var scheduleOnValidations = A2($elm$core$List$concatMap, function(scheduledPayment) {
            return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOn, scheduledPayment.yc, today, scheduledPayment);
        }, scheduledPaymentsToValidate);
        var amountInCentsValidations = A2($elm$core$List$concatMap, function(scheduledPayment) {
            return A3($author$project$Components$Invoice$CreateScheduledPaymentModal$validateAmountInCents, invoiceDueInCents, scheduledPayment.yc, scheduledPayment);
        }, scheduledPaymentsToValidate);
        return $elm$core$List$concat(_List_fromArray([
            amountInCentsValidations,
            sourceValidations,
            scheduleOnValidations
        ]));
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnPaymentSourceCombinationValidation = {
        $: 3
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors = function(fields) {
        var scheduledPaymentsToValidate = $author$project$Components$Invoice$CreateScheduledPaymentModal$activeScheduledPaymentFields(fields.j);
        var allPairs = A2($elm$core$List$map, function(scheduledPayment) {
            var _v0 = _Utils_Tuple2(scheduledPayment.Wr, scheduledPayment.ag7);
            if (_v0.a.$ === 1) {
                if (!_v0.b.$) {
                    var _v1 = _v0.a;
                    var scheduledOn = _v0.b.a;
                    return '-1|' + $justinmimbs$date$Date$toIsoString(scheduledOn);
                } else return '0|0';
            } else if (!_v0.b.$) {
                var paymentSource = _v0.a.a;
                var scheduledOn = _v0.b.a;
                return $author$project$Api$Source$id(paymentSource) + ('|' + $justinmimbs$date$Date$toIsoString(scheduledOn));
            } else {
                var paymentSource = _v0.a.a;
                return $author$project$Api$Source$id(paymentSource) + '|1';
            }
        }, scheduledPaymentsToValidate);
        var uniquePairs = $elm_community$list_extra$List$Extra$unique(allPairs);
        return !_Utils_eq(uniquePairs, allPairs);
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOnPaymentSourceCombined = function(fields) {
        return $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields) ? _List_fromArray([
            _Utils_Tuple2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnPaymentSourceCombinationValidation, 'The same source can not be used for more than single scheduled payment per day')
        ]) : _List_Nil;
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$formValidation = F2(function(invoiceDueInCents, today) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Invoice$CreateScheduledPaymentModal$validateForm, invoiceDueInCents, today)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Invoice$CreateScheduledPaymentModal$validateScheduledOnPaymentSourceCombined)
        ]));
    });
    var $author$project$Api$Provider$ScheduledPayment$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$calculateExistingSourceValue = F2(function(scheduledPaymentSource, sources) {
        if (!scheduledPaymentSource.$) {
            var source = scheduledPaymentSource.a;
            return A2($elm$core$List$any, function(s) {
                return _Utils_eq($author$project$Api$Source$id(s), $author$project$Api$Source$id(source));
            }, sources) ? !_Utils_eq($author$project$Api$Source$status(source), $elm$core$Maybe$Just('failed')) ? scheduledPaymentSource : $elm$core$Maybe$Nothing : $elm$core$Maybe$Nothing;
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$calculateScheduledPaymentSourceDefault = F2(function(model, scheduledPayments) {
        var defaultSource = A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$CustomerInvoice$One$source(model.lN));
        var _v0 = $elm$core$List$head($elm$core$List$reverse(scheduledPayments));
        if (!_v0.$) {
            var scheduledPaymentForm = _v0.a;
            var _v1 = A2($elm$core$Maybe$andThen, $author$project$Api$Source$status, scheduledPaymentForm.Wr);
            if (!_v1.$ && _v1.a === 'failed') return $elm$core$Maybe$Nothing;
            else {
                var _v2 = A2($elm$core$Maybe$andThen, $author$project$Api$Source$status, defaultSource);
                if (!_v2.$ && _v2.a === 'failed') return $elm$core$Maybe$Nothing;
                else return A2($elm$core$Maybe$withDefault, defaultSource, A2($elm$core$Maybe$map, $elm$core$Maybe$Just, scheduledPaymentForm.Wr));
            }
        } else return defaultSource;
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$deriveScheduledPaymentSource = function(scheduledPayment) {
        return A2($elm$core$Maybe$map, $author$project$Api$Source$Source, $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment));
    };
    var $author$project$Api$Provider$ScheduledPayment$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$ScheduledPayment$Shared$memo = function(_v0) {
        var record = _v0;
        return record.ae0;
    };
    var $author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents = function(_v0) {
        var record = _v0;
        return record.V5;
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources = function(model) {
        var _v0 = _Utils_Tuple2(model.pQ, model.pF);
        if (_v0.a.$ === 3 && _v0.b.$ === 3) {
            var _v1 = _v0.a;
            var cards = _v1.a;
            var _v2 = _v0.b;
            var bankAccounts = _v2.a;
            return $elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, $author$project$Api$Source$createdAt, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$time$Time$posixToMillis), $elm$core$Maybe$withDefault(0))), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Source$Card, cards), A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
        } else return _List_Nil;
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName = function(source_) {
        var _v0 = A2($elm$core$Maybe$andThen, $author$project$Utils$String$toMaybe, $author$project$Api$Source$name(source_));
        if (!_v0.$) {
            var label = _v0.a;
            return $elm$core$Maybe$Just(label);
        } else return $author$project$Api$Source$type_(source_);
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectLabel = function(source) {
        return A2($elm$core$String$join, ' ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $author$project$Formatters$String$titleize, $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName(source)),
            A2($elm$core$Maybe$map, function(lastFour) {
                return ' * ' + lastFour;
            }, $author$project$Api$Source$lastFour(source)),
            A2($elm$core$Maybe$map, function(funding) {
                return ' (' + (funding + ')');
            }, $author$project$Api$Source$funding(source))
        ])));
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectToValue = function(source) {
        return $elm$core$Maybe$Just($author$project$Api$Source$id(source));
    };
    var $author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn = function(_v0) {
        var record = _v0;
        return record.ag7;
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSourceSelect = function(source) {
        return _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectName(source);
                    if (!_v0.$) {
                        var name = _v0.a;
                        return A2($elm$html$Html$strong, _List_fromArray([
                            $elm$html$Html$Attributes$class('inline')
                        ]), _List_fromArray([
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Formatters$String$titleize(name))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v1 = $author$project$Api$Source$lastFour(source);
                    if (!_v1.$) {
                        var lastFour = _v1.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('*' + lastFour)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v2 = $author$project$Api$Source$funding(source);
                    if (!_v2.$) {
                        var funding = _v2.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('(' + (funding + ')'))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                $author$project$Utils$Html$noBreakSpace,
                A2($author$project$Ui$Badge$fromString, _List_Nil, A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Source$status(source))),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v3 = $author$project$Api$Source$label(source);
                    if (!_v3.$) {
                        var label = _v3.a;
                        return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$em, _List_fromArray([
                                $elm$html$Html$Attributes$class('text-muted')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true),
                                    $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(label)
                                ]))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]);
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList = F2(function(model, _v0) {
        var index = _v0.a;
        var scheduledPayment_ = _v0.b;
        var sourceSelect = $author$project$Ui$Form$SearchableSelect$init({
            aef: 'schpmt-source-select-' + $elm$core$String$fromInt(index),
            ahW: $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSourceSelect,
            ahZ: $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectLabel,
            g4: $author$project$Components$Invoice$CreateScheduledPaymentModal$paymentSourceSelectToValue
        });
        var amountInCents = function() {
            if (!scheduledPayment_.$) {
                var scheduledPayment = scheduledPayment_.a;
                return $author$project$Currency$fromMaybeInt($elm$core$Maybe$Just($author$project$Api$Provider$ScheduledPayment$Shared$amountInCents(scheduledPayment)));
            } else return $elm$core$Maybe$Nothing;
        }();
        var _v1 = $author$project$Components$DateInput$init;
        var dateInput = _v1.a;
        var dateInputCmd = _v1.b;
        var updatedScheduledPayment = function() {
            if (!scheduledPayment_.$) {
                var scheduledPayment = scheduledPayment_.a;
                var paymentSource = A2($author$project$Components$Invoice$CreateScheduledPaymentModal$calculateExistingSourceValue, $author$project$Components$Invoice$CreateScheduledPaymentModal$deriveScheduledPaymentSource(scheduledPayment), $author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources(model));
                return {
                    Jh: amountInCents,
                    fy: false,
                    aef: $elm$core$Maybe$Just($author$project$Api$Provider$ScheduledPayment$Shared$id(scheduledPayment)),
                    yc: index,
                    ae0: $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment),
                    nf: $elm$core$Maybe$Just(scheduledPayment),
                    V5: $author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents(scheduledPayment),
                    Wr: paymentSource,
                    r1: sourceSelect,
                    Yz: false,
                    ag7: $elm$core$Maybe$Just($author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)),
                    n9: dateInput,
                    ahy: $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment)
                };
            } else {
                var tomorrow = A3($justinmimbs$date$Date$add, 3, 1, model.aae);
                var fields = $author$project$Utils$Form$fields(model.PU);
                var lastDate = A2($elm$core$Maybe$withDefault, model.aae, $elm$core$List$head($elm$core$List$reverse(A2($elm$core$List$sortBy, $justinmimbs$date$Date$toRataDie, A2($elm$core$List$map, function(scheduledPayment) {
                    return A2($elm$core$Maybe$withDefault, tomorrow, scheduledPayment.ag7);
                }, A2($elm$core$List$filter, function(scheduledPayment) {
                    return !A2($author$project$Utils$Date$isBefore, A2($elm$core$Maybe$withDefault, model.aae, scheduledPayment.ag7), model.aae);
                }, $author$project$Components$Invoice$CreateScheduledPaymentModal$editableScheduledPaymentFields(fields.j)))))));
                return {
                    Jh: amountInCents,
                    fy: true,
                    aef: $elm$core$Maybe$Nothing,
                    yc: index,
                    ae0: $elm$core$Maybe$Nothing,
                    nf: $elm$core$Maybe$Nothing,
                    V5: $elm$core$Maybe$Just(0),
                    Wr: A2($author$project$Components$Invoice$CreateScheduledPaymentModal$calculateScheduledPaymentSourceDefault, model, fields.j),
                    r1: sourceSelect,
                    Yz: false,
                    ag7: $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, 1, lastDate)),
                    n9: dateInput,
                    ahy: 'scheduled'
                };
            }
        }();
        return _Utils_Tuple2(updatedScheduledPayment, A2($elm$core$Platform$Cmd$map, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, index, dateInput), dateInputCmd));
    });
    var $author$project$Api$Provider$PassthroughFee$Shared$passthroughFeeInCents = function(_v0) {
        var internalRecord = _v0;
        return internalRecord.V3;
    };
    var $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PassthroughFee$Shared$passthroughFeeInCents(shared);
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnFieldUpdated = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnInputFieldUpdated = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$updateScheduledOnFormField = F5(function(model, index, dateInput, subMsg, toMsg) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var changedForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnInputFieldUpdated, index, newDateInput), model.PU);
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnFieldUpdated, index, date), changedForm);
            } else return changedForm;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, A2(toMsg, index, newDateInput), subCmd),
            adu: 1,
            zi: _Utils_update(model, {
                PU: newForm
            }),
            at: _List_Nil
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var scheduledPayments = response.a;
                    if ($elm$core$List$length(scheduledPayments) > 0) {
                        var scheduledPaymentsIndexedTuples = A2($elm$core$List$indexedMap, F2(function(index, scheduledPayment) {
                            return _Utils_Tuple2(index, $elm$core$Maybe$Just(scheduledPayment));
                        }), scheduledPayments);
                        var updatedScheduledPaymentsAndCmds = A2($elm$core$List$map, $author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList(model), scheduledPaymentsIndexedTuples);
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(A2($elm$core$List$map, $elm$core$Tuple$first, updatedScheduledPaymentsAndCmds)), model.PU);
                        return {
                            EQ: $elm$core$Platform$Cmd$batch(A2($elm$core$List$map, $elm$core$Tuple$second, updatedScheduledPaymentsAndCmds)),
                            adu: 1,
                            zi: _Utils_update(model, {
                                PU: newForm,
                                c_: false
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var fields = $author$project$Utils$Form$fields(model.PU);
                        var _v3 = A2($author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList, model, _Utils_Tuple2(0, $elm$core$Maybe$Nothing));
                        var defaultScheduledPayment = _v3.a;
                        var dateInputCmd = _v3.b;
                        var updatedScheduledPayment = _Utils_ap(fields.j, _List_fromArray([
                            defaultScheduledPayment
                        ]));
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment), model.PU);
                        return {
                            EQ: dateInputCmd,
                            adu: 1,
                            zi: _Utils_update(model, {
                                PU: newForm,
                                c_: false
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                var cmd = _Utils_eq(model.pF, $author$project$Api$Data$Loading) ? $elm$core$Platform$Cmd$none : A2($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments, apiClient, model.lN);
                return {
                    EQ: cmd,
                    adu: 1,
                    zi: _Utils_update(model, {
                        pQ: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var response = msg.a;
                var cmd = _Utils_eq(model.pQ, $author$project$Api$Data$Loading) ? $elm$core$Platform$Cmd$none : A2($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchScheduledPayments, apiClient, model.lN);
                return {
                    EQ: cmd,
                    adu: 1,
                    zi: _Utils_update(model, {
                        pF: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 1:
                var fields = $author$project$Utils$Form$fields(model.PU);
                var newIndex = $elm$core$List$length(fields.j);
                var _v4 = A2($author$project$Components$Invoice$CreateScheduledPaymentModal$generateScheduledPaymentsList, model, _Utils_Tuple2(newIndex, $elm$core$Maybe$Nothing));
                var newScheduledPayment = _v4.a;
                var dateInputCmd = _v4.b;
                var updatedScheduledPayment = _Utils_ap(fields.j, _List_fromArray([
                    newScheduledPayment
                ]));
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment), model.PU);
                return {
                    EQ: dateInputCmd,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 6:
                var index = msg.a;
                var paymentSourceSelectMsg = msg.b;
                var _v5 = $author$project$Utils$Form$fields(model.PU);
                var scheduledPaymentsForm = _v5.j;
                var scheduledPaymentFormItem = A2($elm_community$list_extra$List$Extra$getAt, index, scheduledPaymentsForm);
                if (!scheduledPaymentFormItem.$) {
                    var scheduledPaymentFormItem_ = scheduledPaymentFormItem.a;
                    var _v7 = A2($author$project$Ui$Form$SearchableSelect$update, paymentSourceSelectMsg, scheduledPaymentFormItem_.r1);
                    var selectModel = _v7.a;
                    var selectCmd = _v7.b;
                    var event = _v7.c;
                    var updatesSourceSelectForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelectFieldUpdated, index, selectModel), model.PU);
                    var _v8 = function() {
                        if (!event.$ && !event.a.$) {
                            var maybeSource = event.a.a;
                            var amountInCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, scheduledPaymentFormItem_.Jh)));
                            return _Utils_Tuple2(A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceFieldUpdated, index, maybeSource), updatesSourceSelectForm), A6($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd, model._c, apiClient, amountInCents, maybeSource, model.V8, index));
                        } else return _Utils_Tuple2(updatesSourceSelectForm, $elm$core$Platform$Cmd$none);
                    }();
                    var newForm = _v8.a;
                    var reFetchPassthroughFeesCmd = _v8.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelected(index), selectCmd),
                            reFetchPassthroughFeesCmd
                        ])),
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 10:
                var index = msg.a;
                var _v10 = $author$project$Utils$Form$fields(model.PU);
                var invoiceDueInCents = _v10.mF;
                var scheduledPaymentsForm = _v10.j;
                var scheduledPaymentForm = A2($elm_community$list_extra$List$Extra$getAt, index, scheduledPaymentsForm);
                if (!scheduledPaymentForm.$) {
                    var scheduledPaymentFormItem_ = scheduledPaymentForm.a;
                    var _v12 = A2($author$project$Utils$Form$validate, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$amountInCentsFormValidation, invoiceDueInCents, scheduledPaymentFormItem_), model.PU);
                    if (!_v12.$) {
                        var _v13 = _v12.a;
                        var newForm = _v13.a;
                        var passthroughFeesCmd = function() {
                            var amountInCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, scheduledPaymentFormItem_.Jh)));
                            return A6($author$project$Components$Invoice$CreateScheduledPaymentModal$fetchPassthroughFeesCmd, model._c, apiClient, amountInCents, scheduledPaymentFormItem_.Wr, model.V8, index);
                        }();
                        return {
                            EQ: passthroughFeesCmd,
                            adu: 1,
                            zi: _Utils_update(model, {
                                PU: newForm
                            }),
                            at: _List_Nil
                        };
                    } else {
                        var newForm = _v12.a;
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 1,
                            zi: _Utils_update(model, {
                                PU: newForm
                            }),
                            at: _List_Nil
                        };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 11:
                var index = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var passthroughFees = response.a;
                    var passthroughFeesInCents = $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents(passthroughFees);
                    var updatedScheduledPayment = A3($elm_community$list_extra$List$Extra$updateAt, index, function(scheduledPaymentForm) {
                        return _Utils_update(scheduledPaymentForm, {
                            V5: $elm$core$Maybe$Just(passthroughFeesInCents)
                        });
                    }, $author$project$Utils$Form$fields(model.PU).j);
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$CreateScheduledPaymentModal$formFieldsUpdate, $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewUpdated(updatedScheduledPayment), model.PU);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var _v15 = $author$project$Utils$Form$fields(model.PU);
                var invoiceDueInCents = _v15.mF;
                var scheduledPaymentsForm = _v15.j;
                var _v16 = A2($author$project$Utils$Form$validate, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$formValidation, invoiceDueInCents, model.aae), model.PU);
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var newForm = _v17.a;
                    var createScheduledPaymentCmd = A3($author$project$Components$Invoice$CreateScheduledPaymentModal$createScheduledPayment, apiClient, model.lN, scheduledPaymentsForm);
                    return {
                        EQ: createScheduledPaymentCmd,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            j_: $author$project$Api$Data$Loading
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v16.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 1,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 9:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        j_: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Successfully created scheduled payments')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var index = msg.a;
                var dateInput = msg.b;
                var subMsg = msg.c;
                return A5($author$project$Components$Invoice$CreateScheduledPaymentModal$updateScheduledOnFormField, model, index, dateInput, subMsg, $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected);
        }
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$GotPatient = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Location = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Payer = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateFailed = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateSucceeded = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var maybePatient = field.a;
                return _Utils_update(fields, {
                    GR: maybePatient
                });
            case 1:
                var maybeLocation = field.a;
                return _Utils_update(fields, {
                    Tp: maybeLocation
                });
            default:
                var dateInput = field.a;
                var maybeDate = field.b;
                return _Utils_update(fields, {
                    qg: dateInput,
                    RG: maybeDate
                });
        }
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
    var $author$project$Components$Membership$Form$Records$locationFromMin = function(location1) {
        return {
            aef: $author$project$Api$Provider$Location$Min$id(location1),
            zr: $author$project$Api$Provider$Location$Min$name(location1)
        };
    };
    var $author$project$Components$Membership$Form$Records$practitionerFromMin = function(practitioner) {
        return {
            aef: $author$project$Api$Provider$Practitioner$Min$id(practitioner),
            zr: $author$project$Api$Provider$Practitioner$Min$name(practitioner)
        };
    };
    var $author$project$Components$Membership$Form$Records$patientFromAll = function(patient) {
        return {
            IZ: $author$project$Api$Provider$Patient$All$age(patient),
            aef: $author$project$Api$Provider$Patient$All$id(patient),
            aeT: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$locationFromMin, $author$project$Api$Provider$Patient$All$location(patient)),
            T5: $author$project$Api$Provider$Patient$All$membershipStatus(patient),
            zr: $author$project$Api$Provider$Patient$All$name(patient),
            agi: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromMin, $author$project$Api$Provider$Patient$All$practitioner(patient)),
            aa4: $author$project$Api$Provider$Patient$All$usesTobacco(patient)
        };
    };
    var $author$project$Components$ResourceFilter$Location$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$InvoiceUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$updateInvoice = F3(function(apiClient, invoiceId, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = function() {
            var _v0 = _Utils_Tuple2(fields.GR, fields.Tp);
            if (!_v0.a.$) {
                var payer = _v0.a.a;
                var maybeLocationId = _v0.b;
                return {
                    M4: fields.RG,
                    aeT: maybeLocationId,
                    VM: $elm$core$Maybe$Just(payer.aef),
                    $R: $elm$core$Maybe$Nothing
                };
            } else return {
                M4: $elm$core$Maybe$Nothing,
                aeT: $elm$core$Maybe$Nothing,
                VM: $elm$core$Maybe$Nothing,
                $R: $elm$core$Maybe$Nothing
            };
        }();
        return A5($author$project$Api$Provider$CustomerInvoice$update, apiClient, invoiceId, apiFields, _List_fromArray([
            0
        ]), $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$InvoiceUpdated);
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 6:
                var response = msg.a;
                if (response.$ === 3) {
                    var patient = response.a;
                    var _v2 = model.ro;
                    if (!_v2.$) {
                        var locationResourceFilter_ = _v2.a;
                        var _v3 = model.aa;
                        if (!_v3.$) {
                            var _v4 = _v3.a;
                            var invoice = _v4.c;
                            var locationFieldEnabled = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'draft';
                            var _v5 = function() {
                                var _v6 = _Utils_Tuple3($author$project$Api$Provider$Patient$One$location(patient), locationFieldEnabled, model.ye);
                                if (!_v6.a.$ && _v6.b && !_v6.c) {
                                    var location1 = _v6.a.a;
                                    return _Utils_Tuple2($elm$core$Maybe$Just(function(value) {
                                        return A2($author$project$Components$ResourceFilter$Location$setValue, value, locationResourceFilter_);
                                    }($author$project$Components$ResourceFilter$Location$resourceFromShared($elm$core$Maybe$Just($author$project$Api$Location$Shared$Provider(location1))))), $elm$core$Maybe$Just($author$project$Api$Provider$Location$Shared$id(location1)));
                                } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
                            }();
                            var maybeLocationResourceFilter = _v5.a;
                            var preSelectedId = _v5.b;
                            var _v7 = function() {
                                if (!maybeLocationResourceFilter.$) {
                                    var locationResourceFilter = maybeLocationResourceFilter.a;
                                    return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$ResourceFilter$Location$preSelectedId, preSelectedId, locationResourceFilter));
                                } else return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$initLocationResourceFilter, apiClient, invoice));
                            }();
                            var newLocationResourceFilter = _v7.a;
                            var newLocationResourceFilterCmd = _v7.b;
                            return _Utils_Tuple3(_Utils_update(model, {
                                ye: false,
                                ro: newLocationResourceFilter
                            }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, newLocationResourceFilterCmd), $elm$core$Maybe$Nothing);
                        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 4:
                var subMsg = msg.a;
                var _v9 = model.rX;
                if (!_v9.$) {
                    var patientResourceFilter = _v9.a;
                    var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, patientResourceFilter);
                    var _v10 = function() {
                        var _v11 = patientResourceResult.adu;
                        if (!_v11.$ && !_v11.a.$ && !_v11.a.a.$) {
                            var patient = _v11.a.a.a;
                            var _v12 = model.aa;
                            if (!_v12.$) {
                                var _v13 = _v12.a;
                                var id = _v13.a;
                                var form = _v13.b;
                                var invoice = _v13.c;
                                var patientRequestCmd = A3($author$project$Api$Provider$Patient$retrieve, apiClient, $author$project$Api$Provider$Patient$All$id(patient), $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$GotPatient);
                                var patientRecord = $author$project$Components$Membership$Form$Records$patientFromAll(patient);
                                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Payer($elm$core$Maybe$Just(patientRecord)), form);
                                return _Utils_Tuple2(_Utils_update(model, {
                                    aa: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, invoice)),
                                    rX: $elm$core$Maybe$Just(patientResourceResult.zi)
                                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceResult.EQ),
                                    patientRequestCmd
                                ])));
                            } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                        } else return _Utils_Tuple2(_Utils_update(model, {
                            rX: $elm$core$Maybe$Just(patientResourceResult.zi)
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, patientResourceResult.EQ));
                    }();
                    var newModel = _v10.a;
                    var cmd = _v10.b;
                    return _Utils_Tuple3(newModel, cmd, $elm$core$Maybe$Nothing);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 5:
                var subMsg = msg.a;
                var _v14 = model.ro;
                if (!_v14.$) {
                    var locationResourceFilter = _v14.a;
                    var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, locationResourceFilter);
                    var _v15 = function() {
                        var _v16 = model.aa;
                        if (!_v16.$) {
                            var _v17 = _v16.a;
                            var id = _v17.a;
                            var form = _v17.b;
                            var invoice = _v17.c;
                            var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Location($author$project$Components$ResourceFilter$Location$value(locationResourceResult.zi)), form);
                            return _Utils_Tuple2(_Utils_update(model, {
                                aa: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, invoice)),
                                ro: $elm$core$Maybe$Just(locationResourceResult.zi)
                            }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceResult.EQ));
                        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v15.a;
                    var formCmd = _v15.b;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        formCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, locationResourceResult.EQ)
                    ])), $elm$core$Maybe$Nothing);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 0:
                var form = msg.a;
                var maybeInvoiceId = msg.b;
                if (!maybeInvoiceId.$) {
                    var invoiceId = maybeInvoiceId.a;
                    var _v19 = model.aa;
                    if (!_v19.$) {
                        var _v20 = _v19.a;
                        var invoice = _v20.c;
                        var _v21 = A2($author$project$Utils$Form$validate, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsValidator, form);
                        if (!_v21.$) {
                            var _v22 = _v21.a;
                            var newForm = _v22.a;
                            var validFormFields = _v22.b;
                            return _Utils_Tuple3(_Utils_update(model, {
                                aa: $elm$core$Maybe$Just(_Utils_Tuple3(invoiceId, newForm, invoice)),
                                Tk: true
                            }), A3($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$updateInvoice, apiClient, invoiceId, validFormFields), $elm$core$Maybe$Nothing);
                        } else {
                            var newForm = _v21.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                aa: $elm$core$Maybe$Just(_Utils_Tuple3(invoiceId, newForm, invoice))
                            }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                        }
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 1:
                var response = msg.a;
                var _v23 = model.aa;
                if (!_v23.$) switch(response.$){
                    case 3:
                        var invoice = response.a;
                        var ownerId = function() {
                            var _v25 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
                            if (!_v25.$) {
                                var patient = _v25.a;
                                return $author$project$Api$Provider$Patient$Shared$id(patient);
                            } else return '';
                        }();
                        return _Utils_Tuple3(_Utils_update(model, {
                            Tk: false
                        }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateSucceeded(ownerId)));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Tk: false
                        }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$UpdateFailed(error)));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            Tk: false
                        }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                }
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    aa: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            default:
                var dateInput = msg.a;
                var subMsg = msg.b;
                var _v26 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
                var newDateInput = _v26.a;
                var subCmd = _v26.b;
                var event = _v26.c;
                var _v27 = model.aa;
                if (!_v27.$) {
                    var _v28 = _v27.a;
                    var id = _v28.a;
                    var form = _v28.b;
                    var invoice = _v28.c;
                    var newForm = function() {
                        if (event.$ === 1) {
                            var date = event.a;
                            return A3($author$project$Utils$Form$update, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate, A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date, newDateInput, date), form);
                        } else {
                            var _v30 = $author$project$Utils$Form$fields(form);
                            var invoiceDate = _v30.RG;
                            return A3($author$project$Utils$Form$update, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$formFieldsUpdate, A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$Date, newDateInput, invoiceDate), form);
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        aa: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, invoice))
                    }), subCmd, $elm$core$Maybe$Nothing);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
        }
    });
    var $author$project$Components$Patient$Charges$ChargeModal$Category = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$ChargeItem = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated = {
        $: 3
    };
    var $author$project$Components$Patient$Charges$ChargeModal$Closed = {
        $: 1
    };
    var $author$project$Components$Patient$Charges$ChargeModal$EndDate = F2(function(a, b) {
        return {
            $: 10,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$Charges$ChargeModal$Location = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$Name = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$None = {
        $: 0
    };
    var $author$project$Components$Patient$Charges$ChargeModal$Patient = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$Practitioner = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$StartDate = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$Charges$ChargeModal$clearFormFields = F3(function(apiClient, showItemTypeInTitle, existingFormFields) {
        var newCategoryResourceFilter = A2($author$project$Components$ResourceFilter$Category$setValue, $elm$core$Maybe$Nothing, existingFormFields.cK);
        var _v0 = $author$project$Components$DateInput$init;
        var startDateInput = _v0.a;
        var startDateInputCmd = _v0.b;
        var _v1 = $author$project$Components$DateInput$init;
        var endDateInput = _v1.a;
        var endDateInputCmd = _v1.b;
        var _v2 = A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, $elm$core$Basics$identity, $author$project$Components$Patient$Charges$ChargeModal$chargeItemResourceConfig);
        var chargeItemResourceFilter = _v2.a;
        var chargeItemResourceFilterCmd = _v2.b;
        return _Utils_Tuple2(_Utils_update(existingFormFields, {
            EL: $elm$core$Maybe$Nothing,
            cK: newCategoryResourceFilter,
            lv: $elm$core$Maybe$Nothing,
            cL: chargeItemResourceFilter,
            NQ: '',
            N$: 0,
            N0: false,
            qv: $elm$core$Maybe$Nothing,
            qx: endDateInput,
            aef: $elm$core$Maybe$Nothing,
            zr: $elm$core$Maybe$Nothing,
            Br: $elm$core$Maybe$Nothing,
            Xn: $elm$core$Maybe$Nothing,
            Bu: $elm$core$Maybe$Just(1),
            Bv: $elm$core$Maybe$Nothing,
            kj: startDateInput,
            $S: false
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput), startDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput), endDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd)
        ])));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$PreviewDebounced = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$debouncePreview = function(cmd) {
        return A2($elm$core$Task$perform, $author$project$Components$Patient$Charges$ChargeModal$PreviewDebounced, $elm$core$Task$succeed(cmd));
    };
    var $author$project$Components$Patient$Charges$ChargeModal$ChargeItemValidation = 1;
    var $author$project$Components$Patient$Charges$ChargeModal$PatientValidation = 0;
    var $author$project$Components$Patient$Charges$ChargeModal$PriceInCentsValidation = 3;
    var $author$project$Components$Patient$Charges$ChargeModal$QuantityValidation = 2;
    var $author$project$Components$Patient$Charges$ChargeModal$StartDateValidation = 4;
    var $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.zr;
        }, _Utils_Tuple2(1, 'Please pick a charge.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.V7;
        }, _Utils_Tuple2(0, 'Please pick a patient.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Bu;
        }, _Utils_Tuple2(2, 'Can\'t be blank.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.Br;
        }, _Utils_Tuple2(3, 'Please enter an amount.')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $._0;
        }, _Utils_Tuple2(4, 'Please pick a date.'))
    ]));
    var $author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount = F5(function(model, apiClient, charge, form, shouldClose) {
        var fields = $author$project$Utils$Form$fields(form);
        if (fields.N0 && !$author$project$Api$Provider$Charge$One$discountOverridden(charge)) return _Utils_Tuple3(A3($author$project$Api$Provider$Charge$CoverageDiscount$override, apiClient, $author$project$Api$Provider$Charge$One$id(charge), $author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden(shouldClose)), $author$project$Components$Patient$Charges$ChargeModal$None, _List_Nil);
        else {
            if (!fields.N0 && $author$project$Api$Provider$Charge$One$discountOverridden(charge)) return _Utils_Tuple3(A3($author$project$Api$Provider$Charge$CoverageDiscount$reset, apiClient, $author$project$Api$Provider$Charge$One$id(charge), $author$project$Components$Patient$Charges$ChargeModal$GotChargeOverridden(shouldClose)), $author$project$Components$Patient$Charges$ChargeModal$None, _List_Nil);
            else {
                var message = _Utils_eq(model.ach, $elm$core$Maybe$Nothing) ? 'Charge created.' : 'Charge updated.';
                return _Utils_Tuple3($elm$core$Platform$Cmd$none, _Utils_eq(model.ach, $elm$core$Maybe$Nothing) ? $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated(shouldClose) : $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, message)
                ]));
            }
        }
    });
    var $author$project$Components$Patient$Charges$ChargeModal$PreviewDebouncedMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Patient$Charges$ChargeModal$PreviewDebouncedMsg
    };
    var $author$project$Components$Patient$Charges$ChargeModal$GotChargeCreated = F2(function(a, b) {
        return {
            $: 11,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice = F2(function(model, fields) {
        var priceInCents = function() {
            if (!!fields.N$) {
                var _v0 = _Utils_Tuple2(fields.lv, model.agk);
                if (!_v0.a.$) {
                    var chargeItem = _v0.a.a;
                    return $elm$core$Maybe$Just(chargeItem.Br | 0);
                } else if (_v0.b.$ === 3) {
                    var _v1 = _v0.a;
                    var _v2 = _v0.b;
                    var preview = _v2.a;
                    return $elm$core$Maybe$Just($author$project$Api$Provider$Charge$Calculate$issuedSubtotalInCents(preview) + $author$project$Api$Provider$Charge$Calculate$discountInCents(preview));
                } else {
                    var _v3 = _v0.a;
                    return $elm$core$Maybe$Just(fields.N$ + A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Br)));
                }
            } else return A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Br);
        }();
        return {
            EL: fields.EL,
            lv: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.lv),
            M4: fields._0,
            NQ: fields.NQ,
            N0: fields.N0,
            qv: fields.qv,
            RA: $author$project$Api$Provider$Charge$Invoice($elm$core$Maybe$Just({
                aef: $elm$core$Maybe$Just($author$project$Api$Provider$CustomerInvoice$One$id(model.RA)),
                ah5: $elm$core$Maybe$Just('customer_invoice')
            })),
            aeT: fields.aeT,
            zr: fields.zr,
            V7: A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.V7),
            GR: $elm$core$Maybe$Nothing,
            agi: fields.agi,
            Br: priceInCents,
            Bu: A2($elm$core$Maybe$withDefault, 1, fields.Bu),
            Bv: A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, fields.Bv)
        };
    });
    var $author$project$Components$Patient$Charges$ChargeModal$createCharge = F4(function(model, apiClient, formFields, shouldClose) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A4($author$project$Api$Provider$Charge$create, $author$project$Api$Data$providerPath, apiClient, A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields), $author$project$Components$Patient$Charges$ChargeModal$GotChargeCreated(shouldClose));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$GotChargeUpdated = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$updateCharge = F4(function(model, apiClient, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields);
        return A5($author$project$Api$Provider$Charge$update, $author$project$Api$Provider$CustomerInvoice$customerInvoicePath($author$project$Api$Provider$CustomerInvoice$One$id(model.RA)), apiClient, id, apiFields, $author$project$Components$Patient$Charges$ChargeModal$GotChargeUpdated);
    });
    var $author$project$Components$Patient$Charges$ChargeModal$save = F4(function(model, apiClient, formFields, shouldClose) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var id = _v0.aef;
        if (!id.$) {
            var id_ = id.a;
            return A4($author$project$Components$Patient$Charges$ChargeModal$updateCharge, model, apiClient, id_, formFields);
        } else return A4($author$project$Components$Patient$Charges$ChargeModal$createCharge, model, apiClient, formFields, shouldClose);
    });
    var $author$project$Components$Patient$Charges$ChargeModal$GotPreview = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview = function(field) {
        switch(field.$){
            case 1:
                return true;
            case 0:
                return true;
            case 2:
                return true;
            case 3:
                return true;
            case 4:
                return false;
            case 5:
                return false;
            case 6:
                return false;
            case 7:
                return true;
            case 8:
                return true;
            case 9:
                return true;
            case 10:
                return true;
            case 11:
                return true;
            case 12:
                return true;
            default:
                return true;
        }
    };
    var $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields = function(fields) {
        return $author$project$Utils$Maybe$toBool(fields.zr) && A2($elm$core$Maybe$withDefault, 0, fields.Bu) > 0;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$calculatePreview = F4(function(field, form, apiClient, model) {
        var fields = $author$project$Utils$Form$fields(form);
        var _v0 = model.vX && $author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview(field) && $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields) ? _Utils_Tuple2(A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig, A4($author$project$Api$Provider$Charge$calculate, $author$project$Api$Provider$Charge$chargesPath($author$project$Api$Data$providerPath), apiClient, A2($author$project$Components$Patient$Charges$ChargeModal$paramsWithPrice, model, fields), $author$project$Components$Patient$Charges$ChargeModal$GotPreview), model.eq), $author$project$Api$Data$Loading) : _Utils_Tuple2(_Utils_Tuple2(model.eq, $elm$core$Platform$Cmd$none), $author$project$Api$Data$NotAsked);
        var _v1 = _v0.a;
        var newDebouncer = _v1.a;
        var cmd = _v1.b;
        var preview = _v0.b;
        return _Utils_Tuple2($author$project$Components$Patient$Charges$ChargeModal$shouldCalculatePreview(field) && $author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields) ? _Utils_update(model, {
            agk: preview,
            eq: newDebouncer
        }) : !$author$project$Components$Patient$Charges$ChargeModal$validPreviewFields(fields) ? _Utils_update(model, {
            agk: $author$project$Api$Data$NotAsked,
            eq: newDebouncer
        }) : _Utils_update(model, {
            eq: newDebouncer
        }), cmd);
    });
    var $author$project$Components$Patient$Charges$ChargeModal$resetEndDate = function(fields) {
        var _v0 = _Utils_Tuple2(fields.Bu, fields.Bv);
        if (!_v0.a.$ && !_v0.b.$) {
            var quantity = _v0.a.a;
            var quantityUom = _v0.b.a;
            return _Utils_update(fields, {
                qv: A3($author$project$Utils$Uom$addTo, fields._0, quantityUom, quantity)
            });
        } else return fields;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$translateLocation = function(location1) {
        return {
            IY: $elm$core$Maybe$Nothing,
            aef: location1.aef,
            R8: false,
            Su: false,
            zr: location1.zr
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$translatePractitioner = function(practitioner) {
        return {
            IY: $elm$core$Maybe$Nothing,
            aef: practitioner.aef,
            R8: false,
            Su: false,
            zr: practitioner.zr,
            Vy: $elm$core$Maybe$Nothing,
            agg: '',
            Xb: ''
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 1:
                var patient = field.a;
                var _v1 = function() {
                    if (!patient.$) {
                        var pat = patient.a;
                        return _Utils_Tuple3($elm$core$Maybe$Just({
                            aef: pat.aef,
                            zr: pat.zr
                        }), A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$translateLocation, pat.aeT), A2($elm$core$Maybe$map, $author$project$Components$Patient$Charges$ChargeModal$translatePractitioner, pat.agi));
                    } else return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
                }();
                var formPatient = _v1.a;
                var locationResource = _v1.b;
                var practitionerResource = _v1.c;
                return _Utils_update(fields, {
                    aeT: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, locationResource),
                    ro: A2($author$project$Components$ResourceFilter$Location$setValue, locationResource, fields.ro),
                    V7: formPatient,
                    agi: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, practitionerResource),
                    jE: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitionerResource, fields.jE)
                });
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    lv: $elm$core$Maybe$Nothing,
                    zr: $author$project$Utils$String$toMaybe(string),
                    Xn: $elm$core$Maybe$Nothing,
                    Bv: $elm$core$Maybe$Nothing
                });
            case 2:
                var chargeItem = field.a;
                var category = A2($elm$core$Maybe$andThen, function($) {
                    return $.EL;
                }, chargeItem);
                return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(_Utils_update(fields, {
                    EL: A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Shared$id, category),
                    cK: A2($author$project$Components$ResourceFilter$Category$setValue, A2($elm$core$Maybe$map, function(category_) {
                        return {
                            aef: $author$project$Api$Provider$Category$Shared$id(category_),
                            zr: $author$project$Api$Provider$Category$Shared$name(category_)
                        };
                    }, category), fields.cK),
                    lv: chargeItem,
                    NQ: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, function($) {
                        return $.NQ;
                    }, chargeItem)),
                    zr: A2($elm$core$Maybe$map, function($) {
                        return $.zr;
                    }, chargeItem),
                    Br: A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function($) {
                        return $.Br;
                    }, $author$project$Currency$fromFloat), chargeItem),
                    Xn: A2($elm$core$Maybe$map, function($) {
                        return $.aaK;
                    }, chargeItem),
                    Bu: $elm$core$Maybe$Just(1),
                    Bv: A2($elm$core$Maybe$map, function($) {
                        return $.aaK;
                    }, chargeItem)
                }));
            case 3:
                var maybeString = field.a;
                return _Utils_update(fields, {
                    EL: maybeString
                });
            case 4:
                var practitioner = field.a;
                return _Utils_update(fields, {
                    agi: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, practitioner),
                    jE: A2($author$project$Components$ResourceFilter$Practitioner$setValue, practitioner, fields.jE)
                });
            case 5:
                var location1 = field.a;
                return _Utils_update(fields, {
                    aeT: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, location1),
                    ro: A2($author$project$Components$ResourceFilter$Location$setValue, location1, fields.ro)
                });
            case 6:
                var string = field.a;
                return _Utils_update(fields, {
                    NQ: string
                });
            case 7:
                var string = field.a;
                return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(_Utils_update(fields, {
                    Bu: $elm$core$String$toInt(string)
                }));
            case 8:
                var string = field.a;
                var _v3 = $author$project$Utils$Uom$fromCode(string);
                if (!_v3.$) {
                    var quantityUom = _v3.a;
                    var quantity = function() {
                        var _v4 = _Utils_Tuple2(fields._0, fields.qv);
                        if (!_v4.a.$ && !_v4.b.$) {
                            var startDate = _v4.a.a;
                            var endDate = _v4.b.a;
                            return $elm$core$Maybe$Just(A3($author$project$Utils$Uom$quantityBetween, quantityUom, startDate, $elm$core$Maybe$Just(endDate)));
                        } else return fields.Bu;
                    }();
                    return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(_Utils_update(fields, {
                        Bu: quantity,
                        Bv: $elm$core$Maybe$Just(quantityUom)
                    }));
                } else return _Utils_update(fields, {
                    Bv: $elm$core$Maybe$Nothing
                });
            case 9:
                var dateInput = field.a;
                var date = field.b;
                return $author$project$Components$Patient$Charges$ChargeModal$resetEndDate(_Utils_update(fields, {
                    _0: date,
                    kj: dateInput
                }));
            case 10:
                var dateInput = field.a;
                var date = field.b;
                var _v5 = function() {
                    var _v6 = _Utils_Tuple2(fields._0, date);
                    if (!_v6.a.$ && !_v6.b.$) {
                        var startDate_ = _v6.a.a;
                        var endDate = _v6.b.a;
                        var startDate__ = A2($justinmimbs$date$Date$compare, startDate_, endDate) === 2 ? endDate : startDate_;
                        var quantityUom_ = A2($author$project$Utils$Uom$matchRange, startDate__, endDate);
                        return _Utils_Tuple3($elm$core$Maybe$Just(startDate__), $elm$core$Maybe$Just(quantityUom_), $elm$core$Maybe$Just(A3($author$project$Utils$Uom$quantityBetween, quantityUom_, startDate__, $elm$core$Maybe$Just(endDate))));
                    } else return _Utils_Tuple3(fields._0, fields.Bv, fields.Bu);
                }();
                var startDate = _v5.a;
                var quantityUom = _v5.b;
                var quantity = _v5.c;
                return _Utils_update(fields, {
                    qv: date,
                    qx: dateInput,
                    Bu: quantity,
                    Bv: quantityUom,
                    _0: startDate
                });
            case 11:
                var _int = field.a;
                return _Utils_update(fields, {
                    Br: _int
                });
            case 12:
                var bool = field.a;
                var priceInCents = bool ? fields.Br : A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function($) {
                    return $.Br;
                }, $author$project$Currency$fromFloat), fields.lv);
                return _Utils_update(fields, {
                    N0: bool,
                    Br: priceInCents
                });
            default:
                var _int = field.a;
                return _Utils_update(fields, {
                    N$: _int
                });
        }
    });
    var $author$project$Components$Patient$Charges$ChargeModal$updateForm = F4(function(model, apiClient, field, form) {
        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate, field, form);
        return A4($author$project$Components$Patient$Charges$ChargeModal$calculatePreview, field, newForm, apiClient, _Utils_update(model, {
            PU: newForm
        }));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField = F7(function(model, apiClient, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var dateField = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A2(field, newDateInput, date);
            } else return A2(field, newDateInput, fieldGetter($author$project$Utils$Form$fields(model.PU)));
        }();
        var _v1 = A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, dateField, model.PU);
        var newModel = _v1.a;
        var formCmd = _v1.b;
        return {
            EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                formCmd,
                A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd)
            ])),
            adu: $author$project$Components$Patient$Charges$ChargeModal$None,
            zi: newModel,
            at: _List_Nil
        };
    });
    var $author$project$Components$Patient$Charges$ChargeModal$DiscountInCents = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$PriceInCents = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$updateFormFromPreview = F2(function(preview, form) {
        return A3($author$project$Utils$Form$update, $author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate, $author$project$Components$Patient$Charges$ChargeModal$DiscountInCents($author$project$Api$Provider$Charge$Calculate$discountInCents(preview)), A3($author$project$Utils$Form$update, $author$project$Components$Patient$Charges$ChargeModal$formFieldsUpdate, $author$project$Components$Patient$Charges$ChargeModal$PriceInCents($elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Provider$Charge$Calculate$priceInCents(preview)))), form));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator, model.PU);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var newForm = _v2.a;
                    var validFormFields = _v2.b;
                    return {
                        EQ: A4($author$project$Components$Patient$Charges$ChargeModal$save, model, apiClient, validFormFields, true),
                        adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            n8: true
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v1.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Components$Patient$Charges$ChargeModal$formFieldsValidator, model.PU);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    return {
                        EQ: A4($author$project$Components$Patient$Charges$ChargeModal$save, model, apiClient, validFormFields, false),
                        adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            n8: true
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v3.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 3:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A7($author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField, model, apiClient, dateInput, subMsg, $author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg, $author$project$Components$Patient$Charges$ChargeModal$StartDate, function($) {
                    return $._0;
                });
            case 4:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A7($author$project$Components$Patient$Charges$ChargeModal$updateDateInputFormField, model, apiClient, dateInput, subMsg, $author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg, $author$project$Components$Patient$Charges$ChargeModal$EndDate, function($) {
                    return $.qv;
                });
            case 5:
                var subMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var limitedPatientSelectorResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, fields.rg);
                var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    rg: limitedPatientSelectorResult.zi
                }), model.PU);
                var _v5 = function() {
                    var _v6 = limitedPatientSelectorResult.adu;
                    _v6$2: while(true){
                        if (_v6.$ === 1) switch(_v6.a.$){
                            case 0:
                                var patient = _v6.a.a;
                                return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$Patient($elm$core$Maybe$Just(patient)), newForm);
                            case 3:
                                var _v7 = _v6.a;
                                return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$Patient($elm$core$Maybe$Nothing), newForm);
                            default:
                                break _v6$2;
                        }
                        else break _v6$2;
                    }
                    return _Utils_Tuple2(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v5.a;
                var formCmd = _v5.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, limitedPatientSelectorResult.EQ),
                        formCmd
                    ])),
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: newModel,
                    at: limitedPatientSelectorResult.at
                };
            case 6:
                var subMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, fields.cL);
                var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    cL: chargeItemResourceResult.zi
                }), model.PU);
                var _v8 = function() {
                    var _v9 = chargeItemResourceResult.adu;
                    _v9$2: while(true){
                        if (!_v9.$ && !_v9.a.$) switch(_v9.a.a.$){
                            case 0:
                                var item = _v9.a.a.a;
                                return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$ChargeItem($elm$core$Maybe$Just(item)), newForm);
                            case 5:
                                var string = _v9.a.a.a;
                                return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$Name(string), newForm);
                            default:
                                break _v9$2;
                        }
                        else break _v9$2;
                    }
                    return _Utils_Tuple2(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v8.a;
                var formCmd = _v8.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.EQ),
                        formCmd
                    ])),
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: newModel,
                    at: _List_Nil
                };
            case 7:
                var subMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, fields.cK);
                var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    cK: categoryResourceResult.zi
                }), model.PU);
                var _v10 = function() {
                    var _v11 = categoryResourceResult.adu;
                    if (!_v11.$) {
                        if (!_v11.a.$) return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$Category($author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi)), newForm);
                        else {
                            var _v12 = _v11.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                PU: newForm
                            }), $elm$core$Platform$Cmd$none);
                        }
                    } else return _Utils_Tuple2(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v10.a;
                var formCmd = _v10.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, categoryResourceResult.EQ),
                        formCmd
                    ])),
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: newModel,
                    at: categoryResourceResult.at
                };
            case 8:
                var subMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, fields.jE);
                var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    jE: practitionerResourceResult.zi
                }), model.PU);
                var _v13 = function() {
                    var _v14 = practitionerResourceResult.adu;
                    _v14$2: while(true){
                        if (!_v14.$ && !_v14.a.$) switch(_v14.a.a.$){
                            case 0:
                                var practitioner = _v14.a.a.a;
                                return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$Practitioner($elm$core$Maybe$Just(practitioner)), newForm);
                            case 2:
                                var _v15 = _v14.a.a;
                                return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$Practitioner($elm$core$Maybe$Nothing), newForm);
                            default:
                                break _v14$2;
                        }
                        else break _v14$2;
                    }
                    return _Utils_Tuple2(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v13.a;
                var formCmd = _v13.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, practitionerResourceResult.EQ),
                        formCmd
                    ])),
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: newModel,
                    at: practitionerResourceResult.at
                };
            case 9:
                var subMsg = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, fields.ro);
                var newForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    ro: locationResourceResult.zi
                }), model.PU);
                var _v16 = function() {
                    var _v17 = locationResourceResult.adu;
                    _v17$2: while(true){
                        if (!_v17.$ && !_v17.a.$) switch(_v17.a.a.$){
                            case 0:
                                var location1 = _v17.a.a.a;
                                return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$Location($elm$core$Maybe$Just(location1)), newForm);
                            case 2:
                                var _v18 = _v17.a.a;
                                return A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, $author$project$Components$Patient$Charges$ChargeModal$Location($elm$core$Maybe$Nothing), newForm);
                            default:
                                break _v17$2;
                        }
                        else break _v17$2;
                    }
                    return _Utils_Tuple2(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none);
                }();
                var newModel = _v16.a;
                var formCmd = _v16.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, locationResourceResult.EQ),
                        formCmd
                    ])),
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: newModel,
                    at: locationResourceResult.at
                };
            case 10:
                var field = msg.a;
                var _v19 = A4($author$project$Components$Patient$Charges$ChargeModal$updateForm, model, apiClient, field, model.PU);
                var newModel = _v19.a;
                var formCmd = _v19.b;
                return {
                    EQ: formCmd,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: newModel,
                    at: _List_Nil
                };
            case 11:
                var shouldClose = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var charge = response.a;
                    var _v21 = A2($elm$core$Tuple$mapFirst, function(clearedFormFields) {
                        return A2($author$project$Utils$Form$set, clearedFormFields, model.PU);
                    }, A3($author$project$Components$Patient$Charges$ChargeModal$clearFormFields, apiClient, A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1), $author$project$Utils$Form$fields(model.PU)));
                    var resetForm = _v21.a;
                    var resetCmds = _v21.b;
                    var newModel = _Utils_update(model, {
                        PU: resetForm,
                        n8: false
                    });
                    var _v22 = A5($author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount, model, apiClient, charge, model.PU, shouldClose);
                    var cmd = _v22.a;
                    var event = _v22.b;
                    var outMsg = _v22.c;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            resetCmds,
                            cmd
                        ])),
                        adu: event,
                        zi: newModel,
                        at: outMsg
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: _Utils_update(model, {
                        n8: false
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 12:
                var response = msg.a;
                var newModel = _Utils_update(model, {
                    n8: false
                });
                if (response.$ === 3) {
                    var charge = response.a;
                    var _v24 = A5($author$project$Components$Patient$Charges$ChargeModal$overrideChargeDiscount, model, apiClient, charge, model.PU, true);
                    var cmd = _v24.a;
                    var event = _v24.b;
                    var outMsg = _v24.c;
                    return {
                        EQ: cmd,
                        adu: event,
                        zi: newModel,
                        at: outMsg
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: newModel,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 13:
                var shouldClose = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var message = _Utils_eq(model.ach, $elm$core$Maybe$Nothing) ? 'Charge created.' : 'Charge updated.';
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: _Utils_eq(model.ach, $elm$core$Maybe$Nothing) ? $author$project$Components$Patient$Charges$ChargeModal$ChargeCreated(shouldClose) : $author$project$Components$Patient$Charges$ChargeModal$ChargeUpdated,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, message)
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 14:
                var debounceMsg = msg.a;
                var _v26 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Patient$Charges$ChargeModal$previewDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Patient$Charges$ChargeModal$debouncePreview), debounceMsg, model.eq);
                var newDebouncer = _v26.a;
                var cmd = _v26.b;
                return {
                    EQ: cmd,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: _Utils_update(model, {
                        eq: newDebouncer
                    }),
                    at: _List_Nil
                };
            case 15:
                var cmd = msg.a;
                return {
                    EQ: cmd,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: model,
                    at: _List_Nil
                };
            case 16:
                var response = msg.a;
                if (response.$ === 3) {
                    var preview = response.a;
                    var newForm = A2($author$project$Components$Patient$Charges$ChargeModal$updateFormFromPreview, preview, model.PU);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm,
                            agk: response
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: _Utils_update(model, {
                        agk: response
                    }),
                    at: _List_Nil
                };
            default:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Patient$Charges$ChargeModal$None,
                    zi: _Utils_update(model, {
                        gP: !model.gP
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$updateChargeDropdown = F3(function(msg, charge, dropdowns) {
        return A3($elm$core$List$foldl, F2(function(_v2, _v3) {
            var id = _v2.a;
            var dropdown = _v2.b;
            var cmd = _v2.c;
            var dropdownsAcc = _v3.a;
            var cmdAcc = _v3.b;
            return _Utils_Tuple2(_Utils_ap(dropdownsAcc, _List_fromArray([
                _Utils_Tuple2(id, dropdown)
            ])), $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmd,
                cmdAcc
            ])));
        }), _Utils_Tuple2(_List_Nil, $elm$core$Platform$Cmd$none), A2($elm$core$List$map, function(_v0) {
            var chargeId = _v0.a;
            var dropdown = _v0.b;
            if (_Utils_eq(chargeId, $author$project$Api$Provider$Charge$One$id(charge))) {
                var _v1 = A2($author$project$Ui$Dropdown$update, msg, dropdown);
                var newDropdown = _v1.a;
                var dropdownCmd = _v1.b;
                return _Utils_Tuple3(chargeId, newDropdown, dropdownCmd);
            } else return _Utils_Tuple3(chargeId, dropdown, $elm$core$Platform$Cmd$none);
        }, dropdowns));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoice = response.a;
                    var cmd = function() {
                        var _v2 = $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$patientPath(invoice);
                        if (!_v2.$) {
                            var patientPath_ = _v2.a;
                            return A2($author$project$Utils$FeatureGate$gateAvailable, 12, $author$project$Api$Practice$Provider(model.W1)) ? $elm$core$Platform$Cmd$batch(_List_fromArray([
                                A3($author$project$Api$Provider$ScheduledPayment$list, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotScheduledPayments),
                                A4($author$project$Api$Card$list, patientPath_, model.Ej, model.Z$, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards),
                                A4($author$project$Api$BankAccount$list, patientPath_, model.Ej, model.Z$, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotBankAccounts)
                            ])) : $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.V7) ? A4($author$project$Api$Card$list, patientPath_, model.Ej, model.Z$, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCards) : $elm$core$Platform$Cmd$none;
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    var auditTrailLog = A7($author$project$Components$AuditTrailLog$init, model.Z$, model.Cu.aaT, model.Cu.HO, $elm$core$Maybe$Just('customer_invoice'), $elm$core$Maybe$Just(model.RI), $elm$core$Maybe$Just($author$project$Api$Provider$CustomerInvoice$One$createdAt(invoice)), $elm$core$Maybe$Nothing);
                    return _Utils_Tuple3(_Utils_update(model, {
                        hB: $elm$core$Maybe$Just(auditTrailLog),
                        hM: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initChargeDropdowns(invoice),
                        RA: response
                    }), cmd, _List_fromArray([
                        $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7))
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    g2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.ng);
                var dropdown = _v3.a;
                var dropdownCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ng: dropdown
                }), dropdownCmd, _List_Nil);
            case 24:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$markAsSent, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 25:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$markAsUnsent, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 29:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$applyCredits, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 30:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$removeCredits, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 31:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$transferToCredit, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 32:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$reverseCreditTransfer, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 26:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$stopRetrying, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 27:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$returnToDraft, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 28:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$reverseBadDebt, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 34:
                var invoice = msg.a;
                var _v4 = A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$init, model.Ej, invoice);
                var editInvoiceModal = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    iw: $elm$core$Maybe$Just(editInvoiceModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg, cmd), _List_Nil);
            case 35:
                var modalMsg = msg.a;
                var _v5 = model.iw;
                if (!_v5.$) {
                    var modal = _v5.a;
                    var _v6 = A3($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$update, model.Ej, modalMsg, modal);
                    var editInvoiceModel = _v6.a;
                    var editInvoiceCmd = _v6.b;
                    var event = _v6.c;
                    var _v7 = function() {
                        if (!event.$) {
                            if (!event.a.$) {
                                var error = event.a.a;
                                return _Utils_Tuple3($elm$core$Platform$Cmd$none, _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                                ]), $elm$core$Maybe$Just(editInvoiceModel));
                            } else {
                                var patientId = event.a.a;
                                var successText = model.RI + ' was successfully updated.';
                                var currentPayer = function() {
                                    var _v10 = model.RA;
                                    if (_v10.$ === 3) {
                                        var invoice = _v10.a;
                                        return $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
                                    } else return $elm$core$Maybe$Nothing;
                                }();
                                var redirectCommand = function() {
                                    if (!currentPayer.$) {
                                        var currentPayer_ = currentPayer.a;
                                        return _Utils_eq($author$project$Api$Provider$Patient$Shared$id(currentPayer_), patientId) ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI) : A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceRedirect, patientId, model.RI);
                                    } else return $elm$core$Platform$Cmd$none;
                                }();
                                return _Utils_Tuple3(redirectCommand, _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, successText)
                                ]), $elm$core$Maybe$Nothing);
                            }
                        } else return _Utils_Tuple3($elm$core$Platform$Cmd$none, _List_Nil, $elm$core$Maybe$Just(editInvoiceModel));
                    }();
                    var cmd = _v7.a;
                    var outMsg = _v7.b;
                    var newEditInvoiceModal = _v7.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        iw: newEditInvoiceModal
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg, editInvoiceCmd),
                        cmd
                    ])), outMsg);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v11 = model.lH;
                if (!_v11.$) {
                    var createPaymentModal = _v11.a;
                    var createPaymentModalResult = A3($author$project$Components$Invoice$CreatePaymentModal$update, model.Ej, subMsg, createPaymentModal);
                    var _v12 = function() {
                        var _v13 = createPaymentModalResult.adu;
                        switch(_v13){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createPaymentModalResult.zi), model.RA, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var createPaymentModal_ = _v12.a;
                    var invoice = _v12.b;
                    var cmd = _v12.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        lH: createPaymentModal_,
                        RA: invoice
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg, createPaymentModalResult.EQ),
                        cmd
                    ])), createPaymentModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var subMsg = msg.a;
                var _v14 = model.h3;
                if (!_v14.$) {
                    var createScheduledPaymentModal = _v14.a;
                    var createScheduledPaymentModalResult = A3($author$project$Components$Invoice$CreateScheduledPaymentModal$update, model.Ej, subMsg, createScheduledPaymentModal);
                    var _v15 = function() {
                        var _v16 = createScheduledPaymentModalResult.adu;
                        switch(_v16){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createScheduledPaymentModalResult.zi), model.RA, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var createScheduledPaymentModal_ = _v15.a;
                    var invoice = _v15.b;
                    var cmd = _v15.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        h3: createScheduledPaymentModal_,
                        RA: invoice
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg, createScheduledPaymentModalResult.EQ),
                        cmd
                    ])), createScheduledPaymentModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var subMsg = msg.a;
                var _v17 = model.h1;
                if (!_v17.$) {
                    var createPassthroughFeesPaymentModal = _v17.a;
                    var createPassthroughFeesPaymentModalResult = A3($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$update, model.Ej, subMsg, createPassthroughFeesPaymentModal);
                    var _v18 = function() {
                        var _v19 = createPassthroughFeesPaymentModalResult.adu;
                        switch(_v19){
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createPassthroughFeesPaymentModalResult.zi), model.RA, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var createPassthroughFeesPaymentModal_ = _v18.a;
                    var invoice = _v18.b;
                    var cmd = _v18.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        h1: createPassthroughFeesPaymentModal_,
                        RA: invoice
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg, createPassthroughFeesPaymentModalResult.EQ),
                        cmd
                    ])), createPassthroughFeesPaymentModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var subMsg = msg.a;
                var _v20 = model.hs;
                if (!_v20.$) {
                    var adjustVoidModal = _v20.a;
                    var adjustVoidModalResult = A3($author$project$Components$CustomerInvoice$AdjustVoidModal$update, model.Ej, subMsg, adjustVoidModal);
                    var _v21 = function() {
                        var _v22 = adjustVoidModalResult.adu;
                        switch(_v22){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(adjustVoidModalResult.zi), model.RA, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Api$Data$Loading, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var newAdjustVoidModal = _v21.a;
                    var invoice = _v21.b;
                    var cmd = _v21.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        hs: newAdjustVoidModal,
                        RA: invoice
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg, adjustVoidModalResult.EQ),
                        cmd
                    ])), adjustVoidModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal, model, invoice, false));
            case 7:
                var subMsg = msg.a;
                var _v23 = model.jI;
                if (!_v23.$) {
                    var processRefundModal = _v23.a;
                    var processRefundModalResult = A3($author$project$Components$CustomerInvoice$ProcessRefundModal$update, model.Ej, subMsg, processRefundModal);
                    var _v24 = function() {
                        var _v25 = processRefundModalResult.adu;
                        switch(_v25){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(processRefundModalResult.zi), model.RA, $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple3($elm$core$Maybe$Just(processRefundModalResult.zi), model.RA, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                            case 3:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.RA, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                        }
                    }();
                    var newProcessRefundModal = _v24.a;
                    var invoice = _v24.b;
                    var cmd = _v24.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        RA: invoice,
                        jI: newProcessRefundModal
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg, processRefundModalResult.EQ),
                        cmd
                    ])), processRefundModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initProcessRefundModal, model, invoice));
            case 5:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initAdjustVoidModal, model, invoice, true));
            case 8:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal, model, invoice, true, 1));
            case 12:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePaymentModal, model, invoice, false, 0));
            case 13:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreatePassthroughFeesPaymentModal, model, invoice));
            case 22:
                var charge = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$Charge$delete, model.Ej, model.RI, $author$project$Api$Provider$Charge$One$id(charge), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeDeleted), _List_Nil);
            case 23:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                return _Utils_Tuple3(_Utils_update(model, {
                    h9: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                var confirmed = msg.a;
                return confirmed ? $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$deleteInvoice(_Utils_update(model, {
                    h9: false
                })) : _Utils_Tuple3(_Utils_update(model, {
                    h9: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                return _Utils_Tuple3(_Utils_update(model, {
                    hD: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var confirmed = msg.a;
                return confirmed ? $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$markAsBadDebt(_Utils_update(model, {
                    hD: false
                })) : _Utils_Tuple3(_Utils_update(model, {
                    hD: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top({
                    V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                })), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Invoice removed')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 19:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    RA: response
                }), A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 21:
                var invoice = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    mO: true
                }), A4($author$project$Api$Provider$CustomerInvoice$issue, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$InvoiceIssued), _List_Nil);
            case 20:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    RA: response,
                    mO: false
                }), A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI), _List_fromArray([
                    $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7))
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    mO: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 36:
                var id = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    wZ: A3($elm$core$Dict$insert, id, $author$project$Api$Data$Loading, model.wZ)
                }), A3($author$project$Api$Provider$Charge$CoverageDiscount$list, model.Ej, id, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotCoverageDiscounts(id)), _List_Nil);
            case 37:
                var chargeId = msg.a;
                var response = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    wZ: A3($elm$core$Dict$insert, chargeId, response, model.wZ)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 38:
                var _v30 = model.RA;
                if (_v30.$ === 3) {
                    var invoice = _v30.a;
                    var _v31 = A6($author$project$Components$Patient$Charges$ChargeModal$init, model.Ej, model.Z$, model.W1, model.V7, invoice, $elm$core$Maybe$Nothing);
                    var modal = _v31.a;
                    var modalCmd = _v31.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fj: $elm$core$Maybe$Just(modal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, modalCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 39:
                var charge = msg.a;
                var _v32 = model.RA;
                if (_v32.$ === 3) {
                    var invoice = _v32.a;
                    var _v33 = A6($author$project$Components$Patient$Charges$ChargeModal$init, model.Ej, model.Z$, model.W1, model.V7, invoice, $elm$core$Maybe$Just(charge));
                    var modal = _v33.a;
                    var modalCmd = _v33.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fj: $elm$core$Maybe$Just(modal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, modalCmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 40:
                var subMsg = msg.a;
                var _v34 = model.fj;
                if (!_v34.$) {
                    var chargeModal = _v34.a;
                    var chargeModalResult = A3($author$project$Components$Patient$Charges$ChargeModal$update, model.Ej, subMsg, chargeModal);
                    var _v35 = function() {
                        var _v36 = chargeModalResult.adu;
                        switch(_v36.$){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(chargeModalResult.zi), $elm$core$Platform$Cmd$none);
                            case 2:
                                var shouldClose = _v36.a;
                                return shouldClose ? _Utils_Tuple2($elm$core$Maybe$Nothing, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI)) : _Utils_Tuple2($elm$core$Maybe$Just(chargeModalResult.zi), A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                            case 3:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                        }
                    }();
                    var newModalModel = _v35.a;
                    var cmd = _v35.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fj: newModalModel
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, chargeModalResult.EQ)
                    ])), chargeModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 41:
                var invoice = msg.a;
                var _v37 = A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg), A2($author$project$Components$CustomerSchedulePaymentModal$open, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), model.cP));
                var schedulePaymentModal = _v37.a;
                var schedulePaymentModalCmd = _v37.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    gG: schedulePaymentModal
                }), schedulePaymentModalCmd, _List_Nil);
            case 42:
                var subMsg = msg.a;
                var schedulePaymentResult = A3($author$project$Components$CustomerSchedulePaymentModal$update, model.Ej, subMsg, model.gG);
                var invoice = function() {
                    var _v38 = schedulePaymentResult.adu;
                    if (!_v38.$) return model.RA;
                    else {
                        var invoice_ = _v38.b;
                        return invoice_;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    RA: invoice,
                    gG: schedulePaymentResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg, schedulePaymentResult.EQ), schedulePaymentResult.at);
            case 33:
                var invoice = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$CustomerInvoice$cancelPayment, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), _List_fromArray([
                    0,
                    1
                ]), $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 43:
                var subMsg = msg.a;
                var _v39 = A2($author$project$Ui$Dropdown$update, subMsg, model.ku);
                var taxDropdown = _v39.a;
                var taxDropdownCmd = _v39.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ku: taxDropdown
                }), taxDropdownCmd, _List_Nil);
            case 44:
                var profile = msg.a;
                var fields = {
                    M4: $elm$core$Maybe$Nothing,
                    aeT: $elm$core$Maybe$Nothing,
                    VM: $elm$core$Maybe$Nothing,
                    $R: $elm$core$Maybe$Just($author$project$Api$Provider$TaxProfile$All$id(profile))
                };
                return _Utils_Tuple3(model, A5($author$project$Api$Provider$CustomerInvoice$update, model.Ej, model.RI, fields, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoiceExpands, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$GotInvoice), _List_Nil);
            case 45:
                var subMsg = msg.a;
                var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.Ej, subMsg, model.it);
                return _Utils_Tuple3(_Utils_update(model, {
                    it: downloadInvoiceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg, downloadInvoiceResult.EQ), downloadInvoiceResult.at);
            case 46:
                var subMsg = msg.a;
                var _v40 = A3($author$project$Components$CustomerEmailModal$update, model.Ej, subMsg, model.lM);
                var customerEmailModal = _v40.a;
                var subCmd = _v40.b;
                var subOutMsg = _v40.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    lM: customerEmailModal
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg, subCmd), subOutMsg);
            case 47:
                var subMsg = msg.a;
                var refreshInvoice = _Utils_Tuple2($author$project$Api$Data$Loading, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$retrieveInvoice, model.Ej, model.RI));
                var paymentsListResult = A3($author$project$Components$PaymentsList$update, model.Ej, subMsg, model.jt);
                var _v41 = function() {
                    var _v42 = paymentsListResult.adu;
                    switch(_v42){
                        case 1:
                            return refreshInvoice;
                        case 3:
                            return refreshInvoice;
                        case 2:
                            return refreshInvoice;
                        case 4:
                            return refreshInvoice;
                        default:
                            return _Utils_Tuple2(model.RA, $elm$core$Platform$Cmd$none);
                    }
                }();
                var invoice = _v41.a;
                var cmd = _v41.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    RA: invoice,
                    jt: paymentsListResult.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg, paymentsListResult.EQ),
                    cmd
                ])), paymentsListResult.at);
            case 48:
                var subMsg = msg.a;
                var _v43 = function() {
                    var _v44 = model.hB;
                    if (!_v44.$) {
                        var auditTrailLog = _v44.a;
                        var result = A3($author$project$Components$AuditTrailLog$update, model.Ej, subMsg, auditTrailLog);
                        return _Utils_Tuple3($elm$core$Maybe$Just(result.zi), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg, result.EQ), result.at);
                    } else return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
                }();
                var auditTrailLogResultModel = _v43.a;
                var auditTrailLogResultCmd = _v43.b;
                var auditTrailLogResultOutMsgs = _v43.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    hB: auditTrailLogResultModel
                }), auditTrailLogResultCmd, auditTrailLogResultOutMsgs);
            case 49:
                var charge = msg.a;
                var subMsg = msg.b;
                var _v45 = A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$updateChargeDropdown, subMsg, charge, model.hM);
                var chargesDropdowns = _v45.a;
                var dropdownCmd = _v45.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    hM: chargesDropdowns
                }), dropdownCmd, _List_Nil);
            case 50:
                var response = msg.a;
                if (response.$ === 3) {
                    var scheduledPayments = response.a;
                    var passthroughFeesCmd = function() {
                        var _v47 = _Utils_Tuple2($author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.V7), model.RA);
                        if (_v47.a && _v47.b.$ === 3) {
                            var _v48 = _v47.b;
                            var invoice = _v48.a;
                            return A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice), A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource, model.W1, invoice, model.pQ, scheduledPayments), model.V8);
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        j$: scheduledPayments
                    }), passthroughFeesCmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 52:
                var response = msg.a;
                var passthroughFeesCmd = function() {
                    var _v49 = _Utils_Tuple2($author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.V7), model.RA);
                    if (_v49.a && _v49.b.$ === 3) {
                        var _v50 = _v49.b;
                        var invoice = _v50.a;
                        return A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$fetchPassthroughFeesCmd, model.Ej, $author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice), A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSource, model.W1, invoice, response, model.j$), model.V8);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    pQ: response
                }), passthroughFeesCmd, $author$project$OutMsg$handleErrorResponse(response));
            case 51:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    pF: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 53:
                var invoice = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$initCreateScheduledPaymentModal, model, invoice));
            case 54:
                var fees = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    V4: fees
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Rr: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Api$Provider$CustomerInvoice$Shared$invoiceNumber = function(_v0) {
        var record = _v0;
        return record.RK;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$invoiceNumber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$invoiceNumber(shared);
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$issueAction = function(_v0) {
        var meta = _v0;
        return meta.tM.SB;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$Submit = {
        $: 0
    };
    var $author$project$Ui$Padding$Top_0 = 5;
    var $author$project$Ui$Form$Checkbox$ContainerAttr = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Form$Checkbox$containerAttr = function(attributes) {
        return $author$project$Ui$Form$Checkbox$ContainerAttr(attributes);
    };
    var $author$project$Api$Provider$Charge$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$Charge$One$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$type_(shared);
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$chargeSentence = F2(function(charge, canEdit) {
        var practitioner = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(name) {
            return ' with ' + name;
        }, A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$name, $author$project$Api$Provider$Charge$One$practitioner(charge))));
        var patient = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name, $author$project$Api$Provider$Charge$One$patient(charge)));
        var date = A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', $author$project$Api$Provider$Charge$One$date(charge));
        var period = function() {
            if ($author$project$Api$Provider$Charge$One$type_(charge) === 'service') return ' on ' + date;
            else {
                if (canEdit) return ' from ' + (date + ' to ');
                else {
                    var endDate = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $justinmimbs$date$Date$format('MM/dd/yyyy'), $author$project$Api$Provider$Charge$One$endDate(charge)));
                    return ' from ' + (date + (' to ' + endDate));
                }
            }
        }();
        return _Utils_ap(patient, _Utils_ap(practitioner, period));
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewChargeNameCell = function(fields) {
        var strikeOption = fields.M ? _List_fromArray([
            $author$project$Ui$Typography$strike
        ]) : _List_Nil;
        return A2($author$project$Ui$Table$cell, _List_fromArray([
            $author$project$Ui$Table$alignCenter
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$span, strikeOption, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Charge$One$name(fields.ach)))
            ]))
        ]));
    };
    var $author$project$Components$DateInput$Attr = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$DateInput$attr = function(attributes) {
        return $author$project$Components$DateInput$Attr(attributes);
    };
    var $author$project$Components$DateInput$Inline = {
        $: 8
    };
    var $author$project$Components$DateInput$inline = $author$project$Components$DateInput$Inline;
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewEndDateInput = F2(function(canEdit, fields) {
        if (canEdit && $author$project$Api$Provider$Charge$One$type_(fields.ach) === 'coverage') {
            var _v0 = fields.qx;
            if (!_v0.$) {
                var endDateInput = _v0.a;
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$EndDate), A2($author$project$Components$DateInput$view, _List_fromArray([
                        $author$project$Components$DateInput$value(fields.qv),
                        $author$project$Components$DateInput$attr(_List_fromArray([
                            A2($elm$html$Html$Attributes$style, 'width', '150px')
                        ])),
                        $author$project$Components$DateInput$inline,
                        $author$project$Components$DateInput$disabled(fields.M)
                    ]), endDateInput))
                ]));
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$DiscountOverridden = {
        $: 7
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCents = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Charge$Meta$revisableAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Y7;
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewPriceCell = F2(function(form, fields) {
        var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction($author$project$Api$Provider$Charge$One$meta(fields.ach));
        var hasDiscount = !!$author$project$Api$Provider$Charge$One$discountInCents(fields.ach) && !fields.xl;
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(fields.Br),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$PriceInCents)),
                $author$project$Ui$Form$CurrencyInput$disabled(fields.M || hasDiscount || !isRevisable),
                $author$project$Ui$Form$CurrencyInput$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
            ])),
            function() {
                if ($author$project$Api$Provider$Uom$Shared$isTimeBased(fields.Bv)) {
                    var strikeOption = fields.M ? _List_fromArray([
                        $author$project$Ui$Typography$strike
                    ]) : _List_Nil;
                    var priceUom = $author$project$Api$Provider$Charge$One$priceUom(fields.ach);
                    return A2($author$project$Ui$Typography$span, A2($elm$core$List$cons, $author$project$Ui$Typography$muted, A2($elm$core$List$cons, $author$project$Ui$Typography$pull(1), A2($elm$core$List$cons, $author$project$Ui$Typography$small, strikeOption))), _List_fromArray([
                        $elm$html$Html$text('per ' + $author$project$Api$Provider$Uom$Shared$name(priceUom))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            hasDiscount ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Remove membership rule'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$DiscountOverridden),
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$sm
                ]), _List_fromArray([
                    $elm$html$Html$text('Remove membership rule')
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Quantity = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityUom = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewQuantityCell = F2(function(form, fields) {
        var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction($author$project$Api$Provider$Charge$One$meta(fields.ach));
        var quantityInput = $author$project$Ui$Form$Input$view(_List_fromArray([
            $author$project$Ui$Form$Input$number,
            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, fields.Bu))),
            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Quantity)),
            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 1, form)),
            $author$project$Ui$Form$Input$disabled(fields.M || !isRevisable)
        ]));
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            function() {
                if ($author$project$Api$Provider$Uom$Shared$isTimeBased(fields.Bv)) {
                    var uomOptions = A2($elm$core$List$map, function(uom_) {
                        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Uom$Shared$code(uom_)), $author$project$Api$Provider$Uom$Shared$name(uom_));
                    }, $author$project$Api$Provider$Uom$list(function(d) {
                        return _Utils_update(d, {
                            HX: $elm$core$Maybe$Just('time')
                        });
                    }));
                    return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(5)
                        ]), _List_fromArray([
                            quantityInput
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(7)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$Uom$Shared$code(fields.Bv))),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$QuantityUom)),
                                $author$project$Ui$Form$Select$disabled(fields.M || !isRevisable)
                            ]), uomOptions)
                        ]))
                    ]));
                } else return quantityInput;
            }()
        ]));
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$ReturnToInventory = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewReturnToInventory = F2(function(fields, voidOnly) {
        var quantityReduced = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(quantity_) {
            return _Utils_cmp($author$project$Api$Provider$Charge$One$quantity(fields.ach), quantity_) > 0;
        }, fields.Bu));
        return $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$trackInventory(fields.ach) && (fields.M || quantityReduced) ? A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$pull(1),
            $author$project$Ui$Typography$padding(0),
            $author$project$Ui$Typography$attrs(_List_fromArray([
                A2($elm$html$Html$Attributes$style, 'display', 'inline-flex')
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(fields.eB),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$ReturnToInventory)),
                $author$project$Ui$Form$Checkbox$inline,
                $author$project$Ui$Form$Checkbox$attr(_List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'padding', '0')
                ])),
                $author$project$Ui$Form$Checkbox$disabled(voidOnly)
            ]), _List_Nil),
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Return to Inventory')
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$ChargeAdjustment$Shared$subtotalAdjustmentInCents = function(_v0) {
        var record = _v0;
        return record.$u;
    };
    var $author$project$Api$Provider$ChargeAdjustment$Preview$subtotalAdjustmentInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$ChargeAdjustment$Shared$subtotalAdjustmentInCents(shared);
    };
    var $author$project$Api$Provider$Charge$Shared$subtotalInCents = function(_v0) {
        var record = _v0;
        return record.$v;
    };
    var $author$project$Api$Provider$Charge$One$subtotalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$subtotalInCents(shared);
    };
    var $author$project$Api$Provider$Charge$Shared$taxable = function(_v0) {
        var record = _v0;
        return record.$S;
    };
    var $author$project$Api$Provider$Charge$One$taxable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$taxable(shared);
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewSubtotalCell = F3(function(adjustmentPreview, fields, voidOnly) {
        var taxLabel = $author$project$Api$Provider$Charge$One$taxable(fields.ach) ? $elm$html$Html$text(' + tax') : $author$project$Utils$Html$empty;
        var subtotalAdjustmentInCents = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeAdjustment$Preview$subtotalAdjustmentInCents, adjustmentPreview));
        var strikeOption = fields.M ? _List_fromArray([
            $author$project$Ui$Typography$strike
        ]) : _List_Nil;
        var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction($author$project$Api$Provider$Charge$One$meta(fields.ach));
        var tooltipIcon = function() {
            if (!isRevisable && !voidOnly) {
                var isChargeItemPackage = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$ChargeItem$ForCharge$isPackage, fields.lv));
                var tooltipMessage = isChargeItemPackage ? 'Packages cannot be revised on invoices.' : 'Items included in a package cannot be revised on invoices.';
                return _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$wide
                    ]), tooltipMessage, _List_fromArray([
                        $author$project$Ui$Icon$help(_List_Nil)
                    ])),
                    $author$project$Utils$Html$noBreakSpace
                ]);
            } else return _List_Nil;
        }();
        return A2($author$project$Ui$Table$cell, _List_fromArray([
            $author$project$Ui$Table$alignCenter
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, A2($elm$core$List$cons, $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight), strikeOption), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$margin(0)
                ]), !subtotalAdjustmentInCents ? _Utils_ap(tooltipIcon, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$One$subtotalInCents(fields.ach)))
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        taxLabel
                    ]))
                ])) : _Utils_ap(tooltipIcon, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$One$subtotalInCents(fields.ach)))
                    ])),
                    $author$project$Utils$Html$noBreakSpace,
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$One$subtotalInCents(fields.ach) + subtotalAdjustmentInCents))
                    ])),
                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        taxLabel
                    ]))
                ])))
            ]))
        ]));
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Void = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewVoidCell = F2(function(fields, voidOnly) {
        var isRevisable = $author$project$Api$Provider$Charge$Meta$revisableAction($author$project$Api$Provider$Charge$One$meta(fields.ach));
        return A2($author$project$Ui$Table$cell, _List_fromArray([
            $author$project$Ui$Table$alignCenter
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(fields.M),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$Void)),
                $author$project$Ui$Form$Checkbox$disabled(voidOnly || !isRevisable)
            ]), _List_Nil)
        ]));
    });
    var $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$view = function(_v0) {
        var form = _v0.PU;
        var adjustmentPreview = _v0.tS;
        var voidOnly = _v0.D_;
        var fields = $author$project$Utils$Form$fields(form);
        var canEdit = $author$project$Api$Provider$Charge$Meta$editAction($author$project$Api$Provider$Charge$One$meta(fields.ach));
        return _List_fromArray([
            A2($author$project$Ui$Table$row, _List_fromArray([
                $author$project$Ui$Table$styled(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(5),
                    $author$project$Ui$Table$alignCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$chargeSentence, fields.ach, canEdit))
                    ])),
                    A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewEndDateInput, canEdit, fields),
                    A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewReturnToInventory, fields, voidOnly)
                ]))
            ])),
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewVoidCell, fields, voidOnly),
                $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewChargeNameCell(fields),
                A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewQuantityCell, form, fields),
                A2($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewPriceCell, form, fields),
                A3($author$project$Components$CustomerInvoice$ChargeAdjustmentForm$viewSubtotalCell, adjustmentPreview, fields, voidOnly)
            ]))
        ]);
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewChargesTable = function(model) {
        var adjustmentRows = A2($elm$core$List$concatMap, function(_v0) {
            var chargeId = _v0.a;
            var form = _v0.b;
            return A2($elm$core$List$map, $author$project$Ui$Table$mapRow($author$project$Components$CustomerInvoice$AdjustmentsForm$ChargeAdjustmentFormMsg(chargeId)), $author$project$Components$CustomerInvoice$ChargeAdjustmentForm$view(form));
        }, model.W);
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A4($author$project$Ui$Panel$table, _List_fromArray([
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('There are no charges.')
                ]))
            ]), _List_fromArray([
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$containerAttr(_List_fromArray([
                            A2($elm$html$Html$Attributes$style, 'margin-top', '3px')
                        ])),
                        $author$project$Ui$Form$Checkbox$attr(_List_fromArray([
                            $author$project$Ui$Padding$toClass(5)
                        ])),
                        $author$project$Ui$Form$Checkbox$value($author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model)),
                        $author$project$Ui$Form$Checkbox$onCheck($author$project$Components$CustomerInvoice$AdjustmentsForm$VoidAll),
                        $author$project$Ui$Form$Checkbox$disabled(model.D_)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Void')
                    ]))
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(3)
                ]), _List_fromArray([
                    $elm$html$Html$text('Charge')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(3)
                ]), _List_fromArray([
                    $elm$html$Html$text('Qty')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(3)
                ]), _List_fromArray([
                    $elm$html$Html$text('Price')
                ])),
                A2($author$project$Ui$Table$header, _List_fromArray([
                    $author$project$Ui$Table$cellSpan(2),
                    $author$project$Ui$Table$textRight
                ]), _List_fromArray([
                    $elm$html$Html$text('Amount')
                ]))
            ]), adjustmentRows, _List_Nil)
        ]));
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Charges')
                ]))
            ])),
            $author$project$Components$CustomerInvoice$AdjustmentsForm$viewChargesTable(model)
        ]));
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$MemoUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewNewDue = F4(function(totalInCents, totalPayments, totalAdjustment, totalRefundedAmount) {
        if (!!totalAdjustment) {
            var newDue = A3($author$project$Components$CustomerInvoice$AdjustmentsForm$newDueAmount, totalInCents, totalPayments, totalAdjustment) + totalRefundedAmount;
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$attrs(_List_fromArray([
                            $elm$html$Html$Attributes$class('text-label-md')
                        ]))
                    ]), _List_fromArray([
                        $elm$html$Html$text('New due:')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$bold,
                            $author$project$Ui$Typography$display4
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(newDue))
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Utils$Currency$fromIntWithPlus = function(cents) {
        return cents >= 0 ? '+' + $author$project$Utils$Currency$fromInt(cents) : $author$project$Utils$Currency$fromInt(cents);
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewPayments = F2(function(totalPayments, totalAdjustment) {
        return !!totalAdjustment ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$attrs(_List_fromArray([
                        $elm$html$Html$Attributes$class('text-label-md')
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text('Payments:')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromIntWithPlus(-totalPayments))
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewRefunds = function(totalRefundedAmount) {
        return !!totalRefundedAmount ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$attrs(_List_fromArray([
                        $elm$html$Html$Attributes$class('text-label-md')
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text('New refunds:')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromIntWithPlus(totalRefundedAmount))
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewRevision = function(totalAdjustment) {
        if (!!totalAdjustment) {
            var color = totalAdjustment > 0 ? $author$project$Ui$Typography$success : $author$project$Ui$Typography$danger;
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$attrs(_List_fromArray([
                            $elm$html$Html$Attributes$class('text-label-md')
                        ]))
                    ]), _List_fromArray([
                        $elm$html$Html$text('New revision:')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$bold,
                            color
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromIntWithPlus(totalAdjustment))
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummaryContent = function(model) {
        var totalPayments = $author$project$Components$CustomerInvoice$AdjustmentsForm$totalPaymentsAmount(model.RA);
        var totalAdjustment = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $author$project$Api$Provider$InvoiceAdjustment$Preview$totalAdjustmentInCents, $author$project$Api$Data$toMaybe(model.agk)));
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$attrs(_List_fromArray([
                                $elm$html$Html$Attributes$class('text-label-md')
                            ]))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Original total:')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$bold
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.RA)))
                            ]))
                        ]))
                    ]))
                ])),
                $author$project$Components$CustomerInvoice$AdjustmentsForm$viewRevision(totalAdjustment),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                A2($author$project$Components$CustomerInvoice$AdjustmentsForm$viewPayments, totalPayments, totalAdjustment),
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                $author$project$Components$CustomerInvoice$AdjustmentsForm$viewRefunds(model.oS),
                A4($author$project$Components$CustomerInvoice$AdjustmentsForm$viewNewDue, $author$project$Api$Provider$CustomerInvoice$One$totalInCents(model.RA), totalPayments, totalAdjustment, model.oS),
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$phi(true),
                    $author$project$Ui$Form$Textarea$placeholder('Reason / memo for revision'),
                    $author$project$Ui$Form$Textarea$onInput($author$project$Components$CustomerInvoice$AdjustmentsForm$MemoUpdated),
                    $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', model.ae0))
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('This is an internal note and does not appear on the printed invoice.')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Summary')
                ]))
            ])),
            $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummaryContent(model)
        ]));
    };
    var $author$project$Components$CustomerInvoice$AdjustmentsForm$view = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(8)
            ]), _List_fromArray([
                $author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges(model)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(4)
            ]), _List_fromArray([
                $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary(model)
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$AdjustVoidModal$view = function(model) {
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$onSubmit($author$project$Components$CustomerInvoice$AdjustVoidModal$Submit)
        ]), _List_fromArray([
            A3($author$project$Ui$Modal$view, $author$project$Components$CustomerInvoice$AdjustVoidModal$Close, _List_fromArray([
                $author$project$Ui$Modal$size(3)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Create Revision')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$AdjustVoidModal$AdjustmentsFormMsg, $author$project$Components$CustomerInvoice$AdjustmentsForm$view(model.bn))
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$AdjustVoidModal$Close)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    function() {
                        var verb = model.D_ || $author$project$Components$CustomerInvoice$AdjustmentsForm$allVoided(model.bn) ? 'Void' : 'Revise';
                        return A3($author$project$Ui$Button$view, {
                            abP: verb + ' invoice'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$loading(model.km),
                            $author$project$Ui$Button$disabled($author$project$Components$CustomerInvoice$AdjustmentsForm$hasAnyValidationError(model.bn)),
                            $author$project$Ui$Button$submit
                        ]), _List_fromArray([
                            $elm$html$Html$text(verb)
                        ]));
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Api$Provider$PassthroughFee$Shared$totalInCents = function(_v0) {
        var internalRecord = _v0;
        return internalRecord.aam;
    };
    var $author$project$Api$Provider$PassthroughFee$One$totalInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PassthroughFee$Shared$totalInCents(shared);
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesTotalAmount = function(passthroughFees) {
        if (passthroughFees.$ === 3) {
            var passthrough = passthroughFees.a;
            return $author$project$Api$Provider$PassthroughFee$One$totalInCents(passthrough);
        } else return 0;
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardType = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CreatePayment = {
        $: 5
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$StoreCard = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$UpdateUseExistingSources = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardTypeOptions = _List_fromArray([
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose a card type...'),
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('debit'), 'Debit'),
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('credit'), 'Credit'),
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just('amex'), 'American Express')
    ]);
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCardReaders = function(model) {
        var _v0 = function() {
            var _v1 = model.hJ;
            if (_v1.$ === 3) {
                var cardReaders_ = _v1.a;
                return _Utils_Tuple2(cardReaders_, false);
            } else return _Utils_Tuple2(_List_Nil, true);
        }();
        var cardReaders = _v0.a;
        var cardReadersLoading = _v0.b;
        var _v2 = $author$project$Utils$Form$fields(model.PU);
        var cardReader = _v2.ace;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            !cardReadersLoading && $elm$core$List$isEmpty(cardReaders) ? A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                $elm$html$Html$text('There are no card readers available. Please '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__CardReaders, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('add a card reader')
                ])),
                $elm$html$Html$text(' now.')
            ])) : $author$project$Utils$Html$empty,
            A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderSelectMsg, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
                $author$project$Ui$Form$SearchableSelect$value(cardReader),
                $author$project$Ui$Form$SearchableSelect$placeholder('Choose Card Reader'),
                $author$project$Ui$Form$SearchableSelect$loading(cardReadersLoading),
                $author$project$Ui$Form$SearchableSelect$disabled($elm$core$List$isEmpty(cardReaders)),
                $author$project$Ui$Form$SearchableSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                $author$project$Ui$Form$SearchableSelect$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
            ]), A2($elm$core$List$map, $author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil), cardReaders), model.pO)),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$margin(20),
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('Defaulted to the last reader used on this computer. '),
                $elm$html$Html$text('Tap payments such as Apple Pay & Google Pay are not supported at this time.')
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Memo = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewMemoField = function(fields) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Memo'),
            $author$project$Ui$Form$Group$labelSpan(2),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.ae0)),
                $author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Memo))
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCents = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCentsBlur = {
        $: 2
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPayNowPanel = F2(function(fields, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Payment'),
            $author$project$Ui$Form$Group$labelSpan(2),
            $author$project$Ui$Form$Group$inputSpan(10)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$value(fields.Jh),
                        $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCents)),
                        $author$project$Ui$Form$CurrencyInput$onBlur($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$AmountInCentsBlur),
                        $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6),
                    $author$project$Ui$Grid$itemsCenter
                ]), _List_fromArray([
                    A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, model.V, fields) ? A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(' of '),
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(fields.mF)),
                            $elm$html$Html$text(' due')
                        ])),
                        $author$project$Utils$Html$noBreakSpace,
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$p0,
                            $author$project$Ui$Typography$textLeft
                        ]), _List_fromArray([
                            $elm$html$Html$text('(+ credit card fees)')
                        ]))
                    ])) : A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
                        $author$project$Ui$Typography$margin(10)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(' of '),
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(fields.mF)),
                            $elm$html$Html$text(' due')
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
        ]));
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentSources = F2(function(model, selected) {
        var selectedSourceId = A2($elm$core$Maybe$map, $author$project$Api$Source$id, selected);
        var patientSources = function() {
            var _v1 = _Utils_Tuple2(model.pQ, model.pF);
            if (_v1.a.$ === 3 && _v1.b.$ === 3) {
                var _v2 = _v1.a;
                var cards = _v2.a;
                var _v3 = _v1.b;
                var bankAccounts = _v3.a;
                return $elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, $author$project$Api$Source$createdAt, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$time$Time$posixToMillis), $elm$core$Maybe$withDefault(0))), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Source$Card, cards), A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
            } else return _List_Nil;
        }();
        var isSelectedInList = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(id) {
            return A2($elm$core$List$any, function(s) {
                return _Utils_eq($author$project$Api$Source$id(s), id);
            }, patientSources);
        }, selectedSourceId));
        var sources = function() {
            var _v0 = _Utils_Tuple2(selected, isSelectedInList);
            if (!_v0.a.$ && !_v0.b) {
                var selectedSource = _v0.a.a;
                return A2($elm$core$List$cons, selectedSource, patientSources);
            } else return patientSources;
        }();
        return A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$PaymentSourceSelectMsg, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
            $author$project$Ui$Form$SearchableSelect$value(selected),
            $author$project$Ui$Form$SearchableSelect$placeholder('Select a Source'),
            $author$project$Ui$Form$SearchableSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU)),
            $author$project$Ui$Form$SearchableSelect$errors(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
        ]), A2($elm$core$List$map, $author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil), sources), model.r1));
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesInCents = function(passthroughFees) {
        if (passthroughFees.$ === 3) {
            var passthrough = passthroughFees.a;
            return $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents(passthrough);
        } else return 0;
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentTotalModal = F2(function(subtotal, passthroughFees) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt2
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyCenter
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Payment Total')
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetSm(1),
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$p0,
                        $author$project$Ui$Typography$textLeft
                    ]), _List_fromArray([
                        $elm$html$Html$text('Subtotal')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Currency$format($author$project$Currency$fromInt(subtotal)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetSm(1),
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$p0,
                        $author$project$Ui$Typography$textLeft
                    ]), _List_fromArray([
                        $elm$html$Html$text('Credit Card Fees')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Currency$format($author$project$Currency$fromInt($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesInCents(passthroughFees))))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPayNowModal = F3(function(model, fields, amountInCentsString) {
        return _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Process Payment')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CreatePayment),
                    $author$project$Ui$Form$horizontal
                ]), $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPayNowPanel, fields, model),
                        $author$project$Utils$Html$empty,
                        $author$project$Utils$Html$empty,
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Source'),
                            $author$project$Ui$Form$Group$labelSpan(2),
                            $author$project$Ui$Form$Group$inputSpan(9)
                        ]), _List_fromArray([
                            $author$project$Api$Practice$usesCardReaders(model.W1) && !$author$project$Api$Platform$Session$One$organizationIsCompany(model.Z$) ? $author$project$Ui$Form$ButtonSelect$view({
                                afv: $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$UpdateUseExistingSources,
                                z9: _List_fromArray([
                                    A2($author$project$Ui$Form$ButtonSelect$option, true, 'Existing payment source'),
                                    A2($author$project$Ui$Form$ButtonSelect$option, false, 'Card Reader')
                                ]),
                                aa9: model.V
                            }) : $author$project$Utils$Html$empty,
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$margin(2)
                            ]), _List_Nil),
                            model.V ? A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentSources, model, fields.Hw) : $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCardReaders(model)
                        ]))
                    ]),
                    function() {
                        if (!model.V) {
                            var _v0 = function() {
                                var _v1 = model.hJ;
                                if (_v1.$ === 3) {
                                    var cardReaders_ = _v1.a;
                                    return _Utils_Tuple2(cardReaders_, false);
                                } else return _Utils_Tuple2(_List_Nil, true);
                            }();
                            var cardReaders = _v0.a;
                            var cardReadersLoading = _v0.b;
                            return _List_fromArray([
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Card Type'),
                                    $author$project$Ui$Form$Group$labelSpan(2),
                                    $author$project$Ui$Form$Group$inputSpan(9),
                                    $author$project$Ui$Form$Group$clearfix
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                        $author$project$Ui$Form$Select$value(fields.KZ),
                                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardType)),
                                        $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                                        $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 3, model.PU))
                                    ]), $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$cardTypeOptions),
                                    function() {
                                        var _v2 = fields.KZ;
                                        _v2$3: while(true){
                                            if (!_v2.$) switch(_v2.a){
                                                case 'debit':
                                                    return A3($author$project$Ui$Alert$view, 1, _List_fromArray([
                                                        $author$project$Ui$Alert$margin(20)
                                                    ]), _List_fromArray([
                                                        $elm$html$Html$text('No extra fees will be charged to the customer\'s card')
                                                    ]));
                                                case 'credit':
                                                    return A3($author$project$Ui$Alert$view, 2, _List_fromArray([
                                                        $author$project$Ui$Alert$margin(20)
                                                    ]), _List_fromArray([
                                                        $elm$html$Html$text('Credit card fees will be charged to the customer\'s card')
                                                    ]));
                                                case 'amex':
                                                    return A3($author$project$Ui$Alert$view, 2, _List_fromArray([
                                                        $author$project$Ui$Alert$margin(20)
                                                    ]), _List_fromArray([
                                                        $elm$html$Html$text('Credit card fees will be charged to the customer\'s card')
                                                    ]));
                                                default:
                                                    break _v2$3;
                                            }
                                            else break _v2$3;
                                        }
                                        return $author$project$Utils$Html$empty;
                                    }()
                                ])),
                                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Remember this card'),
                                    $author$project$Ui$Form$Group$labelSpan(2),
                                    $author$project$Ui$Form$Group$inputSpan(9)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Store card for future use')
                                    ])),
                                    !cardReadersLoading && !$elm$core$List$isEmpty(cardReaders) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                                        $author$project$Ui$Typography$gray
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Save and set this card as the default payment method for future invoices.')
                                    ])) : $author$project$Utils$Html$empty,
                                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                                        $author$project$Ui$ToggleSwitch$on(fields.CK),
                                        $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$FormUpdated, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$StoreCard))
                                    ]))
                                ]))
                            ]);
                        } else return _List_Nil;
                    }(),
                    _List_fromArray([
                        $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewMemoField(fields)
                    ])
                ]))),
                A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, model.V, fields) ? A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPaymentTotalModal, model.te, model.V4) : $author$project$Utils$Html$empty
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, model.V, fields) ? A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mb4
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$offsetSm(1),
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$p0,
                            $author$project$Ui$Typography$textLeft
                        ]), _List_fromArray([
                            $elm$html$Html$text('Total')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text($author$project$Currency$format($author$project$Currency$fromInt($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesTotalAmount(model.V4))))
                        ]))
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Process now'
                }, _List_fromArray([
                    $author$project$Ui$Button$styled(3),
                    $author$project$Ui$Button$loading(_Utils_eq(model.ag, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CreatePayment),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
                ]), _List_fromArray([
                    $elm$html$Html$text(' Process '),
                    $elm$html$Html$text(amountInCentsString),
                    $elm$html$Html$text(' Now')
                ]))
            ]))
        ]);
    });
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCreatePaymentModal = function(model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var amountInCentsString = A2($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$sourceIsACreditCard, model.V, fields) ? $author$project$Currency$format($author$project$Currency$fromInt($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$passthroughFeesTotalAmount(model.V4))) : $author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$zero, fields.Jh));
        var modalToDisplay = A3($author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewPayNowModal, model, fields, amountInCentsString);
        return A3($author$project$Ui$Modal$view, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$Close, _List_Nil, modalToDisplay);
    };
    var $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$view = function(_v0) {
        var model = _v0;
        var _v1 = _Utils_Tuple2(model.hI, model.bU);
        if (!_v1.a.$) {
            var _v2 = _v1.a.a;
            var cardReaderConnectingModal = _v2.a;
            return A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderConnectingModalMsg, $author$project$Components$CardReader$ConnectingModal$view(cardReaderConnectingModal));
        } else if (!_v1.b.$) {
            var _v3 = _v1.b.a;
            var cardReaderPaymentModal = _v3.a;
            return A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$CardReaderPaymentModalMsg, $author$project$Components$CardReader$PaymentModal$view(cardReaderPaymentModal));
        } else {
            var _v4 = _v1.a;
            var _v5 = _v1.b;
            return $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$viewCreatePaymentModal(model);
        }
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$Submit = {
        $: 0
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$Pay = {
        $: 8
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$Void = {
        $: 9
    };
    var $author$project$Api$Provider$Patient$One$hasPaymentMethod = function(_v0) {
        var record = _v0.b;
        return record.Qv;
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewAfterRefundActions = function(model) {
        var patientHasPaymentMethod = $author$project$Api$Provider$Patient$One$hasPaymentMethod(model.V7);
        return _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Void'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Void),
                $author$project$Ui$Button$loading(model.tG)
            ]), _List_fromArray([
                $elm$html$Html$text('Void')
            ])),
            patientHasPaymentMethod ? A3($author$project$Ui$Button$view, {
                abP: 'Process new payment'
            }, _List_fromArray([
                $author$project$Ui$Button$success,
                $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Pay),
                $author$project$Ui$Button$loading(model.rL),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
            ]), _List_fromArray([
                $elm$html$Html$text(' Process New Payment')
            ])) : A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top({
                V8: $author$project$Api$Provider$Patient$One$id(model.V7)
            }), _List_fromArray([
                $author$project$Ui$Link$buttonSuccess
            ]), _List_fromArray([
                $elm$html$Html$text('Add Payment Source')
            ]))
        ]);
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewFooter = F2(function(model, notRefunded) {
        return notRefunded ? _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Cancel and close modal'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$Close)
            ]), _List_fromArray([
                $elm$html$Html$text('Cancel')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Process refund'
            }, _List_fromArray([
                $author$project$Ui$Button$styled(4),
                $author$project$Ui$Button$loading(_Utils_eq(model.ev, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$disabled(!model.fV && $author$project$Components$CustomerInvoice$RefundsForm$hasAnyValidationError(model.ew)),
                $author$project$Ui$Button$submit,
                $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
            ]), _List_fromArray([
                $elm$html$Html$text('Process Refund')
            ]))
        ]) : $author$project$Components$CustomerInvoice$ProcessRefundModal$viewAfterRefundActions(model);
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$Memo = $elm$core$Basics$identity;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$MemoValidation = 0;
    var $author$project$Ui$Form$Textarea$CustomHeight = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Form$Textarea$customHeight = function(height) {
        return $author$project$Ui$Form$Textarea$CustomHeight(height);
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$passthroughFeesInCents = function(_v0) {
        var record = _v0;
        return record.V5;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$passthroughFeesInCents(shared);
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewFullRefundSection = F2(function(model, fields) {
        var feesCharged = $author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(model.RA);
        var feesChargedText = feesCharged > 0 ? ' (includes fees)' : '';
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(6)
            ]), _List_fromArray([
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', fields.ae0)),
                    $author$project$Ui$Form$Textarea$phi(true),
                    $author$project$Ui$Form$Textarea$customHeight('63px'),
                    $author$project$Ui$Form$Textarea$placeholder('Memo for revision'),
                    $author$project$Ui$Form$Textarea$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                    $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$ProcessRefundModal$FormUpdated, $elm$core$Basics$identity))
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('This is an internal note and does not appear on the printed invoice.')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(6)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Total refund' + (feesChargedText + ' :'))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanMd(6)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$p, _List_fromArray([
                                        $author$project$Ui$Typography$bold
                                    ]), _List_fromArray([
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.RA) + feesCharged))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$FormUpdated = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$formHasErrors = F2(function(model, paymentId) {
        var _v0 = A2($author$project$Components$CustomerInvoice$RefundsForm$findRefundForm, paymentId, model.ap);
        if (!_v0.$) {
            var form = _v0.a;
            return A2($author$project$Utils$Form$validationErrors, 0, form);
        } else return _List_fromArray([
            ''
        ]);
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$viewRefundablePaymentRow = F2(function(model, _v0) {
        var paymentId = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        var source = $author$project$Api$Payment$source(fields.Wk);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    function() {
                        var _v1 = $author$project$Api$Payment$paidAt(fields.Wk);
                        if (!_v1.$) {
                            var paidAt_ = _v1.a;
                            return $elm$html$Html$text(A2(model.HO, 5, paidAt_));
                        } else return $elm$html$Html$text(A2(model.HO, 5, $author$project$Api$Payment$createdAt(fields.Wk)));
                    }()
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Payment$status(fields.Wk)),
                $author$project$Api$Payment$external(fields.Wk) ? $elm$html$Html$text(' with ') : $elm$html$Html$text(' on '),
                A2($author$project$Components$PaymentSourceDisplayer$view, model.HO, _List_fromArray([
                    $author$project$Components$PaymentSourceDisplayer$source(A2($elm$core$Maybe$map, $author$project$Api$Source$Source, source)),
                    $author$project$Components$PaymentSourceDisplayer$limitedView(true),
                    $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                    $author$project$Components$PaymentSourceDisplayer$paymentProcessor($author$project$Api$Payment$paymentProcessor(fields.Wk))
                ])),
                $author$project$Api$Payment$status(fields.Wk) === 'failed' ? $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, $author$project$Api$Payment$errorMessage(fields.Wk)))) : $author$project$Utils$Html$empty,
                function() {
                    var _v2 = $author$project$Api$Payment$memo(fields.Wk);
                    if (!_v2.$) {
                        var memo = _v2.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(' - ' + memo)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(3)
            ]), _List_fromArray([
                $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$value(fields.Jh),
                    $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$CustomerInvoice$RefundsForm$FormUpdated(paymentId), $elm$core$Basics$identity)),
                    $author$project$Ui$Form$CurrencyInput$errors(A2($author$project$Components$CustomerInvoice$RefundsForm$formHasErrors, model, paymentId))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                ]), _List_fromArray([
                    _Utils_eq($author$project$Api$Payment$attemptedInCents(fields.Wk), $author$project$Api$Payment$amountInCents(fields.Wk)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$strike
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Payment$attemptedInCents(fields.Wk)))
                    ])),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('from ' + $author$project$Utils$Currency$fromInt($author$project$Api$Payment$amountInCents(fields.Wk)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$CustomerInvoice$RefundsForm$view = function(_v0) {
        var model = _v0;
        var refundRows = A2($elm$core$List$map, $author$project$Components$CustomerInvoice$RefundsForm$viewRefundablePaymentRow(model), model.ap);
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Refunds')
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    function() {
                        if (model.pp > 0) {
                            var overPaidAmount = A2($elm$core$Basics$min, $author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.RA), model.pp);
                            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Overpaid amount (with current adjustment): ')
                                ])),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(overPaidAmount))
                                ]))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                A4($author$project$Ui$Panel$table, _List_fromArray([
                    $author$project$Ui$Table$zeroState(_List_fromArray([
                        $elm$html$Html$text('There are no refunds.')
                    ]))
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_fromArray([
                        $author$project$Ui$Table$cellSpan(3)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Payment Date')
                    ])),
                    A2($author$project$Ui$Table$header, _List_fromArray([
                        $author$project$Ui$Table$cellSpan(4)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Payment Details')
                    ])),
                    A2($author$project$Ui$Table$header, _List_fromArray([
                        $author$project$Ui$Table$cellSpan(3)
                    ]), _List_fromArray([
                        $elm$html$Html$text('')
                    ])),
                    A2($author$project$Ui$Table$header, _List_fromArray([
                        $author$project$Ui$Table$cellSpan(2),
                        $author$project$Ui$Table$textRight
                    ]), _List_fromArray([
                        $elm$html$Html$text('Amount')
                    ]))
                ]), refundRows, _List_Nil),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_Nil)
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewPartialRefundSection = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(8)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg, $author$project$Components$CustomerInvoice$AdjustmentsForm$viewCharges(model.bn)),
                A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundsFormMsg, $author$project$Components$CustomerInvoice$RefundsForm$view(model.ew))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(4)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$AdjustmentsFormMsg, $author$project$Components$CustomerInvoice$AdjustmentsForm$viewSummary(model.bn))
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$Other = 2;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundAlertMessage = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _Utils_eq(model.gB, $elm$core$Maybe$Just(1)) || _Utils_eq(model.gB, $elm$core$Maybe$Just(2)) ? _List_fromArray([
                A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('By selecting an external refund method, you acknowledge that you are responsible for refunding the patient outside of this platform.')
                    ]))
                ]))
            ]) : _List_fromArray([
                $author$project$Utils$Html$empty
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundConfirmation = function(model) {
        var refundAmount = function() {
            var _v0 = model.ev;
            if (_v0.$ === 3) {
                var refund = _v0.a;
                return $author$project$Api$Provider$Refund$One$amountInCents(refund);
            } else return 0;
        }();
        var name = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$name, $author$project$Api$Provider$CustomerInvoice$One$owner(model.RA)));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You have successfully recorded a refund of ')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(refundAmount))
                    ])),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' to ')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text(name)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Previous due:')
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$margin(2),
                                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$bold
                                        ]), _List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.RA)))
                                        ]))
                                    ]))
                                ]))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                                $author$project$Ui$HorizontalRule$thin
                            ])),
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Current due:')
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$justifyRight
                                    ]), _List_fromArray([
                                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(refundAmount))
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundFailedMessage = function(model) {
        var maybePatient = $author$project$Api$Provider$CustomerInvoice$One$owner(model.RA);
        var name = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$name, maybePatient));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('A refund of ')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$paidInCents(model.RA)))
                    ])),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' to ')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text(name)
                    ])),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' failed to process ')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$OriginalSource = 0;
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundMethod = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(7)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Refund method')
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('How do you want to issue a refund?')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(5),
                $author$project$Ui$Grid$justifyRight
            ]), function() {
                var _v0 = model.gB;
                if (!_v0.$) {
                    var refundType = _v0.a;
                    var refundablePayments = A2($elm$core$List$filter, function(payment) {
                        return !$author$project$Api$Payment$external(payment);
                    }, A2($elm$core$List$filter, $author$project$Api$Payment$isRefundableOnPaymentProcessor, model.Wt));
                    return _List_fromArray([
                        $author$project$Ui$Button$group(_List_fromArray([
                            function() {
                                if (!$elm$core$List$isEmpty(refundablePayments)) {
                                    var originalSourceName = function() {
                                        if ($elm$core$List$length(refundablePayments) > 1) return 'Original Souce';
                                        else {
                                            var firstSource = A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Payment$source, $elm$core$List$head(refundablePayments)));
                                            if (!firstSource.$) {
                                                var source = firstSource.a;
                                                var nameSource = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$Source$Shared$name(source));
                                                var lastFour = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$Source$Shared$lastFour(source));
                                                return nameSource + (' *' + lastFour);
                                            } else return '';
                                        }
                                    }();
                                    return A3($author$project$Ui$Button$view, {
                                        abP: 'Select original source ' + originalSourceName
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$active(!refundType),
                                        $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(0))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(originalSourceName)
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Select check'
                            }, _List_fromArray([
                                $author$project$Ui$Button$active(refundType === 1),
                                $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(1))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Check')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Select other'
                            }, _List_fromArray([
                                $author$project$Ui$Button$active(refundType === 2),
                                $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(2))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Other')
                            ]))
                        ]))
                    ]);
                } else return _List_fromArray([
                    $author$project$Ui$Button$group(_List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Change refund method'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$RefundTypeUpdated(0))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Change refund method')
                        ]))
                    ]))
                ]);
            }())
        ]));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Payment$Shared$passthroughFees = function(_v0) {
        var record = _v0;
        return record.V4;
    };
    var $author$project$Api$Provider$Payment$One$passthroughFees = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$passthroughFees(shared);
    };
    var $author$project$Api$Provider$Payment$SharedWithRefunds$passthroughFees = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Payment$Shared$passthroughFees(shared);
    };
    var $author$project$Api$Payment$passthroughFees = function(payment) {
        switch(payment.$){
            case 1:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$One$passthroughFees(payment_);
            case 0:
                var payment_ = payment.a;
                return $author$project$Api$Provider$Payment$SharedWithRefunds$passthroughFees(payment_);
            default:
                return false;
        }
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$thereIsAtLeastOnePaymentWithPassthroughFees = function(payments) {
        return function(paymentWithPassthroughFees) {
            return !_Utils_eq(paymentWithPassthroughFees, $elm$core$Maybe$Nothing);
        }(A2($elm_community$list_extra$List$Extra$find, function(payment) {
            return $author$project$Api$Payment$passthroughFees(payment);
        }, payments));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundType = function(model) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(7)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$label, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Refund type')
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('Do you want to issue a full or partial refund?')
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(5),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Select partial refund'
                    }, _List_fromArray([
                        $author$project$Ui$Button$active(!model.fV),
                        $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType(false)),
                        $author$project$Ui$Button$disabled($author$project$Components$CustomerInvoice$ProcessRefundModal$thereIsAtLeastOnePaymentWithPassthroughFees(model.Wt))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Partial refund')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Select full refund'
                    }, _List_fromArray([
                        $author$project$Ui$Button$active(model.fV),
                        $author$project$Ui$Button$onClick($author$project$Components$CustomerInvoice$ProcessRefundModal$ToggledRefundType(true))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Full refund')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundBody = F3(function(model, refundStatus, notRefunded) {
        return notRefunded ? _List_fromArray([
            refundStatus === 'failed' ? $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundFailedMessage(model) : $author$project$Utils$Html$empty,
            $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundType(model),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundMethod(model),
            $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundAlertMessage(model),
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            model.fV ? A2($author$project$Components$CustomerInvoice$ProcessRefundModal$viewFullRefundSection, model, $author$project$Utils$Form$fields(model.PU)) : $author$project$Components$CustomerInvoice$ProcessRefundModal$viewPartialRefundSection(model)
        ]) : _List_fromArray([
            $author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundConfirmation(model)
        ]);
    });
    var $author$project$Components$CustomerInvoice$ProcessRefundModal$view = function(model) {
        var _v0 = model.lH;
        if (!_v0.$) {
            var createPaymentModal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Components$CustomerInvoice$ProcessRefundModal$CreatePaymentModalMsg, $author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
        } else {
            var refundStatus = function() {
                var _v1 = model.ev;
                switch(_v1.$){
                    case 3:
                        var refund_ = _v1.a;
                        return $author$project$Api$Provider$Refund$One$status(refund_);
                    case 2:
                        return 'failed';
                    default:
                        return '';
                }
            }();
            var notRefunded = refundStatus !== 'successful' && refundStatus !== 'waiting_for_processor' || _Utils_eq(model.ev, $author$project$Api$Data$NotAsked);
            return A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$noValidate(true),
                $author$project$Ui$Form$autocomplete(false),
                $author$project$Ui$Form$horizontal,
                $author$project$Ui$Form$onSubmit($author$project$Components$CustomerInvoice$ProcessRefundModal$Submit)
            ]), _List_fromArray([
                A3($author$project$Ui$Modal$view, $author$project$Components$CustomerInvoice$ProcessRefundModal$Close, _List_fromArray([
                    $author$project$Ui$Modal$size(3)
                ]), _List_fromArray([
                    $author$project$Ui$Modal$header(_List_fromArray([
                        $author$project$Ui$Modal$title('Process Refund')
                    ])),
                    $author$project$Ui$Modal$body(A3($author$project$Components$CustomerInvoice$ProcessRefundModal$viewRefundBody, model, refundStatus, notRefunded)),
                    $author$project$Ui$Modal$footer(A2($author$project$Components$CustomerInvoice$ProcessRefundModal$viewFooter, model, notRefunded))
                ]))
            ]));
        }
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewClicked = {
        $: 1
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked = {
        $: 7
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsAmountInCents = function(scheduledPaymentsForm) {
        return $elm$core$List$sum(A2($elm$core$List$map, function(scheduledPayment) {
            return scheduledPayment.Yz ? 0 : !_Utils_eq($author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment), $elm$core$Maybe$Nothing) ? 0 : A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, scheduledPayment.Jh));
        }, scheduledPaymentsForm));
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsPassthroughFeesInCents = function(scheduledPaymentsForm) {
        return $elm$core$List$sum(A2($elm$core$List$map, function(scheduledPayment) {
            return scheduledPayment.Yz ? 0 : !_Utils_eq($author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment), $elm$core$Maybe$Nothing) ? 0 : A2($elm$core$Maybe$withDefault, 0, scheduledPayment.V5);
        }, scheduledPaymentsForm));
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewErrorBox = F3(function(fields, scheduledAmountInCents, amountInCentsString) {
        var hasCombinationErrors = $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields);
        var errorHtml = function() {
            var _v0 = _Utils_Tuple2(_Utils_cmp(scheduledAmountInCents, fields.mF) > 0, hasCombinationErrors);
            if (_v0.a) return _List_fromArray([
                $elm$html$Html$text('The total scheduled payments amount '),
                $elm$html$Html$text(amountInCentsString),
                $elm$html$Html$text(' exceeds the total amount due '),
                $elm$html$Html$text($author$project$Utils$Currency$fromInt(fields.mF)),
                $elm$html$Html$text('. Please adjust one of the payments to a lower amount.')
            ]);
            else {
                if (_v0.b) return _List_fromArray([
                    $elm$html$Html$text(' '),
                    $elm$html$Html$text('The same source can not be used for more than single scheduled payment per day.'),
                    $elm$html$Html$text(' ')
                ]);
                else return _List_Nil;
            }
        }();
        return $elm$core$List$isEmpty(errorHtml) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Alert$view, 3, _List_fromArray([
                $author$project$Ui$Alert$margin(25),
                $author$project$Ui$Alert$icon(59),
                $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$black,
                    $author$project$Ui$Typography$fontWeight(1),
                    $author$project$Ui$Typography$margin(25)
                ]), errorHtml)
            ])),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$margin(2)
            ]), _List_Nil)
        ]));
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewProcessedPayment = F2(function(timeFormatter, scheduledPayment) {
        var humanStatus = function() {
            var _v5 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
            if (!_v5.$) {
                var payment_ = _v5.a;
                return $author$project$Api$Provider$Payment$One$status(payment_);
            } else return $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment);
        }();
        var _v0 = function() {
            var _v1 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment);
            if (!_v1.$) {
                var source = _v1.a;
                return _Utils_Tuple2($elm$html$Html$text('on '), A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                    $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just($author$project$Api$Source$Source(source))),
                    $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                    $author$project$Components$PaymentSourceDisplayer$limitedView(true)
                ])));
            } else return _Utils_Tuple2($elm$html$Html$text('No payment info'), $author$project$Utils$Html$empty);
        }();
        var paymentInfoText = _v0.a;
        var paymentInfoHtml = _v0.b;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$justifyLeft
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$justifyCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, humanStatus),
                    $elm$html$Html$text(' '),
                    paymentInfoText,
                    paymentInfoHtml,
                    function() {
                        var _v2 = $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment);
                        if (!_v2.$) {
                            var memo = _v2.a;
                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text(' - ' + memo)
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                function() {
                    var _v3 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
                    if (!_v3.$) {
                        var payment = _v3.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$createdBy
                        ]), _List_fromArray([
                            $elm$html$Html$text('Created by '),
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'this platform', A2($elm$core$Maybe$map, $author$project$Api$Provider$Payment$Creator$displayName, $author$project$Api$Provider$Payment$One$createdBy(payment)))),
                            $elm$html$Html$text(' on '),
                            $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Provider$Payment$One$createdAt(payment)))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$justifyRight
            ]), function() {
                var _v4 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
                if (!_v4.$) {
                    var payment = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                        ]), _List_fromArray([
                            _Utils_eq($author$project$Api$Provider$Payment$One$attemptedInCents(payment), $author$project$Api$Provider$Payment$One$amountInCents(payment)) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$strike
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Payment$One$attemptedInCents(payment)))
                            ])),
                            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Payment$One$amountInCents(payment)))
                            ]))
                        ]))
                    ]);
                } else return _List_fromArray([
                    $author$project$Utils$Html$empty
                ]);
            }())
        ]));
    });
    var $author$project$Ui$Table$rowspan = $author$project$Ui$Table$Rowspan;
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsBlur = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsFieldUpdated = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewAmount = F2(function(scheduledPayment, form) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(scheduledPayment.Jh),
                $author$project$Ui$Form$CurrencyInput$disabled($author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated, $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsFieldUpdated(scheduledPayment.yc))),
                $author$project$Ui$Form$CurrencyInput$onBlur($author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsBlur(scheduledPayment.yc)),
                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(scheduledPayment.yc), form)),
                $author$project$Ui$Form$CurrencyInput$errors(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Invoice$CreateScheduledPaymentModal$AmountInCentsValidation(scheduledPayment.yc), form))
            ]))
        ]));
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$DeleteFieldUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewDestroy = function(scheduledPayment) {
        return $author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Remove scheduled payment'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$size(0),
                $author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated($author$project$Components$Invoice$CreateScheduledPaymentModal$DeleteFieldUpdated(scheduledPayment.yc))),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_Nil)
        ]));
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$MemoFieldUpdated = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewMemo = function(scheduledPayment) {
        return A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', scheduledPayment.ae0)),
                $author$project$Ui$Form$Input$disabled($author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
                $author$project$Ui$Form$Input$placeholder('Additional notes about this payment'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Invoice$CreateScheduledPaymentModal$FormUpdated, $author$project$Components$Invoice$CreateScheduledPaymentModal$MemoFieldUpdated(scheduledPayment.yc)))
            ]))
        ]));
    };
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSource = F2(function(model, scheduledPayment) {
        return A2($elm$html$Html$map, $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceSelected(scheduledPayment.yc), A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
            $author$project$Ui$Form$SearchableSelect$value(scheduledPayment.Wr),
            $author$project$Ui$Form$SearchableSelect$placeholder('Select a Source'),
            $author$project$Ui$Form$SearchableSelect$disabled($author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
            $author$project$Ui$Form$SearchableSelect$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(scheduledPayment.yc), model.PU)),
            $author$project$Ui$Form$SearchableSelect$errors(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Invoice$CreateScheduledPaymentModal$PaymentSourceValidation(scheduledPayment.yc), model.PU))
        ]), A2($elm$core$List$map, $author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil), $author$project$Components$Invoice$CreateScheduledPaymentModal$patientSources(model)), scheduledPayment.r1));
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduleOn = F2(function(model, scheduledPayment) {
        return A2($elm$html$Html$map, A2($author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnSelected, scheduledPayment.yc, scheduledPayment.n9), A2($author$project$Components$DateInput$view, _List_fromArray([
            $author$project$Components$DateInput$value(scheduledPayment.ag7),
            $author$project$Components$DateInput$disabled($author$project$Components$Invoice$CreateScheduledPaymentModal$isScheduledPaymentDisabled(scheduledPayment)),
            $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(scheduledPayment.yc), model.PU)),
            $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, $author$project$Components$Invoice$CreateScheduledPaymentModal$ScheduledOnValidation(scheduledPayment.yc), model.PU)),
            $author$project$Components$DateInput$disabledPickerDates(function(date) {
                return A2($author$project$Utils$Date$isBefore, date, model.aae);
            })
        ]), scheduledPayment.n9));
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPayment = F2(function(scheduledPayment, model) {
        return scheduledPayment.Yz ? _List_Nil : _List_fromArray([
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduleOn, model, scheduledPayment)
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewPaymentSource, model, scheduledPayment)
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewAmount, scheduledPayment, model.PU)
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(5),
                    $author$project$Ui$Table$alignCenter,
                    $author$project$Ui$Table$rowspan(2)
                ]), _List_fromArray([
                    $author$project$Components$Invoice$CreateScheduledPaymentModal$viewDestroy(scheduledPayment)
                ]))
            ])),
            A2($author$project$Ui$Table$row, _List_fromArray([
                $author$project$Ui$Table$noBorder
            ]), _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(3)
                ]), _List_fromArray([
                    $author$project$Components$Invoice$CreateScheduledPaymentModal$viewMemo(scheduledPayment)
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPaymentsTable = F2(function(model, fields) {
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$loading(model.c_),
            $author$project$Ui$Table$containerClasses(_List_fromArray([
                'table-wrapper-overflow-visible'
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Date')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Source')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(1)
            ]), _List_fromArray([
                $elm$html$Html$text('')
            ]))
        ]), A2($elm$core$List$concatMap, function(scheduledPayment) {
            var _v0 = _Utils_Tuple2(scheduledPayment.nf, $author$project$Components$Invoice$CreateScheduledPaymentModal$existingPayment(scheduledPayment));
            if (!_v0.a.$ && !_v0.b.$) {
                var originalscheduledPayment_ = _v0.a.a;
                return _List_fromArray([
                    A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Table$cell, _List_fromArray([
                            $author$project$Ui$Table$colspan(3)
                        ]), _List_fromArray([
                            A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewProcessedPayment, model.HO, originalscheduledPayment_)
                        ]))
                    ]))
                ]);
            } else return A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPayment, scheduledPayment, model);
        }, fields.j), _List_Nil);
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$viewWarningBox = F2(function(fields, amountInCentsString) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Alert$view, 2, _List_fromArray([
                $author$project$Ui$Alert$margin(25),
                $author$project$Ui$Alert$icon(64),
                $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$black,
                    $author$project$Ui$Typography$fontWeight(1),
                    $author$project$Ui$Typography$margin(25)
                ]), _List_fromArray([
                    $elm$html$Html$text('The total scheduled payments amount '),
                    $elm$html$Html$text(amountInCentsString),
                    $elm$html$Html$text(' is less than the total amount due '),
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(fields.mF)),
                    $elm$html$Html$text('.')
                ]))
            ])),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$margin(2)
            ]), _List_Nil)
        ]));
    });
    var $author$project$Components$Invoice$CreateScheduledPaymentModal$view = function(_v0) {
        var model = _v0;
        var fields = $author$project$Utils$Form$fields(model.PU);
        var _v1 = $author$project$Utils$Form$fields(model.PU);
        var scheduledPaymentsForm = _v1.j;
        var scheduledAmountInCents = $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsAmountInCents(scheduledPaymentsForm);
        var amountInCentsString = $author$project$Currency$format($author$project$Currency$fromInt(scheduledAmountInCents));
        var disableSaveButton = !$author$project$Utils$Form$dirty(model.PU) || _Utils_cmp(scheduledAmountInCents, fields.mF) > 0 || $author$project$Components$Invoice$CreateScheduledPaymentModal$hasScheduledOnPaymentSourceCombinedErrors(fields);
        var totalPassthroughFees = model._c ? $author$project$Components$Invoice$CreateScheduledPaymentModal$sumScheduledPaymentsPassthroughFeesInCents(scheduledPaymentsForm) : 0;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Invoice$CreateScheduledPaymentModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Scheduled Payment(s)')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked),
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewScheduledPaymentsTable, model, fields),
                        !!scheduledAmountInCents && _Utils_cmp(scheduledAmountInCents, fields.mF) < 0 ? A2($author$project$Components$Invoice$CreateScheduledPaymentModal$viewWarningBox, fields, amountInCentsString) : $author$project$Utils$Html$empty,
                        A3($author$project$Components$Invoice$CreateScheduledPaymentModal$viewErrorBox, fields, scheduledAmountInCents, amountInCentsString),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$margin(2)
                        ]), _List_Nil),
                        A2($author$project$Ui$Grid$row, _List_fromArray([
                            $author$project$Ui$Grid$rowItemsCenter
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(4)
                            ]), _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Add another payment'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$AddNewClicked)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$wrapWord),
                                        $author$project$Ui$Typography$preWrap
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Add Another Payment')
                                    ]))
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(1)
                            ]), _List_fromArray([
                                $author$project$Utils$Html$empty
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(7)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(12)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Total'),
                                            $author$project$Ui$Form$Group$labelSpan(6),
                                            $author$project$Ui$Form$Group$inputSpan(6)
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                                    $author$project$Ui$Typography$bold
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text(amountInCentsString)
                                                ])),
                                                $elm$html$Html$text(' of '),
                                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                                    $author$project$Ui$Typography$bold
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(fields.mF))
                                                ])),
                                                $elm$html$Html$text(' due')
                                            ]))
                                        ]))
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(12)
                                    ]), _List_fromArray([
                                        totalPassthroughFees > 0 ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                            $author$project$Ui$Form$Group$label('Total Credit Card Fees'),
                                            $author$project$Ui$Form$Group$labelSpan(6),
                                            $author$project$Ui$Form$Group$inputSpan(6)
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                                    $author$project$Ui$Typography$bold
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(totalPassthroughFees))
                                                ]))
                                            ]))
                                        ])) : $author$project$Utils$Html$empty
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                $author$project$Utils$Html$empty,
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Schedule paymnets'
                }, _List_fromArray([
                    $author$project$Ui$Button$styled(3),
                    $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Invoice$CreateScheduledPaymentModal$SaveScheduledPaymentsClicked),
                    $author$project$Ui$Button$disabled(disableSaveButton),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
                ]), _List_fromArray([
                    $elm$html$Html$text(' Schedule Payments ')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Patient$Charges$ChargeModal$SaveAndAddAnotherClicked = {
        $: 2
    };
    var $author$project$Components$Patient$Charges$ChargeModal$SaveClicked = {
        $: 1
    };
    var $author$project$Api$Provider$Charge$Meta$categoryEditable = function(_v0) {
        var meta = _v0;
        return meta.EL.Ot;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip = F2(function(disabled, contents) {
        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$active(disabled)
        ]), 'To change the item, price, or quantity you must revise the invoice.', contents);
    });
    var $author$project$Components$Patient$Charges$ChargeModal$viewCategoryFormGroup = F2(function(form, meta) {
        var canEdit = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$categoryEditable, meta));
        var _v0 = $author$project$Utils$Form$fields(form);
        var categoryResourceFilter = _v0.cK;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Category'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEdit, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Patient$Charges$ChargeModal$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(0),
                    $author$project$Components$ResourceFilter$disabled(!canEdit)
                ]), categoryResourceFilter))
            ]))
        ]));
    });
    var $author$project$Api$Provider$Charge$Meta$nameEditable = function(_v0) {
        var meta = _v0;
        return meta.zr.Ot;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewChargeFormGroup = F2(function(form, meta) {
        var canEdit = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$nameEditable, meta));
        var _v0 = $author$project$Utils$Form$fields(form);
        var chargeItemResourceFilter = _v0.cL;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Item'),
            $author$project$Ui$Form$Group$required(canEdit),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEdit, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Patient$Charges$ChargeModal$ChargeItemResourceFilterMsg, A2($author$project$Components$ResourceFilter$ChargeItem$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(0),
                    $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, form)),
                    $author$project$Components$ResourceFilter$disabled(!canEdit)
                ]), chargeItemResourceFilter))
            ]))
        ]));
    });
    var $author$project$Api$Provider$Charge$Meta$dateEditable = function(_v0) {
        var meta = _v0;
        return meta.M4.Ot;
    };
    var $author$project$Api$Provider$Charge$Meta$endDateEditable = function(_v0) {
        var meta = _v0;
        return meta.qv.Ot;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$isTimeBased = function(uom) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq('time'), A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$unitClass, uom)));
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewDatesFormGroup = F2(function(form, meta) {
        var canEditDate = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$dateEditable, meta));
        var _v0 = $author$project$Utils$Form$fields(form);
        var startDate = _v0._0;
        var startDateInput = _v0.kj;
        var endDate = _v0.qv;
        var endDateInput = _v0.qx;
        var quantityUom = _v0.Bv;
        var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(timeBased ? 'Dates' : 'Date'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEditDate, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Patient$Charges$ChargeModal$StartDateInputMsg(startDateInput), A2($author$project$Components$DateInput$view, _List_fromArray([
                            $author$project$Components$DateInput$value(startDate),
                            $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, form)),
                            $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 4, form)),
                            $author$project$Components$DateInput$disabled(!canEditDate)
                        ]), startDateInput))
                    ]))
                ])),
                function() {
                    if (timeBased) {
                        var canEditEndDate = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$endDateEditable, meta));
                        return A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEditEndDate, _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Components$Patient$Charges$ChargeModal$EndDateInputMsg(endDateInput), A2($author$project$Components$DateInput$view, _List_fromArray([
                                    $author$project$Components$DateInput$value(endDate),
                                    $author$project$Components$DateInput$disabled(!canEditEndDate)
                                ]), endDateInput))
                            ]))
                        ]));
                    } else return $author$project$Ui$Grid$none;
                }()
            ]))
        ]));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$Description = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$FormUpdated = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$Charge$Meta$descriptionEditable = function(_v0) {
        var meta = _v0;
        return meta.NQ.Ot;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewDescriptionFormGroup = F2(function(form, meta) {
        var canEdit = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$descriptionEditable, meta));
        var _v0 = $author$project$Utils$Form$fields(form);
        var description = _v0.NQ;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Description'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEdit, _List_fromArray([
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$value(description),
                    $author$project$Ui$Form$Textarea$placeholder('e.g. Examination'),
                    $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$Description)),
                    $author$project$Ui$Form$Textarea$disabled(!canEdit)
                ]))
            ]))
        ]));
    });
    var $author$project$Api$Provider$Charge$Meta$locationEditable = function(_v0) {
        var meta = _v0;
        return meta.aeT.Ot;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewLocationFormGroup = F2(function(form, meta) {
        var canEdit = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$locationEditable, meta));
        var _v0 = $author$project$Utils$Form$fields(form);
        var locationResourceFilter = _v0.ro;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Location'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEdit, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Patient$Charges$ChargeModal$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(0),
                    $author$project$Components$ResourceFilter$disabled(!canEdit)
                ]), locationResourceFilter))
            ]))
        ]));
    });
    var $author$project$Api$Provider$Charge$Meta$patientEditable = function(_v0) {
        var meta = _v0;
        return meta.V7.Ot;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewPatientFormGroup = F2(function(form, meta) {
        var canEdit = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$patientEditable, meta));
        var _v0 = $author$project$Utils$Form$fields(form);
        var limitedPatientSelector = _v0.rg;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Patient'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEdit, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Patient$Charges$ChargeModal$LimitedPatientSelectorMsg, A2($author$project$Components$LimitedPatientSelector$view, _List_fromArray([
                    $author$project$Components$LimitedPatientSelector$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Components$LimitedPatientSelector$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]), limitedPatientSelector))
            ]))
        ]));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewPriceFormGroup = F2(function(model, meta) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var priceInCents = _v0.Br;
        var quantityUom = _v0.Bv;
        var priceUom = _v0.Xn;
        var discountOverridden = _v0.N0;
        var chargeItem = _v0.lv;
        var chargeItemPriceEditable = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Basics$not, function($) {
            return $.aeE;
        }), chargeItem));
        var priceEditableByChargeItem = A2($elm$core$Maybe$withDefault, chargeItemPriceEditable, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
        var canEdit = priceEditableByChargeItem;
        var discountNotRemoved = function() {
            var _v2 = $author$project$Api$Data$toMaybe(model.agk);
            if (!_v2.$) {
                var preview = _v2.a;
                return !discountOverridden && !!$author$project$Api$Provider$Charge$Calculate$discountInCents(preview);
            } else return false;
        }();
        var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Price'),
            $author$project$Ui$Form$Group$required(canEdit),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEdit, _List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$view(_Utils_ap(function() {
                            var _v1 = _Utils_Tuple2(timeBased, A2($elm$core$Maybe$map, $elm$core$String$toLower, A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$name, priceUom)));
                            if (_v1.a && !_v1.b.$) {
                                var name = _v1.b.a;
                                return _List_fromArray([
                                    $author$project$Ui$Form$CurrencyInput$postfix('per ' + name)
                                ]);
                            } else return _List_Nil;
                        }(), _List_fromArray([
                            $author$project$Ui$Form$CurrencyInput$value(priceInCents),
                            $author$project$Ui$Form$CurrencyInput$placeholder('e.g. 50.00'),
                            $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$PriceInCents)),
                            $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                            $author$project$Ui$Form$CurrencyInput$disabled(!canEdit || discountNotRemoved)
                        ]))),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 3, model.PU)),
                        discountNotRemoved ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Remove membership rule'
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$FormUpdated($author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden(true)))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Remove membership rule')
                            ]))
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Amounts can be negative')
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Api$Provider$Charge$Meta$practitionerEditable = function(_v0) {
        var meta = _v0;
        return meta.agi.Ot;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewProviderFormGroup = F2(function(form, meta) {
        var canEdit = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$practitionerEditable, meta));
        var _v0 = $author$project$Utils$Form$fields(form);
        var practitionerResourceFilter = _v0.jE;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Provider'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEdit, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Patient$Charges$ChargeModal$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(0),
                    $author$project$Components$ResourceFilter$disabled(!canEdit)
                ]), practitionerResourceFilter))
            ]))
        ]));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$Quantity = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Patient$Charges$ChargeModal$QuantityUom = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Charge$Meta$quantityEditable = function(_v0) {
        var meta = _v0;
        return meta.Bu.Ot;
    };
    var $author$project$Api$Provider$Charge$Meta$quantityUomEditable = function(_v0) {
        var meta = _v0;
        return meta.Bv.Ot;
    };
    var $author$project$Components$Patient$Charges$ChargeModal$uomOptions = A2($elm$core$List$map, function(uom_) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Uom$Shared$code(uom_)), $author$project$Api$Provider$Uom$Shared$name(uom_));
    }, $author$project$Api$Provider$Uom$list(function(d) {
        return _Utils_update(d, {
            HX: $elm$core$Maybe$Just('time')
        });
    }));
    var $author$project$Components$Patient$Charges$ChargeModal$viewQuantityFormGroup = F2(function(form, meta) {
        var canEditQuantity = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$quantityEditable, meta));
        var _v0 = $author$project$Utils$Form$fields(form);
        var quantity = _v0.Bu;
        var quantityUom = _v0.Bv;
        var chargeItem = _v0.lv;
        var timeBased = $author$project$Components$Patient$Charges$ChargeModal$isTimeBased(quantityUom);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('QTY'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9),
            $author$project$Ui$Form$Group$required(canEditQuantity)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEditQuantity, _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$number,
                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, quantity))),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$Quantity)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                            $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, form)),
                            $author$project$Ui$Form$Input$disabled(!canEditQuantity)
                        ]))
                    ]))
                ])),
                function() {
                    if (timeBased) {
                        var canEditQuantityUom = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$quantityUomEditable, meta));
                        return A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($author$project$Components$Patient$Charges$ChargeModal$withDisabledTooltip, !canEditQuantityUom, _List_fromArray([
                                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$Provider$Uom$Shared$code, quantityUom)),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Patient$Charges$ChargeModal$FormUpdated, $author$project$Components$Patient$Charges$ChargeModal$QuantityUom)),
                                    $author$project$Ui$Form$Select$disabled(!canEditQuantityUom)
                                ]), $author$project$Components$Patient$Charges$ChargeModal$uomOptions)
                            ]))
                        ]));
                    } else return $author$project$Ui$Grid$none;
                }()
            ])),
            A2($author$project$Components$InventoryWarning$view, A2($elm$core$Maybe$map, function(item) {
                return {
                    I0: item.I0,
                    XT: item.XT,
                    aap: item.aap
                };
            }, chargeItem), quantity)
        ]));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$ToggleAdditionalDetails = {
        $: 17
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewShowAdditionalDetails = function(showAdditionalDetails) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(''),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            function() {
                var _v0 = showAdditionalDetails ? _Utils_Tuple2('Hide additional charge details', $author$project$Ui$Icon$chevron(_List_fromArray([
                    $author$project$Ui$Icon$rotate180
                ]))) : _Utils_Tuple2('See additional charge details', $author$project$Ui$Icon$chevronDown(_List_Nil));
                var label = _v0.a;
                var icon = _v0.b;
                return A3($author$project$Ui$Button$view, {
                    abP: label
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$ToggleAdditionalDetails)
                ]), _List_fromArray([
                    $elm$html$Html$text(label),
                    $author$project$Utils$Html$noBreakSpace,
                    icon
                ]));
            }()
        ]));
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewDiscount = F3(function(_v0, meta, preview) {
        var form = _v0.PU;
        var canEdit = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$Meta$priceInCentsEditable, meta));
        var _v1 = $author$project$Utils$Form$fields(form);
        var discountOverridden = _v1.N0;
        var chargeItem = _v1.lv;
        var discountRemoved = discountOverridden && !$author$project$Api$Provider$Charge$Calculate$discountInCents(preview);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            !$elm$core$List$isEmpty($author$project$Api$Provider$Charge$Calculate$coveredCharges(preview)) ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Total without membership: '),
                $author$project$Components$Invoice$ChargeDiscount$view(preview)
            ])) : $author$project$Utils$Html$empty,
            discountRemoved ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Membership rule was removed')
            ])) : $author$project$Utils$Html$empty,
            canEdit && discountRemoved && $author$project$Utils$Maybe$toBool(chargeItem) ? A3($author$project$Ui$Button$view, {
                abP: 'Revert to original'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$FormUpdated($author$project$Components$Patient$Charges$ChargeModal$DiscountOverridden(false)))
            ]), _List_fromArray([
                $elm$html$Html$text('Revert to original')
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$viewTotalFormGroup = F2(function(model, meta) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Total'),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, function() {
                var _v0 = _Utils_Tuple2(model.vX, model.agk);
                if (!_v0.a) return _List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$display4
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$subtotalInCents, model.ach))))
                    ]))
                ]);
                else switch(_v0.b.$){
                    case 3:
                        var _v1 = _v0.b;
                        var preview = _v1.a;
                        var total = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$Calculate$subtotalInCents(preview));
                        var routingWarning = A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($author$project$Components$ChargeRoutingWarning$viewWithChargeCalculate, 0, preview));
                        var discountInfo = A3($author$project$Components$Patient$Charges$ChargeModal$viewDiscount, model, meta, preview);
                        return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$display4
                            ]), _List_fromArray([
                                $elm$html$Html$text(total)
                            ])),
                            discountInfo,
                            routingWarning
                        ]);
                    case 1:
                        var _v2 = _v0.b;
                        return _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_fromArray([
                                $author$project$Ui$Spinner$small
                            ]))
                        ]);
                    default:
                        return _List_fromArray([
                            $elm$html$Html$text('N/A')
                        ]);
                }
            }())
        ]));
    });
    var $author$project$Components$Patient$Charges$ChargeModal$viewFormGroups = function(model) {
        var meta = A2($elm$core$Maybe$map, $author$project$Api$Provider$Charge$One$meta, model.ach);
        var form = model.PU;
        var basicFormGroups = _List_fromArray([
            A2($author$project$Components$Patient$Charges$ChargeModal$viewPatientFormGroup, form, meta),
            A2($author$project$Components$Patient$Charges$ChargeModal$viewChargeFormGroup, form, meta),
            A2($author$project$Components$Patient$Charges$ChargeModal$viewQuantityFormGroup, form, meta),
            A2($author$project$Components$Patient$Charges$ChargeModal$viewPriceFormGroup, model, meta),
            A2($author$project$Components$Patient$Charges$ChargeModal$viewTotalFormGroup, model, meta),
            $author$project$Components$Patient$Charges$ChargeModal$viewShowAdditionalDetails(model.gP)
        ]);
        var additionalFormGroups = model.gP ? _List_fromArray([
            A2($author$project$Components$Patient$Charges$ChargeModal$viewCategoryFormGroup, form, meta),
            A2($author$project$Components$Patient$Charges$ChargeModal$viewDescriptionFormGroup, form, meta),
            A2($author$project$Components$Patient$Charges$ChargeModal$viewDatesFormGroup, form, meta),
            A2($author$project$Components$Patient$Charges$ChargeModal$viewProviderFormGroup, form, meta),
            A2($author$project$Components$Patient$Charges$ChargeModal$viewLocationFormGroup, form, meta)
        ]) : _List_Nil;
        return $elm$core$List$concat(_List_fromArray([
            basicFormGroups,
            additionalFormGroups
        ]));
    };
    var $author$project$Components$Patient$Charges$ChargeModal$viewBody = function(model) {
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$onSubmit($author$project$Components$Patient$Charges$ChargeModal$SaveClicked),
            $author$project$Ui$Form$horizontal
        ]), $author$project$Components$Patient$Charges$ChargeModal$viewFormGroups(model));
    };
    var $author$project$Components$Patient$Charges$ChargeModal$view = function(model) {
        var previewLoading = _Utils_eq(model.agk, $author$project$Api$Data$Loading);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$Charges$ChargeModal$CloseClicked, _List_fromArray([
            $author$project$Ui$Modal$size(1)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(_Utils_eq(model.ach, $elm$core$Maybe$Nothing) ? 'Add Charge' : 'Edit Charge')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $author$project$Components$Patient$Charges$ChargeModal$viewBody(model)
            ])),
            $author$project$Ui$Modal$footer($elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$CloseClicked),
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ]))
                ]),
                function() {
                    var _v0 = model.ach;
                    if (!_v0.$) return _List_fromArray([
                        $author$project$Utils$Html$empty
                    ]);
                    else return _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace,
                        A3($author$project$Ui$Button$view, {
                            abP: 'save & Add another'
                        }, _List_fromArray([
                            $author$project$Ui$Button$styled(0),
                            $author$project$Ui$Button$loading(model.n8),
                            $author$project$Ui$Button$disabled(previewLoading),
                            $author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$SaveAndAddAnotherClicked)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Save & Add Another')
                        ]))
                    ]);
                }(),
                _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace,
                    A3($author$project$Ui$Button$view, {
                        abP: 'Save'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$Patient$Charges$ChargeModal$SaveClicked),
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$disabled(previewLoading),
                        $author$project$Ui$Button$loading(model.n8)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Save')
                    ]))
                ])
            ])))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalOpened = {
        $: 38
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewAddChargeButton = A3($author$project$Ui$Button$view, {
        abP: 'Add charge'
    }, _List_fromArray([
        $author$project$Ui$Button$secondary,
        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalOpened),
        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
    ]), _List_fromArray([
        $elm$html$Html$text('Add Charge')
    ]));
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$findChargeDropdown = F2(function(charge, dropdowns) {
        return A2($elm$core$Maybe$map, $elm$core$Tuple$second, $elm$core$List$head(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, $elm$core$Tuple$mapFirst($elm$core$Basics$eq($author$project$Api$Provider$Charge$One$id(charge))), $elm$core$Tuple$first), dropdowns)));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteCharge = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditCharge = function(a) {
        return {
            $: 39,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$destroyAction = function(_v0) {
        var meta = _v0;
        return meta.tM.NT;
    };
    var $author$project$Ui$Icon$Dots = 60;
    var $author$project$Ui$Icon$dots = $author$project$Ui$Icon$viewIcon(60);
    var $author$project$Api$Provider$Charge$One$isLocked = function(_v0) {
        var record = _v0.b;
        return record.R7;
    };
    var $author$project$Ui$Element$Danger = 4;
    var $author$project$Ui$Element$textDanger = $author$project$Ui$Element$Text(4);
    var $author$project$Ui$Element$textLeft = $author$project$Ui$Element$Alignment($author$project$Ui$Alignment$textLeft);
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeActions = F3(function(charge, customerInvoiceMeta, maybeDropdown) {
        if ($author$project$Api$Provider$Charge$One$isLocked(charge)) {
            var tooltipText = 'An admin must unlock the charge\'s reporting period before editing this charge';
            return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Tooltip$view, _List_fromArray([
                    $author$project$Ui$Tooltip$placement(2)
                ]), tooltipText, _List_fromArray([
                    $author$project$Ui$Icon$lock(_List_fromArray([
                        $author$project$Ui$Icon$info
                    ]))
                ]))
            ]));
        } else return A2($author$project$Ui$Table$cell, _List_fromArray([
            $author$project$Ui$Table$textRight
        ]), function() {
            if (maybeDropdown.$ === 1) return _List_Nil;
            else {
                var dropdown = maybeDropdown.a;
                return $elm$core$List$singleton(A4($author$project$Ui$Dropdown$view, _List_fromArray([
                    $author$project$Ui$Dropdown$buttonSecondary,
                    $author$project$Ui$Dropdown$buttonSm
                ]), _List_fromArray([
                    $author$project$Ui$Icon$dots(_List_Nil)
                ]), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditCharge(charge))
                ]), A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textLeft,
                    $author$project$Ui$Element$flex,
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Icon$edit(_List_Nil),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Edit')
                    ]))
                ]))), $author$project$Api$Provider$CustomerInvoice$Meta$destroyAction(customerInvoiceMeta) ? _List_fromArray([
                    A2($author$project$Ui$Dropdown$item, _List_fromArray([
                        $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteCharge(charge))
                    ]), A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textDanger,
                        $author$project$Ui$Element$textLeft,
                        $author$project$Ui$Element$flex,
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$delete(_List_Nil),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Delete')
                        ]))
                    ])))
                ]) : _List_Nil), dropdown));
            }
        }());
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AmountDetailHovered = function(a) {
        return {
            $: 36,
            a: a
        };
    };
    var $author$project$Api$Provider$Charge$One$consumedPrepaidCharges = function(_v0) {
        var record = _v0.b;
        return record.L_;
    };
    var $author$project$Api$Provider$Charge$Shared$issuedSubtotalInCents = function(_v0) {
        var record = _v0;
        return record.SG;
    };
    var $author$project$Api$Provider$Charge$One$issuedSubtotalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$issuedSubtotalInCents(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCoverageDiscount = function(coverageDiscount) {
        var coverageRule = $author$project$Api$Provider$CoveredCharge$All$coverageRule(coverageDiscount);
        return A2($author$project$Components$CoverageRuleDescription$view, $author$project$Components$CoverageRuleDescription$Shared(coverageRule), false);
    };
    var $author$project$Api$Provider$PrepaidCharge$packageName = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$map, function($) {
            return $.zr;
        }, record.ach);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPrepaidCharges = F2(function(hasCoverageRules, prepaidCharges) {
        var packageNames = A2($elm$core$List$filterMap, $author$project$Api$Provider$PrepaidCharge$packageName, prepaidCharges);
        if ($elm$core$List$isEmpty(packageNames)) return _List_Nil;
        else {
            var joinedNames = function() {
                if (!packageNames.b) return '';
                else if (!packageNames.b.b) {
                    var single = packageNames.a;
                    return single;
                } else {
                    var last = A2($elm$core$Maybe$withDefault, '', $elm$core$List$head(A2($elm$core$List$drop, $elm$core$List$length(packageNames) - 1, packageNames)));
                    var allButLast = A2($elm$core$List$take, $elm$core$List$length(packageNames) - 1, packageNames);
                    return A2($elm$core$String$join, ', ', allButLast) + (' and ' + last);
                }
            }();
            var packageText = hasCoverageRules ? 'and included in ' + joinedNames : 'Included in ' + (joinedNames + '.');
            return _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(packageText)
                ]))
            ]);
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeAmount = F2(function(charge, maybeCoverageDiscounts) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$justifyRight
        ]), _List_fromArray([
            function() {
                if (!!$author$project$Api$Provider$Charge$One$discountInCents(charge)) {
                    var coverageDiscountContent = function() {
                        if (!maybeCoverageDiscounts.$ && maybeCoverageDiscounts.a.$ === 3) {
                            var _v2 = maybeCoverageDiscounts.a;
                            var coverageDiscounts = _v2.a;
                            return A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCoverageDiscount, coverageDiscounts);
                        } else return _List_Nil;
                    }();
                    var hasCoverageRules = !$elm$core$List$isEmpty(coverageDiscountContent);
                    var costBeforeDiscount = $author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge) + $author$project$Api$Provider$Charge$One$discountInCents(charge);
                    var consumedPrepaidCharges = $author$project$Api$Provider$Charge$One$consumedPrepaidCharges(charge);
                    var prepaidContent = A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPrepaidCharges, hasCoverageRules, consumedPrepaidCharges);
                    var popoverContent = _Utils_ap(coverageDiscountContent, prepaidContent);
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        function() {
                            if (!$elm$core$List$isEmpty(popoverContent) || _Utils_eq(maybeCoverageDiscounts, $elm$core$Maybe$Nothing)) {
                                var popoverOptions = function() {
                                    if (!maybeCoverageDiscounts.$) return _List_Nil;
                                    else return $elm$core$List$isEmpty(consumedPrepaidCharges) ? _List_fromArray([
                                        $author$project$Ui$Popover$onHover($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AmountDetailHovered($author$project$Api$Provider$Charge$One$id(charge)))
                                    ]) : _List_Nil;
                                }();
                                return A3($author$project$Ui$Popover$view, popoverOptions, _List_fromArray([
                                    $author$project$Ui$Icon$help(_List_Nil)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Popover$body, _List_Nil, popoverContent)
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        $author$project$Utils$Html$noBreakSpace,
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$strike,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(costBeforeDiscount))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            !_Utils_eq($author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge), $author$project$Api$Provider$Charge$One$subtotalInCents(charge)) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$strike,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$One$issuedSubtotalInCents(charge)))
            ])) : $author$project$Utils$Html$empty,
            $author$project$Utils$Html$noBreakSpace,
            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Charge$One$subtotalInCents(charge))),
            $author$project$Api$Provider$Charge$One$taxable(charge) ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text(' + tax')
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail = F2(function(label, value) {
        return $elm$core$String$isEmpty(value) ? $elm$html$Html$text('') : A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$textSm,
            $author$project$Ui$Element$textMuted
        ]), _List_fromArray([
            $elm$html$Html$text(label + ':  '),
            $elm$html$Html$text(value)
        ]));
    });
    var $author$project$Api$Provider$PrepaidCharge$chargeItem = function(_v0) {
        var record = _v0;
        return record.lv;
    };
    var $author$project$Api$Provider$PrepaidCharge$originalQuantity = function(_v0) {
        var record = _v0;
        return record.VF;
    };
    var $author$project$Api$Provider$Charge$One$prepaidCharges = function(_v0) {
        var record = _v0.b;
        return record.Xi;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePackageItems = function(charge) {
        var toItemText = function(prepaidCharge) {
            var quantity = $author$project$Api$Provider$PrepaidCharge$originalQuantity(prepaidCharge);
            var chargeItem = $author$project$Api$Provider$PrepaidCharge$chargeItem(prepaidCharge);
            var name = $author$project$Api$Provider$ChargeItem$Min$name(chargeItem);
            return $elm$core$String$fromInt(quantity) + (' ' + name);
        };
        var itemsText = A2($elm$core$String$join, ', ', A2($elm$core$List$map, toItemText, $author$project$Api$Provider$Charge$One$prepaidCharges(charge)));
        return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Includes', itemsText);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetails = function(charge) {
        var date = A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Charge$One$date(charge));
        var detailsRow = A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$wrap,
            $author$project$Ui$Element$spaceX2
        ]), _List_fromArray([
            function() {
                var _v0 = $author$project$Api$Provider$Charge$One$endDate(charge);
                if (!_v0.$) {
                    var endDate = _v0.a;
                    return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Dates', date + (' - ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate)));
                } else return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Date', date);
            }(),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Description', $author$project$Api$Provider$Charge$One$description(charge)),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Practitioner', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Shared$name, $author$project$Api$Provider$Charge$One$practitioner(charge)))),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Patient', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name, $author$project$Api$Provider$Charge$One$patient(charge)))),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetail, 'Location', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$Charge$One$location(charge)))),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textSm
            ]), _List_fromArray([
                A2($author$project$Components$InventoryWarning$view, A2($elm$core$Maybe$map, function(chargeItem) {
                    return {
                        I0: $author$project$Api$Provider$ChargeItem$ForCharge$alertQuantity(chargeItem),
                        XT: $author$project$Api$Provider$ChargeItem$ForCharge$quantityInStock(chargeItem),
                        aap: $author$project$Api$Provider$ChargeItem$ForCharge$trackInventory(chargeItem)
                    };
                }, $author$project$Api$Provider$Charge$One$chargeItem(charge)), $elm$core$Maybe$Just($author$project$Api$Provider$Charge$One$quantity(charge)))
            ]))
        ]));
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flexCol,
            $author$project$Ui$Element$spaceY2
        ]), _List_fromArray([
            $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePackageItems(charge),
            detailsRow
        ]));
    };
    var $author$project$Formatters$ChargeItem$ifPresent = function(string) {
        return $elm$core$String$isEmpty(string) ? '' : A2($elm$core$String$append, ' - ', string);
    };
    var $author$project$Formatters$ChargeItem$toTitle = function(chargeItem) {
        var codeTypeAndCode = $author$project$Formatters$ChargeItemCode$toString($author$project$Formatters$ChargeItemCode$CodeTypeAndCode(_Utils_Tuple2($author$project$Api$Provider$ChargeItem$ForCharge$codeType(chargeItem), $author$project$Api$Provider$ChargeItem$ForCharge$code(chargeItem))));
        return $elm$core$String$concat(_List_fromArray([
            $author$project$Api$Provider$ChargeItem$ForCharge$name(chargeItem),
            $author$project$Formatters$ChargeItem$ifPresent(codeTypeAndCode),
            $author$project$Formatters$ChargeItem$ifPresent($author$project$Api$Provider$ChargeItem$ForCharge$manufacturer(chargeItem))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeName = function(charge) {
        var name = function() {
            var _v1 = $author$project$Api$Provider$Charge$One$chargeItem(charge);
            if (!_v1.$) {
                var chargeItem = _v1.a;
                return $author$project$Formatters$ChargeItem$toTitle(chargeItem);
            } else return A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Charge$One$name(charge));
        }();
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$bold
            ]), _List_fromArray([
                $elm$html$Html$text(name)
            ])),
            function() {
                var _v0 = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Charge$One$category, $elm$core$Maybe$map($author$project$Api$Provider$Category$Shared$name))(charge);
                if (!_v0.$) {
                    var categoryName = _v0.a;
                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' - ' + categoryName)
                    ]));
                } else return $elm$html$Html$text('');
            }()
        ]));
    };
    var $author$project$Api$Provider$Charge$Shared$issuedPriceInCents = function(_v0) {
        var record = _v0;
        return record.SD;
    };
    var $author$project$Api$Provider$Charge$One$issuedPriceInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$issuedPriceInCents(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePrice = function(charge) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            function() {
                var _v0 = _Utils_Tuple2($author$project$Api$Provider$Charge$One$issuedPriceInCents(charge), $author$project$Api$Provider$Charge$One$priceInCents(charge));
                if (!_v0.a.$ && !_v0.b.$) {
                    var issuedPrice = _v0.a.a;
                    var price = _v0.b.a;
                    return !_Utils_eq(issuedPrice, price) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$strike,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(issuedPrice))
                    ])) : $author$project$Utils$Html$empty;
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Utils$Html$noBreakSpace,
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                function() {
                    var _v1 = $author$project$Api$Provider$Charge$One$priceInCents(charge);
                    if (!_v1.$) {
                        var price = _v1.a;
                        return $elm$html$Html$text($author$project$Utils$Currency$fromInt(price));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            $author$project$Api$Provider$Charge$One$type_(charge) === 'coverage' ? A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$italic,
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text($elm$core$String$concat(_List_fromArray([
                    ' per ',
                    $elm$core$String$toLower($author$project$Api$Provider$Uom$Shared$name($author$project$Api$Provider$Charge$One$priceUom(charge)))
                ])))
            ])) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Api$Provider$Charge$Shared$issuedQuantity = function(_v0) {
        var record = _v0;
        return record.SE;
    };
    var $author$project$Api$Provider$Charge$One$issuedQuantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$issuedQuantity(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeQuantity = function(charge) {
        var showQuantityWithUnit = F2(function(quantity, uom) {
            return $author$project$Api$Provider$Uom$Shared$isTimeBased(uom) ? A2($author$project$Formatters$String$pluralize, $author$project$Api$Provider$Uom$Shared$name(uom), quantity) : $elm$core$String$fromInt(quantity);
        });
        var diffInQuantityUom = !_Utils_eq($author$project$Api$Provider$Uom$Shared$code($author$project$Api$Provider$Charge$One$issuedQuantityUom(charge)), $author$project$Api$Provider$Uom$Shared$code($author$project$Api$Provider$Charge$One$quantityUom(charge)));
        var diffInQuantity = !_Utils_eq($author$project$Api$Provider$Charge$One$issuedQuantity(charge), $author$project$Api$Provider$Charge$One$quantity(charge));
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            diffInQuantity || diffInQuantityUom ? A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$strike
            ]), _List_fromArray([
                $elm$html$Html$text(A2(showQuantityWithUnit, $author$project$Api$Provider$Charge$One$issuedQuantity(charge), $author$project$Api$Provider$Charge$One$issuedQuantityUom(charge)))
            ])) : $author$project$Utils$Html$empty,
            $author$project$Utils$Html$noBreakSpace,
            $elm$html$Html$text(A2(showQuantityWithUnit, $author$project$Api$Provider$Charge$One$quantity(charge), $author$project$Api$Provider$Charge$One$quantityUom(charge)))
        ]));
    };
    var $author$project$Components$ChargeRoutingWarning$One = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ChargeRoutingWarning$viewWithChargeOne = F2(function(selectedPayer, charge) {
        return A2($author$project$Components$ChargeRoutingWarning$view, selectedPayer, $author$project$Components$ChargeRoutingWarning$One(charge));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCharge = F4(function(charge, customerInvoiceMeta, coverageDiscounts, dropdown) {
        var warning = A2($author$project$Components$ChargeRoutingWarning$viewWithChargeOne, 0, charge);
        return A2($elm$core$List$cons, A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeName(charge)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargePrice(charge)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeQuantity(charge)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeAmount, charge, coverageDiscounts)
            ])),
            A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeActions, charge, customerInvoiceMeta, dropdown)
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Table$row, _List_fromArray([
            $author$project$Ui$Table$noBorder
        ]), _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$colspan(3)
            ]), _List_fromArray([
                $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargeDetails(charge)
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$colspan(3)
            ]), _List_fromArray([
                $author$project$Api$Provider$Charge$One$discountOverridden(charge) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$pull(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Membership rule was removed')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
        ])), A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(warning_) {
            return _List_fromArray([
                A2($author$project$Ui$Table$row, _List_fromArray([
                    $author$project$Ui$Table$noBorder
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_fromArray([
                        $author$project$Ui$Table$colspan(12)
                    ]), _List_fromArray([
                        warning_
                    ]))
                ]))
            ]);
        }, warning))));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargesTable = function(model) {
        var _v0 = function() {
            var _v1 = model.RA;
            if (_v1.$ === 3) {
                var invoice = _v1.a;
                var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
                return _Utils_Tuple2(false, A2($elm$core$List$concatMap, function(charge) {
                    return A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCharge, charge, meta, A2($elm$core$Dict$get, $author$project$Api$Provider$Charge$One$id(charge), model.wZ), A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$findChargeDropdown, charge, model.hM));
                }, A2($elm$core$List$filter, $author$project$Api$Provider$Charge$One$isPersisted, A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$CustomerInvoice$One$charges(invoice)))));
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var charges = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('There are no charges.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(6)
            ]), _List_fromArray([
                $elm$html$Html$text('Item')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2)
            ]), _List_fromArray([
                $elm$html$Html$text('Price')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(1)
            ]), _List_fromArray([
                $elm$html$Html$text('Qty')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(2),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(1)
            ]), _List_fromArray([
                $elm$html$Html$text('')
            ]))
        ]), charges, _List_Nil);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmOpened = {
        $: 14
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDeleteButton = F2(function(model, invoice) {
        return $author$project$Api$Provider$CustomerInvoice$Meta$destroyAction($author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A3($author$project$Ui$Button$view, {
            abP: 'Delete invoice'
        }, _List_fromArray([
            $author$project$Ui$Button$secondary,
            $author$project$Ui$Button$loading(_Utils_eq(model.RA, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmOpened)
        ]), _List_fromArray([
            $elm$html$Html$text('Delete')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceClicked = function(a) {
        return {
            $: 34,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Shared$phones = function(_v0) {
        var shared = _v0;
        return shared.WG;
    };
    var $author$project$Ui$Element$Test = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ui$Element$test = $author$project$Ui$Element$Test;
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled = function(invoice) {
        var invoiceStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
        var hasLockedCharges = A2($elm$core$List$any, function(charge) {
            return $author$project$Api$Provider$Charge$One$isLocked(charge);
        }, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Expandable$toMaybe($author$project$Api$Provider$CustomerInvoice$One$charges(invoice))));
        return hasLockedCharges && invoiceStatus !== 'draft' || A2($elm$core$List$member, invoiceStatus, _List_fromArray([
            'bad_debt',
            'cancelled'
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecord = F2(function(timeFormatter, record) {
        var unsyncedReason = function() {
            var _v2 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
            if (!_v2.$) {
                var reason = _v2.a;
                return A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('ml-1')
                ]), _List_fromArray([
                    $elm$html$Html$text(reason)
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        var lastSyncedAt = function() {
            var _v1 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
            if (!_v1.$) {
                var time = _v1.a;
                return A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('ml-1')
                ]), _List_fromArray([
                    $elm$html$Html$text('on ' + A2(timeFormatter, 0, time))
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$name($author$project$Api$Provider$IntegrationRecord$All$integration(record));
        var errorMessage = function() {
            var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
            if (!_v0.$) {
                var message = _v0.a;
                return A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('ml-1')
                ]), _List_fromArray([
                    $elm$html$Html$text(message)
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        var additionalInfo = A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('form-control-static'),
            $elm$html$Html$Attributes$class('text-muted'),
            $elm$html$Html$Attributes$class('text-body-sm')
        ]), _List_fromArray([
            unsyncedReason,
            errorMessage,
            lastSyncedAt
        ]));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(7)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flexAuto,
                    $author$project$Ui$Element$spaceX2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $author$project$Ui$HinterOnly$icon(_List_Nil)
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$p0,
                        $author$project$Ui$Typography$textLeft
                    ]), _List_fromArray([
                        $elm$html$Html$text(integrationName)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(5)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsStart
                ]), _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$IntegrationRecord$Status$toString($author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record)))
                ])),
                additionalInfo
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecords = F2(function(formatter, response) {
        if (response.$ === 3) {
            var integrationRecords = response.a;
            return A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecord(formatter), integrationRecords);
        } else return _List_Nil;
    });
    var $author$project$Formatters$Phone$phoneParts = function(phone) {
        var countryAt = $elm$core$String$length(phone) - 10;
        var rest = A2($elm$core$String$dropLeft, countryAt, phone);
        var country = A3($elm$core$String$slice, 0, countryAt, phone);
        return _Utils_Tuple2(country, rest);
    };
    var $author$project$Formatters$Phone$formatWithCountry = function(phoneNumber) {
        var parsedNumber = A2($elm$core$String$filter, function(_char) {
            return _char !== '+';
        }, $elm$core$String$trim(phoneNumber));
        var length = $elm$core$String$length(parsedNumber);
        if (A2($elm$core$String$contains, '-', parsedNumber) || length < 10 || length > 13) return phoneNumber;
        else {
            var phoneWithCountry = length === 10 ? '1' + parsedNumber : parsedNumber;
            var _v0 = $author$project$Formatters$Phone$phoneParts(phoneWithCountry);
            var country = _v0.a;
            var rest = _v0.b;
            return country + (' ' + $author$project$Formatters$Phone$format(rest));
        }
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPhone = function(phone) {
        var formattedPhone = function(number) {
            return $author$project$Formatters$Phone$formatWithCountry(number) + (' (' + ($author$project$Formatters$PhoneType$toString($author$project$Api$Common$Phone$Shared$type_(phone)) + ')'));
        };
        var _v0 = $author$project$Api$Common$Phone$Shared$number(phone);
        if (!_v0.$) {
            var number = _v0.a;
            return A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$phi(true),
                $author$project$Ui$Typography$margin(1)
            ]), _List_fromArray([
                $elm$html$Html$text(formattedPhone(number))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetails = F5(function(timeFormatter, isHintAdmin, integrationRecords, practice, invoice) {
        var editButtonDisabled = $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled(invoice);
        var editButton = A3($author$project$Ui$Button$view, {
            abP: 'Edit details'
        }, _List_fromArray([
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$secondary,
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceClicked(invoice)),
            $author$project$Ui$Button$disabled(editButtonDisabled),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
        ]), _List_fromArray([
            $elm$html$Html$text('Edit Details')
        ]));
        var _v0 = function() {
            var _v1 = $author$project$Api$Provider$CustomerInvoice$One$owner(invoice);
            if (!_v1.$) {
                var patient = _v1.a;
                return _Utils_Tuple2($author$project$Api$Provider$Patient$Shared$name(patient), A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$Patient$Shared$phones(patient)));
            } else return _Utils_Tuple2('', _List_Nil);
        }();
        var ownerName = _v0.a;
        var ownerPhones = _v0.b;
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$test('invoice-details'),
            $author$project$Ui$Element$mb4
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(2),
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$p0,
                        $author$project$Ui$Typography$textLeft
                    ]), _List_fromArray([
                        $elm$html$Html$text('Payer')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(4),
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold,
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text(ownerName)
                    ])),
                    A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPhone, ownerPhones))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(4)
                ]), A2($elm$core$List$cons, A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(7),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$p0,
                            $author$project$Ui$Typography$textLeft
                        ]), _List_fromArray([
                            $elm$html$Html$text('Invoice Date')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$CustomerInvoice$One$date(invoice)))
                        ]))
                    ]))
                ])), A2($elm$core$List$cons, A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(7),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$p0,
                            $author$project$Ui$Typography$textLeft
                        ]), _List_fromArray([
                            $elm$html$Html$text('Location')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$CustomerInvoice$One$location(invoice))))
                        ]))
                    ]))
                ])), A2($elm$core$List$cons, !$elm$core$List$isEmpty($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$invoicePayments(invoice)) || $author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(7),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$p0,
                            $author$project$Ui$Typography$textLeft
                        ]), _List_fromArray([
                            $elm$html$Html$text('Default Payment Source')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        function() {
                            var _v2 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
                            if (!_v2.$) {
                                var source = _v2.a;
                                return A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                                    $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just($author$project$Api$Source$Source(source))),
                                    $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                                    $author$project$Components$PaymentSourceDisplayer$limitedView(true)
                                ]));
                            } else {
                                var _v3 = $author$project$Api$Provider$CustomerInvoice$One$source(invoice);
                                if (!_v3.$) {
                                    var source = _v3.a;
                                    return A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                                        $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just($author$project$Api$Source$Source(source))),
                                        $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                                        $author$project$Components$PaymentSourceDisplayer$limitedView(true)
                                    ]));
                                } else return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'none')
                                ]));
                            }
                        }()
                    ]))
                ])), isHintAdmin ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIntegrationRecords, timeFormatter, integrationRecords) : _List_Nil)))),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(2),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    editButton
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetailsSkeleton = A2($author$project$Ui$Element$view, _List_fromArray([
        $author$project$Ui$Element$mb4
    ]), _List_fromArray([
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(2),
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Payer')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(4)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(7),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$p0
                        ]), _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Invoice Date')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$span(4)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(7),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Location')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$span(5)
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]));
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$SaveInvoice = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewLocationInput = F2(function(locationResourceFilter, disable) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8),
            $author$project$Ui$Form$Group$label('Location')
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                $author$project$Components$ResourceFilter$disabled(disable)
            ]), locationResourceFilter))
        ]));
    });
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewPatientInput = function(patientResourceFilter) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(4),
            $author$project$Ui$Form$Group$inputSpanSm(8),
            $author$project$Ui$Form$Group$label('Payer')
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$PatientResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$view, _List_Nil, patientResourceFilter))
        ]));
    };
    var $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$view = function(model) {
        var _v0 = model.aa;
        if (!_v0.$) {
            var _v1 = _v0.a;
            var invoiceId = _v1.a;
            var form = _v1.b;
            var invoice = _v1.c;
            var _v2 = $author$project$Utils$Form$fields(form);
            var invoiceDate = _v2.RG;
            var dateInput = _v2.qg;
            var _v3 = _Utils_Tuple2(model.rX, model.ro);
            if (!_v3.a.$ && !_v3.b.$) {
                var patientResourceFilter = _v3.a.a;
                var locationResourceFilter = _v3.b.a;
                var modalConfig = {
                    QG: $elm$core$Maybe$Nothing,
                    aeI: 'Customer Invoice',
                    Tk: model.Tk,
                    TR: $elm$core$Maybe$Just(invoiceId),
                    TS: $elm$core$Maybe$Nothing,
                    Vl: $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$CancelInvoiceEdit,
                    Vn: $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$SaveInvoice(form)
                };
                var disabled = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) !== 'draft';
                return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
                    $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewPatientInput(patientResourceFilter),
                    A2($author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$viewLocationInput, locationResourceFilter, disabled),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Invoice Date'),
                        $author$project$Ui$Form$Group$labelSpan(4),
                        $author$project$Ui$Form$Group$inputSpan(8)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$DateInputMsg(dateInput), A2($author$project$Components$DateInput$view, _List_fromArray([
                            $author$project$Components$DateInput$value(invoiceDate),
                            $author$project$Components$DateInput$disabled(disabled)
                        ]), dateInput))
                    ]))
                ]));
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditInvoiceModal = function(maybeModal) {
        if (!maybeModal.$) {
            var modal = maybeModal.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$EditInvoiceModalMsg, $author$project$Components$Invoice$Summary$EditCustomerInvoiceModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsSentClicked = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsUnsentClicked = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$PatientShared = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$StopRetryingClicked = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$OpenModal = F4(function(a, b, c, d) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Components$CustomerEmailModal$defaultOptions = {
        d$: false,
        ahq: 0
    };
    var $author$project$Components$CustomerEmailModal$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            if (!option.$) {
                var bool = option.a;
                return _Utils_update(record, {
                    d$: bool
                });
            } else {
                var size_ = option.a;
                return _Utils_update(record, {
                    ahq: size_
                });
            }
        }), $author$project$Components$CustomerEmailModal$defaultOptions, options);
    };
    var $author$project$Components$CustomerEmailModal$button = F5(function(session, options, type_, contextId, recipient) {
        var optionsRecord = $author$project$Components$CustomerEmailModal$optionsToRecord(options);
        return A3($author$project$Ui$Tooltip$view, _List_Nil, 'Send Invoice via Email', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Send invoice via email'
            }, _List_fromArray([
                $author$project$Ui$Button$size(optionsRecord.ahq),
                $author$project$Ui$Button$onClick(A4($author$project$Components$CustomerEmailModal$OpenModal, session, type_, contextId, recipient)),
                $author$project$Ui$Button$disabled(optionsRecord.d$),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
            ]), _List_fromArray([
                $elm$html$Html$text('Email')
            ]))
        ]));
    });
    var $author$project$Api$Provider$CustomerInvoice$Shared$issuedTotalInCents = function(_v0) {
        var record = _v0;
        return record.SH;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$issuedTotalInCents(shared);
    };
    var $author$project$Api$Provider$CustomerInvoice$One$lastSentAt = function(_v0) {
        var record = _v0.b;
        return record.SY;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$markAsSentAction = function(_v0) {
        var meta = _v0;
        return meta.tM.TF;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$markAsUnsentAction = function(_v0) {
        var meta = _v0;
        return meta.tM.TG;
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$securePdfInlineToken = function(_v0) {
        var record = _v0;
        return record.ZC;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$securePdfInlineToken = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$securePdfInlineToken(shared);
    };
    var $author$project$Components$CustomerEmailModal$Size = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$size = $author$project$Components$CustomerEmailModal$Size;
    var $author$project$Api$Provider$CustomerInvoice$Meta$stopRetryingAction = function(_v0) {
        var meta = _v0;
        return meta.tM.$b;
    };
    var $author$project$Ui$Badge$Test = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Badge$test = $author$project$Ui$Badge$Test;
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ConvertToCreditClicked = function(a) {
        return {
            $: 31,
            a: a
        };
    };
    var $author$project$Api$FeatureGate$PatientCredits = 4;
    var $author$project$Ui$Margin$X_0_5 = 24;
    var $author$project$Api$Provider$CustomerInvoice$Meta$transferToCreditAction = function(_v0) {
        var meta = _v0;
        return meta.tM.aav;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewConvertToCreditButton = F2(function(model, invoice) {
        return A2($author$project$Utils$FeatureGate$gateAvailable, 4, $author$project$Api$Practice$Provider(model.W1)) && $author$project$Api$Provider$CustomerInvoice$Meta$transferToCreditAction($author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A3($author$project$Ui$Button$view, {
            abP: 'Convert amount to credit'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$margin(24),
            $author$project$Ui$Button$loading(_Utils_eq(model.RA, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ConvertToCreditClicked(invoice))
        ]), _List_fromArray([
            $elm$html$Html$text('Convert to Credit')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmOpened = {
        $: 16
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReturnToDraftClicked = function(a) {
        return {
            $: 27,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseBadDebtClicked = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked = function(a) {
        return {
            $: 53,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentClicked = function(a) {
        return {
            $: 41,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Void = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$cancel = function(_v0) {
        var meta = _v0;
        return meta.tM.KW;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment = function(_v0) {
        var meta = _v0;
        return meta.tM.Mt;
    };
    var $author$project$Ui$Dropdown$Item$HiddenLg = {
        $: 11
    };
    var $author$project$Ui$Dropdown$hiddenLg = $author$project$Ui$Dropdown$Item$HiddenLg;
    var $author$project$Api$Provider$CustomerInvoice$Meta$markAsBadDebtAction = function(_v0) {
        var meta = _v0;
        return meta.tM.TD;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Yi;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$returnToDraftAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Y0;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$reverseBadDebtAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Y4;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Zt;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$schedulePaymentAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Zu;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$updateAction = function(_v0) {
        var meta = _v0;
        return meta.tM.aaO;
    };
    var $author$project$Ui$Icon$Void = 56;
    var $author$project$Ui$Icon$void = $author$project$Ui$Icon$viewIcon(56);
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewOtherDropdown = F2(function(model, invoice) {
        var ifAllowed = F2(function(condition, dropdownItem) {
            return condition($author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? $elm$core$Maybe$Just(dropdownItem) : $elm$core$Maybe$Nothing;
        });
        var schedulePaymentsOption = A2($author$project$Utils$FeatureGate$gateAvailable, 12, $author$project$Api$Practice$Provider(model.W1)) ? A2(ifAllowed, $author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked(invoice))
        ]), A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flex,
            $author$project$Ui$Element$gap2,
            $author$project$Ui$Element$itemsCenter
        ]), _List_fromArray([
            $author$project$Ui$Icon$calendar(_List_Nil),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Schedule Payments')
            ]))
        ])))) : A2(ifAllowed, $author$project$Api$Provider$CustomerInvoice$Meta$schedulePaymentAction, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentClicked(invoice))
        ]), A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flex,
            $author$project$Ui$Element$gap2,
            $author$project$Ui$Element$itemsCenter
        ]), _List_fromArray([
            $author$project$Ui$Icon$calendar(_List_Nil),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Schedule Payment')
            ]))
        ]))));
        var canRevise = function(meta) {
            return $author$project$Api$Provider$CustomerInvoice$Meta$updateAction(meta) && $author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment(meta) && A3($author$project$Permission$canGoTo, model.Z$, model.Cu.aeb, 48);
        };
        return function(options) {
            return $elm$core$List$isEmpty(options) ? $author$project$Utils$Html$empty : A4($author$project$Ui$Dropdown$view, _List_Nil, _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Other ')
                ]))
            ]), options, model.ng);
        }(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2(ifAllowed, $author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment(invoice)),
                $author$project$Ui$Dropdown$hiddenLg
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Icon$check(_List_Nil),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Record Payment')
                ]))
            ])))),
            A2(ifAllowed, canRevise, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise(invoice)),
                $author$project$Ui$Dropdown$hiddenLg
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Icon$edit(_List_Nil),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Revise')
                ]))
            ])))),
            schedulePaymentsOption,
            A2(ifAllowed, $author$project$Api$Provider$CustomerInvoice$Meta$markAsBadDebtAction, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmOpened)
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Icon$stop(_List_Nil),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Bad Debt')
                ]))
            ])))),
            A2(ifAllowed, $author$project$Api$Provider$CustomerInvoice$Meta$returnToDraftAction, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReturnToDraftClicked(invoice))
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Icon$arrowLeft(_List_fromArray([
                    $author$project$Ui$Icon$xs
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Return To Draft')
                ]))
            ])))),
            A2(ifAllowed, $author$project$Api$Provider$CustomerInvoice$Meta$reverseBadDebtAction, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseBadDebtClicked(invoice))
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Icon$arrowLeft(_List_Nil),
                $elm$html$Html$text('Return To Issued')
            ])))),
            A2(ifAllowed, $author$project$Api$Provider$CustomerInvoice$Meta$cancel, A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Void(invoice))
            ]), A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$flex,
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$textDanger,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Icon$void(_List_Nil),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Void')
                ]))
            ]))))
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Pay = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PayWithPassthroughFees = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$createPaymentAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Wn;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessPayment = F2(function(model, invoice) {
        var usesCardReaders = $author$project$Api$Provider$Practice$One$usesCardReaders(model.W1);
        var hasPaymentMethod = $author$project$Utils$Maybe$toBool($author$project$Api$Provider$CustomerInvoice$One$source(invoice));
        var canCreatePaymentAction = $author$project$Api$Provider$CustomerInvoice$Meta$createPaymentAction($author$project$Api$Provider$CustomerInvoice$One$meta(invoice));
        return canCreatePaymentAction && (hasPaymentMethod || usesCardReaders) && $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.V7) ? A3($author$project$Ui$Button$view, {
            abP: 'Process payment'
        }, _List_fromArray([
            $author$project$Ui$Button$success,
            $author$project$Ui$Button$loading(_Utils_eq(model.RA, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PayWithPassthroughFees(invoice)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$dollarSign)
        ]), _List_fromArray([
            $elm$html$Html$text('Process Payment')
        ])) : canCreatePaymentAction && (hasPaymentMethod || usesCardReaders) ? A3($author$project$Ui$Button$view, {
            abP: 'Process payment'
        }, _List_fromArray([
            $author$project$Ui$Button$success,
            $author$project$Ui$Button$loading(_Utils_eq(model.RA, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Pay(invoice)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$dollarSign)
        ]), _List_fromArray([
            $elm$html$Html$text('Process Payment')
        ])) : canCreatePaymentAction && !hasPaymentMethod && !usesCardReaders ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top({
            V8: model.V8
        }), _List_fromArray([
            $author$project$Ui$Link$buttonSuccess
        ]), _List_fromArray([
            $elm$html$Html$text('Add Payment Source')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefund = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton = F2(function(permitted, button) {
        return permitted ? button : A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
            button
        ]), _List_fromArray([
            A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Please contact your practice administrator to be granted permission.')
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessRefund = F2(function(model, invoice) {
        if ($author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice) > 0) {
            var canIssueRefunds = A3($author$project$Permission$canGoTo, model.Z$, model.Cu.aeb, 49);
            var buttonStyle = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'paid' ? 4 : 5;
            return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton, canIssueRefunds, A3($author$project$Ui$Button$view, {
                abP: 'Process refund'
            }, _List_fromArray([
                $author$project$Ui$Button$styled(buttonStyle),
                $author$project$Ui$Button$loading(_Utils_eq(model.RA, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefund(invoice)),
                $author$project$Ui$Button$disabled(!canIssueRefunds),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
            ]), _List_fromArray([
                $elm$html$Html$text('Process Refund')
            ])));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Ui$Button$Display = F2(function(a, b) {
        return {
            $: 19,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Button$displayLg = A2($author$project$Ui$Button$Display, true, 3);
    var $author$project$Ui$Button$hidden = A2($author$project$Ui$Button$Display, false, 0);
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRecordPayment = F2(function(model, invoice) {
        return $author$project$Api$Provider$CustomerInvoice$Meta$recordPaymentAction($author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A3($author$project$Ui$Button$view, {
            abP: 'Record payment'
        }, _List_fromArray([
            $author$project$Ui$Button$secondary,
            $author$project$Ui$Button$loading(_Utils_eq(model.RA, $author$project$Api$Data$Loading)),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RecordPayment(invoice)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$check),
            $author$project$Ui$Button$hidden,
            $author$project$Ui$Button$displayLg
        ]), _List_fromArray([
            $elm$html$Html$text('Record Payment')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRevise = F2(function(model, invoice) {
        var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
        if ($author$project$Api$Provider$CustomerInvoice$Meta$updateAction(meta) && $author$project$Api$Provider$CustomerInvoice$Meta$createAdjustment(meta)) {
            var canRevise = A3($author$project$Permission$canGoTo, model.Z$, model.Cu.aeb, 48);
            return A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$permittedButton, canRevise, A3($author$project$Ui$Button$view, {
                abP: 'Revise invoice'
            }, _List_fromArray([
                $author$project$Ui$Button$styled(4),
                $author$project$Ui$Button$loading(_Utils_eq(model.RA, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Revise(invoice)),
                $author$project$Ui$Button$disabled(!canRevise),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                $author$project$Ui$Button$hidden,
                $author$project$Ui$Button$displayLg
            ]), _List_fromArray([
                $elm$html$Html$text('Revise')
            ])));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeader = F3(function(model, meta, invoice) {
        var statusLabel = function() {
            var _v1 = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
            if (_v1 === 'sent') return A3($author$project$Ui$Tooltip$view, _List_Nil, 'on ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, model.HO(0), $author$project$Api$Provider$CustomerInvoice$One$lastSentAt(invoice))), _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_fromArray([
                    $author$project$Ui$Badge$test('invoice-status')
                ]), $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice))
            ]));
            else return A2($author$project$Ui$Badge$fromString, _List_fromArray([
                $author$project$Ui$Badge$test('invoice-status')
            ]), $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice));
        }();
        var markAsSentButton = $author$project$Api$Provider$CustomerInvoice$Meta$markAsSentAction(meta) ? A3($author$project$Ui$Button$view, {
            abP: 'Mark as sent'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsSentClicked(invoice))
        ]), _List_fromArray([
            $elm$html$Html$text('Mark as Sent')
        ])) : $author$project$Api$Provider$CustomerInvoice$Meta$markAsUnsentAction(meta) ? A3($author$project$Ui$Button$view, {
            abP: 'Mark as not sent'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$MarkAsUnsentClicked(invoice))
        ]), _List_fromArray([
            $elm$html$Html$text('Mark as Not Sent')
        ])) : $author$project$Api$Provider$CustomerInvoice$Meta$stopRetryingAction(meta) ? A3($author$project$Ui$Button$view, {
            abP: 'Stop retrying'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$StopRetryingClicked(invoice))
        ]), _List_fromArray([
            $elm$html$Html$text('Stop Retrying')
        ])) : $author$project$Utils$Html$empty;
        var emailButton = A2($elm$core$Maybe$map, function(owner) {
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg, A5($author$project$Components$CustomerEmailModal$button, model.Z$, _List_fromArray([
                $author$project$Components$CustomerEmailModal$size(0)
            ]), 0, $author$project$Api$Provider$CustomerInvoice$One$id(invoice), $author$project$Components$CustomerEmailModal$PatientShared(owner)));
        }, $author$project$Api$Provider$CustomerInvoice$One$owner(invoice));
        var downloadPdfButton = A2($elm$core$Maybe$map, function(securePdfInlineToken) {
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DownloadInvoiceMsg, A4($author$project$Components$Invoice$DownloadFile$view, model.it, securePdfInlineToken, _List_fromArray([
                $author$project$Components$Invoice$DownloadFile$label('Export to PDF'),
                $author$project$Components$Invoice$DownloadFile$tooltip(true)
            ]), _List_fromArray([
                $author$project$Ui$Button$sm
            ])));
        }, $author$project$Api$Provider$CustomerInvoice$One$securePdfInlineToken(invoice));
        var buttons = _List_fromArray([
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewOtherDropdown, model, invoice),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessRefund, model, invoice),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRevise, model, invoice),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewRecordPayment, model, invoice),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewProcessPayment, model, invoice),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewConvertToCreditButton, model, invoice)
        ]);
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(4),
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$mb2
                    ]), _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Invoice #' + $elm$core$String$fromInt($author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice))),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text(' for ')
                            ])),
                            !_Utils_eq($author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents(invoice), $author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice)) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$strike,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$issuedTotalInCents(invoice))),
                                $author$project$Utils$Html$noBreakSpace
                            ])) : $author$project$Utils$Html$empty,
                            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(' '),
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice)))
                            ])),
                            !!$author$project$Api$Provider$CustomerInvoice$One$revisionNumber(invoice) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text(' (rev. ' + ($elm$core$String$fromInt($author$project$Api$Provider$CustomerInvoice$One$revisionNumber(invoice)) + ')'))
                            ])) : $author$project$Utils$Html$empty,
                            $author$project$Utils$Html$noBreakSpace,
                            statusLabel
                        ]))
                    ])),
                    function() {
                        var _v0 = model.hB;
                        if (!_v0.$) {
                            var auditTrailLog = _v0.a;
                            return A2($author$project$Ui$Element$view, _List_Nil, $elm$core$List$singleton(A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$view(auditTrailLog))));
                        } else return A2($author$project$Ui$Element$view, _List_Nil, _List_Nil);
                    }(),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mt2,
                        $author$project$Ui$Element$gap2
                    ]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                        emailButton,
                        downloadPdfButton,
                        $elm$core$Maybe$Just(markAsSentButton)
                    ])))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(8),
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight,
                        $author$project$Ui$Element$wrap,
                        $author$project$Ui$Element$gap2
                    ]), buttons)
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeaderSkeleton = A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(4),
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Invoice #100 for $50.00')
                    ]))
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$span(3)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt2,
                    $author$project$Ui$Element$spaceX2
                ]), _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(2)
                    ])),
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(2)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanLg(8),
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight,
                    $author$project$Ui$Element$wrap,
                    $author$project$Ui$Element$spaceX2
                ]), _List_fromArray([
                    $author$project$Ui$Skeleton$input(_List_fromArray([
                        $author$project$Ui$Skeleton$span(2)
                    ])),
                    $author$project$Ui$Skeleton$input(_List_fromArray([
                        $author$project$Ui$Skeleton$span(2)
                    ]))
                ]))
            ]))
        ]))
    ]));
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHiConfirmModals = F2(function(model, invoice_) {
        if (model.h9) {
            var due = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice_));
            var deleteInvoiceModalText = 'You\'re about to delete Invoice #' + ($elm$core$String$fromInt($author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice_)) + (' for ' + (due + '. This action cannot be undone.')));
            return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$DeleteInvoiceHiConfirmClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('delete'),
                $author$project$Components$HiConfirm$noun('invoice'),
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    $elm$html$Html$text(deleteInvoiceModalText)
                ]))
            ]));
        } else {
            if (model.hD) {
                var modalHeaderText = 'invoice #' + ($elm$core$String$fromInt($author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice_)) + ' as bad debt');
                var modalBodyText = '\n                Marking an invoice as bad debt will remove it from your outstanding invoices report,\n                but your revenue is unaffected, and it remains on the patient\'s balance\n                ';
                return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$BadDebtHiConfirmClosed, _List_fromArray([
                    $author$project$Components$HiConfirm$verb('mark'),
                    $author$project$Components$HiConfirm$noun(modalHeaderText),
                    $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                        $elm$html$Html$text(modalBodyText)
                    ]))
                ]));
            } else return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Api$Provider$CustomerInvoice$One$adjustments = function(_v0) {
        var record = _v0.b;
        return record.IR;
    };
    var $author$project$Formatters$Time$Time__Only = 3;
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt = function(_v0) {
        var record = _v0.b;
        return record.Mx;
    };
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$position = function(_v0) {
        var record = _v0.b;
        return record.WX;
    };
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$reason = function(_v0) {
        var record = _v0.b;
        return record.Yb;
    };
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$InvoiceAdjustment$Shared$totalAdjustmentInCents(shared);
    };
    var $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$user = function(_v0) {
        var record = _v0.b;
        return record.aaX;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevision = F2(function(timeFormatter, adjustment) {
        var totalAdjustment = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents(adjustment));
        var revisionDescription = $elm$html$Html$text($elm$core$String$concat(_List_fromArray([
            'Revision #',
            $elm$core$String$fromInt($author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$position(adjustment)),
            ' by ',
            A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$User$Shared$name, $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$user(adjustment))),
            ' at ',
            A2(timeFormatter, 3, $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt(adjustment))
        ])));
        var revisionAmount = $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$totalAdjustmentInCents(adjustment) < 0 ? A2($author$project$Ui$Typography$strong, _List_fromArray([
            $author$project$Ui$Typography$danger,
            $author$project$Ui$Typography$pull(1)
        ]), _List_fromArray([
            $elm$html$Html$text(totalAdjustment)
        ])) : A2($author$project$Ui$Typography$strong, _List_fromArray([
            $author$project$Ui$Typography$pull(1)
        ]), _List_fromArray([
            $elm$html$Html$text(totalAdjustment)
        ]));
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('revision__item')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2(timeFormatter, 5, $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$createdAt(adjustment)))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(7)
                ]), _List_fromArray([
                    revisionDescription,
                    function() {
                        var _v0 = $author$project$Api$Provider$InvoiceAdjustment$SharedWithUser$reason(adjustment);
                        if (!_v0.$) {
                            var reason = _v0.a;
                            return A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock,
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text(reason)
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    revisionAmount
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('')
                ]))
            ]))
        ]));
    });
    var $author$project$Api$Provider$CustomerInvoice$One$voidReason = function(_v0) {
        var record = _v0.b;
        return record.aif;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$voidedAt = function(_v0) {
        var record = _v0.b;
        return record.abf;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$voidedByName = function(_v0) {
        var record = _v0.b;
        return record.abg;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewVoidRevision = F2(function(timeFormatter, invoice) {
        var voidDescription = function() {
            var _v1 = _Utils_Tuple2($author$project$Api$Provider$CustomerInvoice$One$voidedByName(invoice), $author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice));
            if (!_v1.a.$ && !_v1.b.$) {
                var name = _v1.a.a;
                var time = _v1.b.a;
                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$concat(_List_fromArray([
                        name,
                        ' at ',
                        A2(timeFormatter, 3, time)
                    ])))
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('revision__item--voided')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, timeFormatter(5), $author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice))))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(7)
                ]), _List_fromArray([
                    $elm$html$Html$text('Voided by '),
                    voidDescription,
                    function() {
                        var _v0 = $author$project$Api$Provider$CustomerInvoice$One$voidReason(invoice);
                        if (!_v0.$) {
                            var reason = _v0.a;
                            return A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock,
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text(reason)
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    $elm$html$Html$text('')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevisions = function(model) {
        var _v0 = model.RA;
        if (_v0.$ === 3) {
            var invoice = _v0.a;
            var isVoided = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'cancelled' && $author$project$Utils$Maybe$toBool($author$project$Api$Provider$CustomerInvoice$One$voidedAt(invoice));
            var adjustments = A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$CustomerInvoice$One$adjustments(invoice));
            var adjustmentsCount = isVoided ? $elm$core$List$length(adjustments) + 1 : $elm$core$List$length(adjustments);
            return adjustmentsCount > 0 ? A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('invoice-revisions mt-4')
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flex,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Invoice Revisions')
                    ])),
                    A2($author$project$Ui$Badge$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt(adjustmentsCount))
                    ]))
                ])),
                A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevision(model.HO), adjustments)),
                isVoided ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewVoidRevision, model.HO, invoice) : $author$project$Utils$Html$empty
            ])) : $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Issue = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIssueButton = F2(function(model, invoice) {
        if ($author$project$Api$Provider$CustomerInvoice$Meta$issueAction($author$project$Api$Provider$CustomerInvoice$One$meta(invoice))) {
            var due = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice));
            var buttonText = 'Issue ' + (due + ' Invoice');
            return A3($author$project$Ui$Button$view, {
                abP: buttonText
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(model.mO),
                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$Issue(invoice))
            ]), _List_fromArray([
                $elm$html$Html$text(buttonText)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultSourceFromList = function(model) {
        var allSources = function() {
            var _v0 = _Utils_Tuple2(model.pQ, model.pF);
            if (_v0.a.$ === 3 && _v0.b.$ === 3) {
                var _v1 = _v0.a;
                var cards = _v1.a;
                var _v2 = _v0.b;
                var bankAccounts = _v2.a;
                return $elm$core$List$reverse(A2($elm$core$List$sortBy, A2($elm$core$Basics$composeR, $author$project$Api$Source$createdAt, A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$time$Time$posixToMillis), $elm$core$Maybe$withDefault(0))), _Utils_ap(A2($elm$core$List$map, $author$project$Api$Source$Card, cards), A2($elm$core$List$map, $author$project$Api$Source$BankAccount, bankAccounts))));
            } else return _List_Nil;
        }();
        var defaultSource = $elm$core$List$head(A2($elm$core$List$filter, $author$project$Api$Source$default, allSources));
        return !_Utils_eq(defaultSource, $elm$core$Maybe$Nothing) ? defaultSource : $elm$core$List$head(allSources);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$UnschedulePaymentClicked = function(a) {
        return {
            $: 33,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$paymentScheduledOn = function(_v0) {
        var record = _v0;
        return record.Wq;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$paymentScheduledOn = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$paymentScheduledOn(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPayment = F2(function(timeFormatter, invoice) {
        if ($author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice)) {
            var paymentScheduledOn = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$CustomerInvoice$One$paymentScheduledOn(invoice)));
            return A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('payment__scheduled')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(2)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(paymentScheduledOn)
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(7)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $author$project$Api$Provider$CustomerInvoice$One$hasGoodPaymentSource(invoice) ? A2($author$project$Ui$Badge$fromString, _List_Nil, 'scheduled') : A2($author$project$Ui$Badge$fromString, _List_Nil, 'scheduled_without_source')
                        ])),
                        $elm$html$Html$text(' '),
                        function() {
                            var _v0 = $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice);
                            if (!_v0.$) {
                                var source = _v0.a;
                                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('on '),
                                    A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                                        $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just($author$project$Api$Source$Source(source))),
                                        $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
                                        $author$project$Components$PaymentSourceDisplayer$limitedView(true)
                                    ]))
                                ]));
                            } else {
                                var _v1 = $author$project$Api$Provider$CustomerInvoice$One$source(invoice);
                                if (!_v1.$) {
                                    var source = _v1.a;
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('on '),
                                        A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                                            $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just($author$project$Api$Source$Source(source))),
                                            $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
                                            $author$project$Components$PaymentSourceDisplayer$limitedView(true)
                                        ]))
                                    ]));
                                } else return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('No payment info')
                                ]));
                            }
                        }()
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(2),
                        $author$project$Ui$Grid$justifyRight
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice)))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Unschedule payment'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$UnschedulePaymentClicked(invoice))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Unschedule')
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow = F4(function(patient, timeFormatter, scheduledPayment, defaultSource) {
        var totalInCents = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$ScheduledPayment$Shared$amountInCents(scheduledPayment) + ($author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(patient) ? A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$ScheduledPayment$Shared$passthroughFeesInCents(scheduledPayment)) : 0));
        var humanStatus = function() {
            var _v4 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
            if (!_v4.$) {
                var payment_ = _v4.a;
                return $author$project$Api$Provider$Payment$One$status(payment_);
            } else return $author$project$Api$Provider$ScheduledPayment$Shared$status(scheduledPayment);
        }();
        var _v0 = function() {
            var _v1 = $author$project$Api$Provider$ScheduledPayment$Shared$paymentSource(scheduledPayment);
            if (!_v1.$) {
                var source = _v1.a;
                return _Utils_Tuple2($elm$html$Html$text('on '), A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                    $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just($author$project$Api$Source$Source(source))),
                    $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                    $author$project$Components$PaymentSourceDisplayer$limitedView(true)
                ])));
            } else return !_Utils_eq(defaultSource, $elm$core$Maybe$Nothing) ? _Utils_Tuple2($elm$html$Html$text('on '), A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                $author$project$Components$PaymentSourceDisplayer$source(defaultSource),
                $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(true),
                $author$project$Components$PaymentSourceDisplayer$limitedView(true)
            ]))) : _Utils_Tuple2($elm$html$Html$text('No payment info'), $author$project$Utils$Html$empty);
        }();
        var paymentInfoText = _v0.a;
        var paymentInfoHtml = _v0.b;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(2)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$ScheduledPayment$Shared$scheduledOn(scheduledPayment)))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(7)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, humanStatus),
                    $elm$html$Html$text(' '),
                    paymentInfoText,
                    paymentInfoHtml,
                    function() {
                        var _v2 = $author$project$Api$Provider$ScheduledPayment$Shared$memo(scheduledPayment);
                        if (!_v2.$) {
                            var memo = _v2.a;
                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text(' - ' + memo)
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                function() {
                    var _v3 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
                    if (!_v3.$) {
                        var payment = _v3.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$createdBy
                        ]), _List_fromArray([
                            $elm$html$Html$text('Created by '),
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'this platform', A2($elm$core$Maybe$map, $author$project$Api$Provider$Payment$Creator$displayName, $author$project$Api$Provider$Payment$One$createdBy(payment)))),
                            $elm$html$Html$text(' on '),
                            $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Provider$Payment$One$createdAt(payment)))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(2),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(totalInCents)
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentList = F5(function(patient, timeFormatter, scheduledPayments, payments, defaultSource) {
        var existingPaymentIds = A2($elm$core$List$map, function(p) {
            return $author$project$Api$Payment$id(p);
        }, payments);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('payment__scheduled')
        ]), A2($elm$core$List$map, function(scheduledPayment) {
            var _v0 = $author$project$Api$Provider$ScheduledPayment$Shared$payment(scheduledPayment);
            if (!_v0.$) {
                var scheduledPaymentPayment_ = _v0.a;
                return A2($elm$core$List$member, $author$project$Api$Provider$Payment$One$id(scheduledPaymentPayment_), existingPaymentIds) ? $author$project$Utils$Html$empty : A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow, patient, timeFormatter, scheduledPayment, defaultSource);
            } else return A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentRow, patient, timeFormatter, scheduledPayment, defaultSource);
        }, scheduledPayments));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPaymentsList = F2(function(model, invoice) {
        var showScheduledPayments = A2($author$project$Utils$FeatureGate$gateAvailable, 12, $author$project$Api$Practice$Provider(model.W1)) && !$elm$core$List$isEmpty(model.j$);
        var payments = A2($elm$core$List$map, $author$project$Api$Payment$Provider_One, A2($author$project$Api$Expandable$withDefault, _List_Nil, $author$project$Api$Provider$CustomerInvoice$One$payments(invoice)));
        return !$elm$core$List$isEmpty(payments) || $author$project$Api$Provider$CustomerInvoice$One$isPaymentScheduled(invoice) || showScheduledPayments ? A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('payments-history mb-4'),
            $author$project$Utils$Html$Attributes$test('payments-history')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Payments')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    showScheduledPayments && $author$project$Api$Provider$CustomerInvoice$Meta$schedulePartialPaymentsAction($author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) && !$author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditButtonDisabled(invoice) ? A3($author$project$Ui$Button$view, {
                        abP: 'Edit scheduled payments'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePartialPaymentsClicked(invoice))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit Scheduled Payments')
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(1)
                ]), _List_fromArray([
                    $elm$html$Html$text('')
                ]))
            ])),
            A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg, A3($author$project$Components$PaymentsList$view, _List_fromArray([
                $author$project$Components$PaymentsList$showCreatedBy(true),
                $author$project$Components$PaymentsList$showRefundMemo(true),
                $author$project$Components$PaymentsList$allowDisputes(true),
                $author$project$Components$PaymentsList$isHintAdmin(model.F3)
            ]), payments, model.jt)),
            showScheduledPayments ? A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPaymentList, model.V7, model.HO, model.j$, payments, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultSourceFromList(model)) : A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewScheduledPayment, model.HO, invoice)
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$CustomerInvoice$Shared$estimatedDueInCents = function(_v0) {
        var record = _v0;
        return record.O7;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$estimatedDueInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$estimatedDueInCents(shared);
    };
    var $author$project$Ui$Typography$m0 = $author$project$Ui$Typography$Margin(25);
    var $author$project$Api$Provider$CustomerInvoice$Shared$subtotalInCents = function(_v0) {
        var record = _v0;
        return record.$v;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$subtotalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$subtotalInCents(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ApplyCreditsClicked = function(a) {
        return {
            $: 29,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RemoveCreditsClicked = function(a) {
        return {
            $: 30,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseCreditTransferClicked = function(a) {
        return {
            $: 32,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$applyCreditsAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Jz;
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$creditInCents = function(_v0) {
        var record = _v0;
        return record.MD;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$creditInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$creditInCents(shared);
    };
    var $author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents = function(_v0) {
        var record = _v0.b;
        return record.ME;
    };
    var $author$project$Ui$Typography$Display5 = {
        $: 27
    };
    var $author$project$Ui$Typography$display5 = $author$project$Ui$Typography$Display5;
    var $author$project$Api$Provider$CustomerInvoice$Meta$removeCreditsAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Yy;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$reverseCreditTransferAction = function(_v0) {
        var meta = _v0;
        return meta.tM.Y5;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents = function(_v0) {
        var record = _v0.b;
        return record.aax;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail = F3(function(invoice, customerInvoiceMeta, hasPassthoughFees) {
        if (!!$author$project$Api$Provider$CustomerInvoice$One$creditInCents(invoice) || !!$author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents(invoice)) {
            var creditTotal = $author$project$Api$Provider$CustomerInvoice$One$creditInCents(invoice) + $author$project$Api$Provider$CustomerInvoice$One$creditToAutoApplyInCents(invoice);
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetMd(7),
                    $author$project$Ui$Grid$spanMd(4),
                    $author$project$Ui$Grid$span(11)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$label, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$m0,
                            $author$project$Ui$Typography$p0
                        ]), _List_fromArray([
                            $elm$html$Html$text('Credit')
                        ])),
                        hasPassthoughFees ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(-creditTotal))
                        ])) : A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$display5
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(-creditTotal))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(1)
                ]), _List_fromArray([
                    $author$project$Api$Provider$CustomerInvoice$Meta$removeCreditsAction(customerInvoiceMeta) ? A3($author$project$Ui$Button$view, {
                        abP: 'Remove credit'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$RemoveCreditsClicked(invoice))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Remove')
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]));
        } else {
            if ($author$project$Api$Provider$CustomerInvoice$Meta$applyCreditsAction(customerInvoiceMeta)) return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetMd(7),
                    $author$project$Ui$Grid$spanMd(4),
                    $author$project$Ui$Grid$span(11)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$label, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$m0,
                            $author$project$Ui$Typography$p0
                        ]), _List_fromArray([
                            $elm$html$Html$text('Credit')
                        ])),
                        hasPassthoughFees ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(0))
                        ])) : A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$display5
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(0))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(1)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Apply credits'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ApplyCreditsClicked(invoice))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Apply')
                    ]))
                ]))
            ]));
            else {
                if ($author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents(invoice) > 0) return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$offsetMd(7),
                        $author$project$Ui$Grid$spanMd(4),
                        $author$project$Ui$Grid$span(11)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter,
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$hintLabel,
                                $author$project$Ui$Typography$m0,
                                $author$project$Ui$Typography$p0
                            ]), _List_fromArray([
                                $elm$html$Html$text('Transferred to Credit')
                            ])),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$display5
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$transferredToCreditInCents(invoice)))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(1)
                    ]), _List_fromArray([
                        $author$project$Api$Provider$CustomerInvoice$Meta$reverseCreditTransferAction(customerInvoiceMeta) ? A3($author$project$Ui$Button$view, {
                            abP: 'Undo credit transfer'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ReverseCreditTransferClicked(invoice))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Undo')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]));
                else return $author$project$Utils$Html$empty;
            }
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSourceIsACreditCard = F4(function(practice, invoice, cards, scheduledPayments) {
        if ($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$allScheduledPaymentsAreNonCard(scheduledPayments)) return false;
        else {
            var _v0 = $author$project$Api$Provider$Practice$One$allowMultipleRetailMemberships(practice) ? $author$project$Api$Provider$CustomerInvoice$One$membershipPaymentSource(invoice) : $elm$core$Maybe$Nothing;
            if (!_v0.$) {
                var source = _v0.a;
                return _Utils_eq($author$project$Api$Common$Source$Shared$type_(source), $elm$core$Maybe$Just('Card'));
            } else return !_Utils_eq($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDefaultCard(cards), $elm$core$Maybe$Nothing);
        }
    });
    var $author$project$Ui$HorizontalRule$Minimal = 2;
    var $author$project$Ui$HorizontalRule$minimal = $author$project$Ui$HorizontalRule$Style(2);
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesInCents = function(passthroughFees) {
        if (passthroughFees.$ === 3) {
            var passthrough = passthroughFees.a;
            return $author$project$Api$Provider$PassthroughFee$One$passthroughFeeInCents(passthrough);
        } else return 0;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesTotalAmount = function(passthroughFees) {
        if (passthroughFees.$ === 3) {
            var passthrough = passthroughFees.a;
            return $author$project$Api$Provider$PassthroughFee$One$totalInCents(passthrough);
        } else return 0;
    };
    var $author$project$Api$Provider$TaxProfile$Shared$forDisplay = function(taxProfile) {
        return $elm$core$String$concat(_List_fromArray([
            $author$project$Api$Provider$TaxProfile$Shared$name(taxProfile),
            $author$project$Utils$String$noBreakSpace,
            'Tax',
            $author$project$Utils$String$noBreakSpace,
            $elm$core$String$fromFloat($author$project$Api$Provider$TaxProfile$Shared$rate(taxProfile)),
            '%'
        ]));
    };
    var $author$project$Api$Provider$CustomerInvoice$Shared$taxInCents = function(_v0) {
        var record = _v0;
        return record.$P;
    };
    var $author$project$Api$Provider$CustomerInvoice$One$taxInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CustomerInvoice$Shared$taxInCents(shared);
    };
    var $author$project$Api$Provider$CustomerInvoice$One$taxProfile = function(_v0) {
        var record = _v0.b;
        return record.$R;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileEditable = function(_v0) {
        var meta = _v0;
        return meta.$R.Ot;
    };
    var $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileViewable = function(_v0) {
        var meta = _v0;
        return meta.$R.abc;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel = F3(function(invoice, hasPassthoughFees, label) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$offsetMd(7),
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$span(11)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    label,
                    hasPassthoughFees ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice)))
                    ])) : A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$display5
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileChanged = function(a) {
        return {
            $: 44,
            a: a
        };
    };
    var $author$project$Api$Provider$TaxProfile$One$forDisplay = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$TaxProfile$Shared$forDisplay(shared);
    };
    var $author$project$Api$Provider$TaxProfile$All$forDisplay = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$TaxProfile$One$forDisplay(one);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxProfileOption = function(taxProfile) {
        return A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$TaxProfileChanged(taxProfile))
        ]), A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$hintLabel
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$TaxProfile$All$forDisplay(taxProfile))
        ])));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail = F5(function(invoice, customerInvoiceMeta, taxProfiles, taxProfileDropdown, hasPassthoughFees) {
        var taxProfileIsViewable = $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileViewable(customerInvoiceMeta) || !!$author$project$Api$Provider$CustomerInvoice$One$taxInCents(invoice);
        var taxProfileIsEditable = $author$project$Api$Provider$CustomerInvoice$Meta$taxProfileEditable(customerInvoiceMeta);
        var maybeTaxProfile = $author$project$Api$Provider$CustomerInvoice$One$taxProfile(invoice);
        var _v0 = _Utils_Tuple3(taxProfileIsViewable, taxProfileIsEditable, maybeTaxProfile);
        _v0$2: while(true){
            if (_v0.a) {
                if (_v0.b) {
                    var currentTaxProfileLabel = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$TaxProfile$Shared$forDisplay, $author$project$Api$Provider$CustomerInvoice$One$taxProfile(invoice)));
                    return A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel, invoice, hasPassthoughFees, A4($author$project$Ui$Dropdown$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel
                        ]), _List_fromArray([
                            $elm$html$Html$text(currentTaxProfileLabel)
                        ]))
                    ]), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxProfileOption, taxProfiles), taxProfileDropdown));
                } else {
                    if (!_v0.c.$) {
                        var taxProfile = _v0.c.a;
                        return A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetailWithLabel, invoice, hasPassthoughFees, A2($author$project$Ui$Typography$label, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$m0,
                            $author$project$Ui$Typography$p0
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$TaxProfile$Shared$forDisplay(taxProfile))
                        ])));
                    } else break _v0$2;
                }
            } else break _v0$2;
        }
        return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail = F2(function(label, content) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$offsetMd(7),
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$span(11)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$m0,
                        $author$project$Ui$Typography$p0
                    ]), _List_fromArray([
                        $elm$html$Html$text(label)
                    ])),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        content
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold = F2(function(label, content) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$offsetMd(7),
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$span(11)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$hintLabel,
                        $author$project$Ui$Typography$m0,
                        $author$project$Ui$Typography$p0
                    ]), _List_fromArray([
                        $elm$html$Html$text(label)
                    ])),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$display5
                    ]), _List_fromArray([
                        content
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewNewInvoiceTotalsSummary = F5(function(model, invoice, meta, taxProfiles, dueTotal) {
        var totalToHtml = function(value) {
            return $elm$html$Html$text($author$project$Utils$Currency$fromInt(value));
        };
        var invoiceHumanStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
        var showCreditCardFeesForDueAmount = $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.V7) && A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$effectivePaymentSourceIsACreditCard, model.W1, invoice, model.pQ, model.j$) && A2($elm$core$List$member, invoiceHumanStatus, _List_fromArray([
            'issued',
            'sent',
            'retrying'
        ]));
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4
        ]), _List_fromArray([
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail, 'Subtotal', totalToHtml($author$project$Api$Provider$CustomerInvoice$One$subtotalInCents(invoice))),
            A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail, invoice, meta, taxProfiles, model.ku, true),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold, 'Invoice Total', totalToHtml($author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice))),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetMd(7),
                    $author$project$Ui$Grid$spanMd(4)
                ]), _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_fromArray([
                        $author$project$Ui$HorizontalRule$minimal
                    ]))
                ]))
            ])),
            A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail, invoice, meta, true),
            invoiceHumanStatus !== 'draft' ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail, 'Paid', totalToHtml($author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice) * -1)) : $author$project$Utils$Html$empty,
            !!$author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(invoice) ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail, 'Credit Card Fees Paid', totalToHtml($author$project$Api$Provider$CustomerInvoice$One$passthroughFeesInCents(invoice) * -1)) : $author$project$Utils$Html$empty,
            invoiceHumanStatus !== 'draft' ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetMd(7),
                    $author$project$Ui$Grid$spanMd(4)
                ]), _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_fromArray([
                        $author$project$Ui$HorizontalRule$minimal
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty,
            showCreditCardFeesForDueAmount ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetail, 'Total Credit Card Fees', totalToHtml($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesInCents(model.V4))) : $author$project$Utils$Html$empty,
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetMd(7),
                    $author$project$Ui$Grid$spanMd(4),
                    $author$project$Ui$Grid$span(11)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$label, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$m0,
                            $author$project$Ui$Typography$p0
                        ]), _List_fromArray([
                            $elm$html$Html$text('Due')
                        ])),
                        showCreditCardFeesForDueAmount ? A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('display-3')
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$passthroughFeesTotalAmount(model.V4)))
                        ])) : A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('display-3')
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(dueTotal))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotals = function(model) {
        var _v0 = _Utils_Tuple2(model.RA, model.g2);
        if (_v0.a.$ === 3 && _v0.b.$ === 3) {
            var _v1 = _v0.a;
            var invoice = _v1.a;
            var _v2 = _v0.b;
            var taxProfiles = _v2.a;
            var totalToHtml = function(value) {
                return $elm$html$Html$text($author$project$Utils$Currency$fromInt(value));
            };
            var meta = $author$project$Api$Provider$CustomerInvoice$One$meta(invoice);
            var invoiceHumanStatus = $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice);
            var dueTotal = invoiceHumanStatus === 'draft' ? $author$project$Api$Provider$CustomerInvoice$One$estimatedDueInCents(invoice) : $author$project$Api$Provider$CustomerInvoice$One$dueInCents(invoice);
            return $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(model.V7) ? A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewNewInvoiceTotalsSummary, model, invoice, meta, taxProfiles, dueTotal) : A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold, 'Subtotal', totalToHtml($author$project$Api$Provider$CustomerInvoice$One$subtotalInCents(invoice))),
                A5($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTaxDetail, invoice, meta, taxProfiles, model.ku, false),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$offsetMd(7),
                        $author$project$Ui$Grid$spanMd(4),
                        $author$project$Ui$Grid$span(11)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter,
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$hintLabel,
                                $author$project$Ui$Typography$m0,
                                $author$project$Ui$Typography$p0
                            ]), _List_fromArray([
                                $elm$html$Html$text('Total')
                            ])),
                            A2($elm$html$Html$span, _List_fromArray([
                                $elm$html$Html$Attributes$class('display-3')
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$CustomerInvoice$One$totalInCents(invoice)))
                            ]))
                        ]))
                    ]))
                ])),
                A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewCreditDetail, invoice, meta, false),
                invoiceHumanStatus !== 'draft' ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold, 'Paid', totalToHtml($author$project$Api$Provider$CustomerInvoice$One$paidInCents(invoice))) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$offsetMd(7),
                        $author$project$Ui$Grid$spanMd(4)
                    ]), _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_fromArray([
                            $author$project$Ui$HorizontalRule$thin
                        ]))
                    ]))
                ])),
                A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold, 'Due', totalToHtml(dueTotal))
            ]));
        } else return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4
        ]), _List_fromArray([
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold, 'Subtotal', $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('$100.00')
            ]))),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetMd(7),
                    $author$project$Ui$Grid$spanMd(4),
                    $author$project$Ui$Grid$span(11)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$label, _List_fromArray([
                            $author$project$Ui$Typography$hintLabel,
                            $author$project$Ui$Typography$m0,
                            $author$project$Ui$Typography$p0
                        ]), _List_fromArray([
                            $elm$html$Html$text('Total')
                        ])),
                        A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('display-3')
                        ]), _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('$100.00')
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold, 'Paid', $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('$100.00')
            ]))),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offsetMd(7),
                    $author$project$Ui$Grid$spanMd(4)
                ]), _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_fromArray([
                        $author$project$Ui$HorizontalRule$thin
                    ]))
                ]))
            ])),
            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotalDetailInBold, 'Due', $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('$100.00')
            ])))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewBody = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$SchedulePaymentModalMsg, $author$project$Components$CustomerSchedulePaymentModal$view(model.gG)),
            A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CustomerEmailModalMsg, $author$project$Components$CustomerEmailModal$modal(model.lM)),
            A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$PaymentsListMsg, $author$project$Components$PaymentsList$modal(model.jt)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHiConfirmModals(model), $author$project$Api$Data$toMaybe(model.RA))),
                    $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewEditInvoiceModal(model.iw),
                    A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$route, model.Gc, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Invoices')
                            ]))
                        ])),
                        A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                            $author$project$Ui$Breadcrumb$active(true)
                        ]), _List_fromArray([
                            function() {
                                var _v0 = model.RA;
                                if (_v0.$ === 3) {
                                    var invoice = _v0.a;
                                    return $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Provider$CustomerInvoice$One$invoiceNumber(invoice)));
                                } else return $author$project$Ui$Skeleton$text(_List_fromArray([
                                    $author$project$Ui$Skeleton$spanFromText('#1234')
                                ]));
                            }()
                        ]))
                    ]))),
                    function() {
                        var _v1 = model.RA;
                        if (_v1.$ === 3) {
                            var invoice = _v1.a;
                            return A3($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeader, model, $author$project$Api$Provider$CustomerInvoice$One$meta(invoice), invoice);
                        } else return $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewHeaderSkeleton;
                    }(),
                    $author$project$Ui$HorizontalRule$view(_List_Nil),
                    A2($elm$core$Maybe$withDefault, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetailsSkeleton, A2($elm$core$Maybe$map, A4($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDetails, model.HO, model.F3, model.Rr, model.W1), $author$project$Api$Data$toMaybe(model.RA))),
                    A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewPaymentsList(model), $author$project$Api$Data$toMaybe(model.RA))),
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Charges')
                    ])),
                    $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewChargesTable(model),
                    function() {
                        var _v2 = model.RA;
                        if (_v2.$ === 3) {
                            var invoice = _v2.a;
                            return $author$project$Api$Provider$CustomerInvoice$One$humanStatus(invoice) === 'draft' ? A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt4
                            ]), _List_fromArray([
                                $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewAddChargeButton
                            ])) : $author$project$Utils$Html$empty;
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewTotals(model),
                    $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewInvoiceRevisions(model)
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), function() {
                    var _v3 = model.RA;
                    if (_v3.$ === 3) {
                        var invoice = _v3.a;
                        return _List_fromArray([
                            A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewDeleteButton, model, invoice),
                            $author$project$Api$Provider$CustomerInvoice$Meta$issueAction($author$project$Api$Provider$CustomerInvoice$One$meta(invoice)) ? A2($author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewIssueButton, model, invoice) : $author$project$Utils$Html$empty
                        ]);
                    } else return _List_Nil;
                }())
            ])),
            function() {
                var _v4 = model.lH;
                if (!_v4.$) {
                    var createPaymentModal = _v4.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePaymentModalMsg, $author$project$Components$Invoice$CreatePaymentModal$view(createPaymentModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v5 = model.h3;
                if (!_v5.$) {
                    var createScheduledPaymentModal = _v5.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreateScheduledPaymentModalMsg, $author$project$Components$Invoice$CreateScheduledPaymentModal$view(createScheduledPaymentModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v6 = model.h1;
                if (!_v6.$) {
                    var createPassthroughFeesPaymentModal = _v6.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$CreatePassthroughFeesPaymentModalMsg, $author$project$Components$CustomerInvoice$CreatePassthroughFeesPaymentModal$view(createPassthroughFeesPaymentModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v7 = model.fj;
                if (!_v7.$) {
                    var chargeModal = _v7.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ChargeModalMsg, $author$project$Components$Patient$Charges$ChargeModal$view(chargeModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v8 = model.hs;
                if (!_v8.$) {
                    var adjustVoidModal = _v8.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$AdjustVoidModalMsg, $author$project$Components$CustomerInvoice$AdjustVoidModal$view(adjustVoidModal));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v9 = model.jI;
                if (!_v9.$) {
                    var processRefundModal = _v9.a;
                    return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$ProcessRefundModalMsg, $author$project$Components$CustomerInvoice$ProcessRefundModal$view(processRefundModal));
                } else return $author$project$Utils$Html$empty;
            }()
        ]);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$view = function(model) {
        return {
            fb: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$viewBody(model),
            $2: 'Patient | Invoices'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$DateRangeInput$additionalItem = F4(function(id, label, start, end) {
        return {
            Fn: end,
            aef: id,
            aeI: label,
            HB: start
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$additionalMonthOptions = function(currentDate) {
        var currentYear = $justinmimbs$date$Date$year(currentDate);
        var firstDayCurrentYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear, 0, 1);
        var firstDayLastYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear - 1, 0, 1);
        var lastDayCurrentYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear, 11, 31);
        var lastDayLastYear = A3($justinmimbs$date$Date$fromCalendarDate, currentYear - 1, 11, 31);
        return _List_fromArray([
            A4($author$project$Components$DateRangeInput$additionalItem, 'current_year', 'Current Year', $elm$core$Maybe$Just(firstDayCurrentYear), $elm$core$Maybe$Just(lastDayCurrentYear)),
            A4($author$project$Components$DateRangeInput$additionalItem, 'last_year', 'Last Year', $elm$core$Maybe$Just(firstDayLastYear), $elm$core$Maybe$Just(lastDayLastYear))
        ]);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            kW: $author$project$Pages$Patients$PatientId_String$Charges$Top$additionalMonthOptions,
            w4: _List_fromArray([
                $author$project$Ui$Grid$span(6)
            ]),
            ad1: start,
            FD: true,
            ahV: end
        });
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$GotInvoices = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices = function(model) {
        var options = function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                VM: $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$id(model.V7)),
                af_: model.af_,
                ahs: A3($author$project$Api$Sort$withDefault, 'date', 1, $author$project$Api$Sort$init),
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ahy: $elm$core$Maybe$Nothing
            });
        };
        return A3($author$project$Api$Provider$CustomerInvoice$list, model.Ej, options, $author$project$Pages$Patients$PatientId_String$Charges$Top$GotInvoices);
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top({
                V8: $author$project$Api$Provider$Patient$One$id(model.V7)
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$init = F5(function(_v0, practice, patient, _v1, _v2) {
        var apiClient = _v1.Ej;
        var timeFormatter = _v1.HO;
        var url = _v1.aaT;
        var currentDate = _v1.cP;
        var query = _v2.Bz;
        var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v3.a;
        var end = _v3.b;
        var _v4 = A2($author$project$Components$DateRangeInput$init, 'date-range', A2($author$project$Pages$Patients$PatientId_String$Charges$Top$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v4.a;
        var dateRangeInputCmd = _v4.b;
        var model = {
            Ej: apiClient,
            cP: currentDate,
            h6: dateRangeInput,
            E8: '',
            it: $author$project$Components$Invoice$DownloadFile$init(url),
            Fn: end,
            q5: $author$project$Api$Data$NotAsked,
            af_: $author$project$Api$Pagination$init,
            V7: patient,
            W1: practice,
            ahs: A3($author$project$Api$Sort$withDefault, 'date', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            HO: timeFormatter,
            aaT: url
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg, dateRangeInputCmd),
            $author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(model),
            $author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(model)
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg, $author$project$Components$Invoice$DownloadFile$subscriptions(model.it))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceCreated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$create = F3(function(apiClient, patientId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('customer_invoice', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('patient', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(patientId))
                ])))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$CustomerInvoice$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CustomerInvoice$customerInvoicesPath)));
    });
    var $author$project$Api$Provider$CustomerInvoice$One$ownerId = A2($elm$core$Basics$composeR, $author$project$Api$Provider$CustomerInvoice$One$owner, $elm$core$Maybe$map($author$project$Api$Provider$Patient$Shared$id));
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        q5: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    q5: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    q5: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(newModel),
                    $author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, model.Ej, subMsg, model.it);
                return _Utils_Tuple3(_Utils_update(model, {
                    it: downloadInvoiceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg, downloadInvoiceResult.EQ), downloadInvoiceResult.at);
            case 3:
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$CustomerInvoice$create, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceCreated), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var invoice = response.a;
                    var _v3 = $author$project$Api$Provider$CustomerInvoice$One$ownerId(invoice);
                    if (!_v3.$) {
                        var ownerId = _v3.a;
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                            RI: $author$project$Api$Provider$CustomerInvoice$One$id(invoice),
                            V8: ownerId
                        })), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Invoice created.')
                        ]));
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 1, 'We were unable to create an invoice.')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v4.a;
                var subCmd = _v4.b;
                var event = _v4.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        var label = event.c;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            E8: label,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$Charges$Top$fetchInvoices(newModel),
                    $author$project$Pages$Patients$PatientId_String$Charges$Top$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$One$overdueAmountInCents = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.VJ;
    });
    var $author$project$Api$Provider$Patient$One$owedInCents = function(_v0) {
        var record = _v0.b;
        return record.VL;
    };
    var $author$project$Components$Invoice$DownloadFile$FetchToken = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Invoice$DownloadFile$viewAndGenerateToken = F3(function(model, path, options) {
        return A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('inline text-left')
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Download ' + options.aeI
            }, _List_fromArray([
                $author$project$Ui$Button$onClick(A2($author$project$Components$Invoice$DownloadFile$FetchToken, path, options.M6)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$export)
            ]), _List_fromArray([
                $elm$html$Html$text(options.aeI)
            ])),
            model.Sk ? $author$project$Components$Invoice$DownloadFile$viewModal : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Api$Provider$CustomerInvoice$All$dueInCents = function(_v0) {
        var record = _v0;
        return record.Ol;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$isPaymentScheduled = function(_v0) {
        var record = _v0;
        return record.Si;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$issuedTotalInCents = function(_v0) {
        var record = _v0;
        return record.SH;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$lastSentAt = function(_v0) {
        var record = _v0;
        return record.SY;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate = function(_v0) {
        var record = _v0;
        return record.U1;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$paidAt = function(_v0) {
        var record = _v0;
        return record.VQ;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$paymentScheduledOn = function(_v0) {
        var record = _v0;
        return record.Wq;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted = function(scheduledDate) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), scheduledDate));
    };
    var $author$project$Api$Provider$CustomerInvoice$All$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$CustomerInvoice$All$totalInCents = function(_v0) {
        var record = _v0;
        return record.aam;
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$viewInvoiceRow = F4(function(timeFormatter, patientId, practice, invoice) {
        var issuedTotalInCents = $author$project$Api$Provider$CustomerInvoice$All$issuedTotalInCents(invoice);
        var issueDate = A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$CustomerInvoice$All$date(invoice));
        var invoiceId = $author$project$Api$Provider$CustomerInvoice$All$id(invoice);
        var invoiceRoute = $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
            RI: invoiceId,
            V8: patientId
        });
        var humanStatus = _List_fromArray([
            A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$CustomerInvoice$All$humanStatus(invoice)),
            function() {
                if ($author$project$Api$Provider$CustomerInvoice$All$isPaymentScheduled(invoice)) {
                    var paymentScheduledOnTextValue = A2($author$project$Utils$FeatureGate$gateAvailable, 12, $author$project$Api$Practice$Provider(practice)) && !_Utils_eq($author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate(invoice), $elm$core$Maybe$Nothing) ? $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted($author$project$Api$Provider$CustomerInvoice$All$nextScheduledPaymentDate(invoice)) : $author$project$Pages$Patients$PatientId_String$Charges$Top$scheduledDateValueFormatted($author$project$Api$Provider$CustomerInvoice$All$paymentScheduledOn(invoice));
                    var paymentScheduledOnFullText = $elm$core$String$isEmpty(paymentScheduledOnTextValue) ? '' : A2($elm$core$String$append, ' payment scheduled for ', paymentScheduledOnTextValue);
                    return A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(paymentScheduledOnFullText)
                    ]));
                } else {
                    if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'sent') {
                        var lastSentAtText = A2($elm$core$String$append, ' last sent at ', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, timeFormatter(5), $author$project$Api$Provider$CustomerInvoice$All$lastSentAt(invoice))));
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$small
                        ]), _List_fromArray([
                            $elm$html$Html$text(lastSentAtText)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }
            }(),
            function() {
                if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'paid') {
                    var paidAtText = A2($elm$core$String$append, ' on ', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, timeFormatter(5), $author$project$Api$Provider$CustomerInvoice$All$paidAt(invoice))));
                    return A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(paidAtText)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]);
        var dueInCents = $author$project$Api$Provider$CustomerInvoice$All$dueInCents(invoice);
        var amount = _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_Nil, function() {
                if ($author$project$Api$Provider$CustomerInvoice$All$status(invoice) === 'draft') return _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(issuedTotalInCents))
                    ]))
                ]);
                else {
                    var totalInCents = $author$project$Api$Provider$CustomerInvoice$All$totalInCents(invoice);
                    return !_Utils_eq(totalInCents, issuedTotalInCents) ? _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$strike,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(issuedTotalInCents))
                        ])),
                        $elm$html$Html$text(' ' + $author$project$Utils$Currency$fromInt(totalInCents))
                    ]) : _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(totalInCents))
                    ]);
                }
            }()),
            !_Utils_eq(dueInCents, $author$project$Api$Provider$CustomerInvoice$All$totalInCents(invoice)) ? dueInCents > 0 ? A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text(' (' + ($author$project$Utils$Currency$fromInt(dueInCents) + ' owed)'))
            ])) : dueInCents < 0 ? A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text(' (-' + ($author$project$Utils$Currency$fromInt(dueInCents) + ' overpaid)'))
            ])) : $elm$html$Html$text('') : $elm$html$Html$text('')
        ]);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, invoiceRoute, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(issueDate)
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, invoiceRoute, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Provider$CustomerInvoice$All$invoiceNumber(invoice)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$minWidth('12em')
            ]), amount),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$minWidth('12em')
            ]), humanStatus)
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceButtonClicked = {
        $: 3
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$viewNewInvoiceButton = A3($author$project$Ui$Button$view, {
        abP: 'Add invoice'
    }, _List_fromArray([
        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Charges$Top$NewInvoiceButtonClicked),
        $author$project$Ui$Button$icon($author$project$Ui$Icon$add),
        $author$project$Ui$Button$default
    ]), _List_fromArray([
        $elm$html$Html$text('Add Invoice')
    ]));
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$view = function(_v0) {
        var invoices = _v0.q5;
        var pagination = _v0.af_;
        var timeFormatter = _v0.HO;
        var patient = _v0.V7;
        var currentDate = _v0.cP;
        var downloadInvoice = _v0.it;
        var dateRangeInput = _v0.h6;
        var start = _v0.HB;
        var end = _v0.Fn;
        var practice = _v0.W1;
        var patientId = $author$project$Api$Provider$Patient$One$id(patient);
        var path = A2($author$project$Api$Data$pathAppend, _List_fromArray([
            patientId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients'
        ]), $author$project$Api$Data$providerPath));
        var _v1 = function() {
            if (invoices.$ === 3) {
                var inv = invoices.a;
                return _Utils_Tuple2(false, inv);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v1.a;
        var invoices_ = _v1.b;
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Invoices')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanLg(3),
                                $author$project$Ui$Grid$spanSm(12)
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(dateRangeInput))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanLg(1),
                                $author$project$Ui$Grid$spanSm(6)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$ml2
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$primary
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Balance:')
                                    ])),
                                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Patient$One$owedInCents(patient)))
                                    ]))
                                ]))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanLg(2),
                                $author$project$Ui$Grid$spanSm(6)
                            ]), _List_fromArray([
                                !!$author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) ? A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$ml2
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$primary
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(' Past Due:')
                                    ])),
                                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$danger
                                    ]), _List_fromArray([
                                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Patient$One$overdueAmountInCents(patient)))
                                    ]))
                                ])) : $author$project$Utils$Html$empty
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanLg(6),
                                $author$project$Ui$Grid$spanSm(12),
                                $author$project$Ui$Grid$justifyRight
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$gap2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$DownloadInvoiceMsg, A3($author$project$Components$Invoice$DownloadFile$viewAndGenerateToken, downloadInvoice, path, {
                                        abS: true,
                                        M6: {
                                            FI: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start))),
                                            Gg: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)))
                                        },
                                        aeI: 'Export Account Statement'
                                    })),
                                    $author$project$Pages$Patients$PatientId_String$Charges$Top$viewNewInvoiceButton
                                ]))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A4($author$project$Ui$Table$view, _List_fromArray([
                            $author$project$Ui$Table$verticalCentered,
                            $author$project$Ui$Table$loading(loading),
                            $author$project$Ui$Table$zeroState(_List_fromArray([
                                $elm$html$Html$text('This patient has no invoices')
                            ]))
                        ]), _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Date')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Number')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Amount')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Status')
                            ]))
                        ]), A2($elm$core$List$map, A3($author$project$Pages$Patients$PatientId_String$Charges$Top$viewInvoiceRow, timeFormatter, patientId, practice), invoices_), _List_Nil)
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Charges$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(loading)
                        ]), pagination))
                    ]))
                ]))
            ]),
            $2: 'Patient | Invoices'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Charges$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Charges$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Charges$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Charges$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Charges$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Charges$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Charges$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$Chart$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Chart$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Chart$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Patients$PatientId_String$Chart$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Patient Chart'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Chart$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Patients$PatientId_String$Chart$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Chart$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Patients$PatientId_String$Chart$update,
        aid: $author$project$Pages$Patients$PatientId_String$Chart$view
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$GotCompany = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$GotMeta = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$init = F5(function(session, practice, patient, shared, _v0) {
        var params = _v0.VU;
        var _v1 = function() {
            var _v2 = $author$project$Api$Provider$Patient$One$company(patient);
            if (!_v2.$) {
                var company_ = _v2.a;
                return _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$Company$retrieve, shared.Ej, $author$project$Api$Provider$Company$Min$id(company_), $author$project$Pages$Patients$PatientId_String$Edit$GotCompany));
            } else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
        }();
        var company = _v1.a;
        var retrieveCompanyCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            acy: company,
            cP: shared.cP,
            PU: $elm$core$Maybe$Nothing,
            aeb: shared.aeb,
            aef: params.V8,
            Ue: $author$project$Api$Data$Loading,
            gf: $elm$core$Maybe$Nothing,
            V7: patient,
            W1: practice,
            Z$: session,
            km: false
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            retrieveCompanyCmd,
            A4($author$project$Api$Patient$Meta$retrieve, shared.Ej, session, $author$project$Api$Provider$Patient$One$id(patient), $author$project$Pages$Patients$PatientId_String$Edit$GotMeta)
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked = {
        $: 6
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$FormMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$subscriptions = function(_v0) {
        var form = _v0.PU;
        var openModal = _v0.gf;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Patient$Form$subscriptions, $elm$core$Platform$Sub$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg)), form)),
            function() {
                if (!openModal.$) {
                    if (!openModal.a) {
                        var _v2 = openModal.a;
                        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked);
                    } else {
                        var _v3 = openModal.a;
                        return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked);
                    }
                } else return $elm$core$Platform$Sub$none;
            }()
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$PatientArchived = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$PatientUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$delete = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientPath(id_)));
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm = F8(function(session, practice, hinterViewOff, patient, apiClient, currentDate, company, meta) {
        return A8($author$project$Components$Patient$Form$fill, apiClient, session, currentDate, A2($elm$core$Maybe$map, $author$project$Api$Company$Provider, company), false, $author$project$Api$Patient$One$Provider(patient), meta, function(settings) {
            return _Utils_update(settings, {
                ab1: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
                ab8: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
                Qr: $author$project$Api$Provider$Practice$One$hasLocations(practice),
                Qx: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
                ae_: $author$project$Api$Provider$Practice$One$isMce(practice),
                ru: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
                agQ: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
                YK: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
                agR: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
                YP: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
                YQ: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
                _$: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
                $D: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, $author$project$Api$Provider$Practice$One$network(practice))),
                ah_: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
                aaq: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
                aas: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
                DT: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0)
            });
        });
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm = function(model) {
        var _v0 = _Utils_Tuple2(model.acy, model.Ue);
        _v0$2: while(true){
            if (_v0.b.$ === 3) switch(_v0.a.$){
                case 3:
                    var _v1 = _v0.a;
                    var company_ = _v1.a;
                    var _v2 = _v0.b;
                    var meta = _v2.a;
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A8($author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm, model.Z$, model.W1, model.aeb, model.V7, model.Ej, model.cP, $elm$core$Maybe$Just(company_), meta)));
                case 0:
                    var _v3 = _v0.a;
                    var _v4 = _v0.b;
                    var meta = _v4.a;
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A8($author$project$Pages$Patients$PatientId_String$Edit$fillPatientForm, model.Z$, model.W1, model.aeb, model.V7, model.Ej, model.cP, $elm$core$Maybe$Nothing, meta)));
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Api$Provider$Patient$update = F4(function(apiClient, id_, jsonBody, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, jsonBody, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                var modelWithCompany = _Utils_update(model, {
                    acy: response
                });
                var _v1 = $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm(modelWithCompany);
                var form = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(modelWithCompany, {
                    PU: form
                }), cmd, _List_Nil);
            case 1:
                var response = msg.a;
                var modelWithMeta = _Utils_update(model, {
                    Ue: response
                });
                var _v2 = $author$project$Pages$Patients$PatientId_String$Edit$initPatientForm(modelWithMeta);
                var form = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(modelWithMeta, {
                    PU: form
                }), cmd, _List_Nil);
            case 2:
                var formMsg = msg.a;
                if (formMsg.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                    V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                })), _List_fromArray([
                    $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7)),
                    A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated ' + $author$project$Api$Provider$Patient$One$id(model.V7))
                ]));
                else {
                    var _v4 = model.PU;
                    if (!_v4.$) {
                        var form = _v4.a;
                        var _v5 = function() {
                            var _v6 = model.acy;
                            if (_v6.$ === 3) {
                                var company_ = _v6.a;
                                return A5($author$project$Components$Patient$Form$update, model.Ej, model.Z$, $elm$core$Maybe$Just($author$project$Api$Company$Provider(company_)), formMsg, form);
                            } else return A5($author$project$Components$Patient$Form$update, model.Ej, model.Z$, $elm$core$Maybe$Nothing, formMsg, form);
                        }();
                        var newForm = _v5.a;
                        var formCmd = _v5.b;
                        var formOutMsgs = _v5.c;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Edit$FormMsg, formCmd), formOutMsgs);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var _v7 = model.PU;
                if (!_v7.$) {
                    var form = _v7.a;
                    var _v8 = $author$project$Components$Patient$Form$validate(form);
                    if (!_v8.$) {
                        var _v9 = _v8.a;
                        var validForm = _v9.a;
                        var validFields = _v9.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: true
                        }), A4($author$project$Api$Provider$Patient$update, model.Ej, model.aef, A2($author$project$Components$Patient$Form$encode, validFields, validForm), $author$project$Pages$Patients$PatientId_String$Edit$PatientUpdated), _List_Nil);
                    } else {
                        var erroredForm = _v8.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: $elm$core$Maybe$Just(erroredForm)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var patient = response.a;
                        var createAffiliationResult = function() {
                            var _v12 = model.PU;
                            if (!_v12.$) {
                                var form = _v12.a;
                                var affiliationId = A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliate$AffiliateMin$id, $author$project$Api$Provider$Patient$One$assignedAffiliation(model.V7));
                                return A5($author$project$Components$Patient$Form$createAffiliation, model.Ej, model.Z$, $author$project$Api$Provider$Patient$One$id(patient), affiliationId, form);
                            } else return {
                                v6: false,
                                EQ: $elm$core$Platform$Cmd$none
                            };
                        }();
                        var _v11 = createAffiliationResult.v6 ? _Utils_Tuple2(A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Edit$FormMsg, createAffiliationResult.EQ), _List_Nil) : _Utils_Tuple2(A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                            V8: $author$project$Api$Provider$Patient$One$id(patient)
                        })), _List_fromArray([
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(patient)),
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully updated ' + $author$project$Api$Provider$Patient$One$id(patient))
                        ]));
                        var cmd = _v11.a;
                        var outMsgs = _v11.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), cmd, outMsgs);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            km: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 5:
                var openModal = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    gf: $elm$core$Maybe$Just(openModal)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    gf: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    gf: $elm$core$Maybe$Nothing
                }), A3($author$project$Api$Provider$Patient$delete, model.Ej, model.aef, $author$project$Pages$Patients$PatientId_String$Edit$PatientArchived), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    gf: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                            V8: model.aef
                        })), _List_fromArray([
                            $author$project$OutMsg$RetrievePatient(model.aef),
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully archived ' + model.aef)
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                return _Utils_Tuple3(model, $author$project$Ports$Navigation$back, _List_Nil);
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$CancelButtonClicked = {
        $: 9
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$FormSubmitted = {
        $: 3
    };
    var $author$project$Api$Provider$Patient$Shared$archived = function(_v0) {
        var shared = _v0;
        return shared.JC;
    };
    var $author$project$Api$Provider$Patient$One$archived = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$archived(shared);
    };
    var $author$project$Api$Provider$Patient$One$isSynced = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.Su;
    });
    var $author$project$Components$AddressInput$skeleton = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(7)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(5)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(8)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ]))
        ]))
    ]));
    var $author$project$Components$NameInput$skeleton = A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(2)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(6),
            $author$project$Ui$Grid$spanMd(3)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(4),
            $author$project$Ui$Grid$spanMd(2)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(7),
            $author$project$Ui$Grid$spanMd(3)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanSm(5),
            $author$project$Ui$Grid$spanMd(2)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ]))
    ]));
    var $author$project$Components$PhoneInput$skeleton = function(repeat) {
        return _Utils_ap(A2($elm$core$List$repeat, repeat, A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(8)
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$input(_List_Nil)
            ]))
        ]))), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Add Another Phone')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Patient$Form$skeleton = _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Legal Name'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Components$NameInput$skeleton,
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(4)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Date of Birth'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Sex'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(3)
                ]))
            ]))
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Gender Identity'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Pronoun'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Email'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Phones'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), $author$project$Components$PhoneInput$skeleton(1)),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Address'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Components$AddressInput$skeleton
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Provider'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Location'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Health Insurance'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton('Lead Source'),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpanMd(8)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ]))
    ]);
    var $author$project$Pages$Patients$PatientId_String$Edit$unlessRestricted = F2(function(hideSection, body) {
        return hideSection ? $author$project$Utils$Html$empty : body;
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$CannotArchive = 0;
    var $author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchive = 1;
    var $author$project$Api$Patient$Meta$archive = function(_v0) {
        var actions = _v0.b;
        return actions.JB;
    };
    var $author$project$Utils$MetaFields$isActionable = $elm$core$Basics$identity;
    var $author$project$Pages$Patients$PatientId_String$Edit$viewArchiveButton = F2(function(patient, meta) {
        var openArchiveModalMsg = $author$project$Utils$MetaFields$isActionable($author$project$Api$Patient$Meta$archive(meta)) ? $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked(1) : $author$project$Pages$Patients$PatientId_String$Edit$ArchiveButtonClicked(0);
        return A3($author$project$Ui$Button$view, {
            abP: 'Archive patient'
        }, _List_fromArray([
            $author$project$Ui$Button$danger,
            $author$project$Ui$Button$disabled($author$project$Api$Provider$Patient$One$archived(patient)),
            $author$project$Ui$Button$onClick(openArchiveModalMsg)
        ]), _List_fromArray([
            $elm$html$Html$text('Archive')
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Edit$viewCannotArchiveModal = A3($author$project$Ui$Modal$view, $author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked, _List_fromArray([
        $author$project$Ui$Modal$size(1)
    ]), _List_fromArray([
        $author$project$Ui$Modal$header(_List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Cannot Archive Patient')
            ]))
        ])),
        $author$project$Ui$Modal$body(_List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('You cannot archive a patient in the following situations:')
            ])),
            A2($elm$html$Html$ul, _List_Nil, _List_fromArray([
                A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If they have an uncollected balance')
                ])),
                A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If they have an active membership')
                ])),
                A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If they are actively linked to a company')
                ]))
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('To archive the patient, cancel any charges or mark them as bad debt, end any memberships, and unlink any companies.')
            ]))
        ])),
        $author$project$Ui$Modal$footer(_List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Close'
            }, _List_fromArray([
                $author$project$Ui$Button$styled(0),
                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Edit$CloseArchiveModalClicked)
            ]), _List_fromArray([
                $elm$html$Html$text('OK')
            ]))
        ]))
    ]));
    var $author$project$Pages$Patients$PatientId_String$Edit$confirmArchiveMessage = _List_fromArray([
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Are you sure you want to archive this patient? This will disable all payments and emails to this patient.')
            ]))
        ]))
    ]);
    var $author$project$Pages$Patients$PatientId_String$Edit$viewConfirmArchiveModal = A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Edit$ConfirmArchiveModalClicked, _List_fromArray([
        $author$project$Components$HiConfirm$verb('archive'),
        $author$project$Components$HiConfirm$noun('patient'),
        $author$project$Components$HiConfirm$customMessage($author$project$Pages$Patients$PatientId_String$Edit$confirmArchiveMessage)
    ]));
    var $author$project$Pages$Patients$PatientId_String$Edit$viewMergeButton = function(patient) {
        var button = A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Merge({
            V8: $author$project$Api$Provider$Patient$One$id(patient)
        }), _List_fromArray([
            $author$project$Ui$Link$buttonWarning,
            $author$project$Ui$Link$disabled($author$project$Api$Provider$Patient$One$membershipStatus(patient) !== 'inactive')
        ]), _List_fromArray([
            $elm$html$Html$text('Merge')
        ]));
        return $author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive' ? button : A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
            button
        ]), _List_fromArray([
            A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Patient must be inactive in order to be merged into another record.')
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.gf;
                    if (!_v0.$) {
                        if (!_v0.a) {
                            var _v1 = _v0.a;
                            return $author$project$Pages$Patients$PatientId_String$Edit$viewCannotArchiveModal;
                        } else {
                            var _v2 = _v0.a;
                            return $author$project$Pages$Patients$PatientId_String$Edit$viewConfirmArchiveModal;
                        }
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$onSubmit($author$project$Pages$Patients$PatientId_String$Edit$FormSubmitted)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: model.aef
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Patient')
                                ])),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$gray
                                ]), _List_fromArray([
                                    $elm$html$Html$text('  /  Edit Patient')
                                ]))
                            ])),
                            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                                $author$project$Ui$HorizontalRule$thin
                            ])),
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Edit Patient')
                            ])),
                            function() {
                                var _v3 = model.PU;
                                if (!_v3.$) {
                                    var form = _v3.a;
                                    return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Patients$PatientId_String$Edit$FormMsg), $author$project$Components$Patient$Form$view(form)));
                                } else return A2($elm$html$Html$div, _List_Nil, $author$project$Components$Patient$Form$skeleton);
                            }()
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$justifyCenter,
                            $author$project$Ui$Element$gap2
                        ]), function() {
                            var _v4 = model.Ue;
                            if (_v4.$ === 3) {
                                var meta = _v4.a;
                                return _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Cancel and go back'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Edit$CancelButtonClicked)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Cancel')
                                    ])),
                                    A2($author$project$Pages$Patients$PatientId_String$Edit$unlessRestricted, $author$project$Api$Provider$Patient$One$isSynced(model.V7), A2($author$project$Pages$Patients$PatientId_String$Edit$viewArchiveButton, model.V7, meta)),
                                    $author$project$Pages$Patients$PatientId_String$Edit$viewMergeButton(model.V7),
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Update patient'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$primary,
                                        $author$project$Ui$Button$disabled($author$project$Api$Provider$Patient$One$archived(model.V7)),
                                        $author$project$Ui$Button$submit,
                                        $author$project$Ui$Button$loading(model.km)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Update')
                                    ]))
                                ]);
                            } else return _List_Nil;
                        }())
                    ]))
                ]))
            ]),
            $2: 'Patient | ' + model.aef
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Edit$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Edit$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Edit$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Edit$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Edit$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Edit$update,
        aid: $author$project$Pages$Patients$PatientId_String$Edit$view
    });
    var $author$project$Pages$Patients$PatientId_String$GrowthChart$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$GrowthChart$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$GrowthChart$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Patients$PatientId_String$GrowthChart$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Growth Chart'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$GrowthChart$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Patients$PatientId_String$GrowthChart$init,
        aeR: $author$project$Pages$Patients$PatientId_String$GrowthChart$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Patients$PatientId_String$GrowthChart$update,
        aid: $author$project$Pages$Patients$PatientId_String$GrowthChart$view
    });
    var $author$project$Pages$Patients$PatientId_String$LabTrends$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$LabTrends$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$LabTrends$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Patients$PatientId_String$LabTrends$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Lab Trends'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$LabTrends$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Patients$PatientId_String$LabTrends$init,
        aeR: $author$project$Pages$Patients$PatientId_String$LabTrends$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Patients$PatientId_String$LabTrends$update,
        aid: $author$project$Pages$Patients$PatientId_String$LabTrends$view
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusDropdownMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$GotCredits = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Credit$creditsPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'credits'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId));
    };
    var $author$project$Api$Provider$Credit$All$Credit = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Credit$Shared$Credit = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Credit$Shared$Record = function(id) {
        return function(name) {
            return function(amountInCents) {
                return function(balanceInCents) {
                    return function(createdAt) {
                        return function(expiresOn) {
                            return function(expiresSoon) {
                                return function(isEditable) {
                                    return function(isExpired) {
                                        return function(issuedOn) {
                                            return function(reason) {
                                                return function(transferredInCents) {
                                                    return function(creditCategory) {
                                                        return {
                                                            Jh: amountInCents,
                                                            abW: balanceInCents,
                                                            Mx: createdAt,
                                                            MB: creditCategory,
                                                            Pj: expiresOn,
                                                            Pk: expiresSoon,
                                                            aef: id,
                                                            aeD: isEditable,
                                                            R4: isExpired,
                                                            SC: issuedOn,
                                                            zr: name,
                                                            Yb: reason,
                                                            aaw: transferredInCents
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Credit$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credit_category', $author$project$Api$Provider$CreditCategory$Shared$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transferred_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reason', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_expired', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_editable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'expires_soon', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'expires_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'balance_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Credit$Shared$Record))))))))))))));
    var $author$project$Api$Provider$Credit$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Credit$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Credit$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Credit$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$Credit$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: A3($author$project$Api$Sort$withDefault, 'issued_on', 0, $author$project$Api$Sort$init),
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Patient$Credit$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Patient$Credit$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.ahy;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Patient$Credit$list = F4(function(apiClient, patientId, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Credit$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Patient$Credit$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$Credit$creditsPath(patientId))));
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue = function(option) {
        switch(option){
            case 1:
                return 'zero_balance';
            case 2:
                return 'outstanding';
            default:
                return 'all';
        }
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits = function(model) {
        var options = function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                ahs: A3($author$project$Api$Sort$withDefault, 'issued_on', 1, $author$project$Api$Sort$init),
                ahy: $elm$core$Maybe$Just($author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue(model.ahy))
            });
        };
        return A4($author$project$Api$Provider$Patient$Credit$list, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), options, $author$project$Pages$Patients$PatientId_String$ManageCredits$GotCredits);
    };
    var $author$project$Components$ResourceFilter$CreditCategory$list = $author$project$Api$Provider$CreditCategory$list;
    var $author$project$Components$ResourceFilter$CreditCategory$resourceFromAll = function(category) {
        return {
            Jh: $author$project$Api$Provider$CreditCategory$All$amountInCents(category),
            Pi: $author$project$Api$Provider$CreditCategory$All$expiresInDays(category),
            aef: $author$project$Api$Provider$CreditCategory$All$id(category),
            zr: $author$project$Api$Provider$CreditCategory$All$name(category)
        };
    };
    var $author$project$Components$ResourceFilter$CreditCategory$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$CreditCategory$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query
            });
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$CreditCategory$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$CreditCategory$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$CreditCategory$list, apiClient, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($elm$core$List$map($author$project$Components$ResourceFilter$CreditCategory$resourceFromAll))));
    });
    var $author$project$Components$ResourceFilter$CreditCategory$selectId = 'credit_category';
    var $author$project$Components$ResourceFilter$CreditCategory$toTitle = function($) {
        return $.zr;
    };
    var $author$project$Components$ResourceFilter$CreditCategory$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$CreditCategory$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$CreditCategory$toValue = function($) {
        return $.aef;
    };
    var $author$project$Components$ResourceFilter$CreditCategory$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$CreditCategory$fetchResources,
            aef: $author$project$Components$ResourceFilter$CreditCategory$selectId,
            gD: 'Category',
            sz: $author$project$Components$ResourceFilter$CreditCategory$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$CreditCategory$toLabel,
            ahZ: $author$project$Components$ResourceFilter$CreditCategory$toTitle,
            g4: $author$project$Components$ResourceFilter$CreditCategory$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$initColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'issued_on', false, 'Issued On'),
        A3($author$project$Api$Column$init, '', false, 'Category'),
        A3($author$project$Api$Column$init, '', false, 'Reason'),
        A3($author$project$Api$Column$init, 'expires_on', false, 'Expires'),
        A3($author$project$Api$Column$init, 'amount_in_cents', false, 'Total Amount'),
        A3($author$project$Api$Column$init, 'used_in_cents', false, 'Amount Left')
    ]);
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$All = 0;
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$Outstanding = 2;
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$ZeroBalance = 1;
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionFromQuery = function(queryString) {
        _v0$2: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'zero_balance':
                    return 1;
                case 'outstanding':
                    return 2;
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return 0;
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$url$Url$Builder$string, 'status', $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToValue(model.ahy))
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits({
                V8: $author$project$Api$Provider$Patient$One$id(model.V7)
            }))
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), queryParams))));
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$init = F5(function(_v0, practice, patient, _v1, _v2) {
        var apiClient = _v1.Ej;
        var currentDate = _v1.cP;
        var query = _v2.Bz;
        var _v3 = A2($author$project$Components$ResourceFilter$CreditCategory$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Credit Category',
                I5: false,
                afn: false
            });
        });
        var creditCategoriesResourceFilter = _v3.a;
        var creditCategoriesResourceFilterCmd = _v3.b;
        var model = {
            Ej: apiClient,
            LC: $author$project$Pages$Patients$PatientId_String$ManageCredits$initColumns,
            r: $elm$core$Maybe$Nothing,
            fn: creditCategoriesResourceFilter,
            a$: $author$project$Api$Data$Loading,
            cP: currentDate,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            V7: patient,
            W1: practice,
            ahs: A3($author$project$Api$Sort$withDefault, 'issued_on', 1, $author$project$Api$Sort$initFromQuery(query)),
            ahy: $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionFromQuery(A2($elm$core$Dict$get, 'status', query)),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'credits-status-dropdown-filter',
                ahX: $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model),
            $author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(model),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, creditCategoriesResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit = {
        $: 2
    };
    var $author$project$Components$ResourceFilter$CreditCategory$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$subscriptions = function(_v0) {
        var credit = _v0.r;
        var statusDropdown = _v0.oD;
        var creditCategoriesResourceFilter = _v0.fn;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(statusDropdown),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, $author$project$Components$ResourceFilter$CreditCategory$subscriptions(creditCategoriesResourceFilter)),
            function() {
                if (!credit.$) return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit);
                else return $elm$core$Platform$Sub$none;
            }()
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategory = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryOnly = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$Date = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Credit$Shared$category = function(_v0) {
        var record = _v0;
        return record.MB;
    };
    var $author$project$Api$Provider$Credit$All$category = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$category(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg = F2(function(a, b) {
        return {
            $: 8,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Credit$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Credit$All$amountInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$Credit$Shared$expiresOn = function(_v0) {
        var record = _v0;
        return record.Pj;
    };
    var $author$project$Api$Provider$Credit$All$expiresOn = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$expiresOn(shared);
    };
    var $author$project$Api$Provider$Credit$Shared$reason = function(_v0) {
        var record = _v0;
        return record.Yb;
    };
    var $author$project$Api$Provider$Credit$All$reason = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$reason(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsFromCredit = function(credit) {
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2({
            Jh: $elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Provider$Credit$All$amountInCents(credit))),
            MB: $elm$core$Maybe$Nothing,
            qg: dateInput,
            Pj: $author$project$Api$Provider$Credit$All$expiresOn(credit),
            Yb: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Credit$All$reason(credit))
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput), dateInputCmd));
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsInit = function() {
        var _v0 = $author$project$Components$DateInput$init;
        var dateInput = _v0.a;
        var dateInputCmd = _v0.b;
        return _Utils_Tuple2({
            Jh: $elm$core$Maybe$Nothing,
            MB: $elm$core$Maybe$Nothing,
            qg: dateInput,
            Pj: $elm$core$Maybe$Nothing,
            Yb: ''
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput), dateInputCmd));
    }();
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate = F3(function(currentDate, field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    Yb: string
                });
            case 1:
                var maybeCurrency = field.a;
                return _Utils_update(fields, {
                    Jh: maybeCurrency
                });
            case 2:
                var dateInput = field.a;
                var maybeDate = field.b;
                return _Utils_update(fields, {
                    qg: dateInput,
                    Pj: maybeDate
                });
            case 3:
                var creditCategory = field.a;
                return _Utils_update(fields, {
                    Jh: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, creditCategory.Jh),
                    MB: $elm$core$Maybe$Just(creditCategory),
                    Pj: function() {
                        var _v1 = creditCategory.Pi;
                        if (!_v1.$) {
                            var days = _v1.a;
                            return $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, days, currentDate));
                        } else return $elm$core$Maybe$Nothing;
                    }()
                });
            default:
                var creditCategory = field.a;
                return _Utils_update(fields, {
                    MB: $elm$core$Maybe$Just(creditCategory)
                });
        }
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$NameValidation = 0;
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.MB;
        }, _Utils_Tuple2(0, 'Please enter a category.'))
    ]));
    var $author$project$Api$Provider$Credit$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Credit$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$id(shared);
    };
    var $author$project$Api$Provider$Credit$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Credit$One$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$name(shared);
    };
    var $author$project$Components$ResourceFilter$CreditCategory$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCreated = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Credit$One$Credit = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Credit$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Credit$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$Credit$create = F4(function(apiClient, patientId, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('credit', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('credit_category', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(fields.EZ))
                ]))),
                _Utils_Tuple2('amount_in_cents', $elm$json$Json$Encode$int(fields.Jh)),
                _Utils_Tuple2('expires_on', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Pj)),
                _Utils_Tuple2('reason', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Yb))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Credit$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$Credit$creditsPath(patientId))));
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$createCredit = F3(function(apiClient, patientId, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            Jh: A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Jh)),
            EZ: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.MB)),
            Pj: fields.Pj,
            Yb: fields.Yb === '' ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(fields.Yb)
        };
        return A4($author$project$Api$Provider$Patient$Credit$create, apiClient, patientId, apiFields, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCreated);
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditUpdated = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Credit$creditPath = F2(function(patientId, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Patient$Credit$creditsPath(patientId));
    });
    var $author$project$Api$Provider$Patient$Credit$update = F5(function(apiClient, patientId, id_, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('credit', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('credit_category', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(fields.EZ))
                ]))),
                _Utils_Tuple2('amount_in_cents', $elm$json$Json$Encode$int(fields.Jh)),
                _Utils_Tuple2('expires_on', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.Pj)),
                _Utils_Tuple2('reason', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.Yb))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Credit$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Patient$Credit$creditPath, patientId, id_))));
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$updateCredit = F4(function(apiClient, patientId, id, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        var apiFields = {
            Jh: A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, fields.Jh)),
            EZ: A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, fields.MB)),
            Pj: fields.Pj,
            Yb: $elm$core$Maybe$Just(fields.Yb)
        };
        return A5($author$project$Api$Provider$Patient$Credit$update, apiClient, patientId, id, apiFields, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditUpdated);
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$saveCredit = F4(function(patientId, maybeId, apiClient, formFields) {
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A4($author$project$Pages$Patients$PatientId_String$ManageCredits$updateCredit, apiClient, patientId, id_, formFields);
        } else return A3($author$project$Pages$Patients$PatientId_String$ManageCredits$createCredit, apiClient, patientId, formFields);
    });
    var $author$project$Components$ResourceFilter$CreditCategory$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        a$: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    a$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var field = msg.a;
                var _v2 = model.r;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var id = _v3.a;
                    var form = _v3.b;
                    var credit = _v3.c;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.cP), field, form);
                    return _Utils_Tuple3(_Utils_update(model, {
                        r: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, credit))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    r: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v4 = $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsInit;
                var form = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    r: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Nothing, $author$project$Utils$Form$init(form), $author$project$Api$Data$NotAsked))
                }), cmd, _List_Nil);
            case 5:
                var form = msg.a;
                var maybeId = msg.b;
                var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsValidator, form);
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var newForm = _v6.a;
                    var validFormFields = _v6.b;
                    var patientId = $author$project$Api$Provider$Patient$One$id(model.V7);
                    return _Utils_Tuple3(_Utils_update(model, {
                        r: $elm$core$Maybe$Just(_Utils_Tuple3(maybeId, newForm, $author$project$Api$Data$Loading))
                    }), A4($author$project$Pages$Patients$PatientId_String$ManageCredits$saveCredit, patientId, maybeId, model.Ej, validFormFields), _List_Nil);
                } else {
                    var newForm = _v5.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        r: $elm$core$Maybe$Just(_Utils_Tuple3(maybeId, newForm, $author$project$Api$Data$NotAsked))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 4:
                var credit = msg.a;
                var _v7 = function(categoryId) {
                    return A2($author$project$Components$ResourceFilter$CreditCategory$preSelectedId, categoryId, model.fn);
                }($elm$core$Maybe$Just($author$project$Api$Provider$CreditCategory$Shared$id($author$project$Api$Provider$Credit$All$category(credit))));
                var newFilter = _v7.a;
                var filterCmd = _v7.b;
                var _v8 = $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsFromCredit(credit);
                var newForm = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    r: $elm$core$Maybe$Just(_Utils_Tuple3($elm$core$Maybe$Just($author$project$Api$Provider$Credit$All$id(credit)), $author$project$Utils$Form$init(newForm), $author$project$Api$Data$NotAsked)),
                    fn: newFilter
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, filterCmd)
                ])), _List_Nil);
            case 6:
                var response = msg.a;
                var _v9 = model.r;
                if (!_v9.$) {
                    var _v10 = _v9.a;
                    var id = _v10.a;
                    var form = _v10.b;
                    if (response.$ === 3) {
                        var credit = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            r: $elm$core$Maybe$Nothing,
                            a$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully created ' + $author$project$Api$Provider$Credit$One$name(credit)),
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        r: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v12 = model.r;
                if (!_v12.$) {
                    var _v13 = _v12.a;
                    var id = _v13.a;
                    var form = _v13.b;
                    if (response.$ === 3) {
                        var credit = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            r: $elm$core$Maybe$Nothing,
                            a$: $author$project$Api$Data$Loading
                        }), $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(model), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Credit$One$name(credit) + ' was successfully updated.'),
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7))
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        r: $elm$core$Maybe$Just(_Utils_Tuple3(id, form, response))
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var dateInput = msg.a;
                var subMsg = msg.b;
                var _v15 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
                var newDateInput = _v15.a;
                var subCmd = _v15.b;
                var event = _v15.c;
                var _v16 = model.r;
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var id = _v17.a;
                    var form = _v17.b;
                    var credit = _v17.c;
                    var newForm = function() {
                        if (event.$ === 1) {
                            var date = event.a;
                            return A3($author$project$Utils$Form$update, $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.cP), A2($author$project$Pages$Patients$PatientId_String$ManageCredits$Date, newDateInput, date), form);
                        } else {
                            var _v19 = $author$project$Utils$Form$fields(form);
                            var expiresOn = _v19.Pj;
                            return A3($author$project$Utils$Form$update, $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.cP), A2($author$project$Pages$Patients$PatientId_String$ManageCredits$Date, newDateInput, expiresOn), form);
                        }
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        r: $elm$core$Maybe$Just(_Utils_Tuple3(id, newForm, credit))
                    }), subCmd, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v20 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var dropdown = _v20.a;
                var dropdownCmd = _v20.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: dropdown
                }), dropdownCmd, _List_Nil);
            case 10:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    a$: $author$project$Api$Data$Loading,
                    ahy: status
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
                    $author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
                ])), _List_Nil);
            case 11:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    a$: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
                    $author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
                ])), _List_Nil);
            case 12:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    a$: $author$project$Api$Data$Loading,
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$ManageCredits$fetchCredits(newModel),
                    $author$project$Pages$Patients$PatientId_String$ManageCredits$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var resourceResult = A3($author$project$Components$ResourceFilter$CreditCategory$update, model.Ej, subMsg, model.fn);
                var newCredit = A2($elm$core$Maybe$map, function(_v21) {
                    var id = _v21.a;
                    var form = _v21.b;
                    var credit = _v21.c;
                    var newForm = function() {
                        var _v22 = resourceResult.adu;
                        if (!_v22.$ && !_v22.a.$ && !_v22.a.a.$) {
                            var creditCategory = _v22.a.a.a;
                            var formField = function() {
                                if (!id.$) return $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryOnly(creditCategory);
                                else return $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategory(creditCategory);
                            }();
                            return A3($author$project$Utils$Form$update, $author$project$Pages$Patients$PatientId_String$ManageCredits$formFieldsUpdate(model.cP), formField, form);
                        } else return form;
                    }();
                    return _Utils_Tuple3(id, newForm, credit);
                }, model.r);
                return _Utils_Tuple3(_Utils_update(model, {
                    r: newCredit,
                    fn: resourceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, resourceResult.EQ), _List_Nil);
        }
    });
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$NewCredit = {
        $: 3
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$PaginationMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$SortTable = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$AmountInCents = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$Reason = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$SaveCredit = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Form$Accessible$CreditCategoryFilter = F3(function(a, b, c) {
        return {
            $: 12,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Form$Accessible$creditCategoryFilter = $author$project$Ui$Form$Accessible$CreditCategoryFilter;
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditModal = F4(function(creditCategoryResourceFilter, maybeId, form, credit) {
        var modalConfig = {
            QG: $elm$core$Maybe$Nothing,
            aeI: 'Credit',
            Tk: _Utils_eq(credit, $author$project$Api$Data$Loading),
            TR: maybeId,
            TS: $elm$core$Maybe$Nothing,
            Vl: $author$project$Pages$Patients$PatientId_String$ManageCredits$CancelCreditEdit,
            Vn: $author$project$Pages$Patients$PatientId_String$ManageCredits$SaveCredit(form)
        };
        var _v0 = $author$project$Utils$Form$fields(form);
        var amountInCents = _v0.Jh;
        var expiresOn = _v0.Pj;
        var reason = _v0.Yb;
        var dateInput = _v0.qg;
        return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
            A4($author$project$Ui$Form$Accessible$single, 'Category', _List_fromArray([
                $author$project$Ui$Form$Accessible$labelSpan(4),
                $author$project$Ui$Form$Accessible$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Accessible$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]), A3($author$project$Ui$Form$Accessible$creditCategoryFilter, $author$project$Pages$Patients$PatientId_String$ManageCredits$CreditCategoryResourceFilterMsg, _List_fromArray([
                $author$project$Components$ResourceFilter$disabled($author$project$Utils$Maybe$toBool(maybeId))
            ]), creditCategoryResourceFilter)),
            A4($author$project$Ui$Form$Accessible$single, 'Reason', _List_fromArray([
                $author$project$Ui$Form$Accessible$labelSpan(4)
            ]), _List_Nil, $author$project$Ui$Form$Accessible$textInput(_List_fromArray([
                $author$project$Ui$Form$Input$value(reason),
                $author$project$Ui$Form$Input$placeholder('Extra info about credit'),
                $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated, $author$project$Pages$Patients$PatientId_String$ManageCredits$Reason))
            ]))),
            A4($author$project$Ui$Form$Accessible$single, 'Expires', _List_fromArray([
                $author$project$Ui$Form$Accessible$labelSpan(4)
            ]), _List_Nil, A3($author$project$Ui$Form$Accessible$dateInput, $author$project$Pages$Patients$PatientId_String$ManageCredits$DateInputMsg(dateInput), _List_fromArray([
                $author$project$Components$DateInput$value(expiresOn)
            ]), dateInput)),
            A4($author$project$Ui$Form$Accessible$single, 'Amount', _List_fromArray([
                $author$project$Ui$Form$Accessible$labelSpan(4),
                $author$project$Ui$Form$Accessible$required(true)
            ]), _List_fromArray([
                $author$project$Ui$Form$Accessible$inputSpan(8)
            ]), $author$project$Ui$Form$Accessible$currencyInput(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(amountInCents),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$Patients$PatientId_String$ManageCredits$FormUpdated, $author$project$Pages$Patients$PatientId_String$ManageCredits$AmountInCents)),
                $author$project$Ui$Form$CurrencyInput$placeholder('100.00')
            ])))
        ]));
    });
    var $author$project$Ui$Table$Danger = 4;
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$EditCredit = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Credit$Shared$balanceInCents = function(_v0) {
        var record = _v0;
        return record.abW;
    };
    var $author$project$Api$Provider$Credit$All$balanceInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$balanceInCents(shared);
    };
    var $author$project$Api$Provider$Credit$Shared$expiresSoon = function(_v0) {
        var record = _v0;
        return record.Pk;
    };
    var $author$project$Api$Provider$Credit$All$expiresSoon = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$expiresSoon(shared);
    };
    var $author$project$Api$Provider$Credit$Shared$isExpired = function(_v0) {
        var record = _v0;
        return record.R4;
    };
    var $author$project$Api$Provider$Credit$All$isExpired = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$isExpired(shared);
    };
    var $author$project$Api$Provider$Credit$Shared$issuedOn = function(_v0) {
        var record = _v0;
        return record.SC;
    };
    var $author$project$Api$Provider$Credit$All$issuedOn = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$issuedOn(shared);
    };
    var $author$project$Api$Provider$Credit$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$name(shared);
    };
    var $author$project$Api$Provider$Credit$Shared$transferredInCents = function(_v0) {
        var record = _v0;
        return record.aaw;
    };
    var $author$project$Api$Provider$Credit$All$transferredInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Credit$Shared$transferredInCents(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditRow = function(credit) {
        var zeroBalance = !$author$project$Api$Provider$Credit$All$balanceInCents(credit);
        var rowOptions = zeroBalance ? _List_fromArray([
            $author$project$Ui$Table$styled(4)
        ]) : _List_Nil;
        var reason = A2($elm$core$Maybe$withDefault, '-', $author$project$Api$Provider$Credit$All$reason(credit));
        var name = $author$project$Formatters$String$humanize($author$project$Api$Provider$Credit$All$name(credit));
        var issuedOn = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Credit$All$issuedOn(credit)));
        var expiresOn = function() {
            var _v0 = $author$project$Api$Provider$Credit$All$expiresOn(credit);
            if (!_v0.$) {
                var expiration = _v0.a;
                return $author$project$Api$Provider$Credit$All$isExpired(credit) ? $elm$html$Html$text('Expired') : $author$project$Api$Provider$Credit$All$expiresSoon(credit) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$danger
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiration))
                ])) : $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiration));
            } else return $elm$html$Html$text('Never');
        }();
        var amountLeft = !$author$project$Api$Provider$Credit$All$amountInCents(credit) ? $author$project$Api$Provider$Credit$All$transferredInCents(credit) : $author$project$Api$Provider$Credit$All$amountInCents(credit);
        return A2($author$project$Ui$Table$row, rowOptions, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(issuedOn)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(name)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Tooltip$view, _List_fromArray([
                    $author$project$Ui$Tooltip$placement(0)
                ]), reason, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 35, reason))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                expiresOn
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt(amountLeft))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Credit$All$balanceInCents(credit)))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                zeroBalance ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
                    abP: 'Edit credit'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$ManageCredits$EditCredit(credit)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$edit),
                    $author$project$Ui$Button$link
                ]), _List_fromArray([
                    $elm$html$Html$text('Edit')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$StatusFiltered = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel = function(option) {
        switch(option){
            case 1:
                return 'Applied';
            case 2:
                return 'Outstanding';
            default:
                return 'All Credits';
        }
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$statusDropdownOptions = function(currentStatusOption) {
        var statusOptionToItem = function(option) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatusOption, option)),
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$Patients$PatientId_String$ManageCredits$StatusFiltered(option))
            ]), $elm$html$Html$text($author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel(option)));
        };
        return A2($elm$core$List$cons, statusOptionToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, statusOptionToItem, _List_fromArray([
            1,
            2
        ]))));
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$viewStatusDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Pages$Patients$PatientId_String$ManageCredits$statusOptionToLabel(model.ahy))
        ]), $author$project$Pages$Patients$PatientId_String$ManageCredits$statusDropdownOptions(model.ahy), model.oD);
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$view = function(model) {
        var patient = model.V7;
        var credits = model.a$;
        var credit = model.r;
        var patientId = $author$project$Api$Provider$Patient$One$id(patient);
        var _v0 = function() {
            if (credits.$ === 3) {
                var data = credits.a;
                return _Utils_Tuple2(false, data);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var creds = _v0.b;
        return {
            fb: _List_fromArray([
                function() {
                    if (!credit.$) {
                        var _v3 = credit.a;
                        var id = _v3.a;
                        var form = _v3.b;
                        var credit_ = _v3.c;
                        return A4($author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditModal, model.fn, id, form, credit_);
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween,
                            $author$project$Ui$Element$itemsCenter
                        ]), _List_fromArray([
                            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: patientId
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Patient')
                                ])),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$gray
                                ]), _List_fromArray([
                                    $elm$html$Html$text('  /  Manage Credits')
                                ]))
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Add credit'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$ManageCredits$NewCredit),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Add Credit')
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(4)
                            ]), _List_fromArray([
                                $author$project$Pages$Patients$PatientId_String$ManageCredits$viewStatusDropdown(model)
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Ui$HorizontalRule$view(_List_fromArray([
                            $author$project$Ui$HorizontalRule$thin
                        ])),
                        A4($author$project$Ui$Table$view, _List_fromArray([
                            $author$project$Ui$Table$verticalCentered,
                            $author$project$Ui$Table$loading(loading),
                            $author$project$Ui$Table$zeroState(_List_fromArray([
                                $elm$html$Html$text('This patient has no credits. You can add credits by clicking \'Add Credit\' above.')
                            ]))
                        ]), $elm$core$List$concat(_List_fromArray([
                            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Pages$Patients$PatientId_String$ManageCredits$SortTable)), model.LC),
                            _List_fromArray([
                                A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                            ])
                        ])), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$viewCreditRow, creds), _List_Nil)
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$ManageCredits$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(loading)
                        ]), model.af_))
                    ]))
                ]))
            ]),
            $2: 'Patient | Credits'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$ManageCredits$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$ManageCredits$init,
        aeR: $author$project$Pages$Patients$PatientId_String$ManageCredits$load,
        ag3: $author$project$Pages$Patients$PatientId_String$ManageCredits$save,
        ahE: $author$project$Pages$Patients$PatientId_String$ManageCredits$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$ManageCredits$update,
        aid: $author$project$Pages$Patients$PatientId_String$ManageCredits$view
    });
    var $author$project$Api$Provider$Membership$CoveragePlan = 0;
    var $author$project$Components$Membership$Form$GotCancellationReasons = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$GotItem = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$new = F5(function(apiClient, ownerId, companyAccountId, expand, toMsg) {
        var query = A2($elm$core$List$cons, A2($author$project$Api$Param$string, 'owner', ownerId), A2($elm$core$List$cons, A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand)), function() {
            if (!companyAccountId.$) {
                var string = companyAccountId.a;
                return _List_fromArray([
                    A2($author$project$Api$Param$string, 'company_account', string)
                ]);
            } else return _List_Nil;
        }()));
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, query, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'new'
        ]), $author$project$Api$Provider$Membership$membershipsPath))));
    });
    var $author$project$Components$Membership$Form$retrieveItem = F2(function(apiClient, id) {
        return A4($author$project$Api$Provider$Membership$retrieve, apiClient, id, _List_fromArray([
            0
        ]), $author$project$Components$Membership$Form$GotItem);
    });
    var $author$project$Components$Membership$Form$init = function(apiClient) {
        return function(timeZone) {
            return function(currentDate) {
                return function(session) {
                    return function(practice) {
                        return function(hinterViewOff) {
                            return function(query) {
                                return function(patient) {
                                    return function(id) {
                                        return function(currentTime) {
                                            return function(url) {
                                                var cmd = function() {
                                                    if (!id.$) {
                                                        var id_ = id.a;
                                                        return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id_);
                                                    } else return A5($author$project$Api$Provider$Membership$new, apiClient, $author$project$Api$Provider$Patient$One$id(patient), A2($elm$core$Dict$get, 'company_account', query), _List_fromArray([
                                                        0
                                                    ]), $author$project$Components$Membership$Form$GotItem);
                                                }();
                                                return _Utils_Tuple2({
                                                    dA: $elm$core$Maybe$Nothing,
                                                    acb: $author$project$Api$Data$Loading,
                                                    cP: currentDate,
                                                    fr: $elm$core$Maybe$Nothing,
                                                    aeb: hinterViewOff,
                                                    aef: id,
                                                    iZ: !$author$project$Utils$Maybe$toBool(id),
                                                    jc: $elm$core$Maybe$Nothing,
                                                    gi: $elm$core$Maybe$Nothing,
                                                    V7: patient,
                                                    da: $elm$core$Maybe$Nothing,
                                                    W1: practice,
                                                    jG: $author$project$Api$Data$NotAsked,
                                                    er: $jinjor$elm_debounce$Debounce$init,
                                                    jP: $elm$core$Maybe$Nothing,
                                                    jU: $elm$core$Maybe$Nothing,
                                                    gF: true,
                                                    j_: $author$project$Api$Data$NotAsked,
                                                    l: $elm$core$Maybe$Nothing,
                                                    Z$: session,
                                                    HO: A2($author$project$Formatters$Time$init, timeZone, currentTime),
                                                    HP: timeZone,
                                                    aaT: url
                                                }, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                    cmd,
                                                    A4($author$project$Api$CancellationReason$list, apiClient, session, function(d) {
                                                        return _Utils_update(d, {
                                                            af_: A2($author$project$Api$Pagination$withItemsPerPage, 100, $author$project$Api$Pagination$init)
                                                        });
                                                    }, $author$project$Components$Membership$Form$GotCancellationReasons)
                                                ])));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$init = F5(function(session, practice, patient, _v0, _v1) {
        var apiClient = _v0.Ej;
        var timeZone = _v0.HP;
        var currentDate = _v0.cP;
        var hinterViewOff = _v0.aeb;
        var currentTime = _v0.acJ;
        var url = _v0.aaT;
        var params = _v1.VU;
        var query = _v1.Bz;
        var _v2 = $author$project$Components$Membership$Form$init(apiClient)(timeZone)(currentDate)(session)(practice)(hinterViewOff)(query)(patient)($elm$core$Maybe$Just(params.y0))(currentTime)(url);
        var form = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, cmd);
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Membership$Form$save = F2(function(model, shared) {
        var pendingChangesExists = !model.iZ && !model.gF;
        return _Utils_update(shared, {
            af8: pendingChangesExists ? $elm$core$Maybe$Just('You have draft changes to your membership. Are you sure you want to leave?') : $elm$core$Maybe$Nothing
        });
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$save = F2(function(_v0, shared) {
        var form = _v0.PU;
        return A2($author$project$Components$Membership$Form$save, form, shared);
    });
    var $author$project$Components$Membership$Form$CancelModalMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$ContractsMsg = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$DeleteHiConfirmClosed = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$MembersMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$PlanChangeMsg = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringChargesMsg = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RenewContractModalMsg = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RestartModalMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$SummaryMsg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$CancelModal$Close = {
        $: 1
    };
    var $author$project$Components$Membership$Form$CancelModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$CancelModal$Close);
    };
    var $author$project$Components$Membership$Form$OutsideAgeRangeModal$subscriptions = F2(function(onClose, _v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose(false));
    });
    var $author$project$Components$Membership$Form$RenewContractModal$Close = {
        $: 0
    };
    var $author$project$Components$Membership$Form$RenewContractModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RenewContractModal$Close);
    };
    var $author$project$Components$Membership$Form$RestartModal$Close = {
        $: 1
    };
    var $author$project$Components$Membership$Form$RestartModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RestartModal$Close);
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$subscriptions = function(_v0) {
        var model = _v0;
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$second, model.fd)));
    };
    var $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$CreatePatientModal$Close = {
        $: 0
    };
    var $author$project$Components$CreatePatientModal$PatientFormMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$CreatePatientModal$subscriptions = function(_v0) {
        var form = _v0.PU;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$CreatePatientModal$Close),
            A2($elm$core$Platform$Sub$map, $author$project$Components$CreatePatientModal$PatientFormMsg, $author$project$Components$Patient$Form$subscriptions(form))
        ]));
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$subscriptions = function(_v0) {
        var model = _v0;
        return A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$CreatePatientModal$subscriptions, model.h2)));
    };
    var $author$project$Components$Membership$Form$Sections$Members$subscriptions = function(_v0) {
        var membershipPatients = _v0.T$;
        return $elm$core$Platform$Sub$batch(A2($elm$core$List$map, function(_v1) {
            var id = _v1.a;
            var _v2 = _v1.b;
            var membershipPatient = _v2.b;
            return A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id), $author$project$Components$Membership$Form$Members$MembershipPatient$subscriptions(membershipPatient));
        }, $elm$core$Dict$toList(membershipPatients)));
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$CloseModal = {
        $: 1
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed = F3(function(a, b, c) {
        return {
            $: 7,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v1 = model.PU;
                if (!_v1.$) return $author$project$Components$Admin$CreateEditModal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$Sections$PlanChange$CloseModal);
                else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, function(_v2) {
                var membershipId = _v2.a;
                var scheduledChange = _v2.c;
                return $author$project$Components$HiConfirm$subscribeToEscapeKeyPress(A2($author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed, membershipId, scheduledChange));
            }, model.fr))
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit = {
        $: 0
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit);
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$subscriptions = function(_v0) {
        var model = _v0;
        var _v1 = model.fm;
        if (!_v1.$) {
            var createEditModal = _v1.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$subscriptions(createEditModal));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $author$project$Components$BrokerDeal$CreateModal$subscriptions), model.h$))),
            $author$project$Components$AuditTrailLog$isOpen(model.hB) ? A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$subscriptions(model.hB)) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Components$Membership$Form$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            function() {
                var _v0 = model.dA;
                if (!_v0.$) {
                    var cancelModal = _v0.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$CancelModalMsg, $author$project$Components$Membership$Form$CancelModal$subscriptions(cancelModal));
                } else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v1 = model.jU;
                if (!_v1.$) {
                    var restartModal = _v1.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$RestartModalMsg, $author$project$Components$Membership$Form$RestartModal$subscriptions(restartModal));
                } else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v2 = model.gi;
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var outsideAgeRangeModal = _v3.a;
                    return A2($author$project$Components$Membership$Form$OutsideAgeRangeModal$subscriptions, $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed, outsideAgeRangeModal);
                } else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v4 = model.l;
                if (!_v4.$) {
                    var sections = _v4.a;
                    return $elm$core$Platform$Sub$batch(_List_fromArray([
                        A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$SummaryMsg, $author$project$Components$Membership$Form$Sections$Summary$subscriptions(sections.$x)),
                        A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$MembersMsg, $author$project$Components$Membership$Form$Sections$Members$subscriptions(sections.B)),
                        A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$RecurringChargesMsg, $author$project$Components$Membership$Form$Sections$RecurringCharges$subscriptions(sections.Yl)),
                        A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$ContractsMsg, $author$project$Components$Membership$Form$Sections$Contracts$subscriptions(sections.aD)),
                        function() {
                            var _v5 = sections.jw;
                            if (!_v5.$) {
                                var planChange = _v5.a;
                                return A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$PlanChangeMsg, $author$project$Components$Membership$Form$Sections$PlanChange$subscriptions(planChange));
                            } else return $elm$core$Platform$Sub$none;
                        }()
                    ]));
                } else return $elm$core$Platform$Sub$none;
            }(),
            function() {
                var _v6 = model.jP;
                if (!_v6.$) {
                    var renewContractModal = _v6.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Components$Membership$Form$RenewContractModalMsg, $author$project$Components$Membership$Form$RenewContractModal$subscriptions(renewContractModal));
                } else return $elm$core$Platform$Sub$none;
            }(),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Components$Membership$Form$DeleteHiConfirmClosed), A2($elm$core$Maybe$map, $elm$core$Tuple$first, model.fr)))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$subscriptions = function(model) {
        return $author$project$Components$Membership$Form$subscriptions(model.PU);
    };
    var $author$project$Components$Membership$Form$BillsOverviewMsg = function(a) {
        return {
            $: 24,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Confirmed = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Contract = {
        $: 3
    };
    var $author$project$Components$Membership$Form$Deleted = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Members = {
        $: 1
    };
    var $author$project$Components$Membership$Form$Pricing = {
        $: 2
    };
    var $author$project$Components$Membership$Form$PricingMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges = {
        $: 4
    };
    var $author$project$Components$Membership$Form$Summary = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$confirm = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'confirm'
        ]), $author$project$Api$Provider$Membership$membershipPath(id))));
    });
    var $author$project$Components$Membership$Form$PriceCheckDebounced = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$debouncePriceCheck = function(cmd) {
        return A2($elm$core$Task$perform, $author$project$Components$Membership$Form$PriceCheckDebounced, $elm$core$Task$succeed(cmd));
    };
    var $author$project$Api$Provider$Membership$delete = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipPath(id)));
    });
    var $author$project$Api$Provider$MembershipContract$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Components$Membership$Form$CancelModal$EndDateInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$CancelModal$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Membership$Meta$endDateDefaultValue = function(_v0) {
        var meta = _v0;
        return meta.qv.NE;
    };
    var $author$project$Api$Provider$Membership$One$meta = function(_v0) {
        var record = _v0.b;
        return record.Ue;
    };
    var $author$project$Components$Membership$Form$CancelModal$initFormFields = function(membership) {
        return {
            ab9: $elm$core$Maybe$Nothing,
            aca: $elm$core$Maybe$Nothing,
            qv: $author$project$Api$Provider$Membership$Meta$endDateDefaultValue($author$project$Api$Provider$Membership$One$meta(membership))
        };
    };
    var $author$project$Components$Membership$Form$CancelModal$init = F2(function(currentDate, membership) {
        var fields = $author$project$Components$Membership$Form$CancelModal$initFormFields(membership);
        var _v0 = $author$project$Components$DateInput$init;
        var endDateInput = _v0.a;
        var endDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            fd: $author$project$Api$Data$NotAsked,
            cP: currentDate,
            qx: endDateInput,
            PU: $author$project$Utils$Form$init(fields),
            jc: membership
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModal$EndDateInputMsg, endDateInputCmd));
    });
    var $author$project$Components$Membership$Form$OutsideAgeRangeModal$init = F4(function(minimumAge, maximumAge, belowAgePatients, aboveAgePatients) {
        return {
            tL: aboveAgePatients,
            vM: belowAgePatients,
            TQ: maximumAge,
            Un: minimumAge
        };
    });
    var $author$project$Components$Membership$Form$RenewContractModal$init = F2(function(membershipId, lastContractEndDate) {
        return {
            F9: lastContractEndDate,
            y0: membershipId,
            ae0: $elm$core$Maybe$Nothing,
            nZ: $author$project$Api$Data$NotAsked
        };
    });
    var $author$project$Components$Membership$Form$RestartModal$GotPriceCheck = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$restart = F5(function(apiClient, id, priceCheck, nextBillDate, toMsg) {
        var body = $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            priceCheck ? _List_fromArray([
                _Utils_Tuple2('check_price', $elm$json$Json$Encode$bool(true))
            ]) : _List_Nil,
            _List_fromArray([
                _Utils_Tuple2('next_bill_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, nextBillDate))
            ])
        ])));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'restart'
        ]), $author$project$Api$Provider$Membership$membershipPath(id)))));
    });
    var $author$project$Components$Membership$Form$RestartModal$init = F4(function(apiClient, currentDate, nextBillDate, membership) {
        var dateInput = $author$project$Components$DateInput$initFromDate(A2($elm$core$Maybe$withDefault, currentDate, nextBillDate));
        return _Utils_Tuple2({
            cP: currentDate,
            qg: dateInput,
            jc: membership,
            UY: $elm$core$Maybe$Nothing,
            da: $elm$core$Maybe$Nothing,
            sy: $author$project$Api$Data$NotAsked
        }, A5($author$project$Api$Provider$Membership$restart, apiClient, $author$project$Api$Provider$Membership$One$id(membership), true, nextBillDate, $author$project$Components$Membership$Form$RestartModal$GotPriceCheck));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$fixedPeriodRateInCentsEdited = function(_v0) {
        var form = _v0.PU;
        var _v1 = $author$project$Utils$Form$fields(form);
        var manuallySet = _v1.cc;
        return manuallySet.X5;
    };
    var $elm_community$list_extra$List$Extra$count = function(predicate) {
        return A2($elm$core$List$foldl, F2(function(x, acc) {
            return predicate(x) ? acc + 1 : acc;
        }), 0);
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$fixedPeriodRateInCentsEdited = function(_v0) {
        var editFixedPeriodRateInCents = _v0.d2;
        return editFixedPeriodRateInCents;
    };
    var $author$project$Components$Membership$Form$Sections$Members$fixedPeriodRateInCentsEditedCount = function(_v0) {
        var membershipPatients = _v0.T$;
        return A2($elm_community$list_extra$List$Extra$count, $author$project$Components$Membership$Form$Members$MembershipPatient$fixedPeriodRateInCentsEdited, A2($elm$core$List$map, $elm$core$Tuple$second, $elm$core$Dict$values(membershipPatients)));
    };
    var $author$project$Components$Membership$Form$Sections$Members$membersFields = function(_v0) {
        var membershipPatients = _v0.T$;
        return membershipPatients;
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields = function(_v0) {
        var form = _v0.PU;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Components$Membership$Form$initSectionsShared = F5(function(patient, membership, pendingMembership, sections, model) {
        var _v0 = sections;
        var pricing = _v0.cm;
        var members = _v0.B;
        var patients = A2($elm$core$List$filterMap, function($) {
            return $.V7;
        }, A2($elm$core$List$map, $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields, A2($elm$core$List$map, $elm$core$Tuple$second, A2($elm$core$List$sortBy, $elm$core$Tuple$first, $elm$core$Dict$values($author$project$Components$Membership$Form$Sections$Members$membersFields(members))))));
        var fixedPeriodRateInCentsEditedCount = $author$project$Components$Membership$Form$Sections$Members$fixedPeriodRateInCentsEditedCount(members) + ($author$project$Components$Membership$Form$Sections$Pricing$fixedPeriodRateInCentsEdited(pricing) ? 1 : 0);
        var onlyOneFixedPeriodRateInCentsEditable = _Utils_eq(fixedPeriodRateInCentsEditedCount, $elm$core$List$length(patients));
        return {
            iZ: model.iZ,
            jc: membership,
            afT: onlyOneFixedPeriodRateInCentsEditable,
            VM: patient,
            AD: patients,
            da: pendingMembership,
            agm: _Utils_eq(model.jG, $author$project$Api$Data$Loading),
            gF: model.gF
        };
    });
    var $author$project$Components$Membership$Form$patientsOutsideAgeRange = F2(function(plan, sections) {
        var patients = A2($elm$core$List$filterMap, function($) {
            return $.V7;
        }, A2($elm$core$List$map, $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields, A2($elm$core$List$map, $elm$core$Tuple$second, $elm$core$Dict$values($author$project$Components$Membership$Form$Sections$Members$membersFields(sections.B)))));
        var belowAgePatients = A2($elm$core$List$filter, function(patient) {
            var _v1 = _Utils_Tuple2($author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan), patient.IZ);
            if (!_v1.a.$ && !_v1.b.$) {
                var minimumAge = _v1.a.a;
                var age = _v1.b.a;
                return _Utils_cmp(age, minimumAge) < 0;
            } else return false;
        }, patients);
        var aboveAgePatients = A2($elm$core$List$filter, function(patient) {
            var _v0 = _Utils_Tuple2($author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan), patient.IZ);
            if (!_v0.a.$ && !_v0.b.$) {
                var maximumAge = _v0.a.a;
                var age = _v0.b.a;
                return _Utils_cmp(age, maximumAge) > 0;
            } else return false;
        }, patients);
        return _Utils_Tuple2(belowAgePatients, aboveAgePatients);
    });
    var $author$project$Components$Membership$Form$PriceCheckDebouncedMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$priceCheckDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(1000),
        ah3: $author$project$Components$Membership$Form$PriceCheckDebouncedMsg
    };
    var $author$project$Api$Provider$Membership$CompanyAccount = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$AutoRenew = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$BillDate = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$ContractEndDate = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$ContractExpires = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$ContractPeriodInMonths = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$ContractType = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Coupon = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$FixedPeriodRateInCents = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$FixedRegistrationFeeInCents = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$MinimumEnrollmentPeriodInMonths = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$NextBillDate = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Owner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$PaymentSource = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$PeriodInMonths = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Plan = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$RecurringCharges = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$StartDate = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Meta$autoRenewEditable = function(_v0) {
        var meta = _v0;
        return meta.JX.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$billDateEditable = function(_v0) {
        var meta = _v0;
        return meta.vN.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$contractEndDateEditable = function(_v0) {
        var meta = _v0;
        return meta.wV.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$contractExpiresEditable = function(_v0) {
        var meta = _v0;
        return meta.L5.Ot;
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$contractFields = function(_v0) {
        var form = _v0.PU;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable = function(_v0) {
        var meta = _v0;
        return meta.L6.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$contractTypeEditable = function(_v0) {
        var meta = _v0;
        return meta.EW.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$couponEditable = function(_v0) {
        var meta = _v0;
        return meta.Mj.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable = function(_v0) {
        var meta = _v0;
        return meta.PP.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable = function(_v0) {
        var meta = _v0;
        return meta.PQ.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable = function(_v0) {
        var meta = _v0;
        return meta.Up.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$nextBillDateEditable = function(_v0) {
        var meta = _v0;
        return meta.UY.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$ownerEditable = function(_v0) {
        var meta = _v0;
        return meta.VM.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$paymentSourceEditable = function(_v0) {
        var meta = _v0;
        return meta.Wr.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$periodInMonthsEditable = function(_v0) {
        var meta = _v0;
        return meta.WA.Ot;
    };
    var $author$project$Api$Provider$Membership$Meta$planEditable = function(_v0) {
        var meta = _v0;
        return meta.GW.Ot;
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$pricingFields = function(_v0) {
        var form = _v0.PU;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Api$Provider$Membership$Meta$recurringChargesEditable = function(_v0) {
        var meta = _v0;
        return meta.Yl.Ot;
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$recurringChargesFields = function(_v0) {
        var form = _v0.PU;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Api$Provider$Membership$Meta$startDateEditable = function(_v0) {
        var meta = _v0;
        return meta._0.Ot;
    };
    var $author$project$Components$Membership$Form$Sections$Summary$summaryFields = function(_v0) {
        var form = _v0.PU;
        return $author$project$Utils$Form$fields(form);
    };
    var $author$project$Components$Membership$Form$apiFields = F2(function(membership, sections) {
        var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections.$x);
        var recurringCharges = $author$project$Components$Membership$Form$Sections$RecurringCharges$recurringChargesFields(sections.Yl);
        var pricing = $author$project$Components$Membership$Form$Sections$Pricing$pricingFields(sections.cm);
        var meta = $author$project$Api$Provider$Membership$One$meta(membership);
        var membershipPatients = $author$project$Components$Membership$Form$Sections$Members$membersFields(sections.B);
        var contract = $author$project$Components$Membership$Form$Sections$Contracts$contractFields(sections.aD);
        return _Utils_Tuple2(A2($elm$core$List$map, $elm$core$Tuple$first, A2($elm$core$List$filter, $elm$core$Tuple$second, _List_fromArray([
            _Utils_Tuple2($author$project$Api$Provider$Membership$Owner(A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, summary.VM)), $author$project$Api$Provider$Membership$Meta$ownerEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$Plan(A2($elm$core$Maybe$map, function($) {
                return $.aef;
            }, summary.GW)), $author$project$Api$Provider$Membership$Meta$planEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$StartDate(summary._0), $author$project$Api$Provider$Membership$Meta$startDateEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$BillDate(summary.vN), $author$project$Api$Provider$Membership$Meta$billDateEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$NextBillDate(summary.UY), $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$AutoRenew(summary.JX), $author$project$Api$Provider$Membership$Meta$autoRenewEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$PeriodInMonths(summary.WA), $author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$MinimumEnrollmentPeriodInMonths(summary.Up), $author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$FixedPeriodRateInCents(pricing.PP), $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$Coupon(pricing.Mj), $author$project$Api$Provider$Membership$Meta$couponEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$FixedRegistrationFeeInCents(pricing.PQ), $author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$PaymentSource(pricing.Wr), $author$project$Utils$Maybe$toBool(pricing.Wr) && $author$project$Api$Provider$Membership$Meta$paymentSourceEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$ContractEndDate(contract.qv), $author$project$Api$Provider$Membership$Meta$contractEndDateEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$ContractExpires(contract.Pg), $author$project$Api$Provider$Membership$Meta$contractExpiresEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$ContractPeriodInMonths(contract.WA), $author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$ContractType(contract.ah5), $author$project$Api$Provider$Membership$Meta$contractTypeEditable(meta)),
            _Utils_Tuple2($author$project$Api$Provider$Membership$RecurringCharges(A2($elm$core$List$map, function(recurringCharge) {
                return {
                    lv: recurringCharge.lv.aef,
                    adS: recurringCharge.adS,
                    adT: recurringCharge.adT,
                    aef: recurringCharge.aef,
                    V7: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, recurringCharge.V7),
                    WA: recurringCharge.WA,
                    agb: recurringCharge.agb,
                    agi: A2($elm$core$Maybe$map, function($) {
                        return $.aef;
                    }, recurringCharge.agi),
                    Bu: recurringCharge.Bu
                };
            }, recurringCharges.Yl)), $author$project$Api$Provider$Membership$Meta$recurringChargesEditable(meta))
        ]))), A2($elm$core$List$map, function(_v0) {
            var membershipPatient = _v0.b;
            var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
            return {
                D7: membershipPatientRecord.D7,
                ab9: A2($elm$core$Maybe$map, function($) {
                    return $.aef;
                }, membershipPatientRecord.ab9),
                aca: membershipPatientRecord.aca,
                qv: membershipPatientRecord.qv,
                O_: membershipPatientRecord.O_,
                PP: A2($elm$core$Maybe$andThen, $author$project$Currency$toInt, membershipPatientRecord.PP),
                aef: membershipPatientRecord.aef,
                TX: membershipPatientRecord.TX,
                V7: A2($elm$core$Maybe$map, function(patient) {
                    return {
                        aef: patient.aef,
                        aa4: patient.aa4
                    };
                }, membershipPatientRecord.V7),
                _L: membershipPatientRecord._L,
                _0: membershipPatientRecord._0
            };
        }, $elm$core$Dict$values(membershipPatients)));
    });
    var $author$project$Components$Membership$Form$Created = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$encodePaymentSource = function(maybePaymentSource) {
        if (!maybePaymentSource.$) {
            var paymentSource = maybePaymentSource.a;
            var _v1 = paymentSource.aef;
            if (!_v1.$) {
                var id_ = _v1.a;
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(id_))
                ]));
            } else return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$null)
            ]));
        } else return $elm$json$Json$Encode$null;
    };
    var $author$project$Api$Provider$Membership$encodeRecurringCharge = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aef)),
            _Utils_Tuple2('fixed_price_in_cents', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$float, fields.adT)),
            _Utils_Tuple2('fixed_description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.adS)),
            _Utils_Tuple2('quantity', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Bu)),
            _Utils_Tuple2('periods_remaining', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.agb)),
            _Utils_Tuple2('period_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.WA)),
            _Utils_Tuple2('charge_item', $author$project$Utils$Encode$association(fields.lv)),
            _Utils_Tuple2('patient', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.V7)),
            _Utils_Tuple2('practitioner', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.agi))
        ]));
    };
    var $author$project$Api$Provider$Membership$encodeMembershipField = function(field) {
        switch(field.$){
            case 0:
                var owner = field.a;
                return _Utils_Tuple2('owner', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, owner));
            case 1:
                var plan = field.a;
                return _Utils_Tuple2('plan', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, plan));
            case 2:
                var companyAccount = field.a;
                return _Utils_Tuple2('company_account', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, companyAccount));
            case 3:
                var startDate = field.a;
                return _Utils_Tuple2('start_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, startDate));
            case 4:
                var billDate = field.a;
                return _Utils_Tuple2('bill_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, billDate));
            case 5:
                var nextBillDate = field.a;
                return _Utils_Tuple2('next_bill_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, nextBillDate));
            case 6:
                var autoRenew = field.a;
                return _Utils_Tuple2('auto_renew', $elm$json$Json$Encode$bool(autoRenew));
            case 7:
                var periodInMonths = field.a;
                return _Utils_Tuple2('period_in_months', $elm$json$Json$Encode$int(periodInMonths));
            case 8:
                var minimumEnrollmentPeriodInMonths = field.a;
                return _Utils_Tuple2('minimum_enrollment_period_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, minimumEnrollmentPeriodInMonths));
            case 9:
                var fixedPeriodRateInCents = field.a;
                return _Utils_Tuple2('fixed_period_rate_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fixedPeriodRateInCents));
            case 10:
                var coupon = field.a;
                return _Utils_Tuple2('coupon', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, coupon));
            case 11:
                var fixedRegistrationFeeInCents = field.a;
                return _Utils_Tuple2('fixed_registration_fee_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fixedRegistrationFeeInCents));
            case 12:
                var contractEndDate = field.a;
                return _Utils_Tuple2('contract_end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, contractEndDate));
            case 13:
                var contractExpires = field.a;
                return _Utils_Tuple2('contract_expires', $elm$json$Json$Encode$bool(contractExpires));
            case 14:
                var contractPeriodInMonths = field.a;
                return _Utils_Tuple2('contract_period_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, contractPeriodInMonths));
            case 15:
                var contractType = field.a;
                return _Utils_Tuple2('contract_type', A2($author$project$Utils$Encode$nullable, $author$project$Api$ContractType$encode, contractType));
            case 16:
                var recurringCharges = field.a;
                return _Utils_Tuple2('recurring_charges', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Membership$encodeRecurringCharge, recurringCharges));
            default:
                var maybePaymentSource = field.a;
                return _Utils_Tuple2('payment_source', $author$project$Api$Provider$Membership$encodePaymentSource(maybePaymentSource));
        }
    };
    var $author$project$Api$MemberRelationship$encode = function(memberRelationship) {
        switch(memberRelationship){
            case 0:
                return $elm$json$Json$Encode$string('employee');
            case 1:
                return $elm$json$Json$Encode$string('spouse');
            case 2:
                return $elm$json$Json$Encode$string('child');
            default:
                return $elm$json$Json$Encode$string('other');
        }
    };
    var $author$project$Api$Provider$Membership$encodePatient = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string(fields.aef)),
            _Utils_Tuple2('uses_tobacco', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, fields.aa4))
        ]));
    };
    var $author$project$Api$Provider$Membership$encodeMembershipPatient = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string(fields.aef)),
            _Utils_Tuple2('member_type', $author$project$Api$MemberRelationship$encode(fields.TX)),
            _Utils_Tuple2('patient', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Membership$encodePatient, fields.V7)),
            _Utils_Tuple2('enrollment_requested_on', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.O_)),
            _Utils_Tuple2('start_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields._0)),
            _Utils_Tuple2('end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qv)),
            _Utils_Tuple2('fixed_period_rate_in_cents', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.PP)),
            _Utils_Tuple2('special_rate', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields._L)),
            _Utils_Tuple2('cancellation_reason', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ab9)),
            _Utils_Tuple2('cancellation_reason_other', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aca)),
            _Utils_Tuple2('_action', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.D7))
        ]));
    };
    var $author$project$Api$Provider$Membership$encodeMembership = F2(function(fields, membershipPatients) {
        return $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('membership_patients', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Membership$encodeMembershipPatient, membershipPatients)), A2($elm$core$List$map, $author$project$Api$Provider$Membership$encodeMembershipField, fields)));
    });
    var $author$project$Api$Provider$Membership$create = F7(function(apiClient, fields, membershipPatients, priceCheck, expand, billNow, toMsg) {
        var body = $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                _Utils_Tuple2('membership', A2($author$project$Api$Provider$Membership$encodeMembership, fields, membershipPatients))
            ]),
            priceCheck ? _List_fromArray([
                _Utils_Tuple2('check_price', $elm$json$Json$Encode$bool(true))
            ]) : _List_Nil,
            billNow ? _List_fromArray([
                _Utils_Tuple2('create_and_bill_now', $elm$json$Json$Encode$bool(true))
            ]) : _List_Nil
        ])));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipsPath))));
    });
    var $author$project$Components$Membership$Form$createItem = F4(function(apiClient, membershipApiFields, membershipPatientsApiFields, billNow) {
        return A7($author$project$Api$Provider$Membership$create, apiClient, membershipApiFields, membershipPatientsApiFields, false, _List_fromArray([
            0
        ]), billNow, $author$project$Components$Membership$Form$Created);
    });
    var $author$project$Components$Membership$Form$Updated = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$update = F7(function(apiClient, id, fields, membershipPatients, priceCheck, expand, toMsg) {
        var body = $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                _Utils_Tuple2('membership', A2($author$project$Api$Provider$Membership$encodeMembership, fields, membershipPatients))
            ]),
            priceCheck ? _List_fromArray([
                _Utils_Tuple2('check_price', $elm$json$Json$Encode$bool(true))
            ]) : _List_Nil
        ])));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$list, 'expand', A2($elm$core$List$map, $author$project$Api$Provider$Membership$expandToString, expand))
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipPath(id)))));
    });
    var $author$project$Components$Membership$Form$updateItem = F4(function(apiClient, id, membershipApiFields, membershipPatientsApiFields) {
        return A7($author$project$Api$Provider$Membership$update, apiClient, id, membershipApiFields, membershipPatientsApiFields, false, _List_fromArray([
            0
        ]), $author$project$Components$Membership$Form$Updated);
    });
    var $author$project$Components$Membership$Form$saveItem = F5(function(apiClient, maybeId, membership, sections, billNow) {
        var _v0 = A2($author$project$Components$Membership$Form$apiFields, membership, sections);
        var membershipApiFields = _v0.a;
        var membershipPatientsApiFields = _v0.b;
        if (!maybeId.$) {
            var id_ = maybeId.a;
            return A4($author$project$Components$Membership$Form$updateItem, apiClient, id_, membershipApiFields, membershipPatientsApiFields);
        } else {
            var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections.$x);
            return A4($author$project$Components$Membership$Form$createItem, apiClient, A2($elm$core$List$cons, $author$project$Api$Provider$Membership$CompanyAccount(summary.LI), membershipApiFields), membershipPatientsApiFields, billNow);
        }
    });
    var $author$project$Api$Provider$Membership$Shared$isUpdatable = function(_v0) {
        var record = _v0;
        return record.Sz;
    };
    var $author$project$Api$Provider$Membership$One$isUpdatable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$isUpdatable(shared);
    };
    var $author$project$Components$Membership$Form$GotPriceCheck = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$priceCheck = F4(function(apiClient, membership, sections, model) {
        var _v0 = A2($elm$core$Tuple$mapSecond, function(membershipPatients) {
            return A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function($) {
                return $.V7;
            }, $author$project$Utils$Maybe$toBool), membershipPatients);
        }, A2($author$project$Components$Membership$Form$apiFields, membership, sections));
        var membershipApiFields = _v0.a;
        var membershipPatientsApiFields = _v0.b;
        var _v1 = model.aef;
        if (!_v1.$) {
            var id = _v1.a;
            return A7($author$project$Api$Provider$Membership$update, apiClient, id, membershipApiFields, membershipPatientsApiFields, true, _List_fromArray([
                0
            ]), $author$project$Components$Membership$Form$GotPriceCheck);
        } else {
            var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections.$x);
            return A7($author$project$Api$Provider$Membership$create, apiClient, A2($elm$core$List$cons, $author$project$Api$Provider$Membership$CompanyAccount(summary.LI), membershipApiFields), membershipPatientsApiFields, true, _List_fromArray([
                0
            ]), false, $author$project$Components$Membership$Form$GotPriceCheck);
        }
    });
    var $author$project$Components$Membership$Form$validPriceCheckFields = function(sections) {
        var summary = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(sections.$x);
        var membershipPatients = $author$project$Components$Membership$Form$Sections$Members$membersFields(sections.B);
        var contract = $author$project$Components$Membership$Form$Sections$Contracts$contractFields(sections.aD);
        return !$elm$core$Dict$isEmpty(membershipPatients) && $author$project$Utils$Maybe$toBool(summary.GW) && (!contract.Pg || $author$project$Utils$Maybe$toBool(contract.WA) && $author$project$Utils$Maybe$toBool(contract.ah5));
    };
    var $author$project$Components$Membership$Form$checkPrice = F4(function(apiClient, membership, newSections, model) {
        var shouldCheckPrice = $author$project$Api$Provider$Membership$One$isUpdatable(membership) && $author$project$Components$Membership$Form$validPriceCheckFields(newSections);
        var _v0 = shouldCheckPrice ? A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Membership$Form$priceCheckDebounceConfig, A4($author$project$Components$Membership$Form$priceCheck, apiClient, membership, newSections, model), model.er) : _Utils_Tuple2(model.er, $elm$core$Platform$Cmd$none);
        var newDebouncer = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(shouldCheckPrice ? _Utils_update(model, {
            jG: $author$project$Api$Data$Loading,
            er: newDebouncer
        }) : !$author$project$Components$Membership$Form$validPriceCheckFields(newSections) ? _Utils_update(model, {
            jG: $author$project$Api$Data$NotAsked,
            er: newDebouncer
        }) : _Utils_update(model, {
            er: newDebouncer
        }), cmd);
    });
    var $author$project$Components$Membership$Form$Sections$BillsOverview$init = F2(function(currentDate, membershipId) {
        return {
            lf: $author$project$Api$Data$NotAsked,
            cP: currentDate,
            y0: membershipId
        };
    });
    var $author$project$Components$Membership$Form$initBillsOverview = F2(function(membership, model) {
        return _Utils_Tuple2(A2($author$project$Components$Membership$Form$Sections$BillsOverview$init, model.cP, $author$project$Api$Provider$Membership$One$id(membership)), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$GotMembershipContracts = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Membership$Shared$contractEndDate = function(_v0) {
        var record = _v0;
        return record.wV;
    };
    var $author$project$Api$Provider$Membership$One$contractEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$contractEndDate(shared);
    };
    var $author$project$Api$Provider$Membership$Shared$contractExpires = function(_v0) {
        var record = _v0;
        return record.L5;
    };
    var $author$project$Api$Provider$Membership$One$contractExpires = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$contractExpires(shared);
    };
    var $author$project$Api$Provider$Membership$One$contractPeriodInMonths = function(_v0) {
        var record = _v0.b;
        return record.L6;
    };
    var $author$project$Api$Provider$Membership$Shared$contractType = function(_v0) {
        var record = _v0;
        return record.EW;
    };
    var $author$project$Api$Provider$Membership$One$contractType = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$contractType(shared);
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$initFormFields = function(membership) {
        return {
            qv: $author$project$Api$Provider$Membership$One$contractEndDate(membership),
            Pg: $author$project$Api$Provider$Membership$One$contractExpires(membership),
            WA: $author$project$Api$Provider$Membership$One$contractPeriodInMonths(membership),
            ah5: $author$project$Api$Provider$Membership$One$contractType(membership)
        };
    };
    var $author$project$Api$Provider$MembershipContract$All$MembershipContract = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipContract$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipContract$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath = function(membershipId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'contracts'
        ]), $author$project$Api$Provider$Membership$membershipPath(membershipId));
    };
    var $author$project$Api$Provider$Membership$MembershipContract$list = F3(function(apiClient, membershipId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$MembershipContract$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId)));
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$init = F3(function(apiClient, isNew, membership) {
        var formFields = $author$project$Components$Membership$Form$Sections$Contracts$initFormFields(membership);
        var _v0 = !isNew ? _Utils_Tuple2($author$project$Api$Data$Loading, A3($author$project$Api$Provider$Membership$MembershipContract$list, apiClient, $author$project$Api$Provider$Membership$One$id(membership), $author$project$Components$Membership$Form$Sections$Contracts$GotMembershipContracts)) : _Utils_Tuple2($author$project$Api$Data$NotAsked, $elm$core$Platform$Cmd$none);
        var membershipContracts = _v0.a;
        var membershipContractsCmd = _v0.b;
        return _Utils_Tuple2({
            fd: $elm$core$Maybe$Nothing,
            iv: false,
            PU: $author$project$Utils$Form$init(formFields),
            jc: membership,
            y$: membershipContracts,
            sO: false
        }, membershipContractsCmd);
    });
    var $author$project$Components$Membership$Form$initContracts = F3(function(apiClient, membership, model) {
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$ContractsMsg), A3($author$project$Components$Membership$Form$Sections$Contracts$init, apiClient, model.iZ, membership));
    });
    var $author$project$Components$Membership$Form$Sections$Members$GotNewMembershipPatient = F4(function(a, b, c, d) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c,
            d: d
        };
    });
    var $author$project$Api$Provider$MembershipPatient$New$MembershipPatient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$MembershipPatient$New$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$MembershipPatient$New$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$New$Record));
    var $author$project$Api$Provider$MembershipPatient$New$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipPatient$New$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$MembershipPatient$membershipPatientsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'membership_patients'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$MembershipPatient$build = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$MembershipPatient$New$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'build'
        ]), $author$project$Api$Provider$MembershipPatient$membershipPatientsPath)));
    });
    var $author$project$Components$Membership$Form$Sections$Members$addMember = F4(function(apiClient, memberType, patient, startDate) {
        return A2($author$project$Api$Provider$MembershipPatient$build, apiClient, A3($author$project$Components$Membership$Form$Sections$Members$GotNewMembershipPatient, memberType, patient, startDate));
    });
    var $author$project$Api$Provider$Membership$One$billedThroughDate = function(_v0) {
        var record = _v0.b;
        return record.Kd;
    };
    var $author$project$Api$Provider$Membership$One$companyAccount = function(_v0) {
        var record = _v0.b;
        return record.LI;
    };
    var $author$project$Api$Provider$MembershipPatient$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$id(shared);
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$Model = $elm$core$Basics$identity;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$initPatientResourceFilter = F2(function(apiClient, patient) {
        return function(_v0) {
            var patientResourceFilter = _v0.a;
            var patientResourceFilterCmd = _v0.b;
            return A2($elm$core$Maybe$withDefault, _Utils_Tuple2(patientResourceFilter, patientResourceFilterCmd), A2($elm$core$Maybe$map, function(patient_) {
                var _v1 = A2($author$project$Components$ResourceFilter$Patient$preSelectedId, $elm$core$Maybe$Just(patient_.aef), patientResourceFilter);
                var withPreSelectedModel = _v1.a;
                var withPreSelectedCmd = _v1.b;
                return _Utils_Tuple2(A2($author$project$Components$ResourceFilter$Patient$extraItems, _List_fromArray([
                    {
                        IZ: patient_.IZ,
                        aef: patient_.aef,
                        T5: patient_.T5,
                        zr: patient_.zr
                    }
                ]), withPreSelectedModel), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    withPreSelectedCmd,
                    patientResourceFilterCmd
                ])));
            }, patient));
        }(A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Patient',
                I5: true
            });
        }));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$init = F9(function(apiClient, currentDate, session, practice, hinterViewOff, isNew, originalPatient, originalMembershipPatient, formFields) {
        var _v0 = A2($author$project$Components$Membership$Form$Members$MembershipPatient$initPatientResourceFilter, apiClient, formFields.V7);
        var patientResourceFilter = _v0.a;
        var patientResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            h2: $elm$core$Maybe$Nothing,
            cP: currentDate,
            qp: false,
            d2: $author$project$Utils$Maybe$toBool(formFields.PP),
            qq: false,
            d3: function() {
                if (!originalPatient.$) {
                    var originalPatient_ = originalPatient.a;
                    return _Utils_eq(originalPatient_.aa4, $elm$core$Maybe$Nothing);
                } else return false;
            }(),
            qx: $author$project$Components$DateInput$initFromDate(currentDate),
            qB: $author$project$Components$DateInput$initFromDate(currentDate),
            PU: $author$project$Utils$Form$init(formFields),
            aeb: hinterViewOff,
            iZ: isNew,
            eg: $author$project$Utils$Maybe$toBool(formFields._L),
            GI: originalMembershipPatient,
            GK: formFields,
            VE: originalPatient,
            rX: patientResourceFilter,
            W1: practice,
            aO: false,
            Z$: session,
            kj: $author$project$Components$DateInput$initFromDate(currentDate)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg, patientResourceFilterCmd));
    });
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason = function(_v0) {
        var record = _v0.b;
        return record.ab9;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReasonOther = function(_v0) {
        var record = _v0.b;
        return record.aca;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$companyRegistration = function(_v0) {
        var record = _v0.b;
        return record.LP;
    };
    var $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate = function(_v0) {
        var record = _v0;
        return record.Ox;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$effectiveEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate(shared);
    };
    var $author$project$Api$Provider$MembershipPatient$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$endDate(shared);
    };
    var $author$project$Api$Provider$MembershipPatient$Shared$enrollmentRequestedOn = function(_v0) {
        var record = _v0;
        return record.O_;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$enrollmentRequestedOn(shared);
    };
    var $author$project$Api$Provider$MembershipPatient$Shared$firstBillStartDate = function(_v0) {
        var record = _v0;
        return record.PL;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$firstBillStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$firstBillStartDate(shared);
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents = function(_v0) {
        var record = _v0.b;
        return record.PP;
    };
    var $author$project$Components$CancellationReason$CancellationReasonRecord$fromShared = function(cancellationReason) {
        return {
            NQ: $author$project$Api$Provider$CancellationReason$Shared$description(cancellationReason),
            aef: $author$project$Api$Provider$CancellationReason$Shared$id(cancellationReason)
        };
    };
    var $author$project$Api$Provider$SpecialRate$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType = function(_v0) {
        var record = _v0.b;
        return record.TX;
    };
    var $author$project$Api$Provider$CompanyRegistration$Meta$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation = function(patient) {
        return {
            IZ: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$age(patient),
            aef: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient),
            aeT: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$locationFromMin, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$location(patient)),
            T5: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$membershipStatus(patient),
            zr: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient),
            agi: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromMin, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$practitioner(patient)),
            aa4: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco(patient)
        };
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate = function(_v0) {
        var record = _v0.b;
        return record._L;
    };
    var $author$project$Api$Provider$MembershipPatient$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$startDate(shared);
    };
    var $author$project$Components$Membership$Form$Records$membershipPatientFromOne = function(membershipPatient) {
        var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
        var companyRegistration = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$companyRegistration(membershipPatient);
        var companyRegistrationRecord = A2($elm$core$Maybe$map, function(companyRegistration_) {
            return {
                Ue: $author$project$Api$Provider$CompanyRegistration$Meta$meta(companyRegistration_)
            };
        }, companyRegistration);
        return {
            D7: $elm$core$Maybe$Nothing,
            ab9: A2($elm$core$Maybe$map, $author$project$Components$CancellationReason$CancellationReasonRecord$fromShared, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason(membershipPatient)),
            aca: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReasonOther(membershipPatient),
            LP: companyRegistrationRecord,
            Ox: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$effectiveEndDate(membershipPatient),
            qv: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(membershipPatient),
            O_: $elm$core$Maybe$Just($author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn(membershipPatient)),
            PL: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$firstBillStartDate(membershipPatient),
            PP: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents(membershipPatient)),
            aef: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient),
            TX: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient),
            V7: $elm$core$Maybe$Just($author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation(patient)),
            _L: A2($elm$core$Maybe$map, $author$project$Api$Provider$SpecialRate$Min$id, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate(membershipPatient)),
            _0: $elm$core$Maybe$Just($author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate(membershipPatient))
        };
    };
    var $author$project$Components$Membership$Form$Sections$Members$initMembersFields = F8(function(apiClient, currentDate, session, practice, hinterViewOff, isNew, patient, membership) {
        var startDate = isNew ? $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Membership$One$startDate(membership), $author$project$Api$Provider$Membership$One$billedThroughDate(membership))) : $author$project$Api$Provider$Membership$One$billedThroughDate(membership);
        var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(membership);
        var membershipPatientsWithCmds = A2($elm$core$List$map, function(membershipPatient) {
            var originalMembershipPatient = A2($elm_community$list_extra$List$Extra$find, function(membershipPatient_) {
                return _Utils_eq($author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_), $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient));
            }, $author$project$Api$Provider$Membership$One$membershipPatients(membership));
            var originalPatient = A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromSharedWithMinPractitionerAndLocation, A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, originalMembershipPatient));
            var membershipPatientRecord = $author$project$Components$Membership$Form$Records$membershipPatientFromOne(membershipPatient);
            return A2($author$project$Utils$Tuple3$fromTuple2, membershipPatientRecord, A9($author$project$Components$Membership$Form$Members$MembershipPatient$init, apiClient, currentDate, session, practice, hinterViewOff, isNew, originalPatient, originalMembershipPatient, membershipPatientRecord));
        }, membershipPatients);
        var membershipPatientsCmds = A2($elm$core$List$map, function(_v2) {
            var cmd = _v2.b;
            var membershipPatientRecord = _v2.c;
            return A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.aef), cmd);
        }, membershipPatientsWithCmds);
        var companyAccount = $author$project$Api$Provider$Membership$One$companyAccount(membership);
        var addMembershipPatientCmd = function() {
            var _v1 = _Utils_Tuple3(isNew, companyAccount, $author$project$Api$Provider$Patient$One$company(patient));
            if (_v1.a) {
                if (!_v1.b.$ && !_v1.c.$) return A4($author$project$Components$Membership$Form$Sections$Members$addMember, apiClient, 0, $elm$core$Maybe$Just(patient), startDate);
                else return A4($author$project$Components$Membership$Form$Sections$Members$addMember, apiClient, 1, $elm$core$Maybe$Just(patient), startDate);
            } else return $elm$core$Platform$Cmd$none;
        }();
        return _Utils_Tuple2($elm$core$Dict$fromList(A2($elm$core$List$indexedMap, F2(function(index, _v0) {
            var membershipPatientModel = _v0.a;
            var membershipPatientRecord = _v0.c;
            return _Utils_Tuple2(membershipPatientRecord.aef, _Utils_Tuple2(index, membershipPatientModel));
        }), membershipPatientsWithCmds)), $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, addMembershipPatientCmd, membershipPatientsCmds)));
    });
    var $author$project$Api$Provider$Membership$Meta$membershipPatientsMaxCount = function(_v0) {
        var meta = _v0;
        return meta.T0;
    };
    var $author$project$Components$Membership$Form$Sections$Members$init = F8(function(apiClient, currentDate, session, practice, patient, hinterViewOff, isNew, membership) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var _v0 = A8($author$project$Components$Membership$Form$Sections$Members$initMembersFields, apiClient, currentDate, session, practice, hinterViewOff, isNew, patient, membership);
        var membershipPatients = _v0.a;
        var formFieldsCmd = _v0.b;
        return _Utils_Tuple2({
            cP: currentDate,
            Oq: false,
            aeb: hinterViewOff,
            iZ: isNew,
            Gi: $author$project$Api$Provider$Membership$Meta$membershipPatientsMaxCount(membershipMeta),
            T$: membershipPatients,
            GJ: $elm$core$Set$fromList($elm$core$Dict$keys(membershipPatients)),
            W1: practice,
            Z$: session
        }, formFieldsCmd);
    });
    var $author$project$Components$Membership$Form$initMembers = F3(function(apiClient, membership, model) {
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$MembersMsg), A8($author$project$Components$Membership$Form$Sections$Members$init, apiClient, model.cP, model.Z$, model.W1, model.V7, model.aeb, model.iZ, membership));
    });
    var $author$project$Api$Provider$Membership$Shared$billsAtEndOfPeriod = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, false, record.Kh);
    };
    var $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$billsAtEndOfPeriod(shared);
    };
    var $author$project$Api$Provider$Membership$One$company = function(_v0) {
        var record = _v0.b;
        return record.acy;
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$Model = $elm$core$Basics$identity;
    var $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$initPlanResourceFilter = F5(function(apiClient, session, planType, billsAtEndOfPeriod, companyId) {
        var listOptionals = function() {
            if (!companyId.$) {
                var companyId_ = companyId.a;
                return function(d) {
                    return _Utils_update(d, {
                        En: $elm$core$Maybe$Just(companyId_)
                    });
                };
            } else return function(d) {
                return _Utils_update(d, {
                    Kh: billsAtEndOfPeriod ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing,
                    A8: _List_fromArray([
                        planType
                    ])
                });
            };
        }();
        return A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, listOptionals, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Plan',
                I5: true
            });
        });
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$init = F7(function(apiClient, session, currentDate, membershipId, planType, billsAtEndOfPeriod, companyId) {
        var _v0 = A5($author$project$Components$Membership$Form$Sections$PlanChange$initPlanResourceFilter, apiClient, session, planType, billsAtEndOfPeriod, companyId);
        var planResourceFilter = _v0.a;
        var planResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            cP: currentDate,
            fr: $elm$core$Maybe$Nothing,
            PU: $elm$core$Maybe$Nothing,
            q8: !$author$project$Utils$Maybe$toBool(membershipId),
            y0: membershipId,
            jy: planResourceFilter,
            j_: $author$project$Api$Data$NotAsked
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg, planResourceFilterCmd));
    });
    var $author$project$Components$Membership$Form$initPlanChange = F3(function(apiClient, membership, model) {
        if (A2($author$project$Utils$FeatureGate$gateAvailable, 6, $author$project$Api$Practice$Provider(model.W1))) {
            var plan = $author$project$Api$Provider$Membership$One$plan(membership);
            return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$PlanChangeMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A7($author$project$Components$Membership$Form$Sections$PlanChange$init, apiClient, model.Z$, model.cP, model.aef, $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(plan), $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership), A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$id, $author$project$Api$Provider$Membership$One$company(membership)))));
        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$GotCoupons = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$GotPaymentMethods = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PaymentMethod$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Membership$One$coupon = function(_v0) {
        var record = _v0.b;
        return record.Mj;
    };
    var $author$project$Api$Provider$Membership$Shared$fixedPeriodRateInCents = function(_v0) {
        var record = _v0;
        return record.PP;
    };
    var $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$fixedPeriodRateInCents(shared);
    };
    var $author$project$Api$Provider$Membership$Shared$fixedRegistrationFeeInCents = function(_v0) {
        var record = _v0;
        return record.PQ;
    };
    var $author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$fixedRegistrationFeeInCents(shared);
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$initFormFields = function(membership) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        return {
            Mj: A2($elm$core$Maybe$map, $author$project$Api$Common$Coupon$Shared$id, $author$project$Api$Provider$Membership$One$coupon(membership)),
            PP: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership)),
            PQ: A2($elm$core$Maybe$map, $author$project$Currency$fromInt, $author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership)),
            cc: {
                X5: $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership)) && $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(membershipMeta),
                ex: $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership)) && $author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(membershipMeta)
            },
            Wr: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Api$Provider$PaymentMethod$Min$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$paymentMethodTitle = function(paymentMethod) {
        var _v0 = $author$project$Api$Provider$PaymentMethod$Min$label(paymentMethod);
        if (!_v0.$) {
            var lbl = _v0.a;
            return lbl;
        } else {
            var lastFour = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(lf) {
                return ' *' + lf;
            }, $author$project$Api$Provider$PaymentMethod$Min$lastFour(paymentMethod)));
            var brand = $author$project$Formatters$String$titleize($author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(paymentMethod));
            return _Utils_ap(brand, lastFour);
        }
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodOption = function(paymentMethod) {
        return _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                A2($elm$html$Html$strong, _List_fromArray([
                    $elm$html$Html$Attributes$class('inline')
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Api$Provider$PaymentMethod$Min$paymentMethodBrand(paymentMethod)))
                ])),
                $elm$html$Html$text(' '),
                function() {
                    var _v0 = $author$project$Api$Provider$PaymentMethod$Min$lastFour(paymentMethod);
                    if (!_v0.$) {
                        var lastFour = _v0.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('*' + lastFour)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]);
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$init = F3(function(apiClient, patientId, membership) {
        var formFields = $author$project$Components$Membership$Form$Sections$Pricing$initFormFields(membership);
        return _Utils_Tuple2({
            wY: $author$project$Api$Data$Loading,
            Oq: $author$project$Utils$Maybe$toBool(formFields.Mj),
            l0: false,
            PU: $author$project$Utils$Form$init(formFields),
            rZ: $author$project$Ui$Form$SearchableSelect$init({
                aef: 'payment-method-select',
                ahW: $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodOption,
                ahZ: $author$project$Components$Membership$Form$Sections$Pricing$paymentMethodTitle,
                g4: function(pm) {
                    return $elm$core$Maybe$Just($author$project$Api$Provider$PaymentMethod$Min$id(pm));
                }
            }),
            A0: $author$project$Api$Data$Loading,
            j3: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Coupon$list, apiClient, function(d) {
                return _Utils_update(d, {
                    Hc: $elm$core$Maybe$Just(true)
                });
            }, $author$project$Components$Membership$Form$Sections$Pricing$GotCoupons),
            A3($author$project$Api$Provider$Patient$PaymentMethod$list, apiClient, patientId, $author$project$Components$Membership$Form$Sections$Pricing$GotPaymentMethods)
        ])));
    });
    var $author$project$Components$Membership$Form$initPricing = F3(function(apiClient, patientId, membership) {
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$PricingMsg), A3($author$project$Components$Membership$Form$Sections$Pricing$init, apiClient, patientId, membership));
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$GotTaxableChargeItemsCount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem = function(_v0) {
        var record = _v0.b;
        return record.lv;
    };
    var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$description = function(_v0) {
        var record = _v0.b;
        return record.NQ;
    };
    var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Min$id(min);
    };
    var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Provider$ChargeItem$Min$name(min);
    };
    var $author$project$Api$Provider$ChargeItem$ForRecurringCharge$priceInCents = function(_v0) {
        var record = _v0.b;
        return record.Br;
    };
    var $author$project$Components$Membership$Form$Records$chargeItemFromForRecurringCharge = function(chargeItem) {
        return {
            NQ: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$description(chargeItem),
            aef: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id(chargeItem),
            zr: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$name(chargeItem),
            Br: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$priceInCents(chargeItem)
        };
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$fixedDescription = function(_v0) {
        var record = _v0;
        return record.adS;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$fixedDescription(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$fixedPriceInCents = function(_v0) {
        var record = _v0;
        return record.adT;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$fixedPriceInCents(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$id(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$name(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$nextBillDate = function(_v0) {
        var record = _v0;
        return record.UY;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$nextBillDate(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Components$Membership$Form$Records$patientFromMin = function(patient) {
        return {
            IZ: $elm$core$Maybe$Nothing,
            aef: $author$project$Api$Provider$Patient$Min$id(patient),
            aeT: $elm$core$Maybe$Nothing,
            T5: '',
            zr: $author$project$Api$Provider$Patient$Min$name(patient),
            agi: $elm$core$Maybe$Nothing,
            aa4: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$periodInMonths = function(_v0) {
        var record = _v0;
        return record.WA;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$periodInMonths(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$periodsMax = function(_v0) {
        var record = _v0;
        return record.WC;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsMax = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$periodsMax(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$periodsRemaining = function(_v0) {
        var record = _v0;
        return record.agb;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$periodsRemaining(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner = function(_v0) {
        var record = _v0.b;
        return record.agi;
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$quantity = function(_v0) {
        var record = _v0;
        return record.Bu;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$quantity(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$RecurringCharge$Shared$startDate(shared);
    };
    var $author$project$Api$Provider$RecurringCharge$ForMembershipOne$uom = function(_v0) {
        var record = _v0.b;
        return record.aaK;
    };
    var $author$project$Components$Membership$Form$Records$recurringChargeFromForMembershipOne = function(recurringCharge) {
        var practitioner = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner(recurringCharge);
        var patient = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient(recurringCharge);
        var chargeItem = $author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem(recurringCharge);
        return {
            lv: $author$project$Components$Membership$Form$Records$chargeItemFromForRecurringCharge(chargeItem),
            adS: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription(recurringCharge),
            adT: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents(recurringCharge),
            aef: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$id(recurringCharge),
            zr: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$name(recurringCharge),
            UY: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate(recurringCharge),
            V7: $elm$core$Maybe$Just($author$project$Components$Membership$Form$Records$patientFromMin(patient)),
            WA: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths(recurringCharge),
            WC: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsMax(recurringCharge),
            agb: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining(recurringCharge),
            agi: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromMin, practitioner),
            Bu: $elm$core$Maybe$Just($author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity(recurringCharge)),
            _0: $elm$core$Maybe$Just($author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate(recurringCharge)),
            aaK: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$uom(recurringCharge)
        };
    };
    var $author$project$Api$Provider$Membership$One$recurringCharges = function(_v0) {
        var record = _v0.b;
        return record.Yl;
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsInit = function(membership) {
        var recurringCharges = $author$project$Api$Provider$Membership$One$recurringCharges(membership);
        return {
            Yl: A2($elm$core$List$map, $author$project$Components$Membership$Form$Records$recurringChargeFromForMembershipOne, recurringCharges)
        };
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$init = F3(function(apiClient, practice, membership) {
        var showItemTypeInTitle = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice);
        var formFields = $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsInit(membership);
        return _Utils_Tuple2({
            fm: $elm$core$Maybe$Nothing,
            PU: $author$project$Utils$Form$init(formFields),
            qO: false,
            Cz: showItemTypeInTitle
        }, A3($author$project$Api$Provider$ChargeItem$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: A2($author$project$Api$Pagination$withItemsPerPage, 0, $author$project$Api$Pagination$init),
                $S: $elm$core$Maybe$Just(false)
            });
        }, $author$project$Components$Membership$Form$Sections$RecurringCharges$GotTaxableChargeItemsCount));
    });
    var $author$project$Components$Membership$Form$initRecurringCharges = F3(function(apiClient, practice, membership) {
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$RecurringChargesMsg), A3($author$project$Components$Membership$Form$Sections$RecurringCharges$init, apiClient, practice, membership));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$Model = $elm$core$Basics$identity;
    var $author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$One$createdAt = function(_v0) {
        var record = _v0.b;
        return record.Mx;
    };
    var $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderOne = function(brokerDeal) {
        return {
            vQ: $author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal),
            acy: $author$project$Api$Provider$BrokerDeal$One$company(brokerDeal),
            Nj: $author$project$Api$Provider$BrokerDeal$One$dealName(brokerDeal),
            Nk: $author$project$Api$Provider$BrokerDeal$One$dealType(brokerDeal),
            qv: $author$project$Api$Provider$BrokerDeal$One$endDate(brokerDeal),
            aef: $author$project$Api$Provider$BrokerDeal$One$id(brokerDeal),
            Ue: $author$project$Api$Provider$BrokerDeal$One$meta(brokerDeal),
            X8: $author$project$Api$Provider$BrokerDeal$One$rates(brokerDeal)
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$initPatientResourceFilter = function(apiClient) {
        return A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
            return _Utils_update(d, {
                I5: false
            });
        });
    };
    var $author$project$Api$Provider$Membership$One$neverBeenBilled = function(_v0) {
        var record = _v0.b;
        return record.UQ;
    };
    var $author$project$Components$Membership$Form$Sections$Summary$initPlanResourceFilter = F3(function(apiClient, session, membership) {
        var listOptionals = function() {
            var _v0 = $author$project$Api$Provider$Membership$One$company(membership);
            if (!_v0.$) {
                var company = _v0.a;
                return function(d) {
                    return _Utils_update(d, {
                        En: $elm$core$Maybe$Just($author$project$Api$Provider$Company$Shared$id(company))
                    });
                };
            } else {
                var planType = _List_fromArray([
                    2,
                    3
                ]);
                var billsAtEndOfPeriod = $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership) && !$author$project$Api$Provider$Membership$One$neverBeenBilled(membership);
                return function(d) {
                    return _Utils_update(d, {
                        Kh: billsAtEndOfPeriod ? $elm$core$Maybe$Just(true) : $elm$core$Maybe$Nothing,
                        A8: planType
                    });
                };
            }
        }();
        return A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, listOptionals, function(d) {
            return _Utils_update(d, {
                I5: false
            });
        });
    });
    var $author$project$Api$Provider$Membership$One$autoRenew = function(_v0) {
        var record = _v0.b;
        return record.JX;
    };
    var $author$project$Api$Provider$Membership$Shared$billDate = function(_v0) {
        var record = _v0;
        return record.vN;
    };
    var $author$project$Api$Provider$Membership$One$billDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$billDate(shared);
    };
    var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentPeriodInMonths = function(_v0) {
        var record = _v0;
        return record.Up;
    };
    var $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentPeriodInMonths(shared);
    };
    var $author$project$Api$Provider$Membership$Shared$nextBillDate = function(_v0) {
        var record = _v0;
        return record.UY;
    };
    var $author$project$Api$Provider$Membership$One$nextBillDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$nextBillDate(shared);
    };
    var $author$project$Api$Provider$Membership$One$periodInMonths = function(_v0) {
        var record = _v0.b;
        return record.WA;
    };
    var $author$project$Components$Membership$Form$Records$planFromSharedWithContractInfo = function(plan) {
        return {
            aef: $author$project$Api$Provider$Plan$SharedWithContractInfo$id(plan),
            zr: $author$project$Api$Provider$Plan$SharedWithContractInfo$name(plan)
        };
    };
    var $author$project$Api$Provider$Membership$One$status = function(_v0) {
        var record = _v0.b;
        return record.ahy;
    };
    var $author$project$Components$Membership$Form$Sections$Summary$initSummaryFields = F4(function(currentDate, isNew, practice, membership) {
        var minimumEnrollmentPeriodInMonths = $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths(membership);
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var setBillDate = $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) && $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta) ? _Utils_eq($author$project$Api$Provider$Membership$One$billDate(membership), $author$project$Api$Provider$Membership$One$nextBillDate(membership)) : $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) ? false : $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta);
        var companyAccount = $author$project$Api$Provider$Membership$One$companyAccount(membership);
        var _v0 = function() {
            var _v1 = _Utils_Tuple2(isNew, companyAccount);
            if (_v1.a && !_v1.b.$) {
                var companyAccount_ = _v1.b.a;
                var eligibilityStartDate = A2($elm$core$Maybe$withDefault, currentDate, $author$project$Api$Provider$CompanyAccount$Shared$eligibilityStartDate(companyAccount_));
                return _Utils_Tuple2(A2($justinmimbs$date$Date$compare, eligibilityStartDate, currentDate) === 2 ? $elm$core$Maybe$Just(eligibilityStartDate) : $elm$core$Maybe$Nothing, $elm$core$Maybe$Just($author$project$Api$Provider$Membership$One$startDate(membership)));
            } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Api$Provider$Membership$One$nextBillDate(membership));
        }();
        var futureEligibilityDate = _v0.a;
        var nextBillDate = _v0.b;
        return {
            JX: $author$project$Api$Provider$Membership$One$autoRenew(membership),
            vN: $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta) ? setBillDate ? $author$project$Api$Provider$Membership$One$billDate(membership) : $elm$core$Maybe$Nothing : $elm$core$Maybe$Nothing,
            LI: A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$Shared$id, companyAccount),
            FE: futureEligibilityDate,
            cc: {
                _0: false
            },
            Up: minimumEnrollmentPeriodInMonths,
            UY: $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) ? nextBillDate : $elm$core$Maybe$Nothing,
            VM: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromShared, $author$project$Api$Provider$Membership$One$owner(membership)),
            WA: $author$project$Api$Provider$Membership$One$periodInMonths(membership),
            GW: isNew && A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, practice) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Components$Membership$Form$Records$planFromSharedWithContractInfo($author$project$Api$Provider$Membership$One$plan(membership))),
            eJ: setBillDate,
            _0: function() {
                if ($author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta)) {
                    var startDateMembership = $author$project$Api$Provider$Membership$One$startDate(membership);
                    var startDate = $author$project$Api$Provider$Membership$One$status(membership) === 'unconfirmed' && A2($author$project$Utils$Date$isBefore, startDateMembership, currentDate) ? currentDate : startDateMembership;
                    return $elm$core$Maybe$Just(startDate);
                } else return $elm$core$Maybe$Nothing;
            }()
        };
    });
    var $author$project$Components$Membership$Form$Sections$Summary$init = function(apiClient) {
        return function(timeZone) {
            return function(currentDate) {
                return function(session) {
                    return function(practice) {
                        return function(isNew) {
                            return function(timeFormatter) {
                                return function(hinterViewOff) {
                                    return function(url) {
                                        return function(membership) {
                                            var membershipCreatedAt = $author$project$Api$Provider$Membership$One$createdAt(membership);
                                            var formFields = A4($author$project$Components$Membership$Form$Sections$Summary$initSummaryFields, currentDate, isNew, practice, membership);
                                            var brokerDeals = A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderOne, $author$project$Api$Provider$Membership$One$brokerDeals(membership));
                                            var _v0 = $author$project$Components$DateInput$init;
                                            var startDateInput = _v0.a;
                                            var startDateInputCmd = _v0.b;
                                            var _v1 = A3($author$project$Components$Membership$Form$Sections$Summary$initPlanResourceFilter, apiClient, session, membership);
                                            var planResourceFilter = _v1.a;
                                            var planResourceFilterCmd = _v1.b;
                                            var _v2 = $author$project$Components$Membership$Form$Sections$Summary$initPatientResourceFilter(apiClient);
                                            var patientResourceFilter = _v2.a;
                                            var patientResourceFilterCmd = _v2.b;
                                            var _v3 = $author$project$Components$DateInput$init;
                                            var nextBillDateInput = _v3.a;
                                            var nextBillDateInputCmd = _v3.b;
                                            return _Utils_Tuple2({
                                                hB: A7($author$project$Components$AuditTrailLog$init, session, url, timeFormatter, $elm$core$Maybe$Just('membership'), $elm$core$Maybe$Just($author$project$Api$Provider$Membership$One$id(membership)), membershipCreatedAt, $elm$core$Maybe$Nothing),
                                                Kq: brokerDeals,
                                                fd: $elm$core$Maybe$Nothing,
                                                h$: $elm$core$Maybe$Nothing,
                                                cP: currentDate,
                                                iv: false,
                                                PU: $author$project$Utils$Form$init(formFields),
                                                aeb: hinterViewOff,
                                                iZ: isNew,
                                                zL: false,
                                                rB: nextBillDateInput,
                                                rX: patientResourceFilter,
                                                jy: planResourceFilter,
                                                W1: practice,
                                                Z$: session,
                                                oi: {
                                                    eY: !$author$project$Utils$Maybe$toBool(formFields.Up) && $author$project$Api$Provider$Membership$One$neverBeenBilled(membership),
                                                    UY: false,
                                                    VM: false,
                                                    GW: isNew && A2($author$project$Api$Provider$Practice$One$featureEnabled, 17, practice)
                                                },
                                                kj: startDateInput,
                                                HP: timeZone
                                            }, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                                A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceFilterCmd),
                                                A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceFilterCmd),
                                                A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg, startDateInputCmd),
                                                A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg, nextBillDateInputCmd)
                                            ])));
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Components$Membership$Form$initSummary = F3(function(apiClient, membership, model) {
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Components$Membership$Form$SummaryMsg), $author$project$Components$Membership$Form$Sections$Summary$init(apiClient)(model.HP)(model.cP)(model.Z$)(model.W1)(model.iZ)(model.HO)(model.aeb)(model.aaT)(membership));
    });
    var $author$project$Components$Membership$Form$setupMembershipOnScope = F3(function(apiClient, membership, model) {
        var _v0 = A3($author$project$Components$Membership$Form$initSummary, apiClient, membership, model);
        var summary = _v0.a;
        var summaryCmd = _v0.b;
        var _v1 = A3($author$project$Components$Membership$Form$initRecurringCharges, apiClient, model.W1, membership);
        var recurringCharges = _v1.a;
        var recurringChargesCmd = _v1.b;
        var _v2 = A3($author$project$Components$Membership$Form$initPricing, apiClient, $author$project$Api$Provider$Patient$One$id(model.V7), membership);
        var pricing = _v2.a;
        var pricingCmd = _v2.b;
        var _v3 = A3($author$project$Components$Membership$Form$initPlanChange, apiClient, membership, model);
        var planChange = _v3.a;
        var planChangeCmd = _v3.b;
        var _v4 = A3($author$project$Components$Membership$Form$initMembers, apiClient, membership, model);
        var members = _v4.a;
        var membersCmd = _v4.b;
        var _v5 = A3($author$project$Components$Membership$Form$initContracts, apiClient, membership, model);
        var contracts = _v5.a;
        var contractsCmd = _v5.b;
        var _v6 = A2($author$project$Components$Membership$Form$initBillsOverview, membership, model);
        var billsOverview = _v6.a;
        var billsOverviewCmd = _v6.b;
        var sections = {
            pI: billsOverview,
            aD: contracts,
            B: members,
            jw: planChange,
            cm: pricing,
            Yl: recurringCharges,
            $x: summary
        };
        var newModel = _Utils_update(model, {
            jc: $elm$core$Maybe$Just(membership),
            da: $elm$core$Maybe$Just(membership),
            gF: true,
            l: $elm$core$Maybe$Just(sections)
        });
        return A2($elm$core$Tuple$mapSecond, function(checkPriceCmd) {
            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                summaryCmd,
                membersCmd,
                pricingCmd,
                contractsCmd,
                recurringChargesCmd,
                billsOverviewCmd,
                planChangeCmd,
                checkPriceCmd
            ]));
        }, A4($author$project$Components$Membership$Form$checkPrice, apiClient, membership, sections, newModel));
    });
    var $author$project$Components$Membership$Form$CancelModal$Cancelled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$CancelModal$Closed = {
        $: 1
    };
    var $author$project$Components$Membership$Form$CancelModal$EndDate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$CancelModal$MembershipCancelled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$CancelModal$None = {
        $: 0
    };
    var $author$project$Api$Provider$Membership$cancel = F4(function(apiClient, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('membership', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('end_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.qv)),
                _Utils_Tuple2('cancellation_reason', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.ab9)),
                _Utils_Tuple2('cancellation_reason_other', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.aca))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel'
        ]), $author$project$Api$Provider$Membership$membershipPath(id)))));
    });
    var $author$project$Components$Membership$Form$CancelModal$formFieldsUpdate = F2(function(field, fields) {
        if (!field.$) {
            var date = field.a;
            return _Utils_update(fields, {
                qv: date
            });
        } else {
            var _v1 = field.a;
            var cancellationReason = _v1.a;
            var cancellationReasonOther = _v1.b;
            return _Utils_update(fields, {
                ab9: cancellationReason,
                aca: cancellationReasonOther
            });
        }
    });
    var $author$project$Components$Membership$Form$CancelModal$CancellationReasonOtherValidation = 2;
    var $author$project$Components$Membership$Form$CancelModal$CancellationReasonValidation = 1;
    var $author$project$Components$Membership$Form$CancelModal$EndDateValidation = 0;
    var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMin = function(_v0) {
        var meta = _v0;
        return meta.qv._Y;
    };
    var $author$project$Components$Membership$Form$CancelModal$validateEndDate = F2(function(membership, fields) {
        var minEndDate = $author$project$Api$Provider$Membership$One$isSponsored(membership) ? $author$project$Api$Provider$Membership$Meta$endDateSponsoredMin($author$project$Api$Provider$Membership$One$meta(membership)) : $elm$core$Maybe$Nothing;
        var _v0 = _Utils_Tuple2(fields.qv, minEndDate);
        if (!_v0.a.$) {
            if (!_v0.b.$) {
                var endDate = _v0.a.a;
                var minEndDate_ = _v0.b.a;
                return !A2($justinmimbs$date$Date$compare, endDate, minEndDate_) ? _List_fromArray([
                    _Utils_Tuple2(0, 'Please enter a date greater or equal than ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, minEndDate_))
                ]) : _List_Nil;
            } else {
                var _v1 = _v0.b;
                return _List_Nil;
            }
        } else {
            var _v2 = _v0.a;
            return _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a date.')
            ]);
        }
    });
    var $author$project$Components$Membership$Form$CancelModal$formFieldsValidator = function(membership) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$CancelModal$validateEndDate(membership)),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$CancellationReason$Input$validate, 1, 2))
        ]));
    };
    var $author$project$Components$Membership$Form$CancelModal$updateDateInputFormField = F7(function(model, dateInputGetter, dateInputSetter, subMsg, toMsg, field, fieldGetter) {
        var dateInput = dateInputGetter(model);
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var event = _v0.c;
        var newForm = function() {
            if (event.$ === 1) {
                var date = event.a;
                return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$CancelModal$formFieldsUpdate, field(date), model.PU);
            } else {
                var fields = $author$project$Utils$Form$fields(model.PU);
                return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$CancelModal$formFieldsUpdate, field(fieldGetter(fields)), model.PU);
            }
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
            adu: $author$project$Components$Membership$Form$CancelModal$None,
            zi: A2(dateInputSetter, newDateInput, _Utils_update(model, {
                PU: newForm
            })),
            at: _List_Nil
        };
    });
    var $author$project$Components$Membership$Form$CancelModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$CancelModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 0:
                var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$CancelModal$formFieldsValidator(model.jc), model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var newForm = _v3.a;
                    var validFormFields = _v3.b;
                    var validFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var apiFields = {
                        ab9: A2($elm$core$Maybe$map, function($) {
                            return $.aef;
                        }, validFields.ab9),
                        aca: validFields.aca,
                        qv: validFields.qv
                    };
                    return {
                        EQ: A4($author$project$Api$Provider$Membership$cancel, apiClient, $author$project$Api$Provider$Membership$One$id(model.jc), apiFields, $author$project$Components$Membership$Form$CancelModal$MembershipCancelled),
                        adu: $author$project$Components$Membership$Form$CancelModal$None,
                        zi: _Utils_update(model, {
                            fd: $author$project$Api$Data$Loading,
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Membership$Form$CancelModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var membership = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Membership$Form$CancelModal$Cancelled(membership),
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$CancelModal$None,
                    zi: _Utils_update(model, {
                        fd: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var subMsg = msg.a;
                return A7($author$project$Components$Membership$Form$CancelModal$updateDateInputFormField, model, function($) {
                    return $.qx;
                }, F2(function(newDateInput, model_) {
                    return _Utils_update(model_, {
                        qx: newDateInput
                    });
                }), subMsg, $author$project$Components$Membership$Form$CancelModal$EndDateInputMsg, $author$project$Components$Membership$Form$CancelModal$EndDate, function($) {
                    return $.qv;
                });
            default:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$CancelModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$CancelModal$None,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Membership$Form$RenewContractModal$Closed = 1;
    var $author$project$Components$Membership$Form$RenewContractModal$GotRenewResponse = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RenewContractModal$None = 0;
    var $author$project$Components$Membership$Form$RenewContractModal$Renwed = 2;
    var $author$project$Api$Provider$MembershipContract$One$MembershipContract = 0;
    var $author$project$Api$Provider$MembershipContract$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Membership$MembershipContract$renew = F4(function(apiClient, membershipId, memo, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('memo', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, memo))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$MembershipContract$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'renew'
        ]), $author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId)))));
    });
    var $author$project$Components$Membership$Form$RenewContractModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var memo = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        ae0: $author$project$Utils$String$toMaybe(memo)
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: A4($author$project$Api$Provider$Membership$MembershipContract$renew, apiClient, model.y0, model.ae0, $author$project$Components$Membership$Form$RenewContractModal$GotRenewResponse),
                    adu: 0,
                    zi: _Utils_update(model, {
                        nZ: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        nZ: response
                    }),
                    at: _List_Nil
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        nZ: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Membership$Form$RestartModal$Closed = {
        $: 1
    };
    var $author$project$Components$Membership$Form$RestartModal$MembershipRestarted = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RestartModal$None = {
        $: 0
    };
    var $author$project$Components$Membership$Form$RestartModal$Restarted = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RestartModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$RestartModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var pendingMembership = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Membership$Form$RestartModal$None,
                        zi: _Utils_update(model, {
                            da: $elm$core$Maybe$Just(pendingMembership)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$RestartModal$Closed,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 0:
                return {
                    EQ: A5($author$project$Api$Provider$Membership$restart, apiClient, $author$project$Api$Provider$Membership$One$id(model.jc), false, model.UY, $author$project$Components$Membership$Form$RestartModal$MembershipRestarted),
                    adu: $author$project$Components$Membership$Form$RestartModal$None,
                    zi: _Utils_update(model, {
                        sy: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var membership = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Membership$Form$RestartModal$Restarted(membership),
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$RestartModal$None,
                    zi: _Utils_update(model, {
                        sy: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var dateInputModel = msg.a;
                var dateInputMsg = msg.b;
                var _v3 = A2($author$project$Components$DateInput$update, dateInputMsg, dateInputModel);
                var newDateInput = _v3.a;
                var subCmd = _v3.b;
                var event = _v3.c;
                if (event.$ === 1) {
                    var maybeDate = event.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            subCmd,
                            A5($author$project$Api$Provider$Membership$restart, apiClient, $author$project$Api$Provider$Membership$One$id(model.jc), true, maybeDate, $author$project$Components$Membership$Form$RestartModal$GotPriceCheck)
                        ])),
                        adu: $author$project$Components$Membership$Form$RestartModal$None,
                        zi: _Utils_update(model, {
                            qg: newDateInput,
                            UY: maybeDate
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: subCmd,
                    adu: $author$project$Components$Membership$Form$RestartModal$None,
                    zi: _Utils_update(model, {
                        qg: newDateInput
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Membership$Form$Sections$BillsOverview$Billed = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$BillsOverview$MembershipBilled = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$BillsOverview$None = {
        $: 0
    };
    var $author$project$Api$Provider$Membership$bill = F4(function(apiClient, id, startDate, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('membership', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('start_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, startDate))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Membership$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'bill'
        ]), $author$project$Api$Provider$Membership$membershipPath(id)))));
    });
    var $author$project$Components$Membership$Form$Sections$BillsOverview$update = F3(function(apiClient, msg, model) {
        if (!msg.$) {
            var startDate = msg.a;
            return {
                EQ: A4($author$project$Api$Provider$Membership$bill, apiClient, model.y0, startDate, $author$project$Components$Membership$Form$Sections$BillsOverview$Billed),
                adu: $author$project$Components$Membership$Form$Sections$BillsOverview$None,
                zi: _Utils_update(model, {
                    lf: $author$project$Api$Data$Loading
                }),
                at: _List_Nil
            };
        } else {
            var response = msg.a;
            if (response.$ === 3) {
                var membership = response.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$Sections$BillsOverview$MembershipBilled(membership),
                    zi: _Utils_update(model, {
                        lf: $author$project$Api$Data$NotAsked
                    }),
                    at: _List_Nil
                };
            } else return {
                EQ: $elm$core$Platform$Cmd$none,
                adu: $author$project$Components$Membership$Form$Sections$BillsOverview$None,
                zi: _Utils_update(model, {
                    lf: response
                }),
                at: $author$project$OutMsg$handleErrorResponse(response)
            };
        }
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$Canceled = 1;
    var $author$project$Components$Membership$Form$Sections$Contracts$GotCanceledResponse = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$None = 0;
    var $author$project$Components$Membership$Form$Sections$Contracts$Updated = 2;
    var $author$project$Api$Provider$Membership$MembershipContract$cancel = F3(function(apiClient, membershipId, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'cancel'
        ]), $author$project$Api$Provider$Membership$MembershipContract$membershipContractsPath(membershipId))));
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var bool = field.a;
                return _Utils_update(fields, {
                    Pg: bool
                });
            case 1:
                var date = field.a;
                return _Utils_update(fields, {
                    qv: $elm$core$Result$toMaybe($justinmimbs$date$Date$fromIsoString(date))
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    WA: $elm$core$String$toInt(string)
                });
            default:
                var type_ = field.a;
                return _Utils_update(fields, {
                    ah5: $author$project$Api$ContractType$fromString(type_)
                });
        }
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        y$: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                var endDate = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var newFields = _Utils_update(fields, {
                    qv: endDate
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        iv: !model.iv,
                        PU: A2($author$project$Utils$Form$set, newFields, model.PU)
                    }),
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        sO: !model.sO
                    }),
                    at: _List_Nil
                };
            case 4:
                var membershipId = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Api$Data$NotAsked, membershipId))
                    }),
                    at: _List_Nil
                };
            case 5:
                var membershipId = msg.a;
                var confirmed = msg.b;
                return confirmed ? {
                    EQ: A3($author$project$Api$Provider$Membership$MembershipContract$cancel, apiClient, membershipId, $author$project$Components$Membership$Form$Sections$Contracts$GotCanceledResponse(membershipId)),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Api$Data$Loading, membershipId))
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 3:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$Contracts$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            default:
                var membershipId = msg.a;
                var response = msg.b;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Nothing
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Contract canceled.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fd: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Api$Data$NotAsked, membershipId))
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Membership$Form$Sections$Members$None = 0;
    var $author$project$Components$Membership$Form$Sections$Members$Updated = 1;
    var $author$project$Api$Provider$MembershipPatient$New$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Membership$Form$Records$locationFromShared = function(location1) {
        return {
            aef: $author$project$Api$Provider$Location$Shared$id(location1),
            zr: $author$project$Api$Provider$Location$Shared$name(location1)
        };
    };
    var $author$project$Components$Membership$Form$Records$practitionerFromShared = function(practitioner) {
        return {
            aef: $author$project$Api$Provider$Practitioner$Shared$id(practitioner),
            zr: $author$project$Api$Provider$Practitioner$Shared$name(practitioner)
        };
    };
    var $author$project$Components$Membership$Form$Records$patientFromOne = function(patient) {
        return {
            IZ: $author$project$Api$Provider$Patient$One$age(patient),
            aef: $author$project$Api$Provider$Patient$One$id(patient),
            aeT: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$locationFromShared, $author$project$Api$Provider$Patient$One$location(patient)),
            T5: $author$project$Api$Provider$Patient$One$membershipStatus(patient),
            zr: $author$project$Api$Provider$Patient$One$name(patient),
            agi: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromShared, $author$project$Api$Provider$Patient$One$practitioner(patient)),
            aa4: $author$project$Api$Provider$Patient$One$usesTobacco(patient)
        };
    };
    var $author$project$Components$Membership$Form$Records$membershipPatientFromNew = F5(function(currentDate, membershipPatient, memberType, patient, startDate) {
        return {
            D7: $elm$core$Maybe$Just('create'),
            ab9: $elm$core$Maybe$Nothing,
            aca: $elm$core$Maybe$Nothing,
            LP: $elm$core$Maybe$Nothing,
            Ox: $elm$core$Maybe$Nothing,
            qv: $elm$core$Maybe$Nothing,
            O_: $elm$core$Maybe$Just(currentDate),
            PL: $elm$core$Maybe$Nothing,
            PP: $elm$core$Maybe$Nothing,
            aef: $author$project$Api$Provider$MembershipPatient$New$id(membershipPatient),
            TX: memberType,
            V7: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromOne, patient),
            _L: $elm$core$Maybe$Nothing,
            _0: startDate
        };
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDate = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOn = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$None = 0;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$Patient = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$Removed = 2;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$Restarted = 3;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDate = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$Updated = 1;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var patient = field.a;
                return _Utils_update(fields, {
                    V7: patient
                });
            case 1:
                var string = field.a;
                var patient = A2($elm$core$Maybe$map, function(patient_) {
                    return _Utils_update(patient_, {
                        aa4: $author$project$Utils$Bool$fromString(string)
                    });
                }, fields.V7);
                return _Utils_update(fields, {
                    V7: patient
                });
            case 2:
                var date = field.a;
                return _Utils_update(fields, {
                    O_: date
                });
            case 3:
                var date = field.a;
                return _Utils_update(fields, {
                    _0: date
                });
            case 4:
                var string = field.a;
                return _Utils_update(fields, {
                    _L: string
                });
            case 5:
                var currency = field.a;
                return _Utils_update(fields, {
                    PP: currency
                });
            case 6:
                var date = field.a;
                return _Utils_update(fields, {
                    qv: date
                });
            default:
                var _v1 = field.a;
                var cancellationReason = _v1.a;
                var cancellationReasonOther = _v1.b;
                return _Utils_update(fields, {
                    ab9: cancellationReason,
                    aca: cancellationReasonOther
                });
        }
    });
    var $author$project$Components$Patient$Form$withAddress = F2(function(address, _v0) {
        var settings = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        var _v1 = A2($author$project$Components$AddressInput$initFromApi, 'patient-address', address);
        var addressInput = _v1.a;
        var addressInputCmd = _v1.b;
        var newFields = _Utils_update(fields, {
            II: addressInput
        });
        return _Utils_Tuple2(A2($author$project$Components$Patient$Form$PatientForm, settings, A2($author$project$Utils$Form$set, newFields, form)), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Address), addressInputCmd));
    });
    var $author$project$Components$Patient$Form$withLeadSource = F4(function(apiClient, leadSource, leadSourceOther, _v0) {
        var settings = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        var _v1 = A3($author$project$Components$LeadSourceInput$init, apiClient, A2($elm$core$Maybe$map, $author$project$Api$LeadSource$Shared$id, leadSource), leadSourceOther);
        var leadSourceInput = _v1.a;
        var leadSourceInputCmd = _v1.b;
        var newFields = _Utils_update(fields, {
            S1: leadSourceInput
        });
        return _Utils_Tuple2(A2($author$project$Components$Patient$Form$PatientForm, settings, A2($author$project$Utils$Form$set, newFields, form)), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$LeadSource), leadSourceInputCmd));
    });
    var $author$project$Components$Patient$Form$withPractitioner = F3(function(apiClient, practitioner, _v0) {
        var settings = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        var _v1 = A3($author$project$Components$PractitionerInput$init, apiClient, $elm$core$Basics$identity, practitioner);
        var practitionerInput = _v1.a;
        var practitionerInputCmd = _v1.b;
        var newFields = _Utils_update(fields, {
            agi: practitionerInput
        });
        return _Utils_Tuple2(A2($author$project$Components$Patient$Form$PatientForm, settings, A2($author$project$Utils$Form$set, newFields, form)), A2($elm$core$Platform$Cmd$map, A2($elm$core$Basics$composeL, $author$project$Components$Patient$Form$FieldUpdated, $author$project$Components$Patient$Form$Practitioner), practitionerInputCmd));
    });
    var $author$project$Components$Patient$Form$withSyncToEmr = F2(function(syncToEmr, _v0) {
        var settings = _v0.a;
        var form = _v0.b;
        var fields = $author$project$Utils$Form$fields(form);
        var newFields = _Utils_update(fields, {
            $H: syncToEmr
        });
        return A2($author$project$Components$Patient$Form$PatientForm, settings, A2($author$project$Utils$Form$set, newFields, form));
    });
    var $author$project$Components$CreatePatientModal$init = F6(function(apiClient, currentDate, session, practice, hinterViewOff, patient) {
        var _v0 = A2($elm$core$Tuple$mapFirst, $author$project$Components$Patient$Form$withSyncToEmr(true), function(_v3) {
            var f = _v3.a;
            var cmd = _v3.b;
            return A2($elm$core$Tuple$mapSecond, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Platform$Cmd$batch, $elm$core$List$append(_List_fromArray([
                cmd
            ]))), $elm$core$List$singleton), A3($author$project$Components$Patient$Form$withPractitioner, apiClient, A2($elm$core$Maybe$map, $author$project$Api$Practitioner$Shared$Provider, $author$project$Api$Provider$Patient$One$practitioner(patient)), f));
        }(function(_v2) {
            var f = _v2.a;
            var cmd = _v2.b;
            return A2($elm$core$Tuple$mapSecond, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Platform$Cmd$batch, $elm$core$List$append(_List_fromArray([
                cmd
            ]))), $elm$core$List$singleton), A4($author$project$Components$Patient$Form$withLeadSource, apiClient, A2($elm$core$Maybe$map, $author$project$Api$LeadSource$Shared$Provider, $author$project$Api$Provider$Patient$One$leadSource(patient)), $author$project$Api$Provider$Patient$One$leadSourceOther(patient), f));
        }(function(_v1) {
            var f = _v1.a;
            var cmd = _v1.b;
            return A2($elm$core$Tuple$mapSecond, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $elm$core$Platform$Cmd$batch, $elm$core$List$append(_List_fromArray([
                cmd
            ]))), $elm$core$List$singleton), A2($author$project$Components$Patient$Form$withAddress, $author$project$Api$Provider$Patient$One$address(patient), f));
        }(A6($author$project$Components$Patient$Form$empty, apiClient, session, currentDate, $elm$core$Maybe$Nothing, false, function(settings) {
            return _Utils_update(settings, {
                ab1: $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice),
                ab8: A2($author$project$Api$Provider$Practice$One$featureEnabled, 3, practice),
                Qr: $author$project$Api$Provider$Practice$One$hasLocations(practice),
                Qx: $author$project$Api$Provider$Practice$One$hasPractitioners(practice),
                ae_: $author$project$Api$Provider$Practice$One$isMce(practice),
                ru: A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice),
                agQ: $author$project$Api$Provider$Practice$One$requiresPatientEmail(practice),
                YK: $author$project$Api$Provider$Practice$One$requiresLocation(practice),
                agR: $author$project$Api$Provider$Practice$One$requiresPatientMobile(practice),
                YP: $author$project$Api$Provider$Practice$One$requiresPractitioner(practice),
                YQ: $author$project$Api$Provider$Practice$One$requiresSSN(practice),
                _$: $author$project$Api$Provider$Practice$One$ssnEnabled(practice),
                $D: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, $author$project$Api$Provider$Practice$One$network(practice))),
                ah_: A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice),
                aaq: $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice),
                aas: $author$project$Api$Provider$Practice$One$transInclusivity(practice),
                DT: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0)
            });
        })))));
        var form = _v0.a;
        var formCmd = _v0.b;
        return _Utils_Tuple2({
            PU: form,
            Z$: session,
            km: false
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePatientModal$PatientFormMsg, formCmd));
    });
    var $author$project$Components$CreatePatientModal$Closed = {
        $: 1
    };
    var $author$project$Components$CreatePatientModal$Created = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$CreatePatientModal$None = {
        $: 0
    };
    var $author$project$Components$CreatePatientModal$PatientCreated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$CreatePatientModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$CreatePatientModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var formMsg = msg.a;
                var _v1 = A5($author$project$Components$Patient$Form$update, apiClient, model.Z$, $elm$core$Maybe$Nothing, formMsg, model.PU);
                var form = _v1.a;
                var formCmd = _v1.b;
                var formOutMsgs = _v1.c;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePatientModal$PatientFormMsg, formCmd),
                    adu: $author$project$Components$CreatePatientModal$None,
                    zi: _Utils_update(model, {
                        PU: form
                    }),
                    at: formOutMsgs
                };
            case 2:
                var _v2 = $author$project$Components$Patient$Form$validate(model.PU);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validForm = _v3.a;
                    var validFields = _v3.b;
                    return {
                        EQ: A3($author$project$Api$Provider$Patient$create, apiClient, A2($author$project$Components$Patient$Form$encode, validFields, validForm), $author$project$Components$CreatePatientModal$PatientCreated),
                        adu: $author$project$Components$CreatePatientModal$None,
                        zi: _Utils_update(model, {
                            km: true
                        }),
                        at: _List_Nil
                    };
                } else {
                    var erroredForm = _v2.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$CreatePatientModal$None,
                        zi: _Utils_update(model, {
                            PU: erroredForm
                        }),
                        at: _List_Nil
                    };
                }
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var patient = response.a;
                        return {
                            EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$CreatePatientModal$PatientFormMsg, A5($author$project$Components$Patient$Form$createAffiliation, apiClient, model.Z$, $author$project$Api$Provider$Patient$One$id(patient), $elm$core$Maybe$Nothing, model.PU).EQ),
                            adu: $author$project$Components$CreatePatientModal$Created(patient),
                            zi: _Utils_update(model, {
                                km: false
                            }),
                            at: _List_Nil
                        };
                    case 2:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$CreatePatientModal$None,
                            zi: _Utils_update(model, {
                                km: false
                            }),
                            at: $author$project$OutMsg$handleErrorResponse(response)
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$CreatePatientModal$None,
                            zi: _Utils_update(model, {
                                km: false
                            }),
                            at: _List_Nil
                        };
                }
        }
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField = F6(function(model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
        var dateInput = dateInputGetter(model);
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var dateInputEvent = _v0.c;
        var _v1 = function() {
            if (dateInputEvent.$ === 1) {
                var date = dateInputEvent.a;
                var field_ = toField(date);
                return _Utils_Tuple2(A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, toField(date), model.PU), $elm$core$Maybe$Just(field_));
            } else return _Utils_Tuple2(model.PU, $elm$core$Maybe$Nothing);
        }();
        var newForm = _v1.a;
        var field = _v1.b;
        return {
            EQ: A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
            adu: A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $elm$core$Basics$always(1), field)),
            zi: A2(dateInputSetter, newDateInput, _Utils_update(model, {
                PU: newForm
            })),
            at: _List_Nil
        };
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var membershipPatient = $author$project$Utils$Form$fields(model.PU);
                var newMembershipPatient = _Utils_update(membershipPatient, {
                    D7: $elm$core$Maybe$Just('restart'),
                    ab9: $elm$core$Maybe$Nothing,
                    aca: $elm$core$Maybe$Nothing,
                    qv: $elm$core$Maybe$Nothing
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 3,
                    zi: _Utils_update(model, {
                        PU: A2($author$project$Utils$Form$set, newMembershipPatient, model.PU),
                        aO: false
                    }),
                    at: _List_Nil
                };
            case 1:
                var endDate = msg.a;
                var membershipPatient = $author$project$Utils$Form$fields(model.PU);
                var _v2 = function() {
                    if (_Utils_eq(membershipPatient.D7, $elm$core$Maybe$Just('create'))) return _Utils_Tuple2(2, membershipPatient);
                    else {
                        var newMembershipPatient_ = _Utils_update(membershipPatient, {
                            D7: $elm$core$Maybe$Just('terminate'),
                            qv: endDate
                        });
                        return _Utils_Tuple2(1, newMembershipPatient_);
                    }
                }();
                var event = _v2.a;
                var newMembershipPatient = _v2.b;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: event,
                    zi: _Utils_update(model, {
                        PU: A2($author$project$Utils$Form$set, newMembershipPatient, model.PU),
                        aO: true
                    }),
                    at: _List_Nil
                };
            case 2:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 3:
                var subMsg = msg.a;
                var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rX);
                var _v3 = function() {
                    var _v4 = patientResourceResult.adu;
                    _v4$2: while(true){
                        if (!_v4.$ && !_v4.a.$) switch(_v4.a.a.$){
                            case 0:
                                var patient = _v4.a.a.a;
                                var patientRecord = $author$project$Components$Membership$Form$Records$patientFromAll(patient);
                                var field = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient($elm$core$Maybe$Just(patientRecord));
                                var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.PU);
                                return _Utils_Tuple3(newForm_, _Utils_eq(patientRecord.aa4, $elm$core$Maybe$Nothing), 1);
                            case 2:
                                var _v5 = _v4.a.a;
                                var field = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient($elm$core$Maybe$Nothing);
                                var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.PU);
                                return _Utils_Tuple3(newForm_, false, 1);
                            default:
                                break _v4$2;
                        }
                        else break _v4$2;
                    }
                    return _Utils_Tuple3(model.PU, model.d3, 0);
                }();
                var newForm = _v3.a;
                var editTobaccoUsage = _v3.b;
                var event = _v3.c;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg, patientResourceResult.EQ),
                    adu: event,
                    zi: _Utils_update(model, {
                        d3: editTobaccoUsage,
                        PU: newForm,
                        rX: patientResourceResult.zi
                    }),
                    at: patientResourceResult.at
                };
            case 4:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        qp: true
                    }),
                    at: _List_Nil
                };
            case 5:
                var subMsg = msg.a;
                return A6($author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField, model, function($) {
                    return $.qB;
                }, F2(function(newDateInput, model_) {
                    return _Utils_update(model_, {
                        qB: newDateInput
                    });
                }), subMsg, $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg, $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOn);
            case 6:
                var date = msg.a;
                var field = $author$project$Components$Membership$Form$Members$MembershipPatient$StartDate(date);
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        qq: true,
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 7:
                var subMsg = msg.a;
                return A6($author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField, model, function($) {
                    return $.kj;
                }, F2(function(newDateInput, model_) {
                    return _Utils_update(model_, {
                        kj: newDateInput
                    });
                }), subMsg, $author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg, $author$project$Components$Membership$Form$Members$MembershipPatient$StartDate);
            case 8:
                var fields = $author$project$Utils$Form$fields(model.PU);
                var specialRate = model.eg ? $elm$core$Maybe$Nothing : fields._L;
                var newFields = _Utils_update(fields, {
                    _L: specialRate
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: A2($author$project$Utils$Form$set, newFields, model.PU),
                        eg: !model.eg
                    }),
                    at: _List_Nil
                };
            case 9:
                var defaultValue = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var fixedPeriodRateInCents = function() {
                    var _v6 = _Utils_Tuple2(model.d2, fields.PP);
                    if (_v6.a) return $elm$core$Maybe$Nothing;
                    else if (!_v6.b.$) {
                        var fixedPeriodRateInCents_ = _v6.b.a;
                        return $elm$core$Maybe$Just(fixedPeriodRateInCents_);
                    } else {
                        var _v7 = _v6.b;
                        return defaultValue;
                    }
                }();
                var newFields = _Utils_update(fields, {
                    PP: fixedPeriodRateInCents
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        d2: !model.d2,
                        PU: A2($author$project$Utils$Form$set, newFields, model.PU)
                    }),
                    at: _List_Nil
                };
            case 10:
                var subMsg = msg.a;
                return A6($author$project$Components$Membership$Form$Members$MembershipPatient$updateDateInputFormField, model, function($) {
                    return $.qx;
                }, F2(function(newDateInput, model_) {
                    return _Utils_update(model_, {
                        qx: newDateInput
                    });
                }), subMsg, $author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg, $author$project$Components$Membership$Form$Members$MembershipPatient$EndDate);
            case 11:
                var patient = msg.a;
                var _v8 = A6($author$project$Components$CreatePatientModal$init, apiClient, model.cP, model.Z$, model.W1, model.aeb, patient);
                var createPatientModal = _v8.a;
                var createPatientModalCmd = _v8.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg, createPatientModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        h2: $elm$core$Maybe$Just(createPatientModal)
                    }),
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                var _v9 = model.h2;
                if (!_v9.$) {
                    var createPatientModal = _v9.a;
                    var createPatientModalResult = A3($author$project$Components$CreatePatientModal$update, apiClient, subMsg, createPatientModal);
                    var _v10 = function() {
                        var _v11 = createPatientModalResult.adu;
                        switch(_v11.$){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createPatientModalResult.zi), $elm$core$Maybe$Nothing, _List_Nil);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, _List_Nil);
                            default:
                                var patient = _v11.a;
                                var outMsgs_ = model.iZ ? _List_Nil : _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, $author$project$Api$Provider$Patient$One$name(patient) + ' was added as a new patient to this membership. Click \" Update \" to confirm adding them to this membership.')
                                ]);
                                var field_ = $author$project$Components$Membership$Form$Members$MembershipPatient$Patient($elm$core$Maybe$Just($author$project$Components$Membership$Form$Records$patientFromOne(patient)));
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Just(field_), outMsgs_);
                        }
                    }();
                    var createPatientModal_ = _v10.a;
                    var field = _v10.b;
                    var outMsgs = _v10.c;
                    var editTobaccoUsage = function() {
                        if (!field.$ && !field.a.$ && !field.a.a.$) {
                            var patientRecord = field.a.a.a;
                            return _Utils_eq(patientRecord.aa4, $elm$core$Maybe$Nothing);
                        } else return model.d3;
                    }();
                    var _v12 = A2($elm$core$Maybe$withDefault, _Utils_Tuple2(model.PU, 0), A2($elm$core$Maybe$map, function(field_) {
                        var newForm_ = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsUpdate, field_, model.PU);
                        return _Utils_Tuple2(newForm_, 1);
                    }, field));
                    var newForm = _v12.a;
                    var event = _v12.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg, createPatientModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            h2: createPatientModal_,
                            d3: editTobaccoUsage,
                            PU: newForm
                        }),
                        at: _Utils_ap(createPatientModalResult.at, outMsgs)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Membership$Form$Sections$Members$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var memberType = msg.a;
                var patient = msg.b;
                var startDate = msg.c;
                var response = msg.d;
                if (response.$ === 3) {
                    var membershipPatient = response.a;
                    var membershipPatientRecord = A5($author$project$Components$Membership$Form$Records$membershipPatientFromNew, model.cP, membershipPatient, memberType, patient, startDate);
                    var _v2 = A9($author$project$Components$Membership$Form$Members$MembershipPatient$init, apiClient, model.cP, model.Z$, model.W1, model.aeb, model.iZ, membershipPatientRecord.V7, $elm$core$Maybe$Nothing, membershipPatientRecord);
                    var membershipPatientModel = _v2.a;
                    var membershipPatientCmd = _v2.b;
                    var membershipPatients = A3($elm$core$Dict$insert, membershipPatientRecord.aef, _Utils_Tuple2($elm$core$Dict$size(model.T$), membershipPatientModel), model.T$);
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.aef), membershipPatientCmd),
                        adu: 1,
                        zi: _Utils_update(model, {
                            T$: membershipPatients
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$reportDecodeError(response)
                };
            case 1:
                var memberType = msg.a;
                var startDate = msg.b;
                return {
                    EQ: A4($author$project$Components$Membership$Form$Sections$Members$addMember, apiClient, memberType, $elm$core$Maybe$Nothing, startDate),
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var id = msg.a;
                var subMsg = msg.b;
                var _v3 = A2($elm$core$Dict$get, id, model.T$);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var originalIndex = _v4.a;
                    var membershipPatient = _v4.b;
                    var membershipPatientResult = A3($author$project$Components$Membership$Form$Members$MembershipPatient$update, apiClient, subMsg, membershipPatient);
                    var _v5 = function() {
                        var _v6 = membershipPatientResult.adu;
                        switch(_v6){
                            case 0:
                                return _Utils_Tuple2(A3($elm$core$Dict$insert, id, _Utils_Tuple2(originalIndex, membershipPatientResult.zi), model.T$), 0);
                            case 1:
                                var newMembershipPatients_ = A3($elm$core$Dict$insert, id, _Utils_Tuple2(originalIndex, membershipPatientResult.zi), model.T$);
                                return _Utils_Tuple2(newMembershipPatients_, 1);
                            case 2:
                                var newMembershipPatients_ = A2($elm$core$Dict$remove, id, model.T$);
                                return _Utils_Tuple2(newMembershipPatients_, 1);
                            default:
                                var newMembershipPatients_ = A3($elm$core$Dict$insert, id, _Utils_Tuple2(originalIndex, membershipPatientResult.zi), model.T$);
                                return _Utils_Tuple2(newMembershipPatients_, 1);
                        }
                    }();
                    var newMembershipPatients = _v5.a;
                    var event = _v5.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id), membershipPatientResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            T$: newMembershipPatients
                        }),
                        at: membershipPatientResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDate = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$Created = 2;
    var $author$project$Components$Membership$Form$Sections$PlanChange$Deleted = 1;
    var $author$project$Components$Membership$Form$Sections$PlanChange$GotDeletedResponse = F3(function(a, b, c) {
        return {
            $: 8,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$None = 0;
    var $author$project$Components$Membership$Form$Sections$PlanChange$ToPlan = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$Updated = 3;
    var $author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath = function(membershipId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'scheduled_changes'
        ]), $author$project$Api$Provider$Membership$membershipPath(membershipId));
    };
    var $author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath = F2(function(membershipId, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath(membershipId));
    });
    var $author$project$Api$Provider$Membership$ScheduledChange$delete = F4(function(apiClient, membershipId, id, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath, membershipId, id)));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var type_ = field.a;
                return _Utils_update(fields, {
                    ah5: type_
                });
            case 1:
                var dateInput = field.a;
                var date = field.b;
                return _Utils_update(fields, {
                    K3: date,
                    v5: dateInput
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    K2: $elm$core$String$toInt(string)
                });
            default:
                var planId = field.a;
                return _Utils_update(fields, {
                    $5: planId
                });
        }
    });
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$initFormFields = F2(function(contract, membershipMeta) {
        var type_ = contract.Pg ? 2 : 1;
        var _v0 = $author$project$Components$DateInput$init;
        var changeOnDateDateInput = _v0.a;
        var changeOnDateDateInputCmd = _v0.b;
        return _Utils_Tuple2({
            K2: $elm$core$Maybe$Nothing,
            K3: $elm$core$Maybe$Nothing,
            v5: changeOnDateDateInput,
            EV: contract,
            Gj: membershipMeta,
            $5: $elm$core$Maybe$Nothing,
            ah5: type_
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg(changeOnDateDateInput), changeOnDateDateInputCmd));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$GotCreatedResponse = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$GotUpdatedResponse = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$apiFields = function(validFormFields) {
        var _v0 = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        var changeOnDate = _v0.K3;
        var changeAfterMonths = _v0.K2;
        var toPlan = _v0.$5;
        return {
            K2: changeAfterMonths,
            K3: changeOnDate,
            $5: toPlan
        };
    };
    var $author$project$Api$Provider$MembershipScheduledChange$One$MembershipScheduledChange = 0;
    var $author$project$Api$Provider$MembershipScheduledChange$One$decoder = $elm$json$Json$Decode$succeed(0);
    var $author$project$Api$Provider$Membership$ScheduledChange$create = F4(function(apiClient, membershipId, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('scheduled_change', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('change_after_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.K2)),
                _Utils_Tuple2('change_on_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.K3)),
                _Utils_Tuple2('to_plan', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.$5))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$MembershipScheduledChange$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$ScheduledChange$scheduledChangesPath(membershipId))));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$ToPlanValidation = 2;
    var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonthsValidation = 1;
    var $author$project$Components$Membership$Form$Sections$PlanChange$validateChangeAfterMonths = function(fields) {
        var _v0 = _Utils_Tuple2(fields.ah5, fields.K2);
        if (_v0.a === 1) {
            if (!_v0.b.$) {
                var _v1 = _v0.a;
                var changeAfterMonths = _v0.b.a;
                return changeAfterMonths >= 1 && changeAfterMonths <= 48 ? _List_Nil : _List_fromArray([
                    _Utils_Tuple2(1, 'Please enter a number between 1 and 48')
                ]);
            } else {
                var _v2 = _v0.a;
                var _v3 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(1, 'Please enter a number.')
                ]);
            }
        } else return _List_Nil;
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateValidation = 0;
    var $author$project$Components$Membership$Form$Sections$PlanChange$validateChangeOnDate = F2(function(currentDate, fields) {
        var _v0 = _Utils_Tuple2(fields.ah5, fields.K3);
        if (!_v0.a) {
            if (!_v0.b.$) {
                var _v1 = _v0.a;
                var changeOnDate = _v0.b.a;
                var tomorrowDate = A3($justinmimbs$date$Date$add, 3, -1, currentDate);
                return A2($justinmimbs$date$Date$compare, tomorrowDate, changeOnDate) !== 2 ? _List_Nil : _List_fromArray([
                    _Utils_Tuple2(0, 'Please enter a date greater or equal than tomorrow')
                ]);
            } else {
                var _v2 = _v0.a;
                var _v3 = _v0.b;
                return _List_fromArray([
                    _Utils_Tuple2(0, 'Please enter a date.')
                ]);
            }
        } else return _List_Nil;
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsValidator = function(currentDate) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$PlanChange$validateChangeOnDate(currentDate)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$PlanChange$validateChangeAfterMonths),
            A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
                return $.$5;
            }, _Utils_Tuple2(2, 'Please pick a plan'))
        ]));
    };
    var $author$project$Api$Provider$Membership$ScheduledChange$update = F5(function(apiClient, membershipId, id, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('scheduled_change', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('change_after_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.K2)),
                _Utils_Tuple2('change_on_date', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Date$encode, fields.K3)),
                _Utils_Tuple2('to_plan', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, fields.$5))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$MembershipScheduledChange$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$Membership$ScheduledChange$scheduledChangePath, membershipId, id))));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$save = F3(function(apiClient, id, model) {
        var _v0 = _Utils_Tuple3(model.y0, A2($elm$core$Maybe$map, $author$project$Utils$Form$validate($author$project$Components$Membership$Form$Sections$PlanChange$formFieldsValidator(model.cP)), model.PU), id);
        if (!_v0.a.$ && !_v0.b.$) {
            if (_v0.b.a.$ === 1) {
                var newForm = _v0.b.a.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm)
                    }),
                    at: _List_Nil
                };
            } else if (!_v0.c.$) {
                var membershipId = _v0.a.a;
                var _v1 = _v0.b.a.a;
                var newForm = _v1.a;
                var validFormFields = _v1.b;
                var id_ = _v0.c.a;
                return {
                    EQ: A5($author$project$Api$Provider$Membership$ScheduledChange$update, apiClient, membershipId, id_, $author$project$Components$Membership$Form$Sections$PlanChange$apiFields(validFormFields), $author$project$Components$Membership$Form$Sections$PlanChange$GotUpdatedResponse),
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        j_: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            } else {
                var membershipId = _v0.a.a;
                var _v2 = _v0.b.a.a;
                var newForm = _v2.a;
                var validFormFields = _v2.b;
                var _v3 = _v0.c;
                return {
                    EQ: A4($author$project$Api$Provider$Membership$ScheduledChange$create, apiClient, membershipId, $author$project$Components$Membership$Form$Sections$PlanChange$apiFields(validFormFields), $author$project$Components$Membership$Form$Sections$PlanChange$GotCreatedResponse),
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: $elm$core$Maybe$Just(newForm),
                        j_: $author$project$Api$Data$Loading
                    }),
                    at: _List_Nil
                };
            }
        } else return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 0,
            zi: model,
            at: _List_Nil
        };
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$updateDateInputFormField = F6(function(model, dateInput, subMsg, toMsg, field, fieldGetter) {
        var _v0 = model.PU;
        if (!_v0.$) {
            var form = _v0.a;
            var _v1 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
            var newDateInput = _v1.a;
            var subCmd = _v1.b;
            var event = _v1.c;
            var newForm = function() {
                if (event.$ === 1) {
                    var date = event.a;
                    return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate, A2(field, newDateInput, date), form);
                } else {
                    var fields = $author$project$Utils$Form$fields(form);
                    return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate, A2(field, newDateInput, fieldGetter(fields)), form);
                }
            }();
            return {
                EQ: A2($elm$core$Platform$Cmd$map, toMsg(newDateInput), subCmd),
                adu: 0,
                zi: _Utils_update(model, {
                    PU: $elm$core$Maybe$Just(newForm)
                }),
                at: _List_Nil
            };
        } else return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: 0,
            zi: model,
            at: _List_Nil
        };
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var contract = msg.a;
                var membershipMeta = msg.b;
                var _v2 = A2($author$project$Components$Membership$Form$Sections$PlanChange$initFormFields, contract, membershipMeta);
                var formFields = _v2.a;
                var formFieldsCmd = _v2.b;
                return {
                    EQ: formFieldsCmd,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: $elm$core$Maybe$Just($author$project$Utils$Form$init(formFields))
                    }),
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 2:
                var membershipId = msg.a;
                var scheduledChange = msg.b;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just(_Utils_Tuple3(membershipId, $author$project$Api$Data$NotAsked, scheduledChange))
                    }),
                    at: _List_Nil
                };
            case 7:
                var membershipId = msg.a;
                var scheduledChange = msg.b;
                var confirmed = msg.c;
                return confirmed ? {
                    EQ: A4($author$project$Api$Provider$Membership$ScheduledChange$delete, apiClient, membershipId, $author$project$Api$Provider$MembershipScheduledChange$Shared$id(scheduledChange), A2($author$project$Components$Membership$Form$Sections$PlanChange$GotDeletedResponse, membershipId, scheduledChange)),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just(_Utils_Tuple3(membershipId, $author$project$Api$Data$Loading, scheduledChange))
                    }),
                    at: _List_Nil
                } : {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
            case 3:
                var field = msg.a;
                var _v3 = model.PU;
                if (!_v3.$) {
                    var form = _v3.a;
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate, field, form);
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            PU: $elm$core$Maybe$Just(newForm)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var dateInput = msg.a;
                var subMsg = msg.b;
                return A6($author$project$Components$Membership$Form$Sections$PlanChange$updateDateInputFormField, model, dateInput, subMsg, $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg, $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDate, function($) {
                    return $.K3;
                });
            case 5:
                var subMsg = msg.a;
                var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jy);
                var newForm = A2($elm$core$Maybe$map, function(form) {
                    var _v4 = planResourceResult.adu;
                    if (!_v4.$ && !_v4.a.$) {
                        var planId = $author$project$Components$ResourceFilter$Plan$value(planResourceResult.zi);
                        return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$PlanChange$formFieldsUpdate, $author$project$Components$Membership$Form$Sections$PlanChange$ToPlan(planId), form);
                    } else return form;
                }, model.PU);
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg, planResourceResult.EQ),
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm,
                        jy: planResourceResult.zi
                    }),
                    at: planResourceResult.at
                };
            case 8:
                var membershipId = msg.a;
                var scheduledChange = msg.b;
                var response = msg.c;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Nothing
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change removed.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        fr: $elm$core$Maybe$Just(_Utils_Tuple3(membershipId, $author$project$Api$Data$NotAsked, scheduledChange))
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 6:
                var id = msg.a;
                return A3($author$project$Components$Membership$Form$Sections$PlanChange$save, apiClient, id, model);
            case 9:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: _Utils_update(model, {
                        j_: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change applied.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 3,
                    zi: _Utils_update(model, {
                        j_: response
                    }),
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Scheduled plan change applied.')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$None = 0;
    var $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSelectMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$Updated = 1;
    var $author$project$Components$Membership$Form$Sections$Pricing$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var currency = field.a;
                return _Utils_update(fields, {
                    PP: currency
                });
            case 1:
                var coupon = field.a;
                return _Utils_update(fields, {
                    Mj: $author$project$Utils$String$toMaybe(coupon)
                });
            default:
                var currency = field.a;
                return _Utils_update(fields, {
                    PQ: currency
                });
        }
    });
    var $author$project$Api$Provider$MembershipBill$Shared$registrationFeeInCents = function(_v0) {
        var record = _v0;
        return record.Yt;
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipBill$Shared$registrationFeeInCents(shared);
    };
    var $author$project$Api$Provider$Membership$One$revenueInCents = function(_v0) {
        var record = _v0.b;
        return record.Y1;
    };
    var $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills = function(_v0) {
        var record = _v0.b;
        return record.aaL;
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        wY: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                var pendingMembership = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var manuallySet = fields.cc;
                var fixedPeriodRateInCents = function() {
                    var _v2 = _Utils_Tuple2(manuallySet.X5, fields.PP);
                    if (_v2.a) return $elm$core$Maybe$Nothing;
                    else if (!_v2.b.$) {
                        var fixedPeriodRateInCents_ = _v2.b.a;
                        return $elm$core$Maybe$Just(fixedPeriodRateInCents_);
                    } else {
                        var _v3 = _v2.b;
                        return $elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Provider$Membership$One$revenueInCents(pendingMembership)));
                    }
                }();
                var newFields = _Utils_update(fields, {
                    PP: fixedPeriodRateInCents,
                    cc: _Utils_update(manuallySet, {
                        X5: !manuallySet.X5
                    })
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: A2($author$project$Utils$Form$set, newFields, model.PU)
                    }),
                    at: _List_Nil
                };
            case 2:
                var pendingMembership = msg.a;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var manuallySet = fields.cc;
                var fixedRegistrationFeeInCents = function() {
                    var _v4 = _Utils_Tuple2(manuallySet.ex, fields.PQ);
                    if (_v4.a) return $elm$core$Maybe$Nothing;
                    else if (!_v4.b.$) {
                        var fixedRegistrationFeeInCents_ = _v4.b.a;
                        return $elm$core$Maybe$Just(fixedRegistrationFeeInCents_);
                    } else {
                        var _v5 = _v4.b;
                        return A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents, $elm$core$List$head($author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership))));
                    }
                }();
                var newFields = _Utils_update(fields, {
                    PQ: fixedRegistrationFeeInCents,
                    cc: _Utils_update(manuallySet, {
                        ex: !manuallySet.ex
                    })
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: A2($author$project$Utils$Form$set, newFields, model.PU)
                    }),
                    at: _List_Nil
                };
            case 3:
                var fields = $author$project$Utils$Form$fields(model.PU);
                var newFields = model.Oq ? _Utils_update(fields, {
                    Mj: $elm$core$Maybe$Nothing
                }) : fields;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        Oq: !model.Oq,
                        PU: A2($author$project$Utils$Form$set, newFields, model.PU)
                    }),
                    at: _List_Nil
                };
            case 4:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$Pricing$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 5:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        A0: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 6:
                var _v6 = function() {
                    if (model.l0) {
                        var fields = $author$project$Utils$Form$fields(model.PU);
                        return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($author$project$Utils$Form$set, _Utils_update(fields, {
                            Wr: $elm$core$Maybe$Nothing
                        }), model.PU));
                    } else return _Utils_Tuple2(model.j3, model.PU);
                }();
                var newSelectedPaymentMethod = _v6.a;
                var newForm = _v6.b;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        l0: !model.l0,
                        PU: newForm,
                        j3: newSelectedPaymentMethod
                    }),
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                var _v7 = A2($author$project$Ui$Form$SearchableSelect$update, subMsg, model.rZ);
                var newSelect = _v7.a;
                var selectCmd = _v7.b;
                var maybeEvent = _v7.c;
                var _v8 = function() {
                    if (!maybeEvent.$ && !maybeEvent.a.$) {
                        var maybePaymentMethod = maybeEvent.a.a;
                        var newPaymentSource = function() {
                            if (!maybePaymentMethod.$) {
                                var pm = maybePaymentMethod.a;
                                return $elm$core$Maybe$Just({
                                    aef: $elm$core$Maybe$Just($author$project$Api$Provider$PaymentMethod$Min$id(pm))
                                });
                            } else return $elm$core$Maybe$Just({
                                aef: $elm$core$Maybe$Nothing
                            });
                        }();
                        var fields = $author$project$Utils$Form$fields(model.PU);
                        return _Utils_Tuple3(A2($author$project$Utils$Form$set, _Utils_update(fields, {
                            Wr: newPaymentSource
                        }), model.PU), maybePaymentMethod, 1);
                    } else return _Utils_Tuple3(model.PU, model.j3, 0);
                }();
                var newForm = _v8.a;
                var newSelectedPaymentMethod = _v8.b;
                var event = _v8.c;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSelectMsg, selectCmd),
                    adu: event,
                    zi: _Utils_update(model, {
                        PU: newForm,
                        rZ: newSelect,
                        j3: newSelectedPaymentMethod
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$None = 0;
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$Updated = 1;
    var $author$project$Api$Provider$Uom$Shared$periodInMonths = function(_v0) {
        var record = _v0;
        return record.WA;
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate = F3(function(index, field, fields) {
        var recurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(recurringCharge) {
            switch(field.$){
                case 0:
                    var _int = field.a;
                    var quantity = function() {
                        var _v1 = _Utils_Tuple2($author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.aaK), _int);
                        if (!_v1.a.$ && !_v1.b.$) {
                            var chargeItemPeriod = _v1.a.a;
                            var periodInMonths = _v1.b.a;
                            return $elm$core$Maybe$Just(periodInMonths / chargeItemPeriod | 0);
                        } else return recurringCharge.Bu;
                    }();
                    return _Utils_update(recurringCharge, {
                        WA: _int,
                        Bu: quantity
                    });
                case 1:
                    var _int = field.a;
                    return _Utils_update(recurringCharge, {
                        agb: _int
                    });
                default:
                    var _int = field.a;
                    return _Utils_update(recurringCharge, {
                        Bu: _int
                    });
            }
        }, fields.Yl);
        return _Utils_update(fields, {
            Yl: recurringCharges
        });
    });
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initChargeItemResourceFilter = F2(function(apiClient, showItemTypeInTitle) {
        return A4($author$project$Components$ResourceFilter$ChargeItem$initWithItemType, showItemTypeInTitle, apiClient, function(d) {
            return _Utils_update(d, {
                $S: $elm$core$Maybe$Just(false)
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'Select an item',
                I5: true
            });
        });
    });
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFields = function(patient) {
        return {
            lv: $elm$core$Maybe$Nothing,
            adS: $elm$core$Maybe$Nothing,
            adT: $elm$core$Maybe$Nothing,
            V7: patient,
            agb: $elm$core$Maybe$Nothing,
            agi: $elm$core$Maybe$Nothing,
            aaK: $elm$core$Maybe$Nothing
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFieldsFromItem = function(recurringCharge) {
        return {
            lv: $elm$core$Maybe$Just(recurringCharge.lv),
            adS: recurringCharge.adS,
            adT: A2($elm$core$Maybe$map, $author$project$Currency$fromFloat, recurringCharge.adT),
            V7: recurringCharge.V7,
            agb: recurringCharge.agb,
            agi: recurringCharge.agi,
            aaK: $elm$core$Maybe$Just(recurringCharge.aaK)
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initLimitedPatientSelector = F3(function(apiClient, patients, patient) {
        return A4($author$project$Components$LimitedPatientSelector$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Select a Patient',
                I5: true
            });
        }, patients, patient);
    });
    var $author$project$Components$ResourceFilter$Practitioner$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initPractitionerResourceFilter = F2(function(apiClient, practitioner) {
        return function(_v0) {
            var practitionerResourceFilter = _v0.a;
            var practitionerResourceFilterCmd = _v0.b;
            return A2($elm$core$Maybe$withDefault, _Utils_Tuple2(practitionerResourceFilter, practitionerResourceFilterCmd), A2($elm$core$Maybe$map, function(practitioner_) {
                var _v1 = A2($author$project$Components$ResourceFilter$Practitioner$preSelectedId, $elm$core$Maybe$Just(practitioner_.aef), practitionerResourceFilter);
                var withPreSelectedModel = _v1.a;
                var withPreSelectedCmd = _v1.b;
                return _Utils_Tuple2(A2($author$project$Components$ResourceFilter$Practitioner$extraItems, _List_fromArray([
                    {
                        aef: practitioner_.aef,
                        zr: practitioner_.aef
                    }
                ]), withPreSelectedModel), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    withPreSelectedCmd,
                    practitionerResourceFilterCmd
                ])));
            }, practitioner));
        }(A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned'
            });
        }));
    });
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init = F6(function(apiClient, showItemTypeInTitle, patients, patient, index, recurringCharge) {
        var formFields = function() {
            if (!recurringCharge.$) {
                var recurringCharge_ = recurringCharge.a;
                return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFieldsFromItem(recurringCharge_);
            } else return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initFormFields(patient);
        }();
        var _v0 = A2($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initPractitionerResourceFilter, apiClient, A2($elm$core$Maybe$andThen, function($) {
            return $.agi;
        }, recurringCharge));
        var practitionerResourceFilter = _v0.a;
        var practitionerResourceFilterCmd = _v0.b;
        var _v1 = A3($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initLimitedPatientSelector, apiClient, patients, formFields.V7);
        var limitedPatientSelector = _v1.a;
        var limitedPatientSelectorCmd = _v1.b;
        var _v2 = A2($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$initChargeItemResourceFilter, apiClient, showItemTypeInTitle);
        var chargeItemResourceFilter = _v2.a;
        var chargeItemResourceFilterCmd = _v2.b;
        return _Utils_Tuple2({
            cL: chargeItemResourceFilter,
            PU: $author$project$Utils$Form$init(formFields),
            yc: index,
            rg: limitedPatientSelector,
            jE: practitionerResourceFilter
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg, limitedPatientSelectorCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg, chargeItemResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
        ])));
    });
    var $author$project$Components$Membership$Form$Records$recurringChargeFromNew = function(newRecurringCharge) {
        var _v0 = _Utils_Tuple2(newRecurringCharge.lv, newRecurringCharge.aaK);
        if (!_v0.a.$ && !_v0.b.$) {
            var chargeItem = _v0.a.a;
            var uom = _v0.b.a;
            return $elm$core$Maybe$Just({
                lv: chargeItem,
                adS: $elm$core$Maybe$Nothing,
                adT: $elm$core$Maybe$Nothing,
                aef: $elm$core$Maybe$Nothing,
                zr: $elm$core$Maybe$Nothing,
                UY: $elm$core$Maybe$Nothing,
                V7: newRecurringCharge.V7,
                WA: $elm$core$Maybe$Just(A2($elm$core$Maybe$withDefault, 1, $author$project$Api$Provider$Uom$Shared$periodInMonths(uom))),
                WC: newRecurringCharge.agb,
                agb: newRecurringCharge.agb,
                agi: newRecurringCharge.agi,
                Bu: $elm$core$Maybe$Just(1),
                _0: $elm$core$Maybe$Nothing,
                aaK: uom
            });
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Added = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Closed = {
        $: 1
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None = {
        $: 0
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Updated = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Records$chargeItemFromResourceFilter = function(chargeItem) {
        return {
            NQ: chargeItem.NQ,
            aef: chargeItem.aef,
            zr: chargeItem.zr,
            Br: chargeItem.Br
        };
    };
    var $author$project$Components$Membership$Form$Records$patientFromLimitedPatientSelector = $elm$core$Basics$identity;
    var $author$project$Components$Membership$Form$Records$practitionerFromResourceFilter = function(practitioner) {
        return {
            aef: practitioner.aef,
            zr: practitioner.zr
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var patient = field.a;
                return _Utils_update(fields, {
                    V7: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromLimitedPatientSelector, patient),
                    agi: A2($elm$core$Maybe$andThen, function($) {
                        return $.agi;
                    }, patient)
                });
            case 1:
                var chargeItem = field.a;
                return _Utils_update(fields, {
                    lv: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$chargeItemFromResourceFilter, chargeItem),
                    aaK: A2($elm$core$Maybe$map, function($) {
                        return $.aaK;
                    }, chargeItem)
                });
            case 2:
                var practitioner = field.a;
                return _Utils_update(fields, {
                    agi: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$practitionerFromResourceFilter, practitioner)
                });
            case 3:
                var currency = field.a;
                return _Utils_update(fields, {
                    adT: currency
                });
            default:
                var string = field.a;
                return _Utils_update(fields, {
                    adS: $author$project$Utils$String$toMaybe(string)
                });
        }
    });
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemValidation = 1;
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PatientValidation = 0;
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.V7;
        }, _Utils_Tuple2(0, 'Please pick a patient')),
        A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.lv;
        }, _Utils_Tuple2(1, 'Please pick a charge item'))
    ]));
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Closed,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 2:
                var subMsg = msg.a;
                var patientResourceResult = A3($author$project$Components$LimitedPatientSelector$update, apiClient, subMsg, model.rg);
                var newForm = function() {
                    var _v2 = patientResourceResult.adu;
                    _v2$2: while(true){
                        if (_v2.$ === 1) switch(_v2.a.$){
                            case 0:
                                var patient = _v2.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient($elm$core$Maybe$Just(patient)), model.PU);
                            case 3:
                                var _v3 = _v2.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Patient($elm$core$Maybe$Nothing), model.PU);
                            default:
                                break _v2$2;
                        }
                        else break _v2$2;
                    }
                    return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg, patientResourceResult.EQ),
                    adu: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
                    zi: _Utils_update(model, {
                        PU: newForm,
                        rg: patientResourceResult.zi
                    }),
                    at: patientResourceResult.at
                };
            case 3:
                var subMsg = msg.a;
                var chargeItemResourceResult = A3($author$project$Components$ResourceFilter$ChargeItem$update, apiClient, subMsg, model.cL);
                var newForm = function() {
                    var _v4 = chargeItemResourceResult.adu;
                    _v4$2: while(true){
                        if (!_v4.$ && !_v4.a.$) switch(_v4.a.a.$){
                            case 0:
                                var chargeItem = _v4.a.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem($elm$core$Maybe$Just(chargeItem)), model.PU);
                            case 2:
                                var _v5 = _v4.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItem($elm$core$Maybe$Nothing), model.PU);
                            default:
                                break _v4$2;
                        }
                        else break _v4$2;
                    }
                    return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg, chargeItemResourceResult.EQ),
                    adu: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
                    zi: _Utils_update(model, {
                        cL: chargeItemResourceResult.zi,
                        PU: newForm
                    }),
                    at: chargeItemResourceResult.at
                };
            case 4:
                var subMsg = msg.a;
                var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, model.jE);
                var newForm = function() {
                    var _v6 = practitionerResourceResult.adu;
                    _v6$2: while(true){
                        if (!_v6.$ && !_v6.a.$) switch(_v6.a.a.$){
                            case 0:
                                var practitioner = _v6.a.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner($elm$core$Maybe$Just(practitioner)), model.PU);
                            case 2:
                                var _v7 = _v6.a.a;
                                return A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsUpdate, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Practitioner($elm$core$Maybe$Nothing), model.PU);
                            default:
                                break _v6$2;
                        }
                        else break _v6$2;
                    }
                    return model.PU;
                }();
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg, practitionerResourceResult.EQ),
                    adu: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
                    zi: _Utils_update(model, {
                        PU: newForm,
                        jE: practitionerResourceResult.zi
                    }),
                    at: practitionerResourceResult.at
                };
            default:
                var periodsRemaining = msg.a;
                var _v8 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$formFieldsValidator, model.PU);
                if (!_v8.$) {
                    var _v9 = _v8.a;
                    var newForm = _v9.a;
                    var validFormFields = _v9.b;
                    var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var event = function() {
                        var _v10 = model.yc;
                        if (!_v10.$) {
                            var index = _v10.a;
                            return A2($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Updated, index, _Utils_update(formFields, {
                                agb: periodsRemaining
                            }));
                        } else return $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Added(_Utils_update(formFields, {
                            agb: periodsRemaining
                        }));
                    }();
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: event,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                } else {
                    var newForm = _v8.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$None,
                        zi: _Utils_update(model, {
                            PU: newForm
                        }),
                        at: _List_Nil
                    };
                }
        }
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    var taxableChargeItemsCount = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-total-count', headers)));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            qO: taxableChargeItemsCount > 0
                        }),
                        at: $author$project$OutMsg$handleErrorResponse(response)
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                var index = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate(index), $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining($elm$core$Maybe$Just(1)), model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 2:
                var index = msg.a;
                var formFields = $author$project$Utils$Form$fields(model.PU);
                var newFormFields = _Utils_update(formFields, {
                    Yl: A2($elm_community$list_extra$List$Extra$removeAt, index, formFields.Yl)
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: A2($author$project$Utils$Form$set, newFormFields, model.PU)
                    }),
                    at: _List_Nil
                };
            case 3:
                var patients = msg.a;
                var index = msg.b;
                var _v3 = $author$project$Utils$Form$fields(model.PU);
                var recurringCharges = _v3.Yl;
                var _v4 = A2($elm_community$list_extra$List$Extra$getAt, index, recurringCharges);
                if (!_v4.$) {
                    var recurringCharge = _v4.a;
                    var _v5 = A6($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init, apiClient, model.Cz, patients, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(index), $elm$core$Maybe$Just(recurringCharge));
                    var createEditModal = _v5.a;
                    var createEditModalCmd = _v5.b;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalCmd),
                        adu: 0,
                        zi: _Utils_update(model, {
                            fm: $elm$core$Maybe$Just(createEditModal)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var index = msg.a;
                var field = msg.b;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsUpdate(index), field, model.PU);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        PU: newForm
                    }),
                    at: _List_Nil
                };
            case 5:
                var patients = msg.a;
                var patient = $elm$core$List$head(patients);
                var _v6 = A6($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$init, apiClient, model.Cz, patients, patient, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
                var createEditModal = _v6.a;
                var createEditModalCmd = _v6.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalCmd),
                    adu: 0,
                    zi: _Utils_update(model, {
                        fm: $elm$core$Maybe$Just(createEditModal)
                    }),
                    at: _List_Nil
                };
            default:
                var subMsg = msg.a;
                var _v7 = model.fm;
                if (!_v7.$) {
                    var createEditModal = _v7.a;
                    var createEditModalResult = A3($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$update, apiClient, subMsg, createEditModal);
                    var _v8 = function() {
                        var _v9 = createEditModalResult.adu;
                        switch(_v9.$){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(createEditModalResult.zi), model.PU, 0);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, model.PU, 0);
                            case 2:
                                var newRecurringCharge = _v9.a;
                                var _v10 = $author$project$Components$Membership$Form$Records$recurringChargeFromNew(newRecurringCharge);
                                if (!_v10.$) {
                                    var recurringCharge = _v10.a;
                                    var formFields = $author$project$Utils$Form$fields(model.PU);
                                    var newFormFields = _Utils_update(formFields, {
                                        Yl: _Utils_ap(formFields.Yl, _List_fromArray([
                                            recurringCharge
                                        ]))
                                    });
                                    return _Utils_Tuple3($elm$core$Maybe$Nothing, A2($author$project$Utils$Form$set, newFormFields, model.PU), 1);
                                } else return _Utils_Tuple3($elm$core$Maybe$Nothing, model.PU, 0);
                            default:
                                var index = _v9.a;
                                var updatedRecurringCharge = _v9.b;
                                var formFields = $author$project$Utils$Form$fields(model.PU);
                                var newRecurringCharges = A3($elm_community$list_extra$List$Extra$updateAt, index, function(recurringCharge) {
                                    return _Utils_update(recurringCharge, {
                                        adS: updatedRecurringCharge.adS,
                                        adT: A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, updatedRecurringCharge.adT),
                                        V7: updatedRecurringCharge.V7,
                                        agi: updatedRecurringCharge.agi
                                    });
                                }, formFields.Yl);
                                var newFormFields = _Utils_update(formFields, {
                                    Yl: newRecurringCharges
                                });
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A2($author$project$Utils$Form$set, newFormFields, model.PU), 1);
                        }
                    }();
                    var newCreateEditModal = _v8.a;
                    var newForm = _v8.b;
                    var event = _v8.c;
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, createEditModalResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            fm: newCreateEditModal,
                            PU: newForm
                        }),
                        at: createEditModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Membership$Form$Sections$Summary$NextBillDate = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$None = {
        $: 0
    };
    var $author$project$Components$Membership$Form$Sections$Summary$Owner = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$Plan = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$StartDate = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$Updated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$FormUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm = function(field) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Components$Membership$Form$Sections$Summary$FormUpdated(field);
        }, $elm$core$Process$sleep(0));
    };
    var $author$project$Components$ResourceFilter$Plan$extraItems = F2(function(list_, model) {
        var extraItems_ = A2($elm$core$List$map, function(item) {
            return {
                aeI: item.zr,
                aa9: item.aef
            };
        }, list_);
        return _Utils_update(model, {
            bf: A2($author$project$Components$ResourceFilter$extraItems, extraItems_, model.bf)
        });
    });
    var $author$project$Components$Membership$Form$Sections$Summary$GotBrokerDeals = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals = F3(function(apiClient, isNew, membershipId) {
        return isNew ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Provider$BrokerDeal$list, apiClient, function(d) {
            return _Utils_update(d, {
                jc: $elm$core$Maybe$Just(membershipId)
            });
        }, $author$project$Components$Membership$Form$Sections$Summary$GotBrokerDeals);
    });
    var $author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Records$planFromApiPlan = function(plan) {
        return {
            aef: $author$project$Api$Plan$id(plan),
            zr: $author$project$Api$Plan$name(plan)
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var patient = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    VM: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$patientFromAll, patient)
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var plan = field.a;
                var cmd = A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, function(plan_) {
                    var allowedPeriodInMonths = A2($elm$core$List$map, $author$project$Api$Period$numberOfMonths, $author$project$Api$Plan$periods(plan_));
                    return !A2($elm$core$List$member, fields.WA, allowedPeriodInMonths) ? $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm($author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths(A2($elm$core$Maybe$withDefault, 1, $elm$core$List$head(allowedPeriodInMonths)))) : $elm$core$Platform$Cmd$none;
                }, plan));
                return _Utils_Tuple2(_Utils_update(fields, {
                    GW: A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Records$planFromApiPlan, plan)
                }), cmd);
            case 2:
                var date = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    _0: date
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var date = field.a;
                var billDate = fields.eJ ? date : $elm$core$Maybe$Nothing;
                return _Utils_Tuple2(_Utils_update(fields, {
                    vN: billDate,
                    UY: date
                }), $elm$core$Platform$Cmd$none);
            case 5:
                var bool = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    JX: bool
                }), $elm$core$Platform$Cmd$none);
            case 6:
                var _int = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    WA: _int
                }), $elm$core$Platform$Cmd$none);
            case 7:
                var string = field.a;
                return _Utils_Tuple2(_Utils_update(fields, {
                    Up: $elm$core$String$toInt(string)
                }), $elm$core$Platform$Cmd$none);
            default:
                var bool = field.a;
                var billDate = bool ? fields.UY : $elm$core$Maybe$Nothing;
                return _Utils_Tuple2(_Utils_update(fields, {
                    vN: billDate,
                    eJ: bool
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Components$ResourceFilter$Plan$preSelectedId = F2(function(id, model) {
        var _v0 = A2($author$project$Components$ResourceFilter$preSelectedId, id, model.bf);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            bf: resourceFilter
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod = function(_v0) {
        var record = _v0;
        return record.Kh;
    };
    var $author$project$Api$Employer$Plan$All$billsAtEndOfPeriod = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(shared);
    };
    var $author$project$Api$Employer$Plan$One$billsAtEndOfPeriod = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(shared);
    };
    var $author$project$Api$Provider$Plan$All$billsAtEndOfPeriod = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(shared);
    };
    var $author$project$Api$Plan$billsAtEndOfPeriod = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$billsAtEndOfPeriod(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$billsAtEndOfPeriod(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$billsAtEndOfPeriod(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$billsAtEndOfPeriod(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$billsAtEndOfPeriod(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$billsAtEndOfPeriod(plan_);
        }
    };
    var $author$project$Components$Membership$Form$Sections$Summary$planBillsAtEndOfPeriodChanged = F2(function(pendingMembership, plan) {
        var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
        return !_Utils_eq($author$project$Api$Provider$Plan$SharedWithContractInfo$billsAtEndOfPeriod(pendingMembershipPlan), $author$project$Api$Plan$billsAtEndOfPeriod(plan));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$resetBillDate = F3(function(pendingMembership, newPlan, model) {
        if (A2($author$project$Components$Membership$Form$Sections$Summary$planBillsAtEndOfPeriodChanged, pendingMembership, newPlan)) {
            var fields = $author$project$Utils$Form$fields(model.PU);
            var newFields = _Utils_update(fields, {
                vN: $elm$core$Maybe$Nothing
            });
            return _Utils_update(model, {
                PU: A2($author$project$Utils$Form$set, newFields, model.PU)
            });
        } else return model;
    });
    var $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths = function(_v0) {
        var record = _v0;
        return record.Up;
    };
    var $author$project$Api$Employer$Plan$All$minimumEnrollmentPeriodInMonths = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
    };
    var $author$project$Api$Employer$Plan$One$minimumEnrollmentPeriodInMonths = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
    };
    var $author$project$Api$Provider$Plan$All$minimumEnrollmentPeriodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(shared);
    };
    var $author$project$Api$Plan$minimumEnrollmentPeriodInMonths = function(plan) {
        switch(plan.$){
            case 0:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$Shared$minimumEnrollmentPeriodInMonths(plan_);
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths(plan_);
            case 4:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$Shared$minimumEnrollmentPeriodInMonths(plan_);
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$minimumEnrollmentPeriodInMonths(plan_);
            case 6:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$All$minimumEnrollmentPeriodInMonths(plan_);
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$minimumEnrollmentPeriodInMonths(plan_);
            default:
                var plan_ = plan.a;
                return $author$project$Api$Employer$Plan$One$minimumEnrollmentPeriodInMonths(plan_);
        }
    };
    var $author$project$Components$Membership$Form$Sections$Summary$planMinimumEnrollmentPeriodInMonthsChanged = F2(function(pendingMembership, plan) {
        var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
        return !_Utils_eq($author$project$Api$Provider$Plan$SharedWithContractInfo$minimumEnrollmentPeriodInMonths(pendingMembershipPlan), $author$project$Api$Plan$minimumEnrollmentPeriodInMonths(plan));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$resetMinimumEnrollmentPeriod = F3(function(pendingMembership, newPlan, model) {
        if (A2($author$project$Components$Membership$Form$Sections$Summary$planMinimumEnrollmentPeriodInMonthsChanged, pendingMembership, newPlan)) {
            var show = model.oi;
            var fields = $author$project$Utils$Form$fields(model.PU);
            var newFields = _Utils_update(fields, {
                Up: $author$project$Api$Plan$minimumEnrollmentPeriodInMonths(newPlan)
            });
            return _Utils_update(model, {
                PU: A2($author$project$Utils$Form$set, newFields, model.PU),
                oi: _Utils_update(show, {
                    eY: !show.eY
                })
            });
        } else return model;
    });
    var $author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField = F6(function(model, dateInputGetter, dateInputSetter, subMsg, toMsg, toField) {
        var dateInput = dateInputGetter(model);
        var _v0 = A2($author$project$Components$DateInput$update, subMsg, dateInput);
        var newDateInput = _v0.a;
        var subCmd = _v0.b;
        var dateInputEvent = _v0.c;
        var newFormCmd = function() {
            if (dateInputEvent.$ === 1) {
                var date = dateInputEvent.a;
                var field_ = toField(date);
                return $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm(field_);
            } else return $elm$core$Platform$Cmd$none;
        }();
        return {
            EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                newFormCmd,
                A2($elm$core$Platform$Cmd$map, toMsg, subCmd)
            ])),
            adu: $author$project$Components$Membership$Form$Sections$Summary$None,
            zi: A2(dateInputSetter, newDateInput, model),
            at: _List_Nil
        };
    });
    var $author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate = F3(function(membership, startDate, model) {
        var fields = $author$project$Utils$Form$fields(model.PU);
        var calculatedStartDate = $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership) ? A3($justinmimbs$date$Date$add, 1, $author$project$Api$Provider$Membership$One$periodInMonths(membership), startDate) : startDate;
        var nextBillDate = model.zL ? A2($elm_community$list_extra$List$Extra$maximumBy, $justinmimbs$date$Date$toRataDie, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            function() {
                var _v0 = _Utils_Tuple2(fields.UY, $author$project$Api$Provider$Membership$One$nextBillDate(membership));
                if (!_v0.a.$) {
                    var nextBillDate_ = _v0.a.a;
                    return $elm$core$Maybe$Just(nextBillDate_);
                } else {
                    if (!_v0.b.$) {
                        var _v1 = _v0.a;
                        var nextBillDate_ = _v0.b.a;
                        return $elm$core$Maybe$Just(nextBillDate_);
                    } else return $elm$core$Maybe$Nothing;
                }
            }(),
            $elm$core$Maybe$Just(calculatedStartDate)
        ]))) : $elm$core$Maybe$Just(calculatedStartDate);
        return _Utils_eq(nextBillDate, fields.UY) ? $elm$core$Platform$Cmd$none : $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm($author$project$Components$Membership$Form$Sections$Summary$NextBillDate(nextBillDate));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$update = F4(function(apiClient, sectionsShared, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var show = model.oi;
                var _v2 = $author$project$Utils$Form$fields(model.PU);
                var owner = _v2.VM;
                var _v3 = A2($elm$core$Maybe$withDefault, _Utils_Tuple2(model.rX, $elm$core$Platform$Cmd$none), A2($elm$core$Maybe$map, function(owner_) {
                    var _v4 = A2($author$project$Components$ResourceFilter$Patient$preSelectedId, $elm$core$Maybe$Just(owner_.aef), model.rX);
                    var withPreSelectedModel = _v4.a;
                    var withPreSelectedCmd = _v4.b;
                    return _Utils_Tuple2(A2($author$project$Components$ResourceFilter$Patient$extraItems, _List_fromArray([
                        {
                            IZ: owner_.IZ,
                            aef: owner_.aef,
                            T5: owner_.T5,
                            zr: owner_.zr
                        }
                    ]), withPreSelectedModel), withPreSelectedCmd);
                }, owner));
                var patientResourceFilter = _v3.a;
                var patientResourceFilterCmd = _v3.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceFilterCmd),
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: _Utils_update(model, {
                        rX: patientResourceFilter,
                        oi: _Utils_update(show, {
                            VM: !show.VM
                        })
                    }),
                    at: _List_Nil
                };
            case 1:
                var show = model.oi;
                var _v5 = $author$project$Utils$Form$fields(model.PU);
                var plan = _v5.GW;
                var _v6 = A2($elm$core$Maybe$withDefault, _Utils_Tuple2(model.jy, $elm$core$Platform$Cmd$none), A2($elm$core$Maybe$map, function(plan_) {
                    var _v7 = A2($author$project$Components$ResourceFilter$Plan$preSelectedId, $elm$core$Maybe$Just(plan_.aef), model.jy);
                    var withPreSelectedModel = _v7.a;
                    var withPreSelectedCmd = _v7.b;
                    return _Utils_Tuple2(A2($author$project$Components$ResourceFilter$Plan$extraItems, _List_fromArray([
                        {
                            aef: plan_.aef,
                            zr: plan_.zr
                        }
                    ]), withPreSelectedModel), withPreSelectedCmd);
                }, plan));
                var planResourceFilter = _v6.a;
                var planResourceFilterCmd = _v6.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceFilterCmd),
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: _Utils_update(model, {
                        jy: planResourceFilter,
                        oi: _Utils_update(show, {
                            GW: !show.GW
                        })
                    }),
                    at: _List_Nil
                };
            case 2:
                var fields = $author$project$Utils$Form$fields(model.PU);
                var manuallySet = fields.cc;
                var newFields = _Utils_update(fields, {
                    cc: _Utils_update(manuallySet, {
                        _0: true
                    })
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: _Utils_update(model, {
                        PU: A2($author$project$Utils$Form$set, newFields, model.PU)
                    }),
                    at: _List_Nil
                };
            case 3:
                var show = model.oi;
                var newModel = _Utils_update(model, {
                    zL: true,
                    oi: _Utils_update(show, {
                        UY: true
                    })
                });
                var fields = $author$project$Utils$Form$fields(model.PU);
                var cmd = !$author$project$Utils$Maybe$toBool(fields.UY) ? A3($author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate, sectionsShared.jc, A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Membership$One$startDate(sectionsShared.da), fields._0), newModel) : $elm$core$Platform$Cmd$none;
                return {
                    EQ: cmd,
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: newModel,
                    at: _List_Nil
                };
            case 4:
                var show = model.oi;
                var fields = $author$project$Utils$Form$fields(model.PU);
                var minimumEnrollmentPeriodInMonths = show.eY ? fields.Up : $elm$core$Maybe$Nothing;
                var newFields = _Utils_update(fields, {
                    Up: minimumEnrollmentPeriodInMonths
                });
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: _Utils_update(model, {
                        PU: A2($author$project$Utils$Form$set, newFields, model.PU),
                        oi: _Utils_update(show, {
                            eY: !show.eY
                        })
                    }),
                    at: _List_Nil
                };
            case 5:
                var field = msg.a;
                var _v8 = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate, field, model.PU);
                var newForm = _v8.a;
                var newFormCmd = _v8.b;
                var newModel = (function() {
                    if (field.$ === 1 && !field.a.$) {
                        var plan = field.a.a;
                        return A2($elm$core$Basics$composeL, A2($author$project$Components$Membership$Form$Sections$Summary$resetBillDate, sectionsShared.da, plan), A2($author$project$Components$Membership$Form$Sections$Summary$resetMinimumEnrollmentPeriod, sectionsShared.da, plan));
                    } else return $elm$core$Basics$identity;
                })()(_Utils_update(model, {
                    PU: newForm
                }));
                var updateNextBillCmd = function() {
                    var _v9 = _Utils_Tuple2(A2($author$project$Utils$Form$field, function($) {
                        return $._0;
                    }, newForm), _Utils_eq(A2($author$project$Utils$Form$field, function($) {
                        return $._0;
                    }, newForm), A2($author$project$Utils$Form$field, function($) {
                        return $._0;
                    }, model.PU)));
                    if (!_v9.a.$ && !_v9.b) {
                        var newStartDate = _v9.a.a;
                        return A3($author$project$Components$Membership$Form$Sections$Summary$updateMembershipNextBillDate, sectionsShared.jc, newStartDate, newModel);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        updateNextBillCmd,
                        newFormCmd
                    ])),
                    adu: $author$project$Components$Membership$Form$Sections$Summary$Updated(field),
                    zi: newModel,
                    at: _List_Nil
                };
            case 6:
                var subMsg = msg.a;
                var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, model.rX);
                var _v11 = function() {
                    var _v13 = patientResourceResult.adu;
                    if (!_v13.$ && !_v13.a.$ && !_v13.a.a.$) {
                        var patient = _v13.a.a.a;
                        var field_ = $author$project$Components$Membership$Form$Sections$Summary$Owner($elm$core$Maybe$Just(patient));
                        var newForm_ = A3($author$project$Utils$Form$updateWithCmd, $author$project$Components$Membership$Form$Sections$Summary$formFieldsUpdate, field_, model.PU);
                        return _Utils_Tuple2(newForm_, $elm$core$Maybe$Just(field_));
                    } else return _Utils_Tuple2(_Utils_Tuple2(model.PU, $elm$core$Platform$Cmd$none), $elm$core$Maybe$Nothing);
                }();
                var _v12 = _v11.a;
                var newForm = _v12.a;
                var newFormCmd = _v12.b;
                var field = _v11.b;
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        newFormCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, patientResourceResult.EQ)
                    ])),
                    adu: A2($elm$core$Maybe$withDefault, $author$project$Components$Membership$Form$Sections$Summary$None, A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$Sections$Summary$Updated, field)),
                    zi: _Utils_update(model, {
                        PU: newForm,
                        rX: patientResourceResult.zi
                    }),
                    at: patientResourceResult.at
                };
            case 7:
                var subMsg = msg.a;
                var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jy);
                var updateFormCmd = function() {
                    var _v14 = planResourceResult.adu;
                    if (!_v14.$ && !_v14.a.$ && !_v14.a.a.$) {
                        var plan = _v14.a.a.a;
                        return $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm($author$project$Components$Membership$Form$Sections$Summary$Plan($elm$core$Maybe$Just(plan)));
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                        updateFormCmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, planResourceResult.EQ)
                    ])),
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: _Utils_update(model, {
                        jy: planResourceResult.zi
                    }),
                    at: planResourceResult.at
                };
            case 8:
                var subMsg = msg.a;
                return A6($author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField, model, function($) {
                    return $.kj;
                }, F2(function(newDateInput, model_) {
                    return _Utils_update(model_, {
                        kj: newDateInput
                    });
                }), subMsg, $author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg, $author$project$Components$Membership$Form$Sections$Summary$StartDate);
            case 9:
                var subMsg = msg.a;
                return A6($author$project$Components$Membership$Form$Sections$Summary$updateDateInputFormField, model, function($) {
                    return $.rB;
                }, F2(function(newDateInput, model_) {
                    return _Utils_update(model_, {
                        rB: newDateInput
                    });
                }), subMsg, $author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg, $author$project$Components$Membership$Form$Sections$Summary$NextBillDate);
            case 10:
                var membership = msg.a;
                var _v15 = A5($author$project$Components$BrokerDeal$CreateModal$init, apiClient, model.Z$, model.cP, model.HP, {
                    vQ: $elm$core$Maybe$Nothing,
                    vR: $elm$core$Maybe$Nothing,
                    LG: $author$project$Api$Provider$Practice$One$commissionsTrackingFrom(model.W1),
                    acy: $elm$core$Maybe$Nothing,
                    Nk: 1,
                    jc: $elm$core$Maybe$Just(membership),
                    agX: false
                });
                var createModal = _v15.a;
                var createModalCmd = _v15.b;
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg, createModalCmd),
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: _Utils_update(model, {
                        h$: $elm$core$Maybe$Just(_Utils_Tuple2($author$project$Api$Provider$Membership$One$id(membership), createModal))
                    }),
                    at: _List_Nil
                };
            case 11:
                var subMsg = msg.a;
                var _v16 = model.h$;
                if (!_v16.$) {
                    var _v17 = _v16.a;
                    var membershipId = _v17.a;
                    var createModal = _v17.b;
                    var createModalResult = A3($author$project$Components$BrokerDeal$CreateModal$update, apiClient, subMsg, createModal);
                    var _v18 = function() {
                        var _v19 = createModalResult.adu;
                        switch(_v19){
                            case 0:
                                return _Utils_Tuple2($elm$core$Maybe$Just(_Utils_Tuple2(membershipId, createModalResult.zi)), $elm$core$Platform$Cmd$none);
                            case 1:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
                            case 2:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, A3($author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals, apiClient, model.iZ, membershipId));
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, A3($author$project$Components$Membership$Form$Sections$Summary$fetchBrokerDeals, apiClient, model.iZ, membershipId));
                        }
                    }();
                    var createModal_ = _v18.a;
                    var cmd = _v18.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg, createModalResult.EQ),
                            cmd
                        ])),
                        adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                        zi: _Utils_update(model, {
                            h$: createModal_
                        }),
                        at: createModalResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: model,
                    at: _List_Nil
                };
            case 12:
                var response = msg.a;
                if (response.$ === 3) {
                    var brokerDeals = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                        zi: _Utils_update(model, {
                            Kq: A2($elm$core$List$map, $author$project$Components$BrokerDeal$BrokerDealRecord$fromProviderAll, brokerDeals)
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var subMsg = msg.a;
                var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, apiClient, subMsg, model.hB);
                return {
                    EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg, auditTrailLogResult.EQ),
                    adu: $author$project$Components$Membership$Form$Sections$Summary$None,
                    zi: _Utils_update(model, {
                        hB: auditTrailLogResult.zi
                    }),
                    at: auditTrailLogResult.at
                };
        }
    });
    var $author$project$Api$Provider$Plan$All$contractExpires = function(_v0) {
        var record = _v0.b;
        return record.L5;
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires = function(_v0) {
        var record = _v0.b;
        return record.L5;
    };
    var $author$project$Api$Plan$contractExpires = function(plan) {
        switch(plan.$){
            case 0:
                return false;
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires(plan_);
            case 4:
                return false;
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$contractExpires(plan_);
            case 6:
                return false;
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$contractExpires(plan_);
            default:
                return false;
        }
    };
    var $author$project$Api$Provider$Plan$All$contractPeriodInMonths = function(_v0) {
        var record = _v0.b;
        return record.L6;
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractPeriodInMonths = function(_v0) {
        var record = _v0.b;
        return record.L6;
    };
    var $author$project$Api$Plan$contractPeriodInMonths = function(plan) {
        switch(plan.$){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractPeriodInMonths(plan_);
            case 4:
                return $elm$core$Maybe$Nothing;
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$contractPeriodInMonths(plan_);
            case 6:
                return $elm$core$Maybe$Nothing;
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$contractPeriodInMonths(plan_);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$Plan$All$contractType = function(_v0) {
        var record = _v0.b;
        return record.EW;
    };
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$contractType = function(_v0) {
        var record = _v0.b;
        return record.EW;
    };
    var $author$project$Api$Plan$contractType = function(plan) {
        switch(plan.$){
            case 0:
                return $elm$core$Maybe$Nothing;
            case 1:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$SharedWithContractInfo$contractType(plan_);
            case 4:
                return $elm$core$Maybe$Nothing;
            case 2:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$All$contractType(plan_);
            case 6:
                return $elm$core$Maybe$Nothing;
            case 3:
                var plan_ = plan.a;
                return $author$project$Api$Provider$Plan$One$contractType(plan_);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$resetContractFields = F3(function(isNew, newPlan, _v0) {
        var model = _v0;
        if (isNew) {
            var fields = $author$project$Utils$Form$fields(model.PU);
            var newFields = ($author$project$Api$Plan$contractExpires(newPlan) ? function(f) {
                return _Utils_update(f, {
                    qv: $elm$core$Maybe$Nothing,
                    WA: $author$project$Api$Plan$contractPeriodInMonths(newPlan),
                    ah5: $author$project$Api$Plan$contractType(newPlan)
                });
            } : $elm$core$Basics$identity)(_Utils_update(fields, {
                Pg: $author$project$Api$Plan$contractExpires(newPlan)
            }));
            var editEndDate = $author$project$Api$Plan$contractExpires(newPlan) ? false : model.iv;
            return _Utils_update(model, {
                iv: editEndDate,
                PU: A2($author$project$Utils$Form$set, newFields, model.PU)
            });
        } else return model;
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$updateFixedPeriodRateInCents = F3(function(newPeriodInMonths, oldPeriodInMonths, _v0) {
        var model = _v0;
        var _v1 = $author$project$Utils$Form$fields(model.PU);
        var fixedPeriodRateInCents = _v1.PP;
        var _v2 = A2($elm$core$Maybe$andThen, $author$project$Currency$toFloat, fixedPeriodRateInCents);
        if (!_v2.$) {
            var fixedPeriodRateInCents_ = _v2.a;
            var ratio = newPeriodInMonths / oldPeriodInMonths;
            var newFixedPeriodRateInCents = fixedPeriodRateInCents_ * ratio;
            return _Utils_eq(newFixedPeriodRateInCents, fixedPeriodRateInCents_) ? $elm$core$Platform$Cmd$none : A2($elm$core$Task$perform, function(_v3) {
                return $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated($author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents($elm$core$Maybe$Just($author$project$Currency$fromFloat(newFixedPeriodRateInCents))));
            }, $elm$core$Process$sleep(0));
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$updateStartDates = F3(function(startDate, previousStartDate, _v0) {
        var model = _v0;
        var membershipPatientRecord = $author$project$Utils$Form$fields(model.PU);
        var newMembershipPatientRecord = _Utils_eq(previousStartDate, $elm$core$Maybe$Nothing) || _Utils_eq(membershipPatientRecord._0, previousStartDate) ? _Utils_update(membershipPatientRecord, {
            _0: startDate
        }) : membershipPatientRecord;
        return _Utils_update(model, {
            PU: A2($author$project$Utils$Form$set, newMembershipPatientRecord, model.PU)
        });
    });
    var $author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates = F3(function(startDate, previousStartDate, model) {
        var membershipPatients = A2($elm$core$Dict$map, F2(function(_v0, _v1) {
            var originalIndex = _v1.a;
            var membershipPatientModel = _v1.b;
            var newMembershipPatientModel = A3($author$project$Components$Membership$Form$Members$MembershipPatient$updateStartDates, startDate, previousStartDate, membershipPatientModel);
            return _Utils_Tuple2(originalIndex, newMembershipPatientModel);
        }), model.T$);
        return _Utils_update(model, {
            T$: membershipPatients
        });
    });
    var $author$project$Components$Membership$Form$updateForm = F6(function(apiClient, membership, model, oldSections, section, currentSections) {
        var _v0 = function() {
            _v1$3: while(true){
                if (!section.$) switch(section.a.$){
                    case 1:
                        if (!section.a.a.$) {
                            var plan = section.a.a.a;
                            var newContracts = A3($author$project$Components$Membership$Form$Sections$Contracts$resetContractFields, model.iZ, plan, currentSections.aD);
                            return _Utils_Tuple2(_Utils_update(currentSections, {
                                aD: newContracts
                            }), $elm$core$Platform$Cmd$none);
                        } else break _v1$3;
                    case 2:
                        var startDate = section.a.a;
                        var newMembers = A3($author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates, startDate, $elm$core$Maybe$Nothing, currentSections.B);
                        return _Utils_Tuple2(_Utils_update(currentSections, {
                            B: newMembers
                        }), $elm$core$Platform$Cmd$none);
                    case 6:
                        var newPeriodInMonths = section.a.a;
                        var _v2 = $author$project$Components$Membership$Form$Sections$Summary$summaryFields(oldSections.$x);
                        var periodInMonths = _v2.WA;
                        return _Utils_Tuple2(currentSections, A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$PricingMsg, A3($author$project$Components$Membership$Form$Sections$Pricing$updateFixedPeriodRateInCents, newPeriodInMonths, periodInMonths, currentSections.cm)));
                    default:
                        break _v1$3;
                }
                else break _v1$3;
            }
            return _Utils_Tuple2(currentSections, $elm$core$Platform$Cmd$none);
        }();
        var newSections = _v0.a;
        var newSectionsCmd = _v0.b;
        return A2($elm$core$Tuple$mapSecond, function(checkPriceCmd) {
            return $elm$core$Platform$Cmd$batch(_List_fromArray([
                newSectionsCmd,
                checkPriceCmd
            ]));
        }, A4($author$project$Components$Membership$Form$checkPrice, apiClient, membership, newSections, _Utils_update(model, {
            l: $elm$core$Maybe$Just(newSections)
        })));
    });
    var $author$project$Components$Membership$Form$brokerDealForMatching = function(brokerDeal) {
        return {
            vQ: {
                aef: $author$project$Api$Provider$Broker$Shared$id($author$project$Api$Provider$BrokerDeal$One$broker(brokerDeal))
            }
        };
    };
    var $author$project$Api$Provider$Membership$Shared$isConfirmed = function(_v0) {
        var record = _v0;
        return record.RX;
    };
    var $author$project$Api$Provider$Membership$One$isConfirmed = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$isConfirmed(shared);
    };
    var $author$project$Components$Membership$Form$membershipPatientForMatching = function(membershipPatient) {
        return {
            ab9: {
                aef: A2($elm$core$Maybe$map, $author$project$Api$Provider$CancellationReason$Shared$id, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$cancellationReason(membershipPatient))
            },
            qv: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(membershipPatient),
            O_: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$enrollmentRequestedOn(membershipPatient),
            PP: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents(membershipPatient),
            aef: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient),
            TX: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient),
            V7: {
                aef: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id($author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient)),
                aic: false
            },
            _L: {
                aef: A2($elm$core$Maybe$map, $author$project$Api$Provider$SpecialRate$Min$id, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$specialRate(membershipPatient))
            },
            _0: $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate(membershipPatient)
        };
    };
    var $author$project$Components$Membership$Form$recurringChargeForMatching = function(recurringCharge) {
        return {
            lv: {
                aef: $author$project$Api$Provider$ChargeItem$ForRecurringCharge$id($author$project$Api$Provider$RecurringCharge$ForMembershipOne$chargeItem(recurringCharge))
            },
            adS: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedDescription(recurringCharge),
            adT: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$fixedPriceInCents(recurringCharge),
            V7: {
                aef: $author$project$Api$Provider$Patient$Min$id($author$project$Api$Provider$RecurringCharge$ForMembershipOne$patient(recurringCharge))
            },
            WA: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodInMonths(recurringCharge),
            agb: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$periodsRemaining(recurringCharge),
            agi: {
                aef: A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$id, $author$project$Api$Provider$RecurringCharge$ForMembershipOne$practitioner(recurringCharge))
            },
            Bu: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$quantity(recurringCharge),
            _0: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$startDate(recurringCharge)
        };
    };
    var $author$project$Components$Membership$Form$membershipForMatching = function(membership) {
        return {
            JX: $author$project$Api$Provider$Membership$One$autoRenew(membership),
            vN: $author$project$Api$Provider$Membership$One$billDate(membership),
            Kh: $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership),
            Kq: A2($elm$core$List$map, $author$project$Components$Membership$Form$brokerDealForMatching, $author$project$Api$Provider$Membership$One$brokerDeals(membership)),
            LI: {
                aef: A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$Shared$id, $author$project$Api$Provider$Membership$One$companyAccount(membership))
            },
            wV: $author$project$Api$Provider$Membership$One$contractEndDate(membership),
            L5: $author$project$Api$Provider$Membership$One$contractExpires(membership),
            L6: $author$project$Api$Provider$Membership$One$contractPeriodInMonths(membership),
            EW: $author$project$Api$Provider$Membership$One$contractType(membership),
            Mj: {
                aef: A2($elm$core$Maybe$map, $author$project$Api$Common$Coupon$Shared$id, $author$project$Api$Provider$Membership$One$coupon(membership))
            },
            PP: $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(membership),
            PQ: $author$project$Api$Provider$Membership$One$fixedRegistrationFeeInCents(membership),
            RX: $author$project$Api$Provider$Membership$One$isConfirmed(membership),
            T$: A2($elm$core$List$map, $author$project$Components$Membership$Form$membershipPatientForMatching, $author$project$Api$Provider$Membership$One$membershipPatients(membership)),
            Up: $author$project$Api$Provider$Membership$One$minimumEnrollmentPeriodInMonths(membership),
            UY: $author$project$Api$Provider$Membership$One$nextBillDate(membership),
            VM: {
                aef: A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$id, $author$project$Api$Provider$Membership$One$owner(membership))
            },
            WA: $author$project$Api$Provider$Membership$One$periodInMonths(membership),
            GW: {
                aef: $author$project$Api$Provider$Plan$SharedWithContractInfo$id($author$project$Api$Provider$Membership$One$plan(membership))
            },
            Yl: A2($elm$core$List$map, $author$project$Components$Membership$Form$recurringChargeForMatching, $author$project$Api$Provider$Membership$One$recurringCharges(membership)),
            _0: $author$project$Api$Provider$Membership$One$startDate(membership)
        };
    };
    var $author$project$Components$Membership$Form$membershipsMatch = F2(function(membership, otherMembership) {
        return _Utils_eq($author$project$Components$Membership$Form$membershipForMatching(membership), $author$project$Components$Membership$Form$membershipForMatching(otherMembership));
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$updateNextBillDates = F2(function(pendingMembership, _v0) {
        var model = _v0;
        var formFields = $author$project$Utils$Form$fields(model.PU);
        var newRecurringCharges = A2($elm$core$List$map, function(recurringCharge) {
            var _v1 = recurringCharge.aef;
            if (!_v1.$) {
                var id = _v1.a;
                var pendingRecurringCharge = A2($elm_community$list_extra$List$Extra$find, function(pendingRecurringCharge_) {
                    return _Utils_eq($author$project$Api$Provider$RecurringCharge$ForMembershipOne$id(pendingRecurringCharge_), $elm$core$Maybe$Just(id));
                }, $author$project$Api$Provider$Membership$One$recurringCharges(pendingMembership));
                return A2($elm$core$Maybe$withDefault, recurringCharge, A2($elm$core$Maybe$map, function(pendingRecurringCharge_) {
                    return _Utils_update(recurringCharge, {
                        UY: $author$project$Api$Provider$RecurringCharge$ForMembershipOne$nextBillDate(pendingRecurringCharge_)
                    });
                }, pendingRecurringCharge));
            } else return recurringCharge;
        }, formFields.Yl);
        var newFormFields = _Utils_update(formFields, {
            Yl: newRecurringCharges
        });
        return _Utils_update(model, {
            PU: A2($author$project$Utils$Form$set, newFormFields, model.PU)
        });
    });
    var $author$project$Components$Membership$Form$Sections$Summary$updateStartDate = F3(function(pendingMembership, newStartDate, _v0) {
        var model = _v0;
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        var _v1 = $author$project$Utils$Form$fields(model.PU);
        var startDate = _v1._0;
        return _Utils_eq($elm$core$Maybe$Just(newStartDate), startDate) || !$author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta) ? $elm$core$Platform$Cmd$none : $author$project$Components$Membership$Form$Sections$Summary$asynUpdateForm($author$project$Components$Membership$Form$Sections$Summary$StartDate($elm$core$Maybe$Just(newStartDate)));
    });
    var $author$project$Components$Membership$Form$updateFromPriceCheck = F3(function(pendingMembership, sections, model) {
        var startDate = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
        var summaryCmd = A3($author$project$Components$Membership$Form$Sections$Summary$updateStartDate, pendingMembership, startDate, sections.$x);
        var sameAsOriginal = model.iZ ? model.gF : A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Components$Membership$Form$membershipsMatch(pendingMembership), model.jc));
        var recurringCharges = A2($author$project$Components$Membership$Form$Sections$RecurringCharges$updateNextBillDates, pendingMembership, sections.Yl);
        var previousStartDate = A2($elm$core$Maybe$map, $author$project$Api$Provider$Membership$One$startDate, model.da);
        var members = A3($author$project$Components$Membership$Form$Sections$Members$updateMembershipPatientsStartDates, $elm$core$Maybe$Just(startDate), previousStartDate, sections.B);
        return _Utils_Tuple2(_Utils_update(model, {
            da: $elm$core$Maybe$Just(pendingMembership),
            gF: sameAsOriginal,
            l: $elm$core$Maybe$Just(_Utils_update(sections, {
                B: members,
                Yl: recurringCharges
            }))
        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$SummaryMsg, summaryCmd));
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonthsValidation = 1;
    var $author$project$Components$Membership$Form$Sections$Contracts$TypeValidation = 0;
    var $author$project$Components$Membership$Form$Sections$Contracts$validateContracts = function(contract) {
        return contract.Pg ? $elm$core$List$concat(_List_fromArray([
            _Utils_eq(contract.WA, $elm$core$Maybe$Nothing) ? _List_fromArray([
                _Utils_Tuple2(1, 'Please enter a number.')
            ]) : _List_Nil,
            _Utils_eq(contract.ah5, $elm$core$Maybe$Nothing) ? _List_fromArray([
                _Utils_Tuple2(0, 'Please pick an action.')
            ]) : _List_Nil
        ])) : _List_Nil;
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$Contracts$validateContracts)
    ]));
    var $author$project$Components$Membership$Form$Sections$Contracts$validate = F2(function(_v0, _v1) {
        var model = _v1;
        var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$Contracts$formFieldsValidator, model.PU);
        if (!_v2.$) {
            var _v3 = _v2.a;
            var newForm = _v3.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), true);
        } else {
            var newForm = _v2.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), false);
        }
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReasonOtherValidation = 8;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReasonValidation = 7;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientValidation = 0;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$EndDateValidation = 6;
    var $author$project$Api$Provider$Membership$Shared$billFromDate = function(_v0) {
        var record = _v0;
        return record.Kc;
    };
    var $author$project$Api$Provider$Membership$One$billFromDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$billFromDate(shared);
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$validateEndDate = F2(function(_v0, fields) {
        var pendingMembership = _v0.da;
        var min = fields._0;
        var max = $author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, 1, $author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)));
        return A2($author$project$Utils$Validate$isOutsideDateRange, {
            abI: false,
            y_: max,
            Uj: min
        }, fields.qv) ? _List_fromArray([
            _Utils_Tuple2(6, 'Please pick an option.')
        ]) : _List_Nil;
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnValidation = 2;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$validateEnrollmentRequestedOn = F2(function(_v0, fields) {
        var editEnrollmentRequestedOn = _v0.qp;
        var _v1 = _Utils_Tuple2(editEnrollmentRequestedOn, fields.O_);
        if (_v1.a) {
            if (!_v1.b.$) return _List_Nil;
            else {
                var _v2 = _v1.b;
                return _List_fromArray([
                    _Utils_Tuple2(2, 'Please pick a date.')
                ]);
            }
        } else return _List_Nil;
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCentsValidation = 5;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$validateFixedPeriodRateInCents = F2(function(model, fields) {
        if (model.d2) {
            var min = 0;
            var max = 999999999;
            return A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: false,
                y_: $elm$core$Maybe$Just(max),
                Uj: $elm$core$Maybe$Just(min)
            }, fields.PP) ? _List_fromArray([
                _Utils_Tuple2(5, 'Please enter an amount between ' + ($author$project$Utils$Currency$fromInt(min) + (' and ' + $author$project$Utils$Currency$fromInt(max))))
            ]) : _List_Nil;
        } else return _List_Nil;
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobaccoValidation = 1;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$validatePatientUsesTobacco = F3(function(_v0, model, fields) {
        var pendingMembership = _v0.da;
        var showTobaccoUsage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, model.W1) && $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType($author$project$Api$Provider$Membership$One$plan(pendingMembership)));
        var _v1 = _Utils_Tuple2(showTobaccoUsage && model.d3, fields.V7);
        if (_v1.a && !_v1.b.$) {
            var patient = _v1.b.a;
            return _Utils_eq(patient.aa4, $elm$core$Maybe$Nothing) ? _List_fromArray([
                _Utils_Tuple2(1, 'Please pick an option.')
            ]) : _List_Nil;
        } else return _List_Nil;
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRateValidation = 4;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$validateSetSpecialRate = F2(function(model, fields) {
        return model.eg ? _Utils_eq(fields._L, $elm$core$Maybe$Nothing) ? _List_fromArray([
            _Utils_Tuple2(4, 'Please pick a rate.')
        ]) : _List_Nil : _List_Nil;
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$StartDateValidation = 3;
    var $author$project$Components$Membership$Form$Members$MembershipPatient$validateStartDate = F3(function(_v0, _v1, fields) {
        var pendingMembership = _v0.da;
        var editStartDate = _v1.qq;
        var _v2 = _Utils_Tuple2(editStartDate, fields._0);
        if (_v2.a) {
            if (!_v2.b.$) {
                var startDate = _v2.b.a;
                var min = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
                var max = A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Membership$One$billFromDate(pendingMembership), fields.PL);
                return A2($author$project$Utils$Date$isBefore, startDate, min) || A2($author$project$Utils$Date$isAfter, startDate, max) ? _List_fromArray([
                    _Utils_Tuple2(3, 'Please pick a date between ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, min) + (' and ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, max) + '.'))))
                ]) : _List_Nil;
            } else {
                var _v3 = _v2.b;
                return _List_fromArray([
                    _Utils_Tuple2(3, 'Please pick a date.')
                ]);
            }
        } else return _List_Nil;
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsValidator = F2(function(sectionsShared, model) {
        return $rtfeldman$elm_validate$Validate$all(A2($elm$core$List$cons, A2($rtfeldman$elm_validate$Validate$ifNothing, function($) {
            return $.V7;
        }, _Utils_Tuple2(0, 'Please pick a patient.')), A2($elm$core$List$cons, $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Members$MembershipPatient$validateEnrollmentRequestedOn(model)), A2($elm$core$List$cons, $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Membership$Form$Members$MembershipPatient$validateStartDate, sectionsShared, model)), A2($elm$core$List$cons, $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Membership$Form$Members$MembershipPatient$validatePatientUsesTobacco, sectionsShared, model)), A2($elm$core$List$cons, $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Members$MembershipPatient$validateFixedPeriodRateInCents(model)), A2($elm$core$List$cons, $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Members$MembershipPatient$validateSetSpecialRate(model)), model.aO ? _List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Members$MembershipPatient$validateEndDate(sectionsShared)),
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$CancellationReason$Input$validate, 7, 8))
        ]) : _List_Nil)))))));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$validate = F2(function(sectionsShared, _v0) {
        var model = _v0;
        var _v1 = A2($author$project$Utils$Form$validate, A2($author$project$Components$Membership$Form$Members$MembershipPatient$formFieldsValidator, sectionsShared, model), model.PU);
        if (!_v1.$) {
            var _v2 = _v1.a;
            var newForm = _v2.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), true);
        } else {
            var newForm = _v1.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), false);
        }
    });
    var $author$project$Components$Membership$Form$Sections$Members$validate = F2(function(sectionsShared, model) {
        var membershipPatientsWithValid = A2($elm$core$Dict$map, F2(function(_v3, _v4) {
            var membershipPatientModel = _v4.b;
            return A2($author$project$Components$Membership$Form$Members$MembershipPatient$validate, sectionsShared, membershipPatientModel);
        }), model.T$);
        var valid = A2($elm$core$List$all, $elm$core$Tuple$second, $elm$core$Dict$values(membershipPatientsWithValid));
        var membershipPatients = A2($elm$core$Dict$map, F2(function(id, _v0) {
            var originalIndex = _v0.a;
            var membershipPatientModel = _v0.b;
            var _v1 = A2($elm$core$Dict$get, id, membershipPatientsWithValid);
            if (!_v1.$) {
                var _v2 = _v1.a;
                var newMembershipPatientModel = _v2.a;
                return _Utils_Tuple2(originalIndex, newMembershipPatientModel);
            } else return _Utils_Tuple2(originalIndex, membershipPatientModel);
        }), model.T$);
        return _Utils_Tuple2(_Utils_update(model, {
            T$: membershipPatients
        }), valid);
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCentsValidation = 0;
    var $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCentsValidation = 1;
    var $author$project$Components$Membership$Form$Sections$Pricing$validatePricing = function(pricing) {
        return $elm$core$List$concat(_List_fromArray([
            A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: !pricing.cc.X5,
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Just(0)
            }, pricing.PP) ? _List_fromArray([
                _Utils_Tuple2(0, 'Please enter a valid amount.')
            ]) : _List_Nil,
            A2($author$project$Utils$Validate$isInvalidCurrency, {
                abI: !pricing.cc.ex,
                y_: $elm$core$Maybe$Nothing,
                Uj: $elm$core$Maybe$Just(0)
            }, pricing.PQ) ? _List_fromArray([
                _Utils_Tuple2(1, 'Please enter a valid amount.')
            ]) : _List_Nil
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Membership$Form$Sections$Pricing$validatePricing)
    ]));
    var $author$project$Components$Membership$Form$Sections$Pricing$validate = F2(function(_v0, _v1) {
        var model = _v1;
        var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$Pricing$formFieldsValidator, model.PU);
        if (!_v2.$) {
            var _v3 = _v2.a;
            var newForm = _v3.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), true);
        } else {
            var newForm = _v2.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), false);
        }
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_Nil);
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$validate = F2(function(_v0, _v1) {
        var model = _v1;
        var _v2 = A2($author$project$Utils$Form$validate, $author$project$Components$Membership$Form$Sections$RecurringCharges$formFieldsValidator, model.PU);
        if (!_v2.$) {
            var _v3 = _v2.a;
            var newForm = _v3.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), true);
        } else {
            var newForm = _v2.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), false);
        }
    });
    var $author$project$Components$Membership$Form$Sections$Summary$NextBillDateValidation = 3;
    var $author$project$Components$Membership$Form$Sections$Summary$OwnerValidation = 0;
    var $author$project$Components$Membership$Form$Sections$Summary$PlanValidation = 1;
    var $author$project$Components$Membership$Form$Sections$Summary$StartDateValidation = 2;
    var $author$project$Api$Provider$Membership$Meta$billDateMin = function(_v0) {
        var meta = _v0;
        return meta.vN.Uj;
    };
    var $author$project$Api$Provider$Membership$Meta$nextBillDateMax = function(_v0) {
        var meta = _v0;
        return meta.UY.y_;
    };
    var $author$project$Api$Provider$Membership$Meta$nextBillDateMin = function(_v0) {
        var meta = _v0;
        return meta.UY.Uj;
    };
    var $author$project$Api$Provider$Membership$Meta$startDateMax = function(_v0) {
        var meta = _v0;
        return meta._0.y_;
    };
    var $author$project$Api$Provider$Membership$Meta$startDateMin = function(_v0) {
        var meta = _v0;
        return meta._0.Uj;
    };
    var $author$project$Components$Membership$Form$Sections$Summary$validateSummary = F3(function(pendingMembership, show, summary) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        return $elm$core$List$concat(_List_fromArray([
            _Utils_eq(summary.VM, $elm$core$Maybe$Nothing) ? _List_fromArray([
                _Utils_Tuple2(0, 'Please pick an owner.')
            ]) : _List_Nil,
            _Utils_eq(summary.GW, $elm$core$Maybe$Nothing) ? _List_fromArray([
                _Utils_Tuple2(1, 'Please select a plan.')
            ]) : _List_Nil,
            function() {
                var _v0 = _Utils_Tuple2($author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta), summary._0);
                if (!_v0.a) return _List_Nil;
                else if (_v0.b.$ === 1) {
                    var _v1 = _v0.b;
                    return _List_fromArray([
                        _Utils_Tuple2(2, 'Please enter a valid date.')
                    ]);
                } else {
                    var startDate = _v0.b.a;
                    var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
                    var min = $author$project$Api$Provider$Membership$Meta$startDateMin(pendingMembershipMeta);
                    if (!A2($justinmimbs$date$Date$compare, startDate, min)) return _List_fromArray([
                        _Utils_Tuple2(2, 'A membership cannot be started before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, min) + '.'))
                    ]);
                    else {
                        var max = A2($elm$core$Maybe$withDefault, startDate, $author$project$Api$Provider$Membership$Meta$startDateMax(pendingMembershipMeta));
                        return A2($justinmimbs$date$Date$compare, startDate, max) === 2 ? _List_fromArray([
                            _Utils_Tuple2(2, 'A membership cannot be started after the first bill.')
                        ]) : _List_Nil;
                    }
                }
            }(),
            function() {
                var _v2 = _Utils_Tuple2(show.UY, summary.UY);
                if (!_v2.a) return _List_Nil;
                else if (_v2.b.$ === 1) {
                    var _v3 = _v2.b;
                    return _List_fromArray([
                        _Utils_Tuple2(3, 'Please enter a valid date.')
                    ]);
                } else {
                    var nextBillDate = _v2.b.a;
                    var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
                    var nextBillDateMin = A2($elm$core$Maybe$withDefault, nextBillDate, $author$project$Api$Provider$Membership$Meta$nextBillDateMin(pendingMembershipMeta));
                    var nextBillDateMax = A2($elm$core$Maybe$withDefault, nextBillDate, $author$project$Api$Provider$Membership$Meta$nextBillDateMax(pendingMembershipMeta));
                    var billDateMin = $author$project$Api$Provider$Membership$Meta$billDateMin(pendingMembershipMeta);
                    return $elm$core$List$concat(_List_fromArray([
                        summary.eJ && !A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMin) ? _List_fromArray([
                            _Utils_Tuple2(3, 'Must change all bills for dates before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMin) + '.'))
                        ]) : _List_Nil,
                        summary.eJ && A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMax) === 2 ? _List_fromArray([
                            _Utils_Tuple2(3, 'Must change all bills for dates after ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMax) + '.'))
                        ]) : _List_Nil,
                        summary.eJ && !A2($justinmimbs$date$Date$compare, nextBillDate, billDateMin) ? _List_fromArray([
                            _Utils_Tuple2(3, 'Bill date cannot be set before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, billDateMin) + '.'))
                        ]) : _List_Nil,
                        !summary.eJ && !A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMin) ? _List_fromArray([
                            _Utils_Tuple2(3, 'Next bill date cannot be set before ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMin) + '.'))
                        ]) : _List_Nil,
                        A2($justinmimbs$date$Date$compare, nextBillDate, nextBillDateMax) === 2 ? _List_fromArray([
                            _Utils_Tuple2(3, 'Next bill date cannot be set after ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDateMax) + '.'))
                        ]) : _List_Nil
                    ]));
                }
            }()
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$formFieldsValidator = F2(function(pendingMembership, show) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors(A2($author$project$Components$Membership$Form$Sections$Summary$validateSummary, pendingMembership, show))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$validate = F2(function(_v0, _v1) {
        var pendingMembership = _v0.da;
        var model = _v1;
        var _v2 = A2($author$project$Utils$Form$validate, A2($author$project$Components$Membership$Form$Sections$Summary$formFieldsValidator, pendingMembership, model.oi), model.PU);
        if (!_v2.$) {
            var _v3 = _v2.a;
            var newForm = _v3.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), true);
        } else {
            var newForm = _v2.a;
            return _Utils_Tuple2(_Utils_update(model, {
                PU: newForm
            }), false);
        }
    });
    var $author$project$Components$Membership$Form$validateSections = F2(function(sectionsShared, sections) {
        var _v0 = A2($author$project$Components$Membership$Form$Sections$Summary$validate, sectionsShared, sections.$x);
        var summary = _v0.a;
        var summaryIsValid = _v0.b;
        var _v1 = A2($author$project$Components$Membership$Form$Sections$RecurringCharges$validate, sectionsShared, sections.Yl);
        var recurringCharges = _v1.a;
        var recurringChargesIsValid = _v1.b;
        var _v2 = A2($author$project$Components$Membership$Form$Sections$Pricing$validate, sectionsShared, sections.cm);
        var pricing = _v2.a;
        var pricingIsValid = _v2.b;
        var _v3 = A2($author$project$Components$Membership$Form$Sections$Members$validate, sectionsShared, sections.B);
        var members = _v3.a;
        var membersIsValid = _v3.b;
        var _v4 = A2($author$project$Components$Membership$Form$Sections$Contracts$validate, sectionsShared, sections.aD);
        var contracts = _v4.a;
        var contractsIsValid = _v4.b;
        return _Utils_Tuple2(summaryIsValid && membersIsValid && pricingIsValid && recurringChargesIsValid && contractsIsValid, _Utils_update(sections, {
            aD: contracts,
            B: members,
            cm: pricing,
            Yl: recurringCharges,
            $x: summary
        }));
    });
    var $author$project$Components$Membership$Form$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var membership = response.a;
                    return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, model));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var response = msg.a;
                var _v2 = model.l;
                if (!_v2.$) {
                    var sections = _v2.a;
                    var _v3 = function() {
                        if (response.$ === 3) {
                            var membership = response.a;
                            return A3($author$project$Components$Membership$Form$updateFromPriceCheck, membership, sections, _Utils_update(model, {
                                jG: response
                            }));
                        } else return _Utils_Tuple2(_Utils_update(model, {
                            jG: response
                        }), $elm$core$Platform$Cmd$none);
                    }();
                    var newModel = _v3.a;
                    var cmd = _v3.b;
                    return _Utils_Tuple3(newModel, cmd, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var debounceMsg = msg.a;
                var _v5 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$Membership$Form$priceCheckDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast($author$project$Components$Membership$Form$debouncePriceCheck), debounceMsg, model.er);
                var newDebouncer = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    er: newDebouncer
                }), cmd, _List_Nil);
            case 3:
                var cmd = msg.a;
                return _Utils_Tuple3(model, cmd, _List_Nil);
            case 4:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    acb: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var billNow = msg.a;
                var _v6 = _Utils_Tuple3(model.l, model.jc, model.da);
                if (!_v6.a.$ && !_v6.b.$ && !_v6.c.$) {
                    var sections = _v6.a.a;
                    var membership = _v6.b.a;
                    var pendingMembership = _v6.c.a;
                    var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.V7, membership, pendingMembership, sections, model);
                    var _v7 = A2($author$project$Components$Membership$Form$validateSections, shared, sections);
                    if (_v7.a) {
                        var newSections = _v7.b;
                        var saveCmd = A5($author$project$Components$Membership$Form$saveItem, apiClient, model.aef, membership, newSections, billNow);
                        var plan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
                        var _v8 = A2($author$project$Components$Membership$Form$patientsOutsideAgeRange, plan, newSections);
                        var belowAgePatients = _v8.a;
                        var aboveAgePatients = _v8.b;
                        var _v9 = $elm$core$List$length(belowAgePatients) > 0 || $elm$core$List$length(aboveAgePatients) > 0 ? _Utils_Tuple3($elm$core$Platform$Cmd$none, $author$project$Api$Data$NotAsked, $elm$core$Maybe$Just(_Utils_Tuple2(A4($author$project$Components$Membership$Form$OutsideAgeRangeModal$init, $author$project$Api$Provider$Plan$SharedWithContractInfo$minimumAge(plan), $author$project$Api$Provider$Plan$SharedWithContractInfo$maximumAge(plan), belowAgePatients, aboveAgePatients), saveCmd))) : _Utils_Tuple3(saveCmd, $author$project$Api$Data$Loading, $elm$core$Maybe$Nothing);
                        var cmd = _v9.a;
                        var saveRequest = _v9.b;
                        var outsideAgeRangeModal = _v9.c;
                        return _Utils_Tuple3(_Utils_update(model, {
                            gi: outsideAgeRangeModal,
                            j_: saveRequest,
                            l: $elm$core$Maybe$Just(newSections)
                        }), cmd, _List_Nil);
                    } else {
                        var newSections = _v7.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            j_: $author$project$Api$Data$NotAsked,
                            l: $elm$core$Maybe$Just(newSections)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var confirmed = msg.a;
                var _v10 = model.gi;
                if (!_v10.$) {
                    var _v11 = _v10.a;
                    var saveCmd = _v11.b;
                    return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                        gi: $elm$core$Maybe$Nothing,
                        j_: $author$project$Api$Data$Loading
                    }), saveCmd, _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                        gi: $elm$core$Maybe$Nothing
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var response = msg.a;
                var _v12 = model.l;
                if (!_v12.$) {
                    if (response.$ === 3) {
                        var membership = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            j_: response
                        }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top({
                            y0: $author$project$Api$Provider$Membership$One$id(membership),
                            V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                        })), _List_fromArray([
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7)),
                            A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully started')
                        ]));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var response = msg.a;
                var _v14 = model.l;
                if (!_v14.$) {
                    if (response.$ === 3) {
                        var membership = response.a;
                        return A2($author$project$Utils$Tuple3$fromTuple2, _List_fromArray([
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7)),
                            A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully updated')
                        ]), A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, _Utils_update(model, {
                            j_: response
                        })));
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        j_: response
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var membership = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$Membership$confirm, apiClient, $author$project$Api$Provider$Membership$One$id(membership), $author$project$Components$Membership$Form$Confirmed), _List_Nil);
            case 10:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    j_: response
                }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top({
                    V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                })), _List_fromArray([
                    $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7)),
                    A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully confirmed')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 11:
                var membership = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(membership, $author$project$Api$Data$NotAsked))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var membership = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(membership, $author$project$Api$Data$Loading))
                }), A3($author$project$Api$Provider$Membership$delete, apiClient, $author$project$Api$Provider$Membership$One$id(membership), $author$project$Components$Membership$Form$Deleted(membership)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var membership = msg.a;
                var response = msg.b;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                    V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                })), _List_fromArray([
                    $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7)),
                    A2($author$project$OutMsg$ShowToast, 3, 'Membership successfully deleted')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    fr: $elm$core$Maybe$Just(_Utils_Tuple2(membership, response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                var membership = msg.a;
                var _v18 = A2($author$project$Components$Membership$Form$CancelModal$init, model.cP, membership);
                var cancelModal = _v18.a;
                var cancelModalCmd = _v18.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    dA: $elm$core$Maybe$Just(cancelModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModalMsg, cancelModalCmd), _List_Nil);
            case 15:
                var subMsg = msg.a;
                var _v19 = model.dA;
                if (!_v19.$) {
                    var cancelModal = _v19.a;
                    var cancelModalResult = A3($author$project$Components$Membership$Form$CancelModal$update, apiClient, subMsg, cancelModal);
                    var _v20 = function() {
                        var _v21 = cancelModalResult.adu;
                        switch(_v21.$){
                            case 0:
                                return _Utils_Tuple3(_Utils_update(model, {
                                    dA: $elm$core$Maybe$Just(cancelModalResult.zi)
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            case 1:
                                return _Utils_Tuple3(_Utils_update(model, {
                                    dA: $elm$core$Maybe$Nothing
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            default:
                                var membership = _v21.a;
                                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, _Utils_update(model, {
                                    dA: $elm$core$Maybe$Nothing
                                })));
                        }
                    }();
                    var newModel = _v20.a;
                    var cmd = _v20.b;
                    var outMsgs = _v20.c;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$CancelModalMsg, cancelModalResult.EQ),
                        cmd
                    ])), _Utils_ap(cancelModalResult.at, outMsgs));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var membership = msg.a;
                var _v22 = A4($author$project$Components$Membership$Form$RestartModal$init, apiClient, model.cP, $elm$core$Maybe$Nothing, membership);
                var restartModal = _v22.a;
                var restartModalCmd = _v22.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    jU: $elm$core$Maybe$Just(restartModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RestartModalMsg, restartModalCmd), _List_Nil);
            case 17:
                var subMsg = msg.a;
                var _v23 = model.jU;
                if (!_v23.$) {
                    var restartModal = _v23.a;
                    var restartModalResult = A3($author$project$Components$Membership$Form$RestartModal$update, apiClient, subMsg, restartModal);
                    var _v24 = function() {
                        var _v25 = restartModalResult.adu;
                        switch(_v25.$){
                            case 0:
                                return _Utils_Tuple3(_Utils_update(model, {
                                    jU: $elm$core$Maybe$Just(restartModalResult.zi)
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            case 1:
                                return _Utils_Tuple3(_Utils_update(model, {
                                    jU: $elm$core$Maybe$Nothing
                                }), $elm$core$Platform$Cmd$none, _List_Nil);
                            default:
                                var membership = _v25.a;
                                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, _Utils_update(model, {
                                    jU: $elm$core$Maybe$Nothing
                                })));
                        }
                    }();
                    var newModel = _v24.a;
                    var cmd = _v24.b;
                    var outMsgs = _v24.c;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RestartModalMsg, restartModalResult.EQ),
                        cmd
                    ])), _Utils_ap(restartModalResult.at, outMsgs));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var subMsg = msg.a;
                var _v26 = _Utils_Tuple3(model.jc, model.da, model.l);
                if (!_v26.a.$ && !_v26.b.$ && !_v26.c.$) {
                    var membership = _v26.a.a;
                    var pendingMembership = _v26.b.a;
                    var sections = _v26.c.a;
                    var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.V7, membership, pendingMembership, sections, model);
                    var summaryResult = A4($author$project$Components$Membership$Form$Sections$Summary$update, apiClient, shared, subMsg, sections.$x);
                    var newSections = _Utils_update(sections, {
                        $x: summaryResult.zi
                    });
                    var _v27 = function() {
                        var _v28 = summaryResult.adu;
                        if (!_v28.$) return _Utils_Tuple2($elm$core$Platform$Cmd$none, _Utils_update(model, {
                            l: $elm$core$Maybe$Just(newSections)
                        }));
                        else {
                            var summaryField = _v28.a;
                            var _v29 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Summary(summaryField), newSections);
                            var newModel = _v29.a;
                            var formCmd = _v29.b;
                            return _Utils_Tuple2(formCmd, newModel);
                        }
                    }();
                    var cmd = _v27.a;
                    var newModel_ = _v27.b;
                    return _Utils_Tuple3(newModel_, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$SummaryMsg, summaryResult.EQ),
                        cmd
                    ])), summaryResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                var subMsg = msg.a;
                var _v30 = _Utils_Tuple2(model.jc, model.l);
                if (!_v30.a.$ && !_v30.b.$) {
                    var membership = _v30.a.a;
                    var sections = _v30.b.a;
                    var membersResult = A3($author$project$Components$Membership$Form$Sections$Members$update, apiClient, subMsg, sections.B);
                    var newSections = _Utils_update(sections, {
                        B: membersResult.zi
                    });
                    var _v31 = function() {
                        var _v32 = membersResult.adu;
                        if (!_v32) return _Utils_Tuple2($elm$core$Platform$Cmd$none, _Utils_update(model, {
                            l: $elm$core$Maybe$Just(newSections)
                        }));
                        else {
                            var _v33 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Members, newSections);
                            var newModel = _v33.a;
                            var formCmd = _v33.b;
                            return _Utils_Tuple2(formCmd, newModel);
                        }
                    }();
                    var cmd = _v31.a;
                    var newModel_ = _v31.b;
                    return _Utils_Tuple3(newModel_, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$MembersMsg, membersResult.EQ),
                        cmd
                    ])), membersResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 20:
                var subMsg = msg.a;
                var _v34 = _Utils_Tuple2(model.jc, model.l);
                if (!_v34.a.$ && !_v34.b.$) {
                    var membership = _v34.a.a;
                    var sections = _v34.b.a;
                    var pricingResult = A2($author$project$Components$Membership$Form$Sections$Pricing$update, subMsg, sections.cm);
                    var newSections = _Utils_update(sections, {
                        cm: pricingResult.zi
                    });
                    var _v35 = function() {
                        var _v36 = pricingResult.adu;
                        if (!_v36) return _Utils_Tuple2($elm$core$Platform$Cmd$none, _Utils_update(model, {
                            l: $elm$core$Maybe$Just(newSections)
                        }));
                        else {
                            var _v37 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Pricing, newSections);
                            var newModel = _v37.a;
                            var formCmd = _v37.b;
                            return _Utils_Tuple2(formCmd, newModel);
                        }
                    }();
                    var cmd = _v35.a;
                    var newModel_ = _v35.b;
                    return _Utils_Tuple3(newModel_, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$PricingMsg, pricingResult.EQ),
                        cmd
                    ])), pricingResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 21:
                var subMsg = msg.a;
                var _v38 = _Utils_Tuple2(model.jc, model.l);
                if (!_v38.a.$ && !_v38.b.$) {
                    var membership = _v38.a.a;
                    var sections = _v38.b.a;
                    var contractsResult = A3($author$project$Components$Membership$Form$Sections$Contracts$update, apiClient, subMsg, sections.aD);
                    var newSections = _Utils_update(sections, {
                        aD: contractsResult.zi
                    });
                    var _v39 = function() {
                        var _v40 = contractsResult.adu;
                        switch(_v40){
                            case 0:
                                return _Utils_Tuple2($elm$core$Platform$Cmd$none, _Utils_update(model, {
                                    l: $elm$core$Maybe$Just(newSections)
                                }));
                            case 1:
                                return _Utils_Tuple2(A2($author$project$Components$Membership$Form$retrieveItem, apiClient, A2($elm$core$Maybe$withDefault, '', model.aef)), model);
                            default:
                                var _v41 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$Contract, newSections);
                                var newModel = _v41.a;
                                var formCmd = _v41.b;
                                return _Utils_Tuple2(formCmd, newModel);
                        }
                    }();
                    var cmd = _v39.a;
                    var newModel_ = _v39.b;
                    return _Utils_Tuple3(newModel_, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$ContractsMsg, contractsResult.EQ),
                        cmd
                    ])), contractsResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 22:
                var subMsg = msg.a;
                var _v42 = _Utils_Tuple2(model.jc, model.l);
                if (!_v42.a.$ && !_v42.b.$) {
                    var membership = _v42.a.a;
                    var sections = _v42.b.a;
                    var recurringChargesResult = A3($author$project$Components$Membership$Form$Sections$RecurringCharges$update, apiClient, subMsg, sections.Yl);
                    var newSections = _Utils_update(sections, {
                        Yl: recurringChargesResult.zi
                    });
                    var _v43 = function() {
                        var _v44 = recurringChargesResult.adu;
                        if (!_v44) return _Utils_Tuple2($elm$core$Platform$Cmd$none, _Utils_update(model, {
                            l: $elm$core$Maybe$Just(newSections)
                        }));
                        else {
                            var _v45 = A6($author$project$Components$Membership$Form$updateForm, apiClient, membership, model, sections, $author$project$Components$Membership$Form$RecurringCharges, newSections);
                            var newModel = _v45.a;
                            var formCmd = _v45.b;
                            return _Utils_Tuple2(formCmd, newModel);
                        }
                    }();
                    var cmd = _v43.a;
                    var newModel_ = _v43.b;
                    return _Utils_Tuple3(newModel_, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RecurringChargesMsg, recurringChargesResult.EQ),
                        cmd
                    ])), recurringChargesResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 23:
                var subMsg = msg.a;
                var _v46 = model.l;
                if (!_v46.$) {
                    var sections = _v46.a;
                    var _v47 = sections.jw;
                    if (!_v47.$) {
                        var planChange = _v47.a;
                        var planChangeResult = A3($author$project$Components$Membership$Form$Sections$PlanChange$update, apiClient, subMsg, planChange);
                        var id = A2($elm$core$Maybe$withDefault, '', model.aef);
                        var cmd = function() {
                            var _v48 = planChangeResult.adu;
                            switch(_v48){
                                case 0:
                                    return $elm$core$Platform$Cmd$none;
                                case 1:
                                    return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
                                case 2:
                                    return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
                                default:
                                    return A2($author$project$Components$Membership$Form$retrieveItem, apiClient, id);
                            }
                        }();
                        return _Utils_Tuple3(_Utils_update(model, {
                            l: $elm$core$Maybe$Just(_Utils_update(sections, {
                                jw: $elm$core$Maybe$Just(planChangeResult.zi)
                            }))
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$PlanChangeMsg, planChangeResult.EQ),
                            cmd
                        ])), planChangeResult.at);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 24:
                var subMsg = msg.a;
                var _v49 = model.l;
                if (!_v49.$) {
                    var sections = _v49.a;
                    var billsOverviewResult = A3($author$project$Components$Membership$Form$Sections$BillsOverview$update, apiClient, subMsg, sections.pI);
                    var _v50 = function() {
                        var _v51 = billsOverviewResult.adu;
                        if (!_v51.$) return _Utils_Tuple3(_Utils_update(model, {
                            l: $elm$core$Maybe$Just(_Utils_update(sections, {
                                pI: billsOverviewResult.zi
                            }))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                        else {
                            var membership = _v51.a;
                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A3($author$project$Components$Membership$Form$setupMembershipOnScope, apiClient, membership, model));
                        }
                    }();
                    var newModel = _v50.a;
                    var cmd = _v50.b;
                    var outMsgs = _v50.c;
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$BillsOverviewMsg, billsOverviewResult.EQ),
                        cmd
                    ])), _Utils_ap(billsOverviewResult.at, outMsgs));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 25:
                var membershipId = msg.a;
                var lastContract = msg.b;
                var endDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$endDate, lastContract);
                return _Utils_Tuple3(_Utils_update(model, {
                    jP: $elm$core$Maybe$Just(A2($author$project$Components$Membership$Form$RenewContractModal$init, membershipId, endDate))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v52 = model.jP;
                if (!_v52.$) {
                    var renewContractModal = _v52.a;
                    var renewContractModalResult = A3($author$project$Components$Membership$Form$RenewContractModal$update, apiClient, subMsg, renewContractModal);
                    var _v53 = function() {
                        var _v54 = renewContractModalResult.adu;
                        switch(_v54){
                            case 0:
                                return _Utils_Tuple3($elm$core$Maybe$Just(renewContractModalResult.zi), $elm$core$Platform$Cmd$none, model);
                            case 1:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, model);
                            default:
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A2($author$project$Components$Membership$Form$retrieveItem, apiClient, A2($elm$core$Maybe$withDefault, '', model.aef)), model);
                        }
                    }();
                    var renewContractModal_ = _v53.a;
                    var cmd = _v53.b;
                    var newModel_ = _v53.c;
                    return _Utils_Tuple3(_Utils_update(newModel_, {
                        jP: renewContractModal_
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Membership$Form$RenewContractModalMsg, renewContractModalResult.EQ),
                        cmd
                    ])), renewContractModalResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$update = F2(function(msg, model) {
        var _v0 = A3($author$project$Components$Membership$Form$update, model.Ej, msg, model.PU);
        var form = _v0.a;
        var cmd = _v0.b;
        var outMsgs = _v0.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), cmd, outMsgs);
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$dirty = function(_v0) {
        var model = _v0;
        return $author$project$Utils$Form$dirty(model.PU);
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$dirty = function(_v0) {
        var model = _v0;
        return $author$project$Utils$Form$dirty(model.PU);
    };
    var $author$project$Components$Membership$Form$Sections$Members$dirty = function(model) {
        return !_Utils_eq(model.GJ, $elm$core$Set$fromList($elm$core$Dict$keys(model.T$))) || A2($elm$core$List$any, function(_v0) {
            var _v1 = _v0.b;
            var membershipPatientModel = _v1.b;
            return $author$project$Components$Membership$Form$Members$MembershipPatient$dirty(membershipPatientModel);
        }, $elm$core$Dict$toList(model.T$));
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$dirty = function(_v0) {
        var model = _v0;
        return $author$project$Utils$Form$dirty(model.PU);
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$dirty = function(_v0) {
        var model = _v0;
        return $author$project$Utils$Form$dirty(model.PU);
    };
    var $author$project$Components$Membership$Form$Sections$Summary$dirty = function(_v0) {
        var model = _v0;
        return $author$project$Utils$Form$dirty(model.PU);
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$modal = function(_v0) {
        var model = _v0;
        var _v1 = model.fd;
        if (!_v1.$) {
            var _v2 = _v1.a;
            var cancelRequest = _v2.a;
            var membershipId = _v2.b;
            return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Membership$Form$Sections$Contracts$CancelHiConfirmClosed(membershipId), _List_fromArray([
                $author$project$Components$HiConfirm$noun('Contract'),
                $author$project$Components$HiConfirm$verb('Cancel'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(cancelRequest, $author$project$Api$Data$Loading))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$CreatePatientModal$Create = {
        $: 2
    };
    var $author$project$Components$CreatePatientModal$view = F2(function(title, model) {
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false),
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$onSubmit($author$project$Components$CreatePatientModal$Create)
        ]), _List_fromArray([
            A3($author$project$Ui$Modal$view, $author$project$Components$CreatePatientModal$Close, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title(title)
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$CreatePatientModal$PatientFormMsg), $author$project$Components$Patient$Form$view(model.PU)))
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Cancel and close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$CreatePatientModal$Close)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Create patient'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$loading(model.km),
                        $author$project$Ui$Button$submit
                    ]), _List_fromArray([
                        $elm$html$Html$text('Create')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$modal = function(_v0) {
        var model = _v0;
        var _v1 = model.h2;
        if (!_v1.$) {
            var createPatientModal = _v1.a;
            return A2($elm$html$Html$map, $author$project$Components$Membership$Form$Members$MembershipPatient$CreatePatientModalMsg, A2($author$project$Components$CreatePatientModal$view, 'Add New Patient to Membership', createPatientModal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Membership$Form$Sections$Members$modal = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, function(_v0) {
            var id = _v0.a;
            var _v1 = _v0.b;
            var membershipPatient = _v1.b;
            return A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(id), $author$project$Components$Membership$Form$Members$MembershipPatient$modal(membershipPatient));
        }, $elm$core$Dict$toList(model.T$)));
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$Save = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonths = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Meta$contractEndDateDefault = function(_v0) {
        var meta = _v0;
        return meta.wV.Nn;
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$Type = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton = F3(function(currentType_, type_, label) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(currentType_, type_)),
            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated($author$project$Components$Membership$Form$Sections$PlanChange$Type(type_)))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$viewEffectiveDate = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var type_ = _v0.ah5;
        var changeOnDate = _v0.K3;
        var changeAfterMonths = _v0.K2;
        var changeOnDateDateInput = _v0.v5;
        var contract = _v0.EV;
        var membershipMeta = _v0.Gj;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Effective date'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            function() {
                if (type_ === 2) return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var _v2 = contract.WA;
                        if (!_v2.$) {
                            var contractPeriodInMonths_ = _v2.a;
                            var effectiveDate = function() {
                                var _v3 = _Utils_Tuple2(contract.qv, $author$project$Api$Provider$Membership$Meta$contractEndDateDefault(membershipMeta));
                                if (!_v3.a.$) {
                                    var contractEndDate_ = _v3.a.a;
                                    return $elm$core$Maybe$Just(contractEndDate_);
                                } else {
                                    var _v4 = _v3.a;
                                    var defaultContractEndDate = _v3.b;
                                    return defaultContractEndDate;
                                }
                            }();
                            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', contractPeriodInMonths_)),
                                $elm$html$Html$text(' ('),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), effectiveDate))),
                                $elm$html$Html$text(')')
                            ]));
                        } else return $elm$html$Html$text('Contract end date');
                    }(),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('When contract periods are enabled, the plan can only be changed after the contract is ended.')
                    ]))
                ]));
                else return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(7)
                    ]), _List_fromArray([
                        $author$project$Ui$Button$group(_List_fromArray([
                            A3($author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton, type_, 1, 'Periods of months'),
                            A3($author$project$Components$Membership$Form$Sections$PlanChange$viewTypeButton, type_, 0, 'Date')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        function() {
                            switch(type_){
                                case 2:
                                    return $author$project$Utils$Html$empty;
                                case 1:
                                    return $author$project$Ui$Form$PeriodInMonthsInput$view({
                                        fK: A2($author$project$Utils$Form$validationErrors, 1, form),
                                        q2: A2($author$project$Utils$Form$hasValidationErrors, 1, form),
                                        afE: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$PlanChange$FormUpdated, $author$project$Components$Membership$Form$Sections$PlanChange$ChangeAfterMonths),
                                        aa9: changeAfterMonths
                                    });
                                default:
                                    return A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$PlanChange$ChangeOnDateDateInputMsg(changeOnDateDateInput), A2($author$project$Components$DateInput$view, _List_fromArray([
                                        $author$project$Components$DateInput$value(changeOnDate),
                                        $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                                        $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                                    ]), changeOnDateDateInput));
                            }
                        }()
                    ]))
                ]));
            }()
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$viewToPlan = F2(function(model, form) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('New plan'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$PlanChange$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
            ]), model.jy))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$viewForm = F2(function(model, form) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Components$Membership$Form$Sections$PlanChange$viewEffectiveDate(form),
            A2($author$project$Components$Membership$Form$Sections$PlanChange$viewToPlan, model, form)
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$modal = function(_v0) {
        var model = _v0;
        var _v1 = _Utils_Tuple2(model.PU, model.fr);
        if (!_v1.a.$) {
            var form = _v1.a.a;
            var modalConfig = {
                QG: $elm$core$Maybe$Nothing,
                aeI: 'Plan Change',
                Tk: _Utils_eq(model.j_, $author$project$Api$Data$Loading),
                TR: $elm$core$Maybe$Nothing,
                TS: $elm$core$Maybe$Nothing,
                Vl: $author$project$Components$Membership$Form$Sections$PlanChange$CloseModal,
                Vn: $author$project$Components$Membership$Form$Sections$PlanChange$Save
            };
            return A2($author$project$Components$Admin$CreateEditModal$modal, modalConfig, _List_fromArray([
                A2($author$project$Components$Membership$Form$Sections$PlanChange$viewForm, model, form)
            ]));
        } else if (!_v1.b.$) {
            var _v2 = _v1.a;
            var _v3 = _v1.b.a;
            var membershipId = _v3.a;
            var deleteRequest = _v3.b;
            var scheduledChange = _v3.c;
            return A2($author$project$Components$HiConfirm$modal, A2($author$project$Components$Membership$Form$Sections$PlanChange$DeleteHiConfirmClosed, membershipId, scheduledChange), _List_fromArray([
                $author$project$Components$HiConfirm$noun('Plan change'),
                $author$project$Components$HiConfirm$verb('Remove'),
                $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
            ]));
        } else {
            var _v4 = _v1.a;
            var _v5 = _v1.b;
            return $author$project$Utils$Html$empty;
        }
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewChargeItemInput = function(model) {
        var editing = $author$project$Utils$Maybe$toBool(model.yc);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Charge Item'),
            $author$project$Ui$Form$Group$required(!editing)
        ]), _List_fromArray([
            function() {
                if (editing) {
                    var recurringCharge = $author$project$Utils$Form$fields(model.PU);
                    return A2($author$project$Ui$Form$Static$view, _List_fromArray([
                        $author$project$Ui$Form$Static$phi(true)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, function($) {
                                return $.zr;
                            }, recurringCharge.lv)))
                        ]))
                    ]));
                } else return A2($elm$html$Html$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$ChargeItemResourceFilterMsg, A2($author$project$Components$ResourceFilter$ChargeItem$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                    $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
                ]), model.cL));
            }()
        ]));
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedDescription = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewDescriptionInput = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var fixedDescription = _v0.adS;
        var chargeItem = _v0.lv;
        var placeholder = A2($elm$core$Maybe$withDefault, 'Additional details for receipt (e.g. ICD-10 Codes)', A2($elm$core$Maybe$andThen, function($) {
            return $.NQ;
        }, chargeItem));
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Description')
        ]), _List_fromArray([
            $author$project$Ui$Form$Textarea$view(_List_fromArray([
                $author$project$Ui$Form$Textarea$rows(2),
                $author$project$Ui$Form$Textarea$phi(true),
                $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', fixedDescription)),
                $author$project$Ui$Form$Textarea$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedDescription)),
                $author$project$Ui$Form$Textarea$placeholder(placeholder)
            ]))
        ]));
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedPriceInCents = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewFixedPriceInCentsInput = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var fixedPriceInCents = _v0.adT;
        var chargeItem = _v0.lv;
        var placeholder = $author$project$Utils$Currency$fromFloat(A2($elm$core$Maybe$withDefault, 0.0, A2($elm$core$Maybe$map, function($) {
            return $.Br;
        }, chargeItem)));
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Price')
        ]), _List_fromArray([
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(fixedPriceInCents),
                $author$project$Ui$Form$CurrencyInput$placeholder(placeholder),
                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FormUpdated, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$FixedPriceInCents))
            ]))
        ]));
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPatientInput = function(model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Patient'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$LimitedPatientSelectorMsg, A2($author$project$Components$LimitedPatientSelector$view, _List_fromArray([
                $author$project$Components$LimitedPatientSelector$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                $author$project$Components$LimitedPatientSelector$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
            ]), model.rg))
        ]));
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPractitionerInput = function(model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Provider')
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$view, _List_Nil, model.jE))
        ]));
    };
    var $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$view = function(_v0) {
        var model = _v0;
        var editing = $author$project$Utils$Maybe$toBool(model.yc);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title(editing ? 'Edit Charge' : 'New Charge')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal
                ]), A2($elm$core$List$cons, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewChargeItemInput(model), A2($elm$core$List$cons, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPatientInput(model), editing ? _List_fromArray([
                    $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewPractitionerInput(model),
                    $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewFixedPriceInCentsInput(model),
                    $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$viewDescriptionInput(model)
                ]) : _List_Nil))),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(A2($elm$core$List$cons, A3($author$project$Ui$Button$view, {
                abP: 'Cancel and close modal'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$CancelEdit)
            ]), _List_fromArray([
                $elm$html$Html$text('Cancel')
            ])), editing ? _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Save recurring charge'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save($elm$core$Maybe$Nothing)),
                    $author$project$Ui$Button$primary
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]) : _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Add charge once'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save($elm$core$Maybe$Just(1))),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Once')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add charge recurring'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$Save($elm$core$Maybe$Nothing)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Recurring')
                ]))
            ])))
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$modal = function(_v0) {
        var model = _v0;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            function() {
                var _v1 = model.fm;
                if (!_v1.$) {
                    var createEditModal = _v1.a;
                    return A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$RecurringCharges$CreateEditModalMsg, $author$project$Components$Membership$Form$RecurringCharges$CreateEditModal$view(createEditModal));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$Summary$modal = function(_v0) {
        var model = _v0;
        var _v1 = model.h$;
        if (!_v1.$) {
            var _v2 = _v1.a;
            var createModal = _v2.b;
            return A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Summary$CreateModalMsg, $author$project$Components$BrokerDeal$CreateModal$view(createModal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$MemberRelationship$toString = function(memberRelationship) {
        switch(memberRelationship){
            case 0:
                return 'employee';
            case 1:
                return 'spouse';
            case 2:
                return 'child';
            default:
                return 'other';
        }
    };
    var $author$project$Components$Membership$Form$CancelModal$Cancel = {
        $: 0
    };
    var $author$project$Components$Membership$Form$CancelModal$CancellationReason = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$CancelModal$FormUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Formatters$Date$Timeago = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Membership$Meta$endDateRetailValues = function(_v0) {
        var meta = _v0;
        return meta.qv.Y$;
    };
    var $author$project$Components$Membership$Form$CancelModal$endDateOptions = function(membership) {
        return $author$project$Ui$Form$Select$dateOptions($author$project$Api$Provider$Membership$Meta$endDateRetailValues($author$project$Api$Provider$Membership$One$meta(membership)));
    };
    var $author$project$Api$Provider$Membership$One$lastContract = function(_v0) {
        var record = _v0.b;
        return record.SQ;
    };
    var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration = function(_v0) {
        var meta = _v0;
        return meta.qv._Z;
    };
    var $author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice = F2(function(membership, endDate) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var minWithoutProration = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta);
        var billFromDate = $author$project$Api$Provider$Membership$One$billFromDate(membership);
        var _v0 = _Utils_Tuple2(endDate, minWithoutProration);
        if (!_v0.a.$) {
            if (!_v0.b.$) {
                var endDate_ = _v0.a.a;
                var minWithoutProration_ = _v0.b.a;
                return A3($justinmimbs$date$Date$isBetween, minWithoutProration_, billFromDate, endDate_) && !_Utils_eq(endDate_, billFromDate);
            } else {
                var endDate_ = _v0.a.a;
                var _v1 = _v0.b;
                return !A2($justinmimbs$date$Date$compare, endDate_, billFromDate);
            }
        } else {
            var _v2 = _v0.a;
            return false;
        }
    });
    var $author$project$Api$Provider$Membership$Shared$billingStartDate = function(_v0) {
        var record = _v0;
        return record.Kg;
    };
    var $author$project$Api$Provider$Membership$One$billingStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$billingStartDate(shared);
    };
    var $author$project$Components$Membership$Form$Utils$billedFromDate = F2(function(membership, endDate) {
        return A2($elm_community$list_extra$List$Extra$maximumBy, $justinmimbs$date$Date$toRataDie, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            endDate,
            $elm$core$Maybe$Just($author$project$Api$Provider$Membership$One$billingStartDate(membership))
        ])));
    });
    var $author$project$Api$Provider$Membership$Meta$endDateSponsoredMaxWithoutBilling = function(_v0) {
        var meta = _v0;
        return meta.qv._X;
    };
    var $author$project$Components$Membership$Form$Utils$mayNeedProration = F2(function(membership, endDate) {
        if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) {
            var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
            var minWithoutProration = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta);
            var maxWithoutBilling = $author$project$Api$Provider$Membership$Meta$endDateSponsoredMaxWithoutBilling(membershipMeta);
            var _v0 = _Utils_Tuple3(minWithoutProration, maxWithoutBilling, endDate);
            if (!_v0.a.$ && !_v0.b.$ && !_v0.c.$) {
                var minWithoutProration_ = _v0.a.a;
                var maxWithoutBilling_ = _v0.b.a;
                var endDate_ = _v0.c.a;
                return A3($justinmimbs$date$Date$isBetween, maxWithoutBilling_, minWithoutProration_, endDate_) && !_Utils_eq(endDate_, minWithoutProration_);
            } else return false;
        } else {
            if (!endDate.$) {
                var endDate_ = endDate.a;
                return !A2($justinmimbs$date$Date$compare, endDate_, $author$project$Api$Provider$Membership$One$billFromDate(membership));
            } else return false;
        }
    });
    var $author$project$Components$Membership$Form$Utils$prorationWarning = F4(function(noun, supportUrl, startDate, endDate) {
        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text('We have billed this '),
                $elm$html$Html$text(noun),
                $elm$html$Html$text(' through '),
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), endDate))),
                $elm$html$Html$text(". If you\u2019d like to credit the period of "),
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), startDate))),
                $elm$html$Html$text(' through '),
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), endDate))),
                $elm$html$Html$text(', you can learn how to do that '),
                A3($author$project$Ui$Link$externalHref, supportUrl, _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                $elm$html$Html$text('.')
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Utils$mayNeedProrationWarning = F3(function(noun, membership, endDate) {
        if (A2($author$project$Components$Membership$Form$Utils$mayNeedProration, membership, endDate)) {
            if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) {
                var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
                return A4($author$project$Components$Membership$Form$Utils$prorationWarning, noun, 'https://support.hint.com/en/articles/4622730-adding-an-employer-credit-or-one-off-charge', A2($author$project$Components$Membership$Form$Utils$billedFromDate, membership, endDate), $author$project$Api$Provider$Membership$Meta$endDateSponsoredMinWithoutProration(membershipMeta));
            } else return A4($author$project$Components$Membership$Form$Utils$prorationWarning, noun, 'https://support.hint.com/invoices/creating-a-prorated-membership-invoice', endDate, $author$project$Api$Provider$Membership$One$billedThroughDate(membership));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentEndDate = function(_v0) {
        var record = _v0;
        return record.Uo;
    };
    var $author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentEndDate(shared);
    };
    var $author$project$Api$Provider$Membership$One$periodRateInCents = function(_v0) {
        var record = _v0.b;
        return record.WB;
    };
    var $author$project$Components$Membership$Form$CancelModal$viewMembershipPatient = function(membershipPatient) {
        var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
        var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(memberType === 1 ? 'Adult' : $author$project$Formatters$String$titleize($author$project$Api$MemberRelationship$toString(memberType))),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                    V8: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
                }), _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Membership$Form$CancelModal$view = F2(function(cancellationReasons, _v0) {
        var model = _v0;
        var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(model.jc);
        var fields = $author$project$Utils$Form$fields(model.PU);
        var earlyTermination = function() {
            var _v1 = _Utils_Tuple2(fields.qv, $author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.jc));
            if (!_v1.a.$ && !_v1.b.$) {
                var endDate = _v1.a.a;
                var minimumEnrollmentEndDate = _v1.b.a;
                return !A2($justinmimbs$date$Date$compare, endDate, minimumEnrollmentEndDate);
            } else return false;
        }();
        return A3($author$project$Ui$Modal$view, $author$project$Components$Membership$Form$CancelModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('End Membership')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                earlyTermination ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This patient\'s minimum enrollment is scheduled to end '),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString(A2($author$project$Formatters$Date$Timeago, model.cP, $elm$core$Maybe$Just('days'))), $author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.jc)))),
                    $elm$html$Html$text(' on '),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(model.jc)))),
                    $elm$html$Html$text('. If you end their membership early they will not pay for the remaining time.')
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Membership$Form$CancelModal$Cancel),
                    $author$project$Ui$Form$horizontal
                ]), $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Membership Started'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Membership$One$startDate(model.jc)))
                            ]))
                        ])),
                        $author$project$Api$Provider$Membership$One$contractExpires(model.jc) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Contract end date'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$endDate, $author$project$Api$Provider$Membership$One$lastContract(model.jc)))))
                        ])) : $author$project$Utils$Html$empty,
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('End Date'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$required(true)
                        ]), _List_fromArray([
                            $author$project$Api$Provider$Membership$One$isSponsored(model.jc) ? A2($elm$html$Html$map, $author$project$Components$Membership$Form$CancelModal$EndDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                                $author$project$Components$DateInput$value(fields.qv),
                                $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                                $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                            ]), model.qx)) : A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, fields.qv)),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$CancelModal$FormUpdated, $author$project$Components$Membership$Form$CancelModal$EndDate), $elm$core$Result$toMaybe), $justinmimbs$date$Date$fromIsoString)),
                                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                            ]), $author$project$Components$Membership$Form$CancelModal$endDateOptions(model.jc)),
                            A2($author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice, model.jc, fields.qv) ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Invoices after this date will be automatically cancelled unless paid.')
                                ]))
                            ])) : $author$project$Utils$Html$empty,
                            A3($author$project$Components$Membership$Form$Utils$mayNeedProrationWarning, 'membership', model.jc, fields.qv)
                        ])),
                        A2($author$project$Components$Membership$Form$Utils$mayHaveCancellableInvoice, model.jc, fields.qv) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Amount'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Membership$One$periodRateInCents(model.jc))),
                                $author$project$Utils$Html$noBreakSpace,
                                $elm$html$Html$text($author$project$Formatters$Int$asPeriod($author$project$Api$Provider$Membership$One$periodInMonths(model.jc)))
                            ]))
                        ])) : $author$project$Utils$Html$empty,
                        $author$project$Components$CancellationReason$Input$view({
                            acb: cancellationReasons,
                            fK: A2($author$project$Utils$Form$validationErrors, 1, model.PU),
                            O6: A2($author$project$Utils$Form$validationErrors, 2, model.PU),
                            aeJ: $elm$core$Maybe$Nothing,
                            afv: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$CancelModal$FormUpdated, $author$project$Components$Membership$Form$CancelModal$CancellationReason),
                            aa9: _Utils_Tuple2(fields.ab9, fields.aca)
                        })
                    ]),
                    A2($elm$core$List$map, $author$project$Components$Membership$Form$CancelModal$viewMembershipPatient, membershipPatients)
                ]))),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$CancelModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'End membership'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$loading(_Utils_eq(model.fd, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$CancelModal$Cancel)
                ]), _List_fromArray([
                    $elm$html$Html$text('End Membership')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatient = function(patient) {
        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text(patient.zr)
            ])),
            $elm$html$Html$text(' is '),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, patient.IZ)))
            ])),
            $elm$html$Html$text(' years old.')
        ]));
    };
    var $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange = F3(function(range, limit, patients) {
        return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            $elm$html$Html$text('The '),
            $elm$html$Html$text(range),
            $elm$html$Html$text(' age defined for this plan is '),
            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $elm$core$String$fromInt, limit))),
            $elm$html$Html$text('.'),
            A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, $author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatient, patients))
        ]));
    });
    var $author$project$Components$Membership$Form$OutsideAgeRangeModal$view = F2(function(onClose, model) {
        return A3($author$project$Ui$Modal$view, onClose(false), _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Warning - patient outside of plan age range')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $elm$core$List$length(model.vM) >= 1 ? A3($author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange, 'minimum', model.Un, model.vM) : $author$project$Utils$Html$empty,
                $elm$core$List$length(model.tL) >= 1 ? A3($author$project$Components$Membership$Form$OutsideAgeRangeModal$viewPatientsOutsideRange, 'maximum', model.TQ, model.tL) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Do you want to proceed anyway?')
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick(onClose(false))
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Proceed anyway'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick(onClose(true))
                ]), _List_fromArray([
                    $elm$html$Html$text('Confirm')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$RenewContractModal$MemoUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RenewContractModal$Renew = {
        $: 2
    };
    var $author$project$Components$Membership$Form$RenewContractModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Membership$Form$RenewContractModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Set contract to renew?')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Current contract expires: '),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), model.F9)))
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Memo:')
                ])),
                $author$project$Ui$Form$Textarea$view(_List_fromArray([
                    $author$project$Ui$Form$Textarea$rows(4),
                    $author$project$Ui$Form$Textarea$value(A2($elm$core$Maybe$withDefault, '', model.ae0)),
                    $author$project$Ui$Form$Textarea$onInput($author$project$Components$Membership$Form$RenewContractModal$MemoUpdated)
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RenewContractModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Confirm contract renewal'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.nZ, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RenewContractModal$Renew)
                ]), _List_fromArray([
                    $elm$html$Html$text('Confirm')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Membership$Form$RestartModal$DateInputMsg = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$RestartModal$Restart = {
        $: 0
    };
    var $author$project$Formatters$Date$Relative = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$MembershipBill$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipBill$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$MembershipBill$Shared$date = function(_v0) {
        var record = _v0;
        return record.M4;
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$date = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipBill$Shared$date(shared);
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice = function(_v0) {
        var record = _v0.b;
        return record.RA;
    };
    var $author$project$Api$Provider$MembershipBill$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipBill$Shared$startDate(shared);
    };
    var $author$project$Components$Membership$Form$RestartModal$viewMembershipBill = F3(function(currentDate, membership, membershipBill) {
        var invoice = $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill);
        var date = $author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill);
        var startDate = A2($elm$core$Maybe$withDefault, date, $author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate(membershipBill));
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, startDate)),
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$primary
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill))),
                    function() {
                        if (!invoice.$) {
                            var invoice_ = invoice.a;
                            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $author$project$Utils$Html$noBreakSpace,
                                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice_))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        if (!invoice.$) {
                            var invoice_ = invoice.a;
                            var invoiceRoute = function() {
                                if ($author$project$Api$Provider$Membership$One$isSponsored(membership)) return A2($elm$core$Maybe$map, function(company_) {
                                    return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                                        fl: $author$project$Api$Provider$Company$Shared$id(company_),
                                        aef: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_)
                                    });
                                }, $author$project$Api$Provider$Membership$One$company(membership));
                                else {
                                    var owner = $author$project$Api$Provider$Membership$One$owner(membership);
                                    return A2($elm$core$Maybe$map, function(owner_) {
                                        return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                            RI: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_),
                                            V8: $author$project$Api$Provider$Patient$Shared$id(owner_)
                                        });
                                    }, owner);
                                }
                            }();
                            if (!invoiceRoute.$) {
                                var route = invoiceRoute.a;
                                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $author$project$Utils$Html$noBreakSpace,
                                    A3($author$project$Ui$Link$route, route, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('#'),
                                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
                                    ]))
                                ]));
                            } else return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(' #'),
                                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ])),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('due '),
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Just('bill')), date))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$RestartModal$viewMembershipPatient = function(membershipPatient) {
        var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
        var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                V8: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
            }), _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
                ]))
            ])),
            $author$project$Utils$Html$noBreakSpace,
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                memberType === 1 ? $elm$html$Html$text('Adult') : $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Api$MemberRelationship$toString(memberType)))
            ]))
        ]));
    };
    var $author$project$Components$Membership$Form$RestartModal$viewModal = F4(function(pendingMembership, model, maybeDate, dateInput) {
        var upcomingAndOutstandingBills = $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership);
        var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(model.jc);
        return A3($author$project$Ui$Modal$view, $author$project$Components$Membership$Form$RestartModal$Close, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Restart Membership')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This membership will no longer end and it\'s next billing date will be '),
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership)))),
                    $elm$html$Html$text('.')
                ])),
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$onSubmit($author$project$Components$Membership$Form$RestartModal$Restart),
                    $author$project$Ui$Form$horizontal
                ]), $elm$core$List$concat(_List_fromArray([
                    _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Start Date'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Membership$One$startDate(pendingMembership)))
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Next Bill Date'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8),
                            $author$project$Ui$Form$Group$inputSpan(6),
                            $author$project$Ui$Form$Group$inputSpanSm(4),
                            $author$project$Ui$Form$Group$clearfix
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Membership$Form$RestartModal$DateInputMsg(dateInput), A2($author$project$Components$DateInput$view, _List_fromArray([
                                $author$project$Components$DateInput$value(maybeDate)
                            ]), dateInput))
                        ])),
                        !$elm$core$List$isEmpty(membershipPatients) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Members'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, A2($elm$core$List$map, $author$project$Components$Membership$Form$RestartModal$viewMembershipPatient, membershipPatients))
                        ])) : $author$project$Utils$Html$empty,
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Upcoming Bills'),
                            $author$project$Ui$Form$Group$labelSpan(4),
                            $author$project$Ui$Form$Group$inputSpan(8)
                        ]), _List_Nil)
                    ]),
                    A2($elm$core$List$map, A2($author$project$Components$Membership$Form$RestartModal$viewMembershipBill, model.cP, model.jc), upcomingAndOutstandingBills)
                ]))),
                $author$project$Ui$Clearfix$view
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RestartModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Restart membership'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$loading(_Utils_eq(model.sy, $author$project$Api$Data$Loading)),
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RestartModal$Restart)
                ]), _List_fromArray([
                    $elm$html$Html$text('Restart Membership')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$RestartModal$view = function(model) {
        var _v0 = model.da;
        if (_v0.$ === 1) return $author$project$Utils$Html$empty;
        else {
            var pendingMembership = _v0.a;
            return A4($author$project$Components$Membership$Form$RestartModal$viewModal, pendingMembership, model, $author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership), model.qg);
        }
    };
    var $author$project$Components$Membership$Form$modal = function(model) {
        return A2($author$project$Ui$Typography$div, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                function() {
                    var _v0 = model.fr;
                    if (!_v0.$) {
                        var _v1 = _v0.a;
                        var membership = _v1.a;
                        var deleteRequest = _v1.b;
                        var membershipPatients = $author$project$Api$Provider$Membership$One$membershipPatients(membership);
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Components$Membership$Form$DeleteHiConfirmClosed(membership), _List_fromArray([
                            $author$project$Components$HiConfirm$noun('membership'),
                            $author$project$Components$HiConfirm$verb('delete'),
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Are you sure you want to delete this membership? This cannot be undone.')
                                ])),
                                !$elm$core$List$isEmpty(membershipPatients) ? A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('These related patients will also have their membership deleted.')
                                ])), A2($elm$core$List$map, function(membershipPatient) {
                                    var patient = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient(membershipPatient);
                                    var memberType = $author$project$Api$Provider$MembershipPatient$ForMembershipOne$memberType(membershipPatient);
                                    return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                        $author$project$Ui$Form$Group$labelSpan(4),
                                        $author$project$Ui$Form$Group$inputSpan(4),
                                        $author$project$Ui$Form$Group$clearfix,
                                        $author$project$Ui$Form$Group$label(memberType === 1 ? 'Adult' : $author$project$Formatters$String$titleize($author$project$Api$MemberRelationship$toString(memberType)))
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                                V8: $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$id(patient)
                                            }), _List_Nil, _List_fromArray([
                                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                                    $author$project$Ui$Typography$phi(true)
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text($author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$name(patient))
                                                ]))
                                            ]))
                                        ]))
                                    ]));
                                }, membershipPatients))) : $author$project$Utils$Html$empty
                            ])),
                            $author$project$Components$HiConfirm$loading(_Utils_eq(deleteRequest, $author$project$Api$Data$Loading))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.dA;
                    if (!_v2.$) {
                        var cancelModal = _v2.a;
                        return A2($elm$html$Html$map, $author$project$Components$Membership$Form$CancelModalMsg, A2($author$project$Components$Membership$Form$CancelModal$view, model.acb, cancelModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v3 = model.jU;
                    if (!_v3.$) {
                        var restartModal = _v3.a;
                        return A2($elm$html$Html$map, $author$project$Components$Membership$Form$RestartModalMsg, $author$project$Components$Membership$Form$RestartModal$view(restartModal));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v4 = model.gi;
                    if (!_v4.$) {
                        var _v5 = _v4.a;
                        var outsideAgeRangeModal = _v5.a;
                        return A2($author$project$Components$Membership$Form$OutsideAgeRangeModal$view, $author$project$Components$Membership$Form$OutsideAgeRangeModalClosed, outsideAgeRangeModal);
                    } else return $author$project$Utils$Html$empty;
                }()
            ]),
            function() {
                var _v6 = model.l;
                if (!_v6.$) {
                    var sections = _v6.a;
                    return _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Membership$Form$SummaryMsg, $author$project$Components$Membership$Form$Sections$Summary$modal(sections.$x)),
                        A2($elm$html$Html$map, $author$project$Components$Membership$Form$MembersMsg, $author$project$Components$Membership$Form$Sections$Members$modal(sections.B)),
                        A2($elm$html$Html$map, $author$project$Components$Membership$Form$ContractsMsg, $author$project$Components$Membership$Form$Sections$Contracts$modal(sections.aD)),
                        A2($elm$html$Html$map, $author$project$Components$Membership$Form$RecurringChargesMsg, $author$project$Components$Membership$Form$Sections$RecurringCharges$modal(sections.Yl)),
                        function() {
                            var _v7 = sections.jw;
                            if (!_v7.$) {
                                var planChange = _v7.a;
                                return A2($elm$html$Html$map, $author$project$Components$Membership$Form$PlanChangeMsg, $author$project$Components$Membership$Form$Sections$PlanChange$modal(planChange));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]);
                } else return _List_Nil;
            }(),
            _List_fromArray([
                function() {
                    var _v8 = model.jP;
                    if (!_v8.$) {
                        var renewContractModal = _v8.a;
                        return A2($elm$html$Html$map, $author$project$Components$Membership$Form$RenewContractModalMsg, $author$project$Components$Membership$Form$RenewContractModal$view(renewContractModal));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])
        ])));
    };
    var $author$project$Components$Membership$Form$CancelMembership = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$ConfirmMembership = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$DeleteMembership = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$RestartMembership = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Save = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Api$Provider$Membership$One$endDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$endDate(shared);
    };
    var $author$project$Api$Provider$Membership$Shared$endDateFarInThePast = function(_v0) {
        var record = _v0;
        return record.OR;
    };
    var $author$project$Api$Provider$Membership$One$endDateFarInThePast = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$endDateFarInThePast(shared);
    };
    var $author$project$Ui$Typography$HiddenXs = {
        $: 29
    };
    var $author$project$Ui$Typography$hiddenXs = $author$project$Ui$Typography$HiddenXs;
    var $author$project$Api$Provider$Membership$One$isCancellable = function(_v0) {
        var record = _v0.b;
        return record.RV;
    };
    var $author$project$Api$Provider$Membership$One$isConfirmable = function(_v0) {
        var record = _v0.b;
        return record.RW;
    };
    var $author$project$Api$Provider$Membership$One$isDestroyable = function(_v0) {
        var record = _v0.b;
        return record.R1;
    };
    var $author$project$Api$Provider$Membership$Shared$isRestartable = function(_v0) {
        var record = _v0;
        return record.Sq;
    };
    var $author$project$Api$Provider$Membership$One$isRestartable = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$isRestartable(shared);
    };
    var $author$project$Components$Membership$Form$RenewContract = F2(function(a, b) {
        return {
            $: 25,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$viewRenewContractButton = F2(function(dirty, membership) {
        return $author$project$Api$Provider$Membership$One$contractExpires(membership) && !(dirty && $author$project$Api$Provider$Membership$One$isUpdatable(membership)) && !$author$project$Api$Provider$Membership$One$isRestartable(membership) ? A3($author$project$Ui$Button$view, {
            abP: 'Renew contract'
        }, _List_fromArray([
            $author$project$Ui$Button$success,
            $author$project$Ui$Button$onClick(A2($author$project$Components$Membership$Form$RenewContract, $author$project$Api$Provider$Membership$One$id(membership), $author$project$Api$Provider$Membership$One$lastContract(membership)))
        ]), _List_fromArray([
            $elm$html$Html$text('Renew Contract')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Membership$Form$viewEditButtons = F3(function(dirty, membership, model) {
        return _List_fromArray([
            A2($author$project$Components$Membership$Form$viewRenewContractButton, dirty, membership),
            dirty && $author$project$Api$Provider$Membership$One$isUpdatable(membership) ? A3($author$project$Ui$Button$view, {
                abP: 'Update membership'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Save(false))
            ]), _List_fromArray([
                $elm$html$Html$text('Update')
            ])) : $author$project$Utils$Html$empty,
            !dirty && $author$project$Api$Provider$Membership$One$isCancellable(membership) ? A3($author$project$Ui$Button$view, {
                abP: 'End membership'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$CancelMembership(membership))
            ]), _List_fromArray([
                $author$project$Ui$Icon$stop(_List_Nil),
                $elm$html$Html$text(' End'),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$hiddenXs
                ]), _List_fromArray([
                    $elm$html$Html$text(' Membership')
                ]))
            ])) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$Membership$One$isDestroyable(membership) ? A3($author$project$Ui$Button$view, {
                abP: 'Delete membership'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$DeleteMembership(membership)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
            ]), _List_fromArray([
                $elm$html$Html$text('Delete'),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$hiddenXs
                ]), _List_fromArray([
                    $elm$html$Html$text(' Membership')
                ]))
            ])) : $author$project$Utils$Html$empty,
            function() {
                var _v0 = $author$project$Api$Provider$Membership$One$endDate(membership);
                if (!_v0.$) {
                    var isRestartable = $author$project$Api$Provider$Membership$One$isRestartable(membership);
                    var endDateFarInThePast = $author$project$Api$Provider$Membership$One$endDateFarInThePast(membership);
                    var button = A3($author$project$Ui$Button$view, {
                        abP: 'Restart memberhsip'
                    }, _List_fromArray([
                        $author$project$Ui$Button$styled(1),
                        $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$RestartMembership(membership)),
                        $author$project$Ui$Button$disabled(!$author$project$Api$Provider$Membership$One$isRestartable(membership))
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$repeat(_List_Nil),
                        $elm$html$Html$text(' Restart'),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$hiddenXs
                        ]), _List_fromArray([
                            $elm$html$Html$text(' Membership')
                        ]))
                    ]));
                    var _v1 = _Utils_Tuple2(isRestartable, endDateFarInThePast);
                    if (_v1.a) return button;
                    else {
                        if (_v1.b) return A3($author$project$Ui$Tooltip$view, _List_Nil, 'Memberships which ended more than 3 months in the past cannot be restarted. Please create a new membership for the patient.', _List_fromArray([
                            button
                        ]));
                        else return A3($author$project$Ui$Tooltip$view, _List_Nil, 'This membership is not restartable', _List_fromArray([
                            button
                        ]));
                    }
                } else return $author$project$Utils$Html$empty;
            }(),
            !dirty && $author$project$Api$Provider$Membership$One$isConfirmable(membership) ? A3($author$project$Ui$Button$view, {
                abP: 'Confirm membership'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$ConfirmMembership(membership))
            ]), _List_fromArray([
                $elm$html$Html$text('Confirm'),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$hiddenXs
                ]), _List_fromArray([
                    $elm$html$Html$text(' Membership')
                ]))
            ])) : $author$project$Utils$Html$empty
        ]);
    });
    var $author$project$Ui$Typography$ContentDisabled = function(a) {
        return {
            $: 33,
            a: a
        };
    };
    var $author$project$Ui$Typography$contentDisabled = $author$project$Ui$Typography$ContentDisabled;
    var $author$project$Ui$Spinner$Pull = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Spinner$pull = $author$project$Ui$Spinner$Pull;
    var $author$project$Components$Membership$Form$Sections$BillsOverview$IssueInvoice = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$charges = function(_v0) {
        var record = _v0.b;
        return record.K9;
    };
    var $author$project$Api$Provider$MembershipBill$Shared$couponDiscountInCents = function(_v0) {
        var record = _v0;
        return record.Mk;
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipBill$Shared$couponDiscountInCents(shared);
    };
    var $author$project$Api$Provider$MembershipBill$Shared$couponDiscountMonths = function(_v0) {
        var record = _v0;
        return record.Ml;
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipBill$Shared$couponDiscountMonths(shared);
    };
    var $author$project$Api$Provider$Membership$Meta$invoiceNowAction = function(_v0) {
        var meta = _v0;
        return meta.tM.RJ;
    };
    var $author$project$Utils$Date$isAfterOrEqual = F2(function(date, otherDate) {
        return A2($author$project$Utils$Date$isAfter, date, otherDate) || _Utils_eq(date, otherDate);
    });
    var $author$project$Components$Membership$Form$Sections$BillsOverview$isFirstUninvoicedBill = F3(function(isNew, membershipBills, index) {
        return isNew ? false : _Utils_eq(A2($elm_community$list_extra$List$Extra$findIndex, function(membershipBill) {
            return !$author$project$Utils$Maybe$toBool($author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill));
        }, membershipBills), $elm$core$Maybe$Just(index));
    });
    var $author$project$Api$Provider$MembershipBill$Shared$membershipAmountInCents = function(_v0) {
        var record = _v0;
        return record.TZ;
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipBill$Shared$membershipAmountInCents(shared);
    };
    var $author$project$Api$Common$Payable$Invoice$Min$paymentScheduledOn = function(_v0) {
        var record = _v0;
        return record.Wq;
    };
    var $author$project$Api$Provider$MembershipBill$Shared$periodInMonths = function(_v0) {
        var record = _v0;
        return record.WA;
    };
    var $author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipBill$Shared$periodInMonths(shared);
    };
    var $author$project$Api$Provider$Membership$One$shouldBeBilledUpToDate = function(_v0) {
        var record = _v0.b;
        return record._a;
    };
    var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$quantity = function(_v0) {
        var record = _v0;
        return record.Bu;
    };
    var $author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBillCharge = function(membershipBillCharge) {
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 27, $author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$name(membershipBillCharge))),
                    $elm$html$Html$text(' x ')
                ])),
                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$quantity(membershipBillCharge)))
            ])),
            $author$project$Utils$Html$noBreakSpace,
            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$MembershipBillCharge$ForMembershipOne$amountInCents(membershipBillCharge)))
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBill = F8(function(membership, pendingMembership, isNew, sameAsOriginal, model, membershipBills, index, membershipBill) {
        var startDate = $author$project$Api$Provider$MembershipBill$ForMembershipOne$startDate(membershipBill);
        var owner = $author$project$Api$Provider$Membership$One$owner(membership);
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var invoice = $author$project$Api$Provider$MembershipBill$ForMembershipOne$invoice(membershipBill);
        var date = A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill), startDate);
        var couponDiscountInCents = $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents(membershipBill);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndYear, date))
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$primary
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill))),
                    function() {
                        if (!invoice.$) {
                            var invoice_ = invoice.a;
                            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $author$project$Utils$Html$noBreakSpace,
                                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Common$Payable$Invoice$Min$humanStatus(invoice_))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    $author$project$Api$Provider$Membership$Meta$invoiceNowAction(membershipMeta) && $author$project$Api$Provider$Membership$One$isConfirmed(membership) && A3($author$project$Components$Membership$Form$Sections$BillsOverview$isFirstUninvoicedBill, isNew, membershipBills, index) ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace,
                        A3($author$project$Ui$Button$view, {
                            abP: 'Invoice now'
                        }, _List_fromArray([
                            $author$project$Ui$Button$size(0),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$BillsOverview$IssueInvoice(startDate)),
                            $author$project$Ui$Button$disabled(!sameAsOriginal),
                            $author$project$Ui$Button$loading(_Utils_eq(model.lf, $author$project$Api$Data$Loading)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
                        ]), _List_fromArray([
                            $elm$html$Html$text(' Invoice Now')
                        ]))
                    ])) : $author$project$Utils$Html$empty,
                    function() {
                        if (!invoice.$) {
                            var invoice_ = invoice.a;
                            var invoiceRoute = $author$project$Api$Provider$Membership$One$isSponsored(membership) ? A2($elm$core$Maybe$map, function(company_) {
                                return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                                    fl: $author$project$Api$Provider$Company$Shared$id(company_),
                                    aef: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_)
                                });
                            }, $author$project$Api$Provider$Membership$One$company(pendingMembership)) : A2($elm$core$Maybe$map, function(owner_) {
                                return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                    RI: $author$project$Api$Common$Payable$Invoice$Min$id(invoice_),
                                    V8: $author$project$Api$Provider$Patient$Shared$id(owner_)
                                });
                            }, owner);
                            if (!invoiceRoute.$) {
                                var route = invoiceRoute.a;
                                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $author$project$Utils$Html$noBreakSpace,
                                    A3($author$project$Ui$Link$route, route, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('#'),
                                        $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
                                    ]))
                                ]));
                            } else return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(' #'),
                                $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(invoice_)))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])),
            function() {
                var _v3 = $author$project$Api$Provider$Membership$One$shouldBeBilledUpToDate(pendingMembership);
                if (!_v3.$) {
                    var shouldBeBilledUpToDate_ = _v3.a;
                    var autopay = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$autopay, owner));
                    return autopay && !!A2($justinmimbs$date$Date$compare, shouldBeBilledUpToDate_, $author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)) && !$author$project$Utils$Maybe$toBool(invoice) && !$author$project$Api$Provider$Membership$One$isSponsored(membership) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text('Will automatically invoice '),
                        A2($author$project$Utils$Date$isAfterOrEqual, model.cP, $author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)) ? $elm$html$Html$text('and bill ') : $elm$html$Html$text(' '),
                        $elm$html$Html$text('tonight.')
                    ])) : $author$project$Utils$Html$empty;
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                var _v4 = _Utils_Tuple2($author$project$Api$Provider$Membership$One$isSponsored(membership), A2($elm$core$Maybe$andThen, $author$project$Api$Common$Payable$Invoice$Min$paymentScheduledOn, invoice));
                if (!_v4.a) {
                    if (!_v4.b.$) {
                        var paymenScheduledOn = _v4.b.a;
                        var contents = !A2($justinmimbs$date$Date$compare, model.cP, paymenScheduledOn) ? _List_fromArray([
                            $elm$html$Html$text('Payment scheduled for '),
                            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, paymenScheduledOn)),
                            $elm$html$Html$text('.')
                        ]) : _List_fromArray([
                            $elm$html$Html$text('Payment scheduled for tonight.')
                        ]);
                        return A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$small
                        ]), contents);
                    } else {
                        var _v5 = _v4.b;
                        return $author$project$Utils$Html$empty;
                    }
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $author$project$Api$Provider$Membership$One$isSponsored(membership) ? $author$project$Utils$Html$empty : $elm$html$Html$text('Due '),
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill)))
            ])),
            function() {
                var _v6 = $author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents(membershipBill);
                if (!_v6.$) {
                    var registrationFeeInCents = _v6.a;
                    return registrationFeeInCents > 0 ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Registration Fee')
                        ])),
                        $author$project$Utils$Html$noBreakSpace,
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt(registrationFeeInCents))
                    ])) : $author$project$Utils$Html$empty;
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$map, $author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBillCharge, $author$project$Api$Provider$MembershipBill$ForMembershipOne$charges(membershipBill))),
            function() {
                if ($author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents(membershipBill) > 0 || $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountInCents(membershipBill) > 0) {
                    var periodInMonths = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths(membershipBill));
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Membership')
                        ])),
                        $author$project$Utils$Html$noBreakSpace,
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$MembershipBill$ForMembershipOne$membershipAmountInCents(membershipBill))),
                        $author$project$Utils$Html$noBreakSpace,
                        $elm$html$Html$text($author$project$Formatters$Int$asPeriod(periodInMonths))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            function() {
                if (couponDiscountInCents > 0) {
                    var periodInMonths = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$MembershipBill$ForMembershipOne$periodInMonths(membershipBill));
                    var couponDiscountMonths = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$MembershipBill$ForMembershipOne$couponDiscountMonths(membershipBill));
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('Includes '),
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(couponDiscountInCents)),
                            $elm$html$Html$text(' coupon discount')
                        ])),
                        _Utils_cmp(couponDiscountMonths, periodInMonths) < 0 ? A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('('),
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt(couponDiscountInCents / couponDiscountMonths | 0)),
                            $elm$html$Html$text(') off for '),
                            $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', couponDiscountMonths))
                        ])) : $author$project$Utils$Html$empty
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$BillsOverview$viewBillsOverview = F2(function(_v0, model) {
        var membership = _v0.jc;
        var pendingMembership = _v0.da;
        var isNew = _v0.iZ;
        var priceCheckLoading = _v0.agm;
        var sameAsOriginal = _v0.gF;
        var upcomingAndOutstandingBills = $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership);
        var owner = $author$project$Api$Provider$Membership$One$owner(pendingMembership);
        var autopay = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$autopay, owner));
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$contentDisabled(priceCheckLoading)
        ]), $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Bills overview')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9),
                    $author$project$Ui$Form$Group$label('Autopay')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            autopay ? $elm$html$Html$text('Enabled') : $elm$html$Html$text('Disabled')
                        ]))
                    ])),
                    priceCheckLoading ? $author$project$Ui$Spinner$view(_List_fromArray([
                        $author$project$Ui$Spinner$pull(1)
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]),
            A2($elm$core$List$indexedMap, A6($author$project$Components$Membership$Form$Sections$BillsOverview$viewMembershipBill, membership, pendingMembership, isNew, sameAsOriginal, model, upcomingAndOutstandingBills), upcomingAndOutstandingBills)
        ])));
    });
    var $author$project$Components$Membership$Form$Sections$BillsOverview$view = F2(function(shared, model) {
        return $elm$core$List$isEmpty($author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(shared.da)) ? $author$project$Utils$Html$empty : A2($author$project$Components$Membership$Form$Sections$BillsOverview$viewBillsOverview, shared, model);
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts = {
        $: 2
    };
    var $author$project$Api$Provider$Membership$One$firstContract = function(_v0) {
        var record = _v0.b;
        return record.PM;
    };
    var $author$project$Api$Provider$MembershipContract$Shared$isUpcoming = function(_v0) {
        var record = _v0;
        return record.Sy;
    };
    var $author$project$Api$Provider$MembershipContract$All$endDate = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$MembershipContract$Shared$endDate(shared);
    };
    var $author$project$Api$Provider$MembershipContract$Shared$memo = function(_v0) {
        var record = _v0;
        return record.ae0;
    };
    var $author$project$Api$Provider$MembershipContract$All$memo = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$MembershipContract$Shared$memo(shared);
    };
    var $author$project$Api$Provider$MembershipContract$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$MembershipContract$All$startDate = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$MembershipContract$Shared$startDate(shared);
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$CancelContract = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract = F7(function(canCancel, isNew, membership, period, startDate, endDate, memo) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Contract period ' + $elm$core$String$fromInt(period))
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), startDate))),
                $elm$html$Html$text(' - '),
                A3($author$project$Ui$Tooltip$view, _List_fromArray([
                    $author$project$Ui$Tooltip$placement(0)
                ]), memo, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$gray,
                        $author$project$Ui$Typography$ellipsis
                    ]), _List_fromArray([
                        $elm$html$Html$text(memo)
                    ]))
                ])),
                function() {
                    var _v0 = _Utils_Tuple2(canCancel, isNew);
                    if (_v0.a && _v0.b) return A3($author$project$Ui$Button$view, {
                        abP: 'Cancel contract'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$CancelContract($author$project$Api$Provider$Membership$One$id(membership)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Cancel contract')
                    ]));
                    else return $author$project$Utils$Html$empty;
                }(),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), endDate)))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractAll = F6(function(membershipContracts, canCancel, isNew, membership, index, membershipContract) {
        if (!index || _Utils_eq(index, $elm$core$List$length(membershipContracts) - 1)) return $author$project$Utils$Html$empty;
        else {
            var startDate = $author$project$Api$Provider$MembershipContract$All$startDate(membershipContract);
            var memo = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$MembershipContract$All$memo(membershipContract));
            var endDate = $author$project$Api$Provider$MembershipContract$All$endDate(membershipContract);
            return A7($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract, canCancel, isNew, membership, index + 1, $elm$core$Maybe$Just(startDate), endDate, memo);
        }
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared = F5(function(canCancel, isNew, membership, period, membershipContract) {
        var startDate = A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipContract$Shared$startDate, membershipContract);
        var memo = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$memo, membershipContract));
        var endDate = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipContract$Shared$endDate, membershipContract);
        return A7($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContract, canCancel, isNew, membership, period, startDate, endDate, memo);
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$viewContracts = F4(function(showAllContracts, isNew, membership, membershipContracts) {
        var firstContract = $author$project$Api$Provider$Membership$One$firstContract(membership);
        return A2($author$project$Ui$Typography$div, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A5($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared, false, isNew, membership, 1, firstContract)
            ]),
            $elm$core$List$length(membershipContracts) > 2 && !showAllContracts ? _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9),
                    $author$project$Ui$Form$Group$label('')
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Show more contracts'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Show more')
                    ]))
                ]))
            ]) : _List_Nil,
            showAllContracts ? A2($elm$core$List$indexedMap, A4($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractAll, membershipContracts, false, isNew, membership), membershipContracts) : _List_Nil,
            function() {
                if ($elm$core$List$length(membershipContracts) > 1) {
                    var lastContract = $author$project$Api$Provider$Membership$One$lastContract(membership);
                    return _List_fromArray([
                        A5($author$project$Components$Membership$Form$Sections$Contracts$viewMembershipContractShared, A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipContract$Shared$isUpcoming, lastContract)), isNew, membership, $elm$core$List$length(membershipContracts), lastContract)
                    ]);
                } else return _List_Nil;
            }(),
            showAllContracts ? _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9),
                    $author$project$Ui$Form$Group$label('')
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Show less contracts'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$ToggleAllContracts)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Show less')
                    ]))
                ]))
            ]) : _List_Nil
        ])));
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonths = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$viewContractPeriodInMonthsField = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var periodInMonths = _v0.WA;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(4),
            $author$project$Ui$Form$Group$label('Contract period'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            $author$project$Ui$Form$PeriodInMonthsInput$view({
                fK: A2($author$project$Utils$Form$validationErrors, 1, form),
                q2: A2($author$project$Utils$Form$hasValidationErrors, 1, form),
                afE: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$PeriodInMonths),
                aa9: periodInMonths
            })
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$Type = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Meta$contractTypeValues = function(_v0) {
        var meta = _v0;
        return meta.EW.pc;
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$typeOptions = function(membershipMeta) {
        var types = $author$project$Api$Provider$Membership$Meta$contractTypeValues(membershipMeta);
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose an action'), A2($elm$core$List$map, function(type_) {
            var typeString = $author$project$Api$ContractType$toString(type_);
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(typeString), $author$project$Formatters$String$titleize($author$project$Formatters$String$humanize(typeString)));
        }, types));
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$viewContractTypeField = F2(function(membershipMeta, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var type_ = _v0.ah5;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(4),
            $author$project$Ui$Form$Group$label('At End Of Period'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Api$ContractType$toString, type_)),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$Type)),
                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
            ]), $author$project$Components$Membership$Form$Sections$Contracts$typeOptions(membershipMeta))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$EndDate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Meta$contractEndDateValues = function(_v0) {
        var meta = _v0;
        return meta.wV.pc;
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$validContractEndDates = function(pendingMembership) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        var contractEndDates = $author$project$Api$Provider$Membership$Meta$contractEndDateValues(membershipMeta);
        var contractEndDate = function() {
            var _v1 = $author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership);
            if (!_v1.$) {
                var date = _v1.a;
                return $elm$core$Maybe$Just(date);
            } else return $author$project$Api$Provider$Membership$Meta$contractEndDateDefault(membershipMeta);
        }();
        return A2($elm$core$List$sortBy, $justinmimbs$date$Date$toRataDie, function() {
            if (!contractEndDate.$) {
                var date = contractEndDate.a;
                return A2($elm$core$List$member, date, contractEndDates) ? contractEndDates : A2($elm$core$List$cons, date, contractEndDates);
            } else return contractEndDates;
        }());
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$endDatesOptions = function(pendingMembership) {
        return A2($elm$core$List$map, function(date) {
            var dateString = $justinmimbs$date$Date$toIsoString(date);
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(dateString), A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date));
        }, $author$project$Components$Membership$Form$Sections$Contracts$validContractEndDates(pendingMembership));
    };
    var $author$project$Api$Provider$Membership$One$finalBillingEndDate = function(_v0) {
        var record = _v0.b;
        return record.PI;
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$viewEndDateField = F3(function(pendingMembership, editEndDate, form) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Contract End Date')
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, function() {
                if (!editEndDate && $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership)) {
                    var meta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
                    var contractEndDate = function() {
                        var _v0 = _Utils_Tuple2($author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership), $author$project$Api$Provider$Membership$Meta$contractEndDateDefault(meta));
                        if (!_v0.a.$) {
                            var date = _v0.a.a;
                            return $elm$core$Maybe$Just(date);
                        } else {
                            var _v1 = _v0.a;
                            var contractEndDateDefault = _v0.b;
                            return contractEndDateDefault;
                        }
                    }();
                    return _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), contractEndDate))),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Change contract end date'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$pull(1),
                                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate($author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership)))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Change Contract End Date')
                                ]))
                            ]))
                        ]))
                    ]);
                } else {
                    var _v2 = $author$project$Utils$Form$fields(form);
                    var endDate = _v2.qv;
                    return _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(5)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, endDate)),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$EndDate))
                            ]), $author$project$Components$Membership$Form$Sections$Contracts$endDatesOptions(pendingMembership))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(7)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: ' Cancel end date edition'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Contracts$ToggleEditEndDate($author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership)))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Cancel')
                            ]))
                        ]))
                    ]);
                }
            }()),
            !_Utils_eq($author$project$Api$Provider$Membership$One$finalBillingEndDate(pendingMembership), $author$project$Api$Provider$Membership$One$contractEndDate(pendingMembership)) ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$label, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('Contract end date does not align with the billing periods')
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$Expires = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$viewExpiresField = function(form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var expires = _v0.Pg;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Contract Expires')
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(expires),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Contracts$FormUpdated, $author$project$Components$Membership$Form$Sections$Contracts$Expires))
            ]))
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$Contracts$viewForm = F3(function(model, pendingMembership, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var expires = _v0.Pg;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Components$Membership$Form$Sections$Contracts$viewExpiresField(form),
            function() {
                if (expires) {
                    var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
                    return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                        $author$project$Api$Provider$Membership$Meta$contractEndDateEditable(membershipMeta) ? A3($author$project$Components$Membership$Form$Sections$Contracts$viewEndDateField, pendingMembership, model.iv, form) : $author$project$Utils$Html$empty,
                        $author$project$Api$Provider$Membership$Meta$contractPeriodInMonthsEditable(membershipMeta) ? $author$project$Components$Membership$Form$Sections$Contracts$viewContractPeriodInMonthsField(form) : $author$project$Utils$Html$empty,
                        $author$project$Api$Provider$Membership$Meta$contractTypeEditable(membershipMeta) ? A2($author$project$Components$Membership$Form$Sections$Contracts$viewContractTypeField, membershipMeta, form) : $author$project$Utils$Html$empty
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Contracts$view = F2(function(_v0, _v1) {
        var isNew = _v0.iZ;
        var membership = _v0.jc;
        var pendingMembership = _v0.da;
        var model = _v1;
        var plan = $author$project$Api$Provider$Membership$One$plan(membership);
        var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        if (($author$project$Api$Provider$Plan$SharedWithContractInfo$contractExpires(plan) || $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership)) && $author$project$Api$Provider$Membership$Meta$contractExpiresEditable(pendingMembershipMeta)) {
            var membershipContracts = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(model.y$));
            var fields = $author$project$Utils$Form$fields(model.PU);
            return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Contract Periods')
                ])),
                A3($author$project$Components$Membership$Form$Sections$Contracts$viewForm, model, pendingMembership, model.PU),
                fields.Pg && !$elm$core$List$isEmpty(membershipContracts) && $author$project$Api$Provider$Membership$One$contractExpires(pendingMembership) ? A4($author$project$Components$Membership$Form$Sections$Contracts$viewContracts, model.sO, isNew, membership, membershipContracts) : $author$project$Utils$Html$empty
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Membership$Form$Sections$Members$AddMember = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Sections$Members$membershipPatientSortValue = F2(function(membership, _v0) {
        var originalIndex = _v0.a;
        var membershipPatient = _v0.b;
        var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
        var original = A2($elm_community$list_extra$List$Extra$find, function(membershipPatient_) {
            return _Utils_eq($author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_), membershipPatientRecord.aef);
        }, $author$project$Api$Provider$Membership$One$membershipPatients(membership));
        var _v1 = function() {
            if (!original.$) {
                var original_ = original.a;
                return _Utils_Tuple2($elm$core$Maybe$Nothing, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$endDate(original_));
            } else return _Utils_Tuple2(membershipPatientRecord.D7, membershipPatientRecord.qv);
        }();
        var action = _v1.a;
        var endDate = _v1.b;
        return _Utils_eq(action, $elm$core$Maybe$Just('create')) ? _Utils_Tuple2(4, originalIndex) : _Utils_eq(action, $elm$core$Maybe$Just('restart')) ? _Utils_Tuple2(1, originalIndex) : _Utils_eq(action, $elm$core$Maybe$Just('terminate')) || _Utils_eq(action, $elm$core$Maybe$Just('destroy')) ? _Utils_Tuple2(2, originalIndex) : !$author$project$Utils$Maybe$toBool(endDate) ? _Utils_Tuple2(0, originalIndex) : _Utils_Tuple2(3, originalIndex);
    });
    var $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient = function(_v0) {
        var meta = _v0;
        return meta.T$.V7;
    };
    var $author$project$Components$Membership$Form$Sections$Members$overMaxMembershipPatientsWarning = F2(function(maxMembershipPatients, membershipPatients) {
        return _Utils_cmp($elm$core$Dict$size(membershipPatients), maxMembershipPatients) > 0 ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
            $elm$html$Html$text('This sponsored membership '),
            function() {
                if (maxMembershipPatients === 1) return $elm$html$Html$text('does not allow dependents');
                else return $elm$html$Html$text('only allows ' + A2($author$project$Formatters$String$pluralize, 'dependent', maxMembershipPatients - 1));
            }(),
            $elm$html$Html$text(', by saving this membership you are choosing to exceed that limit.')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Ui$Typography$Inactive = function(a) {
        return {
            $: 34,
            a: a
        };
    };
    var $author$project$Ui$Typography$inactive = $author$project$Ui$Typography$Inactive;
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$isMcePlan(shared);
    };
    var $author$project$Api$Provider$Membership$One$isSynced = function(_v0) {
        var record = _v0.b;
        return record.Su;
    };
    var $author$project$Components$CancellationReason$Display$view = F2(function(cancellationReason, cancellationReasonOther) {
        var isTerminatedByPatient = cancellationReason.NQ === 'Termination by Patient';
        var patientNoteView = isTerminatedByPatient ? A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$small,
            $author$project$Ui$Typography$muted
        ]), _List_fromArray([
            $elm$html$Html$text('\"' + (A2($elm$core$Maybe$withDefault, '', cancellationReasonOther) + '\"'))
        ])) : $author$project$Utils$Html$empty;
        var descriptionText = function() {
            if (isTerminatedByPatient) return 'Termination by Patient';
            else {
                var _v0 = _Utils_Tuple2(cancellationReason.NQ, cancellationReasonOther);
                if (_v0.a === 'Other' && !_v0.b.$) {
                    var customReason = _v0.b.a;
                    return customReason;
                } else return cancellationReason.NQ;
            }
        }();
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                $elm$html$Html$text(descriptionText),
                patientNoteView
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReason = F2(function(membershipPatient, cancellationReason) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Cancellation Reason')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Components$CancellationReason$Display$view, cancellationReason, membershipPatient.aca)
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReason = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReasonInput = F3(function(cancellationReasons, membershipPatient, model) {
        return $author$project$Components$CancellationReason$Input$view({
            acb: cancellationReasons,
            fK: A2($author$project$Utils$Form$validationErrors, 7, model.PU),
            O6: A2($author$project$Utils$Form$validationErrors, 8, model.PU),
            aeJ: $elm$core$Maybe$Just(3),
            afv: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$CancellationReason),
            aa9: _Utils_Tuple2(membershipPatient.ab9, membershipPatient.aca)
        });
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewEndDateInput = F3(function(pendingMembership, membershipPatient, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('End date'),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$Members$MembershipPatient$EndDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                $author$project$Components$DateInput$value(membershipPatient.qv),
                $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 6, model.PU)),
                $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 6, model.PU))
            ]), model.qx)),
            $author$project$Utils$Maybe$toBool(membershipPatient.PL) && !_Utils_eq(membershipPatient.qv, model.GK.qv) ? A3($author$project$Components$Membership$Form$Utils$mayNeedProrationWarning, 'patient', pendingMembership, membershipPatient.qv) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$EditEnrollmentRequestedOn = {
        $: 4
    };
    var $author$project$Api$Provider$Membership$Meta$membershipPatientsEnrollmentRequestedOn = function(_v0) {
        var meta = _v0;
        return meta.T$.O_;
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewEnrollmentRequestedOnInput = F4(function(membership, isPatientActive, membershipPatient, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Enrollment Requested')
        ]), _List_fromArray([
            function() {
                if (model.qp) return A2($elm$html$Html$map, $author$project$Components$Membership$Form$Members$MembershipPatient$EnrollmentRequestedOnInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(membershipPatient.O_),
                    $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, model.PU)),
                    $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 2, model.PU))
                ]), model.qB));
                else {
                    var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
                    var enrollmentRequestedOnIsEditable = !model.aO && $author$project$Api$Provider$Membership$Meta$membershipPatientsEnrollmentRequestedOn(membershipMeta);
                    return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), membershipPatient.O_))),
                        isPatientActive && enrollmentRequestedOnIsEditable ? A3($author$project$Ui$Button$view, {
                            abP: 'Change enrollment requested on date'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$EditEnrollmentRequestedOn)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Change Date')
                        ])) : $author$project$Utils$Html$empty
                    ]));
                }
            }()
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCents = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$ToggleFixedPeriodRateInCentsOverride = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$billAffiliateRateEnabled = F2(function(practice, company) {
        var ratesFromAffiliate = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$ratesFromAffiliate, $author$project$Api$Provider$Practice$One$network(practice)));
        var billAffiliateRateCompanySetting = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$billAffiliateRate, company));
        return ratesFromAffiliate && billAffiliateRateCompanySetting;
    });
    var $author$project$Api$Provider$Membership$Meta$membershipPatientsFixedPeriodRateInCents = function(_v0) {
        var meta = _v0;
        return meta.T$.PP;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$revenueInCents = function(_v0) {
        var record = _v0.b;
        return record.Y1;
    };
    var $author$project$Formatters$Int$asPeriodHuman = function(periodInMonths) {
        switch(periodInMonths){
            case 1:
                return 'Monthly';
            case 3:
                return 'Quarterly';
            case 6:
                return 'Semi-annually';
            case 12:
                return 'Annually';
            default:
                return 'Every ' + ($elm$core$String$fromInt(periodInMonths) + ' Months');
        }
    };
    var $author$project$Components$FixedRate$view = F3(function(_v0, onInput, toggleEdit) {
        var editable = _v0.Ot;
        var disabled = _v0.d$;
        var editing = _v0.w;
        var current = _v0.MJ;
        var period = _v0.aga;
        var value = _v0.aa9;
        var billAffiliateRate = _v0.Kb;
        var defaultValue = _v0.NE;
        var errors = _v0.fK;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                editing ? A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                        $author$project$Ui$Form$CurrencyInput$value(value),
                        $author$project$Ui$Form$CurrencyInput$onInput(onInput),
                        $author$project$Ui$Form$CurrencyInput$invalid(!$elm$core$List$isEmpty(errors)),
                        $author$project$Ui$Form$CurrencyInput$placeholder('10.00')
                    ])),
                    $author$project$Utils$FormErrors$view(errors)
                ])) : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Currency$format(A2($elm$core$Maybe$withDefault, $author$project$Currency$fromInt(0), defaultValue))),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Formatters$Int$asPeriodHuman(period))
                ]))
            ])),
            editable ? A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(6),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                function() {
                    var verb = editing ? 'Remove Override' : 'Override Rate';
                    return A3($author$project$Ui$Button$view, {
                        abP: verb
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick(toggleEdit),
                        $author$project$Ui$Button$disabled(!editing && disabled)
                    ]), _List_fromArray([
                        $elm$html$Html$text(verb)
                    ]));
                }()
            ])) : $author$project$Ui$Grid$none,
            function() {
                if (!current.$) return A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Fixed price ('),
                        $elm$html$Html$text($author$project$Formatters$Int$asPeriodHuman(period)),
                        $elm$html$Html$text(')')
                    ]))
                ]));
                else return $author$project$Ui$Grid$none;
            }(),
            !editable || $author$project$Utils$Maybe$toBool(current) ? $author$project$Ui$Grid$none : billAffiliateRate ? A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Automatically calculated using Affiliate Rate')
                ]))
            ])) : A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(12)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpBlock
                ]), _List_fromArray([
                    $elm$html$Html$text('Automatically calculated')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewFixedPeriodRateInput = F5(function(_v0, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
        var membership = _v0.jc;
        var pendingMembership = _v0.da;
        var onlyOneFixedPeriodRateInCentsEditable = _v0.afT;
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var fixedPeriodRateInCentsIsEditable = !model.aO && $author$project$Api$Provider$Membership$Meta$membershipPatientsFixedPeriodRateInCents(membershipMeta);
        var defaultValue = A2($elm$core$Maybe$map, $author$project$Currency$fromInt, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$revenueInCents, pendingMembershipPatient));
        var billAffiliateRate = A2($author$project$Components$Membership$Form$Members$MembershipPatient$billAffiliateRateEnabled, model.W1, $author$project$Api$Provider$Membership$One$company(membership));
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Rate'),
            $author$project$Ui$Form$Group$required(model.d2)
        ]), _List_fromArray([
            A3($author$project$Components$FixedRate$view, {
                Kb: billAffiliateRate,
                MJ: A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$fixedPeriodRateInCents, pendingMembershipPatient),
                NE: defaultValue,
                d$: onlyOneFixedPeriodRateInCentsEditable,
                Ot: isPatientActive && fixedPeriodRateInCentsIsEditable,
                w: model.d2,
                fK: A2($author$project$Utils$Form$validationErrors, 5, model.PU),
                aga: $author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership),
                aa9: membershipPatient.PP
            }, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$FixedPeriodRateInCents), $author$project$Components$Membership$Form$Members$MembershipPatient$ToggleFixedPeriodRateInCentsOverride(defaultValue))
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$AddNewPatient = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$Remove = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$Restart = {
        $: 0
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientInput = F8(function(practice, owner, membership, pendingMembership, activePatientsCount, isPatientActive, membershipPatient, model) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var patientIsEditable = !model.aO && $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta);
        var memberType = membershipPatient.TX;
        var isActive = !$author$project$Utils$Maybe$toBool(membershipPatient.Ox);
        var humanMemberType = $author$project$Api$Provider$Practice$One$usesSponsors(practice) && !memberType ? 'primary member' : memberType === 1 ? 'adult' : $author$project$Api$MemberRelationship$toString(memberType);
        var canRestartPatient = isPatientActive || !$author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta) || !memberType ? false : $author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Meta$CompanyRegistration$enrollAction, A2($elm$core$Maybe$map, function($) {
            return $.Ue;
        }, membershipPatient.LP))) : true;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label($author$project$Formatters$String$titleize(humanMemberType))
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(9)
                ]), _List_fromArray([
                    function() {
                        var _v0 = membershipPatient.V7;
                        if (!_v0.$) {
                            var patient = _v0.a;
                            return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: patient.aef
                                }), _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$phi(true)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(patient.zr)
                                    ]))
                                ]))
                            ]));
                        } else return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$view, _List_fromArray([
                                $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                                $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU))
                            ]), model.rX)),
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small
                            ]), _List_fromArray([
                                $elm$html$Html$text(' or '),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Add a new patient'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$size(0),
                                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$AddNewPatient(owner))
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add a new patient')
                                ]))
                            ]))
                        ]));
                    }(),
                    isActive || model.aO ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Member from '),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), membershipPatient._0))),
                        $elm$html$Html$text(' to '),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), membershipPatient.Ox)))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        canRestartPatient ? A3($author$project$Ui$Button$view, {
                            abP: 'Restart patient'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$Restart)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Restart Patient')
                        ])) : $author$project$Utils$Html$empty,
                        function() {
                            if ((isPatientActive || model.aO) && patientIsEditable && !!memberType) {
                                var removeError = !membershipPatient.TX ? $elm$core$Maybe$Just('You cannot remove the employee from a sponsored membership.') : activePatientsCount === 1 ? $elm$core$Maybe$Just('You can\'t remove the only patient on a membership. Please add another patient first, or if you\'d like to just end the membership, you can click that button below.') : $elm$core$Maybe$Nothing;
                                var endDate = A2($elm_community$list_extra$List$Extra$maximumBy, $justinmimbs$date$Date$toRataDie, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                                    membershipPatient._0,
                                    $author$project$Api$Provider$Membership$Meta$endDateDefaultValue(membershipMeta)
                                ])));
                                return A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                    $author$project$Ui$Tooltip$placement(0),
                                    $author$project$Ui$Tooltip$active($author$project$Utils$Maybe$toBool(removeError))
                                ]), A2($elm$core$Maybe$withDefault, '', removeError), _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Remove patient'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$Remove(endDate)),
                                        $author$project$Ui$Button$disabled($author$project$Utils$Maybe$toBool(removeError))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Remove Patient')
                                    ]))
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobacco = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$patientUsesTobaccoOptions = _List_fromArray([
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose an option'),
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Utils$Bool$toString(true)), 'Uses tobacco'),
        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Utils$Bool$toString(false)), 'Does not use tobacco')
    ]);
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientUsesTobaccoInput = F3(function(pendingMembershipPatient, patient, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Tobacco use'),
            $author$project$Ui$Form$Group$required(model.d3)
        ]), _List_fromArray([
            model.d3 ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Utils$Bool$toString, patient.aa4)),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$PatientUsesTobacco)),
                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, model.PU)),
                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 1, model.PU))
            ]), $author$project$Components$Membership$Form$Members$MembershipPatient$patientUsesTobaccoOptions) : A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$patient, $author$project$Api$Provider$Patient$SharedWithMinPractitionerAndLocation$usesTobacco), pendingMembershipPatient)) ? $elm$html$Html$text('Uses tobacco') : $elm$html$Html$text('Does not use tobacco')
            ]))
        ]));
    });
    var $author$project$Api$Plan$ProviderSharedWithContractInfo = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRate = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$ToggleSpecialRateOverride = {
        $: 8
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$discountRule = function(_v0) {
        var record = _v0.b;
        return record.N1;
    };
    var $author$project$Api$Provider$Membership$Meta$membershipPatientsSpecialRate = function(_v0) {
        var meta = _v0;
        return meta.T$._L;
    };
    var $author$project$Api$Provider$DiscountRule$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$MembershipPatient$ForMembershipOne$rateRule = function(_v0) {
        var record = _v0.b;
        return record.X7;
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$specialRateOptions = F2(function(periodInMonths, specialRates) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'Choose an option'), A2($elm$core$List$map, function(specialRate) {
            var amountInCents = A2($elm$core$Maybe$withDefault, 0, function() {
                switch(periodInMonths){
                    case 1:
                        return $author$project$Api$Provider$SpecialRate$Shared$monthAmountInCents(specialRate);
                    case 3:
                        return $author$project$Api$Provider$SpecialRate$Shared$quarterAmountInCents(specialRate);
                    case 6:
                        return $author$project$Api$Provider$SpecialRate$Shared$semiAnnualAmountInCents(specialRate);
                    case 12:
                        return $author$project$Api$Provider$SpecialRate$Shared$annualAmountInCents(specialRate);
                    default:
                        return $elm$core$Maybe$Nothing;
                }
            }());
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$SpecialRate$Shared$id(specialRate)), $author$project$Api$Provider$SpecialRate$Shared$name(specialRate) + (' - ' + ($author$project$Utils$Currency$fromInt(amountInCents) + (' ' + $author$project$Formatters$Int$asPeriod(periodInMonths)))));
        }, A2($elm$core$List$sortBy, $author$project$Api$Provider$SpecialRate$Shared$name, specialRates)));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewSpecialRateInput = F6(function(membership, pendingMembership, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
        var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(pendingMembership);
        var planHasSpecialRates = !$elm$core$List$isEmpty($author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(pendingMembershipPlan));
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var specialRateIsEditable = !model.aO && $author$project$Api$Provider$Membership$Meta$membershipPatientsSpecialRate(membershipMeta);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Rule'),
            $author$project$Ui$Form$Group$required(model.eg)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) === 4 ? _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, $author$project$Components$Plan$Summary$Percentage$view($author$project$Api$Plan$ProviderSharedWithContractInfo(pendingMembershipPlan)))
                ]) : _List_fromArray([
                    function() {
                        if (model.eg) {
                            var specialRates = $author$project$Api$Provider$Plan$SharedWithContractInfo$specialRates(pendingMembershipPlan);
                            return A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value(membershipPatient._L),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Members$MembershipPatient$FormUpdated, $author$project$Components$Membership$Form$Members$MembershipPatient$SpecialRate), $author$project$Utils$String$toMaybe)),
                                $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 4, model.PU)),
                                $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 4, model.PU)),
                                $author$project$Ui$Form$Select$loading($elm$core$List$isEmpty(specialRates))
                            ]), A2($author$project$Components$Membership$Form$Members$MembershipPatient$specialRateOptions, $author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership), specialRates));
                        } else {
                            var ruleDescription = function() {
                                if ($author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) === 1) return 'Fixed Fee';
                                else {
                                    var rateRuleName = A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$RateRule$Min$name, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$rateRule, pendingMembershipPatient)));
                                    var discountRuleDescription = function() {
                                        var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$DiscountRule$Min$name, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$discountRule, pendingMembershipPatient));
                                        if (!_v0.$) {
                                            var discountRuleName = _v0.a;
                                            return ' (' + (discountRuleName + ' discount)');
                                        } else return '';
                                    }();
                                    return _Utils_ap(rateRuleName, discountRuleDescription);
                                }
                            }();
                            return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(ruleDescription)
                            ]));
                        }
                    }()
                ])),
                $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) !== 4 && isPatientActive && planHasSpecialRates && specialRateIsEditable ? A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        function() {
                            var label = model.eg ? 'Remove Override' : 'Override Rule';
                            return A3($author$project$Ui$Button$view, {
                                abP: label
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$ToggleSpecialRateOverride)
                            ]), _List_fromArray([
                                $elm$html$Html$text(label)
                            ]));
                        }()
                    ]))
                ])) : $author$project$Ui$Grid$none
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$EditStartDate = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Meta$membershipPatientsStartDate = function(_v0) {
        var meta = _v0;
        return meta.T$._0;
    };
    var $author$project$Components$Membership$Form$Members$MembershipPatient$viewStartDateInput = F6(function(membership, pendingMembership, pendingMembershipPatient, isPatientActive, membershipPatient, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Membership Start Date')
        ]), function() {
            if (model.qq) {
                var min = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
                var max = A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Membership$One$billFromDate(pendingMembership), membershipPatient.PL);
                return _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Membership$Form$Members$MembershipPatient$StartDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                        $author$project$Components$DateInput$value(membershipPatient._0),
                        $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, model.PU)),
                        $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 3, model.PU)),
                        $author$project$Components$DateInput$disabledPickerDates(function(date) {
                            return A2($author$project$Utils$Date$isBefore, date, min) || A2($author$project$Utils$Date$isAfter, date, max);
                        })
                    ]), model.kj)),
                    function() {
                        var _v0 = membershipPatient._0;
                        if (!_v0.$) {
                            var membershipPatientStartDate = _v0.a;
                            return A2($author$project$Utils$Date$isBefore, membershipPatientStartDate, $author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)) ? $author$project$Api$Provider$Membership$One$isSponsored(pendingMembership) ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('We will charge for this patient starting on the '),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Company$Shared$nextInvoiceDate, $author$project$Api$Provider$Membership$One$company(pendingMembership))))),
                                $elm$html$Html$text(' invoice.')
                            ])) : $author$project$Utils$Maybe$toBool(membershipPatient.PL) && !_Utils_eq(membershipPatient._0, A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate, model.GI)) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock
                            ]), _List_fromArray([
                                $elm$html$Html$text('We will continue billing this patient on '),
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Membership$One$billFromDate(pendingMembership)))
                            ])) : !$author$project$Utils$Maybe$toBool(membershipPatient.PL) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$helpBlock
                            ]), _List_fromArray([
                                $elm$html$Html$text('We will bill this patient starting on '),
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Membership$One$billFromDate(pendingMembership))),
                                $elm$html$Html$text('. If you\'d like to prorate for the period of '),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), membershipPatient._0))),
                                $elm$html$Html$text(' - '),
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Membership$One$billFromDate(pendingMembership))),
                                $elm$html$Html$text(', you can learn how to do that '),
                                A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/invoices/creating-a-prorated-membership-invoice', _List_fromArray([
                                    $author$project$Ui$Link$targetBlank
                                ]), _List_fromArray([
                                    $elm$html$Html$text('here')
                                ])),
                                $elm$html$Html$text('.')
                            ])) : $author$project$Utils$Html$empty : $author$project$Utils$Html$empty;
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]);
            } else {
                var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
                var startDateIsEditable = !model.aO && $author$project$Api$Provider$Membership$Meta$membershipPatientsStartDate(membershipMeta);
                return _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), membershipPatient._0))),
                        isPatientActive && startDateIsEditable ? A3($author$project$Ui$Button$view, {
                            abP: 'Change start date'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Members$MembershipPatient$EditStartDate(A2($elm$core$Maybe$map, $author$project$Api$Provider$MembershipPatient$ForMembershipOne$startDate, pendingMembershipPatient)))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Change Date')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]);
            }
        }());
    });
    var $author$project$Components$Membership$Form$Members$MembershipPatient$view = F5(function(practice, sectionsShared, cancellationReasons, activePatientsCount, _v0) {
        var model = _v0;
        var membershipPatient = $author$project$Utils$Form$fields(model.PU);
        var isPatientActive = !$author$project$Utils$Maybe$toBool(membershipPatient.qv);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A8($author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientInput, practice, sectionsShared.VM, sectionsShared.jc, sectionsShared.da, activePatientsCount, isPatientActive, membershipPatient, model),
            function() {
                var _v1 = membershipPatient.V7;
                if (!_v1.$) {
                    var patient = _v1.a;
                    var showTobaccoUsage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice) && $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Plan$SharedWithContractInfo$tobaccoSurchargeType($author$project$Api$Provider$Membership$One$plan(sectionsShared.da)));
                    var pendingMembershipPatient = A2($elm_community$list_extra$List$Extra$find, function(membershipPatient_) {
                        return _Utils_eq($author$project$Api$Provider$MembershipPatient$ForMembershipOne$id(membershipPatient_), membershipPatient.aef);
                    }, $author$project$Api$Provider$Membership$One$membershipPatients(sectionsShared.da));
                    var isTerminated = $author$project$Utils$Maybe$toBool(membershipPatient.qv) && !_Utils_eq(membershipPatient.D7, $elm$core$Maybe$Just('terminate')) && !_Utils_eq(membershipPatient.D7, $elm$core$Maybe$Just('destroy'));
                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$inactive(!isPatientActive)
                    ]), _List_fromArray([
                        showTobaccoUsage ? A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewPatientUsesTobaccoInput, pendingMembershipPatient, patient, model) : $author$project$Utils$Html$empty,
                        function() {
                            var _v2 = _Utils_Tuple2(!isPatientActive && !model.aO, membershipPatient.ab9);
                            if (_v2.a && !_v2.b.$) {
                                var cancellationReason = _v2.b.a;
                                return A2($author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReason, membershipPatient, cancellationReason);
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        function() {
                            if (!isTerminated && ($author$project$Api$Provider$Membership$One$isUpdatable(sectionsShared.da) || $author$project$Api$Provider$Membership$One$isSynced(sectionsShared.da))) {
                                var pendingMembershipPlan = $author$project$Api$Provider$Membership$One$plan(sectionsShared.da);
                                return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    A4($author$project$Components$Membership$Form$Members$MembershipPatient$viewEnrollmentRequestedOnInput, sectionsShared.jc, isPatientActive, membershipPatient, model),
                                    A6($author$project$Components$Membership$Form$Members$MembershipPatient$viewStartDateInput, sectionsShared.jc, sectionsShared.da, pendingMembershipPatient, isPatientActive, membershipPatient, model),
                                    !$author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan(pendingMembershipPlan) ? A6($author$project$Components$Membership$Form$Members$MembershipPatient$viewSpecialRateInput, sectionsShared.jc, sectionsShared.da, pendingMembershipPatient, isPatientActive, membershipPatient, model) : $author$project$Utils$Html$empty,
                                    !$author$project$Api$Provider$Plan$SharedWithContractInfo$isMcePlan(pendingMembershipPlan) && $author$project$Api$Provider$Plan$SharedWithContractInfo$planType(pendingMembershipPlan) !== 1 ? A5($author$project$Components$Membership$Form$Members$MembershipPatient$viewFixedPeriodRateInput, sectionsShared, pendingMembershipPatient, isPatientActive, membershipPatient, model) : $author$project$Utils$Html$empty
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            model.aO ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewEndDateInput, sectionsShared.da, membershipPatient, model),
                A3($author$project$Components$Membership$Form$Members$MembershipPatient$viewCancellationReasonInput, cancellationReasons, membershipPatient, model)
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Members$viewMembershipPatient = F8(function(practice, sectionsShared, cancellationReasons, lastIndex, canEditMembershipPatients, activePatientsCount, index, _v0) {
        var membershipPatient = _v0.b;
        var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Members$MembershipPatientMsg(membershipPatientRecord.aef), A5($author$project$Components$Membership$Form$Members$MembershipPatient$view, practice, sectionsShared, cancellationReasons, activePatientsCount, membershipPatient)),
            !_Utils_eq(index, lastIndex) || canEditMembershipPatients ? A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(11),
                    $author$project$Ui$Grid$offset(1)
                ]), _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil)
                ]))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Members$viewMembershipPatients = F5(function(sectionsShared, cancellationReasons, canEditMembershipPatients, membershipPatients, model) {
        var lastIndex = $elm$core$List$length(membershipPatients) - 1;
        var activePatientsCount = A2($elm_community$list_extra$List$Extra$count, function(_v0) {
            var membershipPatient = _v0.b;
            var membershipPatientRecord = $author$project$Components$Membership$Form$Members$MembershipPatient$membershipPatientFields(membershipPatient);
            return !$author$project$Utils$Maybe$toBool(membershipPatientRecord.qv);
        }, membershipPatients);
        return A2($elm$core$List$indexedMap, A6($author$project$Components$Membership$Form$Sections$Members$viewMembershipPatient, model.W1, sectionsShared, cancellationReasons, lastIndex, canEditMembershipPatients, activePatientsCount), membershipPatients);
    });
    var $author$project$Components$Membership$Form$Sections$Members$view = F3(function(sectionsShared, cancellationReasons, model) {
        var membershipPatients = A2($elm$core$List$sortBy, $author$project$Components$Membership$Form$Sections$Members$membershipPatientSortValue(sectionsShared.jc), $elm$core$Dict$values(model.T$));
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(sectionsShared.jc);
        var canEditMembershipPatients = $author$project$Api$Provider$Membership$Meta$membershipPatientsPatient(membershipMeta);
        return A2($author$project$Ui$Typography$div, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Members')
                ]))
            ]),
            A5($author$project$Components$Membership$Form$Sections$Members$viewMembershipPatients, sectionsShared, cancellationReasons, canEditMembershipPatients, membershipPatients, model),
            function() {
                if (canEditMembershipPatients) {
                    var startDate = $author$project$Api$Provider$Membership$One$billedThroughDate(sectionsShared.da);
                    return _List_fromArray([
                        function() {
                            var _v0 = model.Gi;
                            if (!_v0.$) {
                                var maxMembershipPatients = _v0.a;
                                return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(11),
                                        $author$project$Ui$Grid$offset(1)
                                    ]), _List_fromArray([
                                        A2($author$project$Components$Membership$Form$Sections$Members$overMaxMembershipPatientsWarning, maxMembershipPatients, model.T$)
                                    ]))
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(9),
                                $author$project$Ui$Grid$offset(3)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$gap2
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Add adult'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$onClick(A2($author$project$Components$Membership$Form$Sections$Members$AddMember, 1, startDate)),
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Add Adult')
                                    ])),
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Add child'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$onClick(A2($author$project$Components$Membership$Form$Sections$Members$AddMember, 2, startDate)),
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Add Child')
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]);
                } else return _List_Nil;
            }()
        ])));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$Add = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$Remove = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Membership$Meta$membershipScheduledChangeEditable = function(_v0) {
        var meta = _v0;
        return meta.T3.Ot;
    };
    var $author$project$Ui$Tooltip$Pull = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Tooltip$pull = $author$project$Ui$Tooltip$Pull;
    var $author$project$Api$Provider$Membership$One$scheduledChange = function(_v0) {
        var record = _v0.b;
        return record.Zv;
    };
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$changeAfterMonths = function(_v0) {
        var record = _v0;
        return record.K2;
    };
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$changeOnDate = function(_v0) {
        var record = _v0;
        return record.K3;
    };
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$effectiveDate = function(_v0) {
        var record = _v0;
        return record.Ow;
    };
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$toPlan = function(_v0) {
        var record = _v0;
        return record.$5;
    };
    var $author$project$Api$Provider$MembershipScheduledChange$Shared$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Components$Membership$Form$Sections$PlanChange$viewScheduledChange = F2(function(contractPeriodInMonths, scheduledChange) {
        var type_ = $author$project$Api$Provider$MembershipScheduledChange$Shared$type_(scheduledChange);
        var effectiveDate = $author$project$Api$Provider$MembershipScheduledChange$Shared$effectiveDate(scheduledChange);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$label('Status')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Scheduled')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$label('Effective date')
            ]), _List_fromArray([
                function() {
                    switch(type_){
                        case 2:
                            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', A2($elm$core$Maybe$withDefault, 0, contractPeriodInMonths))),
                                $elm$html$Html$text(' ('),
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, effectiveDate)),
                                $elm$html$Html$text(')')
                            ]));
                        case 1:
                            var changeAfterMonths = $author$project$Api$Provider$MembershipScheduledChange$Shared$changeAfterMonths(scheduledChange);
                            return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', A2($elm$core$Maybe$withDefault, 0, changeAfterMonths))),
                                    $elm$html$Html$text(' ('),
                                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, effectiveDate)),
                                    $elm$html$Html$text(')')
                                ]))
                            ]));
                        default:
                            var changeOnDate = $author$project$Api$Provider$MembershipScheduledChange$Shared$changeOnDate(scheduledChange);
                            return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), changeOnDate)))
                            ]));
                    }
                }()
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$label('New plan')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Plan$Shared$name, $author$project$Api$Provider$MembershipScheduledChange$Shared$toPlan(scheduledChange))))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$PlanChange$view = F3(function(_v0, contract, _v1) {
        var membership = _v0.jc;
        var pendingMembership = _v0.da;
        var model = _v1;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Plan Change')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(7)
                ]), function() {
                    var _v2 = $author$project$Api$Provider$Membership$One$scheduledChange(pendingMembership);
                    if (!_v2.$) {
                        var scheduledChange = _v2.a;
                        var buttonOption = function() {
                            var _v3 = model.y0;
                            if (!_v3.$) {
                                var membershipId = _v3.a;
                                return $author$project$Ui$Button$onClick(A2($author$project$Components$Membership$Form$Sections$PlanChange$Remove, membershipId, scheduledChange));
                            } else return $author$project$Ui$Button$disabled(true);
                        }();
                        return _List_fromArray([
                            A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                $author$project$Ui$Tooltip$placement(0),
                                $author$project$Ui$Tooltip$active(model.q8),
                                $author$project$Ui$Tooltip$pull(1)
                            ]), 'This plan change is set automatically and can be removed after saving the membership.', _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Remove schedule change'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$pull(1),
                                    buttonOption
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Remove')
                                ]))
                            ]))
                        ]);
                    } else {
                        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
                        return _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceBetween
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    $elm$html$Html$text('None')
                                ])),
                                $author$project$Api$Provider$Membership$Meta$membershipScheduledChangeEditable(membershipMeta) ? A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                    $author$project$Ui$Tooltip$placement(0),
                                    $author$project$Ui$Tooltip$active(model.q8),
                                    $author$project$Ui$Tooltip$pull(1)
                                ]), 'You will be able to add a plan change after the membership is created.', _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Add plan change'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                        $author$project$Ui$Button$disabled(model.q8),
                                        $author$project$Ui$Button$onClick(A2($author$project$Components$Membership$Form$Sections$PlanChange$Add, contract, membershipMeta))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Add plan change')
                                    ]))
                                ])) : $author$project$Utils$Html$empty
                            ]))
                        ]);
                    }
                }()),
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    function() {
                        var _v4 = $author$project$Api$Provider$Membership$One$scheduledChange(pendingMembership);
                        if (!_v4.$) {
                            var scheduledChange = _v4.a;
                            return A2($author$project$Components$Membership$Form$Sections$PlanChange$viewScheduledChange, contract.WA, scheduledChange);
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee = function(pendingMembership) {
        return $author$project$Api$Provider$Plan$SharedWithContractInfo$planType($author$project$Api$Provider$Membership$One$plan(pendingMembership)) === 1;
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$Coupon = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon = {
        $: 3
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$formatCoupon = F5(function(percentOff, amountOffInCents, applyToEachPatient, durationInMonths, code) {
        return function(string) {
            return A2($elm$core$String$append, string, ' (' + (code + ')'));
        }(function(string) {
            return A2($elm$core$String$append, string, function() {
                if (!durationInMonths.$) {
                    var durationInMonths_ = durationInMonths.a;
                    return ' for ' + ($elm$core$String$fromInt(durationInMonths_) + ' months');
                } else return '';
            }());
        }(function() {
            var _v0 = _Utils_Tuple2(percentOff, amountOffInCents);
            if (!_v0.a.$) {
                var percentOff_ = _v0.a.a;
                return $elm$core$String$fromFloat(percentOff_) + '% off';
            } else if (!_v0.b.$) {
                var _v1 = _v0.a;
                var amountOffInCents_ = _v0.b.a;
                return $author$project$Utils$Currency$fromInt(amountOffInCents_) + (' / ' + (applyToEachPatient ? 'patient' : 'membership'));
            } else {
                var _v2 = _v0.a;
                var _v3 = _v0.b;
                return '';
            }
        }()));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$formatCouponAll = function(coupon) {
        return A5($author$project$Components$Membership$Form$Sections$Pricing$formatCoupon, $author$project$Api$Provider$Coupon$All$percentOff(coupon), $author$project$Api$Provider$Coupon$All$amountOffInCents(coupon), $author$project$Api$Provider$Coupon$All$applyToEachPatient(coupon), $author$project$Api$Provider$Coupon$All$durationInMonths(coupon), $author$project$Api$Provider$Coupon$All$code(coupon));
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$couponOptions = function(coupons) {
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), 'None'), A2($elm$core$List$map, function(coupon) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$Coupon$All$id(coupon)), $author$project$Components$Membership$Form$Sections$Pricing$formatCouponAll(coupon));
        }, coupons));
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$formatCouponShared = function(coupon) {
        if (!coupon.$) {
            var coupon_ = coupon.a;
            return A5($author$project$Components$Membership$Form$Sections$Pricing$formatCoupon, $author$project$Api$Common$Coupon$Shared$percentOff(coupon_), $author$project$Api$Common$Coupon$Shared$amountOffInCents(coupon_), $author$project$Api$Common$Coupon$Shared$applyToEachPatient(coupon_), $author$project$Api$Common$Coupon$Shared$durationInMonths(coupon_), $author$project$Api$Common$Coupon$Shared$code(coupon_));
        } else return '';
    };
    var $author$project$Ui$Form$Static$Muted = {
        $: 2
    };
    var $author$project$Ui$Form$Static$muted = $author$project$Ui$Form$Static$Muted;
    var $author$project$Components$Membership$Form$Sections$Pricing$viewCouponField = F5(function(membership, pendingMembership, coupons, editCoupon, form) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var _v0 = function() {
            if (coupons.$ === 3) {
                var list = coupons.a;
                return _Utils_Tuple2(false, list);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var couponsLoading = _v0.a;
        var coupons_ = _v0.b;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Coupon')
        ]), _List_fromArray([
            function() {
                if ($author$project$Api$Provider$Membership$Meta$couponEditable(membershipMeta)) {
                    if (editCoupon) {
                        var _v2 = $author$project$Utils$Form$fields(form);
                        var coupon = _v2.Mj;
                        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value(coupon),
                                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$Coupon)),
                                    $author$project$Ui$Form$Select$loading(couponsLoading)
                                ]), $author$project$Components$Membership$Form$Sections$Pricing$couponOptions(coupons_))
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(6)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    A3($author$project$Ui$Button$view, {
                                        abP: 'Remoce coupon'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                        $author$project$Ui$Button$pull(1),
                                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Remove Coupon')
                                    ]))
                                ]))
                            ])),
                            function() {
                                var _v3 = $author$project$Api$Provider$Membership$One$coupon(pendingMembership);
                                if (!_v3.$) {
                                    var coupon_ = _v3.a;
                                    return A2($author$project$Ui$Grid$column, _List_fromArray([
                                        $author$project$Ui$Grid$span(12)
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_fromArray([
                                            $author$project$Ui$Typography$helpBlock
                                        ]), function() {
                                            var _v4 = $author$project$Api$Common$Coupon$Shared$durationInMonths(coupon_);
                                            if (!_v4.$) {
                                                var durationInMonths = _v4.a;
                                                return _List_fromArray([
                                                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', durationInMonths)),
                                                    $elm$html$Html$text('  coupon')
                                                ]);
                                            } else return _List_fromArray([
                                                $elm$html$Html$text('Unlimited duration coupon')
                                            ]);
                                        }())
                                    ]));
                                } else return $author$project$Ui$Grid$none;
                            }()
                        ]));
                    } else return A2($author$project$Ui$Form$Static$view, _List_fromArray([
                        $author$project$Ui$Form$Static$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('None'),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Add coupon'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditCoupon)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Add Coupon')
                        ]))
                    ]));
                } else return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Components$Membership$Form$Sections$Pricing$formatCouponShared($author$project$Api$Provider$Membership$One$coupon(membership)))
                ]));
            }()
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$ToggleFixedPeriodRateInCentsOverride = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$viewFixedRateField = F3(function(pendingMembership, onlyOneFixedPeriodRateInCentsEditable, form) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        var _v0 = $author$project$Utils$Form$fields(form);
        var fixedPeriodRateInCents = _v0.PP;
        var manuallySet = _v0.cc;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Total Rate'),
            $author$project$Ui$Form$Group$required(manuallySet.X5)
        ]), _List_fromArray([
            A3($author$project$Components$FixedRate$view, {
                Kb: false,
                MJ: $author$project$Api$Provider$Membership$One$fixedPeriodRateInCents(pendingMembership),
                NE: $elm$core$Maybe$Just($author$project$Currency$fromInt($author$project$Api$Provider$Membership$One$revenueInCents(pendingMembership))),
                d$: onlyOneFixedPeriodRateInCentsEditable,
                Ot: $author$project$Api$Provider$Membership$Meta$fixedPeriodRateInCentsEditable(membershipMeta),
                w: manuallySet.X5,
                fK: A2($author$project$Utils$Form$validationErrors, 0, form),
                aga: $author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership),
                aa9: fixedPeriodRateInCents
            }, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$FixedPeriodRateInCents), $author$project$Components$Membership$Form$Sections$Pricing$ToggleFixedPeriodRateInCentsOverride(pendingMembership))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod = {
        $: 6
    };
    var $author$project$Api$Provider$Membership$One$source = function(_v0) {
        var record = _v0.b;
        return record.Hw;
    };
    var $author$project$Api$Provider$Membership$Source$expMonth = function(_v0) {
        var record = _v0;
        return record.adz;
    };
    var $author$project$Api$Provider$Membership$Source$expYear = function(_v0) {
        var record = _v0;
        return record.adA;
    };
    var $author$project$Api$Provider$Membership$Source$funding = function(_v0) {
        var record = _v0;
        return record.P1;
    };
    var $author$project$Api$Provider$Membership$Source$lastFour = function(_v0) {
        var record = _v0;
        return record.ST;
    };
    var $author$project$Api$Provider$Membership$Source$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Membership$Source$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Membership$Source$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$Membership$Source$zip = function(_v0) {
        var record = _v0;
        return record.tK;
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodDisplay = F2(function(source, isEditable) {
        var sourceType = $author$project$Api$Provider$Membership$Source$type_(source);
        var isCard = sourceType === 'Card';
        var zipText = isCard ? A2($elm$core$Maybe$map, function(zip) {
            return 'ZIP code ' + zip;
        }, $author$project$Api$Provider$Membership$Source$zip(source)) : $elm$core$Maybe$Nothing;
        var expiresText = function() {
            if (isCard) {
                var _v1 = _Utils_Tuple2($author$project$Api$Provider$Membership$Source$expMonth(source), $author$project$Api$Provider$Membership$Source$expYear(source));
                if (!_v1.a.$ && !_v1.b.$) {
                    var expMonth = _v1.a.a;
                    var expYear = _v1.b.a;
                    return $elm$core$Maybe$Just('Expires ' + ($elm$core$String$fromInt(expMonth) + ('/' + $elm$core$String$fromInt(expYear))));
                } else return $elm$core$Maybe$Nothing;
            } else return $elm$core$Maybe$Nothing;
        }();
        var secondLineText = A2($elm$core$String$join, ', ', A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            expiresText,
            zipText
        ])));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$attrs(_List_fromArray([
                        $elm$html$Html$Attributes$class('pt-2')
                    ]))
                ]), A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$strong, _List_fromArray([
                        $elm$html$Html$Attributes$class('inline')
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Api$Provider$Membership$Source$name(source)))
                    ])),
                    $elm$html$Html$text(' '),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text('*' + $author$project$Api$Provider$Membership$Source$lastFour(source))
                    ])),
                    $elm$html$Html$text(' '),
                    function() {
                        var _v0 = $author$project$Api$Provider$Membership$Source$funding(source);
                        if (!_v0.$) {
                            var funding = _v0.a;
                            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('(' + (funding + ')'))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    $elm$html$Html$text(' '),
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Membership$Source$status(source))
                ])), $elm$core$String$isEmpty(secondLineText) ? _List_Nil : _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(secondLineText)
                    ]))
                ])))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                isEditable ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Change Payment Method'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Change Payment Method')
                    ]))
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodField = F2(function(membership, model) {
        var _v0 = function() {
            var _v1 = model.A0;
            if (_v1.$ === 3) {
                if (!_v1.a.$) {
                    var list = _v1.a.a;
                    return _Utils_Tuple2(false, list);
                } else {
                    var _v2 = _v1.a;
                    return _Utils_Tuple2(false, _List_Nil);
                }
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var paymentMethodsLoading = _v0.a;
        var paymentMethodsList = _v0.b;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Payment Method')
        ]), _List_fromArray([
            function() {
                if (model.l0) return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Pricing$PaymentMethodSelectMsg, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
                                $author$project$Ui$Form$SearchableSelect$value(model.j3),
                                $author$project$Ui$Form$SearchableSelect$placeholder('Select a payment method'),
                                $author$project$Ui$Form$SearchableSelect$loading(paymentMethodsLoading)
                            ]), A2($elm$core$List$map, $author$project$Ui$Form$SearchableSelect$Item$new(_List_Nil), paymentMethodsList), model.rZ))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Cancel'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$pull(1),
                                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Cancel')
                                ]))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Any upcoming payments for this membership will be charged to the new payment method.')
                    ]))
                ]));
                else {
                    var source = $author$project$Api$Provider$Membership$One$source(membership);
                    var isEditable = $author$project$Api$Provider$Membership$Meta$paymentSourceEditable($author$project$Api$Provider$Membership$One$meta(membership));
                    if (!source.$) {
                        var src = source.a;
                        return A2($author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodDisplay, src, isEditable);
                    } else return A2($author$project$Ui$Form$Static$view, _List_fromArray([
                        $author$project$Ui$Form$Static$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('No payment method'),
                        isEditable && !$elm$core$List$isEmpty(paymentMethodsList) ? A3($author$project$Ui$Button$view, {
                            abP: 'Change Payment Method'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleEditPaymentMethod)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Change Payment Method')
                        ])) : $author$project$Utils$Html$empty
                    ]));
                }
            }()
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCents = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$ToggleRegistrationFeeOverride = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Pricing$viewRegistrationFeeField = F2(function(pendingMembership, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var fixedRegistrationFeeInCents = _v0.PQ;
        var manuallySet = _v0.cc;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Registration Fee'),
            $author$project$Ui$Form$Group$required(manuallySet.ex)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    function() {
                        if (manuallySet.ex) return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                                $author$project$Ui$Form$CurrencyInput$value(fixedRegistrationFeeInCents),
                                $author$project$Ui$Form$CurrencyInput$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Pricing$FormUpdated, $author$project$Components$Membership$Form$Sections$Pricing$FixedRegistrationFeeInCents)),
                                $author$project$Ui$Form$CurrencyInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                                $author$project$Ui$Form$CurrencyInput$placeholder('10.00')
                            ])),
                            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form))
                        ]));
                        else {
                            var registrationFeeInCents = A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$MembershipBill$ForMembershipOne$registrationFeeInCents, $elm$core$List$head($author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership))));
                            return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt(registrationFeeInCents))
                            ]));
                        }
                    }()
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        function() {
                            var label = manuallySet.ex ? 'Remove Override' : 'Override Registration Fee';
                            return A3($author$project$Ui$Button$view, {
                                abP: label
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Pricing$ToggleRegistrationFeeOverride(pendingMembership))
                            ]), _List_fromArray([
                                $elm$html$Html$text(label)
                            ]));
                        }()
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        manuallySet.ex ? $elm$html$Html$text('Fixed registration fee') : $elm$html$Html$text('Standard registration fee')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$viewForm = F2(function(_v0, model) {
        var membership = _v0.jc;
        var pendingMembership = _v0.da;
        var onlyOneFixedPeriodRateInCentsEditable = _v0.afT;
        var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            !$author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee(pendingMembership) ? A3($author$project$Components$Membership$Form$Sections$Pricing$viewFixedRateField, pendingMembership, onlyOneFixedPeriodRateInCentsEditable, model.PU) : $author$project$Utils$Html$empty,
            $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Membership$One$coupon(membership)) || $author$project$Api$Provider$Membership$Meta$couponEditable(membershipMeta) ? A5($author$project$Components$Membership$Form$Sections$Pricing$viewCouponField, membership, pendingMembership, model.wY, model.Oq, model.PU) : $author$project$Utils$Html$empty,
            !$author$project$Api$Provider$Membership$One$isSponsored(membership) && $author$project$Api$Provider$Membership$Meta$paymentSourceEditable($author$project$Api$Provider$Membership$One$meta(membership)) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewPaymentMethodField, membership, model) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$Membership$Meta$fixedRegistrationFeeInCentsEditable(pendingMembershipMeta) && !$author$project$Components$Membership$Form$Sections$Pricing$planIsFixedFee(pendingMembership) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewRegistrationFeeField, pendingMembership, model.PU) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Pricing$view = F2(function(sectionsShared, _v0) {
        var model = _v0;
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Pricing')
            ])),
            $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Membership$One$nextBillDate(sectionsShared.da)) ? A2($author$project$Components$Membership$Form$Sections$Pricing$viewForm, sectionsShared, model) : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offset(5),
                    $author$project$Ui$Grid$span(7)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$em, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('This membership has no upcoming bills.')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$AddEndDate = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$Edit = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodInMonths = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$Quantity = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$Remove = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$Static$Numeric = {
        $: 1
    };
    var $author$project$Ui$Form$Static$numeric = $author$project$Ui$Form$Static$Numeric;
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities = function(recurringCharge) {
        var _v0 = $author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.aaK);
        if (_v0.$ === 1) return A2($elm$core$List$range, 1, 100);
        else {
            var periodInMonths = _v0.a;
            return periodInMonths === 1 ? _Utils_eq(recurringCharge.WC, $elm$core$Maybe$Just(1)) ? A2($elm$core$List$range, 1, 12) : _List_fromArray([
                1,
                3,
                6,
                12
            ]) : A2($elm$core$List$range, 1, 4);
        }
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$validRecurringChargePeriods = function(recurringCharge) {
        var _v0 = $author$project$Api$Provider$Uom$Shared$periodInMonths(recurringCharge.aaK);
        if (_v0.$ === 1) return _List_fromArray([
            1,
            3,
            6,
            12
        ]);
        else {
            var periodInMonths = _v0.a;
            return A2($elm$core$List$map, function(quantity) {
                return quantity * periodInMonths;
            }, $author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities(recurringCharge));
        }
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$periodInMonthsOptions = function(recurringCharge) {
        return A2($elm$core$List$map, function(period) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(period)), $author$project$Formatters$Int$asPeriodHuman(period));
        }, $author$project$Components$Membership$Form$Sections$RecurringCharges$validRecurringChargePeriods(recurringCharge));
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$validEndPeriods = function(recurringCharge) {
        var periodInMonths = A2($elm$core$Maybe$withDefault, 0, recurringCharge.WA);
        return A2($elm$core$List$range, 1, (23 / periodInMonths | 0) + (periodInMonths / 4 | 0) + 1);
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$periodsRemainingOptions = function(recurringCharge) {
        var periodInMonths = A2($elm$core$Maybe$withDefault, 0, recurringCharge.WA);
        return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Unlimited'), A2($elm$core$List$map, function(remaining) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(remaining)), A2($author$project$Formatters$String$pluralize, 'month', remaining * periodInMonths));
        }, $author$project$Components$Membership$Form$Sections$RecurringCharges$validEndPeriods(recurringCharge)));
    };
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$quantityOptions = function(recurringCharge) {
        var uom = recurringCharge.aaK;
        if ($author$project$Api$Provider$Uom$Shared$isTimeBased(uom)) {
            var periodInMonths = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$Uom$Shared$periodInMonths(uom));
            return A2($elm$core$List$map, function(quantity) {
                return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(quantity)), A2($author$project$Formatters$String$pluralize, 'month', quantity * periodInMonths));
            }, $author$project$Components$Membership$Form$Sections$RecurringCharges$validQuantities(recurringCharge));
        } else return A2($elm$core$List$map, function(quantity) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($elm$core$String$fromInt(quantity)), $elm$core$String$fromInt(quantity));
        }, A2($elm$core$List$range, 1, 99));
    };
    var $author$project$Ui$Typography$SrOnly = {
        $: 35
    };
    var $author$project$Ui$Typography$srOnly = $author$project$Ui$Typography$SrOnly;
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharge = F4(function(pendingMembership, patients, index, recurringCharge) {
        var uom = recurringCharge.aaK;
        var quantity = A2($elm$core$Maybe$withDefault, 0, recurringCharge.Bu);
        var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        var chargeItem = recurringCharge.lv;
        var priceInCents = A2($elm$core$Maybe$withDefault, chargeItem.Br, recurringCharge.adT);
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                _Utils_eq(recurringCharge.WC, $elm$core$Maybe$Just(1)) ? $elm$html$Html$text('On next invoice') : A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Invoiced'),
                                    $author$project$Utils$Html$noBreakSpace,
                                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                        $author$project$Ui$Form$Select$size(1),
                                        $author$project$Ui$Form$Select$inline,
                                        $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.WA)),
                                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index), $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodInMonths), $elm$core$String$toInt))
                                    ]), $author$project$Components$Membership$Form$Sections$RecurringCharges$periodInMonthsOptions(recurringCharge)),
                                    $author$project$Utils$Html$noBreakSpace,
                                    A2($elm$core$Maybe$withDefault, 0, recurringCharge.agb) > 0 ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('for'),
                                        $author$project$Utils$Html$noBreakSpace,
                                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                            $author$project$Ui$Form$Select$size(1),
                                            $author$project$Ui$Form$Select$inline,
                                            $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.agb)),
                                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index), $author$project$Components$Membership$Form$Sections$RecurringCharges$PeriodsRemaining), $elm$core$String$toInt))
                                        ]), $author$project$Components$Membership$Form$Sections$RecurringCharges$periodsRemainingOptions(recurringCharge))
                                    ])) : A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(' until membership ends '),
                                        A3($author$project$Ui$Button$view, {
                                            abP: 'Add end date'
                                        }, _List_fromArray([
                                            $author$project$Ui$Button$sm,
                                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$RecurringCharges$AddEndDate(index))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Add End Date')
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ])),
                        $author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta) ? A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$justifyRight,
                            $author$project$Ui$Element$itemsCenter,
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Remove recurring charge'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$RecurringCharges$Remove(index)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Remove')
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Edit recurring charge'
                            }, _List_fromArray([
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$onClick(A2($author$project$Components$Membership$Form$Sections$RecurringCharges$Edit, patients, index)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$edit)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Edit')
                            ]))
                        ])) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'No Patient', A2($elm$core$Maybe$map, function($) {
                                return $.zr;
                            }, recurringCharge.V7)))
                        ])),
                        function() {
                            var _v0 = recurringCharge.agi;
                            if (!_v0.$) {
                                var practitioner = _v0.a;
                                return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(' with '),
                                    $elm$html$Html$text(practitioner.zr)
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        !_Utils_eq(recurringCharge.WC, $elm$core$Maybe$Just(1)) ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            function() {
                                var _v1 = recurringCharge.WA;
                                if (!_v1.$) {
                                    var periodInMonths = _v1.a;
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(' repeating every '),
                                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', periodInMonths))
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            function() {
                                var _v2 = _Utils_Tuple2(recurringCharge.agb, recurringCharge.WA);
                                if (!_v2.a.$ && !_v2.b.$) {
                                    var periodsRemaining = _v2.a.a;
                                    var periodInMonths = _v2.b.a;
                                    return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        _Utils_eq($elm$core$Maybe$Just(periodsRemaining), recurringCharge.WC) ? $elm$html$Html$text(' for ') : $elm$html$Html$text(' for the next '),
                                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'month', periodsRemaining * periodInMonths))
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ])) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(5)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$controlLabel,
                                $author$project$Ui$Typography$srOnly
                            ]), _List_fromArray([
                                $elm$html$Html$text('Item')
                            ])),
                            A2($author$project$Ui$Form$Static$view, _List_fromArray([
                                $author$project$Ui$Form$Static$phi(true)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, chargeItem.zr, recurringCharge.zr))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$controlLabel,
                                $author$project$Ui$Typography$srOnly
                            ]), _List_fromArray([
                                $elm$html$Html$text('Quantity')
                            ])),
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$size(1),
                                $author$project$Ui$Form$Select$inline,
                                $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $elm$core$String$fromInt, recurringCharge.Bu)),
                                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$RecurringCharges$FormUpdated(index), $author$project$Components$Membership$Form$Sections$RecurringCharges$Quantity), $elm$core$String$toInt)),
                                $author$project$Ui$Form$Select$disabled($author$project$Api$Provider$Uom$Shared$isTimeBased(uom) && !_Utils_eq(recurringCharge.WC, $elm$core$Maybe$Just(1)))
                            ]), $author$project$Components$Membership$Form$Sections$RecurringCharges$quantityOptions(recurringCharge))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(3)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$controlLabel,
                                $author$project$Ui$Typography$srOnly
                            ]), _List_fromArray([
                                $elm$html$Html$text('Price')
                            ])),
                            A2($author$project$Ui$Form$Static$view, _List_fromArray([
                                $author$project$Ui$Form$Static$numeric
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Currency$format($author$project$Currency$fromFloat(priceInCents))),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                $author$project$Api$Provider$Uom$Shared$isTimeBased(uom) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$small,
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    $elm$html$Html$text('per '),
                                    $elm$html$Html$text($author$project$Api$Provider$Uom$Shared$name(uom))
                                ])) : $author$project$Utils$Html$empty
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$label, _List_fromArray([
                                $author$project$Ui$Typography$controlLabel,
                                $author$project$Ui$Typography$srOnly
                            ]), _List_fromArray([
                                $elm$html$Html$text('Price')
                            ])),
                            A2($author$project$Ui$Form$Static$view, _List_fromArray([
                                $author$project$Ui$Form$Static$numeric
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Currency$format($author$project$Currency$fromFloat(priceInCents * quantity)))
                                ]))
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_fromArray([
                                $author$project$Ui$Form$Static$phi(true),
                                $author$project$Ui$Form$Static$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, A2($elm$core$Maybe$withDefault, 'No Description', chargeItem.NQ), recurringCharge.adS))
                            ]))
                        ])),
                        !_Utils_eq(recurringCharge.WC, $elm$core$Maybe$Just(1)) && !_Utils_eq(recurringCharge.agb, $elm$core$Maybe$Just(0)) ? A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(4)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$justifyRight,
                                $author$project$Ui$Element$textMuted
                            ]), _List_fromArray([
                                function() {
                                    if (!$author$project$Utils$Maybe$toBool(recurringCharge._0) || _Utils_eq(recurringCharge._0, recurringCharge.UY)) {
                                        var startDate = A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Membership$One$billFromDate(pendingMembership), recurringCharge._0);
                                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$phi(true)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Starting on '),
                                            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }(),
                                function() {
                                    var _v3 = _Utils_Tuple2(recurringCharge.UY, !_Utils_eq(recurringCharge.UY, recurringCharge._0));
                                    if (!_v3.a.$ && _v3.b) {
                                        var nextBillDate = _v3.a.a;
                                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$phi(true)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Recurring on '),
                                            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDate))
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ]))
                        ])) : $author$project$Ui$Grid$none
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharges = F4(function(pendingMembership, patients, hasChargeItems, recurringCharges) {
        var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        return A2($elm$html$Html$div, _List_Nil, _Utils_ap(A2($elm$core$List$indexedMap, A2($author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharge, pendingMembership, patients), recurringCharges), hasChargeItems && $author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta) ? _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Add charge'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge(patients)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Charge')
                ]))
            ]))
        ]) : _List_Nil));
    });
    var $author$project$Components$Membership$Form$Sections$RecurringCharges$view = F2(function(_v0, _v1) {
        var pendingMembership = _v0.da;
        var patients = _v0.AD;
        var model = _v1;
        var _v2 = $author$project$Utils$Form$fields(model.PU);
        var recurringCharges = _v2.Yl;
        return !model.qO && $elm$core$List$isEmpty(recurringCharges) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(5)
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text('Additional Charges')
                        ]))
                    ]))
                ]),
                function() {
                    if ($elm$core$List$isEmpty(recurringCharges)) {
                        var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
                        return _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(7)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$spaceBetween
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$muted
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('None')
                                    ])),
                                    $author$project$Api$Provider$Membership$Meta$recurringChargesEditable(pendingMembershipMeta) ? A3($author$project$Ui$Button$view, {
                                        abP: 'Add charge'
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$link,
                                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$RecurringCharges$AddRecurringCharge(patients))
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Add Charge')
                                    ])) : $author$project$Utils$Html$empty
                                ]))
                            ]))
                        ]);
                    } else return _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$hintLabel,
                                $author$project$Ui$Typography$numeric
                            ]), _List_fromArray([
                                $elm$html$Html$text('Qty')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(3)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$hintLabel,
                                $author$project$Ui$Typography$numeric
                            ]), _List_fromArray([
                                $elm$html$Html$text('Price')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$hintLabel,
                                $author$project$Ui$Typography$numeric
                            ]), _List_fromArray([
                                $elm$html$Html$text('Amount')
                            ]))
                        ]))
                    ]);
                }()
            ]))),
            !$elm$core$List$isEmpty(recurringCharges) ? A4($author$project$Components$Membership$Form$Sections$RecurringCharges$viewRecurringCharges, pendingMembership, patients, model.qO, recurringCharges) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Api$Feature$MembershipAutoRenewEditable = 5;
    var $author$project$Api$Provider$Practice$One$anyRetailBrokers = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Jv;
    });
    var $author$project$Api$Provider$Membership$One$cancellationReason = function(_v0) {
        var record = _v0.b;
        return record.ab9;
    };
    var $author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus = F2(function(statuses, membership) {
        return A2($elm$core$List$member, $author$project$Api$Provider$Membership$One$status(membership), statuses);
    });
    var $author$project$Components$Membership$Form$Sections$Summary$AutoRenew = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$viewAutoRenewInput = F2(function(membership, _v0) {
        var autoRenew = _v0.JX;
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Auto Invoice')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(autoRenew),
                $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, $author$project$Components$Membership$Form$Sections$Summary$AutoRenew)),
                $author$project$Ui$Form$Checkbox$disabled(!$author$project$Api$Provider$Membership$Meta$autoRenewEditable(membershipMeta))
            ]), _List_fromArray([
                autoRenew ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text('Invoices are currently being automatically generated for this membership')
                ])) : $author$project$Utils$Html$empty,
                $author$project$Api$Provider$Membership$Meta$autoRenewEditable(membershipMeta) && !autoRenew ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$gray
                ]), _List_fromArray([
                    $elm$html$Html$text('We are currently '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('not')
                    ])),
                    $elm$html$Html$text(' automatically creating invoices for this membership. Check the box to the left to start generating automated invoices.')
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$AddBroker = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$BrokerDeal$Timeline$viewWithoutControls = F2(function(options, brokerDeal) {
        return A5($author$project$Components$BrokerDeal$Timeline$view, options.ahn, brokerDeal, $author$project$Utils$Html$empty, $author$project$Utils$Html$empty, $elm$core$Basics$always($author$project$Utils$Html$empty));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$viewBrokerDeal = F3(function(brokerDeals, index, brokerDeal) {
        var isLast = _Utils_eq(index, $elm$core$List$length(brokerDeals) - 1);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Broker$Shared$name(brokerDeal.vQ)),
                $elm$html$Html$text(' ('),
                $elm$html$Html$text($author$project$Api$Provider$BrokerAccount$Shared$name($author$project$Api$Provider$Broker$Shared$brokerAccount(brokerDeal.vQ))),
                $elm$html$Html$text(')')
            ])),
            A2($author$project$Components$BrokerDeal$Timeline$viewWithoutControls, {
                ahn: false
            }, brokerDeal),
            !isLast ? $author$project$Ui$HorizontalRule$view(_List_Nil) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$viewBrokerInput = F3(function(isNew, membership, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Broker')
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_Nil, A2($elm$core$List$indexedMap, $author$project$Components$Membership$Form$Sections$Summary$viewBrokerDeal(model.Kq), model.Kq)),
            A3($author$project$Ui$Button$view, {
                abP: 'Add broker'
            }, _List_fromArray([
                $author$project$Ui$Button$disabled(isNew),
                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$AddBroker(membership)),
                $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
            ]), _List_fromArray([
                $elm$html$Html$text('Add broker')
            ])),
            isNew ? A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('You will be able to assign a broker after the membership is created.')
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Api$Provider$Membership$One$cancellationReasonOther = function(_v0) {
        var record = _v0.b;
        return record.aca;
    };
    var $author$project$Components$CancellationReason$Display$viewShared = F2(function(cancellationReason, cancellationReasonOther) {
        return A2($author$project$Components$CancellationReason$Display$view, $author$project$Components$CancellationReason$CancellationReasonRecord$fromShared(cancellationReason), cancellationReasonOther);
    });
    var $author$project$Components$Membership$Form$Sections$Summary$viewCancellationReason = F2(function(membership, cancellationReason) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Cancellation Reason')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Components$CancellationReason$Display$viewShared, cancellationReason, $author$project$Api$Provider$Membership$One$cancellationReasonOther(membership))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$viewCompanyName = F2(function(company, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label(A2($author$project$Formatters$String$sponsorize, model.W1, 'Employer') + ' Name')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                    fl: $author$project$Api$Provider$Company$Shared$id(company)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Company$Shared$name(company))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$viewEndDate = F2(function(membership, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('End Date')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString(A2($author$project$Formatters$Date$Relative, model.cP, $elm$core$Maybe$Nothing)), $author$project$Api$Provider$Membership$One$endDate(membership))))
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$viewMembershipType = function(model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Membership Type')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$String$sponsorize, model.W1, 'Employer'))
            ]))
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$Summary$MinimumEnrollmentPeriodInMonths = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths = {
        $: 4
    };
    var $author$project$Api$Provider$Membership$Shared$minimumEnrollmentStartDate = function(_v0) {
        var record = _v0;
        return record.Uq;
    };
    var $author$project$Api$Provider$Membership$One$minimumEnrollmentStartDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Membership$Shared$minimumEnrollmentStartDate(shared);
    };
    var $author$project$Components$Membership$Form$Sections$Summary$viewMinimumEnrollmentPeriodInMonthsInput = F3(function(pendingMembership, _v0, model) {
        var minimumEnrollmentPeriodInMonths = _v0.Up;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Minimum Enrollment')
        ]), _List_fromArray([
            model.oi.eY ? A3($author$project$Ui$Button$view, {
                abP: 'Add minimum enrollment'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$pull(1),
                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths)
            ]), _List_fromArray([
                $elm$html$Html$text('Add Minimum Enrollment')
            ])) : A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(9)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$PeriodInMonthsSelect$view({
                            U5: 'Choose an option',
                            afv: A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, $author$project$Components$Membership$Form$Sections$Summary$MinimumEnrollmentPeriodInMonths),
                            z9: A2($elm$core$List$range, 1, 12),
                            aa9: minimumEnrollmentPeriodInMonths
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(3),
                        $author$project$Ui$Grid$justifyRight,
                        $author$project$Ui$Grid$itemsCenter
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Remove minimum enrollment'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$ToggleMinimumEnrollmentPeriodInMonths)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Remove')
                        ]))
                    ]))
                ])),
                function() {
                    var _v1 = $author$project$Api$Provider$Membership$One$minimumEnrollmentStartDate(pendingMembership);
                    if (!_v1.$) {
                        var minimumEnrollmentStartDate = _v1.a;
                        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$span(12)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$helpBlock
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Cannot cancel between '),
                                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, minimumEnrollmentStartDate)),
                                    $elm$html$Html$text(' and '),
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Membership$One$minimumEnrollmentEndDate(pendingMembership))))
                                ]))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$EditNextBillDate = {
        $: 3
    };
    var $author$project$Components$Membership$Form$Sections$Summary$SetBillDate = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$Meta$billDateValues = function(_v0) {
        var meta = _v0;
        return meta.vN.pc;
    };
    var $author$project$Components$Membership$Form$Sections$Summary$nextBillDateOptions = function(membership) {
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var minBillDate = $author$project$Api$Provider$Membership$Meta$billDateMin(membershipMeta);
        return $author$project$Ui$Form$Select$dateOptions(A2($elm$core$List$filter, function(date) {
            return !!A2($justinmimbs$date$Date$compare, date, minBillDate);
        }, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Provider$Membership$Meta$billDateValues($author$project$Api$Provider$Membership$One$meta(membership)))));
    };
    var $author$project$Components$Membership$Form$Sections$Summary$viewNextBillDateInput = F5(function(currentDate, membership, pendingMembership, form, model) {
        var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        var _v0 = $author$project$Utils$Form$fields(form);
        var nextBillDate = _v0.UY;
        var setBillDate = _v0.eJ;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Next Bill Due'),
            $author$project$Ui$Form$Group$required(model.oi.UY)
        ]), _List_fromArray([
            model.oi.UY ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                setBillDate && $author$project$Api$Provider$Membership$One$isSponsored(membership) ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, nextBillDate)),
                    $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$NextBillDate, $elm$core$Result$toMaybe), $justinmimbs$date$Date$fromIsoString))),
                    $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                    $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
                ]), $author$project$Components$Membership$Form$Sections$Summary$nextBillDateOptions(membership)) : A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Summary$NextBillDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                    $author$project$Components$DateInput$value(nextBillDate),
                    $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 3, form)),
                    $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 3, form))
                ]), model.rB)),
                $author$project$Api$Provider$Membership$Meta$billDateEditable(pendingMembershipMeta) && $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(pendingMembershipMeta) ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(setBillDate),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, $elm$core$Basics$always($author$project$Components$Membership$Form$Sections$Summary$SetBillDate(true)))),
                        $author$project$Ui$Form$Radio$disabled(!A2($author$project$Utils$Form$hasValidationErrors, 3, form))
                    ]), _List_fromArray([
                        $elm$html$Html$text('All future bills')
                    ])),
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(!setBillDate),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, $elm$core$Basics$always($author$project$Components$Membership$Form$Sections$Summary$SetBillDate(false)))),
                        $author$project$Ui$Form$Radio$disabled(!A2($author$project$Utils$Form$hasValidationErrors, 3, form))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Only next bill')
                    ]))
                ])) : $author$project$Utils$Html$empty
            ])) : A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        function() {
                            var _v1 = _Utils_Tuple3($author$project$Api$Provider$Membership$One$billDate(pendingMembership), $author$project$Api$Provider$Membership$One$nextBillDate(pendingMembership), nextBillDate);
                            _v1$3: while(true){
                                if (_v1.a.$ === 1) {
                                    if (_v1.b.$ === 1) {
                                        var _v2 = _v1.a;
                                        var _v3 = _v1.b;
                                        return $elm$html$Html$text('Never');
                                    } else break _v1$3;
                                } else if (!_v1.c.$) {
                                    var nextBillDate_ = _v1.c.a;
                                    return $elm$html$Html$text(A2($author$project$Formatters$Date$toString, A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing), nextBillDate_));
                                } else {
                                    if (!_v1.b.$) {
                                        var nextBillDate_ = _v1.b.a;
                                        var _v4 = _v1.c;
                                        return $elm$html$Html$text(A2($author$project$Formatters$Date$toString, A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing), nextBillDate_));
                                    } else break _v1$3;
                                }
                            }
                            return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ])),
                $author$project$Api$Provider$Membership$Meta$billDateEditable(pendingMembershipMeta) || $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(pendingMembershipMeta) ? A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Change billing date'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditNextBillDate)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Change Billing Date')
                        ]))
                    ]))
                ])) : $author$project$Ui$Grid$none
            ]))
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$EditOwner = {
        $: 0
    };
    var $author$project$Components$Membership$Form$Sections$Summary$viewOwnerInput = F4(function(membership, pendingMembership, form, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$required(model.oi.VM),
            $author$project$Ui$Form$Group$label('Payer')
        ]), function() {
            if (model.oi.VM) return _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Summary$PatientResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]), model.rX))
            ]);
            else {
                var meta = $author$project$Api$Provider$Membership$One$meta(membership);
                return _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$name, $author$project$Api$Provider$Membership$One$owner(pendingMembership))))
                        ])),
                        $author$project$Api$Provider$Membership$Meta$ownerEditable(meta) ? A3($author$project$Ui$Button$view, {
                            abP: 'Change payer'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditOwner)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Change Payer')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]);
            }
        }());
    });
    var $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$periodInMonths = function(_v0) {
        var record = _v0;
        return record.WA;
    };
    var $author$project$Api$Provider$Membership$One$prepayOptions = function(_v0) {
        var record = _v0.b;
        return record.Xk;
    };
    var $author$project$Components$Membership$Form$Sections$Summary$periodInMonthsOptions = function(pendingMembership) {
        return A2($elm$core$List$map, function(membershipBill) {
            var periodInMonths = $author$project$Api$Provider$MembershipBill$ForMembershipPrepayOptions$periodInMonths(membershipBill);
            return A3($author$project$Ui$Form$Select$option, _List_Nil, A2($elm$core$Maybe$map, $elm$core$String$fromInt, periodInMonths), A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Int$asPeriod, periodInMonths)));
        }, $author$project$Api$Provider$Membership$One$prepayOptions(pendingMembership));
    };
    var $author$project$Components$Membership$Form$Sections$Summary$viewPeriodInMonthsInput = F3(function(membership, pendingMembership, _v0) {
        var periodInMonths = _v0.WA;
        var pendingMembershipMeta = $author$project$Api$Provider$Membership$One$meta(pendingMembership);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Billed')
        ]), _List_fromArray([
            $author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(pendingMembership) ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('At end of monthly billing period')
            ])) : $author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(pendingMembershipMeta) ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($elm$core$String$fromInt(periodInMonths))),
                $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, function(string) {
                    return $author$project$Components$Membership$Form$Sections$Summary$PeriodInMonths(A2($elm$core$Maybe$withDefault, 1, $elm$core$String$toInt(string)));
                }))
            ]), $author$project$Components$Membership$Form$Sections$Summary$periodInMonthsOptions(pendingMembership)) : $author$project$Utils$Html$empty,
            !$author$project$Api$Provider$Membership$One$billsAtEndOfPeriod(membership) && !$author$project$Api$Provider$Membership$Meta$periodInMonthsEditable(pendingMembershipMeta) ? A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$Int$asPeriodHuman($author$project$Api$Provider$Membership$One$periodInMonths(pendingMembership)))
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$EditPlan = {
        $: 1
    };
    var $author$project$Components$Membership$Form$Sections$Summary$viewPlanInput = F4(function(membership, pendingMembership, form, model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$required(model.oi.GW),
            $author$project$Ui$Form$Group$label('Plan')
        ]), function() {
            if (model.oi.GW) return _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Summary$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form)),
                    $author$project$Components$ResourceFilter$errors(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]), model.jy))
            ]);
            else {
                var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
                return _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$Plan$SharedWithContractInfo$name($author$project$Api$Provider$Membership$One$plan(pendingMembership)))
                        ])),
                        $author$project$Api$Provider$Membership$Meta$planEditable(membershipMeta) ? A3($author$project$Ui$Button$view, {
                            abP: 'Change plan'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$pull(1),
                            $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditPlan)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Change Plan')
                        ])) : $author$project$Utils$Html$empty
                    ]))
                ]);
            }
        }());
    });
    var $author$project$Components$Membership$Form$Sections$Summary$EditStartDate = {
        $: 2
    };
    var $author$project$Components$Membership$Form$Sections$Summary$startDateOptions = function(membership) {
        return $author$project$Ui$Form$Select$dateOptions(A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Provider$Membership$Meta$billDateValues($author$project$Api$Provider$Membership$One$meta(membership))));
    };
    var $author$project$Components$Membership$Form$Sections$Summary$viewStartDateInput = F5(function(currentDate, membership, pendingMembership, form, model) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var startDate = _v0._0;
        var futureEligibilityDate = _v0.FE;
        var manuallySet = _v0.cc;
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label(A2($author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus, _List_fromArray([
                'pending',
                'unconfirmed'
            ]), membership) ? 'Starting' : 'Start Date'),
            $author$project$Ui$Form$Group$required(manuallySet._0)
        ]), _List_fromArray([
            function() {
                if (manuallySet._0) return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                    $author$project$Api$Provider$Membership$One$isSponsored(membership) ? A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, startDate)),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$FormUpdated, A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Components$Membership$Form$Sections$Summary$StartDate, $elm$core$Result$toMaybe), $justinmimbs$date$Date$fromIsoString))),
                        $author$project$Ui$Form$Select$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                        $author$project$Ui$Form$Select$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                    ]), $author$project$Components$Membership$Form$Sections$Summary$startDateOptions(membership)) : A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Summary$StartDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                        $author$project$Components$DateInput$value(startDate),
                        $author$project$Components$DateInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form)),
                        $author$project$Components$DateInput$errors(A2($author$project$Utils$Form$validationErrors, 2, form))
                    ]), model.kj)),
                    function() {
                        if (!futureEligibilityDate.$) {
                            var futureEligibilityDate_ = futureEligibilityDate.a;
                            return A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$name, $author$project$Api$Provider$Membership$One$owner(membership))))
                                ])),
                                $elm$html$Html$text(' is not eligible for coverage under '),
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Shared$name, $author$project$Api$Provider$Membership$One$company(membership)))),
                                $elm$html$Html$text('\'s plan until '),
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, futureEligibilityDate_))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]));
                else {
                    var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
                    return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, A2($author$project$Formatters$Date$Relative, currentDate, $elm$core$Maybe$Nothing), $author$project$Api$Provider$Membership$One$startDate(pendingMembership)))
                            ]))
                        ])),
                        $author$project$Api$Provider$Membership$Meta$startDateEditable(membershipMeta) ? A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Change start date'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$pull(1),
                                    $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Sections$Summary$EditStartDate)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Change Start Date')
                                ]))
                            ]))
                        ])) : $author$project$Ui$Grid$none
                    ]));
                }
            }()
        ]));
    });
    var $author$project$Components$Membership$Form$Sections$Summary$viewStatus = function(membership) {
        var status = $author$project$Api$Provider$Membership$One$status(membership);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Status')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, status),
                function() {
                    var _v0 = _Utils_Tuple2(status === 'active', $author$project$Api$Provider$Membership$One$endDate(membership));
                    if (_v0.a && !_v0.b.$) {
                        var endDate = _v0.b.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text(' until '),
                            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    };
    var $author$project$Components$Membership$Form$Sections$Summary$view = F2(function(_v0, _v1) {
        var membership = _v0.jc;
        var pendingMembership = _v0.da;
        var isNew = _v0.iZ;
        var model = _v1;
        var membershipMeta = $author$project$Api$Provider$Membership$One$meta(membership);
        var fields = $author$project$Utils$Form$fields(model.PU);
        var autoRenewEditable = A2($author$project$Api$Provider$Practice$One$featureEnabled, 5, model.W1);
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Summary')
                ])),
                isNew ? $author$project$Utils$Html$empty : A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$ml2
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Membership$Form$Sections$Summary$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$view(model.hB))
                ]))
            ])),
            A4($author$project$Components$Membership$Form$Sections$Summary$viewOwnerInput, membership, pendingMembership, model.PU, model),
            A4($author$project$Components$Membership$Form$Sections$Summary$viewPlanInput, membership, pendingMembership, model.PU, model),
            !isNew ? $author$project$Components$Membership$Form$Sections$Summary$viewStatus(membership) : $author$project$Utils$Html$empty,
            A5($author$project$Components$Membership$Form$Sections$Summary$viewStartDateInput, model.cP, membership, pendingMembership, model.PU, model),
            A2($author$project$Components$Membership$Form$Sections$Summary$isMembershipStatus, _List_fromArray([
                'active',
                'unpaid'
            ]), membership) || $author$project$Api$Provider$Membership$Meta$billDateEditable(membershipMeta) || $author$project$Api$Provider$Membership$Meta$nextBillDateEditable(membershipMeta) ? A5($author$project$Components$Membership$Form$Sections$Summary$viewNextBillDateInput, model.cP, membership, pendingMembership, model.PU, model) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$Membership$One$isRestartable(membership) || $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Membership$One$endDate(pendingMembership)) ? A2($author$project$Components$Membership$Form$Sections$Summary$viewEndDate, membership, model) : $author$project$Utils$Html$empty,
            $author$project$Utils$Maybe$toBool($author$project$Api$Provider$Membership$One$company(pendingMembership)) ? $author$project$Components$Membership$Form$Sections$Summary$viewMembershipType(model) : $author$project$Utils$Html$empty,
            function() {
                var _v2 = $author$project$Api$Provider$Membership$One$company(pendingMembership);
                if (!_v2.$) {
                    var company = _v2.a;
                    return A2($author$project$Components$Membership$Form$Sections$Summary$viewCompanyName, company, model);
                } else return $author$project$Utils$Html$empty;
            }(),
            A3($author$project$Components$Membership$Form$Sections$Summary$viewPeriodInMonthsInput, membership, pendingMembership, fields),
            $author$project$Api$Provider$Membership$Meta$minimumEnrollmentPeriodInMonthsEditable(membershipMeta) ? A3($author$project$Components$Membership$Form$Sections$Summary$viewMinimumEnrollmentPeriodInMonthsInput, pendingMembership, fields, model) : $author$project$Utils$Html$empty,
            autoRenewEditable ? A2($author$project$Components$Membership$Form$Sections$Summary$viewAutoRenewInput, membership, fields) : $author$project$Utils$Html$empty,
            $author$project$Api$Provider$Practice$One$anyRetailBrokers(model.W1) && !$author$project$Api$Provider$Membership$One$isSponsored(membership) && !A2($author$project$Permission$disallowForRoles, model.Z$, _List_fromArray([
                'practice_staff_limited'
            ])) ? A3($author$project$Components$Membership$Form$Sections$Summary$viewBrokerInput, model.iZ, membership, model) : $author$project$Utils$Html$empty,
            function() {
                var _v3 = $author$project$Api$Provider$Membership$One$cancellationReason(membership);
                if (!_v3.$) {
                    var cancellationReason = _v3.a;
                    return A2($author$project$Components$Membership$Form$Sections$Summary$viewCancellationReason, membership, cancellationReason);
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Membership$Form$viewForm = F4(function(membership, pendingMembership, sections, model) {
        var shared = A5($author$project$Components$Membership$Form$initSectionsShared, model.V7, membership, pendingMembership, sections, model);
        var _v0 = sections;
        var summary = _v0.$x;
        var members = _v0.B;
        var pricing = _v0.cm;
        var contracts = _v0.aD;
        var recurringCharges = _v0.Yl;
        var planChange = _v0.jw;
        var billsOverview = _v0.pI;
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$SummaryMsg, A2($author$project$Components$Membership$Form$Sections$Summary$view, shared, summary)),
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$MembersMsg, A3($author$project$Components$Membership$Form$Sections$Members$view, shared, model.acb, members)),
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$PricingMsg, A2($author$project$Components$Membership$Form$Sections$Pricing$view, shared, pricing)),
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$ContractsMsg, A2($author$project$Components$Membership$Form$Sections$Contracts$view, shared, contracts)),
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$RecurringChargesMsg, A2($author$project$Components$Membership$Form$Sections$RecurringCharges$view, shared, recurringCharges)),
            function() {
                if (!planChange.$) {
                    var planChange_ = planChange.a;
                    return A2($elm$html$Html$map, $author$project$Components$Membership$Form$PlanChangeMsg, A3($author$project$Components$Membership$Form$Sections$PlanChange$view, shared, $author$project$Components$Membership$Form$Sections$Contracts$contractFields(contracts), planChange_));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($elm$html$Html$map, $author$project$Components$Membership$Form$BillsOverviewMsg, A2($author$project$Components$Membership$Form$Sections$BillsOverview$view, shared, billsOverview))
        ]);
    });
    var $author$project$Components$Membership$Form$viewNewButtons = F3(function(membership, pendingMembership, model) {
        var startDate = $author$project$Api$Provider$Membership$One$startDate(pendingMembership);
        return _List_fromArray([
            function() {
                if (A2($author$project$Utils$Date$isAfter, startDate, model.cP) || $author$project$Api$Provider$Membership$One$isSponsored(pendingMembership)) return $author$project$Utils$Html$empty;
                else {
                    var dueAmountInCents = A3($elm$core$List$foldl, F2(function(membershipBill, acc) {
                        return $author$project$Api$Provider$MembershipBill$ForMembershipOne$amountInCents(membershipBill) + acc;
                    }), 0, A2($elm$core$List$filter, function(membershipBill) {
                        return A2($justinmimbs$date$Date$compare, $author$project$Api$Provider$MembershipBill$ForMembershipOne$date(membershipBill), model.cP) !== 2;
                    }, $author$project$Api$Provider$Membership$One$upcomingAndOutstandingBills(pendingMembership)));
                    var label = A2($elm$core$String$join, ' ', _List_fromArray([
                        'Create membership and',
                        A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Shared$autopay, $author$project$Api$Provider$Membership$One$owner(membership))) ? 'Bill' : 'Invoice',
                        $author$project$Utils$Currency$fromInt(dueAmountInCents),
                        'Now'
                    ]));
                    return A3($author$project$Ui$Button$view, {
                        abP: label
                    }, _List_fromArray([
                        $author$project$Ui$Button$styled(0),
                        $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                        $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Save(true))
                    ]), _List_fromArray([
                        $elm$html$Html$text(label)
                    ]));
                }
            }(),
            A3($author$project$Ui$Button$view, {
                abP: 'Create membership'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading)),
                $author$project$Ui$Button$onClick($author$project$Components$Membership$Form$Save(false))
            ]), _List_fromArray([
                $elm$html$Html$text('Create')
            ]))
        ]);
    });
    var $author$project$Components$Membership$Form$view = function(model) {
        return _List_fromArray([
            $author$project$Components$Membership$Form$modal(model),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$view, _List_fromArray([
                        $author$project$Ui$Form$horizontal,
                        $author$project$Ui$Form$noValidate(true),
                        $author$project$Ui$Form$autocomplete(false)
                    ]), function() {
                        var _v0 = _Utils_Tuple3(model.jc, model.da, model.l);
                        if (!_v0.a.$ && !_v0.b.$ && !_v0.c.$) {
                            var membership = _v0.a.a;
                            var pendingMembership = _v0.b.a;
                            var sections = _v0.c.a;
                            return A4($author$project$Components$Membership$Form$viewForm, membership, pendingMembership, sections, model);
                        } else return _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]))
                        ]);
                    }())
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter,
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), A2($elm$core$List$cons, A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top({
                    V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])), function() {
                    var _v1 = _Utils_Tuple3(model.jc, model.da, model.l);
                    if (!_v1.a.$ && !_v1.b.$ && !_v1.c.$) {
                        var membership = _v1.a.a;
                        var pendingMembership = _v1.b.a;
                        var sections = _v1.c.a;
                        if (model.iZ) return A3($author$project$Components$Membership$Form$viewNewButtons, membership, pendingMembership, model);
                        else {
                            var summaryDirty = $author$project$Components$Membership$Form$Sections$Summary$dirty(sections.$x);
                            var recurringChargesDirty = $author$project$Components$Membership$Form$Sections$RecurringCharges$dirty(sections.Yl);
                            var pricingDirty = $author$project$Components$Membership$Form$Sections$Pricing$dirty(sections.cm);
                            var membersDirty = $author$project$Components$Membership$Form$Sections$Members$dirty(sections.B);
                            var contractsDirty = $author$project$Components$Membership$Form$Sections$Contracts$dirty(sections.aD);
                            var dirty = summaryDirty || membersDirty || pricingDirty || recurringChargesDirty || contractsDirty;
                            return A3($author$project$Components$Membership$Form$viewEditButtons, dirty, membership, model);
                        }
                    } else return _List_fromArray([
                        $author$project$Utils$Html$empty
                    ]);
                }()))
            ]))
        ]);
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$view = function(model) {
        return {
            fb: $author$project$Components$Membership$Form$view(model.PU),
            $2: 'Patient | Memberships'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$New$init = F5(function(session, practice, patient, _v0, _v1) {
        var apiClient = _v0.Ej;
        var timeZone = _v0.HP;
        var currentDate = _v0.cP;
        var hinterViewOff = _v0.aeb;
        var currentTime = _v0.acJ;
        var url = _v0.aaT;
        var query = _v1.Bz;
        var _v2 = $author$project$Components$Membership$Form$init(apiClient)(timeZone)(currentDate)(session)(practice)(hinterViewOff)(query)(patient)($elm$core$Maybe$Nothing)(currentTime)(url);
        var form = _v2.a;
        var cmd = _v2.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: form
        }, cmd);
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$New$save = F2(function(_v0, shared) {
        var form = _v0.PU;
        return A2($author$project$Components$Membership$Form$save, form, shared);
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$New$subscriptions = function(model) {
        return $author$project$Components$Membership$Form$subscriptions(model.PU);
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$New$update = F2(function(msg, model) {
        var _v0 = A3($author$project$Components$Membership$Form$update, model.Ej, msg, model.PU);
        var form = _v0.a;
        var cmd = _v0.b;
        var outMsgs = _v0.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), cmd, outMsgs);
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$New$view = function(model) {
        return {
            fb: $author$project$Components$Membership$Form$view(model.PU),
            $2: 'Patient | Memberships'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$New$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Memberships$New$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Memberships$New$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Memberships$New$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Memberships$New$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Memberships$New$update,
        aid: $author$project$Pages$Patients$PatientId_String$Memberships$New$view
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$GotMemberships = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$All$Membership = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Membership$All$Record = F9(function(id, startDate, nextBillDate, status, plan, periodRateInCents, periodInMonths, state, isPrimary) {
        return {
            aef: id,
            aeF: isPrimary,
            UY: nextBillDate,
            WA: periodInMonths,
            WB: periodRateInCents,
            GW: plan,
            _0: startDate,
            s4: state,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Membership$All$EndingOrEnded = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$All$Renewing = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$All$Started = {
        $: 1
    };
    var $author$project$Api$Provider$Membership$All$Starting = {
        $: 0
    };
    var $author$project$Api$Provider$Membership$All$Terminating = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$All$decodeMembershipState = A2($elm$json$Json$Decode$andThen, function(_v0) {
        var isCurrent = _v0.a;
        var endDate = _v0.b;
        var contractExpires = _v0.c;
        var _v1 = _Utils_Tuple3(isCurrent, endDate, contractExpires);
        _v1$3: while(true){
            if (!_v1.a) {
                if (_v1.b.$ === 1) {
                    var _v2 = _v1.b;
                    return $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Starting);
                } else break _v1$3;
            } else if (_v1.b.$ === 1) {
                var _v3 = _v1.b;
                return $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Started);
            } else {
                if (_v1.c) return A3($elm$json$Json$Decode$map2, F2(function(type_, contractEndDate) {
                    return type_ === 'terminating' ? $author$project$Api$Provider$Membership$All$Terminating(contractEndDate) : $author$project$Api$Provider$Membership$All$Renewing(contractEndDate);
                }), A2($elm$json$Json$Decode$field, 'contract_type', $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$field, 'contract_end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode)));
                else break _v1$3;
            }
        }
        return A2($elm$json$Json$Decode$map, $author$project$Api$Provider$Membership$All$EndingOrEnded, A2($elm$json$Json$Decode$field, 'end_date', $author$project$Utils$Date$decode));
    }, A4($elm$json$Json$Decode$map3, F3(function(isCurrent, endDate, contractExpires) {
        return _Utils_Tuple3(isCurrent, endDate, contractExpires);
    }), A2($elm$json$Json$Decode$field, 'is_current', $elm$json$Json$Decode$bool), A2($elm$json$Json$Decode$field, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode)), A2($elm$json$Json$Decode$field, 'contract_expires', $elm$json$Json$Decode$bool)));
    var $author$project$Api$Provider$Membership$All$Other = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$All$Unconfirmed = {
        $: 0
    };
    var $author$project$Api$Provider$Membership$All$membershipStatusFromString = function(stringStatus) {
        if (stringStatus === 'unconfirmed') return $author$project$Api$Provider$Membership$All$Unconfirmed;
        else return $author$project$Api$Provider$Membership$All$Other(stringStatus);
    };
    var $author$project$Api$Provider$Membership$All$decoder = $elm$json$Json$Decode$list(A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'is_primary', $elm$json$Json$Decode$bool, false, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Membership$All$decodeMembershipState, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_rate_in_cents', $author$project$Currency$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Plan$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', A2($elm$json$Json$Decode$map, $author$project$Api$Provider$Membership$All$membershipStatusFromString, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Membership$All$Record))))))))))));
    var $author$project$Api$Provider$Membership$listDefaults = {
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$Provider$Membership$list = F4(function(apiClient, ownerId, optionals, toMsg) {
        var options = optionals($author$project$Api$Provider$Membership$listDefaults);
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Membership$All$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, A2($elm$core$List$cons, A2($author$project$Api$Param$string, 'owner', ownerId), $author$project$Api$Pagination$toApiParams(options.af_)), $author$project$Api$Data$requestTo($author$project$Api$Provider$Membership$membershipsPath)));
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships = function(model) {
        return A4($author$project$Api$Provider$Membership$list, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), function(opts) {
            return _Utils_update(opts, {
                af_: model.af_
            });
        }, $author$project$Pages$Patients$PatientId_String$Memberships$Top$GotMemberships);
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$GotPackages = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientPackage$All$PatientPackage = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientPackage$All$PatientPackageRecord = F8(function(id, packageName, priceInCents, purchasedOn, endedAt, expiresAt, status, prepaidCharges) {
        return {
            adr: endedAt,
            Ph: expiresAt,
            aef: id,
            VP: packageName,
            Xi: prepaidCharges,
            Br: priceInCents,
            XP: purchasedOn,
            ahy: status
        };
    });
    var $author$project$Api$Provider$PatientPackage$All$PrepaidCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientPackage$All$PrepaidChargeRecord = F6(function(id, originalQuantity, remainingQuantity, priceInCents, chargeItem, consumptionEvents) {
        return {
            lv: chargeItem,
            L$: consumptionEvents,
            aef: id,
            VF: originalQuantity,
            Br: priceInCents,
            Yx: remainingQuantity
        };
    });
    var $author$project$Api$Provider$PatientPackage$All$ConsumptionEvent = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientPackage$All$ConsumptionEventRecord = F4(function(occurredAt, quantity, chargeItemName, invoiceId) {
        return {
            acl: chargeItemName,
            RI: invoiceId,
            Vh: occurredAt,
            Bu: quantity
        };
    });
    var $author$project$Api$Provider$PatientPackage$All$consumptionEventDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_item_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'occurred_at', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientPackage$All$ConsumptionEventRecord))))));
    var $author$project$Api$Provider$PatientPackage$All$prepaidChargeDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'consumption_events', $elm$json$Json$Decode$list($author$project$Api$Provider$PatientPackage$All$consumptionEventDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge_item', $author$project$Api$Provider$ChargeItem$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'remaining_quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'original_quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientPackage$All$PrepaidChargeRecord))))))));
    var $author$project$Api$Provider$PatientPackage$All$Active = 0;
    var $author$project$Api$Provider$PatientPackage$All$Ended = 1;
    var $author$project$Api$Provider$PatientPackage$All$Inactive = 2;
    var $author$project$Api$Provider$PatientPackage$All$statusDecoder = A2($elm$json$Json$Decode$andThen, function(str) {
        switch(str){
            case 'active':
                return $elm$json$Json$Decode$succeed(0);
            case 'ended':
                return $elm$json$Json$Decode$succeed(1);
            case 'inactive':
                return $elm$json$Json$Decode$succeed(2);
            default:
                var other = str;
                return $elm$json$Json$Decode$fail('Unknown status: ' + other);
        }
    }, $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$PatientPackage$All$patientPackageDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'prepaid_charges', $elm$json$Json$Decode$list($author$project$Api$Provider$PatientPackage$All$prepaidChargeDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$Api$Provider$PatientPackage$All$statusDecoder, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'expires_at', A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Utils$Date$decode), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'ended_at', A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Utils$Date$decode), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'purchased_on', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'package_name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientPackage$All$PatientPackageRecord))))))))));
    var $author$project$Api$Provider$PatientPackage$All$listDecoder = $elm$json$Json$Decode$list($author$project$Api$Provider$PatientPackage$All$patientPackageDecoder);
    var $author$project$Api$Provider$PatientPackage$All$packagesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'patient_packages'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PatientPackage$All$list = F3(function(client, patientId, toMsg) {
        return A4($author$project$Api$Data$get, client, $author$project$Api$Provider$PatientPackage$All$listDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'patient_id', patientId)
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$PatientPackage$All$packagesPath)));
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchPackages = function(model) {
        return A3($author$project$Api$Provider$PatientPackage$All$list, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Pages$Patients$PatientId_String$Memberships$Top$GotPackages);
    };
    var $author$project$Components$Patient$PackageDetailsModal$init = {
        cW: $elm$core$Set$empty,
        ys: false,
        VN: $elm$core$Maybe$Nothing,
        nh: $elm$core$Maybe$Nothing,
        V8: $elm$core$Maybe$Nothing
    };
    var $author$project$Components$PatientsList$urlParams = function(model) {
        var filters = model.g;
        var queryParams = _List_fromArray([
            $elm$core$List$isEmpty(filters.g) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'filter', A2($elm$core$String$join, ',', A2($elm$core$List$map, $author$project$Api$Provider$Patient$filterToString, filters.g)))),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('patients_q'), filters.agq),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('patients_company'), filters.fl),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('patients_plan'), filters.agd),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('patients_location_group'), filters.f0),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('patients_location'), filters.Tp),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('patients_practitioner'), filters.Xa),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('patients_affiliate'), filters.pr)
        ]);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$init = F5(function(session, practice, patient, shared, _v0) {
        var query = _v0.Bz;
        var model = {
            Ej: shared.Ej,
            jd: $author$project$Api$Data$NotAsked,
            bc: $elm$core$Maybe$Nothing,
            c8: $author$project$Components$Patient$PackageDetailsModal$init,
            Ah: A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? $author$project$Api$Data$Loading : $author$project$Api$Data$NotAsked,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            V7: patient,
            W1: practice,
            Z$: session,
            DS: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Components$PatientsList$urlParams, shared.af4))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships(model),
            A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchPackages(model) : $elm$core$Platform$Cmd$none
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked = {
        $: 1
    };
    var $author$project$Components$Patient$CreateMembershipModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked);
    };
    var $author$project$Components$Patient$PackageDetailsModal$Close = {
        $: 0
    };
    var $author$project$Components$Patient$PackageDetailsModal$subscriptions = function(model) {
        return model.ys ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$PackageDetailsModal$Close) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$subscriptions = function(_v0) {
        var modal = _v0.bc;
        var packageDetailsModal = _v0.c8;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$CreateMembershipModal$subscriptions, modal))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg, $author$project$Components$Patient$PackageDetailsModal$subscriptions(packageDetailsModal))
        ]));
    };
    var $author$project$Components$Patient$CreateMembershipModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Patient$CreateMembershipModal$Retail = {
        $: 0
    };
    var $author$project$Components$Patient$CreateMembershipModal$init = F3(function(urlParams, companyAccounts, patient) {
        return {
            LK: companyAccounts,
            V7: patient,
            sK: $author$project$Components$Patient$CreateMembershipModal$Retail,
            DS: urlParams
        };
    });
    var $author$project$Utils$NonEmpty$NonEmpty = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Utils$NonEmpty$init = $author$project$Utils$NonEmpty$NonEmpty;
    var $author$project$Api$Provider$CompanyAccount$ForPatient$isEligible = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$isEligible(shared);
    };
    var $author$project$Components$Patient$PackageDetailsModal$open = F3(function(patientId, _package, model) {
        return _Utils_update(model, {
            cW: $elm$core$Set$empty,
            ys: true,
            VN: $elm$core$Maybe$Just(_package),
            nh: $elm$core$Maybe$Nothing,
            V8: $elm$core$Maybe$Just(patientId)
        });
    });
    var $author$project$Components$Patient$PackageDetailsModal$openWithPrice = F4(function(patientId, _package, price, model) {
        return _Utils_update(model, {
            cW: $elm$core$Set$empty,
            ys: true,
            VN: $elm$core$Maybe$Just(_package),
            nh: $elm$core$Maybe$Just(price),
            V8: $elm$core$Maybe$Just(patientId)
        });
    });
    var $author$project$Api$Provider$PatientPackage$All$priceInCents = function(_v0) {
        var record = _v0;
        return record.Br;
    };
    var $author$project$Components$Patient$CreateMembershipModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Patient$CreateMembershipModal$CreationFailed = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$CreateMembershipModal$CreationSucceeded = {
        $: 2
    };
    var $author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations = function(_v0) {
        var record = _v0.b;
        return record.LQ;
    };
    var $author$project$Components$Patient$CreateMembershipModal$Enrolled = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyAccount$ForPatient$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$id(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Components$Patient$CreateMembershipModal$enrollDependent = F3(function(apiClient, companyAccount, patient) {
        var maybeCompanyRegistrationId = A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id, $elm$core$List$head(A2($elm$core$List$filter, function(registration) {
            return _Utils_eq($author$project$Api$Provider$Patient$Min$id($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)), $author$project$Api$Provider$Patient$One$id(patient));
        }, $author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(companyAccount))));
        if (!maybeCompanyRegistrationId.$) {
            var companyRegistrationId = maybeCompanyRegistrationId.a;
            var companyId = $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount));
            return A6($author$project$Api$Provider$Company$Registration$enroll, apiClient, companyId, $author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount), companyRegistrationId, $elm$json$Json$Encode$object(_List_Nil), $author$project$Components$Patient$CreateMembershipModal$Enrolled);
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember = function(_v0) {
        var record = _v0.b;
        return record.RY;
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$isSubscriber(shared);
    };
    var $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber = function(_v0) {
        var record = _v0.b;
        return record.$r;
    };
    var $author$project$Components$Patient$CreateMembershipModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var patientId = $author$project$Api$Provider$Patient$One$id(model.V7);
                var _v2 = model.sK;
                if (!_v2.$) return _Utils_Tuple3(model, A2($author$project$Ports$Navigation$pushRoute, model.DS, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New({
                    V8: patientId
                })), $elm$core$Maybe$Nothing);
                else {
                    var sponsor = _v2.a;
                    var subscriber = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(sponsor);
                    var isSubscriberEnrolled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember, $elm$core$List$head(A2($elm$core$List$filter, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber, $author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(sponsor)))));
                    var isSubscriber = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq(patientId), A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, subscriber)));
                    var _v3 = _Utils_Tuple2(isSubscriber, isSubscriberEnrolled);
                    if (!_v3.a) {
                        if (!_v3.b) {
                            var companyId = $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(sponsor));
                            return _Utils_Tuple3(model, A2($author$project$Ports$Navigation$pushRoute, $author$project$Utils$QueryParameter$fromList(_List_fromArray([
                                _Utils_Tuple2('filter', 'all'),
                                _Utils_Tuple2('q', A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, subscriber)))
                            ])), $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                fl: companyId
                            })), $elm$core$Maybe$Nothing);
                        } else return _Utils_Tuple3(model, A3($author$project$Components$Patient$CreateMembershipModal$enrollDependent, apiClient, sponsor, model.V7), $elm$core$Maybe$Nothing);
                    } else {
                        var companyAccountId = $author$project$Api$Provider$CompanyAccount$ForPatient$id(sponsor);
                        return _Utils_Tuple3(model, A2($author$project$Ports$Navigation$pushRoute, A2($elm$core$List$append, $author$project$Utils$QueryParameter$fromList(_List_fromArray([
                            _Utils_Tuple2('company_account', companyAccountId)
                        ])), model.DS), $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New({
                            V8: patientId
                        })), $elm$core$Maybe$Nothing);
                    }
                }
            case 1:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Components$Patient$CreateMembershipModal$CloseModal));
            case 2:
                var membershipType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    sK: membershipType
                }), $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Components$Patient$CreateMembershipModal$CreationSucceeded));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Just($author$project$Components$Patient$CreateMembershipModal$CreationFailed(error)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
                }
        }
    });
    var $author$project$Components$Patient$PackageDetailsModal$close = function(model) {
        return _Utils_update(model, {
            cW: $elm$core$Set$empty,
            ys: false,
            VN: $elm$core$Maybe$Nothing,
            nh: $elm$core$Maybe$Nothing,
            V8: $elm$core$Maybe$Nothing
        });
    };
    var $author$project$Components$Patient$PackageDetailsModal$update = F2(function(msg, model) {
        if (!msg.$) return _Utils_Tuple2($author$project$Components$Patient$PackageDetailsModal$close(model), $elm$core$Platform$Cmd$none);
        else {
            var chargeId = msg.a;
            var newExpanded = A2($elm$core$Set$member, chargeId, model.cW) ? A2($elm$core$Set$remove, chargeId, model.cW) : A2($elm$core$Set$insert, chargeId, model.cW);
            return _Utils_Tuple2(_Utils_update(model, {
                cW: newExpanded
            }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top({
                V8: $author$project$Api$Provider$Patient$One$id(model.V7)
            }))
        ]), $author$project$Api$Pagination$toPageQuery(model.af_));
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl($author$project$Pages$Patients$PatientId_String$Memberships$Top$buildUrl(model));
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$update = F2(function(msg, model) {
        var patient = model.V7;
        switch(msg.$){
            case 0:
                var membershipId = msg.a;
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top({
                    y0: membershipId,
                    V8: $author$project$Api$Provider$Patient$One$id(patient)
                })), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        jd: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    jd: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var eligibleCompanyAccounts = A2($elm$core$List$filter, $author$project$Api$Provider$CompanyAccount$ForPatient$isEligible, $author$project$Api$Provider$Patient$One$companyAccounts(patient));
                if (!eligibleCompanyAccounts.b) return _Utils_Tuple3(model, A2($author$project$Ports$Navigation$pushRoute, model.DS, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New({
                    V8: $author$project$Api$Provider$Patient$One$id(patient)
                })), _List_Nil);
                else {
                    var x = eligibleCompanyAccounts.a;
                    var xs = eligibleCompanyAccounts.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bc: $elm$core$Maybe$Just(A3($author$project$Components$Patient$CreateMembershipModal$init, model.DS, A2($author$project$Utils$NonEmpty$init, x, xs), model.V7))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$fromList(_List_fromArray([
                    _Utils_Tuple2('patient', $author$project$Api$Provider$Patient$One$id(patient))
                ])), $author$project$Spa$Generated$Route$Charges__New), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v3 = model.bc;
                if (!_v3.$) {
                    var modal = _v3.a;
                    var _v4 = A3($author$project$Components$Patient$CreateMembershipModal$update, model.Ej, subMsg, modal);
                    var createModal_ = _v4.a;
                    var cmd = _v4.b;
                    var maybeEvent = _v4.c;
                    var _v5 = function() {
                        if (!maybeEvent.$) switch(maybeEvent.a.$){
                            case 0:
                                var _v7 = maybeEvent.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, _List_Nil);
                            case 2:
                                var _v8 = maybeEvent.a;
                                return _Utils_Tuple3($elm$core$Maybe$Nothing, A2($author$project$Ports$Navigation$pushRoute, model.DS, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: $author$project$Api$Provider$Patient$One$id(patient)
                                })), _List_fromArray([
                                    $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7))
                                ]));
                            default:
                                var error = maybeEvent.a.a;
                                return _Utils_Tuple3($elm$core$Maybe$Just(createModal_), $elm$core$Platform$Cmd$none, _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                                ]));
                        }
                        else return _Utils_Tuple3($elm$core$Maybe$Just(createModal_), $elm$core$Platform$Cmd$none, _List_Nil);
                    }();
                    var newModal = _v5.a;
                    var cmdFromEvent = _v5.b;
                    var outMsgs = _v5.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bc: newModal
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmdFromEvent,
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg, cmd)
                    ])), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    jd: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$Memberships$Top$fetchMemberships(newModel),
                    $author$project$Pages$Patients$PatientId_String$Memberships$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 6:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Ah: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var _package = msg.a;
                var patientId = $author$project$Api$Provider$Patient$One$id(model.V7);
                var modalWithPackage = function() {
                    var _v9 = $author$project$Api$Provider$PatientPackage$All$priceInCents(_package);
                    if (!_v9.$) {
                        var price = _v9.a;
                        return A4($author$project$Components$Patient$PackageDetailsModal$openWithPrice, patientId, _package, price, model.c8);
                    } else return A3($author$project$Components$Patient$PackageDetailsModal$open, patientId, _package, model.c8);
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    c8: modalWithPackage
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v10 = A2($author$project$Components$Patient$PackageDetailsModal$update, subMsg, model.c8);
                var newModal = _v10.a;
                var cmd = _v10.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    c8: newModal
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg, cmd), _List_Nil);
        }
    });
    var $author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Patient$CreateMembershipModal$Sponsored = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$CreateMembershipModal$companyAccountDescription = F2(function(companyAccount, patient) {
        var name = $author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount));
        var maybeSubscriber = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount);
        var isSubscriber = function() {
            var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, maybeSubscriber);
            if (!_v0.$) {
                var id = _v0.a;
                return _Utils_eq(id, $author$project$Api$Provider$Patient$One$id(patient));
            } else return false;
        }();
        return _Utils_ap(name, function() {
            if (isSubscriber) return ' (employee)';
            else {
                var subscriberName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, maybeSubscriber));
                return ' (dependent of ' + (subscriberName + ')');
            }
        }());
    });
    var $author$project$Utils$NonEmpty$head = function(_v0) {
        var head_ = _v0.a;
        return head_;
    };
    var $author$project$Utils$NonEmpty$toList = function(_v0) {
        var head_ = _v0.a;
        var rest = _v0.b;
        return A2($elm$core$List$cons, head_, rest);
    };
    var $author$project$Components$Patient$CreateMembershipModal$viewAlerts = F2(function(selectedCompanyAccount, patient) {
        var maybeSelectedSponsorshipIsSubscriber = A2($elm$core$Maybe$map, $elm$core$Basics$eq($author$project$Api$Provider$Patient$One$id(patient)), A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(selectedCompanyAccount)));
        var maybeIsSubscriberEnrolled = A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isCurrentMember, $elm$core$List$head(A2($elm$core$List$filter, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$isSubscriber, $author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(selectedCompanyAccount))));
        var _v0 = _Utils_Tuple2(maybeSelectedSponsorshipIsSubscriber, maybeIsSubscriberEnrolled);
        if (!_v0.a.$ && !_v0.a.a && !_v0.b.$) {
            var bool = _v0.b.a;
            var selectedSponsorshipName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(selectedCompanyAccount)));
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanMd(4),
                $author$project$Ui$Form$Group$inputSpanMd(8)
            ]), _List_fromArray([
                bool ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('This will enroll ' + ($author$project$Api$Provider$Patient$One$name(patient) + (' in membership of ' + selectedSponsorshipName)))
                ])) : A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('You will be redirected to ' + (selectedSponsorshipName + '\'s Employment Page'))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Patient$CreateMembershipModal$viewBody = F3(function(selectedType, companyAccounts, patient) {
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Membership Type'),
                $author$project$Ui$Form$Group$labelSpanMd(4),
                $author$project$Ui$Form$Group$inputSpanMd(8)
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Select retail membership'
                    }, _List_fromArray([
                        $author$project$Ui$Button$active(_Utils_eq($author$project$Components$Patient$CreateMembershipModal$Retail, selectedType)),
                        $author$project$Ui$Button$onClick($author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged($author$project$Components$Patient$CreateMembershipModal$Retail))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Retail')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Select sponsored membership'
                    }, _List_fromArray([
                        $author$project$Ui$Button$active(!_Utils_eq($author$project$Components$Patient$CreateMembershipModal$Retail, selectedType)),
                        $author$project$Ui$Button$onClick($author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged($author$project$Components$Patient$CreateMembershipModal$Sponsored($author$project$Utils$NonEmpty$head(companyAccounts))))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Sponsored')
                    ]))
                ]))
            ])),
            function() {
                if (selectedType.$ === 1) {
                    var companyAccount = selectedType.a;
                    var onSponsorSelected = function(companyAccountId) {
                        return $author$project$Components$Patient$CreateMembershipModal$MembershipTypeChanged($author$project$Components$Patient$CreateMembershipModal$Sponsored(A2($elm$core$Maybe$withDefault, companyAccount, $elm$core$List$head(A2($elm$core$List$filter, function(elem) {
                            return _Utils_eq($author$project$Api$Provider$CompanyAccount$ForPatient$id(elem), companyAccountId);
                        }, $author$project$Utils$NonEmpty$toList(companyAccounts))))));
                    };
                    var companyAccountOptions = A2($elm$core$List$map, function(companyAccount_) {
                        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount_)), A2($author$project$Components$Patient$CreateMembershipModal$companyAccountDescription, companyAccount_, patient));
                    }, $author$project$Utils$NonEmpty$toList(companyAccounts));
                    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('Sponsor'),
                            $author$project$Ui$Form$Group$labelSpanMd(4),
                            $author$project$Ui$Form$Group$inputSpanMd(8)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount))),
                                $author$project$Ui$Form$Select$onChange(onSponsorSelected)
                            ]), companyAccountOptions)
                        ])),
                        A2($author$project$Components$Patient$CreateMembershipModal$viewAlerts, companyAccount, patient)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    });
    var $author$project$Components$Patient$CreateMembershipModal$ConfirmButtonClicked = {
        $: 0
    };
    var $author$project$Components$Patient$CreateMembershipModal$viewFooter = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Cancel and close modal'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked)
        ]), _List_fromArray([
            $elm$html$Html$text('Cancel')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Confirm membership'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$onClick($author$project$Components$Patient$CreateMembershipModal$ConfirmButtonClicked)
        ]), _List_fromArray([
            $elm$html$Html$text('Confirm')
        ]))
    ]);
    var $author$project$Components$Patient$CreateMembershipModal$view = function(_v0) {
        var selectedMembershipType = _v0.sK;
        var companyAccounts = _v0.LK;
        var patient = _v0.V7;
        return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$CreateMembershipModal$CloseButtonClicked, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Create a membership')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A3($author$project$Components$Patient$CreateMembershipModal$viewBody, selectedMembershipType, companyAccounts, patient)
            ])),
            $author$project$Ui$Modal$footer($author$project$Components$Patient$CreateMembershipModal$viewFooter)
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal = function(maybeModal) {
        if (!maybeModal.$) {
            var modal = maybeModal.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$ModalMsg, $author$project$Components$Patient$CreateMembershipModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$PatientPackage$All$expiresAt = function(_v0) {
        var record = _v0;
        return record.Ph;
    };
    var $author$project$Api$Provider$PatientPackage$All$packageName = function(_v0) {
        var record = _v0;
        return record.VP;
    };
    var $author$project$Api$Provider$PatientPackage$All$prepaidCharges = function(_v0) {
        var record = _v0;
        return record.Xi;
    };
    var $author$project$Components$Patient$PackageDetailsModal$ToggleChargeExpand = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientPackage$All$chargeItemName = function(_v0) {
        var record = _v0;
        return $author$project$Api$Provider$ChargeItem$Min$name(record.lv);
    };
    var $author$project$Api$Provider$PatientPackage$All$consumptionEvents = function(_v0) {
        var record = _v0;
        return record.L$;
    };
    var $author$project$Api$Provider$PatientPackage$All$originalQuantity = function(_v0) {
        var record = _v0;
        return record.VF;
    };
    var $author$project$Api$Provider$PatientPackage$All$prepaidChargeId = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PatientPackage$All$remainingQuantity = function(_v0) {
        var record = _v0;
        return record.Yx;
    };
    var $author$project$Api$Provider$PatientPackage$All$eventInvoiceId = function(_v0) {
        var record = _v0;
        return record.RI;
    };
    var $author$project$Api$Provider$PatientPackage$All$eventOccurredAt = function(_v0) {
        var record = _v0;
        return record.Vh;
    };
    var $author$project$Api$Provider$PatientPackage$All$eventQuantity = function(_v0) {
        var record = _v0;
        return record.Bu;
    };
    var $author$project$Components$Patient$PackageDetailsModal$viewConsumptionEvent = F3(function(maybePatientId, showLine, event) {
        var qty = $author$project$Api$Provider$PatientPackage$All$eventQuantity(event);
        var suffix = '  ' + ($elm$core$String$fromInt(qty) + ' utilized');
        var invoiceId = $author$project$Api$Provider$PatientPackage$All$eventInvoiceId(event);
        var date = A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', $author$project$Api$Provider$PatientPackage$All$eventOccurredAt(event));
        return A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$small,
            $author$project$Ui$Typography$muted,
            $author$project$Ui$Typography$margin(20)
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                A2($elm$html$Html$Attributes$style, 'display', 'flex'),
                A2($elm$html$Html$Attributes$style, 'align-items', 'flex-start')
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'display', 'flex'),
                    A2($elm$html$Html$Attributes$style, 'flex-direction', 'column'),
                    A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
                    A2($elm$html$Html$Attributes$style, 'margin-right', '10px'),
                    A2($elm$html$Html$Attributes$style, 'padding-top', '6px')
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        A2($elm$html$Html$Attributes$style, 'width', '6px'),
                        A2($elm$html$Html$Attributes$style, 'height', '6px'),
                        A2($elm$html$Html$Attributes$style, 'border-radius', '50%'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'currentColor'),
                        A2($elm$html$Html$Attributes$style, 'opacity', '0.4'),
                        A2($elm$html$Html$Attributes$style, 'flex-shrink', '0')
                    ]), _List_Nil),
                    showLine ? A2($elm$html$Html$div, _List_fromArray([
                        A2($elm$html$Html$Attributes$style, 'width', '1px'),
                        A2($elm$html$Html$Attributes$style, 'flex', '1'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'currentColor'),
                        A2($elm$html$Html$Attributes$style, 'opacity', '0.3'),
                        A2($elm$html$Html$Attributes$style, 'margin-bottom', '-22px')
                    ]), _List_Nil) : $elm$html$Html$text('')
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = _Utils_Tuple2(invoiceId, maybePatientId);
                        if (!_v0.a.$ && !_v0.b.$) {
                            var invId = _v0.a.a;
                            var patientId = _v0.b.a;
                            return A2($elm$html$Html$a, _List_fromArray([
                                $elm$html$Html$Attributes$href($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                    RI: invId,
                                    V8: patientId
                                }))),
                                A2($elm$html$Html$Attributes$style, 'text-decoration', 'underline')
                            ]), _List_fromArray([
                                $elm$html$Html$text(date)
                            ]));
                        } else return $elm$html$Html$text(date);
                    }(),
                    $elm$html$Html$text(suffix)
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Patient$PackageDetailsModal$viewConsumptionEvents = F2(function(maybePatientId, events) {
        var total = $elm$core$List$length(events);
        var indexedEvents = A2($elm$core$List$indexedMap, F2(function(i, e) {
            return _Utils_Tuple2(i, e);
        }), events);
        return A2($elm$html$Html$div, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'padding-left', '16px')
        ]), A2($elm$core$List$map, function(_v0) {
            var i = _v0.a;
            var e = _v0.b;
            return A3($author$project$Components$Patient$PackageDetailsModal$viewConsumptionEvent, maybePatientId, _Utils_cmp(i, total - 1) < 0, e);
        }, indexedEvents));
    });
    var $author$project$Components$Patient$PackageDetailsModal$viewPrepaidCharge = F3(function(maybePatientId, expandedCharges, prepaidCharge) {
        var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
        var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
        var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
        var events = $author$project$Api$Provider$PatientPackage$All$consumptionEvents(prepaidCharge);
        var hasEvents = !$elm$core$List$isEmpty(events);
        var chargeId = $author$project$Api$Provider$PatientPackage$All$prepaidChargeId(prepaidCharge);
        var isExpanded = A2($elm$core$Set$member, chargeId, expandedCharges);
        return A2($elm$html$Html$div, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(originalQty) + (' ' + name))
                ])),
                $elm$html$Html$text(' '),
                hasEvents ? A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Events$onClick($author$project$Components$Patient$PackageDetailsModal$ToggleChargeExpand(chargeId)),
                    A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
                    $elm$html$Html$Attributes$tabindex(0),
                    A2($elm$html$Html$Attributes$attribute, 'aria-expanded', isExpanded ? 'true' : 'false'),
                    A2($elm$html$Html$Attributes$style, 'cursor', 'pointer'),
                    $elm$html$Html$Attributes$class('link text-primary'),
                    A2($elm$html$Html$Attributes$style, 'text-decoration', 'none')
                ]), _List_fromArray([
                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)'))
                    ])),
                    isExpanded ? A2($elm$html$Html$span, _List_fromArray([
                        A2($elm$html$Html$Attributes$style, 'display', 'inline-flex'),
                        A2($elm$html$Html$Attributes$style, 'align-items', 'center'),
                        A2($elm$html$Html$Attributes$style, 'vertical-align', 'middle'),
                        A2($elm$html$Html$Attributes$style, 'margin-left', '4px')
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$chevronDown(_List_Nil)
                    ])) : $elm$html$Html$text('')
                ])) : A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)'))
                ]))
            ])),
            isExpanded && hasEvents ? A2($author$project$Components$Patient$PackageDetailsModal$viewConsumptionEvents, maybePatientId, events) : $elm$html$Html$text('')
        ]));
    });
    var $author$project$Components$Patient$PackageDetailsModal$viewModal = F4(function(_package, maybePrice, maybePatientId, expandedCharges) {
        var prepaidCharges_ = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(_package);
        var packageTotal = A2($elm$core$Maybe$withDefault, 'Price not available', A2($elm$core$Maybe$map, function(currency) {
            return '$' + $author$project$Currency$toString(currency);
        }, A2($elm$core$Maybe$map, function(price) {
            return $author$project$Currency$fromFloat(price);
        }, maybePrice)));
        var packageName_ = $author$project$Api$Provider$PatientPackage$All$packageName(_package);
        var expiresAt_ = A2($elm$core$Maybe$map, $justinmimbs$date$Date$format('MM/dd/yyyy'), $author$project$Api$Provider$PatientPackage$All$expiresAt(_package));
        return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$PackageDetailsModal$Close, _List_fromArray([
            $author$project$Ui$Modal$size(1)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Package Details')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Package'),
                        $author$project$Ui$Form$Group$labelSpanSm(3),
                        $author$project$Ui$Form$Group$inputSpanSm(9)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(packageName_)
                            ]))
                        ]))
                    ])),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Price'),
                        $author$project$Ui$Form$Group$labelSpanSm(3),
                        $author$project$Ui$Form$Group$inputSpanSm(9)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(packageTotal)
                            ]))
                        ]))
                    ])),
                    function() {
                        if (!expiresAt_.$) {
                            var expiryDate = expiresAt_.a;
                            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Expires'),
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(expiryDate)
                                    ]))
                                ]))
                            ]));
                        } else return $elm$html$Html$text('');
                    }(),
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Includes'),
                        $author$project$Ui$Form$Group$labelSpanSm(3),
                        $author$project$Ui$Form$Group$inputSpanSm(9)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A2($author$project$Components$Patient$PackageDetailsModal$viewPrepaidCharge, maybePatientId, expandedCharges), prepaidCharges_))
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Components$Patient$PackageDetailsModal$Close)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Close')
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Patient$PackageDetailsModal$view = function(model) {
        if (model.ys) {
            var _v0 = model.VN;
            if (!_v0.$) {
                var _package = _v0.a;
                return A4($author$project$Components$Patient$PackageDetailsModal$viewModal, _package, model.nh, model.V8, model.cW);
            } else return $elm$html$Html$text('');
        } else return $elm$html$Html$text('');
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal = function(modal) {
        return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$PackageDetailsModalMsg, $author$project$Components$Patient$PackageDetailsModal$view(modal));
    };
    var $author$project$Api$Provider$PatientPackage$All$activePackages = $elm$core$List$filter(function(_v0) {
        var record = _v0;
        return !record.ahy;
    });
    var $author$project$Ui$Element$Padding = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Element$p0 = $author$project$Ui$Element$Padding('p-0');
    var $author$project$Ui$Panel$viewKeyed = F2(function(options, keyedSections) {
        var optionsRecord = $author$project$Ui$Panel$optionsToRecord(options);
        return A3($elm$html$Html$Keyed$node, 'div', A2($elm$core$List$cons, $elm$html$Html$Attributes$class('panel'), A2($elm$core$List$cons, $elm$html$Html$Attributes$class(optionsRecord.s5), optionsRecord.vE)), A2($elm$core$List$filterMap, function(_v0) {
            var key = _v0.a;
            var maybeSection = _v0.b;
            return A2($elm$core$Maybe$map, function(section) {
                return _Utils_Tuple2(key, section);
            }, maybeSection);
        }, A2($elm$core$List$map, $elm$core$Tuple$mapSecond($author$project$Ui$Panel$sectionToContents(optionsRecord)), keyedSections)));
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$NewPackageClicked = {
        $: 2
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewNewPackageButton = A3($author$project$Ui$Button$view, {
        abP: 'New package'
    }, _List_fromArray([
        $author$project$Ui$Button$styled(0),
        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Memberships$Top$NewPackageClicked),
        $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
    ]), _List_fromArray([
        $elm$html$Html$text('New Package')
    ]));
    var $author$project$Ui$Margin$Bottom_2_00 = 3;
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$OpenPackageDetailsModal = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientPackage$All$purchasedOn = function(_v0) {
        var record = _v0;
        return record.XP;
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPrepaidCharge = function(prepaidCharge) {
        var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
        var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
        var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('text-muted'),
            A2($elm$html$Html$Attributes$style, 'margin-bottom', '20px')
        ]), _List_fromArray([
            $elm$html$Html$text($elm$core$String$fromInt(originalQty) + (' ' + (name + ' '))),
            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)'))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageItem = function(packageItem) {
        var purchasedOn = $author$project$Api$Provider$PatientPackage$All$purchasedOn(packageItem);
        var prepaidCharges = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(packageItem);
        var packageName = $author$project$Api$Provider$PatientPackage$All$packageName(packageItem);
        var packageDetailsButton = A3($author$project$Ui$Button$view, {
            abP: 'See package details'
        }, _List_fromArray([
            $author$project$Ui$Button$margin(20),
            $author$project$Ui$Button$margin(3),
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$styled(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Memberships$Top$OpenPackageDetailsModal(packageItem))
        ]), _List_fromArray([
            $elm$html$Html$text('See Package Details')
        ]));
        var expiresAt = $author$project$Api$Provider$PatientPackage$All$expiresAt(packageItem);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('list__item')
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text(packageName)
                ]))
            ])),
            !$elm$core$List$isEmpty(prepaidCharges) ? A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mb2
            ]), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPrepaidCharge, prepaidCharges)) : $author$project$Utils$Html$empty,
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('text-body-sm text-muted mb-1')
            ]), _List_fromArray([
                $elm$html$Html$text('Purchased on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, purchasedOn))
            ])),
            function() {
                if (!expiresAt.$) {
                    var expiryDate = expiresAt.a;
                    return A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-sm text-muted mb-1')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Expires on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expiryDate))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            packageDetailsButton
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel = function(model) {
        var _v0 = model.Ah;
        switch(_v0.$){
            case 3:
                var patientPackages = _v0.a;
                var activePackages = $author$project$Api$Provider$PatientPackage$All$activePackages(patientPackages);
                return A2($author$project$Ui$Panel$viewKeyed, _List_Nil, _List_fromArray([
                    _Utils_Tuple2('title', A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Packages')
                        ]))
                    ]))),
                    !$elm$core$List$isEmpty(activePackages) ? _Utils_Tuple2('packages-body', A2($author$project$Ui$Panel$body, _List_fromArray([
                        $author$project$Ui$Element$p0
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('list')
                        ]), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageItem, activePackages))
                    ]))) : _Utils_Tuple2('no-packages', A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('This patient has no packages')
                    ]))),
                    _Utils_Tuple2('footer', A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewNewPackageButton
                    ])))
                ]));
            case 1:
                return A2($author$project$Ui$Panel$viewKeyed, _List_Nil, _List_fromArray([
                    _Utils_Tuple2('title', A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Packages')
                        ]))
                    ]))),
                    _Utils_Tuple2('loading', A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textCenter
                        ]), _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]))
                    ])))
                ]));
            default:
                return $author$project$Utils$Html$empty;
        }
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$NewMembershipClicked = {
        $: 1
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$PaginationMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Phi$Phi = $elm$core$Basics$identity;
    var $author$project$Api$Phi$from = function(thing) {
        return thing;
    };
    var $author$project$Api$Pagination$headerTotalCount = function(_v0) {
        var model = _v0;
        return model.oQ;
    };
    var $author$project$Api$Provider$Patient$One$membershipThrough = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.T6;
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$MembershipClicked = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Membership$All$record_ = function(_v0) {
        var record = _v0;
        return record;
    };
    var $author$project$Api$Provider$Membership$All$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Membership$All$record_, function($) {
        return $.aef;
    });
    var $author$project$Api$Provider$Membership$All$nextBillDate = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Membership$All$record_, function($) {
        return $.UY;
    });
    var $author$project$Api$Provider$Membership$All$periodInMonths = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Membership$All$record_, function($) {
        return $.WA;
    });
    var $author$project$Api$Provider$Membership$All$periodRateInCents = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Membership$All$record_, function($) {
        return $.WB;
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$periodToString = function(periodInMonths) {
        switch(periodInMonths){
            case 1:
                return 'Monthly';
            case 3:
                return 'Quarterly';
            case 6:
                return 'Semi-annually';
            case 12:
                return 'Annually';
            default:
                return '/ ' + $elm$core$String$fromInt(periodInMonths);
        }
    };
    var $author$project$Api$Provider$Membership$All$plan = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Membership$All$record_, function($) {
        return $.GW;
    });
    var $author$project$Api$Provider$Membership$All$startDate = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Membership$All$record_, function($) {
        return $._0;
    });
    var $author$project$Api$Provider$Membership$All$state = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Membership$All$record_, function($) {
        return $.s4;
    });
    var $author$project$Api$Provider$Membership$All$status = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Membership$All$record_, function($) {
        return $.ahy;
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$statusToBadge = function(status) {
        var statusText = function() {
            if (!status.$) return 'unconfirmed';
            else {
                var status_ = status.a;
                return status_;
            }
        }();
        return A2($author$project$Ui$Badge$fromString, _List_Nil, statusText);
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewMembership = function(membership) {
        var status = $author$project$Api$Provider$Membership$All$status(membership);
        var startDate = $author$project$Api$Provider$Membership$All$startDate(membership);
        var planName = $author$project$Api$Provider$Plan$Min$name($author$project$Api$Provider$Membership$All$plan(membership));
        return A2($elm$html$Html$a, _List_fromArray([
            $elm$html$Html$Attributes$class('list__item'),
            $elm$html$Html$Attributes$class('list__item--clickable'),
            $elm$html$Html$Events$onClick($author$project$Pages$Patients$PatientId_String$Memberships$Top$MembershipClicked($author$project$Api$Provider$Membership$All$id(membership)))
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flex items-center mb-025')
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    function() {
                        var _v0 = $author$project$Api$Provider$Membership$All$nextBillDate(membership);
                        if (!_v0.$) return A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('mr-025')
                        ]), $elm$core$List$singleton($elm$html$Html$text($author$project$Currency$format($author$project$Api$Provider$Membership$All$periodRateInCents(membership)))));
                        else return $elm$html$Html$text('');
                    }(),
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('mr-025')
                    ]), _List_fromArray([
                        $elm$html$Html$text(planName)
                    ])),
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('mr-025')
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Pages$Patients$PatientId_String$Memberships$Top$periodToString($author$project$Api$Provider$Membership$All$periodInMonths(membership)))
                    ]))
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('flex items-center')
                ]), _List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$Memberships$Top$statusToBadge(status)
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('text-body-sm text-muted')
            ]), function() {
                var _v1 = _Utils_Tuple2(status, $author$project$Api$Provider$Membership$All$state(membership));
                _v1$0: while(true)switch(_v1.b.$){
                    case 0:
                        if (!_v1.a.$) break _v1$0;
                        else {
                            var _v3 = _v1.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Starting on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
                            ]);
                        }
                    case 1:
                        if (!_v1.a.$) break _v1$0;
                        else {
                            var _v4 = _v1.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Memberships started on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
                            ]);
                        }
                    case 3:
                        if (!_v1.a.$) break _v1$0;
                        else {
                            var on = _v1.b.a;
                            return _List_fromArray([
                                $elm$html$Html$text('Contract terminating on ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), on)))
                            ]);
                        }
                    case 4:
                        if (!_v1.a.$) break _v1$0;
                        else {
                            var on = _v1.b.a;
                            return _List_fromArray([
                                $elm$html$Html$text('Contract renewing on ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), on)))
                            ]);
                        }
                    default:
                        if (!_v1.a.$) break _v1$0;
                        else {
                            var on = _v1.b.a;
                            return _List_fromArray([
                                $elm$html$Html$text('From ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate) + (' to ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, on))))
                            ]);
                        }
                }
                var _v2 = _v1.a;
                return _List_fromArray([
                    $elm$html$Html$text('Signed up on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, startDate))
                ]);
            }())
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel = F2(function(model, memberships) {
        var _v0 = model;
        var patient = _v0.V7;
        var urlParams = _v0.DS;
        var pagination = _v0.af_;
        var membershipsData = _v0.jd;
        var loading = function() {
            if (membershipsData.$ === 1) return true;
            else return false;
        }();
        var hasPagination = $author$project$Api$Pagination$headerTotalCount(pagination) > 10;
        return A2($author$project$Ui$Panel$viewKeyed, _List_Nil, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $elm$core$Maybe$Just(_Utils_Tuple2('title', A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Memberships')
                ]))
            ])))),
            function() {
                var _v1 = _Utils_Tuple2($author$project$Api$Provider$Patient$One$membershipThrough(patient), $elm$core$List$length(memberships));
                if (!_v1.a.$) {
                    var through = _v1.a.a;
                    return $elm$core$Maybe$Just(A2($elm$core$Tuple$pair, 'heading', A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Membership through '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                            V8: $author$project$Api$Provider$Patient$Min$id(through)
                        }), _List_fromArray([
                            $author$project$Ui$Link$routeParams(urlParams)
                        ]), _List_fromArray([
                            $author$project$Api$Phi$text($author$project$Api$Phi$from($author$project$Api$Provider$Patient$Min$name(through)))
                        ]))
                    ]))));
                } else {
                    if (!_v1.b) return loading ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$core$Tuple$pair, 'body', A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('This patient has no memberships')
                    ]))));
                    else return $elm$core$Maybe$Nothing;
                }
            }(),
            $elm$core$Maybe$Just(_Utils_Tuple2('widget', A2($author$project$Ui$Panel$body, _List_fromArray([
                $author$project$Ui$Element$p0
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('list')
                ]), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewMembership, memberships))
            ])))),
            hasPagination ? $elm$core$Maybe$Just(A2($elm$core$Tuple$pair, 'pagination', A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Memberships$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                    $author$project$Ui$Pagination$List$loading(loading)
                ]), pagination))
            ])))) : $elm$core$Maybe$Nothing,
            $author$project$Api$Provider$Patient$One$isSynced(patient) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$core$Tuple$pair, 'footer', A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'New membership'
                }, _List_fromArray([
                    $author$project$Ui$Button$styled(0),
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Memberships$Top$NewMembershipClicked),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                ]), _List_fromArray([
                    $elm$html$Html$text('New Membership')
                ]))
            ]))))
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$view = function(model) {
        var pageTitle = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1) ? 'Patient | Memberships & Packages' : 'Patient | Memberships';
        return {
            fb: function() {
                var _v0 = model.jd;
                switch(_v0.$){
                    case 3:
                        var memberships = _v0.a;
                        return _List_fromArray([
                            A2($author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel, model, memberships),
                            A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel(model) : $author$project$Utils$Html$empty,
                            $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal(model.bc),
                            $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal(model.c8)
                        ]);
                    case 1:
                        return _List_fromArray([
                            A2($author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPanel, model, _List_Nil),
                            A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1) ? $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackagesPanel(model) : $author$project$Utils$Html$empty,
                            $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewModal(model.bc),
                            $author$project$Pages$Patients$PatientId_String$Memberships$Top$viewPackageDetailsModal(model.c8)
                        ]);
                    default:
                        return _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textCenter
                            ]), _List_fromArray([
                                $author$project$Ui$Spinner$view(_List_Nil)
                            ]))
                        ]);
                }
            }(),
            $2: pageTitle
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Memberships$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Memberships$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Memberships$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Memberships$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Memberships$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Memberships$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Memberships$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$init = F5(function(_v0, practice, patient, _v1, _v2) {
        var apiClient = _v1.Ej;
        var _v3 = A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Search for a patient... ',
                abE: $elm$core$Maybe$Nothing,
                adw: $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$id(patient))
            });
        }));
        var patientResourceFilter = _v3.a;
        var patientResourceFilterCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            hV: false,
            ab: false,
            m6: _List_Nil,
            cd: _List_Nil,
            c0: _List_Nil,
            c1: _List_Nil,
            ei: $elm$core$Maybe$Nothing,
            cf: $elm$core$Maybe$Nothing,
            V7: patient,
            rX: patientResourceFilter,
            W1: practice,
            bC: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg, patientResourceFilterCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$subscriptions = function(model) {
        return model.hV ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Api$Provider$PatientMerge$associations = function(_v0) {
        var record = _v0;
        return record.JG;
    };
    var $author$project$Api$Provider$PatientMerge$attributes = function(_v0) {
        var record = _v0;
        return record.vD;
    };
    var $author$project$Api$Provider$PatientMerge$externalRecords = function(_v0) {
        var record = _v0;
        return record.xD;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$GotPreview = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientMerge$patientMergesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'patient_merges'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PatientMerge$Merge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMerge$MergeRecords = F5(function(attributes, paymentOptions, externalRecords, integrationRecords, associations) {
        return {
            JG: associations,
            vD: attributes,
            xD: externalRecords,
            Rr: integrationRecords,
            Wm: paymentOptions
        };
    });
    var $author$project$Api$Provider$PatientMerge$Association = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMerge$AssociationRecord = F3(function(key, message, count) {
        return {
            Me: count,
            yy: key,
            ae1: message
        };
    });
    var $author$project$Api$Provider$PatientMerge$associationRecordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'count', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'message', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'key', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$AssociationRecord))));
    var $author$project$Api$Provider$PatientMerge$associationDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMerge$associationRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientMerge$Attribute = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMerge$AttributeRecord = F4(function(key, field, fromValue, toValue) {
        return {
            PD: field,
            fN: fromValue,
            yy: key,
            g4: toValue
        };
    });
    var $author$project$Api$Provider$PatientMerge$attributeRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_value', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'from_value', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'field', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'key', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$AttributeRecord)))));
    var $author$project$Api$Provider$PatientMerge$attributeDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMerge$attributeRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientMerge$ExternalRecord = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMerge$ExternalRecordRecord = F3(function(source, fromValue, toValue) {
        return {
            fN: fromValue,
            Hw: source,
            g4: toValue
        };
    });
    var $author$project$Api$Provider$PatientMerge$externalRecordRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_value', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'from_value', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$ExternalRecordRecord))));
    var $author$project$Api$Provider$PatientMerge$externalRecordDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMerge$externalRecordRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientMerge$Integration = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMerge$IntegrationRecord = F3(function(partner, fromValue, toValue) {
        return {
            fN: fromValue,
            VW: partner,
            g4: toValue
        };
    });
    var $author$project$Api$Provider$PatientMerge$integrationRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_value', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'from_value', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'partner', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$IntegrationRecord))));
    var $author$project$Api$Provider$PatientMerge$integrationDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMerge$integrationRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientMerge$PaymentOptions = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMerge$PaymentOptionsRecord = F2(function(fromValue, toValue) {
        return {
            fN: fromValue,
            g4: toValue
        };
    });
    var $author$project$Api$Provider$PatientMerge$PaymentSources = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMerge$PaymentSourcesRecord = F4(function(defaultSource, sources, stripeConnectId, cantKeep) {
        return {
            KY: cantKeep,
            ND: defaultSource,
            _I: sources,
            $e: stripeConnectId
        };
    });
    var $author$project$Api$Provider$PatientMerge$paymentSourcesRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'cant_keep', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_connect_id', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sources', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'default_source', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$PaymentSourcesRecord)))));
    var $author$project$Api$Provider$PatientMerge$paymentSourcesDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMerge$paymentSourcesRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientMerge$paymentOptionsRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'to_value', $author$project$Api$Provider$PatientMerge$paymentSourcesDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'from_value', $author$project$Api$Provider$PatientMerge$paymentSourcesDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$PaymentOptionsRecord)));
    var $author$project$Api$Provider$PatientMerge$paymentOptionsDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMerge$paymentOptionsRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientMerge$mergeRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'associations', $elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$associationDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'integration_records', $elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$integrationDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'external_records', $elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$externalRecordDecoder), A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'payment_options', $elm$json$Json$Decode$nullable($author$project$Api$Provider$PatientMerge$paymentOptionsDecoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'attributes', $elm$json$Json$Decode$list($author$project$Api$Provider$PatientMerge$attributeDecoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMerge$MergeRecords))))));
    var $author$project$Api$Provider$PatientMerge$mergeDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMerge$mergeRecordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientMerge$resultDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'result'
    ]), $author$project$Api$Provider$PatientMerge$mergeDecoder);
    var $author$project$Api$Provider$PatientMerge$postToPatientMerges = F6(function(apiClient, fromId, toId, isPreview, maybeOptions, toMsg) {
        var values = $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                _Utils_Tuple2('from_id', $elm$json$Json$Encode$string(fromId)),
                _Utils_Tuple2('to_id', $elm$json$Json$Encode$string(toId)),
                _Utils_Tuple2('preview', $elm$json$Json$Encode$bool(isPreview))
            ]),
            function() {
                if (!maybeOptions.$) {
                    var options = maybeOptions.a;
                    return _List_fromArray([
                        _Utils_Tuple2('attributes', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.vD)),
                        _Utils_Tuple2('transfer_payment_options', $elm$json$Json$Encode$bool(options.aau)),
                        _Utils_Tuple2('integration_records', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.Rr)),
                        _Utils_Tuple2('external_records', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, options.xD))
                    ]);
                } else return _List_Nil;
            }()
        ]));
        var body = $elm$json$Json$Encode$object(values);
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$PatientMerge$resultDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PatientMerge$patientMergesPath)));
    });
    var $author$project$Api$Provider$PatientMerge$preview = F4(function(apiClient, fromId, toId, toMsg) {
        return A6($author$project$Api$Provider$PatientMerge$postToPatientMerges, apiClient, fromId, toId, true, $elm$core$Maybe$Nothing, toMsg);
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$fetchPreview = F3(function(apiClient, fromId, toId) {
        return A4($author$project$Api$Provider$PatientMerge$preview, apiClient, fromId, toId, $author$project$Pages$Patients$PatientId_String$Merge$GotPreview);
    });
    var $author$project$Api$Provider$PatientMerge$attributeField = function(_v0) {
        var record = _v0;
        return record.PD;
    };
    var $author$project$Api$Provider$PatientMerge$attributeFromValue = function(_v0) {
        var record = _v0;
        return record.fN;
    };
    var $author$project$Api$Provider$PatientMerge$attributeKey = function(_v0) {
        var record = _v0;
        return record.yy;
    };
    var $author$project$Api$Provider$PatientMerge$attributeToValue = function(_v0) {
        var record = _v0;
        return record.g4;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$initAttributeRowModel = function(attribute) {
        var keep = function() {
            var _v0 = $author$project$Api$Provider$PatientMerge$attributeToValue(attribute);
            if (!_v0.$) return 'toValue';
            else return 'fromValue';
        }();
        return {
            aT: $author$project$Api$Provider$PatientMerge$attributeFromValue(attribute),
            aA: $author$project$Api$Provider$PatientMerge$attributeToValue(attribute),
            PD: $author$project$Api$Provider$PatientMerge$attributeField(attribute),
            t: keep,
            yy: $author$project$Api$Provider$PatientMerge$attributeKey(attribute)
        };
    };
    var $author$project$Api$Provider$PatientMerge$externalRecordFromValue = function(_v0) {
        var record = _v0;
        return record.fN;
    };
    var $author$project$Api$Provider$PatientMerge$externalRecordSource = function(_v0) {
        var record = _v0;
        return record.Hw;
    };
    var $author$project$Api$Provider$PatientMerge$externalRecordToValue = function(_v0) {
        var record = _v0;
        return record.g4;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$initExternalRecordRow = function(externalRecord) {
        var keep = function() {
            var _v0 = $author$project$Api$Provider$PatientMerge$externalRecordToValue(externalRecord);
            if (!_v0.$) return 'toValue';
            else return 'fromValue';
        }();
        return {
            aT: $author$project$Api$Provider$PatientMerge$externalRecordFromValue(externalRecord),
            aA: $author$project$Api$Provider$PatientMerge$externalRecordToValue(externalRecord),
            t: keep,
            Hw: $author$project$Api$Provider$PatientMerge$externalRecordSource(externalRecord)
        };
    };
    var $author$project$Api$Provider$PatientMerge$integrationFromValue = function(_v0) {
        var record = _v0;
        return record.fN;
    };
    var $author$project$Api$Provider$PatientMerge$integrationPartner = function(_v0) {
        var record = _v0;
        return record.VW;
    };
    var $author$project$Api$Provider$PatientMerge$integrationToValue = function(_v0) {
        var record = _v0;
        return record.g4;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$initIntegrationRow = function(integration) {
        var keep = function() {
            var _v0 = $author$project$Api$Provider$PatientMerge$integrationToValue(integration);
            if (!_v0.$) return 'toValue';
            else return 'fromValue';
        }();
        return {
            aT: $author$project$Api$Provider$PatientMerge$integrationFromValue(integration),
            aA: $author$project$Api$Provider$PatientMerge$integrationToValue(integration),
            t: keep,
            VW: $author$project$Api$Provider$PatientMerge$integrationPartner(integration)
        };
    };
    var $author$project$Api$Provider$PatientMerge$paymentOptionsFromValue = function(_v0) {
        var record = _v0;
        return record.fN;
    };
    var $author$project$Api$Provider$PatientMerge$paymentOptionsToValue = function(_v0) {
        var record = _v0;
        return record.g4;
    };
    var $author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId = function(_v0) {
        var record = _v0;
        return record.$e;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$initPaymentMethodRowModel = function(mergePaymentOptions) {
        var toValueHasNoStripeId = $author$project$Utils$Maybe$isNothing($author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId($author$project$Api$Provider$PatientMerge$paymentOptionsToValue(mergePaymentOptions)));
        var toValue = $author$project$Api$Provider$PatientMerge$paymentOptionsToValue(mergePaymentOptions);
        var fromValue = $author$project$Api$Provider$PatientMerge$paymentOptionsFromValue(mergePaymentOptions);
        return {
            aT: fromValue,
            aA: toValue,
            g5: toValueHasNoStripeId
        };
    };
    var $author$project$Api$Provider$PatientMerge$integrations = function(_v0) {
        var record = _v0;
        return record.Rr;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$PatientsMerged = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientMerge$merge = F5(function(apiClient, fromId, toId, options, toMsg) {
        return A6($author$project$Api$Provider$PatientMerge$postToPatientMerges, apiClient, fromId, toId, false, $elm$core$Maybe$Just(options), toMsg);
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$merge = function(model) {
        var toId = A2($elm$core$Maybe$withDefault, '', model.cf);
        var mergeOptions = {
            vD: A2($elm$core$List$map, function(att) {
                return att.yy;
            }, A2($elm$core$List$filter, function(att) {
                return att.t === 'fromValue';
            }, model.cd)),
            xD: A2($elm$core$List$map, function(att) {
                return att.Hw;
            }, A2($elm$core$List$filter, function(att) {
                return att.t === 'fromValue';
            }, model.c0)),
            Rr: A2($elm$core$List$map, function(att) {
                return att.VW;
            }, A2($elm$core$List$filter, function(att) {
                return att.t === 'fromValue';
            }, model.c1)),
            aau: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(opt) {
                return opt.g5;
            }, model.ei))
        };
        var fromId = $author$project$Api$Provider$Patient$One$id(model.V7);
        return A5($author$project$Api$Provider$PatientMerge$merge, model.Ej, fromId, toId, mergeOptions, $author$project$Pages$Patients$PatientId_String$Merge$PatientsMerged);
    };
    var $author$project$Api$Provider$PatientMerge$paymentOptions = function(_v0) {
        var record = _v0;
        return record.Wm;
    };
    var $author$project$Components$ResourceFilter$Patient$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = model.rX;
                if (!_v1.$) {
                    var patientResourceFilter = _v1.a;
                    var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, model.Ej, subMsg, patientResourceFilter);
                    var _v2 = function() {
                        var _v3 = patientResourceResult.adu;
                        if (!_v3.$) {
                            if (!_v3.a.$) return {
                                xK: A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, A2($author$project$Pages$Patients$PatientId_String$Merge$fetchPreview, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7)), $author$project$Components$ResourceFilter$Patient$value(patientResourceResult.zi))),
                                Tk: true,
                                bC: $elm$core$Maybe$Nothing,
                                Cl: $author$project$Components$ResourceFilter$Patient$value(patientResourceResult.zi)
                            };
                            else {
                                var _v4 = _v3.a;
                                return {
                                    xK: $elm$core$Platform$Cmd$none,
                                    Tk: model.ab,
                                    bC: model.bC,
                                    Cl: model.cf
                                };
                            }
                        } else return {
                            xK: $elm$core$Platform$Cmd$none,
                            Tk: model.ab,
                            bC: model.bC,
                            Cl: model.cf
                        };
                    }();
                    var selectedPatientId = _v2.Cl;
                    var loading = _v2.Tk;
                    var previewError = _v2.bC;
                    var fetchMergeCmd = _v2.xK;
                    var commands = _List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg, patientResourceResult.EQ),
                        fetchMergeCmd
                    ]);
                    var newModel = _Utils_update(model, {
                        ab: loading,
                        cf: selectedPatientId,
                        rX: $elm$core$Maybe$Just(patientResourceResult.zi),
                        bC: previewError
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(commands), patientResourceResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var response = msg.a;
                _v5$2: while(true)switch(response.$){
                    case 3:
                        var data = response.a;
                        var paymentMethodRowModel = A2($elm$core$Maybe$map, $author$project$Pages$Patients$PatientId_String$Merge$initPaymentMethodRowModel, $author$project$Api$Provider$PatientMerge$paymentOptions(data));
                        var integrationModels = A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Merge$initIntegrationRow, $author$project$Api$Provider$PatientMerge$integrations(data));
                        var externalRecordModels = A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Merge$initExternalRecordRow, $author$project$Api$Provider$PatientMerge$externalRecords(data));
                        var attributeRowModels = A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Merge$initAttributeRowModel, $author$project$Api$Provider$PatientMerge$attributes(data));
                        return _Utils_Tuple3(_Utils_update(model, {
                            ab: false,
                            m6: $author$project$Api$Provider$PatientMerge$associations(data),
                            cd: attributeRowModels,
                            c0: externalRecordModels,
                            c1: integrationModels,
                            ei: paymentMethodRowModel
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        if (response.a.$ === 6) {
                            var _v6 = response.a;
                            var status = _v6.a;
                            var errorMsg = _v6.b;
                            var baseError = 'We are not able to automatically merge into the selected patient, ';
                            var previewError = status === 406 ? _Utils_ap(baseError, errorMsg) : baseError + 'please contact Customer Support to get further assistance.';
                            return _Utils_Tuple3(_Utils_update(model, {
                                ab: false,
                                m6: _List_Nil,
                                cd: _List_Nil,
                                c0: _List_Nil,
                                c1: _List_Nil,
                                ei: $elm$core$Maybe$Nothing,
                                bC: $elm$core$Maybe$Just(previewError)
                            }), $elm$core$Platform$Cmd$none, _List_Nil);
                        } else break _v5$2;
                    default:
                        break _v5$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    ab: false,
                    m6: _List_Nil,
                    cd: _List_Nil,
                    c0: _List_Nil,
                    c1: _List_Nil,
                    ei: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 2:
                var idx = msg.a;
                var option = msg.b;
                var _v7 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.cd);
                if (!_v7.$) {
                    var attributesRow = _v7.a;
                    var newList = A3($elm_community$list_extra$List$Extra$setAt, idx, _Utils_update(attributesRow, {
                        t: option
                    }), model.cd);
                    return _Utils_Tuple3(_Utils_update(model, {
                        cd: newList
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var option = msg.a;
                var newModel = function() {
                    var _v8 = model.ei;
                    if (!_v8.$) {
                        var paymentOptions = _v8.a;
                        return _Utils_update(model, {
                            ei: $elm$core$Maybe$Just(_Utils_update(paymentOptions, {
                                g5: option === 'fromValue'
                            }))
                        });
                    } else return model;
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var idx = msg.a;
                var option = msg.b;
                var _v9 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.c0);
                if (!_v9.$) {
                    var recordRow = _v9.a;
                    var newList = A3($elm_community$list_extra$List$Extra$setAt, idx, _Utils_update(recordRow, {
                        t: option
                    }), model.c0);
                    return _Utils_Tuple3(_Utils_update(model, {
                        c0: newList
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var idx = msg.a;
                var option = msg.b;
                var _v10 = A2($elm_community$list_extra$List$Extra$getAt, idx, model.c1);
                if (!_v10.$) {
                    var integrationRow = _v10.a;
                    var newList = A3($elm_community$list_extra$List$Extra$setAt, idx, _Utils_update(integrationRow, {
                        t: option
                    }), model.c1);
                    return _Utils_Tuple3(_Utils_update(model, {
                        c1: newList
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    hV: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    hV: false
                }), $author$project$Pages$Patients$PatientId_String$Merge$merge(model), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    hV: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                            V8: A2($elm$core$Maybe$withDefault, '', model.cf)
                        })), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Patients merged.')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalOpened = {
        $: 6
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$mergeDisabled = function(model) {
        return $author$project$Utils$Maybe$isNothing(model.cf) || model.ab;
    };
    var $author$project$Api$Provider$PatientMerge$associationKey = function(_v0) {
        var record = _v0;
        return record.yy;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$showAssociation = function(association) {
        var visibleAssociations = _List_fromArray([
            'note',
            'membership',
            'credit',
            'company_account',
            'invoices',
            'phone'
        ]);
        return A2($elm$core$List$member, $author$project$Api$Provider$PatientMerge$associationKey(association), visibleAssociations);
    };
    var $author$project$Api$Provider$PatientMerge$associationCount = function(_v0) {
        var record = _v0;
        return record.Me;
    };
    var $author$project$Api$Provider$PatientMerge$associationMessage = function(_v0) {
        var record = _v0;
        return record.ae1;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$viewAssociation = function(association) {
        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
            function() {
                var _v0 = $author$project$Api$Provider$PatientMerge$associationCount(association);
                if (!_v0.$) {
                    var count = _v0.a;
                    return A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($elm$core$String$fromInt(count))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Utils$Html$noBreakSpace,
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$PatientMerge$associationMessage(association))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$viewAssociations = function(_v0) {
        var loadingPreview = _v0.ab;
        var mergeAssociations = _v0.m6;
        var shownAssociations = A2($elm$core$List$filter, $author$project$Pages$Patients$PatientId_String$Merge$showAssociation, mergeAssociations);
        return loadingPreview || $elm$core$List$isEmpty(shownAssociations) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Associated Changes')
            ])),
            A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Merge$viewAssociation, shownAssociations))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForAttribute = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$keepOptions = function(_v0) {
        var disableA = _v0.a;
        var disableB = _v0.b;
        return _List_fromArray([
            A3($author$project$Ui$Form$Select$option, _List_fromArray([
                $author$project$Ui$Form$Select$itemDisabled(disableA)
            ]), $elm$core$Maybe$Just('fromValue'), 'Keep Option A'),
            A3($author$project$Ui$Form$Select$option, _List_fromArray([
                $author$project$Ui$Form$Select$itemDisabled(disableB)
            ]), $elm$core$Maybe$Just('toValue'), 'Keep Option B')
        ]);
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$cellStyle = function(selected) {
        return selected ? _List_fromArray([
            $elm$html$Html$Attributes$class('text-success')
        ]) : _List_fromArray([
            $elm$html$Html$Attributes$class('text-danger'),
            $elm$html$Html$Attributes$class('text-strike')
        ]);
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$viewHtml = function(string) {
        var _v0 = $hecrj$html_parser$Html$Parser$run(string);
        if (!_v0.$) {
            var html = _v0.a;
            return A2($elm$html$Html$div, _List_Nil, $hecrj$html_parser$Html$Parser$Util$toVirtualDom(html));
        } else return $elm$html$Html$text(string);
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell = F3(function(selectedOption, key, value) {
        var actualValue = function() {
            if (!value.$) {
                var str = value.a;
                return key === 'address' ? $author$project$Pages$Patients$PatientId_String$Merge$viewHtml(str) : $elm$html$Html$text(str);
            } else return $elm$html$Html$text('[Blank]');
        }();
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, $author$project$Pages$Patients$PatientId_String$Merge$cellStyle(selectedOption), _List_fromArray([
                actualValue
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeRow = F2(function(idx, rowModel) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(rowModel.PD)
                ]))
            ])),
            A3($author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell, rowModel.t === 'fromValue', rowModel.yy, rowModel.aT),
            A3($author$project$Pages$Patients$PatientId_String$Merge$viewAttributeValueCell, rowModel.t === 'toValue', rowModel.yy, rowModel.aA),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(rowModel.t)),
                    $author$project$Ui$Form$Select$onChange($author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForAttribute(idx))
                ]), $author$project$Pages$Patients$PatientId_String$Merge$keepOptions(_Utils_Tuple2(false, false)))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$viewAttributesTable = function(_v0) {
        var mergeAttributes = _v0.cd;
        var loadingPreview = _v0.ab;
        return loadingPreview || $elm$core$List$isEmpty(mergeAttributes) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Field')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Option A')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Option B')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('')
                ]))
            ]), A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewAttributeRow, mergeAttributes), _List_Nil)
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForExternalRecord = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordRow = F2(function(idx, model) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(model.Hw)
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, $author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.t === 'fromValue'), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '[Blank]', model.aT))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, $author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.t === 'toValue'), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '[Blank]', model.aA))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(model.t)),
                    $author$project$Ui$Form$Select$onChange($author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForExternalRecord(idx))
                ]), $author$project$Pages$Patients$PatientId_String$Merge$keepOptions(_Utils_Tuple2(false, false)))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordsTable = function(_v0) {
        var loadingPreview = _v0.ab;
        var mergeExternalRecords = _v0.c0;
        return loadingPreview || $elm$core$List$isEmpty(mergeExternalRecords) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                $elm$html$Html$text('External Records')
            ])),
            A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Service')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Option A')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Option B')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('')
                ]))
            ]), A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordRow, mergeExternalRecords), _List_Nil)
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForIntegration = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationRow = F2(function(idx, model) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(model.VW)
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, $author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.t === 'fromValue'), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '[Blank]', model.aT))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, $author$project$Pages$Patients$PatientId_String$Merge$cellStyle(model.t === 'toValue'), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '[Blank]', model.aA))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(model.t)),
                    $author$project$Ui$Form$Select$onChange($author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForIntegration(idx))
                ]), $author$project$Pages$Patients$PatientId_String$Merge$keepOptions(_Utils_Tuple2(false, false)))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationsTable = function(_v0) {
        var loadingPreview = _v0.ab;
        var mergeIntegrations = _v0.c1;
        return loadingPreview || $elm$core$List$isEmpty(mergeIntegrations) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Integrations')
            ])),
            A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Service')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Option A')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Option B')
                ])),
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('')
                ]))
            ]), A2($elm$core$List$indexedMap, $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationRow, mergeIntegrations), _List_Nil)
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$viewMergeConfirmModal = function(model) {
        return model.hV ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalClosed, _List_fromArray([
            $author$project$Components$HiConfirm$verb('merge'),
            $author$project$Components$HiConfirm$noun('patient record'),
            $author$project$Components$HiConfirm$detail($author$project$Api$Provider$Patient$One$id(model.V7) + (' into patient record ' + A2($elm$core$Maybe$withDefault, '', model.cf)))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForPaymentMethod = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep = function(_v0) {
        var record = _v0;
        return record.KY;
    };
    var $author$project$Api$Provider$PatientMerge$paymentSourcesDefaultSource = function(_v0) {
        var record = _v0;
        return record.ND;
    };
    var $author$project$Api$Provider$PatientMerge$paymentSourcesSources = function(_v0) {
        var record = _v0;
        return record._I;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption = F2(function(paymentSource, selectedOption) {
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, $author$project$Pages$Patients$PatientId_String$Merge$cellStyle(selectedOption), _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Stripe ID:')
                    ])),
                    $elm$html$Html$text(' ' + A2($elm$core$Maybe$withDefault, '[Blank]', $author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId(paymentSource)))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Default Source:')
                    ])),
                    $elm$html$Html$text(' ' + A2($elm$core$Maybe$withDefault, ' [Blank]', $author$project$Api$Provider$PatientMerge$paymentSourcesDefaultSource(paymentSource)))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Payment Sources:')
                    ])),
                    $elm$core$List$isEmpty($author$project$Api$Provider$PatientMerge$paymentSourcesSources(paymentSource)) ? $elm$html$Html$text(' None') : A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, function(source) {
                        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(source)
                        ]));
                    }, $author$project$Api$Provider$PatientMerge$paymentSourcesSources(paymentSource)))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOptionsTable = function(_v0) {
        var loadingPreview = _v0.ab;
        var mergePaymentOptions = _v0.ei;
        if (loadingPreview) return $author$project$Utils$Html$empty;
        else {
            if (mergePaymentOptions.$ === 1) return $author$project$Utils$Html$empty;
            else {
                var paymentOptions = mergePaymentOptions.a;
                var keepOption = paymentOptions.g5 ? 'fromValue' : 'toValue';
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$label, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Payment options')
                    ])),
                    A4($author$project$Ui$Table$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Option A')
                        ])),
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Option B')
                        ])),
                        A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('')
                        ]))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                            A2($author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption, paymentOptions.aT, paymentOptions.g5),
                            A2($author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOption, paymentOptions.aA, !paymentOptions.g5),
                            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(keepOption)),
                                    $author$project$Ui$Form$Select$onChange($author$project$Pages$Patients$PatientId_String$Merge$SelectOptionForPaymentMethod)
                                ]), $author$project$Pages$Patients$PatientId_String$Merge$keepOptions(_Utils_Tuple2($author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep(paymentOptions.aT), $author$project$Api$Provider$PatientMerge$paymentSourcesCantKeep(paymentOptions.aA))))
                            ]))
                        ]))
                    ]), _List_Nil),
                    paymentOptions.g5 && $author$project$Utils$Maybe$toBool($author$project$Api$Provider$PatientMerge$paymentSourcesStripeConnectId(paymentOptions.aA)) ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Migrating payment options will override the current payment options on the destination patient. This will prevent refunds of old payments that used the discarded options.')
                    ])) : $author$project$Utils$Html$empty
                ]));
            }
        }
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$conflictsPresent = function(_v0) {
        var mergeAttributes = _v0.cd;
        return !$elm$core$List$isEmpty(mergeAttributes);
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$viewPatientOptions = function(patientResourceFilter) {
        if (!patientResourceFilter.$) {
            var dependentResourceFilter = patientResourceFilter.a;
            return A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('form-group')
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Merge$PatientResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(0)
                ]), dependentResourceFilter))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$viewTopSection = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                    V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patient')
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$gray
                ]), _List_fromArray([
                    $elm$html$Html$text('  /  Merge ')
                ]))
            ])),
            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                $author$project$Ui$HorizontalRule$thin
            ])),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Merge Duplicate Patients')
            ])),
            A2($elm$html$Html$p, _List_fromArray([
                $elm$html$Html$Attributes$class('text-body-sm text-muted')
            ]), _List_fromArray([
                $elm$html$Html$text('We will attempt to merge all the information we can, including Demographics, Notes, Payment Options, Invoices, Memberships, and Employment Info. After merging, this patient record will automatically be archived.')
            ])),
            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Merge this patient record ')
            ])),
            $elm$html$Html$text($author$project$Api$Provider$Patient$One$id(model.V7)),
            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text(' with ')
            ])),
            function() {
                var _v0 = model.cf;
                if (!_v0.$) {
                    var id = _v0.a;
                    return $elm$html$Html$text(id);
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Pages$Patients$PatientId_String$Merge$viewPatientOptions(model.rX),
            function() {
                var _v1 = model.bC;
                if (!_v1.$) {
                    var error = _v1.a;
                    return A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(error)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }(),
            model.ab ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('Resolve differences')
                    ]))
                ])),
                A4($author$project$Ui$Table$view, _List_fromArray([
                    $author$project$Ui$Table$loading(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Field')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Option A')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Option B')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('')
                    ]))
                ]), _List_Nil, _List_Nil)
            ])) : $author$project$Pages$Patients$PatientId_String$Merge$conflictsPresent(model) ? $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Resolve differences')
            ])) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Patients$PatientId_String$Merge$viewMergeConfirmModal(model),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Patients$PatientId_String$Merge$viewTopSection(model),
                        $author$project$Pages$Patients$PatientId_String$Merge$viewAttributesTable(model),
                        $author$project$Pages$Patients$PatientId_String$Merge$viewPaymentOptionsTable(model),
                        $author$project$Pages$Patients$PatientId_String$Merge$viewExternalRecordsTable(model),
                        $author$project$Pages$Patients$PatientId_String$Merge$viewIntegrationsTable(model),
                        $author$project$Pages$Patients$PatientId_String$Merge$viewAssociations(model),
                        $author$project$Utils$Maybe$toBool(model.cf) && !model.ab && $author$project$Utils$Maybe$isNothing(model.bC) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('All other fields will be unchanged on the destination patient.')
                        ])) : $author$project$Utils$Html$empty
                    ])),
                    A2($author$project$Ui$Panel$footer, _List_fromArray([
                        $author$project$Ui$Element$justifyCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Edit({
                            V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                        }), _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Merge patients'
                        }, _List_fromArray([
                            $author$project$Ui$Button$danger,
                            $author$project$Ui$Button$disabled($author$project$Pages$Patients$PatientId_String$Merge$mergeDisabled(model)),
                            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Merge$MergeConfirmationModalOpened)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Merge')
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Patient | Merge'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Merge$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Merge$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Merge$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Merge$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Merge$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Merge$update,
        aid: $author$project$Pages$Patients$PatientId_String$Merge$view
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Note'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$update,
        aid: $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$view
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$Top$NotesMsg = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Note$Patient = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Notes$Top$init = F5(function(session, _v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var params = _v2.VU;
        var _v3 = A6($author$project$Components$Notes$init, shared.Ej, shared.HO, $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top({
            V8: params.V8
        }), query, $author$project$Api$Provider$Note$Patient(params.V8), $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session));
        var notes = _v3.a;
        var notesCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: notes
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, notesCmd));
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$Top$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Notes$subscriptions(model.rk));
    };
    var $author$project$Pages$Patients$PatientId_String$Notes$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Notes$update, model.Ej, subMsg, model.rk);
        var notes = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: notes
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Patients$PatientId_String$Notes$Top$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Notes$view(model.rk)),
            $2: 'Patient | Notes'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Notes$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Notes$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Notes$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Notes$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Notes$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Notes$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Notes$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotEmailAddress = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$EmailAddress$One$EmailAddress = $elm$core$Basics$identity;
    var $author$project$Api$Provider$EmailAddress$One$Record = F6(function(id, email, portalEnabled, isBounced, isRejected, isUnsubscribed) {
        return {
            OH: email,
            aef: id,
            RT: isBounced,
            Sp: isRejected,
            Sx: isUnsubscribed,
            WW: portalEnabled
        };
    });
    var $author$project$Api$Provider$EmailAddress$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_unsubscribed', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_rejected', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_bounced', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'portal_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$EmailAddress$One$Record)))))));
    var $author$project$Api$Provider$EmailAddress$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$EmailAddress$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$EmailAddress$emailAddressPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'email_address'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            patientId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$EmailAddress$retrieve = F3(function(apiClient, emailAddressId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$EmailAddress$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$EmailAddress$emailAddressPath(emailAddressId)));
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchEmailAddress = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$EmailAddress$retrieve, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotEmailAddress);
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotPatientNotifications = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Notification$All$Notification = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Notification$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Notification$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Notification$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init
    };
    var $author$project$Api$Provider$Notification$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Notification$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Notification$recipientNotificationsPath = function(recipient) {
        if (!recipient.$) {
            var patientId = recipient.a;
            return A2($author$project$Api$Data$pathAppend, _List_fromArray([
                'notifications'
            ]), $author$project$Api$Provider$Patient$patientPath(patientId));
        } else {
            var companyId = recipient.a;
            return A2($author$project$Api$Data$pathAppend, _List_fromArray([
                'notifications'
            ]), $author$project$Api$Provider$Company$companyPath(companyId));
        }
    };
    var $author$project$Api$Provider$Notification$list = F4(function(apiClient, recipient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Notification$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Notification$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Notification$recipientNotificationsPath(recipient))));
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList = function(model) {
        return A4($author$project$Api$Provider$Notification$list, model.Ej, $author$project$Api$Provider$Notification$Patient($author$project$Api$Provider$Patient$One$id(model.V7)), function(d) {
            return _Utils_update(d, {
                af_: model.af_,
                ahs: model.ahs
            });
        }, $author$project$Pages$Patients$PatientId_String$Notifications$Top$GotPatientNotifications);
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$init = F5(function(_v0, practice, patient, _v1, _v2) {
        var timeFormatter = _v1.HO;
        var apiClient = _v1.Ej;
        var query = _v2.Bz;
        var model = {
            Ej: apiClient,
            Ex: false,
            qs: $elm$core$Maybe$Nothing,
            rE: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            V7: patient,
            W1: practice,
            oc: $elm$core$Maybe$Nothing,
            ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init),
            HO: timeFormatter
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList(model),
            A2($author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchEmailAddress, apiClient, $author$project$Api$Provider$Patient$One$id(patient))
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$CloseModal = {
        $: 4
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$subscriptions = function(model) {
        var _v0 = model.oc;
        if (!_v0.$) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Notifications$Top$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$updateUrl = function(model) {
        var baseRoute = $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top({
            V8: $author$project$Api$Provider$Patient$One$id(model.V7)
        }));
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            baseRoute
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), $author$project$Api$Sort$toQuery(model.ahs))));
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        rE: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    rE: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$Notifications$Top$fetchList(newModel),
                    $author$project$Pages$Patients$PatientId_String$Notifications$Top$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var emailAddress = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            qs: $elm$core$Maybe$Just(emailAddress)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        var error = response.a;
                        if (error.$ === 5) return _Utils_Tuple3(_Utils_update(model, {
                            qs: $elm$core$Maybe$Nothing
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                        else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            case 3:
                var notification = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    oc: $elm$core$Maybe$Just(notification)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    oc: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$PaginationMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$EmailAddress$One$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$EmailAddress$One$isBounced = function(_v0) {
        var record = _v0;
        return record.RT;
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewBouncedEmailAlert = F2(function(emailAddress, bouncedEmailReset) {
        var _v0 = _Utils_Tuple2(bouncedEmailReset, $author$project$Api$Provider$EmailAddress$One$isBounced(emailAddress));
        if (!_v0.a && _v0.b) return A2($author$project$Ui$Alert$warning, _List_fromArray([
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$itemsCenter),
            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$spaceBetween)
        ]), _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $author$project$Ui$Icon$warning(_List_fromArray([
                    $author$project$Ui$Icon$danger
                ])),
                $elm$html$Html$text(' Emails to ' + ($author$project$Api$Provider$EmailAddress$One$email(emailAddress) + ' have bounced.'))
            ]))
        ]));
        else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$Notification$All$bodyHtml = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$bodyHtml(one);
    };
    var $author$project$Api$Provider$Notification$Shared$recipientEmail = function(_v0) {
        var record = _v0;
        return record.Yh;
    };
    var $author$project$Api$Provider$Notification$One$recipientEmail = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$recipientEmail(shared);
    };
    var $author$project$Api$Provider$Notification$All$recipientEmail = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$recipientEmail(one);
    };
    var $author$project$Api$Provider$Notification$All$subject = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$subject(one);
    };
    var $author$project$Api$Provider$Notification$All$subjectHtml = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$subjectHtml(one);
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewEmailModal = function(notification) {
        return A3($author$project$Ui$Modal$view, $author$project$Pages$Patients$PatientId_String$Notifications$Top$CloseModal, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Notification Email')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('email-preview')
                    ]), _List_fromArray([
                        function() {
                            var _v0 = $author$project$Api$Provider$Notification$All$recipientEmail(notification);
                            if (!_v0.$) {
                                var email = _v0.a;
                                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('To ')
                                    ])),
                                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('<' + (email + '>'))
                                    ])),
                                    $author$project$Ui$HorizontalRule$view(_List_Nil)
                                ]));
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Subject ')
                        ])),
                        A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('subject')
                        ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), $author$project$Utils$Dom$textToHtml(A2($elm$core$Maybe$withDefault, A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Notification$All$subject(notification)), $author$project$Api$Provider$Notification$All$subjectHtml(notification))))),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('body'), $author$project$Api$Phi$displayAttr), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), $author$project$Utils$Dom$textToHtml(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Notification$All$bodyHtml(notification)))))
                    ]))
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Notifications$Top$CloseModal)
                ]), _List_fromArray([
                    $elm$html$Html$text('Close')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotificationSkeleton = A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('mm/dd/yyyy at l:%MM %pp')
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Sent notification to email')
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$textSm
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Patient clicked notification at: Uknown')
            ]))
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$textSm
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Patient opened notification at: Uknown')
            ]))
        ]))
    ]));
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$ViewNotification = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Notification$Shared$attemptedAt = function(_v0) {
        var record = _v0;
        return record.JK;
    };
    var $author$project$Api$Provider$Notification$One$attemptedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$attemptedAt(shared);
    };
    var $author$project$Api$Provider$Notification$All$attemptedAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$attemptedAt(one);
    };
    var $author$project$Api$Provider$Notification$Shared$clickedAt = function(_v0) {
        var record = _v0;
        return record.Lh;
    };
    var $author$project$Api$Provider$Notification$One$clickedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$clickedAt(shared);
    };
    var $author$project$Api$Provider$Notification$All$clickedAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$clickedAt(one);
    };
    var $author$project$Api$Provider$Notification$Shared$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$Notification$One$errorMessage = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$errorMessage(shared);
    };
    var $author$project$Api$Provider$Notification$All$errorMessage = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$errorMessage(one);
    };
    var $author$project$Api$Provider$Notification$Shared$failedAt = function(_v0) {
        var record = _v0;
        return record.Pp;
    };
    var $author$project$Api$Provider$Notification$One$failedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$failedAt(shared);
    };
    var $author$project$Api$Provider$Notification$All$failedAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$failedAt(one);
    };
    var $author$project$Api$Provider$Notification$Shared$openedAt = function(_v0) {
        var record = _v0;
        return record.Vx;
    };
    var $author$project$Api$Provider$Notification$One$openedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$openedAt(shared);
    };
    var $author$project$Api$Provider$Notification$All$openedAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$openedAt(one);
    };
    var $author$project$Utils$Maybe$orElse = F2(function(elseMaybe, maybe) {
        if (!maybe.$) return maybe;
        else return elseMaybe;
    });
    var $author$project$Api$Provider$Notification$Shared$shortDescription = function(_v0) {
        var record = _v0;
        return record.Z7;
    };
    var $author$project$Api$Provider$Notification$One$shortDescription = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Notification$Shared$shortDescription(shared);
    };
    var $author$project$Api$Provider$Notification$All$shortDescription = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$shortDescription(one);
    };
    var $author$project$Api$Provider$Notification$One$shortDescriptionHtml = function(_v0) {
        var record = _v0.b;
        return record.Z8;
    };
    var $author$project$Api$Provider$Notification$All$shortDescriptionHtml = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$Notification$One$shortDescriptionHtml(one);
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotification = F2(function(timeFormatter, notification) {
        var description = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Notification$All$shortDescription(notification)) === 'Custom Message' ? $author$project$Api$Provider$Notification$All$subjectHtml(notification) : $author$project$Api$Provider$Notification$All$shortDescriptionHtml(notification);
        var attemptedOrFailedAt = A2($author$project$Utils$Maybe$orElse, $author$project$Api$Provider$Notification$All$failedAt(notification), $author$project$Api$Provider$Notification$All$attemptedAt(notification));
        return A2($author$project$Ui$ListGroup$item, _List_fromArray([
            $author$project$Ui$ListGroup$clearfix,
            $author$project$Ui$ListGroup$note
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                function() {
                    if (!attemptedOrFailedAt.$) {
                        var dateTime = attemptedOrFailedAt.a;
                        return $elm$html$Html$text(A2(timeFormatter, 0, dateTime));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                function() {
                    var _v1 = $author$project$Api$Provider$Notification$All$failedAt(notification);
                    if (!_v1.$) return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Attempted to send')
                    ]));
                    else return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Sent')
                    ]));
                }(),
                $author$project$Utils$Html$noBreakSpace,
                A3($author$project$Ui$Button$view, {
                    abP: 'View email: ' + A2($elm$core$Maybe$withDefault, 'notification', description)
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Notifications$Top$ViewNotification(notification))
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', description))
                    ]))
                ])),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v2 = $author$project$Api$Provider$Notification$All$recipientEmail(notification);
                    if (!_v2.$) {
                        var email = _v2.a;
                        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $author$project$Api$Phi$text($author$project$Api$Phi$from('to ' + email))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ])),
            function() {
                var _v3 = $author$project$Api$Provider$Notification$All$failedAt(notification);
                if (!_v3.$) return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, 'failed'),
                    $author$project$Utils$Html$noBreakSpace,
                    $author$project$Utils$FormErrors$viewError(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Notification$All$errorMessage(notification)))
                ]));
                else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace,
                    $author$project$Utils$Html$noBreakSpace
                ])),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patient clicked notification at:')
                ])),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v4 = $author$project$Api$Provider$Notification$All$clickedAt(notification);
                    if (!_v4.$) {
                        var dateTime = _v4.a;
                        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2(timeFormatter, 4, dateTime))
                        ]));
                    } else return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Never')
                    ]));
                }()
            ])),
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace,
                    $author$project$Utils$Html$noBreakSpace
                ])),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Patient opened notification at:')
                ])),
                $author$project$Utils$Html$noBreakSpace,
                function() {
                    var _v5 = $author$project$Api$Provider$Notification$All$openedAt(notification);
                    if (!_v5.$) {
                        var dateTime = _v5.a;
                        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(A2(timeFormatter, 4, dateTime))
                        ]));
                    } else return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Unknown')
                    ]));
                }()
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotifications = F2(function(notifications, timeFormatter) {
        return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotification(timeFormatter), notifications));
    });
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$view = function(_v0) {
        var notifications = _v0.rE;
        var timeFormatter = _v0.HO;
        var pagination = _v0.af_;
        var bouncedEmailReset = _v0.Ex;
        var emailAddress = _v0.qs;
        var selectedNotification = _v0.oc;
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Notifications')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        function() {
                            if (!emailAddress.$) {
                                var emailAddress_ = emailAddress.a;
                                return A2($author$project$Pages$Patients$PatientId_String$Notifications$Top$viewBouncedEmailAlert, emailAddress_, bouncedEmailReset);
                            } else return $elm$html$Html$text('');
                        }(),
                        function() {
                            if (notifications.$ === 3) {
                                var notifications_ = notifications.a;
                                return $elm$core$List$isEmpty(notifications_) ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('This patient has no notifications.')
                                ])) : A2($author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotifications, notifications_, timeFormatter);
                            } else return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$repeat, 10, $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewNotificationSkeleton));
                        }(),
                        A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Notifications$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(notifications))
                        ]), pagination))
                    ]))
                ])),
                function() {
                    if (!selectedNotification.$) {
                        var notification = selectedNotification.a;
                        return $author$project$Pages$Patients$PatientId_String$Notifications$Top$viewEmailModal(notification);
                    } else return $author$project$Utils$Html$empty;
                }()
            ]),
            $2: 'Patient | Notifications'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Notifications$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Notifications$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Notifications$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Notifications$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Notifications$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Notifications$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Notifications$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$Top$PopoverMsg = function(a) {
        return {
            $: 61,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$One$accountAccessSentAt = function(_v0) {
        var record = _v0.b;
        return record.Ik;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$GotEmailAddress = function(a) {
        return {
            $: 64,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$EmailAddress$retrieve, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotEmailAddress);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotIntegrationRecords = function(a) {
        return {
            $: 23,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$integrationRecords = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$IntegrationRecord$All$decoder), toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'integration_records'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$Patient$integrationRecords, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotIntegrationRecords);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotMembershipPatients = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$MembershipPatient = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$Record = F7(function(billedThroughDate, nextBillDate, nextInvoiceDueDate, isSponsored, owner, company, plan) {
        return {
            Kd: billedThroughDate,
            acy: company,
            Sr: isSponsored,
            UY: nextBillDate,
            U0: nextInvoiceDueDate,
            VM: owner,
            GW: plan
        };
    });
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Plan$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Company$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_sponsored', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_invoice_due_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'billed_through_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientOne$Record))))))));
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipPatient$ForPatientOne$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$MembershipPatient$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$MembershipPatient$ForPatientOne$MembershipPatient)));
    var $author$project$Api$Provider$Patient$MembershipPatient$membershipPatientsPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'membership_patients'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId));
    };
    var $author$project$Api$Provider$Patient$MembershipPatient$list = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$MembershipPatient$ForPatientOne$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$MembershipPatient$membershipPatientsPath(patientId)));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$fetchMembershipPatients = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$Patient$MembershipPatient$list, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotMembershipPatients);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotOutdatedDocuments = function(a) {
        return {
            $: 32,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientDocument$All$PatientDocument = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientDocument$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientDocument$One$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$PatientDocument$outdatedDocumentsPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'outdated_signed_documents'
        ]), $author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId));
    };
    var $author$project$Api$Provider$Patient$PatientDocument$listOutdated = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PatientDocument$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$PatientDocument$outdatedDocumentsPath(patientId)));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$fetchOutdatedPatientDocuments = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$Patient$PatientDocument$listOutdated, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotOutdatedDocuments);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotPackages = function(a) {
        return {
            $: 69,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientPackage$patientPackagesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'patient_packages'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$PatientPackage$list = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$PatientPackage$All$listDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, _List_fromArray([
            A2($author$project$Api$Param$string, 'patient_id', patientId)
        ]), $author$project$Api$Data$requestTo($author$project$Api$Provider$PatientPackage$patientPackagesPath)));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$fetchPackages = F2(function(apiClient, patientIdent) {
        return A3($author$project$Api$Provider$PatientPackage$list, apiClient, patientIdent, $author$project$Pages$Patients$PatientId_String$Top$GotPackages);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotDocuments = function(a) {
        return {
            $: 34,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$PatientDocument$list = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PatientDocument$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId)));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$fetchPatientDocuments = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$Patient$PatientDocument$list, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotDocuments);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotPatientMceEligibilities = function(a) {
        return {
            $: 53,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientMceEligibility$All$PatientMceEligibility = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMceEligibility$Shared$PatientMceEligibility = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientMceEligibility$Shared$Record = F4(function(id, name, status, message) {
        return {
            aef: id,
            ae1: message,
            zr: name,
            ahy: status
        };
    });
    var $author$project$Api$Provider$PatientMceEligibility$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientMceEligibility$Shared$Record)))));
    var $author$project$Api$Provider$PatientMceEligibility$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMceEligibility$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientMceEligibility$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientMceEligibility$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$MceEligibility$mceEligibilitiesPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patient_mce_eligibilities'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId));
    };
    var $author$project$Api$Provider$Patient$MceEligibility$list = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PatientMceEligibility$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$MceEligibility$mceEligibilitiesPath(patientId)));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$fetchPatientMceEligibility = F3(function(client, practice, patientId) {
        return $elm$core$List$isEmpty($author$project$Api$Provider$Practice$One$addons(practice)) ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Provider$Patient$MceEligibility$list, client, patientId, $author$project$Pages$Patients$PatientId_String$Top$GotPatientMceEligibilities);
    });
    var $author$project$Api$Provider$Patient$One$integrations = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.Rt;
    });
    var $author$project$Api$Provider$Patient$One$lastPortalAccessedAt = function(_v0) {
        var record = _v0.b;
        return record.SW;
    };
    var $author$project$Api$Provider$Patient$One$requestPendingDocumentsAcceptanceSentAt = function(_v0) {
        var record = _v0.b;
        return record.YG;
    };
    var $author$project$Api$Provider$SyncDetail$CoveragePlan = 1;
    var $author$project$Pages$Patients$PatientId_String$Top$GotAffiliateSyncDetail = function(a) {
        return {
            $: 65,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$retrieveSyncDetails = F2(function(apiClient, patientId) {
        return A4($author$project$Api$Provider$SyncDetail$retrieveAffiliate, apiClient, patientId, function(d) {
            return _Utils_update(d, {
                Fq: _List_fromArray([
                    0,
                    1
                ])
            });
        }, $author$project$Pages$Patients$PatientId_String$Top$GotAffiliateSyncDetail);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$init = F5(function(session, practice, patient, shared, _v0) {
        return _Utils_Tuple2({
            kQ: false,
            Ik: $author$project$Api$Provider$Patient$One$accountAccessSentAt(patient),
            hn: $elm$core$Maybe$Nothing,
            dt: $elm$core$Maybe$Nothing,
            hq: $elm$core$Set$empty,
            ve: $author$project$Api$Data$Loading,
            Ej: shared.Ej,
            hB: A7($author$project$Components$AuditTrailLog$init, session, shared.aaT, shared.HO, $elm$core$Maybe$Just('patient'), $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$id(patient)), $elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$createdAt(patient)), $elm$core$Maybe$Nothing),
            Ex: false,
            Mn: $elm$core$Maybe$Nothing,
            Mp: $author$project$Api$Data$NotAsked,
            h_: $elm$core$Maybe$Nothing,
            cP: shared.cP,
            p8: $elm$core$Maybe$Nothing,
            il: false,
            iu: $elm$core$Maybe$Nothing,
            fE: $elm$core$Maybe$Nothing,
            qs: $author$project$Api$Data$NotAsked,
            Fo: $author$project$Api$Data$NotAsked,
            mo: false,
            aea: shared.aea,
            aeb: shared.aeb,
            q$: A2($elm$core$List$map, function(_v1) {
                return false;
            }, $author$project$Api$Provider$Patient$One$integrations(patient)),
            fR: _List_Nil,
            Rr: $author$project$Api$Data$NotAsked,
            F3: $author$project$Shared$isHintAdmin(shared),
            SW: $author$project$Api$Provider$Patient$One$lastPortalAccessedAt(patient),
            i7: $elm$core$Maybe$Nothing,
            jb: $elm$core$Set$empty,
            m4: $elm$core$List$isEmpty($author$project$Api$Provider$Practice$One$addons(practice)) ? $author$project$Api$Data$NotAsked : $author$project$Api$Data$Loading,
            jc: $author$project$Api$Data$NotAsked,
            m5: false,
            T$: $author$project$Api$Data$Loading,
            UL: $elm$core$Maybe$Nothing,
            rQ: false,
            rR: $author$project$Api$Data$Loading,
            c8: $author$project$Components$Patient$PackageDetailsModal$init,
            Ah: $author$project$Api$Data$Loading,
            V7: patient,
            nn: $author$project$Api$Data$Loading,
            AC: $author$project$Api$Provider$Patient$One$requestPayInfoSentAt(patient),
            rW: $author$project$Api$Provider$Patient$One$requestPendingDocumentsAcceptanceSentAt(patient),
            A7: $author$project$Api$Data$NotAsked,
            aN: A3($author$project$Ui$Popover$init, 'engagement', false, $author$project$Pages$Patients$PatientId_String$Top$PopoverMsg),
            W1: practice,
            nY: false,
            df: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
            jV: false,
            oe: false,
            j5: false,
            j6: false,
            Z$: session,
            sY: false,
            ou: false,
            gX: $author$project$Api$Provider$Patient$One$companyAccounts(patient),
            HO: A2($author$project$Formatters$Time$init, shared.HP, shared.acJ),
            DS: A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Components$PatientsList$urlParams, shared.af4))
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Pages$Patients$PatientId_String$Top$fetchMembershipPatients, shared.Ej, $author$project$Api$Provider$Patient$One$id(patient)),
            A2($author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords, shared.Ej, $author$project$Api$Provider$Patient$One$id(patient)),
            A2($author$project$Pages$Patients$PatientId_String$Top$fetchPatientDocuments, shared.Ej, $author$project$Api$Provider$Patient$One$id(patient)),
            A2($author$project$Pages$Patients$PatientId_String$Top$fetchOutdatedPatientDocuments, shared.Ej, $author$project$Api$Provider$Patient$One$id(patient)),
            A3($author$project$Pages$Patients$PatientId_String$Top$fetchPatientMceEligibility, shared.Ej, practice, $author$project$Api$Provider$Patient$One$id(patient)),
            A2($author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress, shared.Ej, $author$project$Api$Provider$Patient$One$id(patient)),
            A2($author$project$Pages$Patients$PatientId_String$Top$retrieveSyncDetails, shared.Ej, $author$project$Api$Provider$Patient$One$id(patient)),
            A2($author$project$Pages$Patients$PatientId_String$Top$fetchPackages, shared.Ej, $author$project$Api$Provider$Patient$One$id(patient))
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$load = F2(function(shared, model) {
        var _v0 = shared.MO;
        if (_v0.$ === 3) {
            var patient = _v0.a;
            return _Utils_Tuple2(_Utils_update(model, {
                F3: $author$project$Shared$isHintAdmin(shared),
                V7: patient,
                gX: $author$project$Api$Provider$Patient$One$companyAccounts(patient)
            }), $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed = function(a) {
        return {
            $: 48,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg = function(a) {
        return {
            $: 58,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked = F2(function(a, b) {
        return {
            $: 36,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked = F2(function(a, b) {
        return {
            $: 20,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg = function(a) {
        return {
            $: 42,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg = function(a) {
        return {
            $: 39,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg = function(a) {
        return {
            $: 66,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg = function(a) {
        return {
            $: 63,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed = {
        $: 41
    };
    var $author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg = function(a) {
        return {
            $: 43,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg = function(a) {
        return {
            $: 72,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed = function(a) {
        return {
            $: 49,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$integrationRecordDropdownsSubscriptions = function(models) {
        return A2($elm$core$List$map, function(model) {
            return $author$project$Ui$Dropdown$subscriptions(model);
        }, models);
    };
    var $author$project$Components$Patient$AddDependentModal$Closed = {
        $: 0
    };
    var $author$project$Components$Patient$AddDependentModal$subscriptions = function(_v0) {
        var model = _v0;
        return model.Vw ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$AddDependentModal$Closed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Patient$AddSponsorshipModal$Closed = {
        $: 0
    };
    var $author$project$Components$Patient$AddSponsorshipModal$subscriptions = function(_v0) {
        var model = _v0;
        return model.Vw ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$AddSponsorshipModal$Closed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Patient$EditAthenaIdModal$Close = {
        $: 0
    };
    var $author$project$Components$Patient$EditAthenaIdModal$subscriptions = function(_v0) {
        var model = _v0;
        return model.Vw ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$EditAthenaIdModal$Close) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$Close = {
        $: 0
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$EditCustomFormAnswerModal$Close);
    };
    var $author$project$Components$Patient$ManagePortalAccessModal$Closed = {
        $: 0
    };
    var $author$project$Components$Patient$ManagePortalAccessModal$subscriptions = function(_v0) {
        var model = _v0;
        return model.Vw ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Patient$ManagePortalAccessModal$Closed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $elm$core$Platform$Sub$batch($author$project$Pages$Patients$PatientId_String$Top$integrationRecordDropdownsSubscriptions(model.fR)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$AddDependentModal$subscriptions, model.hn))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$AddSponsorshipModal$subscriptions, model.dt))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$CreateMembershipModal$subscriptions, model.h_))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$EditCustomFormAnswerModal$subscriptions, model.fE))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg, $author$project$Components$Patient$PackageDetailsModal$subscriptions(model.c8)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.Mn))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.UL))),
            model.m5 ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed) : $elm$core$Platform$Sub$none,
            model.il ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked($author$project$Api$Provider$Patient$One$id(model.V7))) : $elm$core$Platform$Sub$none,
            model.jV ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked($author$project$Api$Provider$Patient$One$id(model.V7))) : $elm$core$Platform$Sub$none,
            model.mo ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed) : $elm$core$Platform$Sub$none,
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed), model.df.b)),
            model.kQ ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed) : $elm$core$Platform$Sub$none,
            model.nY ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed) : $elm$core$Platform$Sub$none,
            $author$project$Components$AuditTrailLog$isOpen(model.hB) ? A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$subscriptions(model.hB)) : $elm$core$Platform$Sub$none,
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$ManagePortalAccessModal$subscriptions, model.i7))),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$EditAthenaIdModal$subscriptions, model.iu)))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$AddonRequestEmailSent = F2(function(a, b) {
        return {
            $: 55,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$BouncedEmailReset = function(a) {
        return {
            $: 68,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$DropdownMenuMsg = F2(function(a, b) {
        return {
            $: 22,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotEngagement = function(a) {
        return {
            $: 60,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$GotMembership = function(a) {
        return {
            $: 44,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$GotPayInfoUpdate = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$GotPendingDocsAcceptanceUpdate = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$MceActivationEmailSent = F2(function(a, b) {
        return {
            $: 57,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$PatientDetached = F2(function(a, b) {
        return {
            $: 37,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$PatientRestored = F2(function(a, b) {
        return {
            $: 21,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverAccepted = function(a) {
        return {
            $: 50,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$acceptEphiWaiver = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$Patient$acceptHipaaAuthorization, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverAccepted);
    });
    var $author$project$Api$Provider$Patient$AccountAccess$accountAccessSentAt = function(_v0) {
        var record = _v0;
        return record.Ik;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$metadata = function(_v0) {
        var record = _v0.b;
        return record.Uf;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$athenaMetadata = function(record) {
        var _v0 = $author$project$Api$Provider$IntegrationRecord$One$metadata(record);
        if (!_v0.$) {
            var metadata_ = _v0.a;
            return $elm$core$Maybe$Just(metadata_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$athenaMetadata(one);
    };
    var $author$project$Api$Provider$Patient$SyncDetail$coveragePlan = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.Mn;
    });
    var $author$project$Api$Provider$Patient$MceActivation$mceActivationsPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'mce_activation'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId));
    };
    var $author$project$Api$Provider$Patient$MceActivation$create = F4(function(apiClient, patientId, mcePracticeId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('mce_practice_id', $elm$json$Json$Encode$string(mcePracticeId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$MceActivation$mceActivationsPath(patientId))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotAccountAccessToken = function(a) {
        return {
            $: 74,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$AccountAccessToken$AccountAccessToken = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$AccountAccessToken$Record = F2(function(token, url) {
        return {
            aaf: token,
            aaT: url
        };
    });
    var $author$project$Api$Provider$Patient$AccountAccessToken$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'token', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$AccountAccessToken$Record))));
    var $author$project$Api$Provider$Patient$AccountAccessToken$impersonate = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$AccountAccessToken$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'account_access_tokens',
            'impersonate'
        ]), $author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$createAccountAccessToken = F2(function(apiClient, patient) {
        return A3($author$project$Api$Provider$Patient$AccountAccessToken$impersonate, apiClient, $author$project$Api$Provider$Patient$One$id(patient), $author$project$Pages$Patients$PatientId_String$Top$GotAccountAccessToken);
    });
    var $author$project$Api$Provider$Patient$disableSyncing = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'disable_syncing'
        ]), $author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Api$Provider$Patient$Shared$engagementStatus = function(_v0) {
        var shared = _v0;
        return shared.OU;
    };
    var $author$project$Api$Provider$Patient$One$engagementStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$engagementStatus(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$GotPlainSSN = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$fetchPlainSSN = F2(function(apiClient, patient) {
        return A3($author$project$Api$Provider$SocialSecurityNumber$retrieve, apiClient, $author$project$Api$Provider$Patient$One$id(patient), $author$project$Pages$Patients$PatientId_String$Top$GotPlainSSN);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushed = function(a) {
        return {
            $: 29,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$forcePushElation = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'force_push_elation'
        ]), $author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$forcePushElation = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$Patient$forcePushElation, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushed);
    });
    var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$id(shared);
    };
    var $author$project$Api$Provider$Integration$SharedWithInlinePartner$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Integration$Shared$id(shared);
    };
    var $author$project$Api$Provider$PatientMceEligibility$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PatientMceEligibility$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PatientMceEligibility$Shared$id(shared);
    };
    var $author$project$Components$Patient$AddSponsorshipModal$Employee = 0;
    var $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$Invalid = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$companiesCount = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.LH;
    });
    var $author$project$Components$Patient$AddSponsorshipModal$resetModel = F7(function(type_, apiClient, practice, patient, open_, usesEmployeeDivisions, requiresEmployeeDivisions) {
        if (!type_) {
            var _v1 = $author$project$Api$Provider$Practice$One$companiesCount(practice) > 0 ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$ResourceFilter$Company$init, apiClient, function(d) {
                return _Utils_update(d, {
                    Ee: 'Search for a company... ',
                    abE: $elm$core$Maybe$Nothing
                });
            })) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
            var companyResourceFilter = _v1.a;
            var companyResourceFilterCmd = _v1.b;
            return _Utils_Tuple2({
                pY: companyResourceFilter,
                xv: $author$project$Api$Data$NotAsked,
                Vw: open_,
                V7: patient,
                W1: practice,
                YJ: requiresEmployeeDivisions,
                gI: $elm$core$Maybe$Nothing,
                cq: $elm$core$Maybe$Nothing,
                eH: $elm$core$Maybe$Nothing,
                gL: $elm$core$Maybe$Nothing,
                sL: 0,
                ahy: $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing),
                ko: $elm$core$Maybe$Nothing,
                oG: $elm$core$Maybe$Nothing,
                aa1: usesEmployeeDivisions
            }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg, companyResourceFilterCmd));
        } else {
            var _v2 = A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
                return _Utils_update(d, {
                    Ee: 'Search for a patient... ',
                    abE: $elm$core$Maybe$Nothing
                });
            }));
            var patientResourceFilter = _v2.a;
            var patientResourceFilterCmd = _v2.b;
            return _Utils_Tuple2({
                pY: $elm$core$Maybe$Nothing,
                xv: $author$project$Api$Data$NotAsked,
                Vw: open_,
                V7: patient,
                W1: practice,
                YJ: requiresEmployeeDivisions,
                gI: $elm$core$Maybe$Nothing,
                cq: $elm$core$Maybe$Nothing,
                eH: $elm$core$Maybe$Nothing,
                gL: $elm$core$Maybe$Nothing,
                sL: type_,
                ahy: $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing),
                ko: $elm$core$Maybe$Nothing,
                oG: patientResourceFilter,
                aa1: usesEmployeeDivisions
            }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg, patientResourceFilterCmd));
        }
    });
    var $author$project$Components$Patient$AddSponsorshipModal$init = F3(function(apiClient, practice, patient) {
        return A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, practice, patient, true, false, false);
    });
    var $author$project$Api$Provider$CustomForm$answers = function(_v0) {
        var record = _v0;
        return record.pz;
    };
    var $author$project$Api$Provider$CustomForm$initEmptyAnswers = _List_fromArray([
        {
            NT: $elm$core$Maybe$Nothing,
            aef: '',
            $Y: ''
        }
    ]);
    var $author$project$Api$Provider$CustomForm$questionId = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CustomForm$questionType = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$CustomForm$title = function(_v0) {
        var record = _v0;
        return record.$2;
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$init = F4(function(patientId, question, formId, formResponseId) {
        var answers = $elm$core$List$isEmpty($author$project$Api$Provider$CustomForm$answers(question)) ? $author$project$Api$Provider$CustomForm$initEmptyAnswers : $author$project$Api$Provider$CustomForm$answers(question);
        return _Utils_Tuple2({
            pz: answers,
            Fz: formId,
            FA: $author$project$Api$Provider$CustomForm$questionId(question),
            xP: formResponseId,
            V8: patientId,
            $2: $author$project$Api$Provider$CustomForm$title(question),
            ah5: $author$project$Api$Provider$CustomForm$questionType(question)
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Plan$Shared$coveragePlan(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$initCoveragePlanRules = F3(function(model, plan, coverageRuleUsages) {
        var _v0 = A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan(plan));
        if (!_v0.$) {
            var coveragePlan = _v0.a;
            return A3($elm$core$Tuple$mapBoth, $elm$core$Maybe$Just, $elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg), A6($author$project$Components$Admin$CoveragePlans$Rules$init, model.Ej, model.Z$, $elm$core$Maybe$Just($author$project$Api$Provider$CoveragePlan$One$id(coveragePlan)), $author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan), $elm$core$Maybe$Just(coverageRuleUsages), {
                Ya: true
            }));
        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$initNetworkCoveragePlanRules = F3(function(model, coveragePlan, coverageRuleUsages) {
        if (!coveragePlan.$) {
            var coveragePlan_ = coveragePlan.a;
            return A3($elm$core$Tuple$mapBoth, $elm$core$Maybe$Just, $elm$core$Platform$Cmd$map($author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg), A6($author$project$Components$Admin$CoveragePlans$Rules$init, model.Ej, model.Z$, $elm$core$Maybe$Just($author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_)), $author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_), $elm$core$Maybe$Just(coverageRuleUsages), {
                Ya: true
            }));
        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Api$Provider$IntegrationRecord$Shared$integrationRecordId = function(_v0) {
        var record = _v0;
        return record.Rq;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$integrationRecordId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$IntegrationRecord$Shared$integrationRecordId(shared);
    };
    var $author$project$Api$Provider$IntegrationRecord$All$integrationRecordId = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$integrationRecordId(one);
    };
    var $author$project$Components$Patient$AddDependentModal$Adult = 0;
    var $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Patient$AddDependentModal$Invalid = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$AddDependentModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Patient$AddDependentModal$open = F4(function(apiClient, practice, patient, companyAccount) {
        var _v0 = $author$project$Api$Provider$Practice$One$companiesCount(practice) > 0 ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$ResourceFilter$Patient$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'Search for a dependent... ',
                abE: $elm$core$Maybe$Nothing
            });
        })) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        var patientResourceFilter = _v0.a;
        var patientResourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            LI: companyAccount,
            qk: patientResourceFilter,
            Vw: true,
            V7: patient,
            W1: practice,
            gJ: $elm$core$Maybe$Nothing,
            sL: 0,
            ahy: $author$project$Components$Patient$AddDependentModal$Invalid($elm$core$Maybe$Nothing)
        }, A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg, patientResourceFilterCmd));
    });
    var $author$project$Components$Patient$AddSponsorshipModal$open = function(_v0) {
        var model = _v0;
        return _Utils_update(model, {
            Vw: true
        });
    };
    var $author$project$Components$Patient$EditAthenaIdModal$Model = $elm$core$Basics$identity;
    var $author$project$Components$Patient$EditAthenaIdModal$open = F5(function(_v0, practice, integrationRecord, maybeMetadataRecord, patient) {
        var newLocalPatientId = function() {
            if (!maybeMetadataRecord.$) {
                var metadataRecord = maybeMetadataRecord.a;
                return A2($elm$core$Maybe$withDefault, '', metadataRecord.aeS);
            } else return '';
        }();
        return _Utils_Tuple2({
            q0: integrationRecord,
            rz: newLocalPatientId,
            Vw: true,
            V7: patient,
            W1: practice,
            Xv: false
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$Model = $elm$core$Basics$identity;
    var $author$project$Api$Provider$EmailAddress$One$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Patient$ManagePortalAccessModal$GotPatientEmails = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientEmail$All$PatientEmail = $elm$core$Basics$identity;
    var $author$project$Api$Provider$PatientEmail$All$Record = F3(function(id, portalEnabled, patient) {
        return {
            aef: id,
            V7: patient,
            WW: portalEnabled
        };
    });
    var $author$project$Api$Provider$PatientEmail$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'portal_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$PatientEmail$All$Record))));
    var $author$project$Api$Provider$PatientEmail$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$PatientEmail$All$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PatientEmail$patientEmailsPath = function(emailAddressId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patient_emails'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            emailAddressId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'email_addresses'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$PatientEmail$retrieve = F3(function(apiClient, emailAddressId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$PatientEmail$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)));
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$retrievePatientEmails = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$PatientEmail$retrieve, apiClient, patientId, $author$project$Components$Patient$ManagePortalAccessModal$GotPatientEmails);
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$open = F4(function(apiClient, practice, emailAddress, patient) {
        var emailAddressId = A2($elm$core$Maybe$map, $author$project$Api$Provider$EmailAddress$One$id, emailAddress);
        var cmd = function() {
            if (!emailAddressId.$) {
                var id = emailAddressId.a;
                return A2($author$project$Components$Patient$ManagePortalAccessModal$retrievePatientEmails, apiClient, id);
            } else return $elm$core$Platform$Cmd$none;
        }();
        return _Utils_Tuple2({
            Fk: emailAddressId,
            Vw: true,
            V7: patient,
            AA: $author$project$Api$Data$NotAsked,
            no: _List_Nil,
            W1: practice,
            Xv: false
        }, cmd);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$IntegrationPushed = function(a) {
        return {
            $: 26,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Integration$integrationsPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'integrations'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            patientId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$Patient$Integration$integrationPath = F2(function(patientId, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$Patient$Integration$integrationsPath(patientId));
    });
    var $author$project$Api$Provider$Patient$Integration$forcePush = F4(function(apiClient, patientId, integrationId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'force_push'
        ]), A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$pushIntegration = F3(function(apiClient, patientId, integrationId) {
        return A4($author$project$Api$Provider$Patient$Integration$forcePush, apiClient, patientId, integrationId, $author$project$Pages$Patients$PatientId_String$Top$IntegrationPushed);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$removeDependent = F3(function(apiClient, companyAccount, companyRegistrationId) {
        return A5($author$project$Api$Provider$Company$Registration$delete, apiClient, $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)), $author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount), companyRegistrationId, $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted($author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$removeEmployee = F2(function(apiClient, companyAccount) {
        return A4($author$project$Api$Provider$Company$Account$delete, apiClient, $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)), $author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount), $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipCompleted($author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverRemoved = function(a) {
        return {
            $: 51,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$removeHipaaAuthorization = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'remove_hipaa_authorization'
        ]), $author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$removeEphiWaiver = F2(function(apiClient, patientId) {
        return A3($author$project$Api$Provider$Patient$removeHipaaAuthorization, apiClient, patientId, $author$project$Pages$Patients$PatientId_String$Top$EphiWaiverRemoved);
    });
    var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$RequestPendingDocumentsAcceptance = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$Record = function(requestPendingDocumentsAcceptanceSentAt) {
        return {
            YG: requestPendingDocumentsAcceptanceSentAt
        };
    };
    var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_pending_documents_acceptance_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$Record));
    var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$PatientDocument$requestPendingDocumentsAcceptance = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'request_acceptance'
        ]), $author$project$Api$Provider$Patient$PatientDocument$patientDocumentsPath(patientId))));
    });
    var $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$requestPendingDocumentsAcceptanceSentAt = function(_v0) {
        var record = _v0;
        return record.YG;
    };
    var $author$project$Api$Provider$Patient$resetBouncedEmail = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'reset_bounced_email'
        ]), $author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Api$Provider$Patient$restore = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'restore'
        ]), $author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Api$Provider$Patient$Engagement$Engagement = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$Engagement$Record = F2(function(lastEngagementDate, invoice) {
        return {
            RA: invoice,
            SS: lastEngagementDate
        };
    });
    var $author$project$Api$Provider$Patient$Engagement$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_engagement_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$Engagement$Record)));
    var $author$project$Api$Provider$Patient$Engagement$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$Engagement$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$Engagement$retrieve = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Patient$Engagement$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'engagement'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$GotCoverageRuleUsages = function(a) {
        return {
            $: 45,
            a: a
        };
    };
    var $author$project$Api$Provider$CoverageRuleUsage$coverageRuleUsagePath = function(membershipPatientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'coverage_rule_usage'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'membership_patients',
            membershipPatientId
        ]), $author$project$Api$Data$providerPath));
    };
    var $author$project$Api$Provider$CoverageRuleUsage$All$CoverageRuleUsage = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoverageRuleUsage$Shared$CoverageRuleUsage = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoverageRuleUsage$Shared$Record = F4(function(coverageRule, coveredCharges, remainingItems, remainingItemsUntil) {
        return {
            Mo: coverageRule,
            Mr: coveredCharges,
            Yv: remainingItems,
            Yw: remainingItemsUntil
        };
    });
    var $author$project$Api$Provider$CoveredCharge$Min$CoveredCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CoveredCharge$Min$Record = F3(function(id, quantity, coveredDate) {
        return {
            Ms: coveredDate,
            aef: id,
            Bu: quantity
        };
    });
    var $author$project$Api$Provider$CoveredCharge$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'covered_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'quantity', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoveredCharge$Min$Record))));
    var $author$project$Api$Provider$CoveredCharge$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoveredCharge$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CoverageRuleUsage$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'remaining_items_until', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'remaining_items', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'covered_charges', $elm$json$Json$Decode$list($author$project$Api$Provider$CoveredCharge$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'coverage_rule', $author$project$Api$Provider$CoverageRule$One$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CoverageRuleUsage$Shared$Record)))));
    var $author$project$Api$Provider$CoverageRuleUsage$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoverageRuleUsage$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CoverageRuleUsage$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CoverageRuleUsage$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$CoverageRuleUsage$list = F3(function(apiClient, membershipPatientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$CoverageRuleUsage$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$CoverageRuleUsage$coverageRuleUsagePath(membershipPatientId)));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages = F2(function(apiClient, membershipPatientId) {
        return A3($author$project$Api$Provider$CoverageRuleUsage$list, apiClient, membershipPatientId, $author$project$Pages$Patients$PatientId_String$Top$GotCoverageRuleUsages);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$retrieveMembership = F3(function(apiClient, membershipId, toMsg) {
        return A4($author$project$Api$Provider$Membership$retrieve, apiClient, membershipId, _List_fromArray([
            0
        ]), toMsg);
    });
    var $author$project$Pages$Patients$PatientId_String$Top$AccessLinkSent = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$AccountAccess$Patient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Patient$AccountAccess$Record = function(accountAccessSentAt) {
        return {
            Ik: accountAccessSentAt
        };
    };
    var $author$project$Api$Provider$Patient$AccountAccess$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'account_access_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$AccountAccess$Record));
    var $author$project$Api$Provider$Patient$AccountAccess$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$AccountAccess$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Patient$requestAccountAccess = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Patient$AccountAccess$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'account_access'
        ]), $author$project$Api$Provider$Patient$patientPath(id_))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$sendAccountAccess = F2(function(apiClient, patient) {
        return A3($author$project$Api$Provider$Patient$requestAccountAccess, apiClient, $author$project$Api$Provider$Patient$One$id(patient), $author$project$Pages$Patients$PatientId_String$Top$AccessLinkSent);
    });
    var $author$project$Api$Provider$AddonRequest$addonRequestsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'addon_requests'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$AddonRequest$addonRequestPath = function(addonId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            addonId
        ]), $author$project$Api$Provider$AddonRequest$addonRequestsPath);
    };
    var $author$project$Api$Provider$AddonRequest$sendEmail = F4(function(apiClient, addonId, patientId, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('patient_id', $elm$json$Json$Encode$string(patientId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'send_email'
        ]), $author$project$Api$Provider$AddonRequest$addonRequestPath(addonId)))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$IntegrationUnlinked = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Integration$unlink = F4(function(apiClient, patientId, integrationId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$IntegrationRecord$One$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'unlink'
        ]), A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$unlinkIntegration = F3(function(apiClient, patientId, integrationId) {
        return A4($author$project$Api$Provider$Patient$Integration$unlink, apiClient, patientId, integrationId, $author$project$Pages$Patients$PatientId_String$Top$IntegrationUnlinked);
    });
    var $author$project$Components$Patient$AddDependentModal$CreatedCompanyRegistration = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Company$Registration$encodeCreateParams = function(_v0) {
        var type_ = _v0.ah5;
        var patientId = _v0.V8;
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('registration', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('type', $elm$json$Json$Encode$string(type_)),
                _Utils_Tuple2('patient', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(patientId))
                ])))
            ])))
        ]));
    };
    var $author$project$Components$Patient$AddDependentModal$typeToCode = function(t) {
        if (!t) return 'spouse';
        else return 'child';
    };
    var $author$project$Components$Patient$AddDependentModal$createCompanyRegistration = F5(function(apiClient, companyId, companyAccountId, patientId, type_) {
        var params = {
            V8: patientId,
            ah5: $author$project$Components$Patient$AddDependentModal$typeToCode(type_)
        };
        var encodedParams = $author$project$Api$Provider$Company$Registration$encodeCreateParams(params);
        return A5($author$project$Api$Provider$Company$Registration$create, apiClient, companyId, companyAccountId, encodedParams, $author$project$Components$Patient$AddDependentModal$CreatedCompanyRegistration);
    });
    var $author$project$Components$Patient$AddDependentModal$GotDependent = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Patient$AddDependentModal$fetchPatient = F2(function(token, patientId) {
        return A3($author$project$Api$Provider$Patient$retrieve, token, patientId, $author$project$Components$Patient$AddDependentModal$GotDependent);
    });
    var $author$project$Components$Patient$AddDependentModal$Child = 1;
    var $author$project$Components$Patient$AddDependentModal$typeFromLabel = function(str) {
        if (str === 'Adult') return 0;
        else return 1;
    };
    var $author$project$Components$Patient$AddDependentModal$Valid = {
        $: 0
    };
    var $author$project$Components$Patient$AddDependentModal$findCompanyAccountForSameCompanyAndSubscriber = F3(function(accounts, companyId, patientId) {
        return $elm$core$List$head(A2($elm$core$List$filter, function(account) {
            return _Utils_eq($author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(account)), companyId) && _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account)), $elm$core$Maybe$Just(patientId));
        }, accounts));
    });
    var $author$project$Components$Patient$AddDependentModal$validateModel = function(model) {
        var status = function() {
            var _v0 = model.gJ;
            if (_v0.$ === 1) return $author$project$Components$Patient$AddDependentModal$Invalid($elm$core$Maybe$Nothing);
            else {
                var dependent = _v0.a;
                var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(dependent);
                var existingCompanyAccount = A3($author$project$Components$Patient$AddDependentModal$findCompanyAccountForSameCompanyAndSubscriber, accounts, $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(model.LI)), $author$project$Api$Provider$Patient$One$id(model.V7));
                if (!existingCompanyAccount.$) {
                    var subscriberName = $author$project$Api$Provider$Patient$One$name(model.V7);
                    var dependentName = $author$project$Api$Provider$Patient$One$name(dependent);
                    var companyName = $author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(model.LI));
                    return $author$project$Components$Patient$AddDependentModal$Invalid($elm$core$Maybe$Just(A2($elm$html$Html$p, _List_fromArray([
                        $elm$html$Html$Attributes$class('alert'),
                        $elm$html$Html$Attributes$class('alert-warning')
                    ]), _List_fromArray([
                        $elm$html$Html$text('It looks like ' + (dependentName + (' is already linked with ' + (companyName + (', through ' + (subscriberName + '.'))))))
                    ]))));
                } else return $author$project$Components$Patient$AddDependentModal$Valid;
            }
        }();
        return _Utils_update(model, {
            ahy: status
        });
    };
    var $author$project$Components$Patient$AddDependentModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: _Utils_update(model, {
                        Vw: false
                    }),
                    at: _List_Nil
                };
            case 1:
                var command = function() {
                    var _v2 = model.gJ;
                    if (!_v2.$) {
                        var dependent = _v2.a;
                        return A5($author$project$Components$Patient$AddDependentModal$createCompanyRegistration, apiClient, $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(model.LI)), $author$project$Api$Provider$CompanyAccount$ForPatient$id(model.LI), $author$project$Api$Provider$Patient$One$id(dependent), model.sL);
                    } else return $elm$core$Platform$Cmd$none;
                }();
                return {
                    EQ: command,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var type_ = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: _Utils_update(model, {
                        sL: $author$project$Components$Patient$AddDependentModal$typeFromLabel(type_)
                    }),
                    at: _List_Nil
                };
            case 3:
                var subMsg = msg.a;
                var _v3 = model.qk;
                if (!_v3.$) {
                    var subscriberResourceFilter = _v3.a;
                    var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, subscriberResourceFilter);
                    var _v4 = function() {
                        var _v5 = patientResourceResult.adu;
                        if (!_v5.$) {
                            if (!_v5.a.$) return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$AddDependentModal$fetchPatient(apiClient), $author$project$Components$ResourceFilter$Patient$value(patientResourceResult.zi))));
                            else {
                                var _v6 = _v5.a;
                                return _Utils_Tuple2(model.gJ, $elm$core$Platform$Cmd$none);
                            }
                        } else return _Utils_Tuple2(model.gJ, $elm$core$Platform$Cmd$none);
                    }();
                    var selectedDependent = _v4.a;
                    var fetchPatientCmd = _v4.b;
                    var commands = _List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg, patientResourceResult.EQ),
                        fetchPatientCmd
                    ]);
                    var newModel = $author$project$Components$Patient$AddDependentModal$validateModel(_Utils_update(model, {
                        qk: $elm$core$Maybe$Just(patientResourceResult.zi),
                        gJ: selectedDependent
                    }));
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(commands),
                        zi: newModel,
                        at: patientResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: _Utils_update(model, {
                        Vw: false
                    }),
                    at: _List_fromArray([
                        $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7))
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var pat = response.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        zi: $author$project$Components$Patient$AddDependentModal$validateModel(_Utils_update(model, {
                            gJ: $elm$core$Maybe$Just(pat)
                        })),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyAccount = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Company$Account$encodeCreateParams = function(_v0) {
        var divisionId = _v0.Ob;
        var type_ = _v0.ah5;
        var patientId = _v0.V8;
        var encodePatient = function(patId) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('patient', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(patId))
                ])))
            ]));
        };
        var encodeRegistrations = function(patId) {
            return A2($elm$json$Json$Encode$list, encodePatient, _List_fromArray([
                patId
            ]));
        };
        var encodeDivision = function(divId) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(divId))
            ]));
        };
        var add = F2(function(item, list_) {
            return _Utils_ap(list_, _List_fromArray([
                item
            ]));
        });
        var maybeAdd = F2(function(_v2, list_) {
            var key = _v2.a;
            var item = _v2.b;
            if (!item.$) {
                var item_ = item.a;
                return A2(add, _Utils_Tuple2(key, item_), list_);
            } else return list_;
        });
        return function(fields) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('account', $elm$json$Json$Encode$object(fields))
            ]));
        }(A2(maybeAdd, _Utils_Tuple2('division', A2($elm$core$Maybe$map, encodeDivision, divisionId)), A2(maybeAdd, _Utils_Tuple2('registrations', A2($elm$core$Maybe$map, encodeRegistrations, patientId)), A2(maybeAdd, _Utils_Tuple2('type', A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, type_)), _List_Nil))));
    };
    var $author$project$Components$Patient$AddSponsorshipModal$createCompanyAccount = F4(function(token, companyId, divisionId, patientId) {
        var params = {
            Ob: divisionId,
            V8: $elm$core$Maybe$Just(patientId),
            ah5: $elm$core$Maybe$Just('employee')
        };
        var encodedParams = $author$project$Api$Provider$Company$Account$encodeCreateParams(params);
        return A4($author$project$Api$Provider$Company$Account$create, token, $author$project$Api$Provider$Company$companyPath(companyId), encodedParams, $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyAccount(companyId));
    });
    var $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyRegistration = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$typeToCode = function(t) {
        switch(t){
            case 0:
                return 'employee';
            case 1:
                return 'spouse';
            default:
                return 'child';
        }
    };
    var $author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration = F5(function(token, companyId, companyAccountId, patientId, type_) {
        var params = {
            V8: patientId,
            ah5: $author$project$Components$Patient$AddSponsorshipModal$typeToCode(type_)
        };
        var encodedParams = $author$project$Api$Provider$Company$Registration$encodeCreateParams(params);
        return A5($author$project$Api$Provider$Company$Registration$create, token, companyId, companyAccountId, encodedParams, $author$project$Components$Patient$AddSponsorshipModal$CreatedCompanyRegistration);
    });
    var $author$project$Components$Patient$AddSponsorshipModal$GotAccountDivisions = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$fetchAccountDivisions = F2(function(token, companyId) {
        return A4($author$project$Api$Provider$Company$EmployeeDivision$list, token, companyId, function(d) {
            return d;
        }, $author$project$Components$Patient$AddSponsorshipModal$GotAccountDivisions);
    });
    var $author$project$Components$Patient$AddSponsorshipModal$GotSubscriber = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$fetchPatient = F2(function(token, patientId) {
        return A3($author$project$Api$Provider$Patient$retrieve, token, patientId, $author$project$Components$Patient$AddSponsorshipModal$GotSubscriber);
    });
    var $author$project$Api$Provider$Company$All$requiresEmployeeDivisions = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Company$Shared$requiresEmployeeDivisions(shared);
    };
    var $author$project$Components$ResourceFilter$Company$requiresEmployeeDivisions = $author$project$Api$Provider$Company$All$requiresEmployeeDivisions;
    var $author$project$Components$Patient$AddSponsorshipModal$Adult = 1;
    var $author$project$Components$Patient$AddSponsorshipModal$Child = 2;
    var $author$project$Components$Patient$AddSponsorshipModal$typeFromLabel = function(str) {
        switch(str){
            case 'Adult':
                return 1;
            case 'Child':
                return 2;
            default:
                return 0;
        }
    };
    var $author$project$Api$Provider$Company$All$usesEmployeeDivisions = function(_v0) {
        var record = _v0.b;
        return record.aa1;
    };
    var $author$project$Components$ResourceFilter$Company$usesEmployeeDivisions = $author$project$Api$Provider$Company$All$usesEmployeeDivisions;
    var $author$project$Components$Patient$AddSponsorshipModal$Valid = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$findCompanyAccount = F2(function(accounts, companyAccountId) {
        return $elm$core$List$head(A2($elm$core$List$filter, function(account) {
            return _Utils_eq($author$project$Api$Provider$CompanyAccount$ForPatient$id(account), companyAccountId);
        }, accounts));
    });
    var $author$project$Components$Patient$AddSponsorshipModal$validateDependentModel = function(model) {
        var hasNoAccountsWarning = function(subscriber) {
            return A2($elm$html$Html$p, _List_fromArray([
                $elm$html$Html$Attributes$class('alert'),
                $elm$html$Html$Attributes$class('alert-warning')
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Patient$One$name(subscriber) + ' is not an employee at a company. Visit their page '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                    V8: $author$project$Api$Provider$Patient$One$id(subscriber)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text('here')
                ])),
                $elm$html$Html$text(' to add employment.')
            ]));
        };
        var _v0 = _Utils_Tuple2(model.gL, model.gI);
        if (_v0.a.$ === 1) {
            var _v1 = _v0.a;
            return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing);
        } else if (_v0.b.$ === 1) {
            var subscriber = _v0.a.a;
            var _v2 = _v0.b;
            return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Just(hasNoAccountsWarning(subscriber)));
        } else {
            var subscriber = _v0.a.a;
            var companyAccountId = _v0.b.a;
            var _v3 = function() {
                var _v4 = model.ko;
                if (!_v4.$) {
                    var ownedAccounts = _v4.a;
                    if ($elm$core$List$isEmpty(ownedAccounts)) return _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
                    else {
                        var found = A2($author$project$Components$Patient$AddSponsorshipModal$findCompanyAccount, $author$project$Api$Provider$Patient$One$companyAccounts(model.V7), companyAccountId);
                        return _Utils_Tuple2(false, found);
                    }
                } else return _Utils_Tuple2(false, $elm$core$Maybe$Nothing);
            }();
            var hasNoAccounts = _v3.a;
            var maybeAlreadyRegisteredOn = _v3.b;
            if (hasNoAccounts) return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Just(hasNoAccountsWarning(subscriber)));
            else {
                var subscriberName = $author$project$Api$Provider$Patient$One$name(subscriber);
                var patientName = $author$project$Api$Provider$Patient$One$name(model.V7);
                if (!maybeAlreadyRegisteredOn.$) {
                    var companyAccount = maybeAlreadyRegisteredOn.a;
                    return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Just(A2($elm$html$Html$p, _List_fromArray([
                        $elm$html$Html$Attributes$class('alert'),
                        $elm$html$Html$Attributes$class('alert-warning')
                    ]), _List_fromArray([
                        $elm$html$Html$text('It looks like ' + (patientName + (' is already linked with ' + ($author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)) + (', through ' + (subscriberName + '.'))))))
                    ]))));
                } else {
                    var companyName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Min$name, A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$ForPatient$company, $elm$core$List$head(A2($elm$core$List$filter, function(account) {
                        return _Utils_eq($author$project$Api$Provider$CompanyAccount$ForPatient$id(account), companyAccountId);
                    }, $author$project$Api$Provider$Patient$One$companyAccounts(subscriber))))));
                    return $author$project$Components$Patient$AddSponsorshipModal$Valid($elm$core$Maybe$Just(A2($elm$html$Html$p, _List_fromArray([
                        $elm$html$Html$Attributes$class('alert'),
                        $elm$html$Html$Attributes$class('alert-info')
                    ]), _List_fromArray([
                        $elm$html$Html$text(patientName + (' will be added to ' + (companyName + (', through ' + (subscriberName + '\'s account.')))))
                    ]))));
                }
            }
        }
    };
    var $author$project$Components$Patient$AddSponsorshipModal$findCompanyAccountForSameCompanyAndSubscriber = F3(function(accounts, companyId, patientId) {
        return $elm$core$List$head(A2($elm$core$List$filter, function(account) {
            return _Utils_eq($author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(account)), companyId) && _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account)), $elm$core$Maybe$Just(patientId));
        }, accounts));
    });
    var $author$project$Components$Patient$AddSponsorshipModal$validateEmployeeModel = function(model) {
        var _v0 = model.cq;
        if (!_v0.$) {
            var selectedCompanyId = _v0.a;
            var accounts = $author$project$Api$Provider$Patient$One$companyAccounts(model.V7);
            var alreadyRegistered = A3($author$project$Components$Patient$AddSponsorshipModal$findCompanyAccountForSameCompanyAndSubscriber, accounts, selectedCompanyId, $author$project$Api$Provider$Patient$One$id(model.V7));
            if (!alreadyRegistered.$) {
                var companyAccount = alreadyRegistered.a;
                var patientName = $author$project$Api$Provider$Patient$One$name(model.V7);
                return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Just(A2($elm$html$Html$p, _List_fromArray([
                    $elm$html$Html$Attributes$class('alert'),
                    $elm$html$Html$Attributes$class('alert-warning')
                ]), _List_fromArray([
                    $elm$html$Html$text('It looks like ' + (patientName + (' is already linked with ' + $author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)))))
                ]))));
            } else return $author$project$Components$Patient$AddSponsorshipModal$Valid($elm$core$Maybe$Nothing);
        } else return $author$project$Components$Patient$AddSponsorshipModal$Invalid($elm$core$Maybe$Nothing);
    };
    var $author$project$Components$Patient$AddSponsorshipModal$validateModel = function(model) {
        var status = function() {
            var _v0 = model.sL;
            if (!_v0) return $author$project$Components$Patient$AddSponsorshipModal$validateEmployeeModel(model);
            else return $author$project$Components$Patient$AddSponsorshipModal$validateDependentModel(model);
        }();
        return _Utils_update(model, {
            ahy: status
        });
    };
    var $author$project$Components$Patient$AddSponsorshipModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var _v2 = A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, model.W1, model.V7, false, model.aa1, model.YJ);
                var newModel = _v2.a;
                var cmd = _v2.b;
                return {
                    EQ: cmd,
                    zi: newModel,
                    at: _List_Nil
                };
            case 1:
                var _v3 = model.sL;
                if (!_v3) {
                    var command = function() {
                        var _v4 = model.cq;
                        if (!_v4.$) {
                            var companyId = _v4.a;
                            return A4($author$project$Components$Patient$AddSponsorshipModal$createCompanyAccount, apiClient, companyId, model.eH, $author$project$Api$Provider$Patient$One$id(model.V7));
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    return {
                        EQ: command,
                        zi: model,
                        at: _List_Nil
                    };
                } else {
                    var type_ = _v3;
                    var command = function() {
                        var _v5 = _Utils_Tuple2(model.cq, model.gI);
                        if (!_v5.a.$ && !_v5.b.$) {
                            var companyId = _v5.a.a;
                            var companyAccountId = _v5.b.a;
                            return A5($author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration, apiClient, companyId, companyAccountId, $author$project$Api$Provider$Patient$One$id(model.V7), type_);
                        } else return $elm$core$Platform$Cmd$none;
                    }();
                    return {
                        EQ: command,
                        zi: model,
                        at: _List_Nil
                    };
                }
            case 2:
                var type_ = msg.a;
                var _v6 = A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, $author$project$Components$Patient$AddSponsorshipModal$typeFromLabel(type_), apiClient, model.W1, model.V7, true, model.aa1, model.YJ);
                var newModel = _v6.a;
                var cmd = _v6.b;
                return {
                    EQ: cmd,
                    zi: newModel,
                    at: _List_Nil
                };
            case 3:
                var subMsg = msg.a;
                var _v7 = model.pY;
                if (!_v7.$) {
                    var companyResourceFilter = _v7.a;
                    var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, companyResourceFilter);
                    var _v8 = function() {
                        var _v9 = companyResourceResult.adu;
                        if (!_v9.$ && !_v9.a.$ && !_v9.a.a.$) {
                            var company = _v9.a.a.a;
                            return _Utils_Tuple2($author$project$Components$ResourceFilter$Company$usesEmployeeDivisions(company), $author$project$Components$ResourceFilter$Company$requiresEmployeeDivisions(company));
                        } else return _Utils_Tuple2(model.aa1, model.YJ);
                    }();
                    var usesEmployeeDivisions = _v8.a;
                    var requiresEmployeeDivision = _v8.b;
                    var _v10 = function() {
                        var _v11 = companyResourceResult.adu;
                        if (!_v11.$) {
                            if (!_v11.a.$) return _Utils_Tuple2($author$project$Components$ResourceFilter$Company$value(companyResourceResult.zi), A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$AddSponsorshipModal$fetchAccountDivisions(apiClient), $author$project$Components$ResourceFilter$Company$value(companyResourceResult.zi))));
                            else {
                                var _v12 = _v11.a;
                                return _Utils_Tuple2(model.cq, $elm$core$Platform$Cmd$none);
                            }
                        } else return _Utils_Tuple2(model.cq, $elm$core$Platform$Cmd$none);
                    }();
                    var companyId = _v10.a;
                    var fetchDivisionsCmd = _v10.b;
                    var newModel = $author$project$Components$Patient$AddSponsorshipModal$validateModel(_Utils_update(model, {
                        pY: $elm$core$Maybe$Just(companyResourceResult.zi),
                        YJ: requiresEmployeeDivision,
                        cq: companyId,
                        eH: $elm$core$Maybe$Nothing,
                        aa1: usesEmployeeDivisions
                    }));
                    var commands = _List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg, companyResourceResult.EQ),
                        fetchDivisionsCmd
                    ]);
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(commands),
                        zi: newModel,
                        at: companyResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var subMsg = msg.a;
                var _v13 = model.oG;
                if (!_v13.$) {
                    var subscriberResourceFilter = _v13.a;
                    var patientResourceResult = A3($author$project$Components$ResourceFilter$Patient$update, apiClient, subMsg, subscriberResourceFilter);
                    var _v14 = function() {
                        var _v15 = patientResourceResult.adu;
                        if (!_v15.$) {
                            if (!_v15.a.$) return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, $author$project$Components$Patient$AddSponsorshipModal$fetchPatient(apiClient), $author$project$Components$ResourceFilter$Patient$value(patientResourceResult.zi))));
                            else {
                                var _v16 = _v15.a;
                                return _Utils_Tuple2(model.gL, $elm$core$Platform$Cmd$none);
                            }
                        } else return _Utils_Tuple2(model.gL, $elm$core$Platform$Cmd$none);
                    }();
                    var newSelectedSubscriber = _v14.a;
                    var fetchPatientCmd = _v14.b;
                    var commands = _List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg, patientResourceResult.EQ),
                        fetchPatientCmd
                    ]);
                    var newModel = $author$project$Components$Patient$AddSponsorshipModal$validateModel(_Utils_update(model, {
                        gL: newSelectedSubscriber,
                        oG: $elm$core$Maybe$Just(patientResourceResult.zi)
                    }));
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(commands),
                        zi: newModel,
                        at: patientResourceResult.at
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                var response = msg.a;
                var newModel = function() {
                    if (model.YJ) {
                        var selectedDivisionId = function() {
                            if (response.$ === 3) {
                                var data = response.a;
                                return A2($elm$core$Maybe$map, $author$project$Api$Provider$EmployeeDivision$All$id, $elm$core$List$head(data));
                            } else return $elm$core$Maybe$Nothing;
                        }();
                        return $author$project$Components$Patient$AddSponsorshipModal$validateModel(_Utils_update(model, {
                            xv: response,
                            eH: selectedDivisionId
                        }));
                    } else return $author$project$Components$Patient$AddSponsorshipModal$validateModel(_Utils_update(model, {
                        xv: response
                    }));
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: newModel,
                    at: _List_Nil
                };
            case 6:
                var divisionId = msg.a;
                if (divisionId === '') return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: _Utils_update(model, {
                        eH: $elm$core$Maybe$Nothing
                    }),
                    at: _List_Nil
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: $author$project$Components$Patient$AddSponsorshipModal$validateModel(_Utils_update(model, {
                        eH: $elm$core$Maybe$Just(divisionId)
                    })),
                    at: _List_Nil
                };
            case 7:
                var companyId = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var data = response.a;
                    return {
                        EQ: A5($author$project$Components$Patient$AddSponsorshipModal$createCompanyRegistration, apiClient, companyId, $author$project$Api$Provider$CompanyAccount$One$id(data), $author$project$Api$Provider$Patient$One$id(model.V7), model.sL),
                        zi: model,
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 8:
                var response = msg.a;
                if (response.$ === 3) {
                    var _v21 = A7($author$project$Components$Patient$AddSponsorshipModal$resetModel, 0, apiClient, model.W1, model.V7, false, model.aa1, model.YJ);
                    var newModel = _v21.a;
                    var cmd = _v21.b;
                    return {
                        EQ: cmd,
                        zi: newModel,
                        at: _List_fromArray([
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7))
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 9:
                var response = msg.a;
                if (response.$ === 3) {
                    var pat = response.a;
                    var subscriberOwnedCompanyAccounts = A2($elm$core$List$filter, function(acc) {
                        return _Utils_eq(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(acc))), $author$project$Api$Provider$Patient$One$id(pat));
                    }, $author$project$Api$Provider$Patient$One$companyAccounts(pat));
                    var selectedCompanyAccount = $elm$core$List$head(subscriberOwnedCompanyAccounts);
                    var selectedCompanyId = A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Min$id, A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$ForPatient$company, selectedCompanyAccount));
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        zi: $author$project$Components$Patient$AddSponsorshipModal$validateModel(_Utils_update(model, {
                            gI: A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$ForPatient$id, selectedCompanyAccount),
                            cq: selectedCompanyId,
                            gL: $elm$core$Maybe$Just(pat),
                            ko: $elm$core$Maybe$Just(subscriberOwnedCompanyAccounts)
                        })),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: model,
                    at: _List_Nil
                };
            default:
                var id = msg.a;
                var companyId = A2($elm$core$Maybe$map, $author$project$Api$Provider$Company$Min$id, A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$ForPatient$company, $elm$core$List$head(A2($elm$core$List$filter, function(acc) {
                    return _Utils_eq($author$project$Api$Provider$CompanyAccount$ForPatient$id(acc), id);
                }, A2($elm$core$Maybe$withDefault, _List_Nil, model.ko)))));
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    zi: $author$project$Components$Patient$AddSponsorshipModal$validateModel(_Utils_update(model, {
                        gI: $elm$core$Maybe$Just(id),
                        cq: companyId
                    })),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Patient$EditAthenaIdModal$Closed = {
        $: 0
    };
    var $author$project$Components$Patient$EditAthenaIdModal$None = {
        $: 2
    };
    var $author$project$Components$Patient$EditAthenaIdModal$Success = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$EditAthenaIdModal$MetadataUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Patient$Integration$metadataRecordEncoder = function(metadata) {
        var innerObject = $elm$json$Json$Encode$object(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(idVal) {
            return $elm$core$String$trim(idVal) === '' ? _List_Nil : _List_fromArray([
                _Utils_Tuple2('athena_local_patient_id', $elm$json$Json$Encode$string(idVal))
            ]);
        }, metadata.aeS)));
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('metadata', innerObject)
        ]));
    };
    var $author$project$Api$Provider$Patient$Integration$updateMetadata = F5(function(apiClient, patientId, integrationId, metadata, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Provider$IntegrationRecord$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$Provider$Patient$Integration$metadataRecordEncoder(metadata), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'metadata'
        ]), A2($author$project$Api$Provider$Patient$Integration$integrationPath, patientId, integrationId)))));
    });
    var $author$project$Components$Patient$EditAthenaIdModal$updateLocalPatientId = F4(function(apiClient, patientId, integrationId, localPatientId) {
        var metadata = {
            aeS: $elm$core$Maybe$Just(localPatientId)
        };
        return A5($author$project$Api$Provider$Patient$Integration$updateMetadata, apiClient, patientId, integrationId, metadata, $author$project$Components$Patient$EditAthenaIdModal$MetadataUpdated);
    });
    var $author$project$Components$Patient$EditAthenaIdModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                var newLocalPatientId = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Patient$EditAthenaIdModal$None,
                    zi: _Utils_update(model, {
                        rz: newLocalPatientId
                    }),
                    at: _List_Nil
                };
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$Patient$EditAthenaIdModal$Closed,
                    zi: _Utils_update(model, {
                        Vw: false
                    }),
                    at: _List_Nil
                };
            case 2:
                var cmd = A4($author$project$Components$Patient$EditAthenaIdModal$updateLocalPatientId, apiClient, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Api$Provider$Integration$SharedWithInlinePartner$id($author$project$Api$Provider$IntegrationRecord$All$integration(model.q0)), model.rz);
                return {
                    EQ: cmd,
                    adu: $author$project$Components$Patient$EditAthenaIdModal$None,
                    zi: _Utils_update(model, {
                        Xv: true
                    }),
                    at: _List_Nil
                };
            default:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var newModel = _Utils_update(model, {
                            Vw: false,
                            Xv: false
                        });
                        var integrationId = $author$project$Api$Provider$Integration$SharedWithInlinePartner$id($author$project$Api$Provider$IntegrationRecord$All$integration(model.q0));
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$Patient$EditAthenaIdModal$Success(integrationId),
                            zi: newModel,
                            at: _List_fromArray([
                                A2($author$project$OutMsg$ShowToast, 3, 'Local ID saved')
                            ])
                        };
                    case 2:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$Patient$EditAthenaIdModal$None,
                            zi: model,
                            at: $author$project$OutMsg$handleErrorResponse(response)
                        };
                    default:
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: $author$project$Components$Patient$EditAthenaIdModal$None,
                            zi: model,
                            at: _List_Nil
                        };
                }
        }
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$Closed = 1;
    var $author$project$Components$Patient$EditCustomFormAnswerModal$FormResponseUpdated = 2;
    var $author$project$Components$Patient$EditCustomFormAnswerModal$None = 0;
    var $author$project$Api$Provider$CustomForm$answerId = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomForm$answerText = function(_v0) {
        var record = _v0;
        return record.$Y;
    };
    var $author$project$Api$Provider$CustomForm$formResponsesPath = function(patientId) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'form_responses'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            patientId
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'patients'
        ]), $author$project$Api$Data$providerPath)));
    };
    var $author$project$Api$Provider$CustomForm$create = F5(function(apiClient, patientId, formId, fields, toMsg) {
        var encodeFormResponseItems = function(item) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('answer', $elm$json$Json$Encode$string(item.$Y)),
                _Utils_Tuple2('form_item', $author$project$Utils$Encode$association(item.FA))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('form_response_items', A2($elm$json$Json$Encode$list, encodeFormResponseItems, fields)),
            _Utils_Tuple2('form', $author$project$Utils$Encode$association(formId))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$CustomForm$formResponsesPath(patientId))));
    });
    var $author$project$Api$Provider$CustomForm$destroy = function(_v0) {
        var record = _v0;
        return record.NT;
    };
    var $author$project$Api$Provider$CustomForm$formResponsePath = F2(function(patientId, id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$CustomForm$formResponsesPath(patientId));
    });
    var $author$project$Api$Provider$CustomForm$update = F5(function(apiClient, patientId, id_, fields, toMsg) {
        var encodeFormResponseItems = function(item) {
            return $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, item.aef)),
                _Utils_Tuple2('answer', $elm$json$Json$Encode$string(item.$Y)),
                _Utils_Tuple2('form_item', $author$project$Utils$Encode$association(item.FA)),
                _Utils_Tuple2('_destroy', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$bool, item.NT))
            ]));
        };
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('form_response_items', A2($elm$json$Json$Encode$list, encodeFormResponseItems, fields))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Provider$CustomForm$formResponsePath, patientId, id_))));
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$createOrUpdateFormResponse = F2(function(apiClient, model) {
        var payload = A2($elm$core$List$map, function(answer) {
            return {
                NT: $author$project$Api$Provider$CustomForm$destroy(answer),
                FA: model.FA,
                aef: $elm$core$String$isEmpty($author$project$Api$Provider$CustomForm$answerId(answer)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just($author$project$Api$Provider$CustomForm$answerId(answer)),
                $Y: $author$project$Api$Provider$CustomForm$answerText(answer)
            };
        }, model.pz);
        return $elm$core$String$isEmpty(model.xP) ? A5($author$project$Api$Provider$CustomForm$create, apiClient, model.V8, model.Fz, payload, $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated) : A5($author$project$Api$Provider$CustomForm$update, apiClient, model.V8, model.xP, payload, $author$project$Components$Patient$EditCustomFormAnswerModal$FormAnswerUpdated);
    });
    var $author$project$Api$Provider$CustomForm$updateDestroy = F2(function(_v0, bool) {
        var formAnswer = _v0;
        return _Utils_update(formAnswer, {
            NT: $elm$core$Maybe$Just(bool)
        });
    });
    var $author$project$Api$Provider$CustomForm$updateText = F2(function(newValue, _v0) {
        var formAnswer = _v0;
        return _Utils_update(formAnswer, {
            $Y: newValue
        });
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_Nil
                };
            case 1:
                return {
                    EQ: A2($author$project$Components$Patient$EditCustomFormAnswerModal$createOrUpdateFormResponse, apiClient, model),
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (response.$ === 3) return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 2,
                    zi: model,
                    at: _List_fromArray([
                        $author$project$OutMsg$RetrievePatient(model.V8),
                        A2($author$project$OutMsg$ShowToast, 3, 'Answer updated succesfully')
                    ])
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 3:
                var formAnswer = msg.a;
                var string = msg.b;
                var newAnswer = A2($author$project$Api$Provider$CustomForm$updateText, string, formAnswer);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        pz: _List_fromArray([
                            newAnswer
                        ])
                    }),
                    at: _List_Nil
                };
            case 4:
                var newAnswers = A2($elm$core$List$append, model.pz, $author$project$Api$Provider$CustomForm$initEmptyAnswers);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        pz: newAnswers
                    }),
                    at: _List_Nil
                };
            case 5:
                var index = msg.a;
                var newValue = msg.b;
                var newAnswers = A3($elm_community$list_extra$List$Extra$updateAt, index, function(answer) {
                    return A2($author$project$Api$Provider$CustomForm$updateText, newValue, answer);
                }, model.pz);
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        pz: newAnswers
                    }),
                    at: _List_Nil
                };
            default:
                var index = msg.a;
                var maybeAnswer = A2($elm_community$list_extra$List$Extra$getAt, index, model.pz);
                var newAnswers = function() {
                    if (maybeAnswer.$ === 1) return model.pz;
                    else {
                        var answer_ = maybeAnswer.a;
                        return $author$project$Api$Provider$CustomForm$answerId(answer_) === '' ? A2($elm_community$list_extra$List$Extra$removeAt, index, model.pz) : A3($elm_community$list_extra$List$Extra$updateAt, index, function(answer) {
                            return A2($author$project$Api$Provider$CustomForm$updateDestroy, answer, true);
                        }, model.pz);
                    }
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: _Utils_update(model, {
                        pz: newAnswers
                    }),
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$None = 1;
    var $author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged = F3(function(a, b, c) {
        return {
            $: 3,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$ToggledPortalStatus = 0;
    var $author$project$Api$Provider$PatientEmail$authorize = F4(function(apiClient, emailAddressId, patientEmailId, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'authorize'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            patientEmailId
        ]), $author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)))));
    });
    var $author$project$Api$Provider$PatientEmail$All$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$PatientEmail$All$isPortalEnabled = function(_v0) {
        var record = _v0;
        return record.WW;
    };
    var $author$project$Api$Provider$PatientEmail$revoke = F4(function(apiClient, emailAddressId, patientEmailId, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'revoke'
        ]), A2($author$project$Api$Data$pathAppend, _List_fromArray([
            patientEmailId
        ]), $author$project$Api$Provider$PatientEmail$patientEmailsPath(emailAddressId)))));
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$toggleisPortalEnabled = F3(function(isPortalEnabled, patientEmailId, _v0) {
        var id = _v0.a;
        var enabled = _v0.b;
        return _Utils_eq(id, patientEmailId) ? _Utils_Tuple2(id, isPortalEnabled) : _Utils_Tuple2(id, enabled);
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                var response = msg.a;
                var patientEmailsEnabled = function() {
                    if (response.$ === 3) {
                        var patientEmails = response.a;
                        return A2($elm$core$List$map, function(p) {
                            return _Utils_Tuple2($author$project$Api$Provider$PatientEmail$All$id(p), $author$project$Api$Provider$PatientEmail$All$isPortalEnabled(p));
                        }, patientEmails);
                    } else return _List_Nil;
                }();
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        AA: response,
                        no: patientEmailsEnabled
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        Vw: false
                    }),
                    at: _List_Nil
                };
            case 2:
                var patientEmail = msg.a;
                var isPortalEnabled = msg.b;
                var _v3 = model.Fk;
                if (!_v3.$) {
                    var emailAddressId = _v3.a;
                    var patientEmailId = $author$project$Api$Provider$PatientEmail$All$id(patientEmail);
                    var requestPortalChange = isPortalEnabled ? A4($author$project$Api$Provider$PatientEmail$authorize, apiClient, emailAddressId, patientEmailId, A2($author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged, patientEmailId, isPortalEnabled)) : A4($author$project$Api$Provider$PatientEmail$revoke, apiClient, emailAddressId, patientEmailId, A2($author$project$Components$Patient$ManagePortalAccessModal$PortalStatusChanged, patientEmailId, isPortalEnabled));
                    return {
                        EQ: requestPortalChange,
                        adu: 1,
                        zi: _Utils_update(model, {
                            Xv: true
                        }),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 1, 'No email address found for this patient.')
                    ])
                };
            default:
                var patientEmailId = msg.a;
                var isPortalEnabled = msg.b;
                var response = msg.c;
                if (response.$ === 3) {
                    var statusText = isPortalEnabled ? 'authorized' : 'revoked';
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: _Utils_update(model, {
                            no: A2($elm$core$List$map, A2($author$project$Components$Patient$ManagePortalAccessModal$toggleisPortalEnabled, isPortalEnabled, patientEmailId), model.no),
                            Xv: false
                        }),
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Patient has been ' + (statusText + ' to use the portal.'))
                        ])
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: _Utils_update(model, {
                        Xv: false
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
        }
    });
    var $author$project$Api$Provider$Patient$AccountAccessToken$url = function(_v0) {
        var record = _v0;
        return record.aaT;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 65:
                var data = msg.a;
                if (data.$ === 3) {
                    var syncDetail = data.a;
                    if (!syncDetail.$) {
                        var syncDetail_ = syncDetail.a;
                        var coveragePlanAll = A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$coveragePlan(syncDetail_));
                        var _v3 = A3($author$project$Pages$Patients$PatientId_String$Top$initNetworkCoveragePlanRules, model, coveragePlanAll, _List_Nil);
                        var coveragePlan = _v3.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            ve: data,
                            UL: coveragePlan
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        ve: data
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    ve: data
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(data));
            case 0:
                return _Utils_Tuple3(model, A2($author$project$Pages$Patients$PatientId_String$Top$fetchPlainSSN, model.Ej, model.V7), _List_Nil);
            case 2:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    A7: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    T$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    oe: true
                }), A2($author$project$Pages$Patients$PatientId_String$Top$sendAccountAccess, model.Ej, model.V7), _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var data = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Ik: $author$project$Api$Provider$Patient$AccountAccess$accountAccessSentAt(data),
                        oe: false
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    oe: false
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var employeeOrDependent = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    df: _Utils_Tuple2(true, $elm$core$Maybe$Just(employeeOrDependent))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                var employeeOrDependant = msg.a;
                var confirmed = msg.b;
                if (confirmed) {
                    var newModel = _Utils_update(model, {
                        df: _Utils_Tuple2(false, $elm$core$Maybe$Just(employeeOrDependant))
                    });
                    switch(employeeOrDependant.$){
                        case 0:
                            var companyAccount = employeeOrDependant.a;
                            return _Utils_Tuple3(newModel, A2($author$project$Pages$Patients$PatientId_String$Top$removeEmployee, model.Ej, companyAccount), _List_Nil);
                        case 1:
                            var companyAccount = employeeOrDependant.a;
                            var companyRegistration = employeeOrDependant.b;
                            return _Utils_Tuple3(newModel, A3($author$project$Pages$Patients$PatientId_String$Top$removeDependent, model.Ej, companyAccount, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(companyRegistration)), _List_Nil);
                        default:
                            var companyAccount = employeeOrDependant.a;
                            var companyRegistration = employeeOrDependant.b;
                            return _Utils_Tuple3(newModel, A3($author$project$Pages$Patients$PatientId_String$Top$removeDependent, model.Ej, companyAccount, $author$project$Api$Provider$CompanyRegistration$ForPatientOne$id(companyRegistration)), _List_Nil);
                    }
                } else return _Utils_Tuple3(_Utils_update(model, {
                    df: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 7:
                var cacId = msg.a;
                var response = msg.b;
                if (response.$ === 3) {
                    var newList = A2($elm$core$List$filter, function(cac) {
                        return !_Utils_eq($author$project$Api$Provider$CompanyAccount$ForPatient$id(cac), cacId);
                    }, model.gX);
                    var newModel = _Utils_update(model, {
                        df: _Utils_Tuple2(false, $elm$core$Maybe$Nothing),
                        gX: newList
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Successfully removed')
                    ]));
                } else {
                    var newModel = _Utils_update(model, {
                        df: _Utils_Tuple2(false, $elm$core$Maybe$Nothing)
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            case 12:
                return _Utils_Tuple3(_Utils_update(model, {
                    ou: !model.ou
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 8:
                var _v7 = model.dt;
                if (_v7.$ === 1) {
                    var _v8 = A3($author$project$Components$Patient$AddSponsorshipModal$init, model.Ej, model.W1, model.V7);
                    var modal = _v8.a;
                    var cmd = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        dt: $elm$core$Maybe$Just(modal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg, cmd), _List_Nil);
                } else {
                    var modal = _v7.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        dt: $elm$core$Maybe$Just($author$project$Components$Patient$AddSponsorshipModal$open(modal))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 9:
                var account = msg.a;
                var _v9 = A4($author$project$Components$Patient$AddDependentModal$open, model.Ej, model.W1, model.V7, account);
                var modal = _v9.a;
                var cmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    hn: $elm$core$Maybe$Just(modal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg, cmd), _List_Nil);
            case 10:
                var modalMsg = msg.a;
                var _v10 = model.dt;
                if (!_v10.$) {
                    var modal = _v10.a;
                    var result = A3($author$project$Components$Patient$AddSponsorshipModal$update, model.Ej, modalMsg, modal);
                    return _Utils_Tuple3(_Utils_update(model, {
                        dt: $elm$core$Maybe$Just(result.zi)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg, result.EQ), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var modalMsg = msg.a;
                var _v11 = model.hn;
                if (!_v11.$) {
                    var modal = _v11.a;
                    var result = A3($author$project$Components$Patient$AddDependentModal$update, model.Ej, modalMsg, modal);
                    return _Utils_Tuple3(_Utils_update(model, {
                        hn: $elm$core$Maybe$Just(result.zi)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg, result.EQ), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                return _Utils_Tuple3(_Utils_update(model, {
                    j6: true
                }), A4($author$project$Api$Provider$Patient$requestPaymentInfo, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), $elm$core$Maybe$Nothing, $author$project$Pages$Patients$PatientId_String$Top$GotPayInfoUpdate), _List_Nil);
            case 14:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var payInfo = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            AC: $author$project$Api$Provider$Patient$RequestPaymentInfoOne$requestPayInfoSentAt(payInfo),
                            j6: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            j6: false
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            j6: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 15:
                var cmd = A3($author$project$Api$Provider$Patient$PatientDocument$requestPendingDocumentsAcceptance, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Pages$Patients$PatientId_String$Top$GotPendingDocsAcceptanceUpdate);
                return _Utils_Tuple3(_Utils_update(model, {
                    j5: true
                }), cmd, _List_Nil);
            case 16:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var pendingDocs = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            rW: $author$project$Api$Provider$Patient$RequestPendingDocumentsAcceptanceOne$requestPendingDocumentsAcceptanceSentAt(pendingDocs),
                            j5: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            j5: false
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            j5: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 17:
                var eligibleCompanyAccounts = A2($elm$core$List$filter, $author$project$Api$Provider$CompanyAccount$ForPatient$isEligible, $author$project$Api$Provider$Patient$One$companyAccounts(model.V7));
                if (!eligibleCompanyAccounts.b) return _Utils_Tuple3(model, A2($author$project$Ports$Navigation$pushRoute, model.DS, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New({
                    V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                })), _List_Nil);
                else {
                    var x = eligibleCompanyAccounts.a;
                    var xs = eligibleCompanyAccounts.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        h_: $elm$core$Maybe$Just(A3($author$project$Components$Patient$CreateMembershipModal$init, model.DS, A2($author$project$Utils$NonEmpty$init, x, xs), model.V7))
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 18:
                var subMsg = msg.a;
                var _v15 = model.h_;
                if (!_v15.$) {
                    var modal = _v15.a;
                    var _v16 = A3($author$project$Components$Patient$CreateMembershipModal$update, model.Ej, subMsg, modal);
                    var createModal_ = _v16.a;
                    var cmd = _v16.b;
                    var maybeEvent = _v16.c;
                    var _v17 = function() {
                        if (!maybeEvent.$) switch(maybeEvent.a.$){
                            case 0:
                                var _v19 = maybeEvent.a;
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil);
                            case 2:
                                var _v20 = maybeEvent.a;
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, _List_fromArray([
                                    $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7))
                                ]));
                            default:
                                var error = maybeEvent.a.a;
                                return _Utils_Tuple2($elm$core$Maybe$Just(createModal_), _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                                ]));
                        }
                        else return _Utils_Tuple2($elm$core$Maybe$Just(createModal_), _List_Nil);
                    }();
                    var newModal = _v17.a;
                    var outMsgs = _v17.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        h_: newModal
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg, cmd), outMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 19:
                return _Utils_Tuple3(_Utils_update(model, {
                    jV: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 20:
                var patientId = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    jV: false
                }), A3($author$project$Api$Provider$Patient$restore, model.Ej, patientId, $author$project$Pages$Patients$PatientId_String$Top$PatientRestored(patientId)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    jV: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 21:
                var id = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$RetrievePatient(id),
                            A2($author$project$OutMsg$ShowToast, 3, 'This patient is successfully restored.')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 23:
                var response = msg.a;
                var _v22 = function() {
                    if (response.$ === 3) {
                        var data = response.a;
                        return _Utils_Tuple3(A2($elm$core$List$indexedMap, F2(function(index, record) {
                            return $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toDownLeft($author$project$Ui$Dropdown$defaultConfig({
                                aef: $author$project$Api$Provider$Integration$SharedWithInlinePartner$id($author$project$Api$Provider$IntegrationRecord$All$integration(record)) + '-integration-record-dropdown',
                                ahX: $author$project$Pages$Patients$PatientId_String$Top$DropdownMenuMsg(index)
                            })));
                        }), data), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(_List_Nil, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }();
                var integrationRecordDropdowns = _v22.a;
                var errorReport = _v22.b;
                var outMsgs = _v22.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    fR: integrationRecordDropdowns,
                    Rr: response
                }), errorReport, outMsgs);
            case 22:
                var index = msg.a;
                var subMsg = msg.b;
                var _v24 = A2($elm_community$list_extra$List$Extra$getAt, index, model.fR);
                if (_v24.$ === 1) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    var dropdownModel = _v24.a;
                    var _v25 = A2($author$project$Ui$Dropdown$update, subMsg, dropdownModel);
                    var dropdownMenu = _v25.a;
                    var cmd = _v25.b;
                    var newList = A3($elm_community$list_extra$List$Extra$setAt, index, dropdownMenu, model.fR);
                    return _Utils_Tuple3(_Utils_update(model, {
                        fR: newList
                    }), cmd, _List_Nil);
                }
            case 24:
                var action = msg.a;
                var record = msg.b;
                var patientId = $author$project$Api$Provider$Patient$One$id(model.V7);
                var integrationId = $author$project$Api$Provider$Integration$SharedWithInlinePartner$id($author$project$Api$Provider$IntegrationRecord$All$integration(record));
                switch(action){
                    case 0:
                        return _Utils_Tuple3(model, A3($author$project$Pages$Patients$PatientId_String$Top$unlinkIntegration, model.Ej, patientId, integrationId), _List_Nil);
                    case 1:
                        var metadataRecord = $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata(record);
                        var externalPatientId = function() {
                            if (!metadataRecord.$) {
                                var metadataRecord_ = metadataRecord.a;
                                return A2($elm$core$Maybe$withDefault, '', metadataRecord_.aeS);
                            } else return A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$IntegrationRecord$All$integrationRecordId(record));
                        }();
                        return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(externalPatientId), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard!')
                        ]));
                    case 2:
                        return _Utils_Tuple3(model, A3($author$project$Pages$Patients$PatientId_String$Top$pushIntegration, model.Ej, patientId, integrationId), _List_Nil);
                    default:
                        var metadataRecord = $author$project$Api$Provider$IntegrationRecord$All$athenaMetadata(record);
                        var _v28 = A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A5($author$project$Components$Patient$EditAthenaIdModal$open, model.Ej, model.W1, record, metadataRecord, model.V7));
                        var modal = _v28.a;
                        var cmd = _v28.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            iu: modal
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, cmd), _List_Nil);
                }
            case 26:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Record pushed, this might take a while')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 25:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Record unlinked')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 27:
                return _Utils_Tuple3(_Utils_update(model, {
                    mo: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 28:
                var confirmed = msg.a;
                var cmd = confirmed ? A2($author$project$Pages$Patients$PatientId_String$Top$forcePushElation, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7)) : $elm$core$Platform$Cmd$none;
                return _Utils_Tuple3(_Utils_update(model, {
                    mo: false
                }), cmd, _List_Nil);
            case 29:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var patient = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            V7: patient
                        }), $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Successfully synced with Elation')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                        ]));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 30:
                var idx = msg.a;
                var bool = msg.b;
                var newList = A3($elm_community$list_extra$List$Extra$setAt, idx, bool, model.q$);
                return _Utils_Tuple3(_Utils_update(model, {
                    q$: newList
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 31:
                var url = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Navigation$openInNewWindow(url), _List_Nil);
            case 34:
                var response = msg.a;
                if (response.$ === 2) {
                    var error = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        nn: response
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    nn: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 32:
                var response = msg.a;
                if (response.$ === 2) {
                    var error = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        rR: response
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error))
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    rR: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 33:
                return _Utils_Tuple3(_Utils_update(model, {
                    rQ: !model.rQ
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 38:
                var formQuestion = msg.a;
                var formId = msg.b;
                var formResponseId = msg.c;
                var _v34 = model.fE;
                if (_v34.$ === 1) {
                    var _v35 = A4($author$project$Components$Patient$EditCustomFormAnswerModal$init, $author$project$Api$Provider$Patient$One$id(model.V7), formQuestion, formId, formResponseId);
                    var modal = _v35.a;
                    var cmd = _v35.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fE: $elm$core$Maybe$Just(modal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg, cmd), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 35:
                return _Utils_Tuple3(_Utils_update(model, {
                    il: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 36:
                var patientId = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    il: false
                }), A3($author$project$Api$Provider$Patient$disableSyncing, model.Ej, patientId, $author$project$Pages$Patients$PatientId_String$Top$PatientDetached(patientId)), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    il: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 37:
                var patientId = msg.a;
                var response = msg.b;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$RetrievePatient(patientId),
                            A2($author$project$OutMsg$ShowToast, 3, 'Record detached')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 39:
                var subMsg = msg.a;
                var _v37 = model.fE;
                if (!_v37.$) {
                    var modal = _v37.a;
                    var result = A3($author$project$Components$Patient$EditCustomFormAnswerModal$update, model.Ej, subMsg, modal);
                    var newModal = function() {
                        var _v38 = result.adu;
                        if (!_v38) return $elm$core$Maybe$Just(result.zi);
                        else return $elm$core$Maybe$Nothing;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        fE: newModal
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg, result.EQ), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 44:
                var response = msg.a;
                if (response.$ === 3) {
                    var membership = response.a;
                    var cmd = $author$project$Api$Provider$Membership$One$status(membership) === 'ended' ? $elm$core$Platform$Cmd$none : A2($author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages, model.Ej, A2($elm$core$Maybe$withDefault, '', model.p8));
                    return _Utils_Tuple3(_Utils_update(model, {
                        jc: response
                    }), cmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    jc: response
                }), A2($author$project$Pages$Patients$PatientId_String$Top$retrieveCoverageRuleUsages, model.Ej, A2($elm$core$Maybe$withDefault, '', model.p8)), _List_Nil);
            case 45:
                var response = msg.a;
                var _v40 = _Utils_Tuple2(response, model.jc);
                if (_v40.a.$ === 3 && _v40.b.$ === 3) {
                    var _v41 = _v40.a;
                    var coverageRuleUsages = _v41.a;
                    var _v42 = _v40.b;
                    var membership = _v42.a;
                    var plan = $author$project$Api$Provider$Membership$One$plan(membership);
                    var _v43 = A3($author$project$Pages$Patients$PatientId_String$Top$initCoveragePlanRules, model, plan, coverageRuleUsages);
                    var coveragePlan = _v43.a;
                    var coveragePlanRulesCmd = _v43.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mn: coveragePlan,
                        Mp: response
                    }), coveragePlanRulesCmd, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    Mp: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 40:
                var membershipId = msg.a;
                var membershipPatientId = msg.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    p8: $elm$core$Maybe$Just(membershipPatientId),
                    jc: $author$project$Api$Data$Loading,
                    m5: true
                }), A3($author$project$Pages$Patients$PatientId_String$Top$retrieveMembership, model.Ej, membershipId, $author$project$Pages$Patients$PatientId_String$Top$GotMembership), _List_Nil);
            case 41:
                return _Utils_Tuple3(_Utils_update(model, {
                    Mn: $elm$core$Maybe$Nothing,
                    jc: $author$project$Api$Data$NotAsked,
                    m5: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 42:
                var subMsg = msg.a;
                var _v44 = model.Mn;
                if (!_v44.$) {
                    var coveragePlan = _v44.a;
                    var _v45 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, model.Ej, subMsg, coveragePlan);
                    var newCoveragePlan = _v45.a;
                    var coveragePlanCmd = _v45.b;
                    var coveragePlanOutMsgs = _v45.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Mn: $elm$core$Maybe$Just(newCoveragePlan)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg, coveragePlanCmd), coveragePlanOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 43:
                var subMsg = msg.a;
                var _v46 = model.UL;
                if (!_v46.$) {
                    var networkCoveragePlan = _v46.a;
                    var _v47 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, model.Ej, subMsg, networkCoveragePlan);
                    var newNetworkCoveragePlan = _v47.a;
                    var networkCoveragePlanCmd = _v47.b;
                    var networkCoveragePlanOutMsgs = _v47.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        UL: $elm$core$Maybe$Just(newNetworkCoveragePlan)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg, networkCoveragePlanCmd), networkCoveragePlanOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 46:
                return _Utils_Tuple3(_Utils_update(model, {
                    kQ: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 48:
                var confirmed = msg.a;
                var cmd = confirmed ? A2($author$project$Pages$Patients$PatientId_String$Top$acceptEphiWaiver, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7)) : $elm$core$Platform$Cmd$none;
                return _Utils_Tuple3(_Utils_update(model, {
                    kQ: false
                }), cmd, _List_Nil);
            case 47:
                return _Utils_Tuple3(_Utils_update(model, {
                    nY: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 49:
                var confirmed = msg.a;
                var cmd = confirmed ? A2($author$project$Pages$Patients$PatientId_String$Top$removeEphiWaiver, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7)) : $elm$core$Platform$Cmd$none;
                return _Utils_Tuple3(_Utils_update(model, {
                    nY: false
                }), cmd, _List_Nil);
            case 50:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7)),
                            A2($author$project$OutMsg$ShowToast, 3, 'Ephi Waiver Accepted')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 51:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                            $author$project$OutMsg$RetrievePatient($author$project$Api$Provider$Patient$One$id(model.V7)),
                            A2($author$project$OutMsg$ShowToast, 3, 'Ephi Waiver Removed')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, $author$project$Ui$Toast$serverError(error)), $author$project$OutMsg$reportDecodeError(response)));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 52:
                var patientValue = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(patientValue), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
                ]));
            case 73:
                return _Utils_Tuple3(model, A2($author$project$Pages$Patients$PatientId_String$Top$createAccountAccessToken, model.Ej, model.V7), _List_Nil);
            case 74:
                var response = msg.a;
                if (response.$ === 3) {
                    var accountAccessToken = response.a;
                    return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy($author$project$Api$Provider$Patient$AccountAccessToken$url(accountAccessToken)), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Portal URL copied to clipboard')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 53:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    m4: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 54:
                var addon = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    hq: A2($elm$core$Set$insert, $author$project$Api$Provider$Addon$Min$id(addon), model.hq)
                }), A4($author$project$Api$Provider$AddonRequest$sendEmail, model.Ej, $author$project$Api$Provider$Addon$Min$id(addon), $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Pages$Patients$PatientId_String$Top$AddonRequestEmailSent(addon)), _List_Nil);
            case 55:
                var addon = msg.a;
                var response = msg.b;
                var ourMsgs = function() {
                    if (response.$ === 3) return _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Email has been sent')
                    ]);
                    else return _List_Nil;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    hq: A2($elm$core$Set$remove, $author$project$Api$Provider$Addon$Min$id(addon), model.hq)
                }), $elm$core$Platform$Cmd$none, _Utils_ap(ourMsgs, $author$project$OutMsg$handleErrorResponse(response)));
            case 56:
                var patientMceEligibility = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    jb: A2($elm$core$Set$insert, $author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility), model.jb)
                }), A4($author$project$Api$Provider$Patient$MceActivation$create, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility), $author$project$Pages$Patients$PatientId_String$Top$MceActivationEmailSent(patientMceEligibility)), _List_Nil);
            case 57:
                var patientMceEligibility = msg.a;
                var response = msg.b;
                var ourMsgs = function() {
                    if (response.$ === 3) return _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Email has been sent')
                    ]);
                    else return _List_Nil;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    jb: A2($elm$core$Set$remove, $author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility), model.jb)
                }), $elm$core$Platform$Cmd$none, _Utils_ap(ourMsgs, $author$project$OutMsg$handleErrorResponse(response)));
            case 58:
                var subMsg = msg.a;
                var auditTrailLogResult = A3($author$project$Components$AuditTrailLog$update, model.Ej, subMsg, model.hB);
                return _Utils_Tuple3(_Utils_update(model, {
                    hB: auditTrailLogResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg, auditTrailLogResult.EQ), auditTrailLogResult.at);
            case 59:
                var popover = A3($author$project$Ui$Popover$init, 'engagement', !$author$project$Ui$Popover$isOpen(model.aN), $author$project$Pages$Patients$PatientId_String$Top$PopoverMsg);
                var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.V7);
                var _v53 = _Utils_Tuple2(model.Fo, engagementStatus !== 'never_engaged');
                if (!_v53.a.$ && _v53.b) {
                    var _v54 = _v53.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        Fo: $author$project$Api$Data$Loading,
                        aN: popover
                    }), A3($author$project$Api$Provider$Patient$Engagement$retrieve, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Pages$Patients$PatientId_String$Top$GotEngagement), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    aN: popover
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 60:
                var data = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Fo: data
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(data));
            case 61:
                var subMsg = msg.a;
                var popoverModel = A2($author$project$Ui$Popover$update, subMsg, model.aN);
                return _Utils_Tuple3(_Utils_update(model, {
                    aN: popoverModel
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 62:
                var _v55 = A4($author$project$Components$Patient$ManagePortalAccessModal$open, model.Ej, model.W1, A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Data$toMaybe(model.qs)), model.V7);
                var modal = _v55.a;
                var cmd = _v55.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    i7: $elm$core$Maybe$Just(modal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg, cmd), _List_Nil);
            case 63:
                var modalMsg = msg.a;
                var _v56 = model.i7;
                if (!_v56.$) {
                    var modal = _v56.a;
                    var result = A3($author$project$Components$Patient$ManagePortalAccessModal$update, model.Ej, modalMsg, modal);
                    var cmd = function() {
                        var _v57 = result.adu;
                        if (!_v57) return A2($author$project$Pages$Patients$PatientId_String$Top$fetchEmailAddress, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7));
                        else return $elm$core$Platform$Cmd$none;
                    }();
                    return _Utils_Tuple3(_Utils_update(model, {
                        i7: $elm$core$Maybe$Just(result.zi)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg, result.EQ),
                        cmd
                    ])), result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 64:
                var response = msg.a;
                if (response.$ === 2) {
                    var error = response.a;
                    if (error.$ === 5) return _Utils_Tuple3(_Utils_update(model, {
                        qs: A2($author$project$Api$Data$Success, $elm$core$Maybe$Nothing, $elm$core$Dict$empty)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                    else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    qs: A2($author$project$Api$Data$map, $elm$core$Maybe$Just, response)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 66:
                var modalMsg = msg.a;
                var _v60 = model.iu;
                if (!_v60.$) {
                    var modal = _v60.a;
                    var result = A3($author$project$Components$Patient$EditAthenaIdModal$update, model.Ej, modalMsg, modal);
                    var _v61 = function() {
                        var _v62 = result.adu;
                        switch(_v62.$){
                            case 1:
                                var integrationId = _v62.a;
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$batch(_List_fromArray([
                                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.EQ),
                                    A2($author$project$Pages$Patients$PatientId_String$Top$fetchIntegrationRecords, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7)),
                                    A3($author$project$Pages$Patients$PatientId_String$Top$pushIntegration, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), integrationId)
                                ])));
                            case 2:
                                return _Utils_Tuple2($elm$core$Maybe$Just(result.zi), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.EQ));
                            default:
                                return _Utils_Tuple2($elm$core$Maybe$Nothing, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, result.EQ));
                        }
                    }();
                    var newModal = _v61.a;
                    var cmds = _v61.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        iu: newModal
                    }), cmds, result.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 67:
                return _Utils_Tuple3(model, A3($author$project$Api$Provider$Patient$resetBouncedEmail, model.Ej, $author$project$Api$Provider$Patient$One$id(model.V7), $author$project$Pages$Patients$PatientId_String$Top$BouncedEmailReset), _List_Nil);
            case 68:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    Ex: true
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, A2($elm$core$String$append, 'You should now be able to send emails to ', A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$One$email(model.V7))))
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 69:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Ah: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 70:
                return _Utils_Tuple3(_Utils_update(model, {
                    sY: !model.sY
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 71:
                var _package = msg.a;
                var patientId = $author$project$Api$Provider$Patient$One$id(model.V7);
                var modalWithPackage = function() {
                    var _v64 = $author$project$Api$Provider$PatientPackage$All$priceInCents(_package);
                    if (!_v64.$) {
                        var price = _v64.a;
                        return A4($author$project$Components$Patient$PackageDetailsModal$openWithPrice, patientId, _package, price, model.c8);
                    } else return A3($author$project$Components$Patient$PackageDetailsModal$open, patientId, _package, model.c8);
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    c8: modalWithPackage
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v65 = A2($author$project$Components$Patient$PackageDetailsModal$update, subMsg, model.c8);
                var newModal = _v65.a;
                var cmd = _v65.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    c8: newModal
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg, cmd), _List_Nil);
        }
    });
    var $author$project$Api$FeatureGate$PatientPortal = 5;
    var $author$project$Api$Platform$Session$One$practiceReadOnlyRole = function(_v0) {
        var record = _v0;
        return record.ag_ === 'practice_read_only' || record.ag_ === 'practice_read_only_and_reports';
    };
    var $author$project$Permission$hideIfReadOnly = F2(function(session, html) {
        return $author$project$Api$Platform$Session$One$practiceReadOnlyRole(session) ? $author$project$Utils$Html$empty : html;
    });
    var $author$project$Ui$Panel$titleSm = function(contents) {
        return $author$project$Ui$Typography$headingSm(contents);
    };
    var $author$project$Components$HiConfirm$CenterText = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$centerText = $author$project$Components$HiConfirm$CenterText;
    var $author$project$Pages$Patients$PatientId_String$Top$viewAcceptEphiWaiverModal = function(model) {
        return model.kQ ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverModalClosed, _List_fromArray([
            $author$project$Components$HiConfirm$verb('Accept'),
            $author$project$Components$HiConfirm$noun('ePHI Waiver'),
            $author$project$Components$HiConfirm$titleizeNoun(false),
            $author$project$Components$HiConfirm$centerText(false),
            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('We need authorization from this customer that allows us to send them unencrypted communications which may contain Protected Health Information.')
                ])),
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Without this authorization we cannot communicate electronically on your behalf with this customer.')
                ])),
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Do you have signed authorization that allows us to send unencrypted communication, which may include Protected Health Information, to this customer?')
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Patient$AddDependentModal$Submitted = {
        $: 1
    };
    var $author$project$Utils$Maybe$appendMaybe = F2(function(maybe, list) {
        return _Utils_ap(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$singleton, maybe)), list);
    });
    var $author$project$Components$Patient$AddDependentModal$viewDependentOptions = function(model) {
        var _v0 = model.qk;
        if (!_v0.$) {
            var dependentResourceFilter = _v0.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Dependent'),
                $author$project$Ui$Form$Group$labelSpanMd(3),
                $author$project$Ui$Form$Group$inputSpanMd(9),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Patient$AddDependentModal$DependentResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(0)
                ]), dependentResourceFilter))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Patient$AddDependentModal$TypeSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Patient$AddDependentModal$typeToLabel = function(t) {
        if (!t) return 'Adult';
        else return 'Child';
    };
    var $author$project$Components$Patient$AddDependentModal$types = _List_fromArray([
        $author$project$Components$Patient$AddDependentModal$typeToLabel(0),
        $author$project$Components$Patient$AddDependentModal$typeToLabel(1)
    ]);
    var $author$project$Components$Patient$AddDependentModal$typeOptions = A2($elm$core$List$map, function(typeStr) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(typeStr), typeStr);
    }, $author$project$Components$Patient$AddDependentModal$types);
    var $author$project$Components$Patient$AddDependentModal$viewTypeOptions = function(model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Type'),
            $author$project$Ui$Form$Group$labelSpanMd(3),
            $author$project$Ui$Form$Group$inputSpanMd(9),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Components$Patient$AddDependentModal$typeToLabel(model.sL))),
                $author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddDependentModal$TypeSelected)
            ]), $author$project$Components$Patient$AddDependentModal$typeOptions)
        ]));
    };
    var $author$project$Components$Patient$AddDependentModal$view = function(_v0) {
        var model = _v0;
        if (model.Vw) {
            var _v1 = function() {
                var _v2 = model.ahy;
                if (!_v2.$) return _Utils_Tuple2(true, $elm$core$Maybe$Nothing);
                else {
                    var msg = _v2.a;
                    return _Utils_Tuple2(false, msg);
                }
            }();
            var canSubmit = _v1.a;
            var statusBadge = _v1.b;
            var footerContent = _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$AddDependentModal$Closed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Add dependent to company'
                }, _List_fromArray([
                    $author$project$Ui$Button$success,
                    $author$project$Ui$Button$disabled(!canSubmit),
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$AddDependentModal$Submitted)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add to company')
                ]))
            ]);
            var body = A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$onSubmit($author$project$Components$Patient$AddDependentModal$Submitted),
                $author$project$Ui$Form$horizontal
            ]), A2($author$project$Utils$Maybe$appendMaybe, statusBadge, _List_fromArray([
                $author$project$Components$Patient$AddDependentModal$viewDependentOptions(model),
                $author$project$Components$Patient$AddDependentModal$viewTypeOptions(model)
            ])));
            return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$AddDependentModal$Closed, _List_fromArray([
                $author$project$Ui$Modal$size(1)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Add Dependent')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    body
                ])),
                $author$project$Ui$Modal$footer(footerContent)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewAddDependentModal = function(model) {
        var _v0 = model.hn;
        if (!_v0.$) {
            var modal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalMsg, $author$project$Components$Patient$AddDependentModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Patient$AddSponsorshipModal$Submitted = {
        $: 1
    };
    var $author$project$Components$Patient$AddSponsorshipModal$viewCompanyOptions = function(model) {
        var _v0 = model.pY;
        if (!_v0.$) {
            var companyResourceFilter = _v0.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Company'),
                $author$project$Ui$Form$Group$labelSpanMd(3),
                $author$project$Ui$Form$Group$inputSpanMd(9),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Patient$AddSponsorshipModal$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(0)
                ]), companyResourceFilter))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Patient$AddSponsorshipModal$DivisionSelected = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$divisionOptions = F2(function(requiresEmployeeDivisions, divisions) {
        var optionsList = A2($elm$core$List$map, function(division) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$EmployeeDivision$All$id(division)), $author$project$Api$Provider$EmployeeDivision$All$name(division));
        }, divisions);
        return requiresEmployeeDivisions ? optionsList : A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(''), ''), optionsList);
    });
    var $author$project$Components$Patient$AddSponsorshipModal$viewDivisionsOptions = function(model) {
        if (model.aa1) {
            var _v0 = model.xv;
            if (_v0.$ === 3) {
                var divisions = _v0.a;
                return $elm$core$List$length(divisions) > 0 ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Division'),
                    $author$project$Ui$Form$Group$labelSpanMd(3),
                    $author$project$Ui$Form$Group$inputSpanMd(9),
                    $author$project$Ui$Form$Group$required(model.YJ)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value(model.eH),
                        $author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$DivisionSelected)
                    ]), A2($author$project$Components$Patient$AddSponsorshipModal$divisionOptions, model.YJ, divisions))
                ])) : $author$project$Utils$Html$empty;
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Patient$AddSponsorshipModal$SubscriberCompanyAccountSelected = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$companyAccountOptions = function(companyAccounts) {
        return A2($elm$core$List$map, function(companyAccount) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)), $author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)));
        }, companyAccounts);
    };
    var $author$project$Components$Patient$AddSponsorshipModal$viewPatientCompanyAccountOptions = function(model) {
        var _v0 = model.ko;
        if (!_v0.$) {
            var accounts = _v0.a;
            return $elm$core$List$length(accounts) > 1 ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Company'),
                $author$project$Ui$Form$Group$labelSpanMd(3),
                $author$project$Ui$Form$Group$inputSpanMd(9),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                    $author$project$Ui$Form$Select$value(model.gI),
                    $author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$SubscriberCompanyAccountSelected)
                ]), $author$project$Components$Patient$AddSponsorshipModal$companyAccountOptions(accounts))
            ])) : $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Patient$AddSponsorshipModal$viewSubscriberOptions = function(model) {
        var _v0 = model.oG;
        if (!_v0.$) {
            var subscriberResourceFilter = _v0.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Dependent of'),
                $author$project$Ui$Form$Group$labelSpanMd(3),
                $author$project$Ui$Form$Group$inputSpanMd(9),
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$Patient$AddSponsorshipModal$SubscriberResourceFilterMsg, A2($author$project$Components$ResourceFilter$Patient$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(0)
                ]), subscriberResourceFilter))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Patient$AddSponsorshipModal$TypeSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Patient$AddSponsorshipModal$typeToLabel = function(t) {
        switch(t){
            case 0:
                return 'Employee';
            case 1:
                return 'Adult';
            default:
                return 'Child';
        }
    };
    var $author$project$Components$Patient$AddSponsorshipModal$typeLabels = _List_fromArray([
        $author$project$Components$Patient$AddSponsorshipModal$typeToLabel(0),
        $author$project$Components$Patient$AddSponsorshipModal$typeToLabel(1),
        $author$project$Components$Patient$AddSponsorshipModal$typeToLabel(2)
    ]);
    var $author$project$Components$Patient$AddSponsorshipModal$typeOptions = A2($elm$core$List$map, function(typeStr) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(typeStr), typeStr);
    }, $author$project$Components$Patient$AddSponsorshipModal$typeLabels);
    var $author$project$Components$Patient$AddSponsorshipModal$viewTypeOptions = function(model) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Type'),
            $author$project$Ui$Form$Group$labelSpanMd(3),
            $author$project$Ui$Form$Group$inputSpanMd(9),
            $author$project$Ui$Form$Group$required(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Select$view, _List_fromArray([
                $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Components$Patient$AddSponsorshipModal$typeToLabel(model.sL))),
                $author$project$Ui$Form$Select$onChange($author$project$Components$Patient$AddSponsorshipModal$TypeSelected)
            ]), $author$project$Components$Patient$AddSponsorshipModal$typeOptions)
        ]));
    };
    var $author$project$Components$Patient$AddSponsorshipModal$view = function(_v0) {
        var model = _v0;
        if (model.Vw) {
            var _v1 = function() {
                var _v2 = model.ahy;
                if (!_v2.$) {
                    var msg = _v2.a;
                    return _Utils_Tuple2(true, msg);
                } else {
                    var msg = _v2.a;
                    return _Utils_Tuple2(false, msg);
                }
            }();
            var canSubmit = _v1.a;
            var statusBadge = _v1.b;
            var footerContent = _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$AddSponsorshipModal$Closed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Link employer to company'
                }, _List_fromArray([
                    $author$project$Ui$Button$success,
                    $author$project$Ui$Button$disabled(!canSubmit),
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$AddSponsorshipModal$Submitted)
                ]), _List_fromArray([
                    $elm$html$Html$text('Add to company')
                ]))
            ]);
            var body = A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$onSubmit($author$project$Components$Patient$AddSponsorshipModal$Submitted),
                $author$project$Ui$Form$horizontal
            ]), A2($author$project$Utils$Maybe$appendMaybe, statusBadge, _List_fromArray([
                $author$project$Components$Patient$AddSponsorshipModal$viewTypeOptions(model),
                $author$project$Components$Patient$AddSponsorshipModal$viewCompanyOptions(model),
                $author$project$Components$Patient$AddSponsorshipModal$viewSubscriberOptions(model),
                $author$project$Components$Patient$AddSponsorshipModal$viewDivisionsOptions(model),
                $author$project$Components$Patient$AddSponsorshipModal$viewPatientCompanyAccountOptions(model)
            ])));
            return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$AddSponsorshipModal$Closed, _List_fromArray([
                $author$project$Ui$Modal$size(1)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Link Employer')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    body
                ])),
                $author$project$Ui$Modal$footer(footerContent)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewAddSponsorshipModal = function(model) {
        var _v0 = model.dt;
        if (!_v0.$) {
            var modal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalMsg, $author$project$Components$Patient$AddSponsorshipModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$PatientValueCopiedToClipboard = function(a) {
        return {
            $: 52,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewCopyButton = F2(function(description, value) {
        return $elm$core$String$length($elm$core$String$trim(value)) > 0 ? A3($author$project$Ui$Button$view, {
            abP: 'Copy ' + description
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$PatientValueCopiedToClipboard(value)),
            $author$project$Ui$Button$margin(10)
        ]), _List_Nil) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$AddressDisplay$formatSegment = function(maybeSegment) {
        return function(segment) {
            return $elm$core$String$isEmpty(segment) ? '' : segment;
        }(A2($elm$core$Maybe$withDefault, '', maybeSegment));
    };
    var $author$project$Components$AddressDisplay$addCommaIfNotEmpty = function(segment) {
        var formatted = $author$project$Components$AddressDisplay$formatSegment(segment);
        return $elm$core$String$isEmpty(formatted) ? '' : formatted + ', ';
    };
    var $author$project$Components$AddressDisplay$viewOneLineAddress = function(address) {
        return $author$project$Components$AddressDisplay$addCommaIfNotEmpty($author$project$Api$Common$Address$Shared$line1(address)) + ($author$project$Components$AddressDisplay$addCommaIfNotEmpty($author$project$Api$Common$Address$Shared$line2(address)) + ($author$project$Components$AddressDisplay$addCommaIfNotEmpty($author$project$Api$Common$Address$Shared$city(address)) + ($author$project$Components$AddressDisplay$formatSegment($author$project$Api$Common$Address$Shared$state(address)) + (' ' + $author$project$Components$AddressDisplay$formatSegment($author$project$Api$Common$Address$Shared$zip(address))))));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewAddressesSection = F2(function(practice, patient) {
        var primaryAddressTitle = $author$project$Api$Provider$Patient$One$usesBillingAddress(patient) ? A2($elm$html$Html$p, _List_fromArray([
            $elm$html$Html$Attributes$class('text-label-md'),
            $elm$html$Html$Attributes$class('mb-025')
        ]), _List_fromArray([
            $elm$html$Html$text('Primary Address')
        ])) : $author$project$Utils$Html$empty;
        var billingAddress = function() {
            var _v2 = _Utils_Tuple2($author$project$Api$Provider$Patient$One$usesBillingAddress(patient), $author$project$Api$Provider$Patient$One$billingAddress(patient));
            if (_v2.a && !_v2.b.$) {
                var billingAddress_ = _v2.b.a;
                var billingAddressTitle = $author$project$Api$Provider$Practice$One$labelBillingAsShipping(practice) ? 'Shipping Address' : 'Billing Address';
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$p, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-label-md'),
                        $elm$html$Html$Attributes$class('mb-025')
                    ]), _List_fromArray([
                        $elm$html$Html$text(billingAddressTitle)
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsEnd
                    ]), _List_fromArray([
                        $author$project$Components$AddressDisplay$view(billingAddress_),
                        A2($author$project$Pages$Patients$PatientId_String$Top$viewCopyButton, 'patient billing address', $author$project$Components$AddressDisplay$viewOneLineAddress(billingAddress_))
                    ]))
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        var _v0 = function() {
            var _v1 = $author$project$Api$Provider$Patient$One$address(patient);
            if (!_v1.$) {
                var address = _v1.a;
                return _Utils_Tuple2($author$project$Components$AddressDisplay$view(address), A2($author$project$Pages$Patients$PatientId_String$Top$viewCopyButton, 'patient primary address', $author$project$Components$AddressDisplay$viewOneLineAddress(address)));
            } else return _Utils_Tuple2($author$project$Utils$Html$empty, $author$project$Utils$Html$empty);
        }();
        var primaryAddress = _v0.a;
        var primaryAddressCopyButton = _v0.b;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(6)
            ]), _List_fromArray([
                primaryAddressTitle,
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsEnd
                ]), _List_fromArray([
                    primaryAddress,
                    primaryAddressCopyButton
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(6)
            ]), _List_fromArray([
                billingAddress
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$RequestPendingDocsAcceptanceButtonClicked = {
        $: 15
    };
    var $author$project$Ui$Skeleton$ifLoading = F3(function(data, skeleton, content) {
        switch(data.$){
            case 1:
                return skeleton;
            case 3:
                return content;
            default:
                return $elm$html$Html$text('');
        }
    });
    var $author$project$Api$Provider$PatientDocument$All$name = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PatientDocument$One$name(one);
    };
    var $author$project$Api$Provider$PatientDocument$All$signedAt = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PatientDocument$One$signedAt(one);
    };
    var $author$project$Api$Provider$PatientDocument$All$status = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PatientDocument$One$status(one);
    };
    var $author$project$Api$Provider$PatientDocument$All$id = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$PatientDocument$One$id(one);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementLink = F2(function(patient, document1) {
        return $author$project$Api$Provider$Patient$One$archived(patient) ? $author$project$Utils$Html$empty : A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top({
            I$: $author$project$Api$Provider$PatientDocument$All$id(document1),
            V8: $author$project$Api$Provider$Patient$One$id(patient)
        }), _List_Nil, _List_fromArray([
            $elm$html$Html$text('View Details')
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewAgreement = F3(function(timeFormatter, patient, document1) {
        var signedAt = A2($elm$core$Maybe$map, timeFormatter(0), $author$project$Api$Provider$PatientDocument$All$signedAt(document1));
        var signedAtText = function() {
            if (!signedAt.$) {
                var text = signedAt.a;
                return ' on ' + text;
            } else return '';
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label($author$project$Api$Provider$PatientDocument$All$name(document1)),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$labelClass('control-label')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$PatientDocument$All$status(document1)),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$small
                        ]), _List_fromArray([
                            $elm$html$Html$text(signedAtText)
                        ]))
                    ])),
                    A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreementLink, patient, document1)
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementsLastRequestSent = function(model) {
        var _v0 = model.rW;
        if (!_v0.$) {
            var sentAt = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, model.HO(1), model.rW));
            return A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('Last request sent ' + (sentAt + '.'))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAccepted = function(_v0) {
        var shared = _v0;
        return shared.QR;
    };
    var $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAccepted(shared);
    };
    var $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAcceptedAt = function(_v0) {
        var shared = _v0;
        return shared.QS;
    };
    var $author$project$Api$Provider$Patient$One$hipaaAuthorizationAcceptedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$hipaaAuthorizationAcceptedAt(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverClicked = {
        $: 46
    };
    var $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverClicked = {
        $: 47
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiverLink = function(patient) {
        var _v0 = $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted(patient) ? _Utils_Tuple2('Remove ePHI waiver', $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverClicked) : _Utils_Tuple2('Accept ePHI waiver', $author$project$Pages$Patients$PatientId_String$Top$AcceptEphiWaiverClicked);
        var linkText = _v0.a;
        var linkMsg = _v0.b;
        return A3($author$project$Ui$Button$view, {
            abP: linkText
        }, _List_fromArray([
            $author$project$Ui$Button$onClick(linkMsg),
            $author$project$Ui$Button$sm
        ]), _List_fromArray([
            $elm$html$Html$text(linkText)
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiver = function(model) {
        var accepted = $author$project$Api$Provider$Patient$One$hipaaAuthorizationAccepted(model.V7);
        var signedAt = accepted ? A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(date) {
            return ' on ' + A2(model.HO, 0, date);
        }, $author$project$Api$Provider$Patient$One$hipaaAuthorizationAcceptedAt(model.V7))) : '';
        var status = accepted ? 'accepted' : 'not_accepted';
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('ePHI Waiver'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Badge$fromString, _List_Nil, status),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$small
                        ]), _List_fromArray([
                            $elm$html$Html$text(signedAt)
                        ]))
                    ])),
                    A2($author$project$Permission$hideIfReadOnly, model.Z$, $author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiverLink(model.V7))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ToggleViewOutdatedDocuments = {
        $: 33
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewOutdatedAgreements = function(_v0) {
        var outdatedPatientDocuments = _v0.rR;
        var outdatedDocumentsVisible = _v0.rQ;
        var patient = _v0.V7;
        var timeFormatter = _v0.HO;
        if (outdatedPatientDocuments.$ === 3) {
            var documents = outdatedPatientDocuments.a;
            return $elm$core$List$length(documents) > 0 ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                function() {
                    var _v2 = outdatedDocumentsVisible ? _Utils_Tuple2('Hide additional signed agreements ', $author$project$Ui$Icon$chevron(_List_fromArray([
                        $author$project$Ui$Icon$rotate180
                    ]))) : _Utils_Tuple2('Show additional signed agreements ', $author$project$Ui$Icon$chevronDown(_List_Nil));
                    var label = _v2.a;
                    var icon = _v2.b;
                    return A3($author$project$Ui$Button$view, {
                        abP: label
                    }, _List_fromArray([
                        $author$project$Ui$Button$styled(8),
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleViewOutdatedDocuments)
                    ]), _List_fromArray([
                        $elm$html$Html$text(label),
                        icon
                    ]));
                }(),
                outdatedDocumentsVisible ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$margin(21)
                    ]), _List_fromArray([
                        $elm$html$Html$text('These are previously signed agreements that are no longer required for the patient. These agreements may be related to an old plan or location assignment, or from agreements that have since become unpublished.')
                    ])),
                    A2($author$project$Ui$Form$view, _List_fromArray([
                        $author$project$Ui$Form$horizontal
                    ]), A2($elm$core$List$map, A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreement, timeFormatter, patient), documents))
                ])) : $author$project$Utils$Html$empty
            ])) : $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewAgreementsSection = function(model) {
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, $author$project$Ui$HorizontalRule$view(_List_Nil), A2($elm$core$List$cons, $author$project$Ui$Panel$titleSm(_List_fromArray([
            A3($author$project$Ui$Skeleton$ifLoading, model.nn, $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Agreements')
            ])), $elm$html$Html$text('Agreements'))
        ])), function() {
            var _v0 = model.nn;
            switch(_v0.$){
                case 3:
                    var documents = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Form$view, _List_fromArray([
                            $author$project$Ui$Form$horizontal
                        ]), $elm$core$List$concat(_List_fromArray([
                            A2($elm$core$List$map, A2($author$project$Pages$Patients$PatientId_String$Top$viewAgreement, model.HO, model.V7), documents),
                            _List_fromArray([
                                $author$project$Pages$Patients$PatientId_String$Top$viewEphiWaiver(model)
                            ])
                        ]))),
                        A2($author$project$Permission$hideIfReadOnly, model.Z$, $author$project$Pages$Patients$PatientId_String$Top$viewOutdatedAgreements(model)),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$justifyRight
                        ]), _List_fromArray([
                            A2($author$project$Permission$hideIfReadOnly, model.Z$, A3($author$project$Ui$Button$view, {
                                abP: 'Request acceptance by email'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$disabled($author$project$Api$Provider$Patient$One$archived(model.V7)),
                                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RequestPendingDocsAcceptanceButtonClicked),
                                $author$project$Ui$Button$loading(model.j5),
                                $author$project$Ui$Button$sm,
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Request acceptance by email')
                            ])))
                        ])),
                        $author$project$Pages$Patients$PatientId_String$Top$viewAgreementsLastRequestSent(model)
                    ]);
                case 1:
                    return _List_fromArray([
                        A2($author$project$Ui$Form$view, _List_fromArray([
                            $author$project$Ui$Form$horizontal
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSkeleton('Agreement'),
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    $author$project$Ui$Skeleton$text(_List_fromArray([
                                        $author$project$Ui$Skeleton$span(3)
                                    ]))
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSkeleton('Other Agreement'),
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    $author$project$Ui$Skeleton$text(_List_fromArray([
                                        $author$project$Ui$Skeleton$span(4)
                                    ]))
                                ]))
                            ]))
                        ]))
                    ]);
                default:
                    return _List_Nil;
            }
        }())));
    };
    var $author$project$Ui$Button$Outline = 6;
    var $author$project$Pages$Patients$PatientId_String$Top$RestorePatientButtonClicked = {
        $: 19
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewArchivedPatientAlert = function(patient) {
        return $author$project$Api$Provider$Patient$One$archived(patient) ? A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1),
                    $author$project$Ui$Grid$span(2),
                    $author$project$Ui$Grid$textCenter
                ]), _List_fromArray([
                    $author$project$Ui$Icon$warning(_List_fromArray([
                        $author$project$Ui$Icon$lg,
                        $author$project$Ui$Icon$danger
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8),
                    $author$project$Ui$Grid$span(10)
                ]), _List_fromArray([
                    $elm$html$Html$text('This patient has been archived and is currently read-only.')
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3)
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Restore ' + $author$project$Api$Provider$Patient$One$name(patient)
                    }, _List_fromArray([
                        $author$project$Ui$Button$styled(6),
                        $author$project$Ui$Button$pull(1),
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RestorePatientButtonClicked)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Restore ' + $author$project$Api$Provider$Patient$One$name(patient))
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewCreateMembershipModal = function(model) {
        var _v0 = model.h_;
        if (!_v0.$) {
            var modal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$CreateMembershipModalMsg, $author$project$Components$Patient$CreateMembershipModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$Patient$One$customForms = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.MU;
    });
    var $author$project$Api$Provider$Practice$One$customForms = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.MU;
    });
    var $author$project$Api$Provider$CustomForm$mergeForms = F2(function(practiceForms, patientForms) {
        var mergedForms = _Utils_ap(patientForms, practiceForms);
        return A2($elm_community$list_extra$List$Extra$uniqueBy, function(_v0) {
            var record = _v0;
            return record.aef;
        }, mergedForms);
    });
    var $author$project$Api$Provider$CustomForm$formResponseId = function(_v0) {
        var record = _v0;
        return record.xP;
    };
    var $author$project$Api$Provider$CustomForm$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$CustomForm$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$CustomForm$questions = function(_v0) {
        var record = _v0;
        return record.BA;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$OpenEditCustomFormAnswerModal = F3(function(a, b, c) {
        return {
            $: 38,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Utils$String$boolStringToYesNo = function(boolString) {
        return boolString === 'true' ? 'Yes' : 'No';
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormAnswer = F2(function(answer, type_) {
        var text_ = function() {
            if (!type_) return $author$project$Utils$String$boolStringToYesNo(answer);
            else return answer;
        }();
        return A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$phi(true)
        ]), _List_fromArray([
            $elm$html$Html$text(text_)
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormQuestion = F3(function(formId, formResponseId, question) {
        return A2($author$project$Ui$Form$Static$view, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$CustomForm$title(question))
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Edit answer'
                    }, _List_fromArray([
                        $author$project$Ui$Button$sm,
                        $author$project$Ui$Button$onClick(A3($author$project$Pages$Patients$PatientId_String$Top$OpenEditCustomFormAnswerModal, question, formId, formResponseId))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Edit Answer')
                    ]))
                ]))
            ]))
        ])), $elm$core$List$isEmpty($author$project$Api$Provider$CustomForm$answers(question)) ? _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$italic,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('None')
            ]))
        ]) : A2($elm$core$List$map, function(answer) {
            return A2($author$project$Pages$Patients$PatientId_String$Top$viewCustomFormAnswer, $author$project$Api$Provider$CustomForm$answerText(answer), $author$project$Api$Provider$CustomForm$questionType(question));
        }, $author$project$Api$Provider$CustomForm$answers(question))));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewCustomForm = function(customForm) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label($author$project$Api$Provider$CustomForm$name(customForm)),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A2($author$project$Pages$Patients$PatientId_String$Top$viewCustomFormQuestion, $author$project$Api$Provider$CustomForm$id(customForm), $author$project$Api$Provider$CustomForm$formResponseId(customForm)), $author$project$Api$Provider$CustomForm$questions(customForm)))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormsSection = function(_v0) {
        var patient = _v0.V7;
        var practice = _v0.W1;
        var customForms = A2($author$project$Api$Provider$CustomForm$mergeForms, $author$project$Api$Provider$Practice$One$customForms(practice), $author$project$Api$Provider$Patient$One$customForms(patient));
        return $elm$core$List$isEmpty(customForms) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Panel$titleSm(_List_fromArray([
                $elm$html$Html$text('Additional Info')
            ])),
            A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewCustomForm, customForms))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewDetachPatientModal = function(model) {
        return model.il ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Top$ConfirmDetachPatientModalClicked($author$project$Api$Provider$Patient$One$id(model.V7)), _List_fromArray([
            $author$project$Components$HiConfirm$verb('detach'),
            $author$project$Components$HiConfirm$noun('patient'),
            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('This patient will become independent of the network and be attached to your practice only.')
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$Patient$One$dpcPatient = function(_v0) {
        var record = _v0.b;
        return record.Oi;
    };
    var $author$project$Ui$Form$Static$NoValue = {
        $: 3
    };
    var $author$project$Ui$Form$Static$noValue = $author$project$Ui$Form$Static$NoValue;
    var $author$project$Api$Provider$Patient$DpcPatient$status = function(_v0) {
        var dpc = _v0;
        return dpc.ahy;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewDpcPractice = F2(function(practice, patient) {
        var _v0 = $author$project$Api$Provider$Practice$One$accountType(practice);
        if (_v0 === 2) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('DPC Practice'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            function() {
                var _v1 = $author$project$Api$Provider$Patient$One$knownPractice(patient);
                if (!_v1.$) {
                    var knownPractice = _v1.a;
                    return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$KnownPractice$Shared$name(knownPractice) + ' '),
                        function() {
                            var _v2 = $author$project$Api$Provider$Patient$One$dpcPatient(patient);
                            if (!_v2.$) {
                                var dpcPatient = _v2.a;
                                var _v3 = $author$project$Api$Provider$Patient$DpcPatient$status(dpcPatient);
                                if (!_v3.$) {
                                    var status = _v3.a;
                                    return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
                                } else return $author$project$Utils$Html$empty;
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]));
                } else return A2($author$project$Ui$Form$Static$view, _List_fromArray([
                    $author$project$Ui$Form$Static$noValue
                ]), _List_Nil);
            }()
        ]));
        else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Patient$EditAthenaIdModal$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Patient$EditAthenaIdModal$Submit = {
        $: 2
    };
    var $author$project$Components$Patient$EditAthenaIdModal$view = function(_v0) {
        var model = _v0;
        if (model.Vw) {
            var footerContent = _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Cancel and close modal'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$EditAthenaIdModal$Close)
                ]), _List_fromArray([
                    $elm$html$Html$text('Cancel')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Save'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$EditAthenaIdModal$Submit)
                ]), _List_fromArray([
                    $elm$html$Html$text('Save')
                ]))
            ]);
            var enterpriseID = $author$project$Api$Provider$IntegrationRecord$All$integrationRecordId(model.q0);
            var body = _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Partner IDs'),
                    $author$project$Ui$Form$Group$labelSpanSm(4)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text("You can find patient ID on athena\u2019s patient chart next to their age and date of birth.")
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$m0
                    ]), _List_fromArray([
                        $elm$html$Html$text("Changing the linked patient id will immediately push data to athena for this patient. If any conflicts arise, athena\u2019s data will be automatically overwritten.")
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(''),
                    $author$project$Ui$Form$Group$labelSpanSm(4)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$group(_List_fromArray([
                        $author$project$Ui$Form$Input$addon(_List_fromArray([
                            $elm$html$Html$text('#')
                        ])),
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(model.rz),
                            $author$project$Ui$Form$Input$onInput($author$project$Components$Patient$EditAthenaIdModal$FormUpdated)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label(''),
                    $author$project$Ui$Form$Group$labelSpanSm(4)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$group(_List_fromArray([
                        $author$project$Ui$Form$Input$addon(_List_fromArray([
                            $elm$html$Html$text('E#')
                        ])),
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', enterpriseID)),
                            $author$project$Ui$Form$Input$disabled(true)
                        ]))
                    ]))
                ]))
            ]);
            return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$EditAthenaIdModal$Close, _List_fromArray([
                $author$project$Ui$Modal$size(1)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Edit Partner ID')
                ])),
                $author$project$Ui$Modal$body(body),
                $author$project$Ui$Modal$footer(footerContent)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEditAthenaIdModal = function(model) {
        var _v0 = model.iu;
        if (!_v0.$) {
            var modal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$EditPartnerIdModalMsg, $author$project$Components$Patient$EditAthenaIdModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerCreated = {
        $: 4
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$Update = {
        $: 1
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$BooleanAnswerChanged = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer = F3(function(answer, newAnswer, displayAnswer) {
        return A3($author$project$Ui$Button$view, {
            abP: displayAnswer
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq($author$project$Api$Provider$CustomForm$answerText(answer), newAnswer)),
            $author$project$Ui$Button$onClick(A2($author$project$Components$Patient$EditCustomFormAnswerModal$BooleanAnswerChanged, answer, newAnswer))
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text(displayAnswer)
            ]))
        ]));
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$viewBooleanAnswers = function(formAnswer) {
        return $author$project$Ui$Button$group(_List_fromArray([
            A3($author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer, formAnswer, 'true', 'Yes'),
            A3($author$project$Components$Patient$EditCustomFormAnswerModal$toggleBooleanAnswer, formAnswer, 'false', 'No')
        ]));
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerDeleted = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerUpdated = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput = F2(function(index, value) {
        return $author$project$Ui$Form$Input$view(_List_fromArray([
            $author$project$Ui$Form$Input$value(value),
            $author$project$Ui$Form$Input$onInput($author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerUpdated(index)),
            $author$project$Ui$Form$Input$phi(true)
        ]));
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$viewMultipleStringAnswer = F3(function(index, value, isDestroyed) {
        if (!isDestroyed.$ && isDestroyed.a) return $author$project$Utils$Html$empty;
        else return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(11)
            ]), _List_fromArray([
                A2($author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput, index, value)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(1)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Delete multiple string answer'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$margin(7),
                    $author$project$Ui$Button$size(0),
                    $author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerDeleted(index)),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_Nil)
            ]))
        ]));
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$viewStringAnswer = F2(function(index, value) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanSm(12)
            ]), _List_fromArray([
                A2($author$project$Components$Patient$EditCustomFormAnswerModal$viewStringInput, index, value)
            ]))
        ]));
    });
    var $author$project$Components$Patient$EditCustomFormAnswerModal$viewBody = function(model) {
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$onSubmit($author$project$Components$Patient$EditCustomFormAnswerModal$Update),
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Answers to the Question'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$bold
                ]), _List_fromArray([
                    $elm$html$Html$text(model.$2)
                ])), function() {
                    var _v0 = model.ah5;
                    switch(_v0){
                        case 0:
                            return A2($elm$core$List$map, $author$project$Components$Patient$EditCustomFormAnswerModal$viewBooleanAnswers, model.pz);
                        case 2:
                            return A2($elm$core$List$indexedMap, F2(function(index, answer) {
                                return A2($author$project$Components$Patient$EditCustomFormAnswerModal$viewStringAnswer, index, $author$project$Api$Provider$CustomForm$answerText(answer));
                            }), model.pz);
                        default:
                            return _Utils_ap(A2($elm$core$List$indexedMap, F2(function(index, answer) {
                                return A3($author$project$Components$Patient$EditCustomFormAnswerModal$viewMultipleStringAnswer, index, $author$project$Api$Provider$CustomForm$answerText(answer), $author$project$Api$Provider$CustomForm$destroy(answer));
                            }), model.pz), _List_fromArray([
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Add answer'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$MultipleStringAnswerCreated),
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Add Answer')
                                ]))
                            ]));
                    }
                }()))
            ]))
        ]));
    };
    var $author$project$Components$Patient$EditCustomFormAnswerModal$viewFooter = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Cancel and close modal'
        }, _List_fromArray([
            $author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$Close)
        ]), _List_fromArray([
            $elm$html$Html$text('Cancel')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Update'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$onClick($author$project$Components$Patient$EditCustomFormAnswerModal$Update)
        ]), _List_fromArray([
            $elm$html$Html$text('Update')
        ]))
    ]);
    var $author$project$Components$Patient$EditCustomFormAnswerModal$view = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$EditCustomFormAnswerModal$Close, _List_fromArray([
            $author$project$Ui$Modal$size(1)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Edit Answer')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $author$project$Components$Patient$EditCustomFormAnswerModal$viewBody(model)
            ])),
            $author$project$Ui$Modal$footer($author$project$Components$Patient$EditCustomFormAnswerModal$viewFooter)
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEditCustomFormAnswerModal = function(model) {
        var _v0 = model.fE;
        if (!_v0.$) {
            var modal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$EditCustomFormAnswerModalMsg, $author$project$Components$Patient$EditCustomFormAnswerModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewElationForcePushConfirmModal = function(model) {
        return model.mo ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalClosed, _List_fromArray([
            $author$project$Components$HiConfirm$verb('sync To'),
            $author$project$Components$HiConfirm$noun('elation'),
            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                $elm$html$Html$text('You\'re about to sync to elation and override the conflicting values with their values here. This action cannot be undone.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ResetBouncedEmail = {
        $: 67
    };
    var $author$project$Api$Provider$EmailAddress$One$isRejected = function(_v0) {
        var record = _v0;
        return record.Sp;
    };
    var $author$project$Api$Provider$EmailAddress$One$isUnsubscribed = function(_v0) {
        var record = _v0;
        return record.Sx;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEmailSection = F2(function(patient, emailAddressData) {
        return A2($author$project$Ui$Form$Group$view, _List_Nil, function() {
            if (emailAddressData.$ === 3) {
                if (!emailAddressData.a.$) {
                    var emailAddress = emailAddressData.a.a;
                    return _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Provider$EmailAddress$One$email(emailAddress))
                                ])),
                                $author$project$Api$Provider$EmailAddress$One$isRejected(emailAddress) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Popover$view, _List_fromArray([
                                        $author$project$Ui$Popover$dark
                                    ]), _List_fromArray([
                                        $author$project$Ui$Icon$cross(_List_fromArray([
                                            $author$project$Ui$Icon$danger
                                        ])),
                                        $elm$html$Html$text('Invalid')
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Popover$heading, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Email is invalid and will not be used')
                                        ]))
                                    ]))
                                ])) : $author$project$Utils$Html$empty
                            ])),
                            A2($author$project$Pages$Patients$PatientId_String$Top$viewCopyButton, 'patient email', A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$One$email(patient)))
                        ])),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $author$project$Api$Provider$EmailAddress$One$isBounced(emailAddress) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Badge$view, _List_fromArray([
                                        $author$project$Ui$Badge$danger
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('Bounced')
                                    ]))
                                ])),
                                A3($author$project$Ui$Button$view, {
                                    abP: 'Reset bounced status'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$styled(6),
                                    $author$project$Ui$Button$primary,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ResetBouncedEmail),
                                    $author$project$Ui$Button$margin(7),
                                    $author$project$Ui$Button$pull(1),
                                    $author$project$Ui$Button$sm,
                                    $author$project$Ui$Button$icon($author$project$Ui$Icon$repeat)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Reset Bounced Status')
                                ]))
                            ])) : $author$project$Api$Provider$EmailAddress$One$isUnsubscribed(emailAddress) ? A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                A2($author$project$Ui$Badge$view, _List_fromArray([
                                    $author$project$Ui$Badge$warning
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Unsubscribed')
                                ]))
                            ])) : $author$project$Utils$Html$empty
                        ]))
                    ]);
                } else {
                    var _v1 = emailAddressData.a;
                    return _List_fromArray([
                        $author$project$Utils$Html$empty
                    ]);
                }
            } else return _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(2)
                    ]))
                ]))
            ]);
        }());
    });
    var $author$project$Api$Common$EmergencyContact$Shared$name = A2($elm$core$Basics$composeR, $author$project$Api$Common$EmergencyContact$Shared$record, function($) {
        return $.zr;
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewPhone = function(phone) {
        var formattedPhone = function(number) {
            return $author$project$Formatters$Phone$formatWithCountry(number) + (' (' + ($author$project$Formatters$PhoneType$toString($author$project$Api$Common$Phone$Shared$type_(phone)) + ')'));
        };
        var _v0 = $author$project$Api$Common$Phone$Shared$number(phone);
        if (!_v0.$) {
            var number = _v0.a;
            return A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text(formattedPhone(number)),
                A2($author$project$Pages$Patients$PatientId_String$Top$viewCopyButton, 'patient phone', $author$project$Formatters$Phone$formatWithCountry(number))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEmergencyContact = function(emergencyContact) {
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$andThen, function(name) {
                return $elm$core$String$isEmpty(name) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($elm$html$Html$div, _List_Nil, $elm$core$List$singleton($elm$html$Html$text(name))));
            }, $author$project$Api$Common$EmergencyContact$Shared$name(emergencyContact)),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Formatters$String$titleize, A2($elm$core$Basics$composeR, $elm$html$Html$text, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm$html$Html$div(_List_Nil)))), $author$project$Api$Common$EmergencyContact$Shared$relationship(emergencyContact)),
            A2($elm$core$Maybe$map, function(email) {
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(email),
                    A2($author$project$Pages$Patients$PatientId_String$Top$viewCopyButton, 'emergency contact email', email)
                ]));
            }, $author$project$Api$Common$EmergencyContact$Shared$email(emergencyContact)),
            A2($elm$core$Maybe$map, function(phone) {
                return $author$project$Pages$Patients$PatientId_String$Top$viewPhone(phone);
            }, $author$project$Api$Common$EmergencyContact$Shared$phone(emergencyContact))
        ])));
    };
    var $author$project$Api$Provider$Patient$One$isMaster = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.R8;
    });
    var $author$project$Pages$Patients$PatientId_String$Top$EngagementClicked = {
        $: 59
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEngagementBadge = function(status) {
        var _v0 = function() {
            switch(status){
                case 'currently_engaged':
                    return _Utils_Tuple2($author$project$Ui$Badge$success, 'Currently Engaged');
                case 'previously_engaged':
                    return _Utils_Tuple2($author$project$Ui$Badge$primary, 'Previously Engaged');
                default:
                    return _Utils_Tuple2($author$project$Ui$Badge$danger, 'Never Engaged');
            }
        }();
        var color = _v0.a;
        var engagementStatus = _v0.b;
        return A3($author$project$Ui$Button$view, {
            abP: engagementStatus
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$EngagementClicked)
        ]), _List_fromArray([
            A2($author$project$Ui$Badge$view, _List_fromArray([
                color
            ]), _List_fromArray([
                $elm$html$Html$text(engagementStatus)
            ]))
        ]));
    };
    var $author$project$Api$Provider$Patient$Engagement$invoice = function(_v0) {
        var engagement = _v0;
        return engagement.RA;
    };
    var $author$project$Api$Provider$Patient$Engagement$lastEngagementDate = function(_v0) {
        var engagement = _v0;
        return engagement.SS;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEngagementPopover = function(model) {
        var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.V7);
        var _v0 = _Utils_Tuple2(model.Fo, engagementStatus === 'never_engaged');
        if (!_v0.b) {
            if (_v0.a.$ === 3) {
                var _v1 = _v0.a;
                var engagement = _v1.a;
                var maybeLastEngagementDate = $author$project$Api$Provider$Patient$Engagement$lastEngagementDate(engagement);
                var maybeInvoice = $author$project$Api$Provider$Patient$Engagement$invoice(engagement);
                var _v2 = _Utils_Tuple2(maybeLastEngagementDate, maybeInvoice);
                if (!_v2.a.$ && !_v2.b.$) {
                    var lastEngagementDate = _v2.a.a;
                    var invoice = _v2.b.a;
                    var invoiceType = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
                    var invoiceNumber = $author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice);
                    var invoiceId = $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice);
                    var invoiceLink = function() {
                        switch(invoiceType){
                            case 1:
                                var patientId = $author$project$Api$Provider$Patient$One$id(model.V7);
                                return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                    RI: invoiceId,
                                    V8: patientId
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('#' + $elm$core$String$fromInt(invoiceNumber))
                                ]));
                            case 0:
                                var companyId = function() {
                                    var _v5 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
                                    if (!_v5.$) {
                                        var company = _v5.a;
                                        return $author$project$Api$Common$Payable$Owner$Min$id(company);
                                    } else return '';
                                }();
                                return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                                    fl: companyId,
                                    aef: invoiceId
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('#' + $elm$core$String$fromInt(invoiceNumber))
                                ]));
                            default:
                                return $author$project$Utils$Html$empty;
                        }
                    }();
                    var engagementThreshold = $elm$core$String$fromInt($author$project$Api$Provider$Practice$One$engagementThreshold(model.W1));
                    var topText = function() {
                        switch(engagementStatus){
                            case 'currently_engaged':
                                return 'Received services within ' + (engagementThreshold + ' months');
                            case 'previously_engaged':
                                return 'Previously utilized services, none received in the past ' + (engagementThreshold + ' months');
                            default:
                                return '';
                        }
                    }();
                    return A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(topText)
                        ])),
                        $author$project$Ui$HorizontalRule$view(_List_fromArray([
                            $author$project$Ui$HorizontalRule$thin
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Most recent service date: ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, lastEngagementDate))
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Invoice: '),
                            invoiceLink
                        ]))
                    ]));
                } else return A2($author$project$Ui$Popover$body, _List_Nil, _List_Nil);
            } else return A2($author$project$Ui$Popover$body, _List_Nil, _List_Nil);
        } else return A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Individuals who have never received services')
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEngagement = function(model) {
        var hasSyncedRecord = $author$project$Api$Provider$Patient$One$isSynced(model.V7) || $author$project$Api$Provider$Patient$One$isMaster(model.V7);
        var gateIsAvailable = A2($author$project$Utils$FeatureGate$gateAvailable, 11, $author$project$Api$Practice$Provider(model.W1));
        if (gateIsAvailable || hasSyncedRecord) {
            var engagementStatus = $author$project$Api$Provider$Patient$One$engagementStatus(model.V7);
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Engagement'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A4($author$project$Ui$Popover$viewAsClickable, _List_fromArray([
                        $author$project$Ui$Popover$dark,
                        $author$project$Ui$Popover$visible($author$project$Ui$Popover$isOpen(model.aN))
                    ]), _List_fromArray([
                        $author$project$Pages$Patients$PatientId_String$Top$viewEngagementBadge(engagementStatus)
                    ]), _List_fromArray([
                        $author$project$Pages$Patients$PatientId_String$Top$viewEngagementPopover(model)
                    ]), model.aN)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewAutopaySection = function(patient) {
        var autopayStatus = $author$project$Api$Provider$Patient$One$autopay(patient) ? 'Enabled' : 'Disabled';
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Autopay'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(autopayStatus)
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Api$Provider$Patient$One$creditExpiresSoon = function(_v0) {
        var record = _v0.b;
        return record.MC;
    };
    var $author$project$Api$Provider$Patient$One$creditInCents = function(_v0) {
        var record = _v0.b;
        return record.MD;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewCreditsSection = F3(function(practice, session, patient) {
        var manageCreditsLink = function() {
            var patientId = $author$project$Api$Provider$Patient$One$id(patient);
            return A2($author$project$Permission$hideIfReadOnly, session, A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$pull(1)
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits({
                    V8: patientId
                }), _List_fromArray([
                    $author$project$Ui$Link$buttonDefault,
                    $author$project$Ui$Link$disabled($author$project$Api$Provider$Patient$One$archived(patient)),
                    $author$project$Ui$Link$xs
                ]), _List_fromArray([
                    $elm$html$Html$text('Manage Credits')
                ]))
            ])));
        }();
        var expirationText = $author$project$Api$Provider$Patient$One$creditExpiresSoon(patient) ? A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$small,
            $author$project$Ui$Typography$danger
        ]), _List_fromArray([
            $elm$html$Html$text(' Expires soon')
        ])) : $author$project$Utils$Html$empty;
        var creditInCents = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Patient$One$creditInCents(patient));
        return A3($author$project$Utils$FeatureGate$gate, 4, $author$project$Api$Practice$Provider(practice), A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Credits'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(creditInCents),
                        expirationText,
                        manageCreditsLink
                    ]))
                ]))
            ]))
        ])));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewInvoicesLink = function(patient) {
        var patientId = $author$project$Api$Provider$Patient$One$id(patient);
        return A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$pull(1)
        ]), _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top({
                V8: patientId
            }), _List_fromArray([
                $author$project$Ui$Link$disabled($author$project$Api$Provider$Patient$One$archived(patient))
            ]), _List_fromArray([
                $elm$html$Html$text('See Invoices')
            ]))
        ]));
    };
    var $author$project$Api$Provider$Patient$One$defaultSource = function(_v0) {
        var record = _v0.b;
        return record.ND;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewNoPaymentMessage = function(patient) {
        return $author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0 && $author$project$Utils$Maybe$isNothing($author$project$Api$Provider$Patient$One$defaultSource(patient)) ? $elm$html$Html$text('There is no payment method for this account') : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$RequestPaymentInfoUpdateButtonClicked = {
        $: 13
    };
    var $author$project$Api$Provider$Patient$One$sourcesCount = function(_v0) {
        var record = _v0.b;
        return record._J;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewPaymentSourcesSection = F7(function(sendingRequestForPaymentInfo, patient, practice, patientRequestInfoSentAt, session, timeFormatter, isHintAdmin) {
        var lastRequestSent = function() {
            if (!patientRequestInfoSentAt.$) {
                var patientRequestInfoSentAt_ = patientRequestInfoSentAt.a;
                var sentAt = A2(timeFormatter, 1, patientRequestInfoSentAt_);
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('Last request sent ' + (sentAt + '.'))
                    ]))
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Default Payment Method'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = $author$project$Api$Provider$Patient$One$defaultSource(patient);
                        if (!_v0.$) {
                            var defaultSource = _v0.a;
                            var sourcesCount = $author$project$Api$Provider$Patient$One$sourcesCount(patient);
                            var sourcesCountText = function() {
                                if (sourcesCount > 1) {
                                    var additionalCount = sourcesCount - 1;
                                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                                        $author$project$Ui$Typography$attrs(_List_fromArray([
                                            $elm$html$Html$Attributes$class('pt-2')
                                        ]))
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top({
                                            V8: $author$project$Api$Provider$Patient$One$id(patient)
                                        }), _List_fromArray([
                                            $author$project$Ui$Link$disabled($author$project$Api$Provider$Patient$One$archived(patient))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('View ' + A2($author$project$Formatters$String$pluralize, 'additional payment option', additionalCount))
                                        ]))
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }();
                            var source = function() {
                                if (!defaultSource.$) {
                                    var cardOne = defaultSource.a;
                                    return $author$project$Api$Source$Card($author$project$Api$Card$ProviderOne(cardOne));
                                } else {
                                    var bankAccountOne = defaultSource.a;
                                    return $author$project$Api$Source$BankAccount($author$project$Api$BankAccount$ProviderOne(bankAccountOne));
                                }
                            }();
                            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Components$PaymentSourceDisplayer$view, timeFormatter, _List_fromArray([
                                        $author$project$Components$PaymentSourceDisplayer$source($elm$core$Maybe$Just(source)),
                                        $author$project$Components$PaymentSourceDisplayer$noPaymentMethodStatus(false),
                                        $author$project$Components$PaymentSourceDisplayer$limitedView(false),
                                        $author$project$Components$PaymentSourceDisplayer$showProcessor(isHintAdmin)
                                    ])),
                                    sourcesCountText
                                ]))
                            ]));
                        } else {
                            var patientId = $author$project$Api$Provider$Patient$One$id(patient);
                            var goToOrManagePaymentOptionsText = $author$project$Api$Provider$Patient$One$sourcesCount(patient) > 0 ? 'Manage Payment Options' : 'Go to Payment Options';
                            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Badge$fromString, _List_Nil, 'none')
                                    ]))
                                ])),
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanMd(6)
                                ]), _List_fromArray([
                                    A2($author$project$Permission$hideIfReadOnly, session, A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$justifyRight
                                    ]), _List_fromArray([
                                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top({
                                            V8: patientId
                                        }), _List_fromArray([
                                            $author$project$Ui$Link$disabled($author$project$Api$Provider$Patient$One$archived(patient))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text(goToOrManagePaymentOptionsText)
                                        ]))
                                    ])))
                                ]))
                            ]));
                        }
                    }(),
                    function() {
                        if (!$author$project$Api$Provider$Practice$One$acceptsAch(practice) && !$author$project$Api$Provider$Practice$One$acceptsCards(practice)) return $author$project$Utils$Html$empty;
                        else {
                            if (!$author$project$Api$Provider$Practice$One$collectPaymentSourceOnSignup(practice)) return $author$project$Utils$Html$empty;
                            else {
                                var sendOrResendRequestTest = function() {
                                    if (!patientRequestInfoSentAt.$) return ' Resend Request For Payment Info';
                                    else return ' Send Request For Payment Info';
                                }();
                                return A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$justifyRight
                                ]), _List_fromArray([
                                    A2($author$project$Permission$hideIfReadOnly, session, A3($author$project$Ui$Button$view, {
                                        abP: sendOrResendRequestTest
                                    }, _List_fromArray([
                                        $author$project$Ui$Button$primary,
                                        $author$project$Ui$Button$disabled($author$project$Api$Provider$Patient$One$archived(patient)),
                                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RequestPaymentInfoUpdateButtonClicked),
                                        $author$project$Ui$Button$loading(sendingRequestForPaymentInfo),
                                        $author$project$Ui$Button$sm,
                                        $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(sendOrResendRequestTest)
                                    ])))
                                ]));
                            }
                        }
                    }(),
                    lastRequestSent
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewSurchargeEligibilitySection = function(patient) {
        var _v0 = $author$project$Api$Provider$Patient$One$shouldChargeCreditCardFees(patient) ? _Utils_Tuple2('Enabled', 'Fees will be passed through to the patient if they pay by credit card') : _Utils_Tuple2('Disabled', 'This patient is excluded from credit card passthrough fees');
        var surchargeStatus = _v0.a;
        var surchargeTooltip = _v0.b;
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Surcharging'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$wide
                    ]), surchargeTooltip, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(surchargeStatus)
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewUnpaidWarning = function(patient) {
        return $author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0 ? A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$margin(10),
            $author$project$Ui$Typography$small,
            $author$project$Ui$Typography$danger
        ]), _List_fromArray([
            $author$project$Ui$Icon$warning(_List_fromArray([
                $author$project$Ui$Icon$danger
            ])),
            $elm$html$Html$text(' Unpaid Charges')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewFinancialInformation = function(_v0) {
        var patient = _v0.V7;
        var session = _v0.Z$;
        var practice = _v0.W1;
        var timeFormatter = _v0.HO;
        var patientRequestInfoSentAt = _v0.AC;
        var sendingRequestForPaymentInfo = _v0.j6;
        var isHintAdmin = _v0.F3;
        var owedInCents = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Patient$One$owedInCents(patient));
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Panel$titleSm(_List_fromArray([
                $elm$html$Html$text('Financial Info')
            ])),
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Balance'),
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(owedInCents),
                            $author$project$Pages$Patients$PatientId_String$Top$viewUnpaidWarning(patient),
                            A2($author$project$Permission$hideIfReadOnly, session, $author$project$Pages$Patients$PatientId_String$Top$viewInvoicesLink(patient))
                        ])),
                        $author$project$Pages$Patients$PatientId_String$Top$viewNoPaymentMessage(patient)
                    ]))
                ]))
            ])),
            A3($author$project$Pages$Patients$PatientId_String$Top$viewCreditsSection, practice, session, patient),
            $author$project$Pages$Patients$PatientId_String$Top$viewAutopaySection(patient),
            A2($author$project$Utils$Html$htmlIf, $author$project$Api$Provider$Practice$One$chargePatientsCreditCardFees(practice), $author$project$Pages$Patients$PatientId_String$Top$viewSurchargeEligibilitySection(patient)),
            A7($author$project$Pages$Patients$PatientId_String$Top$viewPaymentSourcesSection, sendingRequestForPaymentInfo, patient, practice, patientRequestInfoSentAt, session, timeFormatter, isHintAdmin)
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$fullGenderIdentity = function(pat) {
        var fields = A2($elm$core$List$map, $elm_community$string_extra$String$Extra$toSentenceCase, A2($elm$core$List$filter, function(val) {
            return val !== 'not listed';
        }, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $author$project$Api$Provider$Patient$One$sex(pat),
            $author$project$Api$Provider$Patient$One$genderIdentity(pat),
            $author$project$Api$Provider$Patient$One$genderOther(pat),
            $author$project$Api$Provider$Patient$One$pronoun(pat)
        ]))));
        return $elm$html$Html$text(A2($elm$core$String$join, ', ', fields));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewGenderSection = F2(function(practice, patient) {
        var gender = function() {
            if ($author$project$Api$Provider$Practice$One$transInclusivity(practice)) return $author$project$Pages$Patients$PatientId_String$Top$fullGenderIdentity(patient);
            else {
                var _v0 = $author$project$Api$Provider$Patient$One$gender(patient);
                if (!_v0.$) {
                    var gender_ = _v0.a;
                    return gender_ === 'other' ? $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$One$genderOther(patient))) : $elm$html$Html$text(gender_);
                } else return $author$project$Utils$Html$empty;
            }
        }();
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                gender
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewHealthInsurance = function(patient) {
        var content = function() {
            var _v0 = $author$project$Api$Provider$Patient$One$healthInsurance(patient);
            if (!_v0.$) {
                var insurance = _v0.a;
                return _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$HealthInsurance$Shared$payerName(insurance)))
                            ]))
                        ]))
                    ])),
                    function() {
                        var _v1 = $author$project$Api$Provider$HealthInsurance$Shared$groupId(insurance);
                        if (!_v1.$) {
                            var groupId = _v1.a;
                            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Group ID: '),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(groupId)
                                ]))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v2 = $author$project$Api$Provider$HealthInsurance$Shared$memberId(insurance);
                        if (!_v2.$) {
                            var memberId = _v2.a;
                            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Member ID: '),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(memberId)
                                ]))
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v3 = $author$project$Api$Provider$HealthInsurance$Shared$highDeductible(insurance);
                        if (!_v3.$) {
                            var highDeductible = _v3.a;
                            var icon = highDeductible ? $author$project$Ui$Icon$check(_List_fromArray([
                                $author$project$Ui$Icon$success
                            ])) : $author$project$Ui$Icon$cross(_List_fromArray([
                                $author$project$Ui$Icon$danger
                            ]));
                            return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                    icon
                                ])),
                                $elm$html$Html$text('  High Deductible Plan')
                            ]));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]);
            } else return _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_fromArray([
                    $author$project$Ui$Form$Static$noValue
                ]), _List_Nil)
            ]);
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Insurance Carrier'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), content);
    };
    var $author$project$Utils$Route$integrationsRoute = function(practice) {
        return ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe' || $author$project$Api$Provider$Practice$One$hasStripeAccount(practice)) && !A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice) ? $author$project$Spa$Generated$Route$Admin__Stripe : $author$project$Spa$Generated$Route$Admin__CardReaders;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalOpened = {
        $: 27
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts = F2(function(a, b) {
        return {
            $: 30,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$ExternalRecord$conflicts = function(_v0) {
        var record = _v0;
        return record.LY;
    };
    var $author$project$Api$Provider$ExternalRecord$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$ExternalRecord$source = function(_v0) {
        var record = _v0;
        return record.Hw;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewConflict = function(_v0) {
        var name = _v0.zr;
        var ours = _v0.afZ;
        var theirs = _v0.ahR;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(3)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(name)
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(ours)
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(theirs)
                ]))
            ]))
        ]));
    };
    var $author$project$Api$Provider$ExternalRecord$statusCode = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecordStatusBadge = function(record) {
        var _v0 = $author$project$Api$Provider$ExternalRecord$statusCode(record);
        switch(_v0){
            case 2:
                return A2($author$project$Ui$Badge$fromString, _List_Nil, 'errored');
            case 0:
                return A2($author$project$Ui$Badge$fromString, _List_Nil, 'synced');
            default:
                return $author$project$Utils$Html$empty;
        }
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecord = F3(function(idx, conflictsVisible, record) {
        var source = $author$project$Api$Provider$ExternalRecord$source(record);
        var showConflicts = A2($elm$core$Maybe$withDefault, false, conflictsVisible);
        var maybeErrorMsg = $author$project$Api$Provider$ExternalRecord$errorMessage(record);
        var conflictsList = A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Provider$ExternalRecord$conflicts(record));
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label($author$project$Formatters$String$titleize(source)),
            $author$project$Ui$Form$Group$labelSpan(3),
            $author$project$Ui$Form$Group$inputSpan(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(2)
                ]), _List_fromArray([
                    A2($elm$html$Html$p, _List_fromArray([
                        $elm$html$Html$Attributes$class('form-control-static')
                    ]), _List_fromArray([
                        source === 'elation' ? $author$project$Pages$Patients$PatientId_String$Top$viewExternalRecordStatusBadge(record) : $author$project$Utils$Html$empty
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(10)
                ]), _List_fromArray([
                    A2($elm$html$Html$p, _List_fromArray([
                        $elm$html$Html$Attributes$class('form-control-static')
                    ]), _List_fromArray([
                        A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('text-muted'),
                            $elm$html$Html$Attributes$class('text-body-small'),
                            $elm$html$Html$Attributes$class('ml-1')
                        ]), _List_fromArray([
                            function() {
                                if (!maybeErrorMsg.$) {
                                    var error = maybeErrorMsg.a;
                                    return $elm$html$Html$text(error);
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ])),
                        $elm$core$List$isEmpty(conflictsList) ? $author$project$Utils$Html$empty : showConflicts ? A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('pull-right')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Hide conflicts'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick(A2($author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts, idx, false))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Hide conflicts')
                            ]))
                        ])) : A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('pull-right')
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Show conflicts'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                $author$project$Ui$Button$onClick(A2($author$project$Pages$Patients$PatientId_String$Top$ToggleIntegrationConflicts, idx, true))
                            ]), _List_fromArray([
                                $elm$html$Html$text('Show conflicts')
                            ]))
                        ]))
                    ]))
                ]))
            ])),
            showConflicts ? A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('well'),
                $elm$html$Html$Attributes$class('well-sm')
            ]), A2($elm$core$List$cons, A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-label-md')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Field')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-label-md')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Our Value')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-label-md')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Elation\'s Value')
                    ]))
                ]))
            ])), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewConflict, conflictsList))) : $author$project$Utils$Html$empty,
            showConflicts ? A3($author$project$Ui$Button$view, {
                abP: 'Sync to elation anyways'
            }, _List_fromArray([
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$styled(4),
                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ElationForcePushConfirmationModalOpened)
            ]), _List_fromArray([
                $elm$html$Html$text('Sync to Elation Anyway')
            ])) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$WebLinkClicked = function(a) {
        return {
            $: 31,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ExecuteActionForIntegrationRecord = F2(function(a, b) {
        return {
            $: 24,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$IntegrationRecord$Meta$actions = function(_v0) {
        var record = _v0;
        return record.tM;
    };
    var $author$project$Api$Provider$IntegrationRecord$Shared$meta = function(_v0) {
        var record = _v0;
        return record.Ue;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$meta = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$IntegrationRecord$Shared$meta(shared);
    };
    var $author$project$Api$Provider$IntegrationRecord$All$meta = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$meta(one);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecordActions = F2(function(maybeMenu, record) {
        if (maybeMenu.$ === 1) return $author$project$Utils$Html$empty;
        else {
            var menuModel = maybeMenu.a;
            var actions = A2($elm$core$List$filterMap, function(action) {
                return action.abS ? $elm$core$Maybe$Just(A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect(A2($author$project$Pages$Patients$PatientId_String$Top$ExecuteActionForIntegrationRecord, action.zr, record))
                ]), $elm$html$Html$text(action.NQ))) : $elm$core$Maybe$Nothing;
            }, $author$project$Api$Provider$IntegrationRecord$Meta$actions($author$project$Api$Provider$IntegrationRecord$All$meta(record)));
            return A4($author$project$Ui$Dropdown$view, _List_fromArray([
                $author$project$Ui$Dropdown$buttonSm
            ]), _List_fromArray([
                $elm$html$Html$text('Actions')
            ]), actions, menuModel);
        }
    });
    var $author$project$Api$Provider$IntegrationRecord$Shared$webLink = function(_v0) {
        var record = _v0;
        return record.abh;
    };
    var $author$project$Api$Provider$IntegrationRecord$One$webLink = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$IntegrationRecord$Shared$webLink(shared);
    };
    var $author$project$Api$Provider$IntegrationRecord$All$webLink = function(_v0) {
        var one = _v0;
        return $author$project$Api$Provider$IntegrationRecord$One$webLink(one);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecord = F4(function(pat, timeFormatter, maybeMenu, record) {
        var integrationName = $author$project$Api$Provider$Integration$SharedWithInlinePartner$name($author$project$Api$Provider$IntegrationRecord$All$integration(record));
        if (!$author$project$Api$Provider$Patient$One$syncToEmr(pat) && integrationName === 'Elation') return $author$project$Utils$Html$empty;
        else {
            var webLink = function() {
                var _v3 = $author$project$Api$Provider$IntegrationRecord$All$webLink(record);
                if (!_v3.$) {
                    var link = _v3.a;
                    return A2($elm$html$Html$p, _List_fromArray([
                        $elm$html$Html$Attributes$class('form-control-static')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'View in ' + integrationName
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$WebLinkClicked(link)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$launch)
                        ]), _List_fromArray([
                            $elm$html$Html$text(' View in ' + integrationName)
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }();
            var unsyncedReason = function() {
                var _v2 = $author$project$Api$Provider$IntegrationRecord$All$unsyncedReason(record);
                if (!_v2.$) {
                    var reason = _v2.a;
                    return A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('ml-1')
                    ]), _List_fromArray([
                        $elm$html$Html$text(reason)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }();
            var lastSyncedAt = function() {
                var _v1 = $author$project$Api$Provider$IntegrationRecord$All$integrationLastSyncedAt(record);
                if (!_v1.$) {
                    var time = _v1.a;
                    return A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('ml-1')
                    ]), _List_fromArray([
                        $elm$html$Html$text('on ' + A2(timeFormatter, 0, time))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }();
            var errorMessage = function() {
                var _v0 = $author$project$Api$Provider$IntegrationRecord$All$errorMessage(record);
                if (!_v0.$) {
                    var message = _v0.a;
                    return A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('ml-1')
                    ]), _List_fromArray([
                        $elm$html$Html$text(message)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }();
            var additionalInfo = A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('form-control-static'),
                $elm$html$Html$Attributes$class('text-muted'),
                $elm$html$Html$Attributes$class('text-body-sm')
            ]), _List_fromArray([
                unsyncedReason,
                errorMessage,
                lastSyncedAt
            ]));
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(integrationName),
                $author$project$Ui$Form$Group$labelSpan(3),
                $author$project$Ui$Form$Group$inputSpan(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$IntegrationRecord$Status$toString($author$project$Api$Provider$IntegrationRecord$All$integrationSyncStatus(record))),
                            additionalInfo,
                            webLink
                        ])),
                        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecordActions, maybeMenu, record)
                        ]))
                    ]))
                ]))
            ]));
        }
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationsSection = function(_v0) {
        var practice = _v0.W1;
        var patient = _v0.V7;
        var timeFormatter = _v0.HO;
        var integrationRecordDropdowns = _v0.fR;
        var integrationRecords = _v0.Rr;
        var integrationConflictsVisible = _v0.q$;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Panel$titleSm(_List_fromArray([
                A3($author$project$Ui$Skeleton$ifLoading, integrationRecords, $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Integrations')
                ])), $elm$html$Html$text('Integrations'))
            ])),
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal
            ]), _List_fromArray([
                function() {
                    if (integrationRecords.$ === 3) {
                        var integrationRecords_ = integrationRecords.a;
                        var externalRecords_ = $author$project$Api$Provider$Patient$One$integrations(patient);
                        return $elm$core$List$isEmpty(externalRecords_) && $elm$core$List$isEmpty(integrationRecords_) ? A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('No integrations are active. View integrations '),
                            A3($author$project$Ui$Link$route, $author$project$Utils$Route$integrationsRoute(practice), _List_Nil, _List_fromArray([
                                $elm$html$Html$text('here.')
                            ]))
                        ])) : A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$append, A2($elm$core$List$indexedMap, function(idx) {
                            return A2($author$project$Pages$Patients$PatientId_String$Top$viewExternalRecord, idx, A2($elm_community$list_extra$List$Extra$getAt, idx, integrationConflictsVisible));
                        }, externalRecords_), A2($elm$core$List$indexedMap, function(idx) {
                            return A3($author$project$Pages$Patients$PatientId_String$Top$viewIntegrationRecord, patient, timeFormatter, A2($elm_community$list_extra$List$Extra$getAt, idx, integrationRecordDropdowns));
                        }, integrationRecords_)));
                    } else return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSkeleton('Integration name'),
                        $author$project$Ui$Form$Group$labelSpan(3),
                        $author$project$Ui$Form$Group$inputSpan(9)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$span(3)
                            ]))
                        ]))
                    ]));
                }()
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewJoinDate = function(patient) {
        var _v0 = $author$project$Api$Provider$Patient$One$joinedPracticeDate(patient);
        if (!_v0.$) {
            var date = _v0.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Joined Practice'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewLeadSource = function(patient) {
        var content = function() {
            var _v0 = $author$project$Api$Provider$Patient$One$leadSource(patient);
            if (!_v0.$) {
                var leadSource = _v0.a;
                var leadSourceName = $author$project$Api$Provider$LeadSource$Shared$name(leadSource);
                var leadSourceStr = leadSourceName === 'Other' ? A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$One$leadSourceOther(patient)) : leadSourceName;
                return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(leadSourceStr)
                ]));
            } else return A2($author$project$Ui$Form$Static$view, _List_fromArray([
                $author$project$Ui$Form$Static$noValue
            ]), _List_Nil);
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Lead Source'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            content
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewLocation = F2(function(practice, patient) {
        var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        var maybeLocation = $author$project$Api$Provider$Patient$One$location(patient);
        var _v0 = _Utils_Tuple2(trackPatientsByLocation, maybeLocation);
        if (_v0.a && !_v0.b.$) {
            var location1 = _v0.b.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Location'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Location$Shared$name(location1))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$PatientEmail$All$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Components$Patient$ManagePortalAccessModal$PortalStatusToggled = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$patientInfo = F2(function(isCurrentPatient, patientEmail) {
        var thisPatientText = isCurrentPatient ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text(' (this patient)')
        ])) : $author$project$Utils$Html$empty;
        var patient = $author$project$Api$Provider$PatientEmail$All$patient(patientEmail);
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                V8: $author$project$Api$Provider$Patient$Min$id(patient)
            }), _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(patient))
            ])),
            thisPatientText
        ]));
    });
    var $author$project$Ui$ToggleSwitch$Sm = {
        $: 3
    };
    var $author$project$Ui$ToggleSwitch$sm = $author$project$Ui$ToggleSwitch$Sm;
    var $author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail = F3(function(patientEmailsEnabled, isCurrentPatient, patientEmail) {
        var isPortalEnabled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Tuple$second, A2($elm_community$list_extra$List$Extra$find, function(pe) {
            return _Utils_eq(pe.a, $author$project$Api$Provider$PatientEmail$All$id(patientEmail));
        }, patientEmailsEnabled)));
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(5)
                ]), _List_fromArray([
                    A2($author$project$Components$Patient$ManagePortalAccessModal$patientInfo, isCurrentPatient, patientEmail)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(1),
                    $author$project$Ui$Grid$offset(6)
                ]), _List_fromArray([
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$sm,
                        $author$project$Ui$ToggleSwitch$on(isPortalEnabled),
                        $author$project$Ui$ToggleSwitch$onChange($author$project$Components$Patient$ManagePortalAccessModal$PortalStatusToggled(patientEmail))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmails = F3(function(patientEmailsEnabled, data, currentPatientId) {
        switch(data.$){
            case 3:
                var patientEmails = data.a;
                var _v1 = A2($elm$core$List$partition, function(patientEmail) {
                    return _Utils_eq($author$project$Api$Provider$Patient$Min$id($author$project$Api$Provider$PatientEmail$All$patient(patientEmail)), currentPatientId);
                }, patientEmails);
                var thesePatients = _v1.a;
                var otherPatientEmails = _v1.b;
                return _Utils_ap(A2($elm$core$List$map, A2($author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail, patientEmailsEnabled, true), thesePatients), A2($elm$core$List$map, A2($author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmail, patientEmailsEnabled, false), otherPatientEmails));
            case 1:
                return _List_fromArray([
                    $elm$html$Html$text('Loading...')
                ]);
            default:
                return _List_fromArray([
                    $author$project$Utils$Html$empty
                ]);
        }
    });
    var $author$project$Components$Patient$ManagePortalAccessModal$view = function(_v0) {
        var model = _v0;
        if (model.Vw) {
            var body = A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Portal access for members using this patient\'s email address:')
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, A3($author$project$Components$Patient$ManagePortalAccessModal$viewPatientEmails, model.no, model.AA, $author$project$Api$Provider$Patient$One$id(model.V7)))
            ]));
            return A3($author$project$Ui$Modal$view, $author$project$Components$Patient$ManagePortalAccessModal$Closed, _List_fromArray([
                $author$project$Ui$Modal$size(1)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Manage Portal Access')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    body
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewManagePortalAccessModal = function(model) {
        var _v0 = model.i7;
        if (!_v0.$) {
            var modal = _v0.a;
            return A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalMsg, $author$project$Components$Patient$ManagePortalAccessModal$view(modal));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewCoveragePlanName = function(membership) {
        return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$name, A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan($author$project$Api$Provider$Membership$One$plan(membership))))));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageRules = F2(function(model, membership) {
        var _v0 = model.Mn;
        if (!_v0.$) {
            var modelCoveragePlanRules = _v0.a;
            return _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9),
                    $author$project$Ui$Form$Group$clearfix,
                    $author$project$Ui$Form$Group$label('Coverage Plan')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$bold
                            ]), _List_fromArray([
                                $author$project$Pages$Patients$PatientId_String$Top$viewCoveragePlanName(membership)
                            ]))
                        ]))
                    ])),
                    function() {
                        var coverageDocuments = A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$coverageDocuments, A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Plan$SharedWithContractInfo$coveragePlan($author$project$Api$Provider$Membership$One$plan(membership))));
                        return A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoverageDocuments$Form$viewAsList, coverageDocuments));
                    }()
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9),
                    $author$project$Ui$Form$Group$label('')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$CoveragePlanMsg, $author$project$Components$Admin$CoveragePlans$Rules$view(modelCoveragePlanRules))
                    ]))
                ]))
            ]);
        } else return _List_Nil;
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor = function(syncDetails) {
        if (!syncDetails.$) {
            var details = syncDetails.a;
            var companyName = A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$companyName(details));
            if (!companyName.$) {
                var name = companyName.a;
                return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Coverage Sponsor'),
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$bold
                        ]), _List_fromArray([
                            $elm$html$Html$text(name)
                        ]))
                    ]))
                ]));
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewCoverageType = function(syncDetails) {
        if (!syncDetails.$) {
            var details = syncDetails.a;
            var coverageType = $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$coverageType(details))));
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Coverage Type'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        coverageType
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Alert$HardNotification = {
        $: 3
    };
    var $author$project$Ui$Alert$hardNotification = $author$project$Ui$Alert$HardNotification;
    var $author$project$Ui$Alert$m0 = $author$project$Ui$Alert$Margin(25);
    var $author$project$Pages$Patients$PatientId_String$Top$viewInformationalAlert = F3(function(networkCoveragePlan, coveragePlan, coverageRuleUsages) {
        var _v0 = _Utils_Tuple3(networkCoveragePlan, coveragePlan, coverageRuleUsages);
        if (!_v0.a.$ && _v0.b.$ === 1 && _v0.c.$ === 3) {
            var _v1 = _v0.b;
            var _v2 = _v0.c;
            return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$double
                ])),
                A2($author$project$Ui$Alert$warning, _List_fromArray([
                    $author$project$Ui$Alert$hardNotification,
                    $author$project$Ui$Alert$m0
                ]), _List_fromArray([
                    $author$project$Ui$Icon$alert(_List_Nil),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text('These rules are for informational purposes and will not be applied to charges. Please contact your affiliated network with any questions.')
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewMemberType = function(syncDetails) {
        if (!syncDetails.$) {
            var details = syncDetails.a;
            var memberType = $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$memberType(details))));
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Member Type'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        memberType
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Ui$Element$Bold = 3;
    var $author$project$Ui$Element$fontBold = $author$project$Ui$Element$Text(3);
    var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipName = function(membership) {
        return $elm$html$Html$text($author$project$Api$Provider$Plan$SharedWithContractInfo$name($author$project$Api$Provider$Membership$One$plan(membership)));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan = function(membership) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Membership Plan')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$fontBold
                ]), _List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$Top$viewMembershipName(membership)
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$periodName = function(periodInMonths) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Period$rateName, $author$project$Api$Period$retrieveByNumberOfMonths(periodInMonths)));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate = function(membership) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9),
            $author$project$Ui$Form$Group$label('Rate')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Membership$One$periodRateInCents(membership)) + (' ' + $author$project$Pages$Patients$PatientId_String$Top$periodName($author$project$Api$Provider$Membership$One$periodInMonths(membership))))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageDocuments = function(coverageDouments) {
        if (!coverageDouments.$) {
            var coverageDocuments_ = coverageDouments.a;
            return A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$margin(2)
            ]), _List_fromArray([
                $author$project$Components$Admin$CoverageDocuments$Form$viewAsList(coverageDocuments_)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageRules = F2(function(model, syncDetails) {
        var _v0 = _Utils_Tuple3(model.UL, model.Mn, model.Mp);
        if (!_v0.a.$ && _v0.b.$ === 1 && _v0.c.$ === 3) {
            var networkRules = _v0.a.a;
            var _v1 = _v0.b;
            var _v2 = _v0.c;
            var coveragePlan = A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$coveragePlan, $author$project$Api$Expandable$withDefault($elm$core$Maybe$Nothing)), syncDetails);
            var coverageDocuments = A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$coverageDocuments, coveragePlan);
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$label('Network Coverage Plan')
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageDocuments(coverageDocuments),
                    A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$NetworkCoveragePlanMsg, $author$project$Components$Admin$CoveragePlans$Rules$view(networkRules))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipDetailsModal = function(model) {
        return model.m5 ? A3($author$project$Ui$Modal$view, $author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Memberships Details')
            ])),
            $author$project$Ui$Modal$body(function() {
                var _v0 = _Utils_Tuple2(model.jc, model.Mp);
                _v0$3: while(true)switch(_v0.a.$){
                    case 3:
                        switch(_v0.b.$){
                            case 3:
                                var _v1 = _v0.a;
                                var membership = _v1.a;
                                var _v2 = _v0.b;
                                var affiliateSyncDetails = function() {
                                    var _v3 = model.ve;
                                    if (_v3.$ === 3) {
                                        var details = _v3.a;
                                        return details;
                                    } else return $elm$core$Maybe$Nothing;
                                }();
                                return A2($elm$core$List$cons, $author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan(membership), A2($elm$core$List$cons, $author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate(membership), A2($elm$core$List$cons, A3($author$project$Pages$Patients$PatientId_String$Top$viewInformationalAlert, model.UL, model.Mn, model.Mp), A2($elm$core$List$cons, $author$project$Pages$Patients$PatientId_String$Top$viewCoverageType(affiliateSyncDetails), A2($elm$core$List$cons, $author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor(affiliateSyncDetails), A2($elm$core$List$cons, $author$project$Pages$Patients$PatientId_String$Top$viewMemberType(affiliateSyncDetails), A2($elm$core$List$cons, A2($author$project$Pages$Patients$PatientId_String$Top$viewNetworkCoverageRules, model, affiliateSyncDetails), A2($author$project$Pages$Patients$PatientId_String$Top$viewCoverageRules, model, membership))))))));
                            case 0:
                                var _v4 = _v0.a;
                                var membership = _v4.a;
                                var _v5 = _v0.b;
                                var affiliateSyncDetails = function() {
                                    var _v6 = model.ve;
                                    if (_v6.$ === 3) {
                                        var details = _v6.a;
                                        return details;
                                    } else return $elm$core$Maybe$Nothing;
                                }();
                                return _List_fromArray([
                                    $author$project$Pages$Patients$PatientId_String$Top$viewMembershipPlan(membership),
                                    $author$project$Pages$Patients$PatientId_String$Top$viewMembershipRate(membership),
                                    $author$project$Pages$Patients$PatientId_String$Top$viewCoverageType(affiliateSyncDetails),
                                    $author$project$Pages$Patients$PatientId_String$Top$viewCoverageSponsor(affiliateSyncDetails),
                                    $author$project$Pages$Patients$PatientId_String$Top$viewMemberType(affiliateSyncDetails)
                                ]);
                            default:
                                break _v0$3;
                        }
                    case 1:
                        var _v7 = _v0.a;
                        return A2($elm$core$List$repeat, 3, A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpanSm(3),
                            $author$project$Ui$Form$Group$inputSpanSm(9),
                            $author$project$Ui$Form$Group$labelSkeleton('Detail')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $author$project$Ui$Skeleton$text(_List_fromArray([
                                    $author$project$Ui$Skeleton$span(4)
                                ]))
                            ]))
                        ])));
                    default:
                        break _v0$3;
                }
                return _List_Nil;
            }()),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalClosed)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Close')
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$MembershipPatient$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$status(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$NewMembershipButtonClicked = {
        $: 17
    };
    var $author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalShown = F2(function(a, b) {
        return {
            $: 40,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$effectiveEndDate(shared);
    };
    var $justinmimbs$date$Date$min = F2(function(dateA, dateB) {
        var a = dateA;
        var b = dateB;
        return _Utils_cmp(a, b) < 0 ? dateA : dateB;
    });
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextBillDate = function(_v0) {
        var record = _v0.b;
        return record.UY;
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextInvoiceDueDate = function(_v0) {
        var record = _v0.b;
        return record.U0;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships = F2(function(currentDate, membershipPatient) {
        var nextInvoiceDueDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextInvoiceDueDate(membershipPatient);
        var nextBillDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$nextBillDate(membershipPatient);
        var effectiveEndDate = $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate(membershipPatient);
        return _Utils_ap(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(date) {
            return ' until ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
        }, effectiveEndDate)), _Utils_ap(function() {
            if (!nextInvoiceDueDate.$) {
                var date = nextInvoiceDueDate.a;
                return _Utils_ap(_Utils_eq(A2($justinmimbs$date$Date$min, date, currentDate), date) ? ' past due invoices starting ' : ' next invoice due ', A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date));
            } else return '';
        }(), function() {
            var _v1 = _Utils_Tuple2(nextBillDate, nextInvoiceDueDate);
            if (!_v1.a.$ && _v1.b.$ === 1) {
                var date = _v1.a.a;
                var _v2 = _v1.b;
                return ' next due ' + A2($justinmimbs$date$Date$format, 'MMMM d, yyyy', date);
            } else return '';
        }()));
    });
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$id = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$id(shared);
    };
    var $author$project$Api$Provider$MembershipPatient$Shared$membership = function(_v0) {
        var record = _v0;
        return record.jc;
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$membership = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$membership(shared);
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner = function(_v0) {
        var record = _v0.b;
        return record.VM;
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$plan = function(_v0) {
        var record = _v0.b;
        return record.GW;
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$startDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$MembershipPatient$Shared$startDate(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipActions = F3(function(session, patient, membershipPatient) {
        var patientId = $author$project$Api$Provider$Patient$One$id(patient);
        var membershipId = $author$project$Api$Provider$Membership$Min$id($author$project$Api$Provider$MembershipPatient$ForPatientOne$membership(membershipPatient));
        var disabled = $author$project$Api$Provider$Patient$One$archived(patient);
        var actionText = $author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient) === 'ended' || $author$project$Api$Provider$Patient$One$isSynced(patient) ? 'See Membership' : $author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient) !== 'ended' ? 'Edit Membership' : '';
        var body = A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top({
            y0: membershipId,
            V8: patientId
        }), _List_fromArray([
            $author$project$Ui$Link$disabled(disabled)
        ]), _List_fromArray([
            $elm$html$Html$text(actionText)
        ]));
        return A2($author$project$Permission$hideIfReadOnly, session, body);
    });
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored = function(_v0) {
        var record = _v0.b;
        return record.Sr;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewPayerInfo = F2(function(patient, membershipPatient) {
        var _v0 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner(membershipPatient);
        if (!_v0.$) {
            var owner = _v0.a;
            var patientId = $author$project$Api$Provider$Patient$One$id(patient);
            var ownerId = $author$project$Api$Provider$Patient$Min$id(owner);
            if (!_Utils_eq(patientId, ownerId)) {
                var _v1 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored(membershipPatient);
                if (!_v1.$) {
                    var isSponsored = _v1.a;
                    var ownerName = $author$project$Api$Provider$Patient$Min$name(owner);
                    var link = A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                        V8: ownerId
                    }), _List_fromArray([
                        $author$project$Ui$Link$disabled($author$project$Api$Provider$Patient$One$archived(patient))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(ownerName)
                        ]))
                    ]));
                    return isSponsored ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Dependent of '),
                        link
                    ])) : A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Paid by '),
                        link
                    ]));
                } else return $author$project$Utils$Html$empty;
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$MembershipPatient$ForPatientOne$company = function(_v0) {
        var record = _v0.b;
        return record.acy;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewSponsorInfo = F2(function(patient, membershipPatient) {
        var maybeCompany = $author$project$Api$Provider$MembershipPatient$ForPatientOne$company(membershipPatient);
        var _v0 = _Utils_Tuple2($author$project$Api$Provider$MembershipPatient$ForPatientOne$isSponsored(membershipPatient), maybeCompany);
        if (!_v0.a.$ && !_v0.b.$) {
            var company = _v0.b.a;
            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $author$project$Api$Provider$Patient$One$isSynced(patient) ? $elm$html$Html$text('Network: ') : $elm$html$Html$text('Employer: '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                    fl: $author$project$Api$Provider$Company$Min$id(company)
                }), _List_fromArray([
                    $author$project$Ui$Link$disabled($author$project$Api$Provider$Patient$One$archived(patient))
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Company$Min$name(company))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient = F5(function(session, patient, currentDate, affiliateSyncDetails, membershipPatient) {
        var status = $author$project$Api$Provider$MembershipPatient$ForPatientOne$status(membershipPatient);
        var showSponsorInfo = $author$project$Api$Provider$Patient$One$isSynced(patient) && (status === 'active' || status === 'unpaid');
        var description = function() {
            switch(status){
                case 'pending':
                    return ' begins ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', $author$project$Api$Provider$MembershipPatient$ForPatientOne$startDate(membershipPatient));
                case 'unconfirmed':
                    return ' awaiting confirmation';
                case 'active':
                    return A2($author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships, currentDate, membershipPatient);
                case 'unpaid':
                    return A2($author$project$Pages$Patients$PatientId_String$Top$descriptionForActiveOrUnpaidMemberships, currentDate, membershipPatient);
                case 'ended':
                    var _v5 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$effectiveEndDate(membershipPatient);
                    if (!_v5.$) {
                        var date = _v5.a;
                        return ' ended on ' + A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', date);
                    } else return '';
                default:
                    return '';
            }
        }();
        var button = A3($author$project$Ui$Button$view, {
            abP: 'See membership details'
        }, _List_fromArray([
            $author$project$Ui$Button$margin(20),
            $author$project$Ui$Button$margin(3),
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$styled(0),
            $author$project$Ui$Button$onClick(A2($author$project$Pages$Patients$PatientId_String$Top$MembershipDetailsModalShown, $author$project$Api$Provider$Membership$Min$id($author$project$Api$Provider$MembershipPatient$ForPatientOne$membership(membershipPatient)), $author$project$Api$Provider$MembershipPatient$ForPatientOne$id(membershipPatient)))
        ]), _List_fromArray([
            $elm$html$Html$text('See Membership Details')
        ]));
        var badge = function() {
            var _v3 = $author$project$Api$Provider$MembershipPatient$ForPatientOne$owner(membershipPatient);
            if (!_v3.$) {
                var owner = _v3.a;
                return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top({
                    V8: $author$project$Api$Provider$Patient$Min$id(owner)
                }), _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_fromArray([
                        $author$project$Ui$Badge$test('membership-status')
                    ]), status)
                ]));
            } else return A2($author$project$Ui$Badge$fromString, _List_Nil, status);
        }();
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        badge,
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$Plan$Min$name($author$project$Api$Provider$MembershipPatient$ForPatientOne$plan(membershipPatient)))
                        ])),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text(description)
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A3($author$project$Pages$Patients$PatientId_String$Top$viewMembershipActions, session, patient, membershipPatient)
                    ]))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Pages$Patients$PatientId_String$Top$viewPayerInfo, patient, membershipPatient)
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Pages$Patients$PatientId_String$Top$viewSponsorInfo, patient, membershipPatient)
                ])),
                function() {
                    if (showSponsorInfo) {
                        var syncDetails = function() {
                            if (affiliateSyncDetails.$ === 3) {
                                var details = affiliateSyncDetails.a;
                                return details;
                            } else return $elm$core$Maybe$Nothing;
                        }();
                        var companyName = function() {
                            if (!syncDetails.$) {
                                var details_ = syncDetails.a;
                                return A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Patient$SyncDetail$companyName(details_));
                            } else return $elm$core$Maybe$Nothing;
                        }();
                        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                            function() {
                                if (!companyName.$) {
                                    var name = companyName.a;
                                    return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Employer: ' + name)
                                    ]));
                                } else return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Retail ')
                                ]));
                            }()
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                button
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewCurrentMemberships = F5(function(session, currentDate, patient, syncDetails, membershipPatients) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Current and Pending'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), function() {
            if ($author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive') return _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_fromArray([
                        $author$project$Ui$Badge$test('membership-status')
                    ]), 'inactive'),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$pull(1)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'New membership'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$NewMembershipButtonClicked)
                        ]), _List_fromArray([
                            $elm$html$Html$text('New Membership')
                        ]))
                    ]))
                ]))
            ]);
            else {
                if ($elm$core$List$isEmpty(membershipPatients)) return _List_fromArray([
                    $author$project$Utils$Html$empty
                ]);
                else {
                    var firstFiveMembershipPatients = A2($elm$core$List$take, 5, membershipPatients);
                    return _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A4($author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient, session, patient, currentDate, syncDetails), firstFiveMembershipPatients)),
                            $elm$core$List$length(membershipPatients) > 5 ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top({
                                V8: $author$project$Api$Provider$Patient$One$id(patient)
                            }), _List_Nil, _List_fromArray([
                                $elm$html$Html$text('See all memberships')
                            ])) : $author$project$Utils$Html$empty
                        ]))
                    ]);
                }
            }
        }());
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewPastMemberships = F5(function(session, currentDate, patient, syncDetails, membershipPatients) {
        var firstFiveMembershipPatients = A2($elm$core$List$take, 5, membershipPatients);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Past'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A4($author$project$Pages$Patients$PatientId_String$Top$viewMembershipPatient, session, patient, currentDate, syncDetails), firstFiveMembershipPatients)),
                $elm$core$List$length(membershipPatients) > 5 ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top({
                    V8: $author$project$Api$Provider$Patient$One$id(patient)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text('See all memberships')
                ])) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewMembershipSection = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Panel$titleSm(_List_fromArray([
                A3($author$project$Ui$Skeleton$ifLoading, model.T$, $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Memberships')
                ])), $elm$html$Html$text('Memberships'))
            ])),
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal
            ]), function() {
                var _v0 = model.T$;
                if (_v0.$ === 3) {
                    var membershipPatients = _v0.a;
                    var _v1 = A2($elm$core$List$partition, function(item) {
                        return $author$project$Api$Provider$MembershipPatient$ForPatientOne$status(item) === 'ended';
                    }, membershipPatients);
                    var endedMembershipPatients = _v1.a;
                    var currentMembershipPatients = _v1.b;
                    return _List_fromArray([
                        $author$project$Api$Provider$Patient$One$membershipStatus(model.V7) === 'inactive' || !$elm$core$List$isEmpty(currentMembershipPatients) ? A5($author$project$Pages$Patients$PatientId_String$Top$viewCurrentMemberships, model.Z$, model.cP, model.V7, model.ve, currentMembershipPatients) : $author$project$Utils$Html$empty,
                        $elm$core$List$isEmpty(endedMembershipPatients) ? $author$project$Utils$Html$empty : A5($author$project$Pages$Patients$PatientId_String$Top$viewPastMemberships, model.Z$, model.cP, model.V7, model.ve, endedMembershipPatients)
                    ]);
                } else return _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSkeleton('Membership'),
                        $author$project$Ui$Form$Group$labelSpanSm(3),
                        $author$project$Ui$Form$Group$inputSpanSm(9)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$span(10),
                                $author$project$Ui$Skeleton$block
                            ])),
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$span(2),
                                $author$project$Ui$Skeleton$block
                            ]))
                        ]))
                    ]))
                ]);
            }())
        ]));
    };
    var $author$project$Api$Provider$Patient$One$mergedInto = function(_v0) {
        var record = _v0.b;
        return record.Ud;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewMergedInto = function(patient) {
        var _v0 = $author$project$Api$Provider$Patient$One$mergedInto(patient);
        if (!_v0.$) {
            var merged = _v0.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Merged Into'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                            V8: $author$project$Api$Provider$Patient$Min$id(merged)
                        }), _List_Nil, _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(merged))
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$DetachPatientButtonClicked = {
        $: 35
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewNetworkLinkageAlert = function(patient) {
        return $author$project$Api$Provider$Patient$One$isSynced(patient) && $author$project$Api$Provider$Patient$One$membershipStatus(patient) === 'inactive' ? A2($author$project$Ui$Alert$info, _List_fromArray([
            $author$project$Ui$Alert$mb2
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1),
                    $author$project$Ui$Grid$span(2),
                    $author$project$Ui$Grid$textCenter
                ]), _List_fromArray([
                    $author$project$Ui$Icon$lock(_List_fromArray([
                        $author$project$Ui$Icon$lg
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(8),
                    $author$project$Ui$Grid$span(10)
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb2
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('This patient\'s record is still linked to the network.')
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Detach this patient from the network to manage their complete profile and memberships.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(3),
                    $author$project$Ui$Grid$justifyRight
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Detach the patient'
                    }, _List_fromArray([
                        $author$project$Ui$Button$styled(6),
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$DetachPatientButtonClicked)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Detach the patient')
                    ]))
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$PatientPackage$All$endedPackages = $elm$core$List$filter(function(_v0) {
        var record = _v0;
        return record.ahy === 1;
    });
    var $author$project$Pages$Patients$PatientId_String$Top$OpenPackageDetailsModal = function(a) {
        return {
            $: 71,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewPrepaidCharge = function(prepaidCharge) {
        var remainingQty = $author$project$Api$Provider$PatientPackage$All$remainingQuantity(prepaidCharge);
        var remainingText = '(' + ($elm$core$String$fromInt(remainingQty) + ' remaining)');
        var originalQty = $author$project$Api$Provider$PatientPackage$All$originalQuantity(prepaidCharge);
        var name = $author$project$Api$Provider$PatientPackage$All$chargeItemName(prepaidCharge);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt(originalQty) + (' ' + name))
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$bold
            ]), _List_fromArray([
                $elm$html$Html$text(' ' + remainingText)
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewPackage = function(_package) {
        var purchasedOn_ = A2($justinmimbs$date$Date$format, 'MM/dd/yyyy', $author$project$Api$Provider$PatientPackage$All$purchasedOn(_package));
        var prepaidCharges_ = $author$project$Api$Provider$PatientPackage$All$prepaidCharges(_package);
        var prepaidChargesView = A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPrepaidCharge, prepaidCharges_);
        var packageName_ = $author$project$Api$Provider$PatientPackage$All$packageName(_package);
        var packageDetailsButton = A3($author$project$Ui$Button$view, {
            abP: 'See package details'
        }, _List_fromArray([
            $author$project$Ui$Button$margin(20),
            $author$project$Ui$Button$margin(3),
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$styled(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$OpenPackageDetailsModal(_package))
        ]), _List_fromArray([
            $elm$html$Html$text('See Package Details')
        ]));
        var expiresAt_ = A2($elm$core$Maybe$map, $justinmimbs$date$Date$format('MM/dd/yyyy'), $author$project$Api$Provider$PatientPackage$All$expiresAt(_package));
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(packageName_),
                    A2($elm$html$Html$div, _List_Nil, prepaidChargesView),
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted,
                        $author$project$Ui$Typography$margin(20)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Purchased on ' + purchasedOn_)
                    ])),
                    function() {
                        if (!expiresAt_.$) {
                            var expiryDate = expiresAt_.a;
                            return A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted,
                                $author$project$Ui$Typography$margin(20)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Expires on ' + expiryDate)
                            ]));
                        } else return $elm$html$Html$text('');
                    }()
                ]))
            ])),
            packageDetailsButton
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewActivePackages = function(packages) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Active'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPackage, packages))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ToggleEndedPackages = {
        $: 70
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEndedPackages = F2(function(showingEnded, packages) {
        var icon = showingEnded ? $author$project$Ui$Icon$chevron(_List_fromArray([
            $author$project$Ui$Icon$rotate180
        ])) : $author$project$Ui$Icon$chevronDown(_List_Nil);
        var endedCount = $elm$core$List$length(packages);
        var buttonText = 'View Ended (' + ($elm$core$String$fromInt(endedCount) + ')');
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Ended'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: buttonText
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleEndedPackages)
                ]), _List_fromArray([
                    $elm$html$Html$text(buttonText),
                    $author$project$Utils$Html$noBreakSpace,
                    icon
                ])),
                showingEnded ? A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mt-2')
                ]), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPackage, packages)) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewNoActivePackages = A2($author$project$Ui$Form$Group$view, _List_fromArray([
        $author$project$Ui$Form$Group$label('Active'),
        $author$project$Ui$Form$Group$labelSpanSm(3),
        $author$project$Ui$Form$Group$inputSpanSm(9)
    ]), _List_fromArray([
        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$italic,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('None')
            ]))
        ]))
    ]));
    var $author$project$Pages$Patients$PatientId_String$Top$viewNoEndedPackages = A2($author$project$Ui$Form$Group$view, _List_fromArray([
        $author$project$Ui$Form$Group$label('Ended'),
        $author$project$Ui$Form$Group$labelSpanSm(3),
        $author$project$Ui$Form$Group$inputSpanSm(9)
    ]), _List_fromArray([
        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$italic,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('None')
            ]))
        ]))
    ]));
    var $author$project$Pages$Patients$PatientId_String$Top$viewPackagesSection = function(model) {
        var packagesEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, model.W1);
        return packagesEnabled ? A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Panel$titleSm(_List_fromArray([
                A3($author$project$Ui$Skeleton$ifLoading, model.Ah, $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('Packages')
                ])), $elm$html$Html$text('Packages'))
            ])),
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal
            ]), function() {
                var _v0 = model.Ah;
                if (_v0.$ === 3) {
                    var patientPackages = _v0.a;
                    var endedPackages_ = $author$project$Api$Provider$PatientPackage$All$endedPackages(patientPackages);
                    var activePackages_ = $author$project$Api$Provider$PatientPackage$All$activePackages(patientPackages);
                    return _List_fromArray([
                        !$elm$core$List$isEmpty(activePackages_) ? $author$project$Pages$Patients$PatientId_String$Top$viewActivePackages(activePackages_) : $author$project$Pages$Patients$PatientId_String$Top$viewNoActivePackages,
                        !$elm$core$List$isEmpty(endedPackages_) ? A2($author$project$Pages$Patients$PatientId_String$Top$viewEndedPackages, model.sY, endedPackages_) : $author$project$Pages$Patients$PatientId_String$Top$viewNoEndedPackages
                    ]);
                } else return _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSkeleton('Package'),
                        $author$project$Ui$Form$Group$labelSpanSm(3),
                        $author$project$Ui$Form$Group$inputSpanSm(9)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$span(10),
                                $author$project$Ui$Skeleton$block
                            ])),
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$span(2),
                                $author$project$Ui$Skeleton$block
                            ]))
                        ]))
                    ]))
                ]);
            }())
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewPhonesSection = function(patient) {
        var phones = $author$project$Api$Provider$Patient$One$phones(patient);
        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPhone, phones));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewPractitioner = function(patient) {
        var _v0 = $author$project$Api$Provider$Patient$One$practitioner(patient);
        if (!_v0.$) {
            var practitioner = _v0.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Practitioner'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Practitioner$Shared$name(practitioner))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewPreferredLanguage = F2(function(practice, patient) {
        var multiLanguage = A2($author$project$Api$Provider$Practice$One$featureEnabled, 10, practice);
        return multiLanguage ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Preferred Language'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Language$toLabel($author$project$Api$Provider$Patient$One$preferredLanguage(patient)))
            ]))
        ])) : $elm$html$Html$text('');
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewPrimaryCareClinic = F2(function(practice, patient) {
        var syncByAffiliation = A2($elm$core$Maybe$map, $author$project$Api$Provider$Network$Shared$syncByAffiliation, $author$project$Api$Provider$Practice$One$network(practice));
        var affiliationName = A2($elm$core$Maybe$withDefault, $elm$core$Maybe$Nothing, A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliate$AffiliateMin$name, $author$project$Api$Provider$Patient$One$assignedAffiliation(patient)));
        var _v0 = _Utils_Tuple2(affiliationName, syncByAffiliation);
        if (!_v0.a.$ && !_v0.b.$ && _v0.b.a) {
            var name = _v0.a.a;
            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Primary Care Clinic'),
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(name)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Ui$ProfilePicture$Alt = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$ProfilePicture$alt = $author$project$Ui$ProfilePicture$Alt;
    var $author$project$Ui$ProfilePicture$Size = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$ProfilePicture$size = $author$project$Ui$ProfilePicture$Size;
    var $author$project$Ui$ProfilePicture$defaultOptions = {
        vD: _List_Nil,
        qV: _List_Nil
    };
    var $author$project$Ui$ProfilePicture$pxSize = function(px) {
        return $elm$core$String$fromInt(px) + 'px';
    };
    var $author$project$Ui$ProfilePicture$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var px = option.a;
                    return _Utils_update(record, {
                        vD: $elm$core$List$concat(_List_fromArray([
                            _List_fromArray([
                                A2($elm$html$Html$Attributes$style, 'width', $author$project$Ui$ProfilePicture$pxSize(px)),
                                A2($elm$html$Html$Attributes$style, 'height', $author$project$Ui$ProfilePicture$pxSize(px))
                            ]),
                            record.vD
                        ]))
                    });
                case 1:
                    var string = option.a;
                    return _Utils_update(record, {
                        qV: A2($elm$core$List$cons, $elm$html$Html$Attributes$alt(string), record.qV)
                    });
                default:
                    var string = option.a;
                    return _Utils_update(record, {
                        vD: A2($elm$core$List$cons, $elm$html$Html$Attributes$class(string), record.vD)
                    });
            }
        }), $author$project$Ui$ProfilePicture$defaultOptions, options);
    };
    var $author$project$Ui$ProfilePicture$view = F2(function(options, profilePictureUrl) {
        var optionsRecord = $author$project$Ui$ProfilePicture$optionsToRecord(options);
        return A2($elm$html$Html$div, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('profile-picture'), optionsRecord.vD), _List_fromArray([
            A2($elm$html$Html$img, A2($elm$core$List$cons, $elm$html$Html$Attributes$src(profilePictureUrl), optionsRecord.qV), _List_Nil)
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewProfilePicture = function(_v0) {
        var patient = _v0.V7;
        var profilePictureUrl = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$One$profilePictureUrl(patient));
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Profile Picture'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            $elm$core$String$length(profilePictureUrl) > 0 ? A2($author$project$Ui$ProfilePicture$view, _List_fromArray([
                $author$project$Ui$ProfilePicture$alt($author$project$Api$Provider$Patient$One$name(patient)),
                $author$project$Ui$ProfilePicture$size(80)
            ]), profilePictureUrl) : A2($author$project$Ui$Form$Static$view, _List_fromArray([
                $author$project$Ui$Form$Static$noValue
            ]), _List_Nil)
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewRemoveEphiWaiverModal = function(model) {
        return model.nY ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Top$RemoveEphiWaiverModalClosed, _List_fromArray([
            $author$project$Components$HiConfirm$verb('Remove'),
            $author$project$Components$HiConfirm$noun('ePHI Waiver'),
            $author$project$Components$HiConfirm$titleizeNoun(false),
            $author$project$Components$HiConfirm$centerText(false),
            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                $elm$html$Html$text('You\'re about to remove ePHI waiver for this patient. You will no longer be able to send emails to this patient. You can re-authorize at any time.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewRemoveSponsorshipModal = function(model) {
        var _v0 = model.df;
        if (_v0.a && !_v0.b.$) {
            var employeeOrDependant = _v0.b.a;
            var _v1 = function() {
                switch(employeeOrDependant.$){
                    case 0:
                        var account = employeeOrDependant.a;
                        return _Utils_Tuple2(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$name, $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(account))), $author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
                    case 1:
                        var account = employeeOrDependant.a;
                        var registration = employeeOrDependant.b;
                        return _Utils_Tuple2($author$project$Api$Provider$Patient$Min$name($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)), $author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
                    default:
                        var account = employeeOrDependant.a;
                        var patient = employeeOrDependant.c;
                        return _Utils_Tuple2($author$project$Api$Provider$Patient$One$name(patient), $author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(account)));
                }
            }();
            var patientName = _v1.a;
            var companyName = _v1.b;
            var details = 'This will permanently remove ' + (patientName + (' from ' + (companyName + '. Are you sure?')));
            return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalClosed(employeeOrDependant), _List_fromArray([
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    $elm$html$Html$text(details)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$confirmRestorePatientMessage = function(patientName) {
        return _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Are you sure you want to restore ' + (patientName + '? This will allow you to restart their membership, payments, and emails.'))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewRestorePatientModal = function(model) {
        return model.jV ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$PatientId_String$Top$ConfirmRestorePatientModalClicked($author$project$Api$Provider$Patient$One$id(model.V7)), _List_fromArray([
            $author$project$Components$HiConfirm$verb('restore'),
            $author$project$Components$HiConfirm$noun('patient'),
            $author$project$Components$HiConfirm$customMessage($author$project$Pages$Patients$PatientId_String$Top$confirmRestorePatientMessage($author$project$Api$Provider$Patient$One$name(model.V7)))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$FetchPlainSSN = {
        $: 0
    };
    var $author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber = function(_v0) {
        var record = _v0;
        return record.TJ;
    };
    var $author$project$Api$Provider$Patient$One$ssn = function(_v0) {
        var record = _v0.b;
        return record.__;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewSSNSection = function(_v0) {
        var session = _v0.Z$;
        var practice = _v0.W1;
        var patient = _v0.V7;
        var plainSSN = _v0.A7;
        var hinterViewOff = _v0.aeb;
        if ($author$project$Api$Provider$Practice$One$ssnEnabled(practice)) {
            var maybeSSN = function() {
                if (plainSSN.$ === 3) {
                    var data = plainSSN.a;
                    return $author$project$Api$Provider$SocialSecurityNumber$One$formattedNumber(data);
                } else return A2($elm$core$Maybe$andThen, $author$project$Api$Common$SocialSecurityNumber$Masked$maskedNumber, $author$project$Api$Provider$Patient$One$ssn(patient));
            }();
            if (!maybeSSN.$) {
                var ssn = maybeSSN.a;
                return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('SSN'),
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text(ssn)
                            ])),
                            function() {
                                if (plainSSN.$ === 3) return $author$project$Utils$Html$empty;
                                else return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0) ? A3($author$project$Ui$Button$view, {
                                    abP: 'Show full number'
                                }, _List_fromArray([
                                    $author$project$Ui$Button$sm,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$FetchPlainSSN)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Show Full Number')
                                ])) : $author$project$Utils$Html$empty;
                            }()
                        ]))
                    ]))
                ]));
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$GenerateDebugPortalUrl = {
        $: 73
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalOpened = {
        $: 62
    };
    var $author$project$Pages$Patients$PatientId_String$Top$SendAccessLink = {
        $: 3
    };
    var $author$project$Api$Provider$EmailAddress$One$isPortalEnabled = function(_v0) {
        var record = _v0;
        return record.WW;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewSelfService = F8(function(sendingAccessLink, timeFormatter, accountAccessSentAt, lastPortalAccessedAt, dataEmailAddress, patient, isHintAdmin, hintEnv) {
        var patientArchived = $author$project$Api$Provider$Patient$One$archived(patient);
        var noEmail = _Utils_eq($author$project$Api$Provider$Patient$One$email(patient), $elm$core$Maybe$Nothing);
        var hasDisabledPortal = function() {
            if (dataEmailAddress.$ === 3 && !dataEmailAddress.a.$) {
                var emailAddress = dataEmailAddress.a.a;
                return !$author$project$Api$Provider$EmailAddress$One$isPortalEnabled(emailAddress);
            } else return false;
        }();
        var cannotRequestAccountAccess = patientArchived || noEmail;
        var accessLinkButton = A3($author$project$Ui$Button$view, {
            abP: 'Send access link to patient'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$SendAccessLink),
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$margin(7),
            $author$project$Ui$Button$disabled(cannotRequestAccountAccess || hasDisabledPortal),
            $author$project$Ui$Button$loading(sendingAccessLink),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
        ]), _List_fromArray([
            $elm$html$Html$text('Send an Access Link')
        ]));
        var links = function() {
            if (cannotRequestAccountAccess) {
                var tooltipMsg = patientArchived ? 'The patient is archived.' : noEmail ? 'The patient must have a valid email address to send the access link.' : '';
                return A3($author$project$Ui$Tooltip$view, _List_Nil, tooltipMsg, _List_fromArray([
                    accessLinkButton
                ]));
            } else {
                var managePortalAccessButton = A3($author$project$Ui$Button$view, {
                    abP: 'Manage portal access'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ManagePortalAccessModalOpened),
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$disabled(cannotRequestAccountAccess)
                ]), _List_fromArray([
                    $elm$html$Html$text('Manage Portal Access')
                ]));
                var lastSent = function() {
                    if (!accountAccessSentAt.$) {
                        var time = accountAccessSentAt.a;
                        return A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textMuted,
                            $author$project$Ui$Element$textSm,
                            $author$project$Ui$Element$mt2
                        ]), _List_fromArray([
                            $elm$html$Html$text('Last sent ' + (A2(timeFormatter, 1, time) + '.'))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }();
                var debugPortalUrlButton = isHintAdmin && !_Utils_eq(hintEnv, $elm$core$Maybe$Just(0)) ? A3($author$project$Ui$HinterOnly$button, {
                    abP: 'View as member'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$margin(7),
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$GenerateDebugPortalUrl)
                ]), _List_fromArray([
                    $elm$html$Html$text('View as Member')
                ])) : $author$project$Utils$Html$empty;
                var accessLink = hasDisabledPortal ? A3($author$project$Ui$Tooltip$view, _List_Nil, 'This patient\'s portal access is disabled. You can manage this access using the Manage Portal Access button above.', _List_fromArray([
                    accessLinkButton
                ])) : accessLinkButton;
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$flexCol,
                    $author$project$Ui$Element$itemsEnd
                ]), _List_fromArray([
                    managePortalAccessButton,
                    accessLink,
                    debugPortalUrlButton,
                    lastSent
                ]));
            }
        }();
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Patient Portal'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        if (!lastPortalAccessedAt.$) {
                            var time = lastPortalAccessedAt.a;
                            return $elm$html$Html$text('Last accessed ' + A2(timeFormatter, 1, time));
                        } else return $elm$html$Html$text('Never accessed');
                    }()
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    links
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalOpened = {
        $: 8
    };
    var $author$project$Pages$Patients$PatientId_String$Top$ToggleViewPastSponsorships = {
        $: 12
    };
    var $author$project$Api$Provider$Practice$One$hasActiveCompanies = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Qj;
    });
    var $author$project$Api$Provider$CompanyAccount$Shared$needsApproval = function(_v0) {
        var record = _v0.b;
        return record.UI;
    };
    var $author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$needsApproval(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$Dependent = F3(function(a, b, c) {
        return {
            $: 2,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$Employee = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyRegistration$ForPatientOne$account = function(_v0) {
        var record = _v0.b;
        return record.Ij;
    };
    var $author$project$Api$Provider$Patient$One$companyRegistrations = function(_v0) {
        var record = _v0.b;
        return record.LQ;
    };
    var $elm$html$Html$small = _VirtualDom_node('small');
    var $author$project$Pages$Patients$PatientId_String$Top$AddDependentModalOpened = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$CompanyAccount$Shared$terminationRequestedAt = function(_v0) {
        var record = _v0.b;
        return record.ahQ;
    };
    var $author$project$Api$Provider$CompanyAccount$ForPatient$terminationRequestedAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyAccount$Shared$terminationRequestedAt(shared);
    };
    var $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$type_ = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$CompanyRegistration$Shared$type_(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$DependentThrough = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewDependent = F5(function(session, account, removingSponsorship, index, registration) {
        var isBeingRemoved = function() {
            if (!removingSponsorship.a && !removingSponsorship.b.$ && removingSponsorship.b.a.$ === 1) {
                var _v2 = removingSponsorship.b.a;
                var reg = _v2.b;
                return _Utils_eq($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(reg), $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$id(registration)) ? A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Removing')
                ])) : $author$project$Ui$Grid$none;
            } else return $author$project$Ui$Grid$none;
        }();
        var canRemove = !$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(account);
        var removeLink = canRemove ? A3($author$project$Ui$Button$view, {
            abP: 'Delete dependent'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened(A2($author$project$Pages$Patients$PatientId_String$Top$DependentThrough, account, registration))),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
        ]), _List_Nil) : $author$project$Utils$Html$empty;
        var _v0 = index > 0 ? _Utils_Tuple2(_List_fromArray([
            $author$project$Ui$Grid$offset(2),
            $author$project$Ui$Grid$span(4)
        ]), $author$project$Ui$Grid$none) : _Utils_Tuple2(_List_fromArray([
            $author$project$Ui$Grid$span(4)
        ]), A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$span(2)
        ]), _List_fromArray([
            $elm$html$Html$text('Dependents: ')
        ])));
        var style = _v0.a;
        var dependentsTitle = _v0.b;
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            dependentsTitle,
            A2($author$project$Ui$Grid$column, style, _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                        V8: $author$project$Api$Provider$Patient$Min$id($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration))
                    }), _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name($author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$patient(registration)))
                        ]))
                    ])),
                    A2($author$project$Permission$hideIfReadOnly, session, removeLink)
                ]))
            ])),
            isBeingRemoved
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewDependents = F4(function(session, patient, companyAccount, removingSponsorship) {
        var dependents = A2($elm$core$List$filter, A2($elm$core$Basics$composeR, $author$project$Api$Provider$CompanyRegistration$ForCompanyAccountOnPatient$type_, $elm$core$Basics$neq('employee')), $author$project$Api$Provider$CompanyAccount$ForPatient$companyRegistrations(companyAccount));
        var canAddDependent = !$author$project$Utils$Maybe$toBool($author$project$Api$Provider$CompanyAccount$ForPatient$terminationRequestedAt(companyAccount)) && !$author$project$Api$Provider$Patient$One$isSynced(patient);
        var addDependentButton = canAddDependent ? A3($author$project$Ui$Button$view, {
            abP: 'Add dependent'
        }, _List_fromArray([
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$AddDependentModalOpened(companyAccount)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$add)
        ]), _List_fromArray([
            $elm$html$Html$text('Add Dependent')
        ])) : $author$project$Utils$Html$empty;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$core$List$length(dependents) > 0 ? A2($author$project$Ui$Form$Static$view, _List_Nil, A2($elm$core$List$indexedMap, A3($author$project$Pages$Patients$PatientId_String$Top$viewDependent, session, companyAccount, removingSponsorship), dependents)) : $author$project$Utils$Html$empty,
            addDependentButton
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount = F2(function(_v0, companyAccount) {
        var session = _v0.Z$;
        var patient = _v0.V7;
        var removingSponsorship = _v0.df;
        var patientIsEmployee = _Utils_eq($elm$core$Maybe$Just($author$project$Api$Provider$Patient$One$id(patient)), A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount)));
        var isBeingRemoved = function() {
            _v3$2: while(true){
                if (!removingSponsorship.a && !removingSponsorship.b.$) switch(removingSponsorship.b.a.$){
                    case 0:
                        var account = removingSponsorship.b.a.a;
                        return _Utils_eq($author$project$Api$Provider$CompanyAccount$ForPatient$id(account), $author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)) ? A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Removing')
                        ])) : $author$project$Utils$Html$empty;
                    case 2:
                        var _v4 = removingSponsorship.b.a;
                        var account = _v4.a;
                        return _Utils_eq($author$project$Api$Provider$CompanyAccount$ForPatient$id(account), $author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)) ? A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Removing')
                        ])) : $author$project$Utils$Html$empty;
                    default:
                        break _v3$2;
                }
                else break _v3$2;
            }
            return $author$project$Utils$Html$empty;
        }();
        var employeeOrDependentText = patientIsEmployee ? _List_fromArray([
            $elm$html$Html$text(' Employee ')
        ]) : _List_fromArray([
            $elm$html$Html$text(' Dependent through '),
            function() {
                var _v2 = $author$project$Api$Provider$CompanyAccount$ForPatient$subscriber(companyAccount);
                if (!_v2.$) {
                    var pat = _v2.a;
                    return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                        V8: $author$project$Api$Provider$Patient$Min$id(pat)
                    }), _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(pat))
                        ]))
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]);
        var employeeOrDependant = A2($author$project$Ui$Typography$span, _List_Nil, employeeOrDependentText);
        var canRemove = patientIsEmployee ? !($author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(companyAccount) || $author$project$Api$Provider$Patient$One$isSynced(patient)) : !$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(companyAccount);
        var removeLink = function() {
            if (canRemove) {
                if (patientIsEmployee) return A3($author$project$Ui$Button$view, {
                    abP: 'Remove sponsorship'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened($author$project$Pages$Patients$PatientId_String$Top$Employee(companyAccount))),
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                ]), _List_Nil);
                else {
                    var registrationForAccount = $elm$core$List$head(A2($elm$core$List$filter, function(reg) {
                        return _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Provider$CompanyAccount$Min$id, $author$project$Api$Provider$CompanyRegistration$ForPatientOne$account(reg)), $elm$core$Maybe$Just($author$project$Api$Provider$CompanyAccount$ForPatient$id(companyAccount)));
                    }, $author$project$Api$Provider$Patient$One$companyRegistrations(patient)));
                    if (!registrationForAccount.$) {
                        var registration = registrationForAccount.a;
                        return A3($author$project$Ui$Button$view, {
                            abP: 'Remove sponsorship'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$RemoveSponsorshipModalOpened(A3($author$project$Pages$Patients$PatientId_String$Top$Dependent, companyAccount, registration, patient))),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$delete)
                        ]), _List_Nil);
                    } else return $author$project$Utils$Html$empty;
                }
            } else return $author$project$Utils$Html$empty;
        }();
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Element$custom, 'inline-flex', _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                    $author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval(companyAccount) ? $elm$core$Maybe$Just(A2($author$project$Ui$Badge$view, _List_fromArray([
                        $author$project$Ui$Badge$warning,
                        $author$project$Ui$Badge$test('sponsorship-needs-approval')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Needs Approval')
                    ]))) : $elm$core$Maybe$Nothing,
                    $elm$core$Maybe$Just(A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                        fl: $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount))
                    }), _List_fromArray([
                        $author$project$Ui$Link$routeParams(_List_fromArray([
                            A2($elm$url$Url$Builder$string, 'q', $author$project$Api$Provider$Patient$One$name(patient))
                        ]))
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$CompanyAccount$ForPatient$company(companyAccount)))
                    ])))
                ]))),
                A2($elm$html$Html$small, _List_fromArray([
                    $elm$html$Html$Attributes$class('text-muted')
                ]), _List_fromArray([
                    employeeOrDependant,
                    A2($author$project$Permission$hideIfReadOnly, session, removeLink)
                ]))
            ])),
            isBeingRemoved,
            patientIsEmployee ? A4($author$project$Pages$Patients$PatientId_String$Top$viewDependents, session, patient, companyAccount, removingSponsorship) : $author$project$Utils$Html$empty
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewSponsorshipsSection = function(model) {
        if ($author$project$Api$Provider$Practice$One$hasActiveCompanies(model.W1)) {
            var pendingSponsorships = A2($elm$core$List$filter, $author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval, model.gX);
            var pastSponsorships = A2($elm$core$List$filter, function(account) {
                return !$author$project$Api$Provider$CompanyAccount$ForPatient$isEligible(account) && !$author$project$Api$Provider$CompanyAccount$ForPatient$needsApproval(account);
            }, model.gX);
            var eligibleSponsorships = A2($elm$core$List$filter, $author$project$Api$Provider$CompanyAccount$ForPatient$isEligible, model.gX);
            var anyPendingSponsorship = $elm$core$List$length(pendingSponsorships) > 0;
            var anyPastSponsorship = $elm$core$List$length(pastSponsorships) > 0;
            var anyEligibleSponsorship = $elm$core$List$length(eligibleSponsorships) > 0;
            var addSponsorshipLink = $author$project$Api$Provider$Patient$One$isSynced(model.V7) ? $author$project$Utils$Html$empty : A2($author$project$Permission$hideIfReadOnly, model.Z$, A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$pull(1)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Add sponsorship'
                }, _List_fromArray([
                    $author$project$Ui$Button$disabled($author$project$Api$Provider$Patient$One$archived(model.V7)),
                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$AddSponsorshipModalOpened),
                    $author$project$Ui$Button$sm
                ]), _List_fromArray([
                    $elm$html$Html$text('Add Sponsorship')
                ]))
            ])));
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                $author$project$Ui$Panel$titleSm(_List_fromArray([
                    $elm$html$Html$text('Sponsorships')
                ])),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Eligible Sponsorship'),
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9)
                ]), A2($elm$core$List$cons, addSponsorshipLink, anyEligibleSponsorship ? A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model), eligibleSponsorships) : _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_fromArray([
                        $author$project$Ui$Form$Static$noValue
                    ]), _List_Nil)
                ]))),
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Pending Sponsorship'),
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9)
                ]), A2($elm$core$List$cons, addSponsorshipLink, anyPendingSponsorship ? A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model), pendingSponsorships) : _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_fromArray([
                        $author$project$Ui$Form$Static$noValue
                    ]), _List_Nil)
                ]))),
                model.ou ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Past Sponsorship'),
                    $author$project$Ui$Form$Group$labelSpanSm(3),
                    $author$project$Ui$Form$Group$inputSpanSm(9)
                ]), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewCompanyAccount(model), pastSponsorships)) : $author$project$Utils$Html$empty,
                anyPastSponsorship ? A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$offsetSm(3),
                            $author$project$Ui$Grid$spanSm(9)
                        ]), _List_fromArray([
                            function() {
                                var _v0 = model.ou ? _Utils_Tuple2('Hide past sponsorships ', $author$project$Ui$Icon$chevron(_List_fromArray([
                                    $author$project$Ui$Icon$rotate180
                                ]))) : _Utils_Tuple2('See past sponsorships ', $author$project$Ui$Icon$chevronDown(_List_Nil));
                                var label = _v0.a;
                                var icon = _v0.b;
                                return A3($author$project$Ui$Button$view, {
                                    abP: label
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$ToggleViewPastSponsorships)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(label),
                                    icon
                                ]));
                            }()
                        ]))
                    ]))
                ])) : $author$project$Utils$Html$empty
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewTobaccoSection = F2(function(practice, patient) {
        var tobaccoEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 2, practice);
        return tobaccoEnabled ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label('Tobacco Use'),
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(9)
        ]), _List_fromArray([
            function() {
                var _v0 = $author$project$Api$Provider$Patient$One$usesTobacco(patient);
                if (!_v0.$) {
                    var usesTobaccoBool = _v0.a;
                    var usesTobaccoStr = usesTobaccoBool ? 'Uses tobacco' : 'Does not use tobacco';
                    return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(usesTobaccoStr)
                    ]));
                } else return A2($author$project$Ui$Form$Static$view, _List_fromArray([
                    $author$project$Ui$Form$Static$noValue
                ]), _List_Nil);
            }()
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Provider$Addon$Min$sendsExternalEmail = function(_v0) {
        var record = _v0;
        return record.ZU;
    };
    var $author$project$Api$Provider$PatientMceEligibility$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$PatientMceEligibility$All$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PatientMceEligibility$Shared$status(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$SendAddonEmail = function(a) {
        return {
            $: 54,
            a: a
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewEmailableAddon = F2(function(addonRequestsLoading, addon) {
        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Addon$Min$name(addon)),
            A3($author$project$Ui$Button$view, {
                abP: 'Send enrollment email'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$pull(1),
                $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$SendAddonEmail(addon)),
                $author$project$Ui$Button$loading(A2($elm$core$Set$member, $author$project$Api$Provider$Addon$Min$id(addon), addonRequestsLoading))
            ]), _List_fromArray([
                $elm$html$Html$text('Send Enrollment Email')
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$SendMceActivationEmail = function(a) {
        return {
            $: 56,
            a: a
        };
    };
    var $author$project$Api$Provider$PatientMceEligibility$Shared$message = function(_v0) {
        var record = _v0;
        return record.ae1;
    };
    var $author$project$Api$Provider$PatientMceEligibility$All$message = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PatientMceEligibility$Shared$message(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewMceSendActivationButton = F2(function(mceActivationsLoading, patientMceEligibility) {
        var message = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$PatientMceEligibility$All$message(patientMceEligibility));
        return $elm$core$String$isEmpty(message) ? A3($author$project$Ui$Button$view, {
            abP: ' Send enrollment email'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$PatientId_String$Top$SendMceActivationEmail(patientMceEligibility)),
            $author$project$Ui$Button$loading(A2($elm$core$Set$member, $author$project$Api$Provider$PatientMceEligibility$All$id(patientMceEligibility), mceActivationsLoading)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$send),
            $author$project$Ui$Button$sm
        ]), _List_fromArray([
            $elm$html$Html$text('Send Enrollment Email')
        ])) : A2($elm$html$Html$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text(message)
        ]));
    });
    var $author$project$Api$Provider$PatientMceEligibility$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$PatientMceEligibility$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$PatientMceEligibility$Shared$name(shared);
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility = function(patientMceEligibility) {
        var message = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$PatientMceEligibility$All$message(patientMceEligibility));
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$PatientMceEligibility$All$name(patientMceEligibility)),
            $author$project$Utils$Html$noBreakSpace,
            $author$project$Api$Provider$PatientMceEligibility$All$status(patientMceEligibility) === 'active' || !$elm$core$String$isEmpty(message) ? A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$PatientMceEligibility$All$status(patientMceEligibility)) : $author$project$Utils$Html$empty
        ]));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$viewInactivePatientMceEligibility = F2(function(mceActivationsLoading, patientMceEligibility) {
        return A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                $author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility(patientMceEligibility),
                A2($author$project$Pages$Patients$PatientId_String$Top$viewMceSendActivationButton, mceActivationsLoading, patientMceEligibility)
            ]))
        ]));
    });
    var $author$project$Pages$Patients$PatientId_String$Top$viewWrapArounds = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$cons, function() {
            var _v0 = model.m4;
            if (!_v0.$) return $author$project$Utils$Html$empty;
            else return $author$project$Ui$HorizontalRule$view(_List_Nil);
        }(), A2($elm$core$List$cons, $author$project$Ui$Panel$titleSm(_List_fromArray([
            A3($author$project$Ui$Skeleton$ifLoading, model.m4, $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Wrap-Arounds')
            ])), $elm$html$Html$text('Wrap-Arounds'))
        ])), function() {
            var _v1 = model.m4;
            switch(_v1.$){
                case 3:
                    var mcePractices = _v1.a;
                    var emailableAddons = A2($elm$core$List$filter, function(addon) {
                        return $author$project$Api$Provider$Addon$Min$sendsExternalEmail(addon);
                    }, $author$project$Api$Provider$Practice$One$addons(model.W1));
                    if ($elm$core$List$isEmpty(mcePractices) && $elm$core$List$isEmpty(emailableAddons)) return _List_Nil;
                    else {
                        var mceInactivePractices = A2($elm$core$List$filter, function(mcePractice) {
                            return $author$project$Api$Provider$PatientMceEligibility$All$status(mcePractice) === 'inactive';
                        }, mcePractices);
                        var mceActivePractices = A2($elm$core$List$filter, function(mcePractice) {
                            return $author$project$Api$Provider$PatientMceEligibility$All$status(mcePractice) === 'active';
                        }, mcePractices);
                        return _List_fromArray([
                            A2($author$project$Ui$Form$view, _List_fromArray([
                                $author$project$Ui$Form$horizontal
                            ]), _List_fromArray([
                                !$elm$core$List$isEmpty(mceActivePractices) ? A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Current and Pending'),
                                    $author$project$Ui$Form$Group$labelSpanSm(3),
                                    $author$project$Ui$Form$Group$inputSpanSm(9)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewPatientMceEligibility, mceActivePractices))
                                ])) : $author$project$Utils$Html$empty,
                                $elm$core$List$isEmpty(mceInactivePractices) && $elm$core$List$isEmpty(emailableAddons) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                    $author$project$Ui$Form$Group$label('Available'),
                                    $author$project$Ui$Form$Group$labelSpanSm(3),
                                    $author$project$Ui$Form$Group$inputSpanSm(9)
                                ]), _Utils_ap(A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewInactivePatientMceEligibility(model.jb), mceInactivePractices), A2($elm$core$List$map, $author$project$Pages$Patients$PatientId_String$Top$viewEmailableAddon(model.hq), emailableAddons)))
                            ]))
                        ]);
                    }
                case 1:
                    return _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSkeleton('Wrap around'),
                            $author$project$Ui$Form$Group$labelSpanSm(3),
                            $author$project$Ui$Form$Group$inputSpanSm(9)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                $author$project$Ui$Skeleton$text(_List_fromArray([
                                    $author$project$Ui$Skeleton$span(3)
                                ]))
                            ]))
                        ]))
                    ]);
                default:
                    return _List_fromArray([
                        $author$project$Utils$Html$empty
                    ]);
            }
        }())));
    };
    var $author$project$Pages$Patients$PatientId_String$Top$view = function(model) {
        var name = _Utils_ap(function() {
            var _v1 = $author$project$Api$Provider$Patient$One$chosenTitle(model.V7);
            if (!_v1.$) {
                var chosenTitle = _v1.a;
                return chosenTitle + ' ';
            } else {
                var title = A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$One$title(model.V7));
                return title === '' ? '' : title + ' ';
            }
        }(), $author$project$Api$Provider$Patient$One$name(model.V7));
        var dob = function() {
            var _v0 = $author$project$Api$Provider$Patient$One$dob(model.V7);
            if (!_v0.$) {
                var date = _v0.a;
                return A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, date);
            } else return '';
        }();
        return {
            fb: _List_fromArray([
                $author$project$Pages$Patients$PatientId_String$Top$viewAddSponsorshipModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewAddDependentModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewRemoveSponsorshipModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewCreateMembershipModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewRestorePatientModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewElationForcePushConfirmModal(model),
                A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$PackageDetailsModalMsg, $author$project$Components$Patient$PackageDetailsModal$view(model.c8)),
                $author$project$Pages$Patients$PatientId_String$Top$viewDetachPatientModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewEditCustomFormAnswerModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewMembershipDetailsModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewAcceptEphiWaiverModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewRemoveEphiWaiverModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewManagePortalAccessModal(model),
                $author$project$Pages$Patients$PatientId_String$Top$viewEditAthenaIdModal(model),
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Pages$Patients$PatientId_String$Top$viewArchivedPatientAlert(model.V7),
                        $author$project$Pages$Patients$PatientId_String$Top$viewNetworkLinkageAlert(model.V7),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter
                        ]), _List_fromArray([
                            $author$project$Ui$Panel$titleSm(_List_fromArray([
                                $elm$html$Html$text('Patient')
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$ml2
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$Patients$PatientId_String$Top$AuditTrailLogMsg, $author$project$Components$AuditTrailLog$view(model.hB))
                            ]))
                        ])),
                        A2($author$project$Ui$Form$view, _List_fromArray([
                            $author$project$Ui$Form$horizontal
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Patient Info'),
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9)
                            ]), _List_fromArray([
                                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Element$view, _List_fromArray([
                                            $author$project$Ui$Element$spaceBetween
                                        ]), _List_fromArray([
                                            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                                    $author$project$Ui$Typography$phi(true)
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text(name)
                                                ])),
                                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                                    $author$project$Ui$Typography$muted,
                                                    $author$project$Ui$Typography$small,
                                                    $author$project$Ui$Typography$margin(10),
                                                    $author$project$Ui$Typography$italic
                                                ]), _List_fromArray([
                                                    $elm$html$Html$text($author$project$Api$Provider$Patient$One$id(model.V7))
                                                ])),
                                                A2($author$project$Pages$Patients$PatientId_String$Top$viewCopyButton, 'patient identifier ', $author$project$Api$Provider$Patient$One$id(model.V7))
                                            ])),
                                            A2($author$project$Permission$hideIfReadOnly, model.Z$, A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Edit({
                                                V8: $author$project$Api$Provider$Patient$One$id(model.V7)
                                            }), _List_fromArray([
                                                $author$project$Ui$Link$buttonDefault,
                                                $author$project$Ui$Link$disabled($author$project$Api$Provider$Patient$One$archived(model.V7)),
                                                $author$project$Ui$Link$xs,
                                                $author$project$Ui$Link$icon($author$project$Ui$Icon$edit)
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Edit Patient Details')
                                            ])))
                                        ]))
                                    ])),
                                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$phi(true)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text(dob)
                                        ]))
                                    ])),
                                    A2($author$project$Pages$Patients$PatientId_String$Top$viewGenderSection, model.W1, model.V7),
                                    A2($author$project$Pages$Patients$PatientId_String$Top$viewEmailSection, model.V7, model.qs),
                                    $author$project$Pages$Patients$PatientId_String$Top$viewPhonesSection(model.V7),
                                    A2($author$project$Pages$Patients$PatientId_String$Top$viewAddressesSection, model.W1, model.V7)
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Emergency Contact'),
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9)
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                    A2($elm$core$Maybe$withDefault, A2($author$project$Ui$Typography$p, _List_fromArray([
                                        $author$project$Ui$Typography$italic,
                                        $author$project$Ui$Typography$muted
                                    ]), _List_fromArray([
                                        $elm$html$Html$text('None')
                                    ])), A2($elm$core$Maybe$map, $author$project$Pages$Patients$PatientId_String$Top$viewEmergencyContact, $author$project$Api$Provider$Patient$One$emergencyContact(model.V7)))
                                ]))
                            ])),
                            A2($author$project$Pages$Patients$PatientId_String$Top$viewPreferredLanguage, model.W1, model.V7),
                            $author$project$Pages$Patients$PatientId_String$Top$viewProfilePicture(model),
                            $author$project$Pages$Patients$PatientId_String$Top$viewSSNSection(model),
                            $author$project$Pages$Patients$PatientId_String$Top$viewHealthInsurance(model.V7),
                            $author$project$Pages$Patients$PatientId_String$Top$viewPractitioner(model.V7),
                            A2($author$project$Pages$Patients$PatientId_String$Top$viewLocation, model.W1, model.V7),
                            A2($author$project$Pages$Patients$PatientId_String$Top$viewDpcPractice, model.W1, model.V7),
                            A2($author$project$Pages$Patients$PatientId_String$Top$viewPrimaryCareClinic, model.W1, model.V7),
                            A2($author$project$Pages$Patients$PatientId_String$Top$viewTobaccoSection, model.W1, model.V7),
                            $author$project$Pages$Patients$PatientId_String$Top$viewJoinDate(model.V7),
                            $author$project$Pages$Patients$PatientId_String$Top$viewLeadSource(model.V7),
                            A3($author$project$Utils$FeatureGate$gate, 5, $author$project$Api$Practice$Provider(model.W1), A8($author$project$Pages$Patients$PatientId_String$Top$viewSelfService, model.oe, model.HO, model.Ik, model.SW, model.qs, model.V7, model.F3, model.aea)),
                            $author$project$Pages$Patients$PatientId_String$Top$viewEngagement(model),
                            $author$project$Pages$Patients$PatientId_String$Top$viewMergedInto(model.V7),
                            $author$project$Pages$Patients$PatientId_String$Top$viewSponsorshipsSection(model)
                        ])),
                        $author$project$Pages$Patients$PatientId_String$Top$viewMembershipSection(model),
                        $author$project$Pages$Patients$PatientId_String$Top$viewPackagesSection(model),
                        $author$project$Pages$Patients$PatientId_String$Top$viewWrapArounds(model),
                        $author$project$Pages$Patients$PatientId_String$Top$viewFinancialInformation(model),
                        $author$project$Pages$Patients$PatientId_String$Top$viewAgreementsSection(model),
                        $author$project$Pages$Patients$PatientId_String$Top$viewIntegrationsSection(model),
                        $author$project$Pages$Patients$PatientId_String$Top$viewCustomFormsSection(model)
                    ]))
                ]))
            ]),
            $2: 'Patient | ' + $author$project$Api$Provider$Patient$One$id(model.V7)
        };
    };
    var $author$project$Pages$Patients$PatientId_String$Top$page = $author$project$Spa$Page$applicationPatient({
        aeq: $author$project$Pages$Patients$PatientId_String$Top$init,
        aeR: $author$project$Pages$Patients$PatientId_String$Top$load,
        ag3: $author$project$Pages$Patients$PatientId_String$Top$save,
        ahE: $author$project$Pages$Patients$PatientId_String$Top$subscriptions,
        aaO: $author$project$Pages$Patients$PatientId_String$Top$update,
        aid: $author$project$Pages$Patients$PatientId_String$Top$view
    });
    var $author$project$Pages$Patients$PatientId_String$VitalsTrends$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$VitalsTrends$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$PatientId_String$VitalsTrends$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Patients$PatientId_String$VitalsTrends$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Vitals Trends'
        };
    };
    var $author$project$Pages$Patients$PatientId_String$VitalsTrends$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Patients$PatientId_String$VitalsTrends$init,
        aeR: $author$project$Pages$Patients$PatientId_String$VitalsTrends$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Patients$PatientId_String$VitalsTrends$update,
        aid: $author$project$Pages$Patients$PatientId_String$VitalsTrends$view
    });
    var $author$project$Api$Provider$Report$Patient = 0;
    var $author$project$Pages$Patients$Top$PatientsListMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PatientsList$GotTodaysDate = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$PatientsList$PracticePulseMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$PatientsList$GotPatients = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PatientsList$fetchParams = function(_v0) {
        var filters = _v0.g;
        var pagination = _v0.af_;
        var sort = _v0.ahs;
        return function(d) {
            return _Utils_update(d, {
                IY: filters.pr,
                acy: filters.fl,
                Fw: filters.g,
                aeT: filters.Tp,
                rm: filters.f0,
                af_: pagination,
                GW: filters.agd,
                agi: filters.Xa,
                agq: filters.agq,
                ahs: sort
            });
        };
    };
    var $author$project$Components$PatientsList$fetchPatients = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Patient$list, apiClient, $author$project$Components$PatientsList$fetchParams(model), $author$project$Components$PatientsList$GotPatients);
    });
    var $author$project$Components$PracticePulse$GotPulse = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Pulse$One$Pulse = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Pulse$One$Record = function(activePatients) {
        return function(newPatients) {
            return function(newTerminations) {
                return function(patientInvoicesDueInCents) {
                    return function(sponsorInvoicesDueInCents) {
                        return function(totalPractitioners) {
                            return function(activePatientsPercentage) {
                                return function(newPatientsPercentage) {
                                    return function(newTerminationsPercentage) {
                                        return function(patientInvoicesDueInCentsPercentage) {
                                            return function(sponsorInvoicesDueInCentsPercentage) {
                                                return function(upcomingBirthdayPatients) {
                                                    return {
                                                        Ix: activePatients,
                                                        Iy: activePatientsPercentage,
                                                        US: newPatients,
                                                        UT: newPatientsPercentage,
                                                        UW: newTerminations,
                                                        UX: newTerminationsPercentage,
                                                        Wa: patientInvoicesDueInCents,
                                                        Wb: patientInvoicesDueInCentsPercentage,
                                                        _U: sponsorInvoicesDueInCents,
                                                        _V: sponsorInvoicesDueInCentsPercentage,
                                                        aan: totalPractitioners,
                                                        aaM: upcomingBirthdayPatients
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Pulse$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'upcoming_birthday_patients', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsor_invoices_due_in_cents_percentage', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient_invoices_due_in_cents_percentage', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'new_terminations_percentage', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'new_patients_percentage', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_patients_percentage', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$float), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_practitioners', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsor_invoices_due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient_invoices_due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'new_terminations', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'new_patients', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active_patients', $elm$json$Json$Decode$int, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Pulse$One$Record)))))))))))));
    var $author$project$Api$Provider$Pulse$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Pulse$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Pulse$pulsePath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'pulse'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Pulse$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Pulse$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Pulse$pulsePath));
    });
    var $author$project$Components$PracticePulse$init = F2(function(apiClient, session) {
        return _Utils_Tuple2({
            sn: $author$project$Api$Data$Loading,
            Z$: session
        }, A2($author$project$Api$Provider$Pulse$retrieve, apiClient, $author$project$Components$PracticePulse$GotPulse));
    });
    var $author$project$Components$PatientsList$AffiliateResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$PatientsList$CompanyResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$PatientsList$PlanResourceFilterMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter = F4(function(apiClient, locationsFilterVisible, locationGroupId, locationId) {
        return locationsFilterVisible ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Components$ResourceFilter$Location$init, apiClient, locationGroupId, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'All Locations',
                afn: _Utils_eq(locationGroupId, $elm$core$Maybe$Nothing),
                agj: locationId
            });
        })) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter = F5(function(apiClient, hidePractitioner, locationGroupId, locationId, practitionerId) {
        return !hidePractitioner ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A3($author$project$Components$ResourceFilter$Practitioner$init, apiClient, function(d) {
            return _Utils_update(d, {
                aeT: locationId,
                rm: locationGroupId
            });
        }, function(d) {
            return _Utils_update(d, {
                Ee: 'All Providers',
                afn: true,
                agj: practitionerId
            });
        })) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Api$Platform$Session$One$restrictedByGroups = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$withDefault, false, record.YW);
    };
    var $author$project$Api$Platform$Session$One$locationGroups = function(_v0) {
        var record = _v0;
        return record.Tl;
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$userCanSelectLocationGroup = F2(function(session, practice) {
        return $author$project$Api$Platform$Session$One$restrictedByGroups(session) ? A3($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty, $author$project$Api$Platform$Session$One$locationGroups(session)) : $author$project$Api$Provider$Practice$One$locationGroupsCount(practice) > 0;
    });
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init = F7(function(apiClient, session, practice, hidePractitioner, locationGroupId, locationId, practitionerId) {
        var locationsFilterVisible = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        var locationGroupsFilterVisible = locationsFilterVisible && A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$userCanSelectLocationGroup, session, practice);
        var _v0 = A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, hidePractitioner, locationGroupId, locationId, practitionerId);
        var practitionerResourceFilter = _v0.a;
        var practitionerResourceFilterCmd = _v0.b;
        var _v1 = A4($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter, apiClient, locationsFilterVisible, locationGroupId, locationId);
        var locationResourceFilter = _v1.a;
        var locationResourceFilterCmd = _v1.b;
        var _v2 = function() {
            if (locationGroupsFilterVisible) {
                var userRestrictedByGroups = $author$project$Api$Platform$Session$One$restrictedByGroups(session);
                return A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$ResourceFilter$LocationGroup$init, apiClient, function(d) {
                    return _Utils_update(d, {
                        Ee: 'All Groups',
                        afn: !userRestrictedByGroups,
                        agj: locationGroupId
                    });
                }));
            } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        }();
        var locationGroupResourceFilter = _v2.a;
        var locationGroupResourceFilterCmd = _v2.b;
        return _Utils_Tuple2({
            xX: hidePractitioner,
            rn: locationGroupResourceFilter,
            Tn: locationGroupsFilterVisible,
            ro: locationResourceFilter,
            Gd: locationsFilterVisible,
            jE: practitionerResourceFilter
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg, locationGroupResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
        ])));
    });
    var $author$project$Api$Provider$Practice$One$plansCount = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.WP;
    });
    var $author$project$Components$PatientsList$initFilters = F4(function(apiClient, session, practice, query) {
        var q = A2($elm$core$Dict$get, 'patients_q', query);
        var practitionerId = A2($elm$core$Dict$get, 'patients_practitioner', query);
        var planId = A2($elm$core$Dict$get, 'patients_plan', query);
        var locationId = A2($elm$core$Dict$get, 'patients_location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'patients_location_group', query);
        var initialFilters = function(maybeFilters) {
            var _v5 = _Utils_Tuple2(maybeFilters, $author$project$Api$Provider$Practice$One$defaultToActivePatientsFilter(practice));
            if (_v5.a.$ === 1) {
                if (_v5.b) {
                    var _v6 = _v5.a;
                    return _List_fromArray([
                        $author$project$Api$Provider$Patient$Status(0)
                    ]);
                } else {
                    var _v7 = _v5.a;
                    return _List_Nil;
                }
            } else {
                var justFilters = _v5.a.a;
                return justFilters;
            }
        }(A2($elm$core$Maybe$map, $elm$core$List$filterMap($author$project$Api$Provider$Patient$filterFromString), A2($elm$core$Maybe$map, $elm$core$String$split(','), A2($elm$core$Dict$get, 'filter', query))));
        var companyId = A2($elm$core$Dict$get, 'patients_company', query);
        var affiliateId = A2($elm$core$Dict$get, 'patients_affiliate', query);
        var _v0 = $author$project$Api$Provider$Practice$One$plansCount(practice) > 0 ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        var planResourceFilter = _v0.a;
        var planResourceFilterCmd = _v0.b;
        var _v1 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v1.a;
        var groupLocationAndPractitionerFiltersCmd = _v1.b;
        var _v2 = $author$project$Api$Provider$Practice$One$companiesCount(practice) > 0 ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Utils$Report$CompanyResourceFilter$init, apiClient, function(d) {
            return _Utils_update(d, {
                afn: true
            });
        }, $author$project$Api$Practice$Provider(practice), companyId)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        var companyResourceFilter = _v2.a;
        var companyResourceFilterCmd = _v2.b;
        var _v3 = function() {
            if ($author$project$Api$Provider$Practice$One$isNetwork(practice)) {
                var _v4 = A4($author$project$Components$ResourceFilter$Affiliate$init, apiClient, session, $elm$core$Basics$identity, function(d) {
                    return _Utils_update(d, {
                        Ee: 'All Affiliates',
                        I5: true,
                        afn: true
                    });
                });
                var filter = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple2($elm$core$Maybe$Just(filter), cmd);
            } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        }();
        var affiliateResourceFilter = _v3.a;
        var affiliateResourceFilterCmd = _v3.b;
        return _Utils_Tuple2({
            pr: affiliateId,
            pu: affiliateResourceFilter,
            fl: companyId,
            pY: companyResourceFilter,
            g: initialFilters,
            b8: groupLocationAndPractitionerFilters,
            f0: locationGroupId,
            Tp: locationId,
            jq: $author$project$Components$PatientFilter$init,
            agd: planId,
            jy: planResourceFilter,
            Xa: practitionerId,
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q)
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$AffiliateResourceFilterMsg, affiliateResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$CompanyResourceFilterMsg, companyResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PlanResourceFilterMsg, planResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd)
        ])));
    });
    var $author$project$Api$Provider$Practice$One$practicePulse = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.W6;
    });
    var $author$project$Components$PatientsList$init = F4(function(session, practice, patientId, _v0) {
        var apiClient = _v0.Ej;
        var query = _v0.Bz;
        var timeFormatter = _v0.HO;
        var timeZone = _v0.HP;
        var url = _v0.aaT;
        var _v1 = $author$project$Api$Provider$Practice$One$practicePulse(practice) ? A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$PracticePulse$init, apiClient, session)) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
        var practicePulse = _v1.a;
        var practicePulseCmd = _v1.b;
        var _v2 = A4($author$project$Components$PatientsList$initFilters, apiClient, session, practice, query);
        var filters = _v2.a;
        var filtersCmd = _v2.b;
        var model = {
            g: filters,
            af_: A2($author$project$Api$Pagination$fromQuery, query, A2($author$project$Api$Pagination$withPrefix, 'patients_', $author$project$Api$Pagination$init)),
            V8: patientId,
            AD: $author$project$Api$Data$Loading,
            r5: false,
            W1: practice,
            W6: practicePulse,
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'last_name', 0, A2($author$project$Api$Sort$fromQuery, query, A2($author$project$Api$Sort$withPrefix, 'patients_', $author$project$Api$Sort$init))),
            HO: timeFormatter,
            HP: timeZone,
            oP: $elm$core$Maybe$Nothing,
            aaT: url
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$PatientsList$fetchPatients, apiClient, model),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PracticePulseMsg, practicePulseCmd),
            filtersCmd,
            A2($elm$core$Task$perform, $author$project$Components$PatientsList$GotTodaysDate, $justinmimbs$date$Date$today)
        ])));
    });
    var $author$project$Pages$Patients$Top$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var accountStep = A2($elm$core$Maybe$withDefault, 8, A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$Shared$accountStep, $author$project$Api$Provider$Practice$One$practiceOnboarding(practice)));
        var _v1 = function() {
            var _v2 = shared.af4;
            if (_v2.$ === 1) return A4($author$project$Components$PatientsList$init, session, practice, $elm$core$Maybe$Nothing, {
                Ej: shared.Ej,
                Bz: query,
                HO: shared.HO,
                HP: shared.HP,
                aaT: shared.aaT
            });
            else {
                var patientsList_ = _v2.a;
                return _Utils_Tuple2(patientsList_, $elm$core$Platform$Cmd$none);
            }
        }();
        var patientsList = _v1.a;
        var patientListCmd = _v1.b;
        return _Utils_Tuple2({
            Im: accountStep,
            Ej: shared.Ej,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 0
            }),
            af4: patientsList,
            W1: practice,
            Z$: session
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$PatientsListMsg, patientListCmd));
    });
    var $author$project$Pages$Patients$Top$load = F2(function(shared, model) {
        var _v0 = shared.af4;
        if (_v0.$ === 1) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        else {
            var patientsList = _v0.a;
            return _Utils_Tuple2(_Utils_update(model, {
                af4: patientsList
            }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Pages$Patients$Top$save = F2(function(_v0, shared) {
        var patientsList = _v0.af4;
        return _Utils_update(shared, {
            af4: $elm$core$Maybe$Just(patientsList)
        });
    });
    var $author$project$Pages$Patients$Top$ExportCsvMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PatientsList$PatientFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Affiliate$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$ResourceFilter$LocationGroup$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$ResourceFilter$Location$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg)), model.ro),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$ResourceFilter$LocationGroup$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg)), model.rn),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$ResourceFilter$Practitioner$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg)), model.jE)
        ])));
    };
    var $author$project$Components$PatientsList$subscriptions = function(_v0) {
        var filters = _v0.g;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$PatientsList$PatientFilterMsg, $author$project$Components$PatientFilter$subscriptions(filters.jq)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$ResourceFilter$Company$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$PatientsList$CompanyResourceFilterMsg)), filters.pY)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(filters.b8)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$ResourceFilter$Plan$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$PatientsList$PlanResourceFilterMsg)), filters.jy)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$ResourceFilter$Affiliate$subscriptions, $elm$core$Platform$Sub$map($author$project$Components$PatientsList$AffiliateResourceFilterMsg)), filters.pu))
        ]));
    };
    var $author$project$Pages$Patients$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$Top$PatientsListMsg, $author$project$Components$PatientsList$subscriptions(model.af4)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$Top$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md))
        ]));
    };
    var $author$project$Utils$PracticeOnboarding$redirectToLastAccountStep = F2(function(accountStep, practice) {
        switch(accountStep){
            case 0:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Account);
            case 1:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans);
            case 2:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Documents);
            case 3:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Team);
            case 4:
                return !A2($elm$core$Maybe$withDefault, 13, A2($elm$core$Maybe$map, $author$project$Api$Provider$Practice$Emr$toOption, $author$project$Api$Provider$Practice$One$emr(practice))) ? A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Communications) : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing);
            case 5:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Legal);
            case 6:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing);
            case 7:
                return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top);
            default:
                return $elm$core$Platform$Cmd$none;
        }
    });
    var $author$project$Components$ResourceFilter$Affiliate$reset = function(model) {
        return _Utils_update(model, {
            Hg: $author$project$Components$ResourceFilter$All
        });
    };
    var $author$project$Components$ResourceFilter$Company$reset = function(model) {
        return _Utils_update(model, {
            Hg: $author$project$Components$ResourceFilter$All
        });
    };
    var $author$project$Components$ResourceFilter$Location$reset = function(model) {
        return _Utils_update(model, {
            Hg: $author$project$Components$ResourceFilter$All
        });
    };
    var $author$project$Components$ResourceFilter$LocationGroup$reset = function(model) {
        return _Utils_update(model, {
            Hg: $author$project$Components$ResourceFilter$All
        });
    };
    var $author$project$Components$ResourceFilter$Practitioner$reset = function(model) {
        return _Utils_update(model, {
            Hg: $author$project$Components$ResourceFilter$All
        });
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$reset = function(model) {
        return _Utils_update(model, {
            rn: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$LocationGroup$reset, model.rn),
            ro: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Location$reset, model.ro),
            jE: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Practitioner$reset, model.jE)
        });
    };
    var $author$project$Components$ResourceFilter$Plan$reset = function(model) {
        return _Utils_update(model, {
            Hg: $author$project$Components$ResourceFilter$All
        });
    };
    var $author$project$Components$PracticePulse$FilterSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PracticePulse$None = {
        $: 0
    };
    var $author$project$Components$PracticePulse$cancellationReasonReportEmbeddedId = 'rpt-OEmUlF2gSktd';
    var $author$project$Components$PracticePulse$courseUrl = 'https://accelerator.hint.com/watch';
    var $author$project$Components$PracticePulse$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$PracticePulse$None,
                    zi: _Utils_update(model, {
                        sn: response
                    }),
                    at: $author$project$OutMsg$handleErrorResponse(response)
                };
            case 1:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$NewActivationsSinceDate),
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$NewTerminationsSinceDate),
                    zi: model,
                    at: _List_Nil
                };
            case 3:
                return {
                    EQ: A2($author$project$Utils$Route$navigate, $elm$core$Dict$fromList(_List_fromArray([
                        _Utils_Tuple2('status', 'issued,sent,retrying')
                    ])), $author$project$Spa$Generated$Route$Reports__Invoices),
                    adu: $author$project$Components$PracticePulse$None,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                return {
                    EQ: A2($author$project$Utils$Route$navigate, $elm$core$Dict$fromList(_List_fromArray([
                        _Utils_Tuple2('status', 'issued,failed')
                    ])), $author$project$Spa$Generated$Route$Reports__CompanyInvoices),
                    adu: $author$project$Components$PracticePulse$None,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                return {
                    EQ: A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Admin__Notifications__Patient),
                    adu: $author$project$Components$PracticePulse$None,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$WithoutEmail),
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                return {
                    EQ: A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Reports__Custom__Id_String({
                        aef: $author$project$Components$PracticePulse$cancellationReasonReportEmbeddedId
                    })),
                    adu: $author$project$Components$PracticePulse$None,
                    zi: model,
                    at: _List_Nil
                };
            case 8:
                return {
                    EQ: $author$project$Ports$Navigation$openInNewWindow($author$project$Components$PracticePulse$courseUrl),
                    adu: $author$project$Components$PracticePulse$None,
                    zi: model,
                    at: _List_Nil
                };
            default:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: $author$project$Components$PracticePulse$FilterSelected($author$project$Api$Provider$Patient$WithUpcomingBirthday),
                    zi: model,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Components$PatientsList$SearchInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Closed = {
        $: 1
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated = F3(function(a, b, c) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None = {
        $: 2
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop = function(model) {
        return {
            EQ: $elm$core$Platform$Cmd$none,
            adu: $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None,
            zi: model,
            at: _List_Nil
        };
    };
    var $author$project$Components$ResourceFilter$LocationGroup$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = model.rn;
                if (!_v1.$) {
                    var locationGroupResourceFilter = _v1.a;
                    var locationGroupResourceResult = A3($author$project$Components$ResourceFilter$LocationGroup$update, apiClient, subMsg, locationGroupResourceFilter);
                    var event = function() {
                        var _v6 = locationGroupResourceResult.adu;
                        if (!_v6.$) {
                            if (!_v6.a.$) return A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated, $author$project$Components$ResourceFilter$LocationGroup$value(locationGroupResourceResult.zi), $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
                            else {
                                var _v7 = _v6.a;
                                return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Closed;
                            }
                        } else return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
                    }();
                    var _v2 = function() {
                        if (!event.$) {
                            var locationGroupId = event.a;
                            return A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, model.xX, locationGroupId, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
                        } else return _Utils_Tuple2(model.jE, $elm$core$Platform$Cmd$none);
                    }();
                    var practitionerResourceFilter = _v2.a;
                    var practitionerResourceFilterCmd = _v2.b;
                    var _v4 = function() {
                        if (!event.$) {
                            var locationGroupId = event.a;
                            return A4($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initLocationFilter, apiClient, model.Gd, locationGroupId, $elm$core$Maybe$Nothing);
                        } else return _Utils_Tuple2(model.ro, $elm$core$Platform$Cmd$none);
                    }();
                    var locationResourceFilter = _v4.a;
                    var locationResourceFilterCmd = _v4.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg, locationGroupResourceResult.EQ),
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceFilterCmd),
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
                        ])),
                        adu: event,
                        zi: _Utils_update(model, {
                            rn: $elm$core$Maybe$Just(locationGroupResourceResult.zi),
                            ro: locationResourceFilter,
                            jE: practitionerResourceFilter
                        }),
                        at: locationGroupResourceResult.at
                    };
                } else return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
            case 1:
                var subMsg = msg.a;
                var _v8 = model.ro;
                if (!_v8.$) {
                    var locationResourceFilter = _v8.a;
                    var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, apiClient, subMsg, locationResourceFilter);
                    var event = function() {
                        var _v11 = locationResourceResult.adu;
                        if (!_v11.$) {
                            if (!_v11.a.$) return A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated, A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$LocationGroup$value, model.rn), $author$project$Components$ResourceFilter$Location$value(locationResourceResult.zi), $elm$core$Maybe$Nothing);
                            else {
                                var _v12 = _v11.a;
                                return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Closed;
                            }
                        } else return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
                    }();
                    var _v9 = function() {
                        if (!event.$) {
                            var locationGroupId = event.a;
                            var locationId = event.b;
                            return A5($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$initPractitionerFilter, apiClient, model.xX, locationGroupId, locationId, $elm$core$Maybe$Nothing);
                        } else return _Utils_Tuple2(model.jE, $elm$core$Platform$Cmd$none);
                    }();
                    var practitionerResourceFilter = _v9.a;
                    var practitionerResourceFilterCmd = _v9.b;
                    return {
                        EQ: $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, locationResourceResult.EQ),
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceFilterCmd)
                        ])),
                        adu: event,
                        zi: _Utils_update(model, {
                            ro: $elm$core$Maybe$Just(locationResourceResult.zi),
                            jE: practitionerResourceFilter
                        }),
                        at: locationResourceResult.at
                    };
                } else return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
            default:
                var subMsg = msg.a;
                var _v13 = model.jE;
                if (!_v13.$) {
                    var practitionerResourceFilter = _v13.a;
                    var practitionerResourceResult = A3($author$project$Components$ResourceFilter$Practitioner$update, apiClient, subMsg, practitionerResourceFilter);
                    var event = function() {
                        var _v14 = practitionerResourceResult.adu;
                        if (!_v14.$) {
                            if (!_v14.a.$) return A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$FiltersUpdated, A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$LocationGroup$value, model.rn), A2($elm$core$Maybe$andThen, $author$project$Components$ResourceFilter$Location$value, model.ro), $author$project$Components$ResourceFilter$Practitioner$value(practitionerResourceResult.zi));
                            else {
                                var _v15 = _v14.a;
                                return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Closed;
                            }
                        } else return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$None;
                    }();
                    return {
                        EQ: A2($elm$core$Platform$Cmd$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, practitionerResourceResult.EQ),
                        adu: event,
                        zi: _Utils_update(model, {
                            jE: $elm$core$Maybe$Just(practitionerResourceResult.zi)
                        }),
                        at: practitionerResourceResult.at
                    };
                } else return $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$noop(model);
        }
    });
    var $author$project$Components$PatientsList$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            model.aaT.V6
        ]), $author$project$Components$PatientsList$urlParams(model)));
    };
    var $author$project$Components$ResourceFilter$Affiliate$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$PatientsList$updateCurrentFilters = F3(function(apiClient, msg, model) {
        var filters = model.g;
        switch(msg.$){
            case 6:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, filters.b8);
                var _v1 = result.adu;
                switch(_v1.$){
                    case 0:
                        var locationGroupId = _v1.a;
                        var locationId = _v1.b;
                        var practitionerId = _v1.c;
                        var newFilters = _Utils_update(filters, {
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            Xa: practitionerId
                        });
                        var newFiltersAreDifferent = !_Utils_eq(filters.Tp, newFilters.Tp) || !_Utils_eq(filters.Xa, newFilters.Xa) || !_Utils_eq(filters.f0, newFilters.f0);
                        var newModel = newFiltersAreDifferent ? _Utils_update(model, {
                            g: newFilters,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            AD: $author$project$Api$Data$Loading
                        }) : _Utils_update(model, {
                            g: newFilters
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            newFiltersAreDifferent ? $elm$core$Platform$Cmd$batch(_List_fromArray([
                                A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
                                $author$project$Components$PatientsList$updateUrl(newModel)
                            ])) : $elm$core$Platform$Cmd$none
                        ])), result.at);
                    case 1:
                        var newFilters = _Utils_update(filters, {
                            b8: result.zi
                        });
                        return _Utils_Tuple3(_Utils_update(model, {
                            g: newFilters
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        var newFilters = _Utils_update(filters, {
                            b8: result.zi
                        });
                        return _Utils_Tuple3(_Utils_update(model, {
                            g: newFilters
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 5:
                var subMsg = msg.a;
                var _v2 = filters.jy;
                if (!_v2.$) {
                    var planResourceFilter = _v2.a;
                    var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, planResourceFilter);
                    var planId = function() {
                        var _v4 = planResourceResult.adu;
                        if (!_v4.$) {
                            if (!_v4.a.$) return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.zi);
                            else {
                                var _v5 = _v4.a;
                                return filters.agd;
                            }
                        } else return filters.agd;
                    }();
                    var pagination = _Utils_eq(filters.agd, planId) ? model.af_ : $author$project$Api$Pagination$reset(model.af_);
                    var newFilters = _Utils_update(filters, {
                        agd: planId,
                        jy: $elm$core$Maybe$Just(planResourceResult.zi)
                    });
                    var newModel = _Utils_update(model, {
                        g: newFilters,
                        af_: pagination
                    });
                    var _v3 = _Utils_eq(filters.agd, newFilters.agd) ? _Utils_Tuple2(model.AD, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
                        $author$project$Components$PatientsList$updateUrl(newModel)
                    ])));
                    var patients = _v3.a;
                    var cmd = _v3.b;
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        af_: pagination,
                        AD: patients
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PlanResourceFilterMsg, planResourceResult.EQ),
                        cmd
                    ])), planResourceResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v6 = filters.pY;
                if (!_v6.$) {
                    var companyResourceFilter = _v6.a;
                    var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, companyResourceFilter);
                    var companyId = function() {
                        var _v8 = companyResourceResult.adu;
                        if (!_v8.$) {
                            if (!_v8.a.$) return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.zi);
                            else {
                                var _v9 = _v8.a;
                                return filters.fl;
                            }
                        } else return filters.fl;
                    }();
                    var newFilters = _Utils_update(filters, {
                        fl: companyId,
                        pY: $elm$core$Maybe$Just(companyResourceResult.zi)
                    });
                    var pagination = _Utils_eq(filters.fl, companyId) ? model.af_ : $author$project$Api$Pagination$reset(model.af_);
                    var newModel = _Utils_update(model, {
                        g: newFilters,
                        af_: pagination
                    });
                    var _v7 = _Utils_eq(filters.fl, newFilters.fl) ? _Utils_Tuple2(model.AD, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
                        $author$project$Components$PatientsList$updateUrl(newModel)
                    ])));
                    var patients = _v7.a;
                    var cmd = _v7.b;
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        af_: pagination,
                        AD: patients
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$CompanyResourceFilterMsg, companyResourceResult.EQ),
                        cmd
                    ])), companyResourceResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v10 = filters.pu;
                if (!_v10.$) {
                    var affiliateResourceFilter = _v10.a;
                    var affiliateResourceResult = A3($author$project$Components$ResourceFilter$Affiliate$update, apiClient, subMsg, affiliateResourceFilter);
                    var affiliateId = function() {
                        var _v12 = affiliateResourceResult.adu;
                        if (!_v12.$) {
                            if (!_v12.a.$) return $author$project$Components$ResourceFilter$Affiliate$value(affiliateResourceResult.zi);
                            else {
                                var _v13 = _v12.a;
                                return filters.pr;
                            }
                        } else return filters.pr;
                    }();
                    var newFilters = _Utils_update(filters, {
                        pr: affiliateId,
                        pu: $elm$core$Maybe$Just(affiliateResourceResult.zi)
                    });
                    var pagination = _Utils_eq(filters.pr, affiliateId) ? model.af_ : $author$project$Api$Pagination$reset(model.af_);
                    var newModel = _Utils_update(model, {
                        g: newFilters,
                        af_: pagination
                    });
                    var _v11 = _Utils_eq(filters.pr, newFilters.pr) ? _Utils_Tuple2(model.AD, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
                        $author$project$Components$PatientsList$updateUrl(newModel)
                    ])));
                    var patients = _v11.a;
                    var cmd = _v11.b;
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        af_: pagination,
                        AD: patients
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$AffiliateResourceFilterMsg, affiliateResourceResult.EQ),
                        cmd
                    ])), affiliateResourceResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v14 = A2($author$project$Ui$SearchInput$update, subMsg, filters.sG);
                var searchInput = _v14.a;
                var searchInputCmd = _v14.b;
                var searchInputEvent = _v14.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return filters.agq;
                }();
                var newFilters = _Utils_update(filters, {
                    agq: q,
                    sG: searchInput
                });
                var _v15 = function() {
                    if (_Utils_eq(q, filters.agq)) return _Utils_Tuple2(_Utils_update(model, {
                        g: newFilters
                    }), $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            g: newFilters,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            AD: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($author$project$Components$PatientsList$fetchPatients, apiClient, qModel),
                            $author$project$Components$PatientsList$updateUrl(qModel)
                        ])));
                    }
                }();
                var newModel = _v15.a;
                var cmd = _v15.b;
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v17 = A2($author$project$Components$PatientFilter$update, subMsg, filters.jq);
                var patientFilter = _v17.a;
                var cmd = _v17.b;
                var event = _v17.c;
                if (event.$ === 1) {
                    var selectedFilters = event.a;
                    var newFilters = _Utils_update(filters, {
                        g: selectedFilters,
                        jq: patientFilter
                    });
                    var newModel = _Utils_update(model, {
                        g: newFilters,
                        af_: $author$project$Api$Pagination$reset(model.af_),
                        AD: $author$project$Api$Data$Loading
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
                        $author$project$Components$PatientsList$updateUrl(newModel),
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PatientFilterMsg, cmd)
                    ])), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    g: _Utils_update(filters, {
                        jq: patientFilter
                    })
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PatientFilterMsg, cmd), _List_Nil);
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$PatientsList$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        AD: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    AD: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
            case 2:
                return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
            case 3:
                return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
            case 4:
                return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
            case 5:
                return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
            case 6:
                return A3($author$project$Components$PatientsList$updateCurrentFilters, apiClient, msg, model);
            case 7:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    AD: $author$project$Api$Data$Loading,
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
                    $author$project$Components$PatientsList$updateUrl(newModel)
                ])), _List_Nil);
            case 8:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    AD: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
                    $author$project$Components$PatientsList$updateUrl(newModel)
                ])), _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v2 = model.W6;
                if (!_v2.$) {
                    var practicePulse = _v2.a;
                    var practicePulseResult = A2($author$project$Components$PracticePulse$update, subMsg, practicePulse);
                    var _v3 = function() {
                        var _v4 = practicePulseResult.adu;
                        if (!_v4.$) return _Utils_Tuple2(model, false);
                        else {
                            var filter = _v4.a;
                            var newFilters = function(filters) {
                                return _Utils_update(filters, {
                                    g: _List_fromArray([
                                        filter
                                    ])
                                });
                            }(model.g);
                            return _Utils_Tuple2(_Utils_update(model, {
                                g: newFilters,
                                af_: $author$project$Api$Pagination$reset(model.af_),
                                AD: $author$project$Api$Data$Loading
                            }), true);
                        }
                    }();
                    var newModel = _v3.a;
                    var reloadPatients = _v3.b;
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        W6: $elm$core$Maybe$Just(practicePulseResult.zi)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        reloadPatients ? A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel) : $elm$core$Platform$Cmd$none,
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$PatientsList$PracticePulseMsg, practicePulseResult.EQ)
                    ])), practicePulseResult.at);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var phiMode = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    r5: phiMode
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var patientId = msg.a;
                var url = $elm$url$Url$fromString($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                    V8: patientId
                })));
                var newModel = _Utils_update(model, {
                    V8: $elm$core$Maybe$Just(patientId)
                });
                if (!url.$) {
                    var value = url.a;
                    return _Utils_Tuple3(_Utils_update(newModel, {
                        aaT: value
                    }), $author$project$Components$PatientsList$updateUrl(newModel), _List_Nil);
                } else return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                var date = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    oP: $elm$core$Maybe$Just(date)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                var filters_ = model.g;
                var newFilters = _Utils_update(filters_, {
                    pr: $elm$core$Maybe$Nothing,
                    pu: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Affiliate$reset, filters_.pu),
                    fl: $elm$core$Maybe$Nothing,
                    pY: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Company$reset, filters_.pY),
                    g: _List_Nil,
                    b8: $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$reset(filters_.b8),
                    f0: $elm$core$Maybe$Nothing,
                    Tp: $elm$core$Maybe$Nothing,
                    agd: $elm$core$Maybe$Nothing,
                    jy: A2($elm$core$Maybe$map, $author$project$Components$ResourceFilter$Plan$reset, filters_.jy),
                    Xa: $elm$core$Maybe$Nothing
                });
                var newModel = _Utils_update(model, {
                    g: newFilters
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$PatientsList$fetchPatients, apiClient, newModel),
                    $author$project$Components$PatientsList$updateUrl(newModel)
                ])), _List_Nil);
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    AD: $author$project$Api$Data$Loading
                }), A2($author$project$Components$PatientsList$fetchPatients, apiClient, model), _List_Nil);
        }
    });
    var $author$project$Pages$Patients$Top$update = F2(function(msg, model) {
        if (!msg.$) {
            var patientsListMsg = msg.a;
            var _v1 = A3($author$project$Components$PatientsList$update, model.Ej, patientsListMsg, model.af4);
            var patientsListModel = _v1.a;
            var patientsListCmd = _v1.b;
            var outMsgs = _v1.c;
            return _Utils_Tuple3(_Utils_update(model, {
                af4: patientsListModel
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$PatientsListMsg, patientsListCmd),
                A2($author$project$Utils$PracticeOnboarding$redirectToLastAccountStep, model.Im, model.W1)
            ])), outMsgs);
        } else {
            var subMsg = msg.a;
            var _v2 = A3($author$project$Components$ExportCsv$update, model.Ej, subMsg, model.md);
            var exportCsv = _v2.a;
            var subCmd = _v2.b;
            var subOutMsg = _v2.c;
            return _Utils_Tuple3(_Utils_update(model, {
                md: exportCsv
            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Top$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Components$PracticePulse$ViewNewPatients = {
        $: 1
    };
    var $author$project$Components$PracticePulse$ViewRetailInvoices = {
        $: 3
    };
    var $author$project$Components$PracticePulse$ViewSponsorInvoices = {
        $: 4
    };
    var $author$project$Components$PracticePulse$ViewTerminatedPatients = {
        $: 2
    };
    var $author$project$Api$Provider$Pulse$One$activePatients = function(_v0) {
        var record = _v0;
        return record.Ix;
    };
    var $author$project$Api$Provider$Pulse$One$activePatientsPercentage = function(_v0) {
        var record = _v0;
        return record.Iy;
    };
    var $author$project$Ui$Panel$Info = 2;
    var $author$project$Ui$Panel$info = $author$project$Ui$Panel$Styling(2);
    var $author$project$Api$Provider$Pulse$One$newPatients = function(_v0) {
        var record = _v0;
        return record.US;
    };
    var $author$project$Api$Provider$Pulse$One$newPatientsPercentage = function(_v0) {
        var record = _v0;
        return record.UT;
    };
    var $author$project$Api$Provider$Pulse$One$newTerminations = function(_v0) {
        var record = _v0;
        return record.UW;
    };
    var $author$project$Api$Provider$Pulse$One$newTerminationsPercentage = function(_v0) {
        var record = _v0;
        return record.UX;
    };
    var $author$project$Api$Provider$Pulse$One$patientInvoicesDueInCents = function(_v0) {
        var record = _v0;
        return record.Wa;
    };
    var $author$project$Api$Provider$Pulse$One$patientInvoicesDueInCentsPercentage = function(_v0) {
        var record = _v0;
        return record.Wb;
    };
    var $author$project$Components$PracticePulse$period = 14;
    var $author$project$Components$PracticePulse$periodType = 'day';
    var $author$project$Ui$Element$pt0 = $author$project$Ui$Element$Padding('pt-0');
    var $author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCents = function(_v0) {
        var record = _v0;
        return record._U;
    };
    var $author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCentsPercentage = function(_v0) {
        var record = _v0;
        return record._V;
    };
    var $author$project$Api$Provider$Pulse$One$totalPractitioners = function(_v0) {
        var record = _v0;
        return record.aan;
    };
    var $author$project$Components$PracticePulse$EnableEmailSequence = {
        $: 5
    };
    var $author$project$Components$PracticePulse$SeeCancellationReasons = {
        $: 7
    };
    var $author$project$Components$PracticePulse$StartCourse = {
        $: 8
    };
    var $author$project$Components$PracticePulse$ViewPatientsWithoutEmail = {
        $: 6
    };
    var $author$project$Components$PracticePulse$ViewUpcomingBirthdayPatients = {
        $: 9
    };
    var $author$project$Ui$Icon$Gift = 90;
    var $author$project$Ui$Icon$gift = $author$project$Ui$Icon$viewIcon(90);
    var $author$project$Utils$Html$middleDot = $elm$core$String$fromChar("\xb7");
    var $author$project$Ui$Icon$Task = 84;
    var $author$project$Ui$Icon$task = $author$project$Ui$Icon$viewIcon(84);
    var $author$project$Api$Provider$Pulse$One$upcomingBirthdayPatients = function(_v0) {
        var record = _v0;
        return record.aaM;
    };
    var $author$project$Components$PracticePulse$viewActionPlanRow = F6(function(color, icon, title, description, buttonTitle, msg) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('action-plan-row'),
            $elm$html$Html$Attributes$class(color)
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('action-icon')
            ]), _List_fromArray([
                icon
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('action-main')
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('action-title')
                ]), _List_fromArray([
                    $elm$html$Html$text(title)
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('action-description')
                ]), _List_fromArray([
                    $elm$html$Html$text(description)
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('action-button')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: buttonTitle
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick(msg)
                ]), _List_fromArray([
                    $elm$html$Html$text(buttonTitle)
                ]))
            ]))
        ]));
    });
    var $author$project$Ui$Icon$Wrench = 76;
    var $author$project$Ui$Icon$wrench = $author$project$Ui$Icon$viewIcon(76);
    var $author$project$Components$PracticePulse$viewActionPlan = function(pulse) {
        return _List_fromArray([
            A6($author$project$Components$PracticePulse$viewActionPlanRow, 'green', $author$project$Ui$Icon$wrench(_List_Nil), 'Action ' + ($author$project$Utils$Html$middleDot + ' New Patients'), 'Reach out to schedule first appointments with ' + (A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Api$Provider$Pulse$One$newPatients(pulse)) + (' that joined in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))), 'See patients', $author$project$Components$PracticePulse$ViewNewPatients),
            A6($author$project$Components$PracticePulse$viewActionPlanRow, 'blue', $author$project$Ui$Icon$wrench(_List_Nil), 'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Size'), 'Enable email sequence for people that didn\'t finish enrollment', 'Enable email sequence', $author$project$Components$PracticePulse$EnableEmailSequence),
            A6($author$project$Components$PracticePulse$viewActionPlanRow, 'red', $author$project$Ui$Icon$wrench(_List_Nil), 'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Churn'), 'Add emails to 56 patients missing out on communications', 'See patients', $author$project$Components$PracticePulse$ViewPatientsWithoutEmail),
            A6($author$project$Components$PracticePulse$viewActionPlanRow, 'red', $author$project$Ui$Icon$wrench(_List_Nil), 'Action ' + ($author$project$Utils$Html$middleDot + ' Panel Churn'), 'View cancellation reasons for ' + (A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Api$Provider$Pulse$One$newTerminations(pulse)) + (' patients that terminated in last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))), 'See cancellation reasons', $author$project$Components$PracticePulse$SeeCancellationReasons),
            A6($author$project$Components$PracticePulse$viewActionPlanRow, 'gray', $author$project$Ui$Icon$task(_List_Nil), 'Learning', 'If you want to improve your metrics, check out our DPC Accelerator courses on growth, retention and revenue management', 'Start the course', $author$project$Components$PracticePulse$StartCourse),
            A6($author$project$Components$PracticePulse$viewActionPlanRow, 'gray', $author$project$Ui$Icon$gift(_List_Nil), 'Engagement', 'Wish a happy birthday to ' + (A2($author$project$Formatters$String$pluralize, 'patient', $author$project$Api$Provider$Pulse$One$upcomingBirthdayPatients(pulse)) + (' who have birthdays in the next ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))), 'See patients', $author$project$Components$PracticePulse$ViewUpcomingBirthdayPatients)
        ]);
    };
    var $author$project$Components$InfoCard$view = F8(function(color, title, button, mainNumber, subtitle, description, percentageDisplay, compact) {
        var subtitleElement = function() {
            if (!subtitle.$) {
                var subtitle_ = subtitle.a;
                return A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$italic
                ]), _List_fromArray([
                    $elm$html$Html$text(subtitle_)
                ]));
            } else return $author$project$Utils$Html$empty;
        }();
        var compactClasses = compact ? _List_fromArray([
            $author$project$Ui$Element$m0
        ]) : _List_Nil;
        return A3($author$project$Ui$Element$custom, 'box', compactClasses, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('panel panel--inset m-0'),
                $elm$html$Html$Attributes$class(color + '-panel')
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('panel-heading flex items-center justify-between')
                ]), A2($elm$core$List$cons, $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text(title)
                ])), button)),
                A3($author$project$Ui$Element$custom, 'panel-body', _List_Nil, _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text(mainNumber)
                    ])),
                    subtitleElement,
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$inlineBlock,
                        $author$project$Ui$Element$textMuted,
                        $author$project$Ui$Element$mt2
                    ]), _List_fromArray([
                        $elm$html$Html$text(description)
                    ])),
                    percentageDisplay
                ]))
            ]))
        ]));
    });
    var $author$project$Ui$Icon$Decrease = 82;
    var $author$project$Ui$Icon$decrease = $author$project$Ui$Icon$viewIcon(82);
    var $author$project$Components$PracticePulse$PercentageDisplay$positiveInteger = function(value) {
        return value > 0;
    };
    var $author$project$Components$PracticePulse$PercentageDisplay$goodForPractice = F2(function(value, increaseIsGood) {
        return _Utils_eq(increaseIsGood, $author$project$Components$PracticePulse$PercentageDisplay$positiveInteger(value));
    });
    var $author$project$Ui$Icon$Increase = 83;
    var $author$project$Ui$Icon$increase = $author$project$Ui$Icon$viewIcon(83);
    var $author$project$Components$PracticePulse$PercentageDisplay$view = function(_v0) {
        var value = _v0.aa9;
        var increaseIsGood = _v0.aen;
        var period = _v0.aga;
        var type_ = _v0.ah5;
        if (!value.$) {
            var value_ = value.a;
            var icon = $author$project$Components$PracticePulse$PercentageDisplay$positiveInteger(value_) ? $author$project$Ui$Icon$increase(_List_Nil) : $author$project$Ui$Icon$decrease(_List_Nil);
            var goodOrBadClass = A2($author$project$Components$PracticePulse$PercentageDisplay$goodForPractice, value_, increaseIsGood) ? 'positive' : 'negative';
            return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('box-percentage'),
                    $elm$html$Html$Attributes$class(goodOrBadClass)
                ]), _List_fromArray([
                    icon,
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Formatters$Float$toPercentage(value_))
                ])),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text('Compared to previous '),
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, type_, period))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$PracticePulse$viewBox = F8(function(color, title, button, getMainNumber, getDescription, getPercentage, increaseIsGood, model) {
        var _v0 = model.sn;
        if (_v0.$ === 3) {
            var pulse = _v0.a;
            var percentageDisplay = $author$project$Components$PracticePulse$PercentageDisplay$view({
                aen: increaseIsGood,
                aga: $author$project$Components$PracticePulse$period,
                ah5: $author$project$Components$PracticePulse$periodType,
                aa9: getPercentage(pulse)
            });
            return A8($author$project$Components$InfoCard$view, color, title, button, getMainNumber(pulse), $elm$core$Maybe$Nothing, getDescription(pulse), percentageDisplay, false);
        } else return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('box')
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$card(_List_Nil)
        ]));
    });
    var $author$project$Components$PracticePulse$view = function(model) {
        return A2($author$project$Ui$Panel$view, _List_fromArray([
            $author$project$Ui$Panel$collapsed(false)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$titleSm(_List_fromArray([
                        $elm$html$Html$text('Practice Pulse')
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted,
                        $author$project$Ui$Element$textSm,
                        $author$project$Ui$Element$inlineBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Last '),
                        $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_fromArray([
                $author$project$Ui$Element$pt0
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('box-container')
                ]), _List_fromArray([
                    A8($author$project$Components$PracticePulse$viewBox, 'blue', 'Total Active Patients', _List_Nil, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Pulse$One$activePatients, $elm$core$String$fromInt), function(pulse) {
                        return 'Total across ' + A2($author$project$Formatters$String$pluralize, 'provider', $author$project$Api$Provider$Pulse$One$totalPractitioners(pulse));
                    }, $author$project$Api$Provider$Pulse$One$activePatientsPercentage, true, model),
                    A8($author$project$Components$PracticePulse$viewBox, 'green', 'New Patients', _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'View new patients'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewNewPatients),
                            $author$project$Ui$Button$pull(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('View')
                        ]))
                    ]), function(pulse) {
                        return '+' + $elm$core$String$fromInt($author$project$Api$Provider$Pulse$One$newPatients(pulse));
                    }, function(_v0) {
                        return 'Enrolled in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period);
                    }, $author$project$Api$Provider$Pulse$One$newPatientsPercentage, true, model),
                    A8($author$project$Components$PracticePulse$viewBox, 'red', 'Terminations', _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'View terminations'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewTerminatedPatients),
                            $author$project$Ui$Button$pull(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('View')
                        ]))
                    ]), function(pulse) {
                        return '-' + $elm$core$String$fromInt($author$project$Api$Provider$Pulse$One$newTerminations(pulse));
                    }, function(_v1) {
                        return 'Terminated in the last ' + A2($author$project$Formatters$String$pluralize, $author$project$Components$PracticePulse$periodType, $author$project$Components$PracticePulse$period);
                    }, $author$project$Api$Provider$Pulse$One$newTerminationsPercentage, false, model),
                    A8($author$project$Components$PracticePulse$viewBox, 'yellow', 'Past Due - Retail', _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'View retail past due'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewRetailInvoices),
                            $author$project$Ui$Button$pull(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('View')
                        ]))
                    ]), function(pulse) {
                        return $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Pulse$One$patientInvoicesDueInCents(pulse));
                    }, $elm$core$Basics$always('Patients\' due invoices'), $author$project$Api$Provider$Pulse$One$patientInvoicesDueInCentsPercentage, false, model),
                    A8($author$project$Components$PracticePulse$viewBox, 'yellow', 'Past Due - Sponsor', _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'View sponsor past due'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Components$PracticePulse$ViewSponsorInvoices),
                            $author$project$Ui$Button$pull(1)
                        ]), _List_fromArray([
                            $elm$html$Html$text('View')
                        ]))
                    ]), function(pulse) {
                        return $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCents(pulse));
                    }, $elm$core$Basics$always('Sponsors\' due invoices'), $author$project$Api$Provider$Pulse$One$sponsorInvoicesDueInCentsPercentage, false, model)
                ])),
                A2($author$project$Ui$Panel$view, _List_fromArray([
                    $author$project$Ui$Panel$info,
                    $author$project$Ui$Panel$collapsed(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$titleSm(_List_fromArray([
                            $elm$html$Html$text('Action Plan')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, function() {
                        var _v2 = model.sn;
                        if (_v2.$ === 3) {
                            var pulse = _v2.a;
                            return $author$project$Components$PracticePulse$viewActionPlan(pulse);
                        } else return _List_Nil;
                    }())
                ]))
            ]))
        ]));
    };
    var $author$project$Components$PatientsList$PaginationMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$PatientsList$viewPagination = F2(function(paginationOptions, _v0) {
        var patients = _v0.AD;
        var pagination = _v0.af_;
        return A2($elm$html$Html$map, $author$project$Components$PatientsList$PaginationMsg, A2($author$project$Api$Pagination$view, A2($elm$core$List$cons, $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(patients))), paginationOptions), pagination));
    });
    var $author$project$Components$PatientsList$SortTable = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Table$Md = 2;
    var $author$project$Ui$Table$displayMd = $author$project$Ui$Table$Display(2);
    var $author$project$Ui$Table$hidden = $author$project$Ui$Table$Hidden(0);
    var $author$project$Components$PatientsList$columns = F2(function(mini, practice) {
        var hiddenOnMiniOrSm = function(col) {
            return mini ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($author$project$Api$Column$withOption, $author$project$Ui$Table$displayMd, A2($author$project$Api$Column$withOption, $author$project$Ui$Table$hidden, col)));
        };
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            hiddenOnMiniOrSm(A3($author$project$Api$Column$init, 'last_name', true, 'Patient')),
            hiddenOnMiniOrSm(A3($author$project$Api$Column$init, 'status', false, 'Status')),
            hiddenOnMiniOrSm(A3($author$project$Api$Column$init, 'dob', true, 'Date of Birth')),
            hiddenOnMiniOrSm(A3($author$project$Api$Column$init, 'joined_practice_date', true, 'Joined Practice')),
            hiddenOnMiniOrSm(A3($author$project$Api$Column$init, 'email', true, 'Email')),
            hiddenOnMiniOrSm(A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')),
            $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice) ? hiddenOnMiniOrSm(A3($author$project$Api$Column$init, 'location', true, 'Location')) : $elm$core$Maybe$Nothing,
            hiddenOnMiniOrSm(A3($author$project$Api$Column$init, '', false, A2($author$project$Formatters$String$sponsorize, practice, 'Employer'))),
            hiddenOnMiniOrSm(A3($author$project$Api$Column$init, '', false, 'Plan'))
        ]));
    });
    var $author$project$Ui$Table$active = function(value) {
        return $author$project$Ui$Table$CellActive(value);
    };
    var $author$project$Api$Provider$Patient$All$affiliateSyncStatus = function(_v0) {
        var record = _v0.b;
        return record.IX;
    };
    var $author$project$Ui$Typography$Age = {
        $: 28
    };
    var $author$project$Ui$Typography$age = $author$project$Ui$Typography$Age;
    var $author$project$Ui$Icon$ArrowRightBottom = 63;
    var $author$project$Ui$Icon$arrowRightBottom = $author$project$Ui$Icon$viewIcon(63);
    var $author$project$Api$Provider$Patient$All$dob = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$dob(shared);
    };
    var $author$project$Api$Provider$Patient$All$flaggedNotesCount = function(_v0) {
        var record = _v0.b;
        return record.PR;
    };
    var $author$project$Formatters$Patient$formatAge = F3(function(currentDate, maybeDob, maybeAge) {
        if (!maybeDob.$) {
            var dob = maybeDob.a;
            var ageInMonths = A3($justinmimbs$date$Date$diff, 1, dob, currentDate);
            return ageInMonths < 24 ? $elm$core$String$fromInt(ageInMonths) + 'm' : $elm$core$String$fromInt(ageInMonths / 12 | 0);
        } else {
            if (!maybeAge.$) {
                var ageValue = maybeAge.a;
                return !ageValue ? '0m' : $elm$core$String$fromInt(ageValue);
            } else return '';
        }
    });
    var $author$project$Api$Provider$Patient$All$isAffiliated = function(_v0) {
        var record = _v0.b;
        return record.RQ;
    };
    var $author$project$Api$Provider$Patient$All$isMaster = function(_v0) {
        var record = _v0.b;
        return record.R8;
    };
    var $author$project$Api$Provider$Patient$All$isSynced = function(_v0) {
        var record = _v0.b;
        return record.Su;
    };
    var $author$project$Api$Provider$Patient$All$joinedPracticeDate = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Patient$Shared$joinedPracticeDate(shared);
    };
    var $author$project$Api$Provider$Patient$All$membershipThrough = function(_v0) {
        var record = _v0.b;
        return record.T6;
    };
    var $author$project$Components$PatientsList$membershipStatus = function(patient) {
        return _Utils_ap($author$project$Formatters$String$humanize($author$project$Api$Provider$Patient$All$membershipStatus(patient)), function() {
            var _v0 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
            if (!_v0.$) {
                var membershipThrough = _v0.a;
                return ' through ' + $author$project$Api$Provider$Patient$Min$name(membershipThrough);
            } else return '';
        }());
    };
    var $author$project$Api$Provider$Patient$All$networkSyncStatus = function(_v0) {
        var record = _v0.b;
        return record.UP;
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientAll$plan = function(_v0) {
        var record = _v0;
        return record.GW;
    };
    var $author$project$Components$PatientsList$SelectPatient = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$PatientsList$selectPatient = function(patientId) {
        return $author$project$Components$PatientsList$SelectPatient(patientId);
    };
    var $author$project$Api$Provider$Patient$All$sponsorName = function(_v0) {
        var record = _v0.b;
        return record._W;
    };
    var $author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Components$PatientsList$viewMembershipPatient = F2(function(todaysDate, membershipPatient) {
        var isCurrentMembership = function() {
            if (!todaysDate.$) {
                var today = todaysDate.a;
                return A2($author$project$Utils$Date$isBeforeOrEqual, $author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate(membershipPatient), today);
            } else return true;
        }();
        return A2($author$project$Ui$Typography$div, isCurrentMembership ? _List_Nil : _List_fromArray([
            $author$project$Ui$Typography$small,
            $author$project$Ui$Typography$italic
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Plan$Min$name($author$project$Api$Provider$MembershipPatient$ForPatientAll$plan(membershipPatient))),
            isCurrentMembership ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('on '),
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$MembershipPatient$ForPatientAll$startDate(membershipPatient)))
            ]))
        ]));
    });
    var $author$project$Components$PatientsList$viewPatient = F3(function(mini, model, patient) {
        var responsiveCell = function(cellChildren) {
            return mini ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$hidden,
                $author$project$Ui$Table$displayMd
            ]), cellChildren));
        };
        var practitionerName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$name, $author$project$Api$Provider$Patient$All$practitioner(patient)));
        var id = $author$project$Api$Provider$Patient$All$id(patient);
        return A2($author$project$Ui$Table$row, _List_Nil, A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $elm$core$Maybe$Just(A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$active(_Utils_eq(model.V8, $elm$core$Maybe$Just(id)))
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap
                ]), _List_fromArray([
                    function() {
                        var isClinical = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.W1) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, model.W1);
                        var _v0 = isClinical ? _Utils_Tuple2($author$project$Spa$Generated$Route$Patients__PatientId_String__Chart({
                            V8: id
                        }), _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Components$PatientsList$selectPatient(id))
                        ])) : _Utils_Tuple2($author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                            V8: id
                        }), _List_fromArray([
                            $author$project$Ui$Link$routeParams($author$project$Components$PatientsList$urlParams(model)),
                            $author$project$Ui$Link$onClick($author$project$Components$PatientsList$selectPatient(id))
                        ]));
                        var patientRoute = _v0.a;
                        var linkOptions = _v0.b;
                        return A3($author$project$Ui$Link$route, patientRoute, linkOptions, _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true),
                                $author$project$Ui$Typography$attrs(_List_fromArray([
                                    $elm$html$Html$Attributes$class('mr-2')
                                ]))
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$All$name(patient)),
                                function() {
                                    var _v1 = model.oP;
                                    if (!_v1.$) {
                                        var currentDate = _v1.a;
                                        var ageDisplay = A3($author$project$Formatters$Patient$formatAge, currentDate, $author$project$Api$Provider$Patient$All$dob(patient), $author$project$Api$Provider$Patient$All$age(patient));
                                        return $elm$core$String$isEmpty(ageDisplay) ? $author$project$Utils$Html$empty : A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$age
                                        ]), _List_fromArray([
                                            $elm$html$Html$text(', '),
                                            $elm$html$Html$text(ageDisplay)
                                        ]));
                                    } else {
                                        var _v2 = $author$project$Api$Provider$Patient$All$age(patient);
                                        if (!_v2.$) {
                                            var age = _v2.a;
                                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                                $author$project$Ui$Typography$age
                                            ]), _List_fromArray([
                                                $elm$html$Html$text(', '),
                                                $elm$html$Html$text($elm$core$String$fromInt(age))
                                            ]));
                                        } else return $author$project$Utils$Html$empty;
                                    }
                                }()
                            ]))
                        ]));
                    }(),
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('md:hidden', !mini)
                        ]))
                    ]), _List_fromArray([
                        function() {
                            var _v3 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
                            if (!_v3.$) return A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                $author$project$Ui$Tooltip$placement(0)
                            ]), $author$project$Components$PatientsList$membershipStatus(patient), _List_fromArray([
                                A3($author$project$Ui$Badge$fromStringWithIcon, _List_Nil, $author$project$Api$Provider$Patient$All$membershipStatus(patient), $author$project$Ui$Icon$arrowRightBottom(_List_Nil))
                            ]));
                            else return A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Patient$All$membershipStatus(patient));
                        }()
                    ]))
                ])),
                function() {
                    var _v4 = $author$project$Api$Provider$Patient$All$membershipPatients(patient);
                    if (_v4.b) {
                        var membershipPatient = _v4.a;
                        return A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$classList(_List_fromArray([
                                _Utils_Tuple2('md:hidden', !mini)
                            ]))
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$Plan$Min$name($author$project$Api$Provider$MembershipPatient$ForPatientAll$plan(membershipPatient)))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('text-muted'),
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('md:hidden', !mini)
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text(practitionerName)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2
                ]), $elm$core$List$concat(_List_fromArray([
                    $author$project$Api$Provider$Patient$All$flaggedNotesCount(patient) > 0 ? _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top({
                            V8: $author$project$Api$Provider$Patient$All$id(patient)
                        }), _List_fromArray([
                            $author$project$Ui$Link$routeParams(_List_fromArray([
                                A2($elm$url$Url$Builder$string, 'flagged', '1')
                            ])),
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
                        ]), _List_Nil)
                    ]) : _List_Nil,
                    $author$project$Api$Provider$Patient$All$isMaster(patient) && $author$project$Api$Provider$Patient$All$isAffiliated(patient) ? _List_fromArray([
                        $author$project$Components$SyncedIcon$view(_List_fromArray([
                            $author$project$Components$SyncedIcon$master,
                            $author$project$Components$SyncedIcon$status($author$project$Api$Provider$Patient$All$networkSyncStatus(patient))
                        ]))
                    ]) : _List_Nil,
                    $author$project$Api$Provider$Patient$All$isSynced(patient) && $author$project$Api$Provider$Patient$All$isAffiliated(patient) ? _List_fromArray([
                        $author$project$Components$SyncedIcon$view(_List_fromArray([
                            $author$project$Components$SyncedIcon$synced,
                            $author$project$Components$SyncedIcon$status($author$project$Api$Provider$Patient$All$affiliateSyncStatus(patient))
                        ]))
                    ]) : _List_Nil
                ])))
            ]))),
            responsiveCell(_List_fromArray([
                function() {
                    var _v5 = $author$project$Api$Provider$Patient$All$membershipThrough(patient);
                    if (!_v5.$) return A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$placement(0)
                    ]), $author$project$Components$PatientsList$membershipStatus(patient), _List_fromArray([
                        A3($author$project$Ui$Badge$fromStringWithIcon, _List_Nil, $author$project$Api$Provider$Patient$All$membershipStatus(patient), $author$project$Ui$Icon$arrowRightBottom(_List_Nil))
                    ]));
                    else return A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Patient$All$membershipStatus(patient));
                }()
            ])),
            responsiveCell(_List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Patient$All$dob(patient))))
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('md:hidden', !mini)
                    ]))
                ]), A2($elm$core$List$map, $author$project$Components$PatientsList$viewMembershipPatient(model.oP), $author$project$Api$Provider$Patient$All$membershipPatients(patient)))
            ])),
            responsiveCell(_List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Patient$All$joinedPracticeDate(patient)))),
                $author$project$Utils$Html$noBreakSpace,
                $author$project$Api$Provider$Patient$All$membershipStatus(patient) === 'unconfirmed' ? $elm$html$Html$text('(unconfirmed)') : $author$project$Utils$Html$empty
            ])),
            responsiveCell(_List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$All$email(patient)))
                ]))
            ])),
            responsiveCell(_List_fromArray([
                $elm$html$Html$text(practitionerName)
            ])),
            $author$project$Api$Provider$Practice$One$trackPatientsByLocation(model.W1) ? responsiveCell(_List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$Patient$All$location(patient))))
            ])) : $elm$core$Maybe$Nothing,
            responsiveCell(_List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$All$sponsorName(patient)))
                ]))
            ])),
            responsiveCell(A2($elm$core$List$map, $author$project$Components$PatientsList$viewMembershipPatient(model.oP), $author$project$Api$Provider$Patient$All$membershipPatients(patient)))
        ])));
    });
    var $author$project$Components$PatientsList$viewPatientsTable = F2(function(mini, model) {
        var _v0 = function() {
            var _v1 = model.AD;
            if (_v1.$ === 3) {
                var patients_ = _v1.a;
                return _Utils_Tuple2(false, patients_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var patients = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$verticalCentered,
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('No patients found.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$PatientsList$SortTable)), A2($author$project$Components$PatientsList$columns, mini, model.W1)), A2($elm$core$List$map, A2($author$project$Components$PatientsList$viewPatient, mini, model), patients), _List_Nil);
    });
    var $author$project$Components$PatientsList$ResetFilters = {
        $: 13
    };
    var $author$project$Ui$Grid$Conditional = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Grid$conditional = $author$project$Ui$Grid$Conditional;
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$Multi = 0;
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi = 0;
    var $author$project$Ui$FilterChips$Reset = $elm$core$Basics$identity;
    var $author$project$Ui$FilterChips$reset = $elm$core$Basics$identity;
    var $author$project$Ui$FilterChips$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, acc) {
            var msg = option;
            return _Utils_update(acc, {
                Hf: $elm$core$Maybe$Just(msg)
            });
        }), {
            Hf: $elm$core$Maybe$Nothing
        }, options);
    };
    var $author$project$Ui$FilterChips$view = F2(function(options, activeFilters) {
        if ($elm$core$List$isEmpty(activeFilters)) return $elm$html$Html$text('');
        else {
            var optionsRecord = $author$project$Ui$FilterChips$optionsToRecord(options);
            return A3($author$project$Ui$Element$custom, 'filter-chips', _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('filter-chips__title')
                ]), _List_fromArray([
                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Active filters')
                    ])),
                    A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, function(msg) {
                        return A3($author$project$Ui$Button$view, {
                            abP: 'Reset filters'
                        }, _List_fromArray([
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$cross),
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick(msg)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Reset filters')
                        ]));
                    }, optionsRecord.Hf))
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('filter-chips__wrapper')
                ]), activeFilters)
            ]));
        }
    });
    var $author$project$Components$PatientFilter$viewMultiSelected = function(selected) {
        return A2($elm$core$List$map, function(filter) {
            return A3($author$project$Ui$Button$view, {
                abP: 'Remove selection'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$PatientFilter$FilterSelected_(A2($author$project$Components$PatientFilter$checkedItem, filter, selected))),
                $author$project$Ui$Button$sm,
                $author$project$Ui$Button$mb2
            ]), A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), _List_fromArray([
                $elm$html$Html$text($author$project$Components$PatientFilter$filterToLabel(filter)),
                $author$project$Ui$Icon$cross(_List_fromArray([
                    $author$project$Ui$Icon$xs,
                    $author$project$Ui$Icon$spacedLeft
                ]))
            ])));
        }, selected);
    };
    var $author$project$Components$ResourceFilter$Company$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$ResourceFilter$Location$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$ResourceFilter$LocationGroup$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$ResourceFilter$Practitioner$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected = function(model) {
        return $elm$core$List$concat(_List_fromArray([
            A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(locationGroupResourceFilter) {
                return A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg), $author$project$Components$ResourceFilter$LocationGroup$viewMultiSelected(locationGroupResourceFilter));
            }, model.rn)),
            A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(locationResourceFilter) {
                return A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg), $author$project$Components$ResourceFilter$Location$viewMultiSelected(locationResourceFilter));
            }, model.ro)),
            A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(practitionerResourceFilter) {
                return A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg), $author$project$Components$ResourceFilter$Practitioner$viewMultiSelected(practitionerResourceFilter));
            }, model.jE))
        ]));
    };
    var $author$project$Components$ResourceFilter$Plan$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$ResourceFilter$Affiliate$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$ResourceFilter$LocationGroup$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew = F2(function(options, model) {
        var optionsRecord = A3($elm$core$List$foldl, F2(function(opt, acc) {
            return _Utils_update(acc, {
                zo: true
            });
        }), {
            zo: false
        }, options);
        var multiOption = optionsRecord.zo ? _List_fromArray([
            $author$project$Components$ResourceFilter$multi
        ]) : _List_Nil;
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, function(locationGroupResourceFilter) {
                return A2($elm$html$Html$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg, A2($author$project$Components$ResourceFilter$LocationGroup$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$style(1), multiOption), locationGroupResourceFilter));
            }, model.rn),
            A2($elm$core$Maybe$map, function(locationResourceFilter) {
                return A2($elm$html$Html$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$style(1), multiOption), locationResourceFilter));
            }, model.ro),
            A2($elm$core$Maybe$map, function(practitionerResourceFilter) {
                return A2($elm$html$Html$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$style(1), multiOption), practitionerResourceFilter));
            }, model.jE)
        ]));
    });
    var $author$project$Components$PatientsList$viewSearchAndFilters = F2(function(miniView, model) {
        var filters = model.g;
        var unlessMini = function(option) {
            return $author$project$Ui$Grid$conditional(_Utils_Tuple2(!miniView, option));
        };
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mb2
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$PatientsList$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                        $author$project$Ui$SearchInput$phi(true),
                        $author$project$Ui$SearchInput$placeholder('Search patients by name, email, ID, date of birth, phone number')
                    ]), filters.sG))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Grid$column, _List_fromArray([
                unlessMini($author$project$Ui$Grid$spanMd(2)),
                $author$project$Ui$Grid$span(6)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Components$PatientsList$PatientFilterMsg, A3($author$project$Components$PatientFilter$view, model.W1, filters.g, filters.jq))
            ])), A2($elm$core$List$cons, function() {
                var _v0 = filters.pY;
                if (!_v0.$) {
                    var companyResourceFilter = _v0.a;
                    return A2($author$project$Ui$Grid$column, _List_fromArray([
                        unlessMini($author$project$Ui$Grid$spanMd(2)),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$PatientsList$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$viewNew, _List_fromArray([
                            $author$project$Components$ResourceFilter$style(1),
                            $author$project$Components$ResourceFilter$multi
                        ]), companyResourceFilter))
                    ]));
                } else return $author$project$Ui$Grid$none;
            }(), A2($elm$core$List$cons, function() {
                var _v1 = filters.jy;
                if (!_v1.$) {
                    var planResourceFilter = _v1.a;
                    return A2($author$project$Ui$Grid$column, _List_fromArray([
                        unlessMini($author$project$Ui$Grid$spanMd(2)),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$PatientsList$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$viewNew, _List_fromArray([
                            $author$project$Components$ResourceFilter$style(1),
                            $author$project$Components$ResourceFilter$multi
                        ]), planResourceFilter))
                    ]));
                } else return $author$project$Ui$Grid$none;
            }(), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                $author$project$Ui$Grid$span(6),
                unlessMini($author$project$Ui$Grid$spanMd(2))
            ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
            ]), filters.b8))), _List_fromArray([
                function() {
                    var _v2 = filters.pu;
                    if (!_v2.$) {
                        var affiliateResourceFilter = _v2.a;
                        return A2($author$project$Ui$Grid$column, _List_fromArray([
                            unlessMini($author$project$Ui$Grid$spanMd(2)),
                            $author$project$Ui$Grid$span(6)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$PatientsList$AffiliateResourceFilterMsg, A2($author$project$Components$ResourceFilter$Affiliate$viewNew, _List_fromArray([
                                $author$project$Components$ResourceFilter$style(1)
                            ]), affiliateResourceFilter))
                        ]));
                    } else return $author$project$Ui$Grid$none;
                }()
            ])))))),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, function() {
                    var activeFilters = _Utils_ap(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$ResourceFilter$Plan$viewMultiSelected, $elm$core$List$map($elm$html$Html$map($author$project$Components$PatientsList$PlanResourceFilterMsg))), model.g.jy)), _Utils_ap(A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$ResourceFilter$Company$viewMultiSelected, $elm$core$List$map($elm$html$Html$map($author$project$Components$PatientsList$CompanyResourceFilterMsg))), model.g.pY)), _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$PatientsList$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(filters.b8)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$PatientsList$PatientFilterMsg), $author$project$Components$PatientFilter$viewMultiSelected(model.g.g)))));
                    return _List_fromArray([
                        A2($author$project$Ui$FilterChips$view, _List_fromArray([
                            $author$project$Ui$FilterChips$reset($author$project$Components$PatientsList$ResetFilters)
                        ]), activeFilters)
                    ]);
                }())
            ]))
        ]);
    });
    var $author$project$Components$PatientsList$view = function(model) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('patients-list')
        ]), _List_fromArray([
            function() {
                var _v0 = model.W6;
                if (!_v0.$) {
                    var practicePulse = _v0.a;
                    return A2($elm$html$Html$map, $author$project$Components$PatientsList$PracticePulseMsg, $author$project$Components$PracticePulse$view(practicePulse));
                } else return $author$project$Utils$Html$empty;
            }(),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, A2($author$project$Components$PatientsList$viewSearchAndFilters, false, model)),
                A2($author$project$Components$PatientsList$viewPatientsTable, false, model),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($author$project$Components$PatientsList$viewPagination, _List_Nil, model)
                ]))
            ]))
        ]));
    };
    var $author$project$Ui$Link$Test = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Link$test = $author$project$Ui$Link$Test;
    var $author$project$Pages$Patients$Top$viewActions = _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$hidden,
                $author$project$Ui$Element$flexMd,
                $author$project$Ui$Element$gap4
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Upload, _List_fromArray([
                    $author$project$Ui$Link$icon($author$project$Ui$Icon$upload)
                ]), _List_fromArray([
                    $elm$html$Html$text('Upload from CSV')
                ])),
                A2($elm$html$Html$map, $author$project$Pages$Patients$Top$ExportCsvMsg, $author$project$Components$ExportCsv$link)
            ])),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Charges__New, _List_fromArray([
                $author$project$Ui$Link$buttonSecondary,
                $author$project$Ui$Link$icon($author$project$Ui$Icon$dollarSign),
                $author$project$Ui$Link$test('add-charge')
            ]), _List_fromArray([
                $elm$html$Html$text('Add Charge')
            ])),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Create, _List_fromArray([
                $author$project$Ui$Link$buttonPrimary,
                $author$project$Ui$Link$icon($author$project$Ui$Icon$add)
            ]), _List_fromArray([
                $elm$html$Html$text('Add Patient ')
            ]))
        ]))
    ]);
    var $author$project$Pages$Patients$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$Patients$Top$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, model.Ej, _List_fromArray([
                    $author$project$Components$ExportCsv$path($author$project$Api$Provider$Patient$patientsPath),
                    $author$project$Components$ExportCsv$params(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Patient$listOptionsToParams, $author$project$Components$PatientsList$fetchParams)(model.af4))
                ]), model.md)),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4,
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Patients')
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter
                    ]), $author$project$Pages$Patients$Top$viewActions)
                ])),
                A2($elm$html$Html$map, $author$project$Pages$Patients$Top$PatientsListMsg, $author$project$Components$PatientsList$view(model.af4))
            ]),
            $2: 'Patients'
        };
    };
    var $author$project$Pages$Patients$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Patients$Top$init,
        aeR: $author$project$Pages$Patients$Top$load,
        ag3: $author$project$Pages$Patients$Top$save,
        ahE: $author$project$Pages$Patients$Top$subscriptions,
        aaO: $author$project$Pages$Patients$Top$update,
        aid: $author$project$Pages$Patients$Top$view
    });
    var $author$project$Api$Upload$McePlanResource$McePlan = 0;
    var $author$project$Api$Upload$Resource$Patient = 3;
    var $author$project$Pages$Patients$Upload$Patient = 0;
    var $author$project$Pages$Patients$Upload$UploadFormMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Practice$One$canDeleteAllPatients = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.KH;
    });
    var $author$project$Api$Upload$ClinicalResource$AtlasClinical = 0;
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotClinicalUploadResults = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$ClinicalUploadResult$clinicalUploadsPath = F2(function(clinicalResource, basePath) {
        var resourcePath = function() {
            if (!clinicalResource) return 'atlas';
            else return 'ccda';
        }();
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'emr',
            'file_imports',
            resourcePath
        ]), basePath);
    });
    var $author$project$Api$Provider$ClinicalUploadResult$All$ClinicalUploadResult = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$ClinicalUploadResult = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$Record = F5(function(fileName, status, result, createdAt, id) {
        return {
            Mx: createdAt,
            PF: fileName,
            aef: id,
            YX: result,
            ahy: status
        };
    });
    var $author$project$Api$Provider$ClinicalUploadResult$Data$Data = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ClinicalUploadResult$Data$Record = F2(function(code, message) {
        return {
            Lk: code,
            ae1: message
        };
    });
    var $author$project$Api$Provider$ClinicalUploadResult$Data$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'code', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$core$Maybe$Nothing, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ClinicalUploadResult$Data$Record)));
    var $author$project$Api$Provider$ClinicalUploadResult$Data$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ClinicalUploadResult$Data$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'result', $elm$json$Json$Decode$nullable($author$project$Api$Provider$ClinicalUploadResult$Data$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'file_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ClinicalUploadResult$Shared$Record))))));
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ClinicalUploadResult$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ClinicalUploadResult$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ClinicalUploadResult$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$ClinicalUploadResult$listDefaults = {
        af_: $author$project$Api$Pagination$init
    };
    var $author$project$Api$ClinicalUploadResult$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$ClinicalUploadResult$listDefaults);
        return $author$project$Api$Pagination$toApiParams(options.af_);
    };
    var $author$project$Api$ClinicalUploadResult$list = F4(function(clinicalResource, apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ClinicalUploadResult$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$ClinicalUploadResult$listOptionsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$ClinicalUploadResult$clinicalUploadsPath, clinicalResource, $author$project$Api$Data$providerPath))));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults = F2(function(pagination, apiClient) {
        return A4($author$project$Api$ClinicalUploadResult$list, 0, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination
            });
        }, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotClinicalUploadResults);
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init = F2(function(timeFormatter, apiClient) {
        var newPagination = $author$project$Api$Pagination$init;
        return _Utils_Tuple2({
            Ej: apiClient,
            mL: false,
            af_: newPagination,
            kc: false,
            HO: timeFormatter,
            tA: $elm$core$Maybe$Nothing,
            o8: $author$project$Api$Data$Loading
        }, A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults, newPagination, apiClient));
    });
    var $author$project$Api$Upload$ClinicalResource$CcdaClinical = 1;
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$GotClinicalUploadResults = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults = F2(function(pagination, apiClient) {
        return A4($author$project$Api$ClinicalUploadResult$list, 1, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination
            });
        }, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$GotClinicalUploadResults);
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload = {
        $: 0
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle = {
        $: 0
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$init = {
        ka: false,
        tA: $elm$core$Maybe$Nothing,
        DR: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload,
        kK: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init = {
        bc: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$init,
        gp: _List_Nil,
        kG: $elm$core$Maybe$Nothing,
        DR: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$NewUpload
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init = F2(function(timeFormatter, apiClient) {
        var newPagination = $author$project$Api$Pagination$init;
        return _Utils_Tuple2({
            af_: newPagination,
            nN: $elm$core$Maybe$Nothing,
            HO: timeFormatter,
            DR: $elm$core$Maybe$Nothing,
            hg: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init,
            o8: $author$project$Api$Data$Loading
        }, A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, newPagination, apiClient));
    });
    var $author$project$Api$Upload$McePlanResource$McePlanCreate = 0;
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init = F3(function(timeFormatter, apiClient, mcePlanResource) {
        return _Utils_Tuple2({
            Iq: 0,
            Ej: apiClient,
            TT: mcePlanResource,
            kc: false,
            HO: timeFormatter,
            tA: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$Upload$init = F4(function(_v0, practice, shared, _v1) {
        var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
        var _v2 = A4($author$project$Components$Upload$Form$init, shared.HO, shared.Ej, 3, $elm$core$Maybe$Nothing);
        var uploadForm = _v2.a;
        var uploadFormCmd = _v2.b;
        var _v3 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init, shared.HO, shared.Ej, 0);
        var mcePlanUploadForm = _v3.a;
        var _v4 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init, shared.HO, shared.Ej);
        var ccdaClinicalUploadForm = _v4.a;
        var _v5 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init, shared.HO, shared.Ej);
        var atlasClinicalUploadForm = _v5.a;
        return _Utils_Tuple2({
            vr: $author$project$Api$Provider$Practice$One$canDeleteAllPatients(practice),
            Ej: shared.Ej,
            e6: atlasClinicalUploadForm,
            fh: ccdaClinicalUploadForm,
            dB: $elm$core$Maybe$Nothing,
            ib: false,
            F3: isHintAdmin,
            TT: $elm$core$Maybe$Nothing,
            f8: mcePlanUploadForm,
            W1: practice,
            Hg: $elm$core$Maybe$Just(0),
            HO: shared.HO,
            hd: uploadForm
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, uploadFormCmd));
    });
    var $author$project$Pages$Patients$Upload$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Patients$Upload$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Patients$Upload$HiConfirmClosed = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Patients$Upload$McePlanUploadFormMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal = {
        $: 2
    };
    var $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress = function(onClose) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(onClose);
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$subscriptions = function(model) {
        return model.kc ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ReceivedFilePath = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ports$FilePaths$receiveFilePath = _Platform_incomingPort('receiveFilePath', A2($elm$json$Json$Decode$andThen, function(_v0) {
        return A2($elm$json$Json$Decode$andThen, function(_v1) {
            return A2($elm$json$Json$Decode$andThen, function(_v2) {
                return $elm$json$Json$Decode$succeed(_Utils_Tuple3(_v0, _v1, _v2));
            }, A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$int));
        }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
    }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$subscriptions = function(model) {
        return model.ka ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$subscriptions(model.bc)),
            $author$project$Ports$FilePaths$receiveFilePath($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ReceivedFilePath)
        ]));
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$subscriptions(model.hg));
    };
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal = {
        $: 2
    };
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$subscriptions = function(model) {
        return model.kc ? $author$project$Components$Admin$Uploads$UploadModal$subscribeToEscapeKeyPress($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Patients$Upload$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$Upload$UploadFormMsg, $author$project$Components$Upload$Form$subscriptions(model.hd)),
            model.ib ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$Patients$Upload$HiConfirmClosed) : $elm$core$Platform$Sub$none,
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$subscriptions(model.e6)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$subscriptions(model.fh)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$subscriptions(model.f8))
        ]));
    };
    var $author$project$Api$Upload$Resource$Charge = 4;
    var $author$project$Pages$Patients$Upload$GotPatientDestroyAll = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Upload$Resource$PatientNote = 7;
    var $author$project$Api$Provider$Patient$destroyAll = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Patient$patientsPath));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotResponse = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$ClinicalUploadResult$createAtlas = F3(function(apiClient, files, toMsg) {
        var filesPart = A2($elm$core$List$map, function(file) {
            return A2($elm$http$Http$filePart, 'files[]', file);
        }, files);
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestMultipartBody, filesPart, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'emr',
            'file_imports',
            'atlas'
        ]), $author$project$Api$Data$providerPath))));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var files = msg.a;
                return $elm$core$List$isEmpty(files) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    mL: true
                }), A3($author$project$Api$ClinicalUploadResult$createAtlas, apiClient, files, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$GotResponse), _List_Nil);
            case 1:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            mL: false,
                            kc: true,
                            tA: $elm$core$Maybe$Nothing
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            mL: false,
                            kc: true,
                            tA: $elm$core$Maybe$Just($author$project$Api$Data$errorToString(error))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    kc: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        o8: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    o8: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    o8: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$fetchClinicalUploadResults, pagination, newModel.Ej), _List_Nil);
        }
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$AddToExisting = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$NewUpload = {
        $: 0
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUploadResponse = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$initForExistingUpload = function(uploadId) {
        return {
            ka: false,
            tA: $elm$core$Maybe$Nothing,
            DR: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting(uploadId),
            kK: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$initForExistingUpload = function(uploadId) {
        return {
            bc: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$initForExistingUpload(uploadId),
            gp: _List_Nil,
            kG: $elm$core$Maybe$Nothing,
            DR: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$AddToExisting(uploadId)
        };
    };
    var $author$project$Api$ClinicalUploadResult$processUpload = F4(function(clinicalResource, apiClient, uploadId, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $elm$json$Json$Encode$object(_List_Nil), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            uploadId,
            'process_upload'
        ]), A2($author$project$Api$ClinicalUploadResult$clinicalUploadsPath, clinicalResource, $author$project$Api$Data$providerPath)))));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal = F2(function(f, model) {
        return f(model);
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal = function(model) {
        return _Utils_update(model, {
            bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal, function(m) {
                return _Utils_update(m, {
                    ka: true
                });
            }, model.bc)
        });
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadCreated = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish = F2(function(toMsg, proc) {
        var _v0 = proc.ss;
        if (_v0.b) {
            var next = _v0.a;
            return A2($elm$core$Task$perform, function(_v1) {
                return A2(toMsg, proc.H_, next);
            }, $elm$core$Task$succeed(0));
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Api$Provider$ClinicalUploadResult$One$ClinicalUploadResult = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ClinicalUploadResult$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ClinicalUploadResult$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$ClinicalUploadResult$createCcda = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$ClinicalUploadResult$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $elm$json$Json$Encode$object(_List_Nil), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'emr',
            'file_imports',
            'ccda'
        ]), $author$project$Api$Data$providerPath))));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates = F2(function(uploadId, candidates) {
        return {
            xF: _List_Nil,
            ss: candidates,
            tt: $elm$core$List$length(candidates),
            H_: uploadId,
            aaQ: 0
        };
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState = F2(function(state, model) {
        return _Utils_update(model, {
            ka: true,
            tA: $elm$core$Maybe$Nothing,
            kK: state
        });
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onCreateUpload = F3(function(apiClient, candidates, model) {
        if ($elm$core$List$isEmpty(candidates)) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        else {
            var _v0 = model.DR;
            if (_v0.$ === 1) {
                var uploadId = _v0.a;
                var uploadProcess = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates, uploadId, candidates);
                var nextCmd = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, uploadProcess);
                return _Utils_Tuple3(_Utils_update(model, {
                    bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(uploadProcess), model.bc)
                }), nextCmd, _List_Nil);
            } else return _Utils_Tuple3(_Utils_update(model, {
                bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload, 0, $elm$core$List$length(candidates)), model.bc)
            }), A2($author$project$Api$ClinicalUploadResult$createCcda, apiClient, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadCreated(candidates)), _List_Nil);
        }
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$CreateUpload = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilePath = F2(function(_v0, model) {
        var filename = _v0.a;
        var relativePath = _v0.b;
        var size = _v0.c;
        var _v1 = model.kG;
        if (!_v1.$) {
            var candidates = _v1.a;
            var updateFirstMatch = function(candidateList) {
                if (!candidateList.b) return _List_Nil;
                else {
                    var first = candidateList.a;
                    var rest = candidateList.b;
                    return _Utils_eq($elm$file$File$name(first.adN), filename) && _Utils_eq($elm$file$File$size(first.adN), size) && _Utils_eq(first.V6, $elm$core$Maybe$Nothing) ? A2($elm$core$List$cons, _Utils_update(first, {
                        V6: $elm$core$Maybe$Just(relativePath)
                    }), rest) : A2($elm$core$List$cons, first, updateFirstMatch(rest));
                }
            };
            var updatedCandidates = updateFirstMatch(candidates);
            var totalCount = $elm$core$List$length(updatedCandidates);
            var processedCount = $elm$core$List$length(A2($elm$core$List$filter, A2($elm$core$Basics$composeR, function($) {
                return $.V6;
            }, $elm$core$Basics$neq($elm$core$Maybe$Nothing)), updatedCandidates));
            var updatedModal = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload, processedCount, totalCount), model.bc);
            var allPathsResolved = A2($elm$core$List$all, A2($elm$core$Basics$composeR, function($) {
                return $.V6;
            }, $elm$core$Basics$neq($elm$core$Maybe$Nothing)), updatedCandidates);
            var shouldTriggerCreate = allPathsResolved && !A2($elm$core$List$all, A2($elm$core$Basics$composeR, function($) {
                return $.V6;
            }, $elm$core$Basics$neq($elm$core$Maybe$Nothing)), candidates);
            return _Utils_Tuple3(_Utils_update(model, {
                bc: updatedModal,
                kG: $elm$core$Maybe$Just(updatedCandidates)
            }), shouldTriggerCreate ? A2($elm$core$Task$perform, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$CreateUpload, $elm$core$Task$succeed(updatedCandidates)) : $elm$core$Platform$Cmd$none, _List_Nil);
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState = function(process) {
        return $elm$core$List$isEmpty(process.ss) ? _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete({
            xE: A2($elm$core$List$map, function(file) {
                return _Utils_Tuple3(file.zr, file.V6, file.xy);
            }, process.xF),
            aal: process.tt
        })) : _Utils_Tuple2(A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, process), $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(process));
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step = F2(function(proc, result) {
        var newRemaining = function() {
            var _v1 = proc.ss;
            if (!_v1.b) return _List_Nil;
            else {
                var rest = _v1.b;
                return rest;
            }
        }();
        var newFailures = function() {
            if (result.$ === 1) {
                var failedFile = result.a;
                return _Utils_ap(proc.xF, _List_fromArray([
                    failedFile
                ]));
            } else return proc.xF;
        }();
        return _Utils_update(proc, {
            xF: newFailures,
            ss: newRemaining,
            aaQ: proc.aaQ + 1
        });
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFileUploadResponse = F4(function(_v0, candidate, response, model) {
        var _v1 = _Utils_Tuple2(model.bc.kK, response);
        _v1$2: while(true){
            if (_v1.a.$ === 2) switch(_v1.b.$){
                case 3:
                    var process = _v1.a.a;
                    var _v2 = _v1.b;
                    var updatedProcess = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step, process, $elm$core$Result$Ok(0));
                    var _v3 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
                    var nextCmd = _v3.a;
                    var newState = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.bc)
                    }), nextCmd, _List_Nil);
                case 2:
                    var process = _v1.a.a;
                    var error = _v1.b.a;
                    if (error.$ === 10) {
                        var updatedProcess = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step, process, $elm$core$Result$Ok(0));
                        var _v5 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
                        var nextCmd = _v5.a;
                        var newState = _v5.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.bc)
                        }), nextCmd, _List_Nil);
                    } else {
                        var failedFile = {
                            xy: $author$project$Api$Data$errorToString(error),
                            zr: $elm$file$File$name(candidate.adN),
                            V6: A2($elm$core$Maybe$withDefault, '', candidate.V6)
                        };
                        var updatedProcess = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$step, process, $elm$core$Result$Err(failedFile));
                        var _v6 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$nextCmdAndState(updatedProcess);
                        var nextCmd = _v6.a;
                        var newState = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, newState, model.bc)
                        }), nextCmd, _List_Nil);
                    }
                default:
                    break _v1$2;
            }
            else break _v1$2;
        }
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch = {
        $: 7
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$isXmlFile = function(file) {
        return A2($elm$core$String$endsWith, '.xml', $elm$file$File$name(file)) && !A2($elm$core$String$startsWith, '.', $elm$file$File$name(file));
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilesSelected = F2(function(rawFiles, model) {
        var _v0 = model.bc.kK;
        if (_v0.$ === 3) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        else {
            var candidates = A2($elm$core$List$map, function(f) {
                return {
                    adN: f,
                    V6: $elm$core$Maybe$Nothing
                };
            }, A2($elm$core$List$filter, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$isXmlFile, rawFiles));
            return _Utils_Tuple3(_Utils_update(model, {
                bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CreatingUpload, 0, $elm$core$List$length(candidates)), model.bc),
                gp: candidates,
                kG: $elm$core$Maybe$Just(candidates)
            }), A2($elm$core$Task$perform, $elm$core$Basics$identity, $elm$core$Task$succeed($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch)), _List_Nil);
        }
    });
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$ClinicalUploadResult$One$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ClinicalUploadResult$Shared$id(shared);
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadCreated = F4(function(_v0, candidates, response, model) {
        switch(response.$){
            case 3:
                var uploadData = response.a;
                var uploadProcess = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$initWithCandidates, $author$project$Api$Provider$ClinicalUploadResult$One$id(uploadData), candidates);
                var nextCmd = A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadRunner$continueOrFinish, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$UploadFile, uploadProcess);
                return _Utils_Tuple3(_Utils_update(model, {
                    bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Uploading(uploadProcess), model.bc)
                }), nextCmd, _List_Nil);
            case 2:
                var error = response.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    bc: A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal, function(m) {
                        return _Utils_update(m, {
                            ka: true,
                            tA: $elm$core$Maybe$Just($author$project$Api$Data$errorToString(error)),
                            kK: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle
                        });
                    }, model.bc)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploadResponse = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Api$ClinicalUploadResult$uploadCcdaFile = F5(function(apiClient, uploadId, file, maybeRelativePath, toMsg) {
        var filePart = A2($elm$http$Http$filePart, 'file', file);
        var parts = function() {
            if (!maybeRelativePath.$) {
                var relativePath = maybeRelativePath.a;
                return _List_fromArray([
                    filePart,
                    A2($elm$http$Http$stringPart, 'relative_path', relativePath)
                ]);
            } else return _List_fromArray([
                filePart
            ]);
        }();
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestMultipartBody, parts, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'emr',
            'file_imports',
            'ccda',
            uploadId,
            'upload_file'
        ]), $author$project$Api$Data$providerPath))));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadFile = F4(function(apiClient, uploadId, candidate, model) {
        return _Utils_Tuple3(model, A5($author$project$Api$ClinicalUploadResult$uploadCcdaFile, apiClient, uploadId, candidate.adN, candidate.V6, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploadResponse(candidate)), _List_Nil);
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize = 20;
    var $author$project$Ports$FilePaths$getFilePath = _Platform_outgoingPort('getFilePath', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('name', $elm$json$Json$Encode$string($.zr)),
            _Utils_Tuple2('size', $elm$json$Json$Encode$int($.ahq))
        ]));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$processNextBatch = function(model) {
        var _v0 = function(batch) {
            return _Utils_Tuple2(batch, A2($elm$core$List$drop, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize, model.gp));
        }(A2($elm$core$List$take, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$fileProcessingBatchSize, model.gp));
        var currentBatch = _v0.a;
        var remainingCandidates = _v0.b;
        var batchCommands = A2($elm$core$List$map, function(candidate) {
            return $author$project$Ports$FilePaths$getFilePath({
                zr: $elm$file$File$name(candidate.adN),
                ahq: $elm$file$File$size(candidate.adN)
            });
        }, currentBatch);
        var hasMoreBatches = !$elm$core$List$isEmpty(remainingCandidates);
        var nextBatchCmd = hasMoreBatches ? A2($elm$core$Task$perform, $elm$core$Basics$identity, $elm$core$Task$succeed($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ProcessNextBatch)) : $elm$core$Platform$Cmd$none;
        return _Utils_Tuple3(_Utils_update(model, {
            gp: remainingCandidates
        }), $elm$core$Platform$Cmd$batch(_Utils_ap(batchCommands, _List_fromArray([
            nextBatchCmd
        ]))), _List_Nil);
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploaded = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$update = F3(function(config, msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    ka: false,
                    tA: $elm$core$Maybe$Nothing,
                    kK: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$Idle
                }), $elm$core$Platform$Cmd$none, config.rK(_List_Nil));
            case 1:
                var _v1 = model.kK;
                if (_v1.$ === 2) {
                    var process = _v1.a;
                    return _Utils_Tuple3(A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$withModal, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$setUploadState($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$UploadingComplete({
                        xE: A2($elm$core$List$cons, _Utils_Tuple3('Upload canceled', '', 'The upload was canceled by the user. ' + ($elm$core$String$fromInt(process.aaQ) + (' of ' + ($elm$core$String$fromInt(process.tt) + (' files were uploaded successfully' + ($elm$core$List$length(process.xF) > 0 ? ', ' + ($elm$core$String$fromInt($elm$core$List$length(process.xF)) + ' failed.') : '.')))))), A2($elm$core$List$map, function(f) {
                            return _Utils_Tuple3(f.zr, f.V6, f.xy);
                        }, process.xF)),
                        aal: process.tt
                    })), model), $elm$core$Platform$Cmd$none, config.rK(_List_Nil));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, config.rK(_List_Nil));
            default:
                var files = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, config.rK(files));
        }
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$updateModal = F3(function(_v0, modalMsg, model) {
        var config = {
            rK: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$FileUploaded
        };
        var _v1 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$update, config, modalMsg, model.bc);
        var newModal = _v1.a;
        var cmd = _v1.b;
        var parentMsg = _v1.c;
        switch(modalMsg.$){
            case 0:
                return _Utils_Tuple3(_Utils_update(model, {
                    bc: newModal,
                    gp: _List_Nil,
                    kG: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    bc: newModal
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    bc: newModal
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg, cmd),
                    A2($elm$core$Task$perform, $elm$core$Basics$identity, $elm$core$Task$succeed(parentMsg))
                ])), _List_Nil);
        }
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$update = F3(function(api, msg, model) {
        switch(msg.$){
            case 5:
                var mm = msg.a;
                return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$updateModal, api, mm, model);
            case 0:
                var files = msg.a;
                return A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilesSelected, files, model);
            case 1:
                var candidates = msg.a;
                return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onCreateUpload, api, candidates, model);
            case 2:
                var candidates = msg.a;
                var resp = msg.b;
                return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadCreated, api, candidates, resp, model);
            case 3:
                var id = msg.a;
                var candidate = msg.b;
                return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onUploadFile, api, id, candidate, model);
            case 4:
                var candidate = msg.a;
                var rsp = msg.b;
                return A4($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFileUploadResponse, api, candidate, rsp, model);
            case 6:
                var _v1 = msg.a;
                var filename = _v1.a;
                var relativePath = _v1.b;
                var size = _v1.c;
                return A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$onFilePath, _Utils_Tuple3(filename, relativePath, size), model);
            default:
                return $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$processNextBatch(model);
        }
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$uploadState = function(model) {
        return model.bc.kK;
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        o8: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    o8: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 0:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    o8: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, pagination, apiClient), _List_Nil);
            case 1:
                var uploadId = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    nN: $elm$core$Maybe$Just(uploadId)
                }), A4($author$project$Api$ClinicalUploadResult$processUpload, 1, apiClient, uploadId, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUploadResponse), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Processing started for the upload.')
                ]));
            case 2:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            nN: $elm$core$Maybe$Nothing
                        }), A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.af_, apiClient), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Processing completed successfully.')
                        ]));
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            nN: $elm$core$Maybe$Nothing
                        }), A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.af_, apiClient), _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 1, 'Processing failed: ' + $author$project$Api$Data$errorToString(error))
                        ]));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var uploadId = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    DR: $elm$core$Maybe$Just($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$AddToExisting(uploadId)),
                    hg: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$initForExistingUpload(uploadId))
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    DR: $elm$core$Maybe$Just($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$NewUpload),
                    hg: $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$showModal($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$init)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var uploaderMsg = msg.a;
                var _v3 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$update, apiClient, uploaderMsg, model.hg);
                var newUploader = _v3.a;
                var cmd = _v3.b;
                var outMsgs = _v3.c;
                var refreshCmd = function() {
                    var _v4 = $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$uploadState(newUploader);
                    if (_v4.$ === 3) return A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$fetchClinicalUploadResults, model.af_, apiClient);
                    else return $elm$core$Platform$Cmd$none;
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    hg: newUploader
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg, cmd),
                    refreshCmd
                ])), outMsgs);
        }
    });
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$McePlanUpload$mcePlanUploadsPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'mce_plan_upload'
        ]), basePath);
    };
    var $author$project$Api$McePlanUpload$create = F3(function(apiClient, file, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A3($author$project$Api$Data$requestWithFile, 'file', file, $author$project$Api$Data$requestTo($author$project$Api$McePlanUpload$mcePlanUploadsPath($author$project$Api$Data$providerPath))));
    });
    var $author$project$Api$McePlanUpload$update = F3(function(apiClient, file, toMsg) {
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A3($author$project$Api$Data$requestWithFile, 'file', file, $author$project$Api$Data$requestTo($author$project$Api$McePlanUpload$mcePlanUploadsPath($author$project$Api$Data$providerPath))));
    });
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var files = msg.a;
                return $elm$core$List$isEmpty(files) ? _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil) : _Utils_Tuple3(model, function() {
                    var _v1 = $elm$core$List$head(files);
                    if (!_v1.$) {
                        var file = _v1.a;
                        var _v2 = model.Iq;
                        if (!_v2) return A3($author$project$Api$McePlanUpload$create, apiClient, file, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse);
                        else return A3($author$project$Api$McePlanUpload$update, apiClient, file, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$GotResponse);
                    } else return $elm$core$Platform$Cmd$none;
                }(), _List_Nil);
            case 1:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            kc: true,
                            tA: $elm$core$Maybe$Nothing
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            kc: true,
                            tA: $elm$core$Maybe$Just($author$project$Api$Data$errorToString(error))
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    kc: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var actionType = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Iq: actionType
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Patients$Upload$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var resource = msg.a;
                var uploadResource = function() {
                    switch(resource){
                        case 0:
                            return 3;
                        case 1:
                            return 5;
                        case 2:
                            return 4;
                        default:
                            return 7;
                    }
                }();
                var _v1 = A4($author$project$Components$Upload$Form$init, model.HO, model.Ej, uploadResource, $elm$core$Maybe$Nothing);
                var uploadForm = _v1.a;
                var uploadFormCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    dB: $elm$core$Maybe$Nothing,
                    TT: $elm$core$Maybe$Nothing,
                    Hg: $elm$core$Maybe$Just(resource),
                    hd: uploadForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, uploadFormCmd), _List_Nil);
            case 1:
                var clinicalResource = msg.a;
                if (!clinicalResource) {
                    var _v4 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$init, model.HO, model.Ej);
                    var atlasClinicalUploadForm = _v4.a;
                    var atlasClinicalUploadFormCmd = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        e6: atlasClinicalUploadForm,
                        dB: $elm$core$Maybe$Just(clinicalResource),
                        TT: $elm$core$Maybe$Nothing,
                        Hg: $elm$core$Maybe$Nothing
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, atlasClinicalUploadFormCmd), _List_Nil);
                } else {
                    var _v5 = A2($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$init, model.HO, model.Ej);
                    var ccdaClinicalUploadForm = _v5.a;
                    var ccdaClinicalUploadFormCmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fh: ccdaClinicalUploadForm,
                        dB: $elm$core$Maybe$Just(clinicalResource),
                        TT: $elm$core$Maybe$Nothing,
                        Hg: $elm$core$Maybe$Nothing
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, ccdaClinicalUploadFormCmd), _List_Nil);
                }
            case 8:
                var mcePlanResource = msg.a;
                var uploadResource = 0;
                var _v6 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$init, model.HO, model.Ej, uploadResource);
                var mcePlanUploadForm = _v6.a;
                var mcePlanUploadCmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    dB: $elm$core$Maybe$Nothing,
                    TT: $elm$core$Maybe$Just(mcePlanResource),
                    f8: mcePlanUploadForm,
                    Hg: $elm$core$Maybe$Nothing
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, mcePlanUploadCmd), _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v7 = A3($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$update, model.Ej, subMsg, model.f8);
                var mcePlanUploadForm = _v7.a;
                var subCmd = _v7.b;
                var subOutMsgs = _v7.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    f8: mcePlanUploadForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, subCmd), subOutMsgs);
            case 2:
                return _Utils_Tuple3(_Utils_update(model, {
                    ib: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    ib: false
                }), A2($author$project$Api$Provider$Patient$destroyAll, model.Ej, $author$project$Pages$Patients$Upload$GotPatientDestroyAll), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    ib: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    vr: false
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Patients were successfully removed.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var subMsg = msg.a;
                var _v9 = A3($author$project$Components$Upload$Form$update, model.Ej, subMsg, model.hd);
                var uploadForm = _v9.a;
                var subCmd = _v9.b;
                var subOutMsgs = _v9.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    hd: uploadForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$UploadFormMsg, subCmd), subOutMsgs);
            case 6:
                var subMsg = msg.a;
                var _v10 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$update, model.Ej, subMsg, model.e6);
                var atlasClinicalUploadForm = _v10.a;
                var subCmd = _v10.b;
                var subOutMsgs = _v10.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    e6: atlasClinicalUploadForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, subCmd), subOutMsgs);
            default:
                var subMsg = msg.a;
                var _v11 = A3($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$update, model.Ej, subMsg, model.fh);
                var ccdaClinicalUploadForm = _v11.a;
                var subCmd = _v11.b;
                var subOutMsgs = _v11.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    fh: ccdaClinicalUploadForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, subCmd), subOutMsgs);
        }
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$uploadingModal = A3($author$project$Ui$Modal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal, _List_fromArray([
        $author$project$Ui$Modal$size(2)
    ]), _List_fromArray([
        $author$project$Ui$Modal$header(_List_Nil),
        $author$project$Ui$Modal$body(_List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('text-center')
            ]), _List_fromArray([
                $author$project$Ui$Spinner$view(_List_Nil),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mt-3')
                ]), _List_fromArray([
                    $elm$html$Html$text('Uploading files, please wait...')
                ]))
            ]))
        ]))
    ]));
    var $author$project$Components$Admin$Uploads$UploadModal$viewModalBody = F2(function(isError, message) {
        return isError ? _List_fromArray([
            A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                $elm$html$Html$text(message)
            ]))
        ]) : _List_fromArray([
            A2($author$project$Ui$Alert$success, _List_Nil, _List_fromArray([
                $elm$html$Html$text(message)
            ]))
        ]);
    });
    var $author$project$Components$Admin$Uploads$UploadModal$view = F3(function(onClose, isError, message) {
        return A3($author$project$Ui$Modal$view, onClose, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_Nil),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('text-center')
                ]), A2($author$project$Components$Admin$Uploads$UploadModal$viewModalBody, isError, message))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$modal = function(model) {
        if (model.mL) return $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$uploadingModal;
        else {
            var _v0 = _Utils_Tuple2(model.kc, model.tA);
            if (_v0.a) {
                if (!_v0.b.$) {
                    var errorMessage = _v0.b.a;
                    return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal, true, errorMessage);
                } else {
                    var _v1 = _v0.b;
                    return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$UploadModal, false, 'Your files were uploaded successfully.');
                }
            } else return $author$project$Utils$Html$empty;
        }
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FileSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$File$Xml = 5;
    var $author$project$Ui$Form$File$Directory = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Form$File$directory = $author$project$Ui$Form$File$Directory;
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FailedFile = F3(function(name, path, error) {
        return {
            xy: error,
            zr: name,
            V6: path
        };
    });
    var $author$project$Ui$Element$mb3 = $author$project$Ui$Element$Margin('mb-3');
    var $author$project$Ui$Table$Bordered = {
        $: 1
    };
    var $author$project$Ui$Table$bordered = $author$project$Ui$Table$Bordered;
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFailures = function(failedFiles) {
        var hasFailedFiles = !$elm$core$List$isEmpty(failedFiles);
        return hasFailedFiles ? A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mt4,
            $author$project$Ui$Element$textLeft
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Failed files:')
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('table-wrapper overflow-y-auto max-h-[400px]')
            ]), _List_fromArray([
                A4($author$project$Ui$Table$view, _List_fromArray([
                    $author$project$Ui$Table$bordered,
                    $author$project$Ui$Table$containerClasses(_List_fromArray([
                        'table-wrapper',
                        'overflow-y-auto',
                        'max-h-[400px]'
                    ]))
                ]), _List_fromArray([
                    A2($author$project$Api$Column$view, $author$project$Api$Column$NonSortable, A3($author$project$Api$Column$init, 'filename', true, 'File Name')),
                    A2($author$project$Api$Column$view, $author$project$Api$Column$NonSortable, A3($author$project$Api$Column$init, 'path', true, 'Path')),
                    A2($author$project$Api$Column$view, $author$project$Api$Column$NonSortable, A3($author$project$Api$Column$init, 'error', true, 'Error Message'))
                ]), A2($elm$core$List$map, function(_v0) {
                    var name = _v0.zr;
                    var path = _v0.V6;
                    var error = _v0.xy;
                    return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$bold,
                                $author$project$Ui$Typography$danger
                            ]), _List_fromArray([
                                $elm$html$Html$text(name)
                            ]))
                        ])),
                        A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                            $elm$core$String$isEmpty(path) ? $elm$html$Html$text('-') : $elm$html$Html$text(path)
                        ])),
                        A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_fromArray([
                                $author$project$Ui$Typography$danger
                            ]), _List_fromArray([
                                $elm$html$Html$text(error)
                            ]))
                        ]))
                    ]));
                }, failedFiles), _List_Nil)
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mt2
            ]), _List_fromArray([
                $elm$html$Html$text('Note: Failed files will be skipped, but the upload process will continue.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CancelUpload = {
        $: 1
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFooter = function(_v0) {
        var allowCancel = _v0.I7;
        var hasFailures = _v0.Qp;
        var finished = _v0.PJ;
        return allowCancel ? _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Cancel upload'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CancelUpload),
                $author$project$Ui$Button$danger
            ]), _List_fromArray([
                $elm$html$Html$text('Cancel Upload')
            ]))
        ]) : hasFailures || finished ? _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Cancel and close modal'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal),
                $author$project$Ui$Button$primary
            ]), _List_fromArray([
                $elm$html$Html$text('Close')
            ]))
        ]) : _List_Nil;
    };
    var $author$project$Ui$ProgressBar$Animated = {
        $: 1
    };
    var $author$project$Ui$ProgressBar$animated = $author$project$Ui$ProgressBar$Animated;
    var $author$project$Ui$ProgressBar$ShowProgress = {
        $: 6
    };
    var $author$project$Ui$ProgressBar$showProgress = $author$project$Ui$ProgressBar$ShowProgress;
    var $author$project$Ui$ProgressBar$Striped = {
        $: 0
    };
    var $author$project$Ui$ProgressBar$striped = $author$project$Ui$ProgressBar$Striped;
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewProgress = F2(function(current, total) {
        if (total > 0) {
            var progress = current * 100 / total | 0;
            var displayCount = progress >= 100 ? total : current;
            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt2,
                    $author$project$Ui$Element$mb3
                ]), _List_fromArray([
                    $author$project$Ui$ProgressBar$view(_List_fromArray([
                        $author$project$Ui$ProgressBar$striped,
                        $author$project$Ui$ProgressBar$animated,
                        $author$project$Ui$ProgressBar$width(progress),
                        $author$project$Ui$ProgressBar$showProgress
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt2,
                    $author$project$Ui$Element$mb3
                ]), _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt(displayCount) + (' of ' + ($elm$core$String$fromInt(total) + ' XML files')))
                ]))
            ]));
        } else return $author$project$Ui$Spinner$view(_List_Nil);
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal = F5(function(message, current, total, failedFiles, allowCancel) {
        var progress = !total ? 0 : current * 100 / total | 0;
        var failedCount = $elm$core$List$length(failedFiles);
        var config = {
            MJ: current,
            xE: A2($elm$core$List$map, function(_v0) {
                var name = _v0.a;
                var path = _v0.b;
                var error = _v0.c;
                return A3($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FailedFile, name, path, error);
            }, failedFiles),
            adV: {
                I7: allowCancel,
                PJ: progress >= 100,
                Qp: failedCount > 0
            },
            ae1: message,
            tt: total
        };
        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal, _List_fromArray([
            $author$project$Ui$Modal$size(2)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_Nil),
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('text-center')
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb3
                    ]), _List_fromArray([
                        $elm$html$Html$text(config.ae1)
                    ])),
                    A2($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewProgress, config.MJ, config.tt),
                    $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFailures(config.xE)
                ]))
            ])),
            $author$project$Ui$Modal$footer($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$viewFooter(config.adV))
        ]));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$view = function(model) {
        if (!model.ka) return $author$project$Utils$Html$empty;
        else {
            var _v0 = model.kK;
            switch(_v0.$){
                case 1:
                    var current = _v0.a;
                    var total = _v0.b;
                    return A5($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal, 'Reading ' + ($elm$core$String$fromInt(current) + (' of ' + ($elm$core$String$fromInt(total) + ' files'))), current, total, _List_Nil, false);
                case 2:
                    var process = _v0.a;
                    return A5($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal, 'Uploading files', process.aaQ, process.tt, A2($elm$core$List$map, function(f) {
                        return _Utils_Tuple3(f.zr, f.V6, f.xy);
                    }, process.xF), true);
                case 3:
                    var failedFiles = _v0.a.xE;
                    var totalFiles = _v0.a.aal;
                    return $elm$core$List$isEmpty(failedFiles) ? A5($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal, 'Upload complete!', totalFiles, totalFiles, _List_Nil, false) : A5($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$uploadingModal, 'Upload complete with errors', totalFiles, totalFiles, failedFiles, false);
                default:
                    var _v1 = model.tA;
                    if (!_v1.$) {
                        var errorMessage = _v1.a;
                        return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal, true, errorMessage);
                    } else {
                        var _v2 = function() {
                            var _v3 = model.DR;
                            if (!_v3.$) return _Utils_Tuple2('Select Files to Upload', 'Select a folder containing CCDA (.xml) files. All CCDA files in the folder and its subfolders will be processed.');
                            else return _Utils_Tuple2('Upload More Files', 'Select additional CCDA (.xml) files to add to this upload.');
                        }();
                        var headerText = _v2.a;
                        var helpText = _v2.b;
                        return A3($author$project$Ui$Modal$view, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$CloseModal, _List_fromArray([
                            $author$project$Ui$Modal$size(2)
                        ]), _List_fromArray([
                            $author$project$Ui$Modal$header(_List_fromArray([
                                $elm$html$Html$text(headerText)
                            ])),
                            $author$project$Ui$Modal$body(_List_fromArray([
                                A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$helpText
                                ]), _List_fromArray([
                                    $elm$html$Html$text(helpText)
                                ])),
                                A2($author$project$Ui$Form$view, _List_fromArray([
                                    $author$project$Ui$Form$noValidate(true),
                                    $author$project$Ui$Form$autocomplete(false)
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                                        $author$project$Ui$Form$File$view(_List_fromArray([
                                            $author$project$Ui$Form$File$directory(true),
                                            $author$project$Ui$Form$File$accept(5),
                                            $author$project$Ui$Form$File$onInput($author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$FileSelected)
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ]));
                    }
            }
        }
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$view = function(model) {
        return A2($elm$html$Html$map, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$ModalMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$UploadModal$view(model.bc));
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$modal = function(model) {
        return A2($elm$html$Html$map, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploaderMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$Ccda$Uploader$view(model.hg));
    };
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$modal = function(model) {
        var _v0 = _Utils_Tuple2(model.kc, model.tA);
        if (_v0.a) {
            if (!_v0.b.$) {
                var errorMessage = _v0.b.a;
                return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal, true, errorMessage);
            } else {
                var _v1 = _v0.b;
                return A3($author$project$Components$Admin$Uploads$UploadModal$view, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$UploadModal, false, 'Your files were uploaded successfully.');
            }
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$Upload$DeleteAllPatients = {
        $: 2
    };
    var $author$project$Pages$Patients$Upload$Membership = 1;
    var $author$project$Pages$Patients$Upload$PatientNote = 3;
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$PaginationMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'file_name', true, 'File name'),
        A3($author$project$Api$Column$init, 'status', true, 'Status'),
        A3($author$project$Api$Column$init, 'result', true, 'Result'),
        A3($author$project$Api$Column$init, 'created_at', true, 'Created At')
    ]);
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$createdAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ClinicalUploadResult$Shared$createdAt(shared);
    };
    var $author$project$Api$Provider$ClinicalUploadResult$Data$message = function(_v0) {
        var record = _v0;
        return record.ae1;
    };
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$result = function(_v0) {
        var record = _v0;
        return record.YX;
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$errorMessage = function(_v0) {
        var shared = _v0;
        return A2($elm$core$Maybe$andThen, $author$project$Api$Provider$ClinicalUploadResult$Data$message, $author$project$Api$Provider$ClinicalUploadResult$Shared$result(shared));
    };
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$fileName = function(_v0) {
        var record = _v0;
        return record.PF;
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$fileName = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ClinicalUploadResult$Shared$fileName(shared);
    };
    var $author$project$Api$Provider$ClinicalUploadResult$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$Enqueued = {
        $: 0
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$Failed = {
        $: 5
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$PartiallyProcessed = {
        $: 6
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$Processed = {
        $: 4
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$Processing = {
        $: 3
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForProcessing = {
        $: 2
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForUploading = {
        $: 1
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$Unknown = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$stringToStatus = function(str) {
        switch(str){
            case 'enqueued':
                return $author$project$Api$Provider$ClinicalUploadResult$All$Enqueued;
            case 'ready_for_uploading':
                return $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForUploading;
            case 'ready_for_processing':
                return $author$project$Api$Provider$ClinicalUploadResult$All$ReadyForProcessing;
            case 'processing':
                return $author$project$Api$Provider$ClinicalUploadResult$All$Processing;
            case 'processed':
                return $author$project$Api$Provider$ClinicalUploadResult$All$Processed;
            case 'failed':
                return $author$project$Api$Provider$ClinicalUploadResult$All$Failed;
            case 'partially_processed':
                return $author$project$Api$Provider$ClinicalUploadResult$All$PartiallyProcessed;
            default:
                return $author$project$Api$Provider$ClinicalUploadResult$All$Unknown(str);
        }
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ClinicalUploadResult$All$stringToStatus($author$project$Api$Provider$ClinicalUploadResult$Shared$status(shared));
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$statusToString = function(uploadStatus) {
        switch(uploadStatus.$){
            case 0:
                return 'enqueued';
            case 1:
                return 'ready_for_uploading';
            case 2:
                return 'ready_for_processing';
            case 3:
                return 'processing';
            case 4:
                return 'processed';
            case 5:
                return 'failed';
            case 6:
                return 'partially_processed';
            default:
                var str = uploadStatus.a;
                return str;
        }
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewRow = F2(function(model, upload) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$ClinicalUploadResult$All$fileName(upload))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$ClinicalUploadResult$All$statusToString($author$project$Api$Provider$ClinicalUploadResult$All$status(upload)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$longText
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$ClinicalUploadResult$All$errorMessage(upload)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2(model.HO, 0, $author$project$Api$Provider$ClinicalUploadResult$All$createdAt(upload)))
            ]))
        ]));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.o8;
            if (_v1.$ === 3) {
                var uploads_ = _v1.a;
                return _Utils_Tuple2(false, uploads_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var uploads = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You have no uploads yet!')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$columns), A2($elm$core$List$map, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewRow(model), uploads), _List_Nil);
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewClinicalUploadResults = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Previous Atlas uploads')
            ])),
            $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewTable(model),
            A2($elm$html$Html$map, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_))
        ]));
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$FileUploaded = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$File$Zip = 4;
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$isZipFile = function(file) {
        var fileName = $elm$file$File$name(file);
        return A2($elm$core$String$endsWith, '.zip', fileName) && !A2($elm$core$String$startsWith, '.', fileName);
    };
    var $author$project$Ui$Form$File$Multiple = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Form$File$multiple = $author$project$Ui$Form$File$Multiple;
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewUploadForm = A2($elm$html$Html$div, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Typography$p, _List_fromArray([
            $author$project$Ui$Typography$helpText
        ]), _List_fromArray([
            $elm$html$Html$text('Upload files (.zip only)')
        ])),
        A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(false)
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$File$view(_List_fromArray([
                    $author$project$Ui$Form$File$directory(true),
                    $author$project$Ui$Form$File$accept(4),
                    $author$project$Ui$Form$File$onInput(A2($elm$core$Basics$composeL, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$FileUploaded, $elm$core$List$filter($author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$isZipFile))),
                    $author$project$Ui$Form$File$multiple(true)
                ]))
            ]))
        ]))
    ]));
    var $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$view = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Step 2. Upload Atlas clinical information.')
            ])),
            $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewUploadForm,
            $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$viewClinicalUploadResults(model)
        ]));
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$PaginationMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$columns = _List_fromArray([
        A3($author$project$Api$Column$init, 'file_name', true, 'File name'),
        A3($author$project$Api$Column$init, 'status', true, 'Status'),
        A3($author$project$Api$Column$init, 'result', true, 'Result'),
        A3($author$project$Api$Column$init, 'created_at', true, 'Created At'),
        A3($author$project$Api$Column$init, 'actions', false, 'Actions')
    ]);
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUpload = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploadMoreFiles = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$ClinicalUploadResult$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ClinicalUploadResult$Shared$id(shared);
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewActionButtons = F3(function(model, upload, status) {
        switch(status.$){
            case 3:
                return $author$project$Utils$Html$empty;
            case 4:
                return $author$project$Utils$Html$empty;
            default:
                var uploadId = $author$project$Api$Provider$ClinicalUploadResult$All$id(upload);
                var uploadMoreButton = A3($author$project$Ui$Button$view, {
                    abP: 'Upload more'
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$UploadMoreFiles(uploadId))
                ]), _List_fromArray([
                    $elm$html$Html$text('Upload more')
                ]));
                var isProcessing = _Utils_eq(model.nN, $elm$core$Maybe$Just(uploadId));
                var buttonText = function() {
                    switch(status.$){
                        case 6:
                            return 'Re-process failed ones';
                        case 5:
                            return 'Re-process failed ones';
                        default:
                            return 'Process';
                    }
                }();
                var processButton = A3($author$project$Ui$Button$view, {
                    abP: buttonText
                }, _List_fromArray([
                    $author$project$Ui$Button$sm,
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$ProcessUpload(uploadId)),
                    $author$project$Ui$Button$loading(isProcessing)
                ]), _List_fromArray([
                    $elm$html$Html$text(buttonText)
                ]));
                return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    processButton,
                    uploadMoreButton
                ]));
        }
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewRow = F2(function(model, upload) {
        var uploadStatus = $author$project$Api$Provider$ClinicalUploadResult$All$status(upload);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$ClinicalUploadResult$All$fileName(upload))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Api$Provider$ClinicalUploadResult$All$statusToString(uploadStatus))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$longText
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$ClinicalUploadResult$All$errorMessage(upload)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2(model.HO, 0, $author$project$Api$Provider$ClinicalUploadResult$All$createdAt(upload)))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$noWrap
            ]), _List_fromArray([
                A3($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewActionButtons, model, upload, uploadStatus)
            ]))
        ]));
    });
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.o8;
            if (_v1.$ === 3) {
                var uploads_ = _v1.a;
                return _Utils_Tuple2(false, uploads_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var uploads = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You have no uploads yet!')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$columns), A2($elm$core$List$map, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewRow(model), uploads), _List_Nil);
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewClinicalUploadResults = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Previous CCDA uploads')
            ])),
            $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewTable(model),
            A2($elm$html$Html$map, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_))
        ]));
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$OpenFileSelectionModal = {
        $: 4
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewUploadForm = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.DR;
                if (!_v0.$ && _v0.a.$ === 1) {
                    var uploadId = _v0.a.a;
                    return A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpText
                    ]), _List_fromArray([
                        $elm$html$Html$text('Adding files to upload ' + uploadId)
                    ]));
                } else return A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$helpText
                ]), _List_fromArray([
                    $elm$html$Html$text('Click the button below to select a folder containing CCDA (.xml) files. All CCDA files in the folder and its subfolders will be processed.')
                ]));
            }(),
            A3($author$project$Ui$Button$view, {
                abP: 'Create upload'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$OpenFileSelectionModal),
                $author$project$Ui$Button$primary
            ]), _List_fromArray([
                $elm$html$Html$text('Create Upload')
            ]))
        ]));
    };
    var $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$view = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Step 2. Upload CCDA clinical information.')
            ])),
            $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewUploadForm(model),
            $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$viewClinicalUploadResults(model)
        ]));
    };
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Upload$McePlanResource$McePlanUpdate = 1;
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns = function(isCreate) {
        var viewColumn = function(_v0) {
            var name = _v0.a;
            var isRequired = _v0.b;
            return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                $elm$html$Html$text(name),
                isRequired ? A2($author$project$Ui$Typography$em, _List_fromArray([
                    $author$project$Ui$Typography$danger,
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$small
                ]), _List_fromArray([
                    $elm$html$Html$text(' * required')
                ])) : $author$project$Utils$Html$empty
            ]));
        };
        var baseColumns = _List_fromArray([
            _Utils_Tuple2('Tier', isCreate),
            _Utils_Tuple2('Ages', isCreate),
            _Utils_Tuple2('IUA Level', isCreate)
        ]);
        var actionSpecificColumns = isCreate ? _List_fromArray([
            _Utils_Tuple2('Plan Name', true)
        ]) : _List_fromArray([
            _Utils_Tuple2('Plan ID', true)
        ]);
        var csvColumns = _Utils_ap(baseColumns, actionSpecificColumns);
        return A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, viewColumn, csvColumns));
    };
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$FileUploaded = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewUploadForm = A2($author$project$Ui$Form$view, _List_fromArray([
        $author$project$Ui$Form$noValidate(true),
        $author$project$Ui$Form$autocomplete(false)
    ]), _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$accept(1),
                $author$project$Ui$Form$File$onInput($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$FileUploaded),
                $author$project$Ui$Form$File$multiple(true)
            ]))
        ]))
    ]));
    var $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$view = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Step 2. Select desired change.')
            ])),
            $author$project$Ui$Button$group(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Create mce plan'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated(0)),
                    $author$project$Ui$Button$active(!model.Iq)
                ]), _List_fromArray([
                    $elm$html$Html$text('Create')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Update mce plan'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick($author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$MceActionTypeUpdated(1)),
                    $author$project$Ui$Button$active(model.Iq === 1)
                ]), _List_fromArray([
                    $elm$html$Html$text('Update')
                ]))
            ])),
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Step 3. Create a CSV file.')
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('It should include these exact headers:')
            ])),
            !model.Iq ? $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns(true) : $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewColumns(false),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Get started with our ready-to-go template'),
                $author$project$Utils$Html$noBreakSpace,
                A3($author$project$Ui$Link$externalHref, 'https://docs.google.com/spreadsheets/d/1QNttlhfBQm-LV-a0WCvsiqNOONyzYTE99WG7BLkVIso/edit?gid=0#gid=0', _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text('here.')
                ]))
            ])),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Step 4. Upload the file.')
            ])),
            $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$viewUploadForm
        ]));
    };
    var $author$project$Pages$Patients$Upload$Charge = 2;
    var $author$project$Api$FeatureGate$ChargeUploader = 1;
    var $author$project$Pages$Patients$Upload$ResourceSelected = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Patients$Upload$buttonStyle = function(bool) {
        return bool ? 1 : 0;
    };
    var $author$project$Pages$Patients$Upload$viewChargeResourceButton = function(model) {
        var hasFeatureGate = A2($author$project$Utils$FeatureGate$gateAvailable, 1, $author$project$Api$Practice$Provider(model.W1));
        return hasFeatureGate ? A3($author$project$Ui$Button$view, {
            abP: 'Charges'
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(model.Hg, $elm$core$Maybe$Just(2))),
            $author$project$Ui$Button$styled($author$project$Pages$Patients$Upload$buttonStyle(_Utils_eq(model.Hg, $elm$core$Maybe$Just(2)))),
            $author$project$Ui$Button$pull(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$Upload$ResourceSelected(2))
        ]), _List_fromArray([
            $elm$html$Html$text('Charges')
        ])) : model.F3 ? A3($author$project$Ui$HinterOnly$button, {
            abP: 'Charges'
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(model.Hg, $elm$core$Maybe$Just(2))),
            $author$project$Ui$Button$styled($author$project$Pages$Patients$Upload$buttonStyle(_Utils_eq(model.Hg, $elm$core$Maybe$Just(2)))),
            $author$project$Ui$Button$pull(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$Upload$ResourceSelected(2))
        ]), _List_fromArray([
            $elm$html$Html$text('Charges')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$Patients$Upload$ClinicalResourceSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Patients$Upload$viewClinicalResourceButton = F4(function(clinicalResource, label, flag, model) {
        return flag ? A3($author$project$Ui$HinterOnly$button, {
            abP: 'Select ' + label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(model.dB, $elm$core$Maybe$Just(clinicalResource))),
            $author$project$Ui$Button$styled($author$project$Pages$Patients$Upload$buttonStyle(_Utils_eq(model.dB, $elm$core$Maybe$Just(clinicalResource)))),
            $author$project$Ui$Button$pull(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$Upload$ClinicalResourceSelected(clinicalResource))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$Upload$McePlanResourceSelected = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Patients$Upload$viewMcePlanResourceButton = F2(function(mcePlanResource, model) {
        return $author$project$Api$Provider$Practice$One$accountType(model.W1) === 2 ? A3($author$project$Ui$Button$view, {
            abP: 'Select Healthshare Plan'
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(model.TT, $elm$core$Maybe$Just(0))),
            $author$project$Ui$Button$styled($author$project$Pages$Patients$Upload$buttonStyle(_Utils_eq(model.TT, $elm$core$Maybe$Just(0)))),
            $author$project$Ui$Button$pull(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$Upload$McePlanResourceSelected(mcePlanResource))
        ]), _List_fromArray([
            $elm$html$Html$text('Healthshare Plan')
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Pages$Patients$Upload$viewResourceButton = F4(function(resource, label, isHinter, model) {
        return isHinter ? A3($author$project$Ui$HinterOnly$button, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(model.Hg, $elm$core$Maybe$Just(resource))),
            $author$project$Ui$Button$styled($author$project$Pages$Patients$Upload$buttonStyle(_Utils_eq(model.Hg, $elm$core$Maybe$Just(resource))))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ])) : A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$active(_Utils_eq(model.Hg, $elm$core$Maybe$Just(resource))),
            $author$project$Ui$Button$styled($author$project$Pages$Patients$Upload$buttonStyle(_Utils_eq(model.Hg, $elm$core$Maybe$Just(resource)))),
            $author$project$Ui$Button$pull(0),
            $author$project$Ui$Button$onClick($author$project$Pages$Patients$Upload$ResourceSelected(resource))
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Pages$Patients$Upload$viewBody = function(model) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                    $elm$html$Html$text('Data Uploader')
                ]), _List_Nil)
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                model.vr ? A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Want to Start Over?')
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Click the button below to remove all existing patients before uploading a new list of patients.')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Delete all patients'
                    }, _List_fromArray([
                        $author$project$Ui$Button$danger,
                        $author$project$Ui$Button$onClick($author$project$Pages$Patients$Upload$DeleteAllPatients)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Delete All Patients')
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Step 1. Choose a data type.')
                        ])),
                        $author$project$Ui$Button$group(_List_fromArray([
                            A4($author$project$Pages$Patients$Upload$viewResourceButton, 0, 'Patients', false, model),
                            A4($author$project$Pages$Patients$Upload$viewResourceButton, 1, 'Memberships', false, model),
                            $author$project$Pages$Patients$Upload$viewChargeResourceButton(model),
                            A4($author$project$Pages$Patients$Upload$viewResourceButton, 3, 'Patient Notes', false, model),
                            A4($author$project$Pages$Patients$Upload$viewClinicalResourceButton, 0, 'Atlas Clinical', model.F3, model),
                            A4($author$project$Pages$Patients$Upload$viewClinicalResourceButton, 1, 'CCDA Clinical', model.F3, model),
                            A2($author$project$Pages$Patients$Upload$viewMcePlanResourceButton, 0, model)
                        ]))
                    ]))
                ])),
                function() {
                    var _v0 = _Utils_Tuple3(model.Hg, model.dB, model.TT);
                    _v0$3: while(true){
                        if (_v0.a.$ === 1) {
                            if (!_v0.b.$) {
                                if (!_v0.b.a) {
                                    if (_v0.c.$ === 1) {
                                        var _v1 = _v0.a;
                                        var _v2 = _v0.b.a;
                                        var _v3 = _v0.c;
                                        return A2($elm$html$Html$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$view(model.e6));
                                    } else break _v0$3;
                                } else {
                                    if (_v0.c.$ === 1) {
                                        var _v4 = _v0.a;
                                        var _v5 = _v0.b.a;
                                        var _v6 = _v0.c;
                                        return A2($elm$html$Html$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$view(model.fh));
                                    } else break _v0$3;
                                }
                            } else {
                                if (!_v0.c.$) {
                                    var _v7 = _v0.a;
                                    var _v8 = _v0.b;
                                    var _v9 = _v0.c.a;
                                    return A2($elm$html$Html$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$view(model.f8));
                                } else break _v0$3;
                            }
                        } else break _v0$3;
                    }
                    return A2($elm$html$Html$map, $author$project$Pages$Patients$Upload$UploadFormMsg, A2($author$project$Components$Upload$Form$view, model.Ej, model.hd));
                }()
            ])),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_fromArray([
                    $author$project$Ui$Link$buttonDefault
                ]), _List_fromArray([
                    $author$project$Ui$Icon$arrowLeft(_List_Nil),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text('Go Back')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Patients$Upload$view = function(model) {
        return {
            fb: _List_fromArray([
                model.ib ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Patients$Upload$HiConfirmClosed, _List_fromArray([
                    $author$project$Components$HiConfirm$verb('Delete All Patients'),
                    $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Warning: ')
                        ])),
                        $elm$html$Html$text('this will delete all the patients from the practice.')
                    ]))
                ])) : $author$project$Utils$Html$empty,
                A2($elm$html$Html$map, $author$project$Pages$Patients$Upload$UploadFormMsg, A2($author$project$Components$Upload$Form$modal, model.Ej, model.hd)),
                A2($elm$html$Html$map, $author$project$Pages$Patients$Upload$AtlasClinicalUploadFormMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$AtlasClinicalForm$modal(model.e6)),
                A2($elm$html$Html$map, $author$project$Pages$Patients$Upload$CcdaClinicalUploadFormMsg, $author$project$Components$Admin$Uploads$ClinicalUploads$CcdaClinicalForm$modal(model.fh)),
                A2($elm$html$Html$map, $author$project$Pages$Patients$Upload$McePlanUploadFormMsg, $author$project$Components$Admin$Uploads$McePlanUploads$McePlanForm$modal(model.f8)),
                $author$project$Pages$Patients$Upload$viewBody(model)
            ]),
            $2: 'Patients'
        };
    };
    var $author$project$Pages$Patients$Upload$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Patients$Upload$init,
        aeR: $author$project$Pages$Patients$Upload$load,
        ag3: $author$project$Pages$Patients$Upload$save,
        ahE: $author$project$Pages$Patients$Upload$subscriptions,
        aaO: $author$project$Pages$Patients$Upload$update,
        aid: $author$project$Pages$Patients$Upload$view
    });
    var $author$project$Pages$PracticeSetup$Account$AccountFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Account$GotPractice = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Platform$Organization$Shared$onboardingClinical = function(_v0) {
        var record = _v0.b;
        return record.Vt;
    };
    var $author$project$Pages$PracticeSetup$Account$onboardingClinical = function(session) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$onboardingClinical, $author$project$Api$Platform$Session$One$organization(session)));
    };
    var $author$project$Api$Provider$Practice$DefaultPlan = 1;
    var $author$project$Pages$PracticeSetup$Account$practiceOptionals = function(optionals) {
        return _Utils_update(optionals, {
            Fq: _List_fromArray([
                1
            ])
        });
    };
    var $author$project$Pages$PracticeSetup$Account$init = F4(function(session, practice, shared, _v0) {
        var _v1 = A4($author$project$Components$Practice$AccountForm$init, practice, shared.abq, shared, {
            aK: true,
            Vt: $author$project$Pages$PracticeSetup$Account$onboardingClinical(session)
        });
        var accountFormModel = _v1.a;
        var accountFormCmd = _v1.b;
        return _Utils_Tuple2({
            cv: accountFormModel,
            Ej: shared.Ej,
            NA: '',
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            Cu: shared
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, accountFormCmd),
            A3($author$project$Api$Provider$Practice$retrieve, shared.Ej, $author$project$Pages$PracticeSetup$Account$practiceOptionals, $author$project$Pages$PracticeSetup$Account$GotPractice)
        ])));
    });
    var $author$project$Utils$PracticeSetup$redirectIfOnboardingComplete = F2(function(sessionData, hinterViewOff) {
        if (sessionData.$ === 3) {
            var session = sessionData.a;
            var practiceIsOnboarding = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding, $author$project$Api$Platform$Session$One$organization(session)));
            return practiceIsOnboarding ? $elm$core$Platform$Cmd$none : A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, hinterViewOff));
        } else return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Pages$PracticeSetup$Account$load = F2(function(shared, model) {
        return _Utils_Tuple2(model, A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$Account$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Account$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, $author$project$Components$Practice$AccountForm$subscriptions(model.cv));
    };
    var $author$project$Api$Provider$Practice$One$defaultPlanId = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.NA;
    });
    var $author$project$Pages$PracticeSetup$Account$Updated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Account$updatePractice = F2(function(apiClient, formFields) {
        var fields = $rtfeldman$elm_validate$Validate$fromValid(formFields);
        return A3($author$project$Api$Provider$Practice$update, apiClient, $author$project$Components$Practice$AccountForm$practiceFromFields(fields), $author$project$Pages$PracticeSetup$Account$Updated);
    });
    var $author$project$Pages$PracticeSetup$Account$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$Practice$AccountForm$update, subMsg, model.cv);
                var accountFormModel = _v1.a;
                var accountFormCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    cv: accountFormModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, accountFormCmd), _List_Nil);
            case 1:
                var _v2 = $author$project$Components$Practice$AccountForm$validate(model.cv);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validatedForm = _v3.a;
                    var validFormFields = _v3.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cv: validatedForm,
                        j_: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$PracticeSetup$Account$updatePractice, model.Ej, validFormFields), _List_Nil);
                } else {
                    var erroredForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cv: erroredForm,
                        j_: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    var _v5 = A4($author$project$Components$Practice$AccountForm$init, practice, model.Cu.abq, model.Cu, {
                        aK: true,
                        Vt: $author$project$Pages$PracticeSetup$Account$onboardingClinical(model.Z$)
                    });
                    var form = _v5.a;
                    var cmds = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        cv: form,
                        j_: response
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, cmds),
                        A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit({
                            aef: model.NA
                        }))
                    ])), _List_fromArray([
                        $author$project$OutMsg$PracticeUpdated(response)
                    ]));
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var practice = response.a;
                    var defaultPlanId = A2($elm$core$Maybe$withDefault, '', A2($author$project$Api$Expandable$withDefault, $elm$core$Maybe$Nothing, $author$project$Api$Provider$Practice$One$defaultPlanId(practice)));
                    return _Utils_Tuple3(_Utils_update(model, {
                        NA: defaultPlanId
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$PracticeSetup$Account$FormSubmitted = {
        $: 1
    };
    var $author$project$Pages$PracticeSetup$Account$view = function(model) {
        var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(model.W1) || $author$project$Pages$PracticeSetup$Account$onboardingClinical(model.Z$);
        var practiceIsOnboarding = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding, $author$project$Api$Platform$Session$One$organization(model.Z$)));
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$PracticeSetup$Account$FormSubmitted)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, practiceIsOnboarding ? _List_fromArray([
                        $author$project$Ui$Panel$onlyBorderLeft
                    ]) : _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text('Contact Information')
                            ])),
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('This information will be displayed to patients on communications and sign-up pages so they know how to reach you.'),
                                usingClinicalEmr ? A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Practice phone and fax will be added later.')
                                ])) : $author$project$Utils$Html$empty
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$PracticeSetup$Account$AccountFormMsg, $author$project$Components$Practice$AccountForm$view(model.cv)),
                            function() {
                                var _v0 = model.j_;
                                if (_v0.$ === 2) {
                                    var error = _v0.a;
                                    return A2($author$project$Ui$Element$view, _List_fromArray([
                                        $author$project$Ui$Element$mt4
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text($author$project$Api$Data$errorToString(error))
                                        ]))
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }()
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_Nil, _List_Nil),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Next'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Next')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Account$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Account$init,
        aeR: $author$project$Pages$PracticeSetup$Account$load,
        ag3: $author$project$Pages$PracticeSetup$Account$save,
        ahE: $author$project$Pages$PracticeSetup$Account$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Account$update,
        aid: $author$project$Pages$PracticeSetup$Account$view
    });
    var $author$project$Pages$PracticeSetup$Communications$GetNewNumbers = 0;
    var $author$project$Pages$PracticeSetup$Communications$initFormFields = {
        iH: 0,
        mg: '',
        gs: 0,
        nw: ''
    };
    var $author$project$Pages$PracticeSetup$Communications$init = F4(function(session, practice, shared, _v0) {
        var phoneInputOptions = function(opts) {
            return _Utils_update(opts, {
                Iz: true,
                abK: false,
                ac_: $author$project$Api$Common$Phone$Shared$Office,
                ada: true,
                ms: true,
                y_: 1
            });
        };
        return _Utils_Tuple2({
            Ej: shared.Ej,
            O4: $elm$core$Maybe$Nothing,
            fL: A3($author$project$Components$PhoneInput$init, 'practice-fax', _List_Nil, phoneInputOptions),
            PU: $author$project$Utils$Form$init($author$project$Pages$PracticeSetup$Communications$initFormFields),
            F3: $author$project$Shared$isHintAdmin(shared),
            fX: false,
            bA: A3($author$project$Components$PhoneInput$init, 'practice-phone', _List_Nil, phoneInputOptions),
            W1: practice,
            Z$: session
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$PracticeSetup$Communications$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$Communications$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Communications$FaxInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg, $author$project$Components$PhoneInput$subscriptions(model.bA)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$PracticeSetup$Communications$FaxInputMsg, $author$project$Components$PhoneInput$subscriptions(model.fL))
        ]));
    };
    var $author$project$Pages$PracticeSetup$Communications$GotResponse = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$PortExistingNumbers = 1;
    var $author$project$Api$CommunicationsSetup$communicationsSetupPath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'communications_setup'
        ]), basePath);
    };
    var $author$project$Api$CommunicationsSetup$listDefaults = {
        Fv: $elm$core$Maybe$Nothing,
        WE: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$CommunicationsSetup$encodeRequest = function(optionals) {
        var options = optionals($author$project$Api$CommunicationsSetup$listDefaults);
        var encodePhoneOrFax = function(data) {
            return $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    _Utils_Tuple2('action', $elm$json$Json$Encode$string(data.D7))
                ]),
                A3($author$project$Utils$Encode$optional, 'area_code', $elm$json$Json$Encode$string, data.El),
                A3($author$project$Utils$Encode$optional, 'number', $elm$json$Json$Encode$string, data.Gx)
            ])));
        };
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('phone', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, encodePhoneOrFax, options.WE))),
            _Utils_Tuple2('fax', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, encodePhoneOrFax, options.Fv)))
        ]));
    };
    var $author$project$Api$CommunicationsSetup$create = F3(function(apiClient, query, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, $author$project$Api$CommunicationsSetup$encodeRequest(query), $author$project$Api$Data$requestTo($author$project$Api$CommunicationsSetup$communicationsSetupPath($author$project$Api$Data$providerPath))));
    });
    var $author$project$Api$CommunicationsSetup$FaxData = F3(function(action, area_code, number) {
        return {
            D7: action,
            El: area_code,
            Gx: number
        };
    });
    var $author$project$Api$CommunicationsSetup$PhoneData = F3(function(action, area_code, number) {
        return {
            D7: action,
            El: area_code,
            Gx: number
        };
    });
    var $author$project$Pages$PracticeSetup$Communications$createParams = F2(function(fields, model) {
        return function(d) {
            var phoneData = function() {
                var _v1 = fields.gs;
                if (!_v1) return A3($author$project$Api$CommunicationsSetup$PhoneData, 'buy', $elm$core$Maybe$Just(fields.nw), $elm$core$Maybe$Nothing);
                else {
                    var phoneNumber = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function($) {
                        return $.Gx;
                    }, A2($elm$core$Maybe$andThen, $elm$core$List$head, $author$project$Components$PhoneInput$getPhones(model.bA))));
                    return A3($author$project$Api$CommunicationsSetup$PhoneData, 'port', $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(phoneNumber));
                }
            }();
            var faxData = function() {
                var _v0 = fields.iH;
                if (!_v0) return A3($author$project$Api$CommunicationsSetup$FaxData, 'buy', $elm$core$Maybe$Just(fields.mg), $elm$core$Maybe$Nothing);
                else {
                    var faxNumber = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function($) {
                        return $.Gx;
                    }, A2($elm$core$Maybe$andThen, $elm$core$List$head, $author$project$Components$PhoneInput$getPhones(model.fL))));
                    return A3($author$project$Api$CommunicationsSetup$FaxData, 'port', $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(faxNumber));
                }
            }();
            return _Utils_update(d, {
                Fv: $elm$core$Maybe$Just(faxData),
                WE: $elm$core$Maybe$Just(phoneData)
            });
        };
    });
    var $author$project$Pages$PracticeSetup$Communications$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var option = field.a;
                return _Utils_update(fields, {
                    gs: option
                });
            case 1:
                var areaCode = field.a;
                return _Utils_update(fields, {
                    nw: areaCode
                });
            case 2:
                var option = field.a;
                return _Utils_update(fields, {
                    iH: option
                });
            default:
                var areaCode = field.a;
                return _Utils_update(fields, {
                    mg: areaCode
                });
        }
    });
    var $author$project$Pages$PracticeSetup$Communications$FaxAreaCodeValidation = 2;
    var $author$project$Pages$PracticeSetup$Communications$FaxNumberValidation = 3;
    var $author$project$Pages$PracticeSetup$Communications$validateNumber = F6(function(action, areaCode, phoneInput, areaCodeValidation, numberValidation, numberType) {
        if (!action) return !$elm$core$String$length(A2($elm$core$String$filter, $elm$core$Char$isDigit, areaCode)) ? _List_fromArray([
            _Utils_Tuple2(areaCodeValidation, 'You must enter a preferred area code for ' + (numberType + '.'))
        ]) : $elm$core$String$length(A2($elm$core$String$filter, $elm$core$Char$isDigit, areaCode)) !== 3 ? _List_fromArray([
            _Utils_Tuple2(areaCodeValidation, 'Area code must be exactly 3 digits.')
        ]) : _List_Nil;
        else {
            if ($author$project$Components$PhoneInput$hasErrors(phoneInput)) return _List_fromArray([
                _Utils_Tuple2(numberValidation, 'Please enter a valid ' + (numberType + ' number.'))
            ]);
            else {
                var number = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function($) {
                    return $.Gx;
                }, A2($elm$core$Maybe$andThen, $elm$core$List$head, $author$project$Components$PhoneInput$getPhones(phoneInput))));
                return !$elm$core$String$length(number) ? _List_fromArray([
                    _Utils_Tuple2(numberValidation, 'You must enter a ' + (numberType + ' number to port.'))
                ]) : _List_Nil;
            }
        }
    });
    var $author$project$Pages$PracticeSetup$Communications$validateFax = F2(function(model, fields) {
        return A6($author$project$Pages$PracticeSetup$Communications$validateNumber, fields.iH, fields.mg, model.fL, 2, 3, 'fax');
    });
    var $author$project$Pages$PracticeSetup$Communications$PhoneAreaCodeValidation = 0;
    var $author$project$Pages$PracticeSetup$Communications$PhoneNumberValidation = 1;
    var $author$project$Pages$PracticeSetup$Communications$validatePhone = F2(function(model, fields) {
        return A6($author$project$Pages$PracticeSetup$Communications$validateNumber, fields.gs, fields.nw, model.bA, 0, 1, 'phone');
    });
    var $author$project$Pages$PracticeSetup$Communications$formFieldsValidator = function(model) {
        return $rtfeldman$elm_validate$Validate$all(_List_fromArray([
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$PracticeSetup$Communications$validatePhone(model)),
            $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$PracticeSetup$Communications$validateFax(model))
        ]));
    };
    var $author$project$Pages$PracticeSetup$Communications$navigateToLegal = A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Legal);
    var $author$project$Pages$PracticeSetup$Communications$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$PracticeSetup$Communications$formFieldsValidator(model), model.PU);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var newForm = _v2.a;
                    var validFormFields = _v2.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var _v3 = fields.gs;
                    if (!_v3) {
                        var cmd = A3($author$project$Api$CommunicationsSetup$create, model.Ej, A2($author$project$Pages$PracticeSetup$Communications$createParams, fields, model), $author$project$Pages$PracticeSetup$Communications$GotResponse);
                        return _Utils_Tuple3(_Utils_update(model, {
                            O4: $elm$core$Maybe$Nothing,
                            PU: newForm,
                            fX: true
                        }), cmd, _List_Nil);
                    } else {
                        var cmd = A3($author$project$Api$CommunicationsSetup$create, model.Ej, A2($author$project$Pages$PracticeSetup$Communications$createParams, fields, model), $author$project$Pages$PracticeSetup$Communications$GotResponse);
                        return _Utils_Tuple3(_Utils_update(model, {
                            O4: $elm$core$Maybe$Nothing,
                            PU: newForm,
                            fX: true
                        }), cmd, _List_Nil);
                    }
                } else {
                    var newForm = _v1.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var fields = $author$project$Utils$Form$fields(model.PU);
                        var isFaxPorting = fields.iH === 1;
                        var isPhonePorting = fields.gs === 1;
                        var portingType = function() {
                            var _v6 = _Utils_Tuple2(isPhonePorting, isFaxPorting);
                            if (_v6.a) {
                                if (_v6.b) return $elm$core$Maybe$Just('phone, fax');
                                else return $elm$core$Maybe$Just('phone');
                            } else {
                                if (_v6.b) return $elm$core$Maybe$Just('fax');
                                else return $elm$core$Maybe$Nothing;
                            }
                        }();
                        var logPortingEventCmd = function() {
                            if (!portingType.$) {
                                var typeValue = portingType.a;
                                return A2($author$project$Utils$Analytics$Shared$logSimpleEvent, 'self onboarding phone port requested', _List_fromArray([
                                    A2($author$project$Utils$Analytics$Shared$property, 'type', typeValue)
                                ]));
                            } else return $elm$core$Platform$Cmd$none;
                        }();
                        return _Utils_Tuple3(_Utils_update(model, {
                            O4: $elm$core$Maybe$Nothing,
                            fX: false
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Pages$PracticeSetup$Communications$navigateToLegal,
                            logPortingEventCmd
                        ])), _List_Nil);
                    case 2:
                        var error = response.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            O4: $elm$core$Maybe$Just($author$project$Api$Data$errorToString(error)),
                            fX: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            fX: false
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 1:
                var field = msg.a;
                var form = A3($author$project$Utils$Form$update, $author$project$Pages$PracticeSetup$Communications$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: form
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v7 = A2($author$project$Components$PhoneInput$update, subMsg, model.bA);
                var phoneInput = _v7.a;
                var phoneCmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    bA: phoneInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg, phoneCmd), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v8 = A2($author$project$Components$PhoneInput$update, subMsg, model.fL);
                var faxInput = _v8.a;
                var faxCmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    fL: faxInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Communications$FaxInputMsg, faxCmd), _List_Nil);
        }
    });
    var $author$project$Pages$PracticeSetup$Communications$FormSubmitted = {
        $: 0
    };
    var $author$project$Pages$PracticeSetup$Communications$SetFaxAction = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$SetFaxAreaCode = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$FormUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$areaCodeInput = function(config) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(4),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Area Code')
        ]), _List_fromArray([
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$value(config.vz),
                $author$project$Ui$Form$Input$onInput(function(str) {
                    return $author$project$Pages$PracticeSetup$Communications$FormUpdated(config.zT(str));
                }),
                $author$project$Ui$Form$Input$maxLength(3),
                $author$project$Ui$Form$Input$placeholder('000'),
                $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, config.pA, config.PU))
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text('Enter a 3-digit area code to use for any new numbers.')
            ])),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, config.pA, config.PU))
        ]));
    };
    var $author$project$Pages$PracticeSetup$Communications$existingNumberInput = function(config) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpanSm(3),
            $author$project$Ui$Form$Group$inputSpanSm(5),
            $author$project$Ui$Form$Group$required(true),
            $author$project$Ui$Form$Group$label('Existing ' + (config.aeI + ' Number'))
        ]), _List_fromArray([
            A2($elm$html$Html$map, config.A4, $author$project$Components$PhoneInput$view(config.bA)),
            $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, config.zR, config.PU))
        ]));
    };
    var $author$project$Pages$PracticeSetup$Communications$viewOptions = function(config) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$labelSpanSm(3),
                $author$project$Ui$Form$Group$inputSpanSm(9),
                $author$project$Ui$Form$Group$label(config.aeI)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$mt2
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(3)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                            $author$project$Ui$Form$Radio$value(!config.lJ),
                            $author$project$Ui$Form$Radio$onCheck(function(_v0) {
                                return $author$project$Pages$PracticeSetup$Communications$FormUpdated(config.rH(0));
                            })
                        ]), _List_fromArray([
                            $elm$html$Html$text('Get a New Number')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                            $author$project$Ui$Form$Radio$value(config.lJ === 1),
                            $author$project$Ui$Form$Radio$onCheck(function(_v1) {
                                return $author$project$Pages$PracticeSetup$Communications$FormUpdated(config.rH(1));
                            })
                        ]), _List_fromArray([
                            $elm$html$Html$text('Port an Existing Number')
                        ]))
                    ]))
                ]))
            ])),
            !config.lJ ? $author$project$Pages$PracticeSetup$Communications$areaCodeInput(config) : $author$project$Pages$PracticeSetup$Communications$existingNumberInput(config)
        ]));
    };
    var $author$project$Pages$PracticeSetup$Communications$viewFaxOptions = F2(function(model, fields) {
        return $author$project$Pages$PracticeSetup$Communications$viewOptions({
            vz: fields.mg,
            pA: 2,
            lJ: fields.iH,
            PU: model.PU,
            aeI: 'Fax',
            zR: 3,
            rH: $author$project$Pages$PracticeSetup$Communications$SetFaxAction,
            zT: $author$project$Pages$PracticeSetup$Communications$SetFaxAreaCode,
            bA: model.fL,
            A4: $author$project$Pages$PracticeSetup$Communications$FaxInputMsg
        });
    });
    var $author$project$Pages$PracticeSetup$Communications$SetPhoneAction = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$SetPhoneAreaCode = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$viewPhoneOptions = F2(function(model, fields) {
        return $author$project$Pages$PracticeSetup$Communications$viewOptions({
            vz: fields.nw,
            pA: 0,
            lJ: fields.gs,
            PU: model.PU,
            aeI: 'Phone',
            zR: 1,
            rH: $author$project$Pages$PracticeSetup$Communications$SetPhoneAction,
            zT: $author$project$Pages$PracticeSetup$Communications$SetPhoneAreaCode,
            bA: model.bA,
            A4: $author$project$Pages$PracticeSetup$Communications$PhoneInputMsg
        });
    });
    var $author$project$Pages$PracticeSetup$Communications$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Set up your practice phone & fax')
                        ])),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('If you\'re getting a new number, we\'ll assign it right away based upon the area code that you enter. If you\'re porting, your onboarding manager will follow up with next steps. If you\'re porting multiple numbers, just enter your main practice number here.')
                        ]))
                    ])),
                    function() {
                        var fields = $author$project$Utils$Form$fields(model.PU);
                        return A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Pages$PracticeSetup$Communications$viewPhoneOptions, model, fields),
                            $author$project$Utils$Html$noBreakSpace,
                            A2($author$project$Pages$PracticeSetup$Communications$viewFaxOptions, model, fields),
                            function() {
                                var _v0 = model.O4;
                                if (!_v0.$) {
                                    var error = _v0.a;
                                    return A2($author$project$Ui$Alert$danger, _List_fromArray([
                                        $author$project$Ui$Alert$m0,
                                        $author$project$Ui$Alert$margin(8)
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(error)
                                    ]));
                                } else return $elm$html$Html$text('');
                            }(),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Next'
                            }, _List_fromArray([
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$margin(8),
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Communications$FormSubmitted),
                                $author$project$Ui$Button$loading(model.fX)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Next')
                            ]))
                        ]));
                    }()
                ]))
            ]),
            $2: 'Admin Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Communications$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Communications$init,
        aeR: $author$project$Pages$PracticeSetup$Communications$load,
        ag3: $author$project$Pages$PracticeSetup$Communications$save,
        ahE: $author$project$Pages$PracticeSetup$Communications$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Communications$update,
        aid: $author$project$Pages$PracticeSetup$Communications$view
    });
    var $author$project$Pages$PracticeSetup$Complete$GotDefaultSignupPage = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Complete$GotPractice = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Complete$fetchPractice = function(apiClient) {
        return A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Pages$PracticeSetup$Complete$GotPractice);
    };
    var $author$project$Pages$PracticeSetup$Complete$init = F4(function(_v0, _v1, shared, _v2) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            NC: $elm$core$Maybe$Nothing,
            qW: shared.qW,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: $author$project$Api$Data$Loading
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$SignupPage$getDefault, shared.Ej, $author$project$Pages$PracticeSetup$Complete$GotDefaultSignupPage),
            $author$project$Pages$PracticeSetup$Complete$fetchPractice(shared.Ej)
        ])));
    });
    var $author$project$Pages$PracticeSetup$Complete$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$PracticeSetup$Complete$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Complete$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$OutMsg$RefreshSession = {
        $: 4
    };
    var $author$project$Pages$PracticeSetup$Complete$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Patients__Top), _List_fromArray([
                    $author$project$OutMsg$PracticeUpdated(model.W1)
                ]));
            case 1:
                var response = msg.a;
                if (response.$ === 3) {
                    var signupPages = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        NC: $elm$core$List$head(signupPages)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 2:
                var url = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(url), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied signup url to clipboard')
                ]));
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    W1: response
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$RefreshSession
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$PracticeSetup$Complete$Completed = {
        $: 0
    };
    var $author$project$Ui$Image$OnboardingComplete = 14;
    var $author$project$Ui$Grid$rowItemsJustifySpaceBetween = $author$project$Ui$Grid$RowElement($author$project$Ui$Element$spaceBetween);
    var $author$project$Pages$PracticeSetup$Complete$CopyToClipboard = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Utils$Phone$displayPhoneNumber = F2(function(region, number_) {
        if (!region) return $author$project$Formatters$Phone$format(number_);
        else return number_;
    });
    var $author$project$Utils$Phone$displayPhone = function(phoneInfo) {
        return A2($author$project$Utils$Phone$displayPhoneNumber, phoneInfo.H0 ? 0 : 1, phoneInfo.Gx);
    };
    var $author$project$Pages$PracticeSetup$Complete$practicePhone = function(practice) {
        return $elm$core$List$head($author$project$Api$Provider$Practice$One$phones(practice));
    };
    var $author$project$Pages$PracticeSetup$Complete$viewPracticePhone = function(practice) {
        var _v0 = $author$project$Pages$PracticeSetup$Complete$practicePhone(practice);
        if (!_v0.$) {
            var phone = _v0.a;
            var formattedNumber = $author$project$Utils$Phone$displayPhone({
                Gx: A2($elm$core$Maybe$withDefault, '', $author$project$Api$Common$Phone$Shared$number(phone)),
                H0: $author$project$Api$Common$Phone$Shared$usFormattable(phone)
            });
            return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Your practice phone number: '),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$tel, formattedNumber, _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text(formattedNumber)
                        ]))
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Copy Practice Phone Number'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                        $author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Complete$CopyToClipboard(formattedNumber))
                    ]), _List_Nil)
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Pages$PracticeSetup$Complete$viewSkeletonText = A2($elm$html$Html$div, _List_fromArray([
        $author$project$Ui$Margin$toClass(11),
        $elm$html$Html$Attributes$class('w-full')
    ]), _List_fromArray([
        A2($author$project$Ui$Typography$div, _List_fromArray([
            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
            $author$project$Ui$Typography$margin(2)
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$block,
                $author$project$Ui$Skeleton$span(10)
            ]))
        ]))
    ]));
    var $author$project$Pages$PracticeSetup$Complete$viewSignupPageUrl = function(maybeSignupPage) {
        if (!maybeSignupPage.$) {
            var signupPage = maybeSignupPage.a;
            var signupUrl = $author$project$Api$Provider$SignupPage$All$baseUrl(signupPage);
            return A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
                $author$project$Ui$Typography$margin(2),
                $author$project$Ui$Typography$margin(11)
            ]), _List_fromArray([
                A3($author$project$Ui$Link$externalHref, signupUrl, _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text(signupUrl)
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Copy Signup URL'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$icon($author$project$Ui$Icon$copy),
                    $author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Complete$CopyToClipboard(signupUrl))
                ]), _List_Nil)
            ]));
        } else return $author$project$Pages$PracticeSetup$Complete$viewSkeletonText;
    };
    var $author$project$Pages$PracticeSetup$Complete$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_fromArray([
                    $author$project$Ui$Grid$rowItemsCenter,
                    $author$project$Ui$Grid$rowItemsJustifySpaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12),
                        $author$project$Ui$Grid$justifyCenter
                    ]), _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textLeft,
                            $author$project$Ui$Element$mb2
                        ]), _List_fromArray([
                            $author$project$Ui$Typography$heading(_List_fromArray([
                                $elm$html$Html$text('Congratulations on setting up your account! What\'s next?')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(6),
                                $author$project$Ui$Grid$justifyLeft
                            ]), _List_fromArray([
                                A4($author$project$Ui$Image$view, model.qW, {
                                    Jg: 'Congratulations illustration showing completed setup'
                                }, _List_Nil, 14)
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(6),
                                $author$project$Ui$Grid$justifyLeft
                            ]), _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$muted,
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Patients can now signup with your practice')
                                ])),
                                A2($elm$html$Html$ul, _List_Nil, function() {
                                    var signupItems = function() {
                                        var _v1 = model.NC;
                                        if (!_v1.$) return _List_fromArray([
                                            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                                                $author$project$Pages$PracticeSetup$Complete$viewSignupPageUrl(model.NC)
                                            ]))
                                        ]);
                                        else return _List_fromArray([
                                            $author$project$Pages$PracticeSetup$Complete$viewSkeletonText
                                        ]);
                                    }();
                                    var practiceItems = function() {
                                        var _v0 = model.W1;
                                        if (_v0.$ === 3) {
                                            var practice = _v0.a;
                                            return _List_fromArray([
                                                $author$project$Pages$PracticeSetup$Complete$viewPracticePhone(practice)
                                            ]);
                                        } else return _List_Nil;
                                    }();
                                    return A2($elm$core$List$cons, A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('Use the following link to sign-up for your practice. We recommend posting this on your website:')
                                        ]))
                                    ])), _Utils_ap(signupItems, practiceItems));
                                }()),
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$muted,
                                    $author$project$Ui$Typography$bold,
                                    $author$project$Ui$Typography$margin(9)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Expect an email from your onboarding manager within 2 business days')
                                ])),
                                A2($elm$html$Html$ul, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('You will receive emails from your onboarding manager at '),
                                            A3($author$project$Ui$Link$mailto, 'onboarding@hint.com', _List_fromArray([
                                                $author$project$Ui$Link$targetBlank
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('onboarding@hint.com')
                                            ])),
                                            $elm$html$Html$text('.')
                                        ]))
                                    ]))
                                ])),
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$muted,
                                    $author$project$Ui$Typography$bold,
                                    $author$project$Ui$Typography$margin(9)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Complete your onboarding checklist')
                                ])),
                                A2($elm$html$Html$ul, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('After clicking \'Next,\' you will see an onboarding checklist with additional next steps.')
                                        ]))
                                    ]))
                                ])),
                                A2($author$project$Ui$Typography$div, _List_fromArray([
                                    $author$project$Ui$Typography$muted,
                                    $author$project$Ui$Typography$bold,
                                    $author$project$Ui$Typography$margin(9)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Learn more on Hint Community')
                                ])),
                                A2($elm$html$Html$ul, _List_Nil, _List_fromArray([
                                    A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text('You now have access to '),
                                            A3($author$project$Ui$Link$externalHref, 'https://community.hint.com/c/account-configuration?automatic_login=true', _List_fromArray([
                                                $author$project$Ui$Link$targetBlank,
                                                $author$project$Ui$Link$test('help-community')
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Hint Community')
                                            ])),
                                            $elm$html$Html$text('! View resources on how to jumpstart your Hint Experience!')
                                        ]))
                                    ]))
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Typography$div, _List_fromArray([
                            $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                        ]), _List_fromArray([
                            A3($author$project$Ui$Button$view, {
                                abP: 'Next'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$loading(false),
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Complete$Completed)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Next')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Complete$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Complete$init,
        aeR: $author$project$Pages$PracticeSetup$Complete$load,
        ag3: $author$project$Pages$PracticeSetup$Complete$save,
        ahE: $author$project$Pages$PracticeSetup$Complete$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Complete$update,
        aid: $author$project$Pages$PracticeSetup$Complete$view
    });
    var $author$project$Pages$PracticeSetup$Documents$DocumentFormMsg = $elm$core$Basics$identity;
    var $author$project$Pages$PracticeSetup$Documents$init = F4(function(session, practice, shared, _v0) {
        var _v1 = A5($author$project$Components$Admin$Documents$Form$init, shared.Ej, session, $elm$core$Maybe$Nothing, practice, {
            aK: true
        });
        var form = _v1.a;
        var cmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$PracticeSetup$Documents$load = F2(function(shared, model) {
        return _Utils_Tuple2(model, A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$Documents$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Documents$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Admin$Documents$Form$subscriptions(model.PU));
    };
    var $author$project$Pages$PracticeSetup$Documents$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$Documents$Form$update, model.Ej, subMsg, model.PU);
        var form = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            PU: form
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$PracticeSetup$Documents$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$Documents$Form$view(model.PU))
            ]),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Documents$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Documents$init,
        aeR: $author$project$Pages$PracticeSetup$Documents$load,
        ag3: $author$project$Pages$PracticeSetup$Documents$save,
        ahE: $author$project$Pages$PracticeSetup$Documents$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Documents$update,
        aid: $author$project$Pages$PracticeSetup$Documents$view
    });
    var $author$project$Pages$PracticeSetup$Legal$AddressInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Legal$initFormFields = function() {
        var _v0 = $author$project$Components$AddressInput$init('practice-legal-address');
        var addressInput = _v0.a;
        var addressInputCmd = _v0.b;
        return _Utils_Tuple2({
            Oy: $elm$core$Maybe$Nothing,
            aeO: addressInput,
            S4: $elm$core$Maybe$Nothing
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Legal$AddressInputMsg, addressInputCmd));
    }();
    var $author$project$Pages$PracticeSetup$Legal$init = F4(function(session, practice, shared, _v0) {
        var _v1 = $author$project$Pages$PracticeSetup$Legal$initFormFields;
        var formFields = _v1.a;
        var formFieldsCmd = _v1.b;
        var form = $author$project$Utils$Form$init(formFields);
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: form,
            W1: practice,
            Z$: session
        }, formFieldsCmd);
    });
    var $author$project$Pages$PracticeSetup$Legal$load = F2(function(shared, model) {
        return _Utils_Tuple2(model, A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$Legal$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Legal$subscriptions = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var legalAddress = _v0.aeO;
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$PracticeSetup$Legal$AddressInputMsg, $author$project$Components$AddressInput$subscriptions(legalAddress));
    };
    var $author$project$Pages$PracticeSetup$Legal$GotResponse = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Legal$LegalAddress = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$PracticeBusinessProfile$practiceBusinessProfilePath = function(basePath) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'practice_business_profile'
        ]), basePath);
    };
    var $author$project$Api$Provider$PracticeBusinessProfile$create = F3(function(apiClient, fields, toMsg) {
        var addressField = function() {
            var _v0 = fields.aeO;
            if (!_v0.$) {
                var address_ = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('legal_address', $author$project$Api$Common$Address$Shared$encode(address_))
                ]);
            } else return _List_Nil;
        }();
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('practice_business_profile', $elm$json$Json$Encode$object($elm$core$List$concat(_List_fromArray([
                A3($author$project$Utils$Encode$optional, 'legal_name', $elm$json$Json$Encode$string, fields.S4),
                A3($author$project$Utils$Encode$optional, 'ein', $elm$json$Json$Encode$string, fields.Oy),
                addressField
            ]))))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$PracticeBusinessProfile$practiceBusinessProfilePath($author$project$Api$Data$providerPath))));
    });
    var $author$project$Pages$PracticeSetup$Legal$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    S4: $elm$core$Maybe$Just(string)
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    Oy: $author$project$Utils$String$toMaybe(string)
                });
            default:
                var address = field.a;
                return _Utils_update(fields, {
                    aeO: address
                });
        }
    });
    var $author$project$Pages$PracticeSetup$Legal$EinValidation = 0;
    var $author$project$Pages$PracticeSetup$Legal$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($author$project$Ui$Form$Ein$ifInvalid, function($) {
            return $.Oy;
        }, _Utils_Tuple2(0, 'Please enter a valid EIN or leave empty'))
    ]));
    var $author$project$Pages$PracticeSetup$Legal$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                var form = A3($author$project$Utils$Form$update, $author$project$Pages$PracticeSetup$Legal$formFieldsUpdate, field, model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: form
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v1 = $author$project$Utils$Form$fields(model.PU);
                var legalAddress = _v1.aeO;
                var _v2 = A2($author$project$Components$AddressInput$update, subMsg, legalAddress);
                var addressInputModel = _v2.a;
                var addressInputCmd = _v2.b;
                var outMsgs = _v2.c;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$PracticeSetup$Legal$formFieldsUpdate, $author$project$Pages$PracticeSetup$Legal$LegalAddress(addressInputModel), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Legal$AddressInputMsg, addressInputCmd), outMsgs);
            case 2:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$PracticeSetup$Legal$formFieldsValidator, model.PU);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    var fields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
                    var legalAddress = $author$project$Components$AddressInput$getAddress(fields.aeO);
                    var hasAnyAddressField = A2($elm$core$List$any, $elm$core$Basics$identity, _List_fromArray([
                        !_Utils_eq(legalAddress.pW, $elm$core$Maybe$Nothing),
                        !_Utils_eq(legalAddress.p0, $elm$core$Maybe$Nothing),
                        !_Utils_eq(legalAddress.ri, $elm$core$Maybe$Nothing),
                        !_Utils_eq(legalAddress.yG, $elm$core$Maybe$Nothing),
                        !_Utils_eq(legalAddress.s4, $elm$core$Maybe$Nothing),
                        !_Utils_eq(legalAddress.tK, $elm$core$Maybe$Nothing)
                    ]));
                    var legalName = fields.S4;
                    var ein = fields.Oy;
                    var cmd = A3($author$project$Api$Provider$PracticeBusinessProfile$create, model.Ej, {
                        Oy: ein,
                        aeO: hasAnyAddressField ? $elm$core$Maybe$Just({
                            pW: legalAddress.pW,
                            p0: legalAddress.p0,
                            ri: legalAddress.ri,
                            yG: legalAddress.yG,
                            s4: legalAddress.s4,
                            tK: legalAddress.tK
                        }) : $elm$core$Maybe$Nothing,
                        S4: legalName
                    }, $author$project$Pages$PracticeSetup$Legal$GotResponse);
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), cmd, _List_Nil);
                } else {
                    var newForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$PracticeSetup$Legal$Ein = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Legal$FormSubmitted = {
        $: 2
    };
    var $author$project$Pages$PracticeSetup$Legal$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Legal$LegalName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Form$Ein$Placeholder = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Form$Ein$placeholder = $author$project$Ui$Form$Ein$Placeholder;
    var $author$project$Pages$PracticeSetup$Legal$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Verify your business information')
                        ]))
                    ])),
                    function() {
                        var fields = $author$project$Utils$Form$fields(model.PU);
                        return A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('This information should be used to verify your business when necessary for services including phone registration for fax and text messages, eRX, payment processing, and more.')
                            ])),
                            A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('All information should match your IRS SS-4 form or there may be delays in activating some features on your account. If you have not yet registered your business with the IRS, leave this information blank.')
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9),
                                $author$project$Ui$Form$Group$label('Legal Business Name')
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Input$view(_List_fromArray([
                                    $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', fields.S4)),
                                    $author$project$Ui$Form$Input$onInput(function(name) {
                                        return $author$project$Pages$PracticeSetup$Legal$FormUpdated($author$project$Pages$PracticeSetup$Legal$LegalName(name));
                                    }),
                                    $author$project$Ui$Form$Input$placeholder('Legal name from IRS SS-4 Form')
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9),
                                $author$project$Ui$Form$Group$label('EIN')
                            ]), _List_fromArray([
                                $author$project$Ui$Form$Ein$view(_List_fromArray([
                                    $author$project$Ui$Form$Ein$value(fields.Oy),
                                    $author$project$Ui$Form$Ein$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$PracticeSetup$Legal$FormUpdated, $author$project$Pages$PracticeSetup$Legal$Ein)),
                                    $author$project$Ui$Form$Ein$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, model.PU)),
                                    $author$project$Ui$Form$Ein$errors(A2($author$project$Utils$Form$validationErrors, 0, model.PU)),
                                    $author$project$Ui$Form$Ein$placeholder('12-3456789')
                                ]))
                            ])),
                            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$labelSpanSm(3),
                                $author$project$Ui$Form$Group$inputSpanSm(9),
                                $author$project$Ui$Form$Group$label('Legal Address')
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, $author$project$Pages$PracticeSetup$Legal$AddressInputMsg, A2($author$project$Components$AddressInput$view, _List_Nil, fields.aeO))
                            ])),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Next'
                            }, _List_fromArray([
                                $author$project$Ui$Button$pull(1),
                                $author$project$Ui$Button$margin(8),
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$onClick($author$project$Pages$PracticeSetup$Legal$FormSubmitted)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Next')
                            ]))
                        ]));
                    }()
                ]))
            ]),
            $2: 'Practice Setup - Legal Information'
        };
    };
    var $author$project$Pages$PracticeSetup$Legal$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Legal$init,
        aeR: $author$project$Pages$PracticeSetup$Legal$load,
        ag3: $author$project$Pages$PracticeSetup$Legal$save,
        ahE: $author$project$Pages$PracticeSetup$Legal$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Legal$update,
        aid: $author$project$Pages$PracticeSetup$Legal$view
    });
    var $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$PaymentProcessing$Stripe = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$PaymentProcessing$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = function() {
            if ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest') {
                var _v2 = A5($author$project$Components$PaymentProcessing$init, session, practice, shared, query, {
                    aK: true
                });
                var paymentProcessing = _v2.a;
                var paymentProcessingCmd = _v2.b;
                return _Utils_Tuple2($author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing(paymentProcessing), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg, paymentProcessingCmd));
            } else {
                var _v3 = A5($author$project$Components$Stripe$init, session, practice, shared, query, {
                    aK: true
                });
                var stripe = _v3.a;
                var stripeCmd = _v3.b;
                return _Utils_Tuple2($author$project$Pages$PracticeSetup$PaymentProcessing$Stripe(stripe), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg, stripeCmd));
            }
        }();
        var paymentProcessor = _v1.a;
        var paymentProcessorCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            F3: $author$project$Shared$isHintAdmin(shared),
            Wo: paymentProcessor
        }, paymentProcessorCmd);
    });
    var $author$project$Pages$PracticeSetup$PaymentProcessing$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            F3: $author$project$Shared$isHintAdmin(shared)
        }), A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$PaymentProcessing$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$PaymentProcessing$subscriptions = function(model) {
        var _v0 = model.Wo;
        if (_v0.$ === 1) {
            var paymentProcessing = _v0.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg, $author$project$Components$PaymentProcessing$subscriptions(paymentProcessing));
        } else {
            var stripe = _v0.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg, $author$project$Components$Stripe$subscriptions(stripe));
        }
    };
    var $author$project$Pages$PracticeSetup$PaymentProcessing$update = F2(function(msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var _v1 = model.Wo;
            if (!_v1.$) {
                var stripe = _v1.a;
                var _v2 = A3($author$project$Components$Stripe$update, subMsg, stripe, model.Ej);
                var newStripe = _v2.a;
                var stripeCmd = _v2.b;
                var outMsgs = _v2.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    Wo: $author$project$Pages$PracticeSetup$PaymentProcessing$Stripe(newStripe)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg, stripeCmd), outMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        } else {
            var subMsg = msg.a;
            var _v3 = model.Wo;
            if (_v3.$ === 1) {
                var paymentProcessing = _v3.a;
                var _v4 = A3($author$project$Components$PaymentProcessing$update, subMsg, paymentProcessing, model.Ej);
                var newPaymentProcessing = _v4.a;
                var paymentProcessingCmd = _v4.b;
                var outMsgs = _v4.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    Wo: $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessing(newPaymentProcessing)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg, paymentProcessingCmd), outMsgs);
            } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$PracticeSetup$PaymentProcessing$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.Wo;
                    if (_v0.$ === 1) {
                        var paymentProcessing = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$PracticeSetup$PaymentProcessing$PaymentProcessingMsg, $author$project$Components$PaymentProcessing$view(paymentProcessing));
                    } else {
                        var stripe = _v0.a;
                        return A2($elm$html$Html$map, $author$project$Pages$PracticeSetup$PaymentProcessing$StripeMsg, $author$project$Components$Stripe$view(stripe));
                    }
                }()
            ]),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$PaymentProcessing$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$PaymentProcessing$init,
        aeR: $author$project$Pages$PracticeSetup$PaymentProcessing$load,
        ag3: $author$project$Pages$PracticeSetup$PaymentProcessing$save,
        ahE: $author$project$Pages$PracticeSetup$PaymentProcessing$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$PaymentProcessing$update,
        aid: $author$project$Pages$PracticeSetup$PaymentProcessing$view
    });
    var $author$project$Pages$PracticeSetup$Plans$ListMsg = $elm$core$Basics$identity;
    var $author$project$Pages$PracticeSetup$Plans$init = F4(function(session, practice, shared, params) {
        var _v0 = $author$project$Components$Admin$Plans$List$init(shared.Ej)(session)($author$project$Api$Platform$User$Shared$isAdmin($author$project$Api$Platform$Session$One$user(session)))(_List_fromArray([
            2,
            3
        ]))($author$project$Spa$Generated$Route$Admin__Plans__Top)($author$project$Spa$Generated$Route$Admin__Plans__New)($author$project$Spa$Generated$Route$Admin__Plans__Id_String)(_List_fromArray([
            $elm$html$Html$text("To edit or add more plans later, you can go to Admin \u2192 Membership Options page in the product.")
        ]))(params.Bz)({
            aK: true
        })($elm$core$Maybe$Just(practice));
        var list = _v0.a;
        var listCmd = _v0.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            rk: list
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd));
    });
    var $author$project$Pages$PracticeSetup$Plans$load = F2(function(shared, model) {
        return _Utils_Tuple2(model, A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$Plans$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Plans$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$PracticeSetup$Plans$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Admin$Plans$List$update, model.Ej, subMsg, model.rk);
        var list = _v1.a;
        var listCmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            rk: list
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, listCmd), outMsgs);
    });
    var $author$project$Pages$PracticeSetup$Plans$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Admin$Plans$List$view(model.rk))
            ]),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Plans$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Plans$init,
        aeR: $author$project$Pages$PracticeSetup$Plans$load,
        ag3: $author$project$Pages$PracticeSetup$Plans$save,
        ahE: $author$project$Pages$PracticeSetup$Plans$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Plans$update,
        aid: $author$project$Pages$PracticeSetup$Plans$view
    });
    var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var timeZone = _v0.HP;
        var currentDate = _v0.cP;
        var hinterViewOff = _v0.aeb;
        var query = _v1.Bz;
        var params = _v1.VU;
        return A2($elm$core$Tuple$mapFirst, function(planForm) {
            return {
                Ej: apiClient,
                nB: planForm
            };
        }, A9($author$project$Components$Plan$Form$init, apiClient, timeZone, currentDate, session, practice, query, $author$project$Spa$Generated$Route$Admin__Plans__Top, params.aef, {
            aeb: hinterViewOff,
            W4: true
        }));
    });
    var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$load = F2(function(shared, model) {
        return _Utils_Tuple2(model, A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$subscriptions = function(model) {
        return $author$project$Components$Plan$Form$subscriptions(model.nB);
    };
    var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$update = F2(function(msg, model) {
        return A2($author$project$Utils$Tuple3$mapFirst, function(planForm) {
            return _Utils_update(model, {
                nB: planForm
            });
        }, A3($author$project$Components$Plan$Form$update, model.Ej, msg, model.nB));
    });
    var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$view = function(model) {
        return {
            fb: $author$project$Components$Plan$Form$view(model.nB),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$init,
        aeR: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$load,
        ag3: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$save,
        ahE: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$update,
        aid: $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$view
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$Model = $elm$core$Basics$identity;
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$initEmptyRules = {
        Rd: {
            OM: false
        },
        TN: {
            OM: false
        }
    };
    var $author$project$Components$Plan$Form$RegistrationFeePricingFields$empty = $author$project$Utils$Form$init({
        cK: $elm$core$Maybe$Nothing,
        Rd: $elm$core$Maybe$Nothing,
        TN: $elm$core$Maybe$Nothing,
        Zk: $author$project$Components$Plan$Form$RegistrationFeePricingFields$initEmptyRules
    });
    var $author$project$Components$Plan$BasicForm$initEmptyRules = {
        Up: {
            OM: false
        }
    };
    var $author$project$Components$Plan$BasicForm$empty = F2(function(practice, isViewingAsHinter) {
        var settings = {
            yu: isViewingAsHinter,
            W1: practice,
            W4: true
        };
        return A2($author$project$Components$Plan$BasicForm$BasicPlanForm, settings, $author$project$Utils$Form$init({
            IF: false,
            vu: $elm$core$Maybe$Nothing,
            vv: false,
            Kh: false,
            Ky: false,
            p7: $elm$core$Maybe$Nothing,
            xb: $elm$core$Maybe$Nothing,
            xc: 'Membership Fee',
            Nx: 'month',
            NQ: A2($author$project$Components$TranslatedRichText$init, $elm$core$Dict$empty, 'plan-description-language-dropdown'),
            qr: false,
            iB: false,
            l1: false,
            mw: 0,
            Q4: $elm$core$Maybe$Nothing,
            Up: $elm$core$Maybe$Nothing,
            zj: $elm$core$Maybe$Nothing,
            zk: false,
            zr: '',
            Bw: $elm$core$Maybe$Nothing,
            Bx: false,
            BF: $elm$core$Maybe$Nothing,
            sr: 'Unassigned',
            BG: '',
            BH: 'Registration Fee',
            de: $author$project$Components$Plan$Form$RegistrationFeePricingFields$empty,
            Zk: $author$project$Components$Plan$BasicForm$initEmptyRules,
            Cn: $elm$core$Maybe$Nothing,
            Co: false,
            Hy: $elm$core$Maybe$Nothing
        }));
    });
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initEmptyRules = {
        tQ: {
            OM: false
        },
        tR: {
            OM: false
        },
        wa: {
            OM: false
        },
        wb: {
            OM: false
        },
        wX: {
            OM: false
        },
        xG: {
            OM: false
        },
        xH: {
            OM: false
        },
        zP: {
            OM: false
        },
        CE: {
            OM: false
        }
    };
    var $author$project$Components$Plan$Form$FamilyMembershipPricingFields$empty = $author$project$Utils$Form$init({
        tQ: $elm$core$Maybe$Nothing,
        tR: $elm$core$Maybe$Nothing,
        wa: $elm$core$Maybe$Nothing,
        wb: $elm$core$Maybe$Nothing,
        wX: $elm$core$Maybe$Nothing,
        xG: $elm$core$Maybe$Nothing,
        xH: $elm$core$Maybe$Nothing,
        zP: $elm$core$Maybe$Nothing,
        Zk: $author$project$Components$Plan$Form$FamilyMembershipPricingFields$initEmptyRules,
        CE: $elm$core$Maybe$Nothing
    });
    var $author$project$Components$Plan$Form$IndividualMembershipPricingFields$empty = $author$project$Utils$Form$init({
        I_: $author$project$Components$Plan$Form$IndividualMembershipPricingFields$defaultAgeRules('month')
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$initFormFields = F2(function(practice, isViewingAsHinter) {
        var membershipPricingForm = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$empty;
        var familyPricingForm = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$empty;
        var defaultGroupPricingType = 'family';
        var basicPlanForm = A2($author$project$Components$Plan$BasicForm$empty, practice, isViewingAsHinter);
        return {
            aB: basicPlanForm,
            xm: false,
            cY: familyPricingForm,
            Qh: defaultGroupPricingType,
            c$: membershipPricingForm
        };
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$init = F3(function(apiClient, practice, isViewingAsHinter) {
        return _Utils_Tuple2({
            Ej: apiClient,
            PU: $author$project$Utils$Form$init(A2($author$project$Components$Plan$PracticeSetupNewPlan$initFormFields, practice, isViewingAsHinter)),
            W1: practice
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$PracticeSetup$Plans$New$init = F4(function(_v0, practice, shared, _v1) {
        var _v2 = A3($author$project$Components$Plan$PracticeSetupNewPlan$init, shared.Ej, practice, $author$project$Shared$isHintAdmin(shared));
        var practiceSetupNewPlan = _v2.a;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            F3: $author$project$Shared$isHintAdmin(shared),
            se: practiceSetupNewPlan
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$PracticeSetup$Plans$New$load = F2(function(shared, model) {
        return _Utils_Tuple2(model, A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$Plans$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Plans$New$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$PracticeSetup$Plans$New$NewPlanMsg = $elm$core$Basics$identity;
    var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlan = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFields = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$MembershipPricingFields = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$ToggleFixedMembershipPricing = {
        $: 3
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$Created = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Plan$encodeCreateFullFields = function(fields) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('name', $elm$json$Json$Encode$string(fields.zr)),
            _Utils_Tuple2('buyable', $elm$json$Json$Encode$bool(fields.Ky)),
            _Utils_Tuple2('plan_type', $elm$json$Json$Encode$string($author$project$Api$PlanType$toString(2))),
            _Utils_Tuple2('default_period', $elm$json$Json$Encode$string(fields.Nx)),
            _Utils_Tuple2('discounts_enabled', $elm$json$Json$Encode$bool(false)),
            _Utils_Tuple2('bills_at_end_of_period', $elm$json$Json$Encode$bool(fields.Kh)),
            _Utils_Tuple2('individual_registration_fee_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.Rd)),
            _Utils_Tuple2('minimum_enrollment_period_in_months', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.Up)),
            _Utils_Tuple2('default_charge_name', $elm$json$Json$Encode$string(fields.xc)),
            _Utils_Tuple2('default_charge_description', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, fields.xb)),
            _Utils_Tuple2('registration_fee_category', A2($author$project$Utils$Encode$nullable, function(id) {
                return $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string(id))
                ]));
            }, fields.BF)),
            _Utils_Tuple2('max_registration_fee_in_cents', A2($author$project$Utils$Encode$nullable, $author$project$Currency$encode, fields.TN)),
            _Utils_Tuple2('month_adjustment_percent', $author$project$Percentage$encode(fields.zj)),
            _Utils_Tuple2('month_allowed', $elm$json$Json$Encode$bool(fields.zk)),
            _Utils_Tuple2('quarter_adjustment_percent', $author$project$Percentage$encode(fields.Bw)),
            _Utils_Tuple2('quarter_allowed', $elm$json$Json$Encode$bool(fields.Bx)),
            _Utils_Tuple2('semi_annual_adjustment_percent', $author$project$Percentage$encode(fields.Cn)),
            _Utils_Tuple2('semi_annual_allowed', $elm$json$Json$Encode$bool(fields.Co)),
            _Utils_Tuple2('annual_adjustment_percent', $author$project$Percentage$encode(fields.vu)),
            _Utils_Tuple2('annual_allowed', $elm$json$Json$Encode$bool(fields.vv)),
            _Utils_Tuple2('age_rate_rules', A2($elm$json$Json$Encode$list, $author$project$Api$Provider$Plan$encodeAgeRateRuleFields, fields.I_)),
            _Utils_Tuple2('group_pricing_type', $elm$json$Json$Encode$string(fields.Qh)),
            _Utils_Tuple2('family_num_children_included', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.xH)),
            _Utils_Tuple2('number_additional_children_allowed', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.zP)),
            _Utils_Tuple2('children_age_limit', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, fields.wa)),
            _Utils_Tuple2('couple_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.wX)),
            _Utils_Tuple2('family_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.xG)),
            _Utils_Tuple2('single_parent_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.CE)),
            _Utils_Tuple2('additional_adult_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.tQ)),
            _Utils_Tuple2('additional_child_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.tR)),
            _Utils_Tuple2('children_only_discount_rule', A2($author$project$Utils$Encode$nullable, $author$project$Api$Provider$Plan$encodeFamilyDiscountRule, fields.wb)),
            _Utils_Tuple2('discounts_enabled', $elm$json$Json$Encode$bool(fields.xm)),
            _Utils_Tuple2('registration_fee_name', $elm$json$Json$Encode$string(fields.BH)),
            _Utils_Tuple2('registration_fee_description', $elm$json$Json$Encode$string(fields.BG))
        ]));
    };
    var $author$project$Api$Provider$Plan$createFull = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('plan', $author$project$Api$Provider$Plan$encodeCreateFullFields(fields))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Plan$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Provider$Plan$plansPath)));
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$createPlanFields = F2(function(sharedFields, formFields) {
        var membershipPricingFormFields = $author$project$Components$Plan$Form$IndividualMembershipPricingFields$formFields(formFields.c$);
        var familyMembershipPricingFormFields = $author$project$Components$Plan$Form$FamilyMembershipPricingFields$formFields(formFields.cY);
        var basicPlanFormFields = $author$project$Components$Plan$BasicForm$formFields(formFields.aB);
        var registrationFeeFields = $author$project$Components$Plan$Form$RegistrationFeePricingFields$formFields(basicPlanFormFields.de);
        return {
            tQ: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.tQ),
            tR: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.tR),
            I_: A2($elm$core$List$map, function(ageRateRule) {
                return {
                    Jk: ageRateRule.dc.Jk,
                    e3: ageRateRule.dc.e3,
                    Mg: A2($elm$core$Maybe$map, function(coupleRule) {
                        return {
                            Jk: coupleRule.dc.Jk,
                            e3: coupleRule.dc.e3,
                            Uu: coupleRule.dc.Uu,
                            gb: coupleRule.dc.gb,
                            XU: coupleRule.dc.XU,
                            gx: coupleRule.dc.gx,
                            ZH: coupleRule.dc.ZH,
                            gM: coupleRule.dc.gM
                        };
                    }, ageRateRule.Mg),
                    P_: $elm$core$Maybe$Just(ageRateRule.P_),
                    Uu: ageRateRule.dc.Uu,
                    gb: ageRateRule.dc.gb,
                    XU: ageRateRule.dc.XU,
                    gx: ageRateRule.dc.gx,
                    ZH: ageRateRule.dc.ZH,
                    gM: ageRateRule.dc.gM,
                    $4: ageRateRule.$4,
                    aaG: ageRateRule.aaG
                };
            }, membershipPricingFormFields.I_),
            vu: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.vu),
            vv: basicPlanFormFields.vv,
            Kh: basicPlanFormFields.Kh,
            Ky: basicPlanFormFields.Ky,
            wa: familyMembershipPricingFormFields.wa,
            wb: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.wb),
            wX: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.wX),
            xb: basicPlanFormFields.xb,
            xc: basicPlanFormFields.xc,
            Nx: basicPlanFormFields.Nx,
            xm: formFields.xm,
            xG: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.xG),
            xH: familyMembershipPricingFormFields.xH,
            Qh: sharedFields.Qh,
            Rd: registrationFeeFields.Rd,
            TN: registrationFeeFields.TN,
            Up: basicPlanFormFields.Up,
            zj: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.zj),
            zk: basicPlanFormFields.zk,
            zr: basicPlanFormFields.zr,
            zP: familyMembershipPricingFormFields.zP,
            Bw: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Bw),
            Bx: basicPlanFormFields.Bx,
            BF: basicPlanFormFields.BF,
            BG: basicPlanFormFields.BG,
            BH: basicPlanFormFields.BH,
            Cn: A2($elm$core$Maybe$withDefault, $author$project$Percentage$zero, basicPlanFormFields.Cn),
            Co: basicPlanFormFields.Co,
            CE: A2($elm$core$Maybe$map, function(familyDiscountRule) {
                return {
                    Jo: familyDiscountRule.Jo,
                    Jp: familyDiscountRule.Jp,
                    Ux: familyDiscountRule.Ux,
                    Uy: familyDiscountRule.Uy,
                    XY: familyDiscountRule.XY,
                    XZ: familyDiscountRule.XZ,
                    ZL: familyDiscountRule.ZL,
                    ZM: familyDiscountRule.ZM
                };
            }, familyMembershipPricingFormFields.CE),
            Hy: basicPlanFormFields.Hy
        };
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$createPlan = F3(function(sharedFields, apiClient, validFormFields) {
        var formFields = $rtfeldman$elm_validate$Validate$fromValid(validFormFields);
        return A3($author$project$Api$Provider$Plan$createFull, apiClient, A2($author$project$Components$Plan$PracticeSetupNewPlan$createPlanFields, sharedFields, formFields), $author$project$Components$Plan$PracticeSetupNewPlan$Created);
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var basicPlanForm = field.a;
                return _Utils_update(fields, {
                    aB: basicPlanForm
                });
            case 1:
                var membershipPricingForm = field.a;
                return _Utils_update(fields, {
                    c$: membershipPricingForm
                });
            case 2:
                var familyMembershipPricingForm = field.a;
                return _Utils_update(fields, {
                    cY: familyMembershipPricingForm
                });
            case 3:
                var groupPricingType = fields.Qh === 'fixed_pricing' ? 'family' : 'fixed_pricing';
                return _Utils_update(fields, {
                    Qh: groupPricingType
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    xm: bool
                });
        }
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFieldValidation = 0;
    var $author$project$Components$Plan$PracticeSetupNewPlan$validateBasicPlanFormFields = function(_v0) {
        var basicPlan = _v0.aB;
        return $author$project$Components$Plan$BasicForm$hasErrors(basicPlan) ? _List_fromArray([
            _Utils_Tuple2(0, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsValidation = 2;
    var $author$project$Components$Plan$PracticeSetupNewPlan$validateFamilyMembershipPricingFields = function(_v0) {
        var familyMembershipPricingForm = _v0.cY;
        return $author$project$Components$Plan$Form$FamilyMembershipPricingFields$hasErrors(familyMembershipPricingForm) ? _List_fromArray([
            _Utils_Tuple2(2, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsValidation = 1;
    var $author$project$Components$Plan$PracticeSetupNewPlan$validateIndividualMembershipPricingFields = function(_v0) {
        var membershipPricingForm = _v0.c$;
        return $author$project$Components$Plan$Form$IndividualMembershipPricingFields$hasErrors(membershipPricingForm) ? _List_fromArray([
            _Utils_Tuple2(1, '')
        ]) : _List_Nil;
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateBasicPlanFormFields),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateIndividualMembershipPricingFields),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Components$Plan$PracticeSetupNewPlan$validateFamilyMembershipPricingFields)
    ]));
    var $author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields = F2(function(maybePlan, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var groupPricingType = _v0.Qh;
        var basicPlan = _v0.aB;
        var _v1 = $author$project$Components$Plan$BasicForm$formFields(basicPlan);
        var defaultPeriod = _v1.Nx;
        return {
            Nx: defaultPeriod,
            Qh: groupPricingType,
            GW: maybePlan
        };
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$updateForm = F3(function(model, field, newPlanForm) {
        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate, field, newPlanForm);
        return _Utils_update(model, {
            PU: newForm
        });
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var planFormMsg = msg.a;
                var _v2 = $author$project$Utils$Form$fields(model.PU);
                var basicPlan = _v2.aB;
                var updateResult = A4($author$project$Components$Plan$BasicForm$update, apiClient, planFormMsg, basicPlan, $elm$core$Maybe$Nothing);
                var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate, $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlan(updateResult.zi), model.PU);
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: newForm
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated, updateResult.EQ), updateResult.at);
            case 1:
                var membershipPricingFieldsMsg = msg.a;
                var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.PU);
                var _v3 = $author$project$Utils$Form$fields(model.PU);
                var membershipPricingForm = _v3.c$;
                var newMembershipPricingResult = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$update, sharedFields, membershipPricingFieldsMsg, membershipPricingForm);
                var newModel = function() {
                    var _v4 = newMembershipPricingResult.adu;
                    if (!_v4.$) {
                        var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate, $author$project$Components$Plan$PracticeSetupNewPlan$MembershipPricingFields(newMembershipPricingResult.zi), model.PU);
                        return _Utils_update(model, {
                            PU: newForm
                        });
                    } else return A3($author$project$Components$Plan$PracticeSetupNewPlan$updateForm, model, $author$project$Components$Plan$PracticeSetupNewPlan$ToggleFixedMembershipPricing, model.PU);
                }();
                return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated, newMembershipPricingResult.EQ), newMembershipPricingResult.at);
            case 2:
                var familyPricingFieldsMsg = msg.a;
                var _v5 = $author$project$Utils$Form$fields(model.PU);
                var familyMembershipPricingForm = _v5.cY;
                var newFamilyMembershipPricingResult = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$update, familyPricingFieldsMsg, familyMembershipPricingForm, $elm$core$Maybe$Nothing);
                var newModel = function() {
                    var newForm = A3($author$project$Utils$Form$update, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsUpdate, $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFields(newFamilyMembershipPricingResult.zi), model.PU);
                    return _Utils_update(model, {
                        PU: newForm
                    });
                }();
                return _Utils_Tuple3(newModel, A2($elm$core$Platform$Cmd$map, $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated, newFamilyMembershipPricingResult.EQ), newFamilyMembershipPricingResult.at);
            case 3:
                var field = msg.a;
                var newModel = A3($author$project$Components$Plan$PracticeSetupNewPlan$updateForm, model, field, model.PU);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$PracticeSetup__Plans), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Plan successfully created.'),
                    $author$project$OutMsg$RefreshPractice
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.PU);
                var fields = $author$project$Utils$Form$fields(model.PU);
                var validatedFamilyMembershipPricingForm = function() {
                    var _v13 = A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$validate, fields.cY, sharedFields, $elm$core$Maybe$Nothing);
                    if (!_v13.$) {
                        var _v14 = _v13.a;
                        var newForm_ = _v14.a;
                        return newForm_;
                    } else {
                        var newForm_ = _v13.a;
                        return newForm_;
                    }
                }();
                var validatedMembershipPricingForm = function() {
                    var _v11 = A3($author$project$Components$Plan$Form$IndividualMembershipPricingFields$validate, sharedFields, fields.c$, $elm$core$Maybe$Nothing);
                    if (!_v11.$) {
                        var _v12 = _v11.a;
                        var newForm = _v12.a;
                        return newForm;
                    } else {
                        var newForm = _v11.a;
                        return newForm;
                    }
                }();
                var basicPlanForm = function() {
                    var _v9 = A2($author$project$Components$Plan$BasicForm$validate, fields.aB, $elm$core$Maybe$Nothing);
                    if (!_v9.$) {
                        var _v10 = _v9.a;
                        var newForm = _v10.a;
                        return newForm;
                    } else {
                        var newForm = _v9.a;
                        return newForm;
                    }
                }();
                var newValidForm = A2($author$project$Utils$Form$set, _Utils_update(fields, {
                    aB: basicPlanForm,
                    cY: validatedFamilyMembershipPricingForm,
                    c$: validatedMembershipPricingForm
                }), model.PU);
                var _v7 = A2($author$project$Utils$Form$validate, $author$project$Components$Plan$PracticeSetupNewPlan$formFieldsValidator, newValidForm);
                if (!_v7.$) {
                    var _v8 = _v7.a;
                    var newForm = _v8.a;
                    var validFormFields = _v8.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), A3($author$project$Components$Plan$PracticeSetupNewPlan$createPlan, sharedFields, apiClient, validFormFields), _List_Nil);
                } else {
                    var newForm = _v7.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
        }
    });
    var $author$project$Pages$PracticeSetup$Plans$New$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Plan$PracticeSetupNewPlan$update, model.Ej, subMsg, model.se);
        var practiceSetupNewPlanModel = _v1.a;
        var practiceSetupNewPlanCmd = _v1.b;
        return _Utils_Tuple3(_Utils_update(model, {
            se: practiceSetupNewPlanModel
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, practiceSetupNewPlanCmd), _List_Nil);
    });
    var $author$project$Components$Plan$PracticeSetupNewPlan$Save = {
        $: 5
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$viewFamilyDiscountsToggle = function(model) {
        var _v0 = $author$project$Utils$Form$fields(model.PU);
        var discountsEnabled = _v0.xm;
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Do you offer discounts to family members who enroll together?'),
                $author$project$Utils$Html$noBreakSpace,
                A2($elm$html$Html$map, $elm$core$Basics$never, $author$project$Ui$SupportDocumentLink$view('https://support.hint.com/account-configuration/configuring-your-membership-rates-and-billing-options'))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(discountsEnabled),
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled(true))))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Yes')
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                        $author$project$Ui$Form$Radio$value(!discountsEnabled),
                        $author$project$Ui$Form$Radio$inline,
                        $author$project$Ui$Form$Radio$onCheck(A2($elm$core$Basics$composeL, $author$project$Components$Plan$PracticeSetupNewPlan$FormUpdated, $elm$core$Basics$always($author$project$Components$Plan$PracticeSetupNewPlan$DiscountsEnabled(false))))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('No')
                        ]))
                    ]))
                ]))
            ])),
            $author$project$Utils$Html$noBreakSpace
        ]));
    };
    var $author$project$Components$Plan$PracticeSetupNewPlan$view = function(_v0) {
        var model = _v0;
        var sharedFields = A2($author$project$Components$Plan$PracticeSetupNewPlan$initSharedFields, $elm$core$Maybe$Nothing, model.PU);
        var _v1 = $author$project$Utils$Form$fields(model.PU);
        var basicPlan = _v1.aB;
        var membershipPricingForm = _v1.c$;
        var familyMembershipPricingForm = _v1.cY;
        var discountsEnabled = _v1.xm;
        return _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$onlyBorderLeft
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Plan$PracticeSetupNewPlan$BasicPlanFormUpdated), A2($author$project$Components$Plan$BasicForm$view, basicPlan, $elm$core$Maybe$Nothing)))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Plan$PracticeSetupNewPlan$IndividualMembershipPricingFieldsUpdated, A4($author$project$Components$Plan$Form$IndividualMembershipPricingFields$view, sharedFields, model.W1, $elm$core$Maybe$Nothing, membershipPricingForm))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                            $author$project$Components$Plan$PracticeSetupNewPlan$viewFamilyDiscountsToggle(model),
                            discountsEnabled ? A2($elm$html$Html$map, $author$project$Components$Plan$PracticeSetupNewPlan$FamilyMembershipPricingFieldsUpdated, A3($author$project$Components$Plan$Form$FamilyMembershipPricingFields$view, sharedFields, $elm$core$Maybe$Nothing, familyMembershipPricingForm)) : $author$project$Utils$Html$empty
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$flexCol
                ]), _List_fromArray([
                    A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$info
                        ]), _List_fromArray([
                            $elm$html$Html$text('If you\'re looking for additional options, or have more than one plan, you can access advanced settings after saving your plan.')
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$justifyRight
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Save new plan'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$onClick($author$project$Components$Plan$PracticeSetupNewPlan$Save)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Save')
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$PracticeSetup$Plans$New$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), $author$project$Components$Plan$PracticeSetupNewPlan$view(model.se)),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Plans$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Plans$New$init,
        aeR: $author$project$Pages$PracticeSetup$Plans$New$load,
        ag3: $author$project$Pages$PracticeSetup$Plans$New$save,
        ahE: $author$project$Pages$PracticeSetup$Plans$New$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Plans$New$update,
        aid: $author$project$Pages$PracticeSetup$Plans$New$view
    });
    var $author$project$Pages$PracticeSetup$Team$TeamFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$PracticeSetup$Team$init = F4(function(session, practice, shared, _v0) {
        var onboardingClinical = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$onboardingClinical, $author$project$Api$Platform$Session$One$organization(session)));
        var usingClinicalEmr = $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice) || onboardingClinical;
        var _v1 = A4($author$project$Components$TeamForm$init, shared.cP, session, practice, {
            aK: true,
            dn: usingClinicalEmr
        });
        var teamFormModel = _v1.a;
        var teamFormCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            W1: practice,
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            g3: teamFormModel,
            dn: usingClinicalEmr
        }, A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Team$TeamFormMsg, teamFormCmd));
    });
    var $author$project$Pages$PracticeSetup$Team$load = F2(function(shared, model) {
        return _Utils_Tuple2(model, A2($author$project$Utils$PracticeSetup$redirectIfOnboardingComplete, shared.Z$, shared.aeb));
    });
    var $author$project$Pages$PracticeSetup$Team$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$PracticeSetup$Team$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$PracticeSetup$Team$Updated = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Platform$User$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Pages$PracticeSetup$Team$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$TeamForm$update, subMsg, model.g3, model.Ej);
                var teamFormModel = _v1.a;
                var teamFormCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    g3: teamFormModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$PracticeSetup$Team$TeamFormMsg, teamFormCmd), _List_Nil);
            case 1:
                var _v2 = $author$project$Components$TeamForm$validate(model.g3);
                if (!_v2.$) {
                    var _v3 = _v2.a;
                    var validatedForm = _v3.a;
                    var validFormFields = _v3.b;
                    var fields = $author$project$Components$TeamForm$teamMemberFormFields($rtfeldman$elm_validate$Validate$fromValid(validFormFields));
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: $author$project$Api$Data$Loading,
                        g3: validatedForm
                    }), A4($author$project$Api$Provider$TeamMember$update, model.Ej, $author$project$Api$Platform$User$Shared$id($author$project$Api$Platform$Session$One$user(model.Z$)), {
                        M7: fields.M7,
                        xa: fields.xa,
                        NG: fields.NG,
                        Tl: $elm$core$Maybe$Nothing,
                        U8: $elm$core$Maybe$Nothing,
                        U9: fields.U9,
                        WF: fields.WF,
                        Xm: fields.Xm,
                        XK: fields.XK,
                        YB: $elm$core$Maybe$Nothing,
                        YW: $elm$core$Maybe$Nothing,
                        ag_: $elm$core$Maybe$Nothing,
                        CI: fields.CI
                    }, $author$project$Pages$PracticeSetup$Team$Updated), _List_Nil);
                } else {
                    var erroredForm = _v2.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked,
                        g3: erroredForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var nextRoute = model.dn ? $author$project$Spa$Generated$Route$PracticeSetup__Communications : $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing;
                    return _Utils_Tuple3(_Utils_update(model, {
                        j_: $author$project$Api$Data$NotAsked
                    }), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, nextRoute), _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    j_: $author$project$Api$Data$NotAsked
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Pages$PracticeSetup$Team$FormSubmitted = {
        $: 1
    };
    var $author$project$Pages$PracticeSetup$Team$view = function(model) {
        var loading = _Utils_eq(model.j_, $author$project$Api$Data$Loading);
        var headerText = model.dn ? 'Create your Clinical Profile' : 'Create your Profile';
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Form$view, _List_fromArray([
                    $author$project$Ui$Form$horizontal,
                    $author$project$Ui$Form$autocomplete(false),
                    $author$project$Ui$Form$noValidate(true),
                    $author$project$Ui$Form$onSubmit($author$project$Pages$PracticeSetup$Team$FormSubmitted)
                ]), _List_fromArray([
                    A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                            $author$project$Ui$Panel$title(_List_fromArray([
                                $elm$html$Html$text(headerText)
                            ]))
                        ])),
                        A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Pages$PracticeSetup$Team$TeamFormMsg, $author$project$Components$TeamForm$view(model.g3))
                        ])),
                        A2($author$project$Ui$Panel$footer, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$div, _List_Nil, _List_Nil),
                            A3($author$project$Ui$Button$view, {
                                abP: 'Next'
                            }, _List_fromArray([
                                $author$project$Ui$Button$primary,
                                $author$project$Ui$Button$submit,
                                $author$project$Ui$Button$loading(loading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Next')
                            ]))
                        ]))
                    ]))
                ]))
            ]),
            $2: 'User Profile Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Team$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$PracticeSetup$Team$init,
        aeR: $author$project$Pages$PracticeSetup$Team$load,
        ag3: $author$project$Pages$PracticeSetup$Team$save,
        ahE: $author$project$Pages$PracticeSetup$Team$subscriptions,
        aaO: $author$project$Pages$PracticeSetup$Team$update,
        aid: $author$project$Pages$PracticeSetup$Team$view
    });
    var $author$project$Pages$PracticeSetup$Top$view = function(_v0) {
        return {
            fb: _List_fromArray([
                $elm$html$Html$text('Practice Setup')
            ]),
            $2: 'Practice Setup'
        };
    };
    var $author$project$Pages$PracticeSetup$Top$page = $author$project$Spa$Page$static($author$project$Pages$PracticeSetup$Top$view);
    var $author$project$Pages$Reports$AncillaryCharges$Id_String$ViewDetailsMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$GotAncillaryChargePreview = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$AffiliateAncillaryCharge = 22;
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('company'), model.fl),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('affiliate_practice'), model.abB)
        ]);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl = function(model) {
        var route = function() {
            var _v0 = model.aef;
            if (!_v0.$) {
                var id = _v0.a;
                return $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String({
                    aef: id
                });
            } else return $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top;
        }();
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString(route)
        ]), $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams(model)));
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$GotAncillaryCharges = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams = F2(function(model, pagination) {
        return function(d) {
            return _Utils_update(d, {
                IU: model.abB,
                acy: model.fl,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af_: pagination,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    });
    var $author$project$Api$Provider$Reports$AncillaryCharge$AncillaryCharge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$AncillaryCharge$Record = F7(function(id, status, charge, sponsor, affiliate, affiliatePractice, sponsorCharge) {
        return {
            Eb: affiliate,
            IU: affiliatePractice,
            ach: charge,
            aef: id,
            _Q: sponsor,
            _R: sponsorCharge,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Affiliate$Min$Affiliate = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Affiliate$Min$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$Affiliate$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Affiliate$Min$Record));
    var $author$project$Api$Provider$Affiliate$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Affiliate$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Charge = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Record = F5(function(createdAt, category, patient, priceInCents, invoice) {
        return {
            EL: category,
            Mx: createdAt,
            RA: invoice,
            V7: patient,
            Br: priceInCents
        };
    });
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$Min$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'price_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Record))))));
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Charge$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$Charge)));
    var $author$project$Api$Provider$Reports$AncillaryCharge$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'sponsor_charge', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate_practice', $author$project$Api$Provider$Practice$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'affiliate', $author$project$Api$Provider$Affiliate$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sponsor', $author$project$Api$Provider$Company$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge', $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$AncillaryCharge$Record))))))));
    var $author$project$Api$Provider$Reports$AncillaryCharge$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$AncillaryCharge$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$AncillaryCharge$listDefaults = {
        IU: $elm$core$Maybe$Nothing,
        acy: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$AncillaryCharge$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.acy;
                if (!_v2.$) {
                    var string = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'sponsor', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.IU;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'affiliate_practice', string)
                    ]);
                } else return _List_Nil;
            }()
        ])));
    };
    var $author$project$Api$Provider$Reports$AncillaryCharge$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'affiliate_ancillary_charges'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$AncillaryCharge$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$AncillaryCharge$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$AncillaryCharge$listPath)));
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges = F3(function(apiClient, model, pagination) {
        return A3($author$project$Api$Provider$Reports$AncillaryCharge$list, apiClient, A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams, model, pagination), $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$GotAncillaryCharges);
    });
    var $author$project$Components$ResourceFilter$Affiliates$Practice$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$Affiliates$Practice$list = $author$project$Api$Platform$User$Practice$list;
    var $author$project$Components$ResourceFilter$Affiliates$Practice$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A4($author$project$Components$ResourceFilter$Affiliates$Practice$list, apiClient, function(d) {
            return _Utils_update(d, {
                Ec: $elm$core$Maybe$Just(true),
                af_: pagination,
                agq: query
            });
        }, $elm$core$Maybe$Nothing, toMsg);
    });
    var $author$project$Components$ResourceFilter$Affiliates$Practice$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A4($author$project$Components$ResourceFilter$Affiliates$Practice$list, apiClient, function(d) {
            return _Utils_update(d, {
                Ec: $elm$core$Maybe$Just(true),
                Fq: _List_fromArray([
                    0
                ]),
                agq: $elm$core$Maybe$Just(id)
            });
        }, $elm$core$Maybe$Nothing, toMsg);
    });
    var $author$project$Components$ResourceFilter$Affiliates$Practice$selectId = 'practices';
    var $author$project$Components$ResourceFilter$Affiliates$Practice$toTitle = $author$project$Api$Platform$Practice$All$name;
    var $author$project$Components$ResourceFilter$Affiliates$Practice$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Affiliates$Practice$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$Affiliates$Practice$toValue = $author$project$Api$Platform$Practice$All$id;
    var $author$project$Components$ResourceFilter$Affiliates$Practice$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Affiliates$Practice$fetchResources,
            aef: $author$project$Components$ResourceFilter$Affiliates$Practice$selectId,
            gD: 'Practices',
            sz: $author$project$Components$ResourceFilter$Affiliates$Practice$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$Affiliates$Practice$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Affiliates$Practice$toTitle,
            g4: $author$project$Components$ResourceFilter$Affiliates$Practice$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Utils$Report$PracticeResourceFilter$init = F4(function(apiClient, optionals, practice, practiceId) {
        return A2($author$project$Components$ResourceFilter$Affiliates$Practice$init, apiClient, A2($elm$core$Basics$composeL, optionals, function(d) {
            return _Utils_update(d, {
                Ee: 'All ' + A2($author$project$Api$Practice$sponsorize, practice, 'Affiliates'),
                agj: practiceId
            });
        }));
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'charge_added', false, 'Charge Added Date'),
        A3($author$project$Api$Column$init, 'sponsor', false, 'Sponsor'),
        A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
        A3($author$project$Api$Column$init, 'affiliate', false, 'Affiliate'),
        A3($author$project$Api$Column$init, 'charge', false, 'Charge'),
        A2($author$project$Api$Column$withOption, $author$project$Ui$Table$textCenter, A3($author$project$Api$Column$init, 'sponsor_invoice', false, 'Sponsor Invoice'))
    ]);
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init = F4(function(practice, _v0, query, paramsId) {
        var apiClient = _v0.Ej;
        var timeZone = _v0.HP;
        var currentDate = _v0.cP;
        var pagination = A2($author$project$Api$Pagination$fromQuery, query, $author$project$Api$Pagination$init);
        var companyId = A2($elm$core$Dict$get, 'company', query);
        var affiliatePracticeId = A2($elm$core$Dict$get, 'affiliate_practice', query);
        var _v1 = A4($author$project$Utils$Report$PracticeResourceFilter$init, apiClient, $elm$core$Basics$identity, $author$project$Api$Practice$Provider(practice), affiliatePracticeId);
        var practiceResourceFilter = _v1.a;
        var practiceResourceFilterCmd = _v1.b;
        var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v2.a;
        var end = _v2.b;
        var _v3 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v3.a;
        var dateRangeInputCmd = _v3.b;
        var _v4 = A4($author$project$Utils$Report$CompanyResourceFilter$init, apiClient, $elm$core$Basics$identity, $author$project$Api$Practice$Provider(practice), companyId);
        var companyResourceFilter = _v4.a;
        var companyResourceFilterCmd = _v4.b;
        var model = {
            abB: affiliatePracticeId,
            aj: $author$project$Api$Data$Loading,
            LC: $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initColumns,
            fl: companyId,
            pY: companyResourceFilter,
            cP: currentDate,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 22
            }),
            aef: paramsId,
            af_: pagination,
            jC: practiceResourceFilter,
            HB: start,
            HP: timeZone
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg, companyResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg, practiceResourceFilterCmd),
            A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, model, pagination),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(model)
        ])));
    });
    var $author$project$Api$Provider$AffiliateAncillaryCharge$AffiliateAncillaryChargePreview = $elm$core$Basics$identity;
    var $author$project$Api$Provider$AffiliateAncillaryCharge$Record = F5(function(id, status, charge, category, networkCoveragePlan) {
        return {
            EL: category,
            ach: charge,
            aef: id,
            UL: networkCoveragePlan,
            ahy: status
        };
    });
    var $author$project$Api$Provider$AffiliateAncillaryCharge$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'network_coverage_plan', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CoveragePlan$One$decoder), $elm$core$Maybe$Nothing, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge', $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$AffiliateAncillaryCharge$Record))))));
    var $author$project$Api$Provider$AffiliateAncillaryCharge$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$AffiliateAncillaryCharge$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$AffiliateAncillaryCharge$preview = F3(function(apiClient, id, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$AffiliateAncillaryCharge$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'affiliate_ancillary_charges',
            id,
            'preview'
        ]), $author$project$Api$Data$providerPath)));
    });
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$init = F4(function(practice, shared, _v0, session) {
        var params = _v0.VU;
        var query = _v0.Bz;
        var _v1 = A4($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init, practice, shared, query, $elm$core$Maybe$Just(params.aef));
        var ancillaryCharges = _v1.a;
        var cmd = _v1.b;
        var _v2 = A3($author$project$Components$ResourceFilter$Category$init, shared.Ej, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false
            });
        });
        var categoryResourceFilter = _v2.a;
        var categoryResourceFilterCmd = _v2.b;
        return _Utils_Tuple2({
            vc: $elm$core$Maybe$Nothing,
            aj: ancillaryCharges,
            cK: categoryResourceFilter,
            Mn: $elm$core$Maybe$Nothing,
            aef: params.aef,
            UL: $elm$core$Maybe$Nothing,
            j1: $elm$core$Maybe$Nothing,
            Z$: session,
            aaT: shared.aaT
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg, cmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A3($author$project$Api$Provider$AffiliateAncillaryCharge$preview, shared.Ej, params.aef, $author$project$Components$Reports$AncillaryCharges$ViewDetails$GotAncillaryChargePreview)
        ])));
    });
    var $author$project$Pages$Reports$AncillaryCharges$Id_String$init = F4(function(session, practice, shared, urlParams) {
        var _v0 = A4($author$project$Components$Reports$AncillaryCharges$ViewDetails$init, practice, shared, urlParams, session);
        var viewDetails = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            pf: viewDetails
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd));
    });
    var $author$project$Pages$Reports$AncillaryCharges$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$AncillaryCharges$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Admin$CoveragePlans$Rules$subscriptions, model.UL)));
    };
    var $author$project$Pages$Reports$AncillaryCharges$Id_String$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$AncillaryCharges$ViewDetails$subscriptions(model.pf));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargeApproved = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$AffiliateAncillaryCharge$approve = F4(function(apiClient, id, params, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('charge', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('category', A2($author$project$Utils$Encode$nullable, $author$project$Utils$Encode$association, params.EL))
            ])))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'affiliate_ancillary_charges',
            id,
            'approve'
        ]), $author$project$Api$Data$providerPath))));
    });
    var $author$project$Spa$Url$toQuery = function(queryString) {
        var second = A2($elm$core$Basics$composeR, $elm$core$List$drop(1), $elm$core$List$head);
        var toTuple = function(list) {
            return A2($elm$core$Maybe$map, function(first) {
                return _Utils_Tuple2(first, A2($elm$core$Maybe$withDefault, '', second(list)));
            }, $elm$core$List$head(list));
        };
        var decode = A2($elm$core$Basics$composeR, $elm$url$Url$percentDecode, $elm$core$Maybe$withDefault(''));
        return A2($elm$core$List$map, A2($elm$core$Tuple$mapBoth, decode, decode), A2($elm$core$List$filterMap, toTuple, A2($elm$core$List$map, $elm$core$String$split('='), A2($elm$core$String$split, '&', queryString))));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl = F3(function(maybePageSize, maybeSelectedPageNumber, model) {
        var queryParamsList = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$map(function(_v3) {
            var key = _v3.a;
            var value = _v3.b;
            return A2($elm$url$Url$Builder$string, key, value);
        }), A2($elm$core$Maybe$map, $elm$core$List$filter(function(_v2) {
            var key = _v2.a;
            return A2($elm$core$List$member, key, _List_fromArray([
                'company',
                'start',
                'end',
                'affiliate_practice'
            ]));
        }), A2($elm$core$Maybe$map, $author$project$Spa$Url$toQuery, model.aaT.Bz))));
        var perPageQuery = function() {
            if (!maybePageSize.$) {
                var pageSize = maybePageSize.a;
                return _List_fromArray([
                    A2($elm$url$Url$Builder$int, 'per_page', pageSize)
                ]);
            } else return $author$project$Api$Pagination$toPageQuery(model.aj.af_);
        }();
        var pageQuery = function() {
            if (!maybeSelectedPageNumber.$) {
                var pageNumber = maybeSelectedPageNumber.a;
                return _List_fromArray([
                    A2($elm$url$Url$Builder$int, 'page', pageNumber)
                ]);
            } else return $author$project$Api$Pagination$toPageQuery(model.aj.af_);
        }();
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top)
        ]), A2($elm$core$List$append, pageQuery, A2($elm$core$List$append, perPageQuery, queryParamsList))));
    });
    var $author$project$Api$Provider$AffiliateAncillaryCharge$category = function(_v0) {
        var record = _v0;
        return record.EL;
    };
    var $author$project$Api$Provider$Reports$AncillaryCharge$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$initCategoryResourceFilter = F3(function(apiClient, session, id) {
        return A3($author$project$Components$ResourceFilter$Category$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                Ee: 'Unassigned',
                afn: false,
                agj: id
            });
        });
    });
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$initNetworkCoveragePlanRules = F4(function(apiClient, session, coveragePlan, coverageRuleUsages) {
        if (!coveragePlan.$) {
            var coveragePlan_ = coveragePlan.a;
            return A3($elm$core$Tuple$mapBoth, $elm$core$Maybe$Just, $elm$core$Platform$Cmd$map($author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg), A6($author$project$Components$Admin$CoveragePlans$Rules$init, apiClient, session, $elm$core$Maybe$Just($author$project$Api$Provider$CoveragePlan$One$id(coveragePlan_)), $author$project$Api$Provider$CoveragePlan$One$coverageRules(coveragePlan_), $elm$core$Maybe$Just(coverageRuleUsages), {
                Ya: true
            }));
        } else return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan = function(_v0) {
        var record = _v0;
        return record.UL;
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$selectAncillaryCharge = F2(function(model, id) {
        var _v0 = model.aj;
        if (_v0.$ === 3) {
            var charges = _v0.a;
            return $elm$core$List$head(A2($elm$core$List$filter, function(ancillaryCharge) {
                return _Utils_eq($author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge), id);
            }, charges));
        } else return $elm$core$Maybe$Nothing;
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$AncillaryChargeApproved = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Affiliates$Practice$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$ && !_v1.a.$) {
                var selected = _v1.a.a;
                return _Utils_update(model, {
                    Hg: selected
                });
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$Affiliates$Practice$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update = F3(function(msg, model, apiClient) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    var totalCount = A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_);
                    return _Utils_Tuple3(_Utils_update(model, {
                        aj: response,
                        af_: totalCount
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    aj: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                var ancillaryCharge = msg.a;
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$AffiliateAncillaryCharge$approve, apiClient, $author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge), {
                    EL: $elm$core$Maybe$Nothing
                }, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$AncillaryChargeApproved), _List_Nil);
            case 2:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, model, model.af_), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Affiliate ancillary charge approved')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var subMsg = msg.a;
                var _v3 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v3.a;
                var subCmd = _v3.b;
                var subOutMsg = _v3.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg, subCmd), subOutMsg);
            case 4:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    aj: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, pagination),
                    $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
                ])), _List_Nil);
            case 5:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v4.a;
                var subCmd = _v4.b;
                var event = _v4.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            aj: $author$project$Api$Data$Loading,
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var _v5 = function() {
                    if (_Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn)) return _Utils_Tuple2(_List_Nil, model.af_);
                    else {
                        var paginationReset = $author$project$Api$Pagination$reset(model.af_);
                        return _Utils_Tuple2(_List_fromArray([
                            A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
                            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
                        ]), paginationReset);
                    }
                }();
                var cmds = _v5.a;
                var pagination = _v5.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    af_: pagination
                }), $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 6:
                var subMsg = msg.a;
                var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pY);
                var companyId = function() {
                    var _v8 = companyResourceResult.adu;
                    if (!_v8.$ && !_v8.a.$) return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.zi);
                    else return model.fl;
                }();
                var newModel = _Utils_update(model, {
                    fl: companyId,
                    pY: companyResourceResult.zi
                });
                var _v7 = function() {
                    if (_Utils_eq(model.fl, newModel.fl)) return _Utils_Tuple3(model.aj, $elm$core$Platform$Cmd$none, model.af_);
                    else {
                        var paginationReset = $author$project$Api$Pagination$reset(model.af_);
                        return _Utils_Tuple3($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
                            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
                        ])), paginationReset);
                    }
                }();
                var ancillaryCharges = _v7.a;
                var cmd = _v7.b;
                var pagination = _v7.c;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    aj: ancillaryCharges,
                    af_: pagination
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg, companyResourceResult.EQ),
                    cmd
                ])), companyResourceResult.at);
            default:
                var subMsg = msg.a;
                var practiceResourceResult = A3($author$project$Components$ResourceFilter$Affiliates$Practice$update, apiClient, subMsg, model.jC);
                var affiliatePracticeId = function() {
                    var _v10 = practiceResourceResult.adu;
                    if (!_v10.$ && !_v10.a.$) return $author$project$Components$ResourceFilter$Affiliates$Practice$value(practiceResourceResult.zi);
                    else return model.abB;
                }();
                var newModel = _Utils_update(model, {
                    abB: affiliatePracticeId,
                    jC: practiceResourceResult.zi
                });
                var _v9 = function() {
                    if (_Utils_eq(model.abB, newModel.abB)) return _Utils_Tuple3(model.aj, $elm$core$Platform$Cmd$none, model.af_);
                    else {
                        var paginationReset = $author$project$Api$Pagination$reset(model.af_);
                        return _Utils_Tuple3($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryCharges, apiClient, newModel, paginationReset),
                            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildUrl(newModel)
                        ])), paginationReset);
                    }
                }();
                var ancillaryCharges = _v9.a;
                var cmd = _v9.b;
                var pagination = _v9.c;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    aj: ancillaryCharges,
                    af_: pagination
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg, practiceResourceResult.EQ),
                    cmd
                ])), practiceResourceResult.at);
        }
    });
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$update = F3(function(msg, model, apiClient) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update, subMsg, model.aj, apiClient);
                var ancillaryChargesModel = _v1.a;
                var cmd = _v1.b;
                var outMsgs = _v1.c;
                var selectedAncillaryCharge = A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$selectAncillaryCharge, ancillaryChargesModel, model.aef);
                var newCmd = function() {
                    if (subMsg.$ === 4) {
                        var paginationMsg = subMsg.a;
                        if (!paginationMsg.$) {
                            var selectedPageNumber = paginationMsg.a;
                            return A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl, $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(selectedPageNumber), model);
                        } else {
                            var perPage = paginationMsg.a;
                            return A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl, $elm$core$Maybe$Just(perPage), $elm$core$Maybe$Nothing, model);
                        }
                    } else return A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg, cmd);
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    aj: ancillaryChargesModel,
                    j1: selectedAncillaryCharge
                }), newCmd, outMsgs);
            case 1:
                return _Utils_Tuple3(model, A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model), _List_Nil);
            case 2:
                var response = msg.a;
                switch(response.$){
                    case 3:
                        var affiliateAncillaryChargePreview = response.a;
                        var previewSponsorChargeCategoryId = A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$id, $author$project$Api$Provider$AffiliateAncillaryCharge$category(affiliateAncillaryChargePreview));
                        var coveragePlan = $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan(affiliateAncillaryChargePreview);
                        var _v5 = A4($author$project$Components$Reports$AncillaryCharges$ViewDetails$initNetworkCoveragePlanRules, apiClient, model.Z$, coveragePlan, _List_Nil);
                        var networkCoveragePlan = _v5.a;
                        var _v6 = A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$initCategoryResourceFilter, apiClient, model.Z$, previewSponsorChargeCategoryId);
                        var categoryResourceFilter = _v6.a;
                        var categoryResourceFilterCmd = _v6.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            vc: $elm$core$Maybe$Just(affiliateAncillaryChargePreview),
                            cK: categoryResourceFilter,
                            Mn: coveragePlan,
                            UL: networkCoveragePlan
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceFilterCmd), _List_Nil);
                    case 2:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var subMsg = msg.a;
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cK);
                var newCategoryResourceFilter = categoryResourceResult.zi;
                return _Utils_Tuple3(_Utils_update(model, {
                    cK: newCategoryResourceFilter
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, categoryResourceResult.EQ), categoryResourceResult.at);
            case 4:
                var ancillaryCharge = msg.a;
                var category = $author$project$Components$ResourceFilter$Category$value(model.cK);
                return _Utils_Tuple3(model, A4($author$project$Api$Provider$AffiliateAncillaryCharge$approve, apiClient, $author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge), {
                    EL: category
                }, $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargeApproved), _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(model, A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$buildRouteFromUrl, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, model), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Affiliate ancillary charge approved')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var subMsg = msg.a;
                var _v8 = model.UL;
                if (!_v8.$) {
                    var networkCoveragePlan = _v8.a;
                    var _v9 = A3($author$project$Components$Admin$CoveragePlans$Rules$update, apiClient, subMsg, networkCoveragePlan);
                    var newNetworkCoveragePlan = _v9.a;
                    var networkCoveragePlanCmd = _v9.b;
                    var networkCoveragePlanOutMsgs = _v9.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        UL: $elm$core$Maybe$Just(newNetworkCoveragePlan)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg, networkCoveragePlanCmd), networkCoveragePlanOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Reports$AncillaryCharges$Id_String$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$AncillaryCharges$ViewDetails$update, subMsg, model.pf, model.Ej);
        var viewDetails = _v1.a;
        var cmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            pf: viewDetails
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), outMsgs);
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initMiniColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'charge_added', false, 'Charge Added Date'),
        A3($author$project$Api$Column$init, 'sponsor', false, 'Sponsor'),
        A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
        A3($author$project$Api$Column$init, 'affiliate', false, 'Affiliate'),
        A3($author$project$Api$Column$init, 'charge', false, 'Charge')
    ]);
    var $author$project$Api$Provider$Reports$AncillaryCharge$affiliate = function(_v0) {
        var record = _v0;
        return record.Eb;
    };
    var $author$project$Api$Provider$Reports$AncillaryCharge$affiliatePractice = function(_v0) {
        var record = _v0;
        return record.IU;
    };
    var $author$project$Api$Provider$Reports$AncillaryCharge$charge = function(_v0) {
        var record = _v0;
        return record.ach;
    };
    var $author$project$Api$Provider$Affiliate$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice = function(_v0) {
        var record = _v0.b;
        return record.RA;
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell = function(ancillaryCharge) {
        var invoice = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice($author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
        var invoiceId = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$id, invoice));
        var affiliationId = $author$project$Api$Provider$Affiliate$Min$id($author$project$Api$Provider$Reports$AncillaryCharge$affiliate(ancillaryCharge));
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Practice$Min$name($author$project$Api$Provider$Reports$AncillaryCharge$affiliatePractice(ancillaryCharge))),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Invoice: ')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String({
                    pr: affiliationId,
                    aef: invoiceId
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text('#' + $elm$core$String$fromInt(A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$invoiceNumber, invoice))))
                ])),
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Ui$Badge$fromString(_List_Nil), A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Invoice$Min$humanStatus, invoice)))
            ]))
        ]));
    };
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$createdAt = function(_v0) {
        var record = _v0.b;
        return record.Mx;
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell = F2(function(model, ancillaryCharge) {
        var chargeAdded = A2($justinmimbs$date$Date$fromPosix, model.HP, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$createdAt($author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge)));
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, chargeAdded))
        ]));
    });
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category = function(_v0) {
        var record = _v0.b;
        return record.EL;
    };
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name = function(_v0) {
        var shared = _v0.a;
        return A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Charge$Shared$name(shared));
    };
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$totalInCents = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$totalInCents(shared);
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell = function(ancillaryCharge) {
        var totalAmountInCents = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$totalInCents($author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
        var chargeCategory = $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category($author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge));
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name($author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge))),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$name, chargeCategory)))
            ])),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt(totalAmountInCents))
            ]))
        ]));
    };
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$patient = function(_v0) {
        var record = _v0.b;
        return record.V7;
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell = function(ancillaryCharge) {
        var patientName = $author$project$Api$Provider$Patient$Min$name($author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$patient($author$project$Api$Provider$Reports$AncillaryCharge$charge(ancillaryCharge)));
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text(patientName)
        ]));
    };
    var $author$project$Api$Provider$Reports$AncillaryCharge$sponsor = function(_v0) {
        var record = _v0;
        return record._Q;
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell = function(ancillaryCharge) {
        return A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Api$Provider$Company$Min$name($author$project$Api$Provider$Reports$AncillaryCharge$sponsor(ancillaryCharge)))
        ]));
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniAncillaryCharge = F2(function(model, ancillaryCharge) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell, model, ancillaryCharge),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell(ancillaryCharge),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell(ancillaryCharge),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell(ancillaryCharge),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell(ancillaryCharge)
        ]));
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter = function(companyResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), companyResourceFilter));
    };
    var $author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$ResourceFilter$Affiliates$Practice$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter = function(practiceResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg, A2($author$project$Components$ResourceFilter$Affiliates$Practice$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), practiceResourceFilter));
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniFilters = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$itemsCenter,
                    $author$project$Ui$Grid$spanLg(2)
                ]), _List_fromArray([
                    $elm$html$Html$text('Charge Added Date')
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(2)
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(2)
                ]), _List_fromArray([
                    $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter(model.pY)
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanLg(2)
                ]), _List_fromArray([
                    $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter(model.jC)
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, function() {
                    var activeFilters = _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg), $author$project$Components$ResourceFilter$Company$viewMultiSelected(model.pY)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg), $author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected(model.jC)));
                    return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$mt2,
                            $author$project$Ui$Element$mb2
                        ]), _List_fromArray([
                            A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Active filters')
                            ]))
                        ])),
                        A2($elm$html$Html$span, _List_Nil, activeFilters)
                    ]);
                }())
            ]))
        ]);
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PaginationMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination = function(model) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.aj)))
        ]), model.af_));
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMini = function(model) {
        var _v0 = function() {
            var _v1 = model.aj;
            if (_v1.$ === 3) {
                var charges = _v1.a;
                return _Utils_Tuple2(false, charges);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var ancillaryCharges = _v0.b;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniFilters(model)),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A4($author$project$Ui$Table$view, _List_fromArray([
                        $author$project$Ui$Table$zeroState(_List_fromArray([
                            $elm$html$Html$text('No matching results.')
                        ])),
                        $author$project$Ui$Table$loading(loading)
                    ]), $elm$core$List$concat(_List_fromArray([
                        A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$initMiniColumns),
                        _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_Nil)
                        ])
                    ])), A2($elm$core$List$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMiniAncillaryCharge(model), ancillaryCharges), _List_Nil)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination(model)
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewAncillaryChargesList = function(model) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('w-1/2')
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Affiliate Ancillary Charges')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$AncillaryChargesListMsg, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewMini(model.aj))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$Close = {
        $: 1
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$ApproveAncillaryCharge = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$AncillaryCharge$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewApproveButton = function(ancillaryCharge) {
        return $author$project$Api$Provider$Reports$AncillaryCharge$status(ancillaryCharge) !== 'approved' ? A3($author$project$Ui$Button$view, {
            abP: 'Approve charge'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$onClick($author$project$Components$Reports$AncillaryCharges$ViewDetails$ApproveAncillaryCharge(ancillaryCharge))
        ]), _List_fromArray([
            $elm$html$Html$text('Approve')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCategory = function(model) {
        var chargeCategory = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$name, A2($elm$core$Maybe$andThen, $elm$core$Basics$identity, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$AncillaryCharge$charge, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$category), model.j1))));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Category')
                ]), _List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(chargeCategory)
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('category-resource-filter')
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$view, _List_fromArray([
                            $author$project$Components$ResourceFilter$style(0)
                        ]), model.cK))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeName = function(model) {
        var chargeName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$AncillaryCharge$charge, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$name), model.j1));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Charge')
                ]), _List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(chargeName)
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(chargeName)
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoveragePlanName = function(model) {
        var planName = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$name, A2($elm$core$Maybe$andThen, $author$project$Api$Provider$AffiliateAncillaryCharge$networkCoveragePlan, model.vc)));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Coverage Plan')
                ]), _List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(planName)
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewNetworkCoverageDocuments = function(coverageDouments) {
        if (!coverageDouments.$) {
            var coverageDocuments_ = coverageDouments.a;
            return A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$margin(2)
            ]), _List_fromArray([
                $author$project$Components$Admin$CoverageDocuments$Form$viewAsList(coverageDocuments_)
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoverageRules = function(model) {
        var _v0 = model.UL;
        if (!_v0.$) {
            var networkRules = _v0.a;
            var coverageDocuments = A2($elm$core$Maybe$map, $author$project$Api$Provider$CoveragePlan$One$coverageDocuments, model.Mn);
            return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(12)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$labelSpanSm(1),
                        $author$project$Ui$Form$Group$inputSpanSm(11),
                        $author$project$Ui$Form$Group$label('')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewNetworkCoverageDocuments(coverageDocuments),
                            A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$NetworkCoveragePlanMsg, $author$project$Components$Admin$CoveragePlans$Rules$view(networkRules))
                        ]))
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewHeaders = A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(4)
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_Nil)
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(4)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Affiliate Invoice')
            ]))
        ])),
        A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$spanMd(4)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Sponsor Invoice')
            ]))
        ]))
    ]));
    var $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$date = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Charge$Shared$date(shared);
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewServiceDate = function(model) {
        var chargeDate = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$AncillaryCharge$charge, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$date, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full))), model.j1));
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4),
                $author$project$Ui$Grid$justifyRight
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Service Date')
                ]), _List_Nil)
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(chargeDate)
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeDetails = function(model) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('w-1/2 view-details')
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$titleWithButton, _List_fromArray([
                        $elm$html$Html$text('Charge Details')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Close details'
                        }, _List_fromArray([
                            $author$project$Ui$Button$close,
                            $author$project$Ui$Button$onClick($author$project$Components$Reports$AncillaryCharges$ViewDetails$Close)
                        ]), _List_fromArray([
                            A2($elm$html$Html$span, _List_fromArray([
                                A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
                            ]), _List_fromArray([
                                $elm$html$Html$text("\xd7")
                            ]))
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewHeaders,
                        $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeName(model),
                        $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCategory(model),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewServiceDate(model),
                        $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoveragePlanName(model),
                        $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewCoverageRules(model)
                    ]))
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyRight
                ]), _List_fromArray([
                    A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewApproveButton, model.j1))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$AncillaryCharges$ViewDetails$view = function(model) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('flex')
        ]), _List_fromArray([
            $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewAncillaryChargesList(model),
            $author$project$Components$Reports$AncillaryCharges$ViewDetails$viewChargeDetails(model)
        ]));
    };
    var $author$project$Pages$Reports$AncillaryCharges$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$Reports$AncillaryCharges$ViewDetails$view(model.pf))
            ]),
            $2: 'Reports | Affiliate Ancillary Charges'
        };
    };
    var $author$project$Pages$Reports$AncillaryCharges$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$AncillaryCharges$Id_String$init,
        aeR: $author$project$Pages$Reports$AncillaryCharges$Id_String$load,
        ag3: $author$project$Pages$Reports$AncillaryCharges$Id_String$save,
        ahE: $author$project$Pages$Reports$AncillaryCharges$Id_String$subscriptions,
        aaO: $author$project$Pages$Reports$AncillaryCharges$Id_String$update,
        aid: $author$project$Pages$Reports$AncillaryCharges$Id_String$view
    });
    var $author$project$Pages$Reports$AncillaryCharges$Top$AncillaryChargesMsg = $elm$core$Basics$identity;
    var $author$project$Pages$Reports$AncillaryCharges$Top$init = F4(function(_v0, practice, shared, _v1) {
        var query = _v1.Bz;
        var _v2 = A4($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$init, practice, shared, query, $elm$core$Maybe$Nothing);
        var ancillaryChargesModel = _v2.a;
        var ancillaryChargesCmd = _v2.b;
        return _Utils_Tuple2({
            aj: ancillaryChargesModel,
            Ej: shared.Ej,
            W1: practice
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, ancillaryChargesCmd));
    });
    var $author$project$Pages$Reports$AncillaryCharges$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$AncillaryCharges$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$ResourceFilter$Affiliates$Practice$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg, $author$project$Components$ResourceFilter$Affiliates$Practice$subscriptions(model.jC)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg, $author$project$Components$ResourceFilter$Company$subscriptions(model.pY))
        ]));
    };
    var $author$project$Pages$Reports$AncillaryCharges$Top$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$subscriptions(model.aj));
    };
    var $author$project$Pages$Reports$AncillaryCharges$Top$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$update, subMsg, model.aj, model.Ej);
        var ancillaryChargesModel = _v1.a;
        var cmd = _v1.b;
        var outMsgs = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            aj: ancillaryChargesModel
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, cmd), outMsgs);
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ApproveAncillaryCharge = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildViewDetailsRoute = function(model) {
        return $author$project$Ui$Link$routeParams($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildQueryParams(model));
    };
    var $author$project$Api$Provider$Reports$AncillaryCharge$sponsorCharge = function(_v0) {
        var record = _v0;
        return record._R;
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewApprovedSponsorInvoice = function(ancillaryCharge) {
        var sponsorInvoice = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Charge$ForAffiliateAncillaryCharge$invoice, $author$project$Api$Provider$Reports$AncillaryCharge$sponsorCharge(ancillaryCharge));
        if (!sponsorInvoice.$) {
            var sponsorInvoice_ = sponsorInvoice.a;
            var companyId = $author$project$Api$Provider$Company$Min$id($author$project$Api$Provider$Reports$AncillaryCharge$sponsor(ancillaryCharge));
            return A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                    fl: companyId,
                    aef: $author$project$Api$Common$Payable$Invoice$Min$id(sponsorInvoice_)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$Min$invoiceNumber(sponsorInvoice_)))
                ]))
            ]));
        } else return $elm$html$Html$text('');
    };
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorInvoiceCell = F2(function(model, ancillaryCharge) {
        return A2($author$project$Ui$Table$cell, _List_fromArray([
            $author$project$Ui$Table$noWrap
        ]), _List_fromArray([
            $author$project$Api$Provider$Reports$AncillaryCharge$status(ancillaryCharge) === 'approved' ? $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewApprovedSponsorInvoice(ancillaryCharge) : A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Approve ancilliary chage'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ApproveAncillaryCharge(ancillaryCharge))
                ]), _List_fromArray([
                    $elm$html$Html$text('Approve')
                ])),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String({
                    aef: $author$project$Api$Provider$Reports$AncillaryCharge$id(ancillaryCharge)
                }), _List_fromArray([
                    $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$buildViewDetailsRoute(model),
                    $author$project$Ui$Link$buttonSecondary
                ]), _List_fromArray([
                    $elm$html$Html$text('View Details')
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAncillaryCharge = F2(function(model, ancillaryCharge) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeAddedCell, model, ancillaryCharge),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorCell(ancillaryCharge),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPatientCell(ancillaryCharge),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAffiliateCell(ancillaryCharge),
            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewChargeDetailsCell(ancillaryCharge),
            A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewSponsorInvoiceCell, model, ancillaryCharge)
        ]));
    });
    var $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$view = F2(function(apiClient, model) {
        var _v0 = function() {
            var _v1 = model.aj;
            if (_v1.$ === 3) {
                var charges = _v1.a;
                return _Utils_Tuple2(false, charges);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var ancillaryCharges = _v0.b;
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.aj)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$AncillaryCharge$listOptionsToParams, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$fetchAncillaryChargesParams(model))(model.af_))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Affiliate Ancillary Charges')
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$itemsCenter,
                            $author$project$Ui$Grid$spanMd(2)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Charge Added Date')
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(6)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(2)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewCompanyResourceFilter(model.pY)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(2)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPracticeResourceFilter(model.jC)
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$CompanyResourceFilterMsg), $author$project$Components$ResourceFilter$Company$viewMultiSelected(model.pY)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$PracticeResourceFilterMsg), $author$project$Components$ResourceFilter$Affiliates$Practice$viewMultiSelected(model.jC)));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A4($author$project$Ui$Table$view, _List_fromArray([
                        $author$project$Ui$Table$zeroState(_List_fromArray([
                            $elm$html$Html$text('You don\'t have any results for the time period and filters selected. Try broadening your search to see more results.')
                        ])),
                        $author$project$Ui$Table$loading(loading)
                    ]), $elm$core$List$concat(_List_fromArray([
                        A2($elm$core$List$map, $author$project$Api$Column$view($author$project$Api$Column$NonSortable), model.LC),
                        _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$class('pull-right')
                                ]), _List_fromArray([
                                    A2($elm$html$Html$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                                ]))
                            ]))
                        ])
                    ])), A2($elm$core$List$map, $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewAncillaryCharge(model), ancillaryCharges), _List_Nil)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$viewPagination(model)
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Reports$AncillaryCharges$Top$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$AncillaryCharges$AncillaryChargesList$view, model.Ej, model.aj)),
            $2: 'Reports | Affiliate Ancillary Charges'
        };
    };
    var $author$project$Pages$Reports$AncillaryCharges$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$AncillaryCharges$Top$init,
        aeR: $author$project$Pages$Reports$AncillaryCharges$Top$load,
        ag3: $author$project$Pages$Reports$AncillaryCharges$Top$save,
        ahE: $author$project$Pages$Reports$AncillaryCharges$Top$subscriptions,
        aaO: $author$project$Pages$Reports$AncillaryCharges$Top$update,
        aid: $author$project$Pages$Reports$AncillaryCharges$Top$view
    });
    var $author$project$Pages$Reports$CompanyInvoices$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$CompanyInvoices$StatusDropdownMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$CompanyInvoices$statusToString = function(status) {
        switch(status){
            case 0:
                return 'issued,failed';
            case 1:
                return 'paid,processing';
            case 2:
                return 'paid';
            default:
                return 'processing';
        }
    };
    var $author$project$Components$Reports$CompanyInvoices$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('status'), A2($elm$core$Maybe$map, $author$project$Components$Reports$CompanyInvoices$statusToString, model.ahy)),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('company'), model.fl)
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CompanyInvoices)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Components$Reports$CompanyInvoices$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$CompanyInvoices$GotInvoices = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$CompanyInvoices$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                acy: model.fl,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af_: model.af_,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ahy: A2($elm$core$Maybe$map, $elm$core$String$split(','), A2($elm$core$Maybe$map, $author$project$Components$Reports$CompanyInvoices$statusToString, model.ahy))
            });
        };
    };
    var $author$project$Api$Provider$Reports$Invoice$Invoice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Invoice$Record = F9(function(id, invoiceDate, invoiceNumber, amountInCents, dueInCents, paidInCents, description, humanStatus, company) {
        return {
            Jh: amountInCents,
            acy: company,
            NQ: description,
            Ol: dueInCents,
            QX: humanStatus,
            aef: id,
            RG: invoiceDate,
            RK: invoiceNumber,
            VR: paidInCents
        };
    });
    var $author$project$Api$Provider$Reports$Invoice$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'company', $author$project$Api$Provider$Company$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'description', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Invoice$Record))))))))));
    var $author$project$Api$Provider$Reports$Invoice$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Invoice$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Invoice$listDefaults = {
        acy: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init),
        HB: $elm$core$Maybe$Nothing,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$Invoice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$Invoice$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.ahy;
                if (!_v2.$) {
                    var list_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$list, 'status', list_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.acy;
                if (!_v3.$) {
                    var string = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'company', string)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$Invoice$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'invoices'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$Invoice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Invoice$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$Invoice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Invoice$listPath)));
    });
    var $author$project$Components$Reports$CompanyInvoices$fetchInvoices = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$Invoice$list, apiClient, $author$project$Components$Reports$CompanyInvoices$fetchParams(model), $author$project$Components$Reports$CompanyInvoices$GotInvoices);
    });
    var $author$project$Components$Reports$CompanyInvoices$initColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'invoice_date', true, 'Date'),
        A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
        A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
        A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Total'),
        A3($author$project$Api$Column$init, 'company', true, 'Company'),
        A3($author$project$Api$Column$init, 'description', false, 'Description')
    ]);
    var $author$project$Components$Reports$CompanyInvoices$IssuedOrFailed = 0;
    var $author$project$Components$Reports$CompanyInvoices$Paid = 2;
    var $author$project$Components$Reports$CompanyInvoices$PaidOrProcessing = 1;
    var $author$project$Components$Reports$CompanyInvoices$Processing = 3;
    var $author$project$Components$Reports$CompanyInvoices$statusFromString = function(status) {
        switch(status){
            case 'issued,failed':
                return $elm$core$Maybe$Just(0);
            case 'paid,processing':
                return $elm$core$Maybe$Just(1);
            case 'paid':
                return $elm$core$Maybe$Just(2);
            case 'processing':
                return $elm$core$Maybe$Just(3);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Reports$CompanyInvoices$init = F3(function(practice, _v0, query) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var companyId = A2($elm$core$Dict$get, 'company', query);
        var _v1 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v1.a;
        var end = _v1.b;
        var _v2 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$CompanyInvoices$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v2.a;
        var dateRangeInputCmd = _v2.b;
        var _v3 = A4($author$project$Utils$Report$CompanyResourceFilter$init, apiClient, $elm$core$Basics$identity, $author$project$Api$Practice$Provider(practice), companyId);
        var companyResourceFilter = _v3.a;
        var companyResourceFilterCmd = _v3.b;
        var model = {
            LC: $author$project$Components$Reports$CompanyInvoices$initColumns,
            fl: companyId,
            pY: companyResourceFilter,
            cP: currentDate,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 3
            }),
            q5: $author$project$Api$Data$Loading,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            ahs: A3($author$project$Api$Sort$withDefault, 'invoice_date', 0, A2($author$project$Api$Sort$fromQuery, query, $author$project$Api$Sort$init)),
            HB: start,
            ahy: $author$project$Components$Reports$CompanyInvoices$statusFromString(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Dict$get, 'status', query))),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'status-dropdown',
                ahX: $author$project$Components$Reports$CompanyInvoices$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg, companyResourceFilterCmd),
            A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, model),
            A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Reports$CompanyInvoices$init = F4(function(_v0, practice, shared, _v1) {
        var query = _v1.Bz;
        var _v2 = A3($author$project$Components$Reports$CompanyInvoices$init, practice, shared, query);
        var report = _v2.a;
        var reportCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            W1: practice,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$CompanyInvoices$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$CompanyInvoices$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$CompanyInvoices$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg, $author$project$Components$ResourceFilter$Company$subscriptions(model.pY)),
            $author$project$Ui$Dropdown$subscriptions(model.oD)
        ]));
    };
    var $author$project$Pages$Reports$CompanyInvoices$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$CompanyInvoices$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$CompanyInvoices$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v1.a;
                var subCmd = _v1.b;
                var event = _v1.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            q5: $author$project$Api$Data$Loading,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), cmd, _List_Nil);
            case 2:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    q5: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ahy: status
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pY);
                var companyId = function() {
                    var _v5 = companyResourceResult.adu;
                    if (!_v5.$) {
                        if (!_v5.a.$) return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.zi);
                        else {
                            var _v6 = _v5.a;
                            return model.fl;
                        }
                    } else return model.fl;
                }();
                var newModel = _Utils_update(model, {
                    fl: companyId,
                    pY: companyResourceResult.zi
                });
                var _v4 = _Utils_eq(model.fl, newModel.fl) ? _Utils_Tuple2(model.q5, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var invoices = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    q5: invoices
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg, companyResourceResult.EQ),
                    cmd
                ])), companyResourceResult.at);
            case 4:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        q5: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    q5: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    q5: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 6:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CompanyInvoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CompanyInvoices$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v8 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v8.a;
                var subCmd = _v8.b;
                var subOutMsg = _v8.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Reports$CompanyInvoices$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$CompanyInvoices$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$CompanyInvoices$PaginationMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$CompanyInvoices$intFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$CompanyInvoices$viewCompanyResourceFilter = function(companyResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), companyResourceFilter));
    };
    var $author$project$Components$Reports$CompanyInvoices$StatusSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$CompanyInvoices$statusToDisplayName = function(status) {
        switch(status){
            case 0:
                return 'Issued (Overdue, Viewed, Sent, Failed)';
            case 1:
                return 'Collected (Paid, Processing)';
            case 2:
                return 'Paid';
            default:
                return 'Processing';
        }
    };
    var $author$project$Components$Reports$CompanyInvoices$statusDropdownItems = function(currentStatus) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CompanyInvoices$StatusSelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Statuses')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CompanyInvoices$StatusSelected($elm$core$Maybe$Just(status))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatus, $elm$core$Maybe$Just(status)))
            ]), $elm$html$Html$text($author$project$Components$Reports$CompanyInvoices$statusToDisplayName(status)));
        }, _List_fromArray([
            0,
            1,
            2,
            3
        ]))));
    };
    var $author$project$Components$Reports$CompanyInvoices$viewStatusDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.ahy;
            if (!_v0.$) {
                var status = _v0.a;
                return $author$project$Components$Reports$CompanyInvoices$statusToDisplayName(status);
            } else return 'Status';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), $author$project$Components$Reports$CompanyInvoices$statusDropdownItems(model.ahy), model.oD);
    };
    var $author$project$Components$Reports$CompanyInvoices$SortTable = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$Invoice$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$Invoice$company = function(_v0) {
        var record = _v0;
        return record.acy;
    };
    var $author$project$Api$Provider$Reports$Invoice$description = function(_v0) {
        var record = _v0;
        return record.NQ;
    };
    var $author$project$Api$Provider$Reports$Invoice$dueInCents = function(_v0) {
        var record = _v0;
        return record.Ol;
    };
    var $author$project$Api$Provider$Reports$Invoice$humanStatus = function(_v0) {
        var record = _v0;
        return record.QX;
    };
    var $author$project$Api$Provider$Reports$Invoice$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Reports$Invoice$invoiceDate = function(_v0) {
        var record = _v0;
        return record.RG;
    };
    var $author$project$Api$Provider$Reports$Invoice$invoiceNumber = function(_v0) {
        var record = _v0;
        return record.RK;
    };
    var $author$project$Api$Provider$Reports$Invoice$paidInCents = function(_v0) {
        var record = _v0;
        return record.VR;
    };
    var $author$project$Components$Reports$CompanyInvoices$viewRow = function(invoice) {
        var company = $author$project$Api$Provider$Reports$Invoice$company(invoice);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$Invoice$invoiceDate(invoice)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                    fl: $author$project$Api$Provider$Company$Min$id(company),
                    aef: $author$project$Api$Provider$Reports$Invoice$id(invoice)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Reports$Invoice$invoiceNumber(invoice)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$Invoice$humanStatus(invoice))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Invoice$amountInCents(invoice))),
                $author$project$Api$Provider$Reports$Invoice$dueInCents(invoice) > 0 && $author$project$Api$Provider$Reports$Invoice$paidInCents(invoice) > 0 ? $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Invoice$dueInCents(invoice)) + ' due') : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top({
                    fl: $author$project$Api$Provider$Company$Min$id(company)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Company$Min$name(company))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, $author$project$Api$Provider$Reports$Invoice$description(invoice)))
            ]))
        ]));
    };
    var $author$project$Components$Reports$CompanyInvoices$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.q5;
            if (_v1.$ === 3) {
                var invoices_ = _v1.a;
                return _Utils_Tuple2(false, invoices_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var invoices = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$CompanyInvoices$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, $author$project$Components$Reports$CompanyInvoices$viewRow, invoices), _List_Nil);
    };
    var $author$project$Components$Reports$CompanyInvoices$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$CompanyInvoices$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.q5)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Invoice$listOptionsToParams, $author$project$Components$Reports$CompanyInvoices$fetchParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Employer Invoices')
                    ])),
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.q5;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            var totalDueAmount = A2($author$project$Components$Reports$CompanyInvoices$intFromHeader, headers, 'x-total-due-amount');
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$CompanyInvoices$intFromHeader, headers, 'x-total-amount'))),
                                totalDueAmount > 0 ? $author$project$Ui$Typography$headingSm(_List_fromArray([
                                    $elm$html$Html$text('Total Due: ' + $author$project$Utils$Currency$fromInt(totalDueAmount))
                                ])) : $author$project$Utils$Html$empty
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]);
                    }()),
                    A2($elm$html$Html$map, $author$project$Components$Reports$CompanyInvoices$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6)),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanSm(4),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$CompanyInvoices$viewStatusDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(5),
                            $author$project$Ui$Grid$spanSm(3),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$CompanyInvoices$viewCompanyResourceFilter(model.pY)
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$CompanyInvoices$CompanyResourceFilterMsg), $author$project$Components$ResourceFilter$Company$viewMultiSelected(model.pY));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$CompanyInvoices$viewTable(model)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$CompanyInvoices$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.q5)))
                    ]), model.af_))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Reports$CompanyInvoices$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$CompanyInvoices$view, model.Ej, model.jQ)),
            $2: 'Reports | ' + (A2($author$project$Formatters$String$sponsorize, model.W1, 'Companies') + ' Invoices')
        };
    };
    var $author$project$Pages$Reports$CompanyInvoices$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$CompanyInvoices$init,
        aeR: $author$project$Pages$Reports$CompanyInvoices$load,
        ag3: $author$project$Pages$Reports$CompanyInvoices$save,
        ahE: $author$project$Pages$Reports$CompanyInvoices$subscriptions,
        aaO: $author$project$Pages$Reports$CompanyInvoices$update,
        aid: $author$project$Pages$Reports$CompanyInvoices$view
    });
    var $author$project$Pages$Reports$CreditOutstanding$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$CreditOutstanding$Table = 0;
    var $author$project$Components$Reports$CreditOutstanding$ByDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$Credit = 15;
    var $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditOutstanding$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$CreditOutstanding$GotCredits = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditOutstanding$fetchCreditsParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                MB: model.EZ,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                af_: model.af_,
                agi: model.Xa,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Api$Provider$Reports$Credit$Credit = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Credit$Record = F8(function(issuedOn, expiresOn, balanceInCents, amountInCents, transferredInCents, patient, creditCategory, practitioner) {
        return {
            Jh: amountInCents,
            abW: balanceInCents,
            MB: creditCategory,
            Pj: expiresOn,
            SC: issuedOn,
            V7: patient,
            agi: practitioner,
            aaw: transferredInCents
        };
    });
    var $author$project$Api$Provider$CreditCategory$Min$CreditCategory = $elm$core$Basics$identity;
    var $author$project$Api$Provider$CreditCategory$Min$Record = function(name) {
        return {
            zr: name
        };
    };
    var $author$project$Api$Provider$CreditCategory$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$CreditCategory$Min$Record));
    var $author$project$Api$Provider$CreditCategory$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$CreditCategory$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Credit$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credit_category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CreditCategory$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transferred_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'balance_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'expires_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_on', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Credit$Record)))))))));
    var $author$project$Api$Provider$Reports$Credit$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Credit$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Credit$listDefaults = {
        MB: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agi: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$Credit$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$Credit$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.agi;
                if (!_v2.$) {
                    var practitioner_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', practitioner_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.MB;
                if (!_v3.$) {
                    var taxJurisdiction_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'credit_category', taxJurisdiction_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.rm;
                if (!_v4.$) {
                    var locationGroup_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', locationGroup_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.aeT;
                if (!_v5.$) {
                    var location_ = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', location_)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$Credit$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'credits'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$Credit$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Credit$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$Credit$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Credit$listPath)));
    });
    var $author$project$Components$Reports$CreditOutstanding$fetchCredits = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$Credit$list, apiClient, $author$project$Components$Reports$CreditOutstanding$fetchCreditsParams(model), $author$project$Components$Reports$CreditOutstanding$GotCredits);
    });
    var $author$project$Components$Reports$CreditOutstanding$GotSummary = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditOutstanding$fetchSummaryParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                MB: model.EZ,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                agi: model.Xa,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Api$Provider$Reports$Credit$summary = F4(function(apiClient, by, optionals, toMsg) {
        return A5($author$project$Api$Provider$Reports$Summary$retrieve, apiClient, $author$project$Api$Provider$Reports$Credit$listPath, by, $author$project$Api$Provider$Reports$Credit$listOptionsToParams(optionals), toMsg);
    });
    var $author$project$Components$Reports$CreditOutstanding$fetchSummary = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$Reports$Credit$summary, apiClient, A2($elm$core$Maybe$withDefault, '', model.bT), $author$project$Components$Reports$CreditOutstanding$fetchSummaryParams(model), $author$project$Components$Reports$CreditOutstanding$GotSummary);
    });
    var $author$project$Components$Reports$CreditOutstanding$fetchData = F2(function(apiClient, model) {
        var _v0 = model.ah5;
        if (!_v0) return A2($author$project$Components$Reports$CreditOutstanding$fetchCredits, apiClient, model);
        else return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Reports$CreditOutstanding$fetchSummary, apiClient, model),
            A2($author$project$Components$Reports$CreditOutstanding$fetchCredits, apiClient, model)
        ]));
    });
    var $author$project$Components$Reports$CreditOutstanding$initColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'issued_on', true, 'Issued On'),
        A3($author$project$Api$Column$init, 'expires_on', true, 'Expires On'),
        A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Outstanding'),
        A3($author$project$Api$Column$init, 'patient', false, 'Patient'),
        A3($author$project$Api$Column$init, 'credit_category', true, 'Category'),
        A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
    ]);
    var $author$project$Components$Reports$CreditOutstanding$urlParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('credit_category'), model.EZ),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location'), model.Tp),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('practitioner'), model.Xa),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('by'), model.bT)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Components$Reports$CreditOutstanding$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            function() {
                var _v0 = model.bT;
                if (!_v0.$) return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary);
                else return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditOutstanding);
            }()
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), $author$project$Utils$QueryParameter$fromDict($author$project$Components$Reports$CreditOutstanding$urlParams(model))))));
    };
    var $author$project$Components$Reports$CreditOutstanding$init = F5(function(type_, session, practice, _v0, query) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var _v1 = function() {
            if (!type_) return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
            else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
        }();
        var credits = _v1.a;
        var summary = _v1.b;
        var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v3.a;
        var groupLocationAndPractitionerFiltersCmd = _v3.b;
        var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v4.a;
        var end = _v4.b;
        var _v5 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$CreditOutstanding$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v5.a;
        var dateRangeInputCmd = _v5.b;
        var _v6 = A2($author$project$Components$ResourceFilter$CreditCategory$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'All Categories',
                agj: A2($elm$core$Dict$get, 'credit_category', query)
            });
        });
        var creditCategoryResourceFilter = _v6.a;
        var creditCategoryResourceFilterCmd = _v6.b;
        var model = {
            bT: A2($elm$core$Dict$get, 'by', query),
            ln: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'by-dropdown',
                ahX: $author$project$Components$Reports$CreditOutstanding$ByDropdownMsg
            })),
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            LC: $author$project$Components$Reports$CreditOutstanding$initColumns,
            EZ: A2($elm$core$Dict$get, 'credit_category', query),
            fo: creditCategoryResourceFilter,
            a$: credits,
            cP: currentDate,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 15
            }),
            b8: groupLocationAndPractitionerFilters,
            f0: locationGroupId,
            Tp: locationId,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            Xa: practitionerId,
            ahs: A3($author$project$Api$Sort$withDefault, 'issued_on', 0, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            $x: summary,
            ah5: type_
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, creditCategoryResourceFilterCmd),
            A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, model),
            $author$project$Components$Reports$CreditOutstanding$updateUrl(model)
        ])));
    });
    var $author$project$Pages$Reports$CreditOutstanding$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$CreditOutstanding$init, 0, session, practice, shared, query);
        var report = _v1.a;
        var reportTaxCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
    });
    var $author$project$Pages$Reports$CreditOutstanding$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$CreditOutstanding$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditOutstanding$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, $author$project$Components$ResourceFilter$CreditCategory$subscriptions(model.fo)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b8)),
            $author$project$Ui$Dropdown$subscriptions(model.ln)
        ]));
    };
    var $author$project$Pages$Reports$CreditOutstanding$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$CreditOutstanding$subscriptions(model.jQ));
    };
    var $author$project$Components$ResourceFilter$CreditCategory$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Reports$CreditOutstanding$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 2:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$CreditCategory$update, apiClient, subMsg, model.fo);
                var _v1 = result.adu;
                if (!_v1.$ && !_v1.a.$) {
                    var newCreditCategoryId = $author$project$Components$ResourceFilter$CreditCategory$value(result.zi);
                    var newModel = _Utils_update(model, {
                        EZ: newCreditCategoryId,
                        fo: result.zi,
                        a$: $author$project$Api$Data$Loading,
                        af_: $author$project$Api$Pagination$reset(model.af_)
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, result.EQ),
                        A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
                        $author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
                    ])), result.at);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    fo: result.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, result.EQ), result.at);
            case 3:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.ln);
                var byDropdown = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ln: byDropdown
                }), cmd, _List_Nil);
            case 4:
                var by = msg.a;
                var newModel = _Utils_update(model, {
                    bT: by,
                    a$: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                var cmds = function() {
                    var _v3 = _Utils_Tuple2(model.ah5, newModel.bT);
                    if (!_v3.a) {
                        if (!_v3.b.$) {
                            var _v4 = _v3.a;
                            return _List_fromArray([
                                $author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
                            ]);
                        } else {
                            var _v5 = _v3.a;
                            var _v6 = _v3.b;
                            return _List_fromArray([
                                $elm$core$Platform$Cmd$none
                            ]);
                        }
                    } else if (_v3.b.$ === 1) {
                        var _v7 = _v3.a;
                        var _v8 = _v3.b;
                        return _List_fromArray([
                            $author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
                        ]);
                    } else {
                        var _v9 = _v3.a;
                        return _List_fromArray([
                            A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
                            $author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
                        ]);
                    }
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(cmds), _List_Nil);
            case 0:
                var subMsg = msg.a;
                var _v10 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v10.a;
                var subCmd = _v10.b;
                var event = _v10.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            a$: $author$project$Api$Data$Loading,
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b8);
                var _v12 = result.adu;
                switch(_v12.$){
                    case 0:
                        var locationGroupId = _v12.a;
                        var locationId = _v12.b;
                        var practitionerId = _v12.c;
                        var newModel = _Utils_update(model, {
                            a$: $author$project$Api$Data$Loading,
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            Xa: practitionerId
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
                            $author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        a$: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    a$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $x: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    a$: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
                ])), _List_Nil);
            case 8:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CreditOutstanding$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$CreditOutstanding$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v14 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v14.a;
                var subCmd = _v14.b;
                var subOutMsg = _v14.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Reports$CreditOutstanding$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$CreditOutstanding$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$CreditOutstanding$PaginationMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditOutstanding$amountFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$CreditOutstanding$BySelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditOutstanding$byDropdownItems = function(currentBy) {
        return _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditOutstanding$BySelected($elm$core$Maybe$Nothing)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
            ]), $elm$html$Html$text('No Summary')),
            $author$project$Ui$Dropdown$separator,
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditOutstanding$BySelected($elm$core$Maybe$Just('credit_category'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('credit_category')))
            ]), $elm$html$Html$text('Category')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditOutstanding$BySelected($elm$core$Maybe$Just('practitioner'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('practitioner')))
            ]), $elm$html$Html$text('Provider'))
        ]);
    };
    var $author$project$Components$Reports$CreditOutstanding$byToDisplayName = function(by) {
        switch(by){
            case 'credit_category':
                return 'Category';
            case 'practitioner':
                return 'Provider';
            default:
                return by;
        }
    };
    var $author$project$Components$Reports$CreditOutstanding$viewByDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.bT;
            if (!_v0.$) {
                var by = _v0.a;
                return $author$project$Components$Reports$CreditOutstanding$byToDisplayName(by);
            } else return 'Summary By';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), $author$project$Components$Reports$CreditOutstanding$byDropdownItems(model.bT), model.ln);
    };
    var $author$project$Components$Reports$CreditOutstanding$viewCreditCategoryResourceFilter = function(model) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$CreditCategory$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$multi
        ]), model.fo));
    };
    var $author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$Reports$CreditOutstanding$viewSummaryRow = F2(function(model, summaryRow) {
        var routeParams = _List_fromArray([
            $author$project$Ui$Link$routeParams(A2($author$project$Utils$Report$summaryRowTableParams, $author$project$Components$Reports$CreditOutstanding$urlParams(model), summaryRow))
        ]);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$info,
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditOutstanding, routeParams, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'None', $author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditOutstanding, routeParams, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'credit', $author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditOutstanding, routeParams, _List_fromArray([
                        $elm$html$Html$text('Outstanding')
                    ])),
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('numeric')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditOutstanding, routeParams, _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Reports$CreditOutstanding$viewSummaryTable = function(model) {
        var summaryType = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize), $author$project$Api$Data$toMaybe(model.$x)));
        var summaryRows = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Summary$summaryRows, $author$project$Api$Data$toMaybe(model.$x)));
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.$x)),
            $author$project$Ui$Table$zeroState(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text(summaryType)
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Number of Credits')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Reports$CreditOutstanding$viewSummaryRow(model), summaryRows), _List_Nil);
    };
    var $author$project$Components$Reports$CreditOutstanding$SortTable = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$Credit$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$Credit$balanceInCents = function(_v0) {
        var record = _v0;
        return record.abW;
    };
    var $author$project$Api$Provider$Reports$Credit$creditCategory = function(_v0) {
        var record = _v0;
        return record.MB;
    };
    var $author$project$Api$Provider$Reports$Credit$expiresOn = function(_v0) {
        var record = _v0;
        return record.Pj;
    };
    var $author$project$Api$Provider$Reports$Credit$issuedOn = function(_v0) {
        var record = _v0;
        return record.SC;
    };
    var $author$project$Api$Provider$CreditCategory$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Reports$Credit$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Api$Provider$Reports$Credit$practitioner = function(_v0) {
        var record = _v0;
        return record.agi;
    };
    var $author$project$Api$Provider$Reports$Credit$transferredInCents = function(_v0) {
        var record = _v0;
        return record.aaw;
    };
    var $author$project$Components$Reports$CreditOutstanding$viewRow = F2(function(canGoToPatients, credit) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$Credit$issuedOn(credit)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Reports$Credit$expiresOn(credit))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Credit$balanceInCents(credit))),
                $author$project$Api$Provider$Reports$Credit$amountInCents(credit) > 0 ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    !_Utils_eq($author$project$Api$Provider$Reports$Credit$balanceInCents(credit), $author$project$Api$Provider$Reports$Credit$amountInCents(credit)) ? $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Credit$amountInCents(credit))) : $author$project$Utils$Html$empty,
                    $elm$html$Html$text(' Issued')
                ])) : $author$project$Utils$Html$empty,
                $author$project$Api$Provider$Reports$Credit$transferredInCents(credit) > 0 ? A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    !_Utils_eq($author$project$Api$Provider$Reports$Credit$balanceInCents(credit), $author$project$Api$Provider$Reports$Credit$transferredInCents(credit)) ? $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Credit$transferredInCents(credit))) : $author$project$Utils$Html$empty,
                    $elm$html$Html$text(' Transferred')
                ])) : $author$project$Utils$Html$empty
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), function() {
                    var _v0 = _Utils_Tuple2($author$project$Api$Provider$Reports$Credit$patient(credit), canGoToPatients);
                    if (!_v0.a.$) {
                        if (_v0.b) {
                            var patient = _v0.a.a;
                            return _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: $author$project$Api$Provider$Patient$Min$id(patient)
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(patient))
                                ]))
                            ]);
                        } else {
                            var patient = _v0.a.a;
                            return _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(patient))
                            ]);
                        }
                    } else return _List_Nil;
                }())
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$CreditCategory$Min$name, $author$project$Api$Provider$Reports$Credit$creditCategory(credit))))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$colspan(2)
            ]), _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$name, $author$project$Api$Provider$Reports$Credit$practitioner(credit)))))
            ]))
        ]));
    });
    var $author$project$Components$Reports$CreditOutstanding$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.a$;
            if (_v1.$ === 3) {
                var credits_ = _v1.a;
                return _Utils_Tuple2(false, credits_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var credits = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$CreditOutstanding$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, $author$project$Components$Reports$CreditOutstanding$viewRow(model.EF), credits), _List_Nil);
    };
    var $author$project$Components$Reports$CreditOutstanding$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$CreditOutstanding$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.a$)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Credit$listOptionsToParams, $author$project$Components$Reports$CreditOutstanding$fetchCreditsParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Credit Outstanding')
                    ])),
                    $author$project$Ui$Panel$title(function() {
                        var _v0 = model.a$;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total Outstanding: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$CreditOutstanding$amountFromHeader, headers, 'x-total-balance')))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Total Outstanding: $1000.00')
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('All outstanding credits for retail customers')
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(1)
                        ]), _List_fromArray([
                            $author$project$Ui$Typography$headingSm(_List_fromArray([
                                $elm$html$Html$text('Issued')
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(11)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Reports$CreditOutstanding$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$spanSm(3),
                        $author$project$Ui$Grid$spanMd(4)
                    ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                        $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
                    ]), model.b8))), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanSm(3),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$CreditOutstanding$viewCreditCategoryResourceFilter(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanSm(3),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$CreditOutstanding$viewByDropdown(model)
                        ]))
                    ]))),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b8)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$CreditOutstanding$CreditCategoryResourceFilterMsg), $author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected(model.fo)));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                function() {
                    var _v1 = model.ah5;
                    if (!_v1) return $author$project$Components$Reports$CreditOutstanding$viewTable(model);
                    else return $author$project$Components$Reports$CreditOutstanding$viewSummaryTable(model);
                }(),
                function() {
                    var _v2 = model.ah5;
                    if (!_v2) return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$CreditOutstanding$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.a$)))
                        ]), model.af_))
                    ]));
                    else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]);
    });
    var $author$project$Pages$Reports$CreditOutstanding$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$CreditOutstanding$view, model.Ej, model.jQ)),
            $2: 'Reports | Credit Outstanding'
        };
    };
    var $author$project$Pages$Reports$CreditOutstanding$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$CreditOutstanding$init,
        aeR: $author$project$Pages$Reports$CreditOutstanding$load,
        ag3: $author$project$Pages$Reports$CreditOutstanding$save,
        ahE: $author$project$Pages$Reports$CreditOutstanding$subscriptions,
        aaO: $author$project$Pages$Reports$CreditOutstanding$update,
        aid: $author$project$Pages$Reports$CreditOutstanding$view
    });
    var $author$project$Pages$Reports$CreditOutstanding$Summary$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$CreditOutstanding$Summary = 1;
    var $author$project$Pages$Reports$CreditOutstanding$Summary$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$CreditOutstanding$init, 1, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$CreditOutstanding$Summary$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$CreditOutstanding$Summary$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$CreditOutstanding$Summary$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$CreditOutstanding$subscriptions(model.jQ));
    };
    var $author$project$Pages$Reports$CreditOutstanding$Summary$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$CreditOutstanding$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Reports$CreditOutstanding$Summary$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$CreditOutstanding$view, model.Ej, model.jQ)),
            $2: 'Reports | Credit Outstanding'
        };
    };
    var $author$project$Pages$Reports$CreditOutstanding$Summary$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$CreditOutstanding$Summary$init,
        aeR: $author$project$Pages$Reports$CreditOutstanding$Summary$load,
        ag3: $author$project$Pages$Reports$CreditOutstanding$Summary$save,
        ahE: $author$project$Pages$Reports$CreditOutstanding$Summary$subscriptions,
        aaO: $author$project$Pages$Reports$CreditOutstanding$Summary$update,
        aid: $author$project$Pages$Reports$CreditOutstanding$Summary$view
    });
    var $author$project$Pages$Reports$CreditTransactions$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$CreditTransactions$Table = 0;
    var $author$project$Components$Reports$CreditTransactions$ByDropdownMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$CreditLine = 14;
    var $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$TypeDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$urlParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('credit_category'), model.EZ),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location'), model.Tp),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('practitioner'), model.Xa),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('type'), model.g9),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('by'), model.bT)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Components$Reports$CreditTransactions$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            function() {
                var _v0 = model.bT;
                if (!_v0.$) return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary);
                else return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__CreditTransactions);
            }()
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), $author$project$Utils$QueryParameter$fromDict($author$project$Components$Reports$CreditTransactions$urlParams(model)))));
    };
    var $author$project$Components$Reports$CreditTransactions$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$CreditTransactions$GotCreditLines = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                MB: model.EZ,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                af_: model.af_,
                agi: model.Xa,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ah5: model.g9
            });
        };
    };
    var $author$project$Api$Provider$Reports$CreditLine$CreditLine = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$CreditLine$Record = F8(function(transactionDate, amountInCents, type_, invoice, patient, creditCategory, practitioner, location1) {
        return {
            Jh: amountInCents,
            MB: creditCategory,
            RA: invoice,
            aeT: location1,
            V7: patient,
            agi: practitioner,
            aat: transactionDate,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$Reports$CreditLine$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credit_category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$CreditCategory$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transaction_date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$CreditLine$Record)))))))));
    var $author$project$Api$Provider$Reports$CreditLine$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$CreditLine$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$CreditLine$listDefaults = {
        MB: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agi: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        ah5: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$CreditLine$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$CreditLine$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.agi;
                if (!_v2.$) {
                    var practitioner_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', practitioner_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.MB;
                if (!_v3.$) {
                    var taxJurisdiction_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'credit_category', taxJurisdiction_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.rm;
                if (!_v4.$) {
                    var locationGroup_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', locationGroup_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.aeT;
                if (!_v5.$) {
                    var location_ = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', location_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.ah5;
                if (!_v6.$) {
                    var string = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'type', string)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$CreditLine$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'credit_lines'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$CreditLine$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$CreditLine$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$CreditLine$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$CreditLine$listPath)));
    });
    var $author$project$Components$Reports$CreditTransactions$fetchCreditLines = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$CreditLine$list, apiClient, $author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams(model), $author$project$Components$Reports$CreditTransactions$GotCreditLines);
    });
    var $author$project$Components$Reports$CreditTransactions$GotSummary = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$fetchSummaryParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                MB: model.EZ,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                agi: model.Xa,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ah5: model.g9
            });
        };
    };
    var $author$project$Api$Provider$Reports$CreditLine$summary = F4(function(apiClient, by, optionals, toMsg) {
        return A5($author$project$Api$Provider$Reports$Summary$retrieve, apiClient, $author$project$Api$Provider$Reports$CreditLine$listPath, by, $author$project$Api$Provider$Reports$CreditLine$listOptionsToParams(optionals), toMsg);
    });
    var $author$project$Components$Reports$CreditTransactions$fetchSummary = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$Reports$CreditLine$summary, apiClient, A2($elm$core$Maybe$withDefault, '', model.bT), $author$project$Components$Reports$CreditTransactions$fetchSummaryParams(model), $author$project$Components$Reports$CreditTransactions$GotSummary);
    });
    var $author$project$Components$Reports$CreditTransactions$fetchData = F2(function(apiClient, model) {
        var _v0 = model.ah5;
        if (!_v0) return A2($author$project$Components$Reports$CreditTransactions$fetchCreditLines, apiClient, model);
        else return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Reports$CreditTransactions$fetchSummary, apiClient, model),
            A2($author$project$Components$Reports$CreditTransactions$fetchCreditLines, apiClient, model)
        ]));
    });
    var $author$project$Components$Reports$CreditTransactions$initColumns = function(trackPatientsByLocation) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
                A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
                A3($author$project$Api$Column$init, 'type', true, 'Type'),
                A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
                A3($author$project$Api$Column$init, 'patient', true, 'Patient'),
                A3($author$project$Api$Column$init, 'credit_category', true, 'Category'),
                A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
            ]),
            trackPatientsByLocation ? _List_fromArray([
                A3($author$project$Api$Column$init, 'location', true, 'Location')
            ]) : _List_Nil
        ]));
    };
    var $author$project$Components$Reports$CreditTransactions$init = F5(function(type_, session, practice, _v0, query) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var _v1 = function() {
            if (!type_) return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
            else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
        }();
        var creditLines = _v1.a;
        var summary = _v1.b;
        var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v3.a;
        var groupLocationAndPractitionerFiltersCmd = _v3.b;
        var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v4.a;
        var end = _v4.b;
        var _v5 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$CreditTransactions$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v5.a;
        var dateRangeInputCmd = _v5.b;
        var _v6 = A2($author$project$Components$ResourceFilter$CreditCategory$init, apiClient, function(d) {
            return _Utils_update(d, {
                Ee: 'All Categories',
                agj: A2($elm$core$Dict$get, 'credit_category', query)
            });
        });
        var creditCategoryResourceFilter = _v6.a;
        var creditCategoryResourceFilterCmd = _v6.b;
        var model = {
            bT: A2($elm$core$Dict$get, 'by', query),
            ln: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'by-dropdown',
                ahX: $author$project$Components$Reports$CreditTransactions$ByDropdownMsg
            })),
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            LC: $author$project$Components$Reports$CreditTransactions$initColumns(trackPatientsByLocation),
            EZ: A2($elm$core$Dict$get, 'credit_category', query),
            fo: creditCategoryResourceFilter,
            aE: creditLines,
            cP: currentDate,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 14
            }),
            b8: groupLocationAndPractitionerFilters,
            f0: locationGroupId,
            Tp: locationId,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            Xa: practitionerId,
            ahs: A3($author$project$Api$Sort$withDefault, 'transaction_date', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            $x: summary,
            aaq: trackPatientsByLocation,
            oX: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'type-dropdown',
                ahX: $author$project$Components$Reports$CreditTransactions$TypeDropdownMsg
            })),
            g9: A2($elm$core$Dict$get, 'type', query),
            ah5: type_
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, creditCategoryResourceFilterCmd),
            A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, model),
            A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Reports$CreditTransactions$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$CreditTransactions$init, 0, session, practice, shared, query);
        var report = _v1.a;
        var reportTaxCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
    });
    var $author$project$Pages$Reports$CreditTransactions$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$CreditTransactions$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$CreditTransactions$ExportCsvMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CreditTransactions$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, $author$project$Components$ResourceFilter$CreditCategory$subscriptions(model.fo)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b8)),
            $author$project$Ui$Dropdown$subscriptions(model.ln),
            $author$project$Ui$Dropdown$subscriptions(model.oX)
        ]));
    };
    var $author$project$Pages$Reports$CreditTransactions$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$CreditTransactions$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$CreditTransactions$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 2:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$CreditCategory$update, apiClient, subMsg, model.fo);
                var _v1 = result.adu;
                if (!_v1.$ && !_v1.a.$) {
                    var newCreditCategoryId = $author$project$Components$ResourceFilter$CreditCategory$value(result.zi);
                    var newModel = _Utils_update(model, {
                        EZ: newCreditCategoryId,
                        fo: result.zi,
                        aE: $author$project$Api$Data$Loading,
                        af_: $author$project$Api$Pagination$reset(model.af_)
                    });
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, result.EQ),
                        A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
                        A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                    ])), result.at);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    fo: result.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, result.EQ), result.at);
            case 3:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.oX);
                var typeDropdown = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oX: typeDropdown
                }), cmd, _List_Nil);
            case 4:
                var typeFilter = msg.a;
                var newModel = _Utils_update(model, {
                    aE: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    g9: typeFilter
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 5:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.ln);
                var byDropdown = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ln: byDropdown
                }), cmd, _List_Nil);
            case 6:
                var by = msg.a;
                var newModel = _Utils_update(model, {
                    bT: by,
                    aE: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                var cmds = function() {
                    var _v4 = _Utils_Tuple2(model.ah5, newModel.bT);
                    if (!_v4.a) {
                        if (!_v4.b.$) {
                            var _v5 = _v4.a;
                            return _List_fromArray([
                                A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                            ]);
                        } else {
                            var _v6 = _v4.a;
                            var _v7 = _v4.b;
                            return _List_fromArray([
                                $elm$core$Platform$Cmd$none
                            ]);
                        }
                    } else if (_v4.b.$ === 1) {
                        var _v8 = _v4.a;
                        var _v9 = _v4.b;
                        return _List_fromArray([
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ]);
                    } else {
                        var _v10 = _v4.a;
                        return _List_fromArray([
                            A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ]);
                    }
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(cmds), _List_Nil);
            case 0:
                var subMsg = msg.a;
                var _v11 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v11.a;
                var subCmd = _v11.b;
                var event = _v11.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            aE: $author$project$Api$Data$Loading,
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b8);
                var _v13 = result.adu;
                switch(_v13.$){
                    case 0:
                        var locationGroupId = _v13.a;
                        var locationId = _v13.b;
                        var practitionerId = _v13.c;
                        var newModel = _Utils_update(model, {
                            aE: $author$project$Api$Data$Loading,
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            Xa: practitionerId
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 7:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aE: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    aE: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $x: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    aE: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 10:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$CreditTransactions$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$CreditTransactions$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v15 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v15.a;
                var subCmd = _v15.b;
                var subOutMsg = _v15.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$CreditTransactions$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Reports$CreditTransactions$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$CreditTransactions$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$CreditTransactions$PaginationMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$amountFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$CreditTransactions$BySelected = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$byDropdownItems = F2(function(trackPatientsByLocation, currentBy) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$BySelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Summary')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$BySelected($elm$core$Maybe$Just('credit_category'))),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('credit_category')))
        ]), $elm$html$Html$text('Category')), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$BySelected($elm$core$Maybe$Just('practitioner'))),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('practitioner')))
        ]), $elm$html$Html$text('Provider')), trackPatientsByLocation ? _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$BySelected($elm$core$Maybe$Just('location'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('location')))
            ]), $elm$html$Html$text('Location'))
        ]) : _List_Nil))));
    });
    var $author$project$Components$Reports$CreditTransactions$byToDisplayName = function(by) {
        switch(by){
            case 'credit_category':
                return 'Category';
            case 'practitioner':
                return 'Provider';
            case 'location':
                return 'Location';
            default:
                return by;
        }
    };
    var $author$project$Components$Reports$CreditTransactions$viewByDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.bT;
            if (!_v0.$) {
                var by = _v0.a;
                return $author$project$Components$Reports$CreditTransactions$byToDisplayName(by);
            } else return 'Summary By';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), A2($author$project$Components$Reports$CreditTransactions$byDropdownItems, model.aaq, model.bT), model.ln);
    };
    var $author$project$Components$Reports$CreditTransactions$viewCreditCategoryResourceFilter = function(model) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$CreditCategory$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$multi
        ]), model.fo));
    };
    var $author$project$Components$Reports$CreditTransactions$viewSummaryRow = F2(function(model, summaryRow) {
        var routeParams = _List_fromArray([
            $author$project$Ui$Link$routeParams(A2($author$project$Utils$Report$summaryRowTableParams, $author$project$Components$Reports$CreditTransactions$urlParams(model), summaryRow))
        ]);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$info,
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditTransactions, routeParams, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'None', $author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditTransactions, routeParams, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'credit', $author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('numeric')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditTransactions, routeParams, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Reports$CreditTransactions$viewSummaryTable = function(model) {
        var summaryType = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize), $author$project$Api$Data$toMaybe(model.$x)));
        var summaryRows = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Summary$summaryRows, $author$project$Api$Data$toMaybe(model.$x)));
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.$x)),
            $author$project$Ui$Table$zeroState(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text(summaryType)
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Number of Credits')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Reports$CreditTransactions$viewSummaryRow(model), summaryRows), _List_Nil);
    };
    var $author$project$Components$Reports$CreditTransactions$SortTable = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$CreditLine$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$CreditLine$creditCategory = function(_v0) {
        var record = _v0;
        return record.MB;
    };
    var $author$project$Api$Provider$Reports$CreditLine$invoice = function(_v0) {
        var record = _v0;
        return record.RA;
    };
    var $author$project$Api$Provider$Reports$CreditLine$location = function(_v0) {
        var record = _v0;
        return record.aeT;
    };
    var $author$project$Api$Provider$Reports$CreditLine$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Api$Provider$Reports$CreditLine$practitioner = function(_v0) {
        var record = _v0;
        return record.agi;
    };
    var $author$project$Api$Provider$Reports$CreditLine$transactionDate = function(_v0) {
        var record = _v0;
        return record.aat;
    };
    var $author$project$Api$Provider$Reports$CreditLine$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Components$Reports$CreditTransactions$viewRow = F3(function(trackPatientsByLocation, canGoToPatients, creditLine) {
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$CreditLine$transactionDate(creditLine)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$CreditLine$amountInCents(creditLine)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$String$humanize($author$project$Api$Provider$Reports$CreditLine$type_(creditLine)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, function() {
                    var _v0 = $author$project$Api$Provider$Reports$CreditLine$invoice(creditLine);
                    if (!_v0.$) {
                        var invoice = _v0.a;
                        var _v1 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
                        if (!_v1.$) {
                            var owner = _v1.a;
                            return _Utils_ap(canGoToPatients ? _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                    RI: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
                                    V8: $author$project$Api$Common$Payable$Owner$Min$id(owner)
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('#' + ($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' ')),
                                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice))
                                ]))
                            ]) : _List_fromArray([
                                $elm$html$Html$text('#' + ($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' ')),
                                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice))
                            ]), _List_fromArray([
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$small,
                                    $author$project$Ui$Typography$muted,
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text('for ' + $author$project$Api$Common$Payable$Owner$Min$name(owner))
                                ]))
                            ]));
                        } else return _List_Nil;
                    } else return _List_Nil;
                }()),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), function() {
                        var _v2 = _Utils_Tuple2($author$project$Api$Provider$Reports$CreditLine$patient(creditLine), canGoToPatients);
                        if (!_v2.a.$) {
                            if (_v2.b) {
                                var patient = _v2.a.a;
                                return _List_fromArray([
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                        V8: $author$project$Api$Provider$Patient$Min$id(patient)
                                    }), _List_Nil, _List_fromArray([
                                        $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(patient))
                                    ]))
                                ]);
                            } else {
                                var patient = _v2.a.a;
                                return _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Provider$Patient$Min$name(patient))
                                ]);
                            }
                        } else return _List_Nil;
                    }())
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$CreditCategory$Min$name, $author$project$Api$Provider$Reports$CreditLine$creditCategory(creditLine))))
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(trackPatientsByLocation ? 1 : 2)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$name, $author$project$Api$Provider$Reports$CreditLine$practitioner(creditLine))))
                ]))
            ]),
            trackPatientsByLocation ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$Reports$CreditLine$location(creditLine)))))
                ]))
            ]) : _List_Nil
        ])));
    });
    var $author$project$Components$Reports$CreditTransactions$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.aE;
            if (_v1.$ === 3) {
                var creditLines_ = _v1.a;
                return _Utils_Tuple2(false, creditLines_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var creditLines = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$CreditTransactions$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$CreditTransactions$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A2($author$project$Components$Reports$CreditTransactions$viewRow, model.aaq, model.EF), creditLines), _List_Nil);
    };
    var $author$project$Components$Reports$CreditTransactions$TypeSelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$CreditTransactions$typeDropdownItems = function(currentType) {
        return _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$TypeSelected($elm$core$Maybe$Nothing)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentType, $elm$core$Maybe$Nothing))
            ]), $elm$html$Html$text('All Types')),
            $author$project$Ui$Dropdown$separator,
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$TypeSelected($elm$core$Maybe$Just('expired'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentType, $elm$core$Maybe$Just('expired')))
            ]), $elm$html$Html$text('Expired')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$TypeSelected($elm$core$Maybe$Just('applied'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentType, $elm$core$Maybe$Just('applied')))
            ]), $elm$html$Html$text('Applied')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$TypeSelected($elm$core$Maybe$Just('issued'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentType, $elm$core$Maybe$Just('issued')))
            ]), $elm$html$Html$text('Issued')),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$CreditTransactions$TypeSelected($elm$core$Maybe$Just('transferred'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentType, $elm$core$Maybe$Just('transferred')))
            ]), $elm$html$Html$text('Transferred'))
        ]);
    };
    var $author$project$Components$Reports$CreditTransactions$typeToDisplayName = function(typeFilter) {
        switch(typeFilter){
            case 'expired':
                return 'Expired';
            case 'applied':
                return 'Applied';
            case 'issued':
                return 'Issued';
            case 'transferred':
                return 'Transferred';
            default:
                return typeFilter;
        }
    };
    var $author$project$Components$Reports$CreditTransactions$viewTypeDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.g9;
            if (!_v0.$) {
                var typeFilter = _v0.a;
                return $author$project$Components$Reports$CreditTransactions$typeToDisplayName(typeFilter);
            } else return 'Type';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), $author$project$Components$Reports$CreditTransactions$typeDropdownItems(model.g9), model.oX);
    };
    var $author$project$Components$Reports$CreditTransactions$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$CreditTransactions$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.aE)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$CreditLine$listOptionsToParams, $author$project$Components$Reports$CreditTransactions$fetchCreditLinesParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Credit Transactions')
                    ])),
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.aE;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$CreditTransactions$amountFromHeader, headers, 'x-total-amount')))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]);
                    }()),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Total credit transactions for retail customers')
                    ])),
                    A2($elm$html$Html$map, $author$project$Components$Reports$CreditTransactions$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6)),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$spanMd(4)
                    ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                        $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
                    ]), model.b8))), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$CreditTransactions$viewCreditCategoryResourceFilter(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$CreditTransactions$viewTypeDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$CreditTransactions$viewByDropdown(model)
                        ]))
                    ]))),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$CreditTransactions$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b8)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$CreditTransactions$CreditCategoryResourceFilterMsg), $author$project$Components$ResourceFilter$CreditCategory$viewMultiSelected(model.fo)));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                function() {
                    var _v1 = model.ah5;
                    if (!_v1) return $author$project$Components$Reports$CreditTransactions$viewTable(model);
                    else return $author$project$Components$Reports$CreditTransactions$viewSummaryTable(model);
                }(),
                function() {
                    var _v2 = model.ah5;
                    if (!_v2) return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$CreditTransactions$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.aE)))
                        ]), model.af_))
                    ]));
                    else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]);
    });
    var $author$project$Pages$Reports$CreditTransactions$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$CreditTransactions$view, model.Ej, model.jQ)),
            $2: 'Reports | Credit Transactions'
        };
    };
    var $author$project$Pages$Reports$CreditTransactions$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$CreditTransactions$init,
        aeR: $author$project$Pages$Reports$CreditTransactions$load,
        ag3: $author$project$Pages$Reports$CreditTransactions$save,
        ahE: $author$project$Pages$Reports$CreditTransactions$subscriptions,
        aaO: $author$project$Pages$Reports$CreditTransactions$update,
        aid: $author$project$Pages$Reports$CreditTransactions$view
    });
    var $author$project$Pages$Reports$CreditTransactions$Summary$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$CreditTransactions$Summary = 1;
    var $author$project$Pages$Reports$CreditTransactions$Summary$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$CreditTransactions$init, 1, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$CreditTransactions$Summary$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$CreditTransactions$Summary$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$CreditTransactions$Summary$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$CreditTransactions$subscriptions(model.jQ));
    };
    var $author$project$Pages$Reports$CreditTransactions$Summary$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$CreditTransactions$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Reports$CreditTransactions$Summary$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$CreditTransactions$view, model.Ej, model.jQ)),
            $2: 'Reports | Credit Transactions'
        };
    };
    var $author$project$Pages$Reports$CreditTransactions$Summary$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$CreditTransactions$Summary$init,
        aeR: $author$project$Pages$Reports$CreditTransactions$Summary$load,
        ag3: $author$project$Pages$Reports$CreditTransactions$Summary$save,
        ahE: $author$project$Pages$Reports$CreditTransactions$Summary$subscriptions,
        aaO: $author$project$Pages$Reports$CreditTransactions$Summary$update,
        aid: $author$project$Pages$Reports$CreditTransactions$Summary$view
    });
    var $author$project$Pages$Reports$Custom$Id_String$GotEmbeddedReport = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$EmbeddedReport$One$EmbeddedReport = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$EmbeddedReport$Shared$EmbeddedReport = $elm$core$Basics$identity;
    var $author$project$Api$Provider$EmbeddedReport$Shared$Record = F2(function(id, name) {
        return {
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$EmbeddedReport$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$EmbeddedReport$Shared$Record)));
    var $author$project$Api$Provider$EmbeddedReport$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$EmbeddedReport$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$EmbeddedReport$One$Record = F2(function(service, descriptionLink) {
        return {
            NR: descriptionLink,
            ZY: service
        };
    });
    var $author$project$Api$Provider$EmbeddedReport$One$Periscope = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$EmbeddedReport$One$ThoughtSpot = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$EmbeddedReport$One$reportFromServiceName = function(string) {
        switch(string){
            case 'periscope':
                return A2($elm$json$Json$Decode$map, $author$project$Api$Provider$EmbeddedReport$One$Periscope, A2($elm$json$Json$Decode$at, _List_fromArray([
                    'signed_url'
                ]), $elm$json$Json$Decode$string));
            case 'thoughtspot':
                return A2($elm$json$Json$Decode$map, $author$project$Api$Provider$EmbeddedReport$One$ThoughtSpot, A2($elm$json$Json$Decode$at, _List_fromArray([
                    'report_id'
                ]), $elm$json$Json$Decode$string));
            default:
                return $elm$json$Json$Decode$fail('Invalid report type: ');
        }
    };
    var $author$project$Api$Provider$EmbeddedReport$One$recordDecoder = A3($elm$json$Json$Decode$map2, $author$project$Api$Provider$EmbeddedReport$One$Record, A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$EmbeddedReport$One$reportFromServiceName, A2($elm$json$Json$Decode$field, 'service_name', $elm$json$Json$Decode$string)), A2($elm$json$Json$Decode$field, 'description_link', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)));
    var $author$project$Api$Provider$EmbeddedReport$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$EmbeddedReport$One$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$EmbeddedReport$Shared$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$EmbeddedReport$One$EmbeddedReport)));
    var $author$project$Api$Provider$EmbeddedReport$embeddedReportsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'embedded_reports'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$EmbeddedReport$embeddedReportPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$EmbeddedReport$embeddedReportsPath);
    };
    var $author$project$Api$Provider$EmbeddedReport$retrieveDefaults = {
        G3: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$EmbeddedReport$retrieveOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$EmbeddedReport$retrieveDefaults);
        var _v0 = options.G3;
        if (!_v0.$) {
            var filter = _v0.a;
            return _List_fromArray([
                A2($author$project$Api$Param$list, 'practices_filter', filter)
            ]);
        } else return _List_Nil;
    };
    var $author$project$Api$Provider$EmbeddedReport$retrieve = F4(function(apiClient, id_, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$EmbeddedReport$One$decoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$EmbeddedReport$retrieveOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$EmbeddedReport$embeddedReportPath(id_))));
    });
    var $author$project$Pages$Reports$Custom$Id_String$init = F4(function(session, practice, shared, _v0) {
        var params = _v0.VU;
        var model = {
            Ej: shared.Ej,
            F3: $author$project$Shared$isHintAdmin(shared),
            W1: practice,
            jD: $author$project$Api$Data$NotAsked,
            jQ: $author$project$Api$Data$Loading,
            YA: params.aef,
            sw: false,
            Z$: session
        };
        return _Utils_Tuple2(model, A4($author$project$Api$Provider$EmbeddedReport$retrieve, shared.Ej, params.aef, $elm$core$Basics$identity, $author$project$Pages$Reports$Custom$Id_String$GotEmbeddedReport));
    });
    var $author$project$Pages$Reports$Custom$Id_String$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Custom$Id_String$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotTokenRequested = {
        $: 1
    };
    var $author$project$Ports$ThoughtSpot$onThoughtSpotTokenRequestPort = _Platform_incomingPort('onThoughtSpotTokenRequestPort', $elm$json$Json$Decode$null(0));
    var $author$project$Ports$ThoughtSpot$onTokenRequested = A2($elm$core$Basics$composeR, $elm$core$Basics$always, $author$project$Ports$ThoughtSpot$onThoughtSpotTokenRequestPort);
    var $author$project$Pages$Reports$Custom$Id_String$subscriptions = function(_v0) {
        return $author$project$Ports$ThoughtSpot$onTokenRequested($author$project$Pages$Reports$Custom$Id_String$ThoughtSpotTokenRequested);
    };
    var $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$EmbeddedReport$tokenDecoder = A2($elm$json$Json$Decode$at, _List_fromArray([
        'token'
    ]), $elm$json$Json$Decode$string);
    var $author$project$Api$Provider$EmbeddedReport$managementGroupToken = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$EmbeddedReport$tokenDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'management_group_token'
        ]), $author$project$Api$Provider$EmbeddedReport$embeddedReportsPath)));
    });
    var $author$project$Api$Provider$EmbeddedReport$token = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$EmbeddedReport$tokenDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'token'
        ]), $author$project$Api$Provider$EmbeddedReport$embeddedReportsPath)));
    });
    var $author$project$Pages$Reports$Custom$Id_String$andRequestToken = function(model) {
        return _Utils_Tuple2(model, model.sw ? A2($author$project$Api$Provider$EmbeddedReport$managementGroupToken, model.Ej, $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken) : A2($author$project$Api$Provider$EmbeddedReport$token, model.Ej, $author$project$Pages$Reports$Custom$Id_String$ThoughtSpotGotToken));
    };
    var $author$project$Ports$ThoughtSpot$authenticateThoughtSpotPort = _Platform_outgoingPort('authenticateThoughtSpotPort', $elm$json$Json$Encode$string);
    var $author$project$Ports$ThoughtSpot$authenticate = $author$project$Ports$ThoughtSpot$authenticateThoughtSpotPort;
    var $author$project$Ports$ThoughtSpot$ReportRecord = F2(function(id, email) {
        return {
            OH: email,
            aef: id
        };
    });
    var $author$project$Ports$ThoughtSpot$embedThoughtSpotPort = _Platform_outgoingPort('embedThoughtSpotPort', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('email', $elm$json$Json$Encode$string($.OH)),
            _Utils_Tuple2('id', $elm$json$Json$Encode$string($.aef))
        ]));
    });
    var $author$project$Ports$ThoughtSpot$embed = F2(function(id, email) {
        return $author$project$Ports$ThoughtSpot$embedThoughtSpotPort(A2($author$project$Ports$ThoughtSpot$ReportRecord, id, email));
    });
    var $author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction = F3(function(action, reportId, model) {
        return function(email) {
            return A2(action, reportId, email);
        }($author$project$Api$Platform$User$Shared$email($author$project$Api$Platform$Session$One$user(model.Z$)));
    });
    var $author$project$Api$Provider$EmbeddedReport$One$service = function(_v0) {
        var record = _v0.b;
        return record.ZY;
    };
    var $author$project$Pages$Reports$Custom$Id_String$update = F2(function(msg, model) {
        switch(msg.$){
            case 3:
                var bool = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    sw: bool
                }), function() {
                    var _v1 = model.jQ;
                    if (_v1.$ === 3) {
                        var report = _v1.a;
                        var _v2 = $author$project$Api$Provider$EmbeddedReport$One$service(report);
                        if (_v2.$ === 1) {
                            var reportId = _v2.a;
                            return A3($author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction, $author$project$Ports$ThoughtSpot$embed, reportId, model);
                        } else return $elm$core$Platform$Cmd$none;
                    } else return $elm$core$Platform$Cmd$none;
                }(), _List_Nil);
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    jQ: response
                }), function() {
                    if (response.$ === 3) {
                        var report = response.a;
                        var _v4 = $author$project$Api$Provider$EmbeddedReport$One$service(report);
                        if (_v4.$ === 1) {
                            var reportId = _v4.a;
                            return A3($author$project$Pages$Reports$Custom$Id_String$performThoughtSpotAction, $author$project$Ports$ThoughtSpot$embed, reportId, model);
                        } else return $elm$core$Platform$Cmd$none;
                    } else return $elm$core$Platform$Cmd$none;
                }(), $author$project$OutMsg$handleErrorResponse(response));
            case 1:
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, $author$project$Pages$Reports$Custom$Id_String$andRequestToken(model));
            default:
                var dataReport = msg.a;
                return _Utils_Tuple3(model, function() {
                    if (dataReport.$ === 3) {
                        var token = dataReport.a;
                        return $author$project$Ports$ThoughtSpot$authenticate(token);
                    } else return $elm$core$Platform$Cmd$none;
                }(), $author$project$OutMsg$handleErrorResponse(dataReport));
        }
    });
    var $author$project$Api$Provider$EmbeddedReport$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$EmbeddedReport$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$EmbeddedReport$Shared$name(shared);
    };
    var $author$project$Pages$Reports$Custom$Id_String$viewPeriscope = F2(function(signedUrl, embeddedReport) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$EmbeddedReport$One$name(embeddedReport))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$iframe, _List_fromArray([
                    $elm$html$Html$Attributes$src(signedUrl),
                    A2($elm$html$Html$Attributes$attribute, 'width', '100%'),
                    $elm$html$Html$Attributes$height(480),
                    A2($elm$html$Html$Attributes$attribute, 'frameborder', '0')
                ]), _List_Nil)
            ]))
        ]));
    });
    var $author$project$Pages$Reports$Custom$Id_String$ToughtSpotTokenRequestAsManagementGroup = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$EmbeddedReport$One$descriptionLink = function(_v0) {
        var record = _v0.b;
        return record.NR;
    };
    var $author$project$Pages$Reports$Custom$Id_String$viewThoughtspot = F2(function(embeddedReport, model) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$EmbeddedReport$One$name(embeddedReport))
                    ])),
                    A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, function(link) {
                        return _List_fromArray([
                            $elm$html$Html$text('Report description '),
                            A3($author$project$Ui$Link$externalHref, link, _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text('here')
                            ]))
                        ]);
                    }, $author$project$Ui$Element$view(_List_fromArray([
                        $author$project$Ui$Element$textMuted
                    ]))), $author$project$Api$Provider$EmbeddedReport$One$descriptionLink(embeddedReport)))
                ])),
                model.F3 ? A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$spaceX2
                ]), _List_fromArray([
                    $author$project$Ui$HinterOnly$icon(_List_Nil),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$inlineBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('view as management group')
                    ])),
                    $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                        $author$project$Ui$ToggleSwitch$sm,
                        $author$project$Ui$ToggleSwitch$on(model.sw),
                        $author$project$Ui$ToggleSwitch$onChange($author$project$Pages$Reports$Custom$Id_String$ToughtSpotTokenRequestAsManagementGroup)
                    ]))
                ])) : $elm$html$Html$text('')
            ]))
        ]));
    });
    var $author$project$Pages$Reports$Custom$Id_String$viewBody = function(model) {
        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            function() {
                var _v0 = model.jQ;
                if (_v0.$ === 3) {
                    var embeddedReport = _v0.a;
                    var _v1 = $author$project$Api$Provider$EmbeddedReport$One$service(embeddedReport);
                    if (!_v1.$) {
                        var signedUrl = _v1.a;
                        return A2($author$project$Pages$Reports$Custom$Id_String$viewPeriscope, signedUrl, embeddedReport);
                    } else return A2($author$project$Pages$Reports$Custom$Id_String$viewThoughtspot, embeddedReport, model);
                } else return $elm$html$Html$text('');
            }(),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$id('ts-embed'),
                A2($elm$html$Html$Attributes$style, 'margin-left', '-30px'),
                A2($elm$html$Html$Attributes$style, 'margin-right', '-30px'),
                A2($elm$html$Html$Attributes$style, 'min-height', 'calc(100vh - 55px - 60px - 60px)')
            ]), _List_Nil)
        ]));
    };
    var $author$project$Pages$Reports$Custom$Id_String$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Reports$Custom$Id_String$viewBody(model)
            ]),
            $2: 'Reports'
        };
    };
    var $author$project$Pages$Reports$Custom$Id_String$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Custom$Id_String$init,
        aeR: $author$project$Pages$Reports$Custom$Id_String$load,
        ag3: $author$project$Pages$Reports$Custom$Id_String$save,
        ahE: $author$project$Pages$Reports$Custom$Id_String$subscriptions,
        aaO: $author$project$Pages$Reports$Custom$Id_String$update,
        aid: $author$project$Pages$Reports$Custom$Id_String$view
    });
    var $author$project$Ports$ThoughtSpot$SearchRecord = function(email) {
        return {
            OH: email
        };
    };
    var $author$project$Ports$ThoughtSpot$embedSearchThoughtSpotPort = _Platform_outgoingPort('embedSearchThoughtSpotPort', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('email', $elm$json$Json$Encode$string($.OH))
        ]));
    });
    var $author$project$Ports$ThoughtSpot$embedSearch = A2($elm$core$Basics$composeR, $author$project$Ports$ThoughtSpot$SearchRecord, $author$project$Ports$ThoughtSpot$embedSearchThoughtSpotPort);
    var $author$project$Pages$Reports$Custom$New$init = F4(function(session, practice, shared, _v0) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            W1: practice,
            Z$: session
        }, $author$project$Ports$ThoughtSpot$embedSearch($author$project$Api$Platform$User$Shared$email($author$project$Api$Platform$Session$One$user(session))));
    });
    var $author$project$Pages$Reports$Custom$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Custom$New$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$Custom$New$ThoughtSpotTokenRequested = {
        $: 0
    };
    var $author$project$Pages$Reports$Custom$New$subscriptions = function(_v0) {
        return $author$project$Ports$ThoughtSpot$onTokenRequested($author$project$Pages$Reports$Custom$New$ThoughtSpotTokenRequested);
    };
    var $author$project$Pages$Reports$Custom$New$ThoughtSpotGotToken = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Reports$Custom$New$update = F2(function(msg, model) {
        if (!msg.$) return _Utils_Tuple3(model, A2($author$project$Api$Provider$EmbeddedReport$token, model.Ej, $author$project$Pages$Reports$Custom$New$ThoughtSpotGotToken), _List_Nil);
        else {
            var dataReport = msg.a;
            return _Utils_Tuple3(model, function() {
                if (dataReport.$ === 3) {
                    var token = dataReport.a;
                    return $author$project$Ports$ThoughtSpot$authenticate(token);
                } else return $elm$core$Platform$Cmd$none;
            }(), _List_Nil);
        }
    });
    var $author$project$Pages$Reports$Custom$New$viewBody = function(_v0) {
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$id('ts-search-embed'),
                A2($elm$html$Html$Attributes$style, 'height', 'calc(100vh - 55px - 60px - 60px)')
            ]), _List_Nil)
        ]);
    };
    var $author$project$Pages$Reports$Custom$New$view = function(model) {
        return {
            fb: $author$project$Pages$Reports$Custom$New$viewBody(model),
            $2: 'Reports'
        };
    };
    var $author$project$Pages$Reports$Custom$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Custom$New$init,
        aeR: $author$project$Pages$Reports$Custom$New$load,
        ag3: $author$project$Pages$Reports$Custom$New$save,
        ahE: $author$project$Pages$Reports$Custom$New$subscriptions,
        aaO: $author$project$Pages$Reports$Custom$New$update,
        aid: $author$project$Pages$Reports$Custom$New$view
    });
    var $author$project$Pages$Reports$Dashboard$ActiveGrowthAttrition = 0;
    var $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$DateRangeInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Utils$Date$toEndOfMonth = function(date) {
        var lastDayOfMonth = A2($author$project$Utils$Date$daysInMonth, $justinmimbs$date$Date$year(date), $justinmimbs$date$Date$month(date));
        return A2($author$project$Utils$Date$changeDay, lastDayOfMonth, date);
    };
    var $author$project$Utils$Date$monthRange = function(referenceDate) {
        return _Utils_Tuple2($author$project$Utils$Date$toBeginningOfMonth(referenceDate), $author$project$Utils$Date$toEndOfMonth(referenceDate));
    };
    var $author$project$Utils$Date$changeMonth = F2(function(month, date) {
        var year = $justinmimbs$date$Date$year(date);
        var day = $justinmimbs$date$Date$day(date);
        return A3($justinmimbs$date$Date$fromCalendarDate, year, month, day);
    });
    var $author$project$Utils$Date$quarterRange = function(referenceDate) {
        var quarter = $justinmimbs$date$Date$quarter(referenceDate);
        return _Utils_Tuple2($author$project$Utils$Date$toBeginningOfMonth(A2($author$project$Utils$Date$changeMonth, A2($elm$core$Maybe$withDefault, 0, $author$project$Utils$Date$monthFromInt(quarter * 3 - 3)), referenceDate)), $author$project$Utils$Date$toEndOfMonth(A2($author$project$Utils$Date$changeMonth, A2($elm$core$Maybe$withDefault, 0, $author$project$Utils$Date$monthFromInt(quarter * 3)), referenceDate)));
    };
    var $author$project$Utils$Date$trailingRange = F2(function(months_, referenceDate) {
        return _Utils_Tuple2($author$project$Utils$Date$toEndOfMonth(A3($justinmimbs$date$Date$add, 1, -(months_ - 1), referenceDate)), $author$project$Utils$Date$toEndOfMonth(referenceDate));
    });
    var $author$project$Pages$Reports$Dashboard$trailingMonthOption = F2(function(currentDate, months) {
        return function(_v0) {
            var start = _v0.a;
            var end = _v0.b;
            return A4($author$project$Components$DateRangeInput$additionalItem, 'trailing_' + $elm$core$String$fromInt(months), 'Trailing ' + ($elm$core$String$fromInt(months) + ' months'), $elm$core$Maybe$Just(start), $elm$core$Maybe$Just(end));
        }(A2($author$project$Utils$Date$trailingRange, months, currentDate));
    });
    var $author$project$Utils$Date$yearRange = function(referenceDate) {
        return _Utils_Tuple2($author$project$Utils$Date$toBeginningOfMonth(A2($author$project$Utils$Date$changeMonth, 0, referenceDate)), $author$project$Utils$Date$toEndOfMonth(A2($author$project$Utils$Date$changeMonth, 11, referenceDate)));
    };
    var $author$project$Utils$Date$yearToDateRange = function(referenceDate) {
        return _Utils_Tuple2(A2($author$project$Utils$Date$changeDay, 1, A2($author$project$Utils$Date$changeMonth, 0, referenceDate)), $author$project$Utils$Date$toEndOfMonth(referenceDate));
    };
    var $author$project$Pages$Reports$Dashboard$additionalMonthOptions = function(currentDate) {
        return _List_fromArray([
            function(_v0) {
                var start = _v0.a;
                var end = _v0.b;
                return A4($author$project$Components$DateRangeInput$additionalItem, 'this_month', 'This Month', $elm$core$Maybe$Just(start), $elm$core$Maybe$Just(end));
            }($author$project$Utils$Date$monthRange(currentDate)),
            A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 3),
            A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 6),
            A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 12),
            function(item) {
                return _Utils_update(item, {
                    aeI: 'Trailing 24 months'
                });
            }(A2($author$project$Pages$Reports$Dashboard$trailingMonthOption, currentDate, 24)),
            function(_v1) {
                var start = _v1.a;
                var end = _v1.b;
                return A4($author$project$Components$DateRangeInput$additionalItem, 'this_quarter', 'This Quarter', $elm$core$Maybe$Just(start), $elm$core$Maybe$Just(end));
            }($author$project$Utils$Date$quarterRange(currentDate)),
            function(_v2) {
                var start = _v2.a;
                var end = _v2.b;
                return A4($author$project$Components$DateRangeInput$additionalItem, 'last_quarter', 'Last Quarter', $elm$core$Maybe$Just(start), $elm$core$Maybe$Just(end));
            }($author$project$Utils$Date$quarterRange(A3($justinmimbs$date$Date$add, 1, -3, currentDate))),
            function(_v3) {
                var start = _v3.a;
                var end = _v3.b;
                return A4($author$project$Components$DateRangeInput$additionalItem, 'ytd', 'YTD', $elm$core$Maybe$Just(start), $elm$core$Maybe$Just(end));
            }($author$project$Utils$Date$yearToDateRange(currentDate)),
            function(_v4) {
                var start = _v4.a;
                var end = _v4.b;
                return A4($author$project$Components$DateRangeInput$additionalItem, 'this_year', 'This Year', $elm$core$Maybe$Just(start), $elm$core$Maybe$Just(end));
            }($author$project$Utils$Date$yearRange(currentDate)),
            function(_v5) {
                var start = _v5.a;
                var end = _v5.b;
                return A4($author$project$Components$DateRangeInput$additionalItem, 'last_year', 'Last Year', $elm$core$Maybe$Just(start), $elm$core$Maybe$Just(end));
            }($author$project$Utils$Date$yearRange(A3($justinmimbs$date$Date$add, 0, -1, currentDate)))
        ]);
    };
    var $author$project$Pages$Reports$Dashboard$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            kW: $author$project$Pages$Reports$Dashboard$additionalMonthOptions,
            ad1: start,
            Go: 1,
            ahV: end
        });
    });
    var $author$project$Pages$Reports$Dashboard$GotIssuedAmount = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$headerFromData = function(stringCurrency) {
        return $author$project$Currency$fromInt(A2($elm$core$Maybe$withDefault, 0, $elm$core$String$toInt(stringCurrency)));
    };
    var $author$project$Pages$Reports$Dashboard$issuedInvoicesParams = function(d) {
        return _Utils_update(d, {
            af_: $author$project$Api$Pagination$empty,
            ahy: $elm$core$Maybe$Just(_List_fromArray([
                'issued'
            ]))
        });
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$CustomerInvoice = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$CustomerInvoice$Record = function(id) {
        return function(invoiceNumber) {
            return function(dueDate) {
                return function(humanStatus) {
                    return function(status) {
                        return function(paymentScheduledOn) {
                            return function(lastSentAt) {
                                return function(paidAt) {
                                    return function(issuedTotalInCents) {
                                        return function(totalInCents) {
                                            return function(creditInCents) {
                                                return function(paidInCents) {
                                                    return function(dueInCents) {
                                                        return function(isPastDue) {
                                                            return function(isPaymentScheduled) {
                                                                return function(isCustomerViewable) {
                                                                    return function(securePdfInlineToken) {
                                                                        return function(owner) {
                                                                            return function(location1) {
                                                                                return {
                                                                                    MD: creditInCents,
                                                                                    Ok: dueDate,
                                                                                    Ol: dueInCents,
                                                                                    QX: humanStatus,
                                                                                    aef: id,
                                                                                    RK: invoiceNumber,
                                                                                    R_: isCustomerViewable,
                                                                                    Sg: isPastDue,
                                                                                    Si: isPaymentScheduled,
                                                                                    SH: issuedTotalInCents,
                                                                                    SY: lastSentAt,
                                                                                    aeT: location1,
                                                                                    VM: owner,
                                                                                    VQ: paidAt,
                                                                                    VR: paidInCents,
                                                                                    Wq: paymentScheduledOn,
                                                                                    ZC: securePdfInlineToken,
                                                                                    ahy: status,
                                                                                    aam: totalInCents
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Reports$Patient$One = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Patient$Patient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Patient$OneRecord = F5(function(id, name, email, phoneNumber, hipaaAuthorizationAccepted) {
        return {
            OH: email,
            QR: hipaaAuthorizationAccepted,
            aef: id,
            zr: name,
            WF: phoneNumber
        };
    });
    var $author$project$Api$Provider$Reports$Patient$oneRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hipaa_authorization_accepted', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phone_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Patient$OneRecord))))));
    var $author$project$Api$Provider$Reports$Patient$oneDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Patient$oneRecordDecoder), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$CustomerInvoice$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Patient$oneDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secure_pdf_inline_token', $author$project$Api$File$Token$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_customer_viewable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_payment_scheduled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_past_due', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credit_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'issued_total_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'paid_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_sent_at', $elm$json$Json$Decode$nullable($elm_community$json_extra$Json$Decode$Extra$datetime), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_scheduled_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'human_status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice_number', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$CustomerInvoice$Record))))))))))))))))))));
    var $author$project$Api$Provider$Reports$CustomerInvoice$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$CustomerInvoice$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$CustomerInvoice$listDefaults = {
        JY: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: A3($author$project$Api$Sort$withDefault, 'date', 0, $author$project$Api$Sort$init),
        HB: $elm$core$Maybe$Nothing,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$CustomerInvoice$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = _Utils_Tuple2(options.HB, options.Fn);
                if (_v0.a.$ === 1 && _v0.b.$ === 1) {
                    var _v1 = _v0.a;
                    var _v2 = _v0.b;
                    return _List_Nil;
                } else {
                    var dates = A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('gte', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery), options.HB)),
                        _Utils_Tuple2('lte', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery), options.Fn))
                    ])));
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'date', dates)
                    ]);
                }
            }(),
            function() {
                var _v3 = options.ahy;
                if (!_v3.$) {
                    var list_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$list, 'status', list_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.JY;
                if (!_v4.$) {
                    var bool = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'owner', A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([
                            _Utils_Tuple2('autopay', $elm$json$Json$Encode$bool(bool))
                        ]))))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.rm;
                if (!_v5.$) {
                    var string = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.aeT;
                if (!_v6.$) {
                    var string = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', string)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'customer_invoices'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$CustomerInvoice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$CustomerInvoice$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$CustomerInvoice$listPath)));
    });
    var $author$project$Api$Data$mapHeader = F3(function(headerName, func, data) {
        switch(data.$){
            case 3:
                var headers = data.b;
                return A2($elm$core$Maybe$withDefault, $author$project$Api$Data$Failure($author$project$Api$Data$Decoder('Header with name ' + (headerName + ' missing'))), A2($elm$core$Maybe$map, function(header) {
                    return A2($author$project$Api$Data$Success, func(header), headers);
                }, A2($elm$core$Dict$get, headerName, headers)));
            case 0:
                return $author$project$Api$Data$NotAsked;
            case 1:
                return $author$project$Api$Data$Loading;
            default:
                var error = data.a;
                return $author$project$Api$Data$Failure(error);
        }
    });
    var $author$project$Pages$Reports$Dashboard$fetchIssued = function(client) {
        return A3($author$project$Api$Provider$Reports$CustomerInvoice$list, client, $author$project$Pages$Reports$Dashboard$issuedInvoicesParams, A2($elm$core$Basics$composeR, A2($author$project$Api$Data$mapHeader, 'x-total-billed-amount', $author$project$Pages$Reports$Dashboard$headerFromData), $author$project$Pages$Reports$Dashboard$GotIssuedAmount));
    };
    var $author$project$Pages$Reports$Dashboard$GotActiveMembersMetric = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$GotEndedMembersMetric = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$GotEnrolledMembersMetric = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Provider$Metric$Metric = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Metric$compareTick = F2(function(_v0, _v1) {
        var date1 = _v0.a;
        var date2 = _v1.a;
        return A2($justinmimbs$date$Date$compare, date1, date2);
    });
    var $author$project$Api$Provider$Metric$monthDecoder = A2($elm$json$Json$Decode$andThen, A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromIsoString, $elm_community$json_extra$Json$Decode$Extra$fromResult), A2($elm$json$Json$Decode$map, function(s) {
        return s + '-01';
    }, $elm$json$Json$Decode$string));
    var $author$project$Api$Provider$Metric$tickDecoder = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, A2($elm$json$Json$Decode$at, _List_fromArray([
        'x'
    ]), $author$project$Api$Provider$Metric$monthDecoder), A2($elm$json$Json$Decode$at, _List_fromArray([
        'y'
    ]), A2($elm$json$Json$Decode$map, $elm$core$Basics$toFloat, $elm$json$Json$Decode$int)));
    var $author$project$Api$Provider$Metric$metricDataDecoder = A3($elm$json$Json$Decode$map2, $elm$core$Tuple$pair, A2($elm$json$Json$Decode$at, _List_fromArray([
        'key'
    ]), $elm$json$Json$Decode$string), A2($elm$json$Json$Decode$map, $elm$core$List$sortWith($author$project$Api$Provider$Metric$compareTick), A2($elm$json$Json$Decode$at, _List_fromArray([
        'values'
    ]), $elm$json$Json$Decode$list($author$project$Api$Provider$Metric$tickDecoder))));
    var $author$project$Api$Provider$Metric$metricsDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A2($elm$json$Json$Decode$at, _List_fromArray([
        'data'
    ]), $elm$json$Json$Decode$list($author$project$Api$Provider$Metric$metricDataDecoder)));
    var $author$project$Api$Provider$Metric$metricsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'metrics'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Metric$defaults = {
        EA: $elm$core$Maybe$Nothing,
        acy: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        Fo: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        GW: $elm$core$Maybe$Nothing,
        agi: $elm$core$Maybe$Nothing,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Metric$optionalsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Metric$defaults);
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $author$project$Api$Param$date('start'), options.HB),
            A2($elm$core$Maybe$map, $author$project$Api$Param$date('end'), options.Fn),
            A2($elm$core$Maybe$map, $author$project$Api$Param$string('practitioner'), options.agi),
            A2($elm$core$Maybe$map, $author$project$Api$Param$string('location'), options.aeT),
            A2($elm$core$Maybe$map, $author$project$Api$Param$string('location_group'), options.rm),
            A2($elm$core$Maybe$map, $author$project$Api$Param$string('company'), options.acy),
            A2($elm$core$Maybe$map, $author$project$Api$Param$string('plan'), options.GW),
            A2($elm$core$Maybe$map, $author$project$Api$Param$string('engagement'), options.Fo),
            A2($elm$core$Maybe$map, $author$project$Api$Param$string('breakout'), options.EA)
        ]));
    };
    var $author$project$Api$Provider$Metric$activeMembers = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Metric$metricsDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Metric$optionalsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'active_members'
        ]), $author$project$Api$Provider$Metric$metricsPath))));
    });
    var $author$project$Pages$Reports$Dashboard$breakoutToValue = function(breakout) {
        switch(breakout){
            case 0:
                return 'plan';
            case 1:
                return 'practitioner';
            case 2:
                return 'location_group';
            case 3:
                return 'location';
            case 4:
                return 'employer';
            case 5:
                return 'employer-retail';
            case 6:
                return 'lead_source';
            default:
                return 'cancellation_reason';
        }
    };
    var $author$project$Pages$Reports$Dashboard$engagementToValue = function(engagement) {
        _v0$3: while(true){
            if (!engagement.$) switch(engagement.a){
                case 1:
                    var _v1 = engagement.a;
                    return $elm$core$Maybe$Just('currently_engaged');
                case 2:
                    var _v2 = engagement.a;
                    return $elm$core$Maybe$Just('previously_engaged');
                case 3:
                    var _v3 = engagement.a;
                    return $elm$core$Maybe$Just('never_engaged');
                default:
                    break _v0$3;
            }
            else break _v0$3;
        }
        return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Metric$totalEnrollments = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Metric$metricsDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Metric$optionalsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'enrolled_members'
        ]), $author$project$Api$Provider$Metric$metricsPath))));
    });
    var $author$project$Api$Provider$Metric$totalTerminations = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Metric$metricsDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Metric$optionalsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'ended_members'
        ]), $author$project$Api$Provider$Metric$metricsPath))));
    });
    var $author$project$Pages$Reports$Dashboard$fetchMetrics = function(_v0) {
        var apiClient = _v0.Ej;
        var today = _v0.aae;
        var start = _v0.HB;
        var end = _v0.Fn;
        var practitionerId = _v0.Xa;
        var locationId = _v0.Tp;
        var locationGroupId = _v0.f0;
        var planId = _v0.agd;
        var companyId = _v0.fl;
        var engagement = _v0.Fo;
        var breakout = _v0.EA;
        var _v1 = _Utils_Tuple2(A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, today, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, today, 0), end));
        var startDate = _v1.a;
        var endDate = _v1.b;
        var optionals = function(d) {
            return _Utils_update(d, {
                EA: A2($elm$core$Maybe$map, $author$project$Pages$Reports$Dashboard$breakoutToValue, breakout),
                acy: companyId,
                Fn: endDate,
                Fo: $author$project$Pages$Reports$Dashboard$engagementToValue(engagement),
                aeT: locationId,
                rm: locationGroupId,
                GW: planId,
                agi: practitionerId,
                HB: startDate
            });
        };
        return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Metric$activeMembers, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotActiveMembersMetric),
            A3($author$project$Api$Provider$Metric$totalEnrollments, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotEnrolledMembersMetric),
            A3($author$project$Api$Provider$Metric$totalTerminations, apiClient, optionals, $author$project$Pages$Reports$Dashboard$GotEndedMembersMetric)
        ]));
    };
    var $author$project$Pages$Reports$Dashboard$GotOutstanding30To59Amount = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses = _List_fromArray([
        'issued',
        'sent',
        'retrying'
    ]);
    var $author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams = function(today) {
        return function(d) {
            return _Utils_update(d, {
                Fn: $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, -30, today)),
                af_: $author$project$Api$Pagination$empty,
                HB: $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, -59, today)),
                ahy: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
            });
        };
    };
    var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom30To59Days = F2(function(client, today) {
        return A3($author$project$Api$Provider$Reports$CustomerInvoice$list, client, $author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams(today), A2($elm$core$Basics$composeR, A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData), $author$project$Pages$Reports$Dashboard$GotOutstanding30To59Amount));
    });
    var $author$project$Pages$Reports$Dashboard$GotOutstanding60PlusAmount = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams = function(today) {
        return function(d) {
            return _Utils_update(d, {
                Fn: $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, -60, today)),
                af_: $author$project$Api$Pagination$empty,
                ahy: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
            });
        };
    };
    var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom60PlusDays = F2(function(client, today) {
        return A3($author$project$Api$Provider$Reports$CustomerInvoice$list, client, $author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams(today), A2($elm$core$Basics$composeR, A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData), $author$project$Pages$Reports$Dashboard$GotOutstanding60PlusAmount));
    });
    var $author$project$Pages$Reports$Dashboard$GotOutstandingLt30Amount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams = function(today) {
        return function(d) {
            return _Utils_update(d, {
                Fn: $elm$core$Maybe$Just(today),
                af_: $author$project$Api$Pagination$empty,
                HB: $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, -29, today)),
                ahy: $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$outstandingInvoicesStatuses)
            });
        };
    };
    var $author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFromLessThan30Days = F2(function(client, today) {
        return A3($author$project$Api$Provider$Reports$CustomerInvoice$list, client, $author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams(today), A2($elm$core$Basics$composeR, A2($author$project$Api$Data$mapHeader, 'x-total-receivable-amount', $author$project$Pages$Reports$Dashboard$headerFromData), $author$project$Pages$Reports$Dashboard$GotOutstandingLt30Amount));
    });
    var $author$project$Pages$Reports$Dashboard$initMetrics = {
        pm: $author$project$Api$Data$Loading,
        qz: $author$project$Api$Data$Loading,
        qA: $author$project$Api$Data$Loading
    };
    var $author$project$Pages$Reports$Dashboard$AllEngagements = 0;
    var $author$project$Pages$Reports$Dashboard$CurrentlyEngaged = 1;
    var $author$project$Pages$Reports$Dashboard$NeverEngaged = 3;
    var $author$project$Pages$Reports$Dashboard$PreviouslyEngaged = 2;
    var $author$project$Pages$Reports$Dashboard$valueToEngagement = function(stringEngagement) {
        switch(stringEngagement){
            case 'all':
                return $elm$core$Maybe$Just(0);
            case 'currently_engaged':
                return $elm$core$Maybe$Just(1);
            case 'previously_engaged':
                return $elm$core$Maybe$Just(2);
            case 'never_engaged':
                return $elm$core$Maybe$Just(3);
            default:
                return $elm$core$Maybe$Just(0);
        }
    };
    var $author$project$Pages$Reports$Dashboard$init = F4(function(session, practice, _v0, _v1) {
        var apiClient = _v0.Ej;
        var currentDate = _v0.cP;
        var query = _v1.Bz;
        var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
        var planId = A2($elm$core$Dict$get, 'plan', query);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var engagement = $author$project$Pages$Reports$Dashboard$valueToEngagement(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Dict$get, 'engagement', query)));
        var companyId = A2($elm$core$Dict$get, 'company', query);
        var _v2 = A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId);
        var planResourceFilter = _v2.a;
        var planResourceFilterCmd = _v2.b;
        var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v3.a;
        var groupLocationAndPractitionerFiltersCmd = _v3.b;
        var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v4.a;
        var end = _v4.b;
        var _v5 = _Utils_Tuple2(A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end));
        var startDate = _v5.a;
        var endDate = _v5.b;
        var _v6 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Pages$Reports$Dashboard$dateRangeInputSettings, startDate, endDate));
        var dateRangeInput = _v6.a;
        var dateRangeInputCmd = _v6.b;
        var _v7 = A4($author$project$Utils$Report$CompanyResourceFilter$init, apiClient, $elm$core$Basics$identity, $author$project$Api$Practice$Provider(practice), companyId);
        var companyResourceFilter = _v7.a;
        var companyResourceFilterCmd = _v7.b;
        var model = {
            Ej: apiClient,
            EA: $elm$core$Maybe$Nothing,
            fl: companyId,
            pY: companyResourceFilter,
            h6: dateRangeInput,
            Fn: end,
            Fo: engagement,
            b8: groupLocationAndPractitionerFilters,
            yv: $author$project$Api$Data$Loading,
            f0: locationGroupId,
            Tp: locationId,
            ac: $author$project$Pages$Reports$Dashboard$initMetrics,
            Ad: $author$project$Api$Data$Loading,
            Ae: $author$project$Api$Data$Loading,
            Af: $author$project$Api$Data$Loading,
            r3: $elm$core$Maybe$Nothing,
            agd: planId,
            jy: planResourceFilter,
            W1: practice,
            Xa: practitionerId,
            Z$: session,
            sX: 0,
            HB: start,
            aae: currentDate
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFromLessThan30Days, apiClient, currentDate),
            A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom30To59Days, apiClient, currentDate),
            A2($author$project$Pages$Reports$Dashboard$fetchOutstandingInvoicesFrom60PlusDays, apiClient, currentDate),
            $author$project$Pages$Reports$Dashboard$fetchIssued(apiClient),
            $author$project$Pages$Reports$Dashboard$fetchMetrics(model),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg, planResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg, companyResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$Reports$Dashboard$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Dashboard$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$Dashboard$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Reports$Dashboard$Metrics = F3(function(activeMembers, enrolledMembers, endedMembers) {
        return {
            pm: activeMembers,
            qz: endedMembers,
            qA: enrolledMembers
        };
    });
    var $author$project$Api$Provider$Metric$datesRange = function(_v0) {
        var data = _v0;
        return _Utils_Tuple2(A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, $elm$core$List$head, A2($elm$core$Maybe$map, $elm$core$Tuple$second, $elm$core$List$head(data)))), A2($elm$core$Maybe$map, $elm$core$Tuple$first, A2($elm$core$Maybe$andThen, $elm$core$List$head, A2($elm$core$Maybe$map, $elm$core$List$reverse, A2($elm$core$Maybe$map, $elm$core$Tuple$second, $elm$core$List$head(data))))));
    };
    var $author$project$Api$Provider$Metric$filter = F2(function(filterFunc, _v0) {
        var metricData = _v0;
        return A2($elm$core$List$map, function(_v1) {
            var key = _v1.a;
            var data = _v1.b;
            return _Utils_Tuple2(key, A2($elm$core$List$filter, filterFunc, data));
        }, metricData);
    });
    var $author$project$Api$Provider$Metric$filterByMonth = F2(function(month, metric) {
        return A2($author$project$Api$Provider$Metric$filter, function(_v0) {
            var date = _v0.a;
            return _Utils_eq(date, month);
        }, metric);
    });
    var $author$project$Api$Provider$Metric$values = function(_v0) {
        var data = _v0;
        return A2($elm$core$List$map, function(_v1) {
            var ticks = _v1.b;
            return A2($elm$core$List$map, $elm$core$Tuple$second, ticks);
        }, data);
    };
    var $author$project$Api$Provider$Metric$total = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Metric$values, A2($elm$core$Basics$composeR, $elm$core$List$map($elm$core$List$sum), $elm$core$List$sum));
    var $author$project$Pages$Reports$Dashboard$buildPeriodSummary = F4(function(today, active, ended, enrolled) {
        var _v0 = A2($elm$core$Tuple$mapSecond, $elm$core$Maybe$withDefault($author$project$Utils$Date$toEndOfMonth(today)), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$withDefault($author$project$Utils$Date$toBeginningOfMonth(today)), $author$project$Api$Provider$Metric$datesRange(active)));
        var firstMonth = _v0.a;
        var lastMonth = _v0.b;
        var activeDuringFirstMonth = $elm$core$Basics$round($author$project$Api$Provider$Metric$total(A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, active)));
        var endedDuringFirstMonth = $elm$core$Basics$round($author$project$Api$Provider$Metric$total(A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, ended)));
        var enrolledDuringFirstMonth = $elm$core$Basics$round($author$project$Api$Provider$Metric$total(A2($author$project$Api$Provider$Metric$filterByMonth, firstMonth, enrolled)));
        var activeDuringLastMonth = $elm$core$Basics$round($author$project$Api$Provider$Metric$total(A2($author$project$Api$Provider$Metric$filterByMonth, lastMonth, active)));
        return {
            tN: activeDuringLastMonth,
            tO: activeDuringFirstMonth - enrolledDuringFirstMonth + endedDuringFirstMonth,
            Fp: $elm$core$Basics$round($author$project$Api$Provider$Metric$total(enrolled)),
            HL: $elm$core$Basics$round($author$project$Api$Provider$Metric$total(ended))
        };
    });
    var $author$project$Pages$Reports$Dashboard$andBuildSummary = function(original) {
        var model = original.a;
        var metrics = model.ac;
        var cmds = original.b;
        var outMsgs = original.c;
        var _v0 = _Utils_Tuple3(metrics.pm, metrics.qz, metrics.qA);
        if (_v0.a.$ === 3 && _v0.b.$ === 3 && _v0.c.$ === 3) {
            var _v1 = _v0.a;
            var active = _v1.a;
            var _v2 = _v0.b;
            var ended = _v2.a;
            var _v3 = _v0.c;
            var enrolled = _v3.a;
            return _Utils_Tuple3(_Utils_update(model, {
                r3: $elm$core$Maybe$Just(A4($author$project$Pages$Reports$Dashboard$buildPeriodSummary, model.aae, active, ended, enrolled))
            }), cmds, outMsgs);
        } else return original;
    };
    var $author$project$Pages$Reports$Dashboard$isForbidden = function(data) {
        if (data.$ === 2 && data.a.$ === 6 && data.a.a === 403) {
            var _v1 = data.a;
            return true;
        } else return false;
    };
    var $author$project$Pages$Reports$Dashboard$andHandleAmountResponse = F2(function(amount, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$Pages$Reports$Dashboard$isForbidden(amount) ? _List_Nil : $author$project$OutMsg$handleErrorResponse(amount));
    });
    var $author$project$Pages$Reports$Dashboard$activeColor = 'rgba(103, 173, 226, 0.45)';
    var $author$project$Ports$DashboardChart$YAxis$Left = 1;
    var $author$project$Ports$DashboardChart$YAxis$YAxis = $elm$core$Basics$identity;
    var $author$project$Ports$DashboardChart$YAxis$axis = function(attributes) {
        return A3($elm$core$List$foldl, F2(function(attribute, record) {
            switch(attribute.$){
                case 0:
                    var id_ = attribute.a;
                    return _Utils_update(record, {
                        aef: id_
                    });
                case 1:
                    var position = attribute.a;
                    return _Utils_update(record, {
                        WX: position
                    });
                case 2:
                    var label_ = attribute.a;
                    return _Utils_update(record, {
                        aeI: $elm$core$Maybe$Just(label_)
                    });
                case 3:
                    var suffix = attribute.a;
                    return _Utils_update(record, {
                        DG: $elm$core$Maybe$Just(suffix)
                    });
                default:
                    var stacked_ = attribute.a;
                    return _Utils_update(record, {
                        CG: stacked_
                    });
            }
        }), {
            Et: true,
            aef: '',
            aeI: $elm$core$Maybe$Nothing,
            WX: 1,
            CG: false,
            DG: $elm$core$Maybe$Nothing
        }, attributes);
    };
    var $author$project$Ports$DashboardChart$Chart = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ports$DashboardChart$chartAttributesToRecord = function(attributes) {
        return A3($elm$core$List$foldl, F2(function(attr, record) {
            if (!attr.$) {
                var labels_ = attr.a;
                return _Utils_update(record, {
                    yB: labels_
                });
            } else {
                var axis = attr.a;
                return _Utils_update(record, {
                    tJ: _Utils_ap(record.tJ, _List_fromArray([
                        axis
                    ]))
                });
            }
        }), {
            yB: _List_Nil,
            tJ: _List_Nil
        }, attributes);
    };
    var $author$project$Ports$DashboardChart$chart = F2(function(attributes, datasets) {
        return A2($author$project$Ports$DashboardChart$Chart, $author$project$Ports$DashboardChart$chartAttributesToRecord(attributes), datasets);
    });
    var $author$project$Ports$DashboardChart$DataSet$Color = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$DataSet$ColorConfig = F4(function(backgroundColor, borderColor, pointBackgroundColor, pointBorderColor) {
        return {
            J4: backgroundColor,
            Ko: borderColor,
            WT: pointBackgroundColor,
            WU: pointBorderColor
        };
    });
    var $author$project$Ports$DashboardChart$DataSet$color = function(rgbaString) {
        return $author$project$Ports$DashboardChart$DataSet$Color($elm$core$Maybe$Just(A4($author$project$Ports$DashboardChart$DataSet$ColorConfig, rgbaString, rgbaString, rgbaString, rgbaString)));
    };
    var $author$project$Ports$DashboardChart$DataSet$colorAuto = $author$project$Ports$DashboardChart$DataSet$Color($elm$core$Maybe$Nothing);
    var $author$project$Api$Provider$Metric$months = function(_v0) {
        var data = _v0;
        return A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $elm$core$List$map($elm$core$Tuple$first), A2($elm$core$Maybe$map, $elm$core$Tuple$second, $elm$core$List$head(data))));
    };
    var $author$project$Api$Provider$Metric$combine = F2(function(key, metric) {
        var months_ = $author$project$Api$Provider$Metric$months(metric);
        return $elm$core$List$singleton(A2($elm$core$Tuple$pair, key, A3($elm$core$List$map2, F2(function(date, ticks) {
            return _Utils_Tuple2(date, ticks);
        }), months_, A3($elm$core$List$foldl, $elm$core$List$map2(F2(function(y, accY) {
            return y + accY;
        })), A2($elm$core$List$repeat, $elm$core$List$length(months_), 0), $author$project$Api$Provider$Metric$values(metric)))));
    });
    var $author$project$Ports$DashboardChart$DataSet$Bar = 1;
    var $author$project$Ports$DashboardChart$DataSet$DataSet = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ports$DashboardChart$DataSet$dataset = F2(function(attributes, data) {
        return A2($author$project$Ports$DashboardChart$DataSet$DataSet, data, A3($elm$core$List$foldl, F2(function(attribute, record) {
            switch(attribute.$){
                case 0:
                    var axisId = attribute.a;
                    return _Utils_update(record, {
                        vJ: $elm$core$Maybe$Just(axisId)
                    });
                case 2:
                    var type_ = attribute.a;
                    return _Utils_update(record, {
                        ah5: type_
                    });
                case 1:
                    var string = attribute.a;
                    return _Utils_update(record, {
                        aeI: $elm$core$Maybe$Just(string)
                    });
                case 3:
                    var maybeColorConfig = attribute.a;
                    return _Utils_update(record, {
                        hP: maybeColorConfig
                    });
                default:
                    var suffix_ = attribute.a;
                    return _Utils_update(record, {
                        $w: $elm$core$Maybe$Just(suffix_)
                    });
            }
        }), {
            vJ: $elm$core$Maybe$Nothing,
            hP: $elm$core$Maybe$Nothing,
            aeI: $elm$core$Maybe$Nothing,
            $w: $elm$core$Maybe$Nothing,
            ah5: 1
        }, attributes));
    });
    var $author$project$Pages$Reports$Dashboard$enrollmentsColor = 'rgba(75, 192, 192, 1)';
    var $author$project$Api$Provider$Metric$fromList = F2(function(key, tick) {
        return $elm$core$List$singleton(_Utils_Tuple2(key, tick));
    });
    var $author$project$Pages$Reports$Dashboard$growthAndAttritionMetric = F3(function(active, ended, enrolled) {
        var months = $author$project$Api$Provider$Metric$months(active);
        return A3($elm$core$Tuple$mapBoth, $author$project$Api$Provider$Metric$fromList('growth'), $author$project$Api$Provider$Metric$fromList('attrition'), A3($elm$core$List$foldl, F2(function(month, _v0) {
            var growth = _v0.a;
            var attrition = _v0.b;
            var terminations = $author$project$Api$Provider$Metric$total(A2($author$project$Api$Provider$Metric$filterByMonth, month, ended));
            var enrollments = $author$project$Api$Provider$Metric$total(A2($author$project$Api$Provider$Metric$filterByMonth, month, enrolled));
            var activeAtEnd = $author$project$Api$Provider$Metric$total(A2($author$project$Api$Provider$Metric$filterByMonth, month, active));
            var activeAtBeginning = activeAtEnd - enrollments + terminations;
            return _Utils_Tuple2(_Utils_ap(growth, _List_fromArray([
                _Utils_Tuple2(month, !activeAtBeginning ? 0 : A2($myrho$elm_round$Round$roundNum, 2, enrollments * 100 / activeAtBeginning))
            ])), _Utils_ap(attrition, _List_fromArray([
                _Utils_Tuple2(month, !activeAtBeginning ? 0 : A2($myrho$elm_round$Round$roundNum, 2, terminations * 100 / activeAtBeginning))
            ])));
        }), _Utils_Tuple2(_List_Nil, _List_Nil), months));
    });
    var $author$project$Ports$DashboardChart$YAxis$Id = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$YAxis$id = $author$project$Ports$DashboardChart$YAxis$Id;
    var $author$project$Ports$DashboardChart$DataSet$Label = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$DataSet$label = $author$project$Ports$DashboardChart$DataSet$Label;
    var $author$project$Ports$DashboardChart$YAxis$Label = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$YAxis$label = $author$project$Ports$DashboardChart$YAxis$Label;
    var $author$project$Ports$DashboardChart$XLabels = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$labels = $author$project$Ports$DashboardChart$XLabels;
    var $author$project$Ports$DashboardChart$YAxis$Position = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$YAxis$left = $author$project$Ports$DashboardChart$YAxis$Position(1);
    var $author$project$Ports$DashboardChart$DataSet$ChartType = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$DataSet$Line = 0;
    var $author$project$Ports$DashboardChart$DataSet$line = $author$project$Ports$DashboardChart$DataSet$ChartType(0);
    var $author$project$Api$Provider$Metric$map = F2(function(func, _v0) {
        var data = _v0;
        return A2($elm$core$List$map, function(_v1) {
            var key = _v1.a;
            var ticks = _v1.b;
            return func(_Utils_Tuple2(key, A2($elm$core$List$map, $elm$core$Tuple$second, ticks)));
        }, data);
    });
    var $author$project$Ports$DashboardChart$DataSet$encode = function(_v0) {
        var data = _v0.a;
        var record = _v0.b;
        return $elm$json$Json$Encode$object(A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $elm$core$Maybe$Just(_Utils_Tuple2('data', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$float, data))),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('label'), A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.aeI)),
            $elm$core$Maybe$Just(_Utils_Tuple2('type', $elm$json$Json$Encode$string(function() {
                var _v1 = record.ah5;
                if (_v1 === 1) return 'bar';
                else return 'line';
            }()))),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('yAxisID'), A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.vJ)),
            $elm$core$Maybe$Just(_Utils_Tuple2('fill', $elm$json$Json$Encode$bool(function() {
                var _v2 = record.ah5;
                if (_v2 === 1) return true;
                else return false;
            }()))),
            $elm$core$Maybe$Just(_Utils_Tuple2('tension', $elm$json$Json$Encode$float(0.4))),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('backgroundColor'), A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, A2($elm$core$Maybe$map, function($) {
                return $.J4;
            }, record.hP))),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('borderColor'), A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, A2($elm$core$Maybe$map, function($) {
                return $.Ko;
            }, record.hP))),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('pointBackgroundColor'), A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, A2($elm$core$Maybe$map, function($) {
                return $.WT;
            }, record.hP))),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('pointBorderColor'), A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, A2($elm$core$Maybe$map, function($) {
                return $.WU;
            }, record.hP))),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('suffix'), A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.$w))
        ])));
    };
    var $author$project$Ports$DashboardChart$YAxis$encode = function(_v0) {
        var record = _v0;
        return _Utils_Tuple2(record.aef, $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string(record.aef)),
            _Utils_Tuple2('axis', $elm$json$Json$Encode$string('y')),
            _Utils_Tuple2('display', $elm$json$Json$Encode$bool(true)),
            _Utils_Tuple2('stacked', $elm$json$Json$Encode$bool(record.CG)),
            _Utils_Tuple2('position', $elm$json$Json$Encode$string(function() {
                var _v1 = record.WX;
                if (!_v1) return 'right';
                else return 'left';
            }())),
            _Utils_Tuple2('type', $elm$json$Json$Encode$string('linear')),
            _Utils_Tuple2('beginAtZero', $elm$json$Json$Encode$bool(record.Et)),
            _Utils_Tuple2('suggestedMax', $elm$json$Json$Encode$int(20)),
            _Utils_Tuple2('ticks', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('suffix', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.DG)))
            ]))),
            _Utils_Tuple2('title', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('display', $elm$json$Json$Encode$bool(true)),
                _Utils_Tuple2('text', A2($elm$core$Maybe$withDefault, $elm$json$Json$Encode$null, A2($elm$core$Maybe$map, $elm$json$Json$Encode$string, record.aeI))),
                _Utils_Tuple2('fontSize', $elm$json$Json$Encode$int(16))
            ])))
        ])));
    };
    var $author$project$Ports$DashboardChart$DataSet$isEmpty = function(_v0) {
        var data = _v0.a;
        return A2($elm$core$List$all, function(val) {
            return !val;
        }, data);
    };
    var $author$project$Ports$DashboardChart$encode = function(_v0) {
        var record = _v0.a;
        var datasets = _v0.b;
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('datasets', A2($elm$json$Json$Encode$list, $author$project$Ports$DashboardChart$DataSet$encode, A2($elm$core$List$all, $author$project$Ports$DashboardChart$DataSet$isEmpty, datasets) ? _List_Nil : datasets)),
            _Utils_Tuple2('labels', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, record.yB)),
            _Utils_Tuple2('options', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('plugins', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('tooltip', $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('mode', $elm$json$Json$Encode$string('index'))
                    ])))
                ]))),
                _Utils_Tuple2('scales', $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('x', $elm$json$Json$Encode$object(_List_fromArray([
                    _Utils_Tuple2('axis', $elm$json$Json$Encode$string('x')),
                    _Utils_Tuple2('id', $elm$json$Json$Encode$string('x')),
                    _Utils_Tuple2('stacked', $elm$json$Json$Encode$bool(true))
                ]))), A2($elm$core$List$map, $author$project$Ports$DashboardChart$YAxis$encode, record.tJ))))
            ])))
        ]));
    };
    var $author$project$Ports$DashboardChart$mountDashboardChart = _Platform_outgoingPort('mountDashboardChart', $elm$core$Basics$identity);
    var $author$project$Ports$DashboardChart$mount = A2($elm$core$Basics$composeR, $author$project$Ports$DashboardChart$encode, $author$project$Ports$DashboardChart$mountDashboardChart);
    var $author$project$Ports$DashboardChart$YAxis$Right = 0;
    var $author$project$Ports$DashboardChart$YAxis$right = $author$project$Ports$DashboardChart$YAxis$Position(0);
    var $author$project$Ports$DashboardChart$YAxis$Stacked = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$YAxis$stacked = $author$project$Ports$DashboardChart$YAxis$Stacked(true);
    var $author$project$Ports$DashboardChart$DataSet$Suffix = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$DataSet$suffix = $author$project$Ports$DashboardChart$DataSet$Suffix;
    var $author$project$Pages$Reports$Dashboard$terminationsColor = 'rgba(255, 99, 132, 1)';
    var $author$project$Ports$DashboardChart$YAxis$TickSuffix = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$YAxis$tickSuffix = $author$project$Ports$DashboardChart$YAxis$TickSuffix;
    var $author$project$Ports$DashboardChart$YAxis = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$yAxis = $author$project$Ports$DashboardChart$YAxis;
    var $author$project$Ports$DashboardChart$DataSet$YAxisId = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ports$DashboardChart$DataSet$yAxis = $author$project$Ports$DashboardChart$DataSet$YAxisId;
    var $author$project$Pages$Reports$Dashboard$andRenderChart = function(original) {
        var model = original.a;
        var metrics = model.ac;
        var showing = model.sX;
        var breakout = model.EA;
        var cmds = original.b;
        var outMsgs = original.c;
        var _v0 = _Utils_Tuple3(metrics.pm, metrics.qz, metrics.qA);
        if (_v0.a.$ === 3 && _v0.b.$ === 3 && _v0.c.$ === 3) {
            var _v1 = _v0.a;
            var active = _v1.a;
            var _v2 = _v0.b;
            var ended = _v2.a;
            var _v3 = _v0.c;
            var enrolled = _v3.a;
            var monthsLabels = A2($elm$core$List$map, function(date) {
                return A2($justinmimbs$date$Date$format, 'MMM yyyy', date);
            }, $author$project$Api$Provider$Metric$months(active));
            var ifBrokenOut = F2(function(_this, _default) {
                return A2($elm$core$Maybe$withDefault, _default, A2($elm$core$Maybe$map, $elm$core$Basics$always(_this), breakout));
            });
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmds,
                function() {
                    switch(showing){
                        case 0:
                            return $author$project$Ports$DashboardChart$mount(A2($author$project$Ports$DashboardChart$chart, _List_fromArray([
                                $author$project$Ports$DashboardChart$labels(monthsLabels),
                                $author$project$Ports$DashboardChart$yAxis($author$project$Ports$DashboardChart$YAxis$axis(_List_fromArray([
                                    $author$project$Ports$DashboardChart$YAxis$id('y-1'),
                                    $author$project$Ports$DashboardChart$YAxis$left,
                                    $author$project$Ports$DashboardChart$YAxis$label('Active Members'),
                                    $author$project$Ports$DashboardChart$YAxis$stacked
                                ]))),
                                $author$project$Ports$DashboardChart$yAxis($author$project$Ports$DashboardChart$YAxis$axis(_List_fromArray([
                                    $author$project$Ports$DashboardChart$YAxis$id('y-2'),
                                    $author$project$Ports$DashboardChart$YAxis$right,
                                    $author$project$Ports$DashboardChart$YAxis$label('Growth / Attrition'),
                                    $author$project$Ports$DashboardChart$YAxis$tickSuffix('%')
                                ])))
                            ]), $elm$core$List$concat(function(_v5) {
                                var growth = _v5.a;
                                var attrition = _v5.b;
                                return _List_fromArray([
                                    A2($author$project$Api$Provider$Metric$map, function(_v6) {
                                        var key = _v6.a;
                                        var values = _v6.b;
                                        return A2($author$project$Ports$DashboardChart$DataSet$dataset, _List_fromArray([
                                            $author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor),
                                            $author$project$Ports$DashboardChart$DataSet$yAxis('y-1'),
                                            $author$project$Ports$DashboardChart$DataSet$label(A2(ifBrokenOut, key, 'Active')),
                                            A2(ifBrokenOut, $author$project$Ports$DashboardChart$DataSet$colorAuto, $author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor))
                                        ]), values);
                                    }, active),
                                    A2($author$project$Api$Provider$Metric$map, function(_v7) {
                                        var key = _v7.a;
                                        var values = _v7.b;
                                        return A2($author$project$Ports$DashboardChart$DataSet$dataset, _List_fromArray([
                                            $author$project$Ports$DashboardChart$DataSet$yAxis('y-2'),
                                            $author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$enrollmentsColor),
                                            $author$project$Ports$DashboardChart$DataSet$line,
                                            $author$project$Ports$DashboardChart$DataSet$label(key),
                                            $author$project$Ports$DashboardChart$DataSet$suffix('%')
                                        ]), values);
                                    }, A2($author$project$Api$Provider$Metric$combine, 'Enrollments', growth)),
                                    A2($author$project$Api$Provider$Metric$map, function(_v8) {
                                        var key = _v8.a;
                                        var values = _v8.b;
                                        return A2($author$project$Ports$DashboardChart$DataSet$dataset, _List_fromArray([
                                            $author$project$Ports$DashboardChart$DataSet$yAxis('y-2'),
                                            $author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$terminationsColor),
                                            $author$project$Ports$DashboardChart$DataSet$line,
                                            $author$project$Ports$DashboardChart$DataSet$label(key),
                                            $author$project$Ports$DashboardChart$DataSet$suffix('%')
                                        ]), values);
                                    }, A2($author$project$Api$Provider$Metric$combine, 'Terminations', attrition))
                                ]);
                            }(A3($author$project$Pages$Reports$Dashboard$growthAndAttritionMetric, active, ended, enrolled)))));
                        case 1:
                            return $author$project$Ports$DashboardChart$mount(A2($author$project$Ports$DashboardChart$chart, _List_fromArray([
                                $author$project$Ports$DashboardChart$labels(monthsLabels),
                                $author$project$Ports$DashboardChart$yAxis($author$project$Ports$DashboardChart$YAxis$axis(_List_fromArray([
                                    $author$project$Ports$DashboardChart$YAxis$id('y-1'),
                                    $author$project$Ports$DashboardChart$YAxis$left,
                                    $author$project$Ports$DashboardChart$YAxis$label('Active Members'),
                                    $author$project$Ports$DashboardChart$YAxis$stacked
                                ])))
                            ]), A2($author$project$Api$Provider$Metric$map, function(_v9) {
                                var key = _v9.a;
                                var values = _v9.b;
                                return A2($author$project$Ports$DashboardChart$DataSet$dataset, _List_fromArray([
                                    $author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor),
                                    $author$project$Ports$DashboardChart$DataSet$label(A2(ifBrokenOut, key, 'Active')),
                                    A2(ifBrokenOut, $author$project$Ports$DashboardChart$DataSet$colorAuto, $author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$activeColor))
                                ]), values);
                            }, active)));
                        case 2:
                            return $author$project$Ports$DashboardChart$mount(A2($author$project$Ports$DashboardChart$chart, _List_fromArray([
                                $author$project$Ports$DashboardChart$labels(monthsLabels),
                                $author$project$Ports$DashboardChart$yAxis($author$project$Ports$DashboardChart$YAxis$axis(_List_fromArray([
                                    $author$project$Ports$DashboardChart$YAxis$id('y-1'),
                                    $author$project$Ports$DashboardChart$YAxis$left,
                                    $author$project$Ports$DashboardChart$YAxis$label('Terminations'),
                                    $author$project$Ports$DashboardChart$YAxis$stacked
                                ])))
                            ]), A2($author$project$Api$Provider$Metric$map, function(_v10) {
                                var key = _v10.a;
                                var values = _v10.b;
                                return A2($author$project$Ports$DashboardChart$DataSet$dataset, _List_fromArray([
                                    A2(ifBrokenOut, $author$project$Ports$DashboardChart$DataSet$colorAuto, $author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$terminationsColor)),
                                    $author$project$Ports$DashboardChart$DataSet$label(A2(ifBrokenOut, key, 'Terminations'))
                                ]), values);
                            }, ended)));
                        default:
                            return $author$project$Ports$DashboardChart$mount(A2($author$project$Ports$DashboardChart$chart, _List_fromArray([
                                $author$project$Ports$DashboardChart$labels(monthsLabels),
                                $author$project$Ports$DashboardChart$yAxis($author$project$Ports$DashboardChart$YAxis$axis(_List_fromArray([
                                    $author$project$Ports$DashboardChart$YAxis$id('y-1'),
                                    $author$project$Ports$DashboardChart$YAxis$left,
                                    $author$project$Ports$DashboardChart$YAxis$label('Enrollments'),
                                    $author$project$Ports$DashboardChart$YAxis$stacked
                                ])))
                            ]), A2($author$project$Api$Provider$Metric$map, function(_v11) {
                                var key = _v11.a;
                                var values = _v11.b;
                                return A2($author$project$Ports$DashboardChart$DataSet$dataset, _List_fromArray([
                                    $author$project$Ports$DashboardChart$DataSet$label(A2(ifBrokenOut, key, 'Enrollments')),
                                    A2(ifBrokenOut, $author$project$Ports$DashboardChart$DataSet$colorAuto, $author$project$Ports$DashboardChart$DataSet$color($author$project$Pages$Reports$Dashboard$enrollmentsColor))
                                ]), values);
                            }, enrolled)));
                    }
                }()
            ])), outMsgs);
        } else return original;
    };
    var $author$project$Pages$Reports$Dashboard$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.aae, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.aae, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('location'), model.Tp),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('practitioner'), model.Xa),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('plan'), model.agd),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('engagement'), $author$project$Pages$Reports$Dashboard$engagementToValue(model.Fo)),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('company'), model.fl)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Dashboard)
        ]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    };
    var $author$project$Pages$Reports$Dashboard$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var amount = msg.a;
                return A2($author$project$Pages$Reports$Dashboard$andHandleAmountResponse, amount, _Utils_update(model, {
                    Af: amount
                }));
            case 1:
                var amount = msg.a;
                return A2($author$project$Pages$Reports$Dashboard$andHandleAmountResponse, amount, _Utils_update(model, {
                    Ad: amount
                }));
            case 2:
                var amount = msg.a;
                return A2($author$project$Pages$Reports$Dashboard$andHandleAmountResponse, amount, _Utils_update(model, {
                    Ae: amount
                }));
            case 3:
                var amount = msg.a;
                return A2($author$project$Pages$Reports$Dashboard$andHandleAmountResponse, amount, _Utils_update(model, {
                    yv: amount
                }));
            case 5:
                var metric = msg.a;
                return function(metrics) {
                    return $author$project$Pages$Reports$Dashboard$andRenderChart($author$project$Pages$Reports$Dashboard$andBuildSummary(_Utils_Tuple3(_Utils_update(model, {
                        ac: metrics
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(metric))));
                }(function(metrics) {
                    return _Utils_update(metrics, {
                        pm: metric
                    });
                }(model.ac));
            case 6:
                var metric = msg.a;
                return function(metrics) {
                    return $author$project$Pages$Reports$Dashboard$andRenderChart($author$project$Pages$Reports$Dashboard$andBuildSummary(_Utils_Tuple3(_Utils_update(model, {
                        ac: metrics
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(metric))));
                }(function(metrics) {
                    return _Utils_update(metrics, {
                        qA: metric
                    });
                }(model.ac));
            case 7:
                var metric = msg.a;
                return function(metrics) {
                    return $author$project$Pages$Reports$Dashboard$andRenderChart($author$project$Pages$Reports$Dashboard$andBuildSummary(_Utils_Tuple3(_Utils_update(model, {
                        ac: metrics
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(metric))));
                }(function(metrics) {
                    return _Utils_update(metrics, {
                        qz: metric
                    });
                }(model.ac));
            case 8:
                var showing = msg.a;
                return $author$project$Pages$Reports$Dashboard$andRenderChart(_Utils_Tuple3(_Utils_update(model, {
                    sX: showing
                }), $elm$core$Platform$Cmd$none, _List_Nil));
            case 9:
                var breakout = msg.a;
                return function(newModel) {
                    return _Utils_Tuple3(newModel, $author$project$Pages$Reports$Dashboard$fetchMetrics(newModel), _List_Nil);
                }(_Utils_update(model, {
                    EA: breakout,
                    ac: $author$project$Pages$Reports$Dashboard$initMetrics
                }));
            case 10:
                var engagement = msg.a;
                return function(newModel) {
                    return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
                        $author$project$Pages$Reports$Dashboard$updateUrl(newModel)
                    ])), _List_Nil);
                }(_Utils_update(model, {
                    Fo: engagement,
                    ac: $author$project$Pages$Reports$Dashboard$initMetrics
                }));
            case 4:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v1.a;
                var subCmd = _v1.b;
                var event = _v1.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            ac: A3($author$project$Pages$Reports$Dashboard$Metrics, $author$project$Api$Data$Loading, $author$project$Api$Data$Loading, $author$project$Api$Data$Loading),
                            r3: $elm$core$Maybe$Nothing,
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$DateRangeInputMsg, subCmd),
                    _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? $elm$core$Platform$Cmd$none : $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Pages$Reports$Dashboard$updateUrl(newModel),
                        $author$project$Pages$Reports$Dashboard$fetchMetrics(newModel)
                    ]))
                ])), _List_Nil);
            case 11:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, model.Ej, subMsg, model.b8);
                var _v3 = result.adu;
                switch(_v3.$){
                    case 0:
                        var locationGroupId = _v3.a;
                        var locationId = _v3.b;
                        var practitionerId = _v3.c;
                        var newModel = _Utils_update(model, {
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            ac: $author$project$Pages$Reports$Dashboard$initMetrics,
                            Xa: practitionerId
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            $author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
                            $author$project$Pages$Reports$Dashboard$updateUrl(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 13:
                var subMsg = msg.a;
                return function(original) {
                    var newModel = original.a;
                    var cmd = original.b;
                    var outMsgs = original.c;
                    return !_Utils_eq(newModel.fl, model.fl) ? _Utils_Tuple3(_Utils_update(newModel, {
                        ac: $author$project$Pages$Reports$Dashboard$initMetrics
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        $author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
                        $author$project$Pages$Reports$Dashboard$updateUrl(newModel)
                    ])), outMsgs) : original;
                }(function(result) {
                    return _Utils_Tuple3(_Utils_update(model, {
                        fl: function() {
                            var _v4 = result.adu;
                            if (!_v4.$) {
                                if (!_v4.a.$) return $author$project$Components$ResourceFilter$Company$value(result.zi);
                                else {
                                    var _v5 = _v4.a;
                                    return model.fl;
                                }
                            } else return model.fl;
                        }(),
                        pY: result.zi
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg, result.EQ), result.at);
                }(A3($author$project$Components$ResourceFilter$Company$update, model.Ej, subMsg, model.pY)));
            default:
                var subMsg = msg.a;
                return function(original) {
                    var newModel = original.a;
                    var cmd = original.b;
                    var outMsgs = original.c;
                    return !_Utils_eq(newModel.agd, model.agd) ? _Utils_Tuple3(_Utils_update(newModel, {
                        ac: $author$project$Pages$Reports$Dashboard$initMetrics
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        $author$project$Pages$Reports$Dashboard$fetchMetrics(newModel),
                        $author$project$Pages$Reports$Dashboard$updateUrl(newModel)
                    ])), outMsgs) : original;
                }(function(result) {
                    return _Utils_Tuple3(_Utils_update(model, {
                        agd: function() {
                            var _v6 = result.adu;
                            if (!_v6.$) {
                                if (!_v6.a.$) return $author$project$Components$ResourceFilter$Plan$value(result.zi);
                                else {
                                    var _v7 = _v6.a;
                                    return model.agd;
                                }
                            } else return model.agd;
                        }(),
                        jy: result.zi
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg, result.EQ), result.at);
                }(A3($author$project$Components$ResourceFilter$Plan$update, model.Ej, subMsg, model.jy)));
        }
    });
    var $author$project$Pages$Reports$Dashboard$Active = 1;
    var $author$project$Pages$Reports$Dashboard$BreakoutChanged = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$CancellationReason = 7;
    var $author$project$Pages$Reports$Dashboard$Employer = 4;
    var $author$project$Pages$Reports$Dashboard$EmployerVsRetail = 5;
    var $author$project$Pages$Reports$Dashboard$EngagementChanged = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$Enrollments = 3;
    var $author$project$Pages$Reports$Dashboard$LeadSource = 6;
    var $author$project$Pages$Reports$Dashboard$Location = 3;
    var $author$project$Pages$Reports$Dashboard$LocationGroup = 2;
    var $author$project$Pages$Reports$Dashboard$Plan = 0;
    var $author$project$Pages$Reports$Dashboard$Provider = 1;
    var $author$project$Pages$Reports$Dashboard$ShowingChanged = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$Reports$Dashboard$Terminations = 2;
    var $author$project$Pages$Reports$Dashboard$breakoutToLabel = function(breakout) {
        switch(breakout){
            case 0:
                return 'Plan';
            case 1:
                return 'Provider';
            case 2:
                return 'Location Group';
            case 3:
                return 'Location';
            case 4:
                return 'Employer';
            case 5:
                return 'Employer vs Retail';
            case 6:
                return 'Lead Source';
            default:
                return 'Cancellation Reason';
        }
    };
    var $author$project$Pages$Reports$Dashboard$buildBreakoutOption = function(breakout) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$breakoutToValue(breakout)), $author$project$Pages$Reports$Dashboard$breakoutToLabel(breakout));
    };
    var $author$project$Pages$Reports$Dashboard$engagementToLabel = function(engagement) {
        switch(engagement){
            case 0:
                return 'All Engagement Statuses';
            case 1:
                return 'Currently Engaged';
            case 2:
                return 'Previously Engaged';
            default:
                return 'Never Engaged';
        }
    };
    var $author$project$Pages$Reports$Dashboard$buildEngagementOption = function(engagement) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $author$project$Pages$Reports$Dashboard$engagementToValue($elm$core$Maybe$Just(engagement)), $author$project$Pages$Reports$Dashboard$engagementToLabel(engagement));
    };
    var $author$project$Pages$Reports$Dashboard$showingToLabel = function(showing) {
        switch(showing){
            case 0:
                return 'Active, growth, attrition';
            case 1:
                return 'Active';
            case 2:
                return 'Terminations';
            default:
                return 'Enrollments';
        }
    };
    var $author$project$Pages$Reports$Dashboard$showingToValue = function(showing) {
        switch(showing){
            case 0:
                return 'all';
            case 1:
                return 'active';
            case 2:
                return 'terminations';
            default:
                return 'enrollments';
        }
    };
    var $author$project$Pages$Reports$Dashboard$buildShowingOption = function(showing) {
        return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$showingToValue(showing)), $author$project$Pages$Reports$Dashboard$showingToLabel(showing));
    };
    var $author$project$Pages$Reports$Dashboard$valueToBreakout = function(stringBreakout) {
        switch(stringBreakout){
            case 'plan':
                return $elm$core$Maybe$Just(0);
            case 'practitioner':
                return $elm$core$Maybe$Just(1);
            case 'location_group':
                return $elm$core$Maybe$Just(2);
            case 'location':
                return $elm$core$Maybe$Just(3);
            case 'employer':
                return $elm$core$Maybe$Just(4);
            case 'employer-retail':
                return $elm$core$Maybe$Just(5);
            case 'lead_source':
                return $elm$core$Maybe$Just(6);
            case 'cancellation_reason':
                return $elm$core$Maybe$Just(7);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Pages$Reports$Dashboard$valueToShowing = function(stringShowing) {
        switch(stringShowing){
            case 'active':
                return 1;
            case 'terminations':
                return 2;
            case 'enrollments':
                return 3;
            default:
                return 0;
        }
    };
    var $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view = function(model) {
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, function(locationGroupResourceFilter) {
                return A2($elm$html$Html$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationGroupResourceFilterMsg, A2($author$project$Components$ResourceFilter$LocationGroup$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(1)
                ]), locationGroupResourceFilter));
            }, model.rn),
            A2($elm$core$Maybe$map, function(locationResourceFilter) {
                return A2($elm$html$Html$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(1)
                ]), locationResourceFilter));
            }, model.ro),
            A2($elm$core$Maybe$map, function(practitionerResourceFilter) {
                return A2($elm$html$Html$map, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$PractitionerResourceFilterMsg, A2($author$project$Components$ResourceFilter$Practitioner$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$style(1)
                ]), practitionerResourceFilter));
            }, model.jE)
        ]));
    };
    var $author$project$Ui$Grid$Show = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Grid$showMd = $author$project$Ui$Grid$Show(2);
    var $author$project$Pages$Reports$Dashboard$viewPeriodSummary = function(maybePeriodSummary) {
        var showSumaryItem = function(valAccessor) {
            return A2($elm$core$Maybe$withDefault, $author$project$Ui$Spinner$view(_List_Nil), A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, valAccessor, A2($elm$core$Basics$composeR, $elm$core$String$fromInt, function(val) {
                return A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$attrs(_List_fromArray([
                        $elm$html$Html$Attributes$class('text-gray tile-item-big-number')
                    ]))
                ]), _List_fromArray([
                    $elm$html$Html$text(val)
                ]));
            })), maybePeriodSummary));
        };
        return A2($author$project$Ui$Grid$row, _List_fromArray([
            $author$project$Ui$Grid$mb4
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$showMd,
                $author$project$Ui$Grid$textCenter
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('tile-item')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Active at Start')
                    ])),
                    showSumaryItem(function($) {
                        return $.tO;
                    })
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$showMd,
                $author$project$Ui$Grid$textCenter
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('tile-item')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Enrollments')
                    ])),
                    showSumaryItem(function($) {
                        return $.Fp;
                    })
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$showMd,
                $author$project$Ui$Grid$textCenter
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('tile-item')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Terminations')
                    ])),
                    showSumaryItem(function($) {
                        return $.HL;
                    })
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$showMd,
                $author$project$Ui$Grid$textCenter
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('tile-item')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Active At End')
                    ])),
                    showSumaryItem(function($) {
                        return $.tN;
                    })
                ]))
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$span(4),
                $author$project$Ui$Grid$spanMd(2),
                $author$project$Ui$Grid$textCenter
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('tile-item')
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Net Growth')
                    ])),
                    function() {
                        if (!maybePeriodSummary.$) {
                            var activeAtStart = maybePeriodSummary.a.tO;
                            var activeAtEnd = maybePeriodSummary.a.tN;
                            var growth = 100 * ((activeAtEnd - activeAtStart) / activeAtStart);
                            return A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$attrs(_List_fromArray([
                                    $elm$html$Html$Attributes$class('tile-item-big-number'),
                                    $elm$html$Html$Attributes$classList(_List_fromArray([
                                        _Utils_Tuple2('text-danger', growth < 0),
                                        _Utils_Tuple2('text-grey', !growth),
                                        _Utils_Tuple2('text-success', growth > 0)
                                    ]))
                                ]))
                            ]), _List_fromArray([
                                $elm$core$Basics$isInfinite(growth) ? $elm$html$Html$text('--') : $elm$html$Html$text(function(percentage) {
                                    return percentage + '%';
                                }(A2($myrho$elm_round$Round$round, 2, growth)))
                            ]));
                        } else return $author$project$Ui$Spinner$view(_List_Nil);
                    }()
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$Reports$Dashboard$viewMemberAnalytics = function(_v0) {
        var dateRangeInput = _v0.h6;
        var periodSummary = _v0.r3;
        var showing = _v0.sX;
        var groupLocationAndPractitionerFilters = _v0.b8;
        var planResourceFilter = _v0.jy;
        var companyResourceFilter = _v0.pY;
        var breakout = _v0.EA;
        var engagement = _v0.Fo;
        var practice = _v0.W1;
        var practiceIsAffiliateOrNetwork = $author$project$Api$Provider$Practice$One$isNetwork(practice) || $author$project$Api$Provider$Practice$One$isAffiliate(practice);
        var gateIsAvailable = A2($author$project$Utils$FeatureGate$gateAvailable, 11, $author$project$Api$Practice$Provider(practice));
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Member Analytics')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(12)
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$headingSm(_List_fromArray([
                            $elm$html$Html$text('Reporting Period')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(12)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Reports$Dashboard$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(dateRangeInput))
                    ]))
                ])),
                $author$project$Pages$Reports$Dashboard$viewPeriodSummary(periodSummary),
                $author$project$Ui$HorizontalRule$view(_List_Nil),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$mb3,
                    $author$project$Ui$Element$gap2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text('Show me ')
                    ])),
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$inline,
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just($author$project$Pages$Reports$Dashboard$showingToValue(showing))),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToShowing, $author$project$Pages$Reports$Dashboard$ShowingChanged))
                    ]), _List_fromArray([
                        $author$project$Pages$Reports$Dashboard$buildShowingOption(0),
                        $author$project$Pages$Reports$Dashboard$buildShowingOption(1),
                        $author$project$Pages$Reports$Dashboard$buildShowingOption(2),
                        $author$project$Pages$Reports$Dashboard$buildShowingOption(3)
                    ])),
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text(' broken out by ')
                    ])),
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$inline,
                        $author$project$Ui$Form$Select$value(A2($elm$core$Maybe$map, $author$project$Pages$Reports$Dashboard$breakoutToValue, breakout)),
                        $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToBreakout, $author$project$Pages$Reports$Dashboard$BreakoutChanged))
                    ]), A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'No Breakout'), A2($elm$core$List$cons, $author$project$Pages$Reports$Dashboard$buildBreakoutOption(0), A2($elm$core$List$cons, $author$project$Pages$Reports$Dashboard$buildBreakoutOption(1), A2($elm$core$List$cons, $author$project$Pages$Reports$Dashboard$buildBreakoutOption(3), A2($elm$core$List$cons, $author$project$Pages$Reports$Dashboard$buildBreakoutOption(2), A2($elm$core$List$cons, $author$project$Pages$Reports$Dashboard$buildBreakoutOption(4), A2($elm$core$List$cons, $author$project$Pages$Reports$Dashboard$buildBreakoutOption(5), A2($elm$core$List$cons, $author$project$Pages$Reports$Dashboard$buildBreakoutOption(6), function() {
                        if (showing === 2) return _List_fromArray([
                            $author$project$Pages$Reports$Dashboard$buildBreakoutOption(7)
                        ]);
                        else return _List_Nil;
                    }())))))))))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                    $author$project$Ui$Grid$span(6),
                    $author$project$Ui$Grid$spanSm(4)
                ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Pages$Reports$Dashboard$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$view(groupLocationAndPractitionerFilters))), _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Reports$Dashboard$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$view, _List_fromArray([
                            $author$project$Components$ResourceFilter$style(1)
                        ]), companyResourceFilter))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$Reports$Dashboard$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_fromArray([
                            $author$project$Components$ResourceFilter$style(1)
                        ]), planResourceFilter))
                    ])),
                    gateIsAvailable || practiceIsAffiliateOrNetwork ? A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4),
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Select$view, _List_fromArray([
                            $author$project$Ui$Form$Select$inline,
                            $author$project$Ui$Form$Select$value($author$project$Pages$Reports$Dashboard$engagementToValue(engagement)),
                            $author$project$Ui$Form$Select$onChange(A2($elm$core$Basics$composeR, $author$project$Pages$Reports$Dashboard$valueToEngagement, $author$project$Pages$Reports$Dashboard$EngagementChanged))
                        ]), _List_fromArray([
                            $author$project$Pages$Reports$Dashboard$buildEngagementOption(0),
                            $author$project$Pages$Reports$Dashboard$buildEngagementOption(1),
                            $author$project$Pages$Reports$Dashboard$buildEngagementOption(2),
                            $author$project$Pages$Reports$Dashboard$buildEngagementOption(3)
                        ]))
                    ])) : $author$project$Ui$Grid$none
                ]))),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$id('dashboard-chart'),
                    A2($elm$html$Html$Attributes$style, 'position', 'relative'),
                    A2($elm$html$Html$Attributes$style, 'height', '540px')
                ]), _List_Nil)
            ]))
        ]));
    };
    var $author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams = function(optionalsFunc) {
        var options = optionalsFunc($author$project$Api$Provider$Reports$CustomerInvoice$listDefaults);
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), $author$project$Utils$Date$toQuery), options.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), $author$project$Utils$Date$toQuery), options.Fn),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('status'), $elm$core$String$join(',')), options.ahy)
        ]));
    };
    var $author$project$Ui$Panel$Success = 1;
    var $author$project$Ui$Panel$success = $author$project$Ui$Panel$Styling(1);
    var $author$project$Pages$Reports$Dashboard$viewOutstanding = F3(function(title, data, queryParams) {
        if (data.$ === 3) {
            var amount = data.a;
            var intCurrency = A2($elm$core$Maybe$withDefault, 0, $author$project$Currency$toInt(amount));
            var panelStyle = intCurrency > 0 ? $author$project$Ui$Panel$danger : $author$project$Ui$Panel$success;
            return A2($author$project$Ui$Panel$view, _List_fromArray([
                panelStyle
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(title)
                ])),
                A2($author$project$Ui$Panel$body, _List_fromArray([
                    $author$project$Ui$Element$textCenter
                ]), _List_fromArray([
                    $author$project$Ui$Typography$headingSm(_List_fromArray([
                        $elm$html$Html$text($author$project$Currency$format(amount))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                        intCurrency > 0 ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Invoices, _List_fromArray([
                            $author$project$Ui$Link$routeParams(queryParams)
                        ]), _List_fromArray([
                            $elm$html$Html$text('View outstanding')
                        ])) : $elm$html$Html$text('No Outstanding')
                    ]))
                ]))
            ]));
        } else return $author$project$Ui$Spinner$view(_List_fromArray([
            $author$project$Ui$Spinner$small
        ]));
    });
    var $author$project$Pages$Reports$Dashboard$viewPatientInvoices = function(_v0) {
        var today = _v0.aae;
        var outstandingLt30Amount = _v0.Af;
        var outstanding30To59Amount = _v0.Ad;
        var outstanding60PlusAmount = _v0.Ae;
        var issuedAmount = _v0.yv;
        var allAmountsSucceeded = A2($elm$core$List$all, $author$project$Api$Data$isSuccess, _List_fromArray([
            outstandingLt30Amount,
            outstanding30To59Amount,
            outstanding60PlusAmount,
            issuedAmount
        ]));
        return allAmountsSucceeded ? A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Patient Invoices')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A3($author$project$Pages$Reports$Dashboard$viewOutstanding, '< 30 Days Old', outstandingLt30Amount, $author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams($author$project$Pages$Reports$Dashboard$invoicesFromLessThan30DaysParams(today)))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A3($author$project$Pages$Reports$Dashboard$viewOutstanding, '30-59 Days Old', outstanding30To59Amount, $author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams($author$project$Pages$Reports$Dashboard$invoicesFrom30To59DaysParams(today)))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(4)
                    ]), _List_fromArray([
                        A3($author$project$Pages$Reports$Dashboard$viewOutstanding, '60+ Days Old', outstanding60PlusAmount, $author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams($author$project$Pages$Reports$Dashboard$invoicesFrom60PlusDaysParams(today)))
                    ]))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(12)
                    ]), _List_fromArray([
                        function() {
                            if (issuedAmount.$ === 3) {
                                var amount = issuedAmount.a;
                                return A2($author$project$Ui$Panel$view, _List_fromArray([
                                    $author$project$Ui$Panel$info
                                ]), _List_fromArray([
                                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text($author$project$Currency$format(amount))
                                        ])),
                                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text(' in ')
                                        ])),
                                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Invoices, _List_fromArray([
                                            $author$project$Ui$Link$routeParams($author$project$Pages$Reports$Dashboard$listOptionalsToUrlParams($author$project$Pages$Reports$Dashboard$issuedInvoicesParams))
                                        ]), _List_fromArray([
                                            $elm$html$Html$text('Issued, but unsent invoices')
                                        ]))
                                    ]))
                                ]));
                            } else return $author$project$Ui$Spinner$view(_List_fromArray([
                                $author$project$Ui$Spinner$small
                            ]));
                        }()
                    ]))
                ]))
            ]))
        ])) : $elm$html$Html$text('');
    };
    var $author$project$Pages$Reports$Dashboard$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$Reports$Dashboard$viewPatientInvoices(model),
                $author$project$Pages$Reports$Dashboard$viewMemberAnalytics(model)
            ]),
            $2: 'Reports | Dashboard'
        };
    };
    var $author$project$Pages$Reports$Dashboard$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Dashboard$init,
        aeR: $author$project$Pages$Reports$Dashboard$load,
        ag3: $author$project$Pages$Reports$Dashboard$save,
        ahE: $author$project$Pages$Reports$Dashboard$subscriptions,
        aaO: $author$project$Pages$Reports$Dashboard$update,
        aid: $author$project$Pages$Reports$Dashboard$view
    });
    var $author$project$Pages$Reports$DeferredRevenue$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$DeferredRevenue$Table = 0;
    var $author$project$Components$Reports$DeferredRevenue$ByDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$DeferredRevenueLine = 7;
    var $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$DeferredRevenue$urlParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('category'), model.fg),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location'), model.Tp),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('practitioner'), model.Xa),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('by'), model.bT)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Components$Reports$DeferredRevenue$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            function() {
                var _v0 = model.bT;
                if (!_v0.$) return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary);
                else return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__DeferredRevenue);
            }()
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), $author$project$Utils$QueryParameter$fromDict($author$project$Components$Reports$DeferredRevenue$urlParams(model)))));
    };
    var $author$project$Components$Reports$DeferredRevenue$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$DeferredRevenue$GotDeferredRevenueLines = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                EL: model.fg,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                af_: model.af_,
                agi: model.Xa,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$DeferredRevenueLine = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$Record = F8(function(transactionDate, amountInCents, category, charge, invoice, client, practitioner, location1) {
        return {
            Jh: amountInCents,
            EL: category,
            ach: charge,
            Li: client,
            RA: invoice,
            aeT: location1,
            agi: practitioner,
            aat: transactionDate
        };
    });
    var $author$project$Api$Provider$Reports$Charge$Charge = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Charge$Record = F2(function(name, serviceDate) {
        return {
            zr: name,
            ZZ: serviceDate
        };
    });
    var $author$project$Api$Provider$Reports$Charge$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'service_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Charge$Record)));
    var $author$project$Api$Provider$Reports$Charge$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Charge$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$RevenueLine$Client$Client = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$RevenueLine$Client$Record = F3(function(id, type_, name) {
        return {
            aef: id,
            zr: name,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$Reports$RevenueLine$Client$Company = 1;
    var $author$project$Api$Provider$Reports$RevenueLine$Client$Patient = 0;
    var $author$project$Api$Provider$Reports$RevenueLine$Client$decodeType = function(string) {
        switch(string){
            case 'Patient':
                return $elm$json$Json$Decode$succeed(0);
            case 'Company':
                return $elm$json$Json$Decode$succeed(1);
            default:
                return $elm$json$Json$Decode$fail('Unsupported client type: ' + string);
        }
    };
    var $author$project$Api$Provider$Reports$RevenueLine$Client$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$RevenueLine$Client$decodeType, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$RevenueLine$Client$Record))));
    var $author$project$Api$Provider$Reports$RevenueLine$Client$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$RevenueLine$Client$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'client', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$RevenueLine$Client$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transaction_date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$DeferredRevenueLine$Record)))))))));
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$DeferredRevenueLine$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$listDefaults = {
        EL: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agi: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$DeferredRevenueLine$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.EL;
                if (!_v2.$) {
                    var category_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'category', category_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.rm;
                if (!_v3.$) {
                    var locationGroup_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', locationGroup_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.aeT;
                if (!_v4.$) {
                    var location_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', location_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.agi;
                if (!_v5.$) {
                    var practitioner_ = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', practitioner_)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'deferred_revenue_lines'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$DeferredRevenueLine$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$DeferredRevenueLine$listPath)));
    });
    var $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$DeferredRevenueLine$list, apiClient, $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams(model), $author$project$Components$Reports$DeferredRevenue$GotDeferredRevenueLines);
    });
    var $author$project$Components$Reports$DeferredRevenue$GotSummary = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$DeferredRevenue$fetchSummaryParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                EL: model.fg,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                agi: model.Xa,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$summary = F4(function(apiClient, by, optionals, toMsg) {
        return A5($author$project$Api$Provider$Reports$Summary$retrieve, apiClient, $author$project$Api$Provider$Reports$DeferredRevenueLine$listPath, by, $author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams(optionals), toMsg);
    });
    var $author$project$Components$Reports$DeferredRevenue$fetchSummary = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$Reports$DeferredRevenueLine$summary, apiClient, A2($elm$core$Maybe$withDefault, '', model.bT), $author$project$Components$Reports$DeferredRevenue$fetchSummaryParams(model), $author$project$Components$Reports$DeferredRevenue$GotSummary);
    });
    var $author$project$Components$Reports$DeferredRevenue$fetchData = F2(function(apiClient, model) {
        var _v0 = model.ah5;
        if (!_v0) return A2($author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines, apiClient, model);
        else return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Reports$DeferredRevenue$fetchSummary, apiClient, model),
            A2($author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLines, apiClient, model)
        ]));
    });
    var $author$project$Components$Reports$DeferredRevenue$initColumns = function(trackPatientsByLocation) {
        return A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'client', true, 'Client'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'category', true, 'Category'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'), trackPatientsByLocation ? _List_fromArray([
            A3($author$project$Api$Column$init, 'location', true, 'Location')
        ]) : _List_Nil))))));
    };
    var $author$project$Components$Reports$DeferredRevenue$init = F5(function(type_, session, practice, _v0, query) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var categoryId = A2($elm$core$Dict$get, 'category', query);
        var _v1 = function() {
            if (!type_) return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
            else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
        }();
        var deferredRevenueLines = _v1.a;
        var summary = _v1.b;
        var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v3.a;
        var groupLocationAndPractitionerFiltersCmd = _v3.b;
        var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v4.a;
        var end = _v4.b;
        var _v5 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$DeferredRevenue$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v5.a;
        var dateRangeInputCmd = _v5.b;
        var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
        var categoryResourceFilter = _v6.a;
        var categoryResourceFilterCmd = _v6.b;
        var model = {
            bT: A2($elm$core$Dict$get, 'by', query),
            ln: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'by-dropdown',
                ahX: $author$project$Components$Reports$DeferredRevenue$ByDropdownMsg
            })),
            EE: A3($author$project$Permission$canGoTo, session, hinterViewOff, 17),
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            fg: categoryId,
            cK: categoryResourceFilter,
            LC: $author$project$Components$Reports$DeferredRevenue$initColumns(trackPatientsByLocation),
            cP: currentDate,
            h6: dateRangeInput,
            aF: deferredRevenueLines,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 7
            }),
            b8: groupLocationAndPractitionerFilters,
            f0: locationGroupId,
            Tp: locationId,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            Xa: practitionerId,
            ahs: A3($author$project$Api$Sort$withDefault, 'transaction_date', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            $x: summary,
            aaq: trackPatientsByLocation,
            ah5: type_
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, model),
            A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Reports$DeferredRevenue$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$DeferredRevenue$init, 0, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$DeferredRevenue$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$DeferredRevenue$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$DeferredRevenue$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b8)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg, $author$project$Components$ResourceFilter$Category$subscriptions(model.cK)),
            $author$project$Ui$Dropdown$subscriptions(model.ln)
        ]));
    };
    var $author$project$Pages$Reports$DeferredRevenue$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$DeferredRevenue$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$DeferredRevenue$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 2:
                var subMsg = msg.a;
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cK);
                var categoryId = function() {
                    var _v2 = categoryResourceResult.adu;
                    if (!_v2.$) {
                        if (!_v2.a.$) return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi);
                        else {
                            var _v3 = _v2.a;
                            return model.fg;
                        }
                    } else return model.fg;
                }();
                var newModel = _Utils_update(model, {
                    fg: categoryId,
                    cK: categoryResourceResult.zi
                });
                var _v1 = _Utils_eq(model.fg, newModel.fg) ? _Utils_Tuple2(model.aF, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var deferredRevenueLines = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    aF: deferredRevenueLines
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg, categoryResourceResult.EQ),
                    cmd
                ])), categoryResourceResult.at);
            case 3:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.ln);
                var byDropdown = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ln: byDropdown
                }), cmd, _List_Nil);
            case 4:
                var by = msg.a;
                var newModel = _Utils_update(model, {
                    bT: by,
                    aF: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                var cmds = function() {
                    var _v5 = _Utils_Tuple2(model.ah5, newModel.bT);
                    if (!_v5.a) {
                        if (!_v5.b.$) {
                            var _v6 = _v5.a;
                            return _List_fromArray([
                                A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                            ]);
                        } else {
                            var _v7 = _v5.a;
                            var _v8 = _v5.b;
                            return _List_fromArray([
                                $elm$core$Platform$Cmd$none
                            ]);
                        }
                    } else if (_v5.b.$ === 1) {
                        var _v9 = _v5.a;
                        var _v10 = _v5.b;
                        return _List_fromArray([
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ]);
                    } else {
                        var _v11 = _v5.a;
                        return _List_fromArray([
                            A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ]);
                    }
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(cmds), _List_Nil);
            case 0:
                var subMsg = msg.a;
                var _v12 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v12.a;
                var subCmd = _v12.b;
                var event = _v12.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            aF: $author$project$Api$Data$Loading,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b8);
                var _v14 = result.adu;
                switch(_v14.$){
                    case 0:
                        var locationGroupId = _v14.a;
                        var locationId = _v14.b;
                        var practitionerId = _v14.c;
                        var newModel = _Utils_update(model, {
                            aF: $author$project$Api$Data$Loading,
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            Xa: practitionerId
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        aF: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    aF: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $x: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    aF: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 8:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$DeferredRevenue$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$DeferredRevenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v16 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v16.a;
                var subCmd = _v16.b;
                var subOutMsg = _v16.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Reports$DeferredRevenue$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$DeferredRevenue$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$DeferredRevenue$PaginationMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$DeferredRevenue$amountFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$DeferredRevenue$BySelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$DeferredRevenue$byDropdownItems = F2(function(trackPatientsByLocation, currentBy) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$DeferredRevenue$BySelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Summary')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$DeferredRevenue$BySelected($elm$core$Maybe$Just('category'))),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('category')))
        ]), $elm$html$Html$text('Category')), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$DeferredRevenue$BySelected($elm$core$Maybe$Just('practitioner'))),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('practitioner')))
        ]), $elm$html$Html$text('Provider')), trackPatientsByLocation ? _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$DeferredRevenue$BySelected($elm$core$Maybe$Just('location'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('location')))
            ]), $elm$html$Html$text('Location'))
        ]) : _List_Nil))));
    });
    var $author$project$Components$Reports$DeferredRevenue$byToDisplayName = function(by) {
        switch(by){
            case 'category':
                return 'Category';
            case 'practitioner':
                return 'Provider';
            case 'location':
                return 'Location';
            default:
                return by;
        }
    };
    var $author$project$Components$Reports$DeferredRevenue$viewByDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.bT;
            if (!_v0.$) {
                var by = _v0.a;
                return $author$project$Components$Reports$DeferredRevenue$byToDisplayName(by);
            } else return 'Summarize by';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), A2($author$project$Components$Reports$DeferredRevenue$byDropdownItems, model.aaq, model.bT), model.ln);
    };
    var $author$project$Components$Reports$DeferredRevenue$viewCategoryResourceFilter = function(categoryResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), categoryResourceFilter));
    };
    var $author$project$Components$ResourceFilter$Category$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$Reports$DeferredRevenue$viewSummaryRow = F2(function(model, summaryRow) {
        var routeParams = _List_fromArray([
            $author$project$Ui$Link$routeParams(A2($author$project$Utils$Report$summaryRowTableParams, $author$project$Components$Reports$DeferredRevenue$urlParams(model), summaryRow))
        ]);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$info,
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__DeferredRevenue, routeParams, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Unassigned', $author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__DeferredRevenue, routeParams, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'charge', $author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__DeferredRevenue, routeParams, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Reports$DeferredRevenue$viewSummaryTable = function(model) {
        var summaryType = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize), $author$project$Api$Data$toMaybe(model.$x)));
        var summaryRows = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Summary$summaryRows, $author$project$Api$Data$toMaybe(model.$x)));
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.$x)),
            $author$project$Ui$Table$zeroState(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text(summaryType)
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Number of Charges')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Reports$DeferredRevenue$viewSummaryRow(model), summaryRows), _List_Nil);
    };
    var $author$project$Components$Reports$DeferredRevenue$SortTable = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$category = function(_v0) {
        var record = _v0;
        return record.EL;
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$charge = function(_v0) {
        var record = _v0;
        return record.ach;
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$client = function(_v0) {
        var record = _v0;
        return record.Li;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$Client$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$invoice = function(_v0) {
        var record = _v0;
        return record.RA;
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$location = function(_v0) {
        var record = _v0;
        return record.aeT;
    };
    var $author$project$Api$Provider$Reports$Charge$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$Client$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$practitioner = function(_v0) {
        var record = _v0;
        return record.agi;
    };
    var $author$project$Api$Provider$Reports$Charge$serviceDate = function(_v0) {
        var record = _v0;
        return record.ZZ;
    };
    var $author$project$Api$Provider$Reports$DeferredRevenueLine$transactionDate = function(_v0) {
        var record = _v0;
        return record.aat;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$Client$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Components$Reports$DeferredRevenue$viewRow = F4(function(trackPatientsByLocation, canGoToPatients, canGoToCompany, deferredRevenueLine) {
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$DeferredRevenueLine$transactionDate(deferredRevenueLine)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$DeferredRevenueLine$amountInCents(deferredRevenueLine))),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('for '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Charge$name, $author$project$Api$Provider$Reports$DeferredRevenueLine$charge(deferredRevenueLine))))
                        ])),
                        $elm$html$Html$text(' on ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Charge$serviceDate, $author$project$Api$Provider$Reports$DeferredRevenueLine$charge(deferredRevenueLine)))))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, function() {
                    var _v0 = $author$project$Api$Provider$Reports$DeferredRevenueLine$invoice(deferredRevenueLine);
                    if (!_v0.$) {
                        var invoice = _v0.a;
                        var invoiceStatus = A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice));
                        var invoicePath_ = function() {
                            var _v2 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
                            switch(_v2){
                                case 1:
                                    var _v3 = _Utils_Tuple2(canGoToPatients, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
                                    if (_v3.a && !_v3.b.$) {
                                        var owner = _v3.b.a;
                                        return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                            RI: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
                                            V8: $author$project$Api$Common$Payable$Owner$Min$id(owner)
                                        }));
                                    } else return $elm$core$Maybe$Nothing;
                                case 0:
                                    var _v4 = _Utils_Tuple2(canGoToCompany, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
                                    if (_v4.a && !_v4.b.$) {
                                        var owner = _v4.b.a;
                                        return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                                            fl: $author$project$Api$Common$Payable$Owner$Min$id(owner),
                                            aef: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
                                        }));
                                    } else return $elm$core$Maybe$Nothing;
                                default:
                                    return $elm$core$Maybe$Nothing;
                            }
                        }();
                        var invoiceNumber = $elm$html$Html$text('#' + ($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' '));
                        var _for = A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('for ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))))
                        ]));
                        if (!invoicePath_.$) {
                            var path = invoicePath_.a;
                            return _List_fromArray([
                                A3($author$project$Ui$Link$route, path, _List_Nil, _List_fromArray([
                                    invoiceNumber,
                                    invoiceStatus
                                ])),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                _for
                            ]);
                        } else return _List_fromArray([
                            invoiceNumber,
                            invoiceStatus,
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            _for
                        ]);
                    } else return _List_Nil;
                }()),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), function() {
                        var _v5 = $author$project$Api$Provider$Reports$DeferredRevenueLine$client(deferredRevenueLine);
                        if (!_v5.$) {
                            var client = _v5.a;
                            var path = function() {
                                var _v7 = $author$project$Api$Provider$Reports$RevenueLine$Client$type_(client);
                                if (!_v7) return canGoToPatients ? $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
                                })) : $elm$core$Maybe$Nothing;
                                else return canGoToCompany ? $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                    fl: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
                                })) : $elm$core$Maybe$Nothing;
                            }();
                            var clientName = $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, $author$project$Api$Provider$Reports$RevenueLine$Client$name(client)));
                            if (!path.$) {
                                var path_ = path.a;
                                return _List_fromArray([
                                    A3($author$project$Ui$Link$route, path_, _List_Nil, _List_fromArray([
                                        clientName
                                    ]))
                                ]);
                            } else return _List_fromArray([
                                clientName
                            ]);
                        } else return _List_fromArray([
                            $elm$html$Html$text('N/A')
                        ]);
                    }())
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$name, $author$project$Api$Provider$Reports$DeferredRevenueLine$category(deferredRevenueLine))))
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(trackPatientsByLocation ? 1 : 2)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$name, $author$project$Api$Provider$Reports$DeferredRevenueLine$practitioner(deferredRevenueLine)))))
                ]))
            ]),
            trackPatientsByLocation ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$Reports$DeferredRevenueLine$location(deferredRevenueLine)))))
                ]))
            ]) : _List_Nil
        ])));
    });
    var $author$project$Components$Reports$DeferredRevenue$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.aF;
            if (_v1.$ === 3) {
                var deferredRevenueLines_ = _v1.a;
                return _Utils_Tuple2(false, deferredRevenueLines_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var deferredRevenueLines = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$DeferredRevenue$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A3($author$project$Components$Reports$DeferredRevenue$viewRow, model.aaq, model.EF, model.EE), deferredRevenueLines), _List_Nil);
    };
    var $author$project$Components$Reports$DeferredRevenue$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$DeferredRevenue$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.aF)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$DeferredRevenueLine$listOptionsToParams, $author$project$Components$Reports$DeferredRevenue$fetchDeferredRevenueLinesParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Deferred Revenue')
                    ])),
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.aF;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$DeferredRevenue$amountFromHeader, headers, 'x-total-amount')))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Total deferred revenue across retail customers and employers')
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(12)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Reports$DeferredRevenue$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_Nil, _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$spanMd(4)
                    ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                        $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
                    ]), model.b8))), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$DeferredRevenue$viewCategoryResourceFilter(model.cK)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$DeferredRevenue$viewByDropdown(model)
                        ]))
                    ]))),
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$CategoryResourceFilterMsg), $author$project$Components$ResourceFilter$Category$viewMultiSelected(model.cK)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$DeferredRevenue$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b8)));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                function() {
                    var _v1 = model.ah5;
                    if (!_v1) return $author$project$Components$Reports$DeferredRevenue$viewTable(model);
                    else return $author$project$Components$Reports$DeferredRevenue$viewSummaryTable(model);
                }(),
                function() {
                    var _v2 = model.ah5;
                    if (!_v2) return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$DeferredRevenue$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.aF)))
                        ]), model.af_))
                    ]));
                    else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]);
    });
    var $author$project$Pages$Reports$DeferredRevenue$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$DeferredRevenue$view, model.Ej, model.jQ)),
            $2: 'Reports | Deferred Revenue'
        };
    };
    var $author$project$Pages$Reports$DeferredRevenue$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$DeferredRevenue$init,
        aeR: $author$project$Pages$Reports$DeferredRevenue$load,
        ag3: $author$project$Pages$Reports$DeferredRevenue$save,
        ahE: $author$project$Pages$Reports$DeferredRevenue$subscriptions,
        aaO: $author$project$Pages$Reports$DeferredRevenue$update,
        aid: $author$project$Pages$Reports$DeferredRevenue$view
    });
    var $author$project$Pages$Reports$DeferredRevenue$Summary$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$DeferredRevenue$Summary = 1;
    var $author$project$Pages$Reports$DeferredRevenue$Summary$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$DeferredRevenue$init, 1, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$DeferredRevenue$Summary$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$DeferredRevenue$Summary$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$DeferredRevenue$Summary$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$DeferredRevenue$subscriptions(model.jQ));
    };
    var $author$project$Pages$Reports$DeferredRevenue$Summary$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$DeferredRevenue$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Reports$DeferredRevenue$Summary$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$DeferredRevenue$view, model.Ej, model.jQ)),
            $2: 'Reports | Deferred Revenue'
        };
    };
    var $author$project$Pages$Reports$DeferredRevenue$Summary$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$DeferredRevenue$Summary$init,
        aeR: $author$project$Pages$Reports$DeferredRevenue$Summary$load,
        ag3: $author$project$Pages$Reports$DeferredRevenue$Summary$save,
        ahE: $author$project$Pages$Reports$DeferredRevenue$Summary$subscriptions,
        aaO: $author$project$Pages$Reports$DeferredRevenue$Summary$update,
        aid: $author$project$Pages$Reports$DeferredRevenue$Summary$view
    });
    var $author$project$Pages$Reports$Deposits$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$Deposits$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$Deposit = 13;
    var $author$project$Components$Reports$Deposits$StatusDropdownMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$Deposits$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$Deposits$GotDepositSummary = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$DepositSummary$DepositSummary = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$DepositSummary$Record = F3(function(nextDepositAvailableOn, nextDepositAmountInCents, availableSoonAmountInCents) {
        return {
            J0: availableSoonAmountInCents,
            UZ: nextDepositAmountInCents,
            U_: nextDepositAvailableOn
        };
    });
    var $author$project$Api$Provider$Reports$DepositSummary$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'available_soon_amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_deposit_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_deposit_available_on', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$DepositSummary$Record))));
    var $author$project$Api$Provider$Reports$DepositSummary$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$DepositSummary$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$DepositSummary$depositSummaryPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'deposits',
        'summary'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$DepositSummary$depositSummary = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Reports$DepositSummary$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$DepositSummary$depositSummaryPath));
    });
    var $author$project$Components$Reports$Deposits$fetchDepositSummary = F2(function(apiClient, _v0) {
        return A2($author$project$Api$Provider$Reports$DepositSummary$depositSummary, apiClient, $author$project$Components$Reports$Deposits$GotDepositSummary);
    });
    var $author$project$Components$Reports$Deposits$GotDeposits = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$Deposits$fetchDepositsParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af_: model.af_,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ahy: model.ahy
            });
        };
    };
    var $author$project$Api$Provider$Reports$Deposit$Deposit = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Deposit$Record = function(id) {
        return function(availableOn) {
            return function(amountInCents) {
                return function(stripeFeeInCents) {
                    return function(hintFeeInCents) {
                        return function(totalFeeInCents) {
                            return function(discrepancyInCents) {
                                return function(receiptsCount) {
                                    return function(status) {
                                        return function(errorMessage) {
                                            return function(paymentProcessor) {
                                                return function(canReconcile) {
                                                    return {
                                                        Jh: amountInCents,
                                                        J$: availableOn,
                                                        KR: canReconcile,
                                                        N5: discrepancyInCents,
                                                        O4: errorMessage,
                                                        QO: hintFeeInCents,
                                                        aef: id,
                                                        Wo: paymentProcessor,
                                                        Yf: receiptsCount,
                                                        ahy: status,
                                                        $h: stripeFeeInCents,
                                                        aak: totalFeeInCents
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Reports$Deposit$Canceled = 3;
    var $author$project$Api$Provider$Reports$Deposit$Failed = 4;
    var $author$project$Api$Provider$Reports$Deposit$InTransit = 2;
    var $author$project$Api$Provider$Reports$Deposit$Paid = 0;
    var $author$project$Api$Provider$Reports$Deposit$Pending = 1;
    var $author$project$Api$Provider$Reports$Deposit$Upcoming = 5;
    var $author$project$Api$Provider$Reports$Deposit$decodeStatus = function(string) {
        switch(string){
            case 'paid':
                return $elm$json$Json$Decode$succeed(0);
            case 'pending':
                return $elm$json$Json$Decode$succeed(1);
            case 'in_transit':
                return $elm$json$Json$Decode$succeed(2);
            case 'canceled':
                return $elm$json$Json$Decode$succeed(3);
            case 'failed':
                return $elm$json$Json$Decode$succeed(4);
            case 'upcoming':
                return $elm$json$Json$Decode$succeed(5);
            default:
                return $elm$json$Json$Decode$fail('Unsupported deposit status: ' + string);
        }
    };
    var $author$project$Api$Provider$Reports$Deposit$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'can_reconcile', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'error_message', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$Deposit$decodeStatus, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'receipts_count', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'discrepancy_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hint_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'available_on', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Deposit$Record)))))))))))));
    var $author$project$Api$Provider$Reports$Deposit$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Deposit$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Deposit$listDefaults = {
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$Deposit$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$Deposit$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.ahy;
                if (!_v2.$) {
                    var status_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', status_)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$Deposit$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'deposits'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$Deposit$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Deposit$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$Deposit$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Deposit$listPath)));
    });
    var $author$project$Components$Reports$Deposits$fetchDeposits = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$Deposit$list, apiClient, $author$project$Components$Reports$Deposits$fetchDepositsParams(model), $author$project$Components$Reports$Deposits$GotDeposits);
    });
    var $author$project$Components$Reports$Deposits$initColumns = function(feePlanType) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'available_on', true, 'Est. Available Date'),
                A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Deposit Amount')
            ]),
            function() {
                if (!feePlanType) return _List_fromArray([
                    A3($author$project$Api$Column$init, 'stripe_fee_in_cents', true, 'Processing Fee'),
                    A3($author$project$Api$Column$init, 'hint_fee_in_cents', true, 'Platform Fee')
                ]);
                else return _List_fromArray([
                    A3($author$project$Api$Column$init, 'total_fee_in_cents', true, 'Transaction Fee')
                ]);
            }(),
            _List_fromArray([
                A3($author$project$Api$Column$init, 'discrepancy_in_cents', true, 'Discrepancies'),
                A3($author$project$Api$Column$init, 'receipts_count', false, 'Payment Count'),
                A3($author$project$Api$Column$init, 'payment_processor', false, 'Payment Processor'),
                A3($author$project$Api$Column$init, 'status', false, 'Status')
            ])
        ]));
    };
    var $author$project$Components$Reports$Deposits$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('status'), model.ahy)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Deposits)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Components$Reports$Deposits$init = F3(function(practice, shared, query) {
        var feePlanType = $author$project$Api$Provider$Practice$One$feePlanType(practice);
        var _v0 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v0.a;
        var end = _v0.b;
        var _v1 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$Deposits$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, shared.cP, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, shared.cP, 0), end)));
        var dateRangeInput = _v1.a;
        var dateRangeInputCmd = _v1.b;
        var model = {
            LC: $author$project$Components$Reports$Deposits$initColumns(feePlanType),
            cP: shared.cP,
            h6: dateRangeInput,
            xg: $author$project$Api$Data$Loading,
            b2: $author$project$Api$Data$Loading,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 13
            }),
            PA: feePlanType,
            F3: $author$project$Shared$isHintAdmin(shared),
            af_: $author$project$Api$Pagination$initFromQuery(query),
            W1: practice,
            gz: $elm$core$Maybe$Nothing,
            ahs: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            ahy: A2($elm$core$Dict$get, 'status', query),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'deposits-status-dropdown',
                ahX: $author$project$Components$Reports$Deposits$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$DateRangeInputMsg, dateRangeInputCmd),
            A2($author$project$Components$Reports$Deposits$fetchDeposits, shared.Ej, model),
            A2($author$project$Components$Reports$Deposits$fetchDepositSummary, shared.Ej, model),
            $author$project$Components$Reports$Deposits$updateUrl(model)
        ])));
    });
    var $author$project$Pages$Reports$Deposits$init = F4(function(_v0, practice, shared, _v1) {
        var query = _v1.Bz;
        var _v2 = A3($author$project$Components$Reports$Deposits$init, practice, shared, query);
        var report = _v2.a;
        var reportCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$Deposits$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Deposits$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$Deposits$CloseRainforestDepositModal = {
        $: 10
    };
    var $author$project$Components$Reports$Deposits$ExportCsvMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$Deposits$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Deposits$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Deposits$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            $author$project$Ui$Dropdown$subscriptions(model.oD),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$Rainforest$SessionModal$subscriptions($author$project$Components$Reports$Deposits$CloseRainforestDepositModal)), model.gz))
        ]));
    };
    var $author$project$Pages$Reports$Deposits$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$Deposits$subscriptions(model.jQ));
    };
    var $author$project$Api$Platform$RainforestSession$Deposit = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$Deposits$RainforestDepositModalMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$Deposit$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Reports$Deposits$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v1.a;
                var subCmd = _v1.b;
                var event = _v1.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            b2: $author$project$Api$Data$Loading,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
                    $author$project$Components$Reports$Deposits$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v3.a;
                var statusDropdownCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), statusDropdownCmd, _List_Nil);
            case 2:
                var selectedOption = msg.a;
                var newModel = _Utils_update(model, {
                    b2: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ahy: function() {
                        if (selectedOption.$ === 1) return $elm$core$Maybe$Nothing;
                        else {
                            var status = selectedOption.a;
                            return $elm$core$Maybe$Just(status);
                        }
                    }()
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
                    $author$project$Components$Reports$Deposits$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        b2: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    b2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var response = msg.a;
                if (response.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    xg: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 5:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    b2: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
                    $author$project$Components$Reports$Deposits$updateUrl(newModel)
                ])), _List_Nil);
            case 6:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Deposits$fetchDeposits, apiClient, newModel),
                    $author$project$Components$Reports$Deposits$updateUrl(newModel)
                ])), _List_Nil);
            case 7:
                var subMsg = msg.a;
                var _v7 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v7.a;
                var subCmd = _v7.b;
                var subOutMsg = _v7.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$ExportCsvMsg, subCmd), subOutMsg);
            case 8:
                var deposit = msg.a;
                var _v8 = A2($author$project$Components$Rainforest$SessionModal$init, apiClient, $author$project$Api$Platform$RainforestSession$Deposit($author$project$Api$Provider$Reports$Deposit$id(deposit)));
                var rainforestDepositModal = _v8.a;
                var rainforestDepositModalCmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    gz: $elm$core$Maybe$Just(rainforestDepositModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$RainforestDepositModalMsg, rainforestDepositModalCmd), _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v9 = model.gz;
                if (!_v9.$) {
                    var rainforestDepositModal = _v9.a;
                    var _v10 = A2($author$project$Components$Rainforest$SessionModal$update, subMsg, rainforestDepositModal);
                    var newRainforestDepositModal = _v10.a;
                    var rainforestDepositModalCmd = _v10.b;
                    var rainforestDepositModalOutMsg = _v10.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        gz: $elm$core$Maybe$Just(newRainforestDepositModal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Deposits$RainforestDepositModalMsg, rainforestDepositModalCmd), rainforestDepositModalOutMsg);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                return _Utils_Tuple3(_Utils_update(model, {
                    gz: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Reports$Deposits$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$Deposits$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$Deposits$PaginationMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$Deposits$intFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Api$Provider$Reports$DepositSummary$availableSoonAmountInCents = function(_v0) {
        var record = _v0;
        return record.J0;
    };
    var $author$project$Components$Reports$Deposits$viewAvailableSoonCard = function(depositSummary) {
        var title = 'Available Soon';
        var subtitle = 'Estimate expected within a few business days';
        var description = 'Total amount of payments in progress. These have been collected, but not yet deposited.';
        var availableSoon = $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$DepositSummary$availableSoonAmountInCents(depositSummary));
        return A8($author$project$Components$InfoCard$view, 'blue', title, _List_Nil, availableSoon, $elm$core$Maybe$Just(subtitle), description, $author$project$Utils$Html$empty, true);
    };
    var $author$project$Api$Provider$Reports$DepositSummary$nextDepositAmountInCents = function(_v0) {
        var record = _v0;
        return record.UZ;
    };
    var $author$project$Api$Provider$Reports$DepositSummary$nextDepositAvailableOn = function(_v0) {
        var record = _v0;
        return record.U_;
    };
    var $author$project$Components$Reports$Deposits$viewNextDepositCard = function(depositSummary) {
        var title = 'Next Deposit';
        var nextDepositAvailableOn = function() {
            var _v1 = $author$project$Api$Provider$Reports$DepositSummary$nextDepositAvailableOn(depositSummary);
            if (!_v1.$) {
                var availableOn = _v1.a;
                return $elm$core$Maybe$Just('Estimate expected ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$MonthAndDayAndYear, availableOn));
            } else return $elm$core$Maybe$Nothing;
        }();
        var nextDepositAmount = function() {
            var _v0 = $author$project$Api$Provider$Reports$DepositSummary$nextDepositAmountInCents(depositSummary);
            if (!_v0.$) {
                var amount = _v0.a;
                return $author$project$Utils$Currency$fromInt(amount);
            } else return 'N/A';
        }();
        var description = "This reflects the portion of the \u201CAvailable Soon\u201D amount that is scheduled to be paid out next.";
        return A8($author$project$Components$InfoCard$view, 'green', title, _List_Nil, nextDepositAmount, nextDepositAvailableOn, description, $author$project$Utils$Html$empty, true);
    };
    var $author$project$Components$Reports$Deposits$viewDepositSummary = F2(function(depositSummaryData, practice) {
        if ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'rainforest') {
            if (depositSummaryData.$ === 3) {
                var depositSummary = depositSummaryData.a;
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb6
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$mt4,
                        $author$project$Ui$Grid$mb2
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(6)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Deposits$viewNextDepositCard(depositSummary)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanMd(6)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Deposits$viewAvailableSoonCard(depositSummary)
                        ]))
                    ])),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('The numbers above are estimates based on pending transactions. Stripe payments are excluded. Final deposit amounts may change as payments and refunds process.')
                    ]))
                ]));
            } else return $author$project$Utils$Html$empty;
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Reports$Deposits$formatStatus = $elm_community$string_extra$String$Extra$humanize;
    var $author$project$Components$Reports$Deposits$None = {
        $: 1
    };
    var $author$project$Components$Reports$Deposits$Status = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$Deposits$StatusFiltered = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$Deposits$statusDropdownOptions = function(currentStatus) {
        var baseStatusOptions = _List_fromArray([
            'failed',
            'paid',
            'pending',
            'in_transit',
            'canceled',
            'upcoming'
        ]);
        var statusOptions = A2($elm$core$List$map, function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Deposits$StatusFiltered($author$project$Components$Reports$Deposits$Status(status))),
                $author$project$Ui$Dropdown$selected(_Utils_eq($elm$core$Maybe$Just(status), currentStatus))
            ]), $elm$html$Html$text($author$project$Components$Reports$Deposits$formatStatus(status)));
        }, baseStatusOptions);
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Deposits$StatusFiltered($author$project$Components$Reports$Deposits$None)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Filter')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
    };
    var $author$project$Components$Reports$Deposits$viewStatusDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'All Status', A2($elm$core$Maybe$map, $author$project$Components$Reports$Deposits$formatStatus, model.ahy)))
        ]), $author$project$Components$Reports$Deposits$statusDropdownOptions(model.ahy), model.oD);
    };
    var $author$project$Components$Reports$Deposits$SortTable = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$Deposits$OpenRainforestDepositModal = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$Deposit$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$Deposit$availableOn = function(_v0) {
        var record = _v0;
        return record.J$;
    };
    var $author$project$Api$Provider$Reports$Deposit$canReconcile = function(_v0) {
        var record = _v0;
        return record.KR;
    };
    var $author$project$Api$Provider$Reports$Deposit$discrepancyInCents = function(_v0) {
        var record = _v0;
        return record.N5;
    };
    var $author$project$Api$Provider$Reports$Deposit$errorMessage = function(_v0) {
        var record = _v0;
        return record.O4;
    };
    var $author$project$Api$Provider$Reports$Deposit$hintFeeInCents = function(_v0) {
        var record = _v0;
        return record.QO;
    };
    var $author$project$Api$Provider$Reports$Deposit$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$Reports$Deposit$receiptsCount = function(_v0) {
        var record = _v0;
        return record.Yf;
    };
    var $author$project$Api$Provider$Reports$Deposit$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Reports$Deposit$statusToString = function(status_) {
        switch(status_){
            case 0:
                return 'paid';
            case 1:
                return 'pending';
            case 2:
                return 'in transit';
            case 3:
                return 'canceled';
            case 4:
                return 'failed';
            default:
                return 'upcoming';
        }
    };
    var $author$project$Api$Provider$Reports$Deposit$stripeFeeInCents = function(_v0) {
        var record = _v0;
        return record.$h;
    };
    var $author$project$Api$Provider$Reports$Deposit$totalFeeInCents = function(_v0) {
        var record = _v0;
        return record.aak;
    };
    var $author$project$Components$Reports$Deposits$viewRow = F3(function(isHintAdmin, feePlanType, deposit) {
        var availableDate = $author$project$Api$Provider$Reports$Deposit$status(deposit) === 5 ? $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$Deposit$availableOn(deposit))) : A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__PaymentApplications, _List_fromArray([
            $author$project$Ui$Link$routeParams(_List_fromArray([
                A2($elm$url$Url$Builder$string, 'deposit', $author$project$Api$Provider$Reports$Deposit$id(deposit))
            ]))
        ]), _List_fromArray([
            $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$Deposit$availableOn(deposit)))
        ]));
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    availableDate
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Deposit$amountInCents(deposit)))
                ]))
            ]),
            function() {
                if (!feePlanType) return _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Deposit$stripeFeeInCents(deposit)))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Deposit$hintFeeInCents(deposit)))
                    ]))
                ]);
                else return _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Deposit$totalFeeInCents(deposit)))
                    ]))
                ]);
            }(),
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, $author$project$Api$Provider$Reports$Deposit$canReconcile(deposit) ? _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Deposit$discrepancyInCents(deposit))),
                    !!$author$project$Api$Provider$Reports$Deposit$discrepancyInCents(deposit) ? A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$placement(0)
                    ]), 'Occasionally there are discrepancies due to failed ACH or disputed payments', _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace,
                        $author$project$Ui$Icon$help(_List_Nil)
                    ])) : $author$project$Utils$Html$empty
                ]) : _List_fromArray([
                    $elm$html$Html$text('N/A'),
                    A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$placement(0)
                    ]), 'Non Automated Deposits cannot be reconciled', _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace,
                        $author$project$Ui$Icon$help(_List_Nil)
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromInt($author$project$Api$Provider$Reports$Deposit$receiptsCount(deposit)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, true, isHintAdmin, deposit, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Deposit$paymentProcessor, $elm$core$Maybe$Just)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    function() {
                        var _v1 = _Utils_Tuple2($author$project$Api$Provider$Reports$Deposit$status(deposit), $author$project$Api$Provider$Reports$Deposit$errorMessage(deposit));
                        if (_v1.a === 4 && !_v1.b.$) {
                            var _v2 = _v1.a;
                            var errorMessage = _v1.b.a;
                            return A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                $author$project$Ui$Tooltip$placement(0)
                            ]), errorMessage, _List_fromArray([
                                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$Deposit$statusToString($author$project$Api$Provider$Reports$Deposit$status(deposit)))
                            ]));
                        } else return A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$Deposit$statusToString($author$project$Api$Provider$Reports$Deposit$status(deposit)));
                    }()
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    function() {
                        var _v3 = _Utils_Tuple2(isHintAdmin, $author$project$Api$Provider$Reports$Deposit$paymentProcessor(deposit));
                        if (_v3.a && _v3.b === 'rainforest') return A3($author$project$Ui$HinterOnly$button, {
                            abP: 'View on rainforest'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Components$Reports$Deposits$OpenRainforestDepositModal(deposit))
                        ]), _List_fromArray([
                            $elm$html$Html$text('View on Rainforest')
                        ]));
                        else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ])
        ])));
    });
    var $author$project$Components$Reports$Deposits$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.b2;
            if (_v1.$ === 3) {
                var deposits_ = _v1.a;
                return _Utils_Tuple2(false, deposits_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var deposits = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$Deposits$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$Deposits$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A2($author$project$Components$Reports$Deposits$viewRow, model.F3, model.PA), deposits), _List_Nil);
    };
    var $author$project$Components$Reports$Deposits$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$Deposits$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.b2)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Deposit$listOptionsToParams, $author$project$Components$Reports$Deposits$fetchDepositsParams)(model))
            ]), model.md)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$Rainforest$SessionModal$view($author$project$Components$Reports$Deposits$CloseRainforestDepositModal), model.gz)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Deposits')
                    ])),
                    A2($author$project$Components$Reports$Deposits$viewDepositSummary, model.xg, model.W1),
                    $author$project$Ui$Typography$heading(function() {
                        var _v0 = model.b2;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-amount'))),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$muted,
                                    $author$project$Ui$Typography$small
                                ]), _List_fromArray([
                                    function() {
                                        var _v1 = model.PA;
                                        if (!_v1) return $elm$html$Html$text(' after ' + ($author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-stripe-fee-amount')) + (' in Processing fees and ' + ($author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-hint-fee-amount')) + (' in Platform fees across ' + A2($author$project$Formatters$String$pluralize, 'deposit', A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-count')))))));
                                        else return $elm$html$Html$text(' after ' + ($author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-fee-amount')) + (' in transaction fees across ' + A2($author$project$Formatters$String$pluralize, 'deposit', A2($author$project$Components$Reports$Deposits$intFromHeader, headers, 'x-total-count')))));
                                    }()
                                ]))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
                            ]))
                        ]);
                    }()),
                    A2($elm$html$Html$map, $author$project$Components$Reports$Deposits$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6)),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(5),
                            $author$project$Ui$Grid$spanSm(3),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Deposits$viewStatusDropdown(model)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$Deposits$viewTable(model)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$Deposits$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.b2)))
                    ]), model.af_))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Reports$Deposits$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$Deposits$view, model.Ej, model.jQ)),
            $2: 'Reports | Deposits'
        };
    };
    var $author$project$Pages$Reports$Deposits$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Deposits$init,
        aeR: $author$project$Pages$Reports$Deposits$load,
        ag3: $author$project$Pages$Reports$Deposits$save,
        ahE: $author$project$Pages$Reports$Deposits$subscriptions,
        aaO: $author$project$Pages$Reports$Deposits$update,
        aid: $author$project$Pages$Reports$Deposits$view
    });
    var $author$project$Pages$Reports$Disputes$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$Disputes$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$Dispute = 21;
    var $author$project$Components$Reports$Disputes$StatusDropdownMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$Disputes$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$Disputes$GotDisputes = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$Disputes$fetchDisputesParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                af_: model.af_,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ahy: model.ahy
            });
        };
    };
    var $author$project$Api$Provider$Reports$Dispute$Dispute = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Dispute$Record = F7(function(id, paymentProcessor, dueDate, amountInCents, status, reasonCode, reasonDescription) {
        return {
            Jh: amountInCents,
            Ok: dueDate,
            aef: id,
            Wo: paymentProcessor,
            Yc: reasonCode,
            Yd: reasonDescription,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Reports$Dispute$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reason_description', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'reason_code', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'due_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Dispute$Record))))))));
    var $author$project$Api$Provider$Reports$Dispute$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Dispute$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Dispute$listDefaults = {
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$Dispute$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$Dispute$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.ahy;
                if (!_v2.$) {
                    var status_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', status_)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$Dispute$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'disputes'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$Dispute$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Dispute$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$Dispute$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Dispute$listPath)));
    });
    var $author$project$Components$Reports$Disputes$fetchDisputes = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$Dispute$list, apiClient, $author$project$Components$Reports$Disputes$fetchDisputesParams(model), $author$project$Components$Reports$Disputes$GotDisputes);
    });
    var $author$project$Components$Reports$Disputes$initColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'due_date', true, 'Due Date'),
        A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
        A3($author$project$Api$Column$init, 'reason_code', true, 'Reason Code'),
        A3($author$project$Api$Column$init, 'status', true, 'Status')
    ]);
    var $author$project$Components$Reports$Disputes$updateUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('status'), model.ahy)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Disputes)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)))));
    };
    var $author$project$Components$Reports$Disputes$init = F3(function(session, shared, query) {
        var _v0 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v0.a;
        var end = _v0.b;
        var _v1 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$Disputes$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, shared.cP, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, shared.cP, 0), end)));
        var dateRangeInput = _v1.a;
        var dateRangeInputCmd = _v1.b;
        var model = {
            LC: $author$project$Components$Reports$Disputes$initColumns,
            cP: shared.cP,
            h6: dateRangeInput,
            fB: $elm$core$Maybe$Nothing,
            b3: $author$project$Api$Data$Loading,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 21
            }),
            F3: $author$project$Shared$isHintAdmin(shared),
            F4: $author$project$Api$Platform$Session$One$userIsPracticeAdmin(session),
            af_: $author$project$Api$Pagination$initFromQuery(query),
            ahs: A3($author$project$Api$Sort$withDefault, 'due_date', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            ahy: A2($elm$core$Dict$get, 'status', query),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'disputes-status-dropdown',
                ahX: $author$project$Components$Reports$Disputes$StatusDropdownMsg
            }))
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DateRangeInputMsg, dateRangeInputCmd),
            A2($author$project$Components$Reports$Disputes$fetchDisputes, shared.Ej, model),
            $author$project$Components$Reports$Disputes$updateUrl(model)
        ])));
    });
    var $author$project$Pages$Reports$Disputes$init = F4(function(session, _v0, shared, _v1) {
        var query = _v1.Bz;
        var _v2 = A3($author$project$Components$Reports$Disputes$init, session, shared, query);
        var report = _v2.a;
        var reportCmd = _v2.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$Disputes$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Disputes$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$Disputes$CloseDisputeModal = {
        $: 8
    };
    var $author$project$Components$Reports$Disputes$ExportCsvMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$Disputes$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Disputes$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Disputes$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            $author$project$Ui$Dropdown$subscriptions(model.oD),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $elm$core$Basics$always($author$project$Components$DisputeModal$subscriptions($author$project$Components$Reports$Disputes$CloseDisputeModal)), model.fB))
        ]));
    };
    var $author$project$Pages$Reports$Disputes$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$Disputes$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$Disputes$DisputeModalMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$Dispute$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Components$Reports$Disputes$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v1.a;
                var subCmd = _v1.b;
                var event = _v1.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            b3: $author$project$Api$Data$Loading,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
                    $author$project$Components$Reports$Disputes$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v3.a;
                var statusDropdownCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), statusDropdownCmd, _List_Nil);
            case 2:
                var selectedOption = msg.a;
                var newModel = _Utils_update(model, {
                    b3: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ahy: function() {
                        if (selectedOption.$ === 1) return $elm$core$Maybe$Nothing;
                        else {
                            var status = selectedOption.a;
                            return $elm$core$Maybe$Just(status);
                        }
                    }()
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
                    $author$project$Components$Reports$Disputes$updateUrl(newModel)
                ])), _List_Nil);
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        b3: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    b3: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 4:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    b3: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
                    $author$project$Components$Reports$Disputes$updateUrl(newModel)
                ])), _List_Nil);
            case 5:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Disputes$fetchDisputes, apiClient, newModel),
                    $author$project$Components$Reports$Disputes$updateUrl(newModel)
                ])), _List_Nil);
            case 6:
                var subMsg = msg.a;
                var _v6 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v6.a;
                var subCmd = _v6.b;
                var subOutMsg = _v6.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$ExportCsvMsg, subCmd), subOutMsg);
            case 7:
                var dispute = msg.a;
                var _v7 = A3($author$project$Components$DisputeModal$init, $author$project$Api$Data$providerPath, apiClient, $author$project$Api$Provider$Reports$Dispute$id(dispute));
                var disputeModal = _v7.a;
                var disputeModalCmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    fB: $elm$core$Maybe$Just(disputeModal)
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DisputeModalMsg, disputeModalCmd), _List_Nil);
            case 8:
                return _Utils_Tuple3(_Utils_update(model, {
                    fB: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v8 = model.fB;
                if (!_v8.$) {
                    var disputeModal = _v8.a;
                    var _v9 = A2($author$project$Components$DisputeModal$update, subMsg, disputeModal);
                    var newDisputeModal = _v9.a;
                    var disputeModalCmd = _v9.b;
                    var disputeModalOutMsgs = _v9.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        fB: $elm$core$Maybe$Just(newDisputeModal)
                    }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Disputes$DisputeModalMsg, disputeModalCmd), disputeModalOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$Reports$Disputes$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$Disputes$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$Disputes$PaginationMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$Disputes$intFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$Disputes$None = {
        $: 1
    };
    var $author$project$Components$Reports$Disputes$Status = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$Disputes$StatusFiltered = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$Disputes$statusDropdownOptions = function(currentStatus) {
        var statusOptions = A2($elm$core$List$map, function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Disputes$StatusFiltered($author$project$Components$Reports$Disputes$Status(status))),
                $author$project$Ui$Dropdown$selected(_Utils_eq($elm$core$Maybe$Just(status), currentStatus))
            ]), $elm$html$Html$text($author$project$Formatters$String$humanize(status)));
        }, _List_fromArray([
            'created',
            'action_required',
            'processing',
            'won',
            'lost'
        ]));
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Disputes$StatusFiltered($author$project$Components$Reports$Disputes$None)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatus, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Filter')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, statusOptions));
    };
    var $author$project$Components$Reports$Disputes$viewStatusDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'All Status', A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, model.ahy)))
        ]), $author$project$Components$Reports$Disputes$statusDropdownOptions(model.ahy), model.oD);
    };
    var $author$project$Components$Reports$Disputes$SortTable = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$Disputes$OpenDisputeModal = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$Dispute$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$Dispute$dueDate = function(_v0) {
        var record = _v0;
        return record.Ok;
    };
    var $author$project$Api$Provider$Reports$Dispute$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$Reports$Dispute$reasonCode = function(_v0) {
        var record = _v0;
        return record.Yc;
    };
    var $author$project$Api$Provider$Reports$Dispute$reasonDescription = function(_v0) {
        var record = _v0;
        return record.Yd;
    };
    var $author$project$Api$Provider$Reports$Dispute$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Components$Reports$Disputes$viewRow = F3(function(isHintAdmin, isPracticeAdmin, dispute) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$Dispute$dueDate(dispute)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Dispute$amountInCents(dispute)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = $author$project$Api$Provider$Reports$Dispute$reasonDescription(dispute);
                    if (!_v0.$) {
                        var reasonDescription = _v0.a;
                        return A3($author$project$Ui$Tooltip$view, _List_fromArray([
                            $author$project$Ui$Tooltip$placement(0)
                        ]), reasonDescription, _List_fromArray([
                            A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$Dispute$reasonCode(dispute))
                        ]));
                    } else return A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$Dispute$reasonCode(dispute));
                }()
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$Dispute$status(dispute))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$colspan(2),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, isHintAdmin, isHintAdmin, dispute, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Dispute$paymentProcessor, $elm$core$Maybe$Just))),
                function() {
                    var _v1 = _Utils_Tuple2($author$project$Api$Provider$Reports$Dispute$paymentProcessor(dispute), isPracticeAdmin);
                    if (_v1.a === 'rainforest' && _v1.b) return A3($author$project$Ui$Button$view, {
                        abP: 'View dispute'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$Reports$Disputes$OpenDisputeModal(dispute))
                    ]), _List_fromArray([
                        $elm$html$Html$text('View Dispute')
                    ]));
                    else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    });
    var $author$project$Components$Reports$Disputes$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.b3;
            if (_v1.$ === 3) {
                var disputes_ = _v1.a;
                return _Utils_Tuple2(false, disputes_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var disputes = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$Disputes$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$Disputes$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A2($author$project$Components$Reports$Disputes$viewRow, model.F3, model.F4), disputes), _List_Nil);
    };
    var $author$project$Components$Reports$Disputes$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$Disputes$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.b3)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Dispute$listOptionsToParams, $author$project$Components$Reports$Disputes$fetchDisputesParams)(model))
            ]), model.md)),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, $author$project$Components$DisputeModal$view($author$project$Components$Reports$Disputes$CloseDisputeModal), model.fB)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Disputes')
                    ])),
                    $author$project$Ui$Typography$heading(function() {
                        var _v0 = model.b3;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-amount'))),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$muted,
                                    $author$project$Ui$Typography$small
                                ]), _List_fromArray([
                                    $elm$html$Html$text(' after ' + ($author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-fee-amount')) + (' in transaction fees across ' + A2($author$project$Formatters$String$pluralize, 'dispute', A2($author$project$Components$Reports$Disputes$intFromHeader, headers, 'x-total-count')))))
                                ]))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
                            ]))
                        ]);
                    }()),
                    A2($elm$html$Html$map, $author$project$Components$Reports$Disputes$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6)),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(5),
                            $author$project$Ui$Grid$spanSm(3),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Disputes$viewStatusDropdown(model)
                        ]))
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$Disputes$viewTable(model)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$Disputes$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.b3)))
                    ]), model.af_))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Reports$Disputes$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$Disputes$view, model.Ej, model.jQ)),
            $2: 'Reports | Disputes'
        };
    };
    var $author$project$Pages$Reports$Disputes$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Disputes$init,
        aeR: $author$project$Pages$Reports$Disputes$load,
        ag3: $author$project$Pages$Reports$Disputes$save,
        ahE: $author$project$Pages$Reports$Disputes$subscriptions,
        aaO: $author$project$Pages$Reports$Disputes$update,
        aid: $author$project$Pages$Reports$Disputes$view
    });
    var $author$project$Pages$Reports$Invoices$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$Invoices$AutopayDropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$CustomerInvoice = 12;
    var $author$project$Components$Reports$Invoices$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$StatusDropdownMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$Disabled = 1;
    var $author$project$Components$Reports$Invoices$Enabled = 0;
    var $author$project$Components$Reports$Invoices$autopayStatusFromString = function(string) {
        switch(string){
            case 'enabled':
                return $elm$core$Maybe$Just(0);
            case 'disabled':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Reports$Invoices$additionalMonthOptions = function(currentDate) {
        return _List_fromArray([
            A4($author$project$Components$DateRangeInput$additionalItem, 'upcoming', 'Upcoming', $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, 1, currentDate)), $elm$core$Maybe$Nothing),
            A4($author$project$Components$DateRangeInput$additionalItem, 'date_under_30_days', '< 30 Days', $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, -29, currentDate)), $elm$core$Maybe$Just(currentDate)),
            A4($author$project$Components$DateRangeInput$additionalItem, 'date_30_to_59_days', '30 - 59 Days', $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, -59, currentDate)), $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, -30, currentDate))),
            A4($author$project$Components$DateRangeInput$additionalItem, 'date_60_plus_days', '60+ Days', $elm$core$Maybe$Nothing, $elm$core$Maybe$Just(A3($justinmimbs$date$Date$add, 3, -60, currentDate)))
        ]);
    };
    var $author$project$Components$Reports$Invoices$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            kW: $author$project$Components$Reports$Invoices$additionalMonthOptions,
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$Invoices$GotCustomerInvoices = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$autopayFromString = function(string) {
        switch(string){
            case 'disabled':
                return $elm$core$Maybe$Just(false);
            case 'enabled':
                return $elm$core$Maybe$Just(true);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Reports$Invoices$autopayStatusToString = function(autopay) {
        if (!autopay) return 'enabled';
        else return 'disabled';
    };
    var $author$project$Components$Reports$Invoices$invoiceStatusToString = function(status) {
        switch(status){
            case 0:
                return 'draft';
            case 1:
                return 'issued';
            case 2:
                return 'issued,sent,retrying';
            case 3:
                return 'paid';
            case 4:
                return 'sent';
            case 5:
                return 'retrying';
            case 6:
                return 'cancelled';
            case 7:
                return 'bad_debt';
            default:
                return 'disputed';
        }
    };
    var $author$project$Components$Reports$Invoices$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                JY: A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$autopayStatusToString, $author$project$Components$Reports$Invoices$autopayFromString), model.JY),
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                af_: model.af_,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ahy: A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$invoiceStatusToString, $elm$core$String$split(',')), model.ahy)
            });
        };
    };
    var $author$project$Components$Reports$Invoices$fetchInvoices = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$CustomerInvoice$list, apiClient, $author$project$Components$Reports$Invoices$fetchParams(model), $author$project$Components$Reports$Invoices$GotCustomerInvoices);
    });
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed = {
        $: 0
    };
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$init = $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed;
    var $author$project$Components$Reports$Invoices$initColumns = function(trackPatientsByLocation) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'date', true, 'Date'),
                A3($author$project$Api$Column$init, 'invoice_number', true, 'Invoice Number'),
                A3($author$project$Api$Column$init, 'status', true, 'Invoice Status'),
                A3($author$project$Api$Column$init, 'total_in_cents', true, 'Billed'),
                A3($author$project$Api$Column$init, 'paid_in_cents', true, 'Paid'),
                A3($author$project$Api$Column$init, 'due_in_cents', true, 'Due'),
                A3($author$project$Api$Column$init, 'owner', true, 'Payer')
            ]),
            trackPatientsByLocation ? _List_fromArray([
                A3($author$project$Api$Column$init, 'location', true, 'Location')
            ]) : _List_Nil
        ]));
    };
    var $author$project$Components$Reports$Invoices$BadDebt = 7;
    var $author$project$Components$Reports$Invoices$Cancelled = 6;
    var $author$project$Components$Reports$Invoices$Disputed = 8;
    var $author$project$Components$Reports$Invoices$Draft = 0;
    var $author$project$Components$Reports$Invoices$Issued = 1;
    var $author$project$Components$Reports$Invoices$Outstanding = 2;
    var $author$project$Components$Reports$Invoices$Paid = 3;
    var $author$project$Components$Reports$Invoices$Retrying = 5;
    var $author$project$Components$Reports$Invoices$Sent = 4;
    var $author$project$Components$Reports$Invoices$invoiceStatusFromString = function(string) {
        switch(string){
            case 'draft':
                return $elm$core$Maybe$Just(0);
            case 'issued':
                return $elm$core$Maybe$Just(1);
            case 'issued,sent,retrying':
                return $elm$core$Maybe$Just(2);
            case 'paid':
                return $elm$core$Maybe$Just(3);
            case 'sent':
                return $elm$core$Maybe$Just(4);
            case 'retrying':
                return $elm$core$Maybe$Just(5);
            case 'cancelled':
                return $elm$core$Maybe$Just(6);
            case 'bad_debt':
                return $elm$core$Maybe$Just(7);
            case 'disputed':
                return $elm$core$Maybe$Just(8);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Reports$Invoices$urlFromModel = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('location'), model.Tp),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('status'), $author$project$Components$Reports$Invoices$invoiceStatusToString), model.ahy),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('autopay'), $author$project$Components$Reports$Invoices$autopayStatusToString), model.JY)
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Invoices)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Components$Reports$Invoices$init = F4(function(session, practice, _v0, query) {
        var currentDate = _v0.cP;
        var timeFormatter = _v0.HO;
        var apiClient = _v0.Ej;
        var url = _v0.aaT;
        var hinterViewOff = _v0.aeb;
        var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var _v1 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, true, locationGroupId, locationId, $elm$core$Maybe$Nothing);
        var groupLocationAndPractitionerFilters = _v1.a;
        var groupLocationAndPractitionerFiltersCmd = _v1.b;
        var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v2.a;
        var end = _v2.b;
        var _v3 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$Invoices$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v3.a;
        var dateRangeInputCmd = _v3.b;
        var model = {
            JY: A2($elm$core$Maybe$andThen, $author$project$Components$Reports$Invoices$autopayStatusFromString, A2($elm$core$Dict$get, 'autopay', query)),
            lb: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'autopay-dropdown',
                ahX: $author$project$Components$Reports$Invoices$AutopayDropdownMsg
            })),
            pJ: false,
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            LC: $author$project$Components$Reports$Invoices$initColumns(trackPatientsByLocation),
            cP: currentDate,
            lM: $author$project$Components$CustomerEmailModal$init,
            lO: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$init,
            cR: $author$project$Api$Data$Loading,
            h6: dateRangeInput,
            it: $author$project$Components$Invoice$DownloadFile$init(url),
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 12
            }),
            b8: groupLocationAndPractitionerFilters,
            f0: locationGroupId,
            Tp: locationId,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            GX: $author$project$Api$Provider$Practice$One$deactivated(practice),
            Z$: session,
            ahs: A3($author$project$Api$Sort$withDefault, 'date', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            ahy: A2($elm$core$Maybe$andThen, $author$project$Components$Reports$Invoices$invoiceStatusFromString, A2($elm$core$Dict$get, 'status', query)),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'status-dropdown',
                ahX: $author$project$Components$Reports$Invoices$StatusDropdownMsg
            })),
            HO: timeFormatter,
            aaq: trackPatientsByLocation
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, model),
            $author$project$Ports$Navigation$replaceUrl($author$project$Components$Reports$Invoices$urlFromModel(model))
        ])));
    });
    var $author$project$Pages$Reports$Invoices$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A4($author$project$Components$Reports$Invoices$init, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$Invoices$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Invoices$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$Invoices$CustomerEmailModalMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$DownloadInvoiceMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$ExportCsvMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close = {
        $: 2
    };
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$subscriptions = function(model) {
        if (model.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Components$Reports$Invoices$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Invoices$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Invoices$CustomerEmailModalMsg, $author$project$Components$CustomerEmailModal$subscriptions(model.lM)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg, $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$subscriptions(model.lO)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Invoices$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Invoices$DownloadInvoiceMsg, $author$project$Components$Invoice$DownloadFile$subscriptions(model.it)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b8)),
            $author$project$Ui$Dropdown$subscriptions(model.oD),
            $author$project$Ui$Dropdown$subscriptions(model.lb)
        ]));
    };
    var $author$project$Pages$Reports$Invoices$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$Invoices$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$Invoices$BulkIssueTriggered = {
        $: 12
    };
    var $author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'customer_invoices',
        'bulk'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$CustomerInvoice$Bulk$issue = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'issue'
        ]), $author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath))));
    });
    var $author$project$Components$Reports$Invoices$issueInvoices = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$CustomerInvoice$Bulk$issue, apiClient, $author$project$Components$Reports$Invoices$fetchParams(model), $elm$core$Basics$always($author$project$Components$Reports$Invoices$BulkIssueTriggered));
    });
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsStarted = 1;
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$None = 0;
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$CustomerInvoice$Bulk$processPayments = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'process_payments'
        ]), $author$project$Api$Provider$CustomerInvoice$Bulk$bulkPath))));
    });
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$update = F2(function(msg, model) {
        if (model.$ === 1) {
            var open = model.a;
            switch(msg.$){
                case 2:
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Closed,
                        at: _List_Nil
                    };
                case 0:
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: model,
                        at: _List_Nil
                    };
                default:
                    return {
                        EQ: A3($author$project$Api$Provider$CustomerInvoice$Bulk$processPayments, open.Ej, open.VU, $elm$core$Basics$always($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)),
                        adu: 1,
                        zi: model,
                        at: _List_fromArray([
                            A2($author$project$OutMsg$ShowToast, 3, 'Bulk process payments started. This may take a while to process.')
                        ])
                    };
            }
        } else {
            if (!msg.$) {
                var apiClient = msg.a;
                var params = msg.b;
                var totalCount = msg.c;
                var status = msg.d;
                var start = msg.e;
                var end = msg.f;
                var currentDate = msg.g;
                var open = {
                    Ej: apiClient,
                    cP: currentDate,
                    Fn: end,
                    VU: params,
                    HB: start,
                    ahy: status,
                    oQ: totalCount
                };
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Open(open),
                    at: _List_Nil
                };
            } else return {
                EQ: $elm$core$Platform$Cmd$none,
                adu: 0,
                zi: model,
                at: _List_Nil
            };
        }
    });
    var $author$project$Components$Reports$Invoices$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v1.a;
                var subCmd = _v1.b;
                var event = _v1.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            cR: $author$project$Api$Data$Loading,
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b8);
                var _v3 = result.adu;
                switch(_v3.$){
                    case 0:
                        var locationGroupId = _v3.a;
                        var locationId = _v3.b;
                        var newModel = _Utils_update(model, {
                            cR: $author$project$Api$Data$Loading,
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            af_: $author$project$Api$Pagination$reset(model.af_)
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 2:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), cmd, _List_Nil);
            case 3:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    cR: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    ahy: status
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.lb);
                var autopayDropdown = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    lb: autopayDropdown
                }), cmd, _List_Nil);
            case 5:
                var autopay = msg.a;
                var newModel = _Utils_update(model, {
                    JY: autopay,
                    cR: $author$project$Api$Data$Loading,
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 6:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        pJ: false,
                        cR: response,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    cR: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    cR: $author$project$Api$Data$Loading,
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 8:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Invoices$fetchInvoices, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Invoices$urlFromModel, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v7 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v7.a;
                var subCmd = _v7.b;
                var subOutMsg = _v7.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$ExportCsvMsg, subCmd), subOutMsg);
            case 10:
                var subMsg = msg.a;
                var _v8 = A3($author$project$Components$CustomerEmailModal$update, apiClient, subMsg, model.lM);
                var customerEmailModal = _v8.a;
                var subCmd = _v8.b;
                var subOutMsg = _v8.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    lM: customerEmailModal
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$CustomerEmailModalMsg, subCmd), subOutMsg);
            case 11:
                var subMsg = msg.a;
                var downloadInvoiceResult = A3($author$project$Components$Invoice$DownloadFile$update, apiClient, subMsg, model.it);
                return _Utils_Tuple3(_Utils_update(model, {
                    it: downloadInvoiceResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$DownloadInvoiceMsg, downloadInvoiceResult.EQ), downloadInvoiceResult.at);
            case 13:
                return _Utils_Tuple3(_Utils_update(model, {
                    pJ: true
                }), A2($author$project$Components$Reports$Invoices$issueInvoices, apiClient, model), _List_Nil);
            case 12:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Bulk issue invoices started. This may take a while to process.')
                ]));
            default:
                var subMsg = msg.a;
                var customerInvoiceBulkPaymentModalResult = A2($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$update, subMsg, model.lO);
                return _Utils_Tuple3(_Utils_update(model, {
                    lO: customerInvoiceBulkPaymentModalResult.zi
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg, customerInvoiceBulkPaymentModalResult.EQ), customerInvoiceBulkPaymentModalResult.at);
        }
    });
    var $author$project$Pages$Reports$Invoices$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$Invoices$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$Invoices$PaginationMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$intFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$Invoices$IssueButtonClicked = {
        $: 13
    };
    var $author$project$Components$Reports$Invoices$viewIssueButton = function(bulkIssueTriggered) {
        return bulkIssueTriggered ? $author$project$Utils$Html$empty : A3($author$project$Ui$Button$view, {
            abP: 'Issue invoices'
        }, _List_fromArray([
            $author$project$Ui$Button$primary,
            $author$project$Ui$Button$pull(1),
            $author$project$Ui$Button$onClick($author$project$Components$Reports$Invoices$IssueButtonClicked)
        ]), _List_fromArray([
            $elm$html$Html$text('Issue Invoices')
        ]));
    };
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$OpenModal = F7(function(a, b, c, d, e, f, g) {
        return {
            $: 0,
            a: a,
            b: b,
            c: c,
            d: d,
            e: e,
            f: f,
            g: g
        };
    });
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$button = F7(function(apiClient, params, totalCount, status, start, end, currentDate) {
        return A3($author$project$Ui$Button$view, {
            abP: 'Process payments'
        }, _List_fromArray([
            $author$project$Ui$Button$success,
            $author$project$Ui$Button$pull(1),
            $author$project$Ui$Button$onClick(A7($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$OpenModal, apiClient, params, totalCount, status, start, end, currentDate))
        ]), _List_fromArray([
            $elm$html$Html$text('$ Process Payments')
        ]));
    });
    var $author$project$Components$Reports$Invoices$viewProcessPaymentsButton = F2(function(apiClient, model) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg, A7($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$button, apiClient, $author$project$Components$Reports$Invoices$fetchParams(model), $author$project$Api$Pagination$headerTotalCount(model.af_), A2($elm$core$Maybe$map, $author$project$Components$Reports$Invoices$invoiceStatusToString, model.ahy), model.HB, model.Fn, model.cP));
    });
    var $author$project$Components$Reports$Invoices$issueOrProcessPaymentButton = F2(function(apiClient, model) {
        var anyInvoices = function() {
            var _v6 = model.cR;
            if (_v6.$ === 3) {
                var customerInvoices = _v6.a;
                return !$elm$core$List$isEmpty(customerInvoices);
            } else return false;
        }();
        var _v0 = _Utils_Tuple2(model.ahy, anyInvoices);
        _v0$5: while(true){
            if (!_v0.a.$ && _v0.b) switch(_v0.a.a){
                case 0:
                    var _v1 = _v0.a.a;
                    return $author$project$Components$Reports$Invoices$viewIssueButton(model.pJ);
                case 1:
                    var _v2 = _v0.a.a;
                    return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
                case 4:
                    var _v3 = _v0.a.a;
                    return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
                case 5:
                    var _v4 = _v0.a.a;
                    return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
                case 2:
                    var _v5 = _v0.a.a;
                    return A2($author$project$Components$Reports$Invoices$viewProcessPaymentsButton, apiClient, model);
                default:
                    break _v0$5;
            }
            else break _v0$5;
        }
        return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsClicked = {
        $: 1
    };
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$formatDateRange = F3(function(start, end, currentDate) {
        var startDate = function() {
            if (!start.$) {
                var date = start.a;
                return A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, A3($author$project$Utils$DateWithDefault$toDate, currentDate, 0, date));
            } else return '';
        }();
        var endDate = function() {
            if (!end.$) {
                var date = end.a;
                return A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, A3($author$project$Utils$DateWithDefault$toDate, currentDate, 0, date));
            } else return '';
        }();
        var _v0 = _Utils_Tuple2($elm$core$String$isEmpty(startDate), $elm$core$String$isEmpty(endDate));
        if (_v0.a) {
            if (!_v0.b) return $elm$html$Html$text(' < ' + endDate);
            else return $elm$html$Html$text('All Dates');
        } else {
            if (!_v0.b) return $elm$html$Html$text(startDate + (' - ' + endDate));
            else return $elm$html$Html$text(startDate + ' > ');
        }
    });
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$viewMovePaymentMethodsModal = function(open) {
        return A2($author$project$Ui$Form$view, _List_fromArray([
            $author$project$Ui$Form$horizontal,
            $author$project$Ui$Form$noValidate(true),
            $author$project$Ui$Form$autocomplete(true),
            $author$project$Ui$Form$onSubmit($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)
        ]), _List_fromArray([
            A3($author$project$Ui$Modal$view, $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close, _List_Nil, _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Process Payments')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpanSm(3),
                            $author$project$Ui$Form$Group$inputSpanSm(9),
                            $author$project$Ui$Form$Group$label('Enabled Filters')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
                                    A3($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$formatDateRange, open.HB, open.Fn, open.cP)
                                ])),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$capitalized
                                ]), _List_fromArray([
                                    function() {
                                        var _v0 = open.ahy;
                                        if (!_v0.$) {
                                            var status = _v0.a;
                                            return $elm$html$Html$text(A2($elm$core$String$join, ', ', A2($elm$core$String$split, ',', status)));
                                        } else return $elm$html$Html$text('');
                                    }()
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$labelSpanSm(3),
                            $author$project$Ui$Form$Group$inputSpanSm(9),
                            $author$project$Ui$Form$Group$label('Invoices to Process')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$bold
                                ]), _List_fromArray([
                                    $elm$html$Html$text($elm$core$String$fromInt(open.oQ) + ' patient invoices')
                                ]))
                            ]))
                        ])),
                        A2($author$project$Ui$Alert$info, _List_fromArray([
                            $author$project$Ui$Alert$margin(20),
                            $author$project$Ui$Alert$margin(2),
                            $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$alert(_List_fromArray([
                                $author$project$Ui$Icon$xl
                            ])),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$black,
                                $author$project$Ui$Typography$margin(10)
                            ]), _List_fromArray([
                                $elm$html$Html$text('You will receive an email notification for payments that fail to process.')
                            ]))
                        ]))
                    ]))
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Cancel and close modal'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$Close)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Cancel')
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Process payments'
                        }, _List_fromArray([
                            $author$project$Ui$Button$success,
                            $author$project$Ui$Button$submit,
                            $author$project$Ui$Button$onClick($author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$BulkProcessPaymentsClicked),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$bolt)
                        ]), _List_fromArray([
                            $elm$html$Html$text(' Process ' + ($elm$core$String$fromInt(open.oQ) + ' payments'))
                        ]))
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$modal = function(model) {
        if (model.$ === 1) {
            var open = model.a;
            return $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$viewMovePaymentMethodsModal(open);
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Reports$Invoices$AutopaySelected = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$autopayToDisplayName = function(autopay) {
        if (!autopay) return 'Autopay Enabled';
        else return 'Autopay Disabled';
    };
    var $author$project$Components$Reports$Invoices$autopayDropdownItems = function(current) {
        var toItem = function(autopay) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Invoices$AutopaySelected($elm$core$Maybe$Just(autopay))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(current, $elm$core$Maybe$Just(autopay)))
            ]), $elm$html$Html$text($author$project$Components$Reports$Invoices$autopayToDisplayName(autopay)));
        };
        return _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Invoices$AutopaySelected($elm$core$Maybe$Nothing)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(current, $elm$core$Maybe$Nothing))
            ]), $elm$html$Html$text('All Autopay')),
            $author$project$Ui$Dropdown$separator,
            toItem(0),
            toItem(1)
        ]);
    };
    var $author$project$Components$Reports$Invoices$viewAutopayDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.JY;
            if (!_v0.$) {
                var autopay = _v0.a;
                return $author$project$Components$Reports$Invoices$autopayToDisplayName(autopay);
            } else return 'Autopay';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), $author$project$Components$Reports$Invoices$autopayDropdownItems(model.JY), model.lb);
    };
    var $author$project$Components$Reports$Invoices$StatusSelected = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$Invoices$statusToDisplayName = function(status) {
        switch(status){
            case 0:
                return 'Draft';
            case 1:
                return 'Issued (Not Sent)';
            case 2:
                return 'Outstanding (Issued, Sent, Retrying)';
            case 3:
                return 'Paid';
            case 4:
                return 'Sent';
            case 5:
                return 'Retrying';
            case 6:
                return 'Cancelled';
            case 7:
                return 'Bad Debt';
            default:
                return 'Disputed';
        }
    };
    var $author$project$Components$Reports$Invoices$statusDropdownItems = function(current) {
        var toItem = function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Invoices$StatusSelected($elm$core$Maybe$Just(status))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(current, $elm$core$Maybe$Just(status)))
            ]), $elm$html$Html$text($author$project$Components$Reports$Invoices$statusToDisplayName(status)));
        };
        return _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Invoices$StatusSelected($elm$core$Maybe$Nothing)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(current, $elm$core$Maybe$Nothing))
            ]), $elm$html$Html$text('All Statuses')),
            $author$project$Ui$Dropdown$separator,
            toItem(0),
            toItem(1),
            toItem(2),
            $author$project$Ui$Dropdown$separator,
            toItem(3),
            toItem(4),
            toItem(5),
            toItem(6),
            toItem(7),
            toItem(8)
        ]);
    };
    var $author$project$Components$Reports$Invoices$viewStatusDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.ahy;
            if (!_v0.$) {
                var status = _v0.a;
                return $author$project$Components$Reports$Invoices$statusToDisplayName(status);
            } else return 'Status';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), $author$project$Components$Reports$Invoices$statusDropdownItems(model.ahy), model.oD);
    };
    var $author$project$Components$Reports$Invoices$SortTable = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$ReportsPatient = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Table$Warning = 3;
    var $author$project$Api$Provider$Reports$CustomerInvoice$creditInCents = function(_v0) {
        var record = _v0;
        return record.MD;
    };
    var $author$project$Components$CustomerEmailModal$Disabled = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$CustomerEmailModal$disabled = $author$project$Components$CustomerEmailModal$Disabled;
    var $author$project$Api$Provider$Reports$CustomerInvoice$dueDate = function(_v0) {
        var record = _v0;
        return record.Ok;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$dueInCents = function(_v0) {
        var record = _v0;
        return record.Ol;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$humanStatus = function(_v0) {
        var record = _v0;
        return record.QX;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber = function(_v0) {
        var record = _v0;
        return record.RK;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$isCustomerViewable = function(_v0) {
        var record = _v0;
        return record.R_;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$isPastDue = function(_v0) {
        var record = _v0;
        return record.Sg;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$isPaymentScheduled = function(_v0) {
        var record = _v0;
        return record.Si;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents = function(_v0) {
        var record = _v0;
        return record.SH;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$lastSentAt = function(_v0) {
        var record = _v0;
        return record.SY;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$location = function(_v0) {
        var record = _v0;
        return record.aeT;
    };
    var $author$project$Api$Provider$Reports$Patient$onePhoneNumber = function(_v0) {
        var record = _v0;
        return record.WF;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$owner = function(_v0) {
        var record = _v0;
        return record.VM;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$paidAt = function(_v0) {
        var record = _v0;
        return record.VQ;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$paidInCents = function(_v0) {
        var record = _v0;
        return record.VR;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$paymentScheduledOn = function(_v0) {
        var record = _v0;
        return record.Wq;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$securePdfInlineToken = function(_v0) {
        var record = _v0;
        return record.ZC;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Reports$CustomerInvoice$totalInCents = function(_v0) {
        var record = _v0;
        return record.aam;
    };
    var $author$project$Components$Reports$Invoices$viewRow = F2(function(model, customerInvoice) {
        var isPastDue = $author$project$Api$Provider$Reports$CustomerInvoice$isPastDue(customerInvoice);
        return A2($author$project$Ui$Table$row, isPastDue ? _List_fromArray([
            $author$project$Ui$Table$styled(3)
        ]) : _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, isPastDue ? _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]) : _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$CustomerInvoice$dueDate(customerInvoice)))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, function() {
                    var _v0 = _Utils_Tuple2(model.EF, $author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice));
                    if (_v0.a && !_v0.b.$) {
                        var owner = _v0.b.a;
                        return _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                RI: $author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice),
                                V8: $author$project$Api$Provider$Reports$Patient$oneId(owner)
                            }), _List_Nil, _List_fromArray([
                                $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber(customerInvoice)))
                            ]))
                        ]);
                    } else return _List_fromArray([
                        $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Provider$Reports$CustomerInvoice$invoiceNumber(customerInvoice)))
                    ]);
                }()),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    function() {
                        var _v1 = _Utils_Tuple2(model.EF, $author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice));
                        if (_v1.a && !_v1.b.$) {
                            var owner = _v1.b.a;
                            return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                RI: $author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice),
                                V8: $author$project$Api$Provider$Reports$Patient$oneId(owner)
                            }), _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice))
                            ]));
                        } else return A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice));
                    }(),
                    $author$project$Api$Provider$Reports$CustomerInvoice$isPaymentScheduled(customerInvoice) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(' scheduled for ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Reports$CustomerInvoice$paymentScheduledOn(customerInvoice))))
                    ])) : $author$project$Api$Provider$Reports$CustomerInvoice$status(customerInvoice) === 'sent' ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(' on ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, model.HO(5), $author$project$Api$Provider$Reports$CustomerInvoice$lastSentAt(customerInvoice))))
                    ])) : $author$project$Api$Provider$Reports$CustomerInvoice$humanStatus(customerInvoice) === 'paid' ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small
                    ]), _List_fromArray([
                        $elm$html$Html$text(' on ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, model.HO(5), $author$project$Api$Provider$Reports$CustomerInvoice$paidAt(customerInvoice))))
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $author$project$Api$Provider$Reports$CustomerInvoice$status(customerInvoice) === 'draft' ? A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice)))
                    ])) : A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        !_Utils_eq($author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice), $author$project$Api$Provider$Reports$CustomerInvoice$totalInCents(customerInvoice)) ? A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$CustomerInvoice$issuedTotalInCents(customerInvoice)))
                        ])) : $author$project$Utils$Html$empty,
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$CustomerInvoice$totalInCents(customerInvoice)))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$CustomerInvoice$paidInCents(customerInvoice) + $author$project$Api$Provider$Reports$CustomerInvoice$creditInCents(customerInvoice)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$CustomerInvoice$dueInCents(customerInvoice)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, function() {
                    var _v2 = $author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice);
                    if (!_v2.$) {
                        var owner = _v2.a;
                        return _List_fromArray([
                            model.EF ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                V8: $author$project$Api$Provider$Reports$Patient$oneId(owner)
                            }), _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Provider$Reports$Patient$oneName(owner))
                                ]))
                            ])) : A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Reports$Patient$oneName(owner))
                            ])),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            function() {
                                var _v3 = $author$project$Api$Provider$Reports$Patient$oneEmail(owner);
                                if (!_v3.$) {
                                    var email = _v3.a;
                                    return A3($author$project$Ui$Link$mailto, email, _List_fromArray([
                                        $author$project$Ui$Link$targetBlank
                                    ]), _List_fromArray([
                                        A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$phi(true)
                                        ]), _List_fromArray([
                                            $elm$html$Html$text(email)
                                        ]))
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Phone$format, $author$project$Api$Provider$Reports$Patient$onePhoneNumber(owner))))
                            ]))
                        ]);
                    } else return _List_Nil;
                }())
            ]),
            model.aaq ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$Reports$CustomerInvoice$location(customerInvoice))))
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(2)
                ]), $author$project$Api$Provider$Reports$CustomerInvoice$isCustomerViewable(customerInvoice) ? _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$gap2,
                        $author$project$Ui$Element$flexCol,
                        $author$project$Ui$Element$itemsEnd
                    ]), _List_fromArray([
                        function() {
                            var _v4 = $author$project$Api$Provider$Reports$CustomerInvoice$owner(customerInvoice);
                            if (!_v4.$) {
                                var owner = _v4.a;
                                return A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$CustomerEmailModalMsg, A5($author$project$Components$CustomerEmailModal$button, model.Z$, _List_fromArray([
                                    $author$project$Components$CustomerEmailModal$disabled(model.GX)
                                ]), 0, $author$project$Api$Provider$Reports$CustomerInvoice$id(customerInvoice), $author$project$Components$CustomerEmailModal$ReportsPatient(owner)));
                            } else return $author$project$Utils$Html$empty;
                        }(),
                        A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$DownloadInvoiceMsg, A4($author$project$Components$Invoice$DownloadFile$view, model.it, $author$project$Api$Provider$Reports$CustomerInvoice$securePdfInlineToken(customerInvoice), _List_Nil, _List_fromArray([
                            $author$project$Ui$Button$sm
                        ])))
                    ]))
                ]) : _List_Nil)
            ])
        ])));
    });
    var $author$project$Components$Reports$Invoices$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.cR;
            if (_v1.$ === 3) {
                var invoices_ = _v1.a;
                return _Utils_Tuple2(false, invoices_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var customerInvoices = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$Invoices$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, $author$project$Components$Reports$Invoices$viewRow(model), customerInvoices), _List_Nil);
    };
    var $author$project$Components$Reports$Invoices$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.cR)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$CustomerInvoice$listOptionsToParams, $author$project$Components$Reports$Invoices$fetchParams)(model))
            ]), model.md)),
            A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$CustomerEmailModalMsg, $author$project$Components$CustomerEmailModal$modal(model.lM)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Patient Invoices')
                    ])),
                    A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$CustomerInvoiceBulkPaymentModalMsg, $author$project$Components$Reports$CustomerInvoiceBulkPaymentModal$modal(model.lO)),
                    A2($author$project$Components$Reports$Invoices$issueOrProcessPaymentButton, apiClient, model),
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.cR;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            var totalReceivableAmount = A2($author$project$Components$Reports$Invoices$intFromHeader, headers, 'x-total-receivable-amount');
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$Invoices$intFromHeader, headers, 'x-total-billed-amount'))),
                                totalReceivableAmount > 0 ? $author$project$Ui$Typography$headingSm(_List_fromArray([
                                    $elm$html$Html$text('Total Due: ' + $author$project$Utils$Currency$fromInt(totalReceivableAmount))
                                ])) : $author$project$Utils$Html$empty
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]);
                    }()),
                    A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6)),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$spanMd(4)
                    ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                        $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
                    ]), model.b8))), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanSm(4),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Invoices$viewStatusDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(5),
                            $author$project$Ui$Grid$spanSm(3),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Invoices$viewAutopayDropdown(model)
                        ]))
                    ]))),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Invoices$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b8));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$Invoices$viewTable(model)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$Invoices$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.cR)))
                    ]), model.af_))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Reports$Invoices$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$Invoices$view, model.Ej, model.jQ)),
            $2: 'Reports | Patient Invoices'
        };
    };
    var $author$project$Pages$Reports$Invoices$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Invoices$init,
        aeR: $author$project$Pages$Reports$Invoices$load,
        ag3: $author$project$Pages$Reports$Invoices$save,
        ahE: $author$project$Pages$Reports$Invoices$subscriptions,
        aaO: $author$project$Pages$Reports$Invoices$update,
        aid: $author$project$Pages$Reports$Invoices$view
    });
    var $author$project$Pages$Reports$Memberships$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$Memberships$AutopayDropdownMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$BillingPeriodDropdownMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$CouponResourceFilterMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$DateRangeInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$FilterDropdownMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$MembershipPatients = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$Model = $elm$core$Basics$identity;
    var $author$project$Components$Reports$Memberships$PlanResourceFilterMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$RateCalculationDropdownMsg = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$SourceStatusDropdownMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$AllAutopay = 0;
    var $author$project$Components$Reports$Memberships$AutopayDisabled = 2;
    var $author$project$Components$Reports$Memberships$AutopayEnabled = 1;
    var $author$project$Components$Reports$Memberships$autopayStatusFromQuery = function(queryString) {
        _v0$2: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'enabled':
                    return 1;
                case 'disabled':
                    return 2;
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return 0;
    };
    var $author$project$Components$Reports$Memberships$AllBillingPeriods = 0;
    var $author$project$Components$Reports$Memberships$Annually = 5;
    var $author$project$Components$Reports$Memberships$Monthly = 1;
    var $author$project$Components$Reports$Memberships$NonMonthly = 2;
    var $author$project$Components$Reports$Memberships$Quarterly = 3;
    var $author$project$Components$Reports$Memberships$SemiAnnually = 4;
    var $author$project$Components$Reports$Memberships$billingPeriodFromQuery = function(queryString) {
        _v0$5: while(true){
            if (!queryString.$) switch(queryString.a){
                case '1':
                    return 1;
                case '3,6,12':
                    return 2;
                case '3':
                    return 3;
                case '6':
                    return 4;
                case '12':
                    return 5;
                default:
                    break _v0$5;
            }
            else break _v0$5;
        }
        return 0;
    };
    var $author$project$Components$Reports$Memberships$filterTypeToValue = function(filterType) {
        switch(filterType){
            case 0:
                return 'unconfirmed';
            case 1:
                return 'starting';
            case 2:
                return 'ending';
            case 3:
                return 'current';
            case 4:
                return 'last_or_next_billing';
            case 5:
                return 'contracts_ending';
            default:
                return 'contracts_renewed';
        }
    };
    var $author$project$Components$Reports$Memberships$sourceStatusToValue = function(sourceStatus) {
        switch(sourceStatus){
            case 0:
                return '';
            case 1:
                return 'source_valid';
            case 2:
                return 'source_has_warning';
            default:
                return 'source_requires_action';
        }
    };
    var $author$project$Components$Reports$Memberships$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'filter', $author$project$Components$Reports$Memberships$filterTypeToValue(model.Fw))),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('location'), model.Tp),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('practitioner'), model.Xa),
            function() {
                var _v0 = model.pH;
                switch(_v0){
                    case 0:
                        return $elm$core$Maybe$Nothing;
                    case 1:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'period_in_months', '1'));
                    case 2:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'period_in_months', '3,6,12'));
                    case 3:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'period_in_months', '3'));
                    case 4:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'period_in_months', '6'));
                    default:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'period_in_months', '12'));
                }
            }(),
            function() {
                var _v1 = model.s1;
                if (!_v1) return $elm$core$Maybe$Nothing;
                else return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'source_status', $author$project$Components$Reports$Memberships$sourceStatusToValue(model.s1)));
            }(),
            function() {
                var _v2 = model.JY;
                switch(_v2){
                    case 0:
                        return $elm$core$Maybe$Nothing;
                    case 1:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'autopay', 'enabled'));
                    default:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'autopay', 'disabled'));
                }
            }(),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('plan'), model.agd),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('company'), model.fl),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('coupon'), model.dD),
            function() {
                var _v3 = model.Ha;
                switch(_v3){
                    case 0:
                        return $elm$core$Maybe$Nothing;
                    case 1:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'rate_calculation', 'auto_calculated'));
                    case 2:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'rate_calculation', 'overridden_off_rate'));
                    default:
                        return $elm$core$Maybe$Just(A2($elm$url$Url$Builder$string, 'rate_calculation', 'overridden_on_rate'));
                }
            }()
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Memberships)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Components$Reports$Memberships$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$Memberships$GotData = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                JY: function() {
                    var _v0 = model.JY;
                    switch(_v0){
                        case 0:
                            return $elm$core$Maybe$Nothing;
                        case 1:
                            return $elm$core$Maybe$Just(true);
                        default:
                            return $elm$core$Maybe$Just(false);
                    }
                }(),
                acy: model.fl,
                Mj: model.dD,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                Fw: $elm$core$Maybe$Just($author$project$Components$Reports$Memberships$filterTypeToValue(model.Fw)),
                aeT: model.Tp,
                rm: model.f0,
                af_: model.af_,
                WA: function() {
                    var _v1 = model.pH;
                    switch(_v1){
                        case 0:
                            return $elm$core$Maybe$Nothing;
                        case 1:
                            return $elm$core$Maybe$Just(_List_fromArray([
                                '1'
                            ]));
                        case 2:
                            return $elm$core$Maybe$Just(_List_fromArray([
                                '3',
                                '6',
                                '12'
                            ]));
                        case 3:
                            return $elm$core$Maybe$Just(_List_fromArray([
                                '3'
                            ]));
                        case 4:
                            return $elm$core$Maybe$Just(_List_fromArray([
                                '6'
                            ]));
                        default:
                            return $elm$core$Maybe$Just(_List_fromArray([
                                '12'
                            ]));
                    }
                }(),
                GW: model.agd,
                agi: model.Xa,
                Ha: function() {
                    var _v2 = model.Ha;
                    switch(_v2){
                        case 0:
                            return $elm$core$Maybe$Nothing;
                        case 1:
                            return $elm$core$Maybe$Just('auto_calculated');
                        case 2:
                            return $elm$core$Maybe$Just('overridden_off_rate');
                        default:
                            return $elm$core$Maybe$Just('overridden_on_rate');
                    }
                }(),
                ahs: model.ahs,
                s1: function() {
                    var _v3 = model.s1;
                    if (!_v3) return $elm$core$Maybe$Nothing;
                    else return $elm$core$Maybe$Just($author$project$Components$Reports$Memberships$sourceStatusToValue(model.s1));
                }(),
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$MembershipPatient = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$MembershipPatient$Record = F5(function(status, startDate, endDate, patient, membership) {
        return {
            qv: endDate,
            jc: membership,
            V7: patient,
            _0: startDate,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Reports$Membership$Membership = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Reports$Membership$One = 0;
    var $author$project$Api$Provider$Reports$Membership$OneRecord = function(lastBillAmountInCents) {
        return function(lastBillDate) {
            return function(startDate) {
                return function(endDate) {
                    return function(nextBillDate) {
                        return function(periodRateInCents) {
                            return function(periodInMonths) {
                                return function(sourceStatus) {
                                    return function(status) {
                                        return function(owner) {
                                            return function(plan) {
                                                return {
                                                    qv: endDate,
                                                    SO: lastBillAmountInCents,
                                                    SP: lastBillDate,
                                                    UY: nextBillDate,
                                                    VM: owner,
                                                    WA: periodInMonths,
                                                    WB: periodRateInCents,
                                                    GW: plan,
                                                    s1: sourceStatus,
                                                    _0: startDate,
                                                    ahy: status
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Reports$Patient$ForMembership = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Patient$ForMembershipRecord = F3(function(id, name, autopay) {
        return {
            JY: autopay,
            aef: id,
            zr: name
        };
    });
    var $author$project$Api$Provider$Reports$Patient$forMembershipRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'autopay', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Patient$ForMembershipRecord))));
    var $author$project$Api$Provider$Reports$Patient$forMembershipDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Patient$forMembershipRecordDecoder), $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Plan$Min$Plan = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Plan$Min$Record = F3(function(id, planType, name) {
        return {
            aef: id,
            zr: name,
            WN: planType
        };
    });
    var $author$project$Api$Provider$Reports$Plan$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan_type', $elm$json$Json$Decode$nullable($author$project$Api$PlanType$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Plan$Min$Record))));
    var $author$project$Api$Provider$Reports$Plan$Min$minDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Plan$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Membership$oneRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'plan', $author$project$Api$Provider$Reports$Plan$Min$minDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'owner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Patient$forMembershipDecoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'source_status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_in_months', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'period_rate_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'next_bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_bill_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_bill_amount_in_cents', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$int), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$OneRecord))))))))))));
    var $author$project$Api$Provider$Reports$Membership$oneDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded, 0, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Membership$oneRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$Membership)));
    var $author$project$Api$Provider$Reports$MembershipPatient$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership', $author$project$Api$Provider$Reports$Membership$oneDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$MembershipPatient$Record))))));
    var $author$project$Api$Provider$Reports$MembershipPatient$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$MembershipPatient$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$MembershipPatient$listDefaults = {
        JY: $elm$core$Maybe$Nothing,
        acy: $elm$core$Maybe$Nothing,
        Mj: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        Fw: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        WA: $elm$core$Maybe$Nothing,
        GW: $elm$core$Maybe$Nothing,
        agi: $elm$core$Maybe$Nothing,
        Ha: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'start_date', 0, $author$project$Api$Sort$init),
        s1: $elm$core$Maybe$Nothing,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$MembershipPatient$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Fw;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.HB;
                if (!_v1.$) {
                    var start_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fn;
                if (!_v2.$) {
                    var end_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.rm;
                if (!_v3.$) {
                    var locationGroup_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', locationGroup_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.aeT;
                if (!_v4.$) {
                    var location_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', location_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.agi;
                if (!_v5.$) {
                    var practitioner_ = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', practitioner_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.WA;
                if (!_v6.$) {
                    var list_ = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$list, 'period_in_months', list_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v7 = options.s1;
                if (!_v7.$) {
                    var string = _v7.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'source_status', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v8 = options.JY;
                if (!_v8.$) {
                    var bool = _v8.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'owner', A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([
                            _Utils_Tuple2('autopay', $elm$json$Json$Encode$bool(bool))
                        ]))))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v9 = options.GW;
                if (!_v9.$) {
                    var string = _v9.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'plan', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v10 = options.acy;
                if (!_v10.$) {
                    var string = _v10.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'company', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v11 = options.Ha;
                if (!_v11.$) {
                    var string = _v11.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'rate_calculation', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v12 = options.Mj;
                if (!_v12.$) {
                    var string = _v12.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'coupon', string)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'membership_patients'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$MembershipPatient$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$MembershipPatient$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$MembershipPatient$listPath)));
    });
    var $author$project$Components$Reports$Memberships$fetchMembershipPatients = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$MembershipPatient$list, apiClient, $author$project$Components$Reports$Memberships$fetchParams(model), A2($elm$core$Basics$composeL, $author$project$Components$Reports$Memberships$GotData, $author$project$Components$Reports$Memberships$MembershipPatients));
    });
    var $author$project$Components$Reports$Memberships$Memberships = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$Membership$All = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$Membership$AllRecord = function(membershipPatients) {
        return {
            T$: membershipPatients
        };
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$ForMembership = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$Record = function(patient) {
        return {
            V7: patient
        };
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $author$project$Api$Provider$Patient$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$MembershipPatient$ForMembership$Record));
    var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$Membership$allRecordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'membership_patients', $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$MembershipPatient$ForMembership$decoder), $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$AllRecord));
    var $author$project$Api$Provider$Reports$Membership$allDecoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Api$Provider$Reports$Membership$allRecordDecoder), A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$Membership$oneRecordDecoder, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$Membership$Membership)));
    var $author$project$Api$Provider$Reports$Membership$listDefaults = {
        JY: $elm$core$Maybe$Nothing,
        acy: $elm$core$Maybe$Nothing,
        Mj: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        Fw: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        WA: $elm$core$Maybe$Nothing,
        GW: $elm$core$Maybe$Nothing,
        agi: $elm$core$Maybe$Nothing,
        Ha: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'start_date', 0, $author$project$Api$Sort$init),
        s1: $elm$core$Maybe$Nothing,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$Membership$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$Membership$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Fw;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.HB;
                if (!_v1.$) {
                    var start_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fn;
                if (!_v2.$) {
                    var end_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.rm;
                if (!_v3.$) {
                    var locationGroup_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', locationGroup_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.aeT;
                if (!_v4.$) {
                    var location_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', location_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.agi;
                if (!_v5.$) {
                    var practitioner_ = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', practitioner_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.WA;
                if (!_v6.$) {
                    var list_ = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$list, 'period_in_months', list_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v7 = options.s1;
                if (!_v7.$) {
                    var string = _v7.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'source_status', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v8 = options.JY;
                if (!_v8.$) {
                    var bool = _v8.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'owner', A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([
                            _Utils_Tuple2('autopay', $elm$json$Json$Encode$bool(bool))
                        ]))))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v9 = options.GW;
                if (!_v9.$) {
                    var string = _v9.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'plan', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v10 = options.acy;
                if (!_v10.$) {
                    var string = _v10.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'company', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v11 = options.Ha;
                if (!_v11.$) {
                    var string = _v11.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'rate_calculation', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v12 = options.Mj;
                if (!_v12.$) {
                    var string = _v12.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'coupon', string)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$Membership$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'memberships'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$Membership$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$Membership$allDecoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$Membership$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$Membership$listPath)));
    });
    var $author$project$Components$Reports$Memberships$fetchMemberships = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$Membership$list, apiClient, $author$project$Components$Reports$Memberships$fetchParams(model), A2($elm$core$Basics$composeL, $author$project$Components$Reports$Memberships$GotData, $author$project$Components$Reports$Memberships$Memberships));
    });
    var $author$project$Components$Reports$Memberships$fetchData = F2(function(apiClient, model) {
        var _v0 = model.M$;
        if (!_v0.$) return A2($author$project$Components$Reports$Memberships$fetchMembershipPatients, apiClient, model);
        else return A2($author$project$Components$Reports$Memberships$fetchMemberships, apiClient, model);
    });
    var $author$project$Components$Reports$Memberships$ContractsEnding = 5;
    var $author$project$Components$Reports$Memberships$ContractsRenewed = 6;
    var $author$project$Components$Reports$Memberships$Current = 3;
    var $author$project$Components$Reports$Memberships$Ending = 2;
    var $author$project$Components$Reports$Memberships$LastOrNextBilling = 4;
    var $author$project$Components$Reports$Memberships$Starting = 1;
    var $author$project$Components$Reports$Memberships$Unconfirmed = 0;
    var $author$project$Components$Reports$Memberships$filterTypeFromQuery = function(queryString) {
        _v0$6: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'unconfirmed':
                    return 0;
                case 'starting':
                    return 1;
                case 'ending':
                    return 2;
                case 'current':
                    return 3;
                case 'contracts_ending':
                    return 5;
                case 'contracts_renewed':
                    return 6;
                default:
                    break _v0$6;
            }
            else break _v0$6;
        }
        return 4;
    };
    var $author$project$Components$ResourceFilter$Coupon$ResourceFilterMsg = $elm$core$Basics$identity;
    var $author$project$Components$ResourceFilter$Coupon$list = $author$project$Api$Provider$Coupon$list;
    var $author$project$Components$ResourceFilter$Coupon$fetchResources = F4(function(toMsg, apiClient, pagination, query) {
        return A3($author$project$Components$ResourceFilter$Coupon$list, apiClient, function(d) {
            return _Utils_update(d, {
                af_: pagination,
                agq: query,
                Hc: $elm$core$Maybe$Just(true)
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Coupon$retrieveResource = F3(function(toMsg, apiClient, id) {
        return A3($author$project$Components$ResourceFilter$Coupon$list, apiClient, function(d) {
            return _Utils_update(d, {
                aef: $elm$core$Maybe$Just(id)
            });
        }, toMsg);
    });
    var $author$project$Components$ResourceFilter$Coupon$selectId = 'coupons';
    var $author$project$Components$ResourceFilter$Coupon$toTitle = $author$project$Api$Provider$Coupon$All$code;
    var $author$project$Components$ResourceFilter$Coupon$toLabel = function(resource) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Components$ResourceFilter$Coupon$toTitle(resource))
        ]);
    };
    var $author$project$Components$ResourceFilter$Coupon$toValue = $author$project$Api$Provider$Coupon$All$id;
    var $author$project$Components$ResourceFilter$Coupon$init = F2(function(apiClient, optionals) {
        var _v0 = A3($author$project$Components$ResourceFilter$init, apiClient, {
            PC: $author$project$Components$ResourceFilter$Coupon$fetchResources,
            aef: $author$project$Components$ResourceFilter$Coupon$selectId,
            gD: 'Coupon',
            sz: $author$project$Components$ResourceFilter$Coupon$retrieveResource,
            ahW: $author$project$Components$ResourceFilter$Coupon$toLabel,
            ahZ: $author$project$Components$ResourceFilter$Coupon$toTitle,
            g4: $author$project$Components$ResourceFilter$Coupon$toValue
        }, optionals);
        var resourceFilter = _v0.a;
        var resourceFilterCmd = _v0.b;
        return _Utils_Tuple2({
            Hg: $author$project$Components$ResourceFilter$All,
            bf: resourceFilter
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, resourceFilterCmd));
    });
    var $author$project$Utils$Report$CouponResourceFilter$init = F3(function(apiClient, optionals, couponId) {
        return A2($author$project$Components$ResourceFilter$Coupon$init, apiClient, A2($elm$core$Basics$composeL, optionals, function(d) {
            return _Utils_update(d, {
                Ee: 'All Coupons',
                agj: couponId
            });
        }));
    });
    var $author$project$Components$Reports$Memberships$initColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'owner', false, 'Owner'),
        A3($author$project$Api$Column$init, 'patient', false, 'Patients'),
        A3($author$project$Api$Column$init, 'plan', false, 'Plan'),
        A3($author$project$Api$Column$init, 'status', false, 'Status'),
        A3($author$project$Api$Column$init, 'last_bill_date', true, 'Last Bill'),
        A3($author$project$Api$Column$init, 'next_bill_date', true, 'Next Bill'),
        A3($author$project$Api$Column$init, 'period_in_months', true, 'Billed'),
        A3($author$project$Api$Column$init, 'payment_info', false, 'Payment Info')
    ]);
    var $author$project$Api$Provider$Report$Membership = 11;
    var $author$project$Api$Provider$Report$MembershipPatient = 10;
    var $author$project$Components$Reports$Memberships$initExportCsv = function(showBy) {
        var resource = function() {
            if (!showBy.$) return 10;
            else return 11;
        }();
        return $author$project$Components$ExportCsv$init({
            adW: false,
            Hg: resource
        });
    };
    var $author$project$Components$Reports$Memberships$AllRateCalculations = 0;
    var $author$project$Components$Reports$Memberships$AutoCalculated = 1;
    var $author$project$Components$Reports$Memberships$OverriddenOffRate = 2;
    var $author$project$Components$Reports$Memberships$OverriddenOnRate = 3;
    var $author$project$Components$Reports$Memberships$rateCalculationFromQuery = function(queryString) {
        _v0$3: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'auto_calculated':
                    return 1;
                case 'overridden_off_rate':
                    return 2;
                case 'overridden_on_rate':
                    return 3;
                default:
                    break _v0$3;
            }
            else break _v0$3;
        }
        return 0;
    };
    var $author$project$Components$Reports$Memberships$AllSources = 0;
    var $author$project$Components$Reports$Memberships$SourceRequiresAction = 3;
    var $author$project$Components$Reports$Memberships$SourceWithWarning = 2;
    var $author$project$Components$Reports$Memberships$ValidSource = 1;
    var $author$project$Components$Reports$Memberships$sourceStatusFromQuery = function(queryString) {
        _v0$3: while(true){
            if (!queryString.$) switch(queryString.a){
                case 'source_valid':
                    return 1;
                case 'source_has_warning':
                    return 2;
                case 'source_requires_action':
                    return 3;
                default:
                    break _v0$3;
            }
            else break _v0$3;
        }
        return 0;
    };
    var $author$project$Components$Reports$Memberships$init = F4(function(session, practice, _v0, query) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
        var planId = A2($elm$core$Dict$get, 'plan', query);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var data = $author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading);
        var couponId = A2($elm$core$Dict$get, 'coupon', query);
        var companyId = A2($elm$core$Dict$get, 'company', query);
        var _v1 = A4($author$project$Utils$Report$PlanResourceFilter$init, apiClient, $elm$core$Basics$identity, session, planId);
        var planResourceFilter = _v1.a;
        var planResourceFilterCmd = _v1.b;
        var _v2 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v2.a;
        var groupLocationAndPractitionerFiltersCmd = _v2.b;
        var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v3.a;
        var end = _v3.b;
        var _v4 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$Memberships$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v4.a;
        var dateRangeInputCmd = _v4.b;
        var _v5 = A3($author$project$Utils$Report$CouponResourceFilter$init, apiClient, $elm$core$Basics$identity, couponId);
        var couponResourceFilter = _v5.a;
        var couponResourceFilterCmd = _v5.b;
        var _v6 = A4($author$project$Utils$Report$CompanyResourceFilter$init, apiClient, $elm$core$Basics$identity, $author$project$Api$Practice$Provider(practice), companyId);
        var companyResourceFilter = _v6.a;
        var companyResourceFilterCmd = _v6.b;
        var model = {
            JY: $author$project$Components$Reports$Memberships$autopayStatusFromQuery(A2($elm$core$Dict$get, 'autopay', query)),
            lb: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'autopay-dropdown-filter',
                ahX: $author$project$Components$Reports$Memberships$AutopayDropdownMsg
            })),
            pH: $author$project$Components$Reports$Memberships$billingPeriodFromQuery(A2($elm$core$Dict$get, 'period_in_months', query)),
            lh: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'billing-period-dropdown-filter',
                ahX: $author$project$Components$Reports$Memberships$BillingPeriodDropdownMsg
            })),
            ED: A3($author$project$Permission$canGoTo, session, hinterViewOff, 0),
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            LC: $author$project$Components$Reports$Memberships$initColumns,
            fl: companyId,
            pY: companyResourceFilter,
            dD: couponId,
            hY: couponResourceFilter,
            cP: currentDate,
            lM: $author$project$Components$CustomerEmailModal$init,
            M$: data,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$Reports$Memberships$initExportCsv(data),
            Fw: $author$project$Components$Reports$Memberships$filterTypeFromQuery(A2($elm$core$Dict$get, 'filter', query)),
            mk: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'filter-dropdown-filter',
                ahX: $author$project$Components$Reports$Memberships$FilterDropdownMsg
            })),
            b8: groupLocationAndPractitionerFilters,
            f0: locationGroupId,
            Tp: locationId,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            agd: planId,
            jy: planResourceFilter,
            Xa: practitionerId,
            Ha: $author$project$Components$Reports$Memberships$rateCalculationFromQuery(A2($elm$core$Dict$get, 'rate_calculation', query)),
            nQ: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'rate-calculation-dropdown-filter',
                ahX: $author$project$Components$Reports$Memberships$RateCalculationDropdownMsg
            })),
            ahs: A3($author$project$Api$Sort$withDefault, 'next_bill_date', 0, $author$project$Api$Sort$initFromQuery(query)),
            s1: $author$project$Components$Reports$Memberships$sourceStatusFromQuery(A2($elm$core$Dict$get, 'source_status', query)),
            oB: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'source-status-dropdown-filter',
                ahX: $author$project$Components$Reports$Memberships$SourceStatusDropdownMsg
            })),
            HB: start
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$PlanResourceFilterMsg, planResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg, companyResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CouponResourceFilterMsg, couponResourceFilterCmd),
            A2($author$project$Components$Reports$Memberships$fetchData, apiClient, model),
            A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Reports$Memberships$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A4($author$project$Components$Reports$Memberships$init, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$Memberships$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Memberships$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$Memberships$CustomerEmailModalMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$ExportCsvMsg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$ResourceFilter$Coupon$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$ResourceFilter$subscriptions(model.bf));
    };
    var $author$project$Components$Reports$Memberships$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Memberships$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Memberships$CustomerEmailModalMsg, $author$project$Components$CustomerEmailModal$subscriptions(model.lM)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Memberships$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Memberships$PlanResourceFilterMsg, $author$project$Components$ResourceFilter$Plan$subscriptions(model.jy)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg, $author$project$Components$ResourceFilter$Company$subscriptions(model.pY)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b8)),
            $author$project$Ui$Dropdown$subscriptions(model.oB),
            $author$project$Ui$Dropdown$subscriptions(model.lb),
            $author$project$Ui$Dropdown$subscriptions(model.lh),
            $author$project$Ui$Dropdown$subscriptions(model.nQ),
            $author$project$Ui$Dropdown$subscriptions(model.mk),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Memberships$CouponResourceFilterMsg, $author$project$Components$ResourceFilter$Coupon$subscriptions(model.hY))
        ]));
    };
    var $author$project$Pages$Reports$Memberships$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$Memberships$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$Memberships$dataLoading = function(showBy) {
        if (!showBy.$) return $author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading);
        else return $author$project$Components$Reports$Memberships$Memberships($author$project$Api$Data$Loading);
    };
    var $author$project$Components$ResourceFilter$Coupon$update = F3(function(apiClient, msg, model) {
        var subMsg = msg;
        var result = A3($author$project$Components$ResourceFilter$update, apiClient, subMsg, model.bf);
        var modelAfterEvent = function() {
            var _v1 = result.adu;
            if (!_v1.$) {
                if (!_v1.a.$) {
                    var selected = _v1.a.a;
                    return _Utils_update(model, {
                        Hg: selected
                    });
                } else {
                    var _v2 = _v1.a;
                    return model;
                }
            } else return model;
        }();
        return {
            EQ: A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, result.EQ),
            adu: result.adu,
            zi: _Utils_update(modelAfterEvent, {
                bf: result.zi
            }),
            at: result.at
        };
    });
    var $author$project$Components$ResourceFilter$Coupon$value = function(model) {
        return A2($author$project$Components$ResourceFilter$choiceToValue, model.bf, model.Hg);
    };
    var $author$project$Components$Reports$Memberships$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.mk);
                var dropdown = _v2.a;
                var dropdownCmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mk: dropdown
                }), dropdownCmd, _List_Nil);
            case 1:
                var filterType = msg.a;
                var newModel = _Utils_update(model, {
                    M$: $author$project$Components$Reports$Memberships$dataLoading(model.M$),
                    Fw: filterType,
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v3.a;
                var subCmd = _v3.b;
                var event = _v3.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            M$: $author$project$Components$Reports$Memberships$dataLoading(model.M$),
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 4:
                var data = msg.a;
                var newModel = _Utils_update(model, {
                    M$: data,
                    md: $author$project$Components$Reports$Memberships$initExportCsv(data),
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                return _Utils_Tuple3(newModel, A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b8);
                var _v5 = result.adu;
                switch(_v5.$){
                    case 0:
                        var locationGroupId = _v5.a;
                        var locationId = _v5.b;
                        var practitionerId = _v5.c;
                        var newModel = _Utils_update(model, {
                            M$: $author$project$Components$Reports$Memberships$dataLoading(model.M$),
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            Xa: practitionerId
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 5:
                var subMsg = msg.a;
                var _v6 = A2($author$project$Ui$Dropdown$update, subMsg, model.lh);
                var dropdown = _v6.a;
                var dropdownCmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    lh: dropdown
                }), dropdownCmd, _List_Nil);
            case 6:
                var period = msg.a;
                var newModel = _Utils_update(model, {
                    pH: period,
                    M$: $author$project$Components$Reports$Memberships$dataLoading(model.M$),
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 7:
                var subMsg = msg.a;
                var _v7 = A2($author$project$Ui$Dropdown$update, subMsg, model.oB);
                var dropdown = _v7.a;
                var dropdownCmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oB: dropdown
                }), dropdownCmd, _List_Nil);
            case 8:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    M$: $author$project$Components$Reports$Memberships$dataLoading(model.M$),
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    s1: status
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 9:
                var subMsg = msg.a;
                var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, model.lb);
                var dropdown = _v8.a;
                var dropdownCmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    lb: dropdown
                }), dropdownCmd, _List_Nil);
            case 10:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    JY: status,
                    M$: $author$project$Components$Reports$Memberships$dataLoading(model.M$),
                    af_: $author$project$Api$Pagination$reset(model.af_)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 12:
                var subMsg = msg.a;
                var companyResourceResult = A3($author$project$Components$ResourceFilter$Company$update, apiClient, subMsg, model.pY);
                var companyId = function() {
                    var _v10 = companyResourceResult.adu;
                    if (!_v10.$) {
                        if (!_v10.a.$) return $author$project$Components$ResourceFilter$Company$value(companyResourceResult.zi);
                        else {
                            var _v11 = _v10.a;
                            return model.fl;
                        }
                    } else return model.fl;
                }();
                var newModel = _Utils_update(model, {
                    fl: companyId,
                    pY: companyResourceResult.zi
                });
                var _v9 = _Utils_eq(model.fl, newModel.fl) ? _Utils_Tuple2(model.M$, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Components$Reports$Memberships$dataLoading(model.M$), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var data = _v9.a;
                var cmd = _v9.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    M$: data
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg, companyResourceResult.EQ),
                    cmd
                ])), companyResourceResult.at);
            case 11:
                var subMsg = msg.a;
                var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, apiClient, subMsg, model.jy);
                var planId = function() {
                    var _v13 = planResourceResult.adu;
                    if (!_v13.$) {
                        if (!_v13.a.$) return $author$project$Components$ResourceFilter$Plan$value(planResourceResult.zi);
                        else {
                            var _v14 = _v13.a;
                            return model.agd;
                        }
                    } else return model.agd;
                }();
                var newModel = _Utils_update(model, {
                    agd: planId,
                    jy: planResourceResult.zi
                });
                var _v12 = _Utils_eq(model.agd, newModel.agd) ? _Utils_Tuple2(model.M$, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Components$Reports$Memberships$dataLoading(model.M$), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var data = _v12.a;
                var cmd = _v12.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    M$: data
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$PlanResourceFilterMsg, planResourceResult.EQ),
                    cmd
                ])), planResourceResult.at);
            case 13:
                var subMsg = msg.a;
                var _v15 = A2($author$project$Ui$Dropdown$update, subMsg, model.nQ);
                var dropdown = _v15.a;
                var dropdownCmd = _v15.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    nQ: dropdown
                }), dropdownCmd, _List_Nil);
            case 14:
                var calculation = msg.a;
                var newModel = _Utils_update(model, {
                    M$: $author$project$Components$Reports$Memberships$dataLoading(model.M$),
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    Ha: calculation
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 15:
                var showBy = msg.a;
                if (!showBy.$) {
                    var response = showBy.a;
                    if (response.$ === 3) {
                        var headers = response.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            M$: $author$project$Components$Reports$Memberships$MembershipPatients(response),
                            af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        M$: $author$project$Components$Reports$Memberships$MembershipPatients(response)
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                } else {
                    var response = showBy.a;
                    if (response.$ === 3) {
                        var headers = response.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            M$: $author$project$Components$Reports$Memberships$Memberships(response),
                            af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        M$: $author$project$Components$Reports$Memberships$Memberships(response)
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            case 16:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    M$: $author$project$Components$Reports$Memberships$dataLoading(model.M$),
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 17:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 18:
                var subMsg = msg.a;
                var _v19 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v19.a;
                var subCmd = _v19.b;
                var subOutMsg = _v19.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$ExportCsvMsg, subCmd), subOutMsg);
            case 19:
                var subMsg = msg.a;
                var _v20 = A3($author$project$Components$CustomerEmailModal$update, apiClient, subMsg, model.lM);
                var customerEmailModal = _v20.a;
                var subCmd = _v20.b;
                var subOutMsg = _v20.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    lM: customerEmailModal
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CustomerEmailModalMsg, subCmd), subOutMsg);
            default:
                var subMsg = msg.a;
                var couponResourceResult = A3($author$project$Components$ResourceFilter$Coupon$update, apiClient, subMsg, model.hY);
                var couponId = function() {
                    var _v22 = couponResourceResult.adu;
                    if (!_v22.$) {
                        if (!_v22.a.$) return $author$project$Components$ResourceFilter$Coupon$value(couponResourceResult.zi);
                        else {
                            var _v23 = _v22.a;
                            return model.dD;
                        }
                    } else return model.dD;
                }();
                var newModel = _Utils_update(model, {
                    dD: couponId,
                    hY: couponResourceResult.zi
                });
                var _v21 = _Utils_eq(model.dD, newModel.dD) ? _Utils_Tuple2(model.M$, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Components$Reports$Memberships$dataLoading(model.M$), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Memberships$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Memberships$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var data = _v21.a;
                var cmd = _v21.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    M$: data
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Memberships$CouponResourceFilterMsg, couponResourceResult.EQ),
                    cmd
                ])), couponResourceResult.at);
        }
    });
    var $author$project$Pages$Reports$Memberships$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$Memberships$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$Memberships$PaginationMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$autopayStatusToLabel = function(status) {
        switch(status){
            case 0:
                return 'All Autopay';
            case 1:
                return 'Autopay Enabled';
            default:
                return 'Autopay Disabled';
        }
    };
    var $author$project$Components$Reports$Memberships$AutopaySelected = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$autopayStatuses = function(currentStatus) {
        var autopayStatusToItem = function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatus, status)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Memberships$AutopaySelected(status))
            ]), $elm$html$Html$text($author$project$Components$Reports$Memberships$autopayStatusToLabel(status)));
        };
        return A2($elm$core$List$cons, autopayStatusToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, autopayStatusToItem, _List_fromArray([
            1,
            2
        ]))));
    };
    var $author$project$Components$Reports$Memberships$viewAutopayDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Components$Reports$Memberships$autopayStatusToLabel(model.JY))
        ]), $author$project$Components$Reports$Memberships$autopayStatuses(model.JY), model.lb);
    };
    var $author$project$Components$Reports$Memberships$billingPeriodToLabel = function(period) {
        switch(period){
            case 0:
                return 'All Billing Periods';
            case 1:
                return 'Billed Monthly';
            case 2:
                return 'Billed Non Monthly';
            case 3:
                return 'Billed Quarterly';
            case 4:
                return 'Billed Semi-annually';
            default:
                return 'Billed Annually';
        }
    };
    var $author$project$Components$Reports$Memberships$BillingPeriodSelected = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$billingPeriods = function(currentPeriod) {
        var billingPeriodToItem = function(period) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentPeriod, period)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Memberships$BillingPeriodSelected(period))
            ]), $elm$html$Html$text($author$project$Components$Reports$Memberships$billingPeriodToLabel(period)));
        };
        return A2($elm$core$List$cons, billingPeriodToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, _Utils_ap(A2($elm$core$List$map, billingPeriodToItem, _List_fromArray([
            1,
            2
        ])), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, billingPeriodToItem, _List_fromArray([
            3,
            4,
            5
        ]))))));
    };
    var $author$project$Components$Reports$Memberships$viewBillingPeriodDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Components$Reports$Memberships$billingPeriodToLabel(model.pH))
        ]), $author$project$Components$Reports$Memberships$billingPeriods(model.pH), model.lh);
    };
    var $author$project$Components$Reports$Memberships$viewCompanyResourceFilter = function(companyResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$CompanyResourceFilterMsg, A2($author$project$Components$ResourceFilter$Company$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), companyResourceFilter));
    };
    var $author$project$Components$ResourceFilter$Coupon$viewNew = F2(function(options, model) {
        return A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$ResourceFilter$viewNew, A2($elm$core$List$cons, $author$project$Components$ResourceFilter$value(model.Hg), options), model.bf));
    });
    var $author$project$Components$Reports$Memberships$viewCouponResourceFilter = function(couponResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$CouponResourceFilterMsg, A2($author$project$Components$ResourceFilter$Coupon$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), couponResourceFilter));
    };
    var $author$project$Components$Reports$Memberships$filterTypeToLabel = function(filterType) {
        switch(filterType){
            case 0:
                return 'Unconfirmed';
            case 1:
                return 'Starting';
            case 2:
                return 'Ending';
            case 3:
                return 'Active';
            case 4:
                return 'Last Billed or Billing';
            case 5:
                return 'Contract Ending';
            default:
                return 'Contracts Renewed';
        }
    };
    var $author$project$Components$Reports$Memberships$FilterSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$filterTypes = function(currentFilter) {
        var filterTypeToItem = function(filterType) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentFilter, filterType)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Memberships$FilterSelected(filterType))
            ]), $elm$html$Html$text($author$project$Components$Reports$Memberships$filterTypeToLabel(filterType)));
        };
        return A2($elm$core$List$map, filterTypeToItem, _List_fromArray([
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ]));
    };
    var $author$project$Components$Reports$Memberships$viewFilterDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Components$Reports$Memberships$filterTypeToLabel(model.Fw))
        ]), $author$project$Components$Reports$Memberships$filterTypes(model.Fw), model.mk);
    };
    var $author$project$Components$ResourceFilter$Coupon$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$Reports$Memberships$viewPlanResourceFilter = function(planResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), planResourceFilter));
    };
    var $author$project$Components$Reports$Memberships$rateCalculationToLabel = function(calculation) {
        switch(calculation){
            case 0:
                return 'All Rate Overrides';
            case 1:
                return 'Automatic Rate';
            case 2:
                return 'Overridden (Off Rate)';
            default:
                return 'Overridden (On Rate)';
        }
    };
    var $author$project$Components$Reports$Memberships$RateCalculationSelected = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$rateCalculations = function(currentCalculation) {
        var rateCalculationToItem = function(calculation) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentCalculation, calculation)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Memberships$RateCalculationSelected(calculation))
            ]), $elm$html$Html$text($author$project$Components$Reports$Memberships$rateCalculationToLabel(calculation)));
        };
        return A2($elm$core$List$cons, rateCalculationToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, rateCalculationToItem, _List_fromArray([
            1,
            2,
            3
        ]))));
    };
    var $author$project$Components$Reports$Memberships$viewRateCalculationDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Components$Reports$Memberships$rateCalculationToLabel(model.Ha))
        ]), $author$project$Components$Reports$Memberships$rateCalculations(model.Ha), model.nQ);
    };
    var $author$project$Components$Reports$Memberships$ShowByChanged = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$viewShowByButtonGroup = function(model) {
        var _v0 = function() {
            var _v1 = model.M$;
            if (!_v1.$) return _Utils_Tuple2(true, false);
            else return _Utils_Tuple2(false, true);
        }();
        var membershipPatientsActive = _v0.a;
        var membershipsActive = _v0.b;
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$justifyRight,
            $author$project$Ui$Element$itemsCenter
        ]), _List_fromArray([
            $elm$html$Html$text('Show by: '),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$mr2
            ]), _List_Nil),
            $author$project$Ui$Button$group(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Shhow by patients'
                }, _List_fromArray([
                    $author$project$Ui$Button$active(membershipPatientsActive),
                    $author$project$Ui$Button$onClick($author$project$Components$Reports$Memberships$ShowByChanged($author$project$Components$Reports$Memberships$MembershipPatients($author$project$Api$Data$Loading)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Patients')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Shhow by membership owners'
                }, _List_fromArray([
                    $author$project$Ui$Button$active(membershipsActive),
                    $author$project$Ui$Button$onClick($author$project$Components$Reports$Memberships$ShowByChanged($author$project$Components$Reports$Memberships$Memberships($author$project$Api$Data$Loading)))
                ]), _List_fromArray([
                    $elm$html$Html$text('Membership owners')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$Reports$Memberships$sourceStatusToLabel = function(status) {
        switch(status){
            case 0:
                return 'All Payment Source';
            case 1:
                return 'Source Valid ';
            case 2:
                return 'Source Has Warning';
            default:
                return 'Source Requires Action';
        }
    };
    var $author$project$Components$Reports$Memberships$SourceStatusSelected = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Reports$Memberships$sourceStatuses = function(currentStatus) {
        var sourceStatusToItem = function(status) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentStatus, status)),
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Memberships$SourceStatusSelected(status))
            ]), $elm$html$Html$text($author$project$Components$Reports$Memberships$sourceStatusToLabel(status)));
        };
        return A2($elm$core$List$cons, sourceStatusToItem(0), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, sourceStatusToItem, _List_fromArray([
            1,
            2,
            3
        ]))));
    };
    var $author$project$Components$Reports$Memberships$viewSourceStatusDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Components$Reports$Memberships$sourceStatusToLabel(model.s1))
        ]), $author$project$Components$Reports$Memberships$sourceStatuses(model.s1), model.oB);
    };
    var $author$project$Components$Reports$Memberships$SortTable = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$Membership$endDate = function(_v0) {
        var one = _v0.a;
        return one.qv;
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Api$Provider$Reports$Patient$forMembershipAutopay = function(_v0) {
        var record = _v0;
        return record.JY;
    };
    var $author$project$Api$Provider$Reports$Plan$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Reports$Membership$lastBillAmountInCents = function(_v0) {
        var one = _v0.a;
        return one.SO;
    };
    var $author$project$Api$Provider$Reports$Membership$lastBillDate = function(_v0) {
        var one = _v0.a;
        return one.SP;
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$membership = function(_v0) {
        var record = _v0;
        return record.jc;
    };
    var $author$project$Api$Provider$Reports$Plan$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Reports$Membership$nextBillDate = function(_v0) {
        var one = _v0.a;
        return one.UY;
    };
    var $author$project$Api$Provider$Reports$Membership$owner = function(_v0) {
        var one = _v0.a;
        return one.VM;
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Api$Provider$Reports$Membership$periodInMonths = function(_v0) {
        var one = _v0.a;
        return one.WA;
    };
    var $author$project$Api$Provider$Reports$Membership$periodRateInCents = function(_v0) {
        var one = _v0.a;
        return one.WB;
    };
    var $author$project$Api$Provider$Reports$Membership$plan = function(_v0) {
        var one = _v0.a;
        return one.GW;
    };
    var $author$project$Api$Provider$Reports$Plan$Min$planType = function(_v0) {
        var record = _v0;
        return record.WN;
    };
    var $author$project$Api$Provider$Reports$Membership$sourceStatus = function(_v0) {
        var one = _v0.a;
        return one.s1;
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Components$Reports$Memberships$membershipPatientToRow = function(membershipPatient) {
        var membership = $author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient);
        var owner = $author$project$Api$Provider$Reports$Membership$owner(membership);
        var lastBillAmountInCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$Reports$Membership$lastBillAmountInCents(membership));
        var isFixedFee = _Utils_eq($author$project$Api$Provider$Reports$Plan$Min$planType($author$project$Api$Provider$Reports$Membership$plan(membership)), $elm$core$Maybe$Just(1));
        var lastBillWasFixedFee = isFixedFee && !lastBillAmountInCents;
        return {
            JY: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Patient$forMembershipAutopay, owner)),
            qv: A2($elm$core$Maybe$withDefault, $author$project$Api$Provider$Reports$Membership$endDate(membership), A2($elm$core$Maybe$map, $elm$core$Maybe$Just, $author$project$Api$Provider$Reports$MembershipPatient$endDate(membershipPatient))),
            yo: isFixedFee,
            SO: lastBillAmountInCents,
            SP: $author$project$Api$Provider$Reports$Membership$lastBillDate(membership),
            yD: lastBillWasFixedFee,
            UY: $author$project$Api$Provider$Reports$Membership$nextBillDate(membership),
            VM: owner,
            V8: $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Min$id($author$project$Api$Provider$Reports$MembershipPatient$patient(membershipPatient))),
            Wc: $elm$core$Maybe$Just($author$project$Api$Provider$Patient$Min$name($author$project$Api$Provider$Reports$MembershipPatient$patient(membershipPatient))),
            AB: _List_Nil,
            WA: $author$project$Api$Provider$Reports$Membership$periodInMonths(membership),
            WB: $author$project$Api$Provider$Reports$Membership$periodRateInCents(membership),
            agd: $author$project$Api$Provider$Reports$Plan$Min$id($author$project$Api$Provider$Reports$Membership$plan($author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient))),
            WM: $author$project$Api$Provider$Reports$Plan$Min$name($author$project$Api$Provider$Reports$Membership$plan($author$project$Api$Provider$Reports$MembershipPatient$membership(membershipPatient))),
            s1: $author$project$Api$Provider$Reports$Membership$sourceStatus(membership),
            _0: $elm$core$Maybe$Just($author$project$Api$Provider$Reports$MembershipPatient$startDate(membershipPatient)),
            ahy: $author$project$Api$Provider$Reports$MembershipPatient$status(membershipPatient)
        };
    };
    var $author$project$Api$Provider$Reports$Membership$membershipPatients = function(_v0) {
        var all = _v0.b;
        return all.T$;
    };
    var $author$project$Api$Provider$Reports$MembershipPatient$ForMembership$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Api$Provider$Reports$Membership$startDate = function(_v0) {
        var one = _v0.a;
        return one._0;
    };
    var $author$project$Api$Provider$Reports$Membership$status = function(_v0) {
        var one = _v0.a;
        return one.ahy;
    };
    var $author$project$Components$Reports$Memberships$membershipToRow = function(membership) {
        var owner = $author$project$Api$Provider$Reports$Membership$owner(membership);
        var membershipPatients = $author$project$Api$Provider$Reports$Membership$membershipPatients(membership);
        var lastBillAmountInCents = A2($elm$core$Maybe$withDefault, 0, $author$project$Api$Provider$Reports$Membership$lastBillAmountInCents(membership));
        var isFixedFee = _Utils_eq($author$project$Api$Provider$Reports$Plan$Min$planType($author$project$Api$Provider$Reports$Membership$plan(membership)), $elm$core$Maybe$Just(1));
        var lastBillWasFixedFee = isFixedFee && !lastBillAmountInCents;
        return {
            JY: A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Patient$forMembershipAutopay, owner)),
            qv: $author$project$Api$Provider$Reports$Membership$endDate(membership),
            yo: isFixedFee,
            SO: lastBillAmountInCents,
            SP: $author$project$Api$Provider$Reports$Membership$lastBillDate(membership),
            yD: lastBillWasFixedFee,
            UY: $author$project$Api$Provider$Reports$Membership$nextBillDate(membership),
            VM: owner,
            V8: $elm$core$Maybe$Nothing,
            Wc: $elm$core$Maybe$Nothing,
            AB: A2($elm$core$List$map, function(membershipPatient) {
                return $author$project$Api$Provider$Patient$Min$name($author$project$Api$Provider$Reports$MembershipPatient$ForMembership$patient(membershipPatient));
            }, membershipPatients),
            WA: $author$project$Api$Provider$Reports$Membership$periodInMonths(membership),
            WB: $author$project$Api$Provider$Reports$Membership$periodRateInCents(membership),
            agd: $author$project$Api$Provider$Reports$Plan$Min$id($author$project$Api$Provider$Reports$Membership$plan(membership)),
            WM: $author$project$Api$Provider$Reports$Plan$Min$name($author$project$Api$Provider$Reports$Membership$plan(membership)),
            s1: $author$project$Api$Provider$Reports$Membership$sourceStatus(membership),
            _0: $author$project$Api$Provider$Reports$Membership$startDate(membership),
            ahy: $author$project$Api$Provider$Reports$Membership$status(membership)
        };
    };
    var $author$project$Api$Provider$Reports$Patient$forMembershipId = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Reports$Patient$forMembershipName = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$Reports$Memberships$viewRow = F4(function(canGoToPatients, canGoToAdmin, showBy, _v0) {
        var owner = _v0.VM;
        var patientId = _v0.V8;
        var patientName = _v0.Wc;
        var patientNames = _v0.AB;
        var status = _v0.ahy;
        var startDate = _v0._0;
        var endDate = _v0.qv;
        var lastBillDate = _v0.SP;
        var lastBillWasFixedFee = _v0.yD;
        var lastBillAmountInCents = _v0.SO;
        var nextBillDate = _v0.UY;
        var isFixedFee = _v0.yo;
        var periodRateInCents = _v0.WB;
        var periodInMonths = _v0.WA;
        var autopay = _v0.JY;
        var sourceStatus = _v0.s1;
        var planName = _v0.WM;
        var planId = _v0.agd;
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                var _v1 = _Utils_Tuple2(owner, canGoToPatients);
                if (!_v1.a.$) {
                    if (_v1.b) {
                        var owner_ = _v1.a.a;
                        return _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                V8: $author$project$Api$Provider$Reports$Patient$forMembershipId(owner_)
                            }), _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text($author$project$Api$Provider$Reports$Patient$forMembershipName(owner_))
                                ]))
                            ]))
                        ]);
                    } else {
                        var owner_ = _v1.a.a;
                        return _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Reports$Patient$forMembershipName(owner_))
                            ]))
                        ]);
                    }
                } else {
                    var _v2 = _v1.a;
                    return _List_Nil;
                }
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                if (!showBy.$) {
                    var _v4 = _Utils_Tuple2(canGoToPatients, patientId);
                    if (_v4.a && !_v4.b.$) {
                        var patientId_ = _v4.b.a;
                        return _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                V8: patientId_
                            }), _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$phi(true)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', patientName))
                                ]))
                            ]))
                        ]);
                    } else return _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', patientName))
                        ]))
                    ]);
                } else return A2($elm$core$List$map, function(name) {
                    return A2($author$project$Ui$Typography$div, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text(name)
                    ]));
                }, patientNames);
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, canGoToAdmin ? _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Plans__Id_String({
                    aef: planId
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text(planName)
                ]))
            ]) : _List_fromArray([
                $elm$html$Html$text(planName)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Badge$fromString, _List_Nil, status),
                A2($author$project$Ui$Typography$div, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    function() {
                        if (!endDate.$) {
                            var endDate_ = endDate.a;
                            return $elm$html$Html$text('ending ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, endDate_));
                        } else return $elm$html$Html$text('since ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), startDate)));
                    }()
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                if (!lastBillDate.$) {
                    var lastBillDate_ = lastBillDate.a;
                    return _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, lastBillDate_)),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), _List_fromArray([
                            lastBillWasFixedFee ? $elm$html$Html$text('Fixed Fee') : $elm$html$Html$text('for ' + $author$project$Utils$Currency$fromInt(lastBillAmountInCents))
                        ]))
                    ]);
                } else return _List_Nil;
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, function() {
                if (!nextBillDate.$) {
                    var nextBillDate_ = nextBillDate.a;
                    return _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, nextBillDate_)),
                        A2($author$project$Ui$Typography$p, _List_fromArray([
                            $author$project$Ui$Typography$helpBlock
                        ]), isFixedFee ? _List_fromArray([
                            $elm$html$Html$text('Fixed Fee'),
                            periodRateInCents - lastBillAmountInCents > 0 ? $author$project$Ui$Icon$increase(_List_fromArray([
                                $author$project$Ui$Icon$danger
                            ])) : $author$project$Ui$Icon$decrease(_List_fromArray([
                                $author$project$Ui$Icon$success
                            ]))
                        ]) : _List_fromArray([
                            $elm$html$Html$text('for ' + $author$project$Utils$Currency$fromInt(periodRateInCents))
                        ]))
                    ]);
                } else return _List_Nil;
            }()),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($author$project$Formatters$Int$asPeriod(periodInMonths))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Autopay: ' + $author$project$Formatters$Bool$toString(autopay)),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Source: '),
                    A2($author$project$Ui$Badge$fromString, _List_Nil, A2($elm$core$Maybe$withDefault, 'none', sourceStatus))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Reports$Memberships$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.M$;
            _v1$2: while(true)if (!_v1.$) {
                if (_v1.a.$ === 3) {
                    var _v2 = _v1.a;
                    var membershipPatients = _v2.a;
                    return _Utils_Tuple2(false, A2($elm$core$List$map, $author$project$Components$Reports$Memberships$membershipPatientToRow, membershipPatients));
                } else break _v1$2;
            } else {
                if (_v1.a.$ === 3) {
                    var _v3 = _v1.a;
                    var memberships = _v3.a;
                    return _Utils_Tuple2(false, A2($elm$core$List$map, $author$project$Components$Reports$Memberships$membershipToRow, memberships));
                } else break _v1$2;
            }
            return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var rows = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$Memberships$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A3($author$project$Components$Reports$Memberships$viewRow, model.EF, model.ED, model.M$), rows), _List_Nil);
    };
    var $author$project$Components$Reports$Memberships$view = F2(function(apiClient, _v0) {
        var model = _v0;
        var totalCount = function() {
            var _v5 = model.M$;
            if (!_v5.$) {
                var lastResponse_ = _v5.a;
                return $author$project$Api$Data$totalCount(lastResponse_);
            } else {
                var lastResponse_ = _v5.a;
                return $author$project$Api$Data$totalCount(lastResponse_);
            }
        }();
        var reportParams = function() {
            var _v4 = model.M$;
            if (!_v4.$) return A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$MembershipPatient$listOptionsToParams, $author$project$Components$Reports$Memberships$fetchParams)(model);
            else return A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$Membership$listOptionsToParams, $author$project$Components$Reports$Memberships$fetchParams)(model);
        }();
        var loading = function() {
            var _v1 = model.M$;
            _v1$2: while(true)if (!_v1.$) {
                if (_v1.a.$ === 3) {
                    var _v2 = _v1.a;
                    return false;
                } else break _v1$2;
            } else {
                if (_v1.a.$ === 3) {
                    var _v3 = _v1.a;
                    return false;
                } else break _v1$2;
            }
            return true;
        }();
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report(totalCount),
                $author$project$Components$ExportCsv$reportParams(reportParams)
            ]), model.md)),
            A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$CustomerEmailModalMsg, $author$project$Components$CustomerEmailModal$modal(model.lM)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Memberships')
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm,
                        $author$project$Ui$Grid$mt2
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(2)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewFilterDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(6)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewShowByButtonGroup(model)
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$spanMd(4)
                    ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                        $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
                    ]), model.b8))), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewBillingPeriodDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewSourceStatusDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewAutopayDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewPlanResourceFilter(model.jy)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewCompanyResourceFilter(model.pY)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewRateCalculationDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Memberships$viewCouponResourceFilter(model.hY)
                        ]))
                    ]))),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Memberships$PlanResourceFilterMsg), $author$project$Components$ResourceFilter$Plan$viewMultiSelected(model.jy)), _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Memberships$CompanyResourceFilterMsg), $author$project$Components$ResourceFilter$Company$viewMultiSelected(model.pY)), _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Memberships$CouponResourceFilterMsg), $author$project$Components$ResourceFilter$Coupon$viewMultiSelected(model.hY)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Memberships$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b8)))));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$Memberships$viewTable(model)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$Memberships$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(loading)
                    ]), model.af_))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Reports$Memberships$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$Memberships$view, model.Ej, model.jQ)),
            $2: 'Reports | Memberships'
        };
    };
    var $author$project$Pages$Reports$Memberships$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Memberships$init,
        aeR: $author$project$Pages$Reports$Memberships$load,
        ag3: $author$project$Pages$Reports$Memberships$save,
        ahE: $author$project$Pages$Reports$Memberships$subscriptions,
        aaO: $author$project$Pages$Reports$Memberships$update,
        aid: $author$project$Pages$Reports$Memberships$view
    });
    var $author$project$Pages$Reports$Months$GotReportingPeriods = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$Reports$Months$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.qv),
                af_: model.af_,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model._0)
            });
        };
    };
    var $author$project$Api$Provider$ReportingPeriod$All$ReportingPeriod = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ReportingPeriod$Shared$ReportingPeriod = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ReportingPeriod$Shared$Record = function(id) {
        return function(name) {
            return function(locked) {
                return function(isLockable) {
                    return function(endDate) {
                        return function(startDate) {
                            return function(revenueInCents) {
                                return function(receiptsInCents) {
                                    return function(stripeFeesInCents) {
                                        return function(hintFeesInCents) {
                                            return function(taxesInCents) {
                                                return function(creditsInCents) {
                                                    return {
                                                        MF: creditsInCents,
                                                        qv: endDate,
                                                        QP: hintFeesInCents,
                                                        aef: id,
                                                        R6: isLockable,
                                                        Ts: locked,
                                                        zr: name,
                                                        Yg: receiptsInCents,
                                                        Y1: revenueInCents,
                                                        _0: startDate,
                                                        $i: stripeFeesInCents,
                                                        $T: taxesInCents
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'credits_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'taxes_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hint_fees_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_fees_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'receipts_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'revenue_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'start_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'end_date', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_lockable', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'locked', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$ReportingPeriod$Shared$Record)))))))))))));
    var $author$project$Api$Provider$ReportingPeriod$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ReportingPeriod$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ReportingPeriod$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ReportingPeriod$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ReportingPeriod$listDefaults = {
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$ReportingPeriod$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$ReportingPeriod$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'start', $author$project$Utils$Date$toQuery(start_))
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'end', $author$project$Utils$Date$toQuery(end_))
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reporting_periods'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$ReportingPeriod$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$ReportingPeriod$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$ReportingPeriod$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath)));
    });
    var $author$project$Pages$Reports$Months$fetchReportingPeriods = function(model) {
        return A3($author$project$Api$Provider$ReportingPeriod$list, model.Ej, $author$project$Pages$Reports$Months$fetchParams(model), $author$project$Pages$Reports$Months$GotReportingPeriods);
    };
    var $author$project$Pages$Reports$Months$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var _v3 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v3.a;
        var end = _v3.b;
        var model = {
            Ej: shared.Ej,
            cP: shared.cP,
            qv: end,
            i4: $elm$core$Maybe$Nothing,
            i5: $elm$core$Set$empty,
            af_: A2($author$project$Api$Pagination$withItemsPerPage, 13, $author$project$Api$Pagination$init),
            n$: $author$project$Api$Data$Loading,
            ahs: A3($author$project$Api$Sort$withDefault, 'start_date', 1, $author$project$Api$Sort$init),
            _0: start,
            kC: $elm$core$Maybe$Nothing,
            kD: $elm$core$Set$empty
        };
        return _Utils_Tuple2(model, $author$project$Pages$Reports$Months$fetchReportingPeriods(model));
    });
    var $author$project$Pages$Reports$Months$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            cP: shared.cP
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Months$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$Months$LockHiConfirmClosed = F2(function(a, b) {
        return {
            $: 4,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Reports$Months$UnlockHiConfirmClosed = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$Reports$Months$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Reports$Months$UnlockHiConfirmClosed), model.kC)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Components$HiConfirm$subscribeToEscapeKeyPress, $author$project$Pages$Reports$Months$LockHiConfirmClosed), model.i4))
        ]));
    };
    var $author$project$Pages$Reports$Months$ReportingPeriodLocked = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$Reports$Months$ReportingPeriodUnlocked = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$id(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$One$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$id(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$One$ReportingPeriod = $elm$core$Basics$identity;
    var $author$project$Api$Provider$ReportingPeriod$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$ReportingPeriod$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$ReportingPeriod$reportingPeriodPath = function(id_) {
        return A2($author$project$Api$Data$pathAppend, _List_fromArray([
            id_
        ]), $author$project$Api$Provider$ReportingPeriod$reportingPeriodsPath);
    };
    var $author$project$Api$Provider$ReportingPeriod$lock = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$ReportingPeriod$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('locked', $elm$json$Json$Encode$bool(true))
        ])), $author$project$Api$Data$requestTo($author$project$Api$Provider$ReportingPeriod$reportingPeriodPath(id_))));
    });
    var $author$project$Api$Provider$ReportingPeriod$unlock = F3(function(apiClient, id_, toMsg) {
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Provider$ReportingPeriod$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('locked', $elm$json$Json$Encode$bool(false))
        ])), $author$project$Api$Data$requestTo($author$project$Api$Provider$ReportingPeriod$reportingPeriodPath(id_))));
    });
    var $author$project$Pages$Reports$Months$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    n$: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(response));
            case 1:
                var reportingPeriod = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    kC: $elm$core$Maybe$Just(reportingPeriod)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var reportingPeriod = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    i4: $elm$core$Maybe$Just(reportingPeriod)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var reportingPeriod = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    kC: $elm$core$Maybe$Nothing,
                    kD: A2($elm$core$Set$insert, $author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod), model.kD)
                }), A3($author$project$Api$Provider$ReportingPeriod$unlock, model.Ej, $author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod), $author$project$Pages$Reports$Months$ReportingPeriodUnlocked), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    kC: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var reportingPeriod = msg.a;
                var confirmed = msg.b;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    i4: $elm$core$Maybe$Nothing,
                    i5: A2($elm$core$Set$insert, $author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod), model.i5)
                }), A3($author$project$Api$Provider$ReportingPeriod$lock, model.Ej, $author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod), $author$project$Pages$Reports$Months$ReportingPeriodLocked), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    i4: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var reportingPeriod = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        n$: $author$project$Api$Data$Loading,
                        kD: A2($elm$core$Set$remove, $author$project$Api$Provider$ReportingPeriod$One$id(reportingPeriod), model.kD)
                    }), $author$project$Pages$Reports$Months$fetchReportingPeriods(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Reporting period unlocked')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                var response = msg.a;
                if (response.$ === 3) {
                    var reportingPeriod = response.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        i5: A2($elm$core$Set$remove, $author$project$Api$Provider$ReportingPeriod$One$id(reportingPeriod), model.i5),
                        n$: $author$project$Api$Data$Loading
                    }), $author$project$Pages$Reports$Months$fetchReportingPeriods(model), _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Reporting period locked')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Api$Provider$ReportingPeriod$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$name(shared);
    };
    var $author$project$Pages$Reports$Months$UnlockReportingPeriod = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$endDate = function(_v0) {
        var record = _v0;
        return record.qv;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$endDate = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$endDate(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$isLockable = function(_v0) {
        var record = _v0;
        return record.R6;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$isLockable = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$isLockable(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$locked = function(_v0) {
        var record = _v0;
        return record.Ts;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$locked = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$locked(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$startDate = function(_v0) {
        var record = _v0;
        return record._0;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$startDate = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$startDate(shared);
    };
    var $author$project$Pages$Reports$Months$LockReportingPeriod = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$Reports$Months$viewLockButton = F3(function(unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod) {
        var locked = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod);
        var id = $author$project$Api$Provider$ReportingPeriod$All$id(reportingPeriod);
        var locking = A2($elm$core$Set$member, id, lockingReportingPeriods);
        var unlocking = A2($elm$core$Set$member, id, unlockingReportingPeriods);
        var label = locking ? 'Locking...' : unlocking ? 'Unlocking...' : locked ? 'Locked' : 'Lock';
        var buttonStyle = function() {
            var _v0 = _Utils_Tuple2(locked, unlocking);
            if (_v0.a && !_v0.b) return 1;
            else return 0;
        }();
        var buttonEnabled = !(locked || locking) && $author$project$Api$Provider$ReportingPeriod$All$isLockable(reportingPeriod);
        return A3($author$project$Ui$Button$view, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$styled(buttonStyle),
            $author$project$Ui$Button$pull(1),
            $author$project$Ui$Button$loading(locking || unlocking),
            $author$project$Ui$Button$disabled(!buttonEnabled),
            $author$project$Ui$Button$onClick($author$project$Pages$Reports$Months$LockReportingPeriod(reportingPeriod)),
            $author$project$Ui$Button$icon($author$project$Ui$Icon$lock)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    });
    var $author$project$Api$Provider$ReportingPeriod$Shared$creditsInCents = function(_v0) {
        var record = _v0;
        return record.MF;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$creditsInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$creditsInCents(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$hintFeesInCents = function(_v0) {
        var record = _v0;
        return record.QP;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$hintFeesInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$hintFeesInCents(shared);
    };
    var $author$project$Ui$Panel$Primary = 0;
    var $author$project$Ui$Panel$primary = $author$project$Ui$Panel$Styling(0);
    var $author$project$Api$Provider$ReportingPeriod$Shared$receiptsInCents = function(_v0) {
        var record = _v0;
        return record.Yg;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$receiptsInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$receiptsInCents(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$revenueInCents = function(_v0) {
        var record = _v0;
        return record.Y1;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$revenueInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$revenueInCents(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$stripeFeesInCents = function(_v0) {
        var record = _v0;
        return record.$i;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$stripeFeesInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$stripeFeesInCents(shared);
    };
    var $author$project$Api$Provider$ReportingPeriod$Shared$taxesInCents = function(_v0) {
        var record = _v0;
        return record.$T;
    };
    var $author$project$Api$Provider$ReportingPeriod$All$taxesInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$ReportingPeriod$Shared$taxesInCents(shared);
    };
    var $author$project$Pages$Reports$Months$viewMetric = F5(function(label, route, start, end, cents) {
        var reportParams = _List_fromArray([
            A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), $author$project$Utils$Date$toQuery)(start),
            A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), $author$project$Utils$Date$toQuery)(end)
        ]);
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$label(label),
            $author$project$Ui$Form$Group$labelSpan(6),
            $author$project$Ui$Form$Group$inputSpan(6),
            $author$project$Ui$Form$Group$labelClass('')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_fromArray([
                $author$project$Ui$Form$Static$numeric
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, route, _List_fromArray([
                    $author$project$Ui$Link$routeParams(reportParams)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(cents))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$Reports$Months$viewPanel = function(reportingPeriod) {
        var startDate = $author$project$Api$Provider$ReportingPeriod$All$startDate(reportingPeriod);
        var panelOptions = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod) ? _List_fromArray([
            $author$project$Ui$Panel$primary
        ]) : _List_Nil;
        var endDate = $author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod);
        return A2($author$project$Ui$Panel$view, panelOptions, _List_fromArray([
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A5($author$project$Pages$Reports$Months$viewMetric, 'Billed Revenue', $author$project$Spa$Generated$Route$Reports__Revenue, startDate, endDate, $author$project$Api$Provider$ReportingPeriod$All$revenueInCents(reportingPeriod)),
                A5($author$project$Pages$Reports$Months$viewMetric, 'Payments Received', $author$project$Spa$Generated$Route$Reports__PaymentApplications, startDate, endDate, $author$project$Api$Provider$ReportingPeriod$All$receiptsInCents(reportingPeriod)),
                A5($author$project$Pages$Reports$Months$viewMetric, 'Fees', $author$project$Spa$Generated$Route$Reports__PaymentApplications, startDate, endDate, $author$project$Api$Provider$ReportingPeriod$All$hintFeesInCents(reportingPeriod) + $author$project$Api$Provider$ReportingPeriod$All$stripeFeesInCents(reportingPeriod)),
                A5($author$project$Pages$Reports$Months$viewMetric, 'Taxes', $author$project$Spa$Generated$Route$Reports__SalesTax, startDate, endDate, $author$project$Api$Provider$ReportingPeriod$All$taxesInCents(reportingPeriod)),
                A5($author$project$Pages$Reports$Months$viewMetric, 'Credits', $author$project$Spa$Generated$Route$Reports__CreditTransactions, startDate, endDate, $author$project$Api$Provider$ReportingPeriod$All$creditsInCents(reportingPeriod))
            ]))
        ]));
    };
    var $author$project$Pages$Reports$Months$viewReportingPeriod = F3(function(unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod) {
        var locked = $author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod);
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($elm$html$Html$h3, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod))
                    ])),
                    A3($author$project$Pages$Reports$Months$viewLockButton, unlockingReportingPeriods, lockingReportingPeriods, reportingPeriod)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Period from ' + (A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$ReportingPeriod$All$startDate(reportingPeriod)) + (' to ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod)))))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$textMuted
                    ]), locked ? _List_fromArray([
                        $elm$html$Html$text('If you need to update charges for this period you can '),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Unlock this reporting period'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                            $author$project$Ui$Button$onClick($author$project$Pages$Reports$Months$UnlockReportingPeriod(reportingPeriod))
                        ]), _List_fromArray([
                            $elm$html$Html$text('unlock this reporting period')
                        ]))
                    ]) : !$author$project$Api$Provider$ReportingPeriod$All$locked(reportingPeriod) && !$author$project$Api$Provider$ReportingPeriod$All$isLockable(reportingPeriod) ? _List_fromArray([
                        $elm$html$Html$text('The current reporting period cannot be locked until it is complete on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$ReportingPeriod$All$endDate(reportingPeriod)))
                    ]) : _List_Nil)
                ])),
                $author$project$Pages$Reports$Months$viewPanel(reportingPeriod)
            ]))
        ]));
    });
    var $author$project$Pages$Reports$Months$viewReportingPeriodSkeleton = function(panel) {
        return A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($elm$html$Html$h3, _List_Nil, _List_fromArray([
                        $author$project$Ui$Skeleton$text(_List_fromArray([
                            $author$project$Ui$Skeleton$spanFromText('February')
                        ]))
                    ])),
                    $author$project$Ui$Skeleton$input(_List_fromArray([
                        $author$project$Ui$Skeleton$spanFromText('  Lock  ')
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Skeleton$text(_List_fromArray([
                        $author$project$Ui$Skeleton$span(4)
                    ]))
                ])),
                panel
            ]))
        ]));
    }(A2($author$project$Ui$Panel$view, _List_Nil, $elm$core$List$singleton(A2($author$project$Ui$Panel$body, _List_Nil, A2($elm$core$List$map, function(label) {
        return A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSkeleton(label),
            $author$project$Ui$Form$Group$labelSpan(6),
            $author$project$Ui$Form$Group$inputSpan(6),
            $author$project$Ui$Form$Group$labelClass('')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_fromArray([
                $author$project$Ui$Form$Static$numeric
            ]), _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$spanFromText('$100.00')
                ]))
            ]))
        ]));
    }, _List_fromArray([
        'Billed Revenue',
        'Payments Received',
        'Fees',
        'Taxes'
    ]))))));
    var $author$project$Pages$Reports$Months$view = function(model) {
        return {
            fb: _List_fromArray([
                function() {
                    var _v0 = model.kC;
                    if (!_v0.$) {
                        var reportingPeriod = _v0.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Reports$Months$UnlockHiConfirmClosed(reportingPeriod), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('unlock'),
                            $author$project$Components$HiConfirm$noun($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod)),
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text('Are you sure you want to unlock your ' + ($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod) + ' reporting period? This will allow updating of charges made during this period which may alter your revenue, payment, tax or credit reports.'))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v1 = model.i4;
                    if (!_v1.$) {
                        var reportingPeriod = _v1.a;
                        return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$Reports$Months$LockHiConfirmClosed(reportingPeriod), _List_fromArray([
                            $author$project$Components$HiConfirm$verb('lock'),
                            $author$project$Components$HiConfirm$noun($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod)),
                            $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text('Locking your ' + ($author$project$Api$Provider$ReportingPeriod$All$name(reportingPeriod) + ' reporting period will completely lock down invoices made in this period and ensure your revenue, payments, tax and credit transaction reports cannot change.'))
                            ]))
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                function() {
                    var _v2 = model.n$;
                    if (_v2.$ === 3) {
                        var reportingPeriods = _v2.a;
                        return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, A2($author$project$Pages$Reports$Months$viewReportingPeriod, model.kD, model.i5), reportingPeriods));
                    } else return A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$repeat, 12, $author$project$Pages$Reports$Months$viewReportingPeriodSkeleton));
                }()
            ]),
            $2: 'Reports | Reporting Periods'
        };
    };
    var $author$project$Pages$Reports$Months$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Months$init,
        aeR: $author$project$Pages$Reports$Months$load,
        ag3: $author$project$Pages$Reports$Months$save,
        ahE: $author$project$Pages$Reports$Months$subscriptions,
        aaO: $author$project$Pages$Reports$Months$update,
        aid: $author$project$Pages$Reports$Months$view
    });
    var $author$project$Pages$Reports$PaymentApplications$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$PaymentApplications$Table = 0;
    var $author$project$Components$Reports$PaymentApplications$ByDropdownMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$DateFilterTypeDropdownMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$DepositDropdownMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$FeeTypeDropdownMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$GotDeposits = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$PaymentApplicationLine = 9;
    var $author$project$Components$Reports$PaymentApplications$PaymentProcessorDropdownMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$Transaction = 0;
    var $author$project$Components$Reports$PaymentApplications$TransactionTypeDropdownMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$ByCategory = 0;
    var $author$project$Components$Reports$PaymentApplications$ByLocation = 2;
    var $author$project$Components$Reports$PaymentApplications$ByPractitioner = 1;
    var $author$project$Components$Reports$PaymentApplications$ByTransactionType = 3;
    var $author$project$Components$Reports$PaymentApplications$byOptionFromString = function(str) {
        switch(str){
            case 'category':
                return $elm$core$Maybe$Just(0);
            case 'practitioner':
                return $elm$core$Maybe$Just(1);
            case 'location':
                return $elm$core$Maybe$Just(2);
            case 'transaction_type':
                return $elm$core$Maybe$Just(3);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Reports$PaymentApplications$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$PaymentApplications$AmericanExpress = 2;
    var $author$project$Components$Reports$PaymentApplications$BankTransfer = 0;
    var $author$project$Components$Reports$PaymentApplications$Card = 1;
    var $author$project$Components$Reports$PaymentApplications$CashCheck = 4;
    var $author$project$Components$Reports$PaymentApplications$NoFee = 3;
    var $author$project$Components$Reports$PaymentApplications$feeTypeFromString = function(str) {
        switch(str){
            case 'Bank Transfer':
                return $elm$core$Maybe$Just(0);
            case 'Card':
                return $elm$core$Maybe$Just(1);
            case 'American Express':
                return $elm$core$Maybe$Just(2);
            case 'No Fee':
                return $elm$core$Maybe$Just(3);
            case 'Cash/Check':
                return $elm$core$Maybe$Just(4);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Reports$PaymentApplications$GotPaymentApplications = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$dateFilterTypeToString = function(dateFilterType) {
        if (!dateFilterType) return 'transaction';
        else return 'deposit';
    };
    var $author$project$Components$Reports$PaymentApplications$feeTypeToValue = function(feeType) {
        switch(feeType){
            case 0:
                return 'Bank Transfer';
            case 1:
                return 'Card';
            case 2:
                return 'American Express';
            case 3:
                return 'No Fee';
            default:
                return 'Cash/Check';
        }
    };
    var $author$project$Components$Reports$PaymentApplications$transactionTypeToValue = function(transactionType) {
        switch(transactionType){
            case 0:
                return 'all';
            case 1:
                return 'payments';
            default:
                return 'refunds';
        }
    };
    var $author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                EL: model.fg,
                E6: $elm$core$Maybe$Just($author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.E6)),
                ql: model.ac5,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                PB: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$feeTypeToValue, model.PB),
                aeT: model.Tp,
                rm: model.f0,
                af_: model.af_,
                Wo: model.Wo,
                agi: model.Xa,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                HS: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$transactionTypeToValue, model.HS)
            });
        };
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$PaymentApplication = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$PaymentApplication$Record = function(transactionDate) {
        return function(amountInCents) {
            return function(hintFeeInCents) {
                return function(stripeFeeInCents) {
                    return function(totalFeeInCents) {
                        return function(charge) {
                            return function(deposit) {
                                return function(receipt) {
                                    return function(patient) {
                                        return function(category) {
                                            return function(invoice) {
                                                return function(practitioner) {
                                                    return function(location1) {
                                                        return {
                                                            Jh: amountInCents,
                                                            EL: category,
                                                            ach: charge,
                                                            ql: deposit,
                                                            QO: hintFeeInCents,
                                                            RA: invoice,
                                                            aeT: location1,
                                                            V7: patient,
                                                            agi: practitioner,
                                                            Ye: receipt,
                                                            $h: stripeFeeInCents,
                                                            aak: totalFeeInCents,
                                                            aat: transactionDate
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$Deposit$Shared$Deposit = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Deposit$Shared$Record = F4(function(id, availableOn, amountInCents, status) {
        return {
            Jh: amountInCents,
            J$: availableOn,
            aef: id,
            ahy: status
        };
    });
    var $author$project$Api$Provider$Deposit$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', A2($elm$json$Json$Decode$andThen, $author$project$Api$Provider$Reports$Deposit$decodeStatus, $elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'available_on', $author$project$Utils$Date$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Deposit$Shared$Record)))));
    var $author$project$Api$Provider$Deposit$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Deposit$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Receipt$Shared$Receipt = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Receipt$Shared$Record = F4(function(objectType, feeType, expectedDepositDate, paymentProcessor) {
        return {
            Pc: expectedDepositDate,
            PB: feeType,
            Vg: objectType,
            Wo: paymentProcessor
        };
    });
    var $author$project$Api$Provider$Receipt$Shared$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'payment_processor', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'expected_deposit_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'fee_type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'object_type', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Receipt$Shared$Record)))));
    var $author$project$Api$Provider$Receipt$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Receipt$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$PaymentApplication$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'patient', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'receipt', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Receipt$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'deposit', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Deposit$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'total_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hint_fee_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transaction_date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$PaymentApplication$Record))))))))))))));
    var $author$project$Api$Provider$Reports$PaymentApplication$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$PaymentApplication$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$PaymentApplication$listDefaults = {
        EL: $elm$core$Maybe$Nothing,
        E6: $elm$core$Maybe$Nothing,
        ql: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        PB: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        Wo: $elm$core$Maybe$Nothing,
        agi: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        HS: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$PaymentApplication$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.E6;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'date_filter_type', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.HB;
                if (!_v1.$) {
                    var start_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Fn;
                if (!_v2.$) {
                    var end_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.EL;
                if (!_v3.$) {
                    var category_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'category', category_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.rm;
                if (!_v4.$) {
                    var locationGroup_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', locationGroup_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.aeT;
                if (!_v5.$) {
                    var location_ = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', location_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v6 = options.agi;
                if (!_v6.$) {
                    var practitioner_ = _v6.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', practitioner_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v7 = options.ql;
                if (!_v7.$) {
                    var string = _v7.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'deposit', string)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v8 = options.PB;
                if (!_v8.$ && _v8.a === 'Cash/Check') return _List_fromArray([
                    A2($author$project$Api$Param$string, 'payment', A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('external_type', A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, _List_fromArray([
                            'cash',
                            'check',
                            'other'
                        ])))
                    ]))))
                ]);
                else return _List_Nil;
            }(),
            function() {
                var receiptFields = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                    function() {
                        var _v9 = options.PB;
                        if (!_v9.$) {
                            if (_v9.a === 'Cash/Check') return $elm$core$Maybe$Nothing;
                            else {
                                var string = _v9.a;
                                return $elm$core$Maybe$Just(_Utils_Tuple2('fee_type', $elm$json$Json$Encode$string(string)));
                            }
                        } else return $elm$core$Maybe$Nothing;
                    }(),
                    A2($elm$core$Maybe$map, function(pp) {
                        return _Utils_Tuple2('payment_processor', $elm$json$Json$Encode$string(pp));
                    }, options.Wo)
                ]));
                return $elm$core$List$isEmpty(receiptFields) ? _List_Nil : _List_fromArray([
                    A2($author$project$Api$Param$string, 'receipt', A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(receiptFields)))
                ]);
            }(),
            function() {
                var _v10 = options.HS;
                if (!_v10.$) {
                    var string = _v10.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'transaction_type', string)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'payment_applications'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$PaymentApplication$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$PaymentApplication$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$PaymentApplication$listPath)));
    });
    var $author$project$Components$Reports$PaymentApplications$fetchPaymentApplications = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$PaymentApplication$list, apiClient, $author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams(model), $author$project$Components$Reports$PaymentApplications$GotPaymentApplications);
    });
    var $author$project$Components$Reports$PaymentApplications$GotSummary = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$byOptionToValue = function(byOption) {
        switch(byOption){
            case 0:
                return 'category';
            case 1:
                return 'practitioner';
            case 2:
                return 'location';
            default:
                return 'transaction_type';
        }
    };
    var $author$project$Components$Reports$PaymentApplications$fetchSummaryParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                EL: model.fg,
                E6: $elm$core$Maybe$Just($author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.E6)),
                ql: model.ac5,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                PB: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$feeTypeToValue, model.PB),
                aeT: model.Tp,
                rm: model.f0,
                Wo: model.Wo,
                agi: model.Xa,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                HS: A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$transactionTypeToValue, model.HS)
            });
        };
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$summary = F4(function(apiClient, by, optionals, toMsg) {
        return A5($author$project$Api$Provider$Reports$Summary$retrieve, apiClient, $author$project$Api$Provider$Reports$PaymentApplication$listPath, by, $author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams(optionals), toMsg);
    });
    var $author$project$Components$Reports$PaymentApplications$fetchSummary = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$Reports$PaymentApplication$summary, apiClient, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$byOptionToValue, model.bT)), $author$project$Components$Reports$PaymentApplications$fetchSummaryParams(model), $author$project$Components$Reports$PaymentApplications$GotSummary);
    });
    var $author$project$Components$Reports$PaymentApplications$fetchData = F2(function(apiClient, model) {
        var _v0 = model.ah5;
        if (!_v0) return A2($author$project$Components$Reports$PaymentApplications$fetchPaymentApplications, apiClient, model);
        else return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Reports$PaymentApplications$fetchSummary, apiClient, model),
            A2($author$project$Components$Reports$PaymentApplications$fetchPaymentApplications, apiClient, model)
        ]));
    });
    var $author$project$Components$Reports$PaymentApplications$fetchDepositsParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                ahs: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$init),
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Components$Reports$PaymentApplications$initColumns = function(trackPatientsByLocation) {
        return A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'payment', false, 'Payment'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'patient', true, 'Patient'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'category', true, 'Category'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'), _Utils_ap(trackPatientsByLocation ? _List_fromArray([
            A3($author$project$Api$Column$init, 'location', true, 'Location')
        ]) : _List_Nil, _List_fromArray([
            A3($author$project$Api$Column$init, 'payment_processor', false, 'Processor')
        ])))))))));
    };
    var $author$project$Api$Provider$Deposit$All$Deposit = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Deposit$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Deposit$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Deposit$depositsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'deposits'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Deposit$listDefaults = {
        Fn: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: A3($author$project$Api$Sort$withDefault, 'available_on', 1, $author$project$Api$Sort$init),
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Deposit$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Deposit$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = _Utils_Tuple2(options.HB, options.Fn);
                if (_v0.a.$ === 1 && _v0.b.$ === 1) {
                    var _v1 = _v0.a;
                    var _v2 = _v0.b;
                    return _List_Nil;
                } else {
                    var dates = A2($elm$json$Json$Encode$encode, 0, $elm$json$Json$Encode$object(_List_fromArray([
                        _Utils_Tuple2('gte', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery), options.HB)),
                        _Utils_Tuple2('lte', A2($author$project$Utils$Encode$nullable, A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Utils$Date$toQuery), options.Fn))
                    ])));
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'transaction_date', dates)
                    ]);
                }
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Provider$Deposit$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Deposit$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Deposit$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Deposit$depositsPath)));
    });
    var $author$project$Components$Reports$PaymentApplications$Deposit = 1;
    var $author$project$Components$Reports$PaymentApplications$stringToDateFilterType = function(str) {
        switch(str){
            case 'transaction':
                return $elm$core$Maybe$Just(0);
            case 'deposit':
                return $elm$core$Maybe$Just(1);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Reports$PaymentApplications$AllTransactions = 0;
    var $author$project$Components$Reports$PaymentApplications$Payments = 1;
    var $author$project$Components$Reports$PaymentApplications$Refunds = 2;
    var $author$project$Components$Reports$PaymentApplications$transactionTypeFromString = function(str) {
        switch(str){
            case 'all':
                return $elm$core$Maybe$Just(0);
            case 'payments':
                return $elm$core$Maybe$Just(1);
            case 'refunds':
                return $elm$core$Maybe$Just(2);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Components$Reports$PaymentApplications$urlParams = function(model) {
        var queryParams = _List_fromArray([
            $elm$core$Maybe$Just(_Utils_Tuple2('date_filter_type', $author$project$Components$Reports$PaymentApplications$dateFilterTypeToString(model.E6))),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('category'), model.fg),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('deposit'), model.ac5),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location'), model.Tp),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('practitioner'), model.Xa),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('fee_type'), $author$project$Components$Reports$PaymentApplications$feeTypeToValue), model.PB),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('payment_processor'), model.Wo),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('by'), $author$project$Components$Reports$PaymentApplications$byOptionToValue), model.bT),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('transaction_type'), $author$project$Components$Reports$PaymentApplications$transactionTypeToValue), model.HS)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Components$Reports$PaymentApplications$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            function() {
                var _v0 = model.bT;
                if (!_v0.$) return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary);
                else return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__PaymentApplications);
            }()
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), $author$project$Utils$QueryParameter$fromDict($author$project$Components$Reports$PaymentApplications$urlParams(model))))));
    };
    var $author$project$Components$Reports$PaymentApplications$init = F5(function(type_, session, practice, shared, query) {
        var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var feePlanType = $author$project$Api$Provider$Practice$One$feePlanType(practice);
        var categoryId = A2($elm$core$Dict$get, 'category', query);
        var _v0 = function() {
            if (!type_) return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
            else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
        }();
        var paymentApplications = _v0.a;
        var summary = _v0.b;
        var _v2 = shared;
        var currentDate = _v2.cP;
        var apiClient = _v2.Ej;
        var hinterViewOff = _v2.aeb;
        var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v3.a;
        var groupLocationAndPractitionerFiltersCmd = _v3.b;
        var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v4.a;
        var end = _v4.b;
        var _v5 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$PaymentApplications$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v5.a;
        var dateRangeInputCmd = _v5.b;
        var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
        var categoryResourceFilter = _v6.a;
        var categoryResourceFilterCmd = _v6.b;
        var model = {
            bT: A2($elm$core$Maybe$andThen, $author$project$Components$Reports$PaymentApplications$byOptionFromString, A2($elm$core$Dict$get, 'by', query)),
            ln: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'by-dropdown',
                ahX: $author$project$Components$Reports$PaymentApplications$ByDropdownMsg
            })),
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            fg: categoryId,
            cK: categoryResourceFilter,
            LC: $author$project$Components$Reports$PaymentApplications$initColumns(trackPatientsByLocation),
            cP: currentDate,
            E6: A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $author$project$Components$Reports$PaymentApplications$stringToDateFilterType, A2($elm$core$Dict$get, 'date_filter_type', query))),
            lQ: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'date-filter-type-dropdown-filter',
                ahX: $author$project$Components$Reports$PaymentApplications$DateFilterTypeDropdownMsg
            })),
            h6: dateRangeInput,
            lW: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'deposit-dropdown',
                ahX: $author$project$Components$Reports$PaymentApplications$DepositDropdownMsg
            })),
            ac5: A2($elm$core$Dict$get, 'deposit', query),
            b2: $author$project$Api$Data$Loading,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 9
            }),
            PA: feePlanType,
            PB: A2($elm$core$Maybe$andThen, $author$project$Components$Reports$PaymentApplications$feeTypeFromString, A2($elm$core$Dict$get, 'fee_type', query)),
            mj: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'fee-type-dropdown',
                ahX: $author$project$Components$Reports$PaymentApplications$FeeTypeDropdownMsg
            })),
            b8: groupLocationAndPractitionerFilters,
            F3: $author$project$Shared$isHintAdmin(shared),
            f0: locationGroupId,
            Tp: locationId,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            z: paymentApplications,
            Wo: A2($elm$core$Dict$get, 'payment_processor', query),
            nt: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'payment-processor-dropdown',
                ahX: $author$project$Components$Reports$PaymentApplications$PaymentProcessorDropdownMsg
            })),
            Xa: practitionerId,
            ahs: A3($author$project$Api$Sort$withDefault, 'transaction_date', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            $x: summary,
            aaq: trackPatientsByLocation,
            HS: A2($elm$core$Maybe$andThen, $author$project$Components$Reports$PaymentApplications$transactionTypeFromString, A2($elm$core$Dict$get, 'transaction_type', query)),
            oT: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'transaction-type-dropdown',
                ahX: $author$project$Components$Reports$PaymentApplications$TransactionTypeDropdownMsg
            })),
            ah5: type_
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A3($author$project$Api$Provider$Deposit$list, apiClient, $author$project$Components$Reports$PaymentApplications$fetchDepositsParams(model), $author$project$Components$Reports$PaymentApplications$GotDeposits),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, model),
            $author$project$Components$Reports$PaymentApplications$updateUrl(model)
        ])));
    });
    var $author$project$Pages$Reports$PaymentApplications$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$PaymentApplications$init, 0, session, practice, shared, query);
        var report = _v1.a;
        var reportTaxCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
    });
    var $author$project$Pages$Reports$PaymentApplications$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$PaymentApplications$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$PaymentApplications$ExportCsvMsg = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$PaymentApplications$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b8)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg, $author$project$Components$ResourceFilter$Category$subscriptions(model.cK)),
            $author$project$Ui$Dropdown$subscriptions(model.ln),
            $author$project$Ui$Dropdown$subscriptions(model.lW),
            $author$project$Ui$Dropdown$subscriptions(model.mj),
            $author$project$Ui$Dropdown$subscriptions(model.nt),
            $author$project$Ui$Dropdown$subscriptions(model.lQ),
            $author$project$Ui$Dropdown$subscriptions(model.oT)
        ]));
    };
    var $author$project$Pages$Reports$PaymentApplications$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$PaymentApplications$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$PaymentApplications$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.lQ);
                var dateFilterTypeDropdown = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    lQ: dateFilterTypeDropdown
                }), cmd, _List_Nil);
            case 1:
                var dateFilterType = msg.a;
                var newModel = _Utils_update(model, {
                    E6: dateFilterType,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    z: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ])), _List_Nil);
            case 4:
                var subMsg = msg.a;
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cK);
                var categoryId = function() {
                    var _v3 = categoryResourceResult.adu;
                    if (!_v3.$) {
                        if (!_v3.a.$) return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi);
                        else {
                            var _v4 = _v3.a;
                            return model.fg;
                        }
                    } else return model.fg;
                }();
                var newModel = _Utils_update(model, {
                    fg: categoryId,
                    cK: categoryResourceResult.zi
                });
                var _v2 = _Utils_eq(model.fg, newModel.fg) ? _Utils_Tuple2(model.z, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ])));
                var paymentApplications = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    z: paymentApplications
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg, categoryResourceResult.EQ),
                    cmd
                ])), categoryResourceResult.at);
            case 5:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    b2: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var subMsg = msg.a;
                var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.lW);
                var depositDropdown = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    lW: depositDropdown
                }), cmd, _List_Nil);
            case 7:
                var depositId = msg.a;
                var newModel = _Utils_update(model, {
                    ac5: depositId,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    z: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ])), _List_Nil);
            case 8:
                var subMsg = msg.a;
                var _v6 = A2($author$project$Ui$Dropdown$update, subMsg, model.mj);
                var feeTypeDropdown = _v6.a;
                var cmd = _v6.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mj: feeTypeDropdown
                }), cmd, _List_Nil);
            case 9:
                var feeType = msg.a;
                var newModel = _Utils_update(model, {
                    PB: feeType,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    z: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ])), _List_Nil);
            case 10:
                var subMsg = msg.a;
                var _v7 = A2($author$project$Ui$Dropdown$update, subMsg, model.nt);
                var paymentProcessorDropdown = _v7.a;
                var cmd = _v7.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    nt: paymentProcessorDropdown
                }), cmd, _List_Nil);
            case 11:
                var paymentProcessor = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    z: $author$project$Api$Data$Loading,
                    Wo: paymentProcessor
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ])), _List_Nil);
            case 12:
                var subMsg = msg.a;
                var _v8 = A2($author$project$Ui$Dropdown$update, subMsg, model.ln);
                var byDropdown = _v8.a;
                var cmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ln: byDropdown
                }), cmd, _List_Nil);
            case 13:
                var by = msg.a;
                var newModel = _Utils_update(model, {
                    bT: by,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    z: $author$project$Api$Data$Loading
                });
                var cmds = function() {
                    var _v9 = _Utils_Tuple2(model.ah5, newModel.bT);
                    if (!_v9.a) {
                        if (!_v9.b.$) {
                            var _v10 = _v9.a;
                            return _List_fromArray([
                                $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                            ]);
                        } else {
                            var _v11 = _v9.a;
                            var _v12 = _v9.b;
                            return _List_fromArray([
                                $elm$core$Platform$Cmd$none
                            ]);
                        }
                    } else if (_v9.b.$ === 1) {
                        var _v13 = _v9.a;
                        var _v14 = _v9.b;
                        return _List_fromArray([
                            $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                        ]);
                    } else {
                        var _v15 = _v9.a;
                        return _List_fromArray([
                            A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                            $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                        ]);
                    }
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(cmds), _List_Nil);
            case 14:
                var subMsg = msg.a;
                var _v16 = A2($author$project$Ui$Dropdown$update, subMsg, model.oT);
                var transactionTypeDropdown = _v16.a;
                var cmd = _v16.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oT: transactionTypeDropdown
                }), cmd, _List_Nil);
            case 15:
                var transactionType = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    z: $author$project$Api$Data$Loading,
                    HS: transactionType
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ])), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v17 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v17.a;
                var subCmd = _v17.b;
                var event = _v17.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            z: $author$project$Api$Data$Loading,
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 3:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b8);
                var _v19 = result.adu;
                switch(_v19.$){
                    case 0:
                        var locationGroupId = _v19.a;
                        var locationId = _v19.b;
                        var practitionerId = _v19.c;
                        var newModel = _Utils_update(model, {
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            z: $author$project$Api$Data$Loading,
                            Xa: practitionerId
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                            $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 16:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        z: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    z: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 17:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $x: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 18:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    z: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ])), _List_Nil);
            case 19:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$PaymentApplications$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$PaymentApplications$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v21 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v21.a;
                var subCmd = _v21.b;
                var subOutMsg = _v21.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$PaymentApplications$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Reports$PaymentApplications$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$PaymentApplications$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$PaymentApplications$PaginationMsg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$amountFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$PaymentApplications$creditTransactionsReportParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('practitioner'), model.Xa)
        ]);
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams);
    };
    var $author$project$Components$Reports$PaymentApplications$BySelected = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$byOptionToLabel = function(byOption) {
        switch(byOption){
            case 0:
                return 'Category';
            case 1:
                return 'Provider';
            case 2:
                return 'Location';
            default:
                return 'Transaction Type';
        }
    };
    var $author$project$Components$Reports$PaymentApplications$byDropdownItems = F2(function(trackPatientsByLocation, currentBy) {
        var baseOptions = _List_fromArray([
            0,
            1,
            3
        ]);
        var allOptions = trackPatientsByLocation ? _Utils_ap(baseOptions, _List_fromArray([
            2
        ])) : baseOptions;
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$BySelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Summary')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(byOption) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$BySelected($elm$core$Maybe$Just(byOption))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just(byOption)))
            ]), $elm$html$Html$text($author$project$Components$Reports$PaymentApplications$byOptionToLabel(byOption)));
        }, allOptions)));
    });
    var $author$project$Components$Reports$PaymentApplications$viewByDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.bT;
            if (!_v0.$) {
                var by = _v0.a;
                return $author$project$Components$Reports$PaymentApplications$byOptionToLabel(by);
            } else return 'Summarize By';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), A2($author$project$Components$Reports$PaymentApplications$byDropdownItems, model.aaq, model.bT), model.ln);
    };
    var $author$project$Components$Reports$PaymentApplications$viewCategoryResourceFilter = function(categoryResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), categoryResourceFilter));
    };
    var $author$project$Components$Reports$PaymentApplications$DateFilterTypeSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel = function(dateFilterType) {
        if (!dateFilterType) return 'Transacted';
        else return 'Deposited';
    };
    var $author$project$Components$Reports$PaymentApplications$viewDateFilterTypeDropdown = function(model) {
        var currentLabel = $author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel(model.E6);
        var allTypes = _List_fromArray([
            0,
            1
        ]);
        var items = A2($elm$core$List$map, function(dateFilterType) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$DateFilterTypeSelected(dateFilterType)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.E6, dateFilterType))
            ]), $elm$html$Html$text($author$project$Components$Reports$PaymentApplications$dateFilterTypeToLabel(dateFilterType)));
        }, allTypes);
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(currentLabel)
        ]), items, model.lQ);
    };
    var $author$project$Components$Reports$PaymentApplications$DepositSelected = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Provider$Deposit$Shared$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Deposit$All$amountInCents = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Deposit$Shared$amountInCents(shared);
    };
    var $author$project$Api$Provider$Deposit$Shared$availableOn = function(_v0) {
        var record = _v0;
        return record.J$;
    };
    var $author$project$Api$Provider$Deposit$All$availableOn = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Deposit$Shared$availableOn(shared);
    };
    var $author$project$Components$Reports$PaymentApplications$depositLabel = function(deposit) {
        return $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Deposit$All$amountInCents(deposit)) + (' on ' + A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Deposit$All$availableOn(deposit)));
    };
    var $author$project$Api$Provider$Deposit$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Deposit$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$Deposit$Shared$id(shared);
    };
    var $author$project$Components$Reports$PaymentApplications$depositDropdownItems = F2(function(deposits, currentDepositId) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$DepositSelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentDepositId, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Deposits')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(deposit) {
            var depositId = $author$project$Api$Provider$Deposit$All$id(deposit);
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$DepositSelected($elm$core$Maybe$Just(depositId))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentDepositId, $elm$core$Maybe$Just(depositId)))
            ]), $elm$html$Html$text($author$project$Components$Reports$PaymentApplications$depositLabel(deposit)));
        }, deposits)));
    });
    var $author$project$Components$Reports$PaymentApplications$viewDepositDropdown = function(model) {
        var placeholder = function() {
            var _v1 = model.ac5;
            if (!_v1.$) {
                var depositId = _v1.a;
                var _v2 = model.b2;
                if (_v2.$ === 3) {
                    var deposits = _v2.a;
                    return A2($elm$core$Maybe$withDefault, depositId, A2($elm$core$Maybe$map, $author$project$Components$Reports$PaymentApplications$depositLabel, $elm$core$List$head(A2($elm$core$List$filter, function(deposit) {
                        return _Utils_eq($author$project$Api$Provider$Deposit$All$id(deposit), depositId);
                    }, deposits))));
                } else return depositId;
            } else return 'Deposit';
        }();
        var items = function() {
            var _v0 = model.b2;
            if (_v0.$ === 3) {
                var deposits = _v0.a;
                return A2($author$project$Components$Reports$PaymentApplications$depositDropdownItems, deposits, model.ac5);
            } else return _List_Nil;
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), items, model.lW);
    };
    var $author$project$Components$Reports$PaymentApplications$FeeTypeSelected = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$feeTypeToLabel = function(feeType) {
        switch(feeType){
            case 0:
                return 'Bank Transfer';
            case 1:
                return 'Card (Non Amex)';
            case 2:
                return 'American Express';
            case 3:
                return 'All External';
            default:
                return 'Cash/Check/Other';
        }
    };
    var $author$project$Components$Reports$PaymentApplications$feeTypeDropdownItems = function(currentFeeType) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$FeeTypeSelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentFeeType, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Payment Types')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(feeType) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$FeeTypeSelected($elm$core$Maybe$Just(feeType))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentFeeType, $elm$core$Maybe$Just(feeType)))
            ]), $elm$html$Html$text($author$project$Components$Reports$PaymentApplications$feeTypeToLabel(feeType)));
        }, _List_fromArray([
            0,
            1,
            2,
            3,
            4
        ]))));
    };
    var $author$project$Components$Reports$PaymentApplications$viewFeeTypeDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.PB;
            if (!_v0.$) {
                var feeType = _v0.a;
                return $author$project$Components$Reports$PaymentApplications$feeTypeToLabel(feeType);
            } else return 'Payment Type';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), $author$project$Components$Reports$PaymentApplications$feeTypeDropdownItems(model.PB), model.mj);
    };
    var $author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$paymentProcessorDropdownItems = F2(function(isHintAdmin, currentProcessor) {
        return _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected($elm$core$Maybe$Nothing)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentProcessor, $elm$core$Maybe$Nothing))
            ]), $elm$html$Html$text('All Processors')),
            $author$project$Ui$Dropdown$separator,
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected($elm$core$Maybe$Just('rainforest'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentProcessor, $elm$core$Maybe$Just('rainforest')))
            ]), $elm$html$Html$text(A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'rainforest'))),
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$PaymentProcessorSelected($elm$core$Maybe$Just('stripe'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentProcessor, $elm$core$Maybe$Just('stripe')))
            ]), $elm$html$Html$text(A2($author$project$Utils$PaymentProcessor$toLabelText, isHintAdmin, 'stripe')))
        ]);
    });
    var $author$project$Components$Reports$PaymentApplications$viewPaymentProcessorDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.Wo;
            if (!_v0.$) {
                var processor = _v0.a;
                return $elm$html$Html$text(A2($author$project$Utils$PaymentProcessor$toLabelText, model.F3, processor));
            } else return $elm$html$Html$text('Payment Processor');
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            placeholder
        ]), A2($author$project$Components$Reports$PaymentApplications$paymentProcessorDropdownItems, model.F3, model.Wo), model.nt);
    };
    var $author$project$Ui$Table$alignBottom = $author$project$Ui$Table$VerticalAlignedBottom;
    var $author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents = function(_v0) {
        var record = _v0;
        return record.pc.QO;
    };
    var $author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents = function(_v0) {
        var record = _v0;
        return record.pc.$h;
    };
    var $author$project$Api$Provider$Reports$Summary$summaryRowTotalFeeInCents = function(_v0) {
        var record = _v0;
        return record.pc.aak;
    };
    var $author$project$Components$Reports$PaymentApplications$feePlanTypeAmounts = F2(function(feePlanType, summaryRow) {
        if (!feePlanType) return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                $elm$html$Html$text('Platform Fees'),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents(summaryRow)))
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                $elm$html$Html$text('Stripe Fees'),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents(summaryRow)))
                ]))
            ]))
        ]);
        else return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                $elm$html$Html$text('Transaction Fees'),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowTotalFeeInCents(summaryRow)))
                ]))
            ]))
        ]);
    });
    var $author$project$Components$Reports$PaymentApplications$viewSummaryRow = F2(function(model, summaryRow) {
        var routeParams = _List_fromArray([
            $author$project$Ui$Link$routeParams(A2($author$project$Utils$Report$summaryRowTableParams, $author$project$Components$Reports$PaymentApplications$urlParams(model), summaryRow))
        ]);
        var netInCents = $author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow) - $author$project$Api$Provider$Reports$Summary$summaryRowHintFeeInCents(summaryRow) - $author$project$Api$Provider$Reports$Summary$summaryRowStripeFeeInCents(summaryRow);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$alignBottom
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$info
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__PaymentApplications, routeParams, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'None', $author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$alignBottom
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__PaymentApplications, routeParams, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'payment application', $author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, A2($elm$core$List$cons, A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                $elm$html$Html$text('Net Amount'),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt(netInCents))
                ]))
            ])), _Utils_ap(A2($author$project$Components$Reports$PaymentApplications$feePlanTypeAmounts, model.PA, summaryRow), _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_fromArray([
                    $author$project$Ui$HorizontalRule$thin
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textRight
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__PaymentApplications, routeParams, _List_fromArray([
                            $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
                        ]))
                    ]))
                ]))
            ]))))
        ]));
    });
    var $author$project$Components$Reports$PaymentApplications$viewSummaryTable = function(model) {
        var summaryType = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize), $author$project$Api$Data$toMaybe(model.$x)));
        var summaryRows = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Summary$summaryRows, $author$project$Api$Data$toMaybe(model.$x)));
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.$x)),
            $author$project$Ui$Table$zeroState(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text(summaryType)
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Number of Payment Applications')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Reports$PaymentApplications$viewSummaryRow(model), summaryRows), _List_Nil);
    };
    var $author$project$Components$Reports$PaymentApplications$SortTable = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Ui$Typography$Amount = {
        $: 10
    };
    var $author$project$Ui$Typography$amount = $author$project$Ui$Typography$Amount;
    var $author$project$Api$Provider$Reports$PaymentApplication$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$category = function(_v0) {
        var record = _v0;
        return record.EL;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$charge = function(_v0) {
        var record = _v0;
        return record.ach;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$deposit = function(_v0) {
        var record = _v0;
        return record.ql;
    };
    var $author$project$Components$Reports$PaymentApplications$depositParams = function(deposit) {
        return _List_fromArray([
            A2($elm$url$Url$Builder$string, 'start', $author$project$Utils$Date$toQuery($author$project$Api$Provider$Deposit$Shared$availableOn(deposit))),
            A2($elm$url$Url$Builder$string, 'end', $author$project$Utils$Date$toQuery($author$project$Api$Provider$Deposit$Shared$availableOn(deposit)))
        ]);
    };
    var $author$project$Api$Provider$Receipt$Shared$feeType = function(_v0) {
        var record = _v0;
        return record.PB;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$hintFeeInCents = function(_v0) {
        var record = _v0;
        return record.QO;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$invoice = function(_v0) {
        var record = _v0;
        return record.RA;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$location = function(_v0) {
        var record = _v0;
        return record.aeT;
    };
    var $author$project$Api$Provider$Receipt$Shared$objectType = function(_v0) {
        var record = _v0;
        return record.Vg;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$patient = function(_v0) {
        var record = _v0;
        return record.V7;
    };
    var $author$project$Api$Provider$Receipt$Shared$paymentProcessor = function(_v0) {
        var record = _v0;
        return record.Wo;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$practitioner = function(_v0) {
        var record = _v0;
        return record.agi;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$receipt = function(_v0) {
        var record = _v0;
        return record.Ye;
    };
    var $author$project$Api$Provider$Deposit$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$stripeFeeInCents = function(_v0) {
        var record = _v0;
        return record.$h;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$totalFeeInCents = function(_v0) {
        var record = _v0;
        return record.aak;
    };
    var $author$project$Api$Provider$Reports$PaymentApplication$transactionDate = function(_v0) {
        var record = _v0;
        return record.aat;
    };
    var $author$project$Api$Provider$Receipt$Shared$expectedDepositDate = function(_v0) {
        var record = _v0;
        return record.Pc;
    };
    var $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit = function(paymentApplication) {
        var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Provider$Receipt$Shared$expectedDepositDate, $author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication));
        if (!_v0.$) {
            var expectedDepositDate = _v0.a;
            return A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('Expected deposit date: '),
                $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, expectedDepositDate))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Components$Reports$PaymentApplications$viewRow = F5(function(feePlanType, trackPatientsByLocation, canGoToPatients, isHintAdmin, paymentApplication) {
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$PaymentApplication$transactionDate(paymentApplication))),
                    function() {
                        var _v0 = $author$project$Api$Provider$Reports$PaymentApplication$deposit(paymentApplication);
                        if (!_v0.$) {
                            var deposit = _v0.a;
                            return $author$project$Api$Provider$Deposit$Shared$status(deposit) === 5 ? $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit(paymentApplication) : A2($author$project$Ui$Typography$p, _List_fromArray([
                                $author$project$Ui$Typography$small,
                                $author$project$Ui$Typography$muted
                            ]), _List_fromArray([
                                $elm$html$Html$text('Deposited '),
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Deposits, _List_fromArray([
                                    $author$project$Ui$Link$routeParams($author$project$Components$Reports$PaymentApplications$depositParams(deposit))
                                ]), _List_fromArray([
                                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Deposit$Shared$amountInCents(deposit))),
                                    $elm$html$Html$text(' on '),
                                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Deposit$Shared$availableOn(deposit)))
                                ]))
                            ]));
                        } else return $author$project$Components$Reports$PaymentApplications$viewDateWithoutDeposit(paymentApplication);
                    }()
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Receipt$Shared$objectType, $author$project$Formatters$String$humanize), $author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication)))),
                    $elm$html$Html$text(' '),
                    A2($author$project$Ui$Typography$span, A2($elm$core$List$cons, $author$project$Ui$Typography$small, A2($elm$core$List$cons, $author$project$Ui$Typography$amount, $author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication) < 0 ? _List_fromArray([
                        $author$project$Ui$Typography$danger
                    ]) : _List_Nil)), _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication)))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('Fee Category: ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Receipt$Shared$feeType, $author$project$Api$Provider$Reports$PaymentApplication$receipt(paymentApplication)))),
                        A2($elm$html$Html$br, _List_Nil, _List_Nil),
                        A2($elm$html$Html$span, _List_Nil, function() {
                            if (!feePlanType) return _List_fromArray([
                                $elm$html$Html$text('Platform Fee: ' + $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$PaymentApplication$hintFeeInCents(paymentApplication))),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                $elm$html$Html$text('Stripe Fee: ' + $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$PaymentApplication$stripeFeeInCents(paymentApplication)))
                            ]);
                            else return _List_fromArray([
                                $elm$html$Html$text('Transaction Fee: ' + $author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$PaymentApplication$totalFeeInCents(paymentApplication)))
                            ]);
                        }())
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$PaymentApplication$amountInCents(paymentApplication))),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('for '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Charge$name, $author$project$Api$Provider$Reports$PaymentApplication$charge(paymentApplication))))
                        ])),
                        $elm$html$Html$text(' on ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Charge$serviceDate, $author$project$Api$Provider$Reports$PaymentApplication$charge(paymentApplication)))))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, function() {
                    var _v2 = $author$project$Api$Provider$Reports$PaymentApplication$invoice(paymentApplication);
                    if (!_v2.$) {
                        var invoice = _v2.a;
                        var paidBy = A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('paid by ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))))
                        ]));
                        var invoicePath_ = function() {
                            var _v4 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
                            switch(_v4){
                                case 1:
                                    var _v5 = _Utils_Tuple2(canGoToPatients, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
                                    if (_v5.a && !_v5.b.$) {
                                        var owner = _v5.b.a;
                                        return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                            RI: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
                                            V8: $author$project$Api$Common$Payable$Owner$Min$id(owner)
                                        }));
                                    } else return $elm$core$Maybe$Nothing;
                                case 0:
                                    var _v6 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice);
                                    if (!_v6.$) {
                                        var owner = _v6.a;
                                        return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                                            fl: $author$project$Api$Common$Payable$Owner$Min$id(owner),
                                            aef: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
                                        }));
                                    } else return $elm$core$Maybe$Nothing;
                                default:
                                    return $elm$core$Maybe$Nothing;
                            }
                        }();
                        var invoiceNumber = $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)));
                        if (!invoicePath_.$) {
                            var path = invoicePath_.a;
                            return _List_fromArray([
                                A3($author$project$Ui$Link$route, path, _List_Nil, _List_fromArray([
                                    invoiceNumber
                                ])),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                paidBy
                            ]);
                        } else return _List_fromArray([
                            invoiceNumber,
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            paidBy
                        ]);
                    } else return _List_Nil;
                }()),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), function() {
                        var _v7 = _Utils_Tuple2($author$project$Api$Provider$Reports$PaymentApplication$patient(paymentApplication), canGoToPatients);
                        if (!_v7.a.$) {
                            if (_v7.b) {
                                var patient = _v7.a.a;
                                return _List_fromArray([
                                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                        V8: $author$project$Api$Provider$Patient$Min$id(patient)
                                    }), _List_Nil, _List_fromArray([
                                        $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, $author$project$Api$Provider$Patient$Min$name(patient)))
                                    ]))
                                ]);
                            } else {
                                var patient = _v7.a.a;
                                return _List_fromArray([
                                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, $author$project$Api$Provider$Patient$Min$name(patient)))
                                ]);
                            }
                        } else {
                            var _v8 = _v7.a;
                            return _List_fromArray([
                                $elm$html$Html$text('N/A')
                            ]);
                        }
                    }())
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$name, $author$project$Api$Provider$Reports$PaymentApplication$category(paymentApplication))))
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(trackPatientsByLocation ? 1 : 2)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$name, $author$project$Api$Provider$Reports$PaymentApplication$practitioner(paymentApplication)))))
                ]))
            ]),
            trackPatientsByLocation ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$Reports$PaymentApplication$location(paymentApplication)))))
                ]))
            ]) : _List_Nil,
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A4($author$project$Utils$PaymentProcessor$toBadge, true, isHintAdmin, paymentApplication, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$PaymentApplication$receipt, $elm$core$Maybe$andThen($author$project$Api$Provider$Receipt$Shared$paymentProcessor))))
                ]))
            ])
        ])));
    });
    var $author$project$Components$Reports$PaymentApplications$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.z;
            if (_v1.$ === 3) {
                var paymentApplications_ = _v1.a;
                return _Utils_Tuple2(false, paymentApplications_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var paymentApplications = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$PaymentApplications$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$PaymentApplications$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A4($author$project$Components$Reports$PaymentApplications$viewRow, model.PA, model.aaq, model.EF, model.F3), paymentApplications), _List_Nil);
    };
    var $author$project$Components$Reports$PaymentApplications$TransactionTypeSelected = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Components$Reports$PaymentApplications$transactionTypeToLabel = function(transactionType) {
        switch(transactionType){
            case 0:
                return 'All Transactions';
            case 1:
                return 'Payments';
            default:
                return 'Refunds';
        }
    };
    var $author$project$Components$Reports$PaymentApplications$transactionTypeDropdownItems = function(currentTransactionType) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$TransactionTypeSelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentTransactionType, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Transaction Types')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(transactionType) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$PaymentApplications$TransactionTypeSelected($elm$core$Maybe$Just(transactionType))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentTransactionType, $elm$core$Maybe$Just(transactionType)))
            ]), $elm$html$Html$text($author$project$Components$Reports$PaymentApplications$transactionTypeToLabel(transactionType)));
        }, _List_fromArray([
            1,
            2
        ]))));
    };
    var $author$project$Components$Reports$PaymentApplications$viewTransactionTypeDropdownFilter = function(model) {
        var placeholder = function() {
            var _v0 = model.HS;
            if (!_v0.$) {
                var transactionType = _v0.a;
                return $author$project$Components$Reports$PaymentApplications$transactionTypeToLabel(transactionType);
            } else return 'Transaction Type';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), $author$project$Components$Reports$PaymentApplications$transactionTypeDropdownItems(model.HS), model.oT);
    };
    var $author$project$Components$Reports$PaymentApplications$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$PaymentApplications$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.z)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$PaymentApplication$listOptionsToParams, $author$project$Components$Reports$PaymentApplications$fetchPaymentApplicationsParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Received Payments')
                    ])),
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.z;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            var totalPassthroughFeesAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-passthrough-fee-amount');
                            var totalFeeAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-fee-amount');
                            var totalAmount = A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-amount');
                            var totalNetAmount = totalAmount - totalFeeAmount;
                            return _List_fromArray([
                                $elm$html$Html$text($author$project$Utils$Currency$fromInt(totalAmount)),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$small,
                                    $author$project$Ui$Typography$muted
                                ]), _List_fromArray([
                                    $elm$html$Html$text(' Net ' + ($author$project$Utils$Currency$fromInt(totalNetAmount) + (' across ' + A2($author$project$Formatters$String$pluralize, 'payment application', A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-count')))))
                                ])),
                                function() {
                                    var _v1 = model.PA;
                                    if (!_v1) return A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$small,
                                        $author$project$Ui$Typography$muted
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(' including ' + ($author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-hint-fee-amount')) + (' in Platform fees and ' + ($author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$PaymentApplications$amountFromHeader, headers, 'x-total-stripe-fee-amount')) + ' in Stripe fees.'))))
                                    ]));
                                    else return A2($author$project$Ui$Typography$span, _List_fromArray([
                                        $author$project$Ui$Typography$small,
                                        $author$project$Ui$Typography$muted
                                    ]), _List_fromArray([
                                        $elm$html$Html$text(' including ' + ($author$project$Utils$Currency$fromInt(totalFeeAmount) + ' in transaction fees.'))
                                    ]));
                                }(),
                                function() {
                                    if (totalPassthroughFeesAmount > 0) {
                                        var nonPassthroughFeesAmount = totalFeeAmount - totalPassthroughFeesAmount;
                                        var passthroughFeesText = ' Of those fees, ' + ($author$project$Utils$Currency$fromInt(totalPassthroughFeesAmount) + (' were paid by patients and ' + ($author$project$Utils$Currency$fromInt(nonPassthroughFeesAmount) + ' by your practice.')));
                                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                                            $author$project$Ui$Typography$small,
                                            $author$project$Ui$Typography$muted
                                        ]), _List_fromArray([
                                            $elm$html$Html$text(passthroughFeesText)
                                        ]));
                                    } else return $author$project$Utils$Html$empty;
                                }()
                            ]);
                        } else return _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$spaceX2
                            ]), _List_fromArray([
                                $author$project$Ui$Skeleton$text(_List_fromArray([
                                    $author$project$Ui$Skeleton$spanFromText('$1000.00')
                                ])),
                                A2($author$project$Ui$Typography$span, _List_fromArray([
                                    $author$project$Ui$Typography$small
                                ]), _List_fromArray([
                                    $author$project$Ui$Skeleton$text(_List_fromArray([
                                        $author$project$Ui$Skeleton$span(5)
                                    ]))
                                ]))
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Total payments (and refunds) applied to charges, excluding '),
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditTransactions, _List_fromArray([
                            $author$project$Ui$Link$routeParams($author$project$Components$Reports$PaymentApplications$creditTransactionsReportParams(model))
                        ]), _List_fromArray([
                            $elm$html$Html$text('credit transactions')
                        ])),
                        $elm$html$Html$text('.')
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(3)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$PaymentApplications$viewDateFilterTypeDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(9)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Reports$PaymentApplications$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$spanMd(4)
                    ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                        $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
                    ]), model.b8))), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$PaymentApplications$viewCategoryResourceFilter(model.cK)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$PaymentApplications$viewDepositDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$PaymentApplications$viewFeeTypeDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$PaymentApplications$viewPaymentProcessorDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$PaymentApplications$viewByDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$PaymentApplications$viewTransactionTypeDropdownFilter(model)
                        ]))
                    ]))),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$PaymentApplications$CategoryResourceFilterMsg), $author$project$Components$ResourceFilter$Category$viewMultiSelected(model.cK)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$PaymentApplications$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b8)));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                function() {
                    var _v2 = model.ah5;
                    if (!_v2) return $author$project$Components$Reports$PaymentApplications$viewTable(model);
                    else return $author$project$Components$Reports$PaymentApplications$viewSummaryTable(model);
                }(),
                function() {
                    var _v3 = model.ah5;
                    if (!_v3) return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$PaymentApplications$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.z)))
                        ]), model.af_))
                    ]));
                    else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]);
    });
    var $author$project$Pages$Reports$PaymentApplications$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$PaymentApplications$view, model.Ej, model.jQ)),
            $2: 'Reports | Received Payments'
        };
    };
    var $author$project$Pages$Reports$PaymentApplications$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$PaymentApplications$init,
        aeR: $author$project$Pages$Reports$PaymentApplications$load,
        ag3: $author$project$Pages$Reports$PaymentApplications$save,
        ahE: $author$project$Pages$Reports$PaymentApplications$subscriptions,
        aaO: $author$project$Pages$Reports$PaymentApplications$update,
        aid: $author$project$Pages$Reports$PaymentApplications$view
    });
    var $author$project$Pages$Reports$PaymentApplications$Summary$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$PaymentApplications$Summary = 1;
    var $author$project$Pages$Reports$PaymentApplications$Summary$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$PaymentApplications$init, 1, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$PaymentApplications$Summary$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$PaymentApplications$Summary$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$PaymentApplications$Summary$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$PaymentApplications$subscriptions(model.jQ));
    };
    var $author$project$Pages$Reports$PaymentApplications$Summary$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$PaymentApplications$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Reports$PaymentApplications$Summary$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$PaymentApplications$view, model.Ej, model.jQ)),
            $2: 'Reports | Received Payments'
        };
    };
    var $author$project$Pages$Reports$PaymentApplications$Summary$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$PaymentApplications$Summary$init,
        aeR: $author$project$Pages$Reports$PaymentApplications$Summary$load,
        ag3: $author$project$Pages$Reports$PaymentApplications$Summary$save,
        ahE: $author$project$Pages$Reports$PaymentApplications$Summary$subscriptions,
        aaO: $author$project$Pages$Reports$PaymentApplications$Summary$update,
        aid: $author$project$Pages$Reports$PaymentApplications$Summary$view
    });
    var $author$project$Pages$Reports$Revenue$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$Revenue$Table = 0;
    var $author$project$Components$Reports$Revenue$ByDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$Revenue$DateRangeInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$RevenueLine = 6;
    var $author$project$Components$Reports$Revenue$urlParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('category'), model.fg),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location'), model.Tp),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('practitioner'), model.Xa),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('by'), model.bT)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Components$Reports$Revenue$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            function() {
                var _v0 = model.bT;
                if (!_v0.$) return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Revenue__Summary);
                else return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__Revenue);
            }()
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), $author$project$Utils$QueryParameter$fromDict($author$project$Components$Reports$Revenue$urlParams(model)))));
    };
    var $author$project$Components$Reports$Revenue$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$Revenue$GotRevenueLines = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$Revenue$fetchRevenueLinesParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                EL: model.fg,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                af_: model.af_,
                agi: model.Xa,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Api$Provider$Reports$RevenueLine$RevenueLine = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$RevenueLine$Record = F8(function(transactionDate, amountInCents, category, charge, invoice, client, practitioner, location1) {
        return {
            Jh: amountInCents,
            EL: category,
            ach: charge,
            Li: client,
            RA: invoice,
            aeT: location1,
            agi: practitioner,
            aat: transactionDate
        };
    });
    var $author$project$Api$Provider$Reports$RevenueLine$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'client', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$RevenueLine$Client$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'charge', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Reports$Charge$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'category', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Category$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transaction_date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$RevenueLine$Record)))))))));
    var $author$project$Api$Provider$Reports$RevenueLine$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$RevenueLine$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$RevenueLine$listDefaults = {
        EL: $elm$core$Maybe$Nothing,
        Fn: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agi: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$RevenueLine$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.EL;
                if (!_v2.$) {
                    var taxJurisdiction_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'category', taxJurisdiction_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.rm;
                if (!_v3.$) {
                    var locationGroup_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', locationGroup_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.aeT;
                if (!_v4.$) {
                    var location_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', location_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.agi;
                if (!_v5.$) {
                    var practitioner_ = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', practitioner_)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$RevenueLine$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'revenue_lines'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$RevenueLine$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$RevenueLine$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$RevenueLine$listPath)));
    });
    var $author$project$Components$Reports$Revenue$fetchRevenueLines = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$RevenueLine$list, apiClient, $author$project$Components$Reports$Revenue$fetchRevenueLinesParams(model), $author$project$Components$Reports$Revenue$GotRevenueLines);
    });
    var $author$project$Components$Reports$Revenue$GotSummary = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$Revenue$fetchSummaryParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                EL: model.fg,
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                agi: model.Xa,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB)
            });
        };
    };
    var $author$project$Api$Provider$Reports$RevenueLine$summary = F4(function(apiClient, by, optionals, toMsg) {
        return A5($author$project$Api$Provider$Reports$Summary$retrieve, apiClient, $author$project$Api$Provider$Reports$RevenueLine$listPath, by, $author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams(optionals), toMsg);
    });
    var $author$project$Components$Reports$Revenue$fetchSummary = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$Reports$RevenueLine$summary, apiClient, A2($elm$core$Maybe$withDefault, '', model.bT), $author$project$Components$Reports$Revenue$fetchSummaryParams(model), $author$project$Components$Reports$Revenue$GotSummary);
    });
    var $author$project$Components$Reports$Revenue$fetchData = F2(function(apiClient, model) {
        var _v0 = model.ah5;
        if (!_v0) return A2($author$project$Components$Reports$Revenue$fetchRevenueLines, apiClient, model);
        else return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Reports$Revenue$fetchSummary, apiClient, model),
            A2($author$project$Components$Reports$Revenue$fetchRevenueLines, apiClient, model)
        ]));
    });
    var $author$project$Components$Reports$Revenue$initColumns = function(trackPatientsByLocation) {
        return A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Charge'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'client', true, 'Client'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'category', true, 'Category'), A2($elm$core$List$cons, A3($author$project$Api$Column$init, 'practitioner', true, 'Provider'), trackPatientsByLocation ? _List_fromArray([
            A3($author$project$Api$Column$init, 'location', true, 'Location')
        ]) : _List_Nil))))));
    };
    var $author$project$Components$Reports$Revenue$init = F5(function(type_, session, practice, _v0, query) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var categoryId = A2($elm$core$Dict$get, 'category', query);
        var _v1 = function() {
            if (!type_) return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
            else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
        }();
        var revenueLines = _v1.a;
        var summary = _v1.b;
        var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v3.a;
        var groupLocationAndPractitionerFiltersCmd = _v3.b;
        var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v4.a;
        var end = _v4.b;
        var _v5 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$Revenue$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v5.a;
        var dateRangeInputCmd = _v5.b;
        var _v6 = A3($author$project$Utils$Report$CategoryResourceFilter$init, apiClient, session, categoryId);
        var categoryResourceFilter = _v6.a;
        var categoryResourceFilterCmd = _v6.b;
        var model = {
            bT: A2($elm$core$Dict$get, 'by', query),
            ln: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'by-dropdown',
                ahX: $author$project$Components$Reports$Revenue$ByDropdownMsg
            })),
            EE: A3($author$project$Permission$canGoTo, session, hinterViewOff, 17),
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            fg: categoryId,
            cK: categoryResourceFilter,
            LC: $author$project$Components$Reports$Revenue$initColumns(trackPatientsByLocation),
            cP: currentDate,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 6
            }),
            b8: groupLocationAndPractitionerFilters,
            f0: locationGroupId,
            Tp: locationId,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            Xa: practitionerId,
            aP: revenueLines,
            ahs: A3($author$project$Api$Sort$withDefault, 'transaction_date', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            $x: summary,
            aaq: trackPatientsByLocation,
            ah5: type_
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg, categoryResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($author$project$Components$Reports$Revenue$fetchData, apiClient, model),
            A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Reports$Revenue$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$Revenue$init, 0, session, practice, shared, query);
        var report = _v1.a;
        var reportTaxCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
    });
    var $author$project$Pages$Reports$Revenue$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Revenue$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$Revenue$ExportCsvMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$Revenue$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Revenue$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Revenue$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b8)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg, $author$project$Components$ResourceFilter$Category$subscriptions(model.cK)),
            $author$project$Ui$Dropdown$subscriptions(model.ln)
        ]));
    };
    var $author$project$Pages$Reports$Revenue$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$Revenue$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$Revenue$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 2:
                var subMsg = msg.a;
                var categoryResourceResult = A3($author$project$Components$ResourceFilter$Category$update, apiClient, subMsg, model.cK);
                var categoryId = function() {
                    var _v2 = categoryResourceResult.adu;
                    if (!_v2.$) {
                        if (!_v2.a.$) return $author$project$Components$ResourceFilter$Category$value(categoryResourceResult.zi);
                        else {
                            var _v3 = _v2.a;
                            return model.fg;
                        }
                    } else return model.fg;
                }();
                var newModel = _Utils_update(model, {
                    fg: categoryId,
                    cK: categoryResourceResult.zi
                });
                var _v1 = _Utils_eq(model.fg, newModel.fg) ? _Utils_Tuple2(model.aP, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var revenueLines = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    aP: revenueLines
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg, categoryResourceResult.EQ),
                    cmd
                ])), categoryResourceResult.at);
            case 3:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.ln);
                var byDropdown = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ln: byDropdown
                }), cmd, _List_Nil);
            case 4:
                var by = msg.a;
                var newModel = _Utils_update(model, {
                    bT: by,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    aP: $author$project$Api$Data$Loading
                });
                var cmds = function() {
                    var _v5 = _Utils_Tuple2(model.ah5, newModel.bT);
                    if (!_v5.a) {
                        if (!_v5.b.$) {
                            var _v6 = _v5.a;
                            return _List_fromArray([
                                A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                            ]);
                        } else {
                            var _v7 = _v5.a;
                            var _v8 = _v5.b;
                            return _List_fromArray([
                                $elm$core$Platform$Cmd$none
                            ]);
                        }
                    } else if (_v5.b.$ === 1) {
                        var _v9 = _v5.a;
                        var _v10 = _v5.b;
                        return _List_fromArray([
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ]);
                    } else {
                        var _v11 = _v5.a;
                        return _List_fromArray([
                            A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ]);
                    }
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(cmds), _List_Nil);
            case 0:
                var subMsg = msg.a;
                var _v12 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v12.a;
                var subCmd = _v12.b;
                var event = _v12.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            aP: $author$project$Api$Data$Loading,
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b8);
                var _v14 = result.adu;
                switch(_v14.$){
                    case 0:
                        var locationGroupId = _v14.a;
                        var locationId = _v14.b;
                        var practitionerId = _v14.c;
                        var newModel = _Utils_update(model, {
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            Xa: practitionerId,
                            aP: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
                            A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 5:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        aP: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    aP: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 6:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $x: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 7:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    aP: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 8:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$Revenue$fetchData, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$Revenue$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v16 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v16.a;
                var subCmd = _v16.b;
                var subOutMsg = _v16.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$Revenue$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Reports$Revenue$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$Revenue$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$Revenue$PaginationMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$Revenue$amountFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$Revenue$BySelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$Revenue$byDropdownItems = F2(function(trackPatientsByLocation, currentBy) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Revenue$BySelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Summary')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Revenue$BySelected($elm$core$Maybe$Just('category'))),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('category')))
        ]), $elm$html$Html$text('Category')), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Revenue$BySelected($elm$core$Maybe$Just('practitioner'))),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('practitioner')))
        ]), $elm$html$Html$text('Provider')), trackPatientsByLocation ? _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$Revenue$BySelected($elm$core$Maybe$Just('location'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('location')))
            ]), $elm$html$Html$text('Location'))
        ]) : _List_Nil))));
    });
    var $author$project$Components$Reports$Revenue$byToDisplayName = function(by) {
        switch(by){
            case 'category':
                return 'Category';
            case 'practitioner':
                return 'Provider';
            case 'location':
                return 'Location';
            default:
                return by;
        }
    };
    var $author$project$Components$Reports$Revenue$viewByDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.bT;
            if (!_v0.$) {
                var by = _v0.a;
                return $author$project$Components$Reports$Revenue$byToDisplayName(by);
            } else return 'Summarize by';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), A2($author$project$Components$Reports$Revenue$byDropdownItems, model.aaq, model.bT), model.ln);
    };
    var $author$project$Components$Reports$Revenue$viewCategoryResourceFilter = function(categoryResourceFilter) {
        return A2($elm$html$Html$map, $author$project$Components$Reports$Revenue$CategoryResourceFilterMsg, A2($author$project$Components$ResourceFilter$Category$viewNew, _List_fromArray([
            $author$project$Components$ResourceFilter$style(1),
            $author$project$Components$ResourceFilter$multi
        ]), categoryResourceFilter));
    };
    var $author$project$Components$Reports$Revenue$viewSummaryRow = F2(function(model, summaryRow) {
        var routeParams = _List_fromArray([
            $author$project$Ui$Link$routeParams(A2($author$project$Utils$Report$summaryRowTableParams, $author$project$Components$Reports$Revenue$urlParams(model), summaryRow))
        ]);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$info,
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Revenue, routeParams, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Unassigned', $author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Revenue, routeParams, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'charge', $author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Revenue, routeParams, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Reports$Revenue$viewSummaryTable = function(model) {
        var summaryType = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize), $author$project$Api$Data$toMaybe(model.$x)));
        var summaryRows = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Summary$summaryRows, $author$project$Api$Data$toMaybe(model.$x)));
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.$x)),
            $author$project$Ui$Table$zeroState(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text(summaryType)
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Number of Charges')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Reports$Revenue$viewSummaryRow(model), summaryRows), _List_Nil);
    };
    var $author$project$Components$Reports$Revenue$SortTable = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$RevenueLine$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$category = function(_v0) {
        var record = _v0;
        return record.EL;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$charge = function(_v0) {
        var record = _v0;
        return record.ach;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$client = function(_v0) {
        var record = _v0;
        return record.Li;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$invoice = function(_v0) {
        var record = _v0;
        return record.RA;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$location = function(_v0) {
        var record = _v0;
        return record.aeT;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$practitioner = function(_v0) {
        var record = _v0;
        return record.agi;
    };
    var $author$project$Api$Provider$Reports$RevenueLine$transactionDate = function(_v0) {
        var record = _v0;
        return record.aat;
    };
    var $author$project$Components$Reports$Revenue$viewRow = F4(function(trackPatientsByLocation, canGoToPatients, canGoToCompany, revenueLine) {
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$RevenueLine$transactionDate(revenueLine)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$RevenueLine$amountInCents(revenueLine))),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$small,
                        $author$project$Ui$Typography$muted
                    ]), _List_fromArray([
                        $elm$html$Html$text('for '),
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Charge$name, $author$project$Api$Provider$Reports$RevenueLine$charge(revenueLine))))
                        ])),
                        $elm$html$Html$text(' on ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Charge$serviceDate, $author$project$Api$Provider$Reports$RevenueLine$charge(revenueLine)))))
                    ]))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, function() {
                    var _v0 = $author$project$Api$Provider$Reports$RevenueLine$invoice(revenueLine);
                    if (!_v0.$) {
                        var invoice = _v0.a;
                        var invoiceStatus = A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Common$Payable$Invoice$MinWithOwner$status(invoice));
                        var invoicePath_ = function() {
                            var _v2 = $author$project$Api$Common$Payable$Invoice$MinWithOwner$type_(invoice);
                            switch(_v2){
                                case 1:
                                    var _v3 = _Utils_Tuple2(canGoToPatients, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
                                    if (_v3.a && !_v3.b.$) {
                                        var owner = _v3.b.a;
                                        return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                            RI: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
                                            V8: $author$project$Api$Common$Payable$Owner$Min$id(owner)
                                        }));
                                    } else return $elm$core$Maybe$Nothing;
                                case 0:
                                    var _v4 = _Utils_Tuple2(canGoToCompany, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
                                    if (_v4.a && !_v4.b.$) {
                                        var owner = _v4.b.a;
                                        return $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
                                            fl: $author$project$Api$Common$Payable$Owner$Min$id(owner),
                                            aef: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice)
                                        }));
                                    } else return $elm$core$Maybe$Nothing;
                                default:
                                    return $elm$core$Maybe$Nothing;
                            }
                        }();
                        var invoiceNumber = $elm$html$Html$text('#' + ($elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)) + ' '));
                        var _for = A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true),
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$muted
                        ]), _List_fromArray([
                            $elm$html$Html$text('for ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$Payable$Owner$Min$name, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice))))
                        ]));
                        if (!invoicePath_.$) {
                            var path = invoicePath_.a;
                            return _List_fromArray([
                                A3($author$project$Ui$Link$route, path, _List_Nil, _List_fromArray([
                                    invoiceNumber,
                                    invoiceStatus
                                ])),
                                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                                _for
                            ]);
                        } else return _List_fromArray([
                            invoiceNumber,
                            invoiceStatus,
                            A2($elm$html$Html$br, _List_Nil, _List_Nil),
                            _for
                        ]);
                    } else return _List_Nil;
                }()),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), function() {
                        var _v5 = $author$project$Api$Provider$Reports$RevenueLine$client(revenueLine);
                        if (!_v5.$) {
                            var client = _v5.a;
                            var path = function() {
                                var _v7 = $author$project$Api$Provider$Reports$RevenueLine$Client$type_(client);
                                if (!_v7) return canGoToPatients ? $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                                    V8: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
                                })) : $elm$core$Maybe$Nothing;
                                else return canGoToCompany ? $elm$core$Maybe$Just($author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                                    fl: $author$project$Api$Provider$Reports$RevenueLine$Client$id(client)
                                })) : $elm$core$Maybe$Nothing;
                            }();
                            var clientName = $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, $author$project$Api$Provider$Reports$RevenueLine$Client$name(client)));
                            if (!path.$) {
                                var path_ = path.a;
                                return _List_fromArray([
                                    A3($author$project$Ui$Link$route, path_, _List_Nil, _List_fromArray([
                                        clientName
                                    ]))
                                ]);
                            } else return _List_fromArray([
                                clientName
                            ]);
                        } else return _List_fromArray([
                            $elm$html$Html$text('N/A')
                        ]);
                    }())
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Category$Min$name, $author$project$Api$Provider$Reports$RevenueLine$category(revenueLine))))
                ])),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(trackPatientsByLocation ? 1 : 2)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$name, $author$project$Api$Provider$Reports$RevenueLine$practitioner(revenueLine)))))
                ]))
            ]),
            trackPatientsByLocation ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$Reports$RevenueLine$location(revenueLine)))))
                ]))
            ]) : _List_Nil
        ])));
    });
    var $author$project$Components$Reports$Revenue$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.aP;
            if (_v1.$ === 3) {
                var revenueLines_ = _v1.a;
                return _Utils_Tuple2(false, revenueLines_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var revenueLines = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$Revenue$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$Revenue$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A3($author$project$Components$Reports$Revenue$viewRow, model.aaq, model.EF, model.EE), revenueLines), _List_Nil);
    };
    var $author$project$Components$Reports$Revenue$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$Revenue$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.aP)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$RevenueLine$listOptionsToParams, $author$project$Components$Reports$Revenue$fetchRevenueLinesParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Billed Revenue')
                    ])),
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.aP;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$Revenue$amountFromHeader, headers, 'x-total-amount')))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Total billed (and reversed out) revenue across retail customers and employers')
                    ])),
                    A2($elm$html$Html$map, $author$project$Components$Reports$Revenue$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6)),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$spanMd(4)
                    ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                        $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
                    ]), model.b8))), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Revenue$viewCategoryResourceFilter(model.cK)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$Revenue$viewByDropdown(model)
                        ]))
                    ]))),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = _Utils_ap(A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Revenue$CategoryResourceFilterMsg), $author$project$Components$ResourceFilter$Category$viewMultiSelected(model.cK)), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$Revenue$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b8)));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                function() {
                    var _v1 = model.ah5;
                    if (!_v1) return $author$project$Components$Reports$Revenue$viewTable(model);
                    else return $author$project$Components$Reports$Revenue$viewSummaryTable(model);
                }(),
                function() {
                    var _v2 = model.ah5;
                    if (!_v2) return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$Revenue$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.aP)))
                        ]), model.af_))
                    ]));
                    else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]);
    });
    var $author$project$Pages$Reports$Revenue$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$Revenue$view, model.Ej, model.jQ)),
            $2: 'Reports | Billed Revenue'
        };
    };
    var $author$project$Pages$Reports$Revenue$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Revenue$init,
        aeR: $author$project$Pages$Reports$Revenue$load,
        ag3: $author$project$Pages$Reports$Revenue$save,
        ahE: $author$project$Pages$Reports$Revenue$subscriptions,
        aaO: $author$project$Pages$Reports$Revenue$update,
        aid: $author$project$Pages$Reports$Revenue$view
    });
    var $author$project$Pages$Reports$Revenue$Summary$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$Revenue$Summary = 1;
    var $author$project$Pages$Reports$Revenue$Summary$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$Revenue$init, 1, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$Revenue$Summary$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$Revenue$Summary$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$Revenue$Summary$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$Revenue$subscriptions(model.jQ));
    };
    var $author$project$Pages$Reports$Revenue$Summary$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$Revenue$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Reports$Revenue$Summary$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$Revenue$view, model.Ej, model.jQ)),
            $2: 'Reports | Billed Revenue'
        };
    };
    var $author$project$Pages$Reports$Revenue$Summary$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$Revenue$Summary$init,
        aeR: $author$project$Pages$Reports$Revenue$Summary$load,
        ag3: $author$project$Pages$Reports$Revenue$Summary$save,
        ahE: $author$project$Pages$Reports$Revenue$Summary$subscriptions,
        aaO: $author$project$Pages$Reports$Revenue$Summary$update,
        aid: $author$project$Pages$Reports$Revenue$Summary$view
    });
    var $author$project$Pages$Reports$SalesTax$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$SalesTax$Table = 0;
    var $author$project$Components$Reports$SalesTax$ByDropdownMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$DateRangeInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$GotTaxJurisdictions = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$TaxJurisdictionDropdownMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$TaxLine = 8;
    var $author$project$Components$Reports$SalesTax$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$SalesTax$GotSummary = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$fetchSummaryParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                agi: model.Xa,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                tl: model.g1
            });
        };
    };
    var $author$project$Api$Provider$Reports$TaxLine$listDefaults = {
        Fn: $elm$core$Maybe$Nothing,
        aeT: $elm$core$Maybe$Nothing,
        rm: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        agi: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        tl: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$TaxLine$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$TaxLine$listDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.agi;
                if (!_v2.$) {
                    var practitioner_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'practitioner', practitioner_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.tl;
                if (!_v3.$) {
                    var taxJurisdiction_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'tax_jurisdiction', taxJurisdiction_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.rm;
                if (!_v4.$) {
                    var locationGroup_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location_group', locationGroup_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v5 = options.aeT;
                if (!_v5.$) {
                    var location_ = _v5.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'location', location_)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$TaxLine$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'tax_lines'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$TaxLine$summary = F4(function(apiClient, by, optionals, toMsg) {
        return A5($author$project$Api$Provider$Reports$Summary$retrieve, apiClient, $author$project$Api$Provider$Reports$TaxLine$listPath, by, $author$project$Api$Provider$Reports$TaxLine$listOptionsToParams(optionals), toMsg);
    });
    var $author$project$Components$Reports$SalesTax$fetchSummary = F2(function(apiClient, model) {
        return A4($author$project$Api$Provider$Reports$TaxLine$summary, apiClient, A2($elm$core$Maybe$withDefault, '', model.bT), $author$project$Components$Reports$SalesTax$fetchSummaryParams(model), $author$project$Components$Reports$SalesTax$GotSummary);
    });
    var $author$project$Components$Reports$SalesTax$GotTaxLines = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$fetchTaxLinesParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                aeT: model.Tp,
                rm: model.f0,
                af_: model.af_,
                agi: model.Xa,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                tl: model.g1
            });
        };
    };
    var $author$project$Api$Provider$Reports$TaxLine$TaxLine = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$TaxLine$Record = F8(function(transactionDate, amountInCents, rate, serviceDate, taxJurisdiction, invoice, practitioner, location1) {
        return {
            Jh: amountInCents,
            RA: invoice,
            aeT: location1,
            agi: practitioner,
            X5: rate,
            ZZ: serviceDate,
            tl: taxJurisdiction,
            aat: transactionDate
        };
    });
    var $author$project$Api$Provider$TaxJurisdiction$Min$TaxJurisdiction = $elm$core$Basics$identity;
    var $author$project$Api$Provider$TaxJurisdiction$Min$Record = function(name) {
        return {
            zr: name
        };
    };
    var $author$project$Api$Provider$TaxJurisdiction$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$TaxJurisdiction$Min$Record));
    var $author$project$Api$Provider$TaxJurisdiction$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$TaxJurisdiction$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$TaxLine$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'location', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Location$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practitioner', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Practitioner$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'invoice', $elm$json$Json$Decode$nullable($author$project$Api$Common$Payable$Invoice$MinWithOwner$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'tax_jurisdiction', $elm$json$Json$Decode$nullable($author$project$Api$Provider$TaxJurisdiction$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'service_date', $elm$json$Json$Decode$nullable($author$project$Utils$Date$decode), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rate', $elm$json$Json$Decode$float, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'amount_in_cents', $elm$json$Json$Decode$int, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'transaction_date', $author$project$Utils$Date$decode, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$TaxLine$Record)))))))));
    var $author$project$Api$Provider$Reports$TaxLine$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$TaxLine$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$TaxLine$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$TaxLine$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$TaxLine$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$TaxLine$listPath)));
    });
    var $author$project$Components$Reports$SalesTax$fetchTaxLines = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$TaxLine$list, apiClient, $author$project$Components$Reports$SalesTax$fetchTaxLinesParams(model), $author$project$Components$Reports$SalesTax$GotTaxLines);
    });
    var $author$project$Components$Reports$SalesTax$fetchData = F2(function(apiClient, model) {
        var _v0 = model.ah5;
        if (!_v0) return A2($author$project$Components$Reports$SalesTax$fetchTaxLines, apiClient, model);
        else return $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Components$Reports$SalesTax$fetchSummary, apiClient, model),
            A2($author$project$Components$Reports$SalesTax$fetchTaxLines, apiClient, model)
        ]));
    });
    var $author$project$Components$Reports$SalesTax$initColumns = function(trackPatientsByLocation) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A3($author$project$Api$Column$init, 'transaction_date', true, 'Txn Date'),
                A3($author$project$Api$Column$init, 'amount_in_cents', true, 'Amount'),
                A3($author$project$Api$Column$init, 'rate', true, 'Rate'),
                A3($author$project$Api$Column$init, 'charge', true, 'Service Date'),
                A3($author$project$Api$Column$init, 'tax_jurisdiction', true, 'Jurisdiction'),
                A3($author$project$Api$Column$init, 'invoice', false, 'Invoice'),
                A3($author$project$Api$Column$init, 'practitioner', true, 'Provider')
            ]),
            trackPatientsByLocation ? _List_fromArray([
                A3($author$project$Api$Column$init, 'location', true, 'Location')
            ]) : _List_Nil
        ]));
    };
    var $author$project$Components$Reports$SalesTax$urlParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$core$Tuple$pair('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('tax_jurisdiction'), model.g1),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location_group'), model.f0),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('location'), model.Tp),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('practitioner'), model.Xa),
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('by'), model.bT)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Components$Reports$SalesTax$updateUrl = function(model) {
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            function() {
                var _v0 = model.bT;
                if (!_v0.$) return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SalesTax__Summary);
                else return $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SalesTax);
            }()
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), $author$project$Utils$QueryParameter$fromDict($author$project$Components$Reports$SalesTax$urlParams(model))))));
    };
    var $author$project$Components$Reports$SalesTax$init = F5(function(type_, session, practice, _v0, query) {
        var currentDate = _v0.cP;
        var apiClient = _v0.Ej;
        var hinterViewOff = _v0.aeb;
        var trackPatientsByLocation = $author$project$Api$Provider$Practice$One$trackPatientsByLocation(practice);
        var practitionerId = A2($elm$core$Dict$get, 'practitioner', query);
        var locationId = A2($elm$core$Dict$get, 'location', query);
        var locationGroupId = A2($elm$core$Dict$get, 'location_group', query);
        var _v1 = function() {
            if (!type_) return _Utils_Tuple2($author$project$Api$Data$Loading, $author$project$Api$Data$NotAsked);
            else return _Utils_Tuple2($author$project$Api$Data$NotAsked, $author$project$Api$Data$Loading);
        }();
        var taxLines = _v1.a;
        var summary = _v1.b;
        var _v3 = A7($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$init, apiClient, session, practice, false, locationGroupId, locationId, practitionerId);
        var groupLocationAndPractitionerFilters = _v3.a;
        var groupLocationAndPractitionerFiltersCmd = _v3.b;
        var _v4 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v4.a;
        var end = _v4.b;
        var _v5 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$SalesTax$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v5.a;
        var dateRangeInputCmd = _v5.b;
        var model = {
            bT: A2($elm$core$Dict$get, 'by', query),
            ln: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'by-dropdown',
                ahX: $author$project$Components$Reports$SalesTax$ByDropdownMsg
            })),
            EF: A3($author$project$Permission$canGoTo, session, hinterViewOff, 44),
            LC: $author$project$Components$Reports$SalesTax$initColumns(trackPatientsByLocation),
            cP: currentDate,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 8
            }),
            b8: groupLocationAndPractitionerFilters,
            f0: locationGroupId,
            Tp: locationId,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            Xa: practitionerId,
            ahs: A3($author$project$Api$Sort$withDefault, 'transaction_date', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            $x: summary,
            oL: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'tax-jurisdiction-dropdown',
                ahX: $author$project$Components$Reports$SalesTax$TaxJurisdictionDropdownMsg
            })),
            g1: A2($elm$core$Dict$get, 'tax_jurisdiction', query),
            $Q: $author$project$Api$Data$Loading,
            bl: taxLines,
            aaq: trackPatientsByLocation,
            ah5: type_
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$TaxJurisdiction$list, apiClient, $author$project$Components$Reports$SalesTax$GotTaxJurisdictions),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$DateRangeInputMsg, dateRangeInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, groupLocationAndPractitionerFiltersCmd),
            A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, model),
            $author$project$Components$Reports$SalesTax$updateUrl(model)
        ])));
    });
    var $author$project$Pages$Reports$SalesTax$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$SalesTax$init, 0, session, practice, shared, query);
        var report = _v1.a;
        var reportTaxCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportTaxCmd));
    });
    var $author$project$Pages$Reports$SalesTax$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$SalesTax$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$SalesTax$ExportCsvMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$SalesTax$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$SalesTax$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$subscriptions(model.b8)),
            $author$project$Ui$Dropdown$subscriptions(model.ln),
            $author$project$Ui$Dropdown$subscriptions(model.oL)
        ]));
    };
    var $author$project$Pages$Reports$SalesTax$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$SalesTax$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$SalesTax$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $Q: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 3:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Ui$Dropdown$update, subMsg, model.oL);
                var taxJurisdictionDropdown = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oL: taxJurisdictionDropdown
                }), cmd, _List_Nil);
            case 4:
                var taxJurisdictionId = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    g1: taxJurisdictionId,
                    bl: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$SalesTax$updateUrl(newModel)
                ])), _List_Nil);
            case 5:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.ln);
                var byDropdown = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ln: byDropdown
                }), cmd, _List_Nil);
            case 6:
                var by = msg.a;
                var newModel = _Utils_update(model, {
                    bT: by,
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    bl: $author$project$Api$Data$Loading
                });
                var cmds = function() {
                    var _v3 = _Utils_Tuple2(model.ah5, newModel.bT);
                    if (!_v3.a) {
                        if (!_v3.b.$) {
                            var _v4 = _v3.a;
                            return _List_fromArray([
                                $author$project$Components$Reports$SalesTax$updateUrl(newModel)
                            ]);
                        } else {
                            var _v5 = _v3.a;
                            var _v6 = _v3.b;
                            return _List_fromArray([
                                $elm$core$Platform$Cmd$none
                            ]);
                        }
                    } else if (_v3.b.$ === 1) {
                        var _v7 = _v3.a;
                        var _v8 = _v3.b;
                        return _List_fromArray([
                            $author$project$Components$Reports$SalesTax$updateUrl(newModel)
                        ]);
                    } else {
                        var _v9 = _v3.a;
                        return _List_fromArray([
                            A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
                            $author$project$Components$Reports$SalesTax$updateUrl(newModel)
                        ]);
                    }
                }();
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(cmds), _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v10 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v10.a;
                var subCmd = _v10.b;
                var event = _v10.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate),
                            bl: $author$project$Api$Data$Loading
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$SalesTax$updateUrl(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 2:
                var subMsg = msg.a;
                var result = A3($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$update, apiClient, subMsg, model.b8);
                var _v12 = result.adu;
                switch(_v12.$){
                    case 0:
                        var locationGroupId = _v12.a;
                        var locationId = _v12.b;
                        var practitionerId = _v12.c;
                        var newModel = _Utils_update(model, {
                            b8: result.zi,
                            f0: locationGroupId,
                            Tp: locationId,
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            Xa: practitionerId,
                            bl: $author$project$Api$Data$Loading
                        });
                        return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, result.EQ),
                            A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
                            $author$project$Components$Reports$SalesTax$updateUrl(newModel)
                        ])), result.at);
                    case 1:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                    default:
                        return _Utils_Tuple3(_Utils_update(model, {
                            b8: result.zi
                        }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg, result.EQ), result.at);
                }
            case 7:
                var response = msg.a;
                if (response.$ === 3) {
                    var headers = response.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        bl: response
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    bl: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 8:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    $x: response
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 9:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    bl: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$SalesTax$updateUrl(newModel)
                ])), _List_Nil);
            case 10:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$SalesTax$fetchData, apiClient, newModel),
                    $author$project$Components$Reports$SalesTax$updateUrl(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v14 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v14.a;
                var subCmd = _v14.b;
                var subOutMsg = _v14.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SalesTax$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Reports$SalesTax$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$SalesTax$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$SalesTax$PaginationMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$amountFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, name, headers)));
    });
    var $author$project$Components$Reports$SalesTax$BySelected = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$byDropdownItems = F2(function(trackPatientsByLocation, currentBy) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SalesTax$BySelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('No Summary')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SalesTax$BySelected($elm$core$Maybe$Just('tax_jurisdiction'))),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('tax_jurisdiction')))
        ]), $elm$html$Html$text('Tax Jurisdiction')), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SalesTax$BySelected($elm$core$Maybe$Just('practitioner'))),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('practitioner')))
        ]), $elm$html$Html$text('Provider')), trackPatientsByLocation ? _List_fromArray([
            A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SalesTax$BySelected($elm$core$Maybe$Just('location'))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentBy, $elm$core$Maybe$Just('location')))
            ]), $elm$html$Html$text('Location'))
        ]) : _List_Nil))));
    });
    var $author$project$Components$Reports$SalesTax$byToDisplayName = function(by) {
        switch(by){
            case 'tax_jurisdiction':
                return 'Tax Jurisdiction';
            case 'practitioner':
                return 'Provider';
            case 'location':
                return 'Location';
            default:
                return by;
        }
    };
    var $author$project$Components$Reports$SalesTax$viewByDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.bT;
            if (!_v0.$) {
                var by = _v0.a;
                return $author$project$Components$Reports$SalesTax$byToDisplayName(by);
            } else return 'Summarize by';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), A2($author$project$Components$Reports$SalesTax$byDropdownItems, model.aaq, model.bT), model.ln);
    };
    var $author$project$Components$Reports$SalesTax$viewSummaryRow = F2(function(model, summaryRow) {
        var routeParams = _List_fromArray([
            $author$project$Ui$Link$routeParams(A2($author$project$Utils$Report$summaryRowTableParams, $author$project$Components$Reports$SalesTax$urlParams(model), summaryRow))
        ]);
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_fromArray([
                    $author$project$Ui$Typography$info,
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__SalesTax, routeParams, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'None', $author$project$Api$Provider$Reports$Summary$summaryRowName(summaryRow)))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__SalesTax, routeParams, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'tax line', $author$project$Api$Provider$Reports$Summary$summaryRowCount(summaryRow)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_fromArray([
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__SalesTax, routeParams, _List_fromArray([
                        $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$Summary$summaryRowAmountInCents(summaryRow)))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Components$Reports$SalesTax$viewSummaryTable = function(model) {
        var summaryType = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Reports$Summary$summaryType, $author$project$Formatters$String$humanize), $author$project$Api$Data$toMaybe(model.$x)));
        var summaryRows = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, $author$project$Api$Provider$Reports$Summary$summaryRows, $author$project$Api$Data$toMaybe(model.$x)));
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$loading(!$author$project$Api$Data$isSuccess(model.$x)),
            $author$project$Ui$Table$zeroState(_List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb4
                ]), _List_fromArray([
                    $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text(summaryType)
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4)
            ]), _List_fromArray([
                $elm$html$Html$text('Number of Tax Lines')
            ])),
            A2($author$project$Ui$Table$header, _List_fromArray([
                $author$project$Ui$Table$cellSpan(4),
                $author$project$Ui$Table$textRight
            ]), _List_fromArray([
                $elm$html$Html$text('Amount')
            ]))
        ]), A2($elm$core$List$map, $author$project$Components$Reports$SalesTax$viewSummaryRow(model), summaryRows), _List_Nil);
    };
    var $author$project$Components$Reports$SalesTax$SortTable = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$TaxLine$amountInCents = function(_v0) {
        var record = _v0;
        return record.Jh;
    };
    var $author$project$Api$Provider$Reports$TaxLine$invoice = function(_v0) {
        var record = _v0;
        return record.RA;
    };
    var $author$project$Api$Provider$Reports$TaxLine$location = function(_v0) {
        var record = _v0;
        return record.aeT;
    };
    var $author$project$Api$Provider$TaxJurisdiction$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$Reports$TaxLine$practitioner = function(_v0) {
        var record = _v0;
        return record.agi;
    };
    var $author$project$Api$Provider$Reports$TaxLine$rate = function(_v0) {
        var record = _v0;
        return record.X5;
    };
    var $author$project$Api$Provider$Reports$TaxLine$serviceDate = function(_v0) {
        var record = _v0;
        return record.ZZ;
    };
    var $author$project$Api$Provider$Reports$TaxLine$taxJurisdiction = function(_v0) {
        var record = _v0;
        return record.tl;
    };
    var $author$project$Api$Provider$Reports$TaxLine$transactionDate = function(_v0) {
        var record = _v0;
        return record.aat;
    };
    var $author$project$Components$Reports$SalesTax$viewRow = F3(function(canGoToPatients, trackPatientsByLocation, taxLine) {
        return A2($author$project$Ui$Table$row, _List_Nil, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, $author$project$Api$Provider$Reports$TaxLine$transactionDate(taxLine)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Utils$Currency$fromInt($author$project$Api$Provider$Reports$TaxLine$amountInCents(taxLine)))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($elm$core$String$fromFloat($author$project$Api$Provider$Reports$TaxLine$rate(taxLine)) + '%')
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Reports$TaxLine$serviceDate(taxLine))))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$TaxJurisdiction$Min$name, $author$project$Api$Provider$Reports$TaxLine$taxJurisdiction(taxLine))))
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, function() {
                    var _v0 = $author$project$Api$Provider$Reports$TaxLine$invoice(taxLine);
                    if (!_v0.$) {
                        var invoice = _v0.a;
                        var _v1 = _Utils_Tuple2(canGoToPatients, $author$project$Api$Common$Payable$Invoice$MinWithOwner$owner(invoice));
                        if (_v1.a && !_v1.b.$) {
                            var owner = _v1.b.a;
                            return _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
                                    RI: $author$project$Api$Common$Payable$Invoice$MinWithOwner$id(invoice),
                                    V8: $author$project$Api$Common$Payable$Owner$Min$id(owner)
                                }), _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
                                ]))
                            ]);
                        } else return _List_fromArray([
                            $elm$html$Html$text('#' + $elm$core$String$fromInt($author$project$Api$Common$Payable$Invoice$MinWithOwner$invoiceNumber(invoice)))
                        ]);
                    } else return _List_Nil;
                }()),
                A2($author$project$Ui$Table$cell, _List_fromArray([
                    $author$project$Ui$Table$colspan(trackPatientsByLocation ? 1 : 2)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Practitioner$Min$name, $author$project$Api$Provider$Reports$TaxLine$practitioner(taxLine))))
                ]))
            ]),
            trackPatientsByLocation ? _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($author$project$Formatters$String$ellipsis, 20, A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$Location$Min$name, $author$project$Api$Provider$Reports$TaxLine$location(taxLine)))))
                ]))
            ]) : _List_Nil
        ])));
    });
    var $author$project$Components$Reports$SalesTax$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.bl;
            if (_v1.$ === 3) {
                var taxLines_ = _v1.a;
                return _Utils_Tuple2(false, taxLines_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var taxLines = _v0.b;
        return A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$SalesTax$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$SalesTax$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$map, A2($author$project$Components$Reports$SalesTax$viewRow, model.EF, model.aaq), taxLines), _List_Nil);
    };
    var $author$project$Components$Reports$SalesTax$TaxJurisdictionSelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$SalesTax$taxJurisdictionDropdownItems = F2(function(taxJurisdictions, currentTaxJurisdictionId) {
        return A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SalesTax$TaxJurisdictionSelected($elm$core$Maybe$Nothing)),
            $author$project$Ui$Dropdown$selected(_Utils_eq(currentTaxJurisdictionId, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Tax Jurisdictions')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, function(taxJurisdiction) {
            var jurisdictionId = $author$project$Api$Provider$TaxJurisdiction$All$id(taxJurisdiction);
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SalesTax$TaxJurisdictionSelected($elm$core$Maybe$Just(jurisdictionId))),
                $author$project$Ui$Dropdown$selected(_Utils_eq(currentTaxJurisdictionId, $elm$core$Maybe$Just(jurisdictionId)))
            ]), $elm$html$Html$text($author$project$Api$Provider$TaxJurisdiction$All$name(taxJurisdiction)));
        }, taxJurisdictions)));
    });
    var $author$project$Components$Reports$SalesTax$viewTaxJurisrictionDropdown = function(model) {
        var placeholder = function() {
            var _v1 = model.g1;
            if (!_v1.$) {
                var taxJurisdictionId = _v1.a;
                var _v2 = model.$Q;
                if (_v2.$ === 3) {
                    var taxJurisdictions = _v2.a;
                    return A2($elm$core$Maybe$withDefault, taxJurisdictionId, A2($elm$core$Maybe$map, $author$project$Api$Provider$TaxJurisdiction$All$name, $elm$core$List$head(A2($elm$core$List$filter, function(jurisdiction) {
                        return _Utils_eq($author$project$Api$Provider$TaxJurisdiction$All$id(jurisdiction), taxJurisdictionId);
                    }, taxJurisdictions))));
                } else return taxJurisdictionId;
            } else return 'Tax Jurisdiction';
        }();
        var items = function() {
            var _v0 = model.$Q;
            if (_v0.$ === 3) {
                var taxJurisdictions = _v0.a;
                return A2($author$project$Components$Reports$SalesTax$taxJurisdictionDropdownItems, taxJurisdictions, model.g1);
            } else return _List_Nil;
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), items, model.oL);
    };
    var $author$project$Components$Reports$SalesTax$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$SalesTax$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.bl)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$TaxLine$listOptionsToParams, $author$project$Components$Reports$SalesTax$fetchTaxLinesParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Sales Tax')
                    ])),
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.bl;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total: ' + $author$project$Utils$Currency$fromInt(A2($author$project$Components$Reports$SalesTax$amountFromHeader, headers, 'x-total-amount')))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Total: $1000.00')
                            ]))
                        ]);
                    }()),
                    A2($author$project$Ui$Typography$p, _List_fromArray([
                        $author$project$Ui$Typography$helpBlock
                    ]), _List_fromArray([
                        $elm$html$Html$text('Total sales tax liabilities for all invoices (excluding \"draft\" or \"cancelled\" invoices). The only way to reverse these liabilities is to '),
                        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/invoices/creating-and-issuing-invoices', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('void the invoice.')
                        ])),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(' Learn more about this report ')
                        ])),
                        A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/reports-and-deposits/sales-tax-reporting', _List_fromArray([
                            $author$project$Ui$Link$targetBlank
                        ]), _List_fromArray([
                            $elm$html$Html$text('here')
                        ]))
                    ])),
                    A2($elm$html$Html$map, $author$project$Components$Reports$SalesTax$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6)),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _Utils_ap(A2($elm$core$List$map, A2($elm$core$Basics$composeR, $elm$core$List$singleton, $author$project$Ui$Grid$column(_List_fromArray([
                        $author$project$Ui$Grid$span(6),
                        $author$project$Ui$Grid$spanMd(4)
                    ]))), A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg), A2($author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewNew, _List_fromArray([
                        $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$multi
                    ]), model.b8))), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$SalesTax$viewTaxJurisrictionDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$SalesTax$viewByDropdown(model)
                        ]))
                    ]))),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$SalesTax$GroupLocationAndPractitionerFiltersMsg), $author$project$Components$ResourceFilter$GroupLocationAndPractitionerFilters$viewMultiSelected(model.b8));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                function() {
                    var _v1 = model.ah5;
                    if (!_v1) return $author$project$Components$Reports$SalesTax$viewTable(model);
                    else return $author$project$Components$Reports$SalesTax$viewSummaryTable(model);
                }(),
                function() {
                    var _v2 = model.ah5;
                    if (!_v2) return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$SalesTax$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.bl)))
                        ]), model.af_))
                    ]));
                    else return $author$project$Ui$Panel$none;
                }()
            ]))
        ]);
    });
    var $author$project$Pages$Reports$SalesTax$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$SalesTax$view, model.Ej, model.jQ)),
            $2: 'Reports | Sales Tax'
        };
    };
    var $author$project$Pages$Reports$SalesTax$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$SalesTax$init,
        aeR: $author$project$Pages$Reports$SalesTax$load,
        ag3: $author$project$Pages$Reports$SalesTax$save,
        ahE: $author$project$Pages$Reports$SalesTax$subscriptions,
        aaO: $author$project$Pages$Reports$SalesTax$update,
        aid: $author$project$Pages$Reports$SalesTax$view
    });
    var $author$project$Pages$Reports$SalesTax$Summary$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$SalesTax$Summary = 1;
    var $author$project$Pages$Reports$SalesTax$Summary$init = F4(function(session, practice, shared, _v0) {
        var query = _v0.Bz;
        var _v1 = A5($author$project$Components$Reports$SalesTax$init, 1, session, practice, shared, query);
        var report = _v1.a;
        var reportCmd = _v1.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$SalesTax$Summary$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$SalesTax$Summary$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Reports$SalesTax$Summary$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$SalesTax$subscriptions(model.jQ));
    };
    var $author$project$Pages$Reports$SalesTax$Summary$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$SalesTax$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Pages$Reports$SalesTax$Summary$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$SalesTax$view, model.Ej, model.jQ)),
            $2: 'Reports | Sales Tax'
        };
    };
    var $author$project$Pages$Reports$SalesTax$Summary$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$SalesTax$Summary$init,
        aeR: $author$project$Pages$Reports$SalesTax$Summary$load,
        ag3: $author$project$Pages$Reports$SalesTax$Summary$save,
        ahE: $author$project$Pages$Reports$SalesTax$Summary$subscriptions,
        aaO: $author$project$Pages$Reports$SalesTax$Summary$update,
        aid: $author$project$Pages$Reports$SalesTax$Summary$view
    });
    var $author$project$Pages$Reports$SignupAttempts$ReportMsg = $elm$core$Basics$identity;
    var $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$GotSignupPages = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Api$Provider$Report$SignupAttempt = 1;
    var $author$project$Components$Reports$SignupAttempts$SignupPageDropdownMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$StatusDropdownMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$buildUrl = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.HB),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), A2($author$project$Utils$DateWithDefault$toQuery, model.cP, 0)), model.Fn),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('lead_source'), model.S2),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('signup_page'), model.ow),
            A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('status'), model.ahy)
        ]);
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Reports__SignupAttempts)
        ]), A2($elm$core$List$append, $author$project$Api$Pagination$toPageQuery(model.af_), A2($elm$core$List$append, $author$project$Api$Sort$toQuery(model.ahs), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams))));
    };
    var $author$project$Components$Reports$SignupAttempts$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Components$Reports$SignupAttempts$GotSignupAttempts = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$fetchParams = function(model) {
        return function(d) {
            return _Utils_update(d, {
                Fn: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.Fn),
                S1: model.S2,
                af_: model.af_,
                Hs: model.ow,
                ahs: model.ahs,
                HB: A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, model.cP, 0), model.HB),
                ahy: model.ahy
            });
        };
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$SignupAttempt = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Reports$SignupAttempt$Record = function(createdAt) {
        return function(status) {
            return function(firstName) {
                return function(lastName) {
                    return function(email) {
                        return function(zip) {
                            return function(phoneNumber) {
                                return function(followUpInfo) {
                                    return function(leadSourceOther) {
                                        return function(signupPage) {
                                            return function(leadSource) {
                                                return function(broker) {
                                                    return function(patient) {
                                                        return {
                                                            vQ: broker,
                                                            Mx: createdAt,
                                                            OH: email,
                                                            PN: firstName,
                                                            PT: followUpInfo,
                                                            SU: lastName,
                                                            S1: leadSource,
                                                            S3: leadSourceOther,
                                                            V7: patient,
                                                            WF: phoneNumber,
                                                            Hs: signupPage,
                                                            ahy: status,
                                                            tK: zip
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Provider$LeadSource$Min$LeadSource = $elm$core$Basics$identity;
    var $author$project$Api$Provider$LeadSource$Min$Record = function(name) {
        return {
            zr: name
        };
    };
    var $author$project$Api$Provider$LeadSource$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$LeadSource$Min$Record));
    var $author$project$Api$Provider$LeadSource$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$LeadSource$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$SignupAttempt$recordDecoder = A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'patient', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Patient$Min$decoder), $elm$core$Maybe$Nothing, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'broker', $elm$json$Json$Decode$nullable($author$project$Api$Provider$Broker$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lead_source', $elm$json$Json$Decode$nullable($author$project$Api$Provider$LeadSource$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'signup_page', $elm$json$Json$Decode$nullable($author$project$Api$Provider$SignupPage$Min$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'lead_source_other', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'follow_up_info', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phone_number', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'zip', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'last_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'first_name', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'created_at', $elm_community$json_extra$Json$Decode$Extra$datetime, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Reports$SignupAttempt$Record))))))))))))));
    var $author$project$Api$Provider$Reports$SignupAttempt$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Reports$SignupAttempt$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Reports$SignupAttempt$reportDefaults = {
        Fn: $elm$core$Maybe$Nothing,
        S1: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        Hs: $elm$core$Maybe$Nothing,
        ahs: $author$project$Api$Sort$init,
        HB: $elm$core$Maybe$Nothing,
        ahy: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Reports$SignupAttempt$reportDefaults);
        return A2($elm$core$List$append, $author$project$Api$Pagination$toApiParams(options.af_), A2($elm$core$List$append, $author$project$Api$Sort$toParams(options.ahs), $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.HB;
                if (!_v0.$) {
                    var start_ = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'start', start_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v1 = options.Fn;
                if (!_v1.$) {
                    var end_ = _v1.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$date, 'end', end_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v2 = options.Hs;
                if (!_v2.$) {
                    var signupPage_ = _v2.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'signup_page', signupPage_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v3 = options.S1;
                if (!_v3.$) {
                    var leadSource_ = _v3.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'lead_source', leadSource_)
                    ]);
                } else return _List_Nil;
            }(),
            function() {
                var _v4 = options.ahy;
                if (!_v4.$) {
                    var status_ = _v4.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'status', status_)
                    ]);
                } else return _List_Nil;
            }()
        ]))));
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports',
        'signup_attempts'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Reports$SignupAttempt$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Reports$SignupAttempt$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Provider$Reports$SignupAttempt$listPath)));
    });
    var $author$project$Components$Reports$SignupAttempts$fetchSignupAttempts = F2(function(apiClient, model) {
        return A3($author$project$Api$Provider$Reports$SignupAttempt$list, apiClient, $author$project$Components$Reports$SignupAttempts$fetchParams(model), $author$project$Components$Reports$SignupAttempts$GotSignupAttempts);
    });
    var $author$project$Components$Reports$SignupAttempts$initColumns = _List_fromArray([
        A3($author$project$Api$Column$init, 'created_at', true, 'Started on'),
        A3($author$project$Api$Column$init, 'signup_page', true, 'Signup Page'),
        A3($author$project$Api$Column$init, 'lead_source', true, 'Lead Source'),
        A3($author$project$Api$Column$init, 'first_name', true, 'First Name'),
        A3($author$project$Api$Column$init, 'last_name', true, 'Last Name'),
        A3($author$project$Api$Column$init, 'email', true, 'Email'),
        A3($author$project$Api$Column$init, 'zip', true, 'Zip'),
        A3($author$project$Api$Column$init, 'phone_number', true, 'Phone Number'),
        A3($author$project$Api$Column$init, 'status', false, 'Status')
    ]);
    var $author$project$Components$Reports$SignupAttempts$init = F2(function(_v0, query) {
        var currentDate = _v0.cP;
        var timeFormatter = _v0.HO;
        var apiClient = _v0.Ej;
        var leadSourceId = A2($elm$core$Dict$get, 'lead_source', query);
        var _v1 = A3($author$project$Components$ResourceFilter$LeadSource$init, apiClient, $elm$core$Basics$identity, function(d) {
            return _Utils_update(d, {
                Ee: 'All Lead Sources',
                U5: 'Unassigned',
                afn: true,
                agj: leadSourceId
            });
        });
        var leadSourceResourceFilter = _v1.a;
        var leadSourceResourceFilterCmd = _v1.b;
        var _v2 = $author$project$Utils$DateWithDefault$fromQuery(query);
        var start = _v2.a;
        var end = _v2.b;
        var _v3 = A2($author$project$Components$DateRangeInput$init, 'date-range-input', A2($author$project$Components$Reports$SignupAttempts$dateRangeInputSettings, A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), start), A2($elm$core$Maybe$map, A2($author$project$Utils$DateWithDefault$toDate, currentDate, 0), end)));
        var dateRangeInput = _v3.a;
        var dateRangeInputCmd = _v3.b;
        var model = {
            LC: $author$project$Components$Reports$SignupAttempts$initColumns,
            ES: $elm$core$Maybe$Nothing,
            cP: currentDate,
            h6: dateRangeInput,
            Fn: end,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 1
            }),
            S2: leadSourceId,
            mT: leadSourceResourceFilter,
            af_: $author$project$Api$Pagination$initFromQuery(query),
            eL: $elm$core$Set$empty,
            aR: $author$project$Api$Data$Loading,
            ov: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'signup-page-dropdown',
                ahX: $author$project$Components$Reports$SignupAttempts$SignupPageDropdownMsg
            })),
            ow: A2($elm$core$Dict$get, 'signup_page', query),
            s_: $author$project$Api$Data$Loading,
            ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$initFromQuery(query)),
            HB: start,
            ahy: A2($elm$core$Dict$get, 'status', query),
            oD: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'status-dropdown',
                ahX: $author$project$Components$Reports$SignupAttempts$StatusDropdownMsg
            })),
            HO: timeFormatter
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg, leadSourceResourceFilterCmd),
            A3($author$project$Api$Provider$SignupPage$list, apiClient, function(d) {
                return _Utils_update(d, {
                    af_: $elm$core$Maybe$Nothing
                });
            }, $author$project$Components$Reports$SignupAttempts$GotSignupPages),
            A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg, dateRangeInputCmd),
            A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, model),
            A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])));
    });
    var $author$project$Pages$Reports$SignupAttempts$init = F4(function(_v0, _v1, shared, _v2) {
        var query = _v2.Bz;
        var _v3 = A2($author$project$Components$Reports$SignupAttempts$init, shared, query);
        var report = _v3.a;
        var reportCmd = _v3.b;
        return _Utils_Tuple2({
            Ej: shared.Ej,
            jQ: report
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, reportCmd));
    });
    var $author$project$Pages$Reports$SignupAttempts$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Reports$SignupAttempts$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Components$Reports$SignupAttempts$ExportCsvMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg, $author$project$Components$DateRangeInput$subscriptions(model.h6)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$SignupAttempts$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(model.md)),
            A2($elm$core$Platform$Sub$map, $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg, $author$project$Components$ResourceFilter$LeadSource$subscriptions(model.mT)),
            $author$project$Ui$Dropdown$subscriptions(model.ov),
            $author$project$Ui$Dropdown$subscriptions(model.oD)
        ]));
    };
    var $author$project$Pages$Reports$SignupAttempts$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$Reports$SignupAttempts$subscriptions(model.jQ));
    };
    var $author$project$Components$Reports$SignupAttempts$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var leadSourceResourceResult = A3($author$project$Components$ResourceFilter$LeadSource$update, apiClient, subMsg, model.mT);
                var leadSourceId = function() {
                    var _v2 = leadSourceResourceResult.adu;
                    if (!_v2.$) {
                        if (!_v2.a.$) return $author$project$Components$ResourceFilter$LeadSource$value(leadSourceResourceResult.zi);
                        else {
                            var _v3 = _v2.a;
                            return model.S2;
                        }
                    } else return model.S2;
                }();
                var newModel = _Utils_update(model, {
                    S2: leadSourceId,
                    mT: leadSourceResourceResult.zi
                });
                var _v1 = _Utils_eq(model.S2, newModel.S2) ? _Utils_Tuple2(model.aR, $elm$core$Platform$Cmd$none) : _Utils_Tuple2($author$project$Api$Data$Loading, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])));
                var signupAttempts = _v1.a;
                var cmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    aR: signupAttempts
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg, leadSourceResourceResult.EQ),
                    cmd
                ])), leadSourceResourceResult.at);
            case 1:
                var dataSignupPages = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    s_: dataSignupPages
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataSignupPages));
            case 2:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$Dropdown$update, subMsg, model.ov);
                var signupPageDropdown = _v4.a;
                var cmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    ov: signupPageDropdown
                }), cmd, _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v5 = A2($author$project$Ui$Dropdown$update, subMsg, model.oD);
                var statusDropdown = _v5.a;
                var cmd = _v5.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oD: statusDropdown
                }), cmd, _List_Nil);
            case 3:
                var signupPageId = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    aR: $author$project$Api$Data$Loading,
                    ow: signupPageId
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 5:
                var status = msg.a;
                var newModel = _Utils_update(model, {
                    af_: $author$project$Api$Pagination$reset(model.af_),
                    aR: $author$project$Api$Data$Loading,
                    ahy: status
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 6:
                var subMsg = msg.a;
                var _v6 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
                var dateRangeInput = _v6.a;
                var subCmd = _v6.b;
                var event = _v6.c;
                var newModel = function() {
                    if (event.$ === 1) {
                        var fromDate = event.a;
                        var toDate = event.b;
                        return _Utils_update(model, {
                            h6: dateRangeInput,
                            Fn: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, toDate),
                            af_: $author$project$Api$Pagination$reset(model.af_),
                            aR: $author$project$Api$Data$Loading,
                            HB: A2($elm$core$Maybe$map, $author$project$Utils$DateWithDefault$fromDate, fromDate)
                        });
                    } else return _Utils_update(model, {
                        h6: dateRangeInput
                    });
                }();
                var cmds = _Utils_eq(newModel.HB, model.HB) && _Utils_eq(newModel.Fn, model.Fn) ? _List_Nil : _List_fromArray([
                    A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ]);
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg, subCmd), cmds)), _List_Nil);
            case 7:
                var dataSignupAttempts = msg.a;
                if (dataSignupAttempts.$ === 3) {
                    var headers = dataSignupAttempts.b;
                    var completedCount = A2($elm$core$Maybe$andThen, $elm$core$String$toInt, A2($elm$core$Dict$get, 'x-completed-count', headers));
                    return _Utils_Tuple3(_Utils_update(model, {
                        ES: completedCount,
                        af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_),
                        eL: $elm$core$Set$empty,
                        aR: dataSignupAttempts
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    eL: $elm$core$Set$empty,
                    aR: dataSignupAttempts
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataSignupAttempts));
            case 8:
                var index = msg.a;
                var showMoreInfoFor = A2($elm$core$Set$member, index, model.eL) ? A2($elm$core$Set$remove, index, model.eL) : A2($elm$core$Set$insert, index, model.eL);
                return _Utils_Tuple3(_Utils_update(model, {
                    eL: showMoreInfoFor
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination,
                    aR: $author$project$Api$Data$Loading
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            case 10:
                var columnId = msg.a;
                var newModel = _Utils_update(model, {
                    ahs: A2($author$project$Api$Sort$update, columnId, model.ahs)
                });
                return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Components$Reports$SignupAttempts$fetchSignupAttempts, apiClient, newModel),
                    A2($elm$core$Basics$composeR, $author$project$Components$Reports$SignupAttempts$buildUrl, $author$project$Ports$Navigation$pushUrl)(newModel)
                ])), _List_Nil);
            default:
                var subMsg = msg.a;
                var _v9 = A3($author$project$Components$ExportCsv$update, apiClient, subMsg, model.md);
                var exportCsv = _v9.a;
                var subCmd = _v9.b;
                var subOutMsg = _v9.c;
                return _Utils_Tuple3(_Utils_update(model, {
                    md: exportCsv
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$Reports$SignupAttempts$ExportCsvMsg, subCmd), subOutMsg);
        }
    });
    var $author$project$Pages$Reports$SignupAttempts$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A3($author$project$Components$Reports$SignupAttempts$update, model.Ej, subMsg, model.jQ);
        var report = _v1.a;
        var subCmd = _v1.b;
        var subOutMsg = _v1.c;
        return _Utils_Tuple3(_Utils_update(model, {
            jQ: report
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), subOutMsg);
    });
    var $author$project$Components$Reports$SignupAttempts$PaginationMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$countFromHeader = F2(function(headers, name) {
        return A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Dict$get, name, headers));
    });
    var $author$project$Components$ResourceFilter$LeadSource$viewMultiSelected = function(model) {
        return A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$ResourceFilter$viewMultiSelected, model.Hg, model.bf));
    };
    var $author$project$Components$Reports$SignupAttempts$SignupPageSelected = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$signupPageDropdownItems = function(signupPages) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SignupAttempts$SignupPageSelected($elm$core$Maybe$Nothing))
                ]), $elm$html$Html$text('All Signup Pages')),
                $author$project$Ui$Dropdown$separator
            ]),
            A2($elm$core$List$map, function(signupPage) {
                return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SignupAttempts$SignupPageSelected($elm$core$Maybe$Just($author$project$Api$Provider$SignupPage$All$id(signupPage))))
                ]), $elm$html$Html$text($author$project$Api$Provider$SignupPage$All$slug(signupPage)));
            }, signupPages)
        ]));
    };
    var $author$project$Components$Reports$SignupAttempts$viewSignupPageDropdown = function(model) {
        var placeholder = function() {
            var _v2 = model.ow;
            if (!_v2.$) {
                var id = _v2.a;
                return A2($elm$core$Maybe$withDefault, 'Signup Page', A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$All$slug, A2($elm$core$Maybe$andThen, A2($elm$core$Basics$composeR, $elm$core$List$filter(function(sp) {
                    return _Utils_eq($author$project$Api$Provider$SignupPage$All$id(sp), id);
                }), $elm$core$List$head), $author$project$Api$Data$toMaybe(model.s_))));
            } else return 'Signup Page';
        }();
        var _v0 = function() {
            var _v1 = model.s_;
            if (_v1.$ === 3) {
                var signupPages = _v1.a;
                return _Utils_Tuple2(false, $author$project$Components$Reports$SignupAttempts$signupPageDropdownItems(signupPages));
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var items = _v0.b;
        return A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
            $author$project$Ui$Dropdown$disabled(loading)
        ]), _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), items, model.ov);
    };
    var $author$project$Components$Reports$SignupAttempts$StatusSelected = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$statusDropdownItems = _List_fromArray([
        A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SignupAttempts$StatusSelected($elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('All Statuses')),
        $author$project$Ui$Dropdown$separator,
        A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SignupAttempts$StatusSelected($elm$core$Maybe$Just('abandoned')))
        ]), $elm$html$Html$text('Abandoned')),
        A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SignupAttempts$StatusSelected($elm$core$Maybe$Just('completed')))
        ]), $elm$html$Html$text('Completed')),
        A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SignupAttempts$StatusSelected($elm$core$Maybe$Just('pending')))
        ]), $elm$html$Html$text('Pending')),
        A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Components$Reports$SignupAttempts$StatusSelected($elm$core$Maybe$Just('ineligible')))
        ]), $elm$html$Html$text('Ineligible'))
    ]);
    var $author$project$Components$Reports$SignupAttempts$statusToDisplayName = function(status) {
        switch(status){
            case 'abandoned':
                return 'Abandoned';
            case 'completed':
                return 'Completed';
            case 'pending':
                return 'Pending';
            case 'ineligible':
                return 'Ineligible';
            default:
                return status;
        }
    };
    var $author$project$Components$Reports$SignupAttempts$viewStatusDropdown = function(model) {
        var placeholder = function() {
            var _v0 = model.ahy;
            if (!_v0.$) {
                var status = _v0.a;
                return $author$project$Components$Reports$SignupAttempts$statusToDisplayName(status);
            } else return 'Status';
        }();
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text(placeholder)
        ]), $author$project$Components$Reports$SignupAttempts$statusDropdownItems, model.oD);
    };
    var $author$project$Components$Reports$SignupAttempts$SortTable = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$Reports$SignupAttempts$ShowMoreInfo = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$broker = function(_v0) {
        var record = _v0;
        return record.vQ;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$firstName = function(_v0) {
        var record = _v0;
        return record.PN;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$followUpInfo = function(_v0) {
        var record = _v0;
        return record.PT;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$lastName = function(_v0) {
        var record = _v0;
        return record.SU;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$leadSource = function(_v0) {
        var record = _v0;
        return record.S1;
    };
    var $author$project$Api$Provider$LeadSource$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Components$Reports$SignupAttempts$leadSourceIsOther = function(maybeLeadSource) {
        if (!maybeLeadSource.$) {
            var leadSource = maybeLeadSource.a;
            return $author$project$Api$Provider$LeadSource$Min$name(leadSource) === 'Other';
        } else return false;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$leadSourceOther = function(_v0) {
        var record = _v0;
        return record.S3;
    };
    var $author$project$Components$Reports$SignupAttempts$moreInfoAvailable = function(signupAttempt) {
        var _v0 = _Utils_Tuple2($author$project$Api$Provider$Reports$SignupAttempt$broker(signupAttempt), $author$project$Api$Provider$Reports$SignupAttempt$followUpInfo(signupAttempt));
        if (!_v0.a.$) {
            if (!_v0.b.$) return true;
            else {
                var _v1 = _v0.b;
                return true;
            }
        } else {
            if (!_v0.b.$) {
                var _v2 = _v0.a;
                return true;
            } else return false;
        }
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$phoneNumber = function(_v0) {
        var record = _v0;
        return record.WF;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$signupPage = function(_v0) {
        var record = _v0;
        return record.Hs;
    };
    var $author$project$Api$Provider$SignupPage$Min$slug = function(_v0) {
        var record = _v0;
        return record._A;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Reports$SignupAttempt$patientId = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$map, $author$project$Api$Provider$Patient$Min$id, record.V7);
    };
    var $author$project$Components$Reports$SignupAttempts$viewPatientName = F2(function(signupAttempt, maybeName) {
        var nameText = A2($elm$core$Maybe$withDefault, '', maybeName);
        if ($elm$core$String$trim(nameText) !== '') {
            var _v0 = $author$project$Api$Provider$Reports$SignupAttempt$patientId(signupAttempt);
            if (!_v0.$) {
                var pid = _v0.a;
                return A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                    V8: pid
                }), _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$phi(true)
                    ]), _List_fromArray([
                        $elm$html$Html$text(nameText)
                    ]))
                ]));
            } else return A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text(nameText)
            ]));
        } else return A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$phi(true)
        ]), _List_fromArray([
            $elm$html$Html$text(nameText)
        ]));
    });
    var $author$project$Api$Provider$Reports$SignupAttempt$zip = function(_v0) {
        var record = _v0;
        return record.tK;
    };
    var $author$project$Components$Reports$SignupAttempts$viewRow = F4(function(timeFormatter, showMoreInfoFor, index, signupAttempt) {
        return A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Provider$Reports$SignupAttempt$createdAt(signupAttempt)))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$SignupPage$Min$slug, $author$project$Api$Provider$Reports$SignupAttempt$signupPage(signupAttempt))))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Api$Provider$LeadSource$Min$name, $author$project$Api$Provider$Reports$SignupAttempt$leadSource(signupAttempt)))),
                    $author$project$Utils$Html$noBreakSpace
                ]),
                $author$project$Components$Reports$SignupAttempts$leadSourceIsOther($author$project$Api$Provider$Reports$SignupAttempt$leadSource(signupAttempt)) ? _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_Nil, A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Reports$SignupAttempt$leadSourceOther(signupAttempt)), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$small
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$help(_List_Nil)
                        ]))
                    ]))
                ]) : _List_Nil
            ]))),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Components$Reports$SignupAttempts$viewPatientName, signupAttempt, $author$project$Api$Provider$Reports$SignupAttempt$firstName(signupAttempt))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Components$Reports$SignupAttempts$viewPatientName, signupAttempt, $author$project$Api$Provider$Reports$SignupAttempt$lastName(signupAttempt))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Reports$SignupAttempt$email(signupAttempt)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Reports$SignupAttempt$zip(signupAttempt)))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Formatters$Phone$format(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Reports$SignupAttempt$phoneNumber(signupAttempt))))
                ]))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Reports$SignupAttempt$status(signupAttempt))
                ]),
                $author$project$Components$Reports$SignupAttempts$moreInfoAvailable(signupAttempt) ? _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        A2($elm$html$Html$Attributes$style, 'display', 'grid')
                    ]), $elm$core$List$concat(_List_fromArray([
                        _List_fromArray([
                            A2($elm$html$Html$a, _List_fromArray([
                                $elm$html$Html$Attributes$class('small clickable'),
                                A2($elm$html$Html$Attributes$style, 'margin', '4px 0 3px 0;]'),
                                $elm$html$Html$Events$onClick($author$project$Components$Reports$SignupAttempts$ShowMoreInfo(index))
                            ]), A2($elm$core$Set$member, index, showMoreInfoFor) ? _List_fromArray([
                                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('Less info'),
                                    $author$project$Utils$Html$noBreakSpace,
                                    $author$project$Ui$Icon$chevron(_List_fromArray([
                                        $author$project$Ui$Icon$rotate180
                                    ]))
                                ]))
                            ]) : _List_fromArray([
                                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('More info'),
                                    $author$project$Utils$Html$noBreakSpace,
                                    $author$project$Ui$Icon$chevronDown(_List_fromArray([
                                        $author$project$Ui$Icon$rotate270
                                    ]))
                                ]))
                            ]))
                        ]),
                        A2($elm$core$Set$member, index, showMoreInfoFor) ? $elm$core$List$concat(_List_fromArray([
                            function() {
                                var _v0 = $author$project$Api$Provider$Reports$SignupAttempt$broker(signupAttempt);
                                if (!_v0.$) {
                                    var broker = _v0.a;
                                    return _List_fromArray([
                                        A2($elm$html$Html$span, _List_fromArray([
                                            $elm$html$Html$Attributes$class('inline small text-muted')
                                        ]), _List_fromArray([
                                            A2($elm$html$Html$span, _List_fromArray([
                                                $elm$html$Html$Attributes$class('bold')
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Broker: ')
                                            ])),
                                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text($author$project$Api$Provider$Broker$Min$name(broker))
                                            ]))
                                        ]))
                                    ]);
                                } else return _List_Nil;
                            }(),
                            function() {
                                var _v1 = $author$project$Api$Provider$Reports$SignupAttempt$followUpInfo(signupAttempt);
                                if (!_v1.$) {
                                    var followUpInfo = _v1.a;
                                    return _List_fromArray([
                                        A2($elm$html$Html$span, _List_fromArray([
                                            $elm$html$Html$Attributes$class('inline small text-muted')
                                        ]), _List_fromArray([
                                            A2($elm$html$Html$span, _List_fromArray([
                                                $elm$html$Html$Attributes$class('bold')
                                            ]), _List_fromArray([
                                                $elm$html$Html$text('Followup: ')
                                            ])),
                                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text(followUpInfo)
                                            ]))
                                        ]))
                                    ]);
                                } else return _List_Nil;
                            }()
                        ])) : _List_Nil
                    ])))
                ]) : _List_Nil
            ]))),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_Nil)
        ]));
    });
    var $author$project$Components$Reports$SignupAttempts$viewTable = function(model) {
        var _v0 = function() {
            var _v1 = model.aR;
            if (_v1.$ === 3) {
                var signupAttempts_ = _v1.a;
                return _Utils_Tuple2(false, signupAttempts_);
            } else return _Utils_Tuple2(true, _List_Nil);
        }();
        var loading = _v0.a;
        var signupAttempts = _v0.b;
        return A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$zeroState(_List_fromArray([
                $elm$html$Html$text('You don\'t have any data for the time period and filters selected. Try broadening your search to see more results.')
            ])),
            $author$project$Ui$Table$loading(loading)
        ]), $elm$core$List$concat(_List_fromArray([
            A2($elm$core$List$map, $author$project$Api$Column$view(A2($author$project$Api$Column$Sortable, model.ahs, $author$project$Components$Reports$SignupAttempts$SortTable)), model.LC),
            _List_fromArray([
                A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('pull-right')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Components$Reports$SignupAttempts$ExportCsvMsg, $author$project$Components$ExportCsv$button)
                    ]))
                ]))
            ])
        ])), A2($elm$core$List$indexedMap, A2($author$project$Components$Reports$SignupAttempts$viewRow, model.HO, model.eL), signupAttempts), _List_Nil);
    };
    var $author$project$Components$Reports$SignupAttempts$view = F2(function(apiClient, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Components$Reports$SignupAttempts$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, apiClient, _List_fromArray([
                $author$project$Components$ExportCsv$report($author$project$Api$Data$totalCount(model.aR)),
                $author$project$Components$ExportCsv$reportParams(A2($elm$core$Basics$composeL, $author$project$Api$Provider$Reports$SignupAttempt$listOptionsToParams, $author$project$Components$Reports$SignupAttempts$fetchParams)(model))
            ]), model.md)),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Signup Attempts')
                    ])),
                    A2($elm$html$Html$h3, _List_Nil, function() {
                        var _v0 = model.aR;
                        if (_v0.$ === 3) {
                            var headers = _v0.b;
                            return _List_fromArray([
                                $elm$html$Html$text('Total completed: ' + A2($author$project$Components$Reports$SignupAttempts$countFromHeader, headers, 'x-completed-count')),
                                $author$project$Utils$Html$noBreakSpace,
                                A2($elm$html$Html$small, _List_fromArray([
                                    $elm$html$Html$Attributes$class('text-muted')
                                ]), _List_fromArray([
                                    $elm$html$Html$text('out of ' + (A2($author$project$Components$Reports$SignupAttempts$countFromHeader, headers, 'x-total-count') + ' total'))
                                ]))
                            ]);
                        } else return _List_fromArray([
                            $author$project$Ui$Spinner$view(_List_Nil)
                        ]);
                    }()),
                    A2($elm$html$Html$map, $author$project$Components$Reports$SignupAttempts$DateRangeInputMsg, $author$project$Components$DateRangeInput$view(model.h6)),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$SignupAttempts$viewSignupPageDropdown(model)
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg, A2($author$project$Components$ResourceFilter$LeadSource$viewNew, _List_fromArray([
                                $author$project$Components$ResourceFilter$style(1),
                                $author$project$Components$ResourceFilter$multi
                            ]), model.mT))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(6),
                            $author$project$Ui$Grid$spanMd(4)
                        ]), _List_fromArray([
                            $author$project$Components$Reports$SignupAttempts$viewStatusDropdown(model)
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$row, _List_fromArray([
                        $author$project$Ui$Grid$gutterSm
                    ]), _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_Nil, function() {
                            var activeFilters = A2($elm$core$List$map, $elm$html$Html$map($author$project$Components$Reports$SignupAttempts$LeadSourceResourceFilterMsg), $author$project$Components$ResourceFilter$LeadSource$viewMultiSelected(model.mT));
                            return $elm$core$List$isEmpty(activeFilters) ? _List_Nil : _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$mt2,
                                    $author$project$Ui$Element$mb2
                                ]), _List_fromArray([
                                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Active filters')
                                    ]))
                                ])),
                                A2($elm$html$Html$span, _List_Nil, activeFilters)
                            ]);
                        }())
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Components$Reports$SignupAttempts$viewTable(model)
                ])),
                A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$map, $author$project$Components$Reports$SignupAttempts$PaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$loading(!$author$project$Utils$Maybe$toBool($author$project$Api$Data$toMaybe(model.aR)))
                    ]), model.af_))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$Reports$SignupAttempts$view = function(model) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$identity), A2($author$project$Components$Reports$SignupAttempts$view, model.Ej, model.jQ)),
            $2: 'Reports | Signup Attempts'
        };
    };
    var $author$project$Pages$Reports$SignupAttempts$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Reports$SignupAttempts$init,
        aeR: $author$project$Pages$Reports$SignupAttempts$load,
        ag3: $author$project$Pages$Reports$SignupAttempts$save,
        ahE: $author$project$Pages$Reports$SignupAttempts$subscriptions,
        aaO: $author$project$Pages$Reports$SignupAttempts$update,
        aid: $author$project$Pages$Reports$SignupAttempts$view
    });
    var $author$project$Ui$Spinner$Attr = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Spinner$attrs = $author$project$Ui$Spinner$Attr;
    var $author$project$Pages$StyleGuide$ActivityIndicators$viewBody = _List_fromArray([
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('extraSmall'),
                $author$project$Ui$Spinner$view(_List_fromArray([
                    $author$project$Ui$Spinner$extraSmall
                ]))
            ])),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('small'),
                $author$project$Ui$Spinner$view(_List_fromArray([
                    $author$project$Ui$Spinner$small,
                    $author$project$Ui$Spinner$attrs(_List_fromArray([
                        $elm$html$Html$Attributes$class('some-class')
                    ]))
                ]))
            ])),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('medium'),
                $author$project$Ui$Spinner$view(_List_fromArray([
                    $author$project$Ui$Spinner$attrs(_List_fromArray([
                        $elm$html$Html$Attributes$class('mr-8')
                    ]))
                ]))
            ])),
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('large'),
                $author$project$Ui$Spinner$view(_List_fromArray([
                    $author$project$Ui$Spinner$large,
                    $author$project$Ui$Spinner$attrs(_List_fromArray([
                        $elm$html$Html$Attributes$class('mr-8')
                    ]))
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$ActivityIndicators$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$ActivityIndicators$viewBody,
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$ActivityIndicators$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ActivityIndicators$view);
    var $author$project$Pages$StyleGuide$AddressInput$AddressInputMsg = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$AddressInput$init = function(_v0) {
        var _v1 = $author$project$Components$AddressInput$init('address-input');
        var addressInput = _v1.a;
        var addressInputCmd = _v1.b;
        return _Utils_Tuple2({
            kX: addressInput
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, addressInputCmd));
    };
    var $author$project$Pages$StyleGuide$AddressInput$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$AddressInput$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A2($author$project$Components$AddressInput$update, subMsg, model.kX);
        var addressInput = _v1.a;
        var addressInputCmd = _v1.b;
        return _Utils_Tuple2(_Utils_update(model, {
            kX: addressInput
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, addressInputCmd));
    });
    var $author$project$Generated$StyleGuide$Examples$addressInputExample = '\n    [ AddressInput.view\n        []\n        model.addressInput\n        |> Html.map AddressInputMsg\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$addressInputExampleDisabled = '\n    [ AddressInput.view\n        [ AddressInput.disabled True ]\n        model.addressInput\n        |> Html.map AddressInputMsg\n    ]\n    ';
    var $author$project$Pages$StyleGuide$AddressInput$example = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$AddressInput$view, _List_Nil, model.kX))
        ]);
    };
    var $author$project$Components$AddressInput$Disabled = $elm$core$Basics$identity;
    var $author$project$Components$AddressInput$disabled = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$AddressInput$exampleDisabled = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$identity, A2($author$project$Components$AddressInput$view, _List_fromArray([
                $author$project$Components$AddressInput$disabled(true)
            ]), model.kX))
        ]);
    };
    var $author$project$Components$StyleGuide$Example$Title = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$StyleGuide$Example$title = $author$project$Components$StyleGuide$Example$Title;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$HCode = $elm$core$Basics$identity;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style1 = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style2 = 3;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style3 = 4;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style4 = 5;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style5 = 6;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style6 = 7;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle = function(syntax) {
        switch(syntax){
            case 0:
                return _Utils_Tuple2(3, 'elm-s');
            case 1:
                return _Utils_Tuple2(4, 'elm-bs');
            case 2:
                return _Utils_Tuple2(5, 'elm-gs');
            case 3:
                return _Utils_Tuple2(7, 'elm-c');
            case 4:
                return _Utils_Tuple2(4, 'elm-k');
            case 5:
                return _Utils_Tuple2(6, 'elm-f');
            case 6:
                return _Utils_Tuple2(5, 'elm-ts');
            default:
                return _Utils_Tuple2(2, 'elm-n');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine = function(fragments) {
        return {
            ad_: fragments,
            mt: $elm$core$Maybe$Nothing
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak = {
        $: 2
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Comment = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Default = 0;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment = F2(function(toStyle, _v0) {
        var syntax = _v0.a;
        var text = _v0.b;
        switch(syntax.$){
            case 0:
                return {
                    abz: '',
                    agN: 0,
                    $Y: text
                };
            case 1:
                return {
                    abz: '',
                    agN: 1,
                    $Y: text
                };
            case 2:
                return {
                    abz: '',
                    agN: 0,
                    $Y: text
                };
            default:
                var c = syntax.a;
                var _v2 = toStyle(c);
                var requiredStyle = _v2.a;
                var additionalClass = _v2.b;
                return {
                    abz: additionalClass,
                    agN: requiredStyle,
                    $Y: text
                };
        }
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp = F3(function(toStyle, _v0, _v1) {
        var syntax = _v0.a;
        var text = _v0.b;
        var lines = _v1.a;
        var fragments = _v1.b;
        var maybeLastSyntax = _v1.c;
        if (_Utils_eq(syntax, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak)) return _Utils_Tuple3(A2($elm$core$List$cons, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(fragments), lines), _List_fromArray([
            A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment, toStyle, _Utils_Tuple2(syntax, text))
        ]), $elm$core$Maybe$Nothing);
        else {
            if (_Utils_eq($elm$core$Maybe$Just(syntax), maybeLastSyntax)) {
                if (fragments.b) {
                    var headFrag = fragments.a;
                    var tailFrags = fragments.b;
                    return _Utils_Tuple3(lines, A2($elm$core$List$cons, _Utils_update(headFrag, {
                        $Y: _Utils_ap(text, headFrag.$Y)
                    }), tailFrags), maybeLastSyntax);
                } else return _Utils_Tuple3(lines, A2($elm$core$List$cons, A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment, toStyle, _Utils_Tuple2(syntax, text)), fragments), maybeLastSyntax);
            } else return _Utils_Tuple3(lines, A2($elm$core$List$cons, A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toFragment, toStyle, _Utils_Tuple2(syntax, text)), fragments), $elm$core$Maybe$Just(syntax));
        }
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines = F2(function(toStyle, revTokens) {
        return function(_v0) {
            var lines = _v0.a;
            var frags = _v0.b;
            return A2($elm$core$List$cons, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$newLine(frags), lines);
        }(A3($elm$core$List$foldl, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLinesHelp(toStyle), _Utils_Tuple3(_List_Nil, _List_Nil, $elm$core$Maybe$Nothing), revTokens));
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment = {
        $: 1
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak = function(c) {
        return c === '\n';
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile = F2(function(isNotRelevant, previousParser) {
        return A2($elm$parser$Parser$ignorer, previousParser, $elm$parser$Parser$chompWhile(isNotRelevant));
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$inlineComment = A2($elm$parser$Parser$map, function(b) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b)
        ]);
    }, $elm$parser$Parser$getChompedString(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile, A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak), $elm$parser$Parser$symbol('--'))));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen = F3(function(f, list, plist) {
        return A2($elm$parser$Parser$andThen, function(n) {
            return f(_Utils_ap(n, list));
        }, plist);
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen = F3(function(f, list, pn) {
        return A2($elm$parser$Parser$andThen, function(n) {
            return f(A2($elm$core$List$cons, n, list));
        }, pn);
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable = F2(function(options, revAList) {
        var defaultMap = options.Nt;
        var isNotRelevant = options.Se;
        var end = options.Fn;
        var innerParsers = options.Ri;
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$map, $elm$core$Basics$always(A2($elm$core$List$cons, defaultMap(end), revAList)), $elm$parser$Parser$symbol(end)),
            A2($elm$parser$Parser$map, $elm$core$Basics$always(revAList), $elm$parser$Parser$end),
            A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options), revAList, $elm$parser$Parser$oneOf(innerParsers)),
            A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options), revAList, A2($elm$parser$Parser$map, defaultMap, $elm$parser$Parser$getChompedString(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile, isNotRelevant, $elm$parser$Parser$chompIf($elm$core$Basics$always(true))))))
        ]));
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable = F3(function(nestLevel, options, revAList) {
        var defaultMap = options.Nt;
        var isNotRelevant = options.Se;
        var start = options.HB;
        var end = options.Fn;
        var innerParsers = options.Ri;
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$andThen, function(n) {
                return nestLevel === 1 ? $elm$parser$Parser$succeed(n) : A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel - 1, options, n);
            }, A2($elm$parser$Parser$map, $elm$core$Basics$always(A2($elm$core$List$cons, defaultMap(end), revAList)), $elm$parser$Parser$symbol(end))),
            A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen, A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel + 1, options), revAList, A2($elm$parser$Parser$map, defaultMap, $elm$parser$Parser$getChompedString(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile, isNotRelevant, $elm$parser$Parser$symbol(start))))),
            A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$addThen, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable(options), revAList, $elm$parser$Parser$oneOf(innerParsers)),
            A2($elm$parser$Parser$map, $elm$core$Basics$always(revAList), $elm$parser$Parser$end),
            A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$consThen, A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, nestLevel, options), revAList, A2($elm$parser$Parser$map, defaultMap, $elm$parser$Parser$getChompedString(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile, isNotRelevant, $elm$parser$Parser$chompIf($elm$core$Basics$always(true))))))
        ]));
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp = F2(function(options, revAList) {
        var start = options.HB;
        var end = options.Fn;
        var isNotRelevant = options.Se;
        var _v0 = _Utils_Tuple2($elm$core$String$uncons(options.HB), $elm$core$String$uncons(options.Fn));
        if (_v0.a.$ === 1) {
            var _v1 = _v0.a;
            return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the start token cannot be an empty string!');
        } else if (_v0.b.$ === 1) {
            var _v2 = _v0.b;
            return $elm$parser$Parser$problem('Trying to parse a delimited helper, but the end token cannot be an empty string!');
        } else {
            var _v3 = _v0.a.a;
            var startChar = _v3.a;
            var _v4 = _v0.b.a;
            var endChar = _v4.a;
            return options.Sc ? A3($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedNestable, 1, _Utils_update(options, {
                Se: function(c) {
                    return isNotRelevant(c) && !_Utils_eq(c, startChar) && !_Utils_eq(c, endChar);
                }
            }), revAList) : A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedUnnestable, _Utils_update(options, {
                Se: function(c) {
                    return isNotRelevant(c) && !_Utils_eq(c, endChar);
                }
            }), revAList);
        }
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited = function(options) {
        var start = options.HB;
        var isNotRelevant = options.Se;
        var defaultMap = options.Nt;
        return A2($elm$parser$Parser$andThen, function(n) {
            return A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimitedHelp, options, _List_fromArray([
                n
            ]));
        }, A2($elm$parser$Parser$map, $elm$core$Basics$always(defaultMap(start)), $elm$parser$Parser$symbol(start)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList = A2($elm$parser$Parser$map, function(_v0) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\n')
        ]);
    }, $elm$parser$Parser$symbol('\n'));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$multilineComment = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited({
        Nt: function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Comment, b);
        },
        Fn: '-}',
        Ri: _List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList
        ]),
        Sc: true,
        Se: function(c) {
            return !$pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
        },
        HB: '{-'
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment = $elm$parser$Parser$oneOf(_List_fromArray([
        $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$inlineComment,
        $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$multilineComment
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$BasicSymbol = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Capitalized = 3;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$GroupSymbol = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Keyword = 4;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal = {
        $: 0
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Number = 7;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile = function(isNotRelevant) {
        return A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf(isNotRelevant)), $elm$parser$Parser$chompWhile(isNotRelevant));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbols = $elm$core$Set$fromList(_List_fromArray([
        '|',
        '.',
        '=',
        '\\',
        '/',
        '(',
        ')',
        '-',
        '>',
        '<',
        ':',
        '+',
        '!',
        '$',
        '%',
        '&',
        '*'
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol = function(c) {
        return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbols);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbol = $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbols = $elm$core$Set$fromList(_List_fromArray([
        ',',
        '[',
        ']',
        '{',
        '}'
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol = function(c) {
        return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbols);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isStringLiteralChar = function(c) {
        return c === '\"' || c === '\'';
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace = function(c) {
        return c === ' ' || c === '\t';
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace = function(c) {
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar = function(c) {
        return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isBasicSymbol(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isStringLiteralChar(c));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$capitalized = $elm$parser$Parser$getChompedString(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar, $elm$parser$Parser$chompIf($elm$core$Char$isUpper)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbol = $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isGroupSymbol));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$Function = 5;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixSet = $elm$core$Set$fromList(_List_fromArray([
        '+',
        '-',
        '/',
        '*',
        '=',
        '.',
        '$',
        '<',
        '>',
        ':',
        '&',
        '|',
        '^',
        '?',
        '%',
        '#',
        '@',
        '~',
        '!',
        ','
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isInfixChar = function(c) {
        return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser = A2($elm$parser$Parser$map, function(b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), b);
    }, $elm$parser$Parser$getChompedString(A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol('('))), $elm$parser$Parser$backtrackable($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isInfixChar))), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol(')')))));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$keywordSet = $elm$core$Set$fromList(_List_fromArray([
        'as',
        'where',
        'let',
        'in',
        'if',
        'else',
        'then',
        'case',
        'of',
        'type',
        'alias'
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword = function(str) {
        return A2($elm$core$Set$member, str, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$keywordSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber = function(c) {
        return $elm$core$Char$isDigit(c) || c === '.';
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber = A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber)), $elm$parser$Parser$chompWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isNumber));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber = A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol('-'))), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number = $elm$parser$Parser$oneOf(_List_fromArray([
        $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$positiveNumber,
        $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$negativeNumber
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable = $elm$parser$Parser$getChompedString(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar, $elm$parser$Parser$chompIf($elm$core$Char$isLower)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$weirdText = $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isVariableChar));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent = $elm$parser$Parser$oneOf(_List_fromArray([
        A2($elm$parser$Parser$map, function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(7), b);
        }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$number)),
        A2($elm$parser$Parser$map, $elm$core$Basics$always(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), '()')), $elm$parser$Parser$symbol('()')),
        $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser,
        A2($elm$parser$Parser$map, function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1), b);
        }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$basicSymbol),
        A2($elm$parser$Parser$map, function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(2), b);
        }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$groupSymbol),
        A2($elm$parser$Parser$map, function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), b);
        }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$capitalized),
        A2($elm$parser$Parser$map, function(n) {
            return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword(n) ? _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), n) : _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, n);
        }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable),
        A2($elm$parser$Parser$map, function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
        }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$weirdText)
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$String = 0;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet = $elm$core$Set$fromList(_List_fromArray([
        '\'',
        '\"',
        '\\',
        'n',
        'r',
        't',
        'b',
        'f',
        'v'
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar = function(c) {
        return A2($elm$core$Set$member, c, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapableSet);
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable = A2($elm$parser$Parser$ignorer, A2($elm$parser$Parser$ignorer, $elm$parser$Parser$succeed(0), $elm$parser$Parser$backtrackable($elm$parser$Parser$symbol('\\'))), $elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapableChar));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$elmEscapable = A2($elm$parser$Parser$map, function(b) {
        return _List_fromArray([
            _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(3), b)
        ]);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$escapable));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable = function(c) {
        return c === '\\';
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter = {
        Nt: function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(0), b);
        },
        Fn: '\"',
        Ri: _List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreakList,
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$elmEscapable
        ]),
        Sc: false,
        Se: function(c) {
            return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isEscapable(c));
        },
        HB: '\"'
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$doubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$quote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(_Utils_update($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter, {
        Fn: '\'',
        HB: '\''
    }));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$tripleDoubleQuote = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$delimited(_Utils_update($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringDelimiter, {
        Fn: '\"\"\"',
        HB: '\"\"\"'
    }));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral = $elm$parser$Parser$oneOf(_List_fromArray([
        $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$tripleDoubleQuote,
        $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$doubleQuote,
        $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$quote
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak = A2($elm$parser$Parser$map, function(_v0) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$LineBreak, '\n');
    }, $elm$parser$Parser$symbol('\n'));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space = A2($elm$parser$Parser$map, function(b) {
        return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
    }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isSpace)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContext = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(A2($elm$core$List$cons, n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
            A2($elm$parser$Parser$andThen, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContext, A2($elm$parser$Parser$map, function(n) {
                return A2($elm$core$List$cons, n, revTokens);
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak)),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(_Utils_ap(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
            A2($elm$parser$Parser$map, function(ns) {
                return $elm$parser$Parser$Loop(_Utils_ap(ns, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(A2($elm$core$List$cons, n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$TypeSignature = 6;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant = function(c) {
        return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || c === '(' || c === ')' || c === '-' || c === ',');
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContentHelp = $elm$parser$Parser$oneOf(_List_fromArray([
        A2($elm$parser$Parser$map, $elm$core$Basics$always(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), '()')), $elm$parser$Parser$symbol('()')),
        A2($elm$parser$Parser$map, $elm$core$Basics$always(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1), '->')), $elm$parser$Parser$symbol('->')),
        A2($elm$parser$Parser$map, function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
        }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(function(c) {
            return c === '(' || c === ')' || c === '-' || c === ',';
        }))),
        A2($elm$parser$Parser$map, function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), b);
        }, $elm$parser$Parser$getChompedString(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant, $elm$parser$Parser$chompIf($elm$core$Char$isUpper)))),
        A2($elm$parser$Parser$map, function(b) {
            return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
        }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigIsNotRelevant)))
    ]));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContent = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(A2($elm$core$List$cons, n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContentHelp),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$map, $elm$parser$Parser$Done, A2($elm$parser$Parser$andThen, function(ns) {
                return A2($elm$parser$Parser$loop, ns, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$fnSigContent);
            }, A2($elm$parser$Parser$map, $elm$core$Basics$always(A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(1), ':'), revTokens)), $elm$parser$Parser$symbol(':')))),
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Done, A2($elm$parser$Parser$loop, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody)),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar = function(c) {
        return c === '-' || c === '{';
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar = $elm$parser$Parser$getChompedString($elm$parser$Parser$chompIf($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar));
    var $elm$parser$Parser$ExpectingKeyword = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $elm$parser$Parser$Advanced$keyword = function(_v0) {
        var kwd = _v0.a;
        var expecting = _v0.b;
        var progress = !$elm$core$String$isEmpty(kwd);
        return function(s) {
            var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.f, s.n4, s.Ln, s.s2);
            var newOffset = _v1.a;
            var newRow = _v1.b;
            var newCol = _v1.c;
            return _Utils_eq(newOffset, -1) || 0 <= A3($elm$parser$Parser$Advanced$isSubChar, function(c) {
                return $elm$core$Char$isAlphaNum(c) || c === '_';
            }, newOffset, s.s2) ? A2($elm$parser$Parser$Advanced$Bad, false, A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3($elm$parser$Parser$Advanced$Good, progress, 0, {
                Ln: newCol,
                aC: s.aC,
                aeo: s.aeo,
                f: newOffset,
                n4: newRow,
                s2: s.s2
            });
        };
    };
    var $elm$parser$Parser$keyword = function(kwd) {
        return $elm$parser$Parser$Advanced$keyword(A2($elm$parser$Parser$Advanced$Token, kwd, $elm$parser$Parser$ExpectingKeyword(kwd)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecIsNotRelevant = function(c) {
        return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || c === '(');
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant = function(c) {
        return !($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isWhitespace(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || c === '(' || c === ')' || c === ',' || c === '.');
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpnIsSpecialChar = function(c) {
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$isLineBreak(c) || $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isCommentChar(c) || c === '(' || c === ')';
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContextNested = function(_v1) {
        var nestLevel = _v1.a;
        var revTokens = _v1.b;
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested(_Utils_Tuple2(nestLevel, revTokens)),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested = function(_v0) {
        var nestLevel = _v0.a;
        var revTokens = _v0.b;
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(_Utils_Tuple2(nestLevel, A2($elm$core$List$cons, n, revTokens)));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
            A2($elm$parser$Parser$andThen, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$checkContextNested, A2($elm$parser$Parser$map, function(n) {
                return _Utils_Tuple2(nestLevel, A2($elm$core$List$cons, n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak)),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(_Utils_Tuple2(nestLevel, _Utils_ap(n, revTokens)));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParNest = function(_v0) {
        var nestLevel = _v0.a;
        var revTokens = _v0.b;
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStepNested(_Utils_Tuple2(nestLevel, revTokens)),
            A2($elm$parser$Parser$map, function(ns) {
                return $elm$parser$Parser$Loop(_Utils_Tuple2(nestLevel + 1, ns));
            }, A2($elm$parser$Parser$map, $elm$core$Basics$always(A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('), revTokens)), $elm$parser$Parser$symbol('('))),
            A2($elm$parser$Parser$map, function(ns) {
                return !nestLevel ? $elm$parser$Parser$Done(ns) : $elm$parser$Parser$Loop(_Utils_Tuple2(nestLevel - 1, ns));
            }, A2($elm$parser$Parser$map, $elm$core$Basics$always(A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, ')'), revTokens)), $elm$parser$Parser$symbol(')'))),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(_Utils_Tuple2(nestLevel, A2($elm$core$List$cons, n, revTokens)));
            }, $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$map, function(b) {
                    return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
                }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
                A2($elm$parser$Parser$map, function(s) {
                    return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, s);
                }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(A2($elm$core$Basics$composeL, $elm$core$Basics$not, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpnIsSpecialChar))))
            ]))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParentheses = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Done, A2($elm$parser$Parser$map, $elm$core$Basics$always(A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, ')'), revTokens)), $elm$parser$Parser$symbol(')'))),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(A2($elm$core$List$cons, n, revTokens));
            }, $elm$parser$Parser$oneOf(_List_fromArray([
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$infixParser,
                A2($elm$parser$Parser$map, function(b) {
                    return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
                }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
                A2($elm$parser$Parser$map, function(b) {
                    return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
                }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile(function(c) {
                    return c === ',' || c === '.';
                }))),
                A2($elm$parser$Parser$map, function(b) {
                    return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(6), b);
                }, $elm$parser$Parser$getChompedString(A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$thenChompWhile, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant, $elm$parser$Parser$chompIf($elm$core$Char$isUpper)))),
                A2($elm$parser$Parser$map, function(b) {
                    return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), b);
                }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mdpIsNotRelevant)))
            ]))),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Loop, A2($elm$parser$Parser$andThen, function(n) {
                return A2($elm$parser$Parser$loop, _Utils_Tuple2(0, n), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParNest);
            }, A2($elm$parser$Parser$map, $elm$core$Basics$always(A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('), revTokens)), $elm$parser$Parser$symbol('(')))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Loop, A2($elm$parser$Parser$andThen, function(n) {
                return A2($elm$parser$Parser$loop, n, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecParentheses);
            }, A2($elm$parser$Parser$map, $elm$core$Basics$always(A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, '('), revTokens)), $elm$parser$Parser$symbol('(')))),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(A2($elm$core$List$cons, n, revTokens));
            }, $elm$parser$Parser$oneOf(_List_fromArray([
                A2($elm$parser$Parser$map, function(b) {
                    return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
                }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$commentChar),
                A2($elm$parser$Parser$map, $elm$core$Basics$always(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), 'exposing')), $elm$parser$Parser$keyword('exposing')),
                A2($elm$parser$Parser$map, $elm$core$Basics$always(_Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), 'as')), $elm$parser$Parser$keyword('as')),
                A2($elm$parser$Parser$map, function(b) {
                    return _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$Normal, b);
                }, $elm$parser$Parser$getChompedString($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Helpers$chompIfThenWhile($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$modDecIsNotRelevant)))
            ]))),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp = F2(function(revTokens, str) {
        return str === 'module' ? A2($elm$parser$Parser$loop, A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), str), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration) : A2($elm$parser$Parser$loop, A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), str), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature);
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclaration = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$whitespaceOrCommentStep(revTokens),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Done, A2($elm$parser$Parser$andThen, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclarationHelp(revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable)),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Done, A2($elm$parser$Parser$loop, revTokens, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody)),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable = F2(function(revTokens, n) {
        return n === 'module' || n === 'import' ? A2($elm$parser$Parser$loop, A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$moduleDeclaration) : n === 'port' ? A2($elm$parser$Parser$loop, A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$portDeclaration) : $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$isKeyword(n) ? A2($elm$parser$Parser$loop, A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(4), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody) : A2($elm$parser$Parser$loop, A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Type$C(5), n), revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionSignature);
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mainLoop = function(revTokens) {
        return $elm$parser$Parser$oneOf(_List_fromArray([
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(A2($elm$core$List$cons, n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$space),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(A2($elm$core$List$cons, n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineBreak),
            A2($elm$parser$Parser$map, function(n) {
                return $elm$parser$Parser$Loop(_Utils_ap(n, revTokens));
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$comment),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Loop, A2($elm$parser$Parser$andThen, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$lineStartVariable(revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$variable)),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Loop, A2($elm$parser$Parser$andThen, function(s) {
                return A2($elm$parser$Parser$loop, _Utils_ap(s, revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody);
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$stringLiteral)),
            A2($elm$parser$Parser$map, $elm$parser$Parser$Loop, A2($elm$parser$Parser$andThen, function(s) {
                return A2($elm$parser$Parser$loop, A2($elm$core$List$cons, s, revTokens), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBody);
            }, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$functionBodyContent)),
            $elm$parser$Parser$succeed($elm$parser$Parser$Done(revTokens))
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toRevTokens = A2($elm$parser$Parser$loop, _List_Nil, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$mainLoop);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toLines = A2($elm$core$Basics$composeR, $elm$parser$Parser$run($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toRevTokens), $elm$core$Result$map($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Helpers$toLines($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle)));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$elm = A2($elm$core$Basics$composeR, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$toLines, $elm$core$Result$map($elm$core$Basics$identity));
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme = $elm$core$Basics$identity;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$ClassExtends = 8;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$DeclarationKeyword = 3;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Elm = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Identifier = 0;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Property = {
        $: 3
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$bold = function(style) {
        return _Utils_update(style, {
            mG: true
        });
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic = function(style) {
        return _Utils_update(style, {
            mJ: true
        });
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor = {
        $: 0
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor = function(background) {
        return {
            pE: background,
            mG: false,
            mJ: false,
            ra: false,
            $Y: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis = F2(function(text, background) {
        return {
            pE: background,
            mG: false,
            mJ: false,
            ra: false,
            $Y: text
        };
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor = function(text) {
        return {
            pE: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$DefaultColor,
            mG: false,
            mJ: false,
            ra: false,
            $Y: text
        };
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$requiredStyles = {
        po: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#003800')),
        LD: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#75715e')),
        Nn: A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$noEmphasis, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f8f8f2'), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#23241f')),
        qj: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#380000')),
        mt: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$backgroundColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#343434')),
        s6: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#ae81ff')),
        s7: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#e6db74')),
        s8: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f92672')),
        s9: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#66d9ef')),
        ta: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#a6e22e')),
        tb: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#ae81ff')),
        tc: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#fd971f'))
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$theme = {
        acK: _List_fromArray([
            _Utils_Tuple2(_List_fromArray([
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Elm(6),
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript(3),
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$Property)
            ]), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#66d9ef')))),
            _Utils_Tuple2(_List_fromArray([
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Javascript(8)
            ]), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$italic($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#a6e22e')))),
            _Utils_Tuple2(_List_fromArray([
                $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$Css($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$AtRule(0))
            ]), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$bold($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$textColor($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Hex('#f92672'))))
        ]),
        agO: $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$requiredStyles
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment = function(a) {
        switch(a){
            case 0:
                return _Utils_Tuple2(4, 'css-ar-i');
            case 1:
                return _Utils_Tuple2(6, 'css-ar-p');
            case 2:
                return _Utils_Tuple2(4, 'css-ar-k');
            default:
                return _Utils_Tuple2(5, 'css-ar-v');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$Style7 = 8;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment = function(att) {
        switch(att){
            case 0:
                return _Utils_Tuple2(6, 'css-s-a-an');
            case 1:
                return _Utils_Tuple2(3, 'css-s-a-av');
            default:
                return _Utils_Tuple2(4, 'css-s-a-o');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment = function(s) {
        switch(s.$){
            case 0:
                return _Utils_Tuple2(4, 'css-s-e');
            case 1:
                return _Utils_Tuple2(6, 'css-s-i');
            case 2:
                return _Utils_Tuple2(6, 'css-s-cl');
            case 3:
                return _Utils_Tuple2(8, 'css-s-c');
            case 4:
                return _Utils_Tuple2(4, 'css-s-u');
            case 5:
                var att = s.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$attributeSelectorToFragment(att);
            case 6:
                return _Utils_Tuple2(0, 'css-s-pe');
            default:
                return _Utils_Tuple2(0, 'css-s-pc');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle = function(syntax) {
        switch(syntax.$){
            case 0:
                return _Utils_Tuple2(3, 'css-s');
            case 1:
                var a = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$atRuleToFragment(a);
            case 2:
                var s = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$selectorToFragment(s);
            case 3:
                return _Utils_Tuple2(5, 'css-p');
            case 4:
                return _Utils_Tuple2(5, 'css-pv');
            case 5:
                return _Utils_Tuple2(2, 'css-n');
            default:
                return _Utils_Tuple2(4, 'css-u');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle = function(syntax) {
        switch(syntax){
            case 0:
                return _Utils_Tuple2(2, 'js-n');
            case 1:
                return _Utils_Tuple2(3, 'js-s');
            case 2:
                return _Utils_Tuple2(4, 'js-k');
            case 3:
                return _Utils_Tuple2(5, 'js-dk');
            case 4:
                return _Utils_Tuple2(5, 'js-fe');
            case 5:
                return _Utils_Tuple2(6, 'js-f');
            case 6:
                return _Utils_Tuple2(7, 'js-lk');
            case 7:
                return _Utils_Tuple2(8, 'js-p');
            default:
                return _Utils_Tuple2(6, 'js-ce');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle = function(syntax) {
        return _Utils_Tuple2(0, 'nolang');
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle = function(syntax) {
        switch(syntax){
            case 0:
                return _Utils_Tuple2(2, 'py-n');
            case 1:
                return _Utils_Tuple2(3, 'py-s');
            case 2:
                return _Utils_Tuple2(4, 'py-k');
            case 3:
                return _Utils_Tuple2(5, 'py-dk');
            case 5:
                return _Utils_Tuple2(6, 'py-f');
            case 6:
                return _Utils_Tuple2(7, 'py-lk');
            case 7:
                return _Utils_Tuple2(8, 'py-p');
            default:
                return _Utils_Tuple2(0, 'py-fe');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle = function(syntax) {
        switch(syntax){
            case 0:
                return _Utils_Tuple2(2, 'sql-n');
            case 1:
                return _Utils_Tuple2(3, 'sql-s');
            case 2:
                return _Utils_Tuple2(4, 'sql-k');
            case 3:
                return _Utils_Tuple2(5, 'sql-o');
            case 4:
                return _Utils_Tuple2(6, 'sql-f');
            case 5:
                return _Utils_Tuple2(7, 'sql-p');
            default:
                return _Utils_Tuple2(8, 'sql-l');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle = function(syntax) {
        switch(syntax){
            case 0:
                return _Utils_Tuple2(4, 'xml-t');
            case 1:
                return _Utils_Tuple2(6, 'xml-a');
            default:
                return _Utils_Tuple2(3, 'xlm-av');
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxToSelector = function(syntax) {
        switch(syntax.$){
            case 0:
                var elmSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Elm$syntaxToStyle(elmSyntax).b;
            case 1:
                var xmlSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Xml$syntaxToStyle(xmlSyntax).b;
            case 2:
                var jsSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Javascript$syntaxToStyle(jsSyntax).b;
            case 3:
                var cssSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Css$syntaxToStyle(cssSyntax).b;
            case 4:
                var pythonSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Python$syntaxToStyle(pythonSyntax).b;
            case 5:
                var sqlSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$Sql$syntaxToStyle(sqlSyntax).b;
            default:
                var noLangSyntax = syntax.a;
                return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Language$NoLang$syntaxToStyle(noLangSyntax).b;
        }
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxesToSelectors = function(syntaxes) {
        return $elm$core$String$concat(A2($elm$core$List$intersperse, ', ', A2($elm$core$List$map, $elm$core$Basics$append('.elmsh-'), A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxToSelector, syntaxes))));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss = F2(function(property, color) {
        switch(color.$){
            case 0:
                return '';
            case 1:
                var hex = color.a;
                return property + (hex + ';');
            case 2:
                var r = color.a;
                var g = color.b;
                var b = color.c;
                return $elm$core$String$concat(_List_fromArray([
                    property,
                    'rgb(',
                    $elm$core$String$fromInt(r),
                    ', ',
                    $elm$core$String$fromInt(g),
                    ',',
                    $elm$core$String$fromInt(b),
                    ');'
                ]));
            default:
                var r = color.a;
                var g = color.b;
                var b = color.c;
                var a = color.d;
                return $elm$core$String$concat(_List_fromArray([
                    property,
                    'rgba(',
                    $elm$core$String$fromInt(r),
                    ', ',
                    $elm$core$String$fromInt(g),
                    ',',
                    $elm$core$String$fromInt(b),
                    ', ',
                    $elm$core$String$fromFloat(a),
                    ');'
                ]));
        }
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse = F2(function(bool, str) {
        return bool ? str : '';
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$styleToCss = function(_v0) {
        var isBold = _v0.mG;
        var isItalic = _v0.mJ;
        var isUnderline = _v0.ra;
        var text = _v0.$Y;
        var background = _v0.pE;
        return $elm$core$String$concat(_List_fromArray([
            A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isBold, 'font-weight: bold;'),
            A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isItalic, 'font-style: italic;'),
            A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$emptyIfFalse, isUnderline, 'text-decoration: underline;'),
            A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss, 'color: ', text),
            A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$colorToCss, 'background: ', background)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCssClass = function(_v0) {
        var selectors = _v0.a;
        var style = _v0.b;
        return $elm$core$String$isEmpty(selectors) ? '' : selectors + (' {' + ($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$styleToCss(style) + '}'));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCss = function(classes) {
        return $elm$core$String$concat(A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCssClass, classes));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$toCss = function(_v0) {
        var requiredStyles = _v0.agO;
        var customStyles = _v0.acK;
        return $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Style$toCss(_Utils_ap(_List_fromArray([
            _Utils_Tuple2('.elmsh', requiredStyles.Nn),
            _Utils_Tuple2('.elmsh-hl', requiredStyles.mt),
            _Utils_Tuple2('.elmsh-add', requiredStyles.po),
            _Utils_Tuple2('.elmsh-del', requiredStyles.qj),
            _Utils_Tuple2('.elmsh-comm', requiredStyles.LD),
            _Utils_Tuple2('.elmsh1', requiredStyles.s6),
            _Utils_Tuple2('.elmsh2', requiredStyles.s7),
            _Utils_Tuple2('.elmsh3', requiredStyles.s8),
            _Utils_Tuple2('.elmsh4', requiredStyles.s9),
            _Utils_Tuple2('.elmsh5', requiredStyles.ta),
            _Utils_Tuple2('.elmsh6', requiredStyles.tb),
            _Utils_Tuple2('.elmsh7', requiredStyles.tc)
        ]), A2($elm$core$List$map, $elm$core$Tuple$mapFirst($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$syntaxesToSelectors), customStyles)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$css = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Type$toCss($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$theme);
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$monokai = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$Monokai$css;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$monokai = $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Theme$monokai;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Add = 1;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Del = 2;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$Line$Normal = 0;
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString = function(required) {
        return 'elmsh' + function() {
            switch(required){
                case 0:
                    return '0';
                case 1:
                    return '-comm';
                case 2:
                    return '1';
                case 3:
                    return '2';
                case 4:
                    return '3';
                case 5:
                    return '4';
                case 6:
                    return '5';
                case 7:
                    return '6';
                default:
                    return '7';
            }
        }();
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView = function(_v0) {
        var text = _v0.$Y;
        var requiredStyle = _v0.agN;
        var additionalClass = _v0.abz;
        return !requiredStyle && $elm$core$String$isEmpty(additionalClass) ? $elm$html$Html$text(text) : A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$requiredStyleToString(requiredStyle), !!requiredStyle),
                _Utils_Tuple2('elmsh-' + additionalClass, additionalClass !== '')
            ]))
        ]), _List_fromArray([
            $elm$html$Html$text(text)
        ]));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView = F3(function(start, index, _v0) {
        var fragments = _v0.ad_;
        var highlight = _v0.mt;
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('elmsh-line', true),
                _Utils_Tuple2('elmsh-hl', _Utils_eq(highlight, $elm$core$Maybe$Just(0))),
                _Utils_Tuple2('elmsh-add', _Utils_eq(highlight, $elm$core$Maybe$Just(1))),
                _Utils_Tuple2('elmsh-del', _Utils_eq(highlight, $elm$core$Maybe$Just(2)))
            ])),
            A2($elm$html$Html$Attributes$attribute, 'data-elmsh-lc', $elm$core$String$fromInt(start + index))
        ]), A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments));
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml = function(lines) {
        return A2($elm$html$Html$code, _List_fromArray([
            $elm$html$Html$Attributes$class('elmsh')
        ]), $elm$core$List$concat(A2($elm$core$List$map, function(_v0) {
            var highlight = _v0.mt;
            var fragments = _v0.ad_;
            return _Utils_eq(highlight, $elm$core$Maybe$Nothing) ? A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments) : _List_fromArray([
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('elmsh-hl', _Utils_eq(highlight, $elm$core$Maybe$Just(0))),
                        _Utils_Tuple2('elmsh-add', _Utils_eq(highlight, $elm$core$Maybe$Just(1))),
                        _Utils_Tuple2('elmsh-del', _Utils_eq(highlight, $elm$core$Maybe$Just(2)))
                    ]))
                ]), A2($elm$core$List$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$fragmentView, fragments))
            ]);
        }, lines)));
    };
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml = F2(function(maybeStart, lines) {
        if (maybeStart.$ === 1) return A2($elm$html$Html$pre, _List_fromArray([
            $elm$html$Html$Attributes$class('elmsh')
        ]), _List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toInlineHtml(lines)
        ]));
        else {
            var start = maybeStart.a;
            return A2($elm$html$Html$pre, _List_fromArray([
                $elm$html$Html$Attributes$class('elmsh')
            ]), $elm$core$List$singleton(A2($elm$html$Html$code, _List_Nil, A2($elm$core$List$indexedMap, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$lineView(start), lines))));
        }
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml = F2(function(maybeStart, _v0) {
        var lines = _v0;
        return A2($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$View$toBlockHtml, maybeStart, lines);
    });
    var $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$useTheme = function(_v0) {
        var theme = _v0;
        return A3($elm$html$Html$node, 'style', _List_Nil, _List_fromArray([
            $elm$html$Html$text(theme)
        ]));
    };
    var $author$project$Components$StyleGuide$Example$highlight = function(code) {
        return _List_fromArray([
            $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$useTheme($pablohirafuji$elm_syntax_highlight$SyntaxHighlight$monokai),
            A2($elm$core$Result$withDefault, A2($elm$html$Html$pre, _List_Nil, _List_fromArray([
                A2($elm$html$Html$code, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(code)
                ]))
            ])), A2($elm$core$Result$map, $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$toBlockHtml($elm$core$Maybe$Just(1)), $pablohirafuji$elm_syntax_highlight$SyntaxHighlight$elm(code)))
        ]);
    };
    var $author$project$Components$StyleGuide$Example$Base = 0;
    var $author$project$Components$StyleGuide$Example$optionsToOptionsRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, acc) {
            switch(option.$){
                case 2:
                    var string = option.a;
                    return _Utils_update(acc, {
                        $2: string
                    });
                case 0:
                    var content = option.a;
                    return _Utils_update(acc, {
                        NQ: content
                    });
                default:
                    var surface = option.a;
                    return _Utils_update(acc, {
                        Dz: surface
                    });
            }
        }), {
            NQ: _List_Nil,
            Dz: 0,
            $2: ''
        }, options);
    };
    var $author$project$Components$StyleGuide$Example$view = F2(function(options, _v0) {
        var content = _v0.EU;
        var code = _v0.Lk;
        var optionsRecord = $author$project$Components$StyleGuide$Example$optionsToOptionsRecord(options);
        var surfaceClass = function() {
            var _v1 = optionsRecord.Dz;
            if (_v1 === 1) return 'surface-subtle';
            else return '';
        }();
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$id($author$project$Formatters$String$slugify(optionsRecord.$2)),
            $elm$html$Html$Attributes$class('style-guide-example'),
            $elm$html$Html$Attributes$class(surfaceClass)
        ]), _List_fromArray([
            $elm$core$String$isEmpty(optionsRecord.$2) ? $elm$html$Html$text('') : A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                A2($elm$html$Html$a, _List_fromArray([
                    $elm$html$Html$Attributes$href('#' + $author$project$Formatters$String$slugify(optionsRecord.$2))
                ]), _List_fromArray([
                    $elm$html$Html$text(optionsRecord.$2)
                ]))
            ])),
            $elm$core$List$isEmpty(optionsRecord.NQ) ? $elm$html$Html$text('') : A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('style-guide-example__description')
            ]), optionsRecord.NQ),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('style-guide-example__separator')
            ]), _List_Nil),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('style-guide-example__content')
            ]), content),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('style-guide-example__code')
            ]), $author$project$Components$StyleGuide$Example$highlight(code))
        ]));
    });
    var $author$project$Pages$StyleGuide$AddressInput$viewBody = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Address Input')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$addressInputExample,
                        EU: $author$project$Pages$StyleGuide$AddressInput$example(model)
                    })
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Invalid address input')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$addressInputExampleDisabled,
                        EU: $author$project$Pages$StyleGuide$AddressInput$exampleDisabled(model)
                    })
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$AddressInput$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$AddressInput$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$AddressInput$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$AddressInput$init,
        ahE: $author$project$Pages$StyleGuide$AddressInput$subscriptions,
        aaO: $author$project$Pages$StyleGuide$AddressInput$update,
        aid: $author$project$Pages$StyleGuide$AddressInput$view
    });
    var $author$project$Pages$StyleGuide$Alert$init = function(_v0) {
        return _Utils_Tuple2({
            k0: false
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Alert$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Alert$update = F2(function(msg, model) {
        if (msg === 1) return _Utils_Tuple2(_Utils_update(model, {
            k0: false
        }), $elm$core$Platform$Cmd$none);
        else return _Utils_Tuple2(_Utils_update(model, {
            k0: true
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Generated$StyleGuide$Examples$alertExample = '\n    [ Alert.view Alert.Success [] [ text "This is a Success alert" ]\n    , Alert.view Alert.Danger [] [ text "This is a Danger alert" ]\n    , Alert.view Alert.Warning [] [ text "This is a Warning alert" ]\n    , Alert.view Alert.Info [] [ text "This is a Info alert" ]\n    , Alert.view Alert.Primary [] [ text "This is a Primary alert" ]\n    , Alert.view Alert.Primary [ Alert.icon Icon.Location ] [ text "This is a Primary alert with an Icon" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$alertExampleDismissible = '\n    List.singleton <|\n        if alertDismissed then\n            Button.view { ariaLabel = "Show dismissible alert" } [ Button.onClick AlertShown ] [ text "show dismissible alert " ]\n\n        else\n            Alert.view Alert.Success [ Alert.dismissible AlertDismissed ] [ text "This is a dismissible alert" ]    ';
    var $author$project$Ui$Alert$Primary = 4;
    var $author$project$Pages$StyleGuide$Alert$example = _List_fromArray([
        A3($author$project$Ui$Alert$view, 0, _List_Nil, _List_fromArray([
            $elm$html$Html$text('This is a Success alert')
        ])),
        A3($author$project$Ui$Alert$view, 3, _List_Nil, _List_fromArray([
            $elm$html$Html$text('This is a Danger alert')
        ])),
        A3($author$project$Ui$Alert$view, 2, _List_Nil, _List_fromArray([
            $elm$html$Html$text('This is a Warning alert')
        ])),
        A3($author$project$Ui$Alert$view, 1, _List_Nil, _List_fromArray([
            $elm$html$Html$text('This is a Info alert')
        ])),
        A3($author$project$Ui$Alert$view, 4, _List_Nil, _List_fromArray([
            $elm$html$Html$text('This is a Primary alert')
        ])),
        A3($author$project$Ui$Alert$view, 4, _List_fromArray([
            $author$project$Ui$Alert$icon(14)
        ]), _List_fromArray([
            $elm$html$Html$text('This is a Primary alert with an Icon')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Alert$AlertDismissed = 0;
    var $author$project$Pages$StyleGuide$Alert$AlertShown = 1;
    var $author$project$Ui$Alert$Dismissible = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Alert$dismissible = $author$project$Ui$Alert$Dismissible;
    var $author$project$Pages$StyleGuide$Alert$exampleDismissible = function(_v0) {
        var alertDismissed = _v0.k0;
        return $elm$core$List$singleton(alertDismissed ? A3($author$project$Ui$Button$view, {
            abP: 'Show dismissible alert'
        }, _List_fromArray([
            $author$project$Ui$Button$onClick(1)
        ]), _List_fromArray([
            $elm$html$Html$text('show dismissible alert ')
        ])) : A3($author$project$Ui$Alert$view, 0, _List_fromArray([
            $author$project$Ui$Alert$dismissible(0)
        ]), _List_fromArray([
            $elm$html$Html$text('This is a dismissible alert')
        ])));
    };
    var $author$project$Pages$StyleGuide$Alert$exampleDismissibleWithIcon = function(_v0) {
        var alertDismissed = _v0.k0;
        return $elm$core$List$singleton(alertDismissed ? A3($author$project$Ui$Button$view, {
            abP: 'Show dismissible alert'
        }, _List_fromArray([
            $author$project$Ui$Button$onClick(1)
        ]), _List_fromArray([
            $elm$html$Html$text('show dismissible alert ')
        ])) : A3($author$project$Ui$Alert$view, 0, _List_fromArray([
            $author$project$Ui$Alert$dismissible(0),
            $author$project$Ui$Alert$icon(64)
        ]), _List_fromArray([
            $elm$html$Html$text('This is a dismissible alert with an icon')
        ])));
    };
    var $author$project$Pages$StyleGuide$Alert$viewBody = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Alert')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$alertExample,
                        EU: $author$project$Pages$StyleGuide$Alert$example
                    })
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Dismissible Alert')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$alertExampleDismissible,
                        EU: $author$project$Pages$StyleGuide$Alert$exampleDismissible(model)
                    }),
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Dismissible Alert with an Icon')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$alertExampleDismissible,
                        EU: $author$project$Pages$StyleGuide$Alert$exampleDismissibleWithIcon(model)
                    })
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$Alert$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$Alert$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Alert$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Alert$init,
        ahE: $author$project$Pages$StyleGuide$Alert$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Alert$update,
        aid: $author$project$Pages$StyleGuide$Alert$view
    });
    var $elm$html$Html$h2 = _VirtualDom_node('h2');
    var $author$project$Ui$Typography$headingLg = function(content) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($elm$html$Html$h2, _List_fromArray([
            $elm$html$Html$Attributes$class('text-heading-lg text-main')
        ]), content));
    };
    var $author$project$Pages$StyleGuide$Badge$marketplaceStatuses = _List_fromArray([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]);
    var $author$project$Pages$StyleGuide$Badge$supportedLables = _List_fromArray([
        'needs_payment_info',
        'pending',
        'downloading',
        'bank_not_verified',
        'successful',
        'live',
        'failed',
        'refunded',
        'retrying',
        'cancelled',
        'default',
        'saving',
        'refund_pending',
        'refund_successful',
        'refund_failed',
        'active',
        'unconfirmed',
        'confirmed',
        'warning',
        'new_payment_source',
        'needs_trial_deposits',
        'invalid',
        'inactive',
        'expiring',
        'connected',
        'requested',
        'unpaid',
        'paid',
        'clearing',
        'processing',
        'redeemable',
        'not_redeemable',
        'viewed',
        'bad_debt',
        'disputed',
        'overdue',
        'sent',
        'issued',
        'no_payment',
        'missing',
        'accepted',
        'accepted_and_outdated',
        'not_accepted',
        'none',
        'scheduled',
        'scheduled_without_source',
        'in transit',
        'completed',
        'enabled',
        'synced',
        'unsynced',
        'errored',
        'opened',
        'error',
        'processed',
        'review_data_matches',
        'review_file_size',
        'enqueued_for_preprocessing',
        'enqueued_for_processing',
        'preprocessing',
        'ready_to_preprocess',
        'ready_to_process',
        'payable',
        'deal_ending',
        'failed_payment'
    ]);
    var $author$project$Pages$StyleGuide$Badge$viewLabel = function(label) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            A2($author$project$Ui$Badge$fromString, _List_Nil, label)
        ]));
    };
    var $author$project$Pages$StyleGuide$Badge$viewListingStatus = function(status) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Components$Marketplace$Product$Status$view(status)
        ]));
    };
    var $author$project$Pages$StyleGuide$Badge$viewBody = _List_fromArray([
        $author$project$Ui$Typography$headingLg(_List_fromArray([
            $elm$html$Html$text('Badge')
        ])),
        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title('Supported labels')
                ]), {
                    Lk: 'Badge.fromString [] "active\"',
                    EU: A2($elm$core$List$map, $author$project$Pages$StyleGuide$Badge$viewLabel, $author$project$Pages$StyleGuide$Badge$supportedLables)
                }),
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title('Non supported label')
                ]), {
                    Lk: 'Badge.fromString [] "other->unsupported\"',
                    EU: _List_fromArray([
                        A2($author$project$Ui$Badge$fromString, _List_Nil, 'other->unsupported')
                    ])
                })
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title("Marketplace \u2014 Product Listing Status")
                ]), {
                    Lk: 'Badge.view (listingStatusOptions product.listingStatus)\n    [ text (Status.toLabel product.listingStatus) ]',
                    EU: A2($elm$core$List$map, $author$project$Pages$StyleGuide$Badge$viewListingStatus, $author$project$Pages$StyleGuide$Badge$marketplaceStatuses)
                })
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Badge$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$Badge$viewBody,
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Badge$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Badge$view);
    var $author$project$Pages$StyleGuide$Button$init = function(_v0) {
        return _Utils_Tuple2({}, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Button$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Button$update = F2(function(_v0, _v1) {
        return _Utils_Tuple2({}, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Generated$StyleGuide$Examples$buttonExampleFullWidthGroup = '\n    [ Button.group\n        [ Button.view\n            { ariaLabel = "Active" }\n            [ Button.active True, Button.fullWidth True ]\n            [ text "Active" ]\n        , Button.view\n            { ariaLabel = "Inactive" }\n            [ Button.fullWidth True ]\n            [ text "Inactive" ]\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$buttonExampleGroup = '\n    [ Button.group\n        [ Button.view\n            { ariaLabel = "Active" }\n            [ Button.active True ]\n            [ text "Active" ]\n        , Button.view\n            { ariaLabel = "Inactive" }\n            []\n            [ text "Inactive" ]\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$buttonExampleIcon = '\n    [ Button.view { ariaLabel = "Send message" } [ Button.sm, Button.icon Icon.send ] [ text "Send" ]\n    , Button.view { ariaLabel = "Send message" } [ Button.icon Icon.send ] [ text "Send" ]\n    , Button.view { ariaLabel = "Send message" } [ Button.lg, Button.icon Icon.send ] [ text "Send" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$buttonExampleIconOnly = '\n    [ Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.sm\n        , Button.icon Icon.flag\n        ]\n        []\n    , Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.icon Icon.flag\n        ]\n        []\n    , Button.view\n        { ariaLabel = "Flag Button" }\n        [ Button.secondary\n        , Button.lg\n        , Button.icon Icon.flag\n        ]\n        []\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$buttonExampleLink = '\n    [ Button.view { ariaLabel = "Small link button" } [ Button.link, Button.sm ] [ text "Small link" ]\n    , Button.view { ariaLabel = "Link button" } [ Button.link ] [ text "Link" ]\n    , Button.view { ariaLabel = "Large link button" } [ Button.link, Button.lg ] [ text "Chonk link" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$buttonExampleOther = '\n    [ Button.view { ariaLabel = "Loading button" } [ Button.loading True ] [ text "Loading..." ]\n    , Button.view { ariaLabel = "Disabled button" } [ Button.disabled True ] [ text "disabled" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$buttonExampleSecondaryOverSubtle = '\n    [ Button.view { ariaLabel = "over subtle" } [ Button.secondary ] [ text "I\'m lighter!" ]\n    ]\n    ';
    var $author$project$Generated$StyleGuide$Examples$buttonExampleSize = '\n    [ Button.view { ariaLabel = "Small button" } [ Button.sm ] [ text "Small" ]\n    , Button.view { ariaLabel = "Medium button" } [] [ text "Medium" ]\n    , Button.view { ariaLabel = "Large button" } [ Button.lg ] [ text "Large" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$buttonExampleStyled = '\n    [ Button.view { ariaLabel = "Default button" } [] [ text "Default" ]\n    , Button.view { ariaLabel = "Primary button" } [ Button.primary ] [ text "Primary" ]\n    , Button.view { ariaLabel = "Secondary button" } [ Button.secondary ] [ text "Secondary" ]\n    , Button.view { ariaLabel = "Success button" } [ Button.success ] [ text "Success" ]\n    , Button.view { ariaLabel = "Warning button" } [ Button.warning ] [ text "Warning" ]\n    , Button.view { ariaLabel = "Danger button" } [ Button.danger ] [ text "Danger" ]\n    , Hr.view []\n    , Button.view { ariaLabel = "Link button" } [ Button.link ] [ text "Link" ]\n    , Button.view { ariaLabel = "Grey link button" } [ Button.styled Button.GreyLink ] [ text "Grey Link" ]\n    ]    ';
    var $author$project$Components$StyleGuide$Example$Description = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$StyleGuide$Example$description = $author$project$Components$StyleGuide$Example$Description;
    var $author$project$Pages$StyleGuide$Button$exampleFullWidthGroup = _List_fromArray([
        $author$project$Ui$Button$group(_List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Active'
            }, _List_fromArray([
                $author$project$Ui$Button$active(true),
                $author$project$Ui$Button$fullWidth(true)
            ]), _List_fromArray([
                $elm$html$Html$text('Active')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Inactive'
            }, _List_fromArray([
                $author$project$Ui$Button$fullWidth(true)
            ]), _List_fromArray([
                $elm$html$Html$text('Inactive')
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Button$exampleGroup = _List_fromArray([
        $author$project$Ui$Button$group(_List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Active'
            }, _List_fromArray([
                $author$project$Ui$Button$active(true)
            ]), _List_fromArray([
                $elm$html$Html$text('Active')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Inactive'
            }, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Inactive')
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Button$exampleIcon = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Send message'
        }, _List_fromArray([
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
        ]), _List_fromArray([
            $elm$html$Html$text('Send')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Send message'
        }, _List_fromArray([
            $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
        ]), _List_fromArray([
            $elm$html$Html$text('Send')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Send message'
        }, _List_fromArray([
            $author$project$Ui$Button$lg,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$send)
        ]), _List_fromArray([
            $elm$html$Html$text('Send')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Button$exampleIconOnly = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Flag Button'
        }, _List_fromArray([
            $author$project$Ui$Button$secondary,
            $author$project$Ui$Button$sm,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
        ]), _List_Nil),
        A3($author$project$Ui$Button$view, {
            abP: 'Flag Button'
        }, _List_fromArray([
            $author$project$Ui$Button$secondary,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
        ]), _List_Nil),
        A3($author$project$Ui$Button$view, {
            abP: 'Flag Button'
        }, _List_fromArray([
            $author$project$Ui$Button$secondary,
            $author$project$Ui$Button$lg,
            $author$project$Ui$Button$icon($author$project$Ui$Icon$flag)
        ]), _List_Nil)
    ]);
    var $author$project$Pages$StyleGuide$Button$exampleLink = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Small link button'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$sm
        ]), _List_fromArray([
            $elm$html$Html$text('Small link')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Link button'
        }, _List_fromArray([
            $author$project$Ui$Button$link
        ]), _List_fromArray([
            $elm$html$Html$text('Link')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Large link button'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$lg
        ]), _List_fromArray([
            $elm$html$Html$text('Chonk link')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Button$exampleOther = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Loading button'
        }, _List_fromArray([
            $author$project$Ui$Button$loading(true)
        ]), _List_fromArray([
            $elm$html$Html$text('Loading...')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Disabled button'
        }, _List_fromArray([
            $author$project$Ui$Button$disabled(true)
        ]), _List_fromArray([
            $elm$html$Html$text('disabled')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Button$exampleSecondaryOverSubtle = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'over subtle'
        }, _List_fromArray([
            $author$project$Ui$Button$secondary
        ]), _List_fromArray([
            $elm$html$Html$text('I\'m lighter!')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Button$exampleSize = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Small button'
        }, _List_fromArray([
            $author$project$Ui$Button$sm
        ]), _List_fromArray([
            $elm$html$Html$text('Small')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Medium button'
        }, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Medium')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Large button'
        }, _List_fromArray([
            $author$project$Ui$Button$lg
        ]), _List_fromArray([
            $elm$html$Html$text('Large')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Button$exampleStyled = _List_fromArray([
        A3($author$project$Ui$Button$view, {
            abP: 'Default button'
        }, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Default')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Primary button'
        }, _List_fromArray([
            $author$project$Ui$Button$primary
        ]), _List_fromArray([
            $elm$html$Html$text('Primary')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Secondary button'
        }, _List_fromArray([
            $author$project$Ui$Button$secondary
        ]), _List_fromArray([
            $elm$html$Html$text('Secondary')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Success button'
        }, _List_fromArray([
            $author$project$Ui$Button$success
        ]), _List_fromArray([
            $elm$html$Html$text('Success')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Warning button'
        }, _List_fromArray([
            $author$project$Ui$Button$warning
        ]), _List_fromArray([
            $elm$html$Html$text('Warning')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Danger button'
        }, _List_fromArray([
            $author$project$Ui$Button$danger
        ]), _List_fromArray([
            $elm$html$Html$text('Danger')
        ])),
        $author$project$Ui$HorizontalRule$view(_List_Nil),
        A3($author$project$Ui$Button$view, {
            abP: 'Link button'
        }, _List_fromArray([
            $author$project$Ui$Button$link
        ]), _List_fromArray([
            $elm$html$Html$text('Link')
        ])),
        A3($author$project$Ui$Button$view, {
            abP: 'Grey link button'
        }, _List_fromArray([
            $author$project$Ui$Button$styled(8)
        ]), _List_fromArray([
            $elm$html$Html$text('Grey Link')
        ]))
    ]);
    var $author$project$Components$StyleGuide$Example$Subtle = 1;
    var $author$project$Components$StyleGuide$Example$Surface = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$StyleGuide$Example$subtleSurface = $author$project$Components$StyleGuide$Example$Surface(1);
    var $author$project$Pages$StyleGuide$Button$view = function(_v0) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Button Styles'),
                            $author$project$Components$StyleGuide$Example$description(_List_Nil)
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleStyled,
                            EU: $author$project$Pages$StyleGuide$Button$exampleStyled
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Button Sizes')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleSize,
                            EU: $author$project$Pages$StyleGuide$Button$exampleSize
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Button Secondary over subtle surface'),
                            $author$project$Components$StyleGuide$Example$subtleSurface
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleSecondaryOverSubtle,
                            EU: $author$project$Pages$StyleGuide$Button$exampleSecondaryOverSubtle
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Link options'),
                            $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                                $elm$html$Html$text('Buttons that look like links but don\'t have a href')
                            ]))
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleLink,
                            EU: $author$project$Pages$StyleGuide$Button$exampleLink
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Other options')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleOther,
                            EU: $author$project$Pages$StyleGuide$Button$exampleOther
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Button Group')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleGroup,
                            EU: $author$project$Pages$StyleGuide$Button$exampleGroup
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Full width button Group')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleFullWidthGroup,
                            EU: $author$project$Pages$StyleGuide$Button$exampleFullWidthGroup
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('with Icon')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleIcon,
                            EU: $author$project$Pages$StyleGuide$Button$exampleIcon
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('with Icon and no content'),
                            $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                                $elm$html$Html$text('They require Button.ariaLabel option for accessibility')
                            ]))
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$buttonExampleIconOnly,
                            EU: $author$project$Pages$StyleGuide$Button$exampleIconOnly
                        })
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Button$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Button$init,
        ahE: $author$project$Pages$StyleGuide$Button$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Button$update,
        aid: $author$project$Pages$StyleGuide$Button$view
    });
    var $author$project$Pages$StyleGuide$Carousel$CarouselMsg = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$Carousel$init = function(_v0) {
        return _Utils_Tuple2({
            pR: $author$project$Components$Carousel$init($elm$core$Basics$identity)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Carousel$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Carousel$update = F2(function(msg, model) {
        var subMsg = msg;
        return A2($elm$core$Tuple$mapFirst, function(carousel) {
            return _Utils_update(model, {
                pR: carousel
            });
        }, A2($author$project$Components$Carousel$update, subMsg, model.pR));
    });
    var $author$project$Pages$StyleGuide$Carousel$images = _List_fromArray([
        A3($author$project$Components$Carousel$image, '1', 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/full-logo.svg', 'Hint Logo'),
        A3($author$project$Components$Carousel$image, '2', 'https://cdn2.hubspot.net/hubfs/2562809/production-app/web/onboarding-complete.png', 'Hint Logo')
    ]);
    var $author$project$Pages$StyleGuide$Carousel$view = function(model) {
        return {
            fb: $elm$core$List$singleton(A3($author$project$Components$Carousel$view, _List_fromArray([
                $author$project$Components$Carousel$aspectVideo
            ]), model.pR, $author$project$Pages$StyleGuide$Carousel$images)),
            $2: 'StyleGuide.Carousel'
        };
    };
    var $author$project$Pages$StyleGuide$Carousel$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Carousel$init,
        ahE: $author$project$Pages$StyleGuide$Carousel$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Carousel$update,
        aid: $author$project$Pages$StyleGuide$Carousel$view
    });
    var $author$project$Pages$StyleGuide$Checkbox$init = function(_v0) {
        return {
            v8: false,
            v9: true,
            pT: false,
            pU: false,
            pV: false
        };
    };
    var $author$project$Spa$Page$sandbox = function(page) {
        return {
            aeq: F2(function(_v0, url) {
                return _Utils_Tuple3(page.aeq(url), $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aeR: $elm$core$Basics$always($author$project$Spa$Page$ignoreEffect),
            ag3: $elm$core$Basics$always($elm$core$Basics$identity),
            ahE: function(_v1) {
                return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(msg, model) {
                return _Utils_Tuple3(A2(page.aaO, msg, model), $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: page.aid
        };
    };
    var $author$project$Pages$StyleGuide$Checkbox$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var value = msg.a;
                return _Utils_update(model, {
                    v8: value
                });
            case 1:
                var value = msg.a;
                return _Utils_update(model, {
                    v9: value
                });
            case 2:
                var value = msg.a;
                return _Utils_update(model, {
                    pT: value
                });
            case 3:
                var value = msg.a;
                return _Utils_update(model, {
                    pU: value
                });
            case 4:
                var value = msg.a;
                return _Utils_update(model, {
                    pV: value
                });
            default:
                var value = msg.a;
                return _Utils_update(model, {
                    pT: value,
                    pU: value,
                    pV: value
                });
        }
    });
    var $author$project$Pages$StyleGuide$Checkbox$Checkbox1Changed = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Checkbox$Checkbox2Changed = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Checkbox$Checkbox3Changed = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Checkbox$Checkbox4Changed = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Checkbox$Checkbox5Changed = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Checkbox$ToggleAllCheckboxes = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Checkbox$viewBody = function(_v0) {
        var checkbox1 = _v0.v8;
        var checkbox2 = _v0.v9;
        var checkbox3 = _v0.pT;
        var checkbox4 = _v0.pU;
        var checkbox5 = _v0.pV;
        var indeterminateChecked = checkbox3 && checkbox4 && checkbox5;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Form > Checkbox')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(checkbox1),
                    $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox1Changed)
                ]), _List_fromArray([
                    $elm$html$Html$text('Checkbox')
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(checkbox2),
                    $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox2Changed)
                ]), _List_fromArray([
                    A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Checkbox')
                    ])),
                    A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('With multiple lines')
                    ]))
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(false),
                    $author$project$Ui$Form$Checkbox$disabled(true)
                ]), _List_fromArray([
                    $elm$html$Html$text('Disabled Checkbox')
                ])),
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(true),
                    $author$project$Ui$Form$Checkbox$disabled(true)
                ]), _List_fromArray([
                    $elm$html$Html$text('Disabled Checkbox')
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(indeterminateChecked),
                    $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$ToggleAllCheckboxes)
                ]), _List_fromArray([
                    $elm$html$Html$text('Check All')
                ])),
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(checkbox3),
                    $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox3Changed)
                ]), _List_fromArray([
                    $elm$html$Html$text('A')
                ])),
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(checkbox4),
                    $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox4Changed)
                ]), _List_fromArray([
                    $elm$html$Html$text('B')
                ])),
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(checkbox5),
                    $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$Checkbox$Checkbox5Changed)
                ]), _List_fromArray([
                    $elm$html$Html$text('C')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$StyleGuide$Checkbox$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$StyleGuide$Checkbox$viewBody(model)
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Checkbox$page = $author$project$Spa$Page$sandbox({
        aeq: $author$project$Pages$StyleGuide$Checkbox$init,
        aaO: $author$project$Pages$StyleGuide$Checkbox$update,
        aid: $author$project$Pages$StyleGuide$Checkbox$view
    });
    var $author$project$Pages$StyleGuide$CurrencyInput$init = function(_v0) {
        return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$CurrencyInput$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$CurrencyInput$update = F2(function(msg, _v0) {
        var _int = msg;
        return _Utils_Tuple2(_int, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$StyleGuide$CurrencyInput$CurrencyInputChanged = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$CurrencyInput$amountInCentsErrors = function(currency) {
        return $author$project$Utils$Maybe$toBool(currency) ? _List_Nil : _List_fromArray([
            'Please enter an amount.'
        ]);
    };
    var $author$project$Pages$StyleGuide$CurrencyInput$viewBody = function(amountInCents) {
        return _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Form -> Currency Input')
            ])),
            $author$project$Ui$Form$CurrencyInput$view(_List_fromArray([
                $author$project$Ui$Form$CurrencyInput$value(amountInCents),
                $author$project$Ui$Form$CurrencyInput$onInput($elm$core$Basics$identity),
                $author$project$Ui$Form$CurrencyInput$invalid(!$author$project$Utils$Maybe$toBool(amountInCents)),
                $author$project$Ui$Form$CurrencyInput$errors($author$project$Pages$StyleGuide$CurrencyInput$amountInCentsErrors(amountInCents))
            ])),
            $elm$html$Html$text('Amount in cents: ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Currency$toString, amountInCents)))
        ]);
    };
    var $author$project$Pages$StyleGuide$CurrencyInput$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$CurrencyInput$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$CurrencyInput$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$CurrencyInput$init,
        ahE: $author$project$Pages$StyleGuide$CurrencyInput$subscriptions,
        aaO: $author$project$Pages$StyleGuide$CurrencyInput$update,
        aid: $author$project$Pages$StyleGuide$CurrencyInput$view
    });
    var $author$project$Pages$StyleGuide$DateInput$DateInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$DateInput$init = function(_v0) {
        var _v1 = $author$project$Components$DateInput$init;
        var invalidDateInput = _v1.a;
        var invalidDateInputCmd = _v1.b;
        var _v2 = $author$project$Components$DateInput$init;
        var disabledDateInput = _v2.a;
        var disabledDateInputCmd = _v2.b;
        var _v3 = $author$project$Components$DateInput$init;
        var dateInput = _v3.a;
        var dateInputCmd = _v3.b;
        return _Utils_Tuple2({
            M4: $elm$core$Maybe$Nothing,
            qg: dateInput,
            xj: disabledDateInput,
            yh: invalidDateInput
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DateInputMsg, dateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg, invalidDateInputCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg, disabledDateInputCmd)
        ])));
    };
    var $author$project$Pages$StyleGuide$DateInput$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$DateInput$update = F2(function(msg, model) {
        switch(msg.$){
            case 2:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$DateInput$update, subMsg, model.qg);
                var disabledDateInput = _v1.a;
                var disabledDateInputCmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    xj: disabledDateInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg, disabledDateInputCmd));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Components$DateInput$update, subMsg, model.qg);
                var invalidDateInput = _v2.a;
                var invalidDateInputCmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    yh: invalidDateInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg, invalidDateInputCmd));
            default:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Components$DateInput$update, subMsg, model.qg);
                var dateInput = _v3.a;
                var dateInputCmd = _v3.b;
                var dateInputEvent = _v3.c;
                var date = function() {
                    if (dateInputEvent.$ === 1) {
                        var date_ = dateInputEvent.a;
                        return date_;
                    } else return model.M4;
                }();
                return _Utils_Tuple2(_Utils_update(model, {
                    M4: date,
                    qg: dateInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$DateInput$DateInputMsg, dateInputCmd));
        }
    });
    var $author$project$Generated$StyleGuide$Examples$dateInputExample1 = '\n    [ DateInput.view\n        [ DateInput.value model.date\n        ]\n        model.dateInput\n        |> Html.map DateInputMsg\n    , text\n        ("Date: "\n            ++ (model.date\n                    |> Maybe.map Date.toIsoString\n                    |> Maybe.withDefault "N/A"\n               )\n        )\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dateInputExampleDisabled = '\n    [ DateInput.view\n        [ DateInput.placeholder "disabled"\n        , DateInput.disabled True\n        ]\n        model.disabledDateInput\n        |> Html.map DisabledDateInputMsg\n    ]\n    ';
    var $author$project$Generated$StyleGuide$Examples$dateInputExampleInvalid = '\n    [ DateInput.view\n        [ DateInput.placeholder "invalid"\n        , DateInput.invalid True\n        , DateInput.errors [ "Some error" ]\n        ]\n        model.invalidDateInput\n        |> Html.map InvalidDateInputMsg\n    ]    ';
    var $author$project$Pages$StyleGuide$DateInput$example1 = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$DateInput$DateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                $author$project$Components$DateInput$value(model.M4)
            ]), model.qg)),
            $elm$html$Html$text('Date: ' + A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $justinmimbs$date$Date$toIsoString, model.M4)))
        ]);
    };
    var $author$project$Pages$StyleGuide$DateInput$exampleDisabled = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$DateInput$DisabledDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                $author$project$Components$DateInput$placeholder('disabled'),
                $author$project$Components$DateInput$disabled(true)
            ]), model.xj))
        ]);
    };
    var $author$project$Pages$StyleGuide$DateInput$exampleInvalid = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$DateInput$InvalidDateInputMsg, A2($author$project$Components$DateInput$view, _List_fromArray([
                $author$project$Components$DateInput$placeholder('invalid'),
                $author$project$Components$DateInput$invalid(true),
                $author$project$Components$DateInput$errors(_List_fromArray([
                    'Some error'
                ]))
            ]), model.yh))
        ]);
    };
    var $author$project$Pages$StyleGuide$DateInput$viewBody = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Date Input')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$dateInputExample1,
                        EU: $author$project$Pages$StyleGuide$DateInput$example1(model)
                    })
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Disabled date input')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$dateInputExampleDisabled,
                        EU: $author$project$Pages$StyleGuide$DateInput$exampleDisabled(model)
                    })
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Invalid date input')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$dateInputExampleInvalid,
                        EU: $author$project$Pages$StyleGuide$DateInput$exampleInvalid(model)
                    })
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$DateInput$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$DateInput$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$DateInput$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$DateInput$init,
        ahE: $author$project$Pages$StyleGuide$DateInput$subscriptions,
        aaO: $author$project$Pages$StyleGuide$DateInput$update,
        aid: $author$project$Pages$StyleGuide$DateInput$view
    });
    var $author$project$Pages$StyleGuide$DateRangeInput$DateRangeInputMsg = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$DateRangeInput$dateRangeInputSettings = F2(function(start, end) {
        var defaultSettings = $author$project$Components$DateRangeInput$defaultSettings;
        return _Utils_update(defaultSettings, {
            ad1: start,
            ahV: end
        });
    });
    var $author$project$Utils$Date$fromQuery = F2(function(key, query) {
        return A2($elm$core$Maybe$andThen, $author$project$Utils$Date$fromIsoString, A2($elm$core$Dict$get, key, query));
    });
    var $author$project$Pages$StyleGuide$DateRangeInput$init = F2(function(_v0, _v1) {
        var query = _v1.Bz;
        var rawUrl = _v1.agv;
        var start = A2($author$project$Utils$Date$fromQuery, 'start', query);
        var end = A2($author$project$Utils$Date$fromQuery, 'end', query);
        var _v2 = A2($author$project$Components$DateRangeInput$init, 'date-range', A2($author$project$Pages$StyleGuide$DateRangeInput$dateRangeInputSettings, start, end));
        var dateRangeInput = _v2.a;
        var dateRangeInputCmd = _v2.b;
        return _Utils_Tuple3({
            h6: dateRangeInput,
            Fn: end,
            V6: rawUrl.V6,
            HB: start
        }, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, dateRangeInputCmd), _List_Nil);
    });
    var $author$project$Pages$StyleGuide$DateRangeInput$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$DateRangeInput$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$DateRangeInput$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $elm$core$Basics$identity, $author$project$Components$DateRangeInput$subscriptions(model.h6));
    };
    var $author$project$Pages$StyleGuide$DateRangeInput$updateUrl = F3(function(model, start, end) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), $author$project$Utils$Date$toQuery), start),
            A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), $author$project$Utils$Date$toQuery), end)
        ]);
        return $author$project$Ports$Navigation$pushUrl(A2($elm$url$Url$Builder$relative, _List_fromArray([
            model.V6
        ]), A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams)));
    });
    var $author$project$Pages$StyleGuide$DateRangeInput$update = F2(function(msg, model) {
        var subMsg = msg;
        var _v1 = A2($author$project$Components$DateRangeInput$update, subMsg, model.h6);
        var dateRangeInput = _v1.a;
        var subCmd = _v1.b;
        var event = _v1.c;
        var _v2 = function() {
            if (event.$ === 1) {
                var fromDate = event.a;
                var toDate = event.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    Fn: toDate,
                    HB: fromDate
                }), _List_fromArray([
                    A3($author$project$Pages$StyleGuide$DateRangeInput$updateUrl, model, fromDate, toDate)
                ]));
            } else return _Utils_Tuple2(model, _List_Nil);
        }();
        var newModel = _v2.a;
        var cmds = _v2.b;
        return _Utils_Tuple3(_Utils_update(newModel, {
            h6: dateRangeInput
        }), $elm$core$Platform$Cmd$batch(A2($elm$core$List$cons, A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, subCmd), cmds)), _List_Nil);
    });
    var $author$project$Pages$StyleGuide$DateRangeInput$viewBody = function(model) {
        return _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Date Range Input')
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Default')
            ])),
            A2($elm$html$Html$map, $elm$core$Basics$identity, $author$project$Components$DateRangeInput$view(model.h6)),
            $elm$html$Html$text('Start: ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, model.HB))),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            $elm$html$Html$text('End: ' + A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $author$project$Utils$Date$toQuery, model.Fn)))
        ]);
    };
    var $author$project$Pages$StyleGuide$DateRangeInput$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$DateRangeInput$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$DateRangeInput$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$StyleGuide$DateRangeInput$init,
        aeR: $author$project$Pages$StyleGuide$DateRangeInput$load,
        ag3: $author$project$Pages$StyleGuide$DateRangeInput$save,
        ahE: $author$project$Pages$StyleGuide$DateRangeInput$subscriptions,
        aaO: $author$project$Pages$StyleGuide$DateRangeInput$update,
        aid: $author$project$Pages$StyleGuide$DateRangeInput$view
    });
    var $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$DisabledDropdownMsg = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$ErrorDropdownMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$InnerDropdownMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$LangDropdownMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$LangWithSearchDropdownMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$LinksDropdownMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$MultiLangDropdownMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$OuterDropdownMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$ReadonlyDropdownMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$SecondInnerDropdownMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$WithInputMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$toRight = function(config) {
        return _Utils_update(config, {
            a1: 1
        });
    };
    var $author$project$Pages$StyleGuide$Dropdown$init = function(_v0) {
        return _Utils_Tuple2({
            bq: _List_Nil,
            lB: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'free-text-dropdown',
                ahX: $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownMsg
            })),
            lC: '',
            ip: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'disabled-dropdown',
                ahX: $author$project$Pages$StyleGuide$Dropdown$DisabledDropdownMsg
            })),
            iF: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'error-dropdown',
                ahX: $author$project$Pages$StyleGuide$Dropdown$ErrorDropdownMsg
            })),
            iV: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toRight($author$project$Ui$Dropdown$defaultConfig({
                aef: 'inner',
                ahX: $author$project$Pages$StyleGuide$Dropdown$InnerDropdownMsg
            }))),
            fZ: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'lang-dropdown',
                ahX: $author$project$Pages$StyleGuide$Dropdown$LangDropdownMsg
            })),
            f_: '',
            i1: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'lang-dropdown-with-search',
                ahX: $author$project$Pages$StyleGuide$Dropdown$LangWithSearchDropdownMsg
            })),
            mW: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'links-dropdown',
                ahX: $author$project$Pages$StyleGuide$Dropdown$LinksDropdownMsg
            })),
            jg: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'multi-lang-dropdown',
                ahX: $author$project$Pages$StyleGuide$Dropdown$MultiLangDropdownMsg
            })),
            jl: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'outer',
                ahX: $author$project$Pages$StyleGuide$Dropdown$OuterDropdownMsg
            })),
            gA: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'readonly-dropdown',
                ahX: $author$project$Pages$StyleGuide$Dropdown$ReadonlyDropdownMsg
            })),
            j0: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toRight($author$project$Ui$Dropdown$defaultConfig({
                aef: 'second-inner',
                ahX: $author$project$Pages$StyleGuide$Dropdown$SecondInnerDropdownMsg
            }))),
            m: $elm$core$Maybe$Nothing,
            kA: $elm$core$Maybe$Nothing,
            aa9: $elm$core$Maybe$Nothing,
            ph: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'with-input',
                ahX: $author$project$Pages$StyleGuide$Dropdown$WithInputMsg
            }))
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Dropdown$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(model.fZ),
            $author$project$Ui$Dropdown$subscriptions(model.i1),
            $author$project$Ui$Dropdown$subscriptions(model.jg),
            model.iV.Vw || model.j0.Vw ? $elm$core$Platform$Sub$none : $author$project$Ui$Dropdown$subscriptions(model.jl),
            $author$project$Ui$Dropdown$subscriptions(model.iV),
            $author$project$Ui$Dropdown$subscriptions(model.j0),
            $author$project$Ui$Dropdown$subscriptions(model.ph),
            $author$project$Ui$Dropdown$subscriptions(model.ip),
            $author$project$Ui$Dropdown$subscriptions(model.gA),
            $author$project$Ui$Dropdown$subscriptions(model.iF),
            $author$project$Ui$Dropdown$subscriptions(model.lB),
            $author$project$Ui$Dropdown$subscriptions(model.mW)
        ]));
    };
    var $author$project$Pages$StyleGuide$Dropdown$update = F2(function(msg, model) {
        switch(msg.$){
            case 6:
                var text = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    f_: text
                }), $elm$core$Platform$Cmd$none);
            case 5:
                return _Utils_Tuple2(_Utils_update(model, {
                    f_: '',
                    m: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var lang = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    f_: '',
                    m: $elm$core$Maybe$Just(lang),
                    kA: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none);
            case 4:
                var lang = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    lC: lang,
                    m: $elm$core$Maybe$Just(lang)
                }), $elm$core$Platform$Cmd$none);
            case 0:
                var dropdownMsg = msg.a;
                var _v1 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.fZ);
                var newDropdown = _v1.a;
                var dropdownCmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    fZ: newDropdown
                }), dropdownCmd);
            case 1:
                var dropdownMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.i1);
                var newDropdown = _v2.a;
                var dropdownCmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    i1: newDropdown
                }), dropdownCmd);
            case 2:
                var dropdownMsg = msg.a;
                var _v3 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.jg);
                var newDropdown = _v3.a;
                var dropdownCmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    jg: newDropdown
                }), dropdownCmd);
            case 9:
                var dropdownMsg = msg.a;
                var _v4 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.jl);
                var newDropdown = _v4.a;
                var dropdownCmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    jl: newDropdown
                }), dropdownCmd);
            case 10:
                var dropdownMsg = msg.a;
                var _v5 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.iV);
                var newDropdown = _v5.a;
                var dropdownCmd = _v5.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    iV: newDropdown
                }), dropdownCmd);
            case 11:
                var dropdownMsg = msg.a;
                var _v6 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.j0);
                var newDropdown = _v6.a;
                var dropdownCmd = _v6.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    j0: newDropdown
                }), dropdownCmd);
            case 12:
                var dropdownMsg = msg.a;
                var _v7 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.ph);
                var newDropdown = _v7.a;
                var dropdownCmd = _v7.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ph: newDropdown
                }), dropdownCmd);
            case 7:
                var lang = msg.a;
                var checked = msg.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    bq: checked ? A2($elm$core$List$cons, lang, model.bq) : A2($elm$core$List$filter, $elm$core$Basics$neq(lang), model.bq)
                }), $elm$core$Platform$Cmd$none);
            case 8:
                var langs = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    bq: langs
                }), $elm$core$Platform$Cmd$none);
            case 13:
                var lang = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    kA: $elm$core$Maybe$Just(lang)
                }), $elm$core$Platform$Cmd$none);
            case 14:
                var dropdownMsg = msg.a;
                var _v8 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.ip);
                var newDropdown = _v8.a;
                var dropdownCmd = _v8.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ip: newDropdown
                }), dropdownCmd);
            case 15:
                var dropdownMsg = msg.a;
                var _v9 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.gA);
                var newDropdown = _v9.a;
                var dropdownCmd = _v9.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    gA: newDropdown
                }), dropdownCmd);
            case 16:
                var dropdownMsg = msg.a;
                var _v10 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.iF);
                var newDropdown = _v10.a;
                var dropdownCmd = _v10.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    iF: newDropdown
                }), dropdownCmd);
            case 17:
                var dropdownMsg = msg.a;
                var _v11 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.lB);
                var newDropdown = _v11.a;
                var dropdownCmd = _v11.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    lB: newDropdown
                }), dropdownCmd);
            case 18:
                var string = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    lC: string
                }), $elm$core$Platform$Cmd$none);
            default:
                var dropdownMsg = msg.a;
                var _v12 = A2($author$project$Ui$Dropdown$update, dropdownMsg, model.mW);
                var newDropdown = _v12.a;
                var dropdownCmd = _v12.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    mW: newDropdown
                }), dropdownCmd);
        }
    });
    var $author$project$Generated$StyleGuide$Examples$dropdownExample = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.langDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.langDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ]\n            [ Icon.translate []\n            , span [ Html.Attributes.class "ml-1" ] [ text "Select a Language" ]\n            ]\n            options\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleDisabled = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.disabledDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.disabledDropdown\n        |> Dropdown.viewSelect [ Dropdown.disabled True ]\n            [ text "Disabled Dropdown" ]\n            options\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleInnerDropdown = '\n    -- Make sure to check the subscriptions function!\n    let\n        toOption lang =\n            Dropdown.checkbox\n                [ Dropdown.onCheck <| LangChecked lang\n                , Dropdown.checked (List.member lang model.checkedLangs)\n                ]\n                (text lang)\n    in\n    [ span [ Html.Attributes.id <| model.outerDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            if List.isEmpty model.checkedLangs then\n                "None"\n\n            else\n                model.checkedLangs |> String.join ", "\n        ]\n    , model.outerDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ]\n            [ text "Pick languages" ]\n            [ Dropdown.innerDropdown\n                [ Element.view [ Element.spaceBetween, Element.itemsCenter ]\n                    [ Html.span []\n                        [ text "Functional" ]\n                    , Icon.chevron [ Icon.info ]\n                    ]\n                ]\n                ([ "Elm", "Haskell", "Elixir", "Idris" ] |> List.map toOption)\n                model.innerDropdown\n            , Dropdown.innerDropdown\n                [ Element.view [ Element.spaceBetween, Element.itemsCenter ]\n                    [ Html.span []\n                        [ text "Object Oriented" ]\n                    , Icon.chevron [ Icon.info ]\n                    ]\n                ]\n                ([ "Ruby", "Javascript", "Python" ] |> List.map toOption)\n                model.secondInnerDropdown\n            ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleMultiSelect = '\n    let\n        toOption lang =\n            Dropdown.checkbox\n                [ Dropdown.onCheck <| LangChecked lang\n                , Dropdown.checked (List.member lang model.checkedLangs)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect <| CheckedLangsSet []\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.filter (String.contains model.langSearch)\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.multiLangDropdown.id ++ "-selected" ] [ text "Selected: " ]\n    , text <|\n        if List.isEmpty model.checkedLangs then\n            "None"\n\n        else\n            model.checkedLangs |> String.join ", "\n    , model.multiLangDropdown |> Dropdown.view [ Dropdown.buttonSecondary ] [ text "Langs" ] options\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleReadonly = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.readonlyDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.readonlyDropdown\n        |> Dropdown.viewSelect [ Dropdown.readonly True ]\n            [ text "Readonly Dropdown" ]\n            options\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleSearch = '\n    let\n        -- Transform language into an option\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            String.toLower lang |> String.contains (String.toLower model.langSearch)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            Dropdown.input\n                (Dropdown.onInput LangSearched\n                    :: Dropdown.value model.langSearch\n                    :: Dropdown.placeholder "Search..."\n                    :: (case langs of\n                            [ singleLang ] ->\n                                -- Optionally, select a single result on Enter.\n                                [ Dropdown.onEnter (LangSelected singleLang) ]\n\n                            _ ->\n                                []\n                       )\n                )\n                :: Dropdown.item\n                    [ Dropdown.onSelect LangCleared\n                    , Dropdown.selected (model.selectedLang == Nothing)\n                    ]\n                    (text "None")\n                :: Dropdown.separator\n                :: (langs\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.langWithSearchDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.langWithSearchDropdown\n        |> Dropdown.view [ Dropdown.buttonSecondary ] [ text "Lang" ] options\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithButton = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ Button.group\n        [ Button.view { ariaLabel = "Open dropdown menu" }\n            []\n            [ text <|\n                case model.selectedLang of\n                    Just lang ->\n                        lang\n\n                    Nothing ->\n                        "None"\n            ]\n        , model.langDropdown\n            |> Dropdown.view []\n                [ Icon.translate []\n                ]\n                options\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithCombobox = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| FreeLangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            String.toLower lang |> String.contains (String.toLower model.comboboxString)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            langs\n                |> List.map toOption\n    in\n    [ span [ Html.Attributes.id <| model.readonlyDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.comboboxDropdown\n        |> Dropdown.viewCombobox []\n            { onInput = ComboboxDropdownInput\n            , value = model.comboboxString\n            , onEnter =\n                langs\n                    |> List.head\n                    |> Maybe.map FreeLangSelected\n            }\n            options\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithErrors = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        options =\n            Dropdown.item\n                [ Dropdown.onSelect LangCleared\n                , Dropdown.selected (model.selectedLang == Nothing)\n                ]\n                (text "None")\n                :: Dropdown.separator\n                :: ([ "Elm", "Ruby", "Javascript", "Lua" ]\n                        |> List.map toOption\n                   )\n    in\n    [ span [ Html.Attributes.id <| model.errorDropdown.id ++ "-selected" ]\n        [ text "Selected: "\n        , text <|\n            case model.selectedLang of\n                Just lang ->\n                    lang\n\n                Nothing ->\n                    "None"\n        ]\n    , model.errorDropdown\n        |> Dropdown.viewSelect\n            [ Dropdown.errors [ "This field is required", "Please select a valid option" ]\n            , Dropdown.invalid True\n            ]\n            [ text "Dropdown with Errors" ]\n            options\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$dropdownExampleWithInput = '\n    let\n        toOption lang =\n            Dropdown.item\n                [ Dropdown.onSelect <| LangSelected lang\n                , Dropdown.selected (model.selectedLang == Just lang)\n                ]\n                (text lang)\n\n        contains lang =\n            case model.typedLang of\n                Nothing ->\n                    True\n\n                Just typedLang ->\n                    String.toLower lang |> String.contains (String.toLower typedLang)\n\n        -- Define (and filter in this case) the list of languages.\n        langs =\n            [ "Elm", "Ruby", "Javascript", "Lua", "Rust" ]\n                |> List.filter contains\n\n        options =\n            Dropdown.input\n                [ Dropdown.onInput TypedLang\n                , Dropdown.value <| Maybe.withDefault "" model.typedLang\n                , Dropdown.placeholder "Search or type your own"\n                ]\n                :: Dropdown.item\n                    [ Dropdown.onSelect LangCleared\n                    , Dropdown.selected (model.selectedLang == Nothing)\n                    ]\n                    (text "None")\n                :: Dropdown.separator\n                :: (langs\n                        |> List.map toOption\n                   )\n\n        notIfEmpty lang =\n            if String.isEmpty lang then\n                Nothing\n\n            else\n                Just lang\n    in\n    [ model.withInput\n        |> Dropdown.viewSelect []\n            [ model.typedLang\n                |> Maybe.andThen notIfEmpty\n                |> Maybe.withDefault (model.selectedLang |> Maybe.withDefault "All langs")\n                |> text\n            ]\n            options\n    ]    ';
    var $author$project$Pages$StyleGuide$Dropdown$LangCleared = {
        $: 5
    };
    var $author$project$Pages$StyleGuide$Dropdown$LangSelected = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$example = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Just(lang)))
            ]), $elm$html$Html$text(lang));
        };
        var options = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
            $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toOption, _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua'
        ]))));
        return _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$id(model.fZ.aef + '-selected')
            ]), _List_fromArray([
                $elm$html$Html$text('Selected: '),
                $elm$html$Html$text(function() {
                    var _v0 = model.m;
                    if (!_v0.$) {
                        var lang = _v0.a;
                        return lang;
                    } else return 'None';
                }())
            ])),
            A4($author$project$Ui$Dropdown$view, _List_fromArray([
                $author$project$Ui$Dropdown$buttonSecondary
            ]), _List_fromArray([
                $author$project$Ui$Icon$translate(_List_Nil),
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('ml-1')
                ]), _List_fromArray([
                    $elm$html$Html$text('Select a Language')
                ]))
            ]), options, model.fZ)
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$exampleDisabled = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Just(lang)))
            ]), $elm$html$Html$text(lang));
        };
        var options = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
            $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toOption, _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua'
        ]))));
        return _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$id(model.ip.aef + '-selected')
            ]), _List_fromArray([
                $elm$html$Html$text('Selected: '),
                $elm$html$Html$text(function() {
                    var _v0 = model.m;
                    if (!_v0.$) {
                        var lang = _v0.a;
                        return lang;
                    } else return 'None';
                }())
            ])),
            A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                $author$project$Ui$Dropdown$disabled(true)
            ]), _List_fromArray([
                $elm$html$Html$text('Disabled Dropdown')
            ]), options, model.ip)
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$LangChecked = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Dropdown$InnerDropdown = F3(function(a, b, c) {
        return {
            $: 5,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Dropdown$innerDropdown = $author$project$Ui$Dropdown$InnerDropdown;
    var $author$project$Pages$StyleGuide$Dropdown$exampleInnerDropdown = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$checkbox, _List_fromArray([
                $author$project$Ui$Dropdown$onCheck($author$project$Pages$StyleGuide$Dropdown$LangChecked(lang)),
                $author$project$Ui$Dropdown$checked(A2($elm$core$List$member, lang, model.bq))
            ]), $elm$html$Html$text(lang));
        };
        return _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$id(model.jl.aef + '-selected')
            ]), _List_fromArray([
                $elm$html$Html$text('Selected: '),
                $elm$html$Html$text($elm$core$List$isEmpty(model.bq) ? 'None' : A2($elm$core$String$join, ', ', model.bq))
            ])),
            A4($author$project$Ui$Dropdown$view, _List_fromArray([
                $author$project$Ui$Dropdown$buttonSecondary
            ]), _List_fromArray([
                $elm$html$Html$text('Pick languages')
            ]), _List_fromArray([
                A3($author$project$Ui$Dropdown$innerDropdown, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Functional')
                        ])),
                        $author$project$Ui$Icon$chevron(_List_fromArray([
                            $author$project$Ui$Icon$info
                        ]))
                    ]))
                ]), A2($elm$core$List$map, toOption, _List_fromArray([
                    'Elm',
                    'Haskell',
                    'Elixir',
                    'Idris'
                ])), model.iV),
                A3($author$project$Ui$Dropdown$innerDropdown, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$spaceBetween,
                        $author$project$Ui$Element$itemsCenter
                    ]), _List_fromArray([
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Object Oriented')
                        ])),
                        $author$project$Ui$Icon$chevron(_List_fromArray([
                            $author$project$Ui$Icon$info
                        ]))
                    ]))
                ]), A2($elm$core$List$map, toOption, _List_fromArray([
                    'Ruby',
                    'Javascript',
                    'Python'
                ])), model.j0)
            ]), model.jl)
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$CheckedLangsSet = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$exampleMultiSelect = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$checkbox, _List_fromArray([
                $author$project$Ui$Dropdown$onCheck($author$project$Pages$StyleGuide$Dropdown$LangChecked(lang)),
                $author$project$Ui$Dropdown$checked(A2($elm$core$List$member, lang, model.bq))
            ]), $elm$html$Html$text(lang));
        };
        var options = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$CheckedLangsSet(_List_Nil))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toOption, A2($elm$core$List$filter, $elm$core$String$contains(model.f_), _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua'
        ])))));
        return _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$id(model.jg.aef + '-selected')
            ]), _List_fromArray([
                $elm$html$Html$text('Selected: ')
            ])),
            $elm$html$Html$text($elm$core$List$isEmpty(model.bq) ? 'None' : A2($elm$core$String$join, ', ', model.bq)),
            A4($author$project$Ui$Dropdown$view, _List_fromArray([
                $author$project$Ui$Dropdown$buttonSecondary
            ]), _List_fromArray([
                $elm$html$Html$text('Langs')
            ]), options, model.jg)
        ]);
    };
    var $author$project$Ui$Dropdown$Readonly = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$Dropdown$readonly = $author$project$Ui$Dropdown$Readonly;
    var $author$project$Pages$StyleGuide$Dropdown$exampleReadonly = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Just(lang)))
            ]), $elm$html$Html$text(lang));
        };
        var options = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
            $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toOption, _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua'
        ]))));
        return _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$id(model.gA.aef + '-selected')
            ]), _List_fromArray([
                $elm$html$Html$text('Selected: '),
                $elm$html$Html$text(function() {
                    var _v0 = model.m;
                    if (!_v0.$) {
                        var lang = _v0.a;
                        return lang;
                    } else return 'None';
                }())
            ])),
            A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                $author$project$Ui$Dropdown$readonly(true)
            ]), _List_fromArray([
                $elm$html$Html$text('Readonly Dropdown')
            ]), options, model.gA)
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$LangSearched = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$exampleSearch = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Just(lang)))
            ]), $elm$html$Html$text(lang));
        };
        var contains = function(lang) {
            return A2($elm$core$String$contains, $elm$core$String$toLower(model.f_), $elm$core$String$toLower(lang));
        };
        var langs = A2($elm$core$List$filter, contains, _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua',
            'Rust'
        ]));
        var options = A2($elm$core$List$cons, $author$project$Ui$Dropdown$input(A2($elm$core$List$cons, $author$project$Ui$Dropdown$onInput($author$project$Pages$StyleGuide$Dropdown$LangSearched), A2($elm$core$List$cons, $author$project$Ui$Dropdown$value(model.f_), A2($elm$core$List$cons, $author$project$Ui$Dropdown$placeholder('Search...'), function() {
            if (langs.b && !langs.b.b) {
                var singleLang = langs.a;
                return _List_fromArray([
                    $author$project$Ui$Dropdown$onEnter($author$project$Pages$StyleGuide$Dropdown$LangSelected(singleLang))
                ]);
            } else return _List_Nil;
        }())))), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
            $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toOption, langs))));
        return _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$id(model.i1.aef + '-selected')
            ]), _List_fromArray([
                $elm$html$Html$text('Selected: '),
                $elm$html$Html$text(function() {
                    var _v0 = model.m;
                    if (!_v0.$) {
                        var lang = _v0.a;
                        return lang;
                    } else return 'None';
                }())
            ])),
            A4($author$project$Ui$Dropdown$view, _List_fromArray([
                $author$project$Ui$Dropdown$buttonSecondary
            ]), _List_fromArray([
                $elm$html$Html$text('Lang')
            ]), options, model.i1)
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$exampleWithButton = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Just(lang)))
            ]), $elm$html$Html$text(lang));
        };
        var options = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
            $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toOption, _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua'
        ]))));
        return _List_fromArray([
            $author$project$Ui$Button$group(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Open dropdown menu'
                }, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(function() {
                        var _v0 = model.m;
                        if (!_v0.$) {
                            var lang = _v0.a;
                            return lang;
                        } else return 'None';
                    }())
                ])),
                A4($author$project$Ui$Dropdown$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Icon$translate(_List_Nil)
                ]), options, model.fZ)
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownInput = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$FreeLangSelected = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$exampleWithCombobox = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$FreeLangSelected(lang)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Just(lang)))
            ]), $elm$html$Html$text(lang));
        };
        var contains = function(lang) {
            return A2($elm$core$String$contains, $elm$core$String$toLower(model.lC), $elm$core$String$toLower(lang));
        };
        var langs = A2($elm$core$List$filter, contains, _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua',
            'Rust'
        ]));
        var options = A2($elm$core$List$map, toOption, langs);
        return _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$id(model.gA.aef + '-selected')
            ]), _List_fromArray([
                $elm$html$Html$text('Selected: '),
                $elm$html$Html$text(function() {
                    var _v0 = model.m;
                    if (!_v0.$) {
                        var lang = _v0.a;
                        return lang;
                    } else return 'None';
                }())
            ])),
            A4($author$project$Ui$Dropdown$viewCombobox, _List_Nil, {
                afA: A2($elm$core$Maybe$map, $author$project$Pages$StyleGuide$Dropdown$FreeLangSelected, $elm$core$List$head(langs)),
                afE: $author$project$Pages$StyleGuide$Dropdown$ComboboxDropdownInput,
                aa9: model.lC
            }, options, model.lB)
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$exampleWithErrors = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Just(lang)))
            ]), $elm$html$Html$text(lang));
        };
        var options = A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
            $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toOption, _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua'
        ]))));
        return _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$id(model.iF.aef + '-selected')
            ]), _List_fromArray([
                $elm$html$Html$text('Selected: '),
                $elm$html$Html$text(function() {
                    var _v0 = model.m;
                    if (!_v0.$) {
                        var lang = _v0.a;
                        return lang;
                    } else return 'None';
                }())
            ])),
            A4($author$project$Ui$Dropdown$viewSelect, _List_fromArray([
                $author$project$Ui$Dropdown$errors(_List_fromArray([
                    'This field is required',
                    'Please select a valid option'
                ])),
                $author$project$Ui$Dropdown$invalid(true)
            ]), _List_fromArray([
                $elm$html$Html$text('Dropdown with Errors')
            ]), options, model.iF)
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$TypedLang = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$exampleWithInput = function(model) {
        var toOption = function(lang) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangSelected(lang)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Just(lang)))
            ]), $elm$html$Html$text(lang));
        };
        var notIfEmpty = function(lang) {
            return $elm$core$String$isEmpty(lang) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(lang);
        };
        var contains = function(lang) {
            var _v0 = model.kA;
            if (_v0.$ === 1) return true;
            else {
                var typedLang = _v0.a;
                return A2($elm$core$String$contains, $elm$core$String$toLower(typedLang), $elm$core$String$toLower(lang));
            }
        };
        var langs = A2($elm$core$List$filter, contains, _List_fromArray([
            'Elm',
            'Ruby',
            'Javascript',
            'Lua',
            'Rust'
        ]));
        var options = A2($elm$core$List$cons, $author$project$Ui$Dropdown$input(_List_fromArray([
            $author$project$Ui$Dropdown$onInput($author$project$Pages$StyleGuide$Dropdown$TypedLang),
            $author$project$Ui$Dropdown$value(A2($elm$core$Maybe$withDefault, '', model.kA)),
            $author$project$Ui$Dropdown$placeholder('Search or type your own')
        ])), A2($elm$core$List$cons, A2($author$project$Ui$Dropdown$item, _List_fromArray([
            $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangCleared),
            $author$project$Ui$Dropdown$selected(_Utils_eq(model.m, $elm$core$Maybe$Nothing))
        ]), $elm$html$Html$text('None')), A2($elm$core$List$cons, $author$project$Ui$Dropdown$separator, A2($elm$core$List$map, toOption, langs))));
        return _List_fromArray([
            A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, A2($elm$core$Maybe$withDefault, 'All langs', model.m), A2($elm$core$Maybe$andThen, notIfEmpty, model.kA)))
            ]), options, model.ph)
        ]);
    };
    var $author$project$Ui$Dropdown$ButtonLink = 1;
    var $author$project$Ui$Dropdown$buttonLink = $author$project$Ui$Dropdown$Button(1);
    var $author$project$Ui$Dropdown$Link = F3(function(a, b, c) {
        return {
            $: 6,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ui$Dropdown$link = $author$project$Ui$Dropdown$Link;
    var $author$project$Pages$StyleGuide$Dropdown$exampleWithLinks = function(model) {
        return _List_fromArray([
            $elm$html$Html$text('Test arrow navigation on this dropdown with links:'),
            A4($author$project$Ui$Dropdown$view, _List_fromArray([
                $author$project$Ui$Dropdown$buttonLink
            ]), _List_fromArray([
                $elm$html$Html$text('Switch To')
            ]), _List_fromArray([
                A3($author$project$Ui$Dropdown$link, 'https://example.com/clinical', _List_Nil, $elm$html$Html$text('Clinical')),
                A3($author$project$Ui$Dropdown$link, 'https://example.com/admin', _List_Nil, $elm$html$Html$text('Admin Portal')),
                A2($author$project$Ui$Dropdown$item, _List_fromArray([
                    $author$project$Ui$Dropdown$onSelect($author$project$Pages$StyleGuide$Dropdown$LangSelected('regular'))
                ]), $elm$html$Html$text('Regular Item')),
                A3($author$project$Ui$Dropdown$link, 'https://example.com/settings', _List_Nil, $elm$html$Html$text('Settings'))
            ]), model.mW)
        ]);
    };
    var $author$project$Pages$StyleGuide$Dropdown$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Select Like')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExample,
                            EU: $author$project$Pages$StyleGuide$Dropdown$example(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Select Like with search')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleSearch,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleSearch(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Multi select')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleMultiSelect,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleMultiSelect(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Dropdownception')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleInnerDropdown,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleInnerDropdown(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Next to Button')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithButton,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleWithButton(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Free text like?')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithInput,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleWithInput(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Disabled')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleDisabled,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleDisabled(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Readonly')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleReadonly,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleReadonly(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('With Errors')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithErrors,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleWithErrors(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Combobox')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$dropdownExampleWithCombobox,
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleWithCombobox(model)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('With Links (like navbar)')
                        ]), {
                            Lk: '-- Links dropdown example',
                            EU: $author$project$Pages$StyleGuide$Dropdown$exampleWithLinks(model)
                        })
                    ]))
                ]))
            ]),
            $2: 'StyleGuide.Dropdown'
        };
    };
    var $author$project$Pages$StyleGuide$Dropdown$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Dropdown$init,
        ahE: $author$project$Pages$StyleGuide$Dropdown$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Dropdown$update,
        aid: $author$project$Pages$StyleGuide$Dropdown$view
    });
    var $author$project$Pages$StyleGuide$ExportCsv$WithSession = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$ExportCsv$WithoutSession = {
        $: 1
    };
    var $author$project$Pages$StyleGuide$ExportCsv$init = F2(function(shared, _v0) {
        var _v1 = shared.Z$;
        if (_v1.$ === 3) return _Utils_Tuple3($author$project$Pages$StyleGuide$ExportCsv$WithSession({
            Ej: shared.Ej,
            md: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 0
            }),
            n_: $author$project$Components$ExportCsv$init({
                adW: false,
                Hg: 1
            })
        }), $elm$core$Platform$Cmd$none, _List_Nil);
        else return _Utils_Tuple3($author$project$Pages$StyleGuide$ExportCsv$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$ExportCsv$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$ExportCsv$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$ExportCsv$subscriptions = function(model) {
        if (!model.$) {
            var record = model.a;
            return $elm$core$Platform$Sub$batch(_List_fromArray([
                A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(record.md)),
                A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg, $author$project$Components$ExportCsv$subscriptions(record.n_))
            ]));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$ExportCsv$update = F2(function(msg, model) {
        if (model.$ === 1) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        else {
            var modelRecord = model.a;
            if (!msg.$) {
                var subMsg = msg.a;
                var _v2 = A3($author$project$Components$ExportCsv$update, modelRecord.Ej, subMsg, modelRecord.md);
                var exportCsv = _v2.a;
                var subCmd = _v2.b;
                var subOutMsgs = _v2.c;
                return _Utils_Tuple3($author$project$Pages$StyleGuide$ExportCsv$WithSession(_Utils_update(modelRecord, {
                    md: exportCsv
                })), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg, subCmd), subOutMsgs);
            } else {
                var subMsg = msg.a;
                var _v3 = A3($author$project$Components$ExportCsv$update, modelRecord.Ej, subMsg, modelRecord.n_);
                var exportCsv = _v3.a;
                var subCmd = _v3.b;
                var subOutMsgs = _v3.c;
                return _Utils_Tuple3($author$project$Pages$StyleGuide$ExportCsv$WithSession(_Utils_update(modelRecord, {
                    n_: exportCsv
                })), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg, subCmd), subOutMsgs);
            }
        }
    });
    var $author$project$Pages$StyleGuide$ExportCsv$viewBody = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg, A3($author$project$Components$ExportCsv$modal, model.Ej, _List_fromArray([
                $author$project$Components$ExportCsv$params(_List_fromArray([
                    A2($author$project$Api$Param$string, 'practitioner', 'pct-26sCCZ8P7PQC')
                ])),
                $author$project$Components$ExportCsv$path($author$project$Api$Provider$Patient$patientsPath),
                $author$project$Components$ExportCsv$filter('current_membership')
            ]), model.md)),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg, A3($author$project$Components$ExportCsv$modal, model.Ej, _List_fromArray([
                $author$project$Components$ExportCsv$report($elm$core$Maybe$Just(100)),
                $author$project$Components$ExportCsv$reportParams(_List_fromArray([
                    A2($author$project$Api$Param$string, 'signup_page', 'spg-5M6rwSEww8Y9')
                ]))
            ]), model.n_)),
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Export Csv')
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Non Report Export')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ExportCsv$ExportCsvMsg, $author$project$Components$ExportCsv$button),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Report Export')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ExportCsv$ReportExportCsvMsg, $author$project$Components$ExportCsv$button)
        ]);
    };
    var $author$project$Pages$StyleGuide$ExportCsv$view = function(model) {
        return {
            fb: function() {
                if (!model.$) {
                    var modelRecord = model.a;
                    return $author$project$Pages$StyleGuide$ExportCsv$viewBody(modelRecord);
                } else return _List_fromArray([
                    A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You need to be logged in to view this style guide')
                    ]))
                ]);
            }(),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$ExportCsv$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$StyleGuide$ExportCsv$init,
        aeR: $author$project$Pages$StyleGuide$ExportCsv$load,
        ag3: $author$project$Pages$StyleGuide$ExportCsv$save,
        ahE: $author$project$Pages$StyleGuide$ExportCsv$subscriptions,
        aaO: $author$project$Pages$StyleGuide$ExportCsv$update,
        aid: $author$project$Pages$StyleGuide$ExportCsv$view
    });
    var $author$project$Pages$StyleGuide$FileInput$init = function(_v0) {
        return _Utils_Tuple2({
            xL: _List_Nil
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$FileInput$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$FileInput$update = F2(function(msg, model) {
        var files = msg;
        return _Utils_Tuple2(_Utils_update(model, {
            xL: files
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$StyleGuide$FileInput$FilesUploaded = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$FileInput$viewFile = function(file) {
        return A2($elm$html$Html$li, _List_Nil, _List_fromArray([
            $elm$html$Html$text($elm$file$File$name(file))
        ]));
    };
    var $author$project$Pages$StyleGuide$FileInput$viewBody = function(_v0) {
        var files = _v0.xL;
        return _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Form -> Input')
            ])),
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Disabled')
            ])),
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$disabled(true)
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Mutiple')
            ])),
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$multiple(true),
                $author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Allowed types')
            ])),
            $author$project$Ui$Form$File$view(_List_fromArray([
                $author$project$Ui$Form$File$multiple(true),
                $author$project$Ui$Form$File$accept(1),
                $author$project$Ui$Form$File$accept(0),
                $author$project$Ui$Form$File$onInput($elm$core$Basics$identity)
            ])),
            $elm$html$Html$text('Selected: '),
            A2($elm$html$Html$br, _List_Nil, _List_Nil),
            A2($elm$html$Html$ul, _List_Nil, A2($elm$core$List$map, $author$project$Pages$StyleGuide$FileInput$viewFile, files))
        ]);
    };
    var $author$project$Pages$StyleGuide$FileInput$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$FileInput$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$FileInput$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$FileInput$init,
        ahE: $author$project$Pages$StyleGuide$FileInput$subscriptions,
        aaO: $author$project$Pages$StyleGuide$FileInput$update,
        aid: $author$project$Pages$StyleGuide$FileInput$view
    });
    var $author$project$Pages$StyleGuide$FlyoutMenu$AbsoluteFlyoutMenuMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$FlyoutMenu$FixedFlyoutMenuMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$FlyoutMenu$Model = $elm$core$Basics$identity;
    var $author$project$Ui$FlyoutMenu$init = F2(function(id, toMsg) {
        return {
            aef: id,
            Vw: false,
            ahX: toMsg
        };
    });
    var $author$project$Pages$StyleGuide$FlyoutMenu$init = function(_v0) {
        return _Utils_Tuple2({
            kP: A2($author$project$Ui$FlyoutMenu$init, 'absolute-menu', $author$project$Pages$StyleGuide$FlyoutMenu$AbsoluteFlyoutMenuMsg),
            ml: A2($author$project$Ui$FlyoutMenu$init, 'fixed-menu', $author$project$Pages$StyleGuide$FlyoutMenu$FixedFlyoutMenuMsg)
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Ui$FlyoutMenu$Close = 1;
    var $author$project$Ui$FlyoutMenu$decodePressedKey = function(closeMsg) {
        return A2($elm$json$Json$Decode$andThen, function(key) {
            return key === 'Escape' ? $elm$json$Json$Decode$succeed(closeMsg) : $elm$json$Json$Decode$fail('ignore');
        }, A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
    };
    var $author$project$Ui$FlyoutMenu$subscribeToEscapeKeyPress = function(closeMsg) {
        return $elm$browser$Browser$Events$onKeyDown($author$project$Ui$FlyoutMenu$decodePressedKey(closeMsg));
    };
    var $author$project$Ui$FlyoutMenu$subscriptions = function(_v0) {
        var open = _v0.Vw;
        var toMsg = _v0.ahX;
        var id = _v0.aef;
        return open ? $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$FlyoutMenu$subscribeToEscapeKeyPress(toMsg(1)),
            A2($author$project$Utils$Dom$onOutsideMouseDown, toMsg(1), id)
        ])) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$FlyoutMenu$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$FlyoutMenu$subscriptions(model.ml),
            $author$project$Ui$FlyoutMenu$subscriptions(model.kP)
        ]));
    };
    var $author$project$Ui$FlyoutMenu$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg){
            case 0:
                return _Utils_update(model, {
                    Vw: true
                });
            case 1:
                return _Utils_update(model, {
                    Vw: false
                });
            default:
                return _Utils_update(model, {
                    Vw: false
                });
        }
    });
    var $author$project$Pages$StyleGuide$FlyoutMenu$update = F2(function(msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var flyoutMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.kP);
            return _Utils_Tuple2(_Utils_update(model, {
                kP: flyoutMenu
            }), $elm$core$Platform$Cmd$none);
        } else {
            var subMsg = msg.a;
            var flyoutMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.ml);
            return _Utils_Tuple2(_Utils_update(model, {
                ml: flyoutMenu
            }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Ui$FlyoutMenu$Fixed = 0;
    var $author$project$Ui$FlyoutMenu$Body = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$FlyoutMenu$body = function(contents) {
        return $author$project$Ui$FlyoutMenu$Body(contents);
    };
    var $author$project$Ui$FlyoutMenu$Header = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$FlyoutMenu$header = function(contents) {
        return $author$project$Ui$FlyoutMenu$Header(contents);
    };
    var $author$project$Ui$FlyoutMenu$Position = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$FlyoutMenu$position = $author$project$Ui$FlyoutMenu$Position;
    var $author$project$Ui$FlyoutMenu$title = function(string) {
        return A2($elm$html$Html$h4, _List_fromArray([
            $elm$html$Html$Attributes$class('modal-title')
        ]), _List_fromArray([
            $elm$html$Html$text(string)
        ]));
    };
    var $author$project$Ui$FlyoutMenu$BlurredOutside = 2;
    var $author$project$Ui$FlyoutMenu$Down = 1;
    var $author$project$Ui$FlyoutMenu$Open = 0;
    var $author$project$Ui$FlyoutMenu$Right = 0;
    var $author$project$Ui$FlyoutMenu$Absolute = 1;
    var $author$project$Ui$FlyoutMenu$defaultOptions = {
        a1: 0,
        WX: 1
    };
    var $author$project$Ui$FlyoutMenu$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            if (!option.$) {
                var pos = option.a;
                return _Utils_update(record, {
                    WX: pos
                });
            } else {
                var dir = option.a;
                return _Utils_update(record, {
                    a1: dir
                });
            }
        }), $author$project$Ui$FlyoutMenu$defaultOptions, options);
    };
    var $author$project$Ui$FlyoutMenu$viewSection = function(section) {
        if (!section.$) {
            var contents = section.a;
            return A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flyout-menu__header')
            ]), contents);
        } else {
            var contents = section.a;
            return A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flyout-menu__content')
            ]), contents);
        }
    };
    var $author$project$Ui$FlyoutMenu$view = F4(function(options, sections, btnOrLink, _v0) {
        var model = _v0;
        var optionsRecord = $author$project$Ui$FlyoutMenu$optionsToRecord(options);
        var displayIfOpen = function(html) {
            return model.Vw ? html : $author$project$Utils$Html$empty;
        };
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('flyout-menu-wrapper'),
            $elm$html$Html$Attributes$id(model.aef),
            A2($author$project$Utils$Dom$onOutsideBlur, model.ahX(2), model.aef)
        ]), _List_fromArray([
            displayIfOpen(A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('flyout-menu', true),
                    _Utils_Tuple2('flyout-menu--right', !optionsRecord.a1),
                    _Utils_Tuple2('flyout-menu--down', optionsRecord.a1 === 1),
                    _Utils_Tuple2('flyout-menu--fixed', !optionsRecord.WX)
                ]))
            ]), A2($elm$core$List$map, $author$project$Ui$FlyoutMenu$viewSection, sections))),
            displayIfOpen(A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flyout-menu__caret')
            ]), _List_Nil)),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Events$onClick(model.ahX(0)),
                model.Vw ? A2($elm$html$Html$Attributes$style, 'pointer-events', 'none') : $elm$html$Html$Attributes$class('')
            ]), _List_fromArray([
                btnOrLink
            ]))
        ]));
    });
    var $author$project$Pages$StyleGuide$FlyoutMenu$viewBody = function(model) {
        return _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Flyout Menu')
            ])),
            A2($elm$html$Html$div, _List_Nil, $elm$core$List$singleton(A4($author$project$Ui$FlyoutMenu$view, _List_Nil, _List_fromArray([
                $author$project$Ui$FlyoutMenu$header(_List_fromArray([
                    $author$project$Ui$FlyoutMenu$title('Example Header')
                ])),
                $author$project$Ui$FlyoutMenu$body(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Menu item 1'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('Lorem Ipsum Hello World')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Menu item 2'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('Ipsum Hello World Lorem')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Menu item 3'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('Hello World Lorem Ipsum')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Menu item 4'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('World Lorem Ipsum Hello')
                    ]))
                ]))
            ]), A3($author$project$Ui$Button$view, {
                abP: 'Open absolute flyout menu'
            }, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Absolute Flyout Menu')
            ])), model.kP))),
            A2($elm$html$Html$div, _List_Nil, $elm$core$List$singleton(A4($author$project$Ui$FlyoutMenu$view, _List_fromArray([
                $author$project$Ui$FlyoutMenu$position(0)
            ]), _List_fromArray([
                $author$project$Ui$FlyoutMenu$header(_List_fromArray([
                    $author$project$Ui$FlyoutMenu$title('Example Header')
                ])),
                $author$project$Ui$FlyoutMenu$body(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Menu item 1'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('Lorem Ipsum Hello World')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Menu item 2'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('Ipsum Hello World Lorem')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Menu item 3'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('Hello World Lorem Ipsum')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Menu item 4'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link
                    ]), _List_fromArray([
                        $elm$html$Html$text('World Lorem Ipsum Hello')
                    ]))
                ]))
            ]), A3($author$project$Ui$Button$view, {
                abP: 'Open fixed flyout menu'
            }, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Fixed Flyout Menu')
            ])), model.ml)))
        ]);
    };
    var $author$project$Pages$StyleGuide$FlyoutMenu$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$FlyoutMenu$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$FlyoutMenu$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$FlyoutMenu$init,
        ahE: $author$project$Pages$StyleGuide$FlyoutMenu$subscriptions,
        aaO: $author$project$Pages$StyleGuide$FlyoutMenu$update,
        aid: $author$project$Pages$StyleGuide$FlyoutMenu$view
    });
    var $author$project$Pages$StyleGuide$FormExample$formFieldsInit = {
        IZ: $elm$core$Maybe$Nothing,
        PN: '',
        SU: ''
    };
    var $author$project$Pages$StyleGuide$FormExample$init = function(_v0) {
        return _Utils_Tuple2({
            PU: $author$project$Utils$Form$init($author$project$Pages$StyleGuide$FormExample$formFieldsInit),
            Xv: false
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$FormExample$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$FormExample$formFieldsUpdate = F2(function(field, form) {
        switch(field.$){
            case 1:
                var firstName = field.a;
                return _Utils_update(form, {
                    PN: firstName
                });
            case 2:
                var lastName = field.a;
                return _Utils_update(form, {
                    SU: lastName
                });
            default:
                var age = field.a;
                return _Utils_update(form, {
                    IZ: age
                });
        }
    });
    var $author$project$Pages$StyleGuide$FormExample$FirstNameValidation = 0;
    var $author$project$Pages$StyleGuide$FormExample$LastNameValidation = 1;
    var $author$project$Pages$StyleGuide$FormExample$AgeValidation = 2;
    var $author$project$Pages$StyleGuide$FormExample$validateAge = function(form) {
        var _v0 = form.IZ;
        if (_v0.$ === 1) return _List_Nil;
        else {
            var age = _v0.a;
            return age < 5 ? _List_fromArray([
                _Utils_Tuple2(2, 'Must be at least 5 years old')
            ]) : age > 65 ? _List_fromArray([
                _Utils_Tuple2(2, 'Must be younger than 65 years old')
            ]) : _List_Nil;
        }
    };
    var $author$project$Pages$StyleGuide$FormExample$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.PN;
        }, _Utils_Tuple2(0, 'Please enter a first name.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.SU;
        }, _Utils_Tuple2(1, 'Please enter a last name.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$StyleGuide$FormExample$validateAge)
    ]));
    var $author$project$Pages$StyleGuide$FormExample$CompletedSubmit = {
        $: 2
    };
    var $author$project$Pages$StyleGuide$FormExample$processForm = function(_v0) {
        return A2($elm$core$Task$perform, function(_v1) {
            return $author$project$Pages$StyleGuide$FormExample$CompletedSubmit;
        }, $elm$core$Process$sleep(3000));
    };
    var $author$project$Pages$StyleGuide$FormExample$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    PU: A3($author$project$Utils$Form$update, $author$project$Pages$StyleGuide$FormExample$formFieldsUpdate, field, model.PU)
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$StyleGuide$FormExample$formFieldsValidator, model.PU);
                if (!_v1.$) {
                    var _v2 = _v1.a;
                    var form = _v2.a;
                    var validFormFields = _v2.b;
                    return _Utils_Tuple2(_Utils_update(model, {
                        PU: form,
                        Xv: true
                    }), $author$project$Pages$StyleGuide$FormExample$processForm(validFormFields));
                } else {
                    var form = _v1.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        PU: form
                    }), $elm$core$Platform$Cmd$none);
                }
            default:
                return _Utils_Tuple2(_Utils_update(model, {
                    Xv: false
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Pages$StyleGuide$FormExample$Age = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$FormExample$AttemptedSubmit = {
        $: 1
    };
    var $author$project$Pages$StyleGuide$FormExample$FirstName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$FormExample$FormUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$FormExample$LastName = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$FormExample$ageToString = function(maybeInt) {
        return A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, $elm$core$String$fromInt, maybeInt));
    };
    var $author$project$Pages$StyleGuide$FormExample$maskAge = F2(function(currentAge, nextAgeString) {
        var _v0 = $elm$core$String$toInt(nextAgeString);
        if (_v0.$ === 1) return nextAgeString === '' ? $elm$core$Maybe$Nothing : currentAge;
        else {
            var age = _v0.a;
            return $elm$core$Maybe$Just(age);
        }
    });
    var $author$project$Pages$StyleGuide$FormExample$viewForm = F2(function(processing, form) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var firstName = _v0.PN;
        var lastName = _v0.SU;
        var age = _v0.IZ;
        return A2($author$project$Ui$Form$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('First Name'),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(firstName),
                            $author$project$Ui$Form$Input$placeholder('Jane'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$FirstName)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(6)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('Last Name'),
                        $author$project$Ui$Form$Group$required(true)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(lastName),
                            $author$project$Ui$Form$Input$placeholder('Doe'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$LastName)),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, form))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Age')
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(12)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value($author$project$Pages$StyleGuide$FormExample$ageToString(age)),
                            $author$project$Ui$Form$Input$placeholder('e.g 30'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Pages$StyleGuide$FormExample$FormUpdated, $author$project$Pages$StyleGuide$FormExample$Age), $author$project$Pages$StyleGuide$FormExample$maskAge(age))),
                            $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, form))
                        ])),
                        $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 2, form))
                    ]))
                ]))
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Submit form'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$disabled(processing),
                $author$project$Ui$Button$loading(processing),
                $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$FormExample$AttemptedSubmit)
            ]), _List_fromArray([
                $elm$html$Html$text('Submit')
            ]))
        ]));
    });
    var $author$project$Pages$StyleGuide$FormExample$view = function(_v0) {
        var processing = _v0.Xv;
        var form = _v0.PU;
        return {
            fb: _List_fromArray([
                A2($author$project$Pages$StyleGuide$FormExample$viewForm, processing, form)
            ]),
            $2: 'Form Example'
        };
    };
    var $author$project$Pages$StyleGuide$FormExample$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$FormExample$init,
        ahE: $author$project$Pages$StyleGuide$FormExample$subscriptions,
        aaO: $author$project$Pages$StyleGuide$FormExample$update,
        aid: $author$project$Pages$StyleGuide$FormExample$view
    });
    var $author$project$Pages$StyleGuide$FormGroup$init = function(_v0) {
        return _Utils_Tuple2({
            PN: 'Bruce',
            SU: 'Wayne',
            HM: false
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$FormGroup$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$FormGroup$update = F2(function(msg, model) {
        var bool = msg;
        return _Utils_Tuple2(_Utils_update(model, {
            HM: bool
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$StyleGuide$FormGroup$example = function(_v0) {
        var firstName = _v0.PN;
        var lastName = _v0.SU;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$labelSpanSm(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(firstName),
                            $author$project$Ui$Form$Input$placeholder('First')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(lastName),
                            $author$project$Ui$Form$Input$placeholder('Last')
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$FormGroup$TermsAcceptedchanged = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$FormGroup$exampleCheckbox = function(_v0) {
        var termsAccepted = _v0.HM;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                    $author$project$Ui$Form$Checkbox$value(termsAccepted),
                    $author$project$Ui$Form$Checkbox$required(true),
                    $author$project$Ui$Form$Checkbox$onCheck($elm$core$Basics$identity)
                ]), _List_fromArray([
                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('I agree to Hint Health\'s Terms of Service.')
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$FormGroup$exampleLabelAbove = function(_v0) {
        var firstName = _v0.PN;
        var lastName = _v0.SU;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Some label'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$labelAbove,
                $author$project$Ui$Form$Group$required(true)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(firstName),
                            $author$project$Ui$Form$Input$placeholder('First')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(lastName),
                            $author$project$Ui$Form$Input$placeholder('Last')
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$FormGroup$exampleStatic = function(_v0) {
        var firstName = _v0.PN;
        var lastName = _v0.SU;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('First Name'),
                $author$project$Ui$Form$Group$labelSpanSm(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(firstName)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Last Name'),
                $author$project$Ui$Form$Group$labelSpanSm(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(lastName)
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabel = function(_v0) {
        var firstName = _v0.PN;
        var lastName = _v0.SU;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(firstName),
                            $author$project$Ui$Form$Input$placeholder('First')
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$span(6)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(lastName),
                            $author$project$Ui$Form$Input$placeholder('Last')
                        ]))
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabelButSpaced = function(_v0) {
        var firstName = _v0.PN;
        var lastName = _v0.SU;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(firstName),
                    $author$project$Ui$Form$Input$placeholder('First')
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Label'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(lastName),
                    $author$project$Ui$Form$Input$placeholder('Last Name')
                ]))
            ]))
        ]);
    };
    var $author$project$Generated$StyleGuide$Examples$formGroupExample = '\n    [ FormGroup.view\n        [ FormGroup.label "Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$formGroupExampleCheckbox = '\n    [ FormGroup.view\n        [ FormGroup.label ""\n        , FormGroup.labelSpanSm 4\n        ]\n        [ Checkbox.view\n            [ Checkbox.value termsAccepted\n            , Checkbox.required True\n            , Checkbox.onCheck TermsAcceptedchanged\n            ]\n            [ strong []\n                [ text "I agree to Hint Health\'s Terms of Service."\n                ]\n            ]\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$formGroupExampleLabelAbove = '\n    [ FormGroup.view\n        [ FormGroup.label "Some label"\n        , FormGroup.labelSpanSm 4\n        , FormGroup.labelAbove\n        , FormGroup.required True\n        ]\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]\n    ';
    var $author$project$Generated$StyleGuide$Examples$formGroupExampleStatic = '\n    [ FormGroup.view\n        [ FormGroup.label "First Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ FormStatic.view [] [ text firstName ]\n        ]\n    , FormGroup.view\n        [ FormGroup.label "Last Name"\n        , FormGroup.labelSpanSm 4\n        ]\n        [ FormStatic.view [] [ text lastName ]\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabel = '\n    [ FormGroup.view\n        []\n        [ Grid.row []\n            [ Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value firstName\n                    , Input.placeholder "First"\n                    ]\n                ]\n            , Grid.column [ Grid.span 6 ]\n                [ Input.view\n                    [ Input.value lastName\n                    , Input.placeholder "Last"\n                    ]\n                ]\n            ]\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabelButSpaced = '\n    [ FormGroup.view\n        [ FormGroup.label ""\n        , FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        ]\n        [ Input.view\n            [ Input.value firstName\n            , Input.placeholder "First"\n            ]\n        ]\n    , FormGroup.view\n        [ FormGroup.label "Label"\n        , FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        ]\n        [ Input.view\n            [ Input.value lastName\n            , Input.placeholder "Last Name"\n            ]\n        ]\n    ]    ';
    var $author$project$Pages$StyleGuide$FormGroup$viewBody = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Form Group')
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$formGroupExample,
                        EU: $author$project$Pages$StyleGuide$FormGroup$example(model)
                    }),
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Form Group with static data'),
                        $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                            $elm$html$Html$text('Inputs and buttons have a certain height that form groups'),
                            $elm$html$Html$text(' account for, so they align.'),
                            $elm$html$Html$text(' Text, because of having way less height'),
                            $elm$html$Html$text(' need to be wrapped inside FormStatic to align.')
                        ]))
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$formGroupExampleStatic,
                        EU: $author$project$Pages$StyleGuide$FormGroup$exampleStatic(model)
                    }),
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Label above'),
                        $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                            $elm$html$Html$text('Only available in QA')
                        ]))
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$formGroupExampleLabelAbove,
                        EU: $author$project$Pages$StyleGuide$FormGroup$exampleLabelAbove(model)
                    })
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('without label'),
                        $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                            $elm$html$Html$text('Input will take the full width')
                        ]))
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabel,
                        EU: $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabel(model)
                    }),
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('without label but with left spacing'),
                        $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                            $elm$html$Html$text('Just set the label as an empty text')
                        ]))
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$formGroupExampleWithoutLabelButSpaced,
                        EU: $author$project$Pages$StyleGuide$FormGroup$exampleWithoutLabelButSpaced(model)
                    }),
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Checkbox'),
                        $author$project$Components$StyleGuide$Example$description(_List_Nil)
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$formGroupExampleCheckbox,
                        EU: $author$project$Pages$StyleGuide$FormGroup$exampleCheckbox(model)
                    })
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$FormGroup$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$FormGroup$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$FormGroup$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$FormGroup$init,
        ahE: $author$project$Pages$StyleGuide$FormGroup$subscriptions,
        aaO: $author$project$Pages$StyleGuide$FormGroup$update,
        aid: $author$project$Pages$StyleGuide$FormGroup$view
    });
    var $author$project$Pages$StyleGuide$FormStatic$viewBody = _List_fromArray([
        A2($author$project$Ui$Form$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('field label'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('value')
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Group$view, _List_fromArray([
                        $author$project$Ui$Form$Group$label('phi field label'),
                        $author$project$Ui$Form$Group$labelSpanSm(4),
                        $author$project$Ui$Form$Group$inputSpanSm(8)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Form$Static$view, _List_fromArray([
                            $author$project$Ui$Form$Static$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text('phi value')
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$FormStatic$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$FormStatic$viewBody,
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$FormStatic$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$FormStatic$view);
    var $author$project$Ui$Grid$Hidden = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Grid$hidden = $author$project$Ui$Grid$Hidden(0);
    var $author$project$Pages$StyleGuide$Grid$viewGrid = _List_fromArray([
        A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('section')
        ]), _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Flex Grid')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'blueviolet'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 6')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6),
                    $author$project$Ui$Grid$spanMd(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6),
                    $author$project$Ui$Grid$spanMd(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(2),
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 2')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(2),
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 2')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(2),
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 2')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanMd(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'cornflowerblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 6')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(6)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 6')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'deepskyblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offset(6),
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(9),
                    $author$project$Ui$Grid$hidden,
                    $author$project$Ui$Grid$showMd
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 9 Hidden')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(3)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'skyblue'),
                        A2($elm$html$Html$Attributes$style, 'height', '3em')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Col 3')
                    ]))
                ]))
            ])),
            A2($elm$html$Html$h2, _List_fromArray([
                $elm$html$Html$Attributes$class('underline mt-4')
            ]), _List_fromArray([
                $elm$html$Html$text('Stretched columns')
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$rowItemsStretch,
                $author$project$Ui$Grid$mt4
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center p-2'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'lightcoral')
                    ]), _List_fromArray([
                        $elm$html$Html$text('This column has some content.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center p-2 h-full'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'lightgreen')
                    ]), _List_fromArray([
                        $elm$html$Html$text('This column\'s content div has `h-full`, allowing its background to fill the stretched column.')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$span(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('text-center p-2'),
                        A2($elm$html$Html$Attributes$style, 'background-color', 'lightblue')
                    ]), _List_fromArray([
                        $elm$html$Html$text('This column stretches to match the content, but the content\'s background does not fill the height.'),
                        $elm$html$Html$text(' It has the most content of the three columns, and will be the primary column that sets the height for the row.')
                    ]))
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Grid$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$Grid$viewGrid,
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Grid$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Grid$view);
    var $author$project$Pages$StyleGuide$HiConfirm$init = function(_v0) {
        return _Utils_Tuple2({
            v3: true,
            pZ: false,
            qc: false,
            qd: false,
            w5: $elm$core$Maybe$Nothing,
            xh: $elm$core$Maybe$Nothing,
            iN: false,
            zO: $elm$core$Maybe$Nothing,
            Cr: $elm$core$Maybe$Nothing,
            DH: true,
            aba: $elm$core$Maybe$Nothing
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$subscriptions = function(model) {
        return model.iN ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe = function(string) {
        return $elm$core$String$isEmpty(string) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(string);
    };
    var $author$project$Pages$StyleGuide$HiConfirm$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    iN: true
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var confirmed = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    pZ: confirmed,
                    iN: false
                }), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2(_Utils_update(model, {
                    qd: true
                }), $elm$core$Platform$Cmd$none);
            case 3:
                var confirmed = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    qc: confirmed,
                    qd: false
                }), $elm$core$Platform$Cmd$none);
            case 5:
                var string = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    aba: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
                }), $elm$core$Platform$Cmd$none);
            case 6:
                var string = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    zO: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
                }), $elm$core$Platform$Cmd$none);
            case 7:
                var string = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    w5: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
                }), $elm$core$Platform$Cmd$none);
            case 8:
                var string = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    xh: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
                }), $elm$core$Platform$Cmd$none);
            case 9:
                var string = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    Cr: $author$project$Pages$StyleGuide$HiConfirm$stringToMaybe(string)
                }), $elm$core$Platform$Cmd$none);
            case 10:
                var bool = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    DH: bool
                }), $elm$core$Platform$Cmd$none);
            case 11:
                var bool = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    v3: bool
                }), $elm$core$Platform$Cmd$none);
            default:
                return _Utils_Tuple2(_Utils_update(model, {
                    pZ: false,
                    qc: false
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Pages$StyleGuide$HiConfirm$OpenHiConfirm = {
        $: 0
    };
    var $author$project$Pages$StyleGuide$HiConfirm$Reset = {
        $: 4
    };
    var $author$project$Pages$StyleGuide$HiConfirm$CenterTextChanged = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$CustomHiConfirmClosed = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$CustomMessageChanged = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$DetailChanged = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$NounChanged = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$OpenCustomHiConfirm = {
        $: 2
    };
    var $author$project$Pages$StyleGuide$HiConfirm$SentenceChanged = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$TitleizeNounChanged = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$VerbChanged = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$viewCustom = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            function() {
                if (model.qd) {
                    var customOptions = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
                        A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$verb, model.aba),
                        A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$noun, model.zO),
                        A2($elm$core$Maybe$map, function(customMessage) {
                            return $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                $elm$html$Html$text(customMessage)
                            ]));
                        }, model.w5),
                        A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$detail, model.xh),
                        A2($elm$core$Maybe$map, $author$project$Components$HiConfirm$sentence, model.Cr),
                        $elm$core$Maybe$Just($author$project$Components$HiConfirm$titleizeNoun(model.DH)),
                        $elm$core$Maybe$Just($author$project$Components$HiConfirm$centerText(model.v3))
                    ]));
                    return A2($author$project$Components$HiConfirm$modal, $author$project$Pages$StyleGuide$HiConfirm$CustomHiConfirmClosed, customOptions);
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Customize')
            ])),
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('Verb'),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', model.aba)),
                $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$VerbChanged)
            ])),
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('Noun'),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', model.zO)),
                $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$NounChanged)
            ])),
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('Custom Message'),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', model.w5)),
                $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$CustomMessageChanged)
            ])),
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('Detail'),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', model.xh)),
                $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$DetailChanged)
            ])),
            $author$project$Ui$Form$Input$view(_List_fromArray([
                $author$project$Ui$Form$Input$placeholder('Sentence'),
                $author$project$Ui$Form$Input$value(A2($elm$core$Maybe$withDefault, '', model.Cr)),
                $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$HiConfirm$SentenceChanged)
            ])),
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(model.DH),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$HiConfirm$TitleizeNounChanged)
            ]), _List_fromArray([
                $elm$html$Html$text('Titleize Noun')
            ])),
            A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                $author$project$Ui$Form$Checkbox$value(model.v3),
                $author$project$Ui$Form$Checkbox$onCheck($author$project$Pages$StyleGuide$HiConfirm$CenterTextChanged)
            ]), _List_fromArray([
                $elm$html$Html$text('Center text')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Open custom confirmation dialog'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$OpenCustomHiConfirm)
            ]), _List_fromArray([
                $elm$html$Html$text('Custom Confirm?')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Confirmed: ' + (model.qc ? 'Yes' : 'No'))
            ]))
        ]));
    };
    var $author$project$Pages$StyleGuide$HiConfirm$viewBody = function(model) {
        return _List_fromArray([
            model.iN ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$StyleGuide$HiConfirm$HiConfirmClosed, _List_Nil) : $author$project$Utils$Html$empty,
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Hi Confirm')
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Default')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Open confirmation dialog'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$OpenHiConfirm)
            ]), _List_fromArray([
                $elm$html$Html$text('Confirm?')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Confirmed: ' + (model.pZ ? 'Yes' : 'No'))
            ])),
            $author$project$Pages$StyleGuide$HiConfirm$viewCustom(model),
            A3($author$project$Ui$Button$view, {
                abP: 'Reset form'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$HiConfirm$Reset)
            ]), _List_fromArray([
                $elm$html$Html$text('Reset')
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$HiConfirm$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$HiConfirm$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$HiConfirm$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$HiConfirm$init,
        ahE: $author$project$Pages$StyleGuide$HiConfirm$subscriptions,
        aaO: $author$project$Pages$StyleGuide$HiConfirm$update,
        aid: $author$project$Pages$StyleGuide$HiConfirm$view
    });
    var $author$project$Pages$StyleGuide$HorizontalRule$view = function(_v0) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        $author$project$Ui$Typography$headingLg(_List_fromArray([
                            $elm$html$Html$text('Default')
                        ])),
                        $author$project$Ui$HorizontalRule$view(_List_Nil),
                        $author$project$Ui$Typography$headingLg(_List_fromArray([
                            $elm$html$Html$text('Double')
                        ])),
                        $author$project$Ui$HorizontalRule$view(_List_fromArray([
                            $author$project$Ui$HorizontalRule$double
                        ])),
                        $author$project$Ui$Typography$headingLg(_List_fromArray([
                            $elm$html$Html$text('Thin')
                        ])),
                        $author$project$Ui$HorizontalRule$view(_List_fromArray([
                            $author$project$Ui$HorizontalRule$thin
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$HorizontalRule$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$HorizontalRule$view);
    var $author$project$Pages$StyleGuide$Icon$init = function(_v0) {
        return _Utils_Tuple2({
            hP: '#000',
            ahq: _List_Nil
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Icon$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Icon$update = F2(function(msg, model) {
        if (!msg.$) {
            var color = msg.a;
            return _Utils_Tuple2(_Utils_update(model, {
                hP: color
            }), $elm$core$Platform$Cmd$none);
        } else {
            var sizeStr = msg.a;
            var size = function() {
                switch(sizeStr){
                    case 'xs':
                        return _List_fromArray([
                            $author$project$Ui$Icon$xs
                        ]);
                    case 'sm':
                        return _List_fromArray([
                            $author$project$Ui$Icon$sm
                        ]);
                    case 'lg':
                        return _List_fromArray([
                            $author$project$Ui$Icon$lg
                        ]);
                    default:
                        return _List_Nil;
                }
            }();
            return _Utils_Tuple2(_Utils_update(model, {
                ahq: size
            }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Pages$StyleGuide$Icon$ColorChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Icon$SizeChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Icon$Account = 3;
    var $author$project$Ui$Icon$AccountAndPricing = 28;
    var $author$project$Ui$Icon$Admin = 4;
    var $author$project$Ui$Icon$ApiKey = 85;
    var $author$project$Ui$Icon$App = 89;
    var $author$project$Ui$Icon$BurgerMenu = 29;
    var $author$project$Ui$Icon$BurgerMenuClose = 30;
    var $author$project$Ui$Icon$BusinessCenter = 99;
    var $author$project$Ui$Icon$Commissions = 6;
    var $author$project$Ui$Icon$Contact = 78;
    var $author$project$Ui$Icon$Dashboard = 75;
    var $author$project$Ui$Icon$Demography = 98;
    var $author$project$Ui$Icon$Dev = 100;
    var $author$project$Ui$Icon$EmployeeUploads = 25;
    var $author$project$Ui$Icon$Employees = 24;
    var $author$project$Ui$Icon$Enter = 16;
    var $author$project$Ui$Icon$Exit = 22;
    var $author$project$Ui$Icon$Favicon = 32;
    var $author$project$Ui$Icon$File = 80;
    var $author$project$Ui$Icon$Filter = 67;
    var $author$project$Ui$Icon$Form = 79;
    var $author$project$Ui$Icon$HintHeartFlat = 34;
    var $author$project$Ui$Icon$Inbox = 77;
    var $author$project$Ui$Icon$Inventory = 81;
    var $author$project$Ui$Icon$Invoices = 26;
    var $author$project$Ui$Icon$KebabMenu = 19;
    var $author$project$Ui$Icon$Open = 18;
    var $author$project$Ui$Icon$Patients = 8;
    var $author$project$Ui$Icon$PaymentMethods = 23;
    var $author$project$Ui$Icon$Report = 9;
    var $author$project$Ui$Icon$Search = 41;
    var $author$project$Ui$Icon$SelectArrows = 17;
    var $author$project$Ui$Icon$Share = 10;
    var $author$project$Ui$Icon$Webhook = 86;
    var $author$project$Pages$StyleGuide$Icon$allIcons = _List_fromArray([
        3,
        28,
        39,
        4,
        5,
        62,
        61,
        63,
        29,
        30,
        57,
        45,
        12,
        13,
        6,
        15,
        48,
        65,
        42,
        54,
        60,
        40,
        25,
        24,
        16,
        22,
        51,
        67,
        43,
        7,
        31,
        32,
        33,
        34,
        55,
        26,
        19,
        20,
        14,
        27,
        18,
        8,
        23,
        44,
        9,
        41,
        17,
        38,
        10,
        35,
        36,
        37,
        11,
        59,
        1,
        0,
        49,
        66,
        69,
        68,
        2,
        50,
        56,
        64,
        70,
        71,
        72,
        73,
        75,
        77,
        78,
        79,
        80,
        81,
        84,
        85,
        86,
        89,
        93,
        94,
        95,
        88,
        98,
        99,
        100,
        46,
        76,
        102,
        103,
        52,
        53,
        47,
        58,
        21,
        90,
        83,
        82
    ]);
    var $author$project$Pages$StyleGuide$Icon$exampleCircled = _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$check(_List_fromArray([
                $author$project$Ui$Icon$circled,
                $author$project$Ui$Icon$success
            ])),
            $elm$html$Html$text('Success')
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$cross(_List_fromArray([
                $author$project$Ui$Icon$circled,
                $author$project$Ui$Icon$danger
            ])),
            $elm$html$Html$text('Danger')
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$alert(_List_fromArray([
                $author$project$Ui$Icon$circled,
                $author$project$Ui$Icon$info
            ])),
            $elm$html$Html$text('Info')
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$circle(_List_fromArray([
                $author$project$Ui$Icon$info,
                $author$project$Ui$Icon$xl
            ])),
            $elm$html$Html$text('Incomplete')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Icon$exampleCircledSizes = _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$check(_List_fromArray([
                $author$project$Ui$Icon$circled,
                $author$project$Ui$Icon$success,
                $author$project$Ui$Icon$xs
            ])),
            $elm$html$Html$text('Extra Small')
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$check(_List_fromArray([
                $author$project$Ui$Icon$circled,
                $author$project$Ui$Icon$success,
                $author$project$Ui$Icon$sm
            ])),
            $elm$html$Html$text('Small')
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$check(_List_fromArray([
                $author$project$Ui$Icon$circled,
                $author$project$Ui$Icon$success
            ])),
            $elm$html$Html$text('Default')
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$check(_List_fromArray([
                $author$project$Ui$Icon$circled,
                $author$project$Ui$Icon$success,
                $author$project$Ui$Icon$lg
            ])),
            $elm$html$Html$text('Large')
        ])),
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$gap4,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$mb2
        ]), _List_fromArray([
            $author$project$Ui$Icon$check(_List_fromArray([
                $author$project$Ui$Icon$circled,
                $author$project$Ui$Icon$success,
                $author$project$Ui$Icon$xl
            ])),
            $elm$html$Html$text('Extra Large')
        ]))
    ]);
    var $author$project$Ui$Icon$account = $author$project$Ui$Icon$viewIcon(3);
    var $author$project$Ui$Icon$accountAndPricing = $author$project$Ui$Icon$viewIcon(28);
    var $author$project$Ui$Icon$admin = $author$project$Ui$Icon$viewIcon(4);
    var $author$project$Ui$Icon$apiKey = $author$project$Ui$Icon$viewIcon(85);
    var $author$project$Ui$Icon$app = $author$project$Ui$Icon$viewIcon(89);
    var $author$project$Ui$Icon$Book = 97;
    var $author$project$Ui$Icon$book = $author$project$Ui$Icon$viewIcon(97);
    var $author$project$Ui$Icon$burgerMenu = $author$project$Ui$Icon$viewIcon(29);
    var $author$project$Ui$Icon$burgerMenuClose = $author$project$Ui$Icon$viewIcon(30);
    var $author$project$Ui$Icon$businessCenter = $author$project$Ui$Icon$viewIcon(99);
    var $author$project$Ui$Icon$commissions = $author$project$Ui$Icon$viewIcon(6);
    var $author$project$Ui$Icon$contact = $author$project$Ui$Icon$viewIcon(78);
    var $author$project$Ui$Icon$dashboard = $author$project$Ui$Icon$viewIcon(75);
    var $author$project$Ui$Icon$demography = $author$project$Ui$Icon$viewIcon(98);
    var $author$project$Ui$Icon$dev = $author$project$Ui$Icon$viewIcon(100);
    var $author$project$Ui$Icon$dollar = $author$project$Ui$Icon$viewIcon(54);
    var $author$project$Ui$Icon$employeeUploads = $author$project$Ui$Icon$viewIcon(25);
    var $author$project$Ui$Icon$employees = $author$project$Ui$Icon$viewIcon(24);
    var $author$project$Ui$Icon$enter = $author$project$Ui$Icon$viewIcon(16);
    var $author$project$Ui$Icon$exit = $author$project$Ui$Icon$viewIcon(22);
    var $author$project$Ui$Icon$favicon = $author$project$Ui$Icon$viewIcon(32);
    var $author$project$Ui$Icon$file = $author$project$Ui$Icon$viewIcon(80);
    var $author$project$Ui$Icon$filter = $author$project$Ui$Icon$viewIcon(67);
    var $author$project$Ui$Icon$form = $author$project$Ui$Icon$viewIcon(79);
    var $author$project$Ui$Icon$Groups = 91;
    var $author$project$Ui$Icon$groups = $author$project$Ui$Icon$viewIcon(91);
    var $author$project$Ui$Icon$hintHeartFlat = $author$project$Ui$Icon$viewIcon(34);
    var $author$project$Ui$Icon$inbox = $author$project$Ui$Icon$viewIcon(77);
    var $author$project$Ui$Icon$inventory = $author$project$Ui$Icon$viewIcon(81);
    var $author$project$Ui$Icon$invoices = $author$project$Ui$Icon$viewIcon(26);
    var $author$project$Ui$Icon$kebabMenu = $author$project$Ui$Icon$viewIcon(19);
    var $author$project$Ui$Icon$Marketplace = 96;
    var $author$project$Ui$Icon$marketplace = $author$project$Ui$Icon$viewIcon(96);
    var $author$project$Ui$Icon$open = $author$project$Ui$Icon$viewIcon(18);
    var $author$project$Ui$Icon$patients = $author$project$Ui$Icon$viewIcon(8);
    var $author$project$Ui$Icon$paymentMethods = $author$project$Ui$Icon$viewIcon(23);
    var $author$project$Ui$Icon$Practices = 87;
    var $author$project$Ui$Icon$practices = $author$project$Ui$Icon$viewIcon(87);
    var $author$project$Ui$Icon$quote = $author$project$Ui$Icon$viewIcon(101);
    var $author$project$Ui$Icon$report = $author$project$Ui$Icon$viewIcon(9);
    var $author$project$Ui$Icon$Sandbox = 92;
    var $author$project$Ui$Icon$sandbox = $author$project$Ui$Icon$viewIcon(92);
    var $author$project$Ui$Icon$scissors = $author$project$Ui$Icon$viewIcon(70);
    var $author$project$Ui$Icon$search = $author$project$Ui$Icon$viewIcon(41);
    var $author$project$Ui$Icon$selectArrows = $author$project$Ui$Icon$viewIcon(17);
    var $author$project$Ui$Icon$share = $author$project$Ui$Icon$viewIcon(10);
    var $author$project$Ui$Icon$sort = $author$project$Ui$Icon$viewIcon(35);
    var $author$project$Ui$Icon$sortDown = $author$project$Ui$Icon$viewIcon(36);
    var $author$project$Ui$Icon$sortUp = $author$project$Ui$Icon$viewIcon(37);
    var $author$project$Ui$Icon$sponsors = $author$project$Ui$Icon$viewIcon(11);
    var $author$project$Ui$Icon$star = $author$project$Ui$Icon$viewIcon(71);
    var $author$project$Ui$Icon$starNote = $author$project$Ui$Icon$viewIcon(72);
    var $author$project$Ui$Icon$webhook = $author$project$Ui$Icon$viewIcon(86);
    var $author$project$Pages$StyleGuide$Icon$iconNameToFunctionAndName = function(icon) {
        switch(icon){
            case 0:
                return _Utils_Tuple2($author$project$Ui$Icon$syncedTo, 'syncedTo');
            case 1:
                return _Utils_Tuple2($author$project$Ui$Icon$syncedFrom, 'syncedFrom');
            case 2:
                return _Utils_Tuple2($author$project$Ui$Icon$unpublishedRuleArrow, 'unpublishedRuleArrow');
            case 3:
                return _Utils_Tuple2($author$project$Ui$Icon$account, 'account');
            case 4:
                return _Utils_Tuple2($author$project$Ui$Icon$admin, 'admin');
            case 6:
                return _Utils_Tuple2($author$project$Ui$Icon$commissions, 'commissions');
            case 7:
                return _Utils_Tuple2($author$project$Ui$Icon$help, 'help');
            case 8:
                return _Utils_Tuple2($author$project$Ui$Icon$patients, 'patients');
            case 9:
                return _Utils_Tuple2($author$project$Ui$Icon$report, 'report');
            case 10:
                return _Utils_Tuple2($author$project$Ui$Icon$share, 'share');
            case 11:
                return _Utils_Tuple2($author$project$Ui$Icon$sponsors, 'sponsors');
            case 12:
                return _Utils_Tuple2($author$project$Ui$Icon$chevron, 'chevron');
            case 13:
                return _Utils_Tuple2($author$project$Ui$Icon$chevronDown, 'chevronDown');
            case 14:
                return _Utils_Tuple2($author$project$Ui$Icon$location, 'location');
            case 15:
                return _Utils_Tuple2($author$project$Ui$Icon$copy, 'copy');
            case 16:
                return _Utils_Tuple2($author$project$Ui$Icon$enter, 'enter');
            case 17:
                return _Utils_Tuple2($author$project$Ui$Icon$selectArrows, 'selectArrows');
            case 18:
                return _Utils_Tuple2($author$project$Ui$Icon$open, 'open');
            case 19:
                return _Utils_Tuple2($author$project$Ui$Icon$kebabMenu, 'kebabMenu');
            case 20:
                return _Utils_Tuple2($author$project$Ui$Icon$launch, 'launch');
            case 22:
                return _Utils_Tuple2($author$project$Ui$Icon$exit, 'exit');
            case 23:
                return _Utils_Tuple2($author$project$Ui$Icon$paymentMethods, 'paymentMethods');
            case 24:
                return _Utils_Tuple2($author$project$Ui$Icon$employees, 'employees');
            case 25:
                return _Utils_Tuple2($author$project$Ui$Icon$employeeUploads, 'employeeUploads');
            case 26:
                return _Utils_Tuple2($author$project$Ui$Icon$invoices, 'invoices');
            case 27:
                return _Utils_Tuple2($author$project$Ui$Icon$onlineSignup, 'onlineSignup');
            case 28:
                return _Utils_Tuple2($author$project$Ui$Icon$accountAndPricing, 'accountPricing');
            case 29:
                return _Utils_Tuple2($author$project$Ui$Icon$burgerMenu, 'burgerMenu');
            case 30:
                return _Utils_Tuple2($author$project$Ui$Icon$burgerMenuClose, 'burgerMenuClose');
            case 32:
                return _Utils_Tuple2($author$project$Ui$Icon$favicon, 'favicon');
            case 33:
                return _Utils_Tuple2($author$project$Ui$Icon$hintHeart, 'hintHeart');
            case 34:
                return _Utils_Tuple2($author$project$Ui$Icon$hintHeartFlat, 'hintHeartFlat');
            case 31:
                return _Utils_Tuple2($author$project$Ui$Icon$hint404, 'hint404');
            case 35:
                return _Utils_Tuple2($author$project$Ui$Icon$sort, 'sort');
            case 36:
                return _Utils_Tuple2($author$project$Ui$Icon$sortDown, 'sortDown');
            case 37:
                return _Utils_Tuple2($author$project$Ui$Icon$sortUp, 'sortUp');
            case 38:
                return _Utils_Tuple2($author$project$Ui$Icon$send, 'send');
            case 39:
                return _Utils_Tuple2($author$project$Ui$Icon$add, 'add');
            case 40:
                return _Utils_Tuple2($author$project$Ui$Icon$edit, 'edit');
            case 41:
                return _Utils_Tuple2($author$project$Ui$Icon$search, 'search');
            case 42:
                return _Utils_Tuple2($author$project$Ui$Icon$delete, 'delete');
            case 43:
                return _Utils_Tuple2($author$project$Ui$Icon$flag, 'flag');
            case 44:
                return _Utils_Tuple2($author$project$Ui$Icon$repeat, 'repeat');
            case 45:
                return _Utils_Tuple2($author$project$Ui$Icon$check, 'check');
            case 48:
                return _Utils_Tuple2($author$project$Ui$Icon$cross, 'cross');
            case 49:
                return _Utils_Tuple2($author$project$Ui$Icon$transfer, 'transfer');
            case 55:
                return _Utils_Tuple2($author$project$Ui$Icon$history, 'history');
            case 50:
                return _Utils_Tuple2($author$project$Ui$Icon$upload, 'upload');
            case 51:
                return _Utils_Tuple2($author$project$Ui$Icon$export, 'export');
            case 54:
                return _Utils_Tuple2($author$project$Ui$Icon$dollar, 'dollar');
            case 56:
                return _Utils_Tuple2($author$project$Ui$Icon$void, 'void');
            case 57:
                return _Utils_Tuple2($author$project$Ui$Icon$calendar, 'calendar');
            case 59:
                return _Utils_Tuple2($author$project$Ui$Icon$stop, 'stop');
            case 60:
                return _Utils_Tuple2($author$project$Ui$Icon$dots, 'dots');
            case 61:
                return _Utils_Tuple2($author$project$Ui$Icon$arrowRight, 'arrowRight');
            case 63:
                return _Utils_Tuple2($author$project$Ui$Icon$arrowRightBottom, 'arrowRightBottom');
            case 62:
                return _Utils_Tuple2($author$project$Ui$Icon$arrowLeft, 'arrowLeft');
            case 64:
                return _Utils_Tuple2($author$project$Ui$Icon$warning, 'warning');
            case 5:
                return _Utils_Tuple2($author$project$Ui$Icon$alert, 'alert');
            case 65:
                return _Utils_Tuple2($author$project$Ui$Icon$crossCircle, 'crossCircle');
            case 66:
                return _Utils_Tuple2($author$project$Ui$Icon$translate, 'translate');
            case 67:
                return _Utils_Tuple2($author$project$Ui$Icon$filter, 'filter');
            case 69:
                return _Utils_Tuple2($author$project$Ui$Icon$trendingDown, 'trendingDown');
            case 68:
                return _Utils_Tuple2($author$project$Ui$Icon$trendingUp, 'trendingUp');
            case 70:
                return _Utils_Tuple2($author$project$Ui$Icon$scissors, 'scissors');
            case 71:
                return _Utils_Tuple2($author$project$Ui$Icon$star, 'star');
            case 72:
                return _Utils_Tuple2($author$project$Ui$Icon$starNote, 'starNote');
            case 73:
                return _Utils_Tuple2($author$project$Ui$Icon$minus, 'minus');
            case 74:
                return _Utils_Tuple2($author$project$Ui$Icon$testConnection, 'testConnection');
            case 75:
                return _Utils_Tuple2($author$project$Ui$Icon$dashboard, 'dashboard');
            case 77:
                return _Utils_Tuple2($author$project$Ui$Icon$inbox, 'inbox');
            case 78:
                return _Utils_Tuple2($author$project$Ui$Icon$contact, 'contact');
            case 79:
                return _Utils_Tuple2($author$project$Ui$Icon$form, 'form');
            case 80:
                return _Utils_Tuple2($author$project$Ui$Icon$file, 'file');
            case 81:
                return _Utils_Tuple2($author$project$Ui$Icon$inventory, 'inventory');
            case 84:
                return _Utils_Tuple2($author$project$Ui$Icon$task, 'task');
            case 85:
                return _Utils_Tuple2($author$project$Ui$Icon$apiKey, 'apiKey');
            case 86:
                return _Utils_Tuple2($author$project$Ui$Icon$webhook, 'webhook');
            case 87:
                return _Utils_Tuple2($author$project$Ui$Icon$practices, 'practices');
            case 89:
                return _Utils_Tuple2($author$project$Ui$Icon$app, 'app');
            case 91:
                return _Utils_Tuple2($author$project$Ui$Icon$groups, 'groups');
            case 92:
                return _Utils_Tuple2($author$project$Ui$Icon$sandbox, 'sandbox');
            case 93:
                return _Utils_Tuple2($author$project$Ui$Icon$package, 'package');
            case 94:
                return _Utils_Tuple2($author$project$Ui$Icon$call, 'call');
            case 95:
                return _Utils_Tuple2($author$project$Ui$Icon$mail, 'mail');
            case 88:
                return _Utils_Tuple2($author$project$Ui$Icon$progressActivity, 'progressActivity');
            case 96:
                return _Utils_Tuple2($author$project$Ui$Icon$marketplace, 'marketplace');
            case 97:
                return _Utils_Tuple2($author$project$Ui$Icon$book, 'book');
            case 98:
                return _Utils_Tuple2($author$project$Ui$Icon$demography, 'demography');
            case 99:
                return _Utils_Tuple2($author$project$Ui$Icon$businessCenter, 'businessCenter');
            case 100:
                return _Utils_Tuple2($author$project$Ui$Icon$dev, 'dev');
            case 101:
                return _Utils_Tuple2($author$project$Ui$Icon$quote, 'quote');
            case 46:
                return _Utils_Tuple2($author$project$Ui$Icon$circle, 'circle');
            case 76:
                return _Utils_Tuple2($author$project$Ui$Icon$wrench, 'wrench');
            case 102:
                return _Utils_Tuple2($author$project$Ui$Icon$link, 'link');
            case 103:
                return _Utils_Tuple2($author$project$Ui$Icon$eraser, 'eraser');
            case 52:
                return _Utils_Tuple2($author$project$Ui$Icon$visibility, 'visibility');
            case 53:
                return _Utils_Tuple2($author$project$Ui$Icon$visibilityOff, 'visibilityOff');
            case 47:
                return _Utils_Tuple2($author$project$Ui$Icon$bolt, 'bolt');
            case 58:
                return _Utils_Tuple2($author$project$Ui$Icon$cart, 'cart');
            case 21:
                return _Utils_Tuple2($author$project$Ui$Icon$lock, 'lock');
            case 90:
                return _Utils_Tuple2($author$project$Ui$Icon$gift, 'gift');
            case 83:
                return _Utils_Tuple2($author$project$Ui$Icon$increase, 'increase');
            default:
                return _Utils_Tuple2($author$project$Ui$Icon$decrease, 'decrease');
        }
    };
    var $author$project$Pages$StyleGuide$Icon$viewIcon = F2(function(sizeOptions, name) {
        var _v0 = $author$project$Pages$StyleGuide$Icon$iconNameToFunctionAndName(name);
        var viewIconFn = _v0.a;
        var functionName = _v0.b;
        return A2($author$project$Ui$Grid$column, _List_fromArray([
            $author$project$Ui$Grid$span(3),
            $author$project$Ui$Grid$justifyLeft
        ]), _List_fromArray([
            viewIconFn(sizeOptions),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('text-base-color mb-8')
            ]), _List_fromArray([
                $elm$html$Html$text('Icon.' + functionName)
            ]))
        ]));
    });
    var $author$project$Pages$StyleGuide$Icon$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Ui$Typography$headingLg(_List_fromArray([
                    $elm$html$Html$text('Icon')
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mb-4')
                ]), _List_fromArray([
                    $elm$html$Html$text('(Make sure when selecting a new color the SVG icon changes accordingly)'),
                    A2($elm$html$Html$input, _List_fromArray([
                        $elm$html$Html$Attributes$type_('color'),
                        $elm$html$Html$Events$onInput($author$project$Pages$StyleGuide$Icon$ColorChanged),
                        $elm$html$Html$Attributes$value(model.hP)
                    ]), _List_Nil),
                    A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Sorts and Hint404 are extent from this ckeck.')
                    ]))
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('mb-4')
                ]), _List_fromArray([
                    $elm$html$Html$text('Size: '),
                    A2($elm$html$Html$select, _List_fromArray([
                        $elm$html$Html$Events$onInput($author$project$Pages$StyleGuide$Icon$SizeChanged)
                    ]), _List_fromArray([
                        A2($elm$html$Html$option, _List_fromArray([
                            $elm$html$Html$Attributes$value('base')
                        ]), _List_fromArray([
                            $elm$html$Html$text('base (default)')
                        ])),
                        A2($elm$html$Html$option, _List_fromArray([
                            $elm$html$Html$Attributes$value('xs')
                        ]), _List_fromArray([
                            $elm$html$Html$text('xs')
                        ])),
                        A2($elm$html$Html$option, _List_fromArray([
                            $elm$html$Html$Attributes$value('sm')
                        ]), _List_fromArray([
                            $elm$html$Html$text('sm')
                        ])),
                        A2($elm$html$Html$option, _List_fromArray([
                            $elm$html$Html$Attributes$value('lg')
                        ]), _List_fromArray([
                            $elm$html$Html$text('lg')
                        ]))
                    ]))
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    A2($elm$html$Html$Attributes$style, 'color', model.hP)
                ]), _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, A2($elm$core$List$map, $author$project$Pages$StyleGuide$Icon$viewIcon(model.ahq), $author$project$Pages$StyleGuide$Icon$allIcons))
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Circled Icons'),
                            $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                                $elm$html$Html$text('Icons with circular backgrounds, useful for status indicators')
                            ]))
                        ]), {
                            Lk: 'Icon.check [ Icon.circled, Icon.success ]\nIcon.cross [ Icon.circled, Icon.danger ]\nIcon.alert [ Icon.circled, Icon.info ]\nIcon.circle [ Icon.info, Icon.xl ]',
                            EU: $author$project$Pages$StyleGuide$Icon$exampleCircled
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Circled Icon Sizes')
                        ]), {
                            Lk: 'Icon.check [ Icon.circled, Icon.success, Icon.xs ]\nIcon.check [ Icon.circled, Icon.success, Icon.sm ]\nIcon.check [ Icon.circled, Icon.success ]\nIcon.check [ Icon.circled, Icon.success, Icon.lg ]\nIcon.check [ Icon.circled, Icon.success, Icon.xl ]',
                            EU: $author$project$Pages$StyleGuide$Icon$exampleCircledSizes
                        })
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Icon$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Icon$init,
        ahE: $author$project$Pages$StyleGuide$Icon$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Icon$update,
        aid: $author$project$Pages$StyleGuide$Icon$view
    });
    var $author$project$Pages$StyleGuide$Input$init = function(_v0) {
        return {
            vL: 'Some initial text',
            xs: '',
            A5: '',
            B7: '',
            Cj: ''
        };
    };
    var $author$project$Pages$StyleGuide$Input$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var string = msg.a;
                return _Utils_update(model, {
                    vL: string
                });
            case 1:
                var string = msg.a;
                return _Utils_update(model, {
                    Cj: string
                });
            case 2:
                var string = msg.a;
                return _Utils_update(model, {
                    B7: string
                });
            case 3:
                var string = msg.a;
                return _Utils_update(model, {
                    xs: string
                });
            default:
                var string = msg.a;
                return _Utils_update(model, {
                    A5: string
                });
        }
    });
    var $author$project$Pages$StyleGuide$Input$BaseInputChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Input$EmailInputchanged = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Input$PhoneInputchanged = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Input$RequiredInputchanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Input$SecretInputChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Input$emailValid = function(emailText) {
        return $elm$core$String$isEmpty(emailText) || A2($elm$core$String$contains, '@', emailText);
    };
    var $author$project$Pages$StyleGuide$Input$phoneMask = '(###) ###-####';
    var $author$project$Pages$StyleGuide$Input$phonePattern = $agustinrhcp$elm_mask$Mask$fromString($author$project$Pages$StyleGuide$Input$phoneMask);
    var $author$project$Pages$StyleGuide$Input$phoneIncomplete = function(phoneNumber) {
        var maskedPhone = A2($agustinrhcp$elm_mask$Mask$mask, $author$project$Pages$StyleGuide$Input$phonePattern, phoneNumber);
        return $elm$core$String$length(maskedPhone) > 0 && !_Utils_eq($elm$core$String$length($author$project$Pages$StyleGuide$Input$phoneMask), $elm$core$String$length(maskedPhone));
    };
    var $author$project$Pages$StyleGuide$Input$phoneErrors = function(phoneNumber) {
        return $author$project$Pages$StyleGuide$Input$phoneIncomplete(phoneNumber) ? _List_fromArray([
            'Please enter a valid phone number.'
        ]) : _List_Nil;
    };
    var $author$project$Pages$StyleGuide$Input$phonePlaceholder = A3($elm$core$String$replace, '#', '5', $author$project$Pages$StyleGuide$Input$phoneMask);
    var $author$project$Pages$StyleGuide$Input$viewBody = function(_v0) {
        var baseText = _v0.vL;
        var secretText = _v0.Cj;
        var requiredText = _v0.B7;
        var emailText = _v0.xs;
        var phoneText = _v0.A5;
        return _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Form -> Input')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(baseText),
                    $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$BaseInputChanged)
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$placeholder('Disabled'),
                    $author$project$Ui$Form$Input$disabled(true)
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$placeholder('Secret'),
                    $author$project$Ui$Form$Input$password,
                    $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$SecretInputChanged),
                    $author$project$Ui$Form$Input$value(secretText)
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$placeholder('This is required'),
                    $author$project$Ui$Form$Input$value(requiredText),
                    $author$project$Ui$Form$Input$invalid($elm$core$String$isEmpty(requiredText)),
                    $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$RequiredInputchanged)
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$placeholder('This is required with feedback'),
                    $author$project$Ui$Form$Input$withFeedback(true),
                    $author$project$Ui$Form$Input$value(requiredText),
                    $author$project$Ui$Form$Input$invalid($elm$core$String$isEmpty(requiredText)),
                    $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$RequiredInputchanged)
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$placeholder('This is an email'),
                    $author$project$Ui$Form$Input$email,
                    $author$project$Ui$Form$Input$withFeedback(true),
                    $author$project$Ui$Form$Input$value(emailText),
                    $author$project$Ui$Form$Input$invalid(!$author$project$Pages$StyleGuide$Input$emailValid(emailText)),
                    $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Input$EmailInputchanged)
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    A2($author$project$Ui$Form$Input$maskedValue, $author$project$Pages$StyleGuide$Input$phonePattern, phoneText),
                    $author$project$Ui$Form$Input$placeholder($author$project$Pages$StyleGuide$Input$phonePlaceholder),
                    A3($author$project$Ui$Form$Input$onMaskedInput, $author$project$Pages$StyleGuide$Input$phonePattern, phoneText, $author$project$Pages$StyleGuide$Input$PhoneInputchanged),
                    $author$project$Ui$Form$Input$invalid($author$project$Pages$StyleGuide$Input$phoneIncomplete(phoneText)),
                    $author$project$Ui$Form$Input$autoComplete(false),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$withFeedback(true),
                    $author$project$Ui$Form$Input$errors($author$project$Pages$StyleGuide$Input$phoneErrors(phoneText))
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$Input$addon(_List_fromArray([
                        $elm$html$Html$text('$')
                    ])),
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value('1.000,00')
                    ]))
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPreAddon, '$', _List_fromArray([
                    $author$project$Ui$Form$Input$value('1.000,00')
                ])))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$group(A2($author$project$Ui$Form$Input$withPostAddon, '%', _List_fromArray([
                    $author$project$Ui$Form$Input$value('20')
                ])))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Form$Input$group(_List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value('a search string')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Search'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary
                    ]), _List_fromArray([
                        $elm$html$Html$text('Search')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$placeholder('Span 9 Offset 3')
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$Input$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$Input$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Input$page = $author$project$Spa$Page$sandbox({
        aeq: $author$project$Pages$StyleGuide$Input$init,
        aaO: $author$project$Pages$StyleGuide$Input$update,
        aid: $author$project$Pages$StyleGuide$Input$view
    });
    var $author$project$Pages$StyleGuide$Link$example = _List_fromArray([
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_Nil, _List_fromArray([
            $elm$html$Html$text('External')
        ])),
        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$StyleGuide__Link, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Internal (Route)')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$underline
        ]), _List_fromArray([
            $elm$html$Html$text('Link with underline')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Link$exampleButton = _List_fromArray([
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonDefault
        ]), _List_fromArray([
            $elm$html$Html$text('Go to Hint')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonPrimary
        ]), _List_fromArray([
            $elm$html$Html$text('Go to Hint')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonSecondary
        ]), _List_fromArray([
            $elm$html$Html$text('Go to Hint')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonSuccess
        ]), _List_fromArray([
            $elm$html$Html$text('Go to Hint')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonWarning
        ]), _List_fromArray([
            $elm$html$Html$text('Go to Hint')
        ]))
    ]);
    var $author$project$Ui$Link$Lg = 3;
    var $author$project$Ui$Link$lg = $author$project$Ui$Link$Size(3);
    var $author$project$Pages$StyleGuide$Link$exampleWithIcon = _List_fromArray([
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$xs,
            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
        ]), _List_fromArray([
            $elm$html$Html$text('Flag')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$sm,
            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
        ]), _List_fromArray([
            $elm$html$Html$text('Flag')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
        ]), _List_fromArray([
            $elm$html$Html$text('Flag')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$lg,
            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
        ]), _List_fromArray([
            $elm$html$Html$text('Flag')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Link$exampleWithIconOnly = _List_fromArray([
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonSecondary,
            $author$project$Ui$Link$xs,
            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
        ]), _List_Nil),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonSecondary,
            $author$project$Ui$Link$sm,
            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
        ]), _List_Nil),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonSecondary,
            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
        ]), _List_Nil),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$buttonSecondary,
            $author$project$Ui$Link$lg,
            $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
        ]), _List_Nil)
    ]);
    var $author$project$Pages$StyleGuide$Link$exampleWithIconRight = _List_fromArray([
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$xs,
            $author$project$Ui$Link$iconRight($author$project$Ui$Icon$flag)
        ]), _List_fromArray([
            $elm$html$Html$text('Flag')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$sm,
            $author$project$Ui$Link$iconRight($author$project$Ui$Icon$flag)
        ]), _List_fromArray([
            $elm$html$Html$text('Flag')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$iconRight($author$project$Ui$Icon$flag)
        ]), _List_fromArray([
            $elm$html$Html$text('Flag')
        ])),
        A3($author$project$Ui$Link$externalHref, 'http://www.hint.com', _List_fromArray([
            $author$project$Ui$Link$lg,
            $author$project$Ui$Link$iconRight($author$project$Ui$Icon$flag)
        ]), _List_fromArray([
            $elm$html$Html$text('Flag')
        ]))
    ]);
    var $author$project$Generated$StyleGuide$Examples$linkExample = '\n    [ Link.externalHref "http://www.hint.com"\n        []\n        [ text "External" ]\n    , Link.route Route.StyleGuide__Link\n        []\n        [ text "Internal (Route)" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.underline ]\n        [ text "Link with underline" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$linkExampleButton = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.buttonDefault\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonPrimary\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSuccess\n        ]\n        [ text "Go to Hint" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonWarning\n        ]\n        [ text "Go to Hint" ]\n    ]\n    ';
    var $author$project$Generated$StyleGuide$Examples$linkExampleWithIcon = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.xs\n        , Link.icon Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.sm\n        , Link.icon Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.icon Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.lg\n        , Link.icon Icon.flag\n        ]\n        [ text "Flag" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$linkExampleWithIconOnly = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.xs\n        , Link.icon Icon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.sm\n        , Link.icon Icon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.icon Icon.flag\n        ]\n        []\n    , Link.externalHref "http://www.hint.com"\n        [ Link.buttonSecondary\n        , Link.lg\n        , Link.icon Icon.flag\n        ]\n        []\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$linkExampleWithIconRight = '\n    [ Link.externalHref "http://www.hint.com"\n        [ Link.xs\n        , Link.iconRight Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.sm\n        , Link.iconRight Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.iconRight Icon.flag\n        ]\n        [ text "Flag" ]\n    , Link.externalHref "http://www.hint.com"\n        [ Link.lg\n        , Link.iconRight Icon.flag\n        ]\n        [ text "Flag" ]\n    ]    ';
    var $author$project$Pages$StyleGuide$Link$view = function(_v0) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Link')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$linkExample,
                            EU: $author$project$Pages$StyleGuide$Link$example
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Button options'),
                            $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                                $elm$html$Html$text('Link that look like buttons redirect to a new page. '),
                                $elm$html$Html$text('Most common use case should be downloading files')
                            ]))
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$linkExampleButton,
                            EU: $author$project$Pages$StyleGuide$Link$exampleButton
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('With icon')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$linkExampleWithIcon,
                            EU: $author$project$Pages$StyleGuide$Link$exampleWithIcon
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('With icon right')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$linkExampleWithIconRight,
                            EU: $author$project$Pages$StyleGuide$Link$exampleWithIconRight
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('With icon and no content')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$linkExampleWithIconOnly,
                            EU: $author$project$Pages$StyleGuide$Link$exampleWithIconOnly
                        })
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Link$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Link$view);
    var $author$project$Ui$ListGroup$Info = 1;
    var $author$project$Ui$ListGroup$heading = function(contents) {
        return A2($elm$html$Html$h3, _List_fromArray([
            $elm$html$Html$Attributes$class('list-group-item-heading')
        ]), contents);
    };
    var $author$project$Pages$StyleGuide$ListGroup$viewBody = _List_fromArray([
        $author$project$Ui$Typography$heading(_List_fromArray([
            $elm$html$Html$text('List Group')
        ])),
        A2($author$project$Ui$ListGroup$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$ListGroup$item, _List_fromArray([
                $author$project$Ui$ListGroup$style(0)
            ]), _List_fromArray([
                $elm$html$Html$text('Success')
            ])),
            A2($author$project$Ui$ListGroup$item, _List_fromArray([
                $author$project$Ui$ListGroup$style(1)
            ]), _List_fromArray([
                $elm$html$Html$text('Info')
            ])),
            A2($author$project$Ui$ListGroup$item, _List_fromArray([
                $author$project$Ui$ListGroup$style(2)
            ]), _List_fromArray([
                $elm$html$Html$text('Warning')
            ])),
            A2($author$project$Ui$ListGroup$item, _List_fromArray([
                $author$project$Ui$ListGroup$style(3)
            ]), _List_fromArray([
                $elm$html$Html$text('Danger')
            ])),
            A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
                $author$project$Ui$ListGroup$heading(_List_fromArray([
                    $elm$html$Html$text('List group item heading')
                ])),
                $author$project$Ui$ListGroup$body(_List_fromArray([
                    $elm$html$Html$text('Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.')
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$ListGroup$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$ListGroup$viewBody,
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$ListGroup$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ListGroup$view);
    var $author$project$Pages$StyleGuide$Modal$init = function(_v0) {
        return _Utils_Tuple2({
            Vw: false,
            ahq: 1
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Modal$CloseModal = {
        $: 1
    };
    var $author$project$Pages$StyleGuide$Modal$subscriptions = function(model) {
        return model.Vw ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$StyleGuide$Modal$CloseModal) : $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Modal$update = F2(function(msg, model) {
        if (!msg.$) {
            var size = msg.a;
            return _Utils_Tuple2(_Utils_update(model, {
                Vw: true,
                ahq: size
            }), $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2(_Utils_update(model, {
            Vw: false
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$StyleGuide$Modal$OpenModal = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Modal$Sm = 0;
    var $author$project$Pages$StyleGuide$Modal$viewBody = function(model) {
        return _List_fromArray([
            model.Vw ? A3($author$project$Ui$Modal$view, $author$project$Pages$StyleGuide$Modal$CloseModal, _List_fromArray([
                $author$project$Ui$Modal$size(model.ahq)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('header')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    $elm$html$Html$text('body')
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$Modal$CloseModal)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Close')
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Save changes'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$Modal$CloseModal)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Save changes')
                    ]))
                ]))
            ])) : $author$project$Utils$Html$empty,
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Modal')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Open small modal'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$Modal$OpenModal(0))
            ]), _List_fromArray([
                $elm$html$Html$text('Open Sm')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Open medium modal'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$Modal$OpenModal(1))
            ]), _List_fromArray([
                $elm$html$Html$text('Open Md')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Open large modal'
            }, _List_fromArray([
                $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$Modal$OpenModal(2))
            ]), _List_fromArray([
                $elm$html$Html$text('Open Lg')
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$Modal$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$Modal$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Modal$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Modal$init,
        ahE: $author$project$Pages$StyleGuide$Modal$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Modal$update,
        aid: $author$project$Pages$StyleGuide$Modal$view
    });
    var $author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage = 7;
    var $author$project$Pages$StyleGuide$Pagination$defaultTotalCount = 95;
    var $author$project$Pages$StyleGuide$Pagination$init = function(_v0) {
        return _Utils_Tuple2({
            bt: 1,
            fY: $author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage,
            oQ: $author$project$Pages$StyleGuide$Pagination$defaultTotalCount
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Pagination$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Pagination$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var string = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    bt: 1,
                    oQ: A2($elm$core$Maybe$withDefault, $author$project$Pages$StyleGuide$Pagination$defaultTotalCount, $elm$core$String$toInt(string))
                }), $elm$core$Platform$Cmd$none);
            case 1:
                var string = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    bt: 1,
                    fY: A2($elm$core$Maybe$withDefault, $author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage, $elm$core$String$toInt(string))
                }), $elm$core$Platform$Cmd$none);
            case 2:
                var currentPage = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    bt: currentPage
                }), $elm$core$Platform$Cmd$none);
            default:
                var perPage = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    bt: 1,
                    fY: perPage
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Pages$StyleGuide$Pagination$CurrentPageChanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Pagination$ItemsPerPageChanged = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$Lg = 2;
    var $author$project$Pages$StyleGuide$Pagination$PerPageChanged = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$Sm = 0;
    var $author$project$Pages$StyleGuide$Pagination$TotalCountChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$HideTotalItemsForSinglePage = {
        $: 2
    };
    var $author$project$Ui$Pagination$List$hideTotalItemsForSinglePage = $author$project$Ui$Pagination$List$HideTotalItemsForSinglePage;
    var $author$project$Ui$Pagination$List$Size = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Ui$Pagination$List$size = $author$project$Ui$Pagination$List$Size;
    var $author$project$Pages$StyleGuide$Pagination$viewBody = function(model) {
        return _List_fromArray([
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Pagination')
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$number,
                        $author$project$Ui$Form$Input$placeholder('Total Count (Default: ' + ($elm$core$String$fromInt($author$project$Pages$StyleGuide$Pagination$defaultTotalCount) + ')')),
                        $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Pagination$TotalCountChanged)
                    ])),
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$number,
                        $author$project$Ui$Form$Input$placeholder('Items Per Page (Default: ' + ($elm$core$String$fromInt($author$project$Pages$StyleGuide$Pagination$defaultItemsPerPage) + ')')),
                        $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$Pagination$ItemsPerPageChanged)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Default')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Ui$Pagination$List$view(_List_fromArray([
                        $author$project$Ui$Pagination$List$totalCount(model.oQ),
                        $author$project$Ui$Pagination$List$itemsPerPage(model.fY),
                        $author$project$Ui$Pagination$List$currentPage(model.bt),
                        $author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged),
                        $author$project$Ui$Pagination$List$onPerPageChange($author$project$Pages$StyleGuide$Pagination$PerPageChanged)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Small')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Ui$Pagination$List$view(_List_fromArray([
                        $author$project$Ui$Pagination$List$totalCount(model.oQ),
                        $author$project$Ui$Pagination$List$itemsPerPage(model.fY),
                        $author$project$Ui$Pagination$List$currentPage(model.bt),
                        $author$project$Ui$Pagination$List$size(0),
                        $author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged),
                        $author$project$Ui$Pagination$List$onPerPageChange($author$project$Pages$StyleGuide$Pagination$PerPageChanged)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Large')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Ui$Pagination$List$view(_List_fromArray([
                        $author$project$Ui$Pagination$List$totalCount(model.oQ),
                        $author$project$Ui$Pagination$List$itemsPerPage(model.fY),
                        $author$project$Ui$Pagination$List$currentPage(model.bt),
                        $author$project$Ui$Pagination$List$size(2),
                        $author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged),
                        $author$project$Ui$Pagination$List$onPerPageChange($author$project$Pages$StyleGuide$Pagination$PerPageChanged)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Hide Total Items For Single Page')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Ui$Pagination$List$view(_List_fromArray([
                        $author$project$Ui$Pagination$List$totalCount(model.oQ),
                        $author$project$Ui$Pagination$List$itemsPerPage(model.oQ),
                        $author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
                        $author$project$Ui$Pagination$List$currentPage(model.bt),
                        $author$project$Ui$Pagination$List$onClick($author$project$Pages$StyleGuide$Pagination$CurrentPageChanged),
                        $author$project$Ui$Pagination$List$onPerPageChange($author$project$Pages$StyleGuide$Pagination$PerPageChanged)
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Loading')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Ui$Pagination$List$view(_List_fromArray([
                        $author$project$Ui$Pagination$List$loading(true)
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$Pagination$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$Pagination$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Pagination$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Pagination$init,
        ahE: $author$project$Pages$StyleGuide$Pagination$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Pagination$update,
        aid: $author$project$Pages$StyleGuide$Pagination$view
    });
    var $author$project$Pages$StyleGuide$Panel$exampleCollapsible = _List_fromArray([
        A2($author$project$Ui$Panel$view, _List_fromArray([
            $author$project$Ui$Panel$collapsed(false)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Click to toggle')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                $elm$html$Html$text('This panel body is collapsible. Click the heading to expand or collapse it.')
            ])),
            A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                $elm$html$Html$text('The footer is also hidden when collapsed.')
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Panel$exampleCollapsibleStyled = _List_fromArray([
        A2($author$project$Ui$Panel$view, _List_fromArray([
            $author$project$Ui$Panel$info,
            $author$project$Ui$Panel$collapsed(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Styled collapsible (starts collapsed)')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Collapsible panels work with all panel style variants.')
            ]))
        ]))
    ]);
    var $author$project$Generated$StyleGuide$Examples$panelExampleCollapsible = '\n    [ Panel.view\n        [ Panel.collapsed False\n        ]\n        [ Panel.heading []\n            [ Panel.title [ text "Click to toggle" ]\n            ]\n        , Panel.body []\n            [ text "This panel body is collapsible. Click the heading to expand or collapse it."\n            ]\n        , Panel.footer []\n            [ text "The footer is also hidden when collapsed."\n            ]\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$panelExampleCollapsibleStyled = '\n    [ Panel.view\n        [ Panel.info\n        , Panel.collapsed True\n        ]\n        [ Panel.heading []\n            [ Panel.title [ text "Styled collapsible (starts collapsed)" ]\n            ]\n        , Panel.body []\n            [ text "Collapsible panels work with all panel style variants."\n            ]\n        ]\n    ]\n    ';
    var $author$project$Ui$Table$Striped = {
        $: 0
    };
    var $author$project$Ui$Table$striped = $author$project$Ui$Table$Striped;
    var $author$project$Pages$StyleGuide$Panel$viewPanel = A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Panel Title')
        ])),
        A2($author$project$Ui$Panel$body, _List_fromArray([
            $author$project$Ui$Element$textCenter
        ]), _List_fromArray([
            $elm$html$Html$text('Panel Content')
        ])),
        A4($author$project$Ui$Panel$table, _List_fromArray([
            $author$project$Ui$Table$striped
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Panel')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Table')
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Jhon')
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Doe')
                ]))
            ])),
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Jane')
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Doe')
                ]))
            ]))
        ]), _List_fromArray([
            A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Some')
                ])),
                A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Footer')
                ]))
            ]))
        ])),
        A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Panel Footer')
        ]))
    ]));
    var $author$project$Pages$StyleGuide$Panel$viewPanelStyle = function(panelStyle) {
        return A2($author$project$Ui$Panel$view, _List_fromArray([
            panelStyle
        ]), _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Panel Title')
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Panel Content')
            ]))
        ]));
    };
    var $author$project$Ui$Panel$Warning = 3;
    var $author$project$Ui$Panel$warning = $author$project$Ui$Panel$Styling(3);
    var $author$project$Pages$StyleGuide$Panel$view = function(_v0) {
        var panelStyles = _List_fromArray([
            $author$project$Ui$Panel$primary,
            $author$project$Ui$Panel$success,
            $author$project$Ui$Panel$info,
            $author$project$Ui$Panel$warning,
            $author$project$Ui$Panel$danger
        ]);
        return {
            fb: $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    $author$project$Pages$StyleGuide$Panel$viewPanel
                ]),
                A2($elm$core$List$map, $author$project$Pages$StyleGuide$Panel$viewPanelStyle, panelStyles),
                _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mb4
                    ]), _List_Nil),
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Collapsible Panel'),
                        $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                            $elm$html$Html$text('The collapsed option sets the initial state only. After rendering, the panel state is managed by CSS (checkbox hack). Click the heading to toggle.')
                        ]))
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$panelExampleCollapsible,
                        EU: $author$project$Pages$StyleGuide$Panel$exampleCollapsible
                    }),
                    A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                        $author$project$Components$StyleGuide$Example$title('Collapsible Styled Panel'),
                        $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                            $elm$html$Html$text('The collapsed option sets the initial state only. After rendering, the panel state is managed by CSS (checkbox hack). Click the heading to toggle.')
                        ]))
                    ]), {
                        Lk: $author$project$Generated$StyleGuide$Examples$panelExampleCollapsibleStyled,
                        EU: $author$project$Pages$StyleGuide$Panel$exampleCollapsibleStyled
                    })
                ])
            ])),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Panel$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Panel$view);
    var $author$project$Pages$StyleGuide$PasswordInput$init = function(_v0) {
        return _Utils_Tuple2('', $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$PasswordInput$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$PasswordInput$update = F2(function(msg, _v0) {
        var string = msg;
        return _Utils_Tuple2(string, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$StyleGuide$PasswordInput$PasswordInputChanged = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$PasswordInput$viewBody = function(password) {
        return _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Form -> Password Input')
            ])),
            $author$project$Ui$Form$PasswordInput$view(_List_fromArray([
                $author$project$Ui$Form$PasswordInput$value(password),
                $author$project$Ui$Form$PasswordInput$onInput($elm$core$Basics$identity)
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$PasswordInput$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$PasswordInput$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$PasswordInput$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$PasswordInput$init,
        ahE: $author$project$Pages$StyleGuide$PasswordInput$subscriptions,
        aaO: $author$project$Pages$StyleGuide$PasswordInput$update,
        aid: $author$project$Pages$StyleGuide$PasswordInput$view
    });
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotBankAccounts = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotCards = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithoutSession = {
        $: 1
    };
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$init = F2(function(shared, _v0) {
        var _v1 = shared.Z$;
        if (_v1.$ === 3) return _Utils_Tuple3($author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession({
            pF: $author$project$Api$Data$Loading,
            pQ: $author$project$Api$Data$Loading,
            HO: shared.HO
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Card$list, $author$project$Api$Data$providerPath, shared.Ej, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotCards),
            A3($author$project$Api$Provider$BankAccount$list, $author$project$Api$Data$providerPath, shared.Ej, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$GotBankAccounts)
        ])), _List_Nil);
        else return _Utils_Tuple3($author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$update = F2(function(msg, model) {
        if (!model.$) {
            var withSession = model.a;
            if (!msg.$) {
                var response = msg.a;
                return _Utils_Tuple3($author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession(_Utils_update(withSession, {
                    pQ: response
                })), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            } else {
                var response = msg.a;
                return _Utils_Tuple3($author$project$Pages$StyleGuide$PaymentSourceDisplayer$WithSession(_Utils_update(withSession, {
                    pF: response
                })), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            }
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$viewBody = function(model) {
        return _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Payment Source Displayer')
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Card')
            ])),
            function() {
                var _v0 = model.pQ;
                if (_v0.$ === 3) {
                    var cards = _v0.a;
                    return $elm$core$List$isEmpty(cards) ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('The current practice does not have any cards, add one  or change to a practice that does')
                    ])) : A2($author$project$Components$PaymentSourceDisplayer$view, model.HO, _List_fromArray([
                        $author$project$Components$PaymentSourceDisplayer$source(A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Api$Source$Card, $author$project$Api$Card$ProviderAll), $elm$core$List$head(cards)))
                    ]));
                } else return $author$project$Ui$Spinner$view(_List_Nil);
            }(),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('BankAccount')
            ])),
            function() {
                var _v1 = model.pF;
                if (_v1.$ === 3) {
                    var bankAccounts = _v1.a;
                    return $elm$core$List$isEmpty(bankAccounts) ? A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('The current practice does not have any cards, add one  or change to a practice that does')
                    ])) : A2($author$project$Components$PaymentSourceDisplayer$view, model.HO, _List_fromArray([
                        $author$project$Components$PaymentSourceDisplayer$source(A2($elm$core$Maybe$map, A2($elm$core$Basics$composeL, $author$project$Api$Source$BankAccount, $author$project$Api$BankAccount$ProviderAll), $elm$core$List$head(bankAccounts)))
                    ]));
                } else return $author$project$Ui$Spinner$view(_List_Nil);
            }(),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Practice Source Displayer')
            ])),
            function() {
                var _v2 = _Utils_Tuple2(model.pQ, model.pF);
                if (_v2.a.$ === 3 && _v2.b.$ === 3) {
                    var _v3 = _v2.a;
                    var cards = _v3.a;
                    var _v4 = _v2.b;
                    var bankAccounts = _v4.a;
                    return A2($author$project$Components$PracticeSourceDisplayer$view, model.HO, A2($author$project$Api$Source$defaultPracticeSource, cards, bankAccounts));
                } else return $author$project$Ui$Spinner$view(_List_Nil);
            }()
        ]);
    };
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$view = function(model) {
        return {
            fb: function() {
                if (!model.$) {
                    var modelRecord = model.a;
                    return $author$project$Pages$StyleGuide$PaymentSourceDisplayer$viewBody(modelRecord);
                } else return _List_fromArray([
                    A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You need to be logged in to view this style guide')
                    ]))
                ]);
            }(),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$PaymentSourceDisplayer$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$init,
        aeR: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$load,
        ag3: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$save,
        ahE: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$subscriptions,
        aaO: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$update,
        aid: $author$project$Pages$StyleGuide$PaymentSourceDisplayer$view
    });
    var $author$project$Pages$StyleGuide$PhoneInput$init = function(_v0) {
        return _Utils_Tuple2({
            bA: A3($author$project$Components$PhoneInput$init, 'phone-input', _List_Nil, $elm$core$Basics$identity),
            nx: A3($author$project$Components$PhoneInput$init, 'phone-input-one', _List_Nil, function(d) {
                return _Utils_update(d, {
                    Iz: true,
                    ac_: $author$project$Api$Common$Phone$Shared$Office,
                    y_: 1
                });
            }),
            ny: A3($author$project$Components$PhoneInput$init, 'phone-input-one-required', _List_Nil, function(d) {
                return _Utils_update(d, {
                    Iz: true,
                    ac_: $author$project$Api$Common$Phone$Shared$Office,
                    y_: 1,
                    agM: true
                });
            }),
            nz: A3($author$project$Components$PhoneInput$init, 'phone-input-preloaded', _List_fromArray([
                A3($author$project$Components$PhoneInput$initPhone, $author$project$Api$Common$Phone$Shared$Office, 1, '1234')
            ]), $elm$core$Basics$identity),
            nA: A3($author$project$Components$PhoneInput$init, 'phone-input-required', _List_Nil, function(d) {
                return _Utils_update(d, {
                    Iz: true,
                    ac_: $author$project$Api$Common$Phone$Shared$Office,
                    y_: 10,
                    agM: true,
                    ah6: _List_fromArray([
                        $author$project$Api$Common$Phone$Shared$Office,
                        $author$project$Api$Common$Phone$Shared$Mobile
                    ])
                });
            })
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$PhoneInput$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg, $author$project$Components$PhoneInput$subscriptions(model.bA)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg, $author$project$Components$PhoneInput$subscriptions(model.nA)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg, $author$project$Components$PhoneInput$subscriptions(model.nx)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg, $author$project$Components$PhoneInput$subscriptions(model.ny)),
            A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg, $author$project$Components$PhoneInput$subscriptions(model.nz))
        ]));
    };
    var $author$project$Pages$StyleGuide$PhoneInput$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v1 = A2($author$project$Components$PhoneInput$update, subMsg, model.bA);
                var updatedPhoneInput = _v1.a;
                var phoneCmd = _v1.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    bA: updatedPhoneInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg, phoneCmd));
            case 1:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Components$PhoneInput$update, subMsg, model.nA);
                var updatedPhoneInputRequired = _v2.a;
                var phoneCmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    nA: updatedPhoneInputRequired
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg, phoneCmd));
            case 2:
                var subMsg = msg.a;
                var _v3 = A2($author$project$Components$PhoneInput$update, subMsg, model.nx);
                var updatedPhoneInputOne = _v3.a;
                var phoneCmd = _v3.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    nx: updatedPhoneInputOne
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg, phoneCmd));
            case 3:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Components$PhoneInput$update, subMsg, model.ny);
                var updatedPhoneInputOneRequired = _v4.a;
                var phoneCmd = _v4.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ny: updatedPhoneInputOneRequired
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg, phoneCmd));
            default:
                var subMsg = msg.a;
                var _v5 = A2($author$project$Components$PhoneInput$update, subMsg, model.nz);
                var updatedPhoneInputPreloaded = _v5.a;
                var phoneCmd = _v5.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    nz: updatedPhoneInputPreloaded
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg, phoneCmd));
        }
    });
    var $author$project$Pages$StyleGuide$PhoneInput$viewBody = function(_v0) {
        var phoneInput = _v0.bA;
        var phoneInputPreloaded = _v0.nz;
        var phoneInputRequired = _v0.nA;
        var phoneInputOne = _v0.nx;
        var phoneInputOneRequired = _v0.ny;
        return _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Phone Input')
            ])),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Default')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputMsg, $author$project$Components$PhoneInput$view(phoneInput)),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Default + Preloaded')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputPreloadedMsg, $author$project$Components$PhoneInput$view(phoneInputPreloaded)),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('Required')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputRequiredMsg, $author$project$Components$PhoneInput$view(phoneInputRequired)),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('One')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneMsg, $author$project$Components$PhoneInput$view(phoneInputOne)),
            $author$project$Ui$Typography$heading(_List_fromArray([
                $elm$html$Html$text('One + Required')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$PhoneInput$GotPhoneInputOneRequiredMsg, $author$project$Components$PhoneInput$view(phoneInputOneRequired))
        ]);
    };
    var $author$project$Pages$StyleGuide$PhoneInput$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$PhoneInput$viewBody(model),
            $2: 'Phone Input'
        };
    };
    var $author$project$Pages$StyleGuide$PhoneInput$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$PhoneInput$init,
        ahE: $author$project$Pages$StyleGuide$PhoneInput$subscriptions,
        aaO: $author$project$Pages$StyleGuide$PhoneInput$update,
        aid: $author$project$Pages$StyleGuide$PhoneInput$view
    });
    var $author$project$Pages$StyleGuide$Popover$example = A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Hover over '),
                $author$project$Ui$Icon$help(_List_Nil)
            ]))
        ]))
    ]), _List_fromArray([
        A2($author$project$Ui$Popover$heading, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Popover Heading')
        ])),
        A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Popover Body')
        ])),
        A2($author$project$Ui$Popover$footer, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Popover Footer')
        ]))
    ]));
    var $author$project$Pages$StyleGuide$Popover$exampleDark = A3($author$project$Ui$Popover$view, _List_fromArray([
        $author$project$Ui$Popover$dark
    ]), _List_fromArray([
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Hover over '),
                $author$project$Ui$Icon$help(_List_Nil)
            ]))
        ]))
    ]), _List_fromArray([
        A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Popover Body')
        ]))
    ]));
    var $author$project$Pages$StyleGuide$Popover$exampleHistory = A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('See history ')
            ]))
        ]))
    ]), _List_fromArray([
        A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Last updated by practice user')
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textMuted
            ]), _List_fromArray([
                $elm$html$Html$text('06/25/2023 at 15:25 by test@test.com')
            ])),
            $author$project$Ui$HorizontalRule$view(_List_fromArray([
                $author$project$Ui$HorizontalRule$thin
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Created by practice')
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textMuted
            ]), _List_fromArray([
                $elm$html$Html$text('04/13/2023 at 13:16 via online signup https://member.staging.hint.com/signup?practice=test')
            ]))
        ]))
    ]));
    var $author$project$Generated$StyleGuide$Examples$popoverExample = '\n    Popover.view []\n        [ div []\n            [ span []\n                [ text "Hover over "\n                , Icon.help []\n                ]\n            ]\n        ]\n        [ Popover.heading []\n            [ text "Popover Heading"\n            ]\n        , Popover.body []\n            [ text "Popover Body"\n            ]\n        , Popover.footer []\n            [ text "Popover Footer"\n            ]\n        ]    ';
    var $author$project$Generated$StyleGuide$Examples$popoverExampleDark = '\n    Popover.view [ Popover.dark ]\n        [ div []\n            [ span []\n                [ text "Hover over "\n                , Icon.help []\n                ]\n            ]\n        ]\n        [ Popover.body []\n            [ text "Popover Body"\n            ]\n        ]    ';
    var $author$project$Generated$StyleGuide$Examples$popoverExampleHistory = '\n    Popover.view []\n        [ div []\n            [ span []\n                [ text "See history "\n                ]\n            ]\n        ]\n        [ Popover.body []\n            [ Element.view [] [ text "Last updated by practice user" ]\n            , Element.view [ Element.textMuted ] [ text "06/25/2023 at 15:25 by test@test.com" ]\n            , Hr.view [ Hr.thin ]\n            , Element.view [] [ text "Created by practice" ]\n            , Element.view [ Element.textMuted ] [ text "04/13/2023 at 13:16 via online signup https://member.staging.hint.com/signup?practice=test" ]\n            ]\n        ]\n    ';
    var $author$project$Pages$StyleGuide$Popover$view = function(_v0) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Popover')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$popoverExample,
                            EU: _List_fromArray([
                                $author$project$Pages$StyleGuide$Popover$example
                            ])
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('History Popover')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$popoverExampleHistory,
                            EU: _List_fromArray([
                                $author$project$Pages$StyleGuide$Popover$exampleHistory
                            ])
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Dark Popover')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$popoverExampleDark,
                            EU: _List_fromArray([
                                $author$project$Pages$StyleGuide$Popover$exampleDark
                            ])
                        })
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Popover$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Popover$view);
    var $author$project$Ui$ProgressBar$Info = {
        $: 3
    };
    var $author$project$Ui$ProgressBar$info = $author$project$Ui$ProgressBar$Info;
    var $author$project$Pages$StyleGuide$ProgressBar$view = function(_v0) {
        return {
            fb: _List_fromArray([
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Striped')
                ])),
                $author$project$Ui$ProgressBar$view(_List_fromArray([
                    $author$project$Ui$ProgressBar$striped,
                    $author$project$Ui$ProgressBar$width(10)
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Animated')
                ])),
                $author$project$Ui$ProgressBar$view(_List_fromArray([
                    $author$project$Ui$ProgressBar$striped,
                    $author$project$Ui$ProgressBar$animated,
                    $author$project$Ui$ProgressBar$width(20)
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Success')
                ])),
                $author$project$Ui$ProgressBar$view(_List_fromArray([
                    $author$project$Ui$ProgressBar$success,
                    $author$project$Ui$ProgressBar$width(30)
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Info')
                ])),
                $author$project$Ui$ProgressBar$view(_List_fromArray([
                    $author$project$Ui$ProgressBar$info,
                    $author$project$Ui$ProgressBar$width(40)
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Danger')
                ])),
                $author$project$Ui$ProgressBar$view(_List_fromArray([
                    $author$project$Ui$ProgressBar$danger,
                    $author$project$Ui$ProgressBar$width(50)
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Warning')
                ])),
                $author$project$Ui$ProgressBar$view(_List_fromArray([
                    $author$project$Ui$ProgressBar$warning,
                    $author$project$Ui$ProgressBar$width(60)
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('With Label')
                ])),
                $author$project$Ui$ProgressBar$view(_List_fromArray([
                    $author$project$Ui$ProgressBar$width(70.512),
                    $author$project$Ui$ProgressBar$showProgress
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Stacked')
                ])),
                $author$project$Ui$ProgressBar$stacked(_List_fromArray([
                    $author$project$Ui$ProgressBar$bar(_List_fromArray([
                        $author$project$Ui$ProgressBar$striped,
                        $author$project$Ui$ProgressBar$animated,
                        $author$project$Ui$ProgressBar$success,
                        $author$project$Ui$ProgressBar$width(10)
                    ])),
                    $author$project$Ui$ProgressBar$bar(_List_fromArray([
                        $author$project$Ui$ProgressBar$striped,
                        $author$project$Ui$ProgressBar$animated,
                        $author$project$Ui$ProgressBar$info,
                        $author$project$Ui$ProgressBar$width(30)
                    ])),
                    $author$project$Ui$ProgressBar$bar(_List_fromArray([
                        $author$project$Ui$ProgressBar$striped,
                        $author$project$Ui$ProgressBar$animated,
                        $author$project$Ui$ProgressBar$danger,
                        $author$project$Ui$ProgressBar$width(60)
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$ProgressBar$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$ProgressBar$view);
    var $author$project$Pages$StyleGuide$Radio$init = function(_v0) {
        return {
            pP: 'A',
            ah: 'A'
        };
    };
    var $author$project$Pages$StyleGuide$Radio$update = F2(function(msg, model) {
        if (!msg.$) {
            var value = msg.a;
            return _Utils_update(model, {
                ah: value
            });
        } else {
            var value = msg.a;
            return _Utils_update(model, {
                pP: value
            });
        }
    });
    var $author$project$Pages$StyleGuide$Radio$Selected = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Radio$example = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                $author$project$Ui$Form$Radio$value(model.ah === 'A'),
                $author$project$Ui$Form$Radio$onCheck($elm$core$Basics$always($author$project$Pages$StyleGuide$Radio$Selected('A')))
            ]), _List_fromArray([
                $elm$html$Html$text('Option A')
            ])),
            A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                $author$project$Ui$Form$Radio$value(model.ah === 'B'),
                $author$project$Ui$Form$Radio$onCheck($elm$core$Basics$always($author$project$Pages$StyleGuide$Radio$Selected('B')))
            ]), _List_fromArray([
                $elm$html$Html$text('Option B')
            ])),
            A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                $author$project$Ui$Form$Radio$value(model.ah === 'C'),
                $author$project$Ui$Form$Radio$onCheck($elm$core$Basics$always($author$project$Pages$StyleGuide$Radio$Selected('C')))
            ]), _List_fromArray([
                $elm$html$Html$text('Option C')
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$Radio$CardSelected = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$Radio$exampleCard = function(model) {
        return _List_fromArray([
            A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                $author$project$Ui$Form$Radio$card,
                $author$project$Ui$Form$Radio$value(model.pP === 'A'),
                $author$project$Ui$Form$Radio$onCheck($elm$core$Basics$always($author$project$Pages$StyleGuide$Radio$CardSelected('A')))
            ]), _List_fromArray([
                $elm$html$Html$text('Option A')
            ])),
            A2($author$project$Ui$Form$Radio$view, _List_fromArray([
                $author$project$Ui$Form$Radio$card,
                $author$project$Ui$Form$Radio$value(model.pP === 'B'),
                $author$project$Ui$Form$Radio$onCheck($elm$core$Basics$always($author$project$Pages$StyleGuide$Radio$CardSelected('B')))
            ]), _List_fromArray([
                $elm$html$Html$text('Option B')
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$Radio$exampleDisabled = _List_fromArray([
        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
            $author$project$Ui$Form$Radio$value(true),
            $author$project$Ui$Form$Radio$disabled(true)
        ]), _List_fromArray([
            $elm$html$Html$text('Disabled checked')
        ])),
        A2($author$project$Ui$Form$Radio$view, _List_fromArray([
            $author$project$Ui$Form$Radio$value(false),
            $author$project$Ui$Form$Radio$disabled(true)
        ]), _List_fromArray([
            $elm$html$Html$text('Disabled unchecked')
        ]))
    ]);
    var $author$project$Generated$StyleGuide$Examples$radioExample = '\n    [ Radio.view [ Radio.value (model.selected == "A"), Radio.onCheck (always (Selected "A")) ] [ text "Option A" ]\n    , Radio.view [ Radio.value (model.selected == "B"), Radio.onCheck (always (Selected "B")) ] [ text "Option B" ]\n    , Radio.view [ Radio.value (model.selected == "C"), Radio.onCheck (always (Selected "C")) ] [ text "Option C" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$radioExampleCard = '\n    [ Radio.view\n        [ Radio.card\n        , Radio.value (model.cardSelected == "A")\n        , Radio.onCheck (always (CardSelected "A"))\n        ]\n        [ text "Option A" ]\n    , Radio.view\n        [ Radio.card\n        , Radio.value (model.cardSelected == "B")\n        , Radio.onCheck (always (CardSelected "B"))\n        ]\n        [ text "Option B" ]\n    ]\n    ';
    var $author$project$Generated$StyleGuide$Examples$radioExampleDisabled = '\n    [ Radio.view [ Radio.value True, Radio.disabled True ] [ text "Disabled checked" ]\n    , Radio.view [ Radio.value False, Radio.disabled True ] [ text "Disabled unchecked" ]\n    ]    ';
    var $author$project$Pages$StyleGuide$Radio$viewBody = function(model) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Form > Radio')
            ])),
            A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                $author$project$Components$StyleGuide$Example$title('Basic')
            ]), {
                Lk: $author$project$Generated$StyleGuide$Examples$radioExample,
                EU: $author$project$Pages$StyleGuide$Radio$example(model)
            }),
            A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                $author$project$Components$StyleGuide$Example$title('Disabled')
            ]), {
                Lk: $author$project$Generated$StyleGuide$Examples$radioExampleDisabled,
                EU: $author$project$Pages$StyleGuide$Radio$exampleDisabled
            }),
            A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                $author$project$Components$StyleGuide$Example$title('Card')
            ]), {
                Lk: $author$project$Generated$StyleGuide$Examples$radioExampleCard,
                EU: $author$project$Pages$StyleGuide$Radio$exampleCard(model)
            })
        ]));
    };
    var $author$project$Pages$StyleGuide$Radio$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Pages$StyleGuide$Radio$viewBody(model)
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Radio$page = $author$project$Spa$Page$sandbox({
        aeq: $author$project$Pages$StyleGuide$Radio$init,
        aaO: $author$project$Pages$StyleGuide$Radio$update,
        aid: $author$project$Pages$StyleGuide$Radio$view
    });
    var $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$ResourceFilter$init = F4(function(session, _v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var _v3 = A4($author$project$Components$ResourceFilter$Plan$init, apiClient, session, function(d) {
            return _Utils_update(d, {
                A8: _List_fromArray([
                    0,
                    1
                ])
            });
        }, $elm$core$Basics$identity);
        var planResourceFilter = _v3.a;
        var planResourceFilterCmd = _v3.b;
        var _v4 = A4($author$project$Components$ResourceFilter$Location$init, apiClient, $elm$core$Maybe$Nothing, $elm$core$Basics$identity, $elm$core$Basics$identity);
        var locationResourceFilter = _v4.a;
        var locationResourceFilterCmd = _v4.b;
        return _Utils_Tuple2({
            Ej: apiClient,
            aeT: $author$project$Components$ResourceFilter$None,
            ro: locationResourceFilter,
            GW: $author$project$Components$ResourceFilter$None,
            jy: planResourceFilter
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg, planResourceFilterCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg, locationResourceFilterCmd)
        ])));
    });
    var $author$project$Pages$StyleGuide$ResourceFilter$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$StyleGuide$ResourceFilter$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$ResourceFilter$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$ResourceFilter$update = F2(function(msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var planResourceResult = A3($author$project$Components$ResourceFilter$Plan$update, model.Ej, subMsg, model.jy);
            var modelAfterEvent = function() {
                var _v1 = planResourceResult.adu;
                if (!_v1.$) {
                    if (!_v1.a.$) {
                        var selected = _v1.a.a;
                        return _Utils_update(model, {
                            GW: selected
                        });
                    } else {
                        var _v2 = _v1.a;
                        return model;
                    }
                } else return model;
            }();
            return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
                jy: planResourceResult.zi
            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg, planResourceResult.EQ), planResourceResult.at);
        } else {
            var subMsg = msg.a;
            var locationResourceResult = A3($author$project$Components$ResourceFilter$Location$update, model.Ej, subMsg, model.ro);
            var modelAfterEvent = function() {
                var _v3 = locationResourceResult.adu;
                if (!_v3.$) {
                    if (!_v3.a.$) {
                        var selected = _v3.a.a;
                        return _Utils_update(model, {
                            aeT: selected
                        });
                    } else {
                        var _v4 = _v3.a;
                        return model;
                    }
                } else return model;
            }();
            return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
                ro: locationResourceResult.zi
            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg, locationResourceResult.EQ), locationResourceResult.at);
        }
    });
    var $author$project$Pages$StyleGuide$ResourceFilter$planName = function(choice) {
        switch(choice.$){
            case 2:
                return 'All';
            case 3:
                return 'None';
            case 0:
                var plan = choice.a;
                return $author$project$Api$Plan$name(plan);
            case 1:
                var plans = choice.a;
                return A2($elm$core$String$join, ', ', A2($elm$core$List$map, $author$project$Api$Plan$name, plans));
            case 4:
                var extraItem = choice.a;
                return extraItem.aeI;
            default:
                var string = choice.a;
                return 'Custom: ' + string;
        }
    };
    var $author$project$Pages$StyleGuide$ResourceFilter$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Ui$Typography$headingLg(_List_fromArray([
                    $elm$html$Html$text('Resource Filter')
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Plan')
                ])),
                A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ResourceFilter$PlanResourceFilterMsg, A2($author$project$Components$ResourceFilter$Plan$view, _List_Nil, model.jy)),
                $elm$html$Html$text('Plan: ' + $author$project$Pages$StyleGuide$ResourceFilter$planName(model.GW)),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Location')
                ])),
                A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_Nil, model.ro)),
                $elm$html$Html$text('Location: ' + A2($elm$core$Maybe$withDefault, 'None', $author$project$Components$ResourceFilter$Location$value(model.ro))),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Location (disabled)')
                ])),
                A2($elm$html$Html$map, $author$project$Pages$StyleGuide$ResourceFilter$LocationResourceFilterMsg, A2($author$project$Components$ResourceFilter$Location$view, _List_fromArray([
                    $author$project$Components$ResourceFilter$disabled(true)
                ]), model.ro))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$ResourceFilter$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$StyleGuide$ResourceFilter$init,
        aeR: $author$project$Pages$StyleGuide$ResourceFilter$load,
        ag3: $author$project$Pages$StyleGuide$ResourceFilter$save,
        ahE: $author$project$Pages$StyleGuide$ResourceFilter$subscriptions,
        aaO: $author$project$Pages$StyleGuide$ResourceFilter$update,
        aid: $author$project$Pages$StyleGuide$ResourceFilter$view
    });
    var $author$project$Pages$StyleGuide$SearchInput$urlParams = function(model) {
        var queryParams = _List_fromArray([
            A2($elm$core$Maybe$map, $elm$core$Tuple$pair('q'), model.agq)
        ]);
        return $elm$core$Dict$fromList(A2($elm$core$List$filterMap, $elm$core$Basics$identity, queryParams));
    };
    var $author$project$Pages$StyleGuide$SearchInput$buildUrl = function(model) {
        return A2($elm$url$Url$Builder$relative, _List_fromArray([
            $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$StyleGuide__SearchInput)
        ]), $author$project$Utils$QueryParameter$fromDict($author$project$Pages$StyleGuide$SearchInput$urlParams(model)));
    };
    var $author$project$Pages$StyleGuide$SearchInput$GotHeroes = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$SearchInput$Hero = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$SearchInput$heroes = _List_fromArray([
        {
            aef: '1',
            zr: 'Batman'
        },
        {
            aef: 'spidey',
            zr: 'Spiderman'
        },
        {
            aef: 'drstrange',
            zr: 'Dr Strange'
        },
        {
            aef: '2',
            zr: 'The Flash'
        },
        {
            aef: 'ironman',
            zr: 'Ironman'
        }
    ]);
    var $author$project$Pages$StyleGuide$SearchInput$searchHeroes = function(query) {
        return A2($elm$core$List$filter, function(choice) {
            var _v0 = _Utils_Tuple2(query, choice);
            if (!_v0.a.$) {
                var query_ = _v0.a.a;
                var hero = _v0.b;
                return A2($elm$core$String$contains, query_, hero.zr);
            } else return true;
        }, $author$project$Pages$StyleGuide$SearchInput$heroes);
    };
    var $author$project$Pages$StyleGuide$SearchInput$fetchHeroes = function(model) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Pages$StyleGuide$SearchInput$GotHeroes($author$project$Pages$StyleGuide$SearchInput$searchHeroes(model.agq));
        }, $elm$core$Process$sleep(1500));
    };
    var $author$project$Pages$StyleGuide$SearchInput$init = F2(function(_v0, _v1) {
        var query = _v1.Bz;
        var q = A2($elm$core$Dict$get, 'q', query);
        var model = {
            qR: _List_Nil,
            Tk: $author$project$Utils$Maybe$toBool(q),
            agq: q,
            sG: $author$project$Ui$SearchInput$init(q)
        };
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$StyleGuide$SearchInput$fetchHeroes(model),
            A2($elm$core$Basics$composeR, $author$project$Pages$StyleGuide$SearchInput$buildUrl, $author$project$Ports$Navigation$replaceUrl)(model)
        ])), _List_Nil);
    });
    var $author$project$Pages$StyleGuide$SearchInput$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$SearchInput$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$SearchInput$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$SearchInput$SearchInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$SearchInput$update = F2(function(msg, model) {
        if (!msg.$) {
            var subMsg = msg.a;
            var _v1 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
            var searchInput = _v1.a;
            var searchInputCmd = _v1.b;
            var searchInputEvent = _v1.c;
            var q = function() {
                if (searchInputEvent.$ === 1) {
                    var query = searchInputEvent.a;
                    return query;
                } else return model.agq;
            }();
            var _v2 = function() {
                if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                else {
                    var qModel = _Utils_update(model, {
                        Tk: true,
                        agq: q
                    });
                    return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        $author$project$Pages$StyleGuide$SearchInput$fetchHeroes(qModel),
                        A2($elm$core$Basics$composeR, $author$project$Pages$StyleGuide$SearchInput$buildUrl, $author$project$Ports$Navigation$pushUrl)(qModel)
                    ])));
                }
            }();
            var newModel = _v2.a;
            var cmd = _v2.b;
            return _Utils_Tuple3(_Utils_update(newModel, {
                sG: searchInput
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$SearchInput$SearchInputMsg, searchInputCmd),
                cmd
            ])), _List_Nil);
        } else {
            var heroes_ = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                qR: heroes_,
                Tk: false
            }), $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$StyleGuide$SearchInput$heroToLabel = function(_v0) {
        var hero = _v0;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text(hero.zr)
        ]));
    };
    var $author$project$Pages$StyleGuide$SearchInput$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Ui$Typography$headingLg(_List_fromArray([
                    $elm$html$Html$text('Search Input')
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$StyleGuide$SearchInput$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                            $author$project$Ui$SearchInput$placeholder('Search for heroes'),
                            $author$project$Ui$SearchInput$phi(false),
                            $author$project$Ui$SearchInput$loading(model.Tk)
                        ]), model.sG))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
                        $author$project$Ui$Typography$heading(_List_fromArray([
                            $elm$html$Html$text('Search results')
                        ])),
                        $elm$core$List$isEmpty(model.qR) ? $elm$html$Html$text('None') : A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$map, $author$project$Pages$StyleGuide$SearchInput$heroToLabel, model.qR))
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$SearchInput$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$StyleGuide$SearchInput$init,
        aeR: $author$project$Pages$StyleGuide$SearchInput$load,
        ag3: $author$project$Pages$StyleGuide$SearchInput$save,
        ahE: $author$project$Pages$StyleGuide$SearchInput$subscriptions,
        aaO: $author$project$Pages$StyleGuide$SearchInput$update,
        aid: $author$project$Pages$StyleGuide$SearchInput$view
    });
    var $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToTitle = function(heroChoice) {
        switch(heroChoice.$){
            case 0:
                var name = heroChoice.a.zr;
                return name;
            case 1:
                return 'All :)';
            default:
                return 'None :(';
        }
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToLabel = function(heroChoice) {
        return _List_fromArray([
            $elm$html$Html$text($author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToTitle(heroChoice))
        ]);
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToValue = function(heroChoice) {
        switch(heroChoice.$){
            case 0:
                var id = heroChoice.a.aef;
                return $elm$core$Maybe$Just(id);
            case 1:
                return $elm$core$Maybe$Just('');
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$All = {
        $: 1
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$Hero = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$None = {
        $: 2
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$heroChoices = _List_fromArray([
        $author$project$Pages$StyleGuide$SearchableSelect$All,
        $author$project$Pages$StyleGuide$SearchableSelect$None,
        $author$project$Pages$StyleGuide$SearchableSelect$Hero({
            aef: '1',
            zr: 'Batman'
        }),
        $author$project$Pages$StyleGuide$SearchableSelect$Hero({
            aef: 'spidey',
            zr: 'Spiderman'
        }),
        $author$project$Pages$StyleGuide$SearchableSelect$Hero({
            aef: 'drstrange',
            zr: 'Dr Strange'
        }),
        $author$project$Pages$StyleGuide$SearchableSelect$Hero({
            aef: '2',
            zr: 'The Flash'
        }),
        $author$project$Pages$StyleGuide$SearchableSelect$Hero({
            aef: 'ironman',
            zr: 'Ironman'
        })
    ]);
    var $author$project$Pages$StyleGuide$SearchableSelect$init = F2(function(_v0, _v1) {
        return _Utils_Tuple3({
            mr: $elm$core$Maybe$Nothing,
            iM: $author$project$Ui$Form$SearchableSelect$init({
                aef: 'heroes',
                ahW: $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToLabel,
                ahZ: $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToTitle,
                g4: $author$project$Pages$StyleGuide$SearchableSelect$heroChoiceToValue
            }),
            qR: $author$project$Pages$StyleGuide$SearchableSelect$heroChoices
        }, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$SearchableSelect$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$SearchableSelect$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$SearchableSelect$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$SelectMsg = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$SearchableSelect$searchHeroes = function(query) {
        return A2($elm$core$List$filter, function(choice) {
            if (!choice.$) {
                var hero = choice.a;
                return A2($elm$core$String$contains, query, hero.zr);
            } else return true;
        }, $author$project$Pages$StyleGuide$SearchableSelect$heroChoices);
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$update = F2(function(msg, model) {
        var selectMsg = msg;
        var _v1 = A2($author$project$Ui$Form$SearchableSelect$update, selectMsg, model.iM);
        var selectModel = _v1.a;
        var selectCmd = _v1.b;
        var event = _v1.c;
        var modelAfterEvent = function() {
            _v2$2: while(true){
                if (!event.$) switch(event.a.$){
                    case 0:
                        var hero = event.a.a;
                        return _Utils_update(model, {
                            mr: hero
                        });
                    case 1:
                        var string = event.a.a;
                        return _Utils_update(model, {
                            qR: $author$project$Pages$StyleGuide$SearchableSelect$searchHeroes(string)
                        });
                    default:
                        break _v2$2;
                }
                else break _v2$2;
            }
            return model;
        }();
        return _Utils_Tuple3(_Utils_update(modelAfterEvent, {
            iM: selectModel
        }), A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, selectCmd), _List_Nil);
    });
    var $author$project$Pages$StyleGuide$SearchableSelect$heroInvalid = function(heroChoice) {
        if (!heroChoice.$ && !heroChoice.a.$) {
            var hero = heroChoice.a.a;
            return hero.aef === 'ironman';
        } else return false;
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$heroErrors = function(heroChoice) {
        return $author$project$Pages$StyleGuide$SearchableSelect$heroInvalid(heroChoice) ? _List_fromArray([
            'Pick a DC hero'
        ]) : _List_Nil;
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Ui$Typography$headingLg(_List_fromArray([
                    $elm$html$Html$text('Form -> Searchable Select')
                ])),
                A2($elm$html$Html$map, $elm$core$Basics$identity, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
                    $author$project$Ui$Form$SearchableSelect$value(model.mr),
                    $author$project$Ui$Form$SearchableSelect$invalid($author$project$Pages$StyleGuide$SearchableSelect$heroInvalid(model.mr)),
                    $author$project$Ui$Form$SearchableSelect$errors($author$project$Pages$StyleGuide$SearchableSelect$heroErrors(model.mr)),
                    $author$project$Ui$Form$SearchableSelect$placeholder('Pick your favorite hero')
                ]), A2($elm$core$List$map, function(heroChoice) {
                    return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, heroChoice);
                }, model.qR), model.iM)),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($elm$html$Html$map, $elm$core$Basics$identity, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
                    $author$project$Ui$Form$SearchableSelect$disabled(true),
                    $author$project$Ui$Form$SearchableSelect$placeholder('Disabled')
                ]), A2($elm$core$List$map, function(heroChoice) {
                    return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, heroChoice);
                }, model.qR), model.iM)),
                A2($elm$html$Html$br, _List_Nil, _List_Nil),
                A2($elm$html$Html$map, $elm$core$Basics$identity, A3($author$project$Ui$Form$SearchableSelect$view, _List_fromArray([
                    $author$project$Ui$Form$SearchableSelect$loading(true),
                    $author$project$Ui$Form$SearchableSelect$placeholder('Loading')
                ]), A2($elm$core$List$map, function(heroChoice) {
                    return A2($author$project$Ui$Form$SearchableSelect$Item$new, _List_Nil, heroChoice);
                }, model.qR), model.iM))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$SearchableSelect$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$StyleGuide$SearchableSelect$init,
        aeR: $author$project$Pages$StyleGuide$SearchableSelect$load,
        ag3: $author$project$Pages$StyleGuide$SearchableSelect$save,
        ahE: $author$project$Pages$StyleGuide$SearchableSelect$subscriptions,
        aaO: $author$project$Pages$StyleGuide$SearchableSelect$update,
        aid: $author$project$Pages$StyleGuide$SearchableSelect$view
    });
    var $author$project$Pages$StyleGuide$Select$init = function(_v0) {
        return _Utils_Tuple2({
            Ck: 'spidey'
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Select$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Select$update = F2(function(msg, model) {
        var selectedHero = msg;
        return _Utils_Tuple2(_Utils_update(model, {
            Ck: selectedHero
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$StyleGuide$Select$HeroSelected = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$Select$heroChoices = _List_fromArray([
        {
            aef: '1',
            zr: 'Batman',
            kB: 'DC'
        },
        {
            aef: 'spidey',
            zr: 'Spiderman',
            kB: 'Marver'
        },
        {
            aef: 'drstrange',
            zr: 'Dr Strange',
            kB: 'Marver'
        },
        {
            aef: '2',
            zr: 'The Flash',
            kB: 'DC'
        }
    ]);
    var $author$project$Pages$StyleGuide$Select$heroGroupOptions = function(heroes) {
        return A2($elm$core$List$map, function(hero) {
            return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just(hero.aef), hero.zr);
        }, heroes);
    };
    var $author$project$Pages$StyleGuide$Select$heroOptions = function(heroes) {
        return A2($elm$core$List$map, function(_v0) {
            var hero = _v0.a;
            var grouped = _v0.b;
            return A2($author$project$Ui$Form$Select$group, hero.kB, $author$project$Pages$StyleGuide$Select$heroGroupOptions(A2($elm$core$List$cons, hero, grouped)));
        }, A2($elm_community$list_extra$List$Extra$gatherEqualsBy, function($) {
            return $.kB;
        }, heroes));
    };
    var $author$project$Pages$StyleGuide$Select$viewBody = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('section')
            ]), _List_fromArray([
                $author$project$Ui$Typography$headingLg(_List_fromArray([
                    $elm$html$Html$text('Form > Select')
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$value($elm$core$Maybe$Just(model.Ck)),
                        $author$project$Ui$Form$Select$onChange($elm$core$Basics$identity)
                    ]), $author$project$Pages$StyleGuide$Select$heroOptions($author$project$Pages$StyleGuide$Select$heroChoices))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$disabled(true)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Disabled')
                    ]))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$loading(true)
                    ]), _List_fromArray([
                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Loading')
                    ]))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Select$view, _List_fromArray([
                        $author$project$Ui$Form$Select$invalid(true),
                        $author$project$Ui$Form$Select$errors(_List_fromArray([
                            'Some error'
                        ]))
                    ]), _List_fromArray([
                        A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Invalid')
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$Select$view = function(model) {
        return {
            fb: $author$project$Pages$StyleGuide$Select$viewBody(model),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Select$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Select$init,
        ahE: $author$project$Pages$StyleGuide$Select$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Select$update,
        aid: $author$project$Pages$StyleGuide$Select$view
    });
    var $author$project$Pages$StyleGuide$Skeleton$init = function(_v0) {
        return {};
    };
    var $author$project$Pages$StyleGuide$Skeleton$update = F2(function(_v0, model) {
        return model;
    });
    var $author$project$Pages$StyleGuide$Skeleton$exampleFormGroup = _List_fromArray([
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$labelSkeleton('Papyrus')
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$labelSkeleton('Sans')
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_Nil)
        ])),
        A2($author$project$Ui$Form$Group$view, _List_fromArray([
            $author$project$Ui$Form$Group$labelSpan(4),
            $author$project$Ui$Form$Group$inputSpan(8),
            $author$project$Ui$Form$Group$label('')
        ]), _List_fromArray([
            A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$span(4)
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Skeleton$exampleInput = _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$spaceBetween
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$input(_List_fromArray([
                $author$project$Ui$Skeleton$span(8)
            ])),
            $author$project$Ui$Skeleton$input(_List_fromArray([
                $author$project$Ui$Skeleton$span(2)
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Skeleton$exampleSpan = _List_fromArray([
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$block,
            $author$project$Ui$Skeleton$span(2)
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$block,
            $author$project$Ui$Skeleton$span(4)
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$block,
            $author$project$Ui$Skeleton$span(6)
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$block,
            $author$project$Ui$Skeleton$span(8)
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$block,
            $author$project$Ui$Skeleton$span(10)
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$block
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Skeleton$exampleSpanFromText = _List_fromArray([
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('The sight of such a friendly skeleton fills you with determination.')
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$spanFromText('The sight of such a friendly skeleton fills you with determination.')
        ])),
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('I can cook spaghetti')
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$spanFromText('I can cook spaghetti')
        ])),
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $elm$html$Html$text('Its a beautiful day outside')
        ])),
        $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$spanFromText('Its a beautiful day outside')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Skeleton$exampleTableWithPagination = _List_fromArray([
        A4($author$project$Ui$Table$view, _List_fromArray([
            $author$project$Ui$Table$loading(true)
        ]), _List_fromArray([
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Header 1')
            ])),
            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Header 2')
            ]))
        ]), _List_Nil, _List_Nil),
        $author$project$Ui$Pagination$List$view(_List_fromArray([
            $author$project$Ui$Pagination$List$loading(true)
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Skeleton$exampleText = _List_fromArray([
        A2($elm$html$Html$h1, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_Nil)
        ])),
        A2($elm$html$Html$h2, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_Nil)
        ])),
        A2($elm$html$Html$h3, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_Nil)
        ])),
        A2($elm$html$Html$p, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_Nil)
        ]))
    ]);
    var $author$project$Generated$StyleGuide$Examples$skeletonExampleFormGroup = '\n    [ FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.labelSkeleton "Papyrus"\n        ]\n        [ Skeleton.input []\n        ]\n    , FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.labelSkeleton "Sans"\n        ]\n        [ Skeleton.input []\n        ]\n    , FormGroup.view\n        [ FormGroup.labelSpan 4\n        , FormGroup.inputSpan 8\n        , FormGroup.label ""\n        ]\n        [ FormStatic.view [] [ Skeleton.text [ Skeleton.span 4 ] ]\n        ]\n    ]\n    ';
    var $author$project$Generated$StyleGuide$Examples$skeletonExampleInput = '\n    [ Element.view [ Element.spaceBetween ]\n        [ Skeleton.input [ Skeleton.span 8 ]\n        , Skeleton.input [ Skeleton.span 2 ]\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$skeletonExampleSpan = '\n    [ Skeleton.text [ Skeleton.block, Skeleton.span 2 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 4 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 6 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 8 ]\n    , Skeleton.text [ Skeleton.block, Skeleton.span 10 ]\n    , Skeleton.text [ Skeleton.block ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$skeletonExampleSpanFromText = '\n    [ Html.div [] [ text "The sight of such a friendly skeleton fills you with determination." ]\n    , Skeleton.text [ Skeleton.spanFromText "The sight of such a friendly skeleton fills you with determination." ]\n    , Html.div [] [ text "I can cook spaghetti" ]\n    , Skeleton.text [ Skeleton.spanFromText "I can cook spaghetti" ]\n    , Html.div [] [ text "Its a beautiful day outside" ]\n    , Skeleton.text [ Skeleton.spanFromText "Its a beautiful day outside" ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$skeletonExampleTableWithPagination = '\n    [ Table.view [ Table.loading True ]\n        [ Table.header [] [ text "Header 1" ]\n        , Table.header [] [ text "Header 2" ]\n        ]\n        []\n        []\n    , Pagination.view [ Pagination.loading True ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$skeletonExampleText = '\n    [ Html.h1 [] [ Skeleton.text [] ]\n    , Html.h2 [] [ Skeleton.text [] ]\n    , Html.h3 [] [ Skeleton.text [] ]\n    , Html.p [] [ Skeleton.text [] ]\n    ]    ';
    var $author$project$Pages$StyleGuide$Skeleton$viewBody = _List_fromArray([
        A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                $author$project$Ui$Panel$title(_List_fromArray([
                    $elm$html$Html$text('Skeletons')
                ]))
            ])),
            $author$project$Ui$Panel$hr,
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Skeletons are the main activity indicator.')
                ])),
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('They can be used alongside progressive loading techniques to enhance the user experience and reduce the perception of waiting time.')
                ])),
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Skeletons are the go to component on first loads or when the data shown is stale and new one being loaded (like on tables).')
                ])),
                A2($elm$html$Html$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('They also look pretty good in my (biased) opinion')
                ]))
            ]))
        ])),
        A2($author$project$Ui$Grid$row, _List_fromArray([
            $author$project$Ui$Grid$mt4
        ]), _List_fromArray([
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title('Text Skeleton'),
                    $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                        $elm$html$Html$text('The height will adjust based on font size, so they can be used inside headings.')
                    ]))
                ]), {
                    Lk: $author$project$Generated$StyleGuide$Examples$skeletonExampleText,
                    EU: $author$project$Pages$StyleGuide$Skeleton$exampleText
                })
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title('Input Skeleton'),
                    $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                        $elm$html$Html$text('Buttons count as inputs')
                    ]))
                ]), {
                    Lk: $author$project$Generated$StyleGuide$Examples$skeletonExampleInput,
                    EU: $author$project$Pages$StyleGuide$Skeleton$exampleInput
                })
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title('Input Span'),
                    $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                        $elm$html$Html$text('Same API as grid, they also support responsive spans (spanSm, spanMd, spanLg)')
                    ]))
                ]), {
                    Lk: $author$project$Generated$StyleGuide$Examples$skeletonExampleSpan,
                    EU: $author$project$Pages$StyleGuide$Skeleton$exampleSpan
                })
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title('Span from Text'),
                    $author$project$Components$StyleGuide$Example$description(_List_fromArray([
                        $elm$html$Html$text('If the text is known beforehand it can be used directly to take the same space')
                    ]))
                ]), {
                    Lk: $author$project$Generated$StyleGuide$Examples$skeletonExampleSpanFromText,
                    EU: $author$project$Pages$StyleGuide$Skeleton$exampleSpanFromText
                })
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title('Table with Pagination')
                ]), {
                    Lk: $author$project$Generated$StyleGuide$Examples$skeletonExampleTableWithPagination,
                    EU: $author$project$Pages$StyleGuide$Skeleton$exampleTableWithPagination
                })
            ])),
            A2($author$project$Ui$Grid$column, _List_fromArray([
                $author$project$Ui$Grid$spanMd(6)
            ]), _List_fromArray([
                A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                    $author$project$Components$StyleGuide$Example$title('Form Group')
                ]), {
                    Lk: $author$project$Generated$StyleGuide$Examples$skeletonExampleFormGroup,
                    EU: $author$project$Pages$StyleGuide$Skeleton$exampleFormGroup
                })
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Skeleton$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$Skeleton$viewBody,
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Skeleton$page = $author$project$Spa$Page$sandbox({
        aeq: $author$project$Pages$StyleGuide$Skeleton$init,
        aaO: $author$project$Pages$StyleGuide$Skeleton$update,
        aid: $author$project$Pages$StyleGuide$Skeleton$view
    });
    var $author$project$Pages$StyleGuide$Table$Id = 0;
    var $author$project$Pages$StyleGuide$Table$init = function(_v0) {
        return _Utils_Tuple2({
            kg: 0,
            kh: 1
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Pages$StyleGuide$Table$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Table$update = F2(function(msg, model) {
        var column = msg;
        var newDirection = function() {
            if (_Utils_eq(model.kg, column)) {
                var _v1 = model.kh;
                if (!_v1) return 1;
                else return 0;
            } else return 0;
        }();
        return _Utils_Tuple2(_Utils_update(model, {
            kg: column,
            kh: newDirection
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$StyleGuide$Table$Name = 1;
    var $author$project$Pages$StyleGuide$Table$Datum = F3(function(id, name, ring) {
        return {
            aef: id,
            zr: name,
            Y9: ring
        };
    });
    var $author$project$Pages$StyleGuide$Table$data = _List_fromArray([
        A3($author$project$Pages$StyleGuide$Table$Datum, 1, 'Mercury', 'Inner'),
        A3($author$project$Pages$StyleGuide$Table$Datum, 2, 'Venus', 'Inner'),
        A3($author$project$Pages$StyleGuide$Table$Datum, 3, 'Earth', 'Inner'),
        A3($author$project$Pages$StyleGuide$Table$Datum, 4, 'Mars', 'Inner'),
        A3($author$project$Pages$StyleGuide$Table$Datum, 5, 'Jupiter', 'Outer'),
        A3($author$project$Pages$StyleGuide$Table$Datum, 6, 'Saturn', 'Outer'),
        A3($author$project$Pages$StyleGuide$Table$Datum, 7, 'Uranus', 'Outer'),
        A3($author$project$Pages$StyleGuide$Table$Datum, 8, 'Neptune', 'Outer')
    ]);
    var $author$project$Pages$StyleGuide$Table$sort = F3(function(column, direction, data_) {
        return (function() {
            if (!direction) return $elm$core$List$reverse;
            else return $elm$core$Basics$identity;
        })()(A2($elm$core$List$sortWith, F2(function(one, other) {
            if (!column) return A2($elm$core$Basics$compare, one.aef, other.aef);
            else return A2($elm$core$Basics$compare, one.zr, other.zr);
        }), data_));
    });
    var $author$project$Pages$StyleGuide$Table$SortTable = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$Table$sortableHeaderAttributes = F3(function(sortColumn, sortDirection, column) {
        var columnSort = _Utils_eq(column, sortColumn) ? _List_fromArray([
            $author$project$Ui$Table$sortDirection(sortDirection)
        ]) : _List_Nil;
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $author$project$Ui$Table$onClick(column),
                $author$project$Ui$Table$sortable(true)
            ]),
            columnSort
        ]));
    });
    var $author$project$Ui$Table$Active = 0;
    var $author$project$Pages$StyleGuide$Table$viewTableRow = function(_v0) {
        var id = _v0.aef;
        var name = _v0.zr;
        var ring = _v0.Y9;
        var options = function() {
            switch(id){
                case 1:
                    return _List_fromArray([
                        $author$project$Ui$Table$styled(1)
                    ]);
                case 2:
                    return _List_fromArray([
                        $author$project$Ui$Table$styled(0)
                    ]);
                case 3:
                    return _List_fromArray([
                        $author$project$Ui$Table$styled(2)
                    ]);
                case 4:
                    return _List_fromArray([
                        $author$project$Ui$Table$styled(3)
                    ]);
                case 5:
                    return _List_fromArray([
                        $author$project$Ui$Table$styled(4)
                    ]);
                default:
                    return _List_Nil;
            }
        }();
        return A2($author$project$Ui$Table$row, options, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text($elm$core$String$fromInt(id))
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(name)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $elm$html$Html$text(ring)
            ]))
        ]));
    };
    var $author$project$Pages$StyleGuide$Table$view = function(model) {
        return {
            fb: _List_fromArray([
                $author$project$Ui$Typography$headingLg(_List_fromArray([
                    $elm$html$Html$text('Table')
                ])),
                A4($author$project$Ui$Table$view, _List_fromArray([
                    $author$project$Ui$Table$striped,
                    $author$project$Ui$Table$bordered
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, A3($author$project$Pages$StyleGuide$Table$sortableHeaderAttributes, model.kg, model.kh, 0), _List_fromArray([
                        $elm$html$Html$text('Id')
                    ])),
                    A2($author$project$Ui$Table$header, A3($author$project$Pages$StyleGuide$Table$sortableHeaderAttributes, model.kg, model.kh, 1), _List_fromArray([
                        $elm$html$Html$text('Name')
                    ])),
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Ring')
                    ]))
                ]), A2($elm$core$List$map, $author$project$Pages$StyleGuide$Table$viewTableRow, A3($author$project$Pages$StyleGuide$Table$sort, model.kg, model.kh, $author$project$Pages$StyleGuide$Table$data)), _List_fromArray([
                    A2($author$project$Ui$Table$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Some')
                        ])),
                        A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Footer')
                        ]))
                    ]))
                ])),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Zero State')
                ])),
                A4($author$project$Ui$Table$view, _List_fromArray([
                    $author$project$Ui$Table$zeroState(_List_fromArray([
                        $elm$html$Html$text('You don\'t have any data for the time period and filters selected.')
                    ]))
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Name')
                    ]))
                ]), _List_Nil, _List_Nil),
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Loading')
                ])),
                A4($author$project$Ui$Table$view, _List_fromArray([
                    $author$project$Ui$Table$loading(true)
                ]), _List_fromArray([
                    A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Name')
                    ]))
                ]), _List_Nil, _List_Nil)
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Table$page = $author$project$Spa$Page$element({
        aeq: $author$project$Pages$StyleGuide$Table$init,
        ahE: $author$project$Pages$StyleGuide$Table$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Table$update,
        aid: $author$project$Pages$StyleGuide$Table$view
    });
    var $author$project$Pages$StyleGuide$Toast$init = F2(function(_v0, _v1) {
        return _Utils_Tuple3({}, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$Toast$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$Toast$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$Toast$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$Toast$update = F2(function(msg, model) {
        var level = msg.a;
        var message = msg.b;
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
            A2($author$project$OutMsg$ShowToast, level, message)
        ]));
    });
    var $author$project$Pages$StyleGuide$Toast$ShowToast = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Pages$StyleGuide$Toast$viewBody = _List_fromArray([
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Show info toast'
            }, _List_fromArray([
                $author$project$Ui$Button$primary,
                $author$project$Ui$Button$onClick(A2($author$project$Pages$StyleGuide$Toast$ShowToast, 0, 'Lots of info'))
            ]), _List_fromArray([
                $elm$html$Html$text('Info')
            ]))
        ])),
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Show success toast'
            }, _List_fromArray([
                $author$project$Ui$Button$success,
                $author$project$Ui$Button$onClick(A2($author$project$Pages$StyleGuide$Toast$ShowToast, 3, 'Wohoo'))
            ]), _List_fromArray([
                $elm$html$Html$text('Success')
            ]))
        ])),
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Show error toast'
            }, _List_fromArray([
                $author$project$Ui$Button$danger,
                $author$project$Ui$Button$onClick(A2($author$project$Pages$StyleGuide$Toast$ShowToast, 1, 'Oopsie Daisy!'))
            ]), _List_fromArray([
                $elm$html$Html$text('Error')
            ]))
        ])),
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Show warning toast'
            }, _List_fromArray([
                $author$project$Ui$Button$styled(4),
                $author$project$Ui$Button$onClick(A2($author$project$Pages$StyleGuide$Toast$ShowToast, 2, 'Halt!'))
            ]), _List_fromArray([
                $elm$html$Html$text('Warning')
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Toast$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$Toast$viewBody,
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Toast$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$StyleGuide$Toast$init,
        aeR: $author$project$Pages$StyleGuide$Toast$load,
        ag3: $author$project$Pages$StyleGuide$Toast$save,
        ahE: $author$project$Pages$StyleGuide$Toast$subscriptions,
        aaO: $author$project$Pages$StyleGuide$Toast$update,
        aid: $author$project$Pages$StyleGuide$Toast$view
    });
    var $author$project$Pages$StyleGuide$ToggleSwitch$init = function(_v0) {
        return {
            kz: true
        };
    };
    var $author$project$Pages$StyleGuide$ToggleSwitch$update = F2(function(msg, model) {
        var bool = msg;
        return _Utils_update(model, {
            kz: bool
        });
    });
    var $author$project$Pages$StyleGuide$ToggleSwitch$ToggleSwitchChanged = $elm$core$Basics$identity;
    var $author$project$Pages$StyleGuide$ToggleSwitch$example = function(value) {
        return _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(value),
                $author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$ToggleSwitch$exampleDisabled = function(value) {
        return _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(value),
                $author$project$Ui$ToggleSwitch$disabled(true),
                $author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$ToggleSwitch$exampleSmall = function(value) {
        return _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$on(value),
                $author$project$Ui$ToggleSwitch$sm,
                $author$project$Ui$ToggleSwitch$onChange($elm$core$Basics$identity)
            ]))
        ]);
    };
    var $author$project$Generated$StyleGuide$Examples$toggleSwitchExample = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleDisabled = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.disabled True\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]    ';
    var $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleSmall = '\n    [ ToggleSwitch.view\n        [ ToggleSwitch.on value\n        , ToggleSwitch.sm\n        , ToggleSwitch.onChange ToggleSwitchChanged\n        ]\n    ]\n    ';
    var $author$project$Pages$StyleGuide$ToggleSwitch$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Toggle Switch: ' + (model.kz ? 'True' : 'False'))
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$toggleSwitchExample,
                            EU: $author$project$Pages$StyleGuide$ToggleSwitch$example(model.kz)
                        }),
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Small')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleSmall,
                            EU: $author$project$Pages$StyleGuide$ToggleSwitch$exampleSmall(model.kz)
                        })
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(6)
                    ]), _List_fromArray([
                        A2($author$project$Components$StyleGuide$Example$view, _List_fromArray([
                            $author$project$Components$StyleGuide$Example$title('Disabled')
                        ]), {
                            Lk: $author$project$Generated$StyleGuide$Examples$toggleSwitchExampleDisabled,
                            EU: $author$project$Pages$StyleGuide$ToggleSwitch$exampleDisabled(model.kz)
                        })
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$ToggleSwitch$page = $author$project$Spa$Page$sandbox({
        aeq: $author$project$Pages$StyleGuide$ToggleSwitch$init,
        aaO: $author$project$Pages$StyleGuide$ToggleSwitch$update,
        aid: $author$project$Pages$StyleGuide$ToggleSwitch$view
    });
    var $author$project$Pages$StyleGuide$Tooltip$view = function(_v0) {
        return {
            fb: _List_fromArray([
                $author$project$Ui$Typography$headingLg(_List_fromArray([
                    $elm$html$Html$text('Tooltip')
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_Nil, 'Thanks for hovering! I\'m a tooltip', _List_fromArray([
                        $elm$html$Html$text('TOP: Hover over me!')
                    ]))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$placement(3)
                    ]), 'Thanks for hovering! I\'m a tooltip', _List_fromArray([
                        $elm$html$Html$text('RIGHT: Hover over me!')
                    ]))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$placement(1)
                    ]), 'Thanks for hovering! I\'m a tooltip', _List_fromArray([
                        $elm$html$Html$text('BOTTOM: Hover over me!')
                    ]))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, _List_fromArray([
                        $author$project$Ui$Tooltip$placement(2)
                    ]), 'Thanks for hovering! I\'m a tooltip', _List_fromArray([
                        $elm$html$Html$text('LEFT: Hover over me!')
                    ]))
                ]))
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Tooltip$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Tooltip$view);
    var $author$project$Pages$StyleGuide$Top$view = function(_v0) {
        return {
            fb: _List_fromArray([
                $elm$html$Html$text('StyleGuide')
            ]),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Top$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Top$view);
    var $author$project$Ui$OverflowWrap$Anywhere = 2;
    var $author$project$Ui$OverflowWrap$anywhere = 2;
    var $author$project$Pages$StyleGuide$Typography$loremIpsum = 'Lorem ipsum dolor sit amet, Antidisestablishmentarianism adipiscing elit.';
    var $author$project$Ui$OverflowWrap$Normal = 1;
    var $author$project$Ui$OverflowWrap$normal = 1;
    var $author$project$Pages$StyleGuide$Typography$viewBody = _List_fromArray([
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Headings')
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $elm$html$Html$text('Base Title')
                ])),
                $author$project$Ui$Typography$headingSm(_List_fromArray([
                    $elm$html$Html$text('Small Title')
                ]))
            ]))
        ])),
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Type')
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('mt-4')
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Normal text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('Muted text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$gray
                ]), _List_fromArray([
                    $elm$html$Html$text('Gray text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$primary
                ]), _List_fromArray([
                    $elm$html$Html$text('Primary text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$success
                ]), _List_fromArray([
                    $elm$html$Html$text('Success text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$info
                ]), _List_fromArray([
                    $elm$html$Html$text('Info text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$warning
                ]), _List_fromArray([
                    $elm$html$Html$text('Warning text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$danger
                ]), _List_fromArray([
                    $elm$html$Html$text('Danger text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$underline
                ]), _List_fromArray([
                    $elm$html$Html$text('Underline text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$strike
                ]), _List_fromArray([
                    $elm$html$Html$text('Strike text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
                ]), _List_fromArray([
                    $elm$html$Html$text('Left text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textCenter)
                ]), _List_fromArray([
                    $elm$html$Html$text('Center text')
                ])),
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textRight)
                ]), _List_fromArray([
                    $elm$html$Html$text('Right text')
                ]))
            ]))
        ])),
        A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Word wrap')
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Break Word')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$breakWord)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Pages$StyleGuide$Typography$loremIpsum)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Anywhere')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$anywhere)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Pages$StyleGuide$Typography$loremIpsum)
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(12)
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Normal')
                    ]))
                ])),
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$spanSm(1)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$overflowWrap($author$project$Ui$OverflowWrap$normal)
                    ]), _List_fromArray([
                        $elm$html$Html$text($author$project$Pages$StyleGuide$Typography$loremIpsum)
                    ]))
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Typography$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$Typography$viewBody,
            $2: 'Typography'
        };
    };
    var $author$project$Pages$StyleGuide$Typography$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Typography$view);
    var $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$UploadForm$WithSession = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$UploadForm$WithoutSession = {
        $: 1
    };
    var $author$project$Ui$DropdownMenu$Model = $elm$core$Basics$identity;
    var $author$project$Ui$DropdownMenu$init = function(id) {
        return {
            aef: id,
            Vw: false
        };
    };
    var $author$project$Pages$StyleGuide$UploadForm$init = F2(function(shared, _v0) {
        var _v1 = shared.Z$;
        if (_v1.$ === 3) {
            var _v2 = A4($author$project$Components$Upload$Form$init, shared.HO, shared.Ej, 0, $elm$core$Maybe$Nothing);
            var uploadForm = _v2.a;
            var uploadFormCmd = _v2.b;
            return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadForm$WithSession({
                Ej: shared.Ej,
                fl: '',
                l_: $author$project$Ui$DropdownMenu$init('resource-dropdown-menu'),
                Hg: 0,
                HO: shared.HO,
                hd: $elm$core$Maybe$Just(uploadForm)
            }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, uploadFormCmd), _List_Nil);
        } else return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadForm$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$UploadForm$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$UploadForm$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$UploadForm$DropdownMenuMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$DropdownMenu$Close = {
        $: 3
    };
    var $author$project$Ui$DropdownMenu$subscriptions = function(_v0) {
        var model = _v0;
        return A2($author$project$Utils$Dom$onOutsideMouseDown, $author$project$Ui$DropdownMenu$Close, model.aef);
    };
    var $author$project$Pages$StyleGuide$UploadForm$subscriptions = function(model) {
        if (!model.$) {
            var withSessionModel = model.a;
            return $elm$core$Platform$Sub$batch(_List_fromArray([
                A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$UploadForm$DropdownMenuMsg, $author$project$Ui$DropdownMenu$subscriptions(withSessionModel.l_)),
                function() {
                    var _v1 = withSessionModel.hd;
                    if (!_v1.$) {
                        var uploadForm = _v1.a;
                        return A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, $author$project$Components$Upload$Form$subscriptions(uploadForm));
                    } else return $elm$core$Platform$Sub$none;
                }()
            ]));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Ui$DropdownMenu$None = {
        $: 0
    };
    var $author$project$Ui$DropdownMenu$OuterMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$DropdownMenu$outerMsgToEvent = function(maybeOuterMsg) {
        if (!maybeOuterMsg.$) {
            var outerMsg = maybeOuterMsg.a;
            return $author$project$Ui$DropdownMenu$OuterMsg(outerMsg);
        } else return $author$project$Ui$DropdownMenu$None;
    };
    var $author$project$Ui$DropdownMenu$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: !model.Vw
                }), $author$project$Ui$DropdownMenu$None);
            case 1:
                var maybeOuterMsg = msg.a;
                var close = msg.b;
                var event = $author$project$Ui$DropdownMenu$outerMsgToEvent(maybeOuterMsg);
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: !close
                }), event);
            case 2:
                var maybeOuterMsg = msg.a;
                var event = $author$project$Ui$DropdownMenu$outerMsgToEvent(maybeOuterMsg);
                return _Utils_Tuple2(model, event);
            default:
                return _Utils_Tuple2(_Utils_update(model, {
                    Vw: false
                }), $author$project$Ui$DropdownMenu$None);
        }
    });
    var $author$project$Pages$StyleGuide$UploadForm$update = F2(function(msg, model) {
        update: while(true){
            if (model.$ === 1) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            else {
                var modelRecord = model.a;
                switch(msg.$){
                    case 0:
                        var subMsg = msg.a;
                        var _v2 = modelRecord.hd;
                        if (!_v2.$) {
                            var uploadForm = _v2.a;
                            var _v3 = A3($author$project$Components$Upload$Form$update, modelRecord.Ej, subMsg, uploadForm);
                            var uploadForm_ = _v3.a;
                            var subCmd = _v3.b;
                            var subOutMsgs = _v3.c;
                            return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadForm$WithSession(_Utils_update(modelRecord, {
                                hd: $elm$core$Maybe$Just(uploadForm_)
                            })), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, subCmd), subOutMsgs);
                        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    case 1:
                        var subMsg = msg.a;
                        var _v4 = A2($author$project$Ui$DropdownMenu$update, subMsg, modelRecord.l_);
                        var dropdownMenu = _v4.a;
                        var dropdownMenuEvent = _v4.b;
                        var modelWithDropdownMenu = $author$project$Pages$StyleGuide$UploadForm$WithSession(_Utils_update(modelRecord, {
                            l_: dropdownMenu
                        }));
                        if (dropdownMenuEvent.$ === 1) {
                            var newMsg = dropdownMenuEvent.a;
                            var $temp$msg = newMsg, $temp$model = modelWithDropdownMenu;
                            msg = $temp$msg;
                            model = $temp$model;
                            continue update;
                        } else return _Utils_Tuple3(modelWithDropdownMenu, $elm$core$Platform$Cmd$none, _List_Nil);
                    default:
                        var resource = msg.a;
                        var _v6 = A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Pages$StyleGuide$UploadForm$UploadFormMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A4($author$project$Components$Upload$Form$init, modelRecord.HO, modelRecord.Ej, resource, $elm$core$Maybe$Nothing)));
                        var uploadForm = _v6.a;
                        var uploadFormCmd = _v6.b;
                        return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadForm$WithSession(_Utils_update(modelRecord, {
                            Hg: resource,
                            hd: uploadForm
                        })), uploadFormCmd, _List_Nil);
                }
            }
        }
    });
    var $author$project$Pages$StyleGuide$UploadForm$ResourceSelected = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$DropdownMenu$Item = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$DropdownMenu$item = F2(function(options, contents) {
        return A2($author$project$Ui$DropdownMenu$Item, options, contents);
    });
    var $author$project$Ui$DropdownMenu$ItemActive = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$DropdownMenu$itemActive = $author$project$Ui$DropdownMenu$ItemActive;
    var $author$project$Ui$DropdownMenu$ItemOnClick = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$DropdownMenu$itemOnClick = $author$project$Ui$DropdownMenu$ItemOnClick;
    var $author$project$Pages$StyleGuide$UploadForm$dropdownMenuItem = F2(function(currentResource, resource) {
        return A2($author$project$Ui$DropdownMenu$item, _List_fromArray([
            $author$project$Ui$DropdownMenu$itemActive(_Utils_eq(currentResource, resource)),
            $author$project$Ui$DropdownMenu$itemOnClick($author$project$Pages$StyleGuide$UploadForm$ResourceSelected(resource))
        ]), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Upload$Resource$toString(resource))
        ]));
    });
    var $author$project$Pages$StyleGuide$UploadForm$dropdownMenuItems = function(resource) {
        return A2($elm$core$List$map, $author$project$Pages$StyleGuide$UploadForm$dropdownMenuItem(resource), _List_fromArray([
            0,
            1,
            2,
            3,
            5
        ]));
    };
    var $author$project$Ui$DropdownMenu$Title = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$DropdownMenu$title = $author$project$Ui$DropdownMenu$Title;
    var $author$project$Ui$DropdownMenu$InputClicked = {
        $: 0
    };
    var $author$project$Ui$DropdownMenu$directionClass = function(direction_) {
        if (!direction_) return 'dropup';
        else return 'dropdown';
    };
    var $author$project$Ui$Button$DropdownToggle = {
        $: 15
    };
    var $author$project$Ui$Button$dropdownToggle = $author$project$Ui$Button$DropdownToggle;
    var $author$project$Ui$DropdownMenu$intToPx = function(pixels) {
        return $elm$core$String$fromInt(pixels) + 'px';
    };
    var $author$project$Ui$DropdownMenu$menuOffsetHorzStyle = function(side_) {
        return 'margin-' + function() {
            if (!side_) return 'right';
            else return 'left';
        }();
    };
    var $author$project$Ui$DropdownMenu$menuOffsetHorzAttr = function(_v0) {
        var side_ = _v0.a;
        var amount = _v0.b;
        return !amount ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$Attributes$style, $author$project$Ui$DropdownMenu$menuOffsetHorzStyle(side_), $author$project$Ui$DropdownMenu$intToPx(amount))
        ]);
    };
    var $author$project$Ui$DropdownMenu$menuOffsetVertStyle = function(dir_) {
        return 'margin-' + function() {
            if (!dir_) return 'bottom';
            else return 'top';
        }();
    };
    var $author$project$Ui$DropdownMenu$menuOffsetVertAttr = function(_v0) {
        var dir_ = _v0.a;
        var amount = _v0.b;
        return !amount ? _List_Nil : _List_fromArray([
            A2($elm$html$Html$Attributes$style, $author$project$Ui$DropdownMenu$menuOffsetVertStyle(dir_), $author$project$Ui$DropdownMenu$intToPx(amount))
        ]);
    };
    var $elm$html$Html$Events$onMouseLeave = function(msg) {
        return A2($elm$html$Html$Events$on, 'mouseleave', $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Ui$DropdownMenu$Caret = 0;
    var $author$project$Ui$DropdownMenu$Down = 1;
    var $author$project$Ui$DropdownMenu$Left = 0;
    var $author$project$Ui$DropdownMenu$Up = 0;
    var $author$project$Ui$DropdownMenu$defaultOptions = {
        vA: 0,
        a1: 1,
        d$: false,
        xO: false,
        FD: false,
        yf: false,
        Tk: false,
        yP: 25,
        y1: _Utils_Tuple2(0, 0),
        y2: _Utils_Tuple2(0, 0),
        y3: '',
        sm: 0,
        CB: 0,
        ahq: 1,
        s5: 0,
        $2: _List_fromArray([
            $elm$html$Html$text('')
        ])
    };
    var $author$project$Ui$DropdownMenu$optionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 2:
                    var string = option.a;
                    return _Utils_update(record, {
                        $2: string
                    });
                case 0:
                    var direction_ = option.a;
                    return _Utils_update(record, {
                        a1: direction_
                    });
                case 1:
                    var side_ = option.a;
                    return _Utils_update(record, {
                        CB: side_
                    });
                case 3:
                    var style_ = option.a;
                    return _Utils_update(record, {
                        s5: style_
                    });
                case 4:
                    var size_ = option.a;
                    return _Utils_update(record, {
                        ahq: size_
                    });
                case 5:
                    var bool = option.a;
                    return _Utils_update(record, {
                        d$: bool
                    });
                case 7:
                    return _Utils_update(record, {
                        FD: true
                    });
                case 6:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Tk: bool
                    });
                case 8:
                    var side_ = option.a;
                    return _Utils_update(record, {
                        sm: side_
                    });
                case 9:
                    return _Utils_update(record, {
                        yf: true
                    });
                case 10:
                    var margin_ = option.a;
                    return _Utils_update(record, {
                        yP: margin_
                    });
                case 11:
                    var arrow_ = option.a;
                    return _Utils_update(record, {
                        vA: arrow_
                    });
                case 12:
                    var side_ = option.a;
                    var amount = option.b;
                    return _Utils_update(record, {
                        y1: _Utils_Tuple2(side_, amount)
                    });
                case 13:
                    var dir_ = option.a;
                    var amount = option.b;
                    return _Utils_update(record, {
                        y2: _Utils_Tuple2(dir_, amount)
                    });
                case 14:
                    var title_ = option.a;
                    return _Utils_update(record, {
                        y3: title_
                    });
                default:
                    return _Utils_update(record, {
                        xO: true
                    });
            }
        }), $author$project$Ui$DropdownMenu$defaultOptions, options);
    };
    var $author$project$Ui$Icon$Rotated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Icon$rotate = $author$project$Ui$Icon$Rotated;
    var $author$project$Ui$DropdownMenu$sideClass = function(side_) {
        if (side_ === 1) return 'dropdown-menu-right';
        else return 'dropdown-menu-left';
    };
    var $author$project$Ui$DropdownMenu$ItemChecked = F2(function(a, b) {
        return {
            $: 2,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$DropdownMenu$checkboxAttributes = function(options) {
        return _List_fromArray([
            $elm$html$Html$Events$onCheck($author$project$Ui$DropdownMenu$ItemChecked(options.afw)),
            $elm$html$Html$Attributes$class('clickable')
        ]);
    };
    var $author$project$Ui$DropdownMenu$defaultCheckboxOptions = {
        afw: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$DropdownMenu$checkboxOptionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            var msg = option;
            return _Utils_update(record, {
                afw: $elm$core$Maybe$Just(msg)
            });
        }), $author$project$Ui$DropdownMenu$defaultCheckboxOptions, options);
    };
    var $author$project$Ui$DropdownMenu$ItemClicked = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$DropdownMenu$itemAttributes = function(options) {
        return $elm$core$List$concat(_List_fromArray([
            options.d$ ? _List_Nil : _List_fromArray([
                $elm$html$Html$Events$onClick(A2($author$project$Ui$DropdownMenu$ItemClicked, options.zU, options.vF)),
                $elm$html$Html$Attributes$class('clickable')
            ]),
            _List_fromArray([
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('active', options.Ir),
                    _Utils_Tuple2('disabled', options.d$)
                ]))
            ])
        ]));
    };
    var $author$project$Ui$DropdownMenu$defaultItemOptions = {
        Ir: false,
        vF: true,
        d$: false,
        zU: $elm$core$Maybe$Nothing
    };
    var $author$project$Ui$DropdownMenu$itemOptionsToRecord = function(options) {
        return A3($elm$core$List$foldl, F2(function(option, record) {
            switch(option.$){
                case 0:
                    var msg = option.a;
                    return _Utils_update(record, {
                        zU: $elm$core$Maybe$Just(msg)
                    });
                case 1:
                    var bool = option.a;
                    return _Utils_update(record, {
                        d$: bool
                    });
                case 2:
                    var bool = option.a;
                    return _Utils_update(record, {
                        Ir: bool
                    });
                default:
                    var bool = option.a;
                    return _Utils_update(record, {
                        vF: bool
                    });
            }
        }), $author$project$Ui$DropdownMenu$defaultItemOptions, options);
    };
    var $author$project$Ui$DropdownMenu$viewItem = function(item_) {
        switch(item_.$){
            case 0:
                var options = item_.a;
                var contents = item_.b;
                var optionsRecord = $author$project$Ui$DropdownMenu$itemOptionsToRecord(options);
                return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('dropdown-menu__item'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'button'), $author$project$Ui$DropdownMenu$itemAttributes(optionsRecord))), _List_fromArray([
                    A2($elm$html$Html$span, _List_Nil, contents)
                ]));
            case 1:
                var contents = item_.a;
                return A2($elm$html$Html$li, _List_fromArray([
                    $elm$html$Html$Attributes$class('dropdown-header')
                ]), contents);
            case 2:
                return A2($elm$html$Html$li, _List_fromArray([
                    A2($elm$html$Html$Attributes$attribute, 'role', 'separator'),
                    $elm$html$Html$Attributes$class('divider')
                ]), _List_Nil);
            case 3:
                var options = item_.a;
                var contents = item_.b;
                var optionsRecord = $author$project$Ui$DropdownMenu$checkboxOptionsToRecord(options);
                return A2($elm$html$Html$li, A2($elm$core$List$cons, $elm$html$Html$Attributes$class('dropdown-menu__item'), A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'role', 'button'), $author$project$Ui$DropdownMenu$checkboxAttributes(optionsRecord))), _List_fromArray([
                    A2($elm$html$Html$span, _List_Nil, contents)
                ]));
            case 4:
                return $author$project$Utils$Html$empty;
            default:
                var externalHref = item_.a;
                var contents = item_.b;
                return A2($elm$html$Html$li, _List_fromArray([
                    $elm$html$Html$Attributes$class('dropdown-menu__item')
                ]), _List_fromArray([
                    A2($elm$html$Html$a, _List_fromArray([
                        $elm$html$Html$Attributes$href(externalHref)
                    ]), contents)
                ]));
        }
    };
    var $author$project$Ui$DropdownMenu$viewMenuTitle = function(title_) {
        return $elm$core$String$length(title_) > 0 ? _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('dropdown-title')
            ]), _List_fromArray([
                $elm$html$Html$text(title_)
            ]))
        ]) : _List_Nil;
    };
    var $author$project$Ui$DropdownMenu$viewDropdownItems = F2(function(title_, items) {
        return _Utils_ap($author$project$Ui$DropdownMenu$viewMenuTitle(title_), A2($elm$core$List$map, $author$project$Ui$DropdownMenu$viewItem, items));
    });
    var $author$project$Ui$DropdownMenu$view = F3(function(options, items, _v0) {
        var model = _v0;
        var optionsRecord = $author$project$Ui$DropdownMenu$optionsToRecord(options);
        var pullClass = function() {
            var _v2 = optionsRecord.sm;
            if (_v2 === 1) return _List_fromArray([
                $author$project$Ui$Pull$toClass(optionsRecord.sm)
            ]);
            else return _List_Nil;
        }();
        var menuOffsetStyleY = $author$project$Ui$DropdownMenu$menuOffsetVertAttr(optionsRecord.y2);
        var menuOffsetStyleX = $author$project$Ui$DropdownMenu$menuOffsetHorzAttr(optionsRecord.y1);
        return A2($elm$html$Html$div, $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                $elm$html$Html$Attributes$class($author$project$Ui$DropdownMenu$directionClass(optionsRecord.a1)),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('open', model.Vw),
                    _Utils_Tuple2('disabled', optionsRecord.d$),
                    _Utils_Tuple2('inline-block', optionsRecord.yf),
                    _Utils_Tuple2('form-control-select', optionsRecord.xO)
                ])),
                $elm$html$Html$Attributes$disabled(optionsRecord.d$),
                $elm$html$Html$Attributes$id(model.aef)
            ]),
            pullClass
        ])), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Open dropdown menu'
            }, _List_fromArray([
                $author$project$Ui$Button$styled(optionsRecord.s5),
                $author$project$Ui$Button$margin(optionsRecord.yP),
                $author$project$Ui$Button$size(optionsRecord.ahq),
                $author$project$Ui$Button$onClick($author$project$Ui$DropdownMenu$InputClicked),
                $author$project$Ui$Button$dropdownToggle,
                $author$project$Ui$Button$fullWidth(optionsRecord.FD),
                $author$project$Ui$Button$loading(optionsRecord.Tk)
            ]), $elm$core$List$concat(_List_fromArray([
                A2($elm$core$List$map, $elm$html$Html$map($elm$core$Basics$never), optionsRecord.$2),
                _List_fromArray([
                    function() {
                        if (optionsRecord.Tk) return $author$project$Utils$Html$empty;
                        else {
                            var _v1 = optionsRecord.vA;
                            switch(_v1){
                                case 0:
                                    return A2($elm$html$Html$span, _List_fromArray([
                                        $elm$html$Html$Attributes$class('form-control-select__caret')
                                    ]), $elm$core$List$singleton(A2($elm$html$Html$b, _List_fromArray([
                                        $elm$html$Html$Attributes$class('caret')
                                    ]), _List_Nil)));
                                case 2:
                                    return A2($elm$html$Html$span, _List_Nil, $elm$core$List$singleton(A2($elm$html$Html$b, _List_fromArray([
                                        $elm$html$Html$Attributes$class('caret')
                                    ]), _List_Nil)));
                                default:
                                    return A2($elm$html$Html$span, _List_fromArray([
                                        $elm$html$Html$Attributes$class('form-control-select__caret')
                                    ]), $elm$core$List$singleton(A2($author$project$Ui$Icon$view, _List_fromArray([
                                        $author$project$Ui$Icon$color('#005377'),
                                        $author$project$Ui$Icon$height('14px'),
                                        $author$project$Ui$Icon$rotate(90)
                                    ]), 12)));
                            }
                        }
                    }()
                ])
            ]))),
            A2($elm$html$Html$ul, $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    $elm$html$Html$Attributes$class('dropdown-menu'),
                    $elm$html$Html$Attributes$class($author$project$Ui$DropdownMenu$sideClass(optionsRecord.CB)),
                    $elm$html$Html$Events$onMouseLeave($author$project$Ui$DropdownMenu$Close)
                ]),
                menuOffsetStyleX,
                menuOffsetStyleY
            ])), A2($author$project$Ui$DropdownMenu$viewDropdownItems, optionsRecord.y3, items))
        ]));
    });
    var $author$project$Pages$StyleGuide$UploadForm$viewBody = function(model) {
        return _List_fromArray([
            function() {
                var _v0 = model.hd;
                if (!_v0.$) {
                    var uploadForm = _v0.a;
                    return A2($elm$html$Html$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, A2($author$project$Components$Upload$Form$modal, model.Ej, uploadForm));
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Upload Form')
            ])),
            A2($elm$html$Html$map, $author$project$Pages$StyleGuide$UploadForm$DropdownMenuMsg, A3($author$project$Ui$DropdownMenu$view, _List_fromArray([
                $author$project$Ui$DropdownMenu$title(_List_fromArray([
                    $elm$html$Html$text($author$project$Api$Upload$Resource$toString(model.Hg))
                ]))
            ]), $author$project$Pages$StyleGuide$UploadForm$dropdownMenuItems(model.Hg), model.l_)),
            $author$project$Utils$Html$empty,
            function() {
                var _v1 = model.hd;
                if (!_v1.$) {
                    var uploadForm = _v1.a;
                    return A2($elm$html$Html$map, $author$project$Pages$StyleGuide$UploadForm$UploadFormMsg, A2($author$project$Components$Upload$Form$view, model.Ej, uploadForm));
                } else return $author$project$Utils$Html$empty;
            }()
        ]);
    };
    var $author$project$Pages$StyleGuide$UploadForm$view = function(model) {
        return {
            fb: function() {
                if (!model.$) {
                    var modelRecord = model.a;
                    return $author$project$Pages$StyleGuide$UploadForm$viewBody(modelRecord);
                } else return _List_fromArray([
                    A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You need to be logged in to view this style guide')
                    ]))
                ]);
            }(),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$UploadForm$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$StyleGuide$UploadForm$init,
        aeR: $author$project$Pages$StyleGuide$UploadForm$load,
        ag3: $author$project$Pages$StyleGuide$UploadForm$save,
        ahE: $author$project$Pages$StyleGuide$UploadForm$subscriptions,
        aaO: $author$project$Pages$StyleGuide$UploadForm$update,
        aid: $author$project$Pages$StyleGuide$UploadForm$view
    });
    var $author$project$Pages$StyleGuide$UploadResult$WithSession = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$UploadResult$WithoutSession = {
        $: 1
    };
    var $author$project$Pages$StyleGuide$UploadResult$init = F2(function(shared, _v0) {
        var _v1 = shared.Z$;
        if (_v1.$ === 3) return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadResult$WithSession({
            Ej: shared.Ej,
            H_: '',
            he: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$none, _List_Nil);
        else return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadResult$WithoutSession, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$UploadResult$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$UploadResult$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$UploadResult$subscriptions = function(model) {
        if (!model.$) {
            var record = model.a;
            return A2($elm$core$Platform$Sub$map, $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg, A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Components$Upload$Result$subscriptions, record.he)));
        } else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$StyleGuide$UploadResult$update = F2(function(msg, model) {
        if (!model.$) {
            var modelRecord = model.a;
            switch(msg.$){
                case 0:
                    var subMsg = msg.a;
                    var _v2 = modelRecord.he;
                    if (!_v2.$) {
                        var uploadResult = _v2.a;
                        var result = A3($author$project$Components$Upload$Result$update, modelRecord.Ej, subMsg, uploadResult);
                        var uploadResult_ = function() {
                            var _v3 = result.adu;
                            if (!_v3) return $elm$core$Maybe$Just(result.zi);
                            else return $elm$core$Maybe$Nothing;
                        }();
                        return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadResult$WithSession(_Utils_update(modelRecord, {
                            he: uploadResult_
                        })), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg, result.EQ), result.at);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 2:
                    var uploadId = msg.a;
                    return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadResult$WithSession(_Utils_update(modelRecord, {
                        H_: uploadId
                    })), $elm$core$Platform$Cmd$none, _List_Nil);
                default:
                    var _v4 = A2($author$project$Components$Upload$Result$init, modelRecord.Ej, modelRecord.H_);
                    var uploadResult = _v4.a;
                    var uploadResultCmd = _v4.b;
                    return _Utils_Tuple3($author$project$Pages$StyleGuide$UploadResult$WithSession(_Utils_update(modelRecord, {
                        he: $elm$core$Maybe$Just(uploadResult)
                    })), A2($elm$core$Platform$Cmd$map, $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg, uploadResultCmd), _List_Nil);
            }
        } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$StyleGuide$UploadResult$UploadIdChanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$StyleGuide$UploadResult$ViewUploadResult = {
        $: 1
    };
    var $author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid = function(uploadId) {
        return $elm$core$String$isEmpty(uploadId) || !A2($elm$core$String$startsWith, 'upl-', uploadId);
    };
    var $author$project$Pages$StyleGuide$UploadResult$uploadIdErrors = function(email) {
        return $author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid(email) ? _List_fromArray([
            'Please enter a valid upload id.'
        ]) : _List_Nil;
    };
    var $author$project$Pages$StyleGuide$UploadResult$viewBody = function(model) {
        return _List_fromArray([
            function() {
                var _v0 = model.he;
                if (!_v0.$) {
                    var uploadResult = _v0.a;
                    return A2($elm$html$Html$map, $author$project$Pages$StyleGuide$UploadResult$UploadResultMsg, A2($author$project$Components$Upload$Result$modal, model.Ej, uploadResult));
                } else return $author$project$Utils$Html$empty;
            }(),
            $author$project$Ui$Typography$headingLg(_List_fromArray([
                $elm$html$Html$text('Upload > Result')
            ])),
            A2($author$project$Ui$Form$view, _List_fromArray([
                $author$project$Ui$Form$horizontal
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Upload Id'),
                    $author$project$Ui$Form$Group$required(true),
                    $author$project$Ui$Form$Group$labelSpanSm(2),
                    $author$project$Ui$Form$Group$inputSpanSm(4)
                ]), _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$value(model.H_),
                        $author$project$Ui$Form$Input$invalid($author$project$Pages$StyleGuide$UploadResult$uploadIdInvalid(model.H_)),
                        $author$project$Ui$Form$Input$errors($author$project$Pages$StyleGuide$UploadResult$uploadIdErrors(model.H_)),
                        $author$project$Ui$Form$Input$onInput($author$project$Pages$StyleGuide$UploadResult$UploadIdChanged)
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'View result'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$onClick($author$project$Pages$StyleGuide$UploadResult$ViewUploadResult)
                    ]), _List_fromArray([
                        $elm$html$Html$text('View result')
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$StyleGuide$UploadResult$view = function(model) {
        return {
            fb: function() {
                if (!model.$) {
                    var modelRecord = model.a;
                    return $author$project$Pages$StyleGuide$UploadResult$viewBody(modelRecord);
                } else return _List_fromArray([
                    A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('You need to be logged in to view this style guide')
                    ]))
                ]);
            }(),
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$UploadResult$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$StyleGuide$UploadResult$init,
        aeR: $author$project$Pages$StyleGuide$UploadResult$load,
        ag3: $author$project$Pages$StyleGuide$UploadResult$save,
        ahE: $author$project$Pages$StyleGuide$UploadResult$subscriptions,
        aaO: $author$project$Pages$StyleGuide$UploadResult$update,
        aid: $author$project$Pages$StyleGuide$UploadResult$view
    });
    var $author$project$Ui$Well$large = $author$project$Ui$Well$Size(3);
    var $author$project$Pages$StyleGuide$Well$viewWell = _List_fromArray([
        $author$project$Ui$Typography$headingLg(_List_fromArray([
            $elm$html$Html$text('Well')
        ])),
        $author$project$Ui$Typography$heading(_List_fromArray([
            $elm$html$Html$text('Styles')
        ])),
        A2($author$project$Ui$Well$view, _List_Nil, _List_fromArray([
            $elm$html$Html$text('default')
        ])),
        A2($author$project$Ui$Well$view, _List_fromArray([
            $author$project$Ui$Well$small
        ]), _List_fromArray([
            $elm$html$Html$text('small')
        ])),
        A2($author$project$Ui$Well$view, _List_fromArray([
            $author$project$Ui$Well$large
        ]), _List_fromArray([
            $elm$html$Html$text('large')
        ])),
        A2($author$project$Ui$Well$view, _List_fromArray([
            $author$project$Ui$Well$signin
        ]), _List_fromArray([
            $elm$html$Html$text('signin')
        ]))
    ]);
    var $author$project$Pages$StyleGuide$Well$view = function(_v0) {
        return {
            fb: $author$project$Pages$StyleGuide$Well$viewWell,
            $2: 'Style Guide'
        };
    };
    var $author$project$Pages$StyleGuide$Well$page = $author$project$Spa$Page$static($author$project$Pages$StyleGuide$Well$view);
    var $author$project$Pages$Support$CannySso$GotCannyJwt = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Support$CannySso$CannyJwtResponse = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Support$CannySso$Record = function(cannyJwt) {
        return {
            KX: cannyJwt
        };
    };
    var $author$project$Api$Provider$Support$CannySso$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'canny_jwt', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Support$CannySso$Record)));
    var $author$project$Api$Provider$Support$CannySso$createToken = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Provider$Support$CannySso$decoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'user',
            'canny_jwt'
        ]), $author$project$Api$Data$platformPath)));
    });
    var $author$project$Pages$Support$CannySso$init = F3(function(_v0, _v1, _v2) {
        var apiClient = _v1.Ej;
        var flags = _v1.adU;
        return _Utils_Tuple2({
            Ej: apiClient,
            acc: flags.acc,
            KX: $author$project$Api$Data$NotAsked
        }, A2($author$project$Api$Provider$Support$CannySso$createToken, apiClient, $elm$core$Basics$identity));
    });
    var $author$project$Pages$Support$CannySso$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Support$CannySso$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Support$CannySso$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $elm$url$Url$Builder$absolute = F2(function(pathSegments, parameters) {
        return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
    });
    var $author$project$Api$Provider$Support$CannySso$cannyJwt = function(_v0) {
        var record = _v0;
        return record.KX;
    };
    var $elm$browser$Browser$Navigation$load = _Browser_load;
    var $author$project$Pages$Support$CannySso$update = F2(function(msg, model) {
        var response = msg;
        if (response.$ === 3) {
            var jwt = response.a;
            var urlParam = A2($elm$core$Maybe$withDefault, _List_Nil, A2($elm$core$Maybe$map, function(param) {
                return _List_fromArray([
                    param
                ]);
            }, A2($elm$core$Maybe$map, $elm$url$Url$Builder$string('companyID'), model.acc)));
            var redirectUrl = 'https://feedback.hint.com/feature-requests';
            var urlWithJwt = A2($elm$core$String$append, 'https://canny.io', A2($elm$url$Url$Builder$absolute, _List_fromArray([
                'api',
                'redirects',
                'sso'
            ]), A2($elm$core$List$cons, A2($elm$url$Url$Builder$string, 'ssoToken', $author$project$Api$Provider$Support$CannySso$cannyJwt(jwt)), A2($elm$core$List$cons, A2($elm$url$Url$Builder$string, 'redirect', redirectUrl), urlParam))));
            return _Utils_Tuple3(_Utils_update(model, {
                KX: response
            }), $elm$browser$Browser$Navigation$load(urlWithJwt), _List_Nil);
        } else return _Utils_Tuple3(_Utils_update(model, {
            KX: response
        }), $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Support$CannySso$view = function(_v0) {
        return {
            fb: $author$project$Components$LoadingPage$view,
            $2: 'Support'
        };
    };
    var $author$project$Pages$Support$CannySso$page = $author$project$Spa$Page$applicationPrivate({
        aeq: $author$project$Pages$Support$CannySso$init,
        aeR: $author$project$Pages$Support$CannySso$load,
        ag3: $author$project$Pages$Support$CannySso$save,
        ahE: $author$project$Pages$Support$CannySso$subscriptions,
        aaO: $author$project$Pages$Support$CannySso$update,
        aid: $author$project$Pages$Support$CannySso$view
    });
    var $author$project$Pages$Tasks$New$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Tasks$New$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Tasks$New$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Tasks$New$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'New Task'
        };
    };
    var $author$project$Pages$Tasks$New$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Tasks$New$init,
        aeR: $author$project$Pages$Tasks$New$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Tasks$New$update,
        aid: $author$project$Pages$Tasks$New$view
    });
    var $author$project$Pages$Tasks$TasksId_String$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Tasks$TasksId_String$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Tasks$TasksId_String$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Tasks$TasksId_String$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Task'
        };
    };
    var $author$project$Pages$Tasks$TasksId_String$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Tasks$TasksId_String$Top$init,
        aeR: $author$project$Pages$Tasks$TasksId_String$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Tasks$TasksId_String$Top$update,
        aid: $author$project$Pages$Tasks$TasksId_String$Top$view
    });
    var $author$project$Pages$Tasks$Top$init = F4(function(_v0, _v1, shared, url) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            aaT: url
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Tasks$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$Tasks$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Tasks$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: 'Tasks'
        };
    };
    var $author$project$Pages$Tasks$Top$page = $author$project$Spa$Page$applicationPractice({
        aeq: $author$project$Pages$Tasks$Top$init,
        aeR: $author$project$Pages$Tasks$Top$load,
        ag3: $elm$core$Basics$always($elm$core$Basics$identity),
        ahE: function(_v0) {
            return $elm$core$Platform$Sub$none;
        },
        aaO: $author$project$Pages$Tasks$Top$update,
        aid: $author$project$Pages$Tasks$Top$view
    });
    var $author$project$Pages$Top$init = F2(function(_v0, _v1) {
        return _Utils_Tuple3({}, A2($author$project$Ports$Navigation$pushRoute, _List_Nil, $author$project$Spa$Generated$Route$Login), _List_Nil);
    });
    var $author$project$Pages$Top$load = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$Top$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Pages$Top$update = F2(function(_v0, model) {
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Pages$Top$view = function(_v0) {
        return {
            fb: _List_Nil,
            $2: ''
        };
    };
    var $author$project$Pages$Top$page = $author$project$Spa$Page$application({
        aeq: $author$project$Pages$Top$init,
        aeR: $author$project$Pages$Top$load,
        ag3: $author$project$Pages$Top$save,
        ahE: $author$project$Pages$Top$subscriptions,
        aaO: $author$project$Pages$Top$update,
        aid: $author$project$Pages$Top$view
    });
    var $author$project$Spa$Page$applicationUser = function(page) {
        return {
            aeq: F2(function(shared, url) {
                var _v0 = _Utils_Tuple2(shared.Z$, shared.aaX);
                _v0$3: while(true){
                    _v0$4: while(true)switch(_v0.a.$){
                        case 3:
                            switch(_v0.b.$){
                                case 3:
                                    var _v1 = _v0.a;
                                    var session = _v1.a;
                                    var _v2 = _v0.b;
                                    var user = _v2.a;
                                    return !A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT) ? _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil) : A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A4(page.aeq, session, user, shared, url)));
                                case 2:
                                    break _v0$3;
                                default:
                                    break _v0$4;
                            }
                        case 0:
                            var _v3 = _v0.a;
                            return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $author$project$Ports$Session$authorize({
                                agy: true
                            }), _List_Nil);
                        case 2:
                            return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                        default:
                            if (_v0.b.$ === 2) break _v0$3;
                            else break _v0$4;
                    }
                    return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aeR: F2(function(shared, model) {
                var _v4 = _Utils_Tuple2(shared.Z$, shared.aaX);
                _v4$2: while(true){
                    _v4$3: while(true)switch(_v4.a.$){
                        case 3:
                            switch(_v4.b.$){
                                case 3:
                                    var _v5 = _v4.a;
                                    var session = _v5.a;
                                    var _v6 = _v4.b;
                                    var user = _v6.a;
                                    switch(model.$){
                                        case 0:
                                            var url = model.a;
                                            if (!A3($author$project$Spa$Page$authorizeUrl, session, shared.aeb, shared.aaT)) return _Utils_Tuple3($author$project$Spa$Page$SessionLoading(url), A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, shared.aeb)), _List_Nil);
                                            else {
                                                var _v8 = A4(page.aeq, session, user, shared, url);
                                                var pageModel = _v8.a;
                                                var cmd = _v8.b;
                                                return _Utils_Tuple3($author$project$Spa$Page$SessionLoaded(pageModel), cmd, _List_Nil);
                                            }
                                        case 1:
                                            var modelWithSession = model.a;
                                            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aeR, shared, _Utils_update(modelWithSession, {
                                                Ej: shared.Ej
                                            }))));
                                        default:
                                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                                    }
                                case 2:
                                    break _v4$2;
                                default:
                                    break _v4$3;
                            }
                        case 2:
                            return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
                        default:
                            if (_v4.b.$ === 2) break _v4$2;
                            else break _v4$3;
                    }
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
                return _Utils_Tuple3($author$project$Spa$Page$SessionFailed, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            ag3: F2(function(model, shared) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2(page.ag3, modelWithSession, shared);
                } else return shared;
            }),
            ahE: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.ahE(modelWithSession);
                } else return $elm$core$Platform$Sub$none;
            },
            aaO: F2(function(msg, model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Page$SessionLoaded, A2(page.aaO, msg, modelWithSession));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            }),
            aid: function(model) {
                if (model.$ === 1) {
                    var modelWithSession = model.a;
                    return page.aid(modelWithSession);
                } else return {
                    fb: $author$project$Components$BlankPage$view,
                    $2: 'Loading...'
                };
            }
        };
    };
    var $author$project$Api$Platform$User$Shared$termsAccepted = function(_v0) {
        var record = _v0;
        return record.HM;
    };
    var $author$project$Api$Platform$User$One$termsAccepted = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$termsAccepted(shared);
    };
    var $author$project$Pages$User$AcceptTerms$initFormFields = function(user) {
        return {
            HM: $author$project$Api$Platform$User$One$termsAccepted(user)
        };
    };
    var $author$project$Pages$User$AcceptTerms$init = F4(function(session, user, shared, _v0) {
        return _Utils_Tuple2({
            Ej: shared.Ej,
            PU: $author$project$Utils$Form$init($author$project$Pages$User$AcceptTerms$initFormFields(user)),
            j_: $author$project$Api$Data$NotAsked,
            Z$: session,
            aaX: user
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$User$AcceptTerms$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$User$AcceptTerms$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$User$AcceptTerms$Close = {
        $: 0
    };
    var $author$project$Pages$User$AcceptTerms$subscriptions = function(_v0) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Pages$User$AcceptTerms$Close);
    };
    var $author$project$Pages$User$AcceptTerms$formFieldsUpdate = F2(function(field, fields) {
        var bool = field;
        return _Utils_update(fields, {
            HM: bool
        });
    });
    var $author$project$Pages$User$AcceptTerms$TermsAcceptedValidation = 0;
    var $author$project$Pages$User$AcceptTerms$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifFalse, function($) {
            return $.HM;
        }, _Utils_Tuple2(0, 'Please accept our terms.'))
    ]));
    var $author$project$Pages$User$AcceptTerms$UserUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$Platform$User$updateTermsAcceptance = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('user', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('terms_accepted', $elm$json$Json$Encode$bool(fields.HM))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Platform$User$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
    });
    var $author$project$Pages$User$AcceptTerms$updateUser = F2(function(apiClient, formFields) {
        return A3($author$project$Api$Platform$User$updateTermsAcceptance, apiClient, $rtfeldman$elm_validate$Validate$fromValid(formFields), $author$project$Pages$User$AcceptTerms$UserUpdated);
    });
    var $author$project$Pages$User$AcceptTerms$update = F2(function(msg, model) {
        switch(msg.$){
            case 1:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$User$AcceptTerms$formFieldsUpdate, field, model.PU);
                var validatedForm = function() {
                    var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$AcceptTerms$formFieldsValidator, newForm);
                    if (!_v1.$) {
                        var _v2 = _v1.a;
                        var form = _v2.a;
                        return form;
                    } else {
                        var form = _v1.a;
                        return form;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: validatedForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$AcceptTerms$formFieldsValidator, model.PU);
                if (!_v3.$) {
                    var _v4 = _v3.a;
                    var newForm = _v4.a;
                    var validFormFields = _v4.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), A2($author$project$Pages$User$AcceptTerms$updateUser, model.Ej, validFormFields), _List_Nil);
                } else {
                    var newForm = _v3.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 3:
                var response = msg.a;
                if (response.$ === 3) {
                    var _v6 = function() {
                        var _v7 = $author$project$Api$Platform$Session$One$organization(model.Z$);
                        if (!_v7.$) {
                            var organization = _v7.a;
                            return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
                                A3($author$project$OutMsg$SwitchToOrganization, $author$project$Api$Platform$Organization$Shared$id(organization), $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToDefaultStateAction)
                            ]));
                        } else return _Utils_Tuple2(A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$User__Organizations__Top), _List_Nil);
                    }();
                    var cmd = _v6.a;
                    var outMsgs = _v6.b;
                    return _Utils_Tuple3(model, cmd, _Utils_ap(outMsgs, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your profile has been updated')
                    ])));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$User$AcceptTerms$UpdateUser = {
        $: 2
    };
    var $author$project$Ui$Modal$Dismissible = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Modal$dismissible = $author$project$Ui$Modal$Dismissible;
    var $author$project$Pages$User$AcceptTerms$FormFieldUpdated = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$User$AcceptTerms$TermsAccepted = $elm$core$Basics$identity;
    var $author$project$Pages$User$AcceptTerms$viewAcceptTerms = F2(function(user, form) {
        if ($author$project$Api$Platform$User$One$termsAccepted(user)) return _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Icon$check(_List_fromArray([
                    $author$project$Ui$Icon$success
                ])),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text(' You agreed to this software platform\'s')
                ])),
                A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$termsUrl, _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text(' Terms of Service.')
                ]))
            ]))
        ]);
        else {
            var _v0 = $author$project$Utils$Form$fields(form);
            var termsAccepted = _v0.HM;
            return _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(termsAccepted),
                        $author$project$Ui$Form$Checkbox$required(true),
                        $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$User$AcceptTerms$FormFieldUpdated, $elm$core$Basics$identity))
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('I agree to this software platform\'s'),
                            A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$termsUrl, _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text(' Terms of Service.')
                            ]))
                        ]))
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 0, form))
                ]))
            ]);
        }
    });
    var $author$project$Pages$User$AcceptTerms$view = function(model) {
        return {
            fb: _List_fromArray([
                A3($author$project$Ui$Modal$view, $author$project$Pages$User$AcceptTerms$Close, _List_fromArray([
                    $author$project$Ui$Modal$dismissible(false)
                ]), _List_fromArray([
                    $author$project$Ui$Modal$header(_List_fromArray([
                        $author$project$Ui$Modal$title('Protect Your Patients\' Privacy')
                    ])),
                    $author$project$Ui$Modal$body(_List_fromArray([
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('This platform has instituted more rigorous safeguards, policies, and procedures in accordance with the HIPAA and HITECH final rule. To help better protect your patients\' privacy, please change your password.')
                            ]))
                        ])),
                        A2($author$project$Ui$Form$Group$view, _List_fromArray([
                            $author$project$Ui$Form$Group$label('')
                        ]), A2($author$project$Pages$User$AcceptTerms$viewAcceptTerms, model.aaX, model.PU)),
                        $author$project$Ui$Clearfix$view
                    ])),
                    $author$project$Ui$Modal$footer(_List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Update terms'
                        }, _List_fromArray([
                            $author$project$Ui$Button$primary,
                            $author$project$Ui$Button$submit,
                            $author$project$Ui$Button$onClick($author$project$Pages$User$AcceptTerms$UpdateUser),
                            $author$project$Ui$Button$loading(_Utils_eq(model.j_, $author$project$Api$Data$Loading))
                        ]), _List_fromArray([
                            $elm$html$Html$text('Update')
                        ]))
                    ]))
                ]))
            ]),
            $2: 'Patients'
        };
    };
    var $author$project$Pages$User$AcceptTerms$page = $author$project$Spa$Page$applicationUser({
        aeq: $author$project$Pages$User$AcceptTerms$init,
        aeR: $author$project$Pages$User$AcceptTerms$load,
        ag3: $author$project$Pages$User$AcceptTerms$save,
        ahE: $author$project$Pages$User$AcceptTerms$subscriptions,
        aaO: $author$project$Pages$User$AcceptTerms$update,
        aid: $author$project$Pages$User$AcceptTerms$view
    });
    var $author$project$Pages$User$Mfa$GotMfa = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$User$Mfa$Qr = 0;
    var $author$project$Api$Platform$User$One$requiresMfa = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$requiresMfa(shared);
    };
    var $author$project$Api$Platform$Mfa$One$Mfa = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Mfa$One$Record = F5(function(accountName, otpSecretKey, qrcodeUrl, qrcode, status) {
        return {
            Il: accountName,
            VH: otpSecretKey,
            XQ: qrcode,
            XR: qrcodeUrl,
            ahy: status
        };
    });
    var $author$project$Api$Platform$Mfa$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $author$project$Api$Platform$Mfa$Status$decode, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'qrcode', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'qrcode_url', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'otp_secret_key', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'account_name', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Mfa$One$Record))))));
    var $author$project$Api$Platform$Mfa$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Mfa$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Mfa$mfaPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'mfa'
    ]), $author$project$Api$Data$platformPath);
    var $author$project$Api$Platform$Mfa$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Platform$Mfa$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
    });
    var $author$project$Pages$User$Mfa$initFromSessionAndUser = F3(function(apiClient, user, requiresMfaPrerequisite) {
        return _Utils_Tuple2({
            kS: $author$project$Api$Data$NotAsked,
            Ej: apiClient,
            qh: $elm$core$Maybe$Nothing,
            Gk: 0,
            f9: $author$project$Api$Data$Loading,
            rO: '',
            YL: $author$project$Api$Platform$User$One$requiresMfa(user),
            He: requiresMfaPrerequisite
        }, A2($author$project$Api$Platform$Mfa$retrieve, apiClient, $author$project$Pages$User$Mfa$GotMfa));
    });
    var $author$project$Pages$User$Mfa$init = F4(function(_v0, user, _v1, _v2) {
        var apiClient = _v1.Ej;
        var query = _v2.Bz;
        var requiresMfaPrerequisite = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $elm$core$Basics$eq('true'), A2($elm$core$Dict$get, 'requiresMfaPrerequisite', query)));
        return A3($author$project$Pages$User$Mfa$initFromSessionAndUser, apiClient, user, requiresMfaPrerequisite);
    });
    var $author$project$Pages$User$Mfa$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$User$Mfa$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$User$Mfa$QRDecoderMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ports$QRDecoder$onDecodePort = _Platform_incomingPort('onDecodePort', $elm$json$Json$Decode$string);
    var $author$project$Ports$QRDecoder$onDecode = $author$project$Ports$QRDecoder$onDecodePort;
    var $author$project$Pages$User$Mfa$subscriptions = function(_v0) {
        return $author$project$Ports$QRDecoder$onDecode($author$project$Pages$User$Mfa$QRDecoderMsg);
    };
    var $author$project$Pages$User$Mfa$GotActivatingMfa = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$User$Mfa$Logout = {
        $: 4
    };
    var $author$project$Pages$User$Mfa$Manual = 1;
    var $author$project$Api$Platform$Mfa$activateMfaPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'activate'
    ]), $author$project$Api$Platform$Mfa$mfaPath);
    var $author$project$Api$Platform$Mfa$activate = F4(function(apiClient, otpCode, qrCodeUrl, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('otp_code', $elm$json$Json$Encode$string(otpCode)),
            _Utils_Tuple2('qrcode_url', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, qrCodeUrl))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$Mfa$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$activateMfaPath)));
    });
    var $author$project$Api$Platform$Mfa$create = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$Mfa$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
    });
    var $author$project$Ports$QRDecoder$decodePort = _Platform_outgoingPort('decodePort', $elm$json$Json$Encode$string);
    var $author$project$Ports$QRDecoder$decode = function(base64) {
        return $author$project$Ports$QRDecoder$decodePort(base64);
    };
    var $author$project$Api$Platform$Mfa$One$qrcode = function(_v0) {
        var record = _v0;
        return record.XQ;
    };
    var $author$project$Api$Platform$Mfa$One$qrcodeUrl = function(_v0) {
        var record = _v0;
        return record.XR;
    };
    var $author$project$Api$Platform$Mfa$update = F3(function(apiClient, qrCodeUrl, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('qrcode_url', $elm$json$Json$Encode$string(qrCodeUrl))
        ]));
        return A4($author$project$Api$Data$put, apiClient, $author$project$Api$Platform$Mfa$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath)));
    });
    var $author$project$Pages$User$Mfa$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var dataMfa = msg.a;
                _v1$2: while(true)switch(dataMfa.$){
                    case 3:
                        var mfa = dataMfa.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            qh: $elm$core$Maybe$Just($author$project$Api$Platform$Mfa$One$qrcodeUrl(mfa)),
                            f9: dataMfa
                        }), A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, $author$project$Ports$QRDecoder$decode, $author$project$Api$Platform$Mfa$One$qrcode(mfa))), _List_Nil);
                    case 2:
                        if (dataMfa.a.$ === 5) {
                            var _v2 = dataMfa.a;
                            return _Utils_Tuple3(_Utils_update(model, {
                                f9: dataMfa
                            }), A2($author$project$Api$Platform$Mfa$create, model.Ej, $author$project$Pages$User$Mfa$GotMfa), _List_Nil);
                        } else break _v1$2;
                    default:
                        break _v1$2;
                }
                return _Utils_Tuple3(_Utils_update(model, {
                    f9: dataMfa
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(dataMfa));
            case 1:
                return _Utils_Tuple3(_Utils_update(model, {
                    Gk: 1
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var code = msg.a;
                var _v3 = $elm$core$String$length(code) === 6 ? _Utils_Tuple2(_Utils_update(model, {
                    kS: $author$project$Api$Data$Loading
                }), A4($author$project$Api$Platform$Mfa$activate, model.Ej, code, model.qh, $author$project$Pages$User$Mfa$GotActivatingMfa)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    rO: code
                }), cmd, _List_Nil);
            case 3:
                var dataMfa = msg.a;
                switch(dataMfa.$){
                    case 3:
                        return _Utils_Tuple3(_Utils_update(model, {
                            kS: dataMfa,
                            f9: dataMfa
                        }), A2($elm$core$Task$perform, function(_v5) {
                            return $author$project$Pages$User$Mfa$Logout;
                        }, $elm$core$Process$sleep(5000)), _List_Nil);
                    case 2:
                        return _Utils_Tuple3(_Utils_update(model, {
                            kS: dataMfa,
                            rO: ''
                        }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataMfa));
                    default:
                        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 4:
                return _Utils_Tuple3(model, $author$project$Ports$Session$logout({
                    agy: true
                }), _List_Nil);
            default:
                var qrCode = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    qh: $elm$core$Maybe$Just(qrCode)
                }), A3($author$project$Api$Platform$Mfa$update, model.Ej, qrCode, $author$project$Pages$User$Mfa$GotMfa), _List_Nil);
        }
    });
    var $author$project$Api$Platform$Mfa$One$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Pages$User$Mfa$OtpCodeChanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$User$Mfa$viewActivate = F2(function(otpCode, activatingMfa) {
        var loading = function() {
            if (activatingMfa.$ === 1) return true;
            else return false;
        }();
        return _List_fromArray([
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Enter the 6 digit code from your phone bellow')
                ])),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$disabled(loading),
                            $author$project$Ui$Form$Input$value(otpCode),
                            $author$project$Ui$Form$Input$autofocus(true),
                            $author$project$Ui$Form$Input$onInput($author$project$Pages$User$Mfa$OtpCodeChanged)
                        ])),
                        loading ? $author$project$Ui$Spinner$view(_List_Nil) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Api$Platform$Mfa$One$accountName = function(_v0) {
        var record = _v0;
        return record.Il;
    };
    var $author$project$Api$Platform$Mfa$One$otpSecretKey = function(_v0) {
        var record = _v0;
        return record.VH;
    };
    var $author$project$Pages$User$Mfa$viewManualSteps = function(mfa) {
        return _List_fromArray([
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Select the '),
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Enter a provided key')
                ])),
                $elm$html$Html$text(' option')
            ])),
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Enter the following information')
                ])),
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Account name: '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Platform$Mfa$One$accountName(mfa))
                    ])),
                    A2($elm$html$Html$br, _List_Nil, _List_Nil),
                    $elm$html$Html$text('Key: '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Platform$Mfa$One$otpSecretKey(mfa))
                    ]))
                ]))
            ])),
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Tap '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Add')
                    ]))
                ]))
            ]))
        ]);
    };
    var $pablohirafuji$elm_qrcode$QRCode$Quartile = 2;
    var $author$project$Pages$User$Mfa$SwitchToManual = {
        $: 1
    };
    var $pablohirafuji$elm_qrcode$QRCode$QRCode = $elm$core$Basics$identity;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex = F3(function(size, row, col) {
        return size * row + col;
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy = F4(function(row, col, size, matrix) {
        var _v0 = A2($elm$core$Array$get, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col), matrix);
        if (!_v0.$ && !_v0.a.$) return true;
        else return false;
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule = function(placement) {
        var row = placement.n4;
        var col = placement.Ln;
        var isRight = placement.ec;
        var isUp = placement.rb;
        return isRight ? _Utils_update(placement, {
            Ln: col - 1,
            ec: false
        }) : isUp ? _Utils_update(placement, {
            Ln: col + 1,
            ec: true,
            n4: row - 1
        }) : _Utils_update(placement, {
            Ln: col + 1,
            ec: true,
            n4: row + 1
        });
    };
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor = F2(function(_byte, offset) {
        return (1 & _byte >> 7 - offset) === 1;
    });
    var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
    var $elm$core$Array$setHelp = F4(function(shift, index, value, tree) {
        var pos = $elm$core$Array$bitMask & index >>> shift;
        var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
        if (!_v0.$) {
            var subTree = _v0.a;
            var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
            return A3($elm$core$Elm$JsArray$unsafeSet, pos, $elm$core$Array$SubTree(newSub), tree);
        } else {
            var values = _v0.a;
            var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
            return A3($elm$core$Elm$JsArray$unsafeSet, pos, $elm$core$Array$Leaf(newLeaf), tree);
        }
    });
    var $elm$core$Array$set = F3(function(index, value, array) {
        var len = array.a;
        var startShift = array.b;
        var tree = array.c;
        var tail = array.d;
        return index < 0 || _Utils_cmp(index, len) > -1 ? array : _Utils_cmp(index, $elm$core$Array$tailIndex(len)) > -1 ? A4($elm$core$Array$Array_elm_builtin, len, startShift, tree, A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4($elm$core$Array$Array_elm_builtin, len, startShift, A4($elm$core$Array$setHelp, startShift, index, value, tree), tail);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule = F3(function(_v0, _byte, offset) {
        var size = _v0.ahq;
        var row = _v0.n4;
        var col = _v0.Ln;
        return A2($elm$core$Array$set, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col), $elm$core$Maybe$Just(_Utils_Tuple2(false, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$bitToColor, _byte, offset))));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule = F4(function(placement, bytes, offset, matrix) {
        addDataModule: while(true){
            var size = placement.ahq;
            var row = placement.n4;
            var col = placement.Ln;
            if (!bytes.b) return matrix;
            else {
                var head = bytes.a;
                var tail = bytes.b;
                if (offset >= 8) {
                    var $temp$placement = placement, $temp$bytes = tail, $temp$offset = 0, $temp$matrix = matrix;
                    placement = $temp$placement;
                    bytes = $temp$bytes;
                    offset = $temp$offset;
                    matrix = $temp$matrix;
                    continue addDataModule;
                } else {
                    if (col === 6) {
                        var $temp$placement = _Utils_update(placement, {
                            Ln: col - 1,
                            ec: true
                        }), $temp$bytes = bytes, $temp$offset = offset, $temp$matrix = matrix;
                        placement = $temp$placement;
                        bytes = $temp$bytes;
                        offset = $temp$offset;
                        matrix = $temp$matrix;
                        continue addDataModule;
                    } else if (row < 0) {
                        var $temp$placement = _Utils_update(placement, {
                            Ln: col - 2,
                            ec: true,
                            rb: false,
                            n4: 0
                        }), $temp$bytes = bytes, $temp$offset = offset, $temp$matrix = matrix;
                        placement = $temp$placement;
                        bytes = $temp$bytes;
                        offset = $temp$offset;
                        matrix = $temp$matrix;
                        continue addDataModule;
                    } else {
                        if (_Utils_cmp(row, size) > -1) {
                            var $temp$placement = _Utils_update(placement, {
                                Ln: col - 2,
                                ec: true,
                                rb: true,
                                n4: size - 1
                            }), $temp$bytes = bytes, $temp$offset = offset, $temp$matrix = matrix;
                            placement = $temp$placement;
                            bytes = $temp$bytes;
                            offset = $temp$offset;
                            matrix = $temp$matrix;
                            continue addDataModule;
                        } else if (A4($pablohirafuji$elm_qrcode$QRCode$Matrix$isOccupy, row, col, size, matrix)) {
                            var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement), $temp$bytes = bytes, $temp$offset = offset, $temp$matrix = matrix;
                            placement = $temp$placement;
                            bytes = $temp$bytes;
                            offset = $temp$offset;
                            matrix = $temp$matrix;
                            continue addDataModule;
                        } else {
                            var $temp$placement = $pablohirafuji$elm_qrcode$QRCode$Matrix$nextModule(placement), $temp$bytes = bytes, $temp$offset = offset + 1, $temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setDataModule, placement, head, offset, matrix);
                            placement = $temp$placement;
                            bytes = $temp$bytes;
                            offset = $temp$offset;
                            matrix = $temp$matrix;
                            continue addDataModule;
                        }
                    }
                }
            }
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement = function(size) {
        return {
            Ln: size + 1,
            ec: true,
            rb: true,
            n4: size + 1,
            ahq: size
        };
    };
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$addData = F3(function(size, bytes, matrix) {
        return A4($pablohirafuji$elm_qrcode$QRCode$Matrix$addDataModule, $pablohirafuji$elm_qrcode$QRCode$Matrix$initPlacement(size), bytes, 0, matrix);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound = {
        $: 0
    };
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData = $elm$core$Array$fromList(_List_fromArray([
        _List_Nil,
        _List_fromArray([
            6,
            18
        ]),
        _List_fromArray([
            6,
            22
        ]),
        _List_fromArray([
            6,
            26
        ]),
        _List_fromArray([
            6,
            30
        ]),
        _List_fromArray([
            6,
            34
        ]),
        _List_fromArray([
            6,
            22,
            38
        ]),
        _List_fromArray([
            6,
            24,
            42
        ]),
        _List_fromArray([
            6,
            26,
            46
        ]),
        _List_fromArray([
            6,
            28,
            50
        ]),
        _List_fromArray([
            6,
            30,
            54
        ]),
        _List_fromArray([
            6,
            32,
            58
        ]),
        _List_fromArray([
            6,
            34,
            62
        ]),
        _List_fromArray([
            6,
            26,
            46,
            66
        ]),
        _List_fromArray([
            6,
            26,
            48,
            70
        ]),
        _List_fromArray([
            6,
            26,
            50,
            74
        ]),
        _List_fromArray([
            6,
            30,
            54,
            78
        ]),
        _List_fromArray([
            6,
            30,
            56,
            82
        ]),
        _List_fromArray([
            6,
            30,
            58,
            86
        ]),
        _List_fromArray([
            6,
            34,
            62,
            90
        ]),
        _List_fromArray([
            6,
            28,
            50,
            72,
            94
        ]),
        _List_fromArray([
            6,
            26,
            50,
            74,
            98
        ]),
        _List_fromArray([
            6,
            30,
            54,
            78,
            102
        ]),
        _List_fromArray([
            6,
            28,
            54,
            80,
            106
        ]),
        _List_fromArray([
            6,
            32,
            58,
            84,
            110
        ]),
        _List_fromArray([
            6,
            30,
            58,
            86,
            114
        ]),
        _List_fromArray([
            6,
            34,
            62,
            90,
            118
        ]),
        _List_fromArray([
            6,
            26,
            50,
            74,
            98,
            122
        ]),
        _List_fromArray([
            6,
            30,
            54,
            78,
            102,
            126
        ]),
        _List_fromArray([
            6,
            26,
            52,
            78,
            104,
            130
        ]),
        _List_fromArray([
            6,
            30,
            56,
            82,
            108,
            134
        ]),
        _List_fromArray([
            6,
            34,
            60,
            86,
            112,
            138
        ]),
        _List_fromArray([
            6,
            30,
            58,
            86,
            114,
            142
        ]),
        _List_fromArray([
            6,
            34,
            62,
            90,
            118,
            146
        ]),
        _List_fromArray([
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ]),
        _List_fromArray([
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ]),
        _List_fromArray([
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ]),
        _List_fromArray([
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ]),
        _List_fromArray([
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ]),
        _List_fromArray([
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ])
    ]));
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord = F2(function(rows, cols) {
        return A3($elm$core$List$foldl, F2(function(row, list) {
            return A3($elm$core$List$foldl, F2(function(col, list_) {
                return A2($elm$core$List$cons, _Utils_Tuple2(row, col), list_);
            }), list, cols);
        }), _List_Nil, rows);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign = F2(function(size, _v0) {
        var row = _v0.a;
        var col = _v0.b;
        return (row > 10 || 10 < col && _Utils_cmp(col, size - 10) < 0) && (_Utils_cmp(row, size - 10) < 0 || col > 10);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange = A2($elm$core$List$range, -2, 2);
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor = F2(function(row, col) {
        return _Utils_eq(row, -2) || row === 2 || _Utils_eq(col, -2) || col === 2 || !row && !col ? $elm$core$Maybe$Just(_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(_Utils_Tuple2(true, false));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule = F4(function(size, rowPos, colPos, _v0) {
        var row = _v0.a;
        var col = _v0.b;
        return A2($elm$core$Array$set, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row + rowPos, col + colPos), A2($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentColor, row, col));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment = F3(function(size, _v0, matrix) {
        var row = _v0.a;
        var col = _v0.b;
        return A3($elm$core$List$foldl, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignModule, size, row, col), matrix, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentRange));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments = F3(function(size, locations, matrix) {
        return A3($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignment(size), matrix, A2($elm$core$List$filter, $pablohirafuji$elm_qrcode$QRCode$Matrix$isValidAlign(size), A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, locations, locations)));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern = F3(function(version, size, matrix) {
        return A2($elm$core$Result$map, function(a) {
            return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setAlignments, size, a, matrix);
        }, A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$AlignmentPatternNotFound, A2($elm$core$Array$get, version - 1, $pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPatternData)));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule = F2(function(version, size) {
        return A2($elm$core$Array$set, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, 4 * version + 9, 8), $elm$core$Maybe$Just(_Utils_Tuple2(true, true)));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange = A2($elm$core$List$range, 0, 8);
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor = F2(function(row, col) {
        return 1 <= row && row <= 7 && (col === 1 || col === 7) || 1 <= col && col <= 7 && (row === 1 || row === 7) || 3 <= row && row <= 5 && 3 <= col && col <= 5;
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder = F5(function(size, rowOffset, colOffset, _v0, matrix) {
        var row = _v0.a;
        var col = _v0.b;
        var finalRow = row + rowOffset;
        var finalCol = col + colOffset;
        return finalRow < 0 || finalCol < 0 || _Utils_cmp(finalRow, size) > -1 || _Utils_cmp(finalCol, size) > -1 ? matrix : A3($elm$core$Array$set, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, finalRow, finalCol), $elm$core$Maybe$Just(_Utils_Tuple2(true, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$finderColor, row, col))), matrix);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern = F4(function(size, rowOffset, colOffset, matrix) {
        return A3($elm$core$List$foldl, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setFinder, size, rowOffset, colOffset), matrix, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getAreaCoord, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange, $pablohirafuji$elm_qrcode$QRCode$Matrix$finderRange));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor = F2(function(maybeModule, isChange) {
        if (isChange) {
            if (!maybeModule.$ && !maybeModule.a.a) {
                var _v1 = maybeModule.a;
                var isDark = _v1.b;
                return $elm$core$Maybe$Just(_Utils_Tuple2(false, !isDark));
            } else return maybeModule;
        } else return maybeModule;
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord = F2(function(size, index) {
        return _Utils_Tuple2(index / size | 0, A2($elm$core$Basics$modBy, size, index));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction = F4(function(_function, size, index, maybeModule) {
        return A2($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskColor, maybeModule, _function(A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getCoord, size, index)));
    });
    var $elm$core$Elm$JsArray$foldl = _JsArray_foldl;
    var $elm$core$Elm$JsArray$indexedMap = _JsArray_indexedMap;
    var $elm$core$Array$indexedMap = F2(function(func, _v0) {
        var len = _v0.a;
        var tree = _v0.c;
        var tail = _v0.d;
        var initialBuilder = {
            R: _List_Nil,
            y: 0,
            J: A3($elm$core$Elm$JsArray$indexedMap, func, $elm$core$Array$tailIndex(len), tail)
        };
        var helper = F2(function(node, builder) {
            if (!node.$) {
                var subTree = node.a;
                return A3($elm$core$Elm$JsArray$foldl, helper, builder, subTree);
            } else {
                var leaf = node.a;
                var offset = builder.y * $elm$core$Array$branchFactor;
                var mappedLeaf = $elm$core$Array$Leaf(A3($elm$core$Elm$JsArray$indexedMap, func, offset, leaf));
                return {
                    R: A2($elm$core$List$cons, mappedLeaf, builder.R),
                    y: builder.y + 1,
                    J: builder.J
                };
            }
        });
        return A2($elm$core$Array$builderToArray, true, A3($elm$core$Elm$JsArray$foldl, helper, initialBuilder, tree));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction = function(mask) {
        switch(mask){
            case 0:
                return function(_v1) {
                    var row = _v1.a;
                    var col = _v1.b;
                    return !A2($elm$core$Basics$modBy, 2, row + col);
                };
            case 1:
                return function(_v2) {
                    var row = _v2.a;
                    return !A2($elm$core$Basics$modBy, 2, row);
                };
            case 2:
                return function(_v3) {
                    var col = _v3.b;
                    return !A2($elm$core$Basics$modBy, 3, col);
                };
            case 3:
                return function(_v4) {
                    var row = _v4.a;
                    var col = _v4.b;
                    return !A2($elm$core$Basics$modBy, 3, row + col);
                };
            case 4:
                return function(_v5) {
                    var row = _v5.a;
                    var col = _v5.b;
                    return !A2($elm$core$Basics$modBy, 2, $elm$core$Basics$floor(row / 2) + $elm$core$Basics$floor(col / 3));
                };
            case 5:
                return function(_v6) {
                    var row = _v6.a;
                    var col = _v6.b;
                    return !(A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
                };
            case 6:
                return function(_v7) {
                    var row = _v7.a;
                    var col = _v7.b;
                    return !A2($elm$core$Basics$modBy, 2, A2($elm$core$Basics$modBy, 2, row * col) + A2($elm$core$Basics$modBy, 3, row * col));
                };
            default:
                return function(_v8) {
                    var row = _v8.a;
                    var col = _v8.b;
                    return !A2($elm$core$Basics$modBy, 2, A2($elm$core$Basics$modBy, 3, row * col) + A2($elm$core$Basics$modBy, 2, row + col));
                };
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask = F3(function(size, mask, matrix) {
        return A2($elm$core$Array$indexedMap, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMaskFunction, $pablohirafuji$elm_qrcode$QRCode$Matrix$maskFunction(mask), size), matrix);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$breakList = F3(function(width, list, acc) {
        breakList: while(true){
            if (!list.b) return $elm$core$List$reverse(acc);
            else {
                var $temp$width = width, $temp$list = A2($elm$core$List$drop, width, list), $temp$acc = A2($elm$core$List$cons, A2($elm$core$List$take, width, list), acc);
                width = $temp$width;
                list = $temp$list;
                acc = $temp$acc;
                continue breakList;
            }
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule = A2($elm$core$Basics$composeR, $elm$core$Maybe$map($elm$core$Tuple$second), $elm$core$Maybe$withDefault(false));
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_ = F2(function(simplifiedList, _v0) {
        rule1Score_: while(true){
            var last = _v0.a;
            var partialScore = _v0.b;
            var score = _v0.c;
            if (!simplifiedList.b) return partialScore >= 5 ? score + partialScore - 2 : score;
            else {
                var head = simplifiedList.a;
                var tail = simplifiedList.b;
                if (_Utils_eq(last, head)) {
                    var $temp$simplifiedList = tail, $temp$_v0 = _Utils_Tuple3(last, partialScore + 1, score);
                    simplifiedList = $temp$simplifiedList;
                    _v0 = $temp$_v0;
                    continue rule1Score_;
                } else if (partialScore >= 5) {
                    var $temp$simplifiedList = tail, $temp$_v0 = _Utils_Tuple3(head, 0, score + partialScore - 2);
                    simplifiedList = $temp$simplifiedList;
                    _v0 = $temp$_v0;
                    continue rule1Score_;
                } else {
                    var $temp$simplifiedList = tail, $temp$_v0 = _Utils_Tuple3(head, 0, score);
                    simplifiedList = $temp$simplifiedList;
                    _v0 = $temp$_v0;
                    continue rule1Score_;
                }
            }
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score = A2($elm$core$Basics$composeR, $elm$core$List$map(function(a) {
        return A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score_, a, _Utils_Tuple3(false, 0, 0));
    }), $elm$core$List$sum);
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_ = F4(function(row1, row2, maybeLast, score) {
        rule2Score_: while(true){
            if (!row1.b) return score;
            else {
                var head = row1.a;
                var tail = row1.b;
                if (!row2.b) return score;
                else {
                    var head2 = row2.a;
                    var tail2 = row2.b;
                    if (_Utils_eq(head, head2)) {
                        if (_Utils_eq($elm$core$Maybe$Just(head), maybeLast)) {
                            var $temp$row1 = tail, $temp$row2 = tail2, $temp$maybeLast = $elm$core$Maybe$Just(head), $temp$score = score + 3;
                            row1 = $temp$row1;
                            row2 = $temp$row2;
                            maybeLast = $temp$maybeLast;
                            score = $temp$score;
                            continue rule2Score_;
                        } else {
                            var $temp$row1 = tail, $temp$row2 = tail2, $temp$maybeLast = $elm$core$Maybe$Just(head), $temp$score = score;
                            row1 = $temp$row1;
                            row2 = $temp$row2;
                            maybeLast = $temp$maybeLast;
                            score = $temp$score;
                            continue rule2Score_;
                        }
                    } else {
                        var $temp$row1 = tail, $temp$row2 = tail2, $temp$maybeLast = $elm$core$Maybe$Nothing, $temp$score = score;
                        row1 = $temp$row1;
                        row2 = $temp$row2;
                        maybeLast = $temp$maybeLast;
                        score = $temp$score;
                        continue rule2Score_;
                    }
                }
            }
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score = F2(function(list, score) {
        rule2Score: while(true){
            if (list.b && list.b.b) {
                var head1 = list.a;
                var _v1 = list.b;
                var head2 = _v1.a;
                var tail = _v1.b;
                var $temp$list = tail, $temp$score = score + A4($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score_, head1, head2, $elm$core$Maybe$Nothing, 0);
                list = $temp$list;
                score = $temp$score;
                continue rule2Score;
            } else return score;
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_ = F2(function(simplifiedList, score) {
        rule3Score_: while(true){
            _v0$3: while(true){
                if (!simplifiedList.b) return score;
                else if (!simplifiedList.a) {
                    if (simplifiedList.b.b && !simplifiedList.b.a && simplifiedList.b.b.b && !simplifiedList.b.b.a && simplifiedList.b.b.b.b && !simplifiedList.b.b.b.a && simplifiedList.b.b.b.b.b && simplifiedList.b.b.b.b.a && simplifiedList.b.b.b.b.b.b && !simplifiedList.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b && simplifiedList.b.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b.b && simplifiedList.b.b.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b.b.b && simplifiedList.b.b.b.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b.b.b.b && !simplifiedList.b.b.b.b.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b.b.b.b.b && simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
                        var _v1 = simplifiedList.b;
                        var _v2 = _v1.b;
                        var _v3 = _v2.b;
                        var _v4 = _v3.b;
                        var _v5 = _v4.b;
                        var _v6 = _v5.b;
                        var _v7 = _v6.b;
                        var _v8 = _v7.b;
                        var _v9 = _v8.b;
                        var _v10 = _v9.b;
                        var tail = _v10.b;
                        var $temp$simplifiedList = tail, $temp$score = score + 40;
                        simplifiedList = $temp$simplifiedList;
                        score = $temp$score;
                        continue rule3Score_;
                    } else break _v0$3;
                } else {
                    if (simplifiedList.b.b && !simplifiedList.b.a && simplifiedList.b.b.b && simplifiedList.b.b.a && simplifiedList.b.b.b.b && simplifiedList.b.b.b.a && simplifiedList.b.b.b.b.b && simplifiedList.b.b.b.b.a && simplifiedList.b.b.b.b.b.b && !simplifiedList.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b && simplifiedList.b.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b.b && !simplifiedList.b.b.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b.b.b && !simplifiedList.b.b.b.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b.b.b.b && !simplifiedList.b.b.b.b.b.b.b.b.b.a && simplifiedList.b.b.b.b.b.b.b.b.b.b.b && !simplifiedList.b.b.b.b.b.b.b.b.b.b.a) {
                        var _v11 = simplifiedList.b;
                        var _v12 = _v11.b;
                        var _v13 = _v12.b;
                        var _v14 = _v13.b;
                        var _v15 = _v14.b;
                        var _v16 = _v15.b;
                        var _v17 = _v16.b;
                        var _v18 = _v17.b;
                        var _v19 = _v18.b;
                        var _v20 = _v19.b;
                        var tail = _v20.b;
                        var $temp$simplifiedList = tail, $temp$score = score + 40;
                        simplifiedList = $temp$simplifiedList;
                        score = $temp$score;
                        continue rule3Score_;
                    } else break _v0$3;
                }
            }
            var head = simplifiedList.a;
            var tail = simplifiedList.b;
            var $temp$simplifiedList = tail, $temp$score = score;
            simplifiedList = $temp$simplifiedList;
            score = $temp$score;
            continue rule3Score_;
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score = A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score_, 0);
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score = F2(function(size, simplifiedList) {
        var moduleCount = size * size;
        var darkCount = $elm$core$List$length(A2($elm$core$List$filter, $elm$core$Basics$identity, simplifiedList));
        var darkPerc = $elm$core$Basics$round(100 * darkCount / moduleCount);
        var remOf5 = darkPerc % 5;
        var nextMult5 = $elm$core$Basics$round($elm$core$Basics$abs(darkPerc + (5 - remOf5) - 50) / 5);
        var prevMult5 = $elm$core$Basics$round($elm$core$Basics$abs(darkPerc - remOf5 - 50) / 5);
        return A2($elm$core$Basics$min, prevMult5, nextMult5) * 10;
    });
    var $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose = function(ll) {
        transpose: while(true){
            if (!ll.b) return _List_Nil;
            else if (!ll.a.b) {
                var xss = ll.b;
                var $temp$ll = xss;
                ll = $temp$ll;
                continue transpose;
            } else {
                var _v1 = ll.a;
                var x = _v1.a;
                var xs = _v1.b;
                var xss = ll.b;
                var tails = A2($elm$core$List$filterMap, $elm$core$List$tail, xss);
                var heads = A2($elm$core$List$filterMap, $elm$core$List$head, xss);
                return A2($elm$core$List$cons, A2($elm$core$List$cons, x, heads), $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(A2($elm$core$List$cons, xs, tails)));
            }
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore = F2(function(size, matrix) {
        var list = A2($elm$core$List$map, $pablohirafuji$elm_qrcode$QRCode$Matrix$isDarkModule, $elm$core$Array$toList(matrix));
        var rowList = A3($pablohirafuji$elm_qrcode$QRCode$Matrix$breakList, size, list, _List_Nil);
        var transposedRowList = $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(rowList);
        return function(b) {
            return _Utils_Tuple2(rowList, b);
        }(A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule4Score, size, list) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(transposedRowList) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule3Score(rowList) + (A2($pablohirafuji$elm_qrcode$QRCode$Matrix$rule2Score, rowList, 0) + ($pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(transposedRowList) + $pablohirafuji$elm_qrcode$QRCode$Matrix$rule1Score(rowList))))));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt = function(ecLevel) {
        switch(ecLevel){
            case 0:
                return 1;
            case 1:
                return 0;
            case 2:
                return 3;
            default:
                return 2;
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit = function(_int) {
        var helper = F2(function(digit, int_) {
            helper: while(true){
                if (!!int_) {
                    var $temp$digit = digit + 1, $temp$int_ = int_ >>> 1;
                    digit = $temp$digit;
                    int_ = $temp$int_;
                    continue helper;
                } else return digit;
            }
        });
        return A2(helper, 0, _int);
    };
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt = function(mask) {
        switch(mask){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            case 3:
                return 3;
            case 4:
                return 4;
            case 5:
                return 5;
            case 6:
                return 6;
            default:
                return 7;
        }
    };
    var $elm$core$Bitwise$xor = _Bitwise_xor;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo = F2(function(ecLevel, mask) {
        var g15Mask = 21522;
        var g15Int = 1335;
        var g15Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g15Int);
        var formatInfoInt = $pablohirafuji$elm_qrcode$QRCode$Matrix$maskToInt(mask) | $pablohirafuji$elm_qrcode$QRCode$Matrix$ecLevelToInt(ecLevel) << 3;
        var helper = function(d_) {
            helper: while(true){
                if ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit >= 0) {
                    var $temp$d_ = d_ ^ g15Int << $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g15Digit;
                    d_ = $temp$d_;
                    continue helper;
                } else return g15Mask ^ (d_ | formatInfoInt << 10);
            }
        };
        var d = formatInfoInt << 10;
        return helper(d);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal = F2(function(size, count) {
        return count < 8 ? _Utils_Tuple2(8, size - count - 1) : count < 9 ? _Utils_Tuple2(8, 15 - count) : _Utils_Tuple2(8, 15 - count - 1);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical = F2(function(size, count) {
        return count < 6 ? _Utils_Tuple2(count, 8) : count < 8 ? _Utils_Tuple2(count + 1, 8) : _Utils_Tuple2(size - 15 + count, 8);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule = F4(function(size, isBlack, row, col) {
        return A2($elm$core$Array$set, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col), $elm$core$Maybe$Just(_Utils_Tuple2(true, isBlack)));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_ = F4(function(size, isBlackFn, count, matrix) {
        setFormatInfo_: while(true){
            if (count < 15) {
                var isBlack = isBlackFn(count);
                var _v0 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoVertical, size, count);
                var x2 = _v0.a;
                var y2 = _v0.b;
                var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$formatInfoHorizontal, size, count);
                var x1 = _v1.a;
                var y1 = _v1.b;
                var $temp$size = size, $temp$isBlackFn = isBlackFn, $temp$count = count + 1, $temp$matrix = A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x2, y2, A5($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatModule, size, isBlack, x1, y1, matrix));
                size = $temp$size;
                isBlackFn = $temp$isBlackFn;
                count = $temp$count;
                matrix = $temp$matrix;
                continue setFormatInfo_;
            } else return matrix;
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo = F4(function(ecLevel, size, mask, matrix) {
        var isBlack = F2(function(bits_, count) {
            return (1 & bits_ >> count) === 1;
        });
        var bits = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$encodeFormatInfo, ecLevel, mask);
        return A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_, size, isBlack(bits), 0, matrix);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_ = F5(function(ecLevel, size, matrix, mask, _v0) {
        var minSMatrix = _v0.a;
        var minScore = _v0.b;
        var maskedMatrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo, ecLevel, size, mask, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$applyMask, size, mask, matrix));
        var _v1 = A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getMaskScore, size, maskedMatrix);
        var maskSMatrix = _v1.a;
        var maskScore = _v1.b;
        return _Utils_cmp(minScore, maskScore) < 0 && !_Utils_eq(minScore, -1) ? _Utils_Tuple2(minSMatrix, minScore) : _Utils_Tuple2(maskSMatrix, maskScore);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern0 = 0;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern1 = 1;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern2 = 2;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern3 = 3;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern4 = 4;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern5 = 5;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern6 = 6;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$Pattern7 = 7;
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList = _List_fromArray([
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ]);
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask = F3(function(ecLevel, size, matrix) {
        return A3($elm$core$List$foldl, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask_, ecLevel, size, matrix), _Utils_Tuple2(_List_Nil, -1), $pablohirafuji$elm_qrcode$QRCode$Matrix$patternList).a;
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo = F2(function(size, matrix) {
        return A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setFormatInfo_, size, $elm$core$Basics$always(true), 0, matrix);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo = function(version) {
        var g18Int = 7973;
        var g18Digit = $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(g18Int);
        var helper = function(d_) {
            helper: while(true){
                if ($pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit >= 0) {
                    var $temp$d_ = d_ ^ g18Int << $pablohirafuji$elm_qrcode$QRCode$Matrix$getBCHDigit(d_) - g18Digit;
                    d_ = $temp$d_;
                    continue helper;
                } else return d_ | version << 12;
            }
        };
        var d = version << 12;
        return helper(d);
    };
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule = F3(function(size, isBlack, _v0) {
        var row = _v0.a;
        var col = _v0.b;
        return A2($elm$core$Array$set, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col), $elm$core$Maybe$Just(_Utils_Tuple2(true, isBlack)));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_ = F4(function(size, isBlackFn, count, matrix) {
        setVersionInfo_: while(true){
            if (count < 18) {
                var topRight = _Utils_Tuple2($elm$core$Basics$floor(count / 3), A2($elm$core$Basics$modBy, 3, count) + size - 8 - 3);
                var isBlack = isBlackFn(count);
                var bottomLeft = _Utils_Tuple2(A2($elm$core$Basics$modBy, 3, count) + size - 8 - 3, $elm$core$Basics$floor(count / 3));
                var $temp$size = size, $temp$isBlackFn = isBlackFn, $temp$count = count + 1, $temp$matrix = A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, bottomLeft, A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionModule, size, isBlack, topRight, matrix));
                size = $temp$size;
                isBlackFn = $temp$isBlackFn;
                count = $temp$count;
                matrix = $temp$matrix;
                continue setVersionInfo_;
            } else return matrix;
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo = F3(function(version, size, matrix) {
        if (version >= 7) {
            var isBlack = F2(function(bits_, count) {
                return (1 & bits_ >> count) === 1;
            });
            var bits = $pablohirafuji$elm_qrcode$QRCode$Matrix$encodeVersionInfo(version);
            return A4($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo_, size, isBlack(bits), 0, matrix);
        } else return matrix;
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor = F2(function(row, col) {
        return !A2($elm$core$Basics$modBy, 2, row + col) ? $elm$core$Maybe$Just(_Utils_Tuple2(true, true)) : $elm$core$Maybe$Just(_Utils_Tuple2(true, false));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming = F3(function(size, row, col) {
        return A2($elm$core$Array$set, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$getIndex, size, row, col), A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingColor, row, col));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern = F2(function(size, matrix) {
        var range = A2($elm$core$List$range, 8, size - 9);
        return A3($elm$core$List$foldl, function(b) {
            return A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, b, 6);
        }, A3($elm$core$List$foldl, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$setTiming, size, 6), matrix, range), range);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Matrix$apply = function(_v0) {
        var ecLevel = _v0.a.Oo;
        var groupInfo = _v0.a.ad3;
        var bytes = _v0.b;
        var version = groupInfo.H2;
        var size = (version - 1) * 4 + 21;
        return A2($elm$core$Result$map, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$getBestMask, ecLevel, size), A2($elm$core$Result$map, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$addData, size, bytes), A3($pablohirafuji$elm_qrcode$QRCode$Matrix$alignmentPattern, version, size, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$timingPattern, size, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$darkModule, version, size, A3($pablohirafuji$elm_qrcode$QRCode$Matrix$setVersionInfo, version, size, A2($pablohirafuji$elm_qrcode$QRCode$Matrix$reserveFormatInfo, size, A4($pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern, size, -1, size - 8, A4($pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern, size, size - 8, -1, A4($pablohirafuji$elm_qrcode$QRCode$Matrix$finderPattern, size, -1, -1, A2($elm$core$Array$initialize, size * size, $elm$core$Basics$always($elm$core$Maybe$Nothing))))))))))));
    };
    var $pablohirafuji$elm_qrcode$QRCode$ECLevel$H = 3;
    var $pablohirafuji$elm_qrcode$QRCode$ECLevel$L = 0;
    var $pablohirafuji$elm_qrcode$QRCode$ECLevel$M = 1;
    var $pablohirafuji$elm_qrcode$QRCode$ECLevel$Q = 2;
    var $pablohirafuji$elm_qrcode$QRCode$convertEC = function(ec) {
        switch(ec){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound = {
        $: 0
    };
    var $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow = {
        $: 7
    };
    var $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar = {
        $: 2
    };
    var $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar = {
        $: 1
    };
    var $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char = {
        $: 3
    };
    var $pablohirafuji$elm_qrcode$QRCode$LogTableException = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $pablohirafuji$elm_qrcode$QRCode$PolynomialModException = {
        $: 6
    };
    var $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException = {
        $: 5
    };
    var $pablohirafuji$elm_qrcode$QRCode$convertError = function(e) {
        switch(e.$){
            case 0:
                return $pablohirafuji$elm_qrcode$QRCode$AlignmentPatternNotFound;
            case 1:
                return $pablohirafuji$elm_qrcode$QRCode$InvalidNumericChar;
            case 2:
                return $pablohirafuji$elm_qrcode$QRCode$InvalidAlphanumericChar;
            case 3:
                return $pablohirafuji$elm_qrcode$QRCode$InvalidUTF8Char;
            case 4:
                var n = e.a;
                return $pablohirafuji$elm_qrcode$QRCode$LogTableException(n);
            case 5:
                return $pablohirafuji$elm_qrcode$QRCode$PolynomialMultiplyException;
            case 6:
                return $pablohirafuji$elm_qrcode$QRCode$PolynomialModException;
            default:
                return $pablohirafuji$elm_qrcode$QRCode$InputLengthOverflow;
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte = 236;
    var $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte = 17;
    var $pablohirafuji$elm_qrcode$QRCode$Encode$addFiller = F2(function(capacity, bytes) {
        var fillerLength = (capacity / 8 | 0) - $elm$core$List$length(bytes);
        var ns = $elm$core$List$concat(A2($elm$core$List$repeat, fillerLength / 2 | 0, _List_fromArray([
            $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte,
            $pablohirafuji$elm_qrcode$QRCode$Encode$secondFillerByte
        ])));
        return !A2($elm$core$Basics$modBy, 2, fillerLength) ? _Utils_ap(bytes, ns) : _Utils_ap(bytes, _Utils_ap(ns, _List_fromArray([
            $pablohirafuji$elm_qrcode$QRCode$Encode$firstFillerByte
        ])));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator = F3(function(capacity, bitsCount, bits) {
        return _Utils_ap(bits, _List_fromArray([
            _Utils_Tuple2(0, A2($elm$core$Basics$min, 4, capacity - bitsCount))
        ]));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3 = function(_v0) {
        bitsToBytes3: while(true){
            var _v1 = _v0.a;
            var bits = _v1.a;
            var length = _v1.b;
            var bytes = _v0.b;
            if (length >= 8) {
                var remLength = length - 8;
                var remBits = bits & (1 << remLength) - 1;
                var _byte = bits >> remLength;
                var $temp$_v0 = _Utils_Tuple2(_Utils_Tuple2(remBits, remLength), A2($elm$core$List$cons, _byte, bytes));
                _v0 = $temp$_v0;
                continue bitsToBytes3;
            } else return _Utils_Tuple2(_Utils_Tuple2(bits, length), bytes);
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2 = F2(function(_v0, _v1) {
        var curBits = _v0.a;
        var curLength = _v0.b;
        var _v2 = _v1.a;
        var remBits = _v2.a;
        var remLength = _v2.b;
        var bytes = _v1.b;
        var lengthSum = curLength + remLength;
        var bitsSum = curBits | remBits << curLength;
        return $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes3(_Utils_Tuple2(_Utils_Tuple2(bitsSum, lengthSum), bytes));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1 = F2(function(bits, _v0) {
        bitsToBytes1: while(true){
            var _v1 = _v0.a;
            var remBits = _v1.a;
            var remLength = _v1.b;
            var bytes = _v0.b;
            if (bits.b) {
                var head = bits.a;
                var tail = bits.b;
                var $temp$bits = tail, $temp$_v0 = A2($pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes2, head, _Utils_Tuple2(_Utils_Tuple2(remBits, remLength), bytes));
                bits = $temp$bits;
                _v0 = $temp$_v0;
                continue bitsToBytes1;
            } else return !remLength ? $elm$core$List$reverse(bytes) : $elm$core$List$reverse(A2($elm$core$List$cons, remBits << 8 - remLength, bytes));
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes = function(bits) {
        return A2($pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes1, bits, _Utils_Tuple2(_Utils_Tuple2(0, 0), _List_Nil));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8 = 3;
    var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength = F2(function(mode, version) {
        if (version <= 9) switch(mode){
            case 0:
                return 10;
            case 1:
                return 9;
            case 2:
                return 8;
            default:
                return 8;
        }
        else if (version <= 26) switch(mode){
            case 0:
                return 12;
            case 1:
                return 11;
            case 2:
                return 16;
            default:
                return 16;
        }
        else switch(mode){
            case 0:
                return 14;
            case 1:
                return 13;
            case 2:
                return 16;
            default:
                return 16;
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator = F2(function(_v0, bits) {
        var groupInfo = _v0.ad3;
        var inputStr = _v0.FR;
        var mode = _v0.zh;
        var length = A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.H2);
        var charCount = mode === 3 ? $elm$core$List$length(bits) : $elm$core$String$length(inputStr);
        return _Utils_Tuple2(charCount, length);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator = function(mode) {
        switch(mode){
            case 0:
                return 1;
            case 1:
                return 2;
            case 2:
                return 4;
            default:
                return 4;
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits = function(_v0) {
        var bits = _v0.a;
        var model = _v0.b;
        return _Utils_Tuple2(model, A2($pablohirafuji$elm_qrcode$QRCode$Encode$addFiller, model.ad3.v0, $pablohirafuji$elm_qrcode$QRCode$Encode$bitsToBytes(A3($pablohirafuji$elm_qrcode$QRCode$Encode$addTerminator, model.ad3.v0, model.Ev, A2($elm$core$List$cons, _Utils_Tuple2($pablohirafuji$elm_qrcode$QRCode$Encode$modeIndicator(model.zh), 4), A2($elm$core$List$cons, A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicator, model, bits), bits))))));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose = function(_v0) {
        var model = _v0.a;
        var dataBlocks = _v0.b;
        var ecBlocks = _v0.c;
        return _Utils_Tuple2(model, $elm$core$List$concat(_Utils_ap($pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(dataBlocks), $pablohirafuji$elm_qrcode$QRCode$Helpers$transpose(ecBlocks))));
    };
    var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(function(size, step, xs) {
        var xs_ = A2($elm$core$List$drop, step, xs);
        var okayXs = $elm$core$List$length(xs) > 0;
        var okayArgs = size > 0 && step > 0;
        return okayArgs && okayXs ? A2($elm$core$List$cons, A2($elm$core$List$take, size, xs), A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, step, xs_)) : _List_Nil;
    });
    var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(function(size, xs) {
        return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
    });
    var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar = {
        $: 2
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes = $elm$core$Dict$fromList(_List_fromArray([
        _Utils_Tuple2('0', 0),
        _Utils_Tuple2('1', 1),
        _Utils_Tuple2('2', 2),
        _Utils_Tuple2('3', 3),
        _Utils_Tuple2('4', 4),
        _Utils_Tuple2('5', 5),
        _Utils_Tuple2('6', 6),
        _Utils_Tuple2('7', 7),
        _Utils_Tuple2('8', 8),
        _Utils_Tuple2('9', 9),
        _Utils_Tuple2('A', 10),
        _Utils_Tuple2('B', 11),
        _Utils_Tuple2('C', 12),
        _Utils_Tuple2('D', 13),
        _Utils_Tuple2('E', 14),
        _Utils_Tuple2('F', 15),
        _Utils_Tuple2('G', 16),
        _Utils_Tuple2('H', 17),
        _Utils_Tuple2('I', 18),
        _Utils_Tuple2('J', 19),
        _Utils_Tuple2('K', 20),
        _Utils_Tuple2('L', 21),
        _Utils_Tuple2('M', 22),
        _Utils_Tuple2('N', 23),
        _Utils_Tuple2('O', 24),
        _Utils_Tuple2('P', 25),
        _Utils_Tuple2('Q', 26),
        _Utils_Tuple2('R', 27),
        _Utils_Tuple2('S', 28),
        _Utils_Tuple2('T', 29),
        _Utils_Tuple2('U', 30),
        _Utils_Tuple2('V', 31),
        _Utils_Tuple2('W', 32),
        _Utils_Tuple2('X', 33),
        _Utils_Tuple2('Y', 34),
        _Utils_Tuple2('Z', 35),
        _Utils_Tuple2(' ', 36),
        _Utils_Tuple2('$', 37),
        _Utils_Tuple2('%', 38),
        _Utils_Tuple2('*', 39),
        _Utils_Tuple2('+', 40),
        _Utils_Tuple2('-', 41),
        _Utils_Tuple2('.', 42),
        _Utils_Tuple2('/', 43),
        _Utils_Tuple2(':', 44)
    ]));
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode = function(_char) {
        return A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar, A2($elm$core$Dict$get, _char, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$alphanumericCodes));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary = function(chars) {
        _v0$2: while(true){
            if (chars.b) {
                if (chars.b.b) {
                    if (!chars.b.b.b) {
                        var firstChar = chars.a;
                        var _v1 = chars.b;
                        var secondChar = _v1.a;
                        return A3($elm$core$Result$map2, F2(function(firstCode, secondCode) {
                            return _Utils_Tuple2(firstCode * 45 + secondCode, 11);
                        }), $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(firstChar), $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(secondChar));
                    } else break _v0$2;
                } else {
                    var _char = chars.a;
                    return A2($elm$core$Result$map, function(a) {
                        return _Utils_Tuple2(a, 6);
                    }, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toAlphanumericCode(_char));
                }
            } else break _v0$2;
        }
        return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InvalidAlphanumericChar);
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode = function(str) {
        return A3($elm$core$List$foldr, $elm$core$Result$map2($elm$core$List$cons), $elm$core$Result$Ok(_List_Nil), A2($elm$core$List$map, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$toBinary, A2($elm_community$list_extra$List$Extra$greedyGroupsOf, 2, $elm$core$String$toList(str))));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode = function(str) {
        return $elm$core$Result$Ok(A2($elm$core$List$map, function(a) {
            return _Utils_Tuple2($elm$core$Char$toCode(a), 8);
        }, $elm$core$String$toList(str)));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar = {
        $: 1
    };
    var $elm$core$String$fromList = _String_fromList;
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength = function(str) {
        var _v0 = $elm$core$String$length(str);
        switch(_v0){
            case 1:
                return 4;
            case 2:
                return 7;
            default:
                return 10;
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp = function(chars) {
        var str = $elm$core$String$fromList(chars);
        return A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$InvalidNumericChar, A2($elm$core$Maybe$map, function(a) {
            return _Utils_Tuple2(a, $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$numericLength(str));
        }, $elm$core$String$toInt(str)));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode = function(str) {
        return A3($elm$core$List$foldr, $elm$core$Result$map2($elm$core$List$cons), $elm$core$Result$Ok(_List_Nil), A2($elm$core$List$map, $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encodeHelp, A2($elm_community$list_extra$List$Extra$greedyGroupsOf, 3, $elm$core$String$toList(str))));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char = {
        $: 3
    };
    var $elm$bytes$Bytes$Encode$getStringWidth = _Bytes_getStringWidth;
    var $elm$bytes$Bytes$Decode$loopHelp = F4(function(state, callback, bites, offset) {
        loopHelp: while(true){
            var _v0 = callback(state);
            var decoder = _v0;
            var _v1 = A2(decoder, bites, offset);
            var newOffset = _v1.a;
            var step = _v1.b;
            if (!step.$) {
                var newState = step.a;
                var $temp$state = newState, $temp$callback = callback, $temp$bites = bites, $temp$offset = newOffset;
                state = $temp$state;
                callback = $temp$callback;
                bites = $temp$bites;
                offset = $temp$offset;
                continue loopHelp;
            } else {
                var result = step.a;
                return _Utils_Tuple2(newOffset, result);
            }
        }
    });
    var $elm$bytes$Bytes$Decode$loop = F2(function(state, callback) {
        return A2($elm$bytes$Bytes$Decode$loopHelp, state, callback);
    });
    var $elm$bytes$Bytes$Decode$Done = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $elm$bytes$Bytes$Decode$Loop = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$bytes$Bytes$Decode$map = F2(function(func, _v0) {
        var decodeA = _v0;
        return F2(function(bites, offset) {
            var _v1 = A2(decodeA, bites, offset);
            var aOffset = _v1.a;
            var a = _v1.b;
            return _Utils_Tuple2(aOffset, func(a));
        });
    });
    var $elm$bytes$Bytes$Decode$succeed = function(a) {
        return F2(function(_v0, offset) {
            return _Utils_Tuple2(offset, a);
        });
    };
    var $elm$bytes$Bytes$Decode$unsignedInt8 = _Bytes_read_u8;
    var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step = function(_v0) {
        var n = _v0.a;
        var xs = _v0.b;
        return n <= 0 ? $elm$bytes$Bytes$Decode$succeed($elm$bytes$Bytes$Decode$Done($elm$core$List$reverse(xs))) : A2($elm$bytes$Bytes$Decode$map, function(x) {
            return $elm$bytes$Bytes$Decode$Loop(_Utils_Tuple2(n - 1, A2($elm$core$List$cons, _Utils_Tuple2(x, 8), xs)));
        }, $elm$bytes$Bytes$Decode$unsignedInt8);
    };
    var $elm$bytes$Bytes$Encode$Utf8 = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $elm$bytes$Bytes$Encode$string = function(str) {
        return A2($elm$bytes$Bytes$Encode$Utf8, _Bytes_getStringWidth(str), str);
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode = function(str) {
        var utf8BytesWidth = $elm$bytes$Bytes$Encode$getStringWidth(str);
        var decoder = A2($elm$bytes$Bytes$Decode$loop, _Utils_Tuple2(utf8BytesWidth, _List_Nil), $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$step);
        return A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$InvalidUTF8Char, A2($elm$bytes$Bytes$Decode$decode, decoder, $elm$bytes$Bytes$Encode$encode($elm$bytes$Bytes$Encode$string(str))));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$encoder = function(mode) {
        switch(mode){
            case 0:
                return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$encode;
            case 1:
                return $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$encode;
            case 2:
                return $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$encode;
            default:
                return $pablohirafuji$elm_qrcode$QRCode$Encode$UTF8$encode;
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable = $elm$core$Array$fromList(_List_fromArray([
        1,
        2,
        4,
        8,
        16,
        32,
        64,
        128,
        29,
        58,
        116,
        232,
        205,
        135,
        19,
        38,
        76,
        152,
        45,
        90,
        180,
        117,
        234,
        201,
        143,
        3,
        6,
        12,
        24,
        48,
        96,
        192,
        157,
        39,
        78,
        156,
        37,
        74,
        148,
        53,
        106,
        212,
        181,
        119,
        238,
        193,
        159,
        35,
        70,
        140,
        5,
        10,
        20,
        40,
        80,
        160,
        93,
        186,
        105,
        210,
        185,
        111,
        222,
        161,
        95,
        190,
        97,
        194,
        153,
        47,
        94,
        188,
        101,
        202,
        137,
        15,
        30,
        60,
        120,
        240,
        253,
        231,
        211,
        187,
        107,
        214,
        177,
        127,
        254,
        225,
        223,
        163,
        91,
        182,
        113,
        226,
        217,
        175,
        67,
        134,
        17,
        34,
        68,
        136,
        13,
        26,
        52,
        104,
        208,
        189,
        103,
        206,
        129,
        31,
        62,
        124,
        248,
        237,
        199,
        147,
        59,
        118,
        236,
        197,
        151,
        51,
        102,
        204,
        133,
        23,
        46,
        92,
        184,
        109,
        218,
        169,
        79,
        158,
        33,
        66,
        132,
        21,
        42,
        84,
        168,
        77,
        154,
        41,
        82,
        164,
        85,
        170,
        73,
        146,
        57,
        114,
        228,
        213,
        183,
        115,
        230,
        209,
        191,
        99,
        198,
        145,
        63,
        126,
        252,
        229,
        215,
        179,
        123,
        246,
        241,
        255,
        227,
        219,
        171,
        75,
        150,
        49,
        98,
        196,
        149,
        55,
        110,
        220,
        165,
        87,
        174,
        65,
        130,
        25,
        50,
        100,
        200,
        141,
        7,
        14,
        28,
        56,
        112,
        224,
        221,
        167,
        83,
        166,
        81,
        162,
        89,
        178,
        121,
        242,
        249,
        239,
        195,
        155,
        43,
        86,
        172,
        69,
        138,
        9,
        18,
        36,
        72,
        144,
        61,
        122,
        244,
        245,
        247,
        243,
        251,
        235,
        203,
        139,
        11,
        22,
        44,
        88,
        176,
        125,
        250,
        233,
        207,
        131,
        27,
        54,
        108,
        216,
        173,
        71,
        142,
        1
    ]));
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp = function(index) {
        return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Array$get, A2($elm$core$Basics$modBy, 255, index), $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$expTable));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException = {
        $: 5
    };
    var $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable = $elm$core$Array$fromList(_List_fromArray([
        0,
        1,
        25,
        2,
        50,
        26,
        198,
        3,
        223,
        51,
        238,
        27,
        104,
        199,
        75,
        4,
        100,
        224,
        14,
        52,
        141,
        239,
        129,
        28,
        193,
        105,
        248,
        200,
        8,
        76,
        113,
        5,
        138,
        101,
        47,
        225,
        36,
        15,
        33,
        53,
        147,
        142,
        218,
        240,
        18,
        130,
        69,
        29,
        181,
        194,
        125,
        106,
        39,
        249,
        185,
        201,
        154,
        9,
        120,
        77,
        228,
        114,
        166,
        6,
        191,
        139,
        98,
        102,
        221,
        48,
        253,
        226,
        152,
        37,
        179,
        16,
        145,
        34,
        136,
        54,
        208,
        148,
        206,
        143,
        150,
        219,
        189,
        241,
        210,
        19,
        92,
        131,
        56,
        70,
        64,
        30,
        66,
        182,
        163,
        195,
        72,
        126,
        110,
        107,
        58,
        40,
        84,
        250,
        133,
        186,
        61,
        202,
        94,
        155,
        159,
        10,
        21,
        121,
        43,
        78,
        212,
        229,
        172,
        115,
        243,
        167,
        87,
        7,
        112,
        192,
        247,
        140,
        128,
        99,
        13,
        103,
        74,
        222,
        237,
        49,
        197,
        254,
        24,
        227,
        165,
        153,
        119,
        38,
        184,
        180,
        124,
        17,
        68,
        146,
        217,
        35,
        32,
        137,
        46,
        55,
        63,
        209,
        91,
        149,
        188,
        207,
        205,
        144,
        135,
        151,
        178,
        220,
        252,
        190,
        97,
        242,
        86,
        211,
        171,
        20,
        42,
        93,
        158,
        132,
        60,
        57,
        83,
        71,
        109,
        65,
        162,
        31,
        45,
        67,
        216,
        183,
        123,
        164,
        118,
        196,
        23,
        73,
        236,
        127,
        12,
        111,
        246,
        108,
        161,
        59,
        82,
        41,
        157,
        85,
        170,
        251,
        96,
        134,
        177,
        187,
        204,
        62,
        90,
        203,
        89,
        95,
        176,
        156,
        169,
        160,
        81,
        11,
        245,
        22,
        235,
        122,
        117,
        44,
        215,
        79,
        174,
        213,
        233,
        230,
        231,
        173,
        232,
        116,
        214,
        244,
        234,
        168,
        80,
        88,
        175
    ]));
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog = function(index) {
        return index < 1 ? $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index)) : A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$LogTableException(index), A2($elm$core$Array$get, index - 1, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$logTable));
    };
    var $elm$core$Array$length = function(_v0) {
        var len = _v0.a;
        return len;
    };
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset = function(_v0) {
        getOffset: while(true){
            var num = _v0.a;
            var offset = _v0.b;
            if (num.b) {
                var head = num.a;
                var tail = num.b;
                if (!head) {
                    var $temp$_v0 = _Utils_Tuple2(tail, offset + 1);
                    _v0 = $temp$_v0;
                    continue getOffset;
                } else return offset;
            } else return offset;
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial = F2(function(num, shift) {
        var offset = $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getOffset(_Utils_Tuple2(num, 0));
        var numArray = $elm$core$Array$fromList(num);
        return A2($elm$core$Array$initialize, $elm$core$List$length(num) - offset + shift, function(index) {
            return A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Array$get, index + offset, numArray));
        });
    });
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply = F2(function(poly1, poly2) {
        var valuesArray = A2($elm$core$List$indexedMap, F2(function(index1, value1) {
            return A2($elm$core$List$indexedMap, F2(function(index2, value2) {
                return _Utils_Tuple3(index1 + index2, value1, value2);
            }), $elm$core$Array$toList(poly2));
        }), $elm$core$Array$toList(poly1));
        var process__ = F3(function(indexSum, num_, exp) {
            return A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialMultiplyException, A2($elm$core$Maybe$map, $elm$core$Bitwise$xor(exp), A2($elm$core$Array$get, indexSum, num_)));
        });
        var process_ = F2(function(_v0, num_) {
            var indexSum = _v0.a;
            var value1 = _v0.b;
            var value2 = _v0.c;
            return A2($elm$core$Result$map, function(r) {
                return A3($elm$core$Array$set, indexSum, r, num_);
            }, A2($elm$core$Result$andThen, A2(process__, indexSum, num_), A2($elm$core$Result$map, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp, A3($elm$core$Result$map2, $elm$core$Basics$add, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value1), $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
        });
        var process = F2(function(args, numResult) {
            return A2($elm$core$Result$andThen, process_(args), numResult);
        });
        var num = A2($elm$core$Array$initialize, $elm$core$Array$length(poly1) + $elm$core$Array$length(poly2) - 1, $elm$core$Basics$always(0));
        return A2($elm$core$Result$map, function(a) {
            return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
        }, A2($elm$core$Result$map, $elm$core$Array$toList, A3($elm$core$List$foldl, process, $elm$core$Result$Ok(num), $elm$core$List$concat(valuesArray))));
    });
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial = function(ecLength) {
        var generate = F2(function(count, polyResult) {
            generate: while(true){
                if (_Utils_cmp(count, ecLength) < 0) {
                    var $temp$count = count + 1, $temp$polyResult = A2($elm$core$Result$andThen, function(a) {
                        return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$multiply, a, A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, _List_fromArray([
                            1,
                            $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp(count)
                        ]), 0));
                    }, polyResult);
                    count = $temp$count;
                    polyResult = $temp$polyResult;
                    continue generate;
                } else return polyResult;
            }
        });
        return A2(generate, 0, $elm$core$Result$Ok(A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, _List_fromArray([
            1
        ]), 0)));
    };
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___ = F2(function(ecLength, modPoly) {
        return $elm$core$Array$toList(A2($elm$core$Array$initialize, ecLength, function(index) {
            var modIndex = index + $elm$core$Array$length(modPoly) - ecLength;
            return modIndex >= 0 ? A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Array$get, modIndex, modPoly)) : 0;
        }));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException = {
        $: 6
    };
    var $elm$core$Array$foldl = F3(function(func, baseCase, _v0) {
        var tree = _v0.c;
        var tail = _v0.d;
        var helper = F2(function(node, acc) {
            if (!node.$) {
                var subTree = node.a;
                return A3($elm$core$Elm$JsArray$foldl, helper, acc, subTree);
            } else {
                var values = node.a;
                return A3($elm$core$Elm$JsArray$foldl, func, acc, values);
            }
        });
        return A3($elm$core$Elm$JsArray$foldl, func, A3($elm$core$Elm$JsArray$foldl, helper, baseCase, tree), tail);
    });
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod = F2(function(poly1, poly2) {
        if ($elm$core$Array$length(poly1) - $elm$core$Array$length(poly2) < 0) return $elm$core$Result$Ok(poly1);
        else {
            var helper_ = F3(function(index2, poly1_, exp) {
                return A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException, A2($elm$core$Maybe$map, $elm$core$Bitwise$xor(exp), A2($elm$core$Array$get, index2, poly1_)));
            });
            var getHead = function(poly) {
                return A2($elm$core$Result$andThen, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog, A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$PolynomialModException, A2($elm$core$Array$get, 0, poly)));
            };
            var ratio = A3($elm$core$Result$map2, $elm$core$Basics$sub, getHead(poly1), getHead(poly2));
            var helper = F2(function(_v0, poly1_) {
                var index2 = _v0.a;
                var value2 = _v0.b;
                return A2($elm$core$Result$map, function(r) {
                    return A3($elm$core$Array$set, index2, r, poly1_);
                }, A2($elm$core$Result$andThen, A2(helper_, index2, poly1_), A2($elm$core$Result$map, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getExp, A3($elm$core$Result$map2, $elm$core$Basics$add, ratio, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getLog(value2)))));
            });
            var numFold = F2(function(args, poly1Result) {
                return A2($elm$core$Result$andThen, helper(args), poly1Result);
            });
            var numResult = A3($elm$core$Array$foldl, numFold, $elm$core$Result$Ok(poly1), A2($elm$core$Array$indexedMap, F2(function(a, b) {
                return _Utils_Tuple2(a, b);
            }), poly2));
            return A2($elm$core$Result$andThen, function(a) {
                return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, a, poly2);
            }, A2($elm$core$Result$map, function(a) {
                return A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, a, 0);
            }, A2($elm$core$Result$map, $elm$core$Array$toList, numResult)));
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__ = F2(function(rsPoly, dataCodewords) {
        return A2($elm$core$Result$map, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get___($elm$core$Array$length(rsPoly) - 1), A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$mod, A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$newPolynomial, dataCodewords, $elm$core$Array$length(rsPoly) - 1), rsPoly));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Helpers$listResult = F3(function(fun, listb, lista) {
        if (lista.b) {
            var head = lista.a;
            var tail = lista.b;
            return A2($elm$core$Result$andThen, function(a) {
                return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, fun, a, tail);
            }, A2($elm$core$Result$map, function(r) {
                return A2($elm$core$List$cons, r, listb);
            }, fun(head)));
        } else return $elm$core$Result$Ok($elm$core$List$reverse(listb));
    });
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_ = F2(function(byteBlocks, rsPoly) {
        return A3($pablohirafuji$elm_qrcode$QRCode$Helpers$listResult, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get__(rsPoly), _List_Nil, byteBlocks);
    });
    var $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get = F2(function(ecPerBlock, byteBlocks) {
        return A2($elm$core$Result$andThen, $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get_(byteBlocks), $pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$getECPolynomial(ecPerBlock));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection = function(_v0) {
        var model = _v0.a;
        var dataBlocks = _v0.b;
        return A2($elm$core$Result$map, function(c) {
            return _Utils_Tuple3(model, dataBlocks, c);
        }, A2($pablohirafuji$elm_qrcode$QRCode$ErrorCorrection$get, model.ad3.adf, dataBlocks));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric = 1;
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte = 2;
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric = 0;
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric = A2($elm$regex$Regex$fromStringWith, {
        acf: false,
        ae8: false
    }, '^[0-9A-Z $%*+\\-.\\/:]+$');
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid = function(input) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(r) {
            return A2($elm$regex$Regex$contains, r, input);
        }, $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$onlyAlphanumeric));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit = A2($elm$regex$Regex$fromStringWith, {
        acf: false,
        ae8: false
    }, '^[\\u0000-\\u00ff]+$');
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid = function(input) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(r) {
            return A2($elm$regex$Regex$contains, r, input);
        }, $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$only8Bit));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber = A2($elm$regex$Regex$fromStringWith, {
        acf: false,
        ae8: false
    }, '^[0-9]+$');
    var $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid = function(input) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(r) {
            return A2($elm$regex$Regex$contains, r, input);
        }, $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$onlyNumber));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode = function(input) {
        return $pablohirafuji$elm_qrcode$QRCode$Encode$Numeric$isValid(input) ? 0 : $pablohirafuji$elm_qrcode$QRCode$Encode$Alphanumeric$isValid(input) ? 1 : $pablohirafuji$elm_qrcode$QRCode$Encode$Byte$isValid(input) ? 2 : 3;
    };
    var $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow = {
        $: 7
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity = F3(function(mode, dataLength, _v0) {
        var version = _v0.H2;
        var capacity = _v0.v0;
        return _Utils_cmp(A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, version) + dataLength, capacity) < 1;
    });
    var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity = function(_v0) {
        var blockCount = _v0.a;
        var bytePerBlock = _v0.b;
        return blockCount * bytePerBlock;
    };
    var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity = F2(function(group1, maybeGroup2) {
        if (!maybeGroup2.$) {
            var block2 = maybeGroup2.a;
            return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1) + $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(block2);
        } else return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$blockByteCapacity(group1);
    });
    var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo = F4(function(version, ecPerBlock, group1, maybeGroup2) {
        return {
            v0: A2($pablohirafuji$elm_qrcode$QRCode$GroupInfo$byteCapacity, group1, maybeGroup2) * 8,
            adf: ecPerBlock,
            Qc: group1,
            aeY: maybeGroup2,
            H2: version
        };
    });
    var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH = _List_fromArray([
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 1, 17, _Utils_Tuple2(1, 9), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 2, 28, _Utils_Tuple2(1, 16), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 3, 22, _Utils_Tuple2(2, 13), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 4, 16, _Utils_Tuple2(4, 9), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 5, 22, _Utils_Tuple2(2, 11), $elm$core$Maybe$Just(_Utils_Tuple2(2, 12))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 6, 28, _Utils_Tuple2(4, 15), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 7, 26, _Utils_Tuple2(4, 13), $elm$core$Maybe$Just(_Utils_Tuple2(1, 14))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 8, 26, _Utils_Tuple2(4, 14), $elm$core$Maybe$Just(_Utils_Tuple2(2, 15))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 9, 24, _Utils_Tuple2(4, 12), $elm$core$Maybe$Just(_Utils_Tuple2(4, 13))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 10, 28, _Utils_Tuple2(6, 15), $elm$core$Maybe$Just(_Utils_Tuple2(2, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 11, 24, _Utils_Tuple2(3, 12), $elm$core$Maybe$Just(_Utils_Tuple2(8, 13))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 12, 28, _Utils_Tuple2(7, 14), $elm$core$Maybe$Just(_Utils_Tuple2(4, 15))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 13, 22, _Utils_Tuple2(12, 11), $elm$core$Maybe$Just(_Utils_Tuple2(4, 12))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 14, 24, _Utils_Tuple2(11, 12), $elm$core$Maybe$Just(_Utils_Tuple2(5, 13))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 15, 24, _Utils_Tuple2(11, 12), $elm$core$Maybe$Just(_Utils_Tuple2(7, 13))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 16, 30, _Utils_Tuple2(3, 15), $elm$core$Maybe$Just(_Utils_Tuple2(13, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 17, 28, _Utils_Tuple2(2, 14), $elm$core$Maybe$Just(_Utils_Tuple2(17, 15))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 18, 28, _Utils_Tuple2(2, 14), $elm$core$Maybe$Just(_Utils_Tuple2(19, 15))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 19, 26, _Utils_Tuple2(9, 13), $elm$core$Maybe$Just(_Utils_Tuple2(16, 14))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 20, 28, _Utils_Tuple2(15, 15), $elm$core$Maybe$Just(_Utils_Tuple2(10, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 21, 30, _Utils_Tuple2(19, 16), $elm$core$Maybe$Just(_Utils_Tuple2(6, 17))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 22, 24, _Utils_Tuple2(34, 13), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 23, 30, _Utils_Tuple2(16, 15), $elm$core$Maybe$Just(_Utils_Tuple2(14, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 24, 30, _Utils_Tuple2(30, 16), $elm$core$Maybe$Just(_Utils_Tuple2(2, 17))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 25, 30, _Utils_Tuple2(22, 15), $elm$core$Maybe$Just(_Utils_Tuple2(13, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 26, 30, _Utils_Tuple2(33, 16), $elm$core$Maybe$Just(_Utils_Tuple2(4, 17))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 27, 30, _Utils_Tuple2(12, 15), $elm$core$Maybe$Just(_Utils_Tuple2(28, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 28, 30, _Utils_Tuple2(11, 15), $elm$core$Maybe$Just(_Utils_Tuple2(31, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 29, 30, _Utils_Tuple2(19, 15), $elm$core$Maybe$Just(_Utils_Tuple2(26, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 30, 30, _Utils_Tuple2(23, 15), $elm$core$Maybe$Just(_Utils_Tuple2(25, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 31, 30, _Utils_Tuple2(23, 15), $elm$core$Maybe$Just(_Utils_Tuple2(28, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 32, 30, _Utils_Tuple2(19, 15), $elm$core$Maybe$Just(_Utils_Tuple2(35, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 33, 30, _Utils_Tuple2(11, 15), $elm$core$Maybe$Just(_Utils_Tuple2(46, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 34, 30, _Utils_Tuple2(59, 16), $elm$core$Maybe$Just(_Utils_Tuple2(1, 17))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 35, 30, _Utils_Tuple2(22, 15), $elm$core$Maybe$Just(_Utils_Tuple2(41, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 36, 30, _Utils_Tuple2(2, 15), $elm$core$Maybe$Just(_Utils_Tuple2(64, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 37, 30, _Utils_Tuple2(24, 15), $elm$core$Maybe$Just(_Utils_Tuple2(46, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 38, 30, _Utils_Tuple2(42, 15), $elm$core$Maybe$Just(_Utils_Tuple2(32, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 39, 30, _Utils_Tuple2(10, 15), $elm$core$Maybe$Just(_Utils_Tuple2(67, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 40, 30, _Utils_Tuple2(20, 15), $elm$core$Maybe$Just(_Utils_Tuple2(61, 16)))
    ]);
    var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL = _List_fromArray([
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 1, 7, _Utils_Tuple2(1, 19), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 2, 10, _Utils_Tuple2(1, 34), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 3, 15, _Utils_Tuple2(1, 55), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 4, 20, _Utils_Tuple2(1, 80), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 5, 26, _Utils_Tuple2(1, 108), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 6, 18, _Utils_Tuple2(2, 68), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 7, 20, _Utils_Tuple2(2, 78), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 8, 24, _Utils_Tuple2(2, 97), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 9, 30, _Utils_Tuple2(2, 116), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 10, 18, _Utils_Tuple2(2, 68), $elm$core$Maybe$Just(_Utils_Tuple2(2, 69))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 11, 20, _Utils_Tuple2(4, 81), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 12, 24, _Utils_Tuple2(2, 92), $elm$core$Maybe$Just(_Utils_Tuple2(2, 93))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 13, 26, _Utils_Tuple2(4, 107), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 14, 30, _Utils_Tuple2(3, 115), $elm$core$Maybe$Just(_Utils_Tuple2(1, 116))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 15, 22, _Utils_Tuple2(5, 87), $elm$core$Maybe$Just(_Utils_Tuple2(1, 88))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 16, 24, _Utils_Tuple2(5, 98), $elm$core$Maybe$Just(_Utils_Tuple2(1, 99))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 17, 28, _Utils_Tuple2(1, 107), $elm$core$Maybe$Just(_Utils_Tuple2(5, 108))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 18, 30, _Utils_Tuple2(5, 120), $elm$core$Maybe$Just(_Utils_Tuple2(1, 121))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 19, 28, _Utils_Tuple2(3, 113), $elm$core$Maybe$Just(_Utils_Tuple2(4, 114))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 20, 28, _Utils_Tuple2(3, 107), $elm$core$Maybe$Just(_Utils_Tuple2(5, 108))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 21, 28, _Utils_Tuple2(4, 116), $elm$core$Maybe$Just(_Utils_Tuple2(4, 117))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 22, 28, _Utils_Tuple2(2, 111), $elm$core$Maybe$Just(_Utils_Tuple2(7, 112))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 23, 30, _Utils_Tuple2(4, 121), $elm$core$Maybe$Just(_Utils_Tuple2(5, 122))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 24, 30, _Utils_Tuple2(6, 117), $elm$core$Maybe$Just(_Utils_Tuple2(4, 118))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 25, 26, _Utils_Tuple2(8, 106), $elm$core$Maybe$Just(_Utils_Tuple2(4, 107))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 26, 28, _Utils_Tuple2(10, 114), $elm$core$Maybe$Just(_Utils_Tuple2(2, 115))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 27, 30, _Utils_Tuple2(8, 122), $elm$core$Maybe$Just(_Utils_Tuple2(4, 123))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 28, 30, _Utils_Tuple2(3, 117), $elm$core$Maybe$Just(_Utils_Tuple2(10, 118))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 29, 30, _Utils_Tuple2(7, 116), $elm$core$Maybe$Just(_Utils_Tuple2(7, 117))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 30, 30, _Utils_Tuple2(5, 115), $elm$core$Maybe$Just(_Utils_Tuple2(10, 116))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 31, 30, _Utils_Tuple2(13, 115), $elm$core$Maybe$Just(_Utils_Tuple2(3, 116))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 32, 30, _Utils_Tuple2(17, 115), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 33, 30, _Utils_Tuple2(17, 115), $elm$core$Maybe$Just(_Utils_Tuple2(1, 116))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 34, 30, _Utils_Tuple2(13, 115), $elm$core$Maybe$Just(_Utils_Tuple2(6, 116))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 35, 30, _Utils_Tuple2(12, 121), $elm$core$Maybe$Just(_Utils_Tuple2(7, 122))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 36, 30, _Utils_Tuple2(6, 121), $elm$core$Maybe$Just(_Utils_Tuple2(14, 122))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 37, 30, _Utils_Tuple2(17, 122), $elm$core$Maybe$Just(_Utils_Tuple2(4, 123))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 38, 30, _Utils_Tuple2(4, 122), $elm$core$Maybe$Just(_Utils_Tuple2(18, 123))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 39, 30, _Utils_Tuple2(20, 117), $elm$core$Maybe$Just(_Utils_Tuple2(4, 118))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 40, 30, _Utils_Tuple2(19, 118), $elm$core$Maybe$Just(_Utils_Tuple2(6, 119)))
    ]);
    var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM = _List_fromArray([
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 1, 10, _Utils_Tuple2(1, 16), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 2, 16, _Utils_Tuple2(1, 28), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 3, 26, _Utils_Tuple2(1, 44), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 4, 18, _Utils_Tuple2(2, 32), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 5, 24, _Utils_Tuple2(2, 43), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 6, 16, _Utils_Tuple2(4, 27), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 7, 18, _Utils_Tuple2(4, 31), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 8, 22, _Utils_Tuple2(2, 38), $elm$core$Maybe$Just(_Utils_Tuple2(2, 39))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 9, 22, _Utils_Tuple2(3, 36), $elm$core$Maybe$Just(_Utils_Tuple2(2, 37))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 10, 26, _Utils_Tuple2(4, 43), $elm$core$Maybe$Just(_Utils_Tuple2(1, 44))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 11, 30, _Utils_Tuple2(1, 50), $elm$core$Maybe$Just(_Utils_Tuple2(4, 51))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 12, 22, _Utils_Tuple2(6, 36), $elm$core$Maybe$Just(_Utils_Tuple2(2, 37))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 13, 22, _Utils_Tuple2(8, 37), $elm$core$Maybe$Just(_Utils_Tuple2(1, 38))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 14, 24, _Utils_Tuple2(4, 40), $elm$core$Maybe$Just(_Utils_Tuple2(5, 41))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 15, 24, _Utils_Tuple2(5, 41), $elm$core$Maybe$Just(_Utils_Tuple2(5, 42))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 16, 28, _Utils_Tuple2(7, 45), $elm$core$Maybe$Just(_Utils_Tuple2(3, 46))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 17, 28, _Utils_Tuple2(10, 46), $elm$core$Maybe$Just(_Utils_Tuple2(1, 47))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 18, 26, _Utils_Tuple2(9, 43), $elm$core$Maybe$Just(_Utils_Tuple2(4, 44))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 19, 26, _Utils_Tuple2(3, 44), $elm$core$Maybe$Just(_Utils_Tuple2(11, 45))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 20, 26, _Utils_Tuple2(3, 41), $elm$core$Maybe$Just(_Utils_Tuple2(13, 42))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 21, 26, _Utils_Tuple2(17, 42), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 22, 28, _Utils_Tuple2(17, 46), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 23, 28, _Utils_Tuple2(4, 47), $elm$core$Maybe$Just(_Utils_Tuple2(14, 48))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 24, 28, _Utils_Tuple2(6, 45), $elm$core$Maybe$Just(_Utils_Tuple2(14, 46))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 25, 28, _Utils_Tuple2(8, 47), $elm$core$Maybe$Just(_Utils_Tuple2(13, 48))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 26, 28, _Utils_Tuple2(19, 46), $elm$core$Maybe$Just(_Utils_Tuple2(4, 47))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 27, 28, _Utils_Tuple2(22, 45), $elm$core$Maybe$Just(_Utils_Tuple2(3, 46))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 28, 28, _Utils_Tuple2(3, 45), $elm$core$Maybe$Just(_Utils_Tuple2(23, 46))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 29, 28, _Utils_Tuple2(21, 45), $elm$core$Maybe$Just(_Utils_Tuple2(7, 46))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 30, 28, _Utils_Tuple2(19, 47), $elm$core$Maybe$Just(_Utils_Tuple2(10, 48))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 31, 28, _Utils_Tuple2(2, 46), $elm$core$Maybe$Just(_Utils_Tuple2(29, 47))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 32, 28, _Utils_Tuple2(10, 46), $elm$core$Maybe$Just(_Utils_Tuple2(23, 47))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 33, 28, _Utils_Tuple2(14, 46), $elm$core$Maybe$Just(_Utils_Tuple2(21, 47))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 34, 28, _Utils_Tuple2(14, 46), $elm$core$Maybe$Just(_Utils_Tuple2(23, 47))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 35, 28, _Utils_Tuple2(12, 47), $elm$core$Maybe$Just(_Utils_Tuple2(26, 48))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 36, 28, _Utils_Tuple2(6, 47), $elm$core$Maybe$Just(_Utils_Tuple2(34, 48))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 37, 28, _Utils_Tuple2(29, 46), $elm$core$Maybe$Just(_Utils_Tuple2(14, 47))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 38, 28, _Utils_Tuple2(13, 46), $elm$core$Maybe$Just(_Utils_Tuple2(32, 47))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 39, 28, _Utils_Tuple2(40, 47), $elm$core$Maybe$Just(_Utils_Tuple2(7, 48))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 40, 28, _Utils_Tuple2(18, 47), $elm$core$Maybe$Just(_Utils_Tuple2(31, 48)))
    ]);
    var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ = _List_fromArray([
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 1, 13, _Utils_Tuple2(1, 13), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 2, 22, _Utils_Tuple2(1, 22), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 3, 18, _Utils_Tuple2(2, 17), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 4, 26, _Utils_Tuple2(2, 24), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 5, 18, _Utils_Tuple2(2, 15), $elm$core$Maybe$Just(_Utils_Tuple2(2, 16))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 6, 24, _Utils_Tuple2(4, 19), $elm$core$Maybe$Nothing),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 7, 18, _Utils_Tuple2(2, 14), $elm$core$Maybe$Just(_Utils_Tuple2(4, 15))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 8, 22, _Utils_Tuple2(4, 18), $elm$core$Maybe$Just(_Utils_Tuple2(2, 19))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 9, 20, _Utils_Tuple2(4, 16), $elm$core$Maybe$Just(_Utils_Tuple2(4, 17))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 10, 24, _Utils_Tuple2(6, 19), $elm$core$Maybe$Just(_Utils_Tuple2(2, 20))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 11, 28, _Utils_Tuple2(4, 22), $elm$core$Maybe$Just(_Utils_Tuple2(4, 23))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 12, 26, _Utils_Tuple2(4, 20), $elm$core$Maybe$Just(_Utils_Tuple2(6, 21))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 13, 24, _Utils_Tuple2(8, 20), $elm$core$Maybe$Just(_Utils_Tuple2(4, 21))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 14, 20, _Utils_Tuple2(11, 16), $elm$core$Maybe$Just(_Utils_Tuple2(5, 17))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 15, 30, _Utils_Tuple2(5, 24), $elm$core$Maybe$Just(_Utils_Tuple2(7, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 16, 24, _Utils_Tuple2(15, 19), $elm$core$Maybe$Just(_Utils_Tuple2(2, 20))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 17, 28, _Utils_Tuple2(1, 22), $elm$core$Maybe$Just(_Utils_Tuple2(15, 23))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 18, 28, _Utils_Tuple2(17, 22), $elm$core$Maybe$Just(_Utils_Tuple2(1, 23))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 19, 26, _Utils_Tuple2(17, 21), $elm$core$Maybe$Just(_Utils_Tuple2(4, 22))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 20, 30, _Utils_Tuple2(15, 24), $elm$core$Maybe$Just(_Utils_Tuple2(5, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 21, 28, _Utils_Tuple2(17, 22), $elm$core$Maybe$Just(_Utils_Tuple2(6, 23))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 22, 30, _Utils_Tuple2(7, 24), $elm$core$Maybe$Just(_Utils_Tuple2(16, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 23, 30, _Utils_Tuple2(11, 24), $elm$core$Maybe$Just(_Utils_Tuple2(14, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 24, 30, _Utils_Tuple2(11, 24), $elm$core$Maybe$Just(_Utils_Tuple2(16, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 25, 30, _Utils_Tuple2(7, 24), $elm$core$Maybe$Just(_Utils_Tuple2(22, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 26, 28, _Utils_Tuple2(28, 22), $elm$core$Maybe$Just(_Utils_Tuple2(6, 23))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 27, 30, _Utils_Tuple2(8, 23), $elm$core$Maybe$Just(_Utils_Tuple2(26, 24))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 28, 30, _Utils_Tuple2(4, 24), $elm$core$Maybe$Just(_Utils_Tuple2(31, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 29, 30, _Utils_Tuple2(1, 23), $elm$core$Maybe$Just(_Utils_Tuple2(37, 24))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 30, 30, _Utils_Tuple2(15, 24), $elm$core$Maybe$Just(_Utils_Tuple2(25, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 31, 30, _Utils_Tuple2(42, 24), $elm$core$Maybe$Just(_Utils_Tuple2(1, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 32, 30, _Utils_Tuple2(10, 24), $elm$core$Maybe$Just(_Utils_Tuple2(35, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 33, 30, _Utils_Tuple2(29, 24), $elm$core$Maybe$Just(_Utils_Tuple2(19, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 34, 30, _Utils_Tuple2(44, 24), $elm$core$Maybe$Just(_Utils_Tuple2(7, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 35, 30, _Utils_Tuple2(39, 24), $elm$core$Maybe$Just(_Utils_Tuple2(14, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 36, 30, _Utils_Tuple2(46, 24), $elm$core$Maybe$Just(_Utils_Tuple2(10, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 37, 30, _Utils_Tuple2(49, 24), $elm$core$Maybe$Just(_Utils_Tuple2(10, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 38, 30, _Utils_Tuple2(48, 24), $elm$core$Maybe$Just(_Utils_Tuple2(14, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 39, 30, _Utils_Tuple2(43, 24), $elm$core$Maybe$Just(_Utils_Tuple2(22, 25))),
        A4($pablohirafuji$elm_qrcode$QRCode$GroupInfo$newGroupInfo, 40, 30, _Utils_Tuple2(34, 24), $elm$core$Maybe$Just(_Utils_Tuple2(34, 25)))
    ]);
    var $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData = function(ecLevel) {
        switch(ecLevel){
            case 0:
                return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataL;
            case 1:
                return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataM;
            case 2:
                return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataQ;
            default:
                return $pablohirafuji$elm_qrcode$QRCode$GroupInfo$dataH;
        }
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$getVersion = F3(function(ecLevel, mode, dataLength) {
        return A2($elm$core$Result$fromMaybe, $pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow, $elm$core$List$head(A2($elm$core$List$sortBy, function($) {
            return $.v0;
        }, A2($elm$core$List$filter, A2($pablohirafuji$elm_qrcode$QRCode$Encode$filterCapacity, mode, dataLength), $pablohirafuji$elm_qrcode$QRCode$GroupInfo$getGroupData(ecLevel)))));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel = F5(function(inputStr, ecLevel, mode, partialBitsCount, groupInfo) {
        return {
            Ev: partialBitsCount + A2($pablohirafuji$elm_qrcode$QRCode$Encode$charCountIndicatorLength, mode, groupInfo.H2),
            Oo: ecLevel,
            ad3: groupInfo,
            FR: inputStr,
            zh: mode
        };
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion = F4(function(inputStr, ecLevel, mode, encodedStr) {
        var partialBitsCount = 4 + A3($elm$core$List$foldl, F2(function(a, b) {
            return a.b + b;
        }), 0, encodedStr);
        return A2($elm$core$Result$map, function(b) {
            return _Utils_Tuple2(encodedStr, b);
        }, A2($elm$core$Result$map, A4($pablohirafuji$elm_qrcode$QRCode$Encode$versionToModel, inputStr, ecLevel, mode, partialBitsCount), A3($pablohirafuji$elm_qrcode$QRCode$Encode$getVersion, ecLevel, mode, partialBitsCount)));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$breakList = F3(function(checkFinish, _v0, _v1) {
        breakList: while(true){
            var times = _v0.a;
            var itemCount = _v0.b;
            var byteList = _v1.a;
            var progress = _v1.b;
            if (times > 0) {
                var remainList = A2($elm$core$List$drop, itemCount, byteList);
                var block = A2($elm$core$List$take, itemCount, byteList);
                var $temp$checkFinish = checkFinish, $temp$_v0 = _Utils_Tuple2(times - 1, itemCount), $temp$_v1 = _Utils_Tuple2(remainList, A2($elm$core$List$cons, block, progress));
                checkFinish = $temp$checkFinish;
                _v0 = $temp$_v0;
                _v1 = $temp$_v1;
                continue breakList;
            } else {
                if (checkFinish && $elm$core$List$length(byteList) > 0) return $elm$core$Result$Err($pablohirafuji$elm_qrcode$QRCode$Error$InputLengthOverflow);
                else return $elm$core$Result$Ok(_Utils_Tuple2(byteList, progress));
            }
        }
    });
    var $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks = function(_v0) {
        var model = _v0.a;
        var groupInfo = model.ad3;
        var byteList = _v0.b;
        var _v1 = groupInfo.aeY;
        if (!_v1.$) {
            var group2 = _v1.a;
            return A2($elm$core$Result$map, function(b) {
                return _Utils_Tuple2(model, b);
            }, A2($elm$core$Result$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse), A2($elm$core$Result$andThen, A2($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, group2), A3($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, false, groupInfo.Qc, _Utils_Tuple2(byteList, _List_Nil)))));
        } else return A2($elm$core$Result$map, function(b) {
            return _Utils_Tuple2(model, b);
        }, A2($elm$core$Result$map, A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$List$reverse), A3($pablohirafuji$elm_qrcode$QRCode$Encode$breakList, true, groupInfo.Qc, _Utils_Tuple2(byteList, _List_Nil))));
    };
    var $pablohirafuji$elm_qrcode$QRCode$Encode$encode = F2(function(inputStr, ecLevel) {
        var mode = $pablohirafuji$elm_qrcode$QRCode$Encode$selectMode(inputStr);
        return A2($elm$core$Result$map, $pablohirafuji$elm_qrcode$QRCode$Encode$concatTranspose, A2($elm$core$Result$andThen, $pablohirafuji$elm_qrcode$QRCode$Encode$getErrorCorrection, A2($elm$core$Result$andThen, $pablohirafuji$elm_qrcode$QRCode$Encode$toBlocks, A2($elm$core$Result$map, $pablohirafuji$elm_qrcode$QRCode$Encode$addInfoAndFinalBits, A2($elm$core$Result$andThen, A3($pablohirafuji$elm_qrcode$QRCode$Encode$selectVersion, inputStr, ecLevel, mode), A2($pablohirafuji$elm_qrcode$QRCode$Encode$encoder, mode, inputStr))))));
    });
    var $pablohirafuji$elm_qrcode$QRCode$fromStringWith = F2(function(ecLevel, input) {
        return A2($elm$core$Result$mapError, $pablohirafuji$elm_qrcode$QRCode$convertError, A2($elm$core$Result$andThen, function(_v0) {
            var encodeModel = _v0.a;
            var encodedData = _v0.b;
            return A2($elm$core$Result$map, function(matrix) {
                return {
                    rq: matrix,
                    H2: encodeModel.ad3.H2
                };
            }, $pablohirafuji$elm_qrcode$QRCode$Matrix$apply(_Utils_Tuple2(encodeModel, encodedData)));
        }, A2($pablohirafuji$elm_qrcode$QRCode$Encode$encode, input, $pablohirafuji$elm_qrcode$QRCode$convertEC(ecLevel))));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize = 5;
    var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect = function(_v0) {
        var lastRect = _v0.a;
        var rowLines = _v0.b;
        return A2($elm$core$List$cons, 'h' + $elm$core$String$fromInt(lastRect.aih * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize), rowLines);
    };
    var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
    var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
    var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
    var $elm$svg$Svg$Attributes$shapeRendering = _VirtualDom_attribute('shape-rendering');
    var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
    var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
    var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
    var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
    var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines = F2(function(isDark, _v0) {
        var lastRect = _v0.a;
        var rowLines = _v0.b;
        return isDark ? !lastRect.ki ? _Utils_Tuple2(_Utils_update(lastRect, {
            aih: lastRect.aih + 1
        }), rowLines) : _Utils_Tuple2({
            ki: 0,
            aih: 1
        }, A2($elm$core$List$cons, $elm$core$String$concat(_List_fromArray([
            lastRect.aih > 0 ? 'h' + $elm$core$String$fromInt(lastRect.aih * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) : '',
            'm',
            $elm$core$String$fromInt(lastRect.ki * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize),
            ' 0'
        ])), rowLines)) : _Utils_Tuple2(_Utils_update(lastRect, {
            ki: lastRect.ki + 1
        }), rowLines);
    });
    var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
    var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow = F3(function(quietZoneSize, rowIndex, rowLines) {
        return A2($elm$core$List$cons, 'M0 ', A2($elm$core$List$cons, $elm$core$String$fromInt(rowIndex * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize), rowLines));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase = F3(function(quietZoneSize, extraAttrs, matrix) {
        var quietZonePx = quietZoneSize * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize;
        var sizePx = $elm$core$String$fromInt($elm$core$List$length(matrix) * $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize + 2 * quietZonePx);
        return A2($elm$svg$Svg$svg, _Utils_ap(_List_fromArray([
            $elm$svg$Svg$Attributes$viewBox('0 0 ' + (sizePx + (' ' + sizePx))),
            $elm$svg$Svg$Attributes$shapeRendering('crispEdges'),
            $elm$svg$Svg$Attributes$stroke('#000'),
            $elm$svg$Svg$Attributes$strokeWidth($elm$core$String$fromInt($pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize) + 'px')
        ]), extraAttrs), function(d) {
            return _List_fromArray([
                A2($elm$svg$Svg$path, _List_fromArray([
                    d,
                    $elm$svg$Svg$Attributes$transform('translate(' + ($elm$core$String$fromInt(quietZonePx) + (', ' + ($elm$core$String$fromFloat(quietZonePx + $pablohirafuji$elm_qrcode$QRCode$Render$Svg$moduleSize / 2) + ')')))),
                    $elm$svg$Svg$Attributes$style('stroke-width: 5px')
                ]), _List_Nil)
            ]);
        }($elm$svg$Svg$Attributes$d($elm$core$String$concat($elm$core$List$concat(A2($elm$core$List$indexedMap, $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewRow(quietZoneSize), A2($elm$core$List$map, A2($elm$core$Basics$composeR, A2($elm$core$List$foldl, $pablohirafuji$elm_qrcode$QRCode$Render$Svg$toRowLines, _Utils_Tuple2({
            ki: 0,
            aih: 0
        }, _List_Nil)), A2($elm$core$Basics$composeR, $pablohirafuji$elm_qrcode$QRCode$Render$Svg$appendLastRect, $elm$core$List$reverse)), matrix)))))));
    });
    var $pablohirafuji$elm_qrcode$QRCode$Render$Svg$view = $pablohirafuji$elm_qrcode$QRCode$Render$Svg$viewBase(4);
    var $pablohirafuji$elm_qrcode$QRCode$toSvg = F2(function(extraAttrs, _v0) {
        var matrix = _v0.rq;
        return A2($pablohirafuji$elm_qrcode$QRCode$Render$Svg$view, extraAttrs, matrix);
    });
    var $author$project$Pages$User$Mfa$viewQrSteps = function(mfa) {
        var qrCodeImage = function() {
            var _v0 = $author$project$Api$Platform$Mfa$One$qrcode(mfa);
            if (!_v0.$) {
                var qrcode_ = _v0.a;
                return A3($author$project$Ui$Image$fromSrc, {
                    Jg: 'QR Code'
                }, qrcode_, _List_Nil);
            } else return A2($elm$core$Result$withDefault, A2($author$project$Ui$Alert$danger, _List_Nil, _List_fromArray([
                $elm$html$Html$text('There was a problem generating the QR code, please contact us.')
            ])), A2($elm$core$Result$map, $pablohirafuji$elm_qrcode$QRCode$toSvg(_List_fromArray([
                $elm$svg$Svg$Attributes$width('200px'),
                $elm$svg$Svg$Attributes$height('200px')
            ])), A2($pablohirafuji$elm_qrcode$QRCode$fromStringWith, 2, $author$project$Api$Platform$Mfa$One$qrcodeUrl(mfa))));
        }();
        return _List_fromArray([
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Select the '),
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Scan Barcode')
                ])),
                $elm$html$Html$text(' option'),
                $elm$html$Html$text(' (or '),
                A3($author$project$Ui$Button$view, {
                    abP: 'Click here'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                    $author$project$Ui$Button$onClick($author$project$Pages$User$Mfa$SwitchToManual)
                ]), _List_fromArray([
                    $elm$html$Html$text('Click here')
                ])),
                $elm$html$Html$text(' if you are having issues scanning the code)')
            ])),
            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Scan the following barcode')
                ])),
                qrCodeImage
            ]))
        ]);
    };
    var $author$project$Pages$User$Mfa$viewInactiveMfa = F2(function(_v0, mfa) {
        var method = _v0.Gk;
        var otpCode = _v0.rO;
        var activatingMfa = _v0.kS;
        var requiresMfaPrerequisite = _v0.He;
        var requiresMfa = _v0.YL;
        return _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                !requiresMfa && requiresMfaPrerequisite ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('In order to require multi-factor authentication for all users accessing your account, please complete the setup of multi-factor authentication for your account by following the directions below. ')
                ])) : $author$project$Utils$Html$empty,
                requiresMfa ? A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('To protect patient information, one of your practices requires that all users enable multi-factor authentication to access their account. ')
                ])) : $author$project$Utils$Html$empty,
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('To Enable Multi-factor authentication (MFA), you\'ll need the '),
                    A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Google Authenticator')
                    ])),
                    $elm$html$Html$text(' app, which you can download from the '),
                    A3($author$project$Ui$Link$externalHref, 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_US', _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Google Play Store')
                    ])),
                    A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(' or the ')
                    ])),
                    A3($author$project$Ui$Link$externalHref, 'https://itunes.apple.com/us/app/google-authenticator/id388497605?mt=8', _List_Nil, _List_fromArray([
                        $elm$html$Html$text('Apple App Store.')
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offset(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$ul, _List_Nil, $elm$core$List$concat(_List_fromArray([
                        _List_fromArray([
                            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Open Google Authenticator on your phone.')
                            ])),
                            A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Tap the + button in Google Authenticator')
                            ]))
                        ]),
                        function() {
                            if (!method) return $author$project$Pages$User$Mfa$viewQrSteps(mfa);
                            else return $author$project$Pages$User$Mfa$viewManualSteps(mfa);
                        }(),
                        A2($author$project$Pages$User$Mfa$viewActivate, otpCode, activatingMfa)
                    ])))
                ]))
            ]))
        ]);
    });
    var $author$project$Pages$User$Mfa$viewInactiveMfaSkeleton = _List_fromArray([
        A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$block,
                $author$project$Ui$Skeleton$span(10)
            ])),
            A2($author$project$Ui$Grid$row, _List_fromArray([
                $author$project$Ui$Grid$mt2
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$column, _List_fromArray([
                    $author$project$Ui$Grid$offset(4)
                ]), _List_fromArray([
                    A2($elm$html$Html$ul, _List_fromArray([
                        $elm$html$Html$Attributes$class('list-none')
                    ]), _List_fromArray([
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Open Google Authenticator on your phone.')
                            ]))
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Tap the + button in Google Authenticator')
                            ]))
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$span(3)
                            ]))
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$card(_List_fromArray([
                                $author$project$Ui$Skeleton$span(4)
                            ]))
                        ])),
                        A2($elm$html$Html$li, _List_Nil, _List_fromArray([
                            $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$block,
                                $author$project$Ui$Skeleton$span(5)
                            ])),
                            $author$project$Ui$Skeleton$input(_List_fromArray([
                                $author$project$Ui$Skeleton$span(5)
                            ]))
                        ]))
                    ]))
                ]))
            ]))
        ]))
    ]);
    var $author$project$Pages$User$Mfa$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Multi-factor authentication (MFA)')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(12)
                            ]), function() {
                                var _v0 = model.f9;
                                if (_v0.$ === 3) {
                                    var mfa = _v0.a;
                                    var _v1 = $author$project$Api$Platform$Mfa$One$status(mfa);
                                    if (!_v1) return _List_fromArray([
                                        A2($elm$html$Html$div, _List_fromArray([
                                            $elm$html$Html$Attributes$class('text-center')
                                        ]), _List_fromArray([
                                            $author$project$Ui$Typography$heading(_List_fromArray([
                                                $elm$html$Html$text('You\'re all set!')
                                            ])),
                                            A2($author$project$Ui$Alert$info, _List_Nil, _List_fromArray([
                                                $elm$html$Html$text('You will be logged out and will need to login again.')
                                            ]))
                                        ]))
                                    ]);
                                    else return A2($author$project$Pages$User$Mfa$viewInactiveMfa, model, mfa);
                                } else return $author$project$Pages$User$Mfa$viewInactiveMfaSkeleton;
                            }())
                        ]))
                    ])),
                    function() {
                        var _v2 = model.f9;
                        if (_v2.$ === 3) {
                            var mfa = _v2.a;
                            var _v3 = $author$project$Api$Platform$Mfa$One$status(mfa);
                            if (_v3 === 1) return A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Security, _List_fromArray([
                                    $author$project$Ui$Link$buttonDefault
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Back')
                                ]))
                            ]));
                            else return $author$project$Ui$Panel$none;
                        } else return $author$project$Ui$Panel$none;
                    }()
                ]))
            ]),
            $2: 'Login'
        };
    };
    var $author$project$Pages$User$Mfa$page = $author$project$Spa$Page$applicationUser({
        aeq: $author$project$Pages$User$Mfa$init,
        aeR: $author$project$Pages$User$Mfa$load,
        ag3: $author$project$Pages$User$Mfa$save,
        ahE: $author$project$Pages$User$Mfa$subscriptions,
        aaO: $author$project$Pages$User$Mfa$update,
        aid: $author$project$Pages$User$Mfa$view
    });
    var $author$project$Pages$User$Organizations$Top$AdminActionsDropdownMsg = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$GoAsRoleDropdownMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$NavMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$PracticesDropdownMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Api$Platform$User$One$companiesCount = function(_v0) {
        var record = _v0.b;
        return record.LH;
    };
    var $author$project$Pages$User$Organizations$Top$GotCompanyRoles = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Api$Employer$Role$rolesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'roles'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Role$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Common$Role$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Role$rolesPath));
    });
    var $author$project$Pages$User$Organizations$Top$fetchCompanyRoles = function(apiClient) {
        return A2($author$project$Api$Employer$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotCompanyRoles);
    };
    var $author$project$Pages$User$Organizations$Top$GotCompanies = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$GotPartners = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$GotPractices = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$filterToValue = function(filter) {
        return 'with_flagged_notes';
    };
    var $author$project$Api$Platform$User$Company$companiesPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'companies'
    ]), $author$project$Api$Platform$User$userPath);
    var $author$project$Api$Platform$Company$All$Company = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$Company$Min$Company = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Company$Min$Record = F3(function(id, name, requiresMfa) {
        return {
            aef: id,
            zr: name,
            YL: requiresMfa
        };
    });
    var $author$project$Api$Platform$Company$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_mfa', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$Min$Record))));
    var $author$project$Api$Platform$Company$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Company$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Company$All$Record = F2(function(practice, organizationId) {
        return {
            afV: organizationId,
            W1: practice
        };
    });
    var $author$project$Api$Platform$Company$All$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'practice', $author$project$Api$Platform$Practice$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$All$Record)));
    var $author$project$Api$Platform$Company$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Company$All$recordDecoder, A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Company$Min$decoder, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Company$All$Company)));
    var $author$project$Api$Platform$User$Company$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Platform$User$Company$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$User$Company$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Platform$User$Company$list = F4(function(apiClient, optionals, maybeTracker, toMsg) {
        var request = function(req) {
            if (!maybeTracker.$) {
                var tracker = maybeTracker.a;
                return A2($author$project$Api$Data$requestWithTracker, tracker, req);
            } else return req;
        }(A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$User$Company$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Platform$User$Company$companiesPath)));
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$Company$All$decoder), toMsg, request);
    });
    var $author$project$Api$Platform$Partner$All$Partner = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Partner$Shared$Partner = $elm$core$Basics$identity;
    var $author$project$Api$Platform$Partner$Shared$Record = F6(function(id, name, requiresMfa, active, status, organizationId) {
        return {
            Ir: active,
            aef: id,
            zr: name,
            afV: organizationId,
            YL: requiresMfa,
            ahy: status
        };
    });
    var $author$project$Api$Platform$Partner$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'active', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_mfa', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$Partner$Shared$Record)))))));
    var $author$project$Api$Platform$Partner$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Partner$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$Partner$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$Partner$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$User$Partner$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        agq: $elm$core$Maybe$Nothing,
        ahs: A3($author$project$Api$Sort$withDefault, 'name', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Platform$User$Partner$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$User$Partner$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.agq;
                if (!_v0.$) {
                    var string = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'q', string)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Platform$User$Partner$partnersPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'partners'
    ]), $author$project$Api$Platform$User$userPath);
    var $author$project$Api$Platform$User$Partner$list = F4(function(apiClient, optionals, maybeTracker, toMsg) {
        var request = function(req) {
            if (!maybeTracker.$) {
                var tracker = maybeTracker.a;
                return A2($author$project$Api$Data$requestWithTracker, tracker, req);
            } else return req;
        }(A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$User$Partner$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Platform$User$Partner$partnersPath)));
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$Partner$All$decoder), toMsg, request);
    });
    var $author$project$Pages$User$Organizations$Top$organizationSearchTracker = function(q) {
        return 'organization-search-' + A2($elm$core$Maybe$withDefault, '', q);
    };
    var $author$project$Pages$User$Organizations$Top$fetchOrganizations = function(model) {
        var tracker = $author$project$Pages$User$Organizations$Top$organizationSearchTracker(model.agq);
        var _v0 = model.cQ;
        if (!_v0.$) switch(_v0.a){
            case 0:
                var _v1 = _v0.a;
                return A4($author$project$Api$Platform$User$Practice$list, model.Ej, function(d) {
                    return _Utils_update(d, {
                        Fw: A2($elm$core$Maybe$map, $author$project$Pages$User$Organizations$Top$filterToValue, model.G3),
                        af_: model.af_,
                        agq: model.agq
                    });
                }, $elm$core$Maybe$Just(tracker), $author$project$Pages$User$Organizations$Top$GotPractices);
            case 1:
                var _v2 = _v0.a;
                return A4($author$project$Api$Platform$User$Company$list, model.Ej, function(d) {
                    return _Utils_update(d, {
                        af_: model.af_,
                        agq: model.agq
                    });
                }, $elm$core$Maybe$Just(tracker), $author$project$Pages$User$Organizations$Top$GotCompanies);
            default:
                var _v3 = _v0.a;
                return A4($author$project$Api$Platform$User$Partner$list, model.Ej, function(d) {
                    return _Utils_update(d, {
                        af_: model.af_,
                        agq: model.agq
                    });
                }, $elm$core$Maybe$Just(tracker), $author$project$Pages$User$Organizations$Top$GotPartners);
        }
        else return $elm$core$Platform$Cmd$none;
    };
    var $author$project$Pages$User$Organizations$Top$GotPartnerRoles = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$fetchPartnerRoles = function(apiClient) {
        return A2($author$project$Api$Partner$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotPartnerRoles);
    };
    var $author$project$Pages$User$Organizations$Top$GotPracticeRoles = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$fetchPracticeRoles = function(apiClient) {
        return A2($author$project$Api$Provider$Role$list, apiClient, $author$project$Pages$User$Organizations$Top$GotPracticeRoles);
    };
    var $author$project$Pages$User$Organizations$Top$FocusResult = {
        $: 20
    };
    var $author$project$Pages$User$Organizations$Top$focusSearchInput = A2($elm$core$Task$attempt, function(_v0) {
        return $author$project$Pages$User$Organizations$Top$FocusResult;
    }, $elm$browser$Browser$Dom$focus('organization-search-input'));
    var $author$project$Api$Platform$User$One$partnersCount = function(_v0) {
        var record = _v0.b;
        return record.V2;
    };
    var $author$project$Api$Platform$User$One$practicesCount = function(_v0) {
        var record = _v0.b;
        return record.W8;
    };
    var $author$project$Pages$User$Organizations$Top$init = F4(function(session, user, shared, _v0) {
        var organizationTypes = $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Platform$User$One$practicesCount(user) > 0 ? _List_fromArray([
                0
            ]) : _List_Nil,
            $author$project$Api$Platform$User$One$companiesCount(user) > 0 ? _List_fromArray([
                1
            ]) : _List_Nil,
            $author$project$Api$Platform$User$One$partnersCount(user) > 0 ? _List_fromArray([
                2
            ]) : _List_Nil
        ]));
        var currentUserIsHintAdmin = $author$project$Api$Platform$User$Shared$isAdmin($author$project$Api$Platform$Session$One$user(session));
        var currentOrganizationType = $elm$core$List$head(organizationTypes);
        var _v1 = A2($author$project$Ui$Nav$init, 'organization-types', $author$project$Pages$User$Organizations$Top$NavMsg);
        var navModel = _v1.a;
        var navCmd = _v1.b;
        var model = {
            kY: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toDownLeft($author$project$Ui$Dropdown$defaultConfig({
                aef: 'admin-actions-dropdown',
                ahX: $author$project$Pages$User$Organizations$Top$AdminActionsDropdownMsg
            }))),
            Ej: shared.Ej,
            abT: shared.adU.abT,
            wO: _List_Nil,
            lK: $author$project$Api$Platform$Session$One$organization(session),
            cQ: currentOrganizationType,
            E2: user,
            E3: currentUserIsHintAdmin,
            mp: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$toDownLeft($author$project$Ui$Dropdown$defaultConfig({
                aef: 'go-as-role-dropdown',
                ahX: $author$project$Pages$User$Organizations$Top$GoAsRoleDropdownMsg
            }))),
            mu: shared.mu,
            F3: $author$project$Shared$isHintAdmin(shared),
            Tk: true,
            nb: navModel,
            ne: organizationTypes,
            rM: _List_Nil,
            af_: $author$project$Api$Pagination$init,
            V1: _List_Nil,
            Bc: _List_Nil,
            nE: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'practices-dropdown-filter',
                ahX: $author$project$Pages$User$Organizations$Top$PracticesDropdownMsg
            })),
            G3: $elm$core$Maybe$Nothing,
            agq: $elm$core$Maybe$Nothing,
            sG: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing),
            Z$: session
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            $author$project$Pages$User$Organizations$Top$fetchOrganizations(model),
            navCmd,
            currentUserIsHintAdmin && A2($elm$core$List$member, 0, organizationTypes) ? $author$project$Pages$User$Organizations$Top$fetchPracticeRoles(model.Ej) : $elm$core$Platform$Cmd$none,
            currentUserIsHintAdmin && A2($elm$core$List$member, 1, organizationTypes) ? $author$project$Pages$User$Organizations$Top$fetchCompanyRoles(model.Ej) : $elm$core$Platform$Cmd$none,
            currentUserIsHintAdmin && A2($elm$core$List$member, 2, organizationTypes) ? $author$project$Pages$User$Organizations$Top$fetchPartnerRoles(model.Ej) : $elm$core$Platform$Cmd$none,
            $author$project$Pages$User$Organizations$Top$focusSearchInput
        ])));
    });
    var $author$project$Pages$User$Organizations$Top$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            mu: shared.mu,
            F3: $author$project$Shared$isHintAdmin(shared)
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$User$Organizations$Top$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$User$Organizations$Top$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$Dropdown$subscriptions(model.nE),
            $author$project$Ui$Dropdown$subscriptions(model.kY),
            $author$project$Ui$Dropdown$subscriptions(model.mp),
            $author$project$Ui$Nav$subscriptions(model.nb)
        ]));
    };
    var $author$project$Pages$User$Organizations$Top$SearchInputMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$OutMsg$SwitchRole = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$OutMsg$SwitchToClinical = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$OutMsg$ToggleHighlightPhi = {
        $: 13
    };
    var $author$project$OutMsg$ToggleHinterView = {
        $: 12
    };
    var $author$project$Api$Platform$Company$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Platform$Company$All$id = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Company$Min$id(min);
    };
    var $author$project$Api$Platform$Company$Min$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Platform$Company$All$name = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Company$Min$name(min);
    };
    var $author$project$Api$Platform$Company$All$organizationId = function(_v0) {
        var record = _v0.b;
        return record.afV;
    };
    var $author$project$Api$Platform$Company$All$practice = function(_v0) {
        var record = _v0.b;
        return record.W1;
    };
    var $author$project$Api$Platform$Company$Min$requiresMfa = function(_v0) {
        var record = _v0;
        return record.YL;
    };
    var $author$project$Api$Platform$Company$All$requiresMfa = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Company$Min$requiresMfa(min);
    };
    var $author$project$Pages$User$Organizations$Top$companyToOrganization = function(company) {
        return {
            PR: 0,
            aef: $author$project$Api$Platform$Company$All$id(company),
            R$: false,
            aeT: $elm$core$Maybe$Nothing,
            zr: $author$project$Api$Platform$Company$All$name(company),
            afV: $author$project$Api$Platform$Company$All$organizationId(company),
            VM: $elm$core$Maybe$Nothing,
            agg: $elm$core$Maybe$Just($author$project$Api$Platform$Practice$Min$name($author$project$Api$Platform$Company$All$practice(company))),
            G7: $elm$core$Maybe$Nothing,
            YL: $author$project$Api$Platform$Company$All$requiresMfa(company),
            ah5: 1
        };
    };
    var $author$project$Api$Platform$Partner$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Platform$Partner$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$Partner$Shared$id(shared);
    };
    var $author$project$Api$Platform$Partner$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Platform$Partner$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$Partner$Shared$name(shared);
    };
    var $author$project$Api$Platform$Partner$Shared$organizationId = function(_v0) {
        var record = _v0;
        return record.afV;
    };
    var $author$project$Api$Platform$Partner$All$organizationId = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$Partner$Shared$organizationId(shared);
    };
    var $author$project$Api$Platform$Partner$Shared$requiresMfa = function(_v0) {
        var record = _v0;
        return record.YL;
    };
    var $author$project$Api$Platform$Partner$All$requiresMfa = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$Partner$Shared$requiresMfa(shared);
    };
    var $author$project$Api$Platform$Partner$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Platform$Partner$All$status = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$Partner$Shared$status(shared);
    };
    var $author$project$Pages$User$Organizations$Top$partnerToOrganization = function(partner) {
        return {
            PR: 0,
            aef: $author$project$Api$Platform$Partner$All$id(partner),
            R$: false,
            aeT: $elm$core$Maybe$Nothing,
            zr: _Utils_ap($author$project$Api$Platform$Partner$All$name(partner), A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(status) {
                return ' (' + (status + ')');
            }, $author$project$Api$Platform$Partner$All$status(partner)))),
            afV: $author$project$Api$Platform$Partner$All$organizationId(partner),
            VM: $elm$core$Maybe$Nothing,
            agg: $elm$core$Maybe$Nothing,
            G7: $elm$core$Maybe$Nothing,
            YL: $author$project$Api$Platform$Partner$All$requiresMfa(partner),
            ah5: 2
        };
    };
    var $author$project$Api$Platform$Practice$Min$flaggedNotesCount = function(_v0) {
        var record = _v0;
        return record.PR;
    };
    var $author$project$Api$Platform$Practice$All$flaggedNotesCount = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Practice$Min$flaggedNotesCount(min);
    };
    var $author$project$Api$Platform$Practice$Min$isDeactivated = function(_v0) {
        var record = _v0;
        return record.R$;
    };
    var $author$project$Api$Platform$Practice$All$isDeactivated = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Practice$Min$isDeactivated(min);
    };
    var $author$project$Api$Platform$Practice$All$organizationId = function(_v0) {
        var record = _v0.b;
        return record.afV;
    };
    var $author$project$Api$Platform$Practice$All$owner = function(_v0) {
        var record = _v0.b;
        return record.VM;
    };
    var $author$project$Api$Platform$Practice$All$productType = function(_v0) {
        var record = _v0.b;
        return record.G7;
    };
    var $author$project$Api$Platform$Practice$Min$requiresMfa = function(_v0) {
        var record = _v0;
        return record.YL;
    };
    var $author$project$Api$Platform$Practice$All$requiresMfa = function(_v0) {
        var min = _v0.a;
        return $author$project$Api$Platform$Practice$Min$requiresMfa(min);
    };
    var $author$project$Components$AddressDisplay$viewCityState = function(address) {
        var state = $author$project$Components$AddressDisplay$formatSegment($author$project$Api$Common$Address$Shared$state(address));
        var city = $author$project$Components$AddressDisplay$formatSegment($author$project$Api$Common$Address$Shared$city(address));
        var _v0 = _Utils_Tuple2(city, state);
        if (_v0.a === '') {
            if (_v0.b === '') return '';
            else {
                var stateStr = _v0.b;
                return stateStr;
            }
        } else if (_v0.b === '') {
            var cityStr = _v0.a;
            return cityStr;
        } else {
            var cityStr = _v0.a;
            var stateStr = _v0.b;
            return cityStr + (', ' + stateStr);
        }
    };
    var $author$project$Pages$User$Organizations$Top$practiceToOrganization = function(practice) {
        var location1 = function() {
            var _v0 = $author$project$Api$Platform$Practice$All$address(practice);
            if (!_v0.$) {
                var address = _v0.a;
                return $elm$core$Maybe$Just($author$project$Components$AddressDisplay$viewCityState(address));
            } else return $elm$core$Maybe$Just('');
        }();
        return {
            PR: $author$project$Api$Platform$Practice$All$flaggedNotesCount(practice),
            aef: $author$project$Api$Platform$Practice$All$id(practice),
            R$: $author$project$Api$Platform$Practice$All$isDeactivated(practice),
            aeT: location1,
            zr: $author$project$Api$Platform$Practice$All$name(practice),
            afV: $author$project$Api$Platform$Practice$All$organizationId(practice),
            VM: A2($elm$core$Maybe$map, $author$project$Api$Platform$User$Min$name, $author$project$Api$Platform$Practice$All$owner(practice)),
            agg: $elm$core$Maybe$Just($author$project$Api$Platform$Practice$All$name(practice)),
            G7: $elm$core$Maybe$Just($author$project$Api$Platform$Practice$All$productType(practice)),
            YL: $author$project$Api$Platform$Practice$All$requiresMfa(practice),
            ah5: 0
        };
    };
    var $author$project$Pages$User$Organizations$Top$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$ToggleHinterView
                ]));
            case 1:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$ToggleHighlightPhi
                ]));
            case 2:
                var navMsg = msg.a;
                var _v1 = A2($author$project$Ui$Nav$update, navMsg, model.nb);
                var nav = _v1.a;
                var navCmd = _v1.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    nb: nav
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Organizations$Top$NavMsg, navCmd), _List_Nil);
            case 3:
                var organizationType = msg.a;
                var newModel = _Utils_update(model, {
                    cQ: $elm$core$Maybe$Just(organizationType),
                    Tk: true,
                    rM: _List_Nil,
                    G3: $elm$core$Maybe$Nothing,
                    agq: $elm$core$Maybe$Nothing,
                    sG: $author$project$Ui$SearchInput$init($elm$core$Maybe$Nothing)
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel), _List_Nil);
            case 4:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$SearchInput$update, subMsg, model.sG);
                var searchInput = _v2.a;
                var searchInputCmd = _v2.b;
                var searchInputEvent = _v2.c;
                var q = function() {
                    if (searchInputEvent.$ === 1) {
                        var query = searchInputEvent.a;
                        return query;
                    } else return model.agq;
                }();
                var _v3 = function() {
                    if (_Utils_eq(q, model.agq)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    else {
                        var qModel = _Utils_update(model, {
                            agq: q
                        });
                        return _Utils_Tuple2(qModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $elm$http$Http$cancel($author$project$Pages$User$Organizations$Top$organizationSearchTracker(model.agq)),
                            $author$project$Pages$User$Organizations$Top$fetchOrganizations(qModel)
                        ])));
                    }
                }();
                var newModel = _v3.a;
                var cmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(newModel, {
                    sG: searchInput
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Organizations$Top$SearchInputMsg, searchInputCmd),
                    cmd
                ])), _List_Nil);
            case 5:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.af_);
                var newModel = _Utils_update(model, {
                    af_: pagination
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel), _List_Nil);
            case 6:
                var response = msg.a;
                if (!_Utils_eq(model.cQ, $elm$core$Maybe$Just(0))) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    if (response.$ === 3) {
                        var practices = response.a;
                        var headers = response.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Tk: false,
                            rM: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$practiceToOrganization, practices),
                            af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        Tk: false,
                        rM: _List_Nil
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            case 7:
                var response = msg.a;
                if (!_Utils_eq(model.cQ, $elm$core$Maybe$Just(1))) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    if (response.$ === 3) {
                        var companies = response.a;
                        var headers = response.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Tk: false,
                            rM: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$companyToOrganization, companies),
                            af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        Tk: false,
                        rM: _List_Nil
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            case 8:
                var response = msg.a;
                if (!_Utils_eq(model.cQ, $elm$core$Maybe$Just(2))) return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                else {
                    if (response.$ === 3) {
                        var partners = response.a;
                        var headers = response.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            Tk: false,
                            rM: A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$partnerToOrganization, partners),
                            af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.af_)
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(_Utils_update(model, {
                        Tk: false,
                        rM: _List_Nil
                    }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                }
            case 9:
                var organization = msg.a;
                var role = msg.b;
                var roleWithPrefix = function() {
                    var _v8 = _Utils_Tuple2(model.cQ, role);
                    if (!_v8.a.$ && !_v8.b.$) switch(_v8.a.a){
                        case 0:
                            var _v9 = _v8.a.a;
                            var role_ = _v8.b.a;
                            return $elm$core$Maybe$Just('practice_' + $author$project$Api$Common$Role$All$name(role_));
                        case 1:
                            var _v10 = _v8.a.a;
                            var role_ = _v8.b.a;
                            return $elm$core$Maybe$Just('company_' + $author$project$Api$Common$Role$All$name(role_));
                        default:
                            var _v11 = _v8.a.a;
                            var role_ = _v8.b.a;
                            return $elm$core$Maybe$Just('partner_' + $author$project$Api$Common$Role$All$name(role_));
                    }
                    else return $elm$core$Maybe$Nothing;
                }();
                var postOrganizationSwitchedAction = $author$project$Api$Platform$Session$One$sandbox(model.Z$) ? $author$project$OutMsg$GoToDefaultStateAndReloadAction : $author$project$OutMsg$GoToDefaultStateAction;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tk: true
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A3($author$project$OutMsg$SwitchToOrganization, organization.afV, roleWithPrefix, postOrganizationSwitchedAction)
                ]));
            case 10:
                var organization = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Tk: true
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$SwitchToClinical(organization.afV)
                ]));
            case 11:
                var subMsg = msg.a;
                var _v12 = A2($author$project$Ui$Dropdown$update, subMsg, model.mp);
                var dropdown = _v12.a;
                var dropdownCmd = _v12.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    mp: dropdown
                }), dropdownCmd, _List_Nil);
            case 12:
                var role = msg.a;
                var roleWithPrefix = function() {
                    var _v13 = A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, model.lK);
                    if (!_v13.$) switch(_v13.a){
                        case 0:
                            var _v14 = _v13.a;
                            return 'practice_' + $author$project$Api$Common$Role$All$name(role);
                        case 1:
                            var _v15 = _v13.a;
                            return 'company_' + $author$project$Api$Common$Role$All$name(role);
                        default:
                            var _v16 = _v13.a;
                            return 'partner_' + $author$project$Api$Common$Role$All$name(role);
                    }
                    else return $author$project$Api$Common$Role$All$name(role);
                }();
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    $author$project$OutMsg$SwitchRole(roleWithPrefix)
                ]));
            case 13:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    Bc: A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 14:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    wO: A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 15:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    V1: A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(response))
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
            case 16:
                var subMsg = msg.a;
                var _v17 = A2($author$project$Ui$Dropdown$update, subMsg, model.nE);
                var dropdown = _v17.a;
                var dropdownCmd = _v17.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    nE: dropdown
                }), dropdownCmd, _List_Nil);
            case 18:
                var subMsg = msg.a;
                var _v18 = A2($author$project$Ui$Dropdown$update, subMsg, model.kY);
                var dropdown = _v18.a;
                var dropdownCmd = _v18.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    kY: dropdown
                }), dropdownCmd, _List_Nil);
            case 17:
                var selected = msg.a;
                var newModel = _Utils_update(model, {
                    Tk: true,
                    rM: _List_Nil,
                    G3: selected
                });
                return _Utils_Tuple3(newModel, $author$project$Pages$User$Organizations$Top$fetchOrganizations(newModel), _List_Nil);
            case 19:
                var text = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(text), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
                ]));
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$User$Organizations$Top$GoAsRole = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$currentOrgRoles = function(model) {
        var _v0 = A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, model.lK);
        if (!_v0.$) switch(_v0.a){
            case 0:
                var _v1 = _v0.a;
                return model.Bc;
            case 1:
                var _v2 = _v0.a;
                return model.wO;
            default:
                var _v3 = _v0.a;
                return model.V1;
        }
        else return _List_Nil;
    };
    var $author$project$Pages$User$Organizations$Top$PaginationMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$Autofocus = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$autofocus = $author$project$Ui$SearchInput$Autofocus;
    var $author$project$Ui$SearchInput$Id = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Ui$SearchInput$id = $author$project$Ui$SearchInput$Id;
    var $author$project$Pages$User$Organizations$Top$CopyToClipboard = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Api$Platform$User$One$isMfaActive = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$isMfaActive(shared);
    };
    var $author$project$Pages$User$Organizations$Top$mfaRequiredButDisabled = F2(function(currentUser, organization) {
        return organization.YL && !$author$project$Api$Platform$User$One$isMfaActive(currentUser);
    });
    var $author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage = F2(function(currentUser, organization) {
        return A2($author$project$Pages$User$Organizations$Top$mfaRequiredButDisabled, currentUser, organization) ? $elm$core$Maybe$Just(A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            $elm$html$Html$text('MFA is required for this practice. Click '),
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Mfa, _List_Nil, _List_fromArray([
                $elm$html$Html$text('here')
            ])),
            $elm$html$Html$text(' to enable it.')
        ]))) : $elm$core$Maybe$Nothing;
    });
    var $author$project$Pages$User$Organizations$Top$canSwitchOrganization = F2(function(currentUser, organization) {
        return _Utils_eq(A2($author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage, currentUser, organization), $elm$core$Maybe$Nothing);
    });
    var $author$project$Pages$User$Organizations$Top$isCurrentOrganization = F2(function(currentOrganization, organization) {
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(currentOrganization_) {
            return _Utils_eq($author$project$Api$Platform$Organization$Shared$type_(currentOrganization_), organization.ah5) && _Utils_eq($author$project$Api$Platform$Organization$Shared$id(currentOrganization_), organization.aef);
        }, currentOrganization));
    });
    var $author$project$Ui$Element$mr1 = $author$project$Ui$Element$Margin('mr-1');
    var $author$project$Pages$User$Organizations$Top$SwitchToOrganization = F2(function(a, b) {
        return {
            $: 9,
            a: a,
            b: b
        };
    });
    var $author$project$Ui$Button$Aligned = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Ui$Button$aligned = $author$project$Ui$Button$Aligned;
    var $author$project$Pages$User$Organizations$Top$viewOrganizationNameCell = F2(function(isLoading, organization) {
        var name = organization.R$ ? organization.zr + ' (deactivated)' : organization.zr;
        return A3($author$project$Ui$Button$view, {
            abP: 'Switch to ' + name
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick(A2($author$project$Pages$User$Organizations$Top$SwitchToOrganization, organization, $elm$core$Maybe$Nothing)),
            $author$project$Ui$Button$disabled(isLoading),
            $author$project$Ui$Button$aligned($author$project$Ui$Alignment$textLeft)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$gap2
            ]), _List_fromArray([
                $elm$html$Html$text(name),
                organization.ah5 === 1 ? A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textSm,
                    $author$project$Ui$Element$textSm
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', organization.agg))
                ])) : $author$project$Utils$Html$empty,
                organization.PR > 0 && !organization.ah5 ? $author$project$Ui$Icon$flag(_List_Nil) : $author$project$Utils$Html$empty
            ]))
        ]));
    });
    var $author$project$Pages$User$Organizations$Top$SwitchToClinical = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$viewProductOptions = function(_v0) {
        var organization = _v0.VA;
        var isCurrentOrganization_ = _v0.RZ;
        var currentUser = _v0.E2;
        var backupAuthEnabled = _v0.abT;
        var isLoading = _v0.c_;
        var _v1 = _Utils_Tuple2(isCurrentOrganization_, A2($author$project$Pages$User$Organizations$Top$cantSwitchOrganizationMessage, currentUser, organization));
        if (_v1.a) return A2($author$project$Ui$Typography$span, _List_fromArray([
            $author$project$Ui$Typography$muted,
            $author$project$Ui$Typography$pull(1)
        ]), _List_fromArray([
            $elm$html$Html$text('active')
        ]));
        else if (!_v1.b.$) {
            var message = _v1.b.a;
            return A2($author$project$Ui$Badge$view, _List_fromArray([
                $author$project$Ui$Badge$danger
            ]), _List_fromArray([
                message
            ]));
        } else {
            var _v2 = _v1.b;
            return A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$pull(1)
            ]), _List_fromArray([
                $author$project$Ui$Button$group(_List_fromArray([
                    function() {
                        var _v3 = organization.G7;
                        if (!_v3.$ && _v3.a === 'Clinical') {
                            var switchToClinicalButton = A3($author$project$Ui$Button$view, {
                                abP: 'Switch to clinical'
                            }, _List_fromArray([
                                $author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$SwitchToClinical(organization)),
                                $author$project$Ui$Button$disabled(backupAuthEnabled || isLoading)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Clinical '),
                                $author$project$Ui$Icon$arrowRight(_List_fromArray([
                                    $author$project$Ui$Icon$xs,
                                    $author$project$Ui$Icon$info
                                ]))
                            ]));
                            return backupAuthEnabled ? A3($author$project$Ui$Popover$view, _List_Nil, _List_fromArray([
                                $author$project$Ui$Button$group(_List_fromArray([
                                    switchToClinicalButton
                                ]))
                            ]), _List_fromArray([
                                A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text('The Clinical app is temporarily unavailable due to the sign-in system outage.')
                                ]))
                            ])) : switchToClinicalButton;
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Switch to core'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick(A2($author$project$Pages$User$Organizations$Top$SwitchToOrganization, organization, $elm$core$Maybe$Nothing)),
                        $author$project$Ui$Button$disabled(isLoading),
                        $author$project$Ui$Button$loading(isLoading)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Core '),
                        $author$project$Ui$Icon$arrowRight(_List_fromArray([
                            $author$project$Ui$Icon$xs,
                            $author$project$Ui$Icon$info
                        ]))
                    ]))
                ]))
            ]));
        }
    };
    var $author$project$Pages$User$Organizations$Top$viewOrganizationRow = F2(function(model, organization) {
        var isCurrentOrganization_ = A2($author$project$Pages$User$Organizations$Top$isCurrentOrganization, model.lK, organization);
        var productSwitcherParams = {
            abT: model.abT,
            E2: model.E2,
            RZ: isCurrentOrganization_,
            c_: model.Tk,
            VA: organization
        };
        var rowOptions = isCurrentOrganization_ ? _List_fromArray([
            $author$project$Ui$Table$styled(1)
        ]) : !A2($author$project$Pages$User$Organizations$Top$canSwitchOrganization, model.E2, organization) ? _List_fromArray([
            $author$project$Ui$Table$styled(4)
        ]) : organization.R$ ? _List_fromArray([
            $author$project$Ui$Table$styled(3)
        ]) : _List_Nil;
        var _v0 = _Utils_Tuple2(model.F3, organization.ah5);
        if (_v0.a) switch(_v0.b){
            case 0:
                var _v1 = _v0.b;
                return A2($author$project$Ui$Table$row, rowOptions, _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.Tk, organization)
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', organization.VM))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', organization.aeT))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', organization.G7))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$inlineBlock,
                            $author$project$Ui$Element$mr1
                        ]), _List_fromArray([
                            $elm$html$Html$text(organization.aef)
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy organization id'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.aef)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                        ]), _List_Nil)
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$inlineBlock,
                            $author$project$Ui$Element$mr1
                        ]), _List_fromArray([
                            $elm$html$Html$text(organization.afV)
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy organization identifier'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.afV)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                        ]), _List_Nil)
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
                    ]))
                ]));
            case 2:
                var _v2 = _v0.b;
                return A2($author$project$Ui$Table$row, rowOptions, _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.Tk, organization)
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$inlineBlock,
                            $author$project$Ui$Element$mr1
                        ]), _List_fromArray([
                            $elm$html$Html$text(organization.aef)
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy organization id'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.aef)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                        ]), _List_Nil)
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$inlineBlock,
                            $author$project$Ui$Element$mr1
                        ]), _List_fromArray([
                            $elm$html$Html$text(organization.afV)
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy organization identifier'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.afV)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                        ]), _List_Nil)
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
                    ]))
                ]));
            default:
                var _v3 = _v0.b;
                return A2($author$project$Ui$Table$row, rowOptions, _List_fromArray([
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.Tk, organization)
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$inlineBlock,
                            $author$project$Ui$Element$mr1
                        ]), _List_fromArray([
                            $elm$html$Html$text(organization.aef)
                        ])),
                        A3($author$project$Ui$Button$view, {
                            abP: 'Copy organization id'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$CopyToClipboard(organization.aef)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                        ]), _List_Nil)
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', organization.agg))
                    ])),
                    A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                        $author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
                    ]))
                ]));
        }
        else return A2($author$project$Ui$Table$row, rowOptions, _List_fromArray([
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                A2($author$project$Pages$User$Organizations$Top$viewOrganizationNameCell, model.Tk, organization)
            ])),
            A2($author$project$Ui$Table$cell, _List_Nil, _List_fromArray([
                $author$project$Pages$User$Organizations$Top$viewProductOptions(productSwitcherParams)
            ]))
        ]));
    });
    var $author$project$Pages$User$Organizations$Top$filterToLabel = function(filter) {
        if (filter.$ === 1) return 'All Practices';
        else {
            var _v1 = filter.a;
            return 'Has Flagged Notes';
        }
    };
    var $author$project$Pages$User$Organizations$Top$PracticesFilterSelected = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Pages$User$Organizations$Top$WithFlaggedNotes = 0;
    var $author$project$Pages$User$Organizations$Top$practicesDropdownOptions = function(currentFilter) {
        var filterToItem = function(filter) {
            return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                $author$project$Ui$Dropdown$onSelect($author$project$Pages$User$Organizations$Top$PracticesFilterSelected(filter)),
                $author$project$Ui$Dropdown$selected(_Utils_eq(filter, currentFilter))
            ]), $elm$html$Html$text($author$project$Pages$User$Organizations$Top$filterToLabel(filter)));
        };
        return _List_fromArray([
            filterToItem($elm$core$Maybe$Nothing),
            $author$project$Ui$Dropdown$separator,
            filterToItem($elm$core$Maybe$Just(0))
        ]);
    };
    var $author$project$Pages$User$Organizations$Top$viewPracticesDropdown = function(model) {
        return A4($author$project$Ui$Dropdown$viewSelect, _List_Nil, _List_fromArray([
            $elm$html$Html$text($author$project$Pages$User$Organizations$Top$filterToLabel(model.G3))
        ]), $author$project$Pages$User$Organizations$Top$practicesDropdownOptions(model.G3), model.nE);
    };
    var $author$project$Pages$User$Organizations$Top$toPane = F2(function(model, organizationType) {
        var showPracticeFilters = !organizationType && model.F3;
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(showPracticeFilters ? 10 : 12)
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, $author$project$Pages$User$Organizations$Top$SearchInputMsg, A2($author$project$Ui$SearchInput$view, _List_fromArray([
                            $author$project$Ui$SearchInput$loading(model.Tk),
                            $author$project$Ui$SearchInput$autofocus(true),
                            $author$project$Ui$SearchInput$id('organization-search-input')
                        ]), model.sG))
                    ])),
                    showPracticeFilters ? A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(2)
                    ]), _List_fromArray([
                        $author$project$Pages$User$Organizations$Top$viewPracticesDropdown(model)
                    ])) : $author$project$Ui$Grid$none
                ]))
            ])),
            A4($author$project$Ui$Panel$table, _List_fromArray([
                $author$project$Ui$Table$zeroState(_List_fromArray([
                    $elm$html$Html$text('No results')
                ])),
                $author$project$Ui$Table$loading(model.Tk)
            ]), function() {
                var _v0 = _Utils_Tuple2(model.F3, organizationType);
                if (_v0.a) switch(_v0.b){
                    case 0:
                        var _v1 = _v0.b;
                        return _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Practice Name')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Owner')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Location')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Product')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Practice ID')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Org ID')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('')
                            ]))
                        ]);
                    case 2:
                        var _v2 = _v0.b;
                        return _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Partner Name')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Partner ID')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Org ID')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('')
                            ]))
                        ]);
                    default:
                        var _v3 = _v0.b;
                        return _List_fromArray([
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Company Name')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Company ID')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Practice Name')
                            ])),
                            A2($author$project$Ui$Table$header, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('')
                            ]))
                        ]);
                }
                else return _List_Nil;
            }(), A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$viewOrganizationRow(model), model.rM), _List_Nil),
            $elm$core$List$length(model.ne) > 0 ? A2($author$project$Ui$Panel$footer, _List_Nil, _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$User$Organizations$Top$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_))
            ])) : $author$project$Ui$Panel$none
        ]));
    });
    var $author$project$Pages$User$Organizations$Top$ToggleHighlightPhi = {
        $: 1
    };
    var $author$project$Pages$User$Organizations$Top$viewHighlightPhiToggle = function(highlightPhi) {
        return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Toggle PHI highlighting'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                $author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$ToggleHighlightPhi)
            ]), _List_fromArray([
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('clickable clickable-badge')
                ]), _List_fromArray([
                    $elm$html$Html$text('Highlight Phi: '),
                    highlightPhi ? $elm$html$Html$text('ON') : $elm$html$Html$text('OFF')
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$User$Organizations$Top$ToggleHinterView = {
        $: 0
    };
    var $author$project$Pages$User$Organizations$Top$viewHinterViewToggle = function(isHintAdmin) {
        var label = $elm$core$String$concat(_List_fromArray([
            'as ',
            isHintAdmin ? '' : 'NON-',
            'hinter'
        ]));
        return A3($author$project$Ui$HinterOnly$button, {
            abP: label
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
            $author$project$Ui$Button$onClick($author$project$Pages$User$Organizations$Top$ToggleHinterView)
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ]));
    };
    var $author$project$Pages$User$Organizations$Top$TabClicked = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Api$OrganizationType$toString = function(organizationType) {
        switch(organizationType){
            case 0:
                return 'practice';
            case 1:
                return 'company';
            default:
                return 'partner';
        }
    };
    var $author$project$Pages$User$Organizations$Top$toTab = function(organizationType) {
        switch(organizationType){
            case 0:
                return $elm$html$Html$text('Practices');
            case 1:
                return $elm$html$Html$text('Companies');
            default:
                return $elm$html$Html$text('Partners');
        }
    };
    var $author$project$Pages$User$Organizations$Top$viewNavItem = F2(function(currentType, orgType) {
        return A2($author$project$Ui$Nav$item, _List_fromArray([
            $author$project$Ui$Nav$itemId($author$project$Api$OrganizationType$toString(orgType)),
            $author$project$Ui$Nav$activeItem(_Utils_eq(currentType, $elm$core$Maybe$Just(orgType))),
            $author$project$Ui$Nav$onItemClick($author$project$Pages$User$Organizations$Top$TabClicked(orgType))
        ]), _List_fromArray([
            $author$project$Pages$User$Organizations$Top$toTab(orgType)
        ]));
    });
    var $author$project$Pages$User$Organizations$Top$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                        $author$project$Ui$Panel$title(_List_fromArray([
                            $elm$html$Html$text('Choose Organization')
                        ]))
                    ])),
                    A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$spaceBetween
                        ]), _List_fromArray([
                            function() {
                                var _v0 = model.lK;
                                if (!_v0.$) {
                                    var currentOrganization = _v0.a;
                                    return A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('You are currently administering '),
                                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                                            $elm$html$Html$text($author$project$Api$Platform$Organization$Shared$name(currentOrganization))
                                        ])),
                                        $author$project$Utils$Html$noBreakSpace,
                                        model.E3 ? $author$project$Pages$User$Organizations$Top$viewHinterViewToggle(model.F3) : $author$project$Utils$Html$empty,
                                        model.F3 ? $author$project$Pages$User$Organizations$Top$viewHighlightPhiToggle(model.mu) : $author$project$Utils$Html$empty
                                    ]));
                                } else return $author$project$Utils$Html$empty;
                            }(),
                            model.F3 ? A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$gap2,
                                $author$project$Ui$Element$itemsCenter
                            ]), _List_fromArray([
                                !$elm$core$List$isEmpty($author$project$Pages$User$Organizations$Top$currentOrgRoles(model)) ? A4($author$project$Ui$HinterOnly$dropdown, _List_fromArray([
                                    $author$project$Ui$Dropdown$buttonSecondary
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Go As Role')
                                ]), A2($elm$core$List$map, function(role) {
                                    return A2($author$project$Ui$Dropdown$item, _List_fromArray([
                                        $author$project$Ui$Dropdown$onSelect($author$project$Pages$User$Organizations$Top$GoAsRole(role))
                                    ]), $elm$html$Html$text('Go as ' + $author$project$Api$Common$Role$All$name(role)));
                                }, $author$project$Pages$User$Organizations$Top$currentOrgRoles(model)), model.mp) : $author$project$Utils$Html$empty,
                                A4($author$project$Ui$HinterOnly$dropdown, _List_fromArray([
                                    $author$project$Ui$Dropdown$buttonSecondary
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Hinter Actions')
                                ]), _List_fromArray([
                                    A3($author$project$Ui$Dropdown$link, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__ClonePractice), _List_Nil, $elm$html$Html$text('Clone practice')),
                                    A3($author$project$Ui$Dropdown$link, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewPractice), _List_Nil, $elm$html$Html$text('Create new practice')),
                                    A3($author$project$Ui$Dropdown$link, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewPartner), _List_Nil, $elm$html$Html$text('Create new partner')),
                                    A3($author$project$Ui$Dropdown$link, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__NewGroup), _List_Nil, $elm$html$Html$text('Create new group')),
                                    $author$project$Ui$Dropdown$separator,
                                    A3($author$project$Ui$Dropdown$link, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__Disputes), _List_Nil, $elm$html$Html$text('Manage Disputes')),
                                    A3($author$project$Ui$Dropdown$link, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top), _List_Nil, $elm$html$Html$text('Manage Admin Users Groups')),
                                    A3($author$project$Ui$Dropdown$link, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Hinter__FeatureFlags), _List_Nil, $elm$html$Html$text('Manage Feature Flags'))
                                ]), model.kY)
                            ])) : $author$project$Utils$Html$empty
                        ])),
                        $elm$core$List$length(model.ne) > 1 ? A3($author$project$Ui$Nav$view, _List_Nil, A2($elm$core$List$map, $author$project$Pages$User$Organizations$Top$viewNavItem(model.cQ), model.ne), model.nb) : $author$project$Utils$Html$empty,
                        $elm$core$List$length(model.ne) > 0 ? A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, $author$project$Pages$User$Organizations$Top$toPane(model), model.cQ)) : $author$project$Utils$Html$empty
                    ]))
                ]))
            ]),
            $2: 'Switch Organization'
        };
    };
    var $author$project$Pages$User$Organizations$Top$page = $author$project$Spa$Page$applicationUser({
        aeq: $author$project$Pages$User$Organizations$Top$init,
        aeR: $author$project$Pages$User$Organizations$Top$load,
        ag3: $author$project$Pages$User$Organizations$Top$save,
        ahE: $author$project$Pages$User$Organizations$Top$subscriptions,
        aaO: $author$project$Pages$User$Organizations$Top$update,
        aid: $author$project$Pages$User$Organizations$Top$view
    });
    var $author$project$Api$Practice$hasClinicalAccount = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$hasClinicalAccount(practice_);
        } else return false;
    };
    var $author$project$Api$Platform$User$Shared$identityProviderId = function(_v0) {
        var record = _v0;
        return record.Q1;
    };
    var $author$project$Api$Platform$User$One$identityProviderId = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$identityProviderId(shared);
    };
    var $author$project$Api$Platform$User$One$email = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$email(shared);
    };
    var $author$project$Api$Platform$User$One$firstName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$firstName(shared);
    };
    var $author$project$Api$Platform$User$One$lastName = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$lastName(shared);
    };
    var $author$project$Pages$User$Profile$initFormFields = function(user) {
        return {
            OH: $author$project$Api$Platform$User$One$email(user),
            PN: $author$project$Api$Platform$User$One$firstName(user),
            SU: $author$project$Api$Platform$User$One$lastName(user),
            HM: $author$project$Api$Platform$User$One$termsAccepted(user)
        };
    };
    var $author$project$Pages$User$Profile$initPhoneInput = function(phones) {
        return A3($author$project$Components$PhoneInput$init, 'user-phone-input', A2($elm$core$List$map, $author$project$Utils$Phone$fromApi, phones), $elm$core$Basics$identity);
    };
    var $author$project$Api$Platform$User$One$phones = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$phones(shared);
    };
    var $author$project$Ports$Navigation$navigationPortRequestUrl = _Platform_outgoingPort('navigationPortRequestUrl', function($) {
        var a = $.a;
        var b = $.b;
        var c = $.c;
        return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([
            $elm$json$Json$Encode$string(a),
            $elm$json$Json$Encode$bool(b),
            $elm$json$Json$Encode$bool(c)
        ]));
    });
    var $author$project$Ports$Navigation$requestUrl = F3(function(href, isLocal, shouldOpenInNewWindow) {
        return $author$project$Ports$Navigation$navigationPortRequestUrl(_Utils_Tuple3(href, isLocal, shouldOpenInNewWindow));
    });
    var $author$project$Pages$User$Profile$init = F4(function(_v0, user, shared, _v1) {
        var redirectCmd = function() {
            var _v2 = $author$project$Api$Data$toMaybe(shared.W1);
            if (!_v2.$) {
                var practice = _v2.a;
                if ($author$project$Api$Practice$hasClinicalAccount(practice) && A2($author$project$Api$Practice$featureEnabled, 19, practice)) {
                    var _v3 = $author$project$Api$Platform$User$One$identityProviderId(user);
                    if (!_v3.$) {
                        var ipId = _v3.a;
                        return A3($author$project$Ports$Navigation$requestUrl, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo({
                            ahL: ipId
                        })), true, false);
                    } else return $elm$core$Platform$Cmd$none;
                } else return $elm$core$Platform$Cmd$none;
            } else return $elm$core$Platform$Cmd$none;
        }();
        var emailDisabled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Practice$hasClinicalAccount, $author$project$Api$Data$toMaybe(shared.W1)));
        return _Utils_Tuple2({
            Ej: shared.Ej,
            Fl: emailDisabled,
            PU: $author$project$Utils$Form$init($author$project$Pages$User$Profile$initFormFields(user)),
            bA: $author$project$Pages$User$Profile$initPhoneInput($author$project$Api$Platform$User$One$phones(user)),
            tz: $author$project$Api$Data$NotAsked,
            aaX: user
        }, redirectCmd);
    });
    var $author$project$Pages$User$Profile$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$User$Profile$save = F2(function(model, shared) {
        var _v0 = model.tz;
        if (_v0.$ === 3) return _Utils_update(shared, {
            aaX: model.tz
        });
        else return shared;
    });
    var $author$project$Pages$User$Profile$GotPhoneInputMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$User$Profile$subscriptions = function(model) {
        return A2($elm$core$Platform$Sub$map, $author$project$Pages$User$Profile$GotPhoneInputMsg, $author$project$Components$PhoneInput$subscriptions(model.bA));
    };
    var $author$project$Pages$User$Profile$formFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var firstName = field.a;
                return _Utils_update(fields, {
                    PN: firstName
                });
            case 1:
                var lastName = field.a;
                return _Utils_update(fields, {
                    SU: lastName
                });
            case 2:
                var email = field.a;
                return _Utils_update(fields, {
                    OH: email
                });
            default:
                var bool = field.a;
                return _Utils_update(fields, {
                    HM: bool
                });
        }
    });
    var $author$project$Pages$User$Profile$EmailValidation = 0;
    var $author$project$Pages$User$Profile$TermsAcceptedValidation = 1;
    var $author$project$Pages$User$Profile$formFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A3($author$project$Utils$Validate$ifInvalidEmail, {
            abH: false
        }, A2($elm$core$Basics$composeR, function($) {
            return $.OH;
        }, $elm$core$Maybe$Just), _Utils_Tuple2(0, 'Please enter a valid email.')),
        A2($rtfeldman$elm_validate$Validate$ifFalse, function($) {
            return $.HM;
        }, _Utils_Tuple2(1, 'Please accept this platform\'s terms.'))
    ]));
    var $author$project$Pages$User$Profile$GotUpdatedUser = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Platform$User$update = F4(function(apiClient, fields, phones_, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('user', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('first_name', $elm$json$Json$Encode$string(fields.PN)),
                _Utils_Tuple2('last_name', $elm$json$Json$Encode$string(fields.SU)),
                _Utils_Tuple2('email', $elm$json$Json$Encode$string(fields.OH)),
                _Utils_Tuple2('terms_accepted', $elm$json$Json$Encode$bool(fields.HM)),
                _Utils_Tuple2('phones', A2($elm$json$Json$Encode$list, $author$project$Api$Common$Phone$Shared$encode, phones_))
            ])))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Platform$User$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$User$userPath)));
    });
    var $author$project$Pages$User$Profile$updateUser = F3(function(apiClient, formFields, phones) {
        return A4($author$project$Api$Platform$User$update, apiClient, $rtfeldman$elm_validate$Validate$fromValid(formFields), A2($elm$core$List$map, $author$project$Utils$Phone$toRecord, phones), $author$project$Pages$User$Profile$GotUpdatedUser);
    });
    var $author$project$Pages$User$Profile$update = F2(function(msg, model) {
        switch(msg.$){
            case 3:
                var field = msg.a;
                var newForm = A3($author$project$Utils$Form$update, $author$project$Pages$User$Profile$formFieldsUpdate, field, model.PU);
                var validatedForm = function() {
                    var _v1 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Profile$formFieldsValidator, newForm);
                    if (!_v1.$) {
                        var _v2 = _v1.a;
                        var form = _v2.a;
                        return form;
                    } else {
                        var form = _v1.a;
                        return form;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    PU: validatedForm
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var _v3 = _Utils_Tuple2(A2($author$project$Utils$Form$validate, $author$project$Pages$User$Profile$formFieldsValidator, model.PU), $author$project$Components$PhoneInput$getPhones(model.bA));
                if (!_v3.a.$) {
                    if (!_v3.b.$) {
                        var _v4 = _v3.a.a;
                        var newForm = _v4.a;
                        var validFormFields = _v4.b;
                        var phones = _v3.b.a;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: newForm
                        }), A3($author$project$Pages$User$Profile$updateUser, model.Ej, validFormFields, phones), _List_Nil);
                    } else {
                        var _v5 = _v3.a.a;
                        var newForm = _v5.a;
                        var _v6 = _v3.b;
                        return _Utils_Tuple3(_Utils_update(model, {
                            PU: newForm
                        }), $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                } else {
                    var newForm = _v3.a.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var dataUser = msg.a;
                if (dataUser.$ === 3) {
                    var user = dataUser.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        PU: $author$project$Utils$Form$init($author$project$Pages$User$Profile$initFormFields(user)),
                        bA: $author$project$Pages$User$Profile$initPhoneInput($author$project$Api$Platform$User$One$phones(user)),
                        tz: dataUser,
                        aaX: user
                    }), $elm$core$Platform$Cmd$none, _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Your profile has been updated')
                    ]));
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataUser));
            default:
                var subMsg = msg.a;
                var _v8 = A2($author$project$Components$PhoneInput$update, subMsg, model.bA);
                var updatedPhoneInput = _v8.a;
                var phoneCmd = _v8.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    bA: updatedPhoneInput
                }), A2($elm$core$Platform$Cmd$map, $author$project$Pages$User$Profile$GotPhoneInputMsg, phoneCmd), _List_Nil);
        }
    });
    var $author$project$Pages$User$Profile$UpdateUser = {
        $: 1
    };
    var $author$project$Pages$User$Profile$Email = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$User$Profile$FirstName = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$User$Profile$FormFieldUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$User$Profile$LastName = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$User$Profile$TermsAccepted = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$User$Profile$viewAcceptTerms = F2(function(user, form) {
        if ($author$project$Api$Platform$User$One$termsAccepted(user)) return _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Ui$Icon$check(_List_fromArray([
                    $author$project$Ui$Icon$success
                ])),
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text(' You agreed to this software platform\'s')
                ])),
                A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$termsUrl, _List_fromArray([
                    $author$project$Ui$Link$targetBlank
                ]), _List_fromArray([
                    $elm$html$Html$text(' Terms of Service.')
                ]))
            ]))
        ]);
        else {
            var _v0 = $author$project$Utils$Form$fields(form);
            var termsAccepted = _v0.HM;
            return _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Form$Checkbox$view, _List_fromArray([
                        $author$project$Ui$Form$Checkbox$value(termsAccepted),
                        $author$project$Ui$Form$Checkbox$required(true),
                        $author$project$Ui$Form$Checkbox$onCheck(A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$TermsAccepted))
                    ]), _List_fromArray([
                        A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('I agree to this software platform\'s'),
                            A3($author$project$Ui$Link$externalHref, $author$project$Utils$HintUrls$termsUrl, _List_fromArray([
                                $author$project$Ui$Link$targetBlank
                            ]), _List_fromArray([
                                $elm$html$Html$text(' Terms of Service.')
                            ]))
                        ]))
                    ])),
                    $author$project$Utils$FormErrors$view(A2($author$project$Utils$Form$validationErrors, 1, form))
                ]))
            ]);
        }
    });
    var $author$project$Pages$User$Profile$viewProfileFields = F4(function(user, form, phoneInput, emailDisabled) {
        var _v0 = $author$project$Utils$Form$fields(form);
        var firstName = _v0.PN;
        var lastName = _v0.SU;
        var email = _v0.OH;
        return _List_fromArray([
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Name'),
                $author$project$Ui$Form$Group$labelSpanSm(4)
            ]), _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(firstName),
                            $author$project$Ui$Form$Input$placeholder('First'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$FirstName))
                        ]))
                    ])),
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(4)
                    ]), _List_fromArray([
                        $author$project$Ui$Form$Input$view(_List_fromArray([
                            $author$project$Ui$Form$Input$value(lastName),
                            $author$project$Ui$Form$Input$placeholder('Last'),
                            $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$LastName))
                        ]))
                    ]))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Email'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(email),
                    $author$project$Ui$Form$Input$withFeedback($author$project$Utils$Form$validated(form)),
                    $author$project$Ui$Form$Input$placeholder('email@example.com'),
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$User$Profile$FormFieldUpdated, $author$project$Pages$User$Profile$Email)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, form)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, form)),
                    $author$project$Ui$Form$Input$disabled(emailDisabled)
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Phone'),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                A2($elm$html$Html$map, $author$project$Pages$User$Profile$GotPhoneInputMsg, $author$project$Components$PhoneInput$view(phoneInput))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label(''),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), A2($author$project$Pages$User$Profile$viewAcceptTerms, user, form))
        ]);
    });
    var $author$project$Pages$User$Profile$toPane = function(model) {
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('clearfix')
            ]), _List_Nil),
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Your account')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$form, _List_fromArray([
                        $elm$html$Html$Attributes$class('form-horizontal'),
                        $elm$html$Html$Attributes$name('profileForm'),
                        $elm$html$Html$Attributes$novalidate(true),
                        $elm$html$Html$Attributes$autocomplete(true)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_Nil, A4($author$project$Pages$User$Profile$viewProfileFields, model.aaX, model.PU, model.bA, model.Fl))
                    ]))
                ])),
                A2($author$project$Ui$Panel$footer, _List_fromArray([
                    $author$project$Ui$Element$justifyCenter
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Update profile'
                    }, _List_fromArray([
                        $author$project$Ui$Button$primary,
                        $author$project$Ui$Button$submit,
                        $author$project$Ui$Button$onClick($author$project$Pages$User$Profile$UpdateUser)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Update')
                    ]))
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$User$Profile$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), $author$project$Pages$User$Profile$toPane(model))
                ]))
            ]),
            $2: 'Profile'
        };
    };
    var $author$project$Pages$User$Profile$page = $author$project$Spa$Page$applicationUser({
        aeq: $author$project$Pages$User$Profile$init,
        aeR: $author$project$Pages$User$Profile$load,
        ag3: $author$project$Pages$User$Profile$save,
        ahE: $author$project$Pages$User$Profile$subscriptions,
        aaO: $author$project$Pages$User$Profile$update,
        aid: $author$project$Pages$User$Profile$view
    });
    var $author$project$Pages$User$Security$GotSessions = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Pages$User$Security$GotTrustedDevices = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Api$Platform$User$Session$listDefaults = {
        Fw: $elm$core$Maybe$Nothing,
        af_: $author$project$Api$Pagination$init,
        ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 1, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Platform$User$Session$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$User$Session$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            function() {
                var _v0 = options.Fw;
                if (!_v0.$) {
                    var filter = _v0.a;
                    return _List_fromArray([
                        A2($author$project$Api$Param$string, 'filter', filter)
                    ]);
                } else return _List_Nil;
            }(),
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Platform$User$Session$sessionsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'sessions'
    ]), $author$project$Api$Platform$User$userPath);
    var $author$project$Api$Platform$User$Session$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$Session$One$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$User$Session$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Platform$User$Session$sessionsPath)));
    });
    var $author$project$Pages$User$Security$fetchSessions = F2(function(model, toMsg) {
        return A3($author$project$Api$Platform$User$Session$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.gN
            });
        }, toMsg);
    });
    var $author$project$Api$Platform$TrustedDevice$All$TrustedDevice = $elm$core$Basics$identity;
    var $author$project$Api$Platform$TrustedDevice$Shared$TrustedDevice = $elm$core$Basics$identity;
    var $author$project$Api$Platform$TrustedDevice$Shared$Record = F4(function(isExpired, trustedAt, trustedUntil, requestDetail) {
        return {
            R4: isExpired,
            YE: requestDetail,
            aaA: trustedAt,
            aaB: trustedUntil
        };
    });
    var $author$project$Api$Platform$TrustedDevice$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'request_detail', $elm$json$Json$Decode$nullable($author$project$Api$Common$RequestDetail$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'trusted_until', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'trusted_at', $elm_community$json_extra$Json$Decode$Extra$datetime, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'is_expired', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Platform$TrustedDevice$Shared$Record)))));
    var $author$project$Api$Platform$TrustedDevice$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$TrustedDevice$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$TrustedDevice$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Platform$TrustedDevice$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Platform$User$TrustedDevice$listDefaults = {
        af_: $author$project$Api$Pagination$init,
        ahs: A3($author$project$Api$Sort$withDefault, 'created_at', 0, $author$project$Api$Sort$init)
    };
    var $author$project$Api$Platform$User$TrustedDevice$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Platform$User$TrustedDevice$listDefaults);
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Sort$toParams(options.ahs),
            $author$project$Api$Pagination$toApiParams(options.af_)
        ]));
    };
    var $author$project$Api$Platform$User$TrustedDevice$listPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'trusted_devices'
    ]), $author$project$Api$Platform$User$userPath);
    var $author$project$Api$Platform$User$TrustedDevice$list = F3(function(apiClient, optionals, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$TrustedDevice$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Platform$User$TrustedDevice$listOptionsToParams(optionals), $author$project$Api$Data$requestTo($author$project$Api$Platform$User$TrustedDevice$listPath)));
    });
    var $author$project$Pages$User$Security$fetchTrustedDevices = F2(function(model, toMsg) {
        return A3($author$project$Api$Platform$User$TrustedDevice$list, model.Ej, function(d) {
            return _Utils_update(d, {
                af_: model.g8
            });
        }, toMsg);
    });
    var $author$project$Pages$User$Security$initPasswordFormFields = {
        afe: '',
        rA: '',
        af2: '',
        nk: $elm$core$Maybe$Nothing
    };
    var $author$project$Pages$User$Security$init = F4(function(session, user, shared, _v0) {
        var model = {
            Ej: shared.Ej,
            io: false,
            gl: $author$project$Utils$Form$init($author$project$Pages$User$Security$initPasswordFormFields),
            nl: $author$project$Api$Data$NotAsked,
            Z$: session,
            of: $author$project$Api$Data$Loading,
            gN: $author$project$Api$Pagination$init,
            HO: shared.HO,
            oW: $author$project$Api$Data$Loading,
            g8: $author$project$Api$Pagination$init,
            aaX: user
        };
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Pages$User$Security$fetchSessions, model, $author$project$Pages$User$Security$GotSessions),
            A2($author$project$Pages$User$Security$fetchTrustedDevices, model, $author$project$Pages$User$Security$GotTrustedDevices)
        ])));
    });
    var $author$project$Pages$User$Security$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Pages$User$Security$save = F2(function(_v0, shared) {
        return shared;
    });
    var $author$project$Pages$User$Security$DisableMfaHiConfirmClosed = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Pages$User$Security$PasswordFormFieldUpdated = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$User$Security$PasswordStrengthCheck = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Pages$User$Security$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ports$PasswordStrength$checked(A2($elm$core$Basics$composeL, A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$PasswordStrengthCheck), $elm$core$Maybe$Just)),
            model.io ? $author$project$Components$HiConfirm$subscribeToEscapeKeyPress($author$project$Pages$User$Security$DisableMfaHiConfirmClosed) : $elm$core$Platform$Sub$none
        ]));
    };
    var $author$project$Pages$User$Security$GotMfaDestroy = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Platform$Mfa$delete = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$delete, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$Mfa$mfaPath));
    });
    var $author$project$Pages$User$Security$passwordFormFieldsUpdate = F2(function(field, fields) {
        switch(field.$){
            case 0:
                var string = field.a;
                return _Utils_update(fields, {
                    af2: string
                });
            case 1:
                var string = field.a;
                return _Utils_update(fields, {
                    afe: string,
                    nk: $elm$core$Maybe$Nothing
                });
            case 2:
                var string = field.a;
                return _Utils_update(fields, {
                    rA: string
                });
            default:
                var check = field.a;
                return _Utils_update(fields, {
                    nk: check
                });
        }
    });
    var $author$project$Pages$User$Security$NewPasswordValidation = 1;
    var $author$project$Pages$User$Security$PasswordValidation = 0;
    var $author$project$Pages$User$Security$NewPasswordConfirmationValidation = 2;
    var $author$project$Pages$User$Security$validateNewPasswordConfirmation = function(form) {
        return $elm$core$String$isEmpty(form.afe) ? _List_Nil : _Utils_eq(form.afe, form.rA) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2(2, 'The new password and its confirmation don\'t match')
        ]);
    };
    var $author$project$Pages$User$Security$passwordFormFieldsValidator = $rtfeldman$elm_validate$Validate$all(_List_fromArray([
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.af2;
        }, _Utils_Tuple2(0, 'Please enter your current password.')),
        A2($rtfeldman$elm_validate$Validate$ifBlank, function($) {
            return $.afe;
        }, _Utils_Tuple2(1, 'Please enter your new password.')),
        $rtfeldman$elm_validate$Validate$fromErrors($author$project$Pages$User$Security$validateNewPasswordConfirmation),
        A2($rtfeldman$elm_validate$Validate$ifFalse, function(subject) {
            return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Utils$PasswordStrength$isUnguessable, subject.nk));
        }, _Utils_Tuple2(1, 'Please enter a secure password.'))
    ]));
    var $author$project$Pages$User$Security$GotPasswordUpdate = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Platform$User$Password$passwordPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'password'
    ]), $author$project$Api$Platform$User$userPath);
    var $author$project$Api$Platform$User$Password$update = F3(function(apiClient, fields, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('password', $elm$json$Json$Encode$string(fields.af2)),
            _Utils_Tuple2('new_password', $elm$json$Json$Encode$string(fields.afe))
        ]));
        return A4($author$project$Api$Data$patch, apiClient, $author$project$Api$Data$emptyBodyDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo($author$project$Api$Platform$User$Password$passwordPath)));
    });
    var $author$project$Pages$User$Security$updatePassword = F2(function(apiClient, passwordFormFields) {
        return A3($author$project$Api$Platform$User$Password$update, apiClient, $rtfeldman$elm_validate$Validate$fromValid(passwordFormFields), $author$project$Pages$User$Security$GotPasswordUpdate);
    });
    var $author$project$Pages$User$Security$update = F2(function(msg, model) {
        switch(msg.$){
            case 0:
                var field = msg.a;
                var _v1 = _Utils_Tuple2(A3($author$project$Utils$Form$update, $author$project$Pages$User$Security$passwordFormFieldsUpdate, field, model.gl), function() {
                    if (field.$ === 1) {
                        var newPassword = field.a;
                        return $author$project$Ports$PasswordStrength$check(newPassword);
                    } else return $elm$core$Platform$Cmd$none;
                }());
                var newForm = _v1.a;
                var cmd = _v1.b;
                var validatedForm = function() {
                    var _v3 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Security$passwordFormFieldsValidator, newForm);
                    if (!_v3.$) {
                        var _v4 = _v3.a;
                        var form = _v4.a;
                        return form;
                    } else {
                        var form = _v3.a;
                        return form;
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    gl: validatedForm
                }), cmd, _List_Nil);
            case 1:
                var _v5 = A2($author$project$Utils$Form$validate, $author$project$Pages$User$Security$passwordFormFieldsValidator, model.gl);
                if (!_v5.$) {
                    var _v6 = _v5.a;
                    var newForm = _v6.a;
                    var validFormFields = _v6.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        gl: newForm,
                        nl: $author$project$Api$Data$Loading
                    }), A2($author$project$Pages$User$Security$updatePassword, model.Ej, validFormFields), _List_Nil);
                } else {
                    var newForm = _v5.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        gl: newForm
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var passwordUpdate = msg.a;
                if (passwordUpdate.$ === 3) return _Utils_Tuple3(_Utils_update(model, {
                    nl: passwordUpdate
                }), $elm$core$Platform$Cmd$none, _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Your password has been updated')
                ]));
                else return _Utils_Tuple3(_Utils_update(model, {
                    nl: passwordUpdate
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(passwordUpdate));
            case 3:
                return _Utils_Tuple3(_Utils_update(model, {
                    io: true
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var confirmed = msg.a;
                return confirmed ? _Utils_Tuple3(_Utils_update(model, {
                    io: false
                }), A2($author$project$Api$Platform$Mfa$delete, model.Ej, $author$project$Pages$User$Security$GotMfaDestroy), _List_Nil) : _Utils_Tuple3(_Utils_update(model, {
                    io: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                var dataMfa = msg.a;
                if (dataMfa.$ === 3) return _Utils_Tuple3(model, $author$project$Ports$Session$logout({
                    agy: true
                }), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Multi-factor authentication has been disabled.')
                ]));
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(dataMfa));
            case 6:
                var dataSessions = msg.a;
                if (dataSessions.$ === 3) {
                    var headers = dataSessions.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        of: dataSessions,
                        gN: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.gN)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    of: dataSessions
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(dataSessions));
            case 7:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.gN);
                var newModel = _Utils_update(model, {
                    gN: pagination
                });
                return _Utils_Tuple3(newModel, A2($author$project$Pages$User$Security$fetchSessions, newModel, $author$project$Pages$User$Security$GotSessions), _List_Nil);
            case 8:
                var dataTrustedDevices = msg.a;
                if (dataTrustedDevices.$ === 3) {
                    var headers = dataTrustedDevices.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        oW: dataTrustedDevices,
                        g8: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, model.g8)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(_Utils_update(model, {
                    oW: dataTrustedDevices
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$reportDecodeError(dataTrustedDevices));
            case 9:
                var subMsg = msg.a;
                var pagination = A2($author$project$Api$Pagination$update, subMsg, model.g8);
                var newModel = _Utils_update(model, {
                    g8: pagination
                });
                return _Utils_Tuple3(newModel, A2($author$project$Pages$User$Security$fetchTrustedDevices, newModel, $author$project$Pages$User$Security$GotTrustedDevices), _List_Nil);
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Pages$User$Security$EnableMfaClicked = {
        $: 10
    };
    var $author$project$Pages$User$Security$OpenDisableMfaHiConfirm = {
        $: 3
    };
    var $author$project$Pages$User$Security$TrustedDevicesPaginationMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Api$Platform$User$Shared$mfaStatus = function(_v0) {
        var record = _v0;
        return record.Ug;
    };
    var $author$project$Api$Platform$User$One$mfaStatus = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Platform$User$Shared$mfaStatus(shared);
    };
    var $author$project$Api$Common$RequestDetail$Shared$clientDescription = function(requestDetail) {
        return A2($elm$core$String$join, ' on ', _List_fromArray([
            A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Common$RequestDetail$Shared$clientName(requestDetail)),
            A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Common$RequestDetail$Shared$osName(requestDetail)) + (' ' + A2($elm$core$Maybe$withDefault, 'N/A', $author$project$Api$Common$RequestDetail$Shared$deviceType(requestDetail)))
        ]));
    };
    var $author$project$Api$Platform$TrustedDevice$Shared$isExpired = function(_v0) {
        var record = _v0;
        return record.R4;
    };
    var $author$project$Api$Platform$TrustedDevice$All$isExpired = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$TrustedDevice$Shared$isExpired(shared);
    };
    var $author$project$Api$Platform$TrustedDevice$Shared$requestDetail = function(_v0) {
        var record = _v0;
        return record.YE;
    };
    var $author$project$Api$Platform$TrustedDevice$All$requestDetail = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$TrustedDevice$Shared$requestDetail(shared);
    };
    var $author$project$Api$Platform$TrustedDevice$Shared$trustedAt = function(_v0) {
        var record = _v0;
        return record.aaA;
    };
    var $author$project$Api$Platform$TrustedDevice$All$trustedAt = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$TrustedDevice$Shared$trustedAt(shared);
    };
    var $author$project$Api$Platform$TrustedDevice$Shared$trustedUntil = function(_v0) {
        var record = _v0;
        return record.aaB;
    };
    var $author$project$Api$Platform$TrustedDevice$All$trustedUntil = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Platform$TrustedDevice$Shared$trustedUntil(shared);
    };
    var $author$project$Pages$User$Security$viewTrustedDevice = F2(function(timeFormatter, trustedDevice) {
        var style = $author$project$Api$Platform$TrustedDevice$All$isExpired(trustedDevice) ? 3 : 0;
        return A2($author$project$Ui$ListGroup$item, _List_fromArray([
            $author$project$Ui$ListGroup$style(style)
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$RequestDetail$Shared$clientDescription, $author$project$Api$Platform$TrustedDevice$All$requestDetail(trustedDevice)))),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Trusted from ' + (A2(timeFormatter, 0, $author$project$Api$Platform$TrustedDevice$All$trustedAt(trustedDevice)) + (' to ' + A2(timeFormatter, 0, $author$project$Api$Platform$TrustedDevice$All$trustedUntil(trustedDevice)))))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$User$Security$viewTrustedDeviceSkeleton = A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$spaceBetween
        ]), _List_fromArray([
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Chrome on Mac')
            ])),
            $author$project$Ui$Skeleton$text(_List_fromArray([
                $author$project$Ui$Skeleton$spanFromText('Trusted on mm/dd/YYYY at ll:MM pp')
            ]))
        ]))
    ]));
    var $author$project$Pages$User$Security$viewMfaStatus = function(model) {
        return A2($elm$html$Html$form, _List_fromArray([
            $elm$html$Html$Attributes$class('form-horizontal')
        ]), _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Multi-factor authentication (MFA)')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Status'),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8)
            ]), _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = $author$project$Api$Platform$User$One$mfaStatus(model.aaX);
                        if (!_v0) return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $author$project$Ui$Icon$check(_List_fromArray([
                                $author$project$Ui$Icon$success
                            ])),
                            $author$project$Utils$Html$noBreakSpace,
                            $elm$html$Html$text('Enabled '),
                            function() {
                                var label = $author$project$Api$Platform$User$One$requiresMfa(model.aaX) ? 'Reset MFA device' : 'Disable';
                                return A3($author$project$Ui$Button$view, {
                                    abP: label
                                }, _List_fromArray([
                                    $author$project$Ui$Button$link,
                                    $author$project$Ui$Button$padding($author$project$Ui$Padding$none),
                                    $author$project$Ui$Button$onClick($author$project$Pages$User$Security$OpenDisableMfaHiConfirm)
                                ]), _List_fromArray([
                                    $elm$html$Html$text(label)
                                ]));
                            }()
                        ]));
                        else return A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $author$project$Ui$Icon$cross(_List_fromArray([
                                $author$project$Ui$Icon$danger
                            ])),
                            $author$project$Utils$Html$noBreakSpace,
                            $elm$html$Html$text('Disabled'),
                            $author$project$Utils$Html$noBreakSpace,
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Mfa, _List_fromArray([
                                $author$project$Ui$Link$onClick($author$project$Pages$User$Security$EnableMfaClicked)
                            ]), _List_fromArray([
                                $elm$html$Html$text('Enable Now')
                            ]))
                        ]));
                    }()
                ]))
            ])),
            function() {
                var _v1 = $author$project$Api$Platform$User$One$mfaStatus(model.aaX);
                if (!_v1) return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                    $author$project$Ui$Form$Group$label('Trusted devices'),
                    $author$project$Ui$Form$Group$labelSpan(4),
                    $author$project$Ui$Form$Group$inputSpan(8)
                ]), _List_fromArray([
                    A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                        function() {
                            var _v2 = model.oW;
                            if (_v2.$ === 3) {
                                var trustedDevices = _v2.a;
                                return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, $author$project$Pages$User$Security$viewTrustedDevice(model.HO), trustedDevices));
                            } else return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$repeat, 10, $author$project$Pages$User$Security$viewTrustedDeviceSkeleton));
                        }(),
                        A2($elm$html$Html$map, $author$project$Pages$User$Security$TrustedDevicesPaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                            $author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
                            $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.oW))
                        ]), model.g8))
                    ]))
                ]));
                else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Pages$User$Security$NewPassword = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Pages$User$Security$NewPasswordConfirmation = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Pages$User$Security$Password = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Pages$User$Security$UpdatePassword = {
        $: 1
    };
    var $author$project$Pages$User$Security$viewPasswordForm = F2(function(passwordUpdate, passwordForm) {
        var _v0 = $author$project$Utils$Form$fields(passwordForm);
        var password = _v0.af2;
        var newPassword = _v0.afe;
        var newPasswordConfirmation = _v0.rA;
        var passwordStrengthCheck = _v0.nk;
        return A2($elm$html$Html$form, _List_fromArray([
            $elm$html$Html$Attributes$class('form-horizontal'),
            $elm$html$Html$Attributes$novalidate(true),
            $elm$html$Html$Attributes$autocomplete(true)
        ]), _List_fromArray([
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Password')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('Current Password'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpan(4),
                $author$project$Ui$Form$Group$inputSpan(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(password),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$password,
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$Password)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 0, passwordForm)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 0, passwordForm))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('New Password'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$PasswordInput$view(_List_fromArray([
                    $author$project$Ui$Form$PasswordInput$value(newPassword),
                    $author$project$Ui$Form$PasswordInput$strengthCheck(passwordStrengthCheck),
                    $author$project$Ui$Form$PasswordInput$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$NewPassword)),
                    $author$project$Ui$Form$PasswordInput$invalid(A2($author$project$Utils$Form$hasValidationErrors, 1, passwordForm)),
                    $author$project$Ui$Form$PasswordInput$errors(A2($author$project$Utils$Form$validationErrors, 1, passwordForm))
                ]))
            ])),
            A2($author$project$Ui$Form$Group$view, _List_fromArray([
                $author$project$Ui$Form$Group$label('New Password Confirmation'),
                $author$project$Ui$Form$Group$required(true),
                $author$project$Ui$Form$Group$labelSpanSm(4),
                $author$project$Ui$Form$Group$inputSpanSm(8)
            ]), _List_fromArray([
                $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$value(newPasswordConfirmation),
                    $author$project$Ui$Form$Input$phi(true),
                    $author$project$Ui$Form$Input$password,
                    $author$project$Ui$Form$Input$onInput(A2($elm$core$Basics$composeL, $author$project$Pages$User$Security$PasswordFormFieldUpdated, $author$project$Pages$User$Security$NewPasswordConfirmation)),
                    $author$project$Ui$Form$Input$invalid(A2($author$project$Utils$Form$hasValidationErrors, 2, passwordForm)),
                    $author$project$Ui$Form$Input$errors(A2($author$project$Utils$Form$validationErrors, 2, passwordForm))
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textCenter,
                $author$project$Ui$Element$mt4
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Update security settings'
                }, _List_fromArray([
                    $author$project$Ui$Button$primary,
                    $author$project$Ui$Button$onClick($author$project$Pages$User$Security$UpdatePassword),
                    $author$project$Ui$Button$loading(_Utils_eq(passwordUpdate, $author$project$Api$Data$Loading))
                ]), _List_fromArray([
                    $elm$html$Html$text('Update')
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$User$Security$SessionsPaginationMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Common$RequestDetail$Shared$countryCode = function(_v0) {
        var record = _v0;
        return record.Mf;
    };
    var $author$project$Api$Platform$Session$One$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Platform$Session$One$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Common$RequestDetail$Shared$locationDescription = function(_v0) {
        var record = _v0;
        var _v1 = _Utils_Tuple2(record.s4, record.p0);
        if (!_v1.a.$) {
            if (!_v1.b.$) {
                var state_ = _v1.a.a;
                var country_ = _v1.b.a;
                return state_ + (' - ' + country_);
            } else {
                var state_ = _v1.a.a;
                var _v2 = _v1.b;
                return state_;
            }
        } else if (!_v1.b.$) {
            var _v3 = _v1.a;
            var country_ = _v1.b.a;
            return country_;
        } else {
            var _v4 = _v1.a;
            var _v5 = _v1.b;
            return 'N/A';
        }
    };
    var $author$project$Api$Platform$Session$One$requestDetail = function(_v0) {
        var record = _v0;
        return record.YE;
    };
    var $author$project$Ui$CountryFlag$flagClass = function(code) {
        return 'fi-' + $elm$core$String$toLower(code);
    };
    var $author$project$Ui$CountryFlag$view = F2(function(_v0, code) {
        return A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('fi'),
            $elm$html$Html$Attributes$class($author$project$Ui$CountryFlag$flagClass(code))
        ]), _List_Nil);
    });
    var $author$project$Pages$User$Security$viewSession = F3(function(currentSession, timeFormatter, session) {
        var options = _Utils_eq($author$project$Api$Platform$Session$One$id(currentSession), $author$project$Api$Platform$Session$One$id(session)) ? _List_fromArray([
            $author$project$Ui$ListGroup$style(1)
        ]) : _List_Nil;
        return A2($author$project$Ui$ListGroup$item, options, _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Started at: ')
                        ])),
                        $elm$html$Html$text(A2(timeFormatter, 0, $author$project$Api$Platform$Session$One$createdAt(session)))
                    ])),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Location: ')
                        ])),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$RequestDetail$Shared$locationDescription, $author$project$Api$Platform$Session$One$requestDetail(session)))),
                        $author$project$Utils$Html$noBreakSpace,
                        function() {
                            var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Common$RequestDetail$Shared$countryCode, $author$project$Api$Platform$Session$One$requestDetail(session));
                            if (!_v0.$) {
                                var countryCode = _v0.a;
                                return A2($author$project$Ui$CountryFlag$view, _List_Nil, countryCode);
                            } else return $author$project$Utils$Html$empty;
                        }()
                    ]))
                ])),
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Device: ')
                        ])),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$map, $author$project$Api$Common$RequestDetail$Shared$clientDescription, $author$project$Api$Platform$Session$One$requestDetail(session))))
                    ])),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Role: ')
                        ])),
                        $elm$html$Html$text($author$project$Formatters$String$titleize($author$project$Formatters$String$humanize($author$project$Api$Platform$Session$One$role(session))))
                    ])),
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('IP: ')
                        ])),
                        $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'N/A', A2($elm$core$Maybe$andThen, $author$project$Api$Common$RequestDetail$Shared$ip, $author$project$Api$Platform$Session$One$requestDetail(session))))
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Pages$User$Security$viewSessionSkeleton = A2($author$project$Ui$ListGroup$item, _List_Nil, _List_fromArray([
        A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$spaceBetween
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$spanFromText('Started at: mm/dd/YYYY at ll:MM pp')
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$spanFromText('Location: Montevideo')
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$spanFromText('Authenticated by: SSO')
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$spanFromText('Device: Chrome on Mac desktop')
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$spanFromText('Role: Practice Admin')
                ])),
                $author$project$Ui$Skeleton$text(_List_fromArray([
                    $author$project$Ui$Skeleton$block,
                    $author$project$Ui$Skeleton$spanFromText('IP: 123.456.78.900')
                ]))
            ]))
        ]))
    ]));
    var $author$project$Pages$User$Security$viewSessions = function(model) {
        return A2($elm$html$Html$form, _List_fromArray([
            $elm$html$Html$Attributes$class('form-horizontal')
        ]), _List_fromArray([
            $author$project$Ui$HorizontalRule$view(_List_Nil),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text('Sessions')
            ])),
            A2($author$project$Ui$Form$Group$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    function() {
                        var _v0 = model.of;
                        if (_v0.$ === 3) {
                            var sessions = _v0.a;
                            return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$map, A2($author$project$Pages$User$Security$viewSession, model.Z$, model.HO), sessions));
                        } else return A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$repeat, 10, $author$project$Pages$User$Security$viewSessionSkeleton));
                    }(),
                    A2($elm$html$Html$map, $author$project$Pages$User$Security$SessionsPaginationMsg, A2($author$project$Api$Pagination$view, _List_fromArray([
                        $author$project$Ui$Pagination$List$hideTotalItemsForSinglePage,
                        $author$project$Ui$Pagination$List$loading(!$author$project$Api$Data$isSuccess(model.of))
                    ]), model.gN))
                ]))
            ]))
        ]));
    };
    var $author$project$Pages$User$Security$toPane = function(model) {
        return _List_fromArray([
            model.io ? A2($author$project$Components$HiConfirm$modal, $author$project$Pages$User$Security$DisableMfaHiConfirmClosed, _List_fromArray([
                $author$project$Components$HiConfirm$verb('disable'),
                $author$project$Components$HiConfirm$noun('MFA'),
                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                    $elm$html$Html$text('Disabling MFA will prevent you from accessing practices that enforce its use. You will be logged out and will have to login again.')
                ]))
            ])) : $author$project$Utils$Html$empty,
            $author$project$Ui$Clearfix$view,
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                    $author$project$Ui$Panel$title(_List_fromArray([
                        $elm$html$Html$text('Security')
                    ]))
                ])),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Pages$User$Security$viewPasswordForm, model.nl, model.gl),
                    $author$project$Pages$User$Security$viewMfaStatus(model),
                    $author$project$Pages$User$Security$viewSessions(model)
                ]))
            ]))
        ]);
    };
    var $author$project$Pages$User$Security$view = function(model) {
        return {
            fb: _List_fromArray([
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanMd(12)
                    ]), $author$project$Pages$User$Security$toPane(model))
                ]))
            ]),
            $2: 'Profile | Security'
        };
    };
    var $author$project$Pages$User$Security$page = $author$project$Spa$Page$applicationUser({
        aeq: $author$project$Pages$User$Security$init,
        aeR: $author$project$Pages$User$Security$load,
        ag3: $author$project$Pages$User$Security$save,
        ahE: $author$project$Pages$User$Security$subscriptions,
        aaO: $author$project$Pages$User$Security$update,
        aid: $author$project$Pages$User$Security$view
    });
    var $author$project$Spa$Url$toQueryDict = function(queryString) {
        return $elm$core$Dict$fromList($author$project$Spa$Url$toQuery(queryString));
    };
    var $author$project$Spa$Url$create = F2(function(params, url) {
        return {
            VU: params,
            Bz: A2($elm$core$Maybe$withDefault, $elm$core$Dict$empty, A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, url.Bz)),
            agv: url
        };
    });
    var $author$project$Spa$Document$map = F2(function(fn, doc) {
        return {
            fb: A2($elm$core$List$map, $elm$html$Html$map(fn), doc.fb),
            $2: doc.$2
        };
    });
    var $author$project$Spa$Generated$Pages$mapFirstAndSecond = F3(function(mapFirst, mapSecond, _v0) {
        var first = _v0.a;
        var second = _v0.b;
        var third = _v0.c;
        return _Utils_Tuple3(mapFirst(first), mapSecond(second), third);
    });
    var $author$project$Spa$Generated$Pages$upgrade = F3(function(toModel, toMsg, page) {
        var update_ = F2(function(msg, model) {
            return A3($author$project$Spa$Generated$Pages$mapFirstAndSecond, toModel, $elm$core$Platform$Cmd$map(toMsg), A2(page.aaO, msg, model));
        });
        var load_ = F2(function(model, shared) {
            return A3($author$project$Spa$Generated$Pages$mapFirstAndSecond, toModel, $elm$core$Platform$Cmd$map(toMsg), A2(page.aeR, shared, model));
        });
        var init_ = F2(function(params, shared) {
            return A3($author$project$Spa$Generated$Pages$mapFirstAndSecond, toModel, $elm$core$Platform$Cmd$map(toMsg), A2(page.aeq, shared, A2($author$project$Spa$Url$create, params, shared.aaT)));
        });
        var bundle_ = function(model) {
            return {
                aeR: function(_v0) {
                    return load_(model);
                },
                ag3: function(_v1) {
                    return page.ag3(model);
                },
                ahE: function(_v2) {
                    return A2($elm$core$Platform$Sub$map, toMsg, page.ahE(model));
                },
                aid: function(_v3) {
                    return A2($author$project$Spa$Document$map, toMsg, page.aid(model));
                }
            };
        };
        return {
            a: bundle_,
            aeq: init_,
            aaO: update_
        };
    });
    var $author$project$Spa$Generated$Pages$pages = {
        tU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Model, $author$project$Spa$Generated$Pages$Admin__AdvanceBilling__Msg, $author$project$Pages$Admin$AdvanceBilling$page),
        tV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Fields__Msg, $author$project$Pages$Admin$Athenahealth$Fields$page),
        tW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Link__Msg, $author$project$Pages$Admin$Athenahealth$Link$page),
        tX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Locations__Msg, $author$project$Pages$Admin$Athenahealth$Locations$page),
        tY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Overview__Msg, $author$project$Pages$Admin$Athenahealth$Overview$page),
        tZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Providers__Msg, $author$project$Pages$Admin$Athenahealth$Providers$page),
        t_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Model, $author$project$Spa$Generated$Pages$Admin__Athenahealth__Top__Msg, $author$project$Pages$Admin$Athenahealth$Top$page),
        t$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Billing__Model, $author$project$Spa$Generated$Pages$Admin__Billing__Msg, $author$project$Pages$Admin$Billing$page),
        t0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Billing__PracticeInvoices__Id_String__Msg, $author$project$Pages$Admin$Billing$PracticeInvoices$Id_String$page),
        t1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Model, $author$project$Spa$Generated$Pages$Admin__CancellationReasons__Msg, $author$project$Pages$Admin$CancellationReasons$page),
        t2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CardReaders__Model, $author$project$Spa$Generated$Pages$Admin__CardReaders__Msg, $author$project$Pages$Admin$CardReaders$page),
        t3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Categories__Model, $author$project$Spa$Generated$Pages$Admin__Categories__Msg, $author$project$Pages$Admin$Categories$page),
        t4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Id_String__Msg, $author$project$Pages$Admin$ChargeItems$Id_String$page),
        t5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__New__Msg, $author$project$Pages$Admin$ChargeItems$New$page),
        t6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Top__Msg, $author$project$Pages$Admin$ChargeItems$Top$page),
        t7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Model, $author$project$Spa$Generated$Pages$Admin__ChargeItems__Upload__Msg, $author$project$Pages$Admin$ChargeItems$Upload$page),
        t8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Commissions__Model, $author$project$Spa$Generated$Pages$Admin__Commissions__Msg, $author$project$Pages$Admin$Commissions$page),
        t9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Id_String__Msg, $author$project$Pages$Admin$CompanyPlans$Id_String$page),
        ua: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__New__Msg, $author$project$Pages$Admin$CompanyPlans$New$page),
        ub: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Model, $author$project$Spa$Generated$Pages$Admin__CompanyPlans__Top__Msg, $author$project$Pages$Admin$CompanyPlans$Top$page),
        uc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Coupons__Model, $author$project$Spa$Generated$Pages$Admin__Coupons__Msg, $author$project$Pages$Admin$Coupons$page),
        ud: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Id_String__Msg, $author$project$Pages$Admin$CoveragePlans$Id_String$page),
        ue: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__New__Msg, $author$project$Pages$Admin$CoveragePlans$New$page),
        uf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Model, $author$project$Spa$Generated$Pages$Admin__CoveragePlans__Top__Msg, $author$project$Pages$Admin$CoveragePlans$Top$page),
        ug: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__CreditCategories__Model, $author$project$Spa$Generated$Pages$Admin__CreditCategories__Msg, $author$project$Pages$Admin$CreditCategories$page),
        uh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Model, $author$project$Spa$Generated$Pages$Admin__Credits__Upload__Msg, $author$project$Pages$Admin$Credits$Upload$page),
        ui: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Id_String__Msg, $author$project$Pages$Admin$DataExportSettings$Id_String$page),
        uj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__New__Msg, $author$project$Pages$Admin$DataExportSettings$New$page),
        uk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Model, $author$project$Spa$Generated$Pages$Admin__DataExportSettings__Top__Msg, $author$project$Pages$Admin$DataExportSettings$Top$page),
        ul: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__DataExport__Id_String__Msg, $author$project$Pages$Admin$DataExport$Id_String$page),
        um: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Model, $author$project$Spa$Generated$Pages$Admin__DataExport__Top__Msg, $author$project$Pages$Admin$DataExport$Top$page),
        un: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Model, $author$project$Spa$Generated$Pages$Admin__Developers__ApiKeys__Msg, $author$project$Pages$Admin$Developers$ApiKeys$page),
        uo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Model, $author$project$Spa$Generated$Pages$Admin__Developers__GetStarted__Msg, $author$project$Pages$Admin$Developers$GetStarted$page),
        up: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Model, $author$project$Spa$Generated$Pages$Admin__Developers__Sandboxes__Msg, $author$project$Pages$Admin$Developers$Sandboxes$page),
        uq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Model, $author$project$Spa$Generated$Pages$Admin__Developers__WebhookEndpoints__Msg, $author$project$Pages$Admin$Developers$WebhookEndpoints$page),
        ur: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Documents__Id_String__Msg, $author$project$Pages$Admin$Documents$Id_String$page),
        us: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__New__Model, $author$project$Spa$Generated$Pages$Admin__Documents__New__Msg, $author$project$Pages$Admin$Documents$New$page),
        ut: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Documents__Top__Model, $author$project$Spa$Generated$Pages$Admin__Documents__Top__Msg, $author$project$Pages$Admin$Documents$Top$page),
        uu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Model, $author$project$Spa$Generated$Pages$Admin__ElationLegacy__Msg, $author$project$Pages$Admin$ElationLegacy$page),
        uv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Link__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Link__Msg, $author$project$Pages$Admin$Elation$Link$page),
        uw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Overview__Msg, $author$project$Pages$Admin$Elation$Overview$page),
        ux: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Providers__Msg, $author$project$Pages$Admin$Elation$Providers$page),
        uy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Elation__Top__Model, $author$project$Spa$Generated$Pages$Admin__Elation__Top__Msg, $author$project$Pages$Admin$Elation$Top$page),
        uz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Features__Model, $author$project$Spa$Generated$Pages$Admin__Features__Msg, $author$project$Pages$Admin$Features$page),
        uA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Model, $author$project$Spa$Generated$Pages$Admin__HipaaAuthorizations__Msg, $author$project$Pages$Admin$HipaaAuthorizations$page),
        uB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Model, $author$project$Spa$Generated$Pages$Admin__Integrations__Slug_String__Msg, $author$project$Pages$Admin$Integrations$Slug_String$page),
        uC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__InternalSettings__Model, $author$project$Spa$Generated$Pages$Admin__InternalSettings__Msg, $author$project$Pages$Admin$InternalSettings$page),
        uD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Model, $author$project$Spa$Generated$Pages$Admin__InvoiceSettings__Msg, $author$project$Pages$Admin$InvoiceSettings$page),
        uE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__LeadSources__Model, $author$project$Spa$Generated$Pages$Admin__LeadSources__Msg, $author$project$Pages$Admin$LeadSources$page),
        uF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Locations__Model, $author$project$Spa$Generated$Pages$Admin__Locations__Msg, $author$project$Pages$Admin$Locations$page),
        uG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Mailgun__Model, $author$project$Spa$Generated$Pages$Admin__Mailgun__Msg, $author$project$Pages$Admin$Mailgun$page),
        uH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notes__Model, $author$project$Spa$Generated$Pages$Admin__Notes__Msg, $author$project$Pages$Admin$Notes$page),
        uI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Company__Msg, $author$project$Pages$Admin$Notifications$Company$page),
        uJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Employee__Msg, $author$project$Pages$Admin$Notifications$Employee$page),
        uK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Membership__Msg, $author$project$Pages$Admin$Notifications$Membership$page),
        uL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__Msg, $author$project$Pages$Admin$Notifications$Patient$page),
        uM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Patient__DunningSchedule__Msg, $author$project$Pages$Admin$Notifications$Patient$DunningSchedule$page),
        uN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Practice__Msg, $author$project$Pages$Admin$Notifications$Practice$page),
        uO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Model, $author$project$Spa$Generated$Pages$Admin__Notifications__Settings__Msg, $author$project$Pages$Admin$Notifications$Settings$page),
        uP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Patients__Model, $author$project$Spa$Generated$Pages$Admin__Patients__Msg, $author$project$Pages$Admin$Patients$page),
        uQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Model, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Msg, $author$project$Pages$Admin$PaymentMethodImport$page),
        uR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Model, $author$project$Spa$Generated$Pages$Admin__PaymentMethodImport__Upload__Msg, $author$project$Pages$Admin$PaymentMethodImport$Upload$page),
        uS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Model, $author$project$Spa$Generated$Pages$Admin__PaymentProcessing__Msg, $author$project$Pages$Admin$PaymentProcessing$page),
        uT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__PaymentSources__Model, $author$project$Spa$Generated$Pages$Admin__PaymentSources__Msg, $author$project$Pages$Admin$PaymentSources$page),
        uU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__Msg, $author$project$Pages$Admin$Plans$Id_String$page),
        uV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__New__Msg, $author$project$Pages$Admin$Plans$Id_String$PricingVersions$New$page),
        uW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String__Msg, $author$project$Pages$Admin$Plans$Id_String$PricingVersions$PricingVersionId_String$page),
        uX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__New__Model, $author$project$Spa$Generated$Pages$Admin__Plans__New__Msg, $author$project$Pages$Admin$Plans$New$page),
        uY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Plans__Top__Model, $author$project$Spa$Generated$Pages$Admin__Plans__Top__Msg, $author$project$Pages$Admin$Plans$Top$page),
        uZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Practice__Model, $author$project$Spa$Generated$Pages$Admin__Practice__Msg, $author$project$Pages$Admin$Practice$page),
        u_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Model, $author$project$Spa$Generated$Pages$Admin__ProviderGroups__Msg, $author$project$Pages$Admin$ProviderGroups$page),
        u$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Providers__Top__Model, $author$project$Spa$Generated$Pages$Admin__Providers__Top__Msg, $author$project$Pages$Admin$Providers$Top$page),
        u0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Model, $author$project$Spa$Generated$Pages$Admin__Providers__Upload__Msg, $author$project$Pages$Admin$Providers$Upload$page),
        u1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Model, $author$project$Spa$Generated$Pages$Admin__Quickbooks__Top__Msg, $author$project$Pages$Admin$Quickbooks$Top$page),
        u2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Model, $author$project$Spa$Generated$Pages$Admin__ScheduledJobs__Msg, $author$project$Pages$Admin$ScheduledJobs$page),
        u3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SelfService__Model, $author$project$Spa$Generated$Pages$Admin__SelfService__Msg, $author$project$Pages$Admin$SelfService$page),
        u4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Signup__Model, $author$project$Spa$Generated$Pages$Admin__Signup__Msg, $author$project$Pages$Admin$Signup$page),
        u5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__Id_String__Msg, $author$project$Pages$Admin$SignupPages$Id_String$page),
        u6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__New__Msg, $author$project$Pages$Admin$SignupPages$New$page),
        u7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Model, $author$project$Spa$Generated$Pages$Admin__SignupPages__Top__Msg, $author$project$Pages$Admin$SignupPages$Top$page),
        u8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Stripe__Model, $author$project$Spa$Generated$Pages$Admin__Stripe__Msg, $author$project$Pages$Admin$Stripe$page),
        u9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Taxes__Model, $author$project$Spa$Generated$Pages$Admin__Taxes__Msg, $author$project$Pages$Admin$Taxes$page),
        va: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Team__Model, $author$project$Spa$Generated$Pages$Admin__Team__Msg, $author$project$Pages$Admin$Team$page),
        vb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Admin__Team__New__Model, $author$project$Spa$Generated$Pages$Admin__Team__New__Msg, $author$project$Pages$Admin$Team$New$page),
        vd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$AffiliateBills__Top__Model, $author$project$Spa$Generated$Pages$AffiliateBills__Top__Msg, $author$project$Pages$AffiliateBills$Top$page),
        vf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__AffiliateActions__Msg, $author$project$Pages$Affiliates$AffiliateId_String$AffiliateActions$page),
        vg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Id_String__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Id_String$page),
        vh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Bills__Top__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Bills$Top$page),
        vi: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkProviders__Msg, $author$project$Pages$Affiliates$AffiliateId_String$LinkProviders$page),
        vj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__LinkedProviders__Msg, $author$project$Pages$Affiliates$AffiliateId_String$LinkedProviders$page),
        vk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Patients__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Patients$page),
        vl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Settings__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Settings$page),
        vm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Model, $author$project$Spa$Generated$Pages$Affiliates__AffiliateId_String__Users__Msg, $author$project$Pages$Affiliates$AffiliateId_String$Users$page),
        vn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__Create__Model, $author$project$Spa$Generated$Pages$Affiliates__Create__Msg, $author$project$Pages$Affiliates$Create$page),
        vo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__New__Model, $author$project$Spa$Generated$Pages$Affiliates__New__Msg, $author$project$Pages$Affiliates$New$page),
        vp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Affiliates__Top__Model, $author$project$Spa$Generated$Pages$Affiliates__Top__Msg, $author$project$Pages$Affiliates$Top$page),
        vy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Apps__Slug_String__Model, $author$project$Spa$Generated$Pages$Apps__Slug_String__Msg, $author$project$Pages$Apps$Slug_String$page),
        vO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Blank__Model, $author$project$Spa$Generated$Pages$Blank__Msg, $author$project$Pages$Blank$page),
        vP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Bookkeeping__Model, $author$project$Spa$Generated$Pages$Bookkeeping__Msg, $author$project$Pages$Bookkeeping$page),
        vW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Calendar__Model, $author$project$Spa$Generated$Pages$Calendar__Msg, $author$project$Pages$Calendar$page),
        v7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Charges__New__Model, $author$project$Spa$Generated$Pages$Charges__New__Msg, $author$project$Pages$Charges$New$page),
        wf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$BrokerId_String$Top$page),
        wg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Ended$page),
        wh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$New$page),
        wi: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Brokers$Top$page),
        wj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Deals__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Deals$page),
        wk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$EndedDeals$page),
        wl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$StatementId_String$page),
        wm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Statements$Top$page),
        wn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__BrokerAccountId_String__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$BrokerAccountId_String$Top$page),
        wo: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__New__Msg, $author$project$Pages$Commissions$BrokerAccounts$New$page),
        wp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Model, $author$project$Spa$Generated$Pages$Commissions__BrokerAccounts__Top__Msg, $author$project$Pages$Commissions$BrokerAccounts$Top$page),
        wq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Model, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Summary__Msg, $author$project$Pages$Commissions$StatementLines$Summary$page),
        wr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Model, $author$project$Spa$Generated$Pages$Commissions__StatementLines__Top__Msg, $author$project$Pages$Commissions$StatementLines$Top$page),
        ws: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Commissions__Statements__Model, $author$project$Spa$Generated$Pages$Commissions__Statements__Msg, $author$project$Pages$Commissions$Statements$page),
        wt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__AffiliatesPricing__Msg, $author$project$Pages$Companies$CompanyId_String$AffiliatesPricing$page),
        wu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Eas__Msg, $author$project$Pages$Companies$CompanyId_String$Eas$page),
        wv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Create__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$Create$page),
        ww: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$EmployeeId_String$Dependent$DependentId_String$Top$page),
        wx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Employees__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Employees$Top$page),
        wy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__EndedCommissions__Msg, $author$project$Pages$Companies$CompanyId_String$EndedCommissions$page),
        wz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__InvoiceSettings__Msg, $author$project$Pages$Companies$CompanyId_String$InvoiceSettings$page),
        wA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Id_String__Msg, $author$project$Pages$Companies$CompanyId_String$Invoices$Id_String$page),
        wB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Invoices__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Invoices$Top$page),
        wC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notes__Msg, $author$project$Pages$Companies$CompanyId_String$Notes$page),
        wD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Notifications__Msg, $author$project$Pages$Companies$CompanyId_String$Notifications$page),
        wE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__PaymentSources__Msg, $author$project$Pages$Companies$CompanyId_String$PaymentSources$page),
        wF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Signup__Msg, $author$project$Pages$Companies$CompanyId_String$Signup$page),
        wG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__Id_String__Msg, $author$project$Pages$Companies$CompanyId_String$SignupPages$Id_String$page),
        wH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__SignupPages__New__Msg, $author$project$Pages$Companies$CompanyId_String$SignupPages$New$page),
        wI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Top$page),
        wJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$Top$page),
        wK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__Top__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$Top$page),
        wL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Model, $author$project$Spa$Generated$Pages$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults__Msg, $author$project$Pages$Companies$CompanyId_String$Uploads$UploadId_String$UploadResults$page),
        wM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__New__Model, $author$project$Spa$Generated$Pages$Companies__New__Msg, $author$project$Pages$Companies$New$page),
        wN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Companies__Top__Model, $author$project$Spa$Generated$Pages$Companies__Top__Msg, $author$project$Pages$Companies$Top$page),
        wP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Model, $author$project$Spa$Generated$Pages$Contacts__ContactId_String__Top__Msg, $author$project$Pages$Contacts$ContactId_String$Top$page),
        wQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__List__Model, $author$project$Spa$Generated$Pages$Contacts__List__Msg, $author$project$Pages$Contacts$List$page),
        wR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Contacts__New__Model, $author$project$Spa$Generated$Pages$Contacts__New__Msg, $author$project$Pages$Contacts$New$page),
        xz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Error__Status_String__Model, $author$project$Spa$Generated$Pages$Error__Status_String__Msg, $author$project$Pages$Error$Status_String$page),
        xM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Files__Public__Model, $author$project$Spa$Generated$Pages$Files__Public__Msg, $author$project$Pages$Files$Public$page),
        xN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Files__Top__Model, $author$project$Spa$Generated$Pages$Files__Top__Msg, $author$project$Pages$Files$Top$page),
        ap: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Forms__Model, $author$project$Spa$Generated$Pages$Forms__Msg, $author$project$Pages$Forms$page),
        xS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$GoogleCallback__Model, $author$project$Spa$Generated$Pages$GoogleCallback__Msg, $author$project$Pages$GoogleCallback$page),
        x$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Model, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Id_String__Msg, $author$project$Pages$Hinter$AdminUsersGroups$Id_String$page),
        x0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Model, $author$project$Spa$Generated$Pages$Hinter__AdminUsersGroups__Top__Msg, $author$project$Pages$Hinter$AdminUsersGroups$Top$page),
        x1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Model, $author$project$Spa$Generated$Pages$Hinter__ClonePractice__Msg, $author$project$Pages$Hinter$ClonePractice$page),
        x2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__Disputes__Model, $author$project$Spa$Generated$Pages$Hinter__Disputes__Msg, $author$project$Pages$Hinter$Disputes$page),
        x3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Model, $author$project$Spa$Generated$Pages$Hinter__FeatureFlags__Msg, $author$project$Pages$Hinter$FeatureFlags$page),
        x4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewGroup__Model, $author$project$Spa$Generated$Pages$Hinter__NewGroup__Msg, $author$project$Pages$Hinter$NewGroup$page),
        x5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewPartner__Model, $author$project$Spa$Generated$Pages$Hinter__NewPartner__Msg, $author$project$Pages$Hinter$NewPartner$page),
        x6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Hinter__NewPractice__Model, $author$project$Spa$Generated$Pages$Hinter__NewPractice__Msg, $author$project$Pages$Hinter$NewPractice$page),
        x7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Home__Model, $author$project$Spa$Generated$Pages$Home__Msg, $author$project$Pages$Home$page),
        yj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Model, $author$project$Spa$Generated$Pages$Inventory__InventoryId_String__Top__Msg, $author$project$Pages$Inventory$InventoryId_String$Top$page),
        yk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__List__Model, $author$project$Spa$Generated$Pages$Inventory__List__Msg, $author$project$Pages$Inventory$List$page),
        yl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__New__Model, $author$project$Spa$Generated$Pages$Inventory__New__Msg, $author$project$Pages$Inventory$New$page),
        ym: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Inventory__Settings__Model, $author$project$Spa$Generated$Pages$Inventory__Settings__Msg, $author$project$Pages$Inventory$Settings$page),
        yx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Join__Token_String__Model, $author$project$Spa$Generated$Pages$Join__Token_String__Msg, $author$project$Pages$Join$Token_String$page),
        yL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Login__Model, $author$project$Spa$Generated$Pages$Login__Msg, $author$project$Pages$Login$page),
        yM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Logout__Model, $author$project$Spa$Generated$Pages$Logout__Msg, $author$project$Pages$Logout$page),
        yR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Bookkeeping__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Bookkeeping__Manage__Settings__Msg, $author$project$Pages$Marketplace$Bookkeeping$Manage$Settings$page),
        yS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Elation__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Elation__Manage__Settings__Msg, $author$project$Pages$Marketplace$Elation$Manage$Settings$page),
        yT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Manage__Model, $author$project$Spa$Generated$Pages$Marketplace__Manage__Msg, $author$project$Pages$Marketplace$Manage$page),
        yU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Quickbooks__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Quickbooks__Manage__Settings__Msg, $author$project$Pages$Marketplace$Quickbooks$Manage$Settings$page),
        yV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Msg, $author$project$Pages$Marketplace$Slug_String$page),
        yW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Onboarding__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Onboarding$page),
        yX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Settings__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Settings$page),
        yY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Model, $author$project$Spa$Generated$Pages$Marketplace__Slug_String__Manage__Users__Msg, $author$project$Pages$Marketplace$Slug_String$Manage$Users$page),
        yZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Marketplace__Top__Model, $author$project$Spa$Generated$Pages$Marketplace__Top__Msg, $author$project$Pages$Marketplace$Top$page),
        y5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Calls__Model, $author$project$Spa$Generated$Pages$Messages__Calls__Msg, $author$project$Pages$Messages$Calls$page),
        y6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Chat__Model, $author$project$Spa$Generated$Pages$Messages__Chat__Msg, $author$project$Pages$Messages$Chat$page),
        y7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Drafts__Model, $author$project$Spa$Generated$Pages$Messages__Drafts__Msg, $author$project$Pages$Messages$Drafts$page),
        y8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Faxes__New__Model, $author$project$Spa$Generated$Pages$Messages__Faxes__New__Msg, $author$project$Pages$Messages$Faxes$New$page),
        y9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Model, $author$project$Spa$Generated$Pages$Messages__Faxes__Top__Msg, $author$project$Pages$Messages$Faxes$Top$page),
        za: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Forms__Model, $author$project$Spa$Generated$Pages$Messages__Forms__Msg, $author$project$Pages$Messages$Forms$page),
        zb: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Labs__Model, $author$project$Spa$Generated$Pages$Messages__Labs__Msg, $author$project$Pages$Messages$Labs$page),
        zc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__New__Msg, $author$project$Pages$Messages$Scheduled$New$page),
        zd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__ScheduledId_String__Top__Msg, $author$project$Pages$Messages$Scheduled$ScheduledId_String$Top$page),
        ze: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Model, $author$project$Spa$Generated$Pages$Messages__Scheduled__Top__Msg, $author$project$Pages$Messages$Scheduled$Top$page),
        zf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Messages__Sms__Model, $author$project$Spa$Generated$Pages$Messages__Sms__Msg, $author$project$Pages$Messages$Sms$page),
        zt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Ident_String__Msg, $author$project$Pages$NewSettings$AppointmentTypes$Ident_String$page),
        zu: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__New__Msg, $author$project$Pages$NewSettings$AppointmentTypes$New$page),
        zv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__AppointmentTypes__Top__Msg, $author$project$Pages$NewSettings$AppointmentTypes$Top$page),
        zw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__BlockedPhoneNumbers__Model, $author$project$Spa$Generated$Pages$NewSettings__BlockedPhoneNumbers__Msg, $author$project$Pages$NewSettings$BlockedPhoneNumbers$page),
        zx: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__BookingOverview__Model, $author$project$Spa$Generated$Pages$NewSettings__BookingOverview__Msg, $author$project$Pages$NewSettings$BookingOverview$page),
        zy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Erx__Model, $author$project$Spa$Generated$Pages$NewSettings__Erx__Msg, $author$project$Pages$NewSettings$Erx$page),
        zz: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Export__Model, $author$project$Spa$Generated$Pages$NewSettings__Export__Msg, $author$project$Pages$NewSettings$Export$page),
        zA: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Model, $author$project$Spa$Generated$Pages$NewSettings__HinterSettings__Msg, $author$project$Pages$NewSettings$HinterSettings$page),
        zB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Locations__BookingLocationId_String__Msg, $author$project$Pages$NewSettings$Locations$BookingLocationId_String$page),
        zC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Locations__New__LocationId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Locations__New__LocationId_String__Msg, $author$project$Pages$NewSettings$Locations$New$LocationId_String$page),
        zD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__Locations__Top__Msg, $author$project$Pages$NewSettings$Locations$Top$page),
        zE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Model, $author$project$Spa$Generated$Pages$NewSettings__PracticeInfo__Msg, $author$project$Pages$NewSettings$PracticeInfo$page),
        zF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__Msg, $author$project$Pages$NewSettings$Team$page),
        zG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__Msg, $author$project$Pages$NewSettings$Team$TeamId_String$page),
        zH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Model, $author$project$Spa$Generated$Pages$NewSettings__Team__TeamId_String__BasicInfo__Msg, $author$project$Pages$NewSettings$Team$TeamId_String$BasicInfo$page),
        zI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__New__Msg, $author$project$Pages$NewSettings$Templates$New$page),
        zJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__TemplateId_String__Msg, $author$project$Pages$NewSettings$Templates$TemplateId_String$page),
        zK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Model, $author$project$Spa$Generated$Pages$NewSettings__Templates__Top__Msg, $author$project$Pages$NewSettings$Templates$Top$page),
        rD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$NotFound__Model, $author$project$Spa$Generated$Pages$NotFound__Msg, $author$project$Pages$NotFound$page),
        zS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Oauth__Callback__Model, $author$project$Spa$Generated$Pages$Oauth__Callback__Msg, $author$project$Pages$Oauth$Callback$page),
        z3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Model, $author$project$Spa$Generated$Pages$Onboard__DealId_String__Top__Msg, $author$project$Pages$Onboard$DealId_String$Top$page),
        z4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completed__Msg, $author$project$Pages$Onboard$OnboardId_String$Completed$page),
        z5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Completing__Msg, $author$project$Pages$Onboard$OnboardId_String$Completing$page),
        z6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__Payment__Msg, $author$project$Pages$Onboard$OnboardId_String$Payment$page),
        z7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Model, $author$project$Spa$Generated$Pages$Onboard__OnboardId_String__User__Msg, $author$project$Pages$Onboard$OnboardId_String$User$page),
        z8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Onboarding__Model, $author$project$Spa$Generated$Pages$Onboarding__Msg, $author$project$Pages$Onboarding$page),
        Aj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__ApiKeys__Model, $author$project$Spa$Generated$Pages$Partner__ApiKeys__Msg, $author$project$Pages$Partner$ApiKeys$page),
        Ak: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Msg, $author$project$Pages$Partner$Billing$page),
        Al: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Billing__Hinter__Msg, $author$project$Pages$Partner$Billing$Hinter$page),
        Am: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Model, $author$project$Spa$Generated$Pages$Partner__Dashboard__Top__Msg, $author$project$Pages$Partner$Dashboard$Top$page),
        An: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Engagements__Model, $author$project$Spa$Generated$Pages$Partner__Engagements__Msg, $author$project$Pages$Partner$Engagements$page),
        Ao: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Hinter__Msg, $author$project$Pages$Partner$Hinter$page),
        Ap: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Practices__Top__Model, $author$project$Spa$Generated$Pages$Partner__Practices__Top__Msg, $author$project$Pages$Partner$Practices$Top$page),
        Aq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__Model, $author$project$Spa$Generated$Pages$Partner__Product__Msg, $author$project$Pages$Partner$Product$page),
        Ar: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__ActivationSettings__Model, $author$project$Spa$Generated$Pages$Partner__Product__ActivationSettings__Msg, $author$project$Pages$Partner$Product$ActivationSettings$page),
        As: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__AppSettings__Model, $author$project$Spa$Generated$Pages$Partner__Product__AppSettings__Msg, $author$project$Pages$Partner$Product$AppSettings$page),
        At: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__Hinter__Model, $author$project$Spa$Generated$Pages$Partner__Product__Hinter__Msg, $author$project$Pages$Partner$Product$Hinter$page),
        Au: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Product__New__Model, $author$project$Spa$Generated$Pages$Partner__Product__New__Msg, $author$project$Pages$Partner$Product$New$page),
        Av: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Model, $author$project$Spa$Generated$Pages$Partner__Sandboxes__Top__Msg, $author$project$Pages$Partner$Sandboxes$Top$page),
        Aw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Team__Model, $author$project$Spa$Generated$Pages$Partner__Team__Msg, $author$project$Pages$Partner$Team$page),
        Ax: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Webhooks__Requests__Model, $author$project$Spa$Generated$Pages$Partner__Webhooks__Requests__Msg, $author$project$Pages$Partner$Webhooks$Requests$page),
        Ay: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Partner__Webhooks__Settings__Model, $author$project$Spa$Generated$Pages$Partner__Webhooks__Settings__Msg, $author$project$Pages$Partner$Webhooks$Settings$page),
        AE: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Create__Model, $author$project$Spa$Generated$Pages$Patients__Create__Msg, $author$project$Pages$Patients$Create$page),
        AF: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Accounts__Top__Msg, $author$project$Pages$Patients$PatientId_String$Accounts$Top$page),
        AG: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Affiliation__Top__Msg, $author$project$Pages$Patients$PatientId_String$Affiliation$Top$page),
        AH: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Agreements__AgreementId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Agreements$AgreementId_String$Top$page),
        AI: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__InvoiceId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Charges$InvoiceId_String$Top$page),
        AJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Charges__Top__Msg, $author$project$Pages$Patients$PatientId_String$Charges$Top$page),
        AK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Chart__Msg, $author$project$Pages$Patients$PatientId_String$Chart$page),
        AL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Edit__Msg, $author$project$Pages$Patients$PatientId_String$Edit$page),
        AM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__GrowthChart__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__GrowthChart__Msg, $author$project$Pages$Patients$PatientId_String$GrowthChart$page),
        AN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__LabTrends__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__LabTrends__Msg, $author$project$Pages$Patients$PatientId_String$LabTrends$page),
        AO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__ManageCredits__Msg, $author$project$Pages$Patients$PatientId_String$ManageCredits$page),
        AP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__MembershipId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$MembershipId_String$Top$page),
        AQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__New__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$New$page),
        AR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Memberships__Top__Msg, $author$project$Pages$Patients$PatientId_String$Memberships$Top$page),
        AS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Merge__Msg, $author$project$Pages$Patients$PatientId_String$Merge$page),
        AT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__NoteId_String__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__NoteId_String__Msg, $author$project$Pages$Patients$PatientId_String$Notes$NoteId_String$page),
        AU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notes__Top__Msg, $author$project$Pages$Patients$PatientId_String$Notes$Top$page),
        AV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Notifications__Top__Msg, $author$project$Pages$Patients$PatientId_String$Notifications$Top$page),
        AW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__Top__Msg, $author$project$Pages$Patients$PatientId_String$Top$page),
        AX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__PatientId_String__VitalsTrends__Model, $author$project$Spa$Generated$Pages$Patients__PatientId_String__VitalsTrends__Msg, $author$project$Pages$Patients$PatientId_String$VitalsTrends$page),
        AY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Top__Model, $author$project$Spa$Generated$Pages$Patients__Top__Msg, $author$project$Pages$Patients$Top$page),
        AZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Patients__Upload__Model, $author$project$Spa$Generated$Pages$Patients__Upload__Msg, $author$project$Pages$Patients$Upload$page),
        Bd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Account__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Account__Msg, $author$project$Pages$PracticeSetup$Account$page),
        Be: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Communications__Msg, $author$project$Pages$PracticeSetup$Communications$page),
        Bf: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Complete__Msg, $author$project$Pages$PracticeSetup$Complete$page),
        Bg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Documents__Msg, $author$project$Pages$PracticeSetup$Documents$page),
        Bh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Legal__Msg, $author$project$Pages$PracticeSetup$Legal$page),
        Bi: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Model, $author$project$Spa$Generated$Pages$PracticeSetup__PaymentProcessing__Msg, $author$project$Pages$PracticeSetup$PaymentProcessing$page),
        Bj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Msg, $author$project$Pages$PracticeSetup$Plans$page),
        Bk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__Id_String__Edit__Msg, $author$project$Pages$PracticeSetup$Plans$Id_String$Edit$page),
        Bl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Plans__New__Msg, $author$project$Pages$PracticeSetup$Plans$New$page),
        Bm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Team__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Team__Msg, $author$project$Pages$PracticeSetup$Team$page),
        Bn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$PracticeSetup__Top__Model, $author$project$Spa$Generated$Pages$PracticeSetup__Top__Msg, $author$project$Pages$PracticeSetup$Top$page),
        BK: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Model, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Id_String__Msg, $author$project$Pages$Reports$AncillaryCharges$Id_String$page),
        BL: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Model, $author$project$Spa$Generated$Pages$Reports__AncillaryCharges__Top__Msg, $author$project$Pages$Reports$AncillaryCharges$Top$page),
        BM: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Model, $author$project$Spa$Generated$Pages$Reports__CompanyInvoices__Msg, $author$project$Pages$Reports$CompanyInvoices$page),
        BN: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Model, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Msg, $author$project$Pages$Reports$CreditOutstanding$page),
        BO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Model, $author$project$Spa$Generated$Pages$Reports__CreditOutstanding__Summary__Msg, $author$project$Pages$Reports$CreditOutstanding$Summary$page),
        BP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Model, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Msg, $author$project$Pages$Reports$CreditTransactions$page),
        BQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Model, $author$project$Spa$Generated$Pages$Reports__CreditTransactions__Summary__Msg, $author$project$Pages$Reports$CreditTransactions$Summary$page),
        BR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Model, $author$project$Spa$Generated$Pages$Reports__Custom__Id_String__Msg, $author$project$Pages$Reports$Custom$Id_String$page),
        BS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Custom__New__Model, $author$project$Spa$Generated$Pages$Reports__Custom__New__Msg, $author$project$Pages$Reports$Custom$New$page),
        BT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Dashboard__Model, $author$project$Spa$Generated$Pages$Reports__Dashboard__Msg, $author$project$Pages$Reports$Dashboard$page),
        BU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Model, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Msg, $author$project$Pages$Reports$DeferredRevenue$page),
        BV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Model, $author$project$Spa$Generated$Pages$Reports__DeferredRevenue__Summary__Msg, $author$project$Pages$Reports$DeferredRevenue$Summary$page),
        BW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Deposits__Model, $author$project$Spa$Generated$Pages$Reports__Deposits__Msg, $author$project$Pages$Reports$Deposits$page),
        BX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Disputes__Model, $author$project$Spa$Generated$Pages$Reports__Disputes__Msg, $author$project$Pages$Reports$Disputes$page),
        BY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Invoices__Model, $author$project$Spa$Generated$Pages$Reports__Invoices__Msg, $author$project$Pages$Reports$Invoices$page),
        BZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Memberships__Model, $author$project$Spa$Generated$Pages$Reports__Memberships__Msg, $author$project$Pages$Reports$Memberships$page),
        B_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Months__Model, $author$project$Spa$Generated$Pages$Reports__Months__Msg, $author$project$Pages$Reports$Months$page),
        B$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Model, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Msg, $author$project$Pages$Reports$PaymentApplications$page),
        B0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Model, $author$project$Spa$Generated$Pages$Reports__PaymentApplications__Summary__Msg, $author$project$Pages$Reports$PaymentApplications$Summary$page),
        B1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Revenue__Model, $author$project$Spa$Generated$Pages$Reports__Revenue__Msg, $author$project$Pages$Reports$Revenue$page),
        B2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Model, $author$project$Spa$Generated$Pages$Reports__Revenue__Summary__Msg, $author$project$Pages$Reports$Revenue$Summary$page),
        B3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SalesTax__Model, $author$project$Spa$Generated$Pages$Reports__SalesTax__Msg, $author$project$Pages$Reports$SalesTax$page),
        B4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Model, $author$project$Spa$Generated$Pages$Reports__SalesTax__Summary__Msg, $author$project$Pages$Reports$SalesTax$Summary$page),
        B5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Model, $author$project$Spa$Generated$Pages$Reports__SignupAttempts__Msg, $author$project$Pages$Reports$SignupAttempts$page),
        CO: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Model, $author$project$Spa$Generated$Pages$StyleGuide__ActivityIndicators__Msg, $author$project$Pages$StyleGuide$ActivityIndicators$page),
        CP: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__AddressInput__Msg, $author$project$Pages$StyleGuide$AddressInput$page),
        CQ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Alert__Model, $author$project$Spa$Generated$Pages$StyleGuide__Alert__Msg, $author$project$Pages$StyleGuide$Alert$page),
        CR: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Badge__Model, $author$project$Spa$Generated$Pages$StyleGuide__Badge__Msg, $author$project$Pages$StyleGuide$Badge$page),
        CS: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Button__Model, $author$project$Spa$Generated$Pages$StyleGuide__Button__Msg, $author$project$Pages$StyleGuide$Button$page),
        CT: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Model, $author$project$Spa$Generated$Pages$StyleGuide__Carousel__Msg, $author$project$Pages$StyleGuide$Carousel$page),
        CU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Model, $author$project$Spa$Generated$Pages$StyleGuide__Checkbox__Msg, $author$project$Pages$StyleGuide$Checkbox$page),
        CV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__CurrencyInput__Msg, $author$project$Pages$StyleGuide$CurrencyInput$page),
        CW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__DateInput__Msg, $author$project$Pages$StyleGuide$DateInput$page),
        CX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__DateRangeInput__Msg, $author$project$Pages$StyleGuide$DateRangeInput$page),
        CY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Model, $author$project$Spa$Generated$Pages$StyleGuide__Dropdown__Msg, $author$project$Pages$StyleGuide$Dropdown$page),
        CZ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Model, $author$project$Spa$Generated$Pages$StyleGuide__ExportCsv__Msg, $author$project$Pages$StyleGuide$ExportCsv$page),
        C_: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__FileInput__Msg, $author$project$Pages$StyleGuide$FileInput$page),
        C$: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Model, $author$project$Spa$Generated$Pages$StyleGuide__FlyoutMenu__Msg, $author$project$Pages$StyleGuide$FlyoutMenu$page),
        C0: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormExample__Msg, $author$project$Pages$StyleGuide$FormExample$page),
        C1: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormGroup__Msg, $author$project$Pages$StyleGuide$FormGroup$page),
        C2: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Model, $author$project$Spa$Generated$Pages$StyleGuide__FormStatic__Msg, $author$project$Pages$StyleGuide$FormStatic$page),
        C3: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Grid__Model, $author$project$Spa$Generated$Pages$StyleGuide__Grid__Msg, $author$project$Pages$StyleGuide$Grid$page),
        C4: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Model, $author$project$Spa$Generated$Pages$StyleGuide__HiConfirm__Msg, $author$project$Pages$StyleGuide$HiConfirm$page),
        C5: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Model, $author$project$Spa$Generated$Pages$StyleGuide__HorizontalRule__Msg, $author$project$Pages$StyleGuide$HorizontalRule$page),
        C6: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Icon__Model, $author$project$Spa$Generated$Pages$StyleGuide__Icon__Msg, $author$project$Pages$StyleGuide$Icon$page),
        C7: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Input__Model, $author$project$Spa$Generated$Pages$StyleGuide__Input__Msg, $author$project$Pages$StyleGuide$Input$page),
        C8: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Link__Model, $author$project$Spa$Generated$Pages$StyleGuide__Link__Msg, $author$project$Pages$StyleGuide$Link$page),
        C9: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Model, $author$project$Spa$Generated$Pages$StyleGuide__ListGroup__Msg, $author$project$Pages$StyleGuide$ListGroup$page),
        Da: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Modal__Model, $author$project$Spa$Generated$Pages$StyleGuide__Modal__Msg, $author$project$Pages$StyleGuide$Modal$page),
        Db: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Model, $author$project$Spa$Generated$Pages$StyleGuide__Pagination__Msg, $author$project$Pages$StyleGuide$Pagination$page),
        Dc: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Panel__Model, $author$project$Spa$Generated$Pages$StyleGuide__Panel__Msg, $author$project$Pages$StyleGuide$Panel$page),
        Dd: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__PasswordInput__Msg, $author$project$Pages$StyleGuide$PasswordInput$page),
        De: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Model, $author$project$Spa$Generated$Pages$StyleGuide__PaymentSourceDisplayer__Msg, $author$project$Pages$StyleGuide$PaymentSourceDisplayer$page),
        Df: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__PhoneInput__Msg, $author$project$Pages$StyleGuide$PhoneInput$page),
        Dg: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Popover__Model, $author$project$Spa$Generated$Pages$StyleGuide__Popover__Msg, $author$project$Pages$StyleGuide$Popover$page),
        Dh: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Model, $author$project$Spa$Generated$Pages$StyleGuide__ProgressBar__Msg, $author$project$Pages$StyleGuide$ProgressBar$page),
        Di: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Radio__Model, $author$project$Spa$Generated$Pages$StyleGuide__Radio__Msg, $author$project$Pages$StyleGuide$Radio$page),
        Dj: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Model, $author$project$Spa$Generated$Pages$StyleGuide__ResourceFilter__Msg, $author$project$Pages$StyleGuide$ResourceFilter$page),
        Dk: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Model, $author$project$Spa$Generated$Pages$StyleGuide__SearchInput__Msg, $author$project$Pages$StyleGuide$SearchInput$page),
        Dl: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__SearchableSelect__Model, $author$project$Spa$Generated$Pages$StyleGuide__SearchableSelect__Msg, $author$project$Pages$StyleGuide$SearchableSelect$page),
        Dm: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Select__Model, $author$project$Spa$Generated$Pages$StyleGuide__Select__Msg, $author$project$Pages$StyleGuide$Select$page),
        Dn: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Model, $author$project$Spa$Generated$Pages$StyleGuide__Skeleton__Msg, $author$project$Pages$StyleGuide$Skeleton$page),
        Do: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Table__Model, $author$project$Spa$Generated$Pages$StyleGuide__Table__Msg, $author$project$Pages$StyleGuide$Table$page),
        Dp: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Toast__Model, $author$project$Spa$Generated$Pages$StyleGuide__Toast__Msg, $author$project$Pages$StyleGuide$Toast$page),
        Dq: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Model, $author$project$Spa$Generated$Pages$StyleGuide__ToggleSwitch__Msg, $author$project$Pages$StyleGuide$ToggleSwitch$page),
        Dr: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Model, $author$project$Spa$Generated$Pages$StyleGuide__Tooltip__Msg, $author$project$Pages$StyleGuide$Tooltip$page),
        Ds: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Top__Model, $author$project$Spa$Generated$Pages$StyleGuide__Top__Msg, $author$project$Pages$StyleGuide$Top$page),
        Dt: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Typography__Model, $author$project$Spa$Generated$Pages$StyleGuide__Typography__Msg, $author$project$Pages$StyleGuide$Typography$page),
        Du: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Model, $author$project$Spa$Generated$Pages$StyleGuide__UploadForm__Msg, $author$project$Pages$StyleGuide$UploadForm$page),
        Dv: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Model, $author$project$Spa$Generated$Pages$StyleGuide__UploadResult__Msg, $author$project$Pages$StyleGuide$UploadResult$page),
        Dw: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$StyleGuide__Well__Model, $author$project$Spa$Generated$Pages$StyleGuide__Well__Msg, $author$project$Pages$StyleGuide$Well$page),
        Dy: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Support__CannySso__Model, $author$project$Spa$Generated$Pages$Support__CannySso__Msg, $author$project$Pages$Support$CannySso$page),
        DB: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__New__Model, $author$project$Spa$Generated$Pages$Tasks__New__Msg, $author$project$Pages$Tasks$New$page),
        DC: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Model, $author$project$Spa$Generated$Pages$Tasks__TasksId_String__Top__Msg, $author$project$Pages$Tasks$TasksId_String$Top$page),
        DD: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Tasks__Top__Model, $author$project$Spa$Generated$Pages$Tasks__Top__Msg, $author$project$Pages$Tasks$Top$page),
        DJ: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$Top__Model, $author$project$Spa$Generated$Pages$Top__Msg, $author$project$Pages$Top$page),
        DU: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__AcceptTerms__Model, $author$project$Spa$Generated$Pages$User__AcceptTerms__Msg, $author$project$Pages$User$AcceptTerms$page),
        DV: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Mfa__Model, $author$project$Spa$Generated$Pages$User__Mfa__Msg, $author$project$Pages$User$Mfa$page),
        DW: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Organizations__Top__Model, $author$project$Spa$Generated$Pages$User__Organizations__Top__Msg, $author$project$Pages$User$Organizations$Top$page),
        DX: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Profile__Model, $author$project$Spa$Generated$Pages$User__Profile__Msg, $author$project$Pages$User$Profile$page),
        DY: A3($author$project$Spa$Generated$Pages$upgrade, $author$project$Spa$Generated$Pages$User__Security__Model, $author$project$Spa$Generated$Pages$User__Security__Msg, $author$project$Pages$User$Security$page)
    };
    var $author$project$Spa$Generated$Pages$init = function(route) {
        switch(route.$){
            case 0:
                return $author$project$Spa$Generated$Pages$pages.DJ.aeq(0);
            case 1:
                return $author$project$Spa$Generated$Pages$pages.vO.aeq(0);
            case 2:
                return $author$project$Spa$Generated$Pages$pages.vP.aeq(0);
            case 3:
                return $author$project$Spa$Generated$Pages$pages.vW.aeq(0);
            case 4:
                return $author$project$Spa$Generated$Pages$pages.ap.aeq(0);
            case 5:
                return $author$project$Spa$Generated$Pages$pages.xS.aeq(0);
            case 6:
                return $author$project$Spa$Generated$Pages$pages.x7.aeq(0);
            case 7:
                return $author$project$Spa$Generated$Pages$pages.yL.aeq(0);
            case 8:
                return $author$project$Spa$Generated$Pages$pages.yM.aeq(0);
            case 9:
                return $author$project$Spa$Generated$Pages$pages.rD.aeq(0);
            case 10:
                return $author$project$Spa$Generated$Pages$pages.z8.aeq(0);
            case 11:
                return $author$project$Spa$Generated$Pages$pages.vd.aeq(0);
            case 12:
                return $author$project$Spa$Generated$Pages$pages.vp.aeq(0);
            case 13:
                return $author$project$Spa$Generated$Pages$pages.wN.aeq(0);
            case 14:
                return $author$project$Spa$Generated$Pages$pages.xN.aeq(0);
            case 15:
                return $author$project$Spa$Generated$Pages$pages.yZ.aeq(0);
            case 16:
                return $author$project$Spa$Generated$Pages$pages.AY.aeq(0);
            case 17:
                return $author$project$Spa$Generated$Pages$pages.Bn.aeq(0);
            case 18:
                return $author$project$Spa$Generated$Pages$pages.Ds.aeq(0);
            case 19:
                return $author$project$Spa$Generated$Pages$pages.DD.aeq(0);
            case 20:
                return $author$project$Spa$Generated$Pages$pages.tU.aeq(0);
            case 21:
                return $author$project$Spa$Generated$Pages$pages.t$.aeq(0);
            case 22:
                return $author$project$Spa$Generated$Pages$pages.t1.aeq(0);
            case 23:
                return $author$project$Spa$Generated$Pages$pages.t2.aeq(0);
            case 24:
                return $author$project$Spa$Generated$Pages$pages.t3.aeq(0);
            case 25:
                return $author$project$Spa$Generated$Pages$pages.t8.aeq(0);
            case 26:
                return $author$project$Spa$Generated$Pages$pages.uc.aeq(0);
            case 27:
                return $author$project$Spa$Generated$Pages$pages.ug.aeq(0);
            case 28:
                return $author$project$Spa$Generated$Pages$pages.uu.aeq(0);
            case 29:
                return $author$project$Spa$Generated$Pages$pages.uz.aeq(0);
            case 30:
                return $author$project$Spa$Generated$Pages$pages.uA.aeq(0);
            case 31:
                return $author$project$Spa$Generated$Pages$pages.uC.aeq(0);
            case 32:
                return $author$project$Spa$Generated$Pages$pages.uD.aeq(0);
            case 33:
                return $author$project$Spa$Generated$Pages$pages.uE.aeq(0);
            case 34:
                return $author$project$Spa$Generated$Pages$pages.uF.aeq(0);
            case 35:
                return $author$project$Spa$Generated$Pages$pages.uG.aeq(0);
            case 36:
                return $author$project$Spa$Generated$Pages$pages.uH.aeq(0);
            case 37:
                return $author$project$Spa$Generated$Pages$pages.uP.aeq(0);
            case 38:
                return $author$project$Spa$Generated$Pages$pages.uQ.aeq(0);
            case 39:
                return $author$project$Spa$Generated$Pages$pages.uS.aeq(0);
            case 40:
                return $author$project$Spa$Generated$Pages$pages.uT.aeq(0);
            case 41:
                return $author$project$Spa$Generated$Pages$pages.uZ.aeq(0);
            case 42:
                return $author$project$Spa$Generated$Pages$pages.u_.aeq(0);
            case 43:
                return $author$project$Spa$Generated$Pages$pages.u2.aeq(0);
            case 44:
                return $author$project$Spa$Generated$Pages$pages.u3.aeq(0);
            case 45:
                return $author$project$Spa$Generated$Pages$pages.u4.aeq(0);
            case 46:
                return $author$project$Spa$Generated$Pages$pages.u8.aeq(0);
            case 47:
                return $author$project$Spa$Generated$Pages$pages.u9.aeq(0);
            case 48:
                return $author$project$Spa$Generated$Pages$pages.va.aeq(0);
            case 49:
                return $author$project$Spa$Generated$Pages$pages.vn.aeq(0);
            case 50:
                return $author$project$Spa$Generated$Pages$pages.vo.aeq(0);
            case 51:
                return $author$project$Spa$Generated$Pages$pages.v7.aeq(0);
            case 52:
                return $author$project$Spa$Generated$Pages$pages.ws.aeq(0);
            case 53:
                return $author$project$Spa$Generated$Pages$pages.wM.aeq(0);
            case 54:
                return $author$project$Spa$Generated$Pages$pages.wQ.aeq(0);
            case 55:
                return $author$project$Spa$Generated$Pages$pages.wR.aeq(0);
            case 56:
                return $author$project$Spa$Generated$Pages$pages.xM.aeq(0);
            case 57:
                return $author$project$Spa$Generated$Pages$pages.x1.aeq(0);
            case 58:
                return $author$project$Spa$Generated$Pages$pages.x2.aeq(0);
            case 59:
                return $author$project$Spa$Generated$Pages$pages.x3.aeq(0);
            case 60:
                return $author$project$Spa$Generated$Pages$pages.x4.aeq(0);
            case 61:
                return $author$project$Spa$Generated$Pages$pages.x5.aeq(0);
            case 62:
                return $author$project$Spa$Generated$Pages$pages.x6.aeq(0);
            case 63:
                return $author$project$Spa$Generated$Pages$pages.yk.aeq(0);
            case 64:
                return $author$project$Spa$Generated$Pages$pages.yl.aeq(0);
            case 65:
                return $author$project$Spa$Generated$Pages$pages.ym.aeq(0);
            case 66:
                return $author$project$Spa$Generated$Pages$pages.yT.aeq(0);
            case 67:
                return $author$project$Spa$Generated$Pages$pages.y5.aeq(0);
            case 68:
                return $author$project$Spa$Generated$Pages$pages.y6.aeq(0);
            case 69:
                return $author$project$Spa$Generated$Pages$pages.y7.aeq(0);
            case 70:
                return $author$project$Spa$Generated$Pages$pages.za.aeq(0);
            case 71:
                return $author$project$Spa$Generated$Pages$pages.zb.aeq(0);
            case 72:
                return $author$project$Spa$Generated$Pages$pages.zf.aeq(0);
            case 73:
                return $author$project$Spa$Generated$Pages$pages.zw.aeq(0);
            case 74:
                return $author$project$Spa$Generated$Pages$pages.zx.aeq(0);
            case 75:
                return $author$project$Spa$Generated$Pages$pages.zy.aeq(0);
            case 76:
                return $author$project$Spa$Generated$Pages$pages.zz.aeq(0);
            case 77:
                return $author$project$Spa$Generated$Pages$pages.zA.aeq(0);
            case 78:
                return $author$project$Spa$Generated$Pages$pages.zE.aeq(0);
            case 79:
                return $author$project$Spa$Generated$Pages$pages.zF.aeq(0);
            case 80:
                return $author$project$Spa$Generated$Pages$pages.zS.aeq(0);
            case 81:
                return $author$project$Spa$Generated$Pages$pages.Aj.aeq(0);
            case 82:
                return $author$project$Spa$Generated$Pages$pages.Ak.aeq(0);
            case 83:
                return $author$project$Spa$Generated$Pages$pages.An.aeq(0);
            case 84:
                return $author$project$Spa$Generated$Pages$pages.Ao.aeq(0);
            case 85:
                return $author$project$Spa$Generated$Pages$pages.Aq.aeq(0);
            case 86:
                return $author$project$Spa$Generated$Pages$pages.Aw.aeq(0);
            case 87:
                return $author$project$Spa$Generated$Pages$pages.AE.aeq(0);
            case 88:
                return $author$project$Spa$Generated$Pages$pages.AZ.aeq(0);
            case 89:
                return $author$project$Spa$Generated$Pages$pages.Bd.aeq(0);
            case 90:
                return $author$project$Spa$Generated$Pages$pages.Be.aeq(0);
            case 91:
                return $author$project$Spa$Generated$Pages$pages.Bf.aeq(0);
            case 92:
                return $author$project$Spa$Generated$Pages$pages.Bg.aeq(0);
            case 93:
                return $author$project$Spa$Generated$Pages$pages.Bh.aeq(0);
            case 94:
                return $author$project$Spa$Generated$Pages$pages.Bi.aeq(0);
            case 95:
                return $author$project$Spa$Generated$Pages$pages.Bj.aeq(0);
            case 96:
                return $author$project$Spa$Generated$Pages$pages.Bm.aeq(0);
            case 97:
                return $author$project$Spa$Generated$Pages$pages.BM.aeq(0);
            case 98:
                return $author$project$Spa$Generated$Pages$pages.BN.aeq(0);
            case 99:
                return $author$project$Spa$Generated$Pages$pages.BP.aeq(0);
            case 100:
                return $author$project$Spa$Generated$Pages$pages.BT.aeq(0);
            case 101:
                return $author$project$Spa$Generated$Pages$pages.BU.aeq(0);
            case 102:
                return $author$project$Spa$Generated$Pages$pages.BW.aeq(0);
            case 103:
                return $author$project$Spa$Generated$Pages$pages.BX.aeq(0);
            case 104:
                return $author$project$Spa$Generated$Pages$pages.BY.aeq(0);
            case 105:
                return $author$project$Spa$Generated$Pages$pages.BZ.aeq(0);
            case 106:
                return $author$project$Spa$Generated$Pages$pages.B_.aeq(0);
            case 107:
                return $author$project$Spa$Generated$Pages$pages.B$.aeq(0);
            case 108:
                return $author$project$Spa$Generated$Pages$pages.B1.aeq(0);
            case 109:
                return $author$project$Spa$Generated$Pages$pages.B3.aeq(0);
            case 110:
                return $author$project$Spa$Generated$Pages$pages.B5.aeq(0);
            case 111:
                return $author$project$Spa$Generated$Pages$pages.CO.aeq(0);
            case 112:
                return $author$project$Spa$Generated$Pages$pages.CP.aeq(0);
            case 113:
                return $author$project$Spa$Generated$Pages$pages.CQ.aeq(0);
            case 114:
                return $author$project$Spa$Generated$Pages$pages.CR.aeq(0);
            case 115:
                return $author$project$Spa$Generated$Pages$pages.CS.aeq(0);
            case 116:
                return $author$project$Spa$Generated$Pages$pages.CT.aeq(0);
            case 117:
                return $author$project$Spa$Generated$Pages$pages.CU.aeq(0);
            case 118:
                return $author$project$Spa$Generated$Pages$pages.CV.aeq(0);
            case 119:
                return $author$project$Spa$Generated$Pages$pages.CW.aeq(0);
            case 120:
                return $author$project$Spa$Generated$Pages$pages.CX.aeq(0);
            case 121:
                return $author$project$Spa$Generated$Pages$pages.CY.aeq(0);
            case 122:
                return $author$project$Spa$Generated$Pages$pages.CZ.aeq(0);
            case 123:
                return $author$project$Spa$Generated$Pages$pages.C_.aeq(0);
            case 124:
                return $author$project$Spa$Generated$Pages$pages.C$.aeq(0);
            case 125:
                return $author$project$Spa$Generated$Pages$pages.C0.aeq(0);
            case 126:
                return $author$project$Spa$Generated$Pages$pages.C1.aeq(0);
            case 127:
                return $author$project$Spa$Generated$Pages$pages.C2.aeq(0);
            case 128:
                return $author$project$Spa$Generated$Pages$pages.C3.aeq(0);
            case 129:
                return $author$project$Spa$Generated$Pages$pages.C4.aeq(0);
            case 130:
                return $author$project$Spa$Generated$Pages$pages.C5.aeq(0);
            case 131:
                return $author$project$Spa$Generated$Pages$pages.C6.aeq(0);
            case 132:
                return $author$project$Spa$Generated$Pages$pages.C7.aeq(0);
            case 133:
                return $author$project$Spa$Generated$Pages$pages.C8.aeq(0);
            case 134:
                return $author$project$Spa$Generated$Pages$pages.C9.aeq(0);
            case 135:
                return $author$project$Spa$Generated$Pages$pages.Da.aeq(0);
            case 136:
                return $author$project$Spa$Generated$Pages$pages.Db.aeq(0);
            case 137:
                return $author$project$Spa$Generated$Pages$pages.Dc.aeq(0);
            case 138:
                return $author$project$Spa$Generated$Pages$pages.Dd.aeq(0);
            case 139:
                return $author$project$Spa$Generated$Pages$pages.De.aeq(0);
            case 140:
                return $author$project$Spa$Generated$Pages$pages.Df.aeq(0);
            case 141:
                return $author$project$Spa$Generated$Pages$pages.Dg.aeq(0);
            case 142:
                return $author$project$Spa$Generated$Pages$pages.Dh.aeq(0);
            case 143:
                return $author$project$Spa$Generated$Pages$pages.Di.aeq(0);
            case 144:
                return $author$project$Spa$Generated$Pages$pages.Dj.aeq(0);
            case 145:
                return $author$project$Spa$Generated$Pages$pages.Dk.aeq(0);
            case 146:
                return $author$project$Spa$Generated$Pages$pages.Dl.aeq(0);
            case 147:
                return $author$project$Spa$Generated$Pages$pages.Dm.aeq(0);
            case 148:
                return $author$project$Spa$Generated$Pages$pages.Dn.aeq(0);
            case 149:
                return $author$project$Spa$Generated$Pages$pages.Do.aeq(0);
            case 150:
                return $author$project$Spa$Generated$Pages$pages.Dp.aeq(0);
            case 151:
                return $author$project$Spa$Generated$Pages$pages.Dq.aeq(0);
            case 152:
                return $author$project$Spa$Generated$Pages$pages.Dr.aeq(0);
            case 153:
                return $author$project$Spa$Generated$Pages$pages.Dt.aeq(0);
            case 154:
                return $author$project$Spa$Generated$Pages$pages.Du.aeq(0);
            case 155:
                return $author$project$Spa$Generated$Pages$pages.Dv.aeq(0);
            case 156:
                return $author$project$Spa$Generated$Pages$pages.Dw.aeq(0);
            case 157:
                return $author$project$Spa$Generated$Pages$pages.Dy.aeq(0);
            case 158:
                return $author$project$Spa$Generated$Pages$pages.DB.aeq(0);
            case 159:
                return $author$project$Spa$Generated$Pages$pages.DU.aeq(0);
            case 160:
                return $author$project$Spa$Generated$Pages$pages.DV.aeq(0);
            case 161:
                return $author$project$Spa$Generated$Pages$pages.DX.aeq(0);
            case 162:
                return $author$project$Spa$Generated$Pages$pages.DY.aeq(0);
            case 163:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vy.aeq(params);
            case 164:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.xz.aeq(params);
            case 165:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.yx.aeq(params);
            case 166:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.yV.aeq(params);
            case 167:
                return $author$project$Spa$Generated$Pages$pages.t_.aeq(0);
            case 168:
                return $author$project$Spa$Generated$Pages$pages.t6.aeq(0);
            case 169:
                return $author$project$Spa$Generated$Pages$pages.ub.aeq(0);
            case 170:
                return $author$project$Spa$Generated$Pages$pages.uf.aeq(0);
            case 171:
                return $author$project$Spa$Generated$Pages$pages.um.aeq(0);
            case 172:
                return $author$project$Spa$Generated$Pages$pages.uk.aeq(0);
            case 173:
                return $author$project$Spa$Generated$Pages$pages.ut.aeq(0);
            case 174:
                return $author$project$Spa$Generated$Pages$pages.uy.aeq(0);
            case 175:
                return $author$project$Spa$Generated$Pages$pages.uY.aeq(0);
            case 176:
                return $author$project$Spa$Generated$Pages$pages.u$.aeq(0);
            case 177:
                return $author$project$Spa$Generated$Pages$pages.u1.aeq(0);
            case 178:
                return $author$project$Spa$Generated$Pages$pages.u7.aeq(0);
            case 179:
                return $author$project$Spa$Generated$Pages$pages.wp.aeq(0);
            case 180:
                return $author$project$Spa$Generated$Pages$pages.wr.aeq(0);
            case 181:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wI.aeq(params);
            case 182:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wP.aeq(params);
            case 183:
                return $author$project$Spa$Generated$Pages$pages.x0.aeq(0);
            case 184:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.yj.aeq(params);
            case 185:
                return $author$project$Spa$Generated$Pages$pages.y9.aeq(0);
            case 186:
                return $author$project$Spa$Generated$Pages$pages.ze.aeq(0);
            case 187:
                return $author$project$Spa$Generated$Pages$pages.zv.aeq(0);
            case 188:
                return $author$project$Spa$Generated$Pages$pages.zD.aeq(0);
            case 189:
                return $author$project$Spa$Generated$Pages$pages.zK.aeq(0);
            case 190:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.z3.aeq(params);
            case 191:
                return $author$project$Spa$Generated$Pages$pages.Am.aeq(0);
            case 192:
                return $author$project$Spa$Generated$Pages$pages.Ap.aeq(0);
            case 193:
                return $author$project$Spa$Generated$Pages$pages.Av.aeq(0);
            case 194:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AW.aeq(params);
            case 195:
                return $author$project$Spa$Generated$Pages$pages.BL.aeq(0);
            case 196:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.DC.aeq(params);
            case 197:
                return $author$project$Spa$Generated$Pages$pages.DW.aeq(0);
            case 198:
                return $author$project$Spa$Generated$Pages$pages.tV.aeq(0);
            case 199:
                return $author$project$Spa$Generated$Pages$pages.tW.aeq(0);
            case 200:
                return $author$project$Spa$Generated$Pages$pages.tX.aeq(0);
            case 201:
                return $author$project$Spa$Generated$Pages$pages.tY.aeq(0);
            case 202:
                return $author$project$Spa$Generated$Pages$pages.tZ.aeq(0);
            case 203:
                return $author$project$Spa$Generated$Pages$pages.t5.aeq(0);
            case 204:
                return $author$project$Spa$Generated$Pages$pages.t7.aeq(0);
            case 205:
                return $author$project$Spa$Generated$Pages$pages.ua.aeq(0);
            case 206:
                return $author$project$Spa$Generated$Pages$pages.ue.aeq(0);
            case 207:
                return $author$project$Spa$Generated$Pages$pages.uh.aeq(0);
            case 208:
                return $author$project$Spa$Generated$Pages$pages.uj.aeq(0);
            case 209:
                return $author$project$Spa$Generated$Pages$pages.un.aeq(0);
            case 210:
                return $author$project$Spa$Generated$Pages$pages.uo.aeq(0);
            case 211:
                return $author$project$Spa$Generated$Pages$pages.up.aeq(0);
            case 212:
                return $author$project$Spa$Generated$Pages$pages.uq.aeq(0);
            case 213:
                return $author$project$Spa$Generated$Pages$pages.us.aeq(0);
            case 214:
                return $author$project$Spa$Generated$Pages$pages.uv.aeq(0);
            case 215:
                return $author$project$Spa$Generated$Pages$pages.uw.aeq(0);
            case 216:
                return $author$project$Spa$Generated$Pages$pages.ux.aeq(0);
            case 217:
                return $author$project$Spa$Generated$Pages$pages.uI.aeq(0);
            case 218:
                return $author$project$Spa$Generated$Pages$pages.uJ.aeq(0);
            case 219:
                return $author$project$Spa$Generated$Pages$pages.uK.aeq(0);
            case 220:
                return $author$project$Spa$Generated$Pages$pages.uL.aeq(0);
            case 221:
                return $author$project$Spa$Generated$Pages$pages.uN.aeq(0);
            case 222:
                return $author$project$Spa$Generated$Pages$pages.uO.aeq(0);
            case 223:
                return $author$project$Spa$Generated$Pages$pages.uR.aeq(0);
            case 224:
                return $author$project$Spa$Generated$Pages$pages.uX.aeq(0);
            case 225:
                return $author$project$Spa$Generated$Pages$pages.u0.aeq(0);
            case 226:
                return $author$project$Spa$Generated$Pages$pages.u6.aeq(0);
            case 227:
                return $author$project$Spa$Generated$Pages$pages.vb.aeq(0);
            case 228:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vf.aeq(params);
            case 229:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vi.aeq(params);
            case 230:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vj.aeq(params);
            case 231:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vk.aeq(params);
            case 232:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vl.aeq(params);
            case 233:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vm.aeq(params);
            case 234:
                return $author$project$Spa$Generated$Pages$pages.wo.aeq(0);
            case 235:
                return $author$project$Spa$Generated$Pages$pages.wq.aeq(0);
            case 236:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wt.aeq(params);
            case 237:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wu.aeq(params);
            case 238:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wy.aeq(params);
            case 239:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wz.aeq(params);
            case 240:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wC.aeq(params);
            case 241:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wD.aeq(params);
            case 242:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wE.aeq(params);
            case 243:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wF.aeq(params);
            case 244:
                return $author$project$Spa$Generated$Pages$pages.y8.aeq(0);
            case 245:
                return $author$project$Spa$Generated$Pages$pages.zc.aeq(0);
            case 246:
                return $author$project$Spa$Generated$Pages$pages.zu.aeq(0);
            case 247:
                return $author$project$Spa$Generated$Pages$pages.zI.aeq(0);
            case 248:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.z4.aeq(params);
            case 249:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.z5.aeq(params);
            case 250:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.z6.aeq(params);
            case 251:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.z7.aeq(params);
            case 252:
                return $author$project$Spa$Generated$Pages$pages.Al.aeq(0);
            case 253:
                return $author$project$Spa$Generated$Pages$pages.Ar.aeq(0);
            case 254:
                return $author$project$Spa$Generated$Pages$pages.As.aeq(0);
            case 255:
                return $author$project$Spa$Generated$Pages$pages.At.aeq(0);
            case 256:
                return $author$project$Spa$Generated$Pages$pages.Au.aeq(0);
            case 257:
                return $author$project$Spa$Generated$Pages$pages.Ax.aeq(0);
            case 258:
                return $author$project$Spa$Generated$Pages$pages.Ay.aeq(0);
            case 259:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AK.aeq(params);
            case 260:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AL.aeq(params);
            case 261:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AM.aeq(params);
            case 262:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AN.aeq(params);
            case 263:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AO.aeq(params);
            case 264:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AS.aeq(params);
            case 265:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AX.aeq(params);
            case 266:
                return $author$project$Spa$Generated$Pages$pages.Bl.aeq(0);
            case 267:
                return $author$project$Spa$Generated$Pages$pages.BO.aeq(0);
            case 268:
                return $author$project$Spa$Generated$Pages$pages.BQ.aeq(0);
            case 269:
                return $author$project$Spa$Generated$Pages$pages.BS.aeq(0);
            case 270:
                return $author$project$Spa$Generated$Pages$pages.BV.aeq(0);
            case 271:
                return $author$project$Spa$Generated$Pages$pages.B0.aeq(0);
            case 272:
                return $author$project$Spa$Generated$Pages$pages.B2.aeq(0);
            case 273:
                return $author$project$Spa$Generated$Pages$pages.B4.aeq(0);
            case 274:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.t4.aeq(params);
            case 275:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.t9.aeq(params);
            case 276:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.ud.aeq(params);
            case 277:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.ul.aeq(params);
            case 278:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.ui.aeq(params);
            case 279:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.ur.aeq(params);
            case 280:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.uB.aeq(params);
            case 281:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.uU.aeq(params);
            case 282:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.u5.aeq(params);
            case 283:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.x$.aeq(params);
            case 284:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.zt.aeq(params);
            case 285:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.zB.aeq(params);
            case 286:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.zG.aeq(params);
            case 287:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.zJ.aeq(params);
            case 288:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.BK.aeq(params);
            case 289:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.BR.aeq(params);
            case 290:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vh.aeq(params);
            case 291:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wn.aeq(params);
            case 292:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wx.aeq(params);
            case 293:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wB.aeq(params);
            case 294:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wJ.aeq(params);
            case 295:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.zd.aeq(params);
            case 296:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AF.aeq(params);
            case 297:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AG.aeq(params);
            case 298:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AJ.aeq(params);
            case 299:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AR.aeq(params);
            case 300:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AU.aeq(params);
            case 301:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AV.aeq(params);
            case 302:
                return $author$project$Spa$Generated$Pages$pages.uM.aeq(0);
            case 303:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wj.aeq(params);
            case 304:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wk.aeq(params);
            case 305:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wv.aeq(params);
            case 306:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wH.aeq(params);
            case 307:
                return $author$project$Spa$Generated$Pages$pages.yR.aeq(0);
            case 308:
                return $author$project$Spa$Generated$Pages$pages.yS.aeq(0);
            case 309:
                return $author$project$Spa$Generated$Pages$pages.yU.aeq(0);
            case 310:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.yW.aeq(params);
            case 311:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.yX.aeq(params);
            case 312:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.yY.aeq(params);
            case 313:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.zH.aeq(params);
            case 314:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AQ.aeq(params);
            case 315:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.Bk.aeq(params);
            case 316:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.t0.aeq(params);
            case 317:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.vg.aeq(params);
            case 318:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wA.aeq(params);
            case 319:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wG.aeq(params);
            case 320:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.zC.aeq(params);
            case 321:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AT.aeq(params);
            case 322:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wi.aeq(params);
            case 323:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wm.aeq(params);
            case 324:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wK.aeq(params);
            case 325:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AH.aeq(params);
            case 326:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AI.aeq(params);
            case 327:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.AP.aeq(params);
            case 328:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.uV.aeq(params);
            case 329:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wg.aeq(params);
            case 330:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wh.aeq(params);
            case 331:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wL.aeq(params);
            case 332:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.uW.aeq(params);
            case 333:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wl.aeq(params);
            case 334:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.wf.aeq(params);
            default:
                var params = route.a;
                return $author$project$Spa$Generated$Pages$pages.ww.aeq(params);
        }
    };
    var $author$project$Spa$Layout$AdminModel = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Spa$Layout$AdminMsg = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Spa$Layout$AffiliatesAffiliateModel = F2(function(a, b) {
        return {
            $: 7,
            a: a,
            b: b
        };
    });
    var $author$project$Spa$Layout$AffiliatesAffiliateMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Spa$Layout$AffiliatesModel = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Spa$Layout$AffiliatesMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Spa$Layout$ApplicationModel = {
        $: 1
    };
    var $author$project$Spa$Layout$BlankModel = {
        $: 15
    };
    var $author$project$Spa$Layout$ClinicalModel = {
        $: 16
    };
    var $author$project$Spa$Layout$CommissionsBrokerAccountModel = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Spa$Layout$CommissionsBrokerAccountMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Spa$Layout$CommissionsModel = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Spa$Layout$CommissionsMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Spa$Layout$CompanyModel = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Spa$Layout$CompanyMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Spa$Layout$MarketplaceManageModel = F2(function(a, b) {
        return {
            $: 12,
            a: a,
            b: b
        };
    });
    var $author$project$Spa$Layout$MarketplaceManageMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Spa$Layout$OnboardModel = {
        $: 18
    };
    var $author$project$Spa$Layout$PartnerBillingModel = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Spa$Layout$PartnerBillingMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Spa$Layout$PartnerPracticesModel = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Spa$Layout$PartnerPracticesMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Spa$Layout$PartnerProductModel = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Spa$Layout$PartnerProductMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Spa$Layout$PartnerWebhooksModel = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Spa$Layout$PartnerWebhooksMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Spa$Layout$PatientAndSidebarModel = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Spa$Layout$PatientChartModel = F2(function(a, b) {
        return {
            $: 17,
            a: a,
            b: b
        };
    });
    var $author$project$Spa$Layout$PatientMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Spa$Layout$PatientsSidebarModel = {
        $: 2
    };
    var $author$project$Spa$Layout$PracticeSetupModel = {
        $: 20
    };
    var $author$project$Spa$Layout$StyleGuideModel = {
        $: 0
    };
    var $author$project$Spa$Layout$UserModel = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Spa$Layout$UserMsg = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Layouts$Admin$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$Admin$init = function(_v0) {
        var _v1 = A2($author$project$Ui$Nav$init, 'admin-nav', $elm$core$Basics$identity);
        var nav = _v1.a;
        var navCmd = _v1.b;
        return _Utils_Tuple2({
            nb: nav
        }, navCmd);
    };
    var $author$project$Layouts$Affiliates$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$Affiliates$init = A2($elm$core$Tuple$mapFirst, function(nav) {
        return {
            nb: nav
        };
    }, A2($author$project$Ui$Nav$init, 'affiliates-nav', $elm$core$Basics$identity));
    var $author$project$Layouts$Affiliates$Affiliate$GotAffiliate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Layouts$Affiliates$Affiliate$NavMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Layouts$Affiliates$Affiliate$init = F2(function(_v0, affiliateId) {
        var apiClient = _v0.Ej;
        var _v1 = A2($author$project$Ui$Nav$init, 'affiliate-nav', $author$project$Layouts$Affiliates$Affiliate$NavMsg);
        var nav = _v1.a;
        var navCmd = _v1.b;
        return _Utils_Tuple2({
            Eb: $author$project$Api$Data$Loading,
            pr: affiliateId,
            nb: nav
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$Affiliate$retrieve, apiClient, affiliateId, $author$project$Layouts$Affiliates$Affiliate$GotAffiliate),
            navCmd
        ])));
    });
    var $author$project$Layouts$Commissions$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$Commissions$init = A2($elm$core$Tuple$mapFirst, function(nav) {
        return {
            nb: nav
        };
    }, A2($author$project$Ui$Nav$init, 'commissions-nav', $elm$core$Basics$identity));
    var $author$project$Layouts$Commissions$BrokerAccount$GotBrokerAccount = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Layouts$Commissions$BrokerAccount$NavMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Layouts$Commissions$BrokerAccount$init = F2(function(_v0, brokerAccountId) {
        var apiClient = _v0.Ej;
        var _v1 = A2($author$project$Ui$Nav$init, 'broker-account-nav', $author$project$Layouts$Commissions$BrokerAccount$NavMsg);
        var nav = _v1.a;
        var navCmd = _v1.b;
        return _Utils_Tuple2({
            vR: $author$project$Api$Data$Loading,
            bS: brokerAccountId,
            nb: nav
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A3($author$project$Api$Provider$BrokerAccount$retrieve, apiClient, brokerAccountId, $author$project$Layouts$Commissions$BrokerAccount$GotBrokerAccount),
            navCmd
        ])));
    });
    var $author$project$Layouts$Company$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$Company$init = A2($elm$core$Tuple$mapFirst, function(nav) {
        return {
            nb: nav
        };
    }, A2($author$project$Ui$Nav$init, 'company-nav', $elm$core$Basics$identity));
    var $author$project$Layouts$Marketplace$Manage$GotIntegration = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Layouts$Marketplace$Manage$NavMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Layouts$Marketplace$Manage$init = F2(function(apiClient, slug) {
        var _v0 = A2($author$project$Ui$Nav$init, 'marketplace-manage-nav', $author$project$Layouts$Marketplace$Manage$NavMsg);
        var nav = _v0.a;
        var navCmd = _v0.b;
        return _Utils_Tuple2({
            Rn: $author$project$Api$Data$Loading,
            nb: nav,
            _A: slug
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            navCmd,
            A3($author$project$Api$Provider$Integration$retrieve, apiClient, slug, $author$project$Layouts$Marketplace$Manage$GotIntegration)
        ])));
    });
    var $author$project$Layouts$Partner$Billing$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$Partner$Billing$init = function() {
        var _v0 = A2($author$project$Ui$Nav$init, 'partner-billing-nav', $elm$core$Basics$identity);
        var nav = _v0.a;
        var navCmd = _v0.b;
        return _Utils_Tuple2({
            nb: nav
        }, navCmd);
    }();
    var $author$project$Layouts$Partner$Practices$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$Partner$Practices$init = function() {
        var _v0 = A2($author$project$Ui$Nav$init, 'partner-practices-nav', $elm$core$Basics$identity);
        var nav = _v0.a;
        var navCmd = _v0.b;
        return _Utils_Tuple2({
            nb: nav
        }, navCmd);
    }();
    var $author$project$Layouts$Partner$Product$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$Partner$Product$init = function(partner) {
        var _v0 = A2($author$project$Ui$Nav$init, 'partner-product-nav', $elm$core$Basics$identity);
        var nav = _v0.a;
        var navCmd = _v0.b;
        return _Utils_Tuple2({
            nb: nav,
            VW: partner
        }, navCmd);
    };
    var $author$project$Layouts$Partner$Webhooks$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$Partner$Webhooks$init = function() {
        var _v0 = A2($author$project$Ui$Nav$init, 'partner-webhooks-nav', $elm$core$Basics$identity);
        var nav = _v0.a;
        var navCmd = _v0.b;
        return _Utils_Tuple2({
            nb: nav
        }, navCmd);
    }();
    var $author$project$Layouts$Patient$NavMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Layouts$Patient$init = F2(function(_v0, patientId) {
        var session = _v0.Z$;
        var hinterViewOff = _v0.aeb;
        var currentPatient = _v0.MO;
        var _v1 = A2($author$project$Ui$Nav$init, 'patient-nav', $author$project$Layouts$Patient$NavMsg);
        var nav = _v1.a;
        var navCmd = _v1.b;
        return _Utils_Tuple2({
            hw: $author$project$Api$Data$NotAsked,
            aeb: hinterViewOff,
            nb: nav,
            jh: $author$project$Api$Data$NotAsked,
            V7: currentPatient,
            V8: patientId,
            Z$: session
        }, navCmd);
    });
    var $author$project$Layouts$PatientChart$init = F2(function(_v0, patientId) {
        var currentPatient = _v0.MO;
        return _Utils_Tuple2({
            V7: currentPatient,
            V8: patientId
        }, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Layouts$User$NavMsg = $elm$core$Basics$identity;
    var $author$project$Layouts$User$init = A2($elm$core$Tuple$mapFirst, function(nav) {
        return {
            nb: nav
        };
    }, A2($author$project$Ui$Nav$init, 'user-nav', $elm$core$Basics$identity));
    var $author$project$Spa$Layout$Admin = {
        $: 14
    };
    var $author$project$Spa$Layout$Affiliates = {
        $: 6
    };
    var $author$project$Spa$Layout$AffiliatesAffiliate = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Spa$Layout$Application = {
        $: 1
    };
    var $author$project$Spa$Layout$Clinical = {
        $: 18
    };
    var $author$project$Spa$Layout$Commissions = {
        $: 4
    };
    var $author$project$Spa$Layout$CommissionsBrokerAccount = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Spa$Layout$Company = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Spa$Layout$MarketplaceManage = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Spa$Layout$Onboard = {
        $: 15
    };
    var $author$project$Spa$Layout$PartnerBilling = {
        $: 8
    };
    var $author$project$Spa$Layout$PartnerPractices = {
        $: 9
    };
    var $author$project$Spa$Layout$PartnerProduct = {
        $: 10
    };
    var $author$project$Spa$Layout$PartnerWebhooks = {
        $: 11
    };
    var $author$project$Spa$Layout$PatientAndSidebar = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Spa$Layout$PatientChart = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Spa$Layout$PatientsSidebar = {
        $: 2
    };
    var $author$project$Spa$Layout$PracticeSetup = {
        $: 16
    };
    var $author$project$Spa$Layout$StyleGuide = {
        $: 0
    };
    var $author$project$Spa$Layout$User = {
        $: 17
    };
    var $author$project$Spa$Layout$routeToLayout = function(url) {
        var idRegex = $elm$regex$Regex$fromString('[a-z]+-[a-zA-Z0-9]+');
        var idMatch = function(possibleId) {
            return A2($elm$core$Maybe$andThen, function(regex) {
                return A2($elm$regex$Regex$contains, regex, possibleId) ? $elm$core$Maybe$Just(possibleId) : $elm$core$Maybe$Nothing;
            }, idRegex);
        };
        return A2($elm$core$Maybe$withDefault, $author$project$Spa$Layout$Application, function() {
            var _v0 = A2($elm$core$List$filter, A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not), A2($elm$core$String$split, '/', url.V6));
            _v0$9: while(true){
                _v0$25: while(true){
                    _v0$37: while(true){
                        if (_v0.b) switch(_v0.a){
                            case 'style_guide':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$StyleGuide);
                            case 'onboard':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Onboard);
                            case 'practice_setup':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$PracticeSetup);
                            case 'patients':
                                if (!_v0.b.b) return $elm$core$Maybe$Just($author$project$Spa$Layout$Application);
                                else if (!_v0.b.b.b) {
                                    if (_v0.b.a === 'create') {
                                        var _v1 = _v0.b;
                                        return $elm$core$Maybe$Just($author$project$Spa$Layout$PatientsSidebar);
                                    } else break _v0$9;
                                } else {
                                    if (!_v0.b.b.b.b) switch(_v0.b.b.a){
                                        case 'chart':
                                            var _v2 = _v0.b;
                                            var patientId = _v2.a;
                                            var _v3 = _v2.b;
                                            return A2($elm$core$Maybe$map, $author$project$Spa$Layout$PatientChart, idMatch(patientId));
                                        case 'growth_chart':
                                            var _v4 = _v0.b;
                                            var patientId = _v4.a;
                                            var _v5 = _v4.b;
                                            return A2($elm$core$Maybe$map, $author$project$Spa$Layout$PatientChart, idMatch(patientId));
                                        case 'lab_trends':
                                            var _v6 = _v0.b;
                                            var patientId = _v6.a;
                                            var _v7 = _v6.b;
                                            return A2($elm$core$Maybe$map, $author$project$Spa$Layout$PatientChart, idMatch(patientId));
                                        case 'vitals_trends':
                                            var _v8 = _v0.b;
                                            var patientId = _v8.a;
                                            var _v9 = _v8.b;
                                            return A2($elm$core$Maybe$map, $author$project$Spa$Layout$PatientChart, idMatch(patientId));
                                        default:
                                            break _v0$9;
                                    }
                                    else break _v0$9;
                                }
                            case 'calendar':
                                if (!_v0.b.b) return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                                else break _v0$37;
                            case 'home':
                                if (!_v0.b.b) return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                                else break _v0$37;
                            case 'contacts':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                            case 'files':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                            case 'forms':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                            case 'google_callback':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                            case 'new_settings':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                            case 'inventory':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                            case 'messages':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                            case 'tasks':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Clinical);
                            case 'companies':
                                if (_v0.b.b) {
                                    var _v11 = _v0.b;
                                    var companyId = _v11.a;
                                    return A2($elm$core$Maybe$map, $author$project$Spa$Layout$Company, idMatch(companyId));
                                } else break _v0$37;
                            case 'affiliate_bills':
                                if (!_v0.b.b) return $elm$core$Maybe$Just($author$project$Spa$Layout$Affiliates);
                                else break _v0$37;
                            case 'affiliates':
                                if (!_v0.b.b) return $elm$core$Maybe$Just($author$project$Spa$Layout$Affiliates);
                                else {
                                    if (_v0.b.b.b && !_v0.b.b.b.b) switch(_v0.b.b.a){
                                        case 'link_providers':
                                            var _v12 = _v0.b;
                                            var _v13 = _v12.b;
                                            return $elm$core$Maybe$Nothing;
                                        case 'activate_new':
                                            var _v14 = _v0.b;
                                            var _v15 = _v14.b;
                                            return $elm$core$Maybe$Nothing;
                                        default:
                                            break _v0$25;
                                    }
                                    else break _v0$25;
                                }
                            case 'partner':
                                if (_v0.b.b) switch(_v0.b.a){
                                    case 'billing':
                                        var _v17 = _v0.b;
                                        return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerBilling);
                                    case 'practices':
                                        var _v18 = _v0.b;
                                        return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerPractices);
                                    case 'engagements':
                                        var _v19 = _v0.b;
                                        return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerPractices);
                                    case 'webhooks':
                                        var _v20 = _v0.b;
                                        return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerWebhooks);
                                    case 'product':
                                        var _v21 = _v0.b;
                                        return $elm$core$Maybe$Just($author$project$Spa$Layout$PartnerProduct);
                                    default:
                                        break _v0$37;
                                }
                                else break _v0$37;
                            case 'marketplace':
                                if (_v0.b.b && _v0.b.b.b && _v0.b.b.a === 'manage') {
                                    var _v22 = _v0.b;
                                    var slug = _v22.a;
                                    var _v23 = _v22.b;
                                    return $elm$core$Maybe$Just($author$project$Spa$Layout$MarketplaceManage(slug));
                                } else break _v0$37;
                            case 'commissions':
                                if (_v0.b.b && _v0.b.a === 'broker_accounts' && _v0.b.b.b) {
                                    var _v24 = _v0.b;
                                    var _v25 = _v24.b;
                                    var brokerAccountId = _v25.a;
                                    return A2($elm$core$Maybe$map, $author$project$Spa$Layout$CommissionsBrokerAccount, idMatch(brokerAccountId));
                                } else return $elm$core$Maybe$Just($author$project$Spa$Layout$Commissions);
                            case 'admin':
                                return $elm$core$Maybe$Just($author$project$Spa$Layout$Admin);
                            case 'user':
                                if (_v0.b.b && _v0.b.a === 'organizations') {
                                    var _v26 = _v0.b;
                                    return $elm$core$Maybe$Nothing;
                                } else return $elm$core$Maybe$Just($author$project$Spa$Layout$User);
                            default:
                                break _v0$37;
                        }
                        else break _v0$37;
                    }
                    return $elm$core$Maybe$Nothing;
                }
                var _v16 = _v0.b;
                var affiliateId = _v16.a;
                return A2($elm$core$Maybe$map, $author$project$Spa$Layout$AffiliatesAffiliate, idMatch(affiliateId));
            }
            var _v10 = _v0.b;
            var patientId = _v10.a;
            return A2($elm$core$Maybe$map, $author$project$Spa$Layout$PatientAndSidebar, idMatch(patientId));
        }());
    };
    var $author$project$Spa$Layout$init = function(shared) {
        var route = $author$project$Utils$Route$fromUrl(shared.aaT);
        if (_Utils_eq(route, $author$project$Spa$Generated$Route$Blank)) return _Utils_Tuple2($author$project$Spa$Layout$BlankModel, $elm$core$Platform$Cmd$none);
        else {
            var _v0 = $author$project$Spa$Layout$routeToLayout(shared.aaT);
            switch(_v0.$){
                case 13:
                    var companyId = _v0.a;
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CompanyModel(companyId), $author$project$Layouts$Company$init));
                case 5:
                    var brokerAccountId = _v0.a;
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CommissionsBrokerAccountModel(brokerAccountId), A2($author$project$Layouts$Commissions$BrokerAccount$init, shared, brokerAccountId)));
                case 4:
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CommissionsModel, $author$project$Layouts$Commissions$init));
                case 7:
                    var affiliateId = _v0.a;
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AffiliatesAffiliateModel(affiliateId), A2($author$project$Layouts$Affiliates$Affiliate$init, shared, affiliateId)));
                case 6:
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AffiliatesModel, $author$project$Layouts$Affiliates$init));
                case 8:
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerBillingModel, $author$project$Layouts$Partner$Billing$init));
                case 9:
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerPracticesModel, $author$project$Layouts$Partner$Practices$init));
                case 10:
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerProductModel, $author$project$Layouts$Partner$Product$init(shared.VW)));
                case 11:
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerWebhooksMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerWebhooksModel, $author$project$Layouts$Partner$Webhooks$init));
                case 12:
                    var slug = _v0.a;
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$MarketplaceManageModel(slug), A2($author$project$Layouts$Marketplace$Manage$init, shared.Ej, slug)));
                case 14:
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AdminModel, $author$project$Layouts$Admin$init(shared)));
                case 3:
                    var id = _v0.a;
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PatientAndSidebarModel(id), A2($author$project$Layouts$Patient$init, shared, id)));
                case 17:
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$UserModel, $author$project$Layouts$User$init));
                case 1:
                    return _Utils_Tuple2($author$project$Spa$Layout$ApplicationModel, $elm$core$Platform$Cmd$none);
                case 2:
                    return _Utils_Tuple2($author$project$Spa$Layout$PatientsSidebarModel, $elm$core$Platform$Cmd$none);
                case 15:
                    return _Utils_Tuple2($author$project$Spa$Layout$OnboardModel, $elm$core$Platform$Cmd$none);
                case 16:
                    return _Utils_Tuple2($author$project$Spa$Layout$PracticeSetupModel, $elm$core$Platform$Cmd$none);
                case 0:
                    return _Utils_Tuple2($author$project$Spa$Layout$StyleGuideModel, $elm$core$Platform$Cmd$none);
                case 18:
                    return _Utils_Tuple2($author$project$Spa$Layout$ClinicalModel, $elm$core$Platform$Cmd$none);
                default:
                    var patientId = _v0.a;
                    return A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PatientChartModel(patientId), A2($author$project$Layouts$PatientChart$init, shared, patientId));
            }
        }
    };
    var $author$project$Ports$Sentry$captureErrorMessage = _Platform_outgoingPort('captureErrorMessage', $elm$json$Json$Encode$string);
    var $author$project$Main$defaultUrl = A6($elm$url$Url$Url, 0, 'localhost', $elm$core$Maybe$Nothing, '', $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
    var $author$project$Main$locationHrefToUrl = function(locationHref) {
        var _v0 = $elm$url$Url$fromString(locationHref);
        if (!_v0.$) {
            var url = _v0.a;
            return _Utils_Tuple2(url, $elm$core$Platform$Cmd$none);
        } else return _Utils_Tuple2($author$project$Main$defaultUrl, $author$project$Ports$Sentry$captureErrorMessage('Url.fromString Failed: ' + locationHref));
    };
    var $author$project$Shared$BackupAuthOrganizationSwitched = F2(function(a, b) {
        return {
            $: 19,
            a: a,
            b: b
        };
    });
    var $author$project$OutMsg$GoToClinicalAction = {
        $: 4
    };
    var $author$project$Shared$GotCompany = F2(function(a, b) {
        return {
            $: 3,
            a: a,
            b: b
        };
    });
    var $author$project$Shared$GotPatient = F2(function(a, b) {
        return {
            $: 24,
            a: a,
            b: b
        };
    });
    var $author$project$Shared$GotRoleSwitched = function(a) {
        return {
            $: 30,
            a: a
        };
    };
    var $author$project$Shared$PatientsListMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$PatientsList$RefreshPatients = {
        $: 14
    };
    var $author$project$Shared$ToastMsg = function(a) {
        return {
            $: 16,
            a: a
        };
    };
    var $author$project$Ports$Sentry$captureDebugMessage = _Platform_outgoingPort('captureDebugMessage', $elm$json$Json$Encode$string);
    var $author$project$Shared$decodeErrorToMsg = function(error) {
        return $author$project$Ports$Sentry$captureErrorMessage('Decoder Failed: ' + error);
    };
    var $author$project$Shared$NavbarMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Api$WhitelabelSetting$empty = {
        Ey: '',
        Ez: true,
        GP: $elm$core$Maybe$Nothing,
        GY: '',
        GZ: '',
        G_: '',
        G$: 'App Logo',
        G0: $elm$core$Maybe$Nothing
    };
    var $author$project$Api$Practice$Employer = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Navbar$CompanyNav = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Navbar$CompanyNavbarMsg = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Navbar$Model = $elm$core$Basics$identity;
    var $author$project$Navbar$GotHeaderEndElement = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
    var $author$project$Navbar$getHeaderEnd = A2($elm$core$Task$attempt, $author$project$Navbar$GotHeaderEndElement, $elm$browser$Browser$Dom$getElement('topnav-end'));
    var $author$project$Navbars$Company$Model = $elm$core$Basics$identity;
    var $author$project$Navbars$Company$ProfileMenuMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Api$Platform$User$Shared$canSwitchOrganizations = function(_v0) {
        var record = _v0;
        return record.KV;
    };
    var $author$project$Navbars$Company$initSessionConfiguration = function(session) {
        var showSideNav_ = function(_v0) {
            return true;
        };
        var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
        return {
            KV: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
            yu: isViewingAsHinter,
            afX: A2($elm$core$Maybe$map, function(org) {
                return $author$project$Api$Platform$Organization$Shared$type_(org);
            }, $author$project$Api$Platform$Session$One$organization(session)),
            VG: A2($elm$core$Maybe$andThen, $author$project$Api$Common$RequestDetail$Shared$osName, $author$project$Api$Platform$Session$One$requestDetail(session)),
            _k: showSideNav_,
            aib: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
        };
    };
    var $author$project$Navbars$Company$Account = 6;
    var $author$project$Navbars$Company$AccountAndPricing = 5;
    var $author$project$Navbars$Company$EmployeeUploads = 3;
    var $author$project$Navbars$Company$Employees = 0;
    var $author$project$Navbars$Company$Invoices = 1;
    var $author$project$Navbars$Company$OnlineSignup = 4;
    var $author$project$Navbars$Company$PaymentMethods = 2;
    var $author$project$Navbars$Company$navItemFromUrl = function(url) {
        var pathList = A2($elm$core$List$drop, 1, A2($elm$core$String$split, '/', url.V6));
        _v0$2: while(true){
            if (pathList.b) switch(pathList.a){
                case 'companies':
                    var tail = pathList.b;
                    var companySubpath = A2($elm$core$List$drop, 1, tail);
                    if (companySubpath.b) switch(companySubpath.a){
                        case 'employees':
                            return 0;
                        case 'invoices':
                            return 1;
                        case 'payment_sources':
                            return 2;
                        case 'uploads':
                            return 3;
                        case 'signup':
                            return 4;
                        default:
                            return 0;
                    }
                    else return 5;
                case 'user':
                    return 6;
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return 0;
    };
    var $author$project$Navbars$Company$None = 1;
    var $author$project$Navbars$Company$ProfileNav = 0;
    var $author$project$Navbars$Company$openSubNavFromSelectedNav = function(selectedNav) {
        if (selectedNav === 6) return 0;
        else return 1;
    };
    var $author$project$Navbars$Company$init = function(_v0) {
        var url = _v0.aaT;
        var session = _v0.Z$;
        var practice = _v0.W1;
        var company = _v0.acy;
        var whitelabelSetting = _v0.abq;
        var selectedNav = $author$project$Navbars$Company$navItemFromUrl(url);
        return _Utils_Tuple2({
            acy: company,
            c5: $author$project$Navbars$Company$openSubNavFromSelectedNav(selectedNav),
            W1: practice,
            et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg),
            eI: selectedNav,
            Z$: session,
            Cs: $author$project$Navbars$Company$initSessionConfiguration(session),
            oz: false,
            abq: whitelabelSetting
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Navbar$andInitEmployerNavbar = F4(function(practice, whitelabelSetting, company, _v0) {
        var model = _v0;
        return function(_v1) {
            var nav = _v1.a;
            var cmd = _v1.b;
            return _Utils_Tuple2(_Utils_update(model, {
                ad: nav
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmd,
                $author$project$Navbar$getHeaderEnd
            ])));
        }(A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Navbar$CompanyNavbarMsg), A2($elm$core$Tuple$mapFirst, $author$project$Navbar$CompanyNav, $author$project$Navbars$Company$init({
            acy: company,
            W1: practice,
            Z$: model.Z$,
            aaT: model.aaT,
            abq: whitelabelSetting
        }))));
    });
    var $author$project$Navbar$NoNav = {
        $: 0
    };
    var $author$project$Navbar$init = F3(function(session, practice, flags) {
        return {
            adm: flags.adm,
            aeb: flags.aeb,
            qW: flags.qW,
            ad: $author$project$Navbar$NoNav,
            afY: flags.afY,
            W1: practice,
            Z$: session,
            _l: false,
            aaT: flags.aaT
        };
    });
    var $author$project$Navbar$initForEmployer = F5(function(session, whitelabelSetting, practice, company, flags) {
        return A4($author$project$Navbar$andInitEmployerNavbar, practice, whitelabelSetting, company, A3($author$project$Navbar$init, session, $elm$core$Maybe$Just($author$project$Api$Practice$Employer(practice)), flags));
    });
    var $author$project$Navbar$PartnerNav = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Navbar$PartnerNavbarMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Navbars$Partner$Model = $elm$core$Basics$identity;
    var $author$project$Navbars$Partner$ProfileMenuMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Navbars$Partner$initSessionConfiguration = function(session) {
        var showSideNav_ = function(_v0) {
            return true;
        };
        var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
        return {
            KV: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
            yu: isViewingAsHinter,
            afX: A2($elm$core$Maybe$map, function(org) {
                return $author$project$Api$Platform$Organization$Shared$type_(org);
            }, $author$project$Api$Platform$Session$One$organization(session)),
            VG: A2($elm$core$Maybe$andThen, $author$project$Api$Common$RequestDetail$Shared$osName, $author$project$Api$Platform$Session$One$requestDetail(session)),
            _k: showSideNav_,
            aib: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
        };
    };
    var $author$project$Navbars$Partner$Account = 8;
    var $author$project$Navbars$Partner$Marketplace = 9;
    var $author$project$Navbars$Partner$PartnerApiKeys = 3;
    var $author$project$Navbars$Partner$PartnerBilling = 2;
    var $author$project$Navbars$Partner$PartnerHinter = 1;
    var $author$project$Navbars$Partner$PartnerPractices = 5;
    var $author$project$Navbars$Partner$PartnerProducts = 7;
    var $author$project$Navbars$Partner$PartnerSandboxes = 6;
    var $author$project$Navbars$Partner$PartnerTeam = 0;
    var $author$project$Navbars$Partner$PartnerWebhooks = 4;
    var $author$project$Navbars$Partner$navItemFromUrl = function(url) {
        var pathList = A2($elm$core$List$drop, 1, A2($elm$core$String$split, '/', url.V6));
        _v0$3: while(true){
            if (pathList.b) switch(pathList.a){
                case 'partner':
                    var partnerSubpath = pathList.b;
                    _v1$10: while(true){
                        if (partnerSubpath.b) switch(partnerSubpath.a){
                            case 'team':
                                return 0;
                            case 'api_keys':
                                return 3;
                            case 'webhooks':
                                return 4;
                            case 'practices':
                                return 5;
                            case 'engagements':
                                return 5;
                            case 'hinter':
                                return 1;
                            case 'billing':
                                return 2;
                            case 'dashboard':
                                return 7;
                            case 'product':
                                return 7;
                            case 'sandboxes':
                                return 6;
                            default:
                                break _v1$10;
                        }
                        else break _v1$10;
                    }
                    return 0;
                case 'user':
                    return 8;
                case 'marketplace':
                    return 9;
                default:
                    break _v0$3;
            }
            else break _v0$3;
        }
        return 0;
    };
    var $author$project$Navbars$Partner$None = 1;
    var $author$project$Navbars$Partner$ProfileNav = 0;
    var $author$project$Navbars$Partner$openSubNavFromSelectedNav = function(selectedNav) {
        if (selectedNav === 8) return 0;
        else return 1;
    };
    var $author$project$Navbars$Partner$init = function(_v0) {
        var url = _v0.aaT;
        var session = _v0.Z$;
        var partner = _v0.VW;
        var selectedNav = $author$project$Navbars$Partner$navItemFromUrl(url);
        return _Utils_Tuple2({
            c5: $author$project$Navbars$Partner$openSubNavFromSelectedNav(selectedNav),
            VW: partner,
            et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg),
            eI: selectedNav,
            Z$: session,
            Cs: $author$project$Navbars$Partner$initSessionConfiguration(session),
            oz: false
        }, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Navbar$andInitPartnerNavbar = F2(function(partner, _v0) {
        var model = _v0;
        return function(_v1) {
            var nav = _v1.a;
            var cmd = _v1.b;
            return _Utils_Tuple2(_Utils_update(model, {
                ad: nav
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmd,
                $author$project$Navbar$getHeaderEnd
            ])));
        }(A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Navbar$PartnerNavbarMsg), A2($elm$core$Tuple$mapFirst, $author$project$Navbar$PartnerNav, $author$project$Navbars$Partner$init({
            VW: partner,
            Z$: model.Z$,
            aaT: model.aaT
        }))));
    });
    var $author$project$Navbar$initForPartner = F3(function(session, partner, flags) {
        return A2($author$project$Navbar$andInitPartnerNavbar, partner, A3($author$project$Navbar$init, session, $elm$core$Maybe$Nothing, flags));
    });
    var $author$project$Navbar$PracticeNav = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Navbar$PracticeNavbarMsg = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Navbars$Practice$AdminMenuMsg = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Navbars$Practice$GotCurrentDate = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Navbars$Practice$GotEmbeddedReports = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Navbars$Practice$GotPartnerApps = function(a) {
        return {
            $: 18,
            a: a
        };
    };
    var $author$project$Navbars$Practice$GotReports = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Navbars$Practice$Model = $elm$core$Basics$identity;
    var $author$project$Navbars$Practice$ProfileMenuMsg = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Navbars$Practice$ReportMenuMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Navbars$Practice$SwitchProductDropDownMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Api$Feature$ManageDataExports = 18;
    var $author$project$Api$Feature$NavReorganization = 26;
    var $author$project$Api$Provider$Practice$One$customLogoUrl = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.MX;
    });
    var $author$project$Navbars$Practice$buildPracticeConfig = function(practice) {
        return {
            Km: A2($author$project$Api$Provider$Practice$One$featureEnabled, 15, practice) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 16, practice),
            LE: $author$project$Api$Provider$Practice$One$commissionsEnabled(practice),
            MW: $author$project$Api$Provider$Practice$One$customLogoUrl(practice),
            M1: A2($author$project$Api$Provider$Practice$One$featureEnabled, 18, practice),
            FX: A2($author$project$Utils$FeatureGate$gateAvailable, 2, $author$project$Api$Practice$Provider(practice)),
            Sd: $author$project$Api$Provider$Practice$One$isNetwork(practice),
            Gh: A2($author$project$Utils$FeatureGate$gateAvailable, 9, $author$project$Api$Practice$Provider(practice)),
            UH: A2($author$project$Api$Provider$Practice$One$featureEnabled, 26, practice),
            Az: A2($author$project$Utils$FeatureGate$gateAvailable, 4, $author$project$Api$Practice$Provider(practice)),
            $C: A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice),
            oY: A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice)
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$Closed = {
        $: 0
    };
    var $author$project$Components$HinterPracticeSettingsModal$init = $author$project$Components$HinterPracticeSettingsModal$Closed;
    var $author$project$Api$Platform$Organization$Shared$accountType = function(_v0) {
        var record = _v0.b;
        return record.In;
    };
    var $author$project$Api$Platform$Session$One$accountType = function(_v0) {
        var record = _v0;
        return A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$accountType, record.VA);
    };
    var $author$project$Navbars$Practice$initSessionConfiguration = function(session) {
        var practiceIsOnboarding = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding, $author$project$Api$Platform$Session$One$organization(session)));
        var onboarded = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$onboarded, $author$project$Api$Platform$Session$One$organization(session)));
        var isViewingAsHinter = $author$project$Utils$User$isViewingAsHinter(session);
        var showSideNav_ = function(hinterViewOff) {
            return practiceIsOnboarding && !isViewingAsHinter(hinterViewOff) || $author$project$Api$Platform$Session$One$role(session) === 'practice_practice_billing_only' ? false : isViewingAsHinter(hinterViewOff) ? true : onboarded;
        };
        var canGoToReports = function(hinterViewOff) {
            return A3($author$project$Permission$canGoTo, session, hinterViewOff, 45);
        };
        var canGoToPatients = function(hinterViewOff) {
            return A3($author$project$Permission$canGoTo, session, hinterViewOff, 44);
        };
        var canSearch = function(hinterViewOff) {
            return canGoToPatients(hinterViewOff) && onboarded;
        };
        var canGoToNetwork = function(hinterViewOff) {
            return A3($author$project$Permission$canGoTo, session, hinterViewOff, 50);
        };
        var canGoToCompanies = function(hinterViewOff) {
            return A3($author$project$Permission$canGoTo, session, hinterViewOff, 16);
        };
        var canGoToCommissions = function(hinterViewOff) {
            return A3($author$project$Permission$canGoTo, session, hinterViewOff, 46);
        };
        var canGoToBookkeeping = function(hinterViewOff) {
            return A3($author$project$Permission$canGoTo, session, hinterViewOff, 53);
        };
        var canGoToAdmin = function(hinterViewOff) {
            return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0);
        };
        return {
            In: $author$project$Api$Platform$Session$One$accountType(session),
            ED: canGoToAdmin,
            KK: canGoToBookkeeping,
            KL: canGoToCommissions,
            KM: canGoToCompanies,
            KN: canGoToNetwork,
            EF: canGoToPatients,
            vZ: canGoToReports,
            v_: canSearch,
            W4: practiceIsOnboarding,
            Cu: {
                KV: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$canSwitchOrganizations)(session),
                yu: isViewingAsHinter,
                afX: A2($elm$core$Maybe$map, function(org) {
                    return $author$project$Api$Platform$Organization$Shared$type_(org);
                }, $author$project$Api$Platform$Session$One$organization(session)),
                VG: A2($elm$core$Maybe$andThen, $author$project$Api$Common$RequestDetail$Shared$osName, $author$project$Api$Platform$Session$One$requestDetail(session)),
                _k: showSideNav_,
                aib: A2($elm$core$Basics$composeR, $author$project$Api$Platform$Session$One$user, $author$project$Api$Platform$User$Shared$name)(session)
            }
        };
    };
    var $author$project$Api$Provider$EmbeddedReport$All$EmbeddedReport = $elm$core$Basics$identity;
    var $author$project$Api$Provider$EmbeddedReport$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$EmbeddedReport$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$EmbeddedReport$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$EmbeddedReport$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$EmbeddedReport$embeddedReportsPath));
    });
    var $author$project$Api$Common$PartnerApp$All$PartnerApp = $elm$core$Basics$identity;
    var $author$project$Api$Common$PartnerApp$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Common$PartnerApp$Shared$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$PartnerApp$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Common$PartnerApp$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$PartnerApp$partnerAppsPath));
    });
    var $author$project$Api$Provider$Report$All$Record = function(id) {
        return {
            aef: id
        };
    };
    var $author$project$Api$Provider$Report$All$Report = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Report$All$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A2($elm$json$Json$Decode$map, $author$project$Api$Provider$Report$All$Record, A2($elm$json$Json$Decode$at, _List_fromArray([
        'id'
    ]), $elm$json$Json$Decode$string)));
    var $author$project$Api$Provider$Report$reportsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'reports'
    ]), $author$project$Api$Data$providerPath);
    var $author$project$Api$Provider$Report$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Report$All$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Provider$Report$reportsPath));
    });
    var $author$project$Navbars$Practice$Navigation$Account = {
        $: 5
    };
    var $author$project$Navbars$Practice$Navigation$Admin = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Navbars$Practice$Navigation$AppointmentTypes = 14;
    var $author$project$Navbars$Practice$Navigation$Bookkeeping = {
        $: 6
    };
    var $author$project$Navbars$Practice$Navigation$Calendar = {
        $: 1
    };
    var $author$project$Navbars$Practice$Navigation$CalendarLocations = 13;
    var $author$project$Navbars$Practice$Navigation$ChargeItems = 5;
    var $author$project$Navbars$Practice$Navigation$ClinicalDashboard = {
        $: 7
    };
    var $author$project$Navbars$Practice$Navigation$Commissions = {
        $: 4
    };
    var $author$project$Navbars$Practice$Navigation$CommissionsSetup = 6;
    var $author$project$Navbars$Practice$Navigation$CompanyInvoices = {
        $: 5
    };
    var $author$project$Navbars$Practice$Navigation$Contacts = {
        $: 11
    };
    var $author$project$Navbars$Practice$Navigation$CreditCategories = 4;
    var $author$project$Navbars$Practice$Navigation$CreditOutstanding = {
        $: 6
    };
    var $author$project$Navbars$Practice$Navigation$CreditTransactions = {
        $: 10
    };
    var $author$project$Navbars$Practice$Navigation$Custom = function(a) {
        return {
            $: 13,
            a: a
        };
    };
    var $author$project$Navbars$Practice$Navigation$Dashboard = {
        $: 0
    };
    var $author$project$Navbars$Practice$Navigation$DataExport = 12;
    var $author$project$Navbars$Practice$Navigation$DeferredRevenue = {
        $: 8
    };
    var $author$project$Navbars$Practice$Navigation$Deposits = {
        $: 11
    };
    var $author$project$Navbars$Practice$Navigation$Developers = 19;
    var $author$project$Navbars$Practice$Navigation$Documents = 11;
    var $author$project$Navbars$Practice$Navigation$ERx = 15;
    var $author$project$Navbars$Practice$Navigation$FileDrive = 17;
    var $author$project$Navbars$Practice$Navigation$Forms = {
        $: 10
    };
    var $author$project$Navbars$Practice$Navigation$Help = function(a) {
        return {
            $: 14,
            a: a
        };
    };
    var $author$project$Navbars$Practice$Navigation$HipaaAuthorizations = 8;
    var $author$project$Navbars$Practice$Navigation$Inbox = {
        $: 8
    };
    var $author$project$Navbars$Practice$Navigation$Integrations = 9;
    var $author$project$Navbars$Practice$Navigation$InvoiceSettings = 10;
    var $author$project$Navbars$Practice$Navigation$Invoices = {
        $: 4
    };
    var $author$project$Navbars$Practice$Navigation$Marketplace = {
        $: 16
    };
    var $author$project$Navbars$Practice$Navigation$Medications = 16;
    var $author$project$Navbars$Practice$Navigation$MembershipOptions = 2;
    var $author$project$Navbars$Practice$Navigation$Memberships = {
        $: 3
    };
    var $author$project$Navbars$Practice$Navigation$Months = {
        $: 1
    };
    var $author$project$Navbars$Practice$Navigation$Networks = {
        $: 3
    };
    var $author$project$Navbars$Practice$Navigation$NotificationsPatient = 7;
    var $author$project$Navbars$Practice$Navigation$PartnerApp = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Navbars$Practice$Navigation$Patients = {
        $: 0
    };
    var $author$project$Navbars$Practice$Navigation$PaymentApplications = {
        $: 9
    };
    var $author$project$Navbars$Practice$Navigation$Phones = 20;
    var $author$project$Navbars$Practice$Navigation$Practice = 0;
    var $author$project$Navbars$Practice$Navigation$Providers = 1;
    var $author$project$Navbars$Practice$Navigation$Reports = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Navbars$Practice$Navigation$Revenue = {
        $: 7
    };
    var $author$project$Navbars$Practice$Navigation$SalesTax = {
        $: 12
    };
    var $author$project$Navbars$Practice$Navigation$Signup = 3;
    var $author$project$Navbars$Practice$Navigation$SignupAttempts = {
        $: 2
    };
    var $author$project$Navbars$Practice$Navigation$Sponsors = {
        $: 2
    };
    var $author$project$Navbars$Practice$Navigation$Support = 0;
    var $author$project$Navbars$Practice$Navigation$Tasks = {
        $: 9
    };
    var $author$project$Navbars$Practice$Navigation$Team = 21;
    var $author$project$Navbars$Practice$Navigation$Templates = 18;
    var $author$project$Navbars$Practice$Navigation$navItemFromUrl = function(url) {
        var pathList = A2($elm$core$List$drop, 1, A2($elm$core$String$split, '/', url.V6));
        _v0$23: while(true){
            _v0$27: while(true){
                if (pathList.b) switch(pathList.a){
                    case 'calendar':
                        return $author$project$Navbars$Practice$Navigation$Calendar;
                    case 'patients':
                        return $author$project$Navbars$Practice$Navigation$Patients;
                    case 'companies':
                        return $author$project$Navbars$Practice$Navigation$Sponsors;
                    case 'affiliate_bills':
                        return $author$project$Navbars$Practice$Navigation$Networks;
                    case 'affiliates':
                        return $author$project$Navbars$Practice$Navigation$Networks;
                    case 'commissions':
                        return $author$project$Navbars$Practice$Navigation$Commissions;
                    case 'reports':
                        var tail = pathList.b;
                        _v1$14: while(true){
                            if (tail.b) switch(tail.a){
                                case 'dashboard':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard);
                                case 'months':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Months);
                                case 'signup_attempts':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SignupAttempts);
                                case 'memberships':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Memberships);
                                case 'invoices':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Invoices);
                                case 'company_invoices':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CompanyInvoices);
                                case 'credit_outstanding':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditOutstanding);
                                case 'revenue':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Revenue);
                                case 'deferred_revenue':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$DeferredRevenue);
                                case 'payment_applications':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$PaymentApplications);
                                case 'credit_transactions':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditTransactions);
                                case 'deposits':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Deposits);
                                case 'sales_tax':
                                    return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SalesTax);
                                case 'custom':
                                    if (tail.b.b) {
                                        var _v2 = tail.b;
                                        var id = _v2.a;
                                        return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Custom(id));
                                    } else break _v1$14;
                                default:
                                    break _v1$14;
                            }
                            else break _v1$14;
                        }
                        return $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard);
                    case 'admin':
                        var tail = pathList.b;
                        _v3$44: while(true){
                            if (tail.b) switch(tail.a){
                                case 'practice':
                                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                                case 'team':
                                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                                case 'phones':
                                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                                case 'billing':
                                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                                case 'payment_sources':
                                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                                case 'notes':
                                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                                case 'features':
                                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                                case 'scheduled_jobs':
                                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                                case 'providers':
                                    return $author$project$Navbars$Practice$Navigation$Admin(1);
                                case 'patients':
                                    return $author$project$Navbars$Practice$Navigation$Admin(1);
                                case 'locations':
                                    return $author$project$Navbars$Practice$Navigation$Admin(1);
                                case 'provider_groups':
                                    return $author$project$Navbars$Practice$Navigation$Admin(1);
                                case 'plans':
                                    return $author$project$Navbars$Practice$Navigation$Admin(2);
                                case 'coverage_plans':
                                    return $author$project$Navbars$Practice$Navigation$Admin(2);
                                case 'coupons':
                                    return $author$project$Navbars$Practice$Navigation$Admin(2);
                                case 'cancellation_reasons':
                                    return $author$project$Navbars$Practice$Navigation$Admin(2);
                                case 'advance_billing':
                                    return $author$project$Navbars$Practice$Navigation$Admin(2);
                                case 'signup':
                                    return $author$project$Navbars$Practice$Navigation$Admin(3);
                                case 'signup_pages':
                                    return $author$project$Navbars$Practice$Navigation$Admin(3);
                                case 'self_service':
                                    return $author$project$Navbars$Practice$Navigation$Admin(3);
                                case 'lead_sources':
                                    return $author$project$Navbars$Practice$Navigation$Admin(3);
                                case 'credit_categories':
                                    return $author$project$Navbars$Practice$Navigation$Admin(4);
                                case 'credits':
                                    return $author$project$Navbars$Practice$Navigation$Admin(4);
                                case 'charge_items':
                                    return $author$project$Navbars$Practice$Navigation$Admin(5);
                                case 'categories':
                                    return $author$project$Navbars$Practice$Navigation$Admin(5);
                                case 'taxes':
                                    return $author$project$Navbars$Practice$Navigation$Admin(5);
                                case 'commissions':
                                    return $author$project$Navbars$Practice$Navigation$Admin(6);
                                case 'notifications':
                                    return $author$project$Navbars$Practice$Navigation$Admin(7);
                                case 'hipaa_authorizations':
                                    return $author$project$Navbars$Practice$Navigation$Admin(8);
                                case 'stripe':
                                    return $author$project$Navbars$Practice$Navigation$Admin(9);
                                case 'card_readers':
                                    return $author$project$Navbars$Practice$Navigation$Admin(9);
                                case 'quickbooks':
                                    return $author$project$Navbars$Practice$Navigation$Admin(9);
                                case 'elation':
                                    return $author$project$Navbars$Practice$Navigation$Admin(9);
                                case 'athenahealth':
                                    return $author$project$Navbars$Practice$Navigation$Admin(9);
                                case 'google_analytics':
                                    return $author$project$Navbars$Practice$Navigation$Admin(9);
                                case 'integrations':
                                    return $author$project$Navbars$Practice$Navigation$Admin(9);
                                case 'invoice_settings':
                                    return $author$project$Navbars$Practice$Navigation$Admin(10);
                                case 'company_plans':
                                    return $author$project$Navbars$Practice$Navigation$Admin(10);
                                case 'documents':
                                    return $author$project$Navbars$Practice$Navigation$Admin(11);
                                case 'data_export':
                                    return $author$project$Navbars$Practice$Navigation$Admin(12);
                                case 'calendar':
                                    return $author$project$Navbars$Practice$Navigation$Admin(13);
                                case 'appointment_types':
                                    return $author$project$Navbars$Practice$Navigation$Admin(14);
                                case 'erx':
                                    return $author$project$Navbars$Practice$Navigation$Admin(15);
                                case 'developers':
                                    return $author$project$Navbars$Practice$Navigation$Admin(19);
                                default:
                                    break _v3$44;
                            }
                            else break _v3$44;
                        }
                        return $author$project$Navbars$Practice$Navigation$Admin(0);
                    case 'support':
                        return $author$project$Navbars$Practice$Navigation$Help(0);
                    case 'user':
                        return $author$project$Navbars$Practice$Navigation$Account;
                    case 'bookkeeping':
                        return $author$project$Navbars$Practice$Navigation$Bookkeeping;
                    case 'marketplace':
                        return $author$project$Navbars$Practice$Navigation$Marketplace;
                    case 'apps':
                        if (pathList.b.b && !pathList.b.b.b) {
                            var _v10 = pathList.b;
                            var id = _v10.a;
                            return $author$project$Navbars$Practice$Navigation$PartnerApp(id);
                        } else break _v0$27;
                    case 'google_callback':
                        return $author$project$Navbars$Practice$Navigation$ClinicalDashboard;
                    case 'home':
                        return $author$project$Navbars$Practice$Navigation$ClinicalDashboard;
                    case 'contacts':
                        return $author$project$Navbars$Practice$Navigation$Contacts;
                    case 'files':
                        return $author$project$Navbars$Practice$Navigation$Admin(17);
                    case 'forms':
                        return $author$project$Navbars$Practice$Navigation$Forms;
                    case 'inventory':
                        return $author$project$Navbars$Practice$Navigation$Admin(16);
                    case 'new_settings':
                        if (pathList.b.b) switch(pathList.b.a){
                            case 'practice_info':
                                var _v4 = pathList.b;
                                return $author$project$Navbars$Practice$Navigation$Admin(20);
                            case 'team':
                                if (pathList.b.b.b && pathList.b.b.b.b && pathList.b.b.b.a === 'basic_info') {
                                    var _v5 = pathList.b;
                                    var _v6 = _v5.b;
                                    var _v7 = _v6.b;
                                    return $author$project$Navbars$Practice$Navigation$Account;
                                } else {
                                    var _v8 = pathList.b;
                                    return $author$project$Navbars$Practice$Navigation$Admin(21);
                                }
                            case 'erx':
                                var _v9 = pathList.b;
                                return $author$project$Navbars$Practice$Navigation$Admin(15);
                            default:
                                break _v0$23;
                        }
                        else break _v0$23;
                    case 'messages':
                        if (pathList.b.b) switch(pathList.b.a){
                            case 'sms':
                                var _v12 = pathList.b;
                                return $author$project$Navbars$Practice$Navigation$Inbox;
                            case 'chat':
                                var _v13 = pathList.b;
                                return $author$project$Navbars$Practice$Navigation$Inbox;
                            default:
                                break _v0$27;
                        }
                        else break _v0$27;
                    case 'tasks':
                        return $author$project$Navbars$Practice$Navigation$Tasks;
                    default:
                        break _v0$27;
                }
                else break _v0$27;
            }
            return $author$project$Navbars$Practice$Navigation$Patients;
        }
        var tail = pathList.b;
        _v11$7: while(true){
            if (tail.b) switch(tail.a){
                case 'appointment_types':
                    return $author$project$Navbars$Practice$Navigation$Admin(14);
                case 'booking_overview':
                    return $author$project$Navbars$Practice$Navigation$Admin(13);
                case 'blocked_phone_numbers':
                    return $author$project$Navbars$Practice$Navigation$Admin(20);
                case 'export':
                    return $author$project$Navbars$Practice$Navigation$Admin(12);
                case 'locations':
                    return $author$project$Navbars$Practice$Navigation$Admin(13);
                case 'templates':
                    return $author$project$Navbars$Practice$Navigation$Admin(18);
                case 'hinter_settings':
                    return $author$project$Navbars$Practice$Navigation$Admin(0);
                default:
                    break _v11$7;
            }
            else break _v11$7;
        }
        return $author$project$Navbars$Practice$Navigation$Admin(0);
    };
    var $author$project$Navbars$Practice$Navigation$AdminNav = 1;
    var $author$project$Navbars$Practice$Navigation$HelpNav = 2;
    var $author$project$Navbars$Practice$Navigation$None = 4;
    var $author$project$Navbars$Practice$Navigation$ProfileNav = 3;
    var $author$project$Navbars$Practice$Navigation$ReportNav = 0;
    var $author$project$Navbars$Practice$openSubNavFromSelectedNav = function(selectedNav) {
        switch(selectedNav.$){
            case 13:
                return 1;
            case 14:
                return 2;
            case 12:
                return 0;
            case 5:
                return 3;
            default:
                return 4;
        }
    };
    var $author$project$Navbars$Practice$init = function(shared) {
        var selectedNav = $author$project$Navbars$Practice$Navigation$navItemFromUrl(shared.aaT);
        var practice = shared.W1;
        var apiClient = shared.Ej;
        return _Utils_Tuple3({
            hu: A2($author$project$Ui$FlyoutMenu$init, 'admin-menu', $author$project$Navbars$Practice$AdminMenuMsg),
            abT: shared.abT,
            cP: $elm$core$Maybe$Nothing,
            qt: $author$project$Api$Data$Loading,
            adm: shared.adm,
            iQ: $author$project$Components$HinterPracticeSettingsModal$init,
            qW: shared.qW,
            yr: false,
            c5: $author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav),
            afY: shared.afY,
            rS: $author$project$Api$Data$NotAsked,
            W1: practice,
            jz: $author$project$Navbars$Practice$buildPracticeConfig(practice),
            et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg),
            jR: A2($author$project$Ui$FlyoutMenu$init, 'reporting-menu', $author$project$Navbars$Practice$ReportMenuMsg),
            st: $author$project$Api$Data$NotAsked,
            eI: selectedNav,
            Z$: shared.Z$,
            Cs: $author$project$Navbars$Practice$initSessionConfiguration(shared.Z$),
            sZ: false,
            oz: false,
            oI: $author$project$Ui$Dropdown$init($author$project$Ui$Dropdown$defaultConfig({
                aef: 'switch-product-dropdown',
                ahX: $author$project$Navbars$Practice$SwitchProductDropDownMsg
            })),
            abq: shared.abq
        }, $author$project$Api$Data$clientHasAuthToken(apiClient) ? $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$EmbeddedReport$list, apiClient, $author$project$Navbars$Practice$GotEmbeddedReports),
            A2($elm$core$Task$perform, $author$project$Navbars$Practice$GotCurrentDate, $justinmimbs$date$Date$today),
            A2($author$project$Api$Provider$Report$list, apiClient, $author$project$Navbars$Practice$GotReports),
            A2($author$project$Api$Provider$PartnerApp$list, apiClient, $author$project$Navbars$Practice$GotPartnerApps)
        ])) : $elm$core$Platform$Cmd$none, _List_Nil);
    };
    var $author$project$Navbar$andInitPracticeNavbar = F5(function(apiClient, whitelabelSetting, practice, backupAuthEnabled, _v0) {
        var model = _v0;
        var _v1 = $author$project$Navbars$Practice$init({
            Ej: apiClient,
            abT: backupAuthEnabled,
            adm: model.adm,
            aeb: model.aeb,
            qW: model.qW,
            afY: model.afY,
            W1: practice,
            Z$: model.Z$,
            aaT: model.aaT,
            abq: whitelabelSetting
        });
        var navbarModel = _v1.a;
        var navbarCmd = _v1.b;
        return _Utils_Tuple2(_Utils_update(model, {
            ad: $author$project$Navbar$PracticeNav(navbarModel)
        }), A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PracticeNavbarMsg, navbarCmd));
    });
    var $author$project$Navbar$initForPractice = F6(function(apiClient, session, whitelabelSetting, practice, backupAuthEnabled, flags) {
        return A5($author$project$Navbar$andInitPracticeNavbar, apiClient, whitelabelSetting, practice, backupAuthEnabled, A3($author$project$Navbar$init, session, $elm$core$Maybe$Just($author$project$Api$Practice$Provider(practice)), flags));
    });
    var $author$project$Shared$isPublicRoute = function(route) {
        var _v0 = $author$project$Permission$forRoute(route);
        if (_v0.$ === 1) return true;
        else return false;
    };
    var $author$project$Shared$initNavbar = function(_v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        var _v1 = _Utils_Tuple2(model.Z$, model.ae);
        if (_v1.a.$ === 3 && _v1.b.$ === 1) {
            var _v2 = _v1.a;
            var session = _v2.a;
            var _v3 = _v1.b;
            var currentRoute = $author$project$Utils$Route$fromUrl(model.aaT);
            var isPublic = $author$project$Shared$isPublicRoute(currentRoute);
            if (isPublic) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            else {
                var whitelabelSetting = A2($elm$core$Maybe$withDefault, $author$project$Api$WhitelabelSetting$empty, $author$project$Api$Data$toMaybe(model.abq));
                var organizationType = A2($elm$core$Maybe$map, function(org) {
                    return $author$project$Api$Platform$Organization$Shared$type_(org);
                }, $author$project$Api$Platform$Session$One$organization(session));
                var _v4 = _Utils_Tuple2(organizationType, model.W1);
                _v4$3: while(true){
                    if (!_v4.a.$) switch(_v4.a.a){
                        case 0:
                            if (_v4.b.$ === 3) {
                                var _v5 = _v4.a.a;
                                var _v6 = _v4.b;
                                var practice = _v6.a;
                                var _v7 = _Utils_Tuple2(practice, model.acy);
                                if (!_v7.a.$) {
                                    var practice_ = _v7.a.a;
                                    return A2($elm$core$Tuple$mapFirst, function(navbar) {
                                        return _Utils_update(model, {
                                            ae: $elm$core$Maybe$Just(navbar)
                                        });
                                    }, A2($elm$core$Tuple$mapSecond, function(navbarCmd) {
                                        return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                            cmd,
                                            navbarCmd
                                        ]));
                                    }, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg), A6($author$project$Navbar$initForPractice, model.Ej, session, whitelabelSetting, practice_, model.adU.abT, {
                                        adm: model.adU.adm,
                                        aeb: model.aeb,
                                        qW: model.qW,
                                        afY: model.adU.afY,
                                        aaT: model.aaT
                                    }))));
                                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                            } else break _v4$3;
                        case 1:
                            if (_v4.b.$ === 3) {
                                var _v8 = _v4.a.a;
                                var _v9 = _v4.b;
                                var practice = _v9.a;
                                var _v10 = _Utils_Tuple2(practice, model.acy);
                                if (_v10.a.$ === 1 && _v10.b.$ === 3 && _v10.b.a.$ === 1) {
                                    var practice_ = _v10.a.a;
                                    var _v11 = _v10.b;
                                    var company = _v11.a.a;
                                    return A2($elm$core$Tuple$mapFirst, function(navbar) {
                                        return _Utils_update(model, {
                                            ae: $elm$core$Maybe$Just(navbar)
                                        });
                                    }, A2($elm$core$Tuple$mapSecond, function(navbarCmd) {
                                        return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                            cmd,
                                            navbarCmd
                                        ]));
                                    }, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg), A5($author$project$Navbar$initForEmployer, session, whitelabelSetting, practice_, company, {
                                        adm: model.adU.adm,
                                        aeb: model.aeb,
                                        qW: model.qW,
                                        afY: model.adU.afY,
                                        aaT: model.aaT
                                    }))));
                                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                            } else break _v4$3;
                        default:
                            var _v12 = _v4.a.a;
                            var _v13 = model.VW;
                            if (_v13.$ === 3) {
                                var partner = _v13.a;
                                return A2($elm$core$Tuple$mapFirst, function(navbar) {
                                    return _Utils_update(model, {
                                        ae: $elm$core$Maybe$Just(navbar)
                                    });
                                }, A2($elm$core$Tuple$mapSecond, function(navbarCmd) {
                                    return $elm$core$Platform$Cmd$batch(_List_fromArray([
                                        cmd,
                                        navbarCmd
                                    ]));
                                }, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Shared$NavbarMsg), A3($author$project$Navbar$initForPartner, session, partner, {
                                    adm: model.adU.adm,
                                    aeb: model.aeb,
                                    qW: model.qW,
                                    afY: model.adU.afY,
                                    aaT: model.aaT
                                }))));
                            } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    }
                    else break _v4$3;
                }
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            }
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Api$Practice$provider = function(practice) {
        return A2($author$project$Api$Data$map, $author$project$Api$Practice$Provider, practice);
    };
    var $author$project$Shared$resetTenancyProperties = function(_v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            acy: $author$project$Api$Data$NotAsked,
            MO: $author$project$Api$Data$NotAsked,
            lL: $elm$core$Maybe$Nothing,
            qY: $elm$core$Maybe$Just($elm$core$Dict$empty),
            ae: $elm$core$Maybe$Nothing,
            af4: $elm$core$Maybe$Nothing,
            n1: $elm$core$Maybe$Nothing
        }), cmd);
    };
    var $author$project$Shared$GotPartner = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Shared$retrievePartner = function(apiClient) {
        return A2($author$project$Api$Partner$Partner$retrieve, apiClient, $author$project$Shared$GotPartner);
    };
    var $author$project$Shared$GotPractice = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Employer$Practice$One$Practice = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Practice$One$Record = function(id) {
        return function(name) {
            return function(hasPaymentProcessorAccount) {
                return function(stripePublishableKey) {
                    return function(ssnEnabled) {
                        return function(features) {
                            return function(trackPatientsByLocation) {
                                return function(transInclusivity) {
                                    return function(address) {
                                        return function(phones) {
                                            return function(collectSSNOnSignup) {
                                                return function(featureGates) {
                                                    return function(requiresPatientMobile) {
                                                        return function(requiresSSN) {
                                                            return function(requiresPatientEmail) {
                                                                return function(requiresPractitioner) {
                                                                    return function(requiresLocation) {
                                                                        return function(meta) {
                                                                            return function(email) {
                                                                                return function(network) {
                                                                                    return function(paymentProcessor) {
                                                                                        return function(hideSponsorInvoices) {
                                                                                            return function(organizationId) {
                                                                                                return {
                                                                                                    II: address,
                                                                                                    Ly: collectSSNOnSignup,
                                                                                                    OH: email,
                                                                                                    Pv: featureGates,
                                                                                                    Px: features,
                                                                                                    Qw: hasPaymentProcessorAccount,
                                                                                                    QI: hideSponsorInvoices,
                                                                                                    aef: id,
                                                                                                    Ue: meta,
                                                                                                    zr: name,
                                                                                                    UK: network,
                                                                                                    afV: organizationId,
                                                                                                    Wo: paymentProcessor,
                                                                                                    WG: phones,
                                                                                                    YK: requiresLocation,
                                                                                                    YM: requiresPatientEmail,
                                                                                                    YN: requiresPatientMobile,
                                                                                                    YP: requiresPractitioner,
                                                                                                    YQ: requiresSSN,
                                                                                                    _$: ssnEnabled,
                                                                                                    $l: stripePublishableKey,
                                                                                                    aaq: trackPatientsByLocation,
                                                                                                    aas: transInclusivity
                                                                                                };
                                                                                            };
                                                                                        };
                                                                                    };
                                                                                };
                                                                            };
                                                                        };
                                                                    };
                                                                };
                                                            };
                                                        };
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
    var $author$project$Api$Employer$Network$Shared$Network = $elm$core$Basics$identity;
    var $author$project$Api$Employer$Network$Shared$Record = F2(function(syncByAffiliation, ratesFromAffiliate) {
        return {
            X9: ratesFromAffiliate,
            $D: syncByAffiliation
        };
    });
    var $author$project$Api$Employer$Network$Shared$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'rates_from_affiliate', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sync_by_affiliation', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Network$Shared$Record)));
    var $author$project$Api$Employer$Network$Shared$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Network$Shared$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Practice$One$OneMeta = F2(function(hasPractitioners, hasLocations) {
        return {
            Qr: hasLocations,
            Qx: hasPractitioners
        };
    });
    var $author$project$Api$Employer$Practice$One$metaDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_locations', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_practitioners', $elm$json$Json$Decode$bool, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Practice$One$OneMeta)));
    var $author$project$Api$Employer$Practice$One$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'hide_sponsor_invoices', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'payment_processor', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'network', $elm$json$Json$Decode$nullable($author$project$Api$Employer$Network$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'email', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'meta', $author$project$Api$Employer$Practice$One$metaDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_location', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_practitioner', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_patient_email', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_ssn', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'requires_patient_mobile', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'feature_gates', $elm$json$Json$Decode$list($author$project$Api$Common$FeatureGate$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'collect_ssn_on_signup', $author$project$Api$CollectOnSignup$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'phones', $elm$json$Json$Decode$list($author$project$Api$Common$Phone$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'address', $elm$json$Json$Decode$nullable($author$project$Api$Common$Address$Shared$decoder), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'trans_inclusivity', $elm$json$Json$Decode$bool, A4($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional, 'track_patients_by_location', $elm$json$Json$Decode$bool, false, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'features', $elm$json$Json$Decode$list($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'ssn_enabled', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'stripe_publishable_key', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'has_payment_processor_account', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Employer$Practice$One$Record))))))))))))))))))))))));
    var $author$project$Api$Employer$Practice$One$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Employer$Practice$One$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Employer$Practice$practicePath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'practice'
    ]), $author$project$Api$Data$employerPath);
    var $author$project$Api$Employer$Practice$retrieve = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Employer$Practice$One$decoder, toMsg, $author$project$Api$Data$requestTo($author$project$Api$Employer$Practice$practicePath));
    });
    var $author$project$Api$Practice$retrieve = F3(function(apiClient, session, toMsg) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? A2($author$project$Api$Employer$Practice$retrieve, apiClient, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Practice$Employer))) : A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, A2($elm$core$Basics$composeL, toMsg, $author$project$Api$Data$map($author$project$Api$Practice$Provider)));
    });
    var $author$project$Shared$retrievePractice = F2(function(apiClient, session) {
        return A3($author$project$Api$Practice$retrieve, apiClient, session, $author$project$Shared$GotPractice);
    });
    var $author$project$Shared$OrgSwitcher$pendingRedirect = function(action) {
        return $elm$core$Maybe$Just({
            D7: action
        });
    };
    var $author$project$Shared$scheduleOrgSwitchRedirect = F3(function(model, action, cmd) {
        return $author$project$Shared$resetTenancyProperties(_Utils_Tuple2(_Utils_update(model, {
            VW: $author$project$Api$Data$NotAsked,
            db: $author$project$Shared$OrgSwitcher$pendingRedirect(action),
            W1: $author$project$Api$Data$NotAsked
        }), cmd));
    });
    var $author$project$Ui$Toast$levelToString = function(level) {
        switch(level){
            case 0:
                return 'info';
            case 1:
                return 'danger';
            case 2:
                return 'warning';
            default:
                return 'success';
        }
    };
    var $author$project$Ui$Toast$sendToastMessagePort = _Platform_outgoingPort('sendToastMessagePort', function($) {
        var a = $.a;
        var b = $.b;
        return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([
            $elm$json$Json$Encode$string(a),
            $elm$json$Json$Encode$string(b)
        ]));
    });
    var $author$project$Ui$Toast$sendMessage = F2(function(level, message) {
        return $author$project$Ui$Toast$sendToastMessagePort(_Utils_Tuple2($author$project$Ui$Toast$levelToString(level), message));
    });
    var $author$project$Shared$showToast = F3(function(embedded, toastLevel, message) {
        return embedded ? A2($author$project$Ui$Toast$sendMessage, toastLevel, message) : $elm$core$Platform$Cmd$none;
    });
    var $author$project$Ports$HinterView$hinterViewStorePort = _Platform_outgoingPort('hinterViewStorePort', $elm$json$Json$Encode$bool);
    var $author$project$Ports$HinterView$store = $author$project$Ports$HinterView$hinterViewStorePort;
    var $author$project$Ports$Session$persistBackupAuthTokenPort = _Platform_outgoingPort('persistBackupAuthTokenPort', $elm$json$Json$Encode$string);
    var $author$project$Ports$Session$persistBackupAuthToken = function(token) {
        return $author$project$Ports$Session$persistBackupAuthTokenPort(token);
    };
    var $author$project$Ports$Session$refreshBackupAuthTokenPort = _Platform_outgoingPort('refreshBackupAuthTokenPort', $elm$json$Json$Encode$string);
    var $author$project$Ports$Session$refreshBackupAuthToken = function(token) {
        return $author$project$Ports$Session$refreshBackupAuthTokenPort(token);
    };
    var $author$project$Shared$storeAuthToken = F2(function(authToken, isRefresh) {
        var portCmd = isRefresh ? $author$project$Ports$Session$refreshBackupAuthToken : $author$project$Ports$Session$persistBackupAuthToken;
        return A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, portCmd, $author$project$Api$AuthToken$toString(authToken)));
    });
    var $author$project$Api$Platform$Session$switchRole = F3(function(apiClient, role, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('role', $elm$json$Json$Encode$string(role))
        ]));
        return A4($author$project$Api$Data$post, apiClient, $author$project$Api$Platform$Session$One$decoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'switch_role'
        ]), $author$project$Api$Platform$Session$sessionPath))));
    });
    var $author$project$Ports$Session$sessionSwitchTenant = _Platform_outgoingPort('sessionSwitchTenant', $elm$json$Json$Encode$string);
    var $author$project$Ports$Session$switchTenant = function(organizationId) {
        return $author$project$Ports$Session$sessionSwitchTenant(organizationId);
    };
    var $author$project$Api$Auth$switchToOrganization = F4(function(client, organizationId, role, toMsg) {
        var body = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('organization', $elm$json$Json$Encode$object(_List_fromArray([
                _Utils_Tuple2('id', $elm$json$Json$Encode$string(organizationId)),
                _Utils_Tuple2('type', $elm$json$Json$Encode$string('organization'))
            ]))),
            _Utils_Tuple2('role', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, role))
        ]));
        return A4($author$project$Api$Data$post, client, $author$project$Api$Auth$authTokenDecoder, toMsg, A2($author$project$Api$Data$requestWithJson, body, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'switch_organization'
        ]), $author$project$Api$Auth$authPath))));
    });
    var $author$project$Ui$Toast$ToastAutoDismissed = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Toast$dismissInSeconds = F2(function(seconds, id) {
        return A2($elm$core$Task$perform, function(_v0) {
            return $author$project$Ui$Toast$ToastAutoDismissed(id);
        }, $elm$core$Process$sleep(seconds * 1000));
    });
    var $author$project$Ui$Toast$Toast = $elm$core$Basics$identity;
    var $author$project$Ui$Toast$ToastRecord = F4(function(id, level, message, dismissible) {
        return {
            qm: dismissible,
            aef: id,
            S5: level,
            ae1: message
        };
    });
    var $author$project$Ui$Toast$newToast = F3(function(id, level, message) {
        return A4($author$project$Ui$Toast$ToastRecord, id, level, message, true);
    });
    var $author$project$Ui$Toast$toast = F3(function(level, message, _v0) {
        var count = _v0.a;
        var toasts = _v0.b;
        return _Utils_Tuple2(A2($author$project$Ui$Toast$Toastr, count + 1, _Utils_ap(toasts, _List_fromArray([
            A3($author$project$Ui$Toast$newToast, count, level, message)
        ]))), A2($author$project$Ui$Toast$dismissInSeconds, 4, count));
    });
    var $author$project$Shared$updateFromOutMsg = F2(function(outMsg, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        switch(outMsg.$){
            case 0:
                var error = outMsg.a;
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    $author$project$Shared$decodeErrorToMsg(error)
                ])));
            case 1:
                var toastLevel = outMsg.a;
                var message = outMsg.b;
                var _v2 = A3($author$project$Ui$Toast$toast, toastLevel, message, model.ky);
                var toastr = _v2.a;
                var toastrCmd = _v2.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ky: toastr
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A3($author$project$Shared$showToast, model.adU.adj, toastLevel, message),
                    A2($elm$core$Platform$Cmd$map, $author$project$Shared$ToastMsg, toastrCmd)
                ])));
            case 5:
                var practice = outMsg.a;
                return $author$project$Shared$initNavbar($author$project$Shared$resetTenancyProperties(_Utils_Tuple2(_Utils_update(model, {
                    W1: $author$project$Api$Practice$provider(practice)
                }), cmd)));
            case 6:
                var partner = outMsg.a;
                return $author$project$Shared$initNavbar(_Utils_Tuple2(_Utils_update(model, {
                    VW: partner
                }), cmd));
            case 7:
                var dataWhitelabelSetting = outMsg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    abq: dataWhitelabelSetting
                }), $elm$core$Platform$Cmd$none);
            case 2:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    function() {
                        var _v3 = model.Z$;
                        if (_v3.$ === 3) {
                            var session = _v3.a;
                            return A2($author$project$Shared$retrievePractice, model.Ej, session);
                        } else return $elm$core$Platform$Cmd$none;
                    }()
                ])));
            case 3:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    function() {
                        var _v4 = model.Z$;
                        if (_v4.$ === 3) return $author$project$Shared$retrievePartner(model.Ej);
                        else return $elm$core$Platform$Cmd$none;
                    }()
                ])));
            case 9:
                var patientId = outMsg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    MO: $author$project$Api$Data$Loading,
                    lL: $elm$core$Maybe$Just(patientId)
                }), A3($author$project$Api$Provider$Patient$retrieve, model.Ej, patientId, $author$project$Shared$GotPatient(patientId)));
            case 8:
                var companyId = outMsg.a;
                var _v5 = function() {
                    var _v6 = model.Z$;
                    switch(_v6.$){
                        case 3:
                            var session = _v6.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                acy: $author$project$Api$Data$Loading
                            }), A4($author$project$Api$Company$retrieve, model.Ej, session, companyId, $author$project$Shared$GotCompany(companyId)));
                        case 1:
                            return _Utils_Tuple2(_Utils_update(model, {
                                acy: $author$project$Api$Data$Loading,
                                n1: $elm$core$Maybe$Just(companyId)
                            }), $elm$core$Platform$Cmd$none);
                        default:
                            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    }
                }();
                var newModel = _v5.a;
                var retrieveCompanyCmd = _v5.b;
                return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    retrieveCompanyCmd
                ])));
            case 10:
                var query = outMsg.a;
                var _v7 = _Utils_Tuple3(model.Z$, model.W1, model.af4);
                if (_v7.a.$ === 3 && _v7.b.$ === 3 && !_v7.b.a.$ && _v7.c.$ === 1) {
                    var _v8 = _v7.a;
                    var session = _v8.a;
                    var _v9 = _v7.b;
                    var practice = _v9.a.a;
                    var _v10 = _v7.c;
                    var _v11 = A4($author$project$Components$PatientsList$init, session, practice, model.lL, {
                        Ej: model.Ej,
                        Bz: query,
                        HO: model.HO,
                        HP: model.HP,
                        aaT: model.aaT
                    });
                    var newList = _v11.a;
                    var listCmd = _v11.b;
                    return _Utils_Tuple2(_Utils_update(model, {
                        af4: $elm$core$Maybe$Just(newList)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        cmd,
                        A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, listCmd)
                    ])));
                } else return _Utils_Tuple2(model, cmd);
            case 11:
                var _v12 = model.af4;
                if (!_v12.$) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A2($elm$core$Task$perform, function(_v13) {
                        return $author$project$Shared$PatientsListMsg($author$project$Components$PatientsList$RefreshPatients);
                    }, $elm$core$Task$succeed(0))
                ])));
                else return _Utils_Tuple2(model, cmd);
            case 12:
                var hinterViewOff = !model.aeb;
                return _Utils_Tuple2(_Utils_update(model, {
                    aeb: hinterViewOff
                }), $author$project$Ports$HinterView$store(hinterViewOff));
            case 13:
                var highlightPhi = !model.mu;
                return _Utils_Tuple2(_Utils_update(model, {
                    mu: highlightPhi
                }), $elm$core$Platform$Cmd$none);
            case 14:
                var error = outMsg.a;
                var serverError = $author$project$Ui$Toast$serverError(error);
                return $author$project$Api$Data$clientHasAuthToken(model.Ej) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    $author$project$Ports$Session$logout({
                        agy: true
                    }),
                    $author$project$Ports$Sentry$captureDebugMessage('Unauthorized request: ' + serverError)
                ]))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A3($author$project$Shared$showToast, model.adU.adj, 1, serverError)
                ])));
            case 15:
                var organizationId = outMsg.a;
                var roleWithPrefix = outMsg.b;
                var postOrganizationSwitchedAction_ = outMsg.c;
                return model.adU.abT ? _Utils_Tuple2(model, A4($author$project$Api$Auth$switchToOrganization, model.Ej, organizationId, roleWithPrefix, $author$project$Shared$BackupAuthOrganizationSwitched(postOrganizationSwitchedAction_))) : A3($author$project$Shared$scheduleOrgSwitchRedirect, model, postOrganizationSwitchedAction_, $author$project$Ports$Session$switchTenant(organizationId));
            case 16:
                var id = outMsg.a;
                return A3($author$project$Shared$scheduleOrgSwitchRedirect, model, $author$project$OutMsg$GoToClinicalAction, $author$project$Ports$Session$switchTenant(id));
            case 17:
                var roleWithPrefix = outMsg.a;
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A3($author$project$Api$Platform$Session$switchRole, model.Ej, roleWithPrefix, $author$project$Shared$GotRoleSwitched)
                ])));
            case 4:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A2($author$project$Api$Platform$Session$retrieve, model.Ej, $author$project$Shared$GotSession)
                ])));
            case 18:
                var authToken = outMsg.a;
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($author$project$Shared$storeAuthToken, authToken, false),
                    $author$project$Ports$Session$authorize({
                        agy: true
                    })
                ])));
            case 19:
                return _Utils_Tuple2(model, $author$project$Ports$Sentry$captureErrorMessage('Bad Gateway error'));
            default:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Shared$updateFromOutMsgs = F2(function(msgs, model) {
        return A3($elm$core$List$foldl, $author$project$Shared$updateFromOutMsg, _Utils_Tuple2(model, $elm$core$Platform$Cmd$none), msgs);
    });
    var $author$project$Main$init = function(flags) {
        var _v0 = $author$project$Main$locationHrefToUrl(flags.To);
        var url = _v0.a;
        var defaultUrlCmd = _v0.b;
        var _v1 = A2($author$project$Shared$init, flags, url);
        var shared = _v1.a;
        var sharedCmd = _v1.b;
        var _v2 = $author$project$Spa$Layout$init(shared);
        var layout = _v2.a;
        var layoutCmd = _v2.b;
        var route = $author$project$Utils$Route$fromUrl(url);
        var _v3 = A2($author$project$Spa$Generated$Pages$init, route, shared);
        var page = _v3.a;
        var pageCmd = _v3.b;
        var outMsgs = _v3.c;
        var _v4 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, shared);
        var newShared = _v4.a;
        var extraSharedCmd = _v4.b;
        return _Utils_Tuple2(A5($author$project$Main$Model, newShared, route, page, layout, $jinjor$elm_debounce$Debounce$init), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, extraSharedCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
            A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
            defaultUrlCmd
        ])));
    };
    var $author$project$Main$UrlChanged = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Main$UrlRequested = F3(function(a, b, c) {
        return {
            $: 1,
            a: a,
            b: b,
            c: c
        };
    });
    var $author$project$Ports$Navigation$onUrlChange = _Platform_incomingPort('onUrlChange', $elm$json$Json$Decode$string);
    var $author$project$Ports$Navigation$navigationPortOnUrlRequest = _Platform_incomingPort('navigationPortOnUrlRequest', A2($elm$json$Json$Decode$andThen, function(_v0) {
        return A2($elm$json$Json$Decode$andThen, function(_v1) {
            return A2($elm$json$Json$Decode$andThen, function(_v2) {
                return $elm$json$Json$Decode$succeed(_Utils_Tuple3(_v0, _v1, _v2));
            }, A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$bool));
        }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$bool));
    }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
    var $author$project$Ports$Navigation$onUrlRequest = function(toMsg) {
        return $author$project$Ports$Navigation$navigationPortOnUrlRequest(function(_v0) {
            var href = _v0.a;
            var isLocal = _v0.b;
            var shouldOpenInNewWindow = _v0.c;
            return A3(toMsg, href, isLocal, shouldOpenInNewWindow);
        });
    };
    var $author$project$Shared$AccessTokenCreated = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Shared$AccessTokenUpdated = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Shared$AccountLockedModalMsg = function(a) {
        return {
            $: 15,
            a: a
        };
    };
    var $author$project$Shared$GotCurrentTime = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Shared$LoggedOut = {
        $: 18
    };
    var $author$project$Shared$OrganizationSwitcherMsg = function(a) {
        return {
            $: 29,
            a: a
        };
    };
    var $author$project$Shared$PendingChangesKeep = {
        $: 23
    };
    var $author$project$Shared$ShowLogoutWarning = {
        $: 9
    };
    var $elm$time$Time$Every = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $elm$time$Time$State = F2(function(taggers, processes) {
        return {
            Xu: processes,
            $L: taggers
        };
    });
    var $elm$time$Time$init = $elm$core$Task$succeed(A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
    var $elm$time$Time$addMySub = F2(function(_v0, state) {
        var interval = _v0.a;
        var tagger = _v0.b;
        var _v1 = A2($elm$core$Dict$get, interval, state);
        if (_v1.$ === 1) return A3($elm$core$Dict$insert, interval, _List_fromArray([
            tagger
        ]), state);
        else {
            var taggers = _v1.a;
            return A3($elm$core$Dict$insert, interval, A2($elm$core$List$cons, tagger, taggers), state);
        }
    });
    var $elm$time$Time$setInterval = _Time_setInterval;
    var $elm$time$Time$spawnHelp = F3(function(router, intervals, processes) {
        if (!intervals.b) return $elm$core$Task$succeed(processes);
        else {
            var interval = intervals.a;
            var rest = intervals.b;
            var spawnTimer = $elm$core$Process$spawn(A2($elm$time$Time$setInterval, interval, A2($elm$core$Platform$sendToSelf, router, interval)));
            var spawnRest = function(id) {
                return A3($elm$time$Time$spawnHelp, router, rest, A3($elm$core$Dict$insert, interval, id, processes));
            };
            return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
        }
    });
    var $elm$time$Time$onEffects = F3(function(router, subs, _v0) {
        var processes = _v0.Xu;
        var rightStep = F3(function(_v6, id, _v7) {
            var spawns = _v7.a;
            var existing = _v7.b;
            var kills = _v7.c;
            return _Utils_Tuple3(spawns, existing, A2($elm$core$Task$andThen, function(_v5) {
                return kills;
            }, $elm$core$Process$kill(id)));
        });
        var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
        var leftStep = F3(function(interval, taggers, _v4) {
            var spawns = _v4.a;
            var existing = _v4.b;
            var kills = _v4.c;
            return _Utils_Tuple3(A2($elm$core$List$cons, interval, spawns), existing, kills);
        });
        var bothStep = F4(function(interval, taggers, id, _v3) {
            var spawns = _v3.a;
            var existing = _v3.b;
            var kills = _v3.c;
            return _Utils_Tuple3(spawns, A3($elm$core$Dict$insert, interval, id, existing), kills);
        });
        var _v1 = A6($elm$core$Dict$merge, leftStep, bothStep, rightStep, newTaggers, processes, _Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, $elm$core$Task$succeed(0)));
        var spawnList = _v1.a;
        var existingDict = _v1.b;
        var killTask = _v1.c;
        return A2($elm$core$Task$andThen, function(newProcesses) {
            return $elm$core$Task$succeed(A2($elm$time$Time$State, newTaggers, newProcesses));
        }, A2($elm$core$Task$andThen, function(_v2) {
            return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
        }, killTask));
    });
    var $elm$time$Time$onSelfMsg = F3(function(router, interval, state) {
        var _v0 = A2($elm$core$Dict$get, interval, state.$L);
        if (_v0.$ === 1) return $elm$core$Task$succeed(state);
        else {
            var taggers = _v0.a;
            var tellTaggers = function(time) {
                return $elm$core$Task$sequence(A2($elm$core$List$map, function(tagger) {
                    return A2($elm$core$Platform$sendToApp, router, tagger(time));
                }, taggers));
            };
            return A2($elm$core$Task$andThen, function(_v1) {
                return $elm$core$Task$succeed(state);
            }, A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
        }
    });
    var $elm$time$Time$subMap = F2(function(f, _v0) {
        var interval = _v0.a;
        var tagger = _v0.b;
        return A2($elm$time$Time$Every, interval, A2($elm$core$Basics$composeL, f, tagger));
    });
    _Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
    var $elm$time$Time$subscription = _Platform_leaf('Time');
    var $elm$time$Time$every = F2(function(interval, tagger) {
        return $elm$time$Time$subscription(A2($elm$time$Time$Every, interval, tagger));
    });
    var $author$project$Ports$Session$NewSession = F2(function(accessToken, redirectToURI) {
        return {
            pl: accessToken,
            agz: redirectToURI
        };
    });
    var $author$project$Ports$Session$newSessionDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'redirectToURI', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'accessToken', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), $elm$json$Json$Decode$succeed($author$project$Ports$Session$NewSession)));
    var $author$project$Ports$Session$decodeNewSession = function(json) {
        var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$Session$newSessionDecoder, json);
        if (!_v0.$) {
            var newSession = _v0.a;
            return $elm$core$Result$Ok(newSession);
        } else {
            var error = _v0.a;
            return $elm$core$Result$Err($elm$json$Json$Decode$errorToString(error));
        }
    };
    var $author$project$Ports$Session$onAccessTokenCreatedPort = _Platform_incomingPort('onAccessTokenCreatedPort', $elm$json$Json$Decode$value);
    var $author$project$Ports$Session$onAccessTokenCreated = function(toMsg) {
        return $author$project$Ports$Session$onAccessTokenCreatedPort(A2($elm$core$Basics$composeL, toMsg, $author$project$Ports$Session$decodeNewSession));
    };
    var $author$project$Ports$Session$decodeToken = function(json) {
        var _v0 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), json);
        if (!_v0.$) {
            var token = _v0.a;
            return $elm$core$Result$Ok(token);
        } else {
            var error = _v0.a;
            return $elm$core$Result$Err($elm$json$Json$Decode$errorToString(error));
        }
    };
    var $author$project$Ports$Session$onAccessTokenUpdatedPort = _Platform_incomingPort('onAccessTokenUpdatedPort', $elm$json$Json$Decode$value);
    var $author$project$Ports$Session$onAccessTokenUpdated = function(toMsg) {
        return $author$project$Ports$Session$onAccessTokenUpdatedPort(A2($elm$core$Basics$composeL, toMsg, $author$project$Ports$Session$decodeToken));
    };
    var $author$project$Ports$Session$onLogoutWarningPort = _Platform_incomingPort('onLogoutWarningPort', $elm$json$Json$Decode$null(0));
    var $author$project$Ports$Session$onLogoutWarning = function(toMsg) {
        return $author$project$Ports$Session$onLogoutWarningPort($elm$core$Basics$always(toMsg));
    };
    var $author$project$Shared$seconds = function(_float) {
        return _float * 1000;
    };
    var $author$project$Ports$Session$onSessionLoggedOutPort = _Platform_incomingPort('onSessionLoggedOutPort', $elm$json$Json$Decode$null(0));
    var $author$project$Ports$Session$sessionLoggedOut = function(toMsg) {
        return $author$project$Ports$Session$onSessionLoggedOutPort($elm$core$Basics$always(toMsg));
    };
    var $author$project$Components$AccountLockedModal$Close = 0;
    var $author$project$Components$AccountLockedModal$subscriptions = $author$project$Ui$Modal$subscribeToEscapeKeyPress(0);
    var $author$project$Components$GlobalSearch$GlobalSearchTriggered = {
        $: 0
    };
    var $author$project$Components$GlobalSearch$LoggedOut = {
        $: 13
    };
    var $author$project$Components$GlobalSearch$ModalCloseClicked = {
        $: 1
    };
    var $author$project$Ports$GlobalSearch$globalSearchTriggeredPort = _Platform_incomingPort('globalSearchTriggeredPort', $elm$json$Json$Decode$null(0));
    var $author$project$Ports$GlobalSearch$globalSearchTriggered = function(toMsg) {
        return $author$project$Ports$GlobalSearch$globalSearchTriggeredPort($elm$core$Basics$always(toMsg));
    };
    var $author$project$Components$GlobalSearch$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ports$Session$sessionLoggedOut($author$project$Components$GlobalSearch$LoggedOut),
            function() {
                if (!model.$) return $author$project$Ports$GlobalSearch$globalSearchTriggered($author$project$Components$GlobalSearch$GlobalSearchTriggered);
                else {
                    var openModel = model.a;
                    return $elm$core$Platform$Sub$batch(_List_fromArray([
                        $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$GlobalSearch$ModalCloseClicked),
                        A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, $author$project$Ui$Nav$subscriptions, openModel.nb))
                    ]));
                }
            }()
        ]));
    };
    var $author$project$Components$OrganizationSwitcher$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ui$FlyoutMenu$subscriptions(model.mn),
            $author$project$Ui$Nav$subscriptions(model.nc)
        ]));
    };
    var $author$project$Components$PendingChangesModal$subscriptions = function(keepChangesMsg) {
        return $author$project$Ui$Modal$subscribeToEscapeKeyPress(keepChangesMsg);
    };
    var $author$project$Navbar$HinterViewUpdated = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Navbar$ScreenResized = {
        $: 5
    };
    var $elm$browser$Browser$Events$Window = 1;
    var $elm$browser$Browser$Events$onResize = function(func) {
        return A3($elm$browser$Browser$Events$on, 1, 'resize', A2($elm$json$Json$Decode$field, 'target', A3($elm$json$Json$Decode$map2, func, A2($elm$json$Json$Decode$field, 'innerWidth', $elm$json$Json$Decode$int), A2($elm$json$Json$Decode$field, 'innerHeight', $elm$json$Json$Decode$int))));
    };
    var $author$project$Ports$Navbar$sidenavHinterViewUpdatedPort = _Platform_incomingPort('sidenavHinterViewUpdatedPort', $elm$json$Json$Decode$bool);
    var $author$project$Ports$Navbar$sidenavHinterViewUpdated = function(toMsg) {
        return $author$project$Ports$Navbar$sidenavHinterViewUpdatedPort(toMsg);
    };
    var $author$project$Navbars$Company$SidenavLinkClicked = {
        $: 3
    };
    var $author$project$Ports$Navbar$onSidenavLinkClickedPort = _Platform_incomingPort('onSidenavLinkClickedPort', $elm$json$Json$Decode$null(0));
    var $author$project$Ports$Navbar$onSidenavLinkClicked = function(toMsg) {
        return $author$project$Ports$Navbar$onSidenavLinkClickedPort($elm$core$Basics$always(toMsg));
    };
    var $author$project$Navbars$Company$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Company$SidenavLinkClicked),
            $author$project$Ui$FlyoutMenu$subscriptions(model.et)
        ]));
    };
    var $author$project$Navbars$Partner$SidenavLinkClicked = {
        $: 3
    };
    var $author$project$Navbars$Partner$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Partner$SidenavLinkClicked),
            $author$project$Ui$FlyoutMenu$subscriptions(model.et)
        ]));
    };
    var $author$project$Navbars$Practice$CloseModal = {
        $: 5
    };
    var $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg = function(a) {
        return {
            $: 17,
            a: a
        };
    };
    var $author$project$Navbars$Practice$SidenavLinkClicked = {
        $: 12
    };
    var $author$project$Components$HinterPracticeSettingsModal$CloseModal = {
        $: 0
    };
    var $author$project$Components$HinterPracticeSettingsModal$subscriptions = function(model) {
        if (model.$ === 1) return $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Components$HinterPracticeSettingsModal$CloseModal);
        else return $elm$core$Platform$Sub$none;
    };
    var $author$project$Navbars$Practice$subscriptions = function(_v0) {
        var model = _v0;
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            model.yr ? $author$project$Ui$Modal$subscribeToEscapeKeyPress($author$project$Navbars$Practice$CloseModal) : $elm$core$Platform$Sub$none,
            A2($elm$core$Platform$Sub$map, $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg, $author$project$Components$HinterPracticeSettingsModal$subscriptions(model.iQ)),
            $author$project$Ui$FlyoutMenu$subscriptions(model.jR),
            $author$project$Ui$FlyoutMenu$subscriptions(model.hu),
            $author$project$Ui$FlyoutMenu$subscriptions(model.et),
            $author$project$Ports$Navbar$onSidenavLinkClicked($author$project$Navbars$Practice$SidenavLinkClicked),
            $author$project$Ui$Dropdown$subscriptions(model.oI)
        ]));
    };
    var $author$project$Navbar$subscriptions = function(_v0) {
        var model = _v0;
        var subs = function() {
            var _v3 = model.ad;
            switch(_v3.$){
                case 0:
                    return $elm$core$Platform$Sub$none;
                case 1:
                    var practiceNavModel = _v3.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Navbar$PracticeNavbarMsg, $author$project$Navbars$Practice$subscriptions(practiceNavModel));
                case 2:
                    var companyNavModel = _v3.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Navbar$CompanyNavbarMsg, $author$project$Navbars$Company$subscriptions(companyNavModel));
                default:
                    var partnerNavModel = _v3.a;
                    return A2($elm$core$Platform$Sub$map, $author$project$Navbar$PartnerNavbarMsg, $author$project$Navbars$Partner$subscriptions(partnerNavModel));
            }
        }();
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            subs,
            $author$project$Ports$Navbar$sidenavHinterViewUpdated($author$project$Navbar$HinterViewUpdated),
            $elm$browser$Browser$Events$onResize(F2(function(_v1, _v2) {
                return $author$project$Navbar$ScreenResized;
            }))
        ]));
    };
    var $author$project$Shared$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ports$Session$onAccessTokenUpdated($author$project$Shared$AccessTokenUpdated),
            $author$project$Ports$Session$onAccessTokenCreated($author$project$Shared$AccessTokenCreated),
            A2($elm$time$Time$every, $author$project$Shared$seconds(1), $author$project$Shared$GotCurrentTime),
            $author$project$Ports$Session$onLogoutWarning($author$project$Shared$ShowLogoutWarning),
            A2($elm$core$Platform$Sub$map, $author$project$Shared$GlobalSearchMsg, $author$project$Components$GlobalSearch$subscriptions(model.fP)),
            A2($elm$core$Platform$Sub$map, $author$project$Shared$AccountLockedModalMsg, $author$project$Components$AccountLockedModal$subscriptions),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Navbar$subscriptions, $elm$core$Platform$Sub$map($author$project$Shared$NavbarMsg)), model.ae)),
            $author$project$Ports$Session$sessionLoggedOut($author$project$Shared$LoggedOut),
            $author$project$Components$PendingChangesModal$subscriptions($author$project$Shared$PendingChangesKeep),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$PatientsList$subscriptions, $elm$core$Platform$Sub$map($author$project$Shared$PatientsListMsg)), model.af4)),
            A2($elm$core$Maybe$withDefault, $elm$core$Platform$Sub$none, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Components$OrganizationSwitcher$subscriptions, $elm$core$Platform$Sub$map($author$project$Shared$OrganizationSwitcherMsg)), model.gg))
        ]));
    };
    var $author$project$Spa$Generated$Pages$bundle = function(bigModel) {
        switch(bigModel.$){
            case 0:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DJ.a(model);
            case 1:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vO.a(model);
            case 2:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vP.a(model);
            case 3:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vW.a(model);
            case 4:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ap.a(model);
            case 5:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.xS.a(model);
            case 6:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x7.a(model);
            case 7:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yL.a(model);
            case 8:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yM.a(model);
            case 9:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.rD.a(model);
            case 10:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.z8.a(model);
            case 11:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vd.a(model);
            case 12:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vp.a(model);
            case 13:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wN.a(model);
            case 14:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.xN.a(model);
            case 15:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yZ.a(model);
            case 16:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AY.a(model);
            case 17:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bn.a(model);
            case 18:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Ds.a(model);
            case 19:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DD.a(model);
            case 20:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.tU.a(model);
            case 21:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t$.a(model);
            case 22:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t1.a(model);
            case 23:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t2.a(model);
            case 24:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t3.a(model);
            case 25:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t8.a(model);
            case 26:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uc.a(model);
            case 27:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ug.a(model);
            case 28:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uu.a(model);
            case 29:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uz.a(model);
            case 30:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uA.a(model);
            case 31:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uC.a(model);
            case 32:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uD.a(model);
            case 33:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uE.a(model);
            case 34:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uF.a(model);
            case 35:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uG.a(model);
            case 36:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uH.a(model);
            case 37:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uP.a(model);
            case 38:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uQ.a(model);
            case 39:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uS.a(model);
            case 40:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uT.a(model);
            case 41:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uZ.a(model);
            case 42:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u_.a(model);
            case 43:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u2.a(model);
            case 44:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u3.a(model);
            case 45:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u4.a(model);
            case 46:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u8.a(model);
            case 47:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u9.a(model);
            case 48:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.va.a(model);
            case 49:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vn.a(model);
            case 50:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vo.a(model);
            case 51:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.v7.a(model);
            case 52:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ws.a(model);
            case 53:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wM.a(model);
            case 54:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wQ.a(model);
            case 55:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wR.a(model);
            case 56:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.xM.a(model);
            case 57:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x1.a(model);
            case 58:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x2.a(model);
            case 59:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x3.a(model);
            case 60:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x4.a(model);
            case 61:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x5.a(model);
            case 62:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x6.a(model);
            case 63:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yk.a(model);
            case 64:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yl.a(model);
            case 65:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ym.a(model);
            case 66:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yT.a(model);
            case 67:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.y5.a(model);
            case 68:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.y6.a(model);
            case 69:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.y7.a(model);
            case 70:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.za.a(model);
            case 71:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zb.a(model);
            case 72:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zf.a(model);
            case 73:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zw.a(model);
            case 74:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zx.a(model);
            case 75:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zy.a(model);
            case 76:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zz.a(model);
            case 77:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zA.a(model);
            case 78:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zE.a(model);
            case 79:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zF.a(model);
            case 80:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zS.a(model);
            case 81:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Aj.a(model);
            case 82:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Ak.a(model);
            case 83:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.An.a(model);
            case 84:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Ao.a(model);
            case 85:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Aq.a(model);
            case 86:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Aw.a(model);
            case 87:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AE.a(model);
            case 88:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AZ.a(model);
            case 89:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bd.a(model);
            case 90:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Be.a(model);
            case 91:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bf.a(model);
            case 92:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bg.a(model);
            case 93:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bh.a(model);
            case 94:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bi.a(model);
            case 95:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bj.a(model);
            case 96:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bm.a(model);
            case 97:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BM.a(model);
            case 98:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BN.a(model);
            case 99:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BP.a(model);
            case 100:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BT.a(model);
            case 101:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BU.a(model);
            case 102:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BW.a(model);
            case 103:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BX.a(model);
            case 104:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BY.a(model);
            case 105:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BZ.a(model);
            case 106:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.B_.a(model);
            case 107:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.B$.a(model);
            case 108:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.B1.a(model);
            case 109:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.B3.a(model);
            case 110:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.B5.a(model);
            case 111:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CO.a(model);
            case 112:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CP.a(model);
            case 113:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CQ.a(model);
            case 114:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CR.a(model);
            case 115:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CS.a(model);
            case 116:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CT.a(model);
            case 117:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CU.a(model);
            case 118:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CV.a(model);
            case 119:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CW.a(model);
            case 120:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CX.a(model);
            case 121:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CY.a(model);
            case 122:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.CZ.a(model);
            case 123:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C_.a(model);
            case 124:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C$.a(model);
            case 125:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C0.a(model);
            case 126:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C1.a(model);
            case 127:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C2.a(model);
            case 128:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C3.a(model);
            case 129:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C4.a(model);
            case 130:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C5.a(model);
            case 131:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C6.a(model);
            case 132:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C7.a(model);
            case 133:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C8.a(model);
            case 134:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.C9.a(model);
            case 135:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Da.a(model);
            case 136:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Db.a(model);
            case 137:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dc.a(model);
            case 138:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dd.a(model);
            case 139:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.De.a(model);
            case 140:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Df.a(model);
            case 141:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dg.a(model);
            case 142:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dh.a(model);
            case 143:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Di.a(model);
            case 144:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dj.a(model);
            case 145:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dk.a(model);
            case 146:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dl.a(model);
            case 147:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dm.a(model);
            case 148:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dn.a(model);
            case 149:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Do.a(model);
            case 150:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dp.a(model);
            case 151:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dq.a(model);
            case 152:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dr.a(model);
            case 153:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dt.a(model);
            case 154:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Du.a(model);
            case 155:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dv.a(model);
            case 156:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dw.a(model);
            case 157:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Dy.a(model);
            case 158:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DB.a(model);
            case 159:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DU.a(model);
            case 160:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DV.a(model);
            case 161:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DX.a(model);
            case 162:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DY.a(model);
            case 163:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vy.a(model);
            case 164:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.xz.a(model);
            case 165:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yx.a(model);
            case 166:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yV.a(model);
            case 167:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t_.a(model);
            case 168:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t6.a(model);
            case 169:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ub.a(model);
            case 170:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uf.a(model);
            case 171:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.um.a(model);
            case 172:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uk.a(model);
            case 173:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ut.a(model);
            case 174:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uy.a(model);
            case 175:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uY.a(model);
            case 176:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u$.a(model);
            case 177:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u1.a(model);
            case 178:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u7.a(model);
            case 179:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wp.a(model);
            case 180:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wr.a(model);
            case 181:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wI.a(model);
            case 182:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wP.a(model);
            case 183:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x0.a(model);
            case 184:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yj.a(model);
            case 185:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.y9.a(model);
            case 186:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ze.a(model);
            case 187:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zv.a(model);
            case 188:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zD.a(model);
            case 189:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zK.a(model);
            case 190:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.z3.a(model);
            case 191:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Am.a(model);
            case 192:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Ap.a(model);
            case 193:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Av.a(model);
            case 194:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AW.a(model);
            case 195:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BL.a(model);
            case 196:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DC.a(model);
            case 197:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.DW.a(model);
            case 198:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.tV.a(model);
            case 199:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.tW.a(model);
            case 200:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.tX.a(model);
            case 201:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.tY.a(model);
            case 202:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.tZ.a(model);
            case 203:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t5.a(model);
            case 204:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t7.a(model);
            case 205:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ua.a(model);
            case 206:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ue.a(model);
            case 207:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uh.a(model);
            case 208:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uj.a(model);
            case 209:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.un.a(model);
            case 210:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uo.a(model);
            case 211:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.up.a(model);
            case 212:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uq.a(model);
            case 213:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.us.a(model);
            case 214:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uv.a(model);
            case 215:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uw.a(model);
            case 216:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ux.a(model);
            case 217:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uI.a(model);
            case 218:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uJ.a(model);
            case 219:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uK.a(model);
            case 220:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uL.a(model);
            case 221:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uN.a(model);
            case 222:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uO.a(model);
            case 223:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uR.a(model);
            case 224:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uX.a(model);
            case 225:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u0.a(model);
            case 226:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u6.a(model);
            case 227:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vb.a(model);
            case 228:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vf.a(model);
            case 229:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vi.a(model);
            case 230:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vj.a(model);
            case 231:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vk.a(model);
            case 232:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vl.a(model);
            case 233:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vm.a(model);
            case 234:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wo.a(model);
            case 235:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wq.a(model);
            case 236:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wt.a(model);
            case 237:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wu.a(model);
            case 238:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wy.a(model);
            case 239:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wz.a(model);
            case 240:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wC.a(model);
            case 241:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wD.a(model);
            case 242:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wE.a(model);
            case 243:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wF.a(model);
            case 244:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.y8.a(model);
            case 245:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zc.a(model);
            case 246:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zu.a(model);
            case 247:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zI.a(model);
            case 248:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.z4.a(model);
            case 249:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.z5.a(model);
            case 250:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.z6.a(model);
            case 251:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.z7.a(model);
            case 252:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Al.a(model);
            case 253:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Ar.a(model);
            case 254:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.As.a(model);
            case 255:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.At.a(model);
            case 256:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Au.a(model);
            case 257:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Ax.a(model);
            case 258:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Ay.a(model);
            case 259:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AK.a(model);
            case 260:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AL.a(model);
            case 261:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AM.a(model);
            case 262:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AN.a(model);
            case 263:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AO.a(model);
            case 264:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AS.a(model);
            case 265:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AX.a(model);
            case 266:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bl.a(model);
            case 267:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BO.a(model);
            case 268:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BQ.a(model);
            case 269:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BS.a(model);
            case 270:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BV.a(model);
            case 271:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.B0.a(model);
            case 272:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.B2.a(model);
            case 273:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.B4.a(model);
            case 274:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t4.a(model);
            case 275:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t9.a(model);
            case 276:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ud.a(model);
            case 277:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ul.a(model);
            case 278:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ui.a(model);
            case 279:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ur.a(model);
            case 280:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uB.a(model);
            case 281:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uU.a(model);
            case 282:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.u5.a(model);
            case 283:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.x$.a(model);
            case 284:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zt.a(model);
            case 285:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zB.a(model);
            case 286:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zG.a(model);
            case 287:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zJ.a(model);
            case 288:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BK.a(model);
            case 289:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.BR.a(model);
            case 290:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vh.a(model);
            case 291:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wn.a(model);
            case 292:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wx.a(model);
            case 293:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wB.a(model);
            case 294:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wJ.a(model);
            case 295:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zd.a(model);
            case 296:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AF.a(model);
            case 297:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AG.a(model);
            case 298:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AJ.a(model);
            case 299:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AR.a(model);
            case 300:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AU.a(model);
            case 301:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AV.a(model);
            case 302:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uM.a(model);
            case 303:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wj.a(model);
            case 304:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wk.a(model);
            case 305:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wv.a(model);
            case 306:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wH.a(model);
            case 307:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yR.a(model);
            case 308:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yS.a(model);
            case 309:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yU.a(model);
            case 310:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yW.a(model);
            case 311:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yX.a(model);
            case 312:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.yY.a(model);
            case 313:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zH.a(model);
            case 314:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AQ.a(model);
            case 315:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.Bk.a(model);
            case 316:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.t0.a(model);
            case 317:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.vg.a(model);
            case 318:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wA.a(model);
            case 319:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wG.a(model);
            case 320:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.zC.a(model);
            case 321:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AT.a(model);
            case 322:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wi.a(model);
            case 323:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wm.a(model);
            case 324:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wK.a(model);
            case 325:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AH.a(model);
            case 326:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AI.a(model);
            case 327:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.AP.a(model);
            case 328:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uV.a(model);
            case 329:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wg.a(model);
            case 330:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wh.a(model);
            case 331:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wL.a(model);
            case 332:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.uW.a(model);
            case 333:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wl.a(model);
            case 334:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.wf.a(model);
            default:
                var model = bigModel.a;
                return $author$project$Spa$Generated$Pages$pages.ww.a(model);
        }
    };
    var $author$project$Spa$Generated$Pages$subscriptions = function(model) {
        return $author$project$Spa$Generated$Pages$bundle(model).ahE(0);
    };
    var $author$project$Layouts$Admin$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Affiliates$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Affiliates$Affiliate$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Commissions$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Commissions$BrokerAccount$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Company$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Marketplace$Manage$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Partner$Billing$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Partner$Practices$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Partner$Product$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Partner$Webhooks$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$Patient$subscriptions = function(model) {
        return $author$project$Ui$Nav$subscriptions(model.nb);
    };
    var $author$project$Layouts$PatientChart$subscriptions = function(_v0) {
        return $elm$core$Platform$Sub$none;
    };
    var $author$project$Layouts$User$subscriptions = function(_v0) {
        var nav = _v0.nb;
        return $author$project$Ui$Nav$subscriptions(nav);
    };
    var $author$project$Spa$Layout$subscriptions = function(model) {
        switch(model.$){
            case 0:
                return $elm$core$Platform$Sub$none;
            case 1:
                return $elm$core$Platform$Sub$none;
            case 2:
                return $elm$core$Platform$Sub$none;
            case 3:
                var patientModel = model.b;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$PatientMsg, $author$project$Layouts$Patient$subscriptions(patientModel));
            case 4:
                var commissionsModel = model.a;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$CommissionsMsg, $author$project$Layouts$Commissions$subscriptions(commissionsModel));
            case 5:
                var brokerAccountModel = model.b;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$CommissionsBrokerAccountMsg, $author$project$Layouts$Commissions$BrokerAccount$subscriptions(brokerAccountModel));
            case 6:
                var affiliatesModel = model.a;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$AffiliatesMsg, $author$project$Layouts$Affiliates$subscriptions(affiliatesModel));
            case 20:
                return $elm$core$Platform$Sub$none;
            case 7:
                var affiliateModel = model.b;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$AffiliatesAffiliateMsg, $author$project$Layouts$Affiliates$Affiliate$subscriptions(affiliateModel));
            case 8:
                var billingModel = model.a;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$PartnerBillingMsg, $author$project$Layouts$Partner$Billing$subscriptions(billingModel));
            case 9:
                var practicesModel = model.a;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$PartnerPracticesMsg, $author$project$Layouts$Partner$Practices$subscriptions(practicesModel));
            case 10:
                var productModel = model.a;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$PartnerProductMsg, $author$project$Layouts$Partner$Product$subscriptions(productModel));
            case 11:
                var webhooksModel = model.a;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$PartnerWebhooksMsg, $author$project$Layouts$Partner$Webhooks$subscriptions(webhooksModel));
            case 12:
                var manageModel = model.b;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$MarketplaceManageMsg, $author$project$Layouts$Marketplace$Manage$subscriptions(manageModel));
            case 13:
                var companyModel = model.b;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$CompanyMsg, $author$project$Layouts$Company$subscriptions(companyModel));
            case 14:
                var adminModel = model.a;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$AdminMsg, $author$project$Layouts$Admin$subscriptions(adminModel));
            case 15:
                return $elm$core$Platform$Sub$none;
            case 16:
                return $elm$core$Platform$Sub$none;
            case 17:
                var patientChartModel = model.b;
                return $author$project$Layouts$PatientChart$subscriptions(patientChartModel);
            case 18:
                return $elm$core$Platform$Sub$none;
            default:
                var userModel = model.a;
                return A2($elm$core$Platform$Sub$map, $author$project$Spa$Layout$UserMsg, $author$project$Layouts$User$subscriptions(userModel));
        }
    };
    var $author$project$Main$subscriptions = function(model) {
        return $elm$core$Platform$Sub$batch(_List_fromArray([
            $author$project$Ports$Navigation$onUrlChange($author$project$Main$UrlChanged),
            $author$project$Ports$Navigation$onUrlRequest($author$project$Main$UrlRequested),
            A2($elm$core$Platform$Sub$map, $author$project$Main$Shared, $author$project$Shared$subscriptions(model.Cu)),
            A2($elm$core$Platform$Sub$map, $author$project$Main$Pages, $author$project$Spa$Generated$Pages$subscriptions(model.GM)),
            A2($elm$core$Platform$Sub$map, $author$project$Main$Layout, $author$project$Spa$Layout$subscriptions(model.ba))
        ]));
    };
    var $author$project$Spa$Document$toBrowserElement = function(doc) {
        return A2($elm$html$Html$div, _List_Nil, doc.fb);
    };
    var $author$project$Main$RequestLoadClinical = {
        $: 6
    };
    var $author$project$Main$AttemptedScrollingToFragment = F3(function(a, b, c) {
        return {
            $: 5,
            a: a,
            b: b,
            c: c
        };
    });
    var $elm$browser$Browser$Dom$setViewport = _Browser_setViewport;
    var $author$project$Utils$Scroll$toElementByIdWithDelay = F3(function(delay, elementId, toMsg) {
        return A2($elm$core$Task$attempt, toMsg, A2($elm$core$Task$andThen, function(_v1) {
            var element = _v1.adh;
            return A2($elm$browser$Browser$Dom$setViewport, 0, element.abv);
        }, A2($elm$core$Task$andThen, function(_v0) {
            return $elm$browser$Browser$Dom$getElement(elementId);
        }, $elm$core$Process$sleep(delay))));
    });
    var $author$project$Main$attemptScrollingToFragment = F2(function(attempts, fragment) {
        return attempts > 3 ? $elm$core$Platform$Cmd$none : A3($author$project$Utils$Scroll$toElementByIdWithDelay, 500, fragment, A2($author$project$Main$AttemptedScrollingToFragment, attempts + 1, fragment));
    });
    var $author$project$Ports$Clinical$dispatchLoadClinicalPort = _Platform_outgoingPort('dispatchLoadClinicalPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Clinical$load = $author$project$Ports$Clinical$dispatchLoadClinicalPort(0);
    var $author$project$Spa$Generated$Pages$load = function(model) {
        return $author$project$Spa$Generated$Pages$bundle(model).aeR(0);
    };
    var $author$project$Main$LoadClinicalDebounceMsg = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Main$loadClinicalDebounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(300),
        ah3: $author$project$Main$LoadClinicalDebounceMsg
    };
    var $author$project$Spa$Generated$Pages$save = function(model) {
        return $author$project$Spa$Generated$Pages$bundle(model).ag3(0);
    };
    var $author$project$Shared$OrgSwitcher$Company = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Shared$GotSessionCreated = F2(function(a, b) {
        return {
            $: 13,
            a: a,
            b: b
        };
    });
    var $author$project$Shared$GotUserPractices = F2(function(a, b) {
        return {
            $: 20,
            a: a,
            b: b
        };
    });
    var $author$project$Shared$OrgSwitcher$Patient = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Shared$OrgSwitcher$transitionToDefaultState = F3(function(session, hinterViewOff, reload) {
        return (reload ? $author$project$Utils$Route$navigateAndReload($elm$core$Dict$empty) : $author$project$Utils$Route$navigate($elm$core$Dict$empty))(A2($author$project$Permission$homeStateFor, session, hinterViewOff));
    });
    var $author$project$Shared$OrgSwitcher$redirect = F3(function(session, hinterViewOff, maybePending) {
        if (maybePending.$ === 1) return $elm$core$Platform$Cmd$none;
        else {
            var action = maybePending.a.D7;
            var _v1 = _Utils_Tuple2(session, action);
            if (_v1.a.$ === 3) switch(_v1.b.$){
                case 0:
                    var _v2 = _v1.a;
                    var session_ = _v2.a;
                    var _v3 = _v1.b;
                    return A3($author$project$Shared$OrgSwitcher$transitionToDefaultState, session_, hinterViewOff, false);
                case 3:
                    var _v4 = _v1.a;
                    var session_ = _v4.a;
                    var _v5 = _v1.b;
                    return A3($author$project$Shared$OrgSwitcher$transitionToDefaultState, session_, hinterViewOff, true);
                case 1:
                    var _v6 = _v1.a;
                    var route = _v1.b.a;
                    return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, route);
                case 2:
                    var _v7 = _v1.a;
                    var route = _v1.b.a;
                    return A2($author$project$Utils$Route$navigateAndReload, $elm$core$Dict$empty, route);
                default:
                    var _v8 = _v1.a;
                    var _v9 = _v1.b;
                    return $elm$core$Platform$Cmd$none;
            }
            else return $elm$core$Platform$Cmd$none;
        }
    });
    var $author$project$Shared$GotWhitelabelSetting = function(a) {
        return {
            $: 25,
            a: a
        };
    };
    var $author$project$Shared$retrieveWhitelabelSettings = F2(function(apiClient, session) {
        return A3($author$project$Api$WhitelabelSetting$retrieve, apiClient, session, $author$project$Shared$GotWhitelabelSetting);
    });
    var $author$project$Shared$applySession = F4(function(response, session, model, extraCmd) {
        var retrieveCompanyCmd = function() {
            var _v0 = model.n1;
            if (!_v0.$) {
                var companyId = _v0.a;
                return A4($author$project$Api$Company$retrieve, model.Ej, session, companyId, $author$project$Shared$GotCompany(companyId));
            } else return $elm$core$Platform$Cmd$none;
        }();
        var isClinicalSwitch = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(p) {
            return _Utils_eq(p.D7, $author$project$OutMsg$GoToClinicalAction);
        }, model.db));
        var orgSwitchRedirectCmd = isClinicalSwitch ? $elm$core$Platform$Cmd$none : A3($author$project$Shared$OrgSwitcher$redirect, response, model.aeb, model.db);
        return _Utils_Tuple2(_Utils_update(model, {
            afW: $author$project$Api$Platform$Session$One$organizationIsCompany(session),
            db: isClinicalSwitch ? model.db : $elm$core$Maybe$Nothing,
            n1: $elm$core$Maybe$Nothing,
            Z$: response
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            extraCmd,
            $author$project$Api$Platform$Session$One$organizationIsPartner(session) ? $author$project$Shared$retrievePartner(model.Ej) : $elm$core$Platform$Cmd$batch(_List_fromArray([
                A2($author$project$Shared$retrievePractice, model.Ej, session),
                A2($author$project$Shared$retrieveWhitelabelSettings, model.Ej, session)
            ])),
            retrieveCompanyCmd,
            orgSwitchRedirectCmd
        ])));
    });
    var $author$project$Ports$Intercom$intercomPortShutdown = _Platform_outgoingPort('intercomPortShutdown', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Intercom$shutdown = $author$project$Ports$Intercom$intercomPortShutdown(0);
    var $author$project$Shared$deidentifyForIntercom = $author$project$Ports$Intercom$shutdown;
    var $author$project$Ports$FullStory$fullStoryPortStopCapturing = _Platform_outgoingPort('fullStoryPortStopCapturing', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$FullStory$shutdown = $author$project$Ports$FullStory$fullStoryPortStopCapturing(0);
    var $author$project$Shared$deidentifyForSessionRecording = $author$project$Ports$FullStory$shutdown;
    var $author$project$Shared$deidentifyOnExternalServices = $elm$core$Platform$Cmd$batch(_List_fromArray([
        $author$project$Shared$deidentifyForIntercom,
        $author$project$Shared$deidentifyForSessionRecording
    ]));
    var $author$project$Ports$GlobalSearch$enableGlobalSearchShortcutPort = _Platform_outgoingPort('enableGlobalSearchShortcutPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$GlobalSearch$enableCoreGlobalSearchShortcut = $author$project$Ports$GlobalSearch$enableGlobalSearchShortcutPort(0);
    var $author$project$Shared$shouldEmbedClinical = function(practice) {
        if (practice.$ === 3) {
            var practice_ = practice.a;
            return $author$project$Api$Practice$hasClinicalAccount(practice_) && A2($author$project$Api$Practice$featureEnabled, 19, practice_);
        } else return false;
    };
    var $author$project$Shared$enableCoreGlobalSearchShortcutFn = function(_v0) {
        var model = _v0.a;
        var msg = _v0.b;
        return $author$project$Shared$shouldEmbedClinical(model.W1) ? _Utils_Tuple2(model, msg) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            msg,
            $author$project$Ports$GlobalSearch$enableCoreGlobalSearchShortcut
        ])));
    };
    var $author$project$Navbars$Company$extractOrgSwitcherMsg = function(msg) {
        if (msg.$ === 5) {
            var subMsg = msg.a;
            return $elm$core$Maybe$Just(subMsg);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Navbars$Partner$extractOrgSwitcherMsg = function(msg) {
        if (msg.$ === 5) {
            var subMsg = msg.a;
            return $elm$core$Maybe$Just(subMsg);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Navbars$Practice$extractOrgSwitcherMsg = function(msg) {
        if (msg.$ === 19) {
            var subMsg = msg.a;
            return $elm$core$Maybe$Just(subMsg);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Navbar$extractOrgSwitcherMsg = function(msg) {
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                return $author$project$Navbars$Practice$extractOrgSwitcherMsg(subMsg);
            case 1:
                var subMsg = msg.a;
                return $author$project$Navbars$Company$extractOrgSwitcherMsg(subMsg);
            case 2:
                var subMsg = msg.a;
                return $author$project$Navbars$Partner$extractOrgSwitcherMsg(subMsg);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Utils$Clinical$getDashboardUrl = F3(function(isUnifiedExperience, origin, emrHost) {
        return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + '/home';
    });
    var $author$project$Shared$OrgSwitcher$emrDashboardUrl = F3(function(practice, origin, emrHost) {
        return A3($author$project$Utils$Clinical$getDashboardUrl, A2($author$project$Api$Practice$featureEnabled, 19, practice), origin, emrHost);
    });
    var $author$project$Shared$handlePendingClinicalRedirect = F2(function(response, _v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        var _v1 = _Utils_Tuple2(model.db, response);
        if (!_v1.a.$ && _v1.b.$ === 3) {
            var action = _v1.a.a.D7;
            var _v2 = _v1.b;
            var practice = _v2.a;
            return _Utils_eq(action, $author$project$OutMsg$GoToClinicalAction) ? _Utils_Tuple2(_Utils_update(model, {
                db: $elm$core$Maybe$Nothing
            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmd,
                A3($author$project$Ports$Navigation$requestUrl, A3($author$project$Shared$OrgSwitcher$emrDashboardUrl, practice, model.adU.afY, model.adU.adm), false, false)
            ]))) : _Utils_Tuple2(model, cmd);
        } else return _Utils_Tuple2(model, cmd);
    });
    var $author$project$Ports$Intercom$intercomPortBoot = _Platform_outgoingPort('intercomPortBoot', $elm$core$Basics$identity);
    var $author$project$Api$Platform$User$Shared$intercomUserHash = function(_v0) {
        var record = _v0;
        return record.Rx;
    };
    var $author$project$Utils$User$isHinter = function(user) {
        return $author$project$Api$Platform$User$Shared$isAdmin(user) || A2($author$project$Utils$Regex$matches, '@hint\\.com$', $author$project$Api$Platform$User$Shared$email(user));
    };
    var $author$project$Ports$Intercom$boot = F3(function(intercomAppId, session, practice) {
        var user = $author$project$Api$Platform$Session$One$user(session);
        var userAttrs = _List_fromArray([
            _Utils_Tuple2('user_id', $elm$json$Json$Encode$string($author$project$Api$Platform$User$Shared$id(user))),
            _Utils_Tuple2('user_hash', $elm$json$Json$Encode$string($author$project$Api$Platform$User$Shared$intercomUserHash(user)))
        ]);
        var practiceAttrs = $author$project$Utils$User$isHinter(user) ? _List_Nil : _List_fromArray([
            _Utils_Tuple2('id', $elm$json$Json$Encode$string($author$project$Api$Practice$id(practice)))
        ]);
        var encoded = $elm$json$Json$Encode$object(A2($elm$core$List$cons, _Utils_Tuple2('app_id', $elm$json$Json$Encode$string(intercomAppId)), A2($elm$core$List$cons, _Utils_Tuple2('company', $elm$json$Json$Encode$object(practiceAttrs)), userAttrs)));
        return $author$project$Ports$Intercom$intercomPortBoot(encoded);
    });
    var $author$project$Shared$identifyForIntercom = function(_v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
            cmd,
            function() {
                var _v1 = _Utils_Tuple3(model.adU.aes, model.Z$, model.W1);
                if (!_v1.a.$ && _v1.b.$ === 3 && _v1.c.$ === 3) {
                    var intercomAppId = _v1.a.a;
                    var _v2 = _v1.b;
                    var session = _v2.a;
                    var _v3 = _v1.c;
                    var practice = _v3.a;
                    return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $author$project$Ports$Intercom$shutdown : A3($author$project$Ports$Intercom$boot, intercomAppId, session, practice);
                } else return $elm$core$Platform$Cmd$none;
            }()
        ])));
    };
    var $author$project$Api$Provider$Practice$Shared$createdAt = function(_v0) {
        var record = _v0;
        return record.Mx;
    };
    var $author$project$Api$Provider$Practice$One$createdAt = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Practice$Shared$createdAt(shared);
    };
    var $author$project$Api$Practice$createdAt = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $elm$core$Maybe$Just($author$project$Api$Provider$Practice$One$createdAt(practice_));
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Utils$Release$currentRelease = function(_v0) {
        var model = _v0;
        var _v1 = model.E0;
        if (_v1 === '') return $elm$core$Maybe$Nothing;
        else {
            var rest = _v1;
            return $elm$core$Maybe$Just(rest);
        }
    };
    var $author$project$Api$Employer$Practice$One$email = function(_v0) {
        var record = _v0;
        return record.OH;
    };
    var $author$project$Api$Practice$email = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$email(practice_);
        } else {
            var practice_ = practice.a;
            return $author$project$Api$Employer$Practice$One$email(practice_);
        }
    };
    var $author$project$Ports$FullStory$fullStoryPortBoot = _Platform_outgoingPort('fullStoryPortBoot', function($) {
        var a = $.a;
        var b = $.b;
        return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_fromArray([
            $elm$json$Json$Encode$string(a),
            $elm$core$Basics$identity(b)
        ]));
    });
    var $author$project$Ports$FullStory$boot = F3(function(session, practice, release) {
        var user = $author$project$Api$Platform$Session$One$user(session);
        var organizationAttrs = function() {
            var _v0 = $author$project$Api$Platform$Session$One$organization(session);
            if (!_v0.$) {
                var organization = _v0.a;
                return _List_fromArray([
                    _Utils_Tuple2('organization_type', $elm$json$Json$Encode$string($author$project$Api$OrganizationType$toString($author$project$Api$Platform$Organization$Shared$type_(organization)))),
                    _Utils_Tuple2('organization_id', $elm$json$Json$Encode$string($author$project$Api$Platform$Organization$Shared$id(organization)))
                ]);
            } else return _List_Nil;
        }();
        var defaultAttrs = _List_fromArray([
            _Utils_Tuple2('email', $elm$json$Json$Encode$string($author$project$Api$Platform$User$Shared$email(user))),
            _Utils_Tuple2('name', $elm$json$Json$Encode$string($author$project$Api$Platform$User$Shared$name(user))),
            _Utils_Tuple2('practice_id', $elm$json$Json$Encode$string($author$project$Api$Practice$id(practice))),
            _Utils_Tuple2('practice_name', $elm$json$Json$Encode$string($author$project$Api$Practice$name(practice))),
            _Utils_Tuple2('practice_created_at', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$int, A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, $author$project$Api$Practice$createdAt(practice)))),
            _Utils_Tuple2('practice_email', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, $author$project$Api$Practice$email(practice))),
            _Utils_Tuple2('practice_has_stripe_account', $elm$json$Json$Encode$bool($author$project$Api$Practice$paymentProcessor(practice) === 'stripe' && $author$project$Api$Practice$hasPaymentProcessorAccount(practice))),
            _Utils_Tuple2('practice_has_payment_processor_account', $elm$json$Json$Encode$bool($author$project$Api$Practice$hasPaymentProcessorAccount(practice))),
            _Utils_Tuple2('payment_processor', $elm$json$Json$Encode$string($author$project$Api$Practice$paymentProcessor(practice))),
            _Utils_Tuple2('soft_version', A2($author$project$Utils$Encode$nullable, $elm$json$Json$Encode$string, $author$project$Utils$Release$currentRelease(release)))
        ]);
        var userAttrs = $elm$json$Json$Encode$object(_Utils_ap(defaultAttrs, organizationAttrs));
        return $author$project$Ports$FullStory$fullStoryPortBoot(_Utils_Tuple2($author$project$Api$Platform$User$Shared$id(user), userAttrs));
    });
    var $author$project$Ports$Sentry$sentrySetContext = _Platform_outgoingPort('sentrySetContext', $elm$core$Basics$identity);
    var $author$project$Ports$Sentry$setContext = F2(function(user, practice) {
        var contextAttrs = $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('user_id', $elm$json$Json$Encode$string($author$project$Api$Platform$User$Shared$id(user))),
            _Utils_Tuple2('practice_id', $elm$json$Json$Encode$string($author$project$Api$Practice$id(practice)))
        ]));
        return $author$project$Ports$Sentry$sentrySetContext(contextAttrs);
    });
    var $author$project$Shared$identifyForSessionRecording = function(_v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        var _v1 = _Utils_Tuple2(model.Z$, model.W1);
        if (_v1.a.$ === 3 && _v1.b.$ === 3) {
            var _v2 = _v1.a;
            var session = _v2.a;
            var _v3 = _v1.b;
            var practice = _v3.a;
            var user = $author$project$Api$Platform$Session$One$user(session);
            return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                cmd,
                A3($author$project$Ports$FullStory$boot, session, practice, model.agH),
                A2($author$project$Ports$Sentry$setContext, user, practice)
            ])));
        } else return _Utils_Tuple2(model, cmd);
    };
    var $author$project$Shared$identifyOnExternalServices = function(_v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return $author$project$Shared$identifyForSessionRecording($author$project$Shared$identifyForIntercom(_Utils_Tuple2(model, cmd)));
    };
    var $author$project$Components$OrganizationSwitcher$FlyoutMenuMsg = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$OrganizationSwitcher$GotOrganizations = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$OrganizationSwitcher$Live = 0;
    var $author$project$Components$OrganizationSwitcher$Model = $elm$core$Basics$identity;
    var $author$project$Components$OrganizationSwitcher$NavMsg = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$OrganizationSwitcher$Sandbox = 1;
    var $author$project$Api$Platform$User$Organization$Organization = $elm$core$Basics$identity;
    var $author$project$Api$Platform$User$Organization$Record = F5(function(id, name, organizationId, type_, sandbox) {
        return {
            aef: id,
            zr: name,
            afV: organizationId,
            Zn: sandbox,
            ah5: type_
        };
    });
    var $author$project$Api$Platform$User$Organization$decoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'sandbox', $elm$json$Json$Decode$bool, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $author$project$Api$OrganizationType$decoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'organization_id', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'name', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Platform$User$Organization$Record)))))));
    var $author$project$Api$Platform$User$Organization$organizationsPath = A2($author$project$Api$Data$pathAppend, _List_fromArray([
        'organizations'
    ]), $author$project$Api$Platform$User$userPath);
    var $author$project$Api$Platform$User$Organization$list = F2(function(apiClient, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Platform$User$Organization$decoder), toMsg, $author$project$Api$Data$requestTo($author$project$Api$Platform$User$Organization$organizationsPath));
    });
    var $author$project$Components$OrganizationSwitcher$init = F2(function(apiClient, options) {
        var _v0 = A2($author$project$Ui$Nav$init, 'org-switcher-nav', $author$project$Components$OrganizationSwitcher$NavMsg);
        var navModel = _v0.a;
        var navCmd = _v0.b;
        return _Utils_Tuple2({
            qC: options.Zn ? 1 : 0,
            mn: A2($author$project$Ui$FlyoutMenu$init, 'org-switcher', $author$project$Components$OrganizationSwitcher$FlyoutMenuMsg),
            nc: navModel,
            rM: $author$project$Api$Data$Loading
        }, $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Platform$User$Organization$list, apiClient, $author$project$Components$OrganizationSwitcher$GotOrganizations),
            navCmd
        ])));
    });
    var $author$project$Shared$initializePatientsList = function(_v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        var _v1 = model.af4;
        if (_v1.$ === 1) {
            var _v2 = _Utils_Tuple3(model.Z$, model.W1, model.qY);
            if (_v2.a.$ === 3 && _v2.b.$ === 3 && !_v2.b.a.$ && !_v2.c.$) {
                var _v3 = _v2.a;
                var session = _v3.a;
                var _v4 = _v2.b;
                var practice = _v4.a.a;
                var query = _v2.c.a;
                var _v5 = A4($author$project$Components$PatientsList$init, session, practice, model.lL, {
                    Ej: model.Ej,
                    Bz: query,
                    HO: model.HO,
                    HP: model.HP,
                    aaT: model.aaT
                });
                var patientsListModel = _v5.a;
                var patientsListCmd = _v5.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    qY: $elm$core$Maybe$Nothing,
                    af4: $elm$core$Maybe$Just(patientsListModel)
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    cmd,
                    A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, patientsListCmd)
                ])));
            } else return _Utils_Tuple2(model, cmd);
        } else return _Utils_Tuple2(model, cmd);
    };
    var $author$project$Shared$navigateToErrorPage = function(error) {
        return A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, $author$project$Spa$Generated$Route$Error__Status_String({
            ahy: $author$project$Api$Data$errorToStatus(error)
        }));
    };
    var $author$project$Utils$Route$navigateWithFragment = F3(function(params, fragment, route) {
        return $author$project$Ports$Navigation$pushUrl(_Utils_ap(A2($author$project$Utils$Route$toString, params, route), A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(f) {
            return '#' + f;
        }, fragment))));
    });
    var $author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction = function(switchOrganizationFrom) {
        return $author$project$OutMsg$GoToRouteAndReloadAction(function() {
            switch(switchOrganizationFrom.$){
                case 0:
                    var id = switchOrganizationFrom.a;
                    return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                        V8: id
                    });
                case 1:
                    var id = switchOrganizationFrom.a;
                    return $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                        fl: id
                    });
                case 2:
                    var route = switchOrganizationFrom.a;
                    return route;
                default:
                    var route = switchOrganizationFrom.a;
                    return route;
            }
        }());
    };
    var $author$project$Shared$practiceChanged = F2(function(oldPractice, newPractice) {
        var _v0 = _Utils_Tuple2(oldPractice, newPractice);
        _v0$2: while(true)if (!_v0.a.$) {
            if (!_v0.b.$) return !_Utils_eq($author$project$Api$Practice$id(oldPractice), $author$project$Api$Practice$id(newPractice));
            else break _v0$2;
        } else {
            if (_v0.b.$ === 1) return !_Utils_eq($author$project$Api$Practice$id(oldPractice), $author$project$Api$Practice$id(newPractice));
            else break _v0$2;
        }
        return true;
    });
    var $author$project$Shared$requestLoadEmbeddedClinical = function(_v0) {
        var model = _v0.a;
        var cmd = _v0.b;
        return $author$project$Shared$shouldEmbedClinical(model.W1) ? _Utils_Tuple2(_Utils_update(model, {
            Wy: true
        }), cmd) : _Utils_Tuple2(model, cmd);
    };
    var $author$project$Api$WhitelabelSetting$practiceFacingFaviconAppleUrl = function(_v0) {
        var record = _v0;
        return record.GY;
    };
    var $author$project$Api$WhitelabelSetting$practiceFacingFaviconIcoUrl = function(_v0) {
        var record = _v0;
        return record.GZ;
    };
    var $author$project$Api$WhitelabelSetting$practiceFacingFaviconPngUrl = function(_v0) {
        var record = _v0;
        return record.G_;
    };
    var $author$project$Ports$Favicon$setFaviconPort = _Platform_outgoingPort('setFaviconPort', function($) {
        return $elm$json$Json$Encode$object(_List_fromArray([
            _Utils_Tuple2('appleUrl', $elm$json$Json$Encode$string($.Jx)),
            _Utils_Tuple2('icoUrl', $elm$json$Json$Encode$string($.QY)),
            _Utils_Tuple2('pngUrl', $elm$json$Json$Encode$string($.WS))
        ]));
    });
    var $author$project$Shared$setFaviconUrls = function(whitelabelSetting) {
        var pngUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconPngUrl(whitelabelSetting);
        var icoUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconIcoUrl(whitelabelSetting);
        var appleUrl = $author$project$Api$WhitelabelSetting$practiceFacingFaviconAppleUrl(whitelabelSetting);
        return $author$project$Ports$Favicon$setFaviconPort({
            Jx: appleUrl,
            QY: icoUrl,
            WS: pngUrl
        });
    };
    var $author$project$Shared$GotUserPartners = F2(function(a, b) {
        return {
            $: 21,
            a: a,
            b: b
        };
    });
    var $author$project$Shared$OrgSwitcher$PartnerQueryParam = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Shared$OrgSwitcher$PracticeQueryParam = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Shared$switchToPracticeWithQueryParam = F3(function(apiClient, backupAuthEnabled, url) {
        var query = A2($elm$core$Maybe$withDefault, $elm$core$Dict$empty, A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, url.Bz));
        var practiceId = A2($elm$core$Dict$get, 'switch-to-practice', query);
        var partnerId = A2($elm$core$Dict$get, 'switch-to-partner', query);
        var _v0 = _Utils_Tuple3(backupAuthEnabled, practiceId, partnerId);
        _v0$4: while(true){
            if (_v0.a) {
                if (!_v0.b.$) {
                    var practiceId_ = _v0.b.a;
                    return A4($author$project$Api$Auth$switchToOrganization, apiClient, practiceId_, $elm$core$Maybe$Nothing, $author$project$Shared$BackupAuthOrganizationSwitched($author$project$OutMsg$GoToRouteAndReloadAction($author$project$Utils$Route$fromUrl(url))));
                } else {
                    if (!_v0.c.$) {
                        var partnerId_ = _v0.c.a;
                        return A4($author$project$Api$Auth$switchToOrganization, apiClient, partnerId_, $elm$core$Maybe$Nothing, $author$project$Shared$BackupAuthOrganizationSwitched($author$project$OutMsg$GoToRouteAndReloadAction($author$project$Utils$Route$fromUrl(url))));
                    } else break _v0$4;
                }
            } else if (!_v0.b.$) {
                var practiceId_ = _v0.b.a;
                return A4($author$project$Api$Platform$User$Practice$list, apiClient, function(d) {
                    return _Utils_update(d, {
                        agq: $elm$core$Maybe$Just(practiceId_)
                    });
                }, $elm$core$Maybe$Nothing, $author$project$Shared$GotUserPractices($author$project$Shared$OrgSwitcher$PracticeQueryParam($author$project$Utils$Route$fromUrl(url))));
            } else {
                if (!_v0.c.$) {
                    var partnerId_ = _v0.c.a;
                    return A4($author$project$Api$Platform$User$Partner$list, apiClient, function(d) {
                        return _Utils_update(d, {
                            agq: $elm$core$Maybe$Just(partnerId_)
                        });
                    }, $elm$core$Maybe$Nothing, $author$project$Shared$GotUserPartners($author$project$Shared$OrgSwitcher$PartnerQueryParam($author$project$Utils$Route$fromUrl(url))));
                } else break _v0$4;
            }
        }
        var _v1 = _v0.b;
        var _v2 = _v0.c;
        return $elm$core$Platform$Cmd$none;
    });
    var $author$project$Components$AccountLockedModal$update = function(msg) {
        return $elm$core$Platform$Cmd$none;
    };
    var $author$project$Components$GlobalSearch$NavMsg = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$GlobalSearch$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$GlobalSearch$SearchInputFocused = {
        $: 7
    };
    var $author$project$Components$GlobalSearch$DebounceMsg = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$GlobalSearch$debounceConfig = {
        ahA: $jinjor$elm_debounce$Debounce$later(300),
        ah3: $author$project$Components$GlobalSearch$DebounceMsg
    };
    var $author$project$Ports$GlobalSearch$openClinicalSearchPort = _Platform_outgoingPort('openClinicalSearchPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$GlobalSearch$openClinicalSearch = $author$project$Ports$GlobalSearch$openClinicalSearchPort(0);
    var $author$project$Api$Provider$Search$Min$path = function(_v0) {
        var record = _v0;
        return record.V6;
    };
    var $author$project$Api$Provider$Search$All$path = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Search$Min$path(min);
    };
    var $author$project$Api$Provider$SearchPermissions$Shared$attributes = function(_v0) {
        var record = _v0;
        return record.vD;
    };
    var $author$project$Api$Provider$SearchPermissions$All$attributes = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SearchPermissions$Shared$attributes(shared);
    };
    var $author$project$Api$Provider$SearchPermissions$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$SearchPermissions$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SearchPermissions$Shared$id(shared);
    };
    var $author$project$Api$Provider$SearchPermissions$Shared$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Provider$SearchPermissions$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SearchPermissions$Shared$name(shared);
    };
    var $author$project$Api$Provider$SearchPermissions$Shared$searchable = function(_v0) {
        var record = _v0;
        return record.ZA;
    };
    var $author$project$Api$Provider$SearchPermissions$All$searchable = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$SearchPermissions$Shared$searchable(shared);
    };
    var $author$project$Components$GlobalSearch$permissionToPermissionType = function(permission) {
        return {
            vD: A2($elm$core$List$map, function(attr) {
                return $elm$core$String$toLower($author$project$Formatters$String$humanize(attr));
            }, $author$project$Api$Provider$SearchPermissions$All$attributes(permission)),
            aef: $author$project$Api$Provider$SearchPermissions$All$id(permission),
            zr: $author$project$Formatters$String$pluralOf($author$project$Api$Provider$SearchPermissions$All$name(permission)),
            ZA: $author$project$Api$Provider$SearchPermissions$All$searchable(permission)
        };
    };
    var $author$project$Components$GlobalSearch$GotSearchResult = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Api$Provider$Search$All$Search = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Search$Min$Search = $elm$core$Basics$identity;
    var $author$project$Api$Provider$Search$Min$Record = F6(function(id, label, secondaryLabel, type_, path, status) {
        return {
            aef: id,
            aeI: label,
            V6: path,
            ZB: secondaryLabel,
            ahy: status,
            ah5: type_
        };
    });
    var $author$project$Api$Provider$Search$Min$recordDecoder = A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'status', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'path', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'type', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'secondary_label', $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string), A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'label', $elm$json$Json$Decode$string, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required, 'id', $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Search$Min$Record)))))));
    var $author$project$Api$Provider$Search$Min$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Search$Min$recordDecoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Search$All$decoder = A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Search$Min$decoder, $elm$json$Json$Decode$succeed($elm$core$Basics$identity));
    var $author$project$Api$Provider$Search$listDefaults = {
        af_: $elm$core$Maybe$Just($author$project$Api$Pagination$init)
    };
    var $author$project$Api$Provider$Search$listOptionsToParams = function(optionals) {
        var options = optionals($author$project$Api$Provider$Search$listDefaults);
        var _v0 = options.af_;
        if (!_v0.$) {
            var pagination = _v0.a;
            return $author$project$Api$Pagination$toApiParams(pagination);
        } else return _List_Nil;
    };
    var $author$project$Api$Provider$Search$search = F5(function(apiClient, term, filter, optionals, toMsg) {
        var queryParams = function() {
            if (!filter.$) {
                var string = filter.a;
                return _List_fromArray([
                    A2($author$project$Api$Param$string, 'q', term),
                    A2($author$project$Api$Param$string, 'type', string)
                ]);
            } else return _List_fromArray([
                A2($author$project$Api$Param$string, 'q', term)
            ]);
        }();
        return A4($author$project$Api$Data$get, apiClient, $elm$json$Json$Decode$list($author$project$Api$Provider$Search$All$decoder), toMsg, A2($author$project$Api$Data$requestWithQuery, $author$project$Api$Provider$Search$listOptionsToParams(optionals), A2($author$project$Api$Data$requestWithQuery, queryParams, $author$project$Api$Data$requestTo($author$project$Api$Provider$Search$path))));
    });
    var $author$project$Components$GlobalSearch$search = F4(function(apiClient, model, maybeFilter, term) {
        return A5($author$project$Api$Provider$Search$search, apiClient, term, maybeFilter, function(d) {
            return _Utils_update(d, {
                af_: $elm$core$Maybe$Just(model.af_)
            });
        }, $author$project$Components$GlobalSearch$GotSearchResult);
    });
    var $author$project$Components$GlobalSearch$update = F5(function(apiClient, _v0, practice, msg, model) {
        if (model.$ === 1) {
            var openModel = model.a;
            switch(msg.$){
                case 0:
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 1:
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Closed({
                        aaT: openModel.aaT
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                case 8:
                    var navMsg = msg.a;
                    var _v3 = openModel.nb;
                    if (!_v3.$) {
                        var nav = _v3.a;
                        var _v4 = A2($author$project$Ui$Nav$update, navMsg, nav);
                        var updatedNav = _v4.a;
                        var navCmd = _v4.b;
                        return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                            nb: $elm$core$Maybe$Just(updatedNav)
                        })), A2($elm$core$Platform$Cmd$map, $author$project$Components$GlobalSearch$NavMsg, navCmd), _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 9:
                    var tabId = msg.a;
                    var searchInputFocusedCmd = A2($elm$core$Task$attempt, function(_v8) {
                        return $author$project$Components$GlobalSearch$SearchInputFocused;
                    }, $elm$browser$Browser$Dom$focus('global-search-input'));
                    var filter = function() {
                        if (tabId === 'all') return $elm$core$Maybe$Nothing;
                        else return $elm$core$Maybe$Just(tabId);
                    }();
                    var _v5 = openModel.eP;
                    if (_v5 === '') return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                        Fw: filter
                    })), searchInputFocusedCmd, _List_Nil);
                    else {
                        var _v6 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$GlobalSearch$debounceConfig, openModel.eP, openModel.dJ);
                        var debouncer = _v6.a;
                        var cmd = _v6.b;
                        return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                            dJ: debouncer,
                            Fw: filter,
                            af_: $author$project$Api$Pagination$init
                        })), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            searchInputFocusedCmd,
                            cmd
                        ])), _List_Nil);
                    }
                case 2:
                    var term = msg.a;
                    var _v9 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$GlobalSearch$debounceConfig, term, openModel.dJ);
                    var debouncer = _v9.a;
                    var cmd = _v9.b;
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                        N: -1,
                        dJ: debouncer,
                        af_: $author$project$Api$Pagination$init,
                        eP: term
                    })), cmd, _List_Nil);
                case 3:
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                        N: -1,
                        dJ: $jinjor$elm_debounce$Debounce$init,
                        af_: $author$project$Api$Pagination$init,
                        Y_: $author$project$Api$Data$NotAsked,
                        eP: ''
                    })), A2($elm$core$Task$attempt, function(_v10) {
                        return $author$project$Components$GlobalSearch$SearchInputFocused;
                    }, $elm$browser$Browser$Dom$focus('global-search-input')), _List_Nil);
                case 4:
                    var debounceMsg = msg.a;
                    var _v11 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Components$GlobalSearch$debounceConfig, $jinjor$elm_debounce$Debounce$takeLast(A3($author$project$Components$GlobalSearch$search, apiClient, openModel, openModel.Fw)), debounceMsg, openModel.dJ);
                    var debouncer = _v11.a;
                    var cmd = _v11.b;
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                        dJ: debouncer
                    })), cmd, _List_Nil);
                case 5:
                    var response = msg.a;
                    if (response.$ === 3) {
                        var headers = response.b;
                        return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                            N: 0,
                            af_: A2($author$project$Api$Pagination$totalCountFromHeaders, headers, openModel.af_),
                            Y_: response,
                            Ci: openModel.Ci + 1
                        })), $elm$core$Platform$Cmd$none, _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                case 14:
                    var response = msg.a;
                    if (response.$ === 3) {
                        var permissions = response.a;
                        var searchableTypeList = A2($elm$core$List$filter, function($) {
                            return $.ZA;
                        }, A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions));
                        var _v14 = A2($author$project$Ui$Nav$init, 'search-tabs', $author$project$Components$GlobalSearch$NavMsg);
                        var navModel = _v14.a;
                        var navCmd = _v14.b;
                        var _v15 = function() {
                            if ($elm$core$List$length(searchableTypeList) > 1) return _Utils_Tuple2($elm$core$Maybe$Nothing, 'all');
                            else {
                                var _default = A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, function(elem) {
                                    return elem.aef;
                                }, $elm$core$List$head(searchableTypeList)));
                                return _Utils_Tuple2($elm$core$Maybe$Just(_default), _default);
                            }
                        }();
                        var filter = _v15.a;
                        return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                            Fw: filter,
                            nb: $elm$core$Maybe$Just(navModel),
                            r4: response
                        })), navCmd, _List_Nil);
                    } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
                case 6:
                    var subMsg = msg.a;
                    var pagination = A2($author$project$Api$Pagination$update, subMsg, openModel.af_);
                    var newModel = _Utils_update(openModel, {
                        af_: pagination
                    });
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(newModel), A4($author$project$Components$GlobalSearch$search, apiClient, newModel, newModel.Fw, newModel.eP), _List_Nil);
                case 7:
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                case 12:
                    var key = msg.a;
                    var resultsCount = function() {
                        var _v20 = openModel.Y_;
                        if (_v20.$ === 3) {
                            var results = _v20.a;
                            return $elm$core$List$length(results);
                        } else return 0;
                    }();
                    switch(key){
                        case 13:
                            var _v17 = function() {
                                var _v18 = openModel.Y_;
                                if (_v18.$ === 3) {
                                    var results = _v18.a;
                                    return openModel.N >= 0 ? _Utils_Tuple2(A2($elm_community$list_extra$List$Extra$getAt, openModel.N, results), openModel.N) : $elm$core$List$length(results) > 0 ? _Utils_Tuple2(A2($elm_community$list_extra$List$Extra$getAt, 0, results), 0) : _Utils_Tuple2($elm$core$Maybe$Nothing, -1);
                                } else return _Utils_Tuple2($elm$core$Maybe$Nothing, -1);
                            }();
                            var maybeSelectedDoc = _v17.a;
                            if (!maybeSelectedDoc.$) {
                                var selectedDoc = maybeSelectedDoc.a;
                                return openModel.N >= 0 ? _Utils_Tuple3($author$project$Components$GlobalSearch$Closed({
                                    aaT: openModel.aaT
                                }), A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, $author$project$Utils$Route$navigate($elm$core$Dict$empty), A2($elm$core$Maybe$map, $author$project$Utils$Route$fromUrl, $elm$url$Url$fromString(A2($elm$core$String$append, 'https://app.hint.com', $author$project$Api$Provider$Search$All$path(selectedDoc)))))), _List_Nil) : _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                                    N: 0
                                })), $elm$core$Platform$Cmd$none, _List_Nil);
                            } else return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(openModel), $elm$core$Platform$Cmd$none, _List_Nil);
                        case 38:
                            var newIndex = resultsCount > 0 ? _Utils_eq(openModel.N, -1) ? resultsCount - 1 : A2($elm$core$Basics$modBy, resultsCount, openModel.N - 1) : -1;
                            return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                                N: newIndex
                            })), $elm$core$Platform$Cmd$none, _List_Nil);
                        case 40:
                            var newIndex = resultsCount > 0 ? A2($elm$core$Basics$modBy, resultsCount, openModel.N + 1) : -1;
                            return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                                N: newIndex
                            })), $elm$core$Platform$Cmd$none, _List_Nil);
                        default:
                            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                    }
                case 11:
                    var index = msg.a;
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                        N: index
                    })), $elm$core$Platform$Cmd$none, _List_Nil);
                case 10:
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Closed({
                        aaT: openModel.aaT
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                default:
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Closed({
                        aaT: openModel.aaT
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
            }
        } else {
            var url = model.a.aaT;
            var _v21 = _Utils_Tuple2(msg, $author$project$Api$Data$clientHasAuthToken(apiClient));
            _v21$2: while(true)switch(_v21.a.$){
                case 0:
                    if (_v21.b) {
                        var _v22 = _v21.a;
                        var useClinicalSearch = function() {
                            if (practice.$ === 3) {
                                var practice_ = practice.a;
                                return $author$project$Api$Practice$hasClinicalAccount(practice_) && A2($author$project$Api$Practice$featureEnabled, 19, practice_);
                            } else return false;
                        }();
                        var _v23 = function() {
                            if (useClinicalSearch) return _Utils_Tuple2(model, $author$project$Ports$GlobalSearch$openClinicalSearch);
                            else {
                                var searchPermissionsCmd = A2($author$project$Api$Provider$Search$permissions, apiClient, $author$project$Components$GlobalSearch$GotSearchPermissions);
                                var openModalModel = $author$project$Components$GlobalSearch$Open({
                                    N: -1,
                                    dJ: $jinjor$elm_debounce$Debounce$init,
                                    Fw: $elm$core$Maybe$Nothing,
                                    nb: $elm$core$Maybe$Nothing,
                                    af_: $author$project$Api$Pagination$init,
                                    r4: $author$project$Api$Data$NotAsked,
                                    Y_: $author$project$Api$Data$NotAsked,
                                    Ci: 0,
                                    eP: '',
                                    aaT: url
                                });
                                var openModalCmds = $elm$core$Platform$Cmd$batch(_List_fromArray([
                                    A2($elm$core$Task$attempt, function(_v24) {
                                        return $author$project$Components$GlobalSearch$SearchInputFocused;
                                    }, $elm$browser$Browser$Dom$focus('global-search-input')),
                                    searchPermissionsCmd
                                ]));
                                return _Utils_Tuple2(openModalModel, openModalCmds);
                            }
                        }();
                        var newModel = _v23.a;
                        var newCmds = _v23.b;
                        return _Utils_Tuple3(newModel, newCmds, _List_Nil);
                    } else break _v21$2;
                case 13:
                    var _v26 = _v21.a;
                    return _Utils_Tuple3($author$project$Components$GlobalSearch$Closed({
                        aaT: url
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                default:
                    break _v21$2;
            }
            return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Components$OrganizationSwitcher$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    rM: response
                }), $elm$core$Platform$Cmd$none, function() {
                    if (response.$ === 2 && response.a.$ === 6 && response.a.b === 'Too many organizations') {
                        var _v3 = response.a;
                        return _List_Nil;
                    } else return $author$project$OutMsg$handleErrorResponse(response);
                }());
            case 1:
                var env = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    qC: env
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var subMsg = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    mn: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.mn)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var subMsg = msg.a;
                var _v4 = A2($author$project$Ui$Nav$update, subMsg, model.nc);
                var newNavModel = _v4.a;
                var navCmd = _v4.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    nc: newNavModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Components$OrganizationSwitcher$NavMsg, navCmd), _List_Nil);
            default:
                var organizationId = msg.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToDefaultStateAndReloadAction)
                ]));
        }
    });
    var $author$project$Navbar$SandboxAlertMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Ports$Navbar$topnavHeaderHeightChangedPort = _Platform_outgoingPort('topnavHeaderHeightChangedPort', $elm$json$Json$Encode$float);
    var $author$project$Components$SandboxAlert$update = function(msg) {
        var organizationType = msg.a;
        var organizationId = msg.b;
        var postOrganizationSwitchedAction = function() {
            if (organizationType === 2) return $author$project$OutMsg$GoToRouteAndReloadAction($author$project$Spa$Generated$Route$Partner__Sandboxes__Top);
            else return $author$project$OutMsg$GoToDefaultStateAndReloadAction;
        }();
        return _Utils_Tuple2($elm$core$Platform$Cmd$none, _List_fromArray([
            A3($author$project$OutMsg$SwitchToOrganization, organizationId, $elm$core$Maybe$Nothing, postOrganizationSwitchedAction)
        ]));
    };
    var $author$project$Ports$Navbar$sidenavLinkClickedPort = _Platform_outgoingPort('sidenavLinkClickedPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Navbar$sidenavLinkClicked = $author$project$Ports$Navbar$sidenavLinkClickedPort(0);
    var $author$project$Navbars$Company$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: 1,
                    et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg)
                }), $author$project$Ports$Navbar$sidenavLinkClicked);
            case 1:
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: 1,
                    et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg)
                }), $author$project$Ports$Session$logout({
                    agy: true
                }));
            case 2:
                var checked = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: checked ? $author$project$Navbars$Company$openSubNavFromSelectedNav(model.eI) : 1,
                    oz: checked
                }), $elm$core$Platform$Cmd$none);
            case 3:
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: 1,
                    oz: false
                }), $elm$core$Platform$Cmd$none);
            case 4:
                var subnav = msg.a;
                var newOpenSubNav = _Utils_eq(subnav, model.c5) ? 1 : subnav;
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: newOpenSubNav
                }), $elm$core$Platform$Cmd$none);
            case 5:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            default:
                var subMsg = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    et: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.et)
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Navbars$Partner$update = F2(function(msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: 1,
                    et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg)
                }), $author$project$Ports$Navbar$sidenavLinkClicked);
            case 1:
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: 1,
                    et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg)
                }), $author$project$Ports$Session$logout({
                    agy: true
                }));
            case 2:
                var checked = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: checked ? $author$project$Navbars$Partner$openSubNavFromSelectedNav(model.eI) : 1,
                    oz: checked
                }), $elm$core$Platform$Cmd$none);
            case 3:
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: 1,
                    oz: false
                }), $elm$core$Platform$Cmd$none);
            case 4:
                var subnav = msg.a;
                var newOpenSubNav = _Utils_eq(subnav, model.c5) ? 1 : subnav;
                return _Utils_Tuple2(_Utils_update(model, {
                    c5: newOpenSubNav
                }), $elm$core$Platform$Cmd$none);
            case 5:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            default:
                var subMsg = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    et: A2($author$project$Ui$FlyoutMenu$update, subMsg, model.et)
                }), $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Navbars$Practice$GotPracticeRefresh = function(a) {
        return {
            $: 22,
            a: a
        };
    };
    var $author$project$Ports$Navbar$globalSearchButtonClickedPort = _Platform_outgoingPort('globalSearchButtonClickedPort', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Navbar$globalSearchTriggered = $author$project$Ports$Navbar$globalSearchButtonClickedPort(0);
    var $author$project$Components$HinterPracticeSettingsModal$GotCurrentManagementGroup = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$GotFeatures = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$GotManagementGroups = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$Open = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$open = F2(function(apiClient, practice) {
        return _Utils_Tuple2($author$project$Components$HinterPracticeSettingsModal$Open({
            L9: $elm$core$Maybe$Nothing,
            h5: $elm$core$Maybe$Nothing,
            Px: $author$project$Api$Data$Loading,
            m1: $author$project$Api$Data$Loading,
            W1: practice,
            sH: ''
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            A2($author$project$Api$Provider$ManagementGroup$getCurrent, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotCurrentManagementGroup),
            A2($author$project$Api$Provider$ManagementGroup$list, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotManagementGroups),
            A3($author$project$Api$Common$Feature$list, $author$project$Api$Data$providerPath, apiClient, $author$project$Components$HinterPracticeSettingsModal$GotFeatures)
        ])));
    });
    var $author$project$Ports$Intercom$intercomPortShow = _Platform_outgoingPort('intercomPortShow', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Intercom$show = function(session) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortShow(0);
    };
    var $author$project$Components$HinterPracticeSettingsModal$FeaturesUpdated = 3;
    var $author$project$Components$HinterPracticeSettingsModal$GotFeatureEnableResponse = function(a) {
        return {
            $: 7,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupSaved = 2;
    var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupUpdated = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$ModalClosed = 1;
    var $author$project$Components$HinterPracticeSettingsModal$None = 0;
    var $author$project$Components$HinterPracticeSettingsModal$replaceUpdatedFeature = F2(function(newFeature, feature) {
        return _Utils_eq($author$project$Api$Common$Feature$Shared$id(feature), $author$project$Api$Common$Feature$Shared$id(newFeature)) ? newFeature : feature;
    });
    var $author$project$Components$HinterPracticeSettingsModal$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 1,
                    zi: $author$project$Components$HinterPracticeSettingsModal$Closed,
                    at: _List_Nil
                };
            case 1:
                var response = msg.a;
                if (model.$ === 1) {
                    var data = model.a;
                    switch(response.$){
                        case 3:
                            var group = response.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                    h5: $elm$core$Maybe$Just(group)
                                })),
                                at: _List_Nil
                            };
                        case 2:
                            var error = response.a;
                            if (error.$ === 5) return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                    h5: $elm$core$Maybe$Nothing
                                })),
                                at: _List_Nil
                            };
                            else return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: model,
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: model,
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 2:
                var response = msg.a;
                if (model.$ === 1) {
                    var data = model.a;
                    switch(response.$){
                        case 3:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                    m1: response
                                })),
                                at: _List_Nil
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                    m1: response
                                })),
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, 'Failed to load management groups')
                                ])
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: model,
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 3:
                var groupId = msg.a;
                if (model.$ === 1) {
                    var data = model.a;
                    return {
                        EQ: A3($author$project$Api$Provider$ManagementGroup$update, apiClient, groupId, $author$project$Components$HinterPracticeSettingsModal$ManagementGroupUpdated),
                        adu: 0,
                        zi: $author$project$Components$HinterPracticeSettingsModal$Open(data),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 4:
                var response = msg.a;
                if (model.$ === 1) {
                    var data = model.a;
                    if (response.$ === 3) {
                        if (!response.a.$) {
                            var group = response.a.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 2,
                                zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                    h5: $elm$core$Maybe$Just(group)
                                })),
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, 'Management group updated successfully')
                                ])
                            };
                        } else {
                            var _v9 = response.a;
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                    h5: $elm$core$Maybe$Nothing
                                })),
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 3, 'Management group removed successfully')
                                ])
                            };
                        }
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: model,
                        at: A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, 'Failed to update management group'), $author$project$OutMsg$handleErrorResponse(response))
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 5:
                var response = msg.a;
                if (model.$ === 1) {
                    var data = model.a;
                    switch(response.$){
                        case 3:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                    Px: response
                                })),
                                at: _List_Nil
                            };
                        case 2:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                    Px: response
                                })),
                                at: _List_fromArray([
                                    A2($author$project$OutMsg$ShowToast, 1, 'Failed to load features')
                                ])
                            };
                        default:
                            return {
                                EQ: $elm$core$Platform$Cmd$none,
                                adu: 0,
                                zi: model,
                                at: $author$project$OutMsg$handleErrorResponse(response)
                            };
                    }
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 6:
                var featureId = msg.a;
                var enabled = msg.b;
                if (model.$ === 1) return {
                    EQ: A5($author$project$Api$Common$Feature$enable, $author$project$Api$Data$providerPath, apiClient, featureId, enabled, $author$project$Components$HinterPracticeSettingsModal$GotFeatureEnableResponse),
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
                else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 7:
                var response = msg.a;
                if (model.$ === 1) {
                    var data = model.a;
                    if (response.$ === 3) {
                        var feature = response.a;
                        var toastMessage = $author$project$Api$Common$Feature$Shared$enabled(feature) ? A2($author$project$OutMsg$ShowToast, 3, 'Feature \"' + ($author$project$Api$Common$Feature$Shared$name(feature) + '\" turned on')) : A2($author$project$OutMsg$ShowToast, 3, 'Feature \"' + ($author$project$Api$Common$Feature$Shared$name(feature) + '\" turned off'));
                        var newFeatures = A2($author$project$Api$Data$map, $elm$core$List$map($author$project$Components$HinterPracticeSettingsModal$replaceUpdatedFeature(feature)), data.Px);
                        return {
                            EQ: $elm$core$Platform$Cmd$none,
                            adu: 3,
                            zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                                Px: newFeatures
                            })),
                            at: _List_fromArray([
                                toastMessage,
                                $author$project$OutMsg$RefreshPractice,
                                $author$project$OutMsg$RefreshLayout
                            ])
                        };
                    } else return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: model,
                        at: A2($elm$core$List$cons, A2($author$project$OutMsg$ShowToast, 1, 'Failed to update feature'), $author$project$OutMsg$handleErrorResponse(response))
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 8:
                var query = msg.a;
                if (model.$ === 1) {
                    var data = model.a;
                    return {
                        EQ: $elm$core$Platform$Cmd$none,
                        adu: 0,
                        zi: $author$project$Components$HinterPracticeSettingsModal$Open(_Utils_update(data, {
                            sH: query
                        })),
                        at: _List_Nil
                    };
                } else return {
                    EQ: $elm$core$Platform$Cmd$none,
                    adu: 0,
                    zi: model,
                    at: _List_Nil
                };
            case 9:
                var text = msg.a;
                return {
                    EQ: $author$project$Ports$Clipboard$copy(text),
                    adu: 0,
                    zi: model,
                    at: _List_fromArray([
                        A2($author$project$OutMsg$ShowToast, 3, 'Copied to clipboard')
                    ])
                };
            default:
                return {
                    EQ: $author$project$Ports$Navigation$pushUrl($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$NewSettings__HinterSettings)),
                    adu: 1,
                    zi: $author$project$Components$HinterPracticeSettingsModal$Closed,
                    at: _List_Nil
                };
        }
    });
    var $author$project$Navbars$Practice$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 1:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    qt: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 14:
                var response = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    st: response
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 0:
                var currentDate = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    cP: $elm$core$Maybe$Just(currentDate)
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var subnav = msg.a;
                var newOpenSubNav = _Utils_eq(subnav, model.c5) ? 4 : subnav;
                return _Utils_Tuple3(_Utils_update(model, {
                    c5: newOpenSubNav
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var reportMenu = A2($author$project$Ui$FlyoutMenu$init, 'reporting-menu', $author$project$Navbars$Practice$ReportMenuMsg);
                var profileMenu = A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg);
                var adminMenu = A2($author$project$Ui$FlyoutMenu$init, 'admin-menu', $author$project$Navbars$Practice$AdminMenuMsg);
                return _Utils_Tuple3(_Utils_update(model, {
                    hu: adminMenu,
                    et: profileMenu,
                    jR: reportMenu
                }), $author$project$Ports$Navbar$sidenavLinkClicked, _List_Nil);
            case 4:
                return _Utils_Tuple3(_Utils_update(model, {
                    c5: 4,
                    oz: false
                }), $author$project$Ports$Navbar$globalSearchTriggered, _List_Nil);
            case 5:
                return _Utils_Tuple3(_Utils_update(model, {
                    yr: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 6:
                return _Utils_Tuple3(_Utils_update(model, {
                    et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg)
                }), $author$project$Ports$Session$logout({
                    agy: true
                }), _List_Nil);
            case 7:
                var subMsg = msg.a;
                var _v2 = A2($author$project$Ui$Dropdown$update, subMsg, model.oI);
                var dropdownMenu = _v2.a;
                var cmd = _v2.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    oI: dropdownMenu
                }), cmd, _List_Nil);
            case 8:
                var subMsg = msg.a;
                var reportMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.jR);
                return _Utils_Tuple3(_Utils_update(model, {
                    jR: reportMenu
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 9:
                var subMsg = msg.a;
                var adminMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.hu);
                return _Utils_Tuple3(_Utils_update(model, {
                    hu: adminMenu
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 10:
                var subMsg = msg.a;
                var profileMenu = A2($author$project$Ui$FlyoutMenu$update, subMsg, model.et);
                return _Utils_Tuple3(_Utils_update(model, {
                    et: profileMenu
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 11:
                var checked = msg.a;
                var newOpenSubNav = checked ? $author$project$Navbars$Practice$openSubNavFromSelectedNav(model.eI) : 4;
                return _Utils_Tuple3(_Utils_update(model, {
                    c5: newOpenSubNav,
                    oz: checked
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 12:
                return _Utils_Tuple3(_Utils_update(model, {
                    c5: 4,
                    oz: false
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                return _Utils_Tuple3(_Utils_update(model, {
                    sZ: !model.sZ
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 15:
                return _Utils_Tuple3(model, $author$project$Ports$Intercom$show(model.Z$), _List_Nil);
            case 16:
                var _v3 = A2($author$project$Components$HinterPracticeSettingsModal$open, apiClient, model.W1);
                var modalModel = _v3.a;
                var modalCmd = _v3.b;
                return _Utils_Tuple3(_Utils_update(model, {
                    iQ: modalModel
                }), A2($elm$core$Platform$Cmd$map, $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg, modalCmd), _List_Nil);
            case 17:
                var modalMsg = msg.a;
                var result = A3($author$project$Components$HinterPracticeSettingsModal$update, apiClient, modalMsg, model.iQ);
                var practiceRefreshCmd = function() {
                    var _v4 = result.adu;
                    switch(_v4){
                        case 0:
                            return $elm$core$Platform$Cmd$none;
                        case 1:
                            return $elm$core$Platform$Cmd$none;
                        case 2:
                            return $elm$core$Platform$Cmd$none;
                        default:
                            return A3($author$project$Api$Provider$Practice$retrieve, apiClient, $elm$core$Basics$identity, $author$project$Navbars$Practice$GotPracticeRefresh);
                    }
                }();
                return _Utils_Tuple3(_Utils_update(model, {
                    iQ: result.zi
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg, result.EQ),
                    practiceRefreshCmd
                ])), result.at);
            case 22:
                var practice = msg.a;
                if (practice.$ === 3) {
                    var practice_ = practice.a;
                    return _Utils_Tuple3(_Utils_update(model, {
                        W1: practice_,
                        jz: $author$project$Navbars$Practice$buildPracticeConfig(practice_)
                    }), $elm$core$Platform$Cmd$none, _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var partnerApps = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    rS: partnerApps
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(partnerApps));
            case 20:
                var pid = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(pid), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied practice id to clipboard')
                ]));
            case 21:
                var oid = msg.a;
                return _Utils_Tuple3(model, $author$project$Ports$Clipboard$copy(oid), _List_fromArray([
                    A2($author$project$OutMsg$ShowToast, 3, 'Copied organization id to clipboard')
                ]));
            default:
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
        }
    });
    var $author$project$Navbar$update = F3(function(apiClient, msg, _v0) {
        var model = _v0;
        switch(msg.$){
            case 0:
                var subMsg = msg.a;
                var _v2 = model.ad;
                if (_v2.$ === 1) {
                    var subModel = _v2.a;
                    var _v3 = A3($author$project$Navbars$Practice$update, apiClient, subMsg, subModel);
                    var subModel_ = _v3.a;
                    var subCmd = _v3.b;
                    var subOutMsgs = _v3.c;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ad: $author$project$Navbar$PracticeNav(subModel_)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PracticeNavbarMsg, subCmd),
                        $author$project$Navbar$getHeaderEnd
                    ])), subOutMsgs);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var subMsg = msg.a;
                var _v4 = model.ad;
                if (_v4.$ === 2) {
                    var subModel = _v4.a;
                    var _v5 = A2($author$project$Navbars$Company$update, subMsg, subModel);
                    var subModel_ = _v5.a;
                    var subCmd = _v5.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ad: $author$project$Navbar$CompanyNav(subModel_)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Navbar$CompanyNavbarMsg, subCmd),
                        $author$project$Navbar$getHeaderEnd
                    ])), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var subMsg = msg.a;
                var _v6 = model.ad;
                if (_v6.$ === 3) {
                    var subModel = _v6.a;
                    var _v7 = A2($author$project$Navbars$Partner$update, subMsg, subModel);
                    var subModel_ = _v7.a;
                    var subCmd = _v7.b;
                    return _Utils_Tuple3(_Utils_update(model, {
                        ad: $author$project$Navbar$PartnerNav(subModel_)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Navbar$PartnerNavbarMsg, subCmd),
                        $author$project$Navbar$getHeaderEnd
                    ])), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var bool = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    aeb: bool
                }), $elm$core$Platform$Cmd$none, _List_Nil);
            case 4:
                var result = msg.a;
                if (!result.$) {
                    var element = result.a.adh;
                    var viewport = result.a.aie;
                    return _Utils_Tuple3(model, $author$project$Ports$Navbar$topnavHeaderHeightChangedPort(element.abv - viewport.abv), _List_Nil);
                } else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 5:
                return _Utils_Tuple3(model, $author$project$Navbar$getHeaderEnd, _List_Nil);
            default:
                var subMsg = msg.a;
                var _v9 = $author$project$Components$SandboxAlert$update(subMsg);
                var sandboxAlertCmd = _v9.a;
                var sandboxAlertOutMsgs = _v9.b;
                return _Utils_Tuple3(model, A2($elm$core$Platform$Cmd$map, $author$project$Navbar$SandboxAlertMsg, sandboxAlertCmd), sandboxAlertOutMsgs);
        }
    });
    var $author$project$Ui$Toast$removeToast = F2(function(filterFunc, _v0) {
        var count = _v0.a;
        var toasts = _v0.b;
        return A2($author$project$Ui$Toast$Toastr, count, A2($elm$core$List$filter, filterFunc, toasts));
    });
    var $author$project$Ui$Toast$updateToast = F3(function(func, id, _v0) {
        var count = _v0.a;
        var toasts = _v0.b;
        return A2($author$project$Ui$Toast$Toastr, count, A2($elm$core$List$map, function(_v1) {
            var toast_ = _v1;
            return _Utils_eq(toast_.aef, id) ? func(toast_) : toast_;
        }, toasts));
    });
    var $author$project$Ui$Toast$update = F2(function(msg, toastr) {
        switch(msg.$){
            case 1:
                var toRemoveId = msg.a;
                return _Utils_Tuple2(A2($author$project$Ui$Toast$removeToast, function(_v1) {
                    var id = _v1.aef;
                    var dismissible = _v1.qm;
                    return !(_Utils_eq(id, toRemoveId) && dismissible);
                }, toastr), $elm$core$Platform$Cmd$none);
            case 0:
                var toRemoveId = msg.a;
                return _Utils_Tuple2(A2($author$project$Ui$Toast$removeToast, function(_v2) {
                    var id = _v2.aef;
                    return !_Utils_eq(id, toRemoveId);
                }, toastr), $elm$core$Platform$Cmd$none);
            case 2:
                var id = msg.a;
                return _Utils_Tuple2(A3($author$project$Ui$Toast$updateToast, function(toast_) {
                    return _Utils_update(toast_, {
                        qm: false
                    });
                }, id, toastr), $elm$core$Platform$Cmd$none);
            default:
                var id = msg.a;
                return _Utils_Tuple2(A3($author$project$Ui$Toast$updateToast, function(toast_) {
                    return _Utils_update(toast_, {
                        qm: true
                    });
                }, id, toastr), A2($author$project$Ui$Toast$dismissInSeconds, 2, id));
        }
    });
    var $author$project$Utils$Release$GotLiveRelease = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$http$Http$BadBody = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $elm$http$Http$BadStatus = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $elm$http$Http$BadUrl = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $elm$http$Http$NetworkError = {
        $: 2
    };
    var $elm$http$Http$Timeout = {
        $: 1
    };
    var $elm$http$Http$resolve = F2(function(toResult, response) {
        switch(response.$){
            case 0:
                var url = response.a;
                return $elm$core$Result$Err($elm$http$Http$BadUrl(url));
            case 1:
                return $elm$core$Result$Err($elm$http$Http$Timeout);
            case 2:
                return $elm$core$Result$Err($elm$http$Http$NetworkError);
            case 3:
                var metadata = response.a;
                return $elm$core$Result$Err($elm$http$Http$BadStatus(metadata._7));
            default:
                var body = response.b;
                return A2($elm$core$Result$mapError, $elm$http$Http$BadBody, toResult(body));
        }
    });
    var $elm$http$Http$expectString = function(toMsg) {
        return A2($elm$http$Http$expectStringResponse, toMsg, $elm$http$Http$resolve($elm$core$Result$Ok));
    };
    var $elm$http$Http$get = function(r) {
        return $elm$http$Http$request({
            fb: $elm$http$Http$emptyBody,
            Pb: r.Pb,
            iL: _List_Nil,
            Gk: 'GET',
            HQ: $elm$core$Maybe$Nothing,
            tu: $elm$core$Maybe$Nothing,
            aaT: r.aaT
        });
    };
    var $author$project$Utils$Release$fetchLiveRelease = $elm$http$Http$get({
        Pb: $elm$http$Http$expectString($author$project$Utils$Release$GotLiveRelease),
        aaT: '/RELEASE'
    });
    var $author$project$Utils$Release$sha1Regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, $elm$regex$Regex$fromString('[a-f0-9]{40}'));
    var $author$project$Utils$Release$update = F2(function(msg, _v0) {
        var model = _v0;
        return A2($elm$core$Tuple$mapFirst, $elm$core$Basics$identity, function() {
            if (!msg.$) {
                if (!msg.a.$) {
                    var liveRelease = msg.a.a;
                    return A2($elm$regex$Regex$contains, $author$project$Utils$Release$sha1Regex, liveRelease) ? _Utils_Tuple2(_Utils_update(model, {
                        zs: !_Utils_eq($elm$core$String$trim(liveRelease), model.E0)
                    }), $elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $author$project$Ports$Sentry$captureErrorMessage('Fetching RELEASE Failed: Not Found'));
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$batch(_List_fromArray([
                $author$project$Utils$Release$fetchLiveRelease,
                model.zs ? $elm$core$Platform$Cmd$none : $author$project$Utils$Release$scheduleNextReleaseCheck
            ])));
        }());
    });
    var $author$project$Shared$validateRedirectUrl = F2(function(currentPath, redirectToURI) {
        var isErrorPage = function(url) {
            return A2($elm$core$String$contains, '/error/', url);
        };
        var onErrorPage = isErrorPage(currentPath);
        var redirectGoesToErrorPage = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, isErrorPage, redirectToURI));
        return onErrorPage || !redirectGoesToErrorPage ? redirectToURI : $elm$core$Maybe$Nothing;
    });
    var $author$project$Shared$update = F2(function(msg, model) {
        update: while(true)switch(msg.$){
            case 0:
                var response = msg.a;
                switch(response.$){
                    case 2:
                        var error = response.a;
                        if (error.$ === 7) {
                            var decodeError = error.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                Z$: response
                            }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                                $author$project$Shared$decodeErrorToMsg(decodeError),
                                $author$project$Shared$navigateToErrorPage(error)
                            ])));
                        } else return _Utils_Tuple2(_Utils_update(model, {
                            Z$: response
                        }), $author$project$Shared$navigateToErrorPage(error));
                    case 3:
                        var session = response.a;
                        var rainforestEnv = _Utils_eq(model.adU.aea, $elm$core$Maybe$Just('production')) && !$author$project$Api$Platform$Session$One$sandbox(session) ? 0 : 1;
                        var _v3 = function() {
                            var _v4 = model.gg;
                            if (_v4.$ === 1) return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Shared$OrganizationSwitcherMsg), A2($elm$core$Tuple$mapFirst, $elm$core$Maybe$Just, A2($author$project$Components$OrganizationSwitcher$init, model.Ej, {
                                Zn: $author$project$Api$Platform$Session$One$sandbox(session)
                            })));
                            else {
                                var existing = _v4.a;
                                return _Utils_Tuple2($elm$core$Maybe$Just(existing), $elm$core$Platform$Cmd$none);
                            }
                        }();
                        var orgSwitcher = _v3.a;
                        var orgSwitcherCmd = _v3.b;
                        return A4($author$project$Shared$applySession, response, session, _Utils_update(model, {
                            gg: orgSwitcher,
                            sp: $elm$core$Maybe$Just(rainforestEnv)
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            $author$project$Ports$Rainforest$load(rainforestEnv),
                            orgSwitcherCmd
                        ])));
                    default:
                        return _Utils_Tuple2(_Utils_update(model, {
                            Z$: response
                        }), $elm$core$Platform$Cmd$none);
                }
            case 1:
                var response = msg.a;
                _v5$2: while(true){
                    if (response.$ === 2) switch(response.a.$){
                        case 7:
                            var error = response.a.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                W1: response
                            }), $author$project$Shared$decodeErrorToMsg(error));
                        case 6:
                            if (response.a.a === 428 && response.a.b === 'This action requires a Practice') {
                                var _v6 = response.a;
                                return _Utils_Tuple2(_Utils_update(model, {
                                    W1: $author$project$Api$Data$NotAsked
                                }), $elm$core$Platform$Cmd$none);
                            } else break _v5$2;
                        default:
                            break _v5$2;
                    }
                    else break _v5$2;
                }
                var invokeIfNewPractice = F3(function(fn, onFirstLoad, newModelAndCmd) {
                    var _v7 = _Utils_Tuple2(model.W1, response);
                    if (_v7.b.$ === 3) {
                        if (_v7.a.$ === 3) {
                            var _v8 = _v7.a;
                            var oldPractice = _v8.a;
                            var _v9 = _v7.b;
                            var newPractice = _v9.a;
                            return A2($author$project$Shared$practiceChanged, oldPractice, newPractice) ? fn(newModelAndCmd) : newModelAndCmd;
                        } else {
                            var _v10 = _v7.b;
                            return onFirstLoad ? fn(newModelAndCmd) : newModelAndCmd;
                        }
                    } else return newModelAndCmd;
                });
                return A2($author$project$Shared$handlePendingClinicalRedirect, response, $author$project$Shared$initNavbar($author$project$Shared$initializePatientsList($author$project$Shared$enableCoreGlobalSearchShortcutFn($author$project$Shared$requestLoadEmbeddedClinical(A3(invokeIfNewPractice, $author$project$Shared$identifyOnExternalServices, true, A3(invokeIfNewPractice, $author$project$Shared$resetTenancyProperties, false, _Utils_Tuple2(_Utils_update(model, {
                    W1: response
                }), $elm$core$Platform$Cmd$none))))))));
            case 3:
                var companyId = msg.a;
                var response = msg.b;
                _v11$2: while(true){
                    if (response.$ === 2) switch(response.a.$){
                        case 5:
                            var _v12 = response.a;
                            return $author$project$Shared$isHintAdmin(model) ? _Utils_Tuple2(_Utils_update(model, {
                                acy: response
                            }), A4($author$project$Api$Platform$User$Practice$list, model.Ej, function(d) {
                                return _Utils_update(d, {
                                    agq: $elm$core$Maybe$Just(companyId)
                                });
                            }, $elm$core$Maybe$Nothing, $author$project$Shared$GotUserPractices($author$project$Shared$OrgSwitcher$Company(companyId)))) : $author$project$Shared$initNavbar(_Utils_Tuple2(_Utils_update(model, {
                                acy: response
                            }), $elm$core$Platform$Cmd$none));
                        case 7:
                            var error = response.a.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                acy: response
                            }), $author$project$Shared$decodeErrorToMsg(error));
                        default:
                            break _v11$2;
                    }
                    else break _v11$2;
                }
                return $author$project$Shared$initNavbar(_Utils_Tuple2(_Utils_update(model, {
                    acy: response
                }), $elm$core$Platform$Cmd$none));
            case 2:
                var response = msg.a;
                if (response.$ === 2 && response.a.$ === 7) {
                    var error = response.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        VW: response
                    }), $author$project$Shared$decodeErrorToMsg(error));
                } else return $author$project$Shared$initNavbar($author$project$Shared$resetTenancyProperties(_Utils_Tuple2(_Utils_update(model, {
                    VW: response
                }), $elm$core$Platform$Cmd$none)));
            case 4:
                var userData = msg.a;
                if (userData.$ === 2 && userData.a.$ === 7) {
                    var error = userData.a.a;
                    return _Utils_Tuple2(_Utils_update(model, {
                        aaX: userData
                    }), $author$project$Shared$decodeErrorToMsg(error));
                } else return _Utils_Tuple2(_Utils_update(model, {
                    aaX: userData
                }), $elm$core$Platform$Cmd$none);
            case 5:
                var result = msg.a;
                if (!result.$) {
                    var maybeSessionToken = result.a;
                    var maybeAuthToken = A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, maybeSessionToken);
                    var apiClient = A2($author$project$Api$Data$clientWithAuthToken, maybeAuthToken, model.Ej);
                    if ($author$project$Api$Data$clientHasAuthToken(apiClient)) {
                        var refreshTimeoutCmd = !A2($author$project$Api$Data$usingDefaultAuth, model.Ej, model.adU.abT) ? $author$project$Shared$backupJwtRefreshTimeout(apiClient) : $elm$core$Platform$Cmd$none;
                        return _Utils_Tuple2(_Utils_update(model, {
                            pl: maybeAuthToken,
                            Ej: apiClient
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($author$project$Api$Platform$Session$retrieve, apiClient, $author$project$Shared$GotSession),
                            A2($author$project$Api$Platform$User$retrieve, apiClient, $author$project$Shared$GotUser),
                            refreshTimeoutCmd
                        ])));
                    } else return $author$project$Shared$resetTenancyProperties(_Utils_Tuple2(_Utils_update(model, {
                        pl: maybeAuthToken,
                        Ej: apiClient,
                        W1: $author$project$Api$Data$NotAsked,
                        Z$: $author$project$Api$Data$NotAsked,
                        aaX: $author$project$Api$Data$NotAsked
                    }), $elm$core$Platform$Cmd$none));
                } else {
                    var error = result.a;
                    return _Utils_Tuple2(model, $author$project$Ports$Sentry$captureErrorMessage('Session update failed: ' + error));
                }
            case 6:
                var result = msg.a;
                if (!result.$) {
                    var _v17 = result.a;
                    var zone = _v17.b;
                    return _Utils_Tuple2(_Utils_update(model, {
                        HO: A2($author$project$Formatters$Time$init, zone, model.acJ),
                        HP: zone
                    }), $elm$core$Platform$Cmd$none);
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 7:
                var currentTime = msg.a;
                return _Utils_Tuple2(_Utils_update(model, {
                    cP: A2($justinmimbs$date$Date$fromPosix, model.HP, currentTime),
                    acJ: currentTime
                }), $elm$core$Platform$Cmd$none);
            case 8:
                var patientsListMsg_ = msg.a;
                var _v18 = model.af4;
                if (!_v18.$) {
                    var patientsList = _v18.a;
                    var _v19 = A3($author$project$Components$PatientsList$update, model.Ej, patientsListMsg_, patientsList);
                    var newList = _v19.a;
                    var listCmd = _v19.b;
                    var outMsgs = _v19.c;
                    var _v20 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, _Utils_update(model, {
                        af4: $elm$core$Maybe$Just(newList)
                    }));
                    var newModel = _v20.a;
                    var outCmd = _v20.b;
                    return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Shared$PatientsListMsg, listCmd),
                        outCmd
                    ])));
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 9:
                return _Utils_Tuple2(_Utils_update(model, {
                    sV: true
                }), $elm$core$Platform$Cmd$none);
            case 10:
                return _Utils_Tuple2(_Utils_update(model, {
                    sV: false
                }), $elm$core$Platform$Cmd$none);
            case 11:
                var subMsg = msg.a;
                var _v21 = A5($author$project$Components$GlobalSearch$update, model.Ej, model.Z$, model.W1, subMsg, model.fP);
                var globalSearch = _v21.a;
                var globalSearchCmd = _v21.b;
                var globalSearchOutMsgs = _v21.c;
                var _v22 = A2($author$project$Shared$updateFromOutMsgs, globalSearchOutMsgs, _Utils_update(model, {
                    fP: globalSearch
                }));
                var newModel = _v22.a;
                var outCmd = _v22.b;
                return _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Shared$GlobalSearchMsg, globalSearchCmd),
                    outCmd
                ])));
            case 12:
                var result = msg.a;
                if (!result.$) {
                    var result_ = result.a;
                    var maybeAuthToken = A2($elm$core$Maybe$map, $author$project$Api$AuthToken$fromString, result_.pl);
                    var apiClient = A2($author$project$Api$Data$clientWithAuthToken, maybeAuthToken, model.Ej);
                    return $author$project$Api$Data$clientHasAuthToken(apiClient) ? _Utils_Tuple2(_Utils_update(model, {
                        pl: maybeAuthToken,
                        Ej: apiClient,
                        Z$: $author$project$Api$Data$Loading
                    }), A2($author$project$Api$Platform$Session$retrieve, apiClient, $author$project$Shared$GotSessionCreated(result_.agz))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                } else {
                    var error = result.a;
                    return _Utils_Tuple2(model, $author$project$Ports$Sentry$captureErrorMessage('Session create failed: ' + error));
                }
            case 13:
                var redirectToURI = msg.a;
                var response = msg.b;
                _v24$2: while(true)switch(response.$){
                    case 2:
                        if (response.a.$ === 7) {
                            var error = response.a.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                Z$: response
                            }), $author$project$Shared$decodeErrorToMsg(error));
                        } else break _v24$2;
                    case 3:
                        var session = response.a;
                        var validatedRedirectToURI = A2($author$project$Shared$validateRedirectUrl, model.aaT.V6, redirectToURI);
                        var finalRedirectToURI = function() {
                            var _v26 = $author$project$Api$Platform$Session$One$organization(session);
                            if (!_v26.$) {
                                var session_ = _v26.a;
                                return $author$project$Api$Platform$Organization$Shared$practiceIsOnboarding(session_) ? $elm$core$Maybe$Nothing : validatedRedirectToURI;
                            } else return validatedRedirectToURI;
                        }();
                        var navigateTo = A2($elm$core$Maybe$withDefault, A2($author$project$Utils$Route$navigate, $elm$core$Dict$empty, A2($author$project$Permission$homeStateFor, session, model.aeb)), A2($elm$core$Maybe$map, function(uri) {
                            var query = A2($elm$core$Maybe$withDefault, $elm$core$Dict$empty, A2($elm$core$Maybe$map, $author$project$Spa$Url$toQueryDict, uri.Bz));
                            return A3($author$project$Utils$Route$navigateWithFragment, query, uri.adZ, $author$project$Utils$Route$fromUrl(uri));
                        }, A2($elm$core$Maybe$andThen, $elm$url$Url$fromString, finalRedirectToURI)));
                        return _Utils_Tuple2(_Utils_update(model, {
                            Z$: response
                        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($author$project$Api$Platform$User$retrieve, model.Ej, $author$project$Shared$GotUser),
                            navigateTo,
                            A2($elm$core$Task$perform, function(_v25) {
                                return $author$project$Shared$GotSession(response);
                            }, $elm$core$Process$sleep(0)),
                            A3($author$project$Shared$switchToPracticeWithQueryParam, model.Ej, model.adU.abT, model.aaT)
                        ])));
                    default:
                        break _v24$2;
                }
                return _Utils_Tuple2(_Utils_update(model, {
                    Z$: response
                }), $elm$core$Platform$Cmd$none);
            case 14:
                var releaseMsg = msg.a;
                var _v27 = A2($author$project$Utils$Release$update, releaseMsg, model.agH);
                var release = _v27.a;
                var releaseCmd = _v27.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    agH: release
                }), A2($elm$core$Platform$Cmd$map, $author$project$Shared$ReleaseMsg, releaseCmd));
            case 15:
                var subMsg = msg.a;
                var accountLockedModalCmd = $author$project$Components$AccountLockedModal$update(subMsg);
                return _Utils_Tuple2(model, A2($elm$core$Platform$Cmd$map, $author$project$Shared$AccountLockedModalMsg, accountLockedModalCmd));
            case 16:
                var toastMsg = msg.a;
                return A2($elm$core$Tuple$mapFirst, function(toastr) {
                    return _Utils_update(model, {
                        ky: toastr
                    });
                }, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Shared$ToastMsg), A2($author$project$Ui$Toast$update, toastMsg, model.ky)));
            case 17:
                var navbarMsg = msg.a;
                var _v28 = $author$project$Navbar$extractOrgSwitcherMsg(navbarMsg);
                if (!_v28.$) {
                    var orgSwitcherMsg = _v28.a;
                    var $temp$msg = $author$project$Shared$OrganizationSwitcherMsg(orgSwitcherMsg), $temp$model = model;
                    msg = $temp$msg;
                    model = $temp$model;
                    continue update;
                } else {
                    var _v29 = model.ae;
                    if (!_v29.$) {
                        var navbar = _v29.a;
                        var _v30 = A3($author$project$Navbar$update, model.Ej, navbarMsg, navbar);
                        var navbar_ = _v30.a;
                        var navbarCmd = _v30.b;
                        var navbarOutMsgs = _v30.c;
                        var _v31 = A3($elm$core$List$foldl, $author$project$Shared$updateFromOutMsg, _Utils_Tuple2(_Utils_update(model, {
                            ae: $elm$core$Maybe$Just(navbar_)
                        }), $elm$core$Platform$Cmd$none), navbarOutMsgs);
                        var modelWithOutMsgs = _v31.a;
                        var outMsgCmd = _v31.b;
                        return _Utils_Tuple2(modelWithOutMsgs, $elm$core$Platform$Cmd$batch(_List_fromArray([
                            A2($elm$core$Platform$Cmd$map, $author$project$Shared$NavbarMsg, navbarCmd),
                            outMsgCmd
                        ])));
                    } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                }
            case 18:
                return _Utils_Tuple2(model, $author$project$Shared$deidentifyOnExternalServices);
            case 19:
                var postOrganizationSwitchedAction_ = msg.a;
                var response = msg.b;
                _v32$4: while(true)switch(response.$){
                    case 3:
                        var authToken = response.a;
                        return A3($author$project$Shared$scheduleOrgSwitchRedirect, model, postOrganizationSwitchedAction_, A2($author$project$Shared$storeAuthToken, authToken, true));
                    case 2:
                        switch(response.a.$){
                            case 9:
                                return _Utils_Tuple2(model, $author$project$Ports$Session$logout({
                                    agy: true
                                }));
                            case 0:
                                return _Utils_Tuple2(model, $author$project$Ports$Session$logout({
                                    agy: true
                                }));
                            case 7:
                                var error = response.a.a;
                                return _Utils_Tuple2(model, $author$project$Shared$decodeErrorToMsg(error));
                            default:
                                break _v32$4;
                        }
                    default:
                        break _v32$4;
                }
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 20:
                var switchOrganizationFrom = msg.a;
                var response = msg.b;
                _v33$2: while(true)switch(response.$){
                    case 3:
                        var practices = response.a;
                        var _v34 = $elm$core$List$head(practices);
                        if (!_v34.$) {
                            var practice = _v34.a;
                            return model.adU.abT ? _Utils_Tuple2(model, A4($author$project$Api$Auth$switchToOrganization, model.Ej, $author$project$Api$Platform$Practice$All$organizationId(practice), $elm$core$Maybe$Nothing, $author$project$Shared$BackupAuthOrganizationSwitched($author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction(switchOrganizationFrom)))) : A3($author$project$Shared$scheduleOrgSwitchRedirect, model, $author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction(switchOrganizationFrom), $author$project$Ports$Session$switchTenant($author$project$Api$Platform$Practice$All$organizationId(practice)));
                        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    case 2:
                        if (response.a.$ === 7) {
                            var error = response.a.a;
                            return _Utils_Tuple2(model, $author$project$Shared$decodeErrorToMsg(error));
                        } else break _v33$2;
                    default:
                        break _v33$2;
                }
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 21:
                var switchOrganizationFrom = msg.a;
                var response = msg.b;
                _v35$2: while(true)switch(response.$){
                    case 3:
                        var partners = response.a;
                        var _v36 = $elm$core$List$head(partners);
                        if (!_v36.$) {
                            var partner = _v36.a;
                            return model.adU.abT ? _Utils_Tuple2(model, A4($author$project$Api$Auth$switchToOrganization, model.Ej, $author$project$Api$Platform$Partner$All$organizationId(partner), $elm$core$Maybe$Nothing, $author$project$Shared$BackupAuthOrganizationSwitched($author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction(switchOrganizationFrom)))) : A3($author$project$Shared$scheduleOrgSwitchRedirect, model, $author$project$Shared$OrgSwitcher$postOrganizationSwitchedAction(switchOrganizationFrom), $author$project$Ports$Session$switchTenant($author$project$Api$Platform$Partner$All$organizationId(partner)));
                        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                    case 2:
                        if (response.a.$ === 7) {
                            var error = response.a.a;
                            return _Utils_Tuple2(model, $author$project$Shared$decodeErrorToMsg(error));
                        } else break _v35$2;
                    default:
                        break _v35$2;
                }
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 22:
                var _v37 = model.Wx;
                if (!_v37.$) {
                    var _v38 = _v37.a;
                    var url = _v38.a;
                    var isLocal = _v38.b;
                    return _Utils_Tuple2(_Utils_update(model, {
                        af8: $elm$core$Maybe$Nothing
                    }), A3($author$project$Ports$Navigation$requestUrl, url, isLocal, false));
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 23:
                return _Utils_Tuple2(_Utils_update(model, {
                    Wx: $elm$core$Maybe$Nothing
                }), $elm$core$Platform$Cmd$none);
            case 24:
                var patientId = msg.a;
                var response = msg.b;
                _v39$2: while(true){
                    if (response.$ === 2) switch(response.a.$){
                        case 5:
                            var _v40 = response.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                MO: response
                            }), A4($author$project$Api$Platform$User$Practice$list, model.Ej, function(d) {
                                return _Utils_update(d, {
                                    agq: $elm$core$Maybe$Just(patientId)
                                });
                            }, $elm$core$Maybe$Nothing, $author$project$Shared$GotUserPractices($author$project$Shared$OrgSwitcher$Patient(patientId))));
                        case 7:
                            var error = response.a.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                MO: response
                            }), $author$project$Shared$decodeErrorToMsg(error));
                        default:
                            break _v39$2;
                    }
                    else break _v39$2;
                }
                return _Utils_Tuple2(_Utils_update(model, {
                    MO: response
                }), $elm$core$Platform$Cmd$none);
            case 25:
                var response = msg.a;
                _v41$2: while(true)switch(response.$){
                    case 2:
                        if (response.a.$ === 7) {
                            var error = response.a.a;
                            return _Utils_Tuple2(_Utils_update(model, {
                                abq: response
                            }), $author$project$Shared$decodeErrorToMsg(error));
                        } else break _v41$2;
                    case 3:
                        var whitelabelSetting_ = response.a;
                        return _Utils_Tuple2(_Utils_update(model, {
                            abq: response
                        }), $author$project$Shared$setFaviconUrls(whitelabelSetting_));
                    default:
                        break _v41$2;
                }
                return _Utils_Tuple2(_Utils_update(model, {
                    abq: response
                }), $elm$core$Platform$Cmd$none);
            case 26:
                var authTokenData = msg.a;
                _v42$4: while(true)switch(authTokenData.$){
                    case 3:
                        var authToken = authTokenData.a;
                        return _Utils_Tuple2(model, A2($author$project$Shared$storeAuthToken, authToken, true));
                    case 2:
                        switch(authTokenData.a.$){
                            case 9:
                                return _Utils_Tuple2(_Utils_update(model, {
                                    sQ: true
                                }), $elm$core$Platform$Cmd$none);
                            case 0:
                                return _Utils_Tuple2(model, $author$project$Ports$Session$logout({
                                    agy: true
                                }));
                            case 7:
                                var error = authTokenData.a.a;
                                return _Utils_Tuple2(model, $author$project$Shared$decodeErrorToMsg(error));
                            default:
                                break _v42$4;
                        }
                    default:
                        break _v42$4;
                }
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 27:
                return _Utils_Tuple2(model, $author$project$Shared$refreshToken(model.Ej));
            case 28:
                var signOutNow = msg.a;
                var newModel = _Utils_update(model, {
                    sQ: false
                });
                return signOutNow ? _Utils_Tuple2(newModel, $author$project$Ports$Session$logout({
                    agy: true
                })) : _Utils_Tuple2(newModel, $elm$core$Platform$Cmd$none);
            case 29:
                var subMsg = msg.a;
                var _v43 = model.gg;
                if (!_v43.$) {
                    var switcher = _v43.a;
                    var _v44 = A2($author$project$Components$OrganizationSwitcher$update, subMsg, switcher);
                    var newSwitcher = _v44.a;
                    var switcherCmd = _v44.b;
                    var outMsgs = _v44.c;
                    var _v45 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, _Utils_update(model, {
                        gg: $elm$core$Maybe$Just(newSwitcher)
                    }));
                    var updatedModel = _v45.a;
                    var outMsgCmd = _v45.b;
                    return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Shared$OrganizationSwitcherMsg, switcherCmd),
                        outMsgCmd
                    ])));
                } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            default:
                var response = msg.a;
                _v46$2: while(true)switch(response.$){
                    case 3:
                        var session_ = response.a;
                        var scheduledModel = _Utils_update(model, {
                            ae: $elm$core$Maybe$Nothing,
                            db: $author$project$Shared$OrgSwitcher$pendingRedirect($author$project$OutMsg$GoToDefaultStateAction),
                            W1: $author$project$Api$Data$NotAsked
                        });
                        return A4($author$project$Shared$applySession, response, session_, scheduledModel, $elm$core$Platform$Cmd$none);
                    case 2:
                        if (response.a.$ === 7) {
                            var error = response.a.a;
                            return _Utils_Tuple2(model, $author$project$Shared$decodeErrorToMsg(error));
                        } else break _v46$2;
                    default:
                        break _v46$2;
                }
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
        }
    });
    var $author$project$Spa$Generated$Pages$update = F2(function(bigMsg, bigModel) {
        var _v0 = _Utils_Tuple2(bigMsg, bigModel);
        _v0$336: while(true)switch(_v0.a.$){
            case 0:
                if (!_v0.b.$) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DJ.aaO, msg, model);
                } else break _v0$336;
            case 1:
                if (_v0.b.$ === 1) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vO.aaO, msg, model);
                } else break _v0$336;
            case 2:
                if (_v0.b.$ === 2) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vP.aaO, msg, model);
                } else break _v0$336;
            case 3:
                if (_v0.b.$ === 3) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vW.aaO, msg, model);
                } else break _v0$336;
            case 4:
                if (_v0.b.$ === 4) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ap.aaO, msg, model);
                } else break _v0$336;
            case 5:
                if (_v0.b.$ === 5) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.xS.aaO, msg, model);
                } else break _v0$336;
            case 6:
                if (_v0.b.$ === 6) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x7.aaO, msg, model);
                } else break _v0$336;
            case 7:
                if (_v0.b.$ === 7) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yL.aaO, msg, model);
                } else break _v0$336;
            case 8:
                if (_v0.b.$ === 8) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yM.aaO, msg, model);
                } else break _v0$336;
            case 9:
                if (_v0.b.$ === 9) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.rD.aaO, msg, model);
                } else break _v0$336;
            case 10:
                if (_v0.b.$ === 10) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.z8.aaO, msg, model);
                } else break _v0$336;
            case 11:
                if (_v0.b.$ === 11) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vd.aaO, msg, model);
                } else break _v0$336;
            case 12:
                if (_v0.b.$ === 12) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vp.aaO, msg, model);
                } else break _v0$336;
            case 13:
                if (_v0.b.$ === 13) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wN.aaO, msg, model);
                } else break _v0$336;
            case 14:
                if (_v0.b.$ === 14) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.xN.aaO, msg, model);
                } else break _v0$336;
            case 15:
                if (_v0.b.$ === 15) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yZ.aaO, msg, model);
                } else break _v0$336;
            case 16:
                if (_v0.b.$ === 16) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AY.aaO, msg, model);
                } else break _v0$336;
            case 17:
                if (_v0.b.$ === 17) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bn.aaO, msg, model);
                } else break _v0$336;
            case 18:
                if (_v0.b.$ === 18) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Ds.aaO, msg, model);
                } else break _v0$336;
            case 19:
                if (_v0.b.$ === 19) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DD.aaO, msg, model);
                } else break _v0$336;
            case 20:
                if (_v0.b.$ === 20) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.tU.aaO, msg, model);
                } else break _v0$336;
            case 21:
                if (_v0.b.$ === 21) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t$.aaO, msg, model);
                } else break _v0$336;
            case 22:
                if (_v0.b.$ === 22) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t1.aaO, msg, model);
                } else break _v0$336;
            case 23:
                if (_v0.b.$ === 23) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t2.aaO, msg, model);
                } else break _v0$336;
            case 24:
                if (_v0.b.$ === 24) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t3.aaO, msg, model);
                } else break _v0$336;
            case 25:
                if (_v0.b.$ === 25) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t8.aaO, msg, model);
                } else break _v0$336;
            case 26:
                if (_v0.b.$ === 26) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uc.aaO, msg, model);
                } else break _v0$336;
            case 27:
                if (_v0.b.$ === 27) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ug.aaO, msg, model);
                } else break _v0$336;
            case 28:
                if (_v0.b.$ === 28) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uu.aaO, msg, model);
                } else break _v0$336;
            case 29:
                if (_v0.b.$ === 29) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uz.aaO, msg, model);
                } else break _v0$336;
            case 30:
                if (_v0.b.$ === 30) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uA.aaO, msg, model);
                } else break _v0$336;
            case 31:
                if (_v0.b.$ === 31) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uC.aaO, msg, model);
                } else break _v0$336;
            case 32:
                if (_v0.b.$ === 32) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uD.aaO, msg, model);
                } else break _v0$336;
            case 33:
                if (_v0.b.$ === 33) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uE.aaO, msg, model);
                } else break _v0$336;
            case 34:
                if (_v0.b.$ === 34) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uF.aaO, msg, model);
                } else break _v0$336;
            case 35:
                if (_v0.b.$ === 35) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uG.aaO, msg, model);
                } else break _v0$336;
            case 36:
                if (_v0.b.$ === 36) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uH.aaO, msg, model);
                } else break _v0$336;
            case 37:
                if (_v0.b.$ === 37) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uP.aaO, msg, model);
                } else break _v0$336;
            case 38:
                if (_v0.b.$ === 38) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uQ.aaO, msg, model);
                } else break _v0$336;
            case 39:
                if (_v0.b.$ === 39) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uS.aaO, msg, model);
                } else break _v0$336;
            case 40:
                if (_v0.b.$ === 40) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uT.aaO, msg, model);
                } else break _v0$336;
            case 41:
                if (_v0.b.$ === 41) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uZ.aaO, msg, model);
                } else break _v0$336;
            case 42:
                if (_v0.b.$ === 42) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u_.aaO, msg, model);
                } else break _v0$336;
            case 43:
                if (_v0.b.$ === 43) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u2.aaO, msg, model);
                } else break _v0$336;
            case 44:
                if (_v0.b.$ === 44) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u3.aaO, msg, model);
                } else break _v0$336;
            case 45:
                if (_v0.b.$ === 45) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u4.aaO, msg, model);
                } else break _v0$336;
            case 46:
                if (_v0.b.$ === 46) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u8.aaO, msg, model);
                } else break _v0$336;
            case 47:
                if (_v0.b.$ === 47) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u9.aaO, msg, model);
                } else break _v0$336;
            case 48:
                if (_v0.b.$ === 48) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.va.aaO, msg, model);
                } else break _v0$336;
            case 49:
                if (_v0.b.$ === 49) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vn.aaO, msg, model);
                } else break _v0$336;
            case 50:
                if (_v0.b.$ === 50) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vo.aaO, msg, model);
                } else break _v0$336;
            case 51:
                if (_v0.b.$ === 51) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.v7.aaO, msg, model);
                } else break _v0$336;
            case 52:
                if (_v0.b.$ === 52) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ws.aaO, msg, model);
                } else break _v0$336;
            case 53:
                if (_v0.b.$ === 53) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wM.aaO, msg, model);
                } else break _v0$336;
            case 54:
                if (_v0.b.$ === 54) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wQ.aaO, msg, model);
                } else break _v0$336;
            case 55:
                if (_v0.b.$ === 55) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wR.aaO, msg, model);
                } else break _v0$336;
            case 56:
                if (_v0.b.$ === 56) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.xM.aaO, msg, model);
                } else break _v0$336;
            case 57:
                if (_v0.b.$ === 57) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x1.aaO, msg, model);
                } else break _v0$336;
            case 58:
                if (_v0.b.$ === 58) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x2.aaO, msg, model);
                } else break _v0$336;
            case 59:
                if (_v0.b.$ === 59) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x3.aaO, msg, model);
                } else break _v0$336;
            case 60:
                if (_v0.b.$ === 60) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x4.aaO, msg, model);
                } else break _v0$336;
            case 61:
                if (_v0.b.$ === 61) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x5.aaO, msg, model);
                } else break _v0$336;
            case 62:
                if (_v0.b.$ === 62) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x6.aaO, msg, model);
                } else break _v0$336;
            case 63:
                if (_v0.b.$ === 63) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yk.aaO, msg, model);
                } else break _v0$336;
            case 64:
                if (_v0.b.$ === 64) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yl.aaO, msg, model);
                } else break _v0$336;
            case 65:
                if (_v0.b.$ === 65) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ym.aaO, msg, model);
                } else break _v0$336;
            case 66:
                if (_v0.b.$ === 66) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yT.aaO, msg, model);
                } else break _v0$336;
            case 67:
                if (_v0.b.$ === 67) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.y5.aaO, msg, model);
                } else break _v0$336;
            case 68:
                if (_v0.b.$ === 68) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.y6.aaO, msg, model);
                } else break _v0$336;
            case 69:
                if (_v0.b.$ === 69) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.y7.aaO, msg, model);
                } else break _v0$336;
            case 70:
                if (_v0.b.$ === 70) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.za.aaO, msg, model);
                } else break _v0$336;
            case 71:
                if (_v0.b.$ === 71) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zb.aaO, msg, model);
                } else break _v0$336;
            case 72:
                if (_v0.b.$ === 72) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zf.aaO, msg, model);
                } else break _v0$336;
            case 73:
                if (_v0.b.$ === 73) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zw.aaO, msg, model);
                } else break _v0$336;
            case 74:
                if (_v0.b.$ === 74) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zx.aaO, msg, model);
                } else break _v0$336;
            case 75:
                if (_v0.b.$ === 75) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zy.aaO, msg, model);
                } else break _v0$336;
            case 76:
                if (_v0.b.$ === 76) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zz.aaO, msg, model);
                } else break _v0$336;
            case 77:
                if (_v0.b.$ === 77) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zA.aaO, msg, model);
                } else break _v0$336;
            case 78:
                if (_v0.b.$ === 78) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zE.aaO, msg, model);
                } else break _v0$336;
            case 79:
                if (_v0.b.$ === 79) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zF.aaO, msg, model);
                } else break _v0$336;
            case 80:
                if (_v0.b.$ === 80) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zS.aaO, msg, model);
                } else break _v0$336;
            case 81:
                if (_v0.b.$ === 81) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Aj.aaO, msg, model);
                } else break _v0$336;
            case 82:
                if (_v0.b.$ === 82) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Ak.aaO, msg, model);
                } else break _v0$336;
            case 83:
                if (_v0.b.$ === 83) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.An.aaO, msg, model);
                } else break _v0$336;
            case 84:
                if (_v0.b.$ === 84) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Ao.aaO, msg, model);
                } else break _v0$336;
            case 85:
                if (_v0.b.$ === 85) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Aq.aaO, msg, model);
                } else break _v0$336;
            case 86:
                if (_v0.b.$ === 86) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Aw.aaO, msg, model);
                } else break _v0$336;
            case 87:
                if (_v0.b.$ === 87) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AE.aaO, msg, model);
                } else break _v0$336;
            case 88:
                if (_v0.b.$ === 88) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AZ.aaO, msg, model);
                } else break _v0$336;
            case 89:
                if (_v0.b.$ === 89) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bd.aaO, msg, model);
                } else break _v0$336;
            case 90:
                if (_v0.b.$ === 90) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Be.aaO, msg, model);
                } else break _v0$336;
            case 91:
                if (_v0.b.$ === 91) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bf.aaO, msg, model);
                } else break _v0$336;
            case 92:
                if (_v0.b.$ === 92) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bg.aaO, msg, model);
                } else break _v0$336;
            case 93:
                if (_v0.b.$ === 93) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bh.aaO, msg, model);
                } else break _v0$336;
            case 94:
                if (_v0.b.$ === 94) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bi.aaO, msg, model);
                } else break _v0$336;
            case 95:
                if (_v0.b.$ === 95) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bj.aaO, msg, model);
                } else break _v0$336;
            case 96:
                if (_v0.b.$ === 96) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bm.aaO, msg, model);
                } else break _v0$336;
            case 97:
                if (_v0.b.$ === 97) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BM.aaO, msg, model);
                } else break _v0$336;
            case 98:
                if (_v0.b.$ === 98) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BN.aaO, msg, model);
                } else break _v0$336;
            case 99:
                if (_v0.b.$ === 99) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BP.aaO, msg, model);
                } else break _v0$336;
            case 100:
                if (_v0.b.$ === 100) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BT.aaO, msg, model);
                } else break _v0$336;
            case 101:
                if (_v0.b.$ === 101) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BU.aaO, msg, model);
                } else break _v0$336;
            case 102:
                if (_v0.b.$ === 102) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BW.aaO, msg, model);
                } else break _v0$336;
            case 103:
                if (_v0.b.$ === 103) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BX.aaO, msg, model);
                } else break _v0$336;
            case 104:
                if (_v0.b.$ === 104) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BY.aaO, msg, model);
                } else break _v0$336;
            case 105:
                if (_v0.b.$ === 105) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BZ.aaO, msg, model);
                } else break _v0$336;
            case 106:
                if (_v0.b.$ === 106) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.B_.aaO, msg, model);
                } else break _v0$336;
            case 107:
                if (_v0.b.$ === 107) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.B$.aaO, msg, model);
                } else break _v0$336;
            case 108:
                if (_v0.b.$ === 108) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.B1.aaO, msg, model);
                } else break _v0$336;
            case 109:
                if (_v0.b.$ === 109) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.B3.aaO, msg, model);
                } else break _v0$336;
            case 110:
                if (_v0.b.$ === 110) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.B5.aaO, msg, model);
                } else break _v0$336;
            case 111:
                if (_v0.b.$ === 111) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CO.aaO, msg, model);
                } else break _v0$336;
            case 112:
                if (_v0.b.$ === 112) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CP.aaO, msg, model);
                } else break _v0$336;
            case 113:
                if (_v0.b.$ === 113) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CQ.aaO, msg, model);
                } else break _v0$336;
            case 114:
                if (_v0.b.$ === 114) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CR.aaO, msg, model);
                } else break _v0$336;
            case 115:
                if (_v0.b.$ === 115) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CS.aaO, msg, model);
                } else break _v0$336;
            case 116:
                if (_v0.b.$ === 116) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CT.aaO, msg, model);
                } else break _v0$336;
            case 117:
                if (_v0.b.$ === 117) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CU.aaO, msg, model);
                } else break _v0$336;
            case 118:
                if (_v0.b.$ === 118) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CV.aaO, msg, model);
                } else break _v0$336;
            case 119:
                if (_v0.b.$ === 119) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CW.aaO, msg, model);
                } else break _v0$336;
            case 120:
                if (_v0.b.$ === 120) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CX.aaO, msg, model);
                } else break _v0$336;
            case 121:
                if (_v0.b.$ === 121) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CY.aaO, msg, model);
                } else break _v0$336;
            case 122:
                if (_v0.b.$ === 122) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.CZ.aaO, msg, model);
                } else break _v0$336;
            case 123:
                if (_v0.b.$ === 123) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C_.aaO, msg, model);
                } else break _v0$336;
            case 124:
                if (_v0.b.$ === 124) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C$.aaO, msg, model);
                } else break _v0$336;
            case 125:
                if (_v0.b.$ === 125) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C0.aaO, msg, model);
                } else break _v0$336;
            case 126:
                if (_v0.b.$ === 126) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C1.aaO, msg, model);
                } else break _v0$336;
            case 127:
                if (_v0.b.$ === 127) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C2.aaO, msg, model);
                } else break _v0$336;
            case 128:
                if (_v0.b.$ === 128) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C3.aaO, msg, model);
                } else break _v0$336;
            case 129:
                if (_v0.b.$ === 129) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C4.aaO, msg, model);
                } else break _v0$336;
            case 130:
                if (_v0.b.$ === 130) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C5.aaO, msg, model);
                } else break _v0$336;
            case 131:
                if (_v0.b.$ === 131) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C6.aaO, msg, model);
                } else break _v0$336;
            case 132:
                if (_v0.b.$ === 132) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C7.aaO, msg, model);
                } else break _v0$336;
            case 133:
                if (_v0.b.$ === 133) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C8.aaO, msg, model);
                } else break _v0$336;
            case 134:
                if (_v0.b.$ === 134) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.C9.aaO, msg, model);
                } else break _v0$336;
            case 135:
                if (_v0.b.$ === 135) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Da.aaO, msg, model);
                } else break _v0$336;
            case 136:
                if (_v0.b.$ === 136) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Db.aaO, msg, model);
                } else break _v0$336;
            case 137:
                if (_v0.b.$ === 137) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dc.aaO, msg, model);
                } else break _v0$336;
            case 138:
                if (_v0.b.$ === 138) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dd.aaO, msg, model);
                } else break _v0$336;
            case 139:
                if (_v0.b.$ === 139) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.De.aaO, msg, model);
                } else break _v0$336;
            case 140:
                if (_v0.b.$ === 140) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Df.aaO, msg, model);
                } else break _v0$336;
            case 141:
                if (_v0.b.$ === 141) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dg.aaO, msg, model);
                } else break _v0$336;
            case 142:
                if (_v0.b.$ === 142) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dh.aaO, msg, model);
                } else break _v0$336;
            case 143:
                if (_v0.b.$ === 143) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Di.aaO, msg, model);
                } else break _v0$336;
            case 144:
                if (_v0.b.$ === 144) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dj.aaO, msg, model);
                } else break _v0$336;
            case 145:
                if (_v0.b.$ === 145) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dk.aaO, msg, model);
                } else break _v0$336;
            case 146:
                if (_v0.b.$ === 146) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dl.aaO, msg, model);
                } else break _v0$336;
            case 147:
                if (_v0.b.$ === 147) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dm.aaO, msg, model);
                } else break _v0$336;
            case 148:
                if (_v0.b.$ === 148) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dn.aaO, msg, model);
                } else break _v0$336;
            case 149:
                if (_v0.b.$ === 149) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Do.aaO, msg, model);
                } else break _v0$336;
            case 150:
                if (_v0.b.$ === 150) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dp.aaO, msg, model);
                } else break _v0$336;
            case 151:
                if (_v0.b.$ === 151) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dq.aaO, msg, model);
                } else break _v0$336;
            case 152:
                if (_v0.b.$ === 152) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dr.aaO, msg, model);
                } else break _v0$336;
            case 153:
                if (_v0.b.$ === 153) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dt.aaO, msg, model);
                } else break _v0$336;
            case 154:
                if (_v0.b.$ === 154) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Du.aaO, msg, model);
                } else break _v0$336;
            case 155:
                if (_v0.b.$ === 155) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dv.aaO, msg, model);
                } else break _v0$336;
            case 156:
                if (_v0.b.$ === 156) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dw.aaO, msg, model);
                } else break _v0$336;
            case 157:
                if (_v0.b.$ === 157) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Dy.aaO, msg, model);
                } else break _v0$336;
            case 158:
                if (_v0.b.$ === 158) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DB.aaO, msg, model);
                } else break _v0$336;
            case 159:
                if (_v0.b.$ === 159) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DU.aaO, msg, model);
                } else break _v0$336;
            case 160:
                if (_v0.b.$ === 160) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DV.aaO, msg, model);
                } else break _v0$336;
            case 161:
                if (_v0.b.$ === 161) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DX.aaO, msg, model);
                } else break _v0$336;
            case 162:
                if (_v0.b.$ === 162) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DY.aaO, msg, model);
                } else break _v0$336;
            case 163:
                if (_v0.b.$ === 163) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vy.aaO, msg, model);
                } else break _v0$336;
            case 164:
                if (_v0.b.$ === 164) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.xz.aaO, msg, model);
                } else break _v0$336;
            case 165:
                if (_v0.b.$ === 165) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yx.aaO, msg, model);
                } else break _v0$336;
            case 166:
                if (_v0.b.$ === 166) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yV.aaO, msg, model);
                } else break _v0$336;
            case 167:
                if (_v0.b.$ === 167) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t_.aaO, msg, model);
                } else break _v0$336;
            case 168:
                if (_v0.b.$ === 168) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t6.aaO, msg, model);
                } else break _v0$336;
            case 169:
                if (_v0.b.$ === 169) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ub.aaO, msg, model);
                } else break _v0$336;
            case 170:
                if (_v0.b.$ === 170) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uf.aaO, msg, model);
                } else break _v0$336;
            case 171:
                if (_v0.b.$ === 171) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.um.aaO, msg, model);
                } else break _v0$336;
            case 172:
                if (_v0.b.$ === 172) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uk.aaO, msg, model);
                } else break _v0$336;
            case 173:
                if (_v0.b.$ === 173) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ut.aaO, msg, model);
                } else break _v0$336;
            case 174:
                if (_v0.b.$ === 174) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uy.aaO, msg, model);
                } else break _v0$336;
            case 175:
                if (_v0.b.$ === 175) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uY.aaO, msg, model);
                } else break _v0$336;
            case 176:
                if (_v0.b.$ === 176) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u$.aaO, msg, model);
                } else break _v0$336;
            case 177:
                if (_v0.b.$ === 177) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u1.aaO, msg, model);
                } else break _v0$336;
            case 178:
                if (_v0.b.$ === 178) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u7.aaO, msg, model);
                } else break _v0$336;
            case 179:
                if (_v0.b.$ === 179) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wp.aaO, msg, model);
                } else break _v0$336;
            case 180:
                if (_v0.b.$ === 180) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wr.aaO, msg, model);
                } else break _v0$336;
            case 181:
                if (_v0.b.$ === 181) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wI.aaO, msg, model);
                } else break _v0$336;
            case 182:
                if (_v0.b.$ === 182) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wP.aaO, msg, model);
                } else break _v0$336;
            case 183:
                if (_v0.b.$ === 183) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x0.aaO, msg, model);
                } else break _v0$336;
            case 184:
                if (_v0.b.$ === 184) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yj.aaO, msg, model);
                } else break _v0$336;
            case 185:
                if (_v0.b.$ === 185) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.y9.aaO, msg, model);
                } else break _v0$336;
            case 186:
                if (_v0.b.$ === 186) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ze.aaO, msg, model);
                } else break _v0$336;
            case 187:
                if (_v0.b.$ === 187) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zv.aaO, msg, model);
                } else break _v0$336;
            case 188:
                if (_v0.b.$ === 188) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zD.aaO, msg, model);
                } else break _v0$336;
            case 189:
                if (_v0.b.$ === 189) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zK.aaO, msg, model);
                } else break _v0$336;
            case 190:
                if (_v0.b.$ === 190) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.z3.aaO, msg, model);
                } else break _v0$336;
            case 191:
                if (_v0.b.$ === 191) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Am.aaO, msg, model);
                } else break _v0$336;
            case 192:
                if (_v0.b.$ === 192) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Ap.aaO, msg, model);
                } else break _v0$336;
            case 193:
                if (_v0.b.$ === 193) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Av.aaO, msg, model);
                } else break _v0$336;
            case 194:
                if (_v0.b.$ === 194) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AW.aaO, msg, model);
                } else break _v0$336;
            case 195:
                if (_v0.b.$ === 195) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BL.aaO, msg, model);
                } else break _v0$336;
            case 196:
                if (_v0.b.$ === 196) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DC.aaO, msg, model);
                } else break _v0$336;
            case 197:
                if (_v0.b.$ === 197) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.DW.aaO, msg, model);
                } else break _v0$336;
            case 198:
                if (_v0.b.$ === 198) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.tV.aaO, msg, model);
                } else break _v0$336;
            case 199:
                if (_v0.b.$ === 199) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.tW.aaO, msg, model);
                } else break _v0$336;
            case 200:
                if (_v0.b.$ === 200) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.tX.aaO, msg, model);
                } else break _v0$336;
            case 201:
                if (_v0.b.$ === 201) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.tY.aaO, msg, model);
                } else break _v0$336;
            case 202:
                if (_v0.b.$ === 202) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.tZ.aaO, msg, model);
                } else break _v0$336;
            case 203:
                if (_v0.b.$ === 203) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t5.aaO, msg, model);
                } else break _v0$336;
            case 204:
                if (_v0.b.$ === 204) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t7.aaO, msg, model);
                } else break _v0$336;
            case 205:
                if (_v0.b.$ === 205) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ua.aaO, msg, model);
                } else break _v0$336;
            case 206:
                if (_v0.b.$ === 206) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ue.aaO, msg, model);
                } else break _v0$336;
            case 207:
                if (_v0.b.$ === 207) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uh.aaO, msg, model);
                } else break _v0$336;
            case 208:
                if (_v0.b.$ === 208) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uj.aaO, msg, model);
                } else break _v0$336;
            case 209:
                if (_v0.b.$ === 209) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.un.aaO, msg, model);
                } else break _v0$336;
            case 210:
                if (_v0.b.$ === 210) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uo.aaO, msg, model);
                } else break _v0$336;
            case 211:
                if (_v0.b.$ === 211) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.up.aaO, msg, model);
                } else break _v0$336;
            case 212:
                if (_v0.b.$ === 212) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uq.aaO, msg, model);
                } else break _v0$336;
            case 213:
                if (_v0.b.$ === 213) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.us.aaO, msg, model);
                } else break _v0$336;
            case 214:
                if (_v0.b.$ === 214) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uv.aaO, msg, model);
                } else break _v0$336;
            case 215:
                if (_v0.b.$ === 215) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uw.aaO, msg, model);
                } else break _v0$336;
            case 216:
                if (_v0.b.$ === 216) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ux.aaO, msg, model);
                } else break _v0$336;
            case 217:
                if (_v0.b.$ === 217) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uI.aaO, msg, model);
                } else break _v0$336;
            case 218:
                if (_v0.b.$ === 218) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uJ.aaO, msg, model);
                } else break _v0$336;
            case 219:
                if (_v0.b.$ === 219) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uK.aaO, msg, model);
                } else break _v0$336;
            case 220:
                if (_v0.b.$ === 220) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uL.aaO, msg, model);
                } else break _v0$336;
            case 221:
                if (_v0.b.$ === 221) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uN.aaO, msg, model);
                } else break _v0$336;
            case 222:
                if (_v0.b.$ === 222) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uO.aaO, msg, model);
                } else break _v0$336;
            case 223:
                if (_v0.b.$ === 223) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uR.aaO, msg, model);
                } else break _v0$336;
            case 224:
                if (_v0.b.$ === 224) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uX.aaO, msg, model);
                } else break _v0$336;
            case 225:
                if (_v0.b.$ === 225) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u0.aaO, msg, model);
                } else break _v0$336;
            case 226:
                if (_v0.b.$ === 226) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u6.aaO, msg, model);
                } else break _v0$336;
            case 227:
                if (_v0.b.$ === 227) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vb.aaO, msg, model);
                } else break _v0$336;
            case 228:
                if (_v0.b.$ === 228) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vf.aaO, msg, model);
                } else break _v0$336;
            case 229:
                if (_v0.b.$ === 229) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vi.aaO, msg, model);
                } else break _v0$336;
            case 230:
                if (_v0.b.$ === 230) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vj.aaO, msg, model);
                } else break _v0$336;
            case 231:
                if (_v0.b.$ === 231) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vk.aaO, msg, model);
                } else break _v0$336;
            case 232:
                if (_v0.b.$ === 232) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vl.aaO, msg, model);
                } else break _v0$336;
            case 233:
                if (_v0.b.$ === 233) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vm.aaO, msg, model);
                } else break _v0$336;
            case 234:
                if (_v0.b.$ === 234) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wo.aaO, msg, model);
                } else break _v0$336;
            case 235:
                if (_v0.b.$ === 235) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wq.aaO, msg, model);
                } else break _v0$336;
            case 236:
                if (_v0.b.$ === 236) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wt.aaO, msg, model);
                } else break _v0$336;
            case 237:
                if (_v0.b.$ === 237) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wu.aaO, msg, model);
                } else break _v0$336;
            case 238:
                if (_v0.b.$ === 238) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wy.aaO, msg, model);
                } else break _v0$336;
            case 239:
                if (_v0.b.$ === 239) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wz.aaO, msg, model);
                } else break _v0$336;
            case 240:
                if (_v0.b.$ === 240) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wC.aaO, msg, model);
                } else break _v0$336;
            case 241:
                if (_v0.b.$ === 241) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wD.aaO, msg, model);
                } else break _v0$336;
            case 242:
                if (_v0.b.$ === 242) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wE.aaO, msg, model);
                } else break _v0$336;
            case 243:
                if (_v0.b.$ === 243) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wF.aaO, msg, model);
                } else break _v0$336;
            case 244:
                if (_v0.b.$ === 244) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.y8.aaO, msg, model);
                } else break _v0$336;
            case 245:
                if (_v0.b.$ === 245) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zc.aaO, msg, model);
                } else break _v0$336;
            case 246:
                if (_v0.b.$ === 246) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zu.aaO, msg, model);
                } else break _v0$336;
            case 247:
                if (_v0.b.$ === 247) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zI.aaO, msg, model);
                } else break _v0$336;
            case 248:
                if (_v0.b.$ === 248) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.z4.aaO, msg, model);
                } else break _v0$336;
            case 249:
                if (_v0.b.$ === 249) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.z5.aaO, msg, model);
                } else break _v0$336;
            case 250:
                if (_v0.b.$ === 250) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.z6.aaO, msg, model);
                } else break _v0$336;
            case 251:
                if (_v0.b.$ === 251) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.z7.aaO, msg, model);
                } else break _v0$336;
            case 252:
                if (_v0.b.$ === 252) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Al.aaO, msg, model);
                } else break _v0$336;
            case 253:
                if (_v0.b.$ === 253) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Ar.aaO, msg, model);
                } else break _v0$336;
            case 254:
                if (_v0.b.$ === 254) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.As.aaO, msg, model);
                } else break _v0$336;
            case 255:
                if (_v0.b.$ === 255) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.At.aaO, msg, model);
                } else break _v0$336;
            case 256:
                if (_v0.b.$ === 256) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Au.aaO, msg, model);
                } else break _v0$336;
            case 257:
                if (_v0.b.$ === 257) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Ax.aaO, msg, model);
                } else break _v0$336;
            case 258:
                if (_v0.b.$ === 258) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Ay.aaO, msg, model);
                } else break _v0$336;
            case 259:
                if (_v0.b.$ === 259) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AK.aaO, msg, model);
                } else break _v0$336;
            case 260:
                if (_v0.b.$ === 260) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AL.aaO, msg, model);
                } else break _v0$336;
            case 261:
                if (_v0.b.$ === 261) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AM.aaO, msg, model);
                } else break _v0$336;
            case 262:
                if (_v0.b.$ === 262) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AN.aaO, msg, model);
                } else break _v0$336;
            case 263:
                if (_v0.b.$ === 263) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AO.aaO, msg, model);
                } else break _v0$336;
            case 264:
                if (_v0.b.$ === 264) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AS.aaO, msg, model);
                } else break _v0$336;
            case 265:
                if (_v0.b.$ === 265) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AX.aaO, msg, model);
                } else break _v0$336;
            case 266:
                if (_v0.b.$ === 266) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bl.aaO, msg, model);
                } else break _v0$336;
            case 267:
                if (_v0.b.$ === 267) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BO.aaO, msg, model);
                } else break _v0$336;
            case 268:
                if (_v0.b.$ === 268) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BQ.aaO, msg, model);
                } else break _v0$336;
            case 269:
                if (_v0.b.$ === 269) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BS.aaO, msg, model);
                } else break _v0$336;
            case 270:
                if (_v0.b.$ === 270) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BV.aaO, msg, model);
                } else break _v0$336;
            case 271:
                if (_v0.b.$ === 271) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.B0.aaO, msg, model);
                } else break _v0$336;
            case 272:
                if (_v0.b.$ === 272) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.B2.aaO, msg, model);
                } else break _v0$336;
            case 273:
                if (_v0.b.$ === 273) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.B4.aaO, msg, model);
                } else break _v0$336;
            case 274:
                if (_v0.b.$ === 274) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t4.aaO, msg, model);
                } else break _v0$336;
            case 275:
                if (_v0.b.$ === 275) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t9.aaO, msg, model);
                } else break _v0$336;
            case 276:
                if (_v0.b.$ === 276) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ud.aaO, msg, model);
                } else break _v0$336;
            case 277:
                if (_v0.b.$ === 277) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ul.aaO, msg, model);
                } else break _v0$336;
            case 278:
                if (_v0.b.$ === 278) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ui.aaO, msg, model);
                } else break _v0$336;
            case 279:
                if (_v0.b.$ === 279) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ur.aaO, msg, model);
                } else break _v0$336;
            case 280:
                if (_v0.b.$ === 280) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uB.aaO, msg, model);
                } else break _v0$336;
            case 281:
                if (_v0.b.$ === 281) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uU.aaO, msg, model);
                } else break _v0$336;
            case 282:
                if (_v0.b.$ === 282) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.u5.aaO, msg, model);
                } else break _v0$336;
            case 283:
                if (_v0.b.$ === 283) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.x$.aaO, msg, model);
                } else break _v0$336;
            case 284:
                if (_v0.b.$ === 284) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zt.aaO, msg, model);
                } else break _v0$336;
            case 285:
                if (_v0.b.$ === 285) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zB.aaO, msg, model);
                } else break _v0$336;
            case 286:
                if (_v0.b.$ === 286) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zG.aaO, msg, model);
                } else break _v0$336;
            case 287:
                if (_v0.b.$ === 287) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zJ.aaO, msg, model);
                } else break _v0$336;
            case 288:
                if (_v0.b.$ === 288) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BK.aaO, msg, model);
                } else break _v0$336;
            case 289:
                if (_v0.b.$ === 289) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.BR.aaO, msg, model);
                } else break _v0$336;
            case 290:
                if (_v0.b.$ === 290) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vh.aaO, msg, model);
                } else break _v0$336;
            case 291:
                if (_v0.b.$ === 291) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wn.aaO, msg, model);
                } else break _v0$336;
            case 292:
                if (_v0.b.$ === 292) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wx.aaO, msg, model);
                } else break _v0$336;
            case 293:
                if (_v0.b.$ === 293) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wB.aaO, msg, model);
                } else break _v0$336;
            case 294:
                if (_v0.b.$ === 294) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wJ.aaO, msg, model);
                } else break _v0$336;
            case 295:
                if (_v0.b.$ === 295) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zd.aaO, msg, model);
                } else break _v0$336;
            case 296:
                if (_v0.b.$ === 296) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AF.aaO, msg, model);
                } else break _v0$336;
            case 297:
                if (_v0.b.$ === 297) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AG.aaO, msg, model);
                } else break _v0$336;
            case 298:
                if (_v0.b.$ === 298) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AJ.aaO, msg, model);
                } else break _v0$336;
            case 299:
                if (_v0.b.$ === 299) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AR.aaO, msg, model);
                } else break _v0$336;
            case 300:
                if (_v0.b.$ === 300) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AU.aaO, msg, model);
                } else break _v0$336;
            case 301:
                if (_v0.b.$ === 301) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AV.aaO, msg, model);
                } else break _v0$336;
            case 302:
                if (_v0.b.$ === 302) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uM.aaO, msg, model);
                } else break _v0$336;
            case 303:
                if (_v0.b.$ === 303) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wj.aaO, msg, model);
                } else break _v0$336;
            case 304:
                if (_v0.b.$ === 304) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wk.aaO, msg, model);
                } else break _v0$336;
            case 305:
                if (_v0.b.$ === 305) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wv.aaO, msg, model);
                } else break _v0$336;
            case 306:
                if (_v0.b.$ === 306) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wH.aaO, msg, model);
                } else break _v0$336;
            case 307:
                if (_v0.b.$ === 307) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yR.aaO, msg, model);
                } else break _v0$336;
            case 308:
                if (_v0.b.$ === 308) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yS.aaO, msg, model);
                } else break _v0$336;
            case 309:
                if (_v0.b.$ === 309) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yU.aaO, msg, model);
                } else break _v0$336;
            case 310:
                if (_v0.b.$ === 310) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yW.aaO, msg, model);
                } else break _v0$336;
            case 311:
                if (_v0.b.$ === 311) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yX.aaO, msg, model);
                } else break _v0$336;
            case 312:
                if (_v0.b.$ === 312) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.yY.aaO, msg, model);
                } else break _v0$336;
            case 313:
                if (_v0.b.$ === 313) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zH.aaO, msg, model);
                } else break _v0$336;
            case 314:
                if (_v0.b.$ === 314) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AQ.aaO, msg, model);
                } else break _v0$336;
            case 315:
                if (_v0.b.$ === 315) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.Bk.aaO, msg, model);
                } else break _v0$336;
            case 316:
                if (_v0.b.$ === 316) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.t0.aaO, msg, model);
                } else break _v0$336;
            case 317:
                if (_v0.b.$ === 317) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.vg.aaO, msg, model);
                } else break _v0$336;
            case 318:
                if (_v0.b.$ === 318) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wA.aaO, msg, model);
                } else break _v0$336;
            case 319:
                if (_v0.b.$ === 319) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wG.aaO, msg, model);
                } else break _v0$336;
            case 320:
                if (_v0.b.$ === 320) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.zC.aaO, msg, model);
                } else break _v0$336;
            case 321:
                if (_v0.b.$ === 321) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AT.aaO, msg, model);
                } else break _v0$336;
            case 322:
                if (_v0.b.$ === 322) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wi.aaO, msg, model);
                } else break _v0$336;
            case 323:
                if (_v0.b.$ === 323) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wm.aaO, msg, model);
                } else break _v0$336;
            case 324:
                if (_v0.b.$ === 324) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wK.aaO, msg, model);
                } else break _v0$336;
            case 325:
                if (_v0.b.$ === 325) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AH.aaO, msg, model);
                } else break _v0$336;
            case 326:
                if (_v0.b.$ === 326) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AI.aaO, msg, model);
                } else break _v0$336;
            case 327:
                if (_v0.b.$ === 327) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.AP.aaO, msg, model);
                } else break _v0$336;
            case 328:
                if (_v0.b.$ === 328) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uV.aaO, msg, model);
                } else break _v0$336;
            case 329:
                if (_v0.b.$ === 329) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wg.aaO, msg, model);
                } else break _v0$336;
            case 330:
                if (_v0.b.$ === 330) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wh.aaO, msg, model);
                } else break _v0$336;
            case 331:
                if (_v0.b.$ === 331) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wL.aaO, msg, model);
                } else break _v0$336;
            case 332:
                if (_v0.b.$ === 332) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.uW.aaO, msg, model);
                } else break _v0$336;
            case 333:
                if (_v0.b.$ === 333) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wl.aaO, msg, model);
                } else break _v0$336;
            case 334:
                if (_v0.b.$ === 334) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.wf.aaO, msg, model);
                } else break _v0$336;
            default:
                if (_v0.b.$ === 335) {
                    var msg = _v0.a.a;
                    var model = _v0.b.a;
                    return A2($author$project$Spa$Generated$Pages$pages.ww.aaO, msg, model);
                } else break _v0$336;
        }
        return _Utils_Tuple3(bigModel, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Layouts$Admin$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return _Utils_update(model, {
                nb: nav
            });
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
    });
    var $author$project$Layouts$Affiliates$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return _Utils_update(model, {
                nb: nav
            });
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb)));
    });
    var $author$project$Layouts$Affiliates$Affiliate$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                Eb: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var navMsg = msg.a;
            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Layouts$Affiliates$Affiliate$NavMsg), A2($elm$core$Tuple$mapFirst, function(nav) {
                return _Utils_update(model, {
                    nb: nav
                });
            }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
        }
    });
    var $author$project$Layouts$Commissions$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return _Utils_update(model, {
                nb: nav
            });
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb)));
    });
    var $author$project$Layouts$Commissions$BrokerAccount$update = F2(function(msg, model) {
        if (!msg.$) {
            var response = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                vR: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        } else {
            var navMsg = msg.a;
            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Layouts$Commissions$BrokerAccount$NavMsg), A2($elm$core$Tuple$mapFirst, function(nav) {
                return _Utils_update(model, {
                    nb: nav
                });
            }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
        }
    });
    var $author$project$Layouts$Company$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return _Utils_update(model, {
                nb: nav
            });
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb)));
    });
    var $author$project$Layouts$Marketplace$Manage$update = F2(function(msg, model) {
        if (!msg.$) {
            var navMsg = msg.a;
            return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Layouts$Marketplace$Manage$NavMsg), A2($elm$core$Tuple$mapFirst, function(nav) {
                return _Utils_update(model, {
                    nb: nav
                });
            }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
        } else {
            var response = msg.a;
            return _Utils_Tuple3(_Utils_update(model, {
                Rn: response
            }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(response));
        }
    });
    var $author$project$Layouts$Partner$Billing$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return _Utils_update(model, {
                nb: nav
            });
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
    });
    var $author$project$Layouts$Partner$Practices$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return _Utils_update(model, {
                nb: nav
            });
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
    });
    var $author$project$Layouts$Partner$Product$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return _Utils_update(model, {
                nb: nav
            });
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
    });
    var $author$project$Layouts$Partner$Webhooks$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return _Utils_update(model, {
                nb: nav
            });
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
    });
    var $author$project$Layouts$Patient$GotAffiliateSyncDetail = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Layouts$Patient$GotNetworkSyncDetail = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$Provider$Organization$Min$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$Organization$Shared$id = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Organization$Min$id(min);
    };
    var $author$project$Api$Provider$Patient$SyncDetail$Network = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$SyncDetail$networkDecoder = $elm$json$Json$Decode$nullable(A2($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom, $author$project$Api$Provider$Patient$SyncDetail$recordDecoder, A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt, _List_fromArray([
        'affiliate',
        'name'
    ]), $elm$json$Json$Decode$string, $elm$json$Json$Decode$succeed($author$project$Api$Provider$Patient$SyncDetail$Network))));
    var $author$project$Api$Provider$SyncDetail$retrieveNetwork = F3(function(apiClient, patientId, toMsg) {
        return A4($author$project$Api$Data$get, apiClient, $author$project$Api$Provider$Patient$SyncDetail$networkDecoder, toMsg, $author$project$Api$Data$requestTo(A2($author$project$Api$Data$pathAppend, _List_fromArray([
            'sync_details',
            'network'
        ]), $author$project$Api$Provider$Patient$patientPath(patientId))));
    });
    var $author$project$Layouts$Patient$update = F3(function(apiClient, msg, model) {
        switch(msg.$){
            case 0:
                var navMsg = msg.a;
                return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Layouts$Patient$NavMsg), A2($elm$core$Tuple$mapFirst, function(newNav) {
                    return _Utils_update(model, {
                        nb: newNav
                    });
                }, A2($author$project$Ui$Nav$update, navMsg, model.nb))));
            case 1:
                var _v1 = model.jh;
                if (!_v1.$) return _Utils_Tuple3(_Utils_update(model, {
                    jh: $author$project$Api$Data$Loading
                }), A3($author$project$Api$Provider$SyncDetail$retrieveNetwork, apiClient, model.V8, $author$project$Layouts$Patient$GotNetworkSyncDetail), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                var _v2 = model.hw;
                if (!_v2.$) return _Utils_Tuple3(_Utils_update(model, {
                    hw: $author$project$Api$Data$Loading
                }), A4($author$project$Api$Provider$SyncDetail$retrieveAffiliate, apiClient, model.V8, $elm$core$Basics$identity, $author$project$Layouts$Patient$GotAffiliateSyncDetail), _List_Nil);
                else return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 2:
                var data = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    jh: data
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(data));
            case 4:
                var data = msg.a;
                return _Utils_Tuple3(_Utils_update(model, {
                    hw: data
                }), $elm$core$Platform$Cmd$none, $author$project$OutMsg$handleErrorResponse(data));
            default:
                var organization = msg.a;
                var patientId = msg.b;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_fromArray([
                    A3($author$project$OutMsg$SwitchToOrganization, $author$project$Api$Provider$Organization$Shared$id(organization), $elm$core$Maybe$Nothing, $author$project$OutMsg$GoToRouteAndReloadAction($author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                        V8: patientId
                    })))
                ]));
        }
    });
    var $author$project$Layouts$User$update = F2(function(msg, model) {
        var navMsg = msg;
        return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($elm$core$Basics$identity), A2($elm$core$Tuple$mapFirst, function(nav) {
            return {
                nb: nav
            };
        }, A2($author$project$Ui$Nav$update, navMsg, model.nb)));
    });
    var $author$project$Spa$Layout$update = F3(function(apiClient, msg, model) {
        var _v0 = _Utils_Tuple2(model, msg);
        _v0$21: while(true)switch(_v0.a.$){
            case 5:
                if (!_v0.b.$) {
                    var _v1 = _v0.a;
                    var id = _v1.a;
                    var layoutModel = _v1.b;
                    var subMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$CommissionsBrokerAccountModel(id), A2($author$project$Layouts$Commissions$BrokerAccount$update, subMsg, layoutModel)));
                } else break _v0$21;
            case 7:
                if (_v0.b.$ === 1) {
                    var _v2 = _v0.a;
                    var id = _v2.a;
                    var layoutModel = _v2.b;
                    var subMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$AffiliatesAffiliateModel(id), A2($author$project$Layouts$Affiliates$Affiliate$update, subMsg, layoutModel)));
                } else break _v0$21;
            case 8:
                if (_v0.b.$ === 2) {
                    var layoutModel = _v0.a.a;
                    var subMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$PartnerBillingModel, A2($author$project$Layouts$Partner$Billing$update, subMsg, layoutModel)));
                } else break _v0$21;
            case 9:
                if (_v0.b.$ === 3) {
                    var layoutModel = _v0.a.a;
                    var subMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$PartnerPracticesModel, A2($author$project$Layouts$Partner$Practices$update, subMsg, layoutModel)));
                } else break _v0$21;
            case 10:
                if (_v0.b.$ === 4) {
                    var layoutModel = _v0.a.a;
                    var subMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$PartnerProductModel, A2($author$project$Layouts$Partner$Product$update, subMsg, layoutModel)));
                } else break _v0$21;
            case 11:
                if (_v0.b.$ === 5) {
                    var layoutModel = _v0.a.a;
                    var subMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerWebhooksMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$PartnerWebhooksModel, A2($author$project$Layouts$Partner$Webhooks$update, subMsg, layoutModel)));
                } else break _v0$21;
            case 12:
                if (_v0.b.$ === 6) {
                    var _v3 = _v0.a;
                    var slug = _v3.a;
                    var layoutModel = _v3.b;
                    var subMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$MarketplaceManageModel(slug), A2($author$project$Layouts$Marketplace$Manage$update, subMsg, layoutModel)));
                } else break _v0$21;
            case 14:
                if (_v0.b.$ === 11) {
                    var layout = _v0.a.a;
                    var layoutMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$AdminModel, A2($author$project$Layouts$Admin$update, layoutMsg, layout)));
                } else break _v0$21;
            case 0:
                var _v4 = _v0.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 18:
                var _v5 = _v0.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 1:
                var _v6 = _v0.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 3:
                if (_v0.b.$ === 7) {
                    var _v7 = _v0.a;
                    var id = _v7.a;
                    var layoutModel = _v7.b;
                    var patMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg), A2($author$project$Utils$Tuple3$mapFirst, $author$project$Spa$Layout$PatientAndSidebarModel(id), A3($author$project$Layouts$Patient$update, apiClient, patMsg, layoutModel)));
                } else {
                    var _v8 = _v0.a;
                    return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
                }
            case 2:
                var _v9 = _v0.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 13:
                if (_v0.b.$ === 8) {
                    var _v10 = _v0.a;
                    var id = _v10.a;
                    var layout = _v10.b;
                    var layoutMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CompanyModel(id), A2($author$project$Layouts$Company$update, layoutMsg, layout))));
                } else break _v0$21;
            case 4:
                if (_v0.b.$ === 9) {
                    var layout = _v0.a.a;
                    var layoutMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CommissionsModel, A2($author$project$Layouts$Commissions$update, layoutMsg, layout))));
                } else break _v0$21;
            case 6:
                if (_v0.b.$ === 10) {
                    var layout = _v0.a.a;
                    var layoutMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AffiliatesModel, A2($author$project$Layouts$Affiliates$update, layoutMsg, layout))));
                } else break _v0$21;
            case 19:
                if (_v0.b.$ === 12) {
                    var layout = _v0.a.a;
                    var layoutMsg = _v0.b.a;
                    return A2($author$project$Utils$Tuple3$fromTuple2, _List_Nil, A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$UserModel, A2($author$project$Layouts$User$update, layoutMsg, layout))));
                } else break _v0$21;
            case 15:
                var _v11 = _v0.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 16:
                var _v12 = _v0.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            case 17:
                var _v13 = _v0.a;
                return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
            default:
                break _v0$21;
        }
        return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, _List_Nil);
    });
    var $author$project$Layouts$Admin$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Layouts$Affiliates$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Affiliates$Affiliate$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Commissions$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Commissions$BrokerAccount$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Company$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Marketplace$Manage$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Layouts$Partner$Billing$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Partner$Practices$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Partner$Product$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Partner$Webhooks$load = function(model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    };
    var $author$project$Layouts$Patient$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            V7: shared.MO
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Layouts$PatientChart$load = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            V7: shared.MO
        }), $elm$core$Platform$Cmd$none);
    });
    var $author$project$Layouts$User$load = F2(function(_v0, model) {
        return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Spa$Layout$load = F2(function(shared, model) {
        switch(model.$){
            case 5:
                var id = model.a;
                var layoutModel = model.b;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsBrokerAccountMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CommissionsBrokerAccountModel(id), $author$project$Layouts$Commissions$BrokerAccount$load(layoutModel)));
            case 7:
                var id = model.a;
                var layoutModel = model.b;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AffiliatesAffiliateMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AffiliatesAffiliateModel(id), $author$project$Layouts$Affiliates$Affiliate$load(layoutModel)));
            case 8:
                var layout = model.a;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerBillingMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerBillingModel, $author$project$Layouts$Partner$Billing$load(layout)));
            case 9:
                var layout = model.a;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerPracticesMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerPracticesModel, $author$project$Layouts$Partner$Practices$load(layout)));
            case 10:
                var layout = model.a;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerProductMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerProductModel, $author$project$Layouts$Partner$Product$load(layout)));
            case 11:
                var layout = model.a;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PartnerWebhooksMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PartnerWebhooksModel, $author$project$Layouts$Partner$Webhooks$load(layout)));
            case 12:
                var slug = model.a;
                var layout = model.b;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$MarketplaceManageModel(slug), A2($author$project$Layouts$Marketplace$Manage$load, shared, layout)));
            case 14:
                var layout = model.a;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AdminModel, A2($author$project$Layouts$Admin$load, shared, layout)));
            case 0:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 18:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 1:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 3:
                var id = model.a;
                var layout = model.b;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$PatientMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PatientAndSidebarModel(id), A2($author$project$Layouts$Patient$load, shared, layout)));
            case 2:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 13:
                var id = model.a;
                var layout = model.b;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CompanyMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CompanyModel(id), $author$project$Layouts$Company$load(layout)));
            case 4:
                var layout = model.a;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$CommissionsMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$CommissionsModel, $author$project$Layouts$Commissions$load(layout)));
            case 6:
                var layout = model.a;
                return A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AffiliatesModel, $author$project$Layouts$Affiliates$load(layout));
            case 20:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 19:
                var layout = model.a;
                return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$UserMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$UserModel, A2($author$project$Layouts$User$load, shared, layout)));
            case 15:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 16:
                return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            default:
                var id = model.a;
                var layout = model.b;
                return A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$PatientChartModel(id), A2($author$project$Layouts$PatientChart$load, shared, layout));
        }
    });
    var $author$project$Layouts$Marketplace$Manage$refresh = F2(function(shared, model) {
        return _Utils_Tuple2(_Utils_update(model, {
            Rn: $author$project$Api$Data$Loading
        }), A3($author$project$Api$Provider$Integration$retrieve, shared.Ej, model._A, $author$project$Layouts$Marketplace$Manage$GotIntegration));
    });
    var $author$project$Spa$Layout$refresh = F2(function(shared, model) {
        if (model.$ === 12) {
            var slug = model.a;
            var layout = model.b;
            return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$MarketplaceManageMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$MarketplaceManageModel(slug), A2($author$project$Layouts$Marketplace$Manage$refresh, shared, layout)));
        } else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
    });
    var $author$project$Main$updateLayout = F3(function(shared, outMsgs, layout) {
        var refreshLayout = A2($elm$core$List$member, $author$project$OutMsg$RefreshLayout, outMsgs);
        return function(_v0) {
            var loadedLayout = _v0.a;
            var loadedLayoutCmd = _v0.b;
            return refreshLayout ? A2($elm$core$Tuple$mapSecond, function(refreshLayoutCmd) {
                return $elm$core$Platform$Cmd$batch(_List_fromArray([
                    loadedLayoutCmd,
                    refreshLayoutCmd
                ]));
            }, A2($author$project$Spa$Layout$refresh, shared, loadedLayout)) : _Utils_Tuple2(loadedLayout, loadedLayoutCmd);
        }(A2($author$project$Spa$Layout$load, shared, layout));
    });
    var $author$project$Ports$PageTitle$updateTabTitle = _Platform_outgoingPort('updateTabTitle', $elm$json$Json$Encode$string);
    var $author$project$Utils$Release$newReleaseAvailable = function(_v0) {
        var model = _v0;
        return model.zs;
    };
    var $author$project$Ports$Intercom$intercomPortUpdate = _Platform_outgoingPort('intercomPortUpdate', function($) {
        return $elm$json$Json$Encode$null;
    });
    var $author$project$Ports$Intercom$update = function(session) {
        return $author$project$Api$Platform$Session$One$organizationIsCompany(session) ? $elm$core$Platform$Cmd$none : $author$project$Ports$Intercom$intercomPortUpdate(0);
    };
    var $author$project$Shared$updateIntercom = function(session) {
        if (session.$ === 3) {
            var session_ = session.a;
            return $author$project$Ports$Intercom$update(session_);
        } else return $elm$core$Platform$Cmd$none;
    };
    var $author$project$Components$GlobalSearch$urlChanged = F2(function(url, model) {
        if (!model.$) {
            var closedModel = model.a;
            return $author$project$Components$GlobalSearch$Closed(_Utils_update(closedModel, {
                aaT: url
            }));
        } else {
            var openModel = model.a;
            return $author$project$Components$GlobalSearch$Open(_Utils_update(openModel, {
                aaT: url
            }));
        }
    });
    var $author$project$Components$PatientsList$urlChanged = F2(function(url, model) {
        return _Utils_update(model, {
            aaT: url
        });
    });
    var $author$project$Navbars$Company$urlChanged = F2(function(url, _v0) {
        var model = _v0;
        var newSelectedNav = $author$project$Navbars$Company$navItemFromUrl(url);
        return _Utils_update(model, {
            c5: $author$project$Navbars$Company$openSubNavFromSelectedNav(newSelectedNav),
            et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Company$ProfileMenuMsg),
            eI: newSelectedNav
        });
    });
    var $author$project$Navbars$Partner$urlChanged = F2(function(url, _v0) {
        var model = _v0;
        var newSelectedNav = $author$project$Navbars$Partner$navItemFromUrl(url);
        return _Utils_update(model, {
            c5: $author$project$Navbars$Partner$openSubNavFromSelectedNav(newSelectedNav),
            et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Partner$ProfileMenuMsg),
            eI: newSelectedNav
        });
    });
    var $author$project$Navbars$Practice$urlChanged = F2(function(url, _v0) {
        var model = _v0;
        var newSelectedNav = $author$project$Navbars$Practice$Navigation$navItemFromUrl(url);
        return _Utils_update(model, {
            c5: $author$project$Navbars$Practice$openSubNavFromSelectedNav(newSelectedNav),
            et: A2($author$project$Ui$FlyoutMenu$init, 'profile-menu', $author$project$Navbars$Practice$ProfileMenuMsg),
            eI: newSelectedNav
        });
    });
    var $author$project$Navbar$navbarUrlChanged = F2(function(url, navBar) {
        switch(navBar.$){
            case 0:
                return navBar;
            case 1:
                var model = navBar.a;
                return $author$project$Navbar$PracticeNav(A2($author$project$Navbars$Practice$urlChanged, url, model));
            case 2:
                var model = navBar.a;
                return $author$project$Navbar$CompanyNav(A2($author$project$Navbars$Company$urlChanged, url, model));
            default:
                var model = navBar.a;
                return $author$project$Navbar$PartnerNav(A2($author$project$Navbars$Partner$urlChanged, url, model));
        }
    });
    var $author$project$Navbar$urlChanged = F2(function(url, _v0) {
        var model = _v0;
        return _Utils_update(model, {
            ad: A2($author$project$Navbar$navbarUrlChanged, url, model.ad),
            aaT: url
        });
    });
    var $author$project$Shared$urlChanged = F2(function(url, model) {
        var session = $author$project$Api$Data$toMaybe(model.Z$);
        var shouldInitNavbar = !_Utils_eq(session, $elm$core$Maybe$Nothing) && _Utils_eq(model.ae, $elm$core$Maybe$Nothing);
        var _v0 = shouldInitNavbar ? $author$project$Shared$initNavbar(_Utils_Tuple2(_Utils_update(model, {
            aaT: url
        }), $elm$core$Platform$Cmd$none)) : _Utils_Tuple2(_Utils_update(model, {
            aaT: url
        }), $elm$core$Platform$Cmd$none);
        var modelUpdated = _v0.a;
        var navBarResultCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(modelUpdated, {
            fP: A2($author$project$Components$GlobalSearch$urlChanged, url, modelUpdated.fP),
            ae: A2($elm$core$Maybe$map, $author$project$Navbar$urlChanged(url), modelUpdated.ae),
            af4: A2($elm$core$Maybe$map, $author$project$Components$PatientsList$urlChanged(url), model.af4),
            af8: $elm$core$Maybe$Nothing,
            Wx: $elm$core$Maybe$Nothing
        }), $elm$core$Platform$Cmd$batch(_List_fromArray([
            !_Utils_eq(model.aaT.V6, url.V6) && $author$project$Utils$Release$newReleaseAvailable(model.agH) ? $elm$browser$Browser$Navigation$reload : $elm$core$Platform$Cmd$none,
            navBarResultCmd,
            $author$project$Shared$updateIntercom(modelUpdated.Z$)
        ])));
    });
    var $author$project$Layouts$Admin$initNav = function(model) {
        var _v0 = A2($author$project$Ui$Nav$init, 'admin-nav', $elm$core$Basics$identity);
        var nav = _v0.a;
        var navCmd = _v0.b;
        return _Utils_Tuple2(_Utils_update(model, {
            nb: nav
        }), navCmd);
    };
    var $author$project$Ui$Nav$recalculateActiveTab = function(_v0) {
        var model = _v0;
        return $author$project$Ports$NavTabs$navTabActiveChanged(model.aef);
    };
    var $author$project$Layouts$Patient$refreshNav = function(model) {
        return $author$project$Ui$Nav$recalculateActiveTab(model.nb);
    };
    var $author$project$Spa$Layout$urlChanged = F2(function(shared, layoutModel) {
        var _v0 = _Utils_Tuple2($author$project$Spa$Layout$routeToLayout(shared.aaT), layoutModel);
        _v0$15: while(true)switch(_v0.a.$){
            case 13:
                if (_v0.b.$ === 13) {
                    var newId = _v0.a.a;
                    var _v1 = _v0.b;
                    var currentId = _v1.a;
                    return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
                } else break _v0$15;
            case 7:
                if (_v0.b.$ === 7) {
                    var newId = _v0.a.a;
                    var _v2 = _v0.b;
                    var currentId = _v2.a;
                    return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
                } else break _v0$15;
            case 8:
                if (_v0.b.$ === 8) {
                    var _v3 = _v0.a;
                    return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
                } else break _v0$15;
            case 9:
                if (_v0.b.$ === 9) {
                    var _v4 = _v0.a;
                    return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
                } else break _v0$15;
            case 11:
                if (_v0.b.$ === 11) {
                    var _v5 = _v0.a;
                    return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
                } else break _v0$15;
            case 12:
                if (_v0.b.$ === 12) {
                    var newSlug = _v0.a.a;
                    var _v6 = _v0.b;
                    var currentSlug = _v6.a;
                    return _Utils_eq(newSlug, currentSlug) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
                } else break _v0$15;
            case 5:
                if (_v0.b.$ === 5) {
                    var newId = _v0.a.a;
                    var _v7 = _v0.b;
                    var currentId = _v7.a;
                    return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
                } else break _v0$15;
            case 3:
                if (_v0.b.$ === 3) {
                    var newId = _v0.a.a;
                    var _v8 = _v0.b;
                    var currentId = _v8.a;
                    var patientLayoutModel = _v8.b;
                    return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, A2($elm$core$Platform$Cmd$map, $author$project$Spa$Layout$PatientMsg, $author$project$Layouts$Patient$refreshNav(patientLayoutModel))) : $author$project$Spa$Layout$init(shared);
                } else break _v0$15;
            case 4:
                if (_v0.b.$ === 4) {
                    var _v9 = _v0.a;
                    return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
                } else break _v0$15;
            case 6:
                if (_v0.b.$ === 6) {
                    var _v10 = _v0.a;
                    return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
                } else break _v0$15;
            case 14:
                if (_v0.b.$ === 14) {
                    var _v11 = _v0.a;
                    var adminModel = _v0.b.a;
                    return A2($elm$core$Tuple$mapSecond, $elm$core$Platform$Cmd$map($author$project$Spa$Layout$AdminMsg), A2($elm$core$Tuple$mapFirst, $author$project$Spa$Layout$AdminModel, $author$project$Layouts$Admin$initNav(adminModel)));
                } else break _v0$15;
            case 2:
                if (_v0.b.$ === 2) {
                    var _v12 = _v0.a;
                    var _v13 = _v0.b;
                    return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
                } else break _v0$15;
            case 17:
                if (_v0.b.$ === 19) {
                    var _v14 = _v0.a;
                    return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
                } else break _v0$15;
            case 18:
                if (_v0.b.$ === 16) {
                    var _v15 = _v0.a;
                    var _v16 = _v0.b;
                    return _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none);
                } else break _v0$15;
            case 19:
                if (_v0.b.$ === 17) {
                    var newId = _v0.a.a;
                    var _v17 = _v0.b;
                    var currentId = _v17.a;
                    return _Utils_eq(newId, currentId) ? _Utils_Tuple2(layoutModel, $elm$core$Platform$Cmd$none) : $author$project$Spa$Layout$init(shared);
                } else break _v0$15;
            default:
                break _v0$15;
        }
        return $author$project$Spa$Layout$init(shared);
    });
    var $author$project$Spa$Generated$Pages$view = function(model) {
        return $author$project$Spa$Generated$Pages$bundle(model).aid(0);
    };
    var $author$project$Main$update = F2(function(msg, model) {
        switch(msg.$){
            case 5:
                var attempts = msg.a;
                var fragment = msg.b;
                var result = msg.c;
                if (result.$ === 1) return _Utils_Tuple2(model, A2($author$project$Main$attemptScrollingToFragment, attempts + 1, fragment));
                else return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
            case 1:
                var url = msg.a;
                var isLocal = msg.b;
                var shouldOpenInNewWindow = msg.c;
                var original = model.Cu;
                var hasPendingChanges = !_Utils_eq(original.af8, $elm$core$Maybe$Nothing);
                return _Utils_Tuple2(shouldOpenInNewWindow ? model : hasPendingChanges && _Utils_eq(original.Wx, $elm$core$Maybe$Nothing) ? _Utils_update(model, {
                    Cu: _Utils_update(original, {
                        Wx: $elm$core$Maybe$Just(_Utils_Tuple2(url, isLocal))
                    })
                }) : model, hasPendingChanges ? $elm$core$Platform$Cmd$none : isLocal ? $author$project$Ports$Navigation$pushUrl(url) : shouldOpenInNewWindow ? $elm$core$Platform$Cmd$none : $author$project$Ports$Navigation$load(url));
            case 0:
                var locationHref = msg.a;
                if (model.Cu.adU.adj && !_Utils_eq(model.d, $author$project$Spa$Generated$Route$Blank)) return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
                else {
                    var original = model.Cu;
                    var _v2 = $author$project$Main$locationHrefToUrl(locationHref);
                    var url = _v2.a;
                    var defaultUrlCmd = _v2.b;
                    var _v3 = A2($author$project$Shared$urlChanged, url, original);
                    var shared = _v3.a;
                    var urlChangedCmd = _v3.b;
                    var _v4 = A2($author$project$Spa$Layout$urlChanged, shared, model.ba);
                    var layout = _v4.a;
                    var layoutCmd = _v4.b;
                    var initPage = !_Utils_eq(original.aaT.V6, shared.aaT.V6) || _Utils_eq(model.d, $author$project$Spa$Generated$Route$Blank);
                    var route = $author$project$Utils$Route$fromUrl(url);
                    var _v5 = initPage ? A2($author$project$Spa$Generated$Pages$init, route, shared) : _Utils_Tuple3(model.GM, $elm$core$Platform$Cmd$none, _List_Nil);
                    var page = _v5.a;
                    var pageCmd = _v5.b;
                    var outMsgs = _v5.c;
                    var _v6 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, A2($author$project$Spa$Generated$Pages$save, page, shared));
                    var newShared = _v6.a;
                    var sharedCmd = _v6.b;
                    var _v7 = $author$project$Spa$Generated$Pages$view(page);
                    var title = _v7.$2;
                    return _Utils_Tuple2(_Utils_update(model, {
                        ba: layout,
                        GM: page,
                        d: route,
                        Cu: A2($author$project$Spa$Generated$Pages$save, page, newShared)
                    }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                        A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
                        A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
                        defaultUrlCmd,
                        A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, A2($elm$core$Maybe$map, $author$project$Main$attemptScrollingToFragment(0), url.adZ)),
                        A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, urlChangedCmd),
                        $author$project$Ports$PageTitle$updateTabTitle(title)
                    ])));
                }
            case 2:
                var sharedMsg = msg.a;
                var _v8 = A2($author$project$Shared$update, sharedMsg, model.Cu);
                var shared = _v8.a;
                var sharedCmd = _v8.b;
                var _v9 = A2($author$project$Spa$Generated$Pages$load, model.GM, shared);
                var page = _v9.a;
                var pageCmd = _v9.b;
                var outMsgs = _v9.c;
                var _v10 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, shared);
                var newShared = _v10.a;
                var newSharedCmd = _v10.b;
                var _v11 = newShared.Wy ? _Utils_Tuple2(_Utils_update(newShared, {
                    Wy: false
                }), A2($elm$core$Task$perform, function(_v12) {
                    return $author$project$Main$RequestLoadClinical;
                }, $elm$core$Task$succeed(0))) : _Utils_Tuple2(newShared, $elm$core$Platform$Cmd$none);
                var sharedWithFlagCleared = _v11.a;
                var requestLoadClinicalCmd = _v11.b;
                var _v13 = A3($author$project$Main$updateLayout, shared, outMsgs, model.ba);
                var layout = _v13.a;
                var layoutCmd = _v13.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ba: layout,
                    GM: page,
                    Cu: sharedWithFlagCleared
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, newSharedCmd),
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
                    requestLoadClinicalCmd
                ])));
            case 3:
                var pageMsg = msg.a;
                var _v14 = A2($author$project$Spa$Generated$Pages$update, pageMsg, model.GM);
                var page = _v14.a;
                var pageCmd = _v14.b;
                var outMsgs = _v14.c;
                var _v15 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, A2($author$project$Spa$Generated$Pages$save, page, model.Cu));
                var shared = _v15.a;
                var sharedCmd = _v15.b;
                var _v16 = $author$project$Spa$Generated$Pages$view(page);
                var title = _v16.$2;
                var _v17 = A3($author$project$Main$updateLayout, shared, outMsgs, model.ba);
                var layout = _v17.a;
                var layoutCmd = _v17.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ba: layout,
                    GM: page,
                    Cu: shared
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Pages, pageCmd),
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd),
                    $author$project$Ports$PageTitle$updateTabTitle(title),
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd)
                ])));
            case 6:
                var _v18 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Main$loadClinicalDebounceConfig, 0, model.rl);
                var debouncer = _v18.a;
                var cmd = _v18.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    rl: debouncer
                }), cmd);
            case 7:
                var subMsg = msg.a;
                var _v19 = A4($jinjor$elm_debounce$Debounce$update, $author$project$Main$loadClinicalDebounceConfig, $jinjor$elm_debounce$Debounce$takeLast(function(_v20) {
                    return $author$project$Ports$Clinical$load;
                }), subMsg, model.rl);
                var debouncer = _v19.a;
                var cmd = _v19.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    rl: debouncer
                }), cmd);
            default:
                var layoutMsg = msg.a;
                var _v21 = A3($author$project$Spa$Layout$update, model.Cu.Ej, layoutMsg, model.ba);
                var layout = _v21.a;
                var layoutCmd = _v21.b;
                var outMsgs = _v21.c;
                var _v22 = A2($author$project$Shared$updateFromOutMsgs, outMsgs, model.Cu);
                var shared = _v22.a;
                var sharedCmd = _v22.b;
                return _Utils_Tuple2(_Utils_update(model, {
                    ba: layout,
                    Cu: shared
                }), $elm$core$Platform$Cmd$batch(_List_fromArray([
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Layout, layoutCmd),
                    A2($elm$core$Platform$Cmd$map, $author$project$Main$Shared, sharedCmd)
                ])));
        }
    });
    var $author$project$Main$isClinicalLayout = function(layout) {
        switch(layout.$){
            case 16:
                return true;
            case 17:
                return true;
            default:
                return false;
        }
    };
    var $author$project$Shared$HideAuthRecoveryModal = function(a) {
        return {
            $: 28,
            a: a
        };
    };
    var $author$project$Shared$HideLogoutWarning = {
        $: 10
    };
    var $author$project$Shared$PendingChangesDiscard = {
        $: 22
    };
    var $author$project$Shared$organizationFromSession = function(model) {
        return A2($elm$core$Maybe$map, function(org) {
            return {
                aef: $author$project$Api$Platform$Organization$Shared$id(org),
                zr: $author$project$Api$Platform$Organization$Shared$name(org),
                afV: $author$project$Api$Platform$Organization$Shared$id(org),
                ah5: $author$project$Api$Platform$Organization$Shared$type_(org)
            };
        }, A2($elm$core$Maybe$andThen, $author$project$Api$Platform$Session$One$organization, $author$project$Api$Data$toMaybe(model.Z$)));
    };
    var $author$project$Components$HiConfirm$ShowCancel = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$HiConfirm$showCancel = $author$project$Components$HiConfirm$ShowCancel;
    var $author$project$Navbars$Company$showSideNav = F2(function(hinterViewOff, _v0) {
        var model = _v0;
        return model.Cs._k(hinterViewOff);
    });
    var $author$project$Navbars$Partner$showSideNav = F2(function(hinterViewOff, _v0) {
        var model = _v0;
        return model.Cs._k(hinterViewOff);
    });
    var $author$project$Navbars$Practice$showSideNav = F2(function(hinterViewOff, _v0) {
        var model = _v0;
        return model.Cs.Cu._k(hinterViewOff);
    });
    var $author$project$Navbar$showSideNav = F2(function(hinterViewOff, _v0) {
        var model = _v0;
        var _v1 = model.ad;
        switch(_v1.$){
            case 0:
                return false;
            case 1:
                var navBar_ = _v1.a;
                return A2($author$project$Navbars$Practice$showSideNav, hinterViewOff, navBar_);
            case 2:
                var navBar_ = _v1.a;
                return A2($author$project$Navbars$Company$showSideNav, hinterViewOff, navBar_);
            default:
                var navBar_ = _v1.a;
                return A2($author$project$Navbars$Partner$showSideNav, hinterViewOff, navBar_);
        }
    });
    var $author$project$Utils$Environment$toString = function(environment) {
        return A2($elm$core$Maybe$map, function(env) {
            switch(env){
                case 0:
                    return 'production';
                case 1:
                    return 'staging';
                case 2:
                    return 'development';
                default:
                    return 'feature';
            }
        }, environment);
    };
    var $author$project$Api$Provider$Practice$One$accessRestricted = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Ii;
    });
    var $author$project$Api$Practice$accessRestricted = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$accessRestricted(practice_);
        } else return false;
    };
    var $author$project$Api$Provider$Practice$One$daysWithOutstandingBalance = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Ne;
    });
    var $author$project$Api$Practice$daysWithOutstandingBalance = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$daysWithOutstandingBalance(practice_);
        } else return 0;
    };
    var $author$project$Components$AccountLockedModal$viewModal = function(daysWithOutstandingBalance) {
        return A3($author$project$Ui$Modal$view, 0, _List_fromArray([
            $author$project$Ui$Modal$dismissible(false)
        ]), _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('Your account is locked')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $elm$html$Html$text('You have outstanding invoices that are '),
                $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'day', daysWithOutstandingBalance)),
                $elm$html$Html$text(' overdue, so your account has been locked. '),
                A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('To unlock your account, please '),
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Billing, _List_Nil, _List_fromArray([
                        $elm$html$Html$text('click here')
                    ])),
                    $elm$html$Html$text(' to view and pay your invoices.')
                ])),
                A2($author$project$Ui$Form$Static$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('If you have questions about your invoices or need to temporarily unlock your account, please contact us. ')
                ]))
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
                ]), _List_fromArray([
                    $elm$html$Html$text('Note: Although your account is locked, everything is still active and operating as expected. There will be no disruption to your service, including automated billing, notifications, enrollments, or funds disbursement until your account is closed or suspended.')
                ]))
            ]))
        ]));
    };
    var $author$project$Components$AccountLockedModal$view = F3(function(session, practice, route) {
        var userIsAdmin = $author$project$Api$Platform$User$Shared$isAdmin($author$project$Api$Platform$Session$One$user(session));
        var routeString = $author$project$Spa$Generated$Route$toString(route);
        var practiceAccessRestricted = $author$project$Api$Practice$accessRestricted(practice);
        var organizationIsCompany = _Utils_eq(A2($elm$core$Maybe$map, $author$project$Api$Platform$Organization$Shared$type_, $author$project$Api$Platform$Session$One$organization(session)), $elm$core$Maybe$Just(1));
        var isUserRoute = A2($elm$core$String$startsWith, '/user', routeString);
        var isPaymentSourcesRoute = A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__PaymentSources), routeString);
        var isBillingRoute = A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$Admin__Billing), routeString);
        var routeAllowed = isBillingRoute || isPaymentSourcesRoute || isUserRoute;
        var showModal = !organizationIsCompany && !userIsAdmin && !routeAllowed && practiceAccessRestricted;
        return showModal ? $author$project$Components$AccountLockedModal$viewModal($author$project$Api$Practice$daysWithOutstandingBalance(practice)) : $author$project$Utils$Html$empty;
    });
    var $author$project$Components$Auth$SystemRecoveryModal$hiConfirmMessage = function() {
        var infoText = '\n            Our main sign-in system has recovered from the outage. To continue using all features,\n            please sign out of the temporary system and sign back in with the full system.\n            ';
        var alertText = '\n            If you do not sign out and sign back in within the next 2 minutes, this\n            will happen automatically and you may lose unsaved work,  \n            ';
        return A2($author$project$Ui$Typography$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$p, _List_fromArray([
                $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft)
            ]), _List_fromArray([
                $elm$html$Html$text(infoText)
            ])),
            A2($author$project$Ui$Typography$p, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Alert$warning, _List_fromArray([
                    $author$project$Ui$Alert$margin(25),
                    $author$project$Ui$Alert$icon(64),
                    $author$project$Ui$Alert$alignment($author$project$Ui$Alignment$textLeft)
                ]), _List_fromArray([
                    A2($author$project$Ui$Typography$span, _List_fromArray([
                        $author$project$Ui$Typography$bold
                    ]), _List_fromArray([
                        $elm$html$Html$text('Important:')
                    ])),
                    A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                        $elm$html$Html$text(alertText)
                    ]))
                ]))
            ]))
        ]));
    }();
    var $author$project$Components$Auth$SystemRecoveryModal$hiConfirmOptions = _List_fromArray([
        $author$project$Components$HiConfirm$verb('sign out'),
        $author$project$Components$HiConfirm$noun('now'),
        $author$project$Components$HiConfirm$customMessage(_List_fromArray([
            $author$project$Components$Auth$SystemRecoveryModal$hiConfirmMessage
        ])),
        $author$project$Components$HiConfirm$customTitle('System Recovery Notice'),
        $author$project$Components$HiConfirm$showCancel(true)
    ]);
    var $author$project$Components$Auth$SystemRecoveryModal$view = function(onClose) {
        return A2($author$project$Components$HiConfirm$modal, onClose, $author$project$Components$Auth$SystemRecoveryModal$hiConfirmOptions);
    };
    var $author$project$Components$GlobalSearch$ClearTerm = {
        $: 3
    };
    var $author$project$Components$GlobalSearch$InputKeyDown = function(a) {
        return {
            $: 12,
            a: a
        };
    };
    var $author$project$Components$GlobalSearch$PaginationMsg = function(a) {
        return {
            $: 6,
            a: a
        };
    };
    var $author$project$Components$GlobalSearch$TermChanged = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$GlobalSearch$attributesToText = function(attributes) {
        var attributesText = A2($elm$core$String$join, ', ', attributes);
        return A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('text-muted')
        ]), _List_fromArray([
            $elm$html$Html$text(attributesText)
        ]));
    };
    var $author$project$Components$GlobalSearch$permissionTypeToAttributesList = function(permissionType) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('mt-2')
        ]), _List_fromArray([
            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text(permissionType.zr + ': ')
            ])),
            $author$project$Components$GlobalSearch$attributesToText(permissionType.vD)
        ]));
    };
    var $author$project$Components$GlobalSearch$viewNoResultsFound = F2(function(permissionsData, maybeFilter) {
        var searchableInfo = function() {
            if (permissionsData.$ === 3) {
                var permissions = permissionsData.a;
                if (!maybeFilter.$) {
                    var filter = maybeFilter.a;
                    return A2($elm$core$List$filter, function(elem) {
                        return _Utils_eq(elem.aef, filter);
                    }, A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions));
                } else return A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions);
            } else return _List_Nil;
        }();
        var noMatchingText = _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$aligned($author$project$Ui$Alignment$textLeft),
                    $author$project$Ui$Typography$margin(8)
                ]), _List_fromArray([
                    $elm$html$Html$text('No matching results found')
                ]))
            ])),
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$p, _List_fromArray([
                    $author$project$Ui$Typography$muted,
                    $author$project$Ui$Typography$margin(8)
                ]), _List_fromArray([
                    $elm$html$Html$text($elm$core$String$toUpper('Searchable Information:'))
                ]))
            ]))
        ]);
        return A2($elm$html$Html$div, _List_Nil, _Utils_ap(noMatchingText, A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionTypeToAttributesList, searchableInfo)));
    });
    var $author$project$Components$GlobalSearch$DocumentClicked = {
        $: 10
    };
    var $author$project$Components$GlobalSearch$DocumentHovered = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Ui$Margin$Right_0_5 = 14;
    var $author$project$Ui$ListGroup$Active = {
        $: 3
    };
    var $author$project$Ui$ListGroup$active = $author$project$Ui$ListGroup$Active;
    var $author$project$Components$GlobalSearch$documentTypeToIcon = function(name) {
        if (name === 'sponsor') return A2($author$project$Ui$Icon$view, _List_fromArray([
            $author$project$Ui$Icon$class('global-search__icon')
        ]), 11);
        else switch(name){
            case 'invoice':
                return $author$project$Ui$Icon$invoices(_List_Nil);
            case 'customer_invoice':
                return $author$project$Ui$Icon$invoices(_List_Nil);
            case 'patient':
                return $author$project$Ui$Icon$patients(_List_Nil);
            default:
                return $elm$html$Html$text('');
        }
    };
    var $author$project$Api$Provider$Search$Min$label = function(_v0) {
        var record = _v0;
        return record.aeI;
    };
    var $author$project$Api$Provider$Search$All$label = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Search$Min$label(min);
    };
    var $author$project$Ui$ListGroup$None = {
        $: 4
    };
    var $author$project$Ui$ListGroup$none = $author$project$Ui$ListGroup$None;
    var $elm$html$Html$Events$onMouseEnter = function(msg) {
        return A2($elm$html$Html$Events$on, 'mouseenter', $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Api$Provider$Search$Min$secondaryLabel = function(_v0) {
        var record = _v0;
        return record.ZB;
    };
    var $author$project$Api$Provider$Search$All$secondaryLabel = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Search$Min$secondaryLabel(min);
    };
    var $author$project$Api$Provider$Search$Min$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Provider$Search$All$status = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Search$Min$status(min);
    };
    var $author$project$Api$Provider$Search$Min$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Api$Provider$Search$All$type_ = function(_v0) {
        var min = _v0;
        return $author$project$Api$Provider$Search$Min$type_(min);
    };
    var $author$project$Components$GlobalSearch$viewDocument = F3(function(activeDocumentIndex, index, document1) {
        var activeClass = _Utils_eq(activeDocumentIndex, index) ? $author$project$Ui$ListGroup$active : $author$project$Ui$ListGroup$none;
        return A2($author$project$Ui$ListGroup$item, _List_fromArray([
            activeClass
        ]), _List_fromArray([
            A2($elm$html$Html$a, _List_fromArray([
                $elm$html$Html$Attributes$href($author$project$Api$Provider$Search$All$path(document1)),
                $elm$html$Html$Attributes$class('stretched-link'),
                $elm$html$Html$Events$onClick($author$project$Components$GlobalSearch$DocumentClicked),
                $elm$html$Html$Events$onMouseEnter($author$project$Components$GlobalSearch$DocumentHovered(index))
            ]), _List_fromArray([
                $author$project$Components$GlobalSearch$documentTypeToIcon($author$project$Api$Provider$Search$All$type_(document1)),
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$margin(10),
                    $author$project$Ui$Typography$margin(14),
                    $author$project$Ui$Typography$phi(true)
                ]), _List_fromArray([
                    $elm$html$Html$text($author$project$Api$Provider$Search$All$label(document1))
                ])),
                function() {
                    var _v0 = $author$project$Api$Provider$Search$All$secondaryLabel(document1);
                    if (!_v0.$) {
                        var secondaryLabel_ = _v0.a;
                        return A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$muted,
                            $author$project$Ui$Typography$small,
                            $author$project$Ui$Typography$margin(14),
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text(secondaryLabel_)
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }(),
                A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Search$All$status(document1)),
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('global-search__action')
                ]), 16)
            ]))
        ]));
    });
    var $author$project$Components$GlobalSearch$viewResults = F2(function(documents, activeDocumentIndex) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('global-search__results')
        ]), _List_fromArray([
            A2($author$project$Ui$ListGroup$view, _List_Nil, A2($elm$core$List$indexedMap, $author$project$Components$GlobalSearch$viewDocument(activeDocumentIndex), documents))
        ]));
    });
    var $author$project$Components$GlobalSearch$TabClicked = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$GlobalSearch$viewPermissionTypeTab = function(permissionType) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('text-current')
            ]), _List_fromArray([
                $elm$html$Html$text(permissionType.zr)
            ]))
        ]));
    };
    var $author$project$Components$GlobalSearch$viewNavTab = F2(function(activeFilter, permissionType) {
        return A2($author$project$Ui$Nav$item, _List_fromArray([
            $author$project$Ui$Nav$itemId(permissionType.aef),
            $author$project$Ui$Nav$activeItem(function() {
                if (activeFilter.$ === 1) return permissionType.aef === 'all';
                else {
                    var filterId = activeFilter.a;
                    return _Utils_eq(permissionType.aef, filterId);
                }
            }()),
            $author$project$Ui$Nav$onItemClick($author$project$Components$GlobalSearch$TabClicked(permissionType.aef))
        ]), _List_fromArray([
            $author$project$Components$GlobalSearch$viewPermissionTypeTab(permissionType)
        ]));
    });
    var $author$project$Components$GlobalSearch$viewTabs = function(openModel) {
        var _v0 = openModel.nb;
        if (!_v0.$) {
            var nav = _v0.a;
            var navItems = function() {
                var _v1 = openModel.r4;
                if (_v1.$ === 3) {
                    var permissions = _v1.a;
                    var searchableTypeList = A2($elm$core$List$filter, function($) {
                        return $.ZA;
                    }, A2($elm$core$List$map, $author$project$Components$GlobalSearch$permissionToPermissionType, permissions));
                    if ($elm$core$List$length(searchableTypeList) > 1) {
                        var allType = {
                            vD: _List_Nil,
                            aef: 'all',
                            zr: 'All',
                            ZA: true
                        };
                        return A2($elm$core$List$map, $author$project$Components$GlobalSearch$viewNavTab(openModel.Fw), A2($elm$core$List$cons, allType, searchableTypeList));
                    } else return A2($elm$core$List$map, $author$project$Components$GlobalSearch$viewNavTab(openModel.Fw), searchableTypeList);
                } else return _List_Nil;
            }();
            return _List_fromArray([
                A3($author$project$Ui$Nav$view, _List_Nil, navItems, nav)
            ]);
        } else return _List_fromArray([
            $author$project$Utils$Html$empty
        ]);
    };
    var $author$project$Components$GlobalSearch$viewOpen = function(model) {
        return A3($author$project$Ui$Modal$view, $author$project$Components$GlobalSearch$ModalCloseClicked, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$body(_List_fromArray([
                A2($elm$html$Html$div, _List_Nil, A2($elm$core$List$cons, $author$project$Ui$Form$Input$view(_List_fromArray([
                    $author$project$Ui$Form$Input$id('global-search-input'),
                    $author$project$Ui$Form$Input$placeholder('Search...'),
                    $author$project$Ui$Form$Input$value(model.eP),
                    $author$project$Ui$Form$Input$onInput($author$project$Components$GlobalSearch$TermChanged),
                    $author$project$Ui$Form$Input$onKeyDown($author$project$Components$GlobalSearch$InputKeyDown),
                    $author$project$Ui$Form$Input$autoComplete(false),
                    $author$project$Ui$Form$Input$customAttributes(_List_fromArray([
                        $elm$html$Html$Attributes$class('search-input')
                    ])),
                    $author$project$Ui$Form$Input$wrapped(_List_fromArray([
                        A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('lens-search')
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$search(_List_Nil)
                        ])),
                        model.eP === '' ? $author$project$Utils$Html$empty : A2($elm$html$Html$span, _List_fromArray([
                            $elm$html$Html$Attributes$class('clear-search'),
                            $elm$html$Html$Events$onClick($author$project$Components$GlobalSearch$ClearTerm)
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$crossCircle(_List_Nil)
                        ]))
                    ])),
                    $author$project$Ui$Form$Input$phi(true)
                ])), $author$project$Components$GlobalSearch$viewTabs(model))),
                function() {
                    var _v0 = model.Y_;
                    switch(_v0.$){
                        case 3:
                            var results = _v0.a;
                            return $elm$core$List$isEmpty(results) ? A2($author$project$Components$GlobalSearch$viewNoResultsFound, model.r4, model.Fw) : A2($author$project$Components$GlobalSearch$viewResults, results, model.N);
                        case 1:
                            return $elm$html$Html$text('Loading...');
                        default:
                            return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Typography$p, _List_fromArray([
                                    $author$project$Ui$Typography$margin(21),
                                    $author$project$Ui$Typography$margin(10),
                                    $author$project$Ui$Typography$gray
                                ]), _List_fromArray([
                                    $elm$html$Html$text('Try searching for id, invoice number, name, email and other information')
                                ]))
                            ]));
                    }
                }()
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                function() {
                    var _v1 = model.Y_;
                    if (_v1.$ === 3) return A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('global-search__footer')
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('global-search__pagination')
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, $author$project$Components$GlobalSearch$PaginationMsg, A2($author$project$Api$Pagination$view, _List_Nil, model.af_))
                        ])),
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('global-search__legend')
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$selectArrows(_List_Nil),
                            $elm$html$Html$text('Select'),
                            $author$project$Ui$Icon$open(_List_Nil),
                            $elm$html$Html$text('Open')
                        ]))
                    ]));
                    else return $author$project$Utils$Html$empty;
                }()
            ]))
        ]));
    };
    var $author$project$Components$GlobalSearch$view = function(model) {
        if (!model.$) return $elm$html$Html$text('');
        else {
            var openModel = model.a;
            return $author$project$Components$GlobalSearch$viewOpen(openModel);
        }
    };
    var $author$project$Components$PendingChangesModal$view = F3(function(pendingChangesDetail, discardChangesMsg, keepChangesMsg) {
        return A3($author$project$Ui$Modal$view, keepChangesMsg, _List_Nil, _List_fromArray([
            $author$project$Ui$Modal$header(_List_fromArray([
                $author$project$Ui$Modal$title('You have pending changes')
            ])),
            $author$project$Ui$Modal$body(_List_fromArray([
                $elm$html$Html$text(pendingChangesDetail)
            ])),
            $author$project$Ui$Modal$footer(_List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Stay on this page'
                }, _List_fromArray([
                    $author$project$Ui$Button$onClick(keepChangesMsg)
                ]), _List_fromArray([
                    $elm$html$Html$text('Stay')
                ])),
                A3($author$project$Ui$Button$view, {
                    abP: 'Leave and discard pending changes'
                }, _List_fromArray([
                    $author$project$Ui$Button$danger,
                    $author$project$Ui$Button$onClick(discardChangesMsg)
                ]), _List_fromArray([
                    $elm$html$Html$text('Leave')
                ]))
            ]))
        ]));
    });
    var $elm$html$Html$nav = _VirtualDom_node('nav');
    var $author$project$Components$DebugInfo$viewSetting = F2(function(label, value) {
        return A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text(label + ': ')
            ])),
            $elm$html$Html$text(value)
        ]));
    });
    var $author$project$Components$DebugInfo$view = function(_v0) {
        var nodeEnv = _v0.aff;
        var hintEnv = _v0.aea;
        var apiUrl = _v0.abM;
        var debugOrTest = _v0.acU;
        var embedded = _v0.adj;
        var session = _v0.Z$;
        return !embedded && debugOrTest ? A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('debug-info')
        ]), A2($elm$core$List$intersperse, $elm$html$Html$text(' - '), _List_fromArray([
            A2($author$project$Components$DebugInfo$viewSetting, 'NODE_ENV', A2($elm$core$Maybe$withDefault, 'N/A', nodeEnv)),
            A2($author$project$Components$DebugInfo$viewSetting, 'HINT_ENV', A2($elm$core$Maybe$withDefault, 'N/A', hintEnv)),
            A2($author$project$Components$DebugInfo$viewSetting, 'API_URL', apiUrl),
            A2($author$project$Components$DebugInfo$viewSetting, 'session.role', $author$project$Api$Platform$Session$One$role(session))
        ]))) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$SandboxAlert$SwitchToOrganization = F2(function(a, b) {
        return {
            $: 0,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Platform$Organization$SandboxOf$organizationId = function(_v0) {
        var orgId = _v0;
        return orgId;
    };
    var $author$project$Api$Platform$Organization$Shared$sandboxOf = function(_v0) {
        var record = _v0.b;
        return record.Zp;
    };
    var $author$project$Components$SandboxAlert$view = function(session) {
        return $author$project$Api$Platform$Session$One$sandbox(session) ? A2($author$project$Ui$Alert$warning, _List_fromArray([
            $author$project$Ui$Alert$hardNotification,
            $author$project$Ui$Alert$m0
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Currently viewing sandbox data.')
                ])),
                function() {
                    var _v0 = A2($elm$core$Maybe$andThen, $author$project$Api$Platform$Organization$Shared$sandboxOf, $author$project$Api$Platform$Session$One$organization(session));
                    if (!_v0.$) {
                        var sandboxOf = _v0.a;
                        var _v1 = function() {
                            if (!sandboxOf.$) {
                                var organization = sandboxOf.a;
                                return _Utils_Tuple2(0, $author$project$Api$Platform$Organization$SandboxOf$organizationId(organization));
                            } else {
                                var organization = sandboxOf.a;
                                return _Utils_Tuple2(2, $author$project$Api$Platform$Organization$SandboxOf$organizationId(organization));
                            }
                        }();
                        var organizationType = _v1.a;
                        var organizationId = _v1.b;
                        return A3($author$project$Ui$Button$view, {
                            abP: 'Back to Live'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$sm,
                            $author$project$Ui$Button$onClick(A2($author$project$Components$SandboxAlert$SwitchToOrganization, organizationType, organizationId)),
                            $author$project$Ui$Button$secondary
                        ]), _List_fromArray([
                            $elm$html$Html$text('Back to Live')
                        ]));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Components$BackupAuthAlert$view = function(backupAuthEnabled) {
        return backupAuthEnabled ? A2($author$project$Ui$Alert$warning, _List_fromArray([
            $author$project$Ui$Alert$m0
        ]), $author$project$Components$BackupAuthAlert$viewAlertText) : $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Practice$deactivated = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$deactivated(practice_);
        } else return false;
    };
    var $author$project$Components$DeactivatedPracticeAlert$view = function(practice) {
        return $author$project$Api$Practice$deactivated(practice) ? A2($author$project$Ui$Alert$danger, _List_fromArray([
            $author$project$Ui$Alert$hardNotification,
            $author$project$Ui$Alert$m0
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('Practice Deactivated.')
            ])),
            $author$project$Utils$Html$noBreakSpace,
            $elm$html$Html$text('Practice is deactivated and will not process payments, bill memberships or send emails.')
        ])) : $author$project$Utils$Html$empty;
    };
    var $author$project$Api$Provider$Practice$One$collectionWarningStatus = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.LA;
    });
    var $author$project$Api$Practice$collectionWarningStatus = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$collectionWarningStatus(practice_);
        } else return $elm$core$Maybe$Nothing;
    };
    var $author$project$Api$Provider$Practice$One$daysUntilAccessRestricted = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Nd;
    });
    var $author$project$Api$Practice$daysUntilAccessRestricted = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$daysUntilAccessRestricted(practice_);
        } else return 0;
    };
    var $author$project$Api$Platform$Session$One$showCollectionWarning = function(_v0) {
        var record = _v0;
        return record._f;
    };
    var $author$project$Components$MissingSourceAlert$view = F3(function(session, practice, hinterViewOff) {
        var _v0 = _Utils_Tuple2(A3($author$project$Permission$canGoTo, session, hinterViewOff, 1) && $author$project$Api$Platform$Session$One$showCollectionWarning(session), $author$project$Api$Practice$collectionWarningStatus(practice));
        _v0$2: while(true){
            if (_v0.a && !_v0.b.$) switch(_v0.b.a){
                case 'yellow':
                    return A2($author$project$Ui$Alert$warning, _List_fromArray([
                        $author$project$Ui$Alert$hardNotification,
                        $author$project$Ui$Alert$m0
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('You have outstanding invoices on your account.')
                        ])),
                        $author$project$Utils$Html$noBreakSpace,
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Please '),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Billing, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('click here')
                            ])),
                            $elm$html$Html$text(' to view and pay your invoices so that your account doesn\'t become overdue. If you have questions or concerns regarding your invoices, please contact us.')
                        ]))
                    ]));
                case 'red':
                    var daysWithOutstandingBalance = $author$project$Api$Practice$daysWithOutstandingBalance(practice);
                    var daysUntilAccessRestricted = $author$project$Api$Practice$daysUntilAccessRestricted(practice);
                    return A2($author$project$Ui$Alert$danger, _List_fromArray([
                        $author$project$Ui$Alert$hardNotification,
                        $author$project$Ui$Alert$m0
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('You have outstanding invoices and your account is '),
                            $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'day', daysWithOutstandingBalance)),
                            $elm$html$Html$text(' overdue.')
                        ])),
                        $author$project$Utils$Html$noBreakSpace,
                        A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Please '),
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Admin__Billing, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('click here')
                            ])),
                            $elm$html$Html$text(' to view and pay any overdue invoices to prevent your account from being locked in '),
                            $elm$html$Html$text(A2($author$project$Formatters$String$pluralize, 'day', daysUntilAccessRestricted)),
                            $elm$html$Html$text('. If you have questions or concerns regarding your invoices, please contact us.')
                        ]))
                    ]));
                default:
                    break _v0$2;
            }
            else break _v0$2;
        }
        return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$OnboardedPracticeAlert$isHintAdmin = F2(function(session, hinterViewOff) {
        return A2($author$project$Utils$User$isViewingAsHinter, session, hinterViewOff);
    });
    var $author$project$Api$Provider$Practice$One$onboarded = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Vs;
    });
    var $author$project$Api$Practice$onboarded = function(practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return $author$project$Api$Provider$Practice$One$onboarded(practice_);
        } else return true;
    };
    var $author$project$Components$OnboardedPracticeAlert$view = F3(function(session, practice, hinterViewOff) {
        return A2($author$project$Components$OnboardedPracticeAlert$isHintAdmin, session, hinterViewOff) && !$author$project$Api$Practice$onboarded(practice) ? A2($author$project$Ui$Alert$danger, _List_fromArray([
            $author$project$Ui$Alert$hardNotification
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                $elm$html$Html$text('This Practice is required to add payment information.')
            ])),
            $author$project$Utils$Html$noBreakSpace,
            A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                $elm$html$Html$text('All users (other than Hinters) are being redirected to the '),
                A3($author$project$Ui$HinterOnly$linkRoute, $author$project$Spa$Generated$Route$Onboarding, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('payment setup')
                ])),
                $elm$html$Html$text(' view until a payment method is added.')
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Navbar$viewPracticeAlerts = F3(function(session, hinterViewOff, practice) {
        if (!practice.$) {
            var practice_ = practice.a;
            return _List_fromArray([
                A3($author$project$Components$MissingSourceAlert$view, session, practice_, hinterViewOff),
                A3($author$project$Components$OnboardedPracticeAlert$view, session, practice_, hinterViewOff),
                $author$project$Components$DeactivatedPracticeAlert$view(practice_)
            ]);
        } else return _List_Nil;
    });
    var $author$project$Navbar$viewAlerts = F4(function(session, hinterViewOff, practice, backupAuthEnabled) {
        return A2($elm$core$List$cons, $author$project$Components$BackupAuthAlert$view(backupAuthEnabled), A3($author$project$Navbar$viewPracticeAlerts, session, hinterViewOff, practice));
    });
    var $author$project$Navbars$Company$NavClicked = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Navbars$Company$OrgSwitcherMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Navbars$Company$defaultNav = _List_fromArray([
        {
            yy: 0
        },
        {
            yy: 1
        },
        {
            yy: 2
        },
        {
            yy: 3
        },
        {
            yy: 4
        },
        {
            yy: 5
        }
    ]);
    var $author$project$Components$OrganizationSwitcher$hasInlineOrgs = function(_v0) {
        var model = _v0;
        return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(orgs) {
            if (!orgs.b) return false;
            else {
                if (!orgs.b.b) return false;
                else return true;
            }
        }, $author$project$Api$Data$toMaybe(model.rM)));
    };
    var $author$project$Ui$FlyoutMenu$Direction = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$FlyoutMenu$direction = $author$project$Ui$FlyoutMenu$Direction;
    var $author$project$Api$Platform$User$Organization$type_ = function(_v0) {
        var record = _v0;
        return record.ah5;
    };
    var $author$project$Components$OrganizationSwitcher$groupByType = function(orgs) {
        var practices = A2($elm$core$List$filter, function(o) {
            return !$author$project$Api$Platform$User$Organization$type_(o);
        }, orgs);
        var partners = A2($elm$core$List$filter, function(o) {
            return $author$project$Api$Platform$User$Organization$type_(o) === 2;
        }, orgs);
        var companies = A2($elm$core$List$filter, function(o) {
            return $author$project$Api$Platform$User$Organization$type_(o) === 1;
        }, orgs);
        return A2($elm$core$List$filter, function(_v0) {
            var items = _v0.b;
            return !$elm$core$List$isEmpty(items);
        }, _List_fromArray([
            _Utils_Tuple2(0, practices),
            _Utils_Tuple2(1, companies),
            _Utils_Tuple2(2, partners)
        ]));
    };
    var $author$project$Api$Platform$User$Organization$sandbox = function(_v0) {
        var record = _v0;
        return record.Zn;
    };
    var $author$project$Components$OrganizationSwitcher$SetEnvironment = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$OrganizationSwitcher$viewEnvironmentToggle = F2(function(current, navModel) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$mb3
        ]), _List_fromArray([
            A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Nav$item, _List_fromArray([
                    $author$project$Ui$Nav$activeItem(!current),
                    $author$project$Ui$Nav$onItemClick($author$project$Components$OrganizationSwitcher$SetEnvironment(0))
                ]), _List_fromArray([
                    $elm$html$Html$text('Live')
                ])),
                A2($author$project$Ui$Nav$item, _List_fromArray([
                    $author$project$Ui$Nav$activeItem(current === 1),
                    $author$project$Ui$Nav$onItemClick($author$project$Components$OrganizationSwitcher$SetEnvironment(1))
                ]), _List_fromArray([
                    $elm$html$Html$text('Sandbox')
                ]))
            ]), navModel)
        ]));
    });
    var $author$project$Components$OrganizationSwitcher$orgTypeLabel = function(orgType) {
        switch(orgType){
            case 0:
                return 'Practices';
            case 1:
                return 'Companies';
            default:
                return 'Partners';
        }
    };
    var $author$project$Components$OrganizationSwitcher$SelectOrganization = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Api$Platform$User$Organization$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Platform$User$Organization$name = function(_v0) {
        var record = _v0;
        return record.zr;
    };
    var $author$project$Api$Platform$User$Organization$organizationId = function(_v0) {
        var record = _v0;
        return record.afV;
    };
    var $author$project$Components$OrganizationSwitcher$viewOrgItem = F2(function(currentOrg, org) {
        var isCurrent = _Utils_eq(currentOrg.ah5, $author$project$Api$Platform$User$Organization$type_(org)) && _Utils_eq(currentOrg.aef, $author$project$Api$Platform$User$Organization$id(org));
        return A3($author$project$Ui$Button$view, {
            abP: 'Select org'
        }, A2($elm$core$List$cons, $author$project$Ui$Button$link, A2($elm$core$List$cons, $author$project$Ui$Button$onClick($author$project$Components$OrganizationSwitcher$SelectOrganization($author$project$Api$Platform$User$Organization$organizationId(org))), isCurrent ? _List_fromArray([
            $author$project$Ui$Button$icon($author$project$Ui$Icon$check)
        ]) : _List_Nil)), _List_fromArray([
            $elm$html$Html$text($author$project$Api$Platform$User$Organization$name(org))
        ]));
    });
    var $author$project$Components$OrganizationSwitcher$viewGroup = F2(function(currentOrg, _v0) {
        var orgType = _v0.a;
        var orgs = _v0.b;
        return $elm$core$List$isEmpty(orgs) ? _List_Nil : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$flexCol
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$titleSm, _List_Nil, _List_fromArray([
                    $elm$html$Html$text($author$project$Components$OrganizationSwitcher$orgTypeLabel(orgType))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$gap2,
                    $author$project$Ui$Element$flexCol,
                    $author$project$Ui$Element$textMuted
                ]), A2($elm$core$List$map, $author$project$Components$OrganizationSwitcher$viewOrgItem(currentOrg), orgs))
            ]))
        ]);
    });
    var $author$project$Components$OrganizationSwitcher$viewGroupedOrgs = F2(function(currentOrg, groups) {
        return A2($elm$core$List$concatMap, $author$project$Components$OrganizationSwitcher$viewGroup(currentOrg), groups);
    });
    var $author$project$Components$OrganizationSwitcher$viewTrigger = function(organizationName) {
        return A3($author$project$Ui$Element$custom, 'topnav__left--content cursor-pointer py-3.5', _List_fromArray([
            $author$project$Ui$Element$textMuted,
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$gap2
        ]), _List_fromArray([
            $author$project$Ui$Icon$location(_List_Nil),
            A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                $elm$html$Html$text(organizationName)
            ])),
            $author$project$Ui$Icon$kebabMenu(_List_Nil)
        ]));
    };
    var $author$project$Components$OrganizationSwitcher$viewDropdown = F3(function(currentOrg, model, orgs) {
        var hasSandbox = A2($elm$core$List$any, $author$project$Api$Platform$User$Organization$sandbox, orgs);
        var hasLive = A2($elm$core$List$any, function(o) {
            return !$author$project$Api$Platform$User$Organization$sandbox(o);
        }, orgs);
        var showTabs = hasSandbox && hasLive;
        var filteredOrgs = function() {
            if (showTabs) {
                var _v0 = model.qC;
                if (!_v0) return A2($elm$core$List$filter, function(o) {
                    return !$author$project$Api$Platform$User$Organization$sandbox(o);
                }, orgs);
                else return A2($elm$core$List$filter, $author$project$Api$Platform$User$Organization$sandbox, orgs);
            } else return orgs;
        }();
        var grouped = $author$project$Components$OrganizationSwitcher$groupByType(filteredOrgs);
        return A4($author$project$Ui$FlyoutMenu$view, _List_fromArray([
            $author$project$Ui$FlyoutMenu$direction(1)
        ]), _List_fromArray([
            $author$project$Ui$FlyoutMenu$body($elm$core$List$concat(_List_fromArray([
                showTabs ? _List_fromArray([
                    A2($author$project$Components$OrganizationSwitcher$viewEnvironmentToggle, model.qC, model.nc)
                ]) : _List_Nil,
                _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$gap4,
                        $author$project$Ui$Element$flexCol
                    ]), A2($author$project$Components$OrganizationSwitcher$viewGroupedOrgs, currentOrg, grouped))
                ])
            ])))
        ]), $author$project$Components$OrganizationSwitcher$viewTrigger(currentOrg.zr), model.mn);
    });
    var $author$project$Components$OrganizationSwitcher$view = F2(function(currentOrg, _v0) {
        var model = _v0;
        var _v1 = model.rM;
        if (_v1.$ === 3) {
            var orgs = _v1.a;
            return A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$textSm,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A3($author$project$Components$OrganizationSwitcher$viewDropdown, currentOrg, model, orgs)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Components$OrganizationSwitcher$viewFor = F3(function(toMsg, organization, model) {
        return A2($elm$html$Html$map, toMsg, A2($author$project$Components$OrganizationSwitcher$view, organization, model));
    });
    var $author$project$Components$OrganizationSwitcher$maybeViewFor = F2(function(toMsg, maybeConfig) {
        return A2($elm$core$Maybe$andThen, function(config) {
            return $author$project$Components$OrganizationSwitcher$hasInlineOrgs(config.zi) ? $elm$core$Maybe$Just(A3($author$project$Components$OrganizationSwitcher$viewFor, toMsg, config.VA, config.zi)) : $elm$core$Maybe$Nothing;
        }, maybeConfig);
    });
    var $author$project$Ui$Tooltip$Stacking = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Tooltip$stackingOrder = $author$project$Ui$Tooltip$Stacking;
    var $author$project$Ui$StackingOrder$z1030 = 1030;
    var $author$project$Ui$Tooltip$stackingOrder1030 = $author$project$Ui$Tooltip$stackingOrder($author$project$Ui$StackingOrder$z1030);
    var $author$project$Navbars$Company$subNavClasses = F2(function(subnav, openSubNav) {
        return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
    });
    var $author$project$Api$FeatureGate$EmployeeUploads = 8;
    var $author$project$Navbars$Company$LinkClicked = {
        $: 0
    };
    var $author$project$Api$Employer$Company$One$hideSponsorInvoices = function(_v0) {
        var record = _v0.b;
        return record.QI;
    };
    var $author$project$Api$Employer$Practice$One$hideSponsorInvoices = function(_v0) {
        var record = _v0;
        return record.QI;
    };
    var $author$project$Navbars$Utils$ifConfiguration = F2(function(showSetting, body) {
        return showSetting ? body : $author$project$Utils$Html$empty;
    });
    var $author$project$Navbars$Utils$selectedNavClass = F3(function(modifier, nav, selectedNav) {
        return 'sidenav__item' + (($elm$core$String$isEmpty(modifier) ? '' : ' ' + modifier) + (_Utils_eq(nav, selectedNav) ? ' sidenav__active' : ''));
    });
    var $author$project$Navbars$Company$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('sidenav__item--company');
    var $author$project$Navbars$Company$viewDesktopNavElements = F6(function(hinterViewOff, _v0, company, practice, sessionConfiguration, navItem) {
        var selectedNav = _v0.eI;
        var tooltipOptions = _List_fromArray([
            $author$project$Ui$Tooltip$placement(3),
            $author$project$Ui$Tooltip$stackingOrder1030
        ]);
        var companyId = $author$project$Api$Employer$Company$One$id(company);
        var _v1 = navItem.yy;
        switch(_v1){
            case 0:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                    fl: companyId
                });
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 0, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Employees', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                            $author$project$Ui$Link$test('employees')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 24)
                        ]))
                    ]))
                ]));
            case 1:
                var hideSponsorInvoices = $author$project$Api$Employer$Company$One$hideSponsorInvoices(company) || $author$project$Api$Employer$Practice$One$hideSponsorInvoices(practice);
                if (hideSponsorInvoices) return $author$project$Utils$Html$empty;
                else {
                    var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top({
                        fl: companyId
                    });
                    return A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 1, selectedNav))
                    ]), _List_fromArray([
                        A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Invoices', _List_fromArray([
                            A3($author$project$Ui$Link$route, route, _List_fromArray([
                                $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                                $author$project$Ui$Link$test('invoices')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Icon$view, _List_fromArray([
                                    $author$project$Ui$Icon$class('sidenav__icon')
                                ]), 26)
                            ]))
                        ]))
                    ]));
                }
            case 2:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources({
                    fl: companyId
                });
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 2, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Payment Methods', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                            $author$project$Ui$Link$test('paymentMethods')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 23)
                        ]))
                    ]))
                ]));
            case 3:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top({
                    fl: companyId
                });
                var canSeeEmployeeUploads = A2($author$project$Utils$FeatureGate$gateAvailable, 8, $author$project$Api$Practice$Employer(practice)) || sessionConfiguration.yu(hinterViewOff);
                return A2($author$project$Navbars$Utils$ifConfiguration, canSeeEmployeeUploads, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 3, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Employee Uploads', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                            $author$project$Ui$Link$test('employee-uploads')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 25)
                        ]))
                    ]))
                ])));
            case 4:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup({
                    fl: companyId
                });
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 4, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Online Signup', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                            $author$project$Ui$Link$test('online-signup')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 27)
                        ]))
                    ]))
                ]));
            case 5:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top({
                    fl: companyId
                });
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 5, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Account & Pricing', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                            $author$project$Ui$Link$test('account-and-pricing')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 28)
                        ]))
                    ]))
                ]));
            default:
                return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Navbars$Company$viewMobileNavElements = F6(function(hinterViewOff, _v0, company, practice, sessionConfiguration, navItem) {
        var selectedNav = _v0.eI;
        var companyId = $author$project$Api$Employer$Company$One$id(company);
        var _v1 = navItem.yy;
        switch(_v1){
            case 0:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
                    fl: companyId
                });
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 0, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                        $author$project$Ui$Link$test('employees')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 24),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Employees')
                        ]))
                    ]))
                ]));
            case 1:
                var hideSponsorInvoices = $author$project$Api$Employer$Company$One$hideSponsorInvoices(company) || $author$project$Api$Employer$Practice$One$hideSponsorInvoices(practice);
                if (hideSponsorInvoices) return $author$project$Utils$Html$empty;
                else {
                    var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top({
                        fl: companyId
                    });
                    return A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 1, selectedNav))
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                            $author$project$Ui$Link$test('invoices')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 26),
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Invoices')
                            ]))
                        ]))
                    ]));
                }
            case 2:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources({
                    fl: companyId
                });
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 2, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                        $author$project$Ui$Link$test('paymentMethods')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 23),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Payment Methods')
                        ]))
                    ]))
                ]));
            case 3:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top({
                    fl: companyId
                });
                var canSeeEmployeeUploads = A2($author$project$Utils$FeatureGate$gateAvailable, 8, $author$project$Api$Practice$Employer(practice)) || sessionConfiguration.yu(hinterViewOff);
                return A2($author$project$Navbars$Utils$ifConfiguration, canSeeEmployeeUploads, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 3, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                        $author$project$Ui$Link$test('employee-uploads')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 25),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Employee Uploads')
                        ]))
                    ]))
                ])));
            case 4:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup({
                    fl: companyId
                });
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 4, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                        $author$project$Ui$Link$test('online-signup')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 27),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Online Signup')
                        ]))
                    ]))
                ]));
            case 5:
                var route = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top({
                    fl: companyId
                });
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 5, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                        $author$project$Ui$Link$test('account-and-pricing')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 28),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Account & Pricing')
                        ]))
                    ]))
                ]));
            default:
                return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Navbars$Utils$viewOrganizationHeader = F2(function(organizationName, canSwitchOrganizations) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__header')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__header--right')
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $author$project$Ui$Icon$location(_List_Nil),
                    $elm$html$Html$text(organizationName)
                ])),
                A2($author$project$Navbars$Utils$ifConfiguration, canSwitchOrganizations, A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Organizations__Top, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Change')
                ])))
            ]))
        ]));
    });
    var $author$project$Navbars$Company$LogoutClicked = {
        $: 1
    };
    var $author$project$Navbars$Company$viewProfileSubNav = function(selectedNav) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__subnav__content')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$selectedNavClass, 6, selectedNav))
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Profile, _List_fromArray([
                    $author$project$Ui$Link$onClick($author$project$Navbars$Company$LinkClicked),
                    $author$project$Ui$Link$test('account-profile')
                ]), _List_fromArray([
                    $elm$html$Html$text('Profile')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Logout'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Navbars$Company$LogoutClicked),
                    $author$project$Ui$Button$test('account-logout')
                ]), _List_fromArray([
                    $elm$html$Html$text('Logout')
                ]))
            ]))
        ]));
    };
    var $author$project$Navbars$Utils$viewTopNavEnd = A2($elm$html$Html$div, _List_fromArray([
        $elm$html$Html$Attributes$id('topnav-end'),
        $elm$html$Html$Attributes$class('topnav__end')
    ]), _List_Nil);
    var $author$project$Navbars$Company$SidenavToggled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Api$WhitelabelSetting$practiceFacingLogoAltText = function(_v0) {
        var record = _v0;
        return record.G$;
    };
    var $author$project$Navbars$Company$viewLogo = F3(function(whitelabelSetting, practiceName, maybeLinkOptions) {
        var _v0 = _Utils_Tuple2($author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting), $author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
        var altText = _v0.a;
        var maybeLogoUrl = _v0.b;
        if (!maybeLogoUrl.$) {
            var logoUrl = maybeLogoUrl.a;
            if (logoUrl === '') return A2($elm$html$Html$div, _List_fromArray([
                A2($elm$html$Html$Attributes$style, 'display', 'inline')
            ]), _List_fromArray([
                $elm$html$Html$text(practiceName)
            ]));
            else {
                if (!maybeLinkOptions.$) {
                    var listOptions = maybeLinkOptions.a;
                    return A3($author$project$Ui$Link$externalHref, '/', listOptions, _List_fromArray([
                        A3($author$project$Ui$Image$fromSrc, {
                            Jg: altText
                        }, logoUrl, _List_fromArray([
                            $author$project$Ui$Image$height(40)
                        ]))
                    ]));
                } else return A3($author$project$Ui$Image$fromSrc, {
                    Jg: altText
                }, logoUrl, _List_fromArray([
                    $author$project$Ui$Image$height(40)
                ]));
            }
        } else return A2($elm$html$Html$div, _List_fromArray([
            A2($elm$html$Html$Attributes$style, 'display', 'inline')
        ]), _List_fromArray([
            $elm$html$Html$text(practiceName)
        ]));
    });
    var $author$project$Navbars$Utils$viewSwitchOrganizationLink = F2(function(organizationName, canSwitchOrganizations) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('topnav__left--content')
        ]), canSwitchOrganizations ? _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Organizations__Top, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('topnav__icon topnav__icon--location')
                ]), 14),
                $elm$html$Html$text(organizationName),
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('topnav__icon topnav__icon--change')
                ]), 19)
            ]))
        ]) : _List_fromArray([
            A2($author$project$Ui$Icon$view, _List_fromArray([
                $author$project$Ui$Icon$class('topnav__icon topnav__icon--location')
            ]), 14),
            $elm$html$Html$text(organizationName)
        ]));
    });
    var $author$project$Navbars$Company$viewTopNavbar = F5(function(_v0, whitelabelSetting, companyName, sessionConfig, maybeOrgSwitcher) {
        var slideIn = _v0.oz;
        var practice = _v0.W1;
        var patientFacingLogoSection = A3($author$project$Navbars$Company$viewLogo, whitelabelSetting, $author$project$Api$Employer$Practice$One$name(practice), $elm$core$Maybe$Just(_List_fromArray([
            $author$project$Ui$Link$ariaLabel('Home')
        ])));
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('elm-mobile-nav')
            ]), $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    patientFacingLogoSection
                ]),
                slideIn ? _List_Nil : _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('sidenav-open')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Display side navigation menu'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Navbars$Company$SidenavToggled(true))
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$burgerMenu(_List_Nil)
                        ]))
                    ]))
                ])
            ]))),
            slideIn ? A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav-close')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close side navigation menu'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Navbars$Company$SidenavToggled(false))
                ]), _List_fromArray([
                    $author$project$Ui$Icon$burgerMenuClose(_List_Nil)
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('topnav')
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('topnav__left')
                ]), _List_fromArray([
                    patientFacingLogoSection,
                    A2($elm$core$Maybe$withDefault, A2($author$project$Navbars$Utils$viewSwitchOrganizationLink, companyName, sessionConfig.KV), maybeOrgSwitcher)
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('topnav__right')
                ]), _List_Nil)
            ]))
        ]));
    });
    var $author$project$Navbars$Company$view = F3(function(hinterViewOff, maybeOrgSwitcherConfig, _v0) {
        var model = _v0;
        var practice = model.W1;
        var whitelabelSetting = model.abq;
        var company = model.acy;
        var sessionConfiguration = model.Cs;
        var slideIn = model.oz;
        var tooltipOptions = _List_fromArray([
            $author$project$Ui$Tooltip$placement(3),
            $author$project$Ui$Tooltip$stackingOrder1030
        ]);
        var profileMobileView = A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(A2($author$project$Navbars$Company$subNavClasses, 0, model.c5) + ' sidenav__item--profile-mobile')
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Profile'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Navbars$Company$NavClicked(0)),
                $author$project$Ui$Button$test('account-profile-mobile')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 3),
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__profile-name')
                ]), _List_fromArray([
                    $elm$html$Html$text(sessionConfiguration.aib)
                ])),
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
                ]), 12)
            ])),
            $author$project$Navbars$Company$viewProfileSubNav(model.eI)
        ]));
        var profileMenuView = A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('sidenav__active', model.eI === 6)
            ]))
        ]), $elm$core$List$singleton(A4($author$project$Ui$FlyoutMenu$view, _List_fromArray([
            $author$project$Ui$FlyoutMenu$position(1)
        ]), _List_fromArray([
            $author$project$Ui$FlyoutMenu$body(_List_fromArray([
                $author$project$Navbars$Company$viewProfileSubNav(model.eI)
            ]))
        ]), A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Profile', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Profile'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$test('account-profile')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 3)
            ]))
        ])), model.et)));
        var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Company$OrgSwitcherMsg, maybeOrgSwitcherConfig);
        var navElementsMobile = A2($elm$core$List$map, A5($author$project$Navbars$Company$viewMobileNavElements, hinterViewOff, model, company, practice, sessionConfiguration), $author$project$Navbars$Company$defaultNav);
        var navElementsDesktop = A2($elm$core$List$map, A5($author$project$Navbars$Company$viewDesktopNavElements, hinterViewOff, model, company, practice, sessionConfiguration), $author$project$Navbars$Company$defaultNav);
        return _List_fromArray([
            A5($author$project$Navbars$Company$viewTopNavbar, model, whitelabelSetting, $author$project$Api$Employer$Company$One$name(company), sessionConfiguration, orgSwitcherHtml),
            $author$project$Navbars$Utils$viewTopNavEnd,
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$id('sidenav'),
                $elm$html$Html$Attributes$class('sidenav'),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('sidenav--slide-in', slideIn)
                ]))
            ]), _List_fromArray([
                A2($author$project$Navbars$Utils$viewOrganizationHeader, $author$project$Api$Employer$Company$One$name(company), sessionConfiguration.KV),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
                ]), navElementsMobile),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
                ]), navElementsDesktop),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__bottom')
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('sidenav__bottom-separator')
                    ]), _List_Nil),
                    profileMobileView,
                    profileMenuView
                ]))
            ]))
        ]);
    });
    var $author$project$Navbars$Partner$NavClicked = function(a) {
        return {
            $: 4,
            a: a
        };
    };
    var $author$project$Navbars$Partner$OrgSwitcherMsg = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Navbars$Partner$defaultNav = F2(function(isHinter, partner) {
        var isManaged = !_Utils_eq($author$project$Api$Partner$Partner$One$managedBy(partner), $elm$core$Maybe$Nothing);
        var hideBilling = !$author$project$Api$Partner$Partner$One$active(partner) || isManaged;
        return A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            $elm$core$Maybe$Just({
                yy: 7
            }),
            $elm$core$Maybe$Just({
                yy: 0
            }),
            $elm$core$Maybe$Just({
                yy: 5
            }),
            hideBilling ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just({
                yy: 2
            }),
            !$author$project$Api$Partner$Partner$One$active(partner) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just({
                yy: 3
            }),
            !$author$project$Api$Partner$Partner$One$active(partner) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just({
                yy: 4
            }),
            $author$project$Api$Partner$Partner$One$sandboxEnabled(partner) ? $elm$core$Maybe$Just({
                yy: 6
            }) : $elm$core$Maybe$Nothing,
            isHinter ? $elm$core$Maybe$Just({
                yy: 1
            }) : $elm$core$Maybe$Nothing
        ]));
    });
    var $author$project$Navbars$Partner$subNavClasses = F2(function(subnav, openSubNav) {
        return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
    });
    var $author$project$Navbars$Partner$LinkClicked = {
        $: 0
    };
    var $author$project$Navbars$Partner$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('sidenav__item--partner');
    var $author$project$Navbars$Partner$viewDesktopNavElements = F5(function(_v0, _v1, _v2, _v3, navItem) {
        var selectedNav = _v1.eI;
        var tooltipOptions = _List_fromArray([
            $author$project$Ui$Tooltip$placement(3),
            $author$project$Ui$Tooltip$stackingOrder1030
        ]);
        var _v4 = navItem.yy;
        switch(_v4){
            case 0:
                var route = $author$project$Spa$Generated$Route$Partner__Team;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 0, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Team', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                            $author$project$Ui$Link$test('team')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 91)
                        ]))
                    ]))
                ]));
            case 7:
                var route = $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 7, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Dashboard', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                            $author$project$Ui$Link$test('products')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 75)
                        ]))
                    ]))
                ]));
            case 3:
                var route = $author$project$Spa$Generated$Route$Partner__ApiKeys;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 3, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Api Keys', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                            $author$project$Ui$Link$test('partner-api-keys')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 85)
                        ]))
                    ]))
                ]));
            case 4:
                var route = $author$project$Spa$Generated$Route$Partner__Webhooks__Settings;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 4, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Webhooks', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                            $author$project$Ui$Link$test('partner-webhooks')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 86)
                        ]))
                    ]))
                ]));
            case 5:
                var route = $author$project$Spa$Generated$Route$Partner__Practices__Top;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 5, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Practices', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                            $author$project$Ui$Link$test('practices')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 98)
                        ]))
                    ]))
                ]));
            case 1:
                var route = $author$project$Spa$Generated$Route$Partner__Hinter;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 1, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Hint', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                            $author$project$Ui$Link$test('hinter')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 34)
                        ]))
                    ]))
                ]));
            case 2:
                var route = $author$project$Spa$Generated$Route$Partner__Billing;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 2, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Billing', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                            $author$project$Ui$Link$test('billing')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 54)
                        ]))
                    ]))
                ]));
            case 6:
                var route = $author$project$Spa$Generated$Route$Partner__Sandboxes__Top;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 6, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Sandboxes', _List_fromArray([
                        A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                            $author$project$Ui$Link$test('sandboxes')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 100)
                        ]))
                    ]))
                ]));
            case 8:
                return $author$project$Utils$Html$empty;
            default:
                return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Navbars$Partner$viewMobileNavElements = F5(function(_v0, _v1, _v2, _v3, navItem) {
        var selectedNav = _v1.eI;
        var _v4 = navItem.yy;
        switch(_v4){
            case 0:
                var route = $author$project$Spa$Generated$Route$Partner__Team;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 0, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                        $author$project$Ui$Link$test('team')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 91),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Team')
                        ]))
                    ]))
                ]));
            case 7:
                var route = $author$project$Spa$Generated$Route$Partner__Dashboard__Top;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 7, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 75),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Dashboard')
                        ]))
                    ]))
                ]));
            case 3:
                var route = $author$project$Spa$Generated$Route$Partner__ApiKeys;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 3, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                        $author$project$Ui$Link$test('partner-api-keys')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 85),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Api Keys')
                        ]))
                    ]))
                ]));
            case 4:
                var route = $author$project$Spa$Generated$Route$Partner__Webhooks__Settings;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 4, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                        $author$project$Ui$Link$test('partner-webhooks')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 86),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Webhooks')
                        ]))
                    ]))
                ]));
            case 5:
                var route = $author$project$Spa$Generated$Route$Partner__Practices__Top;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 5, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                        $author$project$Ui$Link$test('practices')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 87),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Practices')
                        ]))
                    ]))
                ]));
            case 1:
                var route = $author$project$Spa$Generated$Route$Partner__Hinter;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 1, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                        $author$project$Ui$Link$test('hinter')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 34),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Hint')
                        ]))
                    ]))
                ]));
            case 6:
                var route = $author$project$Spa$Generated$Route$Partner__Sandboxes__Top;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 6, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                        $author$project$Ui$Link$test('sandboxes')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 92),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Sandboxes')
                        ]))
                    ]))
                ]));
            case 2:
                var route = $author$project$Spa$Generated$Route$Partner__Billing;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 2, selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, route, _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                        $author$project$Ui$Link$test('billing')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class('sidenav__icon')
                        ]), 54),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Billing')
                        ]))
                    ]))
                ]));
            case 8:
                return $author$project$Utils$Html$empty;
            default:
                return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Navbars$Partner$LogoutClicked = {
        $: 1
    };
    var $author$project$Navbars$Partner$viewProfileSubNav = function(selectedNav) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__subnav__content')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$selectedNavClass, 8, selectedNav))
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Profile, _List_fromArray([
                    $author$project$Ui$Link$onClick($author$project$Navbars$Partner$LinkClicked),
                    $author$project$Ui$Link$test('account-profile')
                ]), _List_fromArray([
                    $elm$html$Html$text('Profile')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Logout'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Navbars$Partner$LogoutClicked),
                    $author$project$Ui$Button$test('account-logout')
                ]), _List_fromArray([
                    $elm$html$Html$text('Logout')
                ]))
            ]))
        ]));
    };
    var $author$project$Navbars$Partner$SidenavToggled = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Image$viewHintLogoImage = function(optionsMinusAlt) {
        return A3($author$project$Ui$Image$viewImg, {
            Jg: 'Hint Logo'
        }, $author$project$Ui$Image$nameToCdnSrc('full-logo.svg'), optionsMinusAlt);
    };
    var $author$project$Navbars$Partner$viewLogo = $author$project$Ui$Image$viewHintLogoImage(_List_fromArray([
        $author$project$Ui$Image$height(40)
    ]));
    var $author$project$Navbars$Partner$viewTopNavbar = F5(function(hinterViewOff, _v0, partnerName, sessionConfig, maybeOrgSwitcher) {
        var selectedNav = _v0.eI;
        var slideIn = _v0.oz;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('elm-mobile-nav')
            ]), $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    $author$project$Navbars$Partner$viewLogo
                ]),
                slideIn ? _List_Nil : _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('sidenav-open')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Display side navigation menu'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Navbars$Partner$SidenavToggled(true))
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$burgerMenu(_List_Nil)
                        ]))
                    ]))
                ])
            ]))),
            slideIn ? A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav-close')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Close side navigation menu'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Navbars$Partner$SidenavToggled(false))
                ]), _List_fromArray([
                    $author$project$Ui$Icon$burgerMenuClose(_List_Nil)
                ]))
            ])) : $author$project$Utils$Html$empty,
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('topnav')
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('topnav__left')
                ]), _List_fromArray([
                    $author$project$Navbars$Partner$viewLogo,
                    A2($elm$core$Maybe$withDefault, A2($author$project$Navbars$Utils$viewSwitchOrganizationLink, partnerName, sessionConfig.KV), maybeOrgSwitcher)
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('topnav__right')
                ]), _List_fromArray([
                    sessionConfig.yu(hinterViewOff) ? A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('topnav__item'),
                        $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('topnav__active', 9 === selectedNav)
                        ]))
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Top, _List_fromArray([
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$marketplace)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Marketplace')
                        ]))
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]))
        ]));
    });
    var $author$project$Navbars$Partner$view = F3(function(hinterViewOff, maybeOrgSwitcherConfig, _v0) {
        var model = _v0;
        var partner = model.VW;
        var sessionConfiguration = model.Cs;
        var slideIn = model.oz;
        var tooltipOptions = _List_fromArray([
            $author$project$Ui$Tooltip$placement(3),
            $author$project$Ui$Tooltip$stackingOrder1030
        ]);
        var profileMobileView = A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(A2($author$project$Navbars$Partner$subNavClasses, 0, model.c5) + ' sidenav__item--profile-mobile')
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Profile'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Navbars$Partner$NavClicked(0)),
                $author$project$Ui$Button$test('account-profile-mobile')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 3),
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__profile-name')
                ]), _List_fromArray([
                    $elm$html$Html$text(sessionConfiguration.aib)
                ])),
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
                ]), 12)
            ])),
            $author$project$Navbars$Partner$viewProfileSubNav(model.eI)
        ]));
        var profileMenuView = A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('sidenav__active', model.eI === 8)
            ]))
        ]), $elm$core$List$singleton(A4($author$project$Ui$FlyoutMenu$view, _List_fromArray([
            $author$project$Ui$FlyoutMenu$position(1)
        ]), _List_fromArray([
            $author$project$Ui$FlyoutMenu$body(_List_fromArray([
                $author$project$Navbars$Partner$viewProfileSubNav(model.eI)
            ]))
        ]), A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Profile', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Profile'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$test('account-profile')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 3)
            ]))
        ])), model.et)));
        var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Partner$OrgSwitcherMsg, maybeOrgSwitcherConfig);
        var isHinter = sessionConfiguration.yu(hinterViewOff);
        var navElementsDesktop = A2($elm$core$List$map, A4($author$project$Navbars$Partner$viewDesktopNavElements, hinterViewOff, model, partner, sessionConfiguration), A2($author$project$Navbars$Partner$defaultNav, isHinter, partner));
        var navElementsMobile = A2($elm$core$List$map, A4($author$project$Navbars$Partner$viewMobileNavElements, hinterViewOff, model, partner, sessionConfiguration), A2($author$project$Navbars$Partner$defaultNav, isHinter, partner));
        return _List_fromArray([
            A5($author$project$Navbars$Partner$viewTopNavbar, hinterViewOff, model, $author$project$Api$Partner$Partner$One$name(partner), sessionConfiguration, orgSwitcherHtml),
            $author$project$Navbars$Utils$viewTopNavEnd,
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$id('sidenav'),
                $elm$html$Html$Attributes$class('sidenav'),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('sidenav--slide-in', slideIn)
                ]))
            ]), _List_fromArray([
                A2($author$project$Navbars$Utils$viewOrganizationHeader, $author$project$Api$Partner$Partner$One$name(model.VW), sessionConfiguration.KV),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
                ]), navElementsMobile),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
                ]), navElementsDesktop),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__bottom')
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('sidenav__bottom-separator')
                    ]), _List_Nil),
                    profileMobileView,
                    profileMenuView
                ]))
            ]))
        ]);
    });
    var $author$project$Navbars$Practice$LinkClicked = {
        $: 3
    };
    var $author$project$Navbars$Practice$NavClicked = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Navbars$Practice$OrgSwitcherMsg = function(a) {
        return {
            $: 19,
            a: a
        };
    };
    var $author$project$Navbars$Practice$SearchClicked = {
        $: 4
    };
    var $author$project$Navbars$Practice$SidenavExpandToggled = {
        $: 13
    };
    var $author$project$Navbars$Practice$SidenavToggled = function(a) {
        return {
            $: 11,
            a: a
        };
    };
    var $author$project$Navbars$Practice$Navigation$InternalRoute = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Navbars$Practice$Navigation$InternalRouteWithParams = F2(function(a, b) {
        return {
            $: 1,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Feature$NewMessagingEndpoint = 27;
    var $author$project$Navbars$Practice$Navigation$startAndEndDateParams = F2(function(startDate, endDate) {
        return _List_fromArray([
            A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('start'), $author$project$Utils$Date$toQuery)(startDate),
            A2($elm$core$Basics$composeL, $elm$url$Url$Builder$string('end'), $author$project$Utils$Date$toQuery)(endDate)
        ]);
    });
    var $author$project$Navbars$Practice$Navigation$currentMonthParams = function(maybeDate) {
        if (!maybeDate.$) {
            var currentDate_ = maybeDate.a;
            return A2($author$project$Navbars$Practice$Navigation$startAndEndDateParams, $author$project$Utils$Date$toBeginningOfMonth(currentDate_), $author$project$Utils$Date$toEndOfMonth(currentDate_));
        } else return _List_Nil;
    };
    var $author$project$Navbars$Practice$Navigation$mainNavItems = F4(function(practice, practiceConfiguration, sessionConfiguration, hinterViewOff) {
        var newMessagingEndpointEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 27, practice);
        var inboxRoute = newMessagingEndpointEnabled ? $author$project$Spa$Generated$Route$Messages__Chat : $author$project$Spa$Generated$Route$Messages__Sms;
        var employersText = A2($author$project$Formatters$String$sponsorize, practice, 'Employers');
        return _List_fromArray([
            {
                QZ: 75,
                yy: $author$project$Navbars$Practice$Navigation$ClinicalDashboard,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Home),
                to: 'dashboard',
                $Y: 'Dashboard',
                hh: practiceConfiguration.oY && practiceConfiguration.$C
            },
            {
                QZ: 8,
                yy: $author$project$Navbars$Practice$Navigation$Patients,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Patients__Top),
                to: 'patients',
                $Y: 'Patients',
                hh: sessionConfiguration.EF(hinterViewOff)
            },
            {
                QZ: 57,
                yy: $author$project$Navbars$Practice$Navigation$Calendar,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Calendar),
                to: 'clinical-calendar',
                $Y: 'Calendar',
                hh: practiceConfiguration.oY && practiceConfiguration.$C
            },
            {
                QZ: 77,
                yy: $author$project$Navbars$Practice$Navigation$Inbox,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute(inboxRoute),
                to: 'clinical-inbox',
                $Y: practiceConfiguration.UH ? 'Inbox' : 'Communication',
                hh: practiceConfiguration.oY && practiceConfiguration.$C
            },
            {
                QZ: 84,
                yy: $author$project$Navbars$Practice$Navigation$Tasks,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Tasks__Top),
                to: 'clinical-tasks',
                $Y: 'Tasks',
                hh: practiceConfiguration.oY && practiceConfiguration.$C
            },
            {
                QZ: 79,
                yy: $author$project$Navbars$Practice$Navigation$Forms,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Forms),
                to: 'clinical-forms',
                $Y: 'Forms',
                hh: practiceConfiguration.oY && practiceConfiguration.$C
            },
            {
                QZ: 78,
                yy: $author$project$Navbars$Practice$Navigation$Contacts,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Contacts__List),
                to: 'clinical-contacts',
                $Y: 'Contacts',
                hh: practiceConfiguration.oY && practiceConfiguration.$C && practiceConfiguration.UH
            },
            {
                QZ: 11,
                yy: $author$project$Navbars$Practice$Navigation$Sponsors,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Companies__Top),
                to: 'sponsors',
                $Y: employersText,
                hh: sessionConfiguration.KM(hinterViewOff)
            },
            {
                QZ: 10,
                yy: $author$project$Navbars$Practice$Navigation$Networks,
                Te: A2($author$project$Navbars$Practice$Navigation$InternalRouteWithParams, $author$project$Spa$Generated$Route$AffiliateBills__Top, $author$project$Navbars$Practice$Navigation$currentMonthParams),
                to: 'networks',
                $Y: 'Networks',
                hh: practiceConfiguration.Sd && sessionConfiguration.KN(hinterViewOff)
            },
            {
                QZ: 6,
                yy: $author$project$Navbars$Practice$Navigation$Commissions,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
                to: 'commissions',
                $Y: 'Commissions',
                hh: practiceConfiguration.LE && sessionConfiguration.KL(hinterViewOff)
            },
            {
                QZ: 68,
                yy: $author$project$Navbars$Practice$Navigation$Bookkeeping,
                Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Bookkeeping),
                to: 'bookkeeping',
                $Y: 'Bookkeeping',
                hh: practiceConfiguration.Km && sessionConfiguration.KK(hinterViewOff)
            }
        ]);
    });
    var $author$project$Navbars$Practice$selectedNavClass = $author$project$Navbars$Utils$selectedNavClass('');
    var $author$project$Navbars$Practice$subNavClasses = F2(function(subnav, openSubNav) {
        return 'sidenav__item sidenav__subnav' + (_Utils_eq(subnav, openSubNav) ? ' sidenav__subnav--open' : '');
    });
    var $author$project$Components$HinterPracticeSettingsModal$SearchQueryChanged = function(a) {
        return {
            $: 8,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$filterFeatures = F2(function(query, features) {
        if ($elm$core$String$isEmpty(query)) return features;
        else {
            var lowercaseQuery = $elm$core$String$toLower(query);
            return A2($elm$core$List$filter, function(feature) {
                return A2($elm$core$String$contains, lowercaseQuery, $elm$core$String$toLower($author$project$Api$Common$Feature$Shared$name(feature)));
            }, features);
        }
    });
    var $author$project$Components$HinterPracticeSettingsModal$sortFeatures = function(features) {
        return A2($elm$core$List$sortBy, $author$project$Api$Common$Feature$Shared$name, features);
    };
    var $author$project$Components$HinterPracticeSettingsModal$ChangeFeature = F2(function(a, b) {
        return {
            $: 6,
            a: a,
            b: b
        };
    });
    var $author$project$Components$HinterPracticeSettingsModal$viewFeature = function(feature) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$itemsCenter
        ]), _List_fromArray([
            $author$project$Ui$Button$group(_List_fromArray([
                $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                    $author$project$Ui$ToggleSwitch$on($author$project$Api$Common$Feature$Shared$enabled(feature)),
                    $author$project$Ui$ToggleSwitch$onChange($author$project$Components$HinterPracticeSettingsModal$ChangeFeature($author$project$Api$Common$Feature$Shared$id(feature))),
                    $author$project$Ui$ToggleSwitch$sm
                ]))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$ml2
            ]), _List_fromArray([
                $elm$html$Html$text($author$project$Api$Common$Feature$Shared$name(feature))
            ]))
        ]));
    };
    var $author$project$Components$HinterPracticeSettingsModal$viewFeatureFlags = function(data) {
        var _v0 = data.Px;
        switch(_v0.$){
            case 1:
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textMuted
                ]), _List_fromArray([
                    $author$project$Ui$Spinner$view(_List_fromArray([
                        $author$project$Ui$Spinner$small
                    ])),
                    $elm$html$Html$text(' Loading features...')
                ]));
            case 3:
                var features = _v0.a;
                var filteredFeatures = $author$project$Components$HinterPracticeSettingsModal$sortFeatures(A2($author$project$Components$HinterPracticeSettingsModal$filterFeatures, data.sH, features));
                return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    $author$project$Ui$Form$Input$view(_List_fromArray([
                        $author$project$Ui$Form$Input$placeholder('Search features...'),
                        $author$project$Ui$Form$Input$value(data.sH),
                        $author$project$Ui$Form$Input$onInput($author$project$Components$HinterPracticeSettingsModal$SearchQueryChanged)
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mt4,
                        $author$project$Ui$Element$spaceY2
                    ]), _List_fromArray([
                        $elm$core$List$isEmpty(filteredFeatures) ? A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$textMuted
                        ]), _List_fromArray([
                            $elm$html$Html$text('No features found')
                        ])) : A2($author$project$Ui$Element$view, _List_Nil, A2($elm$core$List$map, $author$project$Components$HinterPracticeSettingsModal$viewFeature, filteredFeatures))
                    ]))
                ]));
            case 2:
                return $author$project$Utils$Html$empty;
            default:
                return A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$textMuted
                ]), _List_fromArray([
                    $author$project$Ui$Spinner$view(_List_fromArray([
                        $author$project$Ui$Spinner$small
                    ])),
                    $elm$html$Html$text(' Loading...')
                ]));
        }
    };
    var $author$project$Components$HinterPracticeSettingsModal$ManagementGroupSelected = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$currentManagementGroupId = function(currentGroup) {
        return A2($elm$core$Maybe$map, $author$project$Api$Provider$ManagementGroup$Shared$id, currentGroup);
    };
    var $author$project$Components$HinterPracticeSettingsModal$managementGroupOptions = function(data) {
        var _v0 = data.m1;
        if (_v0.$ === 3) {
            var groups = _v0.a;
            return A2($elm$core$List$cons, A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'None'), A2($elm$core$List$map, function(group) {
                return A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Just($author$project$Api$Provider$ManagementGroup$Shared$id(group)), $author$project$Api$Provider$ManagementGroup$Shared$name(group));
            }, groups));
        } else return _List_fromArray([
            A3($author$project$Ui$Form$Select$option, _List_Nil, $elm$core$Maybe$Nothing, 'Loading...')
        ]);
    };
    var $author$project$Components$HinterPracticeSettingsModal$viewManagementGroup = function(data) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Practice Settings')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                function() {
                    var _v0 = data.m1;
                    switch(_v0.$){
                        case 1:
                            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Management Group')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$textMuted
                                ]), _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_fromArray([
                                        $author$project$Ui$Spinner$small
                                    ])),
                                    $elm$html$Html$text(' Loading management groups...')
                                ]))
                            ]));
                        case 3:
                            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Management Group')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Form$Select$view, _List_fromArray([
                                    $author$project$Ui$Form$Select$value($author$project$Components$HinterPracticeSettingsModal$currentManagementGroupId(data.h5)),
                                    $author$project$Ui$Form$Select$onChange($author$project$Components$HinterPracticeSettingsModal$ManagementGroupSelected)
                                ]), $author$project$Components$HinterPracticeSettingsModal$managementGroupOptions(data))
                            ]));
                        case 2:
                            return $author$project$Utils$Html$empty;
                        default:
                            return A2($author$project$Ui$Form$Group$view, _List_fromArray([
                                $author$project$Ui$Form$Group$label('Management Group')
                            ]), _List_fromArray([
                                A2($author$project$Ui$Element$view, _List_fromArray([
                                    $author$project$Ui$Element$textMuted
                                ]), _List_fromArray([
                                    $author$project$Ui$Spinner$view(_List_fromArray([
                                        $author$project$Ui$Spinner$small
                                    ])),
                                    $elm$html$Html$text(' Loading...')
                                ]))
                            ]));
                    }
                }()
            ]))
        ]));
    };
    var $author$project$Components$HinterPracticeSettingsModal$CopyToClipboard = function(a) {
        return {
            $: 9,
            a: a
        };
    };
    var $author$project$Components$HinterPracticeSettingsModal$GoToHinterSettings = {
        $: 10
    };
    var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
    var $author$project$Components$HinterPracticeSettingsModal$formatCreatedDate = function(practice) {
        return A2($author$project$Formatters$Date$toString, $author$project$Formatters$Date$Full, A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, $author$project$Api$Provider$Practice$One$createdAt(practice)));
    };
    var $author$project$Components$HinterPracticeSettingsModal$viewPracticeInfo = function(data) {
        return A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Practice Info')
                ]))
            ])),
            A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2,
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Name: ')
                        ])),
                        $elm$html$Html$text($author$project$Api$Provider$Practice$One$name(data.W1))
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Copy practice name'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$CopyToClipboard($author$project$Api$Provider$Practice$One$name(data.W1))),
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                    ]), _List_Nil)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2,
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Practice ID: ')
                        ])),
                        $elm$html$Html$text($author$project$Api$Provider$Practice$One$id(data.W1))
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Copy practice ID'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$CopyToClipboard($author$project$Api$Provider$Practice$One$id(data.W1))),
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                    ]), _List_Nil)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2,
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Organization ID: ')
                        ])),
                        $elm$html$Html$text($author$project$Api$Provider$Practice$One$organizationId(data.W1))
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Copy organization ID'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$CopyToClipboard($author$project$Api$Provider$Practice$One$organizationId(data.W1))),
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                    ]), _List_Nil)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2,
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Typography$strong, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Created On: ')
                        ])),
                        $elm$html$Html$text($author$project$Components$HinterPracticeSettingsModal$formatCreatedDate(data.W1))
                    ])),
                    A3($author$project$Ui$Button$view, {
                        abP: 'Copy created date'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$CopyToClipboard($author$project$Components$HinterPracticeSettingsModal$formatCreatedDate(data.W1))),
                        $author$project$Ui$Button$size(0),
                        $author$project$Ui$Button$icon($author$project$Ui$Icon$copy)
                    ]), _List_Nil)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mt2
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Go to Hinter settings'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$GoToHinterSettings)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Go to Clinical Hinter settings.')
                    ]))
                ]))
            ]))
        ]));
    };
    var $author$project$Components$HinterPracticeSettingsModal$view = function(model) {
        if (model.$ === 1) {
            var data = model.a;
            return A3($author$project$Ui$Modal$view, $author$project$Components$HinterPracticeSettingsModal$CloseModal, _List_fromArray([
                $author$project$Ui$Modal$size(2)
            ]), _List_fromArray([
                $author$project$Ui$Modal$header(_List_fromArray([
                    $author$project$Ui$Modal$title('Hinter Practice Settings')
                ])),
                $author$project$Ui$Modal$body(_List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(12),
                            $author$project$Ui$Grid$spanMd(6)
                        ]), _List_fromArray([
                            $author$project$Components$HinterPracticeSettingsModal$viewPracticeInfo(data),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$mt4
                            ]), _List_fromArray([
                                $author$project$Components$HinterPracticeSettingsModal$viewManagementGroup(data)
                            ]))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$span(12),
                            $author$project$Ui$Grid$spanMd(6)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Panel$heading, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Typography$title, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('Feature Flags')
                                    ]))
                                ])),
                                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                                    $author$project$Components$HinterPracticeSettingsModal$viewFeatureFlags(data)
                                ]))
                            ]))
                        ]))
                    ]))
                ])),
                $author$project$Ui$Modal$footer(_List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: 'Close modal'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Components$HinterPracticeSettingsModal$CloseModal)
                    ]), _List_fromArray([
                        $elm$html$Html$text('Close')
                    ]))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    };
    var $author$project$Navbars$Practice$DesktopExpandedStyle = {
        $: 2
    };
    var $author$project$Navbars$Practice$DesktopStyle = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Api$Common$PartnerApp$All$shared = function(_v0) {
        var shared_ = _v0;
        return shared_;
    };
    var $author$project$Api$Common$PartnerApp$All$embedsCorePage = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$embedsCorePage);
    var $author$project$Navbars$Practice$Navigation$adminSubnavItems = F3(function(practice, practiceConfiguration, isHintAdmin) {
        var providersItem = {
            yy: 1,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Providers__Top),
            to: 'admin-providers',
            $Y: 'Providers & Patients',
            hh: true
        };
        var packagesEnabled = A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice);
        var onlineSignupItem = {
            yy: 3,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Signup),
            to: 'admin-signup',
            $Y: 'Online Signup',
            hh: true
        };
        var notificationsItem = {
            yy: 7,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Notifications__Patient),
            to: 'admin-notifications-patient',
            $Y: 'Notifications',
            hh: true
        };
        var membershipOptionsItem = {
            yy: 2,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Plans__Top),
            to: 'admin-plans',
            $Y: 'Membership Options',
            hh: true
        };
        var isClinicalAndCore = practiceConfiguration.oY && practiceConfiguration.$C;
        var integrationsItem = {
            yy: 9,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Utils$Route$integrationsRoute(practice)),
            to: 'admin-stripe',
            $Y: 'Integrations',
            hh: true
        };
        var ephiItem = {
            yy: 8,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__HipaaAuthorizations),
            to: 'admin-hipaa-authorizations',
            $Y: 'ePHI Communication Waivers',
            hh: true
        };
        var employersText = A2($author$project$Formatters$String$sponsorize, practice, 'Employers');
        var employersItem = {
            yy: 10,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__InvoiceSettings),
            to: 'admin-invoice-settings',
            $Y: employersText,
            hh: practiceConfiguration.Gh
        };
        var documentsItem = {
            yy: 11,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Documents__Top),
            to: 'admin-documents',
            $Y: 'Documents',
            hh: true
        };
        var developersItem = {
            yy: 19,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Developers__ApiKeys),
            to: 'admin-developers',
            $Y: 'Developers',
            hh: isHintAdmin && $author$project$Api$Provider$Practice$One$hasManagedPartner(practice)
        };
        var dataExportItem = {
            yy: 12,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__DataExport__Top),
            to: 'admin-data-export',
            $Y: 'Data Exporter',
            hh: practiceConfiguration.M1
        };
        var creditsItem = {
            yy: 4,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__CreditCategories),
            to: 'admin-credit-categories',
            $Y: 'Credits',
            hh: practiceConfiguration.Az
        };
        var commissionsItem = {
            yy: 6,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Commissions),
            to: 'admin-commissions-setup',
            $Y: 'Commissions',
            hh: true
        };
        var chargesText = function() {
            var _v0 = _Utils_Tuple2(packagesEnabled, practiceConfiguration.FX);
            if (_v0.a) {
                if (_v0.b) return 'Charges, Packages, & Taxes';
                else return 'Charges & Packages';
            } else {
                if (_v0.b) return 'Charges & Taxes';
                else return 'Charges';
            }
        }();
        var chargesItem = {
            yy: 5,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__ChargeItems__Top),
            to: 'admin-charge-items',
            $Y: chargesText,
            hh: true
        };
        var accountItem = {
            yy: 0,
            Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Admin__Practice),
            to: 'admin-practice',
            $Y: 'Account',
            hh: true
        };
        if (isClinicalAndCore) {
            var remainingItems = _List_fromArray([
                ephiItem,
                {
                    yy: 15,
                    Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Erx),
                    to: 'clinical-erx',
                    $Y: 'eRx',
                    hh: true
                },
                {
                    yy: 17,
                    Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Files__Top),
                    to: 'clinical-file-drive',
                    $Y: 'File Drive',
                    hh: practiceConfiguration.UH
                },
                integrationsItem,
                {
                    yy: 16,
                    Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$Inventory__List),
                    to: 'clinical-medications',
                    $Y: 'Medications',
                    hh: practiceConfiguration.UH
                },
                membershipOptionsItem,
                notificationsItem,
                onlineSignupItem,
                {
                    yy: 20,
                    Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__PracticeInfo),
                    to: 'clinical-phones',
                    $Y: 'Phones',
                    hh: true
                },
                providersItem,
                {
                    yy: 21,
                    Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Team),
                    to: 'clinical-team',
                    $Y: 'Team',
                    hh: true
                },
                {
                    yy: 18,
                    Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Templates__Top),
                    to: 'clinical-templates',
                    $Y: 'Templates',
                    hh: true
                }
            ]);
            var clinicalCoreItems = _List_fromArray([
                accountItem,
                {
                    yy: 14,
                    Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top),
                    to: 'clinical-appointment-types',
                    $Y: 'Appointment Types',
                    hh: true
                },
                {
                    yy: 13,
                    Te: $author$project$Navbars$Practice$Navigation$InternalRoute($author$project$Spa$Generated$Route$NewSettings__Locations__Top),
                    to: 'clinical-calendar-locations',
                    $Y: 'Calendar > Locations',
                    hh: true
                },
                chargesItem,
                commissionsItem,
                creditsItem,
                dataExportItem,
                documentsItem
            ]);
            return employersText === 'Employers' ? _Utils_ap(clinicalCoreItems, _Utils_ap(A2($elm$core$List$cons, employersItem, remainingItems), _List_fromArray([
                developersItem
            ]))) : _Utils_ap(clinicalCoreItems, _Utils_ap(remainingItems, _List_fromArray([
                employersItem,
                developersItem
            ])));
        } else return _List_fromArray([
            accountItem,
            providersItem,
            membershipOptionsItem,
            onlineSignupItem,
            creditsItem,
            chargesItem,
            commissionsItem,
            notificationsItem,
            ephiItem,
            integrationsItem,
            employersItem,
            documentsItem,
            dataExportItem,
            developersItem
        ]);
    });
    var $author$project$Navbars$Practice$viewAdminSubNav = F4(function(selectedNav, practice, practiceConfiguration, isHintAdmin) {
        var viewItem = function(item) {
            return item.hh ? A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Admin(item.yy), selectedNav))
            ]), _List_fromArray([
                function() {
                    var _v0 = item.Te;
                    if (!_v0.$) {
                        var route = _v0.a;
                        return A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                            $author$project$Ui$Link$test(item.to)
                        ]), _List_fromArray([
                            $elm$html$Html$text(item.$Y)
                        ]));
                    } else {
                        var route = _v0.a;
                        return A3($author$project$Ui$Link$route, route, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                            $author$project$Ui$Link$test(item.to)
                        ]), _List_fromArray([
                            $elm$html$Html$text(item.$Y)
                        ]));
                    }
                }()
            ])) : $author$project$Utils$Html$empty;
        };
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__subnav__content')
        ]), A2($elm$core$List$map, viewItem, A3($author$project$Navbars$Practice$Navigation$adminSubnavItems, practice, practiceConfiguration, isHintAdmin)));
    });
    var $author$project$Navbars$Practice$viewNavIcon = F2(function(style, iconName) {
        var baseClasses = 'sidenav__icon';
        var classes = function() {
            var _v0 = _Utils_Tuple2(style, iconName);
            _v0$2: while(true){
                if (_v0.b === 68) switch(_v0.a.$){
                    case 1:
                        var _v1 = _v0.b;
                        return baseClasses + ' w-5 h-4.5';
                    case 2:
                        var _v2 = _v0.a;
                        var _v3 = _v0.b;
                        return baseClasses;
                    default:
                        break _v0$2;
                }
                else break _v0$2;
            }
            return baseClasses;
        }();
        return A2($author$project$Ui$Icon$view, _List_fromArray([
            $author$project$Ui$Icon$class(classes)
        ]), iconName);
    });
    var $author$project$Navbars$Practice$viewMainNavItem = F4(function(style, selectedNav, currentDate, item) {
        if (item.hh) {
            var linkOptions = function() {
                switch(style.$){
                    case 0:
                        return _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                            $author$project$Ui$Link$test(item.to)
                        ]);
                    case 1:
                        return _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                            $author$project$Ui$Link$test(item.to),
                            $author$project$Ui$Link$ariaLabel(item.$Y)
                        ]);
                    default:
                        return _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                            $author$project$Ui$Link$test(item.to)
                        ]);
                }
            }();
            var linkContent = function() {
                switch(style.$){
                    case 0:
                        return _List_fromArray([
                            A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Navbars$Practice$viewNavIcon, style, item.QZ)),
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(item.$Y)
                            ]))
                        ]);
                    case 1:
                        return _List_fromArray([
                            A2($author$project$Navbars$Practice$viewNavIcon, style, item.QZ)
                        ]);
                    default:
                        return _List_fromArray([
                            A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Navbars$Practice$viewNavIcon, style, item.QZ)),
                            A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                                $elm$html$Html$text(item.$Y)
                            ]))
                        ]);
                }
            }();
            var createLink = F2(function(route, params) {
                if (!params.$) {
                    var paramsFn = params.a;
                    return A3($author$project$Ui$Link$route, route, A2($elm$core$List$cons, $author$project$Ui$Link$routeParams(paramsFn(currentDate)), linkOptions), linkContent);
                } else return A3($author$project$Ui$Link$route, route, linkOptions, linkContent);
            });
            var linkElement = function() {
                var _v1 = item.Te;
                if (!_v1.$) {
                    var route = _v1.a;
                    return A2(createLink, route, $elm$core$Maybe$Nothing);
                } else {
                    var route = _v1.a;
                    var paramsFn = _v1.b;
                    return A2(createLink, route, $elm$core$Maybe$Just(paramsFn));
                }
            }();
            var wrappedLink = function() {
                switch(style.$){
                    case 0:
                        return linkElement;
                    case 1:
                        var tooltipOptions = style.a;
                        return A3($author$project$Ui$Tooltip$view, tooltipOptions, item.$Y, _List_fromArray([
                            linkElement
                        ]));
                    default:
                        return linkElement;
                }
            }();
            return A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, item.yy, selectedNav))
            ]), _List_fromArray([
                wrappedLink
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Api$Common$PartnerApp$All$corePageAnchor = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$corePageAnchor);
    var $author$project$Api$Common$PartnerApp$Anchor$corePageIconLabel = function(_v0) {
        var record = _v0;
        var _v1 = record.ah5;
        switch(_v1){
            case 0:
                return record.Mc;
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$PartnerApp$Anchor$corePageIconUrl = function(_v0) {
        var record = _v0;
        var _v1 = record.ah5;
        switch(_v1){
            case 0:
                return record.Md;
            case 1:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Common$PartnerApp$All$name = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, $author$project$Api$Common$PartnerApp$Shared$name);
    var $author$project$Api$Common$PartnerApp$Shared$partner = function(_v0) {
        var record = _v0;
        return record.VW;
    };
    var $author$project$Api$Common$Partner$Min$slug = function(_v0) {
        var record = _v0;
        return record._A;
    };
    var $author$project$Api$Common$PartnerApp$All$partnerSlug = A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$All$shared, A2($elm$core$Basics$composeR, $author$project$Api$Common$PartnerApp$Shared$partner, $author$project$Api$Common$Partner$Min$slug));
    var $author$project$WebComponents$SvgIconFromUrl$view = F2(function(attributes, url) {
        return A3($elm$html$Html$node, 'svg-icon-from-url', A2($elm$core$List$cons, A2($elm$html$Html$Attributes$attribute, 'src', url), attributes), _List_Nil);
    });
    var $author$project$Navbars$Practice$viewPartnerNavItem = F3(function(style, selectedNav, partnerApp) {
        var partnerIcon = A2($elm$core$Maybe$withDefault, A2($author$project$Ui$Icon$view, _List_fromArray([
            $author$project$Ui$Icon$class('sidenav__icon')
        ]), 75), A2($elm$core$Maybe$map, function(url) {
            return A2($author$project$WebComponents$SvgIconFromUrl$view, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__icon')
            ]), url);
        }, A2($elm$core$Maybe$andThen, $author$project$Api$Common$PartnerApp$Anchor$corePageIconUrl, $author$project$Api$Common$PartnerApp$All$corePageAnchor(partnerApp))));
        var linkLabel = A2($elm$core$Maybe$withDefault, $author$project$Api$Common$PartnerApp$All$name(partnerApp), A2($elm$core$Maybe$andThen, $author$project$Api$Common$PartnerApp$Anchor$corePageIconLabel, $author$project$Api$Common$PartnerApp$All$corePageAnchor(partnerApp)));
        var linkContent = function() {
            switch(style.$){
                case 0:
                    return _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, partnerIcon),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(linkLabel)
                        ]))
                    ]);
                case 1:
                    return _List_fromArray([
                        partnerIcon
                    ]);
                default:
                    return _List_fromArray([
                        A2($elm$html$Html$map, $elm$core$Basics$never, partnerIcon),
                        A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                            $elm$html$Html$text(linkLabel)
                        ]))
                    ]);
            }
        }();
        var appId = $author$project$Api$Common$PartnerApp$All$partnerSlug(partnerApp);
        var linkOptions = function() {
            switch(style.$){
                case 0:
                    return _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('partner-app-' + appId)
                    ]);
                case 1:
                    return _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('partner-app-' + appId),
                        $author$project$Ui$Link$ariaLabel(linkLabel)
                    ]);
                default:
                    return _List_fromArray([
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('partner-app-' + appId)
                    ]);
            }
        }();
        var linkElement = A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Apps__Slug_String({
            _A: appId
        }), linkOptions, linkContent);
        var wrappedLink = function() {
            switch(style.$){
                case 0:
                    return linkElement;
                case 1:
                    var tooltipOptions = style.a;
                    return A3($author$project$Ui$Tooltip$view, tooltipOptions, linkLabel, _List_fromArray([
                        linkElement
                    ]));
                default:
                    return linkElement;
            }
        }();
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$PartnerApp(appId), selectedNav))
        ]), _List_fromArray([
            wrappedLink
        ]));
    });
    var $author$project$Navbars$Practice$Navigation$AncillaryCharges = {
        $: 14
    };
    var $author$project$Navbars$Practice$Navigation$Disputes = {
        $: 15
    };
    var $author$project$Api$Provider$Report$All$record = function(_v0) {
        var record_ = _v0;
        return record_;
    };
    var $author$project$Api$Provider$Report$All$id = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Report$All$record, function($) {
        return $.aef;
    });
    var $author$project$Api$Provider$Report$idToResource = function(id) {
        switch(id){
            case 'signup_attempts':
                return $elm$core$Maybe$Just(1);
            case 'memberships':
                return $elm$core$Maybe$Just(11);
            case 'customer_invoices':
                return $elm$core$Maybe$Just(12);
            case 'invoices':
                return $elm$core$Maybe$Just(3);
            case 'credits':
                return $elm$core$Maybe$Just(15);
            case 'revenue_lines':
                return $elm$core$Maybe$Just(6);
            case 'deferred_revenue_lines':
                return $elm$core$Maybe$Just(7);
            case 'payment_applications':
                return $elm$core$Maybe$Just(9);
            case 'credit_lines':
                return $elm$core$Maybe$Just(14);
            case 'deposits':
                return $elm$core$Maybe$Just(13);
            case 'tax_lines':
                return $elm$core$Maybe$Just(8);
            case 'disputes':
                return $elm$core$Maybe$Just(21);
            case 'affiliate_ancillary_charges':
                return $elm$core$Maybe$Just(22);
            case 'company_registrations':
                return $elm$core$Maybe$Just(23);
            case 'payment_method_imports':
                return $elm$core$Maybe$Just(24);
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Api$Provider$EmbeddedReport$Shared$id = function(_v0) {
        var record = _v0;
        return record.aef;
    };
    var $author$project$Api$Provider$EmbeddedReport$All$id = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$EmbeddedReport$Shared$id(shared);
    };
    var $author$project$Api$Provider$EmbeddedReport$All$name = function(_v0) {
        var shared = _v0;
        return $author$project$Api$Provider$EmbeddedReport$Shared$name(shared);
    };
    var $author$project$Navbars$Practice$viewEmbeddedReport = F2(function(selectedNav, report) {
        var reportName = $author$project$Api$Provider$EmbeddedReport$All$name(report);
        var reportId = $author$project$Api$Provider$EmbeddedReport$All$id(report);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Custom(reportId)), selectedNav))
        ]), _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Custom__Id_String({
                aef: reportId
            }), _List_fromArray([
                $author$project$Ui$Link$test('reports-custom-' + A3($elm$core$String$replace, ' ', '-', $elm$core$String$toLower(reportName))),
                $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked)
            ]), _List_fromArray([
                $elm$html$Html$text(reportName)
            ]))
        ]));
    });
    var $author$project$Navbars$Practice$viewEmbeddedReports = F2(function(selectedNav, embeddedReports) {
        if (embeddedReports.$ === 3) {
            var reports = embeddedReports.a;
            return A2($elm$core$List$map, $author$project$Navbars$Practice$viewEmbeddedReport(selectedNav), reports);
        } else return _List_Nil;
    });
    var $author$project$Navbars$Practice$viewReportSubNav = F6(function(selectedNav, currentDate, practice, practiceConfiguration, embeddedReports, reports) {
        var viewableReportResources = A2($elm$core$List$filterMap, A2($elm$core$Basics$composeR, $author$project$Api$Provider$Report$All$id, $author$project$Api$Provider$Report$idToResource), A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(reports)));
        var trailing13MonthsParams = function() {
            if (!currentDate.$) {
                var currentDate_ = currentDate.a;
                return function(_v4) {
                    var startDate = _v4.a;
                    var endDate = _v4.b;
                    return A2($author$project$Navbars$Practice$Navigation$startAndEndDateParams, $author$project$Utils$Date$toBeginningOfMonth(startDate), endDate);
                }(A2($author$project$Utils$Date$trailingRange, 13, currentDate_));
            } else return _List_Nil;
        }();
        var trailing12MonthsParams = function() {
            if (!currentDate.$) {
                var currentDate_ = currentDate.a;
                return function(_v2) {
                    var startDate = _v2.a;
                    var endDate = _v2.b;
                    return A2($author$project$Navbars$Practice$Navigation$startAndEndDateParams, startDate, endDate);
                }(A2($author$project$Utils$Date$trailingRange, 12, currentDate_));
            } else return _List_Nil;
        }();
        var ifViewable = F2(function(reportResource, content) {
            return A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), A2($elm$core$Maybe$map, $elm$core$Basics$always(content), A2($elm_community$list_extra$List$Extra$find, $elm$core$Basics$eq(reportResource), viewableReportResources)));
        });
        var currentMonthParams = function() {
            if (!currentDate.$) {
                var currentDate_ = currentDate.a;
                return A2($author$project$Navbars$Practice$Navigation$startAndEndDateParams, $author$project$Utils$Date$toBeginningOfMonth(currentDate_), $author$project$Utils$Date$toEndOfMonth(currentDate_));
            } else return _List_Nil;
        }();
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__subnav__content')
        ]), $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Dashboard), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Dashboard, _List_fromArray([
                        $author$project$Ui$Link$routeParams(trailing12MonthsParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-dashboard')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Dashboard')
                    ]))
                ])),
                A2(ifViewable, 15, A2(ifViewable, 6, A2(ifViewable, 9, A2(ifViewable, 8, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Months), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Months, _List_fromArray([
                        $author$project$Ui$Link$routeParams(trailing13MonthsParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-months')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Reporting Periods')
                    ]))
                ])))))),
                A2(ifViewable, 1, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SignupAttempts), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__SignupAttempts, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-signup-attempts')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Signup Attempts')
                    ]))
                ]))),
                A2(ifViewable, 11, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Memberships), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Memberships, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-memberships')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Memberships')
                    ]))
                ]))),
                A2(ifViewable, 12, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Invoices), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Invoices, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-invoices')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Patient Invoices')
                    ]))
                ]))),
                A2($author$project$Navbars$Utils$ifConfiguration, practiceConfiguration.Gh, A2(ifViewable, 3, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CompanyInvoices), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CompanyInvoices, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-company-invoices')
                    ]), _List_fromArray([
                        $elm$html$Html$text(A2($author$project$Formatters$String$sponsorize, practice, 'Employer Invoices'))
                    ]))
                ])))),
                A2(ifViewable, 15, A2($author$project$Navbars$Utils$ifConfiguration, practiceConfiguration.Az, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditOutstanding), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditOutstanding, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-credit-outstanding')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Credit Outstanding')
                    ]))
                ])))),
                A2(ifViewable, 6, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Revenue), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Revenue, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-revenue')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Billed Revenue')
                    ]))
                ]))),
                A2(ifViewable, 7, A2($author$project$Navbars$Utils$ifConfiguration, A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice), A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$DeferredRevenue), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__DeferredRevenue, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-deferred-revenue')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Deferred Revenue')
                    ]))
                ])))),
                A2(ifViewable, 9, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$PaymentApplications), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__PaymentApplications, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-payment-applications')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Received Payments')
                    ]))
                ]))),
                A2(ifViewable, 14, A2($author$project$Navbars$Utils$ifConfiguration, practiceConfiguration.Az, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$CreditTransactions), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__CreditTransactions, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-credit-transactions')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Credit Transactions')
                    ]))
                ])))),
                A2(ifViewable, 13, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Deposits), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Deposits, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-deposits')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Deposits')
                    ]))
                ]))),
                A2(ifViewable, 21, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$Disputes), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__Disputes, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-disputes')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Disputes')
                    ]))
                ]))),
                A2(ifViewable, 8, A2($author$project$Navbars$Utils$ifConfiguration, practiceConfiguration.FX, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$SalesTax), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__SalesTax, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-sales-tax')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Sales Tax')
                    ]))
                ])))),
                A2($author$project$Navbars$Utils$ifConfiguration, practiceConfiguration.Sd, A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Reports($author$project$Navbars$Practice$Navigation$AncillaryCharges), selectedNav))
                ]), _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top, _List_fromArray([
                        $author$project$Ui$Link$routeParams(currentMonthParams),
                        $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                        $author$project$Ui$Link$test('reports-ancillary-charges')
                    ]), _List_fromArray([
                        $elm$html$Html$text('Affiliate Ancillary Charges')
                    ]))
                ])))
            ]),
            A2($author$project$Navbars$Practice$viewEmbeddedReports, selectedNav, embeddedReports)
        ])));
    });
    var $author$project$Navbars$Practice$viewDesktopNavElements = F4(function(_v0, hinterViewOff, sidenavExpanded, items) {
        var selectedNav = _v0.eI;
        var currentDate = _v0.cP;
        var embeddedReports = _v0.qt;
        var reports = _v0.st;
        var reportMenu = _v0.jR;
        var adminMenu = _v0.hu;
        var openSubNav = _v0.c5;
        var practice = _v0.W1;
        var practiceConfiguration = _v0.jz;
        var sessionConfiguration = _v0.Cs;
        var partnerApps = _v0.rS;
        var tooltipOptions = _List_fromArray([
            $author$project$Ui$Tooltip$placement(3),
            $author$project$Ui$Tooltip$stackingOrder1030
        ]);
        var reportsTrigger = sidenavExpanded ? A3($author$project$Ui$Button$view, {
            abP: 'Reports'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$test('reports')
        ]), _List_fromArray([
            A2($author$project$Ui$Icon$view, _List_fromArray([
                $author$project$Ui$Icon$class('sidenav__icon')
            ]), 9),
            $elm$html$Html$text('Reports'),
            A2($author$project$Ui$Icon$view, _List_fromArray([
                $author$project$Ui$Icon$class('sidenav__expand-chevron ml-auto')
            ]), 12)
        ])) : A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Reports', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Reports'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$test('reports')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 9)
            ]))
        ]));
        var reportsItem = A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.vZ(hinterViewOff), A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('sidenav__item', true),
                _Utils_Tuple2('sidenav__active', !openSubNav || !$author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav))
            ]))
        ]), $elm$core$List$singleton(A4($author$project$Ui$FlyoutMenu$view, _List_fromArray([
            $author$project$Ui$FlyoutMenu$position(0)
        ]), _List_fromArray([
            $author$project$Ui$FlyoutMenu$header(_List_fromArray([
                $author$project$Ui$FlyoutMenu$title('Reports')
            ])),
            $author$project$Ui$FlyoutMenu$body(_List_fromArray([
                A6($author$project$Navbars$Practice$viewReportSubNav, selectedNav, currentDate, practice, practiceConfiguration, embeddedReports, reports)
            ]))
        ]), reportsTrigger, reportMenu))));
        var itemStyle = sidenavExpanded ? $author$project$Navbars$Practice$DesktopExpandedStyle : $author$project$Navbars$Practice$DesktopStyle(tooltipOptions);
        var partnerAppItems = A2($elm$core$List$map, A2($author$project$Navbars$Practice$viewPartnerNavItem, itemStyle, selectedNav), A2($elm$core$List$filter, $author$project$Api$Common$PartnerApp$All$embedsCorePage, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(partnerApps))));
        var baseItems = A2($elm$core$List$map, A3($author$project$Navbars$Practice$viewMainNavItem, itemStyle, selectedNav, currentDate), items);
        var adminTrigger = sidenavExpanded ? A3($author$project$Ui$Button$view, {
            abP: 'Admin'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$test('admin')
        ]), _List_fromArray([
            A2($author$project$Ui$Icon$view, _List_fromArray([
                $author$project$Ui$Icon$class('sidenav__icon')
            ]), 4),
            $elm$html$Html$text('Admin'),
            A2($author$project$Ui$Icon$view, _List_fromArray([
                $author$project$Ui$Icon$class('sidenav__expand-chevron ml-auto')
            ]), 12)
        ])) : A3($author$project$Ui$Tooltip$view, tooltipOptions, 'Admin', _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Admin'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$test('admin')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 4)
            ]))
        ]));
        var adminItem = A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.ED(hinterViewOff), A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('sidenav__item', true),
                _Utils_Tuple2('sidenav__active', openSubNav === 1 || $author$project$Navbars$Practice$openSubNavFromSelectedNav(selectedNav) === 1)
            ]))
        ]), $elm$core$List$singleton(A4($author$project$Ui$FlyoutMenu$view, _List_fromArray([
            $author$project$Ui$FlyoutMenu$position(0)
        ]), _List_fromArray([
            $author$project$Ui$FlyoutMenu$header(_List_fromArray([
                $author$project$Ui$FlyoutMenu$title('Admin')
            ])),
            $author$project$Ui$FlyoutMenu$body(_List_fromArray([
                A4($author$project$Navbars$Practice$viewAdminSubNav, selectedNav, practice, practiceConfiguration, sessionConfiguration.Cu.yu(hinterViewOff))
            ]))
        ]), adminTrigger, adminMenu))));
        return _Utils_ap(baseItems, A2($elm$core$List$cons, reportsItem, _Utils_ap(partnerAppItems, _List_fromArray([
            adminItem
        ]))));
    });
    var $author$project$Navbars$Practice$CopyOrganizationId = function(a) {
        return {
            $: 21,
            a: a
        };
    };
    var $author$project$Navbars$Practice$CopyPracticeId = function(a) {
        return {
            $: 20,
            a: a
        };
    };
    var $author$project$Navbars$Practice$viewHinterIdButtons = F2(function(model, hinterViewOff) {
        return A2($author$project$Utils$User$isViewingAsHinter, model.Z$, hinterViewOff) ? A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$flex,
            $author$project$Ui$Element$justifyCenter,
            $author$project$Ui$Element$gap
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Copy practice identifier'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Navbars$Practice$CopyPracticeId($author$project$Api$Provider$Practice$One$id(model.W1)))
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('PID')
                ]))
            ])),
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$muted
            ]), _List_fromArray([
                $elm$html$Html$text('|')
            ])),
            A3($author$project$Ui$Button$view, {
                abP: 'Copy organization identifier'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Navbars$Practice$CopyOrganizationId($author$project$Api$Provider$Practice$One$organizationId(model.W1)))
            ]), _List_fromArray([
                A2($author$project$Ui$Typography$span, _List_fromArray([
                    $author$project$Ui$Typography$small,
                    $author$project$Ui$Typography$muted
                ]), _List_fromArray([
                    $elm$html$Html$text('OID')
                ]))
            ]))
        ])) : $author$project$Utils$Html$empty;
    });
    var $author$project$Navbars$Practice$MobileStyle = {
        $: 0
    };
    var $author$project$Navbars$Practice$viewMobileNavElements = F3(function(_v0, hinterViewOff, items) {
        var selectedNav = _v0.eI;
        var openSubNav = _v0.c5;
        var currentDate = _v0.cP;
        var embeddedReports = _v0.qt;
        var partnerApps = _v0.rS;
        var practice = _v0.W1;
        var practiceConfiguration = _v0.jz;
        var sessionConfiguration = _v0.Cs;
        var reports = _v0.st;
        var reportsItem = A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.vZ(hinterViewOff), A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$subNavClasses, 0, openSubNav))
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Show reports menu'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Navbars$Practice$NavClicked(0)),
                $author$project$Ui$Button$test('reports')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 9),
                $elm$html$Html$text('Reports'),
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
                ]), 12)
            ])),
            A6($author$project$Navbars$Practice$viewReportSubNav, selectedNav, currentDate, practice, practiceConfiguration, embeddedReports, reports)
        ])));
        var partnerAppItems = A2($elm$core$List$map, A2($author$project$Navbars$Practice$viewPartnerNavItem, $author$project$Navbars$Practice$MobileStyle, selectedNav), A2($elm$core$List$filter, $author$project$Api$Common$PartnerApp$All$embedsCorePage, A2($elm$core$Maybe$withDefault, _List_Nil, $author$project$Api$Data$toMaybe(partnerApps))));
        var baseItems = A2($elm$core$List$map, A3($author$project$Navbars$Practice$viewMainNavItem, $author$project$Navbars$Practice$MobileStyle, selectedNav, currentDate), items);
        var adminItem = A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.ED(hinterViewOff), A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$subNavClasses, 1, openSubNav))
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Show admin menu'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Navbars$Practice$NavClicked(1)),
                $author$project$Ui$Button$test('admin')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 4),
                $elm$html$Html$text('Admin'),
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
                ]), 12)
            ])),
            A4($author$project$Navbars$Practice$viewAdminSubNav, selectedNav, practice, practiceConfiguration, sessionConfiguration.Cu.yu(hinterViewOff))
        ])));
        return _Utils_ap(baseItems, A2($elm$core$List$cons, reportsItem, _Utils_ap(partnerAppItems, _List_fromArray([
            adminItem
        ]))));
    });
    var $author$project$Navbars$Practice$LogoutClicked = {
        $: 6
    };
    var $author$project$Navbars$Practice$viewProfileSubNav = function(selectedNav) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__subnav__content')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Account, selectedNav)),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('bg-primary-100', _Utils_eq(selectedNav, $author$project$Navbars$Practice$Navigation$Account))
                ]))
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Profile, _List_fromArray([
                    $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                    $author$project$Ui$Link$test('account-profile')
                ]), _List_fromArray([
                    $elm$html$Html$text('Profile')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Button$view, {
                    abP: 'Logout'
                }, _List_fromArray([
                    $author$project$Ui$Button$link,
                    $author$project$Ui$Button$onClick($author$project$Navbars$Practice$LogoutClicked),
                    $author$project$Ui$Button$test('account-logout')
                ]), _List_fromArray([
                    $elm$html$Html$text('Logout')
                ]))
            ]))
        ]));
    };
    var $author$project$Ui$Image$HelpCircle = 13;
    var $author$project$Navbars$Practice$ShowSupportChat = {
        $: 15
    };
    var $author$project$Navbars$Practice$viewResourcesSubNav = function(imageStore) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__subnav__content')
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Link$externalHref, '#', _List_fromArray([
                    $author$project$Ui$Link$onClick($author$project$Navbars$Practice$ShowSupportChat),
                    $author$project$Ui$Link$test('help-support-chat')
                ]), _List_fromArray([
                    $elm$html$Html$text('Help & Support '),
                    A4($author$project$Ui$Image$view, imageStore, {
                        Jg: 'Help and support icon'
                    }, _List_fromArray([
                        $author$project$Ui$Image$height(20)
                    ]), 13)
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Link$externalHref, 'https://support.hint.com/', _List_fromArray([
                    $author$project$Ui$Link$targetBlank,
                    $author$project$Ui$Link$test('help-support-articles')
                ]), _List_fromArray([
                    $elm$html$Html$text('Support Articles')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Link$externalHref, 'https://community.hint.com/c/hint-updates/', _List_fromArray([
                    $author$project$Ui$Link$targetBlank,
                    $author$project$Ui$Link$test('help-product-updates')
                ]), _List_fromArray([
                    $elm$html$Html$text('Product Updates')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Support__CannySso, _List_fromArray([
                    $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                    $author$project$Ui$Link$test('help-feature-requests')
                ]), _List_fromArray([
                    $elm$html$Html$text('Feature Requests')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Link$externalHref, 'https://community.hint.com/oauth2/initiate', _List_fromArray([
                    $author$project$Ui$Link$targetBlank,
                    $author$project$Ui$Link$test('help-community')
                ]), _List_fromArray([
                    $elm$html$Html$text('Community')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Link$externalHref, 'https://www.hint.com/ecosystem', _List_fromArray([
                    $author$project$Ui$Link$targetBlank,
                    $author$project$Ui$Link$test('help-partner-ecosystem')
                ]), _List_fromArray([
                    $elm$html$Html$text('Partner Ecosystem')
                ]))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__item')
            ]), _List_fromArray([
                A3($author$project$Ui$Link$externalHref, 'https://www.hint.com/blog', _List_fromArray([
                    $author$project$Ui$Link$targetBlank,
                    $author$project$Ui$Link$test('help-blog')
                ]), _List_fromArray([
                    $elm$html$Html$text('Blog')
                ]))
            ]))
        ]));
    };
    var $author$project$Navbars$Practice$viewSearchKeyboardShortcut = function(maybeOsName) {
        if (!maybeOsName.$) {
            var osName = maybeOsName.a;
            return osName === 'Mac' || osName === 'iOS' || osName === 'iPadOS' ? "\u2318 K" : 'Ctrl+K';
        } else return '';
    };
    var $author$project$Ui$Icon$Fill = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Icon$fill = $author$project$Ui$Icon$Fill;
    var $author$project$Ui$Margin$Left_30 = 13;
    var $author$project$Navbars$Practice$emrDashboardUrl = F3(function(practice, origin, emrHost) {
        var isUnifiedExperience = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice);
        return A3($author$project$Utils$Clinical$getDashboardUrl, isUnifiedExperience, origin, emrHost);
    });
    var $author$project$Ui$Popover$Margin = function(a) {
        return {
            $: 5,
            a: a
        };
    };
    var $author$project$Ui$Popover$margin = $author$project$Ui$Popover$Margin;
    var $author$project$Navbars$Practice$LogoClicked = {
        $: 16
    };
    var $author$project$Navbars$Practice$viewAppLogo = F4(function(whitelabelSetting, practiceName, maybeListOptions, isHintAdmin) {
        var createStaticElement = function(content) {
            return A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$inlineBlock
            ]), _List_fromArray([
                content
            ]));
        };
        var createHinterButton = function(content) {
            return A3($author$project$Ui$Button$view, {
                abP: 'Show hinter practice settings'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Navbars$Practice$LogoClicked)
            ]), _List_fromArray([
                content
            ]));
        };
        var renderContent = F2(function(content, hasValidUrl) {
            if (isHintAdmin) return createHinterButton(A2($elm$html$Html$map, $elm$core$Basics$never, content));
            else {
                if (hasValidUrl) {
                    if (!maybeListOptions.$) {
                        var listOptions = maybeListOptions.a;
                        return A3($author$project$Ui$Link$externalHref, '/', listOptions, _List_fromArray([
                            content
                        ]));
                    } else return A2($elm$html$Html$map, $elm$core$Basics$never, content);
                } else return createStaticElement(A2($elm$html$Html$map, $elm$core$Basics$never, content));
            }
        });
        var _v0 = _Utils_Tuple2($author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting), $author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
        var altText = _v0.a;
        var maybeLogoUrl = _v0.b;
        var logoElementNever = function(logoUrl) {
            return A2($elm$html$Html$map, $elm$core$Basics$never, A3($author$project$Ui$Image$fromSrc, {
                Jg: altText
            }, logoUrl, _List_fromArray([
                $author$project$Ui$Image$height(40)
            ])));
        };
        if (!maybeLogoUrl.$) {
            var logoUrl = maybeLogoUrl.a;
            return A2(renderContent, logoElementNever(logoUrl), true);
        } else return A2(renderContent, A2($elm$html$Html$map, $elm$core$Basics$never, $elm$html$Html$text(practiceName)), false);
    });
    var $author$project$Navbars$Practice$viewAppLogoForDropdown = F2(function(whitelabelSetting, practiceName) {
        var _v0 = _Utils_Tuple2($author$project$Api$WhitelabelSetting$practiceFacingLogoAltText(whitelabelSetting), $author$project$Api$WhitelabelSetting$practiceFacingLogoUrl(whitelabelSetting));
        var altText = _v0.a;
        var maybeLogoUrl = _v0.b;
        if (!maybeLogoUrl.$) {
            var logoUrl = maybeLogoUrl.a;
            return A3($author$project$Ui$Image$fromSrc, {
                Jg: altText
            }, logoUrl, _List_fromArray([
                $author$project$Ui$Image$height(40)
            ]));
        } else return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$inlineBlock
        ]), _List_fromArray([
            $elm$html$Html$text(practiceName)
        ]));
    });
    var $author$project$Navbars$Practice$viewLogo = F4(function(_v0, dropdownMenu, sessionConfiguration, hinterViewOff) {
        var whitelabelSetting = _v0.abq;
        var practice = _v0.W1;
        var origin = _v0.afY;
        var emrHost = _v0.adm;
        var showSwitchProduct = _v0.Hr;
        var unifiedExperienceEnabled = _v0.oY;
        var backupAuthEnabled = _v0.abT;
        var isHintAdmin = _v0.F3;
        if (showSwitchProduct && !unifiedExperienceEnabled) {
            var appSwitcher = function(appList) {
                return isHintAdmin ? A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$spaceX2
                ]), _List_fromArray([
                    A4($author$project$Navbars$Practice$viewAppLogo, whitelabelSetting, $author$project$Api$Provider$Practice$One$name(practice), $elm$core$Maybe$Nothing, isHintAdmin),
                    A4($author$project$Ui$Dropdown$view, _List_fromArray([
                        $author$project$Ui$Dropdown$disabled(backupAuthEnabled),
                        $author$project$Ui$Dropdown$buttonLink
                    ]), _List_Nil, appList, dropdownMenu)
                ])) : A4($author$project$Ui$Dropdown$view, _List_fromArray([
                    $author$project$Ui$Dropdown$disabled(backupAuthEnabled),
                    $author$project$Ui$Dropdown$buttonLink
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Navbars$Practice$viewAppLogoForDropdown, whitelabelSetting, $author$project$Api$Provider$Practice$One$name(practice)))
                ]), appList, dropdownMenu);
            };
            return backupAuthEnabled ? A3($author$project$Ui$Popover$view, _List_fromArray([
                $author$project$Ui$Popover$sm,
                $author$project$Ui$Popover$margin(18),
                $author$project$Ui$Popover$margin(13)
            ]), _List_fromArray([
                appSwitcher(_List_Nil)
            ]), _List_fromArray([
                A2($author$project$Ui$Popover$body, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('The Clinical app is temporarily unavailable due to the sign-in system outage.')
                ]))
            ])) : appSwitcher(_List_fromArray([
                A3($author$project$Ui$Dropdown$link, A3($author$project$Navbars$Practice$emrDashboardUrl, practice, origin, emrHost), _List_Nil, $elm$html$Html$text('Clinical'))
            ]));
        } else {
            var listOptions = _List_fromArray([
                $author$project$Ui$Link$disabled(sessionConfiguration.W4 && !sessionConfiguration.Cu.yu(hinterViewOff))
            ]);
            return A4($author$project$Navbars$Practice$viewAppLogo, whitelabelSetting, $author$project$Api$Provider$Practice$One$name(practice), $elm$core$Maybe$Just(listOptions), isHintAdmin);
        }
    });
    var $author$project$Navbars$Practice$viewTopNavbar = F4(function(hinterViewOff, model, jointProductEnabled, maybeOrgSwitcher) {
        var sessionConfiguration = model.Cs;
        var isHintAdmin = A2($author$project$Utils$User$isViewingAsHinter, model.Z$, hinterViewOff);
        var logoConfig = {
            abT: model.abT,
            adm: model.adm,
            F3: isHintAdmin,
            afY: model.afY,
            W1: model.W1,
            Hr: jointProductEnabled,
            oY: model.jz.oY,
            abq: model.abq
        };
        var logo = A4($author$project$Navbars$Practice$viewLogo, logoConfig, model.oI, sessionConfiguration, hinterViewOff);
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('elm-mobile-nav')
            ]), $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    logo
                ]),
                model.oz ? _List_Nil : _List_fromArray([
                    A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('sidenav-open')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Display side navigation menu'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Navbars$Practice$SidenavToggled(true))
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_Nil, 29)
                        ]))
                    ]))
                ])
            ]))),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('topnav')
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('topnav__left')
                ]), _List_fromArray([
                    logo,
                    A2($elm$core$Maybe$withDefault, A2($author$project$Navbars$Utils$viewSwitchOrganizationLink, $author$project$Api$Provider$Practice$One$name(model.W1), sessionConfiguration.Cu.KV), maybeOrgSwitcher)
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('topnav__right')
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('topnav__search')
                    ]), _List_fromArray([
                        A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.v_(hinterViewOff), A3($author$project$Ui$Button$view, {
                            abP: 'Search'
                        }, _List_fromArray([
                            $author$project$Ui$Button$onClick($author$project$Navbars$Practice$SearchClicked)
                        ]), _List_fromArray([
                            A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('topnav__search-content')
                            ]), _List_fromArray([
                                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    A2($author$project$Ui$Icon$view, _List_fromArray([
                                        $author$project$Ui$Icon$fill('currentColor'),
                                        $author$project$Ui$Icon$height('0.9rem')
                                    ]), 41),
                                    $author$project$Utils$Html$noBreakSpace,
                                    $author$project$Utils$Html$noBreakSpace,
                                    $elm$html$Html$text('Search')
                                ])),
                                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                    $elm$html$Html$text($author$project$Navbars$Practice$viewSearchKeyboardShortcut(sessionConfiguration.Cu.VG))
                                ]))
                            ]))
                        ])))
                    ])),
                    A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.Cu.yu(hinterViewOff) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 25, model.W1), A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('topnav__item')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Top, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                            $author$project$Ui$Link$test('marketplace'),
                            $author$project$Ui$Link$icon($author$project$Ui$Icon$marketplace)
                        ]), _List_fromArray([
                            $elm$html$Html$text('Marketplace')
                        ]))
                    ]))),
                    sessionConfiguration.W4 && !sessionConfiguration.Cu.yu(hinterViewOff) ? $author$project$Utils$Html$empty : A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('topnav__item topnav__subnav'),
                        $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('topnav__subnav--open', 2 === model.c5)
                        ]))
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'view help resources'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Navbars$Practice$NavClicked(2)),
                            $author$project$Ui$Button$icon($author$project$Ui$Icon$book),
                            $author$project$Ui$Button$test('help')
                        ]), _List_fromArray([
                            $elm$html$Html$text('Resources'),
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('topnav__icon--show-more')
                            ]), 12)
                        ])),
                        $author$project$Navbars$Practice$viewResourcesSubNav(model.qW)
                    ]))
                ]))
            ]))
        ]));
    });
    var $author$project$Navbars$Practice$view = F3(function(hinterViewOff, maybeOrgSwitcherConfig, _v0) {
        var model = _v0;
        var sessionConfiguration = model.Cs;
        var slideIn = model.oz;
        var sidenavExpanded = model.sZ;
        var profileMobileView = A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$subNavClasses, 3, model.c5) + ' sidenav__item--profile-mobile')
        ]), _List_fromArray([
            A3($author$project$Ui$Button$view, {
                abP: 'Profile'
            }, _List_fromArray([
                $author$project$Ui$Button$link,
                $author$project$Ui$Button$onClick($author$project$Navbars$Practice$NavClicked(3)),
                $author$project$Ui$Button$test('account-profile-mobile')
            ]), _List_fromArray([
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon')
                ]), 3),
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__profile-name')
                ]), _List_fromArray([
                    $elm$html$Html$text(sessionConfiguration.Cu.aib)
                ])),
                A2($author$project$Ui$Icon$view, _List_fromArray([
                    $author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
                ]), 12)
            ])),
            $author$project$Navbars$Practice$viewProfileSubNav(model.eI)
        ]));
        var profileButton = A3($author$project$Ui$Button$view, {
            abP: 'Profile'
        }, _List_fromArray([
            $author$project$Ui$Button$link,
            $author$project$Ui$Button$test('account-profile')
        ]), _List_fromArray([
            A2($author$project$Ui$Icon$view, _List_fromArray([
                $author$project$Ui$Icon$class('sidenav__icon')
            ]), 3),
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('sidenav__profile-name')
            ]), _List_fromArray([
                $elm$html$Html$text('Profile')
            ]))
        ]));
        var orgSwitcherHtml = A2($author$project$Components$OrganizationSwitcher$maybeViewFor, $author$project$Navbars$Practice$OrgSwitcherMsg, maybeOrgSwitcherConfig);
        var mainItems = A4($author$project$Navbars$Practice$Navigation$mainNavItems, model.W1, model.jz, model.Cs, hinterViewOff);
        var navElementsMobile = A3($author$project$Navbars$Practice$viewMobileNavElements, model, hinterViewOff, mainItems);
        var jointProduct = A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, model.W1);
        var canExpandNav = A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, model.W1);
        var isExpanded = sidenavExpanded && canExpandNav;
        var navElementsDesktop = A4($author$project$Navbars$Practice$viewDesktopNavElements, model, hinterViewOff, isExpanded, mainItems);
        var profileMenuView = A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('sidenav__item sidenav__item--profile sidenav__item--profile-desktop'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('sidenav__active', _Utils_eq(model.eI, $author$project$Navbars$Practice$Navigation$Account))
            ]))
        ]), $elm$core$List$singleton(A4($author$project$Ui$FlyoutMenu$view, _List_fromArray([
            $author$project$Ui$FlyoutMenu$position(1)
        ]), _List_fromArray([
            $author$project$Ui$FlyoutMenu$body(_List_fromArray([
                $author$project$Navbars$Practice$viewProfileSubNav(model.eI)
            ]))
        ]), isExpanded ? profileButton : A3($author$project$Ui$Tooltip$view, _List_fromArray([
            $author$project$Ui$Tooltip$placement(3),
            $author$project$Ui$Tooltip$stackingOrder1030
        ]), 'Profile', _List_fromArray([
            profileButton
        ])), model.et)));
        return _List_fromArray([
            A4($author$project$Navbars$Practice$viewTopNavbar, hinterViewOff, model, jointProduct, orgSwitcherHtml),
            $author$project$Navbars$Utils$viewTopNavEnd,
            A2($elm$html$Html$map, $author$project$Navbars$Practice$HinterPracticeSettingsModalMsg, $author$project$Components$HinterPracticeSettingsModal$view(model.iQ)),
            A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.Cu._k(hinterViewOff), A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$id('sidenav'),
                $elm$html$Html$Attributes$class('sidenav'),
                $elm$html$Html$Attributes$classList(_List_fromArray([
                    _Utils_Tuple2('sidenav--slide-in', slideIn),
                    _Utils_Tuple2('sidenav--expanded', isExpanded)
                ]))
            ]), _List_fromArray([
                canExpandNav ? A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__expand-toggle')
                ]), _List_fromArray([
                    A3($author$project$Ui$Button$view, {
                        abP: isExpanded ? 'Collapse navigation' : 'Expand navigation'
                    }, _List_fromArray([
                        $author$project$Ui$Button$link,
                        $author$project$Ui$Button$onClick($author$project$Navbars$Practice$SidenavExpandToggled),
                        $author$project$Ui$Button$test('sidenav-expand-toggle')
                    ]), _List_fromArray([
                        A2($author$project$Ui$Icon$view, _List_fromArray([
                            $author$project$Ui$Icon$class(isExpanded ? 'sidenav__toggle-icon sidenav__toggle-icon--expanded' : 'sidenav__toggle-icon')
                        ]), 12)
                    ]))
                ])) : $elm$html$Html$text(''),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__header sidenav__header--practice')
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('sidenav__header--left')
                    ]), _List_fromArray([
                        $author$project$Ui$Icon$location(_List_Nil),
                        $elm$html$Html$text($author$project$Api$Provider$Practice$One$name(model.W1)),
                        A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.Cu.KV, A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$User__Organizations__Top, _List_fromArray([
                            $author$project$Ui$Link$ariaLabel('Switch organization'),
                            $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked)
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$kebabMenu(_List_Nil)
                        ])))
                    ])),
                    slideIn ? A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('sidenav-close')
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'Close side navigation menu'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Navbars$Practice$SidenavToggled(false))
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_Nil, 30)
                        ]))
                    ])) : $author$project$Utils$Html$empty
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__search')
                ]), _List_fromArray([
                    A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.v_(hinterViewOff), A3($author$project$Ui$Button$view, {
                        abP: 'Search'
                    }, _List_fromArray([
                        $author$project$Ui$Button$onClick($author$project$Navbars$Practice$SearchClicked)
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('sidenav__search-content')
                        ]), _List_fromArray([
                            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                $author$project$Ui$Icon$search(_List_Nil),
                                $author$project$Utils$Html$noBreakSpace,
                                $elm$html$Html$text('Search')
                            ])),
                            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                                $elm$html$Html$text($author$project$Navbars$Practice$viewSearchKeyboardShortcut(sessionConfiguration.Cu.VG))
                            ]))
                        ]))
                    ])))
                ])),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__main sidenav__main--mobile')
                ]), navElementsMobile),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__main sidenav__main--desktop')
                ]), navElementsDesktop),
                A2($author$project$Navbars$Practice$viewHinterIdButtons, model, hinterViewOff),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('sidenav__bottom')
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('sidenav__bottom-separator')
                    ]), _List_Nil),
                    A2($author$project$Navbars$Utils$ifConfiguration, sessionConfiguration.Cu.yu(hinterViewOff) || A2($author$project$Api$Provider$Practice$One$featureEnabled, 25, model.W1), A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$selectedNavClass, $author$project$Navbars$Practice$Navigation$Marketplace, model.eI)),
                        $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('bg-primary-100', _Utils_eq(model.eI, $author$project$Navbars$Practice$Navigation$Marketplace))
                        ]))
                    ]), _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Marketplace__Top, _List_fromArray([
                            $author$project$Ui$Link$onClick($author$project$Navbars$Practice$LinkClicked),
                            $author$project$Ui$Link$test('marketplace')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon')
                            ]), 96),
                            $elm$html$Html$text('Marketplace')
                        ]))
                    ]))),
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class(A2($author$project$Navbars$Practice$subNavClasses, 2, model.c5))
                    ]), _List_fromArray([
                        A3($author$project$Ui$Button$view, {
                            abP: 'View help resources'
                        }, _List_fromArray([
                            $author$project$Ui$Button$link,
                            $author$project$Ui$Button$onClick($author$project$Navbars$Practice$NavClicked(2)),
                            $author$project$Ui$Button$test('help')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon sidenav__icon--sm')
                            ]), 97),
                            $elm$html$Html$text('Resources'),
                            A2($author$project$Ui$Icon$view, _List_fromArray([
                                $author$project$Ui$Icon$class('sidenav__icon--show-more ml-2')
                            ]), 12)
                        ])),
                        $author$project$Navbars$Practice$viewResourcesSubNav(model.qW)
                    ])),
                    profileMobileView,
                    profileMenuView
                ]))
            ])))
        ]);
    });
    var $author$project$Navbar$viewNavbar = F2(function(orgSwitcherConfig, _v0) {
        var model = _v0;
        var _v1 = model.ad;
        switch(_v1.$){
            case 0:
                return _List_Nil;
            case 1:
                var practiceNavModel = _v1.a;
                return A2($elm$core$List$map, $elm$html$Html$map($author$project$Navbar$PracticeNavbarMsg), A3($author$project$Navbars$Practice$view, model.aeb, orgSwitcherConfig, practiceNavModel));
            case 2:
                var companyNavModel = _v1.a;
                return A2($elm$core$List$map, $elm$html$Html$map($author$project$Navbar$CompanyNavbarMsg), A3($author$project$Navbars$Company$view, model.aeb, orgSwitcherConfig, companyNavModel));
            default:
                var partnerNavModel = _v1.a;
                return A2($elm$core$List$map, $elm$html$Html$map($author$project$Navbar$PartnerNavbarMsg), A3($author$project$Navbars$Partner$view, model.aeb, orgSwitcherConfig, partnerNavModel));
        }
    });
    var $author$project$Navbar$view = F2(function(shared, _v0) {
        var model = _v0;
        var practice = model.W1;
        var session = model.Z$;
        if (shared.adj) return $elm$html$Html$text('');
        else {
            var orgSwitcherConfig = A3($elm$core$Maybe$map2, F2(function(switcher, org) {
                return {
                    zi: switcher,
                    VA: org
                };
            }), shared.afU, shared.VA);
            return A2($elm$html$Html$nav, _List_fromArray([
                $elm$html$Html$Attributes$id('navbar-wrapper'),
                $elm$html$Html$Attributes$class('navbar-wrapper')
            ]), $elm$core$List$concat(_List_fromArray([
                _List_fromArray([
                    $author$project$Components$DebugInfo$view({
                        abM: shared.abM,
                        acU: shared.acU,
                        adj: shared.adj,
                        aea: shared.aea,
                        aff: shared.aff,
                        Z$: session
                    }),
                    A2($elm$html$Html$map, $author$project$Navbar$SandboxAlertMsg, $author$project$Components$SandboxAlert$view(session))
                ]),
                A4($author$project$Navbar$viewAlerts, session, model.aeb, practice, shared.abT),
                A2($author$project$Navbar$viewNavbar, orgSwitcherConfig, model)
            ])));
        }
    });
    var $author$project$Ui$Toast$ToastBlurred = function(a) {
        return {
            $: 3,
            a: a
        };
    };
    var $author$project$Ui$Toast$ToastClicked = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Ui$Toast$ToastHovered = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Toast$levelClass = function(level) {
        switch(level){
            case 0:
                return $elm$html$Html$Attributes$class('toast--info');
            case 1:
                return $elm$html$Html$Attributes$class('toast--danger');
            case 2:
                return $elm$html$Html$Attributes$class('toast--warning');
            default:
                return $elm$html$Html$Attributes$class('toast--success');
        }
    };
    var $elm$html$Html$Events$onMouseOut = function(msg) {
        return A2($elm$html$Html$Events$on, 'mouseout', $elm$json$Json$Decode$succeed(msg));
    };
    var $author$project$Ui$Toast$viewToast = function(_v0) {
        var id = _v0.aef;
        var level = _v0.S5;
        var message = _v0.ae1;
        return _Utils_Tuple2($elm$core$String$fromInt(id), A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Events$onClick($author$project$Ui$Toast$ToastClicked(id)),
            $elm$html$Html$Events$onMouseEnter($author$project$Ui$Toast$ToastHovered(id)),
            $elm$html$Html$Events$onMouseOut($author$project$Ui$Toast$ToastBlurred(id)),
            $elm$html$Html$Attributes$class('toast'),
            $author$project$Ui$Toast$levelClass(level)
        ]), _List_fromArray([
            A2($author$project$Ui$Typography$span, _List_fromArray([
                $author$project$Ui$Typography$phi(true)
            ]), _List_fromArray([
                $elm$html$Html$text(message)
            ]))
        ])));
    };
    var $author$project$Ui$Toast$view = function(_v0) {
        var toasts = _v0.b;
        return $elm$core$List$isEmpty(toasts) ? $elm$html$Html$text('') : A3($elm$html$Html$Keyed$node, 'div', _List_fromArray([
            $elm$html$Html$Attributes$class('toast-container')
        ]), A2($elm$core$List$map, $author$project$Ui$Toast$viewToast, toasts));
    };
    var $author$project$Shared$view = F2(function(_v0, model) {
        var layout = _v0.ba;
        var page = _v0.GM;
        var toMsg = _v0.ahX;
        var isClinicalPage = _v0.aeB;
        var user = $author$project$Api$Data$toMaybe(model.aaX);
        var showSideNav = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Navbar$showSideNav(model.aeb), model.ae));
        return {
            fb: _List_fromArray([
                A2($elm$html$Html$map, toMsg, A2($elm$html$Html$map, $author$project$Shared$ToastMsg, $author$project$Ui$Toast$view(model.ky))),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$id('ng-app'),
                    $elm$html$Html$Attributes$classList(_List_fromArray([
                        _Utils_Tuple2('embedded', model.adU.adj)
                    ]))
                ]), _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('horizontal-wrapper'),
                        $elm$html$Html$Attributes$classList(_List_fromArray([
                            _Utils_Tuple2('login', _Utils_eq(user, $elm$core$Maybe$Nothing))
                        ]))
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('vertical-wrapper'),
                            $elm$html$Html$Attributes$classList(_List_fromArray([
                                _Utils_Tuple2('with-full-navigation', showSideNav)
                            ]))
                        ]), _List_fromArray([
                            A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$id('spa-document'),
                                $elm$html$Html$Attributes$class('flex'),
                                $elm$html$Html$Attributes$class('flex-col'),
                                $elm$html$Html$Attributes$class('h-full')
                            ]), _List_fromArray([
                                A2($elm$html$Html$div, _List_fromArray([
                                    $elm$html$Html$Attributes$class('container content'),
                                    $elm$html$Html$Attributes$classList(_List_fromArray([
                                        _Utils_Tuple2('clinical-page', isClinicalPage)
                                    ]))
                                ]), _List_fromArray([
                                    A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, A2($elm$core$Basics$composeR, $author$project$Navbar$view({
                                        abM: model.adU.abM,
                                        abT: model.adU.abT,
                                        acU: model.adU.acU,
                                        adj: model.adU.adj,
                                        aea: $author$project$Utils$Environment$toString(model.aea),
                                        aff: $author$project$Utils$Environment$toString(model.aff),
                                        afU: model.gg,
                                        VA: $author$project$Shared$organizationFromSession(model)
                                    }), $elm$html$Html$map(A2($elm$core$Basics$composeR, $author$project$Shared$NavbarMsg, toMsg))), model.ae)),
                                    A2($elm$html$Html$div, _List_fromArray([
                                        $elm$html$Html$Attributes$id('elm-app'),
                                        $elm$html$Html$Attributes$classList(_List_fromArray([
                                            _Utils_Tuple2('highlight-phi', model.mu)
                                        ]))
                                    ]), A2(layout, A2($elm$core$Basics$composeR, $author$project$Shared$PatientsListMsg, toMsg), page.fb)),
                                    A2($elm$html$Html$div, _List_fromArray([
                                        $elm$html$Html$Attributes$id('hint-clinical-root'),
                                        $elm$html$Html$Attributes$class('clinical')
                                    ]), _List_Nil)
                                ]))
                            ]))
                        ]))
                    ])),
                    function() {
                        var _v1 = _Utils_Tuple2(model.Z$, model.W1);
                        if (_v1.a.$ === 3 && _v1.b.$ === 3) {
                            var _v2 = _v1.a;
                            var session = _v2.a;
                            var _v3 = _v1.b;
                            var practice = _v3.a;
                            var route = $author$project$Utils$Route$fromUrl(model.aaT);
                            return A2($elm$html$Html$map, toMsg, A2($elm$html$Html$map, $author$project$Shared$AccountLockedModalMsg, A3($author$project$Components$AccountLockedModal$view, session, practice, route)));
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    A2($elm$html$Html$map, toMsg, function() {
                        if (model.sV) {
                            var customOptions = _List_fromArray([
                                $author$project$Components$HiConfirm$verb('resume'),
                                $author$project$Components$HiConfirm$noun('session'),
                                $author$project$Components$HiConfirm$customMessage(_List_fromArray([
                                    $elm$html$Html$text('Simply click anywhere on the screen to continue.')
                                ])),
                                $author$project$Components$HiConfirm$customTitle('Your Session Is About to Expire'),
                                $author$project$Components$HiConfirm$showCancel(false)
                            ]);
                            return A2($author$project$Components$HiConfirm$modal, $elm$core$Basics$always($author$project$Shared$HideLogoutWarning), customOptions);
                        } else return $author$project$Utils$Html$empty;
                    }()),
                    A2($elm$html$Html$map, toMsg, model.sQ ? $author$project$Components$Auth$SystemRecoveryModal$view($author$project$Shared$HideAuthRecoveryModal) : $author$project$Utils$Html$empty),
                    A2($elm$html$Html$map, toMsg, A2($elm$html$Html$map, $author$project$Shared$GlobalSearchMsg, $author$project$Components$GlobalSearch$view(model.fP))),
                    function() {
                        var _v4 = _Utils_Tuple2(model.af8, !_Utils_eq(model.Wx, $elm$core$Maybe$Nothing));
                        if (!_v4.a.$ && _v4.b) {
                            var pendingChangesDetail = _v4.a.a;
                            return A2($elm$html$Html$map, toMsg, A3($author$project$Components$PendingChangesModal$view, pendingChangesDetail, $author$project$Shared$PendingChangesDiscard, $author$project$Shared$PendingChangesKeep));
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]))
            ]),
            $2: page.$2
        };
    });
    var $author$project$Layouts$Admin$StructureNode = $elm$core$Basics$identity;
    var $author$project$Layouts$Admin$Node = $elm$core$Basics$identity;
    var $author$project$Layouts$Admin$structureOrNodeVisible = F2(function(practice, featureGated) {
        return A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, function(featureGated_) {
            return A2($author$project$Utils$FeatureGate$gateAvailable, featureGated_, $author$project$Api$Practice$Provider(practice));
        }, featureGated));
    });
    var $author$project$Layouts$Admin$nodeVisible = F2(function(practice, _v0) {
        var node = _v0;
        return A2($author$project$Layouts$Admin$structureOrNodeVisible, practice, node.b);
    });
    var $author$project$Layouts$Admin$routeActive = F2(function(currentRoute, route) {
        return _Utils_eq(route, currentRoute) || A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(route) + '/', $author$project$Spa$Generated$Route$toString(currentRoute));
    });
    var $author$project$Layouts$Admin$nodeActive = F3(function(currentRoute, practice, _v0) {
        var node = _v0;
        return A2($author$project$Layouts$Admin$nodeVisible, practice, node) && A2($author$project$Layouts$Admin$routeActive, currentRoute, node.d);
    });
    var $author$project$Layouts$Admin$structureVisible = F2(function(practice, _v0) {
        var node = _v0;
        return A2($author$project$Layouts$Admin$structureOrNodeVisible, practice, node.b);
    });
    var $author$project$Layouts$Admin$getActiveStructure = F3(function(currentRoute, practice, nodes) {
        return A2($elm_community$list_extra$List$Extra$find, function(_v0) {
            var node = _v0;
            var visible = A2($author$project$Layouts$Admin$structureVisible, practice, node);
            return visible && A2($elm$core$List$any, A2($author$project$Layouts$Admin$nodeActive, currentRoute, practice), node.v);
        }, nodes);
    });
    var $author$project$Layouts$Admin$getAccountLayout = F2(function(practice, isHintAdmin) {
        return $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-general',
                    zr: 'General',
                    d: $author$project$Spa$Generated$Route$Admin__Practice
                }
            ]),
            A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) ? _List_Nil : !$author$project$Api$Provider$Practice$One$hasClinicalAccount(practice) || isHintAdmin ? _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-users',
                    zr: 'Users',
                    d: $author$project$Spa$Generated$Route$Admin__Team
                }
            ]) : _List_Nil,
            _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-billing',
                    zr: 'Billing',
                    d: $author$project$Spa$Generated$Route$Admin__Billing
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-sources',
                    zr: 'Payment Sources',
                    d: $author$project$Spa$Generated$Route$Admin__PaymentSources
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-payment-processing',
                    zr: 'Payment Processing',
                    d: $author$project$Spa$Generated$Route$Admin__PaymentProcessing
                }
            ]),
            isHintAdmin ? _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Just($author$project$Ui$Icon$hintHeart(_List_fromArray([
                        $author$project$Ui$Icon$spacedRight
                    ]))),
                    aef: 'nav-item-notes',
                    zr: 'Notes',
                    d: $author$project$Spa$Generated$Route$Admin__Notes
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Just($author$project$Ui$Icon$hintHeart(_List_fromArray([
                        $author$project$Ui$Icon$spacedRight
                    ]))),
                    aef: 'nav-item-features',
                    zr: 'Beta Features',
                    d: $author$project$Spa$Generated$Route$Admin__Features
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Just($author$project$Ui$Icon$hintHeart(_List_fromArray([
                        $author$project$Ui$Icon$spacedRight
                    ]))),
                    aef: 'nav-item-internal-settings',
                    zr: 'Internal Settings',
                    d: $author$project$Spa$Generated$Route$Admin__InternalSettings
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Just($author$project$Ui$Icon$hintHeart(_List_fromArray([
                        $author$project$Ui$Icon$spacedRight
                    ]))),
                    aef: 'nav-item-scheduled-jobs',
                    zr: 'Scheduled Jobs',
                    d: $author$project$Spa$Generated$Route$Admin__ScheduledJobs
                }
            ]) : _List_Nil
        ]));
    });
    var $author$project$Api$Provider$Practice$One$mailgunStatus = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Practice$One$one, function($) {
        return $.Ty;
    });
    var $author$project$Layouts$Admin$getIntegrationsLayout = function(practice) {
        return $elm$core$List$concat(_List_fromArray([
            $author$project$Api$Provider$Practice$One$elationEnabled(practice) ? _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-elation-legacy',
                    zr: 'ElationEMR (Legacy)',
                    d: $author$project$Spa$Generated$Route$Admin__ElationLegacy
                }
            ]) : _List_Nil,
            ($author$project$Api$Provider$Practice$One$paymentProcessor(practice) === 'stripe' || $author$project$Api$Provider$Practice$One$hasStripeAccount(practice)) && !A2($author$project$Api$Provider$Practice$One$featureEnabled, 28, practice) ? _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-stripe',
                    zr: 'Stripe',
                    d: $author$project$Spa$Generated$Route$Admin__Stripe
                }
            ]) : _List_Nil,
            _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-card-readers',
                    zr: 'Card Readers',
                    d: $author$project$Spa$Generated$Route$Admin__CardReaders
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-qbo',
                    zr: 'QuickBooks Online',
                    d: $author$project$Spa$Generated$Route$Admin__Quickbooks__Top
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-elation',
                    zr: 'Elation Health',
                    d: $author$project$Spa$Generated$Route$Admin__Elation__Top
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-athena',
                    zr: 'athenahealth',
                    d: $author$project$Spa$Generated$Route$Admin__Athenahealth__Top
                }
            ]),
            _Utils_eq($author$project$Api$Provider$Practice$One$mailgunStatus(practice), $elm$core$Maybe$Just('active')) ? _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-mailgun',
                    zr: 'Mailgun',
                    d: $author$project$Spa$Generated$Route$Admin__Mailgun
                }
            ]) : _List_Nil,
            _List_fromArray([
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-spruce-health',
                    zr: 'Spruce',
                    d: $author$project$Spa$Generated$Route$Marketplace__Slug_String({
                        _A: 'spruce-health'
                    })
                },
                {
                    b: $elm$core$Maybe$Nothing,
                    QZ: $elm$core$Maybe$Nothing,
                    aef: 'nav-item-other-integrations',
                    zr: 'Other Integrations',
                    d: $author$project$Spa$Generated$Route$Marketplace__Manage
                }
            ])
        ]));
    };
    var $author$project$Layouts$Admin$structure = F4(function(session, practice, hinterViewOff, isHintAdmin) {
        return A3($author$project$Permission$canGoTo, session, hinterViewOff, 0) ? $elm$core$List$concat(_List_fromArray([
            _List_fromArray([
                {
                    v: A2($author$project$Layouts$Admin$getAccountLayout, practice, isHintAdmin),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Account'
                }
            ]),
            A2($author$project$Api$Provider$Practice$One$featureEnabled, 19, practice) && A2($author$project$Api$Provider$Practice$One$featureEnabled, 6, practice) ? _List_fromArray([
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-phones',
                            zr: 'Phones',
                            d: $author$project$Spa$Generated$Route$NewSettings__PracticeInfo
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Phones'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-team',
                            zr: 'Team',
                            d: $author$project$Spa$Generated$Route$NewSettings__Team
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Team'
                }
            ]) : _List_Nil,
            _List_fromArray([
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-providers',
                            zr: 'Providers',
                            d: $author$project$Spa$Generated$Route$Admin__Providers__Top
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-patients',
                            zr: 'Patients',
                            d: $author$project$Spa$Generated$Route$Admin__Patients
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-locations',
                            zr: 'Locations',
                            d: $author$project$Spa$Generated$Route$Admin__Locations
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-location-groups',
                            zr: 'Location Groups',
                            d: $author$project$Spa$Generated$Route$Admin__ProviderGroups
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Providers & Patients'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-plans',
                            zr: 'Plans',
                            d: $author$project$Spa$Generated$Route$Admin__Plans__Top
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-coverage-plans',
                            zr: 'Coverage Plans',
                            d: $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-coupons',
                            zr: 'Coupons',
                            d: $author$project$Spa$Generated$Route$Admin__Coupons
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-cancellation-reasons',
                            zr: 'Cancellation Reasons',
                            d: $author$project$Spa$Generated$Route$Admin__CancellationReasons
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-invoicing',
                            zr: 'Invoicing Ahead of Time',
                            d: $author$project$Spa$Generated$Route$Admin__AdvanceBilling
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Membership Options'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-global',
                            zr: 'Global Settings',
                            d: $author$project$Spa$Generated$Route$Admin__Signup
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-signup',
                            zr: 'Signup Pages',
                            d: $author$project$Spa$Generated$Route$Admin__SignupPages__Top
                        },
                        {
                            b: $elm$core$Maybe$Just(5),
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-patient-portal',
                            zr: 'Patient Portal',
                            d: $author$project$Spa$Generated$Route$Admin__SelfService
                        },
                        {
                            b: $elm$core$Maybe$Just(5),
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-lead-sources',
                            zr: 'Lead Sources',
                            d: $author$project$Spa$Generated$Route$Admin__LeadSources
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Online Signup'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-categories',
                            zr: 'Categories',
                            d: $author$project$Spa$Generated$Route$Admin__CreditCategories
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-upload',
                            zr: 'Upload',
                            d: $author$project$Spa$Generated$Route$Admin__Credits__Upload
                        }
                    ]),
                    b: $elm$core$Maybe$Just(4),
                    $2: 'Credits'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-charge-items',
                            zr: A2($author$project$Api$Provider$Practice$One$featureEnabled, 22, practice) ? 'Charge Items & Packages' : 'Charge Items',
                            d: $author$project$Spa$Generated$Route$Admin__ChargeItems__Top
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-charge-categories',
                            zr: 'Charge Categories',
                            d: $author$project$Spa$Generated$Route$Admin__Categories
                        },
                        {
                            b: $elm$core$Maybe$Just(2),
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-tax',
                            zr: 'Sales Tax',
                            d: $author$project$Spa$Generated$Route$Admin__Taxes
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Charges'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-setup',
                            zr: 'Set-Up',
                            d: $author$project$Spa$Generated$Route$Admin__Commissions
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Commissions'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-patient',
                            zr: 'Patient',
                            d: $author$project$Spa$Generated$Route$Admin__Notifications__Patient
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-membership',
                            zr: 'Membership',
                            d: $author$project$Spa$Generated$Route$Admin__Notifications__Membership
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-practice',
                            zr: 'Practice',
                            d: $author$project$Spa$Generated$Route$Admin__Notifications__Practice
                        },
                        {
                            b: $elm$core$Maybe$Just(9),
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-employer',
                            zr: 'Employer',
                            d: $author$project$Spa$Generated$Route$Admin__Notifications__Company
                        },
                        {
                            b: $elm$core$Maybe$Just(9),
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-employee',
                            zr: 'Employee',
                            d: $author$project$Spa$Generated$Route$Admin__Notifications__Employee
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-setting',
                            zr: 'Settings',
                            d: $author$project$Spa$Generated$Route$Admin__Notifications__Settings
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Notifications'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-ephi',
                            zr: 'ePHI Communication Waivers',
                            d: $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'ePHI Communication Waivers'
                },
                {
                    v: $author$project$Layouts$Admin$getIntegrationsLayout(practice),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Integrations'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-employers-invoice-settings',
                            zr: A2($author$project$Formatters$String$sponsorize, practice, 'Employers') + ' Invoice Settings',
                            d: $author$project$Spa$Generated$Route$Admin__InvoiceSettings
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-empoyers-plans',
                            zr: A2($author$project$Formatters$String$sponsorize, practice, 'Employers') + ' Plans',
                            d: $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: A2($author$project$Formatters$String$sponsorize, practice, 'Employers')
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-documents',
                            zr: 'Documents',
                            d: $author$project$Spa$Generated$Route$Admin__Documents__Top
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Documents'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-developers-api-keys',
                            zr: 'API Keys',
                            d: $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-developers-webhook-endpoints',
                            zr: 'Webhook Endpoints',
                            d: $author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-developers-sandboxes',
                            zr: 'Sandboxes',
                            d: $author$project$Spa$Generated$Route$Admin__Developers__Sandboxes
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Developers'
                },
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-data-export',
                            zr: 'Exports',
                            d: $author$project$Spa$Generated$Route$Admin__DataExport__Top
                        },
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Nothing,
                            aef: 'nav-item-data-export-settings',
                            zr: 'Settings',
                            d: $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: 'Data Exporter'
                }
            ]),
            isHintAdmin && $author$project$Api$Provider$Practice$One$accountType(practice) === 1 ? _List_fromArray([
                {
                    v: _List_fromArray([
                        {
                            b: $elm$core$Maybe$Nothing,
                            QZ: $elm$core$Maybe$Just($author$project$Ui$Icon$hintHeart(_List_fromArray([
                                $author$project$Ui$Icon$spacedRight
                            ]))),
                            aef: 'nav-item-affiliate-plans',
                            zr: 'Plans',
                            d: $author$project$Spa$Generated$Route$Admin__Plans__Top
                        }
                    ]),
                    b: $elm$core$Maybe$Nothing,
                    $2: ''
                }
            ]) : _List_Nil
        ])) : _List_Nil;
    });
    var $author$project$Ui$Nav$Empty = {
        $: 2
    };
    var $author$project$Ui$Nav$emptyItem = $author$project$Ui$Nav$Empty;
    var $author$project$Ui$Nav$Route = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Ui$Nav$route = $author$project$Ui$Nav$Route;
    var $author$project$Layouts$Admin$viewActiveChildren = F3(function(currentRoute, practice, _v0) {
        var node = _v0;
        return A2($author$project$Layouts$Admin$nodeVisible, practice, node) ? A2($author$project$Ui$Nav$item, _List_fromArray([
            $author$project$Ui$Nav$route(node.d),
            $author$project$Ui$Nav$activeItem(A3($author$project$Layouts$Admin$nodeActive, currentRoute, practice, node))
        ]), _List_fromArray([
            A2($elm$core$Maybe$withDefault, $elm$html$Html$text(''), node.QZ),
            $elm$html$Html$text(node.zr)
        ])) : $author$project$Ui$Nav$emptyItem;
    });
    var $author$project$Layouts$Admin$viewNav = F6(function(currentRoute, session, practice, hinterViewOff, isHintAdmin, model) {
        var _v0 = A3($author$project$Layouts$Admin$getActiveStructure, currentRoute, practice, A4($author$project$Layouts$Admin$structure, session, practice, hinterViewOff, isHintAdmin));
        if (!_v0.$) {
            var active = _v0.a;
            return A3($author$project$Ui$Nav$view, _List_Nil, A2($elm$core$List$map, A2($author$project$Layouts$Admin$viewActiveChildren, currentRoute, practice), active.v), model.nb);
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Layouts$Admin$view = F4(function(toMsg, shared, model, body) {
        var session = shared.Z$;
        var practice = shared.W1;
        var hinterViewOff = shared.aeb;
        var url = shared.aaT;
        var _v0 = _Utils_Tuple2(session, practice);
        if (_v0.a.$ === 3 && _v0.b.$ === 3 && !_v0.b.a.$) {
            var _v1 = _v0.a;
            var session_ = _v1.a;
            var _v2 = _v0.b;
            var practice_ = _v2.a.a;
            var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
            var currentRoute = $author$project$Utils$Route$fromUrl(url);
            var activeStructure = A3($author$project$Layouts$Admin$getActiveStructure, currentRoute, practice_, A4($author$project$Layouts$Admin$structure, session_, practice_, hinterViewOff, isHintAdmin));
            return _Utils_ap(function() {
                if (!activeStructure.$) {
                    var node = activeStructure.a;
                    return _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('layout-header')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$itemsCenter,
                                $author$project$Ui$Element$mb2
                            ]), _List_fromArray([
                                $author$project$Ui$Typography$heading(_List_fromArray([
                                    $elm$html$Html$text(node.$2)
                                ]))
                            ])),
                            A2($elm$html$Html$map, toMsg, A6($author$project$Layouts$Admin$viewNav, currentRoute, session_, practice_, hinterViewOff, isHintAdmin, model))
                        ]))
                    ]);
                } else return _List_Nil;
            }(), body);
        } else return _List_Nil;
    });
    var $author$project$Ui$Nav$LinkOptions = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Ui$Nav$linkOptions = $author$project$Ui$Nav$LinkOptions;
    var $author$project$Layouts$Affiliates$viewNav = F2(function(currentRoute, nav) {
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$AffiliateBills__Top),
                $author$project$Ui$Nav$linkOptions(_List_fromArray([
                    $author$project$Ui$Link$routeParams(_List_fromArray([
                        A2($elm$url$Url$Builder$string, 'start', 'default'),
                        A2($elm$url$Url$Builder$string, 'end', 'default')
                    ]))
                ])),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$AffiliateBills__Top))
            ]), _List_fromArray([
                $elm$html$Html$text('Affiliate Bills')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Affiliates__Top),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Affiliates__Top))
            ]), _List_fromArray([
                $elm$html$Html$text('Manage Affiliates')
            ]))
        ]), nav);
    });
    var $author$project$Layouts$Affiliates$view = F4(function(toMsg, _v0, _v1, body) {
        var url = _v0.aaT;
        var nav = _v1.nb;
        var currentRoute = $author$project$Utils$Route$fromUrl(url);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Networks')
                    ]))
                ])),
                A2($elm$html$Html$map, toMsg, A2($author$project$Layouts$Affiliates$viewNav, currentRoute, nav))
            ])),
            A2($elm$html$Html$div, _List_Nil, body)
        ]);
    });
    var $author$project$Api$Provider$Affiliate$One$name = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Provider$Affiliate$Shared$name(shared);
    };
    var $author$project$Layouts$Affiliates$Affiliate$affiliateName = function(affiliate) {
        if (affiliate.$ === 3) {
            var affiliate_ = affiliate.a;
            return $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Affiliate$One$name(affiliate_)));
        } else return $author$project$Ui$Spinner$view(_List_fromArray([
            $author$project$Ui$Spinner$extraSmall
        ]));
    };
    var $author$project$Layouts$Affiliates$Affiliate$viewBreadcrumbs = function(affiliate) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Affiliates__Top, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Affiliates')
                ]))
            ])),
            A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                $author$project$Ui$Breadcrumb$active(true)
            ]), _List_fromArray([
                $author$project$Layouts$Affiliates$Affiliate$affiliateName(affiliate)
            ]))
        ])));
    };
    var $author$project$Layouts$Affiliates$Affiliate$viewHeader = function(affiliate) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$itemsCenter,
            $author$project$Ui$Element$gap2
        ]), _List_fromArray([
            $author$project$Ui$Typography$heading(_List_fromArray([
                $author$project$Layouts$Affiliates$Affiliate$affiliateName(affiliate)
            ])),
            A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(status) {
                return A2($author$project$Ui$Badge$fromString, _List_fromArray([
                    $author$project$Ui$Badge$inline
                ]), status);
            }, A2($elm$core$Maybe$map, $author$project$Api$Provider$Affiliate$One$status, $author$project$Api$Data$toMaybe(affiliate))))
        ]));
    };
    var $author$project$Ui$HinterOnly$navItem = F2(function(options, content) {
        return A2($author$project$Ui$Nav$item, options, A2($elm$core$List$cons, $author$project$Ui$HinterOnly$icon(_List_fromArray([
            $author$project$Ui$Icon$spacedRight
        ])), content));
    });
    var $author$project$Layouts$Affiliates$Affiliate$viewNav = F3(function(currentRoute, _v0, shared) {
        var affiliateId = _v0.pr;
        var nav = _v0.nb;
        var usersRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users({
            pr: affiliateId
        });
        var syncByAffiliation = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Network$Shared$syncByAffiliation, A2($elm$core$Maybe$andThen, $author$project$Api$Practice$network, $author$project$Api$Data$toMaybe(shared.W1))));
        var settingsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings({
            pr: affiliateId
        });
        var patientsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients({
            pr: affiliateId
        });
        var linkedProvidersRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders({
            pr: affiliateId
        });
        var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
        var billsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
            pr: affiliateId
        });
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(billsRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(billsRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text('Bills')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(patientsRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(patientsRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text('Patients')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(linkedProvidersRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(linkedProvidersRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text(syncByAffiliation ? 'Linked Providers & Locations' : 'Linked Providers')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(settingsRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(settingsRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text('Terms & Conditions')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(usersRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(usersRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text('Users')
            ])),
            function() {
                if (isHintAdmin) {
                    var affiliateActionsRoute = $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions({
                        pr: affiliateId
                    });
                    return A2($author$project$Ui$HinterOnly$navItem, _List_fromArray([
                        $author$project$Ui$Nav$route(affiliateActionsRoute),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, affiliateActionsRoute))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Affiliate Actions')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }()
        ]), nav);
    });
    var $author$project$Layouts$Affiliates$Affiliate$view = F4(function(toMsg, shared, model, body) {
        var currentRoute = $author$project$Utils$Route$fromUrl(shared.aaT);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($elm$html$Html$map, toMsg, $author$project$Layouts$Affiliates$Affiliate$viewBreadcrumbs(model.Eb)),
                $author$project$Layouts$Affiliates$Affiliate$viewHeader(model.Eb),
                A2($elm$html$Html$map, toMsg, A3($author$project$Layouts$Affiliates$Affiliate$viewNav, currentRoute, model, shared))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
            ]), body)
        ]);
    });
    var $author$project$Layouts$Application$view = function(body) {
        return body;
    };
    var $author$project$Layouts$Blank$view = function(body) {
        return body;
    };
    var $author$project$Layouts$Commissions$viewNav = F2(function(currentRoute, nav) {
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top) || _Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New))
            ]), _List_fromArray([
                $elm$html$Html$text('Broker Accounts')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__Statements),
                $author$project$Ui$Nav$linkOptions(_List_fromArray([
                    $author$project$Ui$Link$routeParams(_List_fromArray([
                        A2($elm$url$Url$Builder$string, 'start', 'default'),
                        A2($elm$url$Url$Builder$string, 'end', 'default')
                    ]))
                ])),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__Statements))
            ]), _List_fromArray([
                $elm$html$Html$text('Statements')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Commissions__StatementLines__Top),
                $author$project$Ui$Nav$linkOptions(_List_fromArray([
                    $author$project$Ui$Link$routeParams(_List_fromArray([
                        A2($elm$url$Url$Builder$string, 'start', 'default'),
                        A2($elm$url$Url$Builder$string, 'end', 'default')
                    ]))
                ])),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__StatementLines__Top) || _Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Commissions__StatementLines__Summary))
            ]), _List_fromArray([
                $elm$html$Html$text('Statement Lines')
            ]))
        ]), nav);
    });
    var $author$project$Layouts$Commissions$view = F4(function(toMsg, _v0, _v1, body) {
        var url = _v0.aaT;
        var nav = _v1.nb;
        var currentRoute = $author$project$Utils$Route$fromUrl(url);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$mb2
                ]), _List_fromArray([
                    $author$project$Ui$Typography$heading(_List_fromArray([
                        $elm$html$Html$text('Commissions')
                    ]))
                ])),
                A2($elm$html$Html$map, toMsg, A2($author$project$Layouts$Commissions$viewNav, currentRoute, nav))
            ])),
            A2($elm$html$Html$div, _List_Nil, body)
        ]);
    });
    var $author$project$Layouts$Commissions$BrokerAccount$brokerAccountName = function(brokerAccount) {
        if (brokerAccount.$ === 3) {
            var brokerAccount_ = brokerAccount.a;
            return $elm$html$Html$text($author$project$Api$Provider$BrokerAccount$One$name(brokerAccount_));
        } else return $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$spanFromText('Some Broker')
        ]));
    };
    var $author$project$Layouts$Commissions$BrokerAccount$viewBreadcrumbs = function(brokerAccount) {
        return A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('All Broker Accounts')
                ]))
            ])),
            A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                $author$project$Ui$Breadcrumb$active(true)
            ]), _List_fromArray([
                $author$project$Layouts$Commissions$BrokerAccount$brokerAccountName(brokerAccount)
            ]))
        ])));
    };
    var $author$project$Layouts$Commissions$BrokerAccount$viewHeader = function(brokerAccount) {
        return $author$project$Ui$Typography$heading(_List_fromArray([
            $author$project$Layouts$Commissions$BrokerAccount$brokerAccountName(brokerAccount)
        ]));
    };
    var $author$project$Layouts$Commissions$BrokerAccount$viewNav = F4(function(currentRoute, brokerAccountId, brokerAccount, nav) {
        var statementsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top({
            bS: brokerAccountId
        });
        var multipleBrokers = A2($elm$core$Maybe$withDefault, true, A2($elm$core$Maybe$map, $author$project$Api$Provider$BrokerAccount$One$multipleBrokers, $author$project$Api$Data$toMaybe(brokerAccount)));
        var endedDealsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals({
            bS: brokerAccountId
        });
        var dealsRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals({
            bS: brokerAccountId
        });
        var brokerAccountRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top({
            bS: brokerAccountId
        });
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(dealsRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$List$member, currentRoute, _List_fromArray([
                    dealsRoute,
                    endedDealsRoute
                ])))
            ]), _List_fromArray([
                $elm$html$Html$text('Deals')
            ])),
            function() {
                if (multipleBrokers) {
                    var brokersRoute = $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
                        bS: brokerAccountId
                    });
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(brokersRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(brokersRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Brokers')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(statementsRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(statementsRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text('Statements')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(brokerAccountRoute),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, brokerAccountRoute))
            ]), _List_fromArray([
                $elm$html$Html$text('Account Setup')
            ]))
        ]), nav);
    });
    var $author$project$Layouts$Commissions$BrokerAccount$view = F4(function(toMsg, _v0, model, body) {
        var url = _v0.aaT;
        var currentRoute = $author$project$Utils$Route$fromUrl(url);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($elm$html$Html$map, toMsg, $author$project$Layouts$Commissions$BrokerAccount$viewBreadcrumbs(model.vR)),
                $author$project$Layouts$Commissions$BrokerAccount$viewHeader(model.vR),
                A2($elm$html$Html$map, toMsg, A4($author$project$Layouts$Commissions$BrokerAccount$viewNav, currentRoute, model.bS, model.vR, model.nb))
            ])),
            A2($elm$html$Html$div, _List_Nil, body)
        ]);
    });
    var $author$project$Layouts$Company$companyName = function(company) {
        if (company.$ === 3) {
            var company_ = company.a;
            return $elm$html$Html$text($author$project$Api$Company$name(company_));
        } else return $author$project$Ui$Skeleton$text(_List_fromArray([
            $author$project$Ui$Skeleton$spanFromText('Company Name')
        ]));
    };
    var $author$project$Api$Provider$Company$One$flaggedNotesCount = function(_v0) {
        var record = _v0.b;
        return record.PR;
    };
    var $author$project$Api$Company$flaggedNotesCount = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$flaggedNotesCount(company_);
        } else return 0;
    };
    var $author$project$Ui$Badge$SizeMd = {
        $: 1
    };
    var $author$project$Ui$Badge$md = $author$project$Ui$Badge$SizeMd;
    var $author$project$Api$Employer$Company$Shared$status = function(_v0) {
        var record = _v0;
        return record.ahy;
    };
    var $author$project$Api$Employer$Company$One$status = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Employer$Company$Shared$status(shared);
    };
    var $author$project$Api$Company$status = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$status(company_);
        } else {
            var company_ = company.a;
            return $author$project$Api$Employer$Company$One$status(company_);
        }
    };
    var $author$project$Layouts$Company$viewHeader = F3(function(organizationIsCompany, practice, company) {
        return organizationIsCompany ? _List_Nil : _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsStart
            ]), _List_fromArray([
                A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__Top, _List_Nil, _List_fromArray([
                            A2($elm$core$Maybe$withDefault, $author$project$Ui$Skeleton$text(_List_fromArray([
                                $author$project$Ui$Skeleton$spanFromText('Employers')
                            ])), $author$project$Api$Data$toMaybe(A2($author$project$Api$Data$map, function(pra) {
                                return $elm$html$Html$text(A2($author$project$Api$Practice$sponsorize, pra, 'Employers'));
                            }, practice)))
                        ]))
                    ])),
                    A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                        $author$project$Ui$Breadcrumb$active(true)
                    ]), _List_fromArray([
                        $author$project$Layouts$Company$companyName(company)
                    ]))
                ]))),
                A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                    A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__Top, _List_Nil, _List_fromArray([
                        $author$project$Ui$Icon$cross(_List_fromArray([
                            $author$project$Ui$Icon$sm
                        ]))
                    ]))
                ])))
            ])),
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$gap2,
                $author$project$Ui$Element$itemsCenter,
                $author$project$Ui$Element$mb2
            ]), _List_fromArray([
                $author$project$Ui$Typography$heading(_List_fromArray([
                    $author$project$Layouts$Company$companyName(company)
                ])),
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$map, function(status) {
                    return A2($author$project$Ui$Badge$fromString, _List_fromArray([
                        $author$project$Ui$Badge$md,
                        $author$project$Ui$Badge$inline
                    ]), status);
                }, A2($elm$core$Maybe$map, $author$project$Api$Company$status, $author$project$Api$Data$toMaybe(company)))),
                $author$project$Utils$Html$noBreakSpace,
                A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$andThen, function(company_) {
                    return $author$project$Api$Company$flaggedNotesCount(company_) > 0 ? $elm$core$Maybe$Just(A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes({
                        fl: $author$project$Api$Company$id(company_)
                    }), _List_fromArray([
                        $author$project$Ui$Link$routeParams(_List_fromArray([
                            A2($elm$url$Url$Builder$string, 'flagged', 'flagged')
                        ])),
                        $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
                    ]), _List_Nil)) : $elm$core$Maybe$Nothing;
                }, $author$project$Api$Data$toMaybe(company)))
            ]))
        ]);
    });
    var $author$project$Api$Provider$Company$One$invitationPending = function(_v0) {
        var record = _v0.b;
        return record.Ry;
    };
    var $author$project$Api$Company$invitationPending = function(company) {
        if (!company.$) {
            var company_ = company.a;
            return $author$project$Api$Provider$Company$One$invitationPending(company_);
        } else return false;
    };
    var $author$project$Layouts$Company$viewInvitationPendingWarning = function(company) {
        return A2($elm$core$Maybe$withDefault, $author$project$Utils$Html$empty, A2($elm$core$Maybe$andThen, function(company_) {
            return $author$project$Api$Company$invitationPending(company_) ? $elm$core$Maybe$Just(A2($author$project$Ui$Alert$warning, _List_Nil, _List_fromArray([
                $elm$html$Html$text('No administrators have accepted their invitation. '),
                $elm$html$Html$text('We cannot send any invoices or emails to administrators who have not accepted their invitation. '),
                A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top({
                    fl: $author$project$Api$Company$id(company_)
                }), _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Click here')
                ])),
                $elm$html$Html$text(' to review invitations.')
            ]))) : $elm$core$Maybe$Nothing;
        }, $author$project$Api$Data$toMaybe(company)));
    };
    var $author$project$Api$Feature$CustomizableNotificationsByEmployer = 12;
    var $author$project$Layouts$Company$viewNav = F5(function(currentRoute, isHintAdmin, practice, company, nav) {
        var gateAvailable = function(code) {
            return A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(practice_) {
                return A2($author$project$Utils$FeatureGate$gateAvailable, code, practice_);
            }, $author$project$Api$Data$toMaybe(practice)));
        };
        var customizableNotifificationsByEmployerEnabled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, function(practice_) {
            return A2($author$project$Api$Practice$featureEnabled, 12, practice_);
        }, $author$project$Api$Data$toMaybe(practice)));
        var companyType = $author$project$Api$Company$companyType(company);
        var isChildCompany = companyType === 1;
        var isNetwork = !companyType;
        var companyId = $author$project$Api$Company$id(company);
        var employeesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
            fl: companyId
        });
        var invoicesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top({
            fl: companyId
        });
        var notesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes({
            fl: companyId
        });
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(employeesRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(employeesRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text(A2($author$project$Formatters$String$affiliateMember, 'Employees', $elm$core$Maybe$Just(companyType)))
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(invoicesRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(invoicesRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text('Invoices')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(notesRoute),
                $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(notesRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
            ]), _List_fromArray([
                $elm$html$Html$text('Notes')
            ])),
            function() {
                if (!isNetwork) {
                    var endedCommissionsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions({
                        fl: companyId
                    });
                    var companyRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top({
                        fl: companyId
                    });
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(companyRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$List$member, currentRoute, _List_fromArray([
                            companyRoute,
                            endedCommissionsRoute
                        ])))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Account & Pricing')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (!isNetwork) {
                    var signupRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup({
                        fl: companyId
                    });
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(signupRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(signupRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Online Signup')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (!isNetwork) {
                    var paymentSourcesRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources({
                        fl: companyId
                    });
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(paymentSourcesRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(paymentSourcesRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Payment Options')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (!isNetwork) {
                    var invoiceSettingsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings({
                        fl: companyId
                    });
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(invoiceSettingsRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(invoiceSettingsRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Invoice Settings')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (customizableNotifificationsByEmployerEnabled) {
                    var notificationsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications({
                        fl: companyId
                    });
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(notificationsRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(notificationsRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Notifications')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (!isNetwork && (gateAvailable(8) || isHintAdmin)) {
                    var uploadsRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top({
                        fl: companyId
                    });
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(uploadsRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(uploadsRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Employee Uploads')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (!isNetwork && isHintAdmin && !isChildCompany) {
                    var easRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas({
                        fl: companyId
                    });
                    return A2($author$project$Ui$HinterOnly$navItem, _List_fromArray([
                        $author$project$Ui$Nav$route(easRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(easRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Upload Settings')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (isNetwork) {
                    var affiliatesPricingRoute = $author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing({
                        fl: companyId
                    });
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(affiliatesPricingRoute),
                        $author$project$Ui$Nav$activeItem(A2($elm$core$String$startsWith, $author$project$Spa$Generated$Route$toString(affiliatesPricingRoute), $author$project$Spa$Generated$Route$toString(currentRoute)))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Pricing')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }()
        ]), nav);
    });
    var $author$project$Layouts$Company$view = F4(function(toMsg, shared, _v0, body) {
        var url = shared.aaT;
        var organizationIsCompany = shared.afW;
        var practice = shared.W1;
        var company = shared.acy;
        var nav = _v0.nb;
        var headerClass = !organizationIsCompany ? 'layout-header' : '';
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class(headerClass)
            ]), _Utils_ap(A3($author$project$Layouts$Company$viewHeader, organizationIsCompany, practice, company), _List_fromArray([
                $author$project$Layouts$Company$viewInvitationPendingWarning(company),
                function() {
                    var _v1 = _Utils_Tuple2(organizationIsCompany, company);
                    if (!_v1.a && _v1.b.$ === 3) {
                        var _v2 = _v1.b;
                        var company_ = _v2.a;
                        var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
                        var currentRoute = $author$project$Utils$Route$fromUrl(url);
                        return A2($elm$html$Html$map, toMsg, A5($author$project$Layouts$Company$viewNav, currentRoute, isHintAdmin, practice, company_, nav));
                    } else return $author$project$Utils$Html$empty;
                }()
            ]))),
            A2($elm$html$Html$div, _List_Nil, body)
        ]);
    });
    var $author$project$Api$Provider$Integration$One$product = function(_v0) {
        var record = _v0.c;
        return record.Xw;
    };
    var $author$project$Layouts$Marketplace$Manage$appNavItems = F3(function(currentRoute, integration, slug) {
        var _v0 = _Utils_Tuple2($author$project$Api$Provider$Integration$One$status(integration), $author$project$Api$Common$Marketplace$Product$Shared$type_($author$project$Api$Provider$Integration$One$product(integration)));
        if (_v0.a === 'active' && !_v0.b) {
            var _v1 = _v0.b;
            var usersRoute = $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users({
                _A: slug
            });
            var settingsAnchor = A2($elm$core$Maybe$andThen, $author$project$Api$Common$PartnerApp$Shared$settingsAnchor, $author$project$Api$Provider$Integration$One$partnerApp(integration));
            var settingsNavItem = function() {
                if (!settingsAnchor.$) {
                    var anchor = settingsAnchor.a;
                    var settingsRoute = $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings({
                        _A: slug
                    });
                    return _List_fromArray([
                        A2($author$project$Ui$Nav$item, _List_fromArray([
                            $author$project$Ui$Nav$route(settingsRoute),
                            $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, settingsRoute))
                        ]), _List_fromArray([
                            $elm$html$Html$text(A2($elm$core$Maybe$withDefault, 'Settings', $author$project$Api$Common$PartnerApp$Anchor$settingsLabel(anchor)))
                        ]))
                    ]);
                } else return _List_Nil;
            }();
            return A2($elm$core$List$cons, A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(usersRoute),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, usersRoute))
            ]), _List_fromArray([
                $elm$html$Html$text('Manage Users')
            ])), settingsNavItem);
        } else return _List_Nil;
    });
    var $author$project$Layouts$Marketplace$Manage$viewNav = F2(function(currentRoute, _v0) {
        var nav = _v0.nb;
        var slug = _v0._A;
        var integration = _v0.Rn;
        var navItems = function() {
            var _v1 = $author$project$Api$Data$toMaybe(integration);
            if (!_v1.$) {
                var integration_ = _v1.a;
                var quickbooksSettingsNavItem = slug === 'quickbooks' ? _List_fromArray([
                    A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Settings')
                    ]))
                ]) : _List_Nil;
                var onboardingNavItem = slug !== 'quickbooks' && slug !== 'elation' && A2($elm$core$List$member, $author$project$Api$Provider$Integration$One$status(integration_), _List_fromArray([
                    'pending',
                    'inactive'
                ])) ? _List_fromArray([
                    A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding({
                            _A: slug
                        })),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding({
                            _A: slug
                        })))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Onboarding')
                    ]))
                ]) : _List_Nil;
                var elationSettingsNavItem = slug === 'elation' ? _List_fromArray([
                    A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Settings')
                    ]))
                ]) : _List_Nil;
                var bookkeepingSettingsNavItem = slug === 'bookkeeping' && $author$project$Api$Provider$Integration$One$status(integration_) === 'active' ? _List_fromArray([
                    A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Settings')
                    ]))
                ]) : _List_Nil;
                return $elm$core$List$concat(_List_fromArray([
                    onboardingNavItem,
                    bookkeepingSettingsNavItem,
                    quickbooksSettingsNavItem,
                    elationSettingsNavItem,
                    A3($author$project$Layouts$Marketplace$Manage$appNavItems, currentRoute, integration_, slug)
                ]));
            } else return _List_Nil;
        }();
        return A3($author$project$Ui$Nav$view, _List_Nil, navItems, nav);
    });
    var $author$project$Layouts$Marketplace$Manage$view = F4(function(toMsg, shared, model, body) {
        var currentRoute = $author$project$Utils$Route$fromUrl(shared.aaT);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                function() {
                    var _v0 = model.Rn;
                    if (_v0.$ === 3) {
                        var integration = _v0.a;
                        var product = $author$project$Api$Provider$Integration$One$product(integration);
                        var productIcon = $author$project$Api$Common$Marketplace$Product$Shared$iconUrl(product);
                        var productName = $author$project$Api$Common$Marketplace$Product$Shared$name(product);
                        return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$flex,
                                $author$project$Ui$Element$itemsCenter,
                                $author$project$Ui$Element$gap4,
                                $author$project$Ui$Element$mb4,
                                $author$project$Ui$Element$mt2
                            ]), _List_fromArray([
                                function() {
                                    if (!productIcon.$) {
                                        var iconUrl = productIcon.a;
                                        return A3($author$project$Ui$Image$fromSrc, {
                                            Jg: productName
                                        }, iconUrl, _List_fromArray([
                                            $author$project$Ui$Image$height(32)
                                        ]));
                                    } else return $elm$html$Html$text('');
                                }(),
                                $author$project$Ui$Typography$heading(_List_fromArray([
                                    $elm$html$Html$text(productName + ' Settings')
                                ]))
                            ])),
                            A2($author$project$Ui$Element$view, _List_fromArray([
                                $author$project$Ui$Element$textMuted,
                                $author$project$Ui$Element$mb2
                            ]), _List_fromArray([
                                function() {
                                    var _v2 = $author$project$Api$Common$Marketplace$Product$Shared$type_(product);
                                    switch(_v2){
                                        case 0:
                                            return $elm$html$Html$text('Manage app configuration and user access.');
                                        case 1:
                                            return $elm$html$Html$text('Manage integration settings.');
                                        default:
                                            return $elm$html$Html$text('');
                                    }
                                }()
                            ]))
                        ]));
                    } else return $elm$html$Html$text('');
                }(),
                A2($elm$html$Html$map, toMsg, A2($author$project$Layouts$Marketplace$Manage$viewNav, currentRoute, model))
            ])),
            A2($elm$html$Html$div, _List_Nil, body)
        ]);
    });
    var $author$project$Ui$Grid$offsetLg = $author$project$Ui$Grid$Offset(3);
    var $author$project$Ui$Grid$offsetXl = $author$project$Ui$Grid$Offset(4);
    var $author$project$Layouts$Onboard$viewHeader = A2($author$project$Ui$Grid$row, _List_fromArray([
        $author$project$Ui$Grid$mb4
    ]), _List_fromArray([
        A2($author$project$Ui$Grid$column, _List_Nil, _List_fromArray([
            $author$project$Ui$Image$viewHintLogoImage(_List_fromArray([
                $author$project$Ui$Image$class('topnav__logo')
            ]))
        ]))
    ]));
    var $author$project$Layouts$Onboard$isCurrentRoute = F2(function(url, route) {
        return A2($elm$core$String$endsWith, $elm$core$String$concat(_List_fromArray([
            '/',
            route
        ])), $author$project$Spa$Generated$Route$toString($author$project$Utils$Route$fromUrl(url)));
    });
    var $author$project$Components$OnboardingStepper$setCurrentStepFromUrl = function(url) {
        var route = $author$project$Utils$Route$fromUrl(url);
        return A2($elm$core$String$endsWith, '/payment', $author$project$Spa$Generated$Route$toString(route)) ? 2 : A2($elm$core$String$endsWith, '/user', $author$project$Spa$Generated$Route$toString(route)) ? 1 : 0;
    };
    var $author$project$Ui$Stepper$Step = F5(function(label, index, disabled, subtitle, subtitleDescription) {
        return {
            d$: disabled,
            yc: index,
            aeI: label,
            $s: subtitle,
            $t: subtitleDescription
        };
    });
    var $author$project$Components$OnboardingStepper$convertedSteps = A2($elm$core$List$map, function(internalStep) {
        return A5($author$project$Ui$Stepper$Step, internalStep.aeI, internalStep.yc, false, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
    }, $author$project$Components$OnboardingStepper$internalSteps);
    var $author$project$Ui$Stepper$viewStep = F3(function(_v0, attr, step) {
        var currentIndex = _v0.P;
        var numSteps = _v0.T;
        var stepIndexString = $elm$core$String$fromInt(step.yc + 1);
        var stepOptions = step.d$ ? {
            cM: A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('stepper__circle')
            ]), _List_fromArray([
                $elm$html$Html$text(stepIndexString)
            ])),
            dl: 'disabled',
            dm: $elm$html$Html$text(step.aeI)
        } : _Utils_eq(step.yc, currentIndex) ? {
            cM: A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('stepper__circle')
            ]), _List_fromArray([
                $elm$html$Html$text(stepIndexString)
            ])),
            dl: 'current',
            dm: $elm$html$Html$text(step.aeI)
        } : _Utils_cmp(step.yc, currentIndex) < 0 ? {
            cM: A2($elm$html$Html$a, _List_fromArray([
                $elm$html$Html$Attributes$class('stepper__circle'),
                attr
            ]), _List_fromArray([
                $author$project$Ui$Icon$check(_List_Nil)
            ])),
            dl: 'previous',
            dm: A2($elm$html$Html$a, _List_fromArray([
                attr
            ]), _List_fromArray([
                $elm$html$Html$text(step.aeI)
            ]))
        } : {
            cM: A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('stepper__circle')
            ]), _List_fromArray([
                $elm$html$Html$text(stepIndexString)
            ])),
            dl: 'next',
            dm: $elm$html$Html$text(step.aeI)
        };
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('stepper__step stepper__step--' + stepOptions.dl)
        ]), _List_fromArray([
            stepOptions.cM,
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('stepper__text')
            ]), _List_fromArray([
                stepOptions.dm
            ])),
            A2($author$project$Utils$Html$htmlIf, _Utils_cmp(step.yc + 1, numSteps) < 0, A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('stepper__line')
            ]), _List_fromArray([
                $author$project$Ui$HorizontalRule$view(_List_Nil)
            ])))
        ]));
    });
    var $author$project$Ui$Stepper$viewStaticStep = F2(function(_v0, step) {
        var currentIndex = _v0.P;
        var numSteps = _v0.T;
        return A3($author$project$Ui$Stepper$viewStep, {
            P: currentIndex,
            T: numSteps
        }, $elm$html$Html$Attributes$class('label'), step);
    });
    var $author$project$Ui$Stepper$viewStatic = F2(function(maybeStepIndex, steps) {
        if ($elm$core$List$isEmpty(steps)) return $author$project$Utils$Html$empty;
        else {
            if (!maybeStepIndex.$) {
                var stepIndex = maybeStepIndex.a;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('stepper')
                ]), A2($elm$core$List$map, function(step) {
                    return A2($author$project$Ui$Stepper$viewStaticStep, {
                        P: stepIndex,
                        T: $elm$core$List$length(steps)
                    }, step);
                }, steps));
            } else return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Components$OnboardingStepper$view = function(model) {
        var currentStep = model.E1;
        return A2($author$project$Ui$Stepper$viewStatic, $elm$core$Maybe$Just(currentStep.yc), $author$project$Components$OnboardingStepper$convertedSteps);
    };
    var $author$project$Layouts$Onboard$viewStepper = function(url) {
        if (A2($author$project$Layouts$Onboard$isCurrentRoute, url, 'complete') || A2($author$project$Layouts$Onboard$isCurrentRoute, url, 'completing')) return $author$project$Utils$Html$empty;
        else {
            var stepId = $author$project$Components$OnboardingStepper$setCurrentStepFromUrl(url);
            var stepperModel = $author$project$Components$OnboardingStepper$init(stepId);
            return $author$project$Components$OnboardingStepper$view(stepperModel);
        }
    };
    var $author$project$Layouts$Onboard$view = F2(function(_v0, body) {
        var url = _v0.aaT;
        return _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Layouts$Onboard$viewHeader,
                $author$project$Layouts$Onboard$viewStepper(url),
                A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$column, _List_fromArray([
                        $author$project$Ui$Grid$spanSm(8),
                        $author$project$Ui$Grid$offsetSm(2),
                        $author$project$Ui$Grid$spanMd(6),
                        $author$project$Ui$Grid$offsetMd(3),
                        $author$project$Ui$Grid$spanLg(6),
                        $author$project$Ui$Grid$offsetLg(3),
                        $author$project$Ui$Grid$spanXl(4),
                        $author$project$Ui$Grid$offsetXl(4)
                    ]), body)
                ]))
            ]))
        ]);
    });
    var $author$project$Layouts$Partner$Billing$viewNav = F3(function(shared, currentRoute, _v0) {
        var nav = _v0.nb;
        var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
        var billingRoute = $author$project$Spa$Generated$Route$Partner__Billing;
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(billingRoute),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, billingRoute))
            ]), _List_fromArray([
                $elm$html$Html$text('Payment Processing')
            ])),
            function() {
                if (isHintAdmin) {
                    var hinterRoute = $author$project$Spa$Generated$Route$Partner__Billing__Hinter;
                    return A2($author$project$Ui$HinterOnly$navItem, _List_fromArray([
                        $author$project$Ui$Nav$route(hinterRoute),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(hinterRoute, currentRoute))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Billing')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }()
        ]), nav);
    });
    var $author$project$Layouts$Partner$Billing$view = F4(function(toMsg, shared, model, body) {
        var currentRoute = $author$project$Utils$Route$fromUrl(shared.aaT);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($elm$html$Html$map, toMsg, A3($author$project$Layouts$Partner$Billing$viewNav, shared, currentRoute, model))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
            ]), body)
        ]);
    });
    var $author$project$Layouts$Partner$Practices$viewNav = F2(function(currentRoute, _v0) {
        var nav = _v0.nb;
        var engagementsRoute = $author$project$Spa$Generated$Route$Partner__Engagements;
        var connectionsRoute = $author$project$Spa$Generated$Route$Partner__Practices__Top;
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(connectionsRoute),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, connectionsRoute))
            ]), _List_fromArray([
                $elm$html$Html$text('Connections')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(engagementsRoute),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, engagementsRoute))
            ]), _List_fromArray([
                $elm$html$Html$text('Engagements')
            ]))
        ]), nav);
    });
    var $author$project$Layouts$Partner$Practices$view = F4(function(toMsg, shared, model, body) {
        var currentRoute = $author$project$Utils$Route$fromUrl(shared.aaT);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($elm$html$Html$map, toMsg, A2($author$project$Layouts$Partner$Practices$viewNav, currentRoute, model))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
            ]), body)
        ]);
    });
    var $author$project$Api$Partner$Partner$Shared$appEnabled = function(_v0) {
        var record = _v0;
        return !record.G7;
    };
    var $author$project$Api$Partner$Partner$One$appEnabled = function(_v0) {
        var shared = _v0.a;
        return $author$project$Api$Partner$Partner$Shared$appEnabled(shared);
    };
    var $author$project$Layouts$Partner$Product$viewNav = F3(function(shared, currentRoute, _v0) {
        var nav = _v0.nb;
        var partner = _v0.VW;
        var productRoute = $author$project$Spa$Generated$Route$Partner__Product;
        var isHintAdmin = $author$project$Shared$isHintAdmin(shared);
        var appEnabled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Partner$Partner$One$appEnabled, $author$project$Api$Data$toMaybe(partner)));
        var apiEnabled = A2($elm$core$Maybe$withDefault, false, A2($elm$core$Maybe$map, $author$project$Api$Partner$Partner$One$active, $author$project$Api$Data$toMaybe(partner)));
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(productRoute),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, productRoute))
            ]), _List_fromArray([
                $elm$html$Html$text('Product Listing')
            ])),
            function() {
                if (apiEnabled) {
                    var activationSettingsRoute = $author$project$Spa$Generated$Route$Partner__Product__ActivationSettings;
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(activationSettingsRoute),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(activationSettingsRoute, currentRoute))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Activation Settings')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (apiEnabled && appEnabled) {
                    var appSettingsRoute = $author$project$Spa$Generated$Route$Partner__Product__AppSettings;
                    return A2($author$project$Ui$Nav$item, _List_fromArray([
                        $author$project$Ui$Nav$route(appSettingsRoute),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(appSettingsRoute, currentRoute))
                    ]), _List_fromArray([
                        $elm$html$Html$text('App Settings')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }(),
            function() {
                if (isHintAdmin) {
                    var hinterRoute = $author$project$Spa$Generated$Route$Partner__Product__Hinter;
                    return A2($author$project$Ui$HinterOnly$navItem, _List_fromArray([
                        $author$project$Ui$Nav$route(hinterRoute),
                        $author$project$Ui$Nav$activeItem(_Utils_eq(hinterRoute, currentRoute))
                    ]), _List_fromArray([
                        $elm$html$Html$text('Admin Settings')
                    ]));
                } else return $author$project$Ui$Nav$emptyItem;
            }()
        ]), nav);
    });
    var $author$project$Layouts$Partner$Product$view = F4(function(toMsg, shared, model, body) {
        var currentRoute = $author$project$Utils$Route$fromUrl(shared.aaT);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($elm$html$Html$map, toMsg, A3($author$project$Layouts$Partner$Product$viewNav, shared, currentRoute, model))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
            ]), body)
        ]);
    });
    var $author$project$Layouts$Partner$Webhooks$viewNav = F2(function(currentRoute, _v0) {
        var nav = _v0.nb;
        var settingsRoute = $author$project$Spa$Generated$Route$Partner__Webhooks__Settings;
        var requestsRoute = $author$project$Spa$Generated$Route$Partner__Webhooks__Requests;
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(settingsRoute),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, settingsRoute))
            ]), _List_fromArray([
                $elm$html$Html$text('Settings')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route(requestsRoute),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, requestsRoute))
            ]), _List_fromArray([
                $elm$html$Html$text('Requests')
            ]))
        ]), nav);
    });
    var $author$project$Layouts$Partner$Webhooks$view = F4(function(toMsg, shared, model, body) {
        var currentRoute = $author$project$Utils$Route$fromUrl(shared.aaT);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('layout-header')
            ]), _List_fromArray([
                A2($elm$html$Html$map, toMsg, A2($author$project$Layouts$Partner$Webhooks$viewNav, currentRoute, model))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('nav-panel nav-panel-header-white')
            ]), body)
        ]);
    });
    var $author$project$Ui$Pagination$List$HideTotalItems = {
        $: 3
    };
    var $author$project$Ui$Pagination$List$hideTotalItems = $author$project$Ui$Pagination$List$HideTotalItems;
    var $author$project$Ui$Pagination$List$sm = $author$project$Ui$Pagination$List$Size(0);
    var $author$project$Components$PatientsList$PhiModeToggled = function(a) {
        return {
            $: 10,
            a: a
        };
    };
    var $author$project$Components$PatientsList$viewPhiToggle = function(phiMode) {
        return A2($author$project$Ui$Element$view, _List_fromArray([
            $author$project$Ui$Element$itemsCenter
        ]), _List_fromArray([
            $author$project$Ui$ToggleSwitch$view(_List_fromArray([
                $author$project$Ui$ToggleSwitch$sm,
                $author$project$Ui$ToggleSwitch$on(!phiMode),
                $author$project$Ui$ToggleSwitch$onChange(A2($elm$core$Basics$composeL, $author$project$Components$PatientsList$PhiModeToggled, $elm$core$Basics$not))
            ])),
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('ml-2')
            ]), _List_fromArray([
                $elm$html$Html$text('Display patients list')
            ]))
        ]));
    };
    var $author$project$Components$PatientsList$viewMini = function(model) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('patients-list patients-list--mini'),
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('patients-list--phi-mode', model.r5)
            ]))
        ]), _Utils_ap(A2($author$project$Components$PatientsList$viewSearchAndFilters, true, model), _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    $author$project$Components$PatientsList$viewPhiToggle(model.r5)
                ])),
                A2($author$project$Components$PatientsList$viewPatientsTable, true, model),
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$mt4
                    ]), _List_fromArray([
                        A2($author$project$Components$PatientsList$viewPagination, _List_fromArray([
                            $author$project$Ui$Pagination$List$hideTotalItems,
                            $author$project$Ui$Pagination$List$sm
                        ]), model)
                    ]))
                ]))
            ]))
        ])));
    };
    var $author$project$Layouts$PatientsSidebar$view = F3(function(toMsg, patientsListModel, body) {
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flex')
            ]), _List_fromArray([
                A2($elm$html$Html$map, toMsg, $author$project$Components$PatientsList$viewMini(patientsListModel)),
                A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('md:w-full md:ml-64 w-full')
                ]), body)
            ]))
        ]);
    });
    var $author$project$Components$PatientViewSwitcher$MembershipsBilling = 1;
    var $author$project$Components$PatientViewSwitcher$ClinicalChart = 0;
    var $author$project$Components$PatientViewSwitcher$viewToRoute = F2(function(activeView, patientId) {
        if (!activeView) return $author$project$Spa$Generated$Route$Patients__PatientId_String__Chart({
            V8: patientId
        });
        else return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
            V8: patientId
        });
    });
    var $author$project$Components$PatientViewSwitcher$viewItem = F4(function(label, itemView, activeView, patientId) {
        return _Utils_eq(itemView, activeView) ? A2($elm$html$Html$span, _List_fromArray([
            $elm$html$Html$Attributes$class('patient-view-switcher__item patient-view-switcher__item--active')
        ]), _List_fromArray([
            $elm$html$Html$text(label)
        ])) : A3($author$project$Ui$Link$route, A2($author$project$Components$PatientViewSwitcher$viewToRoute, itemView, patientId), _List_fromArray([
            $author$project$Ui$Link$currentColor
        ]), _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('patient-view-switcher__item')
            ]), _List_fromArray([
                $elm$html$Html$text(label)
            ]))
        ]));
    });
    var $author$project$Components$PatientViewSwitcher$view = F2(function(patientId, activeView) {
        var barClass = function() {
            if (!activeView) return 'patient-view-switcher-bar patient-view-switcher-bar--clinical';
            else return 'patient-view-switcher-bar patient-view-switcher-bar--core';
        }();
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class(barClass)
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('patient-view-switcher')
            ]), _List_fromArray([
                A4($author$project$Components$PatientViewSwitcher$viewItem, 'Clinical Chart', 0, activeView, patientId),
                A4($author$project$Components$PatientViewSwitcher$viewItem, 'Memberships & Billing', 1, activeView, patientId)
            ]))
        ]));
    });
    var $author$project$Layouts$Patient$AffiliateSyncDetailHovered = {
        $: 3
    };
    var $author$project$Layouts$Patient$NetworkSyncDetailHovered = {
        $: 1
    };
    var $author$project$Api$Provider$Patient$One$affiliateSyncStatus = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.IX;
    });
    var $author$project$Api$Provider$Patient$One$hasFlaggedNotes = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, A2($elm$core$Basics$composeR, function($) {
        return $.PR;
    }, function(flaggedNotesCount) {
        return flaggedNotesCount > 0;
    }));
    var $author$project$Api$Provider$Patient$One$isAffiliated = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.RQ;
    });
    var $author$project$Components$SyncedIcon$Md = 0;
    var $author$project$Components$SyncedIcon$Size = function(a) {
        return {
            $: 2,
            a: a
        };
    };
    var $author$project$Components$SyncedIcon$md = $author$project$Components$SyncedIcon$Size(0);
    var $author$project$Layouts$Patient$membershipStatus = function(patient) {
        return _Utils_ap($author$project$Formatters$String$humanize($author$project$Api$Provider$Patient$One$membershipStatus(patient)), function() {
            var _v0 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
            if (!_v0.$) {
                var membershipThrough = _v0.a;
                return ' through ' + $author$project$Api$Provider$Patient$Min$name(membershipThrough);
            } else return '';
        }());
    };
    var $author$project$Api$Provider$Patient$One$networkSyncStatus = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.UP;
    });
    var $author$project$Layouts$Patient$GoToAffiliatedPatient = F2(function(a, b) {
        return {
            $: 5,
            a: a,
            b: b
        };
    });
    var $author$project$Api$Provider$Patient$One$affiliate = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.Eb;
    });
    var $author$project$Layouts$Patient$isHintAdmin = F2(function(session, hinterViewOff) {
        if (session.$ === 3) {
            var session_ = session.a;
            return A2($author$project$Utils$User$isViewingAsHinter, session_, hinterViewOff);
        } else return false;
    });
    var $author$project$Api$Provider$Patient$One$masterRecordId = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.TK;
    });
    var $author$project$Api$Provider$Patient$One$network = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.UK;
    });
    var $author$project$Api$Provider$Patient$One$syncedRecordId = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$One$record_, function($) {
        return $.$K;
    });
    var $author$project$Layouts$Patient$viewActions = F2(function(_v0, patient) {
        var session = _v0.Z$;
        var hinterViewOff = _v0.aeb;
        var isHintAdmin_ = A2($author$project$Layouts$Patient$isHintAdmin, session, hinterViewOff);
        var hintAdminActions = function() {
            if (isHintAdmin_) {
                var syncedRecordId = $author$project$Api$Provider$Patient$One$syncedRecordId(patient);
                var network = $author$project$Api$Provider$Patient$One$network(patient);
                var masterRecordId = $author$project$Api$Provider$Patient$One$masterRecordId(patient);
                var affiliate = $author$project$Api$Provider$Patient$One$affiliate(patient);
                return _List_fromArray([
                    function() {
                        var _v1 = _Utils_Tuple2(network, masterRecordId);
                        if (!_v1.a.$ && !_v1.b.$) {
                            var network_ = _v1.a.a;
                            var masterId = _v1.b.a;
                            return A3($author$project$Ui$HinterOnly$button, {
                                abP: 'Go to affiliated patient'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick(A2($author$project$Layouts$Patient$GoToAffiliatedPatient, network_, masterId)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$arrowLeft)
                            ]), _List_Nil);
                        } else return $author$project$Utils$Html$empty;
                    }(),
                    function() {
                        var _v2 = _Utils_Tuple2(affiliate, syncedRecordId);
                        if (!_v2.a.$ && !_v2.b.$) {
                            var affiliate_ = _v2.a.a;
                            var syncedId = _v2.b.a;
                            return A3($author$project$Ui$HinterOnly$button, {
                                abP: 'Go to affiliated patient'
                            }, _List_fromArray([
                                $author$project$Ui$Button$link,
                                $author$project$Ui$Button$onClick(A2($author$project$Layouts$Patient$GoToAffiliatedPatient, affiliate_, syncedId)),
                                $author$project$Ui$Button$icon($author$project$Ui$Icon$arrowRight)
                            ]), _List_Nil);
                        } else return $author$project$Utils$Html$empty;
                    }()
                ]);
            } else return _List_Nil;
        }();
        return _Utils_ap(hintAdminActions, _List_fromArray([
            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Charges__New, _List_fromArray([
                $author$project$Ui$Link$buttonSecondary,
                $author$project$Ui$Link$icon($author$project$Ui$Icon$dollarSign),
                $author$project$Ui$Link$test('add-charge'),
                $author$project$Ui$Link$routeParams(_List_fromArray([
                    A2($elm$url$Url$Builder$string, 'patient', $author$project$Api$Provider$Patient$One$id(patient))
                ]))
            ]), _List_fromArray([
                $elm$html$Html$text('Add Charge')
            ]))
        ]));
    });
    var $author$project$Layouts$Patient$viewDemographicsDetails = function(patient) {
        var pronouns = A2($elm$core$Maybe$map, function(p) {
            return '(' + ($author$project$Formatters$String$humanize(p) + ')');
        }, $author$project$Api$Provider$Patient$One$pronoun(patient));
        var mainDetails = A2($elm$core$List$filterMap, $elm$core$Basics$identity, _List_fromArray([
            A2($elm$core$Maybe$map, $author$project$Formatters$String$humanize, $author$project$Api$Provider$Patient$One$gender(patient)),
            A2($elm$core$Maybe$map, $author$project$Formatters$Date$toString($author$project$Formatters$Date$Full), $author$project$Api$Provider$Patient$One$dob(patient))
        ]));
        return $elm$core$List$isEmpty(mainDetails) && _Utils_eq(pronouns, $elm$core$Maybe$Nothing) ? $author$project$Utils$Html$empty : A2($elm$html$Html$span, _List_Nil, _List_fromArray([
            A2($elm$html$Html$span, _List_fromArray([
                $elm$html$Html$Attributes$class('demographics-bar__details')
            ]), _List_fromArray([
                $elm$html$Html$text(A2($elm$core$String$join, ', ', mainDetails))
            ])),
            function() {
                if (!pronouns.$) {
                    var p = pronouns.a;
                    return A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('demographics-bar__pronouns text-muted')
                    ]), _List_fromArray([
                        $elm$html$Html$text(' ' + p)
                    ]));
                } else return $author$project$Utils$Html$empty;
            }()
        ]));
    };
    var $author$project$Api$Provider$Patient$SyncDetail$enrollmentStatus = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, A2($elm$core$Basics$composeR, function($) {
        return $.O$;
    }, $elm$core$Maybe$withDefault('')));
    var $author$project$Api$Provider$Patient$SyncDetail$errorMessage = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.O4;
    });
    var $author$project$Api$Provider$Patient$SyncDetail$startedAt = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $._3;
    });
    var $author$project$Api$Provider$Patient$SyncDetail$syncStatus = A2($elm$core$Basics$composeR, $author$project$Api$Provider$Patient$SyncDetail$record_, function($) {
        return $.$G;
    });
    var $author$project$Api$Provider$Patient$SyncDetail$syncedWith = function(detail) {
        if (!detail.$) {
            var name = detail.a;
            return name;
        } else {
            var name = detail.a;
            return name;
        }
    };
    var $author$project$Layouts$Patient$viewSyncedIconPopover = F2(function(timeFormatter, detailsData) {
        if (detailsData.$ === 3 && !detailsData.a.$) {
            var details = detailsData.a.a;
            return _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(function() {
                        var _v1 = $author$project$Api$Provider$Patient$SyncDetail$syncStatus(details);
                        if (_v1 === 'synced') return 'Synced with ';
                        else {
                            var status = _v1;
                            return 'Sync ' + (status + ' with ');
                        }
                    }()),
                    A2($elm$html$Html$strong, _List_Nil, _List_fromArray([
                        $elm$html$Html$text($author$project$Api$Provider$Patient$SyncDetail$syncedWith(details))
                    ]))
                ])),
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', $author$project$Api$Provider$Patient$SyncDetail$errorMessage(details)))
                ])),
                A2($author$project$Ui$Typography$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', A2($elm$core$Maybe$map, timeFormatter(0), A2($author$project$Utils$Maybe$orElse, $author$project$Api$Provider$Patient$SyncDetail$startedAt(details), $author$project$Api$Provider$Patient$SyncDetail$completedAt(details))))),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Utils$Html$middleDot),
                    $author$project$Utils$Html$noBreakSpace,
                    $elm$html$Html$text($author$project$Api$Provider$Patient$SyncDetail$enrollmentStatus(details))
                ]))
            ]);
        } else return _List_fromArray([
            $elm$html$Html$text('Loading details...'),
            $author$project$Ui$Spinner$view(_List_fromArray([
                $author$project$Ui$Spinner$small
            ]))
        ]);
    });
    var $author$project$Layouts$Patient$viewDemographicsBar = F4(function(shared, patient, model, timeFormatter) {
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('demographics-bar demographics-bar--unified')
        ]), _List_fromArray([
            A2($author$project$Ui$Element$view, _List_fromArray([
                $author$project$Ui$Element$spaceBetween,
                $author$project$Ui$Element$itemsCenter
            ]), _List_fromArray([
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('demographics-bar__name-row')
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$heading(_List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$One$name(patient))
                            ])),
                            function() {
                                var ageDisplay = A3($author$project$Formatters$Patient$formatAge, shared.cP, $author$project$Api$Provider$Patient$One$dob(patient), $author$project$Api$Provider$Patient$One$age(patient));
                                return $elm$core$String$isEmpty(ageDisplay) ? $elm$html$Html$text('') : $elm$html$Html$text(' (' + (ageDisplay + ')'));
                            }()
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter,
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            function() {
                                var _v0 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
                                if (!_v0.$) return A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                    $author$project$Ui$Tooltip$placement(0)
                                ]), $author$project$Layouts$Patient$membershipStatus(patient), _List_fromArray([
                                    A3($author$project$Ui$Badge$fromStringWithIcon, _List_Nil, $author$project$Api$Provider$Patient$One$membershipStatus(patient), $author$project$Ui$Icon$arrowRightBottom(_List_Nil))
                                ]));
                                else return A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Patient$One$membershipStatus(patient));
                            }(),
                            $author$project$Api$Provider$Patient$One$hasFlaggedNotes(patient) ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top({
                                V8: $author$project$Api$Provider$Patient$One$id(patient)
                            }), _List_fromArray([
                                $author$project$Ui$Link$routeParams(_List_fromArray([
                                    A2($elm$url$Url$Builder$string, 'flagged', '1')
                                ])),
                                $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
                            ]), _List_Nil) : $elm$html$Html$text(''),
                            $author$project$Api$Provider$Patient$One$isMaster(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient) ? A3($author$project$Ui$Popover$view, _List_fromArray([
                                $author$project$Ui$Popover$dark,
                                $author$project$Ui$Popover$onHover($author$project$Layouts$Patient$NetworkSyncDetailHovered)
                            ]), _List_fromArray([
                                $author$project$Components$SyncedIcon$view(_List_fromArray([
                                    $author$project$Components$SyncedIcon$md,
                                    $author$project$Components$SyncedIcon$master,
                                    $author$project$Components$SyncedIcon$status($author$project$Api$Provider$Patient$One$networkSyncStatus(patient))
                                ]))
                            ]), _List_fromArray([
                                A2($author$project$Ui$Popover$body, _List_Nil, A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.jh))
                            ])) : $author$project$Utils$Html$empty,
                            $author$project$Api$Provider$Patient$One$isSynced(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient) ? A3($author$project$Ui$Popover$view, _List_fromArray([
                                $author$project$Ui$Popover$dark,
                                $author$project$Ui$Popover$onHover($author$project$Layouts$Patient$AffiliateSyncDetailHovered)
                            ]), _List_fromArray([
                                $author$project$Components$SyncedIcon$view(_List_fromArray([
                                    $author$project$Components$SyncedIcon$md,
                                    $author$project$Components$SyncedIcon$synced,
                                    $author$project$Components$SyncedIcon$status($author$project$Api$Provider$Patient$One$affiliateSyncStatus(patient))
                                ]))
                            ]), _List_fromArray([
                                A2($author$project$Ui$Popover$body, _List_Nil, A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.hw))
                            ])) : $author$project$Utils$Html$empty
                        ]))
                    ])),
                    $author$project$Layouts$Patient$viewDemographicsDetails(patient)
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$itemsCenter,
                    $author$project$Ui$Element$gap2
                ]), A2($author$project$Layouts$Patient$viewActions, shared, patient))
            ]))
        ]));
    });
    var $author$project$Layouts$Patient$viewHeader = F3(function(shared, patient, model) {
        var practice = shared.W1;
        var timeFormatter = shared.HO;
        if (practice.$ === 3) {
            var practice_ = practice.a;
            var isJointProduct = A2($author$project$Api$Practice$featureEnabled, 6, practice_);
            return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                isJointProduct ? A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Components$PatientViewSwitcher$view, model.V8, 1)) : A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_Nil, _List_fromArray([
                            $elm$html$Html$text('Patients')
                        ]))
                    ])),
                    A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                        $author$project$Ui$Breadcrumb$active(true)
                    ]), _List_fromArray([
                        A2($author$project$Ui$Typography$span, _List_fromArray([
                            $author$project$Ui$Typography$phi(true)
                        ]), _List_fromArray([
                            $elm$html$Html$text($author$project$Api$Provider$Patient$One$name(patient))
                        ]))
                    ]))
                ]))),
                A4($author$project$Layouts$Patient$viewDemographicsBar, shared, patient, model, timeFormatter)
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Utils$Clinical$getPatientUrl = F4(function(isUnifiedExperience, origin, emrHost, patientId) {
        return A3($author$project$Utils$Clinical$getHost, isUnifiedExperience, origin, emrHost) + ('/patients/' + (patientId + '/chart'));
    });
    var $author$project$Layouts$Patient$viewHeaderLegacy = F3(function(shared, patient, model) {
        var practice = shared.W1;
        var timeFormatter = shared.HO;
        if (practice.$ === 3) {
            var practice_ = practice.a;
            return A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsStart
                ]), _List_fromArray([
                    A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Breadcrumb$view, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Breadcrumb$item, _List_Nil, _List_fromArray([
                            A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_Nil, _List_fromArray([
                                $elm$html$Html$text('Patients')
                            ]))
                        ])),
                        A2($author$project$Ui$Breadcrumb$item, _List_fromArray([
                            $author$project$Ui$Breadcrumb$active(true)
                        ]), _List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$One$name(patient))
                            ]))
                        ]))
                    ]))),
                    A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Ui$Element$view, _List_Nil, _List_fromArray([
                        A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__Top, _List_Nil, _List_fromArray([
                            $author$project$Ui$Icon$cross(_List_fromArray([
                                $author$project$Ui$Icon$sm
                            ]))
                        ]))
                    ])))
                ])),
                A2($author$project$Ui$Element$view, _List_fromArray([
                    $author$project$Ui$Element$spaceBetween,
                    $author$project$Ui$Element$itemsCenter
                ]), _List_fromArray([
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$mb2,
                        $author$project$Ui$Element$gap2
                    ]), _List_fromArray([
                        $author$project$Ui$Typography$heading(_List_fromArray([
                            A2($author$project$Ui$Typography$span, _List_fromArray([
                                $author$project$Ui$Typography$phi(true)
                            ]), _List_fromArray([
                                $elm$html$Html$text($author$project$Api$Provider$Patient$One$name(patient))
                            ])),
                            function() {
                                var ageDisplay = A3($author$project$Formatters$Patient$formatAge, shared.cP, $author$project$Api$Provider$Patient$One$dob(patient), $author$project$Api$Provider$Patient$One$age(patient));
                                return $elm$core$String$isEmpty(ageDisplay) ? $elm$html$Html$text('') : $elm$html$Html$text(', ' + ageDisplay);
                            }()
                        ])),
                        A2($author$project$Ui$Element$view, _List_fromArray([
                            $author$project$Ui$Element$itemsCenter,
                            $author$project$Ui$Element$gap2
                        ]), _List_fromArray([
                            function() {
                                var _v1 = $author$project$Api$Provider$Patient$One$membershipThrough(patient);
                                if (!_v1.$) return A3($author$project$Ui$Tooltip$view, _List_fromArray([
                                    $author$project$Ui$Tooltip$placement(0)
                                ]), $author$project$Layouts$Patient$membershipStatus(patient), _List_fromArray([
                                    A3($author$project$Ui$Badge$fromStringWithIcon, _List_Nil, $author$project$Api$Provider$Patient$One$membershipStatus(patient), $author$project$Ui$Icon$arrowRightBottom(_List_Nil))
                                ]));
                                else return A2($author$project$Ui$Badge$fromString, _List_Nil, $author$project$Api$Provider$Patient$One$membershipStatus(patient));
                            }(),
                            function() {
                                if (A2($author$project$Api$Practice$featureEnabled, 6, practice_)) {
                                    var isUnifiedExperience = A2($author$project$Api$Practice$featureEnabled, 19, practice_);
                                    var emrUrl = A4($author$project$Utils$Clinical$getPatientUrl, isUnifiedExperience, shared.adU.afY, shared.adU.adm, $author$project$Api$Provider$Patient$One$id(patient));
                                    return A3($author$project$Ui$Link$externalHref, emrUrl, _List_Nil, _List_fromArray([
                                        $elm$html$Html$text('View Chart in Clinical')
                                    ]));
                                } else return $elm$html$Html$text('');
                            }(),
                            $author$project$Api$Provider$Patient$One$hasFlaggedNotes(patient) ? A3($author$project$Ui$Link$route, $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top({
                                V8: $author$project$Api$Provider$Patient$One$id(patient)
                            }), _List_fromArray([
                                $author$project$Ui$Link$routeParams(_List_fromArray([
                                    A2($elm$url$Url$Builder$string, 'flagged', '1')
                                ])),
                                $author$project$Ui$Link$icon($author$project$Ui$Icon$flag)
                            ]), _List_Nil) : $elm$html$Html$text(''),
                            $author$project$Api$Provider$Patient$One$isMaster(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient) ? A3($author$project$Ui$Popover$view, _List_fromArray([
                                $author$project$Ui$Popover$dark,
                                $author$project$Ui$Popover$onHover($author$project$Layouts$Patient$NetworkSyncDetailHovered)
                            ]), _List_fromArray([
                                $author$project$Components$SyncedIcon$view(_List_fromArray([
                                    $author$project$Components$SyncedIcon$md,
                                    $author$project$Components$SyncedIcon$master,
                                    $author$project$Components$SyncedIcon$status($author$project$Api$Provider$Patient$One$networkSyncStatus(patient))
                                ]))
                            ]), _List_fromArray([
                                A2($author$project$Ui$Popover$body, _List_Nil, A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.jh))
                            ])) : $author$project$Utils$Html$empty,
                            $author$project$Api$Provider$Patient$One$isSynced(patient) && $author$project$Api$Provider$Patient$One$isAffiliated(patient) ? A3($author$project$Ui$Popover$view, _List_fromArray([
                                $author$project$Ui$Popover$dark,
                                $author$project$Ui$Popover$onHover($author$project$Layouts$Patient$AffiliateSyncDetailHovered)
                            ]), _List_fromArray([
                                $author$project$Components$SyncedIcon$view(_List_fromArray([
                                    $author$project$Components$SyncedIcon$md,
                                    $author$project$Components$SyncedIcon$synced,
                                    $author$project$Components$SyncedIcon$status($author$project$Api$Provider$Patient$One$affiliateSyncStatus(patient))
                                ]))
                            ]), _List_fromArray([
                                A2($author$project$Ui$Popover$body, _List_Nil, A2($author$project$Layouts$Patient$viewSyncedIconPopover, timeFormatter, model.hw))
                            ])) : $author$project$Utils$Html$empty
                        ]))
                    ])),
                    A2($author$project$Ui$Element$view, _List_fromArray([
                        $author$project$Ui$Element$itemsCenter,
                        $author$project$Ui$Element$mb2,
                        $author$project$Ui$Element$gap2
                    ]), A2($author$project$Layouts$Patient$viewActions, shared, patient))
                ]))
            ]));
        } else return $author$project$Utils$Html$empty;
    });
    var $author$project$Layouts$Patient$Affiliation = 4;
    var $author$project$Layouts$Patient$Invoices = 3;
    var $author$project$Layouts$Patient$Memberships = 1;
    var $author$project$Layouts$Patient$Notes = 5;
    var $author$project$Layouts$Patient$Notifications = 6;
    var $author$project$Layouts$Patient$Patient = 0;
    var $author$project$Layouts$Patient$PaymentOptions = 2;
    var $author$project$Layouts$Patient$isAuthorized = function(session) {
        if (session.$ === 3) {
            var session_ = session.a;
            return !$author$project$Api$Platform$Session$One$practiceReadOnlyRole(session_);
        } else return false;
    };
    var $author$project$Layouts$Patient$showIfAuthorized = F2(function(authorized, item) {
        return authorized ? item : $author$project$Ui$Nav$emptyItem;
    });
    var $author$project$Layouts$Patient$tabFromUrl = function(url) {
        var pathWithoutPat = A2($elm$core$List$drop, 3, A2($elm$core$String$split, '/', url.V6));
        _v0$6: while(true){
            if (pathWithoutPat.b) switch(pathWithoutPat.a){
                case 'memberships':
                    return 1;
                case 'accounts':
                    return 2;
                case 'charges':
                    return 3;
                case 'notes':
                    return 5;
                case 'notifications':
                    return 6;
                case 'affiliation':
                    return 4;
                default:
                    break _v0$6;
            }
            else break _v0$6;
        }
        return 0;
    };
    var $author$project$Layouts$Patient$tabToRoute = function(tab) {
        return function(id) {
            switch(tab){
                case 0:
                    return $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
                        V8: id
                    });
                case 1:
                    return $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top({
                        V8: id
                    });
                case 2:
                    return $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top({
                        V8: id
                    });
                case 3:
                    return $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top({
                        V8: id
                    });
                case 4:
                    return $author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top({
                        V8: id
                    });
                case 5:
                    return $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top({
                        V8: id
                    });
                default:
                    return $author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top({
                        V8: id
                    });
            }
        };
    };
    var $author$project$Layouts$Patient$viewNavWith = F4(function(linkOptions, _v0, patient, _v1) {
        var url = _v0.aaT;
        var session = _v0.Z$;
        var practice = _v0.W1;
        var patientId = _v1.V8;
        var nav = _v1.nb;
        var membershipsTabLabel = function() {
            if (practice.$ === 3) {
                var practice_ = practice.a;
                return A2($author$project$Api$Practice$featureEnabled, 22, practice_) ? 'Memberships & Packages' : 'Memberships';
            } else return 'Memberships';
        }();
        var linkRoute = function(tab) {
            return A2($author$project$Layouts$Patient$tabToRoute, tab, patientId);
        };
        var isSynced = $author$project$Api$Provider$Patient$One$isSynced(patient);
        var isAuthorized_ = $author$project$Layouts$Patient$isAuthorized(session);
        var activeTab = $author$project$Layouts$Patient$tabFromUrl(url);
        var isActive = function(tab) {
            return $author$project$Ui$Nav$activeItem(_Utils_eq(activeTab, tab));
        };
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                isActive(0),
                $author$project$Ui$Nav$route(linkRoute(0)),
                $author$project$Ui$Nav$linkOptions(linkOptions)
            ]), _List_fromArray([
                $elm$html$Html$text('Patient')
            ])),
            A2($author$project$Layouts$Patient$showIfAuthorized, isAuthorized_, A2($author$project$Ui$Nav$item, _List_fromArray([
                isActive(3),
                $author$project$Ui$Nav$route(linkRoute(3)),
                $author$project$Ui$Nav$linkOptions(linkOptions)
            ]), _List_fromArray([
                A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                    $elm$html$Html$text('Invoices'),
                    $author$project$Api$Provider$Patient$One$overdueAmountInCents(patient) > 0 ? A2($elm$html$Html$span, _List_Nil, _List_fromArray([
                        $author$project$Utils$Html$noBreakSpace,
                        $author$project$Ui$Icon$warning(_List_fromArray([
                            $author$project$Ui$Icon$danger
                        ]))
                    ])) : $author$project$Utils$Html$empty
                ]))
            ]))),
            A2($author$project$Layouts$Patient$showIfAuthorized, isAuthorized_, A2($author$project$Ui$Nav$item, _List_fromArray([
                isActive(1),
                $author$project$Ui$Nav$route(linkRoute(1)),
                $author$project$Ui$Nav$linkOptions(linkOptions)
            ]), _List_fromArray([
                $elm$html$Html$text(membershipsTabLabel)
            ]))),
            A2($author$project$Layouts$Patient$showIfAuthorized, isAuthorized_, A2($author$project$Ui$Nav$item, _List_fromArray([
                isActive(2),
                $author$project$Ui$Nav$route(linkRoute(2)),
                $author$project$Ui$Nav$linkOptions(linkOptions)
            ]), _List_fromArray([
                $elm$html$Html$text('Payment Options')
            ]))),
            A2($author$project$Layouts$Patient$showIfAuthorized, isAuthorized_ && isSynced, A2($author$project$Ui$Nav$item, _List_fromArray([
                isActive(4),
                $author$project$Ui$Nav$route(linkRoute(4)),
                $author$project$Ui$Nav$linkOptions(linkOptions)
            ]), _List_fromArray([
                $elm$html$Html$text('Affiliation')
            ]))),
            A2($author$project$Layouts$Patient$showIfAuthorized, isAuthorized_, A2($author$project$Ui$Nav$item, _List_fromArray([
                isActive(5),
                $author$project$Ui$Nav$route(linkRoute(5)),
                $author$project$Ui$Nav$linkOptions(linkOptions)
            ]), _List_fromArray([
                $elm$html$Html$text('Notes')
            ]))),
            A2($author$project$Layouts$Patient$showIfAuthorized, isAuthorized_, A2($author$project$Ui$Nav$item, _List_fromArray([
                isActive(6),
                $author$project$Ui$Nav$route(linkRoute(6)),
                $author$project$Ui$Nav$linkOptions(linkOptions)
            ]), _List_fromArray([
                $elm$html$Html$text('Notifications')
            ])))
        ]), nav);
    });
    var $author$project$Layouts$Patient$viewNav = F3(function(shared, patient, model) {
        return A4($author$project$Layouts$Patient$viewNavWith, _List_Nil, shared, patient, model);
    });
    var $author$project$Layouts$Patient$viewNavLegacy = F4(function(shared, patient, patientsList, model) {
        return A4($author$project$Layouts$Patient$viewNavWith, _List_fromArray([
            $author$project$Ui$Link$routeParams($author$project$Components$PatientsList$urlParams(patientsList))
        ]), shared, patient, model);
    });
    var $author$project$Layouts$Patient$view = F5(function(toMsg, patientListToMsg, shared, model, body) {
        var isUnifiedExperience = function() {
            var _v3 = shared.W1;
            if (_v3.$ === 3) {
                var practice_ = _v3.a;
                return A2($author$project$Api$Practice$featureEnabled, 19, practice_);
            } else return false;
        }();
        if (isUnifiedExperience) {
            var _v0 = model.V7;
            if (_v0.$ === 3) {
                var patient = _v0.a;
                return _List_fromArray([
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('layout-header--patient')
                    ]), _List_fromArray([
                        A2($elm$html$Html$map, toMsg, A3($author$project$Layouts$Patient$viewHeader, shared, patient, model))
                    ])),
                    A2($elm$html$Html$div, _List_fromArray([
                        $elm$html$Html$Attributes$class('patient-content-card')
                    ]), _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            $elm$html$Html$Attributes$class('patient-nav-bar')
                        ]), _List_fromArray([
                            A2($elm$html$Html$map, toMsg, A3($author$project$Layouts$Patient$viewNav, shared, patient, model))
                        ])),
                        A2($elm$html$Html$div, _List_Nil, body)
                    ]))
                ]);
            } else return _List_Nil;
        } else {
            var _v1 = shared.af4;
            if (!_v1.$) {
                var patientsList = _v1.a;
                return A3($author$project$Layouts$PatientsSidebar$view, patientListToMsg, patientsList, function() {
                    var _v2 = model.V7;
                    if (_v2.$ === 3) {
                        var patient = _v2.a;
                        return _List_fromArray([
                            A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('layout-header md:ml-0')
                            ]), _List_fromArray([
                                A2($elm$html$Html$map, toMsg, A3($author$project$Layouts$Patient$viewHeaderLegacy, shared, patient, model)),
                                A2($elm$html$Html$map, toMsg, A4($author$project$Layouts$Patient$viewNavLegacy, shared, patient, patientsList, model))
                            ])),
                            A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('md:ml-8')
                            ]), body)
                        ]);
                    } else return _List_Nil;
                }());
            } else return _List_Nil;
        }
    });
    var $author$project$Layouts$PatientChart$view = F2(function(_v0, model) {
        return _List_fromArray([
            A2($elm$html$Html$map, $elm$core$Basics$never, A2($author$project$Components$PatientViewSwitcher$view, model.V8, 0))
        ]);
    });
    var $author$project$Ui$Panel$FullHeight = {
        $: 1
    };
    var $author$project$Ui$Panel$fullHeight = $author$project$Ui$Panel$FullHeight;
    var $author$project$Layouts$PracticeSetup$isCurrentRoute = F2(function(url, route) {
        return A2($elm$core$String$endsWith, $elm$core$String$concat(_List_fromArray([
            '/',
            route
        ])), $author$project$Spa$Generated$Route$toString($author$project$Utils$Route$fromUrl(url)));
    });
    var $author$project$Components$PracticeSetupStepper$InternalStep = F5(function(id, index, label, subtitle, subtitleDescription) {
        return {
            aef: id,
            yc: index,
            aeI: label,
            $s: subtitle,
            $t: subtitleDescription
        };
    });
    var $author$project$Components$PracticeSetupStepper$stepIndex = F2(function(isHintClinical, stepId) {
        if (isHintClinical) {
            if (!stepId.$) switch(stepId.a){
                case 0:
                    var _v1 = stepId.a;
                    return 0;
                case 1:
                    var _v2 = stepId.a;
                    return 1;
                default:
                    var _v3 = stepId.a;
                    return 2;
            }
            else switch(stepId.a){
                case 0:
                    var _v4 = stepId.a;
                    return 0;
                case 1:
                    var _v5 = stepId.a;
                    return 1;
                case 2:
                    var _v6 = stepId.a;
                    return 1;
                case 3:
                    var _v7 = stepId.a;
                    return 2;
                default:
                    var _v8 = stepId.a;
                    return 3;
            }
        } else if (!stepId.$) switch(stepId.a){
            case 0:
                var _v10 = stepId.a;
                return 0;
            case 1:
                var _v11 = stepId.a;
                return 1;
            default:
                var _v12 = stepId.a;
                return 2;
        }
        else switch(stepId.a){
            case 0:
                var _v13 = stepId.a;
                return 0;
            case 3:
                var _v14 = stepId.a;
                return 1;
            case 4:
                var _v15 = stepId.a;
                return 2;
            default:
                return -1;
        }
    });
    var $author$project$Components$PracticeSetupStepper$stepLabel = F2(function(paymentProcessor, stepId) {
        if (!stepId.$) switch(stepId.a){
            case 0:
                var _v1 = stepId.a;
                return 'General Practice Information';
            case 1:
                var _v2 = stepId.a;
                return 'Membership Pricing Setup';
            default:
                var _v3 = stepId.a;
                return 'Patient Agreements';
        }
        else switch(stepId.a){
            case 3:
                var _v4 = stepId.a;
                return paymentProcessor === 'rainforest' ? 'Payment Processor Setup' : 'Setup Stripe';
            case 0:
                var _v5 = stepId.a;
                return 'Profile Setup';
            case 1:
                var _v6 = stepId.a;
                return 'Communications Setup';
            case 2:
                var _v7 = stepId.a;
                return 'Communications Setup';
            default:
                var _v8 = stepId.a;
                return '';
        }
    });
    var $author$project$Components$PracticeSetupStepper$stepSubtitle = F2(function(paymentProcessor, stepId) {
        if (!stepId.$) switch(stepId.a){
            case 0:
                var _v1 = stepId.a;
                return $elm$core$Maybe$Just('3-5 mins');
            case 1:
                var _v2 = stepId.a;
                return $elm$core$Maybe$Just('5-10 mins');
            default:
                var _v3 = stepId.a;
                return $elm$core$Maybe$Just('2 mins');
        }
        else switch(stepId.a){
            case 3:
                var _v4 = stepId.a;
                return paymentProcessor === 'rainforest' ? $elm$core$Maybe$Just('5-10 mins') : $elm$core$Maybe$Just('10 mins');
            case 0:
                var _v5 = stepId.a;
                return $elm$core$Maybe$Just('5-10 mins');
            case 1:
                var _v6 = stepId.a;
                return $elm$core$Maybe$Just('3-5 mins');
            case 2:
                var _v7 = stepId.a;
                return $elm$core$Maybe$Just('3-5 mins');
            default:
                var _v8 = stepId.a;
                return $elm$core$Maybe$Nothing;
        }
    });
    var $author$project$Components$PracticeSetupStepper$stepSubtitleDescription = F2(function(paymentProcessor, stepId) {
        if (!stepId.$) switch(stepId.a){
            case 0:
                var _v1 = stepId.a;
                return $elm$core$Maybe$Nothing;
            case 1:
                var _v2 = stepId.a;
                return $elm$core$Maybe$Nothing;
            default:
                var _v3 = stepId.a;
                return $elm$core$Maybe$Nothing;
        }
        else switch(stepId.a){
            case 3:
                var _v4 = stepId.a;
                return paymentProcessor === 'rainforest' ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just('*requires tax ID & practice bank account & routing number');
            case 0:
                var _v5 = stepId.a;
                return $elm$core$Maybe$Nothing;
            case 1:
                var _v6 = stepId.a;
                return $elm$core$Maybe$Nothing;
            case 2:
                var _v7 = stepId.a;
                return $elm$core$Maybe$Nothing;
            default:
                var _v8 = stepId.a;
                return $elm$core$Maybe$Nothing;
        }
    });
    var $author$project$Components$PracticeSetupStepper$buildInternalStep = F3(function(isHintClinical, paymentProcessor, stepId) {
        return A5($author$project$Components$PracticeSetupStepper$InternalStep, stepId, A2($author$project$Components$PracticeSetupStepper$stepIndex, isHintClinical, stepId), A2($author$project$Components$PracticeSetupStepper$stepLabel, paymentProcessor, stepId), A2($author$project$Components$PracticeSetupStepper$stepSubtitle, paymentProcessor, stepId), A2($author$project$Components$PracticeSetupStepper$stepSubtitleDescription, paymentProcessor, stepId));
    });
    var $author$project$Components$PracticeSetupStepper$Account = 0;
    var $author$project$Components$PracticeSetupStepper$AdminStep = function(a) {
        return {
            $: 1,
            a: a
        };
    };
    var $author$project$Components$PracticeSetupStepper$Communications = 1;
    var $author$project$Components$PracticeSetupStepper$Complete = 4;
    var $author$project$Components$PracticeSetupStepper$Documents = 2;
    var $author$project$Components$PracticeSetupStepper$Legal = 2;
    var $author$project$Components$PracticeSetupStepper$PaymentProcessing = 3;
    var $author$project$Components$PracticeSetupStepper$Plan = 1;
    var $author$project$Components$PracticeSetupStepper$PracticeInfoStep = function(a) {
        return {
            $: 0,
            a: a
        };
    };
    var $author$project$Components$PracticeSetupStepper$Team = 0;
    var $author$project$Components$PracticeSetupStepper$stepIds = _List_fromArray([
        $author$project$Components$PracticeSetupStepper$PracticeInfoStep(0),
        $author$project$Components$PracticeSetupStepper$PracticeInfoStep(1),
        $author$project$Components$PracticeSetupStepper$PracticeInfoStep(2),
        $author$project$Components$PracticeSetupStepper$AdminStep(0),
        $author$project$Components$PracticeSetupStepper$AdminStep(1),
        $author$project$Components$PracticeSetupStepper$AdminStep(2),
        $author$project$Components$PracticeSetupStepper$AdminStep(3),
        $author$project$Components$PracticeSetupStepper$AdminStep(4)
    ]);
    var $author$project$Components$PracticeSetupStepper$internalSteps = F2(function(isHintClinical, paymentProcessor) {
        return A2($elm$core$List$map, A2($author$project$Components$PracticeSetupStepper$buildInternalStep, isHintClinical, paymentProcessor), $author$project$Components$PracticeSetupStepper$stepIds);
    });
    var $author$project$Components$PracticeSetupStepper$init = F3(function(paymentProcessor, stepId, practice) {
        return {
            E1: A3($author$project$Components$PracticeSetupStepper$buildInternalStep, false, paymentProcessor, stepId),
            Wo: paymentProcessor,
            W1: practice,
            $a: A2($author$project$Components$PracticeSetupStepper$internalSteps, false, paymentProcessor)
        };
    });
    var $author$project$Components$PracticeSetupStepper$setCurrentStepFromUrl = function(url) {
        var route = $author$project$Utils$Route$fromUrl(url);
        return A2($elm$core$String$endsWith, '/account', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(0) : A2($elm$core$String$endsWith, '/new', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(1) : A2($elm$core$String$endsWith, '/plans', $author$project$Spa$Generated$Route$toString(route)) || A2($elm$core$String$contains, '/plans', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(1) : A2($elm$core$String$endsWith, '/documents', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$PracticeInfoStep(2) : A2($elm$core$String$endsWith, '/team', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(0) : A2($elm$core$String$endsWith, '/communications', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(1) : A2($elm$core$String$endsWith, '/legal', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(2) : A2($elm$core$String$endsWith, '/payment_processing', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(3) : A2($elm$core$String$endsWith, '/complete', $author$project$Spa$Generated$Route$toString(route)) ? $author$project$Components$PracticeSetupStepper$AdminStep(4) : $author$project$Components$PracticeSetupStepper$PracticeInfoStep(0);
    };
    var $author$project$Components$PracticeSetupStepper$adminStepIds = function(isHintClinical) {
        return isHintClinical ? _List_fromArray([
            $author$project$Components$PracticeSetupStepper$AdminStep(0),
            $author$project$Components$PracticeSetupStepper$AdminStep(1),
            $author$project$Components$PracticeSetupStepper$AdminStep(2),
            $author$project$Components$PracticeSetupStepper$AdminStep(3)
        ]) : _List_fromArray([
            $author$project$Components$PracticeSetupStepper$AdminStep(0),
            $author$project$Components$PracticeSetupStepper$AdminStep(3)
        ]);
    };
    var $author$project$Components$PracticeSetupStepper$convertStepsToStep = F3(function(isHintClinical, paymentProcessor, stepIds_) {
        return A2($elm$core$List$map, function(step) {
            return A5($author$project$Ui$Stepper$Step, step.aeI, step.yc, true, step.$s, step.$t);
        }, A2($elm_community$list_extra$List$Extra$uniqueBy, function(step) {
            return step.yc;
        }, A2($elm$core$List$map, A2($author$project$Components$PracticeSetupStepper$buildInternalStep, isHintClinical, paymentProcessor), stepIds_)));
    });
    var $author$project$Components$PracticeSetupStepper$convertedAdminSteps = F2(function(isHintClinical, paymentProcessor) {
        return A3($author$project$Components$PracticeSetupStepper$convertStepsToStep, isHintClinical, paymentProcessor, $author$project$Components$PracticeSetupStepper$adminStepIds(isHintClinical));
    });
    var $author$project$Ui$Stepper$viewVerticalStep = F3(function(_v0, attr, step) {
        var currentIndex = _v0.P;
        var lastCompletedIndex = _v0.rd;
        var numSteps = _v0.T;
        var stepIndexString = $elm$core$String$fromInt(step.yc + 1);
        var stepOptions = function() {
            if (_Utils_eq(step.yc, currentIndex)) return {
                cM: A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('stepper__circle')
                ]), _List_fromArray([
                    $elm$html$Html$text(stepIndexString)
                ])),
                dl: 'current',
                dm: $elm$html$Html$text(step.aeI)
            };
            else {
                if (step.d$) return {
                    cM: A2($elm$html$Html$span, _List_fromArray([
                        $elm$html$Html$Attributes$class('stepper__circle')
                    ]), _List_fromArray([
                        $elm$html$Html$text(stepIndexString)
                    ])),
                    dl: 'disabled',
                    dm: $elm$html$Html$text(step.aeI)
                };
                else {
                    if (_Utils_cmp(step.yc, currentIndex) < 0) return {
                        cM: A2($elm$html$Html$a, _List_fromArray([
                            $elm$html$Html$Attributes$class('stepper__circle'),
                            attr
                        ]), _List_fromArray([
                            $author$project$Ui$Icon$check(_List_Nil)
                        ])),
                        dl: 'previous',
                        dm: A2($elm$html$Html$a, _List_fromArray([
                            attr
                        ]), _List_fromArray([
                            $elm$html$Html$text(step.aeI)
                        ]))
                    };
                    else {
                        var circleBodyText = function() {
                            if (!lastCompletedIndex.$) {
                                var index = lastCompletedIndex.a;
                                return _Utils_cmp(step.yc, index) < 0 ? $author$project$Ui$Icon$check(_List_Nil) : $elm$html$Html$text(stepIndexString);
                            } else return $elm$html$Html$text(stepIndexString);
                        }();
                        return {
                            cM: A2($elm$html$Html$span, _List_fromArray([
                                $elm$html$Html$Attributes$class('stepper__circle')
                            ]), _List_fromArray([
                                circleBodyText
                            ])),
                            dl: 'next',
                            dm: $elm$html$Html$text(step.aeI)
                        };
                    }
                }
            }
        }();
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$class('stepper__step stepper__step--' + stepOptions.dl)
        ]), _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flex flex-col justify-center')
            ]), _List_fromArray([
                stepOptions.cM,
                A2($author$project$Utils$Html$htmlIf, _Utils_cmp(step.yc + 1, numSteps) < 0, A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('stepper__line')
                ]), _List_fromArray([
                    $author$project$Ui$HorizontalRule$view(_List_Nil)
                ])))
            ])),
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('flex flex-col')
            ]), _List_fromArray([
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('stepper__text')
                ]), _List_fromArray([
                    stepOptions.dm
                ])),
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('stepper__subtitle')
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', step.$s))
                ])),
                A2($elm$html$Html$span, _List_fromArray([
                    $elm$html$Html$Attributes$class('stepper__subtitle stepper__description')
                ]), _List_fromArray([
                    $elm$html$Html$text(A2($elm$core$Maybe$withDefault, '', step.$t))
                ]))
            ]))
        ]));
    });
    var $author$project$Ui$Stepper$viewStaticVerticalStep = F2(function(_v0, step) {
        var currentIndex = _v0.P;
        var numSteps = _v0.T;
        return A3($author$project$Ui$Stepper$viewVerticalStep, {
            P: currentIndex,
            rd: $elm$core$Maybe$Nothing,
            T: numSteps
        }, $elm$html$Html$Attributes$class('label'), step);
    });
    var $author$project$Ui$Stepper$viewVertical = F2(function(maybeStepIndex, steps) {
        if ($elm$core$List$isEmpty(steps)) return $author$project$Utils$Html$empty;
        else {
            if (!maybeStepIndex.$) {
                var stepIndex = maybeStepIndex.a;
                return A2($elm$html$Html$div, _List_fromArray([
                    $elm$html$Html$Attributes$class('stepper__vertical')
                ]), A2($elm$core$List$map, function(step) {
                    return A2($author$project$Ui$Stepper$viewStaticVerticalStep, {
                        P: stepIndex,
                        T: $elm$core$List$length(steps)
                    }, step);
                }, steps));
            } else return $author$project$Utils$Html$empty;
        }
    });
    var $author$project$Components$PracticeSetupStepper$viewExpandedHeader = F4(function(partLabel, title, steps, currentStep) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$bold
            ]), _List_fromArray([
                $elm$html$Html$text(partLabel)
            ])),
            $author$project$Ui$Typography$headingSm(_List_fromArray([
                $elm$html$Html$text(title)
            ])),
            A2($author$project$Ui$Stepper$viewVertical, $elm$core$Maybe$Just(currentStep.yc), steps)
        ]));
    });
    var $author$project$Components$PracticeSetupStepper$viewMinimizedHeader = F2(function(partLabel, title) {
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small
            ]), _List_fromArray([
                $elm$html$Html$text(partLabel)
            ])),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$bold,
                $author$project$Ui$Typography$padding(8)
            ]), _List_fromArray([
                $elm$html$Html$text(title)
            ]))
        ]));
    });
    var $author$project$Components$PracticeSetupStepper$viewAdminSetup = F3(function(isHintClinical, model, currentStep) {
        return A2($elm$core$List$member, currentStep.aef, $author$project$Components$PracticeSetupStepper$adminStepIds(isHintClinical)) || _Utils_eq(currentStep.aef, $author$project$Components$PracticeSetupStepper$AdminStep(2)) ? A4($author$project$Components$PracticeSetupStepper$viewExpandedHeader, 'Part 2 of 2', 'Admin Setup', A2($author$project$Components$PracticeSetupStepper$convertedAdminSteps, isHintClinical, model.Wo), _Utils_update(currentStep, {
            yc: A2($author$project$Components$PracticeSetupStepper$stepIndex, isHintClinical, currentStep.aef)
        })) : A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A2($author$project$Components$PracticeSetupStepper$viewMinimizedHeader, 'Part 2 of 2', 'Admin Setup'),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$padding(8)
            ]), _List_fromArray([
                $elm$html$Html$text('Est. 25-30 mins.')
            ])),
            A2($author$project$Ui$Typography$div, _List_fromArray([
                $author$project$Ui$Typography$muted,
                $author$project$Ui$Typography$small,
                $author$project$Ui$Typography$padding(8)
            ]), _List_fromArray([
                $elm$html$Html$text('Requires tax ID & practice bank routing & account numbers.')
            ]))
        ]));
    });
    var $author$project$Components$PracticeSetupStepper$practiceInfoStepIds = _List_fromArray([
        $author$project$Components$PracticeSetupStepper$PracticeInfoStep(0),
        $author$project$Components$PracticeSetupStepper$PracticeInfoStep(1),
        $author$project$Components$PracticeSetupStepper$PracticeInfoStep(2)
    ]);
    var $author$project$Components$PracticeSetupStepper$convertedPracticeSteps = F2(function(isHintClinical, paymentProcessor) {
        return A3($author$project$Components$PracticeSetupStepper$convertStepsToStep, isHintClinical, paymentProcessor, $author$project$Components$PracticeSetupStepper$practiceInfoStepIds);
    });
    var $author$project$Components$PracticeSetupStepper$viewPracticeInfoSetup = F3(function(isHintClinical, model, currentStep) {
        return A2($elm$core$List$member, currentStep.aef, $author$project$Components$PracticeSetupStepper$practiceInfoStepIds) ? A4($author$project$Components$PracticeSetupStepper$viewExpandedHeader, 'Part 1 of 2', 'Public Practice Information', A2($author$project$Components$PracticeSetupStepper$convertedPracticeSteps, isHintClinical, model.Wo), currentStep) : A2($author$project$Components$PracticeSetupStepper$viewMinimizedHeader, 'Part 1 of 2', 'Public Practice Information');
    });
    var $author$project$Components$PracticeSetupStepper$view = F2(function(model, _v0) {
        var isHintClinical = function() {
            var _v1 = model.W1;
            if (_v1.$ === 3 && !_v1.a.$) {
                var practice_ = _v1.a.a;
                var _v2 = $author$project$Api$Provider$Practice$One$emr(practice_);
                if (!_v2.$) {
                    var emr = _v2.a;
                    return !$author$project$Api$Provider$Practice$Emr$toOption(emr);
                } else return false;
            } else return false;
        }();
        var currentStep = model.E1;
        return A2($elm$html$Html$div, _List_Nil, _List_fromArray([
            A3($author$project$Components$PracticeSetupStepper$viewPracticeInfoSetup, isHintClinical, model, currentStep),
            A2($elm$html$Html$hr, _List_Nil, _List_Nil),
            A3($author$project$Components$PracticeSetupStepper$viewAdminSetup, isHintClinical, model, currentStep)
        ]));
    });
    var $author$project$Layouts$PracticeSetup$viewStepper = F4(function(paymentProcessor_, url, accountStep, practice) {
        var stepId = $author$project$Components$PracticeSetupStepper$setCurrentStepFromUrl(url);
        var stepperModel = A3($author$project$Components$PracticeSetupStepper$init, paymentProcessor_, stepId, practice);
        return A2($author$project$Components$PracticeSetupStepper$view, stepperModel, accountStep);
    });
    var $author$project$Layouts$PracticeSetup$view = F2(function(_v0, body) {
        var practice = _v0.W1;
        var url = _v0.aaT;
        var _v1 = function() {
            if (practice.$ === 3 && !practice.a.$) {
                var practice_ = practice.a.a;
                return _Utils_Tuple2(A2($elm$core$Maybe$withDefault, 0, A2($elm$core$Maybe$map, $author$project$Api$Provider$PracticeOnboarding$Shared$accountStep, $author$project$Api$Provider$Practice$One$practiceOnboarding(practice_))), $author$project$Api$Provider$Practice$One$paymentProcessor(practice_));
            } else return _Utils_Tuple2(8, 'stripe');
        }();
        var accountStep = _v1.a;
        var paymentProcessor_ = _v1.b;
        return _List_fromArray([
            A2($author$project$Ui$Panel$view, _List_fromArray([
                $author$project$Ui$Panel$extraPadding,
                $author$project$Ui$Panel$fullHeight
            ]), _List_fromArray([
                A2($author$project$Ui$Panel$body, _List_Nil, _List_fromArray([
                    A2($elm$html$Html$div, _List_Nil, A2($author$project$Layouts$PracticeSetup$isCurrentRoute, url, 'complete') ? _List_fromArray([
                        A2($elm$html$Html$div, _List_fromArray([
                            A2($elm$html$Html$Attributes$style, 'border', '1px solid #ccc'),
                            A2($elm$html$Html$Attributes$style, 'padding', '1rem'),
                            A2($elm$html$Html$Attributes$style, 'margin', '1rem 0')
                        ]), _List_fromArray([
                            A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                                A2($author$project$Ui$Grid$column, _List_fromArray([
                                    $author$project$Ui$Grid$spanSm(12),
                                    $author$project$Ui$Grid$justifyLeft
                                ]), body)
                            ]))
                        ]))
                    ]) : _List_fromArray([
                        A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(3)
                            ]), _List_fromArray([
                                A4($author$project$Layouts$PracticeSetup$viewStepper, paymentProcessor_, url, accountStep, practice)
                            ])),
                            A2($author$project$Ui$Grid$column, _List_fromArray([
                                $author$project$Ui$Grid$spanSm(9),
                                $author$project$Ui$Grid$justifyCenter
                            ]), body)
                        ]))
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Spa$Generated$Route$all = _List_fromArray([
        $author$project$Spa$Generated$Route$Top,
        $author$project$Spa$Generated$Route$Blank,
        $author$project$Spa$Generated$Route$Bookkeeping,
        $author$project$Spa$Generated$Route$Calendar,
        $author$project$Spa$Generated$Route$Forms,
        $author$project$Spa$Generated$Route$GoogleCallback,
        $author$project$Spa$Generated$Route$Home,
        $author$project$Spa$Generated$Route$Login,
        $author$project$Spa$Generated$Route$Logout,
        $author$project$Spa$Generated$Route$NotFound,
        $author$project$Spa$Generated$Route$Onboarding,
        $author$project$Spa$Generated$Route$AffiliateBills__Top,
        $author$project$Spa$Generated$Route$Affiliates__Top,
        $author$project$Spa$Generated$Route$Companies__Top,
        $author$project$Spa$Generated$Route$Files__Top,
        $author$project$Spa$Generated$Route$Marketplace__Top,
        $author$project$Spa$Generated$Route$Patients__Top,
        $author$project$Spa$Generated$Route$PracticeSetup__Top,
        $author$project$Spa$Generated$Route$StyleGuide__Top,
        $author$project$Spa$Generated$Route$Tasks__Top,
        $author$project$Spa$Generated$Route$Admin__AdvanceBilling,
        $author$project$Spa$Generated$Route$Admin__Billing,
        $author$project$Spa$Generated$Route$Admin__CancellationReasons,
        $author$project$Spa$Generated$Route$Admin__CardReaders,
        $author$project$Spa$Generated$Route$Admin__Categories,
        $author$project$Spa$Generated$Route$Admin__Commissions,
        $author$project$Spa$Generated$Route$Admin__Coupons,
        $author$project$Spa$Generated$Route$Admin__CreditCategories,
        $author$project$Spa$Generated$Route$Admin__ElationLegacy,
        $author$project$Spa$Generated$Route$Admin__Features,
        $author$project$Spa$Generated$Route$Admin__HipaaAuthorizations,
        $author$project$Spa$Generated$Route$Admin__InternalSettings,
        $author$project$Spa$Generated$Route$Admin__InvoiceSettings,
        $author$project$Spa$Generated$Route$Admin__LeadSources,
        $author$project$Spa$Generated$Route$Admin__Locations,
        $author$project$Spa$Generated$Route$Admin__Mailgun,
        $author$project$Spa$Generated$Route$Admin__Notes,
        $author$project$Spa$Generated$Route$Admin__Patients,
        $author$project$Spa$Generated$Route$Admin__PaymentMethodImport,
        $author$project$Spa$Generated$Route$Admin__PaymentProcessing,
        $author$project$Spa$Generated$Route$Admin__PaymentSources,
        $author$project$Spa$Generated$Route$Admin__Practice,
        $author$project$Spa$Generated$Route$Admin__ProviderGroups,
        $author$project$Spa$Generated$Route$Admin__ScheduledJobs,
        $author$project$Spa$Generated$Route$Admin__SelfService,
        $author$project$Spa$Generated$Route$Admin__Signup,
        $author$project$Spa$Generated$Route$Admin__Stripe,
        $author$project$Spa$Generated$Route$Admin__Taxes,
        $author$project$Spa$Generated$Route$Admin__Team,
        $author$project$Spa$Generated$Route$Affiliates__Create,
        $author$project$Spa$Generated$Route$Affiliates__New,
        $author$project$Spa$Generated$Route$Charges__New,
        $author$project$Spa$Generated$Route$Commissions__Statements,
        $author$project$Spa$Generated$Route$Companies__New,
        $author$project$Spa$Generated$Route$Contacts__List,
        $author$project$Spa$Generated$Route$Contacts__New,
        $author$project$Spa$Generated$Route$Files__Public,
        $author$project$Spa$Generated$Route$Hinter__ClonePractice,
        $author$project$Spa$Generated$Route$Hinter__Disputes,
        $author$project$Spa$Generated$Route$Hinter__FeatureFlags,
        $author$project$Spa$Generated$Route$Hinter__NewGroup,
        $author$project$Spa$Generated$Route$Hinter__NewPartner,
        $author$project$Spa$Generated$Route$Hinter__NewPractice,
        $author$project$Spa$Generated$Route$Inventory__List,
        $author$project$Spa$Generated$Route$Inventory__New,
        $author$project$Spa$Generated$Route$Inventory__Settings,
        $author$project$Spa$Generated$Route$Marketplace__Manage,
        $author$project$Spa$Generated$Route$Messages__Calls,
        $author$project$Spa$Generated$Route$Messages__Chat,
        $author$project$Spa$Generated$Route$Messages__Drafts,
        $author$project$Spa$Generated$Route$Messages__Forms,
        $author$project$Spa$Generated$Route$Messages__Labs,
        $author$project$Spa$Generated$Route$Messages__Sms,
        $author$project$Spa$Generated$Route$NewSettings__BlockedPhoneNumbers,
        $author$project$Spa$Generated$Route$NewSettings__BookingOverview,
        $author$project$Spa$Generated$Route$NewSettings__Erx,
        $author$project$Spa$Generated$Route$NewSettings__Export,
        $author$project$Spa$Generated$Route$NewSettings__HinterSettings,
        $author$project$Spa$Generated$Route$NewSettings__PracticeInfo,
        $author$project$Spa$Generated$Route$NewSettings__Team,
        $author$project$Spa$Generated$Route$Oauth__Callback,
        $author$project$Spa$Generated$Route$Partner__ApiKeys,
        $author$project$Spa$Generated$Route$Partner__Billing,
        $author$project$Spa$Generated$Route$Partner__Engagements,
        $author$project$Spa$Generated$Route$Partner__Hinter,
        $author$project$Spa$Generated$Route$Partner__Product,
        $author$project$Spa$Generated$Route$Partner__Team,
        $author$project$Spa$Generated$Route$Patients__Create,
        $author$project$Spa$Generated$Route$Patients__Upload,
        $author$project$Spa$Generated$Route$PracticeSetup__Account,
        $author$project$Spa$Generated$Route$PracticeSetup__Communications,
        $author$project$Spa$Generated$Route$PracticeSetup__Complete,
        $author$project$Spa$Generated$Route$PracticeSetup__Documents,
        $author$project$Spa$Generated$Route$PracticeSetup__Legal,
        $author$project$Spa$Generated$Route$PracticeSetup__PaymentProcessing,
        $author$project$Spa$Generated$Route$PracticeSetup__Plans,
        $author$project$Spa$Generated$Route$PracticeSetup__Team,
        $author$project$Spa$Generated$Route$Reports__CompanyInvoices,
        $author$project$Spa$Generated$Route$Reports__CreditOutstanding,
        $author$project$Spa$Generated$Route$Reports__CreditTransactions,
        $author$project$Spa$Generated$Route$Reports__Dashboard,
        $author$project$Spa$Generated$Route$Reports__DeferredRevenue,
        $author$project$Spa$Generated$Route$Reports__Deposits,
        $author$project$Spa$Generated$Route$Reports__Disputes,
        $author$project$Spa$Generated$Route$Reports__Invoices,
        $author$project$Spa$Generated$Route$Reports__Memberships,
        $author$project$Spa$Generated$Route$Reports__Months,
        $author$project$Spa$Generated$Route$Reports__PaymentApplications,
        $author$project$Spa$Generated$Route$Reports__Revenue,
        $author$project$Spa$Generated$Route$Reports__SalesTax,
        $author$project$Spa$Generated$Route$Reports__SignupAttempts,
        $author$project$Spa$Generated$Route$StyleGuide__ActivityIndicators,
        $author$project$Spa$Generated$Route$StyleGuide__AddressInput,
        $author$project$Spa$Generated$Route$StyleGuide__Alert,
        $author$project$Spa$Generated$Route$StyleGuide__Badge,
        $author$project$Spa$Generated$Route$StyleGuide__Button,
        $author$project$Spa$Generated$Route$StyleGuide__Carousel,
        $author$project$Spa$Generated$Route$StyleGuide__Checkbox,
        $author$project$Spa$Generated$Route$StyleGuide__CurrencyInput,
        $author$project$Spa$Generated$Route$StyleGuide__DateInput,
        $author$project$Spa$Generated$Route$StyleGuide__DateRangeInput,
        $author$project$Spa$Generated$Route$StyleGuide__Dropdown,
        $author$project$Spa$Generated$Route$StyleGuide__ExportCsv,
        $author$project$Spa$Generated$Route$StyleGuide__FileInput,
        $author$project$Spa$Generated$Route$StyleGuide__FlyoutMenu,
        $author$project$Spa$Generated$Route$StyleGuide__FormExample,
        $author$project$Spa$Generated$Route$StyleGuide__FormGroup,
        $author$project$Spa$Generated$Route$StyleGuide__FormStatic,
        $author$project$Spa$Generated$Route$StyleGuide__Grid,
        $author$project$Spa$Generated$Route$StyleGuide__HiConfirm,
        $author$project$Spa$Generated$Route$StyleGuide__HorizontalRule,
        $author$project$Spa$Generated$Route$StyleGuide__Icon,
        $author$project$Spa$Generated$Route$StyleGuide__Input,
        $author$project$Spa$Generated$Route$StyleGuide__Link,
        $author$project$Spa$Generated$Route$StyleGuide__ListGroup,
        $author$project$Spa$Generated$Route$StyleGuide__Modal,
        $author$project$Spa$Generated$Route$StyleGuide__Pagination,
        $author$project$Spa$Generated$Route$StyleGuide__Panel,
        $author$project$Spa$Generated$Route$StyleGuide__PasswordInput,
        $author$project$Spa$Generated$Route$StyleGuide__PaymentSourceDisplayer,
        $author$project$Spa$Generated$Route$StyleGuide__PhoneInput,
        $author$project$Spa$Generated$Route$StyleGuide__Popover,
        $author$project$Spa$Generated$Route$StyleGuide__ProgressBar,
        $author$project$Spa$Generated$Route$StyleGuide__Radio,
        $author$project$Spa$Generated$Route$StyleGuide__ResourceFilter,
        $author$project$Spa$Generated$Route$StyleGuide__SearchInput,
        $author$project$Spa$Generated$Route$StyleGuide__SearchableSelect,
        $author$project$Spa$Generated$Route$StyleGuide__Select,
        $author$project$Spa$Generated$Route$StyleGuide__Skeleton,
        $author$project$Spa$Generated$Route$StyleGuide__Table,
        $author$project$Spa$Generated$Route$StyleGuide__Toast,
        $author$project$Spa$Generated$Route$StyleGuide__ToggleSwitch,
        $author$project$Spa$Generated$Route$StyleGuide__Tooltip,
        $author$project$Spa$Generated$Route$StyleGuide__Typography,
        $author$project$Spa$Generated$Route$StyleGuide__UploadForm,
        $author$project$Spa$Generated$Route$StyleGuide__UploadResult,
        $author$project$Spa$Generated$Route$StyleGuide__Well,
        $author$project$Spa$Generated$Route$Support__CannySso,
        $author$project$Spa$Generated$Route$Tasks__New,
        $author$project$Spa$Generated$Route$User__AcceptTerms,
        $author$project$Spa$Generated$Route$User__Mfa,
        $author$project$Spa$Generated$Route$User__Profile,
        $author$project$Spa$Generated$Route$User__Security,
        $author$project$Spa$Generated$Route$Apps__Slug_String({
            _A: ''
        }),
        $author$project$Spa$Generated$Route$Error__Status_String({
            ahy: ''
        }),
        $author$project$Spa$Generated$Route$Join__Token_String({
            aaf: ''
        }),
        $author$project$Spa$Generated$Route$Marketplace__Slug_String({
            _A: ''
        }),
        $author$project$Spa$Generated$Route$Admin__Athenahealth__Top,
        $author$project$Spa$Generated$Route$Admin__ChargeItems__Top,
        $author$project$Spa$Generated$Route$Admin__CompanyPlans__Top,
        $author$project$Spa$Generated$Route$Admin__CoveragePlans__Top,
        $author$project$Spa$Generated$Route$Admin__DataExport__Top,
        $author$project$Spa$Generated$Route$Admin__DataExportSettings__Top,
        $author$project$Spa$Generated$Route$Admin__Documents__Top,
        $author$project$Spa$Generated$Route$Admin__Elation__Top,
        $author$project$Spa$Generated$Route$Admin__Plans__Top,
        $author$project$Spa$Generated$Route$Admin__Providers__Top,
        $author$project$Spa$Generated$Route$Admin__Quickbooks__Top,
        $author$project$Spa$Generated$Route$Admin__SignupPages__Top,
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__Top,
        $author$project$Spa$Generated$Route$Commissions__StatementLines__Top,
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Top({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Contacts__ContactId_String__Top({
            acA: ''
        }),
        $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Top,
        $author$project$Spa$Generated$Route$Inventory__InventoryId_String__Top({
            aev: ''
        }),
        $author$project$Spa$Generated$Route$Messages__Faxes__Top,
        $author$project$Spa$Generated$Route$Messages__Scheduled__Top,
        $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Top,
        $author$project$Spa$Generated$Route$NewSettings__Locations__Top,
        $author$project$Spa$Generated$Route$NewSettings__Templates__Top,
        $author$project$Spa$Generated$Route$Onboard__DealId_String__Top({
            acS: ''
        }),
        $author$project$Spa$Generated$Route$Partner__Dashboard__Top,
        $author$project$Spa$Generated$Route$Partner__Practices__Top,
        $author$project$Spa$Generated$Route$Partner__Sandboxes__Top,
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Top({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Top,
        $author$project$Spa$Generated$Route$Tasks__TasksId_String__Top({
            ahJ: ''
        }),
        $author$project$Spa$Generated$Route$User__Organizations__Top,
        $author$project$Spa$Generated$Route$Admin__Athenahealth__Fields,
        $author$project$Spa$Generated$Route$Admin__Athenahealth__Link,
        $author$project$Spa$Generated$Route$Admin__Athenahealth__Locations,
        $author$project$Spa$Generated$Route$Admin__Athenahealth__Overview,
        $author$project$Spa$Generated$Route$Admin__Athenahealth__Providers,
        $author$project$Spa$Generated$Route$Admin__ChargeItems__New,
        $author$project$Spa$Generated$Route$Admin__ChargeItems__Upload,
        $author$project$Spa$Generated$Route$Admin__CompanyPlans__New,
        $author$project$Spa$Generated$Route$Admin__CoveragePlans__New,
        $author$project$Spa$Generated$Route$Admin__Credits__Upload,
        $author$project$Spa$Generated$Route$Admin__DataExportSettings__New,
        $author$project$Spa$Generated$Route$Admin__Developers__ApiKeys,
        $author$project$Spa$Generated$Route$Admin__Developers__GetStarted,
        $author$project$Spa$Generated$Route$Admin__Developers__Sandboxes,
        $author$project$Spa$Generated$Route$Admin__Developers__WebhookEndpoints,
        $author$project$Spa$Generated$Route$Admin__Documents__New,
        $author$project$Spa$Generated$Route$Admin__Elation__Link,
        $author$project$Spa$Generated$Route$Admin__Elation__Overview,
        $author$project$Spa$Generated$Route$Admin__Elation__Providers,
        $author$project$Spa$Generated$Route$Admin__Notifications__Company,
        $author$project$Spa$Generated$Route$Admin__Notifications__Employee,
        $author$project$Spa$Generated$Route$Admin__Notifications__Membership,
        $author$project$Spa$Generated$Route$Admin__Notifications__Patient,
        $author$project$Spa$Generated$Route$Admin__Notifications__Practice,
        $author$project$Spa$Generated$Route$Admin__Notifications__Settings,
        $author$project$Spa$Generated$Route$Admin__PaymentMethodImport__Upload,
        $author$project$Spa$Generated$Route$Admin__Plans__New,
        $author$project$Spa$Generated$Route$Admin__Providers__Upload,
        $author$project$Spa$Generated$Route$Admin__SignupPages__New,
        $author$project$Spa$Generated$Route$Admin__Team__New,
        $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__AffiliateActions({
            pr: ''
        }),
        $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkProviders({
            pr: ''
        }),
        $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__LinkedProviders({
            pr: ''
        }),
        $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Patients({
            pr: ''
        }),
        $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Settings({
            pr: ''
        }),
        $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Users({
            pr: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__New,
        $author$project$Spa$Generated$Route$Commissions__StatementLines__Summary,
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__AffiliatesPricing({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Eas({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__EndedCommissions({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__InvoiceSettings({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notes({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Notifications({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__PaymentSources({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Signup({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Messages__Faxes__New,
        $author$project$Spa$Generated$Route$Messages__Scheduled__New,
        $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__New,
        $author$project$Spa$Generated$Route$NewSettings__Templates__New,
        $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completed({
            afS: ''
        }),
        $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Completing({
            afS: ''
        }),
        $author$project$Spa$Generated$Route$Onboard__OnboardId_String__Payment({
            afS: ''
        }),
        $author$project$Spa$Generated$Route$Onboard__OnboardId_String__User({
            afS: ''
        }),
        $author$project$Spa$Generated$Route$Partner__Billing__Hinter,
        $author$project$Spa$Generated$Route$Partner__Product__ActivationSettings,
        $author$project$Spa$Generated$Route$Partner__Product__AppSettings,
        $author$project$Spa$Generated$Route$Partner__Product__Hinter,
        $author$project$Spa$Generated$Route$Partner__Product__New,
        $author$project$Spa$Generated$Route$Partner__Webhooks__Requests,
        $author$project$Spa$Generated$Route$Partner__Webhooks__Settings,
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Chart({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Edit({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__GrowthChart({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__LabTrends({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__ManageCredits({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Merge({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__VitalsTrends({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$PracticeSetup__Plans__New,
        $author$project$Spa$Generated$Route$Reports__CreditOutstanding__Summary,
        $author$project$Spa$Generated$Route$Reports__CreditTransactions__Summary,
        $author$project$Spa$Generated$Route$Reports__Custom__New,
        $author$project$Spa$Generated$Route$Reports__DeferredRevenue__Summary,
        $author$project$Spa$Generated$Route$Reports__PaymentApplications__Summary,
        $author$project$Spa$Generated$Route$Reports__Revenue__Summary,
        $author$project$Spa$Generated$Route$Reports__SalesTax__Summary,
        $author$project$Spa$Generated$Route$Admin__ChargeItems__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Admin__CompanyPlans__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Admin__CoveragePlans__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Admin__DataExport__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Admin__DataExportSettings__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Admin__Documents__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Admin__Integrations__Slug_String({
            _A: ''
        }),
        $author$project$Spa$Generated$Route$Admin__Plans__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Admin__SignupPages__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Hinter__AdminUsersGroups__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$NewSettings__AppointmentTypes__Ident_String({
            aeg: ''
        }),
        $author$project$Spa$Generated$Route$NewSettings__Locations__BookingLocationId_String({
            ab5: ''
        }),
        $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String({
            ahL: ''
        }),
        $author$project$Spa$Generated$Route$NewSettings__Templates__TemplateId_String({
            ahM: ''
        }),
        $author$project$Spa$Generated$Route$Reports__AncillaryCharges__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Reports__Custom__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Top({
            pr: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Top({
            bS: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Top({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Top({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__Top({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Messages__Scheduled__ScheduledId_String__Top({
            ag6: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Accounts__Top({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Affiliation__Top({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__Top({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__Top({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__Top({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Notifications__Top({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Admin__Notifications__Patient__DunningSchedule,
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Deals({
            bS: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__EndedDeals({
            bS: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__Create({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__New({
            fl: ''
        }),
        $author$project$Spa$Generated$Route$Marketplace__Bookkeeping__Manage__Settings,
        $author$project$Spa$Generated$Route$Marketplace__Elation__Manage__Settings,
        $author$project$Spa$Generated$Route$Marketplace__Quickbooks__Manage__Settings,
        $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Onboarding({
            _A: ''
        }),
        $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Settings({
            _A: ''
        }),
        $author$project$Spa$Generated$Route$Marketplace__Slug_String__Manage__Users({
            _A: ''
        }),
        $author$project$Spa$Generated$Route$NewSettings__Team__TeamId_String__BasicInfo({
            ahL: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__New({
            V8: ''
        }),
        $author$project$Spa$Generated$Route$PracticeSetup__Plans__Id_String__Edit({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Admin__Billing__PracticeInvoices__Id_String({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Affiliates__AffiliateId_String__Bills__Id_String({
            pr: '',
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Invoices__Id_String({
            fl: '',
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__SignupPages__Id_String({
            fl: '',
            aef: ''
        }),
        $author$project$Spa$Generated$Route$NewSettings__Locations__New__LocationId_String({
            Tp: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Notes__NoteId_String({
            afp: '',
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Top({
            bS: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__Top({
            bS: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__Top({
            fl: '',
            H_: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Agreements__AgreementId_String__Top({
            I$: '',
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Charges__InvoiceId_String__Top({
            RI: '',
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Patients__PatientId_String__Memberships__MembershipId_String__Top({
            y0: '',
            V8: ''
        }),
        $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__New({
            aef: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__Ended({
            bS: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__New({
            bS: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Uploads__UploadId_String__UploadResults({
            fl: '',
            H_: ''
        }),
        $author$project$Spa$Generated$Route$Admin__Plans__Id_String__PricingVersions__PricingVersionId_String({
            aef: '',
            ago: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Statements__StatementId_String({
            bS: '',
            ahx: ''
        }),
        $author$project$Spa$Generated$Route$Commissions__BrokerAccounts__BrokerAccountId_String__Brokers__BrokerId_String__Top({
            bS: '',
            EC: ''
        }),
        $author$project$Spa$Generated$Route$Companies__CompanyId_String__Employees__EmployeeId_String__Dependent__DependentId_String__Top({
            fl: '',
            ac2: '',
            adk: ''
        })
    ]);
    var $author$project$Layouts$StyleGuide$routeLabel = function(route) {
        switch(route.$){
            case 115:
                return $elm$core$Maybe$Just('Button');
            case 128:
                return $elm$core$Maybe$Just('Grid');
            case 156:
                return $elm$core$Maybe$Just('Well');
            case 130:
                return $elm$core$Maybe$Just('Horizontal Rule');
            case 131:
                return $elm$core$Maybe$Just('Icon');
            case 137:
                return $elm$core$Maybe$Just('Panel');
            case 149:
                return $elm$core$Maybe$Just('Table');
            case 151:
                return $elm$core$Maybe$Just('Toggle Switch');
            case 111:
                return $elm$core$Maybe$Just('Activity Indicators');
            case 153:
                return $elm$core$Maybe$Just('Typography');
            case 133:
                return $elm$core$Maybe$Just('Link');
            case 150:
                return $elm$core$Maybe$Just('Toast');
            case 142:
                return $elm$core$Maybe$Just('Progress Bar');
            case 113:
                return $elm$core$Maybe$Just('Alert');
            case 125:
                return $elm$core$Maybe$Just('Form');
            case 117:
                return $elm$core$Maybe$Just('Form > Checkbox');
            case 132:
                return $elm$core$Maybe$Just('Form > Input');
            case 126:
                return $elm$core$Maybe$Just('Form > Group');
            case 136:
                return $elm$core$Maybe$Just('Pagination');
            case 140:
                return $elm$core$Maybe$Just('Phone Input');
            case 135:
                return $elm$core$Maybe$Just('Modal');
            case 129:
                return $elm$core$Maybe$Just('Hi Confirm');
            case 114:
                return $elm$core$Maybe$Just('Badge');
            case 152:
                return $elm$core$Maybe$Just('Tooltip');
            case 124:
                return $elm$core$Maybe$Just('Flyout Menu');
            case 141:
                return $elm$core$Maybe$Just('Popover');
            case 122:
                return $elm$core$Maybe$Just('Export Csv');
            case 134:
                return $elm$core$Maybe$Just('List Group');
            case 138:
                return $elm$core$Maybe$Just('Form > Password Input');
            case 127:
                return $elm$core$Maybe$Just('Form > Static');
            case 123:
                return $elm$core$Maybe$Just('Form > File Input');
            case 146:
                return $elm$core$Maybe$Just('Form > Searchable Select');
            case 120:
                return $elm$core$Maybe$Just('Date Range Input');
            case 139:
                return $elm$core$Maybe$Just('Payment Source Displayer');
            case 155:
                return $elm$core$Maybe$Just('Upload > Result');
            case 154:
                return $elm$core$Maybe$Just('Upload > Form');
            case 144:
                return $elm$core$Maybe$Just('Resource Filter');
            case 118:
                return $elm$core$Maybe$Just('Form > Currency Input');
            case 147:
                return $elm$core$Maybe$Just('Form > Select');
            case 119:
                return $elm$core$Maybe$Just('Date Input');
            case 145:
                return $elm$core$Maybe$Just('Search Input');
            case 112:
                return $elm$core$Maybe$Just('Address Input');
            case 148:
                return $elm$core$Maybe$Just('Skeleton');
            case 121:
                return $elm$core$Maybe$Just('Dropdown | Select');
            case 116:
                return $elm$core$Maybe$Just('Carousel');
            case 143:
                return $elm$core$Maybe$Just('Form > Radio');
            case 18:
                return $elm$core$Maybe$Nothing;
            case 1:
                return $elm$core$Maybe$Nothing;
            case 9:
                return $elm$core$Maybe$Nothing;
            case 161:
                return $elm$core$Maybe$Nothing;
            case 29:
                return $elm$core$Maybe$Nothing;
            case 31:
                return $elm$core$Maybe$Nothing;
            case 42:
                return $elm$core$Maybe$Nothing;
            case 160:
                return $elm$core$Maybe$Nothing;
            case 162:
                return $elm$core$Maybe$Nothing;
            case 43:
                return $elm$core$Maybe$Nothing;
            case 22:
                return $elm$core$Maybe$Nothing;
            case 33:
                return $elm$core$Maybe$Nothing;
            case 110:
                return $elm$core$Maybe$Nothing;
            case 37:
                return $elm$core$Maybe$Nothing;
            case 100:
                return $elm$core$Maybe$Nothing;
            case 106:
                return $elm$core$Maybe$Nothing;
            case 21:
                return $elm$core$Maybe$Nothing;
            case 10:
                return $elm$core$Maybe$Nothing;
            case 207:
                return $elm$core$Maybe$Nothing;
            case 88:
                return $elm$core$Maybe$Nothing;
            case 44:
                return $elm$core$Maybe$Nothing;
            case 109:
                return $elm$core$Maybe$Nothing;
            case 273:
                return $elm$core$Maybe$Nothing;
            case 53:
                return $elm$core$Maybe$Nothing;
            case 195:
                return $elm$core$Maybe$Nothing;
            case 288:
                return $elm$core$Maybe$Nothing;
            case 102:
                return $elm$core$Maybe$Nothing;
            case 97:
                return $elm$core$Maybe$Nothing;
            case 104:
                return $elm$core$Maybe$Nothing;
            case 98:
                return $elm$core$Maybe$Nothing;
            case 267:
                return $elm$core$Maybe$Nothing;
            case 99:
                return $elm$core$Maybe$Nothing;
            case 268:
                return $elm$core$Maybe$Nothing;
            case 107:
                return $elm$core$Maybe$Nothing;
            case 271:
                return $elm$core$Maybe$Nothing;
            case 108:
                return $elm$core$Maybe$Nothing;
            case 272:
                return $elm$core$Maybe$Nothing;
            case 101:
                return $elm$core$Maybe$Nothing;
            case 270:
                return $elm$core$Maybe$Nothing;
            case 269:
                return $elm$core$Maybe$Nothing;
            case 289:
                return $elm$core$Maybe$Nothing;
            case 105:
                return $elm$core$Maybe$Nothing;
            case 103:
                return $elm$core$Maybe$Nothing;
            case 27:
                return $elm$core$Maybe$Nothing;
            case 24:
                return $elm$core$Maybe$Nothing;
            case 30:
                return $elm$core$Maybe$Nothing;
            case 173:
                return $elm$core$Maybe$Nothing;
            case 213:
                return $elm$core$Maybe$Nothing;
            case 279:
                return $elm$core$Maybe$Nothing;
            case 218:
                return $elm$core$Maybe$Nothing;
            case 220:
                return $elm$core$Maybe$Nothing;
            case 217:
                return $elm$core$Maybe$Nothing;
            case 219:
                return $elm$core$Maybe$Nothing;
            case 221:
                return $elm$core$Maybe$Nothing;
            case 222:
                return $elm$core$Maybe$Nothing;
            case 302:
                return $elm$core$Maybe$Nothing;
            case 32:
                return $elm$core$Maybe$Nothing;
            case 36:
                return $elm$core$Maybe$Nothing;
            case 240:
                return $elm$core$Maybe$Nothing;
            case 241:
                return $elm$core$Maybe$Nothing;
            case 239:
                return $elm$core$Maybe$Nothing;
            case 48:
                return $elm$core$Maybe$Nothing;
            case 227:
                return $elm$core$Maybe$Nothing;
            case 78:
                return $elm$core$Maybe$Nothing;
            case 79:
                return $elm$core$Maybe$Nothing;
            case 286:
                return $elm$core$Maybe$Nothing;
            case 313:
                return $elm$core$Maybe$Nothing;
            case 75:
                return $elm$core$Maybe$Nothing;
            case 47:
                return $elm$core$Maybe$Nothing;
            case 34:
                return $elm$core$Maybe$Nothing;
            case 168:
                return $elm$core$Maybe$Nothing;
            case 203:
                return $elm$core$Maybe$Nothing;
            case 274:
                return $elm$core$Maybe$Nothing;
            case 204:
                return $elm$core$Maybe$Nothing;
            case 170:
                return $elm$core$Maybe$Nothing;
            case 206:
                return $elm$core$Maybe$Nothing;
            case 276:
                return $elm$core$Maybe$Nothing;
            case 176:
                return $elm$core$Maybe$Nothing;
            case 225:
                return $elm$core$Maybe$Nothing;
            case 178:
                return $elm$core$Maybe$Nothing;
            case 226:
                return $elm$core$Maybe$Nothing;
            case 282:
                return $elm$core$Maybe$Nothing;
            case 20:
                return $elm$core$Maybe$Nothing;
            case 224:
                return $elm$core$Maybe$Nothing;
            case 175:
                return $elm$core$Maybe$Nothing;
            case 281:
                return $elm$core$Maybe$Nothing;
            case 205:
                return $elm$core$Maybe$Nothing;
            case 169:
                return $elm$core$Maybe$Nothing;
            case 275:
                return $elm$core$Maybe$Nothing;
            case 25:
                return $elm$core$Maybe$Nothing;
            case 28:
                return $elm$core$Maybe$Nothing;
            case 46:
                return $elm$core$Maybe$Nothing;
            case 35:
                return $elm$core$Maybe$Nothing;
            case 26:
                return $elm$core$Maybe$Nothing;
            case 293:
                return $elm$core$Maybe$Nothing;
            case 318:
                return $elm$core$Maybe$Nothing;
            case 41:
                return $elm$core$Maybe$Nothing;
            case 2:
                return $elm$core$Maybe$Nothing;
            case 62:
                return $elm$core$Maybe$Nothing;
            case 57:
                return $elm$core$Maybe$Nothing;
            case 61:
                return $elm$core$Maybe$Nothing;
            case 60:
                return $elm$core$Maybe$Nothing;
            case 58:
                return $elm$core$Maybe$Nothing;
            case 183:
                return $elm$core$Maybe$Nothing;
            case 283:
                return $elm$core$Maybe$Nothing;
            case 59:
                return $elm$core$Maybe$Nothing;
            case 16:
                return $elm$core$Maybe$Nothing;
            case 40:
                return $elm$core$Maybe$Nothing;
            case 39:
                return $elm$core$Maybe$Nothing;
            case 38:
                return $elm$core$Maybe$Nothing;
            case 223:
                return $elm$core$Maybe$Nothing;
            case 242:
                return $elm$core$Maybe$Nothing;
            case 316:
                return $elm$core$Maybe$Nothing;
            case 292:
                return $elm$core$Maybe$Nothing;
            case 305:
                return $elm$core$Maybe$Nothing;
            case 335:
                return $elm$core$Maybe$Nothing;
            case 236:
                return $elm$core$Maybe$Nothing;
            case 238:
                return $elm$core$Maybe$Nothing;
            case 181:
                return $elm$core$Maybe$Nothing;
            case 13:
                return $elm$core$Maybe$Nothing;
            case 23:
                return $elm$core$Maybe$Nothing;
            case 179:
                return $elm$core$Maybe$Nothing;
            case 234:
                return $elm$core$Maybe$Nothing;
            case 291:
                return $elm$core$Maybe$Nothing;
            case 303:
                return $elm$core$Maybe$Nothing;
            case 322:
                return $elm$core$Maybe$Nothing;
            case 330:
                return $elm$core$Maybe$Nothing;
            case 334:
                return $elm$core$Maybe$Nothing;
            case 329:
                return $elm$core$Maybe$Nothing;
            case 323:
                return $elm$core$Maybe$Nothing;
            case 52:
                return $elm$core$Maybe$Nothing;
            case 333:
                return $elm$core$Maybe$Nothing;
            case 304:
                return $elm$core$Maybe$Nothing;
            case 180:
                return $elm$core$Maybe$Nothing;
            case 235:
                return $elm$core$Maybe$Nothing;
            case 194:
                return $elm$core$Maybe$Nothing;
            case 260:
                return $elm$core$Maybe$Nothing;
            case 264:
                return $elm$core$Maybe$Nothing;
            case 263:
                return $elm$core$Maybe$Nothing;
            case 325:
                return $elm$core$Maybe$Nothing;
            case 12:
                return $elm$core$Maybe$Nothing;
            case 50:
                return $elm$core$Maybe$Nothing;
            case 290:
                return $elm$core$Maybe$Nothing;
            case 229:
                return $elm$core$Maybe$Nothing;
            case 230:
                return $elm$core$Maybe$Nothing;
            case 233:
                return $elm$core$Maybe$Nothing;
            case 11:
                return $elm$core$Maybe$Nothing;
            case 317:
                return $elm$core$Maybe$Nothing;
            case 49:
                return $elm$core$Maybe$Nothing;
            case 228:
                return $elm$core$Maybe$Nothing;
            case 280:
                return $elm$core$Maybe$Nothing;
            case 294:
                return $elm$core$Maybe$Nothing;
            case 324:
                return $elm$core$Maybe$Nothing;
            case 237:
                return $elm$core$Maybe$Nothing;
            case 331:
                return $elm$core$Maybe$Nothing;
            case 165:
                return $elm$core$Maybe$Nothing;
            case 7:
                return $elm$core$Maybe$Nothing;
            case 8:
                return $elm$core$Maybe$Nothing;
            case 80:
                return $elm$core$Maybe$Nothing;
            case 157:
                return $elm$core$Maybe$Nothing;
            case 231:
                return $elm$core$Maybe$Nothing;
            case 87:
                return $elm$core$Maybe$Nothing;
            case 232:
                return $elm$core$Maybe$Nothing;
            case 326:
                return $elm$core$Maybe$Nothing;
            case 45:
                return $elm$core$Maybe$Nothing;
            case 51:
                return $elm$core$Maybe$Nothing;
            case 296:
                return $elm$core$Maybe$Nothing;
            case 298:
                return $elm$core$Maybe$Nothing;
            case 299:
                return $elm$core$Maybe$Nothing;
            case 314:
                return $elm$core$Maybe$Nothing;
            case 327:
                return $elm$core$Maybe$Nothing;
            case 300:
                return $elm$core$Maybe$Nothing;
            case 301:
                return $elm$core$Maybe$Nothing;
            case 243:
                return $elm$core$Maybe$Nothing;
            case 197:
                return $elm$core$Maybe$Nothing;
            case 297:
                return $elm$core$Maybe$Nothing;
            case 306:
                return $elm$core$Maybe$Nothing;
            case 319:
                return $elm$core$Maybe$Nothing;
            case 174:
                return $elm$core$Maybe$Nothing;
            case 214:
                return $elm$core$Maybe$Nothing;
            case 216:
                return $elm$core$Maybe$Nothing;
            case 215:
                return $elm$core$Maybe$Nothing;
            case 177:
                return $elm$core$Maybe$Nothing;
            case 167:
                return $elm$core$Maybe$Nothing;
            case 199:
                return $elm$core$Maybe$Nothing;
            case 200:
                return $elm$core$Maybe$Nothing;
            case 198:
                return $elm$core$Maybe$Nothing;
            case 202:
                return $elm$core$Maybe$Nothing;
            case 201:
                return $elm$core$Maybe$Nothing;
            case 172:
                return $elm$core$Maybe$Nothing;
            case 208:
                return $elm$core$Maybe$Nothing;
            case 278:
                return $elm$core$Maybe$Nothing;
            case 171:
                return $elm$core$Maybe$Nothing;
            case 277:
                return $elm$core$Maybe$Nothing;
            case 209:
                return $elm$core$Maybe$Nothing;
            case 210:
                return $elm$core$Maybe$Nothing;
            case 211:
                return $elm$core$Maybe$Nothing;
            case 212:
                return $elm$core$Maybe$Nothing;
            case 159:
                return $elm$core$Maybe$Nothing;
            case 164:
                return $elm$core$Maybe$Nothing;
            case 0:
                return $elm$core$Maybe$Nothing;
            case 190:
                return $elm$core$Maybe$Nothing;
            case 250:
                return $elm$core$Maybe$Nothing;
            case 251:
                return $elm$core$Maybe$Nothing;
            case 249:
                return $elm$core$Maybe$Nothing;
            case 248:
                return $elm$core$Maybe$Nothing;
            case 17:
                return $elm$core$Maybe$Nothing;
            case 89:
                return $elm$core$Maybe$Nothing;
            case 95:
                return $elm$core$Maybe$Nothing;
            case 266:
                return $elm$core$Maybe$Nothing;
            case 315:
                return $elm$core$Maybe$Nothing;
            case 92:
                return $elm$core$Maybe$Nothing;
            case 94:
                return $elm$core$Maybe$Nothing;
            case 96:
                return $elm$core$Maybe$Nothing;
            case 90:
                return $elm$core$Maybe$Nothing;
            case 93:
                return $elm$core$Maybe$Nothing;
            case 91:
                return $elm$core$Maybe$Nothing;
            case 86:
                return $elm$core$Maybe$Nothing;
            case 85:
                return $elm$core$Maybe$Nothing;
            case 81:
                return $elm$core$Maybe$Nothing;
            case 258:
                return $elm$core$Maybe$Nothing;
            case 257:
                return $elm$core$Maybe$Nothing;
            case 192:
                return $elm$core$Maybe$Nothing;
            case 84:
                return $elm$core$Maybe$Nothing;
            case 328:
                return $elm$core$Maybe$Nothing;
            case 332:
                return $elm$core$Maybe$Nothing;
            case 254:
                return $elm$core$Maybe$Nothing;
            case 191:
                return $elm$core$Maybe$Nothing;
            case 256:
                return $elm$core$Maybe$Nothing;
            case 253:
                return $elm$core$Maybe$Nothing;
            case 255:
                return $elm$core$Maybe$Nothing;
            case 193:
                return $elm$core$Maybe$Nothing;
            case 252:
                return $elm$core$Maybe$Nothing;
            case 82:
                return $elm$core$Maybe$Nothing;
            case 83:
                return $elm$core$Maybe$Nothing;
            case 163:
                return $elm$core$Maybe$Nothing;
            case 15:
                return $elm$core$Maybe$Nothing;
            case 166:
                return $elm$core$Maybe$Nothing;
            case 310:
                return $elm$core$Maybe$Nothing;
            case 312:
                return $elm$core$Maybe$Nothing;
            case 311:
                return $elm$core$Maybe$Nothing;
            case 307:
                return $elm$core$Maybe$Nothing;
            case 309:
                return $elm$core$Maybe$Nothing;
            case 308:
                return $elm$core$Maybe$Nothing;
            case 66:
                return $elm$core$Maybe$Nothing;
            case 3:
                return $elm$core$Maybe$Nothing;
            case 6:
                return $elm$core$Maybe$Nothing;
            case 259:
                return $elm$core$Maybe$Nothing;
            case 54:
                return $elm$core$Maybe$Nothing;
            case 55:
                return $elm$core$Maybe$Nothing;
            case 182:
                return $elm$core$Maybe$Nothing;
            case 14:
                return $elm$core$Maybe$Nothing;
            case 56:
                return $elm$core$Maybe$Nothing;
            case 4:
                return $elm$core$Maybe$Nothing;
            case 63:
                return $elm$core$Maybe$Nothing;
            case 64:
                return $elm$core$Maybe$Nothing;
            case 184:
                return $elm$core$Maybe$Nothing;
            case 65:
                return $elm$core$Maybe$Nothing;
            case 72:
                return $elm$core$Maybe$Nothing;
            case 68:
                return $elm$core$Maybe$Nothing;
            case 67:
                return $elm$core$Maybe$Nothing;
            case 71:
                return $elm$core$Maybe$Nothing;
            case 185:
                return $elm$core$Maybe$Nothing;
            case 244:
                return $elm$core$Maybe$Nothing;
            case 70:
                return $elm$core$Maybe$Nothing;
            case 69:
                return $elm$core$Maybe$Nothing;
            case 186:
                return $elm$core$Maybe$Nothing;
            case 245:
                return $elm$core$Maybe$Nothing;
            case 295:
                return $elm$core$Maybe$Nothing;
            case 19:
                return $elm$core$Maybe$Nothing;
            case 158:
                return $elm$core$Maybe$Nothing;
            case 196:
                return $elm$core$Maybe$Nothing;
            case 187:
                return $elm$core$Maybe$Nothing;
            case 246:
                return $elm$core$Maybe$Nothing;
            case 284:
                return $elm$core$Maybe$Nothing;
            case 188:
                return $elm$core$Maybe$Nothing;
            case 285:
                return $elm$core$Maybe$Nothing;
            case 320:
                return $elm$core$Maybe$Nothing;
            case 189:
                return $elm$core$Maybe$Nothing;
            case 247:
                return $elm$core$Maybe$Nothing;
            case 287:
                return $elm$core$Maybe$Nothing;
            case 77:
                return $elm$core$Maybe$Nothing;
            case 5:
                return $elm$core$Maybe$Nothing;
            case 74:
                return $elm$core$Maybe$Nothing;
            case 73:
                return $elm$core$Maybe$Nothing;
            case 76:
                return $elm$core$Maybe$Nothing;
            case 321:
                return $elm$core$Maybe$Nothing;
            case 261:
                return $elm$core$Maybe$Nothing;
            case 262:
                return $elm$core$Maybe$Nothing;
            default:
                return $elm$core$Maybe$Nothing;
        }
    };
    var $author$project$Layouts$StyleGuide$menuItems = A2($elm$core$List$sortBy, $elm$core$Tuple$second, A2($elm$core$List$filterMap, function(route) {
        return A2($elm$core$Maybe$map, function(label) {
            return _Utils_Tuple2(route, label);
        }, $author$project$Layouts$StyleGuide$routeLabel(route));
    }, $author$project$Spa$Generated$Route$all));
    var $author$project$Layouts$StyleGuide$viewHeader = $author$project$Ui$Typography$heading(_List_fromArray([
        A2($elm$html$Html$a, _List_fromArray([
            $elm$html$Html$Attributes$href($author$project$Spa$Generated$Route$toString($author$project$Spa$Generated$Route$StyleGuide__Typography))
        ]), _List_fromArray([
            $elm$html$Html$text('Hint Legos')
        ]))
    ]));
    var $author$project$Layouts$StyleGuide$viewMenuItem = F2(function(currentUrl, _v0) {
        var route = _v0.a;
        var linkText = _v0.b;
        var stringRoute = $author$project$Spa$Generated$Route$toString(route);
        return A2($elm$html$Html$div, _List_fromArray([
            $elm$html$Html$Attributes$classList(_List_fromArray([
                _Utils_Tuple2('active', A2($elm$core$String$contains, stringRoute, currentUrl))
            ]))
        ]), _List_fromArray([
            A2($elm$html$Html$a, _List_fromArray([
                $elm$html$Html$Attributes$href(stringRoute)
            ]), _List_fromArray([
                $elm$html$Html$text(linkText)
            ]))
        ]));
    });
    var $author$project$Layouts$StyleGuide$view = F2(function(_v0, body) {
        var url = _v0.aaT;
        return _List_fromArray([
            A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                $author$project$Layouts$StyleGuide$viewHeader,
                A2($elm$html$Html$div, _List_Nil, _List_fromArray([
                    A2($author$project$Ui$Grid$row, _List_Nil, _List_fromArray([
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(4),
                            $author$project$Ui$Grid$spanMd(3),
                            $author$project$Ui$Grid$spanLg(2)
                        ]), _List_fromArray([
                            A2($elm$html$Html$div, _List_fromArray([
                                $elm$html$Html$Attributes$class('')
                            ]), A2($elm$core$List$map, $author$project$Layouts$StyleGuide$viewMenuItem($elm$url$Url$toString(url)), $author$project$Layouts$StyleGuide$menuItems))
                        ])),
                        A2($author$project$Ui$Grid$column, _List_fromArray([
                            $author$project$Ui$Grid$spanSm(8),
                            $author$project$Ui$Grid$spanMd(9),
                            $author$project$Ui$Grid$spanLg(10)
                        ]), body)
                    ]))
                ]))
            ]))
        ]);
    });
    var $author$project$Layouts$User$viewNav = F2(function(currentRoute, nav) {
        return A3($author$project$Ui$Nav$view, _List_Nil, _List_fromArray([
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$User__Profile),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$User__Profile))
            ]), _List_fromArray([
                $elm$html$Html$text('General')
            ])),
            A2($author$project$Ui$Nav$item, _List_fromArray([
                $author$project$Ui$Nav$route($author$project$Spa$Generated$Route$User__Security),
                $author$project$Ui$Nav$activeItem(_Utils_eq(currentRoute, $author$project$Spa$Generated$Route$User__Security))
            ]), _List_fromArray([
                $elm$html$Html$text('Security')
            ]))
        ]), nav);
    });
    var $author$project$Layouts$User$view = F4(function(toMsg, _v0, _v1, body) {
        var url = _v0.aaT;
        var nav = _v1.nb;
        var currentRoute = $author$project$Utils$Route$fromUrl(url);
        return _List_fromArray([
            A2($elm$html$Html$div, _List_fromArray([
                $elm$html$Html$Attributes$class('nav-panel nav-panel-header')
            ]), A2($elm$core$List$cons, A2($elm$html$Html$map, toMsg, A2($author$project$Layouts$User$viewNav, currentRoute, nav)), body))
        ]);
    });
    var $author$project$Spa$Layout$view = F5(function(toMainMsg, layout, shared, toSharedMsg, body) {
        if (shared.adU.adj) return $author$project$Layouts$Blank$view(body);
        else switch(layout.$){
            case 0:
                return A2($author$project$Layouts$StyleGuide$view, shared, body);
            case 18:
                return A2($author$project$Layouts$Onboard$view, shared, body);
            case 15:
                return $author$project$Layouts$Blank$view(body);
            case 16:
                return _List_Nil;
            case 17:
                var layoutModel = layout.b;
                return A2($author$project$Layouts$PatientChart$view, body, layoutModel);
            case 1:
                return $author$project$Layouts$Application$view(body);
            case 4:
                var layoutModel = layout.a;
                return A4($author$project$Layouts$Commissions$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CommissionsMsg, toMainMsg), shared, layoutModel, body);
            case 5:
                var layoutModel = layout.b;
                return A4($author$project$Layouts$Commissions$BrokerAccount$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CommissionsBrokerAccountMsg, toMainMsg), shared, layoutModel, body);
            case 6:
                var layoutModel = layout.a;
                return A4($author$project$Layouts$Affiliates$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AffiliatesMsg, toMainMsg), shared, layoutModel, body);
            case 20:
                return A2($author$project$Layouts$PracticeSetup$view, shared, body);
            case 7:
                var layoutModel = layout.b;
                return A4($author$project$Layouts$Affiliates$Affiliate$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AffiliatesAffiliateMsg, toMainMsg), shared, layoutModel, body);
            case 8:
                var layoutModel = layout.a;
                return A4($author$project$Layouts$Partner$Billing$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerBillingMsg, toMainMsg), shared, layoutModel, body);
            case 9:
                var layoutModel = layout.a;
                return A4($author$project$Layouts$Partner$Practices$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerPracticesMsg, toMainMsg), shared, layoutModel, body);
            case 10:
                var layoutModel = layout.a;
                return A4($author$project$Layouts$Partner$Product$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerProductMsg, toMainMsg), shared, layoutModel, body);
            case 11:
                var layoutModel = layout.a;
                return A4($author$project$Layouts$Partner$Webhooks$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PartnerWebhooksMsg, toMainMsg), shared, layoutModel, body);
            case 12:
                var layoutModel = layout.b;
                return A4($author$project$Layouts$Marketplace$Manage$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$MarketplaceManageMsg, toMainMsg), shared, layoutModel, body);
            case 3:
                var layoutModel = layout.b;
                return A5($author$project$Layouts$Patient$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$PatientMsg, toMainMsg), toSharedMsg, shared, layoutModel, body);
            case 2:
                var _v1 = shared.af4;
                if (!_v1.$) {
                    var patientsList = _v1.a;
                    return A3($author$project$Layouts$PatientsSidebar$view, toSharedMsg, patientsList, body);
                } else return body;
            case 13:
                var layoutModel = layout.b;
                return A4($author$project$Layouts$Company$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$CompanyMsg, toMainMsg), shared, layoutModel, body);
            case 14:
                var layoutModel = layout.a;
                return A4($author$project$Layouts$Admin$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$AdminMsg, toMainMsg), shared, layoutModel, body);
            default:
                var layoutModel = layout.a;
                return A4($author$project$Layouts$User$view, A2($elm$core$Basics$composeR, $author$project$Spa$Layout$UserMsg, toMainMsg), shared, layoutModel, body);
        }
    });
    var $author$project$Main$view = function(model) {
        return A2($author$project$Shared$view, {
            aeB: $author$project$Main$isClinicalLayout(model.ba),
            ba: A3($author$project$Spa$Layout$view, $author$project$Main$Layout, model.ba, model.Cu),
            GM: A2($author$project$Spa$Document$map, $author$project$Main$Pages, $author$project$Spa$Generated$Pages$view(model.GM)),
            ahX: $author$project$Main$Shared
        }, model.Cu);
    };
    var $author$project$Main$main = $elm$browser$Browser$element({
        aeq: $author$project$Main$init,
        ahE: $author$project$Main$subscriptions,
        aaO: $author$project$Main$update,
        aid: A2($elm$core$Basics$composeR, $author$project$Main$view, $author$project$Spa$Document$toBrowserElement)
    });
    _Platform_export({
        'Main': {
            'init': $author$project$Main$main(A2($elm$json$Json$Decode$andThen, function(showRedesignToggle) {
                return A2($elm$json$Json$Decode$andThen, function(sessionToken) {
                    return A2($elm$json$Json$Decode$andThen, function(release) {
                        return A2($elm$json$Json$Decode$andThen, function(providerAuthUrl) {
                            return A2($elm$json$Json$Decode$andThen, function(origin) {
                                return A2($elm$json$Json$Decode$andThen, function(nodeEnv) {
                                    return A2($elm$json$Json$Decode$andThen, function(locationHref) {
                                        return A2($elm$json$Json$Decode$andThen, function(intercomAppId) {
                                            return A2($elm$json$Json$Decode$andThen, function(images) {
                                                return A2($elm$json$Json$Decode$andThen, function(hinterViewOff) {
                                                    return A2($elm$json$Json$Decode$andThen, function(hintEnv) {
                                                        return A2($elm$json$Json$Decode$andThen, function(emrHost) {
                                                            return A2($elm$json$Json$Decode$andThen, function(embedded) {
                                                                return A2($elm$json$Json$Decode$andThen, function(defaultHubspotDeal) {
                                                                    return A2($elm$json$Json$Decode$andThen, function(debugOrTest) {
                                                                        return A2($elm$json$Json$Decode$andThen, function(currentTime) {
                                                                            return A2($elm$json$Json$Decode$andThen, function(currentRataDieDate) {
                                                                                return A2($elm$json$Json$Decode$andThen, function(cannyAppId) {
                                                                                    return A2($elm$json$Json$Decode$andThen, function(backupAuthEnabled) {
                                                                                        return A2($elm$json$Json$Decode$andThen, function(apiVersion) {
                                                                                            return A2($elm$json$Json$Decode$andThen, function(apiUrl) {
                                                                                                return $elm$json$Json$Decode$succeed({
                                                                                                    abM: apiUrl,
                                                                                                    Ek: apiVersion,
                                                                                                    abT: backupAuthEnabled,
                                                                                                    acc: cannyAppId,
                                                                                                    acI: currentRataDieDate,
                                                                                                    acJ: currentTime,
                                                                                                    acU: debugOrTest,
                                                                                                    acY: defaultHubspotDeal,
                                                                                                    adj: embedded,
                                                                                                    adm: emrHost,
                                                                                                    aea: hintEnv,
                                                                                                    aeb: hinterViewOff,
                                                                                                    Q5: images,
                                                                                                    aes: intercomAppId,
                                                                                                    To: locationHref,
                                                                                                    aff: nodeEnv,
                                                                                                    afY: origin,
                                                                                                    G8: providerAuthUrl,
                                                                                                    agH: release,
                                                                                                    ahk: sessionToken,
                                                                                                    aho: showRedesignToggle
                                                                                                });
                                                                                            }, A2($elm$json$Json$Decode$field, 'apiUrl', $elm$json$Json$Decode$string));
                                                                                        }, A2($elm$json$Json$Decode$field, 'apiVersion', $elm$json$Json$Decode$oneOf(_List_fromArray([
                                                                                            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                                                                                            A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                                                                                        ]))));
                                                                                    }, A2($elm$json$Json$Decode$field, 'backupAuthEnabled', $elm$json$Json$Decode$bool));
                                                                                }, A2($elm$json$Json$Decode$field, 'cannyAppId', $elm$json$Json$Decode$oneOf(_List_fromArray([
                                                                                    $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                                                                                    A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                                                                                ]))));
                                                                            }, A2($elm$json$Json$Decode$field, 'currentRataDieDate', $elm$json$Json$Decode$int));
                                                                        }, A2($elm$json$Json$Decode$field, 'currentTime', $elm$json$Json$Decode$int));
                                                                    }, A2($elm$json$Json$Decode$field, 'debugOrTest', $elm$json$Json$Decode$bool));
                                                                }, A2($elm$json$Json$Decode$field, 'defaultHubspotDeal', $elm$json$Json$Decode$oneOf(_List_fromArray([
                                                                    $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                                                                    A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                                                                ]))));
                                                            }, A2($elm$json$Json$Decode$field, 'embedded', $elm$json$Json$Decode$bool));
                                                        }, A2($elm$json$Json$Decode$field, 'emrHost', $elm$json$Json$Decode$string));
                                                    }, A2($elm$json$Json$Decode$field, 'hintEnv', $elm$json$Json$Decode$oneOf(_List_fromArray([
                                                        $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                                                        A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                                                    ]))));
                                                }, A2($elm$json$Json$Decode$field, 'hinterViewOff', $elm$json$Json$Decode$bool));
                                            }, A2($elm$json$Json$Decode$field, 'images', $elm$json$Json$Decode$list(A2($elm$json$Json$Decode$andThen, function(_v0) {
                                                return A2($elm$json$Json$Decode$andThen, function(_v1) {
                                                    return $elm$json$Json$Decode$succeed(_Utils_Tuple2(_v0, _v1));
                                                }, A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$string));
                                            }, A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)))));
                                        }, A2($elm$json$Json$Decode$field, 'intercomAppId', $elm$json$Json$Decode$oneOf(_List_fromArray([
                                            $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                                            A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                                        ]))));
                                    }, A2($elm$json$Json$Decode$field, 'locationHref', $elm$json$Json$Decode$string));
                                }, A2($elm$json$Json$Decode$field, 'nodeEnv', $elm$json$Json$Decode$oneOf(_List_fromArray([
                                    $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                                    A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                                ]))));
                            }, A2($elm$json$Json$Decode$field, 'origin', $elm$json$Json$Decode$string));
                        }, A2($elm$json$Json$Decode$field, 'providerAuthUrl', $elm$json$Json$Decode$string));
                    }, A2($elm$json$Json$Decode$field, 'release', $elm$json$Json$Decode$oneOf(_List_fromArray([
                        $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                        A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                    ]))));
                }, A2($elm$json$Json$Decode$field, 'sessionToken', $elm$json$Json$Decode$oneOf(_List_fromArray([
                    $elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
                    A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
                ]))));
            }, A2($elm$json$Json$Decode$field, 'showRedesignToggle', $elm$json$Json$Decode$string)))(0)
        }
    });
})($b601112f62ed8cc8$var$_s);
var $b601112f62ed8cc8$export$17fa1c27a4799863 = $b601112f62ed8cc8$var$_s.Elm;




"use strict";
var $6b3a55416ed9a71d$exports = {};
var $ed4f92629eba3f2a$exports = {};
!function(e, t) {
    $ed4f92629eba3f2a$exports = t();
}($ed4f92629eba3f2a$exports, function() {
    return function(e) {
        var t = {};
        function r(i) {
            if (t[i]) return t[i].exports;
            var n = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, i) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (r.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var n in e)r.d(i, n, (function(t) {
                return e[t];
            }).bind(null, n));
            return i;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = r(18), n = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    t.push(0);
                    var r = t[0], i = t[1];
                    if (10 === r) switch(i){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                    switch(r){
                        case 11:
                            return "Big Sur";
                        case 12:
                            return "Monterey";
                        case 13:
                            return "Ventura";
                        case 14:
                            return "Sonoma";
                        case 15:
                            return "Sequoia";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, i) {
                    void 0 === i && (i = !1);
                    var n = e.getVersionPrecision(t), a = e.getVersionPrecision(r), o = Math.max(n, a), s = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = o - e.getVersionPrecision(t), i = t + new Array(r + 1).join(".0");
                        return e.map(i.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(i && (s = o - Math.min(n, a)), o -= 1; o >= s;){
                        if (u[0][o] > u[1][o]) return 1;
                        if (u[0][o] === u[1][o]) {
                            if (o === s) return 0;
                            o -= 1;
                        } else if (u[0][o] < u[1][o]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, i = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)i.push(t(e[r]));
                    return i;
                }, e.find = function(e, t) {
                    var r, i;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, i = e.length; r < i; r += 1){
                        var n = e[r];
                        if (t(n, r)) return n;
                    }
                }, e.assign = function(e) {
                    for(var t, r, i = e, n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)a[o - 1] = arguments[o];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(a));
                    var s = function() {
                        var e = a[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            i[t] = e[t];
                        });
                    };
                    for(t = 0, r = a.length; t < r; t += 1)s();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return i.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return i.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = n, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                AmazonBot: "amazonbot",
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                BaiduSpider: "baiduspider",
                Bada: "bada",
                BingCrawler: "bingcrawler",
                Brave: "brave",
                BlackBerry: "blackberry",
                "ChatGPT-User": "chatgpt_user",
                Chrome: "chrome",
                ClaudeBot: "claudebot",
                Chromium: "chromium",
                Diffbot: "diffbot",
                DuckDuckBot: "duckduckbot",
                DuckDuckGo: "duckduckgo",
                Electron: "electron",
                Epiphany: "epiphany",
                FacebookExternalHit: "facebookexternalhit",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                GPTBot: "gptbot",
                "Internet Explorer": "ie",
                InternetArchiveCrawler: "internetarchivecrawler",
                "K-Meleon": "k_meleon",
                LibreWolf: "librewolf",
                Linespider: "linespider",
                Maxthon: "maxthon",
                "Meta-ExternalAds": "meta_externalads",
                "Meta-ExternalAgent": "meta_externalagent",
                "Meta-ExternalFetcher": "meta_externalfetcher",
                "Meta-WebIndexer": "meta_webindexer",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                "OAI-SearchBot": "oai_searchbot",
                Omgilibot: "omgilibot",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                "Pale Moon": "pale_moon",
                PerplexityBot: "perplexitybot",
                "Perplexity-User": "perplexity_user",
                PhantomJS: "phantomjs",
                PingdomBot: "pingdombot",
                Puffin: "puffin",
                QQ: "qq",
                QQLite: "qqlite",
                QupZilla: "qupzilla",
                Roku: "roku",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SlackBot: "slackbot",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                "Sogou Browser": "sogou",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                YahooSlurp: "yahooslurp",
                "Yandex Browser": "yandex",
                YandexBot: "yandexbot",
                YouBot: "youbot"
            };
            t.BROWSER_MAP = {
                amazonbot: "AmazonBot",
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                baiduspider: "BaiduSpider",
                bada: "Bada",
                bingcrawler: "BingCrawler",
                blackberry: "BlackBerry",
                brave: "Brave",
                chatgpt_user: "ChatGPT-User",
                chrome: "Chrome",
                claudebot: "ClaudeBot",
                chromium: "Chromium",
                diffbot: "Diffbot",
                duckduckbot: "DuckDuckBot",
                duckduckgo: "DuckDuckGo",
                edge: "Microsoft Edge",
                electron: "Electron",
                epiphany: "Epiphany",
                facebookexternalhit: "FacebookExternalHit",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                google_search: "Google Search",
                googlebot: "Googlebot",
                gptbot: "GPTBot",
                ie: "Internet Explorer",
                internetarchivecrawler: "InternetArchiveCrawler",
                k_meleon: "K-Meleon",
                librewolf: "LibreWolf",
                linespider: "Linespider",
                maxthon: "Maxthon",
                meta_externalads: "Meta-ExternalAds",
                meta_externalagent: "Meta-ExternalAgent",
                meta_externalfetcher: "Meta-ExternalFetcher",
                meta_webindexer: "Meta-WebIndexer",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                oai_searchbot: "OAI-SearchBot",
                omgilibot: "Omgilibot",
                opera: "Opera",
                opera_coast: "Opera Coast",
                pale_moon: "Pale Moon",
                perplexitybot: "PerplexityBot",
                perplexity_user: "Perplexity-User",
                phantomjs: "PhantomJS",
                pingdombot: "PingdomBot",
                puffin: "Puffin",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                qupzilla: "QupZilla",
                roku: "Roku",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                slackbot: "SlackBot",
                sleipnir: "Sleipnir",
                sogou: "Sogou Browser",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yahooslurp: "YahooSlurp",
                yandex: "Yandex Browser",
                yandexbot: "YandexBot",
                youbot: "YouBot"
            };
            t.PLATFORMS_MAP = {
                bot: "bot",
                desktop: "desktop",
                mobile: "mobile",
                tablet: "tablet",
                tv: "tv"
            };
            t.OS_MAP = {
                Android: "Android",
                Bada: "Bada",
                BlackBerry: "BlackBerry",
                ChromeOS: "Chrome OS",
                HarmonyOS: "HarmonyOS",
                iOS: "iOS",
                Linux: "Linux",
                MacOS: "macOS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku",
                Tizen: "Tizen",
                WebOS: "WebOS",
                Windows: "Windows",
                WindowsPhone: "Windows Phone"
            };
            t.ENGINE_MAP = {
                Blink: "Blink",
                EdgeHTML: "EdgeHTML",
                Gecko: "Gecko",
                Presto: "Presto",
                Trident: "Trident",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(91)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            function o(e, t) {
                for(var r = 0; r < t.length; r++){
                    var i = t[r];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                }
            }
            var s = function() {
                function e() {}
                var t, r, i;
                return e.getParser = function(e, t, r) {
                    if (void 0 === t && (t = !1), void 0 === r && (r = null), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new n.default(e, t, r);
                }, e.parse = function(e, t) {
                    return void 0 === t && (t = null), new n.default(e, t).getResult();
                }, t = e, i = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return a.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return a.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return a.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return a.PLATFORMS_MAP;
                        }
                    }
                ], r = null, i && o(t, i), e;
            }();
            t.default = s, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = u(r(92)), n = u(r(93)), a = u(r(94)), o = u(r(95)), s = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t, r) {
                    if (void 0 === t && (t = !1), void 0 === r && (r = null), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e;
                    var i = !1;
                    "boolean" == typeof t ? (i = t, this._hints = r) : this._hints = null != t && "object" == typeof t ? t : null, this.parsedResult = {}, !0 !== i && this.parse();
                }
                var t = e.prototype;
                return t.getHints = function() {
                    return this._hints;
                }, t.hasBrand = function(e) {
                    if (!this._hints || !Array.isArray(this._hints.brands)) return !1;
                    var t = e.toLowerCase();
                    return this._hints.brands.some(function(e) {
                        return e.brand && e.brand.toLowerCase() === t;
                    });
                }, t.getBrandVersion = function(e) {
                    if (this._hints && Array.isArray(this._hints.brands)) {
                        var t = e.toLowerCase(), r = this._hints.brands.find(function(e) {
                            return e.brand && e.brand.toLowerCase() === t;
                        });
                        return r ? r.version : void 0;
                    }
                }, t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = s.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA(), this)), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = s.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = s.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = s.default.find(o.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return s.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, i = 0, n = {}, a = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var o = e[t];
                        "string" == typeof o ? (n[t] = o, a += 1) : "object" == typeof o && (r[t] = o, i += 1);
                    }), i > 0) {
                        var o = Object.keys(r), u = s.default.find(o, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = s.default.find(o, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (a > 0) {
                        var l = Object.keys(n), b = s.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== b) return this.compareVersion(n[b]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), i = e.toLowerCase(), n = s.default.getBrowserTypeByAlias(i);
                    return t && n && (i = n.toLowerCase()), i === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, i = !1, n = this.getBrowserVersion();
                    if ("string" == typeof n) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (i = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (i = !0, r = e.substr(1)), t.indexOf(s.default.compareVersions(n, r, i)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            };
            var a = /version\/(\d+(\.?_?\d+)+)/i, o = [
                {
                    test: [
                        /gptbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "GPTBot"
                        }, r = n.default.getFirstMatch(/gptbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chatgpt-user/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "ChatGPT-User"
                        }, r = n.default.getFirstMatch(/chatgpt-user\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /oai-searchbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "OAI-SearchBot"
                        }, r = n.default.getFirstMatch(/oai-searchbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /claudebot/i,
                        /claude-web/i,
                        /claude-user/i,
                        /claude-searchbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "ClaudeBot"
                        }, r = n.default.getFirstMatch(/(?:claudebot|claude-web|claude-user|claude-searchbot)\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /omgilibot/i,
                        /webzio-extended/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Omgilibot"
                        }, r = n.default.getFirstMatch(/(?:omgilibot|webzio-extended)\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /diffbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Diffbot"
                        }, r = n.default.getFirstMatch(/diffbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /perplexitybot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PerplexityBot"
                        }, r = n.default.getFirstMatch(/perplexitybot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /perplexity-user/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Perplexity-User"
                        }, r = n.default.getFirstMatch(/perplexity-user\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /youbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "YouBot"
                        }, r = n.default.getFirstMatch(/youbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-webindexer/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-WebIndexer"
                        }, r = n.default.getFirstMatch(/meta-webindexer\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalads/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalAds"
                        }, r = n.default.getFirstMatch(/meta-externalads\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalagent/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalAgent"
                        }, r = n.default.getFirstMatch(/meta-externalagent\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalfetcher/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalFetcher"
                        }, r = n.default.getFirstMatch(/meta-externalfetcher\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /linespider/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Linespider"
                        }, r = n.default.getFirstMatch(/(?:linespider)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /amazonbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "AmazonBot"
                        }, r = n.default.getFirstMatch(/amazonbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bingbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BingCrawler"
                        }, r = n.default.getFirstMatch(/bingbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /baiduspider/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BaiduSpider"
                        }, r = n.default.getFirstMatch(/baiduspider\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /duckduckbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "DuckDuckBot"
                        }, r = n.default.getFirstMatch(/duckduckbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ia_archiver/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "InternetArchiveCrawler"
                        }, r = n.default.getFirstMatch(/ia_archiver\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /facebookexternalhit/i,
                        /facebookcatalog/i
                    ],
                    describe: function() {
                        return {
                            name: "FacebookExternalHit"
                        };
                    }
                },
                {
                    test: [
                        /slackbot/i,
                        /slack-imgProxy/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlackBot"
                        }, r = n.default.getFirstMatch(/(?:slackbot|slack-imgproxy)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yahoo!?[\s/]*slurp/i
                    ],
                    describe: function() {
                        return {
                            name: "YahooSlurp"
                        };
                    }
                },
                {
                    test: [
                        /yandexbot/i,
                        /yandexmobilebot/i
                    ],
                    describe: function() {
                        return {
                            name: "YandexBot"
                        };
                    }
                },
                {
                    test: [
                        /pingdom/i
                    ],
                    describe: function() {
                        return {
                            name: "PingdomBot"
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /PaleMoon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Pale Moon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = n.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /librewolf/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "LibreWolf"
                        }, r = n.default.getFirstMatch(/(?:librewolf)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = n.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sogoumobilebrowser/i,
                        /metasr/i,
                        /se 2\.[x]/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sogou Browser"
                        }, r = n.default.getFirstMatch(/(?:sogoumobilebrowser)[\s/](\d+(\.?_?\d+)+)/i, e), i = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e), a = n.default.getFirstMatch(/se ([\d.]+)x/i, e), o = r || i || a;
                        return o && (t.version = o), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = n.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return !!e.hasBrand("DuckDuckGo") || e.test(/\sDdg\/[\d.]+$/i);
                    },
                    describe: function(e, t) {
                        var r = {
                            name: "DuckDuckGo"
                        };
                        if (t) {
                            var i = t.getBrandVersion("DuckDuckGo");
                            if (i) return r.version = i, r;
                        }
                        var a = n.default.getFirstMatch(/\sDdg\/([\d.]+)$/i, e);
                        return a && (r.version = a), r;
                    }
                },
                {
                    test: function(e) {
                        return e.hasBrand("Brave");
                    },
                    describe: function(e, t) {
                        var r = {
                            name: "Brave"
                        };
                        if (t) {
                            var i = t.getBrandVersion("Brave");
                            if (i) return r.version = i, r;
                        }
                        return r;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: n.default.getFirstMatch(t, e),
                            version: n.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: a.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = n.default.getWindowsVersionName(t);
                        return {
                            name: a.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.OS_MAP.iOS
                        }, r = n.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = n.default.getMacOSVersionName(t), i = {
                            name: a.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: a.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /OpenHarmony/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/OpenHarmony\s+(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.HarmonyOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = n.default.getAndroidVersionName(t), i = {
                            name: a.OS_MAP.Android,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: a.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || n.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: a.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: a.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: a.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /linespider/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Line"
                        };
                    }
                },
                {
                    test: [
                        /amazonbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /gptbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /chatgpt-user/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /oai-searchbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /baiduspider/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Baidu"
                        };
                    }
                },
                {
                    test: [
                        /bingbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Bing"
                        };
                    }
                },
                {
                    test: [
                        /duckduckbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "DuckDuckGo"
                        };
                    }
                },
                {
                    test: [
                        /claudebot/i,
                        /claude-web/i,
                        /claude-user/i,
                        /claude-searchbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Anthropic"
                        };
                    }
                },
                {
                    test: [
                        /omgilibot/i,
                        /webzio-extended/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Webz.io"
                        };
                    }
                },
                {
                    test: [
                        /diffbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Diffbot"
                        };
                    }
                },
                {
                    test: [
                        /perplexitybot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Perplexity AI"
                        };
                    }
                },
                {
                    test: [
                        /perplexity-user/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Perplexity AI"
                        };
                    }
                },
                {
                    test: [
                        /youbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "You.com"
                        };
                    }
                },
                {
                    test: [
                        /ia_archiver/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Internet Archive"
                        };
                    }
                },
                {
                    test: [
                        /meta-webindexer/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalads/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalagent/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalfetcher/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /facebookexternalhit/i,
                        /facebookcatalog/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /slackbot/i,
                        /slack-imgProxy/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Slack"
                        };
                    }
                },
                {
                    test: [
                        /yahoo/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Yahoo"
                        };
                    }
                },
                {
                    test: [
                        /yandexbot/i,
                        /yandexmobilebot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Yandex"
                        };
                    }
                },
                {
                    test: [
                        /pingdom/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Pingdom"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /Nokia/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i, e), r = {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Nokia"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: [
                        /smart-?tv|smarttv/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: [
                        /netcast/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: a.ENGINE_MAP.Blink
                        };
                        var t = n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: a.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Trident
                        }, r = n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Presto
                        }, r = n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Gecko
                        }, r = n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: a.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.WebKit
                        }, r = n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        }
    });
});


"use strict";
const $6b3a55416ed9a71d$var$bowserUnsupported = $ed4f92629eba3f2a$exports.msie && $ed4f92629eba3f2a$exports.version <= 9;
$6b3a55416ed9a71d$exports = {
    loadIfBowserSupported: function(callback) {
        if ($6b3a55416ed9a71d$var$bowserUnsupported) document.getElementById('browser-warning').style.display = 'block';
        else callback();
    }
};


var $79e24b776cfbc090$require$loadIfBowserSupported = $6b3a55416ed9a71d$exports.loadIfBowserSupported;
var $ad87cebdafc1912c$exports = {};
const $ad87cebdafc1912c$var$debugOrTest = ![
    "staging",
    "production"
].includes("production");
const $ad87cebdafc1912c$var$Configuration = {
    apiUrl: "https://api.hint.com",
    apiVersion: "20260331220153",
    authClientId: "d21ab17b-eadb-4633-8b9f-c03b4eaa24a7",
    providerAuthUrl: "https://accounts.hint.com",
    backupAuthEnabled: false,
    cannyAppId: "5a81f16877f59f4871fa9194",
    clinicalServices: "https://kciq8hfr4m.execute-api.us-east-1.amazonaws.com,https://gsvv00p905.execute-api.us-east-1.amazonaws.com,https://1pbvhynwkc.execute-api.us-east-1.amazonaws.com,https://924yw7i8k0.execute-api.us-east-1.amazonaws.com,https://yhrviw1avc.execute-api.us-east-1.amazonaws.com,https://k2ly58jzn9.execute-api.us-east-1.amazonaws.com,https://xom15f4fyl.execute-api.us-east-1.amazonaws.com,https://gxu1m90e8d.execute-api.us-east-1.amazonaws.com,https://i2ta3b3zze.execute-api.us-east-1.amazonaws.com,https://xt23ii4knj.execute-api.us-east-1.amazonaws.com,https://onl8fqxr18.execute-api.us-east-1.amazonaws.com,https://uivjk88z7e.execute-api.us-east-1.amazonaws.com,https://va9v733102.execute-api.us-east-1.amazonaws.com,https://pgbe3ob3i6.execute-api.us-east-1.amazonaws.com,https://zbawp84vt1.execute-api.us-east-1.amazonaws.com,https://una6x3cgxd.execute-api.us-east-1.amazonaws.com,https://vezc6hhrpfffhbpxeyiherj3my.appsync-api.us-east-1.amazonaws.com"?.split(",") || [],
    debugOrTest: $ad87cebdafc1912c$var$debugOrTest,
    defaultHubspotDeal: $ad87cebdafc1912c$var$debugOrTest ? "hint" : null,
    emrHost: "https://one.hint.com",
    fullStoryOrgId: "o-1T3FAV-na1",
    googleMapsKey: "AIzaSyC70wIphqbjFg2gjPjkVGEpwym3QTKxSb4",
    googleRecaptchaSiteKey: "6LfOL9gZAAAAADa1ZTyoPjOfwV9pQRXEMhAb9xRM",
    hintStripePublicKey: "pk_live_ImPWqYGkbMfjwg22MiAmB6u4",
    intercomAppId: "nt0e3shp",
    newRelicAgentId: "1120268481",
    newRelicApplicationId: "1120268481",
    newRelicLicenseKey: "f80caba954",
    nodeEnv: "production",
    hintEnv: "production",
    redirectToUri: "app.hint.com",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505285203460096",
    sentryKey: "ae30a117ea7d49f4bbc8d60568505f62",
    sentryEnvironment: "production",
    sentryReleaseVersion: "01331b6b47d71f7a95b33904d67c99bc2823c1fa.20260331220153",
    skipSSOInit: false,
    statuspageEmbedCode: "8mxj6zhmjmzp",
    release: "01331b6b47d71f7a95b33904d67c99bc2823c1fa.20260331220153",
    rainforestEnv: "production",
    ckeditorLicense: "eyJhbGciOiJFUzI1NiJ9.eyJleHAiOjE3NzU2OTI3OTksImp0aSI6IjYxODk3MzJmLThkNzUtNGVkOS05MDE2LTdjOWIyNWEyYzdhNyIsImxpY2Vuc2VkSG9zdHMiOlsiKi5oaW50LmNvbSJdLCJ1c2FnZUVuZHBvaW50IjoiaHR0cHM6Ly9wcm94eS1ldmVudC5ja2VkaXRvci5jb20iLCJkaXN0cmlidXRpb25DaGFubmVsIjpbImNsb3VkIiwiZHJ1cGFsIl0sIndoaXRlTGFiZWwiOnRydWUsImZlYXR1cmVzIjpbIkRSVVAiLCJETyIsIkZQIiwiU0MiLCJUT0MiLCJUUEwiLCJQT0UiLCJDQyIsIk1GIiwiRTJQIiwiRTJXIiwiTUxMIiwiU0VFIiwiRUNIIiwiRUlTIl0sInZjIjoiZTg3NjljMzgifQ.IU0BtQDrF61MAVYJ63dmEnKnTBFRGUcSizBBLok50uqMBMZdECin_3Z80Zd8uLrVFng5jzuy8a7JD38wJOU5WA"
};
$ad87cebdafc1912c$exports = $ad87cebdafc1912c$var$Configuration;



var $ejN0Z = parcelRequire("ejN0Z");
window.CONFIGURATION = $ad87cebdafc1912c$exports;
window.SessionToken = $ejN0Z;






























$79e24b776cfbc090$require$loadIfBowserSupported(function() {
    const sentryDsn = `https://${CONFIGURATION.sentryKey}@${CONFIGURATION.sentryOrganizationId}.ingest.sentry.io/${CONFIGURATION.sentryProjectId}`;
    $d8088e4871d4eafb$export$2cd8252107eb640b({
        dsn: sentryDsn,
        environment: CONFIGURATION.sentryEnvironment,
        release: CONFIGURATION.sentryReleaseVersion,
        maxValueLength: 1000
    });
    $lHnfk.setExtra("api_version", CONFIGURATION.apiVersion);
    const CKEditorPort = (parcelRequire("fEubg"));
    const ClinicalPort = (parcelRequire("le31q"));
    const DashboardChartPort = (parcelRequire("jCHdb"));
    const ClipboardPort = (parcelRequire("8ppvg"));
    const GlobalSearchPort = (parcelRequire("7Yv4M"));
    const GooglePlaces = (parcelRequire("89GRY"));
    const GoogleRecaptchaPort = (parcelRequire("vtHhd"));
    const HinterViewPort = (parcelRequire("iiYY3"));
    const IntercomPort = (parcelRequire("amH7X"));
    const LayerPort = (parcelRequire("9gaDw"));
    const LocalStoragePort = (parcelRequire("gOoIB"));
    const NavbarPort = (parcelRequire("ipoUY"));
    const NavigationPort = (parcelRequire("616Ei"));
    const NewTab = (parcelRequire("2OWT6"));
    const ToastPort = (parcelRequire("imN2D"));
    const PasswordStrength = (parcelRequire("6ljOM"));
    const QRDecoder = (parcelRequire("Lv0sg"));
    const SentryPort = (parcelRequire("7BtPc"));
    const SessionPort = (parcelRequire("2Cu2d"));
    const StripeTerminalPort = (parcelRequire("f6fb3"));
    const StripePort = (parcelRequire("3i8Jd"));
    const NavTabsPort = (parcelRequire("eNjxw"));
    const ThoughtSpotPort = (parcelRequire("7d4sX"));
    const FullStoryPort = (parcelRequire("iGeIU"));
    const FaviconPort = (parcelRequire("2NItH"));
    const PageTitlePort = (parcelRequire("f9qUo"));
    const DropdownPort = (parcelRequire("jRaNl"));
    const RainforestPort = (parcelRequire("3WmqL"));
    const FilePathsPort = (parcelRequire("jdEJG"));
    const PartnerAppsPort = (parcelRequire("21gpv"));
    if (CONFIGURATION.statuspageEmbedCode) setupStatusPage(CONFIGURATION.statuspageEmbedCode);
    if (CONFIGURATION.newRelicAgentId && CONFIGURATION.newRelicLicenseKey && CONFIGURATION.newRelicApplicationId && typeof setupNewRelic !== "undefined") setupNewRelic(CONFIGURATION.newRelicAgentId, CONFIGURATION.newRelicLicenseKey, CONFIGURATION.newRelicApplicationId);
    const currentRataDieDate = ()=>{
        const difference = new Date().getTime() - new Date("0001-01-01").getTime();
        return Math.ceil(difference / 86400000);
    };
    // Initial data passed to Elm (should match `Flags` defined in `Shared.elm`)
    // https://guide.elm-lang.org/interop/flags.html
    var flags = {
        locationHref: location.href,
        sessionToken: SessionPort.read(),
        showRedesignToggle: LocalStoragePort.getItem("hint.redesign-toggle") || "always",
        currentRataDieDate: currentRataDieDate(),
        currentTime: new Date().getTime(),
        hinterViewOff: HinterViewPort.read(),
        images: window.hintImageStore,
        origin: window.location.origin || window.location.protocol + "//" + window.location.hostname,
        debugOrTest: CONFIGURATION.debugOrTest,
        apiUrl: CONFIGURATION.apiUrl,
        apiVersion: CONFIGURATION.apiVersion || null,
        embedded: window.parent != window,
        emrHost: CONFIGURATION.emrHost,
        release: CONFIGURATION.release || null,
        nodeEnv: CONFIGURATION.nodeEnv || null,
        hintEnv: CONFIGURATION.hintEnv || null,
        intercomAppId: CONFIGURATION.intercomAppId || null,
        defaultHubspotDeal: CONFIGURATION.defaultHubspotDeal || null,
        backupAuthEnabled: $ad87cebdafc1912c$exports.backupAuthEnabled,
        providerAuthUrl: CONFIGURATION.providerAuthUrl,
        cannyAppId: CONFIGURATION.cannyAppId || null
    };
    // Start our Elm application
    var app = (0, $b601112f62ed8cc8$export$17fa1c27a4799863).Main.init({
        node: document.getElementById("elm-main"),
        flags: flags
    });
    // Ports go here
    // https://guide.elm-lang.org/interop/ports.html
    CKEditorPort.add(app, CONFIGURATION.ckeditorLicense, CONFIGURATION.hintEnv);
    ClinicalPort.add(app);
    ClipboardPort.add(app);
    DashboardChartPort.add(app);
    GlobalSearchPort.add(app);
    GooglePlaces.add(app, CONFIGURATION.googleMapsKey);
    GoogleRecaptchaPort.add(app, CONFIGURATION.googleRecaptchaSiteKey);
    HinterViewPort.add(app);
    IntercomPort.add(app, CONFIGURATION.intercomAppId);
    LayerPort.add(app);
    LocalStoragePort.add(app);
    NavbarPort.add(app);
    NavigationPort.add(app);
    NewTab.add(app);
    ToastPort.add(app, CONFIGURATION.emrHost);
    PasswordStrength.add(app);
    QRDecoder.add(app);
    SentryPort.add(app);
    SessionPort.add(app, CONFIGURATION.authClientId);
    StripeTerminalPort.add(app);
    StripePort.add(app, CONFIGURATION.hintStripePublicKey);
    NavTabsPort.add(app);
    ThoughtSpotPort.add(app);
    FullStoryPort.add(app, CONFIGURATION.fullStoryOrgId);
    FaviconPort.add(app);
    PageTitlePort.add(app);
    DropdownPort.add(app);
    RainforestPort.add(app);
    FilePathsPort.add(app);
    PartnerAppsPort.add(app);
});


//# sourceMappingURL=provider-portal.f388fc55.js.map
